(function() {
    'use strict';
    angular.module('hdfc-mf-investor-web', ['ngCookies','ngTouch','ngSanitize','ngMessages','ngAria','ngResource','ui.router','ui.bootstrap','toastr','daterangepicker','ngDroplet', '720kb.tooltips', 'gridster','oc.lazyLoad','ng.deviceDetector', 'timer','ngFileSaver','ngUaParser','vcRecaptcha']);
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UpiWaitingController', upiWaitingController);

  /** @ngInject */
  function upiWaitingController($state, $stateParams, TransactionService, MessageService, LoaderService, AppConstants, $window, HDFC_API, $timeout, NetcoreEvntService) {
    var vm = this;
    vm.intervalId = null;
    vm.CORPORATE_URL = HDFC_API.CORPORATE_URL;
    vm.upiIntentUrl = sessionStorage.getItem('intent');
    vm.isMobile = $stateParams.platform === 'ANDROID' || $stateParams.platform === 'IOS';
    vm.redirecToWelcome = redirecToWelcome;
    vm.init = init();

    function init() {
      if ($stateParams.id) {
        vm.transactionId = $stateParams.id;
        vm.transactionType = $stateParams.type;
        var previousTimer = sessionStorage.getItem('timer'), endTimeInSecond = 60 * 5;
        var Timerminutes = parseInt(previousTimer, 10) > 0 ? parseInt(previousTimer, 10) : endTimeInSecond,
          display = document.querySelector('#timer');
        //updateProgressBar(Timerminutes, endTimeInSecond);
        startTimer(Timerminutes, display, endTimeInSecond);
        startInterval();
        if (vm.upiIntentUrl) {
          redirectToUpiIntent();
        }
        //getSummaryStatus();
      }

    }

    function startInterval() {
      vm.intervalId = $window.setInterval(getSummaryStatus, 5000);
    }

    function getSummaryStatus() {
      var success = function(resp) {
        LoaderService.hideLoader();
        vm.summaryData = resp;
        var statues = [AppConstants.UPI_TRANSACTION_STATUS.WAITING, AppConstants.UPI_TRANSACTION_STATUS.PENDING];
        if (!statues.includes(resp.paymentStatus)) {
          vm.status = resp.paymentStatus;
          checkStatus();
        }
        if(resp.paymentStatus === AppConstants.UPI_TRANSACTION_STATUS.WAITING) {
          NetcoreEvntService.ack_Purchase_upi_waiting('purchase',vm.summaryData);
        } else if(resp.paymentStatus === AppConstants.UPI_TRANSACTION_STATUS.PENDING){
          if(vm.summaryData.sipWithFi) {
            NetcoreEvntService.ack_SIP_AutoPay_waiting('SIP With First Installment',vm.summaryData);
          } else {
            NetcoreEvntService.ack_SIP_AutoPay_waiting('Sip',vm.summaryData);
          }

        }
      }, error = function(err) {
        LoaderService.hideLoader();
      };
      TransactionService.post({
        controller1: 'upi',
        controller2: 'transaction',
        controller3: 'summary'
      }, {
        transactionId: vm.transactionId,
        transactionType: vm.transactionType
      }).$promise.then(success, error);
    }

    function startTimer(duration, display, endTimeInSecond) {
      duration = duration - 1;
      var timer = duration, minutes, seconds;
      var totalDuration = endTimeInSecond;

      vm.updateTime = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
        sessionStorage.setItem('timer', timer);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        display.textContent = minutes + ":" + seconds + " " + "min";
        //updateProgressBar(timer, endTimeInSecond);
        timer --;
        if(minutes == 0 && seconds == 0) {
          clearInterval(vm.updateTime);
          sessionStorage.setItem('timer', 0);
          sessionStorage.removeItem('timer');
        }
      }, 1000);
    }

    function updateProgressBar(timer, endTimeInSecond) {
      var totalDuration = endTimeInSecond;
      var progressBarWidth = timer * 100 / totalDuration;
      document.getElementById("progress-status").style.width = progressBarWidth + "%";
    }

    function checkStatus() {
      if (vm.status === AppConstants.UPI_TRANSACTION_STATUS.EXPIRED) {
        clearInterval(vm.intervalId);
        clearInterval(vm.updateTime);
        sessionStorage.removeItem('timer');
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/investors/upi/payment/expired?id='+vm.transactionId+'&type='+vm.transactionType+'&platform='+$stateParams.platform, "_self");
        // $state.go('upi.expired', {
        //   id: vm.transactionId,
        //   type: vm.transactionType,
        //   platform: $stateParams.platform
        // });
      } else if (vm.status === AppConstants.UPI_TRANSACTION_STATUS.ACTIVE || vm.status === AppConstants.UPI_TRANSACTION_STATUS.SUCCESS || vm.status === AppConstants.UPI_TRANSACTION_STATUS.CAPTURED) {
        clearInterval(vm.intervalId);
        clearInterval(vm.updateTime);
        sessionStorage.removeItem('timer');
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/investors/upi/payment/success?id='+vm.transactionId+'&type='+vm.transactionType+'&platform='+$stateParams.platform, "_self");
        // $state.go('upi.success', {
        //   id: vm.transactionId,
        //   type: vm.transactionType,
        //   platform: $stateParams.platform
        // });
      } else {
        clearInterval(vm.intervalId);
        clearInterval(vm.updateTime);
        sessionStorage.removeItem('timer');
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/investors/upi/payment/failed?id='+vm.transactionId+'&type='+vm.transactionType+'&platform='+$stateParams.platform, "_self");
        // $state.go('upi.failed', {
        //   id: vm.transactionId,
        //   type: vm.transactionType,
        //   platform: $stateParams.platform
        // });
      }
      /*if (${response.sourcePortal != SourcePortal.INVESTOR}) {
        (document.getElementsByClassName("footer-main set-width")[0]).classList.add("hiddenState");
        (document.getElementsByClassName("header-secondary")[0]).classList.add("hiddenState");
      }*/
    }

    function redirectToUpiIntent() {

      $timeout(function () {
        if (vm.upiIntentUrl) {
          $window.location.href = vm.upiIntentUrl;
          sessionStorage.removeItem('intent');
        }
      },2000)
    }

    function redirecToWelcome() {
      clearInterval(vm.intervalId);
      clearInterval(vm.updateTime);
      $state.go('welcome');
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UpiFailedController', upiFailedController);

  /** @ngInject */
  function upiFailedController($stateParams, TransactionService, LoaderService, AppConstants, $window, HDFC_API, UtilService,$state, NetcoreEvntService) {
    var vm = this;
    vm.showWhatsApp = false;
    vm.constants = AppConstants;
    vm.UPI_TRANSACTION_STATUS = AppConstants.UPI_TRANSACTION_STATUS;
    vm.PAYMENT_OPTIONS = AppConstants.PAYMENT_METHODS_LIST;
    vm.CORPORATE_URL = HDFC_API.CORPORATE_URL;
    vm.performRedirect = performRedirect;
    vm.redirectToHome = redirectToHome;
    vm.utilService = UtilService;
    vm.isMobile = $stateParams.platform === 'ANDROID' || $stateParams.platform === 'IOS';
    vm.init = init();

    function init() {
      if ($stateParams.id) {
        vm.transactionId = $stateParams.id;
        vm.transactionType = $stateParams.type;
        getSummaryStatus();
      }
    }

    function getSummaryStatus() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        vm.summaryData = resp;
        vm.summaryData.transactionDateTimeNetCore = vm.summaryData.transactionDateTime;
        vm.summaryData.transactionDateTime = $window.moment(vm.summaryData.transactionDateTime).format("DD MMM YYYY hh:mm:ss A");
        vm.errorMessage = vm.summaryData.errorMsg;
        identifyPostLogin();
        var flowName = vm.summaryData.flowName;
        if (flowName === 'SIP_PURCHASE') {
          vm.transactionType = 'SIPPURCHASE'
          vm.transStatus = 'Failed';
        }
        commonEventCalling();
        if(vm.summaryData.netCoreJourney && vm.summaryData.netCoreJourney === "TRANSACT_NOW") {
          vm.summaryData.transactionInitiatedAt = vm.summaryData.transactionDateTime ? $window.moment(vm.summaryData.transactionDateTime).format("DD MMM YYYY hh:mm:ss A") : null;
          vm.summaryData.transactionDate = vm.summaryData.transactionDateTime ? $window.moment(vm.summaryData.transactionDateTime).format("DD MMM YYYY hh:mm:ss A") : null;
          if(vm.summaryData.sipTenure) {
            var dates = vm.summaryData.sipTenure.split('-');
            vm.summaryData.startDate = $window.moment(dates[0]);
            vm.summaryData.endDate = $window.moment(dates[1]);
          }
          vm.summaryData.transactionStatus = 'Failed';
          if(vm.transactionType.toUpperCase() === "PURCHASE") {
            NetcoreEvntService.upi_Transaction_Status('Purchase',vm.summaryData);
          } else if(vm.transactionType.toUpperCase() === "SIP"){
            NetcoreEvntService.upi_Transaction_Status('Sip',vm.summaryData);
          } else if(vm.transactionType.toUpperCase() === "SIPPURCHASE") {
            NetcoreEvntService.upi_Transaction_Status('SIP_PURCHASE',vm.summaryData);
          }
        }
      }, error = function(err) {
        LoaderService.hideLoader();
      };
      TransactionService.post({
        controller1: 'upi',
        controller2: 'transaction',
        controller3: 'summary'
      }, {
        transactionId: vm.transactionId,
        transactionType: vm.transactionType
      }).$promise.then(success, error);
    }

    function identifyPostLogin() {
      if (vm.summaryData.sourcePortal === 'WHATSAPP') {
        vm.showWhatsApp = true;
      } else {
        vm.showWhatsApp = false;
      }
    }

    function performRedirect(type) {
      if (type === 'PURCHASE') {
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/transactions/initiate/purchase', "_self");
        //$state.go('main.transactions.purchase');
      } else if (type === 'SIP') {
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/transactions/initiate/sip', "_self");
      }
    }

    function redirectToHome() {
      $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/welcome', "_self");
    }

    function commonEventCalling() {
      if(vm.transactionType === 'PURCHASE'){
        NetcoreEvntService.dispatch_smartech(vm.summaryData);
        NetcoreEvntService.contact_Event_JSP(vm.summaryData);
        NetcoreEvntService.ack_Purchase_upi_fail('Purchase',vm.summaryData);
      } else if(vm.transactionType === 'SIP'){
        if(vm.summaryData.sipWithFi) {
          NetcoreEvntService.ack_SIPFI_AutoPay_Failed('SIP With First Installment',vm.summaryData);
        } else {
          NetcoreEvntService.ack_SIPFI_AutoPay_Failed('SIP',vm.summaryData);
        }

      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UpiSuccessController', upiSuccessController);

  /** @ngInject */
  function upiSuccessController($state, $stateParams, UtilService, TransactionService, MessageService, LoaderService, AppConstants, $rootScope, HDFC_API, $window, NetcoreEvntService) {
    var vm = this;
    vm.showWhatsApp = false;
    vm.constants = AppConstants;
    vm.UPI_TRANSACTION_STATUS = AppConstants.UPI_TRANSACTION_STATUS;
    vm.PAYMENT_OPTIONS = AppConstants.PAYMENT_METHODS_LIST;
    vm.CORPORATE_URL = HDFC_API.CORPORATE_URL;
    vm.performRedirect = performRedirect;
    vm.redirectToHome = redirectToHome;
    vm.utilService = UtilService;
    vm.isMobile = $stateParams.platform === 'ANDROID' || $stateParams.platform === 'IOS';
    vm.init = init();

    function init() {
      if ($stateParams.id) {
        vm.transactionId = $stateParams.id;
        vm.transactionType = $stateParams.type;
        getSummaryStatus();
      }
    }

    function getSummaryStatus() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        vm.summaryData = resp;
        vm.summaryData.transactionDateTimeNetCore = vm.summaryData.transactionDateTime;
        vm.summaryData.transactionDateTime = $window.moment(vm.summaryData.transactionDateTime).format("DD-MMM-YYYY hh:mm:ss A");
        identifyPostLogin();
        var flowName =  vm.summaryData.flowName;
        if (flowName === 'SIP_PURCHASE') {
          vm.transactionType = 'SIPPURCHASE'
          vm.transStatus = 'Successful';
          var sipDate = vm.summaryData.sipTerm.split(' to');
          vm.summaryData.transactionDateTimePurchase = angular.copy(vm.summaryData.transactionDateTime);
          vm.summaryData.transactionDateTime =  angular.copy(sipDate[0]);
        } else if (vm.transactionType === 'SIP'){
          var sipDate = vm.summaryData.sipTerm.split(' to');
          vm.summaryData.transactionDateTime =  angular.copy(sipDate[0]);
          vm.showInstallments = sipDate[0] !== sipDate[1].trim();

          if (vm.showInstallments) {
            if (vm.summaryData.frequency && vm.summaryData.frequency === 'Monthly') {
              vm.installmentText = 'month';
            } else if (vm.summaryData.frequency && vm.summaryData.frequency === 'Quarterly') {
              vm.installmentText = 'quarter';
            } else if (vm.summaryData.frequency && vm.summaryData.frequency === 'Daily') {
              vm.installmentText = 'day';
            } else if (vm.summaryData.frequency && vm.summaryData.frequency === 'Weekly') {
              vm.installmentText = 'week';
            } else if (vm.summaryData.frequency && vm.summaryData.frequency === 'Yearly') {
              vm.installmentText = 'year';
            } else if (vm.summaryData.frequency && vm.summaryData.frequency === 'Half Yearly') {
              vm.installmentText = '6 months';
            }
          }
        }
        commonEventCalling();
        if(vm.summaryData.netCoreJourney && vm.summaryData.netCoreJourney === "TRANSACT_NOW") {
          vm.summaryData.transactionInitiatedAt = vm.summaryData.transactionDateTime ? $window.moment(vm.summaryData.transactionDateTime).format("DD MMM YYYY hh:mm:ss A") : null;
          vm.summaryData.transactionDate = vm.summaryData.transactionDateTime ? $window.moment(vm.summaryData.transactionDateTime).format("DD MMM YYYY hh:mm:ss A") : null;
          if(vm.summaryData.sipTenure) {
            var dates = vm.summaryData.sipTenure.split('-');
            vm.summaryData.startDate = $window.moment(dates[0]);
            vm.summaryData.endDate = $window.moment(dates[1]);
          }
          vm.summaryData.transactionStatus = vm.transStatus;
          if(vm.transactionType.toUpperCase() === "PURCHASE") {
            NetcoreEvntService.upi_Transaction_Status('Purchase',vm.summaryData);
          } else if(vm.transactionType.toUpperCase() === "SIP"){
            NetcoreEvntService.upi_Transaction_Status('Sip',vm.summaryData);
          } else if(vm.transactionType.toUpperCase() === "SIPPURCHASE") {
            NetcoreEvntService.upi_Transaction_Status('SIP_PURCHASE',vm.summaryData);
          }
        }
      }, error = function(err) {
        LoaderService.hideLoader();
      };
      TransactionService.post({
        controller1: 'upi',
        controller2: 'transaction',
        controller3: 'summary'
      }, {
        transactionId: vm.transactionId,
        transactionType: vm.transactionType
      }).$promise.then(success, error);
    }

    function identifyPostLogin() {
      if (vm.summaryData.sourcePortal === 'WHATSAPP') {
        vm.showWhatsApp = true;
      } else {
        vm.showWhatsApp = false;
      }
    }

    function performRedirect(type) {
      if (type === 'PURCHASE') {
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/transactions/initiate/purchase', "_self");
        //$state.go('main.transactions.purchase');
      } else if (type === 'SIP') {
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/transactions/initiate/sip', "_self");
      }
    }

    function redirectToHome() {
      $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/welcome', "_self");
    }

    function commonEventCalling() {
      if(vm.transactionType === 'PURCHASE'){
        vm.summaryData.paymentStatus = true;
        NetcoreEvntService.dispatch_smartech(vm.summaryData);
        NetcoreEvntService.contact_Event_JSP(vm.summaryData);
        NetcoreEvntService.ack_Purchase_upi_success('Purchase',vm.summaryData);
      } else if(vm.transactionType === 'SIP') {
        vm.summaryData.paymentStatus = true;
        if(vm.summaryData.sipWithFi) {
          NetcoreEvntService.ack_SIP_AutoPay_Successfull('SIP With First Installment', vm.summaryData);
        } else {
          NetcoreEvntService.ack_SIP_AutoPay_Successfull('SIP', vm.summaryData);
        }
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UpiExpiredController', upiExpiredController);

  /** @ngInject */
  function upiExpiredController($stateParams, TransactionService, LoaderService, AppConstants, $window, HDFC_API, UtilService, NetcoreEvntService, $state) {
    var vm = this;
    vm.showWhatsApp = false;
    vm.constants = AppConstants;
    vm.UPI_TRANSACTION_STATUS = AppConstants.UPI_TRANSACTION_STATUS;
    vm.PAYMENT_OPTIONS = AppConstants.PAYMENT_METHODS_LIST;
    vm.CORPORATE_URL = HDFC_API.CORPORATE_URL;
    vm.performRedirect = performRedirect;
    vm.redirectToHome = redirectToHome;
    vm.utilService = UtilService;
    vm.isMobile = $stateParams.platform === 'ANDROID' || $stateParams.platform === 'IOS';
    vm.init = init();

    function init() {
      if ($stateParams.id) {
        vm.transactionId = $stateParams.id;
        vm.transactionType = $stateParams.type;
        getSummaryStatus();
      }
    }

    function getSummaryStatus() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        vm.summaryData = resp;
        vm.summaryData.transactionDateTime = $window.moment(vm.summaryData.transactionDateTime).format("DD-MMM-YYYY hh:mm:ss A");
        identifyPostLogin();
        var flowName = vm.summaryData.flowName;
        if (flowName === 'SIP_PURCHASE') {
          vm.transactionType = 'SIPPURCHASE'
          vm.transStatus = 'Failed';
        }
        vm.summaryData.paymentStatus = false;
        NetcoreEvntService.dispatch_smartech(vm.summaryData);
        NetcoreEvntService.contact_Event_JSP(vm.summaryData);
        if(vm.summaryData.netCoreJourney && vm.summaryData.netCoreJourney === "TRANSACT_NOW") {
          vm.summaryData.transactionInitiatedAt = vm.summaryData.transactionDateTime ? $window.moment(vm.summaryData.transactionDateTime).format("DD MMM YYYY hh:mm:ss A") : null;
          vm.summaryData.transactionDate = vm.summaryData.transactionDateTime ? $window.moment(vm.summaryData.transactionDateTime).format("DD MMM YYYY hh:mm:ss A") : null;
          if(vm.summaryData.sipTenure) {
            var dates = vm.summaryData.sipTenure.split('-');
            vm.summaryData.startDate = $window.moment(dates[0]);
            vm.summaryData.endDate = $window.moment(dates[1]);
          }
          vm.summaryData.transactionStatus = 'Failed';
          if(vm.transactionType.toUpperCase() === "PURCHASE") {
            NetcoreEvntService.upi_Transaction_Status('Purchase',vm.summaryData);
          } else if(vm.transactionType.toUpperCase() === "SIP"){
            NetcoreEvntService.upi_Transaction_Status('Sip',vm.summaryData);
          } else if(vm.transactionType.toUpperCase() === "SIPPURCHASE") {
            NetcoreEvntService.upi_Transaction_Status('SIP_PURCHASE',vm.summaryData);
          }
        }
      }, error = function(err) {
        LoaderService.hideLoader();
      };
      TransactionService.post({
        controller1: 'upi',
        controller2: 'transaction',
        controller3: 'summary'
      }, {
       transactionId: vm.transactionId,
       transactionType: vm.transactionType
      }).$promise.then(success, error);
    }

    function identifyPostLogin() {
      if (vm.summaryData.sourcePortal === 'WHATSAPP') {
        vm.showWhatsApp = true;
      } else {
        vm.showWhatsApp = false;
      }
    }

    function performRedirect(type) {
      if (type === 'PURCHASE') {
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/transactions/initiate/purchase', "_self");
        //$state.go('main.transactions.purchase');
      } else if (type === 'SIP') {
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/transactions/initiate/sip', "_self");
      }
    }

    function redirectToHome() {
      $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/welcome', "_self");
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UpiController', upiController);

  /** @ngInject */
  function upiController(AppConstants, AuthService, $timeout, $scope, $rootScope, $state, $stateParams) {
    var vm = this;
    vm.isLoading = true;
    vm.flowName = AppConstants.PRE_LOGIN_JOURNEY_ENUM;
    var removeListeners = {};
    var isRefreshing = false;
    var scope = $scope;
    vm.init = init();

    function init() {
      if ($stateParams.platform !== 'ANDROID' && $stateParams.platform !== 'IOS') {
        setListeners();
      }
    }



    function resetFlag() {
      $timeout(function () {
        isRefreshing = false;
      }, 2000);
    };

    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        /*if (!token) {
          if (token.sourcePortal && token.sourcePortal === vm.flowName.WHATSAPP) {
            $state.go('linkExpired');
          } else {
            $state.go('sessionExpired');
          }
          resetFlag();
          return;
        }*/

        if (token && token.refreshToken) {

          if (token.sourcePortal && token.sourcePortal === vm.flowName.WHATSAPP) {

            AuthService.getRefreshTokenGateway(token).then(function () {
              refreshTokenCallBackOne();
            }, function () {
              refreshTokenCallBackTwo();
            });
          } else {
            AuthService.getRefreshToken(token).then(function () {
              refreshTokenCallBackOne();
            }, function () {
              refreshTokenCallBackTwo();
            });
          }

        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          if (token.sourcePortal && token.sourcePortal === vm.flowName.WHATSAPP) {
            $state.go('linkExpired');
          } else {
            $state.go('sessionExpired');
          }
        }
      });
    }


    function refreshTokenCallBackOne() {
      if (localStorage.getItem('doLogOut')) {
        AuthService.logout().then(function () {
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          ModalService.logoutSuccess();
          if (vm.transactionDetails && vm.transactionDetails.sourcePortal === vm.flowName.WHATSAPP) {
            $state.go('linkExpired');
          } else {
            $state.go('sessionExpired');
          }
        }, function () {
          ModalService.logoutSuccess();
          if (vm.transactionDetails && vm.transactionDetails.sourcePortal === vm.flowName.WHATSAPP) {
            $state.go('linkExpired');
          } else {
            $state.go('sessionExpired');
          }
        });
      } else {
        $state.reload();
        resetFlag();
      }
    }


    function refreshTokenCallBackTwo() {
      AuthService.clearCookies(AppConstants.IDENTIFIER);
      MessageService.clear();
      if (vm.transactionDetails && vm.transactionDetails.sourcePortal === vm.flowName.WHATSAPP) {
        $state.go('linkExpired');
      } else {
        $state.go('sessionExpired');
      }
      resetFlag();
    }

    scope.$on("$destroy", function () {
      for (var key in removeListeners) {
        if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
          removeListeners[key]();
        }
      }
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InitiateTransactionSipController', initiateTransactionSipController);

  /** @ngInject */
  function initiateTransactionSipController($log, $timeout, $stateParams, HDFC_API, MessageService, ModalService,
                                                 AppConstants, SipPurchaseHelper, TransactionModel, FolioModel, AuthService, LoaderService,
                                                 NetcoreEvntService, UtilService, InvestorService, DynamicDataSipPurchaseReview, moment, $window, $transitions, $state, $scope) {
    var vm = this;

    /*constant variable declarations*/
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    /*constant variable declaration ends here*/

    vm.tForm = {};
    vm.validations = {};
    vm.renewDetails = {};
    vm.topupAmount = {};
    vm.topupCapAmount = {};
    vm.stateParams = $stateParams;
    vm.folioList = FolioModel.getFolioData() || null;
    vm.transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP;
    vm.formData = TransactionModel.getPayloadRawData() || TransactionModel.getMasterRawData(vm.transactionType);

    if(vm.formData.journey == 'Transact Now'){
      sessionStorage.setItem('journeySelected', vm.formData.journey);
    }

    if(sessionStorage.getItem('journeySelected')){
      vm.formData.journey = sessionStorage.getItem('journeySelected');
    }
    // vm.formData.sipFirstInstallment = false;
    vm.switchInvestmentType = true;
    vm.dividendOptionsOther = [ vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];
    vm.dividendOptionsELSS = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];

    vm.topupFrequencyList = [
      {key: 'Y', value: 'Yearly', monthfreq: 12},
      {key: 'H', value: 'Half Yearly', monthfreq: 6}
    ];
    vm.enabledOTMStartDatesList = [];
    vm.enabledBillerStartDatesList = [];
    vm.navigation = true;
    vm.startDateView = "date";
    vm.endDateView = "month";
    vm.sipTenurePlaceHolder = "Select dates";

    /*Method variable declarations*/
    vm.helper = getHelper();
    vm.folioChanged = folioChanged;
    vm.handleEnter = vm.helper.handleEnter;
    vm.changeThroughDistributor = vm.helper.changeThroughDistributor;
    vm.checkPurchaseValidations = vm.helper.checkPurchaseValidations;
    vm.sipSchemeChanged = sipSchemeChanged;
    vm.filterSipInSchemeList = filterSipInSchemeList;
    vm.sipSchemeListModal = sipSchemeListModal;
    vm.changedPaymentOption = changedPaymentOption;
    // vm.setDuration = setDuration;
    vm.changeFrequency = changeFrequency;
    vm.changeStartDate = vm.helper.changeStartDate;
    vm.changeEndDate = vm.helper.changeEndDate;
    vm.changeTillPerpetuityFlag = vm.helper.changeTillPerpetuityFlag;
    vm.changeDay = vm.helper.changeDay;
    vm.changeAmount = changeAmount;
    vm.checkSipValidations = vm.helper.checkSipValidations;
    vm.changeCapMonthYear = vm.helper.changeCapMonthYear;
    vm.resetCapAmount = vm.helper.resetCapAmount;
    vm.capAmountChanged = vm.helper.capAmountChanged;
    vm.changeTopUpFreq = vm.helper.changeTopUpFreq;
    vm.searchDistributor = vm.helper.searchDistributor;
    vm.fetchEuinList = vm.helper.fetchEuinList;
    vm.changeSubBrokerArn = vm.helper.changeSubBrokerArn;
    vm.fetchEuinListSubBroker = vm.helper.fetchEuinListSubBroker;
    vm.changeSubBrokerCode = vm.helper.changeSubBrokerCode;
    vm.filterEuinList = vm.helper.filterEuinList;
    vm.setTandCVariable = vm.helper.setTandCVariable;
    vm.changeDistributorCode = vm.helper.changeDistributorCode;
    vm.selectEuin = vm.helper.selectEuin;
    vm.DynamicDataSipPurchaseReview = DynamicDataSipPurchaseReview;
    vm.setDynamicData = vm.helper.setDynamicData;
    vm.searchDistributorByName = vm.helper.searchDistributorByName;
    vm.openTopupDetailsPopup = openTopupDetailsPopup;
    vm.proceedToTransact = proceedToTransact;
    /*Method variable declaration ends here*/

    /**/
    vm.init = init();

    function init() {
      if($stateParams.action == "modify") {
        vm.formData = TransactionModel.getPayloadRawData() || JSON.parse(sessionStorage.getItem('systematicData'));
        if(!vm.formData.backFromPaymentPage) {
          vm.formData.sipFirstInstallment = true;
        }
        vm.oldSipSystematicData = JSON.parse(sessionStorage.getItem('systematicData'));
      }
      fetchFolioList();
      fetchDefaultSelectionData();
      vm.setDynamicData();
      var identifierData = AuthService.getToken();
      if (identifierData) {
        vm.investorName = identifierData.investorFName;
      }
      $window.scrollTo(0,0);
    }

    function getHelper() {
      var helper = null;
      helper = SipPurchaseHelper;
      helper.setViewModel(vm);
      return helper;
    }

    function fetchFolioList() {
      vm.helper.getFolioList(function(status) {
        if (status && vm.folioList.length > 0) {
          if ($stateParams.folioNumber && !vm.formData.backFromPaymentPage) {
            vm.formData.folioNumber = $stateParams.folioNumber ? $stateParams.folioNumber : vm.formData.folioNumber;
            folioChanged();
          }

          // fetching data for prefill journey

          if ($stateParams.trackId && !vm.formData.isBackFromSummary && !vm.formData.backFromPaymentPage) {
            fetchUserSavedDataFromSave('netcore');
          } else if (status && $stateParams.transactionId && !vm.formData.backFromPaymentPage) {
            fetchUserSavedDataFromSave('saved');
          } else if (status && $stateParams.action == 'modify') {
            updateDetailsForModifySIP();
          } else if ($stateParams.action == 'renew' && !vm.formData.backFromPaymentPage) {
            vm.renewDetails = {
              folioNumber: $stateParams.folioNumber,
              schemeCode: $stateParams.sc,
              amount: $stateParams.amount,
              frequency: $stateParams.frequency
            }
            vm.showRenewData = true;
            vm.helper.fetchPreviousTrSelectedDistrubutor(function () {
              folioChanged();
            })
          } else if (($stateParams.action == 'portfolio' || ($stateParams.action == 'dashboard' && $stateParams.folioNumber && $stateParams.sc)) && !vm.formData.backFromPaymentPage) {
            vm.helper.fetchPreviousTrSelectedDistrubutor(function () {
              folioChanged();
            });
          } else if (vm.formData && vm.formData.backFromPaymentPage) {
            folioChanged();
            vm.helper.handleInvestThroughPrefill(angular.copy(vm.formData));
          } else {
            /*initialising first folio to folioNumber is list contains only one elements*/
            if (vm.folioList && vm.folioList.length > 0) {
              for(var index=0; index < vm.folioList.length; index++) {
                if(vm.folioList[index].activeFlag) {
                  vm.formData.folioNumber = vm.folioList[index].folioNumber;
                  if (!vm.formData.inSchemeCode && !$stateParams.transactionId) {
                    folioChanged();
                  }
                  break;
                }
              }
            }
          }
        }
      });
    }

    function folioChanged(fromHtml) {
      if (!vm.formData.folioNumber) {
        return;
      }
      vm.helper.checkPanAadharLinkStatus(function(status) {
        if (status) {
          var oldData = angular.copy(vm.formData);
          vm.isEmailMobileinValid = false;
          vm.isEmailinValid = false;
          vm.isMobileinValid = false;
          vm.emandateDisplay = true;
          vm.isfromSaved = false;
          vm.folioNumberChanged = fromHtml ? true : false;
          var selectedFolioObj = null;
          if($stateParams.action === "modify") {
            selectedFolioObj = vm.folioList.filter(function (obj) {
              return obj.folioNumber == vm.formData.folioNumber
            })[0];
          } else if ($stateParams.action === 'renew') {
            selectedFolioObj = vm.folioList.filter(function (folioObj) {
              return folioObj.folioNumber == vm.formData.folioNumber
            })[0];
          } else {
            selectedFolioObj = vm.folioList.filter(function (row) {
              return row.folioNumber == vm.formData.folioNumber
            })[0];
          }
          if(selectedFolioObj) {
            vm.selectedFolioData = selectedFolioObj;
            vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
          }
          /*Minor flags*/
          vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
          vm.formData.minorFlag = vm.folioMinor;

          vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName : '';
          vm.selectedFolioEmail = selectedFolioObj.email;
          vm.selectedFolioMobile = selectedFolioObj.mobileNumber;
          // vm.helper.fetchPreviousTrSelectedDistrubutor(prepareToFetchSipScheme);
          prepareToFetchSipScheme();
          if(!vm.folioNumberChanged && !$stateParams.trackId) {
            vm.helper.userActivityTracking(function(resp) {
              var data = vm.formData;
              if ((resp && angular.isDefined(resp.transactionId))) {
                vm.formData.trackId = resp.transactionId;
              }
              data.deeplink = resp.trxnUniqueLink;
              if(vm.formData.journey == 'Transact Now') {
                NetcoreEvntService.click_Transact_Sip(data);
              }
            }, "FIRST");
          }
        } else {
          vm.formData.folioNumber=null;
        }
      });
    }

    function prepareToFetchSipScheme() {
      vm.helper.fetchSipInSchemes(function (status) {
        if (status) {
          var schemeSelected = null;
          if ($stateParams.sc) {
            vm.formData.inSchemeCode = (vm.schemeChangedByUser || vm.formData.backFromPaymentPage) && vm.formData.inSchemeCode ?  vm.formData.inSchemeCode : $stateParams.sc;
            schemeSelected = vm.inSchemeList && vm.inSchemeList.filter(function(scheme) {
              return scheme.schemeCode === vm.formData.inSchemeCode;
            });
            if (schemeSelected[0]) {
              sipSchemeChanged(schemeSelected[0]);
            } else {
              vm.formData.inSchemeCode = null;
              vm.formData.inSchemeName = null;
            }
          } else if (vm.formData.inSchemeCode) {
            schemeSelected = vm.inSchemeList && vm.inSchemeList.filter(function(scheme) {
              return scheme.schemeCode === vm.formData.inSchemeCode;
            });
            if (schemeSelected[0]) {
              sipSchemeChanged(schemeSelected[0]);
            } else {
              vm.formData.inSchemeCode = null;
              vm.formData.inSchemeName = null;
            }
          }
        }
      });
    }

    function sipSchemeChanged (schemeData, fromHtml) {
      if (!schemeData) {
        return;
      } else {
        vm.schemeChangedByUser = fromHtml ? fromHtml : false;
        vm.formData.startDate = (vm.formData.backFromPaymentPage && vm.formData.startDate) || (vm.folioNumberChanged && vm.formData.startDate) ? vm.formData.startDate : null;
        vm.formData.endDate = (vm.formData.backFromPaymentPage || vm.formData.endDate) || (vm.folioNumberChanged && vm.formData.endDate) ? vm.formData.endDate : null;
        vm.enabledStartDates = null;
        vm.enabledEndDates = null;
        vm.formData.weeklyDay = vm.formData.weeklyDay && vm.formData.frequency && vm.formData.frequency == "OW" ? vm.formData.weeklyDay : null;
        // vm.formData.sipFirstInstallment =false;
        vm.formData.inSchemeCode = schemeData.schemeCode;
        vm.formData.inSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        vm.formData.fundCode = schemeData.fundCode;
        vm.formData.fundName = schemeData.fundName;
        if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.formData.frequency = null;
          vm.frequencyList = [];
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
          return;
        }
        vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
        vm.helper.fetchSipSchemeValidations(function (success) {
          if(success) {
            vm.helper.setSipDividendOptionsValue(vm.inSchemeValidations);
            setDefaultData();
          }
          vm.helper.setUpSipValidations();
          vm.helper.getDateValidation();
        });

        if(schemeData.schemeType === 'NFO') {
          var message = schemeData.message;
          ModalService.nfoEnabledModal({
            message: message,
            showBlueBtn: true
          });
        }
      }
    }

    function filterSipInSchemeList() {
      vm.formData.inSchemeCode = '';
      vm.authenticationMode = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
      vm.isfromSaved = false;
      vm.savedweeklyDay = null;
      vm.savedStartDate = null;
      vm.savedEndDate = null;
      // vm.renewDetails = {};
      vm.helper.resetNumInWords();
    }

    function sipSchemeListModal() {
      vm.helper.checkPanAadharLinkStatus(function(status) {
        if (status) {
          if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
            MessageService.error('No free available units');
            return;
          }
          var successSchemeList = function (result) {
            var schemeChangedByUser = result.schemeChangedByUser ? result.schemeChangedByUser : false;
              vm.savedweeklyDay = null;
              vm.savedStartDate = null;
              vm.savedEndDate = null;
              // vm.renewDetails = {};
              var investOption = result && result.isThroughDistributor ? "ARN" : vm.formData && vm.formData.isThroughRia ? "RIA" : "DIRECT";
              vm.helper.changeInvestmentTypeOption(investOption, "FROM_SCHEME_MODAL",function (sucess) {
                if(sucess) {
                  vm.helper.fetchSipInSchemes(function () {
                    sipSchemeChanged(result, schemeChangedByUser);
                  })
                }
              });
          },
          errorSchemeList = function (crossIconClicked) {
              if(!crossIconClicked) {
                vm.formData.inSchemeCode = '';
                vm.formData.inSchemeName = '';
                vm.formData.startDate = null;
                vm.formData.endDate = null;
                vm.savedweeklyDay = null;
                vm.savedStartDate = null;
                vm.savedEndDate = null;
                vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
              }
            };

          var isFlexStp = false;

          ModalService.schemeListNewModal({
            enabledScheme: 'sipenabled',
            isMinor: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
            isFlexStp: isFlexStp,
            isThroughDistributor: vm.formData.isThroughDistributor,
            corporateFlag : vm.formData.corporateInvestor
          }, successSchemeList, errorSchemeList);
        }
      });
    }

    function changeFrequency(freq, fromHTML) {
      if(!freq || (vm.selectedFreq && (vm.selectedFreq.code === freq.code))) {
        return;
      }
      vm.freqChanged = fromHTML ? fromHTML : false;
      vm.formData.endDate = null;
      vm.enabledEndDates = null;
      vm.formData.day = null;
      vm.formData.weeklyDay = null;
      vm.formData.month = null;
      vm.formData.isTillPerpetuity = false;
      vm.formData.sipTopupEnabled=false;
      // vm.formData.sipFirstInstallment = false;
      vm.showSavedData = false;
      vm.showRenewData = false;
      vm.savedAmount = null;
      vm.savedStartDate = null;
      vm.savedEndDate = null;
      vm.savedFrequency = null;
      setDefaultData(function (success) {
        vm.selectedFreq = freq;
        vm.formData.frequency = vm.selectedFreq.code;
        vm.helper.setUpSipValidations();
        if(vm.formData.frequency == 'OW') {
          vm.formData.weeklyDay = vm.daysList[0];
          vm.formData.startDate = null;
          vm.formData.endDate = null;
          vm.enabledStartDates = [];
          vm.enabledEndDates = [];
          vm.helper.changeDay(vm.formData.weeklyDay);
        }
        if(success && vm.formData.frequency !== 'OW') {
          vm.formData.weeklyDay = null;
          vm.formData.startDate = null;
          vm.formData.endDate = null;
          vm.enabledStartDates = [];
          vm.enabledEndDates = [];
          vm.helper.calculateStartDate();
        }
      });

      if(vm.formData.frequency == 'Q' && vm.formData.topupDetails && vm.formData.topupDetails.frequency === 'H') {
        resetTopupDetails();
        vm.formData.sipTopupSelected = false;
      }

    }

    function changedPaymentOption(optionSelected) {}

    function fetchDefaultSelectionData() {
      var successHandler = function(resp) {
        if(resp.status && resp.data) {
          LoaderService.hideLoader();
          vm.defaultData = resp.data;
          vm.upiMandateData = vm.defaultData && vm.defaultData.upiMandateData && vm.defaultData.upiMandateData.upi ? vm.defaultData.upiMandateData.upi : null;
          vm.maxMandateDurationYears = vm.upiMandateData && vm.upiMandateData.maxMandateDurationYears ? vm.upiMandateData.maxMandateDurationYears : 30;
          setDefaultData();
        } else {
          vm.durations = [];
          MessageService.error(resp.message);
        }

      }, errorHandler = function(err) {
        vm.durations = [];
        LoaderService.hideLoader();
        MessageService.error(err.message)
      };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'transaction',
        child2: 'default',
        child3: 'details'
      }).$promise.then(successHandler, errorHandler)
    }

    function fetchUserSavedDataFromSave(dropJourneyType) {
      vm.helper.fetchDataFromSaveFlow(dropJourneyType,function (data) {
        if (data) {
          vm.transId = data.transactionId;
          vm.savedData = angular.copy(data.formdata ? data.formdata : data);
          if (vm.savedData) {
            vm.showSavedData = true;
            vm.formData = vm.savedData;
            vm.formData.inSchemeCode = vm.savedData.schemeCode;
            vm.savedAmount = vm.savedData && vm.savedData.installmentAmount ? vm.savedData.installmentAmount : vm.savedData.amount ? vm.savedData.amount : null;
            vm.savedFrequency = vm.savedData && vm.savedData.frequency ? vm.savedData.frequency : null;
            vm.savedStartDate = vm.savedData && vm.savedData.sipDate ? moment(vm.savedData.sipDate) : null;
            vm.savedEndDate = vm.savedData && vm.savedData.toDate ? moment(vm.savedData.toDate) : null;
            vm.formData.sipFirstInstallment = vm.savedData.sipWithFirstInstallment;
            vm.formData.sipDividendOption = vm.savedData.dividendOption;
            vm.formData.trackId = angular.copy(data.transactionId);
            if(vm.formData.topupDetails && vm.formData.topupDetails.amount && vm.formData.topupDetails.capMonthYear) {
              vm.formData.topupDetails.capMonthYearSelect = angular.copy($window.moment(vm.savedData.topupDetails.capMonthYear));
            }
            if(vm.savedAmount) {
              vm.formData.displayAmount = UtilService.amountInComma(vm.savedAmount).amountInComma;
            }
            if(vm.formData.topupDetails) {
              if(vm.formData.topupDetails && vm.formData.topupDetails.amount) {
                vm.formData.topupDetails.previousValidAmount = angular.copy(vm.formData.topupDetails.amount);
              }
              if(vm.formData.topupDetails && vm.formData.topupDetails.frequency) {
                vm.formData.topupDetails.previousFreq = angular.copy(vm.formData.topupDetails.frequency)
              }
              if(vm.formData.topupDetails && vm.formData.topupDetails.capAmount) {
                vm.formData.topupDetails.previousCapAmount = angular.copy(vm.formData.topupDetails.capAmount);
              }
              if(vm.formData.topupDetails && vm.formData.topupDetails.capMonthYearSelect) {
                vm.formData.topupDetails.previousCapYear = angular.copy(vm.formData.topupDetails.capMonthYearSelect);
              }
            }
            vm.helper.handleInvestThroughPrefill(angular.copy(vm.savedData));
            vm.formData.investmentType = vm.formData.investmentType ? vm.formData.investmentType : 'PURCHASE';
            folioChanged();
          }
        }
      })

    }

    function updateDetailsForModifySIP() {
      vm.helper.handleInvestThroughPrefill(angular.copy(vm.formData));
      vm.formData.investmentType = vm.formData.investmentType ? vm.formData.investmentType : 'PURCHASE';
      folioChanged();
    }

    function setDefaultData(cb) {
      cb = cb ||function () {};
      if(vm.showSavedData) {
        vm.formData.amount = vm.savedAmount;
      } else if (vm.showRenewData && vm.formData.amount && !vm.changedAmount && (vm.renewDetails.amount > vm.defaultData.sipDefaultAmount)) {
        vm.formData.amount = parseInt(vm.renewDetails.amount);
      } else if ((!vm.showSavedData && !vm.formData.amount && vm.defaultData && vm.defaultData.sipDefaultAmount) || (vm.showRenewData && vm.renewDetails && (vm.renewDetails.amount < vm.defaultData.sipDefaultAmount))) {
        vm.formData.amount = vm.defaultData.sipDefaultAmount;
      } else if (vm.showRenewData && vm.renewDetails && vm.renewDetails.amount && (vm.renewDetails.amount > vm.defaultData.sipDefaultAmount)) {
        vm.formData.amount = vm.renewDetails.amount;
      } else if (vm.formData.amount) {
        vm.formData.amount = vm.formData.amount;
      } else {
        vm.formData.amount = null;
      }
      vm.formData.displayAmount = vm.formData.amount && vm.formData.amount !== 0 ? UtilService.amountInComma(vm.formData.amount).amountInComma: vm.formData.amount;
      if (vm.formData.amount && vm.formData.amount !== 0) {
        $window.NumToWord(vm.formData.amount, "divDisplayWordsModified", vm.formData);
      }

      if(($stateParams.action === "modify" || vm.showSavedData) && vm.formData.topupDetails && vm.formData.topupDetails.amount && !vm.freqChanged) {
        vm.formData.sipTopupSelected = true;
      } else {
        if((vm.formData.backFromPaymentPage && vm.formData.topupDetails && vm.formData.topupDetails.amount && !vm.freqChanged) || (vm.savedData && vm.formData.topupDetails && !vm.formData.backFromPaymentPage)) {
          vm.formData.topupDetails = angular.copy(vm.formData.topupDetails);
        } else if(vm.savedData && !vm.formData.topupDetails){
          vm.formData.topupDetails = {};
        }
      }
      vm.defaultFreq = vm.defaultData && vm.defaultData.defaultFrequency ? vm.defaultData.defaultFrequency : {};
      if(vm.defaultFreq && !vm.formData.backFromPaymentPage && !vm.formData.frequency) {
        vm.selectedFreq = vm.defaultFreq;
      }
      if(vm.defaultFreq && !vm.formData.frequency) {
        vm.formData.frequency = vm.defaultFreq.code;
      }
      vm.durations = vm.defaultData && vm.defaultData.durations ? vm.defaultData.durations : [];
      cb(true);
    }

    function resetTopupDetails() {
      vm.formData.topupDetails = {};
    }

    function changeAmount(fromTopup, changedAmount, fromHTML) {
      vm.amountChangeFromHTML = fromHTML ? fromHTML : false;
      vm.changedAmount = changedAmount;
      vm.formData.displayAmount = vm.formData.displayAmount &&  vm.formData.displayAmount !== '0' ? UtilService.amountInComma(vm.formData.displayAmount).amountInComma: null;
      vm.formData.amount = vm.formData.displayAmount? UtilService.amountInComma(vm.formData.displayAmount).amount: null;
      if (vm.formData.amount && vm.formData.amount !== 0) {
        $window.NumToWord(vm.formData.amount, "divDisplayWordsModified", vm.formData);
      }
      vm.helper.checkSipValidations(false, fromHTML, function () {
        if(vm.formData.frequency === "OW") {
          var day = vm.formData.weeklyDay ? vm.formData.weeklyDay : vm.daysList && vm.daysList.length > 0 ? vm.daysList[0] : null;
          vm.helper.changeDay(day);
        } else {
          vm.helper.updateEndDates();
        }
      });
    }

    function openTopupDetailsPopup() {
      vm.formData.sipTopupSelected = !vm.formData.sipTopupSelected;
      vm.formData.topupDetails = {};
      if(vm.formData.sipTopupSelected) {
        vm.formData.sipTopupSelected = false;
      } else {
        vm.helper.showTopUpDetails();
      }
    }

    function proceedToTransact() {
      if($stateParams.action === "modify" && !vm.showCancelledAndModifiedDetails) {
        vm.showCancelledAndModifiedDetails = true;
        vm.oldSipSystematicData.displayAmount = vm.oldSipSystematicData.amount ? UtilService.amountInComma(vm.oldSipSystematicData.amount).amountInComma : null;
        if(vm.oldSipSystematicData && vm.oldSipSystematicData.topupDetails) {
          vm.oldSipSystematicData.topupDetails.displayAmount = vm.oldSipSystematicData.topupDetails.amount ? UtilService.amountInComma(vm.oldSipSystematicData.topupDetails.amount).amountInComma : null;
          vm.oldSipSystematicData.topupDetails.displayCapAmount = vm.oldSipSystematicData.topupDetails.capAmount ? UtilService.amountInComma(vm.oldSipSystematicData.topupDetails.capAmount).amountInComma : null;
          if(vm.oldSipSystematicData.topupDetails && vm.oldSipSystematicData.topupDetails.amount) {
            vm.topupAmountFromModify = {};
            $window.NumToWord(vm.oldSipSystematicData.topupDetails.amount, "topUpamountFromModify", vm.topupAmountFromModify);
          }
          if(vm.oldSipSystematicData.topupDetails && vm.oldSipSystematicData.topupDetails.capAmount) {
            vm.topupCapAmountFromModify = {};
            $window.NumToWord(vm.oldSipSystematicData.topupDetails.capAmount, "topUpCapamountFromModify", vm.topupCapAmountFromModify);
          }
        }
        $window.NumToWord(vm.oldSipSystematicData.amount, "amountInwords", vm.oldSipSystematicData);
        $window.NumToWord(vm.formData.amount, "divDisplayWordsModified", vm.formData);
        if(vm.formData.topupDetails && vm.formData.topupDetails.amount) {
          $window.NumToWord(vm.formData.topupDetails.amount, "topupAmountModified", vm.topupAmount);
        }
        if(vm.formData.topupDetails && vm.formData.topupDetails.capAmount) {
          $window.NumToWord(vm.formData.topupDetails.capAmount, "capAmountModified", vm.topupCapAmount);
        }
      } else {
        vm.helper.proceedToTransact();
      }
    }

    $transitions.onExit({from: "main.transactions.sip"}, function(transition) {
      if (!vm.navigation) {
        return;
      }
      vm.navigation = false;
      var pendingNavigation = transition;
      var stateName = pendingNavigation.to().name;
      var excludedStates = ['main.paymentHome', 'main.transactions.sip', 'login', 'sessionExpired'];
      if(transition.from().name === "main.transactions.sip" && !excludedStates.includes(stateName)) {
        if(vm.formData.folioNumber && vm.formData.inSchemeCode && vm.formData.fundName && !vm.formData.sipFirstInstallment && vm.formData.frequency === 'OM' && !($stateParams.action && $stateParams.action == "modify")) {
          var successHandler = function() {
            vm.redirectingState = stateName;
            vm.navigation = true;
            if(!$stateParams.trackId) {
              vm.helper.userActivityTracking(function(resp) {
                var data = vm.formData;
                if ((resp && angular.isDefined(resp.transactionId))) {
                  vm.formData.trackId = resp.transactionId;
                }
                data.deeplink = resp.trxnUniqueLink;
                if(vm.formData.journey == 'Transact Now') {
                  NetcoreEvntService.add_to_cart_event_sip(data);
                }
              }, "FIRST");
            }
            vm.helper.addToEcart();
          }, errorHandler = function () {

            // Redirect the user to the intended state
            transition.abort();
            $state.go(pendingNavigation.to().name);

          };
          ModalService.genericModal({
            fundName: vm.formData.fundName
          }, successHandler, errorHandler)
          return false;
        }
      }

      $scope.$on('$destroy', function () {
        sessionStorage.removeItem('journeySelected');
      })

    });


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InitiateTransactionPurchaseController', initiateTransactionPurchaseController);

  /** @ngInject */
  function initiateTransactionPurchaseController($log, $timeout, $stateParams, HDFC_API, MessageService, ModalService,
           AppConstants, SipPurchaseHelper, TransactionModel, FolioModel, AuthService, LoaderService, $scope,
           NetcoreEvntService, UtilService, TransactionService, DynamicDataSipPurchaseReview, InvestorService, $window, $transitions, $state) {
    var vm = this;

    /*constant variable declarations*/
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    /*constant variable declaration ends here*/

    vm.tForm = {};
    vm.validations = {};
    vm.folioList = FolioModel.getFolioData() || null;
    vm.transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE;
    vm.formData = TransactionModel.getPayloadRawData() || TransactionModel.getMasterRawData(vm.transactionType);
    vm.formData.startSip = false;
    vm.navigation = true;

    if(vm.formData.journey == 'Transact Now'){
      sessionStorage.setItem('journeySelected', vm.formData.journey);
    }

    if(sessionStorage.getItem('journeySelected')){
      vm.formData.journey = sessionStorage.getItem('journeySelected');
    }

    /*Method variable declarations*/
    vm.helper = getHelper();
    vm.folioChanged = folioChanged;
    vm.handleEnter = vm.helper.handleEnter;
    vm.changeThroughDistributor = vm.helper.changeThroughDistributor;
    vm.checkPurchaseValidations = vm.helper.checkPurchaseValidations;
    vm.purchaseInSchemeChanged = purchaseInSchemeChanged;
    vm.filterPurchaseInSchemeList = filterPurchaseInSchemeList;
    vm.purchaseSchemeListModal = purchaseSchemeListModal;
    vm.showPrefillValues = showPrefillValues;
    vm.saveForm = saveForm;
    vm.searchDistributor = vm.helper.searchDistributor;
    vm.fetchEuinList = vm.helper.fetchEuinList;
    vm.changeSubBrokerArn = vm.helper.changeSubBrokerArn;
    vm.fetchEuinListSubBroker = vm.helper.fetchEuinListSubBroker;
    vm.changeSubBrokerCode = vm.helper.changeSubBrokerCode;
    vm.filterEuinList = vm.helper.filterEuinList;
    vm.setTandCVariable = vm.helper.setTandCVariable;
    vm.changeDistributorCode = vm.helper.changeDistributorCode;
    vm.selectEuin = vm.helper.selectEuin;
    vm.DynamicDataSipPurchaseReview = DynamicDataSipPurchaseReview;
    vm.setDynamicData = vm.helper.setDynamicData;
    vm.openSIPDetailsPopup = openSIPDetailsPopup;
    vm.proceedToTransact = vm.helper.proceedToTransact;
    vm.dividendOptionsOther = [ vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];
    vm.dividendOptionsELSS = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];
    /*Method variable declaration ends here*/

    vm.init = init();

    /**/
    function init() {
      /*
      * if condition to check the url parameter for schedule transactions
      */
      if ($stateParams.initiatedBy === 'schedule') {
        vm.helper.getScheduleTransactionDetails();
      }
      fetchFolioList();
      fetchDefaultSelectionData();
      vm.setDynamicData();
      var identifierData = AuthService.getToken();
      if (identifierData) {
        vm.investorName = identifierData.investorFName;
      }
    }

    function getHelper() {
      var helper = null;
      helper = SipPurchaseHelper;
      helper.setViewModel(vm);
      return helper;
    }

    function fetchFolioList() {
      vm.helper.getFolioList(function(status) {
        if (status && vm.folioList.length > 0) {
          /*initialising first folio to folioNumber is list contains only one elements*/
          if ($stateParams.folioNumber && !vm.formData.backFromPaymentPage) {
            vm.formData.folioNumber = $stateParams.folioNumber ? $stateParams.folioNumber : vm.formData.folioNumber;
            folioChanged();
          }

          // fetching data for prefill journey

          if ($stateParams.trackId && !vm.formData.isBackFromSummary && !vm.formData.backFromPaymentPage) {
            fetchUserSavedDataFromSave('netcore');
          } else if (status && $stateParams.transactionId && $stateParams.initiatedBy !== 'schedule' && !$stateParams.isFavourite && !vm.formData.backFromPaymentPage) {
            fetchUserSavedDataFromSave('saved');
          } else if (status && $stateParams.transactionId && $stateParams.initiatedBy !== 'schedule' && $stateParams.isFavourite && !vm.formData.backFromPaymentPage) {
            fetchUserSavedDataFromSave('favourite');
          } else if (vm.formData && vm.formData.backFromPaymentPage) {
            folioChanged();
            vm.helper.handleInvestThroughPrefill(angular.copy(vm.formData));
          } else if ($stateParams.action == 'portfolio' || ($stateParams.action == 'dashboard' && $stateParams.folioNumber && $stateParams.sc)) {
            vm.helper.fetchPreviousTrSelectedDistrubutor(function () {
              folioChanged();
            });
          } else {
            if (vm.folioList && vm.folioList.length > 0) {
              for(var index=0; index < vm.folioList.length; index++) {
                if(vm.folioList[index].activeFlag) {
                  vm.formData.folioNumber = vm.folioList[index].folioNumber;
                  if (!vm.formData.purchaseInSchemeCode && !$stateParams.transactionId) {
                    folioChanged();
                  }
                  break;
                }
              }
            }
          }

        }
      });
    }

    function folioChanged(fromHtml) {

      // if (!calledFromSaveFlow) {
      //   vm.showSavedData = false;
      // }

      if (!vm.formData.folioNumber) {
        return;
      }
      vm.helper.checkPanAadharLinkStatus(function(status) {
        if (status) {
          // if (!vm.showSavedData) {
          //   vm.helper.resetAll();
          // }
          var oldData = angular.copy(vm.formData);
          vm.isEmailMobileinValid = false;
          vm.isEmailinValid = false;
          vm.isMobileinValid = false;
          vm.emandateDisplay = true;
          vm.isfromSaved = false;
          vm.folioNumberChanged = fromHtml ? true : false;
          var selectedFolioObj = vm.folioList.filter(function (row) {
            return row.folioNumber == vm.formData.folioNumber
          })[0];
          if(selectedFolioObj) {
            vm.selectedFolioData = selectedFolioObj;
            vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
          }
          /*Minor flags*/
          vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
          vm.formData.minorFlag = vm.folioMinor;

          vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName : '';
          vm.selectedFolioEmail = selectedFolioObj.email;
          vm.selectedFolioMobile = selectedFolioObj.mobileNumber;
          // if (vm.formData.isDirect || calledFromSaveFlow) {
            prepareToFetchPurchaseScheme();
          // } else {
          //   vm.helper.fetchPreviousTrSelectedDistrubutor(prepareToFetchPurchaseScheme);
          // }
          if(!vm.folioNumberChanged && !$stateParams.trackId) {
            vm.helper.userActivityTracking(function(resp) {
              var data = vm.formData;
              if ((resp && angular.isDefined(resp.transactionId))) {
                vm.formData.trackId = resp.transactionId;
              }
              data.deeplink = resp.trxnUniqueLink;
              if(vm.formData.journey == 'Transact Now') {
                NetcoreEvntService.click_Transact_Purchase(data);
              }
            }, "FIRST");
          }
        } else {
          vm.formData.folioNumber=null;
        }
      });
    }

    function prepareToFetchPurchaseScheme() {
      vm.helper.fetchPurchaseInSchemes(function(status) {
        if (status) {
          if ($stateParams.sc) {
            vm.formData.purchaseInSchemeCode = (vm.schemeChangedByUser || vm.formData.backFromPaymentPage) && vm.formData.purchaseInSchemeCode ? vm.formData.purchaseInSchemeCode : $stateParams.sc;
            var schemeSelected = vm.purchaseInSchemeList && vm.purchaseInSchemeList.filter(function(scheme) {
              return scheme.schemeCode === vm.formData.purchaseInSchemeCode;
            });
            if (schemeSelected[0]) {
              purchaseInSchemeChanged(schemeSelected[0]);
            } else {
              vm.formData.purchaseInSchemeCode = null;
              vm.formData.purchaseInSchemeName = null;
            }
          } else if (vm.formData.purchaseInSchemeCode) {
            var schemeSelected = vm.purchaseInSchemeList && vm.purchaseInSchemeList.filter(function(scheme) {
              return scheme.schemeCode === vm.formData.purchaseInSchemeCode;
            });
            if (schemeSelected[0]) {
              purchaseInSchemeChanged(schemeSelected[0]);
            } else {
              vm.formData.purchaseInSchemeCode = null;
              vm.formData.purchaseInSchemeName = null;
            }
          }
        }
      });
    }

    function purchaseInSchemeChanged (schemeData, fromHtml) {
      if (!schemeData) {
        return;
      } else {
        vm.schemeChangedByUser = fromHtml ? fromHtml : false;
        vm.formData.purchaseInSchemeCode = schemeData.schemeCode;
        vm.formData.purchaseInSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        vm.formData.fundCode = schemeData.fundCode;
        vm.formData.fundName = schemeData.fundName;
        setDefaultData();
        if (schemeData.nfoEnabled == 'Y') {
          vm.nfoEnabled = true;
        } else {
          vm.nfoEnabled = false;
        }
        if(vm.formData.purchaseInSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.purchaseInSchemeCode = '';
          vm.formData.purchaseInSchemeName = '';
          vm.formData.frequency = null;
          vm.frequencyList = [];
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
          return;
        }
       /* if (vm.formData.purchaseInSchemeName.toLowerCase().includes("retirement")) {
          vm.showChequeLeaf = true;
        } else {
          vm.showChequeLeaf = false;
        }*/
        vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
        vm.helper.fetchPurchaseValidations();
        // fetchBankList();
      }

      if (vm.showSavedData && vm.formData.amount) {
        // vm.checkPurchaseValidations();
      } else {
        // vm.formData.amount = '';
      }
    }

    function filterPurchaseInSchemeList() {
      vm.formData.purchaseInSchemeCode = '';
      vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
      vm.helper.resetNumInWords();
    }

    function purchaseSchemeListModal() {
      vm.helper.checkPanAadharLinkStatus(function(status) {
        if (status) {
          vm.formData.amount = '';
          var successSchemeList = function (result) {
            // vm.formData.purchaseInSchemeCode = result.schemeCode;
            // vm.formData.purchaseInSchemeName = result.scheme;
            // vm.formData.schemeType = result.schemeType;
            // vm.formData.liquidFlag = vm.formData.schemeType == 'LIQUID' ? true : false;
            // if (result.nfoEnabled == 'Y') {
            //   vm.nfoEnabled = true;
            // } else {
            //   vm.nfoEnabled = false;
            // }
              var schemeChangedByUser = result.schemeChangedByUser ? result.schemeChangedByUser : false;
              var investOption = result && result.isThroughDistributor ? "ARN" : vm.formData && vm.formData.isThroughRia ? "RIA" : "DIRECT";
              vm.helper.changeInvestmentTypeOption(investOption, "FROM_SCHEME_MODAL",function (sucess) {
                if(sucess) {
                  vm.helper.fetchPurchaseInSchemes(function () {
                    purchaseInSchemeChanged(result, schemeChangedByUser);
                  })
                }
              });
            // vm.helper.fetchPurchaseValidations();
            // vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
            // vm.helper.resetNumInWords();
          },
          errorSchemeList = function (crossIconClicked) {
            if(!crossIconClicked) {
              vm.formData.purchaseInSchemeCode = '';
              vm.formData.purchaseInSchemeName = '';
              vm.purchaseValidations = null;
              vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
            }
          };
          ModalService.schemeListNewModal({
            enabledScheme: 'purchaseenabled',
            isMinor: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
            isThroughDistributor: vm.formData.isThroughDistributor,
            corporateFlag : vm.formData.corporateInvestor
          }, successSchemeList, errorSchemeList);
        }
      });
    }

    function fetchBankList() {
      $scope.$broadcast('fetchBankList');
    }

    function showPrefillValues() {

    }

    function saveForm() {
      vm.helper.saveData();
    }

    function fetchUserSavedDataFromSave(dropJourneyType) {


      vm.helper.fetchDataFromSaveFlow(dropJourneyType,function (data) {
        if (data) {
          vm.showSavedData = true;
          vm.transId = data.transactionId;
          vm.formData = angular.copy(data.formdata ? data.formdata : data);
          vm.savedAmount = vm.formData && vm.formData.amount ? vm.formData.amount : null;
          vm.formData.purchaseInSchemeCode = vm.formData.schemeCode;
          vm.formData.trackId = angular.copy(data.transactionId);
          vm.formData.sipDetailsViaPurchase = vm.formData.backFromPaymentPage && vm.formData.sipDetailsViaPurchase ? vm.formData.sipDetailsViaPurchase : {};
          if(dropJourneyType === "netcore" && data.formdata.startSipEnabled) {
            vm.formData.sipDetailsViaPurchase = {
              "sipAmount": data.formdata.startSipDetails.amount
            }
            vm.formData.frequency = data.formdata.startSipDetails.frequency;
            vm.formData.startDate = $window.moment(data.formdata.startSipDetails.startDate);
            vm.formData.endDate = $window.moment(data.formdata.startSipDetails.endDate);
            vm.formData.sipViaPurchaseSelected = data.formdata.startSipEnabled;
            vm.formData.sipDetailsViaPurchase.previousValidAmount = angular.copy(data.formdata.startSipDetails.amount);
            vm.formData.sipDetailsViaPurchase.previousStartDate = angular.copy($window.moment(data.formdata.startSipDetails.startDate));
            vm.formData.sipDetailsViaPurchase.previousEndDate = angular.copy($window.moment(data.formdata.startSipDetails.endDate));
          }

          if(vm.savedAmount) {
            vm.formData.displayAmount = UtilService.amountInComma(vm.savedAmount).amountInComma;
          }

          vm.helper.handleInvestThroughPrefill(angular.copy(vm.formData));
          vm.formData.investmentType = vm.formData.investmentType ? vm.formData.investmentType : 'PURCHASE';
          folioChanged(true);
        }
      })

    }

    function openSIPDetailsPopup() {
      vm.formData.sipViaPurchaseSelected = !vm.formData.sipViaPurchaseSelected;
      if(vm.formData.sipViaPurchaseSelected) {
        vm.formData.sipViaPurchaseSelected = false;
        vm.formData.sipDetailsViaPurchase = {};
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.mixTransactionType = null;
      } else {
        vm.helper.showSIPDetails();
      }
    }

    function fetchDefaultSelectionData() {
      var successHandler = function(resp) {
        if(resp.status && resp.data) {
          LoaderService.hideLoader();
          vm.defaultData = resp.data;
          vm.upiMandateData = vm.defaultData && vm.defaultData.upiMandateData && vm.defaultData.upiMandateData.upi ? vm.defaultData.upiMandateData.upi : null;
          vm.maxMandateDurationYears = vm.upiMandateData && vm.upiMandateData.maxMandateDurationYears ? vm.upiMandateData.maxMandateDurationYears : 30;
          setDefaultData();
        } else {
          vm.durations = [];
          MessageService.error(resp.message);
        }

      }, errorHandler = function(err) {
        vm.durations = [];
        LoaderService.hideLoader();
        MessageService.error(err.message)
      };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'transaction',
        child2: 'default',
        child3: 'details'
      }).$promise.then(successHandler, errorHandler)
    }

    function setDefaultData(cb) {
      cb = cb ||function () {};
      if(vm.showSavedData) {
        vm.formData.amount = vm.savedAmount;
      } else if (!vm.showSavedData && !vm.formData.amount && vm.defaultData && vm.defaultData.purchaseDefaultAmount) {
        vm.formData.amount = vm.defaultData.purchaseDefaultAmount;
      } else if (vm.formData.amount && vm.formData.amount !== 0) {
        vm.formData.amount = vm.formData.amount;
      } else {
        vm.formData.amount = null;
      }
      if (vm.formData.amount && vm.formData.amount !== 0) {
        vm.formData.displayAmount = UtilService.amountInComma(vm.formData.amount).amountInComma;
        $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
      }
      vm.formData.purchaseDefaultAmount = vm.defaultData && vm.defaultData.purchaseDefaultAmount ? vm.defaultData.purchaseDefaultAmount : vm.formData.amount;
      vm.defaultFreq = vm.defaultData && vm.defaultData.defaultFrequency ? vm.defaultData.defaultFrequency : {};
      if(vm.defaultFreq) {
        vm.selectedFreq = vm.defaultFreq;
        vm.formData.frequency = vm.defaultFreq.code;
      }
      cb(true);
    }

    $transitions.onExit({from: "main.transactions.purchase"}, function(transition) {
      if (!vm.navigation) {
        return;
      }
      vm.navigation = false;
      var pendingNavigation = transition;
      var stateName = pendingNavigation.to().name;
      var excludedStates = ['main.paymentHome', 'main.transactions.purchase', 'login', 'sessionExpired'];
      if(transition.from().name === "main.transactions.purchase" && !excludedStates.includes(stateName)) {
        if(vm.formData.folioNumber && vm.formData.purchaseInSchemeCode && vm.formData.fundName) {
          var successHandler = function() {
            vm.redirectingState = stateName;
            vm.navigation = true;
            if(!$stateParams.trackId) {
              vm.helper.userActivityTracking(function(resp) {
                var data = vm.formData;
                if ((resp && angular.isDefined(resp.transactionId))) {
                  vm.formData.trackId = resp.transactionId;
                }
                data.deeplink = resp.trxnUniqueLink;
                if(vm.formData.journey == 'Transact Now' && !vm.formData.sipViaPurchaseSelected) {
                  NetcoreEvntService.add_to_cart_event(data);
                } else if (vm.formData.journey == 'Transact Now' && vm.formData.sipViaPurchaseSelected) {
                  data.totalAmount = vm.formData.amount + vm.formData.sipDetailsViaPurchase.sipAmount;
                  NetcoreEvntService.add_to_cart_event_mix_transaction(data)
                }
              }, "FIRST");
            }
            if(vm.formData.sipViaPurchaseSelected) {
              vm.formData.mixTransactionType = "SIPPURCHASE";
              vm.helper.addToEartMixTrxn();
            } else {
              vm.helper.addToEcart();
            }
          }, errorHandler = function () {

            // Redirect the user to the intended state
            transition.abort();
            $state.go(pendingNavigation.to().name);

          };
          ModalService.genericModal({
            fundName: vm.formData.fundName
          }, successHandler, errorHandler)
          return false;
        }
      }
    });

    $scope.$on('$destroy', function () {
      sessionStorage.removeItem('journeySelected');
    })


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SelectSchemeController', SelectSchemeController);

  /** @ngInject */
  function SelectSchemeController($rootScope, LoaderService, $location, $window, AuthService, $log, AppConstants, MessageService, InvestorService, TransactionsService, $state, IIHttpService, UtilService) {
    var vm = this;
    vm.$state = $state;
    vm.showDetails = false;
    vm.DirectScheme = true;
    vm.filterwithname = "";
    vm.init = init;
    vm.selectedscheme = {};
    vm.setGetDraftData = setGetDraftData;
    vm.GetSchemeCategoryList = GetSchemeCategoryList;
    vm.GetSchemeCategoryDetailsList = GetSchemeCategoryDetailsList;
    vm.schemeCategoryDetailsList = [];
    vm.schemeCategoryList = [];
    vm.selectedschemeCategoryDetails;
    vm.saveDraftPayload = {};
    vm.selectedschemeCategory;
    $rootScope.currentstate = $state.current.url;
    vm.selectedYourScheme = "";
    vm.hideArnTogg = true;
    sessionStorage.removeItem("onotp");
    vm.userData = JSON.parse(sessionStorage.getItem("verifyObj"))
    vm.closeSession = function () {
      sessionStorage.removeItem("verifyObj");
      AuthService.clearCookies(AppConstants.IDENTIFIER);
      $rootScope.refreshme = true;
      $state.go('newInvestor.kycVerification');
    }

    vm.toggleDetails = function (index) {
      vm.selectedschemeCategoryDetails[index].Expand = !vm.selectedschemeCategoryDetails[index].Expand;
    }
    vm.getScheme = function (scheme) {
      if (scheme.selectedScheme) {
        $rootScope.stepperSecondary.steps[0].stepActive = false;
        $rootScope.stepperSecondary.steps[0].stepCompleted = true;
        $rootScope.stepperSecondary.steps[1].stepActive = true;
        $rootScope.stepperSecondary.steps[1].stepCompleted = false;
        var verifyObjData = $state.params.verificationData ? $state.params.verificationData : JSON.parse(sessionStorage.getItem("verifyObj"));
        vm.saveDraftPayload.panNumber = verifyObjData.panNumber;
        vm.saveDraftPayload.investmentGoal = null;
        vm.saveDraftPayload.fundName = scheme.fundName;
        vm.saveDraftPayload.fundCategory = vm.selectedschemeCategory;
        if (!scheme.selectedScheme.schemeCode) {
          var SchemeData = JSON.parse(scheme.selectedScheme);
        } else {
          var SchemeData = scheme.selectedScheme;
        }

        vm.saveDraftPayload.schemeCode = SchemeData.schemeCode;
        vm.saveDraftPayload.investmentOption = SchemeData.investmentOption;
        vm.saveDraftPayload.schemeName = SchemeData.schemeName;
        vm.saveDraftPayload.schemeType = SchemeData.schemeType;

        vm.saveDraftPayload.step = "FIRST";
        $window.smartech('dispatch', 'scheme selection kyc', { 'schemename': vm.saveDraftPayload.schemeName });

        var success = function (resp) {
          if (resp.data && resp.status) {
            var data = resp.data;
            var Details = JSON.parse(sessionStorage.getItem("userData"));
            if (!Details.transactionDraftId) {
              var details = {};
              details.transactionDraftId = data.id;
              $window.sessionStorage.setItem("userData", JSON.stringify(details));
            }
            vm.investmentModeValidation = {};
            vm.investmentModeValidation.purchaseEnabled = SchemeData.purchaseEnabled;
            vm.investmentModeValidation.sipEnabled = SchemeData.sipEnabled;
            vm.investmentModeValidation.directSchemes = vm.DirectScheme;
            sessionStorage.setItem("investmentModeValidation", JSON.stringify(vm.investmentModeValidation));
            $rootScope.stepperSecondary.steps[0].stepActive = false;
            $rootScope.stepperSecondary.steps[0].stepCompleted = true;
            $rootScope.stepperSecondary.steps[1].stepActive = true;
            $state.go('newInvestor.investmentDetails.investmentmode');
          } else {
            MessageService.error(resp.message);
          }
        },
          error = function () {
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        vm.processFlag = false;
        if(vm.distributorDetails || vm.PARTNER_DATA){
          vm.saveDraftPayload.oneClick = true;
        }
        LoaderService.showLoader('.pan-loader');
        InvestorService.post({
          child1: 'new',
          child2: 'user',
          child3: 'save',
          child4: 'transaction'
        }, vm.saveDraftPayload).$promise.then(success, error);
      }
      else {
        alert("Please select scheme");
      }
    }

    // setDraftData
    function setGetDraftData() {

      if (vm.schemeCategoryDetailsList && vm.schemeCategoryList) {
        vm.schemeCategoryDetailsList.forEach(function (res) {
          if (vm.selectedschemeCategory == res.type) {
            var tempArray = [];
            var verifyObjData = $state.params.verificationData ? $state.params.verificationData : JSON.parse(sessionStorage.getItem("verifyObj"));
            $rootScope.testObj.steps[0].panNumber = verifyObjData.panNumber;
            $rootScope.testObj.steps[0].investorName = verifyObjData.panHolderName;
            $rootScope.testObj.steps[0].stepCompleted = true;
            $rootScope.testObj.steps[0].stepActive = false;
            $rootScope.testObj.steps[1].stepActive = true;
            res.funds.forEach(function (res1) {
              res1.selectedScheme = null;
              tempArray.push(res1);
            });
            if (vm.distributorDetails) {
              if (!vm.distributorDetails.schemeCode) {
                vm.selectedschemeCategoryDetails = tempArray;
              }
            } else {
              vm.selectedschemeCategoryDetails = tempArray;
            }
          }
        })

        var Details = JSON.parse(sessionStorage.getItem("userData"));
        if (Details.transactionDraftId) {

          var success = function (resp) {
            if (resp.data && resp.status) {
              if (resp.data.fundCategory) {
                vm.selectedschemeCategory = resp.data.fundCategory;
                vm.saveDraftPayload = resp.data;
                vm.selectedscheme.schemeCode = resp.data.schemeCode;
                vm.schemeCategoryDetailsList.forEach(function (res) {
                  if (vm.selectedschemeCategory == res.type) {
                    var tempArray = [];
                    res.funds.forEach(function (res1) {
                      var filteredArray = res1.directSchemes.filter(function (itm) {
                        return vm.selectedscheme.schemeCode.indexOf(itm.schemeCode) > -1;
                      });
                      if (filteredArray.length == 0) {
                        filteredArray = res1.regularSchemes.filter(function (itm) {
                          return vm.selectedscheme.schemeCode.indexOf(itm.schemeCode) > -1;
                        });
                      }
                      if (filteredArray.length == 1) {
                        res1.selectedScheme = {};
                        res1.selectedScheme = filteredArray[0];
                      } else {
                        res1.selectedScheme = null;
                      }
                      tempArray.push(res1);
                    });
                    // vm.selectedschemeCategoryDetails = tempArray;
                    tempArray = tempArray.sort(function (a, b) {
                      if (a.selectedScheme === null) // a is null? last
                        return 1;
                      else (b.selectedScheme === null) // b is null? last
                      return -1;
                    })
                    if (vm.distributorDetails) {
                      if (vm.distributorDetails.schemeGroupCode) {

                      } else {
                        if (vm.distributorDetails.schemeCode) {

                        } else {
                          vm.selectedschemeCategoryDetails = tempArray;
                        }
                      }
                    } else {
                      vm.selectedschemeCategoryDetails = tempArray;
                    }
                    if (vm.PARTNER_DATA) {
                      vm.schemeCodeList = vm.PARTNER_DATA.schemeList;
                      vm.selectedschemeCategoryDetails = [];
                      if (vm.schemeCategoryDetailsList && vm.schemeCodeList) {
                        vm.schemeCategoryDetailsList.forEach(function (item2) {
                          item2.funds.forEach(function (item3) {
                            if (vm.DirectScheme) {
                              if (item3.directSchemes) {
                                try {
                                  item3.directSchemes.forEach(function (item4) {
                                    vm.schemeCodeList.forEach(function (item1) {
                                      if (item4.schemeCode == item1.schemeCode) {
                                        vm.selectedschemeCategoryDetails.push(item3);
                                        vm.selectedschemeCategory = item2.type;
                                        throw 'Break';
                                      }
                                    })
                                  })
                                } catch (e) {

                                }
                              }
                            } else {
                              if (item3.regularSchemes) {
                                try {
                                  item3.regularSchemes.forEach(function (item4) {
                                    vm.schemeCodeList.forEach(function (item1) {
                                      if (item4.schemeCode == item1.schemeCode) {
                                        vm.selectedschemeCategoryDetails.push(item3);
                                        vm.selectedschemeCategory = item2.type;
                                        throw 'Break';
                                      }
                                    })
                                  })
                                } catch (e) {

                                }
                              }
                            }
                          })
                        })
                      }
                    }
                    // vm.selectedschemeCategoryDetails.sort(function(a, b) {
                    //   if (a.selectedScheme === null) // a is null? last
                    //   return 1;
                    //   else (b.selectedScheme === null) // b is null? last
                    //   return -1;

                    //   })
                    // const selectdeArray = vm.selectedschemeCategoryDetails.filter(item => item.selectedScheme != null);
                    // const unSelectdeArray = vm.selectedschemeCategoryDetails.filter(item => item.selectedScheme == null);
                    // var sortedArray = [];
                    // selectdeArray.forEach(function(res){
                    //   sortedArray.push(res);
                    // });
                    // unSelectdeArray.forEach(function(res){
                    //   sortedArray.push(res);
                    // });
                    // vm.selectedschemeCategoryDetails = sortedArray;
                  }
                })
              }
            } else {
              MessageService.error(resp.message);
            }
          },
            error = function (err) {
              MessageService.error(err.data.message);
            };
          vm.processFlag = false;

          var Data = {};
          Data.id = Details.transactionDraftId;
          if(Data && Data.id){
            InvestorService.post({
              child1: 'new',
              child2: 'user',
              child3: 'saved',
              child4: 'draft'
            }, Data).$promise.then(success, error);
          }
        }
      }
      //  stop
    }
    function init() {
      vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
      vm.PARTNER_DATA = JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
      if (vm.distributorDetails) {
        if (vm.distributorDetails.key == "MFD" || (vm.distributorDetails.key == 'E_CODE' && vm.distributorDetails.arn) || vm.distributorDetails.key == "CONNECT_PARTNER") {
          vm.DirectScheme = false;
          vm.hideArnTogg = false;
          // vm.selectedschemeCategory = "Diversified Equity";
          sessionStorage.removeItem("onotp");
          $state.go("newInvestor.investmentDetails.schemedetails.selectscheme");
        } else {
          if (vm.distributorDetails.key == "RIA") {
            vm.DirectScheme = true;
            vm.hideArnTogg = false;
          } else {
            vm.hideArnTogg = true;
          }
        }
      } else {
        vm.hideArnTogg = true;
      }

      if (vm.PARTNER_DATA) {
        vm.hideArnTogg = false;
        if (vm.PARTNER_DATA.arnFlag) {
          vm.DirectScheme = false;
        } else {
          vm.DirectScheme = true;
          vm.hideArnTogg = true;
        }
      }
      vm.GetSchemeCategoryList();
      vm.GetSchemeCategoryDetailsList();
      vm.investmentValidation = JSON.parse(sessionStorage.getItem("investmentModeValidation"));
      if (vm.investmentValidation && vm.investmentValidation.directSchemes == false) {
        vm.DirectScheme = false;
        if(!vm.PARTNER_DATA.arnFlag){
          vm.DirectScheme = true;
        }
      }

      var userBasicData = JSON.parse(sessionStorage.getItem("verifyObj"));
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[0].panNumber = userBasicData && userBasicData.panNumber? userBasicData.panNumber : "";
      $rootScope.testObj.steps[0].investorName = userBasicData && userBasicData.panHolderName ? userBasicData.panHolderName : "";
      $rootScope.testObj.steps[1].stepCompleted = false;
      $rootScope.testObj.steps[2].stepCompleted = false;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepActive = true;
      $rootScope.testObj.steps[2].stepActive = false;
    }
    // get scheme category  list
    function GetSchemeCategoryList() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.schemeCategoryList = resp.data;
          vm.selectedschemeCategory = vm.schemeCategoryList[0];
          if (vm.distributorDetails) {

          } else {
            setGetDraftData();
          }
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
        };
      InvestorService.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'category',
        child5: 'list',
        nriFlag: !vm.userData.taxStatusResident
      }).$promise.then(success, error);
    }
    // get scheme category details list
    function GetSchemeCategoryDetailsList() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.schemeCategoryDetailsList = resp.data;
          if (vm.distributorDetails) {
            if (vm.distributorDetails.schemeCode && !vm.distributorDetails.schemeGroupCode) {
              chooseARNScheme(vm.schemeCategoryDetailsList);
            } else {
              setGetDraftData();
            }
            if (vm.distributorDetails.schemeGroupCode) {
              vm.schemeCategoryDetailsList = resp.data;
              schemeGroupCodeList(vm.schemeCategoryDetailsList);
            } else {
              vm.schemeCategoryDetailsList = resp.data;
            }
          }
          if(vm.distributorDetails && vm.distributorDetails.HDFCCAMP){
            vm.schemeFilterForHdfcCAMP(resp.data);
          }
          if (vm.PARTNER_DATA) {
            schemeGroupCodeData(vm.schemeCategoryDetailsList);
          }
          if (vm.distributorDetails || vm.PARTNER_DATA) {

          } else {
            setGetDraftData();
          }
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
        };
      InvestorService.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'category',
        nriFlag: !vm.userData.taxStatusResident
      }).$promise.then(success, error);
    }

    // change scheme Category
    vm.changeSchemeCategory = function () {
        if(vm.distributorDetails && vm.distributorDetails.HDFCCAMP){
            vm.schemeCodeList = [ "01","1","02","2","41","44","GFDPD","GFGPG"];
        }
      vm.selectedschemeCategoryDetails = [];
      if (vm.schemeCategoryDetailsList) {
        if (vm.distributorDetails) {
          if (vm.distributorDetails.schemeGroupCode) {
            vm.schemeCategoryDetailsList.forEach(function (item2) {
              if (item2.type == vm.selectedschemeCategory) {
                item2.funds.forEach(function (item3) {
                  if (item3.regularSchemes) {
                    try {
                      item3.regularSchemes.forEach(function (item4) {
                        vm.schemeCodeList.forEach(function (item1) {
                          if (item4.schemeCode == item1.schemeCd) {
                            vm.selectedschemeCategoryDetails.push(item3);
                            vm.selectedschemeCategory = item2.type;
                            throw 'Break';
                          }
                        })
                      })
                    } catch (e) {
                    }
                  }
                })
              }
            })
          } else if(vm.distributorDetails.HDFCCAMP){
            vm.selectedschemeCategoryDetails
            vm.schemeCategoryDetailsList.forEach(function (item2) {
              if (item2.type == vm.selectedschemeCategory) {
                item2.funds.forEach(function (item3) {
                  if (vm.directSchemes) {

                  } else {
                    if (item3.regularSchemes) {
                      try {
                        item3.regularSchemes.forEach(function (item4) {
                          vm.schemeCodeList.forEach(function (item1) {
                            if (item4.schemeCode == item1) {
                              vm.selectedschemeCategoryDetails.push(item3);
                              vm.selectedschemeCategory = item2.type;
                              throw 'Break';
                            }
                          })
                        })
                      } catch (e) {
                      }
                    }
                  }
                })
              }
            })
          }
          else{
            vm.schemeCategoryDetailsList.forEach(function (res) {
              if (vm.selectedschemeCategory == res.type) {
                vm.selectedschemeCategoryDetails = [];
                res.funds.forEach(function (res) {
                  res.Expand = false;
                  vm.selectedschemeCategoryDetails.push(res);
                })
              }
            })
            if(vm.distributorDetails && vm.distributorDetails.schemeCode){
              chooseARNScheme(vm.schemeCategoryDetailsList);
            }
          }
        } else if (vm.PARTNER_DATA) {
          if (vm.PARTNER_DATA.schemeGroupCode) {
            vm.schemeCategoryDetailsList.forEach(function (item2) {
              if (item2.type == vm.selectedschemeCategory) {
                item2.funds.forEach(function (item3) {
                  if (vm.directSchemes) {
                    if (item3.directSchemes) {
                      try {
                        item3.directSchemes.forEach(function (item4) {
                          vm.schemeCodeList.forEach(function (item1) {
                            if (item4.schemeCode == item1.schemeCode) {
                              vm.selectedschemeCategoryDetails.push(item3);
                              vm.selectedschemeCategory = item2.type;
                              throw 'Break';
                            }
                          })
                        })
                      } catch (e) {
                      }
                    }
                  } else {
                    if (item3.regularSchemes) {
                      try {
                        item3.regularSchemes.forEach(function (item4) {
                          vm.schemeCodeList.forEach(function (item1) {
                            if (item4.schemeCode == item1.schemeCode) {
                              vm.selectedschemeCategoryDetails.push(item3);
                              vm.selectedschemeCategory = item2.type;
                              throw 'Break';
                            }
                          })
                        })
                      } catch (e) {
                      }
                    }
                  }
                })
              }
            })
          }
        } else {
          vm.schemeCategoryDetailsList.forEach(function (res) {
            if (vm.selectedschemeCategory == res.type) {
              vm.selectedschemeCategoryDetails = [];
              res.funds.forEach(function (res) {
                res.Expand = false;
                vm.selectedschemeCategoryDetails.push(res);
              })
            }
          })
        }
      }
    }
    vm.changewithFilterName = function () {
      if (vm.schemeCategoryDetailsList) {
        vm.schemeCategoryDetailsList.forEach(function (res) {
          if (vm.selectedschemeCategory == res.type) {
            var tempArray = [];
            res.funds.forEach(function (res1) {
              res1.selectedScheme = null;
              tempArray.push(res1);
            });
            if (vm.distributorDetails) {
              if (vm.distributorDetails.schemeGroupCode) {

              } else {
                vm.selectedschemeCategoryDetails = tempArray;
              }
            } else {
              vm.selectedschemeCategoryDetails = tempArray;
            }


            if (vm.filterwithname) {
              var filterschemarray = [];
              vm.selectedschemeCategoryDetails.forEach(function (filterlist) {
                var fundName = new String(filterlist.fundName.toUpperCase());
                var filterName = new String(vm.filterwithname.toUpperCase());
                if (fundName.indexOf(filterName) > -1) {
                  filterschemarray.push(filterlist);
                }
              });
              vm.selectedschemeCategoryDetails = filterschemarray;
            }
          }
        })
      }
    }





    vm.togScheme = function () {
      if (vm.distributorDetails) {
        if (vm.distributorDetails.key == "MFD" || (vm.distributorDetails.key == 'E_CODE' && vm.distributorDetails.arn) || vm.distributorDetails.key == "CONNECT_PARTNER") {
          vm.DirectScheme = false;
        }
        vm.schemeCategoryDetailsList.forEach(function (res) {
          if (vm.selectedschemeCategory == res.type) {
            var tempArray = [];
            res.funds.forEach(function (res1) {
              res1.selectedScheme = null;
              tempArray.push(res1);
            });
            vm.selectedschemeCategoryDetails = tempArray;
          }
        })
      } else if (vm.PARTNER_DATA) {
        vm.DirectScheme = !vm.DirectScheme;
        schemeGroupCodeData(vm.schemeCategoryDetailsList);
      } else {
        vm.DirectScheme = !vm.DirectScheme;
        vm.schemeCategoryDetailsList.forEach(function (res) {
          if (vm.selectedschemeCategory == res.type) {
            var tempArray = [];
            res.funds.forEach(function (res1) {
              res1.selectedScheme = null;
              tempArray.push(res1);
            });
            vm.selectedschemeCategoryDetails = tempArray;
          }
        })
      }

    }

    function schemeGroupCodeList(schemeList) {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.schemeCodeList = resp.data;
          vm.selectedschemeCategoryDetails = [];
          if (schemeList && vm.schemeCodeList) {
            schemeList.forEach(function (item2) {
              item2.funds.forEach(function (item3) {
                if (item3.regularSchemes) {
                  try {
                    item3.regularSchemes.forEach(function (item4) {
                      vm.schemeCodeList.forEach(function (item1) {
                        if (item4.schemeCode == item1.schemeCd) {
                          vm.selectedschemeCategoryDetails.push(item3);
                          vm.selectedschemeCategory = item2.type;
                          throw 'Break';
                        }
                      });
                    });
                  } catch (e) {

                  }
                }
              });
              // }
            });
          }
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      IIHttpService.post(
        {
          child1: "getListOfSchemes",
        },
        { schemeCode: vm.distributorDetails.schemeGroupCode }
      ).$promise.then(success, error);
    }


    function chooseARNScheme(schemeList) {
      var arnSchemeCode = vm.distributorDetails.schemeCode;
      vm.selectedschemeCategoryDetails = [];
      if (schemeList && arnSchemeCode) {
        schemeList.forEach(function (item2) {
          item2.funds.forEach(function (item3) {
            if (vm.distributorDetails.arn) {
              if (item3.regularSchemes) {
                try {
                  item3.regularSchemes.forEach(function (item4) {

                    if (item4.schemeCode == arnSchemeCode) {
                      item3.selectedScheme = item4;
                      vm.selectedschemeCategoryDetails.push(item3);
                      vm.selectedschemeCategory = item2.type;
                      throw 'Break';
                    }
                  })

                } catch (e) {

                }
              }
            } else {
              if (item3.directSchemes) {
                try {
                  item3.directSchemes.forEach(function (item4) {

                    if (item4.schemeCode == arnSchemeCode) {
                      item3.selectedScheme = item4;
                      vm.selectedschemeCategoryDetails.push(item3);
                      vm.selectedschemeCategory = item2.type;
                      throw 'Break';
                    }
                  })

                } catch (e) {

                }
              }
            }

          })
        })
      }

    }
    function schemeGroupCodeData(schemeList) {

      vm.schemeCodeList = vm.PARTNER_DATA.schemeList;
      vm.selectedschemeCategoryDetails = [];
      if (schemeList && vm.schemeCodeList) {
        schemeList.forEach(function (item2) {
          item2.funds.forEach(function (item3) {
            if (vm.DirectScheme) {
              if (item3.directSchemes) {
                try {
                  item3.directSchemes.forEach(function (item4) {
                    vm.schemeCodeList.forEach(function (item1) {
                      if (item4.schemeCode == item1.schemeCode) {
                        vm.selectedschemeCategoryDetails.push(item3);
                        vm.selectedschemeCategory = item2.type;
                        throw 'Break';
                      }
                    })
                  })
                } catch (e) {

                }
              }
            } else {
              if (item3.regularSchemes) {
                try {
                  item3.regularSchemes.forEach(function (item4) {
                    vm.schemeCodeList.forEach(function (item1) {
                      if (item4.schemeCode == item1.schemeCode) {
                        vm.selectedschemeCategoryDetails.push(item3);
                        vm.selectedschemeCategory = item2.type;
                        throw 'Break';
                      }
                    })
                  })
                } catch (e) {

                }
              }
            }
          })
        })
      }


    }

    vm.schemeFilterForHdfcCAMP = function (schemeList) {
      var schemeCodeMap = {"01": true,"1": true,"02": true,"2": true,"41": true,"44": true,"GFDPD": true,"GFGPG": true,};
      vm.selectedschemeCategoryDetails = [];
      if (schemeList && schemeCodeMap) {
        schemeList.forEach(function (item2) {
          item2.funds.forEach(function (item3) {
            if (vm.distributorDetails.arn) {
              if (item3.regularSchemes) {
                try {
                  item3.regularSchemes.forEach(function (item4) {
                    if (schemeCodeMap.hasOwnProperty(item4.schemeCode)) {
                      item3.selectedScheme = item4;
                      vm.selectedschemeCategoryDetails.push(item3);
                      vm.selectedschemeCategory = item2.type;
                      throw 'Break';
                    }
                  })
                } catch (e) {

                }
              }
            }
          })
        })
      }
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentGoalController', InvestmentGoalController);

  /** @ngInject */
  function InvestmentGoalController($window, $rootScope, $state, $scope, $timeout, AuthService, LoaderService, InvestorService, InvestorServiceV3, AppConstants, MessageService, ModalService, InvestorFileUploadService, IIHttpService, UtilService) {
    var vm = this;
    vm.$state = $state;
    vm.init = init;
    vm.DirectScheme = true;
    vm.GetInvestmentGoalList = GetInvestmentGoalList;
    vm.categoryDetailsList = categoryDetailsList;
    vm.InvestmentGoalList = [];
    vm.changeScheme = changeScheme;
    vm.setGetDraftData = setGetDraftData;
    vm.selectedInvestmentGoal = {};
    vm.selectedCard = false;
    $rootScope.currentstate = $state.current.url;
    vm.saveDraftPayload = {};
    vm.selectedInvestmentGoalName = "Wealth Creation";
    vm.selectedscheme = null;
    vm.hideArnTogg = true;
    vm.userData = JSON.parse(sessionStorage.getItem("verifyObj"));
    function init() {
      vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
      vm.PARTNER_DATA = JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
      if (vm.distributorDetails) {
        if (vm.distributorDetails.key == "MFD" || (vm.distributorDetails.key == 'E_CODE' && vm.distributorDetails.arn) || vm.distributorDetails.key == "CONNECT_PARTNER") {
          vm.DirectScheme = false;
          vm.hideArnTogg = false;
        } else {
          if (vm.distributorDetails.key == "RIA") {
            vm.DirectScheme = true;
            vm.hideArnTogg = false;
          } else {
            vm.hideArnTogg = true;
          }
        }
        if (vm.distributorDetails.schemeGroupCode) {
          schemeGroupCodeList();
        }
      } else if (vm.PARTNER_DATA) {
        schemeGroupCodeData();
        vm.hideArnTogg = false;
        if (vm.PARTNER_DATA.arnFlag) {
          vm.DirectScheme = false;
        } else {
          vm.DirectScheme = true;
          vm.hideArnTogg = true;
        }
      } else {
        vm.hideArnTogg = true;
      }

      vm.selectedCard = false
      vm.GetInvestmentGoalList();
      vm.categoryDetailsList();
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[1].stepCompleted = false;
      $rootScope.testObj.steps[2].stepCompleted = false;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepActive = true;
      $rootScope.testObj.steps[2].stepActive = false;
    }

    // setDraftData
    function setGetDraftData() {
      if (vm.InvestmentGoalDetails && vm.InvestmentGoalList) {
        vm.InvestmentGoalDetails.forEach(function (res) {
          if (vm.selectedInvestmentGoalName == res.type) {
            vm.SelectedInvestmentGoalDetailsList = res.funds;
            vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
            vm.pageArray = [];
            for (var i = 0; i < vm.pageNumber; i++) {
              vm.pageArray.push(i + 1);
            }
          }
        })
        // SelectedInvestmentGoalDetailsList
        var tempArray = [];
        if (vm.distributorDetails) {
          if (vm.distributorDetails.schemeGroupCode) {
            vm.SelectedInvestmentGoalDetailsList = [];
            if (vm.InvestmentGoalDetails && vm.schemeCodeList) {
              vm.InvestmentGoalDetails.forEach(function (item2) {
                item2.funds.forEach(function (item3) {
                  try {
                    item3.regularSchemes.forEach(function (item4) {
                      vm.schemeCodeList.forEach(function (item1) {
                        if (item4.schemeCode == item1.schemeCd) {
                          var tempObj = item3;
                          tempObj.selectedInvestmentGoalcard = null;
                          vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                          vm.selectedInvestmentGoalName = item2.type;
                          throw 'Break';
                        }
                      })
                    })
                  } catch (e) {
                    
                  }
                })
              })
              vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
              vm.pageArray = [];
              for (var i = 0; i < vm.pageNumber; i++) {
                vm.pageArray.push(i + 1);
              }
            }
          }else if (vm.distributorDetails && vm.distributorDetails.HDFCCAMP) {
            vm.schemeCodeList = [ "01","1","02","2","41","44","GFDPD","GFGPG"];
            vm.SelectedInvestmentGoalDetailsList = [];
            if (vm.InvestmentGoalDetails && vm.schemeCodeList) {
              vm.InvestmentGoalDetails.forEach(function (item2) {
                item2.funds.forEach(function (item3) {
                  if(vm.DirectScheme){

                  }else{
                    try {
                      item3.regularSchemes.forEach(function (item4) {
                        vm.schemeCodeList.forEach(function (item1) {
                          if (item4.schemeCode == item1) {
                            var tempObj = item3;
                            tempObj.selectedInvestmentGoalcard = null;
                            vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                            vm.selectedInvestmentGoalName = item2.type;
                            throw 'Break';
                          }
                        })
                      })
                    } catch (e) {
                      
                    }
                  }
                })
              })
              vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
              vm.pageArray = [];
              for (var i = 0; i < vm.pageNumber; i++) {
                vm.pageArray.push(i + 1);
              }
            }
          } else {
            if (vm.InvestmentGoalDetails && vm.distributorDetails.schemeCode) {
              vm.SelectedInvestmentGoalDetailsList = [];
              vm.InvestmentGoalDetails.forEach(function (item2) {
                item2.funds.forEach(function (item3) {
                  try {
                    if (vm.DirectScheme) {
                      item3.directSchemes.forEach(function (item4) {
                        if (item4.schemeCode == vm.distributorDetails.schemeCode) {
                          var tempObj = item3;
                          tempObj.selectedInvestmentGoalcard = item4;
                          vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                          vm.selectedInvestmentGoalName = item2.type;
                          throw 'Break';
                        }
                      })
                    } else {
                      item3.regularSchemes.forEach(function (item4) {
                        if (item4.schemeCode == vm.distributorDetails.schemeCode) {
                          var tempObj = item3;
                          tempObj.selectedInvestmentGoalcard = item4;
                          vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                          vm.selectedInvestmentGoalName = item2.type;
                          throw 'Break';
                        }
                      })
                    }

                  } catch (e) {
                    
                  }
                })
              })
              vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
              vm.pageArray = [];
              for (var i = 0; i < vm.pageNumber; i++) {
                vm.pageArray.push(i + 1);
              }
              vm.temp = [];
              vm.SelectedInvestmentGoalDetailsArray = [];
              vm.temp.push(vm.SelectedInvestmentGoalDetailsList[0]);
              vm.SelectedInvestmentGoalDetailsList = [];
              vm.SelectedInvestmentGoalDetailsList.push(vm.temp[0]);
              vm.changeInvestmentGoalcard(vm.temp);
            } else {
              vm.SelectedInvestmentGoalDetailsList.forEach(function (item) {
                var tempObj = item;
                tempObj.selectedInvestmentGoalcard = null;
                tempArray.push(tempObj);
              })
              vm.SelectedInvestmentGoalDetailsList = tempArray;
            }

          }
        } else if (vm.PARTNER_DATA) {
          vm.SelectedInvestmentGoalDetailsList = [];
          if (vm.InvestmentGoalDetails && vm.schemeCodeList) {
            vm.InvestmentGoalDetails.forEach(function (item2) {
              item2.funds.forEach(function (item3) {
                if(vm.DirectScheme){
                  try {
                    item3.directSchemes.forEach(function (item4) {
                      vm.schemeCodeList.forEach(function (item1) {
                        if (item4.schemeCode == item1.schemeCode) {
                          var tempObj = item3;
                          tempObj.selectedInvestmentGoalcard = null;
                          vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                          vm.selectedInvestmentGoalName = item2.type;
                          throw 'Break';
                        }
                      })
                    })
                  } catch (e) {
                    
                  }
                }else{
                  try {
                    item3.regularSchemes.forEach(function (item4) {
                      vm.schemeCodeList.forEach(function (item1) {
                        if (item4.schemeCode == item1.schemeCode) {
                          var tempObj = item3;
                          tempObj.selectedInvestmentGoalcard = null;
                          vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                          vm.selectedInvestmentGoalName = item2.type;
                          throw 'Break';
                        }
                      })
                    })
                  } catch (e) {
                    
                  }
                }
              })
            })
            vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
            vm.pageArray = [];
            for (var i = 0; i < vm.pageNumber; i++) {
              vm.pageArray.push(i + 1);
            }
          }
        } else {
          vm.SelectedInvestmentGoalDetailsList.forEach(function (item) {
            var tempObj = item;
            tempObj.selectedInvestmentGoalcard = null;
            tempArray.push(tempObj);
          })
          vm.SelectedInvestmentGoalDetailsList = tempArray;
        }
        tempArray = [];
        vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
        vm.pageArray = [];
        for (var i = 0; i < vm.pageNumber; i++) {
          vm.pageArray.push(i + 1);
        }
        vm.getPageData(1);
        var Details = JSON.parse(sessionStorage.getItem("userData"));
        if (Details.transactionDraftId) {
          var success = function (resp) {
            if (resp.data && resp.status) {
              if (resp.data.investmentGoal) {
                if (!vm.distributorDetails) {
                  vm.selectedInvestmentGoalName = resp.data.investmentGoal;
                }
                vm.saveDraftPayload = resp.data;
                vm.selectedscheme = {};
                vm.selectedscheme.schemeCode = vm.saveDraftPayload.schemeCode;
                if (vm.InvestmentGoalDetails) {
                  vm.selectedCard = true;
                  vm.InvestmentGoalDetails.forEach(function (res) {
                    if (vm.selectedInvestmentGoalName == res.type) {
                      var tempArray = [];
                      res.funds.forEach(function (res1) {
                        var filteredArray = [];
                        if (res1.directSchemes) {
                          var filteredArray = res1.directSchemes.filter(function (itm) {
                            return vm.selectedscheme.schemeCode.indexOf(itm.schemeCode) > -1;
                          });
                        }
                        if (filteredArray.length == 0) {
                          if (res1.directSchemes) {
                            filteredArray = res1.regularSchemes.filter(function (itm) {
                              return vm.selectedscheme.schemeCode.indexOf(itm.schemeCode) > -1;
                            });
                          }
                        }
                        if (filteredArray.length == 1) {
                          res1.selectedInvestmentGoalcard = {};
                          res1.selectedInvestmentGoalcard = filteredArray[0];
                          vm.selectedInvestmentGoal = res1;
                        } else {
                          res1.selectedInvestmentGoalcard = null;
                        }
                        tempArray.push(res1);
                      });
                      tempArray = tempArray.sort(function (a, b) {
                        if (a.selectedInvestmentGoalcard === null) // a is null? last
                          return 1;
                        else (b.selectedInvestmentGoalcard === null) // b is null? last
                        return -1;
                      })
                      // vm.SelectedInvestmentGoalDetailsList = res.funds;
                      if(vm.distributorDetails && !vm.distributorDetails.HDFCCAMP){
                      vm.SelectedInvestmentGoalDetailsList = tempArray;
                      }
                      // vm.SelectedInvestmentGoalDetailsList.forEach(function (result) {
                      //   if(result && result.directSchemes || result.regularSchemes){
                      //     var filteredArray = result.directSchemes.filter(function(itm){
                      //       return vm.selectedscheme.schemeCode.indexOf(itm.schemeCode) > -1;
                      //     });
                      //     if(filteredArray.length == 0){
                      //       if(result && result.regularSchemes){
                      //         filteredArray = result.regularSchemes.filter(function(itm){
                      //           return vm.selectedscheme.schemeCode.indexOf(itm.schemeCode) > -1;
                      //         });
                      //       }
                      //     }
                      //     if(filteredArray.length == 1){
                      //       vm.selectedscheme = filteredArray[0];
                      //       vm.selectedInvestmentGoal = result;
                      //     }
                      //   }
                      // });
                    }
                  })

                  if(vm.PARTNER_DATA) {
                    vm.InvestmentGoalDetails.forEach(function (item2) {
                      item2.funds.forEach(function (item3) {
                          try {
                            item3.directSchemes.forEach(function (item4) {
                              if (item4.schemeCode == resp.data.schemeCode) {
                                  vm.DirectScheme = true;
                                  throw 'Break';
                                }
                            })
                          } catch (e) {
                            
                          }

                          try {
                            item3.regularSchemes.forEach(function (item4) {
                                if (item4.schemeCode == resp.data.schemeCode) {
                                  vm.DirectScheme = false;
                                  throw 'Break';
                                }
                            })
                          } catch (e) {
                            
                          }
                      })
                  })

                    vm.SelectedInvestmentGoalDetailsList = [];
                    if (vm.InvestmentGoalDetails && vm.schemeCodeList) {
                      vm.InvestmentGoalDetails.forEach(function (item2) {
                        item2.funds.forEach(function (item3) {
                          if(vm.DirectScheme){
                            try {
                              item3.directSchemes.forEach(function (item4) {
                                vm.schemeCodeList.forEach(function (item1) {
                                  if (item4.schemeCode == item1.schemeCode) {
                                    var tempObj = item3;
                                    tempObj.selectedInvestmentGoalcard = null;
                                    vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                                    vm.selectedInvestmentGoalName = item2.type;
                                    throw 'Break';
                                  }
                                })
                              })
                            } catch (e) {
                              
                            }
                          }else{
                            try {
                              item3.regularSchemes.forEach(function (item4) {
                                vm.schemeCodeList.forEach(function (item1) {
                                  if (item4.schemeCode == item1.schemeCode) {
                                    var tempObj = item3;
                                    tempObj.selectedInvestmentGoalcard = null;
                                    vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                                    vm.selectedInvestmentGoalName = item2.type;
                                    throw 'Break';
                                  }
                                })
                              })
                            } catch (e) {
                              
                            }
                          }
                        })
                      })
                      vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
                      vm.pageArray = [];
                      for (var i = 0; i < vm.pageNumber; i++) {
                        vm.pageArray.push(i + 1);
                      }
                    }
                  }
                  vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
                  vm.pageArray = [];
                  for (var i = 0; i < vm.pageNumber; i++) {
                    vm.pageArray.push(i + 1);
                  }
                  // vm.SelectedInvestmentGoalDetailsList.forEach(function(item,i){
                  //   if(item.fundName === vm.selectedInvestmentGoal.fundName){
                  //     vm.SelectedInvestmentGoalDetailsList.splice(i, 1);
                  //     vm.SelectedInvestmentGoalDetailsList.unshift(item);
                  //   }
                  // });
                  vm.getPageData(1);
                }

              }
            } else {
              MessageService.error(resp.message);
            }
          },
            error = function (err) {
              MessageService.error(err.data.message);
            };
          try {
            vm.processFlag = false;
            var Data = {};
            Data.id = Details.transactionDraftId;
          } catch (e) { }
          if(Data && Data.id){
            LoaderService.showLoader('.pan-loader');
            InvestorService.post({
              child1: 'new',
              child2: 'user',
              child3: 'saved',
              child4: 'draft'
            }, Data).$promise.then(success, error);
          } 
        }
      }
    }
    vm.SelectedInvestmentGoalDetailsArray = [];

    vm.changeInvestmentGoalcard = function (data) {
      var tempArray = [];
      vm.selectedInvestmentGoal = data;
      if (data.selectedInvestmentGoalcard) {
        vm.selectedCard = true;
      } else {
        vm.selectedCard = false;
      }
      // if(vm.distributorDetails){
      //   if(vm.distributorDetails.schemeGroupCode){
      //     if (vm.SelectedInvestmentGoalDetailsList && vm.schemeCodeList) {
      //       vm.SelectedInvestmentGoalDetailsList.forEach(function (item2) {
      //           if (item2.regularSchemes) {
      //             try {
      //               item2.regularSchemes.forEach(function (item4) {
      //                 vm.schemeCodeList.forEach(function (item1) {
      //                   if (item4.schemeCode == item1.schemeCd) {
      //                     var tempObj = item4;
      //                       tempObj.selectedInvestmentGoalcard = null;
      //                       tempArray.push(tempObj);
      //                     throw 'Break';
      //                   }
      //                 })
      //               })
      //             } catch (e) {
      //               
      //             }
      //           }
      //       })
      //     }
      //    }else{
      //     if (vm.SelectedInvestmentGoalDetailsList && vm.distributorDetails.schemeCode) {
      //       vm.SelectedInvestmentGoalDetailsList.forEach(function (item2) {
      //             try {
      //               if (vm.DirectScheme) {
      //                 item2.directSchemes.forEach(function (item4) {

      //                   if (item4.schemeCode == vm.distributorDetails.schemeCode) {
      //                     var tempObj = item4;
      //                       tempObj.selectedInvestmentGoalcard = null;
      //                       tempArray.push(tempObj);
      //                     throw 'Break';
      //                   }
      //                  })
      //             }else{
      //               item2.regularSchemes.forEach(function (item4) {

      //                 if (item4.schemeCode == vm.distributorDetails.schemeCode) {
      //                   var tempObj = item4;
      //                     tempObj.selectedInvestmentGoalcard = null;
      //                     tempArray.push(tempObj);
      //                   throw 'Break';
      //                 }
      //                })
      //             }
      //             } catch (e) {
      //               
      //             }

      //       })
      //     }
      //   }
      // }else{
      vm.SelectedInvestmentGoalDetailsList.forEach(function (item) {
        var tempObj = item;
        if (vm.distributorDetails && !vm.distributorDetails.schemeGroupCode) {
          if (item.selectedInvestmentGoalcard && data[0].selectedInvestmentGoalcard.schemeCode == item.selectedInvestmentGoalcard.schemeCode) {
            tempObj.selectedInvestmentGoalcard = data[0].selectedInvestmentGoalcard;
            vm.selectedscheme = data[0].selectedInvestmentGoalcard;
          } else {
            tempObj.selectedInvestmentGoalcard = null;
          }
        } else {
          if (item.selectedInvestmentGoalcard && data.selectedInvestmentGoalcard.schemeCode == item.selectedInvestmentGoalcard.schemeCode) {
            tempObj.selectedInvestmentGoalcard = data.selectedInvestmentGoalcard;
            vm.selectedscheme = data.selectedInvestmentGoalcard;
          } else {
            tempObj.selectedInvestmentGoalcard = null;
          }
        }
        tempArray.push(tempObj);
      })
      // }
      vm.investmentModeValidation = {};
      if (vm.distributorDetails && !vm.distributorDetails.schemeGroupCode) {
        vm.investmentModeValidation.purchaseEnabled = data[0].selectedInvestmentGoalcard.purchaseEnabled;
        vm.investmentModeValidation.sipEnabled = data[0].selectedInvestmentGoalcard.sipEnabled;
      } else {
        vm.investmentModeValidation.purchaseEnabled = data.selectedInvestmentGoalcard.purchaseEnabled;
        vm.investmentModeValidation.sipEnabled = data.selectedInvestmentGoalcard.sipEnabled;
      }
      vm.investmentModeValidation.directSchemes = vm.DirectScheme;
      sessionStorage.setItem("investmentModeValidation", JSON.stringify(vm.investmentModeValidation));
    }
    vm.getPageData = function (pageNumber) {
      vm.CurrentPage = pageNumber;
      vm.SelectedInvestmentGoalDetailsArray = [];
      var startIndex = 0;
      vm.limit = pageNumber * 6;
      if (vm.limit > vm.SelectedInvestmentGoalDetailsList.length) {
        vm.limit = vm.SelectedInvestmentGoalDetailsList.length;
        startIndex = (pageNumber - 1) * 6;
      } else {
        startIndex = vm.limit - 6;
      }
      if (vm.distributorDetails) {
        if (vm.distributorDetails.schemeCode) {
          vm.SelectedInvestmentGoalDetailsArray.push(vm.SelectedInvestmentGoalDetailsList[0]);
        } else {
          vm.SelectedInvestmentGoalDetailsArray = vm.SelectedInvestmentGoalDetailsList;
        }
      } else if(vm.PARTNER_DATA){
        vm.SelectedInvestmentGoalDetailsArray = vm.SelectedInvestmentGoalDetailsList;
      }else {
        for (var i = startIndex; i < vm.limit; i++) {
          vm.SelectedInvestmentGoalDetailsArray.push(vm.SelectedInvestmentGoalDetailsList[i]);
        }
      }
    }
    vm.nextPage = function () {
      vm.getPageData(vm.CurrentPage + 1);
    }
    vm.prev = function () {
      vm.getPageData(vm.CurrentPage - 1);
    }
    vm.iconsArray = [
      {
        "icon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAABHNCSVQICAgIfAhkiAAABI5JREFUSImllGtsVFUUhdc6c2emhTYBwltFSjqXUguG+PhBQrEKxlQrUmfaGFBDUBCNSpCIkc4wnWnVhEADja8EYowx2ukIBkQTEyDUID6iIREKvVNegkCoIBTsa+492x90aqkzlOL+effe69vr3H0OMYQIhBILAFkMMFtEDBJ/Kk0F4LxWuCPpTT775ZrCC+l61VBAIjIZ4EeNEd+8eNQsSXrtFxpqfE86qicCSKf3ktuVqXdQUOWbVlll9Ph4APDY3KE0FqVyfdNnyxURjG5Y5zt/yyAAx3RPz3uBkLU9acgcDa39YWvF+J1iAMDj6xO3o8MbM8hNNxLhTYDwWM3Jkd5kV6XSCAlUu9JyRRTyCGiQnSJyAMSvjRGz+pYdVVS13jesu/tTl02bmvVK4Ba3bCje6xsbi5pje2CXCcQh+ND/cuRfa81HVs8u+dudr8j3qdkEJQsEMoEAAXZoJd9SjMvQtlHcZC5/uYl6yCAA8Adb5hGsEhcWxsPm6cx11molzItF85eDlKE5ihwpYFJtyWpXpZ9szL88WH0gZL0lgrZ41Ky7aVBpdcI73JZd4jYWxkNTTvYKPQ2RpRBMpPCsUA5BVENjrW83AECEgZD1lWipjtcW/JTSuuEy5Nj6Fa1kSwpybTL1A8S9yVFGUMA/QHYkc3jw39Ep4uIyQkUh0mckI6i0OuHVVGUP7DE/vi4hzgzSvscQZwaVkBozPVfF178kHjZPw4Vf/EFrwaCgYVoeAbB94AbZhrSKxikIkwIZrthTHqv17RvYrxTqSD4/KIgac6H1zv8IEN1QWC3QR4v3mmWf1xRdTNffEDbbhBzuX3U4FwCMyqqWKQCmpAocZR+KR+46CyCfE0xroEA8VHCkPNhcbNCIN81OtKAJ+zMNC5F9rmHGdADfK4es1uR8IedqcjFoPAcA0FCNL9FJ1781WnhCu/AElGysDCVmZTwV8oxDGQP0Hp3yuGtjUfMNkJtdmnkVVYnXAEz2B1vmPbP0oCedSDxsnlYuPmpr3ZERJDpLEZ19oD6nlEIh7tWCZkC/RbKkc5xnfyBoLUkHbAibbV/UTD2QCSSkaTu2BQDGgISLtpyI1/q+SX0rrU68k2PLis5xnj2BNdZVKJyj5jkokWs90ErL5oaaqcf6a9UXi2oSa7qL7rz6Yvn9OlC6+Hqtrx1ABEAk8K64ePHIJCdpjEo9Km7hCJt6R8nK3Xfv2fCgDQBL6n52f/dX61oIxiiNir1zEvcPCuofvctxvLQ6cSbbQREAJCmXlODymJxJD/uDidFKMKv9ohQZNra1FdnTRrW4VyoHF4YESkVuUt+mFZcI4aUjNoDfNPRspXGUgvpYra+5NNKaO8Jyvy1acjDRXHcdSDlii5I7y4PNk7dGC09kAvX+jxfT5fyrDudWVCVe1S6WE6xrrDG3AQOWwXaj2ZPkASWucCBoTYSSnd2GbtwenHZmMJeBsDWTNpcJZboQH3Bcfkn/e8hAVcuHIAtA9lBkJISfxWp86xe9fiq7K6trPkWeAmQUqLoyUkSyQRymyOZYdOqP6Ur+AVXKC01p5weIAAAAAElFTkSuQmCC",
        "activeIcon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAABHNCSVQICAgIfAhkiAAABHtJREFUSImllWtMFFcUx38zszv7XthdYFlYYMtDRcVQ3482aFqbSkx80JbQtLbVhkbTpLFNSUkp0aY1qW1MbSoJNprYhBip8UklfrGaUIwm1hqtWiNUEBREWGDZxyy7O/2AGhEWsT1fJjnnnv/vnnPn3CsweZOyXNYGrQaPxSgZfIHo/eGIqkdFGVZVIaSo1X39/obxEjXPAIkaZCH/4k5PliBAOMLIN6yyq9Eb23msLyleojgJ8R1AGsBwTD1z6nJQBZA1oJXAZBBovOD39nr9v8UTkCYB8QNVwMfeQaX+fGtkOaqgExC42KpQvb8vcr0z1DQ4FN71fyo5BzQBAb1Brn37zXzdLWzhbSeHwwf+0ihLV0wTDSbDtIkEJgM5AKjAhlSHpe1YQxsmk6wtK8mRCwscuiPHbw1HwtEUIDeegDAJyBSgz+O2N1S9k18wb5rNeOJs13BbdyDqdOikpYUpWqdNx5rK5u473vvFvgH++C+QhOfcjnN11fPzCqckxq28qzdEcUVT1/WWniLgxuOxp7VL40mzHf/psznZEwEAUh16Dn65KDUnw9EAGB+PTfh3uV22ig/fyCstKUrXA/T5wqyubGbLnqv88MtN6k910DOg8MKskRGxWWVSHPqESy1DOd7B4KHJVJKYZJU3bVyVbXro0GtFpmZaKF6UyqsLU/H6wpj1o+f5taJ0jcdlWg7kPbUSV2riB5+WTV1bmJf4aI1WIzLDY2Vevp1wNEavV+GL9dMxyKNl8twW0+9XvHl9A8E6mOBaseg160qWpmsf96kqrK1qRgAWz0yitmIuNrM8Jndevg1RFOYAOkCJ2y6jXnIYn2iFIMDhrxdjt8q8t9KD066Ll8786XYZeB5ANCc5v7c63S0JTvdNqyO1HXgJkI16aewWgQynkZ+rFlBZc5mzV3rjQmZlJ5qNZjwAoiRqZjqLN2W7Xq/MSZj9ihvIADzBkBq3SqddR93WBRxvvhsXImoEITA0ModjziQjzbVzYcEMn8/vty376IJa9nKy8O4KN7JmNNNukdlWPjMupLXDNwTcGReysmiJtWZrhRWAaJTdB4+oaz4/JuSmGcjNMJBulzAbJAZDUUQVlsxKGvdszly6HwL+HhcyyiSJ8tISoby0hLb2Dm603aa98y4d9/oBSDRbef/bE9RsziUjxQBAJKpSc+im6gtqrHMK8v8c8geqJ/0yZmW6ycp0jwgFFYKK8mAfEifOnsZl17Hn1zblVndESEtOjp6s3WFoae/QbN7+Y/qzPL+PbEvNXs5fuYbw4HoNKUosN8sRfWv1Ou3yhXNFlyuF3fsPB7bvrbvW0n77mzGQ1o7OqK9/ULIkWuNCvvpk45MuERBRVRpPN0VWbqro8voG9/1zu3MLEBkDOX/p6v7ZpesLPS5X8sbS1cmrlr0oSvpxR+aR9Xv7qa0/Gth3tLE/pCj1D8QHHsYFc5LzgCTrigRBE4uE/Yahnu4NwCEgM8OdVi5LUpktwWIShPHHJhaL4Q8E7/T6Br/rudd7EAg/ueZf7ziIbwUW/ksAAAAASUVORK5CYII="
      },
      {
        "icon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAABHNCSVQICAgIfAhkiAAABJFJREFUSImtVG1sk1UUft77vl0/tlJnRxEcOoeZMhazOECMxAWmRsWgySaDIAgBEhRQIZIY2CDbcMimEhPZD0YyJQZGQFwEIcSBiTFjZHzIDGOF0UEZpev6ta7t1r3ve48/apd26WCLPH9uzrnnPs+595x7gAmgZHvn3JJy6ycTORMDe9Dm0vKuopJK29MxW4CYBgZTzF6w5ZxUvNO6/n8LKaQ6BFk5XFxmzY8KkZ8pwn0AKPn8ujEjbXqTwJk6HiHhYQElO65NZSzlgyM7n/UBWAFgEoBz6/faz/vdkciR6pwTj0QIAIioorUztOPEeT9klTDrGT1WFpkvCcDLgiDI4+EYj0iayy/Luw45SFY4cSKqP9NHzVcDRERLxssjxRtra231TBTeBXDFGRpa/Wv5TAeAGTZXRHoxxwBJjD5AYZ4RzX8HUPSCceZ4hRKaQeXU8+HbkydvLJ7yukWna1ux59aezXX2uqzJWrrSFYbKCQDQcj2InEwdDv3pfX9FtW1jaVX3Ew8TSqhRaZn1tcJ56ccVTin/3AoLpQvN4rznUsVULUOLNYRTrX4QB3Ke0mFlkRkuv4xr9iHlTFu/y+tXflc9/RsadueHHi60u326JOttc/Mn8U3vWFKEcbVKFJdsYeXACVeH3x1a0Lgrzzt6P6FGaRrjgVWLM2h+blpKvL/utz70ehObSwDw8WILLKYoRUG2QUpfNjXv28be0yCaB0GgpBktKeuaU3XI4ab/cLLNT7LCaaJouuALrKmxrRvNzwCguMyar9fhi0UvmcwAQACcPhmqmjypB2FRgcloMIibR/uFdbXdF7MytVnZ07SG4lfS9RpxAoUZAzVHnT2X24IFXEcHBUAWSNrOdHr25LalU81LX338kYgAQF62wUKplH+0KudNrpE2cqZ+M+ZQdfUr2Frfg8/q7Oi4OwQAON7iw6mL/QAAlRP2nXTBPaDgpz8Sm8yUylIMBjETAI7tyL4DAFJ4UBVCEY5UbaKmxSShuDAdDo+M3Ok6qJzQ2hECA/DWbBNEJsCgZfj6iBPL3zAnnBUZwDibXbrtxgUu0nwQH2CDg7R88/f29jU1t71O39jzsaUzBLNRhN7A0N49CADIzdKjzyNjhkWbEOsOKBQckqepGmxhnGWIJK8d2VxWcXPT8fPecHyrtt4I0i8tPiIiqjrsoOarATp92U+1x+4TEdHW+rt0tj1APzS7E1p8/+k+X0ll5/NJM37vyw7zmlqbczju7wwrnEKDKhERBYfUEb/TN0xERP6QkrASESkqp0/33bk5mn+kME3bcz3Dw/TV3qZeT8ynEQUYdNGQ+BpOeUwDADAZxIQVABqaPYHwIC8fswYxrK7uqqs+7OjjExwKdneEdjc6+jZ8d7sqGW/Sj7N6T/fFmo8yCzKM0Tn2c4sv+NfVYH98jEYSNBWrpln0muhNyxru9d66PVDYWDnTmoxTSuYUGCLxttU+FOlxDsw5Vjnrfsy3rrb7bDDMF+pNI0+qjiUyphBXyFNx0OGUmKACgM87nCpxShBXVPJU/nivV9IwBQD8/UpSrhj+Bbf5rMjEKC/eAAAAAElFTkSuQmCC",
        "activeIcon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAABHNCSVQICAgIfAhkiAAABI5JREFUSImtlntMU1cYwH+3LyhFQKA8SrHIlNii4iMKZCqomTE6nW46NRo3shl1m04000zjHmYvs/gYOl22xD00bDodkcSYOdGp0YHOGBkLKOJAqEBpKQW8IGDP/iiwVu0A4/fPvd/r/M757jnfPTAwSQHWDzAHAEUf/tmAyUvXAaFeuhJ462mAKoBcYEy33gTUdr8HAUeA5v6ApH7ExGq12mWyLDcCy/Cs6LTZbD5bVlYGcLI/oH6JEOLD/PxfxLSMsWJa5mixZcs64Xa7i4QQqqcJCbZarZ0zpo8U8o1FQtxZIrZmp4qDB78VQoiX+juOzzcaaog6kBQfY3smLvosYOw2DysuLlZNTw9Fq/WEL35eT2HhGQDzE4E63O6qnBVz9IeyF2YMNUQVGmP0n6SlmPdYLBZxptBFe7sbgMMnGkhNncp7mza8HBsZvhqI7guk9FZaWmWNPixk3tXbd7ljawp+f9HUSdsWZybExMZIwaZxrN2cxw95NgyJk8nOyiK5pSR6hDFyhq2lfSkKxUhXq1wAdD4O9PCuM+nDB5cvSEtm39r5aiQvd/woiDWDSgOOO1BRCF0dve6CP290rtp//O9bNXXTgcb/BSXGRf22ffnMzAWZY3x206qcY1TZmnwTJfh69TyMhoheW0l5jfvF7T9eKa+uTQeEP9CEWamjTp3YlhUGsC//Im/MSgOVT3X7lO0/FTh3Hb+0qb7R+Y23vWczpBj04e+unjkxDAAhqKh10NXZNSAIwMb5UwaH6AIf6YeqRGP0lUkjTENShxuDZ49P8lgliR0r5w4YAiAFqEkyRGjLq2sNwA48/fED1WCd1vj9O4ujnmhUPzLZkhB+oqgkBVgCxACH/TbVypoG0rO/ZPyaHM5duwlATt4Fvjt5uTcma8dhKmvsfHTotE/ukMiQYJ1O1zP5OkConK2y1CG3owkK9AlOMOrZvCCDaoeLjLFJ8MDN0YslIMGrMyeAJJEcH8XCz3M5+PZCn9xAjUYKUCvG3YMi4FngnsLpkpda1uT8lfDKp466eqffcvx84TqG8EGEBgVScMWzwmGxkTiaZYwRIT6xVbamzsamFhOwAdADyxXO1taCipq60e3tXevz/iht905QKRSoFJ7q5p4rZu7EEcydaGbfqSIAdudfYu/KOWw7ctYHVHa3oRHYCqwAPgMc3udIlzw0rqxk7zpj79npegBuN2jUeJe3ymrHFBdJV9t9VNqA3mdPjuXN3eWlldYkb7j3aewMDAi0l1bbpsxJswQBoFCA0hOiVP/XLMJCut3dNoWXb81Xxx3Xb9dubJHbSvyBaL4nF7vaugZdK68xz0tP1vn0uj7kVlU9r39xrP5iadX+qrqGPQ/7H/lDVlhrt6rVUqqjsfm5iAjPPWTn0XOu3PPXW73jgjTqwN8/fi1CEaABYOnOI3WXy/7JAG4+biKP/RWrlcoO4dUSz5dUyldvVKYC1h7bcFPM1Za2+xGh3SABbn8Q8HM5GR4ffUAI6QWVUnID2Jtljd3pSgQcPTEJsfpfVSrleJVCEgD2FlmyN7oi/YH+BSfZn/xiQV8WAAAAAElFTkSuQmCC"
      },
      {
        "icon": "data:image/png;base64,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",
        "activeIcon": "data:image/png;base64,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"
      },
      {
        "icon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAVCAYAAABYHP4bAAAABHNCSVQICAgIfAhkiAAABQlJREFUSImdlGlsVFUUx//3LfM6+9KdUqW1Qy3IIigJIiJGo6IgwWkrtIBIIDEGE4gJYh2KLRUVsKigiQkCIobCRKQBwYJsxhIoFoRCawtFW+leprO9eTNvuX5oWOwAsZxP9557zvnd7X8IBhql5M1P//5AoXQaCO2gGkaxDOMPBKKL+gg5+1OxMxKT8z+M3D5ZWF7DKyH7wknjrWvznrKbOvsUOFMFdHhlfLans7fXK9OIhILt7syq+wa51tSZHHGmc0MTdeZlruQko8DEBHf5FLz7VWtrICQ/71mdXT8Y0K1qYf3Y8dkGm7sgNckoMOjsk3H4Dz8O1vpx4a8wKIAkK4clecnpFgt/fMGKc8b7AlktTMmEh00GANj1qxdf7OmCGNHAssBvl4Jwb7kGf1jFo5kGpCboiMhaHho0aM6KpqzMVGHk2Ay9/mhdAMdq/bBZWEzMNuHZMRY4zByiCsUnFe0AgBmT7XaTmWwYNEg0yV5R0phjdQFs29eNiaPNmP10PMo9Hdhc1YOLV8MoKkhFS1sUVbV+PJZlYKOqNmrQoB+LRvR2+6LV+0/6qE4g0AiFT1ShExiY9CxkWYNPVMGzBBdbwlhb0R4hhBwdDIi7MeiQ4mYTSA2Jdt4shTVbdX0QS2clw2pg4TCx2HuyD3oDK05+xKKWf/9PPWfj592taP6qxkQ1qEqedTmBG77/6KigtHm6Tkc3vTLFkZBg5fTtvTKcQ+Jw9oqIlx63YtXWa52SpPlFMTJ9Z0nOnwMBrxU3TzBbsCM1UWcIixrxhpTmgEhcFe6MDjIw2PVOvdmWLNQVv572QG2ziJauKF59wo6Ne7u8V1rExYaIeGDLmrGhmFOUXk2JtzI1y2enDD12PoBkG4f0RB3dsKvz/OjKYeNiVOlZlxMIeJVpxd9e87f1KkqSjadl37VFO68rH1asGu65EwQABFaZN+c5xxAdS9DplfHzKT+y0+LICKc+7cQzTWO4OyUx0PqCPrXmWPX1j0AZE2XoaJXSe/a4OB2flWTlGZ4l6OiWsWRWMliGID1ep6cqTbsFopS4ii/nE2AhwyKD4xmrKGo9stFYHc+EpkWi7EqXu2k+A3pY0qmfV7pz2m4H+YLRqtONofyCKQ7L4umJqG8NIyNZh5qGUABE+Z0BgLzS+gzXyqYjoBinamyhxcy3v52bkmDQc6fipJB/VLZ57syp9gBRlY8pIafiomxlXlGj63bQk0ecPxyv8dftP+MLZaYImDTChI37ur1ev7zDUzKyncwsuxTPS9xBqjBveNZkXZi67AiX5kj3Go28LxrRvoyEoodMdmE1gImqjH2bl2fMWbDinDHIGTwg5OvdJc49+aVXUww8PSHoGLtGoWcBgTKUKiokjoMkhWkDyXU3llONVHnKnAduXuH7l1/oDbceOrp+qppb3FS4u2T49vz3GkcSgbwoq+gXKlH1RGO2Eg1zKcdmDkvVbZgx2ZZwp/f7prK7hwMwwVPmXHrTSwj1AP3Q9ZQwKngAMFr5Rc4HhcJ4K190I1TVqJ4hpOpKmyR39cjCwdN9UgxFA9UoDXGUEPWuX4kQqm2i2wBAUTVrj1cxhiTtpiQ0DSwhhA0GVZ5hQBlCYuSisf1+kutuPEnQv+t7maAn2W+5Uk0OU6wizlwWtbMNQXnRy0lCDEijWLuzrTumM9zNCsua5hv03EqOY7SBa9GoRjSNikYDa44BUUqkCP3lX0IPONazfl+eAAAAAElFTkSuQmCC",
        "activeIcon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUCAYAAAB4d5a9AAAABHNCSVQICAgIfAhkiAAABLBJREFUOI2dlXts01UUx7+/29+vvz7W9cHarl23jg03GOtGWWWwQBxbVB4aQXQq/rGoTDQhhuj4Zy7BGBZjUP8xJEYDcVMxRDHICAosjnd4TxmPTR4b2+jouq1d37/29/td/xAilGYBzz/nntyc8zn3nnPvYfCw5DjNhl9EyDYAsoZTaOIpaWjEH9oI4DKAWAafaYVJs0tyc3RffVDrrK3K1zGCTKHlCM4Ph4WuvkDkwu1QYHQ8VPm4IMV964o5jhlHVpSZC5bNMfGEMFAq/s3BrufZxcV6Dcsw3MBUclE0nuwEIPwfyLMvuu0vr/VYNNGUjH1Xg+jsi+DUUAzhhIiZJh5lNi1vy1YVXptIqkMx4eCjQti7WuvMNWxZXmZSBuMi2rrHsK5hJd52lyGZEvHzgWPY8sc5tNbZUGrVsBRY8KgAACB39XxPfrZJp2ax+cg4BokOWztPQqtWwTsRQvuZv3ExzmNnzwQsWRxKLNoSAJWPAwIA7RN5Jv9S9yyqLyqmuBik2NRGy0qKqKPAQXGgl6Ljd2opLqafra2iDQuddwAse9Tg92qS0mqU8FSU1/mCYcqdP06Mvaex+6P1yC/IQ09HO7JOHkKJmtCLIxF66Za/LxxPtgCgjwNBKCqcFVJyo4Ywih82rFG9vmQeymflo9BsxNJiMyotOhqNJHzD/snx60N3KgFIGeK5CguMzUaT9rlgMD4J4PYDEACyfzLYIcrUYtRlzU6KIt+67Ud07DuMl+oXYfO2Xf7e64OXgrHIq7FoYjw9utNhaJo3N6d9a4vr6YYVedXjQWlVSiLqYDB+JNPpSGG+7ejW5jeTQ13b6c3fvqGr62tCTkfulmluRFc+2+wN9zfQZUudtMZjp77za2iNxz4KwMFmcJAHh0c//m7f4YN7u8+AMAQDXp9qyOtrnQbiemaJhedYgjybGjYzj2wdi1eedxhOnvNWp0N0OXZjIwPS9tSTLuaL9xsBAO7GZtZEjT2To4FWAAcAiGl+vlu3EymeY1BdaYRex0GlIhgcjsUAjN77uxh7qfVDwpENC5vKTRe+7+N4LQfBmwRkGWaPCb7+AEqXF/r+2nUtKoSTGwNjwc77IEyR03Ri+6dV1bU1OaS3PwRJonTNu6cv3xyYcDMAiL3UundBk6t20XqXNhYQ8HXdT9A7ssCpOYgJCVSWERmL4Y3OVeCzlNj9TlfA++d4m2/Q/zkAWCy6dRoN20gYpsyg47SEYRAMpeKSJF8lwJeMpcDUUv1WRcuS5vlaAJi8OYVz315B9XoXEgEBkkTBqQi6PzmL2k0eWObOAJUpdqzc4+8/OlAH4FKu1TDWtXOxWa0kEGUKyBQsS5CSZKxuOjXMWGaab7x35rUipebhHgiNRCBRCp1ZjZ0v/AoS/68UsigjGUkJkkTDqZSQUPKsNVNHyJJ0hWU5kp0JAABcFgeOUsQDAoTJBOrcpvQnzkuSzB06PpCsr4qwSJ9PDOj+EzCziamkuGPlnpGMlLsiJmWFGJ2y1lf4CJM25gIRYH+3nlRUuqFQkAf2KKU42nNDYABoAPDTQQDwNhsOWQ2YcT+EYUCTIhCKZkeMerVWQR7MgIJCEORj/wAwEOmu7K0f+QAAAABJRU5ErkJggg=="
      }
      , {
        "icon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAABHNCSVQICAgIfAhkiAAAAttJREFUSIndlUFoXFUUhr//vjeTzqRKQQSpKBhJo92IVq2h4kK3koXNM5YuxZWLInVRap4amwYp3RVciKCLLBpNW5QKgmAXtiJoNgoZ8hpasSVUhdLQtC8zmXeOC5ugk0lCSSrov7zn/v9/zr33nCs2GH0jM9WO/PqTjnojo9elx2T+Yrxe4YHBqS5z9RJ4RtDr+dx2pJ8j0/fIxky+OZJ26nazLc/nT0jNHTLtcngOcMGPGBOSny01qudGjzyQL3KSNDsc3MurVtR3qLa13Ih2Ra5nTb6DfO5xh18wzpp0Oip8aOxw9ySSr6QhqJnYs2TUNtsGCH5w94mAv5tX7/rui4Nbb/5DaWSNYzAmpbBdf5V34XWneUzQcLweTPNA3QMLa8isDUXCiwdjAKf5O/BVsbn8quWN+2xTXJhHl9ZtcguVenFV/YNTjwKnCIHIOGPy3cCsu/eND/fU/k54JZ1+ocD2CO4295sK4fPP3us+1SqcvJXtJTAKIDHgzpiSNJuWccYjtuBct+Dfnhjq+XgZ+Z2pfZj2O340mGYE9xZB+wj+5fjQtv3tKknS7FgwJi3wQQw8DHwKbPGID4UuL2O4i7fPH/AFPT3+/ralI+1/szaqSjT90uCFIyeHu35rpQlOFxZmFAwlaeaIWZxCcBHA4QZSY8kngAp/Humb5Xn7U8h/kulKu6pu6SUxQCiVHrF8oaeINQdQKoqqSx1LOw1wnUR2vlXEIrrUCL8SW6eh0M5IsJskzVZsto1CkmZ52wzuBNY9VBfRn2ZvBNjbLuaw+qy7HQh2IsYL9HVrLLif2zAjAEwXTwx3T7QuJ2nm/9od/fceA+Kq48eTNDveGnLw/18fBeDSy4dqD91po1jwkTeiTwYOZkcJngO4h7yImF+NWKI55xZW/YHrlWK26Z1GvU78x43LI/d03n/NYr0GobK4SdAR3KsriRREmxCVleJAtTwfd5Sp4zD9J3sbPP0WTheSAAAAAElFTkSuQmCC",
        "activeIcon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAABHNCSVQICAgIfAhkiAAAAwhJREFUSIm9lk2IHEUUx39V1VPTX7Oz3ZuNOztrwoJxJmtQ1JUYF6KXFSGIUZTgIZ7EXCQhgngSP2+iSLyEnBQxeJB4CRIICEIcUBH8QEUiegmSrLCZ7E7PV09X5TCJsu5MkoVJ/qduXr3f/73XXdUtGL08YB6fBc+PFrNeOtetNx5yRgC+HVjIjwW7VS73SNpqbtMTUZJUZ/Ktyozrnfl1lR/Ozm/UyAEqwEJ+orgorNlte3bcmYraydzWgEpZUSmThm7xakLrwiWf38/tuJ7RFPCAHg8fzGn9aLrausfx3SzbNi0622fyVGZgdjMdIfRQwnSsvMBd05ECqsD9bhwtgn04TdMptxS3kjvKQbdaVsxtoTvm5TY0g+kIY7lLXLl9IZiMjwolDUoaq6RBqQwpzIagQ2TriXe1o2VRituNl/d51BsKIWDTGAgxOLPZAT9/Yy7GwLNv4QA74mJ4JF1pSj4/Q1j7BXyXxuv7Yba0Fn70JP5XP9JcrpMvBJj77iQ9uBc2R2vhp7+HNz/qX7/6HAAiCoOle8uT0bfFoNW4bbzA9i3w+K71lb19HNIeHNgDpRgursInX1L46U9Wjx0e3P37J6C8CY58hrzYSCYVwgKwZyfsrK5PyAz52s/wyj6YnuhD4zF48QlsqwN//D14bLvm4O7ZfkeAjQphT+qcVcUgFVIoAJnXSEeClNIIK1f+WlLJ84+tYxVPfI32NMrVCFcjHAmABTIhsdbS+e63vtHHB56m3mz/m9zq9jDGDq5ygJrdLpkdvv6dUzUcgInAYzL0bxi8Ub13qpbJm0b/n0ZxqLLS7vDayRodM3h/ZyBGYlRP2iw1OxTm9w6Mqwsf2pEYAUipyEWl4fFRGV23kFtlNJLR+dohadT55/gbA+NaayEA+8VL+5HDTuoR6MkPPr11+0jGhXD5/KXkphs5wlHH3j39zaFn5queq/57ZEKCr6/91daOQit1zTVBvs8QgBMWvIN+zn1KCjyAnjEeZsiLIgErXJP1hv6QWJCpyXwAaaWQDucvA/115VDvXsBrAAAAAElFTkSuQmCC"
      }
    ];
    vm.InvestmentGoalList.goalName = "Wealth Creation";
    // get Investment goal list
    function GetInvestmentGoalList() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.InvestmentGoalList = [];
          for (var i = 0; i < resp.data.length; i++) {
            var obj = {
              "goalName": resp.data[i],
              "icon": vm.iconsArray[i].icon,
              "iconAcitve": vm.iconsArray[i].activeIcon,
            }
            vm.InvestmentGoalList.push(obj);
          }
          setGetDraftData();
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
        };
      InvestorService.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'investmentGoal',
        child5: 'list',
        nriFlag: !vm.userData.taxStatusResident
      }).$promise.then(success, error);
    }
    // get category details list
    function categoryDetailsList() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.InvestmentGoalDetails = resp.data;
          setGetDraftData();
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
          // $state.go('newInvestor.kycVerification');
        };
      InvestorService.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'investmentGoal',
        nriFlag: !vm.userData.taxStatusResident
      }).$promise.then(success, error);
    }

    function changeScheme(schemes) {
      vm.selectedInvestmentGoal = schemes;
    }
    // change investment goal list
    vm.changeInvestmentGoal = function (investmentGoal) {
      vm.selectedInvestmentGoalName = investmentGoal;
      vm.SelectedInvestmentGoalDetailsList = [];
      vm.SelectedInvestmentGoalDetailsArray = [];
      if (vm.InvestmentGoalDetails) {
        if (vm.distributorDetails) {
          if (vm.distributorDetails.schemeGroupCode) {
            vm.InvestmentGoalDetails.forEach(function (item2) {
              if (item2.type == vm.selectedInvestmentGoalName) {
                item2.funds.forEach(function (item3) {
                  if (item3.regularSchemes) {
                    try {
                      item3.regularSchemes.forEach(function (item4) {
                        vm.schemeCodeList.forEach(function (item1) {
                          if (item4.schemeCode == item1.schemeCd) {
                            var tempObj = item3;
                            tempObj.selectedInvestmentGoalcard = null;
                            vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                            throw 'Break';
                          }
                        })
                      })
                    } catch (e) {
                      
                    }
                  }
                })
              }
            })
          }else if(vm.distributorDetails && vm.distributorDetails.HDFCCAMP){
            vm.schemeCodeList = [ "01","1","02","2","41","44","GFDPD","GFGPG"];
            vm.InvestmentGoalDetails.forEach(function (item2) {
              if (item2.type == vm.selectedInvestmentGoalName) {
                item2.funds.forEach(function (item3) {
                  if (vm.DirectScheme) {

                  } else {
                    if (item3.regularSchemes) {
                      try {
                        item3.regularSchemes.forEach(function (item4) {
                          vm.schemeCodeList.forEach(function (item1) {
                            if (item4.schemeCode == item1) {
                              var tempObj = item3;
                              tempObj.selectedInvestmentGoalcard = null;
                              vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                              throw 'Break';
                            }
                          })
                        })
                      } catch (e) {
                        
                      }
                    }
                  }
                })
              }
            });
          }else {
            if (vm.InvestmentGoalDetails && vm.distributorDetails.schemeCode) {
              vm.SelectedInvestmentGoalDetailsList = [];
              vm.InvestmentGoalDetails.forEach(function (item2) {
                if (item2.type == vm.selectedInvestmentGoalName) {
                  item2.funds.forEach(function (item3) {
                    try {
                      if (vm.DirectScheme) {
                        if (item3.directSchemes) {
                          item3.directSchemes.forEach(function (item4) {

                            if (item4.schemeCode == vm.distributorDetails.schemeCode) {
                              var tempObj = item3;
                              tempObj.selectedInvestmentGoalcard = item4;
                              vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                              throw 'Break';
                            }

                          })
                        }
                      } else {
                        if (item3.regularSchemes) {
                          item3.regularSchemes.forEach(function (item4) {

                            if (item4.schemeCode == vm.distributorDetails.schemeCode) {
                              var tempObj = item3;
                              tempObj.selectedInvestmentGoalcard = item4;
                              vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                              throw 'Break';
                            }

                          })
                        }
                      }
                    } catch (e) {
                      
                    }
                  })
                }
              })
              vm.changeInvestmentGoalcard(vm.SelectedInvestmentGoalDetailsList);
            } else {
              vm.InvestmentGoalDetails.forEach(function (res) {
                if (vm.selectedInvestmentGoalName == res.type) {
                  vm.SelectedInvestmentGoalDetailsList = res.funds;
                }
              })

            }
          }
        } else if (vm.PARTNER_DATA) {
          vm.InvestmentGoalDetails.forEach(function (item2) {
            if (item2.type == vm.selectedInvestmentGoalName) {
              item2.funds.forEach(function (item3) {
                if (vm.DirectScheme) {
                  if (item3.directSchemes) {
                    try {
                      item3.directSchemes.forEach(function (item4) {
                        vm.schemeCodeList.forEach(function (item1) {
                          if (item4.schemeCode == item1.schemeCode) {
                            var tempObj = item3;
                            tempObj.selectedInvestmentGoalcard = null;
                            vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                            throw 'Break';
                          }
                        })
                      })
                    } catch (e) {
                      
                    }
                  }
                } else {
                  if (item3.regularSchemes) {
                    try {
                      item3.regularSchemes.forEach(function (item4) {
                        vm.schemeCodeList.forEach(function (item1) {
                          if (item4.schemeCode == item1.schemeCode) {
                            var tempObj = item3;
                            tempObj.selectedInvestmentGoalcard = null;
                            vm.SelectedInvestmentGoalDetailsList.push(tempObj);
                            throw 'Break';
                          }
                        })
                      })
                    } catch (e) {
                      
                    }
                  }
                }
              })
            }
          });
        } else {
          vm.InvestmentGoalDetails.forEach(function (res) {
            if (vm.selectedInvestmentGoalName == res.type) {
              vm.SelectedInvestmentGoalDetailsList = res.funds;
            }
          })
        }

        vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
        vm.pageArray = [];
        for (var i = 0; i < vm.pageNumber; i++) {
          vm.pageArray.push(i + 1);
        }
        vm.getPageData(1);
      }
    }

    vm.next = function () {
      var verifyObjData = $state.params.verificationData ? $state.params.verificationData : JSON.parse(sessionStorage.getItem("verifyObj"));
      vm.saveDraftPayload.panNumber = verifyObjData.panNumber;
      vm.saveDraftPayload.investmentGoal = vm.selectedInvestmentGoalName;
      vm.saveDraftPayload.fundName = vm.selectedInvestmentGoal.fundName;
      vm.saveDraftPayload.fundCategory = null;
      vm.saveDraftPayload.step = "FIRST";
      vm.saveDraftPayload.schemeCode = vm.selectedscheme.schemeCode;
      vm.saveDraftPayload.investmentOption = vm.selectedscheme.investmentOption;
      vm.saveDraftPayload.schemeName = vm.selectedscheme.schemeName;
      vm.saveDraftPayload.schemeType = vm.selectedscheme.schemeType;
      var success = function (resp) {
        if (resp.data && resp.status) {
          var data = resp.data;
          var Details = JSON.parse(sessionStorage.getItem("userData"));
          if (!Details.transactionDraftId) {
            var details = {}
            details.transactionDraftId = data.id;
            $window.sessionStorage.setItem("userData", JSON.stringify(details));

          }
          // vm.investmentModeValidation = {};
          // vm.investmentModeValidation.purchaseEnabled = vm.selectedscheme.purchaseEnabled;
          // vm.investmentModeValidation.sipEnabled = vm.selectedscheme.sipEnabled;
          // vm.investmentModeValidation.directSchemes = vm.DirectScheme;
          // sessionStorage.setItem("investmentModeValidation", JSON.stringify(vm.investmentModeValidation));
          $rootScope.stepperSecondary.steps[0].stepActive = false;
          $rootScope.stepperSecondary.steps[0].stepCompleted = true;
          $rootScope.stepperSecondary.steps[1].stepActive = true;
          $state.go('newInvestor.investmentDetails.investmentmode');
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.processFlag = false;
      if(vm.distributorDetails || vm.PARTNER_DATA){
        vm.saveDraftPayload.oneClick = true;
      }
      LoaderService.showLoader('.pan-loader');
      InvestorService.post({
        child1: 'new',
        child2: 'user',
        child3: 'save',
        child4: 'transaction'
      }, vm.saveDraftPayload).$promise.then(success, error);
    }
    function schemeGroupCodeList() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.schemeCodeList = resp.data;
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      }
        IIHttpService.post({
          child1: 'getListOfSchemes',
        }, { schemeCode: vm.distributorDetails.schemeGroupCode }).$promise.then(success, error);
      }

    function schemeGroupCodeData() {
      vm.schemeCodeList = vm.PARTNER_DATA.schemeList;
    }
  }
})();


/**
 * Created by ttn on 6/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ProfileApprovalController', profileApprovalCtrl);

  /** @ngInject */
  function profileApprovalCtrl(InvestorService, $scope, $state, LoaderService, MessageService, ModalService, panAadharService, AuthService, UtilService) {
    var vm = this;
    vm.approvalList = [{}];
    vm.approvFolio = approvFolio;
    vm.rejectFolio = rejectFolio;
    vm.init = init;
    function init() {
      getApproval()
    }

    function getApproval() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.approvalList = resp.data.approvalList;
          $scope.ProfileParentCtrl.pendingApprovalCount = vm.approvalList?vm.approvalList.length:0
        } else {
          vm.approvalList = [];
          MessageService.error(resp.message);
        }
      }, error = function () {
        LoaderService.hideLoader();
      };
      LoaderService.showLoader();// /profile/pending/approvals
      InvestorService.get({
        child1: 'profile',
        child2: 'pending',
        child3: 'approvals'
      }).$promise.then(success, error);
    }

    function approvFolio(item) {

      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        if(item && item.linkId){
          if(item.approvalType == "NOMINEE_ADD_UPDATE" || item.approvalType == "NOMINEE_OPT_OUT"){
            $state.go('main.holderApprovalForNomination', {uuid : item.linkId, type: "existing_investor", approvalType : item.approvalType, sebi_reg: item.sebiNomineeRegulatory01650Active })
          }else {
            $state.go('main.investorApproval', {uuid: item.linkId, type: "investor"});
          }
        }else{
          MessageService.error("Data is not valid");
        }
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(AuthService.getToken().investorPAN,null).then(successHandler).catch(errorHandler);

    }

    function rejectFolio(item) {
      if(item.approvalType == "NOMINEE_ADD_UPDATE" || item.approvalType == "NOMINEE_OPT_OUT"){
        rejectForNominationOrOptOut(item);
      }else {
        var payload = {linkId: item.linkId};
        var msg = "";
        if (item.approvalType == "NOMINEE_ADD_UPDATE") {
          msg = "Do you want to Reject this Nomination?"
        } else if (item.approvalType == "NOMINEE_OPT_OUT") {
          msg = "Do you want to Reject this Opt-out of Nomination?"
        } else {
          msg = "Do you want to Reject this folio?"
        }
        var successModal = function () {
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status) {
              getApproval()
            } else {
              MessageService.error(resp.message);
            }
          }, error = function () {
            LoaderService.hideLoader();
          };
          LoaderService.showLoader();
          InvestorService.post({
            child1: 'folio',
            child2: 'any-or-survivor',
            child3: 'reject',
            child4: 'holder'
          }, payload).$promise.then(success, error);
        };
        ModalService.confirmCancelModal({Text: msg}, successModal);
      }
    }

    function rejectForNominationOrOptOut(item) {
      var success = function () {
        var successReason = function (respModal) {
          var successFolioReject = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              var message = 'Your request for rejection has been submitted successfully.',
                successReject = function () {
                  getApproval();
                };
              var successHandler = function(resp) {

                if(resp.popupDTO.popupDTOMap.Popup_Home !== undefined)
                {
                  ModalService.successMessageModal({message: message, hideOKButton: false}, successReject);
                }
              }

              UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
                MessageService.error(resp);
              });
            } else {
              MessageService.error(resp.message);
            }
          }
            , errorFolioReject = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err)
          };
          var payload = {
            summaryType : item.approvalType && item.approvalType == 'NOMINEE_ADD_UPDATE' ? "NOMINEEADDUPDATE" : "NOMINEEOPTOUT",
            rejectionReason: respModal ? respModal : 'Rejected',
            approved: false
          };
          LoaderService.showLoader();//folio/any-or-survivor/reject/holder
          InvestorService.post({
            child1: 'transaction',
            child2: 'otp',
            child3: 'nominee',
            child4: 'action',
            child5: item.linkId
          }, payload).$promise.then(successFolioReject, errorFolioReject);


        }, dismissReason = function () {
          //UtilService.errorHandler(err);

        };
        ModalService.rejectionReasonModal({type: 'NominationRejection'}, successReason, dismissReason);

      }, dismiss = function () {
        //UtilService.errorHandler(err);

      };
      var msg = "";
      if(item.approvalType == 'NOMINEE_ADD_UPDATE'){
        msg = "Are you sure, you want to reject Nomination?"
      }else {
        msg = "Are you sure, you want to reject Opt-out of Nomination"
      }
      ModalService.confirmCancelModal({Text: msg}, success, dismiss);
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UpdateIFSCController', updateIFSCController);

  /** @ngInject */
  function updateIFSCController(ModalService, $window, LoaderService, MessageService, UtilService, InvestorService, AppConstants, InvestorFileUploadService, AuthService, $state, $stateParams) {
    var vm = this;
    vm.init = init;
    vm.updateIFSCSuccessful = updateIFSCSuccessful;
    vm.copyPasteHandler = copyPasteHandler;
    vm.accFocus = accFocus;
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.breakFileUrl = breakFileUrl;
    vm.openUploadedDoc = openUploadedDoc;
    vm.back = back;
    vm.setHeader = setHeader;
    vm.removeLocalStorage = removeLocalStorage;
    vm.uploadNewBankProof = uploadNewBankProof;
    vm.uploadOldBankProof = uploadOldBankProof;

    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.bankList = null;
    vm.chooseAFileNew = true;
    vm.chooseAFileOld = true;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.chequeLeafUrl = '';
    vm.payload = {bankHolderType: 'MINOR'};

    function updateIFSCSuccessful() {
      var success = function (res) {
        if (res.status) {
          // ModalService.addBankModal(vm.payload);
          var modalSuccess = function(){
            $state.go('main.profile.folioDetails');
          };
          ModalService.forgotPasswordModal({message:res.data.message},modalSuccess);
        }
        else {
          if(res.popupEnabled) {
            ModalService.genericModal({
              text:res.message
            },function () {
              $state.go('main.profile.folioDetails');
            } , function () {})
          } else {
            MessageService.error(res.message);
          }
        }
      };
      var error = function (err) {
        UtilService.errorHandler(err);
      };

      InvestorService.post({
        child1: 'folio',
        child2: 'bank',
        child3: 'update',
        child4: 'ifsc'
      }, vm.payload).$promise.then(success, error);

    }

    function init() {
      if(!$stateParams.folioNumber){
        $state.go('main.profile.folioDetails');
      }
      setHeader();
    }

    function setHeader() {
      var profile = AuthService.getToken();
      vm.MainFolioParent = {};
      vm.MainFolioParent.panNumber = profile.investorPAN;
      vm.MainFolioParent.firstName = profile.investorFName;
      vm.MainFolioParent.lastName = profile.investorLName;
      vm.MainFolioParent.uuid = $stateParams.folioNumber;
      vm.payload.folioNumber = $stateParams.folioNumber;
      vm.MainFolioParent.currentState = 'main.profile.addBank';
      vm.bankDetails = $window.JSON.parse(localStorage.getItem('bankDetails'));
      vm.oldBank = $window.JSON.parse(localStorage.getItem('updateIFSC'));
      vm.payload.bankAccountNumber = vm.oldBank.accountNumber;
    }

    function copyPasteHandler(e) {
      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    }

    function accFocus() {
      vm.accModelDirty = true;
    }

    function uploadOldBankProof(file, type) {
      if (vm.mimeType && (vm.mimeType.indexOf(file.type) == -1)) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 8000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                //vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;
                if (type === 'add') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                else if (type === 'modify') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                breakFileUrl(resp.data.fileUrl, type);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            // DistributorProfileUploadService.post({

            InvestorFileUploadService.post({
              child1: 'profile',
              child2: type,
              child3: 'bank',
              child4: 'upload',
              child5: (type && type === 'add') ? 'cheque-leaf' : 'proof'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 8 MB.")
        }
      }
    }


    function uploadChequeLeafFile(file, type) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 8000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                //vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;
                if (type === 'add') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                else if (type === 'modify') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                breakFileUrl(resp.data.fileUrl, type);
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            // DistributorProfileUploadService.post({

            InvestorFileUploadService.post({
              child1: 'folio',
              child2: 'bank',
              child3: type,
              child4: 'upload',
              child5: (type && type === 'add') ? 'cheque-leaf' : 'proof'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 8 MB.")
        }
      }

    }

    function uploadNewBankProof(file, type) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 8000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                //vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;
                if (type === 'add') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                else if (type === 'modify') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                breakFileUrl(resp.data.fileUrl, type);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            // DistributorProfileUploadService.post({

            InvestorFileUploadService.post({
              child1: 'profile',
              child2: type,
              child3: 'bank',
              child4: 'upload',
              child5: (type && type === 'add') ? 'cheque-leaf' : 'proof'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 8 MB.")
        }
      }

    }

    function breakFileUrl(url, type) {
      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      if (type === 'add') {
        vm.chequeLeafUrlNew = a[a.length - 1] + extension;
        vm.chooseAFileNew = false;
      }
      else if (type === 'modify') {
        vm.chequeLeafUrlOld = a[a.length - 1] + extension;
        vm.chooseAFileOld = false;
      }

    }

    function openUploadedDoc() {
      // window.open(vm.payload.bankDetails.chequeLeaf);
      if(angular.isUndefined(vm.payload.bankDetails.chequeLeaf)){return;}
      ModalService.showImage({docUrl: vm.payload.bankDetails.chequeLeaf});
    }

    function back() {
      vm.removeLocalStorage();
     $state.go('main.profile.folioDetails');
     localStorage.setItem('isBack',true);
    }

    function removeLocalStorage() {
      localStorage.removeItem('updateIFSC');
      localStorage.removeItem('folioId');
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('CobmStatusController', cobmStatusController);

  /** @ngInject */
  function cobmStatusController($window) {

    var vm = this;
    vm.init = init;

    function init() {
      if(localStorage.getItem('cobmDetailList')){
        vm.cobmDetailList = $window.JSON.parse(localStorage.getItem('cobmDetailList'));
      }
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ModifyBankController', modifyBankController);

  /** @ngInject */
  function modifyBankController($log, $scope, $rootScope, $state, AuthService, $cookies, UtilService, $timeout, AppConstants) {

    var vm = this;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ChangeBankController', changeBankController);

  /** @ngInject */
  function changeBankController($window, ModalService, LoaderService, HDFC_API, $http, InvestorFileUploadService, MessageService, UtilService, InvestorService, AppConstants, AuthService, $log, $state) {

    var vm = this;
    vm.init = init;
    vm.fetchBankList = fetchBankList;
    vm.getPayoutMechanism = getPayoutMechanism;
    vm.getAcccountType = getAcccountType;

    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.bankList = null;
    vm.accModelDirty = false;
    vm.chooseAFileNew = true;
    vm.chooseAFileOld = true;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.chequeLeafUrl = '';
    vm.chequeLeafUrlOld = '';
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.uploadChequeLeafFileOld = uploadChequeLeafFileOld;
    vm.breakFileUrl = breakFileUrl;
    vm.openUploadedDoc = openUploadedDoc;
    vm.openUploadedDocOld = openUploadedDocOld;
    vm.changeBank = changeBank;
    vm.changeBankSubmit = changeBankSubmit;
    vm.payload = {makeDefaultBank:true};
    vm.back = back;

    function init() {
      setHeader();
      fetchBankList();
      getPayoutMechanism();
      getAcccountType();
    }

    function setHeader() {
      var profile = AuthService.getToken();
      vm.MainFolioParent = {};
      vm.MainFolioParent.panNumber = profile.investorPAN;
      vm.MainFolioParent.firstName = profile.investorFName;
      vm.MainFolioParent.lastName = profile.investorLName;
      vm.MainFolioParent.uuid = localStorage.getItem('folioId');
      vm.folioNumberToDisplay = localStorage.getItem('folioId');
      vm.payload.folioNumber = localStorage.getItem('folioId');
      vm.MainFolioParent.currentState = 'main.profile.changeBank';
      vm.bankDetails = $window.JSON.parse(localStorage.getItem('bankDetails'));
      vm.oldBankName = vm.bankDetails[0].bankName;
    }

    function fetchBankList() {
      LoaderService.showLoader();
      var success = function (res) {
        LoaderService.hideLoader();
        if(res.status && res.data){
          vm.bankList = res.data.bankList;
        }
        else{
          vm.bankList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        vm.bankList = null;
        UtilService.errorHandler(err);
      };

      InvestorService.get({child1:'bank',child2:'list',child3:'sip'}).$promise.then(success,error);
    }

    function getPayoutMechanism() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payoutMechanismList = resp.data.payoutMechanisms;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'payout-mechanism', child3:'cobm'}).$promise.then(success, error);
    }

    function getAcccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };

      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list'
      }).$promise.then(success, error);
    }

    vm.accFocus = function () {
      vm.accModelDirty = true;
    };

    vm.copyPasteHandler=function (e) {

      var key = e.keyCode?e.keyCode:e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17));

      if ( key === 86 && ctrl ) {
        e.preventDefault();
      } else if ( key === 67 && ctrl ) {
        e.preventDefault();
      }
    };

    function uploadChequeLeafFile(file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if(file){
        if (file.size <= 5000000) {
          vm.fileNew = file;
          vm.bankDetails.chequeLeaf = file.name;
          vm.chooseAFileNew = false;
        }
        else {
          MessageService.error("File size should not be more than 5 MB.")
          vm.chooseAFileNew = true;
        }
      }

    }

    function uploadChequeLeafFileOld(file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if(file){
        if (file.size <= 5000000) {
          vm.fileOld = file;
          vm.bankDetails.chequeLeafOld = file.name;
          vm.chooseAFileOld = false;
        }
        else {
          MessageService.error("File size should not be more than 5 MB.");
          vm.chooseAFileOld = true;
        }
      }

    }

    function breakFileUrl(url,type) {
      url = url.replace(/ /g,'');
      var a, extension;
      if(url.split('.jp').length > 1){
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if(url.split('.png').length > 1){
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if(url.split('.pdf').length > 1){
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if(url.split('.bmp').length > 1){
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      } else if(url.split('.tiff').length > 1){
        extension = '.tiff';
        a = url.split('.tiff')[0].split('/');
      }

      if(angular.isUndefined(extension)){
        MessageService.error("Given cheque Leaf file type is not allowed, Pleaese provide a different file type.")
        vm.chequeLeafUrl = "";
      }else{
        if(type === 'add'){
          vm.chequeLeafUrlNew = a[a.length-1]+extension;
          vm.chooseAFileNew = false;
        }
        else if(type === 'modify'){
          vm.chequeLeafUrlOld = a[a.length-1]+extension;
          vm.chooseAFileOld = false;
        }
      }

    }

    function openUploadedDoc() {
      // window.open(vm.payload.bankDetails.chequeLeaf);
      if(angular.isUndefined(vm.payload.bankDetails.chequeLeaf)){return;}
      ModalService.showImage({docUrl: vm.payload.bankDetails.chequeLeaf});
    }

    function openUploadedDocOld() {
      // window.open(vm.payload.bankDetails.chequeLeafOld);
      if(angular.isUndefined(vm.payload.bankDetails.chequeLeafOld)){return;}
      ModalService.showImage({docUrl: vm.payload.bankDetails.chequeLeafOld});
    }

    function changeBank() {
      vm.payload.bankName = $window.JSON.parse(vm.selectedBank).bankName;
      vm.payload.bankRGTSCode = $window.JSON.parse(vm.selectedBank).bankCode;

      if(vm.payload.bankRGTSCode==='HDF'){
       vm.payload.payoutMechanism = 'DC';
      } else vm.payload.payoutMechanism = null;
    }

    function changeBankSubmit() {
      if(vm.fileNew.type!=vm.fileOld.type){
        MessageService.error("Both Bank Proofs must be of same file extensions");
      } else {
        changeBankSuccessful();
      }
    }

    vm.changeBankSuccessful = changeBankSuccessful;

    function changeBankSuccessful(){
      var success = function (res) {
        LoaderService.hideLoader();
        if(res.status){
          var successModal= function () {

          }, errorModal = function () {

          };
          ModalService.changeBankSuccessModal(vm.payload, successModal, errorModal);
        }
        else{
          MessageService.error(res.message)
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        $log.info(err);
        UtilService.errorHandler(err);
      };
      $log.info(vm.payload);
      $log.info(vm.fd);
      vm.fd = new FormData();
      vm.fd.append('bankCO',$window.JSON.stringify(vm.payload));
      /*var files = [vm.fileNew,vm.fileOld];
       vm.fd.append('proofs', files);*/
      vm.fd.append('newBankProof', vm.fileNew);
      vm.fd.append('oldBankProof', vm.fileOld);
      LoaderService.showLoader();
      InvestorFileUploadService.post({child1:'folio',child2:'bank',child3:'add'},vm.fd).$promise.then(success,error);
    }

    function back() {
      $state.go('main.profile.folioDetails');
      localStorage.setItem('isBack',true);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AddBankController', addBankController);

  /** @ngInject */
  function addBankController($window, ModalService, LoaderService, HDFC_API, $http, MessageService, UtilService, InvestorService, AppConstants, InvestorFileUploadService, AuthService, $log, $state ,dynamicData) {
    var vm = this;
    vm.init = init;
    vm.addBankSuccessful = addBankSuccessful;
    vm.fetchBankList = fetchBankList;
    vm.getPayoutMechanism = getPayoutMechanism;
    vm.getAccountType = getAccountType;
    vm.copyPasteHandler = copyPasteHandler;
    vm.accFocus = accFocus;
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.uploadChequeLeafFileOld = uploadChequeLeafFileOld;
    vm.breakFileUrl = breakFileUrl;
    vm.openUploadedDoc = openUploadedDoc;
    vm.openUploadedDocOld = openUploadedDocOld;
    vm.back = back;
    vm.setHeader = setHeader;
    vm.addBankSubmit = addBankSubmit;
    vm.validatePennyDropDetails = validatePennyDropDetails;
    vm.hideWhenPennyDrop = false;
    vm.disableAccntDetails = false;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.bankList = null;
    vm.chooseAFileNew = true;
    vm.chooseAFileOld = true;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.chequeLeafUrl = '';
    vm.chequeLeafUrlOld = '';
    vm.payload = {makeDefaultBank: false};
    vm.isCheckedCobmTandC = false;
    var identifierData = AuthService.getToken();
    vm.payload.pennyDropValid = false;
    vm.selectIFSC = selectIFSC;
    vm.seletedIFSC ='';
    var pennyDropEnablSelectedBank = false;
    vm.tpv = tpv;
    vm.dynamicData = dynamicData;
    vm.showTerms = true;
    if (vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK) {
      vm.note = vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK.content;
    }
    if (vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK_LIST) {
      vm.noteBankRestrict = vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK_LIST.content;
    }
    if(!dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_ADD_NEWBANK) {
      vm.showTerms = false;
    }
    function tpv(event) {
      event.preventDefault();
      ModalService.tpvModal({});
    }
    function selectIFSC() {
      var successModal = function(data){
        vm.payload.accountNumber= null;
        vm.verifyAccountNumber= null;
        //vm.payload.payoutMechanism= null;
        vm.payload.ifsccode= data.ifscCode;
        vm.payload.bankName = data.bankName;
        vm.selectedBank = data.bankName;
        if(data.branch && data.branch.length>40){
          vm.payload.bankBranch = data.branch.slice(0,40);
        }else {
          vm.payload.bankBranch = data.branch;
        }
        vm.payload.bankCity = data.branchCity;
        if (data.pennyDropEnabled && vm.folioTaxStatusCode ==="01") {
          vm.payload.pennyDropValid = true;
        }
        else {
          vm.payload.pennyDropValid = false;
        }
        pennyDropEnablSelectedBank = vm.payload.pennyDropValid;
        resetCheckLeaf();
      };
      var errorModal = function(){
      };
      ModalService.IFSCSelectionModal({bankList : vm.bankList, constraints: vm.constraints}, successModal, errorModal);
    }

    function addBankSubmit() {
      if(vm.fileNew.type!==vm.fileOld.type){
        MessageService.error("Both Bank Proofs must be of same file extensions");
      } else {
        addBankSuccessful();
      }
    }

    function resetCheckLeaf() {
      vm.fileNew = "";
      vm.bankDetails.chequeLeaf = "";
      vm.chooseAFileNew = true;
      angular.element("#uploadCheckLeafNew").val("");
    }


    function addBankSuccessful() {
      var success = function (res) {
        LoaderService.hideLoader();
        if (res.status) {
          var successModal = function () {
            $state.go('main.profile.folioDetails');
          }, errorModal = function () {};
          ModalService.addBankModal({ modalPayload: vm.payload, requestType: 'add' }, successModal, errorModal);
        } else {
          if(res.popupEnabled) {
            ModalService.genericModal({
              text: res.message
            }, function () {
              $state.go('main.profile.folioDetails');
            } , function () {});
          } else {
            MessageService.error(res.message);
          }
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        $log.info(err);
        UtilService.errorHandler(err);
      };
      vm.fd = new FormData();
      var tempFormdata = angular.copy(vm.payload);
      delete tempFormdata.bankDetails;
      vm.fd.append('bankCO', $window.JSON.stringify(tempFormdata));
      vm.fd.append('newBankProof', vm.fileNew);
        vm.fd.append('oldBankProof', vm.fileOld);
      LoaderService.showLoader();
      InvestorFileUploadService.post({
        child1: 'folio',
        child2: 'bank',
        child3: 'add'
      }, vm.fd).$promise.then(success, error);
    }

    function init() {
      $window.scrollTo(0, 0);
      setHeader();
      fetchBankList();
      getPayoutMechanism();
      getAccountType();
      vm.constraints = angular.fromJson($window.sessionStorage.getItem('bankConstraints'));
    }

    function validatePennyDropDetails() {
      var profile = AuthService.getToken();
      var pennyDropValidatePayload = {
        "beneficiaryIFSC":vm.payload.ifsccode,
        "benificiaryAccountNo":vm.payload.accountNumber,
        "benificiaryName":profile.investorFullName,
        "folioNo": vm.payload.folioNumber
      };
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if(resp.data.valid === false) {
              if (vm.constraints.isFromProfile && !vm.constraints.uploadChequeLeafEnabled) {
                if (resp.data.cobmMessage && angular.isDefined(resp.data.cobmMessage)) {
                  MessageService.error(resp.data.cobmMessage);
                } else {
                  MessageService.error(resp.data.message || "We are unable to validate your bank account using IMPS service. Please upload cheque leaf to continue with add bank");
                }
              } else {
                MessageService.error(resp.data.message || "We are unable to validate your bank account using IMPS service. Please upload cheque leaf to continue with add bank");
              }
              vm.payload.pennyDropValid = vm.constraints.uploadChequeLeafEnabled ? false : true;
            } else {
              vm.payload.pennyDropValid = true;
              vm.disableAccntDetails = true;
              vm.payload.accountHolderName = resp.data.name;
              addBankSuccessful();
            }
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };

      InvestorService.post({
        child1: 'account',
        child2: 'validate',
        child3: 'pennyDrop'
      }, pennyDropValidatePayload).$promise.then(success, error);

    }

    function fetchBankList() {
      LoaderService.showLoader();
      var success = function (res) {
        LoaderService.hideLoader();
        if (res.status && res.data) {
          vm.bankList = res.data.bankList;
        }
        else {
          vm.bankList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        vm.bankList = null;
        UtilService.errorHandler(err);
      };

      InvestorService.get({child1: 'rbi', child2: 'bankNames'}).$promise.then(success, error);
    }

    function getPayoutMechanism() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payoutMechanismList = resp.data.payoutMechanisms;
             resp.data.payoutMechanisms.map(function(pm){
              if(pm.payoutCode=="DC"){
                vm.payload.payoutMechanism = pm.payoutCode;
              }
            });
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'payout-mechanism', child3: 'cobm'}).$promise.then(success, error);
    }

    function getAccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
            if (vm.bankTypeList.length && vm.bankTypeList.length > 0) {
              var sbAccount = resp.data.bankAccountTypes.filter(function(e) { return e.accountTypeCode === vm.validateData.SAVING_ACCOUNT; })
              vm.payload.accountType = sbAccount[0].accountTypeCode?sbAccount[0].accountTypeCode:''
              //to set the default value of account type field when saving account only as per the requirement
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };

      InvestorService.post({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list'
      },{invTypeDesc:vm.folioTaxStatus}).$promise.then(success, error);
    }

    function setHeader() {
      var profile = identifierData;
      vm.MainFolioParent = {};
      vm.MainFolioParent.panNumber = profile.investorPAN;
      vm.MainFolioParent.firstName = profile.investorFName;
      vm.MainFolioParent.lastName = profile.investorLName;
      vm.payload.accountHolderName = profile.investorFullName;
      vm.MainFolioParent.uuid = localStorage.getItem('folioId');
      vm.folioNumberToDisplay = localStorage.getItem('folioId');
      vm.folioTaxStatus = localStorage.getItem('folioTaxStatus');
      vm.folioTaxStatusCode = localStorage.getItem('folioTaxStatusCode');
      vm.payload.pennyDropValid = vm.folioTaxStatusCode==='01'?true:false;
      vm.payload.folioNumber = localStorage.getItem('folioId');
      vm.MainFolioParent.currentState = 'main.profile.addBank';
      vm.bankDetails = $window.JSON.parse(localStorage.getItem('bankDetails'));
      vm.oldBankName = vm.bankDetails && vm.bankDetails[0] && vm.bankDetails[0].bankName;
    }

    function copyPasteHandler(e) {
      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : (key === 17);

      if (key === 86 && ctrl) {
        e.preventDefault();
      } else if (key === 67 && ctrl) {
        e.preventDefault();
      }
    }

    function accFocus() {
      vm.accModelDirty = true;
      vm.chooseAFileNew = true;
      vm.bankDetails.chequeLeaf='';
      vm.bankDetails.chequeLeafUrlNew='';
      angular.element("#uploadCheckLeafNew").val("");
      if(pennyDropEnablSelectedBank){
        vm.payload.pennyDropValid = true;
      }
    }

    function uploadChequeLeafFile(file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          vm.fileNew = file;
          vm.bankDetails.
            chequeLeaf = file.name;
          vm.chooseAFileNew = false;
        }
        else {
          MessageService.error("File size should not be more than 2 MB.");
          vm.chooseAFileNew = true;
        }
      }

    }

    function uploadChequeLeafFileOld(file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          vm.fileOld = file;
          vm.bankDetails.chequeLeafOld = file.name;
          vm.chooseAFileOld = false;
        }
        else {
          MessageService.error("File size should not be more than 2 MB.");
          vm.chooseAFileOld = true;
        }
      }

    }

    function breakFileUrl(url, type) {
      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      if (type === 'add') {
        vm.chequeLeafUrlNew = a[a.length - 1] + extension;
        vm.chooseAFileNew = false;
      }
      else if (type === 'modify') {
        vm.chequeLeafUrlOld = a[a.length - 1] + extension;
        vm.chooseAFileOld = false;
      }

    }

    function openUploadedDoc() {
      if(angular.isUndefined(vm.fileNew)){return;}
      ModalService.showImage({docUrl: vm.fileNew});
    }

    function openUploadedDocOld() {
      if(angular.isUndefined(vm.fileOld)){return;}
      ModalService.showImage({docUrl: vm.fileOld});
    }

    function back() {
      $state.go('main.profile.folioDetails');
      localStorage.setItem('isBack',true);
    }


    vm.showCobmTermConditions = function () {
      ModalService.nonTransactionalTncModal({type:'COBM',dynamicTransactionData:vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_ADD_NEWBANK});
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('folioFormData', folioFormData);

  /*@ngInject*/
  function folioFormData($timeout, AuthService, MessageService, InvestorService, AppConstants, InvestorFolioModel, LoaderService, $stateParams,UtilService, $window, $state, InvestorFileUploadServiceV3,$log, InvestorServiceV3, ModalService,DownloadPdfService,FileSaver,moment, InvestorServiceV2) {
    return {
      restrict: 'E',
      scope: {
        holders: '=' ,
        mainFolioParent: '=',
        firstFlow: '@',nomineesResp:'=',ekycEmail:'=',ekycMobile:'=',ekycEmailBelongsTo:'=',ekycMobileBelongsTo:'='},
      templateUrl: 'app/investor/addFolio/folio-directive/soleApplicant/folio-soleApplicant-directive.html',
      link: function (scope) {
        scope.holders={};
        scope.dirData = {};
        scope.CONST = {};
        // scope.fatcaArray = [];
        scope.CONST.POLITICAL_STATUS = AppConstants.INVESTOR_POLITICAL_STATUS;
        scope.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
        scope.pattern = AppConstants;
        scope.genderList = [{name: 'Male', value: 'MALE'}, {name: 'Female', value: 'FEMALE'}];
        scope.relationshipList = [{name: 'Father', value: 'FATHER'}, {name: 'Mother', value: 'MOTHER'}, {
          name: 'Sibling',
          value: 'SIBLING'
        }, {name: 'Other', value: 'OTHER'}];
        scope.relationshipDoc = null;
        scope.minorAgeDoc = null;
        scope.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
        scope.defaultDob = $window.moment().toString();
        scope.minDate = moment().subtract(1, 'years').format("DD-MMM-YYYY").toString();
        var token = AuthService.getToken();
        scope.hufUserFlag = token.hufUserFlag;
        scope.restrictHufUser = restrictHufUser;
        scope.hufToContinue = true;
        scope.isDreamSip = $window.JSON.parse(localStorage.getItem('isDreamSip'))? $window.JSON.parse(localStorage.getItem('isDreamSip')):false;
        // var masterPayload = {};
        scope.$watch('holders', function () {
          if(Object.keys(scope.holders).includes('minor')) {
            scope.getTaxStatusList()
          }
          if (scope.holders.grossAnnualIncome) {
            scope.holders.netWorth = '';
            $window.NumToWord(scope.holders.netWorth, 'DisplayWordsTaxAmt', scope.holders);
          }
         /* scope.dirData.holders = scope.holders;*/
        });
        scope.editContactDetails = editContactDetails;
        scope.cancelEditAction = cancelEditAction;
        scope.changeValue = changeValue;
        scope.showOtpModal = showOtpModal;
        scope.generateContactUpdateOtp = generateContactUpdateOtp;
        scope.showEmailEditField = false;
        scope.showMobileEditField = false;
        scope.isEmailEdited = false;
        scope.isMobileEdited = false;
        scope.soleApplicantEditedMobile = null;
        scope.soleApplicantEditedEmail = null;
        scope.isContactDetailUpdated = false;

        scope.setMinorFlag = function () {
          var minorVal = scope.holders.minor;
          if (minorVal) {
            scope.mainFolioParent &&  (scope.mainFolioParent.isSoleApplicantMinor = true);
          } else {
            scope.mainFolioParent && (scope.mainFolioParent.isSoleApplicantMinor = false) ;
          }
          scope.holders = InvestorFolioModel.getNewInvestorFolioFormDataModel();
          scope.holders.holdmode = scope.mainFolioParent && (scope.mainFolioParent.holdmode);
          scope.holders.minor = minorVal;
          scope.holders.bankDetails = {};
          scope.nomineesResp = scope.nomineesResp||[];
          scope.ageProofDocUrl = '';
          scope.relationshipDocUrl = '';
          scope.getTaxStatusList();
          scope.holders.politicalStatus = scope.CONST.POLITICAL_STATUS.NONE;
        };

        scope.changedTaxStatus = function () {
          if(scope.holders.taxStatusCode == '21' || scope.holders.taxStatusCode == '24'){
            scope.holders.payTaxInIndia = false;
            scope.changePayTaxOutsideIndiaStatus(true);
          }
          else {
            if(scope.holders && scope.holders.fatcaArray && scope.holders.fatcaArray.length>0
            && angular.isDefined(scope.holders.fatcaArray[0].taxId)){
              scope.holders.payTaxInIndia = angular.isDefined(scope.holders.payTaxInIndia) ? scope.holders.payTaxInIndia : true;
            }else{
              scope.holders.payTaxInIndia = true;
            }
          }
          scope.restrictHufUser();
        };

        scope.changedMinorTaxStatus = function () {
          if(scope.holders.taxStatusCode == '02'){
            scope.holders.payTaxInIndia = true;
            scope.changePayTaxOutsideIndiaStatus(false);
          }
          else {
            if(scope.holders && scope.holders.fatcaArray && scope.holders.fatcaArray.length>0
            && angular.isDefined(scope.holders.fatcaArray[0].taxId)){
              scope.holders.payTaxInIndia = angular.isDefined(scope.holders.payTaxInIndia) ? scope.holders.payTaxInIndia : true;
            }else{
              scope.holders.payTaxInIndia = true;
            }
          }
        };

        scope.getTaxStatusList = function () {
          if (scope.holders.minor) {
            var data = {taxStatusFilter: 'MINOR'};
          } else {
            data = {taxStatusFilter: 'ADULT'};
          }

          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.dirData.taxStatusList = resp.data.taxStatus;
              if(angular.isUndefined(scope.holders.taxStatusCode)
              || (scope.dirData.taxStatusList.length >0 && scope.holders.taxStatusCode != '' &&
                  scope.dirData.taxStatusList.map(function (ele) {
                    return ele.taxStatusCode;
                  }).indexOf(scope.holders.taxStatusCode) === -1)){
                scope.holders.taxStatusCode= scope.dirData.taxStatusList.length && scope.dirData.taxStatusList.length >0
                  ?scope.dirData.taxStatusList[0].taxStatusCode //to select the first element in the list
                  :'';
                scope.changedTaxStatus();
              }
            } else {
              scope.dirData.taxStatusList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.dirData.taxStatusList = null;
          };
          InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
        }


        function restrictHufUser() {
          if (scope.hufUserFlag && scope.holders.taxStatusCode === '01') {
            scope.hufToContinue = false;
            ModalService.genericModal({
              text: scope.validations.RESTRICT_HUF
            });
          }
          else {
            scope.hufToContinue = true;
          }
        }


        scope.getInvestorOccupationList = function () {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.dirData.occupationList = resp.data.investorOccupations;
            } else {
              scope.dirData.occupationList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.dirData.occupationList = null;
          };
          InvestorService.get({child1: 'folio', child2: 'occupation'}).$promise.then(success, error);
        }


        scope.incomeSlab = function () {
          var success = function (resp) {
              if (resp.status && resp.data) {
                scope.dirData.incomeSlabList = resp.data.incomeSlabList;
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
            };

          InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success, error);
        }

        function setSelectedResidency(payload) {
          if (payload.soleApplicantDetail.minorDetail &&
            payload.soleApplicantDetail.minorDetail.guardian && !payload.soleApplicantDetail.minorDetail.guardian.fatca) {
            payload.soleApplicantDetail.minorDetail.guardian.fatca = {};
          }
          var fatca = payload.soleApplicantDetail.minorDetail.guardian.fatca;

          delete fatca.fatcaTax1;
          delete fatca.fatcaTax2;
          delete fatca.fatcaTax3;

          if (payload.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia) {
            return;
          }

          if (angular.isDefined(scope.holders.fatcaArray[0])) {
            fatca.fatcaTax1 = scope.holders.fatcaArray[0];
          }

          if (angular.isDefined(scope.holders.fatcaArray[1])) {
            fatca.fatcaTax2 = scope.holders.fatcaArray[1];
          }

          if (angular.isDefined(scope.holders.fatcaArray[2])) {
            fatca.fatcaTax3 = scope.holders.fatcaArray[2];
          }

        }

        function setSelectedResidencySelf(payload) {
          if (payload.soleApplicantDetail.selfDetail
            && !payload.soleApplicantDetail.selfDetail.fatca) {
            payload.soleApplicantDetail.selfDetail.fatca = {};
          }
          var fatca = payload.soleApplicantDetail.selfDetail.fatca;

          delete fatca.fatcaTax1;
          delete fatca.fatcaTax2;
          delete fatca.fatcaTax3;

          if (payload.soleApplicantDetail.selfDetail.fatca.payTaxInIndia) {
            return;
          }

          if (angular.isDefined(scope.holders.fatcaArray[0])) {
            fatca.fatcaTax1 = scope.holders.fatcaArray[0];
          }

          if (angular.isDefined(scope.holders.fatcaArray[1])) {
            fatca.fatcaTax2 = scope.holders.fatcaArray[1];
          }

          if (angular.isDefined(scope.holders.fatcaArray[2])) {
            fatca.fatcaTax3 = scope.holders.fatcaArray[2];
          }

        }


        function breakFileUrl(url) {
          if(!url){return;}
          scope.holders.minorAgeProof = 'Preview Uploaded Doc';
          scope.chooseAFile = false;
          return;
        }

        scope.uploadMinorDobFile = function (file) {
          if (scope.mimeType.indexOf(file.type) == -1) {
            MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
            return;
          }
          if (file) {
            if (file.size <= 2000000) {
              var success = function (resp) {
                  LoaderService.hideLoader();
                  if (resp.status && resp.data) {
                    scope.holders.minorAgeProofUrl = resp.data.fileUrl;
                    scope.holders.id = resp.data.uuid;
                    scope.holders.minorProofFileType=resp.data.type?resp.data.type.toLowerCase():resp.data.fileUrl.split('_').reverse()[0].toLowerCase();
                    localStorage.setItem('folioId', resp.data.uuid);
                    breakFileUrl(resp.data.fileUrl);
                    //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
                  }
                  else {
                    scope.holders.minorProofFileType="";
                    MessageService.error(resp.message);
                  }
                },
                error = function () {
                  scope.chooseAFile = true;
                  LoaderService.hideLoader();
                };

              if (file) {
                LoaderService.showLoader();
                var fd = new FormData();
                fd.append('file', file);

                // DistributorProfileUploadService.post({
                var uuid = '';
                if ($stateParams.investorId) {
                  uuid = $stateParams.investorId;
                } else if (localStorage.getItem('folioId')) {
                  uuid = localStorage.getItem('folioId');
                } else {
                  uuid = 'null';
                }

                InvestorFileUploadServiceV3.post({
                  child1: 'folio',
                  child2: 'upload',
                  child3: 'minor',
                  child4: 'ageProof',
                  child5: uuid
                }, fd).$promise.then(success, error);
              }
            }
            else {
              MessageService.error("File size should not be more than 2 MB.")
            }
          }

        }

        scope.changeFile = function (file) {
          if(file === 'relation'){
            scope.holders.minorRelationshipProofUrl = null;
            scope.holders.relationShipProofFileType = null;
          } else {
            scope.holders.minorAgeProofUrl = null;
            scope.holders.minorProofFileType = null;
          }
        }

        scope.uploadMinorRelationshipFile = function (file) {
          if (scope.mimeType.indexOf(file.type) == -1) {
            MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
            return;
          }
          if (file) {
            if (file.size <= 2000000) {
              var success = function (resp) {
                  LoaderService.hideLoader();
                  if (resp.status && resp.data) {
                   scope.holders.minorRelationshipProofUrl = resp.data.fileUrl;
                    scope.holders.id = resp.data.uuid;
                    scope.holders.relationShipProofFileType=resp.data.type?resp.data.type.toLowerCase():resp.data.fileUrl.split('_').reverse()[0].toLowerCase();
                    localStorage.setItem('folioId', resp.data.uuid);

                    scope.breakRelationshipFileUrl(resp.data.fileUrl);
                    //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
                  }
                  else {
                    scope.chooseARelationshipFile = true;
                    scope.holders.relationShipProofFileType="";
                    MessageService.error(resp.message);
                  }
                },
                error = function () {
                  LoaderService.hideLoader();
                };

              if (file) {
                LoaderService.showLoader();
                var fd = new FormData();
                fd.append('file', file);

                var uuid = '';
                if ($stateParams.investorId) {
                  uuid = $stateParams.investorId;
                } else if (localStorage.getItem('folioId')) {
                  uuid = localStorage.getItem('folioId');
                } else {
                  uuid = 'null';
                }

                // DistributorProfileUploadService.post({
                InvestorFileUploadServiceV3.post({
                  child1: 'folio',
                  child2: 'upload',
                  child3: 'minor',
                  child4: 'relationshipProof',
                  child5: uuid
                }, fd).$promise.then(success, error);
              }
            }
            else {
              MessageService.error("File size should not be more than 2 MB.")
            }
          }

        };

        scope.downloadFile = function (url, fileType, proofType) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.data) {
                var data = new Blob([resp.data], { type: 'application/'+fileType });
                FileSaver.saveAs(data, proofType+'.'+fileType);
              } else {
                MessageService.error('No Data Available');
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
          LoaderService.showLoader();
          var payload = {};
          DownloadPdfService.downloadFile(payload, fileType, url).then(success, error);
        }

        scope.breakRelationshipFileUrl = function (url) {
          if(!url){return;}
          scope.holders.minorRelationshipProof = 'Preview Uploaded Doc';
          scope.chooseARelationshipFile = false;
          return;
          /*url = url.replace(/ /g, '');
          var a, extension;
          if (url.split('.jp').length > 1) {
            extension = '.jpg';
            a = url.split('.jp')[0].split('/');
          } else if (url.split('.png').length > 1) {
            extension = '.png';
            a = url.split('.png')[0].split('/');
          } else if (url.split('.pdf').length > 1) {
            extension = '.pdf';
            a = url.split('.pdf')[0].split('/');
          } else if (url.split('.bmp').length > 1) {
            extension = '.bmp';
            a = url.split('.bmp')[0].split('/');
          }

          scope.holders.minorRelationshipProof = a[a.length - 1] + extension;
          scope.holders.minorRelationshipProof =  scope.holders.minorRelationshipProof.replace(new RegExp('%20', 'g'), '-');
          scope.chooseARelationshipFile = false;*/

        }

          scope.getSoleApplicantPayload = function () {
          var a = scope.holders;
          var payload = {
            /*"soleApplicantDetail": {
              "personalDetail": {
                "firstName": a.firstName,
                "lastName": "",
                "dateOfBirth": a.dateOfBirth,
                "email": ""
              },
              "selfDetail":{
                "taxStatusCode": a.taxStatusCode,
                "fatcaAddressType": a.fatcaAddressType,
                "occupation": a.occupation,
                "panNumber": scope.mainFolioParent.panNumber,
                "grossAnnualIncome": a.grossAnnualIncome || "",
                "netWorth": a.netWorth || "",
                "netWorthDate": a.netWorthDate || "",
                "politicalStatus": a.politicalStatus,
                "fatca":{
                  "birthCity": a.birthCity,
                  "birthCountry": a.birthCountry,
                  "payTaxInIndia": a.payTaxInIndia,
                  "payOutsideIndiaAddresses": a.payOutsideIndiaAddresses
                },
               },
              "minor": a.minor
            },*/
            "soleApplicantDetail": {
              /*"minorDetail": {
                "minorAgeProof": null,
                "minorRelationshipProof": null,
                "guardian": {
                  "panNumber": null,
                  "occupation": null,
                  "taxStatusCode": null,
                  "grossAnnualIncome": null,
                  "politicalStatus": null,
                  "netWorth": null,
                  "netWorthDate": null,
                  "kycVerified": null,
                  "name": null,
                  "gender": null,
                  "panValid": null,
                  "relation": null,
                  "fatca": {
                    "birthCountry": null,
                    "birthPlace": null,
                    "countryCitizenship": null,
                    "payTaxInIndia": false,
                    "addressType": null,
                    "fatcaTax1": {
                      "taxPayingCountry": null,
                      "taxPayingCity": null,
                      "taxIdNumber": null,
                      "taxId": null,
                      "taxIdType": null
                    },
                    "fatcaTax2": {
                      "taxPayingCountry": null,
                      "taxPayingCity": null,
                      "taxIdNumber": null,
                      "taxId": null,
                      "taxIdType": null
                    },
                    "fatcaTax3": {
                      "taxPayingCountry": null,
                      "taxPayingCity": null,
                      "taxIdNumber": null,
                      "taxId": null,
                      "taxIdType": null
                    }
                  },
                  "guardianRelationshipProofUrl": null
                }
              },*/
              "selfDetail": {
                "panNumber": scope.mainFolioParent.panNumber,
                "occupation": a.occupation,
                "grossAnnualIncome": a.grossAnnualIncome || "",
                "politicalStatus": a.politicalStatus,
                "netWorth": a.netWorth || "",
                "netWorthDate": a.netWorthDate || "",
                "kycVerified": null,
                "fatca": {
                  "birthCountry": a.birthCountry,
                  "birthPlace": a.birthCity,
                  "payTaxInIndia": a.payTaxInIndia,
                  "addressType": a.fatcaAddressType,
                  "fatcaTax1": {
                    "taxPayingCountry": null,
                    "taxPayingCity": null,
                    "taxId": null,
                    "taxIdType": null
                  }/*,
                  "fatcaTax2": {
                    "taxPayingCountry": null,
                    "taxPayingCity": null,
                    "taxIdNumber": null,
                    "taxId": null,
                    "taxIdType": null
                  },
                  "fatcaTax3": {
                    "taxPayingCountry": null,
                    "taxPayingCity": null,
                    "taxIdNumber": null,
                    "taxId": null,
                    "taxIdType": null
                  }*/
                }
              },
              "personalDetail": {
                "firstName": a.firstName,
                "dateOfBirth": a.dateOfBirth,
                "gender": null,
                "taxStatusCode": a.taxStatusCode,
                "emailBelongsTo" : a.emailBelongsTo,
                "mobileBelongsTo": a.mobileBelongsTo,
              }
            },
            "jointHolders": [],
            "nominees": scope.nomineesResp || [],
            "holdmode": a.holdmode
          };
          if (a.hasOwnProperty('sebiNomineeRegulatory01650Active')) {
            payload.sebiNomineeRegulatory01650Active = a.sebiNomineeRegulatory01650Active;
          }
            setSelectedResidencySelf(payload);

          return payload;
        }

        scope.getGuardianPayload = function () {
          var a = scope.holders;
 /*         var payload = {
            "soleApplicantDetail": {
              "personalDetail": {
                "firstName": a.firstName,
                "lastName": "",
                "dateOfBirth": a.dateOfBirth,
                "email": "",
                "gender": a.gender
              },
            },
            "jointHolders": [],
            "nominees": [],
            "minorDetail":{
              "taxStatusCode": a.taxStatusCode,
              "minor": a.minor,
              "minorAgeProof": a.minorAgeProof,
              "minorRelationshipProof": a.minorRelationshipProof,
              "guardianDetail": {
                "fatca": {
                  "birthCountry": a.birthCountry,
                  "birthPlace": a.birthCity,
                  "addressType": a.fatcaAddressType,
                  "payTaxInIndia": a.payTaxInIndia
                },
                "occupationCode": a.occupation,
                "panNumber": scope.mainFolioParent && scope.mainFolioParent.panNumber,
                "income": a.grossAnnualIncome || "",
                "netWorth": a.netWorth || "",
                "netWorthDate": a.netWorthDate || "",
                "pepStatus": a.politicalStatus,
                "relation": a.relationship
              }
            }

          };*/
          var payload = {
            "holdmode":a.holdmode,
            "soleApplicantDetail": {
              "minorDetail": {
                "minorAgeProof": a.minorAgeProofUrl||a.minorAgeProof,
                "minorRelationshipProof": a.minorRelationshipProofUrl||a.minorRelationshipProof,
                "minorRelationshipProofType": a.minorRelationshipProofType,
                "minorProofType": a.minorProofType,
                "guardian": {
                  "panNumber": a.panNumber,
                  "occupation": a.occupation,
                  "grossAnnualIncome": a.grossAnnualIncome,
                  "politicalStatus": a.politicalStatus,
                  "netWorth": a.netWorth,
                  "netWorthDate": a.netWorthDate,
                  "kycVerified": null,
                  "name": a.guardianName,
                  "relation": a.relationship,
                  "fatca": {
                    "birthCountry": a.birthCountry,
                    "birthPlace": a.birthCity,
                    "countryCitizenship": null,
                    "payTaxInIndia": a.payTaxInIndia,
                    "addressType": a.fatcaAddressType,
                    "fatcaTax1": {
                      "taxPayingCountry": null,
                      "taxPayingCity": null,
                      "taxId": null,
                      "taxIdType": null
                    }
                  },
                  "guardianRelationshipProofUrl": null
                }
              },
              "selfDetail": null,
              "personalDetail": {
                "firstName": a.firstName,
                "dateOfBirth": a.dateOfBirth,
                "gender":a.gender,
                "taxStatusCode": a.taxStatusCode,
                "emailBelongsTo" : a.emailBelongsTo,
                "mobileBelongsTo": a.mobileBelongsTo,
              }
            }
          };

          /*Need to be changes*/
          // payload.soleApplicantDetail.minorDetail.minorRelationshipProof = "http://res.cloudinary.com/hdfcmf/image/upload/v1542269420/local/EHWPSO933K/AgeProof/Screenshot%20from%202018-11-13%2015-02-16.png";

          setSelectedResidency(payload);
          return payload;
        }

        scope.getTaxIdTypeList = function () {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.dirData.taxIdTypeList = resp.data.taxIdTypeResponses;
            } else {
              scope.dirData.taxIdTypeList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.dirData.taxIdTypeList = null;
          };
          InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success, error);
        }

        scope.getCountryList = function () {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.dirData.countryList = resp.data.countries;
              if (scope.dirData.countryList.length > 0 && !scope.holders.birthCountry) {
                scope.dirData.countryList.map(function(countries) {
                  if (countries.countryCode === 'IN') {
                    scope.holders.birthCountry = countries.countryCode;
                  }
                });
              }
            } else {
              scope.dirData.countryList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.dirData.countryList = null;
          };
          InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
        }

        scope.filterProofList = function(listType) {
          return function (item) {
            if(listType === 'relationship')
              return item.validRelationProof;
            else
              return item.validMinorProof;
          };
        }

        scope.getProofTypeList = function () {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.dirData.proofList = resp.data.proofTypeDTOList;
            } else {
              scope.dirData.proofList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.dirData.proofList = null;
          };
          InvestorService.get({child1: 'folio', child2: 'proof' , child3: 'type'}, null).$promise.then(success, error);
        }

        scope.getAddressType = function () {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.dirData.addressTypeList = resp.data.addressTypeResponses;
              if (scope.dirData.addressTypeList.length > 0 && !scope.holders.fatcaAddressType) {
                scope.dirData.addressTypeList.map(function(addressTypeResponses) {
                  if (addressTypeResponses.value === 'RESIDENTIAL') {
                    scope.holders.fatcaAddressType = addressTypeResponses.value;
                  }
                });
              }
            } else {
              scope.dirData.addressTypeList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.dirData.addressTypeList = null;
          };
          InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success, error);
        }

        scope.continueFolio = function (stateToMove) {
          LoaderService.showLoader();
          if (scope.holders.minor) {
            var payload = scope.getGuardianPayload();
            payload.minor = scope.holders.minor;
          } else {
            payload = scope.getSoleApplicantPayload();
          }
          if(scope.holders.jointHolders && scope.holders.jointHolders.length>0){
            payload.jointHolders = scope.holders.jointHolders;
          }
          // payload.holdmode = "SINGLE";//HARD CODED FROM BOTH END (FRONT N BACK END)

          if (payload) {
            payload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
            //payload.saveStep = 2;
            payload.folioSaveStep = "TWO";
            var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
            if (contactUpdateCo) {
              scope.isContactDetailUpdated = contactUpdateCo.isContactDetailUpdated;
            }
            if (scope.isContactDetailUpdated && payload.soleApplicantDetail && payload.soleApplicantDetail.personalDetail)  {
              payload.soleApplicantDetail.personalDetail.email = scope.soleApplicantEmailCopy;
              payload.soleApplicantDetail.personalDetail.mobileNo = scope.soleApplicantMobileCopy;
              /*payload.soleApplicantDetail.personalDetail.emailBelongsTo =  scope.holders.emailBelongsTo;
              payload.soleApplicantDetail.personalDetail.mobileBelongsTo = scope.holders.mobileBelongsTo;*/
              payload.soleApplicantDetail.personalDetail.isContactUpdated = scope.isContactDetailUpdated;
            } else {
              payload.soleApplicantDetail.personalDetail.email = scope.soleApplicantEmailCopy;
              payload.soleApplicantDetail.personalDetail.mobileNo = scope.soleApplicantMobileCopy;
            }
          }

          var success = function (resp) {
            if (resp.status && resp.data) {
              localStorage.setItem('folioId', resp.data.id);
              // masterPayload.soleApplicantDetail = angular.copy(scope.holders);
              InvestorFolioModel.setInvestorFolioModel(payload);
              $window.sessionStorage.investorForm = angular.toJson(payload);
              if (stateToMove) {
                // $scope.mainFolioParent.uuid = resp.data.id;
                LoaderService.hideLoader();
              if(!scope.isDreamSip){
                if ($stateParams.investorId||resp.data.id) {
                  // var id = $stateParams.investorId||resp.data.id;
                  $state.go(stateToMove, {investorId: $stateParams.investorId});
                } else {
                  $state.go(stateToMove);
                }
              }else{
                $state.go('main.folio.review',{investorId: $stateParams.investorId});
              }
              }else MessageService.success('Saved Successfully.');
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);
        }
        scope.saveFolio = function () {
          LoaderService.showLoader();
          if (scope.holders.minor) {
            var payload = scope.getGuardianPayload();
            payload.minor = scope.holders.minor;
          } else {
            payload = scope.getSoleApplicantPayload();
          }
          // payload.holdmode = "SINGLE";//HARD CODED FROM BOTH END (FRONT N BACK END)

          if (payload) {
            payload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
            //payload.saveStep = 2;
            payload.folioSaveStep = "TWO";
            payload.soleApplicantDetail.personalDetail.email = scope.soleApplicantEmail ? scope.soleApplicantEmail : null;
            payload.soleApplicantDetail.personalDetail.mobileNo = scope.soleApplicantMobile ? scope.soleApplicantMobile : null;
          }

          var success = function (resp) {
            if (resp.status && resp.data) {
              localStorage.setItem('folioId', resp.data.id);
              // masterPayload.soleApplicantDetail = angular.copy(scope.holders);
              InvestorFolioModel.setInvestorFolioModel(payload);
              $window.sessionStorage.investorForm = angular.toJson(payload);
                LoaderService.hideLoader();
                  MessageService.success('Saved Successfully.');
                  $state.go('welcome');
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          InvestorServiceV3.post({child1: 'folio', child2: 'save'}, payload).$promise.then(success, error);
        }

        scope.savePayload = function (stateToMove) {

          if (scope.holders.minor) {
            scope.payload = scope.getGuardianPayload();
          } else {
            scope.payload = scope.getSoleApplicantPayload();
          }
          scope.payload.saveStep = '1';
          var success = function (resp) {
              if (resp.status && resp.data) {
                localStorage.setItem('folioId',resp.data.id);$state.go(stateToMove);
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              $log.info('Occupation Errror>>>>', err);
            };

          if(scope.payload){
            scope.payload.id = scope.payload.id? scope.payload.id : null;
          }//fresh/folio/save
          // InvestorService.post({child1: 'folio', child2: 'newInvestorFolio'}, vm.payload).$promise.then(success, error);
          InvestorService.post({
            child1: 'fresh',
            child2: 'folio',
            child3: 'save'
          }, scope.payload).$promise.then(success, error);
        }


        scope.getInvestorOccupationList();
        scope.incomeSlab();
        scope.getAddressType();
        scope.getTaxIdTypeList();
        scope.getCountryList();
        scope.getProofTypeList();
//        $timeout(function () {
//          scope.getTaxStatusList();
//        },300);
        $timeout(function () {
          scope.fetchBelongsToDropdown();
        },300);

        // scope.addNewResidencyFields = function () {
        //
        //   scope.holders.fatcaArray.push(
        //     {
        //       "taxPayingCountry": '',
        //       "taxPayingCity": '',
        //       "taxIdType": '',
        //       "taxId": ''
        //     });
        // };

        scope.addMoreTaxResidency = function () {
          var array = scope.holders.fatcaArray || [];
          array.length < 4 ? array.push({}) : '';

        }

        scope.deleteTaxResidency = function (index) {
          scope.holders.fatcaArray.splice(index, 1);
        }


        scope.changeMinorDob = function (date) {
          if (!date) {
            scope.holders.defaultMinorDob = null;
            scope.holders.dateOfBirth = null;
            return;
          }
          scope.holders.defaultMinorDob = date.toString();
          scope.holders.dateOfBirth = date.clone().format('DD-MMM-YYYY').toString();
        }

        scope.changeStartDate = function (date) {
          if (!date) {
            return;
          }
          scope.holders.netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
        }


        scope.addNewResidencyFields = function () {
          if(angular.isUndefined(scope.holders.fatcaArray) || !angular.isArray(scope.holders.fatcaArray) ){
            scope.holders.fatcaArray = [];
          }
          scope.holders.fatcaArray.push(
            {
              "taxPayingCountry": '',
              "taxPayingCity": '',
              "taxIdType": '',
              "taxId": ''
            });
        };

        scope.changePayTaxOutsideIndiaStatus = function (status) {
          if (!status) {
            return;
          }
          if (scope.holders.minor) {
            if (scope.holders && (angular.isUndefined(scope.holders.fatcaArray)||scope.holders.fatcaArray.length === 0)) {
              scope.addNewResidencyFields();
            }
          }
          else {
            if (angular.isUndefined(scope.holders.fatcaArray) || scope.holders.fatcaArray.length === 0) {
              scope.addMoreTaxResidency();
            }
          }
        };

        scope.deleteTaxResidencyFromFatca = function (index) {
          scope.holders.fatcaArray.splice(index, 1);
        };

        scope.continue = function () {
          if (scope.holders.holdmode === scope.pattern.INVESTOR_HOLD_MODE.AOS) {
            if (scope.holders.minor) {
              var payload = scope.getGuardianPayload();
              payload.minor = scope.holders.minor;
            } else {
               payload = scope.getSoleApplicantPayload();
            }
            InvestorFolioModel.setInvestorFolioModel(payload);
            $window.sessionStorage.investorForm = angular.toJson(payload);

            if(scope.firstFlow === 'YES'){
              // $state.go('folioDetails.jointholders',{investorId:$stateParams.investorId});
              scope.continueFolio('folioDetails.jointholders',{investorId:$stateParams.investorId});
            }else{
              // $state.go('main.folio.jointholders',{investorId:$stateParams.investorId});
              scope.continueFolio('main.folio.jointholders',{investorId:$stateParams.investorId});
            }

          }else {
            if (scope.holders.minor) {
              if(scope.firstFlow === 'YES'){
                scope.continueFolio('folioDetails.bankDetails',{investorId:$stateParams.investorId});
              }else{
                scope.continueFolio('main.folio.bankdetails',{investorId:$stateParams.investorId});
              }
            } else {
              if(scope.firstFlow === 'YES'){
                scope.continueFolio('folioDetails.addNominee',{investorId:$stateParams.investorId});
              }else{
                scope.continueFolio('main.folio.nominee',{investorId:$stateParams.investorId});
              }
            }
          }
        };

        scope.back = function () {
          if(scope.firstFlow === 'YES'){
              $state.go('folioDetails.holdMode',{investorId:$stateParams.investorId});
          }else{
              $state.go('main.folio.holdmode',{investorId:$stateParams.investorId});
          }
        }

        scope.openUploadedDoc = function (fileUrl) {
          // window.open(fileUrl);
          if(angular.isUndefined(fileUrl)){return;}
          ModalService.showImage({docUrl: fileUrl});
        }

        scope.fetchBelongsToDropdown = function() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
              scope.soleApplicantEmailCopy = scope.ekycEmail;
              scope.soleApplicantMobileCopy = scope.ekycMobile;
              scope.soleApplicantEmail = contactUpdateCo && contactUpdateCo.isEmailEdited ? contactUpdateCo.soleApplicantEditedEmail : scope.ekycEmail;
              scope.soleApplicantMobile = contactUpdateCo && contactUpdateCo.isMobileEdited ? contactUpdateCo.soleApplicantEditedMobile : scope.ekycMobile;
              scope.holders.emailBelongsTo = scope.ekycEmailBelongsTo;
              scope.holders.mobileBelongsTo = scope.ekycMobileBelongsTo;
              scope.belongToListEmail = resp.data.emailList;
              scope.belongToListMobile = resp.data.mobileList;
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            $log.info('Belongs Dropdown error >>>>', err);
          };

          InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
        }

        function editContactDetails(contactInfo) {
          var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
          if (contactUpdateCo) {
            scope.isMobileEdited = contactUpdateCo.isMobileEdited;
            scope.isEmailEdited = contactUpdateCo.isEmailEdited;
          }
          if (contactInfo === "email") {
            if (scope.isMobileEdited) {
              MessageService.error("You can edit only one contact information at a time.");
              return;
            }
            scope.showEmailEditField = true;
            scope.showMobileEditField = false;
            if (scope.soleApplicantEmail) {
              scope.soleApplicantEditedEmail = scope.soleApplicantEmail;
            }
          } else if (contactInfo === 'mobile') {
            if (scope.isEmailEdited) {
              MessageService.error("You can edit only one contact information at a time.");
              return;
            }
            scope.showMobileEditField = true;
            scope.showEmailEditField = false;
            if (scope.soleApplicantMobile) {
              scope.soleApplicantEditedMobile = scope.soleApplicantMobile;
            }
          }
        }

        function cancelEditAction(contactInfo) {
          if (contactInfo === "email") {
            scope.showEmailEditField = false;
          } else if (contactInfo === 'mobile') {
            scope.showMobileEditField = false;
          }
        }

        function generateContactUpdateOtp(contactInfo) {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              showOtpModal(resp.data, contactInfo);
            } else {
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          var payload = {
            value: contactInfo === "email" ? scope.soleApplicantEditedEmail : scope.soleApplicantEditedMobile,
            fieldType: contactInfo.toUpperCase(),
            linkId: $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId'),
            flowName : "STANDALONE_FOLIO_CREATION"
          };
          InvestorServiceV2.post({
            child1: 'contact',
            child2: 'update',
            child3: 'send',
            child4: 'otp'
          }, payload).$promise.then(success, error);
        }

        function showOtpModal(modalPayload, contactInfo) {
          var confirmSuccess = function () {
            scope.isContactDetailUpdated = true;
            if (contactInfo === "email") {
              scope.isEmailEdited = true;
              scope.showEmailEditField = false;
              scope.soleApplicantEmail = scope.soleApplicantEditedEmail;
            }
            if (contactInfo === "mobile") {
              scope.isMobileEdited = true;
              scope.showMobileEditField = false;
              scope.soleApplicantMobile = scope.soleApplicantEditedMobile;
            }
            sessionStorage.setItem('contactUpdateCo', JSON.stringify({
              isEmailEdited: scope.isEmailEdited,
              isMobileEdited: scope.isMobileEdited,
              soleApplicantEditedEmail: scope.soleApplicantEditedEmail,
              soleApplicantEditedMobile: scope.soleApplicantEditedMobile,
              isContactDetailUpdated: scope.isContactDetailUpdated
            }));
          }, confirmError = function () {
            scope.isContactDetailUpdated = false;
            scope.isEmailEdited = false;
            scope.isMobileEdited = false;
          };
          ModalService.contactOtpModal(modalPayload, confirmSuccess, confirmError);
        }

        function changeValue(contactInfo, val) {
          if (contactInfo === "email") {
            scope.soleApplicantEditedEmail = val;
          } else if (contactInfo === 'mobile') {
            scope.soleApplicantEditedMobile = val;
          }
        }


      }
    }
  }



})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('folioReview', folioReview);

  /*@ngInject*/
  function folioReview(AuthService, MessageService, InvestorService, AppConstants, TransactionModel, InvestorFolioModel, LoaderService, $stateParams, UtilService, $window, $state, InvestorServiceV3, ModalService, InvestorFileUploadService, $rootScope) {
    return {
      restrict: 'E',
      scope: {bankPayload: '=', isSoleApplicantMinor: '=', firstFlow:'@',MainFolioParent:'='},
      templateUrl: 'app/investor/addFolio/folio-directive/review/folio-review-directive.html',
      link: function (scope) {

        scope.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        scope.IFSC_REGEX = AppConstants.ifsc_regex;
        scope.pattern = AppConstants;
        scope.accModelDirty = false;
        scope.reviewFormData = {};
        scope.reviewModalData = {};
        scope.accountType ={};
        scope.verifyAccountNumber ='';
        scope.chooseAFile = true;
        scope.uploadChequeLeafFile = uploadChequeLeafFile;
        scope.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp","application/pdf"];
        scope.chequeLeafUrl = '';
        scope.savePayload = savePayload;
        scope.selfDeclaration = selfDeclaration;
        scope.getCountryNameByCode = getCountryNameByCode;
        scope.getTaxStatusNameByCode = getTaxStatusNameByCode;
        scope.goToBack = goToBack;
        scope.editSoleApplicantForm = editSoleApplicantForm;
        var taxStatusCode = '';
        scope.dreamsipPayload = TransactionModel.getDreamSipPayloadRawData();
        scope.soleApplicantEmail = null;
        scope.soleApplicantEmailBelongsTo = null;
        scope.soleApplicantMobile = null;
        scope.soleApplicantMobileBelongsTo = null;
        scope.belongsToCode =  {
          SP : "Spouse" ,
          DP : "Dependent Parents",
          CD : "Custodian",
          SE : "Self",
          PO : "POA",
          DS : "Dependent Siblings",
          DC : "Dependent Children",
          GD : "Guardian"
        }
        scope.getRelationship = getRelationship;


        scope.init = function () {

          LoaderService.showLoader();
          // setHeader();
          scope.isDreamSip = $window.JSON.parse(localStorage.getItem('isDreamSip'))? $window.JSON.parse(localStorage.getItem('isDreamSip')):false;
          if(scope.isDreamSip && !scope.dreamsipPayload){
            localStorage.removeItem('isDreamSip');
            localStorage.removeItem('isFromFolio');
            $state.go('main.transactions.dreamSip');
          }
          getPayload(function (status) {
            if(status){
              //bankNameList();
              getTaxStatusList();
              getInvestorOccupationList();
              incomeSlab();
              getCountryList();
              getTaxIdTypeList();
              getAddressType();
              getAcccountType();
              getPayoutMechanism();
              getRelationship();
              if (scope.showNomineeUpdate) {
                getPersonalIdentifier();
              }
            }
          });
        };

        scope.init();

        function goToBack(goTo) {
        if(!scope.isDreamSip) {
           if(scope.firstFlow === 'YES'){
            if(angular.isDefined(goTo) && goTo != ''){
              $state.go(goTo,{investorId:$stateParams.investorId});
            }else{
              $state.go('folioDetails.bankDetails',{investorId:$stateParams.investorId});
            }
          }else{
            if(angular.isDefined(goTo) && goTo != ''){
              $state.go(goTo,{investorId:$stateParams.investorId});
            }else{
              $state.go('main.folio.bankdetails',{investorId:$stateParams.investorId});
            }
          }
        }else{
             localStorage.setItem('folioId',$stateParams.investorId);
            if(angular.isDefined(goTo) && goTo != ''){
              $state.go(goTo,{investorId:$stateParams.investorId});
            }else{
              localStorage.removeItem('isDreamSip');
              localStorage.setItem('isFromFolio','true');
              $state.go('main.transactions.dreamSip');
            }
          }


        }

        function editSoleApplicantForm() {

        }

        // function setHeader() {
        //   var profile = AuthService.getToken();
        //   scope.MainFolioParent.panNumber = profile.investorPAN;
        //   scope.MainFolioParent.firstName = profile.investorFName;
        //   scope.MainFolioParent.lastName = profile.investorLName;
        //   scope.MainFolioParent.currentState = 'main.folio.bankdetails';

        // }

        function getPayload(cb) {
          cb = cb || function () {};
          var success = function (resp) {
              if (resp.status && resp.data) {
            scope.accountType = Object.assign({}, resp.data.bankDetails);
                scope.reviewFormData = resp.data;
                // scope.MainFolioParent.holdmode = resp.data.holdmode;
                var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
                scope.soleApplicantEmail = contactUpdateCo && contactUpdateCo.isEmailEdited ? contactUpdateCo.soleApplicantEditedEmail : scope.reviewFormData.soleApplicantDetail.personalDetail.email;
                scope.soleApplicantEmailBelongsTo = scope.belongsToCode[scope.reviewFormData.soleApplicantDetail.personalDetail.emailBelongsTo];
                scope.soleApplicantMobile = contactUpdateCo && contactUpdateCo.isMobileEdited ? contactUpdateCo.soleApplicantEditedMobile : scope.reviewFormData.soleApplicantDetail.personalDetail.mobileNo;
                scope.soleApplicantMobileBelongsTo = scope.belongsToCode[scope.reviewFormData.soleApplicantDetail.personalDetail.mobileBelongsTo];
                if(scope.reviewFormData.bankDetails && !scope.reviewFormData.bankDetails.bankHolderType){
                  scope.reviewFormData.bankDetails.bankHolderType = 'MINOR';
                }
                if(scope.reviewFormData.bankDetails && scope.reviewFormData.bankDetails.chequeLeaf){
                  var fileUrl1=(scope.reviewFormData.bankDetails && scope.reviewFormData.bankDetails.chequeLeaf);
                  var myFile=fileUrl1.split('/');
                  scope.chequeLeafFilename=myFile[myFile.length-1];
                  scope.chequeLeafFilename =  scope.chequeLeafFilename && scope.chequeLeafFilename.replace(new RegExp('%20', 'g'), '-');
                  /*
                  breakFileUrl(scope.reviewFormData.bankDetails.chequeLeaf);*/
                }
                if((scope.reviewFormData.soleApplicantDetail && scope.reviewFormData.soleApplicantDetail.minorDetail && scope.reviewFormData.soleApplicantDetail.minorDetail.minorAgeProof)){
                  fileUrl1=(scope.reviewFormData.soleApplicantDetail && scope.reviewFormData.soleApplicantDetail.minorDetail.minorAgeProof);
                  myFile=fileUrl1.split('/');
                  scope.minorAgeProofFilename=myFile[myFile.length-1];
                }

                if((scope.reviewFormData.soleApplicantDetail && scope.reviewFormData.soleApplicantDetail.minorDetail && scope.reviewFormData.soleApplicantDetail.minorDetail.minorRelationshipProof)){
                  fileUrl1=(scope.reviewFormData.soleApplicantDetail && scope.reviewFormData.soleApplicantDetail.minorDetail.minorRelationshipProof);
                  myFile=fileUrl1.split('/');
                  scope.relationshipProofFilename=myFile[myFile.length-1];
                }
                if(scope.reviewFormData && scope.reviewFormData.minor){
                  (scope.reviewFormData.soleApplicantDetail.minorDetail) && addAvailableResidency(scope.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca);
                  (scope.MainFolioParent) && (scope.MainFolioParent.isSoleApplicantMinor = true);
                }else{
                  (scope.reviewFormData.soleApplicantDetail) && addAvailableResidency(scope.reviewFormData.soleApplicantDetail.selfDetail.fatca);

                }




                taxStatusCode = scope.reviewFormData.soleApplicantDetail.personalDetail.taxStatusCode;
                scope.showNomineeUpdate = scope.reviewFormData && scope.reviewFormData.sebiNomineeRegulatory01650Active ? scope.reviewFormData.sebiNomineeRegulatory01650Active : false;
                LoaderService.hideLoader();
                cb(true);
              } else {
                MessageService.error(resp.message);
                LoaderService.hideLoader();
                cb(false);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
              cb(false);
            };

          // InvestorService.get({child1: 'folio', child2: 'getSavedFolio', child3:localStorage.getItem('folioId')}).$promise.then(success, error);

          var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
          InvestorServiceV3.post({
            child1: 'folio',
            child2: 'getDetails'
          },{id:investorId}).$promise.then(success, error);
        }


        function addAvailableResidency(fatca) {
          scope.fatcaArray=[];
          if (fatca.fatcaTax1) {
            scope.fatcaArray.push(fatca.fatcaTax1);
          }
          if (fatca.fatcaTax2) {
            scope.fatcaArray.push(fatca.fatcaTax2);
          }
          if (fatca.fatcaTax3) {
            scope.fatcaArray.push(fatca.fatcaTax3);
          }
          if(scope.payTaxInIndia == false && scope.fatcaArray.length ===0){
            scope.fatcaArray.push({});
          }
        }


        /*function bankNameList() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                scope.bankList = resp.data.bankList;
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              UtilService.errorHandler(err);
            };

          InvestorService.get({child1: 'folio', child2: 'bank-list'}).$promise.then(success, error);
        }*/
        var bankTypeList = [];
        function getAcccountType() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                bankTypeList = resp.data.bankAccountTypes;
                if(bankTypeList.length && bankTypeList.length >0){
                  if(taxStatusCode == "01"){
                    bankTypeList&&bankTypeList.length>3 && (!scope.reviewFormData.bankDetails.accountType || scope.reviewFormData.bankDetails.accountType==="NRE" )?
                      scope.reviewFormData.bankDetails.accountType=bankTypeList[3].accountTypeCode
                      :''
                  } else{
                    bankTypeList&&bankTypeList.length>0?
                      scope.reviewFormData.bankDetails.accountType=bankTypeList[0].accountTypeCode
                      :''
                  }
                  // scope.reviewModalData.accountType = getAccountNameByCode(scope.reviewFormData.bankDetails.accountType);

                  scope.reviewModalData.accountType = getAccountNameByCode(scope.accountType.accountType);
                  //to set the default value of account type field as per the requirement
                }

              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              UtilService.errorHandler(err);
          };

          InvestorService.get({
            child1: 'folio',
            child2: 'bank',
            child3: 'account-type-list',
            child4: taxStatusCode
          }).$promise.then(success, error);
        }

        function getAccountNameByCode(accCode) {
          if(!accCode || bankTypeList.length<1)return"";
          var bankTypeData  = bankTypeList.find(function (ele) {
            return ele.accountTypeCode == accCode;
          });
          return bankTypeData ?bankTypeData.accountType:'';
        }

        var taxStatusList =[];
        function getTaxStatusList() {
          if (scope.reviewFormData.minor) {
            var data = {taxStatusFilter: 'MINOR'};
          } else {
            data = {taxStatusFilter: 'ADULT'};
          }
          var success = function (resp) {
            if (resp.status && resp.data) {
              taxStatusList = resp.data.taxStatus;
              var taxData = taxStatusList.find(function (ele) {
                return ele.taxStatusCode == scope.reviewFormData.soleApplicantDetail.personalDetail.taxStatusCode;
              });
              scope.reviewModalData.taxStatusDescription = taxData?taxData.taxStatusDescription:'';
            } else {
              MessageService.error(resp.message);
            }
          }, error = function (err) {
            UtilService.errorHandler(err);
          };
          InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
        }


        function getTaxStatusNameByCode(taxCode) {
          if(!taxCode || taxStatusList.length<1)return"";
          var taxData  = taxStatusList.find(function (ele) {
            return ele.taxStatusCode == taxCode;
          });
          return taxData ?taxData.taxStatusDescription:'';
        }

        function getInvestorOccupationList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              var occupationList = resp.data.investorOccupations;
              if(scope.reviewFormData.minor){
               var occupationCode =  scope.reviewFormData.soleApplicantDetail.minorDetail.guardian.occupation;
              }else{
               occupationCode =  scope.reviewFormData.soleApplicantDetail.selfDetail.occupation;
              }
              var occupationData  = occupationList.find(function (ele) {

                return ele.occupationCode == occupationCode;
              });
              scope.reviewModalData.occupationDescription = occupationData ?occupationData .occupationDescription:'';

              if(angular.isArray(scope.reviewFormData.jointHolders) && scope.reviewFormData.jointHolders.length>0){
                scope.reviewFormData.jointHolders.forEach(function (holder) {
                  var jointHolderOccupation  = occupationList.find(function (ele) {
                    return ele.occupationCode == holder.occupationCode;
                  });
                  holder.occupationDescription = jointHolderOccupation ?jointHolderOccupation.occupationDescription:'';
                })
              }
            }
          };
          InvestorService.get({child1: 'folio', child2: 'occupation'}).$promise.then(success);
        }

        function incomeSlab() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              var incomeSlabDataList = resp.data.incomeSlabList;
              if(scope.reviewFormData.minor){
                var incomeCode =  scope.reviewFormData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
              }else{
                incomeCode =  scope.reviewFormData.soleApplicantDetail.selfDetail.grossAnnualIncome;
              }
              var incomeSlabData  = incomeSlabDataList.find(function (ele) {
                return ele.incomeCode == incomeCode;
              });
              scope.reviewModalData.incomeDescription = incomeSlabData ?incomeSlabData .incomeDescription:'';
              if(angular.isArray(scope.reviewFormData.jointHolders) && scope.reviewFormData.jointHolders.length>0){
                scope.reviewFormData.jointHolders.forEach(function (holder) {
                  incomeSlabData  = incomeSlabDataList.find(function (ele) {
                    return ele.incomeCode == holder.grossAnnualIncome;
                  });
                  holder.incomeDescription = incomeSlabData ?incomeSlabData .incomeDescription:'';
                })
              }
            } else {
              MessageService.error(resp.message);
            }
          };

          InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success);
        }

        var countryList = [];
        function getCountryList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              countryList = resp.data.countries;
              if(scope.reviewFormData.minor){
                var countryCode =  scope.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry;
              }else{
                countryCode =  scope.reviewFormData.soleApplicantDetail.selfDetail.fatca.birthCountry;
              }
              var countryData  = countryList.find(function (ele) {
                return ele.countryCode ==countryCode;
              });
              scope.reviewModalData.birthCountry = countryData ?countryData.countryName:'';

              angular.forEach(scope.reviewFormData.jointHolders, function (holder) {
                if(holder.fatcaDetail && holder.fatcaDetail.birthCountry){

                  countryData  = countryList.find(function (ele) {
                    return ele.countryCode == holder.fatcaDetail.birthCountry;
                  });
                  holder.fatcaDetail.birthCountryDescription = countryData ?countryData.countryName:'';
                }
              });



              angular.forEach(scope.reviewFormData.nominees, function (nominee) {
                if(nominee.guardianAddress && nominee.guardianAddress.country){

                  countryData  = countryList.find(function (ele) {
                    return ele.countryCode ==nominee.guardianAddress.country;
                  });
                  nominee.guardianAddress.countryName = countryData ?countryData.countryName:'';
                }
                if(nominee.nomineeAddress && nominee.nomineeAddress.country){

                  countryData  = countryList.find(function (ele) {
                    return ele.countryCode ==nominee.nomineeAddress.country;
                  });
                  nominee.nomineeAddress.countryName = countryData ?countryData.countryName:'';
                }
              })

            }
          };
          InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success);
        }

        function getTaxIdTypeList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              var taxIdTypeList = resp.data.taxIdTypeResponses;
              var taxIdTypeData  = taxIdTypeList.find(function (ele) {
                return ele.value == scope.reviewFormData.value;
              });
              scope.reviewModalData.description = taxIdTypeData?taxIdTypeData.description:'';
            }
          };
          InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success);
        }


        function getAddressType() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              var addressTypeList = resp.data.addressTypeResponses;
              var addressTypeData  = addressTypeList.find(function (ele) {
                return ele.value == scope.reviewFormData.value;
              });
              scope.reviewModalData.addressDescription = addressTypeData?addressTypeData.addressDescription:'';

              angular.forEach(scope.reviewFormData.jointHolders, function (holder) {

                if(holder.fatcaDetail && holder.fatcaDetail.addressType){

                  addressTypeData  = addressTypeList.find(function (ele) {
                    return ele.value == holder.fatcaDetail.addressType;
                  });
                  holder.fatcaDetail.addressType = addressTypeData ?addressTypeData.addressDescription:'';
                }
              });

              if(scope.reviewFormData.minor){
                if(scope.reviewFormData.soleApplicantDetail.minorDetail.guardian &&
                  scope.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca &&
                  scope.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.addressType){

                  addressTypeData  = addressTypeList.find(function (ele) {
                    return ele.value == scope.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.addressType;
                  });
                  scope.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.addressTypeDescription = addressTypeData?addressTypeData.addressDescription:'';
                }
              }else{
                if(scope.reviewFormData.soleApplicantDetail.selfDetail &&
                  scope.reviewFormData.soleApplicantDetail.selfDetail.fatca &&
                  scope.reviewFormData.soleApplicantDetail.selfDetail.fatca.addressType){

                  addressTypeData  = addressTypeList.find(function (ele) {
                    return ele.value == scope.reviewFormData.soleApplicantDetail.selfDetail.fatca.addressType;
                  });
                  scope.reviewFormData.soleApplicantDetail.selfDetail.fatca.addressTypeDescription = addressTypeData?addressTypeData.addressDescription:'';
                }
              }

            }
          };
          InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success);
        }


        function getPayoutMechanism() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              var payoutMechanismList = resp.data.payoutMechanisms;
              var payoutMechanismData  = payoutMechanismList.find(function (ele) {
                return ele.payoutCode == scope.reviewFormData.bankDetails.payoutMechanism;
              });
              scope.reviewModalData.payoutDescription = payoutMechanismData?payoutMechanismData.payoutDescription:'';
            }
          };

          InvestorService.get({child1: 'folio', child2: 'payout-mechanism'}).$promise.then(success);
        }


        function getCountryNameByCode(countryCode) {
          if(!countryCode || countryList.length<1)return"";
          var countryData  = countryList.find(function (ele) {
            return ele.countryCode == countryCode;
          });
          return countryData ?countryData.countryName:'';
        }


        scope.accFocus = function () {
          scope.accModelDirty = true;
        };

        scope.copyPasteHandler=function (e) {

          var key = e.keyCode?e.keyCode:e.which;
          var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

          if ( key == 86 && ctrl ) {
            e.preventDefault();
          } else if ( key == 67 && ctrl ) {
            e.preventDefault();
          }
        };

        scope.done = function () {
          savePayload('main.folio.review');
        };

        scope.save =  function(){
          savePayloadBankDetails('');
        };

        scope.back = function () {
          if(scope.reviewFormData.minor){
            // localStorage.setItem('type', 'minor');
            savePayload('main.folio.soleApplicant');
            // $state.go('main.folio.soleApplicant');
          } else {
            // localStorage.setItem('type', 'self');
            savePayload('main.folio.nominee');
            //$state.go('main.folio.nominee');
          }
        }

        function savePayloadBankDetails(stateToMove) {
          LoaderService.showLoader();
          if(scope.reviewFormData){
            scope.reviewFormData.newFolioComplete = false;
            scope.reviewFormData.id = localStorage.getItem('folioId');
          }
          saveDetails(stateToMove);

        }

        function savePayload(stateToMove) {
          LoaderService.showLoader();
          if(scope.reviewFormData){
            if(!stateToMove){
              scope.reviewFormData.newFolioComplete = true;
            } else {
              scope.reviewFormData.newFolioComplete = false;
            }
            // console.log(localStorage.getItem('folioId'))
            scope.reviewFormData.id = localStorage.getItem('folioId');
          }
          if(scope.reviewFormData.newFolioComplete){
            completeFolio(stateToMove);
          }
          else {
            saveDetails(stateToMove);
          }
        }

        function completeFolio() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                LoaderService.hideLoader();
                if (resp.data.folioDataInvalid) {
                  var success = function() {
                    if (scope.firstFlow=='YES') {
                      $state.go('welcome');
                    } else {
                      $state.go($rootScope.setFolioInitiateState ? $rootScope.setFolioInitiateState : sessionStorage.getItem('setFolioInitiateState'));
                    }
                  }, error = function(resp) {
                    if (scope.firstFlow=='YES') {
                      $state.go('welcome');
                    } else {
                      $state.go($rootScope.setFolioInitiateState ? $rootScope.setFolioInitiateState : sessionStorage.getItem('setFolioInitiateState'));
                    }
                  };
                  ModalService.genericModal({
                    text: resp.data.message
                  }, success, error);
                } else {
                  localStorage.removeItem('optOutNominee');
                  localStorage.removeItem("wantToAddNomineeLater");
                  if (scope.firstFlow == 'YES') {
                    localStorage.removeItem('minorMode');
                    localStorage.removeItem('folioId');

                    var token = AuthService.getToken();
                    if (token && token.investorType &&  scope.reviewFormData.holdmode != "ANY_OR_SURVIVOR") {
                      token.investorType = AppConstants.INVESTOR_TYPE.EXISTING;
                    }
                    if (token && token.firstTimeLogin) {
                    token.firstTimeLogin = false;
                  }
                  if (token && token.landingPageType) {
                    token.landingPageType = AppConstants.LANDING_PAGE_TYPE.NEW_FIRST_TIME_PROSPECT_FOLIO;
                  }
                  // else {
                  //   $state.go('login');
                  // }
                   AuthService.setToken(token);
                }
                else {
                  (scope.MainFolioParent) && (scope.MainFolioParent.bankDetailSuccess = true);
                }
                if(scope.isDreamSip){
                    localStorage.removeItem('isDreamSip');
                  }
                  showPopUp(resp.data);
                }
                /*if(stateToMove){
                  LoaderService.hideLoader();
                  $state.go(stateToMove,{isBack:true});
                } else {
                  LoaderService.hideLoader();
                  scope.MainFolioParent.bankDetailSuccess = true;
                  showPopUp(resp.data);
                }*/
              } else {
                LoaderService.hideLoader();
                if(scope.reviewFormData.holdmode == "ANY_OR_SURVIVOR" ){
                  localStorage.removeItem('optOutNominee');
                  localStorage.removeItem("wantToAddNomineeLater");
                }
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
      /*    if(scope.reviewFormData && scope.reviewFormData.bankDetails && scope.reviewFormData.bankDetails.payoutMechanism){
            // delete scope.reviewFormData.bankDetails.verifyAccountNumber;
            delete scope.reviewFormData.bankDetails.payoutMechanism.micrMandatory;
            delete scope.reviewFormData.bankDetails.payoutMechanism.payoutDescription;
          }*/
          if(scope.isDreamSip){
            InvestorService.post({child1: 'transaction', child2: 'dream-sip', child3: 'approve'},scope.dreamsipPayload).$promise.then(success, error);
          }else{
            InvestorServiceV3.post({child1: 'folio', child2: 'createNew'}, {id : $stateParams.investorId}).$promise.then(success, error);
          }
        }

        function saveDetails (stateToMove) {
          LoaderService.showLoader();
          (stateToMove==='main.folio.nominee')&&(scope.reviewFormData.saveStep = 4);
          (stateToMove==='main.folio.nominee')&&(scope.reviewFormData.saveStep = 2);
          (stateToMove==='main.folio.review')&&(scope.reviewFormData.saveStep = 5);
          /*if(scope.reviewFormData.minor){
            var formData = getGuardianPayload();

          } else {
            var formData = getSoleApplicantPayload();
          }*/
          // var formData = getRefinedPayload();
          /*if(scope.reviewFormData){
            scope.reviewFormData.id = $stateParams.investorId? $stateParams.investorId : scope.MainFolioParent.uuid;
          }*/

          var success = function (resp) {
            if (resp.status && resp.data) {
              localStorage.setItem('folioId', resp.data.id);
              scope.MainFolioParent.uuid = resp.data.id;
              if(stateToMove){
                // scope.MainFolioParent.uuid = resp.data.id;
                LoaderService.hideLoader();
                $state.go(stateToMove,{isBack:true});

              }
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          InvestorService.post({child1: 'folio', child2: 'saveFolio'}, scope.reviewFormData).$promise.then(success, error);
        }

        function showPopUp(data) {
          var successModal = function () {
              // delete $window.sessionStorage.investorForm;
              $window.sessionStorage.removeItem("investorForm");
              $state.go('welcome')
            },
            errorModal = function (err) {
              if(err!=null){
                MessageService.error(err)
              }
            };
          data = data ||{};
          data.holdmode = scope.reviewFormData.holdmode;
          data.firstFlow = scope.firstFlow;
          ModalService.folioCreationSuccessModal(data, successModal, errorModal);
        }

        function selfDeclaration(data) {
          var successModal = function () {
              $state.go('login')
            },
            errorModal = function (err) {
              if(err!=null){
                MessageService.error(err)
              }
            };
          ModalService.selfDeclarationModal(data, successModal, errorModal);
        }

        function uploadChequeLeafFile(file) {

          if (scope.mimeType.indexOf(file.type) == -1) {
            MessageService.error("Only image file is allowed");
            return;
          }
          if(file){
            if (file.size <= 2000000) {
              var success = function (resp) {
                  LoaderService.hideLoader();
                  if (resp.status && resp.data) {
                    scope.reviewFormData.bankDetails.chequeLeaf = resp.data.fileUrl;

                    breakFileUrl(resp.data.fileUrl);
                    //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
                  }
                  else {
                    MessageService.error(resp.message);
                  }
                },
                error = function (err) {
                  LoaderService.hideLoader();
                  UtilService.errorHandler(err);
                };

              if (file) {
                LoaderService.showLoader();
                var fd = new FormData();
                fd.append('file', file);
                // DistributorProfileUploadService.post({

                InvestorFileUploadService.post({
                  child1:'folio',
                  child2: scope.MainFolioParent.uuid,
                  child3: 'bankDetails',
                  child4: 'chequeLeaf',
                  child5: 'upload'
                }, fd).$promise.then(success, error);
              }
            }
            else {
              MessageService.error("File size should not be more than 2 MB.")
            }
          }

        }

        function breakFileUrl() {
          scope.chequeLeafUrl = 'Preview Uploaded Doc';
          scope.chooseAFile = false;
          return;

          /*url = url.replace(/ /g,'');
          var a, extension;
          if(url.split('.jp').length > 1){
            extension = '.jpg';
            a = url.split('.jp')[0].split('/');
          } else if(url.split('.png').length > 1){
            extension = '.png';
            a = url.split('.png')[0].split('/');
          } else if(url.split('.pdf').length > 1){
            extension = '.pdf';
            a = url.split('.pdf')[0].split('/');
          } else if(url.split('.bmp').length > 1){
            extension = '.bmp';
            a = url.split('.bmp')[0].split('/');
          } else if(url.split('.tiff').length > 1){
            extension = '.tiff';
            a = url.split('.tiff')[0].split('/');
          }

          if(angular.isUndefined(extension)){
            MessageService.error("Given cheque Leaf file type is not allowed, Pleaese provide a different file type.")
            scope.chequeLeafUrl = "";
          }else{
            scope.chequeLeafUrl = a[a.length-1]+extension;
          }
          scope.chooseAFile = false;*/

        }

        scope.openUploadedDoc = function() {
          // window.open(scope.reviewFormData.bankDetails.chequeLeaf);
          if(angular.isUndefined(scope.reviewFormData.bankDetails.chequeLeaf)){return;}
          ModalService.showImage({docUrl: scope.reviewFormData.bankDetails.chequeLeaf});
        }

        function getRelationship() {
          scope.applicantRelationShip = {};
          scope.minorRelationShip = {};

          var success = function (resp) {
            if (resp.status && resp.data) {
              var relationshipWithApplicant = resp.data.nomineeRelationshipList;
              var relationshipWithMinor = resp.data.guardianRelationshipList;

              relationshipWithApplicant.forEach(function(el) {
                scope.applicantRelationShip[el.value] = el.relationDesc;
              })

              relationshipWithMinor.forEach(function(el) {
                scope.minorRelationShip[el.value] = el.relationDesc;
              })

            } else {
              scope.applicantRelationShip = {};
              scope.minorRelationShip = {};
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.applicantRelationShip = {};
            scope.minorRelationShip = {};
          };
          InvestorService.get({
            child1: 'folio',
            child2: 'nominee',
            child3: 'relation'
          }).$promise.then(success, error);
        }

        function getPersonalIdentifier(cb) {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.applicantPersonalIdentifiers = resp.data.identityProofs;
              scope.reviewFormData.nominees.forEach(function(obj, index) {
                scope.applicantPersonalIdentifiers.forEach(function(identity) {
                  if (obj.identityProofType === identity.identityProofType) {
                    obj.identityProofDescription = identity.identityProof;
                  }
                });
              });
            } else {
              scope.applicantPersonalIdentifiers = [];
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.applicantPersonalIdentifiers = [];
          };
          InvestorService.get({
            child1: 'identity-proofs'
          }).$promise.then(success, error);
        }
      }
    }
  }



})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('folioNomineeDetails', folioNomineeDetails);

  /*@ngInject*/
  function folioNomineeDetails(AuthService, MessageService, InvestorService, AppConstants, InvestorServiceV3,
                               InvestorFolioModel, LoaderService, $stateParams, UtilService, $window, $state , $timeout) {

    return {
      restrict: 'E',
      scope: {nomineePayload: '=', firstFlow:'@', isSoleApplicantMinor: '=', MainFolioParentpanNumber:'=',MainFolioParent:'=' , pan: '=',  dynamicBankDetailsNote:'='},
      templateUrl: 'app/investor/addFolio/folio-directive/nominee/folio-nominee-directive.html',
      link: function (scope) {

        // var scope = this;
        // scope.wantToAddNomineeLater = true;
        scope.dobRequired = false;
        scope.activeTab = 0;
        scope.nomineeMinDate = $window.moment();
        scope.countryList = [];
        scope.defaultDob = $window.moment().toString();
        scope.nomineeValidateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        var CONST = AppConstants;
        scope.nomineeSaveFolio = nomineeSaveFolio;
        scope.continueFolio = continueFolio;
        scope.goToBack = goToBack;
        scope.validationMsg = '';
        scope.totalPercentage = 0;
        scope.showAddNominee = true;
        scope.nomineePanValid = true;
        scope.minorPanValid = true;
        scope.dynamicNote = scope.dynamicBankDetailsNote.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT;
        // scope.wantToAddNomineeLater = localStorage.getItem('wantToAddNomineeLaterFromExistingFolioCreation') == "true" ? true : false;
        scope.nomineeEnum = {
          0: 'First',
          1: 'Second',
          2: 'Third',
          3: 'Fourth',
          4: 'Fifth',
          5: 'Sixth',
          6: 'Seventh',
          7: 'Eighth',
          8: 'Ninth',
          9: 'Tenth'
        };
        scope.isDreamSip = $window.JSON.parse(localStorage.getItem('isDreamSip'))? $window.JSON.parse(localStorage.getItem('isDreamSip')):false;
        scope.emailPattern = AppConstants.email_regex;
        scope.mobilePattern = AppConstants.mobile_regex_with_country;
        scope.showNomineeUpdate = false;
        scope.maxNominee = 3;
        scope.nomineeAadhaarValid = true;
        scope.nomineeLicenseValid = true;
        scope.nomineePassportValid = true;
        scope.emailIdValid = true;
        scope.changePersonalIdentifier = changePersonalIdentifier;
        scope.selectedNominee = selectedNominee;
        scope.changeEmailId = changeEmailId;
        scope.changeMobileNumber = changeMobileNumber;
        scope.drivingLicenseChanged = drivingLicenseChanged;
        scope.aadharCardChanged = aadharCardChanged;
        scope.passportChanged = passportChanged;
        scope.setStatement = setStatement;
        scope.setIncapcitationList = setIncapcitationList;
        scope.errorMessageEmail = scope.nomineeValidateData.EMAILID_SAME_INVESTOR;
        scope.errorMessageMobile = scope.nomineeValidateData.MOBILE_SAME_INVESTOR;
        scope.errorMessageDrivingLicense = scope.nomineeValidateData.DRIVING_LICENSE_ALREADY_EXIST;
        scope.errorMessageNomineeAadhaar = scope.nomineeValidateData.AADHAAR_ALREADY_EXIST;
        scope.errorMessagePassportNumber = scope.nomineeValidateData.PASSPORT_ALREADY_EXIST;

        // scope.optOutNominee =  localStorage.getItem('optOutNomineeFromExistingFolioCreation') == "true" ? true : false;
        scope.$watch('nomineePayload', function(value) {
          if (scope.nomineePayload && scope.nomineePayload.nominees) {
            for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              if (scope.nomineePayload.nominees[i].dob) {
                updateDob($window.moment(scope.nomineePayload.nominees[i].dob, "DD-MMM-YYYY"), i);
              }
            }
            scope.showNomineeUpdate = scope.nomineePayload && scope.nomineePayload.sebiNomineeRegulatory01650Active ? scope.nomineePayload.sebiNomineeRegulatory01650Active : false;
            scope.maxNominee = scope.nomineePayload && scope.nomineePayload.nomineeLimit ? scope.nomineePayload.nomineeLimit : 3;
            if (scope.showNomineeUpdate) {
              scope.nomineePayload.accountHoldingDeclaration = {};
              //scope.nomineePayload.accountHoldingDeclaration.nomineeName = scope.nomineePayload.nomineeRegistrationCO && scope.nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration && scope.nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration.length > 0 && scope.nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration.includes('NAME_OF_NOMINEES') ? true: false;
              scope.nomineePayload.accountHoldingDeclaration.nomination = scope.nomineePayload.nomineeRegistrationCO && scope.nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration && scope.nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration === 'NOMINATION_NO' ? false : true;
              scope.allowedNomineeLength = scope.maxNominee;
              scope.nomineePayload.incapcitationNomineeIndex = scope.nomineePayload.nomineeRegistrationCO && scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration && scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber ? scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber - 1 : null;
              setStatement();
              getPersonalIdentifier(function (resp) {
                if (resp) {
                  $timeout(function () {
                    scope.nomineePayload.nominees.forEach(function (element, index) {
                      if (element.minor) {
                        element.applicantPersonalIdentifiers = scope.applicantPersonalIdentifiers.filter(function(obj, index) {
                          return obj.identityProofType !== 'DRIVING_LICENSE';
                        });
                      } else {
                        element.applicantPersonalIdentifiers = angular.copy(scope.applicantPersonalIdentifiers);
                      }
                      if (element.hasOwnProperty('identityProofType') && element.identityProofType !== null) {
                        if (element.identityProofType === "AADHAR_CARD") {
                          scope.nomineePayload.nominees[index].aadharCard = scope.nomineePayload.nominees[index].identityProofNumber ? scope.nomineePayload.nominees[index].identityProofNumber : '';
                          aadharCardChanged(index, scope.nomineePayload.nominees[index].aadharCard);
                        } else if (element.identityProofType === "DRIVING_LICENSE") {
                          scope.nomineePayload.nominees[index].drivingLicense = scope.nomineePayload.nominees[index].identityProofNumber ? scope.nomineePayload.nominees[index].identityProofNumber : '';
                          drivingLicenseChanged(index, scope.nomineePayload.nominees[index].drivingLicense);
                        } else if (element.identityProofType === "PAN_CARD") {
                          scope.nomineePayload.nominees[index].panNumber = scope.nomineePayload.nominees[index].identityProofNumber ? scope.nomineePayload.nominees[index].identityProofNumber : '';
                          scope.nomineePanChanged(index, scope.nomineePayload.nominees[index].panNumber);
                        } else if (element.identityProofType === "PASSPORT") {
                          scope.nomineePayload.nominees[index].passport = scope.nomineePayload.nominees[index].identityProofNumber ? scope.nomineePayload.nominees[index].identityProofNumber : '';
                          scope.passportChanged(index, scope.nomineePayload.nominees[index].passport);
                        }
                      }
                      if (element.hasOwnProperty('identityProofCamsCode') && element.identityProofCamsCode !== null) {
                        scope.nomineePayload.nominees[index].identityProofCamsCode = element.identityProofCamsCode;
                      }
                    });
                  });
                }
              });
            }
          }
        });

        nomineeInit();

        function setHeader() {
          var profile = AuthService.getToken();
          scope.MainFolioParent && (scope.MainFolioParent.panNumber = profile.investorPAN);
          scope.MainFolioParent && (scope.MainFolioParent.firstName = profile.investorFName);
          scope.MainFolioParent && (scope.MainFolioParent.middleName = profile.investorMName);
          scope.MainFolioParent && (scope.MainFolioParent.lastName = profile.investorLName);
          scope.MainFolioParent && (scope.MainFolioParent.currentState = 'main.folio.nominee');

        }

        scope.nomineeChangeDob = function (date) {

          if (!date) {
            return;
          }
          // scope.defaultDob = date.toString();
          scope.nomineePayload.nominees[scope.activeTab].dob = date.clone().format('DD-MMM-YYYY').toString();
          // var age = $window.moment().diff(date, 'years');
          // if (age < 18) {
          //   scope.nomineePayload.nominees[scope.activeTab].minor = true;
          //   scope.nomineePayload.nominees[scope.activeTab].panNumber = null;
          // } else {
          //   scope.nomineePayload.nominees[scope.activeTab].minor = false;
          //   scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber = null;
          //   scope.nomineePayload.nominees[scope.activeTab].guardianName = null;
          //   scope.nomineePayload.nominees[scope.activeTab].guardianRelationWithNominee = null;
          // }
          if(scope.nomineePayload.nominees[scope.activeTab].dob){
            scope.dobRequired = false;
          }
          if(scope.nomineePayload.nominees[scope.activeTab].minor){
            if(scope.nomineePayload.nominees[scope.activeTab].dob){
              scope.dobRequired = false;
            }else{
              scope.dobRequired = true;
            }
          }
        };

        scope.percentage = function (data) {
          if (data.percentage.split('%').length != 2)
            data.percentage = data.percentage + '%';
        };

        scope.setActiveTab = function (index) {
          scope.activeTab = index;
          scope.callPan = false;
          if(typeof scope.nomineePayload.nominees[scope.activeTab].panNumber !== 'undefined' && scope.nomineePayload.nominees[scope.activeTab].panNumber != "" && scope.nomineePayload.nominees[scope.activeTab].panNumber != null) {
            scope.nomineePanChanged(index,scope.nomineePayload.nominees[scope.activeTab].panNumber);
          }

          if(typeof scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber!== 'undefined' && scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber != "" && scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber != null && !scope.callPan) {
            scope.minorPanChanged(index,scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber , true)
          }

        };

        scope.deleteNominee = function (index) {
          if (scope.showNomineeUpdate) {
            if (index === parseInt(scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeIndex) && scope.nomineePayload.nominees[index].nomineeName === scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName) {
              scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration = {};
              scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage = null;
              scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount = null;
            }
          }
          scope.activeTab = 0;
          var totalPercentage = 0;
          for (var i in scope.nomineePayload.nominees) {
            totalPercentage += parseInt(scope.nomineePayload.nominees[i].percentage);
          }
          scope.totalPercentage = totalPercentage;
          scope.calculatePercentage();
          var indexToCheck = 0;
          scope.nomineePanChanged(indexToCheck,scope.nomineePayload.nominees[indexToCheck].panNumber);


          if(scope.nomineePayload.nominees.length == 1) {
            if(scope.nomineePayload.nominees[0].guardianPanNumber) {
              scope.minorPanChanged(index,scope.nomineePayload.nominees[0].guardianPanNumber , true)
            } else {
              scope.minorPanValid = true;
            }
          } else {
            if(scope.nomineePayload.nominees[0].guardianPanNumber) {
              scope.minorPanChanged(0,scope.nomineePayload.nominees[0].guardianPanNumber , true)
            } else if(scope.nomineePayload.nominees[1].guardianPanNumber) {
              scope.minorPanChanged(1,scope.nomineePayload.nominees[1].guardianPanNumber , true)
            } else {
              scope.minorPanValid = true;
            }

            if (scope.nomineePayload.nominees[index].hasOwnProperty('aadharCard') && scope.nomineePayload.nominees[index].aadharCard) {
              // if (scope.nomineePayload.nominees[index].sameIndex && scope.nomineePayload.nominees[index].sameIndex.length === 1) {
              //   scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndex[0]].sameIndex = [];
              //   scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndex[0]].nomineeAadhaarInvalid = false;
              //   scope.nomineePayload.nominees[index].sameIndex = [];
              //   scope.nomineePayload.nominees[index].nomineeAadhaarInvalid = false;
              //   scope.nomineePayload.nominees.forEach(function (el) {
              //     if (el.sameIndex && el.sameIndex.length > 0) {
              //       el.sameIndex.forEach(function (val,indexE) {
              //         if (el.sameIndex[indexE] > index) {
              //           el.sameIndex[indexE] = el.sameIndex[indexE] === 0 ? 0 : el.sameIndex[indexE] - 1;
              //         }
              //       });
              //     }
              //   });
              //   for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              //     if (scope.nomineePayload.nominees[i].sameIndex && scope.nomineePayload.nominees[i].sameIndex.length === 0) {
              //       scope.nomineeAadhaarValid = true;
              //     } else if (scope.nomineePayload.nominees[i].sameIndex && scope.nomineePayload.nominees[i].sameIndex.length !== 0)  {
              //       scope.nomineeAadhaarValid = false;
              //       break;
              //     }
              //   }
              // } else if(scope.nomineePayload.nominees[index].sameIndex && scope.nomineePayload.nominees[index].sameIndex.length > 1) {
              //   scope.nomineePayload.nominees[index].sameIndex.forEach(function (el) {
              //     if (scope.nomineePayload.nominees[el].sameIndex && scope.nomineePayload.nominees[el].sameIndex.length === 1) {
              //       scope.nomineePayload.nominees[el].sameIndex = [];
              //       scope.nomineePayload.nominees[el].nomineeAadhaarInvalid = false;
              //     } else {
              //       var indexEL = scope.nomineePayload.nominees[el].sameIndex.indexOf(index);
              //       scope.nomineePayload.nominees[el].sameIndex.splice(indexEL,1);
              //       // updating index of aadhar same elements
              //       scope.nomineePayload.nominees[el].sameIndex.forEach(function (val,indexE) {
              //         if (scope.nomineePayload.nominees[el].sameIndex[indexE] > index) {
              //           scope.nomineePayload.nominees[el].sameIndex[indexE] = scope.nomineePayload.nominees[el].sameIndex[indexE] === 0 ? 0 : scope.nomineePayload.nominees[el].sameIndex[indexE] - 1;
              //         }
              //       });
              //     }
              //   });
              // }

              // updating liscense index value when value with aadhar is deleted
              for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                if (scope.nomineePayload.nominees[i].hasOwnProperty('drivingLicense')) {
                  scope.nomineePayload.nominees[i].sameIndexLiscense.forEach(function (el, indexE) {
                    if (scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] > index) {
                      scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] = scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] === 0 ? 0 : scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] - 1;
                    }
                  })
                }

                if (scope.nomineePayload.nominees[i].hasOwnProperty('passport')) {
                  scope.nomineePayload.nominees[i].sameIndexPassport.forEach(function (el, indexE) {
                    if (scope.nomineePayload.nominees[i].sameIndexPassport[indexE] > index) {
                      scope.nomineePayload.nominees[i].sameIndexPassport[indexE] = scope.nomineePayload.nominees[i].sameIndexPassport[indexE] === 0 ? 0 : scope.nomineePayload.nominees[i].sameIndexPassport[indexE] - 1;
                    }
                  })
                }
              }
            }
            if (scope.nomineePayload.nominees[index].hasOwnProperty('drivingLicense') && scope.nomineePayload.nominees[index].drivingLicense) {
              if (scope.nomineePayload.nominees[index].sameIndexLiscense && scope.nomineePayload.nominees[index].sameIndexLiscense.length === 1) {
                scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndexLiscense[0]].sameIndexLiscense = [];
                scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndexLiscense[0]].nomineeLicenseValid = false;
                scope.nomineePayload.nominees[index].sameIndexLiscense = [];
                scope.nomineePayload.nominees[index].nomineeLicenseValid = false;
                scope.nomineePayload.nominees.forEach(function (el) {
                  if (el.sameIndexLiscense && el.sameIndexLiscense.length > 0) {
                    el.sameIndexLiscense.forEach(function (val,indexE) {
                      if (el.sameIndexLiscense[indexE] > index) {
                        el.sameIndexLiscense[indexE] = el.sameIndexLiscense[indexE] === 0 ? 0 : el.sameIndexLiscense[indexE] - 1;
                      }
                    });
                  }
                });

                for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                  if (scope.nomineePayload.nominees[i].sameIndexLiscense && scope.nomineePayload.nominees[i].sameIndexLiscense.length === 0) {
                    scope.nomineeLicenseValid = true;
                  } else if (scope.nomineePayload.nominees[i].sameIndexLiscense && scope.nomineePayload.nominees[i].sameIndexLiscense.length !== 0)  {
                    scope.nomineeLicenseValid = false;
                    break;
                  }
                }
              } else if(scope.nomineePayload.nominees[index].sameIndexLiscense && scope.nomineePayload.nominees[index].sameIndexLiscense.length > 1) {
                scope.nomineePayload.nominees[index].sameIndexLiscense.forEach(function (el) {
                  if (scope.nomineePayload.nominees[el].sameIndexLiscense && scope.nomineePayload.nominees[el].sameIndexLiscense.length === 1) {
                    scope.nomineePayload.nominees[el].sameIndexLiscense = [];
                    scope.nomineePayload.nominees[el].nomineeLicenseValid = false;
                  } else {
                    var indexEL = scope.nomineePayload.nominees[el].sameIndexLiscense.indexOf(index);
                    scope.nomineePayload.nominees[el].sameIndexLiscense.splice(indexEL,1);
                    scope.nomineePayload.nominees[el].sameIndexLiscense.forEach(function (val,indexE) {
                      if (scope.nomineePayload.nominees[el].sameIndexLiscense[indexE] > index) {
                        scope.nomineePayload.nominees[el].sameIndexLiscense[indexE] = scope.nomineePayload.nominees[el].sameIndexLiscense[indexE] === 0 ? 0 : scope.nomineePayload.nominees[el].sameIndexLiscense[indexE] - 1;
                      }
                    });
                  }
                });
              }
              //updating aadhar index value when value with liscense is deleted
              for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                /*if (scope.nomineePayload.nominees[i].hasOwnProperty('aadharCard')) {
                  scope.nomineePayload.nominees[i].sameIndex.forEach(function (el, indexE) {
                    if (scope.nomineePayload.nominees[i].sameIndex[indexE] > index) {
                      scope.nomineePayload.nominees[i].sameIndex[indexE] = scope.nomineePayload.nominees[i].sameIndex[indexE] === 0 ? 0 : scope.nomineePayload.nominees[i].sameIndex[indexE] - 1;
                    }
                  })
                }*/
                if (scope.nomineePayload.nominees[i].hasOwnProperty('passport')) {
                  scope.nomineePayload.nominees[i].sameIndexPassport.forEach(function (el, indexE) {
                    if (scope.nomineePayload.nominees[i].sameIndexPassport[indexE] > index) {
                      scope.nomineePayload.nominees[i].sameIndexPassport[indexE] = scope.nomineePayload.nominees[i].sameIndexPassport[indexE] === 0 ? 0 : scope.nomineePayload.nominees[i].sameIndexPassport[indexE] - 1;
                    }
                  })
                }
              }
            }
            if (scope.nomineePayload.nominees[index].hasOwnProperty('passport') && scope.nomineePayload.nominees[index].passport) {
              if (scope.nomineePayload.nominees[index].sameIndexPassport && scope.nomineePayload.nominees[index].sameIndexPassport.length === 1) {
                scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndexLiscense[0]].sameIndexPassport = [];
                scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndexLiscense[0]].nomineePassportValid = false;
                scope.nomineePayload.nominees[index].sameIndexPassport = [];
                scope.nomineePayload.nominees[index].nomineePassportValid = false;
                scope.nomineePayload.nominees.forEach(function (el) {
                  if (el.sameIndexPassport && el.sameIndexPassport.length > 0) {
                    el.sameIndexPassport.forEach(function (val,indexE) {
                      if (el.sameIndexPassport[indexE] > index) {
                        el.sameIndexPassport[indexE] = el.sameIndexPassport[indexE] === 0 ? 0 : el.sameIndexPassport[indexE] - 1;
                      }
                    });
                  }
                });

                for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                  if (scope.nomineePayload.nominees[i].sameIndexPassport && scope.nomineePayload.nominees[i].sameIndexPassport.length === 0) {
                    scope.nomineePassportValid = true;
                  } else if (scope.nomineePayload.nominees[i].sameIndexPassport && scope.nomineePayload.nominees[i].sameIndexPassport.length !== 0)  {
                    scope.nomineePassportValid = false;
                    break;
                  }
                }
              } else if(scope.nomineePayload.nominees[index].sameIndexPassport && scope.nomineePayload.nominees[index].sameIndexPassport.length > 1) {
                scope.nomineePayload.nominees[index].sameIndexPassport.forEach(function (el) {
                  if (scope.nomineePayload.nominees[el].sameIndexPassport && scope.nomineePayload.nominees[el].sameIndexPassport.length === 1) {
                    scope.nomineePayload.nominees[el].sameIndexPassport = [];
                    scope.nomineePayload.nominees[el].nomineePassportValid = false;
                  } else {
                    var indexEL = scope.nomineePayload.nominees[el].sameIndexPassport.indexOf(index);
                    scope.nomineePayload.nominees[el].sameIndexPassport.splice(indexEL,1);
                    scope.nomineePayload.nominees[el].sameIndexPassport.forEach(function (val,indexE) {
                      if (scope.nomineePayload.nominees[el].sameIndexPassport[indexE] > index) {
                        scope.nomineePayload.nominees[el].sameIndexPassport[indexE] = scope.nomineePayload.nominees[el].sameIndexPassport[indexE] === 0 ? 0 : scope.nomineePayload.nominees[el].sameIndexPassport[indexE] - 1;
                      }
                    });
                  }
                });
              }

              for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                if (scope.nomineePayload.nominees[i].hasOwnProperty('drivingLicense')) {
                  scope.nomineePayload.nominees[i].sameIndexLiscense.forEach(function (el, indexE) {
                    if (scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] > index) {
                      scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] = scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] === 0 ? 0 : scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] - 1;
                    }
                  })
                }
              }
            }
          }
          setIncapcitationList();
          scope.nomineePayload.nominees.splice(index, 1);
        };

        scope.addNominee = function () {
          var msg = checkValidation();
          if (msg) {
            MessageService.error(msg);
            return;
          }
          if (!scope.nomineePayload.nominees)
            scope.nomineePayload.nominees = [];
          // var percentage = calculateProportion();
          scope.nomineePayload.nominees.push(scope.showAddNominee ? InvestorFolioModel.getUpdatedNomineeObject() : InvestorFolioModel.getNomineeObject());

          scope.activeTab = scope.nomineePayload.nominees.length - 1;
          scope.nomineePayload.nominees[scope.nomineePayload.nominees.length - 1].applicantPersonalIdentifiers = angular.copy(scope.applicantPersonalIdentifiers);
        };

        function checkValidation() {
          var arr = scope.nomineePayload.nominees, msg = '';
          for (var i = 0; i < arr.length; i++) {
            if (!arr[i]['nomineeName'] || !arr[i]['percentage']) {
              msg = 'Please fill details of ' + scope.nomineeEnum[i]
                + ' nominee';
              break;
            }
          }
          return msg;
        }

        /*function calculateProportion() {
          var percentage = 0, nominees = scope.nomineePayload.nominees;

          if (nominees.length === 0) {
            percentage = 100;
          } else if (nominees.length === 1) {
            percentage = 100 - parseInt(nominees[0].percentage);
          } else if (nominees.length === 2) {
            percentage = 100 - (parseInt(nominees[0].percentage) + parseInt(nominees[1].percentage));
          }

          return percentage;
        }*/

        scope.calculatePercentage = function () {
          var totalPercentage = 0;
          var nominees = scope.nomineePayload.nominees;
          for (var i=0; i<nominees.length; i++ ) {
            totalPercentage += parseInt(nominees[i].percentage);
          }
          scope.totalPercentage = totalPercentage;
          if (scope.totalPercentage < 100 && scope.nomineePayload.nominees.length < scope.maxNominee) {
            scope.showAddNominee = true;
          } else {
            scope.showAddNominee = false;
          }
          if (totalPercentage != 100) {
            scope.percentage_msg = scope.nomineeValidateData.PROPORTION_PERCENTAGE;
            return false;
          } else {
            scope.percentage_msg = '';
            return true;
          }
        };

        /*function getPayload() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                scope.nomineePayload = resp.data;
                scope.MainFolioParent.holdmode = resp.data.holdmode;
                if (scope.nomineePayload && scope.nomineePayload.nominees.length === 0) {
                  //scope.nomineePayload.nominees = [];
                  scope.addNominee();
                } else if (scope.nomineePayload && scope.nomineePayload.nominees && scope.nomineePayload.nominees.length === 0) {
                  scope.wantToAddNomineeLater = true;
                } else {
                  scope.wantToAddNomineeLater = false;
                }
                scope.calculatePercentage();
                LoaderService.hideLoader();
              } else {
                MessageService.error(resp.message);
                LoaderService.hideLoader();
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
            };

          var investorId=localStorage.getItem('folioId');
          InvestorServiceV3.post({
            child1: 'folio',
            child2: 'getDetails'
          },{id:investorId}).$promise.then(success, error);

        }*/

        scope.next = function () {
          nomineeSaveFolio('folioDetails.bankDetails');
        };

        scope.back = function (from) {
          if(scope.nomineePayload.holdmode === CONST.INVESTOR_HOLD_MODE.AOS){
            nomineeSaveFolio('main.folio.jointholders', from);
          }else {nomineeSaveFolio('main.folio.soleApplicant', from)}
        };

        function checkProportionTotalSum() {
          var sum = 0, msg = '';
          for (var i = 0; i < scope.nomineePayload.nominees.length; i++) {
            sum = sum + parseInt(scope.nomineePayload.nominees[i].percentage);
          }
          if (sum != 100) {
            msg = 'Total sum of nominee proportion should be 100';
          }

          return msg;

        }

        function getCountryList(cb) {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.nomineeCountryList = resp.data.countries;
              cb();
            } else {
              scope.nomineeCountryList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.nomineeCountryList = null;
          };
          InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
        }

        function nomineeSaveFolio(stateToMove, from) {
          if (from != 'fromBack') {
            // if (!scope.wantToAddNomineeLater) {
            //   var msg = checkProportionTotalSum();
            //   if (msg) {
            //     MessageService.error(msg);
            //     return;
            //   }
            // }
            if (scope.wantToAddNomineeLater) {
              localStorage.setItem("wantToAddNomineeLaterFromExistingFolioCreation", "true");
              if(scope.optOutNominee == true){
                localStorage.setItem("optOutNomineeFromExistingFolioCreation", "true");
              }
              scope.nomineePayload.nominees = [];
            } else if(!scope.wantToAddNomineeLater){
              localStorage.setItem("wantToAddNomineeLaterFromExistingFolioCreation", "false");
              if(!scope.optOutNominee){
                localStorage.setItem("optOutNomineeFromExistingFolioCreation", "false");
              }
            }
          }
          checkNominees();
          if (scope.nomineePayload) {
            scope.nomineePayload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
          }

          LoaderService.showLoader();

          var success = function (resp) {
            if (resp.status && resp.data) {
              (scope.MainFolioParent) && (scope.MainFolioParent.uuid = resp.data.id);
              if (stateToMove) {
                $state.go(stateToMove, {investorId: $stateParams.investorId});
              }else{

                LoaderService.hideLoader();
                MessageService.success('Saved Successfully.');
                $state.go('welcome');
              }
            } else {
              MessageService.error(resp.message);
            }

            LoaderService.hideLoader();
          }, error = function () {
            LoaderService.hideLoader();
          };
          scope.nomineePayload.firstFolio = (scope.firstFlow == 'YES')?true:false;
          scope.nomineePayload.folioSaveStep = "FOUR";
          // InvestorService.post({child1: 'folio', child2: 'saveFolio'}, scope.nomineePayload).$promise.then(success, error);

          InvestorServiceV3.post({child1: 'folio', child2: 'save'}, scope.nomineePayload).$promise.then(success, error);

        }
        function continueFolio(stateToMove, from) {
          if (from != 'fromBack') {
            if (!scope.wantToAddNomineeLater) {
              var msg = checkProportionTotalSum();
              if (msg) {
                MessageService.error(msg);
                return;
              }
            }
            if (scope.wantToAddNomineeLater) {
              scope.nomineePayload.nominees = [];
            }
          }
          checkNominees();
          if (scope.nomineePayload) {
            scope.nomineePayload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
          }

          LoaderService.showLoader();

          var success = function (resp) {
            if (resp.status && resp.data) {

              if (scope.wantToAddNomineeLater == true) {
                localStorage.setItem('wantToAddNomineeLaterFromExistingFolioCreation',"true");
              }else{localStorage.setItem('wantToAddNomineeLaterFromExistingFolioCreation',"false");}
              (scope.MainFolioParent) && (scope.MainFolioParent.uuid = resp.data.id);
              if (stateToMove) {
                $state.go(stateToMove, {investorId: $stateParams.investorId});
              }
            } else {
              MessageService.error(resp.message);
            }

            LoaderService.hideLoader();
          }, error = function () {
            LoaderService.hideLoader();
          };
          scope.nomineePayload.firstFolio = (scope.firstFlow == 'YES')?true:false;
          scope.nomineePayload.folioSaveStep = "FOUR";
          // InvestorService.post({child1: 'folio', child2: 'saveFolio'}, scope.nomineePayload).$promise.then(success, error);
          var payload = scope.nomineePayload;
          if (payload.holdmode === "ANY_OR_SURVIVOR" || payload.nomineeRegistrationCO && payload.nomineeRegistrationCO.incapacitationDeclaration && Object.keys(payload.nomineeRegistrationCO.incapacitationDeclaration).length === 0) {
            delete payload.nomineeRegistrationCO.incapacitationDeclaration;
          }
          if (scope.wantToAddNomineeLater) {
            delete payload.nomineeRegistrationCO;
          }
          InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);

        }

        scope.nomineeContinue = function () {

         if(!scope.isDreamSip){
           if(scope.firstFlow === 'YES'){
            scope.continueFolio('folioDetails.bankDetails',{investorId:$stateParams.investorId});
          }else{
            scope.continueFolio('main.folio.bankdetails',{investorId:$stateParams.investorId});
          }
        }else{
          scope.continueFolio('main.folio.review',{investorId:scope.folioId,isDreamSip:'true'});
        }
          // nomineeSaveFolio('main.folio.bankdetails');
        };

        function goToBack() {
          if(scope.firstFlow === 'YES'){
            if(scope.nomineePayload.holdmode === CONST.INVESTOR_HOLD_MODE.AOS){
              $state.go('folioDetails.jointholders',{investorId:$stateParams.investorId});
            }else {
              $state.go('folioDetails.folioCreation',{investorId:$stateParams.investorId});
              // nomineeSaveFolio('main.folio.soleApplicant','fromBack');
            }
          }else{
            if(scope.nomineePayload.holdmode === CONST.INVESTOR_HOLD_MODE.AOS){
              $state.go('main.folio.jointholders',{investorId:$stateParams.investorId});
              // nomineeSaveFolio('main.folio.jointholders','fromBack');
            }else {
              $state.go('main.folio.soleApplicant',{investorId:$stateParams.investorId});
              // nomineeSaveFolio('main.folio.soleApplicant','fromBack');
            }

          }
          if(scope.wantToAddNomineeLater == false){
            localStorage.setItem('wantToAddNomineeLaterFromExistingFolioCreation',"false");
            localStorage.setItem('optOutNomineeFromExistingFolioCreation',"false");
          }
        }

        function checkNominees() {
          for (var i = 0; i < scope.nomineePayload.nominees.length; i++) {
            delete scope.nomineePayload.nominees[i].minorPanInvalid;
            delete scope.nomineePayload.nominees[i].nomineePanInvalid;
            if(!scope.nomineePayload.nominees[i].minor){
              scope.nomineePayload.nominees[i].minor = false;
            }
            if (scope.nomineePayload.nominees[i].minor) {
              delete scope.nomineePayload.nominees[i].nomineeAddress;
            } else {
              delete scope.nomineePayload.nominees[i].guardianName;
              delete scope.nomineePayload.nominees[i].guardianAddress;
              delete scope.nomineePayload.nominees[i].guardianPanNumber;
              delete scope.nomineePayload.nominees[i].guardianRelationWithNominee;
            }
            if (scope.showNomineeUpdate && scope.nomineePayload.nominees[i].drivingLicense) {
              scope.nomineePayload.nominees[i].identityProofNumber = scope.nomineePayload.nominees[i].drivingLicense;
              delete scope.nomineePayload.nominees[i].drivingLicense;
            }
            if (scope.showNomineeUpdate && scope.nomineePayload.nominees[i].aadharCard) {
              scope.nomineePayload.nominees[i].identityProofNumber = scope.nomineePayload.nominees[i].aadharCard;
              delete scope.nomineePayload.nominees[i].aadharCard;
            }
            if (scope.showNomineeUpdate && scope.nomineePayload.nominees[i].panNumber) {
              scope.nomineePayload.nominees[i].identityProofNumber = scope.nomineePayload.nominees[i].panNumber;
              delete scope.nomineePayload.nominees[i].panNumber;
            }

            if (scope.showNomineeUpdate && scope.nomineePayload.nominees[i].passport) {
              scope.nomineePayload.nominees[i].identityProofNumber = scope.nomineePayload.nominees[i].passport;
              delete scope.nomineePayload.nominees[i].passport;
            }

            if (scope.showNomineeUpdate && scope.nomineePayload.nominees[i].somethingElse) {
              scope.nomineePayload.nominees[i].identityProofNumber = scope.nomineePayload.nominees[i].somethingElse;
              delete scope.nomineePayload.nominees[i].somethingElse;
            }
          }
          if(scope.showNomineeUpdate && scope.nomineePayload.nomineeRegistrationCO && scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration){
            if(scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage && parseInt(scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage) > 0) {
             delete scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount;
            }
            if (scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount && parseInt(scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount) > 0) {
              delete scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage;
            }
          }
        }

        scope.checkAddNominee = function () {
           scope.wantToAddNomineeLater = !scope.wantToAddNomineeLater;
          if(scope.wantToAddNomineeLater == true){
            localStorage.setItem('wantToAddNomineeLaterFromExistingFolioCreation', "true");
          } else if(scope.wantToAddNomineeLater == false){
            scope.optOutNominee = false;
            localStorage.setItem('wantToAddNomineeLaterFromExistingFolioCreation', "false");
            localStorage.setItem('optOutNomineeFromExistingFolioCreation',"false");
          }
        }

        scope.$watch('nomineePayload.nominees', function () {
          if(scope.addNomineeForm.$valid){return;}
          var formFieldList = scope.addNomineeForm.$error.required;
          if (angular.isArray(formFieldList) && formFieldList.length > 0) {

            var formTypeArray = formFieldList.map(function (ele) {
              return ele.$name.split('-')[1];
            }).filter(function (value, index, self) {
              return self.indexOf(value) === index;
            });
            var nomineeList = [];
            angular.forEach(formTypeArray, function (val) {
              switch (val) {
                case "0":
                  nomineeList.push('First Nominee');
                  break;
                case "1":
                  nomineeList.push('Second Nominee');
                  break;
                case "2":
                  nomineeList.push('Third Nominee');
                  break;
                case "3":
                  nomineeList.push('Fourth Nominee');
                  break;
                case "4":
                  nomineeList.push('Fifth Nominee');
                  break;
                case "5":
                  nomineeList.push('Sixth Nominee');
                  break;
              }
            });

            scope.validationMsg = setMsg(nomineeList);
          } else {
            scope.validationMsg = '';
          }
          if (scope.showNomineeUpdate) {
            scope.nomineePayload.accountHoldingDeclaration = scope.nomineePayload.accountHoldingDeclaration ? scope.nomineePayload.accountHoldingDeclaration : {};
            scope.nomineePayload.accountHoldingDeclaration.nomination = scope.nomineePayload.accountHoldingDeclaration.nomination === false ? false : true;
            setStatement();
            setIncapcitationList();
          }
          scope.calculatePercentage();
        }, true);

        function setMsg(list) {
          var msg = 'Please complete the ';
          var array = angular.copy(list);
          if (array.length == 0) {
            return '';
          }
          else if (array.length == 1) {
            return msg + array.join(',') + ' Details';
          }
          else if (array.length > 1) {
            var listLast = array.pop();
            return msg + array.join(' , ') + ' and ' + listLast + ' Details';
          }


        }

        function nomineeInit() {
          $window.scrollTo(0, 0);
          LoaderService.showLoader();
          setHeader();
          // scope.FolioDetailsParent.stepsAway = 2;
          getCountryList(function() {
            getStateList();
            $timeout(function () {
              if (scope.nomineePayload && scope.nomineePayload.nominees) {
                for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                  if (scope.nomineePayload.nominees[i].nomineeAddress.country !== null) {
                    scope.nomineePayload.nominees[i].nomineeAddress.country = getCountryCode(scope.nomineePayload.nominees[i].nomineeAddress.country);
                    scope.changeCountry(i,scope.nomineePayload.nominees[i].nomineeAddress.country);
                  }
                  if (scope.nomineePayload.nominees[i].guardianAddress.country !== '') {
                    scope.changeCountryGuardian(i,scope.nomineePayload.nominees[i].guardianAddress.country);
                  }
                }
              }
            },200);
          });
          getRelationshipList();
          $timeout(function () {
            if (scope.nomineePayload && scope.nomineePayload.nominees) {
              for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                if (scope.nomineePayload.nominees[i].nomineeRelation !== null) {
                  scope.changeNomineeRelationsShip(i, scope.nomineePayload.nominees[i].nomineeRelation);
                }
                if (scope.nomineePayload.nominees[i].dob) {
                  updateDob($window.moment(scope.nomineePayload.nominees[i].dob, "DD-MMM-YYYY"), i);
                }
                scope.changeCountry(i,scope.nomineePayload.nominees[i].nomineeAddress.country);
                scope.changeCountryGuardian(i,scope.nomineePayload.nominees[i].guardianAddress.country);
              }
            }
          },100);
          // getPayload();
        }

        function getRelationshipList() {

          scope.applicantRelationShip = [];
          scope.minorRelationShip = [];

          var success = function (resp) {
            if (resp.status && resp.data) {
              var relationshipWithApplicant = resp.data.nomineeRelationshipList;
              var relationshipWithMinor = resp.data.guardianRelationshipList;

              relationshipWithApplicant.forEach(function(el) {
                scope.applicantRelationShip.push({
                name : el.relationDesc,
                value : el.value
                })
              })


              relationshipWithMinor.forEach(function(el) {
                scope.minorRelationShip.push({
                  name : el.relationDesc,
                  value : el.value
                })
              })

            } else {
              scope.applicantRelationShip = [];
              scope.minorRelationShip = [];
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.applicantRelationShip = [];
            scope.minorRelationShip = [];
          };
          InvestorService.get({
            child1: 'folio',
            child2: 'nominee',
            child3: 'relation'
          }).$promise.then(success, error);
        }

        scope.changeNomineeRelationsShip = function(index, relationship) {
          var userRelation = scope.applicantRelationShip.filter(function(relation) {
            return relation.value === relationship;
          });
          if (userRelation.length > 0) {
            scope.applicantRelationShip.map( function (el) {
              if(el.value === relationship){
                scope.nomineePayload.nominees[index].nomineeRelation = el.value;
              }
            });
          } else {
            scope.nomineePayload.nominees[index].nomineeRelation = null;
          }
        };

        scope.changeMinorRelationsShip = function(index, relationship) {
          scope.minorRelationShip.map( function (el) {
            if(el.value === relationship){
              scope.nomineePayload.nominees[index].guardianRelationWithNominee = el.value;
            }
          });
        }


        scope.nomineePanChanged = function(index, pan) {
          if(pan == "") {
            scope.nomineePayload.nominees[index].panNumber = null;
          }
          if(scope.pan && scope.pan == pan) {
            scope.nomineePayload.nominees[index].nomineePanInvalid = true;
            scope.nomineePanValid = false;
            scope.errorMessageNominee = scope.nomineeValidateData.NOMINEE_SAME_INVESTOR;
            scope.dupIndex = index;
          } else if(scope.pan !== pan) {

            scope.nomineePayload.nominees[index].nomineePanInvalid = false;
            scope.errorMessageNominee = "";

            if (scope.nomineePayload.nominees.length == 1) {
              scope.nomineePanValid = true;
            }

            for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              if(i !== index && scope.nomineePayload.nominees[index].panNumber && scope.nomineePayload.nominees[i].panNumber == pan) {
                scope.nomineePayload.nominees[index].nomineePanInvalid = true;
                scope.nomineePanValid = false;
                scope.errorMessageNominee = scope.nomineeValidateData.NOMINEE_PAN_SAME;
                scope.indexOne = index;
                scope.indexTwo = i ;
                break;
              }

              if (scope.nomineePayload.nominees.length == 2) {
                if (scope.nomineePayload.nominees[i].nomineePanInvalid && (scope.nomineePayload.nominees[i].panNumber !== pan && scope.nomineePayload.nominees[i].panNumber !== scope.pan)) {
                  scope.nomineePanValid = true;
                } else if (scope.nomineePayload.nominees[i].panNumber !== pan && scope.nomineePayload.nominees[i].panNumber !== scope.pan) {
                  scope.nomineePanValid = true;
                }
              }

              if (scope.nomineePayload.nominees.length >= 3) {
                if(i !== index && scope.nomineePayload.nominees[index].panNumber && (scope.nomineePayload.nominees[i].panNumber == pan || scope.nomineePayload.nominees[i].panNumber == scope.pan)){
                  scope.nomineePanValid = false;
                } else if(i !== index && scope.nomineePayload.nominees[index].panNumber && scope.nomineePayload.nominees[i].panNumber !== pan && scope.nomineePayload.nominees[i].panNumber !== scope.pan &&  scope.nomineePayload.nominees[i].nomineePanInvalid != true) {
                  if(!scope.dupIndex)  {
                    if(typeof scope.indexOne !== 'undefined' && typeof scope.indexTwo !== 'undefined') {
                      if(scope.nomineePayload.nominees[scope.indexOne].panNumber == scope.nomineePayload.nominees[scope.indexTwo].panNumber) {
                        scope.nomineePanValid = false;
                      }
                    } else if(typeof scope.indexTwo !== 'undefined'){
                      if(scope.indexTwo !== i && scope.nomineePayload.nominees[i].panNumber == scope.nomineePayload.nominees[scope.indexTwo].panNumber){
                        scope.nomineePanValid = false;
                      }
                    } else {
                      scope.nomineePanValid = true;
                    }
                  } else if(scope.nomineePayload.nominees[scope.dupIndex].panNumber !== scope.pan) {
                    scope.nomineePanValid = true;
                  }
                }  else if(i !== index && scope.nomineePayload.nominees[i].nomineePanInvalid == false && scope.nomineePayload.nominees[i].panNumber !== pan && (scope.nomineePayload.nominees[i].panNumber !== scope.pan)) {
                  if(!scope.dupIndex) {
                    scope.nomineePanValid = true;
                  } else if(scope.nomineePayload.nominees[scope.dupIndex].panNumber !== scope.pan) {
                    scope.nomineePanValid = true;
                  }
                } else if (i !== index && scope.nomineePayload.nominees[i].nomineePanInvalid == false && scope.nomineePayload.nominees[index].nomineePanInvalid == false) {
                  if(!scope.dupIndex)  {
                    scope.nomineePanValid = true;
                  } else if(scope.nomineePayload.nominees[scope.dupIndex].panNumber !== scope.pan) {
                    scope.nomineePanValid = true;
                  }
                } else if(i != index && scope.nomineePayload.nominees[i].nomineePanInvalid == true) {
                  if(scope.nomineePayload.nominees[scope.indexOne].panNumber == scope.nomineePayload.nominees[scope.indexTwo].panNumber) {
                    scope.nomineePanValid = false;
                  } else if(scope.indexTwo !== i && scope.nomineePayload.nominees[i].panNumber == scope.nomineePayload.nominees[scope.indexTwo].panNumber){
                    scope.nomineePanValid = false;
                  } else {
                    scope.nomineePanValid = true;
                  }
                } else {
                   if(typeof scope.indexOne !== 'undefined' && typeof scope.indexTwo !== 'undefined' && (scope.nomineePayload.nominees[scope.indexOne].panNumber == scope.nomineePayload.nominees[scope.indexTwo].panNumber)) {
                     scope.nomineePanValid = false;
                   } else {
                     scope.nomineePanValid = true;
                   }
                }
              }
            }

            if(typeof scope.dupIndex !== 'undefined') {
              if(scope.nomineePayload.nominees[scope.dupIndex].panNumber == scope.pan) {
                scope.nomineePanValid = false;
              }
            }

            for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              if(i != index && typeof scope.indexTwo !== 'undefined' && typeof scope.indexTwo !== 'undefined' && i != scope.indexTwo  && scope.nomineePanValid) {
                if(scope.nomineePayload.nominees[scope.indexTwo] && scope.nomineePayload.nominees[scope.indexTwo].panNumber == scope.nomineePayload.nominees[i].panNumber) {
                  scope.nomineePanValid = false;
                }
              } else if(i != index && typeof scope.dupIndex !== 'undefined') {
                if(scope.nomineePayload.nominees[i].panNumber == scope.pan) {
                  scope.nomineePanValid = false;
                }
              }
            }

            if(typeof pan !== 'undefined' && pan !== null) {
             if(pan.length == 10 || scope.minorPanValid == false) {
              scope.minorPanChanged(index, scope.nomineePayload.nominees[index].guardianPanNumber , false)
             }
            }
           }
        }

        scope.minorPanChanged = function(index, pan , isCalledFromChange) {
          if(pan == "") {
            scope.nomineePayload.nominees[index].guardianPanNumber = null;
            pan = null;
          }

          if(scope.nomineePayload.nominees[index] && scope.nomineePayload.nominees[index].panNumber && scope.nomineePayload.nominees[index].panNumber == pan) {
            scope.nomineePayload.nominees[index].minorPanInvalid = true;
            scope.errorMessage = scope.nomineeValidateData.GUARDIAN_SAME_NOMINEE;
            scope.minorPanValid = false;
            scope.mdIndex = index;
          } else {

            if(scope.nomineePayload.nominees[index] && scope.nomineePayload.nominees[index].minorPanInvalid && isCalledFromChange == false) {
              isCalledFromChange = true;
            }

            scope.callPan = isCalledFromChange;
            scope.nomineePayload.nominees[index].minorPanInvalid = false;
            scope.errorMessage = '';

            for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
             if(i != index) {
                if(scope.nomineePayload.nominees[i].panNumber && scope.nomineePayload.nominees[i].panNumber == scope.pan) {
                    scope.minorPanValid = false;
                    break;
                } else if(typeof scope.mdIndex !== 'undefined' && scope.nomineePayload.nominees[scope.mdIndex] && scope.pan && scope.nomineePayload.nominees[scope.mdIndex].panNumber == scope.nomineePayload.nominees[scope.mdIndex].guardianPanNumber) {
                    scope.minorPanValid = false;
                    break;
                } else if(!scope.isGuardian && i == scope.invalidPanIndex) {
                    scope.nomineePayload.nominees[scope.invalidPanIndex].minorPanInvalid = true;
                    scope.minorPanValid = false;
                    scope.errorMessage = scope.errMessg;
                    break;
                }
             } else {
                scope.minorPanValid = true;
                scope.errorMessage = "";
                if(typeof scope.invalidPanIndex !== 'undefined' && i == scope.invalidPanIndex) {
                    scope.isGuardian = true;
                    scope.nomineePayload.nominees[scope.invalidPanIndex].minorPanInvalid = false;
                }
             }
            }

            if(typeof pan == 'undefined' || pan == null) {
              for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                if(i != index && scope.nomineePayload.nominees[i].minorPanInvalid == true) {
                  scope.minorPanValid = false;
                  break;
                }
              }
            }


            var success = function (resp) {
              if(resp.data && resp.status) {
                if(!resp.data.panVerifiedFlag) {
                  scope.nomineePayload.nominees[index].minorPanInvalid = true;
                  scope.errMessg = resp.data.message;
                  scope.minorPanValid = false;
                  scope.errorMessage = scope.errMessg;
                  scope.isGuardian = false;
                  scope.invalidPanIndex = index;
                } else {
                scope.nomineePayload.nominees[index].minorPanInvalid = false;
                if(scope.invalidPanIndex && scope.nomineePayload.nominees[scope.invalidPanIndex]) {
                  if(scope.nomineePayload.nominees[scope.invalidPanIndex].minorPanInvalid == false) {
                    for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                      if(i != index) {
                        if(scope.nomineePayload.nominees[i].minorPanInvalid) {
                          scope.minorPanValid = false;
                          break;
                        } else {
                          scope.minorPanValid = true;
                        }
                      }
                    }
                      scope.isGuardian = true;
                    }
                  } else {
                      for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                        if(i != index) {
                          if((scope.nomineePayload.nominees[i].guardianPanNumber !== null && typeof scope.nomineePayload.nominees[i].guardianPanNumber !== 'undefined') && scope.nomineePayload.nominees[i].minorPanInvalid) {
                            scope.minorPanValid = false;
                            break;
                          } else {
                            scope.minorPanValid = true;
                          }
                        }
                      }
                  }
                }
              } else {
                MessageService.error(resp.message);
                scope.nomineePayload.nominees[index].minorPanInvalid = true;
                scope.errMessg = resp.message;
                scope.minorPanValid = false;
                scope.errorMessage = scope.errMessg;
                scope.isGuardian = false;
                scope.invalidPanIndex = index;
              }
            }, error = function (resp) {
              MessageService.error(resp.message);
              scope.nomineePayload.nominees[index].minorPanInvalid = true;
              scope.errMessg = resp.message;
              scope.minorPanValid = false;
              scope.errorMessage = scope.errMessg;
              scope.isGuardian = false;
              scope.invalidPanIndex = index;
            };

            if(typeof pan !== 'undefined' && pan !== null && isCalledFromChange) {
              InvestorService.post({
                child1: 'profile',
                child2: 'guardian',
                child3: 'verifyPan'
              },{pan : pan}).$promise.then(success, error);
            }
          }

        }

        function getStateList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.stateList = resp.data.states;
            } else {
              scope.stateList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
              scope.stateList = null;
          };
          InvestorService.get({
            child1: 'folio',
            child2: 'state',
            child3: 'list'
          }).$promise.then(success, error);
        }

        scope.changeState = function(index, stateCode) {
          if (!stateCode) {
            return;
          }
          scope.stateList.map( function (state) {
            if(state.stateCode === stateCode){
              scope.nomineePayload.nominees[index].nomineeAddress.state = state.stateCode;
            }
          });
        }

        scope.changeStateGuardian = function(index, stateCode) {
          scope.stateList.map( function (state) {
            if(state.stateCode === stateCode){
              scope.nomineePayload.nominees[index].guardianAddress.state = state.stateCode;
            }
          });
        }

        scope.changeCountryGuardian = function(index, countryCode) {
          if (!countryCode) {
            scope.nomineePayload.nominees[index].guardianAddress.country = null;
            scope.nomineePayload.nominees[index].guardianAddress.state  = null;
            return;
          }
          scope.nomineeCountryList.map( function (country) {
            if(country.countryCode === countryCode){
                if (scope.nomineePayload.nominees[index].guardianAddress.country != 'IN'){
                    for(var i = 0; i < scope.stateList.length; i++){
                      if (scope.stateList[i].stateCode == 'XX'){
                        scope.nomineePayload.nominees[index].guardianAddress.state  = scope.stateList[i].stateCode;
                        break;
                      }
                    }
                }
            }
          });
        }

        scope.changeCountry = function(index, countryCode) {
          if (!countryCode) {
            scope.nomineePayload.nominees[index].nomineeAddress.country = null;
            scope.nomineePayload.nominees[index].nomineeAddress.state  = null;
            return;
          }
          scope.nomineeCountryList.map( function (country) {
            if(country.countryCode === countryCode){
                if (scope.nomineePayload.nominees[index].nomineeAddress.country != 'IN'){
                    for(var i = 0; i < scope.stateList.length; i++){
                      if (scope.stateList[i].stateCode == 'XX'){
                        scope.nomineePayload.nominees[index].nomineeAddress.state  = scope.stateList[i].stateCode;
                        break;
                      }
                    }
                }
            }
          });
        }
        scope.checkOptOutNominee = function(){
              scope.optOutNominee= !scope.optOutNominee;
              if(scope.optOutNominee == true){
                localStorage.setItem('optOutNomineeFromExistingFolioCreation',"true");
              } else {
                localStorage.setItem('optOutNomineeFromExistingFolioCreation',"false");
              }

        }
        scope.changeNomineeIsMinor = function(index){
          scope.nomineePayload.nominees[index].dob = "";
          scope.dataMinDate = "";
          scope.dataMaxDate = "";
          scope.isMinorMinDate = "";
          scope.isMinorMaxDate = "";
          $timeout(function () {
            if(scope.nomineePayload.nominees[index].minor){
              scope.dobRequired = true;
            }else{
              scope.dobRequired = false;
            }
            var currentDate = Date();
            var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
            var initiateDate = new Date('January 01, 1900 00:00:00');
            scope.isMinorMinDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
            scope.isMinorMaxDate = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
            scope.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
            scope.dataMinDate = $window.moment(Date.parse(initiateDate));
            if (scope.nomineePayload.nominees[scope.activeTab].minor) {
              scope.nomineePayload.nominees[scope.activeTab].minor = true;
              scope.nomineePayload.nominees[scope.activeTab].panNumber = null;
              scope.nomineePayload.nominees[scope.activeTab].minor = true;
              scope.nomineePayload.nominees[index].applicantPersonalIdentifiers = scope.nomineePayload.nominees[index].applicantPersonalIdentifiers.filter(function(obj, index) {
                return obj.identityProofType !== 'DRIVING_LICENSE';
              });
            } else {
              scope.nomineePayload.nominees[scope.activeTab].applicantPersonalIdentifiers = angular.copy(scope.applicantPersonalIdentifiers);
              scope.nomineePayload.nominees[scope.activeTab].minor = false;
              scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber = null;
              scope.nomineePayload.nominees[scope.activeTab].guardianName = null;
              scope.nomineePayload.nominees[scope.activeTab].guardianRelationWithNominee = null;
            }
            resetIncapacitationDetails();
          });
        }
        scope.setInitiatedDate = function(){
          $timeout(function () {
            var currentDate = Date();
            var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
            var initiateDate = new Date('January 01, 1900 00:00:00');
            scope.isMinorMinDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
            scope.isMinorMaxDate = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
            scope.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
            scope.dataMinDate = $window.moment(Date.parse(initiateDate));
          }, 1000);
        }
        scope.setInitiatedDate();

        function getCountryCode(countryCode) {
          if (countryCode) {
            var code = scope.nomineeCountryList.filter( function (country) {
              if(country.countryName === countryCode || country.countryCode === countryCode){
                return country.countryCode;
              }
            });
            return code[0].countryCode;
          }
        }

        function updateDob(date, i) {
          if (!date) {
            return;
          }
          scope.nomineePayload.nominees[i].dob = date.clone().format('DD-MMM-YYYY').toString();
          var age = $window.moment().diff(date, 'years');
          if (age < 18) {
            scope.nomineePayload.nominees[i].minor = true;
            scope.nomineePayload.nominees[i].panNumber = null;
          } else {
            scope.nomineePayload.nominees[i].minor = false;
            scope.nomineePayload.nominees[i].guardianPanNumber = null;
            scope.nomineePayload.nominees[i].guardianName = null;
            scope.nomineePayload.nominees[i].guardianRelationWithNominee = null;
          }
        };

        function getPersonalIdentifier(cb) {
          cb = cb || function() {};
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.applicantPersonalIdentifiers = resp.data.identityProofs;
              cb(true);
            } else {
              scope.applicantPersonalIdentifiers = [];
              MessageService.error(resp.message);
              cb(false);
            }
          }, error = function () {
            cb(false);
            scope.applicantPersonalIdentifiers = [];
          };
          InvestorService.get({
            child1: 'identity-proofs'
          }).$promise.then(success, error);
        }

        function changePersonalIdentifier(index, identifier) {
          scope.applicantPersonalIdentifiers.map(function (el) {
            if (identifier !== "AADHAR_CARD" && scope.nomineePayload.nominees[index].hasOwnProperty('aadharCard')) {
              scope.nomineePayload.nominees[index].aadharCard = '';
              aadharCardChanged(index, scope.nomineePayload.nominees[index].aadharCard);
            }

            if (identifier !== "DRIVING_LICENSE" && scope.nomineePayload.nominees[index].hasOwnProperty('drivingLicense')) {
              scope.nomineePayload.nominees[index].drivingLicense = '';
              drivingLicenseChanged(index, scope.nomineePayload.nominees[index].drivingLicense);
            }

            if (identifier !== "PAN_CARD" && scope.nomineePayload.nominees[index].hasOwnProperty('panNumber')) {
              scope.nomineePayload.nominees[index].panNumber = '';
              scope.nomineePanChanged(index, scope.nomineePayload.nominees[index].panNumber);
            }

            if (identifier !== "PASSPORT" && scope.nomineePayload.nominees[index].hasOwnProperty('passport')) {
              scope.nomineePayload.nominees[index].passport = '';
              scope.passportChanged(index, scope.nomineePayload.nominees[index].passport);
            }

            if (el.identityProofType === identifier) {
              scope.nomineePayload.nominees[index].identityProofType = el.identityProofType;
              scope.nomineePayload.nominees[index].identityProofCamsCode = el.identityProofCamsCode;
            }
          });
        }

        function selectedNominee(value) {
          if (scope.nomineePayload.incapcitationNomineeIndex !== null) {
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = parseInt(scope.nomineePayload.incapcitationNomineeIndex) + 1;
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = scope.nomineePayload.nominees[parseInt(scope.nomineePayload.incapcitationNomineeIndex)].nomineeName;
          } else {
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage = null;
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount = null;
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = null;
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = null;
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration = {};
          }
        }

        function changeEmailId(index, emailId) {
          if (!emailId) {
            return;
          }
          if (scope.nomineePayload.soleApplicantDetail.personalDetail.email && scope.nomineePayload.soleApplicantDetail.personalDetail.email.toLowerCase() === scope.nomineePayload.nominees[index].emailId.toLowerCase()) {
            scope.nomineePayload.nominees[index].emailIdInvalid = true;
            scope.emailIdValid = false;
            scope.errorMessageEmail = scope.nomineeValidateData.EMAILID_SAME_INVESTOR;
          } else {
            scope.nomineePayload.nominees[index].emailIdInvalid = false;
            scope.emailIdValid = true;
            scope.errorMessageEmail = null;
          }
        }
        function changeMobileNumber(index, mobile) {
          if (!mobile) {
            return;
          }
          if (scope.nomineePayload.soleApplicantDetail.personalDetail.mobileNo && scope.nomineePayload.soleApplicantDetail.personalDetail.mobileNo === scope.nomineePayload.nominees[index].mobile) {
            scope.nomineePayload.nominees[index].mobileInvalid = true;
            scope.mobileValid = false;
            scope.errorMessageMobile = scope.nomineeValidateData.MOBILE_SAME_INVESTOR;
          } else {
            scope.nomineePayload.nominees[index].mobileInvalid = false;
            scope.mobileValid = true;
            scope.errorMessageMobile = null;
          }
        }

        function drivingLicenseChanged(index, license) {
          scope.nomineeLicenseValid = true;
          scope.nomineePayload.nominees[index].nomineeLicenseInvalid = false;

          if (!scope.nomineePayload.nominees[index].sameIndexLiscense) {
            scope.nomineePayload.nominees[index].sameIndexLiscense = [];
          }

          if (scope.nomineePayload.nominees.length === 1) {
            scope.nomineeLicenseValid = true;
          } else if (scope.nomineePayload.nominees.length > 1) {
            for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('drivingLicense') && scope.nomineePayload.nominees[i].drivingLicense === license) {
                scope.nomineePayload.nominees[index].nomineeLicenseInvalid = true;
                scope.nomineePayload.nominees[i].nomineeLicenseInvalid = true;
                scope.nomineePayload.nominees[index].sameIndexLiscense.push(i);
                if (!scope.nomineePayload.nominees[i].sameIndexLiscense) {
                  scope.nomineePayload.nominees[i].sameIndexLiscense = [];
                }
                scope.nomineePayload.nominees[i].sameIndexLiscense.push(index);
                scope.nomineeLicenseValid = false;
              } else if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('drivingLicense')) {

                if (!scope.nomineePayload.nominees[i].sameIndexLiscense) {
                  scope.nomineePayload.nominees[i].sameIndexLiscense = [];
                }

                if (scope.nomineePayload.nominees[index].sameIndexLiscense.includes(i)) {
                  var indexEL = scope.nomineePayload.nominees[index].sameIndexLiscense.indexOf(i);
                  scope.nomineePayload.nominees[index].sameIndexLiscense.splice(indexEL,1);

                  indexEL = scope.nomineePayload.nominees[i].sameIndexLiscense.indexOf(index);
                  scope.nomineePayload.nominees[i].sameIndexLiscense.splice(indexEL,1);

                  if (scope.nomineePayload.nominees[i].sameIndexLiscense.length === 0) {
                    scope.nomineePayload.nominees[i].nomineeLicenseValid = false;
                  }
                }
                if (scope.nomineePayload.nominees[i].sameIndexLiscense && scope.nomineePayload.nominees[i].sameIndexLiscense.length !== 0){
                  scope.nomineeLicenseValid = false;
                }
              }
            }
          }
        }

        function aadharCardChanged(index, aadharCard) {
          // scope.nomineeAadhaarValid = true;
          // scope.nomineePayload.nominees[index].nomineeAadhaarInvalid = false;
          // if (!scope.nomineePayload.nominees[index].sameIndex) {
          //   scope.nomineePayload.nominees[index].sameIndex = [];
          // }
          //
          // if (scope.nomineePayload.nominees.length == 1) {
          //   scope.nomineeAadhaarValid = true;
          // } else if (scope.nomineePayload.nominees.length > 1) {
          //   for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
          //
          //     if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('aadharCard') && scope.nomineePayload.nominees[i].aadharCard === aadharCard) {
          //       scope.nomineePayload.nominees[index].nomineeAadhaarInvalid = true;
          //       scope.nomineePayload.nominees[i].nomineeAadhaarInvalid = true;
          //       scope.nomineePayload.nominees[index].sameIndex.push(i);
          //       if (!scope.nomineePayload.nominees[i].sameIndex) {
          //         scope.nomineePayload.nominees[i].sameIndex = [];
          //       }
          //       scope.nomineePayload.nominees[i].sameIndex.push(index);
          //       scope.nomineeAadhaarValid = false;
          //     } else if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('aadharCard')) {
          //
          //       if (!scope.nomineePayload.nominees[i].sameIndex) {
          //         scope.nomineePayload.nominees[i].sameIndex = [];
          //       }
          //       if (scope.nomineePayload.nominees[index].sameIndex.includes(i)) {
          //         var indexEL = scope.nomineePayload.nominees[index].sameIndex.indexOf(i);
          //         scope.nomineePayload.nominees[index].sameIndex.splice(indexEL,1);
          //         indexEL = scope.nomineePayload.nominees[i].sameIndex.indexOf(index);
          //         scope.nomineePayload.nominees[i].sameIndex.splice(indexEL,1);
          //
          //         if (scope.nomineePayload.nominees[i].sameIndex.length === 0) {
          //           scope.nomineePayload.nominees[i].nomineeAadhaarInvalid = false;
          //         }
          //       }
          //       if (scope.nomineePayload.nominees[i].sameIndex && scope.nomineePayload.nominees[i].sameIndex.length !== 0){
          //         scope.nomineeAadhaarValid = false;
          //       }
          //     }
          //
          //   }
          // }
        }

        function setStatement() {
          scope.nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration = scope.nomineePayload.accountHoldingDeclaration.nomination ? 'NOMINATION_YES' : 'NOMINATION_NO';
        }

        function setIncapcitationList(index) {
          scope.incapcitationList = [];
          scope.nomineePayload.nominees.forEach(function(nominee, index) {
            if (scope.nomineePayload.nominees[index].nomineeName) {
              scope.incapcitationList.push(angular.copy({
                key : scope.nomineePayload.nominees[index].nomineeName + '-' + scope.nomineeEnum[index],
                value : index,
                isMinor: scope.nomineePayload.nominees[index].minor
              }));
            }
          });
          scope.nomineePayload.incapcitationNomineeIndex = scope.nomineePayload.incapcitationNomineeIndex === index ? null : scope.nomineePayload.incapcitationNomineeIndex;
        }

        function resetIncapacitationDetails() {
          scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration = {};
        }

        function passportChanged(index, passport) {
          scope.nomineePassportValid = true;
          scope.nomineePayload.nominees[index].nomineePassportInvalid = false;

          if (!scope.nomineePayload.nominees[index].sameIndexPassport) {
            scope.nomineePayload.nominees[index].sameIndexPassport = [];
          }

          if (scope.nomineePayload.nominees.length === 1) {
            scope.nomineePassportValid = true;
          } else if (scope.nomineePayload.nominees.length > 1) {
            for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('passport') && scope.nomineePayload.nominees[i].passport === passport) {
                scope.nomineePayload.nominees[index].nomineePassportInvalid = true;
                scope.nomineePayload.nominees[i].nomineePassportInvalid = true;
                scope.nomineePayload.nominees[index].sameIndexPassport.push(i);
                if (!scope.nomineePayload.nominees[i].sameIndexPassport) {
                  scope.nomineePayload.nominees[i].sameIndexPassport = [];
                }
                scope.nomineePayload.nominees[i].sameIndexPassport.push(index);
                scope.nomineePassportValid = false;
              } else if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('passport')) {

                if (!scope.nomineePayload.nominees[i].sameIndexPassport) {
                  scope.nomineePayload.nominees[i].sameIndexPassport = [];
                }

                if (scope.nomineePayload.nominees[index].sameIndexPassport.includes(i)) {
                  var indexEL = scope.nomineePayload.nominees[index].sameIndexPassport.indexOf(i);
                  scope.nomineePayload.nominees[index].sameIndexPassport.splice(indexEL,1);

                  indexEL = scope.nomineePayload.nominees[i].sameIndexPassport.indexOf(index);
                  scope.nomineePayload.nominees[i].sameIndexPassport.splice(indexEL,1);

                  if (scope.nomineePayload.nominees[i].sameIndexPassport.length === 0) {
                    scope.nomineePayload.nominees[i].nomineePassportValid = false;
                  }
                }
                if (scope.nomineePayload.nominees[i].sameIndexPassport && scope.nomineePayload.nominees[i].sameIndexPassport.length !== 0){
                  scope.nomineePassportValid = false;
                }
              }
            }
          }
        }
      }
    }
  }



})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('folioJointHolders', folioJointHolders);

  /*@ngInject*/
  function folioJointHolders(AuthService, MessageService, InvestorService, AppConstants, ModalService,
                             InvestorFolioModel, LoaderService, $stateParams, UtilService, $window, $state, InvestorServiceV3,moment) {
    return {
      restrict: 'E',
      scope: {jointHoldersPayload: '=', MainFolioParent :'=', firstFlow:'@'},
      templateUrl: 'app/investor/addFolio/folio-directive/jointHolders/folio-joint-holders-directive.html',
      link: function (scope) {
        // vm.defaultMinorDob = $window.moment().toString();
       /* scope.MainFolioParent={};
        scope.jointHoldersPayload={};*/
        scope.defaultsoleApplicantNWDate = $window.moment().toString();
        scope.NumToWord = $window.NumToWord;
        scope.countryList = [];
        scope.occupationList = [];
        scope.incomeSlabList = [];
        scope.taxStatusList = [];
        scope.taxIdTypeList = [];
        scope.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
        scope.pattern = AppConstants;
        scope.POLITICAL_STATUS = AppConstants.INVESTOR_POLITICAL_STATUS;
        scope.currentJointHolder = {};
        scope.currentJointHolder.index = 0;
        scope.defaultDob = $window.moment().toString();
        scope.fileTaxActionJointHolder = fileTaxActionJointHolder;
        scope.addMoreJointHolder = addMoreJointHolder;
        scope.deleteCurrentJointHolder = deleteCurrentJointHolder;
        // vm.uploadMinorDobFile = uploadMinorDobFile;
        // vm.uploadMinorRelationshipFile = uploadMinorRelationshipFile;
        // scope.changeTaxStatus = changeTaxStatus;
        scope.saveFolio = saveFolio;
        scope.continueFolio = continueFolio;
        scope.isSoleApplicantMinor = false;
        scope.fatcaArray = [];
        // vm.minorAgeProof = null;
        scope.minDate = moment().subtract(1, 'years').format("DD-MMM-YYYY").toString();
        scope.enum = {
          0: 'First',
          1: 'Second',
          2: 'Third',
          3: 'Fourth',
          4: 'Fifth'
        };
        scope.notValid2ndHolder=false;
        scope.jointHoldersPayload = angular.fromJson($window.sessionStorage.investorForm) || InvestorFolioModel.getInvestorFolioFormDataModel();
       // scope.MainFolioParent.holdmode = scope.jointHoldersPayload &&  scope.jointHoldersPayload.holdmode;
        // var token = AuthService.getToken();
        scope.back = back;
        scope.init = init;
        // vm.setHoldmode = setHoldmode;

        init();


        function init() {
          dataSanitize();
          if(scope.jointHoldersPayload.jointHolders.length < 2) {
            getTaxStatusList(scope.jointHoldersPayload.jointHolders[0].nriFlag, 0, function () {});
          } else if(scope.jointHoldersPayload.jointHolders && scope.jointHoldersPayload.jointHolders.length){
            scope.jointHoldersPayload.jointHolders.forEach(function (item, index) {
              getTaxStatusList(item.nriFlag, index, function () {})
            })
          }
          getInvestorOccupationList();
          incomeSlab();
          getCountryList();
          getTaxIdTypeList();
          getAddressType();
          checkValid2ndHolder(scope.jointHoldersPayload.jointHolders);
          fetchDynamicContent();
        }








        scope.addNewResidencyFields = function () {

          scope.fatcaArray.push(
            {
              "countryName": '',
              "birthCity": '',
              "taxIdType": '',
              "taxIdNumber": ''
            });
        };

        scope.addAvailableResidency = function (fatca) {
          if (fatca.fatcaTax1) {
            scope.fatcaArray.push(fatca.fatcaTax1);
          }
          if (fatca.fatcaTax2) {
            scope.fatcaArray.push(fatca.fatcaTax2);
          }
          if (fatca.fatcaTax3) {
            scope.fatcaArray.push(fatca.fatcaTax3);
          }
        };

        scope.setSelectedResidency = function (payload) {
          if (payload.guardianDetail && !payload.guardianDetail.fatca) {
            payload.guardianDetail.fatca = {};
          }
          var fatca = payload.guardianDetail.fatca;

          delete fatca.fatcaTax1;
          delete fatca.fatcaTax2;
          delete fatca.fatcaTax3;

          if (payload.guardianDetail.payTaxInIndia) {
            return;
          }

          if (scope.fatcaArray[0]) {
            fatca.fatcaTax1 = scope.fatcaArray[0];
          }

          if (scope.fatcaArray[1]) {
            fatca.fatcaTax2 = scope.fatcaArray[1];
          }

          if (scope.fatcaArray[2]) {
            fatca.fatcaTax3 = scope.fatcaArray[2];
          }

        }

        scope.deleteTaxResidencyFromFatca = function (index) {
          scope.fatcaArray.splice(index, 1);
        }

        function dataSanitize() {
          angular.forEach(scope.jointHoldersPayload.jointHolders, function (holder) {
            if(holder && (angular.isUndefined(holder.fatcaDetail)||angular.isUndefined(holder.fatcaDetail.payTaxInIndia))){
              holder.fatcaDetail = holder.fatcaDetail || {};
              holder.fatcaDetail.payTaxInIndia = true;
            }
            if(holder.fatcaDetail.fatcaTax2 && holder.fatcaDetail.fatcaTax2.taxPayingCountry !== ''){
              holder.fatcaDetail.secondTax = holder.fatcaDetail.fatcaTax2 ? true : false;
            }
            if(holder.fatcaDetail.fatcaTax3 && holder.fatcaDetail.fatcaTax3.taxPayingCountry !== ''){
              holder.fatcaDetail.thirdTax = holder.fatcaDetail.fatcaTax3 ? true : false;
            }
            if (holder.grossAnnualIncome) {
              delete holder.netWorth;
              delete holder.netWorthDate
            }
          });

        }

        function getTaxStatusList(nriFlag, index, cb) {
          cb = cb || function () {}
          if (scope.jointHoldersPayload && scope.jointHoldersPayload.minor) {
            var data = {taxStatusFilter: 'MINOR', nriFlag: nriFlag};
          } else {
            data = {taxStatusFilter: 'ADULT', nriFlag: nriFlag};
          }
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.taxStatusList[index] = resp.data.taxStatus;
              if(scope.taxStatusList && scope.taxStatusList.length > 0) {
                scope.taxStatusList.forEach(function (item, index) {
                  if(!scope.jointHoldersPayload.jointHolders[index].nriFlag) {
                    scope.jointHoldersPayload.jointHolders[index].taxStatusCode = item[0].taxStatusCode;
                    scope.changedTaxStatus();
                  }
                })
              }
              cb();
            } else {
              scope.taxStatusList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.taxStatusList = null;
          };
          InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
        }

        function getInvestorOccupationList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.occupationList = resp.data.investorOccupations;
            } else {
              scope.occupationList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.occupationList = null;
          };
          InvestorService.get({child1: 'folio', child2: 'occupation'}).$promise.then(success, error);
        }

        function incomeSlab() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                scope.incomeSlabList = resp.data.incomeSlabList;
                if (scope.jointHoldersPayload.jointHolders.length > 0 && scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].grossAnnualIncome) {
                  delete scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].netWorth;
                  delete scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].netWorthDate
                }
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
            };
          InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success, error);
        }

        /*function getPayload() {
          scope.jointHoldersPayload = angular.fromJson($window.sessionStorage.investorForm) || InvestorFolioModel.getInvestorFolioFormDataModel();
        }*/


        scope.changeDob = function (date) {

          if (!date) {
            return;
          }
          // vm.defaultDob = date.toString();
          scope.jointHoldersPayload.minorDob = date.clone().format('DD-MMM-YYYY').toString();
        };

        scope.changeStartDate = function (date) {
          if (!date) {
            return;
          }
          scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
          // vm.formData.netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
        }

        function getCountryList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.countryList = resp.data.countries;
              if (scope.countryList.length > 0 && !scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].fatcaDetail.birthCountry) {
                scope.countryList.map(function(countries) {
                  if (countries.countryCode === 'IN') {
                    scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].fatcaDetail.birthCountry = countries.countryCode;
                  }
                });
              }
            } else {
              scope.countryList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.countryList = null;
          };
          InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
        }

        function getTaxIdTypeList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.taxIdTypeList = resp.data.taxIdTypeResponses;
            } else {
              scope.taxIdTypeList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.taxIdTypeList = null;
          };
          InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success, error);
        }

        function getAddressType() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.addressTypeList = resp.data.addressTypeResponses;
              if (scope.addressTypeList.length > 0 && !scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].fatcaDetail.addressType) {
                scope.addressTypeList.map(function(addressTypeResponses) {
                  if (addressTypeResponses.value === 'RESIDENTIAL') {
                    scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].fatcaDetail.addressType = addressTypeResponses.value;
                  }
                });
              }
            } else {
              scope.addressTypeList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.addressTypeList = null;
          };
          InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success, error);
        }

        function fileTaxActionJointHolder(index) {
          if (!scope.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia) {
            scope.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax1 = {"taxPayingCountry": "", "taxId": "", "taxIdType": ""};
            scope.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax2 = {"taxPayingCountry": "", "taxId": "", "taxIdType": ""};
            scope.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax3 = {"taxPayingCountry": "", "taxId": "", "taxIdType": ""};
          } else {
            scope.jointHoldersPayload.jointHolders[index].fatcaDetail && (delete scope.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax1);
            scope.jointHoldersPayload.jointHolders[index].fatcaDetail && (delete scope.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax2);
            scope.jointHoldersPayload.jointHolders[index].fatcaDetail && (delete scope.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax3);
          }

        }

        function addMoreJointHolder() {
          var array = scope.jointHoldersPayload.jointHolders || [];
          if (scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].jointHolderName || scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].firstName) {
            if (array.length < 2) {
              var blankObj = InvestorFolioModel.getNewJointHolder();
              blankObj.nriFlag = false;
              array.push(blankObj);
              InvestorFolioModel.setInvestorFolioModel(scope.jointHoldersPayload);
              $window.sessionStorage.investorForm = angular.toJson(scope.jointHoldersPayload);
            } else {
              array.length = 0;
            }
            scope.currentJointHolder.index++;
            pan4JointHolders();
          }
          else {
            //angular.element('#nomineeName-'+vm.parentIndex).focus();
            //MessageService.error("please enter joint holder name");
          }
        }

        function deleteCurrentJointHolder(parentIndex) {
          var success = function () {
            var model = scope.jointHoldersPayload.jointHolders || [];
            model.splice(parentIndex, 1);
            scope.taxStatusList.splice(parentIndex, 1);
            if(parentIndex == 0) {
              scope.currentJointHolder.index = 0;
            } else {
              scope.currentJointHolder.index = (parentIndex * 1) - 1;
            }
            if (model.length == 0) {
              scope.jointHoldersPayload.jointHolders = [];
              // InvestorModel.setTab({tab3: false, tabJointHolderAddable: false});
              InvestorFolioModel.setInvestorFolioModel(scope.jointHoldersPayload);
              $window.sessionStorage.investorForm = angular.toJson(scope.jointHoldersPayload);
              $state.go('main.folio.soleApplicant',{investorId: $stateParams.investorId});
            }
            checkValid2ndHolder(model);
          };
          ModalService.confirmCancelModal({Text: 'Do you want to delete ' + scope.enum[parentIndex + 1] + ' Holder?'}, success);
        }

        function pan4JointHolders() {
          var addFlag = true;
          var successPanDetails = function (result) {
              if (!angular.isString(result) && (result.status && result.data && result.data.kycverified)) {

                if (scope.jointHoldersPayload.soleApplicantDetail.selfDetail.panNumber != result.data.pan && scope.jointHoldersPayload.jointHolders[0].pan != result.data.pan) {
                  angular.forEach(scope.jointHoldersPayload.jointHolders, function (val) {
                    if (val.panNumber == result.data.pan) {
                      MessageService.error("Valid PAN details required to add joint holder");
                      addFlag = false;
                      scope.jointHoldersPayload.jointHolders.splice(scope.currentJointHolder.index, 1);
                      --scope.currentJointHolder.index;
                    }
                  });
                  if (addFlag) {
                    var newModel = InvestorFolioModel.getNewJointHolder();
                    scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index] = newModel;
                    scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].jointHolderName = result.data.name;
                    scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].firstName = result.data.name;
                    scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].pan = result.data.pan;
                    scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].email = result.data.email;
                    scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].mobileNumber = result.data.mobileNumber;
                    scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].nriFlag = result.data.nriFlag;
                    if(scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].nriFlag !== scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index - 1].nriFlag) {
                      getTaxStatusList(scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].nriFlag, scope.currentJointHolder.index, function () {
                        setInvestorForm();
                      });
                    } else {
                      scope.taxStatusList[scope.currentJointHolder.index] = angular.copy(scope.taxStatusList[0]);
                      if(scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].nriFlag == false && scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index - 1].nriFlag == false) {
                        scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].taxStatusCode = '01';
                        scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index - 1].taxStatusCode = '01';
                      }
                    }
                  }

                } else {
                  scope.jointHoldersPayload.jointHolders.splice(scope.currentJointHolder.index, 1);
                  --scope.currentJointHolder.index;
                  setInvestorForm();
                  MessageService.error("You have already added a Joint Holder using this PAN.");
                }
              } else if (angular.isString(result) && result === "warning") {
                errorPanDetails();
              } else {
                MessageService.error(result.message || 'Kyc verification is pending.');
              }
            },
            errorPanDetails = function () {
              scope.jointHoldersPayload.jointHolders.splice(scope.currentJointHolder.index, 1);
              --scope.currentJointHolder.index;
              setInvestorForm();
            };
          var labelSetter = {type: 'jointholders', label: {header: 'ADD JOINT HOLDER', pan: 'PAN', dob: 'Joint Holder DOB'}, nriFlag: scope.jointHoldersPayload.jointHolders[scope.currentJointHolder.index].nriFlag || false}
          ModalService.checkPan4Holder(labelSetter, successPanDetails, errorPanDetails);
        }

        /*function submitJointHolder() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              MessageService.success(resp.data.message);
              scope.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia = true;

              InvestorFolioModel.setInvestorModel(scope.jointHoldersPayload);
              $state.go('main.folio.bankdetails');
            } else {
              scope.jointHoldersPayload.soleApplicantDetail = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            // vm.formData.soleApplicantDetail = null;
          };
          // InvestorService.post({child1: 'folio', child2: 'createNewFolio'}, null).$promise.then(success, error);
          InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);

        }*/

        function saveFolio(stateToMove) {
          LoaderService.showLoader();
          sanitize4Facta();
          var payload = scope.jointHoldersPayload;
          if (payload) {
            payload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
            payload.folioSaveStep = "THREE";
          }
          var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              localStorage.setItem('folioId', resp.data.id);
              InvestorFolioModel.setInvestorFolioModel(resp.data);
              $window.sessionStorage.investorForm = angular.toJson(scope.jointHoldersPayload);
              if (stateToMove) {
                if ($stateParams.investorId) {
                  $state.go(stateToMove, {investorId: $stateParams.investorId});
                } else {
                  $state.go(stateToMove);
                }
              }else {
                MessageService.success('Saved Successfully.');
                $state.go('welcome');
              }
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          // InvestorService.post({child1: 'folio', child2: 'saveFolio'}, payload).$promise.then(success, error);
          InvestorServiceV3.post({child1: 'folio', child2: 'save'}, payload).$promise.then(success, error);

        }
        function continueFolio(stateToMove) {
          LoaderService.showLoader();
          sanitize4Facta();
          var payload = scope.jointHoldersPayload;
          if (payload) {
            payload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
            payload.folioSaveStep = "THREE";
          }
          var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              localStorage.setItem('folioId', resp.data.id);
              InvestorFolioModel.setInvestorFolioModel(resp.data);
              $window.sessionStorage.investorForm = angular.toJson(scope.jointHoldersPayload);
              if (stateToMove) {
                if ($stateParams.investorId) {
                  $state.go(stateToMove, {investorId: $stateParams.investorId});
                } else {
                  $state.go(stateToMove);
                }
              }else MessageService.success('Saved Successfully.');
            } else {
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                });
              } else  {
                MessageService.error(resp.message);
              }
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          // InvestorService.post({child1: 'folio', child2: 'saveFolio'}, payload).$promise.then(success, error);
          InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);

        }

        function sanitize4Facta(){
          angular.forEach(scope.jointHoldersPayload.jointHolders, function (holder) {
            angular.forEach([1,2,3],function (val) {

              if(holder.fatcaDetail['fatcaTax'+val]
                && ((angular.isUndefined(holder.fatcaDetail['fatcaTax'+val].taxPayingCountry) || holder.fatcaDetail['fatcaTax'+val].taxPayingCountry == '')
                  || angular.isUndefined(holder.fatcaDetail['fatcaTax'+val].taxIdType))){
                delete holder.fatcaDetail['fatcaTax'+val];
              }


            });
            /*if(holder.fatcaDetail.fatcaTax1 && (angular.isUndefined(holder.fatcaDetail.fatcaTax1.taxPayingCountry) || angular.isUndefined(holder.fatcaDetail.fatcaTax1.taxIdType))){
              delete holder.fatcaDetail.fatcaTax1;
            }if(holder.fatcaDetail.fatcaTax2 && (angular.isUndefined(holder.fatcaDetail.fatcaTax2.taxPayingCountry) || angular.isUndefined(holder.fatcaDetail.fatcaTax2.taxIdType))){
              delete holder.fatcaDetail.fatcaTax2;
            }if(holder.fatcaDetail.fatcaTax3 && (angular.isUndefined(holder.fatcaDetail.fatcaTax3.taxPayingCountry) || angular.isUndefined(holder.fatcaDetail.fatcaTax3.taxIdType))){
              delete holder.fatcaDetail.fatcaTax3;
            }*/
            holder.fatcaDetail.secondTax = holder.fatcaDetail.secondTax ? holder.fatcaDetail.secondTax : false;
            holder.fatcaDetail.thirdTax = holder.fatcaDetail.thirdTax ? holder.fatcaDetail.thirdTax : false;
          });
        }

        function back() {
          if(scope.firstFlow === 'YES'){
              $state.go('folioDetails.folioCreation',{investorId:$stateParams.investorId});
          }else{
              $state.go('main.folio.soleApplicant',{investorId:$stateParams.investorId});
          }
        }

        //
        // function changeTaxStatus(index, type){
        //
        //   if(type === '21' || type === '24') {
        //     scope.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia = false;
        //     // scope.changePayTaxOutsideIndiaStatus(true);
        //
        //     fileTaxActionJointHolder(index);
        //   }
        //   else{
        //     scope.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia = true;
        //     fileTaxActionJointHolder(index);
        //   }
        // }



        scope.changedTaxStatus = function (index, type) {
          if (typeof index == 'undefined' || typeof type == 'undefined') {
            return;
          }
          if(type === '21' || type === '24') {
            scope.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia = false;

            // scope.holders.fatcaDetail.payTaxInIndia = false;
            fileTaxActionJointHolder(index);
          }
          else {
            scope.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia = true;

          }
        }


        scope.continue = function () {
          if(scope.firstFlow === 'YES'){
            continueFolio('folioDetails.addNominee',{investorId:$stateParams.investorId});
          }else{
            continueFolio('main.folio.nominee',{investorId:$stateParams.investorId});
          }
          // continueFolio('main.folio.nominee');
        };

        scope.deleteSecond = function(detail) {
          if(detail.fatcaTax3){
            detail.fatcaTax2 = detail.fatcaTax3;
            delete detail.fatcaTax3;
            detail.thirdTax = false;
          } else {
            delete detail.fatcaTax2;
            detail.secondTax = false;
          }
          scope.fatcaDetail = angular.copy(detail);
        }

        scope.deleteThird = function(detail) {
          detail.fatcaTax2 = detail.fatcaTax2;
          delete detail.fatcaTax3;
          detail.thirdTax = false;
          scope.fatcaDetail = angular.copy(detail);
        }

        scope.isObjectEmpty = function(argObj){

          return argObj && Object.keys(argObj) && Object.keys(argObj).length === 0;
        }

       /* function getSoleApplicantPayload() {
          var a = scope.jointHoldersPayload;
          var payload = {
            "soleApplicantDetail": {
              "personalDetail": {
                "firstName": a.firstName,
                "lastName": "",
                "dateOfBirth": a.dateOfBirth,
                "email": ""
              },
              "taxStatusCode": a.taxStatusCode,
              "fatcaAddressType": a.fatcaAddressType,
              "birthCountry": a.birthCountry,
              "birthCity": a.birthCity,
              "occupation": a.occupation,
              "panNumber": $scope.MainFolioParent.panNumber,
              "grossAnnualIncome": a.grossAnnualIncome || "",
              "netWorth": a.netWorth || "",
              "netWorthDate": a.netWorthDate || "",
              "politicalStatus": a.politicalStatus,
              "payTaxInIndia": a.payTaxInIndia,
              "payOutsideIndiaAddresses": a.payOutsideIndiaAddresses,
              "minor": a.minor
            },
            "jointHolders": [],
            "nominees": vm.nomineesResp || [],
            "guardianDetail": null,
            "brokerCode": null,
            "holdmode": a.holdmode,
            "saveStep": null,
            "id": null,
            "newFolioComplete": null
          };

          return payload;
        }*/
        function setInvestorForm() {
          $window.sessionStorage.investorForm = angular.toJson(scope.jointHoldersPayload);
          checkValid2ndHolder(scope.jointHoldersPayload.jointHolders);
        }

        function checkValid2ndHolder(obj){
          scope.notValid2ndHolder=false;
          for(var i =0; i<obj.length;i++){
            if(!obj[i].email && !obj[i].mobileNumber){
              scope.notValid2ndHolder=true;
            }
          }
        }

        function fetchDynamicContent() {
          var successHandler = function(resp) {
            if(resp && resp.noteDTO && resp.noteDTO.noteDTOMap && resp.noteDTO.noteDTOMap.Note_Tax_Status_Info) {
              scope.taxStatusNote = resp.noteDTO.noteDTOMap.Note_Tax_Status_Info.content;
            } else {
              scope.taxStatusNote = "";
            }
          };

          UtilService.fetchDynamicData('FOLIO_CREATION').then(successHandler).catch(function(resp) {
            MessageService.error(resp);
          });
        }
      }
    }
  }



})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('folioHoldMode', folioHoldMode);

  /*@ngInject*/
  function folioHoldMode(AuthService, MessageService, InvestorService, AppConstants, InvestorFolioModel, LoaderService, $stateParams, UtilService, $window, $state, InvestorServiceV3, ModalService, $rootScope, $timeout, InvestorServiceVersionBasket3) {
    return {
      restrict: 'E',
      scope: {holders : '=', mainFolioParent:'=',firstFlow:'@'},
      templateUrl: 'app/investor/addFolio/folio-directive/holdMode/folio-holdMode-directive.html',
      link: function (scope) {

        scope.CONST = AppConstants;
        scope.setMinorFlag = setMinorFlag;
        scope.setHoldmode = setHoldmode;
        scope.saveFolio = saveFolio;
        scope.continueFolio = continueFolio;
        scope.holders.minor = false;
        scope.holders.holdmode = scope.CONST.INVESTOR_HOLD_MODE.SINGLE;


        /*function setHeader() {
          var profile = AuthService.getToken();
          if (profile) {
            scope.mainFolioParent.panNumber = profile.investorPAN;
            scope.mainFolioParent.firstName = profile.investorFName;
            scope.mainFolioParent.middleName = profile.investorMName;
            scope.mainFolioParent.lastName = profile.investorLName;
            vm.guardianName = $scope.mainFolioParent.firstName + ' ' + ($scope.mainFolioParent.lastName || '');
            scope.mainFolioParent.currentState = 'main.folio.holdmode';
          } else {
            $state.go('login')
          }
        }*/

        function setMinorFlag() {
          if((!scope.holders.minor) && (scope.holders.holdmode == scope.CONST.INVESTOR_HOLD_MODE.AOS)){
            scope.mainFolioParent.stepsAway = 6;
          }
          else if((!scope.holders.minor) && (scope.holders.holdmode == scope.CONST.INVESTOR_HOLD_MODE.SINGLE)){
            scope.mainFolioParent.stepsAway = 5;
          }else if(scope.holders.minor){
            scope.holders.holdmode = scope.CONST.INVESTOR_HOLD_MODE.SINGLE;
            scope.mainFolioParent.stepsAway = 4;
          }
        }

        function setHoldmode(){
          scope.mainFolioParent && (scope.mainFolioParent.holdmode = scope.holders.holdmode);
          if((!scope.holders.minor) && (scope.holders.holdmode == scope.CONST.INVESTOR_HOLD_MODE.AOS)){
            scope.mainFolioParent.stepsAway = 6;
          }
          else if((!scope.holders.minor) && (scope.holders.holdmode == scope.CONST.INVESTOR_HOLD_MODE.SINGLE)){
            scope.mainFolioParent.stepsAway = 5;
          }else if(scope.holders.minor){
            scope.mainFolioParent.stepsAway = 4;
          }

        }

        function saveFolio() {
          LoaderService.showLoader();
          var success = function (resp) {
            if (resp.status && resp.data) {
              localStorage.setItem('folioId', resp.data.id);
              InvestorFolioModel.setInvestorFolioModel(scope.holders);
              // $scope.mainFolioParent.uuid = resp.data.id;
              LoaderService.hideLoader();
              if (resp.data.id) {
                MessageService.success('Saved Successfully.');
                $state.go('welcome');
              }
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          if(!scope.holders.minor){
            scope.holders.soleApplicantDetail = scope.holders.soleApplicantDetail || {};
            scope.holders.soleApplicantDetail.selfDetail = scope.holders.soleApplicantDetail.selfDetail || {};
            scope.holders.soleApplicantDetail.selfDetail.panNumber = scope.mainFolioParent.panNumber;
            scope.holders.soleApplicantDetail.personalDetail.taxStatusCode = '01';
          }
          else{
            scope.holders.soleApplicantDetail.minorDetail = scope.holders.soleApplicantDetail.minorDetail||{};
            scope.holders.soleApplicantDetail.minorDetail.guardian = scope.holders.soleApplicantDetail.minorDetail.guardian||{};
            scope.holders.soleApplicantDetail.minorDetail.guardian.panNumber = scope.mainFolioParent.panNumber;
            scope.holders.soleApplicantDetail.personalDetail.taxStatusCode = '02';
          }
          scope.holders.folioSaveStep = "ONE";
          scope.holders.id = $stateParams.investorId;
          sessionStorage.setItem('savedFromFirstStep', true);
          InvestorServiceV3.post({child1: 'folio', child2: 'save'}, scope.holders).$promise.then(success, error);
        }

        function continueFolio() {
          var fromSaved = $rootScope.setFolioInitiateState && $rootScope.setFolioInitiateState === 'main.saved-items' && sessionStorage.getItem('savedFromFirstStep') === 'false' ?  true :
            sessionStorage.getItem('setFolioInitiateState') === 'main.saved-items' && sessionStorage.getItem('savedFromFirstStep') === 'false' ? true : false;
          sessionStorage.setItem('savedFromFirstStep', false);
          if (scope.firstFlow == 'YES') {
            proceedToFolioCreation();
          } else if (scope.firstFlow == 'NO' && fromSaved && (scope.holders.minor === scope.holders.previousFolioCreationFor && scope.holders.holdmode === scope.holders.previousHolders)) {
            proceedToFolioCreation();
          } else if (scope.firstFlow == 'NO' && fromSaved && (scope.holders.minor !== scope.holders.previousFolioCreationFor && scope.holders.holdmode !== scope.holders.previousHolders)) {
            getGoalFolioList(function() {
              if (scope.folioList) {
                showFolioSelectionModal();
              } else {
                proceedToFolioCreation();
              }
            });
          } else {
            getGoalFolioList(function() {
              if (scope.folioList) {
                showFolioSelectionModal();
              } else {
                proceedToFolioCreation();
              }
            });
          }
        }

        function showFolioSelectionModal() {
          $timeout(function() {
            var success = function(resp) {
              if (resp === 'SELECT_NEW') {
                proceedToFolioSelection();
              } else {
                sessionStorage.setItem('isFolioSelected', false);
                proceedToFolioCreation(true);
              }
            }, error = function() {};
            ModalService.fillFolioDetailsModal({
              text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
              journey: "FOLIO_CREATION",
              isFromPostLogin: true
            }, success, error);
          });
        }

        function proceedToFolioCreation(setEmailMobileNull) {
          LoaderService.showLoader();
          var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              if (resp.data.folioDataInvalid) {
                var success = function() {
                  if (scope.firstFlow=='YES') {
                    $state.go('welcome');
                  } else {
                    $state.go($rootScope.setFolioInitiateState ? $rootScope.setFolioInitiateState : sessionStorage.getItem('setFolioInitiateState'));
                  }
                }, error = function(resp) {
                  if (scope.firstFlow=='YES') {
                    $state.go('welcome');
                  } else {
                    $state.go($rootScope.setFolioInitiateState ? $rootScope.setFolioInitiateState : sessionStorage.getItem('setFolioInitiateState'));
                  }
                };
                ModalService.genericModal({
                  text: resp.data.message
                }, success, error);
              } else {
                localStorage.setItem('folioId', resp.data.id);
                if (resp.data.hasOwnProperty('sebiNomineeRegulatory01650Active')) {
                  scope.holders.sebiNomineeRegulatory01650Active = resp.data.sebiNomineeRegulatory01650Active;
                  scope.holders.nomineeLimit = resp.data.nomineeLimit ? resp.data.nomineeLimit : 3;
                }
                InvestorFolioModel.setInvestorFolioModel(scope.holders);
                // $scope.mainFolioParent.uuid = resp.data.id;
                var id = $stateParams.investorId||localStorage.getItem('folioId');
                if (scope.firstFlow=='YES') {
                  $state.go('folioDetails.folioCreation', {investorId: id});
                } else {
                  $state.go('main.folio.soleApplicant', {investorId: id});
                }
              }
            } else {
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message,
                  isAadhar: true
                })
              } else {
                MessageService.error(resp.message);
              }
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          scope.holders.folioSaveStep = "ONE";
          scope.holders.firstFolio = (scope.firstFlow == 'YES')?true:false;
          if(!scope.holders.minor){
            scope.holders.soleApplicantDetail = scope.holders.soleApplicantDetail || {};
            scope.holders.soleApplicantDetail.selfDetail = scope.holders.soleApplicantDetail.selfDetail || {};
            scope.holders.soleApplicantDetail.selfDetail.panNumber = scope.mainFolioParent.panNumber;
          }
          else{
            scope.holders.soleApplicantDetail.minorDetail = scope.holders.soleApplicantDetail.minorDetail||{};
            scope.holders.soleApplicantDetail.minorDetail.guardian = scope.holders.soleApplicantDetail.minorDetail.guardian||{};
            scope.holders.soleApplicantDetail.minorDetail.guardian.panNumber = scope.mainFolioParent.panNumber;
          }

          scope.holders.id = $stateParams.investorId;
          scope.holders.soleApplicantDetail.personalDetail = scope.holders.soleApplicantDetail.personalDetail||{};
          if (setEmailMobileNull) {
            scope.holders.soleApplicantDetail.personalDetail.email = null;
            scope.holders.soleApplicantDetail.personalDetail.mobileNo = null;
          } else {
            scope.holders.folioNumber = scope.selectedFolio;
          }
          InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, scope.holders).$promise.then(success, error);
        }

        /*function getPayload() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                LoaderService.hideLoader();
                scope.holders = resp.data;
                scope.holders.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
                scope.mainFolioParent && (scope.mainFolioParent.holdmode = scope.holders.holdmode);
              } else {
                MessageService.error(resp.message);
                LoaderService.hideLoader();
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
            };

          var investorId=$stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
          InvestorServiceV3.post({
            child1: 'folio',
            child2: 'getDetails'
          },{id:investorId}).$promise.then(success, error);

        }*/

        function getGoalFolioList(cb) {
          LoaderService.showLoader();
          var success = function(resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              var folioList = [];
              scope.kycVerifiedFlag = resp.data.kycVerifiedFlag;
              if (resp.data.kycVerifiedFlag === false) {
                scope.kycMessage = resp.data.kycMessage;
              }
              Object.keys(resp.data.folioList).forEach(function (key) {
                var obj = Object.assign({key: key}, resp.data.folioList[key]);
                if (scope.holders.minor) {
                  if (obj.minorFlag) {
                    folioList.push(angular.copy(obj));
                  }
                } else if (obj.holdMode === "ANY_OR_SURVIVOR" && scope.holders.holdmode === scope.CONST.INVESTOR_HOLD_MODE.AOS) {
                  folioList.push(angular.copy(obj));
                } else if (obj.holdMode !== "ANY_OR_SURVIVOR" && scope.holders.holdmode !== scope.CONST.INVESTOR_HOLD_MODE.AOS)  {
                  if (!obj.minorFlag) {
                    folioList.push(angular.copy(obj));
                  }
                }
              });
              scope.folioList = folioList.length ? folioList : null;
              cb();
            } else {
              LoaderService.hideLoader();
              scope.folioList = null;
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            scope.folioList = null;
            UtilService.errorHandler(err);
          };
          InvestorServiceVersionBasket3.get({
            child1: 'folio',
            child2: 'getFolioList'
          }).$promise.then(success, error);
        }

        function proceedToFolioSelection() {
          var success = function (resp) {
            scope.selectedFolio = resp;
            fetchFolioData(resp);
          }, error = function () {};
          ModalService.prefillFolioModal({
            kycMessage: scope.kycMessage,
            folioList: scope.folioList
          }, success, error);
        }

        function fetchFolioData(folio) {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              var selectedFolioData = resp.data;
              selectedFolioData.holdmode = scope.holders.holdmode;
              if (scope.holders.minor === false) {
                selectedFolioData.minor = false;
              }
              selectedFolioData.isFolioSelected = true;
              sessionStorage.setItem('isFolioSelected', true);
              sessionStorage.setItem('kycContact', JSON.stringify({
                email: selectedFolioData.soleApplicantDetail.personalDetail.email,
                mobileNo: selectedFolioData.soleApplicantDetail.personalDetail.mobileNo
              }));
              InvestorFolioModel.setInvestorFolioModel(selectedFolioData);
              scope.holders = InvestorFolioModel.getInvestorFolioModel();
              proceedToFolioCreation();
            } else {
              MessageService.error("Something went wrong")
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            MessageService.error(err)
          };
          InvestorServiceV3.get({
            child1: 'folio',
            child2: 'getFolioDetails',
            child3: folio
          },{}).$promise.then(success, error);
        }

      }
    }
  }



})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('folioBankDetails', folioBankDetails);

  /*@ngInject*/
  function folioBankDetails(AuthService, MessageService, ModalService, InvestorService, AppConstants, InvestorServiceV3, DownloadPdfService, FileSaver, Blob,
                            InvestorFolioModel, LoaderService, InvestorFileUploadServiceV3, $stateParams, UtilService,$timeout, $window, $state, $log) {
    return {
      restrict: 'E',
      scope: {bankPayload: '=', isSoleApplicantMinor: '=', mainFolioParentpanNumber:'=',
        mainFolioParent:'=', firstFlow:'@', bankTypeList:'=' , dynamicBankDetailsNote:'='},
      templateUrl: 'app/investor/addFolio/folio-directive/bankDetails/folio-bank-details-directive.html',
      link: function (scope) {
        scope.bkValidateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        scope.IFSC_REGEX = AppConstants.ifsc_regex;
        scope.pattern = AppConstants;
        scope.accModelDirty = false;
        scope.chooseAFile = true;
        scope.bankUploadChequeLeafFile = bankUploadChequeLeafFile;
        scope.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
        scope.bankChequeLeafUrl = '';
        scope.fileType = '';
        scope.savePayload = savePayload;
        scope.selfDeclaration = selfDeclaration;
        scope.saveDetails = saveDetails;
        scope.continueFolio = continueFolio;
        scope.selectIFSC = selectIFSC;
        scope.isReseting = true;
        scope.bankPayload.bankDetails.pennyDropValid = null;
        scope.tpv = tpv;
        scope.dynamicNote = scope.dynamicBankDetailsNote.noteDTO.noteDTOMap.Note_Folio_ADDBANK;
        scope.dynamicNoteList = scope.dynamicBankDetailsNote.noteDTO.noteDTOMap.Note_Folio_ADDBANK_LIST;
        scope.isDreamSip = $window.JSON.parse(localStorage.getItem('isDreamSip'))? $window.JSON.parse(localStorage.getItem('isDreamSip')):false;
        function tpv(event) {
          event.preventDefault();
          ModalService.tpvModal({});
        }
        var pennyDropEnablSelectedBank = false;
        function selectIFSC() {
            var successModal = function(data){
              scope.bankPayload.bankDetails.accountNumber= null;
              scope.bankPayload.bankDetails.verifyAccountNumber= null;
              scope.bankPayload.bankDetails.ifsccode= data.ifscCode;
              scope.bankPayload.bankDetails.bankName = data.bankName;
              if(data.branch && data.branch.length>40) scope.bankPayload.bankDetails.bankBranch = data.branch.slice(0,40)
              else scope.bankPayload.bankDetails.bankBranch = data.branch;
              scope.bankPayload.bankDetails.bankCity = data.branchCity;
              if (data.pennyDropEnabled && scope.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode === '01') {
                scope.bankPayload.bankDetails.pennyDropValid = true;
              }
              else {
                scope.bankPayload.bankDetails.pennyDropValid = false;
              }
              pennyDropEnablSelectedBank = scope.bankPayload.bankDetails.pennyDropValid;
              resetCheckLeaf();
            };
            var errorModal = function(){
          };
            ModalService.IFSCSelectionModal({bankList : scope.bankList}, successModal, errorModal);
        }

        function setHeader() {
          var profile = AuthService.getToken();
          scope.mainFolioParent && (scope.mainFolioParent.panNumber = profile.investorPAN);
          scope.mainFolioParent && (scope.mainFolioParent.firstName = profile.investorFName);
          scope.mainFolioParent && (scope.mainFolioParent.lastName = profile.investorLName);
          scope.mainFolioParent && (scope.mainFolioParent.currentState = 'main.folio.bankdetails');
          scope.bankPayload.bankDetails.accountHolderName = profile.investorFullName;

        }

        function resetCheckLeaf() {
          scope.bankchequeLeafUrl = "";
          scope.bankPayload.bankDetails.chequeLeaf = "";
          scope.bankChequeLeaf = "";
          scope.chooseAFile=true;
          angular.element("#uploadCheckLeaf").val("");
        }

        function bankNameList() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                scope.bankList = resp.data.bankList;
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              $log.info('Account type Errror>>>>', err);
            };

          InvestorService.get({child1: 'rbi', child2: 'bankNames'}).$promise.then(success, error);
        }
        function getPayoutMechanism() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                scope.payoutMechanismList = resp.data.payoutMechanisms;
                resp.data.payoutMechanisms.map(function(pm){
                  if(pm.payoutCode=="DC"){
                    scope.bankPayload.bankDetails.payoutMechanism = pm.payoutCode;
                  }
                });
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              $log.info('Payout Machanism error >>>>', err);
            };

          InvestorService.get({child1: 'folio', child2: 'payout-mechanism'}).$promise.then(success, error);
        }

        function setAccountType() {
          var checkFlag=false;
          $timeout(function () {
            scope.bankTypeList.map(function (ele) {
              if(ele.accountTypeCode === scope.bankPayload.bankDetails.accountType){
                checkFlag = true;
              }
            });
          });
          if(checkFlag===false){
            scope.bankPayload.bankDetails.accountType = null;
          }
        }

        scope.accFocus = function () {
          scope.accModelDirty = true;
          scope.chooseAFile=true;
          scope.bankchequeLeafUrl='';
          scope.bankChequeLeaf='';
          scope.bankPayload.bankDetails.chequeLeaf = "";
          angular.element("#uploadCheckLeaf").val("");
          if(pennyDropEnablSelectedBank){
            scope.bankPayload.bankDetails.pennyDropValid=true;
          }
        };

        scope.copyPasteHandler=function (e) {
          var key = e.keyCode?e.keyCode:e.which;
          var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

          if ( key == 86 && ctrl ) {
            e.preventDefault();
          } else if ( key == 67 && ctrl ) {
            e.preventDefault();
          }
        };

        scope.done = function () {
          if(scope.firstFlow == 'YES'){
            savePayload('folioDetails.review');
          }else{
            savePayload('main.folio.review');
          }
        };

        scope.validatePennyDropDetails = function(){
          var pennyDropValidatePayload = {
            "beneficiaryIFSC":scope.bankPayload.bankDetails.ifsccode,
            "benificiaryAccountNo":scope.bankPayload.bankDetails.accountNumber,
            "benificiaryName":scope.bankPayload.bankDetails.accountHolderName.trim()
          };
          LoaderService.showLoader();
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if(resp.data.valid === false) {
                  MessageService.error(resp.data.message || "We are unable to validate your bank account using IMPS service. Please upload cheque leaf to continue with folio creation");
                  scope.bankPayload.bankDetails.pennyDropValid = false;
                }

                else {
                  scope.disableAccntDetails = true;
                  if(resp.data.name) scope.bankPayload.bankDetails.accountHolderName = resp.data.name;
                  scope.bankPayload.bankDetails.pennyDropValid = true;
                  delete scope.bankPayload.bankDetails.chequeLeaf;
                  if(scope.firstFlow == 'YES'){
                    savePayload('folioDetails.review');
                  }else{
                    savePayload('main.folio.review');
                  }
                }
              } else {
                MessageService.error(resp.message);
                LoaderService.hideLoader();
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          InvestorService.post({child1: 'account', child2: 'validate', child3:'pennyDrop'}, pennyDropValidatePayload).$promise.then(success, error);


        };

        scope.save =  function(){
          savePayloadBankDetails('');
        };

        scope.bankBack = function () {
          if(scope.bankPayload.minor){
            if(scope.firstFlow === 'YES'){
              $state.go('folioDetails.folioCreation',{investorId:$stateParams.investorId});
            }else{
              $state.go('main.folio.soleApplicant',{investorId:$stateParams.investorId});
            }
          } else {
            if(scope.firstFlow === 'YES'){
              $state.go('folioDetails.addNominee',{investorId:$stateParams.investorId});
            }else{
              $state.go('main.folio.nominee',{investorId:$stateParams.investorId});
            }
          }
        };

        function savePayloadBankDetails(stateToMove) {
          LoaderService.showLoader();
          if(scope.bankPayload){
            scope.bankPayload.newFolioComplete = false;
            scope.bankPayload.id = localStorage.getItem('folioId');
          }
          saveDetails(stateToMove);

        }

        function savePayload(stateToMove) {
          LoaderService.showLoader();
          if(scope.bankPayload){
            scope.bankPayload.newFolioComplete = true;
            scope.bankPayload.id = localStorage.getItem('folioId');
          }
          if(scope.bankPayload.newFolioComplete){
            continueFolio(stateToMove);
          } else {
            saveDetails(stateToMove);
          }
        }

        function continueFolio(stateToMove) {
          var success = function (resp) {
              if (resp.status && resp.data) {
                if(stateToMove){
                  LoaderService.hideLoader();
                  if(scope.isDreamSip){
                    $state.go(stateToMove,{investorId:$stateParams.investorId,isDreamSip:true});
                  }else{
                    $state.go(stateToMove,{investorId:$stateParams.investorId});
                  }
                } else {
                  LoaderService.hideLoader();
                  scope.mainFolioParent.bankDetailSuccess = true;
                  showPopUp(resp.data);
                }
              } else {
                LoaderService.hideLoader();
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info('Occupation Errror>>>>', err);
            };
          if(scope.bankPayload && scope.bankPayload.bankDetails && scope.bankPayload.bankDetails.payoutMechanism){
            delete scope.bankPayload.bankDetails.payoutMechanism.micrMandatory;
            delete scope.bankPayload.bankDetails.payoutMechanism.payoutDescription;
          }
          scope.bankPayload.folioSaveStep = "FIVE";
          InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, scope.bankPayload).$promise.then(success, error);
        }

        function saveDetails (stateToMove) {
          LoaderService.showLoader();
          (stateToMove==='main.folio.nominee')&&(scope.bankPayload.saveStep = 4);
          (stateToMove==='main.folio.nominee')&&(scope.bankPayload.saveStep = 2);
          (stateToMove==='main.folio.review')&&(scope.bankPayload.saveStep = 5);
          var success = function (resp) {
            if (resp.status && resp.data) {
              localStorage.setItem('folioId', resp.data.id);
              LoaderService.hideLoader();
              $state.go('welcome');
              MessageService.success('Saved Successfully.');

            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          scope.bankPayload.firstFolio = (scope.firstFlow == 'YES')?true:false;
          scope.bankPayload.folioSaveStep = "FIVE";
          InvestorServiceV3.post({child1: 'folio', child2: 'save'}, scope.bankPayload).$promise.then(success, error);
        }

        function showPopUp(data) {
          var successModal = function () {
              $window.sessionStorage.removeItem("investorForm");
              $state.go('welcome')
            },
            errorModal = function (err) {
              if(err!=null){
                MessageService.error(err)
              }
            };
          data = data ||{};
          data.holdmode = scope.bankPayload.holdmode;/////////////////////////
          ModalService.folioCreationSuccessModal(data, successModal, errorModal);
        }

        function selfDeclaration(data) {
          var successModal = function () {
              $state.go('login')
            },
            errorModal = function (err) {
              if(err!=null){
                MessageService.error(err)
              }
            };
          ModalService.selfDeclarationModal(data, successModal, errorModal);
        }

        function bankUploadChequeLeafFile(file) {

          if (scope.mimeType.indexOf(file.type) === -1) {
            MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
            return;
          }
          if(file){
            if (file.size <= 2000000) {
              var success = function (resp) {
                  LoaderService.hideLoader();
                  if (resp.status && resp.data) {
                    scope.bankchequeLeafUrl = resp.data.fileUrl;
                    scope.bankPayload.bankDetails.chequeLeaf = scope.bankchequeLeafUrl;
                    // scope.chooseAFile= false;
                    scope.fileType = resp.data.type.toLowerCase();
                    breakFileUrl(scope.bankchequeLeafUrl);
                  }
                  else {
                    scope.fileType = '';
                    // scope.chooseAFile= true;
                    MessageService.error(resp.message);
                  }
                },
                error = function (err) {
                  LoaderService.hideLoader(err);
                };

              if (file) {
                LoaderService.showLoader();
                var fd = new FormData();
                fd.append('file', file);

                InvestorFileUploadServiceV3.post({
                  child1:'folio',
                  child2: 'upload',
                  child3: 'bankDetails',
                  child4: 'chequeLeaf',
                  child5: $stateParams.investorId
                }, fd).$promise.then(success, error);
              }
            }
            else {
              MessageService.error("File size should not be more than 2 MB.")
            }
          }

        }

        function breakFileUrl(url) {
          scope.bankChequeLeaf = 'Preview Uploaded Leaf Doc';
          scope.fileType = url && url.split('_').reverse()[0].toLowerCase();
          scope.chooseAFile = false;
          scope.bankchequeLeafUrl = url;
          return;
        }

        scope.openUploadedDoc = function() {
          if(angular.isUndefined(scope.bankPayload.bankDetails.chequeLeaf)){return;}
          ModalService.showImage({docUrl: scope.bankPayload.bankDetails.chequeLeaf});
        };

        function searchByIFSC(ifsccode){
          var payload = {
            ifscCode : ifsccode
          };

          var onSuccess = function(resp){
            if(resp.status && resp.data){
              if(resp.data.bankList && resp.data.bankList.length==1){
                var bankInfo = resp.data.bankList[0];
                scope.bankPayload.bankDetails.pennyDropValid = angular.isDefined(bankInfo.pennyDropEnabled)
                ?bankInfo.pennyDropEnabled:false;
                pennyDropEnablSelectedBank = scope.bankPayload.bankDetails.pennyDropValid;
              }
            }
          };
          onerror = function(){
          };
          InvestorService.post({
            child1: 'rbi',
            child2: 'bankList'
          }, payload).$promise.then(onSuccess, onerror);
        }


        scope.downloadPdfFile = function (url, fileType) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.data) {
                var data = new Blob([resp.data], { type: 'application/'+fileType });
                FileSaver.saveAs(data, 'Cheque_Leaf.'+fileType);
              } else {
                MessageService.error('No Data Available');
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
          LoaderService.showLoader();
          var payload = {};
          DownloadPdfService.downloadFile(payload, fileType, scope.bankchequeLeafUrl).then(success, error);
        };
        function bankInit() {
          if(scope.bankPayload.soleApplicantDetail && scope.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode !=='01'){
            scope.bankPayload.bankDetails.pennyDropValid = false;
          }else{scope.bankPayload.bankDetails.pennyDropValid = true;}
          if(scope.bankPayload.soleApplicantDetail && scope.bankPayload.soleApplicantDetail.personalDetail &&
            scope.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode === '01' &&
            angular.isDefined(scope.bankPayload.bankDetails.ifsccode) &&
            scope.bankPayload.bankDetails.ifsccode !=""
          ){
            searchByIFSC(scope.bankPayload.bankDetails.ifsccode);
          }
          $window.scrollTo(0, 0);
          setHeader();
          bankNameList();
          getPayoutMechanism();
          //setAccountType();
          if(angular.isDefined(scope.bankPayload.bankDetails) && scope.bankPayload.bankDetails.chequeLeaf !='') {
            breakFileUrl(scope.bankPayload.bankDetails.chequeLeaf);
          }

          $timeout(function () {
            LoaderService.hideLoader();
            $window.jQuery('[data-bs-toggle="tooltip"]').tooltip();
          },100);
        }

        $timeout(function () {
          LoaderService.showLoader();
          bankInit();
        },1000);
      }
    }
  }



})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('goalsQuestionnairesData', goalsQuestionnairesData);

  /*@ngInject*/
  function goalsQuestionnairesData($timeout, $state, $window, LoaderService, UtilService, MessageService, InvestmentBasketService, AppConstants, ModalService) {
    return {
      restrict: 'E',
      scope: {
        goalName: '='
      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/goals/goals-questionnaires/goals-questionnaires.directive.html',
      link: function (scope, $element, $attrs) {
        var _this = scope;
        _this.questionsList = [];
        _this.fetchQuestions = fetchQuestions;
        _this.toggleListItems = toggleListItems;
        /*_this.durationChanged = durationChanged;
        _this.amountChanged = amountChanged;*/
        _this.goToBack = goToBack;
        _this.evaluateInvestmentPersonality = evaluateInvestmentPersonality;
        _this.submitForm = submitForm;
        _this.timeInMonths = AppConstants.DURATION;
        _this.amountList = AppConstants.AMOUNT_LIST;
        _this.riskProfileOptions = [];
        _this.investmentPersonalityQuestion = [];
        _this.isEvaluated = false;
        _this.formData = {};
        _this.init = function() {
          fetchQuestions();
          fetchRiskAppetites();
          getInvestorRiskAppetite();
        };
        _this.init();

        function fetchQuestions(goalId) {
          _this.questionsList = {
            steps: [
              {
                name: "Duration", step: 1,
                questions : "When are you planning to travel?",
                expanded: true,
                isSelectField: true,
                ngRepeatOption: AppConstants.QUESTIONNAIRE_OPTIONS.TRAVEL_DURATION,
                model : "duration",
                method: "durationChanged()"
              },
              {
                name: "Amount",
                step: 2,
                questions : "How much do you wish to save for your trip?",
                expanded: false,
                isSelectField: false,
                ngRepeatOption: AppConstants.QUESTIONNAIRE_OPTIONS.TRAVEL_AMOUNT,
                model : "amount",
                method: "amountChanged()"
              }
            ]
          };
          // LoaderService.showLoader();
          // var success = function(resp) {
          //   LoaderService.hideLoader();
          //   if (resp.status && resp.data) {
          //     _this.questionsList = resp.data.goalQuestions;
          //   }
          //   else {
          //     MessageService.error(resp.message);
          //     _this.scope.questionsList = null;
          //   }
          // }, error = function(err) {
          //   LoaderService.hideLoader();
          //   UtilService.errorHandler(err);
          //   _this.scope.questionsList = null;
          // };
          // InvestmentBasketService.get({
          //   child1: 'investment',
          //   child2: 'basket',
          //   child3: 'getGoalsDetails',
          //   child4: _this.scope.goalId
          // }).$promise.then(success, error);
          handleFormVisibility();
        }

        function handleFormVisibility() {
          $timeout(function() {
            /*angular.element($window.document.querySelectorAll('.selectfield')).hide();
            angular.element($window.document.querySelectorAll('.selectfield')[0]).show();*/
          });
        }

        function toggleListItems(index) {
          _this.questionsList.steps[index].expanded = !_this.questionsList.steps[index].expanded;
          for (var i = 0; i < _this.questionsList.steps.length; i++) {
            if (_this.questionsList.steps[i].expanded === true && i != index) {
              _this.questionsList.steps[i].expanded = false;
            }
          }
        }

        /*function durationChanged() {
          console.log(_this.formData.duration);
        }

        function amountChanged() {
          console.log(_this.formData.amount);
        }*/

        function goToBack() {
          $state.go("main.investment.goals");
        }

        function fetchRiskAppetites() {
          LoaderService.showLoader();
          var success = function(response) {
            LoaderService.hideLoader();
            if (response.status && response.data) {
              _this.riskProfileOptions = response.data.riskAppetiteDetails.allRiskAppetites;
            }
            else {
              MessageService.error(response.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          InvestmentBasketService.get({
            child1: 'investment',
            child2: 'basket',
            child3: 'getRiskAppetites'
          }).$promise.then(success, error);
        }

        function evaluateInvestmentPersonality() {
          getQuestionAnswserDetails();
        }

        function getQuestionAnswserDetails() {
          LoaderService.showLoader();
          var success = function(response) {
            LoaderService.hideLoader();
            if (response.status && response.data) {
              _this.investmentPersonalityQuestion = response.data.questionAndAnswerDetail;
              showModal();
            }
            else {
              MessageService.error(response.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          InvestmentBasketService.get({
            child1: 'investment',
            child2: 'basket',
            child3: 'quesAndAnsDetail'
          }).$promise.then(success, error);
        }

        function showModal() {
          var success = function(resp) {
            if (resp) {
              _this.isEvaluated = true;
              getInvestorRiskAppetite();
            }
          }, error = function(err) {
          };
          ModalService.investmentPersonality({
            questionAndAnswer: _this.investmentPersonalityQuestion
          }, success, error);
        }

        function getInvestorRiskAppetite() {
          LoaderService.showLoader();
          var success = function(response) {
            LoaderService.hideLoader();
            if (response.status && response.data) {
              _this.isEvaluated = true;
              _this.formData.riskProfiler = response.data.riskAppetiteDetails.riskAppetite;
            } else {
              _this.isEvaluated = false;
              MessageService.error(response.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          InvestmentBasketService.get({
            child1: 'investment',
            child2: 'basket',
            child3: 'getInvestorRiskAppetite'
          }).$promise.then(success, error);
        }

        function submitForm() {
          $state.go("main.investment.suggestions");
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('goalsListData', goalsListData);

  /*@ngInject*/
  function goalsListData($timeout, $state, LoaderService, UtilService, MessageService, InvestmentBasketService) {
    return {
      restrict: 'E',
      scope: {

      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/goals/goals-list/goals-list.directive.html',
      link: function (scope) {
        var _this = scope;
        _this.goalsList = [];
        _this.proceedToGoalSetting = proceedToGoalSetting;
        _this.fetchGoalsList = fetchGoalsList;


        _this.init = function() {
          fetchGoalsList();
        };
        _this.init();

        function fetchGoalsList() {
          LoaderService.showLoader();
          var success = function(response) {
            LoaderService.hideLoader();
            if (response.status && response.data) {
              scope.goalsList = response.data.goalDetailDTOList;
            }
            else {
              MessageService.error(response.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          InvestmentBasketService.get({
            child1: 'investment',
            child2: 'basket',
            child3: 'getGoalDetails'
          }).$promise.then(success, error);
        }

        function proceedToGoalSetting(goalName, goalId) {
          $state.go("main.questionnaire", {goalName: goalName.replaceAll(" ", "-").toLowerCase()});
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('folioNominee', folioNominee);

  /*@ngInject*/
  function folioNominee(AuthService, MessageService, InvestorService, AppConstants, InvestorServiceV3,
                               InvestorFolioModel, LoaderService, $stateParams, UtilService, $window, $state , $timeout , InvestmentModel , $rootScope , NewInvestorServiceV3) {

    return {
      restrict: 'E',
      scope: {firstFlow:'=', stepperUpdatedInfo : '&', proceedAction : '&', selectedFolioData: '=', journey: '='},
      templateUrl: 'app/investment-baskets/investment-basket-directives/folio/nominee/nominee.directive.html',
      link: function (scope) {
        UtilService.fetchDynamicData("FOLIO_CREATION").then(function (resp) {
          scope.dynamicNote = resp.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT;
          }
        );
        scope.dataMinDate = "";
        scope.dataMaxDate = "";
        scope.isMinorMinDate = "";
        scope.isMinorMaxDate = "";
        scope.dobRequired = false;
        scope.maxNominee = 3;
        scope.activeTab = 0;
        scope.nomineeMinDate = $window.moment();
        scope.countryList = [];
        scope.defaultDob = $window.moment().toString();
        scope.nomineeValidateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        var CONST = AppConstants;
        scope.nomineeSaveFolio = nomineeSaveFolio;
        scope.continueFolio = continueFolio;
        scope.goToBack = goToBack;
        scope.folioSelectionData = folioSelectionData;
        scope.validationMsg = '';
        scope.totalPercentage = 0;
        scope.showAddNominee = true;
        scope.nomineePanValid = true;
        scope.minorPanValid = true;
        scope.nomineePayload = {};
        scope.truncateMessage = 198;
        // scope.dynamicNote = scope.dynamicBankDetailsNote.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT;
        scope.wantToAddNomineeLater = localStorage.getItem('wantToAddNomineeLater') == "true" ? true : false;
        scope.nomineeEnum = {
          0: 'First',
          1: 'Second',
          2: 'Third',
          3: 'Fourth',
          4: 'Fifth',
          5: 'Sixth',
          6: 'Seventh',
          7: 'Eighth',
          8: 'Ninth',
          9: 'Tenth'
        };

        scope.editNominee = true;
        scope.emailPattern = AppConstants.email_regex;
        scope.mobilePattern = AppConstants.mobile_regex_with_country;
        scope.showNomineeUpdate = false;
        scope.maxNominee = 3;
        scope.nomineeAadhaarValid = true;
        scope.nomineeLicenseValid = true;
        scope.nomineePassportValid = true;
        scope.emailIdValid = true;
        scope.changePersonalIdentifier = changePersonalIdentifier;
        scope.selectedNominee = selectedNominee;
        scope.changeEmailId = changeEmailId;
        scope.changeMobileNumber = changeMobileNumber;
        scope.drivingLicenseChanged = drivingLicenseChanged;
        scope.aadharCardChanged = aadharCardChanged;
        scope.setStatement = setStatement;
        scope.setIncapcitationList = setIncapcitationList;
        scope.passportChanged = passportChanged;
        scope.errorMessageEmail = scope.nomineeValidateData.EMAILID_SAME_INVESTOR;
        scope.errorMessageMobile = scope.nomineeValidateData.MOBILE_SAME_INVESTOR;
        scope.errorMessageDrivingLicense = scope.nomineeValidateData.DRIVING_LICENSE_ALREADY_EXIST;
        scope.errorMessageNomineeAadhaar = scope.nomineeValidateData.AADHAAR_ALREADY_EXIST;
        scope.errorMessagePassportNumber = scope.nomineeValidateData.PASSPORT_ALREADY_EXIST;


        // listening to edit button click

        var listner = scope.$on("enableEditNominee", function() {
          scope.editNominee = true;
          if (scope.selectedFolioData && scope.selectedFolioData.nominees && scope.selectedFolioData.nominees.length > 0) {
            scope.selectedFolioData.nominees = angular.copy(scope.nomineePayload.nominees);
          }
          scope.payloadData = InvestmentModel.getPayload();
          getPayload();
        });

        // var listner = scope.$on("continueButtonNominee", function() {
        //   scope.payloadData = InvestmentModel.getPayload();
        //   scope.nomineeContinue();
        // });

        scope.optOutNominee =  localStorage.getItem('optOutNominee') == "true" ? true : false;

        scope.payloadData = InvestmentModel.getPayload();

        nomineeInit();

        function setHeader() {
          var profile = AuthService.getToken();
          scope.MainFolioParent && (scope.MainFolioParent.panNumber = profile.investorPAN);
          scope.MainFolioParent && (scope.MainFolioParent.firstName = profile.investorFName);
          scope.MainFolioParent && (scope.MainFolioParent.middleName = profile.investorMName);
          scope.MainFolioParent && (scope.MainFolioParent.lastName = profile.investorLName);
          scope.MainFolioParent && (scope.MainFolioParent.currentState = 'main.folio.nominee');

        }

        scope.nomineeChangeDob = function (date) {

          if (!date) {
            return;
          }
          // scope.defaultDob = date.toString();
          scope.nomineePayload.nominees[scope.activeTab].dob = date.clone().format('DD-MMM-YYYY').toString();
          var age = $window.moment().diff(date, 'years');
          // if (age < 18) {
          //   scope.nomineePayload.nominees[scope.activeTab].minor = true;
          //   scope.nomineePayload.nominees[scope.activeTab].panNumber = null;
          // } else {
          //   scope.nomineePayload.nominees[scope.activeTab].minor = false;
          //   scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber = null;
          //   scope.nomineePayload.nominees[scope.activeTab].guardianName = null;
          //   scope.nomineePayload.nominees[scope.activeTab].guardianRelationWithNominee = null;
          // }
          scope.validateDOBRequired();
        };

        scope.percentage = function (data) {
          if (data.percentage.split('%').length != 2)
            data.percentage = data.percentage + '%';
        };

        scope.setActiveTab = function (index) {
          scope.activeTab = index;
          scope.callPan = false;
          if(typeof scope.nomineePayload.nominees[scope.activeTab].panNumber !== 'undefined' && scope.nomineePayload.nominees[scope.activeTab].panNumber != "" && scope.nomineePayload.nominees[scope.activeTab].panNumber != null) {
            scope.nomineePanChanged(index,scope.nomineePayload.nominees[scope.activeTab].panNumber);
          }

          if(typeof scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber!== 'undefined' && scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber != "" && scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber != null && !scope.callPan) {
            scope.minorPanChanged(index,scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber , true)
          }

        };

        scope.deleteNominee = function (index) {
          if (scope.showNomineeUpdate) {
            if (index === parseInt(scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeIndex) && scope.nomineePayload.nominees[index].nomineeName === scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName) {
              scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration = {};
              scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage = null;
              scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount = null;
            }
          }
          scope.activeTab = 0;
          var totalPercentage = 0;
          for (var i in scope.nomineePayload.nominees) {
            totalPercentage += parseInt(scope.nomineePayload.nominees[i].percentage);
          }
          scope.totalPercentage = totalPercentage;
          scope.calculatePercentage();
          var indexToCheck = 0;
          scope.nomineePanChanged(indexToCheck,scope.nomineePayload.nominees[indexToCheck].panNumber);


          if(scope.nomineePayload.nominees.length == 1) {
            if(scope.nomineePayload.nominees[0].guardianPanNumber) {
              scope.minorPanChanged(index,scope.nomineePayload.nominees[0].guardianPanNumber , true)
            } else {
              scope.minorPanValid = true;
            }
          } else {
            if(scope.nomineePayload.nominees[0].guardianPanNumber) {
              scope.minorPanChanged(0,scope.nomineePayload.nominees[0].guardianPanNumber , true)
            } else if(scope.nomineePayload.nominees[1].guardianPanNumber) {
              scope.minorPanChanged(1,scope.nomineePayload.nominees[1].guardianPanNumber , true)
            } else {
              scope.minorPanValid = true;
            }

            if (scope.nomineePayload.nominees[index].hasOwnProperty('aadharCard') && scope.nomineePayload.nominees[index].aadharCard) {
              // if (scope.nomineePayload.nominees[index].sameIndex && scope.nomineePayload.nominees[index].sameIndex.length === 1) {
              //   scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndex[0]].sameIndex = [];
              //   scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndex[0]].nomineeAadhaarInvalid = false;
              //   scope.nomineePayload.nominees[index].sameIndex = [];
              //   scope.nomineePayload.nominees[index].nomineeAadhaarInvalid = false;
              //   scope.nomineePayload.nominees.forEach(function (el) {
              //     if (el.sameIndex && el.sameIndex.length > 0) {
              //       el.sameIndex.forEach(function (val,indexE) {
              //         if (el.sameIndex[indexE] > index) {
              //           el.sameIndex[indexE] = el.sameIndex[indexE] === 0 ? 0 : el.sameIndex[indexE] - 1;
              //         }
              //       });
              //     }
              //   });
              //   for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              //     if (scope.nomineePayload.nominees[i].sameIndex && scope.nomineePayload.nominees[i].sameIndex.length === 0) {
              //       scope.nomineeAadhaarValid = true;
              //     } else if (scope.nomineePayload.nominees[i].sameIndex && scope.nomineePayload.nominees[i].sameIndex.length !== 0)  {
              //       scope.nomineeAadhaarValid = false;
              //       break;
              //     }
              //   }
              // } else if(scope.nomineePayload.nominees[index].sameIndex && scope.nomineePayload.nominees[index].sameIndex.length > 1) {
              //   scope.nomineePayload.nominees[index].sameIndex.forEach(function (el) {
              //     if (scope.nomineePayload.nominees[el].sameIndex && scope.nomineePayload.nominees[el].sameIndex.length === 1) {
              //       scope.nomineePayload.nominees[el].sameIndex = [];
              //       scope.nomineePayload.nominees[el].nomineeAadhaarInvalid = false;
              //     } else {
              //       var indexEL = scope.nomineePayload.nominees[el].sameIndex.indexOf(index);
              //       scope.nomineePayload.nominees[el].sameIndex.splice(indexEL,1);
              //       // updating index of aadhar same elements
              //       scope.nomineePayload.nominees[el].sameIndex.forEach(function (val,indexE) {
              //         if (scope.nomineePayload.nominees[el].sameIndex[indexE] > index) {
              //           scope.nomineePayload.nominees[el].sameIndex[indexE] = scope.nomineePayload.nominees[el].sameIndex[indexE] === 0 ? 0 : scope.nomineePayload.nominees[el].sameIndex[indexE] - 1;
              //         }
              //       });
              //     }
              //   });
              // }

              // updating liscense index value when value with aadhar is deleted
              for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                if (scope.nomineePayload.nominees[i].hasOwnProperty('drivingLicense')) {
                  scope.nomineePayload.nominees[i].sameIndexLiscense.forEach(function (el, indexE) {
                    if (scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] > index) {
                      scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] = scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] === 0 ? 0 : scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] - 1;
                    }
                  });
                }
                if (scope.nomineePayload.nominees[i].hasOwnProperty('passport')) {
                  scope.nomineePayload.nominees[i].sameIndexPassport.forEach(function (el, indexE) {
                    if (scope.nomineePayload.nominees[i].sameIndexPassport[indexE] > index) {
                      scope.nomineePayload.nominees[i].sameIndexPassport[indexE] = scope.nomineePayload.nominees[i].sameIndexPassport[indexE] === 0 ? 0 : scope.nomineePayload.nominees[i].sameIndexPassport[indexE] - 1;
                    }
                  });
                }
              }
            }

            if (scope.nomineePayload.nominees[index].hasOwnProperty('drivingLicense') && scope.nomineePayload.nominees[index].drivingLicense) {
              if (scope.nomineePayload.nominees[index].sameIndexLiscense && scope.nomineePayload.nominees[index].sameIndexLiscense.length === 1) {
                scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndexLiscense[0]].sameIndexLiscense = [];
                scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndexLiscense[0]].nomineeLicenseValid = false;
                scope.nomineePayload.nominees[index].sameIndexLiscense = [];
                scope.nomineePayload.nominees[index].nomineeLicenseValid = false;
                scope.nomineePayload.nominees.forEach(function (el) {
                  if (el.sameIndexLiscense && el.sameIndexLiscense.length > 0) {
                    el.sameIndexLiscense.forEach(function (val,indexE) {
                      if (el.sameIndexLiscense[indexE] > index) {
                        el.sameIndexLiscense[indexE] = el.sameIndexLiscense[indexE] === 0 ? 0 : el.sameIndexLiscense[indexE] - 1;
                      }
                    });
                  }
                });

                for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                  if (scope.nomineePayload.nominees[i].sameIndexLiscense && scope.nomineePayload.nominees[i].sameIndexLiscense.length === 0) {
                    scope.nomineeLicenseValid = true;
                  } else if (scope.nomineePayload.nominees[i].sameIndexLiscense && scope.nomineePayload.nominees[i].sameIndexLiscense.length !== 0)  {
                    scope.nomineeLicenseValid = false;
                    break;
                  }
                }
              } else if(scope.nomineePayload.nominees[index].sameIndexLiscense && scope.nomineePayload.nominees[index].sameIndexLiscense.length > 1) {
                scope.nomineePayload.nominees[index].sameIndexLiscense.forEach(function (el) {
                  if (scope.nomineePayload.nominees[el].sameIndexLiscense && scope.nomineePayload.nominees[el].sameIndexLiscense.length === 1) {
                    scope.nomineePayload.nominees[el].sameIndexLiscense = [];
                    scope.nomineePayload.nominees[el].nomineeLicenseValid = false;
                  } else {
                    var indexEL = scope.nomineePayload.nominees[el].sameIndexLiscense.indexOf(index);
                    scope.nomineePayload.nominees[el].sameIndexLiscense.splice(indexEL,1);
                    scope.nomineePayload.nominees[el].sameIndexLiscense.forEach(function (val,indexE) {
                      if (scope.nomineePayload.nominees[el].sameIndexLiscense[indexE] > index) {
                        scope.nomineePayload.nominees[el].sameIndexLiscense[indexE] = scope.nomineePayload.nominees[el].sameIndexLiscense[indexE] === 0 ? 0 : scope.nomineePayload.nominees[el].sameIndexLiscense[indexE] - 1;
                      }
                    });
                  }
                });
              }
              // updating aadhar index value when value with liscense is deleted
              for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                /*if (scope.nomineePayload.nominees[i].hasOwnProperty('aadharCard')) {
                  scope.nomineePayload.nominees[i].sameIndex.forEach(function (el, indexE) {
                    if (scope.nomineePayload.nominees[i].sameIndex[indexE] > index) {
                      scope.nomineePayload.nominees[i].sameIndex[indexE] = scope.nomineePayload.nominees[i].sameIndex[indexE] === 0 ? 0 : scope.nomineePayload.nominees[i].sameIndex[indexE] - 1;
                    }
                  })
                }*/
                if (scope.nomineePayload.nominees[i].hasOwnProperty('passport')) {
                  scope.nomineePayload.nominees[i].sameIndexPassport.forEach(function (el, indexE) {
                    if (scope.nomineePayload.nominees[i].sameIndexPassport[indexE] > index) {
                      scope.nomineePayload.nominees[i].sameIndexPassport[indexE] = scope.nomineePayload.nominees[i].sameIndexPassport[indexE] === 0 ? 0 : scope.nomineePayload.nominees[i].sameIndexPassport[indexE] - 1;
                    }
                  });
                }
              }
            }
            if (scope.nomineePayload.nominees[index].hasOwnProperty('passport') && scope.nomineePayload.nominees[index].passport) {
              if (scope.nomineePayload.nominees[index].sameIndexPassport && scope.nomineePayload.nominees[index].sameIndexPassport.length === 1) {
                scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndexLiscense[0]].sameIndexPassport = [];
                scope.nomineePayload.nominees[scope.nomineePayload.nominees[index].sameIndexLiscense[0]].nomineePassportValid = false;
                scope.nomineePayload.nominees[index].sameIndexPassport = [];
                scope.nomineePayload.nominees[index].nomineePassportValid = false;
                scope.nomineePayload.nominees.forEach(function (el) {
                  if (el.sameIndexPassport && el.sameIndexPassport.length > 0) {
                    el.sameIndexPassport.forEach(function (val,indexE) {
                      if (el.sameIndexPassport[indexE] > index) {
                        el.sameIndexPassport[indexE] = el.sameIndexPassport[indexE] === 0 ? 0 : el.sameIndexPassport[indexE] - 1;
                      }
                    });
                  }
                });

                for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                  if (scope.nomineePayload.nominees[i].sameIndexPassport && scope.nomineePayload.nominees[i].sameIndexPassport.length === 0) {
                    scope.nomineePassportValid = true;
                  } else if (scope.nomineePayload.nominees[i].sameIndexPassport && scope.nomineePayload.nominees[i].sameIndexPassport.length !== 0)  {
                    scope.nomineePassportValid = false;
                    break;
                  }
                }
              } else if(scope.nomineePayload.nominees[index].sameIndexPassport && scope.nomineePayload.nominees[index].sameIndexPassport.length > 1) {
                scope.nomineePayload.nominees[index].sameIndexPassport.forEach(function (el) {
                  if (scope.nomineePayload.nominees[el].sameIndexPassport && scope.nomineePayload.nominees[el].sameIndexPassport.length === 1) {
                    scope.nomineePayload.nominees[el].sameIndexPassport = [];
                    scope.nomineePayload.nominees[el].nomineePassportValid = false;
                  } else {
                    var indexEL = scope.nomineePayload.nominees[el].sameIndexPassport.indexOf(index);
                    scope.nomineePayload.nominees[el].sameIndexPassport.splice(indexEL,1);
                    scope.nomineePayload.nominees[el].sameIndexPassport.forEach(function (val,indexE) {
                      if (scope.nomineePayload.nominees[el].sameIndexPassport[indexE] > index) {
                        scope.nomineePayload.nominees[el].sameIndexPassport[indexE] = scope.nomineePayload.nominees[el].sameIndexPassport[indexE] === 0 ? 0 : scope.nomineePayload.nominees[el].sameIndexPassport[indexE] - 1;
                      }
                    });
                  }
                });
              }
              for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                if (scope.nomineePayload.nominees[i].hasOwnProperty('drivingLicense')) {
                  scope.nomineePayload.nominees[i].sameIndexLiscense.forEach(function (el, indexE) {
                    if (scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] > index) {
                      scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] = scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] === 0 ? 0 : scope.nomineePayload.nominees[i].sameIndexLiscense[indexE] - 1;
                    }
                  });
                }
              }
            }
          }
          setIncapcitationList();
          scope.nomineePayload.nominees.splice(index, 1);
        };

        scope.addNominee = function () {
          var msg = checkValidation();
          if (msg) {
            MessageService.error(msg);
            return;
          }
          if (!scope.nomineePayload.nominees)
            scope.nomineePayload.nominees = [];
          // var percentage = calculateProportion();
          scope.nomineePayload.nominees.push(scope.showAddNominee ? InvestorFolioModel.getUpdatedNomineeObject() : InvestorFolioModel.getNomineeObject());
          scope.activeTab = scope.nomineePayload.nominees.length - 1;
          scope.nomineePayload.nominees[scope.nomineePayload.nominees.length - 1].applicantPersonalIdentifiers = angular.copy(scope.applicantPersonalIdentifiers);
        };

        function checkValidation() {
          var arr = scope.nomineePayload.nominees, msg = '';
          for (var i = 0; i < arr.length; i++) {
            if (!arr[i]['nomineeName'] || !arr[i]['percentage']) {
              msg = 'Please fill details of ' + scope.nomineeEnum[i]
                + ' nominee';
              break;
            }
          }
          return msg;
        }

        /*function calculateProportion() {
          var percentage = 0, nominees = scope.nomineePayload.nominees;

          if (nominees.length === 0) {
            percentage = 100;
          } else if (nominees.length === 1) {
            percentage = 100 - parseInt(nominees[0].percentage);
          } else if (nominees.length === 2) {
            percentage = 100 - (parseInt(nominees[0].percentage) + parseInt(nominees[1].percentage));
          }

          return percentage;
        }*/

        scope.calculatePercentage = function () {
          var totalPercentage = 0;
          var nominees = scope.nomineePayload.nominees;
          for (var i=0; i<nominees.length; i++ ) {
            totalPercentage += parseInt(nominees[i].percentage);
          }
          scope.totalPercentage = totalPercentage;
          if (scope.totalPercentage < 100 && scope.nomineePayload.nominees.length < scope.maxNominee) {
            scope.showAddNominee = true;
          } else {
            scope.showAddNominee = false;
          }
          if (totalPercentage != 100) {
            scope.percentage_msg = scope.nomineeValidateData.PROPORTION_PERCENTAGE;
            return false;
          } else {
            scope.percentage_msg = '';
            return true;
          }
        };

        /*function getPayload() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                scope.nomineePayload = resp.data;
                scope.MainFolioParent.holdmode = resp.data.holdmode;
                if (scope.nomineePayload && scope.nomineePayload.nominees.length === 0) {
                  //scope.nomineePayload.nominees = [];
                  scope.addNominee();
                } else if (scope.nomineePayload && scope.nomineePayload.nominees && scope.nomineePayload.nominees.length === 0) {
                  scope.wantToAddNomineeLater = true;
                } else {
                  scope.wantToAddNomineeLater = false;
                }
                scope.calculatePercentage();
                LoaderService.hideLoader();
              } else {
                MessageService.error(resp.message);
                LoaderService.hideLoader();
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
            };

          var investorId=localStorage.getItem('folioId');
          InvestorServiceV3.post({
            child1: 'folio',
            child2: 'getDetails'
          },{id:investorId}).$promise.then(success, error);

        }*/

        scope.next = function () {
          nomineeSaveFolio('folioDetails.bankDetails');
        };

        scope.back = function (from) {
          if(scope.nomineePayload.holdmode === CONST.INVESTOR_HOLD_MODE.AOS){
            nomineeSaveFolio('main.folio.jointholders', from);
          }else {nomineeSaveFolio('main.folio.soleApplicant', from)}
        };

        function checkProportionTotalSum() {
          var sum = 0, msg = '';
          for (var i = 0; i < scope.nomineePayload.nominees.length; i++) {
            sum = sum + parseInt(scope.nomineePayload.nominees[i].percentage);
          }
          if (sum != 100) {
            msg = 'Total sum of nominee proportion should be 100';
          }

          return msg;

        }

        function getCountryList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.nomineeCountryList = resp.data.countries;
            } else {
              scope.nomineeCountryList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.nomineeCountryList = null;
          };
          InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
        }

        function nomineeSaveFolio(stateToMove, from) {
          if (from != 'fromBack') {
            // if (!scope.wantToAddNomineeLater) {
            //   var msg = checkProportionTotalSum();
            //   if (msg) {
            //     MessageService.error(msg);
            //     return;
            //   }
            // }
            if (scope.wantToAddNomineeLater) {
              localStorage.setItem("wantToAddNomineeLater", "true");
              if(scope.optOutNominee == true){
                localStorage.setItem("optOutNominee", "true");
              }
              scope.nomineePayload.nominees = [];
            } else if(!scope.wantToAddNomineeLater){
              localStorage.setItem("wantToAddNomineeLater", "false");
              if(!scope.optOutNominee){
                localStorage.setItem("optOutNominee", "false");
              }
            }
          }
          checkNominees();
          if (scope.nomineePayload) {
            scope.nomineePayload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
          }

          LoaderService.showLoader();

          var success = function (resp) {
            if (resp.status && resp.data) {
              (scope.MainFolioParent) && (scope.MainFolioParent.uuid = resp.data.id);
              if (stateToMove) {
                $state.go(stateToMove, {investorId: $stateParams.investorId});
              }else{

                LoaderService.hideLoader();
                MessageService.success('Saved Successfully.');
                $state.go('welcome');
              }
            } else {
              MessageService.error(resp.message);
            }

            LoaderService.hideLoader();
          }, error = function () {
            LoaderService.hideLoader();
          };
          scope.nomineePayload.firstFolio = scope.firstFlow ? true : false;
          scope.nomineePayload.folioSaveStep = "FOUR";
          // InvestorService.post({child1: 'folio', child2: 'saveFolio'}, scope.nomineePayload).$promise.then(success, error);

          InvestorServiceV3.post({child1: 'folio', child2: 'save'}, scope.nomineePayload).$promise.then(success, error);

        }
        function continueFolio(stateToMove, from) {
          if (from != 'fromBack') {
            if (!scope.wantToAddNomineeLater) {
              var msg = checkProportionTotalSum();
              if (msg) {
                MessageService.error(msg);
                return;
              }
            }
            if (scope.wantToAddNomineeLater) {
              scope.nomineePayload.nominees = [];
            }
          }
          checkNominees();
          if (scope.nomineePayload) {
            scope.nomineePayload.id = localStorage.getItem('folioId');
          }

          LoaderService.showLoader();

          var success = function (resp) {
            if (resp.status && resp.data) {
              if (scope.wantToAddNomineeLater == true) {
                localStorage.setItem('wantToAddNomineeLater',"true");
              } else {
                localStorage.setItem('wantToAddNomineeLater',"false");
              }
              scope.editNominee = false;

              scope.payloadData.FOLIO_CREATION_STEP.nominee_details_completed = true;

              InvestmentModel.setPayload(scope.payloadData);

              // for showing edit button
              scope.stepperUpdatedInfo();

              scope.proceedAction();
              MessageService.success('Saved Successfully.');
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }, error = function () {
            LoaderService.hideLoader();
          };
          scope.nomineePayload.firstFolio = scope.firstFlow  ? true : false;
          scope.nomineePayload.newUserFlow = scope.firstFlow  ? true : false;
          scope.nomineePayload.folioSaveStep = "FOUR";
          scope.nomineePayload.investmentBasketId = sessionStorage.getItem('journeyDraftId');
          scope.nomineePayload.singlePage = true;
          // InvestorService.post({child1: 'folio', child2: 'saveFolio'}, scope.nomineePayload).$promise.then(success, error);
          if(scope.journey === 'ECART') {
            scope.nomineePayload.ignoreDraftFolio = true;
            scope.nomineePayload.newFolioCreationFlow = true;
            scope.nomineePayload.cartFlow = true;
          }
          var payload = scope.nomineePayload;
          if (payload.holdmode === "ANY_OR_SURVIVOR" || payload.nomineeRegistrationCO && payload.nomineeRegistrationCO.incapacitationDeclaration && Object.keys(payload.nomineeRegistrationCO.incapacitationDeclaration).length === 0) {
            delete payload.nomineeRegistrationCO.incapacitationDeclaration;
          }
          if (scope.wantToAddNomineeLater) {
            delete payload.nomineeRegistrationCO;
          }
          if (!scope.firstFlow) {
            InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);
          } else {
            NewInvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);
          }
        }

        scope.nomineeContinue = function () {
          scope.payloadData = InvestmentModel.getPayload();
          scope.continueFolio();
          // if(scope.firstFlow === 'YES'){
          //   scope.continueFolio('folioDetails.bankDetails',{investorId:$stateParams.investorId});
          // }else{
          //   scope.continueFolio('main.folio.bankdetails',{investorId:$stateParams.investorId});
          // }

        };

        function goToBack() {
          if(scope.firstFlow === 'YES'){
            if(scope.nomineePayload.holdmode === CONST.INVESTOR_HOLD_MODE.AOS){
              $state.go('folioDetails.jointholders',{investorId:$stateParams.investorId});
            }else {
              $state.go('folioDetails.folioCreation',{investorId:$stateParams.investorId});
              // nomineeSaveFolio('main.folio.soleApplicant','fromBack');
            }
          }else{
            if(scope.nomineePayload.holdmode === CONST.INVESTOR_HOLD_MODE.AOS){
              $state.go('main.folio.jointholders',{investorId:$stateParams.investorId});
              // nomineeSaveFolio('main.folio.jointholders','fromBack');
            }else {
              $state.go('main.folio.soleApplicant',{investorId:$stateParams.investorId});
              // nomineeSaveFolio('main.folio.soleApplicant','fromBack');
            }

          }
          if(scope.wantToAddNomineeLater == false){
            localStorage.setItem('wantToAddNomineeLater',"false");
            localStorage.setItem('optOutNominee',"false");
          }
        }

        function checkNominees() {
          for (var i = 0; i < scope.nomineePayload.nominees.length; i++) {
            delete scope.nomineePayload.nominees[i].minorPanInvalid;
            delete scope.nomineePayload.nominees[i].nomineePanInvalid;
            if (scope.nomineePayload.nominees[i].minor) {
              delete scope.nomineePayload.nominees[i].nomineeAddress;
            } else {
              delete scope.nomineePayload.nominees[i].guardianName;
              delete scope.nomineePayload.nominees[i].guardianAddress;
              delete scope.nomineePayload.nominees[i].guardianPanNumber;
              delete scope.nomineePayload.nominees[i].guardianRelationWithNominee;
            }
            if (scope.showNomineeUpdate && scope.nomineePayload.nominees[i].drivingLicense) {
              scope.nomineePayload.nominees[i].identityProofNumber = scope.nomineePayload.nominees[i].drivingLicense;
              delete scope.nomineePayload.nominees[i].drivingLicense;
            }
            if (scope.showNomineeUpdate && scope.nomineePayload.nominees[i].aadharCard) {
              scope.nomineePayload.nominees[i].identityProofNumber = scope.nomineePayload.nominees[i].aadharCard;
              delete scope.nomineePayload.nominees[i].aadharCard;
            }
            if (scope.showNomineeUpdate && scope.nomineePayload.nominees[i].panNumber) {
              scope.nomineePayload.nominees[i].identityProofNumber = scope.nomineePayload.nominees[i].panNumber;
              delete scope.nomineePayload.nominees[i].panNumber;
            }

            if (scope.showNomineeUpdate && scope.nomineePayload.nominees[i].passport) {
              scope.nomineePayload.nominees[i].identityProofNumber = scope.nomineePayload.nominees[i].passport;
              delete scope.nomineePayload.nominees[i].passport;
            }

            if (scope.showNomineeUpdate && scope.nomineePayload.nominees[i].somethingElse) {
              scope.nomineePayload.nominees[i].identityProofNumber = scope.nomineePayload.nominees[i].somethingElse;
              delete scope.nomineePayload.nominees[i].somethingElse;
            }
          }
          if(scope.showNomineeUpdate && scope.nomineePayload.nomineeRegistrationCO && scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration){
            if(scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage && parseInt(scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage) > 0) {
              delete scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount;
            }
            if (scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount && parseInt(scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount) > 0) {
              delete scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage;
            }
          }
        }

        scope.checkAddNominee = function (value) {
          scope.wantToAddNomineeLater = value;
          if(scope.wantToAddNomineeLater == true){
            localStorage.setItem('wantToAddNomineeLater', "true");
          } else if(scope.wantToAddNomineeLater == false){
            scope.optOutNominee = false;
            localStorage.setItem('wantToAddNomineeLater', "false");
            localStorage.setItem('optOutNominee',"false");
          }
        }

        scope.$watch('nomineePayload.nominees', function () {
          if(scope.addNomineeForm.$valid){return;}
          var formFieldList = scope.addNomineeForm.$error.required;
          if (angular.isArray(formFieldList) && formFieldList.length > 0) {

            var formTypeArray = formFieldList.map(function (ele) {
              return ele.$name.split('-')[1];
            }).filter(function (value, index, self) {
              return self.indexOf(value) === index;
            });
            var nomineeList = [];
            angular.forEach(formTypeArray, function (val) {
              switch (val) {
                case "0":
                  nomineeList.push('First Nominee');
                  break;
                case "1":
                  nomineeList.push('Second Nominee');
                  break;
                case "2":
                  nomineeList.push('Third Nominee');
                  break;
                case "3":
                  nomineeList.push('Fourth Nominee');
                  break;
                case "4":
                  nomineeList.push('Fifth Nominee');
                  break;
                case "5":
                  nomineeList.push('Sixth Nominee');
                  break;
              }
            });

            scope.validationMsg = setMsg(nomineeList);
          } else {
            scope.validationMsg = '';
          }
          if (scope.showNomineeUpdate) {
            scope.nomineePayload.accountHoldingDeclaration = scope.nomineePayload.hasOwnProperty('accountHoldingDeclaration') ? scope.nomineePayload.accountHoldingDeclaration : {};
            scope.nomineePayload.accountHoldingDeclaration.nomination = scope.nomineePayload.accountHoldingDeclaration.nomination === false ? false : true;
            setStatement();
            setIncapcitationList();
          }
        }, true);

        function setMsg(list) {
          var msg = 'Please complete the ';
          var array = angular.copy(list);
          if (array.length == 0) {
            return '';
          }
          else if (array.length == 1) {
            return msg + array.join(',') + ' Details';
          }
          else if (array.length > 1) {
            var listLast = array.pop();
            return msg + array.join(' , ') + ' and ' + listLast + ' Details';
          }


        }

        function nomineeInit() {
          $window.scrollTo(0, 0);
          LoaderService.showLoader();
          setInitialHeader();
          getPayload();
          // scope.FolioDetailsParent.stepsAway = 2;
          // getCountryList();
          // getRelationshipList();
          // getStateList();
          // $timeout(function () {
          //   for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
          //     scope.changeCountry(i,scope.nomineePayload.nominees[i].nomineeAddress.country)
          //     scope.changeCountryGuardian(i,scope.nomineePayload.nominees[i].guardianAddress.country)
          //   }
          // },1000);
          // getPayload();
          // folioSelectionData();
          var currentDate = Date();
          var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
          var initiateDate = new Date('January 01, 1900 00:00:00');
          scope.isMinorMinDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
          scope.isMinorMaxDate = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
          scope.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
          scope.dataMinDate = $window.moment(Date.parse(initiateDate));
        }

        function folioSelectionData(){
          if(scope.selectedFolioData) {
            if (scope.selectedFolioData.nominees && scope.selectedFolioData.nominees.length > 0) {
              for(var i = 0 ; i < scope.selectedFolioData.nominees.length ; i ++) {
                scope.selectedFolioData.nominees[i].nomineeRelation = scope.selectedFolioData.nominees[i].nomineeRelation.toUpperCase();
              }
              scope.wantToAddNomineeLater = false;
              scope.optOutNominee = false;
              scope.nomineePayload.nominees = angular.copy(scope.selectedFolioData.nominees);
                for (var i = 0 ; i < scope.nomineePayload.nominees.length ; i++) {
                  var currDate = $window.moment(scope.nomineePayload.nominees[i].dob, 'DD-MMM-YYYY');
                  var age = $window.moment().diff(currDate, 'years');

                  if (age < 18) {
                    scope.nomineePayload.nominees[i].minor = true;
                  } else  {
                    scope.nomineePayload.nominees[i].minor = false
                  }
                }
            } else {
              scope.wantToAddNomineeLater = true;
              scope.optOutNominee = true;
            }
          }
        }

        // getting Nominee Details

        function setInitialHeader() {
          var profile = AuthService.getToken();
          scope.MainFolioParent = {};
          scope.MainFolioParent.panNumber = profile.investorPAN;
          scope.MainFolioParent.firstName = profile.investorFName;
          scope.MainFolioParent.middleName = profile.investorMName;
          scope.MainFolioParent.lastName = profile.investorLName;
          scope.MainFolioParent.currentState = 'main.folio.nominee';
          scope.pan = profile.investorPAN;

        }

        function getPayload() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.nomineePayload = resp.data;
              scope.MainFolioParent.holdmode = resp.data.holdmode;
              scope.showNomineeUpdate = scope.nomineePayload && scope.nomineePayload.sebiNomineeRegulatory01650Active ? scope.nomineePayload.sebiNomineeRegulatory01650Active : false;
              scope.nomineePayload.nomineeRegistrationCO = scope.nomineePayload.nomineeRegistrationCO ? scope.nomineePayload.nomineeRegistrationCO : {};
              scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration = scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration ? scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration : {};
              scope.maxNominee = scope.nomineePayload && scope.nomineePayload.nomineeLimit ? scope.nomineePayload.nomineeLimit : 3;
              scope.nomineePayload.accountHoldingDeclaration = {};
              scope.nomineePayload.accountHoldingDeclaration.nomination = scope.nomineePayload.nomineeRegistrationCO && scope.nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration && scope.nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration === 'NOMINATION_NO' ? false: true;
              scope.allowedNomineeLength = scope.maxNominee;
              scope.nomineePayload.incapcitationNomineeIndex = scope.nomineePayload.nomineeRegistrationCO && scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration && scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber ? scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber - 1 : null;
              if(scope.selectedFolioData && scope.selectedFolioData.nominees && scope.selectedFolioData.nominees.length > 0){
                scope.folioSelectionData();
              }else if (scope.nomineePayload && scope.nomineePayload.nominees && scope.nomineePayload.nominees.length === 0) {
                scope.nomineePayload.nominees = [];
                scope.addNominee();
                scope.wantToAddNomineeLater = true;
              } else {
                scope.wantToAddNomineeLater = false;
              }
              scope.calculatePercentage();
              LoaderService.hideLoader();

              setHeader();
              getCountryList();
              getRelationshipList();
              getStateList();
              $timeout(function () {
                for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                  if (scope.nomineePayload.nominees[i].nomineeAddress.country !== null) {
                    scope.nomineePayload.nominees[i].nomineeAddress.country = getCountryCode(scope.nomineePayload.nominees[i].nomineeAddress.country);
                    scope.changeCountry(i,scope.nomineePayload.nominees[i].nomineeAddress.country)
                  }
                  scope.changeCountryGuardian(i,scope.nomineePayload.nominees[i].guardianAddress.country);
                  if (scope.showNomineeUpdate) {
                    setStatement();
                    getPersonalIdentifier(function(resp) {
                      if (resp) {
                        $timeout(function() {
                          scope.nomineePayload.nominees.forEach(function (element, index) {
                            if (element.minor) {
                              element.applicantPersonalIdentifiers = scope.applicantPersonalIdentifiers.filter(function(obj, index) {
                                return obj.identityProofType !== 'DRIVING_LICENSE';
                              });
                            } else {
                              element.applicantPersonalIdentifiers =  angular.copy(scope.applicantPersonalIdentifiers);
                            }
                            if (element.hasOwnProperty('identityProofType') && element.identityProofType !== null) {
                              if (element.identityProofType === "AADHAR_CARD") {
                                scope.nomineePayload.nominees[index].aadharCard = scope.nomineePayload.nominees[index].identityProofNumber ? scope.nomineePayload.nominees[index].identityProofNumber : '';
                                aadharCardChanged(index, scope.nomineePayload.nominees[index].aadharCard);
                              } else if (element.identityProofType === "DRIVING_LICENSE") {
                                scope.nomineePayload.nominees[index].drivingLicense = scope.nomineePayload.nominees[index].identityProofNumber ? scope.nomineePayload.nominees[index].identityProofNumber : '';
                                drivingLicenseChanged(index, scope.nomineePayload.nominees[index].drivingLicense);
                              } else if (element.identityProofType === "PAN_CARD") {
                                scope.nomineePayload.nominees[index].panNumber = scope.nomineePayload.nominees[index].identityProofNumber? scope.nomineePayload.nominees[index].identityProofNumber :'';
                                scope.nomineePanChanged(index, scope.nomineePayload.nominees[index].panNumber);
                              } else if (element.identityProofType === "PASSPORT") {
                                scope.nomineePayload.nominees[index].passport = scope.nomineePayload.nominees[index].identityProofNumber? scope.nomineePayload.nominees[index].identityProofNumber :'';
                                scope.passportChanged(index, scope.nomineePayload.nominees[index].passport);
                              }
                              changePersonalIdentifier(index, element.identityProofType);
                            }
                          });
                        });
                      }
                    });
                  }
                }
              },1000);

            } else {
              MessageService.error(resp.message);
              LoaderService.hideLoader();
            }
          },
          error = function () {
            LoaderService.hideLoader();
          };

          var investorId =localStorage.getItem('folioId');
          InvestorServiceV3.post({
            child1: 'folio',
            child2: 'getDetails'
          },{id:investorId}).$promise.then(success, error);

        }




        function getRelationshipList() {

          scope.applicantRelationShip = [];
          scope.minorRelationShip = [];

          var success = function (resp) {
            if (resp.status && resp.data) {
              var relationshipWithApplicant = resp.data.nomineeRelationshipList;
              var relationshipWithMinor = resp.data.guardianRelationshipList;
              scope.minorRelation = {};
              relationshipWithApplicant.forEach(function(el) {
                scope.applicantRelationShip.push({
                  name : el.relationDesc,
                  value : el.value
                })
              })


              relationshipWithMinor.forEach(function(el) {
                scope.minorRelationShip.push({
                  name : el.relationDesc,
                  value : el.value
                });
                scope.minorRelation[el.value] = el.relationDesc;
              })

            } else {
              scope.applicantRelationShip = [];
              scope.minorRelationShip = [];
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.applicantRelationShip = [];
            scope.minorRelationShip = [];
          };
          InvestorService.get({
            child1: 'folio',
            child2: 'nominee',
            child3: 'relation'
          }).$promise.then(success, error);
        }

        scope.changeNomineeRelationsShip = function(index, relationship) {
          scope.applicantRelationShip.map( function (el) {
            if(el.value === relationship){
              scope.nomineePayload.nominees[index].nomineeRelation = el.value;
            }
          });
          scope.validateDOBRequired();
        }

        scope.changeMinorRelationsShip = function(index, relationship) {
          scope.minorRelationShip.map( function (el) {
            if(el.value === relationship){
              scope.nomineePayload.nominees[index].guardianRelationWithNominee = el.value;
            }
          });
          scope.validateDOBRequired();
        }


        scope.nomineePanChanged = function(index, pan) {
          if(pan == "") {
            scope.nomineePayload.nominees[index].panNumber = null;
          }
          if(scope.pan && scope.pan == pan) {
            scope.nomineePayload.nominees[index].nomineePanInvalid = true;
            scope.nomineePanValid = false;
            scope.errorMessageNominee = scope.nomineeValidateData.NOMINEE_SAME_INVESTOR;
            scope.dupIndex = index;
          } else if(scope.pan !== pan) {

            scope.nomineePayload.nominees[index].nomineePanInvalid = false;
            scope.errorMessageNominee = "";

            if (scope.nomineePayload.nominees.length == 1) {
              scope.nomineePanValid = true;
            }

            for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              if(i !== index && scope.nomineePayload.nominees[index].panNumber && scope.nomineePayload.nominees[i].panNumber == pan) {
                scope.nomineePayload.nominees[index].nomineePanInvalid = true;
                scope.nomineePanValid = false;
                scope.errorMessageNominee = scope.nomineeValidateData.NOMINEE_PAN_SAME;
                scope.indexOne = index;
                scope.indexTwo = i ;
                break;
              }

              if (scope.nomineePayload.nominees.length == 2) {
                if (scope.nomineePayload.nominees[i].nomineePanInvalid && (scope.nomineePayload.nominees[i].panNumber !== pan && scope.nomineePayload.nominees[i].panNumber !== scope.pan)) {
                  scope.nomineePanValid = true;
                } else if (scope.nomineePayload.nominees[i].panNumber !== pan && scope.nomineePayload.nominees[i].panNumber !== scope.pan) {
                  scope.nomineePanValid = true;
                }
              }

              if (scope.nomineePayload.nominees.length >= 3) {
                if(i !== index && scope.nomineePayload.nominees[index].panNumber && (scope.nomineePayload.nominees[i].panNumber == pan || scope.nomineePayload.nominees[i].panNumber == scope.pan)){
                  scope.nomineePanValid = false;
                } else if(i !== index && scope.nomineePayload.nominees[index].panNumber && scope.nomineePayload.nominees[i].panNumber !== pan && scope.nomineePayload.nominees[i].panNumber !== scope.pan &&  scope.nomineePayload.nominees[i].nomineePanInvalid != true) {
                  if(!scope.dupIndex)  {
                    if(typeof scope.indexOne !== 'undefined' && typeof scope.indexTwo !== 'undefined') {
                      if(scope.nomineePayload.nominees[scope.indexOne].panNumber == scope.nomineePayload.nominees[scope.indexTwo].panNumber) {
                        scope.nomineePanValid = false;
                      }
                    } else if(typeof scope.indexTwo !== 'undefined'){
                      if(scope.indexTwo !== i && scope.nomineePayload.nominees[i].panNumber == scope.nomineePayload.nominees[scope.indexTwo].panNumber){
                        scope.nomineePanValid = false;
                      }
                    } else {
                      scope.nomineePanValid = true;
                    }
                  } else if(scope.nomineePayload.nominees[scope.dupIndex].panNumber !== scope.pan) {
                    scope.nomineePanValid = true;
                  }
                }  else if(i !== index && scope.nomineePayload.nominees[i].nomineePanInvalid == false && scope.nomineePayload.nominees[i].panNumber !== pan && (scope.nomineePayload.nominees[i].panNumber !== scope.pan)) {
                  if(!scope.dupIndex) {
                    scope.nomineePanValid = true;
                  } else if(scope.nomineePayload.nominees[scope.dupIndex].panNumber !== scope.pan) {
                    scope.nomineePanValid = true;
                  }
                } else if (i !== index && scope.nomineePayload.nominees[i].nomineePanInvalid == false && scope.nomineePayload.nominees[index].nomineePanInvalid == false) {
                  if(!scope.dupIndex)  {
                    scope.nomineePanValid = true;
                  } else if(scope.nomineePayload.nominees[scope.dupIndex].panNumber !== scope.pan) {
                    scope.nomineePanValid = true;
                  }
                } else if(i != index && scope.nomineePayload.nominees[i].nomineePanInvalid == true) {
                  if(scope.nomineePayload.nominees[scope.indexOne].panNumber == scope.nomineePayload.nominees[scope.indexTwo].panNumber) {
                    scope.nomineePanValid = false;
                  } else if(scope.indexTwo !== i && scope.nomineePayload.nominees[i].panNumber == scope.nomineePayload.nominees[scope.indexTwo].panNumber){
                    scope.nomineePanValid = false;
                  } else {
                    scope.nomineePanValid = true;
                  }
                } else {
                  if(typeof scope.indexOne !== 'undefined' && typeof scope.indexTwo !== 'undefined' && (scope.nomineePayload.nominees[scope.indexOne].panNumber == scope.nomineePayload.nominees[scope.indexTwo].panNumber)) {
                    scope.nomineePanValid = false;
                  } else {
                    scope.nomineePanValid = true;
                  }
                }
              }
            }

            if(typeof scope.dupIndex !== 'undefined') {
              if(scope.nomineePayload.nominees[scope.dupIndex].panNumber == scope.pan) {
                scope.nomineePanValid = false;
              }
            }

            for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              if(i != index && typeof scope.indexTwo !== 'undefined' && typeof scope.indexTwo !== 'undefined' && i != scope.indexTwo  && scope.nomineePanValid) {
                if(scope.nomineePayload.nominees[scope.indexTwo] && scope.nomineePayload.nominees[scope.indexTwo].panNumber == scope.nomineePayload.nominees[i].panNumber) {
                  scope.nomineePanValid = false;
                }
              } else if(i != index && typeof scope.dupIndex !== 'undefined') {
                if(scope.nomineePayload.nominees[i].panNumber == scope.pan) {
                  scope.nomineePanValid = false;
                }
              }
            }

            if(typeof pan !== 'undefined' && pan !== null) {
              if(pan.length == 10 || scope.minorPanValid == false) {
                scope.minorPanChanged(index, scope.nomineePayload.nominees[index].guardianPanNumber , false)
              }
            }
          }
        }

        scope.minorPanChanged = function(index, pan , isCalledFromChange) {
          if(pan == "") {
            scope.nomineePayload.nominees[index].guardianPanNumber = null;
            pan = null;
          }

          if(scope.nomineePayload.nominees[index] && scope.nomineePayload.nominees[index].panNumber && scope.nomineePayload.nominees[index].panNumber == pan) {
            scope.nomineePayload.nominees[index].minorPanInvalid = true;
            scope.errorMessage = scope.nomineeValidateData.GUARDIAN_SAME_NOMINEE;
            scope.minorPanValid = false;
            scope.mdIndex = index;
          } else {

            if(scope.nomineePayload.nominees[index] && scope.nomineePayload.nominees[index].minorPanInvalid && isCalledFromChange == false) {
              isCalledFromChange = true;
            }

            scope.callPan = isCalledFromChange;
            scope.nomineePayload.nominees[index].minorPanInvalid = false;
            scope.errorMessage = '';

            for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              if(i != index) {
                if(scope.nomineePayload.nominees[i].panNumber && scope.nomineePayload.nominees[i].panNumber == scope.pan) {
                  scope.minorPanValid = false;
                  break;
                } else if(typeof scope.mdIndex !== 'undefined' && scope.nomineePayload.nominees[scope.mdIndex] && scope.pan && scope.nomineePayload.nominees[scope.mdIndex].panNumber == scope.nomineePayload.nominees[scope.mdIndex].guardianPanNumber) {
                  scope.minorPanValid = false;
                  break;
                } else if(!scope.isGuardian && i == scope.invalidPanIndex) {
                  scope.nomineePayload.nominees[scope.invalidPanIndex].minorPanInvalid = true;
                  scope.minorPanValid = false;
                  scope.errorMessage = scope.errMessg;
                  break;
                }
              } else {
                scope.minorPanValid = true;
                scope.errorMessage = "";
                if(typeof scope.invalidPanIndex !== 'undefined' && i == scope.invalidPanIndex) {
                  scope.isGuardian = true;
                  scope.nomineePayload.nominees[scope.invalidPanIndex].minorPanInvalid = false;
                }
              }
            }

            if(typeof pan == 'undefined' || pan == null) {
              for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                if(i != index && scope.nomineePayload.nominees[i].minorPanInvalid == true) {
                  scope.minorPanValid = false;
                  break;
                }
              }
            }


            var success = function (resp) {
              if(resp.data && resp.status) {
                if(!resp.data.panVerifiedFlag) {
                  scope.nomineePayload.nominees[index].minorPanInvalid = true;
                  scope.errMessg = resp.data.message;
                  scope.minorPanValid = false;
                  scope.errorMessage = scope.errMessg;
                  scope.isGuardian = false;
                  scope.invalidPanIndex = index;
                } else {
                  scope.nomineePayload.nominees[index].minorPanInvalid = false;
                  if(scope.invalidPanIndex && scope.nomineePayload.nominees[scope.invalidPanIndex]) {
                    if(scope.nomineePayload.nominees[scope.invalidPanIndex].minorPanInvalid == false) {
                      for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                        if(i != index) {
                          if(scope.nomineePayload.nominees[i].minorPanInvalid) {
                            scope.minorPanValid = false;
                            break;
                          } else {
                            scope.minorPanValid = true;
                          }
                        }
                      }
                      scope.isGuardian = true;
                    }
                  } else {
                    for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
                      if(i != index) {
                        if((scope.nomineePayload.nominees[i].guardianPanNumber !== null && typeof scope.nomineePayload.nominees[i].guardianPanNumber !== 'undefined') && scope.nomineePayload.nominees[i].minorPanInvalid) {
                          scope.minorPanValid = false;
                          break;
                        } else {
                          scope.minorPanValid = true;
                        }
                      }
                    }
                  }
                }
              } else {
                MessageService.error(resp.message);
                scope.nomineePayload.nominees[index].minorPanInvalid = true;
                scope.errMessg = resp.message;
                scope.minorPanValid = false;
                scope.errorMessage = scope.errMessg;
                scope.isGuardian = false;
                scope.invalidPanIndex = index;
              }
            }, error = function (resp) {
              MessageService.error(resp.message);
              scope.nomineePayload.nominees[index].minorPanInvalid = true;
              scope.errMessg = resp.message;
              scope.minorPanValid = false;
              scope.errorMessage = scope.errMessg;
              scope.isGuardian = false;
              scope.invalidPanIndex = index;
            };

            if(typeof pan !== 'undefined' && pan !== null && isCalledFromChange) {
              InvestorService.post({
                child1: 'profile',
                child2: 'guardian',
                child3: 'verifyPan'
              },{pan : pan}).$promise.then(success, error);
            }
          }

        }

        function getStateList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.stateList = resp.data.states;
            } else {
              scope.stateList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            scope.stateList = null;
          };
          InvestorService.get({
            child1: 'folio',
            child2: 'state',
            child3: 'list'
          }).$promise.then(success, error);
        }

        scope.changeState = function(index, stateCode) {
          if (!stateCode) {
            return;
          }
          scope.stateList.map( function (state) {
            if(state.stateCode === stateCode){
              scope.nomineePayload.nominees[index].nomineeAddress.state = state.stateCode;
            }
          });
        }

        scope.changeStateGuardian = function(index, stateCode) {
          scope.stateList.map( function (state) {
            if(state.stateCode === stateCode){
              scope.nomineePayload.nominees[index].guardianAddress.state = state.stateCode;
            }
          });
        }

        scope.changeCountryGuardian = function(index, countryCode) {
          if (!countryCode) {
            scope.nomineePayload.nominees[index].guardianAddress.country = null;
            scope.nomineePayload.nominees[index].guardianAddress.state  = null;
            return;
          }
          scope.nomineeCountryList.map( function (country) {
            if(country.countryCode === countryCode){
              if (scope.nomineePayload.nominees[index].guardianAddress.country != 'IN'){
                for(var i = 0; i < scope.stateList.length; i++){
                  if (scope.stateList[i].stateCode == 'XX'){
                    scope.nomineePayload.nominees[index].guardianAddress.state  = scope.stateList[i].stateCode;
                    break;
                  }
                }
              }
            }
          });
        }

        scope.changeCountry = function(index, countryCode) {
          if (!countryCode) {
            scope.nomineePayload.nominees[index].nomineeAddress.country = null;
            scope.nomineePayload.nominees[index].nomineeAddress.state  = null;
            return;
          }
          scope.nomineeCountryList.map( function (country) {
            if(country.countryCode === countryCode){
              if (scope.nomineePayload.nominees[index].nomineeAddress.country != 'IN'){
                for(var i = 0; i < scope.stateList.length; i++){
                  if (scope.stateList[i].stateCode == 'XX'){
                    scope.nomineePayload.nominees[index].nomineeAddress.state  = scope.stateList[i].stateCode;
                    break;
                  }
                }
              }
            }
          });
        }

        scope.checkOptOutNominee = function(){
          scope.optOutNominee= !scope.optOutNominee;
          if(scope.optOutNominee == true){
            localStorage.setItem('optOutNominee',"true");
            scope.formIsvalid()
          } else {
            localStorage.setItem('optOutNominee',"false");
          }

        }

        scope.formIsvalid = function () {
          scope.$emit('buttonEnable')
        }

        scope.formIsinvalid = function () {
          scope.$emit('buttonDisable')
        }

        scope.truncateMsg = function () {
          scope.truncateMessage = scope.truncateMessage == 198 ? scope.dynamicNote.content.length : scope.truncateMessage = 198;
        }

        scope.validateDOBRequired = function(){
          scope.dobRequired = false;
          scope.nomineePayload.nominees.forEach(function (item) {
            if(item.minor && !item.dob){
              scope.dobRequired = true;
            }
          });
        }
        scope.changeFolioMinor = function(){
          scope.nomineePayload.nominees[scope.activeTab].dob = "";
          scope.validateDOBRequired();
          if (scope.nomineePayload.nominees[scope.activeTab].minor) {
            scope.nomineePayload.nominees[scope.activeTab].minor = true;
            scope.nomineePayload.nominees[scope.activeTab].panNumber = null;
            scope.nomineePayload.nominees[scope.activeTab].minor = true;
            scope.nomineePayload.nominees[scope.activeTab].applicantPersonalIdentifiers = scope.nomineePayload.nominees[scope.activeTab].applicantPersonalIdentifiers.filter(function(obj, index) {
              return obj.identityProofType !== 'DRIVING_LICENSE';
            });
          } else {
            scope.nomineePayload.nominees[scope.activeTab].applicantPersonalIdentifiers = angular.copy(scope.applicantPersonalIdentifiers);
            scope.nomineePayload.nominees[scope.activeTab].minor = false;
            scope.nomineePayload.nominees[scope.activeTab].guardianPanNumber = null;
            scope.nomineePayload.nominees[scope.activeTab].guardianName = null;
            scope.nomineePayload.nominees[scope.activeTab].guardianRelationWithNominee = null;
          }
          resetIncapacitationDetails();
        }
        function getCountryCode(countryCode) {
          if (countryCode) {
            var code = scope.nomineeCountryList.filter( function (country) {
              if(country.countryName.toUpperCase() === countryCode.toUpperCase() || country.countryCode === countryCode){
                return country.countryCode;
              }
            });
            return code[0].countryCode;
          }
        }
        function getPersonalIdentifier(cb) {
          cb = cb || function() {};
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.applicantPersonalIdentifiers = resp.data.identityProofs;
              cb(true);
            } else {
              scope.applicantPersonalIdentifiers = [];
              MessageService.error(resp.message);
              cb(false);
            }
          }, error = function () {
            cb(false);
            scope.applicantPersonalIdentifiers = [];
          };
          InvestorService.get({
            child1: 'identity-proofs'
          }).$promise.then(success, error);
        }

        function changePersonalIdentifier(index, identifier) {
          scope.applicantPersonalIdentifiers.map(function (el) {
            if (identifier !== "AADHAR_CARD" && scope.nomineePayload.nominees[index].hasOwnProperty('aadharCard')) {
              scope.nomineePayload.nominees[index].aadharCard = '';
              aadharCardChanged(index, scope.nomineePayload.nominees[index].aadharCard);
            }

            if (identifier !== "DRIVING_LICENSE" && scope.nomineePayload.nominees[index].hasOwnProperty('drivingLicense')) {
              scope.nomineePayload.nominees[index].drivingLicense = '';
              drivingLicenseChanged(index, scope.nomineePayload.nominees[index].drivingLicense);
            }

            if (identifier !== "PAN_CARD" && scope.nomineePayload.nominees[index].hasOwnProperty('panNumber')) {
              scope.nomineePayload.nominees[index].panNumber = '';
              scope.nomineePanChanged(index, scope.nomineePayload.nominees[index].panNumber);
            }

            if (identifier !== "PASSPORT" && scope.nomineePayload.nominees[index].hasOwnProperty('passport')) {
              scope.nomineePayload.nominees[index].passport = '';
              scope.passportChanged(index, scope.nomineePayload.nominees[index].passport);
            }

            if (el.identityProofType === identifier) {
              scope.nomineePayload.nominees[index].identityProofType = el.identityProofType;
              scope.nomineePayload.nominees[index].identityProofDescription = el.identityProof;
              scope.nomineePayload.nominees[index].identityProofCamsCode = el.identityProofCamsCode;
            }
          });
        }

        function selectedNominee(value) {
          if (scope.nomineePayload.incapcitationNomineeIndex !== null) {
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = parseInt(scope.nomineePayload.incapcitationNomineeIndex) + 1;
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = scope.nomineePayload.nominees[parseInt(scope.nomineePayload.incapcitationNomineeIndex)].nomineeName;
          } else {
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage = null;
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount = null;
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = null;
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = null;
            scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration = {};
          }
        }

        function changeEmailId(index, emailId) {
          if (!emailId) {
            return;
          }
          if (scope.nomineePayload.soleApplicantDetail.personalDetail.email && scope.nomineePayload.soleApplicantDetail.personalDetail.email.toLowerCase() === scope.nomineePayload.nominees[index].emailId.toLowerCase()) {
            scope.nomineePayload.nominees[index].emailIdInvalid = true;
            scope.emailIdValid = false;
            scope.errorMessageEmail = scope.nomineeValidateData.EMAILID_SAME_INVESTOR;
          } else {
            scope.nomineePayload.nominees[index].emailIdInvalid = false;
            scope.emailIdValid = true;
            scope.errorMessageEmail = null;
          }
        }
        function changeMobileNumber(index, mobile) {
          if (!mobile) {
            return;
          }
          if (scope.nomineePayload.soleApplicantDetail.personalDetail.mobileNo && scope.nomineePayload.soleApplicantDetail.personalDetail.mobileNo === scope.nomineePayload.nominees[index].mobile) {
            scope.nomineePayload.nominees[index].mobileInvalid = true;
            scope.mobileValid = false;
            scope.errorMessageMobile = scope.nomineeValidateData.MOBILE_SAME_INVESTOR;
          } else {
            scope.nomineePayload.nominees[index].mobileInvalid = false;
            scope.mobileValid = true;
            scope.errorMessageMobile = null;
          }
        }

        function drivingLicenseChanged(index, license) {
          scope.nomineeLicenseValid = true;
          scope.nomineePayload.nominees[index].nomineeLicenseInvalid = false;

          if (!scope.nomineePayload.nominees[index].sameIndexLiscense) {
            scope.nomineePayload.nominees[index].sameIndexLiscense = [];
          }

          if (scope.nomineePayload.nominees.length === 1) {
            scope.nomineeLicenseValid = true;
          } else if (scope.nomineePayload.nominees.length > 1) {
            for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
              if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('drivingLicense') && scope.nomineePayload.nominees[i].drivingLicense === license) {
                scope.nomineePayload.nominees[index].nomineeLicenseInvalid = true;
                scope.nomineePayload.nominees[i].nomineeLicenseInvalid = true;
                scope.nomineePayload.nominees[index].sameIndexLiscense.push(i);
                if (!scope.nomineePayload.nominees[i].sameIndexLiscense) {
                  scope.nomineePayload.nominees[i].sameIndexLiscense = [];
                }
                scope.nomineePayload.nominees[i].sameIndexLiscense.push(index);
                scope.nomineeLicenseValid = false;
              } else if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('drivingLicense')) {

                if (!scope.nomineePayload.nominees[i].sameIndexLiscense) {
                  scope.nomineePayload.nominees[i].sameIndexLiscense = [];
                }

                if (scope.nomineePayload.nominees[index].sameIndexLiscense.includes(i)) {
                  var indexEL = scope.nomineePayload.nominees[index].sameIndexLiscense.indexOf(i);
                  scope.nomineePayload.nominees[index].sameIndexLiscense.splice(indexEL,1);

                  indexEL = scope.nomineePayload.nominees[i].sameIndexLiscense.indexOf(index);
                  scope.nomineePayload.nominees[i].sameIndexLiscense.splice(indexEL,1);

                  if (scope.nomineePayload.nominees[i].sameIndexLiscense.length === 0) {
                    scope.nomineePayload.nominees[i].nomineeLicenseValid = false;
                  }
                }
                if (scope.nomineePayload.nominees[i].sameIndexLiscense && scope.nomineePayload.nominees[i].sameIndexLiscense.length !== 0){
                  scope.nomineeLicenseValid = false;
                }
              }
            }
          }
        }

        function aadharCardChanged(index, aadharCard) {
          // scope.nomineeAadhaarValid = true;
          // scope.nomineePayload.nominees[index].nomineeAadhaarInvalid = false;
          // if (!scope.nomineePayload.nominees[index].sameIndex) {
          //   scope.nomineePayload.nominees[index].sameIndex = [];
          // }
          //
          // if (scope.nomineePayload.nominees.length == 1) {
          //   scope.nomineeAadhaarValid = true;
          // } else if (scope.nomineePayload.nominees.length > 1) {
          //   for(var i = 0 ; i < scope.nomineePayload.nominees.length ; i ++) {
          //
          //     if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('aadharCard') && scope.nomineePayload.nominees[i].aadharCard === aadharCard) {
          //       scope.nomineePayload.nominees[index].nomineeAadhaarInvalid = true;
          //       scope.nomineePayload.nominees[i].nomineeAadhaarInvalid = true;
          //       scope.nomineePayload.nominees[index].sameIndex.push(i);
          //       if (!scope.nomineePayload.nominees[i].sameIndex) {
          //         scope.nomineePayload.nominees[i].sameIndex = [];
          //       }
          //       scope.nomineePayload.nominees[i].sameIndex.push(index);
          //       scope.nomineeAadhaarValid = false;
          //     } else if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('aadharCard')) {
          //
          //       if (!scope.nomineePayload.nominees[i].sameIndex) {
          //         scope.nomineePayload.nominees[i].sameIndex = [];
          //       }
          //       if (scope.nomineePayload.nominees[index].sameIndex.includes(i)) {
          //         var indexEL = scope.nomineePayload.nominees[index].sameIndex.indexOf(i);
          //         scope.nomineePayload.nominees[index].sameIndex.splice(indexEL,1);
          //         indexEL = scope.nomineePayload.nominees[i].sameIndex.indexOf(index);
          //         scope.nomineePayload.nominees[i].sameIndex.splice(indexEL,1);
          //
          //         if (scope.nomineePayload.nominees[i].sameIndex.length === 0) {
          //           scope.nomineePayload.nominees[i].nomineeAadhaarInvalid = false;
          //         }
          //       }
          //       if (scope.nomineePayload.nominees[i].sameIndex && scope.nomineePayload.nominees[i].sameIndex.length !== 0){
          //         scope.nomineeAadhaarValid = false;
          //       }
          //     }
          //
          //   }
          // }
        }

        function setStatement() {
          scope.nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration = scope.nomineePayload.accountHoldingDeclaration.nomination ? 'NOMINATION_YES' : 'NOMINATION_NO';
        }

        function setIncapcitationList(index) {
          scope.incapcitationList = [];
          scope.nomineePayload.nominees.forEach(function(nominee, index) {
            if (scope.nomineePayload.nominees[index].nomineeName) {
              scope.incapcitationList.push(angular.copy({
                key : scope.nomineePayload.nominees[index].nomineeName + '-' + scope.nomineeEnum[index],
                value : index,
                isMinor: scope.nomineePayload.nominees[index].minor
              }));
            }
          });
          scope.nomineePayload.incapcitationNomineeIndex = scope.nomineePayload.incapcitationNomineeIndex === index ? null : scope.nomineePayload.incapcitationNomineeIndex;
        }

        function resetIncapacitationDetails() {
          scope.nomineePayload.nomineeRegistrationCO.incapacitationDeclaration = {};
        }

        function passportChanged(index, passport) {
          scope.nomineePassportValid = true;
          scope.nomineePayload.nominees[index].nomineePassportInvalid = false;

          if (!scope.nomineePayload.nominees[index].sameIndexPassport) {
            scope.nomineePayload.nominees[index].sameIndexPassport = [];
          }

          if (scope.nomineePayload.nominees.length === 1) {
            scope.nomineePassportValid = true;
          } else if (scope.nomineePayload.nominees.length > 1) {
            for (var i = 0; i < scope.nomineePayload.nominees.length; i++) {
              if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('passport') && scope.nomineePayload.nominees[i].passport === passport) {
                scope.nomineePayload.nominees[index].nomineePassportInvalid = true;
                scope.nomineePayload.nominees[i].nomineePassportInvalid = true;
                scope.nomineePayload.nominees[index].sameIndexPassport.push(i);
                if (!scope.nomineePayload.nominees[i].sameIndexPassport) {
                  scope.nomineePayload.nominees[i].sameIndexPassport = [];
                }
                scope.nomineePayload.nominees[i].sameIndexPassport.push(index);
                scope.nomineePassportValid = false;
              } else if (i !== index && scope.nomineePayload.nominees[i].hasOwnProperty('passport')) {

                if (!scope.nomineePayload.nominees[i].sameIndexPassport) {
                  scope.nomineePayload.nominees[i].sameIndexPassport = [];
                }

                if (scope.nomineePayload.nominees[index].sameIndexPassport.includes(i)) {
                  var indexEL = scope.nomineePayload.nominees[index].sameIndexPassport.indexOf(i);
                  scope.nomineePayload.nominees[index].sameIndexPassport.splice(indexEL, 1);

                  indexEL = scope.nomineePayload.nominees[i].sameIndexPassport.indexOf(index);
                  scope.nomineePayload.nominees[i].sameIndexPassport.splice(indexEL, 1);

                  if (scope.nomineePayload.nominees[i].sameIndexPassport.length === 0) {
                    scope.nomineePayload.nominees[i].nomineePassportValid = false;
                  }
                }
                if (scope.nomineePayload.nominees[i].sameIndexPassport && scope.nomineePayload.nominees[i].sameIndexPassport.length !== 0) {
                  scope.nomineePassportValid = false;
                }
              }
            }
          }
        }
      }
    }
  }



})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('incomeDetails', incomeDetails);

  /*@ngInject*/
  function incomeDetails(AppConstants, $rootScope, LoaderService, MessageService, InvestorService, $log, $state, $timeout,
                         $window, NewInvestorServiceV3, $stateParams, InvestorFileUploadServiceV3, InvestmentModel, AuthService, InvestorServiceV3, InvestorServiceV2, ModalService) {

    return {
      restrict: 'E',
      scope: {
        firstFlow:'=', stepperUpdatedInfo : '&', proceedAction : '&', selectedFolioData: '=', journey: '='
      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/folio/income-details/income-details.directive.html',
      link: function (scope) {
        var _this = scope;
        _this.token = AuthService.getToken();
        _this.incomeTab = AppConstants.INCOME_TAB;
        _this.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        _this.CONST_DATA = AppConstants;
        _this.dateErrorMessage = "";
        _this.folioIncomeForm = {}
        _this.folioIncomeForm.occupation = '';
        _this.folioIncomeForm.annualincome = '';
        _this.folioIncomeForm.grossAnnualIncomeDate = '';
        _this.folioIncomeForm.Fatca = {};
        _this.folioIncomeForm.Fatca.city = '';
        // $rootScope.folioBasicDetail.folioForUser = 'Self';
        _this.networth = false;
        _this.holders  = {};
        _this.countries = null;
        _this.taxStatusData = null;
        _this.soleApplicantEmail = null;
        _this.soleApplicantMobile = null;
        _this.folioIncomeForm.taxstatus = null;
        _this.folioIncomeForm.Fatca.countrie = "IN";
        _this.folioIncomeForm.occupation = "2";
        _this.folioIncomeForm.Fatca.addressType = "RESIDENTIAL";
        _this.belongToListEmail = null;
        _this.belongToListMobile = null;
        _this.incomeSlabList = null;
        _this.annualTabForGuardian = true;
        _this.netWorthTabForGurdian = false;
        _this.getCountry = getCountry;
        _this.networthcall = networthcall;
        _this.autoDate = autoDate;
        _this.getPayload = getPayload;
        _this.incomeActiveTabForGuardian = incomeActiveTabForGuardian;
        _this.submitFolioIncomeForm = submitFolioIncomeForm;
        _this.incomeActiveTab = incomeActiveTab;
        _this.netWorthChanges = netWorthChanges;
        // _this.fetchBelongsToDropdown = fetchBelongsToDropdown;
        // _this.getTaxStatus = getTaxStatus;
        // _this.getOccupations = getOccupations;
        // _this.getIncomeSlab = getIncomeSlab;

        //Guardiuan details

        _this.viewMode = "days";
        _this.dateErrorMessage = "";
        $rootScope.myState = $state.current.url;
        _this.networth = false;
        _this.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        _this.minorFormGuardianData = {}
        // $rootScope.folioBasicDetail.folioForUser  = 'Minor';
        _this.minorFormGuardianData.relation = '';
        _this.minorFormGuardianData.guardianrelationproofType = '';
        _this.minorFormGuardianData.guardianrelationproofimageurl = '';
        _this.minorFormGuardianData.guardianrelationproofimagename = '';
        _this.minorFormGuardianData.occupation = '';
        _this.minorFormGuardianData.grossAnnualIncome = '';
        _this.minorFormGuardianData.grossAnnualIncomeDate = '';

        _this.minorFormGuardianData.Fatca = {};
        _this.minorFormGuardianData.Fatca.Countrie = '';
        _this.minorFormGuardianData.Fatca.City = '';
        _this.minorFormGuardianData.Fatca.taxPayIndian = true;
        _this.minorFormGuardianData.Fatca.addressType = "";
        _this.minorFormGuardianData.fileTaxOtherIndian = 'No';

        _this.minorFormGuardianData.Fatca.taxPay1 = {};
        _this.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry = "";
        _this.minorFormGuardianData.Fatca.taxPay1.taxIdType = "";
        _this.minorFormGuardianData.Fatca.taxPay1.taxPayingCity = "";
        _this.minorFormGuardianData.Fatca.taxPay1.taxId = "";

        _this.minorFormGuardianData.userPEPStatusForGuardian = 'No';
        _this.minorFormGuardianData.politicalStatus = 'NONE';
        _this.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];

        _this.relationshipList = [
          { name: 'Father', value: 'FATHER' },
          { name: 'Mother', value: 'MOTHER' }, {
            name: 'Sibling', value: 'SIBLING'
          },
          { name: 'Other', value: 'OTHER' }
        ];
        _this.notolderthan1year = false;
        _this.annualTab = true;
        _this.netWorthTab = false;

       _this.getTaxFileStatusForGuardian = getTaxFileStatusForGuardian;
       _this.grossAnnualIncomeDate = grossAnnualIncomeDate;
       _this.getProofType = getProofType;
       _this.getTaxIdType = getTaxIdType;
       _this.getGuardianRelationProofImage = getGuardianRelationProofImage;
       _this.submitMinorGuardianDetails = submitMinorGuardianDetails;
        _this.getGrossAnnualIncomeDate = getGrossAnnualIncomeDate;
        _this.folioSelectionData = folioSelectionData;

        _this.editIncomeDetail = true;
        // listening to edit button click
        _this.editContactDetails = editContactDetails;
        _this.cancelEditAction = cancelEditAction;
        _this.changeValue = changeValue;
        _this.showOtpModal = showOtpModal;
        _this.generateContactUpdateOtp = generateContactUpdateOtp;
        _this.showEmailEditField = false;
        _this.showMobileEditField = false;
        _this.soleApplicantEditedMobile = null;
        _this.soleApplicantEditedEmail = null;
        _this.isEmailEdited = false;
        _this.isMobileEdited = false;

        var listner = _this.$on("enableEditIncomeDetail", function() {
          _this.editIncomeDetail = true;
          if(_this.selectedFolioData) {
           _this.selectedFolioData.soleApplicantDetail.personalDetail.kycEmail = _this.soleApplicantEmail;
            _this.selectedFolioData.soleApplicantDetail.personalDetail.kycMobileNo = _this.soleApplicantMobile;
            _this.selectedFolioData.soleApplicantDetail.personalDetail.emailBelongsTo = _this.holders.emailBelongsTo;
            _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileBelongsTo = _this.holders.mobileBelongsTo;
            _this.selectedFolioData.soleApplicantDetail.personalDetail.taxStatusCode = _this.folioIncomeForm.taxstatus;
            if (_this.selectedFolioData.soleApplicantDetail.selfDetail) {
              _this.selectedFolioData.soleApplicantDetail.selfDetail.occupation = _this.folioIncomeForm.occupation;
              _this.selectedFolioData.soleApplicantDetail.selfDetail.address = _this.folioIncomeForm.Fatca.countrie;
              _this.selectedFolioData.soleApplicantDetail.selfDetail.fatca.addressType = _this.folioIncomeForm.Fatca.addressType;
              _this.selectedFolioData.soleApplicantDetail.selfDetail.address = _this.folioIncomeForm.Fatca.city;
              if (_this.selectedFolioData.soleApplicantDetail.selfDetail.grossAnnualIncome) {
                _this.selectedFolioData.soleApplicantDetail.selfDetail.grossAnnualIncome = _this.folioIncomeForm.annualincome;
              } else {
                _this.selectedFolioData.soleApplicantDetail.selfDetail.netWorth = _this.folioIncomeForm.networth;
                _this.selectedFolioData.soleApplicantDetail.selfDetail.netWorthDate = _this.folioIncomeForm.grossAnnualIncomeDate;
                netWorthChanges(_this.selectedFolioData.soleApplicantDetail.selfDetail.netWorth);
              }
            }
          }
          getPayload();
          _this.payloadData = InvestmentModel.getPayload();
        });

        _this.editGuardianDetail = true;
        // listening to edit button click

        var listner = _this.$on("enableEditGuardianDetail", function() {
          _this.editGuardianDetail = true;
          getPayload();
          _this.payloadData = InvestmentModel.getPayload();
        });

        // var listner = _this.$on("continueButtonIncomeDetails", function() {
        //   _this.submitFolioIncomeForm();
        // });
        //
        // var listner = _this.$on("continueButtonGuardianIncomeDetails", function() {
        //   _this.submitMinorGuardianDetails();
        // });

        _this.payloadData = InvestmentModel.getPayload();


        _this.init = init();
        _this.receivedData = {
          folioForUser: 'Self',
          folioHoldingMode: 'Single'
        };

       function init() {
         if (localStorage.getItem('folioId')) {
           getPayload();
         }
         getCountry();
         // fetchBelongsToDropdown();
         fetchBelongsToDropdown(function () {
           // _this.getPayload();
         });
         // getTaxStatus();
         getOccupations();
         getIncomeSlab();
         getAddressType();

         //Guardian Method
         getProofType();
         getTaxIdType();

         folioSelectionData();

       }
       function folioSelectionData(){
         var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
         if(_this.selectedFolioData) {
           _this.soleApplicantEmailCopy = _this.selectedFolioData.soleApplicantDetail.personalDetail.email;
           _this.soleApplicantMobileCopy = _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileNo;
           _this.soleApplicantEmail = contactUpdateCo && contactUpdateCo.isEmailEdited ? contactUpdateCo.soleApplicantEditedEmail : _this.selectedFolioData.soleApplicantDetail.personalDetail.email;
           _this.soleApplicantMobile = contactUpdateCo && contactUpdateCo.isMobileEdited ? contactUpdateCo.soleApplicantEditedMobile : _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileNo;
           _this.holders.emailBelongsTo = _this.selectedFolioData.soleApplicantDetail.personalDetail.emailBelongsTo || 'SE';
           _this.holders.mobileBelongsTo = _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileBelongsTo || 'SE';
           _this.folioIncomeForm.taxstatus = _this.selectedFolioData.soleApplicantDetail.personalDetail.taxStatusCode || "01";
           var token = AuthService.getToken()
           _this.folioIncomeForm.nriFlag = token.nriFlag;
           if (_this.folioIncomeForm.nriFlag && _this.folioIncomeForm.taxstatus === "01") {
             _this.folioIncomeForm.taxstatus = null;
           }
           getTaxStatus();
           if (_this.selectedFolioData.soleApplicantDetail.selfDetail) {
             _this.folioIncomeForm.occupation = parseInt(_this.selectedFolioData.soleApplicantDetail.selfDetail.occupation).toString();
             _this.folioIncomeForm.Fatca.countrie = _this.selectedFolioData.soleApplicantDetail.selfDetail.address ? _this.selectedFolioData.soleApplicantDetail.selfDetail.address.country : 'IN';
             _this.folioIncomeForm.Fatca.addressType = _this.selectedFolioData.soleApplicantDetail.selfDetail.fatca.addressType ? _this.selectedFolioData.soleApplicantDetail.selfDetail.fatca.addressType : 'RESIDENTIAL';
             _this.folioIncomeForm.Fatca.city = _this.selectedFolioData.soleApplicantDetail.selfDetail.fatca.birthPlace ? _this.selectedFolioData.soleApplicantDetail.selfDetail.fatca.birthPlace : '';
             if (_this.selectedFolioData.soleApplicantDetail.selfDetail.grossAnnualIncome) {
               _this.incomeActiveTab('ANNUAL_GROSS_INCOME');
               _this.folioIncomeForm.annualincome = _this.selectedFolioData.soleApplicantDetail.selfDetail.grossAnnualIncome;
             } else {
               _this.incomeActiveTab('NET_WORTH');
               _this.folioIncomeForm.networth = _this.selectedFolioData.soleApplicantDetail.selfDetail.netWorth;
               _this.folioIncomeForm.grossAnnualIncomeDate = _this.selectedFolioData.soleApplicantDetail.selfDetail.netWorthDate;
             }
           }
         }

       }

        _this.$on('someEvent', function (event, result) {
          _this.receivedData = result.data;
        });

        function fetchBelongsToDropdown(cb) {
          cb = cb ||function () {

          };
          LoaderService.showLoader();
          var success = function (resp) {
            if (resp.status && resp.data) {
              _this.belongToListEmail = resp.data.emailList;
              _this.belongToListMobile = resp.data.mobileList;
              LoaderService.hideLoader();
            } else {
              MessageService.error(resp.message);
              LoaderService.hideLoader();
            }
            cb();
          },
          error = function (err) {
            $log.info('Belongs Dropdown error >>>>', err);
            LoaderService.hideLoader();
            cb();
          };

          InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
        }

        function getCountry() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.countries = resp.data.countries;
              } else {
                _this.countries = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in country list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'country-list' }, null).$promise.then(success, error);
        }

        function getTaxStatus() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.taxStatusData = resp.data.taxStatus;
                if(angular.isUndefined(_this.folioIncomeForm.taxstatus)
                  || (_this.taxStatusData.length >0 && _this.folioIncomeForm.taxstatus != '' &&
                    _this.taxStatusData.map(function (ele) {
                      return ele.taxStatusCode;
                    }).indexOf(_this.folioIncomeForm.taxstatus) === -1)) {
                  _this.folioIncomeForm.taxstatus = _this.taxStatusData.taxStatusList.length && _this.taxStatusData.taxStatusList.length > 0
                    ? _this.taxStatusData.taxStatusList[0].taxStatusCode //to select the first element in the list
                    : '';
                }
              } else {
                _this.taxStatusData = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in tax status!");
            };
          var data = { taxStatusFilter: 'ADULT' , nriFlag : _this.folioIncomeForm.nriFlag }
          InvestorService.post({ child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
        }

        function getOccupations() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.investorOccupations = resp.data.investorOccupations;
              } else {
                _this.investorOccupations = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in occupation list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'occupation' }).$promise.then(success, error);
        }

        function getIncomeSlab() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.incomeSlabList = resp.data.incomeSlabList;
              } else {
                _this.incomeSlabList = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              _this.incomeSlabList = null;
              // MessageService.error("Error in income slab list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'income-slab' }).$promise.then(success, error);
        }

        function getAddressType() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.addressType = resp.data.addressTypeResponses;
              } else {
                _this.addressType = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in address type list!");
            };
          InvestorService.post({ child1: 'folio', child2: 'address-type' }, null).$promise.then(success);
        }



        function autoDate() {
          var oldlength = 0 ;
          if(_this.dobString){
            oldlength = _this.dobString.length;
          }
          _this.dobString = $("#grossAnnualIncomeDateId").val();
          var newlength = _this.dobString.length;
          if( _this.dobString.length == 2){

            if((newlength== (oldlength - 1)) || (newlength == oldlength)){
            } else{
              $("#grossAnnualIncomeDateId").val(_this.dobString+"-");
            }
          }
          if( _this.dobString.length == 5){

            if((newlength== (oldlength - 1)) || (newlength == oldlength)){
            } else{
              $("#grossAnnualIncomeDateId").val(_this.dobString+"-");
            }
          }
        }


        function getPayload () {
          var success = function (resp) {
            if (resp.status && resp.data) {
              _this.currentPayload = resp.data;
              _this.currentFolio = resp.data;
              if(!_this.selectedFolioData) {
                var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
                _this.soleApplicantEmailCopy = resp.data.soleApplicantDetail.personalDetail.email;
                _this.soleApplicantMobileCopy = resp.data.soleApplicantDetail.personalDetail.mobileNo;
                _this.soleApplicantEmail = contactUpdateCo && contactUpdateCo.isEmailEdited ? contactUpdateCo.soleApplicantEditedEmail : resp.data.soleApplicantDetail.personalDetail.email;
                _this.soleApplicantMobile = contactUpdateCo && contactUpdateCo.isMobileEdited ? contactUpdateCo.soleApplicantEditedMobile : resp.data.soleApplicantDetail.personalDetail.mobileNo;
                _this.holders.emailBelongsTo = resp.data.soleApplicantDetail.personalDetail.emailBelongsTo || "SE";
                _this.holders.mobileBelongsTo = resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo || "SE";
                _this.updatedFieldType  = resp.data.soleApplicantDetail.personalDetail.updatedFieldType;

                var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
                if (isEditbuttonClick && $rootScope.folioBasicDetail.folioHoldingMode == "SINGLE") {
                  $rootScope.nextStep(0);
                  sessionStorage.removeItem("investorIsEditButtonClick");
                }

                if ($rootScope.folioBasicDetail) {
                  $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
                }
                _this.holdeMode = _this.currentFolio.holdmode;
                if (resp.data.soleApplicantDetail.personalDetail.taxStatusCode) {
                  $rootScope.showSaveTag = true;
                  $timeout(function () {
                    $rootScope.showSaveTag = false;
                  }, 3000);

                }

                _this.folioIncomeForm.occupation = resp.data.soleApplicantDetail.selfDetail.occupation || "2";
                if (_this.currentPayload && _this.currentPayload.soleApplicantDetail.selfDetail.grossAnnualIncome) {
                  _this.incomeActiveTab('ANNUAL_GROSS_INCOME');
                  _this.folioIncomeForm.annualincome = _this.currentPayload.soleApplicantDetail.selfDetail.grossAnnualIncome;
                } else if (_this.currentPayload && _this.currentPayload.soleApplicantDetail.selfDetail.netWorth) {
                  _this.incomeActiveTab('NET_WORTH');
                  _this.folioIncomeForm.networth = _this.currentPayload.soleApplicantDetail.selfDetail.netWorth;
                  _this.folioIncomeForm.grossAnnualIncomeDate = _this.currentPayload.soleApplicantDetail.selfDetail.netWorthDate;
                  netWorthChanges(_this.folioIncomeForm.networth);
                }
                _this.folioIncomeForm.Fatca.countrie = resp.data.soleApplicantDetail.selfDetail.fatca.birthCountry ? resp.data.soleApplicantDetail.selfDetail.fatca.birthCountry : "IN";
                _this.folioIncomeForm.Fatca.addressType = resp.data.soleApplicantDetail.selfDetail.fatca.addressType ? resp.data.soleApplicantDetail.selfDetail.fatca.addressType : "RESIDENTIAL";
                _this.folioIncomeForm.Fatca.city = resp.data.soleApplicantDetail.selfDetail.fatca.birthPlace;
                _this.folioIncomeForm.holderDetails = resp.data.jointHolders;
                _this.folioIncomeForm.nomineeDetails = resp.data.nominees;
                _this.folioIncomeForm.bankDetails = resp.data.bankDetails;
                _this.folioIncomeForm.nriFlag = resp.data.nriFlag;
                _this.folioIncomeForm.taxstatus = resp.data.soleApplicantDetail.personalDetail.taxStatusCode ? resp.data.soleApplicantDetail.personalDetail.taxStatusCode : "01";
                if (_this.folioIncomeForm.nriFlag && _this.folioIncomeForm.taxstatus === "01") {
                  _this.folioIncomeForm.taxstatus = null;
                }
                getTaxStatus();
              }
            }else{
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            MessageService.error(err);
          };
          var investorId = localStorage.getItem("folioId");
          NewInvestorServiceV3.post({child1: 'folio',child2: 'getDetails'},{id: investorId}).$promise.then(success, error);
        }


        function getGrossAnnualIncomeDate (date) {

          if (angular.isDefined(date._i) ||
            /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
            _this.folioIncomeForm.grossAnnualIncomeDate = moment(date).format("DD-MMM-YYYY");
            _this.dobmilisecond = moment(date).valueOf();
            _this.grossAnnualIncomeYear = (moment(new Date()).valueOf() - _this.dobmilisecond) / 31556952000;
            if (_this.grossAnnualIncomeYear < 1 || _this.grossAnnualIncomeYear == 1) {
            }
            else {
              _this.folioIncomeForm.grossAnnualIncomeDate = "";
              MessageService.error('Not older than 1 year');
            }
            if (!date) {
              _this.dateErrorMessage = _this.validateData.NET_WORTH_DATE;
            } else _this.dateErrorMessage = '';

          } else {
            _this.dateErrorMessage = _this.validateData.NET_WORTH_DATE;
            _this.folioIncomeForm.grossAnnualIncomeDate = "";
          }
          return;
        }

         function grossAnnualIncomeDate  (date) {
          if (angular.isDefined(date._i) ||
            /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
            _this.minorFormGuardianData.grossAnnualIncomeDate = moment(date).format("DD-MMM-YYYY");
            _this.dobmilisecond = moment(date).valueOf();
            _this.grossAnnualIncomeYear = (moment(new Date()).valueOf() - _this.dobmilisecond) / 31556952000;
            if (_this.grossAnnualIncomeYear < 1 || _this.grossAnnualIncomeYear == 1) {
              _this.notolderthan1year = false;
            }
            else {
              _this.minorFormGuardianData.grossAnnualIncomeDate = "";
              MessageService.error('Not older than 1 year');
              _this.notolderthan1year = true;
            }
            if (!date) {
              _this.dateErrorMessage = _this.validateData.GROSS_ANNUAL_INCOME;
            } else _this.dateErrorMessage = '';

          } else {
            _this.dateErrorMessage = _this.validateData.GROSS_ANNUAL_INCOME;
            _this.minorFormGuardianData.grossAnnualIncomeDate = "";
          }
          return;
        }

        function networthcall() {
          _this.networth = !_this.networth;
          if(_this.networth){
            _this.folioIncomeForm.annualincome = '';
          }else{
            _this.folioIncomeForm.networth = "";
            _this.folioIncomeForm.grossAnnualIncomeDate = "";
          }
        }

        function incomeActiveTab(activeTab){
         if(activeTab == _this.incomeTab[0]){
           _this.annualTab = true;
           _this.netWorthTab = false;
           _this.folioIncomeForm.networth = "";
           _this.folioIncomeForm.grossAnnualIncomeDate = "";
           _this.dateErrorMessage = "";
           _this.folioIncomeForm.networthComma = "";
         }else{
           _this.netWorthTab = true;
           _this.annualTab = false;
           _this.folioIncomeForm.annualincome = '';
         }

        }

        function incomeActiveTabForGuardian(activeTab){
          if(activeTab === _this.incomeTab[0]){
            _this.notolderthan1year = true;
            _this.annualTabForGuardian = true;
            _this.netWorthTabForGurdian = false;
          }else{

            _this.notolderthan1year = false;
            _this.netWorthTabForGurdian = true;
            _this.annualTabForGuardian = false;
          }

          _this.minorFormGuardianData.networth = '';
          _this.minorFormGuardianData.grossAnnualIncomeDate ='';
        }

        function getTaxFileStatusForGuardian(value) {
          if (value == 'Yes') {
            _this.minorFormGuardianData.fileTaxOtherIndian = 'Yes';
            _this.minorFormGuardianData.Fatca.taxPayIndian = false;
          } else {
            _this.minorFormGuardianData.fileTaxOtherIndian = 'No';
            _this.minorFormGuardianData.Fatca.taxPayIndian = true;
          }
        }

        function getProofType () {
          var success = function (resp) {
              _this.relationProofType = resp.data.proofTypeDTOList;
            },
            error = function () {
              MessageService.error("Error in proof type list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'proof', child3: 'type' }, null).$promise.then(success, error);
        }

        function getTaxIdType() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.taxIdType = resp.data.taxIdTypeResponses;
              } else {
                _this.taxIdType = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in tax id type list!");
            };
          InvestorService.post({ child1: 'folio', child2: 'taxId-type' }, null).$promise.then(success);
        }

        function getGuardianRelationProofImage (file) {
          if (_this.mimeType.indexOf(file.type) == -1) {
            MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
            return;
          }
          if (file.size < 2000000) {
            _this.minorFormGuardianData.guardianrelationproofimagename = file.name;
            var success = function (resp) {
              if (resp.status && resp.data) {
                _this.minorFormGuardianData.minorRelationshipProof = resp.data.fileUrl;
                _this.minorFormGuardianData.guardianrelationproofimageurl = resp.data.fileUrl;
                try{
                  const file = resp.data.fileUrl;
                  const fileName = file.split("/");
                  _this.minorFormGuardianData.guardianrelationproofimagename = fileName[fileName.length - 1];
                }catch(e){}
                localStorage.setItem('folioId', resp.data.uuid);
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (e) {
              MessageService.error("file not upload");
            };
            var fd = new FormData();
            fd.append('file', file);
            var uuid = '';
            if ($stateParams.investorId) {
              uuid = $stateParams.investorId;
            } else if (localStorage.getItem('folioId')) {
              uuid = localStorage.getItem('folioId');
            } else {
              uuid = 'null';
            }
            InvestorFileUploadServiceV3.post2({
              child1: 'folio',
              child2: 'upload',
              child3: 'minor',
              child4: 'relationshipProof',
              child5: '01b48aa2-6a3e-4446-a4a6-eefe5d29537a'
            }, fd).$promise.then(success, error);
          }
          else {
            MessageService.error("File size should not be more than 2 MB.")
          }
        }

        function submitMinorGuardianDetails() {
          _this.investorOccupations.forEach(function(occupations){
            if(occupations.occupationCode === _this.minorFormGuardianData.occupation){
              _this.occupation = occupations.occupationDescription;
            }
          });
          _this.countryName = _this.countries.find(function (country) {
            return country.countryCode === _this.minorFormGuardianData.Fatca.Countrie;
          }) || {};
          _this.taxPayingCountry = _this.countries.find(function (country) {
            return country.countryCode === _this.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry;
          }) || {};


          _this.incomeSlabList.forEach(function(income){
            if(income.incomeCode === parseInt(_this.minorFormGuardianData.grossAnnualIncome)){
              _this.grossAnnualincomeGuardian = income.incomeDescription;
            }
          });
          _this.taxIdType.forEach(function (taxId,index) {
            if( taxId.value === _this.minorFormGuardianData.Fatca.taxPay1.taxIdType){
              _this.taxIdTypeName = taxId.description;
            }
          });

          _this.addressType.forEach(function(addressType){

          });
          _this.editGuardianDetail = false;
          _this.payloadData.FOLIO_CREATION_STEP.guardian_details_completed = true;

          InvestmentModel.setPayload(_this.payloadData);

          // for showing edit button
          _this.stepperUpdatedInfo();
        }

        function submitFolioIncomeForm() {

          _this.taxStatusData.forEach(function (taxStatus,index) {
            if( taxStatus.taxStatusCode === _this.folioIncomeForm.taxstatus){
              _this.taxStatusName = taxStatus.taxStatusDescription;
            }
          });
          _this.investorOccupations.forEach(function(occupations){
            if(occupations.occupationCode === _this.folioIncomeForm.occupation){
              _this.occupation = occupations.occupationDescription;
            }
          });

          _this.incomeSlabList.forEach(function(income){
            if(income.incomeCode == _this.folioIncomeForm.annualincome){
              _this.grossAnnualincome = income.incomeDescription;
            }
          });

          _this.countryName = _this.countries.find(function (country) {
            return country.countryCode === _this.folioIncomeForm.Fatca.countrie;
          }) || {};

          _this.belongToListEmail.forEach(function(emailBelongTo){
            if(emailBelongTo.familyCode === _this.holders.emailBelongsTo){
              _this.belongToEmail = emailBelongTo.familyDescription;
            }
          });
          _this.belongToListMobile.forEach(function(mobileBelongTo){
            if(mobileBelongTo.familyCode === _this.holders.mobileBelongsTo){
              _this.belongToMobile = mobileBelongTo.familyDescription;
            }
          });

          continueToInitiate();
        }

        _this.formIsvalid = function () {
          _this.$emit('buttonEnable')
        };

        _this.formIsinvalid = function () {
          _this.$emit('buttonDisable')
        };

        function continueToInitiate() {
          _this.payloadData = InvestmentModel.getPayload();
          LoaderService.showLoader();
          var success = function (resp) {
            LoaderService.hideLoader();
            if(resp.status && resp.data) {
              _this.editIncomeDetail = false;
              _this.payloadData.FOLIO_CREATION_STEP.income_details_completed = true;
              InvestmentModel.setPayload(_this.payloadData);
              // for showing edit button
              _this.stepperUpdatedInfo();
              _this.proceedAction();
              MessageService.success('Saved Successfully.');
            } else {
              MessageService.error(error.message);
            }
          },
          error = function (error) {
            MessageService.error(error.message);
            LoaderService.hideLoader();
          };

          var payload = {
            soleApplicantDetail: {
              selfDetail: {
                panNumber: _this.token.investorPAN,
                occupation: _this.folioIncomeForm.occupation,
                politicalStatus: _this.currentFolio.soleApplicantDetail.selfDetail.politicalStatus,
                fatca: {
                  birthCountry: _this.folioIncomeForm.Fatca.countrie,
                  birthPlace: _this.folioIncomeForm.Fatca.city,
                  addressType: _this.folioIncomeForm.Fatca.addressType,
                  payTaxInIndia : _this.currentFolio.soleApplicantDetail.selfDetail.fatca.payTaxInIndia
                }
              },
              personalDetail: {
                taxStatusCode: _this.folioIncomeForm.taxstatus,
                kycEmail:_this.soleApplicantEmail,
                kycMobileNo:_this.soleApplicantMobile,
                emailBelongsTo:_this.holders.emailBelongsTo,
                mobileBelongsTo:_this.holders.mobileBelongsTo
              }
            },
            jointHolders: _this.folioIncomeForm.holderDetails,
            nominees: _this.folioIncomeForm.nomineeDetails,
            bankDetails : _this.folioIncomeForm.bankDetails,
            holdmode: _this.currentFolio.holdmode,
            id: localStorage.getItem("folioId"),
            folioSaveStep: "TWO"
          };
          payload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = {};
          if(_this.currentFolio.soleApplicantDetail.selfDetail.fatca.fatcaTax1){
            payload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = _this.currentFolio.soleApplicantDetail.selfDetail.fatca.fatcaTax1;
          }

          if (_this.netWorthTab) {
            payload.soleApplicantDetail.selfDetail.grossAnnualIncome = "";
            payload.soleApplicantDetail.selfDetail.netWorth = _this.folioIncomeForm.networth;
            if (_this.folioIncomeForm.grossAnnualIncomeDate.match(/[a-zA-Z]/i)) {
              payload.soleApplicantDetail.selfDetail.netWorthDate = _this.folioIncomeForm.grossAnnualIncomeDate;
            } else {
              if (_this.folioIncomeForm.grossAnnualIncomeDate) {
                payload.soleApplicantDetail.selfDetail.netWorthDate = _this.datetwoTothree(_this.folioIncomeForm.grossAnnualIncomeDate);
              }
            }
          } else {
            payload.soleApplicantDetail.selfDetail.grossAnnualIncome = _this.folioIncomeForm.annualincome;
            payload.soleApplicantDetail.selfDetail.netWorth = '';
            payload.soleApplicantDetail.selfDetail.netWorthDate = "";
          }
          if(scope.journey === 'ECART') {
            payload.ignoreDraftFolio = true;
            payload.newFolioCreationFlow = true;
            payload.cartFlow = true;
          }
          payload.investmentBasketId = sessionStorage.getItem('journeyDraftId');
          payload.singlePage = true;
          payload.nriFlag = _this.folioIncomeForm.nriFlag;
          sessionStorage.setItem("incomeDetails", JSON.stringify(_this.folioIncomeForm));
          if (_this.isContactDetailUpdated && payload.soleApplicantDetail && payload.soleApplicantDetail.personalDetail)  {
            payload.soleApplicantDetail.personalDetail.email = _this.soleApplicantEmailCopy;
            payload.soleApplicantDetail.personalDetail.mobileNo = _this.soleApplicantMobileCopy;
            payload.soleApplicantDetail.personalDetail.isContactUpdated = _this.isContactDetailUpdated;
          } else {
            payload.soleApplicantDetail.personalDetail.email = _this.soleApplicantEmailCopy;
            payload.soleApplicantDetail.personalDetail.mobileNo = _this.soleApplicantMobileCopy;
          }
          if (!_this.firstFlow) {
            payload.firstFolio = false;
            payload.newUserFlow = false;
            InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);
          } else {
            payload.firstFolio = true;
            payload.newUserFlow = true;
            NewInvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);
          }
        }

        _this.datetwoTothree = function(date) {
          var dateChar = date.split("-");
          switch(dateChar[1]){
            case "01":
              _this.cdate = dateChar[0]+"-Jan-"+dateChar[2];
              return _this.cdate;
              break;
            case "02":
              _this.cdate = dateChar[0]+"-Feb-"+dateChar[2];
              return _this.cdate;
              break;
            case "03":
              _this.cdate = dateChar[0]+"-Mar-"+dateChar[2];
              return _this.cdate;
              break;
            case "04":
              _this.cdate = dateChar[0]+"-Apr-"+dateChar[2];
              return _this.cdate;
              break;
            case "05":
              _this.cdate = dateChar[0]+"-May-"+dateChar[2];
              return _this.cdate;
              break;
            case "06":
              _this.cdate = dateChar[0]+"-Jun-"+dateChar[2];
              return _this.cdate;
              break;
            case "07":
              _this.cdate = dateChar[0]+"-Jul-"+dateChar[2];
              return _this.cdate;
              break;
            case "08":
              _this.cdate = dateChar[0]+"-Aug-"+dateChar[2];
              return _this.cdate;
              break;
            case "09":
              _this.cdate = dateChar[0]+"-Sep-"+dateChar[2];
              return _this.cdate;
              break;
            case "10":
              _this.cdate = dateChar[0]+"-Oct-"+dateChar[2];
              return _this.cdate;
              break;
            case "11":
              _this.cdate = dateChar[0]+"-Nov-"+dateChar[2];
              return _this.cdate;
              break;
            case "12":
              _this.cdate = dateChar[0]+"-Dec-"+dateChar[2];
              return _this.cdate;
              break;
            default:
              return "wrong date.";
          }
        }

        _this.datethreeToTwo = function(date) {
          var dateChar = date.split("-");
          switch(dateChar[1]){
            case "Jan":
              _this.cdate = dateChar[0]+"-01-"+dateChar[2];
              return _this.cdate;
              break;
            case "Feb":
              _this.cdate = dateChar[0]+"-02-"+dateChar[2];
              return _this.cdate;
              break;
            case "Mar":
              _this.cdate = dateChar[0]+"-03-"+dateChar[2];
              return _this.cdate;
              break;
            case "Apr":
              _this.cdate = dateChar[0]+"-04-"+dateChar[2];
              return _this.cdate;
              break;
            case "May":
              _this.cdate = dateChar[0]+"-05-"+dateChar[2];
              return _this.cdate;
              break;
            case "Jun":
              _this.cdate = dateChar[0]+"-06-"+dateChar[2];
              return _this.cdate;
              break;
            case "Jul":
              _this.cdate = dateChar[0]+"-07-"+dateChar[2];
              return _this.cdate;
              break;
            case "Aug":
              _this.cdate = dateChar[0]+"-08-"+dateChar[2];
              return _this.cdate;
              break;
            case "Sep":
              _this.cdate = dateChar[0]+"-09-"+dateChar[2];
              return _this.cdate;
              break;
            case "Oct":
              _this.cdate = dateChar[0]+"-10-"+dateChar[2];
              return _this.cdate;
              break;
            case "Nov":
              _this.cdate = dateChar[0]+"-11-"+dateChar[2];
              return _this.cdate;
              break;
            case "Dec":
              _this.cdate = dateChar[0]+"-12-"+dateChar[2];
              return _this.cdate;
              break;
            default:
              return "wrong date.";
          }
        }

        function netWorthChanges(value){
          if(value) {
            _this.folioIncomeForm.networthComma = (parseInt(value.toString().replaceAll(",", "")) || '').toLocaleString('en-IN');
            _this.folioIncomeForm.networth = parseInt(_this.folioIncomeForm.networthComma.toString().replaceAll(",", "") || '');
          }else{
            _this.folioIncomeForm.networth = '';
          }
        }

        _this.taxStatusChanged = function () {
          _this.$emit('taxStatusChanged')
        }

        function editContactDetails(contactInfo) {
          var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
          if (contactUpdateCo) {
            _this.isMobileEdited = contactUpdateCo.isMobileEdited;
            _this.isEmailEdited = contactUpdateCo.isEmailEdited;
          }
          if (contactInfo === "email") {
            if (_this.isMobileEdited) {
              MessageService.error("You can edit only one contact information at a time.");
              return;
            }
            _this.showEmailEditField = true;
            _this.showMobileEditField = false;
            if (_this.soleApplicantEmail) {
              _this.soleApplicantEditedEmail = _this.soleApplicantEmail;
            }
          } else if (contactInfo === 'mobile') {
            if (_this.isEmailEdited) {
              MessageService.error("You can edit only one contact information at a time.");
              return;
            }
            _this.showMobileEditField = true;
            _this.showEmailEditField = false;
            if (_this.soleApplicantMobile) {
              _this.soleApplicantEditedMobile = _this.soleApplicantMobile;
            }
          }
        }

        function cancelEditAction(contactInfo) {
          if (contactInfo === "email") {
            _this.showEmailEditField = false;
          } else if (contactInfo === 'mobile') {
            _this.showMobileEditField = false;
          }
        }

        function generateContactUpdateOtp(contactInfo) {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              showOtpModal(resp.data, contactInfo);
            } else {
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            MessageService.error(err);
            LoaderService.hideLoader();
          };
          var payload = {
            value: contactInfo === "email" ? _this.soleApplicantEditedEmail : _this.soleApplicantEditedMobile,
            fieldType: contactInfo.toUpperCase(),
            linkId: localStorage.getItem("folioId"),
            flowName : "STANDALONE_FOLIO_CREATION"
          };
          InvestorServiceV2.post({
            child1: 'contact',
            child2: 'update',
            child3: 'send',
            child4: 'otp'
          }, payload).$promise.then(success, error);
        }

        function showOtpModal(modalPayload, contactInfo) {
          var confirmSuccess = function () {
            _this.isContactDetailUpdated = true;
            if (contactInfo === "email") {
              _this.isEmailEdited = true;
              _this.showEmailEditField = false;
              _this.soleApplicantEmail = _this.soleApplicantEditedEmail;
            }
            if (contactInfo === "mobile") {
              _this.isMobileEdited = true;
              _this.showMobileEditField = false;
              _this.soleApplicantMobile = _this.soleApplicantEditedMobile;
            }
            sessionStorage.setItem('contactUpdateCo', JSON.stringify({
              isEmailEdited: _this.isEmailEdited,
              isMobileEdited: _this.isMobileEdited,
              soleApplicantEditedEmail: _this.soleApplicantEditedEmail,
              soleApplicantEditedMobile: _this.soleApplicantEditedMobile,
              isContactDetailUpdated: _this.isContactDetailUpdated
            }));
          }, confirmError = function () {
            _this.isContactDetailUpdated = false;
            _this.isEmailEdited = false;
            _this.isMobileEdited = false;
          };
          ModalService.contactOtpModal(modalPayload, confirmSuccess, confirmError);
        }

        function changeValue(contactInfo, val) {
          if (contactInfo === "email") {
            _this.soleApplicantEditedEmail = val;
          } else if (contactInfo === 'mobile') {
            _this.soleApplicantEditedMobile = val;
          }
        }

      }
    }
  }



})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('holderDirective', holderDirective);

  /*@ngInject*/
  function holderDirective($timeout, $state, LoaderService, UtilService, MessageService, InvestmentBasketService ,  AppConstants , AuthService , InvestorService , $window , InvestorFolioModel , $stateParams , InvestorServiceV3 , ModalService , $rootScope , InvestmentModel , NewInvestorServiceV3) {
    return {
      restrict: 'E',
      scope : {
        firstFlow:'=',
        stepperUpdatedInfo : '&',
        proceedAction : '&',
        selectedFolioData: '=',
        journey: '=',
        fromPreLogin: '='
      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/folio/holders/holders.html',
      link: function (scope) {
        var vm = scope;
        vm.formData = {};
        vm.continue = continueModal;
        vm.verifyPAN = verifyPAN;
        vm.wrongMsg = '';
        vm.panVerify = false;
        vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        var panDetails = {};
        vm.stopaddholder = true;
        vm.holderData = {};
        vm.holderData.pan = '';
        vm.holderData.HolderName ='';
        vm.holderData.email = '';
        vm.AllowedJointHolder = true;
        vm.emailMsg = '';
        vm.jointHoldersPayload = angular.fromJson($window.sessionStorage.investorForm) || InvestorFolioModel.getInvestorFolioFormDataModel();

        var token = AuthService.getToken();

        // vm.formData = angular.fromJson($window.sessionStorage.investorForm) || InvestorFolioModel.getInvestorFolioFormDataModel();

        vm.formData.jointHolders = [];

        vm.MainFolioParent = {};

        vm.MainFolioParent.holdmode = vm.formData.holdmode;

        vm.hideVerifyPanField = false;
        vm.showEmail = false;
        vm.allowJointHolder = true;
        vm.showOtp = false;
        vm.pattern = AppConstants;
        vm.emailDetails = {};
        vm.addEmailToHolderPan = addEmailToHolderPan;
        vm.verifyOtp = verifyOtp;
        vm.reGenerateOtp = reGenerateOtp;
        vm.netWorthChanges = netWorthChanges;

        //------------------------//

        vm.defaultsoleApplicantNWDate = $window.moment().toString();
        vm.NumToWord = $window.NumToWord;
        vm.countryList = [];
        vm.occupationList = [];
        vm.incomeSlabList = [];
        vm.taxStatusList = [];
        vm.taxIdTypeList = [];
        vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
        vm.pattern = AppConstants;
        vm.POLITICAL_STATUS = AppConstants.INVESTOR_POLITICAL_STATUS;
        vm.currentJointHolder = {};
        vm.currentJointHolder.index = 0;
        vm.defaultDob = $window.moment().toString();
        vm.fileTaxActionJointHolder = fileTaxActionJointHolder;
        vm.addMoreJointHolder = addMoreJointHolder;
        vm.deleteCurrentJointHolder = deleteCurrentJointHolder;
        // vm.uploadMinorDobFile = uploadMinorDobFile;
        // vm.uploadMinorRelationshipFile = uploadMinorRelationshipFile;
        // vm.changeTaxStatus = changeTaxStatus;
        vm.saveFolio = saveFolio;
        vm.continueFolio = continueFolio;
        vm.folioSelectionData = folioSelectionData;
        vm.isSoleApplicantMinor = false;
        vm.fatcaArray = [];
        // vm.minorAgeProof = null;
        vm.minDate = moment().subtract(1, 'years').format("DD-MMM-YYYY").toString();
        vm.enum = {
          0: 'First',
          1: 'Second',
          2: 'Third',
          3: 'Fourth',
          4: 'Fifth'
        };
        vm.notValid2ndHolder=false;
        vm.back = back;
        vm.initHolders = initHolders;
        vm.editHolder = true;
        vm.payloadData = InvestmentModel.getPayload();
        vm.prevDataSecondHolder = null;
        vm.init = init;
        vm.changeEnteredEmail = changeEnteredEmail;
        vm.appConstants = AppConstants;
        vm.formData.taxStatusResident = false;
        vm.getTaxStatusList = getTaxStatusList;
        vm.KYC_STATUS = AppConstants.KYC_STATUS;

        $rootScope.$emit('buttonDisable');


        // listening to edit button click

        var listner = vm.$on("enableEditHolder", function() {
          vm.editHolder = true;
          if(vm.selectedFolioData && vm.selectedFolioData.jointHolders) {
            vm.selectedFolioData = angular.copy(angular.toJson(vm.jointHoldersPayload));
          }
          getPayload();
          vm.payloadData = InvestmentModel.getPayload();
        });

        // var listner = vm.$on("continueButtonHolder", function() {
        //   vm.continue();
        // });

        init();
        function init() {
          if (localStorage.getItem('folioId')) {
            // initHolders();
            getPayload();
          }

          // fetching dynamic data for tax status dropdown field

          var successHandler = function(resp) {
            if(resp && resp.noteDTO && resp.noteDTO.noteDTOMap && resp.noteDTO.noteDTOMap.Note_Tax_Status_Info) {
              vm.taxStatusNote = resp.noteDTO.noteDTOMap.Note_Tax_Status_Info.content;
            } else {
              vm.taxStatusNote = "";
            }
          };

          UtilService.fetchDynamicData('FOLIO_CREATION').then(successHandler).catch(function(resp) {
            MessageService.error(resp);
          });

        };
        folioSelectionData();
        function folioSelectionData(){
          if(vm.selectedFolioData && vm.selectedFolioData.jointHolders){
            for(var i = 0; i < vm.selectedFolioData.jointHolders.length; i++) {
              vm.selectedFolioData.jointHolders[i].taxStatusCode = "01";
              vm.selectedFolioData.jointHolders[i].fatcaDetail.addressType = "";
            }
            vm.jointHoldersPayload = angular.copy(vm.selectedFolioData);
            vm.hideVerifyPanField = true;
            for(var i = 0; i < vm.selectedFolioData.jointHolders.length; i++) {
              vm.netWorthChanges(vm.selectedFolioData.jointHolders[i].netWorth, i);
              vm.selectedFolioData.jointHolders[i].taxStatusCode = "01";
            }
            $window.sessionStorage.investorForm = angular.copy(angular.toJson(vm.jointHoldersPayload));
            dataSanitize();
            vm.jointHoldersPayload.jointHolders.forEach(function(el, index) {
              getTaxStatusList(el.nriFlag,index,function() {
                if (index ===  vm.jointHoldersPayload.jointHolders.length - 1) {
                  getInvestorOccupationList();
                  incomeSlab();
                  getCountryList();
                  getTaxIdTypeList();
                  getAddressType();
                  checkValid2ndHolder(vm.jointHoldersPayload.jointHolders);
                }
              });
            })
          }
        }

        function initHolders() {
          dataSanitize();
          // getTaxStatusList();
          getInvestorOccupationList();
          incomeSlab();
          getCountryList();
          getTaxIdTypeList();
          getAddressType();
          checkValid2ndHolder(vm.jointHoldersPayload.jointHolders);
        }


        vm.addNewResidencyFields = function () {

          vm.fatcaArray.push(
            {
              "countryName": '',
              "birthCity": '',
              "taxIdType": '',
              "taxIdNumber": ''
            });
        };

        vm.addAvailableResidency = function (fatca) {
          if (fatca.fatcaTax1) {
            vm.fatcaArray.push(fatca.fatcaTax1);
          }
          if (fatca.fatcaTax2) {
            vm.fatcaArray.push(fatca.fatcaTax2);
          }
          if (fatca.fatcaTax3) {
            vm.fatcaArray.push(fatca.fatcaTax3);
          }
        };

        vm.setSelectedResidency = function (payload) {
          if (payload.guardianDetail && !payload.guardianDetail.fatca) {
            payload.guardianDetail.fatca = {};
          }
          var fatca = payload.guardianDetail.fatca;

          delete fatca.fatcaTax1;
          delete fatca.fatcaTax2;
          delete fatca.fatcaTax3;

          if (payload.guardianDetail.payTaxInIndia) {
            return;
          }

          if (vm.fatcaArray[0]) {
            fatca.fatcaTax1 = vm.fatcaArray[0];
          }

          if (vm.fatcaArray[1]) {
            fatca.fatcaTax2 = vm.fatcaArray[1];
          }

          if (vm.fatcaArray[2]) {
            fatca.fatcaTax3 = vm.fatcaArray[2];
          }

        }

        vm.deleteTaxResidencyFromFatca = function (index) {
          vm.fatcaArray.splice(index, 1);
        }

        function dataSanitize() {
          angular.forEach(vm.jointHoldersPayload.jointHolders, function (holder) {
            if(holder && (angular.isUndefined(holder.fatcaDetail)||angular.isUndefined(holder.fatcaDetail.payTaxInIndia))){
              holder.fatcaDetail = holder.fatcaDetail || {};
              holder.fatcaDetail.payTaxInIndia = true;
            }
            if(holder.fatcaDetail.fatcaTax2 && holder.fatcaDetail.fatcaTax2.taxPayingCountry !== ''){
              holder.fatcaDetail.secondTax = holder.fatcaDetail.fatcaTax2 ? true : false;
            }
            if(holder.fatcaDetail.fatcaTax3 && holder.fatcaDetail.fatcaTax3.taxPayingCountry !== ''){
              holder.fatcaDetail.thirdTax = holder.fatcaDetail.fatcaTax3 ? true : false;
            }
          });

        }

        function getTaxStatusList(taxStatusResident, index, cb) {
          cb = cb || function () {};
          if (vm.jointHoldersPayload && vm.jointHoldersPayload.minor) {
            var data = {taxStatusFilter: 'MINOR', 'nriFlag' : angular.copy(taxStatusResident)};
          } else {
            data = {taxStatusFilter: 'ADULT' , 'nriFlag' : angular.copy(taxStatusResident)};
          }

          var success = function (resp) {
            if (resp.status && resp.data) {
              vm.taxStatusList[index] = resp.data.taxStatus;
              if (vm.taxStatusList[index].length && vm.taxStatusList[index].length < 2) {
                vm.jointHoldersPayload.taxStatusCode = vm.taxStatusList[index][0].taxStatusCode;
                vm.changedTaxStatus(index);
              }
              cb(true);
            } else {
              vm.taxStatusList[index] = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            vm.taxStatusList[index] = null;
          };
          InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
        }

        function getInvestorOccupationList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              vm.occupationList = resp.data.investorOccupations;
            } else {
              vm.occupationList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            vm.occupationList = null;
          };
          InvestorService.get({child1: 'folio', child2: 'occupation'}).$promise.then(success, error);
        }

        function incomeSlab() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                vm.incomeSlabList = resp.data.incomeSlabList;
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
            };
          InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success, error);
        }


        vm.changeDob = function (date) {

          if (!date) {
            return;
          }
          // vm.defaultDob = date.toString();
          vm.jointHoldersPayload.minorDob = date.clone().format('DD-MMM-YYYY').toString();
        };

        vm.changeStartDate = function (date) {
          if (!date) {
            return;
          }
          vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
          // vm.formData.netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
        }

        function getCountryList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              vm.countryList = resp.data.countries;
            } else {
              vm.countryList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            vm.countryList = null;
          };
          InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
        }

        function getTaxIdTypeList() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              vm.taxIdTypeList = resp.data.taxIdTypeResponses;
            } else {
              vm.taxIdTypeList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            vm.taxIdTypeList = null;
          };
          InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success, error);
        }

        function getAddressType() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              vm.addressTypeList = resp.data.addressTypeResponses;
              if (vm.addressTypeList.length > 0 && !vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].fatcaDetail.addressType) {
                vm.addressTypeList.map(function(addressTypeResponses) {
                  if (addressTypeResponses.value === 'RESIDENTIAL') {
                    vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].fatcaDetail.addressType = addressTypeResponses.value;
                  }
                });
              }
            } else {
              vm.addressTypeList = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            vm.addressTypeList = null;
          };
          InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success, error);
        }

        function fileTaxActionJointHolder(index) {
          if (!vm.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia) {
            vm.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax1 = {"taxPayingCountry": "", "taxId": "", "taxIdType": ""};
            vm.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax2 = {"taxPayingCountry": "", "taxId": "", "taxIdType": ""};
            vm.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax3 = {"taxPayingCountry": "", "taxId": "", "taxIdType": ""};
          } else {
            vm.jointHoldersPayload.jointHolders[index].fatcaDetail && (delete vm.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax1);
            vm.jointHoldersPayload.jointHolders[index].fatcaDetail && (delete vm.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax2);
            vm.jointHoldersPayload.jointHolders[index].fatcaDetail && (delete vm.jointHoldersPayload.jointHolders[index].fatcaDetail.fatcaTax3);
          }

        }

        function addMoreJointHolder() {
          var array = vm.jointHoldersPayload.jointHolders || [];
          if (vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].jointHolderName || vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].firstName) {
            if (array.length < 2) {
              var blankObj = InvestorFolioModel.getNewJointHolder();
              array.push(blankObj);
              InvestorFolioModel.setInvestorFolioModel(vm.jointHoldersPayload);
              $window.sessionStorage.investorForm = angular.copy(angular.toJson(vm.jointHoldersPayload));
            } else {
              array.length = 0;
            }
            vm.currentJointHolder.index++;
            pan4JointHolders();
          }
          else {
            //angular.element('#nomineeName-'+vm.parentIndex).focus();
            //MessageService.error("please enter joint holder name");
          }
        }

        function deleteCurrentJointHolder(parentIndex) {

          var success = function () {
            var model = vm.jointHoldersPayload.jointHolders || [];
            model.splice(parentIndex, 1);

            // updating tax status
            vm.taxStatusList.splice(parentIndex, 1);

            vm.currentJointHolder.index = 0;
            if (model.length == 0) {
              vm.jointHoldersPayload.jointHolders = [];
              // InvestorModel.setTab({tab3: false, tabJointHolderAddable: false});
              InvestorFolioModel.setInvestorFolioModel(vm.jointHoldersPayload);
              $window.sessionStorage.investorForm = angular.copy(angular.toJson(vm.jointHoldersPayload));
              vm.formData.pan = null;
              vm.formData.taxStatusResident = false;
              vm.hideVerifyPanField = false;
            } else {
              vm.formData.taxStatusResident = angular.copy(model[0].nriFlag);
            }
            checkValid2ndHolder(model);
          };
          ModalService.confirmCancelModal({Text: 'Do you want to delete ' + vm.enum[parentIndex + 1] + ' Holder?', isBasketJourney: true}, success);
        }

        function pan4JointHolders() {
          var addFlag = true;
          var successPanDetails = function (result) {
              if (!angular.isString(result) && (result.status && result.data && result.data.kycverified)) {

                if (vm.jointHoldersPayload.soleApplicantDetail.selfDetail.panNumber != result.data.pan && vm.jointHoldersPayload.jointHolders[0].pan != result.data.pan) {
                  angular.forEach(vm.jointHoldersPayload.jointHolders, function (val) {
                    if (val.panNumber == result.data.pan) {
                      MessageService.error("Valid PAN details required to add joint holder");
                      addFlag = false;
                      vm.jointHoldersPayload.jointHolders.splice(vm.currentJointHolder.index, 1);
                      --vm.currentJointHolder.index;
                    }
                  });
                  if (addFlag) {
                    var newModel = InvestorFolioModel.getNewJointHolder();
                    vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index] = newModel;
                    vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].jointHolderName = result.data.name;
                    vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].firstName = result.data.name;
                    vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].pan = result.data.pan;
                    vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].email = result.data.email;
                    vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].mobileNumber = result.data.mobileNumber;
                    // setting nri flag for holder
                    vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].nriFlag = angular.copy(result.data.nriFlag);
                    // if tax status is same setting same listing for tax status else calling api
                    if (result.data.nriFlag === vm.formData.taxStatusResident) {
                      vm.taxStatusList[vm.currentJointHolder.index] = angular.copy(vm.taxStatusList[0]);
                      if (result.data.nriFlag === false) {
                        vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].taxStatusCode = "01";
                      }
                      setInvestorForm();
                    } else {
                      getTaxStatusList(result.data.nriFlag, vm.currentJointHolder.index , function() {
                        if (result.data.nriFlag === false) {
                          vm.jointHoldersPayload.jointHolders[vm.currentJointHolder.index].taxStatusCode = "01";
                        }
                        setInvestorForm();
                      });
                    }
                  }

                } else {
                  vm.jointHoldersPayload.jointHolders.splice(vm.currentJointHolder.index, 1);
                  --vm.currentJointHolder.index;
                  setInvestorForm();
                  MessageService.error("You have already added a Joint Holder using this PAN.");
                }
              } else if (angular.isString(result) && result === "warning") {
                errorPanDetails();
              } else {
                MessageService.error(result.message || 'Kyc verification is pending.');
              }
            },
            errorPanDetails = function () {
              vm.jointHoldersPayload.jointHolders.splice(vm.currentJointHolder.index, 1);
              --vm.currentJointHolder.index;
              setInvestorForm();
            };
          var labelSetter = {
            type: 'jointholders',
            label: {header: 'ADD JOINT HOLDER',
            pan: 'PAN', dob: 'Joint Holder DOB'},
            isBasketJourney: true,
            nriFlag: false
          };
          ModalService.checkPan4Holder(labelSetter, successPanDetails, errorPanDetails);
        }

        /*function submitJointHolder() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              MessageService.success(resp.data.message);
              vm.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia = true;

              InvestorFolioModel.setInvestorModel(vm.jointHoldersPayload);
              $state.go('main.folio.bankdetails');
            } else {
              vm.jointHoldersPayload.soleApplicantDetail = null;
              MessageService.error(resp.message);
            }
          }, error = function () {
            // vm.formData.soleApplicantDetail = null;
          };
          // InvestorService.post({child1: 'folio', child2: 'createNewFolio'}, null).$promise.then(success, error);
          InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);

        }*/

        function saveFolio(stateToMove) {
          LoaderService.showLoader();
          sanitize4Facta();
          var payload = vm.jointHoldersPayload;
          if (payload) {
            payload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
            payload.folioSaveStep = "THREE";
          }
          var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              localStorage.setItem('folioId', resp.data.id);
              InvestorFolioModel.setInvestorFolioModel(resp.data);
              $window.sessionStorage.investorForm = angular.copy(angular.toJson(vm.jointHoldersPayload));
              if (stateToMove) {
                if ($stateParams.investorId) {
                  $state.go(stateToMove, {investorId: $stateParams.investorId});
                } else {
                  $state.go(stateToMove);
                }
              }else {
                MessageService.success('Saved Successfully.');
                $state.go('welcome');
              }
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          // InvestorService.post({child1: 'folio', child2: 'saveFolio'}, payload).$promise.then(success, error);
          InvestorServiceV3.post({child1: 'folio', child2: 'save'}, payload).$promise.then(success, error);

        }
        function continueFolio(stateToMove) {
          LoaderService.showLoader();
          sanitize4Facta();
          var payload = vm.savedFolioData || vm.jointHoldersPayload;
          payload.jointHolders = vm.jointHoldersPayload.jointHolders;
          if (!payload.holdmode) {
            payload.holdmode = 'ANY_OR_SURVIVOR'
          }
          if (payload) {
            payload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
            payload.folioSaveStep = "THREE";
          }
          payload.investmentBasketId = sessionStorage.getItem('journeyDraftId');
          if (payload.jointHolders ) {

            for (var i = 0 ; i < payload.jointHolders.length ; i ++) {

              if (payload.jointHolders[i].grossAnnualIncome) {
                if (payload.jointHolders[i].netWorth) {
                  delete payload.jointHolders[i].netWorth
                }

                if (payload.jointHolders[i].netWorthDate) {
                  delete payload.jointHolders[i].netWorthDate;
                }
              }
            }
          }
          var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              localStorage.setItem('folioId', resp.data.id);
              InvestorFolioModel.setInvestorFolioModel(resp.data);
              $window.sessionStorage.investorForm = angular.copy(angular.toJson(vm.jointHoldersPayload));
              vm.editHolder = false;

              vm.payloadData.FOLIO_CREATION_STEP.holder_details_completed = true;

              InvestmentModel.setPayload(scope.payloadData);

              // for showing edit button
              vm.stepperUpdatedInfo();
              vm.proceedAction();
              MessageService.success('Saved Successfully.');
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          for(var i=0; i< payload.jointHolders.length; i++) {
            delete payload.jointHolders[i].netWorthComma;
          }
          if(scope.journey === 'ECART') {
            payload.ignoreDraftFolio = true;
            payload.newFolioCreationFlow = true;
            payload.cartFlow = true;
          }
          payload.folioSaveStep = "THREE";
          payload.singlePage = true;
          if (!vm.firstFlow) {
            payload.firstFolio = false;
            payload.newUserFlow = false;
            InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);
          } else {
            payload.firstFolio = true;
            payload.newUserFlow = true;
            NewInvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);
          }
        }

        function sanitize4Facta(){
          angular.forEach(vm.jointHoldersPayload.jointHolders, function (holder) {
            angular.forEach([1,2,3],function (val) {

              if(holder.fatcaDetail['fatcaTax'+val]
                && ((angular.isUndefined(holder.fatcaDetail['fatcaTax'+val].taxPayingCountry) || holder.fatcaDetail['fatcaTax'+val].taxPayingCountry == '')
                  || angular.isUndefined(holder.fatcaDetail['fatcaTax'+val].taxIdType))){
                delete holder.fatcaDetail['fatcaTax'+val];
              }


            });
            /*if(holder.fatcaDetail.fatcaTax1 && (angular.isUndefined(holder.fatcaDetail.fatcaTax1.taxPayingCountry) || angular.isUndefined(holder.fatcaDetail.fatcaTax1.taxIdType))){
              delete holder.fatcaDetail.fatcaTax1;
            }if(holder.fatcaDetail.fatcaTax2 && (angular.isUndefined(holder.fatcaDetail.fatcaTax2.taxPayingCountry) || angular.isUndefined(holder.fatcaDetail.fatcaTax2.taxIdType))){
              delete holder.fatcaDetail.fatcaTax2;
            }if(holder.fatcaDetail.fatcaTax3 && (angular.isUndefined(holder.fatcaDetail.fatcaTax3.taxPayingCountry) || angular.isUndefined(holder.fatcaDetail.fatcaTax3.taxIdType))){
              delete holder.fatcaDetail.fatcaTax3;
            }*/
            holder.fatcaDetail.secondTax = holder.fatcaDetail.secondTax ? holder.fatcaDetail.secondTax : false;
            holder.fatcaDetail.thirdTax = holder.fatcaDetail.thirdTax ? holder.fatcaDetail.thirdTax : false;
          });
        }

        function back() {
          if(vm.firstFlow === 'YES'){
            $state.go('folioDetails.folioCreation',{investorId:$stateParams.investorId});
          }else{
            $state.go('main.folio.soleApplicant',{investorId:$stateParams.investorId});
          }
        }

        //
        // function changeTaxStatus(index, type){
        //
        //   if(type === '21' || type === '24') {
        //     vm.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia = false;
        //     // vm.changePayTaxOutsideIndiaStatus(true);
        //
        //     fileTaxActionJointHolder(index);
        //   }
        //   else{
        //     vm.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia = true;
        //     fileTaxActionJointHolder(index);
        //   }
        // }



        vm.changedTaxStatus = function (index, type) {

          if (typeof index == 'undefined' || typeof type == 'undefined') {
            return;
          }

          // var oldFormData = angular.fromJson($window.sessionStorage.investorForm);
          // oldFormData.jointHolders = angular.copy(vm.jointHoldersPayload.jointHolders);
          // $window.sessionStorage.setItem('investorForm',angular.toJson(oldFormData));

          if(type === '21' || type === '24') {
            vm.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia = false;

            // vm.holders.fatcaDetail.payTaxInIndia = false;
            fileTaxActionJointHolder(index);
          }
          else {
            vm.jointHoldersPayload.jointHolders[index].fatcaDetail.payTaxInIndia = true;

          }
        }


        vm.continue = function () {

          vm.reviewData = angular.copy(vm.jointHoldersPayload.jointHolders);

          for (var i = 0 ; i < vm.reviewData.length ; i ++) {

            vm.taxStatusList[i].forEach(function (taxStatus,index) {
              if(taxStatus.taxStatusCode === vm.reviewData[i].taxStatusCode){
                vm.reviewData[i].taxStatusDescription = taxStatus.taxStatusDescription;
              }
            });

            vm.occupationList.forEach(function (occupationStatus,index) {
              if(occupationStatus.occupationCode === vm.reviewData[i].occupationCode){
                vm.reviewData[i].occupationDescription = occupationStatus.occupationDescription;
              }
            });

            vm.incomeSlabList.forEach(function (incomeDesc,index) {
              if(incomeDesc.incomeCode === vm.reviewData[i].grossAnnualIncome){
                vm.reviewData[i].incomeDescription = incomeDesc.incomeDescription;
              }
            });

            vm.countryList.forEach(function (countryDesc,index) {
              if(countryDesc.countryCode === vm.reviewData[i].fatcaDetail.birthCountry){
                vm.reviewData[i].fatcaDetail.birthCountryDescription = countryDesc.countryName;
              }
            });

            vm.addressTypeList.forEach(function (addDesc,index) {
              if(addDesc.value === vm.reviewData[i].fatcaDetail.addressType){
                vm.reviewData[i].fatcaDetail.addressTypeDescription = addDesc.addressDescription;
              }
            });


          }


          if(vm.firstFlow === 'YES'){
            continueFolio('folioDetails.addNominee',{investorId:$stateParams.investorId});
          }else{
            continueFolio('main.folio.nominee',{investorId:$stateParams.investorId});
          }

        };

        vm.deleteSecond = function(detail) {
          if(detail.fatcaTax3){
            detail.fatcaTax2 = detail.fatcaTax3;
            delete detail.fatcaTax3;
            detail.thirdTax = false;
          } else {
            delete detail.fatcaTax2;
            detail.secondTax = false;
          }
          vm.fatcaDetail = angular.copy(detail);
        }

        vm.deleteThird = function(detail) {
          detail.fatcaTax2 = detail.fatcaTax2;
          delete detail.fatcaTax3;
          detail.thirdTax = false;
          vm.fatcaDetail = angular.copy(detail);
        }

        vm.isObjectEmpty = function(argObj){

          return argObj && Object.keys(argObj) && Object.keys(argObj).length === 0;
        }

        /* function getSoleApplicantPayload() {
           var a = vm.jointHoldersPayload;
           var payload = {
             "soleApplicantDetail": {
               "personalDetail": {
                 "firstName": a.firstName,
                 "lastName": "",
                 "dateOfBirth": a.dateOfBirth,
                 "email": ""
               },
               "taxStatusCode": a.taxStatusCode,
               "fatcaAddressType": a.fatcaAddressType,
               "birthCountry": a.birthCountry,
               "birthCity": a.birthCity,
               "occupation": a.occupation,
               "panNumber": $vm.MainFolioParent.panNumber,
               "grossAnnualIncome": a.grossAnnualIncome || "",
               "netWorth": a.netWorth || "",
               "netWorthDate": a.netWorthDate || "",
               "politicalStatus": a.politicalStatus,
               "payTaxInIndia": a.payTaxInIndia,
               "payOutsideIndiaAddresses": a.payOutsideIndiaAddresses,
               "minor": a.minor
             },
             "jointHolders": [],
             "nominees": vm.nomineesResp || [],
             "guardianDetail": null,
             "brokerCode": null,
             "holdmode": a.holdmode,
             "saveStep": null,
             "id": null,
             "newFolioComplete": null
           };

           return payload;
         }*/
        function setInvestorForm() {
          $window.sessionStorage.investorForm = angular.copy(angular.toJson(vm.jointHoldersPayload));
          checkValid2ndHolder(vm.jointHoldersPayload.jointHolders);
        }

        function checkValid2ndHolder(obj){
          vm.notValid2ndHolder=false;
          for(var i =0; i<obj.length;i++){
            if(!obj[i].email && !obj[i].mobileNumber){
              vm.notValid2ndHolder=true;
            }
          }
        }

        //------------------------//


        function getPayload() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                vm.savedFolioData = resp.data;
                if(angular.isArray(vm.formData.jointHolders) && vm.formData.jointHolders.length>0){
                  vm.formData.jointHolders.forEach(function (holder,index) {
                    holder.netWorth && $window.NumToWord(holder.netWorth, 'DisplayWordsTaxAmt-'+index, vm);
                  })
                }

                vm.formData.holdmode = resp.data.holdmode;
                vm.MainFolioParent.holdmode = vm.formData.holdmode;
                if(vm.savedFolioData.jointHolders.length > 0){
                  for(var i = 0; i < vm.savedFolioData.jointHolders.length; i++){
                    vm.jointHoldersPayload.jointHolders[i].occupationCode = vm.savedFolioData.jointHolders[i].occupationCode ? vm.savedFolioData.jointHolders[i].occupationCode : "2";
                    vm.jointHoldersPayload.jointHolders[i].fatcaDetail.birthCountry = vm.savedFolioData.jointHolders[i].fatcaDetail.birthCountry ? vm.savedFolioData.jointHolders[i].fatcaDetail.birthCountry : "IN";
                    if (vm.jointHoldersPayload.jointHolders[i].netWorth) {
                      vm.jointHoldersPayload.jointHolders[i].netWorthComma = (parseInt(vm.jointHoldersPayload.jointHolders[i].netWorth.toString().replaceAll(",", "")) || '').toLocaleString('en-IN');
                    }
                  }
                }else {
                  if (vm.jointHoldersPayload.jointHolders && vm.jointHoldersPayload.jointHolders.length > 0) {
                    vm.jointHoldersPayload.jointHolders[0].occupationCode = "2";
                    vm.jointHoldersPayload.jointHolders[0].fatcaDetail.birthCountry = "IN";
                  }
                }

                if (vm.formData && vm.formData.jointHolders.length===0) {
                  //vm.payload.nominees = [];
                  // vm.addNominee();

                }
                if(vm.savedFolioData.jointHolders && vm.savedFolioData.jointHolders.length > 0) {
                  vm.hideVerifyPanField = true;
                  vm.jointHoldersPayload = angular.copy(vm.savedFolioData);
                  $window.sessionStorage.investorForm = angular.copy(angular.toJson(vm.jointHoldersPayload));
                  vm.savedFolioData.jointHolders.forEach(function(el, index) {
                    getTaxStatusList(el.nriFlag,index,function() {
                      if (index ===  vm.savedFolioData.jointHolders.length - 1) {
                        initHolders();
                      }
                    });
                  })
                } else {
                  initHolders();
                }

                LoaderService.hideLoader();
              } else {
                MessageService.error(resp.message);
                LoaderService.hideLoader();
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };


          var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');


          InvestorServiceV3.post({
            child1: 'folio',
            child2: 'getDetails'
          },{id:investorId}).$promise.then(success, error);

        }


        function verifyPAN() {
          if(vm.formData.pan === token.investorPAN){
            MessageService.error("You can not add yourself as Joint Holder.");
            continueModal();
            return;
          }
          var success = function (resp) {
              LoaderService.hideLoader('.popup');
              vm.processFlag = false;
              var addFlag = true;
              // resp = {"statusCode":"OK","message":"SUCCESS","data":{"name":"Vinod Kumar Singh","pan":"EHWPS0933K","minor":false,"aadharLinked":false,"newInvestor":false,"emailExists":true,"kycverified":true},"status":true};
              if (resp.status && resp.data) {
                panDetails = resp;
                if (resp.data && resp.data.ekycStatus && (resp.data.ekycStatus === vm.KYC_STATUS.VERIFIED || resp.data.ekycStatus === vm.KYC_STATUS.IN_PROGRESS)) {
                  if ((resp.data && (angular.isDefined(resp.data.emailExists))
                    && (resp.data.emailExists === true)) || vm.formData.email) {
                    // panDetails.data.email = "";

                    // $uibModalInstance.close(panDetails);

                    var model = angular.fromJson($window.sessionStorage.investorForm) || InvestorFolioModel.getInvestorFolioFormDataModel() || InvestorFolioModel.getNewInvestorFolioModel()
                    vm.allowJointHolder = true;
                    if (resp.data && resp.data.kycverified) {
                      if (
                        model.soleApplicantDetail.selfDetail
                        && model.soleApplicantDetail.selfDetail.panNumber
                        && model.soleApplicantDetail.selfDetail.panNumber != resp.data.pan
                      ) {

                        var newModel = InvestorFolioModel.getNewJointHolder();
                        model.jointHolders = angular.isDefined(model.jointHolders)?
                          model.jointHolders:[];
                        model.jointHolders[0] = newModel;
                        model.jointHolders[0].jointHolderName = resp.data.name;
                        model.jointHolders[0].pan = resp.data.pan;
                        model.jointHolders[0].email = resp.data.email ? resp.data.email : vm.formData.email;
                        model.jointHolders[0].mobileNumber = resp.data.mobileNumber;
                        model.jointHolders[0].occupationCode = "2";
                        model.jointHolders[0].nriFlag = angular.copy(vm.formData.taxStatusResident);
                        getTaxStatusList(vm.formData.taxStatusResident, 0, function() {
                          if (!vm.formData.taxStatusResident) {
                            model.jointHolders[0].taxStatusCode = "01";
                          }
                          if (model.jointHolders.length === 2) {
                            model.jointHolders.splice(model.jointHolders.length - 1 , 1)
                          };
                          InvestorFolioModel.setInvestorFolioModel(model);
                          $window.sessionStorage.investorForm = angular.toJson(model);
                          vm.hideVerifyPanField = true;
                          vm.jointHoldersPayload = model;
                        });
                      } else {
                        MessageService.error("A valid PAN details required to add joint holder");
                        $timeout(function () {
                          $state.go('main.folio.soleApplicant');
                        });
                      }
                    }
                  } else {
                    switchVerify('emailVerify');
                  }
                } else if (resp.data && resp.data.ekycStatus && (resp.data.ekycStatus === vm.KYC_STATUS.NOT_VALIDATED || resp.data.ekycStatus === vm.KYC_STATUS.ON_HOLD)) {
                  ModalService.nonKycModal({
                    'text': resp.data.kycStatus === vm.KYC_STATUS.ON_HOLD ? vm.appConstants.ON_HOLD_MESSAGE : vm.appConstants.NOT_VALIDATED_MESSAGE,
                    'showHtml': true,
                    'buttonText': 'OK',
                    'ekycRequestCO': resp.data.ekycRequestCO
                  }, function () {
                      vm.formData.pan = null;
                    }, function () {
                      vm.formData.pan = null;
                  });
                }
              } else {
                if (resp.popupEnabled) {
                  vm.wrongMsg = resp.message;
                } else {
                  vm.wrongMsg = resp.message;
                  MessageService.error(resp.message);
                }
                // vm.wrongMsg = resp.message;
                // MessageService.error(resp.message);
                // $state.go('main.dashboard');
              }
            },
            error = function () {
              LoaderService.hideLoader('.popup');
              vm.processFlag = false;
              vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
            };

          var payload = {
            pan: vm.formData.pan,
            nriFlag: angular.copy(vm.formData.taxStatusResident)
          };

          LoaderService.showLoader('.popup');//folio/any-or-survivor/holder/pan/details

          InvestorService.post({
            child1: 'folio',
            child2: 'any-or-survivor',
            child3: 'holder',
            child4: 'pan',
            child5: 'details'
          }, payload).$promise.then(success, error);

        }

        function continueModal() {

        }

        function switchVerify(verify) {
            vm.panVerify = true;
            vm.emailVerify = false;
            vm.otpVerify = false;
            vm.showEmail = true;
            vm.allowJointHolder = false;
        }


        vm.changeAnnualIncome = function (index) {
          vm.jointHoldersPayload.jointHolders[index].isChecked = !vm.jointHoldersPayload.jointHolders[index].isChecked;

          if (vm.jointHoldersPayload.jointHolders[index].isChecked) {
            vm.jointHoldersPayload.jointHolders[index].showAnnualIncome = true;
            vm.jointHoldersPayload.jointHolders[index].grossAnnualIncome = null;
            vm.jointHoldersPayload.jointHolders[index].netWorthDate = null;
            vm.jointHoldersPayload.jointHolders[index].netWorth = null;
            vm.jointHoldersPayload.jointHolders[index].netWorthComma = null;
          } else {
            vm.jointHoldersPayload.jointHolders[index].showAnnualIncome = false;
            vm.jointHoldersPayload.jointHolders[index].grossAnnualIncome = null;
            vm.jointHoldersPayload.jointHolders[index].netWorthDate = null;
            vm.jointHoldersPayload.jointHolders[index].netWorth = null;
            vm.jointHoldersPayload.jointHolders[index].netWorthComma = null;
          }
        }

        vm.addFirstHolderData = function () {
          vm.sameFirstHoderDetails  = !vm.sameFirstHoderDetails;

          if (!vm.prevDataSecondHolder) {
            vm.prevDataSecondHolder = angular.copy(vm.jointHoldersPayload.jointHolders[1]);
          }

          vm.prevDataSecondHolderTaxStatusCode = angular.copy(vm.jointHoldersPayload.jointHolders[1].taxStatusCode);
          vm.prevDataSecondHolderNriFlag = angular.copy(vm.jointHoldersPayload.jointHolders[1].nriFlag);

          if (!vm.prevDataSecondHolder.taxStatusCode) {
            vm.prevDataSecondHolder.taxStatusCode = angular.copy(vm.prevDataSecondHolderTaxStatusCode);
            vm.prevDataSecondHolder.nriFlag = angular.copy(vm.prevDataSecondHolderNriFlag);
          }

          if (vm.sameFirstHoderDetails == true) {
            vm.firstHolderDetail = angular.copy(vm.jointHoldersPayload.jointHolders[0]);
            if (vm.prevDataSecondHolderNriFlag === vm.firstHolderDetail.nriFlag) {
              vm.jointHoldersPayload.jointHolders[1].taxStatusCode = angular.copy(vm.firstHolderDetail.taxStatusCode);
            }
            vm.jointHoldersPayload.jointHolders[1].occupationCode =  vm.firstHolderDetail.occupationCode;
            vm.jointHoldersPayload.jointHolders[1].fatcaDetail = vm.firstHolderDetail.fatcaDetail;
            vm.jointHoldersPayload.jointHolders[1].isChecked = vm.firstHolderDetail.isChecked;
            vm.jointHoldersPayload.jointHolders[1].showAnnualIncome = vm.firstHolderDetail.showAnnualIncome;

            if (!vm.jointHoldersPayload.jointHolders[1].showAnnualIncome) {
              vm.jointHoldersPayload.jointHolders[1].grossAnnualIncome = vm.firstHolderDetail.grossAnnualIncome;
            } else if (vm.jointHoldersPayload.jointHolders[1].showAnnualIncome) {
              vm.jointHoldersPayload.jointHolders[1].netWorth = vm.firstHolderDetail.netWorth;
              vm.jointHoldersPayload.jointHolders[1].netWorthComma = (parseInt(vm.firstHolderDetail.netWorth.toString().replaceAll(",", "")) || '').toLocaleString('en-IN');
              vm.jointHoldersPayload.jointHolders[1].netWorthDate = vm.firstHolderDetail.netWorthDate;
            }

            vm.jointHoldersPayload.jointHolders[1].politicalStatus = vm.firstHolderDetail.politicalStatus;
            vm.jointHoldersPayload.jointHolders[1].fatcaDetail.payTaxInIndia = vm.firstHolderDetail.fatcaDetail.payTaxInIndia;

            if (vm.jointHoldersPayload.jointHolders[1].fatcaDetail.payTaxInIndia) {
              vm.jointHoldersPayload.jointHolders[1].fatcaDetail.fatcaTax1.taxPayingCountry = vm.firstHolderDetail.fatcaDetail.fatcaTax1.taxPayingCountry;
              vm.jointHoldersPayload.jointHolders[1].fatcaDetail.fatcaTax1.taxIdType = vm.firstHolderDetail.fatcaDetail.fatcaTax1.taxIdType;
              vm.jointHoldersPayload.jointHolders[1].fatcaDetail.fatcaTax1.taxPayingCity = vm.firstHolderDetail.fatcaDetail.fatcaTax1.taxPayingCity;
              vm.jointHoldersPayload.jointHolders[1].fatcaDetail.fatcaTax1.taxId = vm.firstHolderDetail.fatcaDetail.fatcaTax1.taxId;
            }
          } else {
            vm.jointHoldersPayload.jointHolders[1] = vm.prevDataSecondHolder;
            vm.jointHoldersPayload.jointHolders[1].taxStatusCode = angular.copy(vm.prevDataSecondHolderTaxStatusCode);
            vm.jointHoldersPayload.jointHolders[1].nriFlag = angular.copy(vm.prevDataSecondHolderNriFlag);
            vm.prevDataSecondHolder = angular.copy(vm.jointHoldersPayload.jointHolders[1]);
          }
        }

        vm.formIsvalid = function () {
          vm.$emit('buttonEnable')
        }

        vm.formIsinvalid = function () {
          vm.$emit('buttonDisable')
        }

        function addEmailToHolderPan() {
          vm.Otp = '';
          var success = function (resp) {
            LoaderService.hideLoader('.popup');
            vm.processFlag = false;
            if (resp.status && resp.data) {
              vm.emailDetails.secretLink = resp.data.secretLink;
              vm.Otp = resp.data.otp;
              vm.otpResendMessage = resp.data.message;
              vm.showOtp = true;
              MessageService.success(resp.data.message);
            }
          },
          error = function () {
            vm.processFlag = false;
            vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
          };
          var payload = {
            pan: vm.formData.pan,
            email: vm.formData.email
          };
          InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'add',child6: 'email',child7: 'send',child8: 'otp'}, payload).$promise.then(success, error);
        }

        function verifyOtp() {
          var success = function (resp) {
            LoaderService.hideLoader();
            vm.processFlag = false;
            if (resp.status && resp.data && resp.data.verified) {
              vm.showOtp = false;
              vm.showEmail = false;
              vm.allowJointHolder = true;
              verifyPAN();
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function () {
            vm.processFlag = false;
            vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
            LoaderService.hideLoader();
          };
          var payload = {
            uniqueLink: vm.emailDetails.secretLink,
            otp: vm.formData.Otp
          };
          LoaderService.showLoader();
          InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'add',child6: 'email',child7: 'verify',child8: 'otp'}, payload).$promise.then(success, error);
        }

        function reGenerateOtp() {
          var success = function (resp) {
            LoaderService.hideLoader();
            vm.processFlag = false;
            if (resp.status && resp.data) {
              vm.OTPResendMsg = resp.data.message;
              vm.emailMsg = "";
              resetTimer();
            } else {
              vm.wrongMsg = resp.message;
              MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader();
            vm.processFlag = false;
            vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
          };
          vm.payload = {
            pan: vm.formData.pan,
            secretLink: vm.emailDetails.secretLink,
            email: vm.formData.email
          };
          LoaderService.showLoader();
          InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'add',child6: 'email',child7: 'resend',child8: 'otp'}, vm.payload).$promise.then(success, error);
        }

        function resetTimer() {
          scope.$broadcast('timer-add-cd-seconds', vm.pattern.RESEND_OTP_COUNTER);
        }

        vm.changePan = function () {
          vm.wrongMsg='';

          if (!vm.formData.pan) {
            vm.showEmail = false;
            vm.allowJointHolder = true;
            vm.formData.email = null;
            vm.showOtp = false;
            resetTimer();
          }
        }
        function netWorthChanges(value,index) {
          if (value) {
            vm.jointHoldersPayload.jointHolders[index].netWorthComma = (parseInt(value.toString().replaceAll(",", "")) || '').toLocaleString('en-IN');
            vm.jointHoldersPayload.jointHolders[index].netWorth = vm.jointHoldersPayload.jointHolders[index].netWorthComma && parseInt(vm.jointHoldersPayload.jointHolders[index].netWorthComma.toString().replaceAll(",", "") || '');
          } else {
            vm.jointHoldersPayload.jointHolders[index].netWorth = '';
          }
        }

        vm.netWorthChanges = function (value) {
          vm.jointHoldersPayload.jointHolders.forEach(function (holder,index) {
            if(value) {
              holder.netWorthComma = (parseInt(value.toString().replaceAll(",", "")) || '').toLocaleString('en-IN');
              holder.netWorth = parseInt(holder.netWorthComma.toString().replaceAll(",", "") || '');
            }else{
              holder.netWorth = '';
            }
          });
        };

        function changeEnteredEmail() {
          vm.showOtp = false;
          resetTimer();
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('guardianDetails', guardianDetails);

  /*@ngInject*/
  function guardianDetails(AppConstants, $rootScope, LoaderService, MessageService, InvestorService, $log, $state, $timeout, $window, NewInvestorServiceV3, $stateParams, InvestorFileUploadServiceV3, InvestmentModel, AuthService, InvestorServiceV3, InvestorFolioModel, InvestorServiceV2, ModalService) {

    return {
      restrict: 'E',
      scope: {
        firstFlow:'=', stepperUpdatedInfo : '&', proceedAction : '&', selectedFolioData: '=', journey: '='
      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/folio/guardian-details/guardian-details.directive.html',
      link: function (scope) {
        var _this = scope;
        _this.incomeTab = AppConstants.INCOME_TAB;
        _this.CONST_DATA = AppConstants;
        _this.CONST = AppConstants.ToastrMessage.VALIDATE_DATA;
        _this.dateErrorMessage = "";
        _this.folioIncomeForm = {}
        _this.folioIncomeForm.occupation = '';
        _this.folioIncomeForm.annualincome = '';
        _this.folioIncomeForm.grossAnnualIncomeDate = '';
        _this.folioIncomeForm.Fatca = {};
        _this.folioIncomeForm.Fatca.city = '';
        // $rootScope.folioBasicDetail.folioForUser = 'Self';
        // _this.networth = false;
        _this.holders  = {};
        _this.countries = null;
        _this.taxStatusData = null;
        _this.soleApplicantEmail = null;
        _this.soleApplicantMobile = null;
        _this.folioIncomeForm.taxstatus = "01";
        _this.folioIncomeForm.Fatca.countrie = "IN";
        _this.folioIncomeForm.Fatca.addressType = "RESIDENTIAL";
        _this.belongToListEmail = null;
        _this.belongToListMobile = null;
        _this.incomeSlabList = null;
        _this.annualTabForGuardian = true;
        _this.netWorthTabForGurdian = false;
        _this.getCountry = getCountry;
        _this.networthcall = networthcall;
        _this.autoDate = autoDate;
        // _this.getPayload = getPayload;
        _this.incomeActiveTabForGuardian = incomeActiveTabForGuardian;
        _this.submitFolioIncomeForm = submitFolioIncomeForm;
        _this.incomeActiveTab = incomeActiveTab;
        // _this.fetchBelongsToDropdown = fetchBelongsToDropdown;
        // _this.getTaxStatus = getTaxStatus;
        // _this.getOccupations = getOccupations;
        // _this.getIncomeSlab = getIncomeSlab;

        //Guardiuan details

        _this.viewMode = "days";
        _this.dateErrorMessage = "";
        _this.token = AuthService.getToken();
        $rootScope.myState = $state.current.url;
        _this.dataPayload = InvestmentModel.getDataPayload();
        _this.fromBasicDataPayload = InvestorFolioModel.getInvestorFolioModel();
        _this.networth = false;
        _this.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        _this.minorFormGuardianData = {}
        // $rootScope.folioBasicDetail.folioForUser  = 'Minor';
        _this.minorFormGuardianData.relation = '';
        _this.minorFormGuardianData.guardianrelationproofType = '';
        _this.minorFormGuardianData.guardianrelationproofimageurl = '';
        _this.minorFormGuardianData.guardianrelationproofimagename = '';
        _this.minorFormGuardianData.occupation = '';
        _this.minorFormGuardianData.grossAnnualIncome = '';
        _this.minorFormGuardianData.grossAnnualIncomeDate = '';

        _this.minorFormGuardianData.Fatca = {};
        _this.minorFormGuardianData.Fatca.Countrie = '';
        _this.minorFormGuardianData.Fatca.City = '';
        _this.minorFormGuardianData.Fatca.taxPayIndian = true;
        _this.minorFormGuardianData.Fatca.addressType = "";
        _this.minorFormGuardianData.fileTaxOtherIndian = 'No';

        _this.minorFormGuardianData.Fatca.taxPay1 = {};
        _this.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry = "";
        _this.minorFormGuardianData.Fatca.taxPay1.taxIdType = "";
        _this.minorFormGuardianData.Fatca.taxPay1.taxPayingCity = "";
        _this.minorFormGuardianData.Fatca.taxPay1.taxId = "";

        _this.minorFormGuardianData.userPEPStatusForGuardian = 'No';
        _this.minorFormGuardianData.politicalStatus = 'NONE';
        _this.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];

        _this.relationshipList = [
          { name: 'Father', value: 'FATHER' },
          { name: 'Mother', value: 'MOTHER' }, {
            name: 'Sibling', value: 'SIBLING'
          },
          { name: 'Other', value: 'OTHER' }
        ];
        _this.notolderthan1year = false;
        _this.annualTab = true;
        _this.netWorthTab = false;

        //Facta
        scope.holders={};
        // scope.changePayTaxOutsideIndiaStatus(true);
        scope.holders.payTaxInIndia = true;
        scope.holders.fatcaArray = [];

        _this.getPEPStatusForGuardian = getPEPStatusForGuardian;
        _this.getTaxFileStatusForGuardian = getTaxFileStatusForGuardian;
        _this.grossAnnualIncomeDate = grossAnnualIncomeDate;
        _this.getProofType = getProofType;
        _this.getTaxIdType = getTaxIdType;
        _this.getGuardianRelationProofImage = getGuardianRelationProofImage;
        _this.submitMinorGuardianDetails = submitMinorGuardianDetails;
        _this.getGrossAnnualIncomeDate = getGrossAnnualIncomeDate;
        _this.continueFolioForGuardian = continueFolioForGuardian;
        _this.changePayTaxOutsideIndiaStatus = changePayTaxOutsideIndiaStatus;
        _this.folioSelectionData = folioSelectionData;
        _this.addAvailableResidency = addAvailableResidency;
        _this.resetGuardianImage = resetGuardianImage;
        _this.netWorthChanges = netWorthChanges;
        _this.filterBelongToEmail = filterBelongToEmail;
        _this.filterBelongToMobile = filterBelongToMobile;

        _this.editIncomeDetail = true;

        _this.editContactDetails = editContactDetails;
        _this.cancelEditAction = cancelEditAction;
        _this.changeValue = changeValue;
        _this.showOtpModal = showOtpModal;
        _this.generateContactUpdateOtp = generateContactUpdateOtp;
        _this.showEmailEditField = false;
        _this.showMobileEditField = false;
        _this.soleApplicantEditedMobile = null;
        _this.soleApplicantEditedEmail = null;
        _this.isEmailEdited = false;
        _this.isMobileEdited = false;
        // listening to edit button click

        var listner = _this.$on("enableEditIncomeDetail", function() {
          _this.editIncomeDetail = true;
          if (_this.selectedFolioData) {
            _this.selectedFolioData.soleApplicantDetail.personalDetail.kycEmail = _this.soleApplicantEmail;
            _this.selectedFolioData.soleApplicantDetail.personalDetail.kycMobileNo = _this.soleApplicantMobile;
            _this.selectedFolioData.soleApplicantDetail.personalDetail.emailBelongsTo = _this.holders.emailBelongsTo;
            _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileBelongsTo = _this.holders.mobileBelongsTo;
            if (_this.selectedFolioData.soleApplicantDetail.minorDetail) {
              _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.relation =  _this.minorFormGuardianData.relation;
              _this.selectedFolioData.soleApplicantDetail.minorDetail.minorRelationshipProofType = _this.minorFormGuardianData.guardianrelationproofType;
              _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.occupation = _this.minorFormGuardianData.occupation;
              _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry = _this.minorFormGuardianData.Fatca.Countrie;
              _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.fatca.addressType = _this.minorFormGuardianData.Fatca.addressType;
              _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace = _this.minorFormGuardianData.Fatca.City;
              _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.politicalStatus = _this.minorFormGuardianData.politicalStatus;
              _this.selectedFolioData.soleApplicantDetail.minorDetail.minorRelationshipProof = _this.minorFormGuardianData.guardianrelationproofimageurl;
              _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia = scope.holders.payTaxInIndia;
              if (_this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome) {
                _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome = _this.minorFormGuardianData.grossAnnualIncome;
              } else {
                _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.netWorth = _this.minorFormGuardianData.networth;
                _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.netWorthDate = _this.minorFormGuardianData.grossAnnualIncomeDate;
                netWorthChanges(_this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.netWorth);
              }
            }
          }
          _this.payloadData = InvestmentModel.getPayload();
        });

        _this.editGuardianDetail = true;
        // listening to edit button click

        var listner = _this.$on("enableEditGuardianDetail", function() {
          _this.editGuardianDetail = true;
          _this.payloadData = InvestmentModel.getPayload();
        });

        // var listner = _this.$on("continueButtonIncomeDetails", function() {
        //   _this.submitFolioIncomeForm();
        // });
        //
        // var listner = _this.$on("continueButtonGuardianIncomeDetails", function() {
        //   _this.submitMinorGuardianDetails();
        // });

        _this.payloadData = InvestmentModel.getPayload();


        _this.init = init();
        _this.receivedData = {
          folioForUser: 'Self',
          folioHoldingMode: 'Single'
        };

        function init() {
          if (localStorage.getItem('folioId')) {
            getPayload();
            // getOldFolioData();
          }
          getCountry();
          fetchBelongsToDropdown();
          // fetchBelongsToDropdown(function () {
          //   _this.getPayload();
          // });
          getTaxStatus();
          getOccupations();
          getIncomeSlab();
          getAddressType();

          //Guardian Method
          getProofType();
          getTaxIdType();
          // getOldFolioData();
          folioSelectionData();
        }



        function folioSelectionData(){
          var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
          if(_this.selectedFolioData) {
            _this.soleApplicantEmailCopy = _this.selectedFolioData.soleApplicantDetail.personalDetail.email;
            _this.soleApplicantMobileCopy = _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileNo;
            _this.soleApplicantEmail = contactUpdateCo && contactUpdateCo.isEmailEdited ? contactUpdateCo.soleApplicantEditedEmail : _this.selectedFolioData.soleApplicantDetail.personalDetail.email;
            _this.soleApplicantMobile = contactUpdateCo && contactUpdateCo.isMobileEdited ? contactUpdateCo.soleApplicantEditedMobile : _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileNo;
            _this.holders.emailBelongsTo = _this.selectedFolioData.soleApplicantDetail.personalDetail.emailBelongsTo;
            _this.holders.mobileBelongsTo = _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileBelongsTo;
            if (_this.selectedFolioData.soleApplicantDetail.minorDetail) {
              _this.minorFormGuardianData.relation = _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.relation;
              _this.minorFormGuardianData.guardianrelationproofType = _this.selectedFolioData.soleApplicantDetail.minorDetail.minorRelationshipProofType;
              _this.minorFormGuardianData.occupation = parseInt(_this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.occupation).toString();
              _this.minorFormGuardianData.Fatca.Countrie = _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry;
              _this.minorFormGuardianData.Fatca.addressType = _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.fatca.addressType;
              _this.minorFormGuardianData.Fatca.City = _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace;
              _this.minorFormGuardianData.politicalStatus = _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.politicalStatus;
              _this.minorFormGuardianData.guardianrelationproofimageurl = _this.selectedFolioData.soleApplicantDetail.minorDetail.minorRelationshipProof;
              scope.holders.payTaxInIndia = _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia;
              if (!scope.holders.payTaxInIndia) {
                addAvailableResidency(_this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.fatca)
              }
              if(_this.selectedFolioData && _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome) {
                _this.incomeActiveTabForGuardian('ANNUAL_GROSS_INCOME');
                _this.minorFormGuardianData.grossAnnualIncome = _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
              }else {
                _this.incomeActiveTabForGuardian('NET_WORTH');
                _this.minorFormGuardianData.networth = _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.netWorth;
                _this.minorFormGuardianData.grossAnnualIncomeDate = _this.selectedFolioData.soleApplicantDetail.minorDetail.guardian.netWorthDate;

              }
            }
            if(_this.minorFormGuardianData.guardianrelationproofimageurl){
              var file = _this.minorFormGuardianData.guardianrelationproofimageurl;
              var fileName = file.split("/");
              _this.minorFormGuardianData.guardianrelationproofimagename = fileName[fileName.length - 1];
            }
          }

        }
        function addAvailableResidency(fatca){
          if (fatca.fatcaTax1) {
            scope.holders.fatcaArray.push(fatca.fatcaTax1);
          }
          if (fatca.fatcaTax2) {
            scope.holders.fatcaArray.push(fatca.fatcaTax2);
          }
          if (fatca.fatcaTax3) {
            scope.holders.fatcaArray.push(fatca.fatcaTax3);
          }
          if(scope.holders.payTaxInIndia == false && scope.holders.fatcaArray.length ===0){
            scope.holders.fatcaArray.push({});
          }
        }

        scope.addNewResidencyFields = function () {
          if(angular.isUndefined(scope.holders.fatcaArray) || !angular.isArray(scope.holders.fatcaArray) ){
            scope.holders.fatcaArray = [];
          }
          scope.holders.fatcaArray.push(
            {
              "taxPayingCountry": '',
              "taxPayingCity": '',
              "taxIdType": '',
              "taxId": ''
            });
        };

        // scope.deleteTaxResidencyFromFatca = function (index) {
        //   scope.holders.fatcaArray.splice(index, 1);
        // };
        scope.deleteTaxResidency = function (index) {
          scope.holders.fatcaArray.splice(index, 1);
          console.log(scope.holders.fatcaArray)
        }
        scope.addMoreTaxResidency = function () {
          var array = scope.holders.fatcaArray || [];
          array.length < 4 ? array.push({}) : '';
          console.log(scope.holders.fatcaArray)

        }
        function changePayTaxOutsideIndiaStatus(status) {
          if (!status) {
            return;
          }
          if (_this.receivedData.folioForUser === 'Minor') {
            if (scope.holders && (angular.isUndefined(scope.holders.fatcaArray)||scope.holders.fatcaArray.length === 0)) {
              scope.addNewResidencyFields();
            }
          }
          else {
            if (angular.isUndefined(scope.holders.fatcaArray) || scope.holders.fatcaArray.length === 0) {
              scope.addMoreTaxResidency();
            }
          }
        }

        _this.$on('someEvent', function (event, result) {
          _this.receivedData = result.data;
        });

        function fetchBelongsToDropdown(cb) {
          cb = cb ||function () {

          };
          LoaderService.showLoader();
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.belongToListEmail = resp.data.emailList;
                _this.belongToListMobile = resp.data.mobileList;
                LoaderService.hideLoader();
              } else {
                MessageService.error(resp.message);
                LoaderService.hideLoader();
              }
              cb();
            },
            error = function (err) {
              $log.info('Belongs Dropdown error >>>>', err);
              LoaderService.hideLoader();
              cb();
            };

          InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
        }

        function getCountry() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.countries = resp.data.countries;
              } else {
                _this.countries = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in country list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'country-list' }, null).$promise.then(success, error);
        }

        function getTaxStatus() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.taxStatusData = resp.data.taxStatus;
              } else {
                _this.taxStatusData = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in tax status!");
            };
          var data = { taxStatusFilter: 'ADULT' }
          InvestorService.post({ child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
        }

        function getOccupations() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.investorOccupations = resp.data.investorOccupations;
              } else {
                _this.investorOccupations = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in occupation list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'occupation' }).$promise.then(success, error);
        }

        function getIncomeSlab() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.incomeSlabList = resp.data.incomeSlabList;
              } else {
                _this.incomeSlabList = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              _this.incomeSlabList = null;
              // MessageService.error("Error in income slab list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'income-slab' }).$promise.then(success, error);
        }

        function getAddressType() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.addressType = resp.data.addressTypeResponses;
              } else {
                _this.addressType = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in address type list!");
            };
          InvestorService.post({ child1: 'folio', child2: 'address-type' }, null).$promise.then(success);
        }



        function autoDate() {
          var oldlength = 0 ;
          if(_this.dobString){
            oldlength = _this.dobString.length;
          }
          _this.dobString = $("#grossAnnualIncomeDateId").val();
          var newlength = _this.dobString.length;
          if( _this.dobString.length == 2){

            if((newlength== (oldlength - 1)) || (newlength == oldlength)){
            } else{
              $("#grossAnnualIncomeDateId").val(_this.dobString+"-");
            }
          }
          if( _this.dobString.length == 5){

            if((newlength== (oldlength - 1)) || (newlength == oldlength)){
            } else{
              $("#grossAnnualIncomeDateId").val(_this.dobString+"-");
            }
          }
        }


        function getPayload () {
          var success = function (resp) {
            if (resp.status && resp.data) {
              var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
              _this.currentPayload = resp.data;
              _this.prevBankDetails = resp.data.bankDetails;
              _this.minorFormGuardianData.relation = resp.data.soleApplicantDetail.minorDetail.guardian.relation;
              _this.minorFormGuardianData.guardianrelationproofType = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProofType;
              _this.minorFormGuardianData.minorRelationshipProof = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
              _this.minorFormGuardianData.guardianrelationproofimageurl = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
              // _this.soleApplicantEmail = resp.data.soleApplicantDetail.personalDetail.kycEmail;
              // _this.soleApplicantMobile = resp.data.soleApplicantDetail.personalDetail.kycMobileNo;
              // _this.holders.emailBelongsTo = resp.data.soleApplicantDetail.personalDetail.emailBelongsTo;
              // _this.holders.mobileBelongsTo = resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo;
              _this.soleApplicantEmailCopy = _this.selectedFolioData && _this.selectedFolioData.soleApplicantDetail.personalDetail.email ?_this.selectedFolioData.soleApplicantDetail.personalDetail.email : resp.data.soleApplicantDetail.personalDetail.email;
              _this.soleApplicantMobileCopy = _this.selectedFolioData && _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileNo ?_this.selectedFolioData.soleApplicantDetail.personalDetail.mobileNo : resp.data.soleApplicantDetail.personalDetail.mobileNo;
              _this.soleApplicantEmail = _this.selectedFolioData && _this.selectedFolioData.soleApplicantDetail.personalDetail.email ?_this.selectedFolioData.soleApplicantDetail.personalDetail.email : resp.data.soleApplicantDetail.personalDetail.email;
              _this.soleApplicantMobile =_this.selectedFolioData && _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileNo ?_this.selectedFolioData.soleApplicantDetail.personalDetail.mobileNo : resp.data.soleApplicantDetail.personalDetail.mobileNo;
              _this.holders.emailBelongsTo = _this.selectedFolioData && _this.selectedFolioData.soleApplicantDetail.personalDetail.emailBelongsTo ? _this.selectedFolioData.soleApplicantDetail.personalDetail.emailBelongsTo : resp.data.soleApplicantDetail.personalDetail.emailBelongsTo || "SE";
              _this.holders.mobileBelongsTo =_this.selectedFolioData && _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileBelongsTo ? _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileBelongsTo : resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo || "SE";
              _this.currentFolio = resp.data;
              if($rootScope.folioBasicDetail){
                $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
              }
              _this.holdeMode = _this.currentFolio.holdmode;
              try{
                const file = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
                const fileName = file.split("/");
                _this.minorFormGuardianData.guardianrelationproofimagename = fileName[fileName.length - 1];
              }catch(e){}
              _this.minorFormGuardianData.occupation = resp.data.soleApplicantDetail.minorDetail.guardian.occupation || "2";
              _this.minorFormGuardianData.grossAnnualIncome = resp.data.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
              _this.minorFormGuardianData.Fatca.Countrie = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry || "IN";
              _this.minorFormGuardianData.Fatca.City = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace;
              _this.minorFormGuardianData.Fatca.addressType = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.addressType || "RESIDENTIAL";
              _this.minorFormGuardianData.Fatca.taxPay1 = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1;

              if (resp.data.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia == true) {
                _this.minorFormGuardianData.fileTaxOtherIndian = 'No';
                _this.minorFormGuardianData.Fatca.taxPayIndian = true;
              } else {
                _this.minorFormGuardianData.fileTaxOtherIndian = 'Yes';
                _this.minorFormGuardianData.Fatca.taxPayIndian = false;
              }

              if(resp.data.soleApplicantDetail.minorDetail.guardian.politicalStatus){
                if (resp.data.soleApplicantDetail.minorDetail.guardian.politicalStatus == 'NONE') {
                  _this.minorFormGuardianData.userPEPStatusForGuardian = 'No';
                  _this.minorFormGuardianData.politicalStatus = "NONE";
                } else {
                  _this.minorFormGuardianData.userPEPStatusForGuardian = 'Yes';
                  _this.minorFormGuardianData.politicalStatus = "POLITICAL";
                }
              }else{
                _this.minorFormGuardianData.userPEPStatusForGuardian = 'No';
                _this.minorFormGuardianData.politicalStatus = "NONE";
              }
              scope.holders.payTaxInIndia = _this.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia;
              if (!scope.holders.payTaxInIndia) {
                addAvailableResidency(_this.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca)
              }
              if(_this.currentPayload && _this.currentPayload.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome) {
                _this.incomeActiveTabForGuardian('ANNUAL_GROSS_INCOME');
                _this.minorFormGuardianData.grossAnnualIncome = _this.currentPayload.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
              }else if(_this.currentPayload && _this.currentPayload.soleApplicantDetail.minorDetail.guardian.netWorth){
                _this.incomeActiveTabForGuardian('NET_WORTH');
                _this.minorFormGuardianData.networth = _this.currentPayload.soleApplicantDetail.minorDetail.guardian.netWorth;
                _this.minorFormGuardianData.grossAnnualIncomeDate = _this.currentPayload.soleApplicantDetail.minorDetail.guardian.netWorthDate;
                netWorthChanges(_this.minorFormGuardianData.networth);
              }

              _this.minorFormGuardianData.nriFlag = resp.data.nriFlag;

            } else { }
          }, error = function (error) {
            MessageService.error(error.message);
          };
          var investorId = localStorage.getItem("folioId");
          NewInvestorServiceV3.post({child1: 'folio',child2: 'getDetails'},{id:investorId}).$promise.then(success, error);
        }


        function getGrossAnnualIncomeDate (date) {

          if (angular.isDefined(date._i) ||
            /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
            _this.folioIncomeForm.grossAnnualIncomeDate = moment(date).format("DD-MMM-YYYY");
            _this.dobmilisecond = moment(date).valueOf();
            _this.grossAnnualIncomeYear = (moment(new Date()).valueOf() - _this.dobmilisecond) / 31556952000;
            if (_this.grossAnnualIncomeYear < 1 || _this.grossAnnualIncomeYear == 1) {
            }
            else {
              _this.folioIncomeForm.grossAnnualIncomeDate = "";
              alert('Not older than 1 year');
            }
            if (!date) {
              _this.dateErrorMessage = _this.validateData.GROSS_ANNUAL_INCOME;
            } else _this.dateErrorMessage = '';

          } else {
            _this.dateErrorMessage = _this.validateData.GROSS_ANNUAL_INCOME;
            _this.folioIncomeForm.grossAnnualIncomeDate = "";
          }
          return;
        }

        function grossAnnualIncomeDate  (date) {
          if (angular.isDefined(date._i) ||
            /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
            _this.minorFormGuardianData.grossAnnualIncomeDate = moment(date).format("DD-MMM-YYYY");
            _this.dobmilisecond = moment(date).valueOf();
            _this.grossAnnualIncomeYear = (moment(new Date()).valueOf() - _this.dobmilisecond) / 31556952000;
            if (_this.grossAnnualIncomeYear < 1 || _this.grossAnnualIncomeYear == 1) {
              _this.notolderthan1year = false;
            }
            else {
              _this.minorFormGuardianData.grossAnnualIncomeDate = "";
              MessageService.error('Not older than 1 year');
              _this.notolderthan1year = true;
            }
            if (!date) {
              _this.dateErrorMessage = _this.validateData.NET_WORTH_DATE;
            } else _this.dateErrorMessage = '';

          } else {
            _this.dateErrorMessage = _this.validateData.NET_WORTH_DATE;
            _this.minorFormGuardianData.grossAnnualIncomeDate = "";
          }
          return;
        }

        function networthcall() {
          _this.networth = !_this.networth;
          if(_this.networth){
            _this.folioIncomeForm.annualincome = '';
          }else{
            _this.folioIncomeForm.networth = "";
            _this.folioIncomeForm.grossAnnualIncomeDate = "";
          }
        }

        function incomeActiveTab(activeTab){
          if(activeTab == _this.incomeTab[0]){
            _this.annualTab = true;
            _this.netWorthTab = false;
          }else{
            _this.netWorthTab = true;
            _this.annualTab = false;
          }
          _this.folioIncomeForm.annualincome = '';
          _this.folioIncomeForm.networth = "";
          _this.folioIncomeForm.grossAnnualIncomeDate = "";
        }

        function incomeActiveTabForGuardian(activeTab){
          if(activeTab === _this.incomeTab[0]){
            _this.notolderthan1year = true;
            _this.annualTabForGuardian = true;
            _this.netWorthTabForGurdian = false;
            _this.minorFormGuardianData.grossAnnualIncomeDate ='';
            _this.minorFormGuardianData.networth = '';
            _this.minorFormGuardianData.networthComma = '';
          }else{

            _this.notolderthan1year = false;
            _this.netWorthTabForGurdian = true;
            _this.annualTabForGuardian = false;
            _this.minorFormGuardianData.grossAnnualIncome = '';
          }
        }

        function getPEPStatusForGuardian (value) {
          if (value == 'Yes') {
            _this.minorFormGuardianData.userPEPStatusForGuardian = 'Yes';
            _this.minorFormGuardianData.politicalStatus = 'POLITICAL';
          }else if(value == 'Related'){
            _this.minorFormGuardianData.userPEPStatusForGuardian = 'Related';
            _this.minorFormGuardianData.politicalStatus = 'POLITICALLY_RELATED';
          } else {
            _this.minorFormGuardianData.userPEPStatusForGuardian = 'No';
            _this.minorFormGuardianData.politicalStatus = 'NONE';
          }
        }

        function getTaxFileStatusForGuardian(value) {
          if (value == 'Yes') {
            _this.minorFormGuardianData.fileTaxOtherIndian = 'Yes';
            _this.minorFormGuardianData.Fatca.taxPayIndian = false;
          } else {
            _this.minorFormGuardianData.fileTaxOtherIndian = 'No';
            _this.minorFormGuardianData.Fatca.taxPayIndian = true;
          }
        }

        function getProofType () {
          var success = function (resp) {
              _this.relationProofType = resp.data.proofTypeDTOList;
            },
            error = function () {
              MessageService.error("Error in proof type list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'proof', child3: 'type' }, null).$promise.then(success, error);
        }

        function getTaxIdType() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.taxIdType = resp.data.taxIdTypeResponses;
              } else {
                _this.taxIdType = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in tax id type list!");
            };
          InvestorService.post({ child1: 'folio', child2: 'taxId-type' }, null).$promise.then(success);
        }

        function getGuardianRelationProofImage (file) {
          var fi = document.getElementById('guardianrelationproofimage');
          if (_this.mimeType.indexOf(file.type) == -1) {
            MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
            return;
          }
          if (fi.files.item(0).size < 2000000) {
            _this.minorFormGuardianData.guardianrelationproofimagename = file.name;
            var success = function (resp) {
                if (resp.status && resp.data) {
                  _this.minorFormGuardianData.minorRelationshipProof = resp.data.fileUrl;
                  _this.minorFormGuardianData.guardianrelationproofimageurl = resp.data.fileUrl;
                  try{
                    const file = resp.data.fileUrl;
                    const fileName = file.split("/");
                    _this.minorFormGuardianData.guardianrelationproofimagename = fileName[fileName.length - 1];
                  }catch(e){}
                  localStorage.setItem('folioIdForProof', resp.data.uuid);
                }
                else {
                  MessageService.error(resp.message);
                }
              },
              error = function (e) {
                MessageService.error("file not upload");
              };
            var fd = new FormData();
            fd.append('file', file);
            var uuid = '';
            if ($stateParams.investorId) {
              uuid = $stateParams.investorId;
            } else if (localStorage.getItem('folioId')) {
              uuid = localStorage.getItem('folioId');
            } else {
              uuid = 'null';
            }
            InvestorFileUploadServiceV3.post2({
              child1: 'folio',
              child2: 'upload',
              child3: 'minor',
              child4: 'relationshipProof',
              child5: '01b48aa2-6a3e-4446-a4a6-eefe5d29537a'
            }, fd).$promise.then(success, error);
          }
          else {
            MessageService.error("File size should not be more than 2 MB.")
          }
        }

        function getOldFolioData() {

          var success = function (resp) {
            if (resp.status && resp.data) {
              _this.currentPayload = resp.data;
              _this.minorFormGuardianData.relation = resp.data.soleApplicantDetail.minorDetail.guardian.relation;
              _this.minorFormGuardianData.guardianrelationproofType = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProofType;
              _this.minorFormGuardianData.minorRelationshipProof = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
              _this.minorFormGuardianData.guardianrelationproofimageurl = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
              _this.soleApplicantEmail = resp.data.soleApplicantDetail.personalDetail.email;
              _this.soleApplicantMobile = resp.data.soleApplicantDetail.personalDetail.mobileNo;
              _this.holders.emailBelongsTo = resp.data.soleApplicantDetail.personalDetail.emailBelongsTo;
              _this.holders.mobileBelongsTo = resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo;
              _this.currentFolio = resp.data;
              _this.soleApplicantEmailCopy = resp.data.soleApplicantDetail.personalDetail.email;
              _this.soleApplicantMobileCopy = resp.data.soleApplicantDetail.personalDetail.mobileNo;
              if($rootScope.folioBasicDetail){
                $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
              }
              _this.holdeMode = _this.currentFolio.holdmode;
              try{
                const file = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
                const fileName = file.split("/");
                _this.minorFormGuardianData.guardianrelationproofimagename = fileName[fileName.length - 1];
              }catch(e){}
              _this.minorFormGuardianData.occupation = resp.data.soleApplicantDetail.minorDetail.guardian.occupation;
              _this.minorFormGuardianData.grossAnnualIncome = resp.data.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
              _this.minorFormGuardianData.Fatca.Countrie = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry;
              _this.minorFormGuardianData.Fatca.City = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace;
              _this.minorFormGuardianData.Fatca.addressType = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.addressType;
              _this.minorFormGuardianData.Fatca.taxPay1 = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1;

              if (resp.data.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia == true) {
                _this.minorFormGuardianData.fileTaxOtherIndian = 'No';
                _this.minorFormGuardianData.Fatca.taxPayIndian = true;
              } else {
                _this.minorFormGuardianData.fileTaxOtherIndian = 'Yes';
                _this.minorFormGuardianData.Fatca.taxPayIndian = false;
              }

              if(resp.data.soleApplicantDetail.minorDetail.guardian.politicalStatus){
                if (resp.data.soleApplicantDetail.minorDetail.guardian.politicalStatus == 'NONE') {
                  _this.minorFormGuardianData.userPEPStatusForGuardian = 'No';
                  _this.minorFormGuardianData.politicalStatus = "NONE";
                } else {
                  _this.minorFormGuardianData.userPEPStatusForGuardian = 'Yes';
                  _this.minorFormGuardianData.politicalStatus = "POLITICAL";
                }
              }else{
                _this.minorFormGuardianData.userPEPStatusForGuardian = 'No';
                _this.minorFormGuardianData.politicalStatus = "NONE";
              }
              if(resp.data.soleApplicantDetail.minorDetail.guardian.netWorth){
                _this.minorFormGuardianData.networth = resp.data.soleApplicantDetail.minorDetail.guardian.netWorth;
                _this.minorFormGuardianData.grossAnnualIncomeDate = resp.data.soleApplicantDetail.minorDetail.guardian.netWorthDate;
                _this.networth = true;
              }else{
                _this.networth = false;
              }


            } else { }
          }, error = function (error) {
            MessageService.error(error.message);
          };
          var investorId = localStorage.getItem("folioId");
          NewInvestorServiceV3.post({ child1: 'folio', child2: 'getDetails' }, { id: investorId }).$promise.then(success, error);
        }



        function submitMinorGuardianDetails() {
          _this.investorOccupations.forEach(function(occupations){
            if(occupations.occupationCode === _this.minorFormGuardianData.occupation){
              _this.occupation = occupations.occupationDescription;
            }
          });
          _this.countryName = _this.countries.find(function (country) {
            return country.countryCode === _this.minorFormGuardianData.Fatca.Countrie;
          }) || {};



          _this.incomeSlabList.forEach(function(income){
            if(income.incomeCode ==_this.minorFormGuardianData.grossAnnualIncome){
              _this.grossAnnualincomeGuardian = income.incomeDescription;
            }
          });

          _this.reviewData = angular.copy(scope.holders.fatcaArray);
          for (var i = 0 ; i < _this.reviewData.length; i ++) {
            _this.countries.forEach(function (countryDesc,index) {
              if(countryDesc.countryCode === _this.reviewData[i].taxPayingCountry){
                _this.reviewData[i].taxPayingCountry = countryDesc.countryName;
              }
            });
          }

          continueFolioForGuardian();
        }

        function submitFolioIncomeForm() {

          _this.taxStatusData.forEach(function (taxStatus,index) {
            if( taxStatus.taxStatusCode === _this.folioIncomeForm.taxstatus){
              _this.taxStatusName = taxStatus.taxStatusDescription;
            }
          });
          _this.investorOccupations.forEach(function(occupations){
            if(occupations.occupationCode === _this.folioIncomeForm.occupation){
              _this.occupation = occupations.occupationDescription;
            }
          });

          _this.incomeSlabList.forEach(function(income){
            if(income.incomeCode === _this.folioIncomeForm.annualincome){
              _this.grossAnnualincome = income.incomeDescription;
            }
          });

          _this.countryName = _this.countries.find(function (country) {
            return country.countryCode === _this.folioIncomeForm.Fatca.countrie;
          }) || {};

          _this.belongToListEmail.forEach(function(emailBelongTo){
            if(emailBelongTo.familyCode === _this.holders.emailBelongsTo){
              _this.belongToEmail = emailBelongTo.familyDescription;
            }
          });
          _this.belongToListMobile.forEach(function(mobileBelongTo){
            if(mobileBelongTo.familyCode === _this.holders.mobileBelongsTo){
              _this.belongToMobile = mobileBelongTo.familyDescription;
            }
          });

        }

        _this.formIsvalid = function () {
          _this.$emit('buttonEnable')
        }

        _this.formIsinvalid = function () {
          _this.$emit('buttonDisable')
        }

        function setSelectedResidency(payload) {
          if (payload.soleApplicantDetail.minorDetail &&
            payload.soleApplicantDetail.minorDetail.guardian && !payload.soleApplicantDetail.minorDetail.guardian.fatca) {
            payload.soleApplicantDetail.minorDetail.guardian.fatca = {};
          }
          var fatca = payload.soleApplicantDetail.minorDetail.guardian.fatca;

          delete fatca.fatcaTax1;
          delete fatca.fatcaTax2;
          delete fatca.fatcaTax3;

          if (payload.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia) {
            return;
          }

          if (angular.isDefined(scope.holders.fatcaArray[0])) {
            fatca.fatcaTax1 = scope.holders.fatcaArray[0];
          }

          if (angular.isDefined(scope.holders.fatcaArray[1])) {
            fatca.fatcaTax2 = scope.holders.fatcaArray[1];
          }

          if (angular.isDefined(scope.holders.fatcaArray[2])) {
            fatca.fatcaTax3 = scope.holders.fatcaArray[2];
          }
          _this.finalGuardianDetailPayload = payload;

        }

        function continueFolioForGuardian() {
          var payload = getGuardianPayload();
          payload.investmentBasketId = sessionStorage.getItem('journeyDraftId');
          LoaderService.showLoader();
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              localStorage.setItem('folioId', resp.data.id);
              var modelPayload = angular.copy(_this.dataPayload);
              if (modelPayload) {
                modelPayload.id = localStorage.getItem('folioId');
                modelPayload.folioSaveStep = "TWO";
              }
              InvestorFolioModel.setInvestorFolioModel(modelPayload);
              _this.editGuardianDetail = false;
              _this.payloadData.FOLIO_CREATION_STEP.guardian_details_completed = true;
              InvestmentModel.setPayload(_this.payloadData);
              // for showing edit button
              _this.stepperUpdatedInfo();
              _this.proceedAction();
              MessageService.success('Saved Successfully.');
            } else {
              MessageService.error(resp.message);
            }
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          if(scope.journey === 'ECART') {
            payload.ignoreDraftFolio = true;
            payload.newFolioCreationFlow = true;
            payload.cartFlow = true;
          }
          payload.singlePage = true;
          if (_this.isContactDetailUpdated && payload.soleApplicantDetail && payload.soleApplicantDetail.personalDetail)  {
            payload.soleApplicantDetail.personalDetail.email = _this.soleApplicantEmailCopy;
            payload.soleApplicantDetail.personalDetail.mobileNo = _this.soleApplicantMobileCopy;
            payload.soleApplicantDetail.personalDetail.isContactUpdated = _this.isContactDetailUpdated;
          } else {
            payload.soleApplicantDetail.personalDetail.email = _this.soleApplicantEmailCopy;
            payload.soleApplicantDetail.personalDetail.mobileNo = _this.soleApplicantMobileCopy;
          }

          payload.nriFlag = _this.minorFormGuardianData.nriFlag;

          if (!_this.firstFlow) {
            payload.firstFolio = false;
            payload.newUserFlow = false;
            InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);
          } else {
            payload.firstFolio = true;
            payload.newUserFlow = true;
            NewInvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, payload).$promise.then(success, error);
          }
        }


        function getGuardianPayload () {
          var a = scope.holders;
          var payload = {
            "holdmode":a.holdmode,
            "soleApplicantDetail": {
              "minorDetail": {
                "minorRelationshipProof": _this.minorFormGuardianData.guardianrelationproofimageurl,
                "minorRelationshipProofType": _this.minorFormGuardianData.guardianrelationproofType,
                "guardian": {
                  "panNumber": _this.token.investorPAN,
                  "occupation": _this.minorFormGuardianData.occupation,
                  "grossAnnualIncome": a.grossAnnualIncome,
                  "politicalStatus": _this.minorFormGuardianData.politicalStatus,
                  "kycVerified": null,
                  "relation": _this.minorFormGuardianData.relation,
                  "fatca": {
                    "birthCountry": _this.minorFormGuardianData.Fatca.Countrie,
                    "birthPlace": _this.minorFormGuardianData.Fatca.City,
                    "countryCitizenship": null,
                    "payTaxInIndia": scope.holders.payTaxInIndia,
                    "addressType": _this.minorFormGuardianData.Fatca.addressType,
                    "fatcaTax1": {
                      "taxPayingCountry": null,
                      "taxPayingCity": null,
                      "taxId": null,
                      "taxIdType": null
                    }
                  },
                  "guardianRelationshipProofUrl": null
                }
              },
              "personalDetail": {
                "kycEmail": _this.soleApplicantEmail,
                "kycMobileNo": _this.soleApplicantMobile,
                "emailBelongsTo" :_this.holders.emailBelongsTo,
                "mobileBelongsTo" :_this.holders.mobileBelongsTo
              },
              "selfDetail": null,
            }
          };
          if (_this.netWorthTabForGurdian) {
            payload.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome = "";
            payload.soleApplicantDetail.minorDetail.guardian.netWorth = _this.minorFormGuardianData.networth;
            if (_this.minorFormGuardianData.grossAnnualIncomeDate && _this.minorFormGuardianData.grossAnnualIncomeDate.match(/[a-zA-Z]/i)) {
              payload.soleApplicantDetail.minorDetail.guardian.netWorthDate = _this.minorFormGuardianData.grossAnnualIncomeDate;
            } else {
              if (_this.minorFormGuardianData.grossAnnualIncomeDate) {
                payload.soleApplicantDetail.minorDetail.guardian.netWorthDate = _this.datetwoTothree(_this.minorFormGuardianData.grossAnnualIncomeDate);
              }
            }
          } else {
            payload.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome = _this.minorFormGuardianData.grossAnnualIncome;
            payload.soleApplicantDetail.minorDetail.guardian.netWorth = '';
            payload.soleApplicantDetail.minorDetail.guardian.netWorthDate = "";
          }
          payload.holdmode = "SINGLE";
          payload.minor = true;
          payload.id = localStorage.getItem('folioId');
          payload.minorStep = "SECOND";
          payload.folioSaveStep = "TWO";
          payload.newUserFlow = true;
          setSelectedResidency(payload);
          payload.bankDetails = _this.prevBankDetails;
          return payload;
        }

        _this.datetwoTothree = function(date) {
          var dateChar = date.split("-");
          switch(dateChar[1]){
            case "01":
              _this.cdate = dateChar[0]+"-Jan-"+dateChar[2];
              return _this.cdate;
              break;
            case "02":
              _this.cdate = dateChar[0]+"-Feb-"+dateChar[2];
              return _this.cdate;
              break;
            case "03":
              _this.cdate = dateChar[0]+"-Mar-"+dateChar[2];
              return _this.cdate;
              break;
            case "04":
              _this.cdate = dateChar[0]+"-Apr-"+dateChar[2];
              return _this.cdate;
              break;
            case "05":
              _this.cdate = dateChar[0]+"-May-"+dateChar[2];
              return _this.cdate;
              break;
            case "06":
              _this.cdate = dateChar[0]+"-Jun-"+dateChar[2];
              return _this.cdate;
              break;
            case "07":
              _this.cdate = dateChar[0]+"-Jul-"+dateChar[2];
              return _this.cdate;
              break;
            case "08":
              _this.cdate = dateChar[0]+"-Aug-"+dateChar[2];
              return _this.cdate;
              break;
            case "09":
              _this.cdate = dateChar[0]+"-Sep-"+dateChar[2];
              return _this.cdate;
              break;
            case "10":
              _this.cdate = dateChar[0]+"-Oct-"+dateChar[2];
              return _this.cdate;
              break;
            case "11":
              _this.cdate = dateChar[0]+"-Nov-"+dateChar[2];
              return _this.cdate;
              break;
            case "12":
              _this.cdate = dateChar[0]+"-Dec-"+dateChar[2];
              return _this.cdate;
              break;
            default:
              return "wrong date.";
          }
        }

        function resetGuardianImage() {
          angular.element("#guardianrelationproofimage").val(null);
        }

        function netWorthChanges(value){
          if(value) {
            _this.minorFormGuardianData.networthComma = (parseInt(value.toString().replaceAll(",", "")) || '').toLocaleString('en-IN')
            _this.minorFormGuardianData.networth = parseInt(_this.minorFormGuardianData.networthComma.toString().replaceAll(",", ""));
          }else{
            _this.minorFormGuardianData.networth = '';
          }
        }

        function filterBelongToEmail(belongToCode) {
          var list = _this.belongToListEmail.filter(function(object) {
            return object.familyCode === belongToCode;
          });

          return list[0].familyDescription;
        }

        function filterBelongToMobile(belongToCode) {
          var list = _this.belongToListMobile.filter(function(object) {
            return object.familyCode === belongToCode;
          });

          return list[0].familyDescription;
        }

        function editContactDetails(contactInfo) {
          var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
          if (contactUpdateCo) {
            _this.isMobileEdited = contactUpdateCo.isMobileEdited;
            _this.isEmailEdited = contactUpdateCo.isEmailEdited;
          }
          if (contactInfo === "email") {
            if (_this.isMobileEdited) {
              MessageService.error("You can edit only one contact information at a time.");
              return;
            }
            _this.showEmailEditField = true;
            _this.showMobileEditField = false;
            if (_this.soleApplicantEmail) {
              _this.soleApplicantEditedEmail = _this.soleApplicantEmail;
            }
          } else if (contactInfo === 'mobile') {
            if (_this.isEmailEdited) {
              MessageService.error("You can edit only one contact information at a time.");
              return;
            }
            _this.showMobileEditField = true;
            _this.showEmailEditField = false;
            if (_this.soleApplicantMobile) {
              _this.soleApplicantEditedMobile = _this.soleApplicantMobile;
            }
          }
        }

        function cancelEditAction(contactInfo) {
          if (contactInfo === "email") {
            _this.showEmailEditField = false;
          } else if (contactInfo === 'mobile') {
            _this.showMobileEditField = false;
          }
        }

        function generateContactUpdateOtp(contactInfo) {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              showOtpModal(resp.data, contactInfo);
            } else {
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            MessageService.error(err);
            LoaderService.hideLoader();
          };
          var payload = {
            value: contactInfo === "email" ? _this.soleApplicantEditedEmail : _this.soleApplicantEditedMobile,
            fieldType: contactInfo.toUpperCase(),
            linkId: localStorage.getItem("folioId"),
            flowName : "STANDALONE_FOLIO_CREATION"
          };
          InvestorServiceV2.post({
            child1: 'contact',
            child2: 'update',
            child3: 'send',
            child4: 'otp'
          }, payload).$promise.then(success, error);
        }

        function showOtpModal(modalPayload, contactInfo) {
          var confirmSuccess = function () {
            _this.isContactDetailUpdated = true;
            if (contactInfo === "email") {
              _this.isEmailEdited = true;
              _this.showEmailEditField = false;
              _this.soleApplicantEmail = _this.soleApplicantEditedEmail;
            }
            if (contactInfo === "mobile") {
              _this.isMobileEdited = true;
              _this.showMobileEditField = false;
              _this.soleApplicantMobile = _this.soleApplicantEditedMobile;
            }
            sessionStorage.setItem('contactUpdateCo', JSON.stringify({
              isEmailEdited: _this.isEmailEdited,
              isMobileEdited: _this.isMobileEdited,
              soleApplicantEditedEmail: _this.soleApplicantEditedEmail,
              soleApplicantEditedMobile: _this.soleApplicantEditedMobile,
              isContactDetailUpdated: _this.isContactDetailUpdated
            }));
          }, confirmError = function () {
            _this.isContactDetailUpdated = false;
            _this.isEmailEdited = false;
            _this.isMobileEdited = false;
          };
          ModalService.contactOtpModal(modalPayload, confirmSuccess, confirmError);
        }

        function changeValue(contactInfo, val) {
          if (contactInfo === "email") {
            _this.soleApplicantEditedEmail = val;
          } else if (contactInfo === 'mobile') {
            _this.soleApplicantEditedMobile = val;
          }
        }



      }
    }
  }



})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('basicDetails', basicDetails);

  /*@ngInject*/
  function basicDetails($timeout, $state, LoaderService, UtilService, MessageService, InvestmentBasketService, AppConstants,
                        InvestorService, InvestorFileUploadServiceV3, InvestmentModel, $rootScope, InvestorServiceV3, InvestorFolioModel , NewInvestorServiceV3, ModalService, AuthService) {
    return {
      restrict: 'E',
      scope: {
        pan: '=',
        firstFlow: '=',
        stepperUpdatedInfo : '&',
        proceedAction : '&',
        selectedFolioData: '=',
        journey: '=',
        fromPreLogin: '=',
        retirement: '='
      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/folio/basic-details/basic-details.directive.html',
      link: function (scope,element, attrs) {
        var _this = scope;
        var removeListeners = {};
        _this.CONST_DATA = AppConstants;
        _this.CONST = AppConstants.ToastrMessage.VALIDATE_DATA;
        _this.dataPayload = InvestmentModel.getDataPayload();
        _this.folioBasicDetail = {};
        _this.folioBasicDetail.Fatca = {};
        _this.folioBasicDetail.folioForUser = 'Self';
        _this.folioBasicDetail.folioHoldingMode = "SINGLE";
        _this.folioBasicDetail.fileTaxOtherIndian = 'No';
        _this.folioBasicDetail.Fatca.fatcaTax1 = {}
        _this.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry = '';
        _this.folioBasicDetail.Fatca.fatcaTax1.taxIdType = '';
        _this.folioBasicDetail.Fatca.fatcaTax1.taxPayingCity = '';
        _this.folioBasicDetail.Fatca.fatcaTax1.taxId = '';
        _this.myState = $state.current.url;
        // _this.setUsetInfo();
        _this.folioBasicDetail.userPEPStatus = 'No';
        _this.folioBasicDetail.politicalStatus = 'NONE';
        _this.folioBasicDetail.Fatca.taxPayIndia = true;
        _this.folioBasicDetail.Fatca.Countrie = '';
        _this.folioBasicDetail.Fatca.City = '';
        _this.folioBasicDetail.Fatca.addressType = '';
        _this.investorOccupations = [];
        _this.incomeSlabList = [];
        _this.countries = [];
        _this.addressType = [];
        _this.chooseFolioFor = chooseFolioFor;
        _this.getholdingmode = getholdingmode;
        _this.getTaxFileStatus = getTaxFileStatus;
        _this.getOccupations = getOccupations;
        _this.getTaxStatus = getTaxStatus;
        _this.getIncomeSlab = getIncomeSlab;
        _this.getCountry = getCountry;
        _this.getAddressType = getAddressType;
        _this.getTaxIdType = getTaxIdType;
        _this.getPEPStatus = getPEPStatus;
        _this.unsavedDataModal = unsavedDataModal;
        _this.resetAgeProof = resetAgeProof;

        //Start for Minor
        scope.holders={};
        scope.holders.payTaxInIndia = true;
        scope.holders.fatcaArray = [];

        _this.pattern = AppConstants;
        _this.folioBasicMinorDetail = {}
        _this.folioBasicMinorDetail.Fatca = {};
        _this.folioBasicMinorDetail.folioForUser = 'Minor';
        _this.minorFormData = {}
        _this.viewMode = "days";
        _this.dateErrorMessage = "";
        // _this.setUsetInfo();
        _this.minorFormData.minorsFullName = '';
        _this.myState = $state.current.url;
        _this.minorFormData.dob = '';
        _this.minorFormData.gender = '';
        _this.minorFormData.ageproofType = '';
        _this.minorFormData.ageproofimageurl = '';
        _this.minorFormData.ageproofimageName = '';
        _this.minorFormData.taxstatus = '02';
        _this.genderObj = [{ name: 'Male', value: 'MALE' }, { name: 'Female', value: 'FEMALE' }];
        _this.taxStatus = [];
        _this.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
        // _this.folioBasicDetail.folioForUser = _this.folioBasicMinorDetail.folioForUser = 'Minor';
        _this.getTaxStatusForMinor = getTaxStatusForMinor;
        _this.getMinordob = getMinordob;
        _this.getProofType = getProofType;
        _this.getMinorAgeProofImage = getMinorAgeProofImage;
        _this.autoDate = autoDate;

        _this.submitFolioBasicDetails = submitFolioBasicDetails;
        _this.continueFolioForMinor = continueFolioForMinor;
        _this.changePayTaxOutsideIndiaStatus = changePayTaxOutsideIndiaStatus;
        _this.folioSelectionData = folioSelectionData;
        _this.addAvailableResidency = addAvailableResidency;
        _this.proofTypeDTOList = [];
        var token = AuthService.getToken()
        _this.nriFlag = token.nriFlag;

        _this.editBasicDetail = true;
        // listening to edit button click

        removeListeners['enableEditBasicDetails'] = _this.$on("enableEditBasicDetails", function() {
          _this.editBasicDetail = true;
          if (_this.selectedFolioData) {
            if (!_this.selectedFolioData.minor) {
              _this.selectedFolioData.soleApplicantDetail.selfDetail.politicalStatus = _this.folioBasicDetail.politicalStatus;
              _this.selectedFolioData.soleApplicantDetail.selfDetail.fatca.payTaxInIndia = scope.holders.payTaxInIndia;
              _this.selectedFolioData.soleApplicantDetail.selfDetail.fatca = scope.holders.fatcaArray;
              _this.selectedFolioData.holdmode = _this.folioBasicDetail.folioHoldingMode;
            }else{
              _this.selectedFolioData.soleApplicantDetail.personalDetail.firstName = _this.minorFormData.minorsFullName;
              _this.selectedFolioData.soleApplicantDetail.personalDetail.dateOfBirth = _this.minorFormData.dob;
              _this.minorFormData.minorDob = _this.minorFormData.dob;
              _this.selectedFolioData.soleApplicantDetail.personalDetail.gender = _this.minorFormData.gender;
              _this.selectedFolioData.soleApplicantDetail.minorDetail.minorProofType = _this.minorFormData.ageproofType;
              _this.selectedFolioData.soleApplicantDetail.minorDetail.minorAgeProof = _this.minorFormData.ageproofimageurl;
            }
          }
          getPayload();
          _this.payloadData = InvestmentModel.getPayload();
        });

        _this.payloadData = InvestmentModel.getPayload();

        // removeListeners['continueButtonBasicDetails'] = _this.$on("continueButtonBasicDetails", function(event) {
        //   _this.submitFolioBasicDetails();
        // });

        _this.init = init;

        init();

        function init() {
          _this.cgfFlag = sessionStorage.getItem('cgfFlagFromGoalJourney');
          _this.onlyIndividualSelection = sessionStorage.getItem('onlyIndividualFolioCreation');
          if(_this.cgfFlag == 'true'){
            _this.chooseFolioFor('Minor');
          }
          if(_this.onlyIndividualSelection == 'true'){
            _this.chooseFolioFor('Self');
          }
          if (localStorage.getItem('folioId') && localStorage.getItem('folioId') !== 'undefined') {
            getPayload();
          }
          getOccupations();
          getTaxStatus();
          getIncomeSlab();
          getCountry();
          getAddressType();
          getTaxIdType();

          //For Minor
          getTaxStatusForMinor();
          getProofType();
          folioSelectionData();
        }


        function folioSelectionData(){
          if(_this.selectedFolioData) {
            if (!_this.selectedFolioData.minor) {
              // _this.chooseFolioFor('Self');
              _this.folioBasicDetail.folioForUser = 'Self';
              _this.folioBasicDetail.politicalStatus = _this.selectedFolioData.soleApplicantDetail.selfDetail.politicalStatus;
              scope.holders.payTaxInIndia = _this.selectedFolioData.soleApplicantDetail.selfDetail.fatca.payTaxInIndia;
              _this.pepStatusValue = _this.folioBasicDetail.politicalStatus == 'POLITICAL' ? 'Yes' : _this.folioBasicDetail.politicalStatus == 'POLITICALLY_RELATED' ? 'Related' : 'No';
              getPEPStatus(_this.pepStatusValue);
              if (!scope.holders.payTaxInIndia) {
                addAvailableResidency(_this.selectedFolioData.soleApplicantDetail.selfDetail.fatca)
              }
              _this.folioBasicDetail.folioHoldingMode = _this.selectedFolioData.holdmode ? _this.selectedFolioData.holdmode : 'SINGLE';
            }else{
              // _this.chooseFolioFor('Minor');
              _this.folioBasicDetail.folioForUser = 'Minor';
              _this.minorFormData.minorsFullName = _this.selectedFolioData.soleApplicantDetail.personalDetail.firstName;
              _this.minorFormData.dob = _this.selectedFolioData.soleApplicantDetail.personalDetail.dateOfBirth;
              _this.minorFormData.minorDob = _this.minorFormData.dob;
              _this.minorFormData.gender = _this.selectedFolioData.soleApplicantDetail.personalDetail.gender;
              _this.minorFormData.ageproofType = _this.selectedFolioData.soleApplicantDetail.minorDetail.minorProofType;
              _this.minorFormData.ageproofimageurl = _this.selectedFolioData.soleApplicantDetail.minorDetail.minorAgeProof;
              if(_this.minorFormData.ageproofimageurl){
                var file = _this.minorFormData.ageproofimageurl;
                var fileName = file.split("/");
                _this.minorFormData.ageproofimageName = fileName[fileName.length - 1];
              }
            }
            _this.folioForChanged = true;
            _this.$emit('updateHoldMode', {
              data: _this.folioBasicDetail
            });
            _this.payloadData = InvestmentModel.getPayload();
          }
        }
        function addAvailableResidency(fatca) {
          scope.holders.fatcaArray = [];
          if (fatca.fatcaTax1 && Object.keys(fatca.fatcaTax1).length) {
            scope.holders.fatcaArray.push(fatca.fatcaTax1);
          }
          if (fatca.fatcaTax2 && Object.keys(fatca.fatcaTax2).length) {
            scope.holders.fatcaArray.push(fatca.fatcaTax2);
          }
          if (fatca.fatcaTax3 && Object.keys(fatca.fatcaTax3).length) {
            scope.holders.fatcaArray.push(fatca.fatcaTax3);
          }
          if(scope.holders.payTaxInIndia == false && scope.holders.fatcaArray.length ===0){
            scope.holders.fatcaArray.push({});
          }
        }

        scope.addNewResidencyFields = function () {
          if(angular.isUndefined(scope.holders.fatcaArray) || !angular.isArray(scope.holders.fatcaArray) ){
            scope.holders.fatcaArray = [];
          }
          scope.holders.fatcaArray.push(
            {
              "taxPayingCountry": '',
              "taxPayingCity": '',
              "taxIdType": '',
              "taxId": ''
            });
        };

        scope.deleteTaxResidency = function (index) {
          scope.holders.fatcaArray.splice(index, 1);
        }
        scope.addMoreTaxResidency = function () {
          var array = scope.holders.fatcaArray || [];
          array.length < 4 ? array.push({}) : '';

        }
        function changePayTaxOutsideIndiaStatus(status) {
          if (!status) {
            return;
          }
          if (_this.folioBasicDetail.folioForUser === 'Minor') {
            if (scope.holders && (angular.isUndefined(scope.holders.fatcaArray)||scope.holders.fatcaArray.length === 0)) {
              scope.addNewResidencyFields();
            }
          }
          else {
            if (angular.isUndefined(scope.holders.fatcaArray) || scope.holders.fatcaArray.length === 0) {
              scope.addMoreTaxResidency();
            }
          }
        };

        function getPayload() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              _this.dataPayload = resp.data;
              _this.dataPayload.id = localStorage.getItem('folioId');
              if(resp.data.soleApplicantDetail.selfDetail == null){
                _this.dataPayload.soleApplicantDetail.selfDetail = {
                  address: {},
                  fatca: {}
                };
              }
              if(!_this.selectedFolioData) {
                if (!_this.dataPayload.minor) {
                  // _this.chooseFolioFor('Self');
                  _this.folioBasicDetail.folioForUser = 'Self';
                  _this.folioBasicDetail.politicalStatus = _this.dataPayload.soleApplicantDetail.selfDetail.politicalStatus;
                  scope.holders.payTaxInIndia = _this.dataPayload.soleApplicantDetail.selfDetail.fatca.payTaxInIndia;
                  if (!scope.holders.payTaxInIndia) {
                    addAvailableResidency(_this.dataPayload.soleApplicantDetail.selfDetail.fatca)
                  }
                  _this.folioBasicDetail.folioHoldingMode = _this.dataPayload.holdmode ? _this.dataPayload.holdmode : 'SINGLE';
                } else {
                  // _this.chooseFolioFor('Minor');
                  _this.folioBasicDetail.folioForUser = 'Minor';
                  _this.minorFormData.minorsFullName = _this.dataPayload.soleApplicantDetail.personalDetail.firstName;
                  _this.minorFormData.dob = _this.dataPayload.soleApplicantDetail.personalDetail.dateOfBirth;
                  _this.minorFormData.minorDob = _this.minorFormData.dob;
                  _this.minorFormData.gender = _this.dataPayload.soleApplicantDetail.personalDetail.gender;
                  _this.minorFormData.ageproofType = _this.dataPayload.soleApplicantDetail.minorDetail.minorProofType;
                  _this.minorFormData.ageproofimageurl = _this.dataPayload.soleApplicantDetail.minorDetail.minorAgeProof;
                  getPEPStatus(_this.dataPayload.soleApplicantDetail.selfDetail.politicalStatus);
                  if (_this.minorFormData.ageproofimageurl) {
                    var file = _this.minorFormData.ageproofimageurl;
                    var fileName = file.split("/");
                    _this.minorFormData.ageproofimageName = fileName[fileName.length - 1];
                  }
                }
                _this.folioForChanged = true;
                _this.$emit('updateHoldMode', {
                  data: _this.folioBasicDetail
                });
                _this.payloadData = InvestmentModel.getPayload();
              }
            } else {
              MessageService.error(resp.message);
              LoaderService.hideLoader();
            }
          },
          error = function () {
            LoaderService.hideLoader();
            localStorage.removeItem('folioId');
          };
          var investorId = localStorage.getItem('folioId');
          InvestorServiceV3.post({
            child1: 'folio',
            child2: 'getDetails'
          }, {id:investorId}).$promise.then(success, error);
        }

        function chooseFolioFor(foliofor) {
          if (foliofor === 'Minor' && (_this.retirement || _this.nriFlag)) {
            ModalService.genericModal({
              text: _this.CONST_DATA.MINOR_FOLIO_WARNING
            }, function() {
              foliofor = 'Self';
              _this.folioBasicDetail.folioForUser = 'Self';
            });
            return;
          }

          if (foliofor == 'Self') {
            _this.folioBasicDetail.folioForUser = 'Self';
            sessionStorage.setItem('isMinorFolioSelected', 'false');
            if(_this.onlyIndividualSelection !== 'true') {
              if (_this.minorFormData.minorsFullName || _this.minorFormData.dob || _this.minorFormData.gender || _this.minorFormData.ageproofimageurl) {
                unsavedDataModal();
              }
            }
          }
          else {
            _this.folioBasicDetail.folioForUser = 'Minor';
            sessionStorage.setItem('isMinorFolioSelected', 'true');
            // initiatFirstFolio();
          }

          _this.folioForChanged = true;

          _this.$emit('updateHoldMode', {
            data: _this.folioBasicDetail,
            forFolioChanged : true,
            forHoldingChanged : false
          });

          _this.payloadData = InvestmentModel.getPayload();

        }

        function unsavedDataModal(){
          var success = function (folioFor) {
            _this.folioBasicDetail.folioForUser = 'Self';
            _this.deleteCurrentFolio();
            _this.minorFormData.minorsFullName = '';
            _this.minorFormData.dob = '';
            _this.minorFormData.gender = '';
            _this.minorFormData.ageproofType = '';
            _this.minorFormData.ageproofimageurl = '';
            _this.minorFormData.ageproofimageName = '';
            _this.MINOR_DOB_ERROR = false;

          }, error = function (folioFor) {
            _this.folioBasicDetail.folioForUser = 'Minor';
            _this.folioBasicDetail.politicalStatus = 'NONE';
            scope.holders.payTaxInIndia = true;
            scope.holders.fatcaArray = [];
            _this.folioBasicDetail.folioHoldingMode = 'SINGLE';

          };
          ModalService.unsavedChangesModal({}, success, error)
        }

        _this.deleteCurrentFolio =  function () {
          LoaderService.showLoader();
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status) {
                MessageService.success("Successfully delete folio draft data.");
                localStorage.removeItem("folioId");
                _this.dataPayload = InvestmentModel.getDataPayload();
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
            };
          var uuid = localStorage.getItem('folioId');

          if (uuid) {
            if (!_this.firstFlow) {
              InvestorServiceV3.post({ child1: 'folio', child2: 'draftFolio', child3: 'delete' }, { id: uuid }).$promise.then(success, error);
            } else {
              NewInvestorServiceV3.post({ child1: 'folio', child2: 'draftFolio', child3: 'delete' }, { id: uuid }).$promise.then(success, error);
            }
          }
          LoaderService.hideLoader();
        }

          function initiatFirstFolio()  {
          var success = function (resp) {
              if (resp.status && resp.data) {
                localStorage.setItem("folioId", resp.data.id);
                if (localStorage.getItem('folioId') && localStorage.getItem('folioId') !== 'undefined') {
                  getPayload();
                }
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (error) {
              MessageService.error(error.message);
            };
          // NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, _this.payloadDataInitial).$promise.then(success, error);

          // setting nri flag for api call
            _this.payloadDataInitial.nriFlag = _this.nriFlag;
            if (!_this.firstFlow) {
              _this.payloadDataInitial.firstFolio = false;
              _this.payloadDataInitial.newUserFlow = false;
              InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, _this.payloadDataInitial).$promise.then(success, error);
            } else {
              _this.payloadDataInitial.firstFolio = true;
              _this.payloadDataInitial.newUserFlow = true;
              NewInvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, _this.payloadDataInitial).$promise.then(success, error);
            }
        }

        function getholdingmode(value){
          if (value == 'SINGLE') {
            _this.folioBasicDetail.folioHoldingMode = 'SINGLE';
            sessionStorage.setItem('ModeOfHold', _this.folioBasicDetail.folioHoldingMode);
            localStorage.setItem('holdmode', _this.folioBasicDetail.folioHoldingMode);
          }
          else {
            _this.folioBasicDetail.folioHoldingMode = 'ANY_OR_SURVIVOR';
            sessionStorage.setItem('ModeOfHold', _this.folioBasicDetail.folioHoldingMode);
            localStorage.setItem('holdmode', _this.folioBasicDetail.folioHoldingMode);
          }

          _this.$emit('updateHoldMode', {
            data: _this.folioBasicDetail,
            forFolioChanged : false,
            forHoldingChanged : true
          });
        }

        function getTaxFileStatus (value) {
          if (value == 'Yes') {
            _this.folioBasicDetail.fileTaxOtherIndian = 'Yes';
            _this.folioBasicDetail.Fatca.taxPayIndia = false;
          } else {
            _this.folioBasicDetail.fileTaxOtherIndian = 'No';
            _this.folioBasicDetail.Fatca.taxPayIndia = true;
          }
        }


        function getOccupations() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.investorOccupations = resp.data.investorOccupations;
              } else {
                _this.investorOccupations = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in occupation list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'occupation' }).$promise.then(success, error);
        }

        // Tax status
        function getTaxStatus() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.taxStatusData = resp.data.taxStatus;
              } else {
                _this.taxStatusData = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in tax status!");
            };
          var data = { taxStatusFilter: 'ADULT' }
          InvestorService.post({ child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
        }

        //Tax status for minor
        function getTaxStatusForMinor () {
          var success = function (resp) {
              _this.taxStatus = resp.data.taxStatus;
            },
            error = function () {
              MessageService.error("Error in minor tax status!");
            };
          var data = { taxStatusFilter: 'MINOR' }
          InvestorService.post({ child1: 'folio', child2: 'tax-status', }, data).$promise.then(success, error);
        }
        // Income
        function getIncomeSlab() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.incomeSlabList = resp.data.incomeSlabList;
              } else {
                _this.incomeSlabList = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in income slab list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'income-slab' }).$promise.then(success, error);
        }
        // Country
        function getCountry() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.countries = resp.data.countries;
              } else {
                _this.countries = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in country list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'country-list' }, null).$promise.then(success, error);
        }
        // AddressTYpe
        function getAddressType() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.addressType = resp.data.addressTypeResponses;
              } else {
                _this.addressType = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in address type list!");
            };
          InvestorService.post({ child1: 'folio', child2: 'address-type' }, null).$promise.then(success);
        }
        // Tax Id Type
        function getTaxIdType() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.taxIdType = resp.data.taxIdTypeResponses;
              } else {
                _this.taxIdType = null;
                MessageService.error(resp.message);
              }
            },
            error = function () {
              // MessageService.error("Error in tax id type list!");
            };
          InvestorService.post({ child1: 'folio', child2: 'taxId-type' }, null).$promise.then(success);
        }

        function getPEPStatus (value) {
          if (value == 'Yes') {
            _this.folioBasicDetail.userPEPStatus = 'Yes';
            _this.folioBasicDetail.politicalStatus = 'POLITICAL';
          } else if(value == 'Related'){
            _this.folioBasicDetail.userPEPStatus = 'Related';
            _this.folioBasicDetail.politicalStatus = 'POLITICALLY_RELATED';
          }else {
            _this.folioBasicDetail.userPEPStatus = 'No';
            _this.folioBasicDetail.politicalStatus = 'NONE';
          }
        }


        function getMinordob (date) {
          _this.MINOR_DOB_ERROR = false;
          if (angular.isDefined(date._i) ||
            /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
            _this.minorFormData.dob = moment(date).format("DD-MMM-YYYY");
            _this.minorFormData.minorDob = _this.minorFormData.dob;
            _this.dobmilisecond = moment(date).valueOf();
            _this.age = (moment(new Date()).valueOf() - _this.dobmilisecond) / 31556952000;
            if (_this.age < 18) {
              _this.MINOR_DOB_ERROR = false;
              if (_this.folioSelfSingleBasicForm.$valid) {
                _this.formIsvalid();
              }
            }
            else {
              _this.MINOR_DOB_ERROR = true;
              _this.formIsinvalid();
            }
            if (!date) {
              _this.dateErrorMessage = _this.CONST.DOB_FIELD;
            } else _this.dateErrorMessage = '';

          } else {
            _this.dateErrorMessage = _this.CONST.DOB_FIELD;
            _this.minorFormData.minorDob = "";
          }
          return;
        }

        function getProofType () {
          var success = function (resp) {
              _this.minorAgeProofType = resp.data.proofTypeDTOList;
            },
            error = function () {
              _this.minorAgeProofType = _this.proofTypeDTOList;
              MessageService.error("Error in proof type list!");
            };
          InvestorService.get({ child1: 'folio', child2: 'proof', child3: 'type' }, null).$promise.then(success, error);
        }

        function getMinorAgeProofImage  (file) {
          var fi = document.getElementById('minorageproofimage');
          if (_this.mimeType.indexOf(file.type) === -1) {
            MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
            return;
          }
          if (fi.files.item(0).size < 2000000) {
            _this.minorFormData.ageproofimageName = file.name;
            var success = function (resp) {
                if (resp.status && resp.data) {
                  _this.minorFormData.ageproofimageurl = resp.data.fileUrl;
                  try{
                    const file = resp.data.fileUrl;
                    const fileName = file.split("/");
                    _this.minorFormData.ageproofimageName = fileName[fileName.length - 1];
                  }catch(e){}
                  localStorage.setItem('folioIdForProof', resp.data.uuid);
                }
                else {
                  MessageService.error(resp.message);
                }
              },
              error = function (e) {
                MessageService.error("file not upload");
              };
            var fd = new FormData();
            fd.append('file', file);
            var uuid = localStorage.getItem('folioId');
            InvestorFileUploadServiceV3.post2({ child1: 'folio', child2: 'upload', child3: 'minor', child4: 'ageProof', child5: "7b7ffc44-70ea-4f93-acc1-ebafc1e934e6" }, fd).$promise.then(success, error);
          }
          else {
            MessageService.error("File size should not be more than 2 MB.")
          }
        }

        function autoDate (){
          var oldlength = 0 ;
          if(_this.dobString){
            oldlength = _this.dobString.length;
          }
          _this.dobString = $("#dobId").val();
          var newlength = _this.dobString.length;
          if( _this.dobString.length == 2){
            if((newlength== (oldlength - 1)) || (newlength == oldlength)){
            } else{
              $("#dobId").val(_this.dobString+"-");
            }
          }
          if( _this.dobString.length == 5){
            if((newlength== (oldlength - 1)) || (newlength == oldlength)){
            } else{
              $("#dobId").val(_this.dobString+"-");
            }
          }
        }
        function submitFolioBasicDetails(){
          _this.countryName = _this.countries.find(function (country) {
            return country.countryCode === _this.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry;
          }) || {};

           _this.taxIdType.forEach(function (taxId,index) {
            if( taxId.value === _this.folioBasicDetail.Fatca.fatcaTax1.taxIdType){
              _this.taxIdTypeName = taxId.description;
            }
          });
          _this.taxName = _this.taxStatus.find(function (taxStatus) {
            return taxStatus.countryCode === _this.minorFormData.taxstatus;
          }) || {};

          _this.taxStatus.forEach(function (taxStatus,index) {
            if( taxStatus.taxStatusCode === _this.minorFormData.taxstatus){
              _this.taxStatusName = taxStatus.taxStatusDescription;
            }
          });

          _this.reviewData = angular.copy(scope.holders.fatcaArray);
          for (var i = 0 ; i < _this.reviewData.length ; i ++) {
            _this.countries.forEach(function (countryDesc,index) {
              if(countryDesc.countryCode === _this.reviewData[i].taxPayingCountry){
                _this.reviewData[i].taxPayingCountry = countryDesc.countryName;
              }
            });
          }

          if( _this.folioBasicDetail.folioForUser === 'Self') {
            continueFolio();
          }else{
            continueFolioForMinor();
          }
        }

        _this.formIsvalid = function () {
          _this.$emit('buttonEnable')
        }

        _this.formIsinvalid = function () {
          _this.$emit('buttonDisable')
        }

        function setSelectedResidencySelf(payload) {
          if (payload.soleApplicantDetail.selfDetail
            && !payload.soleApplicantDetail.selfDetail.fatca) {
            payload.soleApplicantDetail.selfDetail.fatca = {};
          }
          var fatca = payload.soleApplicantDetail.selfDetail.fatca;

          delete fatca.fatcaTax1;
          delete fatca.fatcaTax2;
          delete fatca.fatcaTax3;

          if (payload.soleApplicantDetail.selfDetail.fatca.payTaxInIndia) {
            return;
          }

          if (angular.isDefined(scope.holders.fatcaArray[0])) {
            fatca.fatcaTax1 = scope.holders.fatcaArray[0];
          }

          if (angular.isDefined(scope.holders.fatcaArray[1])) {
            fatca.fatcaTax2 = scope.holders.fatcaArray[1];
          }

          if (angular.isDefined(scope.holders.fatcaArray[2])) {
            fatca.fatcaTax3 = scope.holders.fatcaArray[2];
          }
          _this.dataPayload = payload;
        }


        function continueFolio() {
          LoaderService.showLoader();
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              if (resp.data.folioDataInvalid) {
                ModalService.genericModal({
                  text: resp.data.message
                }, function() {
                  if (!scope.fromPreLogin) {
                    if (scope.journey === "GOAL_JOURNEY") {
                      sessionStorage.removeItem('investNowBackParams');
                      $state.go('main.investment.goals');
                    } else if (scope.journey === "INVESTMENT_BASKET_JOURNEY") {
                      $state.go('main.investment.basket');
                    } else if (scope.journey === "PERSONALITY") {
                      $state.go('main.investment.personality');
                    }
                  } else {
                    sessionStorage.clear();
                    $state.go('login');
                  }
                }, function() {
                  $state.go('welcome');
                });
                return;
              }
              localStorage.setItem('folioId', resp.data.id);

              var modelPayload = angular.copy(_this.dataPayload);

              if (modelPayload) {
                modelPayload.id = localStorage.getItem('folioId');
                modelPayload.folioSaveStep = "TWO";
              }
              InvestorFolioModel.setInvestorFolioModel(modelPayload);
              var id = localStorage.getItem('folioId');
              _this.editBasicDetail = false;
              _this.payloadData.FOLIO_CREATION_STEP.basic_details_completed = true;

              InvestmentModel.setPayload(_this.payloadData);

              // for showing edit button
              scope.stepperUpdatedInfo();
              _this.proceedAction();
              MessageService.success('Saved Successfully.');
            } else {
              MessageService.error(resp.message);
            }
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          var taxIdentifierNumber = _this.pan;
          _this.dataPayload.holdmode = _this.folioBasicDetail.folioHoldingMode;
          if (_this.dataPayload.holdmode === 'SINGLE') {
            delete _this.dataPayload.jointHolders;
          }
          // _this.dataPayload.folioSaveStep = "ONE";
          _this.dataPayload.minor = false;
          _this.dataPayload.soleApplicantDetail.selfDetail.panNumber = taxIdentifierNumber;
          _this.dataPayload.soleApplicantDetail.selfDetail.politicalStatus = _this.folioBasicDetail.politicalStatus;
          _this.dataPayload.soleApplicantDetail.selfDetail.fatca.payTaxInIndia = scope.holders.payTaxInIndia;
          _this.dataPayload.investmentBasketId = sessionStorage.getItem('journeyDraftId');
          _this.dataPayload.singlePage = true;
          if(scope.journey === 'ECART') {
            _this.dataPayload.ignoreDraftFolio = true;
            _this.dataPayload.newFolioCreationFlow = true;
            _this.dataPayload.cartFlow = true;
          }

          if (_this.folioForChanged) {
            _this.dataPayload.folioSaveStep = "ONE";
            _this.folioForChanged = false;
          }

          _this.dataPayload.folioSaveStep = "ONE"

          setSelectedResidencySelf(_this.dataPayload);
          if (_this.selectedFolioData) {
            _this.dataPayload.soleApplicantDetail.personalDetail.email = _this.selectedFolioData.soleApplicantDetail.personalDetail.email;
            _this.dataPayload.soleApplicantDetail.personalDetail.mobileNo = _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileNo;
            _this.dataPayload.folioNumber = sessionStorage.getItem('folioSelected');
          } else {
            _this.dataPayload.soleApplicantDetail.personalDetail.email = null;
            _this.dataPayload.soleApplicantDetail.personalDetail.mobileNo = null;
          }

          // setting nri flag for api call
          _this.dataPayload.nriFlag = _this.nriFlag;

          if (!_this.firstFlow) {
            _this.dataPayload.firstFolio = false;
            _this.dataPayload.newUserFlow = false;
            InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, _this.dataPayload).$promise.then(success, error);
          } else {
            _this.dataPayload.firstFolio = true;
            _this.dataPayload.newUserFlow = true;
            NewInvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, _this.dataPayload).$promise.then(success, error);
          }
        }


        function continueFolioForMinor() {
          LoaderService.showLoader();
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              if (resp.data.folioDataInvalid) {
                ModalService.genericModal({
                  text: resp.data.message
                }, function() {
                  if (!scope.fromPreLogin) {
                    if (scope.journey === "GOAL_JOURNEY") {
                      sessionStorage.removeItem('investNowBackParams');
                      $state.go('main.investment.goals');
                    } else if (scope.journey === "INVESTMENT_BASKET_JOURNEY") {
                      $state.go('main.investment.basket');
                    } else if (scope.journey === "PERSONALITY") {
                      $state.go('main.investment.personality');
                    }
                  } else {
                    sessionStorage.clear();
                    $state.go('login');
                  }
                }, function() {
                  $state.go('welcome');
                });
                return;
              }
              localStorage.setItem('folioId', resp.data.id);
              var modelPayload = angular.copy(_this.dataPayload);
              if (modelPayload) {
                modelPayload.id = localStorage.getItem('folioId');
                modelPayload.folioSaveStep = "TWO";
              }
              InvestorFolioModel.setInvestorFolioModel(modelPayload);
              _this.editBasicDetail = false;
              _this.payloadData.FOLIO_CREATION_STEP.basic_details_completed = true;

              InvestmentModel.setPayload(_this.payloadData);

              // for showing edit button
              scope.stepperUpdatedInfo();
              _this.proceedAction();
              MessageService.success('Saved Successfully.');
            } else {
              MessageService.error(resp.message);
            }
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };
          var taxIdentifierNumber = _this.pan;

          var bankDetails = _this.dataPayload.bankDetails;

          if (!_this.dataPayload.soleApplicantDetail.minorDetail) {
            _this.dataPayload = InvestmentModel.getDataPayload();
          }

          _this.dataPayload.bankDetails = bankDetails;

          if (localStorage.getItem('folioId')) {
            _this.dataPayload.id = localStorage.getItem('folioId');
          } else {
            if (_this.dataPayload.id) {
              delete _this.dataPayload.id;
            }
          }

          _this.dataPayload.holdmode = _this.folioBasicDetail.folioHoldingMode;
          _this.dataPayload.soleApplicantDetail.minorDetail.guardian.panNumber = taxIdentifierNumber;
          _this.dataPayload.minor = true;
          _this.dataPayload.soleApplicantDetail.minorDetail.minorAgeProof = _this.minorFormData.ageproofimageurl;
          _this.dataPayload.soleApplicantDetail.minorDetail.minorProofType = _this.minorFormData.ageproofType;
          _this.dataPayload.soleApplicantDetail.personalDetail.firstName = _this.minorFormData.minorsFullName;
          _this.dataPayload.soleApplicantDetail.personalDetail.dateOfBirth = _this.minorFormData.dob;
          _this.dataPayload.soleApplicantDetail.personalDetail.gender = _this.minorFormData.gender;
          _this.dataPayload.soleApplicantDetail.personalDetail.taxStatusCode = _this.minorFormData.taxstatus;
          _this.dataPayload.folioSaveStep = 'ONE';
          _this.dataPayload.investmentBasketId = sessionStorage.getItem('journeyDraftId');
          _this.dataPayload.singlePage = true;
          _this.dataPayload.holdmode = 'SINGLE';
          if(scope.journey === 'ECART') {
            _this.dataPayload.ignoreDraftFolio = true;
            _this.dataPayload.newFolioCreationFlow = true;
            _this.dataPayload.cartFlow = true;
          }
          if (_this.selectedFolioData) {
            _this.dataPayload.soleApplicantDetail.personalDetail.email = _this.selectedFolioData.soleApplicantDetail.personalDetail.email;
            _this.dataPayload.soleApplicantDetail.personalDetail.mobileNo = _this.selectedFolioData.soleApplicantDetail.personalDetail.mobileNo;
            _this.dataPayload.folioNumber = sessionStorage.getItem('folioSelected');
          } else {
            _this.dataPayload.soleApplicantDetail.personalDetail.email = null;
            _this.dataPayload.soleApplicantDetail.personalDetail.mobileNo = null;
          }
          // setting nri flag for api call
          _this.dataPayload.nriFlag = _this.nriFlag;

          if (!_this.firstFlow) {
            _this.dataPayload.firstFolio = false;
            _this.dataPayload.newUserFlow = false;
            InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, _this.dataPayload).$promise.then(success, error);
          } else {
            _this.dataPayload.firstFolio = true;
            _this.dataPayload.newUserFlow = true;
            NewInvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, _this.dataPayload).$promise.then(success, error);
          }
        }

        _this.payloadDataInitial = {
          soleApplicantDetail: {
            minorDetail: {
              minorAgeProof: null,
              minorRelationshipProof: null,
              guardian: {
                panNumber: null,
                occupation: null,
                taxStatusCode: null,
                grossAnnualIncome: null,
                politicalStatus: null,
                netWorth: null,
                netWorthDate: null,
                kycVerified: null,
                name: null,
                gender: null,
                panValid: null,
                relation: null,
                fatca: {
                  birthCountry: null,
                  birthPlace: null,
                  countryCitizenship: null,
                  payTaxInIndia: true,
                  addressType: null,
                  fatcaTax1: {
                    taxPayingCountry: null,
                    taxPayingCity: null,
                    taxIdNumber: null,
                    taxId: null,
                    taxIdType: null
                  }
                },
                guardianRelationshipProofUrl: null
              }
            },
            selfDetail: null,
            personalDetail: {
              dateOfBirth: null,
              firstName: null,
              gender: null,
              taxStatusCode: null
            }
          },
          nominees: null,
          holdmode: "SINGLE",
          minor: true,
          folioSaveStep: "ONE",
          firstFolio: true,
          newUserFlow: true
        }

        function resetAgeProof() {
          $('#minorageproofimage').val(null);
        }

      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('bankDetailsDirective', bankDetailsDirective);

  /*@ngInject*/
  function bankDetailsDirective($timeout, $state, $log, $window, LoaderService, UtilService, MessageService, InvestmentBasketService,
                                ModalService, InvestorService, AppConstants, InvestorFileUploadServiceV3, DownloadPdfService,
                                FileSaver, Blob, InvestorServiceV3 , $stateParams , $rootScope , InvestmentModel , NewInvestorServiceV3) {
    return {
      restrict: 'E',
      scope: {
        firstFlow:'=', stepperUpdatedInfo : '&', selectedFolioData: '=' , proceedAction : '&', journey: '='
      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/folio/bank-details/bank-details.directive.html',
      link: function (scope) {
        var _this = scope;
        _this.bkValidateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        _this.IFSC_REGEX = AppConstants.ifsc_regex;
        _this.pattern = AppConstants;
        _this.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
        _this.bankChequeLeafUrl = '';
        _this.fileType = '';
        var pennyDropEnablSelectedBank = false;
        var taxStatusCode = '';
        _this.init = init;
        _this.tpv = tpv;
        _this.selectIFSC = selectIFSC;
        _this.getPayoutMechanism = getPayoutMechanism;
        _this.bankNameList = bankNameList;
        _this.setAccountType = setAccountType;
        _this.bankUploadChequeLeafFile = bankUploadChequeLeafFile;
        _this.openUploadedDoc = openUploadedDoc;
        _this.searchByIFSC = searchByIFSC;
        _this.downloadPdfFile = downloadPdfFile;
        _this.folioSelectionData = folioSelectionData;
        _this.setPayoutMechanism = setPayoutMechanism;
        _this.setAccountTypeValue = setAccountTypeValue;
        _this.folioSelectionPayload = folioSelectionPayload;
        _this.editBank = true;
        _this.payloadData = InvestmentModel.getPayload();
        _this.reviewModalData = {};
        _this.pennyDropCalled = false;
        _this.accModelDirty = false;
        _this.bankDetailsForm = {};
        _this.continueBank = continueBank;

        init();

        var listner = _this.$on("continueButtonFolio", function() {
          if (!_this.pennyDropCalled) {
            _this.pennyDropCalled = true;
            _this.validatePennyDropDetails();
          } else if (_this.pennyDropCalled = true) {
            _this.done();
          }

        });

        var listner = _this.$on("enableEditBank", function() {
          _this.editBank = true;
          _this.selectedFolioData.bankDetails = null;
          _this.payloadData = InvestmentModel.getPayload();
        });


        function init() {
          getPayload();
        }
        function folioSelectionPayload(payload){
          payload = {
            soleApplicantDetail: _this.prospectFolioData.soleApplicantDetail,
            jointHolders: _this.prospectFolioData.holderDetails,
            nominees: _this.prospectFolioData.nominees,
            bankDetails : _this.selectedFolioData.bankDetails,
            holdmode: _this.prospectFolioData.holdmode,
            minor: _this.prospectFolioData.minor,
          };
          _this.selectedFolioData = angular.copy(payload);
        }

        function folioSelectionData(){
          folioSelectionPayload(_this.selectedFolioData);
          _this.bankPayload = angular.copy(_this.selectedFolioData);
          _this.bankPayload.bankDetails.verifyAccountNumber= null;
          // _this.bankPayload.holdmode = _this.prospectFolioData.holdmode;
          setPayoutMechanism(_this.bankPayload.bankDetails.payoutMechanism);
          taxStatusCode = _this.bankPayload.soleApplicantDetail && _this.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode;
          if(taxStatusCode){
            getAcccountType(function(){
              _this.pennyDropCalled = false;
              _this.bankPayload.bankDetails.pennyDropValid = true;
              _this.bankPayload.bankDetails.chequeLeaf = null;
              setAccountTypeValue(_this.bankDetailsForm.$invalid = false,_this.selectedFolioData.bankDetails.accountType);
            });
          }
        }

        function getPayload(cb) {
          cb = cb || function () {
          };
          var success = function (resp) {
              LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.prospectFolioData = resp.data;
              if(_this.selectedFolioData && _this.selectedFolioData.bankDetails){
                folioSelectionData();
                if (_this.bankPayload.bankDetails.chequeLeaf !='') {
                  _this.pennyDropCalled = true;
                }
              }else {
                _this.bankPayload = resp.data;
                if (_this.bankPayload.bankDetails && !_this.bankPayload.bankDetails.bankHolderType) {
                  _this.bankPayload.bankDetails.bankHolderType = 'MINOR';
                }
                taxStatusCode = _this.bankPayload.soleApplicantDetail && _this.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode;
                setDefaultData();
                if(taxStatusCode){
                  getAcccountType();
                }
                bankInit();

              }
              getPayoutMechanism();
              //_this.MainFolioParent.holdmode = resp.data.holdmode;
              _this.bankPayload.nriFlag = resp.data.nriFlag;
                cb(true);
            } else {
              MessageService.error(resp.message);
              cb(false);
            }
          },
          error = function (err) {
            $log.info('Occupation Errror>>>>', err);
            LoaderService.hideLoader();
            cb(false);
          };
          LoaderService.showLoader();
          var folioId = localStorage.getItem('folioId');
          InvestorServiceV3.post({child1: 'folio', child2: 'getDetails'},{ id: folioId}).$promise.then(success, error);

        }

        function bankInit() {
          if(_this.bankPayload.soleApplicantDetail && _this.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode !=='01'){
            _this.bankPayload.bankDetails.pennyDropValid = false;
            _this.pennyDropCalled = true;
          }else{_this.bankPayload.bankDetails.pennyDropValid = true;}
          if(_this.bankPayload.soleApplicantDetail && _this.bankPayload.soleApplicantDetail.personalDetail &&
            _this.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode === '01' &&
            angular.isDefined(_this.bankPayload.bankDetails.ifsccode) &&
            _this.bankPayload.bankDetails.ifsccode !=""
          ){
            searchByIFSC(_this.bankPayload.bankDetails.ifsccode);
          }
          $window.scrollTo(0, 0);
          bankNameList();
          getPayoutMechanism();
          // getAcccountType();
          // setAccountType();
          if(angular.isDefined(_this.bankPayload.bankDetails) && _this.bankPayload.bankDetails.chequeLeaf !='') {
            breakFileUrl(_this.bankPayload.bankDetails.chequeLeaf);
            _this.pennyDropCalled = true;
          }

          $timeout(function () {
            LoaderService.hideLoader();
            $window.jQuery('[data-bs-toggle="tooltip"]').tooltip();
          },100);
        }

        function tpv(event) {
          event.preventDefault();
          ModalService.tp_this.dal({});
        }

        function selectIFSC() {
          var successModal = function(data){
            _this.pennyDropCalled = false;
            _this.bankPayload.bankDetails.accountNumber= null;
            _this.bankPayload.bankDetails.verifyAccountNumber= null;
            _this.bankPayload.bankDetails.ifsccode= data.ifscCode;
            _this.bankPayload.bankDetails.bankName = data.bankName;
            _this.bankPayload.bankDetails.accountType = _this.bankTypeList.length > 3 ? _this.bankTypeList[3].accountTypeCode : _this.bankTypeList[0].accountTypeCode;
            if(data.branch && data.branch.length>40) _this.bankPayload.bankDetails.bankBranch = data.branch.slice(0,40)
            else _this.bankPayload.bankDetails.bankBranch = data.branch;
            _this.bankPayload.bankDetails.bankCity = data.branchCity;
            if (data.pennyDropEnabled && _this.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode === '01') {
              _this.bankPayload.bankDetails.pennyDropValid = true;
            }
            else {
              _this.bankPayload.bankDetails.pennyDropValid = false;
              _this.pennyDropCalled = true;
            }
            pennyDropEnablSelectedBank = _this.bankPayload.bankDetails.pennyDropValid;
            resetCheckLeaf();
          };
          var errorModal = function(){
            _this.pennyDropCalled = true;
          };

          ModalService.IFSCSelectionModalNewJourney({ bankList: _this.bankList, fromFolioCreationForJourneys : true }, successModal, errorModal);
        }

        function resetCheckLeaf() {
          _this.bankchequeLeafUrl = "";
          _this.bankPayload.bankDetails.chequeLeaf = "";
          _this.bankChequeLeaf = "";
          _this.chooseAFile=true;
          angular.element("#uploadCheckLeaf").val("");
        }

        function bankNameList() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.bankList = resp.data.bankList;
                getAcccountType();
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              $log.info('Account type Errror>>>>', err);
            };

          InvestorService.get({child1: 'rbi', child2: 'bankNames'}).$promise.then(success, error);
        }

        function getPayoutMechanism() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.payoutMechanismList = resp.data.payoutMechanisms;
                resp.data.payoutMechanisms.map(function(pm){
                  if(pm.payoutCode=="DC"){
                    _this.bankPayload.bankDetails.payoutMechanism = pm.payoutCode;
                  }
                });

                var payoutMechanismData  = _this.payoutMechanismList.find(function (ele) {
                  return ele.payoutCode == _this.bankPayload.bankDetails.payoutMechanism;
                });

                _this.reviewModalData.payoutDescription = payoutMechanismData?payoutMechanismData.payoutDescription:'';

              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              $log.info('Payout Machanism error >>>>', err);
            };

          InvestorService.get({child1: 'folio', child2: 'payout-mechanism'}).$promise.then(success, error);
        }

        function setAccountType() {
          var checkFlag=false;
          $timeout(function () {
            _this.bankTypeList.map(function (ele) {
              if(ele.accountTypeCode === _this.bankPayload.bankDetails.accountType){
                checkFlag = true;
              }
            });
          });
          if(_this.bankPayload.bankDetails.accountType){
            _this.reviewModalData.accountType = getAccountNameByCode(_this.bankPayload.bankDetails.accountType);
          }
          // if(checkFlag===false){
          //   _this.bankPayload.bankDetails.accountType = null;
          // }
        }

        function bankUploadChequeLeafFile(file) {
          var fi = document.getElementById('uploadCheckLeaf');
          if (_this.mimeType.indexOf(file.type) === -1) {
            MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
            return;
          }
          if(file){
            if (fi.files.item(0).size <= 2000000) {
              var success = function (resp) {
                  LoaderService.hideLoader();
                  if (resp.status && resp.data) {
                    _this.bankchequeLeafUrl = resp.data.fileUrl;
                    _this.bankPayload.bankDetails.chequeLeaf = _this.bankchequeLeafUrl;
                    // _this.chooseAFile= false;
                    _this.fileType = resp.data.type.toLowerCase();
                    breakFileUrl(_this.bankchequeLeafUrl);
                    _this.bankPayload.bankDetails.pennyDropValid = true;
                  }
                  else {
                    _this.fileType = '';
                    // _this.chooseAFile= true;
                    MessageService.error(resp.message);
                  }
                },
                error = function (err) {
                  LoaderService.hideLoader(err);
                };

              if (file) {
                LoaderService.showLoader();
                var fd = new FormData();
                fd.append('file', file);

                InvestorFileUploadServiceV3.post({
                  child1:'folio',
                  child2: 'upload',
                  child3: 'bankDetails',
                  child4: 'chequeLeaf',
                  child5: $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId')
                }, fd).$promise.then(success, error);
              }
            }
            else {
              MessageService.error("File size should not be more than 2 MB.")
            }
          }

        }

        function breakFileUrl(url) {
          _this.bankChequeLeaf = 'Preview Uploaded Leaf Doc';
          _this.fileType = url && url.split('_').reverse()[0].toLowerCase();
          _this.chooseAFile = false;
          _this.bankchequeLeafUrl = url;
          return;
        }

        function openUploadedDoc() {
          if(angular.isUndefined(_this.bankPayload.bankDetails.chequeLeaf)){return;}
          ModalService.showImage1({docUrl: _this.bankPayload.bankDetails.chequeLeaf});
        }

        function searchByIFSC(ifsccode){
          var payload = {
            ifscCode : ifsccode
          };

          var onSuccess = function(resp){
            if(resp.status && resp.data){
              if(resp.data.bankList && resp.data.bankList.length==1){
                var bankInfo = resp.data.bankList[0];
                _this.bankPayload.bankDetails.pennyDropValid = angular.isDefined(bankInfo.pennyDropEnabled)
                  ?bankInfo.pennyDropEnabled:false;
                pennyDropEnablSelectedBank = _this.bankPayload.bankDetails.pennyDropValid;
              }
            }
          };
          onerror = function(){
          };
          InvestorService.post({
            child1: 'rbi',
            child2: 'bankList'
          }, payload).$promise.then(onSuccess, onerror);
        }

        function downloadPdfFile(url, fileType) {
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.data) {
              var data = new Blob([resp.data], { type: 'application/'+fileType });
              FileSaver.saveAs(data, 'Cheque_Leaf.'+fileType);
            } else {
              MessageService.error('No Data Available');
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          LoaderService.showLoader();
          var payload = {};
          DownloadPdfService.downloadFile(payload, fileType, _this.bankchequeLeafUrl).then(success, error);
        }


        function setDefaultData() {
          if(_this.bankPayload.bankDetails.chequeLeaf){
            breakFileUrl(_this.bankPayload.bankDetails.chequeLeaf);
          }
        }

        function getAcccountType(cb) {
          cb = cb || function () {
          };
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.bankTypeList = resp.data.bankAccountTypes;
                if(_this.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode=="01" || _this.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode=="02"){
                  _this.bankList && _this.bankTypeList.length>3 && (!_this.bankPayload.bankDetails.accountType || _this.bankPayload.bankDetails.accountType==="NRE" )?
                    _this.bankPayload.bankDetails.accountType=_this.bankTypeList[3].accountTypeCode
                    :''
                }
                else{
                  _this.bankList && _this.bankTypeList.length>0?
                    _this.bankPayload.bankDetails.accountType=_this.bankTypeList[0].accountTypeCode
                    :''
                }
                setAccountType();
                cb(true);
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              $log.info('Account type Errror>>>>', err);
            };

          var id = _this.bankPayload.soleApplicantDetail.personalDetail.taxStatusCode;

          InvestorService.get({
            child1: 'folio',
            child2: 'bank',
            child3: 'account-type-list',
            child4:  id
          }).$promise.then(success, error);
        }


        function setPayoutMechanism (value) {
          _this.bankPayload.bankDetails.payoutMechanism = value;
          var payoutMechanismData  = _this.payoutMechanismList && _this.payoutMechanismList.find(function (ele) {
            return ele.payoutCode == _this.bankPayload.bankDetails.payoutMechanism;
          });
          _this.reviewModalData.payoutDescription = payoutMechanismData?payoutMechanismData.payoutDescription:'';
        }

        function setAccountTypeValue (bankDetailsForm, value) {
          _this.bankPayload.bankDetails.accountType = value;
          _this.reviewModalData.accountType = getAccountNameByCode(_this.bankPayload.bankDetails.accountType);
          if (!bankDetailsForm.$invalid) {
            _this.formIsvalid();
          }
        }

        function getAccountNameByCode(accCode) {
          if(!accCode || _this.bankTypeList.length<1)return"";
          var bankTypeData  = _this.bankTypeList.find(function (ele) {
            return ele.accountTypeCode == accCode;
          });
          return bankTypeData ?bankTypeData.accountType:'';
        }

        _this.done = function () {
          _this.editBank = false;
          savePayload();
        };

        function savePayload(stateToMove) {
          LoaderService.showLoader();
          if(_this.bankPayload){
            _this.bankPayload.newFolioComplete = true;
            _this.bankPayload.id = localStorage.getItem('folioId');
          }
          if(_this.bankPayload.newFolioComplete){
            continueFolio(stateToMove);
          } else {
            saveDetails(stateToMove);
          }
        }

      function saveDetails (stateToMove) {
        LoaderService.showLoader();
        (stateToMove==='main.folio.nominee')&&(_this.bankPayload.saveStep = 4);
        (stateToMove==='main.folio.nominee')&&(_this.bankPayload.saveStep = 2);
        (stateToMove==='main.folio.review')&&(_this.bankPayload.saveStep = 5);
        var success = function (resp) {
          if (resp.status && resp.data) {
            localStorage.setItem('folioId', resp.data.id);
            LoaderService.hideLoader();
            $state.go('welcome');
            MessageService.success('Saved Successfully.');

          } else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        }, error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
        _this.bankPayload.firstFolio = _this.firstFlow ? true : false;
        _this.bankPayload.folioSaveStep = "FIVE";
        InvestorServiceV3.post({child1: 'folio', child2: 'save'}, _this.bankPayload).$promise.then(success, error);
      }

        function continueFolio(stateToMove) {
          var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              _this.payloadData.FOLIO_CREATION_STEP.bank_details_completed = true;
              InvestmentModel.setPayload(scope.payloadData);
              _this.$emit('buttonEnableProceed');
              _this.stepperUpdatedInfo();
              _this.proceedAction();
              MessageService.success('Saved Successfully.');
              /*if(stateToMove){
              } else {
                LoaderService.hideLoader();
                _this.mainFolioParent.bankDetailSuccess = true;
                showPopUp(resp.data);
              }*/
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            $log.info('Occupation Errror>>>>', err);
          };
          if(_this.bankPayload && _this.bankPayload.bankDetails && _this.bankPayload.bankDetails.payoutMechanism){
            delete _this.bankPayload.bankDetails.payoutMechanism.micrMandatory;
            delete _this.bankPayload.bankDetails.payoutMechanism.payoutDescription;
          }
          _this.bankPayload.folioSaveStep = "FIVE";
          _this.bankPayload.investmentBasketId = sessionStorage.getItem('journeyDraftId');
          _this.bankPayload.singlePage = true;
          if(scope.journey === 'ECART') {
            _this.bankPayload.ignoreDraftFolio = true;
            _this.bankPayload.newFolioCreationFlow = true;
            _this.bankPayload.cartFlow = true;
          }
          if (!_this.firstFlow) {
            _this.bankPayload.firstFolio = false;
            _this.bankPayload.newUserFlow = false;
            InvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, _this.bankPayload).$promise.then(success, error);
          } else {
            _this.bankPayload.firstFolio = true;
            _this.bankPayload.newUserFlow = true;
            NewInvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, _this.bankPayload).$promise.then(success, error);
          }
        }


        function showPopUp(data) {
          var successModal = function () {
              $window.sessionStorage.removeItem("investorForm");
              $state.go('welcome')
            },
            errorModal = function (err) {
              if(err!=null){
                MessageService.error(err)
              }
            };
          data = data ||{};
          data.holdmode = _this.bankPayload.holdmode;/////////////////////////
          ModalService.folioCreationSuccessModal(data, successModal, errorModal);
        }

        _this.validatePennyDropDetails = function(){
          var pennyDropValidatePayload = {
            "beneficiaryIFSC": _this.bankPayload.bankDetails.ifsccode,
            "benificiaryAccountNo": _this.bankPayload.bankDetails.accountNumber,
            "benificiaryName": _this.bankPayload.bankDetails.accountHolderName ? _this.bankPayload.bankDetails.accountHolderName.trim() : ""
          };
          LoaderService.showLoader();
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if(resp.data.valid === false) {
                  MessageService.error(resp.data.message || "We are unable to validate your bank account using IMPS service. Please upload cheque leaf to continue with folio creation");
                  _this.bankPayload.bankDetails.pennyDropValid = false;
                }

                else {
                  _this.disableAccntDetails = true;
                  if(resp.data.name) scope.bankPayload.bankDetails.accountHolderName = resp.data.name;
                  _this.bankPayload.bankDetails.pennyDropValid = true;
                  delete scope.bankPayload.bankDetails.chequeLeaf;
                  if(scope.firstFlow == 'YES'){
                    savePayload('folioDetails.review');
                  }else{
                    savePayload('main.folio.review');
                  }
                }
              } else {
                MessageService.error(resp.message);
                LoaderService.hideLoader();
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          InvestorService.post({child1: 'account', child2: 'validate', child3:'pennyDrop'}, pennyDropValidatePayload).$promise.then(success, error);


        };


        _this.formIsvalid = function () {
            if (_this.bankPayload.bankDetails.accountType && _this.bankPayload.bankDetails.verifyAccountNumber) {
              _this.$emit('buttonEnable');
            } else {
              _this.$emit('buttonDisable');
            }
        }

        _this.formIsinvalid = function () {
          _this.$emit('buttonDisable');
        }

        _this.accFocus = function () {
          _this.accModelDirty = true;
          _this.chooseAFile=true;
          _this.bankchequeLeafUrl='';
          _this.bankChequeLeaf='';
          _this.bankPayload.bankDetails.chequeLeaf = "";
          angular.element("#guardianrelationproofimage").val("");
          if(pennyDropEnablSelectedBank){
            _this.bankPayload.bankDetails.pennyDropValid=true;
          }

          if (_this.bankPayload.bankDetails.pennyDropValid) {
            _this.pennyDropCalled = false;
          }

        };


        function continueBank() {
          if (!_this.pennyDropCalled) {
            _this.pennyDropCalled = true;
            _this.validatePennyDropDetails();
          } else if (_this.pennyDropCalled = true) {
            _this.done();
          }
        }

      }
    };
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('VideoWidgetController', videoWidgetController);

  /** @ngInject */
  function videoWidgetController($scope, InvestorService, LoaderService, UtilService, $window, ModalService, $sce, $timeout) {
    var vm = this;
    vm.videoUrls = [];
    vm.init = init();

    function init() {
      var listeners = $scope.$on('ReadVideoUrls', function () {
        $timeout(function() {
          vm.videoUrls = JSON.parse($window.sessionStorage.getItem("videoUrls"));
          vm.videoUrls.forEach(function (arrayItem) {
            arrayItem['thumbnail'] = captureThumbnails(arrayItem.url);
          });
        }, 100);
      });
    }

    vm.playVideo = function(videoUrl) {
      ModalService.showVideoPlayModal({url: $sce.trustAsResourceUrl(videoUrl)});
    };

    function captureThumbnails(videoUrl) {
      if (videoUrl.includes("youtube")) {
        var youtube_video_id = videoUrl.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
        return $sce.trustAsResourceUrl("https://img.youtube.com/vi/" + youtube_video_id +"/0.jpg");
      } else {
        return "assets/images/youtube.png";
      }
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TransactionWidgetController', transactionWidgetController);

  /** @ngInject */
  function transactionWidgetController(InvestorService, LoaderService, MessageService, UtilService, TransactionService, $log, $state,AppConstants, TransactionModel) {
    var vm = this
    vm.transactionList = [];
    vm.init = init();
    vm.transactionTypeValues = [];
    vm.top_Up_label=AppConstants.ToastrMessage.VALIDATE_DATA.TOP_UP_LABEL;
    vm.fetchTopUpLabel=fetchTopUpLabel;

    function init() {
      fetchTopUpLabel();
      var payload = {
        "searchText": "",
        "sourceType": ["ALL"],
        "transactionNature": "ALL",
        "transactionType": ["ALL"],
        "fromDate": "",
        "toDate": "",
        "fromAmount":null,
        "toAmount":null,
        "pageIndex": 0,
        "pageLimit": 3,
        "transactionStatus": ["PROCESSED"],
        "sortValue": "DESC",
        "sortKey": "transactionDateTime"
      };
      getAllTransaction(payload);
    }

    function getAllTransaction(payload) {
      var success = function (resp) {
        vm.listStatus = resp;
        if (resp.data && resp.status) {
          vm.transactionList = resp.data.transactionList;
          vm.totalTransactionList = resp.data.totalTransactions;
          vm.isPagination = !!(vm.transactionList && vm.transactionList.length);
          getTransactionType();
        } else {
          vm.transactionList = [];
          vm.totalTransactionList = 0;
          vm.response = resp.message;
          vm.isPagination = false;
        }
        LoaderService.hideLoader();
      },
      error = function (err) {
        vm.transactionList = [];
        vm.totalTransactionList = 0;
        $log.info("error====", err);
        LoaderService.hideLoader();
        vm.isPagination = false;
      };
      LoaderService.showLoader();
      vm.isLoading = true;
      TransactionService.post({
        controller1: 'transaction',
        controller2: 'list'
      }, payload).$promise.then(success, error);
    }


    function getTransactionType() {
      vm.transactionLength = vm.transactionList.length;
      for(var i=0;i<(vm.transactionLength);i++){
        vm.transactionTypeValue = vm.transactionList[i].transactionType;
        vm.transactionTypeValueLength = vm.transactionTypeValue.length;
        vm.transactionTypeCapital = vm.transactionTypeValue.slice(0,1);
        vm.transactionTypeSmall = vm.transactionTypeValue.slice(1,vm.transactionTypeValueLength).toLowerCase();
        vm.transactionTypeValues[i] = vm.transactionTypeCapital + vm.transactionTypeSmall;
      }
    }

    vm.selectTransaction = function (data,action){
      TransactionModel.setPayloadRawData(null);
      var folioNumber = data.folioNumber;
      var params = { folioNumber: folioNumber, sc : data.schemeCode, action: 'portfolio'};
      var redirect = action.toLocaleLowerCase();
      switch (redirect) {
        case 'sip':
          $state.go('main.transactions.sip',params);
          break;
        case 'purchase':
          $state.go('main.transactions.purchase',params);
          break;
      }
    };

    function fetchTopUpLabel() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.topUpLabel = resp.data.noteDTO.noteDTOMap.Topup_Button_Label.content;
        } else {
          MessageService.error(resp.message);
        }
      }, failure = function(resp) {
        MessageService.error(resp)
        LoaderService.hideLoader();
      };
      var payload = {
        "pageName": "HOME_SCREEN"
      }
      InvestorService.post({child1: 'dynamicContent'}, payload).$promise.then(success, failure);
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SystematicWidgetController', systematicWidgetController);

  /** @ngInject */
  function systematicWidgetController(InvestorService, LoaderService, MessageService, $window, $state, AppConstants,TransactionModel) {
    var vm = this
    vm.init = init();
    vm.top_Up_label=AppConstants.ToastrMessage.VALIDATE_DATA.TOP_UP_LABEL;
    vm.top_up = AppConstants.TOP_UP
    vm.fetchTopUpLabel=fetchTopUpLabel;

    function init() {
      var systematicPayload = {
        "type" : "ALL",
        "status" : "ALL",
        'pageIndex': 0,
        'pageLimit': 25
      };
      getSystematicList(systematicPayload);
    }

    function getSystematicList(systematicPayload) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.systematicList = resp.data.schemeOverviewDTOs;
          vm.totalSystematicListData = resp.data.count;
          vm.isPagination = !!(vm.systematicList && vm.systematicList.length);
        } else {
          vm.systematicList = null;
          vm.isPagination = false;
          MessageService.error(resp.message);
        }
      },
      error = function () {
        LoaderService.hideLoader();
        vm.isPagination = false;
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'portfolio',
        child2: 'systematic-corner'
      }, systematicPayload).$promise.then(success, error);
    }
    vm.selectTransaction = function (action,data){
      TransactionModel.setPayloadRawData(null);
      var params = { folioNumber : data.folioNumber, sc : data.schemeCode, action: 'portfolio' };
      switch (action.toLocaleLowerCase()) {
        case 'sip':
          $state.go('main.transactions.sip',params);
          break;
        case 'purchase':
          $state.go('main.transactions.purchase',params);
          break;
      }
    };

    function fetchTopUpLabel() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.topUpLabel = resp.data.noteDTO.noteDTOMap.Topup_Button_Label.content;
        } else {
          MessageService.error(resp.message);
        }
      }, failure = function(resp) {
        MessageService.error(resp)
        LoaderService.hideLoader();
      };
      var payload = {
        "pageName": "HOME_SCREEN"
      }
      InvestorService.post({child1: 'dynamicContent'}, payload).$promise.then(success, failure);
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('StatementWidgetController', statementWidgetController);

  /** @ngInject */
  function statementWidgetController(InvestorService, LoaderService, MessageService, UtilService, ModalService, FileSaver,
                                     Blob, $window, DownloadPdfService, $timeout, investorServiceVersion, DownloadPdfServiceV2, $state, HDFC_API, AppConstants) {
    var vm = this
    vm.init = init();
    vm.isCheckedAccount = true;
    vm.isCheckedCapital = false;
    vm.selectedTab = 'account';
    vm.formData = {};
    vm.STATEMENT_OPTIONS = {
      'CURRENT': 'CFY',
      'PREVIOUS': 'PFY',
      'FULL': 'FS',
      'PERIOD': 'P'
    };
    vm.CAPITAL_GAIN_STATEMENT_OPTION = {
      'CFY': 'CY',
      'PFY': 'PY',
      'FS': 'SI',
      'P': 'SD'
    };
    vm.viewMode = 'days';
    vm.formData = {
      minEndDate: null,
      startDate: null,
      endDate: null
    };
    vm.formData.statementOption = vm.STATEMENT_OPTIONS.CURRENT;
    vm.changeStatementType = changeStatementType;
    vm.folioChanged = folioChanged;
    vm.generateStatement = generateStatement;
    vm.downloadStatement = downloadStatement;
    vm.updateEndDate = updateEndDate;
    vm.changeStartDate = changeStartDate;
    vm.changeEndDate = changeEndDate;
    vm.statementOptionChanged = statementOptionChanged;
    vm.changeCaptailGainStartDate = changeCaptailGainStartDate;
    vm.startMaxDate = $window.moment();
    vm.endMaxDate = $window.moment();
    vm.enableDownloadCTA = true;
    vm.schemeNotAvailable = AppConstants.STATEMENT_SCHEME_NOT_AVAILABLE;

    function init() {
      fetchFolioList();
    }

    /*
    * function responsible to fetch the folio list
    * */

    function fetchFolioList() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var folioList = [];
          if (vm.selectedTab == 'account') {
            Object.keys(resp.data.folioTaxDetailLists).forEach(function (key) {
              var obj = Object.assign({key: key}, resp.data.folioTaxDetailLists[key]);
              folioList.push(angular.copy(obj));
            });
          } else {
            Object.keys(resp.data.folioList).forEach(function (key) {
              var obj = Object.assign({key: key}, resp.data.folioList[key]);
              folioList.push(angular.copy(obj));
            });
          }
          vm.folioList = folioList.length ? folioList : null;
        } else {
          vm.folioList = null;
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.folioList = null;
        //UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      $timeout(function () {
        if (vm.selectedTab == 'account') {
          investorServiceVersion.get({
            child1: 'folio',
            child2: 'list'
          }).$promise.then(success, error);
        } else {
          InvestorService.get({
            child1: 'folio',
            child2: 'active-list'
          }).$promise.then(success, error);
        }
      },500)

    }

    /*
    * function responsible to execute the folio change
    * On basis of folio fetch the scheme list for account statements
    * */
    function folioChanged(folioNo) {
      if (folioNo && vm.selectedTab == 'account') {
        //fetchOutSchemes(folioNo); //Commented for HMF-24569
      }
    }

    /*
    * function resonsible to fetch the scheme list on basis of folio number selected
    * */
    function fetchOutSchemes(folioNo) {
      vm.schemeList = null;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.schemeList = resp.data.schemes;
          if (vm.selectedTab == 'account' && vm.schemeList.length > 0) {
            vm.schemeList.unshift({schemeCode: 'ALL', schemeName: 'All Schemes'});
            vm.formData.scheme = vm.schemeList[0].schemeCode;
          }
        } else {
          vm.schemeList = null;
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.schemeList = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      var _config = {child1: 'folio', child2: 'schemes'};

      if (vm.selectedTab == 'account') {
        investorServiceVersion.post(_config, {folioNumber: folioNo}).$promise.then(success, error);
      } else {
        InvestorService.post(_config, {folioNumber: folioNo}).$promise.then(success, error);
      }

    }

    /*
    * function responsible to change the active tab selection
    * */
    function changeStatementType(type) {
      vm.selectedTab = type;
      vm.enableDownloadCTA = true;
      vm.resetFormData();
      if (type === "account") {
        vm.isCheckedAccount = true;
        vm.isCheckedCapital = false;
      } else if (type === "capital") {
        vm.isCheckedCapital = true;
        vm.isCheckedAccount = false;
      }
    }

    /*
    * function responsible to generate the statement
    * */
    function generateStatement() {
      var type = vm.selectedTab;
      var reportName = null;
      switch (type) {
        case 'account':
          var payload = {
            "folioNumber": vm.formData.folioNumber, //'10006184'
            "schemeCode": !vm.formData.scheme || vm.formData.scheme === 'ALL' ? '': vm.formData.scheme,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "email"
            },
            "onScreenType": 'EMAIL'
          };
          reportName = 'accountStatement';
          break;
        case 'capital':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.CAPITAL_GAIN_STATEMENT_OPTION[vm.formData.statementOption],
            "commonReportCO": {
              "docDestination": "email"
            }
          };
          reportName = 'capitalGain';
          break;
      }

      var success = function (resp) {
        var msg = resp.message;
        LoaderService.hideLoader();
        if (resp && resp.status) {
          var success = function () {
            vm.resetFormData();
            $state.reload();
          },
          error = function () {
          };
          var successHandler = function(resp) {

            if(resp.popupDTO.popupDTOMap.Popup_Home !== undefined)
              {
                ModalService.successMessageModal({message: msg}, success, error);
              }
          }

          UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
            MessageService.error(resp);
          });
          //ModalService.successMessageModal({message: resp.message}, success, error);
        } else {
          vm.folioList = null;
          MessageService.error(resp.message);
          vm.resetFormData();
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.folioList = null;
        UtilService.errorHandler(err);
        vm.resetFormData();
      };
      LoaderService.showLoader();
      var _config = {child1: 'statement', child2: reportName};
      if (type !== 'capital' && type !== 'account') {
        InvestorService.post(_config, payload).$promise.then(success, error);
      } else if (type === 'capital' || type === 'account') {
        investorServiceVersion.post(_config, payload).$promise.then(success, error);
      }
    }

    /*
    * function responsible to email the statement
    * */
    function downloadStatement() {
      var type = vm.selectedTab;
      var reportName = null;
      switch (type) {
        case 'account':
          var payload = {
            "folioNumber": vm.formData.folioNumber, //'10006184'
            "schemeCode": !vm.formData.scheme || vm.formData.scheme === 'ALL' ? '': vm.formData.scheme,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "download"
            },
            "onScreenType": 'DOWNLOAD'
          };
          reportName = 'accountStatement';
          break;
        case 'capital':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.CAPITAL_GAIN_STATEMENT_OPTION[vm.formData.statementOption],
            "commonReportCO": {
              "docDestination": "download"
            }
          };
          reportName = 'capitalGain';
          break;
      }


      var decode= function (arr) {
        var d = "";
        for (var i = 0; i < arr.length; i += 1) {
          d += String.fromCharCode(arr[i]);
        }
        return d;
      };

      var success = function (resp) {
        var status = false;
        try {
          var decodedString = decode(new Uint8Array(resp.data));
          if (decodedString.indexOf('PDF') === -1) {
            if (angular.isObject(decodedString)) {
              var obj = $window.JSON.parse(decodedString);
              var message = obj['message'];
              status = false;
            } else {
              var crypt = new $window.JSEncrypt();
              crypt.setKey(HDFC_API.PRIV_KEY);
              var header = decodedString.substring(0, decodedString.lastIndexOf("|"));
              var data = $window.CryptoJS.enc.Base64.parse(decodedString.substring(decodedString.lastIndexOf("|")+1, decodedString.length));
              var responseData = readAesResponsePayload(crypt.decrypt(header), data);
              decodedString = angular.fromJson(responseData);
              var message = decodedString['message'];
              status = false;
            }
          }
          else {
            status = true;
          }
        }
        catch (error) {
          status = false;
        }
        if (resp.data && status) {
          var data = new Blob([resp.data], { type: 'application/pdf' });
          FileSaver.saveAs(data, reportName+'.pdf');
          LoaderService.hideLoader();
          vm.resetFormData();
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message || message || 'No Data Available');
          vm.resetFormData();
        }
      },
      error = function (err) {
        vm.resetFormData();
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      if ($window.sessionStorage.getItem("isExposedStatementActive")) {
        var _pathExposed = '/exposed/statement/';
      }
      LoaderService.showLoader();
      if (type !== 'capital' && type !== 'account') {
        DownloadPdfService.downloadFile(payload, reportName, _pathExposed).then(success, error);
      } else if (type === 'capital' || type === 'account') {
        DownloadPdfServiceV2.downloadFile(payload, reportName, _pathExposed).then(success, error);
      }
    }

    vm.resetFormData = function () {
      !$window.sessionStorage.getItem("isExposedStatementActive") && fetchFolioList();

      switch (vm.selectedTab) {
        case 'account':
          vm.formData.scheme = null;
          vm.formData.minEndDate = null;
          vm.formData.startDate = null;
          vm.formData.endDate = null;
          vm.formData.statementOption = vm.STATEMENT_OPTIONS.CURRENT;
          vm.formData.folioNumber = vm.STATEMENT_OPTIONS.CURRENT;
          break;
        case 'capital':
          vm.formData.minEndDate =  null;
          vm.formData.startDate =  null;
          vm.formData.endDate =  null;
          vm.formData.statementOption =  vm.STATEMENT_OPTIONS.CURRENT;
          vm.formData.folioNumber =  vm.STATEMENT_OPTIONS.CURRENT;
          break;
      }

      !$window.sessionStorage.getItem("isExposedStatementActive") && (vm.formData.folioNumber = null);

      var tmp = vm.selectedTab;
      vm.selectedTab = null;
      $timeout(function () {
        vm.selectedTab = tmp;
      });
    };

    function changeStartDate(date) {
      if (date) {
        vm.formData.startDate = date;
        updateEndDate(date);
      } else {
        vm.errorMessage = 'Enter valid Date';
        vm.formData.startDate = null;
      }
    }

    function changeEndDate(date) {
      if (date) {
        vm.formData.endDate = date;
        if (vm.selectedTab === 'account') {
          var diffInDays = date.diff(vm.formData.startDate, 'days');
          if (diffInDays <= 365) {
            vm.enableDownloadCTA = true;
          } else {
            vm.enableDownloadCTA = false;
          }
        } else {
          vm.enableDownloadCTA = true;
        }
      } else {
        vm.errorMessage = 'Enter valid Date';
        vm.formData.endDate = null;
      }
    }

    function updateEndDate(date) {
      var enabledEndDates = [];

      var currentDay = $window.moment();
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var startDay = angular.copy($window.moment(date)).set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var diff = Math.abs(startDay.diff(currentDay, 'days'));

      for (var i = 1; i <= diff; i++) {
        var _date = startDay.clone().add(i, 'days');
        enabledEndDates.push(_date.clone());
      }

      // if start date selected is current date setting end date same
      if (enabledEndDates.length === 0) {
        enabledEndDates.push(date.clone());
      }

      vm.enabledEndDates = angular.copy(enabledEndDates);
      vm.formData.minEndDate = vm.enabledEndDates[0];
      vm.formData.endDate = '';
    }

    function statementOptionChanged() {
      $timeout(function () {
        vm.enableDownloadCTA = true;

        if (vm.formData.statementOption != 'PE') {
          vm.formData.startDate = null;
          vm.formData.endDate = null;
        }

        if (vm.formData.statementOption === 'FS') {
          vm.enableDownloadCTA = false;
        }

      })

    }

    /*
    * Capital Gain start date changes handler
    * */
    function changeCaptailGainStartDate(date) {
      if (date) {
        vm.formData.startDate = date;
        updateCaptialGainEndDate(date);
      } else {
        vm.errorMessage = 'Enter valid Date';
        vm.formData.startDate = null;
      }
    }

    /*
    * Function responsible to identify enabled dates.
    * */
    function updateCaptialGainEndDate(date) {
      // var day = null;
      var enabledEndDates = [];

      var endDate = $window.moment(date).add(365, 'days');
      endDate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var startDay = angular.copy($window.moment(date)).set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});

      var diff = Math.abs(startDay.diff(endDate, 'days'));
      for (var i = 1; i <= diff; i++) {
        var _date = startDay.clone().add(i, 'days');
        if ($window.moment(_date).isSameOrBefore($window.moment())) {
          enabledEndDates.push(_date.clone());
        }
      }
      if ($window.moment(endDate).isSameOrBefore($window.moment())) {
        vm.endMaxDate = $window.moment(endDate.clone()).set({'hour': 23, 'minute': 59, 'second': 59, 'millisecond': 59});
      } else {
        vm.endMaxDate = $window.moment().add(1, 'minutes');
      }

      // if start date selected is current date setting end date same
      if (enabledEndDates.length === 0) {
        enabledEndDates.push(date.clone());
      }

      vm.capitalGainEnabledEndDates = angular.copy(enabledEndDates);
      vm.formData.minEndDate = vm.capitalGainEnabledEndDates[0];
      vm.formData.endDate = '';
    }

    function readAesResponsePayload(header, data) {
      var iv = $window.CryptoJS.enc.Base64.parse(header.substring(0, header.lastIndexOf("|")));
      var key = $window.CryptoJS.enc.Base64.parse(header.substring(header.lastIndexOf("|")+1, header.length));
      var decryptJson = $window.CryptoJS.AES.decrypt({
        ciphertext: data
      }, key, {iv: iv});
      return decryptJson.toString($window.CryptoJS.enc.Utf8);
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('QuickLinkWidgetController', quickLinkWidgetController);

  /** @ngInject */
  function quickLinkWidgetController(InvestorService, LoaderService, UtilService, $log,HDFC_API) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.quickLinks = null;
    vm.init = init();
    function init() {
      quickLinkApi();
    }

    function quickLinkApi() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.quickLinks = resp.data.quickLinkMap;
        } else {
          UtilService.errorHandler(resp.message);
        }
      }, failure = function(resp) {
        $log.info("error====", resp);
        LoaderService.hideLoader();
      };
      InvestorService.post({
        child1: 'quick',
        child2: 'link'
      },{}).$promise.then(success, failure);
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentWidgetController', investmentWidgetController);

  /** @ngInject */
  function investmentWidgetController(InvestorService, LoaderService, MessageService, UtilService, $log, AppConstants) {
    var vm = this;
    vm.open = false;
    vm.init = init();
    vm.xirrInfo = AppConstants.XIRR_INFORMATION;

    function init() {
      fetchInvestmentOverview();
      $('body').tooltip({
        selector: '[data-bs-toggle="tooltip"]',
        trigger: 'hover',
        template: '<div class="tooltip tooltip-custom"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
      });
    }

    function fetchInvestmentOverview() {
      var success = function(resp) {
        var graphData = [];
        LoaderService.hideLoader(".investment-loader");
        if (resp.status && resp.data) {
          vm.constantDataDTO = resp.data.constantDataDTO;
          vm.xirrValueUnit = UtilService.getUnitSting(resp.data.constantDataDTO.xirrValue);
          vm.xirrValue = resp.data.constantDataDTO.xirrValue?resp.data.constantDataDTO.xirrValue:'';
          vm.investmentData = resp.data.schemesResponseDTO.aumAndSchemesStatsList || [];
          //vm.b = vm.investmentData(function(ele){ if(ele.topSchemesList&&ele.topSchemesList.length>0){return ele;}});
          vm.purchaseValueUnit = vm.constantDataDTO.totalPurchaseValue;
          vm.constantDataDTO.totalPurchaseValue = vm.constantDataDTO.totalPurchaseValue;
          vm.currentValueUnit = vm.constantDataDTO.totalCurrentValue;
          vm.constantDataDTO.totalCurrentValue = vm.constantDataDTO.totalCurrentValue;
          vm.totalCurrentPercentageUnit = vm.constantDataDTO.totalCurrentPercentage;
          vm.schemeCount = resp.data.schemeCount;
          var perList = [];
          vm.investmentData.forEach(function(val, key) {
            if (vm.investmentData[key].aumType && vm.investmentData[key].aumType !== 'Total') {
              var tmp = [];
              perList.push(val.percentage);
              var aumType = val.aumType[0].toUpperCase() + val.aumType.slice(1).toLowerCase();
              vm.investmentData[key].aumType = aumType;
              tmp.push(aumType);
              tmp.push(val.percentage);
              graphData.push(tmp);
              vm.data = graphData;
            } else {
              vm.key = key;
              vm.investmentTotal = val;
            }
          });
          var maxVal = Math.max.apply(null, perList);
          var indexOfMax = perList.indexOf(maxVal)
          vm.investmentSelected = parseInt(indexOfMax)>-1?indexOfMax:0;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function(res) {
        LoaderService.hideLoader(".investment-loader");
        $log.info("error====", res);
      };
      LoaderService.showLoader(".investment-loader");
      InvestorService.post({
        child1: 'dashboard',
        child2: 'widgets',
        child3: 'investment'
      }, {}).$promise.then(success, error);
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('BasketWidgetController', basketWidgetController);

  /** @ngInject */
  function basketWidgetController(InvestorService, LoaderService, UtilService, $window, ModalService, $sce, AppConstants, AuthService, $rootScope, $log,$stateParams, $state, InvestmentBasketService , panAadharService , KycService) {
    var vm = this;
    vm.imageUrls = null;
    vm.basket_widget = AppConstants.BASKET_WIDGET;
    vm.investmentPersonalityQuestion = [];
    vm.isEvaluated = false;
    vm.redirectTo = redirectTo;
    // vm.evaluateInvestmentPersonality = evaluateInvestmentPersonality;
    vm.init = init();
    var token = AuthService.getToken();

    function init() {
      sessionStorage.removeItem('investNowBackParams');
    }
    function redirectTo(state){

      var successHandler = function(resp) {
        LoaderService.hideLoader(".panAadhar-loader");
        var success = function(res) {
          sessionStorage.removeItem('randomOTPIdForGoalKYIPAndBasket');
          switch (state){
            case 'main.investment.personality':
              // evaluateInvestmentPersonality();
              $state.go('main.investment.personality');
              break;
            case 'main.investment.basket'  :
              $state.go('main.investment.basket');
              break;
            case 'main.investment.goals':
              $state.go('main.investment.goals');
          }
        }

        KycService.fetchKycStatus(AppConstants.KYC_RESTRICTION.TRANSACTION).then(success).catch(function(resp) {
          $log.info(resp);
          $state.reload();
        });

      } , errorHandler = function() {
        LoaderService.hideLoader(".panAadhar-loader");
        $state.reload();
      }
      LoaderService.showLoader(".panAadhar-loader");
      panAadharService.fetchPanAadharLinkingStatus(token.investorPAN,null,true).then(successHandler).catch(errorHandler);

    }




  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('BannerWidgetController', bannerWidgetController);

  /** @ngInject */
  function bannerWidgetController(InvestorService, LoaderService, UtilService, $window, ModalService, $sce, AppConstants, AuthService, $rootScope, $log) {
    var vm = this;
    vm.imageUrls = null;
    var token = AuthService.getToken();
    vm.init = init();

    function init() {
      mediaImageApi();
    }

    function mediaImageApi() {
      var videoUrls = [];
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.imageUrls = resp.data.imageUrls;
          if (Object.keys(resp.data.videoUrls).length !== 0) {
            Object.entries(resp.data.videoUrls).map(function(key) {
              videoUrls.push({
                name: key[0],
                url: key[1]
              });
            });
            localStorage.setItem("videoUrl", JSON.stringify(videoUrls));
          } else if (Object.keys(resp.data.videoUrls).length === 0) {
            var videoList = AppConstants.WELCOME_VIDEO_LIST;
            Object.entries(videoList).map(function(key) {
              videoUrls.push({
                name: key[0],
                url: key[1]
              });
            });
            localStorage.setItem("videoUrl", JSON.stringify(videoUrls));
          }
          if (resp.data.imageUrls.length === 0) {
            var imageList = AppConstants.WELCOME_BANNER_LIST;
            vm.imageUrls = imageList;
          }
          $window.sessionStorage.setItem("videoUrls", JSON.stringify(videoUrls));
          $rootScope.$broadcast('ReadVideoUrls');
        } else {
          UtilService.errorHandler(resp.message);
        }
      }, failure = function(resp) {
        $log.info("error====", resp);
        LoaderService.hideLoader();
      };
      InvestorService.post({
        child1: 'landingPage',
        'child2': 'media',
        'child3': 'link'
      }, {
        landingPageType: token.landingPageType,
        limit: "all"
      }).$promise.then(success, failure);
    }
  }
})();

/**
 * Created by ttn on 12/09/19.
 */

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('termsCondition', termsCondition);

  /*@ngInject*/
  function termsCondition(ModalService, $stateParams ,$sce,$templateCache , LoaderService , InvestorService ,UtilService ,MessageService,HDFC_API) {
    return {
      restrict: 'E',
      scope: {transactionType: '@' , transactionModalData : '=',termConditionEnd : '=' , showTerms : '=' },
      templateUrl: 'app/components/modal/transactionalTnc/directive/transactionalTermcondition.html',
      link: function (scope) {
        scope.HDFC_API =HDFC_API;
        scope.dynamicTransactionalModalData = null;
        scope.dynamicTransactionalTerms = null;
        scope.init = function(){
        scope.transactionType =  scope.transactionType !== undefined ?  scope.transactionType  : $stateParams.tncType;
        scope.callTnc = true;
        scope.callTncSip = true;
        scope.biometricTnC = null;
         var successHandler = function(resp) {
            scope.dynamicTransactionalModalData = resp;
            scope.dynamicTransactionalTerms = scope.dynamicTransactionalModalData.termAndConditionDTO.termAndConditionDTOMap[scope.key].content;
         }
        switch (scope.transactionType) {
           case 'PURCHASE':
             scope.key = "TNC_Review_Purchase_Investment"
             UtilService.fetchDynamicData("PURCHASE_REVIEW").then(successHandler).catch(function(resp) {
               MessageService.error(resp)
             });
             break;
           case 'SIP':
              scope.key = "TNC_SIP_Review_Registration"
              UtilService.fetchDynamicData("SIP_REVIEW").then(successHandler).catch(function(resp) {
                 MessageService.error(resp)
              });
              break;
           case 'SWITCH':
              scope.key = "TNC_Review_Transaction_Switch"
              UtilService.fetchDynamicData("SWITCH_REVIEW").then(successHandler).catch(function(resp) {
                MessageService.error(resp)
              });
              break;
           case 'REDEMPTION':
              scope.key = "TNC_Review_transaction_Redemption"
              UtilService.fetchDynamicData("REDEMPTION_REVIEW").then(successHandler).catch(function(resp) {
                MessageService.error(resp)
              });
              break;
           case 'STP':
              scope.key = "TNC_Review_STP"
              UtilService.fetchDynamicData("STP_REVIEW").then(successHandler).catch(function(resp) {
                MessageService.error(resp)
              });
              break;
           case 'FLEX_INDEX':
              scope.key = "TNC_Review_FLEXINDEX"
              UtilService.fetchDynamicData("FLEXINDEX_REVIEW").then(successHandler).catch(function(resp) {
                MessageService.error(resp)
              });
              break;
           case 'SWP':
              scope.key = "TNC_Review_SWAP"
              UtilService.fetchDynamicData("SWAP_REVIEW").then(successHandler).catch(function(resp) {
                MessageService.error(resp)
              });
              break;
           case 'DTP':
              scope.key = "TNC_Review_TIP"
              UtilService.fetchDynamicData("TIP_REVIEW").then(successHandler).catch(function(resp) {
                MessageService.error(resp)
              });
              break;
           case 'SMART_SWAP':
              scope.key = "TNC_Smart_Swap"
              UtilService.fetchDynamicData("SMARTSWAP_REVIEW").then(successHandler).catch(function(resp) {
                MessageService.error(resp)
              });
              break;
           case 'SIP-E-MANDATE':
              scope.key = "TNC_SIP_Review_Registration_eOTM"
              UtilService.fetchDynamicData("SIP_REVIEW").then(successHandler).catch(function(resp) {
                MessageService.error(resp)
              });
              break;
           case 'Flex_STP':
               scope.key = "TNC_FLEXSTP"
               UtilService.fetchDynamicData("FLEXSTP_REVIEW").then(successHandler).catch(function(resp) {
                 MessageService.error(resp)
               });
               break;
            case 'ECART':
              scope.key = "TNC_ECART_IP"
              UtilService.fetchDynamicData("PURCHASE_ECART").then(successHandler).catch(function(resp) {
                MessageService.error(resp)
              });
            break;
          case 'FLEX_SIP':
               scope.key = "TNC_FLEX_SIP_Review_Registration"
               UtilService.fetchDynamicData("FLEX_SIP_REVIEW").then(successHandler).catch(function(resp) {
                MessageService.error(resp)
               });
            break;
           default:
              console.log("not found");
        }

        var successHandler = function(resp) {
          if(!resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General)
            {
              scope.callTnc = false;
            }
          if(!resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General_SIP) {
            scope.callTncSip = false;
          }
        }
        UtilService.fetchDynamicData("INNER_TNC").then(successHandler).catch(function(resp) {
          MessageService.error(resp)
        });

         var successHandlerBiometric = function(resp) {
           scope.biometricTnC = resp.termAndConditionDTO.termAndConditionDTOMap["TNC_Biometric"];
         }

         UtilService.fetchDynamicData("BIOMETRIC").then(successHandlerBiometric).catch(function(resp) {
            MessageService.error(resp)
         });
      }

        scope.init();
        scope.showGeneralTnc = function () {
          if(scope.callTnc && scope.transactionType !== 'SIP')
          {
            ModalService.termConditionModal();
          }

          if(scope.callTncSip && scope.transactionType == 'SIP') {
            ModalService.termConditionModal({type: 'SIP'});
          }
        }


      }
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('tpv', tpv);

  /*@ngInject*/
  function tpv($stateParams) {
    return {
      restrict: 'E',
      scope: {transactionType: '@'},
      templateUrl: 'app/mobile/tpv/tpv.html',
      link: function (scope) {
        scope.init = function(){
          scope.transactionType = $stateParams.tncType;
        }
      }
    }
  }
})();


/**
 * Created by ttn on 12/09/19.
 */

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('generalTermsCondition', generalTermsCondition);

  /*@ngInject*/
  function generalTermsCondition($stateParams,$timeout) {
    return {
      restrict: 'E',
      scope: {transactionType: '@' , transactionTermsData : '='},
      templateUrl: 'app/components/modal/termcondition/directive/transactionalTermcondition.html',
      link: function (scope) {
        scope.init = function(){
          scope.transactionType = $stateParams.tncType;
          scope.showData = false;
          if(scope.transactionTermsData == undefined)
          {
            scope.showData = false;
          }
//          setting up delay to render content
           $timeout(function(){
             scope.showData = true;
           }, 1000);
        }
        scope.init()
      }
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ContactOtpModalController', contactOtpModalController);

  /** @ngInject */
  function contactOtpModalController($uibModalInstance, $timeout, $scope, AppConstants, MessageService, LoaderService, modalData, modalView, InvestorServiceV2, UtilService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.contact = vm.modalData.contact;
    vm.email = vm.modalData.email;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.formData = {};
    vm.modalOtpForm = {};
    vm.verifyOtp = verifyOtp;
    vm.resetValues = resetValues;
    vm.resendOtp = resendOtp;

    vm.closeModal = function (message) {
      $uibModalInstance.close(message);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    /*
    * Function responsible to submit the entered otp
    * on success: close the modal with message
    * on error: show error message on modal
    * */
    function verifyOtp() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.closeModal();
          MessageService.success(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      var payload = {
        "otp" : vm.formData.otpNumber,
        "otp2" : vm.formData.newOtpNumber,
        "uniqueLink" : vm.modalData.secretLink,
        "uniqueLink2" : vm.modalData.secretLink2
      };
      InvestorServiceV2.post({
        child1: 'contact',
        child2: 'update',
        child3: 'verify',
        child4: 'otp'
      }, payload).$promise.then(success, error);
    }

    /*
    * Function resposible to reset the error message received from API.
    * * on change
    * */
    function resetValues() {
      vm.errorMessage = "";
    }

    /*
    * Function responsible to regenrate the OTP
    * */
    function resendOtp() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          resetTimer();
          MessageService.success(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      var payload = {
        "secretLink" : vm.modalData.secretLink,
        "secretLink2" : vm.modalData.secretLink2
      };
      InvestorServiceV2.post({
        child1: 'contact',
        child2: 'update',
        child3: 'resend',
        child4: 'otp'
      }, payload).$promise.then(success, error);
    }

    /*
    * Function resposbile to reset the resend otp counter value
    * value 60s
    * */
    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }
  }
})();

 /**
 * Created by ttn on 12/09/19.
 */

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('nontermsCondition', nontermsCondition);

  /*@ngInject*/
  function nontermsCondition(ModalService, $stateParams) {
    return {
      restrict: 'E', 
      scope: {transactionType: '@', termsConditionDynamic : '='},
      templateUrl: 'app/components/modal/nonTransactionalTnc/directive/nonTransactionalTnc.html',
      link: function (scope,HDFC_API) { 
        scope.HDFC_API = HDFC_API;
        scope.init = function(){
          scope.transactionType = $stateParams.tncType;
        }
        scope.showGeneralTnc = function () {
          ModalService.termConditionModal();
        }
      }
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('CheckuserController', checkuserController);

  /** @ngInject */
  function checkuserController(MessageService, AppConstants, LoaderService, InvestorService, AuthService, $state,$timeout, $rootScope, $window,ModalService,NetcoreEvntService,toastr,UtilService,HDFC_API) {
    var vm = this;
    vm.VALIDATE_CONST = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.mobileTknLogout = mobileTknLogout;
    vm.maskeEmail = maskeEmail;
    vm.maskemobileNo = maskemobileNo;
    vm.maskuserId = maskuserId;
    vm.maskid = maskid; 
    vm.maskFolioList = maskFolioList; 
    vm.userIdDetails = null;
    var removeListeners = {}, isRefreshing = false;
    vm.verifypan = function () {
      sessionStorage.removeItem('primaryPan');
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.userIdDetails = resp.data.userId;
          vm.isNewInvestor = resp.data.isExistingInvestor ? false : true;
          vm.isIndividual = resp.data.isIndividual;
          vm.toUpdate = resp.data.toUpdate;
          vm.corporateFlag = resp.data.corporateFlag;
          vm.message = resp.data.message;
          vm.corporateFolioList = resp.data.corporateFolioList;
          var userData = AuthService.getUserCookies();
          userData.pan = vm.panNumber;
          userData.dob = vm.dob.format('DD-MM-YYYY');
          AuthService.setUserCookies(userData);
          if (vm.isNewInvestor) {
            //redirect on prelimanary dashboard 
            userData.disablePAN = true;
            AuthService.setUserCookies(userData);
            var data = AuthService.getMobileLoginToken();
            data.newPrelimanryUser = true;
            AuthService.setMobileLoginToken(data);
            $state.go('preliminaryDashboard');
            return;
          }
          vm.doberrormsg = '';
          // for handle DOB error
          if (resp.data.isExistingInvestor && !resp.data.isDobValidated) {
            vm.doberrormsg = resp.data.message;
            return;
          } 
          // Existing investor
            if (vm.toUpdate) {
              if (vm.isIndividual) {
                //in case any exception message throw then handle error message
                if (resp.data.message && resp.data.message.length>0) {
                  MessageService.error(resp.data.message);
                  return;
                }
                vm.STEPS = 'VERIFY_DOB_AND_MOBILE';
                vm.openLoginWithMobileModal();
              } else {
                vm.STEPS = 'NON_INDIVIDUAL_NOTE';
                vm.openLoginWithMobileModal();
              }
            } else {
              // Exisitn mobile + Exisitn mobile Individual OR NON Individual
              if (vm.isIndividual) {
                //in case any exception message throw then handle error message
                if (resp.data.message && resp.data.message.length>0) {
                  MessageService.error(resp.data.message);
                  return;
                }
                vm.loginMethod = 'SWITCH_MTOKEN_TO_ETOKEN';
                vm.login();
              } else {
                vm.folioList = maskFolioList(vm.corporateFolioList);
                vm.STEPS = 'FOLIO_LIST';
                vm.openLoginWithMobileModal();
              }
            }
        } else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            });
          }else{
            MessageService.error(resp.message);
          }
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var dateOfBirth = vm.dob.format('DD-MM-YYYY');
      var payload = {
        panNumber: AuthService.encryptRSA(angular.copy(vm.panNumber)),
        dob: dateOfBirth
      }
      InvestorService.post({ child1: 'mobile', child2: 'getVerifyPAN' }, payload).$promise.then(success, error);
    } 
    vm.autoDate = function () {
      var oldlength = 0;
      if (vm.dobString) {
        oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if (vm.dobString.length == 2) {
        if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
        } else {
          $("#dobId").val(vm.dobString + "-");
        }
      }
      if (vm.dobString.length == 5) {
        if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
        } else {
          $("#dobId").val(vm.dobString + "-");
        }
      }
      if(vm.dobString.length == 10){
        var currentDate = $window.moment(new Date(),'DD-MMM-YYYY');
        var selectedDate = $window.moment(vm.dobString,'DD-MMM-YYYY');
        var status = selectedDate.isBefore(currentDate);
        if(status){
          vm.changeStartDate($window.moment(vm.dobString,'DD-MM-YYYY'));
        }
      } 
      if (vm.dobString.length == 0) {
        vm.dob = '';
      }
    }
    vm.changeStartDate = function (date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.dob = date; 
        vm.doberrormsg = '';
        if (!date) {
          vm.dateErrorMessage = 'Please enter valid DOB';
        } else vm.dateErrorMessage = '';
      } else {
        vm.dateErrorMessage = 'Please enter valid DOB';
        vm.dob = "";
      }
      return;
    }
    vm.openLoginWithMobileModal = function () {  
      var successModal = function (resp) {
        if(resp.redirectOnDashboard){ 
          vm.loginMethod = 'SWITCH_MTOKEN_TO_ETOKEN';
          vm.login();
        }  
      },errorModal = function (err) { 
        if(err && err == 'logout'){
          vm.mobileTknLogout(true,function(){
            sessionStorage.setItem('LOGIN_WITH_USERID',true);
            $state.go('login');
          });
        }
        if(err && err == 'HOME_STATE'){
          vm.mobileTknLogout(true,function(){
            $state.go('login');
          });
        }
      }; 
      var data = {
        folioList:vm.folioList,
        throughPrelimanaryDashboard : false,
        showMobileBelongsTo : false,
        isIndividual : vm.isIndividual
      }
      ModalService.loginWithMobileModal({STEPS:vm.STEPS,data:data}, successModal, errorModal); 
    }
    vm.login = function () {
      var successLogin = function (result) {
        vm.loginProcessFlag = false;
        LoaderService.hideLoader();
        if (result.access_token && result.access_token != "") {
            (typeof $window.smartech == 'function') && $window.smartech('identify', result.encryptedPanNumber);
            sessionStorage.setItem('loggedIn', true);
            NetcoreEvntService.login_Success_Smartech();
           if(result.loginType == "SWITCH_MTOKEN_TO_ETOKEN"){
            $window.smartech('contact', '', {
              'pk^pan_number': result.encryptedPanNumber,
              'email': HDFC_API.INFO_RECEIVE_IDENTIFIER ? HDFC_API.INFO_RECEIVE_IDENTIFIER.concat('@gmail.com') : result.email,
              'mobile': HDFC_API.INV_INFO_RECEIVER ? UtilService.genericConverter(HDFC_API.INV_INFO_RECEIVER) : result.mobile,
              'FIRST_NAME': result.investorFName,
              'LAST_NAME': result.investorLName
              });
              vm.netcoreDataObj = NetcoreEvntService.Mobile_Login(result, true);
              $window.smartech('dispatch','Mobile_login_success',vm.netcoreDataObj);
           }
            if (result.investorType != AppConstants.INVESTOR_TYPE.NEW) {
              $state.go('home');
            } else {
              $state.go('welcome.newUserWelcome');
            }
        } else {
          if (result && result.message) {
            MessageService.error(result.message);
          }
        }
      },errorLogin = function (msg) {
          LoaderService.hideLoader();
          if (msg.message === 'Password Expired') {
            var payload = { userId: vm.loginPayload.username, errMsg: msg.message };
            ModalService.changePasswordModal(payload);
            vm.loginProcessFlag = false;
          } else if (msg.message === "REDIRECT_TO_OLD") {
            ModalService.redirectToOldFolioModal({});
            vm.loginProcessFlag = false;
          } else {
            if (typeof (msg) == 'string') {
              var messages = msg + '<span class="' + Math.random() + '"></span>';
              toastr.error(messages, '', {
                allowHtml: true,
                preventDuplicates: false,
                onHidden: function () {
                  vm.loginProcessFlag = false;
                }
              });
            }
            if (typeof (msg) == 'object') {
              UtilService.errorHandler(msg);
              vm.loginProcessFlag = false;
            }
          }
      };
      // switch mobile token to existing login token
      var MToken = AuthService.getMobileLoginToken();
      var singleUseURL = MToken.access_token;
      var userData = AuthService.getUserCookies();
      var payload = {
        grant_type: "password",
        password: AuthService.encryptRSA(angular.copy(MToken.mobile)),
        username: AuthService.encryptRSA(angular.copy(userData.pan)),
        folioNumber: userData && userData.folioNumber ? userData.folioNumber : '',
        userIdDetails:vm.userIdDetails?vm.userIdDetails:''
      };
    
      vm.loginProcessFlag = true;
      LoaderService.showLoader();
      AuthService.login(payload, vm.loginMethod, singleUseURL).then(successLogin, errorLogin);
    };
    function mobileTknLogout(forceLogout, cb){ 
      cb = cb || function () {
        $state.go('login');
      };
      var successLogin = function () {  
        cb();
      },
      errorLogin = function () { 
        cb();
      }
      LoaderService.showLoader(); 
      var userDetails = AuthService.getMobileLoginToken(); 
      if(userDetails){
        var payload = {  
          mobile: AuthService.encryptRSA(userDetails.mobile),
          forceLogout:forceLogout?true:false
        }  
        AuthService.mobileTokenLogout(payload).then(successLogin, errorLogin);
      }else{
        $state.go('login');
      } 
    }
    function maskFolioList(dataList){
      if(dataList && dataList.length > 0){
        var folioListLength =  dataList.length;
        var tempList = [];
        var tempObj = {};
        for (var i = 0; i < folioListLength; i++) {
            tempObj = {};
            tempObj.folioNumber = dataList[i].id;
            tempObj.maskedFolioNumber = maskid(dataList[i].id);
            tempObj.userId = dataList[i].userId;
            tempObj.maskedUserId = maskuserId(dataList[i].userId);
            tempObj.mobile = dataList[i].mobileNo;
            tempObj.maskedMobile = maskemobileNo(dataList[i].mobileNo);
            tempObj.email = dataList[i].email;
            tempObj.maskedEmail = maskeEmail(dataList[i].email);
            tempObj.minorFlag = dataList[i].minorFlag;
            tempList.push(tempObj);
        }
        return tempList;
      }else{
        vm.folioList = [];
      }
    }
    function maskeEmail(email) {
      if (email) {
        if (!email) {
          return;
        }
        var valArray = email.split("@");
        var startVal = valArray[0];
        var endVal = valArray[1];
        var maskyVal = "";
        for (var i = 0; i < startVal.length; i++) {
          if (i == 0) {
            maskyVal += startVal[i];
          }
          if (i == 1) {
            maskyVal += "*";
          }
          if (i > 1) {
            var t = i % 2;
            if (t == 0) {
              maskyVal += startVal[i];
            } else {
              maskyVal += "*";
            }
          }
        }
        var maksemail = maskyVal + "@" + endVal;
        return maksemail;
      }
    }
    function maskid(val) {
      var endVal = val.substr(-3);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 3) {
        maskyVal += "*";
        valLength--;
      }
      return maskyVal + endVal;
    }
    function maskemobileNo(val) {
      if (!val || val == "null") {
          return val = "";
      }
      if (val == 'Not updated') {
          return val = val;
      }
      var endVal = val.substr(-4);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 4) {
          maskyVal += "*";
          valLength--;
      }
      return maskyVal + endVal;
    }
    function maskuserId(val){
      if(val){
        var maskUserId = '';
        for(var i=0;i<val.length;i++){
          if(i%2==0){
            maskUserId = maskUserId+val[i];
          }else{
            maskUserId = maskUserId+'*';
          }
        }
        return maskUserId;
      }else{
        return "";
      }
    }
    removeListeners["RemoveMobileToken"] = $rootScope.$on("RemoveMobileToken", function () {
      sessionStorage.removeItem(AppConstants.MOBILE_IDENTIFIER);  
      $timeout(function () {
        sessionStorage.removeItem('ErrorStep');
        MessageService.error('Session has been expired. Please login to continue.');          
        $state.go('login');
      }, 0);
  });
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('transactionSummary', transactionSummary);

  /*@ngInject*/
  function transactionSummary(ModalService, AppConstants, AuthService, moment, $window, $state, $rootScope, $stateParams, TransactionModel, LoaderService, TransactionService, InvestorService, MessageService, UtilService, HDFC_API, $timeout, NetcoreEvntService) {
    return {
      restrict: 'E',
      scope: {formData: '=', isSummaryViewEnabled: '=',isNewFolioViewEnabled: '=', folioId:'=', transactionType: '@',transactionSubType: '@' , notes:'=' , endDateNotes: '=' , startDateNotes: '=', showTerms: '=' , showTermsEmandate: "=" , showTermsFlex : "=", noteUpiOtp : "="},
      templateUrl: 'app/transactions/summary/directive/summary.html',
      link: function (scope) {
        scope.oldSipSystematicData = JSON.parse(sessionStorage.getItem('systematicData'));
        if(scope.oldSipSystematicData) {
          scope.oldSipSystematicData.amount && $window.NumToWord(scope.oldSipSystematicData.amount, 'amountInwords', scope.oldSipSystematicData);
          scope.oldSipSystematicData.topupDetails.amount && $window.NumToWord(scope.oldSipSystematicData.topupDetails.amount, 'topUpamountInwords', scope.oldSipSystematicData.topupDetails);
          scope.formData.topupDetails.oldTopUpamountInwords = scope.oldSipSystematicData.topupDetails.amountInWords;
          if(scope.oldSipSystematicData.topupDetails.capAmount) {
            $window.NumToWord(scope.oldSipSystematicData.topupDetails.capAmount, 'topUpCapamountInwords', scope.oldSipSystematicData.topupDetails);
            scope.formData.topupDetails.oldtopUpCapamountInwords = scope.oldSipSystematicData.topupDetails.amountInWords;
          }
        }
        if(scope.formData.purchaseAmount != "" && scope.formData.purchaseAmount != undefined){
          $window.NumToWord(scope.formData.purchaseAmount, 'purchaseAmountInWord',scope.formData);
        }else{
          scope.formData.amount && $window.NumToWord(scope.formData.amount, 'amountInwords',scope.formData);
          if (scope.formData.investmentType === "FLEXSIP" && scope.formData.flexSipPaymentOption === 'E-mandate' ) {
            // scope.formData.emandateAmountInWords = {};
            // $window.NumToWord(2 * scope.formData.amount, 'amountInwordsEmandate',scope.formData.emandateAmountInWords);
          }
        }
        scope.billdeskUrl=HDFC_API.BILLDESK_URL;
        scope.formData = scope.formData || TransactionModel.getPayloadRawData();
        if(scope.formData.topupDetails && scope.formData.topupDetails.amount){
          $window.NumToWord(scope.formData.topupDetails.amount, 'topUpamountInwords',scope.formData.topupDetails);
          scope.formData.topupDetails.topUpamountInwords = scope.formData.topupDetails.amountInWords;
        }
        if(scope.formData.topupDetails && scope.formData.topupDetails.capAmount){
          $window.NumToWord(scope.formData.topupDetails.capAmount, 'topUpCapamountInwords',scope.formData.topupDetails);
          scope.formData.topupDetails.topUpCapamountInwords = scope.formData.topupDetails.amountInWords;
        }
        if (scope.formData && scope.formData.emandateAmount) {
          scope.emandateAmountDetails = {};
          $window.NumToWord(scope.formData.emandateAmount, 'amountInwordsEmandateSummary',scope.emandateAmountDetails);
          scope.emandateAmountInWords = scope.emandateAmountDetails.amountInWords;
        }
        scope.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
        scope.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
        scope.summaryToOpen = getSummaryToOpen();
        scope.investorInfo = '';
        scope.isCheckedTandC = false;
        scope.isCheckedTandCeMandate = false;
        scope.NAV_APPLICABILITY_NOTE = AppConstants.NAV_APPLICABILITY_NOTE;
        scope.today = $window.moment($window.moment(),"DD-MMM-YYYY HH:mm A");
        scope.callApprove = callApprove;
        scope.callApproveForSip = callApproveForSip;
        AuthService.checkLinkedUserStatus();
        if (scope.formData.emandateDate) {
          scope.formData.emandateDate = moment(scope.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
        }

        if (scope.formData.endDateEmandate) {
          scope.formData.endDateEmandate = moment(scope.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
        }


        var Card = $window.Card || {};
        var identifierData = AuthService.getToken();
        scope.investorName = identifierData.investorFullName;
        scope.formData.formType = scope.transactionSubType === scope.SUMMARY_CONST.FLEX_STP.key ? scope.SUMMARY_CONST.FLEX_STP.value :
          (scope.formData && scope.formData.formType ? scope.formData.formType: '');
        if(scope.transactionType === 'SIP'){
          scope.capMonthYear = moment(scope.formData.topupDetails.capMonthYear,"MMM-YYYY").format("MMM-YYYY");
        }
        scope.sipTopupCapMonthYear = moment(scope.formData.topupCapMonthYear,"MMM-YYYY").format("MMM-YYYY");

        if(scope.transactionSubType === scope.SUMMARY_CONST.FLEX_STP.key){
          scope.formData.formType = scope.SUMMARY_CONST.FLEX_STP.value;
        } else if(scope.transactionSubType === scope.SUMMARY_CONST.SWING_STP.key){
          scope.formData.formType = scope.SUMMARY_CONST.SWING_STP.value;
        }
        // var _isPaymentDone = false;
        /*if(Object.keys(scope.formData).length === 1 && angular.isUndefined($stateParams.trackId)){
          $state.go('welcome');
        }*/


        function getSummaryToOpen() {
          if (scope.transactionSubType === scope.SUMMARY_CONST.FLEX_STP.key) {
            return scope.SUMMARY_CONST.FLEX_STP.type;
          } else if(scope.transactionSubType === scope.SUMMARY_CONST.SWING_STP.key){
            return scope.SUMMARY_CONST.SWING_STP.type;
          } else {
            return scope.transactionType;
          }

        }
        scope.makeTransaction = function(event) {
          scope.submitForm(event);
        }

        function getInvestorInfo() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              scope.investorInfo = resp.data;
            } else {
              scope.investorInfo = null;
              MessageService.error(resp.message);
            }
          }, error = function (err) {
            UtilService.errorHandler(err);
            scope.investorInfo = null;
          };
          InvestorService.get({
            child1: 'folio',
            child3: 'info'
          }).$promise.then(success, error);
        }

        function showSuccessModal(tid) {

          if (!scope.investorInfo) {
            scope.investorInfo = {};
            MessageService.error('Error while get investor info.');
          }
          var successModal = function (isChecked) {
              TransactionModel.setPayloadRawData(null);
              if (isChecked) {
                favrouiteApi(tid);
              }
              $state.go('welcome');
            },
            errorModal = function () {
              TransactionModel.setPayloadRawData(null);
              $state.go('welcome');
            };
          var type = scope.transactionType;
          if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
            type = 'FLEX INDEX'
          } else if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP) {
            if (scope.formData.formType === 'Flex STP') {
              type = scope.formData.formType;
            }
          }

          ModalService.initiateSuccessModal({
            transactionType: type,
            investorName: scope.investorInfo.name,
            isFavourite: scope.formData.isFavourite
          }, successModal, errorModal);
        }

        function favrouiteApi(tid) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                //MessageService.success(resp.message);
              } else {
                //MessageService.error(resp.message);
              }
            },
            error = function () {
              //   LoaderService.hideLoader();
              // UtilService.errorHandler(err);
            };
          LoaderService.showLoader();
          TransactionService.get({
            controller1: 'makeFavouriteTransaction',
            controller2: tid
          }).$promise.then(success, error);
        }

        function getDreamSipPayload() {
          if (scope.formData.bankInfo && scope.formData.bankInfo.bankName == "OTHER BANKS") {
            scope.formData.bankInfo.bankName = scope.formData.bankName;
          }
          Object.keys(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
            if(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == scope.formData.investmentOption)
              scope.formData.investmentOption = key;
          });
          var sipPayload = {
            installmentAmount: scope.formData.amount,
            investmentOption: scope.formData.investmentOption,
            dividendOption: scope.formData.dividendOption,
            formType: "DREAMSIP",
            euinOpted: (scope.formData.euin && scope.formData.euin.euinName) ? 'Y' : 'N',
            euinName: scope.formData.euin ? scope.formData.euin.euinName : '',
            euinCode: scope.formData.euin ? scope.formData.euin.euinCode : '',
            frequency: scope.formData.frequency,
            folioNumber: scope.formData.folioNumber,
            schemeCode: scope.formData.inSchemeCode,
            schemeType : scope.formData.schemeType,
            primaryFlag: scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
            toDate: scope.formData.endDate ? scope.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            sipDate: scope.formData.startDate ? scope.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            sipDay: scope.formData.day,
            id: scope.formData.sTransactionId,
            bankDetailsForECS: {
              accNumber: scope.formData.bankInfo.accountNumber? scope.formData.bankInfo.accountNumber : scope.formData.bankInfo.bankAcNo,
              bankName: scope.formData.bankInfo ? scope.formData.bankInfo.bankName : scope.formData.bankName,
              ifscCode: scope.formData.bankInfo ? scope.formData.bankInfo.ifscCode : '',
              branchName: scope.formData.bankInfo.bankBranch,
              bankCity: scope.formData.bankInfo.bankCity,
              paymentOption: scope.formData.sipPaymentOption === 'UPI' ? 'UAP' : scope.formData.sipPaymentOption,
              payoutId:scope.formData.bankInfo && scope.formData.bankInfo.payoutId,
              netBankingUrl: scope.formData.bankInfo.netBankingUrl,
              bankCode:scope.formData.bankInfo.bankCode,
              accType: scope.formData.bankInfo.bankAcType
            },
            brokerCode: scope.formData.brokerCode,
            option: scope.formData.option == 'Option A' ? 'A':'B',
            swapAmount:scope.formData.swapAmount,
            sipPeriod:scope.formData.sipPeriod,
            targetSchemeCode:scope.formData.targetSchemeCode?scope.formData.targetSchemeCode:null,
            targetSchemeName:scope.formData.targetSchemeName?scope.formData.targetSchemeName:null,
            subBrokerArn: scope.formData.subBrokerARN ? 'ARN-' + scope.formData.subBrokerARN:'',
            subBrokerCode: scope.formData.subBrokerCode,
            // sipTopupEnabled:scope.formData.sipTopupEnabled,
            riaConsent:scope.formData.riaConsent
            // topupDetails: {
            //   amount: scope.formData.topupDetails.amount,
            //   percentage: scope.formData.topupDetails.percentage,
            //   frequency: scope.formData.topupDetails.frequency,
            //   capAmount : scope.formData.topupDetails.capAmount,
            //   capMonthYear: scope.formData.topupDetails.capMonthYear
            // }
          };

            if (!sipPayload.investmentOption) {
              sipPayload.investmentOption = scope.formData.sipPaymentOption;
            }
            if (!sipPayload.dividendOption) {
              sipPayload.dividendOption = scope.formData.sipDividendOption;
            }
          if (scope.formData.sipPaymentOption == 'UPI') {
            sipPayload.bankDetailsForECS.paymentOption = 'UAP';
            sipPayload.paymentOption = 'UAP';
            sipPayload.payerVpa = scope.formData.virtualAddress;
            sipPayload.payerName = scope.formData.name;
          }
            var payload = {};

            if (scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
              sipPayload = handleBrokerCode(sipPayload);
              payload = angular.copy(sipPayload);
            }
            payload.trackId = scope.formData.trackId;
            if(scope.formData.sipPaymentOption==='E-mandate')
            {
              payload.bankDetailsForECS.authenticationMode = scope.formData.authMode.value;
              payload.bankDetailsForECSbankCode = scope.formData.bankInfo.bankCode;
              payload.mandateStartDate = scope.formData.emandateDate;
              payload.mandateEndDate = scope.formData.endDateEmandate;
              payload.mandateAmount = scope.formData.emandateAmount;
            }
            return payload;
        }
        function getFinalPayload() {
          var payload = null;
          switch (scope.transactionType) {
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP:
              payload = getStpPayload();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
              if(scope.formData.summaryType === "SIP_TOPUP"){
                payload = getSipTopupPayload();
              }else
                payload = getSipPayload();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.DREAM_SIP:
                payload = getDreamSipPayload();
                TransactionModel.setDreamSipPayloadRawData(payload);
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
              payload = getSwpPayload();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION:
              payload = getRedeemPayload();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH:
              payload = getSwitchPayload();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP:
              payload = getDtpPayload();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX:
              payload = getFlexIndexPayload();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION:
              payload = getInstantRedemptionPayload();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP:
              payload = getSmartSwpPayload();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP:
              payload = getSipPayload();
              break;
          }
          return payload;
        }
        function getFlexIndexPayload() {
          if (!scope.formData) {
            return null;
          }

          var payload = {
            "amountForRegistration": scope.formData.amount,
            "compositeTransactionId": "",
            "dividendOption": "Z",
            "euinCode": "",
            "euinName": "",
            "euinOpted": "",
            "folioNumber": scope.formData.folioNumber,
            "formType": 'FLEXINDEX',
            "id": "",
            "investmentMode": '',
            "investorUuid": "",
            "sourcePortal": "",
            "sourceScheme": scope.formData.outSchemeCode,
            "switchExecutionDetails":getSwitchExecutionDetails() ,
            "targetScheme": scope.formData.inSchemeCode,
            "subBrokerArn": scope.formData.subBrokerARN ? 'ARN-' + scope.formData.subBrokerARN:'',
            "subBrokerCode": scope.formData.subBrokerCode
          }

          if (scope.formData.investmentMode === 'Fixed') {
            payload.investmentMode = 'F';
          } else {
            payload.investmentMode = 'V';
          }
          payload = handleBrokerCode(payload);
          return angular.copy(payload);

        }

        function getSwitchExecutionDetails() {

          var obj = {
            "firstSwitchExecutionEntry": {
              "sensexLevelForSwitch": scope.formData.investmentModeData.stage1,
              "switchPercentage": scope.formData.investmentModeData.installment1
            },
            "secondSwitchExecutionEntry": {
              "sensexLevelForSwitch": scope.formData.investmentModeData.stage2,
              "switchPercentage": scope.formData.investmentModeData.installment2
            },
            "thirdSwitchExecutionEntry": {
              "sensexLevelForSwitch": scope.formData.investmentModeData.stage3,
              "switchPercentage": scope.formData.investmentModeData.installment3
            },
            "fourthSwitchExecutionEntry": {
              "sensexLevelForSwitch": scope.formData.investmentModeData.stage4,
              "switchPercentage": scope.formData.investmentModeData.installment4
            }
          }

          return obj;

        }

        function getStpPayload() {
          if (!scope.formData) {
            return null;
          }

          Object.keys(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
            if(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == scope.formData.investmentOption)
              scope.formData.investmentOption = key;
          });

          var payload = {
            investmentOption: scope.formData.investmentOption,
            dividendOption: scope.formData.dividendOption,
            stpType: scope.formData.stpType ? scope.formData.stpType : scope.formData.transferOption,
            folioNumber: scope.formData.folioNumber,
            sourceSchemeCode: scope.formData.outSchemeCode,
            stpDay: scope.formData.day,
            amount: scope.formData.amount,
            euinOpted: (scope.formData.euin && scope.formData.euin.euinName) ? 'Y' : 'N',
            euinName: scope.formData.euin ? scope.formData.euin.euinName : '',
            euinCode: scope.formData.euin ? scope.formData.euin.euinCode : '',
            targetSchemeCode: scope.formData.inSchemeCode,
            frequency: scope.formData.frequency,
            startDate: scope.formData.startDate && scope.formData.startDate.clone().format('DD-MMM-YYYY'),
            endDate: scope.formData.endDate && scope.formData.endDate.clone().format('DD-MMM-YYYY'),
            formType: scope.formData.formType,
            id: scope.formData.transactionId,
            noOfInstallments: scope.formData.noOfInstallments,
            subBrokerArn: scope.formData.subBrokerARN ? 'ARN-' + scope.formData.subBrokerARN:'',
            subBrokerCode: scope.formData.subBrokerCode
          };
          payload = handleBrokerCode(payload);
          return angular.copy(payload);
        }
        function getSipPayload() {
          if (scope.formData.bankInfo && scope.formData.bankInfo.bankName == "OTHER BANKS") {
            scope.formData.bankInfo.bankName = scope.formData.bankName;
          }

          if (typeof scope.formData.endDate === 'string') {
            scope.formData.endDate = $window.moment(scope.formData.endDate);
          }

          if (typeof scope.formData.startDate === 'string') {
            scope.formData.startDate = $window.moment(scope.formData.startDate);
          }

          var sipPayload = {
            installmentAmount: scope.formData.amount,
            investmentOption: scope.formData.investmentOption,
            dividendOption: scope.formData.dividendOption,
            formType: scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP ? scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP : scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
            euinOpted: (scope.formData.euin && scope.formData.euin.euinName) ? 'Y' : 'N',
            euinName: scope.formData.euin ? scope.formData.euin.euinName : '',
            euinCode: scope.formData.euin ? scope.formData.euin.euinCode : '',
            frequency: scope.formData.frequency,
            folioNumber: scope.formData.folioNumber,
            schemeCode: scope.formData.inSchemeCode,
            schemeType : scope.formData.schemeType,
            toDate: scope.formData.endDate ? scope.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            sipDate: scope.formData.startDate ? scope.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            sipDay: scope.formData.day,
            weeklyDay: scope.formData.weeklyDay,
            id: scope.formData.sTransactionId,
            bankDetailsForECS: {
              accNumber: scope.formData.sipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM ? scope.formData.bankInfo.bankAcNo : scope.formData.bankInfo.accountNumber,
              bankName: scope.formData.bankInfo ? scope.formData.bankInfo.bankName : scope.formData.bankName,
              ifscCode: scope.formData.bankInfo && scope.formData.bankInfo.ifscCode ? scope.formData.bankInfo.ifscCode : scope.formData.ifscCode,
              branchName: scope.formData.bankBranch,
              bankCity: scope.formData.bankCity,
              paymentOption: scope.formData.sipPaymentOption,
              payoutId:scope.formData.bankInfo && scope.formData.bankInfo.payoutId,
              netBankingUrl: scope.formData.netBankingUrl,
              bankCode:scope.formData.bankInfo.bankCode,
              accType: scope.formData.bankInfo.bankAcType ? scope.formData.bankInfo.bankAcType : scope.formData.bankAcType
            },
            subBrokerArn: scope.formData.subBrokerARN ? 'ARN-' + scope.formData.subBrokerARN:'',
            subBrokerCode: scope.formData.subBrokerCode,
            sipTopupEnabled:scope.formData.sipTopupEnabled,
            topupDetails: {
              amount: scope.formData.topupDetails.amount,
              percentage: scope.formData.topupDetails.percentage,
              frequency: scope.formData.topupDetails.frequency,
              capAmount : scope.formData.topupDetails.capAmount,
              capMonthYear: scope.formData.topupDetails.capMonthYear
            },
            netCoreRefNo : scope.formData.trackId
          };

          Object.keys(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
            if(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == scope.formData.investmentOption) {
              sipPayload.investmentOption = key;
            }
          });

          if (scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP) {
            sipPayload.primaryFlag = true
          } else {
            sipPayload.primaryFlag = false
          }

          if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP) {
            sipPayload.bankDetailsForECS.accNumber = scope.formData.flexSipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM ? scope.formData.bankInfo.bankAcNo : scope.formData.bankInfo.accountNumber;
            sipPayload.bankDetailsForECS.paymentOption = scope.formData.flexSipPaymentOption;
            sipPayload.flexSip = true;
            delete sipPayload.frequency;
            sipPayload.flexSipFrequency = scope.formData.frequency;
            // sipPayload.installmentAmountEMandate =  2 * sipPayload.installmentAmount
            delete sipPayload.topupDetails
          }

          if((scope.formData.sipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) || (scope.formData.flexSipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)){
              sipPayload.bankDetailsForECS.accNumber= scope.formData.bankInfo.accountNumber,
              sipPayload.bankDetailsForECS.accType=scope.formData.bankInfo.bankAcType,
              sipPayload.bankDetailsForECS.authenticationMode=scope.formData.authMode?scope.formData.authMode.value:'',
              sipPayload.bankDetailsForECSbankCode=scope.formData.bankInfo.bankCode
              sipPayload.mandateStartDate = scope.formData.emandateDate;
              sipPayload.mandateEndDate = scope.formData.endDateEmandate;
              sipPayload.mandateAmount = scope.formData.emandateAmount;
          }
          (scope.formData.bankInfo && angular.isDefined(scope.formData.bankInfo.camsMandateIdNo))
          &&(sipPayload.bankDetailsForECS.camsMandateIdNo=scope.formData.bankInfo.camsMandateIdNo);
          (scope.formData.bankInfo && angular.isDefined(scope.formData.bankInfo.omUmrn))
          &&(sipPayload.bankDetailsForECS.omUmrn=scope.formData.bankInfo.omUmrn);
          if(scope.formData.modifyAction == 'modifySip'){
            sipPayload.cancelTransactionRequestBody= {
              "transactionId": scope.formData.transactionId,
              "transactionType": scope.formData.investmentType
            }
          }
          if (scope.formData.sipPaymentOption == 'UPI') {
            sipPayload.bankDetailsForECS.paymentOption = 'UAP';
            sipPayload.paymentOption = 'UAP';
            sipPayload.payerVpa = scope.formData.virtualAddress;
            sipPayload.payerName = scope.formData.name;
          }
          var payload = {};
          if (!scope.formData.optionalInvestmentType && (scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP)) {
            payload = angular.copy(sipPayload);
          } else {
            payload = null;
          }
          payload = handleBrokerCode(payload);
          return payload;
        }
        function getSwpPayload() {
          if (!scope.formData) {
            return null;
          }

          var payload = {
            amount: scope.formData.amount,
            folioNumber: scope.formData.folioNumber,
            formType: scope.formData.formType,
            frequency: scope.formData.frequency,
            id: scope.formData.isFavourite ? "" : scope.formData.transactionId,
            schemeCode: scope.formData.outSchemeCode,
            startDate: scope.formData.startDate.clone().format('DD-MMM-YYYY'),
            toDate: scope.formData.endDate.clone().format('DD-MMM-YYYY'),
            swpDay: scope.formData.day,
            swpType: scope.formData.transferOption,
            accountNumber: scope.formData.bankInfo.bankAcNo,
            ifscCode: scope.formData.bankInfo.ifscCode,
            bankName: scope.formData.bankInfo.bankName,
            branchName: scope.formData.bankInfo.bankBranch,
            payMech: scope.formData.bankInfo.payMech,
            primaryBankFlag: scope.formData.bankInfo.primaryFlag,
            payoutId: scope.formData.bankInfo.payoutId
          };

          return angular.copy(payload);
        }

        function getSmartSwpPayload() {
          if (!scope.formData) {
            return null;
          }

          var payload = {
            amount: scope.formData.amount,
            folioNumber: scope.formData.folioNumber,
            formType: scope.formData.formType,
            frequency: scope.formData.frequency,
            percentage: scope.formData.percentage,
            id: scope.formData.isFavourite ? "" : scope.formData.transactionId,
            schemeCode: scope.formData.outSchemeCode,
            startDate: scope.formData.startDate.clone().format('DD-MMM-YYYY'),
            swpDay: scope.formData.day,
            accountNumber: scope.formData.bankInfo.bankAcNo,
            ifscCode: scope.formData.bankInfo.ifscCode,
            bankName: scope.formData.bankInfo.bankName,
            branchName: scope.formData.bankInfo.bankBranch,
            primaryBankFlag: scope.formData.bankInfo.primaryFlag,
            payoutId: scope.formData.bankInfo.payoutId,
            accountType: scope.formData.bankInfo.bankAcType
          };

          return angular.copy(payload);
        }


        function getRedeemPayload() {
          if (!scope.formData) {
            return null;
          }
          var payload = {
            folioNumber: scope.formData.folioNumber,
            formType: scope.transactionType,
            schemeCode: scope.formData.outSchemeCode,
            liquidFlag: scope.formData.liquidFlag,
            accountNumber: scope.formData.bankInfo.bankAcNo,
            ifscCode: scope.formData.bankInfo.ifscCode,
            bankName: scope.formData.bankInfo.bankName,
            branchName: scope.formData.bankInfo.bankBranch,
            payMech: scope.formData.bankInfo.payoutDescription,
            primaryBankFlag: scope.formData.bankInfo.primaryFlag,
            payoutId: scope.formData.bankInfo.payoutId,
            amount: scope.formData.amount,
            id: scope.formData.isFavourite ? "" : scope.formData.transactionId,
            units: scope.formData.units,
            transactionMode: scope.formData.amountType.toUpperCase(),
            requestId: scope.formData.nudgeRequestID,
            exitLoad: scope.formData.exitLoad,
            capitalGain: scope.formData.capitalGain
          };

          return angular.copy(payload);
        }

        function getInstantRedemptionPayload() {
          if (!scope.formData) {
            return null;
          }
          var payload = {
            folioNumber: scope.formData.folioNumber,
            formType: scope.transactionType,
            schemeCode: scope.formData.outSchemeCode,
            accountNumber: scope.formData.bankInfo.bankAcNo,
            ifscCode: scope.formData.bankInfo.ifscCode,
            bankName: scope.formData.bankInfo.bankName,
            branchName: scope.formData.bankInfo.bankBranch,
            payMech: scope.formData.bankInfo.payMech,
            primaryBankFlag: scope.formData.bankInfo.primaryFlag,
            payoutId: scope.formData.bankInfo.payOutId,
            amount: scope.formData.amount,
            id: scope.formData.isFavourite ? "" : scope.formData.transactionId,
            units: scope.formData.units
          };
          return angular.copy(payload);
        }

        function getSipTopupPayload() {
          if (!scope.formData) {
            return null;
          }
          var payload = {
            uuid :null,
            transactionId :scope.formData.transactionId ,
            folioNumber:scope.formData.folioNumber,
            schemeCode:scope.formData.schemeCode,
            amount:scope.formData.amount,
            frequency:scope.formData.frequency,
            topupAmount: scope.formData.topupAmount,
            topupPercentage:scope.formData.topupPercentage,
            topupFrequency:scope.formData.topupFrequency,
            topupCapAmount:scope.formData.topupCapAmount,
            topupCapMonthYear: scope.formData.topupCapMonthYear,
            toDate:scope.formData.toDate,
            bankDetailsForECS : {
              accType : scope.formData.bankInfo.bankAcType,
              accNumber: scope.formData.bankInfo.bankAcNo,
              bankName: scope.formData.bankInfo ? scope.formData.bankInfo.bankName : scope.formData.bankName,
              ifscCode: scope.formData.bankInfo.ifscCode,
              branchName: scope.formData.bankInfo.bankBranch,
              bankCity: scope.formData.bankCity,
              paymentOption: scope.formData.bankDetailsForECS.paymentOption,
              otmId: scope.formData.otmId,
              payoutId: scope.formData.bankInfo.payoutId
            },
            netCoreRefNo : scope.formData.trackId
          };
          return angular.copy(payload);
        }

        function getSwitchPayload() {
          Object.keys(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
            if(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == scope.formData.investmentOption)
              scope.formData.investmentOption = key;
          });
          var payload = {
            folioNumber: scope.formData.folioNumber,
            formType: scope.formData.formType,
            id: scope.formData.isFavourite ? "" : scope.formData.transactionId,
            investmentOption: scope.formData.investmentOption,
            dividendOption: scope.formData.dividendOption,
            switchInSchemeCode: scope.formData.inSchemeCode,
            switchOutSchemeCode: scope.formData.outSchemeCode,
            euinOpted: (scope.formData.euin && scope.formData.euin.euinName) ? 'Y' : 'N',
            euinName: scope.formData.euin ? scope.formData.euin.euinName : '',
            euinCode: scope.formData.euin ? scope.formData.euin.euinCode : '',
            units: scope.formData.units,
            amount: scope.formData.amount,
            subBrokerArn: scope.formData.subBrokerARN ? 'ARN-' + scope.formData.subBrokerARN:'',
            subBrokerCode: scope.formData.subBrokerCode,
            checkedNfoAutoSwitch: scope.formData.isAutoSwitch,
            autoSwitchScheme: scope.formData.isAutoSwitch? scope.formData.switchInSchemeCode : null,
            autoSwitchSchemeDividendOption: scope.formData.isAutoSwitch ? scope.formData.autoSwitchSchemeDividendOption : null,
            transactionMode: scope.formData.amountType.toUpperCase()
          };
          payload = handleBrokerCode(payload);
          return angular.copy(payload);

        }

        function getDtpPayload() {
          Object.keys(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
            if(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == scope.formData.investmentOption)
              scope.formData.investmentOption = key;
          });
          var payload = {
            folioNumber: scope.formData.folioNumber,
            formType: scope.formData.formType,
            brokerCode: scope.formData.brokerCode ? 'ARN-' + scope.formData.brokerCode : (scope.formData.distributorARN?scope.formData.distributorARN:''),
            euinOpted: (scope.formData.euin && scope.formData.euin.euinName) ? 'Y' : 'N',
            euinName: scope.formData.euin ? scope.formData.euin.euinName : '',
            euinCode: scope.formData.euin ? scope.formData.euin.euinCode : '',
            id: scope.formData.isFavourite ? "" : scope.formData.transactionId,
            dividendOption: scope.formData.dividendOption,
            investmentOption: scope.formData.investmentOption,
            sourceScheme: scope.formData.outSchemeCode,
            targetScheme: scope.formData.inSchemeCode,
            subBrokerArn: scope.formData.subBrokerARN ? 'ARN-' + scope.formData.subBrokerARN:'',
            subBrokerCode: scope.formData.subBrokerCode

          };
          return angular.copy(payload);
        }

        function handleSipResponse(data) {
          if (!data) {
            MessageService.error();
            return;
          }

          /*if (data.eMandateEnabled && data.paymentOption == 'EC') {
           openPaynimo(data.trxnNo, data.srnNo);
           }
           else if (!data.eMandateEnabled && (data.paymentOption == 'STANDING' || data.paymentOption == 'EC')) {
           ModalService.manualInstructionsModal({name: scope.investorName, srnNo: data.srnNo});
           }
           else {
           MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_APPROVED);
           }*/

          /*if (data.eMandateEnabled && data.paymentOption == 'EC') {
            openPaynimo(data.trxnNo, data.srnNo, data.pNMFreq);
          } else*/
          if (scope.formData.sipPaymentOption == 'UPI') {
            $window.location.href= data.redirectUrl;
          } else {
            if (scope.formData.investmentOption == Object.keys(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS)[1]){
              scope.formData.investmentOption = scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND;
            }


            if (typeof scope.formData.endDate === 'string') {
              scope.formData.endDate = $window.moment(scope.formData.endDate);
            }

            if (typeof scope.formData.startDate === 'string') {
              scope.formData.startDate = $window.moment(scope.formData.startDate);
            }

            var data = {
                investorName: scope.formData.folioInvestorName,
                folioInvestorName: scope.formData.folioInvestorName,
                srnNo: data.srnNo,
                folioNumber: scope.formData.folioNumber,
                schemeName: scope.formData.inSchemeName,
                investmentOption: scope.formData.investmentOption,
                amount: scope.formData.amount,
                sipDividendOption: scope.formData.sipDividendOption,
                netBankingUrl:scope.formData.netBankingUrl,
                paymentOption:data.paymentOption,
                transactionId:data.trxnNo,
                transactionInitiateDate:data.transactionInitiateDate,
                frequency:scope.formData.frequency,
                weeklyDay: scope.formData.weeklyDay ? scope.formData.weeklyDay : null,
                startDate:scope.formData.startDate ? scope.formData.startDate.format('DD-MMM-YYYY'):null,
                endDate:scope.formData.endDate ? scope.formData.endDate.format('DD-MMM-YYYY'):null,
                bankName:scope.formData.bankInfo ? scope.formData.bankInfo.bankName : scope.formData.bankName,
                bankAcNo:scope.formData.bankInfo ? scope.formData.bankInfo.bankAcNo : scope.formData.bankAcNo,
                transactionType : scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP ? 'Flex SIP' : 'SIP',
                schemeCode: scope.formData.inSchemeCode
              };

            if(scope.formData.investmentType == "DREAMSIP"){
              data.swapAmount = scope.formData.swapAmount,
              data.option = scope.formData.option ,
              data.sipPeriod = scope.formData.sipPeriod,
              data.investmentType = scope.formData.investmentType
            }
            ModalService.manualInstructionsModal(
              data
            );

            // Removed code under adobe script removal
            // if (scope.formData.investmentType == "SIP") {
              // UtilService.performDataLayerPushEventEcart(scope.formData.inSchemeName).then(function (resp) {
              //   NetcoreEvntService.COMPLETE_TRANSACTION_CART({
              //     cartItemSchemeNames: resp.cartItemSchemeNames,
              //     transactionSuccessSchemeNames: resp.transactionSuccessSchemeNames
              //   });
              // });
            // }

          }
        }

        function handleResponse() {
        }

        function approveTransaction($event) {
          var payload = getFinalPayload();

          if (!payload) {
            MessageService.error('Something went wrong while calculating payload.');
            return;
          }

          payload.formType = (payload.formType === 'Flex STP' || payload.formType === 'Swing STP') ? 'STP' : payload.formType;

          LoaderService.showLoader();
          var success = function (resp) {
              $event.currentTarget.disabled = false;
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                // _isPaymentDone = true;

                if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP && resp.data.trnxActionFlag === false) {
                  MessageService.error("Something went wrong");
                } else if ((scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP)) {
                  userActivityTracking(true, function(){
                    handleSipResponse(resp.data);
                  });
                }if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.DREAM_SIP) {
                  userActivityTracking(true, function(){
                    handleSipResponse(resp.data);
                  });
                }
                else if((scope.formData.sipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) || (scope.formData.flexSipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)){
                  userActivityTracking(true, function(){
                    handlePurchaseResponse(resp.data);
                  });
                }else if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION
                  || scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP
                  || scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH
                  || scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP
                  || scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP
                  || scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP
                  || scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX
                  || scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION
                ) {
                  localStorage.setItem('Transaction_Value',scope.formData.amountType);
                  var isFavourite = scope.formData.isFavourite ? true : false;
                  $state.go('main.summary-success', {
                    transactionId: resp.data.data,
                    transactionType: scope.transactionType, isFavourite: isFavourite
                  });

                } else {
                  LoaderService.hideLoader();
                  showSuccessModal(resp.data.data);
                }

              } else {
                LoaderService.hideLoader();
                if(resp.popupEnabled) {
                  ModalService.genericModal({
                    text: resp.message,
                    isAadhar: true
                  });
                } else {
                  MessageService.error(resp.message);
                }
                /*Netcore Event Start*/
                if(scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP){
                  NetcoreEvntService.Complete_Transaction_SIP_IP(scope.formData, false);
                }
                /*Netcore Event End*/
              }
            },
            error = function (err) {
              $event.currentTarget.disabled = false;
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };

          // var _controller2 = (scope.transactionType !== scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) ? scope.transactionType.toLowerCase() : 'multiple';

          var _controller2 = scope.transactionType.toLowerCase();


          var _config = {
            controller1: 'transaction',
            controller2: _controller2,
            controller3: 'approve'
          };

          if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
            _config.controller2 = 'flex-index';
            _config.controller3 = 'registration';
          } else if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION) {
            _config.controller2 = 'instant';
            _config.controller3 = 'redemption';
            _config.controller4 = 'approve';
            payload.formType = 'REDEMPTION';
          } else if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP && scope.formData.summaryType === "SIP_TOPUP") {
            _config.controller2 = 'existing';
            _config.controller3 = 'sip';
            _config.controller4 = 'topup';
            _config.controller5 = 'approve';
          }else if(scope.transactionType == "DREAM_SIP"){
            _config.controller2 = 'dream_sip';
          } else if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP) {
            _config.controller2 = 'flexSip'
          }

          if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
            LoaderService.hideLoader();
            var nudgeSuccess = function (res) {
              if(res === 'cancel') {
                $event.currentTarget.disabled = false;
              }
              if(res.key === 'approveRedeem') {
                LoaderService.showLoader();
                $event.currentTarget.disabled = false;
                payload.reasons = res.nudgeReason;
                if (res.nudgeReason === 'Other') {
                  payload.nudgeOtherReason = res.nudgeOtherReason;
                }
                transactionOtmConfirmation($event, _config, payload);
              }
            };
            ModalService.showNudgeReasons({Text:'Please let us know the reason for Redemption:',folioNumber:scope.formData.folioNumber, schemeCode: scope.formData.outSchemeCode, transactionType: scope.transactionType },nudgeSuccess);
            /*if(angular.isUndefined(payload.liquidFlag) || payload.liquidFlag === "N") {
              // commented code to show nudge modal for liquid scheme
            } else if (angular.isUndefined(payload.liquidFlag) || payload.liquidFlag === "Y") {
               transactionOtmConfirmation($event, _config, payload);
             }*/
          }
          else if(scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION
            && (angular.isUndefined(payload.liquidFlag) || payload.liquidFlag === "N")){
            transactionOtmConfirmation($event, _config, payload);
          }
          else if((scope.formData.sipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) || (scope.formData.flexSipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)){
            var successCallback = function (resp) {
              payload.secretLink = resp.secretLink;
              if(payload.bankDetailsForECS.paymentOption=="E-mandate")
                  payload.bankDetailsForECS.paymentOption="HEM";
              finalSubmit(payload);};
            var errorCallback = function (err) {
              LoaderService.hideLoader();
              scope.isCheckedTandC=true;
              scope.isCheckedTandCeMandate = true;
            };
            if(scope.formData && scope.formData.investmentType == "DREAMSIP"){
              // var data = {
              //   folioNumber:  scope.formData.folioNumber,
              //   type : scope.formData.investmentType,
              //   bank : payload.bankDetailsForECS.bankName.substring(0,payload.bankDetailsForECS.bankName.indexOf("-"))
              // }
              // ModalService.registerEMandateModal(data,successCallback,errorCallback)
              ModalService.registerEMandateModal({folioNumber:scope.formData.folioNumber,transactionType : scope.formData.investmentType, bankName :payload.bankDetailsForECS.bankName.substring(0,payload.bankDetailsForECS.bankName.indexOf("-")), authMode: payload.bankDetailsForECS.authenticationMode, randomOTPId: scope.formData.randomOTPId},successCallback,errorCallback)
            } else{
              ModalService.registerEMandateModal({folioNumber:payload.folioNumber,transactionType : scope.formData.investmentType, bankName :payload.bankDetailsForECS.bankName.substring(0,payload.bankDetailsForECS.bankName.indexOf("-")), authMode: payload.bankDetailsForECS.authenticationMode, randomOTPId: scope.formData.randomOTPId},successCallback,errorCallback)
            }
            LoaderService.hideLoader();
          }
          else {
            if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP ||
              scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP ||
              scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH ||
              scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP ||
              scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ||
              scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP ||
              scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP) {
              transactionOtmConfirmation($event, _config, payload);
            }  else {
              if(_config && _config.controller2 == "dream_sip" && _config.controller3 == "approve"){
                LoaderService.showLoader();
                // var modalPayload = {
                //   folioNumber: scope.formData.folioNumber,
                //   transactionType: scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION ?
                //     'INSTAREDEMPTION' : scope.transactionType
                // };
                var modalPayload = {
                  folioNumber: scope.formData.folioNumber,
                  transactionType:"DREAMSIP",
                  randomOTPId: scope.formData.randomOTPId
                };

                var success1 = function (resp) {
                  LoaderService.hideLoader();
                  if (resp.status && resp.data) {
                    var otpSuccessCallback = function() {
                      $event.currentTarget.disabled = false;
                      LoaderService.showLoader();
                      TransactionService.post(_config, payload).$promise.then(success, error);
                    };
                    var otpDismissCallback = function() {
                      $event.currentTarget.disabled = false;
                      LoaderService.hideLoader();
                    };
                    var otpDetails = {
                      secretOtpLink : resp.data.secretLink,
                      otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
                      otpId : resp.data.id
                    };
                    var config = _config;
                    ModalService.transactionOtpModal({
                      otpPayload: otpDetails,
                      config:  config,
                      payload: payload
                    }, otpSuccessCallback, otpDismissCallback);
                  } else {
                    LoaderService.hideLoader();
                    scope.otpSentMessage = '';
                    MessageService.error(resp.message)
                  }
                  scope.isProcessing = false;
                },
                error1 = function (err) {
                  LoaderService.hideLoader();
                  scope.otpResendMessage = '';
                  scope.isProcessing = false;
                  UtilService.errorHandler(err);
                };
                TransactionService.post2({
                  controller1: 'transaction',
                  controller2: 'otp'
                }, modalPayload).$promise.then(success1, error1);
              }else{
                TransactionService.post(_config, payload).$promise.then(success, error);
              }
            }
          }
        }

        function finalSubmit (payload) {
          var transactionType = scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP ? 'flexSip' : 'sip';
          LoaderService.showLoader();
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                userActivityTracking(true, function(){
                  handleEmandateSipResponse(resp.data);
                });
              } else {
                if(resp.popupEnabled) {
                  ModalService.genericModal({
                    text: resp.message,
                    isAadhar: true
                  });
                } else {
                  MessageService.error(resp.message);
                }
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };

            if(payload.formType == 'DREAMSIP'){
              delete payload.sipTopupEnabled;
            delete payload.topupDetails;
              TransactionService.post({
                controller1: 'transaction',
                controller2: 'dream_sip',
                controller3: 'approve'
              }, payload).$promise.then(success, error);
            }else{
              TransactionService.post({
                controller1: 'transaction',
                controller2: transactionType,
                controller3: 'approve'
              }, payload).$promise.then(success, error);
            }
        }

        function handleEmandateSipResponse(data) {
          data = data && data.data ? data.data : data;
          if (!data) {
            MessageService.error();
            return;
          }
          $window.location.href=scope.billdeskUrl+data.emandateMsg;
        }



        scope.init = function () {
          localStorage.setItem('Transaction_Value',scope.formData.amountType);
          if(angular.isDefined($stateParams.trackId) && angular.isDefined($stateParams.stepNo) && $stateParams.stepNo.toUpperCase() === "SECOND"){
            showPrefillValuesUserTracker(function () {
              if (!scope.formData) {
                $state.go('welcome');
                return null;

              }
            });
          }else{
            if (!scope.formData) {
              $state.go('welcome');
              return null;
            }
          }
          if(scope.transactionType != scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP)
            getInvestorInfo();
        };


        function showPrefillValuesUserTracker(cb) {
          cb = cb || function(){};
          // scope.transactionType = $stateParams.transactionType?$stateParams.transactionType.toUpperCase():"";

          var success = function (resp) {
              if (resp.data && resp.status) {
                scope.formData = resp.data.formdata || {};
                (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)&&(scope.formData.investmentType = scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE);
              } else {
                MessageService.error(resp.message);
              }
              cb();
            },
            error = function (err) {
              UtilService.errorHandler(err);
              cb();
            };
          TransactionService.get({
            controller1: 'userBehavior',
            controller2: $stateParams.trackId,
            controller3: 'getFormData'
          }).$promise.then(success, error);
        }

        function approveInstantRedemption(_config, payload) {
          LoaderService.showLoader('.popup');
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                var isFavourite = scope.formData.isFavourite ? true : false;
                $state.go('main.summary-success', {
                  transactionId: resp.data.data,
                  transactionType: scope.transactionType, isFavourite: isFavourite
                });
              } else {
                LoaderService.hideLoader();
                if(resp.popupEnabled) {
                  ModalService.genericModal({
                    text: resp.message,
                    isAadhar: true
                  });
                } else {
                  MessageService.error(resp.message);
                }
                $state.go('welcome');
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };


          TransactionService.post(_config, payload).$promise.then(success, error);
        }

        scope.finishPurchaseFirst = function ($event) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if (resp.data.hasWarning) {
                  var successModal = function () {
                    scope.submitForm($event);
                  }, errorModal = function () {
                  };
                  ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
                }
                else {
                  scope.submitForm($event);
                }
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
          var payload = {
            transactionType: scope.formData.investmentType,
            folioNumber: scope.formData.folioNumber,
            schemeCode: scope.formData.purchaseInSchemeCode,
            amount: scope.formData.purchaseAmount
          };
          LoaderService.showLoader();
          InvestorService.post({
            child1: 'transaction',
            child2: 'check',
            child3: 'duplicate'
          }, payload).$promise.then(success, error);
        };

        scope.submitFormSwitchFirst = function ($event) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if (resp.data.hasWarning) {
                  var successModal = function () {
                    scope.submitForm($event);
                  }, errorModal = function () {
                  };
                  ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
                }
                else {
                  scope.submitForm($event);
                }
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
          var payload = {
            transactionType: scope.formData.investmentType,
            folioNumber: scope.formData.folioNumber,
            targetSchemeCode: scope.formData.inSchemeCode,
            schemeCode: scope.formData.outSchemeCode,
            amount: scope.formData.amountType==='amount'? scope.formData.amount:undefined,
            units: scope.formData.amountType === 'all_units'|| scope.formData.amountType==='units'? scope.formData.units:undefined
          };
          LoaderService.showLoader();
          InvestorService.post({
            child1: 'transaction',
            child2: 'check',
            child3: 'duplicate'
          }, payload).$promise.then(success, error);
        };

        scope.submitRedeemFirst = function ($event) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if (resp.data.hasWarning) {
                  var successModal = function () {
                    scope.submitForm($event);
                  }, errorModal = function () {
                  };
                  ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
                }
                else {
                  scope.submitForm($event);
                }
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
          var payload = {
            transactionType: scope.formData.investmentType||scope.formData.formType,
            folioNumber: scope.formData.folioNumber,
            targetSchemeCode: scope.formData.inSchemeCode,
            schemeCode: scope.formData.outSchemeCode,
            amount: scope.formData.amountType==='amount'? scope.formData.amount:undefined,
            units: scope.formData.amountType === 'all_units'|| scope.formData.amountType==='units'? scope.formData.units:undefined
          };
          LoaderService.showLoader();
          InvestorService.post({
            child1: 'transaction',
            child2: 'check',
            child3: 'duplicate'
          }, payload).$promise.then(success, error);
        };

        scope.submitInstantRedeemFirst = function ($event) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if (resp.data.hasWarning) {
                  var successModal = function () {
                    scope.submitForm($event);
                  }, errorModal = function () {
                  };
                  ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
                }
                else {
                  scope.submitForm($event);
                }
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
          var payload = {
            transactionType: scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION,
            folioNumber: scope.formData.folioNumber,
            schemeCode: scope.formData.outSchemeCode,
            amount: scope.formData.amount,
            units: scope.formData.units
          };
          LoaderService.showLoader();
          InvestorService.post({
            child1: 'transaction',
            child2: 'check',
            child3: 'duplicate'
          }, payload).$promise.then(success, error);
        };

        scope.submitForm = function ($event) {
          if((scope.formData.sipPaymentOption && (scope.formData.sipPaymentOption != scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)) || (scope.formData.flexSipPaymentOption && (scope.formData.flexSipPaymentOption != scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE))){
            $event.currentTarget.disabled = true;}
          if(scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ||
            scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE ||
            scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.DREAM_SIP ||
            scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP
          ){
            userActivityTracking(false, function(statusFlag){
              var params = {};
              if((statusFlag && statusFlag.transactionId)||($stateParams.trackId)){
                params.trackId = statusFlag.transactionId || $stateParams.trackId;
                scope.formData.trackId = statusFlag.transactionId || $stateParams.trackId;
              }
              if (scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || scope.formData.optionalInvestmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
                $state.go('main.transactions.payment',params);
              }
              else if(scope.formData.sipFirstInstallment)
              {
                params.sipWithFirstInstallment=true;
                if(scope.formData.investmentType == "DREAMSIP"){
                  TransactionModel.setPayloadRawData(angular.copy(scope.formData));
                }
                if (scope.formData.sipPaymentOption == 'UPI') {
                  params.isUpi = true;
                }
                $state.go('main.transactions.payment',params);
              }
              else {
                approveTransaction($event)
              }
            });
          }else{
            if (scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || scope.formData.optionalInvestmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
              $state.go('main.transactions.payment');
            } else {
              approveTransaction($event)
            }
          }
        };

        function userActivityTracking(isProcessed, cb){

          /*Netcore Event Start*/
          if(isProcessed && (scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP)){
            NetcoreEvntService.Complete_Transaction_SIP_IP(scope.formData, true);
          }else if(scope.formData.investmentType===scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
            // NetcoreEvntService.Complete_Transaction_Purchase_IP(scope.formData, true);
          }
          /*Netcore Event End*/
          cb = cb || function(){};
          if(scope.transactionType != scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP &&
            scope.transactionType != scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE &&
            scope.transactionType != scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP &&
            scope.transactionType != scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.DREAM_SIP
          ){
            cb(true);
          }
          var success = function(trackResp){
            trackResp = trackResp.data || trackResp;
            LoaderService.hideLoader();
            cb(trackResp);
          }, error = function(err){
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
            cb(err);
          };
          LoaderService.showLoader();
          var userTrackerPayload = setUserTrackerPayload(isProcessed);
          InvestorService.post({
            child1: 'userBehavior',
            child2: 'addupdate'
          },userTrackerPayload).$promise.then(success, error);
        }

        function setUserTrackerPayload(isProcessed){
          var _payload = {
            "trxnRefNo": $stateParams.trackId?$stateParams.trackId:"", //required in case of update
            "trxnType": scope.formData.investmentType, //SIP, PURCHASE
            "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
            "step": "SECOND", // FIRST,SECOND,THIRD,FOURTH
            "schemeCd": scope.formData.purchaseInSchemeCode, // required
            "folioNo": scope.formData.folioNumber, // required
            "formData": angular.copy(scope.formData), // required
            "amount": scope.formData.purchaseAmount, //required
            "trxnStatus": isProcessed ? "PROCESSED": "OPEN"  // OPEN,PROCESSED
          };

          if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            _payload.formData.startDate = $window.moment(angular.copy(scope.formData.startDate),"DD-MMM-YYYY").format("DD-MMM-YYYY");
            _payload.formData.endDate = $window.moment(angular.copy(scope.formData.endDate),"DD-MMM-YYYY").format("DD-MMM-YYYY");
            _payload.formData.minEndDate = $window.moment(angular.copy(scope.formData.minEndDate),"DD-MMM-YYYY").format("DD-MMM-YYYY");
            _payload.formData.maxEndDate = $window.moment(angular.copy(scope.formData.maxEndDate),"DD-MMM-YYYY").format("DD-MMM-YYYY");
          }

          return _payload;
        }

        scope.goToBack = function () {
          scope.isSummaryViewEnabled = false;/*
          if(scope.transactionType ==='INSTANT_REDEMPTION'){
            var goTo= "main.transactions.instantRedemption";
          } else {
            goTo = "main.transactions."+scope.transactionType.toLowerCase();
          }
          var params = {};
          ($stateParams.trackId)&&(params.trackId=$stateParams.trackId);
          $state.go(goTo, params);*/
          /*if (!$state.$previous) {
            return;
          }
          $state.go($state.$previous.name, $state.$previous.param);*/
        };

        scope.goToNewFolioCreation = function () {
           var success = function () {
              scope.isSummaryViewEnabled = false;
                LoaderService.showLoader();
                var success = function (resp) {
                  LoaderService.hideLoader();
                  if (resp.status && resp.data) {
                    // if(resp.data.folioResponseDTO && resp.data.folioResponseDTO.uuid){
                    //    var dreamSipPayloadData = getdreamSipPayload();
                    //    TransactionModel.setDreamSipPayloadRawData(dreamSipPayloadData);
                    //    $state.go('main.folio.review',{investorId:resp.data.folioResponseDTO.uuid,isDreamSip:'true'});
                    //  }
                     if(resp.data.id){
                      var dreamSipPayloadData = getdreamSipPayload();
                      dreamSipPayloadData.uuid = resp.data.id;
                      localStorage.setItem('isDreamSip','true');
                      TransactionModel.setDreamSipPayloadRawData(dreamSipPayloadData);
                      $state.go('main.folio.review',{investorId:resp.data.id});
                    }else{
                      MessageService.error(resp.message);
                    }
                  LoaderService.hideLoader();
                } else {
                  MessageService.error(resp.message);
                  LoaderService.hideLoader();
                }
              },
                error = function (err) {
                  LoaderService.hideLoader();
                  UtilService.errorHandler(err);
                };
                InvestorService.get({
                  child1: 'dreamSip',
                  child2: 'getUuid',
                  child3: scope.formData.folioNumber
              }).$promise.then(success, error);
            },
            error = function () {
            };
          ModalService.dreamSipPointToNoteModal({}, success, error);
        };

        scope.showTermConditions = function () {
          var transactionType = "";
          if (scope.transactionType.toLowerCase().includes("schedule")) {
            transactionType = scope.transactionType.substr(scope.transactionType.lastIndexOf("_")+1, scope.transactionType.length);
          } else {
            transactionType = scope.transactionType;
          }
          ModalService.transactionalTermConditionModal({'transactionType':transactionType,'subTransactionType':scope.formData.formType});
        };

        scope.showTermConditionsemandate = function () {
          ModalService.transactionalTermConditionModalEMandate({'transactionType': 'SIP-E-MANDATE','subTransactionType':scope.formData.formType});
        };

        scope.ischeckedem = function () {
          if(scope.isCheckedTandCeMandate === false) {
            scope.isCheckedTandCeMandate = true;
          }
          else{
            scope.isCheckedTandCeMandate = false;
          }
        }

        /*-------------------------- Schedule transaction --------------------- */
        /**
         * Function to handle view schedule transaction from View Scheduled transaction section
         *
         */
        scope.redirectToSavedItems = function() {
          $state.go('main.saved-items', {});
        };

        /**
         *   function to handle schedule transaction action
         * */
        scope.handleScheduleTransactionAction = function() {
          LoaderService.showLoader();
          var success = function(resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              $window.sessionStorage.setItem("summayPayload", angular.toJson(createPayloadForSummary(resp.data)));
              $state.go('main.schedule-transaction-success', {
                transactionId: resp.data.transactionId,
                transactionType: resp.data.transactionType,
                params: {
                  summaryData: $window.sessionStorage.getItem("summayPayload")
                }
              });
            } else {
              LoaderService.hideLoader();
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message,
                  isAadhar: true
                },function () {
                  $state.go('welcome');
                } , function () {});
              } else {
                MessageService.error(resp.message);
                $state.go('welcome');
              }
            }
          }, error = function(resp) {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
            $state.go('welcome');
          }
          var payload = {};
          switch (scope.formData.scheduleDetails.state) {
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH:
              payload = getSwitchPayloadToSubmit();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
              payload = getPurchasePayloadToSubmit();
              break;
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION:
              payload = getRedeemPayloadToSubmit();
              break;
          }
          TransactionService.post({
            controller1: "schedule",
            controller2: "transaction",
            controller3: scope.formData.scheduleDetails.state.toLowerCase(),
            controller4: "save"
          }, payload).$promise.then(success, error);
        }

        /*
        * function to create switch schedule payload for submit
        */
        function getSwitchPayloadToSubmit() {
          var payload = {
            "folioNumber": scope.formData.folioNumber,
            "formType": scope.formData.formType,
            "investmentOption": scope.formData.investmentOption,
            "dividendOption": scope.formData.dividendOption,
            "switchOutSchemeName": scope.formData.outSchemeName,
            "switchOutSchemeCode": scope.formData.outSchemeCode,
            "switchInSchemeName": scope.formData.inSchemeName,
            "switchInSchemeCode": scope.formData.inSchemeCode,
            "euinOpted": scope.formData.euinOpted,
            "euinName": scope.formData.euin ? scope.formData.euin.euinName : '',
            "euinCode": scope.formData.euin ? scope.formData.euin.euinCode : '',
            "subBrokerARN": scope.formData.subBrokerARN,
            "subBrokerCode": scope.formData.subBrokerCode,
            "autoSwitchScheme": scope.formData.autoSwitchScheme,
            "autoSwitchSchemeDividendOption": scope.formData.autoSwitchSchemeDividendOption,
            "amount": scope.formData.amount,
            "units": scope.formData.units,
            "schedule_frequency": fetchFrequency(),
            "schedule_from_date": $window.moment(scope.formData.scheduleDetails.scheduleDate, "DD-MMM-YYYY").format("DD-MMM-YYYY"),
            "transactionMode": scope.formData.amountType.toUpperCase()
          };
          if (scope.formData.scheduleDetails.endDate) {
            payload['schedule_to_date'] = $window.moment(scope.formData.scheduleDetails.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
          }
          payload = handleBrokerCode(payload);
          return payload;
        }

        /*
        * function to create purchase schedule payload for submit
        */
        function getPurchasePayloadToSubmit() {
          var payload = {
            "amount": scope.formData.purchaseAmount,
            "investmentOption": scope.formData.purchaseInvestmentOption,
            "dividendOption": scope.formData.purchaseDividendOption,
            "folioNumber": scope.formData.folioNumber,
            "formType": scope.formData.investmentType,
            "primaryFlag": true,
            "euinOpted": scope.formData.euinOpted,
            "euinName": scope.formData.euin ? scope.formData.euin.euinName : "",
            "euinCode": scope.formData.euin ? scope.formData.euin.euinCode : "",
            "schemeName": scope.formData.purchaseInSchemeName,
            "schemeCode": scope.formData.purchaseInSchemeCode,
            "autoSwitchScheme": scope.formData.autoSwitchScheme,
            "autoSwitchSchemeDividendOption": scope.formData.autoSwitchSchemeDividendOption,
            "subBrokerARN": scope.formData.subBrokerARN,
            "subBrokerCode": scope.formData.subBrokerCode,
            "schedule_frequency": fetchFrequency(),
            "schedule_from_date": $window.moment(scope.formData.scheduleDetails.scheduleDate, "DD-MMM-YYYY").format("DD-MMM-YYYY")
          };
          if (scope.formData.scheduleDetails.endDate) {
            payload['schedule_to_date'] = $window.moment(scope.formData.scheduleDetails.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
          }
          payload = handleBrokerCode(payload);
          return payload;
        }

        /*
        * function to create redeem schedule payload for submit
        */
        function getRedeemPayloadToSubmit() {
          var payload = {
            "folioNumber": scope.formData.folioNumber,
            "formType": scope.formData.formType,
            "schemeName": scope.formData.outSchemeName,
            "schemeCode":  scope.formData.outSchemeCode,
            "accountNumber":  scope.formData.bankInfo.bankAcNo,
            "ifscCode":  scope.formData.bankInfo.ifscCode,
            "bankName":  scope.formData.bankInfo.bankName,
            "branchName":  scope.formData.bankInfo.bankBranch,
            "primaryBankFlag":  scope.formData.bankInfo.primaryFlag,
            "payoutId":  scope.formData.bankInfo.payoutId,
            "payoutDesc": scope.formData.bankInfo.payoutDescription,
            "amount":  scope.formData.amount,
            "units":  scope.formData.units,
            "schedule_frequency":  fetchFrequency(),
            "schedule_from_date":  $window.moment(scope.formData.scheduleDetails.scheduleDate, "DD-MMM-YYYY").format("DD-MMM-YYYY"),
            "transactionMode": scope.formData.amountType.toUpperCase(),
            "exitLoad": scope.formData.exitLoad,
            "capitalGain": scope.formData.capitalGain
          };
          if (scope.formData.scheduleDetails.endDate) {
            payload['schedule_to_date'] = $window.moment(scope.formData.scheduleDetails.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
          }
          return payload;
        }

        function fetchFrequency() {
          if (scope.formData.scheduleDetails.frequency === 'One-time') {
            return 'OT';
          } else if (scope.formData.scheduleDetails.frequency === 'Monthly') {
            return 'OM'
          } else if (scope.formData.scheduleDetails.frequency === 'Weekly') {
            return 'W';
          }
        }

        /**
         *  Function to handle cancel action from cancel scheduled transaction
         */
        scope.handleCancelAction = function() {
          var confirmSuccess = function () {
            cancelScheduleTransaction();
          };
          var confirmError = function () {
          };
          ModalService.confirmCancelModal({Text: "Are you sure you want to cancel the scheduled transaction?"}, confirmSuccess, confirmError);
        };

        function cancelScheduleTransaction() {
          var success = function(response) {
            if (response.data) {
              MessageService.success(response.data.trnxActionMsg);
              $state.go('main.saved-items', {});
            } else {
              UtilService.errorHandler(response.message);
            }
          }, error = function(err) {
            UtilService.errorHandler(err);
          }
          var payload = {
            transactionId: $stateParams.transactionId,
            transactionType: $stateParams.transactionType,
            baseTransactionId: "",
            transactionStatus: 'CANCELLED'
          };
          TransactionService.post({
            controller1: 'schedule',
            controller2: 'transaction',
            controller3: 'update',
            controller4: 'status'
          }, payload).$promise.then(success, error);
        }

        function createPayloadForSummary(data) {
          var payload = {
            amount: (scope.formData.amount && scope.formData.amount !== "") ? scope.formData.amount : scope.formData.purchaseAmount,
            units: scope.formData.units,
            euin: scope.formData.euin,
            folioNumber: scope.formData.folioNumber,
            scheduleDetails: scope.formData.scheduleDetails,
            transactionType: scope.formData.scheduleDetails.state,
            sourceSchemeName: !angular.isUndefined(scope.formData.purchaseInSchemeName) ? scope.formData.purchaseInSchemeName : scope.formData.outSchemeName,
            targetScheme: !angular.isUndefined(scope.formData.inSchemeName)  ? scope.formData.inSchemeName : "",
            investmentOption: !angular.isUndefined(scope.formData.purchaseInvestmentOption) ? scope.formData.purchaseInvestmentOption : scope.formData.investmentOption,
            dividendOption: scope.formData.dividendOption,
            bankInfo: scope.formData.bankInfo,
            transactionId: data.transactionId,
            transactionMode: scope.formData.amountType.toUpperCase()
          };
          Object.keys(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
            if(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == payload.investmentOption)
              payload.investmentOption = key;
          });
          payload = handleBrokerCode(payload);
          return payload;
        }

        /*
        * Function responsible to manage the broker code for purchase and sip payload
        * */
        function handleBrokerCode(payload) {
          if (scope.formData.isThroughDistributor) {
            payload['brokerCode'] = scope.formData.brokerCode ? 'ARN-' + scope.formData.brokerCode : (scope.formData.distributorARN ? scope.formData.distributorARN : '');
            payload['riaConsent'] = false;
          } else if (scope.formData.isThroughRia) {
            if (scope.formData.investmentType === 'PURCHASE' || scope.formData.investmentType === "SIP" || scope.formData.investmentType === "FLEXSIP") {
              payload['brokerCode'] = scope.formData.riaBrokerCode;
              sessionStorage.setItem('riaName',  scope.formData.riaBrokerName);
            } else {
              payload['brokerCode'] = scope.formData.brokerCode ? scope.formData.brokerCode : (scope.formData.distributorARN ? scope.formData.distributorARN : '');
              sessionStorage.setItem('riaName',  scope.formData.brokerName);
            }
            payload['riaConsent'] = true;
          } else if (scope.formData.isDirect) {
            payload['brokerCode'] = '';
            payload['riaConsent'] = false;
          }
          return payload;
        }

        function approveRedeem(_config, payload) {
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              localStorage.setItem('Transaction_Value',scope.formData.amountType);
              var isFavourite = scope.formData.isFavourite ? true : false;
              $state.go('main.summary-success', {
                transactionId: resp.data.data,
                transactionType: scope.transactionType, isFavourite: isFavourite
              });
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
              $state.go('welcome');
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          TransactionService.post(_config, payload).$promise.then(success, error);
        }

        function transactionOtmConfirmation($event, _config, payload) {
          var otpSuccessCallback, otpDismissCallback;
          otpSuccessCallback = function(resp) {
            $event.currentTarget.disabled = false;
            LoaderService.hideLoader();
            if(scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP){
              scope.callApproveForSip($event, _config, payload);
            }else {
              scope.callApprove(_config, payload)
            }
          };
          otpDismissCallback = function(err) {
            $event.currentTarget.disabled = false;
            LoaderService.hideLoader();
          };
          LoaderService.showLoader();
          var modalPayload = {
            folioNumber: scope.formData.folioNumber,
            transactionType: scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION ?
              'INSTAREDEMPTION' : scope.transactionType,
            randomOTPId: scope.formData.randomOTPId
          };
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              var otpDetails = {
                secretOtpLink : resp.data.secretLink,
                otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
                otpId : resp.data.id
              };
              var config = _config;
              payload.secretLink = resp.data.secretLink;

              if (scope.formData.sipPaymentOption == 'UPI') {
                var noteUpiModal =  scope.noteUpiOtp;
              }
              ModalService.transactionOtpModal({
                otpPayload: otpDetails,
                config:  config,
                payload: payload,
                upiModalOtp : noteUpiModal
              }, otpSuccessCallback, otpDismissCallback);
            } else {
              LoaderService.hideLoader();
              scope.otpSentMessage = '';
              MessageService.error(resp.message)
            }
            scope.isProcessing = false;
          },
          error = function (err) {
            LoaderService.hideLoader();
            scope.otpResendMessage = '';
            scope.isProcessing = false;
            UtilService.errorHandler(err);
          };
          TransactionService.post2({
            controller1: 'transaction',
            controller2: 'otp'
          }, modalPayload).$promise.then(success, error);
        }


        function callApprove(config,payload) {
          LoaderService.showLoader();
          var success, failure;
          success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              if (resp.status && resp.data) {
                localStorage.setItem('Transaction_Value',scope.formData.amountType);
                var isFavourite = scope.formData.isFavourite ? true : false;
                $state.go('main.summary-success', {
                  transactionId: resp.data.data,
                  transactionType: scope.transactionType, isFavourite: isFavourite
                });
              } else {
                LoaderService.hideLoader();
                MessageService.error(resp.message);
              }
            } else {
              LoaderService.hideLoader();
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message,
                  isAadhar: true
                });
              } else {
                MessageService.error(resp.message);
              }
            }
          };
          failure = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          TransactionService.post(config,payload).$promise.then(success, failure);
        }

        function callApproveForSip($event,config,payload) {
          LoaderService.showLoader();
          var success, error;
          success = function (resp) {
              $event.currentTarget.disabled = false;
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP) {
                  userActivityTracking(true, function(){
                    handleSipResponse(resp.data);
                  });
                }
                else {
                  LoaderService.hideLoader();
                  showSuccessModal(resp.data.data);
                }

              } else {
                LoaderService.hideLoader();
                if(resp.popupEnabled) {
                  ModalService.genericModal({
                    text: resp.message,
                    isAadhar: true
                  });
                } else {
                  MessageService.error(resp.message);
                }
                /*Netcore Event Start*/
                if(scope.formData.investmentType===scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP){
                  // NetcoreEvntService.Complete_Transaction_SIP_IP(scope.formData, false);
                }
                /*Netcore Event End*/
                if (scope.formData.investmentType===scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
                  userActivityTracking(false, function(resp) {
                    var data = scope.formData;
                    data.deeplink = resp.trxnUniqueLink;
                    data.schemeName = scope.formData.inSchemeName;
                    data.transactionType = scope.formData.investmentType;
                    NetcoreEvntService.sip_Transaction_Success_Registration(scope.formData, 'failure');
                  });
                }
              }
            },
            error = function (err) {
              $event.currentTarget.disabled = false;
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
          TransactionService.post(config,payload).$promise.then(success, error);
        }

      }
    }
  }
})();

(function() {
    'use strict';
    angular
    .module('hdfc-mf-investor-web')
    .controller('ScheduleTransactionSuccessController', scheduleTransactionSuccessController);

    /** @ngInject */
    function scheduleTransactionSuccessController(AppConstants, $stateParams, $window , NetcoreEvntService) {
      var vm = this;
      vm.transactionId = $stateParams.transactionId;
      vm.transactionType = $stateParams.transactionType;
      vm.isFavourite = $stateParams.isFavourite;
      vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
      vm.ROLLOVER_MODE = angular.copy(AppConstants.TRANSACTION_LIST_FILTER.ROLLOVER_MODE);
      vm.init = init;
      vm.ONEClickHDFCBankFlow = sessionStorage.getItem('ONEClickHDFCBankFlow');

      function init() {
        vm.formData = $stateParams.summaryData || angular.fromJson($window.sessionStorage.getItem("summayPayload"));
        if(vm.formData.amount){
          $window.NumToWord(vm.formData.amount, 'scheduleStatusDisplayWords', vm.formData);
        }
        vm.switchExecutionDetails = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX && vm.formData.switchExecutionDetails;
        performDataLayerPushEvent();
      }

      vm.clearSessionStorage = function() {
          $window.sessionStorage.removeItem("summayPayload");
      }

      function performDataLayerPushEvent() {
        if (vm.formData.formData && vm.formData.formData.purchasePaymentOption === 'OTM') {
          var data = getDataToBePushed();
          NetcoreEvntService.Transaction_Success('purchase', data);
        }
      }

      function getDataToBePushed() {
        return {
          transaction_id: vm.transactionId,
          value: vm.formData.amount,
          tax: 0,
          currency: "INR",
          userId: vm.formData.userId,
          status : "success",
          transaction_time: vm.formData.transactionTime, //yy-mm-dd hh:mm:ss
          transaction_type: vm.formData.transactionType === 'PURCHASE' ? 'Purchase' : vm.formData.transactionType,
          source : 'OTM (One Time Mandate)',
          items: [{
            item_id: vm.formData.folioNumber,
            item_name: vm.formData.sourceSchemeName,
            item_category: vm.formData.sourceSchemeCode,
            item_category2: vm.formData.investorName.trim(),
            item_category3: vm.formData.encryptedPanNumber,//Encrypted value
            price: vm.formData.amount,
            quantity: "N/A"
          }]
        };
      }

    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PaymentStatusController', paymentStatusController);

  /** @ngInject */
  function paymentStatusController($state, $stateParams, UtilService, TransactionService, MessageService, LoaderService,
                                   AppConstants, $window, AuthService, $timeout, $scope, $rootScope, HDFC_API, NetcoreEvntService, InvestorService) {
    var vm = this;
    vm.constants = AppConstants;
    vm.PAYMENT_OPTIONS = AppConstants.PAYMENT_METHODS_LIST;
    vm.showWhatsApp = false;
    vm.transactionDetails = {};
    vm.redirectToHome = redirectToHome;
    vm.performRedirect = performRedirect;
    vm.flowName = AppConstants.PRE_LOGIN_JOURNEY_ENUM;
    vm.CORPORATE_URL = HDFC_API.CORPORATE_URL;
    var removeListeners = {}, isRefreshing = false;
    var scope = $scope;
    vm.utilService = UtilService;
    if ($stateParams.status) {
      // in case of razor pay we will get status pending
      vm.isPending = true;
    }

    vm.init = init();

    function init() {
      LoaderService.showLoader();
      if (!$stateParams.cart_id) {
        MessageService.error(AppConstants.ToastrMessage.PAYMENT_FAILED);
        return;
      }
      if ($stateParams.cart_id && !$stateParams.pt) {
        submitReceivedMsg($stateParams.cart_id);
        vm.cartId = $stateParams.cart_id;
      } else if ($stateParams.cart_id && $stateParams.pt) {
        vm.transactionType = $stateParams.tType;
        fetchTransactionSummary($stateParams.cart_id, $stateParams.pt);
      }
      if ($stateParams.platform !== 'ANDROID' && $stateParams.platform !== 'IOS') {
        setListeners();
      } else if ($stateParams.platform === 'ANDROID' || $stateParams.platform === 'IOS'){
        vm.isMobile = true;
      }
    }

    function performRedirect(type) {
      if (type === 'PURCHASE') {
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/transactions/initiate/purchase', "_self");
        //$state.go('main.transactions.purchase');
      } else if (type === 'SIP') {
        $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/transactions/initiate/sip', "_self");
      } else if (type === 'SIPPURCHASE') {
        if (!vm.isPurchaseSuccess) {
          $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/transactions/initiate/purchase', "_self");
        } else {
          $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/transactions/initiate/sip', "_self");
        }
      }
    }

    function redirectToHome() {
      $window.open(HDFC_API.PROTOCOL + HDFC_API.PATH + '/welcome', "_self");
    }

    function submitReceivedMsg(cart_id) {
      var success = function(resp) {
        if (resp) {
          LoaderService.hideLoader();
          vm.transactionDetails = resp;
          if (vm.transactionDetails.transactionDateTime) {
            vm.transactionDetails.transactionInitiatedAt = $window.moment(vm.transactionDetails.transactionDateTime).format("DD MMM YYYY hh:mm:ss A");
            vm.installmentDate = angular.copy($window.moment(vm.transactionDetails.transactionDateTime).format("DD MMM YYYY"));
          } else {
            vm.transactionDetails.transactionInitiatedAt = $window.moment(vm.transactionDetails.transactionInitiatedAt).format("DD MMM YYYY hh:mm:ss A");
            vm.installmentDate = angular.copy($window.moment(vm.transactionDetails.transactionInitiatedAt).format("DD MMM YYYY"));
          }
          identifyPostLogin();
          vm.errorMessage = vm.transactionDetails.message;
          if (vm.transactionDetails.cartItems[0].sipOpted && vm.transactionDetails.cartItems[0].purchaseOpted) {
            vm.isSipPurchase = true;
            vm.transactionDetails.transactionType = 'SIPPURCHASE';
            vm.transactionDetails.sipDuration = $window.moment(vm.transactionDetails.cartItems[0].sipDate).format("DD MMM YYYY") + ' - ' + $window.moment(vm.transactionDetails.cartItems[0].toDate).format("DD MMM YYYY");
            vm.transactionDetails.investThrough = vm.transactionDetails.cartItems[0].brokerCode;
            vm.isSuccess = vm.transactionDetails.cartItems[0].purchasePaymentStatus === 'Successful' || vm.transactionDetails.cartItems[0].sipPaymentStatus === 'Successful';
            vm.isSipSuccess = vm.transactionDetails.cartItems[0].sipPaymentStatus === 'Successful';
            vm.isPurchaseSuccess = vm.transactionDetails.cartItems[0].purchasePaymentStatus === 'Successful'
            vm.installmentDate = angular.copy($window.moment(vm.transactionDetails.cartItems[0].sipDate).format("DD MMM YYYY"));
            vm.showInstallments = vm.transactionDetails.cartItems[0].sipDate !== vm.transactionDetails.cartItems[0].toDate;

            if (vm.showInstallments) {
              if (vm.transactionDetails.cartItems[0].frequency && vm.transactionDetails.cartItems[0].frequency === 'OM') {
                vm.installmentText = 'month';
              } else if (vm.transactionDetails.cartItems[0].frequency && vm.transactionDetails.cartItems[0].frequency === 'Q') {
                vm.installmentText = 'quarter';
              } else if (vm.transactionDetails.cartItems[0].frequency && vm.transactionDetails.cartItems[0].frequency === 'BZ') {
                vm.installmentText = 'day';
              } else if (vm.transactionDetails.cartItems[0].frequency && vm.transactionDetails.cartItems[0].frequency === 'OW') {
                vm.installmentText = 'week';
              } else if (vm.transactionDetails.cartItems[0].frequency && vm.transactionDetails.cartItems[0].frequency === 'Y') {
                vm.installmentText = 'year';
              } else if (vm.transactionDetails.cartItems[0].frequency && vm.transactionDetails.cartItems[0].frequency === 'H') {
                vm.installmentText = '6 months';
              }
            }

          }
          commonEventCalling();

          if(vm.transactionDetails.netCoreJourney && vm.transactionDetails.netCoreJourney === "TRANSACT_NOW") {
            if(vm.transactionDetails.transactionType.toUpperCase() === "SIP") {
              NetcoreEvntService.transaction_Status_Event_For_SIP(vm.transactionDetails);
            } else if(vm.transactionDetails.transactionType.toUpperCase() === "PURCHASE") {
              NetcoreEvntService.transaction_Status_Event_For_Purchase(vm.transactionDetails);
            } else if(vm.transactionDetails.transactionType.toUpperCase() === "SIPPURCHASE") {
              var netcoreData = {};
              if(vm.transactionDetails.cartItems) {
                netcoreData.transactionDate = vm.transactionDetails.transactionInitiatedAt;
                netcoreData.transactionInitiatedAt = vm.transactionDetails.transactionInitiatedAt;
                netcoreData.netCoreJourney = vm.transactionDetails.netCoreJourney;
                netcoreData.folioNumber = vm.transactionDetails.folioNumber;
                netcoreData.purchaseAmount = vm.transactionDetails.cartItems[0].amount;
                netcoreData.schemeName = vm.transactionDetails.cartItems[0].schemeName;
                netcoreData.frequency = vm.transactionDetails.cartItems[0].sipFrequency;
                netcoreData.paymentMethod = vm.transactionDetails.paymentOption;
                netcoreData.sipAmount = vm.transactionDetails.cartItems[0].installmentAmount;
                netcoreData.startDate = $window.moment(vm.transactionDetails.cartItems[0].sipDate);
                netcoreData.endDate = $window.moment(vm.transactionDetails.cartItems[0].toDate);
                netcoreData.totalAmount = vm.transactionDetails.cartItems[0].amount + vm.transactionDetails.cartItems[0].installmentAmount;
                netcoreData.transactionType = "PURCHASE";
                netcoreData.paymentStatus = vm.transactionDetails.cartItems[0].purchasePaymentStatus;
              }
              NetcoreEvntService.transaction_Status_Event_For_Mixtrans(netcoreData);
            }
          }

        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      TransactionService.get({
        controller1: 'cart',
        controller2: 'details',
        controller3: cart_id
      }).$promise.then(success, error);
    }

    function fetchTransactionSummary(id, type) {
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          manipulateResponse(resp.data);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var payload = {
        transactionId : id,
        transactionType: vm.transactionType
      };


      TransactionService.post({
        controller1: 'transaction',
        controller2: 'approved',
        controller3: 'summary'
      }, payload).$promise.then(success, error);

    }

    function manipulateResponse(data) {
      var obj = {
        "total": 1,
        "folioNumber": data.folioNumber,
        "cartItems": [
          {
            "cartItemId": "",
            "schemeName": data.schemeName,
            "schemeCode": data.schemeCode,
            "amount": data.amount,
            "brokerCode": data.distributorDetails.arnNo,
            "subBrokerCode": data.distributorDetails.subBrokerCode,
            "subBrokerArn": data.distributorDetails.subBrokerArn,
            "euinOpted": "N",
            "liquid": data.liquidSchemeFlag,
            "folioNumber": data.folioNumber,
            "camsReferenceNo": data.camsReferenceNumber,
            "riaConsent": false,
            "riaOpted": false,
            "minorFlag": data.isMinor,
            "purchaseOpted": data.summaryType === 'PURCHASE' ? true: false,
            "sipOpted": data.summaryType === 'SIP' ? true: false,
            "installmentAmount": data.installmentAmount,
            "sourcePortal": data.sourcePortal,
            "sipWithFirstInstallment": data.sipWithFirstInstallment,
          }
        ],
        "message": "success",
        "amount": data.amount,
        "totalAmount": data.totalAmount,
        "minorFlag": data.isMinor,
        "cartId": data.transactionId,
        "sourcePortal": data.sourcePortal,
        "transactionType": data.summaryType,
        "transactionInitiatedAt": data.transactionDate,
        "paymentOption": data.paymentMode === "NEFT/RTGS" ? 'NEFT_RTGS' : 'HDFC_Fund_Transfer',
        "paymentStatus": data.trxnPaymentStatus,
        "sipDuration": data.summaryType === 'SIP' ? $window.moment(data.sipDate).format("DD MMM YYYY") + ' - ' + $window.moment(data.sipEndDate).format("DD MMM YYYY"): null,
        "arn": data.summaryType === 'SIP'? data.distributorDetails.arnNo : null,
        "paymentMethod": data.summaryType === 'SIP' && data.payMech === 'OTM' ? 'Existing Bank Mandate': data.summaryType === 'SIP' && data.payMech === 'EC' ? 'Net Banking' : null,
        "srn": data.summaryType === 'SIP' ? data.srn: null,
        "sipTopUpAmount": data.summaryType === 'SIP' && data.topupDetails ? data.topupDetails.amount : null,
        "sipTopupFrequency": data.summaryType === 'SIP' && data.topupDetails ? data.topupDetails.frequency: null,
        "sipWithFirstInstallment": data.sipWithFirstInstallment,
        "name": data.investorName? data.investorName: '',
        "email": data.email? data.email: '',
        "panNumber": data.panNumber? data.panNumber: '',
        "cartItemSchemeNames": data.schemeNameLeftInCart? data.schemeNameLeftInCart: null,
      };

      if (data.transactionDateTime) {
        obj.transactionInitiatedAt = angular.copy(data.transactionDateTime);
      }

      if ($stateParams.pt && $stateParams.pt === 'E_Mandate') {
        obj.paymentMethod = angular.copy(vm.PAYMENT_OPTIONS[$stateParams.pt]);
        obj.paymentOption = angular.copy($stateParams.pt);
      }

      if ($stateParams.pt && $stateParams.pt === 'OTM') {
        obj.paymentMethod = angular.copy(vm.PAYMENT_OPTIONS[$stateParams.pt]);
        obj.paymentOption = angular.copy($stateParams.pt);
      }

      if ($stateParams.pt && $stateParams.pt === 'EC') {
        obj.paymentMethod = data.summaryType === 'SIP' && data.payMech === 'EC'? 'Net Banking': null;
        obj.paymentOption = angular.copy($stateParams.pt);
      }

      vm.transactionDetails = angular.copy(obj);
      if(data.netCoreJourney) {
        vm.transactionDetails.netCoreJourney = data.netCoreJourney;
      }
      vm.transactionDetails.transactionDate = $window.moment(vm.transactionDetails.transactionDate).format("DD MMM YYYY hh:mm:ss A");
      commonEventCalling();

      if (vm.transactionDetails.transactionType === 'SIP') {

        var sipDate = angular.copy(vm.transactionDetails.sipDuration.split(' to'));

        if (sipDate[0].includes('-')) {
          sipDate = angular.copy(vm.transactionDetails.sipDuration.split(' -'));
        }
        vm.installmentDate =  angular.copy(sipDate[0]);
      }

      if(vm.transactionDetails.netCoreJourney && vm.transactionDetails.netCoreJourney === "TRANSACT_NOW") { // check journey Transact Now
        vm.transactionDetails.schemeName = data.schemeName;
        vm.transactionDetails.frequency = data.sipFrequency;
        vm.transactionDetails.startDate = $window.moment(data.sipDate);
        vm.transactionDetails.endDate = $window.moment(data.sipEndDate);
        if(vm.transactionDetails.transactionType.toUpperCase() === "SIP") {
          NetcoreEvntService.transaction_Status_Event_For_SIP(vm.transactionDetails);
        } else if(vm.transactionDetails.transactionType.toUpperCase() === "PURCHASE") {
          NetcoreEvntService.transaction_Status_Event_For_Purchase(vm.transactionDetails);
        } else if(vm.transactionDetails.transactionType.toUpperCase() === "SIPPURCHASE") {
          var netcoreData = {};
          if(vm.transactionDetails.cartItems) {
            netcoreData.transactionDate = vm.transactionDetails.transactionInitiatedAt;
            netcoreData.transactionInitiatedAt = vm.transactionDetails.transactionInitiatedAt;
            netcoreData.netCoreJourney = vm.transactionDetails.netCoreJourney;
            netcoreData.folioNumber = vm.transactionDetails.folioNumber;
            netcoreData.purchaseAmount = vm.transactionDetails.cartItems[0].amount;
            netcoreData.schemeName = vm.transactionDetails.cartItems[0].schemeName;
            netcoreData.frequency = vm.transactionDetails.cartItems[0].frequency;
            netcoreData.paymentMethod = vm.transactionDetails.paymentOption;
            netcoreData.sipAmount = vm.transactionDetails.cartItems[0].installmentAmount;
            netcoreData.startDate = $window.moment(vm.transactionDetails.cartItems[0].sipDate);
            netcoreData.endDate = $window.moment(vm.transactionDetails.cartItems[0].toDate);
            netcoreData.totalAmount = vm.transactionDetails.cartItems[0].amount + vm.transactionDetails.cartItems[0].installmentAmount;
            netcoreData.transactionType = "PURCHASE";
            netcoreData.paymentStatus = vm.transactionDetails.cartItems[0].purchasePaymentStatus;
          }
          NetcoreEvntService.transaction_Status_Event_For_Mixtrans(netcoreData);
        }
      }

      vm.errorMessage = data.errorMsg;

      vm.showInstallments = data.sipDate !== data.sipEndDate;

      if (vm.showInstallments) {
        if (data.sipFrequency && data.sipFrequency === 'Monthly') {
          vm.installmentText = 'month';
        } else if (data.sipFrequency && data.sipFrequency === 'Quarterly') {
          vm.installmentText = 'quarter';
        } else if (data.sipFrequency && data.sipFrequency === 'Daily') {
          vm.installmentText = 'day';
        } else if (data.sipFrequency && data.sipFrequency === 'Weekly') {
          vm.installmentText = 'week';
        } else if (data.sipFrequency && data.sipFrequency === 'Yearly') {
          vm.installmentText = 'year';
        } else if (data.sipFrequency && data.sipFrequency === 'Half Yearly') {
          vm.installmentText = '6 months';
        }
      }

      identifyPostLogin();
    }

    function identifyPostLogin() {
      if (vm.transactionDetails.sourcePortal === 'WHATSAPP') {
        vm.showWhatsApp = true;
      } else {
        vm.showWhatsApp = false;
      }
    }


    function resetFlag() {
      $timeout(function () {
        isRefreshing = false;
      }, 2000);
    };

    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        if (!token) {
          if (vm.transactionDetails && vm.transactionDetails.sourcePortal === vm.flowName.WHATSAPP) {
            $state.go('linkExpired');
          } else {
            $state.go('sessionExpired');
          }
          resetFlag();
          return;
        }

        if (token && token.refresh_token) {

          if (vm.transactionDetails && vm.transactionDetails.sourcePortal === vm.flowName.WHATSAPP) {

            AuthService.getRefreshTokenGateway(token).then(function () {
              refreshTokenCallBackOne();
            }, function () {
              refreshTokenCallBackTwo();
            });
          } else {
            AuthService.getRefreshToken(token).then(function () {
              refreshTokenCallBackOne();
            }, function () {
              refreshTokenCallBackTwo();
            });
          }
        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          if (vm.transactionDetails && vm.transactionDetails.sourcePortal === vm.flowName.WHATSAPP) {
            $state.go('linkExpired');
          } else {
            $state.go('sessionExpired');
          }
        }
      });

      var resetFlag = function () {
        $timeout(function () {
          isRefreshing = false;
        }, 2000);
      };
    }


    function refreshTokenCallBackOne() {
      if (localStorage.getItem('doLogOut')) {
        AuthService.logout().then(function () {
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          ModalService.logoutSuccess();
          if (vm.transactionDetails && vm.transactionDetails.sourcePortal === vm.flowName.WHATSAPP) {
            $state.go('linkExpired');
          } else {
            $state.go('sessionExpired');
          }
        }, function () {
          ModalService.logoutSuccess();
          if (vm.transactionDetails && vm.transactionDetails.sourcePortal === vm.flowName.WHATSAPP) {
            $state.go('linkExpired');
          } else {
            $state.go('sessionExpired');
          }
        });
      } else {
        $state.reload();
        resetFlag();
      }
    }


    function refreshTokenCallBackTwo() {
      AuthService.clearCookies(AppConstants.IDENTIFIER);
      MessageService.clear();
      if (vm.transactionDetails && vm.transactionDetails.sourcePortal === vm.flowName.WHATSAPP) {
        $state.go('linkExpired');
      } else {
        $state.go('sessionExpired');
      }
      resetFlag();
    }



    scope.$on("$destroy", function () {
      for (var key in removeListeners) {
        if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
          removeListeners[key]();
        }
      }
    });

    function commonEventCalling(){

      // Failure of Netbanking Transaction

      if(vm.transactionDetails.transactionType.toUpperCase() === 'PURCHASE' && vm.transactionDetails.paymentOption === 'NET_BANKING' && vm.transactionDetails.paymentStatus === false){
        NetcoreEvntService.ack_smart_Client();
        NetcoreEvntService.contact_Event_JSP(vm.transactionDetails);
        NetcoreEvntService.dispatch_smartech(vm.transactionDetails);
        NetcoreEvntService.ack_purchase_Netbanking_transaction_Failure('purchase',vm.transactionDetails);
      }

      if(vm.transactionDetails.transactionType.toUpperCase() === 'PURCHASE' && vm.transactionDetails.paymentOption === 'NET_BANKING' && vm.transactionDetails.paymentStatus === true){
        NetcoreEvntService.ack_smart_Client();
        NetcoreEvntService.contact_Event_JSP(vm.transactionDetails);
        NetcoreEvntService.dispatch_smartech(vm.transactionDetails);
        NetcoreEvntService.ack_purchase_Netbanking_transaction_Success('purchase',vm.transactionDetails);
      }

      //Successfull SIP FI Netbanking
      if(vm.transactionDetails.transactionType.toUpperCase() === 'SIP' && (vm.transactionDetails.paymentOption === 'NET_BANKING' || vm.transactionDetails.paymentMethod === 'Net Banking') && vm.transactionDetails.sipWithFirstInstallment && vm.transactionDetails.paymentStatus === true && !vm.isPending){
        NetcoreEvntService.ack_smart_Client();
        NetcoreEvntService.contact_Event_JSP(vm.transactionDetails);
        NetcoreEvntService.Sip_FI_dispatch_smartech(vm.transactionDetails);
        NetcoreEvntService.ack_Successfull_SIP_FI_Netbanking('SIP With First Installment',vm.transactionDetails);
      }

      //SIP FI Netbanking when gateway status is failed
      if((vm.transactionDetails.transactionType.toUpperCase() === 'SIP' || (vm.transactionDetails.summaryType && vm.transactionDetails.summaryType.toUpperCase() === 'SIP')) && (vm.transactionDetails.paymentOption === 'NET_BANKING' || vm.transactionDetails.paymentMethod === 'Net Banking') && vm.transactionDetails.sipWithFirstInstallment && vm.transactionDetails.paymentStatus === false && !vm.isPending){
        NetcoreEvntService.ack_smart_Client();
        NetcoreEvntService.contact_Event_JSP(vm.transactionDetails);
        NetcoreEvntService.Sip_FI_dispatch_smartech(vm.transactionDetails);
        NetcoreEvntService.ack_Failure_SIP_FI_SIP('SIP With First Installment',vm.transactionDetails)
      }

      //For SIP FI Transaction, when no status code is recieved for Razorpay Gateway | Pending
      if(vm.isPending && vm.transactionDetails.transactionType.toUpperCase() === 'SIP' && vm.transactionDetails.sipWithFirstInstallment){
        NetcoreEvntService.ack_smart_Client();
        NetcoreEvntService.ack_pending_razorPay_failure(vm.transactionDetails.transactionType,vm.transactionDetails);
        NetcoreEvntService.Complete_Transaction_SIP_Pending(vm.transactionDetails);
      }

      //SIP - Failure of Emandate
      if(vm.transactionDetails.transactionType === 'SIP' && vm.transactionDetails.paymentOption === "E_Mandate" && vm.transactionDetails.paymentStatus === false) {
        NetcoreEvntService.ack_smart_Client();
        NetcoreEvntService.ack_Failure_Emandate('SIP',vm.transactionDetails);
      }

      //Failue of Emandate - SIP FI Transaction
      if(vm.transactionDetails.transactionType === 'SIP' && vm.transactionDetails.paymentOption === "E_Mandate" && vm.transactionDetails.sipWithFirstInstallment && vm.transactionDetails.paymentStatus === false && !vm.isPending) {
        NetcoreEvntService.ack_smart_Client();
        NetcoreEvntService.ack_Failure_SIP_FI_SIP('SIP With First Installment',vm.transactionDetails)
      }

      //SIP FI- Emandate Success
      if(vm.transactionDetails.transactionType === 'SIP' && vm.transactionDetails.paymentOption === "E_Mandate" && vm.transactionDetails.sipWithFirstInstallment && vm.transactionDetails.paymentStatus === true && !vm.isPending) {
        NetcoreEvntService.ack_smart_Client();
        NetcoreEvntService.ack_Successfull_SIP_FI_Netbanking('SIP With First Installment',vm.transactionDetails);
      }

      //SIP - Emandate Success
      if(vm.transactionDetails.transactionType === 'SIP' && vm.transactionDetails.paymentOption === "E_Mandate" && !vm.transactionDetails.sipWithFirstInstallment && vm.transactionDetails.paymentStatus === true && !vm.isPending){
        NetcoreEvntService.ack_smart_Client();
        NetcoreEvntService.ack_Success_Emandate('SIP',vm.transactionDetails);
      }

      //Mix Transaction

      if(vm.transactionDetails.transactionType === 'SIPPURCHASE' && vm.transactionDetails.paymentOption !== 'UPI') {
        NetcoreEvntService.ack_smart_Client();
        NetcoreEvntService.ack_Mix_transaction_Success('SIPPURCHASE',vm.transactionDetails);
      }


      //Existing Events

      if(vm.transactionDetails.transactionType === 'SIP' && vm.transactionDetails.paymentStatus === false && !vm.transactionDetails.sipWithFirstInstallment && (vm.transactionDetails.paymentOption === "EC" || vm.transactionDetails.paymentOption === "OTM")){
        var data = {
          'schemeName': vm.transactionDetails.cartItems[0].schemeName,
          'folioNumber': vm.transactionDetails.folioNumber,
          'amount': vm.transactionDetails.totalAmount,
          'transactionType': vm.transactionDetails.transactionType
        };
        NetcoreEvntService.sip_Transaction_Success_Registration(data, 'failure');
      }

    }

  }
})();

(function () {
  'use strict';
  angular
      .module('hdfc-mf-investor-web')
      .controller('InitiateTransactionSwpController', InitiateTransactionSwpController);

  /** @ngInject */
  function InitiateTransactionSwpController($timeout, $stateParams, MessageService, ModalService, InvestorService,
                                 SchemeService, TransactionService, AppConstants, $state, LoaderService, UtilService,
                                 moment, TransactionModel, AuthService, StpHelper, SwpHelper, $window, investorServiceVersion , DynamicDataReview, panAadharService) {
    var vm = this;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    vm.transactionType = getTransactionTypeFromStateParams() || getTransactionType();
    vm.formData = TransactionModel.getPayloadRawData() || TransactionModel.getMasterRawData(vm.transactionType);
    vm.devidendOptionsOther = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT];
    vm.devidendOptionsELSS = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];
    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.specificProperties = TransactionModel.getTransactionSpecificProperties(vm.transactionType);
    vm.folioList = null;
    vm.unitsDetails = null;
    vm.outSchemeValidations = null;
    vm.validations = {};
    vm.investorInfo = null;
    vm.isRequired = false;
    vm.bankList = null;
    vm.outSchemeList = null;
    vm.tForm = {};
    vm.isSaving = false;
    vm.isReseting = false;
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.daysList = getDaysList();
    vm.weekList = vm.TRANSACTIONS_CONST.WEEKS_LIST;
    vm.isSchemeDisabled = false;
    vm.isShowDefault = 'false';
    vm.viewMode = 'days';
    vm.isInvalidForm = false;
    vm.isCheckedTandC = 'false';
    vm.profile = AuthService.getToken();
    var name = vm.profile ? vm.profile.investorFName.toLowerCase() : '';
    vm.investorName = name.charAt(0).toUpperCase() + name.slice(1);
    vm.calenderEndDateString = '31-Dec-2036';
    vm.amountInWords = '';
    vm.isSourceSchemeGrowth = false;

    vm.schemeTypeForValidation = '';
    vm.checkSwpStpValidations = checkSwpStpValidations;
    vm.updateEndDates = updateEndDates;
    vm.checkValidations = checkValidations;
    vm.extractValidationObject = extractValidationObject;
    vm.resetAll = resetAll;
    vm.helper = getHelper();
    vm.isOTMAmount= false;
    vm.isOTMDate = false;
    vm.isArnSuccess = false;
    vm.startMinDate = moment().add(10, 'days');
    vm.startMaxDate = moment().add(120, 'days');
    vm.startZindex = 8;
    vm.endZindex = 4;
    vm.changeBank = changeBank;
    vm.masterOutSchemeList = null;
    vm.DynamicDataReview = DynamicDataReview;
    vm.TermsCondition = vm.DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Review_SWAP;
    vm.showTerms = true;
    AuthService.checkLinkedUserStatus();
    function getHelper() {
      var helper = null;

      switch (vm.transactionType){
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          helper = SwpHelper;
          helper.setViewModel(vm);
          break;
      }
      return helper;
    }


    vm.filterOutSchemeList = function () {
      vm.formData.outSchemeObj = '';
      vm.formData.outSchemeCode = '';
      vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList, 'schemeName', vm.formData.outSchemeName);
    };

    /**
     * Function responsible for setting data when getting data from state parameters
     */

    function setStateParams() {
      vm.formData.folioNumber = $stateParams.folioNumber ? $stateParams.folioNumber : vm.formData.folioNumber;
      if(vm.folioListToBlockTxnsaction && vm.folioListToBlockTxnsaction.includes(vm.formData.folioNumber)){
        if(AppConstants.TRANSACTION_CONST_LIST_TO_BLOCK.includes(vm.transactionType)){
          var success = function(){
            if(vm.blockFolioForTransaction){
              vm.formData.folioNumber = null;
              var oldData = angular.copy(vm.formData);
              resetAll();
              recoverFromResetting(oldData);
            }
          }, error = function(){};
          ModalService.genericModal({isUpi : true, text : vm.popUpMessage}, success, error);
        }
      }

      if((vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) || (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE )){
        fetchOutSchemes();
      }
      vm.formData.outSchemeCode = $stateParams.sc ? $stateParams.sc : vm.formData.outSchemeCode;
      if($stateParams.isFavourite){
        vm.formData.isFavourite = true;
      } else {
        vm.formData.isFavourite = false;
      }
      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE ){
        checkForParameters();
      }
    }

    vm.transferOptionChanged = function (transferOpt) {
      vm.formData.transferOption = transferOpt;
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.day = '';
      vm.formData.amount = '';
      vm.formData.frequency = null;
      vm.tForm.frequency.$setPristine(false);
      vm.formData.bankInfo = null;
      vm.tForm.bank.$setPristine(false);
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.frequencyList = getFrequencyList();
      vm.formData.frequency = vm.frequencyList[0].key;
      fetchOutSchemes();
      resetNumInWords();
    };

    function checkForParameters() {
      var param = $window.location.href.split('?')[1];
      if(!param){
        return;
      }
      var data = $window.atob(param).split('&');
      var folioNumber = data[0].split('=')[1];
      var inSchemeCode = data[1].split('=')[1];
      var readOnly = !!data[2].split('=')[1];

      vm.formData.dynamicData = {
        folioNumber :folioNumber,
        inSchemeCode : inSchemeCode,
        readOnly : readOnly
      };
    }

    function getDaysList() {
      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP){
        return vm.TRANSACTIONS_CONST.SIP_DAYS_LIST;
      } else {
        return vm.TRANSACTIONS_CONST.DAYS_LIST;
      }

    }

    function resetAll() {
      vm.formData.amountType = 'amount';
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.dividendOption = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.bankInfo = null;
      vm.formData.day = '';
      vm.formData.isTillPerpetuity = false;
      vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
      vm.formData.month = '';
      vm.formData.outSchemeCode = '';
      vm.formData.outSchemeName = '';

      vm.outSchemeValidations = null;
      vm.validations = {};
      vm.isRequired = false;
      vm.bankList = null;
      vm.outSchemeList = null;
      vm.unitsDetails = null;
      resetNumInWords(); //reset the number in text form on folio change or form reset

      resetBankDetails();
      if(vm.specificProperties && vm.specificProperties.investmentModeData){
        vm.specificProperties.investmentModeData.stage1='';
        vm.specificProperties.investmentModeData.stage2='';
        vm.specificProperties.investmentModeData.stage3='';
        vm.specificProperties.investmentModeData.stage4='';
      }

      if(vm.transactionType === 'SWP') {
        //vm.formData.frequency = vm.frequencyList[0].key;
      } else if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP){
        vm.formData.frequency = null;
      }
      if (vm.tForm.$pristine) {
        vm.tForm.$setPristine();
      }
    }

    function resetNumInWords(){
      vm.amountInWords = '';
      var inWordsDiv = document.getElementById('divDisplayWords');
      if(inWordsDiv){
        inWordsDiv.innerHTML = '(In Words)';
      }
    }

    function reSetting() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.formData.frequency) {
        return;
      }

      vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
      vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
      vm.validations.minInstallments = vm.validations.minInstallments || 0;
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.maxAmount = vm.validations.maxAmount || 0;
      /*if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > 0 && vm.validations.maxAmount < vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }*/

      var amountMultiples = 1;
      var maxAmount = 0;
      var maxInstallments = 0;
      var minInstallments = 0;
      var minAmount = 0;

      switch (vm.formData.frequency) {
        case 'DZ':
          amountMultiples = validationsData.dailyAmtMultiples;
          maxAmount = validationsData.dailyMaxAmt;
          maxInstallments = validationsData.dailyMaxInstallmentNumber;
          minAmount = validationsData.dailyMinAmt;
          minInstallments = validationsData.dailyMinInstallmentNumber;
          break;
        case 'OW':
          amountMultiples = validationsData.weeklyAmtMultiples;
          maxAmount = validationsData.weeklyMaxAmt;
          maxInstallments = validationsData.weeklyMaxInstallmentNumber;
          minAmount = validationsData.weeklyMinAmt;
          minInstallments = validationsData.weeklyMinInstallmentNumber;
          break;
        case 'Q':
          amountMultiples = validationsData.quarterlyAmtMultiples;
          maxAmount = validationsData.quarterlyMaxAmt;
          maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
          minAmount = validationsData.quarterlyMinAmt;
          minInstallments = validationsData.quarterlyMinInstallmentNumber;
          break;
        case 'OM':
          amountMultiples = validationsData.monAmtMultiples;
          maxAmount = validationsData.monMaxAmt;
          maxInstallments = validationsData.monMaxInstallmentNumber;
          minAmount = validationsData.monMinAmt;
          minInstallments = validationsData.monMinInstallmentNumber;
          break;
        case 'H':
          amountMultiples = validationsData.halfYearlyAmtMultiples;
          maxAmount = validationsData.halfYearlyMaxAmt;
          maxInstallments = validationsData.halfYearlyMaxInstallmentNumber;
          minAmount = validationsData.halfYearlyMinAmt;
          minInstallments = validationsData.halfYearlyMinInstallmentNumber;
          break;
        case 'Y':
          amountMultiples = validationsData.yearlyAmtMultiples;
          maxAmount = validationsData.yearlyMaxAmt;
          maxInstallments = validationsData.yearlyMaxInstallmentNumber;
          minAmount = validationsData.yearlyMinAmt;
          minInstallments = validationsData.yearlyMinInstallmentNumber;
          break;
      }

      vm.validations.amountMultiples = amountMultiples;
      vm.validations.maxInstallments = maxInstallments;
      vm.validations.minInstallments = minInstallments;
      vm.validations.minAmount = minAmount;
      vm.validations.maxAmount = maxAmount;

    }

    function checkSwpStpValidations() {
      /*if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }*/

      if (vm.formData.transferOption === vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION) {
        vm.isMax = false;
        vm.isMin = false;
        vm.isInvalidForm = false;
        vm.isMultiples = true;
      } else {
        vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
        vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
        vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
        vm.isInvalidForm = !vm.unitsDetails || vm.formData.amount <= 0 || (vm.formData.amount && (vm.isMax || vm.isMin || (!vm.isMultiples && vm.validations.amountMultiples))) || !vm.unitsDetails.freeValueUnits
      }
      if(vm.specificProperties.stpType === vm.SUMMARY_CONST.FLEX_STP.key){
        if(vm.formData.frequency === 'DZ'){
          if(parseInt(vm.formData.amount) >= 1000){
            vm.validations.minInstallments = 6;
          } else {
            vm.validations.minInstallments = 12;
          }
        }
      }
    }

    function fetchFolioList() {
      var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              var folioList = [];
              vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
              if (resp.data.kycVerifiedFlag === false) {
                ModalService.genericModal({
                  text: resp.data.kycMessage
                }, function() {
                  $state.go("welcome");
                });
                return;
              }
              Object.keys(resp.data.folioList).forEach(function (key) {
                var obj = Object.assign({key: key}, resp.data.folioList[key]);
                folioList.push(angular.copy(obj));
              });
              vm.folioList = folioList.length ? folioList : null;
              if(vm.folioList && vm.folioList.length === 1){
                vm.formData.folioNumber = vm.folioList[0].folioNumber;
                if (!vm.formData.isBackFromSummary && !vm.formData.outSchemeCode) {
                  vm.folioChanged();
                }
              }
              if(vm.formData.dynamicData && vm.formData.dynamicData.folioNumber){
                vm.formData.folioNumber = vm.formData.dynamicData.folioNumber;
                vm.folioChanged();
              }
            } else {
              vm.folioList = null;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            vm.folioList = null;
            UtilService.errorHandler(err);
          };
      LoaderService.showLoader();
      investorServiceVersion.get({
        child1: 'folio',
        child2: 'active-list'
      }).$promise.then(success, error);
    }

    function checkValidations() {
      vm.isInvalidForm = false;
      if (!vm.inSchemeValidations && !vm.outSchemeValidations) {
        vm.validations = {};
      }

      if (vm.outSchemeValidations) {
        vm.validations.isEnabled = vm.outSchemeValidations ? vm.outSchemeValidations.isEnabled : '';
        extractValidationObject(vm.outSchemeValidations);
      }

      if (vm.inSchemeValidations) {
        vm.validations.minInstallDivisionFlag = vm.inSchemeValidations.minInstallDivisionFlag;
        vm.validations.swpTaxCode = vm.inSchemeValidations.swpTaxCode;
        vm.validations.endingType = vm.inSchemeValidations.endingType;
        extractValidationObject(vm.inSchemeValidations);
      }

      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          checkSwpStpValidations();
          break;
      }
    }

    function fetchOutSchemeValidations(cb) {
      vm.outSchemeValidations = null;
      cb = cb || function () {
          };

      if (!vm.formData.outSchemeCode) {
        return;
      }
      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.enabledStartDates = null;
        vm.enabledEndDates = null;
        vm.formData.day = '';
        vm.formData.frequency = null;
        vm.validations = {};
        vm.isMultiples = false;
        vm.isMin = false;
        vm.isMax = false;
        reSetting();
      }
      var success = function (resp) {
            if (resp.status && resp.data) {
              vm.outSchemeValidations = resp.data;
              var schemeTypeCheck= vm.outSchemeValidations && vm.outSchemeValidations.investmentOption;
              vm.isSourceSchemeGrowth = schemeTypeCheck=="GROWTH"?true:false;
              cb(null);
            } else {
              cb('error');
              vm.outSchemeValidations = null;
              MessageService.error(resp.message);
            }
            checkValidations();
          },
          error = function (err) {
            vm.outSchemeValidations = null;
            cb('error');
            UtilService.errorHandler(err);
          };

      var _config = {
        controller: 'schemeValidation',
        type: vm.transactionType.toLowerCase()
      };

      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX){
        _config = {
          controller: 'validation',
          type: 'flexIndex'
        }

        var data = {
          folioNo: vm.formData.folioNumber,
          schemeCode: vm.formData.outSchemeCode,
          transactionType: 'FLEXINDEX'
        }

        SchemeService.post(_config, data).$promise.then(success, error);

      } else {

        data = {
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.outSchemeCode
        };
        SchemeService.post(_config, data).$promise.then(success, error);
      }

    }

    function fetchUnitDetails() {
      vm.unitsDetails = null;
      if (!vm.formData.outSchemeCode) {
        return;
      }
      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX){
        return;
      }
      LoaderService.showLoader();

      var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.unitsDetails = resp.data;
              vm.unitsDetails.message = resp.message || '';
              vm.unitsDetails.isDisabled = !resp.data.freeValueUnits;
              vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
              vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
              vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
              checkValidations();
            } else {
              vm.unitsDetails = null;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            vm.unitsDetails = null;
            UtilService.errorHandler(err);
          };
      InvestorService.post({
        child1: 'transaction',
        child2: 'folio',
        child3: 'scheme-value'
      }, {
        schemeCode: vm.formData.outSchemeCode,
        transactionType: vm.transactionType.toLowerCase(),
        folioNo: vm.formData.folioNumber
      }).$promise.then(success, error);
    }

    function getInvestorInfo() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
        } else {
          vm.investorInfo = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.investorInfo = null;
      };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'folio',
        child2: 'info'
      }).$promise.then(success, error);
    }

    function getTransactionDetails() {
      if (!$stateParams.transactionId) {
        MessageService.error("TransactionId is missing for saved transaction.");
        $state.go('main.dashboard');
        return;
      }

      var success = function (resp) {
            if (resp.data && resp.status) {
              showPrefillValues(resp.data);
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            UtilService.errorHandler(err);
          };
      TransactionService.get({
        controller1: 'transaction',
        controller2: 'saved',
        controller3: $stateParams.transactionId,
        controller4: $stateParams.isCompId
      }).$promise.then(success, error);
    }

    function getTransactionTypeFromStateParams() {
      if($stateParams.transactionType === 'FLEXINDEX'){
        return 'FLEX_INDEX';
      }
      return $stateParams.transactionType;
    }

    function getTransactionType() {
      var transactionType = '';
      switch ($state.current.name) {
        case 'main.transactions.swp':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP;
          break;
        default :
          $state.go('welcome');
          break;
      }
      return transactionType;
    }

    function getFinalPayloadData() {
      var payload = null;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          payload = vm.isSaving ? getSwpPayloadToSave() : getSwpPayloadToSubmit();
          break;
      }
      return angular.copy(payload);
    }

    function getSwpPayloadToSave() {
      var payload = {
        amount: vm.formData.amount,
        folioNumber: vm.formData.folioNumber,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP,
        frequency: vm.formData.frequency,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        schemeCode: vm.formData.outSchemeCode,
        startDate: vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
        toDate: vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
        swpDay: vm.formData.day,
        swpType: vm.formData.transferOption,
        accountNumber: vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '',
        ifscCode: vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : '',
        bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : '',
        branchName: vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '',
        payMech: vm.formData.bankInfo ? vm.formData.bankInfo.payMech : '',
        primaryBankFlag: vm.formData.bankInfo ? vm.formData.bankInfo.primaryFlag : '',
        payoutId: vm.formData.bankInfo ? vm.formData.bankInfo.payoutId : ''
      };

      return angular.copy(payload);
    }

    function getSwpPayloadToSubmit() {
      vm.formData.formType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP;
      vm.formData.id = vm.formData.isFavourite ? "" : vm.formData.transactionId;
      return angular.copy(vm.formData);
    }

    function fetchOutSchemes(cb) {
      cb = cb || function () {
          };

      if (!vm.formData.folioNumber) {
        return;
      }

      vm.outSchemeList = null;
      var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.outSchemeList = resp.data.schemes;
              vm.masterOutSchemeList = vm.outSchemeList;
              cb();
            } else {
              vm.outSchemeList = null;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            vm.outSchemeList = null;
            UtilService.errorHandler(err);
          };
      LoaderService.showLoader();

      var _config = {child1: 'folio', child2: 'schemes'};
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP) {
        _config.child3 = 'dtp'
      } else if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX){
        _config.child3 = 'flex-index-enabled';
      }
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP &&
          vm.specificProperties.stpType === vm.SUMMARY_CONST.FLEX_STP.key) {
        _config.child3 = 'flex',
            _config.child4 = 'stp'
      }

      InvestorService.post(_config,
        {
          folioNumber: vm.formData.folioNumber,
          transactionType: vm.transactionType.toLowerCase(),
          swpType: vm.formData.transferOption
        }
        ).$promise.then(success, error);
    }

    function fetchBankList(cb) {
      cb = cb || function () {
          };
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.bankList = resp.data.bankList;
              vm.bankList = vm.bankList.length ? vm.bankList : null;
              if(vm.bankList && vm.bankList.length == 1){
                vm.formData.bankInfo = vm.bankList[0];
                checkOTMAmountAndDate();
                changeBank();
              }
              cb();
            } else {
              vm.bankList = null;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            vm.bankList = null;
            UtilService.errorHandler(err);
          };
      LoaderService.showLoader();

      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        InvestorService.get({child1: 'bank', child2: 'list', child3: 'sip'}, null).$promise.then(success, error);
      } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        var payload = {
          folioNo : vm.formData.folioNumber,
          transactionType : vm.transactionType.toLowerCase()
        }
        InvestorService.get({
          child1: 'folio',
          child2: 'otm'/*,
          child3: vm.transactionType.toLowerCase(),
          child4: vm.formData.folioNumber*/
        }, payload).$promise.then(success, error);
      } else {
        InvestorService.post({
          child1: 'folio',
          child2: 'scheme',
          child3: 'bankList'
        }, {schemeCode: vm.formData.outSchemeCode, folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
      }
    }

    function updateDatesForDaily() {
      var currentDay = moment().add(3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      //vm.formData.startDate = vm.enabledStartDates[0];
      vm.formData.day = +(vm.formData.startDate.format('DD'));
      updateEndDates();
    }

    function updateDatesForWeekly() {
      var currentDay = moment().add(3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});

      var enabledStartDates = [];
      var _day = vm.daysList.find(function (d) {
            return d.value === vm.formData.day;
          }) || {};
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd') === _day.name) {
          enabledStartDates.push(_date.clone());
        }
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      //vm.formData.startDate = vm.enabledStartDates[0];
      updateEndDates();
    }

    function updateDatesForOthers() {
      var currentDay = moment();
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.formData.day);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      var tDays = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? 15 : 10;
      while (_diff < tDays) {
        updatedDate.add(1, 'months').set('date', vm.formData.day);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }

      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }

      vm.enabledStartDates = angular.copy(enabledStartDates);
      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP){
        calculateMonthsForSip();
      } else {
        //vm.formData.startDate = vm.enabledStartDates[0];
      }
      updateEndDates();
    }

    function calculateMonthsForSip() {
      var arr = [];
      for(var i=0;i<vm.enabledStartDates.length;i++){
        var str1 = vm.enabledStartDates[i].format('MMM') + ', ' + vm.enabledStartDates[i].format('YYYY');
        var str2 = i;
        arr.push({name:str1, value:str2});

      }
      vm.formData.monthList = arr;
    }

    function updateEndDates(doNotUpdateEndDate) {
      if (vm.formData.isTillPerpetuity || !vm.formData.startDate) {
        return;
      }


      var defaultEndDate = moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      //var defaultEndDate = new Date(2036, 12, 31);
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;

      if(!vm.frequencyList){
        vm.frequencyList = getFrequencyList();
      }
      var frequency = vm.frequencyList.find(function (f) {
            return f.key === vm.formData.frequency;
          }) || {};


      switch (vm.formData.frequency) {
        case'DZ':
        case'OW':
          var days = 0;
          var minInstallmentsDays = vm.validations.minInstallments || 6;
          minInstallmentsDays =  minInstallmentsDays - 1;
          endDate = vm.formData.startDate.clone().add(minInstallmentsDays, 'weeks');
          // endDate = vm.formData.startDate.clone().add(frequency.dayfreq, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / frequency.dayfreq);
          for (i = 0; i < freq; i++) {
            days = frequency.dayfreq * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          var minInstallmentsMonths = (vm.validations.minInstallments && (vm.validations.minInstallments * frequency.monthfreq) )
            || (vm.formData.frequency === 'OM' ? 4:1);
          minInstallmentsMonths = minInstallmentsMonths - 1* frequency.monthfreq;
          endDate = vm.formData.startDate.clone().add(minInstallmentsMonths, 'months');
          // endDate = vm.formData.startDate.clone().add(frequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.monthfreq);
          for (i = 0; i < freq; i++) {
            months = frequency.monthfreq * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      // var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;

      vm.enabledEndDates = enabledEndDates;//enabledEndDates.slice(minInstallments);
      vm.enabledEndDateView=angular.copy(vm.enabledEndDates[0]);
      if(!doNotUpdateEndDate){
        //vm.formData.endDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
        vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
      } else {
        //vm.formData.endDate = null;
        vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);

      }
      vm.maxEndDate = new Date(2099, 12, 31);
    }

    function changeFrequency() {
      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        vm.formData.day = null;
        vm.formData.month = null;
        reSetting();
      }
      vm.formData.amount = getFinalAmount();
      checkValidations();
      if (vm.formData.frequency === 'DZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        if(vm.specificProperties.stpType == vm.SUMMARY_CONST.FLEX_STP.key){
          vm.specificProperties.showDayOfTransfer = false;
          vm.specificProperties.showDateOfTransfer = false;
        }
        updateDatesForDaily()
      } else if (vm.formData.frequency === 'OW') {
        vm.daysList = vm.TRANSACTIONS_CONST.WEEKS_LIST;
        vm.viewMode = 'days';
        if(vm.specificProperties.stpType == vm.SUMMARY_CONST.FLEX_STP.key){
          vm.specificProperties.showDayOfTransfer = true;
          vm.specificProperties.showDateOfTransfer = false;
        }
      } else {
        vm.daysList = getDaysList();
        vm.viewMode = 'months';
        updateEndDates();

      }
    }

    function resetDefaults(doNotEmptyValidations) {
      vm.isReseting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      if (!doNotEmptyValidations) {
        vm.validations = {};
      }
      checkValidations();
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function getFrequencyList() {
      var frequencyList = null;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          frequencyList = (vm.formData.transferOption === vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT) ? vm.TRANSACTIONS_CONST.SWP_FREQ_LIST_FOR_FIXED : vm.TRANSACTIONS_CONST.SWP_FREQ_LIST_FOR_CAPITAL;
          break;
      }
      return frequencyList;
    }

    function getAmountForStpType() {
      if (vm.formData.frequency === 'OM' || vm.formData.frequency === 'Q') {
        return 0.01;
      }

      return '';
    }

    function getFinalAmount() {
      var amount = vm.formData.amount;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP:
          amount = (vm.formData.transferOption == vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION) ? getAmountForStpType() : amount;
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          amount = (vm.formData.transferOption == vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION) ? 300 : amount;
          break;
      }
      return amount;
    }

    function showPrefillValues(rawData) {
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          if (rawData) {
            swpPrefillValues(rawData)
          } else {
            vm.formData.amount && $window.NumToWord(vm.formData.amount,'divDisplayWords', vm);
            vm.frequencyList = getFrequencyList();
            fetchFolioList();
            fetchOutSchemes();
            fetchUnitDetails();
            fetchOutSchemeValidations(function (err) {
              if (!err) {
                checkValidations();
                changeFrequency();
                //vm.changeDay();
                updateEndDates();
                vm.formData.isBackFromSummary = false;

              }
            });
            changeFrequency();
            //vm.changeDay();
            updateEndDates();
            fetchBankList();
          }
          break;
      }
    }

    function swpPrefillValues(rawData) {
      fetchFolioList();
      vm.formData.transactionId = rawData.id;
      vm.formData.folioNumber = rawData.folioNumber;
      vm.formData.outSchemeCode = rawData.schemeCode;
      vm.folioChanged();
      fetchOutSchemes(function () {
        var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
              return vm.formData.outSchemeCode === item.schemeCode;
            }) || {};
        vm.formData.outSchemeName = scheme.schemeName || '';
      });
      fetchBankList(function () {
        vm.formData.bankInfo = vm.bankList.find(function (i) {
              return i.payoutId === rawData.payoutId;
            }) || null;
      });
      fetchUnitDetails();
      fetchOutSchemeValidations(function (err) {
        if (!err) {
          vm.formData.transferOption = rawData.swpType;
          vm.frequencyList = getFrequencyList();
          vm.formData.frequency = rawData.frequency;
          changeFrequency();
          vm.isShowDefault = 'true';
          vm.formData.day = rawData.swpDay ? +rawData.swpDay : '';
          vm.changeDay();
          vm.formData.amount = rawData.amount;
          checkValidations();
          vm.formData.isBackFromSummary = false;
          $window.NumToWord(vm.formData.amount,'divDisplayWords', vm);
        }
      });
    }

    vm.init = function () {

      $state.$previous = null;
      TransactionModel.setPayloadRawData(null);
      getInvestorInfo();
      // checkIsTxnBlock(function () {
        if($stateParams){
          setStateParams();
        }

        if (vm.formData.isBackFromSummary || $stateParams.sc) {
          showPrefillValues();
        } else if ($stateParams.transactionId) {
          vm.frequencyList = getFrequencyList();
          getTransactionDetails();
        } else {
          fetchFolioList();
          vm.formData.transferOption = vm.formData.transferOption || vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
          vm.frequencyList = getFrequencyList();
        }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
          vm.formData.investmentType = vm.formData.investmentType || vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE;
          vm.formData.sipPaymentOption = vm.formData.sipPaymentOption || vm.paymentOptions[0];
        }

        if (vm.formData.frequency === 'DZ') {
          vm.daysList = null;
          vm.viewMode = 'days';
          updateDatesForDaily()
        } else if (vm.formData.frequency === 'OW') {
          vm.daysList = vm.TRANSACTIONS_CONST.WEEKS_LIST;
          vm.viewMode = 'days';
        } else {
          vm.daysList = getDaysList();
          vm.viewMode = 'months';
        }

        if(!DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Review_SWAP)
        {
          vm.showTerms = false;
        }
      // });

      var successRandomOTPIdHandler = function(resp) {
        vm.randomOTPId = resp.randomOTPId ? resp.randomOTPId : null;
      }, errorRandomOTPIdHandler = function (){}
      UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);

    };

    vm.confirmCancel = function () {
      var success = function () {
        $state.go('welcome')
      };
      ModalService.confirmCancelModal({}, success);
    };

    /**
     * Function responsible for handling folio selection change
     */

    vm.folioChanged = function () {

      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        if(vm.folioListToBlockTxnsaction && vm.folioListToBlockTxnsaction.includes(vm.formData.folioNumber)){
          if(AppConstants.TRANSACTION_CONST_LIST_TO_BLOCK.includes(vm.transactionType)){
            var success = function(){
              if(vm.blockFolioForTransaction){
                //$state.reload();
                vm.formData.folioNumber = null;
                var oldData = angular.copy(vm.formData);
                resetAll();
                recoverFromResetting(oldData);
              }
            }, error = function(){};
            ModalService.genericModal({isUpi : true, text : vm.popUpMessage}, success, error);
          }
        }
        MessageService.clear();
        var oldData = angular.copy(vm.formData);
        resetAll();
        recoverFromResetting(oldData);
        fetchOutSchemes(function () {
        });
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        vm.formData.folioNumber=null;
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);
    };

    function recoverFromResetting(oldData) {
      if(vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP){
        vm.formData.transferOption = oldData.transferOption;
      }
    }

    vm.outSchemeChanged = function (schemeData) {
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.amountType = 'amount';
      if(vm.transactionType != vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION){
        vm.formData.bankInfo = null;
        vm.bankList = null;
      }
      vm.unitsDetails = null;
      vm.formData.dividendOption = '';
      vm.formData.frequency = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.day = '';

      if(schemeData) {
        vm.formData.outSchemeCode = schemeData.schemeCode;
        vm.formData.outSchemeName = schemeData.schemeName;
      }


      if (!vm.formData.outSchemeCode) {
        vm.formData.outSchemeName = '';
        return;
      }

      var scheme = vm.outSchemeList.find(function (item) {
            return item.schemeCode === vm.formData.outSchemeCode;
          }) || {};
      vm.formData.outSchemeName = scheme.schemeName || '';

      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION){
        vm.helper.setInstantRedSchemeValidations(scheme);
      }
      else {
        if (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP) {
          fetchOutSchemeValidations();
          fetchUnitDetails();
        }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
          fetchBankList();
        }
      }
    };

    vm.changeFrequency = function () {
      resetDefaults(true);
      changeFrequency();
    };

    vm.changeDay = function () {
      if (!vm.formData.frequency || !vm.formData.day) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        reSetting();
        return;
      }

      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.month = '';
        vm.formData.enabledEndDates = [];
      }

      switch (vm.formData.frequency) {
        case 'DZ':
          reSetting();
          break;
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default :
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          reSetting();
          break;
      }
    };

    vm.changeStartDate = function (date) {
      vm.formData.startDate = date ? date : null;
      vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D'):'';
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = false;
      vm.isReseting = true;
      $timeout(function(){vm.isReseting = false;});
      updateEndDates();
    };

    vm.changeEndDate = function (date) {
      vm.formData.endDate = date ? date : null;
    };

    vm.addOptionalTransaction = function () {
      vm.formData.optionalInvestmentType = (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) ? vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE : vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP
      // fetchInSchemes();
    };

    vm.changeTillPerpetuityFlag = function () {
      vm.formData.endDate = null;
      vm.resetting = true;
      $timeout(function () {
        vm.resetting = false;
        if (vm.formData.isTillPerpetuity) {
          var defaultMonths = null;
          var endDate = moment(new Date("12/31/2036"));
          var freq = vm.validations && vm.validations.maxInstallments || 0;

          if(!vm.frequencyList){
            vm.frequencyList = getFrequencyList();
          }
          var frequency = vm.frequencyList.find(function (f) {
                return f.key === vm.formData.frequency;
              }) || {};

          switch (vm.formData.frequency) {
            case'DZ':
            case'OW':
              // var days = 0;
              defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, moment(endDate));
              freq = freq ||Math.floor((defaultMonths * 30) / frequency.dayfreq)*frequency.dayfreq;
              vm.formData.endDate = vm.formData.startDate.clone().add(freq, 'days');
              break;
            default :
              // var months = 0;
              defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, moment(endDate));
              freq = freq || Math.floor(defaultMonths / frequency.monthfreq)*frequency.monthfreq;
              vm.formData.endDate = vm.formData.startDate.clone().add(freq, 'months');
              break;
          }
        } else {
          vm.formData.startDate && updateEndDates();
        }
      }, 0);
    };

    vm.saveForm = function () {
      vm.isRequired = false;
      vm.isSaving = true;
      var payload = getFinalPayloadData();
      if (!payload) {
        return;
      }

      LoaderService.showLoader();
      var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
                vm.formData.transactionId = resp.data.transactionId;
              ModalService.savedTransactionModal();
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };

      var _controller2 = vm.transactionType.toLowerCase();

      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX ){
        _controller2 = 'flex-index';
      }

      TransactionService.post({
        controller1: 'transaction',
        controller2: _controller2,
        controller3: 'save'
      }, payload).$promise.then(success, error);
    };

    function resetBankDetails() {
      vm.formData.bankCity = '';
      vm.formData.bankBranch = '';
      vm.formData.bankAcNo = '';
      vm.formData.verifyBankAcNo = '';

    }

    vm.otherBankSelected = function () {
      //vm.formData.bankInfo = '';
    };

    vm.goToSummary = function () {
      // var transactionSubType = '';

      /*if(transactionSubType){
        var data = {transactionType: vm.transactionType, transactionSubType: transactionSubType};
      } else {
        data = {transactionType: vm.transactionType};
      }*/
      // vm.formData.isBackFromSummary = true;
      vm.isRequired = true;
      vm.isSaving = false;
      $state.$previous = $state.current;
      if (vm.tForm.$valid) {
        var payloadData = getFinalPayloadData();
        if (!payloadData) {
          return;
        }
        var selectedFolioObj = vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        payloadData.email = selectedFolioObj.email ? selectedFolioObj.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
        payloadData.mobileNumber = selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;
        payloadData.randomOTPId = vm.randomOTPId;
        TransactionModel.setPayloadRawData(payloadData);
        vm.summaryData = payloadData;
        vm.formData.isSummaryViewEnabled = true;
        // $state.go('main.summary', data);
      }
    };

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        e.preventDefault();
      }
      return false;
    };

    vm.copyPasteHandler = function (e) {
      UtilService.copyPasteHandler(e);
    };

    vm.accModelDirty = false;
    vm.accFocus = function () {
      vm.accModelDirty = true;
    };

    function checkOTMAmountAndDate() {

      vm.isOTMAmount= false;
      vm.isOTMDate = false;
      // Check Ammout
      if(vm.formData.amount && (vm.formData.amount > vm.formData.bankInfo.maxAmount)){
        vm.isOTMAmount= true;
      }else{
        vm.isOTMAmount= false;
      }

      //Compare Dates
      if(new Date(vm.formData.bankInfo.omExpiryDate) < new Date(vm.formData.startDate)){
        vm.isOTMDate = true;
      }
      else {
        vm.isOTMDate = false;
      }
      //Check for amount or date
      if(vm.isOTMAmount || vm.isOTMDate){
        vm.isInvalidForm = true;
      }else{
        vm.isInvalidForm = false;
      }
    }
    function getDetails(folioNumber, cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
        var bankDetails=[];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if(vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length>0){
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if(value.defaultBank===true){return value;}
          });
          cb(true);
        }
        localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
      }, error = function () {
        cb(false);
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: folioNumber}).$promise.then(success, error);
    }
    function changeBank() {
       vm.selectedFolioObj = vm.folioList.filter(function (row) {
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      if(vm.selectedFolioObj.minorFlag && !vm.formData.bankInfo.minorBankFlag) {
        localStorage.setItem('folioId',vm.selectedFolioObj.folioNumber);
        getDetails(vm.selectedFolioObj.folioNumber, function (success) {
          if (success) {
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
          }
        });
      }
    }

    /**
     * Function responsible for checking blocked transaction flag for blocking transaction
     */

    function checkIsTxnBlock(cb) {
      cb = cb || function () {};
      var successHandler = function(resp){
        if(resp){
          vm.folioListToBlockTxnsaction = resp.folioList ? resp.folioList :null;
          vm.popUpMessage = resp.popUpMessage ? resp.popUpMessage : null;
          vm.blockFolioForTransaction = resp.blockFolioForTransaction ? resp.blockFolioForTransaction : false;
          cb();
        }else{
          MessageService.error();
          cb();
        }
      };
      UtilService.checkTxnBlock().then(successHandler).catch(function(resp) {
        MessageService.error(resp)
      });
    }


  }
})();

/**
 * Created by sudarshan on 17/4/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('SwpHelper', swpHelper);


  /** @ngInject */
  function swpHelper() {
    var vm = null;

    function setViewModel(model) {
      vm = model;
    }

    function isFormValid() {
      var isValid = false;
      var form = vm.formData

      if(form.investmentType === 'PURCHASE'){
        if(form.purchaseInSchemeName && form.purchaseAmount){

          if(form.purchaseAmount >= vm.purchaseMinAmount){
            isValid = true;
          }
        }
      }

     else if(form.investmentType === 'SIP'){
        isValid = true;
      }

      return isValid;


    }

    function calculateSwpStartDate() {
      vm.formData.startDate = vm.enabledStartDates[vm.formData.month];
      vm.updateEndDates(true);

    }

    return {

      setViewModel: setViewModel,
      isFormValid:isFormValid,
      calculateSwpStartDate:calculateSwpStartDate
    };
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('SwitchHelper', switchHelper);


  /** @ngInject */
  function switchHelper() {
    var vm = null;
    /*var minAmount = {'daily':500, 'weekly':1000, 'monthly':1000, 'quarterly':3000},
      minInstallments = {'daily':6, 'weekly':6, 'monthly':6, 'quarterly':2};
    var flexStpValidations = null;*/
      function init() {
        vm.isMinInstallments = true;
      }

      function setViewModel(model) {
      vm = model;
      init();
    }

    return {

      setViewModel: setViewModel
    };
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('StpHelper', stpHelper);


  /** @ngInject */
  function stpHelper($window, $timeout, UtilService, SchemeService, MessageService , termsCondition) {
    // var payload = null;
    var vm = null;
    var flexStpValidations = null;
    /*var minAmount = {'daily': 500, 'weekly': 1000, 'monthly': 1000, 'quarterly': 3000},
      minInstallments = {'daily': 6, 'weekly': 6, 'monthly': 6, 'quarterly': 2};
*/

    function init() {
      vm.isMinInstallments = true;
      vm.showTermsFlex = true;
    }

    function setViewModel(model) {
      vm = model;
      init();
    }


    function changeFrequency(rawData) {

      if (rawData) {
        vm.formData.frequency = rawData.frequency;
      }
      var freq = vm.formData.frequency;
      var props = vm.specificProperties;
      vm.validations = vm.validations || {};
      //  vm.extractValidationObject(vm.inSchemeValidations);
      /*vm.formData.startDate = '';
      vm.formData.endDate = '';
      vm.formData.day = null;*/

      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        vm.formData.day = null;
        vm.formData.month = null;
      }


      if (freq === 'DZ') {
        vm.viewMode = 'days';
        props.showDateOfTransfer = false;
        props.showDayOfTransfer = false;
        props.showStartEndDate = true;
        props.showInstallment = false;

        changeFreqDaily();
        vm.validations.minInstallments = 6;
        if (!vm.formData.amount || parseInt(vm.formData.amount) < 1000) {
          vm.validations.minInstallments = 12;
        }
        vm.validations.minAmount = flexStpValidations.dailyMinAmt;

      } else if (freq === 'OW') {
        vm.viewMode = 'days';
        vm.daysList = vm.TRANSACTIONS_CONST.WEEKS_LIST;
        props.showDateOfTransfer = false;
        props.showDayOfTransfer = true;
        props.showStartEndDate = true;
        props.showInstallment = false;
        // vm.formData.day = 6;
        vm.formData.noOfInstallments = '';
        if (flexStpValidations) {
          vm.validations.minInstallments = flexStpValidations.weeklyMinInstallmentNumber;
          vm.validations.minAmount = flexStpValidations.weeklyMinAmt;
        }

      } else if (freq === 'OM') {
        vm.viewMode = 'months';
        vm.daysList = vm.TRANSACTIONS_CONST.DAYS_LIST;
        props.showDateOfTransfer = true;
        props.showDayOfTransfer = false;
        props.showStartEndDate = true;
        props.showInstallment = false;
        if (flexStpValidations) {
          vm.validations.minInstallments = flexStpValidations.monMinInstallmentNumber;
          vm.validations.minAmount = flexStpValidations.monMinAmt;
        }
      } else if (freq === 'Q') {
        props.showDateOfTransfer = true;
        props.showDayOfTransfer = false;
        props.showStartEndDate = true;
        props.showInstallment = false;
        if (flexStpValidations) {
          vm.validations.minInstallments = flexStpValidations.quarterlyMinInstallmentNumber;
          vm.validations.minAmount = flexStpValidations.quarterlyMinAmt;
        }
      } else {
        props.showDateOfTransfer = false;
        props.showDayOfTransfer = false;
        props.showStartEndDate = false;
        props.showInstallment = false;
        if (flexStpValidations) {
          vm.validations.minInstallments = flexStpValidations.quarterlyMinInstallmentNumber;
          vm.validations.minAmount = flexStpValidations.quarterlyMinAmt;
        }
      }
    }

    function changeFreqDaily() {
      var currentDay = $window.moment().add(3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});

      /*var installments = vm.formData.noOfInstallments;

      var endDate = currentDay.clone().add(installments, 'days');

      vm.formData.startDate = currentDay.clone();
      vm.formData.endDate = endDate.clone();
      vm.formData.day = +(vm.formData.startDate.format('DD'));*/
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.formData.startDate = vm.enabledStartDates[0];
      vm.formData.day = +(vm.formData.startDate.format('DD'));
      updateEndDates();
    }

    function updateEndDates(doNotUpdateEndDate) {
      if (!vm.formData.startDate) {
        return;
      }

      if (vm.formData.isTillPerpetuity) {
        vm.formData.endDate = $window.moment("12/31/2036");
        vm.enabledEndDates = [$window.moment("12/31/2036")];
        return;
      }

      var defaultEndDate = new Date(2036, 12, 31);
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations.maxInstallments || 0;
      var i = 0;

      var frequency = vm.frequencyList.find(function (f) {
        return f.key === vm.formData.frequency;
      }) || {};

      switch (vm.formData.frequency) {
        case'DZ':
        case'OW':
          var days = 0;
          endDate = vm.formData.startDate.clone().add(frequency.dayfreq, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / frequency.dayfreq);
          for (i = 0; i < freq; i++) {
            days = frequency.dayfreq * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          endDate = vm.formData.startDate.clone().add(frequency.monthfreq, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.monthfreq);
          for (i = 0; i < freq; i++) {
            months = frequency.monthfreq * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      var minInstallments = vm.validations.minInstallments && (vm.validations.minInstallments - 2) || 0;
      vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      vm.enabledEndDateView=angular.copy(vm.enabledEndDates[0]);
      if (!doNotUpdateEndDate) {
        vm.formData.endDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
        vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
      } else {
        vm.formData.endDate = null;
        vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);

      }
      reSetting();
    }

    function reSetting() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function changeNumberOfInstallments() {
      var freq = vm.formData.frequency;
      if (freq === 'DZ') {
        changeFreqDaily();

      } else if (freq === 'OW') {
        changeDay();
      } else if (freq === 'OM') {
        changeDate();
      }

    }

    function changeDay() {

      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        reSetting();
      }
      var currentDay = $window.moment().add(2, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});

      var installments = vm.formData.noOfInstallments;

      var enabledStartDates = [];
      var _day = vm.daysList.find(function (d) {
        return d.value === vm.formData.day;
      }) || {};

      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd') === _day.name) {
          enabledStartDates.push(_date.clone());
        }
      }

      vm.enabledStartDates = angular.copy(enabledStartDates);
      if (vm.formData.isBackFromSummary) {
        vm.formData.startDate = vm.formData.startDate ? vm.formData.startDate : vm.enabledStartDates[0];
        var endDate = vm.formData.startDate.clone().add(7 * parseInt(installments), 'days');
        vm.formData.endDate = endDate.clone();
      }

    }

    function changeDate() {
      if (!vm.formData.day) {
        return;
      }
      var currentDay = $window.moment();
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.formData.day);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      var tDays = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? 15 : 10;
      while (_diff < tDays) {
        updatedDate.add(1, 'months').set('date', vm.formData.day);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }

      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }

      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.formData.startDate = vm.enabledStartDates[0];
      vm.minStartDate = angular.copy(vm.enabledStartDates[0]);
      updateEndDates();

    }

    /*function updateEndDates(doNotUpdateEndDate) {
      if (!vm.formData.startDate) {
        return;
      }

      if (vm.formData.isTillPerpetuity) {
        vm.formData.endDate = $window.moment("12/31/2036");
        vm.enabledEndDates = [$window.moment("12/31/2036")];
        return;
      }

      var defaultEndDate = new Date(2036, 12, 31);
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations.maxInstallments || 0;
      var i = 0;

      var frequency = vm.frequencyList.find(function (f) {
        return f.key === vm.formData.frequency;
      }) || {};

      switch (vm.formData.frequency) {
        case'DZ':
        case'OW':
          var days = 0;
          endDate = vm.formData.startDate.clone().add(frequency.dayfreq, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / frequency.dayfreq);
          for (i = 0; i < freq; i++) {
            days = frequency.dayfreq * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          // endDate = vm.formData.startDate.clone().add(frequency.monthfreq, 'months');
          endDate = vm.formData.startDate.clone().add(parseInt(vm.validations.minInstallments), 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.monthfreq);
          for (i = 0; i < freq; i++) {
            months = frequency.monthfreq * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      var minInstallments = vm.validations.minInstallments && (vm.validations.minInstallments - 2) || 0;
      vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      vm.enabledEndDateView=angular.copy(vm.enabledEndDates[0]);
      if (!doNotUpdateEndDate) {
        vm.formData.endDate = angular.copy(vm.enabledEndDates[0]);
      }

      if (vm.formData.frequency === 'OM') {
        if (!doNotUpdateEndDate) {
          vm.formData.endDate = vm.formData.startDate.clone().add(parseInt(vm.validations.minInstallments), 'months');
        }
        // calculateNumberOfInstallmentForStp();
      } else if (vm.formData.frequency === 'Q') {
        if (!doNotUpdateEndDate) {
          vm.formData.endDate = vm.formData.startDate.clone().add(parseInt(vm.validations.minInstallments * 4), 'months');
        }
        // calculateNumberOfInstallmentForStp();
      }
      //  reSetting();

    }*/

    function calculateNumberOfInstallmentForStp() {

      function getAbsoulteMonths(momentDate) {
        var months = Number(momentDate.format("MM"));
        var years = Number(momentDate.format("YYYY"));
        return months + (years * 12);
      }

      var startMonths = getAbsoulteMonths(vm.formData.startDate);
      var endMonths = getAbsoulteMonths(vm.formData.endDate);

      var monthDifference = endMonths - startMonths;
      if (vm.formData.frequency === 'Q') {
        vm.formData.noOfInstallments = Math.floor((monthDifference) / 3) + 1;
      } else {
        vm.formData.noOfInstallments = (monthDifference + 1);
      }
    }

    function calculateNumberOfInstallmentForStpDaysWeek() {

      var startDate = vm.formData.startDate;
      startDate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var endDate = vm.formData.endDate;
      endDate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var _diff = UtilService.getDifferenceInDays(startDate, endDate);

      if (vm.formData.frequency === 'DZ') {
        vm.formData.noOfInstallments = _diff;
      } else {
        vm.formData.noOfInstallments = Math.floor((_diff / 7) + 1);
      }
    }

    function changeStpType(stpType, rawData) {

      if (vm.specificProperties.stpType === 'flexStp' || vm.specificProperties.stpType === 'swingStp') {
        fetchFlexStpValidations(function () {
          changeFrequency(rawData);
        });
      }
      if (stpType === 'Q' && vm.frequencyList.length === 4) {
        vm.frequencyList.splice(0, 1);
      } else if (vm.frequencyList.length === 3) {
        vm.frequencyList.splice(0, 0, {key: 'DZ', value: 'Daily', dayfreq: 1});
      }
      vm.formData.folioNumber = '';
      vm.resetAll();
      vm.formData.transferOption = stpType;
      vm.stpTransactionType = ''

      if(stpType === 'T')
      {
        vm.stpTransactionType = 'Flex_STP'
        vm.key = "TNC_FLEXSTP"
      } else if(stpType === 'F'){
        vm.key = "TNC_Review_STP"
        vm.stpTransactionType = 'STP'
      }

      var successHandler = function(resp) {
        if(Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || !resp.termAndConditionDTO.termAndConditionDTOMap[vm.key])
          {
            if(stpType === 'T')
            {
              vm.showTermsFlex = false;
            } else if(stpType === 'F'){
              vm.showTerms = false;
            }
          }
      }

      termsCondition.fetchData(vm.stpTransactionType).then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });



    }

    function fetchFlexStpValidations(cb) {

      // if (!vm.formData.isBackFromSummary) {
      //   vm.formData.startDate = null;
      //   vm.formData.endDate = null;
      //   vm.enabledStartDates = null;
      //   vm.enabledEndDates = null;
      //   vm.formData.day = '';
      //   vm.formData.frequency = null;
      //   vm.validations = {};
      //   vm.isMultiples = false;
      //   vm.isMin = false;
      //   vm.isMax = false;
      // //  reSetting();
      // }

      cb = cb || function () {

      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            flexStpValidations = resp.data;
            cb();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: vm.transactionType.toLowerCase(),
        child1: 'All'
      }, null).$promise.then(success, error);

    }

    return {

      setViewModel: setViewModel,
      changeFrequency: changeFrequency,
      changeNumberOfInstallments: changeNumberOfInstallments,
      changeDay: changeDay,
      changeDate: changeDate,
      changeStpType: changeStpType,
      calculateNumberOfInstallmentForStp: calculateNumberOfInstallmentForStp,
      calculateNumberOfInstallmentForStpDaysWeek: calculateNumberOfInstallmentForStpDaysWeek
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InitiateTransactionSmartSwpController', initiateTransactionSmartSwpController);

  /** @ngInject */
  function initiateTransactionSmartSwpController($timeout, $stateParams, MessageService, ModalService, InvestorService,
                                                 SchemeService, TransactionService, AppConstants, $state, LoaderService, UtilService,
                                                 moment, TransactionModel, AuthService, StpHelper, SwpHelper, $window, investorServiceVersion , DynamicDataReview , panAadharService) {


    var vm = this;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    vm.transactionType = getTransactionTypeFromStateParams() || getTransactionType();
    vm.formData = TransactionModel.getPayloadRawData() || TransactionModel.getMasterRawData(vm.transactionType);
    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.specificProperties = TransactionModel.getTransactionSpecificProperties(vm.transactionType);
    vm.folioList = null;
    vm.unitsDetails = null;
    vm.outSchemeValidations = null;
    vm.validations = {};
    vm.investorInfo = null;
    vm.isRequired = false;
    vm.bankList = null;
    vm.outSchemeList = null;
    vm.tForm = {};
    vm.isSaving = false;
    vm.isReseting = false;
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.daysList = getDaysList();
    vm.weekList = vm.TRANSACTIONS_CONST.WEEKS_LIST;
    vm.isSchemeDisabled = false;
    vm.isShowDefault = 'false';
    vm.viewMode = 'days';
    vm.isInvalidForm = false;
    vm.isCheckedTandC = 'false';
    vm.profile = AuthService.getToken();
    var name = vm.profile ? vm.profile.investorFName.toLowerCase() : '';
    vm.investorName = name.charAt(0).toUpperCase() + name.slice(1);
    vm.calenderEndDateString = '31-Dec-2036';
    vm.amountInWords = '';
    vm.isSourceSchemeGrowth = false;
    vm.frequencyList = null;
    vm.formData.frequency = null;
    vm.schemeTypeForValidation = '';
    vm.checkValidations = checkValidations;
    vm.extractValidationObject = extractValidationObject;
    vm.resetAll = resetAll;
    vm.isOTMAmount = false;
    vm.isOTMDate = false;
    vm.isArnSuccess = false;
    vm.startMinDate = moment().add(5, 'days').millisecond(0).second(0).minute(0).hour(0);
    vm.startMaxDate = moment().add(120, 'days');
    vm.startZindex = 8;
    vm.endZindex = 4;
    vm.changeBank = changeBank;
    vm.masterOutSchemeList = null;
    vm.percentage = null;
    vm.percentageList = null;
    vm.DynamicDataReview = DynamicDataReview;
    vm.TermsCondition = vm.DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Smart_Swap;
    vm.showTerms = true;
    AuthService.checkLinkedUserStatus();
    vm.filterOutSchemeList = function () {
      vm.formData.outSchemeObj = '';
      vm.formData.outSchemeCode = '';
      vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList, 'schemeName', vm.formData.outSchemeName);

    };

    vm.openTermsAndCondition = function () {
      ModalService.transactionalTermConditionModal({'transactionType':vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP,'subTransactionType':vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP});
    };


    function getDaysList() {
      return vm.TRANSACTIONS_CONST.SIP_DAYS_LIST;
    }


    function resetAll() {
      vm.formData.amountType = 'amount';
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.dividendOption = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.amount = '';
      vm.tForm.amount.$setPristine(false);
      vm.formData.percentage = null;
      vm.tForm.percentage.$setPristine(false);
      vm.formData.units = '';
      vm.formData.bankInfo = null;
      vm.formData.day = '';
      vm.formData.isTillPerpetuity = false;
      vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
      vm.formData.month = '';
      vm.formData.outSchemeCode = '';
      vm.formData.outSchemeName = '';

      vm.outSchemeValidations = null;
      vm.validations = {};
      vm.isRequired = false;
      vm.bankList = null;
      vm.outSchemeList = null;
      vm.unitsDetails = null;
      resetNumInWords(); //reset the number in text form on folio change or form reset

      resetBankDetails();
      vm.formData.frequency = null;
      vm.tForm.frequency.$setPristine(false);
      vm.tForm.$setPristine(false);

    }

    function resetNumInWords() {
      vm.amountInWords = '';
      var inWordsDiv = document.getElementById('divDisplayWords');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
    }

    function reSetting() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function extractValidationObject(validationsData) {
      if (!validationsData) {
        return;
      }
      var amountMultiples = 1;
      var maxAmount = 0;
      var maxInstallments = 0;
      var minInstallments = 0;
      var minAmount = 0;
      vm.validations.amountMultiples = amountMultiples;
      vm.validations.maxInstallments = maxInstallments;
      vm.validations.minInstallments = minInstallments;
      vm.validations.minAmount = validationsData ? validationsData.smartSwapMinAmount ? validationsData.smartSwapMinAmount : minAmount : minAmount;
      vm.isMin=vm.validations.minAmount>vm.formData.amount;
      vm.validations.maxAmount = maxAmount;

    }

    function fetchFolioList() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioList = [];
            vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
            if (resp.data.kycVerifiedFlag === false) {
              ModalService.genericModal({
                text: resp.data.kycMessage
              }, function () {
                $state.go("welcome");
              });
              return;
            }
            Object.keys(resp.data.folioList).forEach(function (key) {
              var obj = Object.assign({key: key}, resp.data.folioList[key]);
              folioList.push(angular.copy(obj));
            });
            vm.folioList = folioList.length ? folioList : null;
            if (vm.folioList && vm.folioList.length === 1) {
              vm.formData.folioNumber = vm.folioList[0].folioNumber;
              if (!vm.formData.isBackFromSummary && !vm.formData.outSchemeCode) {
                vm.folioChanged();
              }
            }
            if (vm.formData.dynamicData && vm.formData.dynamicData.folioNumber) {
              vm.formData.folioNumber = vm.formData.dynamicData.folioNumber;
              vm.folioChanged();
            }
          } else {
            vm.folioList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      investorServiceVersion.get({
        child1: 'folio',
        child2: 'active-list',
        trxnType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP
      }).$promise.then(success, error);
    }

    function checkValidations() {
      vm.isInvalidForm = false;
      if (!vm.inSchemeValidations && !vm.outSchemeValidations) {
        vm.validations = {};
      }

      if (vm.outSchemeValidations) {
        vm.validations.isEnabled = vm.outSchemeValidations ? vm.outSchemeValidations.smartSwapEnabled : null;
        extractValidationObject(vm.outSchemeValidations);
      }

      if (vm.inSchemeValidations) {
        vm.validations.minInstallDivisionFlag = vm.inSchemeValidations.minInstallDivisionFlag;
        vm.validations.swpTaxCode = vm.inSchemeValidations.swpTaxCode;
        vm.validations.endingType = vm.inSchemeValidations.endingType;
        extractValidationObject(vm.inSchemeValidations);
      }
    }


    function fetchOutSchemeValidations(cb) {
      vm.outSchemeValidations = null;
      cb = cb || function () {
      };

      if (!vm.formData.outSchemeCode) {
        return;
      }
      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.enabledStartDates = null;
        vm.enabledEndDates = null;
        vm.formData.day = '';
        vm.formData.frequency = null;
        vm.validations = {};
        vm.isMultiples = false;
        vm.isMin = false;
        vm.isMax = false;
        reSetting();
      }
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.outSchemeValidations = resp.data;
            vm.percentageList = resp.data.smartSwapAllowedPercentage;
            var schemeTypeCheck = vm.outSchemeValidations && vm.outSchemeValidations.investmentOption;
            vm.isSourceSchemeGrowth = schemeTypeCheck == "GROWTH" ? true : false;
            vm.frequencyList = resp.data.frequency;
            cb(null);
          } else {
            cb('error');
            vm.outSchemeValidations = null;
            MessageService.error(resp.message);
          }
          checkValidations();
        },
        error = function (err) {
          vm.outSchemeValidations = null;
          cb('error');
          UtilService.errorHandler(err);
        };

      var _config = {
        controller: 'schemeValidation',
        type: 'smart',
        child1: 'swap'
      };

      var data = {
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.outSchemeCode,
        "transactionType": vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP
      };
      SchemeService.post(_config, data).$promise.then(success, error);


    }

    function fetchUnitDetails() {
      vm.unitsDetails = null;
      if (!vm.formData.outSchemeCode) {
        return;
      }
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        return;
      }
      LoaderService.showLoader();

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.unitsDetails = resp.data;
            vm.unitsDetails.message = resp.message || '';
            vm.unitsDetails.isDisabled = !resp.data.freeValueUnits;
            vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
            vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
            vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
            checkValidations();
          } else {
            vm.unitsDetails = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.unitsDetails = null;
          UtilService.errorHandler(err);
        };
      InvestorService.post({
        child1: 'transaction',
        child2: 'folio',
        child3: 'scheme-value'
      }, {
        schemeCode: vm.formData.outSchemeCode,
        transactionType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP,
        folioNo: vm.formData.folioNumber
      }).$promise.then(success, error);
    }

    function getInvestorInfo() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
        } else {
          vm.investorInfo = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.investorInfo = null;
      };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'folio',
        child2: 'info'
      }).$promise.then(success, error);
    }

    function getTransactionDetails() {
      if (!$stateParams.transactionId) {
        MessageService.error("TransactionId is missing for saved transaction.");
        $state.go('main.dashboard');
        return;
      }

      var success = function (resp) {
          if (resp.data && resp.status) {
            showPrefillValues(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'transaction',
        controller2: 'saved',
        controller3: $stateParams.transactionId,
        controller4: $stateParams.isCompId
      }).$promise.then(success, error);
    }

    function getTransactionTypeFromStateParams() {
      return $stateParams.transactionType;
    }

    function getTransactionType() {
      var transactionType = '';
      switch ($state.current.name) {
        case 'main.transactions.swp':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP;
          break;
        case 'main.transactions.smartSwap':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP;
          break;
        default :
          $state.go('welcome');
          break;
      }
      return transactionType;
    }

    function getFinalPayloadData() {
      var payload = null;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP:
          payload = vm.isSaving ? getSwpPayloadToSave() : getSwpPayloadToSubmit();
          break;
      }
      return angular.copy(payload);
    }

    function getSwpPayloadToSave() {
      var payload = {
        amount: vm.formData.amount,
        folioNumber: vm.formData.folioNumber,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP,
        frequency: vm.formData.frequency,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        schemeCode: vm.formData.outSchemeCode,
        startDate: vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
        toDate: vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
        swpDay: vm.formData.day,
        accountNumber: vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '',
        ifscCode: vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : '',
        bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : '',
        branchName: vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '',
        payMech: vm.formData.bankInfo ? vm.formData.bankInfo.payMech : '',
        primaryBankFlag: vm.formData.bankInfo ? vm.formData.bankInfo.primaryFlag : '',
        payoutId: vm.formData.bankInfo ? vm.formData.bankInfo.payoutId : '',
        percentage: vm.formData.percentage,
      };

      return angular.copy(payload);
    }

    function getSwpPayloadToSubmit() {
      vm.formData.formType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP;
      vm.formData.id = vm.formData.isFavourite ? "" : vm.formData.transactionId;
      vm.formData.amountInWords = $window.document.getElementById('divDisplayWords') ? $window.document.getElementById('divDisplayWords').textContent : '';
      vm.formData.marketValue = vm.unitsDetails.totalCurrentValueAmount;
      return angular.copy(vm.formData);
    }

    function fetchOutSchemes(cb) {
      cb = cb || function () {
      };

      if (!vm.formData.folioNumber) {
        return;
      }

      vm.outSchemeList = null;
      var success = function (resp) {
          LoaderService.hideLoader(".scheme-loader");
          if (resp.status && resp.data) {
            vm.outSchemeList = resp.data.schemes;
            vm.masterOutSchemeList = vm.outSchemeList;
            cb();
          } else {
            vm.outSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader(".scheme-loader");
          vm.outSchemeList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader(".scheme-loader");
      var _config = {child1: 'folio', child2: 'schemes'};
      InvestorService.post(_config,
        {
          folioNumber: vm.formData.folioNumber,
          transactionType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP
        }
      ).$promise.then(success, error);
    }

    function fetchBankList(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            if (vm.bankList && vm.bankList.length == 1) {
              vm.formData.bankInfo = vm.bankList[0];
              changeBank();
            }
            cb();
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();

      InvestorService.post({
        child1: 'folio',
        child2: 'scheme',
        child3: 'bankList'
      }, {schemeCode: vm.formData.outSchemeCode, folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }


    function updateDatesForWeekly() {
      var currentDay = moment().add(3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});

      var enabledStartDates = [];
      var _day = vm.daysList.find(function (d) {
        return d.value === vm.formData.day;
      }) || {};
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd') === _day.name) {
          enabledStartDates.push(_date.clone());
        }
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
    }

    function updateDatesForOthers() {
      var currentDay = moment();
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.formData.day);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      var tDays = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? 15 : 10;
      while (_diff < tDays) {
        updatedDate.add(1, 'months').set('date', vm.formData.day);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }

      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }

      vm.enabledStartDates = angular.copy(enabledStartDates);
      calculateMonthsForSmartSwap();
    }

    function calculateMonthsForSmartSwap() {
      var arr = [];
      for (var i = 0; i < vm.enabledStartDates.length; i++) {
        var str1 = vm.enabledStartDates[i].format('MMM') + ', ' + vm.enabledStartDates[i].format('YYYY');
        var str2 = i;
        arr.push({name: str1, value: str2});

      }
      vm.formData.monthList = arr;
    }


    function showPrefillValues(rawData) {
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP:
          if (rawData) {
            swpPrefillValues(rawData)
          } else {
            vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
            fetchFolioList();
            fetchOutSchemes();
            fetchUnitDetails();
            fetchOutSchemeValidations(function (err) {
              if (!err) {
                checkValidations();
                vm.formData.isBackFromSummary = false;
              }
            });
            fetchBankList();
          }
          break;
      }
    }

    function swpPrefillValues(rawData) {
      fetchFolioList();
      vm.formData.transactionId = rawData.id ? rawData.id : null;
      vm.formData.folioNumber = rawData.folioNumber ? rawData.folioNumber : null;
      vm.formData.outSchemeCode = rawData.schemeCode ? rawData.schemeCode : rawData.sc ? rawData.sc : null;
      vm.formData.percentage = rawData.percentage ? rawData.percentage : null;
      vm.folioChanged();
      fetchOutSchemes(function () {
        var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
          return vm.formData.outSchemeCode === item.schemeCode;
        }) || {};
        vm.formData.outSchemeName = scheme.schemeName || '';
      });
      fetchBankList(function () {
        vm.formData.bankInfo = vm.bankList.find(function (i) {
          return i.payoutId === rawData.payoutId;
        }) || null;
      });
      fetchUnitDetails();
      fetchOutSchemes();
      fetchOutSchemeValidations(function (err) {
        if (!err) {
          vm.formData.transferOption = rawData.swpType;
          vm.formData.frequency = rawData.frequency;
          vm.isShowDefault = 'true';
          vm.formData.day = rawData.swpDay ? +rawData.swpDay : '';
          vm.changeDay();
          vm.formData.amount = rawData.amount;
          checkValidations();
          vm.formData.isBackFromSummary = false;
          if (vm.formData.amount)
            $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
        }
      });
    }

    vm.init = function () {
      $state.$previous = null;
      TransactionModel.setPayloadRawData(null);
      getInvestorInfo();

      if (vm.formData.isBackFromSummary || $stateParams.sc) {
        swpPrefillValues($stateParams);
      } else if ($stateParams.transactionId) {
        getTransactionDetails();
      } else {
        fetchFolioList();
      }
      vm.daysList = getDaysList();
      vm.viewMode = 'months';
      if(!DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Smart_Swap)
      {
        vm.showTerms = false;
      }
      var successRandomOTPIdHandler = function(resp) {
        vm.randomOTPId = resp.randomOTPId ? resp.randomOTPId : null;
      }, errorRandomOTPIdHandler = function (){}
      UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
      // checkIsTxnBlock();
    };


    vm.folioChanged = function () {

      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        if(vm.folioListToBlockTxnsaction && vm.folioListToBlockTxnsaction.includes(vm.formData.folioNumber)){
          if(AppConstants.TRANSACTION_CONST_LIST_TO_BLOCK.includes(vm.transactionType)){
            var success = function(){
              if(vm.blockFolioForTransaction){
                vm.formData.folioNumber = null;
                //var oldData = angular.copy(vm.formData);
                resetAll();
              }
            }, error = function(){};
            ModalService.genericModal({isUpi : true, text : vm.popUpMessage}, success, error);
          }
        }
        MessageService.clear();
        resetAll();
        fetchOutSchemes(function () {
        });
      };

      var errorHandler= function(resp)
      {
        LoaderService.hideLoader();
        vm.formData.folioNumber=null;
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);

    }

    vm.outSchemeChanged = function (schemeData) {
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      resetNumInWords();
      resetBankDetails();
      vm.formData.amount = null;
      vm.tForm.amount.$setPristine(false);
      vm.formData.percentage = null;
      vm.tForm.percentage.$setPristine(false);
      vm.formData.frequency = null;
      vm.tForm.frequency.$setPristine(false);
      vm.formData.units = '';
      vm.formData.amountType = 'amount';
      if (vm.transactionType != vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION) {
        vm.formData.bankInfo = null;
        vm.bankList = null;
      }
      vm.unitsDetails = null;
      vm.formData.dividendOption = '';
      vm.formData.frequency = null;
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.day = '';

      if(schemeData) {
        vm.formData.outSchemeCode = schemeData.schemeCode;
        vm.formData.outSchemeName = schemeData.schemeName;
      }

      if (!vm.formData.outSchemeCode) {
        vm.formData.outSchemeName = '';
        return;
      }

      var scheme = vm.outSchemeList.find(function (item) {
        return item.schemeCode === vm.formData.outSchemeCode;
      }) || {};
      vm.formData.outSchemeName = scheme.schemeName || '';

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION) {
        vm.helper.setInstantRedSchemeValidations(scheme);
      } else {
        if (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP) {
          fetchOutSchemeValidations();
          fetchUnitDetails();
        }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP) {
          fetchBankList();
        }
      }
    };


    vm.changeDay = function () {
      if (!vm.formData.frequency || !vm.formData.day) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        reSetting();
        return;
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.month = '';
        vm.formData.enabledEndDates = [];
      }

      switch (vm.formData.frequency) {
        case 'DZ':
          reSetting();
          break;
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default :
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          reSetting();
          break;
      }
    };

    vm.changeStartDate = function (date) {
      vm.formData.startDate = date ? date : null;
      vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = false;
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      });
    };

    vm.changeEndDate = function (date) {
      vm.formData.endDate = date ? date : null;
    };

    vm.saveForm = function () {
      vm.isRequired = false;
      vm.isSaving = true;
      var payload = getFinalPayloadData();
      if (!payload) {
        return;
      }

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.formData.transactionId = resp.data.transactionId;
            var successModal =function (){
              $state.go("welcome");
            };
            ModalService.savedTransactionModal({},successModal);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      var _controller2 = vm.transactionType.toLowerCase();

      TransactionService.post({
        controller1: 'transaction',
        controller2: _controller2,
        controller3: 'save'
      }, payload).$promise.then(success, error);
    };

    function resetBankDetails() {
      vm.formData.bankCity = '';
      vm.formData.bankBranch = '';
      vm.formData.bankAcNo = '';
      vm.formData.verifyBankAcNo = '';
      vm.tForm.bank.$setPristine(false);

    }

    vm.goToSummary = function () {
      vm.isRequired = true;
      vm.isSaving = false;
      $state.$previous = $state.current;
      if (vm.tForm.$valid) {
        var payloadData = getFinalPayloadData();
        if (!payloadData) {
          return;
        }
        var selectedFolioObj = vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        payloadData.email = selectedFolioObj.email ? selectedFolioObj.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
        payloadData.mobileNumber = selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;
        payloadData.randomOTPId = vm.randomOTPId;
        TransactionModel.setPayloadRawData(payloadData);
        vm.summaryData = payloadData;
        vm.transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP;
        vm.formData.isSummaryViewEnabled = true;
        // $state.go('main.summary', data);
      }
    };

    function getDetails(folioNumber, cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
        var bankDetails = [];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        vm.folioDetailsData.folioNumber = folioNumber;
        if (vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length > 0) {
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if (value.defaultBank === true) {
              return value;
            }
          });
          cb(true);
        }
        localStorage.setItem('bankDetails', $window.JSON.stringify(bankDetails));
      }, error = function () {
        cb(false);
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: folioNumber}).$promise.then(success, error);
    }

    function changeBank() {
      vm.selectedFolioObj = vm.folioList.filter(function (row) {
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      if (vm.selectedFolioObj.minorFlag && !vm.formData.bankInfo.minorBankFlag) {
        sessionStorage.setItem('folioId', vm.selectedFolioObj.folioNumber);
        getDetails(vm.selectedFolioObj.folioNumber, function (success) {
          if (success) {
            ModalService.minorBankModal({folioDetailsData: vm.folioDetailsData});
          }
        });
      }
    }

    function checkIsTxnBlock() {
      var successHandler = function(resp){
        if(resp){
          vm.folioListToBlockTxnsaction = resp.folioList ? resp.folioList :null;
          vm.popUpMessage = resp.popUpMessage ? resp.popUpMessage : null;
          vm.blockFolioForTransaction = resp.blockFolioForTransaction ? resp.blockFolioForTransaction : false;
        }else{
          MessageService.error();
        }
      };
      UtilService.checkTxnBlock().then(successHandler).catch(function(resp) {
        MessageService.error(resp)
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InitiateTransactionSipTopupController', initiateTransactionSipTopupController);

  /** @ngInject */
  function initiateTransactionSipTopupController($window, AppConstants, SchemeService, MessageService, $state, ModalService, TransactionModel, UtilService, LoaderService, InvestorService, $timeout) {
    var vm = this;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.getTopupFrequencyList = getTopupFrequencyList;
    vm.changeEndDate = changeEndDate;
    vm.capAmountChanged = capAmountChanged;
    vm.isminCapAmount = false;
    vm.transactionData = $window.JSON.parse(localStorage.getItem('transactionDataSipTopup'));
    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
    // var identifierData = AuthService.getToken();
    vm.topupFrequencyList = [
      {key: 'Y', value: 'Yearly', monthfreq: 12},
      {key: 'H', value: 'Half Yearly', monthfreq: 6}
    ];
    vm.formData = {
      topupDetails: {

      }
    };
    vm.showTopUpPercentage = AppConstants.SET_TOP_UP_PERCENTAGE_VIEW;
    vm.init = init();

    function init() {
      changeEndDate();
      vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      vm.formData.sipPaymentOption = vm.formData.sipPaymentOption || vm.paymentOptions[0];
      var schemeCode = vm.transactionData.schemeCode;
      getTopupFrequencyList();
      fetchOutSchemeValidations(schemeCode);
      fetchBankList();
    }

    function fetchOutSchemeValidations(schemeCode) {
      vm.outSchemeValidations = null;

      if (!schemeCode) {
        return;
      }
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.schemeValidationsData = resp.data;
          } else {
            vm.schemeValidationsData = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.schemeValidationsData = null;
          UtilService.errorHandler(err);
        };


      var data = {
        folioNumber: vm.transactionData.folioNumber,
        schemeCode: vm.transactionData.schemeCode
      };
      SchemeService.post({
        controller: 'schemeValidation',
        type: vm.transactionData.type.toLowerCase()/*,
        child1: vm.transactionData.schemeCode,
        child2: vm.transactionData.folioNumber*/
      }, data).$promise.then(success, error);
    }

    vm.changeTopupAmount = function (sipTopupForm) {
      vm.isMinTopupAmount = vm.schemeValidationsData && vm.schemeValidationsData.topupMinAmt > vm.formData.topupDetails.amount;
      if (vm.formData.topupDetails.amount < vm.schemeValidationsData.topupMinAmt) {
        sipTopupForm.$invalid = true;
      }

      vm.isMultipleTopupAmount = vm.schemeValidationsData.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.schemeValidationsData.topupAmtMultples === 0) || false;
      if (vm.schemeValidationsData.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.schemeValidationsData.topupAmtMultples === 0) || false) {
        sipTopupForm.$invalid = true;
      }

      if(vm.formData.topupDetails.amount >= 2000000){
        vm.amountExceeded = true;
      }else {
        vm.amountExceeded = false;
      }

    };

    vm.changeTopupPercentage = function (sipTopupForm) {
      vm.isMinTopupPercentage = vm.schemeValidationsData && vm.schemeValidationsData.topupMinPercentage > vm.formData.topupDetails.percentage;
      if (vm.formData.topupDetails.percentage < vm.schemeValidationsData.topupMinPercentage) {
        sipTopupForm.$invalid = true;
      }

      vm.isMultipleTopupPercentage = vm.schemeValidationsData.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.schemeValidationsData.topupPercentageMultples === 0) || false;
      if (vm.schemeValidationsData.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.schemeValidationsData.topupPercentageMultples === 0) || false) {
        sipTopupForm.$invalid = true;
      }

    };

    function changeEndDate() {
      var startDate = vm.transactionData.startDate;
      var endDate = vm.transactionData.endDate;
      var diffInMonths = parseInt($window.moment(endDate,"DD-MMM-YYYY").diff($window.moment(startDate,"DD-MMM-YYYY"), 'months', true));
      if (diffInMonths >= 6) {
        vm.formData.showTopUpBlock = true;
        if(diffInMonths >= 12){
          var capStartDate = $window.moment(startDate,"DD-MMM-YYYY").add(12, 'months').format("MMM-YYYY");
        }
        else{
          capStartDate = $window.moment(startDate,"DD-MMM-YYYY").add(6, 'months').format("MMM-YYYY");
        }
        vm.capDates = [];
        var capLastDate = capStartDate;
        while ($window.moment(capLastDate,"MMM-YYYY").isBefore($window.moment(endDate,"MMM-YYYY"))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(capStartDate);
          }
          capStartDate = $window.moment(capStartDate,"MMM-YYYY").add(12, 'months').format("MMM-YYYY");
          if ($window.moment(capStartDate,"MMM-YYYY").isBefore($window.moment(endDate,"MMM-YYYY"))) {
            vm.capDates.push(capStartDate);
          }
          else {
            break;
          }
          capLastDate = vm.capDates[vm.capDates.length - 1];
        }
      }
    }

    vm.changeTopUpFreq = function () {
      var duration = 6;
      switch (vm.formData.topupDetails.frequency){
        case 'H':duration=6;break;
        case 'Y':duration=12;break;
      }if(duration === 12){
        var capStartDate = $window.moment(vm.transactionData.startDate,"DD-MMM-YYYY").add(12, 'months').format("MMM-YYYY");
      }
      else{
        capStartDate = $window.moment(vm.transactionData.startDate,"DD-MMM-YYYY").add(6, 'months').format("MMM-YYYY");

      }
      vm.capDates = [];
      var capLastDate = capStartDate;
      while ($window.moment(capLastDate,"MMM-YYYY").isBefore($window.moment(vm.transactionData.endDate,"MMM-YYYY"))) {
        if (vm.capDates.length === 0) {
          vm.capDates.push(capStartDate);
        }
        capStartDate = $window.moment(capStartDate,"MMM-YYYY").add(duration, 'months').format("MMM-YYYY");
        if ($window.moment(capStartDate,"MMM-YYYY").isSameOrBefore($window.moment(vm.transactionData.endDate,"MMM-YYYY"))) {
          vm.capDates.push(capStartDate);
        }
        else {
          break;
        }
        capLastDate = vm.capDates[vm.capDates.length - 1];
      }
    }

    function getTopupFrequencyList() {
      var startDate = vm.transactionData.startDate;
      var endDate = vm.transactionData.endDate;
      var diffInMonths = parseInt($window.moment(endDate,"DD-MMM-YYYY").diff($window.moment(startDate,"DD-MMM-YYYY"), 'months', true));
      if (diffInMonths >= 12) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12},
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
      } else if (diffInMonths < 12) {
        vm.topupFrequencyList = [
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
      }
      vm.formData.topupDetails.frequency = null;
      if (vm.formData.topupDetails.percentage) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12}
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      } else if (vm.formData.frequency == 'Q' && !vm.formData.topupDetails.percentage) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12}
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      }
      else if (vm.transactionData.frequency == 'Monthly') {
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      }
      else {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12},
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      }

    }

    vm.confirmCancel = function () {
      var success = function () {
        $state.go('main.systematicCorner')
      };
      ModalService.confirmCancelModal({}, success);
    }

    function getFinalPayloadData() {

      if(vm.transactionData.frequency === "Monthly"){
        var topupFrequency = 'OM'
      }
      else if(vm.transactionData.frequency === "Half Yearly"){
        topupFrequency = 'H'
      }else if(vm.transactionData.frequency === "Quarterly"){
        topupFrequency = 'Q'
      }else if(vm.transactionData.frequency === 'Yearly'){
        topupFrequency = 'Y'
      }

      var topupPayload = null;
      topupPayload = {
        uuid :null,
        transactionId :vm.transactionData.id ,
        folioNumber:vm.transactionData.folioNumber,
        schemeCode:vm.transactionData.schemeCode,
        amount:vm.transactionData.amount,
        frequency:topupFrequency,
        topupAmount: vm.formData.topupDetails.amount,
        topupPercentage:vm.formData.topupDetails.percentage,
        topupFrequency:vm.formData.topupDetails.frequency,
        topupCapAmount:vm.formData.topupDetails.capAmount,
        topupCapMonthYear: $window.moment(vm.formData.topupDetails.capMonthYear,'MMM-YYYY').format("DD-MMM-YYYY"),
        toDate:vm.transactionData.endDate,
        summaryType : "SIP_TOPUP",
        bankDetailsForECS : {
          accNumber: vm.formData.bankAcNo,
          bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
          ifscCode: vm.formData.ifscCode,
          branchName: vm.formData.bankBranch,
          bankCity: vm.formData.bankCity,
          paymentOption: vm.formData.sipPaymentOption,
          otmId: vm.formData.otmId
        },
        bankInfo : vm.formData.bankInfo

      };
      return angular.copy(topupPayload);
    }

    vm.goToSummary = function (sipTopupForm) {
      var transactionSubType = '', data = {};
      if(transactionSubType){
        data = {transactionType: vm.transactionType, transactionSubType: transactionSubType};
      } else {
        data = {transactionType: vm.transactionData.type};
      }vm.formData.isBackFromSummary = true;
      vm.isRequired = true;
      vm.isSaving = false;
      $state.$previous = $state.current;
      $timeout(function () {
        if (sipTopupForm.$valid) {
          var payloadData = getFinalPayloadData();
          if(payloadData.topupCapAmount){
            payloadData.topupCapMonthYear = undefined;
          }

          if (!payloadData) {
            return;
          }
          TransactionModel.setPayloadRawData(payloadData);
          $state.go('main.summary', data);
        }
      }, 0);
    };

    vm.changedPaymentOption = function () {
      vm.formData.bankInfo = '';
      vm.formData.otmId = '';
      fetchBankList()
    };

    function fetchBankList(cb) {
      cb = cb || function () {
        };
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            if (vm.bankList && vm.bankList.length == 1) {
              vm.formData.bankInfo = vm.bankList[0];
            }
            cb();
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();

      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        InvestorService.get({child1: 'bank', child2: 'list', child3: 'sip'}, null).$promise.then(success, error);
      } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        var payload ={
          transactionType:'sip',
          folioNo:vm.transactionData.folioNumber
        }
        InvestorService.post({
          child1: 'folio',
          child2: 'otm'/*,
          child3: 'sip',
          child4: vm.transactionData.folioNumber*/
        }, payload).$promise.then(success, error);
      } else {
        InvestorService.post({
          child1: 'folio',
          child2: 'scheme',
          child3: 'bankList'
        }, {schemeCode: vm.formData.outSchemeCode, folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
      }
    }

    function capAmountChanged() {
      if(vm.formData.topupDetails.amount){
        vm.minCapAmount = vm.transactionData.amount + vm.formData.topupDetails.amount;
      }
      else if (vm.formData.topupDetails.percentage){
        vm.minCapAmount = vm.transactionData.amount + (vm.formData.topupDetails.percentage * vm.transactionData.amount/100)
      }


      if(vm.formData.topupDetails.capAmount < vm.minCapAmount ){
        vm.isminCapAmount = true;
        vm.sipTopupForm.$invalid = true;
      }
      else{
        vm.isminCapAmount = false
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InitiateTransactionSipPurchaseController', initiateTransactionSipPurchaseController);

  /** @ngInject */
  function initiateTransactionSipPurchaseController($log, $timeout, $stateParams, HDFC_API, MessageService, ModalService, InvestorService, DownloadPdfService,
                                                    SchemeService, TransactionService, AppConstants, $state, LoaderService, UtilService,
                                                    TransactionModel, AuthService, SipPurchaseHelper, NetcoreEvntService,
                                                    InvestorFileUploadService, $window, FileSaver, Blob, InvestorFolioModel, investorServiceVersion, FolioModel, $rootScope , DynamicDataSipPurchaseReview , termsCondition, panAadharService) {
    var vm = this;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.TRANSACTIONS_CONST.DESCRIPTIONS['UPI'] = "UPI Autopay";
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    vm.transactionType = getTransactionTypeFromStateParams() || getTransactionType();
    vm.formData = TransactionModel.getPayloadRawData() || TransactionModel.getMasterRawData(vm.transactionType);
    vm.devidendOptionsOther = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT];
    vm.devidendOptionsELSS = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];
    vm.devidendOptions = angular.copy(vm.devidendOptionsOther);
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.specificProperties = TransactionModel.getTransactionSpecificProperties(vm.transactionType);
    vm.folioList = FolioModel.getFolioData() || null;
    vm.unitsDetails = null;
    vm.inSchemeValidations = null;
    vm.outSchemeValidations = null;
    vm.validations = {};
    // vm.investorInfo = null;
    vm.isRequired = false;
    vm.bankList = null;
    vm.outSchemeList = null;
    vm.inSchemeList = null;
    vm.masterInSchemeList = null;
    vm.purchaseInSchemeList = null;
    vm.masterPurchaseInSchemeList = null;
    vm.tForm = {};
    vm.isSaving = false;
    vm.isReseting = false;
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isMultiples = false;
    vm.isTopUpMultiples = false;
    vm.isTopupPercMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.isTopupMinAmt = false;
    vm.isTopupMinPerc = false;
    // vm.daysList = getDaysList();
    vm.daysList = null;
    vm.isSchemeDisabled = false;
    vm.isShowDefault = 'false';
    vm.purchaseMinAmount = 0;
    vm.isPurchaseMin = false;
    vm.viewMode = 'days';
    vm.euinList = null;
    vm.distributorList = null;
    vm.isPurchaseAmountDecimal = false;
    vm.isInvalidForm = false;
    vm.isCheckedTandC = vm.formData.isCheckedTandC;
    vm.profile = AuthService.getToken();
    var name = vm.profile && vm.profile.investorFName ? vm.profile.investorFName.toLowerCase() : '';
    vm.investorName = name.charAt(0).toUpperCase() + name.slice(1);
    vm.calenderEndDateString = '31-Dec-2099';
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.retirementAgeProofURL = '';
    vm.chooseAFile = true;
    vm.amountInWords = '';
    vm.isSourceSchemeGrowth = false;
    vm.isSchemeTypeELSS = false;
    vm.capMonthYear = '';
    vm.formData.showTopUpBlock = false;
    vm.schemeTypeForValidation = '';
    vm.PATTERN = AppConstants;
    vm.formData.isUPIVerified = false;
    vm.checkSipValidations = checkSipValidations;
    vm.updateEndDates = updateEndDates;
    vm.checkValidations = checkValidations;
    vm.extractValidationObject = extractValidationObject;
    vm.changeSipTopupSelected = changeSipTopupSelected;
    vm.getTopupFrequencyList = getTopupFrequencyList;
    vm.capAmountChanged = capAmountChanged;
    vm.fetchSwitchInSchemes = fetchSwitchInSchemes;
    vm.resetAll = resetAll;
    vm.helper = getHelper();
    vm.blocktab = blockTabbing;
    vm.isOTMAmount = false;
    vm.isOTMDate = false;
    vm.isArnSuccess = true;
    vm.isSubarnSuccess = false;
    vm.brokerCodeError = '';
    vm.subBrokerCodeError = '';
    vm.isOTMEnabled = true;
    vm.isEMandateEnabled = false;
    vm.isminCapAmount = false;
    vm.checkOTM= checkOTM;
    vm.changedPaymentOption= changedPaymentOption;
    vm.changeFrequency =changeFrequency;
    vm.selectedFreq = 'OM';
    vm.formData.authMode=null;
    vm.eMandatenoOfDays=null;
    vm.eMandatemaxAmountLimit=null;
    vm.isEmailMobileinValid = false;
    vm.isEmailinValid = false;
    vm.isMobileinValid = false;
    vm.emandateDisplay = true;
    vm.scheduleTransactionDetails = null;
    vm.kycVerifiedFlag = null;
    vm.OTMbankList = null;
    vm.ECbankList = null;
    vm.EMbankList = null;
    vm.riaCodeError = "";
    vm.sipFirstInstallment=false;
    vm.formData.sipFirstInstallment=false;
    vm.sipFirstInstallmentAmount=[];
    vm.changeFirstInstallment = changeFirstInstallment;
    //vm.checkSipFirstValidations = checkSipFirstValidations;
    vm.changeTopUpFreq = changeTopUpFreq;
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.showNavApplicabilityModal=showNavApplicabilityModal;
    vm.setDynamicData = setDynamicData;
    vm.DynamicDataSipPurchaseReview = DynamicDataSipPurchaseReview;
    vm.checkEndPopupAddCart = checkEndPopupAddCart;
    vm.checkEndNoteOtm = checkEndNoteOtm;
    vm.checkEndNoteEOtm = checkEndNoteEOtm;
    vm.changeSubBrokerCode = changeSubBrokerCode;
    vm.changeDividendOption = changeDividendOption;
    vm.changeCapMonthYear = changeCapMonthYear;
    vm.verifyUPI = verifyUPI;
    vm.hideUPIDetails = hideUPIDetails;
    vm.showNote = true;
    vm.showOtmNote = true;
    vm.showEotmNote = true;
    vm.showPopupAddEcart = true;
    vm.notesReview = {};
    vm.popup = {};
    vm.today = $window.moment($window.moment(),"DD-MMM-YYYY HH:mm A");
    vm.notesOtm = {};
    vm.notesEOtm = {};
    vm.riaMessage = {};
    vm.distributorMessage = {};
    vm.showTerms = true;
    vm.showTermsEmandate = false;
    vm.backFromPayment=false;
    vm.euinData = {};
    vm.changeAmount = changeAmount;
    vm.weekDayList = [];
    vm.nonBusinessDatess = null;
    vm.upiErrorMessage = '';
    vm.upiLimit = '';
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.showTopUpPercentage = AppConstants.SET_TOP_UP_PERCENTAGE_VIEW;
    vm.showEcartModel = false;
    vm.sidebarTitle = 'CART_DETAILS';
    vm.closeAction = closeAction;
    vm.showAddCart = true;
    vm.defaultMandateYearDate = AppConstants.DEFAULT_EMANDATE_MAX_YEAR;
    vm.modifiedSipDetails = false;
    vm.isfromSaved = false;
    vm.savedFrequency = null;
    vm.savedAccType = null;
    vm.emandateMinAmountLimit = null;
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.isLessThanSipAmount = false;
    vm.sipDateLessEmandate = false;
    vm.changeEndDateEmandate = changeEndDateEmandate;
    vm.formData.emandateWord = {};
    vm.handleMandateCalender = handleMandateCalender;
    AuthService.checkLinkedUserStatus();
    vm.renewDetails= {
      amount:$stateParams.amount,
      frequency:$stateParams.frequency,
      sc:$stateParams.sc
    }

    if(vm.renewDetails.frequency){
      vm.formData.frequency = vm.renewDetails.frequency;
    }
    vm.formData.virtualAddress = vm.formData.virtualAddress ? vm.formData.virtualAddress : null;
    vm.handleVpa = handleVpa;

    vm.init = function()
    {
      if($window.performance && $window.performance.getEntriesByType( 'navigation' ).map( function (nav){return  nav.type} ).includes( 'back_forward' )){
        $window.location.reload();
      }
      var successHandler = function(resp) {
        if(vm.transactionType == 'PURCHASE')
        {
           if(Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || !resp.termAndConditionDTO.termAndConditionDTOMap[vm.key])
            {
              vm.showTerms = false;
            }
        } else if(vm.transactionType == 'SIP')
          {
             if(Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || !resp.termAndConditionDTO.termAndConditionDTOMap[vm.key])
             {
               vm.showTerms = false;
             }

            if(Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || !resp.termAndConditionDTO.termAndConditionDTOMap[vm.keyOtm])
            {
              vm.showTermsEmandate = false;
            }
            else if(Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || resp.termAndConditionDTO.termAndConditionDTOMap[vm.keyOtm]){
              vm.showTermsEmandate = true;
            }

          }
        }

      termsCondition.fetchData(vm.transactionType).then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    vm.init();

    setDynamicData();
    if(vm.popup !== undefined)
    {
      checkEndPopup(vm.popup.endDate,vm.popup.startDate);
    }

    if (vm.formData.investmentType === 'PURCHASE' && vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_AddToCart !== undefined) {
      checkEndPopupAddCart(vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_AddToCart.endDate,vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_AddToCart.startDate);
    }

    if(vm.formData.investmentType === 'SIP' && vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_AddToCart !== undefined && vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review !== undefined && vm.notesOtm && vm.notesEOtm !== undefined) {
      checkEndNote(vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review.endDate,vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review.startDate);
      checkEndNoteOtm(vm.notesOtm.endDate,vm.notesOtm.startDate);
      checkEndNoteEOtm(vm.notesEOtm.endDate,vm.notesEOtm.startDate);
    }


    function  blockTabbing(){
      var divs = $window.document.querySelectorAll('*');

      for (var i = 0; i < divs.length; i++) {
        if(divs[i].classList.contains('anything-disabled')){
          divs[i].setAttribute('tabindex', -1);
        }
      }
    }

    function getHelper() {
      var helper = null;

      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          helper = SipPurchaseHelper;
          helper.setViewModel(vm);
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          helper = SipPurchaseHelper;
          helper.setViewModel(vm);
          break;
      }


      return helper;

    }

    if ($stateParams) {
      setStateParams();
    }

    function setStateParams() {

      vm.formData.folioNumber = $stateParams.folioNumber ? $stateParams.folioNumber : vm.formData.folioNumber;
      if (vm.formData.folioNumber) {
        LoaderService.showLoader();
        panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(function () {
          LoaderService.hideLoader();
          if($stateParams.eCart)
            return;

          if ((vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) && (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE )) {
            fetchOutSchemes();
          }
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            vm.formData.inSchemeCode = $stateParams.sc ? $stateParams.sc : vm.formData.inSchemeCode;
          } else vm.formData.purchaseInSchemeCode = $stateParams.sc ? $stateParams.sc : vm.formData.purchaseInSchemeCode;

          //need this to prefill scheme name
          vm.formData.outSchemeCode = $stateParams.sc ? $stateParams.sc : vm.formData.outSchemeCode;
          if ($stateParams.isFavourite) {
            vm.formData.isFavourite = true;
          } else {
            vm.formData.isFavourite = false;
          }
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
            checkForParameters();
          }
        }).catch(function () {
          LoaderService.hideLoader();
          vm.formData.folioNumber=null;
          return;
        });
      }
    }

    function checkForParameters() {
      var param = $window.location.href.split('?')[1];
      if (!param) {
        return;
      }
      var data = $window.atob($window.btoa(param)).split('&');
      var transactionId = data[0] && data[0].split('=')[1];
      var isCompId = data[2] && data[2].split('=')[1];
      var readOnly = isCompId == "true" ? true : false;


      vm.formData.dynamicData = {
        transactionId: transactionId,
        readOnly: readOnly
      };
    }
    //
    // function getDaysList() {
    //   if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
    //     return vm.TRANSACTIONS_CONST.SIP_DAYS_LIST;
    //   } else {
    //     return vm.TRANSACTIONS_CONST.DAYS_LIST;
    //   }
    //
    // }

    function resetTopupDetails() {
        vm.formData.topupDetails = {};
    }

    function changeSipTopupSelected(isChecked) {
      if(!$("#sipToptup").is(':checked')){
        resetTopupDetails();
      }
      if(!vm.formData.isBackFromSummary){
        vm.formData.sipTopupSelected = isChecked;
      }
      if(isChecked && vm.formData.sipPaymentOption === 'OTM'&& ((vm.formData.bankInfo && vm.formData.bankInfo.otmFrequency) !== 'AWP')){
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        MessageService.error(vm.VALIDATE_DATA.OTM_VALIDATION_ERROR);
      }
      else if(vm.formData.bankInfo && vm.isOTMAmount){
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        MessageService.error(vm.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR);
      }
      getTopupFrequencyList();
      if(vm.formData.topupDetails.amount) {
        $window.NumToWord(vm.formData.topupDetails.amount, 'divDisplayInWords');
      }
      if(vm.formData.topupDetails.capAmount) {
        $window.NumToWord(vm.formData.topupDetails.capAmount, 'capAmntDisplayInWords');
      }
    }


    if (vm.formData.topupDetails && vm.formData.topupDetails.frequency) {
      getTopupFrequencyList();
    }

    function getTopupFrequencyList() {

      if ((vm.diffInMonths >= 6 && vm.diffInMonths <= 12 ) || (vm.formData.topupDetails.diffInMonths >= 6 && vm.formData.topupDetails.diffInMonths <= 12)) {
        vm.topupFrequencyList = [
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
      } else {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12},
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
      }
      if($stateParams.action == 'modify' && !vm.modifiedSipDetails && vm.oldSipSystematicDataTopUp && vm.oldSipSystematicDataTopUp.topupDetails.frequency){
        vm.formData.topupDetails.frequency = vm.oldSipSystematicDataTopUp.topupDetails.frequency?vm.oldSipSystematicDataTopUp.topupDetails.frequency:null;
      } else {
        vm.formData.topupDetails.frequency = vm.formData.isBackFromSummary?vm.formData.topupDetails.frequency:null;
      }

      if (vm.formData.topupDetails.percentage) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12}
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      } else if ($stateParams.action == 'modify' && !vm.formData.topupDetails.percentage && !vm.modifiedSipDetails && vm.oldSipSystematicDataTopUp && vm.oldSipSystematicDataTopUp.topupDetails.frequency) {

        vm.formData.topupDetails.frequency = vm.oldSipSystematicDataTopUp.topupDetails.frequency;

      } else if (vm.formData.frequency == 'Q' && !vm.formData.topupDetails.percentage) {
          vm.topupFrequencyList = [
            {key: 'Y', value: 'Yearly', monthfreq: 12}
          ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      } else if (vm.formData.frequency == 'OM') {
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      }
      else {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12},
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      }

      if (vm.diffInMonths < 12 || vm.formData.topupDetails.diffInMonths < 12) {
        vm.topupFrequencyList = [
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
        vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;

        vm.hideTopupPercentage = true;
      }
      else if ((vm.diffInMonths >= 12 && vm.formData.frequency !== 'Q')|| (vm.formData.topupDetails.diffInMonths >= 12 && vm.formData.frequency !== 'Q')) {
        vm.hideTopupPercentage = false;
        if(vm.formData.topupDetails.percentage){
          vm.topupFrequencyList = [
            {key: 'Y', value: 'Yearly', monthfreq: 12}
          ];
          if (vm.formData.sipTopupSelected) {
            changeTopUpFreq();
          }
        } else {
          vm.topupFrequencyList = [
            {key: 'Y', value: 'Yearly', monthfreq: 12},
            {key: 'H', value: 'Half Yearly', monthfreq: 6}
          ];
          if (vm.formData.sipTopupSelected) {
            changeTopUpFreq();
          }
        }

      }

    }
    vm.changeCapMonthYear = function () {
      vm.formData.topupDetails.capMonthYear =vm.formData.topupDetails.capMonthYearSelect?$window.moment(vm.formData.topupDetails.capMonthYearSelect,"MMM-YYYY").format("DD-MMM-YYYY"):'';
    };
    function capAmountChanged() {
      vm.amountInWords = '';
      if(vm.formData.topupDetails.amount){
        vm.minCapAmount = vm.formData.amount + vm.formData.topupDetails.amount;
      }
      else if (vm.formData.topupDetails.percentage){
        vm.minCapAmount = vm.formData.amount + (vm.formData.topupDetails.percentage * vm.formData.amount/100)
      }

      if(vm.formData.topupDetails.capAmount && (vm.formData.topupDetails.capAmount < vm.minCapAmount )){
        vm.isminCapAmount = true
      }
      else{
        vm.isminCapAmount = false
      }
      vm.compareDataFromSystematic();
    }
    function resetAll() {
      vm.formData.amountType = 'amount';
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.outSchemeCode = '';
      vm.formData.outSchemeName = '';
      vm.formData.dividendOption = '';
      vm.formData.frequency = null;
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.amount = null;
      vm.formData.units = '';
      vm.formData.bankInfo = null;
      vm.formData.day = '';
      vm.formData.weeklyDay = null;
      vm.formData.isTillPerpetuity = false;
      vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
      vm.formData.purchaseAmount = null;
      vm.formData.purchaseDividendOption = '';
      vm.formData.purchaseInSchemeCode = '';
      vm.formData.purchaseInSchemeName = '';
      vm.formData.purchaseInvestmentOption = '';
      vm.ECbankList = null;
      vm.formData.month = '';

      vm.formData.euin = {};
      vm.euinData = {};
      vm.formData.brokerCode = '';
      vm.formData.brokerName = '';
      vm.euinList = null;
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.formData.subBrokerARN = '';
      vm.formData.subBrokerCode = '';
      vm.isCheckedTandC = false;
      vm.isArnSuccess = true;
      vm.formData.sipPaymentOption = '';


      vm.inSchemeValidations = null;
      vm.outSchemeValidations = null;
      vm.validations = {};
      vm.isRequired = false;
      vm.bankList = null;
      vm.outSchemeList = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
      vm.unitsDetails = null;
      resetNumInWords(); //reset the number in text form on folio change or form reset

      resetBankDetails();
      if (vm.specificProperties && vm.specificProperties.investmentModeData) {
        vm.specificProperties.investmentModeData.stage1 = '';
        vm.specificProperties.investmentModeData.stage2 = '';
        vm.specificProperties.investmentModeData.stage3 = '';
        vm.specificProperties.investmentModeData.stage4 = '';
      }
      manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
      vm.formData.riaBrokerCode = "";
      vm.formData.riaBrokerName = "";
      vm.formData.isCheckedTandC = false;
      vm.brokerCodeError = "";
      vm.riaCodeError = "";
      vm.UPIbankList = null;
    }

    function resetNumInWords() {
      vm.amountInWords = '';
      var inWordsDiv = $window.document.getElementById('divDisplayWords');
      var inWordsFirstInstallmentDiv = $window.document.getElementById('divDisplayWordFirstInstallment');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
      if (inWordsFirstInstallmentDiv) {
        inWordsFirstInstallmentDiv.innerHTML = '(In Words)';
      }
    }

    function reSetting() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.formData.frequency) {
        return;
      }

      vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
      vm.validations.topupAmtMultples = vm.validations.topupAmtMultples || 1;
      vm.validations.topupPercentageMultples = vm.validations.topupPercentageMultples || 1;
      vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
      vm.validations.minInstallments = vm.validations.minInstallments || 0;
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.maxAmount = vm.validations.maxAmount || 0;
      vm.validations.topupMinAmt = vm.validations.topupMinAmt || 0;
      vm.validations.topupMinPercentage = vm.validations.topupMinPercentage || 0;
      vm.validations.sipDefaultAmount = validationsData.sipDefaultAmount;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > 0 && vm.validations.maxAmount < vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }
      vm.validations.sipDefaultAmount = validationsData.sipDefaultAmount;
      switch (vm.formData.frequency) {
        case 'BZ':
          vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          if(validationsData.additionalValidation.BZ){
            vm.additionalSipData = validationsData.additionalValidation.BZ;
            vm.validations.minAmount = validationsData.additionalValidation.BZ[0].min_amount_lower;
          }
          break;
        case 'OW':
          vm.validations.maxInstallments = validationsData.weeklyMaxInstallmentNumber || 0;
          if(validationsData.additionalValidation.OW){
            vm.additionalSipData = validationsData.additionalValidation.OW;
            vm.validations.minAmount = validationsData.additionalValidation.OW[0].min_amount_lower;
          }
          break;
        case 'Q':
          vm.validations.maxInstallments  = validationsData.quarterlyMaxInstallmentNumber;
          vm.validations.topupMinAmt = validationsData.topupMinAmt;
          vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
          vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
          if(validationsData.additionalValidation.Q){
            vm.additionalSipData = validationsData.additionalValidation.Q;
            vm.validations.minAmount =validationsData.additionalValidation.Q[0].min_amount_lower;

          }
          break;
        case 'OM':
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.validations.topupMinAmt = validationsData.topupMinAmt;
          vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
          vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
         if(validationsData.additionalValidation.OM){
           vm.additionalSipData = validationsData.additionalValidation.OM;
           vm.validations.minAmount = validationsData.additionalValidation.OM[0].min_amount_lower;
        }
          break;
        case 'H':
          vm.additionalSipData = validationsData.additionalValidation.H;
          vm.validations.minAmount = validationsData.additionalValidation.H[0].min_amount_lower;
          vm.validations.maxInstallments = 0;
          break;
        case 'Y':
          vm.additionalSipData = validationsData.additionalValidation.Y;
          vm.validations.minAmount = validationsData.additionalValidation.Y[0].min_amount_lower;
          vm.validations.maxInstallments = 0;
          break;
      }
      if(!vm.backFromPayment && !$stateParams.transactionId && !vm.checkTransactionID)
      {
      if( vm.validations.minAmount > validationsData.sipDefaultAmount){
        vm.formData.amount =  vm.validations.minAmount;
      } else if($stateParams.action == 'modify' && !vm.modifiedSipDetails){
        vm.formData.amount = vm.formData.amount < validationsData.sipDefaultAmount ? validationsData.sipDefaultAmount : vm.formData.amount;
        vm.AmountFromModify = angular.copy(vm.formData.amount);
      } else if (!vm.renewDetails.amount && !vm.checkTransactionID) {
        if ($stateParams.action == 'modify' ) {
          vm.formData.amount = vm.AmountFromModify > validationsData.sipDefaultAmount ? vm.AmountFromModify : validationsData.sipDefaultAmount;
        } else {
          vm.formData.amount = vm.oldAmount > validationsData.sipDefaultAmount ? vm.oldAmount : validationsData.sipDefaultAmount;
        }
      }
      if(vm.formData.amount){
        $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
      }
    }
     if(vm.additionalSipData){
      checkSipValidations();
     }

    }

    function checkSipValidations(fromTopUp) {
      if(vm.additionalSipData){
        var newValidation =  vm.additionalSipData;
        for (var i=0; i<newValidation.length;i++){
          var condition = vm.formData.amount < newValidation[i].min_amount_lower ||  vm.formData.amount <= newValidation[i].min_amount_upper
          if(!newValidation[i].min_amount_upper){
          var condition = true;
        }
         if(condition)
         {
           if((!vm.formData.showTopUpBlock || !vm.formData.sipTopupSelected) && !vm.backFromPayment)
         {
           if (vm.formData.frequency === 'OW') {
             //vm.formData.startDate = null;
             //vm.formData.endDate = null;
             //vm.formData.day = null;
             //vm.formData.weeklyDay = null;
           }
           // vm.enabledStartDates = null
           // vm.enabledEndDates = null;
           // vm.formData.month = null;
          }
           vm.validations.amountMultiples = newValidation[i].amt_multiples;
           vm.validations.maxAmount = newValidation[i].min_amount_upper;
           vm.validations.minAmount = newValidation[i].min_amount_lower;
           vm.validations.minInstallments = newValidation[i].min_installments;
           break;
         }
       }
      }
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }
      vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
      vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
      vm.isTopupMinAmt = !!(vm.validations.topupMinAmt && vm.validations.topupMinAmt > vm.formData.topupDetails.amount);
      vm.isTopupMinPerc = !!(vm.validations.topupMinPercentage && vm.validations.topupMinPercentage > vm.formData.topupDetails.percentage);
      vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
      vm.isTopUpMultiples = vm.validations.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.validations.topupAmtMultples === 0) || false;
      vm.isTopupPercMultiples = vm.validations.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.validations.topupPercentageMultples === 0) || false;
      vm.isInvalidForm = vm.formData.amount <= 0 || (vm.formData.amount && ( vm.isMax || vm.isMin || (vm.validations.amountMultiples && !vm.isMultiples)));
      if (!vm.isInvalidForm) {
        vm.isInvalidForm = vm.formData.topupDetails.amount <= 0 || (vm.formData.topupDetails.amount && (vm.isTopupMinAmt || (vm.validations.topupAmtMultples && !vm.isTopUpMultiples)));
      }
      checkEMandateValidation();
      vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.amount) && $window.NumToWord(vm.formData.topupDetails.amount, 'divDisplayInWords', vm);
      vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.capAmount) && $window.NumToWord(vm.formData.topupDetails.capAmount, 'capAmntDisplayInWords', vm);
      if(!vm.formData.isBackFromSummary){
        angular.isDefined(vm.formData.topupDetails) && angular.isDefined(vm.formData.topupDetails.capAmount) &&(vm.formData.topupDetails.capAmount = vm.formData.topupDetails.capAmount ? vm.formData.topupDetails.capAmount : '');
      }
      if(vm.formData.amount == "" || vm.formData.amount == null) {
          resetNumInWords();
      } else {
        $window.NumToWord(vm.formData.amount,'divDisplayWords', vm);
      }

      if(vm.sipFirstInstallment)
      vm.formData.sipFirstAmount = vm.formData.amount;

      if(vm.formData.amount >= 2000000){
        vm.amountExceeded = true;
      }else {
        vm.amountExceeded = false;
      }

      if (vm.formData.startDate && (!vm.savedStartDate) && !fromTopUp) {
        vm.changeStartDate(vm.formData.startDate,true);
      }


      if(vm.formData.sipPaymentOption=='UPI' && vm.formData.amount > vm.formData.upiLimit) {
        var success = function() {
          if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if(vm.paymentOptions.includes("E-mandate") && vm.isEMandateEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
          } else if(vm.paymentOptions.includes("EC")){
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          } else {
            vm.formData.sipPaymentOption = null;
          }
          vm.changedPaymentOption();
        }
        ModalService.genericModal({
          text: vm.formData.upiErrorMessage,
          isUpi: true
        },success);
      }

      if (vm.formData.amount && vm.formData.emandateAmount) {
        checkAmountValidationEmandate();
      }
    }

    /*
    * commented the changes for improvement HMF-11532
    * */
    /*function checkSipFirstValidations() {
      vm.isFirstMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.sipFirstAmount);
      vm.isFirstMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.sipFirstAmount);
      vm.isFirstMultiples = vm.validations.amountMultiples && vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount % vm.validations.amountMultiples === 0) || false;
      vm.isInvalidForm = vm.formData.sipFirstAmount <= 0 || (vm.formData.sipFirstAmount && ( vm.isFirstMax || vm.isFirstMin || (vm.validations.amountMultiples && !vm.isFirstMultiples)));
      $window.NumToWord(vm.formData.sipFirstAmount,'divDisplayWordFirstInstallment', vm);
      if(vm.formData.sipFirstAmount == "") {
        resetNumInWords();
      }
    }*/

    function fetchFolioList(cb) {

      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioList = [];
            vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
            if (resp.data.kycVerifiedFlag === false && $stateParams.initiatedBy != "schedule") {
              ModalService.genericModal({
                text: resp.data.kycMessage
              }, function() {
                $state.go("welcome");
              });
            }
            Object.keys(resp.data.folioList).forEach(function (key) {
              var obj = Object.assign({key: key}, resp.data.folioList[key]);
              folioList.push(angular.copy(obj));
            });
            FolioModel.setFolioData(folioList);
            vm.folioList = folioList.length ? folioList : null;

            if (vm.folioList.length !== 0) {
              var selectedFolioObj = vm.folioList.filter(function (row) {              // for investor's name initialisation
                return row.folioNumber == vm.formData.folioNumber
              })[0];
              if(selectedFolioObj) {
                vm.selectedFolioData = selectedFolioObj;
                vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
              }
              vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
              vm.formData.minorFlag = vm.folioMinor;
            }

            if (vm.folioList && vm.folioList.length === 1) {
              if(vm.folioList[0].activeFlag === true){
                vm.formData.folioNumber = vm.folioList[0].folioNumber;
                if (!vm.formData.isBackFromSummary && !vm.formData.outSchemeCode && !$stateParams.transactionId) {
                  vm.folioChanged();
                }
              }
            }

            if(vm.formData.folioNumber) {
              fetchInvestorType();
            }

            if (vm.formData.dynamicData && vm.formData.dynamicData.folioNumber) {
              vm.formData.folioNumber = vm.formData.dynamicData.folioNumber;
              vm.folioChanged();
            }
            if($stateParams.eCart)
            {
              vm.folioChanged();
            }

            if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP && vm.folioList && vm.folioList.length>1 && !$stateParams.transactionId && !$stateParams.folioNumber)
            {
              if (!vm.formData.folioNumber) {
                  vm.activeFlagFolioList = vm.folioList.filter(function (e){
                      return e.activeFlag === true;
                  })
                  vm.formData.folioNumber = vm.activeFlagFolioList.length>=1 ? vm.activeFlagFolioList[0].folioNumber:'';
                  vm.folioChanged();
              } else {
                vm.folioMinor = vm.formData.minorFlag;
                fetchInSchemes();
                if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
                  checkOTM(function (success) {
                    if (success) {
                      fetchBankList();
                      checkEMandateValidation();
                      checkOTMAmountAndDate();
                    }
                  });
                } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
                  checkOTM(function (success) {
                    if (success) {
                      fetchBankList();
                      checkEMandateValidation();
                      checkOTMAmountAndDate();
                    }
                  });
                }
                else if(vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
                  checkOTM(function (success) {
                    if (success) {
                      checkEMandate(function () {
                        fetchBankList();
                      });
                    }
                  });
                }
              }
            }
            if($stateParams.eCart)
            {
              vm.folioChanged();
            }

            cb(true);
          } else {
            vm.folioList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      investorServiceVersion.get({
        child1: 'folio',
        child2: 'active-list'
      }).$promise.then(success, error);
    }

    vm.brokerCodeError = '';
    function fetchEuinList() {
      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      vm.formData.brokerName = vm.formData.brokerName? vm.formData.brokerName :'';
      vm.formData.riaBrokerName = vm.formData.riaBrokerName? vm.formData.riaBrokerName :'';
      vm.subBrokerCodeError = '';
      vm.euinData = {};
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      vm.distributorList = null;
      // vm.formData.euinInput = '';
      if (!vm.formData.isBackFromSummary && !vm.riaConsent) {
        vm.isCheckedTandC = vm.formData.isCheckedTandC;
        if (!$stateParams.isCompId && !$stateParams.trackId) {
          vm.formData.euin = vm.formData.euin ? vm.formData.euin : '';
        }
      }

      //vm.isInvalidForm = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin ? vm.formData.euin : {};
            vm.brokerCodeError = '';
            vm.riaCodeError = '';
            vm.isArnSuccess = false;
            if (vm.formData.isThroughDistributor) {
              vm.formData.brokerName = resp.data.distributorName;
            } else if (vm.formData.isThroughRia) {
              vm.formData.riaBrokerName = resp.data.distributorName;
            }
            //vm.isInvalidForm = false;
          } else {
            vm.euinList = null;
            if (vm.formData.isThroughDistributor) {
              vm.brokerCodeError = resp.message;
            } else if (vm.formData.isThroughRia) {
              vm.riaCodeError = resp.message;
              vm.isCheckedTandC = false;
              vm.formData.isCheckedTandC = false;
            }
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      var path = {};
      if (vm.formData.isThroughDistributor) {
        path  = {
          controller1: 'getEuin',
          controller2: 'ARN-' + vm.formData.brokerCode
        };
      } else if (vm.formData.isThroughRia) {
        path = {
          controller1: 'getEuin',
          controller2: vm.formData.riaBrokerCode,
          riaOpted: vm.formData.isThroughRia
        };
      }
      TransactionService.get(path).$promise.then(success, error);
    }

    vm.subBrokerCodeError = '';
    vm.fetchEuinListSubBroker = function () {
      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        vm.formData.euin = {};
        vm.euinData = {};
        fetchEuinList();
        return;
      }
      if(vm.formData.brokerCode !== vm.formData.subBrokerARN){
        vm.formData.euin = {};
        vm.euinData = {};
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            for(var i = 0; i<vm.euinList.length; i++){
              if(vm.euinData.euinNameCode === vm.euinList[i].euinNameCode){
                vm.formData.euin = vm.euinList[i];
                break;
              } else {
                vm.formData.euin = {};
              }
            }
            vm.euinData = vm.formData.euin;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
          } else {
            vm.euinList = null;
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = {};
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: vm.formData.isThroughDistributor
      }).$promise.then(success, error);
    }

    function fetchEuinListThroughDistributor(arnCode) {
      if (!arnCode) {
        return;
      }
      vm.formData.brokerName = '';
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin;
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.euinList = null;
            //MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: arnCode
      }).$promise.then(success, error);
    }

    function changeFirstInstallment(installmentActivated, calledFromController) {
      vm.backFromPayment=false;
      vm.isfromSaved = false;
      if (installmentActivated === false) {
        vm.sipFirstInstallment = false;
        vm.formData.sipFirstInstallment = false;
        vm.formData.sipFirstAmount='';
      } else {
        vm.sipFirstInstallment = true;
        vm.formData.sipFirstInstallment = true;
        vm.formData.sipFirstAmount=vm.formData.amount;
        if(vm.formData.sipPaymentOption === "OTM") {
          vm.formData.sipPaymentOption = null;
        }
      }
      checkOTM(function (success) {
        if (success) {
          $timeout(function() {
            fetchBankList();
          }, 100);
          checkEMandateValidation();
          checkOTMAmountAndDate();
          if(vm.formData.frequency === 'BZ' && !vm.inSchemeValidations.cgfFlag) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            if(vm.formData.sipPaymentOption === vm.paymentOptions[1]) {
              vm.formData.sipPaymentOption = vm.paymentOptions[1];
            }else{
              // if(vm.isEMandateEnabled && !vm.isOTMEnabled) {
              //   vm.formData.sipPaymentOption = vm.paymentOptions[1];
              // } else {
                vm.formData.sipPaymentOption = vm.paymentOptions[0];
              // }
            }
            hideUPIDetails();
            changedPaymentOption();
          }
        }
      });
       checkEMandate(function () {});
       vm.compareDataFromSystematic();
       if (!calledFromController && ((vm.savedSIPFI !== undefined && vm.savedSIPFI !== null) && (vm.savedSIPFI !== vm.sipFirstInstallment))) {
         vm.savedStartDate = null;
         vm.savedEndDate = null;
         vm.savedweeklyDay = null;
         vm.savedSIPFI = null;
       }
    }

    function fetchARNByName() {

      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        return;
      }
      vm.formData.distributorARN = '';
      vm.distributorList = null;
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.distributorList = resp.data.distributorList;
            if (vm.distributorList.length == 0) {
              //vm.isInvalidForm = true;
              vm.formData.euin = {};
              vm.isCheckedTandC = false;
            }
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.distributorList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.distributorList=null;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getDistributor',
        controller2: vm.formData.distributorName
      }).$promise.then(success, error);
    }

    function checkValidations() {
      vm.isInvalidForm = false;

      if (!vm.inSchemeValidations && !vm.outSchemeValidations) {
        vm.validations = {};
      }

      if (vm.outSchemeValidations) {
        vm.validations.isEnabled = vm.outSchemeValidations ? vm.outSchemeValidations.isEnabled : '';
        extractValidationObject(vm.outSchemeValidations);
      }

      if (vm.inSchemeValidations) {
        vm.validations.minInstallDivisionFlag = vm.inSchemeValidations.minInstallDivisionFlag;
        vm.validations.swpTaxCode = vm.inSchemeValidations.swpTaxCode;
        vm.validations.endingType = vm.inSchemeValidations.endingType;
        extractValidationObject(vm.inSchemeValidations);
        checkEMandate();
      }
    }

    function fetchInSchemes(cb) {
      cb = cb || function () {
      };

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.masterInSchemeList = resp.data.schemeList;
            vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
            /* fill autoscheme for sip with first installment*/
            if (vm.formData.inSchemeCode) {
              var schemeData = vm.inSchemeList.filter(function(scheme) {
                return scheme.schemeCode === vm.formData.inSchemeCode;
              });
              vm.inSchemeChanged(schemeData[0]);
              if (vm.formData.topupDetails && vm.formData.topupDetails.capMonthYear) {
                vm.formData.topupDetails.capMonthYear = $window.moment(vm.formData.topupDetails.capMonthYear,"MMM-YYYY").format("MMM-YYYY");
              }
            }
            cb();
          } else {
            vm.masterInSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.masterInSchemeList = null;
          UtilService.errorHandler(err);
        };
      var _config = {
        controller: 'scheme',
        type: 'ALL',
        child1: vm.transactionType.toLowerCase() + 'enabled',
        child2: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
        child3: vm.formData.isThroughDistributor,
        child4: vm.formData.corporateInvestor
      };
      SchemeService.get(_config, null).$promise.then(success, error);
    }

    function fetchPurchaseInSchemes(cb) {
      cb = cb || function () {
      };

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.masterPurchaseInSchemeList = resp.data.schemeList;
            vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
            cb();
          } else {
            vm.masterPurchaseInSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.masterPurchaseInSchemeList = null;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'purchaseenabled',
        child2: (vm.folioMinor ? vm.folioMinor :false),//vm.investorInfo.minor,
        child3: vm.formData.isThroughDistributor,
        child4: vm.formData.corporateInvestor
      }, null).$promise.then(success, error);
    }

    function fetchOutSchemeValidations(cb) {
      vm.outSchemeValidations = null;
      cb = cb || function () {
      };

      if (!vm.formData.outSchemeCode) {
        return;
      }
      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.enabledStartDates = null;
        vm.enabledEndDates = null;
        vm.formData.day = '';
        vm.formData.weeklyDay = '';
        vm.formData.frequency = null;
        vm.validations = {};
        vm.isMultiples = false;
        vm.isMin = false;
        vm.isMax = false;
        reSetting();
      }
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.outSchemeValidations = resp.data;
            var schemeTypeCheck = vm.outSchemeValidations && vm.outSchemeValidations.investmentOption;
            vm.isSourceSchemeGrowth = schemeTypeCheck == "GROWTH" ? true : false;

            cb(resp.data);
          } else {
            cb('error');
            vm.outSchemeValidations = null;
            MessageService.error(resp.message);
          }
          checkValidations();
        },
        error = function (err) {
          vm.outSchemeValidations = null;
          cb('error');
          UtilService.errorHandler(err);
        };

      var _config = {
        controller: 'schemeValidation',
        type: vm.transactionType.toLowerCase()/*,
        child1: vm.formData.outSchemeCode*/
      };
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        _config = {
          controller: 'validation',
          type: 'flexIndex'
        };

        var data = {
          folioNo: vm.formData.folioNumber,
          schemeCode: vm.formData.outSchemeCode,
          transactionType: 'FLEXINDEX'
        };

        SchemeService.post(_config, data).$promise.then(success, error);

      } else {

        data = {
          folioNo: vm.formData.folioNumber,
          schemeCode: vm.formData.outSchemeCode
        };
        SchemeService.post(_config, data).$promise.then(success, error);
      }
    }

    function fetchInSchemeValidations(cb) {
      vm.inSchemeValidations = null;

      if (vm.transactionType) {
        vm.formData.investmentType = vm.transactionType;
      } else if (vm.formData.investmentType) {
        vm.transactionType = vm.formData.investmentType;
      }
      var transactionType = vm.formData.investmentType.toLowerCase();
      cb = cb || function () {
      };
      if (!vm.formData.inSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;
            // for minor payment mode change
            if(vm.inSchemeValidations && vm.formData.minorFlag){
              vm.inSchemeValidations.cgfFlag = vm.inSchemeValidations.cgfFlag ? vm.inSchemeValidations.cgfFlag : true;
            }
            vm.formData.upiErrorMessage = resp.data.upiMaxAmountErrMessage;
            vm.formData.upiLimit = resp.data.upiMaxAmountLimit;
            vm.frequencyList = vm.inSchemeValidations.additionalValidation.frequency?vm.inSchemeValidations.additionalValidation.frequency:null;
            if($stateParams.action == 'modify' && !vm.modifiedSipDetails){
              var frequency = vm.frequencyList && vm.frequencyList.find(function (f) {
                return f.code === vm.formData.frequency;
              }) || {};
            } else {
              var frequency = vm.frequencyList && vm.frequencyList.find(function (f) {
                return f.code === 'OM';
              }) || {};
            }

            if(!vm.renewDetails.frequency && !vm.checkTransactionID){
              vm.formData.frequency = vm.formData.frequency ? vm.formData.frequency : frequency?frequency.code:vm.frequencyList[0].code;
            } else if (vm.checkTransactionID) {
              vm.formData.frequency = angular.copy(vm.freqForSavedTrxn);
            }
            _setSipDividendOptionsVali(vm.inSchemeValidations);
            cb(null);
          } else {
            cb('error');
            vm.inSchemeValidations = null;
            vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
            vm.formData.dividendOption = vm.isSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.dividendOption;
            vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
            MessageService.error(resp.message);
          }
          checkValidations();
          if (vm.renewDetails.amount){
            vm.formData.amount= parseInt(vm.renewDetails.amount) < vm.validations.sipDefaultAmount ? vm.validations.sipDefaultAmount : parseInt(vm.renewDetails.amount);
            vm.oldAmount = angular.copy(parseInt(vm.renewDetails.amount));
          }
          /*if(vm.formData.sipFirstInstallment && vm.formData.sipFirstAmount)
          {
            checkSipFirstValidations();
          }*/
        },
        error = function (err) {
          cb('error');
          vm.inSchemeValidations = null;
          vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
          vm.formData.dividendOption = vm.isSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.dividendOption;
          vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
          UtilService.errorHandler(err);
        };
      if (vm.formData.investmentType == 'PURCHASE' && vm.formData.inSchemeCode) {
        transactionType = 'switch'
      }
      var params = {
        controller: 'schemeValidation',
        type: transactionType/*,
        child1: vm.formData.inSchemeCode*/
      };
      /*if (HDFC_API.ENV !== 'prod'){
        params.child2= vm.formData.folioNumber
      }*/

      var data = {
        schemeCode: vm.formData.inSchemeCode,
        folioNo: vm.formData.folioNumber
      }
      SchemeService.post(params, data).$promise.then(success, error);
    }

    function _setSipDividendOptionsVali(inSchemeValidations) {
      // var transactionType = vm.formData.investmentType.toLowerCase();
      vm.inSchemeValidations = inSchemeValidations;
      vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
      vm.inSchemeValidations.investmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[vm.inSchemeValidations.investmentOption];
      if($stateParams.action == 'modify' && !vm.modifiedSipDetails) {
        var investmentOption = vm.formData.investmentOption;
        vm.validations.investmentOption = investmentOption;
      } else {
        var investmentOption = vm.inSchemeValidations.investmentOption || (vm.inSchemeValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
        vm.validations.investmentOption = investmentOption;
      }

      if($stateParams.action == 'modify' && !vm.modifiedSipDetails) {
        vm.formData.dividendOption = vm.formData.dividendOption;
      } else {
        vm.formData.dividendOption = (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : (((vm.inSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (vm.isSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : (vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST));
      }
      vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
      if (!vm.formData.isBackFromSummary && !vm.formData.sipDividendOption) {
        if($stateParams.action == 'modify' && !vm.modifiedSipDetails && vm.formData.dividendOption) {
          if (vm.formData.dividendOption == "Z") {
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          } else {
            if (vm.formData.dividendOption == "N" ) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
            } else if (vm.formData.dividendOption == "Y") {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            }
          }
        } else {
          if (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) {
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          } else {
            if (vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === false) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
            } else if (vm.inSchemeValidations.dividendPayoutApplicable === false && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            } else if (vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            }
          }
          if($stateParams.action == 'modify') {
            vm.formData.modifyDividendOption = vm.formData.sipDividendOption;
          }
        }
      }
      if (vm.inSchemeValidations.validationType == 'SWITCH') {
        vm.switchSchemeInvestmentOption = vm.inSchemeValidations.investmentOption;
        vm.formData.switchDividendOption = (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : (((vm.inSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (vm.isSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : (vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST));
      }

      if(vm.inSchemeValidations.amountArray)
        vm.sipFirstInstallmentAmount=vm.inSchemeValidations.amountArray;

    }

    function fetchPurchaseValidations(cb) {
      vm.purchaseValidations = null;
      cb = cb || function () {
      };
      if (!vm.formData.purchaseInSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.purchaseValidations = resp.data;
            // for minor payment mode change
            if(vm.purchaseValidations && vm.formData.minorFlag){
              vm.purchaseValidations.cgfFlag = vm.purchaseValidations.cgfFlag ? vm.purchaseValidations.cgfFlag : true;
            }
            _setPurchaseDividendOptionsVali(vm.purchaseValidations);
            vm.formData.schemeType= vm.purchaseValidations.schemeType;
            vm.formData.upiErrorMessage = resp.data.upiMaxAmountErrMessage;
            vm.formData.upiLimit = resp.data.upiMaxAmountLimit;
            cb(null);
          } else {
            cb('error');
            vm.purchaseValidations = null;
            vm.isSchemeTypeELSS = (vm.purchaseValidations && vm.purchaseValidations.schemeType == "ELSS") ? true : false;
            vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption || vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.purchaseInvestmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH;
            vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
            MessageService.error(resp.message);
          }
          vm.checkPurchaseValidations();
        },
        error = function (err) {
          cb('error');
          vm.purchaseValidations = null;
          vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption || vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.purchaseInvestmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH;
          vm.isSchemeTypeELSS = (vm.purchaseValidations && vm.purchaseValidations.schemeType == "ELSS") ? true : false;
          vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
          UtilService.errorHandler(err);
        };

      var data = {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.purchaseInSchemeCode
      };
      SchemeService.post({
        controller: 'schemeValidation',
        type: 'purchase'/*,
        child1: vm.formData.purchaseInSchemeCode,
        child2: vm.formData.folioNumber*/
      }, data).$promise.then(success, error);
    }

    function _setPurchaseDividendOptionsVali(purchaseValidations) {
      vm.purchaseValidations = purchaseValidations;
      vm.isSchemeTypeELSS = (vm.purchaseValidations && vm.purchaseValidations.schemeType == "ELSS") ? true : false;
      vm.formData.purchaseInvestmentOption = vm.purchaseValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : (vm.formData.purchaseInvestmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH && vm.formData.purchaseInvestmentOption || vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
      vm.formData.cgfFlag = vm.purchaseValidations  ? vm.purchaseValidations.cgfFlag:null;
        vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
      if (!vm.formData.isBackFromSummary) {
        if(vm.purchaseValidations.isGrowth){
          vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
        }else {
          /*if((vm.formData.purchaseDividendOption !== vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH && vm.formData.purchaseDividendOption)
            || (vm.purchaseValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED)
            || (vm.isSchemeTypeELSS)){*/

          if(vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === false){
            vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
          }else if(vm.purchaseValidations.dividendPayoutApplicable === false && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
            vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          }else if(vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
            vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          }
        }
      }
    }

    function fetchUnitDetails() {
      vm.unitsDetails = null;
      if (!vm.formData.outSchemeCode) {
        return;
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        return;
      }

      LoaderService.showLoader();

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.unitsDetails = resp.data;
            vm.unitsDetails.message = resp.message || '';
            vm.unitsDetails.isDisabled = !resp.data.freeValueUnits;
            vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
            vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
            vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
            checkValidations();
          } else {
            vm.unitsDetails = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.unitsDetails = null;
          UtilService.errorHandler(err);
        };
      InvestorService.post({
        child1: 'transaction',
        child2: 'folio',
        child3: 'scheme-value'
      }, {
        schemeCode: vm.formData.outSchemeCode,
        transactionType: vm.transactionType.toLowerCase(),
        folioNo: vm.formData.folioNumber
      }).$promise.then(success, error);
    }

    function getTransactionDetails() {
      if (!$stateParams.transactionId) {
        MessageService.error("TransactionId is missing for saved transaction.");
        $state.go('main.dashboard');
        return;
      }

      var success = function (resp) {
          if (resp.data && resp.status) {
            showPrefillValues(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'transaction',
        controller2: 'saved',
        controller3: $stateParams.transactionId,
        controller4: $stateParams.isCompId
      }).$promise.then(success, error);
    }

    function getTransactionTypeFromStateParams() {
      return $stateParams.transactionType;
    }

    function getTransactionType() {
      var transactionType = '';
      switch ($state.current.name) {

        case 'main.transactions.sip':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP;
          break;
        case 'main.transactions.purchase':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE;
          break;

        default :
          $state.go('welcome');
          break;
      }
      return transactionType;
    }

    function getFinalPayloadData() {
      var payload = null;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          payload = vm.isSaving ? getSipPurchasePayloadToSave() : getSipPurchasePayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          payload = vm.isSaving ? getSipPurchasePayloadToSave() : getSipPurchasePayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SCHEDULE_TRANSACTION_PURCHASE:
          payload = vm.isSaving ? getSipPurchasePayloadToSave() : getSipPurchasePayloadToSubmit();
          break;
      }
      return angular.copy(payload);
    }

    function getSipPurchasePayloadToSave() {

      if (vm.formData.bankInfo && vm.formData.bankInfo.bankName == "OTHER BANKS") {
        vm.formData.bankInfo.bankName = vm.formData.bankName;
      }
      if(vm.formData.isThroughDistributor===false && vm.formData.isThroughRia === false){
        vm.formData.euin = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
      }

      if (typeof vm.formData.endDate === 'string') {
        vm.formData.endDate = $window.moment(vm.formData.endDate);
      }

      if (typeof vm.formData.startDate === 'string') {
        vm.formData.startDate = $window.moment(vm.formData.startDate);
      }

      var sipPayload = {
          authMode: vm.formData.authMode ? vm.formData.authMode.value  : null,
          installmentAmount: vm.formData.amount,
          investmentOption: fetchInvestmentOption(vm.validations.investmentOption),
          dividendOption: vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.sipDividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          frequency: vm.formData.frequency,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          schemeType: vm.formData.schemeType,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          toDate: vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
          sipDate: vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
          sipDay: vm.formData.day,
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
          euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
          id: vm.formData.sTransactionId,
          compositeTransactionId: $stateParams.ctId ? $stateParams.ctId : '',
          isTillPerpetuityvm: vm.formData.isTillPerpetuity ? vm.formData.isTillPerpetuity : false,
          bankDetailsForECS: {
            accNumber: vm.formData.bankInfo ? vm.formData.bankInfo.accountNumber:'',
            bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.formData.ifscCode,
            branchName: vm.formData.bankBranch,
            bankCity: vm.formData.bankCity,
            paymentOption: vm.formData.sipPaymentOption=='E-mandate'?'HEM': vm.formData.sipPaymentOption === 'UPI' ? 'UAP' : vm.formData.sipPaymentOption,
            otmId: vm.formData.otmId,
            netBankingUrl: vm.formData.netBankingUrl,
            payoutId : vm.formData.payoutId
          },
          subBrokerARN: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode,
          sipTopupEnabled: vm.sipTopupSelected,
          topupDetails: {
            amount: vm.formData.topupDetails?vm.formData.topupDetails.amount:'',
            percentage: vm.formData.topupDetails?vm.formData.topupDetails.percentage:'',
            frequency: vm.formData.topupDetails?vm.formData.topupDetails.frequency:'',
            capAmount: vm.formData.topupDetails?vm.formData.topupDetails.capAmount:'',
            capMonthYear: vm.formData.topupDetails?(vm.formData.topupDetails.capMonthYear?$window.moment(vm.formData.topupDetails.capMonthYear,"MMM-YYYY").format("DD-MMM-YYYY"):''):''
          },
          mandateStartDate : vm.formData.emandateDate ? $window.moment(vm.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null,
          mandateEndDate : vm.formData.endDateEmandate ? $window.moment(vm.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null,
          mandateAmount : vm.formData.emandateAmount ? vm.formData.emandateAmount : null

        },
        purchasePayload = {
          amount: vm.formData.purchaseAmount,
          investmentOption: vm.formData.purchaseInvestmentOption,
          dividendOption: vm.formData.purchaseDividendOption,
          folioNumber: vm.formData.folioNumber,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
          euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
          id: vm.formData.pTransactionId,
          compositeTransactionId: $stateParams.ctId ? $stateParams.ctId : '',
          schemeCode: vm.formData.purchaseInSchemeCode,
          retirementAgeProofURL: vm.formData.retirementAgeProofURL ? vm.formData.retirementAgeProofURL : '',
          checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
          autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null,
          autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null,
          subBrokerARN: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode
        };

      if(vm.backFromPayment)
      {
        vm.sipFirstInstallment=true;
        vm.formData.sipFirstInstallment=true;
      }

      if(vm.formData.sipFirstInstallment)
      {
        sipPayload.sipWithFirstInstallment=vm.formData.sipFirstInstallment;
        sipPayload.firstInstallmentDetails={amount:vm.formData.amount};
      }

      if (!vm.formData.purchaseInSchemeName.toLowerCase().includes('retirement')) {
        purchasePayload.retirementAgeProofURL = '';
      }

      if (!sipPayload.investmentOption) {
        sipPayload.investmentOption = vm.formData.sipPaymentOption;
      }
      if (!sipPayload.dividendOption) {
        sipPayload.dividendOption = vm.formData.sipDividendOption;
      }

      if (vm.formData.bankInfo && !vm.formData.bankInfo.bankAcType) {
        sipPayload.bankDetailsForECS.accType = vm.formData.bankAcType;
      }

      var payload = {};

      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          purchasePayload = handleBrokerCode(purchasePayload);
          payload = angular.copy(purchasePayload);
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          sipPayload = handleBrokerCode(sipPayload);
          payload = angular.copy(sipPayload);
          break;
      }
      payload.trackId = vm.formData.trackId;

      return payload;
    }
    function getSipPurchasePayloadToSubmit() {

      var summaryEnabled=$window.localStorage.getItem("SummaryEnabled");

      if ( summaryEnabled===null && !vm.validations.investmentOption && (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP)) {
        MessageService.error('Invalid Investment option for sip is selected.');
        return false;
      }

      if (!vm.formData.purchaseInvestmentOption && (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)) {
        MessageService.error('Invalid Investment option for purchase is selected.');
        return false;
      }
      if (!vm.formData.purchaseInSchemeName.toLowerCase().includes('retirement')) {
        vm.formData.retirementAgeProofURL = '';
      }

      if (vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        vm.formData.dividendOption = vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.sipDividendOption;
      } else {
        vm.formData.dividendOption = vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.dividendOption;
      }
      if (vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP && vm.formData.sipTopupEnabled && !vm.formData.topupDetails.capAmount) {
        vm.formData.topupDetails.capMonthYear = $window.moment(vm.formData.topupDetails.capMonthYear,"MMM-YYYY").format("DD-MMM-YYYY");
      }
      var selectedFolioObj = vm.folioList && vm.folioList.filter(function (row) {              // for investor's name initialisation
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      if(selectedFolioObj) {
        vm.selectedFolioData = selectedFolioObj;
        vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
      }
      vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName:'';

      vm.formData.investmentOption = vm.validations.investmentOption?vm.validations.investmentOption:vm.formData.investmentOption;
      vm.formData.checkedNfoAutoSwitch = vm.formData.isAutoSwitch;
      vm.formData.autoSwitchScheme = vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null;
      vm.formData.autoSwitchSchemeDividendOption = vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null;
      vm.formData.switchSchemeInvestmentOption = vm.formData.isAutoSwitch ? vm.switchSchemeInvestmentOption : null;
      vm.formData.folioInvestorName = vm.folioInvestorName;
      vm.formData.euinOpted = (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N';
      if (vm.formData.investmentType === 'SIP') {
        vm.formData.accType = vm.formData.bankInfo && vm.formData.bankInfo.bankAcType ? vm.formData.bankInfo.bankAcType : vm.formData.bankAcType;
        vm.formData.ifscCode = vm.formData.bankInfo && vm.formData.bankInfo.ifscCode ? vm.formData.bankInfo.ifscCode : vm.formData.ifscCode;
      }
      return angular.copy(vm.formData);
    }

    function fetchOutSchemes(cb) {
      cb = cb || function () {
      };

      if (!vm.formData.folioNumber) {
        return;
      }

      vm.outSchemeList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.outSchemeList = resp.data.schemes;
            cb();
          } else {
            vm.outSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.outSchemeList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();

      var _config = {child1: 'folio', child2: 'schemes'};
      InvestorService.post(_config, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }

    function checkOTM(cb){
      cb = cb || function () {
      };
      var success = function (resp) {
        if (resp.status && resp.data) {
          if (resp.data.bankList.length == 0) {
            vm.isOTMEnabled = false;
            if(!(vm.checkForMinorBankListCondition())) {
              if (vm.formData.frequency !== 'OW'){
                if(vm.sipFirstInstallment)
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                else
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
              }
              else
              {
                if(vm.sipFirstInstallment)
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI];
                else
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
              }
              var index = vm.paymentOptions.indexOf('OTM');
              if(index > -1) {
                vm.paymentOptions.splice(index,1);
              }
              if (!vm.setPaymentModeFromSave || vm.formData.sipPaymentOption === 'OTM' || !vm.formData.sipPaymentOption) {
                vm.formData.sipPaymentOption = vm.paymentOptions[0];
              }
              hideUPIDetails();
              changedPaymentOption();
            }
              if(vm.formData.isBackFromSummary || $stateParams.transactionId)
              {
                var frequency = vm.frequencyList && vm.frequencyList.find(function (item) {
                  return vm.formData.frequency === item.code;
                }) || {};
                vm.formData.frequency = frequency.code || '';

            }

         }
         else {
            if (vm.sipFirstInstallment && resp.data.nonCOTMBankList.length === 0) {
              vm.isOTMEnabled = false;
              if (vm.checkForMinorBankListCondition() || vm.formData.frequency === 'OW')
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI];
              else
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            } else {
              vm.isOTMEnabled = true;
              if (vm.checkForMinorBankListCondition()) {
                if(vm.sipFirstInstallment)
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                else
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
              } else {
                if (vm.formData.frequency === 'OW' || vm.folioMinor) {
                  if(vm.sipFirstInstallment) {
                      if (vm.ECbankList && vm.ECbankList.length > 0 && vm.formData.frequency !== 'OW') {
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                      } else {
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                      }
                  } else {
                     if (vm.ECbankList && vm.ECbankList.length > 0 && vm.formData.frequency !== 'OW') {
                       vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                     } else {
                       vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                     }
                  }
                } else {
                  if(vm.sipFirstInstallment)
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                  else
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                }
              }
            }
            hideUPIDetails();
            changedPaymentOption();
            vm.formData.showTopUpBlock =  vm.formData.showTopUpBlock ? true : false;

            if(!vm.backFromPayment)
              if (vm.setPaymentModeFromSave && vm.formData.sipPaymentOption && vm.paymentOptions.includes(vm.formData.sipPaymentOption)) {
                vm.formData.sipPaymentOption = vm.formData.sipPaymentOption;
              } else {
                if (vm.checkTransactionID) {
                  vm.formData.sipPaymentOption = angular.copy(vm.savedPaymentOption === 'HEM' ?  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE : vm.savedPaymentOption);
                } else {
                  vm.formData.sipPaymentOption = vm.paymentOptions ? vm.paymentOptions[0] : '';
                  if(vm.formData.sipPaymentOption=='UPI' && vm.formData.amount > vm.formData.upiLimit) {
                    var success = function() {
                      if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
                        vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
                      } else if(vm.paymentOptions.includes("E-mandate") && vm.isEMandateEnabled) {
                        vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
                      } else if(vm.paymentOptions.includes("EC")){
                        vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
                      } else {
                        vm.formData.sipPaymentOption = null;
                      }
                      vm.changedPaymentOption();
                    }
                    ModalService.genericModal({
                      text: vm.formData.upiErrorMessage,
                      isUpi: true
                    },success);
                  }
                }
              }

            if(vm.formData.isBackFromSummary || $stateParams.transactionId)
            {
              frequency = vm.frequencyList && vm.frequencyList.find(function (item) {
                return vm.formData.frequency === item.code;
              }) || {};
              vm.formData.frequency = frequency.code || '';

              }
              vm.OTMbankList = vm.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList;
          }
        }
        cb(true);
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        cb(false);
      };
      // LoaderService.showLoader();//need to check
      var payload = {
        transactionType:vm.transactionType.toLowerCase(),
        folioNo:vm.formData.folioNumber
      };
      InvestorService.post({
        child1: 'folio',
        child2: 'otm'
      }, payload).$promise.then(success, error);
    }

    function fetchBankList(cb) {
      cb = cb || function () {
      };
   //   LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              vm.eMandatenoOfDays=resp.data.noOfDays;
              vm.eMandatemaxAmountLimit=resp.data.maxAmountLimit;
              vm.formData.showTopUpBlock = false;
              /*if(vm.formData.inSchemeCode)
              getDateValidation();*/
              checkEMandateValidation();
            }
            if (vm.formData.sipPaymentOption == 'OTM' && resp.data.bankList.length == 0) {
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
              vm.hideOtmRadio = true;
              //fetchBankList();
            }
            else if (vm.formData.sipPaymentOption == 'OTM' && resp.data.bankList.length > 0) {
              vm.hideOtmRadio = false;
            }
            else if (vm.formData.sipPaymentOption == 'EC' || vm.formData.sipPaymentOption == 'UPI') {
              if (vm.formData.sipPaymentOption == 'EC') {
                vm.ECbankList = resp.data.bankList;
              } else {
                vm.UPIbankList = resp.data.bankList;
              }
              if (vm.hideOtmRadio) {
                if(vm.sipFirstInstallment)
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                else
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                hideUPIDetails();
                vm.formData.sipPaymentOption = vm.paymentOptions[0];
                /*if(vm.formData.inSchemeCode)
                  getDateValidation();*/
              }
              else {
                if(vm.checkForMinorBankListCondition())
                {
                  if(vm.sipFirstInstallment)
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                  else
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                }
                else {
                  if(vm.sipFirstInstallment)
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                  else
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                }
                hideUPIDetails();
                vm.hideOtmRadio = false;
                /*if(vm.formData.inSchemeCode)
                  getDateValidation();*/
              }

              if (vm.formData.frequency === 'OW') {
                var index = vm.paymentOptions.indexOf('EC');
                if(index > -1) {
                  vm.paymentOptions.splice(index,1);
                }
              }
            }

            vm.bankList = resp.data.bankList;

            if (vm.formData.sipPaymentOption == 'EC') {
              for(var i = 0 ;  i < vm.bankList.length ; i++) {
                vm.bankList[i].id = i;
              }
            }

            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              vm.formData.authMode = vm.formData.bankInfo? (vm.formData.bankInfo.authenticationModes.length === 1 ? vm.formData.bankInfo.authenticationModes[0] : null) :null;
              vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
          cb(true);
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      // LoaderService.showLoader();

      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        if(!vm.ECbankList) {
          var payload = {
            "trnxType": 'PURCHASE',
            "folioNumber": vm.formData.folioNumber,
            "liquidSchemeFlag": vm.formData.schemeType == 'LIQUID' ? true : false,
            "sipFlow": true
          };
          InvestorService.post({child1: 'bank', child2: 'list'}, payload).$promise.then(success, error);
        } else {
        LoaderService.hideLoader();
          if (vm.hideOtmRadio) {
            if(vm.sipFirstInstallment)
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            else
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            hideUPIDetails();
            vm.formData.sipPaymentOption = vm.paymentOptions[0];
            /*if(vm.formData.inSchemeCode)
              getDateValidation();*/
          }
          else {
            if(vm.checkForMinorBankListCondition())
            {
              if(vm.sipFirstInstallment)
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
              else
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            }
            else {
              if(vm.sipFirstInstallment)
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
              else
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];

            }
            hideUPIDetails();
            vm.hideOtmRadio = false;
            /*if(vm.formData.inSchemeCode)
              getDateValidation();*/
          }
          vm.bankList = vm.ECbankList;
        }
      } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        LoaderService.hideLoader();
        vm.hideOtmRadio = false;
        vm.bankList = vm.OTMbankList;
      }
      else if(vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
        LoaderService.hideLoader();
        vm.formData.showTopUpBlock = false;
        /*if(vm.formData.inSchemeCode)
          getDateValidation();*/
        checkEMandateValidation();
        vm.bankList =  vm.EMbankList;
        vm.formData.authMode = vm.formData.bankInfo? (vm.formData.bankInfo.authenticationModes.length === 1 ? vm.formData.bankInfo.authenticationModes[0] : null) :null;
        vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
      } else if(vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
        if (!vm.UPIbankList) {
          var payload = {
            "trnxType": 'PURCHASE',
            "folioNumber": vm.formData.folioNumber,
            "liquidSchemeFlag": vm.formData.schemeType == 'LIQUID' ? true : false,
            "sipUpiFlow" : true
          };
          InvestorService.post({child1: 'bank', child2: 'list'}, payload).$promise.then(success, error);
        } else {
          vm.formData.showTopUpBlock = false;
          if(vm.formData.inSchemeCode)
            getDateValidation();
        }
        vm.bankList = vm.UPIbankList;
      }
      else{
        vm.bankList = null;
      }
    }

    vm.checkForMinorBankListCondition = function(){
      var selectedFolioObj = vm.folioList && vm.folioList.filter(function (row) {
        return row.folioNumber == vm.formData.folioNumber
      })[0];

        if (selectedFolioObj) {
          return selectedFolioObj.minorFlag && vm.inSchemeValidations && !vm.inSchemeValidations.cgfFlag;
        }
    };

    function updateDatesForDaily() {
      var currentDay = $window.moment().add(3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.formData.startDate = vm.formData.isBackFromSummary?vm.formData.startDate: vm.savedStartDate ? vm.savedStartDate : vm.enabledStartDates[0];
      vm.formData.day = +(vm.formData.startDate.format('DD'));
      updateEndDates();
    }

    function updateDatesForWeekly() {
      var indexDates = $window.moment();
      var businessDays = [];
      var count = 1;
      //calculating non business days
      for (var i = 1; i <= 90; i++) {
      var indexDate = $window.moment().add(i, 'days').format("DD-MMM-YYYY");
      var isEnable = true;
      if (count <= 5) {
           angular.isArray(vm.nonBusinessDatess) && vm.nonBusinessDatess.forEach(function (value) {
              if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')==0){
                isEnable = false;
              }
           });
        }

        if(isEnable){
         businessDays.push($window.moment().add(i, 'days'));
         count++;
        }
      }
      //setting the 5th day as part of T+5
      var currentDay = businessDays[4];
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [];
      var _day = vm.daysList.find(function (d) {
        return d === vm.formData.weeklyDay;
      }) || {};
      for (var i = 0; i < 90; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (($window.moment(vm.startMinDateOTM,"DD-MMM-YYYY").diff(_date.format("DD-MMM-YYYY"),'days')<=0) &&(_date.format('dddd').toLowerCase() === _day.toLowerCase())) {
          enabledStartDates.push(_date.clone());
        }
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.formData.startDate = vm.savedStartDate ? vm.savedStartDate : vm.enabledStartDates[0];
      updateEndDates();
    }

    function updateDatesForOthers() {
      var currentDay = $window.moment();
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.formData.day);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      var tDays = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? 15 : 10;
      while (_diff < tDays) {
        updatedDate.add(1, 'months').set('date', vm.formData.day);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }

      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
       /*  if (HDFC_API.ENV === 'prod' || HDFC_API.ENV === 'beta') {
          if (_diff <= 90) {
            enabledStartDates.push(_date.clone());
          }
        } */
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }

      vm.enabledStartDates = angular.copy(enabledStartDates);
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
        calculateMonthsForSip();
      } else {
        vm.formData.startDate = vm.savedStartDate ? vm.savedStartDate : vm.enabledStartDates[0];
      }
      updateEndDates();
    }

    function calculateMonthsForSip() {
      var arr = [];
      for (var i = 0; i < vm.enabledStartDates.length; i++) {
        var str1 = vm.enabledStartDates[i].format('MMM') + ', ' + vm.enabledStartDates[i].format('YYYY');
        var str2 = i;
        arr.push({name: str1, value: str2});

      }
      vm.formData.monthList = arr;
    }

    function updateEndDates(doNotUpdateEndDate,amountDateCheck,calledFromOtherFlow) {
      if (!vm.formData.startDate) {
        return;
      }

      if (vm.formData.sipPaymentOption === 'E-mandate' || vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
        var defaultEndDate = $window.moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.emandateMaxYear, 'years');
      } else {
        var defaultEndDate = $window.moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      }
      //var defaultEndDate = new Date(2036, 12, 31);
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;
      var frequency = vm.frequencyList && vm.frequencyList.find(function (f) {
        return f.code === vm.formData.frequency;
      }) || {};


      switch (vm.formData.frequency) {
        case'BZ':
          var days = 0;
          endDate = vm.formData.startDate.clone();//.add(minInstallments, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          var days = getMonthsCount(endDate.clone(), defaultEndDate);
          freq = vm.formData.sipPaymentOption === 'E-mandate' ? defaultEndDate.diff(endDate, 'days', true) : ((defaultMonths * 30) / frequency.duration) + days;
          for (i = 0; i < freq; i++) {
            days = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        case'OW':
          var days = 0;
          if (vm.formData.sipPaymentOption === 'E-mandate' || vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            defaultEndDate = $window.moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.emandateMaxYear, 'years').toDate();
          } else {
            defaultEndDate = new Date("12/31/2099");
          }
          freq = UtilService.getNumberOfWeeks(vm.formData.startDate.toDate(), defaultEndDate);
          for (i = 0; i <= freq; i++) {
            days = frequency.duration * i;
            enabledEndDates.push(vm.formData.startDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          endDate = vm.formData.startDate.clone().add(frequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.duration);
          for (i = 0; i < freq; i++) {
            months = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
      vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
      if (!doNotUpdateEndDate) {
        //vm.formData.endDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
        vm.formData.minEndDate = angular.copy(vm.enabledEndDates[0]);
      } else {
        //vm.formData.endDate = null;
        vm.formData.minEndDate = angular.copy(vm.enabledEndDates[0]);
      }
      vm.formData.maxEndDate = new Date(2099, 12, 31);

      if ($stateParams.transactionId && $stateParams.initiatedBy !== 'schedule' && vm.savedStartDate && vm.savedEndDate) {
        // finding out default end date
        vm.formData.isTillPerpetuity = true;
        if (vm.formData.sipPaymentOption === 'E-mandate') {
          vm.endDateDefaultForPertuity = $window.moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.emandateMaxYear, 'years');
          var isSame = vm.endDateDefaultForPertuity.isSame($window.moment(vm.savedEndDate));
          if (!isSame) {
            vm.formData.isTillPerpetuity = false;
            vm.formData.endDate = vm.savedEndDate;
          }
        } else {
          vm.changeTillPerpetuityFlag(function () {
            var isSame = vm.endDateDefaultForPertuity.isSame($window.moment(vm.savedEndDate));
            if (!isSame) {
              vm.formData.isTillPerpetuity = false;
              vm.formData.endDate = vm.savedEndDate;
            }
          });
        }
      } else {
        if (amountDateCheck && vm.formData.endDate && (($window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates[0]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates.length - 1))))) {
          if (vm.formData.endDate.isSame($window.moment(vm.endDateDefaultForPertuity))) {
            vm.formData.isTillPerpetuity = true;
          } else {
            vm.formData.isTillPerpetuity = false;
          }
        } else if(vm.formData.sipPaymentOption !== 'E-mandate' && vm.formData.sipPaymentOption !== 'UPI')  {
          vm.formData.endDate = null;
          vm.formData.isTillPerpetuity = true;
          vm.changeTillPerpetuityFlag();
        }
      }


      if ((vm.formData.sipPaymentOption === 'E-mandate' && !vm.savedEndDate) || vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
        if (!calledFromOtherFlow) {
          vm.formData.endDate =  $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1], 'DD-MMM-YYYY');
          vm.formData.maxEndDate = $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
        }
        vm.changeEndDate(vm.formData.endDate,calledFromOtherFlow);
      }


      //reSetting();
    }

    function changeFrequency(calledFromHtml) {
      if($stateParams.action == 'modify'){
        vm.checkModifySipDetails();
        vm.compareDataFromSystematic();
      }

      if (calledFromHtml && vm.renewDetails) {
        vm.renewDetails = {};
      }

      if (!vm.formData.isBackFromSummary) {
        if($stateParams.action == 'modify' && !vm.modifiedSipDetails){

        } else {
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          vm.formData.day = null;
          vm.formData.weeklyDay = null;
          vm.formData.month = null;
          vm.authenticationMode = null;
          vm.formData.isTillPerpetuity = false;
          vm.formData.sipTopupEnabled=false;

        if (vm.formData.frequency !== vm.savedFrequency) {
          vm.formData.bankInfo = null;
          vm.savedFrequency = null;
          vm.setPaymentModeFromSave = '';
          vm.savedStartDate = null;
          vm.savedEndDate = null;
          vm.savedweeklyDay = null;
        }
          vm.formData.sipTopupSelected = false;
          resetTopupDetails();
          resetBankDetails();
          reSetting();
        }
      }
      vm.disableEndDateSelection = false;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      vm.formData.amount = getFinalAmount();
      checkValidations();
      checkEMandate(function () {});
      if (vm.formData.frequency === 'BZ') {// for Daily
        vm.daysList = null;
        vm.viewMode = 'days';
        vm.formData.showTopUpBlock = false;
        updateDatesForDaily();
        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
        hideUPIDetails();
        if(vm.formData.sipPaymentOption === vm.paymentOptions[1])
          vm.formData.sipPaymentOption = vm.paymentOptions[1];
        else{
          // if(vm.isEMandateEnabled && !vm.isOTMEnabled) {
          //   vm.formData.sipPaymentOption = vm.paymentOptions[1];
          // } else {
            vm.formData.sipPaymentOption = vm.paymentOptions[0];
          // }
        }
        $timeout(function(){
          vm.formData.sipPaymentOption = vm.formData.sipPaymentOption ? vm.formData.sipPaymentOption : vm.paymentOptions[0];
          fetchBankList();
        },100);
        if($stateParams.action == 'modify' && (vm.formData.sipFirstInstallment == true || vm.formData.sipFirstInstallment == false) && !vm.modifiedSipDetails) {
          changeFirstInstallment(false,true);
        }else {
          changeFirstInstallment(false);
        }
      } else if (vm.formData.frequency === 'OW') {
        vm.daysList = vm.TRANSACTIONS_CONST.WEEKS_LIST;
        if (!vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)) {
          vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
        }
        vm.viewMode = 'days';
        vm.formData.showTopUpBlock = false;
        if (vm.isEMandateEnabled && vm.isOTMEnabled) {
          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
        } else if (vm.isEMandateEnabled && !vm.isOTMEnabled) {
          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
        } else if (!vm.isEMandateEnabled && vm.isOTMEnabled) {
          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
        }
        hideUPIDetails();
        var index = vm.paymentOptions.indexOf('EC');
          if(index > -1) {
            vm.paymentOptions.splice(index,1);
        }

        if (!vm.setPaymentModeFromSave) {
          vm.formData.sipPaymentOption = vm.paymentOptions[0];
        }
        if($stateParams.action == 'modify' && (vm.formData.sipFirstInstallment == true || vm.formData.sipFirstInstallment == false) && !vm.modifiedSipDetails) {
          changeFirstInstallment(false,true);
        }else {
          changeFirstInstallment(false);
        }
        checkEMandate(function () {});
      } else { // for monthly & quartly
        // vm.daysList = getDaysList();
        vm.viewMode = 'months';
        // set payment option standard ins... for month & quartly
        if(!vm.checkForMinorBankListCondition())
        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
        hideUPIDetails();
        if(vm.isOTMEnabled=== true){
          if (!vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM)) {
            vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM);
          }
        }
        if (vm.isEMandateEnabled) {
          vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
        }
        vm.formData.sipPaymentOption = vm.formData.sipPaymentOption ? vm.formData.sipPaymentOption : vm.paymentOptions[0];
        fetchBankList();
        if($stateParams.action == 'modify' && (vm.formData.sipFirstInstallment == true || vm.formData.sipFirstInstallment == false) && !vm.modifiedSipDetails) {
          changeFirstInstallment(false,true);
        }else {
          changeFirstInstallment(false);
        }
        checkEMandate(function () {});
      }
      if(vm.isBackFromSummary){
        checkOTM();
      }
    }

    function resetDefaults(doNotEmptyValidations) {
      vm.isReseting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      if (!doNotEmptyValidations) {
        vm.validations = {};
      }
      checkValidations();
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }


    function getAmountForStpType() {
      if (vm.formData.frequency === 'OM' || vm.formData.frequency === 'Q') {
        return '';
      }

      return '';
    }

    function getFinalAmount() {
      var amount = vm.formData.amount;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP:
          amount = (vm.formData.transferOption == vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION) ? getAmountForStpType() : amount;
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          amount = (vm.formData.transferOption == vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION) ? 300 : amount;
          break;
      }
      return amount;
    }

    function showPrefillValuesUserTracker() {
      vm.transactionType = getTransactionType();
      if (!$stateParams.trackId) {
        MessageService.error("TrackId is missing for saved transaction.");
        $state.go('main.dashboard');
        return;
      }

      var success = function (resp) {
          if (resp.data && resp.status) {
            var formData = resp.data && resp.data.formdata ? resp.data.formdata: {};
            vm.checkTransactionID = true;
            if($stateParams.stepNo == 'SECOND'){
              vm.summaryData = formData;
              vm.formData = angular.copy(formData);
              vm.formData.isSummaryViewEnabled = true;
              TransactionModel.setPayloadRawData(vm.formData);
            }else{
              showPrefillValues(formData);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'userBehavior',
        controller2: $stateParams.trackId,
        controller3: 'getFormData'
      }).$promise.then(success, error);
    }

    function showPrefillValues(rawData) {
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          if (rawData) {
            sipPrefillValues(rawData)
          } else {
            fetchPreviousTrSelectedDistrubutor(function () {
              if (!vm.formData.isEuin) {
                vm.isCheckedTandC = true;
              }
              vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
              if ($stateParams.allowBroker && $stateParams.allowBroker === "true" && $stateParams.action === 'renew') {
                manipulateInvestThrough(AppConstants.INVEST_THROUGH.DISTRIBUTOR);
              } else if ($stateParams.allowBroker && $stateParams.allowBroker === "false" && $stateParams.action === 'renew') {
                if (vm.formData.isThroughRia) {
                  manipulateInvestThrough(AppConstants.INVEST_THROUGH.RIA);
                } else {
                  manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
                  // vm.changeThroughDistributor(AppConstants.INVEST_THROUGH.DIRECT);
                }
              }
              /*if(localStorage.getItem('allowBroker')==="true" && localStorage.getItem('Action')==='renew'){
                manipulateInvestThrough(AppConstants.INVEST_THROUGH.DISTRIBUTOR);
                fetchEuinList();
              } else if (localStorage.getItem('allowBroker')==="false" && localStorage.getItem('Action')==='renew') {
                if (vm.formData.isThroughRia) {
                  manipulateInvestThrough(AppConstants.INVEST_THROUGH.RIA);
                } else {
                  manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
                }
                fetchEuinList();
              }*/
              if (vm.formData.distributorARN) {
                fetchEuinListThroughDistributor(vm.formData.distributorARN);
              }

              fetchFolioList(function (success) {
                if (success) {
                  var selectedFolioObj = vm.folioList.filter(function (row) {
                    return row.folioNumber == vm.formData.folioNumber
                  })[0];
                  if(selectedFolioObj) {
                    vm.selectedFolioData = selectedFolioObj;
                    vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
                  }
                  //checkOTM();
                  checkOTM(function (success) {
                    if(success){
                      vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
                      vm.folioInvestorName = selectedFolioObj.investorName ? selectedFolioObj.investorName : "";
                      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
                        vm.formData.inSchemeCode = $stateParams.sc ? $stateParams.sc : vm.formData.inSchemeCode;
                      } else {
                        vm.formData.purchaseInSchemeCode = $stateParams.sc ? $stateParams.sc : vm.formData.purchaseInSchemeCode;
                      }
                      fetchInSchemes(function () {
                        var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                          return vm.formData.inSchemeCode === item.schemeCode;
                        }) || {};
                        vm.formData.inSchemeName = scheme.scheme || '';
                        // getDateValidation();

                        fetchInSchemeValidations(function (err) {
                          if (!err) {
                            checkEMandate(function () {
                            });
                            changeFrequency();
                            checkValidations();

                            vm.isReseting = true;
                            var startDate = vm.formData.startDate;
                            $timeout(function () {
                              vm.isReseting = false;
                            });
                            vm.formData.startDate = startDate;
                            updateEndDates();
                            // updateEndDates();
                            // fetchBankList(function(success){
                            //   if(success){
                            //     var bankList= vm.bankList && vm.bankList.find(function(item){
                            //       return vm.formData.bankInfo === item;
                            //     })|| {};
                            //     if (vm.formData.bankInfo) {
                            //       (vm.formData.bankInfo !='')&&(vm.formData.bankInfo.bankName = bankList.bankName || '');
                            //     }
                            //   }
                            //   if(vm.formData.topupDetails && Object.keys(vm.formData.topupDetails).length > 0){
                            //     changeSipTopupSelected();
                            //   }
                            //   vm.formData.isBackFromSummary = false;
                            // });

                          }
                        });
                      })

                      // vm.formData.sipPaymentOption = 'OTM';
                      // changedPaymentOption();
                    }

                  });

                }
              });
              vm.changeEndDate(vm.formData.endDate);
              // if (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {}
            });
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          if (rawData) {
            sipPrefillValues(rawData)
          } else {
            fetchPreviousTrSelectedDistrubutor(function () {
              if (!vm.formData.isEuin) {
                vm.isCheckedTandC = true;
              }
              vm.formData.amountType = vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT;
              vm.formData.purchaseAmount && $window.NumToWord(vm.formData.purchaseAmount, 'divDisplayWords', vm);
              if (vm.formData.retirementAgeProofURL != '' && vm.formData.purchaseInSchemeName.toLowerCase().includes("retirement")) {
                vm.showChequeLeaf = true;
                vm.retirementAgeProofURL = vm.formData.retirementAgeProofURL;
                vm.breakFileUrl(vm.formData.retirementAgeProofURL);
              } else {
                vm.showChequeLeaf = false;
              }
              if (vm.formData.distributorARN) {
                fetchEuinListThroughDistributor(vm.formData.distributorARN)
              }
              fetchFolioList(function (success) {
                if (success) {
                  var selectedFolioObj = vm.folioList.filter(function (row) {
                    return row.folioNumber == vm.formData.folioNumber
                  })[0];
                  if(selectedFolioObj) {
                    vm.selectedFolioData = selectedFolioObj;
                    vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
                  }
                  vm.folioMinor = (selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag)) ? selectedFolioObj.minorFlag : false;
                  vm.folioInvestorName = selectedFolioObj.investorName ? selectedFolioObj.investorName : "";
                  // vm.formData.isThroughDistributor = rawData.euinOpted === 'Y' ? true : false;
                  fetchPurchaseInSchemes(function () {
                    var scheme = vm.purchaseInSchemeList && vm.purchaseInSchemeList.find(function (item) {
                      return vm.formData.purchaseInSchemeCode === item.schemeCode;
                    }) || {};
                    vm.formData.purchaseInSchemeName = scheme.scheme || '';

                    if (vm.formData.purchaseInSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && scheme.retirementFlag) {
                      MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
                      vm.formData.purchaseInSchemeCode = '';
                      vm.formData.purchaseInSchemeName = '';
                      vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
                      return;
                    }

                    vm.formData.fundCode = scheme.fundCode || '';
                    if (scheme.nfoEnabled == 'Y') {
                      vm.nfoEnabled = true;
                    } else {
                      vm.nfoEnabled = false;
                    }
                    fetchPurchaseValidations(function (err) {
                      if (!err) {
                        vm.formData.isBackFromSummary = false;
                      }
                    });
                    if (vm.nfoEnabled) {
                      fetchSwitchInSchemes(function () {
                        var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                          return vm.formData.inSchemeCode === item.schemeCode;
                        }) || {};
                        vm.formData.inSchemeName = scheme.scheme || '';
                        fetchInSchemeValidations(function (err) {
                          if (!err) {
                            vm.formData.isBackFromSummary = false;
                          }
                        });
                      });
                    }
                  });

                }
              });

            });
          }
          break;
      }
    }

    function sipPrefillValues(data) {
      fetchFolioList(function (success) {
        if (success) {

          var rawData;
          var frequencyList = null;

          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP)
            rawData = {sipForm: data};
          else if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)
            rawData = {purchaseForm: data};
          else if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SCHEDULE_TRANSACTION_PURCHASE)
            rawData = {purchaseForm: data};
          var folioNumber = data.folioNumber|| data.folioNo;
          var selectedFolioObj = vm.folioList.filter(function (row) {
            return row.folioNumber == folioNumber;
          })[0];
          if(selectedFolioObj) {
            vm.selectedFolioData = selectedFolioObj;
            vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
          }
          vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
          vm.folioInvestorName = selectedFolioObj && selectedFolioObj.investorName ?selectedFolioObj.investorName:'';
          vm.formData.isThroughDistributor = data.euinOpted === 'Y' ? true : false;
          if (rawData.purchaseForm) {
            vm.formData.pTransactionId = rawData.purchaseForm.id;
            vm.formData.folioNumber = rawData.purchaseForm.folioNumber;
            fetchInvestorType();
            vm.formData.purchaseAmount = rawData.purchaseForm.amount;
            vm.formData.purchaseDividendOption = rawData.purchaseForm.dividendOption;
            vm.formData.purchaseInSchemeCode = rawData.purchaseForm.schemeCode;
            vm.formData.inSchemeCode = rawData.purchaseForm.schemeCode;
            vm.formData.purchaseAmount && $window.NumToWord(vm.formData.purchaseAmount, 'divDisplayWords', vm);
            vm.formData.amountType = vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT;
            if (vm.formData.retirementAgeProofURL != '') {
              vm.showChequeLeaf = true;
              vm.retirementAgeProofURL = vm.formData.retirementAgeProofURL;
              vm.breakFileUrl(vm.formData.retirementAgeProofURL);
            } else {
              vm.showChequeLeaf = false;
            }

            if (rawData.purchaseForm.primaryFlag) {
              vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE;
            }

            if (rawData.purchaseForm.euinOpted === 'Y') {
              vm.formData.euin = {euinCode: rawData.purchaseForm.euinCode, euinName: rawData.purchaseForm.euinName,euinNameCode: rawData.purchaseForm.euinName+"-"+rawData.purchaseForm.euinCode};
              vm.formData.isThroughDistributor = true;
              vm.formData.isThroughRia = false;
              vm.formData.isDirect = false;
              vm.formData.euinInput = rawData.purchaseForm.euinName + ' - ' + rawData.purchaseForm.euinCode;
            }
            if (rawData.purchaseForm.riaOpted || rawData.purchaseForm.riaConsent) {
              vm.formData.isThroughDistributor = false;
              vm.formData.isThroughRia = true;
              vm.formData.isDirect = false;
              vm.isArnSuccess = false;
              vm.formData.riaBrokerCode = rawData.purchaseForm.brokerCode;
              vm.riaConsent = rawData.purchaseForm.riaConsent;
              vm.isCheckedTandC = rawData.purchaseForm.riaConsent;
              vm.searchDistributor();
            }
            if (rawData.purchaseForm.brokerCode && !rawData.purchaseForm.riaOpted && !rawData.purchaseForm.riaConsent) {
              vm.formData.brokerCode = rawData.purchaseForm.brokerCode.replace('ARN-', '');
              vm.formData.isThroughDistributor = true;
              vm.searchDistributor();
            }

            fetchPurchaseInSchemes(function () {
              var scheme = vm.purchaseInSchemeList && vm.purchaseInSchemeList.find(function (item) {
                if(vm.formData.purchaseInSchemeCode === item.schemeCode){
                  return item;
                }
              }) || {};
              vm.formData.purchaseInSchemeName = scheme.scheme || '';
              vm.formData.fundCode = scheme.fundCode || '';
              if (vm.formData.purchaseInSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && scheme.retirementFlag) {
                MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
                vm.formData.purchaseInSchemeCode = '';
                vm.formData.purchaseInSchemeName = '';
                vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
                return;
              }
              fetchPurchaseValidations(function (err) {
                if (!err) {
                  vm.formData.purchaseDividendOption = rawData.purchaseForm.dividendOption;
                  if (vm.formData.fromPaymentPage) {
                    vm.summaryData = angular.copy(rawData.purchaseForm);
                    vm.formData.isSummaryViewEnabled = true;
                    $window.localStorage.removeItem("SummaryEnabled");
                  }
                }
              });
            });
          }
          if (rawData.sipForm) {
            if (rawData.sipForm.sipWithFirstInstallment) {
              vm.isFIenabled = angular.copy(rawData.sipForm.sipWithFirstInstallment);
            } else if (rawData.sipForm.sipFirstInstallment) {
              vm.isFIenabled = angular.copy(rawData.sipForm.sipFirstInstallment);
            } else {
              vm.isFIenabled = false;
            }

            vm.investementOption = angular.copy(rawData.sipForm.dividendOption);
            vm.validations = vm.validations ? vm.validations : {};
            vm.formData.sTransactionId = rawData.sipForm.id;
            vm.formData.folioNumber = rawData.sipForm.folioNumber;
            if (vm.folioList.length !== 0) {
              var selectedFolioObj = vm.folioList.filter(function (row) {              // for investor's name initialisation
                return row.folioNumber == vm.formData.folioNumber
              })[0];
              if(selectedFolioObj) {
                vm.selectedFolioData = selectedFolioObj;
                vm.formData.corporateInvestor = selectedFolioObj && angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
              }
              vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
              vm.formData.minorFlag = vm.folioMinor;
            }
            fetchInvestorType();

            if (rawData.sipForm.euinOpted === 'Y') {
              if(rawData.sipForm.subBrokerArn) {
                vm.formData.subBrokerARN = rawData.sipForm.subBrokerArn.replace('ARN-', '');
                vm.fetchEuinListSubBroker();
              }
              vm.formData.subBrokerCode = rawData.sipForm.subBrokerCode ? rawData.sipForm.subBrokerCode : '';
              vm.euinData = {
                euinName: rawData.sipForm.euinName,
                euinCode: rawData.sipForm.euinCode,
                euinNameCode: rawData.sipForm.euinName+'-'+rawData.sipForm.euinCode
              };
              vm.formData.euin = vm.euinData;
            }
            if (rawData.sipForm.riaOpted || rawData.sipForm.riaConsent) {
              vm.formData.isThroughDistributor = false;
              vm.formData.isThroughRia = true;
              vm.formData.isDirect = false;
              vm.isArnSuccess = false;
              vm.formData.riaBrokerCode = rawData.sipForm.brokerCode;
              vm.riaConsent = rawData.sipForm.riaConsent;
              vm.isCheckedTandC = rawData.sipForm.riaConsent;
              vm.searchDistributor();
            }
            if (rawData.sipForm.brokerCode && !rawData.sipForm.riaOpted && !rawData.sipForm.riaConsent) {
              vm.formData.brokerCode = rawData.sipForm.brokerCode.replace('ARN-', '');
              vm.formData.isThroughDistributor = true;
              vm.formData.isThroughRia = false;
              vm.formData.isDirect = false;
              vm.formData.euinInput = rawData.sipForm.euinName + ' - ' + rawData.sipForm.euinCode;
              vm.searchDistributor();   // it will show the name of distributor based on broker code (ARN)
            }

            vm.formData.amount = rawData.sipForm.installmentAmount;
            vm.formData.inSchemeCode = rawData.sipForm.schemeCode;
            vm.freqForSavedTrxn = rawData.sipForm.frequency;
            vm.formData.frequency = rawData.sipForm.frequency || vm.formData.frequency || vm.frequencyList[0].key;
            vm.savedFrequency = vm.formData.frequency;
            vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
            var savedStartDate = $window.moment(rawData.sipForm.sipDate,'DD-MMM-YYYY');
            var today = $window.moment();
            if (savedStartDate.isSameOrAfter($window.moment(today, "DD-MMM-YYYY HH:mm A"))) {
              vm.savedStartDate = savedStartDate;
              vm.savedEndDate =  $window.moment(rawData.sipForm.toDate,'DD-MMM-YYYY');

              if (rawData.sipForm.weeklyDay) {
                vm.savedweeklyDay = rawData.sipForm.weeklyDay;
              }
            }

            if (vm.isFIenabled && rawData.sipForm.sipPaymentOption) {
              vm.savedPaymentOption = angular.copy(rawData.sipForm.sipPaymentOption);
            }

            if (rawData.sipForm.bankDetailsForECS) {
              vm.formData.bankAcNo = rawData.sipForm.bankDetailsForECS.accNumber;
              vm.formData.bankCity = rawData.sipForm.bankDetailsForECS.bankCity;
              vm.formData.bankName = rawData.sipForm.bankDetailsForECS.bankName;
              vm.formData.bankBranch = rawData.sipForm.bankDetailsForECS.branchName;
              vm.savedAccType = rawData.sipForm.bankDetailsForECS.accType;
              vm.savedPaymentOption = angular.copy(rawData.sipForm.bankDetailsForECS.paymentOption);
              if (vm.savedPaymentOption && vm.savedPaymentOption === 'UAP') {
                vm.savedPaymentOption = 'UPI';
              }

              if (rawData.sipForm.bankDetailsForECS && rawData.sipForm.bankDetailsForECS.paymentOption === "HEM") {
                vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
                vm.changedPaymentOption();
                vm.setPaymentModeFromSave = true;
              } else if (rawData.sipForm.bankDetailsForECS && rawData.sipForm.bankDetailsForECS.paymentOption === "OTM") {
                vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
                vm.changedPaymentOption();
                vm.setPaymentModeFromSave = true;
              } else if (rawData.sipForm.bankDetailsForECS.paymentOption === "EC") {
                vm.formData.sipPaymentOption = vm.savedPaymentOption ? vm.savedPaymentOption : vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
                vm.changedPaymentOption();
                vm.setPaymentModeFromSave = true;
              } else {
                vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
                vm.changedPaymentOption();
                vm.setPaymentModeFromSave = true;
              }
            }
            if (vm.calenderEndDateString === rawData.sipForm.toDate) {
              vm.formData.isTillPerpetuity = true;
            }

            if (rawData.sipForm.primaryFlag) {
              vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP;
            }

            // vm.formData.sipPaymentOption = 'EC';   // hard coded to be removed

            if (rawData.purchaseForm && rawData.sipForm) {
              vm.formData.optionalInvestmentType = 'SIP';

              if (vm.formData.investmentType === 'SIP') {
                vm.formData.optionalInvestmentType = 'PURCHASE';
              }
            }

            fetchInSchemes(function () {
              vm.formData.inSchemeCode = rawData.sipForm.schemeCode;
              var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                return vm.formData.inSchemeCode === item.schemeCode;
              }) || {};
              vm.formData.inSchemeName = scheme.scheme || '';
              vm.formData.amount = rawData.sipForm.installmentAmount;
              fetchInSchemeValidations(function (err) {
                checkOTM(function () {
                  $timeout(function() {
                    if (success && rawData.sipForm.bankDetailsForECS && rawData.sipForm.bankDetailsForECS.paymentOption === "OTM"){
                      vm.formData.bankInfo = vm.OTMbankList && vm.OTMbankList.find(function (bank) {
                        return bank.payoutId === rawData.sipForm.bankDetailsForECS.payoutId
                      })
                      vm.isfromSaved = true;
                      vm.changeBank();
                      if (vm.formData.bankInfo && !vm.formData.bankInfo.ifscCode) {
                        vm.formData.ifscCode = rawData.sipForm.bankDetailsForECS.ifscCode;
                      }

                    }
                  })
                });
                checkEMandate(function () {
                  if (err != 'error') {
                  vm.formData.sipDividendOption =  vm.investementOption ? angular.copy(vm.investementOption) : vm.formData.sipDividendOption ? vm.formData.sipDividendOption : null;
                  if (vm.investementOption) {
                    vm.validations.investmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[rawData.sipForm.investmentOption];
                  }
                  changeFrequency();
                  //vm.changeDay();
                  checkValidations();
                  fetchBankList();

                  $timeout(function() {
                    if (rawData.sipForm.bankDetailsForECS && rawData.sipForm.bankDetailsForECS.paymentOption === "HEM") {
                      vm.formData.bankInfo = vm.EMbankList && vm.EMbankList.find(function (bank) {
                        return bank.accountNumber === rawData.sipForm.bankDetailsForECS.accNumber
                      })
                      vm.isfromSaved = true;
                      vm.changeBank();
                    }
                  })
                  // updateEndDates();
                  // vm.formData.isBackFromSummary = false;
                    vm.savedSIPFI = vm.isFIenabled;
                    if(vm.isFIenabled) {
                    vm.sipFirstInstallment=true;
                    vm.formData.sipFirstInstallment=true;
                    vm.formData.sipFirstAmount=rawData.sipForm.installmentAmount;
                  } else {
                    vm.sipFirstInstallment=false;
                    vm.formData.sipFirstInstallment=false;
                  }
                }
                });
              });
            });

            fetchBankList(function (success) {
              var bankDetails;
              if (success){
                $timeout(function() {
                  bankDetails = vm.bankList && vm.bankList.find(function (item) {
                    // return i.bankCode === rawData.bankCode;
                    return item === rawData.sipForm.bankDetailsForECS;
                  }) || {};

                  var savedSelectedBank = vm.bankList && vm.bankList.find(function (bank) {
                    return bank.accountNumber === rawData.sipForm.bankDetailsForECS.accNumber;
                  })

                  vm.formData.bankInfo = savedSelectedBank;
                  vm.changeBank();

                  if (rawData.sipForm.bankDetailsForECS && rawData.sipForm.bankDetailsForECS.paymentOption === "EC") {
                    vm.formData.bankInfo = vm.bankList && vm.bankList.find(function (bank) {
                      return bank.accountNumber === rawData.sipForm.bankDetailsForECS.accNumber
                    })
                    vm.isfromSaved = true;
                    vm.changeBank();
                    if (vm.formData.bankInfo && !vm.formData.bankInfo.ifscCode) {
                      vm.formData.ifscCode = rawData.sipForm.bankDetailsForECS.ifscCode;
                    }

                  }
                });
                // angular.isDefined(vm.formData.bankInfo) && angular.isDefined(vm.formData.bankInfo.bankName) && (vm.formData.bankInfo.bankName = vm.formData.bankInfo.bankName || '');
                var savedSelectedBank = vm.bankList && vm.bankList.find(function (bank) {
                  return bank.accountNumber === rawData.sipForm.bankDetailsForECS.accNumber;
                })

                vm.formData.bankInfo = savedSelectedBank;
                vm.changeBank();
                angular.isDefined(vm.formData.bankInfo) && angular.isDefined(vm.formData.bankInfo.bankName) && (vm.formData.bankInfo.bankName = bankDetails && bankDetails.bankName || '');


                if ((rawData.sipForm.riaOpted || rawData.sipForm.riaConsent) && !vm.formData.riaBrokerCode) {
                  vm.formData.riaBrokerCode = rawData.sipForm.brokerCode;
                  vm.riaConsent = rawData.sipForm.riaConsent;
                  vm.isCheckedTandC = rawData.sipForm.riaConsent;
                  vm.searchDistributor();
                }

              }

            });

          }
          vm.formData.isBackFromSummary = false;
        }
        /*if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) getDateValidation();*/
      })
    }

    vm.init = function () {
      if($window.localStorage.getItem("SummaryEnabled")){
        vm.modifiedSipDetails = true;
      }
      vm.backFromPayment=false;
      $state.$previous = null;
      if ($stateParams.trackId && !vm.formData.isBackFromSummary) {
        showPrefillValuesUserTracker();
      }else if (!vm.formData.isBackFromSummary) {
        TransactionModel.setPayloadRawData(null);
      }
      if (vm.formData.isBackFromSummary || $stateParams.sc) {
        vm.isArnSuccess = false;
        vm.showArnLabel = vm.formData.brokerCode ? true : false;
        resetTopupDetails();
        vm.formData.isThroughDistributor = false;
        vm.formData.amount = null;
        vm.formData.showTopUpBlock = false;
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        resetBankDetails();
        showPrefillValues();
      } else if ($stateParams.transactionId && $stateParams.initiatedBy !== 'schedule') {
        getTransactionDetails();
      } else if (!$window.localStorage.getItem("SummaryEnabled") && (vm.formData.isBackFromSummary || $stateParams.action == 'modify')) {
        vm.formData = TransactionModel.getPayloadRawData() || JSON.parse(sessionStorage.getItem('systematicData'));
        vm.oldSipSystematicData = JSON.parse(sessionStorage.getItem('systematicData'));
        showPrefillValuesForModify();
      }else {
        fetchFolioList();
        if (vm.formData.brokerCode) {
          fetchEuinList();
        }
        vm.formData.transferOption = vm.formData.transferOption || vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;

      }
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        vm.formData.investmentType = vm.formData.investmentType || vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE;
        //vm.formData.sipPaymentOption = vm.formData.sipPaymentOption || (vm.formData.frequency == 'BZ' ? vm.paymentOptions[1] : vm.paymentOptions[0]);
      }
      if (vm.formData.frequency === 'BZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        updateDatesForDaily()
      } else if (vm.formData.frequency === 'OW') {
        vm.daysList = null;
        vm.viewMode = 'days';
        //updateDatesForWeekly();
      } else {
        // vm.daysList = getDaysList();
        vm.viewMode = 'months';
      }
      /*
      * if condition to check the url parameter for schedule transactions
      */
      if ($stateParams.initiatedBy === 'schedule') {
        getScheduleTransactionDetails();
      }
      if( $window.localStorage.getItem("SummaryEnabled")) {

        if(vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
          vm.backFromPayment=true;
          vm.formData.ifscCode = vm.formData.ifscCode ? vm.formData.ifscCode :  null;
          vm.formData.bankAcType = vm.formData.bankAcType ? vm.formData.bankAcType :  null;
        }

        fetchPurchaseValidations();
        if (vm.formData.bankInfo) {
          vm.changeBank();
          vm.changeEndDate(vm.formData.endDate);
        }
        vm.moveToSummary();
      }
      vm.frequencyList = vm.TRANSACTIONS_CONST.Dynamic_SIP_FREQ_LIST;
      sessionStorage.removeItem('setFolioInitiateState');

      if($stateParams.action == 'modify') {
        vm.oldSipSystematicDataTopUp = JSON.parse(sessionStorage.getItem('systematicData'));
      } else {
        sessionStorage.removeItem('systematicData');
      }
      $window.scrollTo(0, 0);
    };

    function getDetails() {
      var success = function (resp) {
        var bankDetails=[];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if(vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length>0){
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if(value.defaultBank===true){return value;}
          });
        }
        localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
      }, error = function () {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }

    vm.checkPurchaseValidations = function () {
      if (vm.purchaseValidations) {

        if (!vm.purchaseValidations.addlPurchase) {
          vm.isPurchaseMin = vm.purchaseValidations.minFirstPurchaseAmt > vm.formData.purchaseAmount;
          vm.purchaseMinAmount = vm.purchaseValidations.minFirstPurchaseAmt;
        } else {
          vm.isPurchaseMin = vm.purchaseValidations.minAddlPurchaseAmt > vm.formData.purchaseAmount;
          vm.purchaseMinAmount = vm.purchaseValidations.minAddlPurchaseAmt;
        }
        vm.isMultiples = vm.purchaseValidations.purchaseMultiple && vm.formData.purchaseAmount && (vm.formData.purchaseAmount % vm.purchaseValidations.purchaseMultiple === 0) || false;
        if(vm.formData.purchaseAmount%1 != 0){
          vm.isPurchaseAmountDecimal = true;
        }
        else{
          vm.isPurchaseAmountDecimal = false;
        }
      }
    };

    vm.confirmCancel = function () {
      var success = function () {
        $state.go('welcome')
      };
      ModalService.confirmCancelModal({}, success);
    };

    vm.folioChanged = function () {
      if(vm.tForm.sAmount){
        vm.tForm.sAmount.$setPristine(true);
      }
      if(!vm.formData.folioNumber){return;}
      var successHandler = function(resp) {
        LoaderService.hideLoader();
        var oldData = angular.copy(vm.formData);
        resetAll();
        recoverFromResetting(oldData);
        vm.isEmailMobileinValid = false;
        vm.isEmailinValid = false;
        vm.isMobileinValid = false;
        vm.emandateDisplay = true;
        vm.isfromSaved = false;
        var selectedFolioObj = vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        if(selectedFolioObj) {
          vm.selectedFolioData = selectedFolioObj;
        }
        vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
        vm.formData.minorFlag = vm.folioMinor;
        vm.formData.corporateInvestor = selectedFolioObj && angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
          // if(vm.formData.minorFlag){
        //   if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)
        //     ModalService.minorPurchaseModal({});
        //   else
        //     ModalService.minorSipModal({});
        // }
        vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName : '';
        vm.selectedFolioEmail = selectedFolioObj.email;
        vm.selectedFolioMobile = selectedFolioObj.mobileNumber;
        vm.transactionType = vm.formData.investmentType;
        fetchPreviousTrSelectedDistrubutor(function () {
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
            vm.formData.purchaseInSchemeCode = '';
            vm.formData.purchaseInSchemeName = '';
            userActivityTracking(function(resp) {
              var data = vm.formData;
              data.deeplink = resp.trxnUniqueLink;
              NetcoreEvntService.click_Transact_Purchase(data);
            });
            fetchPurchaseInSchemes();
          } else {
            vm.formData.inSchemeCode = '';
            vm.formData.inSchemeName = '';
            userActivityTracking(function(resp) {
              var data = vm.formData;
              data.deeplink = resp.trxnUniqueLink;
              NetcoreEvntService.click_Transact_Sip(data);
            });
            fetchInSchemes();
            checkOTM(function (success) {
              if (success) {
                changedPaymentOption();
              }
            })
          }
        });
        if (vm.selectedFolioMobile === null || vm.selectedFolioMobile === '') {
          if (vm.selectedFolioEmail === null || vm.selectedFolioEmail === '') {
            vm.isEmailMobileinValid = true;
            vm.emandateDisplay = false;
          } else {
            vm.isMobileinValid = true;
            vm.emandateDisplay = false;
          }
        } else if (vm.selectedFolioEmail === null || vm.selectedFolioEmail === '') {
          if (vm.selectedFolioMobile === null || vm.selectedFolioMobile === '') {
            vm.isEmailMobileinValid = true;
            vm.emandateDisplay = false;
          } else {
            vm.isEmailinValid = true;
            vm.emandateDisplay = false;
          }
        }
        if (vm.formData.folioNumber) {
          fetchInvestorType();
        }
      }

      var errorHandler = function(resp)
      {
        LoaderService.hideLoader();
        vm.formData.folioNumber=null;
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);
    };

    function checkEMandate(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
        LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.isEMandateEnabled = resp.data.folioEmandateStatus;
            if ((resp.data.bankList && resp.data.bankList.length == 0) || !vm.isEMandateEnabled) {
              // vm.isEMandateEnabled = false;
              vm.EMbankList = null;
              var index = vm.paymentOptions.indexOf('E-mandate');
              if(index > -1) {
                vm.paymentOptions.splice(index,1);
              }

              if(vm.formData.sipPaymentOption === 'E-mandate') {
                vm.formData.sipPaymentOption = null;
              }
              // if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
              //   vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
              // }

              if (!vm.formData.sipPaymentOption) {
                vm.formData.sipPaymentOption = vm.paymentOptions[0];
              }

              if (vm.paymentOptions.includes("OTM") && !vm.isOTMEnabled) {
                var index = vm.paymentOptions.indexOf('OTM');
                if (index > -1) {
                  vm.paymentOptions.splice(index, 1);
                }
              }
              if(vm.inSchemeValidations.cgfFlag && vm.formData.frequency !== 'OW' && vm.formData.frequency !== 'BZ') {
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                hideUPIDetails();
                if (!vm.setPaymentModeFromSave) {
                  vm.formData.sipPaymentOption = vm.paymentOptions[0];
                  changedPaymentOption();
                }
              }
            }
            else{
              if(vm.sipFirstInstallment)
              {
                vm.isEMandateEnabled = false;
              }
              else {
                vm.EMbankList = resp.data.bankList;
                // vm.isEMandateEnabled = true;
              }
            }
          }
          cb(true);
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };
      var data = {
        trnxType: 'SIP',
        liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false,
        folioNumber:vm.formData.folioNumber
      };
      InvestorService.post({
        child1: 'folio',
        child2: 'emandate'
      }, data).$promise.then(success, error);
    }

    vm.enabledOTMStartDatesList = [];
    vm.enabledBillerStartDatesList = [];
    function getDateValidation(cb) {
      cb = cb || function () {};
      var success = function (resp) {
          if (resp.status && resp.data) {
            var currentDate = resp.data.currentDate || Date();
            vm.daysList = resp.data.listOfDays;
            var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
            var todayDate = $window.moment(Date.parse(parsedDate));
            var counter =0;
            vm.nonBusinessDatess = resp.data.nonBuisnessDates;
            vm.startMinDateBiller = null;
            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              if (!vm.emandateObj) {
                  UtilService.fetchMandateValidations().then(function (resp) {
                    vm.emandateObj = resp.eOTM;
                    if (vm.emandateObj) {
                      setEmandateUpiSetting(parsedDate);
                    }
                  }).catch(function(resp) {
                    MessageService.error(resp)
                  });
              } else {
                vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
              }
            }else if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC){
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.inSchemeValidations && vm.inSchemeValidations.sipTDay, 'days');
            }else {
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(11, 'days');
            }
            // vm.startMinDateEMandate= $window.moment(Date.parse(parsedDate)).add(7,'days');
            /* if (HDFC_API.ENV === 'prod' || HDFC_API.ENV === 'beta') {
              vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
            } */
            vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days').add(1, 'minutes');
            var startDate = todayDate.clone();
            var freq = vm.startMaxDate.diff(todayDate, 'days');
            for (var i = 0; i <= freq; i++) {
              var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
              var isEnable = true;
              if(counter<5)
              {
                angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                  if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')===0){
                    isEnable = false;
                  }
                });
              }
              if(isEnable){
                vm.enabledOTMStartDatesList.push(startDate.clone().add(i, 'days'));
                counter++;
              }
            }

            vm.startMinDateOTM = vm.enabledOTMStartDatesList[5];
            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              vm.startMinDateBiller = vm.enabledOTMStartDatesList[vm.eMandatenoOfDays];
              vm.enabledBillerStartDatesList = vm.enabledOTMStartDatesList;
            }
            if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
              vm.startMinDateBiller = angular.copy(vm.startMinDateOTM);
            }

            var enabledFirstStartDate = null;
            if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM || vm.formData.frequency === 'OW') {
              enabledFirstStartDate = angular.copy(vm.startMinDateOTM);
            } else {
              enabledFirstStartDate = angular.copy(vm.startMinDateBiller);
            }
            if(vm.enabledOTMStartDatesList.length > 0 && vm.formData.frequency !== 'OW'){
              if ($stateParams.transactionId && $stateParams.initiatedBy !== 'schedule' && vm.savedStartDate) {
                if (enabledFirstStartDate) {
                  if (vm.savedStartDate.isSameOrAfter($window.moment(enabledFirstStartDate, "DD-MMM-YYYY HH:mm A"))) {
                    vm.formData.startDate = vm.savedStartDate;
                  } else {
                    vm.savedStartDate = null;
                    vm.savedEndDate = null;
                    vm.formData.startDate = vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM || vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE ? angular.copy(vm.startMinDateOTM) : angular.copy(vm.startMinDateBiller);
                    vm.formData.isTillPerpetuity = true;
                  }
                }
              } else {
                if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM || vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
                  vm.formData.startDate = angular.copy(vm.startMinDateOTM);
                } else {
                  vm.formData.startDate = angular.copy(vm.startMinDateBiller);
                }
                vm.formData.isTillPerpetuity = true;
              }
              updateEndDates();
            } else if (vm.enabledOTMStartDatesList.length > 0 && vm.formData.frequency === 'OW') {
              if (enabledFirstStartDate) {
                if ($stateParams.transactionId && $stateParams.initiatedBy !== 'schedule' && vm.savedStartDate && vm.savedStartDate.isSameOrAfter($window.moment(enabledFirstStartDate, "DD-MMM-YYYY HH:mm A"))) {
                  vm.formData.weeklyDay = vm.savedweeklyDay;
                  vm.changeDay();
                } else  {
                  vm.savedweeklyDay = null;
                  vm.savedStartDate = null;
                  vm.savedEndDate = null;
                }
              }
            }

            vm.isReseting = true;
            $timeout(function () {
              vm.isReseting = false;
            });
            cb(true);
          } else {
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb(false);
        };
      InvestorService.get({
        child1: 'nonBusinessDate',
        schemeCode: vm.formData.inSchemeCode //'AFWDQ'
      }).$promise.then(success, error);
    }


    function fetchPreviousTrSelectedDistrubutor(cb) {

      cb = cb || function () {
      };
      if (!vm.formData.folioNumber) {
        resetAll();
        cb(true);
      }else if(vm.formData.isBackFromSummary){cb(true);}
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var distributorDetails = resp.data;
            if (distributorDetails.investThroughDistributor
              && distributorDetails.previousDistributorDetails.brokerCode.indexOf('ARN-') === 0) {
              var brokerCode = distributorDetails.previousDistributorDetails.brokerCode
                ? distributorDetails.previousDistributorDetails.brokerCode.split('-') : [];
              vm.formData.brokerCode = brokerCode.length > 0 ? brokerCode[1] : '';
              manipulateInvestThrough(AppConstants.INVEST_THROUGH.DISTRIBUTOR);
              vm.formData.brokerName = distributorDetails.previousDistributorDetails.brokerName;
              var subBrokerArn = distributorDetails.previousDistributorDetails.subBrokerArn;
              var subBrokerARNArray = subBrokerArn ? subBrokerArn.split('-') : [];
              vm.formData.subBrokerARN = subBrokerARNArray ? subBrokerARNArray[1] : '';
              vm.formData.subBrokerCode = distributorDetails.previousDistributorDetails.subBrokerCode;
              vm.subBrokerName = distributorDetails.previousDistributorDetails.subBrokerName;
              vm.euinMasterList = distributorDetails.previousDistributorDetails.euinDetailList;
              vm.euinList = vm.euinMasterList;
              vm.formData.euin = vm.euinList.length === 1 ? vm.euinList[0] : null;
              vm.formData.euin = distributorDetails.previousDistributorDetails.euinPreviousUsed ? vm.euinList[0] : null;
              vm.euinData = vm.formData.euin ? vm.formData.euin : {};
              if (vm.euinData) {
                vm.euinData.euinNameCode = vm.formData.euin ? vm.formData.euin.euinNameCode : null;
              }
              vm.isCheckedTandC = false;
              vm.isArnSuccess = false;
              vm.showArnLabel = false;
            } else if (distributorDetails.investThroughRIA) {
              vm.formData.riaBrokerCode = distributorDetails.previousDistributorDetails.brokerCode ?
                distributorDetails.previousDistributorDetails.brokerCode : "";
              vm.formData.riaBrokerName = distributorDetails.previousDistributorDetails.brokerName;
              vm.isArnSuccess = false;
              vm.showArnLabel = false;
              vm.riaCodeError = "";
              manipulateInvestThrough(AppConstants.INVEST_THROUGH.RIA);
            } else if($stateParams.action == 'modify'){
              vm.investThroughFromModify();
            } else {
              manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
              (angular.isUndefined($stateParams.sc)) && !vm.checkTransactionID && resetAll();
            }
            cb(true);
          } else {
            //vm.folioList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
         LoaderService.hideLoader();
          //vm.folioList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      var payload = {
        folioNo:vm.formData.folioNumber
      };

      if ($stateParams.sc) {
        payload.schemeCode = $stateParams.sc;
      }
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'folio',
        child2: 'status',
        child3: 'previous',
        child4: 'transaction'
      },payload).$promise.then(success, error);
    }

    function recoverFromResetting(oldData) {
      if (vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP) {
        vm.formData.transferOption = oldData.transferOption;
      }
    }

    vm.schemeListModal = function () {
      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
          MessageService.error('No free available units');
          return;
        }
        var successSchemeList = function (result) {
            vm.savedweeklyDay = null;
            vm.savedStartDate = null;
            vm.savedEndDate = null;
            vm.renewDetails = {};
          vm.inSchemeChanged(result);
        },
        errorSchemeList = function () {
            vm.formData.inSchemeCode = '';
            vm.formData.inSchemeName = '';
            vm.formData.startDate = null;
            vm.formData.endDate = null;
            vm.savedweeklyDay = null;
            vm.savedStartDate = null;
            vm.savedEndDate = null;
            vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
          };

        var isFlexStp = false;

        ModalService.schemeListModal({
          enabledScheme: 'sipenabled',
          isMinor: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
          isFlexStp: isFlexStp,
          isThroughDistributor: vm.formData.isThroughDistributor,
          corporateFlag : vm.formData.corporateInvestor
        }, successSchemeList, errorSchemeList);

      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);

    };

    vm.purchaseSchemeListModal = function () {
      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        vm.formData.purchaseAmount = null;
        var successSchemeList = function (result) {
            vm.formData.purchaseInSchemeCode = result.schemeCode;
            vm.formData.purchaseInSchemeName = result.scheme;
            vm.formData.schemeType = result.schemeType;
            vm.formData.fundCode = result.fundCode || '';
            if (result.nfoEnabled == 'Y') {
              vm.nfoEnabled = true;
            } else {
              vm.nfoEnabled = false;
            }
            if (vm.formData.purchaseInSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && result.retirementFlag) {
              MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
              vm.formData.purchaseInSchemeCode = '';
              vm.formData.purchaseInSchemeName = '';
              vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
              return;
            }
            fetchPurchaseValidations();
            vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
            //NetcoreEvntService.Complete_Selected_Scheme_Purchase_IP(vm.formData);
            userActivityTracking(function(resp) {
              var data = vm.formData;
              data.deeplink = resp.trxnUniqueLink;
              NetcoreEvntService.scheme_Selected(data);
            });
            resetNumInWords();
          },
          errorSchemeList = function () {
            vm.formData.purchaseInSchemeCode = '';
            vm.formData.purchaseInSchemeName = '';
            vm.purchaseValidations = null;
            vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
          };
        ModalService.schemeListModal({
          enabledScheme: 'purchaseenabled',
          isMinor: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
          isThroughDistributor: vm.formData.isThroughDistributor,
          corporateFlag : vm.formData.corporateInvestor
        }, successSchemeList, errorSchemeList);
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);


    };

    vm.outSchemeChanged = function () {
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.amount = null;
      vm.formData.units = '';
      vm.formData.amountType = 'amount';
      if (vm.transactionType != vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION) {
        vm.formData.bankInfo = null;
        vm.bankList = null;
      }
      vm.unitsDetails = null;
      vm.formData.dividendOption = '';
      vm.formData.frequency = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.day = '';
      vm.formData.weeklyDay = null;
      vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;

      if (!vm.formData.outSchemeCode) {
        vm.formData.outSchemeName = '';
        return;
      }

      var scheme = vm.outSchemeList.find(function (item) {
        return item.schemeCode === vm.formData.outSchemeCode;
      }) || {};
      vm.formData.outSchemeName = scheme.schemeName || '';

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION) {
        vm.helper.setInstantRedSchemeValidations(scheme);
      }
      else {
        if (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP) {
          fetchOutSchemeValidations();
          fetchUnitDetails();
        }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
          fetchBankList();
        }
      }
    };

    vm.filterInSchemeList = function () {
      vm.formData.inSchemeCode = '';
      vm.authenticationMode = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
      vm.isfromSaved = false;
      vm.savedweeklyDay = null;
      vm.savedStartDate = null;
      vm.savedEndDate = null;
      vm.renewDetails = {};
      resetNumInWords();
    };

    vm.filterPurchaseInSchemeList = function () {
      vm.formData.purchaseInSchemeCode = '';
      vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
      resetNumInWords();
    };

    function fetchSwitchInSchemes(cb) {
      if (vm.formData.isAutoSwitch) {
        cb = cb || function () {
        };

        var success = function (resp) {
            if (resp.status && resp.data) {
              vm.masterInSchemeList = resp.data.schemeList;
              vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
              if (!vm.formData.inSchemeName) {
                for (var i in vm.inSchemeList) {
                  if (vm.inSchemeList[i].schemeCode == 'LFGTN') {
                    vm.formData.inSchemeName = vm.inSchemeList[i].scheme;
                    vm.formData.inSchemeCode = vm.inSchemeList[i].schemeCode;
                    vm.isInScheme = !!(vm.selectedInScheme);
                    //vm.inSchemeChanged(vm.inSchemes[i])
                    if (vm.inSchemeList[i].schemeType == 'ELSS' && vm.inSchemeList[i].scheme.toLowerCase().includes('dividend')) {
                      vm.formData.switchDividentOption = AppConstants.TRANSACTIONS.DIVIDEND_OPTIONS.PAYOUT;
                    }
                    fetchInSchemeValidations();
                  }
                }
              }
              cb(true);
            } else {
              vm.masterInSchemeList = null;
              MessageService.error(resp.message);
              cb(false);
            }
          },
          error = function (err) {
            vm.masterInSchemeList = null;
            UtilService.errorHandler(err);
            cb(false);
          };
        var _config = {
          controller: 'scheme',
          type: 'ALL',
          child1: 'autoSwitchenabled',
          child2: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
          child3: vm.formData.isThroughDistributor
        };

        SchemeService.get(_config, null).$promise.then(success, error);
      }
    }

    vm.purchaseInSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.formData.purchaseInSchemeCode = schemeData.schemeCode;
        vm.formData.purchaseInSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        vm.formData.fundCode = schemeData.fundCode;
        if (schemeData.nfoEnabled == 'Y') {
          vm.nfoEnabled = true;
        } else {
          vm.nfoEnabled = false;
        }
        if (vm.formData.purchaseInSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.purchaseInSchemeCode = '';
          vm.formData.purchaseInSchemeName = '';
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
          return;
        }
        vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
        fetchPurchaseValidations();
      }
      //NetcoreEvntService.Complete_Selected_Scheme_Purchase_IP(vm.formData);
      userActivityTracking(function(resp) {
        var data = vm.formData;
        data.deeplink = resp.trxnUniqueLink;
        NetcoreEvntService.scheme_Selected(data);
      });
      vm.formData.purchaseAmount = null;
    };

    vm.uploadRetirementProofFile = function (file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.formData.retirementAgeProofURL = resp.data.fileUrl;

                vm.breakFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            InvestorFileUploadService.post({
              child1: 'transaction',
              child2: 'retirement',
              child3: 'ageProof',
              child4: 'upload'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    };

    vm.breakFileUrl = function (url) {

      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1 || url.split('_jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1 || url.split('_png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1 || url.split('_pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1 || url.split('_bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      vm.retirementAgeProofURL = a[a.length - 1] + extension;
      vm.chooseAFile = false;

    };

    vm.inSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        if (vm.formData.inSchemeCode !== schemeData.schemeCode) { //block responsible to reset all values if scheme code doesn't match
          vm.formData.startDate = null;
          vm.formData.endDate = null;
          vm.formData.day = '';
          vm.formData.bankInfo = null;
          //vm.formData.frequency = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? vm.frequencyList[0].key : null;
          vm.enabledStartDates = null;
          vm.enabledEndDates = null;
          vm.formData.amount = null;
          vm.formData.sipFirstAmount = '';
          vm.formData.units = '';
          vm.formData.amountType = 'amount';
          vm.formData.isTillPerpetuity = false;
          vm.formData.showTopUpBlock = false;
          vm.formData.sipTopupEnabled = false;
          vm.disableEndDateSelection = false;
          vm.formData.weeklyDay = null;
          vm.backFromPayment=false;
          vm.formData.sipFirstInstallment =false;
          vm.sipFirstInstallment=false;
          vm.AmountFromModify = null;
          vm.oldAmount = null;
          resetTopupDetails();
          // changeSipTopupSelected(false);
          reSetting();
          resetDefaults();
          resetNumInWords();
        }

        if(!vm.backFromPayment)
          vm.formData.sipDividendOption = null;

        vm.formData.inSchemeCode = schemeData.schemeCode;
        vm.formData.inSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        vm.formData.fundCode = schemeData.fundCode;
        if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.formData.frequency = null;
          vm.frequencyList = [];
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
          return;
        }
        vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
        checkEMandate(function () {
        });
        fetchInSchemeValidations(function () {
          vm.validations.investmentOption = vm.validations.investmentOption;
          if (!vm.formData.amount) {
            vm.formData.amount = vm.validations.sipDefaultAmount;
          }
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
             /*getDateValidation();*/
             if(schemeData.schemeType === 'NFO') {
               var message = schemeData.message;
               ModalService.nfoEnabledModal({message: message});
             }
             checkEMandate();
          }
          if(vm.checkForMinorBankListCondition()) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            hideUPIDetails();
            if(vm.isOTMEnabled){
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
            }
            else {
              vm.formData.sipPaymentOption = null;
            }
            getDetails();
          }
          else if(vm.isOTMEnabled || !vm.checkForMinorBankListCondition()) {
            if(vm.formData.frequency === 'BZ' || vm.formData.frequency === 'OW')
              if(vm.isOTMEnabled)  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
              else  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            else
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            hideUPIDetails();
            if (!vm.formData.sipPaymentOption) {
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
            }
            checkEMandate();
          }
          else {
            vm.formData.sipPaymentOption = null;
            vm.paymentOptions = [];
          }
          changedPaymentOption();
          checkValidations();
          if (vm.formData.bankInfo) {
            if (!vm.isfromSaved) {
              vm.changeBank();
            }
            updateEndDates();
            vm.changeEndDate(vm.formData.endDate);
          }
        });
      }
      if($stateParams.action == 'modify'){
        vm.checkModifySipDetails();
        vm.compareDataFromSystematic();
      }
      //NetcoreEvntService.Complete_Selected_Scheme_SIP_IP(vm.formData);
      userActivityTracking(function(resp) {
        var data = vm.formData;
        data.deeplink = resp.trxnUniqueLink;
        NetcoreEvntService.scheme_Selected_Sip(data);
      });
    };

    vm.amountTypeChanged = function () {
      if (vm.formData.amountType === 'amount') {
        vm.formData.units = '';
      } else if (vm.formData.amountType === 'all_units') {
        vm.formData.amount = null;
        vm.formData.units = +vm.unitsDetails.freeValueUnits.toFixed(2);
        checkValidations();
      } else {
        vm.formData.amount = null;
        vm.formData.units = '';
      }
    };

    vm.transferOptionChanged = function () {
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.day = '';
      vm.formData.weeklyDay = null;
      vm.formData.amount = null;
      vm.formData.frequency = null;
      vm.formData.bankInfo = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
    };
    vm.changeDay = function () {
      vm.disableEndDateSelection = false;
      if (!vm.formData.frequency || (!vm.formData.day && !vm.formData.weeklyDay && (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP))) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        reSetting();
        return;
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.month = '';
        vm.formData.enabledEndDates = [];
      }

      if (vm.formData.weeklyDay !== vm.savedweeklyDay) {
        vm.savedStartDate = null;
        vm.savedEndDate = null;
        vm.savedweeklyDay = null;
        vm.formData.startDate = null;
        vm.formData.endDate = null;
      }

      switch (vm.formData.frequency) {
        case 'BZ':
          reSetting();
          break;
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default :
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          reSetting();
          break;
      }
    };

    vm.changeStartDate = function (date,calledFromAmountChanged) {
      vm.formData.startDate = date ? date : null;
      if (date && vm.savedStartDate) {
        var isSameDate = date.isSame($window.moment(vm.savedStartDate,"DD-MMM-YYYY HH:mm A"));
        if (!isSameDate) {
          vm.savedStartDate = null;
          vm.savedEndDate = null;
        }
      }
      vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
      // vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = false;
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      });
      checkOTMAmountAndDate();
      if (calledFromAmountChanged) {
        updateEndDates(false,true);
      } else {
        updateEndDates();
      }
      vm.compareDataFromSystematic();
    };

    vm.changeEndDate = function (date,calledFromOtherFlow) {
      if (date && vm.endDateDefaultForPertuity) {
        if(vm.endDateDefaultForPertuity.isSame($window.moment(date))){
          vm.formData.isTillPerpetuity = true;
        } else {
          vm.formData.isTillPerpetuity = false;
        }
      }
      vm.formData.sipTopupSelected = vm.formData.sipTopupSelected ? vm.formData.sipTopupSelected : false;
      vm.formData.sipTopupEnabled = vm.formData.sipTopupEnabled ? vm.formData.sipTopupEnabled : false;
      vm.formData.endDate = date ? date : null;
      vm.diffInMonths = parseInt($window.moment(vm.formData.endDate).diff($window.moment(vm.formData.startDate), 'months', true));
      vm.formData.topupDetails.diffInMonths = vm.diffInMonths;
      if(vm.formData.sipPaymentOption!=vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
        if (!vm.diffInMonths ? false : vm.diffInMonths >= 6 && 'BZ' !== vm.formData.frequency && 'OW' !== vm.formData.frequency && 'H'!== vm.formData.frequency && 'Y'!== vm.formData.frequency) {
        vm.formData.showTopUpBlock = true;
        if(vm.diffInMonths >= 12){
          var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
          // var capStartDateValue = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
        }
        else{
          capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
          // capStartDateValue = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
          if(vm.formData.frequency === 'Q'){
            vm.formData.showTopUpBlock = false;
            vm.formData.sipTopupSelected = false;
            vm.formData.sipTopupEnabled = false;
          }
        }

        vm.capDates = [];
        var capLastDate = capStartDate;
          while ($window.moment(capLastDate,"MMM-YYYY").isBefore($window.moment(vm.formData.endDate,"MMM-YYYY"))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(capStartDate);
          }
          // capStartDateValue = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          capStartDate = $window.moment(capStartDate, "MMM-YYYY").add(12, 'months').format("MMM-YYYY");
          if ($window.moment(capStartDate,"MMM-YYYY").isBefore($window.moment(vm.formData.endDate,"MMM-YYYY"))) {
            vm.capDates.push(capStartDate);
          }
          else {
            break;
          }
          capLastDate = vm.capDates[vm.capDates.length - 1];
        }

        if(!$window.localStorage.getItem("SummaryEnabled") && !vm.backFromPayment) {
          if ($stateParams.action == 'modify' && vm.oldSipSystematicDataTopUp.topupDetails && !vm.modifiedSipDetails && vm.oldSipSystematicDataTopUp.sipTopupEnabled) {
            vm.formData.topupDetails = angular.copy(vm.oldSipSystematicDataTopUp.topupDetails);
            vm.formData.topupDetails.capAmount = null;
            vm.formData.sipTopupEnabled = true;
            if(vm.oldSipSystematicDataTopUp.sipTopupEnabled) {
              $("#sipToptup").attr("checked", true);
            }
            changeSipTopupSelected(vm.oldSipSystematicDataTopUp.sipTopupEnabled);
            capAmountChanged();
            if(vm.formData.topupDetails){
              checkSipValidations();
            }
            if (vm.formData.topupDetails && vm.formData.topupDetails.frequency) {
              getTopupFrequencyList();
            }
            $timeout(function(){
              if(vm.formData.topupDetails.amount) {
                $window.NumToWord(vm.formData.topupDetails.amount, 'divDisplayInWords');
              }
            })

            if(vm.formData.topupDetails.capAmount) {
              $window.NumToWord(vm.formData.topupDetails.capAmount, 'capAmntDisplayInWords');
            }
          }
        }
        if($stateParams.action == 'modify' && vm.formData.sipTopupEnabled && !vm.modifiedSipDetails) {
          if (vm.validations.topupAmtMultples && !vm.isTopUpMultiples) {
            vm.isInvalidForm = true;
          } else {
            vm.isInvalidForm = false;
          }
        }
      }
        else {
          vm.formData.showTopUpBlock = false;
          vm.formData.sipTopupSelected = false;
          vm.formData.sipTopupEnabled = false;
          vm.formData.topupDetails = {};
          getTopupFrequencyList();
          if(vm.isInvalidForm && $stateParams.action == 'modify' && !vm.modifiedSipDetails){
            vm.isInvalidForm = false;
          }
        }

        if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI && vm.enabledEndDates) {
          var defaultEndDate = $window.moment().add(vm.emandateMaxYear, 'years').subtract(1,'days');
          var sipDateLessUPI =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter(defaultEndDate) ? true : false;
          if (sipDateLessUPI) {
            var setEndDateLess = false;
            var indexSipEndDate = vm.enabledEndDates.length - 1;
            var tempEndDate;
            while (!setEndDateLess) {
              tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
              indexSipEndDate = indexSipEndDate - 1;
              if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(defaultEndDate, 'DD-MMM-YYYY'))) {
                setEndDateLess = true;
                var newEnabledEndDates = angular.copy(vm.enabledEndDates);
                newEnabledEndDates.splice(indexSipEndDate + 1);
                vm.enabledEndDates = angular.copy(newEnabledEndDates);
                vm.formData.endDate = angular.copy(tempEndDate);
                vm.changeEndDate(vm.formData.endDate);
              }

              if (indexSipEndDate == 0) {
                break;
              }
            }
          }
        }

      } else if(vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
        vm.formData.showTopUpBlock = false;
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        vm.formData.topupDetails = {};
        getTopupFrequencyList();
        if(vm.formData.endDateEmandate) {
          vm.sipDateLessEmandate =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
          if (vm.sipDateLessEmandate) {
            var setEndDateLess = false;
            var indexSipEndDate = vm.enabledEndDates.length - 1;
            var tempEndDate;
            while (!setEndDateLess) {
              tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
              indexSipEndDate = indexSipEndDate - 1;
              if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY'))) {
                setEndDateLess = true;
                var newEnabledEndDates = angular.copy(vm.enabledEndDates);
                newEnabledEndDates.splice(indexSipEndDate + 1);
                vm.enabledEndDates = angular.copy(newEnabledEndDates);
                if (!calledFromOtherFlow) {
                  vm.formData.endDate = angular.copy(tempEndDate);
                  vm.changeEndDate(vm.formData.endDate);
                }
              }

              if (indexSipEndDate == 0) {
                break;
              }
            }

            if (calledFromOtherFlow) {
              var endDateField =  vm.formData.frequency === 'OW' ? angular.element('#endDateCalenderWeekly') : angular.element('#endDateCalender');
              endDateField.focus();
            }
          }
        }
      }
      (vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) && checkOTMAmountAndDate();
      vm.compareDataFromSystematic();
      if(vm.modifiedSipDetails && vm.formData.topupDetails.amount){
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        vm.formData.topupDetails = {};
        getTopupFrequencyList();
      }
    };

    function changeTopUpFreq() {
      var duration = 6;
      switch (vm.formData.topupDetails.frequency){
        case 'H':duration=6;break;
        case 'Y':duration=12;break;
      }
      if(duration === 12){
        var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
      }
      else{
        capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
      }

      vm.capDates = [];
      var capLastDate = capStartDate;
      while ($window.moment(capLastDate,"MMM-YYYY").isSameOrBefore($window.moment(vm.formData.endDate,"MMM-YYYY"))) {
        if (vm.capDates.length === 0) {
          vm.capDates.push(capStartDate);
        }
        capStartDate = $window.moment(capStartDate, "MMM-YYYY").add(duration, 'months').format("MMM-YYYY");
        if ($window.moment(capStartDate,"MMM-YYYY").isSameOrBefore($window.moment(vm.formData.endDate,"MMM-YYYY"))) {
          vm.capDates.push(capStartDate);
        }
        else {
          break;
        }
        capLastDate = vm.capDates[vm.capDates.length - 1];
      }
      vm.compareDataFromSystematic();
    };

    vm.changeInvestmentType = function () {         // specific to sip-purchase transaction only
      var folioNumber = vm.formData.folioNumber;
      var investmentType = vm.formData.investmentType;
      var sipPaymentOption = vm.formData.sipPaymentOption;
      var sTransactionId = vm.formData.sTransactionId;
      var pTransactionId = vm.formData.pTransactionId;
      vm.transactionType = investmentType;
      if (investmentType === 'SIP') {
        fetchInSchemes();
        vm.formData.sipDividendOption = vm.devidendOptionsOther[0];
      } else if (investmentType === 'PURCHASE') {
        fetchPurchaseInSchemes();
      }

      vm.formData = TransactionModel.getMasterRawData(vm.transactionType);
      vm.formData.folioNumber = folioNumber;
      vm.formData.sTransactionId = sTransactionId;
      vm.formData.pTransactionId = pTransactionId;
      vm.formData.investmentType = investmentType;
      vm.formData.sipPaymentOption = sipPaymentOption;
      $state.$previous = null;
      // vm.formData.frequency = vm.frequencyList[0].key;
      if (vm.formData && !vm.formData.isBackFromSummary) {
        TransactionModel.setPayloadRawData(null);
      }
      reSetting();
    };

    vm.changeThroughDistributor = function (investThrough) {
      vm.transactionType = vm.formData.investmentType;
      if (investThrough === 'DIRECT') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
        vm.renewDetails={};
      } else if (investThrough === 'ARN') {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
        vm.renewDetails={};
      } else if (investThrough === 'RIA') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
        vm.renewDetails={};
      }

      if (!vm.formData.isThroughDistributor) {
        vm.formData.euin = {};
        vm.euinData = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        //vm.formData.euinInput = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.formData.subBrokerCode = '';
        vm.isSelectedEuin = true;
        vm.subBrokerName = '';
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
        vm.formData.purchaseInSchemeCode = '';
        vm.formData.purchaseInSchemeName = '';
        fetchPurchaseInSchemes();
      } else {
        if(!vm.renewDetails.sc){
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
        }
        fetchInSchemes();
      }
      if(!vm.renewDetails.frequency && !vm.checkTransactionID){
        vm.formData.frequency=null;
      }
      if(vm.renewDetails.amount && vm.validations && vm.validations.sipDefaultAmount){
        vm.formData.amount= parseInt(vm.renewDetails.amount) < vm.validations.sipDefaultAmount ? vm.validations.sipDefaultAmount : parseInt(vm.renewDetails.amount);
        vm.oldAmount = angular.copy(parseInt(vm.renewDetails.amount));
      } else {
        vm.formData.amount = null;
        vm.formData.frequency=null;
        vm.savedStartDate = null;
        vm.savedEndDate = null;
        vm.savedweeklyDay = null;
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        resetNumInWords();
        vm.tForm.sAmount.$setPristine(true);
      }
      vm.compareDataFromSystematic();
    };

    vm.addOptionalTransaction = function () {
      vm.formData.optionalInvestmentType = (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) ? vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE : vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP
      fetchInSchemes();
    };

    vm.changeTillPerpetuityFlag = function (cb) {
      cb = cb || function () {
      };
      vm.formData.endDate = null;
      vm.resetting = true;
      $timeout(function () {
        vm.resetting = false;
        if (vm.formData.isTillPerpetuity) {
          // vm.disableEndDateSelection = true;
          var defaultMonths = null;
          var day = moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
          var month = moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
          var newEndDate = day + '/'+ (month + 1) +'/2099';
          var endDate = $window.moment(newEndDate, "DD-MM-YYYY");
          var freq = vm.validations && vm.validations.maxInstallments || 0;
          var frequency = vm.frequencyList && vm.frequencyList.find(function (f) {
            return f.code === vm.formData.frequency;
          }) || {};

          switch (vm.formData.frequency) {
            case'BZ':
              var endDateYear = $window.moment((vm.enabledEndDates[vm.enabledEndDates.length - 1]), "DD-MMM-YYYY").year();
              if (endDateYear > 2099) {
                endDateYear = 2099
              }
              var newEndDate = day + '/'+ (month + 1) +'/' + endDateYear;
              vm.formData.endDate = $window.moment(newEndDate, "DD-MM-YYYY");

              //check end date exists between enabled end dates
              var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
              if (!isBetween) {
                if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1 < $window.moment(vm.enabledEndDates[0], 'DD-MMM-YYYY').month() + 1) {
                  vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
                } else {
                  endDateYear = endDateYear - 1;
                  if (endDateYear < $window.moment((vm.enabledEndDates[0]), "DD-MMM-YYYY").year()) {
                    vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
                  } else {
                    var newEndDate = day + '/'+ (month + 1) +'/' + endDateYear;
                    vm.formData.endDate = $window.moment(newEndDate, "DD-MM-YYYY");
                  }
                }
              }
              break;
            case'OW':
              // var days = 0;
              var weeklyEndate = (month + 1) + '/'+ '31' +'/2099';
              endDate = new Date(weeklyEndate);
              var startDate = vm.formData.startDate.toDate();
              var weeksDiff = UtilService.getNumberOfWeeks(startDate,endDate);
              vm.formData.endDate = vm.formData.startDate.clone().add(weeksDiff*7, 'days');
              break;
            default :

              var endday = moment().date();
              var endmonth = moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
              var endnewEndDate = endday + '/'+ (endmonth + 1) +'/2099';
              var endDate = $window.moment(endnewEndDate, "DD-MM-YYYY");

              if (!moment(endDate).isValid()) {
                var initialStartDate = vm.formData.startDate.clone().day(1)
                endDate = initialStartDate.endOf(endmonth + 1).year(2099);
              }


              // var months = 0;
              defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate.clone().add(frequency, 'months'), $window.moment(endDate));
              freq = freq || Math.floor(defaultMonths / frequency.duration);
              freq = vm.validations && vm.validations.maxInstallments ? freq - 1 : freq;
              var months = frequency.duration * freq;
              vm.formData.endDate = vm.formData.startDate.clone().add(months, 'months');

              var calculatedEndDateMonth = moment(vm.formData.endDate, 'DD-MMM-YYYY').month();

              if(calculatedEndDateMonth > month) {
                var endDateCalculated = angular.copy(vm.formData.endDate);
                var checkDate = angular.copy(endDateCalculated.set('month', month));

                var DateisBetween = $window.moment(checkDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))
                if (DateisBetween) {
                  vm.formData.endDate = checkDate;
                }

              }
              break;
          }

          if (vm.validations && vm.validations.maxInstallments && vm.formData.frequency !== 'OW') {
            var lastEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
            var EndDatemonth = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').month() + 1);
            var EndDateYear = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').year());

            var EndDateCalculatedMonth = angular.copy(moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1);
            var EndDateCalculatedYear = angular.copy(moment(vm.formData.endDate, 'DD-MMM-YYYY').year());

            if (EndDateCalculatedYear <= EndDateYear) {
              if (EndDatemonth < EndDateCalculatedMonth) {
                if (moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                  EndDateYear = EndDateYear - 1;
                  var newEndDate = day + '/'+ (month + 1) +'/' + EndDateYear;
                  vm.formData.endDate = $window.moment(newEndDate, "DD-MM-YYYY");
                }
                var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                if (!isBetween) {
                  vm.formData.endDate = angular.copy(lastEndDate);
                }
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              } else if (EndDatemonth === EndDateCalculatedMonth) {
                if (moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                  EndDateYear = EndDateYear - 1;
                  var newEndDate = day + '/'+ (month + 1) +'/' + EndDateYear;
                  vm.formData.endDate = $window.moment(newEndDate, "DD-MM-YYYY");
                }
                var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                if (!isBetween) {
                  vm.formData.endDate = angular.copy(lastEndDate);
                }
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              } else {
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              }
            } else if ((EndDateCalculatedYear > EndDateYear)) {
              if (EndDateCalculatedYear <= 2099) {
                vm.formData.endDate.set('year', EndDateYear);
              } else {
                vm.formData.endDate.set('year', 2099);
              }

            }
          }

          vm.endDateDefaultForPertuity = vm.formData.endDate;
          vm.changeEndDate(vm.formData.endDate);
          cb(true);
        } else {
          vm.disableEndDateSelection = false;
          cb(false);
          /*vm.formData.startDate && updateEndDates();*/
        }
      }, 0);
    };

    vm.searchDistributor = function () {
      //vm.isInvalidForm = vm.formData.brokerCode ? false : (vm.isArnSuccess ? true : false);
      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      fetchEuinList();
      vm.compareDataFromSystematic();
    };

    vm.searchDistributorByName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      //vm.isInvalidForm = true;
      vm.brokerCodeError = '';
      vm.isArnSuccess = true;
      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        vm.distributorList = null;
        vm.euinList = null;
        //vm.formData.euinInput = '';
        vm.formData.euin = null;
        return;
      }
      fetchARNByName();
      vm.compareDataFromSystematic()
    };

    vm.saveForm = function () {
      vm.isRequired = false;
      vm.isSaving = true;
      var payload = getFinalPayloadData();
      if (!payload) {
        return;
      }

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (angular.isArray(resp.data)) {
              var data = {};
              resp.data.forEach(function (_form) {
                if (_form) {
                  switch (_form.transactionType) {
                    case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
                      data.sipForm = _form;
                      break;
                    case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
                      data.purchaseForm = _form;
                      break;
                  }
                }
              });

              vm.formData.sTransactionId = data.sipForm ? data.sipForm.transactionId : '';
              vm.formData.pTransactionId = data.purchaseForm ? data.purchaseForm.transactionId : '';
            } else {
              vm.formData.transactionId = resp.data.transactionId;
            }

            var successModal= function () {
              $state.go('welcome')
            };
            ModalService.savedTransactionModal({},successModal);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      var _controller2 = vm.transactionType.toLowerCase();
      TransactionService.post({
        controller1: 'transaction',
        controller2: _controller2,
        controller3: 'save'
      }, payload).$promise.then(success, error);
    };

    function changedPaymentOption(calledFromHtml) {

      if(vm.formData.sipPaymentOption=='UPI' && vm.formData.amount > vm.formData.upiLimit) {
        var success = function() {
          if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if(vm.paymentOptions.includes("E-mandate") && vm.isEMandateEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
          } else if(vm.paymentOptions.includes("EC")){
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          } else {
            vm.formData.sipPaymentOption = null;
          }
          vm.changedPaymentOption();
        }
        ModalService.genericModal({
          text: vm.formData.upiErrorMessage,
          isUpi: true
        },success);
      }


      if ((vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE || vm.formData.sipPaymentOption=='UPI') && !vm.emandateObj) {
        UtilService.fetchMandateValidations().then(function (resp) {
          vm.emandateUpiData = resp;
          if (vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            vm.emandateObj = vm.emandateUpiData.eOTM;
          } else if (vm.formData.sipPaymentOption=='UPI') {
            vm.emandateObj = vm.emandateUpiData.upi;
          }
          if (vm.emandateObj) {
            setEmandateUpiSetting();
          }
        }).catch(function(resp) {
          MessageService.error(resp)
        });
      }
      vm.formData.bankInfo = null;
      vm.formData.otmId = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity  = null;
      vm.formData.authMode = null;
      vm.authenticationMode = null;
      vm.enabledBillerStartDatesList=null;
      vm.formData.weeklyDay = null;
      vm.disableEndDateSelection = false;
      vm.isfromSaved = false;
      vm.formData.minEndDate = null;
      vm.startMinDateBiller = null;
      vm.formData.virtualAddress = null;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      if (vm.emandateUpiData && vm.emandateObj) {
        if (vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          vm.emandateObj = vm.emandateUpiData.eOTM;
        } else if (vm.formData.sipPaymentOption=='UPI') {
          vm.emandateObj = vm.emandateUpiData.upi;
        }

        if (vm.emandateObj) {
          setEmandateUpiSetting();
        }
      }
      fetchBankList();
      checkEMandateValidation();
      checkOTMAmountAndDate();
      vm.formData.isUPIVerified = false;
      vm.formData.verifyUPIResp = {};
      if(vm.formData.inSchemeCode) {
        getDateValidation();
      }

      if (calledFromHtml) {
        vm.savedweeklyDay = null;
        vm.savedEndDate = null;
        vm.savedStartDate = null;
      }
      // getDateValidation();
      if (vm.formData.sipPaymentOption === "E-mandate" && vm.enabledEmandateEndDatesList) {
        vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
        changeEndDateEmandate(vm.formData.endDateEmandate);
      }
      vm.compareDataFromSystematic();


    }

    function checkEMandateValidation(){
      if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
        vm.validations.maxAmount=vm.eMandatemaxAmountLimit;
        vm.isMax = !!(vm.validations.maxAmount && vm.formData.amount > vm.validations.maxAmount);
      }
      else vm.isMax=false;
    }

    vm.changeBank = function () {

      if (!vm.formData.bankInfo) {
        return;
      }

      if (vm.formData.bankInfo.ifscCode) {
        vm.formData.ifscCode = null;
      }

      if(!vm.formData.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
        var selectedFolioObj = vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        localStorage.setItem('folioId',selectedFolioObj.folioNumber);
        ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
        vm.formData.bankInfo = null;
        return;
      }
      vm.formData.sipTopupSelected = !!vm.formData.sipTopupSelected;
      vm.formData.sipTopupEnabled = !!vm.formData.sipTopupEnabled;
      if(!vm.formData.bankInfo)
        vm.authenticationMode=null;
      switch (vm.formData.sipPaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:
          vm.formData.authMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes[0] : null;
          vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
          vm.formData.bankAcNo = vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '';
          vm.formData.emUmrn = vm.formData.bankInfo ? vm.formData.bankInfo.emUmrn : '';
          vm.formData.maxAmount = vm.formData.bankInfo ? vm.formData.bankInfo.maxAmount : '';
          vm.formData.emExpiryDate = vm.formData.bankInfo ? vm.formData.bankInfo.emExpiryDate : '';
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          vm.formData.otmId = vm.formData.bankInfo ? vm.formData.bankInfo.otmId : '';
          vm.formData.bankName = vm.formData.bankInfo ? vm.formData.bankInfo.bankName : '';
          vm.formData.bankBranch = vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '';
          vm.formData.bankAcNo = vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '';
          // vm.formData.ifscCode = vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : '';
          vm.formData.payoutId = vm.formData.bankInfo ? vm.formData.bankInfo.payoutId : '';
          (vm.formData.bankInfo && angular.isDefined(vm.formData.bankInfo.camsMandateIdNo))&&(vm.formData.camsMandateIdNo = vm.formData.bankInfo.camsMandateIdNo);
          if(angular.isDefined(vm.formData.bankInfo) && (vm.formData.bankInfo.otmFrequency !== 'AWP') && (vm.formData.frequency === 'BZ')){
            vm.isInvalidForm = true;
            MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
          }
          delete vm.formData.netBankingUrl;
          checkOTMAmountAndDate();
          if (!vm.formData.bankInfo.bankAcType) {
            getAccountType(function (success) {
              if (success && vm.savedAccType) {
                $timeout(function() {
                  vm.formData.bankAcType = vm.savedAccType;
                  vm.savedAccType = null;
                })
              }
            });
          }
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
          vm.formData.netBankingUrl = vm.formData.bankInfo ? vm.formData.bankInfo.netBankingUrl : "";
          if (!vm.formData.bankInfo.bankAcType) {
            getAccountType(function (success) {
              if (success && vm.savedAccType) {
                $timeout(function() {
                  vm.formData.bankAcType = vm.savedAccType;
                  vm.savedAccType = null;
                })
              }
            });
          }
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if (!vm.formData.bankInfo) {
            return;
          }
          if (!vm.formData.bankInfo.bankAcType) {
            getAccountType();
          }
          if(!$window.localStorage.getItem("SummaryEnabled")) {
            vm.formData.verifyUPIResp = {};
            vm.formData.isUPIVerified = false;
            vm.formData.virtualAddress = "";
            if (vm.tForm && vm.tForm.virtualAddress) {
              vm.tForm.virtualAddress.$setPristine(true);
            }
          }

          if(!vm.formData.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            localStorage.setItem('folioId',vm.formData.folioNumber);
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.formData.bankInfo = null;
            vm.isCheckedDeclaration = false;
            return;
          }
          vm.upiAccountNumber = vm.formData.bankInfo.accountNumber;
          vm.upiBankName = vm.formData.bankInfo.bankName;
          // vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
          break;
        default :
          vm.formData.netBankingUrl = vm.formData.bankInfo.netBankingUrl;
          vm.formData.bankName = '';
          vm.formData.otmId = '';
          break;
      }
      resetBankDetails();   // need for sip transaction
      vm.compareDataFromSystematic();
    };

    function resetBankDetails() {
      vm.formData.bankCity = '';
      vm.formData.bankBranch = '';
      vm.formData.bankAcNo = '';
      vm.formData.verifyBankAcNo = '';

    }

    vm.removeOptionalScheme = function () {
      switch (vm.formData.optionalInvestmentType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          vm.purchaseMinAmount = 0;
          vm.isPurchaseMin = false;
          vm.purchaseValidations = null;
          vm.formData.purchaseDividendOption = '';
          vm.formData.purchaseInvestmentOption = '';
          vm.formData.purchaseInSchemeCode = '';
          vm.formData.purchaseInSchemeName = '';
          vm.formData.purchaseAmount = null;
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          vm.formData.dividendOption = '';
          vm.formData.frequency = vm.frequencyList[0].code;
          vm.formData.day = '';
          vm.formData.weeklyDay = '';
          vm.formData.startDate = '';
          vm.formData.endDate = '';
          vm.formData.sipPaymentOption = vm.paymentOptions[0];
          vm.formData.bankAcNo = '';
          vm.formData.ifscCode = '';
          vm.formData.bankBranch = '';
          vm.formData.bankCity = '';
          vm.formData.bankName = '';
          vm.formData.otmId = '';
          vm.formData.isTillPerpetuity = false;
          break;
      }
      vm.formData.optionalInvestmentType = '';
    };

    vm.otherBankSelected = function () {
      //vm.formData.bankInfo = '';
    };

    vm.goToPurchaseSummary = function () {
      /*vm.transactionType = vm.formData.investmentType;
      if (vm.formData.purchaseInSchemeName && vm.formData.purchaseInSchemeName.includes('Children')) {
        var success = function () {
            beforeSummary();
          },
          error = function () {

          };
        var message = AppConstants.TRANSACTIONS.CGF_SCHEME_MSG;
        ModalService.childrenFundMessage({message: message}, success, error);
      } else {
        beforeSummary();
      }*/
      beforeSummary();
    };
    vm.goToSipSummary = function () {
      //vm.isCheckedTandC = false;
      /*if (vm.formData.inSchemeName && vm.formData.inSchemeName.includes('Children')) {
        var success = function () {
            beforeSummary();
          },
          error = function () {

          };
        var message = AppConstants.TRANSACTIONS.CGF_SCHEME_MSG;
        ModalService.childrenFundMessage({message: message}, success, error);
      } else {
          beforeSummary();
      }*/
      beforeSummary();
    };

    function beforeSummary() {
      if(vm.popup !== undefined)
      {
        vm.showCutOffModal({cutoffData:vm.popup,showCutOff:vm.showpopup});
      }
      else {
        vm.moveToSummary();
      }

      /*var currentTime = $window.moment(new Date(), "HH:mm:ss a");
      var dow = currentTime.format('dddd');
      var d = new Date();
      var notAllowedDays = ['Saturday', 'Sunday'];
      if (vm.formData.schemeType != 'LIQUID' && notAllowedDays.indexOf(dow) == -1) {
        d.setHours(13);
        d.setMinutes(0);
        d.setSeconds(0);
        var timeToCompareNonLiquid = $window.moment(d, "HH:mm:ss a");
        var status = currentTime.isAfter(timeToCompareNonLiquid);
        status ? vm.showCutOffModal() : vm.moveToSummary();
      } else if (vm.formData.schemeType == 'LIQUID') {
        d.setHours(12);
        d.setMinutes(30);
        d.setSeconds(0);
        var timeToCompareNonLiquid = $window.moment(d, "HH:mm:ss a");
        var status = currentTime.isAfter(timeToCompareNonLiquid);
        status ? vm.showLiquidPurchaseModal() : vm.moveToSummary();
      } else {
        vm.showCutOffModal();
      }*/
    }

    vm.moveToSummary = function () {
      vm.setTandCVariable();
      userActivityTracking(function (trackResp) {
        var params = {transactionType: vm.transactionType};
        if ((trackResp && angular.isDefined(trackResp.transactionId)) || $stateParams.trackId) {
          params.trackId = trackResp.transactionId || $stateParams.trackId;
          vm.formData.trackId = params.trackId;
        }
        vm.isRequired = true;
        vm.isSaving = false;
        if (vm.formData.euin && !vm.formData.euin.euinName && !vm.formData.euin.euinCode && vm.formData.euinInput) {
          vm.formData.euin.euinName = (vm.formData.euinInput.split('-')[0]).trim();
          vm.formData.euin.euinCode = (vm.formData.euinInput.split('-')[1]).trim();
        }
        $state.$previous = $state.current;
        if (vm.tForm.$valid) {
          var payloadData = getFinalPayloadData();
          if (!payloadData) {
            return;
          }
          var selectedFolioObj = vm.folioList && vm.folioList.filter(function (row) {
            return row.folioNumber == vm.formData.folioNumber
          })[0];
          payloadData.email = selectedFolioObj && selectedFolioObj.email ? selectedFolioObj.email : vm.formData.email ? vm.formData.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
          payloadData.mobileNumber = selectedFolioObj && selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.formData.mobileNumber ? vm.formData.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;

          TransactionModel.setPayloadRawData(payloadData);
          /*Netcore Event Start*/
          var netcoreData = payloadData;
          netcoreData.deeplink = trackResp.trxnUniqueLink;
          if(vm.transactionType===vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP){
            //NetcoreEvntService.Proceed_To_Transact_SIP_IP(payloadData);
            NetcoreEvntService.sip_Summary(netcoreData);
          }else{
            //NetcoreEvntService.Proceed_To_Transact_Purchase_IP(payloadData);
            NetcoreEvntService.purchase_Summary(netcoreData);
          }
          /*Netcore Event End*/
          payloadData.investorType = vm.formData.investorType;
          if($stateParams.action == 'modify'){
            payloadData.modifyAction = vm.formData.modifyAction;
          }
          vm.summaryData = payloadData;
          vm.summaryData['scheduleDetails'] = vm.scheduleTransactionDetails;
          vm.formData.isSummaryViewEnabled = true;
          $window.localStorage.removeItem("SummaryEnabled");
        }

      });
    };

    function userActivityTracking(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && (resp.data || resp)) {
            resp = resp.data || resp;
            LoaderService.hideLoader();
            cb(resp);
        }
        else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      },error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(err);
      };

      var userTrackerPayload = setUserTrackerPayload();
      InvestorService.post({
        child1: 'userBehavior',
        child2: 'addupdate'
      }, userTrackerPayload).$promise.then(success, error);
    }

    function setUserTrackerPayload() {
      var _payload = {
        "trxnRefNo": $stateParams.trackId?$stateParams.trackId:"", //required in case of update
        "trxnType": vm.formData.investmentType, //SIP, PURCHASE
        "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
        "step": "FIRST", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode||vm.formData.inSchemeCode, // required
        "folioNo": vm.formData.folioNumber, // required
        "formData": getSipPurchasePayloadToSave(), // required
        "amount": vm.formData.purchaseAmount ? vm.formData.purchaseAmount : vm.formData.amount ? vm.formData.amount : null, //required
        "trxnStatus": "OPEN",  // OPEN,PROCESSED
        "promoterCode": "" // capture from the transaction link
      };
      return _payload;
    }

    vm.showCutOffModal = function (message) {
      var success = function () {
        vm.moveToSummary();
      }, error = function () {

      };
      ModalService.cutOffModal({message: message}, success, error);
    };

    vm.showLiquidPurchaseModal = function () {
      var success = function () {
        vm.moveToSummary();
      }, error = function () {

      };
      ModalService.liquidPurchaseModal({}, success, error);
    };

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        e.preventDefault();
      }
      return false;
    };

    vm.copyPasteHandler = function (e) {
      UtilService.copyPasteHandler(e);
    };

    vm.accModelDirty = false;
    vm.accFocus = function () {
      vm.accModelDirty = true;
    };

    vm.isCheckedEuin = function () {
      if (vm.isCheckedTandC) {
        vm.formData.euin = {};
      }
    }

    vm.isSelectEuin = function () {
      if (vm.formData.euin) {
        vm.isCheckedTandC = false;
      }
    }

    function checkOTMAmountAndDate() {

      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isOTMEndDate = false;
      // Check Ammout
      if (vm.formData.amount && vm.formData.bankInfo && (vm.formData.amount > vm.formData.bankInfo.maxAmount)) {
        vm.isOTMAmount = true;
      } else {
        vm.isOTMAmount = false;
      }

      //Compare Start Dates
      if (vm.formData.bankInfo && ($window.moment(vm.formData.bankInfo.omExpiryDate, "DD-MMM-YYYY").isBefore(vm.formData.startDate))) {
        vm.isOTMDate = true;
      }
      else {
        vm.isOTMDate = false;
      }
      //Compare End Dates
      if (vm.formData.bankInfo && vm.formData.bankInfo.omStartDate) {
        if (!(vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore(new Date($window.moment(vm.formData.startDate))))) {
          if(vm.formData.startDate ==  null) {
            vm.isOTMStartDate = false;
          } else {
            vm.isOTMStartDate = true;
          }
        } else {
          vm.isOTMStartDate = false;
        }
      }

      if (vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isBefore(new Date($window.moment((vm.formData.endDate))))) {
        vm.isOTMEndDate = true;
      }
      else {
        vm.isOTMEndDate = false;
      }
      //Check for amount or date
      if (vm.isOTMAmount || vm.isOTMDate || vm.isOTMEndDate) {
        vm.isInvalidForm = true;
      } else {
        vm.isInvalidForm = false;
      }
    }

    vm.downloadReport = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], {type: 'application/pdf'});
            FileSaver.saveAs(data, 'exitLoad.pdf');

          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "schemeCode": vm.formData.outSchemeCode,
        "commonReportCO": {
          "docDestination": "download"
        }
      };

      DownloadPdfService.downloadFile(payload).then(success, error);
    }

    vm.changeDistributorCode = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.euinList = null;
      vm.isArnSuccess = true;
      vm.riaCodeError = "";
    }

    vm.changeDistributorName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      vm.euinList = null;
    }

    vm.distributorListChanged = function (data) {
      if (!data) {
        // vm.isArnSuccess = true;
        return;
      } else {
        vm.brokerCodeError = '';
        vm.formData.distributorARN = data.arnCode;
        vm.formData.distributorName = data.name + ' - ' + data.arnCode;
        vm.showArnLabel = false;
        if (vm.formData.distributorARN) {
          //vm.isInvalidForm = false;
          vm.isArnSuccess = false;
        }
        else {
          vm.isArnSuccess = true;
        }
        fetchEuinListThroughDistributor(vm.formData.distributorARN);
      }
    };
    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      vm.compareDataFromSystematic();
    }
    vm.redirectToFolioCreation = function() {
      var successHandlerFolioCreation=function(resp) {
        LoaderService.hideLoader();
        localStorage.removeItem('folioId');
        InvestorFolioModel.resetInvestorFolioModel();
        $rootScope.setFolioInitiateState = $state.current.name;
        sessionStorage.setItem('setFolioInitiateState', $rootScope.setFolioInitiateState);
        $state.go('main.folio.holdmode');
      };
      var errorHandlerFolioCreation=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(AuthService.getToken().investorPAN,null).then(successHandlerFolioCreation).catch(errorHandlerFolioCreation);
    }

    /*----------- Schedule transaction section starts from here ------------*/
    /* Schedule transaction button event handler */
    vm.goToScheduleTransaction = function() {
      var success = function(response) {
        var success = function(result) {
          if (angular.isObject(result)) {
            vm.transactionType = "SCHEDULE_TRANSACTION_PURCHASE";
            vm.scheduleTransactionDetails = result;
            vm.scheduleTransactionDetails['transactionAction'] = "REVIEW";
            vm.scheduleTransactionDetails['state'] = vm.formData.investmentType;
            vm.moveToSummary();
          }
        },
        failure = function() {
          $log.info("modal has been cancelled");
        };
        ModalService.openScheduleTransactionModal({
          title: "Schedule Transaction",
          schemeType: vm.formData.schemeType,
          amountType: "amount",
          initiatedController: vm.formData.investmentType,
          nonBusinessDay: response.data,
          notesDynamic : vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_Schedule_Transaction,
          notesReviewSchedule : vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_Review_Schedule_Purchase,
          termsConditionReviewSchedule : vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Review_Schedule_Purchase
        }, success, failure);
      }, failure = function () {

      };
      TransactionService.get({
        controller1: 'nonBusinessDate',
        schemeCode: vm.formData.purchaseInSchemeCode
      }).$promise.then(success, failure);
    }

    /*
    * Function to show Nav applicability modal
    * In use For E-cart
    */
    function showNavApplicabilityModal() {
      if(vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_AddToCart !== undefined)
      {
         beforeEcartAdd(vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_AddToCart);
      }
      else {
         AddToEcart();
      }
    }


    function AddToEcart() {

      // var success = function(resp) {
      //   if (resp.status && resp.data) {
      //     LoaderService.hideLoader();
      //     $rootScope.$broadcast('UpdateCart', {listUpdated: true});
      //     ModalService.ecartSuccessModal({}, function() {
      //       if($stateParams.folioNumber && $stateParams.eCart)
      //       {
      //         $state.reload();
      //       }
      //       else
      //       {
      //         $state.go('main.transactions.purchase', {folioNumber:vm.formData.folioNumber,eCart:true});
      //       }
      //     });
      //   } else {
      //     MessageService.error(resp.message);
      //   }
      // }, error = function(err) {
      //   LoaderService.hideLoader();
      //   UtilService.errorHandler(err);
      // };
      vm.investorData = setInvestorData();
      if (vm.formData.isDirect || vm.formData.isThroughRia ) {
        vm.formData.euin = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        if(!vm.formData.isThroughRia)
          vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.formData.isEuin =false;
      }

      var payload = {
        folioNumber: vm.formData.folioNumber,
        fundCode :  vm.formData.fundCode,
        schemeCode: vm.formData.purchaseInSchemeCode||vm.formData.inSchemeCode,
        installmentAmount: vm.formData.amount,
        amount: vm.formData.purchaseAmount,
        dividendOption: vm.formData.purchaseDividendOption || vm.formData.dividendOptions,
        brokerCode: vm.investorData.brokerCode,
        subBrokerCode: vm.formData.subBrokerCode && vm.formData.subBrokerCode!==""?vm.formData.subBrokerCode:null,
        subBrokerArn: vm.formData.subBrokerARN && vm.formData.subBrokerARN!==""?"ARN-"+vm.formData.subBrokerARN:null,
        euinOpted:(vm.formData.euin && vm.formData.euin.euinCode && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode:null,
        euinName: vm.formData.euin ? vm.formData.euin.euinName:null,
        minorFlag: vm.formData.minorFlag,
        purchaseOpted: vm.formData.investmentType === 'PURCHASE' ? true : false,
        sipOpted : vm.formData.investmentType === 'SIP' ? true : false,
        addTocart : true
      };


      if (vm.formData.investmentType === 'SIP') {
        payload.frequency =  vm.formData.frequency;
        payload.sipDate =  $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').format("DD-MMM-YYYY");
        payload.toDate = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').format("DD-MMM-YYYY");
        payload.installmentAmount = vm.formData.amount;
        payload.dividendOption = vm.formData.sipDividendOption;
      }

      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = vm.isCheckedTandC ? true : false;
      }
      if (vm.formData.brokerCode && vm.formData.brokerCode !== "" && !vm.formData.isEuin)
        payload.euinOpted = "N";

      vm.ecartData = payload;
      vm.showEcartModel = true;
      $window.scrollTo(0,0);
      UtilService.expandSideBar();
      // investorServiceVersion.post({
      //   child1: 'cart',
      //   child2: 'add',
      //   child3: 'item'
      // }, payload).$promise.then(success, error);
    }


    function beforeEcartAdd(data) {
      vm.showCutOffEcart({cutoffData:data,showCutOff:vm.showPopupAddEcart});
      /*var currentTime = $window.moment(new Date(), "HH:mm:ss a");
      var dow = currentTime.format('dddd');
      var d = new Date();
      var notAllowedDays = ['Saturday', 'Sunday'];
      if (vm.formData.schemeType != 'LIQUID' && notAllowedDays.indexOf(dow) == -1) {
        d.setHours(13);
        d.setMinutes(0);
        d.setSeconds(0);
        var timeToCompareNonLiquid = $window.moment(d, "HH:mm:ss a");
        var status = currentTime.isAfter(timeToCompareNonLiquid);
        status ? vm.showCutOffEcart() : AddToEcart();
      } else if (vm.formData.schemeType == 'LIQUID') {
        d.setHours(12);
        d.setMinutes(30);
        d.setSeconds(0);
        var timeToCompareNonLiquid = $window.moment(d, "HH:mm:ss a");
        var status = currentTime.isAfter(timeToCompareNonLiquid);
        status ? vm.showLiquidPurchaseModalEcart() : AddToEcart();
      } else {
        vm.showCutOffEcart();
      }*/
    }


    vm.showCutOffEcart = function (message) {
      var success = function () {
        AddToEcart();
      }, error = function () {

      };
      ModalService.cutOffModal({message: message}, success, error);
    };

    vm.showLiquidPurchaseModalEcart = function () {
      var success = function () {
        AddToEcart();
      }, error = function () {

      };
      ModalService.liquidPurchaseModal({}, success, error);
    };


    /*
    * Function to fetch the schedule transaction details for view and cancel transaciton action
    */
    function getScheduleTransactionDetails() {
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        vm.scheduleTransactionDetails = response.data.summary;
        $stateParams.transactionAction === 'view' ? handleViewScheduleTransaction() : handleCancelScheduleTransactionAction();
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var payload = {
        transactionId: $stateParams.transactionId,
        transactionType: $stateParams.transactionType
      };
      TransactionService.post({
        controller1: 'schedule',
        controller2: 'transaction',
        controller3: 'summary'
      }, payload).$promise.then(success, error);
    }

    /*
    * Function to handle view schedule transaction action
    * responsible to enable schedule transaction summary view to perform view action.
    */
    function handleViewScheduleTransaction() {
      vm.transactionType = "SCHEDULE_TRANSACTION_PURCHASE";
      vm.scheduleTransactionDetails['transactionAction'] = "VIEW";
      vm.scheduleTransactionDetails['state'] = vm.formData.investmentType;
      moveToScheduleView();
    }

    /**
     * Function to handle cancel action for schedule transaction
     * responsible to enable schedule transaction summary view to perform cancel action.
    * */
    function handleCancelScheduleTransactionAction() {
      vm.transactionType = "SCHEDULE_TRANSACTION_PURCHASE";
      vm.scheduleTransactionDetails['transactionAction'] = "CANCEL";
      vm.scheduleTransactionDetails['state'] = vm.formData.investmentType;
      moveToScheduleView();
    }

    /*
    * function to create purchase payload for view/cancel schedule transaction
    */
    function moveToScheduleView() {
      var payloadData = createSchedulePayloadData();
      if (!payloadData) {
        return;
      }
      TransactionModel.setPayloadRawData(payloadData);
      vm.summaryData = payloadData;
      vm.summaryData['scheduleDetails'] = vm.scheduleTransactionDetails;
      vm.formData.isSummaryViewEnabled = true;
    }

    function createSchedulePayloadData() {
      var payload = {
        purchaseAmount: vm.scheduleTransactionDetails.amount,
        bankInfo: null,
        brokerCode: "",
        brokerName: "",
        checkedNfoAutoSwitch: undefined,
        day: null,
        purchaseInvestmentOption: !angular.isUndefined(vm.scheduleTransactionDetails.dividendOption) ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH,
        email: vm.scheduleTransactionDetails.emailID,
        purchaseDividendOption: vm.scheduleTransactionDetails.dividendOption,
        endDate: null,
        euin: "",
        euinOpted: "N",
        folioNumber: vm.scheduleTransactionDetails.folioNumber,
        formType: "SWITCH",
        frequency: null,
        inSchemeCode: "",
        purchaseInSchemeName: vm.scheduleTransactionDetails.defaultSourceSchemeName,
        inSchemeType: "ELSS",
        investmentOption: "DIVIDEND",
        investmentType: vm.scheduleTransactionDetails.transactionType,
        isBackFromSummary: false,
        isFavourite: false,
        isThroughDistributor: false,
        mobileNumber: vm.scheduleTransactionDetails.mobileNumber,
        noOfInstallments: "",
        scheduleDetails: null,
        sipDividendOption: "Y",
        startDate: null,
        transactionId: $stateParams.transactionId
      };
      return payload;
    }

    /*
    * Function responsible to set invest through check
    * */
    function manipulateInvestThrough(investThrough) {
      if (!vm.checkTransactionID) {
        if (investThrough === AppConstants.INVEST_THROUGH.DIRECT) {
          vm.formData.isThroughDistributor = false;
          vm.formData.isThroughRia = false;
          vm.formData.isDirect = true;
        } else if (investThrough === AppConstants.INVEST_THROUGH.DISTRIBUTOR) {
          vm.formData.isThroughDistributor = true;
          vm.formData.isDirect = false;
          vm.formData.isThroughRia = false;
        } else if (investThrough === AppConstants.INVEST_THROUGH.RIA) {
          vm.formData.isThroughDistributor = false;
          vm.formData.isDirect = false;
          vm.formData.isThroughRia = true;
        }
      }
    }

    /*
    * Function responsible to manage the broker code for purchase and sip payload
    * */
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = vm.isCheckedTandC ? true : false;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['subBrokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }

    vm.setTandCVariable = function() {
      vm.formData.isCheckedTandC = vm.isCheckedTandC;
    };

    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };

    function checkEndNote(endDate,startDate) {
      if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showNote = true;
      } else {
        vm.showNote = false;
      }
    }

     function checkEndNoteOtm(endDate,startDate) {
         if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
           vm.showOtmNote = true;
         } else {
           vm.showOtmNote = false;
         }
     }

     function checkEndNoteEOtm(endDate,startDate) {
        if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
           vm.showEotvm.disableEndDateSelection = true;
            var defaultMonths = null;
            var endDate = $window.moment(new Date("12/31/2099"));
            var freq = vm.validations && vm.validations.maxInstallments || 0;
            var frequency = vm.frequencyList && vm.frequencyList.find(function (f) {
              return f.code === vm.formData.frequency;
            }) || {};

          switch (vm.formData.frequency) {
            case'BZ':
              vm.formData.endDate = endDate; break;
            case'OW':
              // var days = 0;
              endDate = new Date("12/31/2099");
              var startDate = vm.formData.startDate.toDate();
              var weeksDiff = UtilService.getNumberOfWeeks(startDate,endDate);
              vm.formData.endDate = vm.formData.startDate.clone().add(weeksDiff*7, 'days');
              break;
            default :
              // var months = 0;
              defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, $window.moment(endDate));
              freq = freq || Math.floor(defaultMonths / frequency.duration) * frequency.duration;
              vm.formData.endDate = vm.formData.startDate.clone().add(freq, 'months');
              break;
          }
          vm.changeEndDate(vm.formData.endDate);mNote = true;
           } else {
             vm.showEotmNote = false;
           }
    }

    function checkEndPopup(endDate,startDate) {
        if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
          vm.showpopup = true;
          } else {
          vm.showpopup = false;
        }
    }

    function checkEndPopupAddCart(endDate,startDate) {
       if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
         vm.showPopupAddEcart = true;
          } else {
         vm.showPopupAddEcart = false;
       }
    }

     function setDynamicData() {
       if (vm.formData.investmentType === 'SIP')
        {
          vm.notesReview = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_Registration;
          vm.popup = vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_SIP_Review;
          vm.notesOtm = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_OTM;
          vm.notesEOtm = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_eOTM;
          vm.notesUPI = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_UPI;
          vm.riaMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_SIP_Review_Through_RIA;
          vm.distributorMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_SIP_Through_Distributor;
          vm.notesEOtmDebitCard = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_eOTM_Debit_Card;
          vm.key = "TNC_SIP_Review_Registration";
          vm.keyOtm = "TNC_SIP_Review_Registration_eOTM";
          vm.upiModalNote = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_UPI_2FA;

          if(!vm.distributorMessage)
            vm.formData.isCheckedTandC = false;

          if(!vm.riaMessage)
            vm.formData.isCheckedTandC = false;
        }
        else if (vm.formData.investmentType === 'PURCHASE') {
           vm.notesReview = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.NOTE_Review_Purchase_Investment;
           vm.popup = vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_ProceedToTransact;
           vm.riaMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Purchase_Through_RIA;
           vm.distributorMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Purchase_Through_Distributor;
           vm.key = "TNC_Review_Purchase_Investment"

           if(!vm.distributorMessage)
             vm.formData.isCheckedTandC = false;
        }
     }

    vm.isSelectedEuin = true;

    vm.filterEuinList = function () {
      vm.formData.euin = {};
      vm.isSelectedEuin = false ;
      if(vm.euinData.euinNameCode){
        if(vm.euinData.euinNameCode.length>=3){
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.euinData.euinNameCode);
        }
      }
      vm.euinList = vm.euinData.euinNameCode == '' || vm.euinData.euinNameCode == undefined || vm.euinData.euinNameCode.length<3 ? vm.euinMasterList : vm.euinList;
    };

    function fetchInvestmentOption(investmentOption) {
      var investmentOptionKey = "";
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == investmentOption) {
          investmentOptionKey = key;
        }
      });
      return investmentOptionKey;
    }
    vm.selectEuin = function(data) {
      if (!data) {
        return;
      }
      vm.euinData = {};
      vm.euinData.euinNameCode = data.euinNameCode;
      vm.isSelectedEuin = vm.euinData.euinNameCode ? true : false;
    }

    function getAccountType(cb) {
      cb = cb || function () {
      };

      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.bankTypeList = resp.data.bankAccountTypes;
          if ($stateParams.transactionId && $stateParams.initiatedBy !== 'schedule') {
            vm.formData.bankAcType = null;
          }
        } else {
          MessageService.error(resp.message);
        }
        cb(true);
      },
      error = function (err) {
        $log.info('Account type Errror>>>>', err);
        cb(false);
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.formData.investorType
      }).$promise.then(success, error);
    }

    function fetchInvestorType() {
      var investorType = vm.folioList.filter(function(folio) {
        return folio.folioNumber === vm.formData.folioNumber;
      });
      vm.formData.investorType = investorType[0].invType;
    }

    function closeAction(action) {
      vm.showEcartModel = false;
      if (action === 'saved') {
        $state.reload();
      }
    }

    function setInvestorData() {
      var payload = {
        folioNumber: vm.formData.folioNumber,
        brokerCode: vm.formData.isDirect ? 'DIRECT' : vm.brokerCode,
        riaConsent: vm.formData.isThroughRia ? true : false,
        directOpted: vm.formData.isDirect == true ? true : false
      };
      return payload;
    }
    function getMonthsCount(startDate, endDate) {
      var daysToBeAdded = 0;
      var daysAdded = 0;
      while(startDate.isBefore(endDate)) {
        var dayInMonth = moment(startDate).daysInMonth();
        if (dayInMonth === 31) {
          daysToBeAdded = daysToBeAdded + 1;
        } else {
          daysAdded = daysAdded + 1;
        }
        startDate.add(1, 'month');
      }
      return daysToBeAdded;
    }
    function showPrefillValuesForModify(rawData) {
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          if (rawData) {
            sipPrefillValues(rawData)
          } else {
            // fetchPreviousTrSelectedDistrubutor(function () {
              if (!vm.formData.isEuin) {
                vm.isCheckedTandC = true;
              }
              vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
              vm.investThroughFromModify();
              if (vm.formData.distributorARN) {
                fetchEuinListThroughDistributor(vm.formData.distributorARN);
              }

              fetchFolioList(function (success) {
                if (success) {
                  var selectedFolioObj = vm.folioList.filter(function (row) {
                    return row.folioNumber == vm.formData.folioNumber
                  })[0];
                  vm.selectedFolioEmail = selectedFolioObj.email;
                  vm.selectedFolioMobile = selectedFolioObj.mobileNumber;
                  if(selectedFolioObj){
                    vm.formData.folioNumber = selectedFolioObj.folioNumber;
                    vm.selectedFolioData = selectedFolioObj;
                    vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
                  }
                  if(vm.selectedFolioMobile === null || vm.selectedFolioMobile === ''){
                    if(vm.selectedFolioEmail === null || vm.selectedFolioEmail === ''){
                      vm.isEmailMobileinValid = true;
                      vm.emandateDisplay = false;
                    }
                    else {
                      vm.isMobileinValid = true;
                      vm.emandateDisplay = false;
                    }
                  }
                  else if(vm.selectedFolioEmail === null || vm.selectedFolioEmail === ''){
                    if(vm.selectedFolioMobile === null || vm.selectedFolioMobile === ''){
                      vm.isEmailMobileinValid = true;
                      vm.emandateDisplay = false;
                    }
                    else {
                      vm.isEmailinValid = true;
                      vm.emandateDisplay = false;
                    }
                  }

                  checkOTM(function (success) {
                    if(success){
                      vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
                      vm.folioInvestorName = selectedFolioObj.investorName ? selectedFolioObj.investorName : "";
                      vm.formData.minorFlag = vm.folioMinor;
                      // if(vm.formData.minorFlag){
                      //     ModalService.minorSipModal({});
                      // }
                      fetchInSchemes(function () {
                        var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                          return vm.formData.inSchemeCode === item.schemeCode;
                        }) || {};
                        vm.formData.inSchemeName = scheme.scheme || '';
                        fetchInSchemeValidations(function (err) {
                          if (!err) {
                            checkEMandate(function () {
                            });
                            changeFrequency();
                            checkValidations();

                            vm.isReseting = true;
                            vm.formData.startDate = null;
                            vm.formData.endDate = null;
                            vm.formData.showTopUpBlock = false;
                          }
                        });
                      })
                    }

                  });

                }
              });
              // vm.formData.endDate = $window.moment(vm.formData.endDate);
              // vm.changeEndDate(vm.formData.endDate);
              if($stateParams.action == 'modify' && !vm.modifiedSipDetails){
                if(vm.formData.isThroughDistributor) {
                  if (vm.formData.brokerCode) {
                    vm.searchDistributor();
                  } else if (vm.formData.distributorName) {
                    var data = {};
                    vm.searchDistributorByName();
                    var splitedName = vm.formData.distributorName.split(' - ');
                    data.name = splitedName[0];
                    data.arnCode = splitedName[1]
                    vm.distributorListChanged(data);
                  }

                  if (vm.formData.subBrokerARN) {
                    vm.fetchEuinListSubBroker();
                  }

                  if(vm.formData.isEuin) {
                    $timeout(function () {
                      vm.euinList.forEach(function (key) {
                        if (key.euinNameCode == vm.formData.euinNameCode) {
                          vm.formData.euin = key;
                          // vm.formData.euinNameCode = key[key.euinNameCode];
                        }
                      });
                      vm.selectEuin(vm.formData.euin);
                    }, 500);
                  } else {
                    vm.isCheckedTandC = true;
                  }
                }
                else if(vm.formData.isThroughRia){
                  if(vm.formData.riaBrokerCode){
                    vm.searchDistributor();
                    vm.isCheckedTandC = true;
                  }
                }

                // $timeout(function() {
                //   if (vm.formData.sipPaymentOption === "EC") {
                //     vm.formData.bankInfo = vm.bankList && vm.bankList.find(function (bank) {
                //       if(vm.formData.bankInfo) {
                //         return bank.accountNumber === vm.formData.bankInfo.bankAcNo
                //       }
                //     })
                //     vm.changeBank();
                //   } else if (vm.formData.sipPaymentOption === "E-mandate") {
                //     vm.formData.bankInfo = vm.EMbankList && vm.EMbankList.find(function (bank) {
                //       if(vm.formData.bankInfo) {
                //         return bank.accountNumber === vm.formData.bankInfo.bankAcNo
                //       }
                //     })
                //     vm.changeBank();
                //   } else if (vm.formData.sipPaymentOption === "OTM"){
                //     vm.formData.bankInfo = vm.OTMbankList && vm.OTMbankList.find(function (bank) {
                //       if(vm.formData.bankInfo) {
                //         return bank.omUmrn === vm.formData.bankInfo.omUmrn
                //       }
                //     })
                //     vm.changeBank();
                //     if (!vm.formData.bankInfo.ifscCode) {
                //       vm.formData.ifscCode = vm.formData.bankInfo.ifscCode;
                //     }
                //   }
                // },600);
              }
            // });
          }
          break;
      }
    }

    vm.checkModifySipDetails = function(){
      if($stateParams.action == 'modify' && vm.oldSipSystematicData){
        if(vm.oldSipSystematicData.folioNumber && (vm.oldSipSystematicData.folioNumber !== vm.formData.folioNumber)){
          vm.modifiedSipDetails = true;
        }
        if(vm.oldSipSystematicData.inSchemeCode && (vm.oldSipSystematicData.inSchemeCode !== vm.formData.inSchemeCode)){
          vm.modifiedSipDetails = true;
        }
        if(vm.oldSipSystematicData.amount && (vm.oldSipSystematicData.amount !== vm.formData.amount)){
          vm.modifiedSipDetails = true;
        }
        if(vm.oldSipSystematicData.frequency && (vm.oldSipSystematicData.frequency !== vm.formData.frequency)){
          vm.modifiedSipDetails = true;
        }
      }
    }

    vm.investThroughFromModify = function(){
      if ($stateParams.allowBroker && $stateParams.allowBroker === "true" && $stateParams.action === 'modify') {
        manipulateInvestThrough(AppConstants.INVEST_THROUGH.DISTRIBUTOR);
      } else if ($stateParams.allowBroker && $stateParams.allowBroker === "false" && $stateParams.action === 'modify') {
        if (vm.formData.isThroughRia) {
          manipulateInvestThrough(AppConstants.INVEST_THROUGH.RIA);
        } else {
          manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
          vm.modifyChangeThroughDistributor(AppConstants.INVEST_THROUGH.DIRECT);
        }
      }
    }

    vm.modifyChangeThroughDistributor = function(investThrough){
      vm.transactionType = vm.formData.investmentType;
      if (investThrough === 'DIRECT') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
        vm.formData.euin = null;
        vm.formData.subBrokerCode = null;
        vm.formData.brokerCode = null;
        vm.formData.subBrokerName = null;
        vm.formData.subBrokerARN = null;
      } else if (investThrough === 'ARN') {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
      } else if (investThrough === 'RIA') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
        vm.formData.euin = null;
        vm.formData.subBrokerCode = null;
        vm.formData.brokerCode = null;
        vm.formData.subBrokerName = null;
        vm.formData.subBrokerARN = null;
      }

      if (!vm.formData.isThroughDistributor) {
        vm.formData.euin = {};
        vm.euinData = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        //vm.formData.euinInput = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.formData.subBrokerCode = '';
        vm.isSelectedEuin = true;
        vm.subBrokerName = '';
      }
    }

    vm.compareDataFromSystematic = function(){
      if($stateParams.action == 'modify' && vm.oldSipSystematicData){

        if(vm.oldSipSystematicData.isDirect && vm.formData.isDirect !== vm.oldSipSystematicData.isDirect){
          vm.isDirectModified = true;
        } else {
          vm.isDirectModified = false;
        }

        if(vm.oldSipSystematicData.isThroughDistributor && vm.formData.isThroughDistributor !== vm.oldSipSystematicData.isThroughDistributor){
          vm.isThroughDistributorModified = true;
        } else {
          vm.isThroughDistributorModified = false;
        }

        if(vm.oldSipSystematicData.isThroughRia && vm.formData.isThroughRia !== vm.oldSipSystematicData.isThroughRia){
          vm.isThroughRiaModified = true;
        } else {
          vm.isThroughRiaModified = false;
        }

        if(vm.formData.isThroughDistributor){
          if(vm.oldSipSystematicData.brokerCode && vm.formData.brokerCode !== vm.oldSipSystematicData.brokerCode){
            vm.brokerCodeModified = true;
          } else {
            vm.brokerCodeModified = false;
          }
          if(vm.oldSipSystematicData.distributorName && vm.formData.distributorName !== vm.oldSipSystematicData.distributorName){
            vm.distributorNameModified = true;
          } else {
            vm.distributorNameModified = false;
          }

          if(vm.oldSipSystematicData.subBrokerARN && vm.formData.subBrokerARN !== vm.oldSipSystematicData.subBrokerARN){
            vm.subBrokerARNModified = true;
          } else {
            vm.subBrokerARNModified = false;
          }

          if(vm.oldSipSystematicData.subBrokerCode && vm.formData.subBrokerCode !== vm.oldSipSystematicData.subBrokerCode){
            vm.subBrokerCodeModified = true;
          } else {
            vm.subBrokerCodeModified = false;
          }

          // if(vm.oldSipSystematicData.isEuin && vm.formData.isEuin !== vm.oldSipSystematicData.isEuin){
          //   vm.isEuinModified = true;
          // } else {
          //   vm.isEuinModified = false;
          // }

          if(vm.oldSipSystematicData.euinNameCode && vm.euinData.euinNameCode !== vm.oldSipSystematicData.euinNameCode){
            vm.euinNameCodeModified = true;
          } else {
            vm.euinNameCodeModified = false;
          }

        }

        if(vm.oldSipSystematicData.isThroughRia){
          if(vm.oldSipSystematicData.riaBrokerCode && vm.formData.riaBrokerCode !== vm.oldSipSystematicData.riaBrokerCode){
            vm.riaBrokerCodeModified = true;
          } else {
            vm.riaBrokerCodeModified = false;
          }
        }

        if(vm.oldSipSystematicData.inSchemeCode && (vm.formData.inSchemeCode !== vm.oldSipSystematicData.inSchemeCode)){
          vm.inSchemeCodeModified = true;
        } else {
          vm.inSchemeCodeModified = false;
        }

        if(vm.oldSipSystematicData.frequency && (vm.formData.frequency !== vm.oldSipSystematicData.frequency)){
          vm.frequencyModified = true;
        } else {
          vm.frequencyModified = false;
        }

        if((vm.oldSipSystematicData.sipFirstInstallment == true || vm.oldSipSystematicData.sipFirstInstallment == false) && vm.formData.sipFirstInstallment !== vm.oldSipSystematicData.sipFirstInstallment){
          vm.sipFirstInstallmentModified = true;
        } else {
          vm.sipFirstInstallmentModified = false;
        }

        if(vm.oldSipSystematicData.dividendOption && vm.formData.sipDividendOption !== vm.oldSipSystematicData.dividendOption){
          vm.dividendOptionModified = true;
        } else {
          vm.dividendOptionModified = false;
        }

        if(vm.oldSipSystematicData.sipPaymentOption && vm.formData.sipPaymentOption !== vm.oldSipSystematicData.sipPaymentOption){
          vm.sipPaymentOptionModified = true;
        } else {
          vm.sipPaymentOptionModified = false;
        }

        if (vm.formData.sipPaymentOption === "EC") {
          if( vm.oldSipSystematicData.bankInfo && vm.formData.bankInfo && !vm.formData.bankInfo.accountNumber && vm.oldSipSystematicData.bankInfo.bankAcNo && vm.formData.bankInfo.bankAcNo !== vm.oldSipSystematicData.bankInfo.bankAcNo){
            vm.eCBankAcNoModified = true;
          } else if( vm.oldSipSystematicData.bankInfo && vm.formData.bankInfo && vm.oldSipSystematicData.bankInfo.bankAcNo && vm.formData.bankInfo.accountNumber !== vm.oldSipSystematicData.bankInfo.bankAcNo){
            vm.eCBankAcNoModified = true;
          } else {
            vm.eCBankAcNoModified = false;
          }
        }

        if (vm.formData.sipPaymentOption === "OTM") {
          if( vm.oldSipSystematicData.bankInfo && vm.formData.bankInfo && vm.oldSipSystematicData.bankInfo.omUmrn && vm.formData.bankInfo.omUmrn !== vm.oldSipSystematicData.bankInfo.omUmrn){
            vm.oTMomUmrnModified = true;
          } else {
            vm.oTMomUmrnModified = false;
          }
        }

        if (vm.formData.sipPaymentOption === "E-mandate") {
          if(vm.oldSipSystematicData.bankInfo && vm.formData.bankInfo && vm.formData.bankInfo.accountNumber && vm.formData.bankInfo.accountNumber !== vm.oldSipSystematicData.bankInfo.bankAcNo){
            vm.hEMBankAcNoModified = true;
          } else {
            vm.hEMBankAcNoModified = false;
          }
        }

        if(vm.oldSipSystematicData.startDate && !$window.moment(vm.formData.startDate) && vm.formData.startDate !==vm.oldSipSystematicData.startDate){
          vm.startDateModified = true;
        } else if(vm.oldSipSystematicData.startDate && $window.moment(vm.formData.startDate).format("DD-MMM-YYYY") !== vm.oldSipSystematicData.startDate){
          vm.startDateModified = true;
        } else {
          vm.startDateModified = false;
        }
        if(vm.oldSipSystematicData.endDate && !$window.moment(vm.formData.endDate) && vm.formData.endDate !==vm.oldSipSystematicData.endDate){
          vm.endDateModified = true;
        } else if(vm.oldSipSystematicData.endDate && $window.moment(vm.formData.endDate).format("DD-MMM-YYYY") !== vm.oldSipSystematicData.endDate){
          vm.endDateModified = true;
        } else {
          vm.endDateModified = false;
        }

        if(vm.oldSipSystematicData.topupDetails && vm.formData.showTopUpBlock) {
          if (vm.oldSipSystematicData.topupDetails.amount && vm.formData.topupDetails.amount !== vm.oldSipSystematicData.topupDetails.amount) {
            vm.topUpAmountModified = true;
          } else {
            vm.topUpAmountModified = false;
          }
          if (vm.oldSipSystematicData.topupDetails.frequency && vm.formData.topupDetails.frequency !== vm.oldSipSystematicData.topupDetails.frequency) {
            vm.topUpFrequencyModified = true;
          } else {
            vm.topUpFrequencyModified = false;
          }
          if (vm.oldSipSystematicData.topupDetails.capAmount && vm.formData.topupDetails.capAmount !== vm.oldSipSystematicData.topupDetails.capAmount) {
            vm.topupCapAmountModified = true;
          } else {
            vm.topupCapAmountModified = false;
          }
          if (vm.oldSipSystematicData.topupDetails.capMonthYear && vm.formData.topupDetails.capMonthYear !== vm.oldSipSystematicData.topupDetails.capMonthYear) {
            vm.topupCapMonthYearModified = true;
          } else {
            vm.topupCapMonthYearModified = false;
          }
        }

        vm.checkBtnDisableForModifySip();
      }
    }

    vm.checkBtnDisableForModifySip = function() {
      if(vm.isDirectModified || vm.isThroughDistributorModified || vm.isThroughRiaModified || vm.brokerCodeModified || vm.distributorNameModified || vm.subBrokerARNModified || vm.subBrokerCodeModified || vm.euinNameCodeModified
      || vm.riaBrokerCodeModified || vm.inSchemeCodeModified || vm.frequencyModified || vm.sipFirstInstallmentModified || vm.dividendOptionModified || vm.sipPaymentOptionModified
        || vm.eCBankAcNoModified || vm.oTMomUmrnModified || vm.hEMBankAcNoModified || vm.startDateModified || vm.endDateModified
        || vm.topUpAmountModified || vm.topUpFrequencyModified || vm.topupCapAmountModified || vm.topupCapAmountModified){
        vm.disableBtnForModify = false;
      } else {
        vm.disableBtnForModify = true;
      }
    }
    vm.resetCapAmount = function() {
      if (!vm.formData.topupDetails.amount || !vm.formData.topupDetails.percentage) {
        delete vm.formData.topupDetails.capAmount;
        delete vm.formData.topupDetails.capMonthYearSelect;
      }
      vm.compareDataFromSystematic();
    };

    function changeSubBrokerCode(){
      vm.compareDataFromSystematic();
    }

    function changeDividendOption(){
      vm.compareDataFromSystematic();
    }

    function changeCapMonthYear(){
      vm.compareDataFromSystematic();
    }

    function changeAmount() {
      if($stateParams.action == 'modify') {
        // vm.formData.startDate = null;
        // vm.enabledStartDates = null;
        // vm.formData.endDate = null;
        // vm.enabledEndDates = null;
        // vm.formData.day = null;
        // vm.formData.weeklyDay = null;
        // vm.formData.month = null;
        vm.formData.showTopUpBlock = false;
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        changeSipTopupSelected(false);
      } else {
        vm.formData.sipTopupEnabled = false;
        vm.formData.sipTopupSelected = false;
        changeSipTopupSelected(false);
        resetTopupDetails();
      }
    }

    vm.checkTopUpModified = function() {
      if ($stateParams.action == 'modify' && vm.oldSipSystematicDataTopUp) {
        if (vm.oldSipSystematicDataTopUp.topupDetails.amount && vm.oldSipSystematicDataTopUp.topupDetails.amount !== vm.formData.topupDetails.amount) {
          vm.modifiedSipDetails = true;
        }
        if (vm.oldSipSystematicDataTopUp.topupDetails.frequency && vm.oldSipSystematicDataTopUp.topupDetails.frequency !== vm.formData.topupDetails.frequency) {
          vm.modifiedSipDetails = true;
        }
      }
    }


    function updateEmandateEndDate() {

      if (!vm.formData.emandateDate) {
        return;
      }

      var enabledEndDates = [];
      vm.formData.endDateEmandate = '';
      if(vm.formData.emandateDate)
      {
        vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
        vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateMaxYear, 'years').subtract(1,'days');
      }

      var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
      for (var i = 0; i <= freq; i++) {
        enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
      }
      vm.enabledEmandateEndDatesList = enabledEndDates;
      vm.endDateViewEmandate = enabledEndDates[0].clone();
      vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
    }


    function checkAmountValidationEmandate() {
      vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
      vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
      vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.formData.amount ? true : false;
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
    }

    function changeEndDateEmandate(date) {
      vm.formData.endDateEmandate = date ? date : null;
      if (vm.formData.endDate) {
        updateEndDates(false,false,true);
      }
    }

    function handleMandateCalender() {
      if (vm.formData.sipPaymentOption == 'E-mandate' && vm.sipDateLessEmandate) {
        vm.formData.endDate = null;
      }
    }

    function verifyUPI() {
      vm.formData.verifyUPIResp = {};
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData.verifyUPIResp = resp.data;
            if (resp.data.valid) {
              vm.formData.name = resp.data.name;
              vm.formData.isUPIVerified = true;
            } else {
              vm.formData.isUPIVerified = false;
            }
          }
          else {
            vm.formData.isUPIVerified = false;
            vm.formData.verifyUPIResp.valid = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.formData.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();

      investorServiceVersion.post({
        child1: 'upi',
        child2: 'check',
        child3: 'virtualAddress'
      }, {
        "virtualAddress": vm.formData.virtualAddress,
        "basketFlow": false,
        "folioNo": vm.formData.folioNumber,
        "transactionType": vm.formData.investmentType,
        "ecartFlow": false
      }).$promise.then(success, error);
    }

    function handleVpa() {
      if (vm.formData.virtualAddress) {
        vm.formData.virtualAddress = vm.formData.virtualAddress.toLowerCase();
        vm.formData.verifyUPIResp={};
      }
    }


    /**
     * Function responsible for setting emandate and upi form fields data related to date and amount
     * @param {Object} parsedDate : todayDate
     */


    function setEmandateUpiSetting(parsedDate) {
      vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
      vm.eMandatenoOfDays = vm.emandateObj.noOfDays;
      if (parsedDate) {
        vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
        vm.formData.startDate = angular.copy(vm.startMinDateOTM);
      }
      vm.eMandatemaxAmountLimit = vm.emandateObj.maxAmountLimit;
      vm.emandateMinAmountLimit = vm.emandateObj.minAmountLimit;
      vm.formData.emandateAmount = Math.floor(vm.emandateObj.defaultMandateAmount);
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
      checkAmountValidationEmandate();
      vm.mandateInfo = vm.emandateObj.mandateInfo;
      vm.minEndDateGapMandate = vm.emandateObj.minEndDateGap;
      vm.mandateMaxString = vm.emandateObj.maxAmountLimitInfo;
      vm.formData.emandateDate = $window.moment().add(vm.emandateObj.minStartDays,'days');
      updateEmandateEndDate();
      if (vm.enabledEndDates && vm.enabledEndDates.length === 0 && vm.formData.startDate) {
        updateEndDates();
      }
    }

    function hideUPIDetails() {
      if(vm.paymentOptions && vm.formData.modifyAction == 'modifySip') {
        var index = vm.paymentOptions.indexOf('UPI');
        if(index > -1) {
          vm.paymentOptions.splice(index,1);
        }
      }
    }
  }
})();

/**
 * Created by sudarshan on 17/4/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('SipPurchaseHelper', sipPurchaseHelper);


  /** @ngInject */
  function sipPurchaseHelper($window, $log, investorServiceVersion, UtilService, MessageService, LoaderService, FolioModel, $state,
           $stateParams, InvestorService, AppConstants, SchemeService, panAadharService, TransactionService, ModalService, $timeout, NetcoreEvntService, TransactionModel) {
    var vm = null;

    function setViewModel(model) {
      vm = model;
      vm.sidebarTitle = 'CART_DETAILS';
      vm.showAddCart = true;
      var success = function(resp) {
        vm.randomOTPId = resp.randomOTPId ? resp.randomOTPId : null;
      }, error = function() {}
      UtilService.getRandomOTPId().then(success, error);
      // vm.isSelectedEuin = true;
    }

    function isFormValid() {
      var isValid = false;
      var form = vm.formData;

      if(form.investmentType === 'PURCHASE'){
        if(vm.showChequeLeaf){
          // if(form.purchaseInSchemeName && form.amount && form.retirementAgeProofURL){
          //
          //   if(form.amount >= vm.purchaseMinAmount){
          //     isValid = true;
          //   }
          // }
        } else {
          if(form.purchaseInSchemeName && form.amount){

            if(form.amount >= vm.purchaseMinAmount){
              isValid = true;
            }
          }
        }

      }

     else if(form.investmentType === 'SIP' || form.investmentType === 'FLEXSIP'){
        isValid = true;
      }

      return isValid;


    }

    function calculateSipStartDate() {
      vm.formData.startDate = vm.enabledStartDates[vm.formData.month];
      vm.updateEndDates(true);

    }

    function getFolioList(cb) {
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var folioList = [];
          vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
          /*KYC check*/
          if (resp.data.kycVerifiedFlag === false && $stateParams.initiatedBy != "schedule") {
            ModalService.genericModal({
              text: resp.data.kycMessage,
              showBlueBtn: true
            }, function() {
              $state.go("welcome");
            });
          }

          Object.keys(resp.data.folioList).forEach(function (key) {
            var obj = Object.assign({key: key}, resp.data.folioList[key]);
            folioList.push(angular.copy(obj));
          });
          FolioModel.setFolioData(folioList);
          vm.folioList = folioList.length ? folioList : null;
          cb(true);
        } else {
          MessageService.error(resp.message);
          cb(false);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.folioList = null;
        UtilService.errorHandler(err);
        cb(false);
      };
      LoaderService.showLoader();
      investorServiceVersion.get({
        child1: 'folio',
        child2: 'active-list'
      }).$promise.then(success, error);
    }

    function fetchPreviousTrSelectedDistrubutor(cb) {
      cb = cb || function () {};
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var distributorDetails = resp.data;
          if (distributorDetails.investThroughDistributor && distributorDetails.previousDistributorDetails.brokerCode.indexOf('ARN-') === 0) {
            var brokerCode = distributorDetails.previousDistributorDetails.brokerCode
              ? distributorDetails.previousDistributorDetails.brokerCode.split('-') : [];
            vm.formData.brokerCode = brokerCode.length > 0 ? brokerCode[1] : '';
            manipulateInvestThrough(AppConstants.INVEST_THROUGH.DISTRIBUTOR);
            vm.formData.brokerName = distributorDetails.previousDistributorDetails.brokerName;
            var subBrokerArn = distributorDetails.previousDistributorDetails.subBrokerArn;
            var subBrokerARNArray = subBrokerArn ? subBrokerArn.split('-') : [];
            vm.formData.subBrokerARN = subBrokerARNArray ? subBrokerARNArray[1] : '';
            vm.formData.subBrokerCode = distributorDetails.previousDistributorDetails.subBrokerCode;
            vm.subBrokerName = distributorDetails.previousDistributorDetails.subBrokerName;
            vm.euinMasterList = distributorDetails.previousDistributorDetails.euinDetailList;
            vm.euinList = vm.euinMasterList;
            vm.formData.euin = vm.euinList.length === 1 ? vm.euinList[0] : null;
            vm.formData.euin = distributorDetails.previousDistributorDetails.euinPreviousUsed ? vm.euinList[0] : null;
            vm.euinData = vm.formData.euin ? vm.formData.euin : {};
            if (vm.euinData) {
              vm.euinData.euinNameCode = vm.formData.euin && vm.formData.euin.euinNameCode ? vm.formData.euin.euinNameCode : null;
            }
            vm.isCheckedTandC = false;
            vm.isArnSuccess = false;
            vm.showArnLabel = false;
            vm.brokerCodeError = "";
            if(vm.euinList && vm.euinList.length === 1) {
              selectEuin(vm.euinList[0]);
            }
          } else if (distributorDetails.investThroughRIA) {
            vm.formData.riaBrokerCode = distributorDetails.previousDistributorDetails.brokerCode ?
              distributorDetails.previousDistributorDetails.brokerCode : "";
            vm.formData.riaBrokerName = distributorDetails.previousDistributorDetails.brokerName;
            vm.isArnSuccess = false;
            vm.showArnLabel = false;
            vm.riaCodeError = "";
            manipulateInvestThrough(AppConstants.INVEST_THROUGH.RIA);
          } else {
            manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
            (angular.isUndefined($stateParams.sc)) && resetAll();
          }
          cb(true);
        } else {
          MessageService.error(resp.message);
          cb(false);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        cb(false);
      };
      var payload = {
        folioNo:vm.formData.folioNumber
      };
      if ($stateParams.sc) {
        payload.schemeCode = $stateParams.sc;
      }
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'folio',
        child2: 'status',
        child3: 'previous',
        child4: 'transaction'
      },payload).$promise.then(success, error);
    }

    function manipulateInvestThrough(investThrough) {
      if (investThrough === AppConstants.INVEST_THROUGH.DIRECT) {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
      } else if (investThrough === AppConstants.INVEST_THROUGH.DISTRIBUTOR) {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
      } else if (investThrough === AppConstants.INVEST_THROUGH.RIA) {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
      }
    }

    function userActivityTracking(cb, step) {
      cb = cb || function () {};
      // LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && (resp.data || resp)) {
          resp = resp.data || resp;
          vm.transId = angular.copy(resp.transactionId);
          // LoaderService.hideLoader();
          cb(resp);
        }
        else {
          MessageService.error(resp.message);
          // LoaderService.hideLoader();
        }
      },error = function (err) {
        UtilService.errorHandler(err);
        // LoaderService.hideLoader();
        cb(err);
      };

      var userTrackerPayload = setUserTrackerPayload(step);
      InvestorService.post({
        child1: 'userBehavior',
        child2: 'addupdate'
      }, userTrackerPayload).$promise.then(success, error);
    }

    function setUserTrackerPayload(step) {
      var _payload = {
        "trxnRefNo": $stateParams.trackId?$stateParams.trackId: vm.formData.trackId ? vm.formData.trackId : "", //required in case of update
        "trxnType": vm.formData.mixTransactionType === "SIPPURCHASE" ? "SIP_PURCHASE" : vm.formData.investmentType, //SIP, PURCHASE
        "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
        "step": step, // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode || vm.formData.inSchemeCode, // required
        "schemeName": vm.formData.purchaseInSchemeName || vm.formData.inSchemeName,
        "netCoreJourney": vm.formData.journey == "Transact Now" ? "TRANSACT_NOW": null,
        "folioNo": vm.formData.folioNumber, // required
        "formData": getSipPurchasePayloadToSave("USER_BEHAVIOUR"), // required
        "amount": vm.formData.mixTransactionType === "SIPPURCHASE" ? vm.formData.amount + vm.formData.sipDetailsViaPurchase.sipAmount : vm.formData.amount ? vm.formData.amount : null, //required
        "trxnStatus": "OPEN",  // OPEN,PROCESSED
        "promoterCode": "" // capture from the transaction link
      };
      return _payload;
    }

    function getSipPurchasePayloadToSave(from) {
      if(vm.formData.isThroughDistributor===false && vm.formData.isThroughRia === false){
        vm.formData.euin = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
      }
      var sipPayload = {
          installmentAmount: vm.formData.amount,
          investmentOption: fetchInvestmentOption(vm.validations.investmentOption),
          dividendOption: vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.sipDividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          frequency: vm.formData.frequency,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          schemeType: vm.formData.schemeType,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          toDate: vm.formData.endDate ? $window.moment(vm.formData.endDate).clone().format('DD-MMM-YYYY') : '',
          sipDate: vm.formData.startDate ? $window.moment(vm.formData.startDate).clone().format('DD-MMM-YYYY') : '',
          sipDay: vm.formData.day,
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinName: vm.formData.euin && vm.formData.euin.euinName ? vm.formData.euin.euinName : '',
          euinCode: vm.formData.euin && vm.formData.euin.euinCode ? vm.formData.euin.euinCode : '',
          id: vm.formData.sTransactionId,
          compositeTransactionId: $stateParams.ctId ? $stateParams.ctId : '',
          // isTillPerpetuity: vm.formData.isTillPerpetuity ? vm.formData.isTillPerpetuity : false,
          subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode,
          sipTopupEnabled: vm.formData.sipTopupSelected,
          brokerCode: vm.formData.isThroughDistributor ? vm.formData.brokerCode : vm.formData.isThroughRia ? vm.formData.riaBrokerCode : null,
          topupDetails: vm.formData.sipTopupSelected ? {
            amount: vm.formData.topupDetails?vm.formData.topupDetails.amount:'',
            percentage: vm.formData.topupDetails?vm.formData.topupDetails.percentage:'',
            frequency: vm.formData.topupDetails?vm.formData.topupDetails.frequency:'',
            capAmount: vm.formData.topupDetails?vm.formData.topupDetails.capAmount:'',
            capMonthYear: vm.formData.topupDetails?(vm.formData.topupDetails.capMonthYearSelect?$window.moment(vm.formData.topupDetails.capMonthYearSelect,"MMM-YYYY").format("DD-MMM-YYYY"):''):''
          } : {}

        },
        purchasePayload = {
          amount: vm.formData.amount,
          investmentOption: fetchInvestmentOption(vm.formData.purchaseInvestmentOption),
          dividendOption: vm.formData.dividendOption,
          folioNumber: vm.formData.folioNumber,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinName: vm.formData.euin && vm.formData.euin.euinName ? vm.formData.euin.euinName : '',
          euinCode: vm.formData.euin && vm.formData.euin.euinCode ? vm.formData.euin.euinCode : '',
          id: vm.formData.pTransactionId,
          compositeTransactionId: $stateParams.ctId ? $stateParams.ctId : '',
          schemeCode: vm.formData.purchaseInSchemeCode,
          retirementAgeProofURL: vm.formData.retirementAgeProofURL ? vm.formData.retirementAgeProofURL : '',
          checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
          autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null,
          autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null,
          subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode
        };

      if(from && (from === "USER_BEHAVIOUR")) {
        sipPayload.amount = vm.formData.amount;
        delete sipPayload.installmentAmount;
      }

      if(vm.backFromPayment) {
        vm.sipFirstInstallment=true;
        vm.formData.sipFirstInstallment=true;
      }

      if(vm.formData.sipFirstInstallment && vm.formData.frequency !== "BZ") {
        sipPayload.sipWithFirstInstallment=vm.formData.sipFirstInstallment;
        // sipPayload.firstInstallmentDetails={amount:vm.formData.amount};
      }

      if (vm.formData.purchaseInSchemeName && !vm.formData.purchaseInSchemeName.toLowerCase().includes('retirement')) {
        purchasePayload.retirementAgeProofURL = '';
      }

      if (!sipPayload.investmentOption) {
        sipPayload.investmentOption = vm.formData.sipPaymentOption;
      }
      if (!sipPayload.dividendOption) {
        sipPayload.dividendOption = vm.formData.sipDividendOption;
      }

      if(vm.showCancelledAndModifiedDetails) {
        sipPayload.cancelTransactionRequestBody = {
          transactionId: vm.formData.transactionId,
          transactionType: "SIP"
        }
      }

      var payload = {};

      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          purchasePayload = handleBrokerCode(purchasePayload);
          if(vm.formData.mixTransactionType && vm.formData.mixTransactionType === "SIPPURCHASE") {
            payload = angular.copy(purchasePayload);
            payload.startSipDetails = {
              "amount" : vm.formData.sipDetailsViaPurchase && vm.formData.sipDetailsViaPurchase.sipAmount,
              "frequency": vm.formData.frequency,
              "startDate": vm.formData.startDate.format("DD-MMM-YYYY"),
              "endDate": vm.formData.endDate.format("DD-MMM-YYYY")
            };
            payload.startSipEnabled = vm.formData.sipViaPurchaseSelected;
          } else {
            payload = angular.copy(purchasePayload);
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          sipPayload = handleBrokerCode(sipPayload);
          payload = angular.copy(sipPayload);
          break;
      }
      payload.trackId = vm.formData.trackId;
      payload.newAcknowledgeScreen = true;

      return payload;
    }

    function getMixTransactionPayload() {
      if(vm.formData.isThroughDistributor===false && vm.formData.isThroughRia === false){
        vm.formData.euin = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
      }
      var payload = {
        amount: vm.formData.amount,
        investmentOption: vm.formData.purchaseInvestmentOption,
        dividendOption: vm.formData.dividendOption,
        folioNumber: vm.formData.folioNumber,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin && vm.formData.euin.euinName ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin && vm.formData.euin.euinCode ? vm.formData.euin.euinCode : '',
        riaConsent: vm.formData.isThroughRia ? true : false,
        brokerCode: vm.formData.isThroughDistributor ? 'ARN-' + vm.formData.brokerCode : vm.formData.isThroughRia ? vm.formData.riaBrokerCode : "DIRECT",
        minorFlag: vm.formData.minorFlag,
        schemeCode: vm.formData.purchaseInSchemeCode,
        subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
        subBrokerCode: vm.formData.subBrokerCode,
        installmentAmount: vm.formData.sipDetailsViaPurchase.sipAmount,
        frequency: vm.formData.frequency,
        toDate: vm.formData.endDate ? $window.moment(vm.formData.endDate).clone().format('DD-MMM-YYYY') : '',
        sipDate: vm.formData.startDate ? $window.moment(vm.formData.startDate).clone().format('DD-MMM-YYYY') : '',
        sipDay: vm.formData.day ? vm.formData.day : vm.formData.startDate ? vm.formData.startDate.format('D') : '',
        purchaseOpted: true,
        sipOpted: true,
        flowName:"SIP_PURCHASE"
      };
      return payload;
    }

    function fetchInvestmentOption(investmentOption) {
      var investmentOptionKey = "";
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == investmentOption) {
          investmentOptionKey = key;
        }
      });
      return investmentOptionKey;
    }

    /*
    * Function responsible to manage the broker code for purchase and sip payload
    * */
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = vm.isCheckedTandC ? true : false;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['subBrokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }

    function fetchPurchaseInSchemes(cb) {
      cb = cb || function () {};
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.masterPurchaseInSchemeList = resp.data.schemeList;
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
          cb(true);
        } else {
          vm.masterPurchaseInSchemeList = null;
          MessageService.error(resp.message);
          cb(false);
        }
      }, error = function (err) {
        cb(false);
        vm.masterPurchaseInSchemeList = null;
        UtilService.errorHandler(err);
      };
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'purchaseenabled',
        child2: (vm.folioMinor ? vm.folioMinor :false),
        child3: vm.formData.isThroughDistributor,
        child4: vm.formData.corporateInvestor
      }, null).$promise.then(success, error);
    }

    function resetAll() {
      vm.formData.amountType = 'amount';
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.outSchemeCode = '';
      vm.formData.outSchemeName = '';
      vm.formData.dividendOption = '';
      // vm.formData.frequency = null;
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      // vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.bankInfo = null;
      vm.formData.day = '';
      vm.formData.weeklyDay = null;
      vm.formData.isTillPerpetuity = false;
      vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
      vm.formData.amount = '';
      vm.formData.dividendOption = '';
      vm.formData.schemeCode = '';
      vm.formData.purchaseInSchemeName = '';
      vm.formData.purchaseInvestmentOption = '';
      vm.ECbankList = null;
      vm.formData.month = '';

      vm.formData.euin = {};
      vm.euinData = {};
      vm.formData.brokerCode = '';
      vm.formData.brokerName = '';
      vm.euinList = null;
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.formData.subBrokerARN = '';
      vm.formData.subBrokerCode = '';
      vm.isCheckedTandC = false;
      vm.isArnSuccess = true;
      vm.formData.sipPaymentOption = '';


      vm.inSchemeValidations = null;
      vm.outSchemeValidations = null;
      vm.validations = {};
      vm.isRequired = false;
      vm.bankList = null;
      vm.outSchemeList = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
      vm.unitsDetails = null;
      resetNumInWords(); //reset the number in text form on folio change or form reset

      resetBankDetails();
      if (vm.specificProperties && vm.specificProperties.investmentModeData) {
        vm.specificProperties.investmentModeData.stage1 = '';
        vm.specificProperties.investmentModeData.stage2 = '';
        vm.specificProperties.investmentModeData.stage3 = '';
        vm.specificProperties.investmentModeData.stage4 = '';
      }
      manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
      vm.formData.riaBrokerCode = "";
      vm.formData.riaBrokerName = "";
      vm.formData.isCheckedTandC = false;
      vm.brokerCodeError = "";
      vm.riaCodeError = "";
      vm.UPIbankList = null;
    }

    function resetNumInWords() {
      vm.amountInWords = '';
      var inWordsDiv = $window.document.getElementById('divDisplayWords');
      var inWordsFirstInstallmentDiv = $window.document.getElementById('divDisplayWordFirstInstallment');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '';
      }
      if (inWordsFirstInstallmentDiv) {
        inWordsFirstInstallmentDiv.innerHTML = '';
      }
    }

    function resetBankDetails() {
      vm.formData.bankCity = '';
      vm.formData.bankBranch = '';
      vm.formData.bankAcNo = '';
      vm.formData.verifyBankAcNo = '';

    }

    function changeThroughDistributor (investThrough) {
      vm.transactionType = vm.formData.investmentType;
      vm.switchInvestmentType = disabledInvestmentType(investThrough);
      investmentTypeVariableUpdate(investThrough);

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
        // vm.formData.purchaseInSchemeCode = '';
        // vm.formData.purchaseInSchemeName = '';
        if(!vm.switchInvestmentType) {
          vm.formData.purchaseInSchemeCode = '';
          vm.formData.purchaseInSchemeName = '';
        }
        if(!vm.formData.purchaseInSchemeCode) {
          fetchPurchaseInSchemes();
        }
      } else {
        // if(!vm.renewDetails.sc){
        //   vm.formData.inSchemeCode = '';
        //   vm.formData.inSchemeName = '';
        // }
        if(!vm.switchInvestmentType) {
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
        }
        if(!vm.formData.inSchemeCode) {
          fetchSipInSchemes();
        }
      }
      if(!vm.renewDetails.frequency){
        // vm.formData.frequency=null;
      }
      if(vm.renewDetails.amount && vm.validations && vm.validations.sipDefaultAmount){
        vm.formData.amount= parseInt(vm.renewDetails.amount) < vm.validations.sipDefaultAmount ? vm.validations.sipDefaultAmount : parseInt(vm.renewDetails.amount);
        vm.oldAmount = angular.copy(parseInt(vm.renewDetails.amount));
      } else if(!vm.switchInvestmentType) {
        // vm.formData.amount = null;
        // vm.formData.frequency=null;
        vm.savedStartDate = null;
        vm.savedEndDate = null;
        vm.savedweeklyDay = null;
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        resetNumInWords();
        //vm.tForm.sAmount.$setPristine(true);
      }
      vm.riaCodeCopy = vm.formData.riaBrokerCode ? vm.formData.riaBrokerCode : null;
      vm.formData.riaBrokerCode = '';
      //vm.compareDataFromSystematic();
    }

    function fetchPurchaseValidations(cb) {
      vm.purchaseValidations = null;
      cb = cb || function () {};
      if (!vm.formData.purchaseInSchemeCode) {
        return;
      }

      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.purchaseValidations = resp.data;
          // for minor payment mode change
          if(vm.purchaseValidations && vm.formData.minorFlag){
            vm.purchaseValidations.cgfFlag = vm.purchaseValidations.cgfFlag ? vm.purchaseValidations.cgfFlag : true;
          }
          _setPurchaseDividendOptionsVali(vm.purchaseValidations);
          vm.formData.schemeType= vm.purchaseValidations.schemeType;
          vm.formData.upiErrorMessage = resp.data.upiMaxAmountErrMessage;
          vm.formData.upiLimit = resp.data.upiMaxAmountLimit;
          cb(true);
        } else {
          cb('error');
          vm.purchaseValidations = null;
          vm.isSchemeTypeELSS = (vm.purchaseValidations && vm.purchaseValidations.schemeType == "ELSS") ? true : false;
          vm.formData.dividendOption = vm.formData.dividendOption || vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.purchaseInvestmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH;
          vm.dividendOptions = vm.isSchemeTypeELSS ? vm.dividendOptionsELSS : vm.dividendOptionsOther;
          MessageService.error(resp.message);
        }
        checkPurchaseValidations();
      },
      error = function (err) {
        cb('error');
        vm.purchaseValidations = null;
        vm.formData.dividendOption = vm.formData.dividendOption || vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
        vm.formData.purchaseInvestmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH;
        vm.isSchemeTypeELSS = (vm.purchaseValidations && vm.purchaseValidations.schemeType == "ELSS") ? true : false;
        vm.dividendOptions = vm.isSchemeTypeELSS ? vm.dividendOptionsELSS : vm.dividendOptionsOther;
        UtilService.errorHandler(err);
      };

      var data = {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.purchaseInSchemeCode
      };
      SchemeService.post({
        controller: 'schemeValidation',
        type: 'purchase'
      }, data).$promise.then(success, error);
    }

    function _setPurchaseDividendOptionsVali(purchaseValidations) {
      vm.purchaseValidations = purchaseValidations;
      vm.isSchemeTypeELSS = (vm.purchaseValidations && vm.purchaseValidations.schemeType == "ELSS") ? true : false;
      vm.formData.purchaseInvestmentOption = vm.purchaseValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : (vm.formData.purchaseInvestmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH && vm.formData.purchaseInvestmentOption || vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
      vm.formData.cgfFlag = vm.purchaseValidations  ? vm.purchaseValidations.cgfFlag:null;
      vm.dividendOptions = vm.isSchemeTypeELSS ? vm.dividendOptionsELSS : vm.dividendOptionsOther;
      if (vm.purchaseValidations.isGrowth) {
        vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
      } else if((!vm.showSavedData && !vm.formData.dividendOption && !vm.formData.backFromPaymentPage) || (vm.showSavedData && !vm.formData.dividendOption && !vm.formData.backFromPaymentPage)) {
        if(vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === false){
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
        } else if(vm.purchaseValidations.dividendPayoutApplicable === false && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
        } else if(vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
        }
      } else if ((vm.formData.backFromPaymentPage && vm.formData.dividendOption) || (!vm.formData.backFromPaymentPage && vm.formData.dividendOption)) {
        if(vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === false){
          if(vm.formData.dividendOption === vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST) {
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
          }
        } else if(vm.purchaseValidations.dividendPayoutApplicable === false && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
          if(vm.formData.dividendOption === vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT) {
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          }
        } else if (vm.formData.dividendOption === vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH) {
          if(vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === false){
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
          } else if(vm.purchaseValidations.dividendPayoutApplicable === false && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          } else if(vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
          }
        }
      }
    }

    function checkPurchaseValidations(fromHTML) {
      vm.formData.amount = vm.formData.displayAmount !== '0' ? UtilService.amountInComma(vm.formData.displayAmount).amount: null;
      vm.formData.displayAmount = vm.formData.amount && vm.formData.amount !== 0  ? UtilService.amountInComma(vm.formData.amount).amountInComma: vm.formData.amount;
      if (vm.formData.amount) {
        $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
      }
      if (vm.purchaseValidations) {
        if (!vm.purchaseValidations.addlPurchase) {
          vm.isPurchaseMin = vm.purchaseValidations.minFirstPurchaseAmt > vm.formData.amount;
          vm.purchaseMinAmount = vm.purchaseValidations.minFirstPurchaseAmt;
        } else {
          vm.isPurchaseMin = vm.purchaseValidations.minAddlPurchaseAmt > vm.formData.amount;
          vm.purchaseMinAmount = vm.purchaseValidations.minAddlPurchaseAmt;
        }
        vm.isMultiples = vm.purchaseValidations.purchaseMultiple && vm.formData.amount && (vm.formData.amount % vm.purchaseValidations.purchaseMultiple === 0) || false;
        if(vm.formData.amount % 1 != 0){
          vm.isPurchaseAmountDecimal = true;
        }
        else{
          vm.isPurchaseAmountDecimal = false;
        }
      }
      if(vm.formData.amount && !vm.isPurchaseMin && (vm.purchaseValidations.purchaseMultiple && !vm.isMultiples) && !fromHTML) {
        vm.formData.amount = vm.defaultData.purchaseDefaultAmount;
        vm.formData.displayAmount = vm.formData.amount && vm.formData.amount !== 0 ? UtilService.amountInComma(vm.formData.amount).amountInComma: vm.formData.amount;
        checkPurchaseValidations();
        vm.formData.sipViaPurchaseSelected = false;
        vm.formData.sipViaPurchaseSelected = false;
        vm.formData.sipDetailsViaPurchase = {};
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.mixTransactionType = null;
      }
    }

    function handleEnter (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        e.preventDefault();
      }
      return false;
    }

    function fetchSipInSchemes(cb) {
      cb = cb || function () {
      };

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.masterInSchemeList = resp.data.schemeList;
            vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
            /* fill autoscheme for sip with first installment*/
            // if (vm.formData.inSchemeCode) {
            //   var schemeData = vm.inSchemeList.filter(function(scheme) {
            //     return scheme.schemeCode === vm.formData.inSchemeCode;
            //   });
            //   vm.inSchemeChanged(schemeData[0]);
            //   if (vm.formData.topupDetails && vm.formData.topupDetails.capMonthYear) {
            //     vm.formData.topupDetails.capMonthYear = $window.moment(vm.formData.topupDetails.capMonthYear,"MMM-YYYY").format("MMM-YYYY");
            //   }
            // }
            cb(true);
          } else {
            vm.masterInSchemeList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          vm.masterInSchemeList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      var _config = {
        controller: 'scheme',
        type: 'ALL',
        child1: vm.transactionType.toLowerCase() + 'enabled',
        child2: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
        child3: vm.formData.isThroughDistributor,
        child4: vm.formData.corporateInvestor
      };
      SchemeService.get(_config, null).$promise.then(success, error);
    }

    function fetchSipSchemeValidations(cb) {
      vm.inSchemeValidations = null;

      if (vm.transactionType) {
        vm.formData.investmentType = vm.transactionType;
      } else if (vm.formData.investmentType) {
        vm.transactionType = vm.formData.investmentType;
      }
      var transactionType = vm.formData.investmentType.toLowerCase();
      cb = cb || function () {
      };
      if (!vm.formData.inSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;
            // for minor payment mode change
            if(vm.inSchemeValidations && vm.formData.minorFlag){
              vm.inSchemeValidations.cgfFlag = vm.inSchemeValidations.cgfFlag ? vm.inSchemeValidations.cgfFlag : true;
            }
            vm.formData.upiErrorMessage = resp.data.upiMaxAmountErrMessage;
            vm.formData.upiLimit = resp.data.upiMaxAmountLimit;
            vm.frequencyList = vm.inSchemeValidations.additionalValidation.frequency?vm.inSchemeValidations.additionalValidation.frequency:null;
            if($stateParams.action == 'modify' && !vm.modifiedSipDetails){
              var frequency = vm.frequencyList.find(function (f) {
                return f.code === vm.formData.frequency;
              }) || {};
              if(frequency) {
                vm.selectedFreq = frequency;
              }
            } else if (vm.showSavedData) {
              frequency = vm.frequencyList.find(function (freq) {
                return freq.code === vm.savedFrequency;
              }) || {}
              if(frequency) {
                vm.selectedFreq = frequency;
                vm.formData.frequency = frequency.code;
              }
            } else if ($stateParams.action == "renew") {
              var compareFreq = vm.renewDetails.frequency && !vm.formData.backFromPaymentPage ? vm.renewDetails.frequency : vm.formData.frequency
              frequency = vm.frequencyList.find(function (freq) {
                return freq.code === compareFreq;
              }) || {}
              if(frequency) {
                vm.selectedFreq = frequency;
                vm.formData.frequency = frequency.code;
              }
            } else if (vm.formData && vm.formData.backFromPaymentPage) {
              frequency = vm.frequencyList.find(function (freq) {
                return freq.code === vm.formData.frequency;
              }) || {}
              if(frequency) {
                vm.selectedFreq = frequency;
                vm.formData.frequency = frequency.code;
              }
            } else {
              var frequency = vm.frequencyList.find(function (f) {
                return f.code === 'OM';
              }) || {};
            }

            // if(!vm.renewDetails.frequency){
              vm.formData.frequency = vm.formData.frequency ? vm.formData.frequency : frequency?frequency.code:vm.frequencyList[0].code;
            // }
            cb(true);
          } else {
            cb('error');
            vm.inSchemeValidations = null;
            vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
            vm.formData.dividendOption = vm.isSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.dividendOption;
            vm.dividendOptions = vm.isSchemeTypeELSS ? vm.dividendOptionsELSS : vm.dividendOptionsOther;
            MessageService.error(resp.message);
          }
          // if (vm.renewDetails.amount){
          //   vm.formData.amount= parseInt(vm.renewDetails.amount) < vm.validations.sipDefaultAmount ? vm.validations.sipDefaultAmount : parseInt(vm.renewDetails.amount);
          //   vm.oldAmount = angular.copy(parseInt(vm.renewDetails.amount));
          // }
          /*if(vm.formData.sipFirstInstallment && vm.formData.sipFirstAmount)
          {
            checkSipFirstValidations();
          }*/
        },
        error = function (err) {
          cb('error');
          vm.inSchemeValidations = null;
          vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
          vm.formData.dividendOption = vm.isSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.dividendOption;
          vm.dividendOptions = vm.isSchemeTypeELSS ? vm.dividendOptionsELSS : vm.dividendOptionsOther;
          UtilService.errorHandler(err);
        };
      if (vm.formData.investmentType == 'PURCHASE' && vm.formData.inSchemeCode) {
        transactionType = 'switch'
      }
      var params = {
        controller: 'schemeValidation',
        type: transactionType/*,
        child1: vm.formData.inSchemeCode*/
      };
      /*if (HDFC_API.ENV !== 'prod'){
        params.child2= vm.formData.folioNumber
      }*/

      var data = {
        schemeCode: vm.formData.inSchemeCode,
        folioNo: vm.formData.folioNumber
      }
      SchemeService.post(params, data).$promise.then(success, error);
    }

    function setSipDividendOptionsValue(inSchemeValidations) {
      // var transactionType = vm.formData.investmentType.toLowerCase();
      vm.inSchemeValidations = inSchemeValidations;
      vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
      vm.inSchemeValidations.investmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[vm.inSchemeValidations.investmentOption];
      if($stateParams.action == 'modify' && !vm.modifiedSipDetails) {
        var investmentOption = vm.inSchemeValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.formData.investmentOption;
        vm.validations.investmentOption = investmentOption;
      } else {
        var investmentOption = vm.inSchemeValidations.investmentOption || (vm.inSchemeValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
        vm.validations.investmentOption = investmentOption;
      }

      if($stateParams.action == 'modify' && !vm.modifiedSipDetails) {
        vm.formData.dividendOption = vm.formData.dividendOption;
      } else {
        vm.formData.dividendOption = (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : (((vm.inSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (vm.isSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : (vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT));
      }
      vm.dividendOptions = vm.isSchemeTypeELSS ? vm.dividendOptionsELSS : vm.dividendOptionsOther;
      if (!vm.formData.isBackFromSummary && !vm.formData.sipDividendOption) {
        if($stateParams.action == 'modify' && !vm.modifiedSipDetails && vm.formData.dividendOption) {
          if (vm.formData.dividendOption == "Z") {
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          } else {
            if (vm.formData.dividendOption == "N" ) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
            } else if (vm.formData.dividendOption == "Y") {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            }
          }
        } else {
          if (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) {
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          } else {
            if (vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === false) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
            } else if (vm.inSchemeValidations.dividendPayoutApplicable === false && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            } else if (vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
            }
          }
          if($stateParams.action == 'modify') {
            vm.formData.modifyDividendOption = vm.formData.sipDividendOption;
          }
        }
      }
      if (vm.inSchemeValidations.validationType == 'SWITCH') {
        vm.switchSchemeInvestmentOption = vm.inSchemeValidations.investmentOption;
        vm.formData.switchDividendOption = (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : (((vm.inSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (vm.isSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : (vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST));
      }

      if(vm.inSchemeValidations.amountArray)
        vm.sipFirstInstallmentAmount=vm.inSchemeValidations.amountArray;

    }

    function setUpSipValidations() {
      vm.isInvalidForm = false;

      if (!vm.inSchemeValidations && !vm.outSchemeValidations) {
        vm.validations = {};
      }

      if (vm.outSchemeValidations) {
        vm.validations.isEnabled = vm.outSchemeValidations ? vm.outSchemeValidations.isEnabled : '';
        extractValidationObject(vm.outSchemeValidations);
      }

      if (vm.inSchemeValidations) {
        vm.validations.minInstallDivisionFlag = vm.inSchemeValidations.minInstallDivisionFlag;
        vm.validations.swpTaxCode = vm.inSchemeValidations.swpTaxCode;
        vm.validations.endingType = vm.inSchemeValidations.endingType;
        extractValidationObject(vm.inSchemeValidations);
      }
    }

    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.formData.frequency) {
        return;
      }

      vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
      vm.validations.topupAmtMultples = vm.validations.topupAmtMultples || 1;
      vm.validations.topupPercentageMultples = vm.validations.topupPercentageMultples || 1;
      vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
      vm.validations.minInstallments = vm.validations.minInstallments || 0;
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.maxAmount = vm.validations.maxAmount || 0;
      vm.validations.topupMinAmt = vm.validations.topupMinAmt || 0;
      vm.validations.topupMinPercentage = vm.validations.topupMinPercentage || 0;
      vm.validations.sipDefaultAmount = validationsData.sipDefaultAmount;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > 0 && vm.validations.maxAmount < vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }
      vm.validations.sipDefaultAmount = validationsData.sipDefaultAmount;
      switch (vm.formData.frequency) {
        case 'BZ':
          vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          if(validationsData.additionalValidation.BZ){
            vm.additionalSipData = validationsData.additionalValidation.BZ;
            vm.validations.minAmount = validationsData.additionalValidation.BZ[0].min_amount_lower;
          }
          break;
        case 'OW':
          vm.validations.maxInstallments = validationsData.weeklyMaxInstallmentNumber || 0;
          if(validationsData.additionalValidation.OW){
            vm.additionalSipData = validationsData.additionalValidation.OW;
            vm.validations.minAmount = validationsData.additionalValidation.OW[0].min_amount_lower;
          }
          break;
        case 'Q':
          vm.validations.maxInstallments  = validationsData.quarterlyMaxInstallmentNumber;
          vm.validations.topupMinAmt = validationsData.topupMinAmt;
          vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
          vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
          if(validationsData.additionalValidation.Q){
            vm.additionalSipData = validationsData.additionalValidation.Q;
            vm.validations.minAmount =validationsData.additionalValidation.Q[0].min_amount_lower;

          }
          break;
        case 'OM':
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.validations.topupMinAmt = validationsData.topupMinAmt;
          vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
          vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
          if(validationsData.additionalValidation.OM){
            vm.additionalSipData = validationsData.additionalValidation.OM;
            vm.validations.minAmount = validationsData.additionalValidation.OM[0].min_amount_lower;
          }
          break;
        case 'H':
          vm.additionalSipData = validationsData.additionalValidation.H;
          vm.validations.minAmount = validationsData.additionalValidation.H[0].min_amount_lower;
          vm.validations.maxInstallments = 0;
          break;
        case 'Y':
          vm.additionalSipData = validationsData.additionalValidation.Y;
          vm.validations.minAmount = validationsData.additionalValidation.Y[0].min_amount_lower;
          vm.validations.maxInstallments = 0;
          break;
      }
      if(!vm.showSavedData) {
        if( vm.formData.amount && (vm.validations.minAmount > vm.formData.amount)){
          vm.formData.amount =  vm.defaultData.sipDefaultAmount;
          vm.formData.displayAmount = vm.formData.amount && vm.formData.amount !== 0 ? UtilService.amountInComma(vm.formData.amount).amountInComma: 5000;
        } else if($stateParams.action == 'modify' && !vm.modifiedSipDetails){
          if(!vm.changedAmount) {
            vm.formData.amount = (vm.formData.amount < validationsData.sipDefaultAmount) && !vm.formData.backFromPaymentPage ? validationsData.sipDefaultAmount : vm.formData.amount;
            vm.formData.displayAmount = vm.formData.amount && vm.formData.amount !== 0 ? UtilService.amountInComma(vm.formData.amount).amountInComma: vm.formData.displayAmount;
          }
          vm.AmountFromModify = angular.copy(vm.formData.amount);
        } else if (!vm.renewDetails.amount){
          if ($stateParams.action == 'modify' ) {
            vm.formData.amount = vm.AmountFromModify > validationsData.sipDefaultAmount ? vm.AmountFromModify : validationsData.sipDefaultAmount;
            vm.formData.displayAmount = vm.formData.amount && vm.formData.amount !== 0 ? UtilService.amountInComma(vm.formData.amount).amountInComma: vm.formData.displayAmount;
          } else {
            // vm.formData.amount = vm.oldAmount > validationsData.sipDefaultAmount ? vm.oldAmount : validationsData.sipDefaultAmount;
          }
        }
        if(vm.formData.amount){
          $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
        }
      }
      if(vm.additionalSipData){
        checkSipValidations();
      }
    }

    function checkSipValidations(fromTopUp, fromHTML, cb) {
      cb = cb || function () {}
      if(vm.additionalSipData){
        var newValidation =  vm.additionalSipData;
        for (var i=0; i<newValidation.length;i++){
          var condition = vm.formData.amount < newValidation[i].min_amount_lower ||  vm.formData.amount <= newValidation[i].min_amount_upper
          if(!newValidation[i].min_amount_upper){
            var condition = true;
          }
          if(condition)
          {
            if((!vm.formData.showTopUpBlock || !vm.formData.sipTopupSelected) && !vm.backFromPayment)
            {
              if (vm.formData.frequency === 'OW') {
                //vm.formData.startDate = null;
                //vm.formData.endDate = null;
                //vm.formData.day = null;
                //vm.formData.weeklyDay = null;
              }
            }
            vm.validations.amountMultiples = newValidation[i].amt_multiples;
            vm.validations.maxAmount = newValidation[i].min_amount_upper;
            vm.validations.minAmount = newValidation[i].min_amount_lower;
            vm.validations.minInstallments = newValidation[i].min_installments;
            break;
          }
        }
      }
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }
      vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
      vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
      vm.isTopupMinAmt = !!(vm.validations.topupMinAmt && vm.validations.topupMinAmt > vm.formData.topupDetails.amount);
      vm.isTopupMinPerc = !!(vm.validations.topupMinPercentage && vm.validations.topupMinPercentage > vm.formData.topupDetails.percentage);
      vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
      vm.isTopUpMultiples = vm.validations.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.validations.topupAmtMultples === 0) || false;
      vm.isTopupPercMultiples = vm.validations.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.validations.topupPercentageMultples === 0) || false;
      vm.isInvalidForm = vm.formData.amount <= 0 || (vm.formData.amount && ( vm.isMax || vm.isMin || (vm.validations.amountMultiples && !vm.isMultiples)));
      if (!vm.isInvalidForm) {
        vm.isInvalidForm = vm.formData.topupDetails.amount <= 0 || (vm.formData.topupDetails.amount && (vm.isTopupMinAmt || (vm.validations.topupAmtMultples && !vm.isTopUpMultiples)));
      }
      // checkEMandateValidation();
      // vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.amount) && $window.NumToWord(vm.formData.topupDetails.amount, 'divDisplayInWords', vm);
      // vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.capAmount) && $window.NumToWord(vm.formData.topupDetails.capAmount, 'capAmntDisplayInWords', vm);
      if(!vm.formData.isBackFromSummary){
        angular.isDefined(vm.formData.topupDetails) && angular.isDefined(vm.formData.topupDetails.capAmount) &&(vm.formData.topupDetails.capAmount = vm.formData.topupDetails.capAmount ? vm.formData.topupDetails.capAmount : '');
      }
      if(vm.formData.amount == "" || vm.formData.amount == null) {
        resetNumInWords();
      } else {
        $window.NumToWord(vm.formData.amount,'divDisplayWords', vm);
      }

      if(vm.formData.amount && !fromHTML && !vm.isMax && !vm.isMin && (vm.validations.amountMultiples&&!vm.isMultiples) && !vm.amountExceeded) {
        vm.formData.amount = vm.defaultData.sipDefaultAmount;
        vm.formData.displayAmount = vm.formData.amount && vm.formData.amount !== 0 ? UtilService.amountInComma(vm.formData.amount).amountInComma: vm.formData.displayAmount;
        checkSipValidations();
      }

      if(vm.sipFirstInstallment)
        vm.formData.sipFirstAmount = vm.formData.amount;

      if(vm.formData.amount >= 2000000){
        vm.amountExceeded = true;
      }else {
        vm.amountExceeded = false;
      }

      if(fromTopUp) {
        return {
          isTopUpMultiples: vm.isTopUpMultiples,
          isTopupMinAmt: vm.isTopupMinAmt
        }
      }
      cb(true);
    }

    function getDateValidation(cb) {
      cb = cb || function () {};
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.currentDate = resp.data.currentDate || Date();
            vm.daysList = resp.data.listOfDays;
            vm.nonBusinessDatess = resp.data.nonBuisnessDates;
            calculateStartDate();
            vm.isReseting = true;
            $timeout(function () {
              vm.isReseting = false;
            });
            cb(true);
          } else {
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb(false);
        };
      InvestorService.get({
        child1: 'nonBusinessDate',
        schemeCode: vm.formData.inSchemeCode //'AFWDQ'
      }).$promise.then(success, error);
    }

    function calculateStartDate(cb) {
      cb = cb || function () {};
      var parsedDate = $window.moment(vm.currentDate, "DD-MMM-YYYY");
      vm.startMinDate = null;
      vm.startMinDate = $window.moment(Date.parse(parsedDate)).add(vm.inSchemeValidations.sipTStartDay, 'days');
      vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days').add(1, 'minutes');
      var businessDays = [];
      var count = 1;
      var today = $window.moment(); // Cache the current date
      var nonBusinessDatesArray = vm.nonBusinessDatess || []; // Fallback in case it's undefined

      // Calculate the first 5 business days (excluding non-business days)
      for (var i = 1; count <= 5 && i <= 90; i++) {
        var indexDate = today.clone().add(i, 'days');
        var formattedIndexDate = indexDate.format("DD-MMM-YYYY");
        var isNonBusinessDay = nonBusinessDatesArray.find(function (value) {
          return $window.moment(value, "DD-MMM-YYYY").format("DD-MMM-YYYY") === formattedIndexDate;
        });

        // If it's not a non-business day, add it to businessDays, include non-businessDay to businessDay if counter is 5 and Non-business day present
        if (!isNonBusinessDay || (isNonBusinessDay && count === 5)) {
          businessDays.push(indexDate);
          count++;
        }
      }

      // Set the 5th business day (T+5)
      var currentDay = businessDays[4].clone().set({ 'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0 });

      var enabledStartDates = [];

      // Generate start dates based on the selected weekly day within the next 90 days
      for (var i = 0; i <= 90; i++) {
        var checkDate = parsedDate.clone().add(i, 'days');
        var isAfterMinDate = $window.moment(vm.startMinDate, "DD-MMM-YYYY").diff(checkDate, 'days') <= 0;

        // Check if the day matches the selected day of the week
        if (isAfterMinDate && checkDate && checkDate.isSameOrAfter(currentDay)) {
          enabledStartDates.push(checkDate);
        }
      }

      // Update the enabled start dates and set the start date
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.formData.startDate = (vm.formData.backFromPaymentPage && vm.formData.startDate) || (vm.folioNumberChanged && vm.formData.startDate)? $window.moment(vm.formData.startDate) : vm.enabledStartDates[0];
      vm.formData.day = vm.formData.startDate.format('D');
      if(vm.formData.frequency !== 'OW'){
        if (($stateParams.transactionId || $stateParams.trackId) && $stateParams.initiatedBy !== 'schedule' && vm.savedStartDate) {
          // if (enabledFirstStartDate) {
          if (vm.savedStartDate.isBetween($window.moment(enabledStartDates[0]), $window.moment(enabledStartDates[enabledStartDates.length - 1]))) {
            vm.formData.startDate = vm.savedStartDate;
            vm.formData.day = vm.formData.startDate.format('D');
          } else {
            vm.savedStartDate = null;
            vm.savedEndDate = null;
            // vm.formData.startDate = angular.copy(vm.startMinDate);
            vm.formData.isTillPerpetuity = true;
          }
          // }
        } else {
          vm.formData.isTillPerpetuity = true;
          // vm.formData.startDate = angular.copy(vm.startMinDate);
        }
        updateEndDates();
      } else if (vm.formData.frequency === 'OW') {
        // if (enabledFirstStartDate) {
        if ((($stateParams.transactionId || $stateParams.trackId) && $stateParams.initiatedBy !== 'schedule' && vm.savedStartDate && vm.savedStartDate.isSameOrAfter($window.moment(vm.startMinDate, "DD-MMM-YYYY HH:mm A"))) || vm.formData.weeklyDay) {
          var day = vm.formData.weeklyDay ? vm.formData.weeklyDay : vm.daysList[0];
          changeDay(day);
        } else if (($stateParams.transactionId || $stateParams.trackId) && vm.savedStartDate && vm.savedStartDate.isBefore($window.moment(vm.startMinDate, "DD-MMM-YYYY HH:mm A"))) {
          vm.savedStartDate = null;
          vm.savedEndDate = null;
          changeDay(vm.daysList[0]);
        } else if ($stateParams.action === "modify" || $stateParams.action === "renew" || (vm.savedData && !vm.formData.weeklyDay && !vm.savedStartDate)) {
          changeDay(vm.daysList[0]);
        } else  {
          vm.savedweeklyDay = null;
          vm.savedStartDate = null;
          vm.savedEndDate = null;
        }
        // }
      }
      cb(true);
    }

    function updateEndDates(doNotUpdateEndDate,fromHTML) {
      if (!vm.formData.startDate) {
        return;
      }
      // configurable end year for future flexibility
      var targetEndYear = 2099; // Change this to any year if needed
      var startDate = vm.formData.startDate.clone(); // Cache start date clone to avoid multiple cloning
      // Calculate the default end date using the last day of December in the target end year
      var defaultEndDate = $window.moment({ year: targetEndYear, month: 11, day: 31 });
      var enabledEndDates = [];
      var frequency = vm.frequencyList.find(function (f) {
        return f.code === vm.formData.frequency;
      }) || {};
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var duration = frequency.duration || 1; // Default duration if frequency not found

      // Cache values that are used multiple times
      var endDate, days, months, calculatedEndDate, monthDependingUponFreq, yearDependingUponFreq, i;

      if (freq > 0) {
        var calculatedEndDate;

        // Adjust the end date calculation depending on the frequency type
        switch (vm.formData.frequency) {
          case 'BZ':
            calculatedEndDate = startDate.clone().add(freq * frequency.duration, 'days');
            break;

          case 'OW':
            calculatedEndDate = startDate.clone().add(freq > 1 ? freq - 1 : freq, 'weeks');
            break;

          case 'OM':
            calculatedEndDate = startDate.clone().add(freq, 'months');
            break;

          case 'Q':
            calculatedEndDate = startDate.clone().add(freq * frequency.duration, 'months');
            break;

          case 'H':
            calculatedEndDate = startDate.clone().add(freq * frequency.duration, 'months');
            break;

          case 'Y':
            calculatedEndDate = startDate.clone().add(freq, 'years');
            break;

          default:
            console.error("Unsupported frequency type");
        }

        // Set the calculated end date to have the same day as the start date
        if(vm.formData.frequency !== "OW" && vm.formData.frequency !== 'BZ') {
          var startDay = startDate.date();
          calculatedEndDate.date(Math.min(startDay, calculatedEndDate.daysInMonth()));
        }

        // Store as moment object for consistent use
        defaultEndDate = $window.moment(calculatedEndDate);
      }
      var minInstallments = (vm.validations && vm.validations.minInstallments || 1) - 1; // Ensure minimum installments default

      switch (vm.formData.frequency) {
        case 'BZ': // Daily
          var totalDays = defaultEndDate.diff(startDate, 'days'); // Calculate total days once
          freq = Math.ceil(totalDays / duration);
          for (i = 0; i < freq; i++) {
            enabledEndDates.push(startDate.clone().add(duration * i, 'days')); // Push all dates in one go
          }
          break;

        case 'OW': // Weekly
          var totalWeeks = UtilService.getNumberOfWeeks(startDate.toDate(), defaultEndDate.toDate()); // Total weeks between start and end
          for (i = 0; i <= totalWeeks; i++) {
            enabledEndDates.push(startDate.clone().add(duration * i, 'days')); // Push all weeks dates
          }
          break;

        default: // Monthly or other
          var totalMonths = defaultEndDate.diff(startDate, 'months'); // Calculate months only once
          freq = Math.ceil(totalMonths / duration);
          if(vm.formData.frequency === "OM") {
            for (i = 0; i <= freq; i++) {
              enabledEndDates.push(startDate.clone().add(duration * i, 'months')); // Add monthly dates
            }
          } else {
            for (i = 0; i < freq; i++) {
              enabledEndDates.push(startDate.clone().add(duration * i, 'months')); // Add monthly dates
            }
          }

          break;
      }

      // Remove unnecessary entries based on minInstallments
      vm.enabledEndDates = enabledEndDates.slice(minInstallments);

      // Set default view for enabled end date
      vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
      if (vm.validations.minInstallments > 0) {
        // Calculate end date based on maxInstallments and frequency
        var firstEnableEndDateYear = Math.round(vm.enabledEndDateView.diff(startDate, 'years', true));
      }
      if (!doNotUpdateEndDate) {
        vm.formData.minEndDate = angular.copy(vm.enabledEndDates[0]);
      } else {
        vm.formData.minEndDate = angular.copy(vm.enabledEndDates[0]);
      }
      vm.formData.maxEndDate = new Date(2099, 12, 31);

      changeTillPerpetuityFlag(function (selectedOther) {});

    }

    function changeTillPerpetuityFlag(cb) {
      cb = cb || function () {};
      vm.formData.endDate = (vm.formData.backFromPaymentPage && vm.formData.endDate) || (vm.folioNumberChanged && vm.formData.endDate) || (vm.amountChangeFromHTML && vm.formData.endDate) ? vm.formData.endDate : null;
      vm.resetting = true;

      $timeout(function () {
        vm.resetting = false;

        // Calculate the selected duration in years (5, 7, 10, or 99 for perpetuity)
        var selectedYear = vm.formData.isTillPerpetuity ? 99 : (vm.selectedDuration && vm.selectedDuration.value !== 0 ? vm.selectedDuration.value : 99);
        var day = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
        var month = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month() + 1; // Month is 1-indexed

        // Calculate end date based on selected duration (5, 7, 10, or 99 years)
        var endYear = selectedYear !== 99 ? $window.moment(vm.formData.startDate).add(selectedYear, 'years').year() : 2099;
        var newEndDate = day + '/' + month + '/' + endYear;
        var endDate = $window.moment(newEndDate, "DD-MM-YYYY");
        var defaultEndDateUpto30Years = $window.moment().add(30, 'years');

        // var freq = vm.validations && vm.validations.maxInstallments || 0;
        var frequency = vm.frequencyList.find(function (f) {
          return f.code === vm.formData.frequency;
        }) || {};

        // Determine behavior based on the selected frequency
        switch (vm.formData.frequency) {
          case 'BZ': // Daily frequency
            if(vm.formData.isTillPerpetuity === false) {
              vm.formData.endDate = null;
            } else {
              handleDailyFrequency(defaultEndDateUpto30Years);
            }
            break;

          case 'OW': // Weekly frequency
            handleWeeklyFrequency(defaultEndDateUpto30Years);
            break;

          default: // Monthly or other frequencies
            if(vm.formData.isTillPerpetuity === false) {
              vm.formData.endDate = null;
            } else {
              handleMonthlyFrequency(defaultEndDateUpto30Years, frequency);
            }
            break;
        }

        handleUPIMaxEndDate();

        // Handle max installments validation if necessary
        handleMaxInstallments(endDate, selectedYear);

        if(vm.showSavedData && vm.savedStartDate && vm.savedEndDate && (vm.savedEndDate.isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1])))) {
          vm.formData.endDate = vm.savedEndDate;
        }

        // Set endDate and invoke the callback
        vm.endDateDefaultForPerpetuity = vm.formData.endDate;
        changeEndDate(vm.formData.endDate);
        cb();

      }, 0);
    }

    function handleDailyFrequency(endDate) {
      var lastEnabledEndDate = $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1], "DD-MMM-YYYY").year();
      if (lastEnabledEndDate > 2099) lastEnabledEndDate = 2099;

      var day = $window.moment(vm.currentDate, 'DD-MMM-YYYY').date();
      var month = $window.moment(vm.currentDate, 'DD-MMM-YYYY').month() + 1;
      var currentDateYear = $window.moment(vm.currentDate).year();
      var defaultDateYearFromStartDate = currentDateYear + vm.maxMandateDurationYears;
      var newEndDate = day + '/' + month + '/' + defaultDateYearFromStartDate;
      var adjustedDate = $window.moment(newEndDate, "DD-MM-YYYY");
      vm.formData.endDate = (vm.formData.backFromPaymentPage && vm.formData.endDate) || (vm.folioNumberChanged && vm.formData.endDate) || (vm.amountChangeFromHTML && vm.formData.endDate) ? vm.formData.endDate : adjustedDate;

      adjustEndDateIfNeeded(adjustedDate);
    }

    function handleWeeklyFrequency(endDate) {
      var weeksDiff = UtilService.getNumberOfWeeks(vm.formData.startDate.toDate(), endDate.toDate());
      vm.formData.endDate = (vm.formData.backFromPaymentPage && vm.formData.endDate) || (vm.folioNumberChanged && vm.formData.endDate) || (vm.amountChangeFromHTML && vm.formData.endDate) ? vm.formData.endDate : vm.formData.startDate.clone().add(weeksDiff * 7, 'days');
    }

    function handleMonthlyFrequency(endDate, frequency) {
      var endDateMonths = UtilService.getNumberOfMonths(vm.formData.startDate, endDate);
      var totalMonths = Math.floor(endDateMonths / (frequency.duration || 1));
      var adjustedDate = vm.formData.startDate.clone().add(totalMonths * frequency.duration, 'months');
      vm.formData.endDate = (vm.formData.backFromPaymentPage && vm.formData.endDate) || (vm.folioNumberChanged && vm.formData.endDate) || (vm.amountChangeFromHTML && vm.formData.endDate) ? vm.formData.endDate : adjustedDate;

      adjustEndDateIfNeeded(adjustedDate);
    }

    function adjustEndDateIfNeeded(calculatedDate) {

      // Adjust end date to stay within valid bounds
      if(vm.formData.endDate && vm.enabledEndDates && vm.enabledEndDates.length > 0) {
        if(vm.formData.endDate.isBefore(vm.enabledEndDates[0])) {
          vm.formData.endDate = $window.moment(calculatedDate);
        }
      }
    }

    function handleMaxInstallments(endDate, selectedYear) {
      if (vm.validations && vm.validations.maxInstallments && vm.formData.endDate) {
        var lastEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
        var lastEndMonth = $window.moment(lastEndDate, 'DD-MMM-YYYY').month() + 1;
        var lastEndYear = $window.moment(lastEndDate, 'DD-MMM-YYYY').year();

        var calculatedEndMonth = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1;
        var calculatedEndYear = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').year();

        if (calculatedEndYear > lastEndYear || (calculatedEndYear === lastEndYear && calculatedEndMonth > lastEndMonth)) {
          vm.formData.endDate.set('year', Math.min(2099, lastEndYear));
        }

        // Ensure end date is within the enabled end dates
        if (((!$window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || (checkDateisPresentInEnableDates(vm.formData.endDate, vm.enabledEndDates))) && !vm.amountChangeFromHTML && calculatedEndYear >= lastEndYear) {
          vm.formData.endDate = angular.copy(lastEndDate);
        } else if (vm.formData.endDate && !vm.amountChangeFromHTML && !checkDateisPresentInEnableDates(vm.formData.endDate, vm.enabledEndDates)) {
          vm.formData.endDate = angular.copy(lastEndDate);
        } else if (vm.formData.endDate && vm.amountChangeFromHTML && !checkDateisPresentInEnableDates(vm.formData.endDate, vm.enabledEndDates)) {
          vm.formData.endDate = angular.copy(lastEndDate);
        }
      }
    }

    function handleUPIMaxEndDate() {
      if(!vm.formData.endDate) {
        return;
      }
      var defaultEndDateUpto30Years = $window.moment().add(30, 'years').subtract(1, 'days');
      var sipDateGreaterUPI =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter(defaultEndDateUpto30Years) ? true : false;
      if (sipDateGreaterUPI && !vm.formData.backFromPaymentPage) {
        var setEndDateLess = false;
        var indexSipEndDate = vm.enabledEndDates.length - 1;
        var tempEndDate;
        while (!setEndDateLess) {
          tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
          indexSipEndDate = indexSipEndDate - 1;
          if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(defaultEndDateUpto30Years, 'DD-MMM-YYYY'))) {
            setEndDateLess = true;
            vm.formData.endDate = angular.copy(tempEndDate);
          }

          if (indexSipEndDate == 0) {
            break;
          }
        }
      }
    }

    function changeStartDate(date) {
      if(!date) {
        return;
      }
      vm.formData.startDate = date ? date : null;
      vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
      updateEndDates();
    }

    function changeEndDate(date) {
      if(!date) {
        return;
      }
      vm.formData.endDate = date ? date : null;
      if (vm.formData.endDate && vm.formData.topupDetails && vm.formData.topupDetails.capMonthYearSelect) {
        var sipEndDateYear = vm.formData.endDate.year();
        var selectedTopUpYear = vm.formData.topupDetails.capMonthYearSelect.year();
        if (selectedTopUpYear > sipEndDateYear) {
          vm.formData.topupDetails = {};
          vm.formData.sipTopupSelected = false;
        }
      } else if ($stateParams.action !== "modify" && vm.formData.topupDetails && !vm.formData.topupDetails.capAmount) {
        vm.formData.topupDetails = {};
        vm.formData.sipTopupSelected = false;
      }
      vm.diffInMonths = parseInt($window.moment(vm.formData.endDate).diff($window.moment(vm.formData.startDate), 'months', true));
      if (!vm.diffInMonths ? false : vm.diffInMonths >= 6 && (vm.formData.frequency == 'OM' || vm.formData.frequency == 'Q')) {
        vm.formData.showTopUpBlock = true;
        capAmountChanged();
        var capStartDate;
        if(!vm.formData.backFromPaymentPage && !vm.showSavedData) {
          if (vm.diffInMonths >= 12) {
            capStartDate = $window.moment(vm.formData.startDate).add(12, 'months');
            vm.formData.topupDetails.frequency = 'Y';
          } else {
            capStartDate = $window.moment(vm.formData.startDate).add(6, 'months');
            vm.formData.topupDetails.frequency = 'H'
          }
        } else {
          if(vm.formData.backFromPaymentPage && vm.formData.topupDetails && (vm.formData.topupDetails.capAmount || vm.formData.topupDetails.capMonthYearSelect)) {
            if (vm.diffInMonths >= 12) {
              capStartDate = $window.moment(vm.formData.startDate).add(12, 'months');
              vm.formData.topupDetails.frequency = 'Y';
            } else {
              capStartDate = $window.moment(vm.formData.startDate).add(6, 'months');
              vm.formData.topupDetails.frequency = 'H'
            }
          } else if (vm.formData.backFromPaymentPage && Object.keys(vm.formData.topupDetails).length == 0) {
            vm.formData.topupDetails.frequency = 'Y';
            if(vm.formData.topupDetails && vm.formData.topupDetails.frequency === 'Y') {
              capStartDate = $window.moment(vm.formData.startDate).add(12, 'months');
            } else if (vm.formData.topupDetails && vm.formData.topupDetails.frequency === 'H') {
              capStartDate = $window.moment(vm.formData.startDate).add(6, 'months');
            }
          } else {
            if(vm.formData.topupDetails && vm.formData.topupDetails.frequency === 'Y') {
              capStartDate = $window.moment(vm.formData.startDate).add(12, 'months');
            } else if (vm.formData.topupDetails && vm.formData.topupDetails.frequency === 'H') {
              capStartDate = $window.moment(vm.formData.startDate).add(6, 'months');
            }
          }
        }
        updateTopupFrequency();
        vm.capDates = [];
        var capLastDate = capStartDate;
        while ($window.moment(capLastDate, "MMM-YYYY").isSameOrBefore($window.moment(vm.formData.endDate, "MMM-YYYY"))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(angular.copy($window.moment(capStartDate, 'DD-MMM-YYYY').startOf('month')));
          }
          // capStartDateValue = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          capStartDate = $window.moment(capStartDate).add(12, 'months');
          if ($window.moment(capStartDate).isSameOrBefore($window.moment(vm.formData.endDate))) {
            vm.capDates.push(angular.copy($window.moment(capStartDate, 'DD-MMM-YYYY').startOf('month')));
          } else {
            break;
          }
          capLastDate = angular.copy(vm.capDates[vm.capDates.length - 1]);
          vm.enableCapDateView = vm.capDates[0];
        }
      } else {
        vm.formData.showTopUpBlock = false;
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        vm.formData.topupDetails = {};
        vm.sipTopupEnabled = false;
        resetTopupDetails();
        // getTopupFrequencyList();
      }
    }

    function changeDay(selectedDay) {
      vm.formData.weeklyDay = selectedDay ? selectedDay : null;
      if(!vm.formData.weeklyDay) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        return;
      }
      switch (vm.formData.frequency) {
        case 'BZ':
          // reSetting();
          break;
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          // updateDatesForOthers();
          break;
        default :
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          // reSetting();
          break;
      }
    }

    function updateDatesForWeekly() {
      var businessDays = [];
      var count = 1;
      var today = $window.moment(); // Cache the current date
      var nonBusinessDatesArray = vm.nonBusinessDatess || []; // Fallback in case it's undefined

      // Calculate the first 5 business days (excluding non-business days)
      for (var i = 1; count <= 5 && i <= 90; i++) {
        var indexDate = today.clone().add(i, 'days');
        var formattedIndexDate = indexDate.format("DD-MMM-YYYY");
        var isNonBusinessDay = nonBusinessDatesArray.find(function (value) {
          return $window.moment(value, "DD-MMM-YYYY").format("DD-MMM-YYYY") === formattedIndexDate;
        });

        // If it's not a non-business day, add it to businessDays
        if (!isNonBusinessDay) {
          businessDays.push(indexDate);
          count++;
        }
      }

      // Set the 5th business day (T+5)
      var currentDay = businessDays[4].clone().set({ 'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0 });

      // Find the specified weekly day
      var selectedDay = vm.daysList.find(function (d) {
        return d === vm.formData.weeklyDay;
      }) || {};

      var enabledStartDates = [];

      // Generate start dates based on the selected weekly day within the next 90 days
      for (var i = 0; i < 90; i++) {
        var checkDate = currentDay.clone().add(i, 'days');
        var isAfterMinDate = $window.moment(vm.startMinDate, "DD-MMM-YYYY").diff(checkDate, 'days') <= 0;

        // Check if the day matches the selected day of the week
        if (isAfterMinDate && checkDate.format('dddd').toLowerCase() === selectedDay.toLowerCase()) {
          enabledStartDates.push(checkDate);
        }
      }

      // Update the enabled start dates and set the start date
      vm.enabledStartDates = angular.copy(enabledStartDates);
      if(vm.savedStartDate) {
        vm.formData.startDate = vm.savedStartDate;
      } else {
        if(vm.formData.backFromPaymentPage || vm.formData.startDate) {
          var isExactMatch = checkDateisPresentInEnableDates(vm.formData.startDate, vm.enabledStartDates);
          if (isExactMatch) {
            vm.formData.startDate = angular.copy(vm.formData.startDate);
          } else {
            vm.formData.startDate = vm.enabledStartDates[0];
          }
        } else {
          vm.formData.startDate = vm.enabledStartDates[0];
        }
      }
      updateEndDates();
    }

    function resetTopupDetails() {
      vm.formData.topupDetails = {};
    }

    function capAmountChanged() {
      vm.amountInWords = '';
      if(vm.formData.topupDetails.amount) {
        vm.minCapAmount = vm.formData.amount + vm.formData.topupDetails.amount;
      }
      // else if (vm.formData.topupDetails.percentage){
      //   vm.minCapAmount = vm.formData.amount + (vm.formData.topupDetails.percentage * vm.formData.amount/100)
      // }

      if(vm.formData.topupDetails.capAmount && (vm.formData.topupDetails.capAmount < vm.minCapAmount )) {
        vm.isminCapAmount = true
      }
      else{
        vm.isminCapAmount = false
      }
    }

    function updateTopupFrequency() {
      if ((vm.diffInMonths >= 6 && vm.diffInMonths <= 12 ) || (vm.formData.topupDetails.diffInMonths >= 6 && vm.formData.topupDetails.diffInMonths <= 12)) {
        vm.topupFrequencyList = [
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
      } else {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12},
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
      }
      if(vm.formData.frequency && (vm.formData.frequency === 'Q')) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12}
        ];
      }
    }

    function changeCapMonthYear(capMonthYear) {
      if(!capMonthYear) {
        return;
      }

      vm.formData.topupDetails.capMonthYearSelect = capMonthYear ? capMonthYear : null;
    }

    function changeTopUpFreq(selectedFreq, fromTopup) {
      if(selectedFreq) {
        vm.formData.topupDetails.frequency = selectedFreq.key;
        vm.formData.topupDetails.capMonthYearSelect = "";
      }
      var duration = 6;
      switch (vm.formData.topupDetails.frequency){
        case 'H':duration=6;break;
        case 'Y':duration=12;break;
      }
      if(duration === 12){
        var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months');
      }
      else{
        capStartDate = $window.moment(vm.formData.startDate).add(6, 'months');
      }

      vm.capDates = [];
      var capLastDate = capStartDate;
      while ($window.moment(capLastDate,"MMM-YYYY").isSameOrBefore($window.moment(vm.formData.endDate,"MMM-YYYY"))) {
        if (vm.capDates.length === 0) {
          vm.capDates.push(angular.copy($window.moment(capStartDate, 'DD-MMM-YYYY').startOf('month')));
        }
        capStartDate = $window.moment(capStartDate).add(duration, 'months');
        if ($window.moment(capStartDate).isSameOrBefore($window.moment(vm.formData.endDate))) {
          vm.capDates.push(angular.copy($window.moment(capStartDate, 'DD-MMM-YYYY').startOf('month')));
        }
        else {
          break;
        }
        capLastDate = vm.capDates[vm.capDates.length - 1];
      }

      if(fromTopup) {
        return {
          capDates: vm.capDates
        }
      }
    }

    function resetCapAmount() {
      if (!vm.formData.topupDetails.amount || !vm.formData.topupDetails.percentage) {
        delete vm.formData.topupDetails.capAmount;
        delete vm.formData.topupDetails.capMonthYearSelect;
      }
    }

    /*
    * Function responsible to check the pan aadhar link status with the selected folio number
    * */
    function checkPanAadharLinkStatus(cb) {
      cb = cb || function () {};

      var successHandler = function() {
        LoaderService.hideLoader();
        cb(true);
      }, errorHandler = function(err) {
        LoaderService.hideLoader();
        cb(err);
      };
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);
    }


    function searchDistributor() {

      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }

      if (!vm.formData.subBrokerARN) {
        fetchEuinList();
      } else if (vm.formData.subBrokerARN) {
        fetchEuinListSubBroker();
      }

      // vm.compareDataFromSystematic();
    }


    function fetchEuinList(arnBySearch) {
      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode && !arnBySearch) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      vm.formData.brokerName = vm.formData.brokerName? vm.formData.brokerName :'';
      vm.formData.riaBrokerName = vm.formData.riaBrokerName? vm.formData.riaBrokerName :'';
      vm.subBrokerCodeError = '';
      vm.euinData = {};
      vm.isArnSuccess = true;
      vm.distributorList = null;
      if (!vm.formData.isBackFromSummary && !vm.riaConsent) {
        vm.isCheckedTandC = vm.formData.isCheckedTandC;
        if (!$stateParams.isCompId && !$stateParams.trackId) {
          vm.formData.euin = vm.formData.euin ? vm.formData.euin : '';
        }
      }

      //vm.isInvalidForm = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin ? vm.formData.euin : {};
            vm.brokerCodeError = '';
            vm.riaCodeError = '';
            vm.isArnSuccess = false;
            if (vm.formData.isThroughDistributor) {
              vm.formData.brokerName = resp.data.distributorName;
              if(vm.euinList && vm.euinList.length === 1) {
                selectEuin(vm.euinList[0]);
              }
            } else if (vm.formData.isThroughRia) {
              vm.formData.riaBrokerName = resp.data.distributorName;
            }
          } else {
            vm.euinList = null;
            if (vm.formData.isThroughDistributor) {
              vm.brokerCodeError = resp.message;
            } else if (vm.formData.isThroughRia) {
              vm.riaCodeError = resp.message;
              vm.isCheckedTandC = false;
              vm.formData.isCheckedTandC = false;
              vm.formData.riaBrokerName = "";
            }
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          vm.formData.riaBrokerName = "";
        };

      LoaderService.showLoader();
      var path = {};
      if (vm.formData.isThroughDistributor) {
        path  = {
          controller1: 'getEuin',
          controller2: arnBySearch ? arnBySearch : 'ARN-' + vm.formData.brokerCode
        };
      } else if (vm.formData.isThroughRia) {
        path = {
          controller1: 'getEuin',
          controller2: vm.formData.riaBrokerCode,
          riaOpted: vm.formData.isThroughRia
        };
      }
      TransactionService.get(path).$promise.then(success, error);
    }


    function fetchEuinListSubBroker() {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        vm.formData.euin = {};
        vm.euinData = {};
        fetchEuinList();
        return;
      }
      // if(vm.formData.brokerCode !== vm.formData.subBrokerARN){
      //   vm.formData.euin = {};
      //   vm.euinData = {};
      // }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            for(var i = 0; i<vm.euinList.length; i++){
              if(vm.euinData && vm.euinData.euinNameCode && (vm.euinData.euinNameCode === vm.euinList[i].euinNameCode)){
                vm.formData.euin = vm.euinList[i];
                break;
              } else {
                vm.formData.euin = {};
              }
            }
            if (vm.formData.isThroughDistributor) {
              vm.formData.brokerName = resp.data.distributorName;
              if(vm.euinList && vm.euinList.length === 1) {
                selectEuin(vm.euinList[0]);
              }
            }
            vm.euinData = vm.formData.euin;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
          } else {
            vm.euinList = null;
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = {};
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
        };

      LoaderService.showLoader();
      TransactionService.get({
        controller1: 'getEuin',
        controller2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: vm.formData.isThroughDistributor
      }).$promise.then(success, error);
    }


    function changeSubBrokerArn() {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      // vm.compareDataFromSystematic();
    }

    function changeSubBrokerCode(){
      // vm.compareDataFromSystematic();
    }

    function filterEuinList() {
      vm.formData.euin = {};
      vm.isSelectedEuin = false ;
      if(vm.euinData.euinNameCode){
        if(vm.euinData.euinNameCode.length>=3){
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.euinData.euinNameCode);
        }
      }
      vm.euinList = vm.euinData.euinNameCode == '' || vm.euinData.euinNameCode == undefined || vm.euinData.euinNameCode.length<3 ? vm.euinMasterList : vm.euinList;
    }


    function setTandCVariable() {
      vm.copyOfIsCheckedTandC = vm.isCheckedTandC;
      vm.formData.isCheckedTandC = vm.isCheckedTandC;
    }


    function changeDistributorCode() {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.euinList = null;
      if (!vm.formData.subBrokerARN) {
        vm.isArnSuccess = true;
      }
      vm.riaCodeError = "";
      vm.formData.riaBrokerName = "";
    }


    function selectEuin(data) {
      if (!data) {
        return;
      }
      vm.euinData = {};
      vm.euinData.euinNameCode = data.euinNameCode;
      vm.formData.euin.euinName = data.euinName;
      vm.formData.euin.euinCode = data.euinCode;
      vm.isSelectedEuin = vm.euinData.euinNameCode ? true : false;
    }

    /*
   * Function responsible to check the pan aadhar link status with the selected folio number
   * */

    function fetchDataFromSaveFlow(flowType,cb) {
      cb = cb || function () {};

      var config = {};

      var success = function (resp) {
          if (resp.data && resp.status) {
            cb(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      switch (flowType) {
        case 'saved':
        case 'favourite':

          if (!$stateParams.transactionId) {
            MessageService.error("TransactionId is missing for saved transaction.");
            $state.go('main.dashboard');
            break;
          }

          config = {
            controller1: 'transaction',
            controller2: 'saved',
            controller3: $stateParams.transactionId,
            controller4: $stateParams.isCompId
          }
          break;
        case 'netcore':
          config = {
            controller1: 'userBehavior',
            controller2: $stateParams.trackId,
            controller3: 'getFormData'
          }
          break;

      }

      TransactionService.get(config).$promise.then(success, error);
    }

    function handleInvestThroughPrefill(formData) {

      if (formData.euinOpted === 'Y') {
        if(formData.subBrokerARN) {
          vm.formData.subBrokerARN = formData.subBrokerARN.replace('ARN-', '');
          // vm.fetchEuinListSubBroker();
        }
        vm.formData.subBrokerCode = formData.subBrokerCode ? formData.subBrokerCode : '';
        vm.euinData = {
          euinName: formData.euinName ? formData.euinName : formData.euin && formData.euin.euinName ? formData.euin.euinName : '',
          euinCode: formData.euinCode ? formData.euinCode : formData.euin && formData.euin.euinCode ? formData.euin.euinCode : '',
          euinNameCode: formData.euinName && formData.euinCode ? formData.euinName + '-' + formData.euinCode : formData.euin && formData.euin.euinName && formData.euin.euinCode ? formData.euin.euinName + '-' + formData.euin.euinCode : ''
        };
        vm.formData.euin = vm.euinData;
        vm.formData.isEuin = true;
      } else if (formData.euinOpted === 'N') {
        vm.formData.euin = {};
        vm.formData.euinCode = null;
        vm.formData.euinName = null;
        vm.formData.euinNameCode = null;
        vm.formData.euinInput = null;
      }

      if (formData.riaOpted || formData.riaConsent || formData.isThroughRia) {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = true;
        vm.formData.isDirect = false;
        vm.isArnSuccess = false;
        vm.formData.riaBrokerCode = formData.brokerCode || formData.riaBrokerCode;
        vm.riaConsent = formData.riaConsent;
        vm.isCheckedTandC = formData.riaConsent;
        searchDistributor();
      } else if (formData.brokerCode && !formData.riaOpted && !formData.riaConsent) {
        if(formData.subBrokerARN) {
          vm.formData.subBrokerARN = formData.subBrokerARN.replace('ARN-', '');
          // vm.fetchEuinListSubBroker();
        }
        vm.formData.subBrokerARN = formData.subBrokerARN && formData.subBrokerARN.replace('ARN-', '') || formData.subBrokerArn && formData.subBrokerArn.replace('ARN-', '');
        vm.formData.brokerCode = formData.brokerCode && formData.brokerCode.replace('ARN-', '');
        vm.formData.isThroughDistributor = true;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = false;
        if (formData.euinName && formData.euinCode) {
          vm.formData.euinInput = formData.euinName + ' - ' + formData.euinCode;
        }
        vm.formData.isEuin =  formData.euinOpted && formData.euinOpted === 'Y' ? true : false;
        vm.isCheckedTandC = formData.euinOpted && formData.euinOpted === 'Y' ? false : true;
        vm.formData.isCheckedTandC = formData.euinOpted && formData.euinOpted === 'Y' ? false : true;
        vm.isSelectedEuin = vm.euinData && vm.euinData.euinNameCode ? true : false;
        searchDistributor();
        if (!vm.formData.subBrokerARN) {
          changeDistributorCode();
        } else {
          vm.brokerCodeError = '';
          vm.subBrokerCodeError ='';
        }
      } else if (formData.distributorName && !formData.riaOpted && !formData.riaConsent) {
        vm.formData.subBrokerARN = formData.subBrokerARN && formData.subBrokerARN.replace('ARN-', '');
        vm.formData.isThroughDistributor = true;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = false;
        vm.formData.isEuin =  formData.euinOpted && formData.euinOpted === 'Y' ? true : false;
        vm.isCheckedTandC = formData.euinOpted && formData.euinOpted === 'Y' ? false : true;
        vm.isSelectedEuin = vm.euinData && vm.euinData.euinNameCode ? true : false;
        searchDistributorByName(formData.distributorName);
        $timeout(function () {
          vm.formData.distributorName = formData.distributorName ? formData.distributorName : null;
        }, 1000)
      } else {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
      }
    }


    function setDynamicData() {
      if (vm.formData.investmentType === 'SIP')
      {
        vm.notesReview = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_Registration;
        vm.popup = vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_SIP_Review;
        vm.notesOtm = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_OTM;
        vm.notesEOtm = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_eOTM;
        vm.notesUPI = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_UPI;
        vm.riaMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_SIP_Review_Through_RIA;
        vm.distributorMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_SIP_Through_Distributor;
        vm.notesEOtmDebitCard = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_eOTM_Debit_Card;
        vm.key = "TNC_SIP_Review_Registration";
        vm.keyOtm = "TNC_SIP_Review_Registration_eOTM";
        vm.upiModalNote = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_UPI_2FA;

        if(!vm.distributorMessage)
          vm.formData.isCheckedTandC = false;

        if(!vm.riaMessage)
          vm.formData.isCheckedTandC = false;
      }
      else if (vm.formData.investmentType === 'PURCHASE') {
        vm.notesReview = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.NOTE_Review_Purchase_Investment;
        vm.popup = vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_ProceedToTransact;
        vm.riaMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Purchase_Through_RIA;
        vm.distributorMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Purchase_Through_Distributor;
        vm.key = "TNC_Review_Purchase_Investment"

        if(!vm.distributorMessage)
          vm.formData.isCheckedTandC = false;
      }
    }


    function saveData() {
      vm.isRequired = false;
      vm.isSaving = true;
      var payload = getSipPurchasePayloadToSave();

      if (!payload) {
        return;
      }

      LoaderService.showLoader();

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (angular.isArray(resp.data)) {
              var data = {};
              resp.data.forEach(function (_form) {
                if (_form) {
                  switch (_form.transactionType) {
                    case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
                      data.sipForm = _form;
                      break;
                    case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
                      data.purchaseForm = _form;
                      break;
                  }
                }
              });

              vm.formData.sTransactionId = data.sipForm ? data.sipForm.transactionId : '';
              vm.formData.pTransactionId = data.purchaseForm ? data.purchaseForm.transactionId : '';
            } else {
              vm.formData.transactionId = resp.data.transactionId;
            }

            var successModal= function () {
              $state.go('welcome')
            };
            ModalService.savedTransactionModal({newFlow : true},successModal);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      var _controller2 = vm.transactionType.toLowerCase();
      TransactionService.post({
        controller1: 'transaction',
        controller2: _controller2,
        controller3: 'save'
      }, payload).$promise.then(success, error);
    }
    function searchDistributorByName(prefillData) {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      //vm.isInvalidForm = true;
      vm.brokerCodeError = '';
      if (!vm.formData.subBrokerARN) {
        vm.isArnSuccess = true;
      }
      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        vm.distributorList = null;
        vm.euinList = null;
        //vm.formData.euinInput = '';
        vm.formData.euin = null;
        return;
      }
      fetchARNByName(prefillData);
    }

    function fetchARNByName(prefillData) {

      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        return;
      }
      vm.formData.distributorARN = '';
      vm.distributorList = null;
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.distributorList = resp.data.distributorList;
            if (vm.distributorList.length == 0) {
              //vm.isInvalidForm = true;
              vm.formData.euin = {};
              vm.isCheckedTandC = false;
            }
            if(prefillData && vm.distributorList && vm.distributorList.length > 0) {
              vm.brokerCodeError = '';
              vm.formData.distributorARN = 'ARN-' + prefillData.split('-')[2];
              vm.formData.distributorName = prefillData;
              vm.showArnLabel = false;
              if (vm.formData.distributorARN) {
                //vm.isInvalidForm = false;
                vm.isArnSuccess = false;
              }
              else {
                vm.isArnSuccess = true;
              }
              fetchEuinList(vm.formData.distributorARN);
            }
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.distributorList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.distributorList=null;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getDistributor',
        controller2: prefillData ? prefillData.split('-')[0].toLowerCase() : vm.formData.distributorName
      }).$promise.then(success, error);
    }

    function showTopUpDetails() {
      var success = function(resp) {
        vm.formData.sipTopupSelected = true;
        vm.isminCapAmount = resp;
        vm.formData.topupDetails.previousValidAmount = vm.formData.topupDetails.amount;
        vm.formData.topupDetails.previousFreq = vm.formData.topupDetails.frequency;
        vm.formData.topupDetails.previousCapAmount = vm.formData.topupDetails && vm.formData.topupDetails.capAmount ? vm.formData.topupDetails.capAmount : null;
        vm.formData.topupDetails.previousCapYear = vm.formData.topupDetails && vm.formData.topupDetails.capMonthYearSelect ? $window.moment(vm.formData.topupDetails.capMonthYearSelect) : null;
      }, error = function(err) {
        if(err) {
          vm.isminCapAmount = err.isminCapAmount;
        }
        vm.isInvalidForm = false;
        if(vm.formData.sipTopupSelected) {
          vm.formData.topupDetails.amount = vm.formData.topupDetails && vm.formData.topupDetails.previousValidAmount ? vm.formData.topupDetails.previousValidAmount : null;
          vm.formData.topupDetails.displayAmount = vm.formData.topupDetails.amount ? UtilService.amountInComma(vm.formData.topupDetails.amount).amountInComma: null;
          vm.formData.topupDetails.frequency = vm.formData.topupDetails.previousFreq;
          vm.formData.topupDetails.capAmount = vm.formData.topupDetails.previousCapAmount ? vm.formData.topupDetails.previousCapAmount : null;
          vm.formData.topupDetails.displayCapAmount = vm.formData.topupDetails.capAmount ? UtilService.amountInComma(vm.formData.topupDetails.capAmount).amountInComma : vm.formData.topupDetails.capAmount;
          vm.formData.topupDetails.capMonthYearSelect = vm.formData.topupDetails.previousCapYear ? $window.moment(vm.formData.topupDetails.previousCapYear) : null;
        }
      };
      ModalService.topupDetailsModal({
        formData: vm.formData,
        capDates: vm.capDates,
        enableCapDateView: angular.copy(vm.enableCapDateView),
        topupFrequencyList: vm.topupFrequencyList,
        isTopupMinAmt: vm.isTopupMinAmt,
        isTopUpMultiples: vm.isTopUpMultiples,
        isminCapAmount: vm.isminCapAmount,
        validations: vm.validations
      }, success, error);
    }

    function showSIPDetails() {
      var success = function() {
        vm.formData.sipViaPurchaseSelected = true;
        vm.formData.mixTransactionType = "SIPPURCHASE";
        vm.formData.sipDetailsViaPurchase.previousValidAmount = vm.formData.sipDetailsViaPurchase.sipAmount;
        vm.formData.sipDetailsViaPurchase.previousStartDate = vm.formData.startDate ? vm.formData.startDate : null;
        vm.formData.sipDetailsViaPurchase.previousEndDate = vm.formData.endDate ? vm.formData.endDate : null;
      }, error = function() {
        if(!vm.formData.sipViaPurchaseSelected) {
          vm.formData.startDate = null;
          vm.formData.endDate = null;
          vm.formData.sipDetailsViaPurchase.sipAmount = vm.defaultData.purchaseDefaultAmount;
          vm.formData.sipDetailsViaPurchase.sipDisplayAmount = vm.formData.sipDetailsViaPurchase.sipAmount? UtilService.amountInComma(vm.formData.sipDetailsViaPurchase.sipAmount).amountInComma: null;
          vm.formData.sipDetailsViaPurchase.previousValidAmount = vm.formData.sipDetailsViaPurchase.sipAmount;
        }
        if(vm.formData.sipViaPurchaseSelected) {
          vm.formData.sipDetailsViaPurchase.sipAmount = vm.formData.sipDetailsViaPurchase && vm.formData.sipDetailsViaPurchase.previousValidAmount ? vm.formData.sipDetailsViaPurchase.previousValidAmount : null;
          vm.formData.sipDetailsViaPurchase.sipDisplayAmount = vm.formData.sipDetailsViaPurchase.sipAmount? UtilService.amountInComma(vm.formData.sipDetailsViaPurchase.sipAmount).amountInComma: null;
          vm.formData.startDate = vm.formData.sipDetailsViaPurchase && vm.formData.sipDetailsViaPurchase.previousStartDate ? $window.moment(vm.formData.sipDetailsViaPurchase.previousStartDate) : null;
          vm.formData.endDate = vm.formData.sipDetailsViaPurchase && vm.formData.sipDetailsViaPurchase.previousEndDate ? $window.moment(vm.formData.sipDetailsViaPurchase.previousEndDate) : null;
        }
      };
      ModalService.sipDetailsModal({formData: vm.formData, defaultFreq : vm.selectedFreq, maxMandateDurationYears : vm.maxMandateDurationYears}, success, error);
    }

    function proceedToTransact() {
      moveToSummary();
      if(vm.formData.mixTransactionType === "SIPPURCHASE") {
        TransactionModel.setPayloadRawData(vm.formData);
        setTandCVariable();
        var payloadData = getFinalPayloadData();
        if (!payloadData) {
          return;
        }
        var selectedFolioObj = vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        payloadData.email = selectedFolioObj.email ? selectedFolioObj.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
        payloadData.mobileNumber = selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;
        TransactionModel.setPayloadRawData(payloadData);
        addItemToCart();
      } else {
        checkDuplicate();
      }
    }

    function checkDuplicate() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                validateTransaction();
              }, errorModal = function () {
              };

              LoaderService.hideLoader();
              ModalService.transactionWarningModal({msg: resp.data.warningMessage, showBlueBtn : true}, successModal, errorModal)
            }
            else {
              validateTransaction();
            }
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType: vm.formData.investmentType,
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.purchaseInSchemeCode,
        amount: vm.formData.amount
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'transaction',
        child2: 'check',
        child3: 'duplicate'
      }, payload).$promise.then(success, error);
    }

    function validateTransaction() {
      var payload = getSipPurchasePayloadToSave();
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.transactionId = resp.data.transactionID;
            if(vm.formData.backFromPaymentPage && !vm.folioNumberChanged) {
              var id = null;
              var transType = null;
              if (vm.formData.sipViaPurchaseSelected) {
                id = vm.formData.folioNumber;
                transType = 'SIPPURCHASE';
              } else {
                id = vm.transactionId;
                transType = vm.formData.investmentType;
              }

              $state.go('main.paymentHome',{
                linkId: id,
                type: transType,
                trackId: vm.transId || vm.formData.trackId
              })
            } else {
              generateOTP();
            }
          } else if (resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message,
              showBlueBtn: true
            });
            LoaderService.hideLoader();
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }

       },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      InvestorService.post({
        child1: 'validate',
        child2: 'transaction'
      }, payload).$promise.then(success, error);
    }

    function addItemToCart() {
      var payload = getMixTransactionPayload();
      var success = function (resp) {
          if (resp.status && resp.data) {
            if(vm.formData.backFromPaymentPage && !vm.folioNumberChanged) {
              var id = null;
              var transType = null;
              if (vm.formData.sipViaPurchaseSelected) {
                id = vm.formData.folioNumber;
                transType = 'SIPPURCHASE';
              } else {
                id = vm.transactionId;
                transType = vm.formData.investmentType;
              }

              $state.go('main.paymentHome',{
                linkId: id,
                type: transType,
                trackId: vm.transId || vm.formData.trackId
              })
            } else {
              generateOTP();
            }
          } else if (resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message,
              showBlueBtn: true
            });
            LoaderService.hideLoader();
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      investorServiceVersion.post({
        child1: 'cart',
        child2: 'add',
        child3: 'item'
      }, payload).$promise.then(success, error);
    }

    function generateOTP() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.secretLink = resp.data.secretLink;
            sessionStorage.setItem('sl', vm.secretLink);
            showOTPModal();
            MessageService.success("OTP sent successfully.");
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        folioNumber: vm.formData.folioNumber,
        transactionType: vm.formData.investmentType,
        randomOTPId: vm.randomOTPId
      };
      TransactionService.post2({
        controller1: 'transaction',
        controller2: 'otp'
      }, payload).$promise.then(success, error);
    }

    function showOTPModal() {
      var success = function(){
        var id = null;
        var transType = null;
        if (vm.formData.sipViaPurchaseSelected) {
          id = vm.formData.folioNumber;
          transType = 'SIPPURCHASE';
        } else {
          id = vm.transactionId;
          transType = vm.formData.investmentType;
        }

        $state.go('main.paymentHome',{
          linkId: id,
          type: transType,
          trackId: vm.transId || vm.formData.trackId
        })
      }, error = function(){};
      ModalService.otpAutoMoveToNextFieldModal({
        secretLink: vm.secretLink,
        folioNumber: vm.formData.folioNumber,
        transactionType: vm.formData.investmentType
      }, success, error);
    }

    function changeInvestmentTypeOption(investThrough, fromWhere, cb) {
      cb = cb || function () {};
      if(fromWhere === "FROM_SCHEME_MODAL") {
        vm.switchInvestmentType = true;
      }
      investmentTypeVariableUpdate(investThrough, fromWhere);
      cb(true);
    }

    function disabledInvestmentType(investThrough) {
      var previousInvestmentType = "";
      if(vm.formData.isDirect) {
        previousInvestmentType = "DIRECT";
      }
      if(vm.formData.isThroughRia) {
        previousInvestmentType = "RIA"
      }
      if(vm.formData.isThroughDistributor) {
        previousInvestmentType = "ARN";
      }

      if((vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP && vm.formData.inSchemeCode) || (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE && vm.formData.purchaseInSchemeCode)) {
        if(investThrough === "ARN" && (investThrough !== previousInvestmentType)) {
          MessageService.error("For Direct scheme Distributor is not allowed.");
          $timeout(function () {
            changeInvestmentTypeOption(previousInvestmentType);
            if(previousInvestmentType == "RIA") {
              vm.formData.riaBrokerCode = vm.riaCodeCopy;
              vm.isCheckedTandC = vm.copyOfIsCheckedTandC;
            }
          });
          return true;
        } else if ((investThrough === "DIRECT" || investThrough === "RIA") && (previousInvestmentType === "DIRECT" || previousInvestmentType === "RIA")) {
          $timeout(function () {
            changeInvestmentTypeOption(investThrough);
          });
          return true;
        } else if ((investThrough == "DIRECT" || investThrough == "RIA") && previousInvestmentType === "ARN") {
          MessageService.error("For Regular scheme Direct and RIA is not allowed.");
          $timeout(function () {
            changeInvestmentTypeOption(previousInvestmentType);
          });
          return true;
        } else if (investThrough == previousInvestmentType) {
          return true;
        }
      }
    }

    function investmentTypeVariableUpdate(investThrough, fromWhere) {
      if (investThrough === 'DIRECT') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
        vm.renewDetails={};
      } else if (investThrough === 'ARN') {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
        vm.formData.isEuin = true;
          vm.renewDetails={};
      } else if (investThrough === 'RIA') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
        vm.renewDetails={};
        vm.isCheckedTandC = fromWhere === "FROM_SCHEME_MODAL" && vm.formData.riaBrokerCode && vm.isCheckedTandC ? true : false;
      }

      if (!vm.formData.isThroughDistributor && !vm.switchInvestmentType) {
        vm.formData.euin = {};
        vm.euinData = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        //vm.formData.euinInput = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.formData.subBrokerCode = '';
        vm.isSelectedEuin = true;
        vm.subBrokerName = '';
        vm.formData.riaBrokerCode = '';
      }
      if(vm.formData.amount) {
        $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
      }
    }

    function distributorListChanged(data) {
      if (!data) {
        // vm.isArnSuccess = true;
        return;
      } else {
        vm.brokerCodeError = '';
        vm.formData.distributorARN = data.arnCode;
        vm.formData.distributorName = data.name + ' - ' + data.arnCode;
        vm.showArnLabel = false;
        if (vm.formData.distributorARN) {
          //vm.isInvalidForm = false;
          vm.isArnSuccess = false;
        }
        else {
          vm.isArnSuccess = true;
        }
        fetchEuinList(vm.formData.distributorARN);
      }
    }

    function changeDividendOption(){}

    function setInvestorData() {
      var payload = {
        folioNumber: vm.formData.folioNumber,
        brokerCode: vm.formData.isDirect ? 'DIRECT' : vm.brokerCode,
        riaConsent: vm.formData.isThroughRia ? true : false,
        directOpted: vm.formData.isDirect == true ? true : false
      };
      return payload;
    }

    function addToEcart() {
      vm.investorData = setInvestorData();
      if (vm.formData.isDirect || vm.formData.isThroughRia ) {
        vm.formData.euin = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        if(!vm.formData.isThroughRia)
          vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.formData.isEuin =false;
      }

      var payload = {
        folioNumber: vm.formData.folioNumber,
        fundCode :  vm.formData.fundCode,
        schemeCode: vm.formData.purchaseInSchemeCode||vm.formData.inSchemeCode,
        installmentAmount: vm.formData.amount,
        amount: vm.formData.purchaseAmount,
        dividendOption: vm.formData.purchaseDividendOption || vm.formData.dividendOptions,
        brokerCode: vm.investorData.brokerCode,
        subBrokerCode: vm.formData.subBrokerCode && vm.formData.subBrokerCode!==""?vm.formData.subBrokerCode:null,
        subBrokerArn: vm.formData.subBrokerARN && vm.formData.subBrokerARN!==""?"ARN-"+vm.formData.subBrokerARN:null,
        euinOpted:(vm.formData.euin && vm.formData.euin.euinCode && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinCode: vm.formData.euin && vm.formData.euin.euinCode ? vm.formData.euin.euinCode : null,
        euinName: vm.formData.euin && vm.formData.euin.euinName ? vm.formData.euin.euinName : null,
        minorFlag: vm.formData.minorFlag,
        purchaseOpted: vm.formData.investmentType === 'PURCHASE' ? true : false,
        sipOpted : vm.formData.investmentType === 'SIP' ? true : false,
        addTocart : true
      };


      if (vm.formData.investmentType === 'SIP') {
        payload.frequency =  vm.formData.frequency;
        payload.sipDate =  $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').format("DD-MMM-YYYY");
        payload.toDate = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').format("DD-MMM-YYYY");
        payload.installmentAmount = vm.formData.amount;
        payload.dividendOption = vm.formData.sipDividendOption;
      }

      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = vm.isCheckedTandC ? true : false;
      }
      if (vm.formData.brokerCode && vm.formData.brokerCode !== "" && !vm.formData.isEuin)
        payload.euinOpted = "N";

      vm.ecartData = payload;
      vm.showEcartModel = true;
      $window.scrollTo(0,0);
      UtilService.expandSideBar();
    }

    function addToEartMixTrxn() {
      vm.investorData = setInvestorData();
      if (vm.formData.isDirect || vm.formData.isThroughRia ) {
        vm.formData.euin = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        if(!vm.formData.isThroughRia)
          vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.formData.isEuin =false;
      }

      var payload = {
        folioNumber: vm.formData.folioNumber,
        fundCode :  vm.formData.fundCode,
        schemeCode: vm.formData.purchaseInSchemeCode||vm.formData.inSchemeCode,
        amount: vm.formData.amount,
        dividendOption: vm.formData.purchaseDividendOption || vm.formData.dividendOption,
        brokerCode: vm.investorData.brokerCode,
        subBrokerCode: vm.formData.subBrokerCode && vm.formData.subBrokerCode!==""?vm.formData.subBrokerCode:null,
        subBrokerArn: vm.formData.subBrokerARN && vm.formData.subBrokerARN!==""?"ARN-"+vm.formData.subBrokerARN:null,
        euinOpted:(vm.formData.euin && vm.formData.euin.euinCode && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinCode: vm.formData.euin && vm.formData.euin.euinCode ? vm.formData.euin.euinCode : null,
        euinName: vm.formData.euin && vm.formData.euin.euinName ? vm.formData.euin.euinName : null,
        minorFlag: vm.formData.minorFlag,
        purchaseOpted: true,
        sipOpted : true,
        addTocart : true
      };


      if (vm.formData.mixTransactionType === 'SIPPURCHASE') {
        payload.frequency =  vm.formData.frequency;
        payload.sipDate =  $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').format("DD-MMM-YYYY");
        payload.toDate = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').format("DD-MMM-YYYY");
        payload.installmentAmount = vm.formData.sipDetailsViaPurchase && vm.formData.sipDetailsViaPurchase.sipAmount;
        payload.dividendOption = vm.formData.dividendOption;
      }

      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = vm.isCheckedTandC ? true : false;
      }
      if (vm.formData.brokerCode && vm.formData.brokerCode !== "" && !vm.formData.isEuin)
        payload.euinOpted = "N";

      vm.ecartData = payload;
      vm.showEcartModel = true;
      $window.scrollTo(0,0);
      UtilService.expandSideBar();
    }

    function closeAction(action) {
      vm.showEcartModel = false;
      if (action === 'saved') {
        vm.navigation = false;
        resetAll();
        $state.reload();
      }
    }

    function checkDateisPresentInEnableDates(captureDate, enabledDates) {
      if(enabledDates.length == 0 || !captureDate) {
        return false;
      }

      var isExactMatch = enabledDates.some(function(date) {
        return $window.moment(date).isSame(captureDate, 'day');
      });
      return isExactMatch;
    }

    function getFinalPayloadData() {
      var payload = null;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          payload = vm.isSaving ? getSipPurchasePayloadToSave() : getSipPurchasePayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          payload = vm.isSaving ? getSipPurchasePayloadToSave() : getSipPurchasePayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SCHEDULE_TRANSACTION_PURCHASE:
          payload = vm.isSaving ? getSipPurchasePayloadToSave() : getSipPurchasePayloadToSubmit();
          break;
      }
      return angular.copy(payload);
    }

    function getSipPurchasePayloadToSubmit() {

      var summaryEnabled=$window.localStorage.getItem("SummaryEnabled");

      if ( summaryEnabled===null && !vm.validations.investmentOption && (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP)) {
        MessageService.error('Invalid Investment option for sip is selected.');
        return false;
      }

      if (!vm.formData.purchaseInvestmentOption && (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)) {
        MessageService.error('Invalid Investment option for purchase is selected.');
        return false;
      }
      if (vm.formData.purchaseInSchemeName && !vm.formData.purchaseInSchemeName.toLowerCase().includes('retirement')) {
        vm.formData.retirementAgeProofURL = '';
      }

      if (vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        vm.formData.dividendOption = vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.sipDividendOption;
      } else {
        vm.formData.dividendOption = vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.dividendOption;
      }
      if (vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP && vm.formData.sipTopupEnabled && !vm.formData.topupDetails.capAmount) {
        vm.formData.topupDetails.capMonthYear = $window.moment(vm.formData.topupDetails.capMonthYearSelect,"MMM-YYYY").format("DD-MMM-YYYY");
      }
      var selectedFolioObj = vm.folioList.filter(function (row) {              // for investor's name initialisation
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName:'';

      vm.formData.investmentOption = vm.validations.investmentOption?vm.validations.investmentOption:vm.formData.investmentOption;
      vm.formData.checkedNfoAutoSwitch = vm.formData.isAutoSwitch;
      vm.formData.autoSwitchScheme = vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null;
      vm.formData.autoSwitchSchemeDividendOption = vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null;
      vm.formData.switchSchemeInvestmentOption = vm.formData.isAutoSwitch ? vm.switchSchemeInvestmentOption : null;
      vm.formData.folioInvestorName = vm.folioInvestorName;
      vm.formData.euinOpted = (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N';
      if (vm.formData.investmentType === 'SIP') {
        vm.formData.accType = vm.formData.bankInfo && vm.formData.bankInfo.bankAcType ? vm.formData.bankInfo.bankAcType : vm.formData.bankAcType;
        vm.formData.ifscCode = vm.formData.bankInfo && vm.formData.bankInfo.ifscCode ? vm.formData.bankInfo.ifscCode : vm.formData.ifscCode;
      }
      return angular.copy(vm.formData);
    }

    function moveToSummary() {
      setTandCVariable();
      if(!$stateParams.trackId && $stateParams.stepNo !== "THIRD") {
        userActivityTracking(function (trackResp) {
          var params = {transactionType: vm.transactionType};
          if ((trackResp && angular.isDefined(trackResp.transactionId)) || $stateParams.trackId) {
            params.trackId = trackResp.transactionId || $stateParams.trackId;
            vm.formData.trackId = params.trackId;
          }
          vm.isRequired = true;
          vm.isSaving = false;
          if (vm.formData.euin && !vm.formData.euin.euinName && !vm.formData.euin.euinCode && vm.formData.euinInput) {
            vm.formData.euin.euinName = (vm.formData.euinInput.split('-')[0]).trim();
            vm.formData.euin.euinCode = (vm.formData.euinInput.split('-')[1]).trim();
          }
          $state.$previous = $state.current;
          if (vm.tForm.$valid) {
            var payloadData = getFinalPayloadData();
            if (!payloadData) {
              return;
            }
            var selectedFolioObj = vm.folioList.filter(function (row) {
              return row.folioNumber == vm.formData.folioNumber
            })[0];
            payloadData.email = selectedFolioObj.email ? selectedFolioObj.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
            payloadData.mobileNumber = selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;
            TransactionModel.setPayloadRawData(payloadData);
            /*Netcore Event Start*/
            var netcoreData = payloadData;
            netcoreData.deeplink = trackResp.trxnUniqueLink;
            if(vm.formData.journey == 'Transact Now') {
              if(vm.transactionType===vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP){
                NetcoreEvntService.scheme_Selected_Sip(netcoreData);
              }else{
                NetcoreEvntService.scheme_Selected(netcoreData);
              }
            }
            /*Netcore Event End*/
            payloadData.investorType = vm.formData.investorType;
            if($stateParams.action == 'modify'){
              payloadData.modifyAction = vm.formData.modifyAction;
            }
            vm.summaryData = payloadData;
            vm.summaryData['scheduleDetails'] = vm.scheduleTransactionDetails;
            // vm.formData.isSummaryViewEnabled = true;
            $window.localStorage.removeItem("SummaryEnabled");
          }

        }, "SECOND");
      } else {
        var payloadData = getFinalPayloadData();
        if (!payloadData) {
          return;
        }
        var selectedFolioObj = vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        payloadData.email = selectedFolioObj.email ? selectedFolioObj.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
        payloadData.mobileNumber = selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;
        payloadData.payment_mode_key = vm.formData.payment_mode_key;
        TransactionModel.setPayloadRawData(payloadData);
      }
    }

    /*
    * Function to fetch the schedule transaction details for view and cancel transaciton action
    */
    function getScheduleTransactionDetails() {
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        vm.scheduleTransactionDetails = response.data.summary;
        $stateParams.transactionAction === 'view' ? handleViewScheduleTransaction() : handleCancelScheduleTransactionAction();
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var payload = {
        transactionId: $stateParams.transactionId,
        transactionType: $stateParams.transactionType
      };
      TransactionService.post({
        controller1: 'schedule',
        controller2: 'transaction',
        controller3: 'summary'
      }, payload).$promise.then(success, error);
    }

    /*
    * Function to handle view schedule transaction action
    * responsible to enable schedule transaction summary view to perform view action.
    */
    function handleViewScheduleTransaction() {
      vm.transactionType = "SCHEDULE_TRANSACTION_PURCHASE";
      vm.scheduleTransactionDetails['transactionAction'] = "VIEW";
      vm.scheduleTransactionDetails['state'] = vm.formData.investmentType;
      moveToScheduleView();
    }

    /**
     * Function to handle cancel action for schedule transaction
     * responsible to enable schedule transaction summary view to perform cancel action.
     * */
    function handleCancelScheduleTransactionAction() {
      vm.transactionType = "SCHEDULE_TRANSACTION_PURCHASE";
      vm.scheduleTransactionDetails['transactionAction'] = "CANCEL";
      vm.scheduleTransactionDetails['state'] = vm.formData.investmentType;
      moveToScheduleView();
    }

    /*
    * function to create purchase payload for view/cancel schedule transaction
    */
    function moveToScheduleView() {
      var payloadData = createSchedulePayloadData();
      if (!payloadData) {
        return;
      }
      TransactionModel.setPayloadRawData(payloadData);
      vm.summaryData = payloadData;
      vm.summaryData['scheduleDetails'] = vm.scheduleTransactionDetails;
      vm.formData.isSummaryViewEnabled = true;
    }

    function createSchedulePayloadData() {
      var payload = {
        purchaseAmount: vm.scheduleTransactionDetails.amount,
        bankInfo: null,
        brokerCode: "",
        brokerName: "",
        checkedNfoAutoSwitch: undefined,
        day: null,
        purchaseInvestmentOption: !angular.isUndefined(vm.scheduleTransactionDetails.dividendOption) ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH,
        email: vm.scheduleTransactionDetails.emailID,
        purchaseDividendOption: vm.scheduleTransactionDetails.dividendOption,
        endDate: null,
        euin: "",
        euinOpted: "N",
        folioNumber: vm.scheduleTransactionDetails.folioNumber,
        formType: "SWITCH",
        frequency: null,
        inSchemeCode: "",
        purchaseInSchemeName: vm.scheduleTransactionDetails.defaultSourceSchemeName,
        inSchemeType: "ELSS",
        investmentOption: "DIVIDEND",
        investmentType: vm.scheduleTransactionDetails.transactionType,
        isBackFromSummary: false,
        isFavourite: false,
        isThroughDistributor: false,
        mobileNumber: vm.scheduleTransactionDetails.mobileNumber,
        noOfInstallments: "",
        scheduleDetails: null,
        sipDividendOption: "Y",
        startDate: null,
        transactionId: $stateParams.transactionId
      };
      return payload;
    }

    return {

      setViewModel: setViewModel,
      isFormValid:isFormValid,
      calculateSipStartDate:calculateSipStartDate,
      getFolioList: getFolioList,
      fetchPreviousTrSelectedDistrubutor: fetchPreviousTrSelectedDistrubutor,
      userActivityTracking: userActivityTracking,
      changeThroughDistributor: changeThroughDistributor,
      resetNumInWords: resetNumInWords,
      checkPanAadharLinkStatus: checkPanAadharLinkStatus,
      handleEnter: handleEnter,
      resetAll: resetAll,
      /*purchase helper methods*/
      fetchPurchaseInSchemes: fetchPurchaseInSchemes,
      fetchPurchaseValidations: fetchPurchaseValidations,
      checkPurchaseValidations: checkPurchaseValidations,
      /*purchase helper methods ends*/
      searchDistributor: searchDistributor,
      fetchEuinList : fetchEuinList,
      changeSubBrokerArn: changeSubBrokerArn,
      fetchEuinListSubBroker: fetchEuinListSubBroker,
      changeSubBrokerCode: changeSubBrokerCode,
      filterEuinList: filterEuinList,
      setTandCVariable: setTandCVariable,
      changeDistributorCode : changeDistributorCode,
      selectEuin: selectEuin,
      fetchDataFromSaveFlow : fetchDataFromSaveFlow,
      handleInvestThroughPrefill : handleInvestThroughPrefill,
      setDynamicData : setDynamicData,
      saveData : saveData,
      fetchSipInSchemes: fetchSipInSchemes,
      fetchSipSchemeValidations: fetchSipSchemeValidations,
      setSipDividendOptionsValue: setSipDividendOptionsValue,
      setUpSipValidations: setUpSipValidations,
      getDateValidation: getDateValidation,
      updateEndDates: updateEndDates,
      changeStartDate: changeStartDate,
      changeEndDate: changeEndDate,
      changeTillPerpetuityFlag: changeTillPerpetuityFlag,
      changeDay: changeDay,
      calculateStartDate: calculateStartDate,
      checkSipValidations: checkSipValidations,
      changeCapMonthYear: changeCapMonthYear,
      capAmountChanged: capAmountChanged,
      resetCapAmount: resetCapAmount,
      changeTopUpFreq: changeTopUpFreq,
      searchDistributorByName: searchDistributorByName,
      showTopUpDetails: showTopUpDetails,
      showSIPDetails: showSIPDetails,
      proceedToTransact: proceedToTransact,
      changeInvestmentTypeOption: changeInvestmentTypeOption,
      distributorListChanged: distributorListChanged,
      changeDividendOption: changeDividendOption,
      addToEcart: addToEcart,
      closeAction: closeAction,
      addToEartMixTrxn: addToEartMixTrxn,
      getScheduleTransactionDetails: getScheduleTransactionDetails
    };
  }

})();

/**
 * Created by sudarshan on 27/4/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('InstantRedemptionHelper', instantRedemptionHelper);


  /** @ngInject */
  function instantRedemptionHelper(UtilService, InvestorService, LoaderService, MessageService) {
    var vm = null;


    function setViewModel(model) {
      vm = model;
      init();
    }
    function init() {
    }

    function getInstantRedSchemes() {
      fetchOutSchemesForInstantRed(function () {

      });

    }


    function filterOutSchemeList() {
      vm.formData.outSchemeObj = '';
      vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList, 'schemeName', vm.formData.outSchemeName);
    };

    function fetchOutSchemesForInstantRed(cb) {
      cb = cb || function () {
        };

      if (!vm.formData.folioNumber) {
        return;
      }

      vm.outSchemeList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.outSchemeList = resp.data.schemeList;
            vm.masterOutSchemeList = vm.outSchemeList;
            if(vm.outSchemeList.length === 0){
              vm.errorMessage = 'Scheme data not available under this folio'
            }
            vm.bankList = resp.data.bankList;
            if(vm.bankList.length === 0){
              vm.bankErrorMsg = 'No any bank mapped under this folio.';
            }
            cb();
          } else {
            vm.outSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.outSchemeList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var _config = {child1: 'scheme', child2: vm.formData.folioNumber, child3: 'instantRedemption'};

      InvestorService.get(_config).$promise.then(success, error);
    }

    function setInstantRedSchemeValidations(scheme) {
      vm.unitsDetails = vm.unitsDetails || {};
      vm.validations.minAmount = '';
      vm.validations.maxAmount = scheme.maxAmount ? parseFloat(scheme.maxAmount) : 0;
      vm.validations.amountMultiples = '';
      vm.unitsDetails.totalCurrentValueUnits = scheme.totalUnit;
      vm.unitsDetails.totalCurrentValueAmount = scheme.totalAmount;

      vm.unitsDetails.exitLoadUnits = scheme.exitLoadUnits;
      vm.unitsDetails.exitLoadAmount = scheme.exitLoadAmount;
    }

    return {

      setViewModel: setViewModel,
      getInstantRedSchemes: getInstantRedSchemes,
      setInstantRedSchemeValidations: setInstantRedSchemeValidations,
      fetchOutSchemesForInstantRed: fetchOutSchemesForInstantRed
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InitiateTransactionFlexSipController', initiateTransactionFlexSipController);

  /** @ngInject */
  function initiateTransactionFlexSipController($log, $timeout, $stateParams, HDFC_API, MessageService, ModalService, InvestorService, DownloadPdfService,
                                                    SchemeService, TransactionService, AppConstants, $state, LoaderService, UtilService,
                                                    TransactionModel, AuthService, SipPurchaseHelper, NetcoreEvntService,
                                                    InvestorFileUploadService, $window, FileSaver, Blob, InvestorFolioModel, investorServiceVersion, FolioModel, $rootScope , DynamicDataFlexSipReview , termsCondition , panAadharService) {
    var vm = this;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    vm.transactionType = "FLEXSIP";
    vm.formData = TransactionModel.getPayloadRawData() || TransactionModel.getMasterRawData('SIP');
    vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP;
    vm.devidendOptionsOther = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT];
    vm.devidendOptionsELSS = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];
    vm.devidendOptions = angular.copy(vm.devidendOptionsOther);
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.specificProperties = TransactionModel.getTransactionSpecificProperties('SIP');
    vm.folioList = FolioModel.getFolioData() || null;
    vm.unitsDetails = null;
    vm.inSchemeValidations = null;
    vm.outSchemeValidations = null;
    vm.validations = {};
    // vm.investorInfo = null;
    vm.isRequired = false;
    vm.bankList = null;
    vm.outSchemeList = null;
    vm.inSchemeList = null;
    vm.masterInSchemeList = null;
    vm.tForm = {};
    vm.isSaving = false;
    vm.isReseting = false;
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    // vm.daysList = getDaysList();
    vm.daysList = null;
    vm.isSchemeDisabled = false;
    vm.isShowDefault = 'false';
    vm.viewMode = 'days';
    vm.euinList = null;
    vm.distributorList = null;
    vm.isInvalidForm = false;
    vm.isCheckedTandC = vm.formData.isCheckedTandC;
    vm.profile = AuthService.getToken();
    var name = vm.profile && vm.profile.investorFName ? vm.profile.investorFName.toLowerCase() : '';
    vm.investorName = name.charAt(0).toUpperCase() + name.slice(1);
    vm.calenderEndDateString = '31-Dec-2099';
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.retirementAgeProofURL = '';
    vm.chooseAFile = true;
    vm.amountInWords = '';
    vm.isSourceSchemeGrowth = false;
    vm.isSchemeTypeELSS = false;
    vm.capMonthYear = '';
    vm.schemeTypeForValidation = '';
    vm.checkFlexSipValidations = checkFlexSipValidations;
    vm.checkValidations = checkValidations;
    vm.extractValidationObject = extractValidationObject;
    vm.resetAll = resetAll;
    // vm.helper = getHelper();
    vm.blocktab = blockTabbing;
    vm.isOTMAmount = false;
    vm.isOTMDate = false;
    vm.isArnSuccess = true;
    vm.isSubarnSuccess = false;
    vm.brokerCodeError = '';
    vm.subBrokerCodeError = '';
    vm.isOTMEnabled = true;
    vm.isEMandateEnabled = false;
    vm.emandateDisplay = true;
    vm.isminCapAmount = false;
    vm.checkOTM= checkOTM;
    vm.changedPaymentOption= changedPaymentOption;
    vm.changeFrequency =changeFrequency;
    vm.selectedFreq = 'OM';
    vm.formData.authMode=null;
    vm.eMandatenoOfDays=null;
    vm.isEmailMobileinValid = false;
    vm.isEmailinValid = false;
    vm.isMobileinValid = false;
    vm.scheduleTransactionDetails = null;
    vm.kycVerifiedFlag = null;
    vm.OTMbankList = null;
    vm.ECbankList = null;
    vm.EMbankList = null;
    vm.riaCodeError = "";
    vm.sipFirstInstallment=false;
    vm.formData.sipFirstInstallment=false;
    vm.sipFirstInstallmentAmount=[];
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.setDynamicData = setDynamicData;
    vm.DynamicDataFlexSipReview = DynamicDataFlexSipReview;
    vm.showNote = true;
    vm.showOtmNote = true;
    vm.showEotmNote = true;
    vm.showPopupAddEcart = true;
    vm.notesReview = {};
    vm.popup = {};
    vm.today = $window.moment($window.moment(),"DD-MMM-YYYY HH:mm A");
    vm.notesOtm = {};
    vm.notesEOtm = {};
    vm.riaMessage = {};
    vm.distributorMessage = {};
    vm.showTerms = true;
    vm.showTermsEmandate = false;
    vm.backFromPayment=false;
    vm.weekDayList = [];
    vm.nonBusinessDatess = null;
    vm.upiErrorMessage = '';
    vm.upiLimit = '';
    vm.validationMessage = AppConstants.FLEX_SIP_OTM_DOUBLE_AMOUNT_ERROR;
    vm.validationMessageNoPayment = AppConstants.FLEXSIP_NO_PAYMENT_MODE_ERROR;
    vm.changeFirstInstallment = changeFirstInstallment;
    vm.isfromSaved = false;
    vm.savedFrequency = null;
    vm.savedAccType = null;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.emandateMinAmountLimit = null;
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.isLessThanSipAmount = false;
    vm.sipDateLessEmandate = false;
    vm.changeEndDateEmandate = changeEndDateEmandate;
    vm.defaultMandateYearDate = AppConstants.DEFAULT_EMANDATE_MAX_YEAR;
    vm.formData.emandateWord = {};
    vm.handleMandatePaymentOption = handleMandatePaymentOption;
    AuthService.checkLinkedUserStatus();
    setDynamicData();

    function  blockTabbing(){
      var divs = $window.document.querySelectorAll('*');

      for (var i = 0; i < divs.length; i++) {
        if(divs[i].classList.contains('anything-disabled')){
          divs[i].setAttribute('tabindex', -1);
        }
      }
    }


    /**
     * Function responsible for setting helper for form validation
     */

    // function getHelper() {
    //   var helper = null;
    //   helper = SipPurchaseHelper;
    //   helper.setViewModel(vm);
    //
    //   return helper;
    //
    // }

    if ($stateParams) {
      setStateParams();
    }

    function setStateParams() {

      vm.formData.folioNumber = $stateParams.folioNumber ? $stateParams.folioNumber : vm.formData.folioNumber;

      if($stateParams.eCart)
       return;

      vm.formData.inSchemeCode = $stateParams.sc ? $stateParams.sc : vm.formData.inSchemeCode;

      //need this to prefill scheme name
      vm.formData.outSchemeCode = $stateParams.sc ? $stateParams.sc : vm.formData.outSchemeCode;
      if ($stateParams.isFavourite) {
        vm.formData.isFavourite = true;
      } else {
        vm.formData.isFavourite = false;
      }
      checkForParameters();
    }

    function checkForParameters() {
      var param = $window.location.href.split('?')[1];
      if (!param) {
        return;
      }
      var data = $window.atob($window.btoa(param)).split('&');
      var transactionId = data[0] && data[0].split('=')[1];
      var isCompId = data[2] && data[2].split('=')[1];
      var readOnly = isCompId == "true" ? true : false;


      vm.formData.dynamicData = {
        transactionId: transactionId,
        readOnly: readOnly
      };
    }

    /**
     * Function responsible for resetting form values
     */

    function resetAll() {
      vm.formData.amountType = 'amount';
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.outSchemeCode = '';
      vm.formData.outSchemeName = '';
      vm.formData.dividendOption = '';
      vm.formData.frequency = null;
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.bankInfo = null;
      vm.formData.day = '';
      vm.formData.weeklyDay = null;
      vm.formData.isTillPerpetuity = false;
      vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
      vm.formData.month = '';

      vm.formData.euin = {};
      vm.euinData = {};
      vm.formData.brokerCode = '';
      vm.formData.brokerName = '';
      vm.euinList = null;
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.formData.subBrokerARN = '';
      vm.formData.subBrokerCode = '';
      vm.isCheckedTandC = false;
      vm.isArnSuccess = true;
      vm.formData.flexSipPaymentOption = '';


      vm.inSchemeValidations = null;
      vm.outSchemeValidations = null;
      vm.validations = {};
      vm.isRequired = false;
      vm.bankList = null;
      vm.outSchemeList = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      vm.unitsDetails = null;
      resetNumInWords(); //reset the number in text form on folio change or form reset

      resetBankDetails();
      if (vm.specificProperties && vm.specificProperties.investmentModeData) {
        vm.specificProperties.investmentModeData.stage1 = '';
        vm.specificProperties.investmentModeData.stage2 = '';
        vm.specificProperties.investmentModeData.stage3 = '';
        vm.specificProperties.investmentModeData.stage4 = '';
      }
      manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
      vm.formData.riaBrokerCode = "";
      vm.formData.riaBrokerName = "";
      vm.formData.isCheckedTandC = false;
      vm.brokerCodeError = "";
      vm.riaCodeError = "";
      vm.formData.emandateAmount = null;
    }


    /**
     * Function responsible for resetting number in words field
     */

    function resetNumInWords() {
      vm.amountInWords = '';
      var inWordsDiv = $window.document.getElementById('divDisplayWords');
      var inWordsFirstInstallmentDiv = $window.document.getElementById('divDisplayWordFirstInstallment');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
      if (inWordsFirstInstallmentDiv) {
        inWordsFirstInstallmentDiv.innerHTML = '(In Words)';
      }
    }

    function reSetting() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    /**
     * Function responsible for setting validations
     */

    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.formData.frequency) {
        return;
      }

      vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
      vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
      vm.validations.minInstallments = vm.validations.minInstallments || 0;
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.maxAmount = vm.validations.maxAmount || 0;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > 0 && vm.validations.maxAmount < vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }
      switch (vm.formData.frequency) {
        case 'Q':
          vm.validations.maxInstallments  = validationsData.quarterlyMaxInstallmentNumber;
          if(validationsData.additionalValidation.Q){
            vm.additionalSipData = validationsData.additionalValidation.Q;
            vm.validations.minAmount =validationsData.additionalValidation.Q[0].min_amount_lower;

          }
          break;
        case 'OM':
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
         if(validationsData.additionalValidation.OM){
           vm.additionalSipData = validationsData.additionalValidation.OM;
           vm.validations.minAmount = validationsData.additionalValidation.OM[0].min_amount_lower;
        }
          break;
      }
      if(!vm.backFromPayment && !$stateParams.transactionId)
      {
      if( vm.validations.minAmount > validationsData.sipDefaultAmount){
        vm.formData.amount =  vm.validations.minAmount;
      }else{
        vm.formData.amount = validationsData.sipDefaultAmount;
      }
      vm.emandateMinAmountLimit = angular.copy(vm.formData.amount * 2);
      vm.formData.emandateAmount = angular.copy(vm.formData.amount * 2);
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
      checkAmountValidationEmandate();
      if(vm.formData.amount){
        $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
      }
    }
     if(vm.additionalSipData){
      checkFlexSipValidations();
     }

    }

    /**
     * Function responsible for checking flex sip validations
     */

    function checkFlexSipValidations() {
      if(vm.additionalSipData){
        var newValidation =  vm.additionalSipData;
       for (var i=0; i<newValidation.length;i++){
         var condition = vm.formData.amount < newValidation[i].min_amount_lower ||  vm.formData.amount <= newValidation[i].min_amount_upper
         if(!newValidation[i].min_amount_upper){
            var condition = true;
         }
         if(condition)
         {
           vm.validations.amountMultiples = newValidation[i].amt_multiples;
           vm.validations.maxAmount = newValidation[i].min_amount_upper;
           vm.validations.minAmount = newValidation[i].min_amount_lower;
           vm.validations.minInstallments = newValidation[i].min_installments;
           break;
         }
       }
      }
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }
      vm.isMax = vm.formData.amount > vm.FlexSipMaxAmount;
      vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
      vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
      vm.isInvalidForm = vm.formData.amount <= 0 || (vm.formData.amount && ( vm.isMax || vm.isMin || (vm.validations.amountMultiples && !vm.isMultiples)));
      checkEMandateValidation();
      if(vm.formData.amount == "" || vm.formData.amount == null) {
          resetNumInWords();
      } else {
        $window.NumToWord(vm.formData.amount,'divDisplayWords', vm);
      }

      if(vm.sipFirstInstallment) {
        vm.formData.sipFirstAmount = vm.formData.amount;
      }
      if(vm.formData.flexSipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        checkOTMAmountAndDate();
      }

      if (vm.formData.flexSipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
        vm.emandateMinAmountLimit = angular.copy(vm.formData.amount * 2);
        vm.formData.emandateAmount = angular.copy(vm.formData.amount * 2);
        $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
        checkAmountValidationEmandate();
      }
    }


    /**
     * Function responsible for fetching folio list
     */

    function fetchFolioList(cb) {

      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioList = [];
            vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
            if (resp.data.kycVerifiedFlag === false && $stateParams.initiatedBy != "schedule") {
              ModalService.genericModal({
                text: resp.data.kycMessage
              }, function() {
                $state.go("welcome");
              });
            }
            Object.keys(resp.data.folioList).forEach(function (key) {
              var obj = Object.assign({key: key}, resp.data.folioList[key]);
              folioList.push(angular.copy(obj));
            });
            FolioModel.setFolioData(folioList);
            vm.folioList = folioList.length ? folioList : null;
            if (vm.folioList && vm.folioList.length === 1) {
              if(vm.folioList[0].activeFlag === true){
                vm.formData.folioNumber = vm.folioList[0].folioNumber;
                if (!vm.formData.isBackFromSummary && !vm.formData.outSchemeCode && !$stateParams.transactionId) {
                  vm.folioChanged();
                }
              }
            }


            if(vm.formData.folioNumber) {
              fetchInvestorType();
            }

            if (vm.formData.dynamicData && vm.formData.dynamicData.folioNumber) {
              vm.formData.folioNumber = vm.formData.dynamicData.folioNumber;
              vm.folioChanged();
            }
            if($stateParams.eCart)
            {
              vm.folioChanged();
            }

            if(vm.folioList && vm.folioList.length>1 && !$stateParams.transactionId && !$stateParams.folioNumber)
            {
              if (!vm.formData.folioNumber) {
                  vm.activeFlagFolioList = vm.folioList.filter(function (e){
                      return e.activeFlag === true;
                  })
                  vm.formData.folioNumber = vm.activeFlagFolioList.length>=1 ? vm.activeFlagFolioList[0].folioNumber:'';
                  vm.folioChanged();
              } else {
                vm.folioMinor = vm.formData.minorFlag;
                fetchInSchemes();
                if (vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
                  checkOTM(function (success) {
                    if (success) {
                      fetchBankList();
                      checkEMandateValidation();
                      checkOTMAmountAndDate();
                    }
                  });
                }
                else if(vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
                  checkOTM(function (success) {
                    if (success) {
                      checkEMandate(function () {
                        fetchBankList();
                      });
                    }
                  });
                }
              }
            }
            if($stateParams.eCart)
            {
              vm.folioChanged();
            }

            cb(true);
          } else {
            vm.folioList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      investorServiceVersion.get({
        child1: 'folio',
        child2: 'active-list'
      }).$promise.then(success, error);
    }

    vm.brokerCodeError = '';


    /**
     * Function responsible for fetching euin list
     */

    function fetchEuinList() {

      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      vm.formData.brokerName = vm.formData.brokerName? vm.formData.brokerName :'';
      vm.formData.riaBrokerName = vm.formData.riaBrokerName? vm.formData.riaBrokerName :'';
      vm.subBrokerCodeError = '';
      vm.euinData = {};
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      vm.distributorList = null;
      // vm.formData.euinInput = '';
      if (!vm.formData.isBackFromSummary && !vm.riaConsent) {
        vm.isCheckedTandC = vm.formData.isCheckedTandC;
        if (!$stateParams.isCompId && !$stateParams.trackId) {
          vm.formData.euin = vm.formData.euin ? vm.formData.euin : '';
        }
      }

      //vm.isInvalidForm = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin ? vm.formData.euin : {};
            vm.brokerCodeError = '';
            vm.riaCodeError = '';
            vm.isArnSuccess = false;
            if (vm.formData.isThroughDistributor) {
              vm.formData.brokerName = resp.data.distributorName;
            } else if (vm.formData.isThroughRia) {
              vm.formData.riaBrokerName = resp.data.distributorName;
            }
            if( $window.localStorage.getItem("SummaryEnabled")) {
              vm.moveToSummary();
            }

            //vm.isInvalidForm = false;
          } else {
            vm.euinList = null;
            if (vm.formData.isThroughDistributor) {
              vm.brokerCodeError = resp.message;
            } else if (vm.formData.isThroughRia) {
              vm.riaCodeError = resp.message;
              vm.isCheckedTandC = false;
              vm.formData.isCheckedTandC = false;
            }
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      var path = {};
      if (vm.formData.isThroughDistributor) {
        path  = {
          controller1: 'getEuin',
          controller2: 'ARN-' + vm.formData.brokerCode
        };
      } else if (vm.formData.isThroughRia) {
        path = {
          controller1: 'getEuin',
          controller2: vm.formData.riaBrokerCode,
          riaOpted: vm.formData.isThroughRia
        };
      }
      TransactionService.get(path).$promise.then(success, error);
    }

    vm.subBrokerCodeError = '';

    /**
     * Function responsible for fetching sub broker list
     */

    vm.fetchEuinListSubBroker = function () {
      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        vm.formData.euin = {};
        vm.euinData = {};
        fetchEuinList();
        return;
      }
      if(vm.formData.brokerCode !== vm.formData.subBrokerARN){
        vm.formData.euin = {};
        vm.euinData = {};
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            for(var i = 0; i<vm.euinList.length; i++){
              if(vm.euinData.euinNameCode === vm.euinList[i].euinNameCode){
                vm.formData.euin = vm.euinList[i];
                break;
              } else {
                vm.formData.euin = {};
              }
            }
            vm.euinData = vm.formData.euin;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
          } else {
            vm.euinList = null;
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = {};
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: vm.formData.isThroughDistributor
      }).$promise.then(success, error);
    }

    /**
     * Function responsible for fetching distributor list
     */

    function fetchEuinListThroughDistributor(arnCode) {
      if (!arnCode) {
        return;
      }
      vm.formData.brokerName = '';
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin;
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.euinList = null;
            //MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: arnCode
      }).$promise.then(success, error);
    }

    /**
     * Function responsible for fetching arn by name
     */

    function fetchARNByName() {

      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        return;
      }
      vm.formData.distributorARN = '';
      vm.distributorList = null;
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.distributorList = resp.data.distributorList;
            if (vm.distributorList.length == 0) {
              //vm.isInvalidForm = true;
              vm.formData.euin = {};
              vm.isCheckedTandC = false;
            }
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.distributorList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.distributorList=null;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getDistributor',
        controller2: vm.formData.distributorName
      }).$promise.then(success, error);
    }

    /**
     * Function responsible for checking validation
     */

    function checkValidations() {
      vm.isInvalidForm = false;

      if (!vm.inSchemeValidations && !vm.outSchemeValidations) {
        vm.validations = {};
      }

      if (vm.outSchemeValidations) {
        vm.validations.isEnabled = vm.outSchemeValidations ? vm.outSchemeValidations.isEnabled : '';
        extractValidationObject(vm.outSchemeValidations);
      }

      if (vm.inSchemeValidations) {
        vm.validations.minInstallDivisionFlag = vm.inSchemeValidations.minInstallDivisionFlag;
        vm.validations.swpTaxCode = vm.inSchemeValidations.swpTaxCode;
        vm.validations.endingType = vm.inSchemeValidations.endingType;
        extractValidationObject(vm.inSchemeValidations);
        checkEMandate();
      }
    }


    /**
     * Function responsible for fetching schemes
     */

    function fetchInSchemes(cb) {
      cb = cb || function () {
      };

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.masterInSchemeList = resp.data.schemeList;
            vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
            /* fill autoscheme for sip with first installment*/
            if (vm.formData.inSchemeCode) {
              var schemeData = vm.inSchemeList.filter(function(scheme) {
                return scheme.schemeCode === vm.formData.inSchemeCode;
              });
              vm.inSchemeChanged(schemeData[0]);
            }
            cb();
          } else {
            vm.masterInSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.masterInSchemeList = null;
          UtilService.errorHandler(err);
        };
      var _config = {
        controller: 'scheme',
        type: 'ALL',
        child1: 'flexsip' + 'enabled',
        child2: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
        child3: vm.formData.isThroughDistributor,
        child4: vm.formData.corporateInvestor
      };
      SchemeService.get(_config, null).$promise.then(success, error);
    }

    /**
     * Function responsible for fetching scheme validations
     */

    function fetchInSchemeValidations(cb) {
      vm.inSchemeValidations = null;
      var transactionType = 'flexSip';
      cb = cb || function () {
      };
      if (!vm.formData.inSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;
            if(vm.inSchemeValidations && vm.formData.minorFlag){
              vm.inSchemeValidations.cgfFlag = vm.inSchemeValidations.cgfFlag ? vm.inSchemeValidations.cgfFlag : true;
            }
            vm.frequencyList = vm.inSchemeValidations.additionalValidation.frequency?vm.inSchemeValidations.additionalValidation.frequency:null;
            var frequency = vm.frequencyList.find(function (f) {
              return f.code === 'OM';
            }) || {};
            vm.formData.frequency = vm.formData.frequency ? vm.formData.frequency : frequency?frequency.code:vm.frequencyList[0].code;
            _setSipDividendOptionsVali(vm.inSchemeValidations);
            cb(null);
          } else {
            cb('error');
            vm.inSchemeValidations = null;
            vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
            vm.formData.dividendOption = vm.isSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.dividendOption;
            vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
            MessageService.error(resp.message);
          }
          checkValidations();
        },
        error = function (err) {
          cb('error');
          vm.inSchemeValidations = null;
          vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
          vm.formData.dividendOption = vm.isSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.dividendOption;
          vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
          UtilService.errorHandler(err);
        };

      var params = {
        controller: 'schemeValidation',
        type: transactionType
      };

      var data = {
        schemeCode: vm.formData.inSchemeCode,
        folioNo: vm.formData.folioNumber
      }
      SchemeService.post(params, data).$promise.then(success, error);
    }


    /**
     * Function responsible for setting dividend option
     */

    function _setSipDividendOptionsVali(inSchemeValidations) {

      vm.inSchemeValidations = inSchemeValidations;
      vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
      vm.inSchemeValidations.investmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[vm.inSchemeValidations.investmentOption];
      var investmentOption = vm.inSchemeValidations.investmentOption || (vm.inSchemeValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
      if (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) {
        vm.validations.investmentOption = investmentOption;
        vm.formData.dividendOption = (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : (((vm.inSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (vm.isSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : (vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST));
        vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
        if (!vm.formData.isBackFromSummary && !vm.formData.sipDividendOption) {
          if (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) {
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          } else {
            if (vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === false) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
            } else if (vm.inSchemeValidations.dividendPayoutApplicable === false && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            } else if (vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
              vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            }
          }
        }

        if (vm.inSchemeValidations.amountArray) {
          vm.sipFirstInstallmentAmount = vm.inSchemeValidations.amountArray;
        }
      } else {
        ModalService.genericModal({
          text: vm.FLEX_SIP_ONLY_GROWTH.content
        },function () {
          vm.resetAll();
        },function () {
          vm.resetAll();
        });
      }
    }

    /**
     * Function responsible for fetching saved transaction details
     */

    function getTransactionDetails() {
      if (!$stateParams.transactionId) {
        MessageService.error("TransactionId is missing for saved transaction.");
        $state.go('main.dashboard');
        return;
      }

      var success = function (resp) {
          if (resp.data && resp.status) {
            showPrefillValues(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'transaction',
        controller2: 'saved',
        controller3: $stateParams.transactionId,
        controller4: $stateParams.isCompId
      }).$promise.then(success, error);
    }

    /**
     * Function responsible for fetching transaction type
     */

    function getTransactionType() {
      var transactionType = '';
      switch ($state.current.name) {

        case 'main.transactions.flexsip':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP;
          break;

        default :
          $state.go('welcome');
          break;
      }
      return transactionType;
    }

    /**
     * Function responsible for fetching payload data
     */

    function getFinalPayloadData() {
      var payload = null;

      payload = vm.isSaving ? getFlexSipPayloadToSave() : getFlexSipPayloadToSubmit();

      return angular.copy(payload);
    }

    /**
     * Function responsible for setting payload data for transaction save
     */

    function getFlexSipPayloadToSave() {

      if (vm.formData.bankInfo && vm.formData.bankInfo.bankName == "OTHER BANKS") {
        vm.formData.bankInfo.bankName = vm.formData.bankName;
      }
      if(vm.formData.isThroughDistributor===false && vm.formData.isThroughRia === false){
        vm.formData.euin = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
      }
      var sipPayload = {
          authMode: vm.formData.authMode ? vm.formData.authMode.value  : null,
          installmentAmount: vm.formData.amount,
          investmentOption: fetchInvestmentOption(vm.validations.investmentOption),
          dividendOption: vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.sipDividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP,
          flexSipFrequency: vm.formData.frequency,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          schemeType: vm.formData.schemeType,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP,
          toDate: vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
          sipDate: vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
          sipDay: vm.formData.day ? vm.formData.day : null,
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
          euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
          id: vm.formData.sTransactionId,
          compositeTransactionId: $stateParams.ctId ? $stateParams.ctId : '',
          isTillPerpetuityvm: vm.formData.isTillPerpetuity ? vm.formData.isTillPerpetuity : false,
          bankDetailsForECS: {
            accNumber: vm.formData.bankInfo ? vm.formData.bankInfo.accountNumber:'',
            bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.formData.ifscCode,
            branchName: vm.formData.bankBranch,
            bankCity: vm.formData.bankCity,
            paymentOption: vm.formData.flexSipPaymentOption == 'E-mandate'?'HEM':vm.formData.flexSipPaymentOption,
            otmId: vm.formData.otmId,
            netBankingUrl: vm.formData.netBankingUrl,
            payoutId : vm.formData.payoutId
          },
          subBrokerARN: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode
        }

      if(vm.backFromPayment)
      {
        vm.sipFirstInstallment=true;
        vm.formData.sipFirstInstallment=true;
      }

      if(vm.formData.sipFirstInstallment) {
        sipPayload.sipWithFirstInstallment=vm.formData.sipFirstInstallment;
        sipPayload.firstInstallmentDetails={amount:vm.formData.amount};
      }

      if (!sipPayload.investmentOption) {
        sipPayload.investmentOption = vm.formData.flexSipPaymentOption;
      }
      if (!sipPayload.dividendOption) {
        sipPayload.dividendOption = vm.formData.sipDividendOption;
      }

      if (vm.formData.bankInfo && !vm.formData.bankInfo.bankAcType) {
        sipPayload.bankDetailsForECS.accType = vm.formData.bankAcType;
      }

      var payload = {};

      sipPayload = handleBrokerCode(sipPayload);
      payload = angular.copy(sipPayload);

      payload.trackId = vm.formData.trackId;

      return payload;
    }


    /**
     * Function responsible for setting payload data for final form submission
     */

    function getFlexSipPayloadToSubmit() {

      var summaryEnabled=$window.localStorage.getItem("SummaryEnabled");

      if ( summaryEnabled===null && !vm.validations.investmentOption) {
        MessageService.error('Invalid Investment option for sip is selected.');
        return false;
      }

      vm.formData.retirementAgeProofURL = '';


      vm.formData.dividendOption = vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.sipDividendOption;

      var selectedFolioObj = vm.folioList.filter(function (row) {              // for investor's name initialisation
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName:'';
      vm.formData.investmentOption = vm.validations.investmentOption?vm.validations.investmentOption:vm.formData.investmentOption;
      vm.formData.checkedNfoAutoSwitch = vm.formData.isAutoSwitch;
      vm.formData.autoSwitchScheme = vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null;
      vm.formData.autoSwitchSchemeDividendOption = vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null;
      vm.formData.switchSchemeInvestmentOption = vm.formData.isAutoSwitch ? vm.switchSchemeInvestmentOption : null;
      vm.formData.folioInvestorName = vm.folioInvestorName;
      vm.formData.euinOpted = (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N';
      vm.formData.accType = vm.formData.bankInfo && vm.formData.bankInfo.bankAcType ? vm.formData.bankInfo.bankAcType : vm.formData.bankAcType;
      vm.formData.ifscCode = vm.formData.bankInfo && vm.formData.bankInfo.ifscCode ? vm.formData.bankInfo.ifscCode : vm.formData.ifscCode;
      return angular.copy(vm.formData);
    }

    /**
     * Function responsible for fetching otm bank list
     */

    function checkOTM(cb){
      cb = cb || function () {
      };
      var success = function (resp) {
        if (resp.status && resp.data) {
          if (resp.data.bankList.length == 0) {
            vm.isOTMEnabled = false;
            if(!(vm.checkForMinorBankListCondition())) {

              if(vm.sipFirstInstallment)
                vm.paymentOptions = [];
              else
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];

              var index = vm.paymentOptions.indexOf('OTM');
              if(index > -1) {
                vm.paymentOptions.splice(index,1);
              }
              vm.formData.flexSipPaymentOption = vm.paymentOptions[0];
            }
              if(vm.formData.isBackFromSummary || $stateParams.transactionId)
              {
                var frequency = vm.frequencyList && vm.frequencyList.find(function (item) {
                  return vm.formData.frequency === item.code;
                }) || {};
                vm.formData.frequency = frequency.code || '';

            }

         }
         else {
            if (vm.sipFirstInstallment && resp.data.nonCOTMBankList.length === 0) {
              vm.isOTMEnabled = false;
              vm.paymentOptions = [];
            } else {
              vm.isOTMEnabled = true;
              if (vm.checkForMinorBankListCondition()) {
                if(vm.sipFirstInstallment)
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                else
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
              } else {
                if (vm.sipFirstInstallment) {
                   vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                } else {
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                }
              }
            }

            if(!vm.backFromPayment)
              if (vm.formData.flexSipPaymentOption && vm.paymentOptions.includes(vm.formData.flexSipPaymentOption)) {
                vm.formData.flexSipPaymentOption = vm.formData.flexSipPaymentOption;
              } else {
                vm.formData.flexSipPaymentOption = vm.paymentOptions ? vm.paymentOptions[0] : '';
              }

            if(vm.formData.isBackFromSummary || $stateParams.transactionId)
            {
              frequency = vm.frequencyList && vm.frequencyList.find(function (item) {
                return vm.formData.frequency === item.code;
              }) || {};
              vm.formData.frequency = frequency.code || '';

              }
              vm.OTMbankList = vm.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList;
          }
          }

        cb(true);
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        cb(false);
      };
      // LoaderService.showLoader();//need to check
      var payload = {
        transactionType: 'sip',
        folioNo:vm.formData.folioNumber
      };
      InvestorService.post({
        child1: 'folio',
        child2: 'otm'
      }, payload).$promise.then(success, error);
    }


    /**
     * Function responsible for setting bank list
     */

    function fetchBankList(cb) {
      cb = cb || function () {
      };

      LoaderService.showLoader();

      if (vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        LoaderService.hideLoader();
        vm.hideOtmRadio = false;
        vm.bankList = vm.OTMbankList;
      }
      else if(vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
        LoaderService.hideLoader();
        vm.formData.showTopUpBlock = false;
        if(vm.formData.inSchemeCode)
          getDateValidation();
        checkEMandateValidation();
        vm.bankList =  vm.EMbankList;
        vm.formData.authMode = vm.formData.bankInfo? (vm.formData.bankInfo.authenticationModes.length === 1 ? vm.formData.bankInfo.authenticationModes[0] : null) :null;
        vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
      }
      else{
        vm.bankList = null;
        LoaderService.hideLoader();
      }
    }

    /**
     * Function responsible for handling minor folio bank selection
     */

    vm.checkForMinorBankListCondition = function(){
      var selectedFolioObj = vm.folioList.filter(function (row) {
        return row.folioNumber == vm.formData.folioNumber
      })[0];
        return selectedFolioObj.minorFlag && vm.inSchemeValidations && !vm.inSchemeValidations.cgfFlag
    };


    /**
     * Function responsible for handling frequency change
     */

    function changeFrequency() {
      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        vm.formData.day = null;
        vm.formData.weeklyDay = null;
        vm.formData.month = null;
        vm.authenticationMode = null;
        vm.formData.isTillPerpetuity = false;
        vm.formData.tenure = null;
        if (vm.tForm.tenure) {
          vm.tForm.tenure.$setPristine(true);
        }
        if (vm.tForm.authenticationMode) {
          vm.tForm.authenticationMode.$setPristine(true)
        }

        if (vm.formData.frequency !== vm.savedFrequency) {
          vm.savedFrequency = null;
          vm.formData.bankInfo = null;
        }

        resetBankDetails();
        reSetting();
      }
      vm.disableEndDateSelection = false;
      vm.formData.amount = getFinalAmount();
      vm.emandateMinAmountLimit = angular.copy(vm.formData.amount * 2);
      vm.formData.emandateAmount = angular.copy(vm.formData.amount * 2);
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
      checkAmountValidationEmandate();
      checkValidations();
      checkEMandate(function () {});

      // for monthly & quarterly

      vm.viewMode = 'months';

      if(!vm.checkForMinorBankListCondition())
      if(vm.isOTMEnabled=== true){
        if (!vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM)) {
          vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM);
        }
      }

      if (vm.isEMandateEnabled) {
        vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
      }

      vm.formData.flexSipPaymentOption = vm.formData.flexSipPaymentOption ? vm.formData.flexSipPaymentOption : vm.paymentOptions[0];
      if(vm.formData.inSchemeCode) {
        getDateValidation();
      }

      fetchBankList();
      changeFirstInstallment(false);
      checkEMandate(function () {});
      if(vm.isBackFromSummary){
        checkOTM();
      }
    }

    /**
     * Function responsible for resetting default selections
     */

    function resetDefaults(doNotEmptyValidations) {
      vm.isReseting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      if (!doNotEmptyValidations) {
        vm.validations = {};
      }
      checkValidations();
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }


    /**
     * Function responsible for setting amount
     */

    function getFinalAmount() {
      var amount = vm.formData.amount;
      amount = amount;
      return amount;
    }

    function showPrefillValuesUserTracker() {
      vm.transactionType = getTransactionType();
      if (!$stateParams.trackId) {
        MessageService.error("TrackId is missing for saved transaction.");
        $state.go('main.dashboard');
        return;
      }

      var success = function (resp) {
          if (resp.data && resp.status) {
            var formData = resp.data && resp.data.formdata ? resp.data.formdata: {};
            if($stateParams.stepNo == 'SECOND'){
              vm.summaryData = formData;
              vm.formData = angular.copy(formData);
              vm.formData.isSummaryViewEnabled = true;
              TransactionModel.setPayloadRawData(vm.formData);
            }else{
              showPrefillValues(formData);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'userBehavior',
        controller2: $stateParams.trackId,
        controller3: 'getFormData'
      }).$promise.then(success, error);
    }

    function showPrefillValues(rawData) {
          if (rawData) {
            FlexSipPrefillValues(rawData)
          } else {
            fetchPreviousTrSelectedDistrubutor(function () {
              if (!vm.formData.isEuin) {
                vm.isCheckedTandC = true;
              }
              vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
              if ($stateParams.allowBroker && $stateParams.allowBroker === "true" && $stateParams.action === 'renew') {
                manipulateInvestThrough(AppConstants.INVEST_THROUGH.DISTRIBUTOR);
              } else if ($stateParams.allowBroker && $stateParams.allowBroker === "false" && $stateParams.action === 'renew') {
                if (vm.formData.isThroughRia) {
                  manipulateInvestThrough(AppConstants.INVEST_THROUGH.RIA);
                } else {
                  manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
                  vm.changeThroughDistributor(AppConstants.INVEST_THROUGH.DIRECT);
                }
              }

              if (vm.formData.distributorARN) {
                fetchEuinListThroughDistributor(vm.formData.distributorARN);
              }

              fetchFolioList(function (success) {
                if (success) {
                  var selectedFolioObj = vm.folioList.filter(function (row) {
                    return row.folioNumber == vm.formData.folioNumber
                  })[0];
                  if (selectedFolioObj) {
                    vm.selectedFolioData = selectedFolioObj;
                    vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
                  }
                  //checkOTM();
                  checkOTM(function (success) {
                    if(success){
                      vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
                      vm.folioInvestorName = selectedFolioObj.investorName ? selectedFolioObj.investorName : "";
                      fetchInSchemes(function () {
                        var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                          return vm.formData.inSchemeCode === item.schemeCode;
                        }) || {};
                        vm.formData.inSchemeName = scheme.scheme || '';
                        // getDateValidation();

                        fetchInSchemeValidations(function (err) {
                          if (!err) {
                            checkEMandate(function () {});
                            changeFrequency();
                            checkValidations();

                            vm.isReseting = true;
                            var startDate = vm.formData.startDate;
                            $timeout(function () {
                              vm.isReseting = false;
                            });
                            vm.formData.startDate = startDate;
                          }
                        });
                      })
                    }

                  });

                }
              });
              vm.changeEndDate(vm.formData.endDate);
            });
          }
    }

    function FlexSipPrefillValues(data) {
      fetchFolioList(function (success) {
        if (success) {

          var rawData;
          var frequencyList = null;

          rawData = {flexSipForm: data};

          var folioNumber = data.folioNumber|| data.folioNo;
          var selectedFolioObj = vm.folioList.filter(function (row) {
            return row.folioNumber == folioNumber;
          })[0];
          if (selectedFolioObj) {
            vm.selectedFolioData = selectedFolioObj;
            vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
          }
          vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
          vm.folioInvestorName = selectedFolioObj && selectedFolioObj.investorName ?selectedFolioObj.investorName:'';
          vm.formData.isThroughDistributor = data.euinOpted === 'Y' ? true : false;

          vm.validations = vm.validations ? vm.validations : {};
          vm.formData.sTransactionId = rawData.flexSipForm.id;
          vm.formData.folioNumber = rawData.flexSipForm.folioNumber;
          if (vm.formData.folioNumber) {
            fetchInvestorType();
          }
          vm.formData.amount = rawData.flexSipForm.installmentAmount;
          vm.emandateMinAmountLimit = angular.copy(vm.formData.amount * 2);
          vm.formData.emandateAmount = angular.copy(vm.formData.amount * 2);
          $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
          checkAmountValidationEmandate();
          vm.formData.inSchemeCode = rawData.flexSipForm.schemeCode;
          vm.formData.frequency = rawData.flexSipForm.flexSipFrequency || vm.formData.frequency || frequencyList[0].key;
          vm.savedFrequency = vm.formData.frequency;
          vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);

          if (rawData.flexSipForm.bankDetailsForECS) {
            vm.formData.bankAcNo = rawData.flexSipForm.bankDetailsForECS.accNumber;
            vm.formData.bankCity = rawData.flexSipForm.bankDetailsForECS.bankCity;
            vm.formData.bankName = rawData.flexSipForm.bankDetailsForECS.bankName;
            vm.formData.bankBranch = rawData.flexSipForm.bankDetailsForECS.branchName;
            vm.savedAccType = rawData.flexSipForm.bankDetailsForECS.accType;
            if (rawData.flexSipForm.bankDetailsForECS.paymentOption === "HEM") {
              vm.formData.flexSipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
              vm.changedPaymentOption();
            } else if (rawData.flexSipForm.bankDetailsForECS.paymentOption === "OTM") {
              vm.formData.flexSipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
              vm.changedPaymentOption();
            } else {
              vm.formData.flexSipPaymentOption = null;
            }
          }
          if (vm.calenderEndDateString === rawData.flexSipForm.toDate) {
            vm.formData.isTillPerpetuity = true;
          }

          if (rawData.flexSipForm.primaryFlag) {
            vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP;
          }

          if (rawData.flexSipForm.euinOpted === 'Y') {
            vm.formData.euin = {euinCode: rawData.flexSipForm.euinCode, euinName: rawData.flexSipForm.euinName,euinNameCode: rawData.flexSipForm.euinName+"-"+rawData.flexSipForm.euinCode}
          }
          if (rawData.flexSipForm.riaOpted) {
              vm.formData.isThroughDistributor = false;
              vm.formData.isThroughRia = true;
              vm.formData.isDirect = false;
              vm.isArnSuccess = false;
              vm.formData.riaBrokerCode = rawData.flexSipForm.brokerCode;
              vm.riaConsent = rawData.flexSipForm.riaConsent;
              vm.isCheckedTandC = rawData.flexSipForm.riaConsent;
              vm.searchDistributor();
          }
          if (rawData.flexSipForm.brokerCode && !rawData.flexSipForm.riaOpted) {
              vm.formData.brokerCode = rawData.flexSipForm.brokerCode.replace('ARN-', '');
              vm.formData.isThroughDistributor = true;
              vm.formData.isThroughRia = false;
              vm.formData.isDirect = false;
              vm.formData.euinInput = rawData.flexSipForm.euinName + ' - ' + rawData.flexSipForm.euinCode;
              vm.searchDistributor();   // it will show the name of distributor based on broker code (ARN)
          }
          fetchInSchemes(function () {
              var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                return vm.formData.inSchemeCode === item.schemeCode;
              }) || {};
              vm.formData.inSchemeName = scheme.scheme || '';
            if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && scheme.retirementFlag) {
              MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
              vm.formData.inSchemeCode = '';
              vm.formData.inSchemeName = '';
              vm.formData.frequency = null;
              vm.frequencyList = [];
              vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
              return;
            }
            fetchInSchemeValidations(function (err) {
              checkOTM(function () {
                $timeout(function() {
                  if (success && rawData.flexSipForm.bankDetailsForECS.paymentOption === "OTM"){
                    vm.formData.bankInfo = vm.OTMbankList && vm.OTMbankList.find(function (bank) {
                      return bank.payoutId === rawData.flexSipForm.bankDetailsForECS.payoutId
                    })
                    vm.isfromSaved = true;
                    vm.changeBank();
                    if (vm.formData.bankInfo && !vm.formData.bankInfo.ifscCode) {
                      vm.formData.ifscCode = rawData.flexSipForm.bankDetailsForECS.ifscCode;
                    }

                  }
                },500)
              });
              checkEMandate(function () {
                if (err != 'error') {
                  vm.formData.sipDividendOption = rawData.flexSipForm.dividendOption;
                  vm.validations.investmentOption =vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[rawData.flexSipForm.investmentOption] ;
                  changeFrequency();
                  checkValidations();
                  fetchBankList();

                  $timeout(function() {
                    if (rawData.flexSipForm.bankDetailsForECS.paymentOption === "HEM") {
                      vm.formData.bankInfo = vm.EMbankList && vm.EMbankList.find(function (bank) {
                        return bank.accountNumber === rawData.flexSipForm.bankDetailsForECS.accNumber
                      })
                      vm.isfromSaved = true;
                      vm.changeBank();
                    }
                  },500)

                  vm.savedFI = rawData.flexSipForm.sipWithFirstInstallment;
                  if(rawData.flexSipForm.sipWithFirstInstallment) {
                    vm.sipFirstInstallment=true;
                    vm.formData.sipFirstInstallment=true;
                    vm.formData.sipFirstAmount=rawData.flexSipForm.installmentAmount;
                  } else {
                    vm.sipFirstInstallment=false;
                    vm.formData.sipFirstInstallment=false;
                  }
                }
              });

            });
          });

          fetchBankList(function (success) {
            if (success){
              $timeout(function() {
                var bankDetails = vm.bankList && vm.bankList.find(function (item) {
                  // return i.bankCode === rawData.bankCode;
                  return item === rawData.flexSipForm.bankDetailsForECS;
                }) || {};
                if (rawData.flexSipForm.bankDetailsForECS.paymentOption === "EC") {
                  vm.formData.bankInfo = vm.bankList && vm.bankList.find(function (bank) {
                    return bank.accountNumber === rawData.flexSipForm.bankDetailsForECS.accNumber
                  })
                  vm.isfromSaved = true;
                  vm.changeBank();
                  if (vm.formData.bankInfo && !vm.formData.bankInfo.ifscCode) {
                    vm.formData.ifscCode = rawData.flexSipForm.bankDetailsForECS.ifscCode;
                  }

                }
              });
            }

          });
          checkOTM();


          vm.formData.isBackFromSummary = false;
        }
        getDateValidation();
      })
    }

    vm.init = function () {
      var successRandomOTPIdHandler = function(resp) {
        vm.randomOTPId = resp.randomOTPId ? resp.randomOTPId : null;
      }, errorRandomOTPIdHandler = function (){}
      UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
      fetchTenureList()
      vm.backFromPayment=false;
      $state.$previous = null;
      if ($stateParams.trackId && !vm.formData.isBackFromSummary) {
        showPrefillValuesUserTracker();
      }else if (!vm.formData.isBackFromSummary) {
        TransactionModel.setPayloadRawData(null);
      }
      if (vm.formData.isBackFromSummary || $stateParams.sc) {
        vm.isArnSuccess = false;
        vm.showArnLabel = vm.formData.brokerCode ? true : false;
        vm.formData.isThroughDistributor = false;
        vm.formData.amount = null;
        resetBankDetails();
        showPrefillValues();
      } else if ($stateParams.transactionId && $stateParams.initiatedBy !== 'schedule') {
        getTransactionDetails();
      } else {
        fetchFolioList();
        if (vm.formData.brokerCode) {
          fetchEuinList();
        }
        vm.formData.transferOption = vm.formData.transferOption || vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;

      }

      var successHandler = function(resp) {
        if(Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || !resp.termAndConditionDTO.termAndConditionDTOMap[vm.key])
        {
          vm.showTerms = false;
        }

        if(Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || !resp.termAndConditionDTO.termAndConditionDTOMap[vm.keyOtm])
        {
          vm.showTermsEmandate = false;
        }
        else if(Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || resp.termAndConditionDTO.termAndConditionDTOMap[vm.keyOtm]){
          vm.showTermsEmandate = true;
        }
      }

      termsCondition.fetchData('FLEX_SIP').then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });

      vm.viewMode = 'months';


      if( $window.localStorage.getItem("SummaryEnabled")) {
        vm.backFromPayment=true;
        vm.formData.ifscCode = vm.formData.ifscCode ? vm.formData.ifscCode :  null;
        vm.formData.bankAcType = vm.formData.bankAcType ? vm.formData.bankAcType :  null;
        if (vm.formData.bankInfo) {
          vm.changeBank();
          vm.changeEndDate(vm.formData.endDate);
        }
        vm.moveToSummary();
      }
      vm.frequencyList = vm.TRANSACTIONS_CONST.Dynamic_FLEX_SIP_FREQ_LIST;
    };

    function getDetails() {
      var success = function (resp) {
        var bankDetails=[];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if(vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length>0){
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if(value.defaultBank===true){return value;}
          });
        }
        localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
      }, error = function () {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }

    vm.confirmCancel = function () {
      var success = function () {
        $state.go('welcome')
      };
      ModalService.confirmCancelModal({}, success);
    };


    vm.folioChanged = function () {
      if(!vm.formData.folioNumber){return;}

      var successHandler = function(resp) {
        LoaderService.hideLoader();
        var oldData = angular.copy(vm.formData);
        resetAll();
        recoverFromResetting(oldData);
        vm.isEmailMobileinValid = false;
        vm.isEmailinValid = false;
        vm.isMobileinValid = false;
        vm.emandateDisplay = true;
        vm.isfromSaved = false;
        vm.sipFirstInstallment = false;
        var selectedFolioObj = vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        if (selectedFolioObj) {
          vm.selectedFolioData = selectedFolioObj;
        }
        vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
        vm.formData.minorFlag = vm.folioMinor;
        vm.formData.corporateInvestor = selectedFolioObj && angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
        /*if(vm.formData.minorFlag){
          ModalService.minorSipModal({});
        }*/
        vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName:'';
        vm.selectedFolioEmail = selectedFolioObj.email;
        vm.selectedFolioMobile = selectedFolioObj.mobileNumber;
        fetchPreviousTrSelectedDistrubutor(function () {
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          fetchInSchemes();
          checkOTM(function (success) {
            if (success) {
              changedPaymentOption();
              checkEMandate();
            }
          });
        });
        if(vm.selectedFolioMobile === null || vm.selectedFolioMobile === ''){
          if(vm.selectedFolioEmail === null || vm.selectedFolioEmail === ''){
            vm.isEmailMobileinValid = true;
            vm.emandateDisplay = false;
          }
          else {
            vm.isMobileinValid = true;
            vm.emandateDisplay = false;
          }
        }
        else if(vm.selectedFolioEmail === null || vm.selectedFolioEmail === ''){
          if(vm.selectedFolioMobile === null || vm.selectedFolioMobile === ''){
            vm.isEmailMobileinValid = true;
            vm.emandateDisplay = false;
          }
          else {
            vm.isEmailinValid = true;
            vm.emandateDisplay = false;
          }
        }
        if (vm.formData.folioNumber) {
          fetchInvestorType();
        }
      }
      var errorHandler = function(resp)
      {
        LoaderService.hideLoader();
        vm.formData.folioNumber=null;
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);
    };


    function checkEMandate(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.isEMandateEnabled = resp.data.folioEmandateStatus;
            if ((resp.data.bankList && resp.data.bankList.length == 0) || !vm.isEMandateEnabled) {
              // vm.isEMandateEnabled = false;
              vm.EMbankList = null;
              var index = vm.paymentOptions.indexOf('E-mandate');
              if(index > -1) {
                vm.paymentOptions.splice(index,1);
              }

              if(vm.formData.flexSipPaymentOption === 'E-mandate') {
                vm.formData.flexSipPaymentOption = null;
              }
              if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
                vm.formData.flexSipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
              }

              if (vm.paymentOptions.includes("OTM") && !vm.isOTMEnabled) {
                var index = vm.paymentOptions.indexOf('OTM');
                if (index > -1) {
                  vm.paymentOptions.splice(index, 1);
                }
              }
              if(vm.inSchemeValidations && vm.inSchemeValidations.cgfFlag && vm.formData.frequency !== 'OW' && vm.formData.frequency !== 'BZ') {
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                vm.formData.flexSipPaymentOption = vm.paymentOptions[0];
                changedPaymentOption();
              }
            }
            else{
              if(vm.sipFirstInstallment)
              {
                vm.isEMandateEnabled = false;
              }
              else {
                vm.EMbankList = resp.data.bankList;
                // vm.isEMandateEnabled = true;
                if (vm.formData.flexSipPaymentOption === 'E-mandate') {
                  vm.bankList =  vm.EMbankList;
                }
              }
            }
          }
          cb(true);
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };
      var data = {
        trnxType: 'SIP',
        liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false,
        folioNumber:vm.formData.folioNumber
      };
      InvestorService.post({
        child1: 'folio',
        child2: 'emandate'
      }, data).$promise.then(success, error);
    }

    vm.enabledOTMStartDatesList = [];
    vm.enabledBillerStartDatesList = [];
    function getDateValidation(cb) {
      cb = cb || function () {};
      var success = function (resp) {
          if (resp.status && resp.data) {
            var currentDate = resp.data.currentDate || Date();
            vm.daysList = resp.data.listOfDays;
            var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
            var todayDate = $window.moment(Date.parse(parsedDate));
            var counter =0;
            vm.nonBusinessDatess = resp.data.nonBuisnessDates;
            if(vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
            }else {
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(11, 'days');
            }
            vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
            var startDate = todayDate.clone();
            var freq = vm.startMaxDate.diff(todayDate, 'days');
            for (var i = 0; i <= freq; i++) {
              var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
              var isEnable = true;
              if(counter<5)
              {
                angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                  if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')===0){
                    isEnable = false;
                  }
                });
              }
              if(isEnable){
                vm.enabledOTMStartDatesList.push(startDate.clone().add(i, 'days'));
                counter++;
              }
            }

            vm.startMinDateOTM = vm.enabledOTMStartDatesList[5];
            if(vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              vm.startMinDateBiller = vm.enabledOTMStartDatesList[vm.eMandatenoOfDays];
              vm.enabledBillerStartDatesList = vm.enabledOTMStartDatesList;
            }

            if(vm.enabledOTMStartDatesList.length > 0){
              vm.formData.startDate = vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM || vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE ? angular.copy(vm.startMinDateOTM) : angular.copy(vm.startMinDateBiller);
              vm.formData.tenure = vm.tenureDuration[vm.tenureDuration.length - 1].tenureValue;
              vm.changeTenure()
            }

            vm.isReseting = true;
            $timeout(function () {
              vm.isReseting = false;
            });
            cb(true);
          } else {
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb(false);
        };
      InvestorService.get({
        child1: 'nonBusinessDate',
        schemeCode: vm.formData.inSchemeCode //'AFWDQ'
      }).$promise.then(success, error);
    }


    function fetchPreviousTrSelectedDistrubutor(cb) {

      cb = cb || function () {
      };
      if (!vm.formData.folioNumber) {
        resetAll();
        cb(true);
      }else if(vm.formData.isBackFromSummary){cb(true);}
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var distributorDetails = resp.data;
            if (distributorDetails.investThroughDistributor
              && distributorDetails.previousDistributorDetails.brokerCode.indexOf('ARN-') === 0) {
              var brokerCode = distributorDetails.previousDistributorDetails.brokerCode
                ? distributorDetails.previousDistributorDetails.brokerCode.split('-') : [];
              vm.formData.brokerCode = brokerCode.length > 0 ? brokerCode[1] : '';
              manipulateInvestThrough(AppConstants.INVEST_THROUGH.DISTRIBUTOR);
              vm.formData.brokerName = distributorDetails.previousDistributorDetails.brokerName;
              var subBrokerArn = distributorDetails.previousDistributorDetails.subBrokerArn;
              var subBrokerARNArray = subBrokerArn ? subBrokerArn.split('-') : [];
              vm.formData.subBrokerARN = subBrokerARNArray ? subBrokerARNArray[1] : '';
              vm.formData.subBrokerCode = distributorDetails.previousDistributorDetails.subBrokerCode;
              vm.subBrokerName = distributorDetails.previousDistributorDetails.subBrokerName;
              vm.euinMasterList = distributorDetails.previousDistributorDetails.euinDetailList;
              vm.euinList = vm.euinMasterList;
              vm.formData.euin = vm.euinList.length === 1 ? vm.euinList[0] : null;
              vm.formData.euin = distributorDetails.previousDistributorDetails.euinPreviousUsed ? vm.euinList[0] : null;
              vm.euinData = vm.formData.euin ? vm.formData.euin : {};
              if (vm.euinData) {
                vm.euinData.euinNameCode = vm.formData.euin ? vm.formData.euin.euinNameCode : null;
              }
              vm.isCheckedTandC = false;
              vm.isArnSuccess = false;
              vm.showArnLabel = false;
            } else if (distributorDetails.investThroughRIA) {
              vm.formData.riaBrokerCode = distributorDetails.previousDistributorDetails.brokerCode ?
                distributorDetails.previousDistributorDetails.brokerCode : "";
              vm.formData.riaBrokerName = distributorDetails.previousDistributorDetails.brokerName;
              vm.isArnSuccess = false;
              vm.showArnLabel = false;
              vm.riaCodeError = "";
              manipulateInvestThrough(AppConstants.INVEST_THROUGH.RIA);
            } else {
              manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
              (angular.isUndefined($stateParams.sc)) && resetAll();
            }
            cb(true);
          } else {
            //vm.folioList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
         LoaderService.hideLoader();
          //vm.folioList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      var payload = {
        folioNo:vm.formData.folioNumber
      };

      if ($stateParams.sc) {
        payload.schemeCode = $stateParams.sc;
      }
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'folio',
        child2: 'status',
        child3: 'previous',
        child4: 'transaction'
      },payload).$promise.then(success, error);
    }

    function recoverFromResetting(oldData) {
      if (vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP) {
        vm.formData.transferOption = oldData.transferOption;
      }
    }

    vm.schemeListModal = function () {
      if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
        MessageService.error('No free available units');
        return;
      }
      var successSchemeList = function (result) {
          vm.inSchemeChanged(result);
        },
        errorSchemeList = function () {
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
        };

      var isFlexStp = false;

      ModalService.schemeListModal({
        enabledScheme: 'flexsipenabled',
        isMinor: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
        isFlexStp: isFlexStp,
        isThroughDistributor: vm.formData.isThroughDistributor,
        corporateFlag : vm.formData.corporateInvestor
      }, successSchemeList, errorSchemeList);
    };

    vm.outSchemeChanged = function () {
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.amountType = 'amount';
      vm.formData.bankInfo = null;
      vm.bankList = null;
      vm.unitsDetails = null;
      vm.formData.dividendOption = '';
      vm.formData.frequency = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.day = '';
      vm.formData.weeklyDay = null;
      vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;

      if (!vm.formData.outSchemeCode) {
        vm.formData.outSchemeName = '';
        return;
      }

      var scheme = vm.outSchemeList.find(function (item) {
        return item.schemeCode === vm.formData.outSchemeCode;
      }) || {};
      vm.formData.outSchemeName = scheme.schemeName || '';
    };

    vm.filterInSchemeList = function () {
      vm.formData.inSchemeCode = '';
      vm.authenticationMode = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
      vm.isfromSaved = false;
      resetNumInWords();
    };


    vm.uploadRetirementProofFile = function (file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.formData.retirementAgeProofURL = resp.data.fileUrl;

                vm.breakFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            InvestorFileUploadService.post({
              child1: 'transaction',
              child2: 'retirement',
              child3: 'ageProof',
              child4: 'upload'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    };

    vm.breakFileUrl = function (url) {

      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1 || url.split('_jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1 || url.split('_png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1 || url.split('_pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1 || url.split('_bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      vm.retirementAgeProofURL = a[a.length - 1] + extension;
      vm.chooseAFile = false;

    };

    /**
     * Function responsible for handling scheme change
     */

    vm.inSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        if (vm.formData.inSchemeCode !== schemeData.schemeCode) { //block responsible to reset all values if scheme code doesn't match
          vm.formData.startDate = null;
          vm.formData.tenure = null;
          if (vm.tForm.tenure) {
            vm.tForm.tenure.$setPristine(true);
          }
          vm.formData.endDate = null;
          vm.formData.day = '';
          vm.formData.bankInfo = null;
          vm.enabledStartDates = null;
          vm.enabledEndDates = null;
          vm.formData.amount = '';
          vm.formData.sipFirstAmount = '';
          vm.formData.units = '';
          vm.formData.amountType = 'amount';
          vm.formData.isTillPerpetuity = false;
          vm.disableEndDateSelection = false;
          vm.formData.weeklyDay = null;
          vm.backFromPayment=false;
          vm.formData.sipFirstInstallment =false;
          vm.sipFirstInstallment=false;
          vm.formData.authMode = null;
          vm.authenticationMode = null;
          if (vm.tForm.authenticationMode) {
            vm.tForm.authenticationMode.$setPristine(true)
          }
          if (vm.enabledEmandateEndDatesList && vm.enabledEmandateEndDatesList.length > 0) {
            vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
          }
          reSetting();
          resetDefaults();
          resetNumInWords();
        }

        if(!vm.backFromPayment)
          vm.formData.sipDividendOption = null;

        vm.formData.inSchemeCode = schemeData.schemeCode;
        vm.formData.inSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.formData.frequency = null;
          vm.frequencyList = [];
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
          return;
        }
        vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
        checkEMandate(function () {});
        fetchInSchemeValidations(function () {
          vm.validations.investmentOption = vm.validations.investmentOption;
          getDateValidation();
          if(schemeData.schemeType === 'NFO') {
            var message = schemeData.message;
            ModalService.nfoEnabledModal({message: message});
            checkEMandate();
          }

          if(vm.checkForMinorBankListCondition()) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            if(vm.isOTMEnabled){
              vm.formData.flexSipPaymentOption = vm.paymentOptions[0];
            }
            else {
              vm.formData.flexSipPaymentOption = null;
            }
            getDetails();
          }
          else if(vm.isOTMEnabled || !vm.checkForMinorBankListCondition()) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            if (!vm.formData.flexSipPaymentOption) {
              if(vm.isOTMEnabled){
                vm.formData.flexSipPaymentOption = vm.paymentOptions[0];
              } else {
                vm.formData.flexSipPaymentOption = vm.paymentOptions[1];
              }
            }
            checkEMandate();
          }
          else {
            vm.formData.flexSipPaymentOption = null;
            vm.paymentOptions = [];
          }
          checkValidations();
          if (vm.formData.bankInfo) {
            if (!vm.isfromSaved) {
              vm.changeBank();
            }
            vm.changeEndDate(vm.formData.endDate);
          }
        });
      }
      if (vm.formData.flexSipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
        $timeout(function() {
          if (vm.bankList && vm.bankList.length === 1) {
            vm.formData.bankInfo = vm.bankList[0];
            vm.changeBank();
          }
        })
      }
      NetcoreEvntService.Complete_Selected_Scheme_SIP_IP(vm.formData);
    };


    /**
     * Function responsible for handling start date selection
     */

    vm.changeStartDate = function (date) {
      vm.formData.startDate = date ? date : null;
      vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = false;
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      });
      if(vm.formData.flexSipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        checkOTMAmountAndDate();
      }
      vm.changeTenure();
    };

    /**
     * Function responsible for handling end date
     */

    vm.changeEndDate = function (date) {
      //vm.formData.endDate = date ? date : null;
      vm.diffInMonths = parseInt($window.moment(vm.formData.endDate).diff($window.moment(vm.formData.startDate), 'months', true));
      if(vm.formData.flexSipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        checkOTMAmountAndDate();
      }
    };

    /**
     * Function responsible for handling invest through selection
     */

    vm.changeThroughDistributor = function (investThrough) {
      if (investThrough === 'DIRECT') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
        vm.formData.euin = null;
        vm.formData.subBrokerCode = null;
        vm.formData.brokerCode = null;
        vm.formData.subBrokerName = null;
        vm.formData.subBrokerARN = null;
      } else if (investThrough === 'ARN') {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
      } else if (investThrough === 'RIA') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
        vm.formData.euin = null;
        vm.formData.subBrokerCode = null;
        vm.formData.brokerCode = null;
        vm.formData.subBrokerName = null;
        vm.formData.subBrokerARN = null;
      }

      if (!vm.formData.isThroughDistributor) {
        vm.formData.euin = {};
        vm.euinData = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        //vm.formData.euinInput = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.formData.subBrokerCode = '';
        vm.isSelectedEuin = true;
        vm.subBrokerName = '';
      }
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      fetchInSchemes();

      vm.formData.frequency=null;
      vm.formData.amount = null;

      vm.formData.flexSipPaymentOption = vm.paymentOptions[0];
      changedPaymentOption();
    };

    vm.changeTillPerpetuityFlag = function () {
      vm.formData.endDate = null;
      vm.resetting = true;
      $timeout(function () {
        vm.resetting = false;
        if (vm.formData.isTillPerpetuity) {
          vm.disableEndDateSelection = true;
          var defaultMonths = null;
          var endDate = $window.moment(new Date("12/31/2099"));
          var freq = vm.validations && vm.validations.maxInstallments || 0;
          var frequency = vm.frequencyList.find(function (f) {
            return f.code === vm.formData.frequency;
          }) || {};

          switch (vm.formData.frequency) {
            default :
              // var months = 0;
              defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, $window.moment(endDate));
              freq = freq || Math.floor(defaultMonths / frequency.duration) * frequency.duration;
              vm.formData.endDate = vm.formData.startDate.clone().add(freq, 'months');
              break;
          }
          vm.changeEndDate(vm.formData.endDate);
        } else {
          vm.disableEndDateSelection = false;
        }
      }, 0);
    };

    /**
     * Function responsible for handling distributor search
     */

    vm.searchDistributor = function () {
      //vm.isInvalidForm = vm.formData.brokerCode ? false : (vm.isArnSuccess ? true : false);
      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      fetchEuinList();
    };

    /**
     * Function responsible for handling distributor name search
     */

    vm.searchDistributorByName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      //vm.isInvalidForm = true;
      vm.brokerCodeError = '';
      vm.isArnSuccess = true;
      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        vm.distributorList = null;
        vm.euinList = null;
        //vm.formData.euinInput = '';
        vm.formData.euin = null;
        return;
      }
      fetchARNByName();

    };

    /**
     * Function responsible for handling save transaction
     */

    vm.saveForm = function () {
      vm.isRequired = false;
      vm.isSaving = true;
      var payload = getFinalPayloadData();
      if (!payload) {
        return;
      }

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (angular.isArray(resp.data)) {
              var data = {};
              resp.data.forEach(function (_form) {
                if (_form) {
                  data.flexSipForm = _form;
                }
              });

              vm.formData.sTransactionId = data.flexSipForm ? data.flexSipForm.transactionId : '';
            } else {
              vm.formData.transactionId = resp.data.transactionId;
            }

            var successModal= function () {
              $state.go('welcome')
            };
            ModalService.savedTransactionModal({},successModal);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      var _controller2 = 'flexSip';
      TransactionService.post({
        controller1: 'transaction',
        controller2: _controller2,
        controller3: 'save'
      }, payload).$promise.then(success, error);
    };

    /**
     * Function responsible for handling payment mode selection
     */

    function changedPaymentOption() {

      if ((vm.formData.flexSipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) && !vm.emandateObj) {
        UtilService.fetchMandateValidations().then(function (resp) {
          vm.emandateObj = resp.eOTM;
          vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
          vm.eMandatenoOfDays = vm.emandateObj.noOfDays;
          vm.eMandatemaxAmountLimit = vm.emandateObj.maxAmountLimit;
          vm.emandateMinimumAmountLimit = vm.emandateObj.minAmountLimit;
          vm.emandateMinAmountLimit = angular.copy(vm.formData.amount * 2);
          if (vm.formData.amount) {
            vm.formData.emandateAmount = angular.copy(vm.formData.amount * 2);
            $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
            checkAmountValidationEmandate();
          }
          vm.mandateInfo = vm.emandateObj.mandateInfo;
          vm.minEndDateGapMandate = vm.emandateObj.minEndDateGap;
          vm.mandateMaxString = vm.emandateObj.maxAmountLimitInfo;
          vm.formData.emandateDate = $window.moment().add(vm.emandateObj.minStartDays,'days');
          updateEmandateEndDate();
        }).catch(function(resp) {
          MessageService.error(resp)
        });
      } else {
        if (vm.formData.flexSipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          vm.formData.emandateDate = $window.moment().add(vm.emandateObj.minStartDays,'days');
          updateEmandateEndDate();
        }
        if (vm.formData.amount) {
          vm.formData.emandateAmount = angular.copy(vm.formData.amount * 2);
          $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
          checkAmountValidationEmandate();
        } else {
          vm.formData.emandateAmount = null;
        }
      }

      vm.formData.bankInfo = null;
      vm.formData.otmId = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity  = null;
      vm.formData.authMode = null;
      vm.authenticationMode = null;
      vm.enabledBillerStartDatesList=null;
      vm.formData.weeklyDay = null;
      vm.disableEndDateSelection = false;
      vm.isInvalidForm = false;
      vm.formData.tenure = null;
      if (vm.tForm.tenure) {
        vm.tForm.tenure.$setPristine(true);
      }
      vm.isfromSaved = false;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      fetchBankList();
      checkEMandateValidation();
      if(vm.formData.flexSipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        checkOTMAmountAndDate();
      }
      if(vm.formData.inSchemeCode) {
        getDateValidation();
      }
      if (vm.formData.flexSipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
        $timeout(function() {
          if (vm.bankList && vm.bankList.length === 1) {
            vm.formData.bankInfo = vm.bankList[0];
            vm.changeBank();
          }
        })
      }
    }

    /**
     * Function responsible for checking emandate validations
     */

    function checkEMandateValidation(){
      if(vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
        vm.validations.maxAmount=vm.eMandatemaxAmountLimit;
        vm.isMax = vm.formData.amount > vm.FlexSipMaxAmount;
      }
      else vm.isMax=false;
    }

    /**
     * Function responsible for handling bank selection
     */

    vm.changeBank = function () {
      if (!vm.formData.bankInfo) {
        return;
      }

      if (vm.formData.bankInfo.ifscCode) {
        vm.formData.ifscCode = null;
      }

      if (vm.formData.bankInfo.bankAcType) {
        vm.formData.bankAcType = null;
      }

      if(!vm.formData.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
        var selectedFolioObj = vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        localStorage.setItem('folioId',selectedFolioObj.folioNumber);
        ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
        vm.formData.bankInfo = null;
        return;
      }
      if(!vm.formData.bankInfo) {
        vm.authenticationMode=null;
      }

      if (vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
        vm.formData.authMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes[0] : null;
        vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
        vm.formData.bankAcNo = vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '';
        vm.formData.emUmrn = vm.formData.bankInfo ? vm.formData.bankInfo.emUmrn : '';
        vm.formData.maxAmount = vm.formData.bankInfo ? vm.formData.bankInfo.maxAmount : '';
        vm.formData.emExpiryDate = vm.formData.bankInfo ? vm.formData.bankInfo.emExpiryDate : '';
      } else if (vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        vm.formData.otmId = vm.formData.bankInfo ? vm.formData.bankInfo.otmId : '';
        vm.formData.bankName = vm.formData.bankInfo ? vm.formData.bankInfo.bankName : '';
        vm.formData.bankBranch = vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '';
        vm.formData.bankAcNo = vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '';
        vm.formData.payoutId = vm.formData.bankInfo ? vm.formData.bankInfo.payoutId : '';
        (vm.formData.bankInfo && angular.isDefined(vm.formData.bankInfo.camsMandateIdNo))&&(vm.formData.camsMandateIdNo = vm.formData.bankInfo.camsMandateIdNo);
        if(angular.isDefined(vm.formData.bankInfo) && (vm.formData.bankInfo.otmFrequency !== 'AWP')){
          vm.isInvalidForm = true;
          MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
        }
        delete vm.formData.netBankingUrl;
        checkOTMAmountAndDate();
        if (!vm.formData.bankInfo.bankAcType) {
          getAccountType(function (success) {
            if (success && vm.savedAccType) {
              $timeout(function() {
                vm.formData.bankAcType = vm.savedAccType;
                vm.savedAccType = null;
              })
            }
          });
        }
      }
      resetBankDetails();   // need for sip transaction
    };


    /**
     * Function responsible for resetting selected bank details
     */

    function resetBankDetails() {
      vm.formData.bankCity = '';
      vm.formData.bankBranch = '';
      vm.formData.bankAcNo = '';
      vm.formData.verifyBankAcNo = '';

    }

    vm.removeOptionalScheme = function () {
      vm.formData.dividendOption = '';
      vm.formData.frequency = vm.frequencyList[0].code;
      vm.formData.day = '';
      vm.formData.weeklyDay = '';
      vm.formData.startDate = '';
      vm.formData.endDate = '';
      vm.formData.flexSipPaymentOption = vm.paymentOptions[0];
      vm.formData.bankAcNo = '';
      vm.formData.ifscCode = '';
      vm.formData.bankBranch = '';
      vm.formData.bankCity = '';
      vm.formData.bankName = '';
      vm.formData.otmId = '';
      vm.formData.isTillPerpetuity = false;
      vm.formData.optionalInvestmentType = '';
    };

    vm.otherBankSelected = function () {
      //vm.formData.bankInfo = '';
    };

    /**
     * Function responsible for triggering summary view function
     */

    vm.goToFlexSipSummary = function () {
      //vm.isCheckedTandC = false;
      /*if (vm.formData.inSchemeName && vm.formData.inSchemeName.includes('Children')) {
        var success = function () {
            beforeSummary();
          },
          error = function () {

          };
        var message = AppConstants.TRANSACTIONS.CGF_SCHEME_MSG;
        ModalService.childrenFundMessage({message: message}, success, error);
      } else {
          beforeSummary();
      }*/
      beforeSummary();
    };

    /**
     * Function responsible for showing cut off modal before summary
     */

    function beforeSummary() {
      if(vm.popup !== undefined)
      {
        vm.showCutOffModal({cutoffData:vm.popup,showCutOff:vm.showpopup});
      }
      else {
        vm.moveToSummary();
      }
    }

    /**
     * Function responsible for setting payload for summary view and enabling summary view
     */

    vm.moveToSummary = function () {
      vm.setTandCVariable();
      userActivityTracking(function (trackResp) {
        var params = {transactionType: 'SIP'};
        if ((trackResp && angular.isDefined(trackResp.transactionId)) || $stateParams.trackId) {
          params.trackId = trackResp.transactionId || $stateParams.trackId;
          vm.formData.trackId = params.trackId;
        }
        vm.isRequired = true;
        vm.isSaving = false;
        if (vm.formData.euin && !vm.formData.euin.euinName && !vm.formData.euin.euinCode && vm.formData.euinInput) {
          vm.formData.euin.euinName = (vm.formData.euinInput.split('-')[0]).trim();
          vm.formData.euin.euinCode = (vm.formData.euinInput.split('-')[1]).trim();
        }
        $state.$previous = $state.current;
        if (vm.tForm.$valid) {
          var payloadData = getFinalPayloadData();
          if (!payloadData) {
            return;
          }
          var selectedFolioObj = vm.folioList.filter(function (row) {
            return row.folioNumber == vm.formData.folioNumber
          })[0];
          payloadData.email = selectedFolioObj.email ? selectedFolioObj.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
          payloadData.mobileNumber = selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;
          payloadData.randomOTPId = vm.randomOTPId;
          TransactionModel.setPayloadRawData(payloadData);
          /*Netcore Event Start*/
          NetcoreEvntService.Proceed_To_Transact_SIP_IP(payloadData);
          /*Netcore Event End*/
          vm.summaryData = payloadData;
          vm.summaryData['scheduleDetails'] = vm.scheduleTransactionDetails;
          vm.formData.isSummaryViewEnabled = true;
          $window.localStorage.removeItem("SummaryEnabled");
        }

      });
    };

    function userActivityTracking(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && (resp.data || resp)) {
            resp = resp.data || resp;
            LoaderService.hideLoader();
            cb(resp);
        }
        else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      },error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(err);
      };

      var userTrackerPayload = setUserTrackerPayload();
      InvestorService.post({
        child1: 'userBehavior',
        child2: 'addupdate'
      }, userTrackerPayload).$promise.then(success, error);
    }

    function setUserTrackerPayload() {
      var _payload = {
        "trxnRefNo": $stateParams.trackId?$stateParams.trackId:"", //required in case of update
        "trxnType": 'SIP',
        "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
        "step": "FIRST", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.inSchemeCode, // required
        "folioNo": vm.formData.folioNumber, // required
        "formData": getFlexSipPayloadToSave(), // required
        "amount": vm.formData.amount, //required
        "trxnStatus": "OPEN",  // OPEN,PROCESSED
        "promoterCode": "" // capture from the transaction link
      };
      return _payload;
    }

    /**
     * Function responsible for showing cut off modal
     */

    vm.showCutOffModal = function (message) {
      var success = function () {
        vm.moveToSummary();
      }, error = function () {

      };
      ModalService.cutOffModal({message: message}, success, error);
    };


    /**
     * Function responsible for handling enter key press
     */

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        e.preventDefault();
      }
      return false;
    };

    /**
     * Function responsible for handling copy paste
     */

    vm.copyPasteHandler = function (e) {
      UtilService.copyPasteHandler(e);
    };

    vm.accModelDirty = false;

    vm.accFocus = function () {
      vm.accModelDirty = true;
    };

    /**
     * Function responsible for checking euin selection
     */

    vm.isCheckedEuin = function () {
      if (vm.isCheckedTandC) {
        vm.formData.euin = {};
      }
    }

    /**
     * Function responsible for handling euin selection change
     */

    vm.isSelectEuin = function () {
      if (vm.formData.euin) {
        vm.isCheckedTandC = false;
      }
    }


    /**
     * Function responsible for checking otm amount and date validations
     */

    function checkOTMAmountAndDate() {

      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isOTMEndDate = false;
      vm.isMax = vm.formData.amount > vm.FlexSipMaxAmount;
      // Check Amount
      var doubleAmount = 2 * vm.formData.amount;
      if (vm.formData.amount && vm.formData.bankInfo && (vm.formData.bankInfo.maxAmount >= doubleAmount)) {
        vm.isOTMAmount = false;
      } else {
        vm.isOTMAmount = true;
      }

      //Compare Start Dates
      if (vm.formData.bankInfo && ($window.moment(vm.formData.bankInfo.omExpiryDate, "DD-MMM-YYYY").isBefore(vm.formData.startDate))) {
        vm.isOTMDate = true;
      }
      else {
        vm.isOTMDate = false;
      }
      //Compare End Dates
      if (vm.formData.bankInfo && vm.formData.bankInfo.omStartDate) {
        if (!(vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore(new Date($window.moment(vm.formData.startDate))))) {
          if(vm.formData.startDate ==  null) {
            vm.isOTMStartDate = false;
          } else {
            vm.isOTMStartDate = true;
          }
        } else {
          vm.isOTMStartDate = false;
        }
      }

      if (vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isBefore(new Date($window.moment((vm.formData.endDate))))) {
        vm.isOTMEndDate = true;
      }
      else {
        vm.isOTMEndDate = false;
      }
      //Check for amount or date
      if (vm.isOTMAmount || vm.isOTMDate || vm.isOTMEndDate) {
        vm.isInvalidForm = true;
      } else {
        vm.isInvalidForm = false;
      }
    }

    /**
     * Function responsible for handling report downloads
     */

    vm.downloadReport = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], {type: 'application/pdf'});
            FileSaver.saveAs(data, 'exitLoad.pdf');

          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "schemeCode": vm.formData.outSchemeCode,
        "commonReportCO": {
          "docDestination": "download"
        }
      };

      DownloadPdfService.downloadFile(payload).then(success, error);
    }

    /**
     * Function responsible for handling distributor code change
     */

    vm.changeDistributorCode = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.euinList = null;
      vm.isArnSuccess = true;
      vm.riaCodeError = "";
    }

    /**
     * Function responsible for handling distributor name change
     */

    vm.changeDistributorName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      vm.euinList = null;
    }

    /**
     * Function responsible for handling distributor list change
     */

    vm.distributorListChanged = function (data) {
      if (!data) {
        // vm.isArnSuccess = true;
        return;
      } else {
        vm.brokerCodeError = '';
        vm.formData.distributorARN = data.arnCode;
        vm.formData.distributorName = data.name + ' - ' + data.arnCode;
        vm.showArnLabel = false;
        if (vm.formData.distributorARN) {
          //vm.isInvalidForm = false;
          vm.isArnSuccess = false;
        }
        else {
          vm.isArnSuccess = true;
        }
        fetchEuinListThroughDistributor(vm.formData.distributorARN);
      }
    };

    /**
     * Function responsible for sub broker arn change
     */

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
    }

    /**
     * Function responsible for folio creation redirection
     */

    vm.redirectToFolioCreation = function() {
      var successHandlerFolioCreation=function(resp) {
        LoaderService.hideLoader();
        localStorage.removeItem('folioId');
        InvestorFolioModel.resetInvestorFolioModel();
        $state.go('main.folio.holdmode');
      };
      var errorHandlerFolioCreation=function(resp) {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.profile.investorPAN, null).then(successHandlerFolioCreation).catch(errorHandlerFolioCreation);
    }


    /**
     * Function responsible to set invest through check
     */

    function manipulateInvestThrough(investThrough) {
      if (investThrough === AppConstants.INVEST_THROUGH.DIRECT) {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
      } else if (investThrough === AppConstants.INVEST_THROUGH.DISTRIBUTOR) {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
      } else if (investThrough === AppConstants.INVEST_THROUGH.RIA) {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
      }
    }

    /**
     * Function responsible to manage the broker code for purchase and sip payload
     */

    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = vm.isCheckedTandC ? true : false;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['subBrokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }

    /**
     * function responsible for tnc checkbox toggle
     */

    vm.setTandCVariable = function() {
      vm.formData.isCheckedTandC = vm.isCheckedTandC;
    };

    /**
     * function responsible for redirection to nav url
     */

    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };

    /**
     * function responsible for setting dynamic data for notes and tnc
     */

     function setDynamicData() {
      vm.notesReview = vm.DynamicDataFlexSipReview.noteDTO.noteDTOMap.Note_FLEX_SIP_Review_Registration;
      vm.popup = vm.DynamicDataFlexSipReview.popupDTO.popupDTOMap.Popup_FLEX_SIP_Review;
      vm.notesOtm = vm.DynamicDataFlexSipReview.noteDTO.noteDTOMap.Note_FLEX_SIP_Review_OTM;
      vm.notesEOtm = vm.DynamicDataFlexSipReview.noteDTO.noteDTOMap.Note_FLEX_SIP_Review_eOTM;
      vm.riaMessage = vm.DynamicDataFlexSipReview.termAndConditionDTO.termAndConditionDTOMap.TNC_FLEX_SIP_Review_Through_RIA;
      vm.distributorMessage = vm.DynamicDataFlexSipReview.termAndConditionDTO.termAndConditionDTOMap.TNC_FLEX_SIP_Through_Distributor;
      vm.FLEX_SIP_ONLY_GROWTH = vm.DynamicDataFlexSipReview.popupDTO.popupDTOMap.FLEX_SIP_GROWTH_MESSAGE;
      vm.key = "TNC_FLEX_SIP_Review_Registration";
      vm.keyOtm = "TNC_FLEX_SIP_Review_Registration_eOTM";
      vm.notesEOtmDebitCard = vm.DynamicDataFlexSipReview.noteDTO.noteDTOMap.Note_FLEX_SIP_Review_eOTM_Debit_Card;

      if(!vm.distributorMessage) {
        vm.formData.isCheckedTandC = false;
      }
      if(!vm.riaMessage) {
        vm.formData.isCheckedTandC = false;
      }

     }

    vm.isSelectedEuin = true;

    /**
     * function responsible for setting euin list
     */

    vm.filterEuinList = function () {
      vm.formData.euin = {};
      vm.isSelectedEuin = false ;
      if(vm.euinData.euinNameCode){
        if(vm.euinData.euinNameCode.length>=3){
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.euinData.euinNameCode);
        }
      }
      vm.euinList = vm.euinData.euinNameCode == '' || vm.euinData.euinNameCode == undefined || vm.euinData.euinNameCode.length<3 ? vm.euinMasterList : vm.euinList;
    };

    /**
     * function responsible for fetching and setting investment option
     */

    function fetchInvestmentOption(investmentOption) {
      var investmentOptionKey = "";
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == investmentOption) {
          investmentOptionKey = key;
        }
      });
      return investmentOptionKey;
    }


    /**
     * function for setting euin code
     */

    vm.selectEuin = function(data) {
      if (!data) {
        return;
      }
      vm.euinData = {};
      vm.euinData.euinNameCode = data.euinNameCode;
      vm.isSelectedEuin = vm.euinData.euinNameCode ? true : false;
    }

    /**
     * function for setting end date based on tenure selection
     */

    vm.changeTenure = function () {
      vm.formData.endDate = null;
      if (vm.formData.startDate && vm.formData.tenure) {
        if (vm.formData.frequency === 'OM') {
          vm.formData.endDate = moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.formData.tenure, 'years').subtract(1, 'months');
        } else if (vm.formData.frequency === 'Q') {
          vm.formData.endDate = moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.formData.tenure, 'years').subtract(3, 'months');
        }
        if(vm.formData.flexSipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && vm.formData.endDateEmandate) {
          vm.sipDateLessEmandate =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
          // if (vm.sipDateLessEmandate) {
          //   var setEndDateLess = false;
          //   var tempEndDate = angular.copy($window.moment(vm.formData.endDate));
          //   while (!setEndDateLess) {
          //     tempEndDate = angular.copy($window.moment(tempEndDate).subtract(1, 'months'));
          //     if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY'))) {
          //       setEndDateLess = true;
          //       vm.formData.endDate = angular.copy(tempEndDate);
          //       vm.sipDateLessEmandate = false;
          //     }
          //   }
          // }
        }
        vm.tForm.tenure.$setPristine(false);
        vm.changeEndDate();
        handleMandatePaymentOption();
      }
    }

    /**
     * function responsible for fetching account type list
     */

    function getAccountType(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
            if ($stateParams.transactionId && $stateParams.initiatedBy !== 'schedule') {
              vm.formData.bankAcType = null;
            }
          } else {
            MessageService.error(resp.message);
          }
          cb(true);
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
          cb(false);
        };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.formData.investorType
      }).$promise.then(success, error);
    }

    /**
     * function responsible for fetching investor type
     */

    function fetchInvestorType() {
      var investorType = vm.folioList.filter(function(folio) {
        return folio.folioNumber === vm.formData.folioNumber;
      });
      vm.formData.investorType = investorType[0].invType;
    }

    /**
     * function for handling first installment toggle changes
     */

    function changeFirstInstallment(installmentActivated) {
      vm.backFromPayment=false;
      vm.isfromSaved = false;
      if (vm.tForm.tenure) {
        vm.tForm.tenure.$setPristine(true);
      }
      if (vm.sipFirstInstallment !== vm.savedFI) {
        vm.savedFI = null
        vm.formData.bankInfo = null;
      }
      if (installmentActivated === false) {
        vm.sipFirstInstallment = false;
        vm.formData.sipFirstInstallment = false;
        vm.formData.sipFirstAmount='';
      } else {
        vm.sipFirstInstallment = true;
        vm.formData.sipFirstInstallment = true;
        vm.formData.sipFirstAmount=vm.formData.amount;
        if(vm.formData.flexSipPaymentOption === "OTM") {
          vm.formData.flexSipPaymentOption = null;
        }
      }
      checkOTM(function (success) {
        if (success) {
          $timeout(function() {
            fetchBankList();
          }, 100);
          checkEMandateValidation();
          if(vm.formData.flexSipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
            checkOTMAmountAndDate();
          }
        }
      });
      checkEMandate(function () {});
    }

    /**
     * function to fetch and set tenure list
     */

    function fetchTenureList() {

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.tenureDuration = resp.data.tenureDTOList;
          vm.FlexSipMaxAmount = resp.data.maxInstallmentAmount;
        } else {
          vm.tenureDuration = null;
        }
      }

      var error = function () {
        LoaderService.hideLoader();
        vm.tenureDuration = null;
      }

      LoaderService.showLoader();
      InvestorService.get({
        child1: 'transaction',
        child2: 'tenure',
        child3: 'FLEXSIP'
      }).$promise.then(success, error);
    }

    /**
     * function to update emandate end dates
     */

    function updateEmandateEndDate() {

      if (!vm.formData.emandateDate) {
        return;
      }

      var enabledEndDates = [];
      vm.formData.endDateEmandate = '';
      if(vm.formData.emandateDate)
      {
        vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
        vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateMaxYear, 'years').subtract(1,'days');
      }

      var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
      for (var i = 0; i <= freq; i++) {
        enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
      }
      vm.enabledEmandateEndDatesList = enabledEndDates;
      vm.endDateViewEmandate = enabledEndDates[0].clone();
      vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
    }

    /**
     * function to check mandate amount validations
     */

    function checkAmountValidationEmandate() {
      vm.amountLessMin = vm.formData.emandateAmount < vm.emandateMinimumAmountLimit ? true : false;
      vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
      vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
      vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.formData.amount ? true : false;
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
    }

    /**
     * function to check mandate end date validation
     */

    function changeEndDateEmandate(date) {
      vm.formData.endDateEmandate = date ? date : null;
      if (vm.formData.endDate) {
        vm.changeStartDate(vm.formData.startDate);
      }
    }

    /**
     * function to update payment options if max tenure is exceeded
     */

    function handleMandatePaymentOption() {
      if (vm.formData.tenure >= vm.emandateMaxYear) {
        vm.isEMandateEnabled = false;
        if ((vm.OTMbankList && vm.OTMbankList.length > 0 && vm.isOTMEnabled)) {
          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
        } else {
          vm.paymentOptions = [];
        }

        if(vm.formData.flexSipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          vm.formData.flexSipPaymentOption = vm.paymentOptions.length === 0 ? null : vm.paymentOptions[0];
          if (vm.formData.flexSipPaymentOption) {
            vm.changedPaymentOption();
          }
        }

        $window.scrollTo(0, 0);

      } else {
        var EmandadateExist = vm.paymentOptions.filter(function (el) {
          return el === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
        })

        if (vm.EMbankList && vm.EMbankList.length > 0 && (!EmandadateExist || vm.paymentOptions.length === 0) && !vm.formData.sipFirstInstallment) {
          vm.isEMandateEnabled = true;
          vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
        }

        if (!vm.formData.flexSipPaymentOption) {
          vm.formData.flexSipPaymentOption = vm.paymentOptions[0];
          vm.changedPaymentOption();
          $window.scrollTo(0, 0);
        }
      }
    }

  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('FlexIndexHelper', flexIndexHelper);


  /** @ngInject */
  function flexIndexHelper() {
    var vm = null;

    function setViewModel(model) {
      vm = model;
      init();
    }

    function init() {
      if(vm.formData.isBackFromSummary){
        vm.specificProperties.investmentModeData = vm.formData.investmentModeData;
        vm.specificProperties.investmentMode = vm.formData.investmentMode;
      }
      checkIfAllStagesAreValid(1);
      checkIfAllInstallmentsValid(1);
    }

    function investModeChanged(mode) {
      var data = vm.specificProperties.investmentModeData;
      data.installment1 = '';
      data.installment2 = '';
      data.installment3 = '';
      data.installment4 = '';
      vm.specificProperties.investmentModeData.stage1 = '';
      vm.specificProperties.investmentModeData.stage2='';
      vm.specificProperties.investmentModeData.stage3='';
      vm.specificProperties.investmentModeData.stage4='';
      if(mode === 'Flexible'){
        vm.specificProperties.validations.installmentsSumHundred = false;
        vm.specificProperties.validations.installmentsValid = false;
      }
    }

    function installmentValueChanged(installment) {
      var value = vm.specificProperties.investmentModeData[installment];
      if(parseInt(value) < 10 || parseInt(value) > 99){
        vm.specificProperties.validations[installment] = false;
      } else {
        vm.specificProperties.validations[installment] = true;
      }

      checkIfAllInstallmentsValid(value);

    }

    function stageValueChanged(stage) {
      var value = vm.specificProperties.investmentModeData[stage];
      if(parseFloat(value)%100){
        vm.specificProperties.validations[stage] = false;
      } else {
        vm.specificProperties.validations[stage] = true;
      }
      checkIfAllStagesAreValid(value);

    }

    function checkIfAllInstallmentsValid(value) {
      if(!value){
        vm.specificProperties.validations.installmentsValid = false;
      }
      if(!vm.specificProperties.validations['installment1'] || !vm.specificProperties.validations['installment2']
        || !vm.specificProperties.validations['installment3'] || !vm.specificProperties.validations['installment4']){
        vm.specificProperties.validations.installmentsValid = false;
      } else {
        vm.specificProperties.validations.installmentsValid = true;
      }

      var inst1 = vm.specificProperties.investmentModeData['installment1'];
      var inst2 = vm.specificProperties.investmentModeData['installment2'];
      var inst3 = vm.specificProperties.investmentModeData['installment3'];
      var inst4 = vm.specificProperties.investmentModeData['installment4'];
      if(parseInt(inst1) + parseInt(inst2)+ parseInt(inst3)+ parseInt(inst4) === 100){
        vm.specificProperties.validations.installmentsSumHundred = true;
      } else {
        vm.specificProperties.validations.installmentsSumHundred = false;
      }



    }

    function checkIfAllStagesAreValid(value) {
      if(!value){
        vm.specificProperties.validations.stagesValid = false;
      }
      if(!vm.specificProperties.validations['stage1'] || !vm.specificProperties.validations['stage2']
        || !vm.specificProperties.validations['stage3'] || !vm.specificProperties.validations['stage4']){
        vm.specificProperties.validations.stagesValid = false;
      } else {
        vm.specificProperties.validations.stagesValid = true;
      }

    }

    function fillSwitchExecutionDetails(data) {
      var model = vm.specificProperties.investmentModeData;

       model.installment1 = data.firstSwitchExecutionEntry.switchPercentage;
       model.stage1 = data.firstSwitchExecutionEntry.sensexLevelForSwitch;

      model.installment2 = data.secondSwitchExecutionEntry.switchPercentage;
      model.stage2 = data.secondSwitchExecutionEntry.sensexLevelForSwitch;

      model.installment3 = data.thirdSwitchExecutionEntry.switchPercentage;
      model.stage3 = data.thirdSwitchExecutionEntry.sensexLevelForSwitch;

      model.installment4 = data.fourthSwitchExecutionEntry.switchPercentage;
      model.stage4 = data.fourthSwitchExecutionEntry.sensexLevelForSwitch;

      if(model.installment1+model.installment2+model.installment3+model.installment4 === 100){
        vm.specificProperties.validations.installmentsSumHundred = true;
      } else
      {
        vm.specificProperties.validations.installmentsSumHundred = false;
      }

    }

    return {

      setViewModel: setViewModel,
      investModeChanged:investModeChanged,
      stageValueChanged:stageValueChanged,
      installmentValueChanged:installmentValueChanged,
      fillSwitchExecutionDetails:fillSwitchExecutionDetails
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('DreamSipController', dreamSipController);

  /** @ngInject */
  function dreamSipController($log, $timeout, $stateParams, HDFC_API, MessageService, ModalService, InvestorService, DownloadPdfService,
    SchemeService, TransactionService, AppConstants, $state, LoaderService, UtilService,
    TransactionModel, AuthService, SipPurchaseHelper, NetcoreEvntService,
    InvestorFileUploadService, $window, FileSaver, Blob, InvestorFolioModel, investorServiceVersion, FolioModel, $rootScope, DynamicDataSipPurchaseReview, termsCondition,panAadharService) {

    var vm = this;
    vm.masterTargetSchemeList= null;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.transactionType = 'DREAMSIP';
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    vm.formData = TransactionModel.getPayloadRawData() || TransactionModel.getMasterRawData(vm.transactionType);
    vm.folioList = FolioModel.getFolioData() || null;
    vm.profile = AuthService.getToken();
    vm.optionList = AppConstants.OPTION_LIST;
    vm.formData.sipFirstInstallment = false;
    fetchDreamSipPeriod();
    // vm.changeSipTopupSelected = changeSipTopupSelected;
    vm.changedPaymentOption = changedPaymentOption;
    vm.checkOTM = checkOTM;
    vm.kycVerifiedFlag = null;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.capAmountChanged = capAmountChanged;
    vm.showNote = true;
    vm.devidendOptionsOther = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT];
    vm.devidendOptionsELSS = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];
    vm.devidendOptions = angular.copy(vm.devidendOptionsOther);
    vm.DynamicDataSipPurchaseReview = DynamicDataSipPurchaseReview;
    vm.setDynamicData = setDynamicData;
    vm.isEMandateEnabled = false;
    vm.EMbankList = null;
    vm.validations = {};
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.checkEndNoteOtm = checkEndNoteOtm;
    vm.checkEndNoteEOtm = checkEndNoteEOtm;
    vm.checkSipValidations = checkSipValidations;
    vm.checkSwapValidations = checkSwapValidations;
    vm.checkValidations = checkValidations;
    vm.showOtmNote = true;
    vm.today = $window.moment($window.moment(), "DD-MMM-YYYY HH:mm A");
    vm.popup = {};
    vm.showEotmNote = true;
    vm.showTerms = true;
    vm.showTermsEmandate = false;
    vm.viewMode = 'months';
    vm.emandateMinAmountLimit = null;
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.isLessThanSipAmount = false;
    vm.sipDateLessEmandate = false;
    vm.changeEndDateEmandate = changeEndDateEmandate;
    vm.defaultMandateYearDate = AppConstants.DEFAULT_EMANDATE_MAX_YEAR;
    vm.formData.emandateWord = {};
    AuthService.checkLinkedUserStatus();
    vm.PATTERN = AppConstants;
    vm.handleVpa = handleVpa;
    vm.verifyUPI = verifyUPI;

    vm.init = function () {
      var isFromFolio = $window.JSON.parse(localStorage.getItem('isFromFolio'))? $window.JSON.parse(localStorage.getItem('isFromFolio')):false;
      vm.summaryData = TransactionModel.getDreamSipPayloadRawData();
      if(isFromFolio && vm.summaryData){
        localStorage.removeItem('isDreamSip');
        localStorage.removeItem('isFromFolio');
         vm.formData = vm.summaryData;
        // fetchFolioList(function (success) {
        //   if (success) {
        //     var rawData;
        //     var frequencyList = null;
        //     rawData = {sipForm: vm.summaryData};
        //     var folioNumber = vm.summaryData.folioNumber|| vm.summaryData.folioNo;
        //     var selectedFolioObj = vm.folioList.filter(function (row) {
        //       return row.folioNumber == folioNumber;
        //     })[0];
        //     vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
        //     vm.folioInvestorName = selectedFolioObj && selectedFolioObj.investorName ?selectedFolioObj.investorName:'';
        //     vm.formData.isThroughDistributor = vm.summaryData.euinOpted === 'Y' ? true : false;
        //     if (rawData.sipForm) {
        //       vm.validations = vm.validations ? vm.validations : {};
        //       vm.formData.sTransactionId = rawData.sipForm.id;
        //       vm.formData.folioNumber = rawData.sipForm.folioNumber;
        //       vm.formData.amount = rawData.sipForm.installmentAmount;
        //       vm.formData.inSchemeCode = rawData.sipForm.schemeCode;
        //       vm.formData.frequency = rawData.sipForm.frequency || vm.formData.frequency || frequencyList[0].key;
        //       vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
        //       vm.formData.option = (rawData.sipForm.option == 'Option B')? 'B':'A';
        //       vm.formData.sipPaymentOption = vm.paymentOptions && vm.paymentOptions[0]?vm.paymentOptions[0] : 'EC';
        //       if(rawData.sipForm.option == 'Option B'){
        //         vm.formData.targetSchemecode = rawData.sipForm.targetSchemeCode;
        //       }
        //       if (rawData.sipForm.bankDetailsForECS) {
        //         vm.formData.bankAcNo = rawData.sipForm.bankDetailsForECS.accNumber;
        //         vm.formData.bankCity = rawData.sipForm.bankDetailsForECS.bankCity;
        //         vm.formData.bankName = rawData.sipForm.bankDetailsForECS.bankName;
        //         vm.formData.bankBranch = rawData.sipForm.bankDetailsForECS.branchName;
        //       }
        //       if (vm.calenderEndDateString === rawData.sipForm.toDate) {
        //         vm.formData.isTillPerpetuity = true;
        //       }

        //       if (rawData.sipForm.primaryFlag) {
        //         vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP;
        //       }

        //       // vm.formData.sipPaymentOption = 'EC';   // hard coded to be removed

        //       if (rawData.sipForm.euinOpted === 'Y') {
        //         vm.formData.euin = {euinCode: rawData.sipForm.euinCode, euinName: rawData.sipForm.euinName,euinNameCode: rawData.sipForm.euinName+"-"+rawData.sipForm.euinCode}
        //       }
        //       if (rawData.sipForm.riaOpted) {
        //         vm.formData.isThroughDistributor = false;
        //         vm.formData.isThroughRia = true;
        //         vm.formData.isDirect = false;
        //         vm.isArnSuccess = false;
        //         vm.formData.riaBrokerCode = rawData.sipForm.brokerCode;
        //         vm.riaConsent = rawData.sipForm.riaConsent;
        //         vm.isCheckedTandC = rawData.sipForm.riaConsent;
        //         vm.searchDistributor();
        //       }
        //       if (rawData.sipForm.brokerCode && !rawData.sipForm.riaOpted) {
        //         vm.formData.brokerCode = rawData.sipForm.brokerCode.replace('ARN-', '');
        //         vm.formData.isThroughDistributor = true;
        //         vm.formData.euinInput = rawData.sipForm.euinName + ' - ' + rawData.sipForm.euinCode;
        //         vm.searchDistributor();   // it will show the name of distributor based on broker code (ARN)
        //       }

        //       vm.formData.startDate = vm.summaryData.sipDate;
        //       vm.formData.endDate = vm.summaryData.toDate;
        //       setbacksummaryStartDate();
        //        vm.changeBank();
        //       fetchInSchemes(function () {
        //         if(rawData.sipForm.option == 'Option B' && vm.targetSchemeList){
        //           vm.targetSchemeList.forEach(function(item) {
        //             if(vm.formData.targetSchemeCode == item.targetSchemeCode){
        //               vm.formData.targetSchemeName = item.scheme;
        //               vm.formData.schemeType = item.schemeType;
        //             }
        //           });
        //         }
        //         var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
        //           return vm.formData.inSchemeCode === item.schemeCode;
        //         }) || {};
        //         vm.formData.inSchemeName = scheme.scheme || '';
        //         checkOTM();
        //         fetchInSchemeValidations(function (err) {
        //           LoaderService.hideLoader();
        //         });
        //       });
        //       fetchBankList(function (success) {
        //         if (success){
        //           var bankDetails = vm.bankList && vm.bankList.find(function (item) {
        //             // return i.bankCode === rawData.bankCode;
        //             return item === rawData.sipForm.bankDetailsForECS;
        //           }) || {};
        //           angular.isDefined(vm.formData.bankInfo) && angular.isDefined(vm.formData.bankInfo.bankName) && (vm.formData.bankInfo.bankName = bankDetails.bankName || '');
        //         }

        //       });
        //       checkOTM();

        //     }
        //     vm.formData.isSummaryViewEnabled = true;
        //   }
        //   // getDateValidation();
        // })
      }else if ($stateParams.transactionId && $stateParams.initiatedBy !== 'schedule') {
        localStorage.removeItem('isDreamSip');
        localStorage.removeItem('isFromFolio');
         getTransactionDetails();
        if (vm.transactionType == "DREAMSIP") {
          vm.formData.investmentType = 'DREAMSIP';
        }
      }
      else{
        localStorage.removeItem('isDreamSip');
        localStorage.removeItem('isFromFolio');
        if (vm.transactionType == "DREAMSIP") {
          vm.formData.investmentType = 'DREAMSIP';
        }
        fetchFolioList();
      }
      var successRandomOTPIdHandler = function(resp) {
        vm.randomOTPId = resp.randomOTPId ? resp.randomOTPId : null;
      }, errorRandomOTPIdHandler = function (){}
      UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
    }
    if (vm.notesOtm && vm.notesEOtm !== undefined) {
      checkEndNote(vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review.endDate, vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review.startDate);
      checkEndNoteOtm(vm.notesOtm.endDate, vm.notesOtm.startDate);
      checkEndNoteEOtm(vm.notesEOtm.endDate, vm.notesEOtm.startDate);
    }
    setDynamicData();
    if (vm.popup !== undefined) {
      checkEndPopup(vm.popup.endDate, vm.popup.startDate);
    }
    vm.folioChanged = function () {
      vm.dynamicData=  UtilService.fetchDynamicData("FOLIO_CREATION");
      if (!vm.formData.folioNumber) { return; }
      var oldData = angular.copy(vm.formData);
      var successHandler = function(resp) {
          resetAll();
          //recoverFromResetting(oldData);
          var selectedFolioObj = vm.folioList.filter(function (row) {
            return row.folioNumber == vm.formData.folioNumber
          })[0];
          if (selectedFolioObj) {
            vm.selectedFolioData = selectedFolioObj;
          }
          vm.folioMinor = false;
          vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName : '';
          vm.selectedFolioEmail = selectedFolioObj.email;
          vm.selectedFolioMobile = selectedFolioObj.mobileNumber;
          vm.formData.corporateInvestor = selectedFolioObj && angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
          vm.changeThroughDistributor(AppConstants.INVEST_THROUGH.DIRECT);
          vm.formData.option = vm.optionList[0].value;
          if (vm.selectedFolioMobile === null || vm.selectedFolioMobile === '') {
            if (vm.selectedFolioEmail === null || vm.selectedFolioEmail === '') {
              vm.isEmailMobileinValid = true;
              vm.emandateDisplay = false;
            }
            else {
              vm.isMobileinValid = true;
              vm.emandateDisplay = false;
            }
          }
          else if (vm.selectedFolioEmail === null || vm.selectedFolioEmail === '') {
            if (vm.selectedFolioMobile === null || vm.selectedFolioMobile === '') {
              vm.isEmailMobileinValid = true;
              vm.emandateDisplay = false;
            }
            else {
              vm.isEmailinValid = true;
              vm.emandateDisplay = false;
            }
          }
          checkOTM(function (success) {
            if (success) {
              changedPaymentOption();
            }
          })
      }
      var errorHandler = function(resp)
      {
        vm.formData.folioNumber=null;
        return;
      };
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);

    };


    vm.enabledOTMStartDatesList = [];
    vm.enabledBillerStartDatesList = [];
    function getDateValidation(cb) {
      if (!vm.formData.inSchemeCode) {
        return;
      }
      cb = cb || function () {};
      var success = function (resp) {
          if (resp.status && resp.data) {
            var currentDate = resp.data.currentDate || Date();
            vm.daysList = resp.data.listOfDays;
            var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
            var todayDate = $window.moment(Date.parse(parsedDate));
            var counter = 0;
            vm.nonBusinessDatess = resp.data.nonBuisnessDates;
            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE || vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
              // vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
              if(!vm.emandateUpiData) {
                sipSettingValidation(parsedDate);
              } else {
                vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
              }
            }else if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC){
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add( vm.inSchemeValidations && vm.inSchemeValidations.sipTDay? vm.inSchemeValidations.sipTDay: 17, 'days');
            }else {
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(11, 'days');
            }
            // vm.startMinDateEMandate= $window.moment(Date.parse(parsedDate)).add(7,'days');
            /* if (HDFC_API.ENV === 'prod' || HDFC_API.ENV === 'beta') {
              vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
            } */
            vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
            var startDate = todayDate.clone();
            var freq = vm.startMaxDate.diff(todayDate, 'days');
            for (var i = 0; i <= freq; i++) {
              var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
              var isEnable = true;
              if(counter<5)
              {
                angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                  if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')===0){
                    isEnable = false;
                  }
                });
              }
              if(isEnable){
                vm.enabledOTMStartDatesList.push(startDate.clone().add(i, 'days'));
                counter++;
              }
            }

            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE || vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
              vm.startMinDateBiller = vm.enabledOTMStartDatesList[vm.eMandatenoOfDays];
              vm.enabledBillerStartDatesList = vm.enabledOTMStartDatesList;
            }

            vm.isReseting = true;
            $timeout(function () {
              vm.isReseting = false;
            });
            cb(true);
          } else {
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb(false);
        };
      InvestorService.get({
        child1: 'nonBusinessDate',
        schemeCode: vm.formData.inSchemeCode //'AFWDQ'
      }).$promise.then(success, error);
    }

    function getTransactionDetails() {
      if (!$stateParams.transactionId) {
        MessageService.error("TransactionId is missing for saved transaction.");
        $state.go('main.dashboard');
        return;
      }

      var success = function (resp) {
          if (resp.data && resp.status) {
            showPrefillValues(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'transaction',
        controller2: 'saved',
        controller3: $stateParams.transactionId,
        controller4: $stateParams.isCompId
      }).$promise.then(success, error);
    }

    function showPrefillValues(rawData) {
          if (rawData) {
            sipPrefillValues(rawData)
          }
    }

    function sipPrefillValues(data) {
      fetchFolioList(function (success) {
        if (success) {
          var rawData;
          var frequencyList = null;
          rawData = {sipForm: data};
          var folioNumber = data.folioNumber|| data.folioNo;
          var selectedFolioObj = vm.folioList.filter(function (row) {
            return row.folioNumber == folioNumber;
          })[0];
          if (selectedFolioObj) {
            vm.selectedFolioData = selectedFolioObj;
            vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
          }
          vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
          vm.folioInvestorName = selectedFolioObj && selectedFolioObj.investorName ?selectedFolioObj.investorName:'';
          vm.formData.isThroughDistributor = data.euinOpted === 'Y' ? true : false;
          if (rawData.sipForm) {
            vm.validations = vm.validations ? vm.validations : {};
            vm.formData.sTransactionId = rawData.sipForm.id;
            vm.formData.folioNumber = rawData.sipForm.folioNumber;
            vm.formData.amount = rawData.sipForm.installmentAmount;
            vm.formData.inSchemeCode = rawData.sipForm.schemeCode;
            vm.formData.frequency = rawData.sipForm.frequency || vm.formData.frequency || frequencyList[0].key;
            vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
            vm.formData.option = (rawData.sipForm.option == 'B')? 'Option B':'Option A';
            vm.formData.sipPaymentOption = vm.paymentOptions && vm.paymentOptions[0]?vm.paymentOptions[0] : 'EC';
            if(rawData.sipForm.option == 'B'){
              vm.formData.targetSchemecode = rawData.sipForm.targetSchemeCode;
            }
            if (rawData.sipForm.bankDetailsForECS) {
              vm.formData.bankAcNo = rawData.sipForm.bankDetailsForECS.accNumber;
              vm.formData.bankCity = rawData.sipForm.bankDetailsForECS.bankCity;
              vm.formData.bankName = rawData.sipForm.bankDetailsForECS.bankName;
              vm.formData.bankBranch = rawData.sipForm.bankDetailsForECS.branchName;
            }
            if (vm.calenderEndDateString === rawData.sipForm.toDate) {
              vm.formData.isTillPerpetuity = true;
            }

            if (rawData.sipForm.primaryFlag) {
              vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP;
            }

            // vm.formData.sipPaymentOption = 'EC';   // hard coded to be removed

            if (rawData.purchaseForm && rawData.sipForm) {
              vm.formData.optionalInvestmentType = 'SIP';

              if (vm.formData.investmentType === 'SIP') {
                vm.formData.optionalInvestmentType = 'PURCHASE';
              }
            }
            if (rawData.sipForm.euinOpted === 'Y') {
              vm.formData.euin = {euinCode: rawData.sipForm.euinCode, euinName: rawData.sipForm.euinName,euinNameCode: rawData.sipForm.euinName+"-"+rawData.sipForm.euinCode}
            }
            if (rawData.sipForm.riaOpted) {
              vm.formData.isThroughDistributor = false;
              vm.formData.isThroughRia = true;
              vm.formData.isDirect = false;
              vm.isArnSuccess = false;
              vm.formData.riaBrokerCode = rawData.sipForm.brokerCode;
              vm.riaConsent = rawData.sipForm.riaConsent;
              vm.isCheckedTandC = rawData.sipForm.riaConsent;
              vm.searchDistributor();
            }
            if (rawData.sipForm.brokerCode && !rawData.sipForm.riaOpted) {
              vm.formData.brokerCode = rawData.sipForm.brokerCode.replace('ARN-', '');
              vm.formData.isThroughDistributor = true;
              vm.formData.euinInput = rawData.sipForm.euinName + ' - ' + rawData.sipForm.euinCode;
              vm.searchDistributor();   // it will show the name of distributor based on broker code (ARN)
            }

            getDateValidation();
            fetchInSchemes(function () {
              if(rawData.sipForm.option == 'B' && vm.targetSchemeList){
                vm.targetSchemeList.forEach(function(item) {
                  if(vm.formData.targetSchemeCode == item.targetSchemeCode){
                    vm.formData.targetSchemeName = item.scheme;
                    vm.formData.schemeType = item.schemeType;
                  }
                });
              }
              var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                return vm.formData.inSchemeCode === item.schemeCode;
              }) || {};
              vm.formData.inSchemeName = scheme.scheme || '';
              if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && scheme.retirementFlag) {
                MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
                vm.formData.inSchemeCode = '';
                vm.formData.inSchemeName = '';
                vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
                return;
              }
              checkOTM();
              checkEmandateBank();
              fetchInSchemeValidations(function (err) {
                LoaderService.hideLoader();
              });
            });
            fetchBankListForEcs();
            fetchBankList(function (success) {
              if (success){
                var bankDetails = vm.bankList && vm.bankList.find(function (item) {
                  // return i.bankCode === rawData.bankCode;
                  return item === rawData.sipForm.bankDetailsForECS;
                }) || {};
                angular.isDefined(vm.formData.bankInfo) && angular.isDefined(vm.formData.bankInfo.bankName) && (vm.formData.bankInfo.bankName = bankDetails.bankName || '');
              }

            });
            checkOTM();
            checkEmandateBank();

          }
          vm.formData.isBackFromSummary = false;
        }
        if (vm.transactionType === 'DREAMSIP') getDateValidation();
      })
    }
    function capAmountChanged() {
      vm.amountInWords = '';
      if(vm.formData.topupDetails.amount){
        vm.minCapAmount = vm.formData.amount + vm.formData.topupDetails.amount;
      }
      else if (vm.formData.topupDetails.percentage){
        vm.minCapAmount = vm.formData.amount + (vm.formData.topupDetails.percentage * vm.formData.amount/100)
      }

      if(vm.formData.topupDetails.capAmount && (vm.formData.topupDetails.capAmount < vm.minCapAmount )){
        vm.isminCapAmount = true
      }
      else{
        vm.isminCapAmount = false
      }
    }

    function fetchFolioList(cb) {

      cb = cb || function () {
      };
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var folioList = [];
          vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
          if (resp.data.kycVerifiedFlag === false && $stateParams.initiatedBy != "schedule") {
            ModalService.genericModal({
              text: resp.data.kycMessage
            }, function () {
              $state.go("welcome");
            });
          }
          Object.keys(resp.data.folioList).forEach(function (key) {
            var obj = Object.assign({ key: key }, resp.data.folioList[key]);
            folioList.push(angular.copy(obj));
          });
          FolioModel.setFolioData(folioList);
          vm.folioList = folioList.length ? folioList : null;
          if (vm.folioList && vm.folioList.length === 1) {
            vm.formData.folioNumber = vm.folioList[0].folioNumber;
            if (!vm.formData.isBackFromSummary && !$stateParams.transactionId) {
              vm.folioChanged();
            }
          }
          if (vm.formData.dynamicData && vm.formData.dynamicData.folioNumber) {
            vm.formData.folioNumber = vm.formData.dynamicData.folioNumber;
            vm.folioChanged();
          }
          if ($stateParams.eCart) {
            vm.folioChanged();
          }

          cb(true);
        } else {
          vm.folioList = null;
          MessageService.error(resp.message);
          cb(false);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      investorServiceVersion.get({
        child1: 'dreamSip',
        child2: 'getNonMinorFolioList'
      }).$promise.then(success, error);
    }

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        e.preventDefault();
      }
      return false;
    };

    function resetAll() {
      vm.formData.frequency = 'OM';
      vm.formData.amountType = 'amount';
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.outSchemeCode = '';
      vm.formData.dividendOption = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.amount = '';
      vm.formData.swapAmount = '';
      vm.formData.units = '';
      vm.formData.bankInfo = null;
      vm.formData.isTillPerpetuity = false;
      // vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;


      vm.formData.euin = {};
      vm.euinData = {};
      vm.formData.brokerCode = '';
      vm.formData.brokerName = '';
      vm.euinList = null;
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.formData.subBrokerARN = '';
      vm.formData.subBrokerCode = '';
      vm.isCheckedTandC = false;
      vm.isArnSuccess = true;
      vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;

      vm.inSchemeValidations = null;
      vm.validations = {};
      vm.isRequired = false;
      vm.bankList = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      vm.changeOption();
      resetBankDetails();
      vm.formData.riaBrokerCode = "";
      vm.formData.riaBrokerName = "";
      vm.formData.isCheckedTandC = false;
      vm.brokerCodeError = "";
      vm.riaCodeError = "";
    }

    function resetBankDetails() {
      vm.formData.bankCity = '';
      vm.formData.bankBranch = '';
      vm.formData.bankAcNo = '';
      vm.formData.verifyBankAcNo = '';

    }
    vm.changeThroughDistributor = function (investThrough) {
      vm.transactionType = vm.formData.investmentType;
      if (investThrough === 'DIRECT') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
      } else if (investThrough === 'ARN') {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
      } else if (investThrough === 'RIA') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
      }

      if (!vm.formData.isThroughDistributor) {
        vm.formData.euin = {};
        vm.euinData = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        //vm.formData.euinInput = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.formData.subBrokerCode = '';
        vm.isSelectedEuin = true;
        vm.subBrokerName = '';
      }
      fetchInSchemes();
    };


    function fetchInSchemes(cb) {
      cb = cb || function () {
      };

      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.masterInSchemeList = resp.data.sourceSchemeList;
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
          if (vm.formData.option == "Option B") {
            vm.targetSchemeList = resp.data.targetSchemeList;
            vm.masterTargetSchemeList = vm.targetSchemeList;
          }
          cb();
        } else {
          vm.masterInSchemeList = null;
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.masterInSchemeList = null;
          UtilService.errorHandler(err);
        };

        var payload = {
           option : (vm.formData.option == 'Option B')? 'B':'A',
           isBroker: vm.formData.isThroughDistributor ? true : false,
           corporateFlag : vm.formData.corporateInvestor
        }
        InvestorService.post({
          child1: 'dreamSip',
          child2: 'getDreamSipScheme'
        }, payload).$promise.then(success, error);
    }

    vm.changeDistributorCode = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.euinList = null;
      vm.isArnSuccess = true;
      vm.riaCodeError = "";
    }
 vm.subBrokerCodeError = '';
    vm.fetchEuinListSubBroker = function () {
      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        vm.formData.euin = {};
        vm.euinData = {};
        fetchEuinList();
        return;
      }
      if(vm.formData.brokerCode !== vm.formData.subBrokerARN){
        vm.formData.euin = {};
        vm.euinData = {};
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            for(var i = 0; i<vm.euinList.length; i++){
              if(vm.euinData.euinNameCode === vm.euinList[i].euinNameCode){
                vm.formData.euin = vm.euinList[i];
                break;
              } else {
                vm.formData.euin = {};
              }
            }
            vm.euinData = vm.formData.euin;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
          } else {
            vm.euinList = null;
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = {};
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: vm.formData.isThroughDistributor
      }).$promise.then(success, error);
    }

    vm.searchDistributor = function () {
      //vm.isInvalidForm = vm.formData.brokerCode ? false : (vm.isArnSuccess ? true : false);
      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      fetchEuinList();
    };

    vm.searchDistributorByName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      //vm.isInvalidForm = true;
      vm.brokerCodeError = '';
      vm.isArnSuccess = true;
      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        vm.distributorList = null;
        vm.euinList = null;
        //vm.formData.euinInput = '';
        vm.formData.euin = null;
        return;
      }
      fetchARNByName();

    };

    function fetchARNByName() {

      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        return;
      }
      vm.formData.distributorARN = '';
      vm.distributorList = null;
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.distributorList = resp.data.distributorList;
            if (vm.distributorList.length == 0) {
              //vm.isInvalidForm = true;
              vm.formData.euin = {};
              vm.isCheckedTandC = false;
            }
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.distributorList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.distributorList=null;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getDistributor',
        controller2: vm.formData.distributorName
      }).$promise.then(success, error);
    }

    vm.distributorListChanged = function (data) {
      if (!data) {
        // vm.isArnSuccess = true;
        return;
      } else {
        vm.brokerCodeError = '';
        vm.formData.distributorARN = data.arnCode;
        vm.formData.distributorName = data.name + ' - ' + data.arnCode;
        vm.showArnLabel = false;
        if (vm.formData.distributorARN) {
          //vm.isInvalidForm = false;
          vm.isArnSuccess = false;
        }
        else {
          vm.isArnSuccess = true;
        }
        fetchEuinListThroughDistributor(vm.formData.distributorARN);
      }
    };


    function fetchEuinListThroughDistributor(arnCode) {
      if (!arnCode) {
        return;
      }
      vm.formData.brokerName = '';
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin;
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.euinList = null;
            //MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: arnCode
      }).$promise.then(success, error);
    }

    vm.brokerCodeError = '';
    function fetchEuinList() {
      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      vm.formData.brokerName = vm.formData.brokerName ? vm.formData.brokerName : '';
      vm.formData.riaBrokerName = vm.formData.riaBrokerName ? vm.formData.riaBrokerName : '';
      vm.subBrokerCodeError = '';
      vm.euinData = {};
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      vm.distributorList = null;
      // vm.formData.euinInput = '';
      if (!vm.formData.isBackFromSummary && !vm.riaConsent) {
        vm.isCheckedTandC = vm.formData.isCheckedTandC;
        if (!$stateParams.isCompId && !$stateParams.trackId) {
          vm.formData.euin = vm.formData.euin ? vm.formData.euin : '';
        }
      }

      //vm.isInvalidForm = true;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinMasterList = resp.data.euinList;
          vm.euinList = vm.euinMasterList;
          vm.euinData = vm.formData.euin ? vm.formData.euin : {};
          vm.brokerCodeError = '';
          vm.riaCodeError = '';
          vm.isArnSuccess = false;
          if (vm.formData.isThroughDistributor) {
            vm.formData.brokerName = resp.data.distributorName;
          } else if (vm.formData.isThroughRia) {
            vm.formData.riaBrokerName = resp.data.distributorName;
          }
          //vm.isInvalidForm = false;
        } else {
          vm.euinList = null;
          if (vm.formData.isThroughDistributor) {
            vm.brokerCodeError = resp.message;
          } else if (vm.formData.isThroughRia) {
            vm.riaCodeError = resp.message;
            vm.isCheckedTandC = false;
            vm.formData.isCheckedTandC = false;
          }
          MessageService.error(resp.message);
        }
      },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      var path = {};
      if (vm.formData.isThroughDistributor) {
        path = {
          controller1: 'getEuin',
          controller2: 'ARN-' + vm.formData.brokerCode
        };
      } else if (vm.formData.isThroughRia) {
        path = {
          controller1: 'getEuin',
          controller2: vm.formData.riaBrokerCode,
          riaOpted: vm.formData.isThroughRia
        };
      }
      TransactionService.get(path).$promise.then(success, error);
    }

    vm.isSelectedEuin = true;

    vm.filterEuinList = function () {
      vm.formData.euin = {};
      vm.isSelectedEuin = false ;
      if(vm.euinData.euinNameCode){
        if(vm.euinData.euinNameCode.length>=3){
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.euinData.euinNameCode);
        }
      }
      vm.euinList = vm.euinData.euinNameCode == '' || vm.euinData.euinNameCode == undefined || vm.euinData.euinNameCode.length<3 ? vm.euinMasterList : vm.euinList;
    };

    // get inschemes

    vm.schemeListModal = function () {

      var successSchemeList = function (result) {
        vm.inSchemeChanged(result);
      },
        errorSchemeList = function () {
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
        };
      var payload = {
          option : (vm.formData.option == 'Option B')? 'B':'A',
          isBroker: vm.formData.isThroughDistributor ? true : false,
          corporateFlag : vm.formData.corporateInvestor
       }
      ModalService.dreamSchemeListModal({
        transactionType: 'dreamSip',
        payload:payload
      }, successSchemeList, errorSchemeList);
    };


    vm.selectEuin = function(data) {
      if (!data) {
        return;
      }
      vm.euinData = {};
      vm.euinData.euinNameCode = data.euinNameCode;
      vm.isSelectedEuin = vm.euinData.euinNameCode ? true : false;
    }

    //change Option

    vm.changeOption = function () {
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.schemeType = '';
      if (vm.formData.targetSchemeCode) {
        vm.formData.targetSchemeCode = '';
        vm.formData.targetSchemeName = '';
        vm.formData.schemeType = '';
      }
      vm.formData.amount = null;
      $window.NumToWord('', 'divDisplayWords', vm);
      vm.formData.swapAmount = null;
      $window.NumToWord('', 'divDisplayWords1', vm);
      vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
      getDateValidation();
      fetchInSchemes();
    };

    vm.goToSipSummary = function () {
      vm.isCheckedTandC = false;
      if (vm.formData.inSchemeName && vm.formData.inSchemeName.includes('Children')) {
        var success = function () {
          beforeSummary();
        },
          error = function () {

          };
        var message = AppConstants.TRANSACTIONS.CGF_SCHEME_MSG;
        ModalService.childrenFundMessage({ message: message }, success, error);
      } else {
        beforeSummary();
      }
    };
    function checkEndPopup(endDate, startDate) {
      if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showpopup = true;
      } else {
        vm.showpopup = false;
      }
    }
    function beforeSummary() {
      if (vm.popup !== undefined) {
        vm.showCutOffModal({ cutoffData: vm.popup, showCutOff: vm.showpopup });
      }
      else {
        vm.moveToSummary();
      }
    }

    vm.showCutOffModal = function (message) {
      var success = function () {
        vm.moveToSummary();
      }, error = function () {

      };
      ModalService.cutOffModal({ message: message }, success, error);
    };

    vm.moveToSummary = function () {
      vm.transactionType;
      vm.setTandCVariable();
      if(vm.formData.sipFirstInstallment){
        userActivityTracking(function (trackResp) {
          var params = { transactionType: vm.transactionType };
          if ((trackResp && angular.isDefined(trackResp.transactionId)) || $stateParams.trackId) {
            params.trackId = trackResp.transactionId || $stateParams.trackId;
            vm.formData.trackId = params.trackId;
          }
          vm.isRequired = true;
          vm.isSaving = false;
          if (vm.formData.euin && !vm.formData.euin.euinName && !vm.formData.euin.euinCode && vm.formData.euinInput) {
            vm.formData.euin.euinName = (vm.formData.euinInput.split('-')[0]).trim();
            vm.formData.euin.euinCode = (vm.formData.euinInput.split('-')[1]).trim();
          }
          $state.$previous = $state.current;
          if (vm.tForm.$valid) {
            var payloadData = getFinalPayloadData();
            if (!payloadData) {
              return;
            }
            var selectedFolioObj = vm.folioList.filter(function (row) {
              return row.folioNumber == vm.formData.folioNumber
            })[0];
            payloadData.email = selectedFolioObj.email ? selectedFolioObj.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
            payloadData.mobileNumber = selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;
            payloadData.randomOTPId = vm.randomOTPId;
            TransactionModel.setPayloadRawData(payloadData);
            /*Netcore Event Start*/
            // if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            //   NetcoreEvntService.Proceed_To_Transact_SIP_IP(payloadData);
            // }
            /*Netcore Event End*/
            vm.summaryData = payloadData;
            localStorage.setItem('summaryData',JSON.stringify(vm.summaryData));
            vm.transactionType = 'DREAM_SIP';
            vm.formData.isSummaryViewEnabled = true;
          }

        });
      }else{
        vm.isRequired = true;
        vm.isSaving = false;
        if (vm.formData.euin && !vm.formData.euin.euinName && !vm.formData.euin.euinCode && vm.formData.euinInput) {
          vm.formData.euin.euinName = (vm.formData.euinInput.split('-')[0]).trim();
          vm.formData.euin.euinCode = (vm.formData.euinInput.split('-')[1]).trim();
        }
        $state.$previous = $state.current;
        if (vm.tForm.$valid) {
          vm.isSaving = false;
          var payloadData = getFinalPayloadData();
          if (!payloadData) {
            return;
          }
          var selectedFolioObj = vm.folioList.filter(function (row) {
            return row.folioNumber == vm.formData.folioNumber
          })[0];
          payloadData.email = selectedFolioObj.email ? selectedFolioObj.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
          payloadData.mobileNumber = selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;
          payloadData.randomOTPId = vm.randomOTPId;
          TransactionModel.setPayloadRawData(payloadData);
          /*Netcore Event Start*/
          // if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
          //   NetcoreEvntService.Proceed_To_Transact_SIP_IP(payloadData);
          // }
          /*Netcore Event End*/
          vm.summaryData = payloadData;
          localStorage.setItem('summaryData',JSON.stringify(vm.summaryData));
          vm.transactionType = 'DREAM_SIP';
          vm.formData.isSummaryViewEnabled = true;
        }
      }
    };

    function userActivityTracking(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && (resp.data || resp)) {
          resp = resp.data || resp;
          LoaderService.hideLoader();
          cb(resp);
        }
        else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(err);
      };

      var userTrackerPayload = setUserTrackerPayload();
      InvestorService.post({
        child1: 'userBehavior',
        child2: 'addupdate'
      }, userTrackerPayload).$promise.then(success, error);
    }

    function setUserTrackerPayload() {
      var _payload = {
        "trxnRefNo": $stateParams.trackId ? $stateParams.trackId : "", //required in case of update
        "trxnType": vm.formData.investmentType, //SIP, PURCHASE
        "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
        "step": "FIRST", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode || vm.formData.inSchemeCode, // required
        "folioNo": vm.formData.folioNumber, // required
        "formData": getSipPurchasePayloadToSave(), // required
        "amount": vm.formData.purchaseAmount || vm.formData.amount, //required
        "trxnStatus": "OPEN",  // OPEN,PROCESSED
        "promoterCode": "" // capture from the transaction link
      };
      return _payload;
    }
    //save Dream Sip
    vm.saveForm = function () {

      vm.isRequired = false;
      vm.isSaving = true;
      var payload = getFinalPayloadData();
      if (!payload) {
        return;
      }

      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (angular.isArray(resp.data)) {
            var data = {};
            resp.data.forEach(function (_form) {
              if (_form) {
                switch (_form.transactionType) {
                  case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
                    data.sipForm = _form;
                    break;
                  case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
                    data.purchaseForm = _form;
                    break;
                }
              }
            });

            vm.formData.sTransactionId = data.sipForm ? data.sipForm.transactionId : '';
            vm.formData.pTransactionId = data.purchaseForm ? data.purchaseForm.transactionId : '';
          } else {
            vm.formData.transactionId = resp.data.transactionId;
          }

          var successModal = function () {
            $state.go('welcome')
          };
          ModalService.savedTransactionModal({}, successModal);
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      TransactionService.post({
        controller1: 'transaction',
        controller2: 'dream-sip',
        controller3: 'save'
      }, payload).$promise.then(success, error);
    };
    function getFinalPayloadData() {
      var payload = null;
      payload = vm.isSaving ? getSipPurchasePayloadToSave() : getSipPurchasePayloadToSubmit();
      return angular.copy(payload);
    }
    function getSipPurchasePayloadToSubmit() {
      if (!vm.validations.investmentOption && (vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.formData.optionalInvestmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP)) {
        MessageService.error('Invalid Investment option for sip is selected.');
        return false;
      }
      vm.formData.dividendOption = vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.sipDividendOption;
      if(vm.formData.topupDetails){
        if(vm.formData.topupDetails.capMonthYear == 'Invalid date' || vm.formData.topupDetails.capMonthYear == ''){
          vm.formData.topupDetails.capMonthYear = '';
        }
      }else{
        vm.formData.topupDetails.capMonthYear = $window.moment(vm.formData.topupDetails.capMonthYear).format("DD-MMM-YYYY");
      }

      var selectedFolioObj = vm.folioList.filter(function (row) {              // for investor's name initialisation
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName : '';
      vm.formData.investmentOption = vm.validations.investmentOption;
      vm.formData.checkedNfoAutoSwitch = vm.formData.isAutoSwitch;
      vm.formData.autoSwitchScheme = vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null;
      vm.formData.autoSwitchSchemeDividendOption = vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null;
      vm.formData.switchSchemeInvestmentOption = vm.formData.isAutoSwitch ? vm.switchSchemeInvestmentOption : null;
      vm.formData.folioInvestorName = vm.folioInvestorName;
      vm.formData.euinOpted = (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N';
      if (vm.formData.investmentType === 'DREAMSIP') {
        vm.formData.bankInfo.bankAcType = vm.formData.bankInfo && vm.formData.bankInfo.bankAcType ? vm.formData.bankInfo.bankAcType : vm.formData.bankAcType;
        vm.formData.bankInfo.ifscCode = vm.formData.bankInfo && vm.formData.bankInfo.ifscCode ? vm.formData.bankInfo.ifscCode : vm.formData.ifscCode;
      }
      return angular.copy(vm.formData);
    }

    function getSipPurchasePayloadToSave() {

      if (vm.formData.bankInfo && vm.formData.bankInfo.bankName == "OTHER BANKS") {
        vm.formData.bankInfo.bankName = vm.formData.bankName;
      }
      if (vm.formData.isThroughDistributor === false && vm.formData.isThroughRia === false) {
        vm.formData.euin = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
      }
      var sipPayload = {
        authMode: vm.formData.authMode ? vm.formData.authMode.value : null,
        installmentAmount: vm.formData.amount,
        investmentOption: fetchInvestmentOption(vm.validations.investmentOption),
        dividendOption: vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.sipDividendOption,
        formType: "DREAMSIP",
        frequency: vm.formData.frequency,
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.inSchemeCode,
        schemeType: vm.formData.schemeType,
        toDate: vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
        sipDate: vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
        sipDay: vm.formData.day,
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        id: vm.formData.sTransactionId,
        sipFirstInstallment : vm.formData.sipFirstInstallment,
        compositeTransactionId: $stateParams.ctId ? $stateParams.ctId : '',
        isTillPerpetuityvm: vm.formData.isTillPerpetuity ? vm.formData.isTillPerpetuity : false,
        bankDetailsForECS: {
          accNumber: vm.formData.bankInfo ? vm.formData.bankInfo.accountNumber : '',
          bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
          ifscCode: vm.formData.bankInfo && vm.formData.bankInfo.ifscCode?vm.formData.bankInfo.ifscCode : vm.formData.ifscCode,
          branchName: vm.formData.bankInfo && vm.formData.bankInfo.bankBranch ? vm.formData.bankInfo.bankBranch: '',
          bankCity: vm.formData.bankInfo && vm.formData.bankInfo.bankCity ?vm.formData.bankInfo.bankCity: '',
          paymentOption: vm.formData.sipPaymentOption=='E-mandate'?'HEM': vm.formData.sipPaymentOption === 'UPI' ? 'UAP' : vm.formData.sipPaymentOption,
          otmId: vm.formData.otmId,
          netBankingUrl: vm.formData.bankInfo && vm.formData.bankInfo.netBankingUrl ? vm.formData.bankInfo.netBankingUrl: ''
        },
        option: vm.formData.option == 'Option A' ? 'A':'B',
        swapAmount:vm.formData.swapAmount,
        sipPeriod:vm.formData.sipPeriod,
        targetSchemeCode:vm.formData.targetSchemeCode,
        targetSchemeName:vm.formData.targetSchemeName,
        subBrokerARN: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
        subBrokerCode: vm.formData.subBrokerCode,
        mandateStartDate : vm.formData.emandateDate ? $window.moment(vm.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null,
        mandateEndDate : vm.formData.endDateEmandate ? $window.moment(vm.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null,
        mandateAmount : vm.formData.emandateAmount ? vm.formData.emandateAmount : null
        // sipTopupEnabled: vm.sipTopupSelected,
        // topupDetails: {
        //   amount: vm.formData.topupDetails ? vm.formData.topupDetails.amount : '',
        //   percentage: vm.formData.topupDetails ? vm.formData.topupDetails.percentage : '',
        //   frequency: vm.formData.topupDetails ? vm.formData.topupDetails.frequency : '',
        //   capAmount: vm.formData.topupDetails ? vm.formData.topupDetails.capAmount : '',
        //   capMonthYear: vm.formData.topupDetails ? (vm.formData.topupDetails.capMonthYear ? $window.moment(vm.formData.topupDetails.capMonthYear).format("DD-MMM-YYYY") : '') : ''
        // }

      }

      if (!sipPayload.investmentOption) {
        sipPayload.investmentOption = vm.formData.sipPaymentOption;
      }
      if (!sipPayload.dividendOption) {
        sipPayload.dividendOption = vm.formData.sipDividendOption;
      }

      var payload = {};

      if (vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        sipPayload = handleBrokerCode(sipPayload);
        payload = angular.copy(sipPayload);
      }
      payload.trackId = vm.formData.trackId;

      return payload;
    };
    /*
     * Function responsible to manage the broker code for purchase and sip payload
     * */
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = vm.isCheckedTandC ? true : false;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }
    function fetchInvestmentOption(investmentOption) {
      var investmentOptionKey = "";
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if (vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == investmentOption) {
          investmentOptionKey = key;
        }
      });
      return investmentOptionKey;
    };
    vm.setTandCVariable = function () {
      vm.formData.isCheckedTandC = vm.isCheckedTandC;
    };


    vm.inSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.inSchemeCode = schemeData.schemeCode;
        vm.formData.inSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        vm.liquidSchemeFlag = false;
        if(vm.formData.schemeType == 'LIQUID'){
          vm.liquidSchemeFlag = true;
        }else{
          vm.liquidSchemeFlag = false;
        }
        if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
          return;
        }
        fetchBankListForEcs();
        fetchBankList(function (success) {
          if (success) {
            checkEmandateBank();
          }
        });
        if(vm.formData.option == 'Option A') {
          fetchInSchemeValidations();
        }
        if(vm.formData.option == 'Option B') {
          vm.formData.targetSchemecode = '';
          vm.formData.targetSchemeName = '';
          vm.filterTargetSchemeList(vm.formData.inSchemeCode);
        }getDateValidation()
      }
    };

    vm.filterInSchemeList = function () {
      vm.formData.inSchemeCode = '';
      vm.authenticationMode = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
      resetNumInWords();
    };
    vm.filterInTargetSchemeList = function () {
      vm.formData.targetSchemecode = '';
      vm.targetSchemeList = [];
      vm.masterTargetSchemeList.forEach(function(item){
        if(item.schemeCode != vm.formData.inSchemeCode){
          vm.targetSchemeList.push(item);
        }
      });
      vm.targetSchemeList = UtilService.getFilteredList(vm.targetSchemeList, 'scheme', vm.formData.targetSchemeName);
      resetNumInWords();
    };
    function resetNumInWords() {
      vm.amountInWords = '';
      var inWordsDiv = $window.document.getElementById('divDisplayWords');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
    }
    vm.targetSchemeChanged = function (schemeData) {

      if (!schemeData) {
        return;
      } else {
        vm.formData.targetSchemeCode = schemeData.schemeCode;
        vm.formData.targetSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        vm.liquidSchemeFlag = false;
          if(vm.formData.schemeType == 'LIQUID'){
            vm.liquidSchemeFlag = true;
          }else{
            vm.liquidSchemeFlag = false;
          }

        if(vm.formData.targetSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.targetSchemeCode = '';
          vm.formData.targetSchemeName = '';
          vm.targetSchemeList = UtilService.getFilteredList(vm.targetSchemeList, 'scheme', vm.formData.targetSchemeName);
          return;
        }

          checkEmandateBank();
        if(vm.formData.option == 'Option B') {
           fetchInSchemeValidations();
        }
      }
    };

    function fetchInSchemeValidations(cb) {
      vm.inSchemeValidations = null;
      cb = cb || function () {
      };
      if (!vm.formData.inSchemeCode) {
        return;
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.inSchemeValidations = resp.data;
          vm.upiErrorMessage = vm.inSchemeValidations.upiMaxAmountErrMessage;
          vm.upiAmountLimit = vm.inSchemeValidations.upiMaxAmountLimit;
          _setSipDividendOptionsVali(vm.inSchemeValidations);
          cb(null);
        } else {
          cb('error');
          MessageService.error(resp.message);
          vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
        }
        checkValidations();
      },
        error = function (err) {
          cb('error');
          LoaderService.hideLoader();
          vm.inSchemeValidations = null;
          UtilService.errorHandler(err);
        };

        // applicationSource:"MF_ONLINE"
      var data = {
        schemeSource: vm.formData.inSchemeCode,
        schemeDestination: vm.formData.targetSchemeCode ? vm.formData.targetSchemeCode : vm.formData.inSchemeCode
      }
      InvestorService.post({
        child1: 'dreamSip',
        child2: 'schemeValidation'
      }, data).$promise.then(success, error);
    }

    vm.changeSipPeriod = function () {
      if (vm.formData.startDate) {
        updateEndDates();
      }
      if (vm.formData.amount) {
        checkSipValidations();
      }

      handleMandatePaymentOption();
    };
    vm.changeStartDate = function (date) {
      vm.formData.startDate = date ? date : null;
      vm.formData.day = vm.formData.startDate?+(vm.formData.startDate.format('DD')):undefined;
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = false;
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      });
      checkOTMAmountAndDate();
      updateEndDates();
    };
    function setbacksummaryStartDate() {
      var currentDay = $window.moment();
      vm.viewMode = 'days';
      var enabledStartDates = [];
      vm.enabledStartDates = angular.copy(enabledStartDates);
      var dateValid;
       if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        dateValid = vm.inSchemeValidations ? vm.inSchemeValidations.sipTDay : 17;
      } else {
        dateValid = 11;
      }
      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE || vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
        dateValid = vm.eMandatenoOfDays ? vm.eMandatenoOfDays : 5;
      }

      for (var i = dateValid; i < 90; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
    }
    function setStartDate() {
      vm.formData.startDate = null;
      var currentDay = $window.moment();
      vm.viewMode = 'days';
      var enabledStartDates = [];
      vm.enabledStartDates = angular.copy(enabledStartDates);
      var dateValid;
       if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        dateValid = vm.inSchemeValidations ? vm.inSchemeValidations.sipTDay : 17;
      } else {
        dateValid = 11;
      }
      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE || vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
        dateValid = vm.eMandatenoOfDays ? vm.eMandatenoOfDays : 5;
      }

      for (var i = dateValid; i < 90; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.startMinDateOTM = vm.enabledStartDates[0];
      if(vm.enabledStartDates && vm.enabledStartDates.length >0){
        var tempDate = vm.enabledStartDates[vm.enabledStartDates.length - 1];
        vm.startMaxDate = $window.moment(Date.parse(tempDate)).add(1, 'days');
      }else{
        vm.startMaxDate = $window.moment(Date.parse(vm.startMinDateOTM)).add(90, 'days');
      }
      vm.formData.endDate = null;
    }
    vm.openDreamDocumentFile = function (url) {
        $window.open(url);
    };

    function updateEndDates() {
      var maxYear = vm.formData.sipPeriod > vm.emandateMaxYear ? vm.emandateMaxYear : vm.formData.sipPeriod;
      vm.formData.endDate = $window.moment(vm.formData.startDate).add(maxYear, 'years');
      vm.formData.endDate = $window.moment(vm.formData.endDate).add(-1, 'months');
      if (vm.formData.sipPaymentOption != vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
        vm.formData.showTopUpBlock = true;
        var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
        vm.capDates = [];
        var capLastDate = capStartDate;
        while ($window.moment(capLastDate).isBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(capStartDate);
          }
          // capStartDateValue = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          capStartDate = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          if ($window.moment(capStartDate).isBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
            vm.capDates.push(capStartDate);
          }
          else {
            break;
          }
          capLastDate = vm.capDates[vm.capDates.length - 1];
        }
        checkOTMAmountAndDate();
      } else if(vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && vm.formData.endDateEmandate) {
        vm.sipDateLessEmandate =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
        if (vm.sipDateLessEmandate) {
          var endDateField =  angular.element('#endDateCalender');
          endDateField.focus();
        }
        // if (vm.sipDateLessEmandate) {
        //   var setEndDateLess = false;
        //   var tempEndDate = angular.copy($window.moment(vm.formData.endDate));
        //   while (!setEndDateLess) {
        //     tempEndDate = angular.copy($window.moment(tempEndDate).subtract(1, 'months'));
        //     if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY'))) {
        //       setEndDateLess = true;
        //       vm.formData.endDate = angular.copy(tempEndDate);
        //       vm.sipDateLessEmandate = false;
        //     }
        //   }
        // }
      }
    }



    // set topup frequency
    // function getTopupFrequencyList() {
    //   vm.topupFrequencyList = [
    //     { key: 'Y', value: 'Yearly', monthfreq: 12 },
    //     { key: 'H', value: 'Half Yearly', monthfreq: 6 }
    //   ];
    //   vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;
    // }

    function resetTopupDetails() {
      vm.formData.topupDetails = {};
      vm.formData.sipTopupEnabled = false;
    }

    // function changeSipTopupSelected(isChecked) {
    //   if (!$("#sipToptup").is(':checked')) {
    //     resetTopupDetails();
    //   }
    //   if (!vm.formData.isBackFromSummary) {
    //     vm.formData.sipTopupSelected = isChecked;
    //   }
    //   if (vm.formData.sipPaymentOption === 'OTM' && ((vm.formData.bankInfo && vm.formData.bankInfo.otmFrequency) !== 'AWP')) {
    //     vm.formData.sipTopupSelected = false;
    //     vm.formData.sipTopupEnabled = false;
    //     MessageService.error(vm.VALIDATE_DATA.OTM_VALIDATION_ERROR);
    //   }
    //   else if (vm.formData.bankInfo && vm.isOTMAmount) {
    //     vm.formData.sipTopupSelected = false;
    //     vm.formData.sipTopupEnabled = false;
    //     MessageService.error(vm.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR);
    //   }
    //   getTopupFrequencyList();
    // }

    vm.changeTopUpFreq = function () {
      var duration = 6;
      switch (vm.formData.topupDetails.frequency) {
        case 'H': duration = 6; break;
        case 'Y': duration = 12; break;
      }
      if (duration === 12) {
        var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
      }
      else {
        capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
      }

      vm.capDates = [];
      var capLastDate = capStartDate;
      while ($window.moment(capLastDate).isSameOrBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
        if (vm.capDates.length === 0) {
          vm.capDates.push(capStartDate);
        }
        capStartDate = $window.moment(capStartDate).add(duration, 'months').format("MMM-YYYY");
        if ($window.moment(capStartDate).isSameOrBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
          vm.capDates.push(capStartDate);
        }
        else {
          break;
        }
        capLastDate = vm.capDates[vm.capDates.length - 1];
      }
    };


    // payment options

    function changedPaymentOption() {
      sipSettingValidation();

      vm.formData.bankInfo = null;
      vm.formData.otmId = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = null;
      vm.formData.authMode = null;
      vm.authenticationMode = null;
      vm.enabledBillerStartDatesList = null;
      vm.disableEndDateSelection = false;
      getDateValidation();
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      vm.EmandateBank = null;
      if (vm.emandateUpiData) {
        vm.formData.emandateAmount = Math.floor(vm.emandateUpiData.defaultMandateAmount);
      }
      setStartDate()
      // fetchBankList();
      fetchBankListForEcs();
      checkOTMAmountAndDate();
      vm.formData.sipTopupSelected = false;
      vm.formData.showTopUpBlock = true;
      resetTopupDetails();
      // getTopupFrequencyList();

      if (vm.formData.sipPaymentOption === "E-mandate" && vm.enabledEmandateEndDatesList) {
        vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
        changeEndDateEmandate(vm.formData.endDateEmandate);
      }
      handleUpiError();
    }

    function checkOTM(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
        if (resp.status && resp.data) {
          if (resp.data.bankList.length == 0) {
            vm.isOTMEnabled = false;
            vm.hideOtmRadio = true;
            vm.paymentOptions =  [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            var index = vm.paymentOptions.indexOf('OTM');
            if (index > -1) {
              vm.paymentOptions.splice(index, 1);
            }
            vm.formData.sipPaymentOption = vm.paymentOptions[0];

          }
          else {
            vm.isOTMEnabled = true;
            vm.hideOtmRadio = false;
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            vm.formData.sipPaymentOption = vm.paymentOptions ? vm.paymentOptions[0] : '';
            vm.OTMbankList = resp.data.bankList;
          }
        }
        cb(true);
      },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };
      // LoaderService.showLoader();//need to check
      var payload = {
        transactionType: 'sip',
        folioNo: vm.formData.folioNumber
      };
      InvestorService.post({
        child1: 'folio',
        child2: 'otm'
      }, payload).$promise.then(success, error);
    }

    //fetch bank list

    function fetchBankList(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (vm.formData.sipPaymentOption == 'OTM' && resp.data.bankList.length == 0) {
            vm.formData.sipPaymentOption = vm.paymentOptions[0];
            vm.hideOtmRadio = true;
            vm.formData.showTopUpBlock = true;
            //fetchBankList();
          }
          else if (vm.formData.sipPaymentOption == 'OTM' && resp.data.bankList.length > 0) {
            vm.hideOtmRadio = false;
          }
          else if (vm.formData.sipPaymentOption == 'EC' || vm.formData.sipPaymentOption == 'UPI') {
            if (vm.formData.sipPaymentOption == 'EC') {
              vm.ECbankList = resp.data.bankList;
            } else {
              vm.UPIbankList = resp.data.bankList;
            }
            // vm.ECbankList = resp.data.bankList;
            if (vm.hideOtmRadio) {
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC ]
              vm.formData.sipPaymentOption = vm.paymentOptions[0];

            }
            else {
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC ];
              vm.hideOtmRadio = false;

            }
          }

          vm.bankList = resp.data.bankList;
        } else {
          vm.bankList = null;
          MessageService.error(resp.message);
        }
        cb(true);
      },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();

      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        InvestorService.post({ child1: 'bank', child2: 'list'}, {
          folioNumber: vm.formData.folioNumber,
          liquidSchemeFlag: vm.liquidSchemeFlag,
          sipFlow: true,
          trnxType: "PURCHASE"
        }).$promise.then(success, error);
      } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        LoaderService.hideLoader();
        vm.hideOtmRadio = false;
        vm.bankList = vm.OTMbankList;
      } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
        InvestorService.post({ child1: 'bank', child2: 'list'}, {
          folioNumber: vm.formData.folioNumber,
          liquidSchemeFlag: vm.liquidSchemeFlag,
          sipUpiFlow: true,
          trnxType: "PURCHASE"
        }).$promise.then(success, error);
      }
      else {
        vm.bankList = null;
      }
    }
    vm.getScheme = function(){
      checkEmandateBank();
    }

    //E-manadate  bank
    function checkEmandateBank() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          // vm.emandateMaxYear = resp.data.maxMandateDurationYears ? resp.data.maxMandateDurationYears : vm.defaultMandateYearDate;
          vm.isEMandateEnabled = resp.data.folioEmandateStatus;
          if (resp.data.bankList.length == 0 || !vm.isEMandateEnabled) {
            // vm.isEMandateEnabled = false;
            vm.EMbankList = null;
          }else{
            // vm.isEMandateEnabled = true;
            if(vm.isOTMEnabled && vm.isEMandateEnabled){
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            }
            if(!vm.isOTMEnabled && vm.isEMandateEnabled){
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            }
            if(!vm.isOTMEnabled && !vm.isEMandateEnabled){
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            }

            if(vm.sipFirstInstallment){
              vm.isEMandateEnabled = false;
            }else {
              vm.EMbankList = resp.data.bankList;
            }
          }
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        trnxType:"SIP",
        liquidSchemeFlag:vm.liquidSchemeFlag,
        folioNumber:vm.formData.folioNumber
      };
      InvestorService.post({
        child1: 'folio',
        child2: 'emandate'
      }, payload).$promise.then(success, error);
    }

    function setDynamicData() {

      vm.notesReview = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_Registration;
      vm.popup = vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_SIP_Review;
      vm.notesOtm = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_OTM;
      vm.notesEOtm = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_eOTM;
      vm.riaMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_SIP_Review_Through_RIA;
      vm.distributorMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_SIP_Through_Distributor;
      vm.notesEOtmDebitCard = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_eOTM_Debit_Card;
      vm.notesUPI = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_DREAMSIP_UPI;
      vm.key = "TNC_SIP_Review_Registration"
      vm.keyOtm = "TNC_SIP_Review_Registration_eOTM"

      if (!vm.distributorMessage)
        vm.formData.isCheckedTandC = false;

      if (!vm.riaMessage)
        vm.formData.isCheckedTandC = false;


    }

    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };
    vm.DreamSipTenure = function () {
      // $window.open(vm.paymentNavURL);
      var successSchemeList = function (result) {
        vm.inSchemeChanged(result);
      },
        errorSchemeList = function () {
        };


      ModalService.dreamSipTenureModal(vm.sipPeriodArray, successSchemeList, errorSchemeList);
    };
    //note show hide

    function checkEndNote(endDate, startDate) {
      if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showNote = true;
      } else {
        vm.showNote = false;
      }
    }

    function checkEndNoteOtm(endDate, startDate) {
      if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showOtmNote = true;
      } else {
        vm.showOtmNote = false;
      }
    }

    function checkEndNoteEOtm(endDate, startDate) {
      if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showEotmNote = true;
      } else {
        vm.showEotmNote = false;
      }
    }

    function checkSipValidations() {
     // vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
      vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
      vm.isTopupMinAmt = !!(vm.validations.topupMinAmt && vm.validations.topupMinAmt > vm.formData.topupDetails.amount);
      vm.isTopupMinPerc = !!(vm.validations.topupMinPercentage && vm.validations.topupMinPercentage > vm.formData.topupDetails.percentage);
      vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
      vm.isTopUpMultiples = vm.validations.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.validations.topupAmtMultples === 0) || false;
      vm.isTopupPercMultiples = vm.validations.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.validations.topupPercentageMultples === 0) || false;
      vm.isInvalidForm = vm.formData.amount <= 0 || (vm.formData.amount && ( vm.isMin || (vm.validations.amountMultiples && !vm.isMultiples)));
      if (!vm.isInvalidForm && vm.formData.topupDetails.amount) {
        vm.isInvalidForm = vm.formData.topupDetails.amount <= 0 || (vm.formData.topupDetails.amount && (vm.isTopupMinAmt || (vm.validations.topupAmtMultples && !vm.isTopUpMultiples)));
      }
      (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) && checkOTMAmountAndDate();
      vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.amount) && $window.NumToWord(vm.formData.topupDetails.amount, 'divDisplayInWords', vm);
      vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.capAmount) && $window.NumToWord(vm.formData.topupDetails.capAmount, 'capAmntDisplayInWords', vm);
      if (!vm.formData.isBackFromSummary) {
        angular.isDefined(vm.formData.topupDetails) && angular.isDefined(vm.formData.topupDetails.capAmount) && (vm.formData.topupDetails.capAmount = '');
      }
      if (!vm.isMin) {
        var swapAmountMultiple = vm.sipPeriodArray.filter(function (data) {
          return data.value == vm.formData.sipPeriod
        })[0];
        vm.formData.swapAmount = vm.formData.amount * swapAmountMultiple.multiple;
        $window.NumToWord(vm.formData.swapAmount, 'divDisplayWords1', vm);
        vm.maxSwapAmount = vm.formData.amount * swapAmountMultiple.multiple;
        checkSwapValidations();
      } else {
        vm.formData.swapAmount = '';
        $window.NumToWord('', 'divDisplayWords1', vm);
      }

      if (vm.formData.amount && vm.formData.emandateAmount) {
        checkAmountValidationEmandate();
      }
      handleUpiError();
    }
    function checkSwapValidations() {
      vm.isSwapMin = !!(vm.validations.swpValidationDTO && vm.validations.swpValidationDTO.monMinAmt > vm.formData.swapAmount);
      vm.isSwapMax = false;
      if(!vm.isSwapMin){
        vm.isSwapMax = !!(vm.maxSwapAmount && vm.maxSwapAmount < vm.formData.swapAmount);
      }
      vm.isSwapMultiples = vm.validations.swpValidationDTO.monAmtMultiples && vm.formData.swapAmount && (vm.formData.swapAmount % vm.validations.swpValidationDTO.monAmtMultiples === 0) || false;

    }

    function _setSipDividendOptionsVali(inSchemeValidations) {

      vm.inSchemeValidations = inSchemeValidations;
      vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
      vm.inSchemeValidations.investmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[vm.inSchemeValidations.investmentOption];
      if(vm.inSchemeValidations && vm.inSchemeValidations.swpValidationDTO){
        if(vm.inSchemeValidations.swpValidationDTO.dividendPayoutApplicable){
          vm.validations.investmentOption = 'Income Distribution cum Capital Withdrawal (IDCW) Option';
          vm.formData.dividendOption = "Y";
        }
        if(vm.inSchemeValidations.swpValidationDTO.dividendPayoutApplicable){
          vm.validations.investmentOption = 'Income Distribution cum Capital Withdrawal (IDCW) Option';
          vm.formData.dividendOption = "N";
        }
        if(!vm.inSchemeValidations.swpValidationDTO.dividendPayoutApplicable && !vm.inSchemeValidations.swpValidationDTO.dividendPayoutApplicable){
          vm.validations.investmentOption = 'GROWTH';
          vm.formData.dividendOption = "Z";
        }
      }
      vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
      if (!vm.formData.isBackFromSummary && !vm.formData.sipDividendOption) {
        if (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) {
          vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
        } else {
          if (vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === false) {
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
          } else if (vm.inSchemeValidations.dividendPayoutApplicable === false && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          } else if (vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          }
        }
      }
      if (vm.inSchemeValidations.validationType == 'SWITCH') {
        vm.switchSchemeInvestmentOption = vm.inSchemeValidations.investmentOption;
        vm.formData.switchDividendOption = (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : (((vm.inSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (vm.isSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : (vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST));
      }
    }

    function checkValidations() {
      vm.isInvalidForm = false;

      if (!vm.inSchemeValidations && !vm.outSchemeValidations) {
        vm.validations = {};
      }


      if (vm.inSchemeValidations) {
        vm.validations.minInstallDivisionFlag = vm.inSchemeValidations.minInstallDivisionFlag;
        vm.validations.swpTaxCode = vm.inSchemeValidations.swpTaxCode;
        vm.validations.endingType = vm.inSchemeValidations.endingType;
        vm.validations.topupAmtMultples = vm.inSchemeValidations.topupAmtMultples;
        vm.validations.topupPercentageMultples = vm.inSchemeValidations.topupPercentageMultples;
        vm.validations.topupMinAmt = vm.inSchemeValidations.topupMinAmt;
        vm.validations.topupMinPercentage = vm.inSchemeValidations.topupMinPercentage;
        vm.validations.amountMultiples = vm.inSchemeValidations.additionalValidation.OM[0].amt_multiples;
        //vm.validations.maxInstallments =vm.inSchemeValidations.additionalValidation.OM[0].amt_multiples;
        vm.validations.minInstallments = vm.inSchemeValidations.additionalValidation.OM[0].min_installments;
        vm.validations.minAmount = vm.inSchemeValidations.additionalValidation.OM[0].min_amount_lower;
        vm.validations.maxAmount = vm.inSchemeValidations.additionalValidation.OM[0].min_amount_upper;
        vm.validations.swpValidationDTO = vm.inSchemeValidations.swpValidationDTO;
        if (!vm.backFromPayment && !$stateParams.transactionId) {
          if (vm.validations.minAmount > vm.inSchemeValidations.sipDefaultAmount) {
            vm.formData.amount = vm.validations.minAmount;
          } else {
            vm.formData.amount = vm.inSchemeValidations.sipDefaultAmount;
          }
          vm.formData.amount = 5000;
          $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
        }
        checkSipValidations();
      }

    }

    function checkOTMAmountAndDate() {

      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isOTMEndDate = false;
      // Check Ammout
      if (vm.formData.amount && vm.formData.bankInfo && (vm.formData.amount > vm.formData.bankInfo.maxAmount)) {
        vm.isOTMAmount = true;
      } else {
        vm.isOTMAmount = false;
      }

      //Compare Start Dates
      if (vm.formData.bankInfo && ($window.moment(vm.formData.bankInfo.omExpiryDate, "DD-MMM-YYYY").isBefore(vm.formData.startDate))) {
        vm.isOTMDate = true;
      }
      else {
        vm.isOTMDate = false;
      }
      //Compare End Dates
      if (vm.formData.bankInfo && vm.formData.bankInfo.omStartDate) {
        if (!(vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore(vm.formData.startDate))) {
          if (vm.formData.startDate == null) {
            vm.isOTMStartDate = false;
          }
          else {
            vm.isOTMStartDate = true;
          }
        }
        else {
          vm.isOTMStartDate = false;
        }
      }

      if (vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isBefore(vm.formData.endDate)) {
        vm.isOTMEndDate = true;
      }
      else {
        vm.isOTMEndDate = false;
      }
      //Check for amount or date
      if (vm.isOTMAmount || vm.isOTMDate || vm.isOTMEndDate) {
        vm.isInvalidForm = true;
      } else {
        vm.isInvalidForm = false;
      }
    }
    function getAccountType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.bankTypeList = resp.data.bankAccountTypes;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        $log.info('Account type Errror>>>>', err);
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.formData.investorType
      }).$promise.then(success, error);
    }
    function fetchInvestorType() {
      var investorType = vm.folioList.filter(function(folio) {
        return folio.folioNumber === vm.formData.folioNumber;
      });
      vm.formData.investorType = investorType[0].invType;
    }
    vm.EmandateBank = null;
    vm.ECBankData = null;
    vm.changeBank = function () {
      if (!vm.formData.bankInfo && !vm.EmandateBank && !vm.ECBankData) {
        return;
      }
      if(vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
        vm.formData.bankInfo = JSON.parse(vm.EmandateBank);
      }else if(vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        vm.formData.bankInfo = JSON.parse(vm.ECBankData);
      } else{
        vm.EmandateBank = null;
        vm.ECBankData = null;
      }
      if(!vm.formData.bankInfo.bankAcType){
        fetchInvestorType();
        getAccountType();
      }
      vm.formData.sipTopupSelected = !!vm.formData.sipTopupSelected;
      vm.formData.sipTopupEnabled = !!vm.formData.sipTopupEnabled;
      if(!vm.formData.bankInfo)
        vm.authenticationMode=null;
      switch (vm.formData.sipPaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          vm.formData.otmId = vm.formData.bankInfo ? vm.formData.bankInfo.otmId : '';
          vm.formData.bankName = vm.formData.bankInfo ? vm.formData.bankInfo.bankName : '';
          vm.formData.bankBranch = vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '';
          vm.formData.bankAcNo = vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '';
          vm.formData.ifscCode = vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : '';
          vm.formData.payoutId = vm.formData.bankInfo ? vm.formData.bankInfo.payoutId : '';
          vm.showIFSCField = vm.formData.bankInfo.ifscCode ? false : true;
          vm.showAccountTypeField = vm.formData.bankInfo.bankAcType ? false : true;
          if (vm.showAccountTypeField) {
            fetchInvestorType();
            getAccountType();
          }
          (vm.formData.bankInfo && angular.isDefined(vm.formData.bankInfo.camsMandateIdNo))&&(vm.formData.camsMandateIdNo = vm.formData.bankInfo.camsMandateIdNo);
          if(angular.isDefined(vm.formData.bankInfo) && (vm.formData.bankInfo.otmFrequency !== 'AWP') && (vm.formData.frequency === 'BZ')){
            vm.isInvalidForm = true;
            MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
          }
          delete vm.formData.netBankingUrl;
          checkOTMAmountAndDate();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:
            vm.formData.authMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes[0] : null;
            vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
            // vm.EMbankList.forEach(function (item) {
            //   if (vm.formData.bankInfo.accountNumber == item.accountNumber){
            //       vm.formData.authMode = item.authenticationModes[0];
            //       vm.authenticationMode = item.authenticationModes;
            //   }
            // });
            vm.formData.bankAcNo = vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '';
            vm.formData.emUmrn = vm.formData.bankInfo ? vm.formData.bankInfo.emUmrn : '';
            vm.formData.maxAmount = vm.formData.bankInfo ? vm.formData.bankInfo.maxAmount : '';
            vm.formData.emExpiryDate = vm.formData.bankInfo ? vm.formData.bankInfo.emExpiryDate : '';
            vm.isInvalidForm = false;
        break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if (!vm.formData.bankInfo) {
            return;
          }
          if (!vm.formData.bankInfo.bankAcType) {
            getAccountType();
          }
          // if(!$window.localStorage.getItem("SummaryEnabled")) {
          //   vm.formData.verifyUPIResp = {};
          //   vm.formData.isUPIVerified = false;
          //   vm.formData.virtualAddress = "";
          //   if (vm.tForm && vm.tForm.virtualAddress) {
          //     vm.tForm.virtualAddress.$setPristine(true);
          //   }
          // }

          // if(!vm.formData.bankInfo.minorBankFlag){
          //   localStorage.setItem('folioId',vm.formData.folioNumber);
          //   ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
          //   vm.formData.bankInfo = null;
          //   vm.isCheckedDeclaration = false;
          //   return;
          // }
          vm.upiAccountNumber = vm.formData.bankInfo.accountNumber;
          vm.upiBankName = vm.formData.bankInfo.bankName;
          // vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
          break;
        default :
          vm.formData.netBankingUrl = vm.formData.bankInfo.netBankingUrl;
          vm.formData.bankName = '';
          vm.formData.otmId = '';
          break;
      }
      resetBankDetails();   // need for sip transaction
    };

    vm.otherBankSelected = function () {
      //vm.formData.bankInfo = '';
    }
    // end
    function fetchDreamSipPeriod() {
      var success = function (resp) {
        if (resp.status && resp.data) {
           vm.sipPeriodArray= resp.data.sipPeriod;
           vm.formData.sipPeriod = 20;
        } else {
          vm.sipPeriodArray = null;
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      investorServiceVersion.get({
        child1: 'dreamSip',
        child2: 'sipPeriod'
      }).$promise.then(success, error);
    }

  vm.targetFolioChanged = function () {
    if (!vm.formData.folioNumber) { return; }
    var selectedFolioObj = vm.folioList.filter(function (row) {
      return row.folioNumber == vm.formData.TargetFolio;
    })[0];
    vm.folioMinor = false;
    vm.TargetfolioInvestorName = selectedFolioObj ? selectedFolioObj.investorName : '';
    vm.TargetselectedFolioEmail = selectedFolioObj.email;
    vm.TargetselectedFolioMobile = selectedFolioObj.mobileNumber;

    if (vm.TargetselectedFolioMobile === null || vm.TargetselectedFolioMobile === '') {
      if (vm.TargetselectedFolioEmail === null || vm.TargetselectedFolioEmail === '') {
        vm.isEmailMobileinValid = true;
        vm.emandateDisplay = false;
      }
      else {
        vm.isMobileinValid = true;
        vm.emandateDisplay = false;
      }
    }
    else if (vm.TargetselectedFolioEmail === null || vm.TargetselectedFolioEmail === '') {
      if (vm.TargetselectedFolioMobile === null || vm.TargetselectedFolioMobile === '') {
        vm.isEmailMobileinValid = true;
        vm.emandateDisplay = false;
      }
      else {
        vm.isEmailinValid = true;
        vm.emandateDisplay = false;
      }
    }
  };

  vm.changeFirstInstallment = function(value){
    vm.formData.sipFirstInstallment = value;
    if(value){
      vm.isEMandateEnabled = false;
      if(vm.isOTMEnabled && vm.isEMandateEnabled){
        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
      }
      if(vm.isOTMEnabled && !vm.isEMandateEnabled){
        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
      }
      if(!vm.isOTMEnabled && !vm.isEMandateEnabled){
        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
      }
    }else{
      if(vm.EMbankList) {
        vm.isEMandateEnabled = true;
      }
      if(vm.isEMandateEnabled && vm.EMbankList && vm.isOTMEnabled){
        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
      }
    }
  }

  vm.filterTargetSchemeList = function(inSchemeCode){
    vm.targetSchemeList = [];
    vm.masterTargetSchemeList.forEach(function(item){
      if(item.schemeCode != inSchemeCode){
        vm.targetSchemeList.push(item);
      }
    });
  }

  function updateEmandateEndDate() {

    if (!vm.formData.emandateDate) {
      return;
    }

    var enabledEndDates = [];
    vm.formData.endDateEmandate = '';
    if(vm.formData.emandateDate)
    {
      vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
      vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateMaxYear, 'years').subtract(1,'days');
    }

    var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
    for (var i = 0; i <= freq; i++) {
      enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
    }
    vm.enabledEmandateEndDatesList = enabledEndDates;
    vm.endDateViewEmandate = enabledEndDates[0].clone();
    vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
  }


  function checkAmountValidationEmandate() {
    vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
    vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
    vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.formData.amount ? true : false;
    $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
  }

  function changeEndDateEmandate(date) {
    vm.formData.endDateEmandate = date ? date : null;
    if (vm.formData.endDate) {
      vm.changeStartDate(vm.formData.startDate);
    }
  }
    function handleVpa() {
      if (vm.formData.virtualAddress) {
        vm.formData.virtualAddress = vm.formData.virtualAddress.toLowerCase();
        vm.formData.verifyUPIResp={};
      }
    }
    function verifyUPI() {
      vm.formData.verifyUPIResp = {};
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData.verifyUPIResp = resp.data;
            if (resp.data.valid) {
              vm.formData.name = resp.data.name;
              vm.formData.isUPIVerified = true;
            } else {
              vm.formData.isUPIVerified = false;
            }
          }
          else {
            vm.formData.isUPIVerified = false;
            vm.formData.verifyUPIResp.valid = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.formData.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();

      investorServiceVersion.post({
        child1: 'upi',
        child2: 'check',
        child3: 'virtualAddress'
      }, {
        "virtualAddress": vm.formData.virtualAddress,
        "basketFlow": false,
        "folioNo": vm.formData.folioNumber,
        "transactionType": vm.formData.investmentType,
        "ecartFlow": false
      }).$promise.then(success, error);
    }
    function sipSettingValidation(parsedDate){
      if ((vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE || vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) && !vm.emandateUpiData) {
        UtilService.fetchMandateValidations().then(function (resp) {
          vm.emandateUpiData = resp;
          if (vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            vm.emandateValidationData = vm.emandateUpiData.eOTM;
          } else if (vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            vm.emandateValidationData = vm.emandateUpiData.upi;
          } else {
            vm.emandateUpiData = null;
          }
          if(vm.emandateValidationData) {
            setEmandateUpiSetting(parsedDate);
          }
        }).catch(function(resp) {
          MessageService.error(resp)
        });
      } else {
        if (vm.emandateUpiData) {
          if (vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            vm.emandateValidationData = vm.emandateUpiData.eOTM;
          } else if (vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            vm.emandateValidationData = vm.emandateUpiData.upi;
          }
          if (vm.emandateValidationData) {
            setEmandateUpiSetting();
          }
        }
      }
    }

    function setEmandateUpiSetting(parsedDate) {
      UtilService.fetchMandateValidations().then(function (resp) {
        vm.emandateMaxYear = vm.emandateValidationData.maxMandateDurationYears ? vm.emandateValidationData.maxMandateDurationYears : vm.defaultMandateYearDate;
        vm.eMandatenoOfDays = vm.emandateValidationData.noOfDays;
        vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
        vm.eMandatemaxAmountLimit = vm.emandateValidationData.maxAmountLimit;
        vm.emandateMinAmountLimit = vm.emandateValidationData.minAmountLimit;
        vm.formData.emandateAmount = Math.floor(vm.emandateValidationData.defaultMandateAmount);
        $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate', vm.formData.emandateWord);
        vm.mandateInfo = vm.emandateValidationData.mandateInfo;
        vm.minEndDateGapMandate = vm.emandateValidationData.minEndDateGap;
        vm.mandateMaxString = vm.emandateValidationData.maxAmountLimitInfo;
        vm.formData.emandateDate = $window.moment().add(vm.emandateValidationData.minStartDays, 'days');
        updateEmandateEndDate();
        $timeout(function () {
          getDateValidation();
        },100);
      }).catch(function (resp) {
        MessageService.error(resp)
      });
    }

    function handleUpiError() {
      if(vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI && vm.formData.amount > vm.upiAmountLimit) {
        var success = function() {
          if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if(vm.paymentOptions.includes("E-mandate") && vm.isEMandateEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
          } else if(vm.paymentOptions.includes("EC")){
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          } else {
            vm.formData.sipPaymentOption = null;
          }
          vm.changedPaymentOption();
        }
        ModalService.genericModal({
          text: vm.upiErrorMessage
        },success);
      }
    }

    function paymentOptionOrdering(){
      // Get the index of OTM and EC in the array
      var otmIndex = vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM);
      var ecIndex = vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC);

      // Check if OTM exists and add EMANDATE after OTM, else add it before EC, or at the end if both don't exist
      if (otmIndex !== -1) {
        vm.paymentOptions.splice(otmIndex + 1, 0, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
      } else if (ecIndex !== -1) {
        vm.paymentOptions.splice(ecIndex, 0, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
      } else {
        vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE); // Add to the end if neither exist
      }
    }

    function handleMandatePaymentOption() {
      var index = vm.paymentOptions.indexOf('E-mandate');
      if (vm.emandateUpiData && (vm.formData.sipPeriod > vm.emandateUpiData.eOTM.maxMandateDurationYears)) {
        if(index > -1) {
          vm.paymentOptions.splice(index,1);
        }

        if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          vm.formData.sipPaymentOption = vm.paymentOptions[0];
          changedPaymentOption();
        }

      } else {
        if (vm.EMbankList && (vm.EMbankList.length > 0 && index <= -1)) {
          // vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)
          paymentOptionOrdering();
        }
      }

      var index = vm.paymentOptions.indexOf('UPI');
      if (vm.emandateUpiData && (vm.formData.sipPeriod > vm.emandateUpiData.upi.maxMandateDurationYears)) {
        if(index > -1) {
          vm.paymentOptions.splice(index,1);
        }

        if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
          if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if(vm.paymentOptions.includes("E-mandate") && vm.isEMandateEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
          } else if(vm.paymentOptions.includes("EC")){
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          } else {
            vm.formData.sipPaymentOption = null;
          }
          changedPaymentOption();
        }

      } else {
        if (vm.UPIbankList && (vm.UPIbankList.length > 0 && index <= -1)) {
          vm.paymentOptions.unshift(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
        }
      }
    }

    function fetchBankListForEcs(cb){
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.ECbankList = resp.data.bankList;

            vm.bankList = resp.data.bankList;
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
          cb(true);
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();

      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        InvestorService.post({ child1: 'bank', child2: 'list'}, {
          folioNumber: vm.formData.folioNumber,
          liquidSchemeFlag: vm.liquidSchemeFlag,
          sipFlow: true,
          trnxType: "PURCHASE"
        }).$promise.then(success, error);
      }
      else {
        vm.bankList = null;
      }
    }

  }
})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .directive('favouriteTransactionsTupple', favouriteTransactionsTupple);

    /** @ngInject */
    function favouriteTransactionsTupple() {
        return {
            restrict: 'E',
            scope: {
                list: '=',
                edit:'=',
                delete:'=',
                cart:'=',
                limit:'=',
                showMore:'=',
                showViewMoreFlag:'='
            },
            templateUrl: 'app/transactions/favourite/components/favouriteTransactionsTupple.html'
        };
    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SchemeInvestmentController', SchemeInvestmentController);

  /** @ngInject */
  function SchemeInvestmentController(LoaderService, $log, MessageService, InvestorService, TransactionsService, $state) {
    var vm = this;
    vm.$state = $state;

    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.PARTNER_DATA = JSON.parse(sessionStorage.getItem("PARTNER_DATA"));

    vm.init = init;
    init();
    function init() { 
      sessionStorage.setItem('folioStateData','BACK_ROUTE');
      var Details =  JSON.parse(sessionStorage.getItem("userData"));
      if(Details.transactionDraftId){ 
      var success = function (resp) { 
        if (resp.data && resp.status) {  
          if(resp.data.fundCategory || resp.data.investmentGoal) {
            var isBackbuttonClick = sessionStorage.getItem("investorIsBackButtonClick");
            if(resp.data.step == "FIRST" && !isBackbuttonClick){ 
              if(vm.distributorDetails || vm.PARTNER_DATA){
                if(resp.data.investmentGoal){
                  $state.go("newInvestor.investmentDetails.schemedetails.investmentGoal");
                }else{ 
                    $state.go("newInvestor.investmentDetails.schemedetails.selectscheme");
                }
              }else{
                $state.go("newInvestor.investmentDetails.investmentmode");
              }
            }else if(resp.data.step == "SECOND" && !isBackbuttonClick){
              if(vm.distributorDetails || vm.PARTNER_DATA){
                if(resp.data.investmentGoal){
                  $state.go("newInvestor.investmentDetails.schemedetails.investmentGoal");
                }else{ 
                    $state.go("newInvestor.investmentDetails.schemedetails.selectscheme");
                }
              }else{
                  $state.go("newInvestor.investmentDetails.amountdetails");
              }
            }else if(resp.data.step == "THIRD" && !isBackbuttonClick){
              if(vm.distributorDetails || vm.PARTNER_DATA){
                if(resp.data.investmentGoal){
                  $state.go("newInvestor.investmentDetails.schemedetails.investmentGoal");
                }else{ 
                    $state.go("newInvestor.investmentDetails.schemedetails.selectscheme");
                }
              }else{
                $state.go("newInvestor.folioDetails.baiscDetails");
              }
            }else{
               if(resp.data.investmentGoal){
                $state.go("newInvestor.investmentDetails.schemedetails.investmentGoal");
              }else{ 
                  $state.go("newInvestor.investmentDetails.schemedetails.selectscheme");
              } 
            }
            
          }else{ 
             $state.go("newInvestor.investmentDetails.schemedetails.selectscheme");
          }  
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) { 
        MessageService.error(err.data.message);
      };
      vm.processFlag = false;
      
      var Data = {};  
      Data.id= Details.transactionDraftId; 
      if(Data && Data.id){
        InvestorService.post({
          child1: 'new',
          child2: 'user',
          child3: 'saved',
          child4: 'draft' 
        },Data).$promise.then(success, error);
      } 
      } else{
        $state.go("newInvestor.investmentDetails.schemedetails.selectscheme");
      }
      
    }
  
  }
})();
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentModeController', InvestmentModeController);

  /** @ngInject */
  function InvestmentModeController($window, $filter, $state, UtilService, $rootScope, $stateParams, $scope, toastr, AuthService, HDFC_API, LoaderService,
    AppConstants, InvestorService, $location, $timeout, TransactionService, MessageService, ModalService, IIHttpService) {
    var vm = this;
    vm.investmentTypeList = ['SIP', 'Lumpsum'];
    vm.investingThroughList = ['Self', 'Distributor', 'RIA'];
    vm.EUINList = ['EUIN', 'EUIN Declaration'];
    vm.SelectedInvestmentType = 'SIP';
    vm.SelectedInvestingThrough = 'Self';
    vm.SelectedEnui = 'EUIN';
    vm.euintempData = {};
    vm.init = init;
    vm.inSearchSchemeName = '';
    // $rootScope.backLocation.push($location.$$path);
    vm.subBrokerCode = '';
    vm.subBrokerARN = '';
    vm.investmentARN = '';
    vm.saveDraftPayload = {};
    vm.investmentValidation = {};
    vm.searchARN = false;
    vm.togglesubBrokerCode = false;
    vm.riaCodeError = '';
    $rootScope.currentstate = $state.current.url;
    $rootScope.setUsetInfo();
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.tForm = {};
    vm.investmentModeDetailsForm = {};
    vm.brokerCodeError = '';
    vm.RiaCode = '';
    vm.inSchemeList = [];
    vm.investmentModeDetailsForm.SelectedInvestmentType = 'SIP';
    vm.investmentModeDetailsForm.accountNumber = '';
    vm.brokerName = '';
    vm.setGetDraftData = setGetDraftData;
    vm.fetchEuinList = fetchEuinList;
    vm.fetchEuinListSubBroker = fetchEuinListSubBroker;
    vm.distributorName = '';
    vm.distributorARN = '';
    vm.distributorList = null;
    vm.isCheckedTandC = false;
    vm.investmentEUNIList = null;
    vm.euinData = {};
    vm.euin = {};
    vm.subBrokerName = '';
    vm.getEuinRIA = getEuinRIA;
    vm.mobileLoginPandetails = sessionStorage.getItem('MobilePanLoginDetails')?JSON.parse(sessionStorage.getItem('MobilePanLoginDetails')) :null;
    init();
    function init() {

      vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
      if(vm.distributorDetails && vm.distributorDetails.transactionType == 'Purchase_Scheduler'){
        vm.distributorDetails.transactionType = 'Purchase';
      }
      vm.PARTNER_DATA = JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
      if (vm.distributorDetails) {
        if (vm.distributorDetails.key == "MFD" || vm.distributorDetails.key == "CONNECT_PARTNER") {
          vm.SelectedInvestingThrough = 'Distributor';
          vm.investmentARN = vm.distributorDetails.arn;
          vm.subBrokerARN = vm.distributorDetails.subBrokerARN ? vm.distributorDetails.subBrokerARN : "";
          vm.subBrokerCode = vm.distributorDetails.subBrokerCode ? vm.distributorDetails.subBrokerCode : "";
          if (vm.investmentARN) {
            if (vm.distributorDetails && vm.distributorDetails.euin) {
              vm.euintempData.euinCode = vm.distributorDetails.euin;
              vm.SelectedEnui = 'EUIN';
            } else {
              vm.SelectedEnui = 'EUIN Declaration';
              // vm.isCheckedTandC = true;
            }
          }
          if (vm.subBrokerARN) {
            fetchEuinListSubBroker();
          }else{
            fetchEuinList();
          }
        }
        if (vm.distributorDetails.key == "RIA") {
          vm.SelectedInvestingThrough = 'RIA';
          vm.RiaCode = vm.distributorDetails.riaCode;
          getEuinRIA();
        }
        if (vm.distributorDetails.key == "E_CODE" && vm.distributorDetails.arn) {
          vm.SelectedInvestingThrough = 'Distributor';
          vm.investmentARN = vm.distributorDetails.arn;
          vm.subBrokerARN = vm.distributorDetails.subBrokerARN ? vm.distributorDetails.subBrokerARN : "";
          vm.subBrokerCode = vm.distributorDetails.subBrokerCode ? vm.distributorDetails.subBrokerCode : "";
          if (vm.investmentARN) {
            if (vm.distributorDetails && vm.distributorDetails.euin) {
              vm.euintempData.euinCode = vm.distributorDetails.euin;
              vm.SelectedEnui = 'EUIN';
            } else {
              vm.SelectedEnui = 'EUIN Declaration';
              // vm.isCheckedTandC = true;
            }
          }
          if(vm.subBrokerARN){
            fetchEuinListSubBroker();
          }else{
            fetchEuinList();
          }
        } else {
          vm.saveDraftPayload = {};
        }
        if (vm.distributorDetails.key == "E_CODE" && !vm.distributorDetails.arn) {
          vm.SelectedInvestingThrough = 'Self';
        }
        if (vm.distributorDetails.transactionType == "SIP") {
          vm.SelectedInvestmentType = "SIP";
        } else {
          vm.SelectedInvestmentType = "Purchase";
        }
      } else if (vm.PARTNER_DATA) {
        vm.SelectedInvestingThrough = vm.PARTNER_DATA.arnCode ? 'Distributor' : 'Distributor';
        vm.investmentARN = vm.PARTNER_DATA.arnCode ? vm.PARTNER_DATA.arnCode : '';
        if (vm.investmentARN) {
          fetchEuinList();
          vm.SelectedEnui = 'EUIN Declaration';
        }
      } else {
        vm.saveDraftPayload = {};
      }

      if(vm.mobileLoginPandetails && vm.mobileLoginPandetails.transactionType == 'purchase'){
        vm.SelectedInvestmentType = "Purchase";
      }
      if(vm.mobileLoginPandetails && vm.mobileLoginPandetails.transactionType == 'sip'){
        vm.SelectedInvestmentType = "SIP";
      }
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[1].stepCompleted = true;
      $rootScope.testObj.steps[2].stepCompleted = false;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepActive = false;
      $rootScope.testObj.steps[2].stepActive = true;
      $rootScope.stepperSecondary.steps[0].stepActive = false;
      $rootScope.stepperSecondary.steps[0].stepCompleted = true;
      $rootScope.stepperSecondary.steps[1].stepActive = true;


    }
    vm.chooseInvestmentType = function (InvestmentType) {
      vm.SelectedInvestmentType = InvestmentType;
    }
    vm.chooseInvestmentThrough = function (InvestmentThrough) {
      vm.SelectedInvestingThrough = InvestmentThrough;
    }
    vm.chooseEnui = function (enui) {
      vm.SelectedEnui = enui;
    }
    vm.disabledDistributtonAlert = function (data) {
      if (data == 'Self' || data == 'Ria') {
        if (!vm.distributorDetails) {
          MessageService.error("For regular scheme Self and ria is not allowed.");
        }
      }
      if (data == 'Distributor') {
        if (!vm.distributorDetails) {
          MessageService.error("For direct scheme distributor is not allowed.");
        }
      }
    }
    vm.disableAlertSIPLumbsum = function (data) {
      if (data == 'Purchase') {
        MessageService.error("For this scheme lumpsum is not allowed.");
      }
      if (data == 'data') {
        MessageService.error("For this scheme sip is not allowed.");
      }
    }
    vm.changeRiaCode = function () {
      vm.brokerCodeError = '';
    }
    vm.filterInSchemeList = function () {
      vm.inSearchSchemeCode = '';
      vm.authenticationMode = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.inSearchSchemeName);
    };
    // setDraftData
    function setGetDraftData() {
      vm.investmentValidation = JSON.parse(sessionStorage.getItem("investmentModeValidation"));

      if (vm.investmentValidation && vm.investmentValidation.directSchemes == false) {
        vm.SelectedInvestingThrough = 'Distributor';
        if (!vm.distributorDetails) {
          // MessageService.error("For regular scheme Self & ria is not allowed.");
        }
      } else {
        if (vm.distributorDetails && vm.distributorDetails.key == "RIA") {
          vm.SelectedInvestingThrough = 'RIA';
        }
        if (!vm.distributorDetails) {
          // MessageService.error("For direct scheme Distributor is not allowed.");
        }
      }
      if (vm.investmentValidation && !vm.investmentValidation.sipEnabled && !vm.investmentValidation.purchaseEnabled) {
        MessageService.error("For this scheme sip & lumpsum is not allowed.");
        vm.SelectedInvestmentType = null;
      } else if (vm.investmentValidation && !vm.investmentValidation.sipEnabled) {
        MessageService.error("For this scheme sip is not allowed.");
        vm.SelectedInvestmentType = "Purchase";
      } else if (vm.investmentValidation && !vm.investmentValidation.purchaseEnabled) {
        MessageService.error("For this scheme lumpsum is not allowed.");
        vm.SelectedInvestmentType = "SIP";
      } else {
        if (vm.distributorDetails && vm.distributorDetails.transactionType) {
          vm.SelectedInvestmentType = vm.distributorDetails.transactionType;
        } else {
          vm.SelectedInvestmentType = vm.saveDraftPayload.investmentType ? vm.saveDraftPayload.investmentType : vm.SelectedInvestmentType;
        }
      }
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.saveDraftPayload = resp.data;
          getValidationForSipPurchase();
          $rootScope.testObj.steps[1].schemeName = resp.data.fundName;
          if (resp.data.investmentType) {
            if (resp.data.investmentType == 'Purchase') {
              if (vm.distributorDetails && vm.distributorDetails.transactionType) {
                vm.SelectedInvestmentType = vm.distributorDetails.transactionType;
              } else {
                vm.SelectedInvestmentType = 'Purchase';
              }
            } else {
              if (vm.distributorDetails && vm.distributorDetails.transactionType) {
                vm.SelectedInvestmentType = vm.distributorDetails.transactionType;
              } else {
                vm.SelectedInvestmentType = 'SIP';
              }
            }
          }

          vm.investmentValidation = JSON.parse(sessionStorage.getItem("investmentModeValidation"));
          if (vm.investmentValidation) {
            if (!vm.investmentValidation.sipEnabled && !vm.investmentValidation.purchaseEnabled) {
              vm.SelectedInvestmentType = null;
            } else if (!vm.investmentValidation.sipEnabled) {
              vm.SelectedInvestmentType = "Purchase";
            } else if (!vm.investmentValidation.purchaseEnabled) {
              vm.SelectedInvestmentType = "SIP";
            } else {
              if (vm.distributorDetails && vm.distributorDetails.transactionType) {
                vm.SelectedInvestmentType = vm.distributorDetails.transactionType;
              } else {
                vm.SelectedInvestmentType = vm.saveDraftPayload.investmentType ? vm.saveDraftPayload.investmentType : vm.SelectedInvestmentType;
              }
            }
            if (vm.investmentValidation.directSchemes == true) {
              if (vm.saveDraftPayload.riaConsent) {
                vm.RiaCode = vm.distributorDetails && vm.distributorDetails.key == 'RIA' ? vm.distributorDetails.riaCode : vm.saveDraftPayload.riaCode;
                vm.SelectedInvestingThrough = 'RIA';
              } else {
                vm.SelectedInvestingThrough = vm.distributorDetails && vm.distributorDetails.key == 'RIA' ? 'RIA' : 'Self';
              }
            } else {
              if (vm.saveDraftPayload.brokerCode) {
                vm.SelectedInvestingThrough = 'Distributor';
                vm.investmentARN = vm.distributorDetails && vm.distributorDetails.arn ? vm.distributorDetails.arn : vm.saveDraftPayload.brokerCode;
                if(vm.PARTNER_DATA){
                  vm.investmentARN = vm.PARTNER_DATA.arnCode ? vm.PARTNER_DATA.arnCode : '' ;
                }
                vm.subBrokerARN = vm.distributorDetails && vm.distributorDetails.subBrokerARN ? vm.distributorDetails.subBrokerARN : vm.saveDraftPayload.subBrokerArn;
                vm.subBrokerCode = vm.distributorDetails && vm.distributorDetails.subBrokerCode ? vm.distributorDetails.subBrokerCode : vm.saveDraftPayload.subBrokerCode;
                if(vm.subBrokerARN){
                  fetchEuinListSubBroker();
                }else{
                  fetchEuinList();
                }
                if (vm.saveDraftPayload.euinOpted == "Y") {
                  vm.euintempData = {};
                  if (vm.distributorDetails && vm.distributorDetails.euin) {
                    vm.euintempData.euinCode = vm.distributorDetails.euin;
                    vm.SelectedEnui = 'EUIN';
                    if(vm.subBrokerARN){
                      fetchEuinListSubBroker();
                    }else{
                      fetchEuinList();
                    }
                  } else {
                    vm.SelectedEnui = 'EUIN Declaration';
                    // vm.isCheckedTandC = true;
                  }
                  vm.euintempData.euinName = vm.saveDraftPayload.euinName;
                  vm.euintempData.euinNameCode = vm.saveDraftPayload.euinName + '-' + vm.saveDraftPayload.euinCode;
                  vm.euinData = vm.euintempData;
                  $timeout(function () {
                    vm.euinData = {};
                    var tData = $filter('filter')(vm.euinList,
                      {
                        euinCode: vm.euintempData.euinCode
                      });
                    vm.euinData = tData[0];
                    if (vm.distributorDetails) {
                      if (!vm.euinData.euinCode) {
                        vm.isCorrectEuin = false;
                      } else {
                        vm.isCorrectEuin = true;
                      }
                    }
                    vm.SelectedEnui = 'EUIN';
                  }, 1000);
                }
                else {
                  vm.SelectedEnui = 'EUIN Declaration';
                  // vm.isCheckedTandC = true;
                }
              }
              else {
                if (vm.saveDraftPayload.riaConsent && vm.saveDraftPayload.riaCode) {
                  if (vm.distributorDetails) {
                    if (vm.distributorDetails.key == "MFD") {
                      vm.SelectedInvestingThrough = 'Distributor';
                    }
                    if (vm.distributorDetails.key == "RIA") {
                      vm.RiaCode = vm.distributorDetails && vm.distributorDetails.key == 'RIA' ? vm.distributorDetails.riaCode : vm.saveDraftPayload.riaCode;
                      vm.SelectedInvestingThrough = 'RIA';
                      getEuinRIA();
                    }
                    if (vm.distributorDetails.key == "E_CODE" && vm.distributorDetails.arn) {
                      vm.SelectedInvestingThrough = 'Distributor';
                    }
                  } else {
                    vm.RiaCode = vm.distributorDetails && vm.distributorDetails.key == 'RIA' ? vm.distributorDetails.riaCode : vm.saveDraftPayload.riaCode;
                    vm.SelectedInvestingThrough = 'RIA';
                    getEuinRIA();
                  }
                } else {
                  if (vm.distributorDetails) {
                    if (vm.distributorDetails.key == "MFD") {
                      vm.SelectedInvestingThrough = 'Distributor';
                    }
                    if (vm.distributorDetails.key == "RIA") {
                      vm.RiaCode = vm.distributorDetails && vm.distributorDetails.key == 'RIA' ? vm.distributorDetails.riaCode : vm.saveDraftPayload.riaCode;
                      vm.SelectedInvestingThrough = 'RIA';
                      getEuinRIA();
                    }
                    if (vm.distributorDetails.key == "E_CODE" && vm.distributorDetails.arn) {
                      vm.SelectedInvestingThrough = 'Distributor';
                    }
                  }
                }
              }
            }
          } else {
            if (vm.saveDraftPayload.brokerCode) {
              if (vm.distributorDetails) {
                if (vm.distributorDetails.key == "MFD") {
                  vm.SelectedInvestingThrough = 'Distributor';
                }
                if (vm.distributorDetails.key == "RIA") {
                  vm.RiaCode = vm.distributorDetails.riaCode;
                  vm.SelectedInvestingThrough = 'RIA';
                  getEuinRIA();
                }
                if (vm.distributorDetails.key == "E_CODE" && vm.distributorDetails.arn) {
                  vm.SelectedInvestingThrough = 'Distributor';
                }
              } else {
                vm.SelectedInvestingThrough = 'Distributor';
              }
              vm.investmentARN = vm.distributorDetails && vm.distributorDetails.arn ? vm.distributorDetails.arn : vm.saveDraftPayload.brokerCode;
              if(vm.PARTNER_DATA){
                vm.investmentARN = vm.PARTNER_DATA.arnCode ? vm.PARTNER_DATA.arnCode : vm.saveDraftPayload.brokerCode ;
              }
              vm.subBrokerARN = vm.distributorDetails && vm.distributorDetails.subBrokerARN ? vm.distributorDetails.subBrokerARN : vm.saveDraftPayload.subBrokerArn;
              vm.subBrokerCode = vm.distributorDetails && vm.distributorDetails.subBrokerCode ?  vm.distributorDetails.subBrokerCode : vm.saveDraftPayload.subBrokerCode;
              if(vm.subBrokerARN){
                fetchEuinListSubBroker();
              }else{
                fetchEuinList();
              }
              if (vm.saveDraftPayload.euinOpted == "Y") {
                vm.euintempData = {};
                if (vm.distributorDetails) {
                  vm.euintempData.euinCode = vm.distributorDetails.euin;
                  if (vm.distributorDetails && vm.distributorDetails.euin) {
                    vm.euintempData.euinCode = vm.distributorDetails.euin;
                  } else {
                    vm.euintempData.euinCode = '';
                  }
                } else {
                  vm.euintempData.euinCode = vm.saveDraftPayload.euinCode;
                  vm.euintempData.euinName = vm.saveDraftPayload.euinName;
                  vm.euintempData.euinNameCode = vm.saveDraftPayload.euinName + '-' + vm.saveDraftPayload.euinCode;
                }
                vm.euinData = vm.euintempData;
                vm.SelectedEnui = 'EUIN';
              }
              else {
                vm.SelectedEnui = 'EUIN Declaration';
                // vm.isCheckedTandC = true;
              }
              if (vm.distributorDetails && vm.distributorDetails.euin) {
                vm.SelectedEnui = 'EUIN';
              } else {
                vm.SelectedEnui = 'EUIN Declaration';
              }
            } else {
              if (vm.saveDraftPayload.riaConsent && vm.saveDraftPayload.riaCode) {
                if (vm.distributorDetails) {
                  if (vm.distributorDetails.key == "MFD") {
                    vm.SelectedInvestingThrough = 'Distributor';
                  }
                  if (vm.distributorDetails.key == "RIA") {
                    vm.RiaCode = vm.distributorDetails && vm.distributorDetails.key == 'RIA' ? vm.distributorDetails.riaCode : vm.saveDraftPayload.riaCode;
                    vm.SelectedInvestingThrough = 'RIA';
                    getEuinRIA();
                  }
                  if (vm.distributorDetails.key == "E_CODE" && vm.distributorDetails.arn) {
                    vm.SelectedInvestingThrough = 'Distributor';
                  }
                } else {
                  vm.RiaCode = vm.distributorDetails && vm.distributorDetails.key == 'RIA' ? vm.distributorDetails.riaCode : vm.saveDraftPayload.riaCode;
                  vm.SelectedInvestingThrough = 'RIA';
                }
              } else {
                if (vm.distributorDetails) {
                  if (vm.distributorDetails.key == "MFD") {
                    vm.SelectedInvestingThrough = 'Distributor';
                  }
                  if (vm.distributorDetails.key == "RIA") {
                    vm.RiaCode = vm.distributorDetails && vm.distributorDetails.key == 'RIA' ? vm.distributorDetails.riaCode : vm.saveDraftPayload.riaCode;
                    vm.SelectedInvestingThrough = 'RIA';
                    getEuinRIA();
                  }
                  if (vm.distributorDetails.key == "E_CODE" && vm.distributorDetails.arn) {
                    vm.SelectedInvestingThrough = 'Distributor';
                  }
                }
              }
            }
          }
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.processFlag = false;
      var Details = JSON.parse(sessionStorage.getItem("userData"));
      var Data = {};
      Data.id = Details.transactionDraftId;
      if(Data && Data.id){
        LoaderService.showLoader('.pan-loader');
        InvestorService.post({
          child1: 'new',
          child2: 'user',
          child3: 'saved',
          child4: 'draft'
        }, Data).$promise.then(success, error);
      } 
    }
    vm.searchDistributorByName = function () {
      if ((!vm.distributorName) || (vm.distributorName && vm.distributorName.length < 3)) {
        vm.distributorList = null;
        vm.investmentEUNIList = null;
        return;
      }
      fetchARNByName();

    };
    function fetchARNByName() {

      if ((!vm.distributorName) || (vm.distributorName && vm.distributorName.length < 3)) {
        return;
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.distributorList = resp.data.distributorList;
          if (vm.distributorList.length == 0) {
            vm.isInvalidForm = true;
            vm.euin = {};
            vm.isCheckedTandC = false;
          }
          vm.formData.brokerName = resp.data.distributorName;
        } else {
          vm.distributorList = null;
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          vm.distributorList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      TransactionService.get({
        controller1: 'getDistributor',
        controller2: vm.distributorName
      }).$promise.then(success, error);
    }

    vm.inSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        if (vm.inSearchSchemeCode !== schemeData.schemeCode) { //block responsible to reset all values if scheme code doesn't match
          vm.formData.startDate = null;
          vm.formData.endDate = null;
          vm.formData.day = '';
          vm.formData.bankInfo = null;
          //vm.formData.frequency = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? vm.frequencyList[0].key : null;
          vm.enabledStartDates = null;
          vm.enabledEndDates = null;
          vm.formData.amount = '';
          vm.formData.sipFirstAmount = '';
          vm.formData.units = '';
          vm.formData.amountType = 'amount';
          vm.formData.isTillPerpetuity = false;
          vm.formData.showTopUpBlock = false;
          vm.formData.sipTopupEnabled = false;
          vm.disableEndDateSelection = false;
          vm.formData.weeklyDay = null;
          vm.backFromPayment = false;
          vm.formData.sipFirstInstallment = false;
          vm.sipFirstInstallment = false;
          resetTopupDetails();
          changeSipTopupSelected(false);
          reSetting();
          resetDefaults();
          resetNumInWords();
        }

        if (!vm.backFromPayment)
          vm.formData.sipDividendOption = null;

        vm.inSearchSchemeCode = schemeData.schemeCode;
        vm.inSearchSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.inSearchSchemeName);
        checkEMandate(function () {
        });
        fetchInSchemeValidations(function () {
          vm.validations.investmentOption = vm.validations.investmentOption;
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            getDateValidation();
            if (schemeData.schemeType === 'NFO') {
              var message = schemeData.message;
              ModalService.nfoEnabledModal({ message: message });
            }
            checkEMandate();
          }
          if (vm.checkForMinorBankListCondition()) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            if (vm.isOTMEnabled) {
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
            }
            else {
              vm.formData.sipPaymentOption = null;
            }
            getDetails();
          }
          else if (vm.isOTMEnabled || !vm.checkForMinorBankListCondition()) {
            if (vm.formData.frequency === 'BZ' || vm.formData.frequency === 'OW')
              if (vm.isOTMEnabled) vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
              else vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            else
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            if (!vm.formData.sipPaymentOption) {
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
            }
            checkEMandate();
          }
          else {
            vm.formData.sipPaymentOption = null;
            vm.paymentOptions = [];
          }
          checkValidations();
          if (vm.formData.bankInfo) {
            vm.changeBank();
            updateEndDates();
            vm.changeEndDate(vm.formData.endDate);
          }
        });
      }
      NetcoreEvntService.Complete_Selected_Scheme_SIP_IP(vm.formData);
    };

    vm.next = function () {
      switch (vm.SelectedInvestingThrough) {
        case 'Distributor':
          if (!vm.searchARN) {
            vm.saveDraftPayload.brokerCode = vm.investmentARN;
          } else {
            vm.saveDraftPayload.brokerCode = vm.distributorARN;
          }
          vm.saveDraftPayload.subBrokerCode = vm.subBrokerCode;
          vm.saveDraftPayload.subBrokerArn = vm.subBrokerARN;
          if (vm.SelectedEnui == 'EUIN') {
            vm.saveDraftPayload.euinCode = vm.euinData.euinCode;
            vm.saveDraftPayload.euinName = vm.euinData.euinName;
            vm.saveDraftPayload.euinNameCode = vm.euinData.euinNameCode;
            vm.saveDraftPayload.euinOpted = "Y";
          } else {
            vm.saveDraftPayload.euinOpted = "N";
          }
          delete vm.saveDraftPayload.riaConsent;
          delete vm.saveDraftPayload.riaCode;
          break;
        case 'Self':
          delete vm.saveDraftPayload.brokerCode;
          delete vm.saveDraftPayload.subBrokerCode;
          delete vm.saveDraftPayload.subBrokerArn;
          delete vm.saveDraftPayload.euinCode;
          delete vm.saveDraftPayload.euinName;
          delete vm.saveDraftPayload.euinOpted;
          delete vm.saveDraftPayload.riaConsent;
          delete vm.saveDraftPayload.riaCode;
          break;
        case 'RIA':
          vm.saveDraftPayload.riaConsent = true;
          vm.saveDraftPayload.riaCode = vm.RiaCode;
          delete vm.saveDraftPayload.brokerCode;
          delete vm.saveDraftPayload.subBrokerCode;
          delete vm.saveDraftPayload.subBrokerArn;
          delete vm.saveDraftPayload.euinCode;
          delete vm.saveDraftPayload.euinName;
          delete vm.saveDraftPayload.euinOpted;
          break;
      }
      var Details = JSON.parse(sessionStorage.getItem("userData"));
      vm.saveDraftPayload.investmentType = vm.SelectedInvestmentType;
      vm.saveDraftPayload.id = Details.transactionDraftId;
      vm.saveDraftPayload.step = "SECOND";
      var success = function (resp) {
        if (resp.data && resp.status) {
          var data = resp.data;
          $rootScope.stepperSecondary.steps[0].stepActive = false;
          $rootScope.stepperSecondary.steps[0].stepCompleted = true;
          $rootScope.stepperSecondary.steps[1].stepActive = false;
          $rootScope.stepperSecondary.steps[1].stepCompleted = true;
          $rootScope.stepperSecondary.steps[2].stepActive = true;
          $state.go('newInvestor.investmentDetails.amountdetails');
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.processFlag = false;
      LoaderService.showLoader('.pan-loader');
      InvestorService.post({
        child1: 'new',
        child2: 'user',
        child3: 'save',
        child4: 'transaction'
      }, vm.saveDraftPayload).$promise.then(success, error);
    }
    vm.distributorListChanged = function (data) {
      if (!data) {
        // vm.isArnSuccess = true;
        return;
      } else {
        vm.brokerCodeError = '';
        vm.distributorARN = data.arnCode;
        vm.distributorName = data.name + ' - ' + data.arnCode;
      }
    };
    function fetchEuinList() {
      if (!vm.investmentARN || (vm.investmentARN && vm.investmentARN.length < 3)) {
        return;
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.brokerCodeError = '';
          vm.isArnSuccess = false;
          vm.brokerName = resp.data.distributorName;
          vm.euinList = resp.data.euinList;
          vm.euinMasterList = resp.data.euinList;
          vm.euinData = vm.euin ? vm.euin : {};
          // vm.formData.brokerName = resp.data.distributorName;
          if(vm.euinList){
            var td = $filter('filter')(vm.euinList,
              {
                euinCode: vm.euintempData.euinCode
              });
            vm.euinData = {};
            if (vm.distributorDetails) {
              if (vm.distributorDetails && vm.distributorDetails.euin) {
                vm.euinData = td[0];
              } else {
                vm.euinData = {};
              }
            } else {
              vm.euinData = {};
            }
            if (vm.distributorDetails) {
              if (!vm.euinData.euinCode) {
                vm.isCorrectEuin = false;
              } else {
                vm.isCorrectEuin = true;
              }
            }
          }
          //vm.isInvalidForm = false;
        } else {
          vm.brokerCodeError = resp.message;
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          vm.investmentEUNIList = null;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      var path = {};
      path = {
        controller1: 'getEuin',
        controller2: 'ARN-' + vm.investmentARN
      };
      TransactionService.get(path).$promise.then(success, error);
    }
    vm.filterEuinList = function () {
      vm.euin = {};
      if (vm.euinData.euinNameCode) {
        if (vm.euinData.euinNameCode.length >= 3) {
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.euinData.euinNameCode);
        }
      }
      vm.euinList = vm.euinData.euinNameCode == '' || vm.euinData.euinNameCode == undefined || vm.euinData.euinNameCode.length < 3 ? vm.euinMasterList : vm.euinList;
    };
    vm.selectEuin = function (data) {
      if (!data) {
        vm.euinDesable = false;
        return;
      }
      vm.euinData = {};
      vm.euinData.euinNameCode = data.euinNameCode;
      vm.euinData.euinCode = data.euinCode;
      vm.euinData.euinName = data.euinName;
      vm.isSelectedEuin = vm.euinData.euinNameCode ? true : false;
    }

    function fetchEuinListSubBroker() {
      if (!vm.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        vm.euinData = {};
        vm.brokerProcess = false;
        vm.subBrokerCode = "";
        fetchEuinList();
        return;
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.brokerProcess = false;
          vm.euinMasterList = resp.data.euinList;
          vm.investmentEUNIList = resp.data.euinList;
          vm.euinList = vm.euinMasterList;
          if (vm.euinData) {
            for (var i = 0; i < vm.euinList.length; i++) {
              if (vm.euinData.euinNameCode === vm.euinList[i].euinNameCode) {
                vm.euin = vm.euinList[i];
                break;
              } else {
                vm.euin = {};
              }
            }
          } else {
            vm.euin = {};
          }
          vm.euinData = vm.euin;
          vm.subBrokerName = resp.data.distributorName;
          vm.subBrokerCodeError = '';
          vm.isSubarnSuccess = false;
        } else {
          vm.euinList = null;
          vm.subBrokerCodeError = resp.message;
          vm.isSubarnSuccess = true;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: 'ARN-' + vm.subBrokerARN,
        isSubBroker: true
      }).$promise.then(success, error);
    }
    vm.brokerProcess = false;
    vm.changeSubBrokerArn = function () {
      vm.isCheckedTandC = false;
      vm.subBrokerName = '';
    }
    vm.checksubbrokercode = function () {
      // if (vm.subBrokerCode) {
      //   vm.brokerProcess = false;
      // } else {
      //   vm.brokerProcess = true;
      // }
    }
    vm.changeinvestmentARN = function () {
      vm.isCheckedTandC = false;
      vm.brokerName = '';
    }
    vm.riaProcced = false;
    function getEuinRIA() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.riaProcced = true;
          vm.euinMasterList = resp.data.euinList;
        } else {
          vm.euinList = null;
          MessageService.error(resp.message);
          vm.RiaCode = "";
          vm.riaProcced = false;
        }
      },
        error = function () {
          vm.riaProcced = false;
          LoaderService.hideLoader();
          vm.euinList = null;
          vm.RiaCode = "";
        };
      var path = {
        child1: 'getEuin',
        child2: vm.RiaCode,
        riaOpted: true
      };
      IIHttpService.get(path).$promise.then(success, error);
    }
    function getValidationForSipPurchase() {
      var success = function (resp) {
        vm.schemeCode = vm.saveDraftPayload.schemeCode;
        vm.schemeList = resp.data;
        vm.selectedschemeCategoryDetails = [];
        if (vm.schemeCode && vm.schemeList) {
          vm.schemeList.forEach(function (item2) {
            item2.funds.forEach(function (item3) {

              if (item3.regularSchemes) {
                try {
                  item3.regularSchemes.forEach(function (item4) {
                    if (item4.schemeCode == vm.schemeCode) {
                      item3.selectedScheme = item4;
                      vm.selectedschemeCategoryDetails.push(item3);
                      vm.selectedschemeCategory = item2.type;
                      if (!vm.investmentValidation) {
                        vm.investmentValidation = {};
                        vm.investmentValidation.purchaseEnabled = item4.purchaseEnabled;
                        vm.investmentValidation.sipEnabled = item4.sipEnabled;
                        vm.investmentValidation.directSchemes = false;
                        sessionStorage.setItem("investmentModeValidation", JSON.stringify(vm.investmentValidation));
                      }

                      throw 'Break';
                    }
                  })

                } catch (e) {
                }
              }

              if (item3.directSchemes) {
                try {
                  item3.directSchemes.forEach(function (item4) {

                    if (item4.schemeCode == vm.schemeCode) {
                      item3.selectedScheme = item4;
                      if (!vm.investmentValidation) {
                        vm.investmentValidation = {};
                        vm.investmentValidation.purchaseEnabled = item4.purchaseEnabled;
                        vm.investmentValidation.sipEnabled = item4.sipEnabled;
                        vm.investmentValidation.directSchemes = true;
                        sessionStorage.setItem("investmentModeValidation", JSON.stringify(vm.investmentValidation));
                      }
                      vm.selectedschemeCategoryDetails.push(item3);
                      vm.selectedschemeCategory = item2.type;
                      throw 'Break';
                    }
                  })

                } catch (e) {
                }
              }

            })
          })
        }

      },
        error = function (err) {

        };
      InvestorService.get({ child1: 'new', child2: 'user', child3: 'fund', child4: 'category' }).$promise.then(success, error);
    }

    vm.getDisclaimer = function () {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.dynamicData = resp.data;
            if(vm.dynamicData && vm.dynamicData.termAndConditionDTO && vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap && vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_Quick_Investment_HDFCBankOneClick){
              vm.hdfcOneClickDisclaimerNote = vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_Quick_Investment_HDFCBankOneClick.content;
            }
          } else {
              MessageService.error(resp.message);
          }
      }, error = function (err) {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
      };
      InvestorService.post({
          child1: 'dynamicContent',
      }, {"pageName": "QUICK_INVESTMENT","hdfcOneClick": true}).$promise.then(success, error);
    }
    if(vm.distributorDetails && vm.distributorDetails.isHdfcBank){
      vm.getDisclaimer();
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AmountDetailsController', AmountDetailsController);

  /** @ngInject */
  function AmountDetailsController($window, UtilService,InvestorService, $state, IIHttpService, TransactionModel, $timeout, $rootScope, $stateParams,HDFC_API, LoaderService,AppConstants, MessageService,$compile,$scope, ModalService,investorServiceVersion,DynamicDataSip) {
    var vm = this;
    vm.stage = 0;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    vm.transactionType = getTransactionTypeFromStateParams() || getTransactionType();
    vm.formData = TransactionModel.getPayloadRawData() || TransactionModel.getMasterRawData(vm.transactionType);
    vm.formData.showTopUpBlock = false;
    vm.formData.amountArray = [5000,10000,15000];
    vm.isReseting = false;
    vm.init = init;
    vm.newAmountInWords = '';
    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
    vm.ispurchseMinAmount = false;
    vm.purchseSchemeValidationData = {};
    vm.PaymentModePurchse = false;
    vm.capAmountChanged = capAmountChanged;
    vm.changeSipTopupSelected = changeSipTopupSelected;
    vm.getTopupFrequencyList = getTopupFrequencyList;
    vm.changeBank = changeBank;
    vm.selectedUpiBank = selectedUpiBank;
    vm.getAccountType = getAccountType;
    vm.resetUPIForm = resetUPIForm;
    vm.verifyUPI = verifyUPI;
    vm.PATTERN = AppConstants;
    vm.sipFirstInstallment = false;
    vm.saveDraftPayload = {};
    $rootScope.currentstate = $state.current.url;
    $rootScope.setUsetInfo();
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.viewMode = 'days';
    vm.dividenInevstmentOption = "Y";
    vm.changeTopUpFreq = changeTopUpFreq;
    vm.checkSipValidations = checkSipValidations;
    vm.checkPurchseAmountValidations = checkPurchseAmountValidations;
    // vm.extractValidationObject = extractValidationObject;
    vm.inSchemeValidations = null;
    vm.extractValidationObject = extractValidationObject;
    vm.frequency = vm.TRANSACTIONS_CONST.NEW_INVESTOR_JOURNY;
    vm.updateEndDates = updateEndDates;
    vm.changedPaymentOption = changedPaymentOption;
    vm.changeFrequency = changeFrequency;
    vm.enabledStartDates = null;
    vm.SelectedFrequency = null;
    vm.paymentvalidBank = true;
    vm.upiPaymentvalidBank = true;
    vm.isUPIVerified = false;
    vm.validations = {};
    vm.showTopUpPercentage = AppConstants.SET_TOP_UP_PERCENTAGE_VIEW;
    vm.dynamicNoteSip = DynamicDataSip;
    vm.TRANSACTIONS_CONST.DESCRIPTIONS['UPI'] = 'UPI Autopay';
    vm.handleVpa = handleVpa;

    function getTransactionTypeFromStateParams() {
      return $stateParams.transactionType;
    }
    function resetTopupDetails() {
      vm.formData.topupDetails = {};
    }
    function capAmountChanged() {
      vm.amountInWords = '';
      if (vm.formData.topupDetails.amount) {
        vm.minCapAmount = vm.formData.amount + vm.formData.topupDetails.amount;
      }
      else if (vm.formData.topupDetails.percentage) {
        vm.minCapAmount = vm.formData.amount + (vm.formData.topupDetails.percentage * vm.formData.amount / 100)
      }

      if (vm.formData.topupDetails.capAmount && (vm.formData.topupDetails.capAmount < vm.minCapAmount)) {
        vm.isminCapAmount = true
      }
      else {
        vm.isminCapAmount = false
      }
    }
    function changeSipTopupSelected(isChecked) {
      if (!$("#sipToptup").is(':checked')) {
        resetTopupDetails();
      }
      if (!vm.formData.isBackFromSummary) {
        vm.formData.sipTopupSelected = isChecked;
      }
      if (vm.formData.sipPaymentOption === 'OTM' && ((vm.formData.bankInfo && vm.formData.bankInfo.otmFrequency) !== 'AWP')) {
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        MessageService.error(vm.VALIDATE_DATA.OTM_VALIDATION_ERROR);
      }
      else if (vm.formData.bankInfo && vm.isOTMAmount) {
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        MessageService.error(vm.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR);
      }
      getTopupFrequencyList();
    }
   $(function(){
    $('#selectbank option:selected').text('Select bank');
   })

    function init(cb) {
      vm.formData.sipPaymentOption = 'UPI';
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[1].stepCompleted = true;
      $rootScope.testObj.steps[2].stepCompleted = false;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepActive = false;
      $rootScope.testObj.steps[2].stepActive = true;
      LoaderService.showLoader();
      vm.userData = JSON.parse(sessionStorage.getItem("verifyObj"));
      vm.nriFlag = vm.userData ? !vm.userData.taxStatusResident : null
      var Details = JSON.parse(sessionStorage.getItem("userData"));
      vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
      if (vm.distributorDetails && vm.distributorDetails.sipStartDate && vm.distributorDetails.sipEndDate && vm.distributorDetails.frequency) {
        vm.savedDateSet = true;
        vm.savedDate = angular.copy(vm.distributorDetails.sipStartDate);
        vm.savedEndDate = angular.copy(vm.distributorDetails.sipEndDate);
        vm.savedFrequency = angular.copy(vm.distributorDetails.frequency);
      }
      var Data = {};
      Data.id = Details.transactionDraftId;
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.saveDraftPayload = resp.data;
          vm.bankCode = resp.data.bankCode ? resp.data.bankCode : '';
          vm.formData.minorFlag = resp.data.minorFlag;
          $rootScope.testObj.steps[1].schemeName = resp.data.fundName;
          $rootScope.testObj.steps[1].schemeName = resp.data.fundName;
          switch(resp.data.installmentFrequency){
            case'OM':
               $rootScope.testObj.steps[1].frequency = "Monthly";
               break;
            case 'Q':
              $rootScope.testObj.steps[1].frequency = "Quarterly";
              break;
              case'H':
               $rootScope.testObj.steps[1].frequency = "Half Yearly";
               break;
            case 'Y':
              $rootScope.testObj.steps[1].frequency = "Yearly";
              break;
          }
          $rootScope.testObj.steps[1].schemeInfo.investmentType = resp.data.investmentType;

          vm.formData.inSchemeCode = vm.saveDraftPayload.schemeCode;
          vm.sipFirstInstallment = vm.saveDraftPayload.sipFI;
          if (vm.sipFirstInstallment) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
          }
          if(vm.distributorDetails){
            vm.formData.amount = vm.distributorDetails.amount ? vm.distributorDetails.amount : vm.saveDraftPayload.amount;
            if(vm.distributorDetails.isHdfcBank){
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            }
          }else{
            vm.formData.amount = vm.saveDraftPayload.amount;
          }
          // vm.formData.bankInfo = {};
          // vm.formData.bankInfo.netBankingUrl = vm.saveDraftPayload.netBankingUrl;
          // vm.formData.bankInfo.bankName = vm.saveDraftPayload.bankName;
          // vm.formData.bankInfo.bankCode = vm.saveDraftPayload.bankCode;
          vm.frequency.forEach(function (value) {
            if(vm.distributorDetails && vm.distributorDetails.transactionType == 'SIP'){
              if(vm.distributorDetails.frequency == "BZ" || vm.distributorDetails.frequency == "OW"){
                if (value.code == vm.saveDraftPayload.installmentFrequency) {
                  vm.SelectedFrequency = value;
                }
              }else{
                if (value.code == vm.distributorDetails.frequency) {
                  vm.SelectedFrequency = value;
                }
              }
            }else{
              if (value.code == vm.saveDraftPayload.installmentFrequency) {
                vm.SelectedFrequency = value;
              }
            }
          });
          if (vm.saveDraftPayload.topUpEnable) {
            vm.formData.sipTopupSelected = true;
            vm.formData.sipTopupEnabled = true;
            if (vm.saveDraftPayload.topUpDetails.amount) {
              vm.formData.topupDetails.amount = vm.saveDraftPayload.topUpDetails.amount;
              delete vm.saveDraftPayload.topUpDetails.percentage;
            } else {
              vm.formData.topupDetails.percentage = vm.saveDraftPayload.topUpDetails.percentage;
              delete vm.saveDraftPayload.topUpDetails.amount;
            }
            if (vm.saveDraftPayload.topUpDetails.capAmount) {
              vm.formData.topupDetails.capAmount = vm.saveDraftPayload.topUpDetails.capAmount;
              delete vm.saveDraftPayload.topUpDetails.capMonthYear;
            } else {
              var d = vm.saveDraftPayload.topUpDetails.capMonthYear.split("-");
              vm.formData.topupDetails.capMonthYear = d[1]+"-"+d[2];
              delete vm.saveDraftPayload.topUpDetails.capAmount;
            }
            // vm.saveDraftPayload.topUpDetails.diffInMonths = vm.formData.topupDetails.diffInMonths;
            vm.formData.topupDetails.frequency = vm.saveDraftPayload.topUpDetails.frequency;
          }
          vm.dividenInevstmentOption = vm.saveDraftPayload.dividendOption;
          if(vm.saveDraftPayload && vm.saveDraftPayload.investmentOption && vm.saveDraftPayload.investmentOption.toUpperCase() != 'GROWTH'){
            if(!vm.saveDraftPayload.dividenInevstmentOption){
              vm.dividenInevstmentOption = 'Y';
            }
          }
          vm.formData.investmentOption = vm.saveDraftPayload.investmentOption;
          $rootScope.stepperSecondary.steps[0].stepActive = false;
          $rootScope.stepperSecondary.steps[0].stepCompleted = true;
          $rootScope.stepperSecondary.steps[1].stepActive = false;
          $rootScope.stepperSecondary.steps[1].stepCompleted = true;
          $rootScope.stepperSecondary.steps[2].stepActive = true;
          if(vm.saveDraftPayload && vm.saveDraftPayload.investmentType == "SIP"){
            if(vm.saveDraftPayload.paymentOption == 'UAP'){
              vm.formData.sipPaymentOption = 'UPI';
              fetchBankList();
              getAccountType();
            }else if(vm.saveDraftPayload.paymentOption == 'HEM'){
              vm.formData.sipPaymentOption = 'E-mandate';
              fetchBankList();
            }else{
              if(vm.saveDraftPayload.paymentOption == 'EC'){
                vm.formData.sipPaymentOption = 'EC';
              } else {
                vm.formData.sipPaymentOption = vm.paymentOptions ? vm.paymentOptions[0] : 'EC';
              }
            }
            if(vm.distributorDetails){
              if(vm.distributorDetails.transactionType == "SIP"){
                if(vm.distributorDetails.sipStartDate){
                  vm.formData.startDate = moment(vm.distributorDetails.sipStartDate, "DD-MMM-YYYY");
                  vm.formData.endDate = moment(vm.distributorDetails.sipEndDate, "DD-MMM-YYYY");
                }else{
                  vm.formData.startDate = moment(vm.saveDraftPayload.installmentStartDate, "DD-MMM-YYYY");
                  vm.formData.endDate =  moment(vm.saveDraftPayload.installmentEndDate, "DD-MMM-YYYY");
                }
              }
            }else{
              vm.formData.startDate = moment(vm.saveDraftPayload.installmentStartDate, "DD-MMM-YYYY");
              vm.formData.endDate =  moment(vm.saveDraftPayload.installmentEndDate, "DD-MMM-YYYY");
            }

            vm.savedDate = vm.savedDate ? vm.savedDate :angular.copy(vm.saveDraftPayload.installmentStartDate);
            vm.savedEndDate = vm.savedEndDate ? vm.savedEndDate : angular.copy(vm.saveDraftPayload.installmentEndDate);
            vm.savedFrequency = vm.savedFrequency ? vm.savedFrequency : angular.copy(vm.saveDraftPayload.installmentFrequency);

            if (vm.savedDate && vm.savedEndDate) {
              vm.savedDateSet = true;
            }
          }


          LoaderService.hideLoader();
          if (vm.saveDraftPayload.investmentType && vm.saveDraftPayload.investmentType.toUpperCase() == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
            vm.PaymentModePurchse = true;
            vm.getPurchseSchemeValidationData();
          } else {
            vm.PaymentModePurchse = false;
            vm.getSchemValidationData();
          }
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.processFlag = false;
      InvestorService.post({
        child1: 'new',
        child2: 'user',
        child3: 'saved',
        child4: 'draft'
      }, Data).$promise.then(success, error);

    }


    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.paymentNavUrl = function(){
      $window.open(vm.paymentNavURL);
    }


    // vm.autoDate1 = function(){
    //   vm.dobString = $("#startDate").val();;
    //   if( vm.dobString.length == 2){
    //       $("#startDate").val(vm.dobString+"-");
    //   }
    //   if( vm.dobString.length == 5){
    //       $("#startDate").val(vm.dobString+"-");
    //   }
    // }
    // vm.autoDate2 = function(){
    //   vm.dobString = $("#endDate").val();;
    //   if( vm.dobString.length == 2){
    //       $("#endDate").val(vm.dobString+"-");
    //   }
    //   if( vm.dobString.length == 5){
    //       $("#endDate").val(vm.dobString+"-");
    //   }
    // }




    function changeTopUpFreq() {
      var duration = 6;
      switch (vm.formData.topupDetails.frequency) {
        case 'H': duration = 6; break;
        case 'Y': duration = 12; break;
      }
      if (duration === 12) {
        var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
      }
      else {
        capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
      }

      vm.capDates = [];
      var capLastDate = capStartDate;
      while ($window.moment(capLastDate, "MMM-YYYY").isSameOrBefore($window.moment(vm.formData.endDate, "MMM-YYYY"))) {
        if (vm.capDates.length === 0) {
          vm.capDates.push(capStartDate);
        }
        capStartDate = $window.moment(capStartDate, "MMM-YYYY").add(duration, 'months').format("MMM-YYYY");
        if ($window.moment(capStartDate, "MMM-YYYY").isSameOrBefore($window.moment(vm.formData.endDate, "MMM-YYYY"))) {
          vm.capDates.push(capStartDate);
        }
        else {
          break;
        }
        capLastDate = vm.capDates[vm.capDates.length - 1];
      }
    };
    vm.getAmount = function (condition,amountValue) {
      if(condition){
        vm.formData.amount = amountValue;
      }else{
        vm.formData.amount = amountValue;
        vm.checkSipValidations();
      }
    }
    vm.getPurchseSchemeValidationData = function () {
      if (!vm.formData.inSchemeCode) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          // if (!vm.formData.amount) {
          //   vm.formData.amount = resp.data.amountArray[0];
          // }else{
          //   vm.formData.amount = vm.formData.amount;
          // }
          // vm.formData.amountArray = resp.data.amountArray;

          vm.purchseSchemeValidationData = resp.data;
          LoaderService.hideLoader();
        }
        else {
          LoaderService.hideLoader();
          vm.inSchemeValidations = null;
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      InvestorService.post({
        child1: 'schemeValidation',
        child2: 'purchase'
      }, { "schemeCode": vm.formData.inSchemeCode }).$promise.then(success, error);
    }
    function getTopupFrequencyList() {

      if ((vm.diffInMonths >= 6 && vm.diffInMonths <= 12) || (vm.formData.topupDetails.diffInMonths >= 6 && vm.formData.topupDetails.diffInMonths <= 12)) {
        vm.topupFrequencyList = [
          { key: 'H', value: 'Half Yearly', monthfreq: 6 }
        ];
      } else {
        vm.topupFrequencyList = [
          { key: 'Y', value: 'Yearly', monthfreq: 12 },
          { key: 'H', value: 'Half Yearly', monthfreq: 6 }
        ];
      }
      vm.formData.topupDetails.frequency = vm.formData.isBackFromSummary ? vm.formData.topupDetails.frequency : null;
      if (vm.formData.topupDetails.percentage) {
        vm.topupFrequencyList = [
          { key: 'Y', value: 'Yearly', monthfreq: 12 }
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      } else if (vm.formData.frequency == 'Q' && !vm.formData.topupDetails.percentage) {
        vm.topupFrequencyList = [
          { key: 'Y', value: 'Yearly', monthfreq: 12 }
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      } else if (vm.formData.frequency == 'OM') {
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      }
      else {
        vm.topupFrequencyList = [
          { key: 'Y', value: 'Yearly', monthfreq: 12 },
          { key: 'H', value: 'Half Yearly', monthfreq: 6 }
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      }

      if (vm.diffInMonths < 12 || vm.formData.topupDetails.diffInMonths < 12) {
        vm.topupFrequencyList = [
          { key: 'H', value: 'Half Yearly', monthfreq: 6 }
        ];
        vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;

        vm.hideTopupPercentage = true;
      }
      else if ((vm.diffInMonths >= 12 && vm.formData.frequency !== 'Q') || (vm.formData.topupDetails.diffInMonths >= 12 && vm.formData.frequency !== 'Q')) {
        vm.hideTopupPercentage = false;
        if (vm.formData.topupDetails.percentage) {
          vm.topupFrequencyList = [
            { key: 'Y', value: 'Yearly', monthfreq: 12 }
          ];
          if (vm.formData.sipTopupSelected) {
            changeTopUpFreq();
          }
        } else {
          vm.topupFrequencyList = [
            { key: 'Y', value: 'Yearly', monthfreq: 12 },
            { key: 'H', value: 'Half Yearly', monthfreq: 6 }
          ];
          if (vm.formData.sipTopupSelected) {
            changeTopUpFreq();
          }
        }

      }

    }
    vm.getSchemValidationData = function (cb) {
      cb = cb || function () {
      };
      if (!vm.formData.inSchemeCode) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.inSchemeValidations = resp.data;
          if (!vm.formData.amount) {
            if(vm.distributorDetails){
              vm.formData.amount = vm.distributorDetails.amount;
            }else{
              vm.formData.amount = vm.inSchemeValidations.amountArray[0];
            }
          }else{
            if(vm.distributorDetails){
              vm.formData.amount = vm.distributorDetails.amount;
            }else{
              vm.formData.amount = vm.formData.amount;
            }
          }
          if (!vm.SelectedFrequency) {
            vm.SelectedFrequency = vm.frequency[0];
          }
          vm.formData.amountArray = vm.inSchemeValidations.amountArray;
          vm.formData.sipDefaultAmount = vm.inSchemeValidations.sipDefaultAmount;
          vm.formData.frequency = vm.SelectedFrequency.code;
          vm.additionalSipData = vm.inSchemeValidations.additionalValidation;
          // vm.formData.sipPaymentOption = 'EC';

          getDateValidation();
          extractValidationObject(vm.inSchemeValidations);
          fetchBankList();
          vm.upiErrorMessage = resp.data.upiMaxAmountErrMessage;
          vm.upiMaxAmountLimit =  resp.data.upiMaxAmountLimit;
          LoaderService.hideLoader();
        }
        else {

          LoaderService.hideLoader();
          cb('error');
          vm.inSchemeValidations = null;
          MessageService.error(resp.message);
        }
        // checkValidations();
      },
        error = function (err) {
          LoaderService.hideLoader();
          cb('error');
          vm.inSchemeValidations = null;
          vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          UtilService.errorHandler(err);
        };
      IIHttpService.get({
        child1: 'schemeValidation',
        child2: 'sip',
        child3: vm.formData.inSchemeCode
      }, null).$promise.then(success, error);
    }
    function getTransactionType() {
      var transactionType = '';
      switch ($state.current.name) {
        case 'newInvestor.investmentDetails.amountdetails':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP;
          break;
        default:
          $state.go('welcome');
          break;
      }
      return transactionType;
    }
    vm.changeTillPerpetuityFlag = function (cb) {
      cb = cb || function () {
      };
      vm.resetting = true;
      $timeout(function () {
        vm.resetting = false;
        if (vm.formData.isTillPerpetuity) {
          var defaultMonths = null;
          var day = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
          var month = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month() + 1;
          var defaultEndate = day + '/'+ month +'/2099';
          var endDate = $window.moment(defaultEndate,"DD-MM-YYYY");
          var freq = vm.validations && vm.validations.maxInstallments || 0;
          var frequency = vm.frequency.find(function (f) {
            return f.code === vm.formData.frequency;
          }) || {};

          switch (vm.formData.frequency) {
            case 'BZ':
              var day = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
              var endDateYear = $window.moment((vm.enabledEndDates[vm.enabledEndDates.length - 1]), "DD-MMM-YYYY").year();
              if (endDateYear > 2099) {
                endDateYear = 2099
              }
              defaultEndate = month + '/' + day + '/' + endDateYear;
              endDate = $window.moment(new Date(defaultEndate));
              vm.formData.endDate = endDate;

              //check end date exists between enabled end dates
              var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
              if (!isBetween) {
                if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1 < $window.moment(vm.enabledEndDates[0], 'DD-MMM-YYYY').month() + 1) {
                  vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
                } else {
                  endDateYear = endDateYear - 1;
                  if (endDateYear < $window.moment((vm.enabledEndDates[0]), "DD-MMM-YYYY").year()) {
                    vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
                  } else {
                    defaultEndate = month + '/' + day + '/' + endDateYear;
                    endDate = $window.moment(new Date(defaultEndate));
                    vm.formData.endDate = endDate;
                  }
                }
              }
              break;
            case 'OW':
              // var days = 0;
              defaultEndate = month + '/31' + '/2099';
              endDate = new Date(defaultEndate);
              var startDate = vm.formData.startDate.toDate();
              var weeksDiff = UtilService.getNumberOfWeeks(startDate, endDate);
              vm.formData.endDate = vm.formData.startDate.clone().add(weeksDiff * 7, 'days');
              break;
            default :

              var endday = moment().date();
              var endmonth = moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
              var endnewEndDate = endday + '/'+ (endmonth + 1) +'/2099';
              var endDate = $window.moment(endnewEndDate, "DD-MM-YYYY");

              if (!moment(endDate).isValid()) {
                var initialStartDate = vm.formData.startDate.clone().day(1)
                endDate = initialStartDate.endOf(endmonth + 1).year(2099);
              }

              // var months = 0;
              defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate.clone().add(frequency, 'months'), $window.moment(endDate));
              freq = freq || Math.floor(defaultMonths / frequency.duration);
              freq = vm.validations && vm.validations.maxInstallments ? freq - 1 : freq;
              var months = frequency.duration * freq;
              vm.formData.endDate = vm.formData.startDate.clone().add(months, 'months');

              var calculatedEndDateMonth = moment(vm.formData.endDate, 'DD-MMM-YYYY').month();

              if(calculatedEndDateMonth > (month - 1)) {
                var endDateCalculated = angular.copy(vm.formData.endDate);
                var checkDate = angular.copy(endDateCalculated.set('month', (month - 1)));

                var DateisBetween = $window.moment(checkDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))
                if (DateisBetween) {
                  vm.formData.endDate = checkDate;
                }

              }
              break;
          }

          if (vm.validations && vm.validations.maxInstallments  && vm.formData.frequency !== 'OW') {
            var lastEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
            var EndDatemonth = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').month() + 1);
            var EndDateYear = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').year());

            var EndDateCalculatedMonth = angular.copy(moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1);
            var EndDateCalculatedYear = angular.copy(moment(vm.formData.endDate, 'DD-MMM-YYYY').year());

            if (EndDateCalculatedYear <= EndDateYear) {
              if (EndDatemonth < EndDateCalculatedMonth) {
                if (moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                  EndDateYear = EndDateYear - 1;
                  var newEndDate = day + '/'+ month +'/' + EndDateYear;
                  vm.formData.endDate = $window.moment(newEndDate, "DD-MM-YYYY");
                }
                var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                if (!isBetween) {
                  vm.formData.endDate = angular.copy(lastEndDate);
                }
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              } else if (EndDatemonth === EndDateCalculatedMonth) {
                if (moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                  EndDateYear = EndDateYear - 1;
                  var newEndDate = day + '/'+ month +'/' + EndDateYear;
                  vm.formData.endDate = $window.moment(newEndDate, "DD-MM-YYYY");
                }
                var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                if (!isBetween) {
                  vm.formData.endDate = angular.copy(lastEndDate);
                }
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              } else {
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              }
            } else if ((EndDateCalculatedYear > EndDateYear)) {
              if (EndDateCalculatedYear <= 2099) {
                vm.formData.endDate.set('year', EndDateYear);
              } else {
                vm.formData.endDate.set('year', 2099);
              }

            }
          }
          vm.endDateDefaultForPertuity = angular.copy(vm.formData.endDate);
          vm.changeEndDate(vm.formData.endDate);
          cb(true);
        } else {
          if(vm.formData.sipPaymentOption != 'E-mandate'){
            vm.formData.endDate = null;
          }
          vm.disableEndDateSelection = false;
          /*vm.formData.startDate && updateEndDates();*/
        }
      }, 0);
    };

    vm.changeEndDate = function (date) {
      if (date && vm.endDateDefaultForPertuity) {
        if(vm.endDateDefaultForPertuity.isSame($window.moment(date))){
          vm.formData.isTillPerpetuity = true;
        } else {
          vm.formData.isTillPerpetuity = false;
        }
      }
      vm.formData.sipTopupSelected = vm.formData.sipTopupSelected ? vm.formData.sipTopupSelected : false;
      vm.formData.sipTopupEnabled = vm.formData.sipTopupEnabled ? vm.formData.sipTopupEnabled : false;
      vm.formData.endDate = date ? date : null;
      vm.diffInMonths = parseInt($window.moment(vm.formData.endDate).diff($window.moment(vm.formData.startDate), 'months', true));
      vm.formData.topupDetails.diffInMonths = vm.diffInMonths;
      if (vm.formData.sipPaymentOption != vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
        if (!vm.diffInMonths ? false : vm.diffInMonths >= 6 && 'BZ' !== vm.formData.frequency && 'OW' !== vm.formData.frequency && 'H' !== vm.formData.frequency && 'Y' !== vm.formData.frequency) {
          vm.formData.showTopUpBlock = true;
          if (vm.diffInMonths >= 12) {
            var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
            // var capStartDateValue = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
          }
          else {
            capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
            // capStartDateValue = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
            if (vm.formData.frequency === 'Q') {
              vm.formData.showTopUpBlock = false;
              vm.formData.sipTopupSelected = false;
              vm.formData.sipTopupEnabled = false;
            }
          }

          vm.capDates = [];
          var capLastDate = capStartDate;
          while ($window.moment(capLastDate, "MMM-YYYY").isBefore($window.moment(vm.formData.endDate, "MMM-YYYY"))) {
            if (vm.capDates.length === 0) {
              vm.capDates.push(capStartDate);
            }
            // capStartDateValue = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
            capStartDate = $window.moment(capStartDate, "MMM-YYYY").add(12, 'months').format("MMM-YYYY");
            if ($window.moment(capStartDate, "MMM-YYYY").isBefore($window.moment(vm.formData.endDate, "MMM-YYYY"))) {
              vm.capDates.push(capStartDate);
            }
            else {
              break;
            }
            capLastDate = vm.capDates[vm.capDates.length - 1];
          }
        }

        if (vm.formData.sipPaymentOption=='UPI' && vm.enabledEndDates) {
          var defaultEndDate = $window.moment().add(vm.emandateMaxYear, 'years').subtract(1, 'days');
          var sipDateLessUPI =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter(defaultEndDate) ? true : false;
          if (sipDateLessUPI) {
            var setEndDateLess = false;
            var indexSipEndDate = vm.enabledEndDates.length - 1;
            var tempEndDate;
            while (!setEndDateLess) {
              tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
              indexSipEndDate = indexSipEndDate - 1;
              if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(defaultEndDate, 'DD-MMM-YYYY'))) {
                setEndDateLess = true;
                var newEnabledEndDates = angular.copy(vm.enabledEndDates);
                newEnabledEndDates.splice(indexSipEndDate + 1);
                vm.enabledEndDates = angular.copy(newEnabledEndDates);
                vm.formData.endDate = angular.copy(tempEndDate);
                vm.changeEndDate(vm.formData.endDate);
              }

              if (indexSipEndDate == 0) {
                break;
              }
            }
          }

        }


        else vm.formData.showTopUpBlock = false;
      }
      (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) && checkOTMAmountAndDate();
    };
    vm.enabledOTMStartDatesList = [];
    vm.enabledBillerStartDatesList = [];


    function getDateValidation(cb) {

      LoaderService.showLoader();
      cb = cb || function () { };
      var success = function (resp) {
        if (resp.status && resp.data) {
          var currentDate = resp.data.currentDate || Date();
          vm.daysList = resp.data.listOfDays;
          var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
          var todayDate = $window.moment(Date.parse(parsedDate));
          var counter = 0;
          // vm.formData.startDate = todayDate;
          vm.nonBusinessDatess = resp.data.nonBuisnessDates;
          if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
          } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
            vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.inSchemeValidations.sipTDay, 'days');
          } else {
            vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(11, 'days');
          }
          vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days').add(1, 'minutes');
          var startDate = todayDate.clone();
          var freq = vm.startMaxDate.diff(todayDate, 'days');
          for (var i = 0; i <= freq; i++) {
            var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
            var isEnable = true;
            if (counter < 5) {
              angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                if ($window.moment(value, "DD-MMM-YYYY").diff(indexDate, 'days') === 0) {
                  isEnable = false;
                }
              });
            }
            if (isEnable) {
              vm.enabledOTMStartDatesList.push(startDate.clone().add(i, 'days'));
              counter++;
            }
          }

          vm.startMinDateOTM = vm.enabledOTMStartDatesList[17];
          if(vm.formData.sipPaymentOption == 'E-mandate'){
            vm.startMinDateOTM = vm.enabledOTMStartDatesList[5];
          }
          if(vm.formData.sipPaymentOption == 'UPI'){
            vm.startMinDateOTM = vm.enabledOTMStartDatesList[7];
          }
          if(vm.startMinDateOTM && vm.formData.frequency !== 'OW'){
            if (vm.savedDate && !$window.moment(vm.savedDate).isSameOrAfter($window.moment(vm.startMinDateOTM, "DD-MMM-YYYY HH:mm A"))) {
              vm.savedDateSet = false;
              vm.savedDate = null;
              vm.savedEndDate = null;
              vm.savedFrequency = null;
            } else if (!vm.savedDateSet) {
              vm.formData.startDate = angular.copy(vm.startMinDateOTM);
              vm.formData.isTillPerpetuity = true;
              updateEndDates();
            }
          }

          vm.isReseting = true;

          LoaderService.hideLoader();
          $timeout(function () {
            vm.isReseting = false;
          });
          cb(true);
        } else {

          LoaderService.hideLoader();
          MessageService.error(resp.message);
          cb(false);
        }
      },
        error = function (err) {

          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };
      InvestorService.get({
        child1: 'nonBusinessDate',
        schemeCode: vm.formData.inSchemeCode
      }).$promise.then(success, error);
    }
    function updateDatesForOthers() {
      LoaderService.showLoader();
      var currentDay = $window.moment();
      currentDay.set({ 'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0 });
      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.formData.day);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      var tDays = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? 15 : 10;
      while (_diff < tDays) {
        updatedDate.add(1, 'months').set('date', vm.formData.day);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }

      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        /*  if (HDFC_API.ENV === 'prod' || HDFC_API.ENV === 'beta') {
           if (_diff <= 90) {
             enabledStartDates.push(_date.clone());
           }
         } */
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }

      vm.enabledStartDates = angular.copy(enabledStartDates);
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
        calculateMonthsForSip();
      } else {
        if(vm.distributorDetails && vm.distributorDetails.sipStartDate){
          vm.formData.startDate = vm.distributorDetails.sipStartDate;
        }else{
          vm.formData.startDate = vm.enabledStartDates[0];
        }
      }
      updateEndDates();
      LoaderService.hideLoader();
    }
    vm.next = function () {
      if (vm.stage === 0) {
        vm.stage = 1;
      }
    }
    function checkPurchseAmountValidations() {
      if (vm.formData.amount < vm.purchseSchemeValidationData.minFirstPurchaseAmt) {
        vm.ispurchseMinAmount = true;
      } else {
        vm.ispurchseMinAmount = false;
      }
    }
    function checkSipValidations(fromTopUp) {
      if (vm.additionalSipData) {
        var newValidation = vm.additionalSipData;
        for (var i = 0; i < newValidation.length; i++) {
          var condition = vm.formData.amount < newValidation[i].min_amount_lower || vm.formData.amount <= newValidation[i].min_amount_upper
          if (!newValidation[i].min_amount_upper) {
            var condition = true;
          }
          if (condition) {
            if (!vm.formData.showTopUpBlock || !vm.formData.sipTopupSelected) {
              if(vm.saveDraftPayload && vm.saveDraftPayload.installmentStartDate && vm.saveDraftPayload.installmentEndDate){
                if(vm.distributorDetails && vm.distributorDetails.transactionType == 'SIP'){
                  if(vm.distributorDetails.frequency == "BZ" || vm.distributorDetails.frequency == "OW"){
                    // vm.formData.startDate = null;
                    // vm.formData.endDate = null;
                  }else{
                    vm.formData.startDate = moment(vm.distributorDetails.sipStartDate, "DD-MMM-YYYY");
                    vm.formData.endDate = moment(vm.distributorDetails.sipEndDate, "DD-MMM-YYYY");
                    vm.changeStartDate(vm.formData.startDate);
                  }
                }else{
                vm.formData.startDate = moment(vm.saveDraftPayload.installmentStartDate, "DD-MMM-YYYY");
                vm.formData.endDate =  moment(vm.saveDraftPayload.installmentEndDate, "DD-MMM-YYYY");
                vm.changeStartDate(vm.formData.startDate);
                }
              }else{
                if(vm.distributorDetails && vm.distributorDetails.transactionType == 'SIP'){
                  if(vm.distributorDetails.frequency == "BZ" || vm.distributorDetails.frequency == "OW"){
                    // vm.formData.startDate = null;
                    // vm.formData.endDate = null;
                  }else{
                    vm.formData.startDate = vm.distributorDetails.sipStartDate ? moment(vm.distributorDetails.sipStartDate, "DD-MMM-YYYY") : null;
                    vm.formData.endDate = vm.distributorDetails.sipEndDate ? moment(vm.distributorDetails.sipEndDate, "DD-MMM-YYYY") : null;
                    vm.changeStartDate(vm.formData.startDate);
                  }
                }else{
                  // vm.formData.startDate = null;
                  // vm.formData.endDate = null;
                }
              }
              if(vm.distributorDetails && vm.distributorDetails.transactionType == 'SIP'){
              }else{
                // vm.enabledStartDates = null;
                // vm.enabledEndDates = null;
                // vm.formData.day = null;
                // vm.formData.weeklyDay = null;
                // vm.formData.month = null;
              }
            }
            vm.validations.amountMultiples = newValidation[i].amt_multiples;
            vm.validations.maxAmount = newValidation[i].min_amount_upper;
            vm.validations.minAmount = newValidation[i].min_amount_lower;
            vm.validations.minInstallments = newValidation[i].min_installments;
            break;
          }
        }
      }
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }
      vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
      vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
      vm.isTopupMinAmt = !!(vm.validations.topupMinAmt && vm.validations.topupMinAmt > vm.formData.topupDetails.amount);
      vm.isTopupMinPerc = !!(vm.validations.topupMinPercentage && vm.validations.topupMinPercentage > vm.formData.topupDetails.percentage);
      vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
      vm.isTopUpMultiples = vm.validations.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.validations.topupAmtMultples === 0) || false;
      vm.isTopupPercMultiples = vm.validations.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.validations.topupPercentageMultples === 0) || false;
      vm.isInvalidForm = vm.formData.amount <= 0 || (vm.formData.amount && (vm.isMax || vm.isMin || (vm.validations.amountMultiples && !vm.isMultiples)));
      if (!vm.isInvalidForm && vm.formData.topupDetails.amount) {
        vm.isInvalidForm = vm.formData.topupDetails.amount <= 0 || (vm.formData.topupDetails.amount && (vm.isTopupMinAmt || (vm.validations.topupAmtMultples && !vm.isTopUpMultiples)));
      }
      checkEMandateValidation();
      if (vm.formData.topupDetails.amount) {
        vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.amount) && $window.NumToWord(vm.formData.topupDetails.amount, 'divDisplayInWords', vm);
      }
      if (vm.formData.topupDetails.capAmount) {
        vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.capAmount) && $window.NumToWord(vm.formData.topupDetails.capAmount, 'capAmntDisplayInWords', vm);
      }
      if (!vm.formData.isBackFromSummary) {
        angular.isDefined(vm.formData.topupDetails) && angular.isDefined(vm.formData.topupDetails.capAmount) && (vm.formData.topupDetails.capAmount = vm.formData.topupDetails.capAmount ? vm.formData.topupDetails.capAmount : '');
      }
      if (vm.formData.amount == "" || vm.formData.amount == null) {
        resetNumInWords();
      } else {
        $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
      }

      if (vm.sipFirstInstallment)
        vm.formData.sipFirstAmount = vm.formData.amount;

      if(vm.formData.amount >= 2000000){
        vm.amountExceeded = true;
      }else {
        vm.amountExceeded = false;
      }

      if (vm.formData.startDate && !fromTopUp) {
        vm.changeStartDate(vm.formData.startDate,true);
      }

      if(vm.formData.sipPaymentOption=='UPI' && vm.formData.amount > vm.upiMaxAmountLimit) {
        var success = function() {
          if(vm.paymentOptions.includes("OTM")) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if(vm.paymentOptions.includes("E-mandate")) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
          } else if(vm.paymentOptions.includes("EC")){
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          } else {
            vm.formData.sipPaymentOption = null;
          }
        }
        ModalService.genericModal({
          text: vm.upiErrorMessage,
          isUpi: true
        },success);
      }
    }


    vm.chooseFrequency = function (frequency) {
      vm.SelectedFrequency = frequency;
      vm.formData.frequency = vm.SelectedFrequency.code;
      vm.enabledStartDates = null;
      extractValidationObject(vm.inSchemeValidations);
    }

    vm.next1 = function () {
      var success = function (resp) {
        if (resp.data && resp.status) {
          var data = resp.data;
          $rootScope.stepperSecondary.steps[0].stepActive = false;
          $rootScope.stepperSecondary.steps[1].stepActive = false;
          $rootScope.stepperSecondary.steps[2].stepActive = false;
          $rootScope.stepperSecondary.steps[0].stepCompleted = true;
          $rootScope.stepperSecondary.steps[1].stepCompleted = true;
          $rootScope.stepperSecondary.steps[2].stepCompleted = true;
          $state.go('newInvestor.folioDetails.baiscDetails');
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      var Details = JSON.parse(sessionStorage.getItem("userData"));
      vm.saveDraftPayload.id = Details.transactionDraftId;
      vm.saveDraftPayload.amount = vm.formData.amount;
      if (!vm.PaymentModePurchse) {
        // vm.saveDraftPayload.netBankingUrl = vm.formData.bankInfo.netBankingUrl;
        // vm.saveDraftPayload.bankName = vm.formData.bankInfo.bankName;
        // vm.saveDraftPayload.bankCode = vm.formData.bankInfo.bankCode;
        vm.saveDraftPayload.installmentFrequency = this.SelectedFrequency.code;
        if (vm.sipFirstInstallment) {
          vm.saveDraftPayload.sipFI = true;
        } else {
          vm.saveDraftPayload.sipFI = false;
        }
        vm.saveDraftPayload.installmentEndDate = vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '';
        vm.saveDraftPayload.installmentStartDate = vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '';
        if (vm.daysList && vm.daysList.length > 0) {
          vm.saveDraftPayload.sipDay = vm.daysList.length;
        }
        if (vm.formData.sipTopupEnabled) {
          vm.saveDraftPayload.topUpDetails = {};
          vm.saveDraftPayload.topUpEnable = true;
          if (vm.formData.topupDetails.amount) {
            vm.saveDraftPayload.topUpDetails.amount = vm.formData.topupDetails.amount;
            delete vm.saveDraftPayload.topUpDetails.percentage;
          } else {
            vm.saveDraftPayload.topUpDetails.percentage = vm.formData.topupDetails.percentage;
            delete vm.saveDraftPayload.topUpDetails.amount;
          }
          if (vm.formData.topupDetails.capAmount) {
            vm.saveDraftPayload.topUpDetails.capAmount = vm.formData.topupDetails.capAmount;
            delete vm.saveDraftPayload.topUpDetails.capMonthYear;
          } else {
            vm.saveDraftPayload.topUpDetails.capMonthYear = "01-"+vm.formData.topupDetails.capMonthYear;
            delete vm.saveDraftPayload.topUpDetails.capAmount;
          }
          // vm.saveDraftPayload.topUpDetails.diffInMonths = vm.formData.topupDetails.diffInMonths;
          vm.saveDraftPayload.topUpDetails.frequency = vm.formData.topupDetails.frequency;
        }
        else {
          vm.saveDraftPayload.topUpEnable = false;
          vm.saveDraftPayload.topUpDetails = {};
        }
        vm.saveDraftPayload.paymentOption = vm.formData.sipPaymentOption;
        if(vm.formData.sipPaymentOption == 'E-mandate'){
          vm.saveDraftPayload.paymentOption = 'HEM';
          var bankInfo = JSON.parse(vm.formData.bankInfo);
          vm.saveDraftPayload.netBankingUrl = bankInfo.netBankingUrl;
          vm.saveDraftPayload.bankName = bankInfo.bankName;
          vm.saveDraftPayload.bankCode = bankInfo.bankCode;
        }
        if(vm.formData.sipPaymentOption == 'UPI'){
          vm.saveDraftPayload.paymentOption = 'UAP';
          var bankInfo = vm.formData.bankInfo;
          vm.saveDraftPayload.bankName = bankInfo.bankName;
          vm.saveDraftPayload.bankCode = bankInfo.bankCode;
          vm.saveDraftPayload.payerVpa = vm.formData.bankInfo.virtualAddress;
          vm.saveDraftPayload.payerName = vm.name;
        }
      }

      if (vm.saveDraftPayload.subBrokerArn) {
        vm.investingthrough = 'Distributer'
      } else if (vm.saveDraftPayload.riaConsent) {
        vm.investingthrough = 'RIA'
      } else {
        vm.investingthrough = 'Self'
      }
      $window.smartech('dispatch', 'investment details', {
        'investmenttype': vm.saveDraftPayload.investmentType,
        'investingthrough': vm.investingthrough,
        'amount': vm.saveDraftPayload.amount,
        'ARN': vm.saveDraftPayload.brokerCode ? vm.saveDraftPayload.brokerCode : '',
        'subbrokerARN': vm.saveDraftPayload.subBrokerArn ? vm.saveDraftPayload.subBrokerArn : '',
        'EUIN': vm.saveDraftPayload.euinCode ? vm.saveDraftPayload.euinCode : '',
        'Installmentfrequency': vm.saveDraftPayload.installmentFrequency
      });
      if(vm.formData.investmentOption && vm.formData.investmentOption.toUpperCase() == 'GROWTH'){
        delete vm.saveDraftPayload.dividendOption;
      }else{
        vm.saveDraftPayload.dividendOption  = vm.dividenInevstmentOption;
      }
      vm.saveDraftPayload.step = "THIRD";
      vm.processFlag = false;
      InvestorService.post({
        child1: 'new',
        child2: 'user',
        child3: 'save',
        child4: 'transaction'
      }, vm.saveDraftPayload).$promise.then(success, error);
    }
    vm.changeStartDate = function (date,calledFromAmountChanged) {

      if (date && vm.savedDateSet && vm.savedDate) {
        var isSameDate = date.isSame($window.moment(vm.savedDate,"DD-MMM-YYYY HH:mm A"));
        if (!isSameDate) {
          vm.savedDateSet = false;
          vm.savedDate = null;
          vm.savedEndDate = null;
          vm.savedFrequency = null;
        }
      }

      if(Object.keys(vm.saveDraftPayload).length !== 0){
        if (!vm.formData.frequency) {
          vm.formData.frequency = vm.saveDraftPayload.installmentFrequency;
        }
        vm.saveDraftPayload ={};
      }

      LoaderService.showLoader();
      vm.formData.startDate = date ? date : null;
      vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
      // vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = false;
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      });
      checkOTMAmountAndDate();
      if (vm.formData.sipPaymentOption === 'E-mandate' || vm.formData.sipPaymentOption === 'UPI' && !vm.emandateObj) {
        fetchMandateValidations(function () {
          if (calledFromAmountChanged && !vm.savedDateSet) {
            updateEndDates(false,true);
          } else {
            updateEndDates();
          }
          LoaderService.hideLoader();
        })
      } else {
        if (calledFromAmountChanged && !vm.savedDateSet) {
          updateEndDates(false,true);
        } else {
          updateEndDates();
        }
        LoaderService.hideLoader();
      }
    };
    function updateEndDates(doNotUpdateEndDate,amountDateCheck) {
      if (!vm.formData.startDate) {
        return;
      }

      if(vm.formData.sipPaymentOption == "E-mandate" || vm.formData.sipPaymentOption == "UPI"){
        vm.formData.isTillPerpetuity=false;
        var tempDate = $window.moment(new Date(vm.formData.startDate), 'DD-MMM-YYYY');
        var defaultEndDate = $window.moment(new Date(tempDate), "DD-MM-YYYY").add(vm.emandateMaxYear, 'years');
      }else{
        var defaultEndDate = $window.moment((new Date()), "DD-MMM-YYYY").add(99, 'years');
      }
      //var defaultEndDate = new Date(2036, 12, 31);
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;
      var frequency = vm.frequency.find(function (f) {
        return f.code === vm.formData.frequency;
      }) || {};


      switch (vm.formData.frequency) {
        case 'BZ':
          var days = 0;
          endDate = vm.formData.startDate.clone();//.add(minInstallments, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / frequency.duration);
          for (i = 0; i < freq; i++) {
            days = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        case 'OW':
          var days = 0;
          defaultEndDate = new Date("12/31/2099");
          freq = UtilService.getNumberOfWeeks(vm.formData.startDate.toDate(), defaultEndDate);
          for (i = 0; i <= freq; i++) {
            days = frequency.duration * i;
            enabledEndDates.push(vm.formData.startDate.clone().add(days, 'days'));
          }
          break;
        default:
          var months = 0;
          endDate = vm.formData.startDate.clone().add(frequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.duration);
          for (i = 0; i < freq; i++) {
            months = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
      vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
      if (!doNotUpdateEndDate) {
        //vm.formData.endDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
        vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
      } else {
        //vm.formData.endDate = null;
        vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);

      }

      if (vm.enabledEndDates.length !== 0) {
        if (vm.savedDateSet && vm.formData.sipPaymentOption !== 'E-mandate' && vm.formData.sipPaymentOption !== 'UPI') {
          var savedEndate = angular.copy($window.moment(vm.savedEndDate,'DD-MMM-YYYY'));
          if (savedEndate && (($window.moment(savedEndate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || (savedEndate.isSame($window.moment(vm.enabledEndDates[0]))) || (savedEndate.isSame($window.moment(vm.enabledEndDates.length - 1))))) {
            vm.formData.isTillPerpetuity = true;
            vm.changeTillPerpetuityFlag(function () {
              vm.formData.endDate = angular.copy(savedEndate);
              if (vm.formData.endDate.isSame($window.moment(vm.endDateDefaultForPertuity))) {
                vm.formData.isTillPerpetuity = true;
              } else {
                vm.formData.isTillPerpetuity = false;
              }
            });
          } else {
            vm.savedDateSet = false;
            vm.savedDate = null;
            vm.savedEndDate = null;
            vm.savedFrequency = null;
            vm.formData.endDate = null;
            vm.formData.isTillPerpetuity = true;
            vm.changeTillPerpetuityFlag();
          }
        } else {
          if (amountDateCheck && vm.formData.endDate && (($window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates[0]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates.length - 1))))) {
            if (vm.formData.endDate.isSame($window.moment(vm.endDateDefaultForPertuity))) {
              vm.formData.isTillPerpetuity = true;
            } else {
              vm.formData.isTillPerpetuity = false;
            }
          } else if(vm.formData.sipPaymentOption !== 'E-mandate' && vm.formData.sipPaymentOption !== 'UPI'){
            vm.formData.endDate = null;
            vm.formData.isTillPerpetuity = true;
            vm.changeTillPerpetuityFlag();
          }
        }
      }

      if(vm.formData.sipPaymentOption == 'E-mandate'){
        vm.formData.isTillPerpetuity = false;
        if(vm.enabledEndDates && vm.distributorDetails && vm.distributorDetails.transactionType == 'SIP' && vm.distributorDetails.sipEndDate){
          if($window.moment(vm.enabledEndDates[vm.enabledEndDates.length-1], 'DD-MMM-YYYY').isBefore(vm.distributorDetails.sipEndDate)){
            vm.formData.endDate = null;
          }else if( vm.distributorDetails.sipStartDate  !=  moment(vm.formData.startDate).format("DD-MMM-YYYY")){
            vm.formData.endDate = null;
          }else{
           vm.formData.endDate = $window.moment(new Date(vm.distributorDetails.sipEndDate), 'DD-MMM-YYYY');
          }
        }else{
          vm.formData.endDate = enabledEndDates && enabledEndDates.length > 0 ? enabledEndDates[enabledEndDates.length-1]:null;
         }
         vm.changeTillPerpetuityFlag();
      }
      if(vm.formData.sipPaymentOption == 'UPI'){
        vm.formData.isTillPerpetuity = false;
        if(vm.enabledEndDates && vm.distributorDetails && vm.distributorDetails.transactionType == 'SIP' && vm.distributorDetails.sipEndDate){
          if($window.moment(vm.enabledEndDates[vm.enabledEndDates.length-1], 'DD-MMM-YYYY').isBefore(vm.distributorDetails.sipEndDate)){
            vm.formData.endDate =  $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1], 'DD-MMM-YYYY');
            vm.changeEndDate(vm.formData.endDate);
          }else if( vm.distributorDetails.sipStartDate  !=  moment(vm.formData.startDate).format("DD-MMM-YYYY")){
            vm.formData.endDate =  $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1], 'DD-MMM-YYYY');
            vm.changeEndDate(vm.formData.endDate);
          }else{
            vm.formData.endDate = $window.moment(new Date(vm.distributorDetails.sipEndDate), 'DD-MMM-YYYY');
          }
        } else if(vm.enabledEndDates && !vm.savedDateSet) {
          vm.formData.endDate =  $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1], 'DD-MMM-YYYY');
          vm.changeEndDate(vm.formData.endDate);
        }
      }


      //reSetting();
    }
    function checkOTMAmountAndDate() {

      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isOTMEndDate = false;
      // Check Ammout
      if (vm.formData.amount && vm.formData.bankInfo && (vm.formData.amount > vm.formData.bankInfo.maxAmount)) {
        vm.isOTMAmount = true;
      } else {
        vm.isOTMAmount = false;
      }

      //Compare Start Dates
      if (vm.formData.bankInfo && ($window.moment(vm.formData.bankInfo.omExpiryDate, "DD-MMM-YYYY").isBefore(vm.formData.startDate))) {
        vm.isOTMDate = true;
      }
      else {
        vm.isOTMDate = false;
      }
      //Compare End Dates
      if (vm.formData.bankInfo && vm.formData.bankInfo.omStartDate) {
        if (!(vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore(new Date($window.moment(vm.formData.startDate))))) {
          if (vm.formData.startDate == null) {
            vm.isOTMStartDate = false;
          } else {
            vm.isOTMStartDate = true;
          }
        } else {
          vm.isOTMStartDate = false;
        }
      }

      if (vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isBefore(new Date($window.moment((vm.formData.endDate))))) {
        vm.isOTMEndDate = true;
      }
      else {
        vm.isOTMEndDate = false;
      }
      //Check for amount or date
      if (vm.isOTMAmount || vm.isOTMDate || vm.isOTMEndDate) {
        vm.isInvalidForm = true;
      } else {
        vm.isInvalidForm = false;
      }
    }
    function checkEMandateValidation() {
      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
        vm.validations.maxAmount = vm.eMandatemaxAmountLimit;
        vm.isMax = !!(vm.validations.maxAmount && vm.formData.amount > vm.validations.maxAmount);
      }
      else vm.isMax = false;
    }
    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.formData.frequency) {
        return;
      }

      vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
      vm.validations.topupAmtMultples = vm.validations.topupAmtMultples || 1;
      vm.validations.topupPercentageMultples = vm.validations.topupPercentageMultples || 1;
      vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
      vm.validations.minInstallments = vm.validations.minInstallments || 0;
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.maxAmount = vm.validations.maxAmount || 0;
      vm.validations.topupMinAmt = vm.validations.topupMinAmt || 0;
      vm.validations.topupMinPercentage = vm.validations.topupMinPercentage || 0;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > 0 && vm.validations.maxAmount < vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }
      switch (vm.formData.frequency) {
        case 'BZ':
          vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          if (validationsData.additionalValidation.BZ) {
            vm.additionalSipData = validationsData.additionalValidation.BZ;
            vm.validations.minAmount = validationsData.additionalValidation.BZ[0].min_amount_lower;
          }
          break;
        case 'OW':
          vm.validations.maxInstallments = validationsData.weeklyMaxInstallmentNumber;
          if (validationsData.additionalValidation.OW) {
            vm.additionalSipData = validationsData.additionalValidation.OW;
            vm.validations.minAmount = validationsData.additionalValidation.OW[0].min_amount_lower;
          }
          break;
        case 'Q':
          vm.validations.maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
          vm.validations.topupMinAmt = validationsData.topupMinAmt;
          vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
          vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
          if (validationsData.additionalValidation.Q) {
            vm.additionalSipData = validationsData.additionalValidation.Q;
            vm.validations.minAmount = validationsData.additionalValidation.Q[0].min_amount_lower;

          }
          break;
        case 'OM':
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.validations.topupMinAmt = validationsData.topupMinAmt;
          vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
          vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
          if (validationsData.additionalValidation.OM) {
            vm.additionalSipData = validationsData.additionalValidation.OM;
            vm.validations.minAmount = validationsData.additionalValidation.OM[0].min_amount_lower;
          }
          break;
        case 'H':
          vm.additionalSipData = validationsData.additionalValidation.H;
          vm.validations.minAmount = validationsData.additionalValidation.H[0].min_amount_lower;
          vm.validations.maxInstallments = 0;
          break;
        case 'Y':
          vm.additionalSipData = validationsData.additionalValidation.Y;
          vm.validations.minAmount = validationsData.additionalValidation.Y[0].min_amount_lower;
          vm.validations.maxInstallments = 0;
          break;
      }
      if (!vm.backFromPayment && !$stateParams.transactionId) {
        if (vm.validations.minAmount > validationsData.sipDefaultAmount) {
          vm.formData.amount = vm.validations.minAmount;
        } else {
          if (vm.savedFrequency) {
            vm.formData.amount = vm.formData.amount ? vm.formData.amount : validationsData.sipDefaultAmount;
          } else {
            vm.formData.amount = validationsData.sipDefaultAmount;
          }

        }
      }
      if (vm.additionalSipData) {
        checkSipValidations();
      }

      getDateValidation();

    }
    vm.frequencyData = [
      {
        "name": "Monthly",
        "code": "OM",
        "duration": 1
    },
      {
      "name": "Quarterly",
      "code": "Q",
      "duration": 3
  },
  {
      "name": "Half Yearly",
      "code": "H",
      "duration": 6
  },
  {
      "name": "Yearly",
      "code": "Y",
      "duration": 12
  }];
    function changeFrequency(freq) {
      vm.formData.startDate = null;
      vm.enabledStartDates = null;
      vm.formData.endDate = null;
      vm.enabledEndDates = null;
      vm.formData.day = null;
      vm.formData.weeklyDay = null;
      vm.formData.month = null;
      vm.formData.isTillPerpetuity = false;
      vm.SelectedFrequency = freq;
      vm.formData.frequency = freq.code;

      if (vm.formData.frequency !== vm.savedFrequency) {
        vm.savedDateSet = false;
        vm.savedDate = null;
        vm.savedEndDate = null;
        vm.savedFrequency = null;
      }
      extractValidationObject(vm.inSchemeValidations);
    }
    vm.changeFirstInstallment = function (installmentActivated) {

      vm.formData.sipPaymentOption = vm.paymentOptions[0];
      changedPaymentOption();

      if (installmentActivated === false) {
        vm.sipFirstInstallment = false;
        vm.formData.sipFirstInstallment = false;
        vm.formData.sipFirstAmount = '';
        if(vm.distributorDetails && vm.distributorDetails.isHdfcBank){
          vm.formData.sipPaymentOption = 'E-mandate';
          fetchBankList();
        }
      } else {
        vm.sipFirstInstallment = true;
        vm.formData.sipFirstInstallment = true;
        vm.formData.sipFirstAmount = vm.formData.amount ? vm.formData.amount : "";
        vm.formData.sipPaymentOption = 'UPI';
      }

      vm.formData.startDate = angular.copy(vm.startMinDateOTM);
      vm.formData.isTillPerpetuity = true;
      vm.changeTillPerpetuityFlag()
    }

    function fetchBankList(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (vm.formData.sipPaymentOption == 'EC') {
            vm.ECbankList = resp.data.bankList;
            vm.formData.sipPaymentOption = vm.formData.sipPaymentOption? vm.formData.sipPaymentOption: vm.paymentOptions[0];
            if(vm.formData.startDate){
              updateEndDates();
            }
          }else{
            if(vm.bankCode){
              if(vm.formData.sipPaymentOption == 'E-mandate'){
                resp.data.bankList.forEach(function(bank){
                    if(bank.bankCode ==  vm.bankCode){
                      vm.formData.bankInfo = JSON.stringify(bank);
                      vm.paymentvalidBank = true;
                    }
                });
              }
              if(vm.formData.sipPaymentOption == 'UPI'){
                var selectedBank = resp.data.bankList.find(function(bank){
                  return bank.bankCode ==  vm.bankCode
                });

                if (selectedBank) {
                  vm.formData.bankInfo = angular.copy(selectedBank);
                  vm.upiPaymentvalidBank = true;
                }

              }
            }
          }
          if (vm.formData.inSchemeCode)
              getDateValidation();
          vm.bankList = resp.data.bankList;
          if(vm.distributorDetails && vm.distributorDetails.isHdfcBank){
            resp.data.bankList.forEach(function(bank){
              if(bank.bankCode ==  'HDFC' || bank.bankCode ==  'HDF'){
                vm.formData.bankInfo = JSON.stringify(bank);
                vm.paymentvalidBank = true;
                vm.bankList =[];
                vm.bankList.push(bank);
              }
            });
          }
        } else {
          vm.bankList = null;
          MessageService.error(resp.message);
        }
        cb(true);
      },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      InvestorService.get({ child1: 'bank', child2: 'list', child3: 'sip' }, null).$promise.then(success, error);
    }

    function changedPaymentOption() {
      if(vm.formData.sipPaymentOption=='UPI' && vm.formData.amount > vm.upiMaxAmountLimit) {
        var success = function() {
          if(vm.paymentOptions.includes("OTM")) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if(vm.paymentOptions.includes("E-mandate")) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
          } else if(vm.paymentOptions.includes("EC")) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          } else {
            vm.formData.sipPaymentOption = null;
          }
        }
        ModalService.genericModal({
          text: vm.upiErrorMessage,
          isUpi: true
        },success);
      }


      if ((vm.formData.sipPaymentOption=='UPI' || vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) && !vm.emandateObj) {
        fetchMandateValidations();
      }


      vm.formData.bankInfo = null;
      vm.formData.otmId = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = null;
      vm.formData.authMode = null;
      vm.authenticationMode = null;
      vm.enabledBillerStartDatesList = null;
      vm.formData.weeklyDay = null;
      vm.disableEndDateSelection = false;
      vm.showIFSCField = false ;
      vm.showAccountTypeField = false;
      vm.formData.ifscCode = '';
      vm.formData.accountType = null;
      vm.verifyUPIResp = {};
      vm.isUPIVerified = false;
      if (vm.emandateUpiData && vm.emandateObj) {
        if (vm.formData.sipPaymentOption=='UPI') {
          vm.emandateObj = vm.emandateUpiData.upi;
        } else if (vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          vm.emandateObj = vm.emandateUpiData.eOTM;
        }
        vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
      }
      fetchBankList();
      //checkEMandateValidation();
      //checkOTMAmountAndDate();
      getDateValidation();
      if(vm.sipFirstInstallment){
        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
        vm.paymentvalidBank = true;
      }else{
        if(vm.distributorDetails && vm.distributorDetails.isHdfcBank){
          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
        }else{
          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
        }
      }
      if(vm.formData.sipPaymentOption == 'E-mandate'){
        vm.paymentvalidBank = false;
      }
      if(vm.formData.sipPaymentOption == 'EC'){
        vm.paymentvalidBank = true;
      }
      if(vm.distributorDetails && vm.distributorDetails.transactionType == 'SIP'){
        vm.formData.startDate = vm.distributorDetails.sipStartDate ? moment(vm.distributorDetails.sipStartDate, "DD-MMM-YYYY") : null;
        vm.formData.endDate = vm.distributorDetails.sipEndDate ? moment(vm.distributorDetails.sipEndDate, "DD-MMM-YYYY") : null;
        vm.changeStartDate(vm.formData.startDate);

        if(vm.formData.sipPaymentOption == 'E-mandate'){
          if(vm.enabledEndDates && vm.distributorDetails && vm.distributorDetails.transactionType == 'SIP' && vm.distributorDetails.sipEndDate){
            if($window.moment(vm.enabledEndDates[vm.enabledEndDates.length-1], 'DD-MMM-YYYY').isBefore(vm.distributorDetails.sipEndDate)){
              vm.formData.endDate = null;
            }else{
             vm.formData.endDate = $window.moment(new Date(vm.distributorDetails.sipEndDate), 'DD-MMM-YYYY');
            }
          }else{
            vm.formData.endDate = null;
           }
        }
      }
      if(vm.formData.sipPaymentOption == 'UPI'){
        vm.upiPaymentvalidBank = false;
      }
    }

    //change day

    function reSetting() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    vm.changeDay = function () {
      vm.disableEndDateSelection = false;
      if (!vm.formData.frequency || (!vm.formData.day && !vm.formData.weeklyDay && (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP))) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        reSetting();
        return;
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.month = '';
        vm.formData.enabledEndDates = [];
      }

      switch (vm.formData.frequency) {
        case 'BZ':
          reSetting();
          break;
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM':
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default:
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          reSetting();
          break;
      }
    };

    function changeBank(){
      if(vm.formData.bankInfo){
        vm.bankInfo = JSON.parse(vm.formData.bankInfo);
      }else{
        vm.paymentvalidBank = false;
        return;
      }
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
           if(resp.data.emandateEnabled){
            vm.formData.bankName = vm.bankInfo.bankName;
            vm.paymentvalidBank = true;
           }else{
            vm.paymentvalidBank = false;
            var msg = vm.bankInfo.bankName +" bank is not support E-mandate payment service."
            MessageService.error(msg);
            vm.formData.bankInfo = '';
           }
          } else {
            vm.formData.bankName = '';
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err.message);
        };
        LoaderService.showLoader();
         if(vm.bankInfo == undefined){
          vm.bankInfo = '';
         }
        if(vm.bankInfo && vm.bankInfo.gateWayVendor){
          InvestorService.get(
            {
              child1: 'NewInvestor',
              child2: 'checkEmandate',
              child3: vm.bankInfo.bankName.toLowerCase(),
              child4: vm.bankInfo.gateWayVendor
            }).$promise.then(success, error);
        }else{
          if(vm.bankInfo != null || vm.bankInfo != undefined){
            vm.paymentvalidBank = false;
            MessageService.error("Bank is not support E-mandate payment service.");
          }
          vm.formData.bankInfo = '';
          LoaderService.hideLoader();
        }

    }
    vm.addNote = function () {
      $timeout(function () {
        if(vm.distributorDetails && vm.distributorDetails.isHdfcBank){
          if(document.querySelector(".point-to-note") && document.querySelector("ul")){
            angular.element(document.querySelector('.point-to-note').querySelectorAll('ul')).append($compile("<li><span> This facility allows payments to be made through or installments to be debited from HDFC Bank only. For payments through any other bank as Payee Bank, kindly visit HDFC MF website <a href='"+HDFC_API.WEBSITE_LINK+"' target='_blank' style='color:blue !important'> "+HDFC_API.WEBSITE_LINK+" </a>.\n</span></li>\n")($scope));
          }else{
            vm.addNote();
          }
        }
      }, 2000);
    }
    vm.addNote();
    // function changeBank(){
    //   if(vm.formData.bankInfo){
    //     vm.bankInfo = JSON.parse(vm.formData.bankInfo);
    //   }else{
    //     vm.paymentvalidBank = false;
    //     return;
    //   }
    //     var success = function (resp) {
    //       LoaderService.hideLoader();
    //       if (resp.data && resp.status) {
    //        if(resp.data.emandateEnabled){
    //         vm.formData.bankName = vm.bankInfo.bankName;
    //         vm.paymentvalidBank = true;
    //        }else{
    //         vm.paymentvalidBank = false;
    //         var msg = vm.bankInfo.bankName +" bank is not support UPI payment service."
    //         MessageService.error(msg);
    //         vm.formData.bankInfo = '';
    //        }
    //       } else {
    //         vm.formData.bankName = '';
    //         MessageService.error(resp.message);
    //       }
    //     },
    //     error = function (err) {
    //       LoaderService.hideLoader();
    //       MessageService.error(err.message);
    //     };
    //     LoaderService.showLoader();
    //      if(vm.bankInfo == undefined){
    //       vm.bankInfo = '';
    //      }
    //     if(vm.bankInfo && vm.bankInfo.gateWayVendor){
    //       InvestorService.get(
    //         {
    //           child1: 'NewInvestor',
    //           child2: 'checkEmandate',
    //           child3: vm.bankInfo.bankName.toLowerCase(),
    //           child4: vm.bankInfo.gateWayVendor
    //         }).$promise.then(success, error);
    //     }else{
    //       if(vm.bankInfo != null || vm.bankInfo != undefined){
    //         vm.paymentvalidBank = false;
    //         MessageService.error("Bank is not support E-mandate payment service.");
    //       }
    //       vm.formData.bankInfo = '';
    //       LoaderService.hideLoader();
    //     }
    //
    // }

    function selectedUpiBank(){
      vm.showIFSCField = vm.formData.bankInfo.ifscCode ? false : true;
      vm.showAccountTypeField = vm.formData.bankInfo.bankAcType ? false : true;
      if (vm.showAccountTypeField) {
        getAccountType();
      }
      if(vm.formData.bankInfo && !vm.formData.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
        ModalService.minorBankModal({instantInvestment:true});
        vm.upiPaymentvalidBank = false;
        return;
      }
      vm.upiAccountNumber = vm.formData.bankInfo.accountNumber;
      vm.upiBankName = vm.formData.bankInfo.bankName;
      vm.formData.bankInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
      vm.upiPaymentvalidBank = true;
    }
    vm.checkForMinorBankListCondition = function(){
      return vm.formData.minorFlag
        // && !vm.formData.cgfFlag
    };

    function getAccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.accountTypeList = resp.data.bankAccountTypes;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          MessageService.error(err)
        };

      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  'NEW'
      }).$promise.then(success, error);
    }

    function resetUPIForm() {
      vm.verifyUPIResp = {};
      vm.isUPIVerified = false;
      (vm.formData.bankInfo)&&(vm.formData.bankInfo.virtualAddress = "");
    }

    function verifyUPI() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.verifyUPIResp = resp.data;
            if(resp.data.valid){
              vm.name = resp.data.name;
              vm.isUPIVerified = true;
            } else {
              vm.isUPIVerified = false;
            }
          }
          else {
            vm.isUPIVerified = false;
            vm.verifyUPIResp.valid = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();

      investorServiceVersion.post({
        child1: 'upi',
        child2: 'check',
        child3: 'virtualAddress'
      }, {
        "virtualAddress":vm.formData.bankInfo.virtualAddress,
        "basketFlow": false,
        "folioNo": null,
        "transactionType": vm.transactionType,
        "ecartFlow": false
      }).$promise.then(success, error);
    }

    function fetchMandateValidations(cb) {
      cb = cb || function () {
      };
      UtilService.fetchMandateValidations().then(function (resp) {
        vm.emandateUpiData = resp;
        if (vm.formData.sipPaymentOption=='UPI') {
          vm.emandateObj = vm.emandateUpiData.upi;
        } else if (vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          vm.emandateObj = vm.emandateUpiData.eOTM;
        }
        vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
        cb(true)
      }).catch(function(resp) {
        MessageService.error(resp)
      });
    }

    function handleVpa() {
      if (vm.formData.bankInfo.virtualAddress) {
        vm.formData.bankInfo.virtualAddress = vm.formData.bankInfo.virtualAddress.toLowerCase();
        vm.verifyUPIResp={};
      }
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SummaryPageController', summaryPageController);

  /** @ngInject */
  function summaryPageController($window, $rootScope, $filter, $timeout, InvestorFileUploadServiceV3, $state, $stateParams, $scope, AuthService, HDFC_API, toastr, LoaderService,
    AppConstants, TransactionService, MessageService, InvestorServiceV3, NewInvestorServiceV3, ModalService, UtilService, CommonFactory, CreatePayloadFactory, InvestorService,
    deviceDetector, $http, $sce, NetcoreEvntService, $location, $log, BrowserService, investorServiceVersion, InvestorServiceVersion3, MetaTagService) {
    var vm = this;
    vm.folioDetails = {};
    vm.folioData = {};
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.emailBelongsToList = vm.TRANSACTIONS_CONST.emailList;
    vm.mobileBelongsToList = vm.TRANSACTIONS_CONST.mobileList;
    vm.userData = JSON.parse(sessionStorage.getItem("verifyObj"));
    vm.holders  = {};
    vm.soleApplicantEmail = null;
    vm.soleApplicantMobile = null;
    vm.belongToListEmail  = null;
    vm.belongToListMobile = null;

    vm.init = function () {
      vm.UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
      vm.taxIdentifierNumber = vm.UserData.panNumber;
      getOccupations();
      getIncomeSlab();
      getCountry();
      getTaxIdType();

      $timeout(function () {
        vm.getFolioDetails();
      }, 1000);
      $rootScope.testObj.steps[1].stepActive = false;
      $rootScope.testObj.steps[1].stepCompleted = true;
    }
    function getOccupations() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorOccupations = resp.data.investorOccupations;
        } else {
          vm.investorOccupations = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in occupation list!");
        };
      InvestorService.get({ child1: 'folio', child2: 'occupation' }).$promise.then(success, error);
    }
    function getIncomeSlab() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.incomeSlabList = resp.data.incomeSlabList;
        } else {
          vm.incomeSlabList = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in income slab list!");
        };
      InvestorService.get({ child1: 'folio', child2: 'income-slab' }).$promise.then(success, error);
    }
    function getCountry() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countries = resp.data.countries;
        } else {
          vm.countries = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in country list!");
        };
      InvestorService.get({ child1: 'folio', child2: 'country-list' }, null).$promise.then(success, error);
    }
    function getTaxIdType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdType = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdType = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in tax id type list!");
        };
      InvestorService.post({ child1: 'folio', child2: 'taxId-type' }, null).$promise.then(success);
    }
    vm.nomineeData = [];
    vm.nomineeCountry = [];
    vm.addressLine1 = [];
    vm.addressLine2 = [];
    vm.countryList = [];
    vm.holderIncomdeslab = [];
    vm.taxIdTypeList = [];
    vm.gAddress = [];
    vm.getFolioDetails = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
          vm.soleApplicantEmail = contactUpdateCo && contactUpdateCo.isEmailEdited ? contactUpdateCo.soleApplicantEditedEmail : resp.data.soleApplicantDetail.personalDetail.kycEmail;
          vm.soleApplicantMobile = contactUpdateCo && contactUpdateCo.isMobileEdited ? contactUpdateCo.soleApplicantEditedMobile : resp.data.soleApplicantDetail.personalDetail.kycMobileNo;
          vm.emailBelongsToList.forEach(function (value) {
            if (value.familyCode == resp.data.soleApplicantDetail.personalDetail.emailBelongsTo) {
              vm.belongToListEmail = value.familyDescription;
            }
          });
          vm.mobileBelongsToList.forEach(function (value) {
            if (value.familyCode == resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo) {
              vm.belongToListMobile = value.familyDescription;
            }
          });
          // vm.belongToListEmail = resp.data.soleApplicantDetail.personalDetail.emailBelongsTo;
          // vm.belongToListMobile = resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo;
        // getOccupations();
        // getIncomeSlab();
        // getCountry();
        // getTaxIdType();
          vm.folioDetails = resp.data;
          vm.folioData.holdmode = resp.data.holdmode;
          vm.nomineeData = resp.data.nominees;
          vm.jointHoldersData = resp.data.jointHolders;

          if(vm.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription =="Individual" ){
            vm.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription = "RESIDENT INDIVIDUAL";
          }
          // holder data
          if (vm.jointHoldersData.length > 0) {
            for (var i = 0; i < vm.jointHoldersData.length; i++) {
              // id type
              if (vm.jointHoldersData[i].fatcaDetail.payTaxInIndia == false) {
                var taxId2 = vm.jointHoldersData[i].fatcaDetail.fatcaTax1.taxIdType;
                vm.taxIdTypeList = vm.taxIdType.filter(function(character){character.value === taxId2});
              } else {
                vm.taxIdTypeList.push('-');
              }

              //  country
              var jointholdercountryId = vm.jointHoldersData[i].fatcaDetail.birthCountry;
              vm.countryList = vm.countries.filter(function(character){character.countryCode === jointholdercountryId});

              // income
              var incomeId = vm.jointHoldersData[i].grossAnnualIncome;
              vm.holderIncomdeslab = vm.incomeSlabList.filter(function(character){character.incomeCode === incomeId});
            }
          }

          // end holder
          if (vm.nomineeData.length === 0) {

          } else {
            for (var i = 0; i < vm.nomineeData.length; i++) {

              if (Object.keys(vm.nomineeData[i].nomineeAddress).length === 0) {
                var ncountryId = vm.nomineeData[i].guardianAddress.country;
                if (ncountryId && ncountryId != "") {
                  vm.countries.forEach(function (value) {
                    if (value.countryCode == ncountryId) {
                      vm.nomineeCountry.push(value);
                    }
                  });
                }else{
                  vm.nomineeCountry.push(null);
                }
                vm.addressLine1.push(vm.nomineeData[i].guardianAddress.addressLine1);
                vm.addressLine2.push(vm.nomineeData[i].guardianAddress.addressLine2);
                vm.gAddress.push(true);

              } else if (Object.keys(vm.nomineeData[i].guardianAddress).length === 0) {

                var ncountryId = vm.nomineeData[i].nomineeAddress.country;
                if (ncountryId && ncountryId != "") {
                  vm.countries.forEach(function (value) {
                    if (value.countryCode == ncountryId) {
                      vm.nomineeCountry.push(value);
                    }
                  });
                }else{
                  vm.nomineeCountry.push(null);
                }
                vm.addressLine1.push(vm.nomineeData[i].nomineeAddress.addressLine1);
                vm.addressLine2.push(vm.nomineeData[i].nomineeAddress.addressLine2);
                vm.gAddress.push(false);

              }
            }
            if (vm.folioDetails.sebiNomineeRegulatory01650Active) {
              getPersonalIdentifier();
            }
          }

          if (vm.folioDetails.minor) {
            // getOccupations();
            var occupationId = vm.folioDetails.soleApplicantDetail.minorDetail.guardian.occupation;
            vm.investorOccupations.forEach(function (item) {
              if (item.occupationCode === occupationId) {
                vm.occupationData = item;
              }
            });
            // getIncomeSlab();
            var grossincomeId = vm.folioDetails.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
            vm.incomeSlabList.forEach(function (item) {
              if (item.incomeCode === grossincomeId) {
                vm.grossIncomeData = item;
              }
            });

            // getCountry();
            var countryId = vm.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry;
            vm.countries.forEach(function (item) {
              if (item.countryCode === countryId) {
                vm.countryData = item;
              }
            });
            // getTaxIdType();
            if (vm.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1) {
              var taxId = vm.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxIdType;
              vm.taxIdType.forEach(function (item) {
                if (item.value === taxId) {
                  vm.taxIdDetails = item;
                }
              });
            }
          } else {
            getOccupations();
            getIncomeSlab();
            getCountry();
            getTaxIdType();

            var occupationId = vm.folioDetails.soleApplicantDetail.selfDetail.occupation;
            vm.investorOccupations.forEach(function (item) {
              if (item.occupationCode === occupationId) {
                vm.occupationData = item;
              }
            });


            var grossincomeId = vm.folioDetails.soleApplicantDetail.selfDetail.grossAnnualIncome;
            vm.incomeSlabList.forEach(function (item) {
              if (item.incomeCode === grossincomeId) {
                vm.grossIncomeData = item;
              }
            });

            var countryId = vm.folioDetails.soleApplicantDetail.selfDetail.fatca.birthCountry;
            vm.countries.forEach(function (item) {
              if (item.countryCode === countryId) {
                vm.countryData = item;
              }
            });

            if (vm.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1) {
              var taxId = vm.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxIdType;
              vm.taxIdType.forEach(function (item) {
                if (item.value === taxId) {
                  vm.taxIdDetails = item;
                }
              });
            }
          }

          if (vm.folioDetails.bankDetails) {
            var accId = vm.folioDetails.bankDetails.accountType;
            $rootScope.AccountTypes.forEach(function (item) {
              if (item.accountTypeCode === accId) {
                vm.bank = item;
              }
            });
          }
          if (vm.folioDetails.bankDetails) {
            var payoutMechanismId = vm.folioDetails.bankDetails.payoutMechanism;
            $rootScope.payoutMechanismData.forEach(function (item) {
              if (item.payoutCode === payoutMechanismId) {
                vm.payoutDescriptionData = item;
              }
            });
          }


        }
      },
        error = function (err) {
          MessageService.error(err);
        };
      var investorId = localStorage.getItem("folioId");
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'getDetails' }, { id: investorId }).$promise.then(success, error);
    }

    vm.createNewFolio = function () {

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (resp.data.folioDataInvalid) {
            var success = function() {
              vm.logout();
            }, error = function(resp) {
              vm.logout();
            };
            ModalService.genericModal({
              text: resp.data.message
            }, success, error);
          } else {
            vm.folioData.folioNumber = resp.data.folioNumber;
            vm.folioData.panNumber = vm.UserData.panNumber;
            localStorage.setItem("folioDataCreate", resp.data);
            sessionStorage.removeItem('retirementSchemeSelected');
            var panevent = $('#callModal');
            panevent.click();
          }
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          // MessageService.error(err);
          var panevent = $('#callModal');
          panevent.click();
          // vm.getModal() called here
        };
        LoaderService.showLoader();
      NewInvestorServiceV3.post({
        child1: 'folio',
        child2: 'createNew'
      }, { id: localStorage.getItem("folioId") }
      ).$promise.then(success, error);
    }

    vm.getModal = function () {

      ModalService.folioSuccssModal(vm.folioData);
    }
    vm.backpage = function () {
      $state.go('newInvestor.folioDetails.baiscDetails');
    }

    vm.openUploadedDoc = function (url) {
      ModalService.showImage1({ docUrl: url });
    };

    // Edit nav
    vm.gotoMinorBasic = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $rootScope.minornext(0);
      $state.go('newInvestor.folioDetails.baiscMinorDetails');
    }
    vm.gotoMinorGuardian = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $rootScope.minornext(1);
      $state.go('newInvestor.folioDetails.guardianMinorDetails');
    }
    vm.gotoBankPage = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $state.go('newInvestor.folioDetails.bankdetails');
    }
    vm.gotofolioBasic = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $state.go('newInvestor.folioDetails.incomeDetails');
    }
    vm.gotoIncomePage = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $state.go('newInvestor.folioDetails.incomeDetails');
    }
    vm.gotoHolderPage = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $state.go('newInvestor.folioDetails.jointHolderDetails');
    }
    vm.gotoNomineePage = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $state.go('newInvestor.folioDetails.nomineeDetails');
    }


    vm.stepperForMinor = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true,
      }, {
        step: 2,
        name: "Guardian Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 3,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }
      ]
    };

    vm.stepperThird = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true,
      }, {
        step: 2,
        name: "Income Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 3,
        name: "Nominee Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 4,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }
      ]
    };

    vm.stepperForAnyoneSurvivor = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true,
      }, {
        step: 2,
        name: "Income Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 3,
        name: "Holder Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 4,
        name: "Nominee Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 5,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }
      ]
    };

    vm.logout = function(){
      var success = function (resp) {
        if (resp.status) {
          MessageService.success(resp.message);
          sessionStorage.clear();
          $state.go('newInvestor.kycVerification');
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader('.logout');
      },
      error = function (err) {
        LoaderService.hideLoader('.logout');
        MessageService.error(err.data.message);
      };
      LoaderService.showLoader('.logout');
      var Details = JSON.parse(sessionStorage.getItem("verifyObj"));
      var Data = {
        "panNumber": vm.taxIdentifierNumber
      };
      InvestorService.post({
        child1: 'force',
        child2: 'logout'
      }, Data).$promise.then(success, error);
    }

    function getPersonalIdentifier(cb) {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.applicantPersonalIdentifiers = resp.data.identityProofs;
          vm.nomineeData.forEach(function(obj, index) {
            vm.applicantPersonalIdentifiers.forEach(function(identity) {
              if (obj.identityProofType === identity.identityProofType) {
                obj.identityProofDescription = identity.identityProof;
              }
            });
          });
        } else {
          vm.applicantPersonalIdentifiers = [];
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.applicantPersonalIdentifiers = [];
      };
      InvestorService.get({
        child1: 'identity-proofs'
      }).$promise.then(success, error);
    }



  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioNomineeDetailsController', FolioNomineeDetailsController);

  /** @ngInject */
  function FolioNomineeDetailsController(InvestorService, investorServiceVersion, $scope, $state, $stateParams, $cookies, $window, AppConstants, UtilService, AuthService, $log, LoaderService,
    InvestorFolioModel, $rootScope, $location, InvestorServiceV3, NewInvestorServiceV3, $http, InvestorProfilePhotoService, MessageService, ModalService, $timeout, KycService, DynamicDataNominee) {
    var vm = this;
    vm.viewMode = "days";
    vm.dateErrorMessage = "";
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.conformation = localStorage.getItem('conformation') == "true" ? true : false;
    vm.minorMinDate = null;
    vm.minorMaxDate = null;
    vm.majorMinDate = null;
    vm.majorMaxDate = null;
    vm.addAddress = false;
    $rootScope.historyLocation.push($location.$$path);
    vm.addressLine1 = "";
    vm.addressLine2 = "";
    vm.country = "";
    vm.city = "";
    vm.pinCode = "";
    $rootScope.folioBasicDetail.folioForUser = 'Self';
    $rootScope.myState = $state.current.url;
    vm.updateOldNomineeData = updateOldNomineeData;
    vm.updatePercentage = updatePercentage;
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.DynamicDataNominee = DynamicDataNominee;
    vm.UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
    vm.showNomineeUpdate = false;
    vm.emailPattern = AppConstants.email_regex;
    vm.mobilePattern = AppConstants.mobile_regex_with_country;
    vm.nomineeValidateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.errorMessageMobile = AppConstants.ToastrMessage.VALIDATE_DATA.MOBILE_SAME_INVESTOR;
    vm.errorMessageNomineeLicense = AppConstants.ToastrMessage.VALIDATE_DATA.DRIVING_LICENSE_ALREADY_EXIST;
    vm.errorMessageNomineeAadhaar = AppConstants.ToastrMessage.VALIDATE_DATA.AADHAAR_ALREADY_EXIST;
    vm.errorMessageNominee = AppConstants.ToastrMessage.VALIDATE_DATA.NOMINEE_PAN_SAME;
    vm.errorMessageEmail = AppConstants.ToastrMessage.VALIDATE_DATA.EMAILID_SAME_INVESTOR;
    vm.errorMessagePassportNumber = AppConstants.ToastrMessage.VALIDATE_DATA.PASSPORT_ALREADY_EXIST;
    vm.nomineeLicenseValid = true;
    vm.nomineeAadhaarValid = true;
    vm.nomineePANValid = true;
    vm.nomineePassportValid = true;
    vm.nomineeEnum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      3: 'Fourth',
      4: 'Fifth',
      5: 'Sixth',
      6: 'Seventh',
      7: 'Eighth',
      8: 'Ninth',
      9: 'Tenth'
    };
    vm.incapcitationList = [];
    vm.setincapcitationList = setincapcitationList;
    vm.nomineeLicenseChanged = nomineeLicenseChanged;
    vm.nomineeAadhaarChanged = nomineeAadhaarChanged;
    vm.nomineePanChanged = nomineePanChanged;
    vm.changePersonalIdentifier = changePersonalIdentifier;
    vm.selectedNominee = selectedNominee;
    vm.setStatement = setStatement;
    vm.nomineeEmailChanged = nomineeEmailChanged;
    vm.passportChanged = passportChanged;
    vm.nomineeRegistrationCO = {};
    vm.nomineeRegistrationCO.incapacitationDeclaration = {};
    vm.nomineeRegistrationCO.accountHoldingDeclaration = {};

    vm.currentNomineeValue = 0;
    vm.maxNominee = 3;

    vm.init = function () {
      vm.getPayload();
      getRelationshipList();
      getStateList();
    }

    vm.deleteNominee = function (index) {

      // handling aadhar, pan and license same value index changes on deletion
      if (vm.nominees[index].hasOwnProperty('aadharCard') && vm.nominees[index].aadharCard) {
        // if (vm.nominees[index].sameIndex && vm.nominees[index].sameIndex.length === 1) {
        //
        //   vm.nominees[vm.nominees[index].sameIndex[0]].sameIndex = [];
        //   vm.nominees[vm.nominees[index].sameIndex[0]].nomineeAadhaarInvalid = false;
        //   vm.nominees[index].sameIndex = [];
        //   vm.nominees[index].nomineeAadhaarInvalid = false;
        //
        //   vm.nominees.forEach(function (el) {
        //
        //     if (el.sameIndex && el.sameIndex.length > 0) {
        //       el.sameIndex.forEach(function (val,indexE) {
        //         if (el.sameIndex[indexE] > index) {
        //           el.sameIndex[indexE] = el.sameIndex[indexE] === 0 ? 0 : el.sameIndex[indexE] - 1;
        //         }
        //       })
        //     }
        //   })
        //
        //
        //   for(var i = 0 ; i < vm.nominees.length ; i ++) {
        //     if (vm.nominees[i].sameIndex && vm.nominees[i].sameIndex.length === 0) {
        //       vm.nomineeAadhaarValid = true;
        //     } else if (vm.nominees[i].sameIndex && vm.nominees[i].sameIndex.length !== 0)  {
        //       vm.nomineeAadhaarValid = false;
        //       break;
        //     }
        //   }
        //
        // } else if(vm.nominees[index].sameIndex && vm.nominees[index].sameIndex.length > 1) {
        //
        //   vm.nominees[index].sameIndex.forEach(function (el) {
        //
        //     if (vm.nominees[el].sameIndex && vm.nominees[el].sameIndex.length === 1) {
        //       vm.nominees[el].sameIndex = [];
        //       vm.nominees[el].nomineeAadhaarInvalid = false;
        //     } else {
        //       var indexEL = vm.nominees[el].sameIndex.indexOf(index);
        //       vm.nominees[el].sameIndex.splice(indexEL,1);
        //
        //
        //       // updating index of aadhar same elements
        //       vm.nominees[el].sameIndex.forEach(function (val,indexE) {
        //         if (vm.nominees[el].sameIndex[indexE] > index) {
        //           vm.nominees[el].sameIndex[indexE] = vm.nominees[el].sameIndex[indexE] === 0 ? 0 : vm.nominees[el].sameIndex[indexE] - 1;
        //         }
        //       })
        //
        //     }
        //
        //   })
        //
        // }



        // updating liscense and pan index value when value with aadhar is deleted

        for(var i = 0 ; i < vm.nominees.length ; i ++) {

          if (vm.nominees[i].hasOwnProperty('drivingLicense') && vm.nominees[i].sameIndexLiscense) {
            vm.nominees[i].sameIndexLiscense.forEach(function (el, indexE) {
              if (vm.nominees[i].sameIndexLiscense[indexE] > index) {
                vm.nominees[i].sameIndexLiscense[indexE] = vm.nominees[i].sameIndexLiscense[indexE] === 0 ? 0 : vm.nominees[i].sameIndexLiscense[indexE] - 1;
              }
            })
          } else {
            vm.nominees[i].sameIndexLiscense = [];
          }


          if (vm.nominees[i].hasOwnProperty('panNumber') && vm.nominees[i].sameIndexPan) {
            vm.nominees[i].sameIndexPan.forEach(function (el, indexE) {
              if (vm.nominees[i].sameIndexPan[indexE] > index) {
                vm.nominees[i].sameIndexPan[indexE] = vm.nominees[i].sameIndexPan[indexE] === 0 ? 0 : vm.nominees[i].sameIndexPan[indexE] - 1;
              }
            })
          } else {
            vm.nominees[i].sameIndexPan = [];
          }

          if (vm.nominees[i].hasOwnProperty('passport') && vm.nominees[i].sameIndexPassport) {
            vm.nominees[i].sameIndexPassport.forEach(function (el, indexE) {
              if (vm.nominees[i].sameIndexPassport[indexE] > index) {
                vm.nominees[i].sameIndexPassport[indexE] = vm.nominees[i].sameIndexPassport[indexE] === 0 ? 0 : vm.nominees[i].sameIndexPassport[indexE] - 1;
              }
            })
          } else {
            vm.nominees[i].sameIndexPassport = [];
          }

        }


      }

      if (vm.nominees[index].hasOwnProperty('drivingLicense') && vm.nominees[index].drivingLicense) {
        if (vm.nominees[index].sameIndexLiscense && vm.nominees[index].sameIndexLiscense.length === 1) {

          vm.nominees[vm.nominees[index].sameIndexLiscense[0]].sameIndexLiscense = [];
          vm.nominees[vm.nominees[index].sameIndexLiscense[0]].nomineeLicenseInvalid = false;
          vm.nominees[index].sameIndexLiscense = [];
          vm.nominees[index].nomineeLicenseInvalid = false;


          vm.nominees.forEach(function (el) {

            if (el.sameIndexLiscense && el.sameIndexLiscense.length > 0) {
              el.sameIndexLiscense.forEach(function (val,indexE) {
                if (el.sameIndexLiscense[indexE] > index) {
                  el.sameIndexLiscense[indexE] = el.sameIndexLiscense[indexE] === 0 ? 0 : el.sameIndexLiscense[indexE] - 1;
                }
              })
            }

          })


          for(var i = 0 ; i < vm.nominees.length ; i ++) {
            if (vm.nominees[i].sameIndexLiscense && vm.nominees[i].sameIndexLiscense.length === 0) {
              vm.nomineeLicenseValid = true;
            } else if (vm.nominees[i].sameIndexLiscense && vm.nominees[i].sameIndexLiscense.length !== 0)  {
              vm.nomineeLicenseValid = false;
              break;
            }
          }


        } else if(vm.nominees[index].sameIndexLiscense && vm.nominees[index].sameIndexLiscense.length > 1) {

          vm.nominees[index].sameIndexLiscense.forEach(function (el) {

            if (vm.nominees[el].sameIndexLiscense && vm.nominees[el].sameIndexLiscense.length === 1) {
              vm.nominees[el].sameIndexLiscense = [];
              vm.nominees[el].nomineeLicenseInvalid = false;
            } else {
              var indexEL = vm.nominees[el].sameIndexLiscense.indexOf(index);
              vm.nominees[el].sameIndexLiscense.splice(indexEL,1);

              vm.nominees[el].sameIndexLiscense.forEach(function (val,indexE) {
                if (vm.nominees[el].sameIndexLiscense[indexE] > index) {
                  vm.nominees[el].sameIndexLiscense[indexE] = vm.nominees[el].sameIndexLiscense[indexE] === 0 ? 0 : vm.nominees[el].sameIndexLiscense[indexE] - 1;
                }
              })

            }

          })

        }


        // updating passport and pan index value when value with liscense is deleted

        for(var i = 0 ; i < vm.nominees.length ; i ++) {

          if (vm.nominees[i].hasOwnProperty('passport') && vm.nominees[i].sameIndexPassport) {
            vm.nominees[i].sameIndexPassport.forEach(function (el, indexE) {
              if (vm.nominees[i].sameIndexPassport[indexE] > index) {
                vm.nominees[i].sameIndexPassport[indexE] = vm.nominees[i].sameIndexPassport[indexE] === 0 ? 0 : vm.nominees[i].sameIndexPassport[indexE] - 1;
              }
            })
          } else {
            vm.nominees[i].sameIndexPassport = [];
          }

          if (vm.nominees[i].hasOwnProperty('panNumber') && vm.nominees[i].sameIndexPan) {
            vm.nominees[i].sameIndexPan.forEach(function (el, indexE) {
              if (vm.nominees[i].sameIndexPan[indexE] > index) {
                vm.nominees[i].sameIndexPan[indexE] = vm.nominees[i].sameIndexPan[indexE] === 0 ? 0 : vm.nominees[i].sameIndexPan[indexE] - 1;
              }
            })
          } else {
            vm.nominees[i].sameIndexPan = [];
          }
        }
      }

      if (vm.nominees[index].hasOwnProperty('panNumber') && vm.nominees[index].panNumber) {
        if (vm.nominees[index].sameIndexPan && vm.nominees[index].sameIndexPan.length === 1) {

          vm.nominees[vm.nominees[index].sameIndexPan[0]].sameIndexPan = [];
          vm.nominees[vm.nominees[index].sameIndexPan[0]].nomineePANInvalid = false;
          vm.nominees[index].sameIndexPan = [];
          vm.nominees[index].nomineePANInvalid = false;


          vm.nominees.forEach(function (el) {

            if (el.sameIndexPan && el.sameIndexPan.length > 0) {
              el.sameIndexPan.forEach(function (val,indexE) {
                if (el.sameIndexPan[indexE] > index) {
                  el.sameIndexPan[indexE] = el.sameIndexPan[indexE] === 0 ? 0 : el.sameIndexPan[indexE] - 1;
                }
              })
            }

          })


          for(var i = 0 ; i < vm.nominees.length ; i ++) {
            if (vm.nominees[i].sameIndexPan && vm.nominees[i].sameIndexPan.length === 0) {
              vm.nomineePANValid = true;
            } else if (vm.nominees[i].sameIndexPan && vm.nominees[i].sameIndexPan.length !== 0)  {
              vm.nomineePANValid = false;
              break;
            }
          }


        } else if(vm.nominees[index].sameIndexPan && vm.nominees[index].sameIndexPan.length > 1) {

          vm.nominees[index].sameIndexPan.forEach(function (el) {

            if (vm.nominees[el].sameIndexPan && vm.nominees[el].sameIndexPan.length === 1) {
              vm.nominees[el].sameIndexPan = [];
              vm.nominees[el].nomineePANInvalid = false;
            } else {
              var indexEL = vm.nominees[el].sameIndexPan.indexOf(index);
              vm.nominees[el].sameIndexPan.splice(indexEL,1);

              vm.nominees[el].sameIndexPan.forEach(function (val,indexE) {
                if (vm.nominees[el].sameIndexPan[indexE] > index) {
                  vm.nominees[el].sameIndexPan[indexE] = vm.nominees[el].sameIndexPan[indexE] === 0 ? 0 : vm.nominees[el].sameIndexPan[indexE] - 1;
                }
              })

            }

          })

        }


        // updating passport and liscense index value when value with pan is deleted

        for(var i = 0 ; i < vm.nominees.length ; i ++) {

          if (vm.nominees[i].hasOwnProperty('passport') && vm.nominees[i].sameIndexPassport) {
            vm.nominees[i].sameIndexPassport.forEach(function (el, indexE) {
              if (vm.nominees[i].sameIndexPassport[indexE] > index) {
                vm.nominees[i].sameIndexPassport[indexE] = vm.nominees[i].sameIndexPassport[indexE] === 0 ? 0 : vm.nominees[i].sameIndexPassport[indexE] - 1;
              }
            })
          } else {
            vm.nominees[i].sameIndexPassport = [];
          }

          if (vm.nominees[i].hasOwnProperty('drivingLicense') && vm.nominees[i].sameIndexLiscense) {
            vm.nominees[i].sameIndexLiscense.forEach(function (el, indexE) {
              if (vm.nominees[i].sameIndexLiscense[indexE] > index) {
                vm.nominees[i].sameIndexLiscense[indexE] = vm.nominees[i].sameIndexLiscense[indexE] === 0 ? 0 : vm.nominees[i].sameIndexLiscense[indexE] - 1;
              }
            })
          } else {
            vm.nominees[i].sameIndexLiscense = [];
          }

        }
      }

      if (vm.nominees[index].hasOwnProperty('passport') && vm.nominees[index].passport) {
        if (vm.nominees[index].sameIndexPassport && vm.nominees[index].sameIndexPassport.length === 1) {

          vm.nominees[vm.nominees[index].sameIndexPassport[0]].sameIndexPassport = [];
          vm.nominees[vm.nominees[index].sameIndexPassport[0]].nomineePassportInvalid = false;
          vm.nominees[index].sameIndexPassport = [];
          vm.nominees[index].nomineePassportInvalid = false;


          vm.nominees.forEach(function (el) {

            if (el.sameIndexPassport && el.sameIndexPassport.length > 0) {
              el.sameIndexPassport.forEach(function (val,indexE) {
                if (el.sameIndexPassport[indexE] > index) {
                  el.sameIndexPassport[indexE] = el.sameIndexPassport[indexE] === 0 ? 0 : el.sameIndexPassport[indexE] - 1;
                }
              })
            }

          })


          for(var i = 0 ; i < vm.nominees.length ; i ++) {
            if (vm.nominees[i].sameIndexPassport && vm.nominees[i].sameIndexPassport.length === 0) {
              vm.nomineePassportValid = true;
            } else if (vm.nominees[i].sameIndexPassport && vm.nominees[i].sameIndexPassport.length !== 0)  {
              vm.nomineePassportValid = false;
              break;
            }
          }


        } else if(vm.nominees[index].sameIndexPassport && vm.nominees[index].sameIndexPassport.length > 1) {

          vm.nominees[index].sameIndexPassport.forEach(function (el) {

            if (vm.nominees[el].sameIndexPassport && vm.nominees[el].sameIndexPassport.length === 1) {
              vm.nominees[el].sameIndexPassport = [];
              vm.nominees[el].nomineePassportInvalid = false;
            } else {
              var indexEL = vm.nominees[el].sameIndexPassport.indexOf(index);
              vm.nominees[el].sameIndexPassport.splice(indexEL,1);

              vm.nominees[el].sameIndexPassport.forEach(function (val,indexE) {
                if (vm.nominees[el].sameIndexPassport[indexE] > index) {
                  vm.nominees[el].sameIndexPassport[indexE] = vm.nominees[el].sameIndexPassport[indexE] === 0 ? 0 : vm.nominees[el].sameIndexPassport[indexE] - 1;
                }
              })

            }

          })

        }


        // updating driving lincense and pan index value when value with liscense is deleted
        for(var i = 0 ; i < vm.nominees.length ; i ++) {

          if (vm.nominees[i].hasOwnProperty('drivingLicense') && vm.nominees[i].sameIndexLiscense) {
            vm.nominees[i].sameIndexLiscense.forEach(function (el, indexE) {
              if (vm.nominees[i].sameIndexLiscense[indexE] > index) {
                vm.nominees[i].sameIndexLiscense[indexE] = vm.nominees[i].sameIndexLiscense[indexE] === 0 ? 0 : vm.nominees[i].sameIndexLiscense[indexE] - 1;
              }
            })
          } else {
            vm.nominees[i].sameIndexLiscense = [];
          }

          if (vm.nominees[i].hasOwnProperty('panNumber') && vm.nominees[i].sameIndexPan) {
            vm.nominees[i].sameIndexPan.forEach(function (el, indexE) {
              if (vm.nominees[i].sameIndexPan[indexE] > index) {
                vm.nominees[i].sameIndexPan[indexE] = vm.nominees[i].sameIndexPan[indexE] === 0 ? 0 : vm.nominees[i].sameIndexPan[indexE] - 1;
              }
            })
          } else {
            vm.nominees[i].sameIndexPan = [];
          }
        }
      }

      // handling aadhar, pan and license same value index changes on deletion

      if (index > -1) {
        vm.nominees.splice(index, 1)
      }

      // if (index === 1) {
      //   vm.shownextSteps1 = false;
      // } else if (index === 2) {
      //   vm.shownextSteps2 = false;
      // }


      vm.numberofnominees = vm.nominees.length;
      MessageService.success("Nominee deteleted success.");
      vm.nomineePan = "";
      vm.guardianName = "";
      vm.guardianRelation = "";
      vm.guardianPan = "";
      vm.addressLine1 = "";
      vm.addressLine2 = "";
      vm.country = "";
      vm.state = "";
      vm.city = "";
      vm.pinCode = "";
      vm.countPercentage();
      vm.currentNominee(0);
    }

    vm.startval = 0;
    vm.addanotherNominee = true;
    vm.countPercentage = function () {
      vm.totalpercent = vm.startval;
      vm.totalShare = vm.startval;

      angular.forEach(vm.nominees, function (p) {
        if (p.percentage) {
          vm.totalpercent = vm.totalpercent + parseInt(p.percentage);
        }
      });

      vm.totalShare = vm.totalpercent;
      if (vm.totalShare == 100) {
        vm.addanotherNominee = false;
      } else {
        if (vm.totalShare < 100) {
          vm.addanotherNominee = true;
        }
      }
    }
    vm.guardianRelationshipList = [
      {
        "relationDesc": "Mother",
        "value": "MOTHER"
      },
      {
        "relationDesc": "Father",
        "value": "FATHER"
      },
      {
        "relationDesc": "Legal Guardian",
        "value": "LEGAL_GUARDIAN"
      }
    ];
    vm.shownextSteps1 = false;
    vm.shownextSteps2 = false;
    vm.extraNomineeVar = false;

    vm.addnewnominee = function (form) {
      vm.fromForm = form;
      vm.numberofnominees = vm.nominees.length;
      vm.totalShare = 0;
      vm.countPercentage();
      // if (vm.totalShare == 100) {
      //   vm.submitNomineeData();
      //   return;
      // }

      if (vm.totalShare != 100 && vm.nominees.length === 0) {
        vm.totalShare = vm.totalpercent + parseInt(vm.nomineeDetails.percentage);
      } else {
        vm.totalShare = angular.copy(vm.totalpercent);
      }

      if (vm.numberofnominees <= vm.maxNominee && (vm.totalShare <= 100)) {

        if (vm.numberofnominees === vm.maxNominee && (vm.totalShare < 100)) {
          MessageService.error('Total sum of nominee proportion should be 100');
          return;
        }

        if (vm.nomineeDetails.minor) {
          vm.nomineeDetails.guardianName = vm.guardianName;
          vm.nomineeDetails.guardianRelationWithNominee = vm.guardianRelation;
          vm.nomineeDetails.guardianPanNumber = vm.guardianPan;
          vm.nomineeDetails.nomineePan = angular.copy(vm.nomineePan);
        } else {
          vm.nomineeDetails.guardianName = vm.guardianName;
          vm.nomineeDetails.guardianRelationWithNominee = vm.guardianRelation;
          vm.nomineeDetails.guardianPanNumber = vm.guardianPan;
          vm.nomineeDetails.minor = false;
        }
        if (!vm.nomineeDetails.minor) {
          vm.nomineeDetails.panNumber = vm.nomineePan;
          vm.nomineeDetails.nomineeAddress = {};
          vm.nomineeDetails.nomineeAddress.addressLine1 = vm.addressLine1;
          vm.nomineeDetails.nomineeAddress.addressLine2 = vm.addressLine2;
          vm.nomineeDetails.nomineeAddress.country = vm.country ? vm.country : "";
          vm.nomineeDetails.nomineeAddress.state = vm.state;
          vm.nomineeDetails.nomineeAddress.city = vm.city ? vm.city: "";
          vm.nomineeDetails.nomineeAddress.pinCode = vm.pinCode;
          if (vm.currentNomineeValue !== undefined) {
            vm.nominees.splice(vm.currentNomineeValue , 1 , vm.nomineeDetails)
          } else {
            vm.nominees[vm.currentNomineeValue] = vm.nomineeDetails;
          }
        } else {
          // var incomdeData = JSON.parse(sessionStorage.getItem("incomeDetails"));
          vm.nomineeDetails.guardianAddress = {};
          vm.nomineeDetails.guardianAddress.addressLine1 = vm.addressLine1;
          vm.nomineeDetails.guardianAddress.addressLine2 = vm.addressLine2;
          vm.nomineeDetails.panNumber = vm.nomineePan;
          vm.nomineeDetails.guardianAddress.country = vm.country ? vm.country : "";;
          vm.nomineeDetails.guardianAddress.city = vm.city ? vm.city: "";
          vm.nomineeDetails.guardianAddress.pinCode = vm.pinCode;
          vm.nomineeDetails.guardianAddress.state = vm.state;

          if (vm.currentNomineeValue !== undefined) {
            vm.nominees.splice(vm.currentNomineeValue , 1 , vm.nomineeDetails)
          } else {
            vm.nominees[vm.currentNomineeValue] = vm.nomineeDetails;
          }
          MessageService.success("Added Nominee");
        }

        if (vm.nominees.length === 1) {

          if(vm.nomineeDetails.aadharCard) {
            vm.nominees[vm.currentNomineeValue].identityProofNumber = angular.copy(vm.nomineeDetails.aadharCard);
            // vm.nomineeAadhaarValid = true;
            // vm.nominees[vm.currentNomineeValue].nomineeAadhaarInvalid = false;
          }

          if (vm.nomineeDetails.drivingLicense) {
            vm.nominees[vm.currentNomineeValue].identityProofNumber = angular.copy(vm.nomineeDetails.drivingLicense);
            vm.nomineeLicenseValid = true;
            vm.nominees[vm.currentNomineeValue].nomineeLicenseInvalid = false;
          }

          if (vm.nomineeDetails.panNumber) {
            vm.nominees[vm.currentNomineeValue].identityProofNumber = angular.copy(vm.nomineeDetails.panNumber);
            vm.nomineePANValid = true;
            vm.nominees[vm.currentNomineeValue].nomineePANInvalid = false;
          }

          if (vm.nomineeDetails.passport) {
            vm.nominees[vm.currentNomineeValue].identityProofNumber = angular.copy(vm.nomineeDetails.passport);
            vm.nomineePassportValid = true;
            vm.nominees[vm.currentNomineeValue].nomineePassportInvalid = false;
          }
          if (vm.nomineeDetails.identityProofCamsCode) {
            vm.nominees[vm.currentNomineeValue].identityProofCamsCode = angular.copy(vm.nomineeDetails.identityProofCamsCode);
          }

        }

        vm.nomineeDetails = {
          nomineeName: "",
          nomineeRelation: "",
          panNumber: "",
          percentage: 0,
          dob: ""
        };
        vm.numberofnominees = vm.nominees.length;
        vm.currentNominee(vm.currentNomineeValue);
      }
      else {
        if (vm.numberofnominees > vm.maxNominee) {
          var text = 'You cant add more than ' + vm.maxNominee + 'nominee';
          MessageService.error(text);
        } else if (vm.numberofnominees <= vm.maxNominee && vm.totalShare > 100) {
          MessageService.error('Total sum of nominee proportion should be 100');
        }
      }
      vm.countPercentage();

      if (vm.numberofnominees < vm.maxNominee) {
        if (vm.totalShare == 100) {;
          vm.extraNomineeVar = false;
          vm.submitNomineeData();
        } else {
          if (vm.totalShare < 100) {
            vm.extraNomineeVar = true;
          }
          vm.currentNominee(vm.currentNomineeValue);
        }
      }

      // if (vm.numberofnominees == 2) {
      //   if (vm.totalShare == 100) {
      //     vm.shownextSteps2 = false;
      //     vm.extraNomineeVar = false;
      //     vm.submitNomineeData();
      //   } else {
      //     if (vm.totalShare < 100) {
      //       vm.extraNomineeVar = true;
      //     }
      //     vm.currentNominee(1);
      //   }
      // }

        if (vm.numberofnominees == vm.maxNominee) {
          if (vm.totalShare == 100) {
            vm.shownextSteps2 = false;
            vm.extraNomineeVar = false;
            vm.submitNomineeData();
          }
        }

        vm.countPercentage();
    }
    vm.proceed = true;
    vm.checkpan = function () {
      if (vm.guardianName && vm.guardianRelation && vm.guardianPan) {
        if(vm.guardianPan == vm.nomineePan){
          MessageService.error("Guardian PAN should not be same as Nominee PAN");
          vm.guardianPan = "";
          vm.proceed = false;
        }else{
          vm.proceed = true;
        }
      } else if (!vm.showNomineeUpdate){
        vm.proceed = false;
      }
    }
    vm.checkgNmae = function () {
      if (vm.guardianName && vm.guardianRelation) {
        vm.proceed = true;
      } else if (!vm.showNomineeUpdate) {
        vm.proceed = false;
      }
    }

    vm.checkGRelation = function () {
      if (vm.guardianName && vm.guardianRelation) {
        vm.proceed = true;
      } else if (!vm.showNomineeUpdate) {
        vm.proceed = false;
      }
    }


    vm.addExtraNomineeFun = function () {
      vm.numberofnominees = vm.nominees.length;

      if (vm.numberofnominees < vm.maxNominee) {
        // vm.shownextSteps1 = true;
        vm.currentNominee(vm.currentNomineeValue + 1);
        vm.extraNomineeVar = false;
      }

      // if (vm.numberofnominees == 2) {
      //   vm.shownextSteps2 = true;
      //   vm.currentNominee(2);
      //   vm.extraNomineeVar = false;
      // }
    }

    vm.showDeleteBtn = false;

    vm.currentNominee = function (val, userTriggered) {

      // updating data on tab change
      if (userTriggered) {
        vm.updateOldNomineeData();
      }

      if (val == vm.maxNominee) {
        val = 0;
      }

      vm.currentNomineeValue = val;
      if (vm.nominees.length > val) {
        try {
          vm.showDeleteBtn = true;
          vm.currentNomineeValue = val;
          vm.data = angular.copy(vm.nominees[val]);
          vm.nomineeDetails = {
            nomineeName: vm.data.nomineeName,
            nomineeRelation: vm.data.nomineeRelation,
            percentage: vm.data.percentage,
            dob: vm.data.dob,
            minor: vm.data.minor
          };

          if (vm.showNomineeUpdate) {
            vm.nomineeDetails.emailId = vm.data.emailId;
            vm.nomineeDetails.mobileNumber = vm.data.mobileNumber;
            vm.nomineeDetails.applicantPersonalIdentifiers = vm.data.applicantPersonalIdentifiers;
            vm.nomineeDetails.identityProofType = vm.data.identityProofType;
            vm.nomineeDetails.identityProofCamsCode = vm.data.identityProofCamsCode;

            if (vm.data.aadharCard) {
              vm.nomineeDetails.aadharCard = vm.data.aadharCard;
              vm.nomineeDetails.drivingLicense = null;
              vm.nomineePan = null;
              vm.nomineeDetails.panNumber = null;
              vm.nomineeDetails.passport = null;
              // vm.nomineeDetails.sameIndex = vm.data.sameIndex;
              // vm.nomineeDetails.nomineeAadhaarInvalid = vm.data.nomineeAadhaarInvalid;
            }

            if (vm.data.drivingLicense) {
              vm.nomineeDetails.drivingLicense = vm.data.drivingLicense;
              vm.nomineeDetails.sameIndexLiscense = vm.data.sameIndexLiscense;
              vm.nomineeDetails.nomineeLicenseInvalid = vm.data.nomineeLicenseInvalid;
              vm.nomineeDetails.aadharCard = null;
              vm.nomineePan = null;
              vm.nomineeDetails.panNumber = null;
              vm.nomineeDetails.passport = null;
            }

            if (vm.data.passport) {
              vm.nomineeDetails.passport = vm.data.passport;
              vm.nomineeDetails.sameIndexPassport = vm.data.sameIndexPassport;
              vm.nomineeDetails.nomineePassportInvalid = vm.data.nomineePassportInvalid;
              vm.nomineeDetails.aadharCard = null;
              vm.nomineePan = null;
              vm.nomineeDetails.panNumber = null;
              vm.nomineeDetails.drivingLicense = null;
            }
          }

          if (vm.data.panNumber) {
            vm.nomineePan = angular.copy(vm.data.panNumber);
            vm.nomineeDetails.sameIndexPan = vm.data.sameIndexPan;
            vm.nomineeDetails.nomineePANInvalid = vm.data.nomineePANInvalid;
            vm.nomineeDetails.aadharCard = null;
            vm.nomineeDetails.drivingLicense = null;
          }

          if (vm.data.minor) {
            vm.guardianName = vm.data.guardianName;
            vm.guardianRelation = vm.data.guardianRelationWithNominee;
            vm.guardianPan = vm.data.guardianPanNumber;
            vm.nomineeDetails.minor = true;
          }

          if (vm.data.nomineeAddress && Object.keys(vm.data.nomineeAddress).length > 0) {
            if(vm.data.nomineeAddress.pinCode == "" || vm.data.nomineeAddress.pinCode == undefined){
                vm.addAddress = true;
              }
              else{
                vm.addAddress = false;
              }
            vm.addressLine1 = vm.data.nomineeAddress.addressLine1;
            vm.addressLine2 = vm.data.nomineeAddress.addressLine2;
            vm.country = vm.data.nomineeAddress.country;
            vm.city = vm.data.nomineeAddress.city;
            vm.pinCode = vm.data.nomineeAddress.pinCode;
            vm.state = vm.data.nomineeAddress.state;
          } else if (vm.data.guardianAddress && Object.keys(vm.data.guardianAddress).length > 0) {
            if(vm.data.guardianAddress.pinCode == "" || vm.data.guardianAddress.pinCode == undefined){
              vm.addAddress = true;
            }
            if(vm.data.guardianAddress.pinCode){
              vm.addAddress = false;
            }
            vm.addressLine1 = vm.data.guardianAddress.addressLine1;
            vm.addressLine2 = vm.data.guardianAddress.addressLine2;
            vm.country = vm.data.guardianAddress.country;
            vm.city = vm.data.guardianAddress.city;
            vm.pinCode = vm.data.guardianAddress.pinCode;
            vm.state = vm.data.guardianAddress.state;
          }
        }
        catch (e) {
          console.log(e);
        }
      } else {
        vm.showDeleteBtn = false;
        vm.nomineeDetails = {
          // nomineeName: "",
          // nomineeRelation: "",
          // percentage: 0,
          // dob: "",
          // minor: true
        };
        vm.addressLine1 = "";
        vm.addressLine2 = "",
        vm.pinCode = "",
        vm.city = "",
        vm.country = ""
        vm.state = "";
        vm.guardianName ="";
        vm.guardianRelation = "";
        vm.guardianPan = "";
        vm.nomineePan = "";

        vm.nomineeDetails.applicantPersonalIdentifiers = angular.copy(vm.applicantPersonalIdentifiers);

        // pushing empty data for maintaining nominee list
        vm.nomineeDetails.sameIndexLiscense = [];
        vm.nomineeDetails.sameIndexPan = [];
        vm.nominees.push(vm.nomineeDetails);

        if (vm.fromForm) {
          vm.fromForm.$setPristine();
          vm.fromForm.$setUntouched();
        }
      }
      vm.changeFolioMinor(true);
    }



    vm.addnominee = false;
    vm.shownomineeList = false;
    vm.nominees = [];
    vm.nomineeDetails = {
      nomineeName: "",
      nomineeRelation: "",
      percentage: 0,
      dob: "",
      minor: false
    };
    vm.nomineeDetails.sameIndexLiscense = [];
    vm.nomineeDetails.sameIndexPan = [];
    vm.numberofnominees = vm.nominees.length;
    vm.totalpercent;


    vm.addNomineeNewAddress = function () {
      vm.addAddress = !vm.addAddress;
    }



    vm.addnomineedata = function (value) {
      if (value == 1) {
        vm.addnominee = true;
      }
      else {
        vm.addnominee = false;
        vm.nominees = [];
        if (vm.payload.nomineeRegistrationCO.incapacitationDeclaration) {
          delete vm.payload.nomineeRegistrationCO.incapacitationDeclaration;
          vm.incapcitationNomineeIndex = null;
        }
      }
    }
    vm.getNomineeDob = function (date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.nomineeDetails.dob = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.age = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.nomineeDetails.minor) {
          //  minor
          if ((vm.currentNomineeValue !== 'undefined') && (vm.nominees[vm.currentNomineeValue])) {
            if (vm.nominees[vm.currentNomineeValue].guardianName && vm.nominees[vm.currentNomineeValue].guardianRelationWithNominee) {
              vm.proceed = true;
            } else if (!vm.showNomineeUpdate){
              vm.proceed = false;
            }
          } else if (!vm.showNomineeUpdate) {
            vm.proceed = false;
          }
          vm.nomineePan = null;
        }
        else {
          vm.proceed = true;
          vm.guardianPan = null
        }



        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.nomineeDetails.dob = "";
      }
      return;
    }
    vm.getconformation = function () {
      vm.conformation = !vm.conformation;
      if(vm.conformation == true){
        localStorage.setItem("conformation", "true")
      } else if (vm.conformation == false){
        localStorage.setItem("conformation", "false")
      }
    }
    vm.getNewUserDetails = function () {
      var success = function (resp) {
        localStorage.setItem("folioId", resp.data.folioCreationDraftId);
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
      var taxIdentifier = UserData.panNumber;
      var payload = {
        "panNumber": taxIdentifier
      }
      InvestorService.post({ child1: 'new', child2: 'user', child3: 'getDetails' }, payload).$promise.then(success, error);
    }
    vm.getNewUserDetails();

    vm.getPayload = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.payload = resp.data;
          vm.holdeMode = resp.data.holdmode;
          $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
          var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");

          if (isEditbuttonClick && $rootScope.folioBasicDetail.folioHoldingMode == "SINGLE") {
            $rootScope.nextStep(0);
            $rootScope.nextStep(1);
            sessionStorage.removeItem("investorIsEditButtonClick");
          } else {
            $rootScope.nextStep(0);
            $rootScope.nextStep(1);
            $rootScope.nextStep(2);
            sessionStorage.removeItem("investorIsEditButtonClick");
          }

          vm.nominees = resp.data.nominees;

          if (vm.nominees && vm.nominees.length > 0) {
            vm.nominees.forEach(function (nominee) {
              if (nominee.identityProofType) {
                if (nominee.identityProofType == "AADHAR_CARD") {
                  nominee.aadharCard = angular.copy(nominee.identityProofNumber);
                } else if (nominee.identityProofType == "DRIVING_LICENSE") {
                  nominee.drivingLicense = angular.copy(nominee.identityProofNumber);
                } else if (nominee.identityProofType == "PASSPORT") {
                  nominee.passport = angular.copy(nominee.identityProofNumber);
                } else {
                  nominee.panNumber = angular.copy(nominee.identityProofNumber);
                }
                nominee.sameIndexLiscense = [];
                nominee.sameIndexPan = [];
              }
            })
          }
          getPersonalIdentifier();

          setincapcitationList();
          if (resp.data.nomineeRegistrationCO && resp.data.nomineeRegistrationCO.incapacitationDeclaration) {
            vm.incapcitationNomineeIndex = angular.copy(resp.data.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber - 1);
            selectedNominee();
          }

          if (resp.data.nomineeRegistrationCO && resp.data.nomineeRegistrationCO.accountHoldingDeclaration) {

            if (resp.data.nomineeRegistrationCO.accountHoldingDeclaration === 'NOMINATION_YES') {
              vm.nomination = true;
            }

            if (resp.data.nomineeRegistrationCO.accountHoldingDeclaration === 'NOMINATION_NO') {
              vm.nomination = false;
            }

          } else {
            vm.payload.nomineeRegistrationCO = {};
            vm.payload.nomineeRegistrationCO.accountHoldingDeclaration = 'NOMINATION_YES';
            vm.nomination = true;
          }

          vm.countPercentage();
          if (vm.nominees.length > 0) {
            vm.currentNominee(0);
            vm.addnomineedata(1);

            vm.numberofnominees = vm.nominees.length;

            if (vm.numberofnominees < vm.maxNominee) {
              if (vm.totalShare == 100) {
                vm.currentNominee(0);
              } else {
                vm.shownextSteps1 = true;
              }
            }

            // if (vm.numberofnominees == 2) {
            //   if (vm.totalShare == 100) {
            //     vm.shownextSteps2 = false;
            //     vm.shownextSteps1 = true;
            //     vm.currentNominee(0);
            //   } else {
            //     vm.shownextSteps2 = true;
            //   }
            // }

            if (vm.numberofnominees == vm.maxNominee) {
              if (vm.totalShare == 100) {
                vm.shownextSteps2 = true;
                vm.shownextSteps1 = true;
                vm.currentNominee(0);
              }
            }
          }
          vm.numberofnominees = vm.nominees.length;
          localStorage.setItem('folioId', resp.data.id);
          vm.showNomineeUpdate = resp.data.sebiNomineeRegulatory01650Active;
          vm.maxNominee = resp.data.nomineeLimit;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(err.message);
        };
      var investorId = localStorage.getItem("folioId");
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'getDetails' }, { id: investorId }).$promise.then(success, error);
    }

    vm.getPayload();

  vm.setState = function(index){
    if (!vm.country) {
      vm.state = null;
    }
    if(vm.country != 'IN'){
      vm.state = "XX";
    }else{
      vm.state = "XX";
    }
  }

    vm.submitNomineeData = function () {
      var dobValidate = false;
          vm.nominees.forEach(function(item,index) {
            if(item.minor && !item.dob){
              MessageService.error("Nominee"+(index+1)+" Date of Birth is manditory field");
              dobValidate = true;
            }
          });
          if(dobValidate){
            return;
          }
      var success = function (resp) {
        if (resp.status && resp.data) {
          if (vm.holdeMode == 'SINGLE') {
            $rootScope.nextStep(2);
            $state.go('newInvestor.folioDetails.bankdetails');
          } else {
            $state.go('newInvestor.folioDetails.bankdetails');
            $rootScope.nextStep(3);
          }
        } else {
          if(resp.popupEnabled){
            ModalService.genericModal({
              text: resp.message
            });
            } else{
              MessageService.error(resp.message);
            }
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      if (vm.addnominee) {
        vm.payload.nominees = vm.nominees;
        vm.payload.nominees.forEach(function(item) {
          if (!item.identityProofNumber) {
            if (item.identityProofType == "AADHAR_CARD") {
              item.identityProofNumber = angular.copy(item.aadharCard);
              item.sameIndex = null;
            } else if (item.identityProofType == "DRIVING_LICENSE") {
              item.identityProofNumber = angular.copy(item.drivingLicense);
              item.sameIndexLiscense = null;
            } else if (item.identityProofType == "PASSPORT") {
              item.identityProofNumber = angular.copy(item.passport);
              item.sameIndexPassport = null;
            } else {
              item.identityProofNumber = angular.copy(item.panNumber);
              item.sameIndex = null;
            }
          }
        })
      } else {
        vm.payload.nominees = [];
      }

      $window.smartech('dispatch', 'nominee details', {
        'addnominee': vm.addnominee
      });

      vm.payload.nominees = vm.nominees;
      vm.payload.id = localStorage.getItem("folioId");
      vm.payload.folioSaveStep = "FOUR";
      vm.payload.brokerCode = "DIRECT";
      vm.payload.nriFlag = vm.UserData ? !vm.UserData.taxStatusResident : null;
      if(vm.distributorDetails){
        if(vm.distributorDetails.arn){
          vm.payload.arnCode = 'ARN-'+vm.distributorDetails.arn;
          vm.payload.brokerCode = 'ARN-'+vm.distributorDetails.arn;
        }
        if(vm.distributorDetails.riaCode){
          vm.payload.arnCode = vm.distributorDetails.riaCode;
        }
        if(vm.distributorDetails.empCode){
          if(vm.distributorDetails.arn){
            vm.payload.arnCode = 'ARN-'+vm.distributorDetails.arn;
          }else{
            vm.payload.arnCode = 'ARN-DIRECT';
          }
        }
        vm.payload.oneClick = true;
      }
      vm.countPercentage();

      if (vm.payload.nomineeRegistrationCO && vm.payload.nomineeRegistrationCO.incapacitationDeclaration && !vm.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName) {
        delete vm.payload.nomineeRegistrationCO.incapacitationDeclaration;
      }

      if (vm.addnominee) {
        if (vm.totalShare == 100) {
          if(vm.payload.holdmode == 'SINGLE'){
            if(vm.payload.jointHolders.length == 0){
              NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.payload).$promise.then(success, error);
            }
            else{
              MessageService.error("Mode of holding cannot be Single for multiple holder's");
            }
          }else{
            if(vm.payload.holdmode == 'ANY_OR_SURVIVOR'){
              if(vm.payload.jointHolders.length != 0){
                NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.payload).$promise.then(success, error);
              }else{
                MessageService.error("Mode of holding cannot be Single for multiple holder's");
              }
            }

          }
        } else {
          MessageService.error('Total sum of percentage is 100 required!');
        }
      } else {

        if (vm.payload.nomineeRegistrationCO) {
          delete vm.payload.nomineeRegistrationCO;
        }

        if(vm.payload.holdmode == 'SINGLE'){
          if(vm.payload.jointHolders.length == 0){
             NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.payload).$promise.then(success, error);
          }
          else{
            MessageService.error("Mode of holding cannot be Single for multiple holder's");
          }
        }else{
          if(vm.payload.holdmode == 'ANY_OR_SURVIVOR'){
            if(vm.payload.jointHolders.length != 0){
               NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.payload).$promise.then(success, error);
            }else{
              MessageService.error("Mode of holding cannot be Single for multiple holder's");
            }
          }

        }

      }
    }

    vm.autoDate = function () {
      vm.dobString = $("#nomineedob").val();;
      if (vm.dobString.length == 2) {
        $("#nomineedob").val(vm.dobString + "-");
      }
      if (vm.dobString.length == 5) {
        $("#nomineedob").val(vm.dobString + "-");
      }
    }
    vm.datethreeToTwo = function (date) {
      var dateChar = date.split("-");
      switch (dateChar[1]) {
        case "Jan":
          vm.cdate = dateChar[0] + "-01-" + dateChar[2];
          return vm.cdate;
          break;
        case "Feb":
          vm.cdate = dateChar[0] + "-02-" + dateChar[2];
          return vm.cdate;
          break;
        case "Mar":
          vm.cdate = dateChar[0] + "-03-" + dateChar[2];
          return vm.cdate;
          break;
        case "Apr":
          vm.cdate = dateChar[0] + "-04-" + dateChar[2];
          return vm.cdate;
          break;
        case "May":
          vm.cdate = dateChar[0] + "-05-" + dateChar[2];
          return vm.cdate;
          break;
        case "Jun":
          vm.cdate = dateChar[0] + "-06-" + dateChar[2];
          return vm.cdate;
          break;
        case "Jul":
          vm.cdate = dateChar[0] + "-07-" + dateChar[2];
          return vm.cdate;
          break;
        case "Aug":
          vm.cdate = dateChar[0] + "-08-" + dateChar[2];
          return vm.cdate;
          break;
        case "Sep":
          vm.cdate = dateChar[0] + "-09-" + dateChar[2];
          return vm.cdate;
          break;
        case "Oct":
          vm.cdate = dateChar[0] + "-10-" + dateChar[2];
          return vm.cdate;
          break;
        case "Nov":
          vm.cdate = dateChar[0] + "-11-" + dateChar[2];
          return vm.cdate;
          break;
        case "Dec":
          vm.cdate = dateChar[0] + "-12-" + dateChar[2];
          return vm.cdate;
          break;
        default:
          return "wrong date.";
      }
    }

    vm.datetwoTothree = function (date) {
      var dateChar = date.split("-");
      switch (dateChar[1]) {
        case "01":
          vm.cdate = dateChar[0] + "-Jan-" + dateChar[2];
          return vm.cdate;
          break;
        case "02":
          vm.cdate = dateChar[0] + "-Feb-" + dateChar[2];
          return vm.cdate;
          break;
        case "03":
          vm.cdate = dateChar[0] + "-Mar-" + dateChar[2];
          return vm.cdate;
          break;
        case "04":
          vm.cdate = dateChar[0] + "-Apr-" + dateChar[2];
          return vm.cdate;
          break;
        case "05":
          vm.cdate = dateChar[0] + "-May-" + dateChar[2];
          return vm.cdate;
          break;
        case "06":
          vm.cdate = dateChar[0] + "-Jun-" + dateChar[2];
          return vm.cdate;
          break;
        case "07":
          vm.cdate = dateChar[0] + "-Jul-" + dateChar[2];
          return vm.cdate;
          break;
        case "08":
          vm.cdate = dateChar[0] + "-Aug-" + dateChar[2];
          return vm.cdate;
          break;
        case "09":
          vm.cdate = dateChar[0] + "-Sep-" + dateChar[2];
          return vm.cdate;
          break;
        case "10":
          vm.cdate = dateChar[0] + "-Oct-" + dateChar[2];
          return vm.cdate;
          break;
        case "11":
          vm.cdate = dateChar[0] + "-Nov-" + dateChar[2];
          return vm.cdate;
          break;
        case "12":
          vm.cdate = dateChar[0] + "-Dec-" + dateChar[2];
          return vm.cdate;
          break;
        default:
          return "wrong date.";
      }
    }

    vm.applicantRelationShip = [];
    function getRelationshipList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.applicantRelationShip = resp.data.nomineeRelationshipList;
        } else {
          vm.applicantRelationShip = [];
          MessageService.error(resp.message);
        }
      },error = function (err) {
        vm.applicantRelationShip = [];
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'nominee',
        child3: 'relation'
      }).$promise.then(success, error);
    }
    vm.stateList = [];
    function getStateList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.stateList = resp.data.states;
        } else {
          vm.stateList = [];
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.stateList = [];
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'state',
        child3: 'list'
      }).$promise.then(success, error);
    }

    function updateOldNomineeData() {

      if (vm.numberofnominees <= vm.maxNominee && (vm.totalShare <= 100)) {
        if (vm.nomineeDetails.minor) {
          vm.nomineeDetails.guardianName = vm.guardianName;
          vm.nomineeDetails.guardianRelationWithNominee = vm.guardianRelation;
          vm.nomineeDetails.guardianPanNumber = vm.guardianPan;
          vm.nomineeDetails.nomineePan = angular.copy(vm.nomineePan);
        } else {
          vm.nomineeDetails.guardianName = vm.guardianName;
          vm.nomineeDetails.guardianRelationWithNominee = vm.guardianRelation;
          vm.nomineeDetails.guardianPanNumber = vm.guardianPan;
          vm.nomineeDetails.minor = false;
        }

        if (!vm.nomineeDetails.minor) {
          vm.nomineeDetails.panNumber = vm.nomineePan;
          vm.nomineeDetails.nomineeAddress = {};
          vm.nomineeDetails.nomineeAddress.addressLine1 = vm.addressLine1;
          vm.nomineeDetails.nomineeAddress.addressLine2 = vm.addressLine2;
          vm.nomineeDetails.nomineeAddress.country = vm.country ? vm.country : "";
          vm.nomineeDetails.nomineeAddress.state = vm.state;
          vm.nomineeDetails.nomineeAddress.city = vm.city ? vm.city : "";
          vm.nomineeDetails.nomineeAddress.pinCode = vm.pinCode;

          // if (vm.nominees[vm.currentNomineeValue].sameIndex) {
          //   vm.nomineeDetails.sameIndex = angular.copy(vm.nominees[vm.currentNomineeValue].sameIndex);
          //   vm.nomineeDetails.nomineeAadhaarInvalid = angular.copy(vm.nominees[vm.currentNomineeValue].nomineeAadhaarInvalid);
          // }

          if (vm.nominees && vm.nominees.length > 0 && vm.nominees[vm.currentNomineeValue].sameIndexLiscense) {
            vm.nomineeDetails.sameIndexLiscense = angular.copy(vm.nominees[vm.currentNomineeValue].sameIndexLiscense);
            vm.nomineeDetails.nomineeLicenseInvalid = angular.copy(vm.nominees[vm.currentNomineeValue].nomineeLicenseInvalid);
          }

          if (vm.nominees && vm.nominees.length > 0 && vm.nominees[vm.currentNomineeValue].sameIndexPan) {
            vm.nomineeDetails.sameIndexPan = angular.copy(vm.nominees[vm.currentNomineeValue].sameIndexPan);
            vm.nomineeDetails.nomineePANInvalid = angular.copy(vm.nominees[vm.currentNomineeValue].nomineePANInvalid);
          }

          if (vm.currentNomineeValue !== undefined) {
            vm.nominees.splice(vm.currentNomineeValue, 1, vm.nomineeDetails)
          } else {
            vm.nominees.push(vm.nomineeDetails);
          }
        } else {
          // var incomdeData = JSON.parse(sessionStorage.getItem("incomeDetails"));
          vm.nomineeDetails.guardianAddress = {};
          vm.nomineeDetails.guardianAddress.addressLine1 = vm.addressLine1;
          vm.nomineeDetails.guardianAddress.addressLine2 = vm.addressLine2;
          vm.nomineeDetails.panNumber = vm.nomineePan;
          vm.nomineeDetails.guardianAddress.country = vm.country ? vm.country : "";
          vm.nomineeDetails.guardianAddress.city = vm.city ? vm.city : "";
          vm.nomineeDetails.guardianAddress.pinCode = vm.pinCode;
          vm.nomineeDetails.guardianAddress.state = vm.state;

          // vm.nomineeDetails.sameIndex = angular.copy(vm.nominees[vm.currentNomineeValue].sameIndex);
          // vm.nomineeDetails.nomineeAadhaarInvalid = angular.copy(vm.nominees[vm.currentNomineeValue].nomineeAadhaarInvalid);

          vm.nomineeDetails.sameIndexLiscense = angular.copy(vm.nominees[vm.currentNomineeValue].sameIndexLiscense);
          vm.nomineeDetails.nomineeLicenseInvalid = angular.copy(vm.nominees[vm.currentNomineeValue].nomineeLicenseInvalid);

          vm.nomineeDetails.sameIndexPan = angular.copy(vm.nominees[vm.currentNomineeValue].sameIndexPan);
          vm.nomineeDetails.nomineePANInvalid = angular.copy(vm.nominees[vm.currentNomineeValue].nomineePANInvalid);


          if (vm.currentNomineeValue !== undefined) {
            vm.nominees.splice(vm.currentNomineeValue, 1, vm.nomineeDetails)
          } else {
            vm.nominees.push(vm.nomineeDetails);
          }
        }
      }
    }

    function updatePercentage() {
      if ((vm.nominees !== 0) && (vm.currentNomineeValue !== undefined) && (vm.nominees[vm.currentNomineeValue])) {
        vm.nominees[vm.currentNomineeValue].percentage = vm.nomineeDetails.percentage;
      }
    }

    vm.checkPanValid = function(){
      var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
        var taxIdentifier = UserData.panNumber;
        if(vm.nomineePan == taxIdentifier){
          vm.nomineePan = '';
          MessageService.error("Nominee's PAN should not be same as Investor's PAN");
        }
        if (vm.guardianName && vm.guardianRelation && vm.guardianPan) {
          if(vm.guardianPan == vm.nomineePan){
            MessageService.error("Nominee PAN should not be same as Guardian PAN");
            vm.nomineePan = '';
          }
        }

        if (vm.showNomineeUpdate) {
          vm.nomineePanChanged(vm.nomineePan);
        }

    }

    vm.changeFolioMinor = function(data){
      if(!data){
        vm.nomineeDetails.dob = null;
      }
      var currentDate = Date();
      var parsedDate = $window.moment(currentDate).format("DD-MMM-YYYY");
      var initiateDate = new Date('January 01, 1900 00:00:00');
        vm.minorMinDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.minorMaxDate = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
        vm.majorMinDate = $window.moment(Date.parse(initiateDate));
        vm.majorMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');

      if (vm.nomineeDetails.minor) {
        vm.nomineeDetails.applicantPersonalIdentifiers = angular.copy(vm.applicantPersonalIdentifiersMinor);
      } else {
        vm.nomineeDetails.applicantPersonalIdentifiers = angular.copy(vm.applicantPersonalIdentifiers);
      }
      setincapcitationList();
      // vm.incapcitationNomineeIndex = vm.incapcitationNomineeIndex === vm.currentNomineeValue ? null : vm.incapcitationNomineeIndex;
    }

    vm.changeFolioMinor(true);


    /**
     * function responsible to fethcing and setting personal identifier dropdown list
     */

    function getPersonalIdentifier() {

      var success = function (resp) {

        vm.applicantPersonalIdentifiers = [];
        vm.applicantPersonalIdentifiersMinor = [];

        if (resp.status && resp.data) {
          var personalIdentifierList = resp.data.identityProofs;
          personalIdentifierList.forEach(function(el) {

            vm.applicantPersonalIdentifiers.push({
              name : el.identityProof,
              value : el.identityProofType,
              identityProofCamsCode: el.identityProofCamsCode
            });

            if (el.identityProofType !== 'DRIVING_LICENSE') {
              vm.applicantPersonalIdentifiersMinor.push({
                name : el.identityProof,
                value : el.identityProofType,
                identityProofCamsCode: el.identityProofCamsCode
              });
            }
          });


          vm.nomineeDetails.applicantPersonalIdentifiers = vm.nomineeDetails.minor ? angular.copy(vm.applicantPersonalIdentifiersMinor) : angular.copy(vm.applicantPersonalIdentifiers);

          if (vm.nominees && vm.nominees.length > 0) {
            vm.nominees.forEach(function (nominee) {
              if (nominee.minor) {
                nominee.applicantPersonalIdentifiers = angular.copy(vm.applicantPersonalIdentifiersMinor);
              } else {
                nominee.applicantPersonalIdentifiers = angular.copy(vm.applicantPersonalIdentifiers);
              }
            })
          }

          LoaderService.hideLoader();
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };


      LoaderService.showLoader();

      InvestorService.get({
        child1: 'identity-proofs'
      }).$promise.then(success, error);

    }


    function setincapcitationList() {

      vm.incapcitationList = [];
      vm.currentNomineeValue = vm.currentNomineeValue ?  vm.currentNomineeValue : 0;

      // when nominees array is filled iterate and fill the data
      vm.nominees && vm.nominees.forEach(function(nominee, index) {
        if (nominee.nomineeName) {

          if (index === vm.currentNomineeValue) {
            nominee.minor = vm.nomineeDetails.minor
          }

          vm.incapcitationList.push(angular.copy({
            key : nominee.nomineeName + '-' + vm.nomineeEnum[index],
            value : index,
            isMinor : nominee.minor,
            index : index
          }));
        }
      })

      // add current tab data
      if (vm.nomineeDetails.nomineeName) {
        if (vm.incapcitationList.length > 0 && vm.incapcitationList[vm.currentNomineeValue]) {
          vm.incapcitationList[vm.currentNomineeValue].key = vm.nomineeDetails.nomineeName + '-' + vm.nomineeEnum[vm.currentNomineeValue];
        } else {
          vm.incapcitationList.push(angular.copy({
            key : vm.nomineeDetails.nomineeName + '-' + vm.nomineeEnum[vm.currentNomineeValue],
            value : vm.currentNomineeValue,
            isMinor : vm.nomineeDetails.minor
          }));
        }
      }

    }

    /**
     * function responsible  for validating nominees license same check
     * @param  {String}   license - entered license number
     */

    function nomineeLicenseChanged(license) {

      if (vm.nominees.length === 0 || !license) {
        return;
      }

      if(license) {
        vm.nominees[vm.currentNomineeValue].identityProofNumber = angular.copy(license);
      }

      vm.nomineeLicenseValid = true;
      vm.nominees[vm.currentNomineeValue].nomineeLicenseInvalid = false;
      if (!vm.nominees[vm.currentNomineeValue].sameIndexLiscense) {
        vm.nominees[vm.currentNomineeValue].sameIndexLiscense = [];
      }

      if (vm.nominees.length == 1) {
        vm.nomineeLicenseValid = true;
      } else if (vm.nominees.length > 1) {

        for(var i = 0 ; i < vm.nominees.length ; i ++) {

          if (i !== vm.currentNomineeValue && vm.nominees[i].hasOwnProperty('drivingLicense') && vm.nominees[i].drivingLicense === license) {
            vm.nominees[vm.currentNomineeValue].nomineeLicenseInvalid = true;
            vm.nominees[i].nomineeLicenseInvalid = true;
            vm.nominees[vm.currentNomineeValue].sameIndexLiscense.push(i);
            if (!vm.nominees[i].sameIndexLiscense) {
              vm.nominees[i].sameIndexLiscense = [];
            }
            vm.nominees[i].sameIndexLiscense.push(vm.currentNomineeValue);
            vm.nomineeLicenseValid = false;
          } else if (i !== vm.currentNomineeValue && vm.nominees[i].hasOwnProperty('drivingLicense')) {

            vm.nomineeLicenseValid = true;

            if (!vm.nominees[i].sameIndexLiscense) {
              vm.nominees[i].sameIndexLiscense = [];
            }

            if (vm.nominees[vm.currentNomineeValue].sameIndexLiscense.includes(i)) {
              var indexEL = vm.nominees[vm.currentNomineeValue].sameIndexLiscense.indexOf(i);
              vm.nominees[vm.currentNomineeValue].sameIndexLiscense.splice(indexEL,1);

              indexEL = vm.nominees[i].sameIndexLiscense.indexOf(vm.currentNomineeValue);
              vm.nominees[i].sameIndexLiscense.splice(indexEL,1);

              if (vm.nominees[i].sameIndexLiscense.length === 0) {
                vm.nominees[i].nomineeLicenseInvalid = false;
              }

            }


            if (vm.nominees[vm.currentNomineeValue].sameIndexLiscense && vm.nominees[vm.currentNomineeValue].sameIndexLiscense.length !== 0){
              vm.nomineeLicenseValid = false;
            }


            if (vm.nominees[i].sameIndexLiscense && vm.nominees[i].sameIndexLiscense.length !== 0){
              vm.nomineeLicenseValid = false;
            }

          }
        }

      }

    }

    /**
     * function responsible  for validating nominees aadhar same check
     * @param  {String}   aadhar - entered aadhar
     */

    function nomineeAadhaarChanged(aadhar) {

      // if (vm.nominees.length === 0 || !aadhar) {
      //   return;
      // }
      //
      // if(aadhar) {
      //   vm.nominees[vm.currentNomineeValue].identityProofNumber = angular.copy(aadhar);
      // }
      //
      // vm.nomineeAadhaarValid = true;
      // vm.nominees[vm.currentNomineeValue].nomineeAadhaarInvalid = false;
      //
      // if (!vm.nominees[vm.currentNomineeValue].sameIndex) {
      //   vm.nominees[vm.currentNomineeValue].sameIndex = [];
      // }
      //
      // if (vm.nominees.length == 1) {
      //   vm.nomineeAadhaarValid = true;
      // } else if (vm.nominees.length > 1) {
      //   for(var i = 0 ; i < vm.nominees.length ; i ++) {
      //
      //     if (i !== vm.currentNomineeValue && vm.nominees[i].hasOwnProperty('aadharCard') && vm.nominees[i].aadharCard === aadhar) {
      //       vm.nominees[vm.currentNomineeValue].nomineeAadhaarInvalid = true;
      //       vm.nominees[i].nomineeAadhaarInvalid = true;
      //       vm.nominees[vm.currentNomineeValue].sameIndex.push(i);
      //       if (!vm.nominees[i].sameIndex) {
      //         vm.nominees[i].sameIndex = [];
      //       }
      //       vm.nominees[i].sameIndex.push(vm.currentNomineeValue);
      //       vm.nomineeAadhaarValid = false;
      //     } else if (i !== vm.currentNomineeValue && vm.nominees[i].hasOwnProperty('aadharCard')) {
      //
      //       vm.nomineeAadhaarValid = true;
      //
      //       if (!vm.nominees[i].sameIndex) {
      //         vm.nominees[i].sameIndex = [];
      //       }
      //
      //       if (vm.nominees[vm.currentNomineeValue].sameIndex.includes(i)) {
      //         var indexEL = vm.nominees[vm.currentNomineeValue].sameIndex.indexOf(i);
      //         vm.nominees[vm.currentNomineeValue].sameIndex.splice(indexEL,1);
      //
      //         indexEL = vm.nominees[i].sameIndex.indexOf(vm.currentNomineeValue);
      //         vm.nominees[i].sameIndex.splice(indexEL,1);
      //
      //         if (vm.nominees[i].sameIndex.length === 0) {
      //           vm.nominees[i].nomineeAadhaarInvalid = false;
      //         }
      //
      //       }
      //
      //
      //       if (vm.nominees[vm.currentNomineeValue].sameIndex && vm.nominees[vm.currentNomineeValue].sameIndex.length !== 0){
      //         vm.nomineeAadhaarValid = false;
      //       }
      //
      //       if (vm.nominees[i].sameIndex && vm.nominees[i].sameIndex.length !== 0){
      //         vm.nomineeAadhaarValid = false;
      //       }
      //
      //
      //     }
      //
      //   }
      //
      // }


    }

    /**
     * function responsible  for validating nominees pan same check
     * @param  {String}   pan - entered pan
     */

    function nomineePanChanged(pan) {

      if (vm.nominees.length === 0 || !pan) {
        return;
      }

      if(pan) {
        vm.nominees[vm.currentNomineeValue].identityProofNumber = angular.copy(pan);
      }

      vm.nomineePANValid = true;
      vm.nominees[vm.currentNomineeValue].nomineePANInvalid = false;

      if (!vm.nominees[vm.currentNomineeValue].sameIndexPan) {
        vm.nominees[vm.currentNomineeValue].sameIndexPan = [];
      }

      if (vm.nominees.length == 1) {
        vm.nomineePANValid = true;
      } else if (vm.nominees.length > 1) {
        for(var i = 0 ; i < vm.nominees.length ; i ++) {

          if (i !== vm.currentNomineeValue && vm.nominees[i].hasOwnProperty('panNumber') && vm.nominees[i].panNumber === pan) {
            vm.nominees[vm.currentNomineeValue].nomineePANInvalid = true;
            vm.nominees[i].nomineePANInvalid = true;
            vm.nominees[vm.currentNomineeValue].sameIndexPan.push(i);
            if (!vm.nominees[i].sameIndexPan) {
              vm.nominees[i].sameIndexPan = [];
            }
            vm.nominees[i].sameIndexPan.push(vm.currentNomineeValue);
            vm.nomineePANValid = false;
          } else if (i !== vm.currentNomineeValue && vm.nominees[i].hasOwnProperty('panNumber')) {

            vm.nomineePANValid = true;

            if (!vm.nominees[i].sameIndexPan) {
              vm.nominees[i].sameIndexPan = [];
            }

            if (vm.nominees[vm.currentNomineeValue].sameIndexPan.includes(i)) {
              var indexEL = vm.nominees[vm.currentNomineeValue].sameIndexPan.indexOf(i);
              vm.nominees[vm.currentNomineeValue].sameIndexPan.splice(indexEL,1);

              indexEL = vm.nominees[i].sameIndexPan.indexOf(vm.currentNomineeValue);
              vm.nominees[i].sameIndexPan.splice(indexEL,1);

              if (vm.nominees[i].sameIndexPan.length === 0) {
                vm.nominees[i].nomineePANInvalid = false;
              }

            }

            if (vm.nominees[vm.currentNomineeValue].sameIndexPan && vm.nominees[vm.currentNomineeValue].sameIndexPan.length !== 0){
              vm.nomineePANValid = false;
            }

            if (vm.nominees[i].sameIndexPan && vm.nominees[i].sameIndexPan.length !== 0){
              vm.nomineePANValid = false;
            }


          }

        }

      }


    }

    /**
     * function responsible for handling identfier selection change
     * @param  {String}   identifier - selected identfier value
     */


    function changePersonalIdentifier(identifier) {

      if (vm.nominees.length === 0) {
        vm.nomineeDetails.drivingLicense = null;
        vm.nomineeDetails.aadharCard = null;
        vm.nomineeDetails.panNumber = null;
        vm.nomineeDetails.passport = null;
        vm.nomineePan = null;
        vm.nomineeDetails.applicantPersonalIdentifiers.forEach(function (el) {
          if (el.value === identifier) {
            vm.nomineeDetails.identityProofCamsCode = el.identityProofCamsCode;
          }
        });
      } else {
        vm.nominees[vm.currentNomineeValue].identityProofNumber = null;

        vm.nominees[vm.currentNomineeValue] && vm.nominees[vm.currentNomineeValue].applicantPersonalIdentifiers && vm.nominees[vm.currentNomineeValue].applicantPersonalIdentifiers.map(function (el) {

          if (identifier !== "AADHAR_CARD" && vm.nominees[vm.currentNomineeValue].hasOwnProperty('aadharCard')) {
            vm.nominees[vm.currentNomineeValue].aadharCard = null;
            vm.nomineeDetails.aadharCard = null;
            vm.nomineeAadhaarChanged(vm.nominees[vm.currentNomineeValue].aadharCard);
          }

          if (identifier !== "DRIVING_LICENSE" && vm.nominees[vm.currentNomineeValue].hasOwnProperty('drivingLicense')) {
            vm.nominees[vm.currentNomineeValue].drivingLicense = null;
            vm.nomineeDetails.drivingLicense = null;
            vm.nomineeLicenseChanged(vm.nominees[vm.currentNomineeValue].drivingLicense);
          }

          if (identifier !== "PAN_CARD" && vm.nominees[vm.currentNomineeValue].hasOwnProperty('panNumber')) {
            vm.nominees[vm.currentNomineeValue].panNumber = null;
            vm.nomineePan = null;
            vm.nomineeDetails.panNumber = null;
            vm.nomineePanChanged(vm.nominees[vm.currentNomineeValue].panNumber);
          }

          if (identifier !== "PASSPORT" && vm.nominees[vm.currentNomineeValue].hasOwnProperty('passport')) {
            vm.nominees[vm.currentNomineeValue].passport = null;
            vm.nomineeDetails.passport = null;
            vm.passportChanged(vm.nominees[vm.currentNomineeValue].passport);
          }
          if (el.value === identifier) {
            vm.nominees[vm.currentNomineeValue].identityProofType = el.value;
            vm.nominees[vm.currentNomineeValue].identityProofDescription = el.name;
            vm.nominees[vm.currentNomineeValue].identityProofCamsCode = el.identityProofCamsCode;
            vm.nomineeDetails.identityProofCamsCode = el.identityProofCamsCode;
          }

        });
      }

    }


    /**
     * function responsible  for setting incapacitation number and nominee name
     */

    function selectedNominee() {
      if (vm.incapcitationNomineeIndex !== null) {
        if (!vm.payload.nomineeRegistrationCO.incapacitationDeclaration) {
          vm.payload.nomineeRegistrationCO.incapacitationDeclaration = {};
        }
        vm.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = angular.copy(parseInt(vm.incapcitationNomineeIndex) + 1);
        if (vm.nominees.length === 0) {
          vm.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = angular.copy(vm.nomineeDetails.nomineeName);
        } if (vm.nominees.length > 0) {
          vm.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = angular.copy(vm.nominees[vm.incapcitationNomineeIndex].nomineeName);
        }
      } else if (vm.payload.nomineeRegistrationCO.incapacitationDeclaration){
        delete vm.payload.nomineeRegistrationCO.incapacitationDeclaration;
      }

    }

    /**
     * function responsible  for setting statement declaration payload
     */

    function setStatement() {
      vm.payload.nomineeRegistrationCO.accountHoldingDeclaration = vm.nomination === true ? 'NOMINATION_YES' : 'NOMINATION_NO';
    }

    /**
     * function responsible for validating investor email and nominee email same check
     * @param  {Number}   index - index of current nominee
     * @param  {String}   email - email entered
     */

    function nomineeEmailChanged(email) {
      if (!email) {
        return;
      }


      if (vm.payload.soleApplicantDetail && vm.payload.soleApplicantDetail.personalDetail && vm.payload.soleApplicantDetail.personalDetail.email && email.toLowerCase() === vm.payload.soleApplicantDetail.personalDetail.email.toLowerCase()) {
        vm.emailIdInvalid = true;
      } else {
        vm.emailIdInvalid = false;
      }

    }

    function passportChanged(passport) {
      if (vm.nominees.length === 0 || !passport) {
        return;
      }

      if(passport) {
        vm.nominees[vm.currentNomineeValue].identityProofNumber = angular.copy(passport);
      }

      vm.nomineePassportValid = true;
      vm.nominees[vm.currentNomineeValue].nomineePassportInvalid = false;

      if (!vm.nominees[vm.currentNomineeValue].sameIndexPassport) {
        vm.nominees[vm.currentNomineeValue].sameIndexPassport = [];
      }

      if (vm.nominees.length === 1) {
        vm.nomineePassportValid = true;
      } else if (vm.nominees.length > 1) {
        for(var i = 0 ; i < vm.nominees.length ; i ++) {
          if (i !== vm.currentNomineeValue && vm.nominees[i].hasOwnProperty('passport') && vm.nominees[i].passport === passport) {
            vm.nominees[vm.currentNomineeValue].nomineePassportInvalid = true;
            vm.nominees[i].nomineePassportInvalid = true;
            vm.nominees[vm.currentNomineeValue].sameIndexPassport.push(i);
            if (!vm.nominees[i].sameIndexPassport) {
              vm.nominees[i].sameIndexPassport = [];
            }
            vm.nominees[i].sameIndexPassport.push(index);
            vm.nomineePassportValid = false;
          } else if (i !== index && vm.nominees[i].hasOwnProperty('passport')) {

            if (!vm.nominees[i].sameIndexPassport) {
              vm.nominees[i].sameIndexPassport = [];
            }

            if (vm.nominees[vm.currentNomineeValue].sameIndexPassport.includes(i)) {
              var indexEL = vm.nominees[vm.currentNomineeValue].sameIndexPassport.indexOf(i);
              vm.nominees[vm.currentNomineeValue].sameIndexPassport.splice(indexEL,1);

              indexEL = vm.nominees[i].sameIndexPassport.indexOf(index);
              vm.nominees[i].sameIndexPassport.splice(indexEL,1);

              if (vm.nominees[i].sameIndexPassport.length === 0) {
                vm.nominees[i].nomineePassportValid = false;
              }
            }
            if (vm.nominees[i].sameIndexPassport && vm.nominees[i].sameIndexPassport.length !== 0){
              vm.nomineePassportValid = false;
            }
          }
        }
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioIncomeDetailsController', FolioIncomeDetailsController);

  /** @ngInject */
  function FolioIncomeDetailsController(InvestorService, investorServiceVersion, $http, $scope, $state, $stateParams, $cookies, $window, AppConstants, UtilService, AuthService, $log, LoaderService,
    InvestorFolioModel, $rootScope, InvestorProfilePhotoService,$location, MessageService,InvestorServiceV3,NewInvestorServiceV3, ModalService, $timeout, KycService, InvestorServiceV2) {
    var vm = this;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.dateErrorMessage = "";
    vm.folioIncomeForm = {}
    vm.folioIncomeForm.occupation = '';
    vm.folioIncomeForm.annualincome = '';
    vm.folioIncomeForm.grossAnnualIncomeDate = '';
    vm.folioIncomeForm.Fatca = {};
    vm.folioIncomeForm.Fatca.city = '';
    $rootScope.folioBasicDetail.folioForUser = 'Self';
    vm.networth = false;
    vm.holders  = {};
    vm.soleApplicantEmail = null;
    vm.soleApplicantMobile = null;
    vm.folioIncomeForm.taxstatus = "01";
    vm.folioIncomeForm.Fatca.countrie = "IN";
    vm.folioIncomeForm.Fatca.addressType = "RESIDENTIAL";
    vm.pattern = AppConstants;
    vm.editContactDetails = editContactDetails;
    vm.cancelEditAction = cancelEditAction;
    vm.changeValue = changeValue;
    vm.generateContactUpdateOtp = generateContactUpdateOtp;
    vm.showEmailEditField = false;
    vm.showMobileEditField = false;
    vm.soleApplicantEditedMobile = null;
    vm.soleApplicantEditedEmail = null;
    vm.isEmailEdited = false;
    vm.isMobileEdited = false;
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
    vm.mobileLoginPandetails = sessionStorage.getItem('MobilePanLoginDetails') ? JSON.parse(sessionStorage.getItem('MobilePanLoginDetails')) :null;
    vm.throughMobileLogin = false;
    vm.isMobileLogin =false;
    function fetchBelongsToDropdown(cb) {
      cb = cb ||function () {

      };
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          var tempData = JSON.parse(sessionStorage.getItem("verifyObj"));
          vm.holders  = {};
          vm.belongToListEmail = resp.data.emailList;
          vm.belongToListMobile = resp.data.mobileList;
          LoaderService.hideLoader();
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
        cb();
      },
      error = function (err) {
        $log.info('Belongs Dropdown error >>>>', err);
        LoaderService.hideLoader();
        cb();
      };

      InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
    }
    // vm.fetchBelongsToDropdown();
    $rootScope.myState = $state.current.url;
    vm.getGrossAnnualIncomeDate = function (date) {

      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.folioIncomeForm.grossAnnualIncomeDate = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.grossAnnualIncomeYear = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.grossAnnualIncomeYear < 1 || vm.grossAnnualIncomeYear == 1) {
          // console.log(vm.grossAnnualIncomeYear);
        }
        else {
          vm.folioIncomeForm.grossAnnualIncomeDate = "";
          alert('Not older than 1 year');
        }
        if (!date) {
          vm.dateErrorMessage = vm.validateData.GROSS_ANNUAL_INCOME;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.GROSS_ANNUAL_INCOME;
        vm.folioIncomeForm.grossAnnualIncomeDate = "";
      }
      return;
    }
    vm.networthcall = function () {
      vm.networth = !vm.networth;
      if(vm.networth){
        vm.folioIncomeForm.annualincome = '';
      }else{
        vm.folioIncomeForm.networth = "";
        vm.folioIncomeForm.grossAnnualIncomeDate = "";
      }
    }

    vm.getNewUserDetails = function(){
      var success = function (resp) {
        localStorage.setItem("folioId", resp.data.folioCreationDraftId);
        // console.log(resp.data.folioCreationDraftId);
      },
      error = function (error) {
        MessageService.error(error.message);
      };
      vm.UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
      vm.taxStatusResident = vm.UserData ? vm.UserData.taxStatusResident : true;
      vm.taxIdentifier = vm.UserData.panNumber;
      var payload = {
        "panNumber":vm.taxIdentifier
      }
      InvestorService.post({child1: 'new',child2: 'user',child3: 'getDetails'},payload).$promise.then(success, error);
    }
    fetchBelongsToDropdown(function () {
      vm.getPayload();
    });
   vm.getNewUserDetails();
    vm.getPayload = function() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
            vm.soleApplicantEmailCopy = resp.data.soleApplicantDetail.personalDetail.email;
            vm.soleApplicantMobileCopy = resp.data.soleApplicantDetail.personalDetail.mobileNo;
            if(vm.mobileLoginPandetails && vm.mobileLoginPandetails.mobile){
              if((vm.mobileLoginPandetails.mobile).slice(-10) != (resp.data.soleApplicantDetail.personalDetail.kycMobileNo).slice(-10)){
                var success = function () {
                  vm.loginWithMobileContactUpdated = true;
                  vm.isMobileLogin = true;
                  vm.isMobileEdited = true;
                  vm.showMobileEditField = false;
                  vm.soleApplicantMobile = contactUpdateCo && contactUpdateCo.isMobileEdited ? contactUpdateCo.soleApplicantEditedMobile : vm.mobileLoginPandetails.mobile;
                  vm.throughMobileLogin =true;
                  sessionStorage.setItem('contactUpdateCo', JSON.stringify({
                  isEmailEdited: false,
                  isMobileEdited: vm.isMobileEdited,
                  soleApplicantEditedEmail: vm.soleApplicantEditedEmail,
                  soleApplicantEditedMobile: vm.soleApplicantMobile,
                  isContactDetailUpdated: vm.loginWithMobileContactUpdated
                }));
                }, error = function (err) {
                  UtilService.errorHandler(err); 
                };
                ModalService.loginWithMobileContactUpdateNJModal({mobileNo:vm.mobileLoginPandetails.mobile}, success, error);
              }else{
                vm.throughMobileLogin =false;
                vm.soleApplicantMobile = contactUpdateCo && contactUpdateCo.isMobileEdited ? contactUpdateCo.soleApplicantEditedMobile : resp.data.soleApplicantDetail.personalDetail.kycMobileNo;
              }
            }else{
              vm.soleApplicantMobile = contactUpdateCo && contactUpdateCo.isMobileEdited ? contactUpdateCo.soleApplicantEditedMobile : resp.data.soleApplicantDetail.personalDetail.kycMobileNo;
            }
          vm.soleApplicantEmail = contactUpdateCo && contactUpdateCo.isEmailEdited ? contactUpdateCo.soleApplicantEditedEmail : resp.data.soleApplicantDetail.personalDetail.email;
            //  vm.soleApplicantMobile = contactUpdateCo && contactUpdateCo.isMobileEdited ? contactUpdateCo.soleApplicantEditedMobile : resp.data.soleApplicantDetail.personalDetail.mobileNo;
          vm.holders.emailBelongsTo = resp.data.soleApplicantDetail.personalDetail.emailBelongsTo;
          vm.holders.mobileBelongsTo = resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo;
            vm.updatedFieldType  = resp.data.soleApplicantDetail.personalDetail.updatedFieldType;
            vm.politicalStatus = resp.data.soleApplicantDetail.selfDetail.politicalStatus;

            var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
          if(isEditbuttonClick && $rootScope.folioBasicDetail.folioHoldingMode == "SINGLE"){
            $rootScope.nextStep(0);
            sessionStorage.removeItem("investorIsEditButtonClick");
          }
            vm.currentFolio = resp.data;
            if($rootScope.folioBasicDetail){
              $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
            }
            vm.holdeMode = vm.currentFolio.holdmode;
            if(resp.data.soleApplicantDetail.personalDetail.taxStatusCode){
              $rootScope.showSaveTag = true;
              $timeout(function () {
                $rootScope.showSaveTag = false;
              }, 3000);

            }
            vm.folioIncomeForm.taxstatus = resp.data.soleApplicantDetail.personalDetail.taxStatusCode ? resp.data.soleApplicantDetail.personalDetail.taxStatusCode : vm.UserData.taxStatusResident == true ? "01" : null;
            vm.folioIncomeForm.occupation = resp.data.soleApplicantDetail.selfDetail.occupation;
            if(resp.data.soleApplicantDetail.selfDetail.netWorthDate){
              vm.folioIncomeForm.grossAnnualIncomeDate = vm.datethreeToTwo(resp.data.soleApplicantDetail.selfDetail.netWorthDate);
            }


            if(resp.data.soleApplicantDetail.selfDetail.netWorthDate){
              vm.networth = true;
              vm.folioIncomeForm.networth = resp.data.soleApplicantDetail.selfDetail.netWorth;
            }else{
              vm.networth = false;
              vm.folioIncomeForm.annualincome = resp.data.soleApplicantDetail.selfDetail.grossAnnualIncome;
            }
            vm.folioIncomeForm.Fatca.countrie = resp.data.soleApplicantDetail.selfDetail.fatca.birthCountry ? resp.data.soleApplicantDetail.selfDetail.fatca.birthCountry : "IN";
            vm.folioIncomeForm.Fatca.addressType = resp.data.soleApplicantDetail.selfDetail.fatca.addressType ? resp.data.soleApplicantDetail.selfDetail.fatca.addressType : "RESIDENTIAL";
            vm.folioIncomeForm.Fatca.city = resp.data.soleApplicantDetail.selfDetail.fatca.birthPlace;
          }else{
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var investorId = localStorage.getItem("folioId");
      NewInvestorServiceV3.post({child1: 'folio',child2: 'getDetails'},{id:investorId}).$promise.then(success, error);
    }


    vm.submitFolioIncomeForm = function () {
      var success = function (resp) {
        if(resp.status && resp.data){
          $rootScope.nextStep(1);
          if (vm.holdeMode == "SINGLE") {
            $state.go('newInvestor.folioDetails.nomineeDetails');
          } else {
          $state.go('newInvestor.folioDetails.jointHolderDetails');
          }
        }else{
          if(resp.popupEnabled){
            ModalService.genericModal({
              text: resp.message
            });
          } else{
            MessageService.error(error.message);
          }
        }
      },
      error = function (error) {
        MessageService.error(error.message);
      };

      $window.smartech('dispatch', 'income details', {
        'taxstatus': vm.folioIncomeForm.taxstatus,
        'occupation': vm.folioIncomeForm.occupation,
        'grossannualincome': vm.folioIncomeForm.annualincome,
        'fatca': {
                  birthCountry: vm.folioIncomeForm.Fatca.countrie,
                  birthPlace: vm.folioIncomeForm.Fatca.city,
                  addressType: vm.folioIncomeForm.Fatca.addressType,
                  payTaxInIndia : vm.currentFolio.soleApplicantDetail.selfDetail.fatca.payTaxInIndia
                }
       });

      var payload = {
        soleApplicantDetail: {
          selfDetail: {
            panNumber: vm.taxIdentifier,
            occupation: vm.folioIncomeForm.occupation,
            politicalStatus : vm.politicalStatus,
            fatca: {
              birthCountry: vm.folioIncomeForm.Fatca.countrie,
              birthPlace: vm.folioIncomeForm.Fatca.city,
              addressType: vm.folioIncomeForm.Fatca.addressType,
              payTaxInIndia : vm.currentFolio.soleApplicantDetail.selfDetail.fatca.payTaxInIndia
            }
          },
          personalDetail: {
            taxStatusCode: vm.folioIncomeForm.taxstatus,
            kycEmail:vm.soleApplicantEmail,
            kycMobileNo:vm.soleApplicantMobile,
            emailBelongsTo:vm.holders.emailBelongsTo,
            mobileBelongsTo:vm.holders.mobileBelongsTo
          }
        },

        jointHolders: [],
        nominees: [],
        holdmode: vm.currentFolio.holdmode,
        id: localStorage.getItem("folioId"),
        folioSaveStep: "TWO",
        newUserFlow: true
      }
      payload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = {};
      if(vm.currentFolio.soleApplicantDetail.selfDetail.fatca.fatcaTax1){
        payload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = vm.currentFolio.soleApplicantDetail.selfDetail.fatca.fatcaTax1;
      }

      if(vm.networth){
        payload.soleApplicantDetail.selfDetail.grossAnnualIncome = "";
        payload.soleApplicantDetail.selfDetail.netWorth = vm.folioIncomeForm.networth;
        if(vm.folioIncomeForm.grossAnnualIncomeDate.match(/[a-zA-Z]/i)){
          payload.soleApplicantDetail.selfDetail.netWorthDate = vm.folioIncomeForm.grossAnnualIncomeDate;
        }else{
          if(vm.folioIncomeForm.grossAnnualIncomeDate){
            payload.soleApplicantDetail.selfDetail.netWorthDate = vm.datetwoTothree(vm.folioIncomeForm.grossAnnualIncomeDate);
          }
        }
      }else{
        payload.soleApplicantDetail.selfDetail.grossAnnualIncome = vm.folioIncomeForm.annualincome;
        payload.soleApplicantDetail.selfDetail.netWorth = '';
        payload.soleApplicantDetail.selfDetail.netWorthDate = "";
      }

      if (vm.isContactDetailUpdated && payload.soleApplicantDetail && payload.soleApplicantDetail.personalDetail)  {
        payload.soleApplicantDetail.personalDetail.email = vm.soleApplicantEmailCopy;
        payload.soleApplicantDetail.personalDetail.mobileNo = vm.soleApplicantMobileCopy;
        payload.soleApplicantDetail.personalDetail.isContactUpdated = vm.isContactDetailUpdated;
      } else if(vm.throughMobileLogin){
        if(vm.loginWithMobileContactUpdated && vm.isMobileLogin && payload.soleApplicantDetail && payload.soleApplicantDetail.personalDetail){
        payload.soleApplicantDetail.personalDetail.email = vm.soleApplicantEmailCopy;
        payload.soleApplicantDetail.personalDetail.mobileNo = vm.soleApplicantMobile;
        payload.soleApplicantDetail.personalDetail.mobileLogin = vm.isMobileLogin;
        }else{
          payload.soleApplicantDetail.personalDetail.email = vm.soleApplicantEmailCopy;
          payload.soleApplicantDetail.personalDetail.mobileNo = vm.soleApplicantMobile;
          payload.soleApplicantDetail.personalDetail.mobileLogin = vm.isMobileLogin;
        }
      } else {
        payload.soleApplicantDetail.personalDetail.email = vm.soleApplicantEmailCopy;
        payload.soleApplicantDetail.personalDetail.mobileNo = vm.soleApplicantMobileCopy;
      }

      sessionStorage.setItem("incomeDetails", JSON.stringify(vm.folioIncomeForm));
      if(vm.distributorDetails){
        if(vm.distributorDetails.arn){
          payload.arnCode = 'ARN-'+vm.distributorDetails.arn;
        }
        if(vm.distributorDetails.riaCode){
          payload.arnCode = vm.distributorDetails.riaCode;
        }
        if(vm.distributorDetails.empCode){
          if(vm.distributorDetails.arn){
            payload.arnCode = 'ARN-'+vm.distributorDetails.arn;
          }else{
            payload.arnCode = 'ARN-DIRECT';
          }
        }
        payload.oneClick = true;
      }
      payload.nriFlag = vm.UserData ? !vm.UserData.taxStatusResident : null;
      NewInvestorServiceV3.post({child1: 'folio',child2: 'initiate'},payload).$promise.then(success, error);
    }

    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
         oldlength = vm.dobString.length;
      }
      vm.dobString = $("#grossAnnualIncomeDateId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){

        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){

        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
        }
      }
    }

  vm.datethreeToTwo = function(date) {
    var dateChar = date.split("-");
    switch(dateChar[1]){
      case "Jan":
          vm.cdate = dateChar[0]+"-01-"+dateChar[2];
          return vm.cdate;
          break;
          case "Feb":
          vm.cdate = dateChar[0]+"-02-"+dateChar[2];
          return vm.cdate;
          break;
          case "Mar":
          vm.cdate = dateChar[0]+"-03-"+dateChar[2];
          return vm.cdate;
          break;
          case "Apr":
          vm.cdate = dateChar[0]+"-04-"+dateChar[2];
          return vm.cdate;
          break;
          case "May":
          vm.cdate = dateChar[0]+"-05-"+dateChar[2];
          return vm.cdate;
          break;
          case "Jun":
          vm.cdate = dateChar[0]+"-06-"+dateChar[2];
          return vm.cdate;
          break;
          case "Jul":
          vm.cdate = dateChar[0]+"-07-"+dateChar[2];
          return vm.cdate;
          break;
          case "Aug":
          vm.cdate = dateChar[0]+"-08-"+dateChar[2];
          return vm.cdate;
          break;
          case "Sep":
          vm.cdate = dateChar[0]+"-09-"+dateChar[2];
          return vm.cdate;
          break;
          case "Oct":
          vm.cdate = dateChar[0]+"-10-"+dateChar[2];
          return vm.cdate;
          break;
          case "Nov":
          vm.cdate = dateChar[0]+"-11-"+dateChar[2];
          return vm.cdate;
          break;
          case "Dec":
          vm.cdate = dateChar[0]+"-12-"+dateChar[2];
          return vm.cdate;
          break;
      default:
        return "wrong date.";
    }
  }

  vm.datetwoTothree = function(date) {
    var dateChar = date.split("-");
    switch(dateChar[1]){
      case "01":
          vm.cdate = dateChar[0]+"-Jan-"+dateChar[2];
          return vm.cdate;
          break;
          case "02":
          vm.cdate = dateChar[0]+"-Feb-"+dateChar[2];
          return vm.cdate;
          break;
          case "03":
          vm.cdate = dateChar[0]+"-Mar-"+dateChar[2];
          return vm.cdate;
          break;
          case "04":
          vm.cdate = dateChar[0]+"-Apr-"+dateChar[2];
          return vm.cdate;
          break;
          case "05":
          vm.cdate = dateChar[0]+"-May-"+dateChar[2];
          return vm.cdate;
          break;
          case "06":
          vm.cdate = dateChar[0]+"-Jun-"+dateChar[2];
          return vm.cdate;
          break;
          case "07":
          vm.cdate = dateChar[0]+"-Jul-"+dateChar[2];
          return vm.cdate;
          break;
          case "08":
          vm.cdate = dateChar[0]+"-Aug-"+dateChar[2];
          return vm.cdate;
          break;
          case "09":
          vm.cdate = dateChar[0]+"-Sep-"+dateChar[2];
          return vm.cdate;
          break;
          case "10":
          vm.cdate = dateChar[0]+"-Oct-"+dateChar[2];
          return vm.cdate;
          break;
          case "11":
          vm.cdate = dateChar[0]+"-Nov-"+dateChar[2];
          return vm.cdate;
          break;
          case "12":
          vm.cdate = dateChar[0]+"-Dec-"+dateChar[2];
          return vm.cdate;
          break;
      default:
        return "wrong date.";
    }
  }

    function editContactDetails(contactInfo) {
      var contactUpdateCo = JSON.parse(sessionStorage.getItem('contactUpdateCo'));
      if (contactUpdateCo) {
        vm.isMobileEdited = contactUpdateCo.isMobileEdited;
        vm.isEmailEdited = contactUpdateCo.isEmailEdited;
      }
      if (contactInfo === "email"|| vm.throughMobileLogin == true) {
        if (vm.isMobileEdited) {
          MessageService.error("You can edit only one contact information at a time.");
          return;
        }
        vm.showEmailEditField = true;
        vm.showMobileEditField = false;
        if (vm.soleApplicantEmail) {
          vm.soleApplicantEditedEmail = vm.soleApplicantEmail;
        }
      } else if (contactInfo === 'mobile'|| vm.throughMobileLogin == true) {
        if (vm.isEmailEdited) {
          MessageService.error("You can edit only one contact information at a time.");
          return;
        }
        vm.showMobileEditField = true;
        vm.showEmailEditField = false;
        if (vm.soleApplicantMobile) {
          vm.soleApplicantEditedMobile = vm.soleApplicantMobile;
        }
      }
    }

    function cancelEditAction(contactInfo) {
      if (contactInfo === "email") {
        vm.showEmailEditField = false;
      } else if (contactInfo === 'mobile') {
        vm.showMobileEditField = false;
      }
    }

    function generateContactUpdateOtp(contactInfo) {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          showOtpModal(resp.data, contactInfo);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      var payload = {
        value: contactInfo === "email" ? vm.soleApplicantEditedEmail : vm.soleApplicantEditedMobile,
        fieldType: contactInfo.toUpperCase(),
        linkId: localStorage.getItem('folioId'),
        flowName : "STANDALONE_FOLIO_CREATION"
      };
      InvestorServiceV2.post({
        child1: 'contact',
        child2: 'update',
        child3: 'send',
        child4: 'otp'
      }, payload).$promise.then(success, error);
    }

    function showOtpModal(modalPayload, contactInfo) {
      var confirmSuccess = function () {
        vm.isContactDetailUpdated = true;
        if (contactInfo === "email") {
          vm.isEmailEdited = true;
          vm.showEmailEditField = false;
          vm.soleApplicantEmail = vm.soleApplicantEditedEmail;
        }
        if (contactInfo === "mobile") {
          vm.isMobileEdited = true;
          vm.showMobileEditField = false;
          vm.soleApplicantMobile = vm.soleApplicantEditedMobile;
        }
        sessionStorage.setItem('contactUpdateCo', JSON.stringify({
          isEmailEdited: vm.isEmailEdited,
          isMobileEdited: vm.isMobileEdited,
          soleApplicantEditedEmail: vm.soleApplicantEditedEmail,
          soleApplicantEditedMobile: vm.soleApplicantEditedMobile,
          isContactDetailUpdated: vm.isContactDetailUpdated
        }));
      }, confirmError = function () {
        vm.isContactDetailUpdated = false;
        vm.isEmailEdited = false;
        vm.isMobileEdited = false;
      };
      ModalService.contactOtpModal(modalPayload, confirmSuccess, confirmError);
    }

    function changeValue(contactInfo, val) {
      if (contactInfo === "email") {
        vm.soleApplicantEditedEmail = val;
      } else if (contactInfo === 'mobile') {
        vm.soleApplicantEditedMobile = val;
      }
    }

  }
})();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('FolioJointHolderDetailsController', FolioJointHolderDetailsController);

    /** @ngInject */
    function FolioJointHolderDetailsController(InvestorService, investorServiceVersion, $scope, $state, $stateParams, $cookies, $window, AppConstants, UtilService, AuthService, $log, LoaderService,
                         InvestorFolioModel, $rootScope,$location,InvestorServiceV3,NewInvestorServiceV3, InvestorProfilePhotoService, MessageService, ModalService, $timeout, KycService, dynamicData) {
      var vm = this;
      vm.panMessage = "";
      vm.addthirdholder = false;
      vm.holders = [];
      vm.emailDetails = {};
      $rootScope.myState = $state.current.url;
      $rootScope.historyLocation.push($location.$$path);
      vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
      vm.appConstants = AppConstants;
      vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
      $rootScope.folioBasicDetail.folioForUser = 'Self';
      vm.notValid2ndHolder=false;
      vm.checkValid2ndHolder=checkValid2ndHolder;
      vm.KYC_STATUS = AppConstants.KYC_STATUS;
      if(dynamicData && dynamicData.noteDTO && dynamicData.noteDTO.noteDTOMap && dynamicData.noteDTO.noteDTOMap.Note_Tax_Status_Info) {
        vm.taxStatusInfoMsg = dynamicData.noteDTO.noteDTOMap.Note_Tax_Status_Info.content;
      } else {
        vm.taxStatusInfoMsg = "";
      }
      vm.taxStatusChanged = taxStatusChanged;
      vm.changedRiNriTaxStatus = changedRiNriTaxStatus;
      $rootScope.addholder = {
      steps: [
        { step: 1, isactive: true },
        { step: 2, isactive: false },
        { step: 3, isactive: false }
      ]
    }
    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
         oldlength = vm.dobString.length;
      }
      vm.dobString = $("#grossAnnualIncomeDateId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
         if((newlength== (oldlength - 1)) || (newlength == oldlength)){
          } else{
            $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
          }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
        }
      }
    }
    vm.jointHolderDetails = {
      email: '',
      fatcaDetail: {
        birthPlace: '',
        birthCountry: '',
        payTaxInIndia: true,
        addressType: '',
        countryCitizenship: "",
        thirdTax: false
      },
      grossAnnualIncome: '',
      netWorth: "",
      netWorthDate: '',
      occupationCode: '',
      pan: '',
      politicalStatus: "NONE",
      taxStatusCode: '',
      jointHolderName: '',
      kycverified: '',
      nriFlag: null
    };
    vm.sameFirstHoderDetails = false;
    vm.addthirdholderinfolio = function () {
      var confirmSuccess = function (data) {
        vm.holderData.pan = data.pan;
        if (data && data.emailExists === true) {
            vm.holderData.jointHolderName = data.name;
            vm.holderData.kycverified = data.kycverified;
            vm.holderData.email= data.email;
            vm.holderData.mobileNumber=data.mobileNumber;
            vm.holderData.taxStatusResident = data.taxStatusResident;
            vm.AllowedJointHolder = true;
            vm.processFlag = true;
            vm.wrongMsg = '';
          }
        vm.verifyOrAddHolder3();
        // vm.closeModal();
      };
      var confirmError = function () {
        // task.done = false;
      };
      ModalService.addJointHolderModal({}, confirmSuccess, confirmError);
      // vm.addthirdholder = !vm.addthirdholder;
    }
    vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
    vm.jointHolderDetails.fatcaDetail.payTaxInIndia = true;

    vm.jointHolderTaxDetails_politicalStatus = 'No';

    vm.getTaxFileStatusForJointHolder = function (value) {
      try{
        if (value == 'Yes') {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
          vm.jointHolderDetails.fatcaDetail.payTaxInIndia = false;
          vm.jointHolderDetails.fatcaDetail.secondTax = {
            taxPayingCountry:"",
            taxIdType:"",
            taxPayingCity:"",
            taxId:""
          }
          // console.log(vm.jointHolderDetails.fatcaDetail.secondTax);
        } else {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
          vm.jointHolderDetails.fatcaDetail.payTaxInIndia = true;
          vm.jointHolderDetails.fatcaDetail.secondTax = false;
          // console.log(vm.jointHolderDetails.fatcaDetail.secondTax);
        }
      }
      catch(e){

      }
    }
    vm.getPEPStatusForJointHolder = function (value) {
      // console.log(vm.jointHolderDetails.politicalStatus);
      if (value == 'Yes') {
        vm.jointHolderTaxDetails_politicalStatus = 'Yes';
        vm.jointHolderDetails.politicalStatus = 'POLITICAL';
      } else {
        vm.jointHolderTaxDetails_politicalStatus = 'No';
        vm.jointHolderDetails.politicalStatus = 'NONE';
      }
      // console.log(vm.jointHolderDetails.politicalStatus);
    }
    vm.resetValues = function () {
      vm.errorMessage = "";
      vm.errorMessageVerify = "";
      vm.panMessage = "";
      vm.availableMessage = "";
      vm.otpResendMessage = "";
      vm.dateErrorMessage = "";
    }
    // holder
    vm.stopaddholder = true;
    vm.holderData = {};
    vm.holderData.pan = '';
    vm.holderData.HolderName ='';
    vm.holderData.email = '';
    vm.holderData.taxStatusResident = true;
    vm.jointHolderDetails.kycverified = false;
    vm.AllowedJointHolder = true;
    vm.checkPanEmailExist = function () {
            var success = function (resp) {
              LoaderService.hideLoader();
              vm.processFlag = false;
              if (resp.status && resp.data) {
                if (resp.data && resp.data.ekycStatus && (resp.data.ekycStatus === vm.KYC_STATUS.VERIFIED || resp.data.ekycStatus === vm.KYC_STATUS.IN_PROGRESS)) {
                  if (resp.data && resp.data.emailExists === true) {
                    //  console.log(resp.data);
                    vm.holderData.jointHolderName = resp.data.name;
                    vm.holderData.mobileNumber=resp.data.mobileNumber;
                    vm.holderData.email=resp.data.email;
                    vm.holderData.kycverified = resp.data.kycverified;
                    vm.AllowedJointHolder = true;
                    vm.processFlag = true;
                    vm.wrongMsg = '';
                    vm.panMessage = '';
                  }else {
                    vm.showEmail = true;
                  }
                } else if (resp.data && resp.data.ekycStatus && (resp.data.ekycStatus === vm.KYC_STATUS.NOT_VALIDATED || resp.data.ekycStatus === vm.KYC_STATUS.ON_HOLD)) {
                  ModalService.nonKycModal({
                    'text': resp.data.ekycStatus === vm.KYC_STATUS.ON_HOLD ? vm.appConstants.ON_HOLD_MESSAGE : vm.appConstants.NOT_VALIDATED_MESSAGE,
                    'showHtml': true,
                    'buttonText': 'OK',
                    'ekycRequestCO': resp.data.ekycRequestCO
                  }, function () {
                    vm.holderData.pan = null;
                  }, function () {
                    vm.holderData.pan = null;
                  });
                }
              } else {
                if (resp.popupEnabled) {
                  vm.panMessage = resp.message;
                } else {
                  vm.panMessage = resp.message;
                  vm.wrongMsg = resp.message;
                  MessageService.error(resp.message);
                }
              }
            },
            error = function () {
              LoaderService.hideLoader();
              vm.processFlag = false;
              vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
            };
            var payload = {
              pan: vm.holderData.pan,
              nriFlag: !vm.holderData.taxStatusResident
            };
            if(payload.pan) {
              LoaderService.showLoader();
              InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'details'}, payload).$promise.then(success, error);
            }
      }

    vm.showEmail = false;
    vm.showOtp = false;
    vm.Otp = '';
    vm.AddEmailToHolderPan = function () {
      vm.Otp = '';
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        vm.processFlag = false;
        if (resp.status && resp.data) {
          // vm.AllowedJointHolder = false;
          vm.emailDetails.secretLink = resp.data.secretLink;
          vm.Otp = resp.data.otp;
          vm.showOtp = true;
        }
      },
      error = function () {
        vm.processFlag = false;
        vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
      };
      var payload = {
        pan: vm.holderData.pan,
        email: vm.holderData.email
      };
      InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'add',child6: 'email',child7: 'send',child8: 'otp'}, payload).$promise.then(success, error);
    }

    vm.verifyOtp = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        vm.processFlag = false;
        if (resp.status && resp.data && resp.data.verified) {
          vm.showOtp = false;
          vm.AllowedJointHolder = true;
          vm.processFlag = true;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function () {
        vm.processFlag = false;
        vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
      };

      var payload = {
        uniqueLink: vm.emailDetails.secretLink,
        otp: vm.Otp
      };
      InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'add',child6: 'email',child7: 'verify',child8: 'otp'}, payload).$promise.then(success, error);
    }
    vm.OTPResendMsg = '';
    vm.reGenerateOtp = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        vm.processFlag = false;
        if (resp.status && resp.data) {
          vm.OTPResendMsg = resp.data.message;
          vm.emailMsg = "";
        } else {
          vm.wrongMsg = resp.message;
          MessageService.error(resp.message);
        }
      },
      error = function () {
        LoaderService.hideLoader('.popup');
        vm.processFlag = false;
        vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
      };
      vm.payload = {
        pan: vm.holderData.pan,
        secretLink: vm.emailDetails.secretLink,
        email: vm.holderData.email
      };
      InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'add',child6: 'email',child7: 'resend',child8: 'otp'}, vm.payload).$promise.then(success, error);
    }
    // add holder
    vm.verifyOrAddHolder2 = function () {
      var userData = JSON.parse(sessionStorage.getItem("verifyObj"));
      if(userData.panNumber === vm.holderData.pan){
        MessageService.error("You can't add joint holder yourself.");
      }else{
        $rootScope.addholder.steps[0].isactive = false;
      $rootScope.addholder.steps[1].isactive = true;
      vm.jointHolderDetails = {
        email: vm.holderData.email,
        fatcaDetail: {
          birthPlace: "",
          birthCountry: "IN",
          payTaxInIndia: true,
          addressType: "RESIDENTIAL",
          countryCitizenship: "",
          fatcaTax1 : {},
          secondTax:false,
          thirdTax: false
        },
        grossAnnualIncome: '',
        netWorth: "",
        netWorthDate: "",
        occupationCode: "",
        pan: vm.holderData.pan,
        politicalStatus: "NONE",
        taxStatusCode: "01",
        jointHolderName : vm.holderData.jointHolderName,
        kycverified : vm.holderData.kycverified,
        mobileNumber:vm.holderData.mobileNumber,
        nriFlag: !vm.holderData.taxStatusResident
      };
      vm.holders.push(vm.jointHolderDetails);
      vm.holderLength = vm.holders.length;
      vm.checkValid2ndHolder(vm.holders)
      vm.holderData.pan = '';
      vm.holderData.jointHolderName = '';
      vm.holderData.kycverified = '';
      vm.holderData.email = '';
      vm.holderData.mobileNumber='';
      }
    }

    vm.verifyOrAddHolder3 = function () {
      var userData = JSON.parse(sessionStorage.getItem("verifyObj"));
      if(vm.holderData.pan === userData.panNumber){
        MessageService.error("You can't add joint holder yourself.");
      }else{
        if(vm.holderData.pan === vm.holders[0].pan){
          MessageService.error("You can't add same joint holder.");
        }else{
          $rootScope.addholder.steps[0].isactive = false;
          $rootScope.addholder.steps[1].isactive = true;
          vm.jointHolderDetails = {
            email: vm.holderData.email,
            fatcaDetail: {
              birthPlace: "",
              birthCountry: "IN",
              payTaxInIndia: true,
              addressType: "RESIDENTIAL",
              countryCitizenship: "",
              fatcaTax1:{},
              secondTax:false,
              thirdTax: false
            },
            grossAnnualIncome: '',
            netWorth: "",
            netWorthDate: "",
            occupationCode: "",
            pan: vm.holderData.pan,
            politicalStatus: "NONE",
            taxStatusCode: "01",
            jointHolderName : vm.holderData.jointHolderName,
            kycverified : vm.holderData.kycverified,
            mobileNumber:vm.holderData.mobileNumber,
            nriFlag: !vm.holderData.taxStatusResident
          };
          vm.holders.push(vm.jointHolderDetails);
          vm.holderLength = vm.holders.length;
          vm.addthirdholder = false;
          vm.stopaddholder = false;
          vm.holderData.pan = '';
          vm.holderData.email = '';
          vm.holderData.taxStatusResident = '';
          vm.checkValid2ndHolder(vm.holders);
        }

      }

    }
    vm.deleteHolder = function(parentIndex){
      var model = vm.holders || [];
      model.splice(parentIndex, 1);
      vm.holders = model;
      vm.checkValid2ndHolder(vm.holders);
      if(vm.holders && vm.holders.length >= 1 && $rootScope.addholder.steps[2].isactive) {
        vm.holdernext();
      }
      if(model && (model.length === 0 || model.length === 1)) {
        vm.stopaddholder = true;
      }
      if(model && model.length == 0) {
        vm.holderData.taxStatusResident = true;
        vm.sameFirstHoderDetails = false;
        vm.showEmail = false;
        vm.showOtp = false;
        vm.submitHolder(true);
      }
    }
    vm.networth = false;
    vm.networthcall = function () {
      vm.networth = !vm.networth;
      if(vm.networth){
        vm.notolderthan1year = true;
        vm.jointHolderDetails.grossAnnualIncome = "";
      }else{
        vm.notolderthan1year = false;
        vm.jointHolderDetails.netWorth = "";
        vm.jointHolderDetails.netWorthDate = "";
      }
    }
    vm.holdernext = function () {
      $rootScope.addholder.steps[0].isactive = false;
      $rootScope.addholder.steps[1].isactive = false;
      $rootScope.addholder.steps[2].isactive = true;
      vm.holderCount = vm.holders.length;
      vm.getholdersdata(0);
      vm.holderTab = 0;
    }

    vm.getholdersdata = function (numberofholder) {
      // console.log(numberofholder);
      if(numberofholder == 1){
        vm.showSameHOlderDetail = true;
        fetchTaxStatus(numberofholder);
      }else{
        vm.showSameHOlderDetail = false;
        fetchTaxStatus(numberofholder);
      }
      vm.holderCount = vm.holders.length
      vm.holderTab = numberofholder;
      vm.currentHolder = vm.holders[numberofholder];
      // console.log(vm.currentHolder);

      if(vm.currentHolder.netWorthDate){
        vm.networth = true;
      }else{
        vm.networth = false;
      }

      if (vm.currentHolder.fatcaDetail.payTaxInIndia == true) {
        vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
        vm.currentHolder.fatcaDetail.payTaxInIndia = true;
      } else {
        vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
        vm.currentHolder.fatcaDetail.payTaxInIndia = false;
      }

      if (vm.currentHolder.politicalStatus == 'NONE') {
        vm.jointHolderTaxDetails_politicalStatus = 'No';
        vm.currentHolder.politicalStatus = 'NONE';
      } else {
        vm.jointHolderTaxDetails_politicalStatus = 'Yes';
        vm.currentHolder.politicalStatus = 'POLITICAL';
      }

      vm.currentHolder.fullname = vm.currentHolder.firstName+' '+vm.currentHolder.middleName+' '+vm.currentHolder.lastName;
      vm.jointHolderDetails = {
        email: vm.currentHolder.email,
        fatcaDetail: {
          birthPlace: vm.currentHolder.fatcaDetail.birthPlace,
          birthCountry: vm.currentHolder.fatcaDetail.birthCountry,
          payTaxInIndia: vm.currentHolder.fatcaDetail.payTaxInIndia,
          addressType: vm.currentHolder.fatcaDetail.addressType,
          fatcaTax1:vm.currentHolder.fatcaDetail.fatcaTax1,
          secondTax:false,
          thirdTax: false
        },
        netWorth: vm.currentHolder.netWorth ? vm.currentHolder.netWorth : '',
        netWorthDate: vm.currentHolder.netWorthDate ? vm.currentHolder.netWorthDate : '',
        occupationCode: vm.currentHolder.occupationCode,
        pan: vm.currentHolder.pan,
        politicalStatus: vm.currentHolder.politicalStatus,
        taxStatusCode: vm.currentHolder.taxStatusCode,
        jointHolderName: vm.currentHolder.jointHolderName ? vm.currentHolder.jointHolderName : vm.currentHolder.fullname,
        kycverified: false,
        mobileNumber:vm.currentHolder.mobileNumber,
        nriFlag: vm.currentHolder.nriFlag
      };
      vm.jointHolderDetails.grossAnnualIncome = vm.currentHolder.grossAnnualIncome.toString();
    }

    vm.getGrossAnnualIncomeDateOfHolder = function (date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.jointHolderDetails.netWorthDate = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.grossAnnualIncomeYear = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.grossAnnualIncomeYear < 1 || vm.grossAnnualIncomeYear == 1) {
          // console.log(vm.grossAnnualIncomeYear);
          vm.notolderthan1year = false;
        }
        else {
          vm.jointHolderDetails.netWorthDate = "";
          MessageService.error('Not older than 1 year');
          vm.notolderthan1year = true;
        }
        if (!date) {
          vm.dateErrorMessage = vm.validateData.GROSS_ANNUAL_INCOME;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.GROSS_ANNUAL_INCOME;
        vm.jointHolderDetails.netWorthDate = "";
      }
      return;
    }
    vm.nextFlag = false;
    vm.submithHolderIncomeDetails = function (holderIndex) {
      vm.holders[holderIndex] = vm.jointHolderDetails;
      vm.nextFlag = true;
      try{
        if(vm.holders.length == 2 && !vm.holders[1].occupationCode){
          vm.getholdersdata(1);
          vm.holderTab = 1;
          vm.nextFlag = false;
        }else{
          // vm.nextFlag = true;
          vm.submitHolder();
        }
      }catch(e){}
    }

    vm.addFirstHolderData = function () {
      vm.sameFirstHoderDetails  = !vm.sameFirstHoderDetails;
      if (vm.sameFirstHoderDetails == true) {
        vm.fistHolder = vm.holders[0];
        if (vm.fistHolder.fatcaDetail.payTaxInIndia == true) {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
          vm.fistHolder.fatcaDetail.payTaxInIndia = true;
        } else {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
          vm.fistHolder.fatcaDetail.payTaxInIndia = false;
        }

        if(vm.fistHolder.netWorthDate){
          vm.networth = true;
        }else{
          vm.networth = false;
        }
        if (vm.fistHolder.politicalStatus == 'NONE') {
            vm.fistHolder.politicalStatus = 'NONE';
          vm.jointHolderTaxDetails_politicalStatus = 'No';
        } else {
          vm.jointHolderTaxDetails_politicalStatus = 'Yes';
          vm.fistHolder.politicalStatus = 'POLITICAL';
        }
        var taxData = vm.fistHolder.fatcaDetail.fatcaTax1;

        vm.jointHolderDetails = {
          email: vm.holders[1].email ? vm.holders[1].email : "",
          mobileNumber: vm.holders[1].mobileNumber ? vm.holders[1].mobileNumber : "",
          fatcaDetail: {
            birthPlace: vm.fistHolder.fatcaDetail.birthPlace,
            birthCountry: vm.fistHolder.fatcaDetail.birthCountry,
            payTaxInIndia: vm.fistHolder.fatcaDetail.payTaxInIndia,
            addressType: vm.fistHolder.fatcaDetail.addressType,
            countryCitizenship: "",
            fatcaTax1:taxData,
            secondTax:false,
            thirdTax: false
          },
          grossAnnualIncome: vm.fistHolder.grossAnnualIncome,
          netWorth: vm.fistHolder.netWorth,
          netWorthDate: vm.fistHolder.netWorthDate,
          occupationCode: vm.fistHolder.occupationCode,
          pan: vm.currentHolder.pan,
          politicalStatus: vm.fistHolder.politicalStatus,
          taxStatusCode: vm.fistHolder.taxStatusCode,
          jointHolderName: vm.currentHolder.jointHolderName,
          kycverified: vm.fistHolder.kycverified,
          nriFlag: null
        };

        if(vm.fistHolder.nriFlag == false && vm.currentHolder.nriFlag== false) {
          vm.jointHolderDetails.nriFlag = false;
          vm.jointHolderDetails.taxStatusCode = vm.fistHolder.taxStatusCode;
        } else if(vm.fistHolder.nriFlag == true && vm.currentHolder.nriFlag== true) {
          vm.jointHolderDetails.nriFlag = true;
          vm.jointHolderDetails.taxStatusCode = vm.fistHolder.taxStatusCode;
        } else if(vm.fistHolder.nriFlag == false && vm.currentHolder.nriFlag== true) {
          vm.jointHolderDetails.nriFlag = true;
          vm.jointHolderDetails.taxStatusCode = vm.currentHolder.taxStatusCode;
        } else if(vm.fistHolder.nriFlag == true && vm.currentHolder.nriFlag== false) {
          vm.jointHolderDetails.nriFlag = false;
          vm.jointHolderDetails.taxStatusCode = vm.currentHolder.taxStatusCode;
        }

      } else {
        vm.fistHolder = vm.holders[1];
        if (vm.fistHolder.fatcaDetail.payTaxInIndia == true) {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
          vm.currentHolder.fatcaDetail.payTaxInIndia = true;
        } else {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
          vm.currentHolder.fatcaDetail.payTaxInIndia = false;
        }
        if(vm.fistHolder.netWorthDate){
          vm.networth = true;
        }else{
          vm.networth = false;
        }
        if (vm.fistHolder.politicalStatus == 'NONE') {
          vm.jointHolderTaxDetails_politicalStatus = 'No';
          vm.fistHolder.politicalStatus = 'NONE';
        } else {
          vm.jointHolderTaxDetails_politicalStatus = 'Yes';
          vm.fistHolder.politicalStatus = 'POLITICAL';
        }
        var taxData1 = vm.fistHolder.fatcaDetail.fatcaTax1;

        vm.jointHolderDetails = {
          email: vm.fistHolder.email,
          mobileNumber: vm.holders[1].mobileNumber ? vm.holders[1].mobileNumber : "",
          fatcaDetail: {
            birthPlace: vm.fistHolder.fatcaDetail.birthPlace,
            birthCountry: vm.fistHolder.fatcaDetail.birthCountry,
            payTaxInIndia: vm.fistHolder.fatcaDetail.payTaxInIndia,
            addressType: vm.fistHolder.fatcaDetail.addressType,
            countryCitizenship: "",
            fatcaTax1:taxData1,
            secondTax:false,
            thirdTax: false
          },
          grossAnnualIncome: vm.fistHolder.grossAnnualIncome,
          netWorth: vm.fistHolder.netWorth,
          netWorthDate: vm.fistHolder.netWorthDate,
          occupationCode: vm.fistHolder.occupationCode,
          pan: vm.currentHolder.pan,
          politicalStatus: vm.fistHolder.politicalStatus,
          taxStatusCode: vm.fistHolder.taxStatusCode,
          jointHolderName: vm.currentHolder.jointHolderName,
          kycverified: false,
          nriFlag: vm.currentHolder.nriFlag
        };
        if(!vm.currentHolder.nriFlag && vm.taxStatusData && vm.taxStatusData.length > 0) {
          var taxStatus = vm.taxStatusData.filter(function (taxStatus) {
            return taxStatus.taxStatusCode == '01';
          });
          if (taxStatus && taxStatus.length > 0) {
            vm.jointHolderDetails.taxStatusCode = taxStatus[0].taxStatusCode;
            vm.holders[1].taxStatusCode = taxStatus[0].taxStatusCode;
          }
        }
        // console.log(vm.jointHolderDetails);
      }
    }

    vm.getNewUserDetails = function(){
      var success = function (resp) {
        localStorage.setItem("folioId", resp.data.folioCreationDraftId);
      },
      error = function (error) {
        MessageService.error(error.message);
      };
      var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
      var taxIdentifierNumber = UserData.panNumber;
      var payload = {
        "panNumber":taxIdentifierNumber
      }
      InvestorService.post({child1: 'new',child2: 'user',child3: 'getDetails'},payload).$promise.then(success, error);
    }
    vm.getNewUserDetails();
    vm.notolderthan1year = false;
    vm.getOldFolioData = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.currentPayload = resp.data;
          if($rootScope.folioBasicDetail){
            $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
          }
          var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
            if(isEditbuttonClick){
              if($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE'){
              }else{
                $rootScope.nextStep(0);
                $rootScope.nextStep(1);
              }
            }
          vm.holdeMode = resp.data.holdmode;
          // if holder is already present
          if(resp.data.jointHolders.length  == 1){
            vm.holders = resp.data.jointHolders;
            $rootScope.addholder.steps[0].isactive = false;
            $rootScope.addholder.steps[1].isactive = false;
            $rootScope.addholder.steps[2].isactive = true;
            vm.getholdersdata(0);
            vm.holderTab = 0;
          }
          if(resp.data.jointHolders.length  == 2){
            vm.holders = resp.data.jointHolders;
            $rootScope.addholder.steps[0].isactive = false;
            $rootScope.addholder.steps[1].isactive = false;
            $rootScope.addholder.steps[2].isactive = true;
            vm.getholdersdata(0);
            vm.holderTab = 0;
          }


        } else {
          MessageService.error(resp.message);
        }
      }, error = function (error) {
        MessageService.error(error.message);
      };
      var investorId = localStorage.getItem("folioId");
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'getDetails' }, { id: investorId }).$promise.then(success, error);
    }
    vm.getOldFolioData();

    vm.submitHolder = function(lastHolderDelete){
      var success = function (resp) {
        if(resp.status && resp.data){
          if(lastHolderDelete) {
            $rootScope.addholder.steps[0].isactive = true;
            $rootScope.addholder.steps[1].isactive = false;
            $rootScope.addholder.steps[2].isactive = false;
          } else {
            $rootScope.nextStep(2);
            $state.go('newInvestor.folioDetails.nomineeDetails');
          }
        }else{
          if(resp.popupEnabled){
            ModalService.genericModal({
              text: resp.message
            });
          } else{
            MessageService.error(resp.message);
          }
        }
      },
      error = function (error) {
         MessageService.error(error.message);
      };

      vm.currentPayload.id = localStorage.getItem("folioId");
      vm.currentPayload.jointHolders = vm.holders;
      vm.currentPayload.holdmode = vm.holdeMode;
      vm.currentPayload.folioSaveStep = "THREE";
      vm.currentPayload.newUserFlow = true;
      vm.currentPayload.minor = false,
      vm.currentPayload.firstFolio = true;
      var userData = JSON.parse(sessionStorage.getItem("verifyObj"));
      vm.currentPayload.nriFlag = userData ? !userData.taxStatusResident : null;
      if(vm.distributorDetails){
        if(vm.distributorDetails.arn){
          vm.currentPayload.arnCode = 'ARN-'+vm.distributorDetails.arn;
        }
        if(vm.distributorDetails.riaCode){
          vm.currentPayload.arnCode = vm.distributorDetails.riaCode;
        }
        if(vm.distributorDetails.empCode){
          if(vm.distributorDetails.arn){
            vm.currentPayload.arnCode = 'ARN-'+vm.distributorDetails.arn;
          }else{
            vm.currentPayload.arnCode = 'ARN-DIRECT';
          }
        }
        vm.currentPayload.oneClick = true;
      }
      if(lastHolderDelete) {
        vm.currentPayload.folioSaveStep = "TWO";
        vm.currentPayload.resetHolder = true;
        NewInvestorServiceV3.post({child1: 'folio',child2: 'initiate'},vm.currentPayload).$promise.then(success, error);
      } else {
        if(vm.currentPayload.holdmode == 'SINGLE'){
          if(vm.currentPayload.jointHolders.length == 0){
            NewInvestorServiceV3.post({child1: 'folio',child2: 'initiate'},vm.currentPayload).$promise.then(success, error);
          }
          else{
            MessageService.error("Mode of holding cannot be Single for multiple holder's");
          }
        }else{
          if(vm.currentPayload.holdmode == 'ANY_OR_SURVIVOR'){
            if(vm.currentPayload.jointHolders.length != 0){
              NewInvestorServiceV3.post({child1: 'folio',child2: 'initiate'},vm.currentPayload).$promise.then(success, error);
            }else{
              MessageService.error("Mode of holding cannot be Single for multiple holder's");
            }
          }

        }
      }

    }
      function checkValid2ndHolder(arr){
        vm.notValid2ndHolder=false;
        for(var i =0; i<arr.length;i++){
          if(!arr[i].email && !arr[i].mobileNumber){
            vm.notValid2ndHolder=true;
          }
        }
      }

      function fetchTaxStatus(holderIndex) {
        var success = function (resp) {
            if (resp.status && resp.data) {
              vm.taxStatusData = resp.data.taxStatus;
              var taxStatus = vm.taxStatusData.filter(function(taxStatus){
                return taxStatus.taxStatusCode == '01';
              });
              if(taxStatus && taxStatus.length > 0) {
                vm.jointHolderDetails.taxStatusCode = taxStatus[0].taxStatusCode;
                vm.holders[holderIndex].taxStatusCode = taxStatus[0].taxStatusCode;
              }
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function () {
            // MessageService.error("Error in tax status!");
          };
        var payloadTaxStatus = {
          taxStatusFilter: vm.jointHolderDetails.minor ? 'MINOR': 'ADULT',
          nriFlag: holderIndex == 0 ? vm.holders[0].nriFlag : vm.holders[1].nriFlag
        };
        InvestorService.post({ child1: 'folio', child2: 'tax-status'}, payloadTaxStatus).$promise.then(success, error);
      }

      function taxStatusChanged(taxStatusValue, holderTab) {
        if(vm.holders && vm.holders.length > 0) {
          vm.holders[holderTab].taxStatusCode = taxStatusValue;
        }
      }

      function changedRiNriTaxStatus(){
        vm.holderData.pan = "";
        vm.holderData.email = "";
        vm.holderData.mobileNumber = "";
        vm.showEmail = false;
        vm.showOtp = false;
        vm.resetValues();
      }

}
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioMinorGuardianDetailsController', FolioMinorGuardianDetailsController);

  /** @ngInject */
  function FolioMinorGuardianDetailsController(InvestorService, InvestorServiceV3,NewInvestorServiceV3, investorServiceVersion, $scope, $http, $state, $stateParams, $cookies, $window, AppConstants, UtilService, AuthService, $log, LoaderService,
    InvestorFolioModel, $rootScope, InvestorFileUploadServiceV3, InvestorProfilePhotoService, MessageService, ModalService, $timeout, KycService) {
    var vm = this;


    vm.viewMode = "days";
    vm.dateErrorMessage = "";
    $rootScope.myState = $state.current.url;
    vm.networth = false;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.minorFormGuardianData = {}
    $rootScope.folioBasicDetail.folioForUser  = 'Minor';
    vm.minorFormGuardianData.relation = '';
    vm.minorFormGuardianData.guardianrelationproofType = '';
    vm.minorFormGuardianData.guardianrelationproofimageurl = '';
    vm.minorFormGuardianData.guardianrelationproofimagename = '';
    vm.minorFormGuardianData.occupation = '';
    vm.minorFormGuardianData.grossAnnualIncome = '';
    vm.minorFormGuardianData.grossAnnualIncomeDate = '';
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.minorFormGuardianData.Fatca = {};
    vm.minorFormGuardianData.Fatca.Countrie = 'IN';
    vm.minorFormGuardianData.Fatca.City = '';
    vm.minorFormGuardianData.Fatca.taxPayIndian = true;
    vm.minorFormGuardianData.Fatca.addressType = "RESIDENTIAL";
    vm.minorFormGuardianData.fileTaxOtherIndian = 'No';

    vm.minorFormGuardianData.Fatca.taxPay1 = {};
    vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry = "";
    vm.minorFormGuardianData.Fatca.taxPay1.taxIdType = "";
    vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCity = "";
    vm.minorFormGuardianData.Fatca.taxPay1.taxId = "";

    vm.minorFormGuardianData.userPEPStatusForGuardian = 'No';
    vm.minorFormGuardianData.politicalStatus = 'NONE';
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];

    vm.relationshipList = [
      { name: 'Father', value: 'FATHER' },
      { name: 'Mother', value: 'MOTHER' }, {
        name: 'Sibling', value: 'SIBLING'
      },
      { name: 'Other', value: 'OTHER' }
    ];
    vm.notolderthan1year = false;
    vm.grossAnnualIncomeDate = function (date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.minorFormGuardianData.grossAnnualIncomeDate = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.grossAnnualIncomeYear = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.grossAnnualIncomeYear < 1 || vm.grossAnnualIncomeYear == 1) {
          // console.log(vm.grossAnnualIncomeYear);
          vm.notolderthan1year = false;
        }
        else {
          vm.minorFormGuardianData.grossAnnualIncomeDate = "";
         MessageService.error('Not older than 1 year');
         vm.notolderthan1year = true;
        }
        if (!date) {
          vm.dateErrorMessage = vm.validateData.GROSS_ANNUAL_INCOME;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.GROSS_ANNUAL_INCOME;
        vm.minorFormGuardianData.grossAnnualIncomeDate = "";
      }
      return;
    }
    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
         oldlength = vm.dobString.length;
      }
      vm.dobString = $("#grossAnnualIncomeDateId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
        }
      }
    }
    vm.getGuardianRelationProofImage = function (file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file.size < 2000000) {
        vm.minorFormGuardianData.guardianrelationproofimagename = file.name;
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.minorFormGuardianData.minorRelationshipProof = resp.data.fileUrl;
            vm.minorFormGuardianData.guardianrelationproofimageurl = resp.data.fileUrl;
            try{
              const file = resp.data.fileUrl;
              const fileName = file.split("/");
              vm.minorFormGuardianData.guardianrelationproofimagename = fileName[fileName.length - 1];
            }catch(e){}
            localStorage.setItem('folioId', resp.data.uuid);
          }
          else {
            MessageService.error(resp.message);
          }
        },
          error = function (e) {
            MessageService.error("file not upload");
          };
        var fd = new FormData();
        fd.append('file', file);
        var uuid = '';
        if ($stateParams.investorId) {
          uuid = $stateParams.investorId;
        } else if (localStorage.getItem('folioId')) {
          uuid = localStorage.getItem('folioId');
        } else {
          uuid = 'null';
        }
        InvestorFileUploadServiceV3.post2({
          child1: 'folio',
          child2: 'upload',
          child3: 'minor',
          child4: 'relationshipProof',
          child5: uuid
        }, fd).$promise.then(success, error);
      }
      else {
        MessageService.error("File size should not be more than 2 MB.")
      }
    }
    vm.getTaxFileStatusForGuardian = function (value) {
      if (value == 'Yes') {
        vm.minorFormGuardianData.fileTaxOtherIndian = 'Yes';
        vm.minorFormGuardianData.Fatca.taxPayIndian = false;
      } else {
        vm.minorFormGuardianData.fileTaxOtherIndian = 'No';
        vm.minorFormGuardianData.Fatca.taxPayIndian = true;
      }
    }

    vm.getPEPStatusForGuardian = function (value) {
      if (value == 'Yes') {
        vm.minorFormGuardianData.userPEPStatusForGuardian = 'Yes';
        vm.minorFormGuardianData.politicalStatus = 'POLITICAL';
      } else {
        vm.minorFormGuardianData.userPEPStatusForGuardian = 'No';
        vm.minorFormGuardianData.politicalStatus = 'NONE';
      }
    }
    vm.networthcall = function () {
      vm.networth = !vm.networth;
      if(vm.networth){
        vm.notolderthan1year = true;
        vm.minorFormGuardianData.grossAnnualIncome = '';
      }else{
        vm.notolderthan1year = false;
        vm.minorFormGuardianData.networth = '';
        vm.minorFormGuardianData.grossAnnualIncomeDate ='';
      }
    }
    vm.getProofType = function () {
      var success = function (resp) {
        vm.relationProofType = resp.data.proofTypeDTOList;
      },
        error = function () {
          MessageService.error("Error in proof type list!");
        };
      InvestorService.get({ child1: 'folio', child2: 'proof', child3: 'type' }, null).$promise.then(success, error);
    }
    vm.getProofType();

    vm.getOldFolioData = function () {
      var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
      if(isEditbuttonClick){
        $rootScope.minornext(0);
        var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
      }

      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.currentPayload = resp.data;

          vm.minorFormGuardianData.relation = resp.data.soleApplicantDetail.minorDetail.guardian.relation;
          vm.minorFormGuardianData.guardianrelationproofType = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProofType;
          vm.minorFormGuardianData.minorRelationshipProof = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
          vm.minorFormGuardianData.guardianrelationproofimageurl = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
          try{
            const file = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
            const fileName = file.split("/");
            vm.minorFormGuardianData.guardianrelationproofimagename = fileName[fileName.length - 1];
          }catch(e){}
          vm.minorFormGuardianData.occupation = resp.data.soleApplicantDetail.minorDetail.guardian.occupation;
          vm.minorFormGuardianData.grossAnnualIncome = resp.data.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
          vm.minorFormGuardianData.Fatca.Countrie = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry ? resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry : vm.minorFormGuardianData.Fatca.Countrie;
          vm.minorFormGuardianData.Fatca.City = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace;
          vm.minorFormGuardianData.Fatca.addressType = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.addressType ? resp.data.soleApplicantDetail.minorDetail.guardian.fatca.addressType : vm.minorFormGuardianData.Fatca.addressType;
          vm.minorFormGuardianData.Fatca.taxPay1 = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1;

          if (resp.data.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia == true) {
            vm.minorFormGuardianData.fileTaxOtherIndian = 'No';
            vm.minorFormGuardianData.Fatca.taxPayIndian = true;
          } else {
            vm.minorFormGuardianData.fileTaxOtherIndian = 'Yes';
            vm.minorFormGuardianData.Fatca.taxPayIndian = false;
          }

          if(resp.data.soleApplicantDetail.minorDetail.guardian.politicalStatus){
            if (resp.data.soleApplicantDetail.minorDetail.guardian.politicalStatus == 'NONE') {
              vm.minorFormGuardianData.userPEPStatusForGuardian = 'No';
              vm.minorFormGuardianData.politicalStatus = "NONE";
            } else {
              vm.minorFormGuardianData.userPEPStatusForGuardian = 'Yes';
              vm.minorFormGuardianData.politicalStatus = "POLITICAL";
            }
          }else{
            vm.minorFormGuardianData.userPEPStatusForGuardian = 'No';
            vm.minorFormGuardianData.politicalStatus = "NONE";
          }
          if(resp.data.soleApplicantDetail.minorDetail.guardian.netWorth){
            vm.minorFormGuardianData.networth = resp.data.soleApplicantDetail.minorDetail.guardian.netWorth;
            vm.minorFormGuardianData.grossAnnualIncomeDate = resp.data.soleApplicantDetail.minorDetail.guardian.netWorthDate;
            vm.networth = true;
          }else{
            vm.networth = false;
          }


        } else { }
      }, error = function (error) {
        MessageService.error(error.message);
      };
      var investorId = localStorage.getItem("folioId");
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'getDetails' }, { id: investorId }).$promise.then(success, error);
    }
    vm.getOldFolioData();

    vm.submitMinorGuardianDetails = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          $rootScope.minornext(1);
          $state.go('newInvestor.folioDetails.bankdetails');
          vm.errorMsg = "";
        } else {
          // vm.errorMsg = resp.message;
          if(resp.popupEnabled){
            ModalService.genericModal({
              text: resp.message
            });
          } else{
            MessageService.error(resp.message);
          }
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
      var taxIdentifier = UserData.panNumber;

      vm.currentPayload.soleApplicantDetail.minorDetail.minorRelationshipProof = vm.minorFormGuardianData.minorRelationshipProof;
      vm.currentPayload.soleApplicantDetail.minorDetail.minorRelationshipProofType = vm.minorFormGuardianData.guardianrelationproofType;
      vm.currentPayload.soleApplicantDetail.minorDetail.guardian = {
        panNumber: taxIdentifier,
        occupation: vm.minorFormGuardianData.occupation,
        grossAnnualIncome: vm.minorFormGuardianData.grossAnnualIncome,
        politicalStatus: vm.minorFormGuardianData.politicalStatus,
        netWorth : vm.minorFormGuardianData.networth,
        netWorthDate : vm.minorFormGuardianData.grossAnnualIncomeDate,
        relation: vm.minorFormGuardianData.relation,
        fatca: {
          birthCountry: vm.minorFormGuardianData.Fatca.Countrie,
          birthPlace: vm.minorFormGuardianData.Fatca.City,
          payTaxInIndia: vm.minorFormGuardianData.Fatca.taxPayIndian,
          addressType: vm.minorFormGuardianData.Fatca.addressType,
        },
        guardianRelationshipProofUrl: null
      };
      if(vm.minorFormGuardianData.grossAnnualIncome){
        vm.currentPayload.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome = vm.minorFormGuardianData.grossAnnualIncome;
      }else{
        delete vm.currentPayload.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
      }



      vm.currentPayload.holdmode = "SINGLE";
      vm.currentPayload.minor = true;
      vm.currentPayload.id = localStorage.getItem("folioId");
      vm.currentPayload.minorStep = "SECOND";
      vm.currentPayload.folioSaveStep = "TWO";
      vm.currentPayload.newUserFlow = true;
      vm.currentPayload.nriFlag = UserData ? !UserData.taxStatusResident : null;

      if (vm.minorFormGuardianData.Fatca.taxPayIndian) {
        vm.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1 = null;
      } else {
        vm.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1 = {
          taxPayingCountry: vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry,
          taxIdType: vm.minorFormGuardianData.Fatca.taxPay1.taxIdType,
          taxPayingCity: vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCity,
          taxId: vm.minorFormGuardianData.Fatca.taxPay1.taxId
        }
      }
      if(vm.distributorDetails){
        if(vm.distributorDetails.arn){
          vm.currentPayload.arnCode = 'ARN-'+vm.distributorDetails.arn;
        }
        if(vm.distributorDetails.riaCode){
          vm.currentPayload.arnCode = vm.distributorDetails.riaCode;
        }
        if(vm.distributorDetails.empCode){
          if(vm.distributorDetails.arn){
            vm.currentPayload.arnCode = 'ARN-'+vm.distributorDetails.arn;
          }else{
            vm.currentPayload.arnCode ='ARN-DIRECT';
          }
        }
        vm.currentPayload.oneClick = true;
      }
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.currentPayload).$promise.then(success, error);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioBasicMinorDetailsController', FolioBasicMinorDetailsController);

  /** @ngInject */
  function FolioBasicMinorDetailsController(InvestorService, InvestorFileUploadServiceV3, InvestorFileUploadService, InvestorServiceV3, investorServiceVersion, $scope, $state, $stateParams, $cookies, $window, AppConstants, UtilService, AuthService, $log, LoaderService,
    InvestorFolioModel, $rootScope, InvestorProfilePhotoService,NewInvestorServiceV3, MessageService, ModalService, $timeout, KycService, InvestorServiceVersion3) {
    var vm = this;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    $rootScope.folioBasicMinorDetail = {}
    $rootScope.folioBasicMinorDetail.Fatca = {};
    $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.minorFormData = {}
    vm.viewMode = "days";
    vm.dateErrorMessage = "";
    $rootScope.setUsetInfo();
    vm.minorFormData.minorsFullName = '';
    $rootScope.myState = $state.current.url;
    vm.minorFormData.dob = 'dd-mmm-yyyy';
    vm.minorFormData.gender = '';
    vm.minorFormData.ageproofType = '';
    vm.minorFormData.ageproofimageurl = '';
    vm.minorFormData.ageproofimageName = '';
    vm.minorFormData.taxstatus = '02';
    vm.genderObj = [{ name: 'Male', value: 'MALE' }, { name: 'Female', value: 'FEMALE' }];
    vm.taxStatus = [];
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.UserData = JSON.parse(sessionStorage.getItem("verifyObj"));

    $rootScope.folioBasicDetail.folioForUser = $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.getTaxStatus = function () {
      var success = function (resp) {
        vm.taxStatus = resp.data.taxStatus;
      },
        error = function () {
          MessageService.error("Error in minor tax status!");
        };
      var data = { taxStatusFilter: 'MINOR' }
      InvestorService.post({ child1: 'folio', child2: 'tax-status', }, data).$promise.then(success, error);
    }
    vm.getTaxStatus();


    vm.chooseFolioFor = function (foliofor) {
      if (foliofor === 'Minor' && vm.retirementFlag === true && (vm.UserData && vm.UserData.taxStatusResident)) {
        ModalService.genericModal({
          text: AppConstants.MINOR_FOLIO_WARNING
        }, function() {
          foliofor = 'Self';
          $rootScope.folioBasicDetail.folioForUser = 'Self';
        });
        return;
      }
      if (foliofor == 'Self') {
        if(vm.saveDraftPayload && vm.saveDraftPayload.investmentType=='SIP' &&
         vm.saveDraftPayload.paymentOption == 'EC' && !vm.saveDraftPayload.sipFI &&
         vm.distributorDetails && vm.distributorDetails.isHdfcBank ){
          MessageService.error("Please select Register E-mandate payment mode to proceed with folio creation and transaction");
        }else{
          $rootScope.folioBasicMinorDetail.folioForUser = 'Self';
          vm.showPopUp = true;
        }
      }
      else {
        $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
      }
    }

    vm.getMinordob = function (date) {
      vm.MINOR_DOB_ERROR = false;
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.minorFormData.dob = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.age = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.age < 18) {
         // console.log(vm.age);
          //console.log(moment(date).format("DD-MMM-YYYY"));
          vm.MINOR_DOB_ERROR = false;
        }
        else {
          vm.MINOR_DOB_ERROR = true;
        }
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.formData.dob = "";
      }
      return;
    }
    vm.getProofType = function () {
      var success = function (resp) {
        vm.minorAgeProofType = resp.data.proofTypeDTOList;
        // console.log(vm.minorAgeProofType);
      },
        error = function () {
          MessageService.error("Error in proof type list!");
        };
      InvestorService.get({ child1: 'folio', child2: 'proof', child3: 'type' }, null).$promise.then(success, error);
    }
    vm.getProofType();

    vm.getMinorAgeProofImage = function (file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file.size < 2000000) {
        vm.minorFormData.ageproofimageName = file.name;
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.minorFormData.ageproofimageurl = resp.data.fileUrl;
            try{
              const file = resp.data.fileUrl;
              const fileName = file.split("/");
              vm.minorFormData.ageproofimageName = fileName[fileName.length - 1];
            }catch(e){}
            localStorage.setItem('folioId', resp.data.uuid);
          }
          else {
            MessageService.error(resp.message);
          }
        },
          error = function (e) {
            MessageService.error("file not upload");
          };
        var fd = new FormData();
        fd.append('file', file);
        var uuid = localStorage.getItem('folioId');
        InvestorFileUploadServiceV3.post2({ child1: 'folio', child2: 'upload', child3: 'minor', child4: 'ageProof', child5: uuid }, fd).$promise.then(success, error);
      }
      else {
        MessageService.error("File size should not be more than 2 MB.")
      }
    }


    vm.getNewUserDetails = function () {
      try {
        var success = function (resp) {
          if (resp.status && resp.data) {
            if (resp.data.folioCreationDraftId) {
              localStorage.setItem("folioId", resp.data.folioCreationDraftId);
              vm.getOldFoliData();
            } else {
              vm.initiatFirstFolio();
            }

          } else {
            MessageService.error(resp.message);
          }
        },
          error = function (error) {
            MessageService.error(error.message);
          };
        var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
        vm.taxStatusResident = UserData ? UserData.taxStatusResident : true;
        var taxIdentifierNumber = UserData.panNumber;
        var payload = {
          "panNumber": taxIdentifierNumber
        }
        InvestorService.post({ child1: 'new', child2: 'user', child3: 'getDetails' }, payload).$promise.then(success, error);
      } catch (e) { }
    }
    vm.getNewUserDetails();
    vm.showPopUp = false;
    vm.getOldFoliData = function () {
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        $timeout(function () {}, 1000);
        if (resp.status && resp.data) {
          if (resp.data.minor == false) {
            vm.isMinor = false;
            vm.deleteCurrentFolio();
            vm.initiatFirstFolio();
            vm.showPopUp = false;
          }else{
            vm.isMinor = true;
            $rootScope.showSaveTag = true;
              $timeout(function () {
                $rootScope.showSaveTag = false;
              }, 3000);

              sessionStorage.setItem('folioStateData', 'BACK_ROUTE4');
              var isBackbuttonClick = sessionStorage.getItem("investorIsBackButtonClick");
              var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
              if(isEditbuttonClick){
                $rootScope.setProgress();
                sessionStorage.removeItem("investorIsEditButtonClick");
              }else{
              /*if(resp.data.folioSaveStep == 'ONE' && !isBackbuttonClick){
                $state.go('newInvestor.folioDetails.baiscMinorDetails');
              }/*else if(resp.data.folioSaveStep == 'TWO' && !isBackbuttonClick){
                $state.go('newInvestor.folioDetails.guardianMinorDetails');
              }else if(resp.data.folioSaveStep == 'FIVE' && !isBackbuttonClick){
                $state.go('newInvestor.folioDetails.bankdetails');
              }*/
            }

            vm.currentPayload = resp.data;
            vm.minorFormData.minorsFullName = resp.data.soleApplicantDetail.personalDetail.firstName;
            vm.minorFormData.dob = resp.data.soleApplicantDetail.personalDetail.dateOfBirth;
            vm.minorFormData.gender = resp.data.soleApplicantDetail.personalDetail.gender;
            vm.minorFormData.ageproofType = resp.data.soleApplicantDetail.minorDetail.minorProofType;
            vm.minorFormData.ageproofimageurl = resp.data.soleApplicantDetail.minorDetail.minorAgeProof;
            try{
              const file = resp.data.soleApplicantDetail.minorDetail.minorAgeProof;
              const fileName = file.split("/");
              vm.minorFormData.ageproofimageName = fileName[fileName.length - 1];
            }catch(e){}
            vm.minorFormData.taxstatus = resp.data.soleApplicantDetail.personalDetail.taxStatusCode || '02';
          }
        } else {
          if (resp.message == "Invalid Folio State") {
            vm.initiatFirstFolio();
          }
        }
      }, error = function (error) {
        LoaderService.hideLoader();
        MessageService.error(error.message);
      };
      LoaderService.showLoader();
      var investorId = localStorage.getItem("folioId");
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'getDetails' }, { id: investorId }).$promise.then(success, error);
    }


    vm.gotoSelf = function(){
      if(!vm.isMinor){
        vm.showPopUp = false;
        $state.go('newInvestor.folioDetails.baiscDetails');
      }
      else{
      vm.deleteCurrentFolio();
      vm.showPopUp = false;
      $state.go('newInvestor.folioDetails.baiscDetails');
      }

  }

   vm.deleteCurrentFolio =  function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status) {
          localStorage.removeItem("folioId");
          MessageService.success("Successfully delete folio draft data.");
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
        };
      var payload = {
        panNumber: vm.UserData.panNumber
      };
      if(payload.panNumber){
        InvestorServiceVersion3.post({ child1: 'new', child2: 'user', child3: 'delete', child4: 'folio' }, payload).$promise.then(success, error);
      }
   }
   vm.stayWithMinor  =function(){
    if(!vm.isMinor){
      vm.deleteCurrentFolio();
      vm.initiatFirstFolio();
      vm.showPopUp = false;
    }
    else{
      vm.showPopUp = false;
    }
    $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
   }


    vm.submitMinorBsicDetails = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          sessionStorage.setItem('folioStateData','BACK_ROUTE4');
          $rootScope.minornext(0);
          $state.go('newInvestor.folioDetails.guardianMinorDetails');
          vm.minor = true;
        } else {
          if(resp.popupEnabled){
            ModalService.genericModal({
              text: resp.message
            });
            } else{
              MessageService.error(resp.message);
            }
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };

        $window.smartech('dispatch', 'folio basic details', {
          'creatingfoliofor': 'Minor',
          'modeofholding': 'SINGLE',
          'taxinindia': vm.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia,
          'pepstatus': vm.currentPayload.soleApplicantDetail.minorDetail.guardian.politicalStatus
      });

      vm.currentPayload.minor = true;
      vm.currentPayload.id = localStorage.getItem("folioId");
      vm.currentPayload.minorStep = "FIRST";
      vm.currentPayload.folioSaveStep = "TWO";
      vm.currentPayload.newUserFlow = true;
      vm.currentPayload.nriFlag = vm.UserData ? !vm.UserData.taxStatusResident : null;
      // vm.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia = true;
      vm.currentPayload.soleApplicantDetail.minorDetail.minorAgeProof = vm.minorFormData.ageproofimageurl;
      vm.currentPayload.soleApplicantDetail.minorDetail.minorProofType = vm.minorFormData.ageproofType;
      vm.currentPayload.soleApplicantDetail.personalDetail.firstName = vm.minorFormData.minorsFullName;
      vm.currentPayload.soleApplicantDetail.personalDetail.dateOfBirth = vm.minorFormData.dob;
      vm.currentPayload.soleApplicantDetail.personalDetail.gender = vm.minorFormData.gender;
      vm.currentPayload.soleApplicantDetail.personalDetail.taxStatusCode = vm.minorFormData.taxstatus;
      if(vm.distributorDetails){
        if(vm.distributorDetails.arn){
          vm.currentPayload.arnCode = 'ARN-'+vm.distributorDetails.arn;
        }
        if(vm.distributorDetails.riaCode){
          vm.currentPayload.arnCode = vm.distributorDetails.riaCode;
        }
        if(vm.distributorDetails.empCode){
          if(vm.distributorDetails.arn){
            vm.currentPayload.arnCode = 'ARN-'+vm.distributorDetails.arn;
          }else{
            vm.currentPayload.arnCode = 'ARN-DIRECT';
          }
        }
        vm.currentPayload.oneClick = true;
      }
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.currentPayload).$promise.then(success, error);
    }

    vm.initiatFirstFolio = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          sessionStorage.setItem('folioStateData', {'userFolioBackState':'BACK_ROUTE4'});
          localStorage.setItem("folioId", resp.data.id);
          vm.getOldFoliData();
          vm.minor = true;
        } else {
          if(resp.popupEnabled){
            ModalService.genericModal({
              text: resp.message
            });
            } else{
              MessageService.error(error.message);
            }
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };
        if(vm.distributorDetails){
          vm.payloadData.ignoreDraftFolio  = true;
          if(vm.distributorDetails.arn){
            vm.payloadData.arnCode = 'ARN-'+vm.distributorDetails.arn;
          }
          if(vm.distributorDetails.riaCode){
            vm.payloadData.arnCode = vm.distributorDetails.riaCode;
          }
          if(vm.distributorDetails.empCode){
            if(vm.distributorDetails.arn){
              vm.payloadData.arnCode = 'ARN-'+vm.distributorDetails.arn;
            }else{
              vm.payloadData.arnCode = 'ARN-DIRECT';
            }
          }
          vm.payloadData.oneClick = true;
        }
        vm.payloadData.nriFlag = vm.UserData ? !vm.UserData.taxStatusResident : null;
        NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.payloadData).$promise.then(success, error);
    }
    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
         oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
    }

    vm.payloadData = {
      soleApplicantDetail: {
        minorDetail: {
          minorAgeProof: null,
          minorRelationshipProof: null,
          guardian: {
            panNumber: null,
            occupation: null,
            taxStatusCode: null,
            grossAnnualIncome: null,
            politicalStatus: null,
            netWorth: null,
            netWorthDate: null,
            kycVerified: null,
            name: null,
            gender: null,
            panValid: null,
            relation: null,
            fatca: {
              birthCountry: null,
              birthPlace: null,
              countryCitizenship: null,
              payTaxInIndia: true,
              addressType: null,
              fatcaTax1: {
                taxPayingCountry: null,
                taxPayingCity: null,
                taxIdNumber: null,
                taxId: null,
                taxIdType: null
              }
            },
            guardianRelationshipProofUrl: null
          }
        },
        selfDetail: null,
        personalDetail: {
          dateOfBirth: null,
          firstName: null,
          gender: null,
          taxStatusCode: null
        }
      },
      nominees: null,
      holdmode: "SINGLE",
      minor: true,
      folioSaveStep: "ONE",
      firstFolio: true,
      newUserFlow: true
    };

    vm.saveDraftPayload = null;
    GettransactionDraftData(function() {
      if(vm.retirementFlag) {
        ModalService.genericModal({
          text: "Only Self Folio can be created"
        }, function () {
          vm.gotoSelf();
        }, function () {
        });
      }
    });

    function GettransactionDraftData(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.saveDraftPayload = resp.data;
          vm.retirementFlag = resp.data.retirementFlag;
          cb(true);
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        MessageService.error(AppConstants.ToastrMessage.FAILED);
      };
      var Details = JSON.parse(sessionStorage.getItem("userData"));
      var Data = {};
      Data.id = Details.transactionDraftId;
      if(Data && Data.id){
        LoaderService.showLoader('.pan-loader');
        InvestorService.post({
          child1: 'new',
          child2: 'user',
          child3: 'saved',
          child4: 'draft'
        }, Data).$promise.then(success, error);
      }
     }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioBasicDetailsController', FolioBasicDetailsController);

  /** @ngInject */
  function FolioBasicDetailsController(InvestorService, investorServiceVersion, $scope, $state, $stateParams, $cookies, $window, AppConstants, UtilService, AuthService, $log, LoaderService,
    InvestorFolioModel, InvestorServiceV3,NewInvestorServiceV3,$location, $rootScope, InvestorProfilePhotoService, MessageService, ModalService, $timeout, KycService, InvestorServiceVersion3) {
    var vm = this;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    $rootScope.folioBasicDetail = {}
    $rootScope.folioBasicDetail.Fatca = {};
    $rootScope.folioBasicDetail.folioForUser = 'Self';
    $rootScope.folioBasicDetail.folioHoldingMode = "SINGLE";
    $rootScope.folioBasicDetail.fileTaxOtherIndian = 'No';
    $rootScope.folioBasicDetail.Fatca.fatcaTax1 = {}
    $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry = '';
    $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxIdType = '';
    $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCity = '';
    $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId = '';
    $rootScope.myState = $state.current.url;
    $rootScope.setUsetInfo();
    $rootScope.folioBasicDetail.userPEPStatus = 'No';
    $rootScope.folioBasicDetail.politicalStatus = 'NONE';
    $rootScope.folioBasicDetail.Fatca.taxPayIndia = true;
    $rootScope.folioBasicDetail.Fatca.Countrie = '';
    $rootScope.folioBasicDetail.Fatca.City = '';
    $rootScope.folioBasicDetail.Fatca.addressType = '';
    localStorage.setItem("folioId","");
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.UserData = JSON.parse(sessionStorage.getItem("verifyObj"));



    vm.folioSelfSingleBasicForm = {
      folioFor: '',
      holderMode: '',
      taxPayIndia: ''
    }
    vm.chooseFolioFor = function (foliofor) {
      if (foliofor === 'Minor' && vm.retirementFlag === true) {
        ModalService.genericModal({
          text: AppConstants.MINOR_FOLIO_WARNING
        }, function() {
          foliofor = 'Self';
          $rootScope.folioBasicDetail.folioForUser = 'Self';
        });
        return;
      }
      if (foliofor == 'Self') {
        $rootScope.folioBasicDetail.folioForUser = 'Self';
      }
      else {
        if(vm.saveDraftPayload && vm.saveDraftPayload.investmentType=='SIP' && vm.saveDraftPayload.paymentOption == 'HEM' && !vm.saveDraftPayload.sipFI ){
          MessageService.error("E-mandate Registration payment mode is not available for investment in minor folio. Please go to previous page and select Standing Instructions/Biller payment mode to continue.");
        }else if(vm.saveDraftPayload && vm.saveDraftPayload.investmentType=='SIP' && vm.saveDraftPayload.paymentOption == 'HEM'  && vm.saveDraftPayload.sipFI && vm.distributorDetails && vm.distributorDetails.isHdfcBank ){
          MessageService.error("SIP with first installment facility is not available in minor folio. Please go to previous page and deselect option for SIP with first installment option");
        }else{
          if(foliofor == 'Minor' && vm.UserData && !vm.UserData.taxStatusResident) {
            ModalService.genericModal({
              text: AppConstants.MINOR_FOLIO_WARNING
            }, function() {
              foliofor = 'Self';
              $rootScope.folioBasicDetail.folioForUser = 'Self';
            });
            return;
          } else {
            $rootScope.folioBasicDetail.folioForUser = 'Minor';
            $rootScope.showPopUpWindow = true;
          }
          // $state.go('newInvestor.folioDetails.baiscMinorDetails');
        }
      }
    }

    vm.getholdingmode = function (value) {
      if (value == 'SINGLE') {
        $rootScope.folioBasicDetail.folioHoldingMode = 'SINGLE';
        sessionStorage.setItem('ModeOfHold', $rootScope.folioBasicDetail.folioHoldingMode);
        localStorage.setItem('holdmode', $rootScope.folioBasicDetail.folioHoldingMode);
      }
      else {
        $rootScope.folioBasicDetail.folioHoldingMode = 'ANY_OR_SURVIVOR';
        sessionStorage.setItem('ModeOfHold', $rootScope.folioBasicDetail.folioHoldingMode);
        localStorage.setItem('holdmode', $rootScope.folioBasicDetail.folioHoldingMode);
      }
    }


    vm.getTaxFileStatus = function (value) {
      if (value == 'Yes') {
        $rootScope.folioBasicDetail.fileTaxOtherIndian = 'Yes';
        $rootScope.folioBasicDetail.Fatca.taxPayIndia = false;
      } else {
        $rootScope.folioBasicDetail.fileTaxOtherIndian = 'No';
        $rootScope.folioBasicDetail.Fatca.taxPayIndia = true;
      }
    }
    vm.getPEPStatus = function (value) {
      if (value == 'Yes') {
        $rootScope.folioBasicDetail.userPEPStatus = 'Yes';
        $rootScope.folioBasicDetail.politicalStatus = 'POLITICAL';
      } else {
        $rootScope.folioBasicDetail.userPEPStatus = 'No';
        $rootScope.folioBasicDetail.politicalStatus = 'NONE';
      }
    }


    vm.isBackbuttonFlow = sessionStorage.getItem("investorIsBackButtonClick");
    vm.getNewUserDetails = function(){
      var success = function (resp) {
        if(resp.status && resp.data){
          if(resp.data.folioCreationDraftId){
            localStorage.setItem("folioId", resp.data.folioCreationDraftId);
            var uuid = localStorage.getItem("folioId");
            if(vm.distributorDetails && !vm.isBackbuttonFlow){
              vm.createFolio = true;
            }else{
              vm.getPayload(localStorage.getItem("folioId"));
              vm.createFolio = false;
            }
          }else{
            vm.createFolio = true;
          }
          if(resp.data.step == "SECOND"){
            // $state.go("newInvestor.investmentDetails.investmentmode")
           }

        }else{
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader('userGetDetails');
      },
      error = function (error) {
        LoaderService.hideLoader('userGetDetails');
        MessageService.error(error.message);
      };

      var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
      vm.taxStatusResident = UserData ? UserData.taxStatusResident : true;
      var taxIdentifier = UserData.panNumber;
      var payload = {
        "panNumber": taxIdentifier
      }
      LoaderService.showLoader('userGetDetails');
      InvestorService.post({child1: 'new',child2: 'user',child3: 'getDetails'},payload).$promise.then(success, error);
    }
    vm.getNewUserDetails();
    vm.createFolio = true;
    $rootScope.showPopUpWindow = false;
    vm.getPayload = function(folioId) {
      var success = function (resp) {
          if (resp.status && resp.data) {
            if(resp.data.minor){
              if(vm.distributorDetails && vm.saveDraftPayload && vm.saveDraftPayload.paymentOption !="EC"){
                vm.deleteFolio();
              }else{
                if(vm.saveDraftPayload && vm.saveDraftPayload.investmentType=='SIP' && vm.saveDraftPayload.paymentOption == 'HEM'){
                  var successModal = function(resp){
                    if(resp.key == 'continuewithSelf'){
                      vm.deleteFolio();
                    }
                  },errorModal = function(){

                  }
                  ModalService.decisionFolioModal({},successModal,errorModal)
                }else{
                  $rootScope.showPopUpWindow = true;
                }
              }
            }else{
              if(vm.distributorDetails && vm.saveDraftPayload && !vm.saveDraftPayload.sipFI && vm.saveDraftPayload.paymentOption =="EC" && vm.saveDraftPayload.investmentType =="SIP" && (vm.UserData && vm.UserData.taxStatusResident == true)){
                vm.deleteFolio();
                $state.go('newInvestor.folioDetails.baiscMinorDetails');
              } else{
                $rootScope.showSaveTag = true;
                $timeout(function () {
                  $rootScope.showSaveTag = false;
                }, 3000);

                $rootScope.folioBasicDetail.folioForUser = 'Self';
                vm.currentPayload = resp.data;
                var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
                if(isEditbuttonClick){
                  sessionStorage.removeItem("investorIsEditButtonClick");
                }else{

                if(resp.data.holdmode == "SINGLE"){
                  $rootScope.folioBasicDetail.folioHoldingMode = "SINGLE";
                  sessionStorage.setItem('ModeOfHold', $rootScope.folioBasicDetail.folioHoldingMode);
                  localStorage.setItem('holdmode', $rootScope.folioBasicDetail.folioHoldingMode);
                  sessionStorage.setItem('folioStateData', 'BACK_ROUTE2');

                var isBackbuttonClick = sessionStorage.getItem("investorIsBackButtonClick");
                $rootScope.setBasicDetails();
                /*if(resp.data.folioSaveStep == 'ONE' && !isBackbuttonClick){
                  $rootScope.nextStep(0);
                  $rootScope.nextStep(1);
                  $state.go('newInvestor.folioDetails.incomeDetails');
                }else if(resp.data.folioSaveStep == 'TWO' && !isBackbuttonClick){
                  $rootScope.nextStep(0);
                  $rootScope.nextStep(1);
                  $rootScope.nextStep(2);
                  $state.go('newInvestor.folioDetails.nomineeDetails' && !isBackbuttonClick);
                }else if(resp.data.folioSaveStep == 'THREE' && !isBackbuttonClick){
                  $state.go('newInvestor.folioDetails.bankdetails');
                }else if(resp.data.folioSaveStep == 'FIVE' && !isBackbuttonClick){
                  $state.go('newInvestor.folioDetails.bankdetails');
                }*/
              }else{
                $rootScope.folioBasicDetail.folioHoldingMode = "ANY_OR_SURVIVOR";
                sessionStorage.setItem('ModeOfHold', $rootScope.folioBasicDetail.folioHoldingMode);
                localStorage.setItem('holdmode', $rootScope.folioBasicDetail.folioHoldingMode);
                sessionStorage.setItem('folioStateData', 'BACK_ROUTE3');
                var isBackbuttonClick = sessionStorage.getItem("investorIsBackButtonClick");
                $rootScope.setBasicDetails();
                /*if(resp.data.folioSaveStep == 'ONE' && !isBackbuttonClick){
                  $rootScope.nextStep(0);
                  $rootScope.nextStep(1);
                  $state.go('newInvestor.folioDetails.incomeDetails');
                }else if(resp.data.folioSaveStep == 'TWO' && !isBackbuttonClick){
                  $rootScope.nextStep(0);
                  $rootScope.nextStep(1);
                  $rootScope.nextStep(2);
                  $state.go('newInvestor.folioDetails.jointHolderDetails');
                }else if(resp.data.folioSaveStep == 'THREE' && !isBackbuttonClick){
                  $rootScope.nextStep(0);
                  $rootScope.nextStep(1);
                  $rootScope.nextStep(2);
                  $state.go('newInvestor.folioDetails.nomineeDetails');
                }else if(resp.data.folioSaveStep == 'FOUR' && !isBackbuttonClick){
                  $state.go('newInvestor.folioDetails.bankdetails');
                }else if(resp.data.folioSaveStep == 'FIVE' && !isBackbuttonClick){
                  $state.go('newInvestor.folioDetails.bankdetails');
                }*/
              }
              }
              if(resp.data.soleApplicantDetail.selfDetail.fatca.payTaxInIndia){
                $rootScope.folioBasicDetail.Fatca.taxPayIndia = true;
                $rootScope.folioBasicDetail.fileTaxOtherIndian = 'No';
              }else{
                $rootScope.folioBasicDetail.Fatca.taxPayIndia = false;
                $rootScope.folioBasicDetail.fileTaxOtherIndian = 'Yes';
                $rootScope.folioBasicDetail.Fatca.fatcaTax1 = resp.data.soleApplicantDetail.selfDetail.fatca.fatcaTax1;
              }


              if(angular.isUndefined(resp.data.soleApplicantDetail.selfDetail.politicalStatus) || resp.data.soleApplicantDetail.selfDetail.politicalStatus == "NONE"){
                $rootScope.folioBasicDetail.politicalStatus = "NONE";
                $rootScope.folioBasicDetail.userPEPStatus = "No";
              }else{
                $rootScope.folioBasicDetail.politicalStatus = "POLITICAL";
                $rootScope.folioBasicDetail.userPEPStatus = "Yes";
              }

              if(resp.data.soleApplicantDetail.selfDetail.fatca.fatcaTax1){
                vm.folioBasicDetail.Fatca.fatcaTax1 = resp.data.soleApplicantDetail.selfDetail.fatca.fatcaTax1;
              }
            }
            }
          } else {
            if(resp.message == "Invalid Folio State"){
              vm.createFolio = true;
            }
          }
           LoaderService.hideLoader('folioGetDetails');
        },
        error = function (err) {
          LoaderService.hideLoader('folioGetDetails');
          MessageService.error(err);
        };
      var investorId = localStorage.getItem("folioId");
      if(investorId){
        LoaderService.showLoader('folioGetDetails');
        NewInvestorServiceV3.post({child1: 'folio',child2: 'getDetails'},{id:investorId}).$promise.then(success, error);
      }
    }
    vm.gotoMinor = function(){
      $rootScope.showPopUpWindow = false;
      $rootScope.folioBasicDetail.folioForUser = 'Minor';
      var uuid = localStorage.getItem("folioId");
      if(uuid){
        vm.deleteFolio();
      }
      $state.go('newInvestor.folioDetails.baiscMinorDetails');
    }
    vm.stayWithMajor = function(){
      $rootScope.showPopUpWindow = false;
      $rootScope.folioBasicDetail.folioForUser = 'Self';
    }
   vm.deleteFolio = function(){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status) {
          vm.createFolio = true;
          localStorage.removeItem("folioId");
          $rootScope.showPopUpWindow = false;
          MessageService.success("Successfully delete folio draft data.");
          vm.getPayload(localStorage.getItem("folioId"));
        } else {
          // MessageService.error(resp.message);
        }
        LoaderService.hideLoader('delete-folio');
      },
        error = function (err) {
         LoaderService.hideLoader('delete-folio');
          LoaderService.hideLoader();
        };
      var payload = {
        panNumber: vm.UserData.panNumber
      };
      if(payload.panNumber){
         LoaderService.showLoader('delete-folio');
        InvestorServiceVersion3.post({ child1: 'new', child2: 'user', child3: 'delete', child4: 'folio' }, payload).$promise.then(success, error);
      }
    }

    vm.submitFolioSelfSingleBsicForm = function () {
      if(vm.createFolio){
        var success = function (resp) {
          if(resp.data){
            if (resp.data.folioDataInvalid) {
              var success = function() {
                vm.logout();
              }, error = function(resp) {
                vm.logout();
              };
              ModalService.genericModal({
                text: resp.data.message
              }, success, error);
            } else {
              if($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE' && $rootScope.folioBasicDetail.folioForUser == 'Self'){
                sessionStorage.setItem('folioStateData', 'BACK_ROUTE2');
              }else if($rootScope.folioBasicDetail.folioHoldingMode == 'ANY_OR_SURVIVOR' && $rootScope.folioBasicDetail.folioForUser == 'Self'){
                sessionStorage.setItem('folioStateData', 'BACK_ROUTE3');
              }else if($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE' && $rootScope.folioBasicDetail.folioForUser == 'Minor'){
                sessionStorage.setItem('folioStateData', 'BACK_ROUTE4');
              }else{
                sessionStorage.setItem('folioStateData', 'NOROUTE');
              }

              localStorage.setItem("folioId", resp.data.id);
              vm.getPayload(resp.data.id);
              $rootScope.nextStep(0);
              $state.go('newInvestor.folioDetails.incomeDetails');
            }
          }else{
            if(resp.popupEnabled){
              ModalService.genericModal({
                text: resp.message
              });
              } else{
                MessageService.error(resp.message);
                vm.createFolio = false;
              }
          }
          LoaderService.hideLoader('initiate');
        },
        error = function (error) {
          LoaderService.hideLoader('initiate');
          MessageService.error(error.message);
        };

        $window.smartech('dispatch', 'folio basic details', {
          'creatingfoliofor': $rootScope.folioBasicDetail.folioForUser,
          'modeofholding': $rootScope.folioBasicDetail.folioHoldingMode,
          'taxinindia': $rootScope.folioBasicDetail.Fatca.taxPayIndia,
          'pepstatus': $rootScope.folioBasicDetail.politicalStatus
       });

        var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
        var taxIdentifier = UserData.panNumber;
        vm.dataPayload.nriFlag = UserData ? !UserData.taxStatusResident : null;
        vm.dataPayload.holdmode = $rootScope.folioBasicDetail.folioHoldingMode;
        vm.dataPayload.soleApplicantDetail.selfDetail.panNumber = taxIdentifier;
        vm.dataPayload.soleApplicantDetail.selfDetail.politicalStatus = $rootScope.folioBasicDetail.politicalStatus;
        vm.dataPayload.soleApplicantDetail.selfDetail.fatca.payTaxInIndia = $rootScope.folioBasicDetail.Fatca.taxPayIndia;
        if($rootScope.folioBasicDetail.Fatca.taxPayIndia){
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = null;
        }else{
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = {};
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCountry = $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry;
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCity = $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCity;
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxIdNumber = $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId;
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxId = $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId;
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxIdType = $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxIdType;
        }
        LoaderService.showLoader('initiate');
        if(vm.distributorDetails){
          vm.dataPayload.ignoreDraftFolio  = true;
          if(vm.distributorDetails.arn){
            vm.dataPayload.arnCode = 'ARN-'+vm.distributorDetails.arn;
          }
          if(vm.distributorDetails.riaCode){
            vm.dataPayload.arnCode = vm.distributorDetails.riaCode;
          }
          if(vm.distributorDetails.empCode){
            if(vm.distributorDetails.arn){
              vm.dataPayload.arnCode = 'ARN-'+vm.distributorDetails.arn;
            }else{
              vm.dataPayload.arnCode = 'ARN-DIRECT';
            }
          }
          vm.dataPayload.oneClick = true;
        }
        NewInvestorServiceV3.post({child1: 'folio',child2: 'initiate'}, vm.dataPayload).$promise.then(success, error);
      }else{
        var success = function (resp) {
          if(resp.status && resp.data){
            if (resp.data.folioDataInvalid) {
              var success = function() {
                vm.logout();
              }, error = function(resp) {
                vm.logout();
              };
              ModalService.genericModal({
                text: resp.data.message
              }, success, error);
            } else {
              if($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE' && $rootScope.folioBasicDetail.folioForUser == 'Self'){
                sessionStorage.setItem('folioStateData','BACK_ROUTE2');
              }else if($rootScope.folioBasicDetail.folioHoldingMode == 'ANY_OR_SURVIVOR' && $rootScope.folioBasicDetail.folioForUser == 'Self'){
                sessionStorage.setItem('folioStateData','BACK_ROUTE3');
              }else if($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE' && $rootScope.folioBasicDetail.folioForUser == 'Minor'){
                sessionStorage.setItem('folioStateData', 'BACK_ROUTE4');
              }else{
                sessionStorage.setItem('folioStateData', 'NOROUTE');
              }
              $rootScope.nextStep(0);
              $state.go('newInvestor.folioDetails.incomeDetails');
            }
          }else{
            if(resp.popupEnabled){
              ModalService.genericModal({
                text: resp.message
              });
              } else{
                MessageService.error(resp.message);
              }
          }
          LoaderService.hideLoader('initiate');
        },
        error = function (error) {
          LoaderService.hideLoader('initiate');
          MessageService.error(error.message);
        };

        $window.smartech('dispatch', 'folio basic details', {
          'creatingfoliofor': $rootScope.folioBasicDetail.folioForUser,
          'modeofholding': $rootScope.folioBasicDetail.folioHoldingMode,
          'taxinindia': $rootScope.folioBasicDetail.Fatca.taxPayIndia,
          'pepstatus': $rootScope.folioBasicDetail.politicalStatus
       });

        vm.currentPayload.holdmode = $rootScope.folioBasicDetail.folioHoldingMode;
        vm.currentPayload.minor = false;
        vm.currentPayload.folioSaveStep = "ONE";
        vm.currentPayload.firstFolio = true;
        vm.currentPayload.newUserFlow = true;
        vm.currentPayload.nriFlag = vm.UserData ? !vm.UserData.taxStatusResident : null;
        vm.currentPayload.id = localStorage.getItem("folioId");
        vm.currentPayload.soleApplicantDetail.selfDetail.politicalStatus = $rootScope.folioBasicDetail.politicalStatus;
        vm.currentPayload.soleApplicantDetail.selfDetail.fatca.payTaxInIndia = $rootScope.folioBasicDetail.Fatca.taxPayIndia;
        if($rootScope.folioBasicDetail.Fatca.taxPayIndia){
          vm.currentPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = null;

        }else{
          vm.currentPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = {
            taxPayingCountry: $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry,
            taxPayingCity: $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCity,
            taxIdNumber: $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId,
            taxId: $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId,
            taxIdType: $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxIdType
          }
        }
        LoaderService.showLoader('initiate');
        if(vm.distributorDetails){
          if(vm.distributorDetails.arn){
            vm.currentPayload.arnCode = 'ARN-'+vm.distributorDetails.arn;
          }
          if(vm.distributorDetails.riaCode){
            vm.currentPayload.arnCode = vm.distributorDetails.riaCode;
          }
          if(vm.distributorDetails.empCode){
            if(vm.distributorDetails.arn){
              vm.currentPayload.arnCode = 'ARN-'+vm.distributorDetails.arn;
            }else{
              vm.currentPayload.arnCode = 'ARN-DIRECT';
            }
          }
          vm.dataPayload.oneClick = true;
        }
        LoaderService.showLoader('initiate');
        NewInvestorServiceV3.post({child1: 'folio',child2: 'initiate'}, vm.currentPayload).$promise.then(success, error);
      }

    }


    try{
      var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
      var taxIdentifier = UserData.panNumber;
    }catch(e){}

   vm.dataPayload = {
      soleApplicantDetail: {
          minorDetail: {
          minorAgeProof: null,
          minorRelationshipProof: null,
          guardian: {
              panNumber: null,
              occupation: null,
              taxStatusCode: null,
              grossAnnualIncome: null,
              politicalStatus: null,
              netWorth: null,
              netWorthDate: null,
              kycVerified: null,
              name: null,
              gender: null,
              panValid: null,
              relation: null,
              fatca: {
                  birthCountry: null,
                  birthPlace: null,
                  countryCitizenship: null,
                  payTaxInIndia: false,
                  addressType: null,
                  fatcaTax1: {
                      taxPayingCountry: null,
                      taxPayingCity: null,
                      taxIdNumber: null,
                      taxId: null,
                      taxIdType: null
                  },
                  fatcaTax2: {
                      taxPayingCountry: null,
                      taxPayingCity: null,
                      taxIdNumber: null,
                      taxId: null,
                      taxIdType: null
                  },
                  fatcaTax: {
                      taxPayingCountry: null,
                      taxPayingCity: null,
                      taxIdNumber: null,
                      taxId: null,
                      taxIdType: null
                  }
              },
              guardianRelationshipProofUrl: null
          }
          },
          selfDetail: {
          panNumber: taxIdentifier,
          occupation: null,
          taxStatusCode: null,
          grossAnnualIncome: null,
          politicalStatus: "NONE",
          netWorth: null,
          netWorthDate: null,
          kycVerified: null,
          address: {
              addressLine1: null,
              addressLine2: null,
              addressLine3: null,
              pinCode: null,
              city: null,
              state: null,
              country: null
          },
          fatca: {
              birthCountry: null,
              birthPlace: null,
              countryCitizenship: null,
              payTaxInIndia: true,
              addressType: null
          }
          },
          personalDetail: {
          dateOfBirth: null,
          firstName: null,
          gender: null,
          taxStatusCode: null
          }
      },

      nominees: [
      {
          title: null,
          nomineeName: null,
          nomineeRelation: null,
          percentage: null,
          dob: null,
          nomineeAddress: {
              addressLine1: null,
              addressLine2: null,
              addressLine3: null,
              pinCode: null,
              city: null,
              state: null,
              country: null
          },
          guardianAddress: {
               addressLine1: null,
              addressLine2: null,
              addressLine3: null,
              pinCode: null,
              city: null,
              state: null,
              country: null
          },
          minor: null,
          guardianName: null,
          soleAddressApplicable: null
      }],

      holdmode: "SINGLE",
      minor: false,
      folioSaveStep: "ONE",
      firstFolio: true,
      newUserFlow:true
   }

    vm.logout = function(){
      var success = function (resp) {
        if (resp.status) {
          MessageService.success(resp.message);
          sessionStorage.clear();
          $state.go('newInvestor.kycVerification');
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader('.logout');
      },
      error = function (err) {
        LoaderService.hideLoader('.logout');
        MessageService.error(err.data.message);
      };
      LoaderService.showLoader('.logout');
      var Details = JSON.parse(sessionStorage.getItem("verifyObj"));
      var Data = {
        "panNumber": Details.panNumber
      };
      InvestorService.post({
        child1: 'force',
        child2: 'logout'
      }, Data).$promise.then(success, error);
    }



   function GettransactionDraftData() {
    var success = function (resp) {
      if (resp.data && resp.status) {
        vm.saveDraftPayload = resp.data;
        vm.retirementFlag = resp.data.retirementFlag;
        if(vm.distributorDetails && vm.saveDraftPayload && !vm.saveDraftPayload.sipFI && vm.saveDraftPayload.paymentOption == "EC" && vm.saveDraftPayload.investmentType =="SIP" && (vm.UserData && vm.UserData.taxStatusResident == true)){
          $state.go('newInvestor.folioDetails.baiscMinorDetails');
        }
      } else {
        MessageService.error(resp.message);
      }
    },
      error = function (err) {
        MessageService.error(AppConstants.ToastrMessage.FAILED);
      };
      var Details = JSON.parse(sessionStorage.getItem("userData"));
      var Data = {};
      Data.id = Details.transactionDraftId;
      if(Data && Data.id){
        LoaderService.showLoader('.pan-loader');
        InvestorService.post({
          child1: 'new',
          child2: 'user',
          child3: 'saved',
          child4: 'draft'
        }, Data).$promise.then(success, error);
      }
      }
      if(vm.distributorDetails && vm.distributorDetails.transactionType == 'Purchase_Scheduler'){
      }else{
        GettransactionDraftData();
      }
    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('BankDetailsController', BankDetailsController);

  /** @ngInject */
  function BankDetailsController($window, $rootScope, $timeout, InvestorFileUploadServiceV3, $state, $stateParams, $scope, AuthService, HDFC_API, toastr, LoaderService,
    AppConstants, TransactionService, MessageService, InvestorServiceV3,NewInvestorServiceV3, ModalService, UtilService, CommonFactory, CreatePayloadFactory, InvestorService,
    deviceDetector, $http, $sce, NetcoreEvntService,$location, $log, BrowserService, investorServiceVersion, InvestorServiceVersion3, MetaTagService,FileSaver,DownloadPdfService) {
    var vm = this;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.bankAccountType = [];
    vm.bankAccountDetailsForm = {};
    vm.bankAccountDetailsForm.bankDetails = {};
    $rootScope.historyLocation.push($location.$$path);
    vm.bankAccountDetailsForm.bankDetails.payoutMechanism = "";
    vm.bankAccountDetailsForm.ifscCode = '';
    $rootScope.myState = $state.current.url;
    $rootScope.setUsetInfo();
    vm.bankAccountDetailsForm.accountNumber = '';
    vm.bankAccountDetailsForm.accountNumberverify = '';
    vm.bankAccountDetailsForm.accountType = '';
    vm.userTaxStatusCode = "";
    vm.gettaxStatus = gettaxStatus;
    vm.getTransactionDetails = getTransactionDetails;
    vm.showValidateBtn = false;
    vm.bankAccountDetailsForm.pennyDropValid = false;
    vm.bankAccountDetailsForm.chequesleafImageUrl = "";
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    $rootScope.testObj.steps[1].stepCompleted = true;
    vm.showcheckLeaf = false;
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.UserData = JSON.parse(sessionStorage.getItem("verifyObj"));

    function gettaxStatus() {
      if(vm.distributorDetails && vm.distributorDetails.transactionType == 'Purchase_Scheduler'){
      }else{
        getTransactionDetails();
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
          if(resp.data.minor){
            $rootScope.folioBasicDetail.folioForUser = "Minor";
            $rootScope.minornext(0);
            $rootScope.minornext(1);
          }else{
            $rootScope.folioBasicDetail.folioForUser = "Self";
            var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
            // if(isEditbuttonClick){
              if($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE'){
                $rootScope.nextStep(0);
                $rootScope.nextStep(1);
                $rootScope.nextStep(2);
              }else{
                $rootScope.nextStep(0);
                $rootScope.nextStep(1);
                $rootScope.nextStep(2);
                $rootScope.nextStep(3);
              }
            // }
          }
          $rootScope.testObj.steps[1].stepActive = false;
          $rootScope.testObj.steps[1].stepCompleted = true;
          vm.userTaxStatusCode = resp.data.soleApplicantDetail.personalDetail.taxStatusCode;
          sessionStorage.setItem('ModeOfHold', resp.data.holdmode);
          localStorage.setItem('holdmode', resp.data.holdmode);
          vm.getBankcAccountType();
          vm.payLoad = resp.data;
          var bankExistData = resp.data.bankDetails;
          vm.bankAccountDetailsForm.ifscCode = bankExistData.ifsccode;
          if(bankExistData.accountType){
            if(vm.userTaxStatusCode === '01'|| vm.userTaxStatusCode === '02'){
                if(bankExistData.accountType == 'CA'|| bankExistData.accountType == 'PSB'|| bankExistData.accountType == 'CLSB'){
                  vm.bankAccountDetailsForm.accountType = bankExistData.accountType;
                }
                else{
                  vm.bankAccountDetailsForm.accountType ="SB";
                }
            }
            if(vm.userTaxStatusCode === '21'){
                vm.bankAccountDetailsForm.accountType ="NRE";
            }
            if(vm.userTaxStatusCode === '24'){
                vm.bankAccountDetailsForm.accountType ="NRO";
            }
          }
          vm.bankAccountDetailsForm.accountNumber = bankExistData.accountNumber;
          vm.bankAccountDetailsForm.accountNumberverify = bankExistData.accountNumber;
          vm.bankchequeLeafUrl = bankExistData.chequeLeaf;
          if(resp.data.bankDetails){
           if(resp.data.bankDetails.accountHolderName){
            if(resp.data.bankDetails.pennyDropValid == false){
              vm.showcheckLeaf = true;
            }else{
              vm.showcheckLeaf = false;
            }
           }else{
            vm.showcheckLeaf = false;
           }
         }

          try{
            const checkLeafString = bankExistData.chequeLeaf;
            const fileName = checkLeafString.split("/");
            vm.bankAccountDetailsForm.chequesleafImageUrl = fileName[fileName.length - 1];
          }catch(e){}
          if(bankExistData.chequeLeaf){
            vm.fileType = bankExistData.chequeLeaf.substr(bankExistData.chequeLeaf.length - 3);
          }
          vm.bankAccountDetailsForm.bankName = bankExistData.bankName;
          vm.bankAccountDetailsForm.bankDetails.payoutMechanism =  bankExistData.payoutMechanism;
          vm.bankAccountDetailsForm.bankCity = bankExistData.bankCity;
          vm.bankAccountDetailsForm.branchLocation = bankExistData.bankBranch;
          vm.bankAccountDetailsForm.pennyDropValid = bankExistData.pennyDropValid;
          if($rootScope.folioBasicDetail.folioForUser =='Minor' || vm.userTaxStatusCode == 21 || vm.userTaxStatusCode == 24){
            vm.showcheckLeaf = true;
          }
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(err.message);
        };
      var investorId = localStorage.getItem("folioId");
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'getDetails' }, { id: investorId }).$promise.then(success, error);
    }

    vm.getBankcAccountType = function () {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.bankAccountType = resp.data.bankAccountTypes;
          $rootScope.AccountTypes = resp.data.bankAccountTypes;
        }
        else {
          vm.panMessage = resp.message;
        }
      },
        error = function () {
          MessageService.error("Bank account type service error!");
        };
      InvestorService.get({ child1: 'folio', child2: 'bank', child3: 'account-type-list', child4: vm.userTaxStatusCode }).$promise.then(success, error);
    }

    vm.getPayoutMechanism = function () {
      var success = function (resp) {
          if (resp.status && resp.data) {
              vm.payoutMechanismList = resp.data.payoutMechanisms;
              $rootScope.payoutMechanismData = resp.data.payoutMechanisms;
          } else {
              MessageService.error(resp.message);
          }
      },
          error = function (err) {
              $log.info('Payout Machanism error >>>>', err);
          };

      InvestorService.get({ child1: 'folio', child2: 'payout-mechanism' }).$promise.then(success, error);
   }
    vm.getPayoutMechanism();

    vm.matchAccountNumber = function () {
      if (vm.bankAccountDetailsForm.accountNumber === vm.bankAccountDetailsForm.accountNumberverify) {
        vm.showValidateBtn = true;
      } else {
        vm.showValidateBtn = false;
        // console.log('not match');
      }
      if($rootScope.folioBasicDetail.folioForUser == "Minor"  || vm.userTaxStatusCode == 21 || vm.userTaxStatusCode == 24){
        vm.showcheckLeaf = true;
      }else{
        vm.showcheckLeaf = false;
      }
    }

    vm.fetchBankList = function () {
      var success = function (res) {
        if (res.status && res.data) {
          vm.bankList = res.data.bankList;

        }
        else {
          vm.bankList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        vm.bankList = null;
        UtilService.errorHandler(err);
      };

      InvestorService.get({ child1: 'rbi', child2: 'bankNames' }).$promise.then(success, error);
    }
    vm.fetchBankList();

    vm.selectIFSC = function () {
      var successModal = function (data) {
        // console.log(data);
        vm.bankAccountDetailsForm.ifscCode = data.ifscCode;
        vm.bankAccountDetailsForm.bankName = data.bankName;
        vm.bankAccountDetailsForm.bankCity = data.branchCity;
        vm.bankAccountDetailsForm.branchLocation = data.branch;

        if (data.branch && data.branch.length > 40)
          vm.bankAccountDetailsForm.bankBranch = data.branch.slice(0, 40)
        else vm.bankAccountDetailsForm.bankBranch = data.branch;

        if (data.pennyDropEnabled && vm.userTaxStatusCode === '01') {
          vm.bankAccountDetailsForm.pennyDropValid = true;
        }
        else {
          vm.bankAccountDetailsForm.pennyDropValid = false;
        }
        if(vm.userTaxStatusCode === '01'|| vm.userTaxStatusCode === '02'){
          vm.bankAccountDetailsForm.accountType ="SB";
        }
        if(vm.userTaxStatusCode === '21'){
          vm.bankAccountDetailsForm.accountType ="NRE";
        }
        if(vm.userTaxStatusCode === '24'){
          vm.bankAccountDetailsForm.accountType ="NRO";
        }
        if(vm.userTaxStatusCode === '02') {
          vm.bankAccountDetailsForm.pennyDropValid = false;
          vm.showcheckLeaf = true;
        }
        vm.bankAccountDetailsForm.bankDetails.payoutMechanism = "DC";
        if($rootScope.folioBasicDetail.folioForUser == "Minor"  || vm.userTaxStatusCode == 21 || vm.userTaxStatusCode == 24){
          vm.showcheckLeaf = true;
        }else{
          vm.showcheckLeaf = false;
        }
      },
      errorModal = function () {

      };
      if(vm.distributorDetails && vm.distributorDetails.transactionType == 'Purchase_Scheduler'){
        ModalService.IFSCSelectionModalNewJourney({ bankList: vm.bankList }, successModal, errorModal);
        return;
      }
      if(vm.transactionDetails){
          if((vm.transactionDetails.paymentOption == 'HEM' || vm.transactionDetails.paymentOption == 'UAP') && vm.transactionDetails.investmentType == 'SIP'){
            if(vm.bankName){
              if(vm.bankName == "SBI"){
                vm.bankName = 'State Bank of India';
              }
              if(vm.bankName == 'HSBC'){
                vm.bankName = 'HSBC Ltd';
              }
              if(vm.bankName == 'CITY UNION BANK'){
                vm.bankName = 'City Union Bank Limited';
              }
              if(vm.bankName == 'ICICI BANK'){
                vm.bankName = 'ICICI Bank Ltd';
              }
              if(vm.bankName == 'IDBI BANK'){
                vm.bankName = 'IDBI Bank Ltd';
              }
              if(vm.bankName == 'STANDARD CHARTERED BANK'){
                vm.bankName = 'Standard Chartered Bank Ltd';
              }
              if(vm.bankName == 'KOTAK MAHINDRA BANK'){
                vm.bankName = 'Kotak Mahindra Bank Ltd';
              }
              if(vm.bankName == 'KARNATAKA BANK'){
                vm.bankName = 'KARNATAKA BANK LIMITED';
              }
              ModalService.IFSCSelectionModalNewJourney({ bankList: vm.bankList,bankName:vm.bankName.toUpperCase() , paymentMode : vm.transactionDetails.paymentOption }, successModal, errorModal);
              }
          }else{
            ModalService.IFSCSelectionModalNewJourney({ bankList: vm.bankList,}, successModal, errorModal);
          }
      }
    }

    vm.getNewUserDetails = function(){
      var success = function (resp) {
        if(resp.status && resp.data){
          localStorage.setItem("folioId", resp.data.folioCreationDraftId);
        }else{
          MessageService.error(resp.message);
        }
      },
      error = function (error) {
        MessageService.error(error.message);
      };
      try{
        var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
        var taxIdentifierNumber = UserData.panNumber;
      }catch(e){}
      var payload = {
        "panNumber": taxIdentifierNumber
      }
      InvestorService.post({child1: 'new',child2: 'user',child3: 'getDetails'},payload).$promise.then(success, error);
    }
    vm.getNewUserDetails();


    vm.submitBankAccountDetails = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (resp.data.valid === false) {
            MessageService.error(resp.data.message || "We are unable to validate your bank account using IMPS service. Please upload cheque leaf to continue with add bank");
            vm.bankAccountDetailsForm.pennyDropValid = false;
            vm.showcheckLeaf = true;
            vm.showValidateBtn = false;
          } else {
            vm.bankAccountDetailsForm.pennyDropValid = true;
            vm.showcheckLeaf = false;
            vm.bankAccountDetailsForm.accountHolderName = resp.data.name;
            vm.continueFolio();
          }
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      },
        error = function () {
          LoaderService.hideLoader();
        };
        var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
        var investorFullName = UserData.panHolderName;
        var pennyDropValidatePayload = {
          "beneficiaryIFSC": vm.bankAccountDetailsForm.ifscCode,
          "benificiaryAccountNo": vm.bankAccountDetailsForm.accountNumber,
          "benificiaryName": investorFullName
        };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'account',
        child2: 'validate',
        child3: 'pennyDrop'
      }, pennyDropValidatePayload).$promise.then(success, error);
    }


    vm.continueFolio = function() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            // vm.createNewFolio();
            $state.go('newInvestor.summarypage');
          } else {
            if(resp.popupEnabled){
              ModalService.genericModal({
                text: resp.message
                  });
              } else{
                MessageService.error(resp.message);
              }

          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('Occupation Errror>>>>', err);
        };

        vm.bankDetailsData ={
          accountHolderName: vm.bankAccountDetailsForm.accountHolderName ? vm.bankAccountDetailsForm.accountHolderName: vm.investorFullName,
          pennyDropValid : vm.bankAccountDetailsForm.pennyDropValid,
          bankHolderType : $rootScope.folioBasicDetail.folioForUser == 'Self' ? 'INVESTOR' : 'MINOR',
          accountType : vm.bankAccountDetailsForm.accountType,
          payoutMechanism : vm.bankAccountDetailsForm.bankDetails.payoutMechanism,
          accountNumber : vm.bankAccountDetailsForm.accountNumber,
          verifyAccountNumber : vm.bankAccountDetailsForm.accountNumberverify,
          ifsccode : vm.bankAccountDetailsForm.ifscCode,
          bankName : vm.bankAccountDetailsForm.bankName,
          bankCity : vm.bankAccountDetailsForm.bankCity,
          chequeLeaf : vm.bankchequeLeafUrl,
        }
        vm.bankDetailsData.bankBranch = vm.bankAccountDetailsForm.branchLocation;
        $window.smartech('dispatch', 'bank details', {});
        vm.payLoad.newUserFlow = true;
        vm.payLoad.folioSaveStep = "FIVE";
        vm.payLoad.bankDetails = vm.bankDetailsData;
        vm.payLoad.newFolioComplete = true;
        vm.payLoad.firstFolio = true;
        vm.payLoad.nriFlag = vm.UserData ? !vm.UserData.taxStatusResident : null;
        vm.payLoad.soleApplicantDetail.selfDetail.politicalStatus = $rootScope.folioBasicDetail.politicalStatus;
        vm.payLoad.minor = $rootScope.folioBasicDetail.folioForUser == 'Self' ? false : true,
        vm.payLoad.id = localStorage.getItem("folioId");
        if(vm.distributorDetails){
          if(vm.distributorDetails.user == 'EXISTING'){
            vm.payLoad.newUserFlag = false;
          }else{
            vm.payLoad.newUserFlag = true;
          }
          if(vm.distributorDetails.arn){
            vm.payLoad.arnCode = 'ARN-'+vm.distributorDetails.arn;
          }
          if(vm.distributorDetails.riaCode){
            vm.payLoad.arnCode = vm.distributorDetails.riaCode;
          }
          if(vm.distributorDetails.empCode){
            if(vm.distributorDetails.arn){
              vm.payLoad.arnCode = 'ARN-'+vm.distributorDetails.arn;
            }else{
              vm.payLoad.arnCode = 'ARN-DIRECT';
            }
          }
          vm.payLoad.oneClick = true;
          if(vm.distributorDetails.transactionType === 'Purchase_Scheduler'){
            vm.payLoad.scheduledTransaction = true;
          }
        }
        var myData = vm.payLoad;
        if(myData.holdmode == 'SINGLE'){
          if(myData.jointHolders.length == 0){
             NewInvestorServiceV3.post({
            child1: 'folio',
            child2: 'initiate'
        }, myData).$promise.then(success, error);
          }
          else{
            MessageService.error("Mode of holding cannot be Single for multiple holder's");
          }
        }else{
          if(myData.holdmode == 'ANY_OR_SURVIVOR'){
            if(myData.jointHolders.length != 0){
            NewInvestorServiceV3.post({
            child1: 'folio',
            child2: 'initiate'
        }, myData).$promise.then(success, error);
            }else{
              MessageService.error("Mode of holding cannot be Single for multiple holder's");
            }
          }

        }
    }

      vm.createNewFolio = function(){
      var success = function (resp) {
        if(resp.status && resp.data){
          localStorage.setItem("folioDataCreate", resp.data);
          // console.log(resp.data);
          $state.go('newInvestor.NewInvestorPayment');
        }else{
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        MessageService.error(err);
      };

      NewInvestorServiceV3.post({
        child1: 'folio',
        child2: 'createNew1'
      }, {id:localStorage.getItem("folioId")}
        ).$promise.then(success, error);
     }

    vm.submitWithCheckLeaf = function(){
      // console.log("called checkleaf");
      var success = function (resp) {
        if (resp.status && resp.data) {
          // vm.createNewFolio();
          $state.go('newInvestor.summarypage');
          // $state.go('newInvestor.NewInvestorPayment');
        } else {
          if(resp.popupEnabled){
            ModalService.genericModal({
              text: resp.message
            });
            } else{
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        $log.info('Occupation Errror>>>>', err);
      };
      try{
        var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
        vm.investorFullName = UserData.panHolderName;
      }catch(e){}
      vm.bankDetailsData ={
        accountHolderName: vm.investorFullName,
        pennyDropValid : vm.bankAccountDetailsForm.pennyDropValid,
        bankHolderType : $rootScope.folioBasicDetail.folioForUser == 'Self' ? 'INVESTOR' : 'MINOR',
        accountType : vm.bankAccountDetailsForm.accountType,
        payoutMechanism : vm.bankAccountDetailsForm.bankDetails.payoutMechanism,
        accountNumber : vm.bankAccountDetailsForm.accountNumber,
        verifyAccountNumber : vm.bankAccountDetailsForm.accountNumberverify,
        ifsccode : vm.bankAccountDetailsForm.ifscCode,
        bankName : vm.bankAccountDetailsForm.bankName,
        bankCity : vm.bankAccountDetailsForm.bankCity,
        chequeLeaf : vm.bankchequeLeafUrl,
      }
      vm.bankDetailsData.bankBranch = vm.bankAccountDetailsForm.branchLocation;
      vm.payLoad.newUserFlow = true;
      vm.payLoad.folioSaveStep = "FIVE";
      vm.payLoad.bankDetails = vm.bankDetailsData;
      vm.payLoad.newFolioComplete = true;
      vm.payLoad.firstFolio = true;
      vm.payLoad.nriFlag = vm.UserData ? !vm.UserData.taxStatusResident : null;
      if(vm.distributorDetails){
        if(vm.distributorDetails.user == 'EXISTING'){
          vm.payLoad.newUserFlag = false;
        }else{
          vm.payLoad.newUserFlag = true;
        }
        if(vm.distributorDetails.arn){
          vm.payLoad.arnCode = 'ARN-'+vm.distributorDetails.arn;
        }
        if(vm.distributorDetails.riaCode){
          vm.payLoad.arnCode = vm.distributorDetails.riaCode;
        }
        if(vm.distributorDetails.empCode){
          if(vm.distributorDetails.arn){
            vm.payLoad.arnCode = 'ARN-'+vm.distributorDetails.arn;
          }else{
            vm.payLoad.arnCode ='ARN-DIRECT';
          }
        }

        vm.payLoad.oneClick = true;
      }
      // if(vm.payLoad.minor == true){
      //   vm.payLoad.soleApplicantDetail.minorDetail.guardian.politicalStatus = $rootScope.folioBasicDetail.politicalStatus ? vm.payLoad.soleApplicantDetail.minorDetail.guardian.politicalStatus : $rootScope.folioBasicDetail.politicalStatus;
      // }else{
      //   vm.payLoad.soleApplicantDetail.selfDetail.politicalStatus = $rootScope.folioBasicDetail.politicalStatus ? $rootScope.folioBasicDetail.politicalStatus :vm.payLoad.soleApplicantDetail.minorDetail.guardian.politicalStatus;
      // }
      $window.smartech('dispatch', 'bank details', {});
      vm.payLoad.minor = $rootScope.folioBasicDetail.folioForUser == 'Self' ? false : true;
      vm.payLoad.id = localStorage.getItem("folioId");
      if(vm.distributorDetails){
        vm.payLoad.oneClick = true;
        if(vm.distributorDetails.transactionType === 'Purchase_Scheduler'){
          vm.payLoad.scheduledTransaction = true;
        }
      }
      if(vm.payLoad.holdmode == 'SINGLE'){
        if(vm.payLoad.jointHolders.length == 0){
          NewInvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, vm.payLoad).$promise.then(success, error);
        }
        else{
          MessageService.error("Mode of holding cannot be Anyone for Single holder");
        }
      }else{
        if(vm.payLoad.holdmode == 'ANY_OR_SURVIVOR'){
          if(vm.payLoad.jointHolders.length != 0){
            NewInvestorServiceV3.post({child1: 'folio', child2: 'initiate'}, vm.payLoad).$promise.then(success, error);
          }else{
            MessageService.error("Mode of holding cannot be Single for multiple holder's");
          }
        }

      }
    }


    vm.bankUploadChequeLeafFile = function (file) {
      var fi = document.getElementById('chequesleafImage');

      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file) {
        if (fi.files[0].size <= 3145728) {
          var success = function (resp) {
            // LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.bankchequeLeafUrl = resp.data.fileUrl;
              try{
                const fileName = vm.bankchequeLeafUrl.split("/");
                vm.bankAccountDetailsForm.chequesleafImageUrl = fileName[fileName.length - 1];
              }catch(e){}
              vm.fileType = resp.data.type.toLowerCase();
              breakFileUrl(vm.bankchequeLeafUrl);
            }
            else {
              vm.fileType = '';
              MessageService.error(resp.message);
            }
          },
            error = function (err) {
              // LoaderService.hideLoader(err);
            };

          if (file) {
            // LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            InvestorFileUploadServiceV3.post2({
              child1: 'folio',
              child2: 'upload',
              child3: 'bankDetails',
              child4: 'chequeLeaf',
              child5: localStorage.getItem("folioId")
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 3 MB.")
        }
      }

    }

    function breakFileUrl(url) {
      vm.bankChequeLeaf = 'Preview Uploaded Leaf Doc';
      vm.fileType = url && url.split('_').reverse()[0].toLowerCase();
      vm.bankchequeLeafUrl = url;
      return;
    }

    vm.openUploadedDoc = function () {
      if (angular.isUndefined(vm.bankchequeLeafUrl)) { return; }
      ModalService.showImage1({ docUrl: vm.bankchequeLeafUrl });
    };

    function getTransactionDetails(){
      var Details = JSON.parse(sessionStorage.getItem("userData"));
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.transactionDetails = resp.data;
         if(resp.data.paymentOption == 'HEM'){
          vm.bankName = resp.data.bankName;
         }
         if(resp.data.paymentOption == 'UAP'){
          vm.bankName = resp.data.bankName;
         }
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'new',
        child2: 'user',
        child3: 'saved',
        child4: 'draft'
      }, {"id":Details.transactionDraftId}).$promise.then(success, error);
    }
    vm.downloadFile = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+vm.fileType });
            FileSaver.saveAs(data, 'bankchequeLeaf.'+vm.fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.downloadFile(payload, vm.fileType, vm.bankchequeLeafUrl).then(success, error);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('RegisterMandateReviewController', registerMandateReview);

  /** @ngInject */
  function registerMandateReview($scope, $state, $window, LoaderService, InvestorService, UtilService, MessageService, HDFC_API) {
    var vm = this;
    $scope.billdeskUrl=HDFC_API.BILLDESK_URL;
    vm.init = init;
    vm.setHeader = setHeader;
    vm.isCheckedTandC = false;
    vm.submitMandate = submitMandate;
    vm.handleEmandateSipResponse = handleEmandateSipResponse;

    function init() {
      $window.scrollTo(0, 0);
      setHeader();
    }

    vm.showTermConditionsemandate = function () {
      ModalService.transactionalTermConditionModalEMandate({'transactionType': 'SIP-E-MANDATE','subTransactionType':vm.formData.formType});
    };

    function setHeader() {
      var payloadDetails = JSON.parse(sessionStorage.getItem("payloadDetails"));
      vm.folioNo = payloadDetails.folioNo;
      vm.bankName = payloadDetails.bankName;
      vm.accountNumber = payloadDetails.AccountNumber;
      vm.accountType = payloadDetails.AccountType;
      vm.frequency = payloadDetails.Frequency;
      vm.startDate = payloadDetails.StartDate;
      vm.endDate = payloadDetails.EndDate;
      vm.purpose = payloadDetails.Purpose;
      vm.authMode = payloadDetails.AuthMode;
      vm.authModeValue = payloadDetails.AuthModeValue;
      vm.amount = payloadDetails.Amount;
      vm.name = payloadDetails.Name;
      vm.mobile = payloadDetails.Mobile;
      vm.email = payloadDetails.Email;
      vm.ifscCode = payloadDetails.IfscCode;
      vm.bankCode = payloadDetails.BankCode;
      vm.accountTypeValue = payloadDetails.AccountTypeValue;
      vm.bankNameOnly = payloadDetails.BankNameOnly;
    }
    function submitMandate() {

      var payload = {
        accNumber: vm.accountNumber,
        accType: vm.accountTypeValue,
        authenticationMode: vm.authModeValue,
        bankCode: vm.bankCode,
        bankName: vm.bankName,
        email: vm.email,
        folioNumber: vm.folioNo,
        ifscCode: vm.ifscCode,
        maxAmount: vm.amount,
        mobile: vm.mobile,
        name: vm.name,
        omEndDate: vm.endDate,
        omStartDate: vm.startDate,
      };
      if (!payload) {
        MessageService.error('Something went wrong while calculating payload.');
        return;
      }
      LoaderService.hideLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          handleEmandateSipResponse(resp.data);
        }else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        cb(false);
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'emandate',
        child2: 'process'
      }, payload).$promise.then(success, error);
    }

    function handleEmandateSipResponse(data) {
      data = data && data.data ? data.data : data;
      if (!data) {
        MessageService.error();
        return;
      }
      $window.location.href=$scope.billdeskUrl+data.message;
    }

    vm.goToBack = function () {
      $state.go('main.emandate');
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('RegisterMandateController', registerMandate);

  /** @ngInject */
  function registerMandate($scope, $state, $window, LoaderService, InvestorService, UtilService, ModalService, MessageService , dynamicData , AppConstants) {
    var vm = this;
    vm.init = init;
    vm.setHeader = setHeader;
    vm.fetchBankList = fetchBankList;
    vm.changeBank = changeBank;
    vm.getDatesValidation = getDatesValidation;
    vm.updateEndDates = updateEndDates;
    vm.goToSummary = goToSummary;
    vm.checkAmountValidation = checkAmountValidation;
    vm.defaultEndDate = defaultEndDate;
    vm.reset = reset;
    vm.authMode = null;
    vm.viewMode = 'days';
    vm.enabledBillerStartDatesList = [];
    vm.isCheckedFatcaTandC = false;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.isDefaultDateSelected = false;
    vm.showTerms = true;
    vm.defaultMandateYearDate = AppConstants.DEFAULT_EMANDATE_MAX_YEAR;
    if (dynamicData.noteDTO.noteDTOMap.Note_Standalone_Emandate) {
      vm.dynamicDataNote = dynamicData.noteDTO.noteDTOMap.Note_Standalone_Emandate.content;
    }
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.emandateWord = {};

    function init(){
      $window.scrollTo(0, 0);
      setHeader();
      UtilService.fetchMandateValidations().then(function (resp) {
        vm.emandateDetail = resp.eOTM;
        vm.formData.amount = Math.floor(vm.emandateDetail.defaultMandateAmount);
        $window.NumToWord(vm.formData.amount, 'amountInwordsEmandate',vm.emandateWord);
        vm.emandateMaxYear = vm.emandateDetail.maxMandateDurationYears ? vm.emandateDetail.maxMandateDurationYears : vm.defaultMandateYearDate;
        vm.mandateInfo = vm.emandateDetail.mandateInfo;
        vm.minEndDateGapMandate = vm.emandateDetail.minEndDateGap;
        vm.mandateMaxString = vm.emandateDetail.maxAmountLimitInfo;
        fetchBankList();
      }).catch(function(resp) {
        MessageService.error(resp)
      });
    }

    var successHandler = function(resp) {
      if(!resp.termAndConditionDTO.termAndConditionDTOMap.TNC_SIP_Review_Registration_eOTM)
        {
          vm.showTerms = false;
        }
    }

     UtilService.fetchDynamicData("SIP_REVIEW").then(successHandler).catch(function(resp) {
       MessageService.error(resp)
     });

    function setHeader(){
      var payload = JSON.parse(sessionStorage.getItem("details"));
      vm.folioNumber =  payload.folioNo;
      vm.InvestorEmail =  payload.emailid;
      vm.InvestorMobile =  payload.mobileNo;
      vm.InvestorName =  payload.investorName;
    }


    function fetchBankList() {
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.bannedInvestorFlag) {
              ModalService.genericModal({
                text: resp.data.bannedInvestorMsg
              }, function () {
                $state.go('main.profile.folioDetails');
              } , function () {});
            } else {
              vm.bankList = resp.data.bankList;
              vm.emandateDetail.minStartDate = resp.data.minStartDate;
              vm.emandateDetail.maxStartDate = resp.data.maxStartDate;
              getDatesValidation();
              vm.bankList && vm.bankList.find(function(item){
                vm.formData.bankInfo === item;
              })|| {};
              if (vm.bankList.length === 1) {
                vm.formData.bankInfo = vm.bankList[0];
                vm.formData.authModeSelect = vm.formData.bankInfo.authenticationModes[0];
                vm.authMode = vm.formData.authModeSelect;
              }
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
        };
      var payload = {
        folioNumber : vm.folioNumber
      }
      LoaderService.showLoader();
        InvestorService.post({
          child1: 'folio',
          child2: 'emandate'
        }, payload).$promise.then(success, error);
    }


    vm.showTermConditionsemandate = function () {
      ModalService.transactionalTermConditionModalEMandate({'transactionType': 'SIP-E-MANDATE','subTransactionType':vm.formData.formType});
    };
    function changeBank() {
      if (!vm.formData.bankInfo) {
        return;
      }
      var selectedBank = vm.formData.bankInfo;
      vm.formData.authModeSelect = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes[0] : null;
      vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
      vm.authMode = selectedBank.authenticationModes && selectedBank.authenticationModes ? selectedBank.authenticationModes[0] : null;
    }

    function getDatesValidation() {
      var enabledDates = [];
      if(vm.emandateDetail) {
        vm.startMinDateBiller = $window.moment(vm.emandateDetail.minStartDate, "DD-MMM-YYYY");
        vm.startMaxDate = $window.moment(vm.emandateDetail.maxStartDate, "DD-MMM-YYYY");
      }
      var freq = vm.startMaxDate.diff(vm.startMinDateBiller, 'days');
      for (var i = 0; i <= freq; i++) {
        enabledDates.push(vm.startMinDateBiller.clone().add(i, 'days'));
      }
      vm.enabledBillerStartDatesList = enabledDates;
      vm.viewDate = enabledDates[0].clone();
    }

    vm.enabledBillerEndDatesList = [];
    function updateEndDates (){
      var enabledEndDates = [];
      vm.formData.endDate = '';
      if(vm.formData.startDateWithoutFormat)
      {
        vm.minEndDate = vm.formData.startDateWithoutFormat.add(vm.minEndDateGapMandate, 'year');
        vm.maxEndDate = $window.moment(vm.formData.startDate, "DD-MMM-YYYY").add(vm.emandateDetail.maxMandateDurationYears, 'years').subtract(1,'days');
      }

      var freq = vm.maxEndDate.diff(vm.minEndDate, 'days');
      for (var i = 0; i <= freq; i++) {
        enabledEndDates.push(vm.minEndDate.clone().add(i, 'days'));
      }
      vm.enabledBillerEndDatesList = enabledEndDates;
      vm.endDateView = enabledEndDates[0].clone();
      vm.formData.endDate =  $window.moment(vm.enabledBillerEndDatesList[vm.enabledBillerEndDatesList.length - 1], 'DD-MMM-YYYY');
      vm.changeEndDate(vm.formData.endDate);
    }

    vm.changeStartDate = function (date) {
      vm.formData.startDateWithoutFormat = date ? date : null;
      vm.formData.startDate = vm.formData.startDateWithoutFormat && vm.formData.startDateWithoutFormat.format('DD-MMM-YYYY');
      updateEndDates();
    };

    vm.changeEndDate = function (date) {
      vm.formData.endDateWithoutFormat = date ? date : null;
      vm.formData.endDate = vm.formData.endDateWithoutFormat && vm.formData.endDateWithoutFormat.format('DD-MMM-YYYY');
      if (vm.maxEndDate.diff(date, 'days') != 0 ) {
        vm.isDefaultDateSelected = false;
      }
    };

    function defaultEndDate() {
      vm.formData.endDateWithoutFormat = vm.maxEndDate ? vm.maxEndDate : null;
      if(vm.formData.endDate === vm.formData.endDateWithoutFormat.format('DD-MMM-YYYY'))
      {
        vm.formData.endDate = null;
      }
      else {
        vm.formData.endDate = vm.formData.endDateWithoutFormat.format('DD-MMM-YYYY');
      }
    }

    function goToSummary() {
      var payloadDetails = {
        folioNo: vm.folioNumber,
        bankName: vm.formData.bankInfo.bankName,
        AccountNumber: vm.formData.bankInfo.accountNumber,
        AccountType: vm.formData.bankInfo.accTypeDesc,
        AccountTypeValue: vm.formData.bankInfo.bankAcType,
        Frequency: vm.emandateDetail.frequency,
        StartDate: vm.formData.startDate,
        EndDate: vm.formData.endDate,
        Purpose: vm.emandateDetail.purpose,
        AuthMode: vm.authMode.text,
        AuthModeValue: vm.authMode.value,
        Amount: vm.formData.amount,
        Name: vm.InvestorName,
        Mobile: vm.InvestorMobile,
        Email: vm.InvestorEmail,
        IfscCode: vm.formData.bankInfo.ifscCode,
        BankCode: vm.formData.bankInfo.bankCode,
        BankNameOnly: vm.formData.bankInfo.bankNameOnly,
      };
      sessionStorage.setItem("payloadDetails", JSON.stringify(payloadDetails));
      $state.go('main.emandatereview')
    }

    function checkAmountValidation() {
      if(vm.formData.amount < vm.emandateDetail.minAmountLimit){
        vm.amountLess = true;
      }
      else{
        vm.amountLess = false;
      }
      if(vm.formData.amount > vm.emandateDetail.maxAmountLimit){
        vm.amountMore = true;
      }
      else{
        vm.amountMore = false;
      }

      $window.NumToWord(vm.formData.amount, 'amountInwordsEmandate',vm.emandateWord);

    }

    function reset() {
      vm.formData.bankInfo = '';
      vm.formData.amount = '';
      vm.formData.startDate = '';
      vm.formData.endDate = '';
      vm.isCheckedFatcaTandC = false;
      vm.isDefaultDateSelected = false;
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('OptoutNomineeController', optoutNomineeController);

  /** @ngInject */
  function optoutNomineeController(InvestorService, $state, $stateParams, $window, AppConstants, $log, LoaderService,
                                   MessageService, ModalService, dynamicData) {
    var vm = this;
    vm.formData = {};
    vm.folioNo = null;
    vm.TnC = false;
    vm.goToBack = goToBack;
    vm.goToContinueOptOutNomination = goToContinueOptOutNomination;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.mobileBelongsTo = null;
    vm.emailBelongsTo = null;
    vm.dynamicNote = dynamicData.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT;
    vm.init = init();

    function init() {
      vm.folioNo = $stateParams.folioNo;
      getEmailMobile();
      fetchBelongsToDropdown();
    }

    function goToBack() {
      $state.go('main.profile.folioDetails');
    }

    function goToContinueOptOutNomination() {
      LoaderService.showLoader();
      var success = function(resp){
        LoaderService.hideLoader();
        if(resp.status && resp.data){
          var successOfOTP = function(response){
            // MessageService.success(response);
            // $state.go('main.profile.folioDetails');
            ModalService.updateNomineeModal({
              message: response
            }, function() {
              $state.go('main.profile.folioDetails');
            },function() { });
          }, errorOfOTP = function(){};
          ModalService.NomineeUpdateOtpModal({
            uniqueLink: resp.data.secretLink,
            folioNumber : vm.folioNo ,
            message : resp.data.message,
            summaryType : 'fromOptOutOfNomination'
          }, successOfOTP, errorOfOTP)
        }
      }, error = function(resp){
        MessageService.error(resp.message);
        LoaderService.hideLoader();
      };
      var payload = {
        folioNo : vm.folioNo,
        inv_Email: vm.investorEmail,
        inv_Mobile: vm.investorMobile,
        email_belongs_to: vm.emailBelongsTo,
        mobile_belongs_to: vm.mobileBelongsTo
      };
      InvestorService.post({
        child1 : 'profile',
        child2 : 'opt-out',
        child3 : 'nominee'
      }, payload).$promise.then(success, error);
    }

    function getEmailMobile(){
      LoaderService.showLoader();
      var success = function(resp){
        LoaderService.hideLoader();
        if(resp.status && resp.data){
          vm.investorEmail = resp.data.inv_Email;
          vm.investorMobile = resp.data.inv_Mobile;
        }else{
          vm.investorEmail = null;
          vm.investorMobile = null;
          MessageService.error(resp.message);
        }
      }
        ,error = function(err){
        LoaderService.hideLoader();
        MessageService.error(err.message);
      };
      InvestorService.get({
        child1 : 'getDetails',
        child2 : 'userDeclartion',
        child3 : vm.folioNo
      },null).$promise.then(success,error);
    }

    function fetchBelongsToDropdown(){
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.belongToListEmail = resp.data.emailList;
            vm.belongToListMobile = resp.data.mobileList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          // $log.info('Belongs Dropdown error >>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UpdateNomineeController', updateNomineeController);

  /** @ngInject */
  function updateNomineeController(InvestorService, $state, $stateParams, $window, AppConstants, $log, LoaderService,
                                   MessageService, ModalService,$timeout, UtilService, InvestorServiceV2) {
    var vm = this;
    vm.currentNomineeIndx = 0;
    vm.formData = {};
    vm.maxNominee = 3;
    vm.activeTab = 0;
    vm.totalPercentage = 0;
    vm.dobRequired = false;
    vm.showAddNominee = true;
    vm.nomineeValidateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.folioNo = null;
    vm.calculatePercentage = calculatePercentage;
    vm.deleteNominee = deleteNominee;
    vm.addNominee = addNominee;
    vm.checkValidation = checkValidation;
    vm.setActiveTab = setActiveTab;
    vm.nomineeChangeDob = nomineeChangeDob;
    vm.getCountryList = getCountryList;
    vm.getStateList = getStateList;
    vm.getRelationshipList = getRelationshipList;
    vm.goToBack = goToBack;
    vm.TnC = false;
    vm.nomineePanChanged = nomineePanChanged;
    vm.minorPanChanged = minorPanChanged;
    vm.nomineePanValid = true;
    vm.minorPanValid = true;
    vm.isGuardian = true;
    vm.isPrefillNomineeDataExist = false;
    vm.nomineeEnum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      3: 'Fourth',
      4: 'Fifth',
      5: 'Sixth',
      6: 'Seventh',
      7: 'Eighth',
      8: 'Ninth',
      9: 'Tenth'
    };
    vm.fetchBelongsToDropdown = fetchBelongsToDropdown;
    vm.emailPattern = AppConstants.email_regex;
    vm.mobilePattern = AppConstants.mobile_regex_with_country;
    vm.showNomineeUpdate = false;
    vm.changePersonalIdentifier = changePersonalIdentifier;
    vm.incapcitationNominee = null;
    vm.nomineeEmailChanged = nomineeEmailChanged;
    vm.nomineeMobileChanged = nomineeMobileChanged;
    vm.nomineeLicenseChanged = nomineeLicenseChanged;
    vm.nomineeAadhaarChanged = nomineeAadhaarChanged;
    vm.passportChanged = passportChanged;
    vm.selectedNominee = selectedNominee;
    vm.setStatement = setStatement;
    vm.errorMessageEmail = AppConstants.ToastrMessage.VALIDATE_DATA.EMAILID_SAME_INVESTOR;
    vm.errorMessageMobile = AppConstants.ToastrMessage.VALIDATE_DATA.MOBILE_SAME_INVESTOR;
    vm.errorMessageNomineeLicense = AppConstants.ToastrMessage.VALIDATE_DATA.DRIVING_LICENSE_ALREADY_EXIST;
    vm.errorMessageNomineeAadhaar = AppConstants.ToastrMessage.VALIDATE_DATA.AADHAAR_ALREADY_EXIST;
    vm.errorMessagePassportNumber = AppConstants.ToastrMessage.VALIDATE_DATA.PASSPORT_ALREADY_EXIST;
    vm.nomineeLicenseValid = true;
    vm.nomineeAadhaarValid = true;
    vm.nomineePassportValid = true;
    vm.emailIdValid = true;
    vm.nameFilter = nameFilter;
    vm.incapcitationList = [];
    vm.setincapcitationList = setincapcitationList;

    vm.init = init();

    function init() {
      LoaderService.showLoader();
      vm.folioNo = $stateParams.folioNo;
      vm.folioData = JSON.parse($window.sessionStorage.getItem('folioData'));
      vm.showNomineeUpdate = vm.folioData.folioDetailsData.sebiNomineeRegulatory01650Active ? vm.folioData.folioDetailsData.sebiNomineeRegulatory01650Active : false;
      vm.maxNominee = vm.folioData.folioDetailsData.nomineeLimit ? vm.folioData.folioDetailsData.nomineeLimit : 3;
      vm.isPrefillNomineeDataExist = vm.folioData.isNomineeData;
      if (!vm.folioData.folioDetailsData.accountHoldingDeclaration) {
        vm.folioData.folioDetailsData.accountHoldingDeclaration = 'NOMINATION_YES';
        vm.nomination = true;
      } else if (vm.folioData.folioDetailsData.accountHoldingDeclaration) {
        if (vm.folioData.folioDetailsData.accountHoldingDeclaration === 'NOMINATION_YES') {
          vm.nomination = true;
        }
        if (vm.folioData.folioDetailsData.accountHoldingDeclaration === 'NOMINATION_NO') {
          vm.nomination = false;
        }
      }
      if (vm.folioData.folioDetailsData.hasOwnProperty("nominees")) {
        calculatePercentage();
        setincapcitationList();

        if (vm.folioData.folioDetailsData.incapacitationDeclaration) {
          vm.incapcitationNomineeIndex = angular.copy(vm.folioData.folioDetailsData.incapacitationDeclaration.nomineeNumber - 1);
          // selectedNominee();
        } else {
          vm.folioData.folioDetailsData.incapacitationDeclaration = {};
        }

      } else {
        var nomineesArray = [];
        var nomineeObject = {
          "firstName": "",
          "relation": "",
          "percentage": "",
          "dateOfBirth": "",
          "panNumber" : null,
          "guardianPanNumber" : null,
          "nomineeAddress1": "",
          "nomineeAddress2": "",
          "pinCode": "",
          "city": "",
          "state": "",
          "stateCode": "",
          "country": "",
          "guardianName": null,
          "guardianRelationWithNominee" : null
        };
        nomineesArray.push(nomineeObject);
        vm.folioData.folioDetailsData.nominees = nomineesArray;
        vm.folioData.folioDetailsData.accountHoldingDeclaration = null;
        vm.folioData.folioDetailsData.accountHoldingDeclaration = "NOMINATION_YES";
        vm.nomineeName = true;
      }
      LoaderService.hideLoader();
      getEmailMobile();
      getCountryList();
      getStateList();
      getRelationshipList();
      checkDobOnInit();
      fetchBelongsToDropdown();
      getPersonalIdentifier();
    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.countryList = null;
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}).$promise.then(success, error);
    }

    function getStateList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.stateList = resp.data.states;
        } else {
          vm.stateList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.stateList = null;
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'state',
        child3: 'list'
      }).$promise.then(success, error);
    }

    function calculatePercentage() {
      var totalPercentage = 0;
      var isProportionmsg = false;
      var nominees = vm.folioData.folioDetailsData.nominees;
      for (var i = 0 ; i < nominees.length ; i ++) {
        totalPercentage += parseInt(nominees[i].percentage);
        if (nominees[i].percentage == 0){
          vm.proportion_msg = vm.nomineeValidateData.PROPORTION_NOT_ZERO;
          isProportionmsg = true;
        }
      }
      if(!isProportionmsg){
        vm.proportion_msg = '';
      }

      vm.totalPercentage = totalPercentage;
      if (vm.totalPercentage < 100 && vm.folioData.folioDetailsData.nominees.length < vm.maxNominee) {
        vm.showAddNominee = true;
      } else {
        vm.showAddNominee = false;
      }
      if (totalPercentage != 100) {
        vm.percentage_msg = vm.nomineeValidateData.PROPORTION_PERCENTAGE;
        return false;
      } else {
        vm.percentage_msg = '';
        return true;
      }
    }


    function deleteNominee(index) {
      if(index == 0 && vm.isPrefillNomineeDataExist && vm.folioData.folioDetailsData.nominees.length == 1){
        var success = function () {
          $state.go('main.optoutNominee', {folioNo : vm.folioNo});
        }, error = function () {}
        ModalService.optOutNomineeModal({
          text : "You are trying to delete last nominee, in-order to proceed with the deletion you will have to Opt-out of Nomination. You can add a nominee later whenever required.",
          ctaText : "Opt-out of Nomination Declaration"
        }, success, error)
      } else {

        if (vm.folioData.folioDetailsData.nominees[index].hasOwnProperty('aadharCard') && vm.folioData.folioDetailsData.nominees[index].aadharCard) {
          // if (vm.folioData.folioDetailsData.nominees[index].sameIndex && vm.folioData.folioDetailsData.nominees[index].sameIndex.length === 1) {
          //
          //   vm.folioData.folioDetailsData.nominees[vm.folioData.folioDetailsData.nominees[index].sameIndex[0]].sameIndex = [];
          //   vm.folioData.folioDetailsData.nominees[vm.folioData.folioDetailsData.nominees[index].sameIndex[0]].nomineeAadhaarInvalid = false;
          //   vm.folioData.folioDetailsData.nominees[index].sameIndex = [];
          //   vm.folioData.folioDetailsData.nominees[index].nomineeAadhaarInvalid = false;
          //
          //   vm.folioData.folioDetailsData.nominees.forEach(function (el) {
          //
          //     if (el.sameIndex && el.sameIndex.length > 0) {
          //       el.sameIndex.forEach(function (val,indexE) {
          //         if (el.sameIndex[indexE] > index) {
          //           el.sameIndex[indexE] = el.sameIndex[indexE] === 0 ? 0 : el.sameIndex[indexE] - 1;
          //         }
          //       })
          //     }
          //   })
          //
          //
          //   for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
          //     if (vm.folioData.folioDetailsData.nominees[i].sameIndex && vm.folioData.folioDetailsData.nominees[i].sameIndex.length === 0) {
          //       vm.nomineeAadhaarValid = true;
          //     } else if (vm.folioData.folioDetailsData.nominees[i].sameIndex && vm.folioData.folioDetailsData.nominees[i].sameIndex.length !== 0)  {
          //       vm.nomineeAadhaarValid = false;
          //       break;
          //     }
          //   }
          //
          // } else if(vm.folioData.folioDetailsData.nominees[index].sameIndex && vm.folioData.folioDetailsData.nominees[index].sameIndex.length > 1) {
          //
          //   vm.folioData.folioDetailsData.nominees[index].sameIndex.forEach(function (el) {
          //
          //     if (vm.folioData.folioDetailsData.nominees[el].sameIndex && vm.folioData.folioDetailsData.nominees[el].sameIndex.length === 1) {
          //       vm.folioData.folioDetailsData.nominees[el].sameIndex = [];
          //       vm.folioData.folioDetailsData.nominees[el].nomineeAadhaarInvalid = false;
          //     } else {
          //       var indexEL = vm.folioData.folioDetailsData.nominees[el].sameIndex.indexOf(index);
          //       vm.folioData.folioDetailsData.nominees[el].sameIndex.splice(indexEL,1);
          //
          //
          //       // updating index of aadhar same elements
          //       vm.folioData.folioDetailsData.nominees[el].sameIndex.forEach(function (val,indexE) {
          //         if (vm.folioData.folioDetailsData.nominees[el].sameIndex[indexE] > index) {
          //           vm.folioData.folioDetailsData.nominees[el].sameIndex[indexE] = vm.folioData.folioDetailsData.nominees[el].sameIndex[indexE] === 0 ? 0 : vm.folioData.folioDetailsData.nominees[el].sameIndex[indexE] - 1;
          //         }
          //       })
          //
          //     }
          //
          //   })
          //
          // }



          // updating liscense index value when value with aadhar is deleted

          for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {

            if (vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('drivingLicense')) {
              vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense.forEach(function (el, indexE) {
                if (vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense[indexE] > index) {
                  vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense[indexE] = vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense[indexE] === 0 ? 0 : vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense[indexE] - 1;
                }
              })
            }

            if (vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('passport')) {
              vm.folioData.folioDetailsData.nominees[i].sameIndexPassport.forEach(function (el, indexE) {
                if (vm.folioData.folioDetailsData.nominees[i].sameIndexPassport[indexE] > index) {
                  vm.folioData.folioDetailsData.nominees[i].sameIndexPassport[indexE] = vm.folioData.folioDetailsData.nominees[i].sameIndexPassport[indexE] === 0 ? 0 : vm.folioData.folioDetailsData.nominees[i].sameIndexPassport[indexE] - 1;
                }
              });
            }
          }


        }

        if (vm.folioData.folioDetailsData.nominees[index].hasOwnProperty('drivingLicense') && vm.folioData.folioDetailsData.nominees[index].drivingLicense) {
          if (vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense && vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense.length === 1) {

            vm.folioData.folioDetailsData.nominees[vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense[0]].sameIndexLiscense = [];
            vm.folioData.folioDetailsData.nominees[vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense[0]].nomineeLicenseInvalid = false;
            vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense = [];
            vm.folioData.folioDetailsData.nominees[index].nomineeLicenseInvalid = false;


            vm.folioData.folioDetailsData.nominees.forEach(function (el) {

              if (el.sameIndexLiscense && el.sameIndexLiscense.length > 0) {
                el.sameIndexLiscense.forEach(function (val,indexE) {
                  if (el.sameIndexLiscense[indexE] > index) {
                    el.sameIndexLiscense[indexE] = el.sameIndexLiscense[indexE] === 0 ? 0 : el.sameIndexLiscense[indexE] - 1;
                  }
                })
              }

            })


            for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
              if (vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense && vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense.length === 0) {
                vm.nomineeLicenseValid = true;
              } else if (vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense && vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense.length !== 0)  {
                vm.nomineeLicenseValid = false;
                break;
              }
            }


          } else if(vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense && vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense.length > 1) {

            vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense.forEach(function (el) {

              if (vm.folioData.folioDetailsData.nominees[el].sameIndexLiscense && vm.folioData.folioDetailsData.nominees[el].sameIndexLiscense.length === 1) {
                vm.folioData.folioDetailsData.nominees[el].sameIndexLiscense = [];
                vm.folioData.folioDetailsData.nominees[el].nomineeLicenseInvalid = false;
              } else {
                var indexEL = vm.folioData.folioDetailsData.nominees[el].sameIndexLiscense.indexOf(index);
                vm.folioData.folioDetailsData.nominees[el].sameIndexLiscense.splice(indexEL,1);

                vm.folioData.folioDetailsData.nominees[el].sameIndexLiscense.forEach(function (val,indexE) {
                  if (vm.folioData.folioDetailsData.nominees[el].sameIndexLiscense[indexE] > index) {
                    vm.folioData.folioDetailsData.nominees[el].sameIndexLiscense[indexE] = vm.folioData.folioDetailsData.nominees[el].sameIndexLiscense[indexE] === 0 ? 0 : vm.folioData.folioDetailsData.nominees[el].sameIndexLiscense[indexE] - 1;
                  }
                })

              }

            })

          }


          // updating aadhar index value when value with liscense is deleted

          for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {

            /*if (vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('aadharCard')) {
              vm.folioData.folioDetailsData.nominees[i].sameIndex.forEach(function (el, indexE) {
                if (vm.folioData.folioDetailsData.nominees[i].sameIndex[indexE] > index) {
                  vm.folioData.folioDetailsData.nominees[i].sameIndex[indexE] = vm.folioData.folioDetailsData.nominees[i].sameIndex[indexE] === 0 ? 0 : vm.folioData.folioDetailsData.nominees[i].sameIndex[indexE] - 1;
                }
              })
            }*/
            if (vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('passport')) {
              vm.folioData.folioDetailsData.nominees[i].sameIndexPassport.forEach(function (el, indexE) {
                if (vm.folioData.folioDetailsData.nominees[i].sameIndexPassport[indexE] > index) {
                  vm.folioData.folioDetailsData.nominees[i].sameIndexPassport[indexE] = vm.folioData.folioDetailsData.nominees[i].sameIndexPassport[indexE] === 0 ? 0 : vm.folioData.folioDetailsData.nominees[i].sameIndexPassport[indexE] - 1;
                }
              });
            }
          }
        }

        if (vm.folioData.folioDetailsData.nominees[index].hasOwnProperty('passport') && vm.folioData.folioDetailsData.nominees[index].passport) {
          if (vm.folioData.folioDetailsData.nominees[index].sameIndexPassport && vm.folioData.folioDetailsData.nominees[index].sameIndexPassport.length === 1) {

            vm.folioData.folioDetailsData.nominees[vm.folioData.folioDetailsData.nominees[index].sameIndexPassport[0]].sameIndexPassport = [];
            vm.folioData.folioDetailsData.nominees[vm.folioData.folioDetailsData.nominees[index].sameIndexPassport[0]].nomineePassportInvalid = false;
            vm.folioData.folioDetailsData.nominees[index].sameIndexPassport = [];
            vm.folioData.folioDetailsData.nominees[index].nomineePassportInvalid = false;


            vm.folioData.folioDetailsData.nominees.forEach(function (el) {

              if (el.sameIndexPassport && el.sameIndexPassport.length > 0) {
                el.sameIndexPassport.forEach(function (val,indexE) {
                  if (el.sameIndexPassport[indexE] > index) {
                    el.sameIndexPassport[indexE] = el.sameIndexPassport[indexE] === 0 ? 0 : el.sameIndexPassport[indexE] - 1;
                  }
                });
              }

            })


            for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
              if (vm.folioData.folioDetailsData.nominees[i].sameIndexPassport && vm.folioData.folioDetailsData.nominees[i].sameIndexPassport.length === 0) {
                vm.nomineePassportValid = true;
              } else if (vm.folioData.folioDetailsData.nominees[i].sameIndexPassport && vm.folioData.folioDetailsData.nominees[i].sameIndexPassport.length !== 0)  {
                vm.nomineePassportValid = false;
                break;
              }
            }


          } else if(vm.folioData.folioDetailsData.nominees[index].sameIndexPassport && vm.folioData.folioDetailsData.nominees[index].sameIndexPassport.length > 1) {

            vm.folioData.folioDetailsData.nominees[index].sameIndexPassport.forEach(function (el) {

              if (vm.folioData.folioDetailsData.nominees[el].sameIndexPassport && vm.folioData.folioDetailsData.nominees[el].sameIndexPassport.length === 1) {
                vm.folioData.folioDetailsData.nominees[el].sameIndexPassport = [];
                vm.folioData.folioDetailsData.nominees[el].nomineePassportInvalid = false;
              } else {
                var indexEL = vm.folioData.folioDetailsData.nominees[el].sameIndexPassport.indexOf(index);
                vm.folioData.folioDetailsData.nominees[el].sameIndexPassport.splice(indexEL,1);

                vm.folioData.folioDetailsData.nominees[el].sameIndexPassport.forEach(function (val,indexE) {
                  if (vm.folioData.folioDetailsData.nominees[el].sameIndexPassport[indexE] > index) {
                    vm.folioData.folioDetailsData.nominees[el].sameIndexPassport[indexE] = vm.folioData.folioDetailsData.nominees[el].sameIndexPassport[indexE] === 0 ? 0 : vm.folioData.folioDetailsData.nominees[el].sameIndexPassport[indexE] - 1;
                  }
                });

              }

            });

          }

          for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {

            if (vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('drivingLicense')) {
              vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense.forEach(function (el, indexE) {
                if (vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense[indexE] > index) {
                  vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense[indexE] = vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense[indexE] === 0 ? 0 : vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense[indexE] - 1;
                }
              });
            }
          }
        }

        vm.folioData.folioDetailsData.nominees.splice(index, 1);
      }
      vm.isNomineeDetailsEmpty = false;
      vm.activeTab = 0;
      vm.calculatePercentage();
      var indexToCheck = 0;
      vm.nomineePanChanged(indexToCheck,vm.folioData.folioDetailsData.nominees[indexToCheck].panNumber);

      if(vm.folioData.folioDetailsData.nominees.length == 1) {
        if(vm.folioData.folioDetailsData.nominees[0].guardianPanNumber) {
          minorPanChanged(index,vm.folioData.folioDetailsData.nominees[0].guardianPanNumber , true)
        } else {
          vm.minorPanValid = true;
        }
      } else {
        if(vm.folioData.folioDetailsData.nominees[0].guardianPanNumber) {
          minorPanChanged(0,vm.folioData.folioDetailsData.nominees[0].guardianPanNumber , true)
        } else if(vm.folioData.folioDetailsData.nominees[1].guardianPanNumber) {
          minorPanChanged(1,vm.folioData.folioDetailsData.nominees[1].guardianPanNumber , true)
        } else {
          vm.minorPanValid = true;
        }
      }

      setincapcitationList();

    }

    function addNominee() {
      var msg = checkValidation();
      if (msg) {
        MessageService.error(msg);
        return;
      }
      if (!vm.folioData.folioDetailsData.nominees)
        vm.folioData.folioDetailsData.nominees = [];
      vm.folioData.folioDetailsData.nominees.push(
        {
          "firstName": "",
          "relation": "",
          "percentage": "",
          "dateOfBirth": "",
          "panNumber" : null,
          "guardianPanNumber" : null,
          "nomineeAddress1": "",
          "nomineeAddress2": "",
          "pinCode": "",
          "city": "",
          "state": "",
          "stateCode": "",
          "country": "",
          "countryCode": "",
          "guardianName": null,
          "guardianRelationWithNominee": null
        }
      );

      vm.activeTab = vm.folioData.folioDetailsData.nominees.length - 1;

      vm.folioData.folioDetailsData.nominees[vm.folioData.folioDetailsData.nominees.length - 1].applicantPersonalIdentifiers = angular.copy(vm.applicantPersonalIdentifiers);

    }

    function checkValidation() {
      var arr = vm.folioData.folioDetailsData.nominees, msg = '';
      for (var i = 0; i < arr.length; i++) {
        if (!arr[i]['firstName'] || !arr[i]['percentage']) {
          msg = 'Please fill details of ' + vm.nomineeEnum[i]
            + ' nominee';
          break;
        }
      }
      return msg;
    }

    function setActiveTab(index) {
      vm.activeTab = index;
      vm.callPan = false;
      checkDobOnInit();
      if(typeof vm.folioData.folioDetailsData.nominees[vm.activeTab].panNumber !== 'undefined' && vm.folioData.folioDetailsData.nominees[vm.activeTab].panNumber != "" && vm.folioData.folioDetailsData.nominees[vm.activeTab].panNumber != null) {
        nomineePanChanged(index,vm.folioData.folioDetailsData.nominees[vm.activeTab].panNumber);
      }

      if(typeof vm.folioData.folioDetailsData.nominees[vm.activeTab].guardianPanNumber!== 'undefined' && vm.folioData.folioDetailsData.nominees[vm.activeTab].guardianPanNumber != "" && vm.folioData.folioDetailsData.nominees[vm.activeTab].guardianPanNumber != null && !vm.callPan) {
        minorPanChanged(index,vm.folioData.folioDetailsData.nominees[vm.activeTab].guardianPanNumber , true)
      }

      if (!vm.folioData.folioDetailsData.nominees[vm.activeTab].minor && vm.folioData.folioDetailsData.nominees[vm.activeTab].applicantPersonalIdentifiers && vm.licenseObj) {
        var lIndex = vm.folioData.folioDetailsData.nominees[vm.activeTab].applicantPersonalIdentifiers.findIndex(function (obj) {
          return obj.identityProofType === 'DRIVING_LICENSE';
        })

        if (lIndex === -1) {
          vm.folioData.folioDetailsData.nominees[vm.activeTab].applicantPersonalIdentifiers.splice(1,0,vm.licenseObj);
        }
      }
    }

    function nomineeChangeDob(date) {
      if (!date) {
        return;
      }
      vm.folioData.folioDetailsData.nominees[vm.activeTab].dateOfBirth = $window.moment(date, 'YYYY-MM-DD').format("DD-MMM-YYYY");
      var age = $window.moment().diff(date, 'years');
      // if (age < 18) {
      //   vm.folioData.folioDetailsData.nominees[vm.activeTab].minor = true;
      // } else {
      //   vm.folioData.folioDetailsData.nominees[vm.activeTab].minor = false;
      //   vm.folioData.folioDetailsData.nominees[vm.activeTab].guardianPanNumber = null;
      //   vm.folioData.folioDetailsData.nominees[vm.activeTab].guardianName = null;
      //   vm.folioData.folioDetailsData.nominees[vm.activeTab].guardianRelationWithNominee = null;
      // }
      if(vm.folioData.folioDetailsData.nominees[vm.activeTab].dateOfBirth){
        vm.dobRequired = false;
      }
      if(vm.folioData.folioDetailsData.nominees[vm.activeTab].minor){
        if(vm.folioData.folioDetailsData.nominees[vm.activeTab].dateOfBirth){
          vm.dobRequired = false;
        }else{
          vm.dobRequired = true;
        }
      }
    }

    vm.showTermConditions = function() {
      ModalService.termConditionModal();
    }

    function goToBack() {
      $state.go('main.profile.folioDetails');
    }

    vm.changeCountry = function(index, countryCode) {
      if (!countryCode) {
        vm.folioData.folioDetailsData.nominees[index].country = null;
        vm.folioData.folioDetailsData.nominees[index].stateCode = null;
        vm.folioData.folioDetailsData.nominees[index].state = null;
        return;
      }
      vm.countryList.map( function (country) {
        if(country.countryCode === countryCode){
          vm.folioData.folioDetailsData.nominees[index].country = country.countryName;
            if (vm.folioData.folioDetailsData.nominees[index].country != 'INDIA'){
                for(var i = 0; i<vm.stateList.length; i++){
                  if (vm.stateList[i].stateCode == 'XX'){
                    vm.folioData.folioDetailsData.nominees[index].stateCode = vm.stateList[i].stateCode;
                    vm.folioData.folioDetailsData.nominees[index].state = vm.stateList[i].stateName;
                    break;
                  }
                }
            }
        }
      });
    }

    vm.changeState = function(index, stateCode) {
      vm.stateList.map( function (state) {
        if(state.stateCode === stateCode){
          vm.folioData.folioDetailsData.nominees[index].stateCode = state.stateCode;
          vm.folioData.folioDetailsData.nominees[index].state = state.stateName;
        }
      });
    }

    vm.nomineeUpdate = function () {
      var payload = {
        folioNumber: 0,
        nomineeList: [],
        inv_Email : vm.investorEmail,
        inv_Mobile : vm.investorMobile,
        email_belongs_to : vm.emailBelongsTo,
        mobile_belongs_to : vm.mobileBelongsTo,
        accountHoldingDeclaration : angular.copy(vm.folioData.folioDetailsData.accountHoldingDeclaration),
        incapacitationDeclaration : angular.copy(vm.folioData.folioDetailsData.incapacitationDeclaration)
      }

      if (payload.incapacitationDeclaration && Object.keys(vm.folioData.folioDetailsData.incapacitationDeclaration).length === 0) {
        delete payload.incapacitationDeclaration;
      }

      var isProportion = calculatePercentage();
      if (!isProportion) {
        vm.percentage_msg = vm.nomineeValidateData.PROPORTION_PERCENTAGE;
      }
      if (isProportion) {
        LoaderService.showLoader();
        var nomineeArr = [];
        nomineeArr = vm.folioData.folioDetailsData.nominees;
        payload.folioNumber = vm.folioNo;
        for (var j = 0; j < nomineeArr.length; j++) {
          if(nomineeArr[j].country == '' || nomineeArr[j].country == null){
            vm.countryList.map( function (country) {
              if(country.countryCode === nomineeArr[j].countryCode){
                vm.folioData.folioDetailsData.nominees[j].country = country.countryName;
              }
            });
          }
          payload.nomineeList.push({
            firstName: nomineeArr[j].firstName,
            guardianName: nomineeArr[j].guardianName,
            nomineeAddress1: nomineeArr[j].nomineeAddress1,
            nomineeAddress2: nomineeArr[j].nomineeAddress2,
            relation: nomineeArr[j].relation,
            dateOfBirth: nomineeArr[j].dateOfBirth,
            percentage: parseInt(nomineeArr[j].percentage, 10),
            city: nomineeArr[j].city,
            state: nomineeArr[j].state,
            stateCode: nomineeArr[j].stateCode,
            country: nomineeArr[j].country,
            countryCode: nomineeArr[j].countryCode,
            postalCode: nomineeArr[j].postalCode ? nomineeArr[j].postalCode : null,
            panNumber: nomineeArr[j].panNumber,
            guardianPanNumber: nomineeArr[j].guardianPanNumber,
            guardianRelationWithNominee: nomineeArr[j].guardianRelationWithNominee,
            minor:nomineeArr[j].minor,
            mobileNumber : nomineeArr[j].mobile,
            emailId: nomineeArr[j].emailId,
            identityProofType : nomineeArr[j].identityProofType,
            identityProofNumber : nomineeArr[j].identityProofNumber,
            identityProofCamsCode : nomineeArr[j].identityProofCamsCode
          });
        }

        if (vm.showNomineeUpdate) {
          InvestorServiceV2.post({
            'child1': 'profile',
            'child2': 'add-update',
            'child3': 'nominee'
          }, payload).$promise.then(success, failure);
        } else {
          InvestorService.post({
            'child1': 'profile',
            'child2': 'add-update',
            'child3': 'nominee'
          }, payload).$promise.then(success, failure);
        }

      }
    };

    function success(resp) {
      if (resp.status == true ) {
        $log.warn(resp.date);
        LoaderService.hideLoader();
          var success = function (response) {
            ModalService.updateNomineeModal({
              message: response.return_msg
            }, function() {
              $state.go('main.profile.folioDetails');
            },function() { });
          },
          error = function() {
          };
        ModalService.NomineeUpdateOtpModal({uniqueLink: resp.data.secretLink , folioNumber : vm.folioNo , message : resp.data.message, showNomineeUpdate : vm.showNomineeUpdate}, success, error);
      } else {
        MessageService.error(resp.message);
        LoaderService.hideLoader();
      }
    }

    function failure(resp) {
      MessageService.error(resp.message);
      LoaderService.hideLoader();
    }

    vm.tncCheck = function () {
      vm.TnC = true;
    }

    function getRelationshipList() {

      vm.applicantRelationShip = [];
      vm.minorRelationShip = [];

      var success = function (resp) {
        if (resp.status && resp.data) {
           var relationshipWithApplicant = resp.data.nomineeRelationshipList;
           var relationshipWithMinor = resp.data.guardianRelationshipList;

            relationshipWithApplicant.forEach(function(el) {
              vm.applicantRelationShip.push({
                name : el.relationDesc,
                value : el.value
              })
            })


            relationshipWithMinor.forEach(function(el) {
              vm.minorRelationShip.push({
                name : el.relationDesc,
                value : el.value
              })
            })

            for (var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
              var applObject =vm.applicantRelationShip.find(function (applRelation) {
                return applRelation.name ===  vm.folioData.folioDetailsData.nominees[i].relation;
              })

              if (applObject) {
                vm.folioData.folioDetailsData.nominees[i].relation = applObject.value;
              }

              var relationObject = vm.minorRelationShip.find(function (relation) {
                return relation.name === vm.folioData.folioDetailsData.nominees[i].guardianRelationWithNominee;
              })

              if (relationObject) {
                vm.folioData.folioDetailsData.nominees[i].guardianRelationWithNominee = relationObject.value;
              }

            }


        } else {
          vm.applicantRelationShip = [];
          vm.minorRelationShip = [];
          MessageService.error(resp.message);
        }
      }, error = function () {
          vm.applicantRelationShip = [];
          vm.minorRelationShip = [];
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'nominee',
        child3: 'relation'
      }).$promise.then(success, error);
    }

    vm.changeNomineeRelationsShip = function(index, relationship) {
      vm.applicantRelationShip.map( function (el) {
        if(el.value === relationship){
          vm.folioData.folioDetailsData.nominees[index].relation = el.value;
        }
      });
    }

    vm.changeMinorRelationsShip = function(index, relationship) {
      vm.minorRelationShip.map( function (el) {
        if(el.value === relationship){
          vm.folioData.folioDetailsData.nominees[index].guardianRelationWithNominee = el.value;
        }
      });
    }

    function checkDobOnInit() {
      checkDobMinor(vm.activeTab)

      if(vm.folioData.folioDetailsData.nominees.length == 2) {
        checkDobMinor(1)
      } else if(vm.folioData.folioDetailsData.nominees.length >= 3) {

        if (vm.showNomineeUpdate) {
          vm.folioData.folioDetailsData.nominees.forEach(function(el, index) {
            checkDobMinor(index);
          })
        } else {
          checkDobMinor(1)
          checkDobMinor(2)
        }

      }
    }

    function nomineePanChanged(index, pan) {
      if(pan == "") {
        vm.folioData.folioDetailsData.nominees[index].panNumber = null;
      } else {
        vm.folioData.folioDetailsData.nominees[index].identityProofNumber = angular.copy(pan);
      }
      if(vm.folioData.folioDetailsData.panNumber && vm.folioData.folioDetailsData.panNumber == pan) {
        vm.folioData.folioDetailsData.nominees[index].nomineePanInvalid = true;
        vm.nomineePanValid = false;
        vm.errorMessageNominee = vm.nomineeValidateData.NOMINEE_SAME_INVESTOR;
        vm.dupIndex = index;
      } else if(vm.folioData.folioDetailsData.panNumber !== pan) {

          vm.folioData.folioDetailsData.nominees[index].nomineePanInvalid = false;
          vm.errorMessageNominee = "";

          if (vm.folioData.folioDetailsData.nominees.length == 1) {
            vm.nomineePanValid = true;
          }

        for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
            if(i !== index && vm.folioData.folioDetailsData.nominees[index].panNumber && vm.folioData.folioDetailsData.nominees[i].panNumber == pan) {
              vm.folioData.folioDetailsData.nominees[index].nomineePanInvalid = true;
              vm.nomineePanValid = false;
              vm.errorMessageNominee = vm.nomineeValidateData.NOMINEE_PAN_SAME;
              vm.indexOne = index;
              vm.indexTwo = i ;
              break;
            }

            if (vm.folioData.folioDetailsData.nominees.length == 2) {
                if (vm.folioData.folioDetailsData.nominees[i].nomineePanInvalid && (vm.folioData.folioDetailsData.nominees[i].panNumber !== pan && vm.folioData.folioDetailsData.nominees[i].panNumber !== vm.folioData.folioDetailsData.panNumber)) {
                  vm.nomineePanValid = true;
                } else if (vm.folioData.folioDetailsData.nominees[i].panNumber !== pan && vm.folioData.folioDetailsData.nominees[i].panNumber !== vm.folioData.folioDetailsData.panNumber) {
                  vm.nomineePanValid = true;
                }
            }

           if (vm.folioData.folioDetailsData.nominees.length >= 3) {
            if(i !== index && vm.folioData.folioDetailsData.nominees[index].panNumber && (vm.folioData.folioDetailsData.nominees[i].panNumber == pan || vm.folioData.folioDetailsData.nominees[i].panNumber == vm.folioData.folioDetailsData.panNumber)){
              vm.nomineePanValid = false;
            }  else if(i !== index && vm.folioData.folioDetailsData.nominees[index].panNumber && vm.folioData.folioDetailsData.nominees[i].panNumber !== pan && vm.folioData.folioDetailsData.nominees[i].panNumber !== vm.folioData.folioDetailsData.panNumber &&  vm.folioData.folioDetailsData.nominees[i].nomineePanInvalid != true) {
              if(!vm.dupIndex)  {
                if(typeof vm.indexOne !== 'undefined' && typeof vm.indexTwo !== 'undefined') {
                  if(vm.folioData.folioDetailsData.nominees[vm.indexOne].panNumber == vm.folioData.folioDetailsData.nominees[vm.indexTwo].panNumber) {
                    vm.nomineePanValid = false;
                  }
                } else if(typeof vm.indexTwo !== 'undefined'){
                  if(vm.indexTwo !== i && vm.folioData.folioDetailsData.nominees[i].panNumber == vm.folioData.folioDetailsData.nominees[vm.indexTwo].panNumber) {
                    vm.nomineePanValid = false;
                  }
                } else {
                  vm.nomineePanValid = true;
                }
              } else if(vm.folioData.folioDetailsData.nominees[vm.dupIndex].panNumber !== vm.folioData.folioDetailsData.panNumber) {
                vm.nomineePanValid = true;
              }
            }  else if(i !== index && vm.folioData.folioDetailsData.nominees[i].nomineePanInvalid == false && vm.folioData.folioDetailsData.nominees[i].panNumber !== pan && (vm.folioData.folioDetailsData.nominees[i].panNumber !== vm.folioData.folioDetailsData.panNumber)) {
              if(!vm.dupIndex)  {
                vm.nomineePanValid = true;
              } else if(vm.folioData.folioDetailsData.nominees[vm.dupIndex].panNumber !== vm.folioData.folioDetailsData.panNumber) {
                vm.nomineePanValid = true;
              }
            } else if (i !== index && vm.folioData.folioDetailsData.nominees[i].nomineePanInvalid == false && vm.folioData.folioDetailsData.nominees[index].nomineePanInvalid == false) {
              if(!vm.dupIndex)  {
                vm.nomineePanValid = true;
              } else if(vm.folioData.folioDetailsData.nominees[vm.dupIndex].panNumber !== vm.folioData.folioDetailsData.panNumber) {
                vm.nomineePanValid = true;
              }
            } else if(i != index && vm.folioData.folioDetailsData.nominees[i].nomineePanInvalid == true) {
              if(vm.folioData.folioDetailsData.nominees[vm.indexOne].panNumber == vm.folioData.folioDetailsData.nominees[vm.indexTwo].panNumber) {
                vm.nomineePanValid = false;
              } else if(vm.indexTwo !== i && vm.folioData.folioDetailsData.nominees[i].panNumber == vm.folioData.folioDetailsData.nominees[vm.indexTwo].panNumber){
                vm.nomineePanValid = false;
              } else {
                vm.nomineePanValid = true;
              }
            } else {
              if(typeof vm.indexOne !== 'undefined' && typeof vm.indexTwo !== 'undefined' && (vm.folioData.folioDetailsData.nominees[vm.indexOne].panNumber == vm.folioData.folioDetailsData.nominees[vm.indexTwo].panNumber)) {
                vm.nomineePanValid = false;
              } else {
                vm.nomineePanValid = true;
              }
            }
           }
        }


         if(typeof vm.dupIndex !== 'undefined') {
            if(vm.folioData.folioDetailsData.nominees[vm.dupIndex].panNumber == vm.folioData.folioDetailsData.panNumber) {
              vm.nomineePanValid = false;
            }
         }


        for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
          if(i != index && typeof vm.indexTwo !== 'undefined' && typeof vm.indexTwo !== 'undefined' && i != vm.indexTwo  && vm.nomineePanValid) {
            if(vm.folioData.folioDetailsData.nominees[vm.indexTwo] && vm.folioData.folioDetailsData.nominees[vm.indexTwo].panNumber == vm.folioData.folioDetailsData.nominees[i].panNumber) {
              vm.nomineePanValid = false;
            }
          } else if(i != index && typeof vm.dupIndex !== 'undefined') {
              if(vm.folioData.folioDetailsData.nominees[i].panNumber == vm.folioData.folioDetailsData.panNumber) {
                vm.nomineePanValid = false;
              }
          }
        }

        if(typeof pan !== 'undefined' && pan !== null) {
          if(pan.length == 10 || vm.minorPanValid == false) {
            minorPanChanged(index, vm.folioData.folioDetailsData.nominees[index].guardianPanNumber , false)
          }
        }
      }
    }

    function minorPanChanged(index, pan , isCalledFromChange) {
      if(pan == "") {
        vm.folioData.folioDetailsData.nominees[index].guardianPanNumber = null;
        pan = null;
      }

      if(vm.folioData.folioDetailsData.nominees[index] && vm.folioData.folioDetailsData.nominees[index].panNumber && vm.folioData.folioDetailsData.nominees[index].panNumber == pan) {
          vm.folioData.folioDetailsData.nominees[index].minorPanInvalid = true;
          vm.errorMessage = vm.nomineeValidateData.GUARDIAN_SAME_NOMINEE;
          vm.minorPanValid = false;
          vm.mdIndex = index;

      } else  {

          if(vm.folioData.folioDetailsData.nominees[index].minorPanInvalid && isCalledFromChange == false) {
            isCalledFromChange = true;
          }

          vm.callPan = isCalledFromChange;
          vm.folioData.folioDetailsData.nominees[index].minorPanInvalid = false;
          vm.errorMessage = '';

          for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
             if(i != index) {
                if(vm.folioData.folioDetailsData.nominees[i].panNumber && vm.folioData.folioDetailsData.nominees[i].panNumber == vm.folioData.folioDetailsData.panNumber) {
                    vm.minorPanValid = false;
                    break;
                } else if(typeof vm.mdIndex !== 'undefined' && vm.folioData.folioDetailsData.nominees[vm.mdIndex] && vm.folioData.folioDetailsData.panNumber && vm.folioData.folioDetailsData.nominees[vm.mdIndex].panNumber == vm.folioData.folioDetailsData.nominees[vm.mdIndex].guardianPanNumber) {
                    vm.minorPanValid = false;
                    break;
                }else if(!vm.isGuardian && i == vm.invalidPanIndex) {
                    vm.folioData.folioDetailsData.nominees[vm.invalidPanIndex].minorPanInvalid = true;
                    vm.minorPanValid = false;
                    vm.errorMessage = vm.errMessg;
                    break;
                }
             } else {
                vm.minorPanValid = true;
                vm.errorMessage = "";
                if(typeof vm.invalidPanIndex !== 'undefined' && i == vm.invalidPanIndex) {
                    vm.isGuardian = true;
                    vm.folioData.folioDetailsData.nominees[vm.invalidPanIndex].minorPanInvalid = false;
                }
             }
          }


          if(typeof pan == 'undefined' || pan == null) {
            for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
              if(i != index && vm.folioData.folioDetailsData.nominees[i].minorPanInvalid == true) {
                vm.minorPanValid = false;
                break;
              }
            }
          }

          var success = function (resp) {
            if(resp.data && resp.status) {
              if(!resp.data.panVerifiedFlag) {
                vm.folioData.folioDetailsData.nominees[index].minorPanInvalid = true;
                vm.errMessg = resp.data.message;
                vm.minorPanValid = false;
                vm.errorMessage = vm.errMessg;
                vm.isGuardian = false;
                vm.invalidPanIndex = index;
              } else {
                vm.folioData.folioDetailsData.nominees[index].minorPanInvalid = false;
                if(vm.invalidPanIndex && vm.folioData.folioDetailsData.nominees[vm.invalidPanIndex]) {
                  if(vm.folioData.folioDetailsData.nominees[vm.invalidPanIndex].minorPanInvalid == false) {
                    for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
                      if(i != index) {
                        if(vm.folioData.folioDetailsData.nominees[i].minorPanInvalid) {
                          vm.minorPanValid = false;
                          break;
                        } else {
                          vm.minorPanValid = true;
                        }
                      }
                    }
                      vm.isGuardian = true;
                    }
                  } else {
                      for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
                        if(i != index) {
                          if((vm.folioData.folioDetailsData.nominees[i].guardianPanNumber !== null && typeof vm.folioData.folioDetailsData.nominees[i].guardianPanNumber !== 'undefined') && vm.folioData.folioDetailsData.nominees[i].minorPanInvalid) {
                            vm.minorPanValid = false;
                            break;
                          } else {
                            vm.minorPanValid = true;
                          }
                        }
                      }
                  }
                }
              } else {
                MessageService.error(resp.message);
                vm.folioData.folioDetailsData.nominees[index].minorPanInvalid = true;
                vm.errMessg = resp.message;
                vm.minorPanValid = false;
                vm.errorMessage = vm.errMessg;
                vm.isGuardian = false;
                vm.invalidPanIndex = index;
              }
            }, error = function (resp) {
                MessageService.error(resp.message);
                vm.folioData.folioDetailsData.nominees[index].minorPanInvalid = true;
                vm.errMessg = resp.message;
                vm.minorPanValid = false;
                vm.errorMessage = vm.errMessg;
                vm.isGuardian = false;
                vm.invalidPanIndex = index;
            };

            if(typeof pan !== 'undefined' && pan !== null && isCalledFromChange) {
              InvestorService.post({
                child1: 'profile',
                child2: 'guardian',
                child3: 'verifyPan'
              },{pan : pan}).$promise.then(success, error);
            }
      }

    }

    function checkDobMinor(index) {
      var date = vm.folioData.folioDetailsData.nominees[index].dateOfBirth;
      if (!date) {
        vm.folioData.folioDetailsData.nominees[index].minor = false;
        return;
      }
      var age = $window.moment().diff(date, 'years');
      if(vm.folioData.folioDetailsData.nominees[index].dateOfBirth){
        if (age < 18) {
          vm.folioData.folioDetailsData.nominees[index].minor = true;
        } else {
          vm.folioData.folioDetailsData.nominees[index].minor = false;
        }
      }else{
        vm.folioData.folioDetailsData.nominees[index].minor = false;
      }

      setincapcitationList(index);
    }

    function fetchBelongsToDropdown(){
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.belongToListEmail = resp.data.emailList;
            vm.belongToListMobile = resp.data.mobileList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          // $log.info('Belongs Dropdown error >>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
    }

    function getEmailMobile(){
      LoaderService.showLoader();
      var success = function(resp){
        LoaderService.hideLoader();
        if(resp.status && resp.data){
          vm.investorEmail = resp.data.inv_Email;
          vm.investorMobile = resp.data.inv_Mobile;
        }else{
          vm.investorEmail = null;
          vm.investorMobile = null;
          MessageService.error(resp.message);
        }
      }
      ,error = function(err){
        LoaderService.hideLoader();
        MessageService.error(err.message);
      };
      InvestorService.get({
        child1 : 'getDetails',
        child2 : 'userDeclartion',
        child3 : vm.folioNo
      },null).$promise.then(success,error);
    }

    vm.changeNomineeIsMinor = function(index){
      vm.folioData.folioDetailsData.nominees[index].dateOfBirth = "";
      vm.dataMinDate = "";
      vm.dataMaxDate = "";
      vm.isMinorMinDate = "";
      vm.isMinorMaxDate = "";
      $timeout(function () {
        if(vm.folioData.folioDetailsData.nominees[index] && vm.folioData.folioDetailsData.nominees[index].minor){
          vm.dobRequired = true;
        }else{
          vm.dobRequired = false;
        }
        var currentDate = Date();
        var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
        var initiateDate = new Date('January 01, 1900 00:00:00');
        vm.isMinorMinDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.isMinorMaxDate = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
        vm.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.dataMinDate = $window.moment(Date.parse(initiateDate));
        if (vm.folioData.folioDetailsData.nominees[vm.activeTab].minor) {
          vm.folioData.folioDetailsData.nominees[vm.activeTab].minor = true;
          vm.folioData.folioDetailsData.nominees[index].applicantPersonalIdentifiers = vm.folioData.folioDetailsData.nominees[index].applicantPersonalIdentifiers.filter(function(obj, index) {
            return obj.identityProofType !== 'DRIVING_LICENSE';
          });
        } else {
          vm.folioData.folioDetailsData.nominees[vm.activeTab].applicantPersonalIdentifiers = angular.copy(vm.applicantPersonalIdentifiers);
          vm.folioData.folioDetailsData.nominees[vm.activeTab].minor = false;
          vm.folioData.folioDetailsData.nominees[vm.activeTab].guardianPanNumber = null;
          vm.folioData.folioDetailsData.nominees[vm.activeTab].guardianName = null;
          vm.folioData.folioDetailsData.nominees[vm.activeTab].guardianRelationWithNominee = null;
        }

        setincapcitationList(index);
      }, 1000);
    }
    vm.setInitiatedDate = function(){
      $timeout(function () {
        var currentDate = Date();
        var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
        var initiateDate = new Date('January 01, 1900 00:00:00');
        vm.isMinorMinDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.isMinorMaxDate = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
        vm.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.dataMinDate = $window.moment(Date.parse(initiateDate));
      }, 1000);
    }

    /**
    * function responsible to fethcing and setting personal identifier dropdown list
    */

    function getPersonalIdentifier() {

      var success = function (resp) {

        vm.applicantPersonalIdentifiers = [];

        if (resp.status && resp.data) {
          vm.applicantPersonalIdentifiers = resp.data.identityProofs;
          vm.folioData.folioDetailsData.nominees.forEach(function (element, index) {
            //vm.folioData.folioDetailsData.nominees[index].applicantPersonalIdentifiers = angular.copy(vm.applicantPersonalIdentifiers);
            if (element.minor) {
              vm.folioData.folioDetailsData.nominees[index].applicantPersonalIdentifiers = vm.applicantPersonalIdentifiers.filter(function(obj, index) {
                return obj.identityProofType !== 'DRIVING_LICENSE';
              });
            } else {
              vm.folioData.folioDetailsData.nominees[index].applicantPersonalIdentifiers = angular.copy(vm.applicantPersonalIdentifiers);
            }

            var optionIndex = vm.folioData.folioDetailsData.nominees[vm.activeTab].applicantPersonalIdentifiers.findIndex(function (obj) {
              return obj.identityProofType === 'PAN_CARD';
            });

            var optionIndexAadhar = vm.folioData.folioDetailsData.nominees[vm.activeTab].applicantPersonalIdentifiers.findIndex(function (obj) {
              return obj.identityProofType === 'AADHAR_CARD';
            });

            var optionIndexLiscense = vm.folioData.folioDetailsData.nominees[vm.activeTab].applicantPersonalIdentifiers.findIndex(function (obj) {
              return obj.identityProofType === 'DRIVING_LICENSE';
            });

            var optionIndexPassport = vm.folioData.folioDetailsData.nominees[vm.activeTab].applicantPersonalIdentifiers.findIndex(function (obj) {
              return obj.identityProofType === 'PASSPORT';
            });

            if ((vm.folioData.folioDetailsData.nominees[index].panNumber || (vm.folioData.folioDetailsData.nominees[index].identityProofNumber && vm.folioData.folioDetailsData.nominees[index].identityProofType === 'PAN_CARD')) && optionIndex > -1) {
              vm.folioData.folioDetailsData.nominees[index].identityProofType = 'PAN_CARD';
              var value = vm.folioData.folioDetailsData.nominees[index].panNumber ?  vm.folioData.folioDetailsData.nominees[index].panNumber : vm.folioData.folioDetailsData.nominees[index].identityProofNumber;
              vm.folioData.folioDetailsData.nominees[index].panNumber = angular.copy(value);
              nomineePanChanged(index , value)
            }

            if ((vm.folioData.folioDetailsData.nominees[index].aadharCard || (vm.folioData.folioDetailsData.nominees[index].identityProofNumber && vm.folioData.folioDetailsData.nominees[index].identityProofType === 'AADHAR_CARD')) && optionIndexAadhar > -1) {
              vm.folioData.folioDetailsData.nominees[index].identityProofType = 'AADHAR_CARD';
              var value = vm.folioData.folioDetailsData.nominees[index].aadharCard ?  vm.folioData.folioDetailsData.nominees[index].aadharCard : vm.folioData.folioDetailsData.nominees[index].identityProofNumber;
              vm.folioData.folioDetailsData.nominees[index].aadharCard = angular.copy(value);
              nomineeAadhaarChanged(index , value)
            }

            if ((vm.folioData.folioDetailsData.nominees[index].drivingLicense || (vm.folioData.folioDetailsData.nominees[index].identityProofNumber && vm.folioData.folioDetailsData.nominees[index].identityProofType === 'DRIVING_LICENSE')) && optionIndexLiscense > -1) {
              vm.folioData.folioDetailsData.nominees[index].identityProofType = 'DRIVING_LICENSE';
              var value = vm.folioData.folioDetailsData.nominees[index].drivingLicense ?  vm.folioData.folioDetailsData.nominees[index].drivingLicense : vm.folioData.folioDetailsData.nominees[index].identityProofNumber;
              vm.folioData.folioDetailsData.nominees[index].drivingLicense = angular.copy(value);
              nomineeLicenseChanged(index , value)
            }

            if ((vm.folioData.folioDetailsData.nominees[index].passport || (vm.folioData.folioDetailsData.nominees[index].identityProofNumber && vm.folioData.folioDetailsData.nominees[index].identityProofType === 'PASSPORT')) && optionIndexPassport > -1) {
              vm.folioData.folioDetailsData.nominees[index].identityProofType = 'PASSPORT';
              var value = vm.folioData.folioDetailsData.nominees[index].passport ?  vm.folioData.folioDetailsData.nominees[index].passport : vm.folioData.folioDetailsData.nominees[index].identityProofNumber;
              vm.folioData.folioDetailsData.nominees[index].passport = angular.copy(value);
              passportChanged(index , value)
            }

          })


          LoaderService.hideLoader();
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };


      LoaderService.showLoader();

      InvestorService.get({
        child1: 'identity-proofs'
      }).$promise.then(success, error);

    }

    /**
    * function responsible for handling identfier selection change
    * @param  {Number}   index - index of current nominee
    * @param  {String}   identifier - selected identfier value
    */


    function changePersonalIdentifier(index, identifier) {

      vm.folioData.folioDetailsData.nominees[index].identityProofNumber = null;

      vm.folioData.folioDetailsData.nominees[index].applicantPersonalIdentifiers.map(function (el) {

        if (identifier !== "AADHAR_CARD" && vm.folioData.folioDetailsData.nominees[index].hasOwnProperty('aadharCard')) {
          vm.folioData.folioDetailsData.nominees[index].aadharCard = null;
          vm.nomineeAadhaarChanged(index,vm.folioData.folioDetailsData.nominees[index].aadharCard);
        }

        if (identifier !== "DRIVING_LICENSE" && vm.folioData.folioDetailsData.nominees[index].hasOwnProperty('drivingLicense')) {
          vm.folioData.folioDetailsData.nominees[index].drivingLicense = null;
          vm.nomineeLicenseChanged(index,vm.folioData.folioDetailsData.nominees[index].drivingLicense);
        }

        if (identifier !== "PAN_CARD" && vm.folioData.folioDetailsData.nominees[index].hasOwnProperty('panNumber')) {
          vm.folioData.folioDetailsData.nominees[index].panNumber = null;
          vm.nomineePanChanged(index,vm.folioData.folioDetailsData.nominees[index].panNumber);
        }

        if (identifier !== "PASSPORT" && vm.folioData.folioDetailsData.nominees[index].hasOwnProperty('passport')) {
          vm.folioData.folioDetailsData.nominees[index].passport = null;
          vm.passportChanged(index,vm.folioData.folioDetailsData.nominees[index].passport);
        }

        if (el.identityProofType === identifier) {
          vm.folioData.folioDetailsData.nominees[index].identityProofType = el.identityProofType;
          vm.folioData.folioDetailsData.nominees[index].identityProofCamsCode = el.identityProofCamsCode;
        }

      });
    }


    /**
     * function responsible for validating investor email and nominee email same check
     * @param  {Number}   index - index of current nominee
     * @param  {String}   email - email entered
     */

    function nomineeEmailChanged(index, email) {
      if (!email) {
        return;
      }

      if (vm.investorEmail && email.toLowerCase() === vm.investorEmail.toLowerCase()) {
        vm.folioData.folioDetailsData.nominees[index].emailIdInvalid = true;
        vm.emailIdValid = false;
      } else {
        vm.folioData.folioDetailsData.nominees[index].emailIdInvalid = false;
        vm.emailIdValid = true;
      }

    }

    /**
     * function responsible  for validating investor mobile and nominee mobile same check - currently not in use
     * @param  {Number}   index - index of current nominee
     * @param  {String}   mobile - entered mobile number
     */

    function nomineeMobileChanged(index, mobile) {
      if (!mobile) {
        return;
      }

      vm.mobileValid = true;

      // var valueComparison = angular.copy(vm.investorMobile);
      // if (!valueCompaisron.includes('91')) {
      //   valueComparison = '+91'+valueComparison;
      // }
      //
      // if (valueComparison && mobile === valueComparison) {
      //   vm.folioData.folioDetailsData.nominees[index].mobileInvalid = true;
      //   vm.mobileValid = false;
      // } else {
      //   vm.folioData.folioDetailsData.nominees[index].mobileInvalid = false;
      //   vm.mobileValid = true;
      // }

    }


    /**
     * function responsible  for validating nominees license same check
     * @param  {Number}   index - index of current nominee
     * @param  {String}   license - entered license number
     */

    function nomineeLicenseChanged(index, license) {

        if(license) {
          vm.folioData.folioDetailsData.nominees[index].identityProofNumber = angular.copy(license);
        }

        vm.nomineeLicenseValid = true;
        vm.folioData.folioDetailsData.nominees[index].nomineeLicenseInvalid = false;
        if (!vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense) {
          vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense = [];
        }

        if (vm.folioData.folioDetailsData.nominees.length == 1) {
          vm.nomineeLicenseValid = true;
        } else if (vm.folioData.folioDetailsData.nominees.length > 1) {

          for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {

            if (i !== index && vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('drivingLicense') && vm.folioData.folioDetailsData.nominees[i].drivingLicense === license) {
              vm.folioData.folioDetailsData.nominees[index].nomineeLicenseInvalid = true;
              vm.folioData.folioDetailsData.nominees[i].nomineeLicenseInvalid = true;
              vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense.push(i);
              if (!vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense) {
                vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense = [];
              }
              vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense.push(index);
              vm.nomineeLicenseValid = false;
            } else if (i !== index && vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('drivingLicense')) {

              if (!vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense) {
                vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense = [];
              }

              if (vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense.includes(i)) {
                var indexEL = vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense.indexOf(i);
                vm.folioData.folioDetailsData.nominees[index].sameIndexLiscense.splice(indexEL,1);

                indexEL = vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense.indexOf(index);
                vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense.splice(indexEL,1);

                if (vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense.length === 0) {
                  vm.folioData.folioDetailsData.nominees[i].nomineeLicenseInvalid = false;
                }

              }

              if (vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense && vm.folioData.folioDetailsData.nominees[i].sameIndexLiscense.length !== 0){
                vm.nomineeLicenseValid = false;
              }

            }
          }

        }

    }

    /**
     * function responsible  for validating nominees aadhar same check
     * @param  {Number}   index - index of current nominee
     * @param  {String}   aadhar - entered aadhar
     */

    function nomineeAadhaarChanged(index, aadhar) {

      if(aadhar) {
        vm.folioData.folioDetailsData.nominees[index].identityProofNumber = angular.copy(aadhar);
      }
      //
      // vm.nomineeAadhaarValid = true;
      // vm.folioData.folioDetailsData.nominees[index].nomineeAadhaarInvalid = false;
      // if (!vm.folioData.folioDetailsData.nominees[index].sameIndex) {
      //   vm.folioData.folioDetailsData.nominees[index].sameIndex = [];
      // }
      //
      // if (vm.folioData.folioDetailsData.nominees.length == 1) {
      //   vm.nomineeAadhaarValid = true;
      // } else if (vm.folioData.folioDetailsData.nominees.length > 1) {
      //   for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
      //
      //     if (i !== index && vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('aadharCard') && vm.folioData.folioDetailsData.nominees[i].aadharCard === aadhar) {
      //       vm.folioData.folioDetailsData.nominees[index].nomineeAadhaarInvalid = true;
      //       vm.folioData.folioDetailsData.nominees[i].nomineeAadhaarInvalid = true;
      //       vm.folioData.folioDetailsData.nominees[index].sameIndex.push(i);
      //       if (!vm.folioData.folioDetailsData.nominees[i].sameIndex) {
      //         vm.folioData.folioDetailsData.nominees[i].sameIndex = [];
      //       }
      //       vm.folioData.folioDetailsData.nominees[i].sameIndex.push(index);
      //       vm.nomineeAadhaarValid = false;
      //     } else if (i !== index && vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('aadharCard')) {
      //
      //       if (!vm.folioData.folioDetailsData.nominees[i].sameIndex) {
      //         vm.folioData.folioDetailsData.nominees[i].sameIndex = [];
      //       }
      //
      //       if (vm.folioData.folioDetailsData.nominees[index].sameIndex.includes(i)) {
      //         var indexEL = vm.folioData.folioDetailsData.nominees[index].sameIndex.indexOf(i);
      //         vm.folioData.folioDetailsData.nominees[index].sameIndex.splice(indexEL,1);
      //
      //         indexEL = vm.folioData.folioDetailsData.nominees[i].sameIndex.indexOf(index);
      //         vm.folioData.folioDetailsData.nominees[i].sameIndex.splice(indexEL,1);
      //
      //         if (vm.folioData.folioDetailsData.nominees[i].sameIndex.length === 0) {
      //           vm.folioData.folioDetailsData.nominees[i].nomineeAadhaarInvalid = false;
      //         }
      //
      //       }
      //
      //       if (vm.folioData.folioDetailsData.nominees[i].sameIndex && vm.folioData.folioDetailsData.nominees[i].sameIndex.length !== 0){
      //         vm.nomineeAadhaarValid = false;
      //       }
      //
      //     }
      //
      //   }
      // }


    }

    /**
     * function responsible  for setting incapacitation number and nominee name
     */

    function selectedNominee() {
      if (vm.incapcitationNomineeIndex !== null) {
        if (!vm.folioData.folioDetailsData.incapacitationDeclaration) {
          vm.folioData.folioDetailsData.incapacitationDeclaration = {};
        }
        vm.folioData.folioDetailsData.incapacitationDeclaration.nomineeNumber = angular.copy(parseInt(vm.incapcitationNomineeIndex) + 1);
        vm.folioData.folioDetailsData.incapacitationDeclaration.nomineeName = angular.copy(vm.folioData.folioDetailsData.nominees[vm.incapcitationNomineeIndex].firstName);
      } else {
        vm.folioData.folioDetailsData.incapacitationDeclaration.nomineeNumber = null;
        vm.folioData.folioDetailsData.incapacitationDeclaration.nomineeName = null;
        vm.folioData.folioDetailsData.incapacitationDeclaration.percentage = null;
        vm.folioData.folioDetailsData.incapacitationDeclaration.amount = null;
      }
    }

    /**
     * function responsible  for setting statement declaration payload
     */

    function setStatement() {
      vm.folioData.folioDetailsData.accountHoldingDeclaration = vm.nomination === true ? 'NOMINATION_YES' : 'NOMINATION_NO';
    }

    /**
     * function responsible  for handling incapcitaion dropdown - don't allow dropdown value to contain value without firstname
     */

    function nameFilter(item) {
      return item.firstName !== '' && item.firstName !== undefined;
    }


    function setincapcitationList(index) {
      vm.incapcitationList = [];
      vm.folioData.folioDetailsData.nominees.forEach(function(nominee, index) {
        if (vm.folioData.folioDetailsData.nominees[index].firstName) {
          vm.incapcitationList.push(angular.copy({
            key : vm.folioData.folioDetailsData.nominees[index].firstName + '-' + vm.nomineeEnum[index],
            value : index,
            isMinor : vm.folioData.folioDetailsData.nominees[index].minor
          }));
        } else {
          vm.incapcitationList.splice(index, 1);
        }
      })

      vm.incapcitationNomineeIndex = vm.incapcitationNomineeIndex === index ? null : vm.incapcitationNomineeIndex;


    }

    function passportChanged(index, passport) {
      vm.nomineePassportValid = true;
      vm.folioData.folioDetailsData.nominees[index].nomineePassportInvalid = false;

      if (!vm.folioData.folioDetailsData.nominees[index].sameIndexPassport) {
        vm.folioData.folioDetailsData.nominees[index].sameIndexPassport = [];
      }
      if(passport) {
        vm.folioData.folioDetailsData.nominees[index].identityProofNumber = angular.copy(passport);
      }

      if (vm.folioData.folioDetailsData.nominees.length === 1) {
        vm.nomineePassportValid = true;
      } else if (vm.folioData.folioDetailsData.nominees.length > 1) {
        for(var i = 0 ; i < vm.folioData.folioDetailsData.nominees.length ; i ++) {
          if (i !== index && vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('passport') && vm.folioData.folioDetailsData.nominees[i].passport === passport) {
            vm.folioData.folioDetailsData.nominees[index].nomineePassportInvalid = true;
            vm.folioData.folioDetailsData.nominees[i].nomineePassportInvalid = true;
            vm.folioData.folioDetailsData.nominees[index].sameIndexPassport.push(i);
            if (!vm.folioData.folioDetailsData.nominees[i].sameIndexPassport) {
              vm.folioData.folioDetailsData.nominees[i].sameIndexPassport = [];
            }
            vm.folioData.folioDetailsData.nominees[i].sameIndexPassport.push(index);
            vm.nomineePassportValid = false;
          } else if (i !== index && vm.folioData.folioDetailsData.nominees[i].hasOwnProperty('passport')) {

            if (!vm.folioData.folioDetailsData.nominees[i].sameIndexPassport) {
              vm.folioData.folioDetailsData.nominees[i].sameIndexPassport = [];
            }

            if (vm.folioData.folioDetailsData.nominees[index].sameIndexPassport.includes(i)) {
              var indexEL = vm.folioData.folioDetailsData.nominees[index].sameIndexPassport.indexOf(i);
              vm.folioData.folioDetailsData.nominees[index].sameIndexPassport.splice(indexEL,1);

              indexEL = vm.folioData.folioDetailsData.nominees[i].sameIndexPassport.indexOf(index);
              vm.folioData.folioDetailsData.nominees[i].sameIndexPassport.splice(indexEL,1);

              if (vm.folioData.folioDetailsData.nominees[i].sameIndexPassport.length === 0) {
                vm.folioData.folioDetailsData.nominees[i].nomineePassportValid = false;
              }
            }
            if (vm.folioData.folioDetailsData.nominees[i].sameIndexPassport && vm.folioData.folioDetailsData.nominees[i].sameIndexPassport.length !== 0){
              vm.nomineePassportValid = false;
            }
          }
        }
      }
    }
    vm.setInitiatedDate();
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('Declaration', declaration);

  function declaration(TransactionService, InvestorService, $scope, $state, LoaderService, MessageService, ModalService, AppConstants, UtilService, $log , dynamicData , panAadharService , AuthService) {
    var vm = this;
    vm.declarationYearList = [];
    vm.init = init;
    vm.declaration = false;
    vm.dobError = false;
    vm.formValidationError = false;
    vm.declarationPopUp = false;
    vm.estimatedIncome = null;
    vm.totalIncome = null;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.taxable = null;
    vm.nonTaxable = null;
    vm.folioList = null;
    vm.folioNumber = null;
    vm.category = null;
    vm.declarationCategory = null;
    vm.yearForDeclarationList = null;
    vm.yearForDeclaration = null;
    vm.assessmentYear = null;
    vm.lastDateOfCFY = null;
    vm.investorName = null;
    vm.folioSubmit = false;
    vm.declarationSubmit = false;
    vm.details = false;
    vm.cancelFolio = null;
    vm.registrationNo = null;
    vm.cancelFolioList = null;
    vm.registerNoList = null;
    vm.detailDeclarationCategory = null;
    vm.detailRegistrationNo = null;
    vm.detailRegistrationDate = null;
    vm.detailInvestorName = null;
    vm.detailTax = null;
    vm.detailIncome = null;
    vm.detailTotalIncome = null;
    vm.detailFYToDate = null;
    vm.detailFYFromDate = null;
    if (dynamicData.noteDTO.noteDTOMap.Note_Profile_Declaration) {
      vm.dynamicDataNote = dynamicData.noteDTO.noteDTOMap.Note_Profile_Declaration.content;
    }
    var token = AuthService.getToken();

    function init() {
      vm.taxable = false;
      vm.nonTaxable = !vm.taxable;
      vm.getDetails();
    }

    vm.getDetails = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.folioList = resp.data.folioActiveList ? resp.data.folioActiveList : '';
            vm.declarationCategory = resp.data.declarationCategory ? resp.data.declarationCategory : '';
            vm.yearForDeclarationList = resp.data.yearForDeclaration ? resp.data.yearForDeclaration : '';
            vm.lastDateOfCFY = resp.data.lastDateOfCFY ? resp.data.lastDateOfCFY : '';
            vm.assessmentYear = resp.data.assessmentYear ? resp.data.assessmentYear : '';
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'form15gh',
        child2: 'folios'
      }).$promise.then(success, error);
    }

    vm.submitDeclaration = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            MessageService.success(resp.data.message);
            vm.resetDeclaration();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        folioNo: vm.folioNumber,
        declarationCategory: vm.category.replaceAll(' ',''),
        yearOfDeclaration: vm.declarationYear,
        estimatedIncome: vm.estimatedIncome,
        estimatedTotalIncome: vm.totalIncome,
        declarationAssessedToTax: vm.taxable
      };

      var successHandler  = function() {
        InvestorService.post({
          child1: 'form15gh',
          child2: 'register'
        },payload).$promise.then(success, error);
      } , errorHandler = function() {
          LoaderService.hideLoader();
    }
      panAadharService.fetchPanAadharLinkingStatus(token.investorPAN,null).then(successHandler).catch(errorHandler);

    }

    vm.getFolio = function () {
      vm.resetDeclaration();
      vm.close();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.cancelFolioList = resp.data.folioList ? resp.data.folioList : '';
            vm.folioSubmit = true;
            if (vm.cancelFolioList.length < 1)
              vm.folioSubmit = false;
          } else {
            MessageService.error(resp.message);
            vm.folioSubmit = false;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'form15gh',
        child2: 'folios',
        child3: 'list'
      }).$promise.then(success, error);
    }

    vm.folioChanged = function () {
      vm.details = false;
      vm.declarationSubmit = false;
      vm.registrationNo = null;
      vm.folioSubmit = true;
      if (vm.cancelFolio)
        vm.submitFolio();
    }

    vm.submitFolio = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.registerNoList = resp.data.registrationNoList ? resp.data.registrationNoList : '';
            vm.declarationSubmit = true;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        folioNo: vm.cancelFolio,
      };
      InvestorService.post({
        child1: 'form15gh',
        child2: 'registration_no',
        child3: 'list'
      }, payload).$promise.then(success, error);
    }

    vm.RegistrationChanged = function () {
      vm.details = false;
      vm.folioSubmit = true;
      vm.declarationSubmit = true;
    }

    vm.submitRegistration = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.detailDeclarationCategory = resp.data.declarationCategory ? resp.data.declarationCategory : '';
            vm.detailRegistrationNo = resp.data.registrationNo ? resp.data.registrationNo : '';
            vm.detailRegistrationDate = resp.data.registrationDate ? resp.data.registrationDate : '';
            vm.detailInvestorName = resp.data.investorName ? resp.data.investorName : '';
            vm.detailTax = resp.data.declarationAssessedToTax ? resp.data.declarationAssessedToTax : '';
            vm.detailIncome = resp.data.estimatedIncome ? resp.data.estimatedIncome : '';
            vm.detailTotalIncome = resp.data.estimatedTotalIncome ? resp.data.estimatedTotalIncome : '';
            vm.detailFYToDate = resp.data.yearToDate ? resp.data.yearToDate : '';
            vm.detailFYFromDate = resp.data.yearFromDate ? resp.data.yearFromDate : '';
            vm.details = true;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        folioNo: vm.cancelFolio,
        registrationNo: vm.registrationNo
      };
      InvestorService.post({
        child1: 'form15gh',
        child2: 'detail'
      }, payload).$promise.then(success, error);
    }

    vm.cancelRegistration = function () {
      var success = function () {
        var successFn = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              MessageService.success(vm.VALIDATE_DATA.CANCEL_SUCCESS);
            } else {
              MessageService.error(resp.message);
            }
          },
          errorFn = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        LoaderService.showLoader();
        var payload = {
          folioNo: vm.cancelFolio,
          registrationNo: vm.registrationNo,
          fyFromDate: vm.detailFYFromDate,
          fyToDate: vm.detailFYToDate
        };
        InvestorService.post({
          child1: 'form15gh',
          child2: 'registration',
          child3: 'cancel',
        }, payload).$promise.then(successFn, errorFn);
        vm.close();
      };
      var msg = "Are you sure you want to cancel the registration?";
      ModalService.confirmCancelModal({Text: msg}, success);
    }

    vm.changeTax = function (value) {
      if (value) {
        vm.taxable = true;
        vm.nonTaxable = false;
      } else {
        vm.taxable = false;
        vm.nonTaxable = true;
      }
    }

    vm.changeDeclarationPopUp = function () {
      if (!vm.declarationPopUp) {
        vm.showDeclarationSuccessPopup();
        vm.declarationPopUp = true;
      }
    }

    vm.showDeclarationSuccessPopup = function () {
      if (!vm.folioNumber) {
        return;
      }
      angular.forEach(vm.folioList, function (el) {
        if (el.folioNumber === vm.folioNumber) vm.investorName = el.investorName;
      });
      var data = {
        "InvestorName": vm.investorName ? vm.investorName : '',
        "lastDateFY": vm.lastDateOfCFY,
        "FY": vm.assessmentYear
      };
      ModalService.declarationModal(data);
    };

    vm.resetDeclaration = function () {
      vm.folioNumber = null;
      vm.category = null;
      vm.declarationYear = null;
      vm.estimatedIncome = null;
      vm.totalIncome = null;
      vm.declaration = false;
      vm.declarationPopUp = false;
      vm.taxable = false;
      vm.nonTaxable = !vm.taxable;
      vm.formValidationError = false;
      vm.formValidationMessage = "";
      vm.dobError = false;
      $scope.form.$setPristine();
      $scope.form.$setUntouched();
    }

    vm.close = function () {
      vm.details = false;
      vm.declarationSubmit = false;
      vm.registrationNo = null;
      vm.cancelFolio = null;
      vm.folioSubmit = true;
      $scope.cancelForm.$setPristine();
      $scope.cancelForm.$setUntouched();
    }

    vm.resetFolio = function () {
      vm.selectedFolio = vm.folioList.filter(function(list) {
        return list.folioNumber === vm.folioNumber;
      });
      if (vm.selectedFolio.length > 0 && vm.selectedFolio[0].dobErrorMessage) {
        MessageService.error(vm.selectedFolio[0].dobErrorMessage);
        vm.dobError = true;
      } else {
        vm.dobError = false;
      }
      vm.category = null;
      vm.declarationYear = null;
      vm.estimatedIncome = null;
      vm.totalIncome = null;
      vm.declaration = false;
      vm.declarationPopUp = false;
      vm.taxable = false;
      vm.nonTaxable = !vm.taxable;
      vm.formValidationError = false;
      vm.formValidationMessage = "";
      $scope.form.$setPristine();
    };

    vm.verifyFormDeclaration = function () {
      var selectedFormType = vm.selectedFolio[0].formType;
      if (selectedFormType && vm.category !== selectedFormType) {
        vm.formValidationError = true;
        if (vm.category === "FORM 15G") {
          vm.formValidationMessage = vm.VALIDATE_DATA.VALIDATION_15G;
        } else if (vm.category === "FORM 15H") {
          vm.formValidationMessage = vm.VALIDATE_DATA.VALIDATION_15H;
        }
      } else {
        vm.formValidationError = false;
        vm.formValidationMessage = "";
      }
    };

  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AddFolioController', addFolioController);

  /** @ngInject */
  function addFolioController($window, $state, $scope, AppConstants, MessageService, InvestorService, InvestorFolioModel,
                              UtilService, AuthService, LoaderService, $stateParams, InvestorFileUploadService, InvestorServiceV3, ModalService) {
    var vm = this;
    vm.defaultMinorDob = $window.moment().toString();
    vm.defaultsoleApplicantNWDate = $window.moment().toString();
    vm.countryList = [];
    vm.occupationList = [];
    vm.incomeSlabList = [];
    vm.taxStatusList = [];
    vm.taxIdTypeList = [];
    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.POLITICAL_STATUS = AppConstants.INVESTOR_POLITICAL_STATUS;
    vm.currentNominee = 0;
    vm.defaultDob = $window.moment().toString();
    vm.changePayTaxOutsideIndiaStatus = changePayTaxOutsideIndiaStatus;
    vm.changeMinorStatus = changeMinorStatus;
    vm.addMoreTaxResidency = addMoreTaxResidency;
    vm.submitSoleApplicantDetails = submitSoleApplicantDetails;
    vm.uploadMinorDobFile = uploadMinorDobFile;
    vm.uploadMinorRelationshipFile = uploadMinorRelationshipFile;
    vm.saveFolio = saveFolio;
    vm.changedTaxStatus = changedTaxStatus;
    vm.isSoleApplicantMinor = false;
    vm.fatcaArray = [];
    vm.minorAgeProof = null;
    vm.minDate = $window.moment().subtract(1, 'years').toString();
    vm.minDateMinor = $window.moment().subtract(18, 'years').toString();
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.ageProofDocUrl = '';
    vm.chooseAFile = true;
    vm.genderList = [{name: 'Male', value: 'MALE'}, {name: 'Female', value: 'FEMALE'}];
    vm.relationshipList = [{name: 'Father', value: 'FATHER'}, {name: 'Mother', value: 'MOTHER'}, {
      name: 'Sibling',
      value: 'SIBLING'
    }, {name: 'Other', value: 'OTHER'}];
    vm.ekycEmail = null;
    vm.ekycMobile = null;
    vm.emailBelongsTo = null;
    vm.mobileBelongsTo = null;

    var masterPayload = {};

    masterPayload = InvestorFolioModel.getInvestorFolioFormDataModel() || InvestorFolioModel.getNewInvestorFolioModel();// InvestorFolioModel.getInvestorFolioModel() || InvestorFolioModel.getNewInvestorFolioModel();vm.formData = masterPayload.soleApplicantDetail;
    // vm.formData.holdmode = masterPayload.holdmode;
    var token = AuthService.getToken();
    vm.back = back;

    vm.init = function () {
      $window.scrollTo(0, 0);
      var id = localStorage.getItem('folioId');
      // var currentState = $state.current ? $state.current.name : '';
      if (id && !$stateParams.isBack && $stateParams.investorId) {
        localStorage.removeItem('folioId');
        // localStorage.removeItem('wantToAddNomineeLater');
      }


      switch ($state.current.name) {
        case 'main.investors.add':
        case 'agent.home.investors.add':
          break;
      }
      //getSavedFolioByUUID();

        getPayload(function () {
          setHeader();
          /*getTaxStatusList();
          getInvestorOccupationList();
          incomeSlab();
          getCountryList();
          getTaxIdTypeList();
          getAddressType();*/
        });
    };

    // vm.init();


    function setHeader() {
      var profile = token;
      if (profile) {
        $scope.MainFolioParent.panNumber = profile.investorPAN;
        $scope.MainFolioParent.firstName = profile.investorFName;
        $scope.MainFolioParent.middleName = profile.investorMName;
        $scope.MainFolioParent.lastName = profile.investorLName;
        vm.guardianName = $scope.MainFolioParent.firstName + ' ' + ($scope.MainFolioParent.lastName || '');
        $scope.MainFolioParent.currentState = 'main.folio.holdmode';
      } else {
        $state.go('login');
      }
    }


    function uploadMinorDobFile(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.formData.minorAgeProof = resp.data.fileUrl;
                vm.formData.id = resp.data.uuid;
                localStorage.setItem('folioId', resp.data.uuid);
                breakFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            // DistributorProfileUploadService.post({
            var uuid = '';
            if ($stateParams.investorId) {
              uuid = $stateParams.investorId;
            } else if (localStorage.getItem('folioId')) {
              uuid = localStorage.getItem('folioId');
            } else {
              uuid = 'null';
            }

            InvestorFileUploadService.post({
              child1: 'folio',
              child2: 'minor',
              child3: 'ageProof',
              child4: 'upload',
              child5: uuid
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function uploadMinorRelationshipFile(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.formData.minorRelationshipProof = resp.data.fileUrl;
                vm.formData.id = resp.data.uuid;
                localStorage.setItem('folioId', resp.data.uuid);

                breakRelationshipFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            var uuid = '';
            if ($stateParams.investorId) {
              uuid = $stateParams.investorId;
            } else if (localStorage.getItem('folioId')) {
              uuid = localStorage.getItem('folioId');
            } else {
              uuid = 'null';
            }

            // DistributorProfileUploadService.post({
            InvestorFileUploadService.post({
              child1: 'folio',
              child2: 'relationship',
              child3: 'proof',
              child4: 'upload',
              child5: uuid
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function breakFileUrl(url) {
      if(!url){return;}
      vm.ageProofDocUrl = 'Preview Uploaded Doc';
      vm.chooseAFile = false;
      return;
      /*url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      vm.formData.minorAgeProof = a[a.length - 1] + extension;
      // vm.chooseAFile = false;*/

    }

    function breakRelationshipFileUrl(url) {
      if(!url){return;}
      vm.relationshipDocUrl = 'Preview Uploaded Doc';
      vm.chooseARelationshipFile = false;
      return;
      /*url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      vm.formData.minorRelationshipProof = a[a.length - 1] + extension;
      // vm.chooseARelationshipFile = false;*/

    }

    vm.openUploadedDoc = function (url) {
      if(angular.isUndefined(url)){return;}
      ModalService.showImage({docUrl: url});
      // window.open(vm.payload.bankDetails.chequeLeaf);
    }

    vm.addNewResidencyFields = function () {

      vm.fatcaArray.push(
        {
          "taxPayingCountry": '',
          "taxPayingCity": '',
          "taxIdType": '',
          "taxId": ''
        });
    };

    function addAvailableResidency(fatca) {
      vm.formData.fatcaArray=[];
      if (fatca.fatcaTax1) {
        vm.formData.fatcaArray.push(fatca.fatcaTax1);
      }
      if (fatca.fatcaTax2) {
        vm.formData.fatcaArray.push(fatca.fatcaTax2);
      }
      if (fatca.fatcaTax3) {
        vm.formData.fatcaArray.push(fatca.fatcaTax3);
      }
      if(vm.formData.payTaxInIndia == false && vm.formData.fatcaArray.length ===0){
        vm.formData.fatcaArray.push({});
      }
    }

    vm.setSelectedResidency = function (payload) {
      if (payload.guardianDetail && !payload.guardianDetail.fatca) {
        payload.guardianDetail.fatca = {};
      }
      var fatca = payload.guardianDetail.fatca;

      delete fatca.fatcaTax1;
      delete fatca.fatcaTax2;
      delete fatca.fatcaTax3;

      if (payload.guardianDetail.payTaxInIndia) {
        return;
      }

      if (vm.fatcaArray[0]) {
        fatca.fatcaTax1 = vm.fatcaArray[0];
      }

      if (vm.fatcaArray[1]) {
        fatca.fatcaTax2 = vm.fatcaArray[1];
      }

      if (vm.fatcaArray[2]) {
        fatca.fatcaTax3 = vm.fatcaArray[2];
      }

    }

    vm.deleteTaxResidencyFromFatca = function (index) {
      vm.fatcaArray.splice(index, 1);
    }

    function getTaxStatusList() {
      if (vm.formData.minor) {
        var data = {taxStatusFilter: 'MINOR'};
      } else {
        data = {taxStatusFilter: 'ADULT'};
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusList = resp.data.taxStatus;
          vm.formData.taxStatusCode= vm.taxStatusList.length && vm.taxStatusList.length >0
          ?vm.taxStatusList[0].taxStatusCode //to select the first element in the list
          :'';
          // if (vm.taxStatusList.length && vm.taxStatusList.length < 2) {
          //   vm.formData.taxStatusCode = vm.taxStatusList[0].taxStatusCode;
          //            }
        } else {
          vm.taxStatusList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.taxStatusList = null;
      };
      InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);

    }

    /*function getInvestorOccupationList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.occupationList = resp.data.investorOccupations;
        } else {
          vm.occupationList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.occupationList = null;
      };
      InvestorService.get({child1: 'folio', child2: 'occupation'}).$promise.then(success, error);
    }*/

    /*function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.incomeSlabList = resp.data.incomeSlabList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
        };

      InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success, error);
    }*/

    function getPayload(cb) {
      cb = cb || function () {};

      if (localStorage.getItem('folioId')||$stateParams.investorId) {

        var success = function (resp) {
            if (resp.status && resp.data) {
              var isFolioSelected = masterPayload.isFolioSelected || sessionStorage.getItem('isFolioSelected') === 'true'? true: false;
              var kycContact = JSON.parse(sessionStorage.getItem('kycContact'));
              if (isFolioSelected) {
                vm.ekycEmail = masterPayload.soleApplicantDetail.personalDetail.email ? masterPayload.soleApplicantDetail.personalDetail.email : kycContact.email;
                vm.ekycMobile = masterPayload.soleApplicantDetail.personalDetail.mobileNo ? masterPayload.soleApplicantDetail.personalDetail.mobileNo : kycContact.mobileNo;
              } else {
                vm.ekycEmail = resp.data.soleApplicantDetail.personalDetail.email;
                vm.ekycMobile = resp.data.soleApplicantDetail.personalDetail.mobileNo;
              }
              masterPayload = resp.data;
              masterPayload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
              $scope.MainFolioParent.holdmode = resp.data.holdmode;
              vm.nomineesResp = resp.data.nominees || [];
              vm.emailBelongsTo = resp.data.soleApplicantDetail.personalDetail.emailBelongsTo;
              vm.mobileBelongsTo = resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo;
              if (angular.isDefined(resp.data.minor) && resp.data.minor) {
                prepareGuardianDetailFormData(resp.data);
                $scope.MainFolioParent.isSoleApplicantMinor = true;
                vm.status = localStorage.getItem('type');
              } else {
                prepareSoleApplicantFormData(resp.data);
                vm.status = localStorage.getItem('type');
              }
              vm.formData.holdmode = resp.data.holdmode;
              if(resp.data.jointHolders && resp.data.jointHolders.length>0){
              vm.formData.jointHolders = resp.data.jointHolders;
              }
              //setDefaultValues();
              LoaderService.hideLoader();
              cb();
            } else {
              MessageService.error(resp.message);
              LoaderService.hideLoader();
              cb();
            }
          },
          error = function () {
            LoaderService.hideLoader();
            cb();
          };

        var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
        InvestorServiceV3.post({
          child1: 'folio',
          child2: 'getDetails'
        },{id:investorId}).$promise.then(success, error);
      }else{
        cb();
      }

    }

    function prepareSoleApplicantFormData(data) {
      var d = data.soleApplicantDetail;
      vm.formData = {
        "firstName": d.selfDetail && d.selfDetail.personalDetail?d.personalDetail.firstName:'',
        "lastName": "",
        "dateOfBirth": d.personalDetail?d.personalDetail.dateOfBirth:'',
        "email": "",
        "minor": !d.minor ? false : d.minor,
        "taxStatusCode": d.personalDetail.taxStatusCode,
        "occupation": d.selfDetail.occupation,
        "panNumber": d.selfDetail.panNumber,
        "grossAnnualIncome": d.selfDetail.grossAnnualIncome,
        "netWorth": d.selfDetail.netWorth,
        "netWorthDate": d.selfDetail.netWorthDate,
        "politicalStatus": d.selfDetail.politicalStatus||vm.POLITICAL_STATUS.NONE,
        "payTaxInIndia": d.selfDetail.fatca.payTaxInIndia,
        "fatcaAddressType": d.selfDetail.fatca.addressType,
        "birthCountry": d.selfDetail.fatca.birthCountry,
        "birthCity": d.selfDetail.fatca.birthPlace,
        "updatedFieldType" : d.personalDetail? d.personalDetail.updatedFieldType: null
      };

      if (data.hasOwnProperty('sebiNomineeRegulatory01650Active')) {
        vm.formData.sebiNomineeRegulatory01650Active = data.sebiNomineeRegulatory01650Active;
        vm.formData.nomineeLimit = data.nomineeLimit;
      }
      if(vm.formData.netWorth){
        $window.NumToWord(vm.formData.netWorth, 'DisplayWordsTaxAmt', vm);
      }
      addAvailableResidency(d.selfDetail.fatca);
    }


    function prepareGuardianDetailFormData(data) {
      var rData = data;
      var d = data.soleApplicantDetail.minorDetail.guardian;
      var s = data.soleApplicantDetail;
      vm.formData = {
        "holdmode":rData.holdmode,
        "firstName": s.personalDetail?s.personalDetail.firstName:'',
        "lastName": "",
        "dateOfBirth": s.personalDetail?s.personalDetail.dateOfBirth:'',
        "email": "",
        "gender": s.personalDetail?s.personalDetail.gender:'',
        "minor": !rData.minor ? false : rData.minor,
        "taxStatusCode": s.personalDetail.taxStatusCode,
        "occupation": d.occupation,
        "panNumber": d.panNumber,
        "relationship": d.relation,
        "grossAnnualIncome": d.grossAnnualIncome,
        "netWorth": d.netWorth,
        "netWorthDate": d.netWorthDate,
        "politicalStatus": d.politicalStatus||vm.POLITICAL_STATUS.NONE,
        "payTaxInIndia": d.fatca?d.fatca.payTaxInIndia:true,
        "fatcaAddressType": d.fatca.addressType,
        "birthCountry": d.fatca.birthCountry,
        "birthCity": d.fatca.birthPlace,
        "minorAgeProofUrl": s.minorDetail && s.minorDetail.minorAgeProof,
        "minorRelationshipProofUrl": s.minorDetail && s.minorDetail.minorRelationshipProof,
        "minorProofType": s.minorDetail && s.minorDetail.minorProofType,
        "minorRelationshipProofType": s.minorDetail && s.minorDetail.minorRelationshipProofType
      };
      breakFileUrl(s.minorDetail.minorAgeProof);
      breakRelationshipFileUrl(s.minorDetail.minorRelationshipProof);
      addAvailableResidency(d.fatca);
    }

    vm.changeDob = function (date) {

      if (!date) {
        return;
      }
      // vm.defaultDob = date.toString();
      vm.formData.minorDob = date.clone().format('DD-MMM-YYYY').toString();
    };

    vm.changeMinorDob = function (date) {
      if (!date) {
        vm.defaultMinorDob = null;
        vm.formData.dateOfBirth = null;
        return;
      }
      vm.defaultMinorDob = date.toString();
      vm.formData.dateOfBirth = date.clone().format('DD-MMM-YYYY').toString();
    };

    vm.changeStartDate = function (date) {
      if (!date) {
        return;
      }
      vm.formData.netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
    }

    /*function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
    }

    function getTaxIdTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdTypeList = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxIdTypeList = null;
      };
      InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success, error);
    }

    function getAddressType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.addressTypeList = resp.data.addressTypeResponses;
        } else {
          vm.addressTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.addressTypeList = null;
      };
      InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success, error);
    }*/

    function changePayTaxOutsideIndiaStatus(status) {
      if (!status) {
        return;
      }
      if (vm.formData.minor) {
        if (vm.formData && vm.fatcaArray.length === 0) {
          vm.addNewResidencyFields();
        }
      }
      else {
        if (vm.formData && (vm.formData.payOutsideIndiaAddresses == undefined || vm.formData.payOutsideIndiaAddresses.length === 0)) {
          vm.formData.payOutsideIndiaAddresses = [];
          addMoreTaxResidency();
        }
      }
    }

    /*
     vm.selectPayTaxOutsideIndia = function () {
     if(vm.fatcaArray.length===0){
     addMoreTaxResidency();
     }
     }*/

    vm.deleteTaxResidency = function (index) {
      vm.formData.payOutsideIndiaAddresses.splice(index, 1);
    }

    function addMoreTaxResidency() {
      var array = vm.formData.payOutsideIndiaAddresses || [];
      array.length < 4 ? array.push({}) : '';

    }

    function submitSoleApplicantDetails() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          MessageService.success(resp.data.message);
          //InvestorFolioModel.setInvestorModel(vm.formData);
          masterPayload.soleApplicantDetail = angular.copy(vm.formData);
          InvestorFolioModel.setInvestorFolioModel(masterPayload);
          $state.go('main.folio.bankdetails');
        } else {
          vm.formData.soleApplicantDetail = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        // vm.formData.soleApplicantDetail = null;
      };
      InvestorService.post({child1: 'folio', child2: 'createNewFolio'}, null).$promise.then(success, error);
    }

    function saveFolio(stateToMove) {
      LoaderService.showLoader();
      if (vm.formData.minor) {
        var payload = getGuardianPayload();
      } else {
        payload = getSoleApplicantPayload();
      }
      // payload.holdmode = "SINGLE";//HARD CODED FROM BOTH END (FRONT N BACK END)

      if (payload) {
        payload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
        payload.saveStep = 2;
      }

      var success = function (resp) {
        if (resp.status && resp.data) {
          localStorage.setItem('folioId', resp.data.id);
          masterPayload.soleApplicantDetail = angular.copy(vm.formData);
          InvestorFolioModel.setInvestorFolioModel(masterPayload);
          $window.sessionStorage.investorForm = angular.toJson(masterPayload);
          if (stateToMove) {
            // $scope.MainFolioParent.uuid = resp.data.id;
            LoaderService.hideLoader();
            if ($stateParams.investorId) {
              $state.go(stateToMove, {investorId: $stateParams.investorId});
            } else {
              $state.go(stateToMove);
            }
          }else MessageService.success('Saved Successfully.');
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      InvestorService.post({child1: 'folio', child2: 'saveFolio'}, payload).$promise.then(success, error);
    }

    function back(from) {
      saveFolio('main.folio.holdmode', from);
    }

    /*function prepareFatcaRemainingProps(payload) {
      payload.fatca.birthCountry = payload.birthCountry;
      payload.fatca.birthPlace = payload.birthPlace;
      payload.fatca.addressType = payload.addressType;
      payload.fatca.payTaxInIndia = payload.payTaxInIndia;
      var prop;
      for (prop in payload) {
        if (prop == 'birthCountry' || prop == 'birthPlace' || prop == 'addressType' || prop == 'payTaxInIndia') {
          delete payload[prop];
        }
      }
    }


    function prepareSoleApplicantDetail(obj) {
      var prop;
      for (prop in obj) {
        if (prop != 'personalDetail' && prop != 'taxStatusCode' && prop != 'minor' && prop != 'minorAgeProof') {
          delete obj[prop];
        }
      }
    }*/


    vm.setMinorFlag = function () {
      var minorVal = vm.formData.minor;
      if (minorVal) {
        $scope.MainFolioParent.isSoleApplicantMinor = true;
      } else {
        $scope.MainFolioParent.isSoleApplicantMinor = false;
      }
      vm.formData = InvestorFolioModel.getNewInvestorFolioFormDataModel();
      vm.formData.holdmode = $scope.MainFolioParent.holdmode;
      vm.formData.minor = minorVal;
      vm.formData.bankDetails = {};
      vm.nomineesResp = [];
      vm.ageProofDocUrl = '';
      vm.relationshipDocUrl = '';
      getTaxStatusList();
      vm.formData.payTaxInIndia = true;
      vm.formData.politicalStatus = vm.POLITICAL_STATUS.NONE;
    };

    vm.continue = function () {
      if (vm.formData.holdmode === vm.pattern.INVESTOR_HOLD_MODE.AOS) {
        saveFolio('main.folio.jointholders');
      }else if (vm.formData.minor) {
        saveFolio('main.folio.bankdetails');
      } else {
        saveFolio('main.folio.nominee');
      }
    };

    function changeMinorStatus() {
      $scope.FolioAddParent.isSoleApplicantMinor = vm.formData.minor;
    }

    function getSoleApplicantPayload() {
      var a = vm.formData;
      var payload = {
        "soleApplicantDetail": {
          "personalDetail": {
            "firstName": a.firstName,
            "lastName": "",
            "dateOfBirth": a.dateOfBirth,
            "email": ""
          },
          "taxStatusCode": a.taxStatusCode,
          "fatcaAddressType": a.fatcaAddressType,
          "birthCountry": a.birthCountry,
          "birthCity": a.birthCity,
          "occupation": a.occupation,
          "panNumber": $scope.MainFolioParent.panNumber,
          "grossAnnualIncome": a.grossAnnualIncome || "",
          "netWorth": a.netWorth || "",
          "netWorthDate": a.netWorthDate || "",
          "politicalStatus": a.politicalStatus,
          "payTaxInIndia": a.payTaxInIndia,
          "payOutsideIndiaAddresses": a.payOutsideIndiaAddresses,
          "minor": a.minor
        },
        "jointHolders": [],
        "nominees": vm.nomineesResp || [],
        "guardianDetail": null,
        "brokerCode": null,
        "holdmode": a.holdmode,
        "saveStep": null,
        "id": null,
        "newFolioComplete": null
      };

      return payload;
    }

    function getGuardianPayload() {
      var a = vm.formData;
      var payload = {
        "holdmode":$scope.MainFolioParent.holdmode,
        "soleApplicantDetail": {
          "personalDetail": {
            "firstName": a.firstName,
            "lastName": "",
            "dateOfBirth": a.dateOfBirth,
            "email": "",
            "gender": a.gender
          },
          "taxStatusCode": a.taxStatusCode,
          "minor": a.minor,
          "minorAgeProof": a.minorAgeProof,
          "minorRelationshipProof": a.minorRelationshipProof
        },
        "jointHolders": [],
        "nominees": [],
        "guardianDetail": {
          "fatca": {
            "birthCountry": a.birthCountry,
            "birthPlace": a.birthCity,
            "addressType": a.fatcaAddressType,
            "payTaxInIndia": a.payTaxInIndia
          },
          "occupationCode": a.occupation,
          "panNumber": $scope.MainFolioParent.panNumber,
          "income": a.grossAnnualIncome || "",
          "netWorth": a.netWorth || "",
          "netWorthDate": a.netWorthDate || "",
          "pepStatus": a.politicalStatus,
          "relation": a.relationship
        }
      };
      vm.setSelectedResidency(payload);
      return payload;
    }

    function changedTaxStatus(){
      if(vm.formData.taxStatusCode == '21'){
        vm.formData.payTaxInIndia = false;
        vm.changePayTaxOutsideIndiaStatus(true);
      }
      else {
        vm.formData.payTaxInIndia = true;
      }
    }

    /*function resetNumInWords() {
      vm.amountInWords = '';
      var inWordsDiv = $window.document.getElementById('DisplayWordsTaxAmt');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
    }*/

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AddFolioReviewController', addFolioReviewController);

  /** @ngInject */
  function addFolioReviewController($stateParams, $window, ModalService, AppConstants, $state, MessageService, InvestorService, $log,$scope,
                                     LoaderService,AuthService, InvestorFileUploadService, UtilService, InvestorServiceV3) {
    var vm = this;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.pattern = AppConstants;
    vm.accModelDirty = false;
    vm.formData = {};
    vm.reviewModalData = {};
    vm.verifyAccountNumber ='';
    vm.chooseAFile = true;
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp","application/pdf"];
    vm.chequeLeafUrl = '';
    vm.savePayload = savePayload;
    vm.selfDeclaration = selfDeclaration;
    vm.getCountryNameByCode = getCountryNameByCode;
    vm.getTaxStatusNameByCode = getTaxStatusNameByCode;
    var taxStatusCode = '';
    if(localStorage.getItem('isDreamSip')){
      setHeader();
    }
    vm.init = function () {
      $window.scrollTo(0, 0);
      LoaderService.showLoader();
      setHeader();

      getPayload(function (status) {
        if(status){
          bankNameList();
          getTaxStatusList();
          getInvestorOccupationList();
          incomeSlab();
          getCountryList();
          getTaxIdTypeList();
          getAddressType();
          getAcccountType();
          getPayoutMechanism();
        }
      });
    };

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.MainFolioParent.panNumber = profile.investorPAN;
      $scope.MainFolioParent.firstName = profile.investorFName;
      $scope.MainFolioParent.lastName = profile.investorLName;
      $scope.MainFolioParent.currentState = 'main.folio.bankdetails';

    }

    function getPayload(cb) {
      cb = cb || function () {};
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.formData = resp.data;
            $scope.MainFolioParent.holdmode = resp.data.holdmode;
            if(vm.formData.bankDetails && !vm.formData.bankDetails.bankHolderType){
              vm.formData.bankDetails.bankHolderType = 'MINOR';
            }
            if(vm.formData.bankDetails && vm.formData.bankDetails.chequeLeaf){
              breakFileUrl(vm.formData.bankDetails.chequeLeaf);
            }
            if(vm.formData.soleApplicantDetail && vm.formData.soleApplicantDetail.minor){
              $scope.MainFolioParent.isSoleApplicantMinor = true;
            }

            taxStatusCode = vm.formData.soleApplicantDetail.taxStatusCode;
            LoaderService.hideLoader();
            cb(true);
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
            cb(false);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
          cb(false);
        };

      // InvestorService.get({child1: 'folio', child2: 'getSavedFolio', child3:localStorage.getItem('folioId')}).$promise.then(success, error);

      var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'getDetails'
      },{id:investorId}).$promise.then(success, error);
    }

    function bankNameList() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'bank-list'}).$promise.then(success, error);
    }
    var bankTypeList = [];
    function getAcccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            bankTypeList = resp.data.bankAccountTypes;
            if(bankTypeList.length && bankTypeList.length >0){
              if(taxStatusCode == "01"){
                bankTypeList&&bankTypeList.length>3 && (!vm.formData.bankDetails.accountType || vm.formData.bankDetails.accountType==="NRE" )?
                  vm.formData.bankDetails.accountType=bankTypeList[3].accountTypeCode
                  :''
              } else{
                bankTypeList&&bankTypeList.length>0?
                  vm.formData.bankDetails.accountType=bankTypeList[0].accountTypeCode
                  :''
              }
              vm.reviewModalData.accountType = getAccountNameByCode(vm.formData.bankDetails.accountType);
              //to set the default value of account type field as per the requirement
            }

          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };

      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4: taxStatusCode
      }).$promise.then(success, error);
    }

    function getAccountNameByCode(accCode) {
      if(!accCode || bankTypeList.length<1)return"";
      var bankTypeData  = bankTypeList.find(function (ele) {
        return ele.accountTypeCode == accCode;
      });
      return bankTypeData ?bankTypeData.accountType:'';
    }

    var taxStatusList =[];
    function getTaxStatusList() {
      if (vm.formData.minor) {
        var data = {taxStatusFilter: 'MINOR'};
      } else {
        data = {taxStatusFilter: 'ADULT'};
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          taxStatusList = resp.data.taxStatus;
          var taxData = taxStatusList.find(function (ele) {
            return ele.taxStatusCode == vm.formData.soleApplicantDetail.taxStatusCode;
          });
          vm.reviewModalData.taxStatusDescription = taxData?taxData.taxStatusDescription:'';
        } else {
          MessageService.error(resp.message);
        }
      }, error = function () {
      };
      InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
    }


    function getTaxStatusNameByCode(taxCode) {
      if(!taxCode || taxStatusList.length<1)return"";
      var taxData  = taxStatusList.find(function (ele) {
        return ele.taxStatusCode == taxCode;
      });
      return taxData ?taxData.taxStatusDescription:'';
    }

    function getInvestorOccupationList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          var occupationList = resp.data.investorOccupations;
          var occupationData  = occupationList.find(function (ele) {
            return ele.occupationCode == vm.formData.soleApplicantDetail.occupation;
          });
          vm.reviewModalData.occupationDescription = occupationData ?occupationData .occupationDescription:'';
        }
      };
      InvestorService.get({child1: 'folio', child2: 'occupation'}).$promise.then(success);
    }

    function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            incomeSlabData = resp.data.incomeSlabList;
            var incomeSlabData  = incomeSlabData.find(function (ele) {
              return ele.incomeCode == vm.formData.soleApplicantDetail.incomeCode;
            });
            vm.reviewModalData.incomeDescription = incomeSlabData ?incomeSlabData .incomeDescription:'';
          } else {
            MessageService.error(resp.message);
          }
        };

      InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success);
    }

    var countryList = [];
    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          countryList = resp.data.countries;
          var countryData  = countryList.find(function (ele) {
            return ele.countryCode == vm.formData.soleApplicantDetail.birthCountry;
          });
          vm.reviewModalData.birthCountry = countryData ?countryData.countryName:'';
        }
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success);
    }

    function getTaxIdTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          var taxIdTypeList = resp.data.taxIdTypeResponses;
          var taxIdTypeData  = taxIdTypeList.find(function (ele) {
            return ele.value == vm.formData.value;
          });
          vm.reviewModalData.description = taxIdTypeData?taxIdTypeData.description:'';
        }
      };
      InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success);
    }


    function getAddressType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          var addressTypeList = resp.data.addressTypeResponses;
          var addressTypeData  = addressTypeList.find(function (ele) {
            return ele.value == vm.formData.value;
          });
          vm.reviewModalData.addressDescription = addressTypeData?addressTypeData.addressDescription:'';
        }
      };
      InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success);
    }


    function getPayoutMechanism() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            var payoutMechanismList = resp.data.payoutMechanisms;
            var payoutMechanismData  = payoutMechanismList.find(function (ele) {
              return ele.payoutCode == vm.formData.bankDetails.payoutMechanism;
            });
            vm.reviewModalData.payoutDescription = payoutMechanismData?payoutMechanismData.payoutDescription:'';
          }
        };

      InvestorService.get({child1: 'folio', child2: 'payout-mechanism'}).$promise.then(success);
    }


    function getCountryNameByCode(countryCode) {
    if(!countryCode || countryList.length<1)return"";
      var countryData  = countryList.find(function (ele) {
        return ele.countryCode == countryCode;
      });
      return countryData ?countryData.countryName:'';
    }



    vm.accFocus = function () {
      vm.accModelDirty = true;
    };

    vm.copyPasteHandler=function (e) {

      var key = e.keyCode?e.keyCode:e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if ( key == 86 && ctrl ) {
        e.preventDefault();
      } else if ( key == 67 && ctrl ) {
        e.preventDefault();
      }
    };

    vm.done = function () {
      savePayload('main.folio.review');
    };

    vm.save =  function(){
      savePayloadBankDetails('');
    };

    vm.back = function () {
      if(vm.formData.soleApplicantDetail.minor){
        // localStorage.setItem('type', 'minor');
        savePayload('main.folio.soleApplicant');
        // $state.go('main.folio.soleApplicant');
      } else {
        // localStorage.setItem('type', 'self');
        savePayload('main.folio.nominee');
        //$state.go('main.folio.nominee');
      }
    }

    function savePayloadBankDetails(stateToMove) {
      LoaderService.showLoader();
      if(vm.formData){
        vm.formData.newFolioComplete = false;
        vm.formData.id = localStorage.getItem('folioId');
      }
      saveDetails(stateToMove);

    }

    function savePayload(stateToMove) {
      LoaderService.showLoader();
      if(vm.formData){
        if(!stateToMove){
          vm.formData.newFolioComplete = true;
        } else {
          vm.formData.newFolioComplete = false;
        }
        vm.formData.id = localStorage.getItem('folioId');
      }
      if(vm.formData.newFolioComplete){
        completeFolio(stateToMove);
      } else {
        saveDetails(stateToMove);
      }
    }

    function completeFolio(stateToMove) {
      var success = function (resp) {
          if (resp.status && resp.data) {
            if(stateToMove){
              LoaderService.hideLoader();
              $state.go(stateToMove,{isBack:true});
            } else {
              LoaderService.hideLoader();
              $scope.MainFolioParent.bankDetailSuccess = true;
              showPopUp(resp.data);
            }
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('Occupation Errror>>>>', err);
        };
      if(vm.formData && vm.formData.bankDetails && vm.formData.bankDetails.payoutMechanism){
        // delete vm.formData.bankDetails.verifyAccountNumber;
        delete vm.formData.bankDetails.payoutMechanism.micrMandatory;
        delete vm.formData.bankDetails.payoutMechanism.payoutDescription;
      }
      vm.formData.saveStep = 5;
      InvestorService.post({child1: 'folio', child2: 'createNewFolio'}, vm.formData).$promise.then(success, error);
    }

    function saveDetails (stateToMove) {
      LoaderService.showLoader();
      (stateToMove==='main.folio.nominee')&&(vm.formData.saveStep = 4);
      (stateToMove==='main.folio.nominee')&&(vm.formData.saveStep = 2);
      (stateToMove==='main.folio.review')&&(vm.formData.saveStep = 5);
      /*if(vm.formData.minor){
        var formData = getGuardianPayload();

      } else {
        var formData = getSoleApplicantPayload();
      }*/
      // var formData = getRefinedPayload();
      /*if(vm.formData){
        vm.formData.id = $stateParams.investorId? $stateParams.investorId : $scope.MainFolioParent.uuid;
      }*/

      var success = function (resp) {
        if (resp.status && resp.data) {
          localStorage.setItem('folioId', resp.data.id);
          $scope.MainFolioParent.uuid = resp.data.id;
          if(stateToMove){
            // $scope.MainFolioParent.uuid = resp.data.id;
            LoaderService.hideLoader();
            $state.go(stateToMove,{isBack:true});

          }
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      InvestorService.post({child1: 'folio', child2: 'saveFolio'}, vm.formData).$promise.then(success, error);
    }

    function showPopUp(data) {
      var successModal = function () {
          // delete $window.sessionStorage.investorForm;
          $window.sessionStorage.removeItem("investorForm");
          $state.go('welcome')
        },
        errorModal = function (err) {
          if(err!=null){
            MessageService.error(err)
          }
        };
      data = data ||{};
      data.holdmode = vm.formData.holdmode;/////////////////////////
      ModalService.folioCreationSuccessModal(data, successModal, errorModal);
    }

    function selfDeclaration(data) {
      var successModal = function () {
          $state.go('login')
        },
        errorModal = function (err) {
          if(err!=null){
            MessageService.error(err)
          }
        };
      ModalService.selfDeclarationModal(data, successModal, errorModal);
    }

    function uploadChequeLeafFile(file) {

      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if(file){
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.formData.bankDetails.chequeLeaf = resp.data.fileUrl;

                breakFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader(err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            // DistributorProfileUploadService.post({

            InvestorFileUploadService.post({
              child1:'folio',
              child2: $scope.MainFolioParent.uuid,
              child3: 'bankDetails',
              child4: 'chequeLeaf',
              child5: 'upload'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function breakFileUrl(url) {

      url = url.replace(/ /g,'');
      var a, extension;
      if(url.split('.jp').length > 1){
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if(url.split('.png').length > 1){
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if(url.split('.pdf').length > 1){
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if(url.split('.bmp').length > 1){
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      } else if(url.split('.tiff').length > 1){
        extension = '.tiff';
        a = url.split('.tiff')[0].split('/');
      }

      if(angular.isUndefined(extension)){
        MessageService.error("Given cheque Leaf file type is not allowed, Pleaese provide a different file type.")
        vm.chequeLeafUrl = "";
      }else{
        vm.chequeLeafUrl = a[a.length-1]+extension;
      }
      vm.chooseAFile = false;

    }

    vm.openUploadedDoc = function() {
      // window.open(vm.formData.bankDetails.chequeLeaf);
      if(angular.isUndefined(vm.formData.bankDetails.chequeLeaf)){return;}
      ModalService.showImage({docUrl: vm.formData.bankDetails.chequeLeaf});
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AddJointHoldersFolioController', addJointHoldersFolioController);

  /** @ngInject */
  function addJointHoldersFolioController($window, $state, $scope, AppConstants, MessageService, InvestorService, InvestorFolioModel,
                                          moment, UtilService, LoaderService, $stateParams, ModalService, InvestorServiceV3) {
    var vm = this;
    // vm.defaultMinorDob = moment().toString();
    vm.defaultsoleApplicantNWDate = moment().toString();
    vm.countryList = [];
    vm.occupationList = [];
    vm.incomeSlabList = [];
    vm.taxStatusList = [];
    vm.taxIdTypeList = [];
    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.POLITICAL_STATUS = AppConstants.INVESTOR_POLITICAL_STATUS;
    vm.currentJointHolder = 0;
    vm.defaultDob = moment().toString();
    vm.fileTaxActionJointHolder = fileTaxActionJointHolder;
    vm.addMoreJointHolder = addMoreJointHolder;
    vm.deleteCurrentJointHolder = deleteCurrentJointHolder;
    // vm.uploadMinorDobFile = uploadMinorDobFile;
    // vm.uploadMinorRelationshipFile = uploadMinorRelationshipFile;
    vm.saveFolio = saveFolio;
    vm.isSoleApplicantMinor = false;
    vm.fatcaArray = [];
    // vm.minorAgeProof = null;
    vm.minDate = moment().subtract(1, 'years').toString();
    // vm.minDateMinor = moment().subtract(18, 'years').toString();
    // vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    // vm.ageProofDocUrl = '';
    // vm.chooseAFile = true;
    // vm.genderList = [{name: 'Male', value: 'MALE'}, {name: 'Female', value: 'FEMALE'}];
    /*vm.relationshipList = [{name: 'Father', value: 'FATHER'}, {name: 'Mother', value: 'MOTHER'}, {
      name: 'Sibling',
      value: 'SIBLING'
    }, {name: 'Other', value: 'OTHER'}];*/
    vm.enum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      3: 'Fourth',
      4: 'Fifth'
    };
    vm.formData = angular.fromJson($window.sessionStorage.investorForm) || InvestorFolioModel.getInvestorFolioFormDataModel();

    $scope.MainFolioParent.holdmode = vm.formData.holdmode;

    // var token = AuthService.getToken();
    vm.back = back;
    // vm.setHoldmode = setHoldmode;

    vm.init = function () {
      /*$window.scrollTo(0, 0);
      var id = localStorage.getItem('folioId');
      var currentState = $state.current ? $state.current.name : '';
      if (id && !$stateParams.isBack && $stateParams.investorId) {
        localStorage.removeItem('folioId');
        localStorage.removeItem('wantToAddNomineeLater');
      }*/


      /*switch ($state.current.name) {
        case 'main.investors.add':
        case 'agent.home.investors.add':
          break;
      }*/
      //getSavedFolioByUUID();
      // setHeader();
      /*getTaxStatusList();
      getInvestorOccupationList();
      incomeSlab();
      getCountryList();
      getTaxIdTypeList();
      getAddressType();*/
      if (localStorage.getItem('folioId')) {

        getPayload();
      }
      if ($stateParams.investorId) {
        getPayload();
      }
    };

    // vm.init();
    /*

        function setHeader() {
          var profile = AuthService.getToken();
          if (profile) {
            $scope.MainFolioParent.panNumber = profile.investorPAN;
            $scope.MainFolioParent.firstName = profile.investorFName;
            $scope.MainFolioParent.middleName = profile.investorMName;
            $scope.MainFolioParent.lastName = profile.investorLName;
            vm.guardianName = $scope.MainFolioParent.firstName + ' ' + ($scope.MainFolioParent.lastName || '');
            $scope.MainFolioParent.currentState = 'main.folio.holdmode';
          } else {
            $state.go('login');
          }
        }
    */
    /*

        function setHoldmode(){
          $scope.MainFolioParent.holdmode = vm.formData.holdmode;
        }
    */
    /*
        function uploadMinorDobFile(file) {
          if (vm.mimeType.indexOf(file.type) == -1) {
            MessageService.error("Only image file is allowed");
            return;
          }
          if (file) {
            if (file.size <= 2000000) {
              var success = function (resp) {
                  LoaderService.hideLoader();
                  if (resp.status && resp.data) {
                    vm.formData.minorAgeProof = resp.data.fileUrl;
                    vm.formData.id = resp.data.uuid;
                    localStorage.setItem('folioId', resp.data.uuid);
                    breakFileUrl(resp.data.fileUrl);
                    //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
                  }
                  else {
                    MessageService.error(resp.message);
                  }
                },
                error = function (err) {
                  LoaderService.hideLoader();
                };

              if (file) {
                LoaderService.showLoader();
                var fd = new FormData();
                fd.append('file', file);

                // DistributorProfileUploadService.post({
                var uuid = '';
                if ($stateParams.investorId) {
                  uuid = $stateParams.investorId;
                } else if (localStorage.getItem('folioId')) {
                  uuid = localStorage.getItem('folioId');
                } else {
                  uuid = 'null';
                }

                InvestorFileUploadService.post({
                  child1: 'folio',
                  child2: 'minor',
                  child3: 'ageProof',
                  child4: 'upload',
                  child5: uuid
                }, fd).$promise.then(success, error);
              }
            }
            else {
              MessageService.error("File size should not be more than 2 MB.")
            }
          }

        }

        function uploadMinorRelationshipFile(file) {
          if (vm.mimeType.indexOf(file.type) == -1) {
            MessageService.error("Only image file is allowed");
            return;
          }
          if (file) {
            if (file.size <= 2000000) {
              var success = function (resp) {
                  LoaderService.hideLoader();
                  if (resp.status && resp.data) {
                    vm.formData.minorRelationshipProof = resp.data.fileUrl;
                    vm.formData.id = resp.data.uuid;
                    localStorage.setItem('folioId', resp.data.uuid);

                    breakRelationshipFileUrl(resp.data.fileUrl);
                    //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
                  }
                  else {
                    MessageService.error(resp.message);
                  }
                },
                error = function (err) {
                  LoaderService.hideLoader();
                };

              if (file) {
                LoaderService.showLoader();
                var fd = new FormData();
                fd.append('file', file);

                var uuid = '';
                if ($stateParams.investorId) {
                  uuid = $stateParams.investorId;
                } else if (localStorage.getItem('folioId')) {
                  uuid = localStorage.getItem('folioId');
                } else {
                  uuid = 'null';
                }

                // DistributorProfileUploadService.post({
                InvestorFileUploadService.post({
                  child1: 'folio',
                  child2: 'relationship',
                  child3: 'proof',
                  child4: 'upload',
                  child5: uuid
                }, fd).$promise.then(success, error);
              }
            }
            else {
              MessageService.error("File size should not be more than 2 MB.")
            }
          }

        }

        function breakFileUrl(url) {

          url = url.replace(/ /g, '');
          var a, extension;
          if (url.split('.jp').length > 1) {
            extension = '.jpg';
            a = url.split('.jp')[0].split('/');
          } else if (url.split('.png').length > 1) {
            extension = '.png';
            a = url.split('.png')[0].split('/');
          } else if (url.split('.pdf').length > 1) {
            extension = '.pdf';
            a = url.split('.pdf')[0].split('/');
          } else if (url.split('.bmp').length > 1) {
            extension = '.bmp';
            a = url.split('.bmp')[0].split('/');
          }

          vm.ageProofDocUrl = a[a.length - 1] + extension;
          vm.chooseAFile = false;

        }

        function breakRelationshipFileUrl(url) {

          url = url.replace(/ /g, '');
          var a, extension;
          if (url.split('.jp').length > 1) {
            extension = '.jpg';
            a = url.split('.jp')[0].split('/');
          } else if (url.split('.png').length > 1) {
            extension = '.png';
            a = url.split('.png')[0].split('/');
          } else if (url.split('.pdf').length > 1) {
            extension = '.pdf';
            a = url.split('.pdf')[0].split('/');
          } else if (url.split('.bmp').length > 1) {
            extension = '.bmp';
            a = url.split('.bmp')[0].split('/');
          }

          vm.relationshipDocUrl = a[a.length - 1] + extension;
          vm.chooseARelationshipFile = false;

        }*/

    vm.addNewResidencyFields = function () {

      vm.fatcaArray.push(
        {
          "countryName": '',
          "birthCity": '',
          "taxIdType": '',
          "taxIdNumber": ''
        });
    };

    vm.addAvailableResidency = function (fatca) {
      if (fatca.fatcaTax1) {
        vm.fatcaArray.push(fatca.fatcaTax1);
      }
      if (fatca.fatcaTax2) {
        vm.fatcaArray.push(fatca.fatcaTax2);
      }
      if (fatca.fatcaTax3) {
        vm.fatcaArray.push(fatca.fatcaTax3);
      }
    };

    vm.setSelectedResidency = function (payload) {
      if (payload.guardianDetail && !payload.guardianDetail.fatca) {
        payload.guardianDetail.fatca = {};
      }
      var fatca = payload.guardianDetail.fatca;

      delete fatca.fatcaTax1;
      delete fatca.fatcaTax2;
      delete fatca.fatcaTax3;

      if (payload.guardianDetail.payTaxInIndia) {
        return;
      }

      if (vm.fatcaArray[0]) {
        fatca.fatcaTax1 = vm.fatcaArray[0];
      }

      if (vm.fatcaArray[1]) {
        fatca.fatcaTax2 = vm.fatcaArray[1];
      }

      if (vm.fatcaArray[2]) {
        fatca.fatcaTax3 = vm.fatcaArray[2];
      }

    }

    vm.deleteTaxResidencyFromFatca = function (index) {
      vm.fatcaArray.splice(index, 1);
    }

    /*function getTaxStatusList() {
      if (vm.formData && vm.formData.minor) {
        var data = {taxStatusFilter: 'MINOR'};
      } else {
        data = {taxStatusFilter: 'ADULT'};
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusList = resp.data.taxStatus;
          if (vm.taxStatusList.length && vm.taxStatusList.length < 2) {
            vm.formData.taxStatusCode = vm.taxStatusList[0].taxStatusCode;
          }
        } else {
          vm.taxStatusList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxStatusList = null;
      };
      InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
    }

    function getInvestorOccupationList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.occupationList = resp.data.investorOccupations;
        } else {
          vm.occupationList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.occupationList = null;
      };
      InvestorService.get({child1: 'folio', child2: 'occupation'}).$promise.then(success, error);
    }

    function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.incomeSlabList = resp.data.incomeSlabList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
        };
      InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success, error);
    }*/

    function getPayload() {
      // vm.formData = angular.fromJson($window.sessionStorage.investorForm) || InvestorFolioModel.getInvestorFolioFormDataModel();
      var success = function (resp) {
          if (resp.status && resp.data) {
            if(angular.isArray(vm.formData.jointHolders) && vm.formData.jointHolders.length>0){
              vm.formData.jointHolders.forEach(function (holder,index) {
                holder.netWorth && $window.NumToWord(holder.netWorth, 'DisplayWordsTaxAmt-'+index, vm);
              })
            }

            vm.formData.holdmode = resp.data.holdmode;
            $scope.MainFolioParent.holdmode = vm.formData.holdmode;
            if (vm.formData && vm.formData.jointHolders.length===0) {
              //vm.payload.nominees = [];
              // vm.addNominee();

            }
            LoaderService.hideLoader();
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };

      /*InvestorService.get({
        child1: 'folio',
        child2: 'getSavedFolio',
        child3: $stateParams.investorId ? $stateParams.investorId : 'bb9412d1-28b7-4106-8bdc-bf2508657954'//localStorage.getItem('folioId')
      }).$promise.then(success, error);*/

      var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'getDetails'
      },{id:investorId}).$promise.then(success, error);

    }

    /*
        function prepareSoleApplicantFormData(data) {
          var d = data.soleApplicantDetail;
          vm.formData = {
            "firstName": d.personalDetail.firstName,
            "lastName": "",
            "dateOfBirth": d.personalDetail.dateOfBirth,
            "email": "",
            "minor": !d.minor ? false : d.minor,
            "taxStatusCode": d.taxStatusCode,
            "occupation": d.occupation,
            "panNumber": d.panNumber,
            "grossAnnualIncome": d.grossAnnualIncome,
            "netWorth": d.netWorth,
            "netWorthDate": d.netWorthDate,
            "politicalStatus": d.politicalStatus,
            "payTaxInIndia": d.payTaxInIndia,
            "fatcaAddressType": d.fatcaAddressType,
            "birthCountry": d.birthCountry,
            "birthCity": d.birthCity,
            "payOutsideIndiaAddresses": d.payOutsideIndiaAddresses
          };
        }*/
    /*

        function prepareGuardianDetailFormData(data) {
          var d = data.guardianDetail;
          var s = data.soleApplicantDetail;
          vm.formData = {
            "firstName": s.personalDetail.firstName,
            "lastName": "",
            "dateOfBirth": s.personalDetail.dateOfBirth,
            "email": "",
            "gender": s.personalDetail.gender,
            "minor": !s.minor ? false : s.minor,
            "taxStatusCode": s.taxStatusCode,
            "occupation": d.occupationCode,
            "panNumber": d.panNumber,
            "relationship": d.relation,
            "grossAnnualIncome": d.income,
            "netWorth": d.netWorth,
            "netWorthDate": d.netWorthDate,
            "politicalStatus": d.pepStatus,
            "payTaxInIndia": d.fatca.payTaxInIndia,
            "fatcaAddressType": d.fatca.addressType,
            "birthCountry": d.fatca.birthCountry,
            "birthCity": d.fatca.birthPlace,
            "minorAgeProof": s.minorAgeProof,
            "minorRelationshipProof": s.minorRelationshipProof
          };
          breakFileUrl(s.minorAgeProof);
          breakRelationshipFileUrl(s.minorRelationshipProof);
          vm.addAvailableResidency(d.fatca);
        }
    */

    vm.changeDob = function (date) {

      if (!date) {
        return;
      }
      // vm.defaultDob = date.toString();
      vm.formData.minorDob = date.clone().format('DD-MMM-YYYY').toString();
    };

    vm.changeStartDate = function (date) {
      if (!date) {
        return;
      }
      vm.formData.jointHolders[vm.currentJointHolder].netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
      // vm.formData.netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
    }

    /*function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
    }

    function getTaxIdTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdTypeList = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxIdTypeList = null;
      };
      InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success, error);
    }

    function getAddressType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.addressTypeList = resp.data.addressTypeResponses;
        } else {
          vm.addressTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.addressTypeList = null;
      };
      InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success, error);
    }*/

    function fileTaxActionJointHolder(index) {

      if (!vm.formData.jointHolders[index].fatcaDetail.payTaxInIndia) {
        vm.formData.jointHolders[index].fatcaDetail.fatcaTax1 = {"taxPayingCountry": "", "taxId": "", "taxIdType": ""};
        vm.formData.jointHolders[index].fatcaDetail.fatcaTax2 = {"taxPayingCountry": "", "taxId": "", "taxIdType": ""};
        vm.formData.jointHolders[index].fatcaDetail.fatcaTax3 = {"taxPayingCountry": "", "taxId": "", "taxIdType": ""};
      } else {
        vm.formData.jointHolders[index].fatcaDetail && (delete vm.formData.jointHolders[index].fatcaDetail.fatcaTax1);
        vm.formData.jointHolders[index].fatcaDetail && (delete vm.formData.jointHolders[index].fatcaDetail.fatcaTax2);
        vm.formData.jointHolders[index].fatcaDetail && (delete vm.formData.jointHolders[index].fatcaDetail.fatcaTax3);
      }

    }

    /*
     vm.selectPayTaxOutsideIndia = function () {
     if(vm.fatcaArray.length===0){
     addMoreTaxResidency();
     }
     }*/

    /*function addMoreTaxResidency(index) {
      var array = vm.formData.jointHolders[index].payOutsideIndiaAddresses || [];
      array.length < 4 ? array.push({}) : '';
    }*/


    function addMoreJointHolder() {
      var array = vm.formData.jointHolders || [];
      if ((vm.formData.jointHolders[vm.currentJointHolder].firstName) || (vm.formData.jointHolders[vm.currentJointHolder].pan) ) {
        if (array.length < 2) {
          var blankObj = InvestorFolioModel.getNewJointHolder();
          array.push(blankObj);
          InvestorFolioModel.setInvestorFolioModel(vm.formData);
          $window.sessionStorage.investorForm = angular.toJson(vm.formData);
        } else {
          array.length = 0;
        }
        vm.currentJointHolder++;
        pan4JointHolders();
      }
      else {
        //angular.element('#nomineeName-'+vm.parentIndex).focus();
        //MessageService.error("please enter joint holder name");
      }
    }

    function deleteCurrentJointHolder(parentIndex) {
      var success = function () {
        var model = vm.formData.jointHolders || [];
        model.splice(parentIndex, 1);
        vm.currentJointHolder = (parentIndex * 1) - 1;
        if (model.length == 0) {
          vm.formData.jointHolders = [];
          // InvestorModel.setTab({tab3: false, tabJointHolderAddable: false});
          InvestorFolioModel.setInvestorModel(vm.formData);
          $window.sessionStorage.investorForm = angular.toJson(vm.formData);
          $state.go('main.folio.soleApplicant');
        }
      };
      ModalService.confirmCancelModal({Text: 'Do you want to delete ' + vm.enum[parentIndex + 1] + ' Holder?'}, success);
    }

    function pan4JointHolders() {
      var addFlag = true;
      var successPanDetails = function (result) {
          if (result.status && result.data && result.data.kycverified) {
            if (vm.formData.soleApplicantDetail.panNumber != result.data.pan) {
              angular.forEach(vm.formData.jointHolders, function (val) {
                if (val.pan == result.data.pan) {
                  MessageService.error("Valid PAN details required to add joint holder");
                  addFlag = false;
                  vm.formData.jointHolders.splice(vm.currentJointHolder, 1);
                  --vm.currentJointHolder;
                }
              });
              if (addFlag) {
                var newModel = InvestorFolioModel.getNewJointHolder();
                vm.formData.jointHolders[vm.currentJointHolder] = newModel;
                vm.formData.jointHolders[vm.currentJointHolder].jointHolderName = result.data.name;
                vm.formData.jointHolders[vm.currentJointHolder].firstName = result.data.name;
                vm.formData.jointHolders[vm.currentJointHolder].pan = result.data.pan;
                vm.formData.jointHolders[vm.currentJointHolder].email = result.data.email;
              }

            } else {
              vm.formData.jointHolders.splice(vm.currentJointHolder, 1);
              --vm.currentJointHolder;
              MessageService.error("Valid PAN details required to add joint holder");
            }
          } else {
            MessageService.error(result.message || 'Kyc verification is pending.');
          }
        },
        errorPanDetails = function () {
          vm.formData.jointHolders.splice(vm.currentJointHolder, 1);
          --vm.currentJointHolder;
        };
      var labelSetter = {type: 'jointholders', label: {header: 'ADD JOINT HOLDER', pan: 'PAN', dob: 'Joint Holder DOB'}}
      ModalService.checkPan4Holder(labelSetter, successPanDetails, errorPanDetails);
    }

    /*function submitJointHolder() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          MessageService.success(resp.data.message);
          InvestorFolioModel.setInvestorModel(vm.formData);
          $state.go('main.folio.bankdetails');
        } else {
          vm.formData.soleApplicantDetail = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        // vm.formData.soleApplicantDetail = null;
      };
      InvestorService.post({child1: 'folio', child2: 'createNewFolio'}, null).$promise.then(success, error);
    }*/

    function saveFolio(stateToMove) {
      LoaderService.showLoader();
      sanitize4Facta();
      var payload = vm.formData;
      if (payload) {
        payload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
        payload.saveStep = 3;
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          LoaderService.hideLoader();
          localStorage.setItem('folioId', resp.data.id);
          InvestorFolioModel.setInvestorFolioModel(resp.data);
          $window.sessionStorage.investorForm = angular.toJson(vm.formData);
          if (stateToMove) {
            if ($stateParams.investorId) {
              $state.go(stateToMove, {investorId: $stateParams.investorId});
            } else {
              $state.go(stateToMove);
            }
          }else MessageService.success('Saved Successfully.');
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      InvestorService.post({child1: 'folio', child2: 'saveFolio'}, payload).$promise.then(success, error);
    }

    function sanitize4Facta(){
      angular.forEach(vm.formData.jointHolders, function (holder) {
        if(holder.fatcaDetail.fatcaTax1 && holder.fatcaDetail.fatcaTax1.taxPayingCountry===''){
          delete holder.fatcaDetail.fatcaTax1;
        }if(holder.fatcaDetail.fatcaTax2 && holder.fatcaDetail.fatcaTax2.taxPayingCountry===''){
          delete holder.fatcaDetail.fatcaTax2;
        }if(holder.fatcaDetail.fatcaTax3 && holder.fatcaDetail.fatcaTax3.taxPayingCountry===''){
          delete holder.fatcaDetail.fatcaTax3;
        }
      });
    }

    function back(from) {
      saveFolio('main.folio.holdmode', from);
    }

    /*function prepareFatcaRemainingProps(payload) {
      payload.fatca.birthCountry = payload.birthCountry;
      payload.fatca.birthPlace = payload.birthPlace;
      payload.fatca.addressType = payload.addressType;
      payload.fatca.payTaxInIndia = payload.payTaxInIndia;
      var prop;
      for (prop in payload) {
        if (prop == 'birthCountry' || prop == 'birthPlace' || prop == 'addressType' || prop == 'payTaxInIndia') {
          delete payload[prop];
        }
      }
    }

    function prepareSoleApplicantDetail(obj) {
      var prop;
      for (prop in obj) {
        if (prop != 'personalDetail' && prop != 'taxStatusCode' && prop != 'minor' && prop != 'minorAgeProof') {
          delete obj[prop];
        }
      }
    }

    vm.setMinorFlag = function () {
      var minorVal = vm.formData.minor;
      if (minorVal) {
        $scope.MainFolioParent.isSoleApplicantMinor = true;
      } else {
        $scope.MainFolioParent.isSoleApplicantMinor = false;
      }
      vm.formData = InvestorFolioModel.getNewInvestorFolioFormDataModel();
      vm.formData.minor = minorVal;
      vm.formData.bankDetails = {};
      vm.nomineesResp = [];
      vm.ageProofDocUrl = '';
      vm.relationshipDocUrl = '';
      getTaxStatusList();
      vm.formData.payTaxInIndia = true;
      vm.formData.politicalStatus = vm.POLITICAL_STATUS.NONE;
    };*/

    vm.continue = function () {
      saveFolio('main.folio.nominee');
    };

    /*
        function changeMinorStatus() {
          $scope.FolioAddParent.isSoleApplicantMinor = vm.formData.minor;
        }*/

    /*function getSoleApplicantPayload() {
      var a = vm.formData;
      var payload = {
        "soleApplicantDetail": {
          "personalDetail": {
            "firstName": a.firstName,
            "lastName": "",
            "dateOfBirth": a.dateOfBirth,
            "email": ""
          },
          "taxStatusCode": a.taxStatusCode,
          "fatcaAddressType": a.fatcaAddressType,
          "birthCountry": a.birthCountry,
          "birthCity": a.birthCity,
          "occupation": a.occupation,
          "panNumber": $scope.MainFolioParent.panNumber,
          "grossAnnualIncome": a.grossAnnualIncome || "",
          "netWorth": a.netWorth || "",
          "netWorthDate": a.netWorthDate || "",
          "politicalStatus": a.politicalStatus,
          "payTaxInIndia": a.payTaxInIndia,
          "payOutsideIndiaAddresses": a.payOutsideIndiaAddresses,
          "minor": a.minor
        },
        "jointHolders": [],
        "nominees": vm.nomineesResp || [],
        "guardianDetail": null,
        "brokerCode": null,
        "holdmode": a.holdmode,
        "saveStep": null,
        "id": null,
        "newFolioComplete": null
      };

      return payload;
    }*/

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AddHoldModeController', addHoldModeController);

  /** @ngInject */
  function addHoldModeController($scope, $stateParams, AppConstants, AuthService, $state,InvestorServiceV3,
                                 InvestorFolioModel, LoaderService, InvestorService, UtilService, MessageService) {
    var vm = this;
    vm.CONST = AppConstants;
    vm.setHoldmode = setHoldmode;
    vm.saveFolio = saveFolio;
    vm.init = init;

    function init() {
      setHeader();
      /*if(!InvestorFolioModel.getInvestorFolioFormDataModel()){
        localStorage.removeItem('folioId');
      }*/
      vm.formData = InvestorFolioModel.getInvestorFolioFormDataModel() ?
        InvestorFolioModel.getInvestorFolioFormDataModel():
        InvestorFolioModel.getNewInvestorFolioModel();

      if (localStorage.getItem('folioId')||$stateParams.investorId) {
        getPayload();
      }
    }

    function setHeader() {
      var profile = AuthService.getToken();
      if (profile) {
        $scope.MainFolioParent.panNumber = profile.investorPAN;
        $scope.MainFolioParent.firstName = profile.investorFName;
        $scope.MainFolioParent.middleName = profile.investorMName;
        $scope.MainFolioParent.lastName = profile.investorLName;
        vm.guardianName = $scope.MainFolioParent.firstName + ' ' + ($scope.MainFolioParent.lastName || '');
        $scope.MainFolioParent.currentState = 'main.folio.holdmode';
      } else {
        $state.go('login')
      }
    }

    function setHoldmode(){
      $scope.MainFolioParent.holdmode = vm.formData.holdmode;
    }

    function saveFolio() {
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          localStorage.setItem('folioId', resp.data.id);
          InvestorFolioModel.setInvestorFolioModel(vm.formData);
            // $scope.MainFolioParent.uuid = resp.data.id;
            LoaderService.hideLoader();
            if ($stateParams.investorId) {
              $state.go('main.folio.soleApplicant', {investorId: $stateParams.investorId});
            } else {
              $state.go('main.folio.soleApplicant');
            }
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      vm.formData.saveStep = 1;
      InvestorService.post({child1: 'folio', child2: 'saveFolio'}, vm.formData).$promise.then(success, error);
    }

    function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            LoaderService.hideLoader();
            vm.formData = resp.data;
            vm.formData.previousFolioCreationFor = resp.data.minor;
            vm.formData.previousHolders = resp.data.holdmode;
            vm.formData.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
            $scope.MainFolioParent.holdmode = vm.formData.holdmode;
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };

      var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'getDetails'
      },{id:investorId}).$promise.then(success, error);

    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('BankDetailsFolioAddController', bankDetailsFolioAddController);

  /** @ngInject */
  function bankDetailsFolioAddController($window, ModalService, AppConstants, $state, MessageService, InvestorService, $log, $scope,
                                         LoaderService, AuthService, InvestorFileUploadService, UtilService, InvestorServiceV3 , dynamicData,$stateParams) {
    var vm = this;
    vm.formData = {};
    var taxStatusCode = '';
    vm.dynamicData = dynamicData;

    vm.init = function () {
      $window.scrollTo(0, 0);
      LoaderService.showLoader();
      setHeader();
      getPayload(function (status) {
        if (status) {
          getAcccountType();
        }
      });
    };

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.MainFolioParent.panNumber = profile.investorPAN;
      $scope.MainFolioParent.firstName = profile.investorFName;
      $scope.MainFolioParent.lastName = profile.investorLName;
      $scope.MainFolioParent.currentState = 'main.folio.bankdetails';

    }

    function getPayload(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payload = resp.data;
            $scope.MainFolioParent.holdmode = resp.data.holdmode;
            if (vm.payload.bankDetails && !vm.payload.bankDetails.bankHolderType) {
              vm.payload.bankDetails.bankHolderType = 'MINOR';
            }
            taxStatusCode = vm.payload.soleApplicantDetail && vm.payload.soleApplicantDetail.personalDetail.taxStatusCode;
            cb(true);
          } else {
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
          cb(false);
        };
      LoaderService.showLoader();
      InvestorServiceV3.post({child1: 'folio', child2: 'getDetails'},{ id:localStorage.getItem('folioId')?localStorage.getItem('folioId'):$stateParams.investorId}).$promise.then(success, error);

    }

    function getAcccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
            if (vm.bankTypeList.length && vm.bankTypeList.length > 0) {
              if (taxStatusCode == "01") {
                vm.bankTypeList && vm.bankTypeList.length > 3 && (!vm.payload.bankDetails.accountType || vm.payload.bankDetails.accountType === "NRE") ?
                  vm.payload.bankDetails.accountType = vm.bankTypeList[3].accountTypeCode
                  : ''
              }
              else {
                vm.bankTypeList && vm.bankTypeList.length > 0 ?
                  vm.payload.bankDetails.accountType = vm.bankTypeList[0].accountTypeCode
                  : ''
              }
              //to set the default value of account type field as per the requirement
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };

      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4: taxStatusCode
      }).$promise.then(success, error);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ExistingUserAddNomineeController', existingUserAddNomineeCtrl);

  /** @ngInject */
  function existingUserAddNomineeCtrl($window, MessageService, InvestorService, $state,$stateParams, AppConstants, $scope, LoaderService, AuthService, InvestorServiceV3,dynamicData) {
    var vm = this;
    vm.dynamicData = dynamicData;
    // vm.wantToAddNomineeLater = true;
    vm.maxNominee = 3;
    vm.activeTab = 0;
    vm.countryList = [];
    vm.defaultDob = $window.moment().toString();
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    var CONST = AppConstants;
    vm.saveFolio = saveFolio;
    vm.validationMsg = '';
    vm.totalPercentage = 0;
    vm.showAddNominee = true;
    vm.wantToAddNomineeLater = localStorage.getItem('wantToAddNomineeLater') == "true" ? true : false;
    vm.enum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      3: 'Fourth',
      4: 'Fifth'

    };
    vm.init = function () {
      $window.scrollTo(0, 0);
      LoaderService.showLoader();
      setHeader();
      // $scope.FolioDetailsParent.stepsAway = 2;
      getCountryList();
      getPayload();

    };

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.MainFolioParent.panNumber = profile.investorPAN;
      $scope.MainFolioParent.firstName = profile.investorFName;
      $scope.MainFolioParent.middleName = profile.investorMName;
      $scope.MainFolioParent.lastName = profile.investorLName;
      $scope.MainFolioParent.currentState = 'main.folio.nominee';
      vm.userPan = profile.investorPAN;

    }

    vm.changeDob = function (date) {

      if (!date) {
        return;
      }
      // vm.defaultDob = date.toString();
      vm.payload.nominees[vm.activeTab].dob = date.clone().format('DD-MMM-YYYY').toString();
      var age = $window.moment().diff(date, 'years');
      if (age < 18) {
        vm.payload.nominees[vm.activeTab].minor = true;
      } else {
        vm.payload.nominees[vm.activeTab].minor = false;
      }
    };

    vm.percentage = function (data) {
      if (data.percentage.split('%').length != 2)
        data.percentage = data.percentage + '%';
    };

    vm.setActiveTab = function (index) {
      vm.activeTab = index;
    };

    vm.deleteNominee = function (index) {
      vm.payload.nominees.splice(index, 1);
      vm.activeTab = 0;
      var totalPercentage = 0;
      for (var i in vm.payload.nominees) {
        totalPercentage += parseInt(vm.payload.nominees[i].percentage);
      }
      vm.totalPercentage = totalPercentage;

    };

    vm.addNominee = function () {
      /*var msg = checkValidation();
      if (msg) {
        MessageService.error(msg);
        return;
      }*/
      if (!vm.payload.nominees)
        vm.payload.nominees = [];
      // var percentage = calculateProportion();
      vm.payload.nominees.push(
        {
          "nomineeName": "",
          "nomineeRelation": "",
          "percentage": "",
          "dob": "",
          "panNumber" : null,
          "nomineeAddress": {
            "addressLine1": "",
            "addressLine2": "",
            "addressLine3": "",
            "pinCode": "",
            "city": "",
            "state": "",
            "country": ""
          },
          "guardianName": null,
          "guardianAddress": {
            "addressLine1": "",
            "addressLine2": "",
            "addressLine3": "",
            "pinCode": "",
            "city": "",
            "state": "",
            "country": ""
          },
          "guardianPanNumber" : null,
          "guardianRelationWithNominee": null
        }
      );

      vm.activeTab = vm.payload.nominees.length - 1;

    };

    /*function checkValidation() {
      var arr = vm.payload.nominees, msg = '';
      for (var i = 0; i < arr.length; i++) {
        if (!arr[i]['nomineeName'] || !arr[i]['percentage']) {
          msg = 'Please fill details of ' + vm.enum[i]
            + ' nominee';
          break;
        }
      }
      return msg;
    }

    function calculateProportion() {
      var percentage = 0, nominees = vm.payload.nominees;

      if (nominees.length === 0) {
        percentage = 100;
      } else if (nominees.length === 1) {
        percentage = 100 - parseInt(nominees[0].percentage);
      } else if (nominees.length === 2) {
        percentage = 100 - (parseInt(nominees[0].percentage) + parseInt(nominees[1].percentage));
      }

      return percentage;
    }*/

    vm.calculatePercentage = function () {
      var totalPercentage = 0;
      var nominees = vm.payload.nominees||[];
      for (var i in nominees) {
        totalPercentage += parseInt(nominees[i].percentage);
      }
      vm.totalPercentage = totalPercentage;
      if (vm.totalPercentage < 100 && nominees.length < vm.maxNominee) {
        vm.showAddNominee = true;
      } else {
        vm.showAddNominee = false;
      }
    };

    function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payload = resp.data;
            $scope.MainFolioParent.holdmode = resp.data.holdmode;
            if (vm.payload.hasOwnProperty('sebiNomineeRegulatory01650Active')) {
              vm.payload.nomineeLimit = resp.data.nomineeLimit ? resp.data.nomineeLimit : 3;
            }
            /*if (vm.payload && !vm.payload.nominees) {
              //vm.payload.nominees = [];
              vm.addNominee();
            } else*/ if (vm.payload && vm.payload.nominees && vm.payload.nominees.length === 0) {
              vm.payload.nominees = [];
              vm.addNominee();
              vm.wantToAddNomineeLater = true;
            } else {
              vm.wantToAddNomineeLater = false;
            }
            if (vm.payload.hasOwnProperty('sebiNomineeRegulatory01650Active')) {
              vm.payload.nomineeRegistrationCO = vm.payload.nomineeRegistrationCO ? vm.payload.nomineeRegistrationCO : {};
              vm.payload.nomineeRegistrationCO.incapacitationDeclaration = vm.payload.nomineeRegistrationCO.incapacitationDeclaration ? vm.payload.nomineeRegistrationCO.incapacitationDeclaration : {};
            }
            vm.calculatePercentage();
            LoaderService.hideLoader();
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };

      var investorId =localStorage.getItem('folioId')?localStorage.getItem('folioId'):$stateParams.investorId;
      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'getDetails'
      },{id:investorId}).$promise.then(success, error);

    }

    vm.next = function () {
      saveFolio('folioDetails.bankDetails');
    };

    vm.back = function (from) {
        if(vm.payload.holdmode === CONST.INVESTOR_HOLD_MODE.AOS){
        saveFolio('main.folio.jointholders', from);
      }else {saveFolio('main.folio.soleApplicant', from)}

    };

    function checkProportionTotalSum() {
      var sum = 0, msg = '';
      for (var i = 0; i < vm.payload.nominees.length; i++) {
        sum = sum + parseInt(vm.payload.nominees[i].percentage);
      }
      if (sum != 100) {
        msg = 'Total sum of nominee proportion should be 100';
      }

      return msg;

    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.countryList = null;
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
    }

    function saveFolio(stateToMove, from) {
      if (from != 'fromBack') {
        if (!vm.wantToAddNomineeLater) {
          var msg = checkProportionTotalSum();
          if (msg) {
            MessageService.error(msg);
            return;
          }
        }
        if (vm.wantToAddNomineeLater) {
          vm.payload.nominees = [];
        }
      }
      checkNominees();
      if (vm.payload) {
        vm.payload.id = localStorage.getItem('folioId');
      }

      LoaderService.showLoader();

      var success = function (resp) {
        if (resp.status && resp.data) {
          $scope.MainFolioParent.uuid = resp.data.id;
          if (stateToMove) {
            $state.go(stateToMove, {isBack: true});
          }
        } else {
          MessageService.error(resp.message);
        }

        LoaderService.hideLoader();
      }, error = function () {
        LoaderService.hideLoader();
      };
      vm.payload.saveStep = 4;
      InvestorService.post({child1: 'folio', child2: 'saveFolio'}, vm.payload).$promise.then(success, error);
    }

    vm.continue = function () {
      saveFolio('main.folio.bankdetails');
    };

    function checkNominees() {
      for (var i = 0; i < vm.payload.nominees.length; i++) {
        if (vm.payload.nominees[i].minor) {
          delete vm.payload.nominees[i].nomineeAddress;
        } else {
          delete vm.payload.nominees[i].guardianName;
          delete vm.payload.nominees[i].guardianAddress;
        }
      }
    }

    vm.checkAddNominee = function () {
      // vm.wantToAddNomineeLater = !vm.wantToAddNomineeLater;
      localStorage.setItem('wantToAddNomineeLater', vm.wantToAddNomineeLater);
    }

    $scope.$watch('addNomineeForm.$error.required', function (newValue) {
      if (angular.isArray(newValue) && newValue.length > 0) {

        var formTypeArray = newValue.map(function (ele) {
          return ele.$name.split('-')[1]
        }).filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });
        var nomineeList = [];
        angular.forEach(formTypeArray, function (val) {
          switch (val) {
            case "0":
              nomineeList.push('First Nominee');
              break;
            case "1":
              nomineeList.push('Second Nominee');
              break;
            case "2":
              nomineeList.push('Third Nominee');
              break;
            case "3":
              nomineeList.push('Fourth Nominee');
              break;
            case "4":
              nomineeList.push('Fifth Nominee');
              break;
            case "5":
              nomineeList.push('Sixth Nominee');
              break;
          }
        });

        vm.validationMsg = setMsg(nomineeList);
      } else {
        vm.validationMsg = '';
      }
    }, true);

    function setMsg(list) {
      var msg = 'Please complete the ';
      var array = angular.copy(list);
      if (array.length == 0) {
        return '';
      }
      else if (array.length == 1) {
        return msg + array.join(',') + ' Details';
      }
      else if (array.length > 1) {
        var listLast = array.pop();
        return msg + array.join(' , ') + ' and ' + listLast + ' Details';
      }


    }

  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('transactionScheme', transactionDirective);

  /*@ngInject*/
  function transactionDirective($state, $window, AuthService, LoaderService, AppConstants, MessageService, InvestmentBasketService, UtilService, $stateParams , ModalService, HDFC_API) {
    return {
      restrict: 'E',
      scope: {
        id: '=',
        journey: '=',
        retirement: '='
      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/transaction-directive-scheme/transaction.scheme.directive.html',
      link: function ($scope) {
        var vm = $scope;
        vm.TRANSACTION_TYPE = vm.disclaimer = AppConstants.INVESTMENT_BASKET.TRANSACTION_TYPE;
        vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
        vm.viewMode = 'days';
        vm.basketDetails = {};
        vm.journeyDetails = null;
        vm.formData = {
          transactionType: vm.TRANSACTION_TYPE.LUMPSUM,
          amount: null,
          sipStartDate: null,
          sipEndDate: null
        }
        vm.calendarRange = {
          minSipStartDate: null,
          maxSipStartDate: null,
          minSipEndDate: null,
          maxSipEndDate: null,
        }

        vm.minAmount = null;
        vm.amountOptions = [];
        vm.schemeCodes = [];
        vm.formData.frequency = 'OM';
        vm.formData.isTillPerpetuity = true;
        vm.showRadio = true;
        vm.convertToLocalString = convertToLocalString;
        vm.changeStartDate = changeStartDate;
        vm.disclaimer = null;
        vm.constants = AppConstants;
        vm.retirement = null;

        init();

        function init() {
          vm.isMinor = sessionStorage.getItem('isMinorFolioSelected') === "true" ? true : false;
          sessionStorage.removeItem('viaViewDetails');
          vm.isFromPreLogin = $stateParams.fromPreLogin;
          vm.invType = sessionStorage.getItem('userType');
          var randomOTPId = sessionStorage.getItem('randomOTPIdForGoalKYIPAndBasket');
          if(!randomOTPId) {
            getRandomOTPId();
          }
          getDetails();
          var successHandler = function(resp) {
            if (vm.journey === AppConstants.JOURNEY.INVESTMENT_BASKET_JOURNEY && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket &&
              resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket !== undefined) {
              vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket.content;
            } else if (vm.journey === AppConstants.JOURNEY.GOAL_JOURNEY && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey &&
              resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey !== undefined) {
              vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey.content;
            } else if (vm.journey === AppConstants.JOURNEY.RISK_JOURNEY && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile &&
              resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile !== undefined) {
              vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile.content;
            }
          };
          UtilService.fetchDynamicData("INVESTMENT_BASKET").then(successHandler).catch(function(resp) {
            MessageService.error(resp);
          });

          UtilService.fetchMandateValidations().then(function (resp) {
            vm.emandateObj = resp.eOTM;
            vm.mandateInfo = vm.emandateObj.mandateInfo;
          }).catch(function(resp) {
            MessageService.error(resp)
          });
        }


        function getDetails() {
          var journeyDraftId = sessionStorage.getItem("journeyDraftId");

          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.journeyDetails = resp.data;
              vm.formData.transactionType = vm.journeyDetails.transactionType;
              // if (vm.isMinor) {
              //   if (vm.formData.transactionType === 'SIP') {
              //     ModalService.minorSipModal({});
              //   } else {
              //     ModalService.minorPurchaseModal({});
              //   }
              // }
              vm.formData.amount = vm.journeyDetails.amount;
              vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
              if(vm.formData.amount){
                $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
              }
              fetchSchemeValidationSingleScheme(vm.journeyDetails.schemes[0].schemeCode,vm.formData.transactionType);

              if(vm.journeyDetails.goalName && vm.journeyDetails.goalName == 'Retirement'){
                sessionStorage.setItem('onlyIndividualFolioCreation',true);
              }else{
                sessionStorage.setItem('onlyIndividualFolioCreation',false);
              }
              vm.journeyDetails.schemes.forEach(function (scheme) {
                var fundType = scheme.direct ? 'direct' : 'regular';
                vm.fundUrl = HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + scheme.linkUrl + '/' + fundType;
              });
            }
          }, error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err)
          }

          LoaderService.showLoader();

          InvestmentBasketService.get({
            child1: 'investment',
            child2: 'basket',
            child3: 'getDetails',
            child4: journeyDraftId,
          }).$promise.then(success, error);
        }

        function fetchSchemeValidationSingleScheme(schemeCode, transactionType) {

          vm.validations = {};
          LoaderService.showLoader();
          var schemeCodes = [];
          schemeCodes.push(schemeCode);

          var payload  = {
            schemeCodes : schemeCodes,
            transactionType : transactionType
          }

          var success = function(resp) {
            LoaderService.hideLoader();
            vm.validationsData = resp.data.validationDTOMap[vm.journeyDetails.schemes[0].schemeCode];
            vm.retirement = vm.validationsData.retirementFlag === true ? true: null;
            vm.amountOptions = vm.validationsData.amountArray;
            sessionStorage.setItem('cgfFlagFromGoalJourney',vm.validationsData.cgfFlag);
            setValidationSchemes();
          } , error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          }

          InvestmentBasketService.post({
            child1: 'investment',
            child2: 'basket',
            child3: 'validate',
            child4: 'schemes'
          },payload).$promise.then(success, error);
        }


        function setValidationSchemes() {
          if (vm.formData.transactionType == 'SIP') {
            vm.frequencyList = vm.validationsData.additionalValidation.frequency ? vm.validationsData.additionalValidation.frequency : null;
            vm.validations.minAmount = vm.validationsData.additionalValidation.OM[0].min_amount_lower;
            vm.additionalSipData = vm.validationsData.additionalValidation.OM;
            vm.validations.maxInstallments = vm.validationsData.monMaxInstallmentNumber;
            vm.sipTDay = vm.validationsData.sipTDay;
            fetchValidationsSip();
            // Setting SIP start date range
            var todayDate = $window.moment();
            vm.calendarRange.minSipStartDate = $window.moment(todayDate).add(vm.sipTDay, 'days');
            vm.calendarRange.maxSipStartDate = $window.moment(todayDate).add(90, 'days');
            vm.formData.sipStartDate = vm.calendarRange.minSipStartDate;
            changeStartDate(vm.formData.sipStartDate);
          } else {
            if (vm.validationsData) {

              if (!vm.validationsData.addlPurchase) {
                vm.isPurchaseMin = vm.validationsData.minFirstPurchaseAmt > vm.formData.purchaseAmount;
                vm.purchaseMinAmount = vm.validationsData.minFirstPurchaseAmt;
              } else {
                vm.isPurchaseMin = vm.validationsData.minAddlPurchaseAmt > vm.formData.purchaseAmount;
                vm.purchaseMinAmount = vm.validationsData.minAddlPurchaseAmt;
              }
              vm.isMultiples = vm.validationsData.purchaseMultiple && vm.formData.purchaseAmount && (vm.formData.purchaseAmount % vm.validationsData.purchaseMultiple === 0) || false;
              if(vm.formData.purchaseAmount%1 != 0){
                vm.isPurchaseAmountDecimal = true;
              }
              else{
                vm.isPurchaseAmountDecimal = false;
              }
            }
          }
        }

        function fetchValidationsSip() {
          if(vm.additionalSipData){
            var newValidation =  vm.additionalSipData;
            for (var i=0; i<newValidation.length;i++){
              var condition = vm.formData.amount < newValidation[i].min_amount_lower ||  vm.formData.amount <= newValidation[i].min_amount_upper
              if(!newValidation[i].min_amount_upper){
                var condition = true;
              }
              if(condition)
              {
                // vm.formData.startDate = null;
                // vm.enabledStartDates = null;
                // vm.formData.endDate = null;
                // vm.enabledEndDates = null;
                vm.validations.amountMultiples = newValidation[i].amt_multiples;
                vm.validations.maxAmount = newValidation[i].min_amount_upper;
                // vm.validations.minAmount = newValidation[i].min_amount_lower;
                vm.validations.minInstallments = newValidation[i].min_installments;
                break;
              }
            }
          }

          vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
          vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
          vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
        }

        vm.onAmountChange = function (value) {
          if (!value) {
            value = null;
          }

          vm.tForm.amount.$setDirty();
          vm.tForm.amount.$setValidity("schemeAmountError", true);

          vm.formData.displayAmount = value ? parseInt(value.toString().replaceAll(",", "")).toLocaleString('en-IN') : "";
          vm.formData.amount = vm.formData.displayAmount ? parseInt(vm.formData.displayAmount.toString().replaceAll(",", "")) : null;
          if(vm.formData.amount){
            $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
          } else {
            vm.amountInWords = null;
          }
          setValidationSchemes();
        }

        vm.onTransTypeChange = function () {
          resetNumInWords();
          vm.formData.amount = null;
          vm.formData.displayAmount = null
          vm.formData.sipStartDate = null;
          vm.formData.sipEndDate = null;
          vm.onAmountChange(vm.formData.amount);
          vm.tForm.$setUntouched();
          vm.tForm.$setPristine();
        }

        function changeStartDate (value) {
          if (value) {
            vm.formData.sipStartDate = value;
          }
          // updateEndDates();
          var timeInMonths = vm.journeyDetails.timeInMonths -1;
          var endDate = $window.moment(vm.formData.sipStartDate, "DD-MMM-YYYY").add(timeInMonths, 'months');
          vm.formData.sipEndDate = $window.moment(endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");

        }

        vm.changeEndDate = function (value) {
          if (value) {
            vm.formData.sipEndDate = value;
          }
        }


        vm.back = function () {
          if (vm.invType) {
            $window.history.back();
          } else {
            var url = sessionStorage.getItem('investNowBackUrl') || 'main.investment.basket';
            var params = sessionStorage.getItem('investNowBackParams');
            params = params ? JSON.parse(params) : {};
            $state.go(url, params);
          }
        }

        vm.onProceed = function () {
          var details = sessionStorage.getItem('reviewDataFromGoalJourney') ? JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')) : {};

          var payload = {};
          payload = {
            "id": vm.journeyDetails.id,
            "folioNumber" : details.folioNumber,
            "panNumber": vm.journeyDetails.panNumber,
            "journey": vm.journeyDetails.journey,
            "step": "SECOND",
            "transactionType": vm.formData.transactionType === "SIP" ? 'SIP' : 'PURCHASE',
            "goalId" : details.goalId,
            "goalQuesAndAnsSet" : details.goalQuesAndAnsSet
          };

          payload.amount = vm.formData.amount;
          payload.basket = false;
          payload.schemes = [
            {
              "schemeCode": vm.journeyDetails.schemes[0].schemeCode,
              "schemeName": vm.journeyDetails.schemes[0].schemeName,
              "schemeType": vm.journeyDetails.schemes[0].schemeType,
            }
          ]

          if (vm.formData.transactionType === 'SIP') {
              payload.sipStartDate =  $window.moment(vm.formData.sipStartDate,"DD-MMM-YYYY").format("DD-MMM-YYYY"),
              payload.sipEndDate = $window.moment(vm.formData.sipEndDate,"DD-MMM-YYYY").format("DD-MMM-YYYY")
          }


          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              if (vm.isFromPreLogin) {
                $state.go("preLoginBasket.folioCreation",{
                  journey : vm.journeyDetails.journey,
                  retirement: vm.retirement
                });
              } else {
                $state.go('main.investment.folio',{
                  journey : vm.journeyDetails.journey,
                  retirement: vm.retirement
                });
              }
            } else {
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };

          InvestmentBasketService.post({
            child1: 'investment',
            child2: 'basket',
            child3: 'saveDetails'
          }, payload).$promise.then(success, error);

        }
        function resetNumInWords() {
          vm.amountInWords = '';
          var inWordsDiv = $window.document.getElementById('divDisplayWords');
          if (inWordsDiv) {
            inWordsDiv.innerHTML = '';
          }
        }

        function convertToLocalString(number) {
          if (number) {
            return number.toLocaleString("en-IN");
          }
        }

        function getRandomOTPId() {
          var successRandomOTPIdHandler = function(resp) {
            sessionStorage.setItem('randomOTPIdForGoalKYIPAndBasket', resp.randomOTPId);
          }, errorRandomOTPIdHandler = function (){}
          UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
        }

      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('transaction', transactionDirective);

  /*@ngInject*/
  function transactionDirective($state, $window, AuthService, LoaderService, AppConstants, MessageService, InvestmentBasketService, UtilService, ModalService, HDFC_API, $timeout) {
    return {
      restrict: 'E',
      scope: {
        id: '=',
        journey: '=',
        fromPreLogin : '=',
        retirement: '=',
        showReset: '&'
      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/transaction-directive/transaction.directive.html',
      link: function ($scope) {
        var vm = $scope;
        vm.TRANSACTION_TYPE = AppConstants.INVESTMENT_BASKET.TRANSACTION_TYPE;
        vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
        vm.viewMode = 'days';
        vm.basketDetails = {};
        vm.journeyDetails = null;
        vm.formData = {
          transactionType: vm.TRANSACTION_TYPE.LUMPSUM,
          amount: null,
          sipStartDate: null,
          sipEndDate: null
        };
        vm.calendarRange = {
          minSipStartDate: null,
          maxSipStartDate: null,
          minSipEndDate: null,
          maxSipEndDate: null,
        };

        vm.minAmount = null;
        vm.amountOptions = [];
        vm.schemeCodes = [];
        vm.formData.frequency = 'OM';
        vm.amountInWords = '';
        vm.changeTillPerpetuityFlag = changeTillPerpetuityFlag;
        vm.formData.isTillPerpetuity = true;
        vm.showRadio = true;
        vm.isMinor = false;
        vm.convertToLocalString = convertToLocalString;
        vm.getProceedBtnLbl = getProceedBtnLbl;
        vm.disclaimer = null;
        vm.constants = AppConstants;
        vm.retirement = null;
        vm.editBasket = editBasket;
        vm.isEdit = false;
        vm.isBasketCustomized = false;
        vm.resetDetails = false;
        vm.detailsSavedFromEditIcon = false;
        vm.editSchemeAmount = editSchemeAmount;
        vm.changeBasketName = changeBasketName;
        vm.resetBasketDetails = resetBasketDetails;
        vm.$on('resetBasketDetails', function(event, data) {
          resetBasketDetails();
        });
        vm.form = {
          basketForm: {}
        };

        init();

        function init() {
          sessionStorage.removeItem('viaViewDetails');
          vm.invType = sessionStorage.getItem('userType');
          var randomOTPId = sessionStorage.getItem('randomOTPIdForGoalKYIPAndBasket');
          if(!randomOTPId) {
            getRandomOTPId();
          }
          getBasketDetails();
          var successHandler = function(resp) {
            if (vm.journey === AppConstants.JOURNEY.INVESTMENT_BASKET_JOURNEY && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket &&
              resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket !== undefined) {
              vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket.content;
            } else if (vm.journey === AppConstants.JOURNEY.GOAL_JOURNEY && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey &&
              resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey !== undefined) {
              vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey.content;
            } else if ((vm.journey === "PERSONALITY" || vm.journey === AppConstants.JOURNEY.RISK_JOURNEY) && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile &&
              resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile !== undefined) {
              vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile.content;
            }
          };
          UtilService.fetchDynamicData("INVESTMENT_BASKET").then(successHandler).catch(function(resp) {
            MessageService.error(resp);
          });

          UtilService.fetchMandateValidations().then(function (resp) {
            vm.emandateObj = resp.eOTM;
            vm.mandateInfo = vm.emandateObj.mandateInfo;
          }).catch(function(resp) {
            MessageService.error(resp)
          });
        }

        function getBasketDetails() {
          var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              vm.basketDetails = resp.data;
              vm.copyBasketDetails = angular.copy(vm.basketDetails);
              vm.recommendedBasketName = resp.data.basketName;
              vm.amountOptions = vm.basketDetails.amountArray;
              vm.minAmount = vm.basketDetails.minBasketAmount;

              // Setting SIP start date range
              var todayDate = $window.moment();
              todayDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
              todayDate.toISOString()
              todayDate.format();
              vm.calendarRange.minSipStartDate = $window.moment(todayDate).add(resp.data.sipTDay, 'days');
              vm.calendarRange.maxSipStartDate = $window.moment(todayDate).add(90, 'days');
              getDetails(function () {
                getValidations(function () {
                  setAmountBasedOnTransactionType();
                });
                if(vm.journeyDetails.goalName == 'Retirement'){
                  sessionStorage.setItem('onlyIndividualFolioCreation',true);
                }else{
                  sessionStorage.setItem('onlyIndividualFolioCreation',false);
                }
              });
              vm.basketDetails.schemesInBasket.forEach(function (scheme) {
                var fundType = scheme.direct ? 'direct' : 'regular';
                scheme.fundUrl = HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + scheme.linkUrl + '/' + fundType;
              });
            }
          }, error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err)
          }

          LoaderService.showLoader();

          InvestmentBasketService.get({
            child1: 'investment',
            child2: 'basket',
            child3: 'getBasketDetails',
            child4: vm.id
          }).$promise.then(success, error);
        }

        function getValidations(cb) {
          cb = cb ||function () {

          };
          vm.schemeCodes = vm.basketDetails.schemesInBasket.map(function (scheme) { return scheme.schemeCode });
          var success = function (resp) {
            if (resp.status && resp.data) {
              vm.validations = resp.data.validationDTOMap;
              cb();
            }
          }, error = function (err) {
            MessageService.error(err)
          }

          InvestmentBasketService.post({
              child1: 'investment',
              child2: 'basket',
              child3: 'validate',
              child4: 'schemes'
            },
            {
              "schemeCodes": vm.schemeCodes,
              "transactionType": vm.formData.transactionType
            }).$promise.then(success, error);
        }

        function saveDetails(requestBody, fromSaveBtn, fromReset) {
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              if(fromSaveBtn) {
                vm.editBasketDetailsSaved = fromReset ? false : true;
                vm.detailsSavedFromEditIcon = true;
                if (vm.journeyDetails && (vm.journeyDetails.journey === "GOAL_JOURNEY")) {
                  var goalDetails = sessionStorage.getItem('reviewDataFromGoalJourney') ? JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')) : {};
                  goalDetails.isBasketCustomized = true;
                  sessionStorage.setItem('reviewDataFromGoalJourney', JSON.stringify(goalDetails));
                }
                return;
              }
              sessionStorage.setItem('journeyDraftId', resp.data.id);
              var folioSelectedForNewFolio = sessionStorage.getItem('folioSelectedForNewFolio') === 'true' ?  true :  false;
              if (folioSelectedForNewFolio && sessionStorage.getItem('folioSelected')) {
                if (vm.fromPreLogin) {
                  $state.go("preLoginBasket.folioCreation",{
                    journey : vm.journey,
                    retirement: vm.retirement
                  });
                } else {
                  $state.go('main.investment.folio',{
                    journey : vm.journey,
                    retirement: vm.retirement
                  });
                }
              } else if (!folioSelectedForNewFolio && sessionStorage.getItem('folioSelected')) {
                if (vm.journey === 'GOAL_JOURNEY') {
                  if (vm.fromPreLogin) {
                    $state.go("preLoginBasket.folioCreation",{
                      journey : vm.journey,
                      retirement: vm.retirement
                    });
                  } else {
                    $state.go('main.investment.folio',{
                      journey : vm.journey,
                      retirement: vm.retirement
                    });
                  }
                } else {
                  if (vm.fromPreLogin) {
                    $state.go('preLoginBasket.review');
                  } else {
                    $state.go('main.investment.review');
                  }
                }
              } else if (!folioSelectedForNewFolio && !sessionStorage.getItem('folioSelected')) {
                if (vm.fromPreLogin) {
                  $state.go("preLoginBasket.folioCreation",{
                    journey : vm.journey,
                    retirement: vm.retirement
                  });
                } else {
                  $state.go('main.investment.folio',{
                    journey : vm.journey,
                    retirement: vm.retirement
                  });
                }
              }

              /*if (sessionStorage.getItem('folioSelected')) {
                if (vm.journey === 'GOAL_JOURNEY') {
                  if (vm.fromPreLogin) {
                    $state.go("preLoginBasket.folioCreation",{
                      journey : vm.journey
                    });
                  } else {
                    $state.go('main.investment.folio',{
                      journey : vm.journey
                    });
                  }
                } else {
                  if (vm.fromPreLogin) {
                    $state.go('preLoginBasket.review');
                  } else {
                    $state.go('main.investment.review');
                  }
                }
              } else {
                if (vm.fromPreLogin) {
                  $state.go("preLoginBasket.folioCreation",{
                    journey : vm.journey
                  });
                } else {
                  $state.go('main.investment.folio',{
                    journey : vm.journey
                  });
                }
              }*/
            } else {
              vm.editBasketDetailsSaved = fromReset && !vm.detailsSavedFromEditIcon ? false : true;
              MessageService.error(resp.message);
            }
          }, error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err)
          }

          LoaderService.showLoader();

          InvestmentBasketService.post({
            child1: 'investment',
            child2: 'basket',
            child3: 'saveDetails'
          }, requestBody).$promise.then(success, error);
        }

        function getDetails(cb) {
          var journeyDraftId = sessionStorage.getItem("journeyDraftId");
          if (!journeyDraftId) {
            return saveFirstStepDetails();
          }

          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.journeyDetails = resp.data;
              vm.defaultSuggestedAmt = vm.journeyDetails.suggestedBasketAmount;
              vm.isBasketCustomized = resp.data.isBasketCustomized || false;
              vm.customBasketName = resp.data.suggestedBasketName;
              if(vm.isBasketCustomized && vm.journeyDetails && vm.journeyDetails.customizedBasketDetails) {
                vm.minAmount = null;
                vm.basketDetails.schemesInBasket = vm.journeyDetails && vm.journeyDetails.customizedBasketDetails.schemesInBasket;
                vm.customBasketName = vm.journeyDetails.customizedBasketDetails.basketName;
                vm.isEditBasketName = true;
                vm.showReset({data: true});
                vm.initialTotalAmount = angular.copy(vm.journeyDetails.amount);
                vm.editBasketDetailsSaved = true;
                if(vm.journey === 'GOAL_JOURNEY' && vm.journeyDetails.preLogin) {
                  var details = sessionStorage.getItem('reviewDataFromGoalJourney') ? JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')) : {};
                  details.isBasketCustomized = true;
                  sessionStorage.setItem('reviewDataFromGoalJourney', JSON.stringify(details));
                }
              }

              if (resp.data.journey === 'GOAL_JOURNEY') {
                vm.showRadio = false;
                vm.formData.transactionType = vm.journeyDetails.transactionType;
                vm.onTransTypeChange();
              }
              vm.formData = {
                transactionType: vm.journeyDetails.transactionType ? vm.journeyDetails.transactionType : vm.TRANSACTION_TYPE.LUMPSUM,
                amount: vm.journeyDetails.amount,
              };

             /* if (vm.journeyDetails.folioNumber) {
                sessionStorage.setItem("folioSelected", vm.journeyDetails.folioNumber);
              }*/
              cb();
            }
          }, error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err)
          }

          LoaderService.showLoader();

          InvestmentBasketService.get({
            child1: 'investment',
            child2: 'basket',
            child3: 'getDetails',
            child4: journeyDraftId,
          }).$promise.then(success, error);
        }

        function saveFirstStepDetails() {
          var identifierData = AuthService.getToken();
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              sessionStorage.setItem("journeyDraftId", resp.data.id);
            }
          }, error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err)
          }

          LoaderService.showLoader();

          var requestBody = {
            "panNumber": identifierData.investorPAN,
            "journey": "INVESTMENT_BASKET_JOURNEY",
            "step": "FIRST",
            "basket": true,
            "basketDetails": {
              "basketId": vm.id,
              "basketName": vm.basketDetails.basketName
            }
          }

          InvestmentBasketService.post({
            child1: 'investment',
            child2: 'basket',
            child3: 'saveDetails'
          }, requestBody).$promise.then(success, error);
        }

        vm.onAmountChange = function (value) {
          if (!value) {
            value = null;
          }

          vm.tForm.amount.$setDirty();
          vm.tForm.amount.$setValidity("schemeAmountError", true);
          if (value) {
            vm.formData.displayAmount = parseInt(value.toString().replaceAll(",", "")).toLocaleString('en-IN');
            vm.formData.amount = parseInt(vm.formData.displayAmount.toString().replaceAll(",", ""));
          } else {
            vm.formData.amount = null;
          }
          if (vm.formData.amount) {
            $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
          } else {
            vm.formData.amountInWords = null;
          }
          var sum = 0;
          vm.basketDetails.schemesInBasket.sort(function (b, a) { return a.allocation - b.allocation; });
          vm.basketDetails.schemesInBasket.forEach(function (scheme, index) {
            if(!vm.isBasketCustomized) {
              if (vm.basketDetails.schemesInBasket.length - 1 !== index) {
                scheme.amount = Math.round((vm.formData.amount * scheme.allocation) / 100);
                sum += scheme.amount;
              } else {
                scheme.amount = vm.formData.amount - sum;
              }
              scheme.initialAmount = angular.copy(scheme.amount);
              vm.initialTotalAmount = vm.initialTotalAmount ? vm.initialTotalAmount : angular.copy(vm.formData.amount);
            }

            // if (scheme.minAmount > scheme.amount) {
            //   scheme.errorMsg = 'Amount is less than the minimum amount for the scheme.';
            //   vm.schemeAmountError = true;
            // } else if ((scheme.amount % scheme.multiplesOf) != 0) {
            //   scheme.errorMsg = 'Please provide amount in multiples of ₹' + scheme.multiplesOf;
            //   vm.schemeAmountError = true;
            // } else {
            //   scheme.errorMsg = '';
            //   vm.schemeAmountError = false;
            // }
            scheme.amount = Math.floor(parseFloat(scheme.amount));
            scheme.customSchemeAmount = Math.floor(parseFloat(scheme.amount));
            scheme.customSchemeAmountDisplay = parseInt(scheme.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
          });
          checkValidation();
        }

        vm.onTransTypeChange = function (transactionTypeChange) {
          vm.formData.amount = null;
          vm.formData.displayAmount= null;
          vm.formData.sipStartDate = null;
          vm.formData.sipEndDate = null;
          vm.formData.amountInWords = null;
          resetNumInWords();
          // if (vm.isMinor) {
          //   if (vm.formData.transactionType === vm.TRANSACTION_TYPE.LUMPSUM)
          //     ModalService.minorPurchaseModal({});
          //   else
          //     ModalService.minorSipModal({});
          // }
          //vm.onAmountChange(vm.formData.amount);
          vm.tForm.$setUntouched();
          vm.tForm.$setPristine();
          if (vm.formData.transactionType === vm.TRANSACTION_TYPE.SIP) {
            vm.formData.isTillPerpetuity = true;
          }
          vm.isEdit = false;
          if(transactionTypeChange) {
            resetBasketDetails(transactionTypeChange);
          }
          getValidations(function () {
            setAmountBasedOnTransactionType();
          });
        };

        vm.changeStartDate = function (value) {
          if (value) {
            vm.formData.sipStartDate = value;
          }
          // updateEndDates();
          if (vm.journeyDetails.journey === 'GOAL_JOURNEY') {
            var timeInMonths = JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')).timeInMonths;
            timeInMonths = timeInMonths -1;
            var endDate = $window.moment(vm.formData.sipStartDate, "DD-MMM-YYYY").add(timeInMonths, 'months');
            vm.formData.sipEndDate = vm.formData.sipEndDate && vm.isEdit ? $window.moment(vm.formData.sipEndDate, "DD-MMM-YYYY").format("DD-MMM-YYYY") : $window.moment(endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
          }
          // else {
            updateEndDatesForBasket();
          // }
        }

        vm.changeEndDate = function (value) {
          if(!value) {
            vm.formData.sipEndDate = null;
            vm.formData.isTillPerpetuity = false;
            return;
          }
          if (value) {
            vm.formData.sipEndDate = value;

            var month = $window.moment(vm.formData.sipEndDate, 'DD-MMM-YYYY').month() + 1;
            var year = $window.moment(vm.formData.sipEndDate, 'DD-MMM-YYYY').year();
            var startDateMonth = $window.moment(vm.formData.sipStartDate, 'DD-MMM-YYYY').month() + 1;

            if ((month !== startDateMonth && year !== 2099) || (month !== startDateMonth && year === 2099) || (month == startDateMonth && year !== 2099)) {
              vm.formData.isTillPerpetuity = false;
              changeTillPerpetuityFlag('eventFromMethod');
            } else if (month === startDateMonth && year === 2099) {
              vm.formData.isTillPerpetuity = true;
              changeTillPerpetuityFlag('eventFromMethod');
            }
          }
        }

        function validateForm() {
          return (vm.tForm.$invalid ? false : true);
        }

        vm.viewDetails = function () {
          sessionStorage.setItem('viaViewDetails', true);
          $state.go('main.investment.basketDetails', { id: vm.id });
        }

        vm.back = function () {
          if (vm.invType) {
            $window.history.back();
          } else {
            var url = sessionStorage.getItem('investNowBackUrl') || 'main.investment.basket';
            var params = sessionStorage.getItem('investNowBackParams');
            params = params ? JSON.parse(params) : {};
            if (url == 'main.investment.personality') {
              params.viaBack = true;
            }
            $state.go(url, params);
          }
        }

        vm.onProceed = function (fromSaveBtn, isBasketCustomized, fromReset) {
          var identifierData = AuthService.getToken();
          if (validateForm()) {
            var recommendedSchmesInBasket = vm.isBasketCustomized && vm.journeyDetails.basketDetails.schemesInBasket ? vm.journeyDetails.basketDetails.schemesInBasket : vm.copyBasketDetails && vm.copyBasketDetails.schemesInBasket;
            if(vm.journeyDetails && vm.journeyDetails.preLogin) {
              recommendedSchmesInBasket = vm.journeyDetails.basketDetails.schemesInBasket;
            }
            var requestBody = {
              "id": sessionStorage.getItem('journeyDraftId'),
              "folioNumber": sessionStorage.getItem('folioSelected') || "",
              "panNumber": identifierData.investorPAN,
              "journey": vm.journey === 'GOAL_JOURNEY' ? vm.journey : vm.journey === 'PERSONALITY' ? 'RISK_JOURNEY' : "INVESTMENT_BASKET_JOURNEY",
              "step": "SECOND",
              "transactionType": 'PURCHASE',
              "amount": isBasketCustomized ? vm.initialTotalAmount : vm.journeyDetails && vm.isBasketCustomized ? vm.journeyDetails.amount : vm.formData.amount,
              "basket": true,
              "basketDetails": {
                "basketId": vm.id,
                "basketName": vm.recommendedBasketName,
                "schemesInBasket": recommendedSchmesInBasket.map(function (scheme) {
                  return {
                    "schemeCode": scheme.schemeCode,
                    "schemeName": scheme.schemeName,
                    "schemeType": scheme.schemeType,
                    "amount": scheme.initialAmount ? scheme.initialAmount : scheme.amount
                  }
                })
              },
              'riskAppetite' : vm.journeyDetails.riskAppetite
            }

            if (vm.formData.transactionType == vm.TRANSACTION_TYPE.SIP) {
              requestBody.transactionType = 'SIP';
              requestBody.sipStartDate = $window.moment(vm.formData.sipStartDate, "DD-MMM-YYYY").format('DD-MMM-YYYY');
              requestBody.sipEndDate = $window.moment(vm.formData.sipEndDate, "DD-MMM-YYYY").format('DD-MMM-YYYY');
            }


            if (vm.journey === 'GOAL_JOURNEY') {
              var details = sessionStorage.getItem('reviewDataFromGoalJourney') ? JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')) : {};
              requestBody.goalId = details.goalId;
              requestBody.goalQuesAndAnsSet = details.goalQuesAndAnsSet;
            }
            if (vm.journey === 'PERSONALITY') {
              requestBody.riskAppetite = vm.journeyDetails.riskAppetite;
              requestBody.riskQuesAndAnsSet = vm.journeyDetails.riskQuesAndAnsSet;
            }

            requestBody.frequency = "MONTHLY";
            if(isBasketCustomized) {
              requestBody.isBasketCustomized = true;
              requestBody.customizedBasketDetails = {
                "totalAmount": vm.formData.amount,
                "basketName": vm.customBasketName,
                "schemesInBasket": vm.basketDetails.schemesInBasket.map(function(scheme) {
                  return {
                    "schemeCode": scheme.schemeCode,
                    "schemeName": scheme.schemeName,
                    "schemeType": scheme.schemeType,
                    "amount": scheme.customSchemeAmount
                  }
                })
              }
            } else {
              requestBody.isBasketCustomized = false;
            }
            //re
            // vm.dataForReviewScreen = {
            //   "goalName" : vm.formData.goalName,
            //   "additionalData" : vm.suggestionData,
            //   "goalId" : goalPayload.goalId,
            //   "goalQuesAndAnsSet" : goalPayload.goalQuestionDetailSet
            // };

            vm.formData.transactionType === "SIP" && $window.moment(vm.formData.sipStartDate).isValid() ? saveDetails(requestBody, fromSaveBtn, fromReset) : saveDetails(requestBody, fromSaveBtn, fromReset);
          }
        }

        function updateEndDatesForBasket() {
          if (!vm.formData.sipStartDate) {
            return;
          }

          var defaultEndDate = $window.moment((new Date()), "DD-MM-YYYY").add(99, 'years');
          //var defaultEndDate = new Date(2036, 12, 31);
          var defaultMonths = null;
          var endDate = null;
          var enabledEndDates = [];
          var freq = vm.validations && vm.validations.maxInstallments || 0;
          var i = 0;
          var frequency = vm.frequencyList.find(function (f) {
            return f.code === vm.formData.frequency;
          }) || {};

          var months = 0;
          endDate = $window.moment(vm.formData.sipStartDate, "DD-MMM-YYYY").clone().add(frequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.duration);
          for (i = 0; i < freq; i++) {
            months = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }

          var minInstallments = null;
          var maxOfAllSchemes = vm.basketDetails.schemesInBasket[0].minInstallments;
          vm.validations && vm.basketDetails.schemesInBasket.forEach(function (scheme) {
            if(scheme.minInstallments && (scheme.minInstallments > maxOfAllSchemes)) {
              maxOfAllSchemes = scheme.minInstallments;
            }
          });
          minInstallments = maxOfAllSchemes - 1 || 0;

          vm.enabledEndDates = enabledEndDates.slice(minInstallments);
          vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
          vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
          changeTillPerpetuityFlag('updateEndDate');
        }

        function resetNumInWords() {
          vm.amountInWords = '';
          var inWordsDiv = $window.document.getElementById('divDisplayWords');
          var inWordsFirstInstallmentDiv = $window.document.getElementById('divDisplayWordFirstInstallment');
          if (inWordsDiv) {
            inWordsDiv.innerHTML = '';
          }
          if (inWordsFirstInstallmentDiv) {
            inWordsFirstInstallmentDiv.innerHTML = '';
          }
        }

        function changeTillPerpetuityFlag(from) {
          if (vm.formData.isTillPerpetuity) {
            vm.formData.sipEndDate = null;
            var day = moment(vm.formData.sipStartDate, 'DD-MMM-YYYY').date();
            var month = moment(vm.formData.sipStartDate, 'DD-MMM-YYYY').month();
            var newEndDate = day + '/'+ (month + 1) +'/2099';
            vm.formData.sipEndDate = moment(newEndDate, 'DD-MM-YYYY');
            // vm.formData.sipEndDate = moment(vm.formData.sipStartDate,'DD-MMM-YYYY').add(90,'years')
          } else if ((from !== 'eventFromMethod' && from !== 'updateEndDate') || (vm.formData.sipEndDate && !(($window.moment(vm.formData.sipEndDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || ($window.moment(vm.formData.sipEndDate).isSame($window.moment(vm.enabledEndDates[0]))) || ($window.moment(vm.formData.sipEndDate).isSame($window.moment(vm.enabledEndDates.length - 1)))))) {
            vm.formData.sipEndDate = null;
          }
        }
        function convertToLocalString(number) {
          if (number) {
            return parseInt(number).toLocaleString("en-IN");
          }
        }

        function getProceedBtnLbl() {
          return (vm.journey !== 'GOAL_JOURNEY' && sessionStorage.getItem('folioSelected') ?
            'Proceed' : 'Proceed to Folio Creation');
        }

        function editBasket(editValue) {
          // vm.isEdit = !editValue;
          // vm.disableFields = compareBasketAmount();
          vm.basketDetails.basketName = vm.customBasketName && vm.customBasketName.length > 0 ? angular.copy(vm.customBasketName): vm.basketDetails.basketName;
          vm.showReset({data: true});
          if (!editValue) {
            vm.isEdit = true;
            vm.isEditBasketName = true;
            vm.basketDetails && vm.basketDetails.schemesInBasket.forEach(function (scheme) {
              //Checking min, max, scheme level validation on click of edit icon
              editSchemeAmount(scheme);
            });
          } else {
            vm.isEdit = false;
            vm.disableFields = true;
            checkValidation();
            vm.isEditBasketName = false;
            $timeout(function () {
              vm.onProceed(true, true);
            });
          }
        }

        function changeBasketName(name) {
          vm.customBasketName = name;
        }

        function editSchemeAmount(scheme) {
          if (!scheme) {
            return;
          }
          if (scheme.customSchemeAmountDisplay) {
            vm.minAmount = null;
            vm.basketDetails.basketName = vm.customBasketName && vm.customBasketName.length > 0 ? angular.copy(vm.customBasketName): vm.basketDetails.basketName;
            vm.isEditBasketName = true;
            scheme.customSchemeAmountDisplay = parseInt(scheme.customSchemeAmountDisplay.toString().replaceAll(",", "")).toLocaleString('en-IN');
            scheme.customSchemeAmount = parseInt(scheme.customSchemeAmountDisplay.toString().replaceAll(",", ""));
            // scheme.initialAmount = scheme.amount;
            scheme.amount = scheme.customSchemeAmount;
            if (scheme.minAmount > scheme.amount) {
              scheme.errorMsg = 'Minimum amount should be ₹' + scheme.minAmount;
            } else if ((scheme.amount % scheme.multiplesOf) != 0) {
              scheme.errorMsg = 'Please provide amount in multiples of ₹' + scheme.multiplesOf;
            } else if (scheme.maxSipAmount && (scheme.customSchemeAmount >= scheme.maxSipAmount)) {
              scheme.errorMsg = vm.VALIDATE_DATA.AMOUNT_EXCEEDED;
            } else {
              scheme.errorMsg = null;
            }
          } else {
            scheme.customSchemeAmount = null;
            scheme.customSchemeAmountDisplay = null;
            vm.isEditBasketName = false;
            scheme.errorMsg = 'Minimum amount should be ₹' + scheme.minAmount;
          }
          if (vm.isEdit === true) { //executed on save button click and on amount change in scheme level
            vm.formData.amount = null;
            var schemeError = [];
            vm.basketDetails.schemesInBasket.forEach(function(scheme) {
              vm.formData.amount += scheme.customSchemeAmount ? parseInt(scheme.customSchemeAmount) : 0;
              vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
              $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
              if(angular.isUndefined(scheme.errorMsg) || scheme.errorMsg === null || scheme.errorMsg === "") {
                schemeError.push(false);
              } else {
                schemeError.push(true);
              }
            });
            vm.schemeAmountError = schemeError.includes(true);
          }
        }

        function compareBasketAmount() {
          var exactValue = [];
          vm.basketDetails.schemesInBasket.forEach(function(scheme, index) {
            if (vm.copyBasketDetails.schemesInBasket[index].schemeCode === scheme.schemeCode) {
              if (parseInt(vm.copyBasketDetails.schemesInBasket[index].amount, 10) == scheme.customSchemeAmount) {
                exactValue.push(false);
              } else {
                exactValue.push(true);
              }
            }
          });
          vm.isAmountEdited = exactValue.includes(true);
          return vm.isAmountEdited;
        }

        function resetBasketDetails(transactionTypeChange) {
          vm.basketDetails = angular.copy(vm.copyBasketDetails);
          vm.isEdit = false;
          vm.showReset({data: false});
          vm.isEditBasketName = false;
          vm.disableFields = false;
          vm.editBasketDetailsSaved = false;
          vm.isBasketCustomized = false;
          vm.minAmount = vm.basketDetails.minBasketAmount;
          vm.customBasketName = vm.journeyDetails.suggestedBasketName;
          vm.basketDetails.basketName = vm.recommendedBasketName;
          vm.schemeAmountError = false;
          if (vm.journeyDetails.journey !== 'GOAL_JOURNEY') {
            vm.formData.isTillPerpetuity = true;
          } else if (vm.journeyDetails.journey === "GOAL_JOURNEY") {
            var goalDetails = sessionStorage.getItem('reviewDataFromGoalJourney') ? JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')) : {};
            goalDetails.isBasketCustomized = false;
            vm.formData.isTillPerpetuity = false;
            sessionStorage.setItem('reviewDataFromGoalJourney', JSON.stringify(goalDetails));
          }
          vm.resetDetails = true;
          setAmountBasedOnTransactionType(transactionTypeChange);
          if(!transactionTypeChange) {
            vm.onProceed(true, false, true);
          }
        }

        function setAmountBasedOnTransactionType(transactionTypeChange) {
          if (vm.formData.transactionType == vm.TRANSACTION_TYPE.SIP) {
            if (vm.journey === 'GOAL_JOURNEY') {
              var details = sessionStorage.getItem('reviewDataFromGoalJourney') ? JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')) : {};
              if(((details.isBasketCustomized && vm.journeyDetails)) && vm.journeyDetails.customizedBasketDetails) {
                vm.formData.amount = vm.journeyDetails.customizedBasketDetails.totalAmount;
              } else if (vm.journeyDetails && vm.journeyDetails.amount && !vm.resetDetails) {
                vm.formData.amount = vm.journeyDetails.amount;
              } else if (vm.resetDetails && vm.defaultSuggestedAmt) {
                vm.formData.amount = vm.defaultSuggestedAmt;
              } else {
                vm.formData.amount = details.additionalData.amount;
              }
              vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
            } else {
              if(vm.journeyDetails.transactionType !== vm.formData.transactionType && !vm.isBasketCustomized){
                vm.formData.amount = vm.defaultSuggestedAmt;
                vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
              } else if (vm.isBasketCustomized && vm.journeyDetails && vm.journeyDetails.customizedBasketDetails) {
                vm.formData.amount = vm.journeyDetails.customizedBasketDetails.totalAmount || 0;
              } else{
                vm.formData.amount = vm.journeyDetails.amount && !vm.resetDetails? vm.journeyDetails.amount : vm.defaultSuggestedAmt;
                vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
              }
            }
          } else {
            if (vm.journey === 'GOAL_JOURNEY') {
              var details = sessionStorage.getItem('reviewDataFromGoalJourney') ? JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')) : {};
              if(((details.isBasketCustomized && vm.journeyDetails)) && vm.journeyDetails.customizedBasketDetails) {
                vm.formData.amount = vm.journeyDetails.customizedBasketDetails.totalAmount
              } else if (vm.journeyDetails && vm.journeyDetails.amount && !vm.resetDetails) {
                vm.formData.amount = vm.journeyDetails.amount;
              } else if (vm.resetDetails && vm.defaultSuggestedAmt) {
                vm.formData.amount = vm.defaultSuggestedAmt;
              } else {
                vm.formData.amount = details.additionalData.amount
              }
              vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
            } else {
              if(vm.journeyDetails.transactionType !== vm.formData.transactionType){
                vm.formData.amount = vm.defaultSuggestedAmt;
                vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
              } else if (vm.isBasketCustomized && vm.journeyDetails && vm.journeyDetails.customizedBasketDetails) {
                vm.formData.amount = vm.journeyDetails.customizedBasketDetails.totalAmount || 0;
              } else{
                vm.formData.amount = vm.journeyDetails.amount && !vm.resetDetails ? vm.journeyDetails.amount: vm.defaultSuggestedAmt;
                vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
              }
            }
          }
          if (vm.formData.amount && !transactionTypeChange) {
            vm.onAmountChange(vm.formData.amount);
          }
        }

        function checkValidation() {
          vm.basketDetails.maxMonths = 0;
          if (vm.formData.transactionType == vm.TRANSACTION_TYPE.SIP) {
            vm.formData.sipStartDate = vm.journeyDetails.sipStartDate || null,
              vm.formData.sipEndDate = vm.formData.sipEndDate ? vm.formData.sipEndDate : vm.journeyDetails.sipEndDate ?  vm.journeyDetails.sipEndDate : null;
            vm.formData.frequency = "OM";
            vm.basketDetails.schemesInBasket.forEach(function (scheme, index) {
              if(vm.isBasketCustomized && vm.journeyDetails && vm.journeyDetails.basketDetails && vm.journeyDetails.basketDetails.schemesInBasket) {
                scheme.initialAmount = vm.journeyDetails.basketDetails.schemesInBasket[index].amount;
              }
              if (vm.validations[scheme.schemeCode].retirementFlag === true) {
                vm.retirement = vm.validations[scheme.schemeCode].retirementFlag;
              }
              var newValidation = vm.validations[scheme.schemeCode].additionalValidation.OM;
              var schemeDistributedAmount = null;
              if(vm.editBasketDetailsSaved) {
                schemeDistributedAmount = Math.floor(parseFloat(scheme.customSchemeAmount));
              } else {
                schemeDistributedAmount = Math.floor(parseFloat(scheme.amount));
              }

              for (var i = 0; i < newValidation.length; i++) {
                var condition = schemeDistributedAmount < newValidation[i].min_amount_lower || schemeDistributedAmount <= newValidation[i].min_amount_upper;
                if (!newValidation[i].min_amount_upper) {
                  var condition = true;
                }
                if (condition) {
                  scheme.minInstallments = newValidation[i].min_installments;
                  vm.basketDetails.maxMonths = Math.max(vm.basketDetails.maxMonths, newValidation[i].min_installments);
                  break;
                }
              }
              scheme.maxSipAmount = vm.validations[scheme.schemeCode].monMaxAmt;
              vm.frequencyList = vm.validations[scheme.schemeCode].additionalValidation.frequency ? vm.validations[scheme.schemeCode].additionalValidation.frequency : null;
              vm.formData.sipStartDate = vm.journeyDetails.sipStartDate ? vm.journeyDetails.sipStartDate : vm.calendarRange.minSipStartDate;
              // changeTillPerpetuityFlag('updateEndDate');
            });
            vm.basketDetails.schemesInBasket.forEach(function (scheme, index) {
              var lowerMinAmt = Infinity;
              var newValidation1 = vm.validations[scheme.schemeCode].additionalValidation.OM;
              for(var j = 0; j < newValidation1.length; j++) {
                if(newValidation1[j].hasOwnProperty('min_amount_lower') && newValidation1[j].min_amount_lower < lowerMinAmt) {
                  lowerMinAmt = newValidation1[j].min_amount_lower;
                  scheme.minAmount = newValidation1[j].min_amount_lower;
                  scheme.multiplesOf = newValidation1[j].amt_multiples;
                }
              }
            });
            vm.changeStartDate(vm.formData.sipStartDate);
            // Setting SIP end date range
            vm.calendarRange.minSipEndDate = $window.moment(vm.calendarRange.minSipStartDate).add(vm.basketDetails.maxMonths, 'months');
            vm.calendarRange.maxSipEndDate = $window.moment(vm.calendarRange.maxSipStartDate).add(vm.basketDetails.maxMonths, 'months');

          } else {
            vm.basketDetails.schemesInBasket.forEach(function (scheme, index) {
              if(vm.isBasketCustomized && vm.journeyDetails && vm.journeyDetails.basketDetails && vm.journeyDetails.basketDetails.schemesInBasket) {
                scheme.initialAmount = vm.journeyDetails.basketDetails.schemesInBasket[index].amount;
              }
              if (vm.validations[scheme.schemeCode].retirementFlag === true) {
                vm.retirement = vm.validations[scheme.schemeCode].retirementFlag;
              }
              scheme.multiplesOf = vm.validations[scheme.schemeCode].purchaseMultiple || 1;
              if (!vm.validations[scheme.schemeCode].addlPurchase) {
                scheme.isPurchaseMin = vm.validations[scheme.schemeCode].minFirstPurchaseAmt > vm.formData.amount;
                scheme.minAmount = vm.validations[scheme.schemeCode].minFirstPurchaseAmt;
              } else {
                scheme.isPurchaseMin = vm.validations[scheme.schemeCode].minAddlPurchaseAmt > vm.formData.amount;
                scheme.minAmount = vm.validations[scheme.schemeCode].minAddlPurchaseAmt;
              }
              if(scheme.maxSipAmount) {
                delete scheme.maxSipAmount;
              }
            });
          }
          vm.isMinor = sessionStorage.getItem('isMinorFolioSelected') === 'true' ? true : false;
          vm.copyBasketDetails = vm.isBasketCustomized && vm.journeyDetails ? angular.copy(vm.journeyDetails.basketDetails) : angular.copy(vm.basketDetails);
        }

        function getRandomOTPId() {
          var successRandomOTPIdHandler = function(resp) {
            sessionStorage.setItem('randomOTPIdForGoalKYIPAndBasket', resp.randomOTPId);
          }, errorRandomOTPIdHandler = function (){}
          UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('suggestionsDirective', suggestionsDirective);

  /*@ngInject*/
  function suggestionsDirective($timeout, $state, LoaderService, UtilService, MessageService, InvestmentBasketService, ModalService) {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/investment-baskets/investment-basket-directives/suggestions-directive/suggestions.directive.html',
      link: function (scope) {
        var _this = scope;
        _this.proceedToInvestment = proceedToInvestment;
        _this.suggestionList = {
          goalAmount: "7000000",
          duration: "5 Years",
          schemes: [
            {
              schemeName: "HDFC Mid Cap Opportunities Fund",
              schemeType: "Open-ended Thematic Equity Scheme",
              numberOfInvestor: "246876345",
              details: ["Direct plan", "Thematic/Secroral Equity"],
              sipAmount: "33,333.3"
            },
            {
              schemeName: "HDFC Mid Cap Opportunities Fund",
              schemeType: "Open-ended Thematic Equity Scheme",
              numberOfInvestor: "246876345",
              details: ["Direct plan", "Thematic/Secroral Equity"],
              sipAmount: "33,333.3"
            }
          ],
          baskets: [
            {
              basketName: "HDFC Balance Basket",
              basketSchemes: [
                {
                  schemeName: "HDFC Top 100 Fund",
                  sipAmount: "7581.7",
                  riskProfile: "Moderately High Risk",
                  type: ""
                },
                {
                  schemeName: "HDFC Top 100 Fund",
                  sipAmount: "7581.7",
                  riskProfile: "Very High Risk",
                  type: "Hybrid"
                },
                {
                  schemeName: "HDFC Banking & PSU Debit Fund",
                  sipAmount: "7581.7",
                  riskProfile: "Very High Risk",
                  type: ""
                },
                {
                  schemeName: "HDFC Banking & PSU Debit Fund",
                  sipAmount: "7581.7",
                  riskProfile: "Very High Risk",
                  type: ""
                }
              ]
            }
          ]
        };

        function proceedToInvestment(name,id) {
          if(true) {
            ModalService.sipOrPurchaseBasketModal({}, function () {
            });
          }else {
            ModalService.installmentDetailModal({}, function () {

            }, function () {

            });
          }
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('paymentData', paymentData);

  /*@ngInject*/
  function paymentData($timeout, $state, LoaderService, UtilService, MessageService, AppConstants, ModalService,
                       InvestorFileUploadServiceV3, InvestorService,$log, NewInvestorTransactionService, $window, $stateParams,
                       InvestmentBasketService, AuthService, $sce, HDFC_API, DownloadPdfService, FileSaver , TransactionService , investorServiceVersion, PaymentService) {
    return {
      restrict: 'E',
      scope: {
        dynamicDataSip : "=",
        dynamicDataPurchase : "="
      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/payment-directive/payment.directive.html',
      link: function (scope) {
        var _this = scope;
        _this.formData = {};
        _this.isOTMEnabled = true;
        _this.folioMinor = false;
        _this.billdeskPayload = {
          hidRequestId : "PGIME1000",
          hidOperation : "ME100",
          msg : ""
        };
        _this.IFSC_REGEX = AppConstants.ifsc_regex;
        _this.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
        _this.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
        _this.purchasePaymentOptions = [
          _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
        ];
        _this.otherPaymentOptions = [
          _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
          _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
          _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
        _this.sipPaymentOptions = [
          _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,
          _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE,
          _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC
        ];
        _this.rtgsBankTogg = false;
        _this.netBankingAndUPIList = null;
        _this.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff","application/pdf"];
        _this.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
        _this.getPaymentMode = getPaymentMode;
        _this.selectRtgsBank = selectRtgsBank;
        _this.fetchBankList = fetchBankList;
        _this.openUploadedDoc = openUploadedDoc;
        _this.bankUploadChequeLeafFile = bankUploadChequeLeafFile;
        _this.bankAccountTypes = bankAccountTypes;
        _this.fetchBankListForSip = fetchBankListForSip;
        _this.fetchBankListForSipUPI = fetchBankListForSipUPI;
        _this.changedSipPaymentOption = changedSipPaymentOption;
        _this.getAccountType = getAccountType;
        _this.fetchInvestorType = fetchInvestorType;
        _this.activeTabs = activeTabs;
        _this.purchaseActiveTabs = purchaseActiveTabs;
        _this.changeBank = changeBank;
        _this.changePurchaseBank = changePurchaseBank;
        _this.purchaseSubmitForm = purchaseSubmitForm;
        _this.sipSubmitForm = sipSubmitForm;
        _this.sipSubmitRegisterForm = sipSubmitRegisterForm;
        _this.getconfirmation = getconfirmation;
        _this.backToReview = backToReview;
        _this.confirmation = false;
        _this.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
        _this.billdeskUrl = HDFC_API.BILLDESK_URL;
        _this.existingInvestor = $stateParams.existingInvestor;
        _this.isFromPrelogin = $stateParams.fromPreLogin;
        _this.sipFirstInstallment = false;
        _this.liquidFlag = false;
        _this.isNewPayment = true;
        _this.copyPasteHandler = copyPasteHandler;
        _this.downloadPdfFile = downloadPdfFile;
        _this.PATTERN = AppConstants;
        _this.OTMList = null;
        _this.isUPIVerified = false;
        _this.isOTMDate = false;
        _this.isOTMStartDate = false;
        _this.isOTMAmount = false;
        _this.fetchRTGSBankList = fetchRTGSBankList;
        _this.verifyUPI = verifyUPI;
        _this.changeUpiVerified = changeUpiVerified;
        _this.selectedUpiBank = selectedUpiBank;
        _this.startDateValidation = false;
        _this.transactionOtmConfirmation = transactionOtmConfirmation;
        _this.defaultMandateYearDate = AppConstants.DEFAULT_EMANDATE_MAX_YEAR;
        _this.emandateMinAmountLimit = null;
        _this.checkAmountValidationEmandate = checkAmountValidationEmandate;
        _this.amountLess = false;
        _this.amountMore = false;
        _this.isLessThanSipAmount = false;
        _this.sipDateLessEmandate = false;
        _this.changeEndDateEmandate = changeEndDateEmandate;
        _this.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
        _this.viewMode = 'days';
        _this.minEmandateDate = null;
        _this.formData.emandateWord = {};
        _this.setDynamicNotes = setDynamicNotes;
        _this.formData.verifyUPIResp = {};
        _this.handleVpa = handleVpa;
        _this.redirectionDataForRazorPay = null;
        _this.randomOTPId = sessionStorage.getItem('randomOTPIdForGoalKYIPAndBasket');

        _this.init = function() {
          var transactionSuccess = sessionStorage.getItem('transactionSuccess') === "true" ? true: false;
          var invType = sessionStorage.getItem('userType');
          if (transactionSuccess) {
            if (invType === 'NEW') {
              $state.go('newInvestor.kycVerification');
            } else if (_this.isFromPrelogin) {
              $state.go('login');
            } else {
              $state.go('welcome');
            }
          }
          _this.formData.paymentInfo = null;
          var token = AuthService.getToken();
          if (token) {
            _this.userName = token.investorFName;
          }
          if ($stateParams.journeyId) {
            _this.formData.journeyId = $stateParams.journeyId;
            getJourneyDetails(function() {
              _this.formData.folioNumber = _this.journeyDetails.folioNumber ? _this.journeyDetails.folioNumber: sessionStorage.getItem("folioSelected");
              _this.folioMinor = sessionStorage.getItem('isMinorFolioSelected') === "true" ? true : false;
              _this.transactionType = _this.journeyDetails.transactionType;
              if(_this.journeyDetails.isBasketCustomized && _this.journeyDetails.customizedBasketDetails) {
                _this.formData.purchaseAmount = _this.journeyDetails.customizedBasketDetails.totalAmount;
              } else {
                _this.formData.purchaseAmount = _this.journeyDetails.amount;
              }
              _this.formData.investmentOption = _this.journeyDetails.investmentOption;
              _this.newFolio = _this.journeyDetails.newFolio ? _this.journeyDetails.newFolio : false;
              _this.nriFlag = _this.journeyDetails.nriFlag;

              getFolioDetailsData();
              if(_this.transactionType == 'PURCHASE'){
                if (!_this.journeyDetails.basket) {
                  _this.purchasePaymentOptions = _this.otherPaymentOptions;
                }
                _this.formData.purchasePaymentOption = _this.purchasePaymentOptions[0];
                _this.active = {0:true};
                getAccountType();
                changedPaymentOption();
              }else{
                _this.formData.sipPaymentOption = _this.sipPaymentOptions[0];
                _this.active = {0:true};
                fetchBankListForSip(function (success) {
                  if(success){
                    checkOTM(function (success){
                      if(success){
                        checkEMandate(function () {
                          if (!_this.emandateObj && !_this.upiObj) {
                            UtilService.fetchMandateValidations().then(function (resp) {
                              _this.emandateObj = resp.eOTM;
                              _this.upiObj = resp.upi;
                              setEmandateUpiSetting();
                            }).catch(function(resp) {
                              MessageService.error(resp)
                            });
                          } else {
                            var emandateEndDate = $window.moment(_this.journeyDetails.sipStartDate,'DD-MMM-YYYY').add(_this.emandateMaxYear,'years');
                            var emandateEndDateUPI = $window.moment().add(_this.upiMaxYear,'years');
                            var selectedEndDate = $window.moment(_this.journeyDetails.sipEndDate,'DD-MMM-YYYY');
                            var endDateEmandateBoundExist = selectedEndDate.isSameOrBefore(emandateEndDate);
                            var endDateEmandateBoundExistUPI = selectedEndDate.isSameOrBefore(emandateEndDateUPI);

                            if (!endDateEmandateBoundExist || _this.nriFlag) {
                              var index = _this.sipPaymentOptions.indexOf('E-mandate');
                              if(index > -1) {
                                _this.sipPaymentOptions.splice(index,1);
                              }
                            }

                            if (!endDateEmandateBoundExistUPI) {
                              var upiIndex = _this.sipPaymentOptions.indexOf('UPI');
                              if(upiIndex > -1) {
                                _this.sipPaymentOptions.splice(upiIndex,1);
                              }
                            }
                            _this.formData.sipPaymentOption = _this.paymentOptions[0];
                            _this.changedPaymentOption();
                          }
                        });
                      }
                    });
                  }
                })
                fetchBankListForSipUPI();
                getAccountType();
              }
              setDynamicNotes();
            });
          }
        };
        _this.init();

        function getPaymentMode(val) {
          _this.formData.ifscCode = null;
          _this.formData.bankAcType = null;
          if(_this.transactionType == 'PURCHASE') {
            _this.formData.purchasePaymentOption = val;
            changedPaymentOption();
            purchaseActiveTabs(val);
          }else {
            _this.formData.sipPaymentOption = val;
            changedSipPaymentOption();
            activeTabs(val);
          }
          setDynamicNotes();
        }
        function activeTabs(state){
          _this.active = {};
          var baseState = state;
          for ( var j = 0; j < _this.sipPaymentOptions.length; j++ ) {
            if ( _this.sipPaymentOptions[j] === baseState ) {
              _this.active[j] = true;
            }
          }
        }

        function purchaseActiveTabs(state) {
          _this.active = {};
          var baseState = state;
          for ( var j = 0; j < _this.purchasePaymentOptions.length; j++ ) {
            if ( _this.purchasePaymentOptions[j] === baseState ) {
              _this.active[j] = true;
            }
          }
        }

        function changedSipPaymentOption(){
          _this.formData.paymentInfo = null;
          _this.startDateValidation = false;
          _this.amountLess = false;
          _this.amountMore = false;
          _this.isLessThanSipAmount = false;
          _this.sipDateLessEmandate = false;

          switch (_this.formData.sipPaymentOption) {
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:
              _this.formData.endDateEmandate =  $window.moment(_this.enabledEmandateEndDatesList[_this.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
              _this.changeEndDateEmandate(_this.formData.endDateEmandate);
              if (_this.emandateObj) {
                _this.formData.emandateAmount = Math.floor(_this.emandateObj.defaultMandateAmount);
                _this.formData.displayAmountMandate = parseInt(_this.formData.emandateAmount.toString().replaceAll(",", "")).toLocaleString('en-IN');
                checkAmountValidationEmandate();
              }
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
              resetUPIForm();
              var validationObject = JSON.parse(sessionStorage.getItem('validationObject'));
              if(validationObject.validationDTOMap) {
                var keys = Object.keys(validationObject.validationDTOMap);
                _this.upiErrorMessage = validationObject.validationDTOMap[keys[0]].upiMaxAmountErrMessage;
                _this.upiMaxAmountLimit =  validationObject.validationDTOMap[keys[0]].upiMaxAmountLimit;
              } else {
                _this.upiErrorMessage = validationObject.upiMaxAmountErrMessage;
                _this.upiMaxAmountLimit =  validationObject.upiMaxAmountLimit;
              }

              if(_this.formData.purchaseAmount > _this.upiMaxAmountLimit) {
                var success = function() {
                  // _this.formData.purchasePaymentOption = _this.sipPaymentOptions[1];
                  if(_this.sipPaymentOptions.includes("OTM") && _this.isOTMEnabled) {
                    _this.formData.purchasePaymentOption = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
                  } else if(_this.sipPaymentOptions.includes("E-mandate") && _this.isEMandateEnabled) {
                    _this.formData.purchasePaymentOption = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
                  } else if(_this.sipPaymentOptions.includes("EC")){
                    _this.formData.purchasePaymentOption = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
                  } else {
                    _this.formData.purchasePaymentOption = null;
                  }
                  _this.getPaymentMode(_this.formData.purchasePaymentOption);
                }
                ModalService.genericModal({
                  text: _this.upiErrorMessage,
                  isUpi: true
                },success);
              }
              _this.formData.endDateEmandate =  $window.moment(_this.enabledEmandateEndDatesList[_this.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
              _this.changeEndDateEmandate(_this.formData.endDateEmandate);
              if (_this.emandateObj) {
                _this.formData.emandateAmount = Math.floor(_this.emandateObj.defaultMandateAmount);
                _this.formData.displayAmountMandate = parseInt(_this.formData.emandateAmount.toString().replaceAll(",", "")).toLocaleString('en-IN');
                checkAmountValidationEmandate();
              }
              break;
            default :

          }
        }

        function changedPaymentOption() {
          _this.confirmation = false;
          _this.formData.bankInfo = null;
          _this.bankList = null;
          _this.formData.paymentInfo = { amount: _this.formData.purchaseAmount };
          _this.isOTMAmount = false;
          _this.isOTMDate = false;
          _this.isOTMStartDate = false;
          _this.isInvalidForm = false;
          _this.bankInfo = null;
          _this.fileType='';
          _this.bankchequeLeafUrl=null;
          _this.formData.paymentInfo.chequeLeaf=null;
          _this.amountLess = false;
          _this.amountMore = false;
          _this.isLessThanSipAmount = false;
          _this.sipDateLessEmandate = false;

          switch (_this.formData.purchasePaymentOption) {
            //case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
              _this.formData.paymentInfo.paymentMode = "WEB";
              _this.fetchBankList();
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
              _this.formData.paymentInfo.paymentMode = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
              _this.fetchBankList();
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
              _this.formData.paymentInfo.paymentMode = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
              //_this.fetchRTGSBankList();
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
              _this.formData.paymentInfo.paymentMode = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC;
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
              resetUPIForm();
              _this.fetchBankList();
              _this.formData.paymentInfo.paymentMode = "WEB";
              _this.formData.paymentInfo.webMode = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
              if(_this.formData.purchaseAmount > _this.formData.upiLimit) {
                var success = function() {
                  // _this.formData.purchasePaymentOption = _this.paymentOptions[1];
                  if(_this.sipPaymentOptions.includes("OTM") && _this.isOTMEnabled) {
                    _this.formData.purchasePaymentOption = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
                  } else if(_this.sipPaymentOptions.includes("E-mandate") && _this.isEMandateEnabled) {
                    _this.formData.purchasePaymentOption = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
                  } else if(_this.sipPaymentOptions.includes("EC")){
                    _this.formData.purchasePaymentOption = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
                  } else {
                    _this.formData.purchasePaymentOption = null;
                  }
                  _this.changedPaymentOption();
                }
                ModalService.genericModal({
                  text: _this.formData.upiErrorMessage,
                  isUpi: true
                },success);
              }
              break;
          }
        }

        function fetchBankList() {
          LoaderService.showLoader();
          _this.bankList = null;
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.otmList = resp.data;
                if (_this.formData.purchasePaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
                  _this.bankList = _this.formData.sipFI ? resp.data.nonCOTMBankList : resp.data.bankList;
                } else {
                  _this.bankList = resp.data.bankList;
                }
                _this.bankList = _this.bankList.length ? _this.bankList : null;
                if (_this.formData.purchasePaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING ||
                  _this.formData.purchasePaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
                  _this.netBankingAndUPIList = _this.bankList;
                }
                if (_this.bankList && _this.bankList.length == 1) {
                  _this.formData.bankInfo = _this.bankList[0];
                  if (!_this.formData.bankInfo.minorBankFlag && _this.checkForMinorBankListCondition()) {
                    localStorage.setItem('folioId', _this.formData.folioNumber);
                    ModalService.minorBankModal({ folioDetailsData: _this.folioDetailsData });
                    return;
                  }
                  _this.formData.paymentInfo.tpvEnableFlag = _this.formData.bankInfo.tpvEnableFlag;
                  _this.formData.paymentInfo.accountNumber = _this.formData.bankInfo.accountNumber;
                  _this.formData.paymentInfo.webMode = _this.formData.bankInfo.gateWayVendor;
                  _this.formData.paymentInfo.bankCode = _this.formData.bankInfo.bankCode;
                  _this.formData.paymentInfo.payoutId = _this.formData.bankInfo.payoutId;
                  _this.formData.paymentInfo.omUmrn = _this.formData.bankInfo.omUmrn;
                  _this.formData.paymentInfo.otmId = _this.formData.bankInfo.otmId;
                  _this.formData.paymentInfo.bankName = _this.formData.bankInfo.bankName;
                  _this.formData.paymentInfo.bankBranch = _this.formData.bankInfo.bankBranch;
                  _this.formData.paymentInfo.bankAcNo = _this.formData.bankInfo.bankAcNo;
                  _this.formData.paymentInfo.ifscCode = _this.formData.bankInfo.ifscCode;
                  _this.formData.paymentInfo.bankAcType = _this.formData.bankInfo.bankAcType;
                  _this.formData.paymentInfo.eMandatebankAcNo = _this.formData.bankInfo.eMandatebankAcNo;
                  _this.formData.paymentInfo.eMandateUmrn = _this.formData.bankInfo.eMandateUmrn;
                  (angular.isDefined(_this.formData.bankInfo.camsMandateIdNo)) && (_this.formData.paymentInfo.camsMandateIdNo = _this.formData.bankInfo.camsMandateIdNo);
                  if (_this.formData.purchasePaymentOption == _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
                    selectedUpiBank();
                  }
                  if (_this.formData.purchasePaymentOption == _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS) {
                    _this.changePurchaseBank();
                  }
                }
              } else {
                _this.bankList = null;
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              _this.bankList = null;
              MessageService.error("Folio creation is in process please wait.");
              if(_this.loaderCounter < 4 && _this.netBankingAndUPIList === ""){
                $timeout(function(){
                  _this.callBankList();
                }, 15000);
                _this.loaderCounter = _this.loaderCounter + 1;
              }
            };
          LoaderService.showLoader();

          var config = null;
          switch (_this.formData.purchasePaymentOption) {
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
              if (_this.netBankingAndUPIList === "" || _this.netBankingAndUPIList === null) {
                InvestorService.post({ child1: 'bank', child2: 'list' }, {
                  trnxType: 'PURCHASE',
                  folioNumber: _this.formData.folioNumber,
                  liquidSchemeFlag: _this.liquidFlag,
                  newFolio: _this.newFolio
                }).$promise.then(success, error);
              }
              checkBankList();
              LoaderService.hideLoader();
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
              if (_this.OTMList === null) {
                config = { child1: 'folio', child2: 'otm' };
                InvestorService.post(config, {
                  folioNo: _this.formData.folioNumber,
                  transactionType: 'purchase'
                }).$promise.then(success, error);
              }
              _this.bankList = _this.OTMList;
              checkBankList();
              LoaderService.hideLoader();
              break;
            default:
              _this.bankList = null;
              config = null;
              break;
          }
        }

        function checkBankList() {
          if (_this.bankList && _this.bankList.length == 1) {
            _this.formData.bankInfo = _this.bankList[0];
            if (!_this.formData.bankInfo.minorBankFlag && _this.checkForMinorBankListCondition()) {
              localStorage.setItem('folioId', _this.formData.folioNumber);
              ModalService.minorBankModal({ folioDetailsData: _this.folioDetailsData });
              return;
            };
            _this.formData.paymentInfo.tpvEnableFlag = _this.formData.bankInfo.tpvEnableFlag;
            _this.formData.paymentInfo.accountNumber = _this.formData.bankInfo.accountNumber;
            _this.formData.paymentInfo.webMode = _this.formData.bankInfo.gateWayVendor;
            _this.formData.paymentInfo.bankCode = _this.formData.bankInfo.bankCode;
            _this.formData.paymentInfo.payoutId = _this.formData.bankInfo.payoutId;
            _this.formData.paymentInfo.omUmrn = _this.formData.bankInfo.omUmrn;
            _this.formData.paymentInfo.otmId = _this.formData.bankInfo.otmId;
            _this.formData.paymentInfo.bankName = _this.formData.bankInfo.bankName;
            _this.formData.paymentInfo.bankBranch = _this.formData.bankInfo.bankBranch;
            _this.formData.paymentInfo.bankAcNo = _this.formData.bankInfo.bankAcNo;
            _this.formData.paymentInfo.ifscCode = _this.formData.bankInfo.ifscCode;
            _this.formData.paymentInfo.eMandatebankAcNo = _this.formData.bankInfo.eMandatebankAcNo;
            _this.formData.paymentInfo.eMandateUmrn = _this.formData.bankInfo.eMandateUmrn;
            (angular.isDefined(_this.formData.bankInfo.camsMandateIdNo)) && (_this.formData.paymentInfo.camsMandateIdNo = _this.formData.bankInfo.camsMandateIdNo);
            // checkOTMAmountAndDate();
            if (_this.formData.purchasePaymentOption == _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
              selectedUpiBank();
            }
          }
        }

        function selectedUpiBank() {
          if (!_this.formData.bankInfo) {
            return;
          }
          if (!_this.formData.bankInfo.minorBankFlag && _this.checkForMinorBankListCondition()) {
            localStorage.setItem('folioId', _this.formData.folioNumber);
            ModalService.minorBankModal({ folioDetailsData: _this.folioDetailsData });
            _this.formData.bankInfo = null;
            _this.isCheckedDeclaration = false;
            return;
          }
          _this.upiAccountNumber = _this.formData.bankInfo.accountNumber;
          _this.upiBankName = _this.formData.bankInfo.bankName;
          _this.formData.paymentInfo.webMode = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
        }

        /*
        * Not getting used
        * */
        function selectRtgsBank() {
          _this.rtgsBankTogg = !_this.rtgsBankTogg;
          if(_this.rtgsBankTogg){
            if(_this.formData && _this.formData.paymentInfo){
              if(_this.formData.paymentInfo.bankName){
                _this.formData.paymentInfo.bankName = "";
              }
              if(_this.formData.paymentInfo.ifscCode){
                _this.formData.paymentInfo.ifscCode = "";
              }
            }
          } else {
            _this.formData.paymentInfo = _this.folioBankData && _this.folioBankData.bankList?_this.folioBankData.bankList[0]:null;
          }
        }

        function bankUploadChequeLeafFile(file) {
          if (_this.mimeType.indexOf(file.type) === -1) {
            MessageService.error("File format should be PDF, TIF, TIFF, JPG and JPEG extension.");
            return;
          }
          if (file) {
            if (file.size <= 2000000 || (file.type == 'application/pdf' && file.size <= 3145728)) {
              var success = function (resp) {
                  // LoaderService.hideLoader();
                  if (resp.status && resp.data) {
                    _this.bankchequeLeafUrl = resp.data.fileUrl;
                    _this.formData.paymentInfo.chequeLeaf = resp.data.fileUrl;
                    _this.fileType = file.type.split('/')[1];
                  }
                  else {
                    _this.fileType = '';
                    MessageService.error(resp.message);
                  }
                },
                error = function (err) {
                };

              if (file) {
                var fd = new FormData();
                fd.append('file', file);
                InvestorFileUploadServiceV3.post2({
                  child1: 'folio',
                  child2: 'upload',
                  child3: 'bankDetails',
                  child4: 'chequeLeaf'
                }, fd).$promise.then(success, error);
              }
            }
            else {
              MessageService.error("File size should not be more than 2 MB.")
            }
          }

        }

        function bankAccountTypes() {
          var success = function (resp) {
            if (resp.data && resp.status) {
              _this.bankAccountType = resp.data.bankAccountTypes;
              //$root_this.AccountTypes = resp.data.bankAccountTypes;
            }
            else {
              _this.panMessage = resp.message;
            }
          },
          error = function () {
            MessageService.error("Bank account type service error!");
          };
          InvestorService.get({ child1: 'folio', child2: 'bank', child3: 'account-type-list', child4: _this.folioTaxStatusCode }).$promise.then(success, error);
        }

        function openUploadedDoc() {
          if (angular.isUndefined(_this.bankchequeLeafUrl)) { return; }
          ModalService.showImage1({ docUrl: _this.bankchequeLeafUrl });
        }

        function downloadPdfFile(url, fileType) {
          var success = function (resp){
            LoaderService.hideLoader();
            if (resp.data) {
              var data = new Blob([resp.data], { type: 'application/'+fileType });
              FileSaver.saveAs(data, 'Cheque_Leaf.'+fileType);
            } else {
              MessageService.error('No Data Available');
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          LoaderService.showLoader();
          var payload = {};
          DownloadPdfService.downloadFile(payload, fileType, url).then(success, error);
        }

        function resetUPIForm() {
          _this.formData.verifyUPIResp = {};
          _this.isUPIVerified = false;
          (_this.formData.paymentInfo)&&(_this.formData.paymentInfo.virtualAddress = "");
        }

        function checkOTM(cb){
          cb = cb || function () {
          };
          var success = function (resp) {
              if (resp.status && resp.data) {
                if (resp.data.bankList.length == 0) {
                  _this.isOTMEnabled = false;
                  if(!(_this.checkForMinorBankListCondition())) {
                    if (_this.formData.frequency !== 'OW'){
                      if(_this.sipFirstInstallment)
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                      else
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                    }
                    else
                    {
                      if(_this.sipFirstInstallment)
                        _this.sipPaymentOptions = [];
                      else
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                    }
                    var index = _this.sipPaymentOptions.indexOf('OTM');
                    if(index > -1) {
                      _this.sipPaymentOptions.splice(index,1);
                    }
                    _this.formData.sipPaymentOption = _this.sipPaymentOptions[0];
                    if(!_this.bankList) {
                      if (_this.sipPaymentOptions.includes("EC")) {
                        var index = _this.sipPaymentOptions.indexOf('EC');
                        if (index > -1) {
                          _this.sipPaymentOptions.splice(index, 1);
                        }
                      }
                    }
                  }
                  if(_this.formData.isBackFromSummary || $stateParams.transactionId)
                  {
                    var frequency = _this.frequencyList && _this.frequencyList.find(function (item) {
                      return _this.formData.frequency === item.code;
                    }) || {};
                    _this.formData.frequency = frequency.code || '';

                  }

                }
                else {
                  if (_this.sipFirstInstallment && resp.data.nonCOTMBankList.length === 0) {
                    _this.isOTMEnabled = false;
                    if (_this.checkForMinorBankListCondition() || _this.formData.frequency === 'OW')
                      _this.sipPaymentOptions = [];
                    else
                      _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                  } else {
                    _this.isOTMEnabled = true;
                    if (_this.checkForMinorBankListCondition()) {
                      if(_this.sipFirstInstallment)
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                      else
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                    } else {
                      if(_this.sipFirstInstallment)
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                      else
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                    }
                  }
                  _this.formData.showTopUpBlock =  _this.formData.showTopUpBlock ? true : false;

                  if(!_this.backFromPayment)
                    _this.formData.sipPaymentOption= _this.sipPaymentOptions ? _this.sipPaymentOptions[0] : '';

                  if(_this.formData.isBackFromSummary || $stateParams.transactionId)
                  {
                    frequency = _this.frequencyList && _this.frequencyList.find(function (item) {
                      return _this.formData.frequency === item.code;
                    }) || {};
                    _this.formData.frequency = frequency.code || '';

                  }
                  _this.OTMbankList = _this.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList;
                }
              }

              cb(true);
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
              cb(false);
            };
          // LoaderService.showLoader();//need to check
          var payload = {
            transactionType:_this.transactionType.toLowerCase(),
            folioNo:_this.formData.folioNumber,
            newFolio: _this.newFolio
          };
          InvestorService.post({
            child1: 'folio',
            child2: 'otm'
          }, payload).$promise.then(success, error);
        }

        function fetchBankListForSip(cb) {
          cb = cb || function () {
          };
          //   LoaderService.showLoader();
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if(_this.formData.sipPaymentOption===_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
                  _this.eMandatenoOfDays=resp.data.noOfDays;
                  _this.eMandatemaxAmountLimit=resp.data.maxAmountLimit;
                  _this.formData.showTopUpBlock = false;
                  // if(_this.formData.inSchemeCode)
                  //   getDateValidation();
                  // checkEMandateValidation();
                }
                if (_this.formData.sipPaymentOption == 'OTM' && resp.data.bankList.length == 0) {
                  _this.formData.sipPaymentOption = _this.sipPaymentOptions[0];
                  _this.hideOtmRadio = true;
                  //fetchBankList();
                }
                else if (_this.formData.sipPaymentOption == 'OTM' && resp.data.bankList.length > 0) {
                  _this.hideOtmRadio = false;
                }
                else if (_this.formData.sipPaymentOption == 'EC') {
                  _this.ECbankList = resp.data.bankList;
                  if (_this.hideOtmRadio) {
                    if(_this.sipFirstInstallment)
                      _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                    else
                      _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                    _this.formData.sipPaymentOption = _this.sipPaymentOptions[0];
                    // if(_this.formData.inSchemeCode)
                    //   getDateValidation();
                  }
                  else {
                    if(_this.checkForMinorBankListCondition())
                    {
                      if(_this.sipFirstInstallment)
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                      else
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                    }
                    else {
                      if (_this.sipFirstInstallment)
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                      else
                        _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                    }
                    _this.hideOtmRadio = false;
                    // if(_this.formData.inSchemeCode)
                    //   getDateValidation();
                  }
                }

                _this.bankList = resp.data.bankList;

                if (_this.formData.sipPaymentOption == 'EC') {
                  for(var i = 0 ;  i < _this.bankList.length ; i++) {
                    _this.bankList[i].id = i;
                  }
                }

                if(_this.formData.sipPaymentOption===_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
                  _this.formData.authMode = _this.formData.bankInfo? (_this.formData.bankInfo.authenticationModes.length === 1 ? _this.formData.bankInfo.authenticationModes[0] : null) :null;
                  _this.authenticationMode = _this.formData.bankInfo ? _this.formData.bankInfo.authenticationModes: null;
                }
              } else {
                _this.bankList = null;
                MessageService.error(resp.message);
              }
              cb(true);
            },
            error = function (err) {
              LoaderService.hideLoader();
              _this.bankList = null;
              UtilService.errorHandler(err);
              cb(false);
            };
          // LoaderService.showLoader();

          if (_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC || _this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            if(!_this.ECbankList) {
              var payload = {
                "trnxType": 'PURCHASE',
                "folioNumber": _this.formData.folioNumber,
                "liquidSchemeFlag": _this.liquidFlag,
                "sipFlow": true,
                "newFolio": _this.newFolio
              };
              InvestorService.post({child1: 'bank', child2: 'list'}, payload).$promise.then(success, error);
            } else {
              LoaderService.hideLoader();
              if (_this.hideOtmRadio) {
                if(_this.sipFirstInstallment)
                  _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                else
                  _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                _this.formData.sipPaymentOption = _this.sipPaymentOptions[0];
                // if(_this.formData.inSchemeCode)
                //   getDateValidation();
              }
              else {
                if(_this.checkForMinorBankListCondition())
                {
                  if(_this.sipFirstInstallment)
                    _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                  else
                    _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                }
                else {
                  if(_this.sipFirstInstallment)
                    _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                  else
                    _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];

                }
                _this.hideOtmRadio = false;
                // if(_this.formData.inSchemeCode)
                //   getDateValidation();
              }
              _this.bankList = _this.ECbankList;
            }
          }/* else if (_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
            LoaderService.hideLoader();
            _this.hideOtmRadio = false;
            _this.bankList = _this.OTMbankList;
          }
          else if(_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
            LoaderService.hideLoader();
            _this.formData.showTopUpBlock = false;
            // if(_this.formData.inSchemeCode)
            //   getDateValidation();
            // checkEMandateValidation();
            _this.bankList =  _this.EMbankList;
            _this.formData.authMode = _this.formData.bankInfo? (_this.formData.bankInfo.authenticationModes.length === 1 ? _this.formData.bankInfo.authenticationModes[0] : null) :null;
            _this.authenticationMode = _this.formData.bankInfo ? _this.formData.bankInfo.authenticationModes: null;
          }*/
          else{
            _this.bankList = null;
          }
        }

        function checkEMandate(cb) {
          cb = cb || function () {
          };
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                resp.data.bankList = resp.data.bankList ? resp.data.bankList : [];
                _this.isEMandateEnabled = resp.data.folioEmandateStatus;
                if (resp.data.bankList.length == 0 || !_this.isEMandateEnabled) {
                  // _this.isEMandateEnabled = false;
                  _this.EMbankList = null;
                  var index = _this.sipPaymentOptions.indexOf('E-mandate');
                  if(index > -1) {
                    _this.sipPaymentOptions.splice(index,1);
                  }

                  if(_this.formData.sipPaymentOption === 'E-mandate') {
                    _this.formData.sipPaymentOption = null;
                  }
                  if(_this.sipPaymentOptions.includes("OTM") && _this.isOTMEnabled) {
                    if (_this.sipPaymentOptions.length > 1) {
                      _this.formData.sipPaymentOption = _this.sipPaymentOptions[0];
                    } else {
                      _this.formData.sipPaymentOption = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
                    }
                  }

                  if (_this.sipPaymentOptions.includes("OTM") && !_this.isOTMEnabled) {
                    var index = _this.sipPaymentOptions.indexOf('OTM');
                    if (index > -1) {
                      _this.sipPaymentOptions.splice(index, 1);
                    }
                  }
                  if(_this.formData.cgfFlag && !_this.folioMinor && _this.formData.frequency !== 'OW' && _this.formData.frequency !== 'BZ') {
                    if(!_this.isOTMEnabled && (_this.UPIbankList && _this.UPIbankList.length > 0)){
                      _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC]
                    } else if (!_this.isOTMEnabled && _this.UPIbankList.length === 0) {
                      _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC]
                    } else {
                      _this.sipPaymentOptions = [_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                    }
                    _this.formData.sipPaymentOption = _this.sipPaymentOptions[0];
                    // changedPaymentOption();
                  }
                }
                else{
                  if(_this.sipFirstInstallment)
                  {
                    _this.isEMandateEnabled = false;
                  }
                  else {
                    _this.EMbankList = resp.data.bankList;
                    // _this.isEMandateEnabled = true;
                  }
                }
              }
              cb(true);
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
              cb(false);
            };
          var data = {
            trnxType: 'SIP',
            liquidSchemeFlag: _this.liquidFlag,
            folioNumber: _this.formData.folioNumber,
            newFolio: _this.newFolio
          };
          InvestorService.post({
            child1: 'folio',
            child2: 'emandate'
          }, data).$promise.then(success, error);
        }

        function getAccountType() {
          var success = function (resp) {
              if (resp.status && resp.data) {
                _this.bankTypeList = resp.data.bankAccountTypes;
              } else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              $log.info('Account type Errror>>>>', err);
            };
          InvestorService.get({
            child1: 'folio',
            child2: 'bank',
            child3: 'account-type-list',
            child4:  _this.formData.investorType ? 'EXISTING' : 'NEW'
          }).$promise.then(success, error);
        }

        function fetchInvestorType() {
          var investorType = _this.folioList.filter(function(folio) {
            return folio.folioNumber === _this.formData.folioNumber;
          });
          _this.formData.investorType = investorType[0].invType;
        }


        _this.checkForMinorBankListCondition = function(){
          if(_this.folioMinor!=null && _this.folioMinor!=null && _this.formData.cgfFlag!=null)
            return _this.folioMinor && !_this.formData.cgfFlag;
          else
            return false;
        };

        function changePurchaseBank() {
          if (!_this.formData.bankInfo) {
            return;
          }
          _this.isInvalidForm = false;
          switch (_this.formData.purchasePaymentOption) {
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
              if(!_this.formData.bankInfo.minorBankFlag && _this.checkForMinorBankListCondition()){
                ModalService.minorBankModal({folioDetailsData:_this.folioDetailsData});
                _this.formData.bankInfo = null;
                _this.isCheckedDeclaration = false;
                return;
              }
              _this.formData.paymentInfo.bankCode = _this.formData.bankInfo.bankCode;
              _this.formData.paymentInfo.webMode = _this.formData.bankInfo.gateWayVendor;
              _this.formData.paymentInfo.accType = _this.formData.bankInfo.bankAcType=="" ? null: _this.formData.bankInfo.bankAcType;
              _this.formData.paymentInfo.ifscCode = _this.formData.bankInfo.ifscCode;
              _this.formData.paymentInfo.bankName = _this.formData.bankInfo ? _this.formData.bankInfo.bankName : '';
              _this.formData.paymentInfo.tpvEnableFlag = _this.formData.bankInfo.tpvEnableFlag;
              _this.formData.paymentInfo.accountNumber = _this.formData.bankInfo.accountNumber;
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
              if(!_this.formData.bankInfo.minorBankFlag && _this.checkForMinorBankListCondition()){
                ModalService.minorBankModal({folioDetailsData:_this.folioDetailsData});
                _this.bankInfo = null;
                _this.isCheckedDeclaration = false;
                return;
              }
              _this.formData.paymentInfo.otmId = _this.formData.bankInfo.otmId;
              _this.formData.paymentInfo.bankName = _this.formData.bankInfo.bankName;
              _this.formData.paymentInfo.bankBranch = _this.formData.bankInfo.bankBranch;
              _this.formData.paymentInfo.accountNumber = _this.formData.bankInfo.bankAcNo;
              _this.formData.paymentInfo.ifscCode = _this.formData.bankInfo.ifscCode;
              _this.formData.paymentInfo.payoutId = _this.formData.bankInfo.payoutId;
              _this.formData.paymentInfo.omUmrn = _this.formData.bankInfo.omUmrn;
              _this.formData.paymentInfo.eMandatebankAcNo = _this.formData.bankInfo.eMandatebankAcNo;
              _this.formData.paymentInfo.eMandateUmrn = _this.formData.bankInfo.eMandateUmrn;
              _this.formData.paymentInfo.accType = _this.formData.bankInfo.bankAcType;
              (angular.isDefined(_this.formData.bankInfo.camsMandateIdNo))&&(_this.formData.paymentInfo.camsMandateIdNo=_this.formData.bankInfo.camsMandateIdNo);
              checkOTMAmountAndDate();
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
              if(!_this.formData.bankInfo.minorBankFlag && _this.checkForMinorBankListCondition()){
                ModalService.minorBankModal({folioDetailsData:_this.folioDetailsData});
                return;
              }
              _this.formData.paymentInfo.accType = _this.formData.bankInfo.bankAcType;
              _this.formData.paymentInfo.bankName = _this.formData.bankInfo.bankName;
              _this.formData.paymentInfo.ifscCode = _this.formData.bankInfo.ifscCode;
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
              if(!_this.formData.bankInfo.minorBankFlag && _this.checkForMinorBankListCondition()){
                ModalService.minorBankModal({folioDetailsData:_this.folioDetailsData});
                _this.bankInfo = null;
                _this.isCheckedDeclaration = false;
                return;
              }
              _this.formData.paymentInfo.bankCode = _this.formData.bankInfo.bankCode;
              _this.formData.paymentInfo.webMode = _this.formData.bankInfo.gateWayVendor;
              /*if (_this.bankInfo.tpvEnableFlag == 'Y') {
                getAccountNumber(_this.bankInfo.bankCode);
              }*/
              _this.formData.paymentInfo.bankName = _this.formData.bankInfo.bankName;
              _this.formData.paymentInfo.bankBranch = _this.formData.bankInfo.bankBranch;
              _this.formData.paymentInfo.accNo = _this.formData.bankInfo.accountNumber;
              _this.formData.paymentInfo.ifscCode = _this.formData.bankInfo.ifscCode;
              _this.formData.paymentInfo.otherBank = true;
              _this.formData.paymentInfo.bankAcType = _this.formData.bankInfo.bankAcType==""?null:_this.formData.bankInfo.bankAcType;
              if(!_this.formData.bankInfo.bankAcType && _this.NRI_STATUS_CODES.includes(_this.formData.investorType)) {
                _this.formData.paymentInfo.bankAcType = _this.bankTypeList[0].accountTypeCode;
              }
              break;
            default :
              _this.bankInfo = null;
              break;
          }
          resetBankDetails();
        }

         function changeBank() {
          if (!_this.formData.paymentInfo) {
            return;
          }
          if(!_this.formData.paymentInfo.minorBankFlag && _this.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:_this.folioDetailsData});
            _this.formData.paymentInfo = null;
            return;
          }
           _this.formData.bankAcType = null;
           _this.formData.ifscCode = null;
          if(!_this.formData.paymentInfo)
            _this.authenticationMode=null;
          switch (_this.formData.sipPaymentOption) {
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:
              _this.formData.authMode = _this.formData.paymentInfo ? _this.formData.paymentInfo.authenticationModes[0] : null;
              _this.authenticationMode = _this.formData.paymentInfo ? _this.formData.paymentInfo.authenticationModes: null;
              _this.formData.bankAcNo = _this.formData.paymentInfo ? _this.formData.paymentInfo.bankAcNo : '';
              _this.formData.emUmrn = _this.formData.paymentInfo ? _this.formData.paymentInfo.emUmrn : '';
              _this.formData.maxAmount = _this.formData.paymentInfo ? _this.formData.paymentInfo.maxAmount : '';
              _this.formData.emExpiryDate = _this.formData.paymentInfo ? _this.formData.paymentInfo.emExpiryDate : '';
              setDynamicNotes();
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
              _this.formData.otmId = _this.formData.paymentInfo ? _this.formData.paymentInfo.otmId : '';
              _this.formData.bankName = _this.formData.paymentInfo ? _this.formData.paymentInfo.bankName : '';
              _this.formData.bankBranch = _this.formData.paymentInfo ? _this.formData.paymentInfo.bankBranch : '';
              _this.formData.bankAcNo = _this.formData.paymentInfo ? _this.formData.paymentInfo.bankAcNo : '';
              // _this.formData.ifscCode = _this.formData.bankInfo ? _this.formData.bankInfo.ifscCode : '';
              _this.formData.payoutId = _this.formData.paymentInfo ? _this.formData.paymentInfo.payoutId : '';
              (_this.formData.paymentInfo && angular.isDefined(_this.formData.paymentInfo.camsMandateIdNo))&&(_this.formData.camsMandateIdNo = _this.formData.paymentInfo.camsMandateIdNo);
              if(angular.isDefined(_this.formData.paymentInfo) && (_this.formData.paymentInfo.otmFrequency !== 'AWP') && (_this.formData.frequency === 'BZ')){
                _this.isInvalidForm = true;
                MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
              }
              checkOTMStartValidation();
              delete _this.formData.netBankingUrl;
              if (!_this.formData.paymentInfo.bankAcType) {
                getAccountType();
              }
              _this.isInvalidDate = $window.moment(_this.formData.paymentInfo.omExpiryDate).isSameOrBefore(_this.journeyDetails.sipEndDate);
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
              _this.formData.netBankingUrl = _this.formData.paymentInfo ? _this.formData.paymentInfo.netBankingUrl : "";
              if (!_this.formData.paymentInfo.bankAcType) {
                getAccountType();
              }
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
              if (!_this.formData.paymentInfo) {
                return;
              }
              if (!_this.formData.paymentInfo.bankAcType) {
                getAccountType();
              }
              if(!_this.formData.paymentInfo.minorBankFlag && _this.checkForMinorBankListCondition()){
                localStorage.setItem('folioId',_this.formData.folioNumber);
                ModalService.minorBankModal({folioDetailsData:_this.folioDetailsData});
                _this.formData.paymentInfo = null;
                _this.isCheckedDeclaration = false;
                return;
              }
              _this.upiAccountNumber = _this.formData.paymentInfo.accountNumber;
              _this.upiBankName = _this.formData.paymentInfo.bankName;
              _this.formData.paymentInfo.webMode = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
              break;
            default :
              _this.formData.netBankingUrl = _this.formData.paymentInfo.netBankingUrl;
              _this.formData.bankName = '';
              _this.formData.otmId = '';
              break;
          }
          resetBankDetails();   // need for sip transaction
        }

        function resetBankDetails() {
          _this.formData.bankCity = '';
          _this.formData.bankBranch = '';
          _this.formData.bankAcNo = '';
          _this.formData.verifyBankAcNo = '';
          _this.formData.paymentInfo.virtualAddress = "";
          changeUpiVerified();
        }

        function getconfirmation() {
          _this.confirmation != _this.confirmation;
        }

        function getJourneyDetails(cb) {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            _this.journeyDetails = resp.data;
            _this.isBasketCustomized = _this.journeyDetails.isBasketCustomized || false;
            checkForLiquidScheme();
            checkForMinorScheme();
            cb();
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          InvestmentBasketService.get({
            child1: "investment",
            child2: 'basket',
            child3: 'getDetails',
            child4: _this.formData.journeyId
          }).$promise.then(success, error);
        }

        function getPurchaseForm() {
          var payload = [];
          if (_this.journeyDetails.basket) {
            if(_this.isBasketCustomized && _this.journeyDetails.customizedBasketDetails) {
              _this.journeyDetails.basketDetails.schemesInBasket = _this.journeyDetails.customizedBasketDetails.schemesInBasket;
            }
            _this.journeyDetails.basketDetails.schemesInBasket.forEach(function(scheme) {
              var object = getPurchaseDetailPayload(scheme);
              object.secretLink = _this.secretLink;
              payload.push(object);
            });
          } else {
            _this.journeyDetails.schemes.forEach(function(scheme) {
              var object = getPurchaseDetailPayload(scheme);
              object.secretLink = _this.secretLink;
              payload.push(object);
            });
          }
          return payload;
        }

        function getSipForm() {
          var payload = [];
          if (_this.journeyDetails.basket) {
            if(_this.isBasketCustomized && _this.journeyDetails.customizedBasketDetails) {
              _this.journeyDetails.basketDetails.schemesInBasket = _this.journeyDetails.customizedBasketDetails.schemesInBasket;
            }
            _this.journeyDetails.basketDetails.schemesInBasket.forEach(function(scheme) {
              var obj = getSIPDetailPayload(scheme);
              obj.secretLink = _this.secretLink;
              payload.push(obj);
            });
          } else {
            _this.journeyDetails.schemes.forEach(function(scheme) {
              var obj = getSIPDetailPayload(scheme);
              obj.secretLink = _this.secretLink;
              payload.push(obj);
            });
          }

          if (_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            payload.mandateStartDate = moment(_this.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
            payload.mandateEndDate = moment(_this.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
            payload.mandateAmount = _this.formData.emandateAmount;
          }
          return payload;
        }


        function getBankDetailForECS() {
          var payload = {
            "accNumber":  _this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM ?_this.formData.paymentInfo.bankAcNo : _this.formData.paymentInfo.accountNumber,
            "bankName": _this.formData.paymentInfo.bankName,
            "bankCode": _this.formData.paymentInfo.bankCode,
            "ifscCode": _this.formData.paymentInfo.ifscCode ? _this.formData.paymentInfo.ifscCode : _this.formData.ifscCode,
            "branchName": _this.formData.paymentInfo.bankBranch,
            "bankCity": _this.formData.paymentInfo.bankCity,
            "paymentOption": _this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE ? 'HEM' : _this.formData.sipPaymentOption,
            "accType": _this.formData.paymentInfo.bankAcType ? _this.formData.paymentInfo.bankAcType : _this.formData.bankAcType,
            "netBankingUrl": _this.formData.paymentInfo.netBankingUrl
          };
          if (_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
            payload.omUmrn = _this.formData.paymentInfo.omUmrn;
            payload.camsMandateIdNo = _this.formData.paymentInfo.camsMandateIdNo;
            payload.payoutId = _this.formData.paymentInfo.payoutId;
          } else if (_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            payload.authenticationMode = _this.formData.authMode ? _this.formData.authMode.value : '';
          } else if (_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            payload.paymentOption = 'UAP';
          }

          return payload;
        }

        function purchaseSubmitForm() {
          var config = {};
          var payload = {};
          LoaderService.showLoader();
          if (_this.journeyDetails.basket) {
            payload = getPayload();
            // payload.secretLink = _this.secretLink;
            config = {
              controller1: 'investment',
              controller2: 'basket',
              controller3: 'transaction',
              controller4: _this.transactionType.toLowerCase(),
              controller5: 'approve'
            };
          } else {
            var objectArray = getPurchaseForm();
            payload = objectArray[0];
            payload.secretLink = _this.secretLink;
            config = {
              controller1: 'transaction',
              controller2: _this.transactionType.toLowerCase(),
              controller3: 'approve',
            };
          }
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.redirectionDataForRazorPay = resp.data;
              handlePurchaseResponse(resp.data);
              if(_this.formData.purchasePaymentOption == _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
                if(!resp.data.redirectUrl) {
                  $state.go("welcome");
                } else {
                  LoaderService.showLoader();
                  $window.location.href = resp.data.redirectUrl
                }
              }
            } else {
              if (resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                })
              } else {
                MessageService.error(resp.message);
              }
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          NewInvestorTransactionService.post(config, payload).$promise.then(success, error);
        }

        function getPayload() {
          var payload = {};
          if (_this.transactionType.toUpperCase() === _this.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
            var purchasePayload = {
              basketDetailId: _this.formData.journeyId,
              folioNumber: _this.formData.folioNumber,
              totalAmount: _this.isBasketCustomized && _this.journeyDetails.customizedBasketDetails ? _this.journeyDetails.customizedBasketDetails.totalAmount : _this.formData.purchaseAmount,
              paymentInfo: getPaymentInfo('payload'),
              purchaseForms: getPurchaseForm()
            };
            payload = purchasePayload;
          } else {
            var sipPayload = {
              basketDetailId: _this.formData.journeyId,
              folioNumber: _this.formData.folioNumber,
              totalAmount: _this.isBasketCustomized && _this.journeyDetails.customizedBasketDetails ? _this.journeyDetails.customizedBasketDetails.totalAmount : _this.formData.purchaseAmount,
              sipForms: getSipForm()
            };
            payload = sipPayload;
          }
          return payload;
        }

        function getPaymentInfo(from, scheme) {
          if (_this.formData.paymentInfo && _this.formData.paymentInfo.webMode === 'MASTER') {
            _this.formData.paymentInfo.webMode = 'MASTERCARD';
          }
          var paymentInfo = {};
          if (from === "payload") {
            paymentInfo = {
              amount: _this.isBasketCustomized && _this.journeyDetails.customizedBasketDetails ? _this.journeyDetails.customizedBasketDetails.totalAmount : _this.formData.purchaseAmount,
            };
          } else {
            paymentInfo = {
              amount: _this.journeyDetails.basket ? scheme.amount : _this.journeyDetails.amount
            };
          }
          switch (_this.formData.purchasePaymentOption) {
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
              paymentInfo.paymentMode = "WEB";
              paymentInfo.bankCode = _this.formData.paymentInfo.bankCode;
              paymentInfo.webMode = _this.formData.paymentInfo.webMode;
              paymentInfo.bankName = _this.formData.paymentInfo.bankName;
              paymentInfo.accountNumber = _this.formData.paymentInfo.accountNumber;
              paymentInfo.accType = _this.formData.paymentInfo.accType ? _this.formData.paymentInfo.accType : _this.formData.paymentInfo.bankAcType ? _this.formData.paymentInfo.bankAcType : null;
              paymentInfo.ifscCode = _this.formData.paymentInfo.ifscCode;
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
              paymentInfo.paymentMode = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
              paymentInfo.bankName = _this.formData.paymentInfo.bankName;
              paymentInfo.bankBranch = _this.formData.paymentInfo.bankBranch;
              paymentInfo.accNo = _this.formData.paymentInfo.accountNumber;
              paymentInfo.accType = _this.formData.paymentInfo.accType ? _this.formData.paymentInfo.accType : _this.formData.paymentInfo.bankAcType ? _this.formData.paymentInfo.bankAcType : null;
              paymentInfo.ifscCode = _this.formData.paymentInfo.ifscCode;
              paymentInfo.chequeLeaf = _this.formData.paymentInfo.chequeLeaf;
              paymentInfo.utr =  _this.formData.paymentInfo.utrNumber;
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
              paymentInfo.otmId = _this.formData.paymentInfo.otmId;
              paymentInfo.bankName = _this.formData.paymentInfo.bankName;
              paymentInfo.branchName = _this.formData.paymentInfo.bankBranch;
              paymentInfo.accNo = _this.formData.paymentInfo.accountNumber;
              paymentInfo.ifscCode = _this.formData.paymentInfo.ifscCode;
              paymentInfo.payoutId = _this.formData.paymentInfo.payoutId;
              paymentInfo.omUmrn = _this.formData.paymentInfo.omUmrn;
              paymentInfo.camsMandateIdNo = _this.formData.paymentInfo.camsMandateIdNo;
              paymentInfo.accType = _this.formData.paymentInfo.accType;
              paymentInfo.paymentMode = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
              paymentInfo.schemeAccountNumber = _this.formData.paymentInfo.schemeAccountNumber;
              paymentInfo.accountNumber = _this.formData.paymentInfo.accountNumber;
              paymentInfo.accountHolderName = _this.formData.paymentInfo.accountHolderName;
              paymentInfo.bankName = "HDFC Bank Ltd";
              paymentInfo.bankBranch = _this.formData.paymentInfo.bankBranch;
              paymentInfo.bankAcNo = _this.formData.paymentInfo.bankAcNo;
              paymentInfo.utr = _this.formData.paymentInfo.utrNumber;
              paymentInfo.accType = _this.formData.paymentInfo.accType;
              paymentInfo.ifscCode = _this.formData.paymentInfo.ifscCode;
              paymentInfo.accNo = _this.formData.paymentInfo.accountNumber;
              paymentInfo.chequeLeaf = _this.formData.paymentInfo.chequeLeaf;
              paymentInfo.paymentMode = _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC;
              break;
            case _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
              paymentInfo.virtualAddress = _this.formData.paymentInfo.virtualAddress;
              paymentInfo.webMode = angular.copy(_this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
              paymentInfo.upiReferenceNumber = _this.transactionNumber;
              paymentInfo.accNo= _this.upiAccountNumber;
              paymentInfo.accountNumber = _this.upiAccountNumber;
              paymentInfo.accType = _this.formData.bankInfo.bankAcType ? _this.formData.bankInfo.bankAcType : _this.formData.paymentInfo.accType;
              paymentInfo.bankName = _this.upiBankName;
              paymentInfo.ifscCode = _this.formData.bankInfo.ifscCode ? _this.formData.bankInfo.ifscCode : _this.formData.paymentInfo.ifscCode;
              paymentInfo.paymentMode = "WEB";
              break;

          }
          return angular.copy(paymentInfo);
        }

        function handlePurchaseResponse(data) {
          var transactionId = data && data.transactionId ? data.transactionId : null;
          data = data && data.data ? data.data : data;
          sessionStorage.setItem('transactionSuccess', true);
          if (!data) {
            MessageService.error();
            return;
          }
          if(_this.formData.investmentType==='SIP')
            _this.billdeskMsg = data.emandateMsg;
          else
            _this.billdeskMsg = data;
          if (_this.formData.paymentInfo.paymentMode == 'WEB' && _this.formData.paymentInfo.webMode == 'BILLDESK') {
            if (_this.formData.purchasePaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || _this.formData.paymentInfo.bankCode === 'NA') {
              _this.billdeskPayload.msg = _this.billdeskMsg;
              $timeout(function () { // commented as debit currently is not getting used
                angular.element('#billdeskForm').submit();
              });
            } else {
              _this.billdeskPayload.msg = _this.billdeskMsg;
              $timeout(function () {
                angular.element('#billdeskForm').submit();
              });
            }
          }
          else if (_this.formData.paymentInfo.paymentMode == 'WEB' && (_this.formData.paymentInfo.webMode == 'MASTERCARD' || _this.formData.paymentInfo.webMode == 'VISA')) {
            if (_this.formData.purchasePaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || _this.formData.paymentInfo.bankCode === 'NA') {
              _this.billdeskPayload.msg = _this.billdeskMsg;
              $timeout(function () {
                angular.element('#billdeskForm').submit();
              });
            } else {
              _this.billdeskPayload.msg = _this.billdeskMsg;
              $timeout(function () {
                angular.element('#billdeskForm').submit();
              });
            }
          }
          else if (_this.formData.paymentInfo.paymentMode == 'WEB' && _this.formData.paymentInfo.webMode == 'BILLJUNCTION') {
            $window.open(_this.billdeskMsg, '_self');
          } else if (_this.formData.paymentInfo.paymentMode == 'WEB' && _this.formData.paymentInfo.webMode == 'RAZORPAY') {
            _this.redirectionDataForRazorPay.trnxActionMsg = _this.redirectionDataForRazorPay.data;
            PaymentService.openRazorPay(_this.redirectionDataForRazorPay);
          } else if (_this.formData.paymentInfo.paymentMode == 'WEB' && _this.formData.paymentInfo.webMode == 'UPI') {

          } else {
            var isFavourite = _this.formData.isFavourite ? true : false;
            if (_this.isFromPrelogin) {
              var invType = sessionStorage.getItem('userType');
              $state.go('preLoginBasket.purchaseTransactionSuccess',{
                existingInvestor : invType === 'NEW' ? false : true
              });
            } else {
              $state.go('main.investment.purchaseTransactionSuccess',{
                transactionId: transactionId,
                transactionType: _this.transactionType,
                isFavourite: isFavourite,
                existingInvestor : invType === 'NEW' ? false : true
              });
            }

          }
        }

        function sipSubmitRegisterForm() {
          var successCallback = function (resp) {
            _this.secretLink = resp.secretLink;
            if(_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
              sipSubmitForm();
            }
          };
          var errorCallback = function () {
            LoaderService.hideLoader();
            scope.isCheckedTandC=true;
            scope.isCheckedTandCeMandate = true;
          };
          ModalService.registerEMandateModal({folioNumber:_this.formData.folioNumber,transactionType : _this.transactionType, bankName :_this.formData.paymentInfo.bankName.substring(0, _this.formData.paymentInfo.bankName.indexOf("-")), authMode: _this.formData.authMode.value, randomOTPId: _this.randomOTPId},
            successCallback, errorCallback);
        }

        function sipSubmitForm() {
          var payload = getPayload();
          LoaderService.showLoader();
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              sessionStorage.setItem('transactionSuccess', true);
              if (_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
                handleEmandateSipResponse(resp.data);
              } else if (_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
                handleUPISipResponse(resp.data);
              } else {
                var successPayload = {
                  investorName: _this.userName,
                  folioInvestorName: _this.userName,
                  srnNo: resp.data.srnNo,
                  folioNumber: _this.formData.folioNumber,
                  investmentOption: _this.formData.investmentOption,
                  amount: _this.formData.purchaseAmount,
                  sipDividendOption: _this.formData.investmentOption, // need to update
                  netBankingUrl: _this.formData.netBankingUrl, // need to update
                  paymentMode: resp.data.paymentOption,
                  tranNumber: resp.data.trxnNo,
                  transactionInitiatedDate: resp.data.transactionInitiateDate,
                  frequency: _this.journeyDetails.frequency, // need to update
                  startDate: _this.journeyDetails.sipStartDate,
                  endDate: _this.journeyDetails.sipEndDate,
                  bankName: _this.formData.paymentInfo && _this.formData.paymentInfo.bankNameOnly ? _this.formData.paymentInfo.bankNameOnly : _this.formData.bankName,
                  bankAcNo: _this.formData.paymentInfo && _this.formData.paymentInfo.accountNumber ? _this.formData.paymentInfo.accountNumber : _this.formData.bankAcNo,
                  transactionType: 'SIP',
                  schemeName: _this.journeyDetails.basket ? _this.journeyDetails.basketDetails.basketName : _this.journeyDetails.schemes[0].schemeName,
                  UMRNNo : _this.formData.paymentInfo.omUmrn,
                  basketTrue: _this.journeyDetails.basket ? true: false
                };
                if (_this.journeyDetails.basket) {
                  if(_this.isBasketCustomized && _this.journeyDetails.customizedBasketDetails) {
                    successPayload.amount = _this.journeyDetails.customizedBasketDetails.totalAmount;
                    successPayload.schemeName = _this.journeyDetails.customizedBasketDetails.basketName;
                    successPayload.basketDetails = _this.journeyDetails.customizedBasketDetails;
                  } else {
                    successPayload.basketDetails = _this.journeyDetails.basketDetails;
                  }
                } else {
                  successPayload.schemes = _this.journeyDetails.schemes;
                }
                localStorage.setItem('q', encodeURI(JSON.stringify(successPayload)));
                if (_this.isFromPrelogin) {
                  var invType = sessionStorage.getItem('userType');
                  $state.go('preLoginBasket.sipTransactionSuccess',{
                    existingInvestor : invType === 'NEW' ? false : true
                  });
                } else {
                  $state.go('main.investment.sipTransactionSuccess');
                }
              }
            } else {
              if (resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                })
              } else {
                MessageService.error(resp.message);
              }
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          NewInvestorTransactionService.post({
            controller1: 'investment',
            controller2: 'basket',
            controller3: 'transaction',
            controller4: _this.transactionType.toLowerCase(),
            controller5: 'approve'
          }, payload).$promise.then(success, error);
        }

        function backToReview() {
          if (_this.isFromPrelogin) {
            $state.go('preLoginBasket.review');
          } else {
            $state.go('main.investment.review');
          }
        }

        function getPurchaseDetailPayload(scheme) {
          var object = {
            "amount": _this.journeyDetails.basket ? scheme.amount : _this.journeyDetails.amount,
            "investmentOption": _this.journeyDetails.basket ? getInvestmentOption(scheme) : _this.formData.investmentOption.toUpperCase(),
            "dividendOption": calculateDividendOption(scheme),
            "folioNumber": _this.formData.folioNumber,
            "formType": "PURCHASE",
            "primaryFlag": _this.transactionType.toUpperCase() === _this.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
            "schemeCode": scheme.schemeCode,
            "euinOpted": "N",
            "id": _this.formData.journeyId,
            "accountNumber": _this.formData.paymentInfo.accountNumber,
            "tpvEnableFlag": _this.formData.paymentInfo.tpvEnableFlag,
            "retirementAgeProofURL": "",
            "subBrokerArn": "",
            "subBrokerCode": "",
            "autoSwitchScheme": null,
            "autoSwitchSchemeDividendOption": null,
            "brokerCode": "DIRECT",
            "riaConsent": false,
            "paymentInfo": getPaymentInfo('detailPayload', scheme)
          };
          if (_this.formData.purchasePaymentOption === "RTGS" || _this.formData.purchasePaymentOption === "HDFC"
            || _this.formData.purchasePaymentOption === "OTM") {
            object.id = "";
          } else if (_this.formData.purchasePaymentOption === "UPI") {
            object.id = "";
            object.accountNumber = _this.upiAccountNumber;
          }
          return object;
        }

        function getSIPDetailPayload(scheme) {
          var obj = {
            "installmentAmount": _this.journeyDetails.basket ? scheme.amount : _this.journeyDetails.amount,
            "investmentOption": _this.journeyDetails.basket ? getInvestmentOption(scheme) : _this.formData.investmentOption.toUpperCase(),
            "dividendOption": calculateDividendOption(scheme),
            "formType": "SIP",
            "euinOpted": "N",
            "brokerCode": "",
            "frequency": "OM",
            "folioNumber": _this.formData.folioNumber,
            "schemeCode": scheme.schemeCode,
            "schemeType": scheme.schemeType,
            "toDate": _this.journeyDetails.sipEndDate,
            "sipDate": _this.journeyDetails.sipStartDate,
            "sipDay": _this.journeyDetails.sipStartDate ? $window.moment(_this.journeyDetails.sipStartDate).format('D') : '',
            "weeklyDay": null,
            "schemeData": [],
            "investmentBasketId": _this.formData.journeyId,
            "bankDetailsForECS": getBankDetailForECS(),
            "sipTopupEnabled": false,
            "primaryFlag": true,
            "riaConsent": false,
            "subBrokerArn": "",
            "subBrokerCode": "",
            "topupDetails": {}
          };

          if (_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            obj.bankDetailsForECSbankCode = _this.formData.paymentInfo.bankCode;
            obj.mandateStartDate = moment(_this.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
            obj.mandateEndDate = moment(_this.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
            obj.mandateAmount = _this.formData.emandateAmount;
          }
          if (_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            obj.payerVpa =_this.formData.paymentInfo.virtualAddress;
            obj.payerName = _this.name;
            obj.paymentOption = 'UAP';
          }
          return obj;
        }

        function getInvestmentOption(scheme) {
          var validationObject = JSON.parse(sessionStorage.getItem('validationObject'));
          var schemeValidation = validationObject.validationDTOMap[scheme.schemeCode];
          return schemeValidation.isGrowth ? _this.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : _this.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND;
        }

        function calculateDividendOption(scheme) {
          var dividendOption = null;
          var validationObject = JSON.parse(sessionStorage.getItem('validationObject'));
          var schemeValidation = null;
          if (_this.journeyDetails.basket) {
            schemeValidation = validationObject.validationDTOMap[scheme.schemeCode];
          } else {
            schemeValidation = validationObject;
          }
          if (schemeValidation.isGrowth) {
            dividendOption = _this.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          } else {
            if(schemeValidation.dividendPayoutApplicable === true && schemeValidation.dividendReinvestmentApplicable === false){
              dividendOption = _this.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
            }else if(schemeValidation.dividendPayoutApplicable === false && schemeValidation.dividendReinvestmentApplicable === true) {
              dividendOption = _this.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            }else if(schemeValidation.dividendPayoutApplicable === true && schemeValidation.dividendReinvestmentApplicable === true) {
              dividendOption = _this.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            }
          }
          return dividendOption;
        }

        function setDynamicNotes() {
          if (_this.transactionType === 'SIP') {
            _this.commonNote = _this.dynamicDataSip.noteDTO.noteDTOMap.Note_SIP_Review_BASKET_JOURNEY;
            if (_this.formData.sipPaymentOption === 'EC') {
              _this.notes = _this.dynamicDataSip.noteDTO.noteDTOMap.NOTE_SIP_SI_BASKET_JOURNEY;
            } else if (_this.formData.sipPaymentOption === 'OTM') {
              _this.notes = _this.dynamicDataSip.noteDTO.noteDTOMap.Note_SIP_Review_OTM_BASKET_JOURNEY;
            } else if (_this.formData.sipPaymentOption === 'UPI') {
              _this.notes = _this.dynamicDataSip.noteDTO.noteDTOMap.Note_SIP_UPI_BASKET_JOURNEY;
            } else {
              if (_this.formData.authMode && _this.formData.authMode.value === "DEBIT_CARD") {
                _this.notes = _this.dynamicDataSip.noteDTO.noteDTOMap.Note_SIP_Review_eOTM_Debit_Card_BASKET_JOURNEY;
              } else {
                _this.notes = _this.dynamicDataSip.noteDTO.noteDTOMap.Note_SIP_Review_eOTM_BASKET_JOURNEY;
              }
            }
          } else {
            if (_this.formData.purchasePaymentOption === 'NETBANKING') {
              _this.notes = _this.dynamicDataPurchase.Note_Purchase_Net_Banking_BASKET_JOURNEY;
            } else if (_this.formData.purchasePaymentOption === 'RTGS') {
              _this.notes = _this.dynamicDataPurchase.Note_Purchase_NEFT_RTGS_BASKET_JOURNEY;
            } else if (_this.formData.purchasePaymentOption === 'HDFC') {
              _this.notes = _this.dynamicDataPurchase.Note_Purchase_HDFC_Fund_Transfer_BASKET_JOURNEY;
            } else if(_this.formData.purchasePaymentOption === 'OTM') {
              _this.notes = _this.dynamicDataPurchase.Note_Purchase_OTM_BASKET_JOURNEY;
            } else if(_this.formData.purchasePaymentOption === 'UPI') {
              _this.notes = _this.dynamicDataPurchase.Note_Purchase_UPI_BASKET_JOURNEY;
            }
          }
        }

        _this.paymentNavUrl = function () {
          $window.open(_this.paymentNavURL);
        };

        _this.tpv = function(event) {
          ModalService.tpvModal({});
        }

        function handleEmandateSipResponse(data) {
          data = data && data.data ? data.data : data;
          if (!data) {
            MessageService.error();
            return;
          }
          $window.location.href = _this.billdeskUrl+data.emandateMsg;
        }

        function getFolioDetailsData() {
          var success = function (resp) {
            var bankDetails=[];
            LoaderService.hideLoader();
            _this.folioDetailsData = resp.data;
            if(_this.folioDetailsData && _this.folioDetailsData.bankDetails && _this.folioDetailsData.bankDetails.length>0){
              bankDetails = _this.folioDetailsData.bankDetails.filter(function (value) {
                if(value.defaultBank===true){return value;}
              });
            }
            localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
          }, error = function () {
            LoaderService.hideLoader();
            cb();
          };

          LoaderService.showLoader();
          InvestorService.post({
            child1: 'profile',
            child2: 'folio',
            child3: 'details'
          }, {folioNumber: _this.formData.folioNumber}).$promise.then(success, error);
        }

        function checkForLiquidScheme() {
          _this.liquidFlag = false;
          if (_this.journeyDetails.basket) {
            _this.journeyDetails.basketDetails.schemesInBasket.forEach(function(scheme) {
              if (scheme.schemeType === "LIQUID") {
                _this.liquidFlag = true;
              }
            });
          } else {
            _this.journeyDetails.schemes.forEach(function(scheme) {
              if (scheme.schemeType === "LIQUID") {
                _this.liquidFlag = true;
              }
            });
          }
        }

        function checkForMinorScheme() {
          _this.formData.cgfFlag = false;
          var validationObject = JSON.parse(sessionStorage.getItem('validationObject'));
          if (_this.journeyDetails.basket) {
            var keys = Object.keys(validationObject.validationDTOMap);
            for (var i=0; i< keys.length; i++) {
              var schemeObject = validationObject.validationDTOMap[keys[i]];
              _this.formData.cgfFlag =  schemeObject.cgfFlag;
              if (_this.formData.cgfFlag === false) {
                _this.formData.cgfFlag = true;
              }
            }
          } else {
            _this.formData.cgfFlag =  validationObject.cgfFlag;
            if (_this.formData.cgfFlag === false) {
              _this.formData.cgfFlag = true;
            }
          }
        }

        function copyPasteHandler(e) {
          UtilService.copyPasteHandler(e);
        }

        function fetchRTGSBankList() {
          LoaderService.showLoader();
          _this.bankList = null;
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.bankList = resp.data.bankList;
                _this.bankList = _this.bankList.length ? _this.bankList : null;
                if (_this.bankList && _this.bankList.length == 1) {
                  _this.bankInfo = _this.bankList[0];
                  if(!_this.bankInfo.minorBankFlag && _this.checkForMinorBankListCondition()){
                    localStorage.setItem('folioId',_this.formData.folioNumber);
                    ModalService.minorBankModal({folioDetailsData:_this.folioDetailsData});
                    return;
                  }
                  _this.formData.paymentInfo.tpvEnableFlag = _this.bankInfo.tpvEnableFlag;
                  _this.formData.paymentInfo.accountNumber = _this.bankInfo.accountNumber;
                  _this.formData.paymentInfo.webMode = _this.bankInfo.gateWayVendor;
                  _this.formData.paymentInfo.bankCode = _this.bankInfo.bankCode;
                  _this.formData.paymentInfo.payoutId = _this.bankInfo.payoutId;
                  _this.formData.paymentInfo.omUmrn = _this.bankInfo.omUmrn;
                  _this.formData.paymentInfo.otmId = _this.bankInfo.otmId;
                  _this.formData.paymentInfo.bankName = _this.bankInfo.bankName;
                  _this.formData.paymentInfo.bankBranch = _this.bankInfo.bankBranch;
                  _this.formData.paymentInfo.bankAcNo = _this.bankInfo.bankAcNo;
                  _this.formData.paymentInfo.ifscCode = _this.bankInfo.ifscCode;
                  _this.formData.paymentInfo.eMandatebankAcNo = _this.bankInfo.eMandatebankAcNo;
                  _this.formData.paymentInfo.eMandateUmrn = _this.bankInfo.eMandateUmrn;
                  (angular.isDefined(_this.bankInfo.camsMandateIdNo))&&(_this.formData.paymentInfo.camsMandateIdNo=_this.bankInfo.camsMandateIdNo);
                }
              } else {
                _this.bankList = null;
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              _this.bankList = null;
              UtilService.errorHandler(err);
            };
          var config = {child1: 'bank', child2: 'list'};
          var payload = {
            trnxType: 'PURCHASE',
            folioNumber: (_this.investorInfo && _this.investorInfo.transactionFlowVersion === TrFlowType.NEW) ? _this.formData.folioNumber:null,
            liquidSchemeFlag: _this.liquidFlag,
            neftFlag: true
          };
          InvestorService.post(config, payload).$promise.then(success, error);
        }

        function verifyUPI() {
          _this.formData.verifyUPIResp = {};
          var success = function (resp) {
            if (resp.data && resp.status) {
              _this.formData.verifyUPIResp = resp.data;
              if (resp.data.valid) {
                _this.name = resp.data.name;
                _this.isUPIVerified = true;
              } else {
                _this.isUPIVerified = false;
                _this.formData.verifyUPIResp.valid = false;
              }
            }
            else {
              _this.isUPIVerified = false;
              _this.formData.verifyUPIResp.valid = false;
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          },
          error = function (err) {
            _this.isUPIVerified = false;
            $log.info("upi error====", err);
            LoaderService.hideLoader();
          };
          LoaderService.showLoader();
          if (_this.formData.sipPaymentOption && _this.formData.sipPaymentOption === 'UPI') {
            investorServiceVersion.post({
              child1: 'upi',
              child2: 'check',
              child3: 'virtualAddress'
            }, {
              "virtualAddress": _this.formData.paymentInfo.virtualAddress,
              "basketFlow": true,
              "folioNo": _this.formData.folioNumber,
              "transactionType": _this.formData.investmentType,
              "ecartFlow": false
            }).$promise.then(success, error);
          } else {
            InvestorService.post({
              child1: 'upi',
              child2: 'check',
              child3: 'virtualAddress'
            }, {"virtualAddress": _this.formData.paymentInfo.virtualAddress}).$promise.then(success, error);
          }
        }

        function changeUpiVerified(){
          _this.isUPIVerified = false;
        }

        function checkOTMAmountAndDate() {

          _this.isOTMAmount = false;
          _this.isOTMDate = false;
          _this.isOTMStartDate = false;
          // Check Ammout
          if (_this.formData.purchaseAmount && (_this.formData.purchaseAmount > _this.formData.bankInfo.maxAmount)) {
            _this.isOTMAmount = true;
          } else if (_this.formData.purchaseAmount && (_this.formData.purchaseAmount < _this.formData.bankInfo.maxAmount)){
            _this.isOTMAmount = false;
          }

          if (_this.formData.sipFirstAmount && (_this.formData.sipFirstAmount > _this.formData.bankInfo.maxAmount)) {
            _this.isOTMAmount = true;
          } else if (_this.formData.sipFirstAmount && (_this.formData.sipFirstAmount < _this.formData.bankInfo.maxAmount)) {
            _this.isOTMAmount = false;
          }

          //Compare Dates
          if ($window.moment(_this.formData.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment())) {
            _this.isOTMDate = true;
          }
          else {
            _this.isOTMDate = false;
          }
          if (!($window.moment(_this.formData.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(_this.otmList.currentDate, 'DD-MMM-YYYY')))){
            _this.isOTMStartDate = true;
          }
          else{
            _this.isOTMStartDate = false;
          }

          //Check for amount or date
          if (_this.isOTMAmount || _this.isOTMDate) {
            _this.isInvalidForm = true;
          } else {
            _this.isInvalidForm = false;
            //tForm.$invalid
          }
        }

        function checkOTMStartValidation() {
          _this.otmStartDate = _this.formData.paymentInfo && $window.moment(_this.formData.paymentInfo.omStartDate, 'DD-MMM-YYYY');
          if(_this.transactionType == 'SIP' && _this.journeyDetails.sipStartDate && _this.otmStartDate){
            _this.startDateValidation = _this.journeyDetails.sipStartDate && ($window.moment(_this.journeyDetails.sipStartDate,"DD-MMM-YYYY")) < ($window.moment(_this.otmStartDate,"DD-MMM-YYYY"));
          }else {
            _this.startDateValidation = false;
          }
        }


        function transactionOtmConfirmation() {
          var otpSuccessCallback, otpDismissCallback;

          otpSuccessCallback = function(resp) {
            if (_this.transactionType === 'PURCHASE') {
              _this.purchaseSubmitForm();
            } else if (_this.transactionType === 'SIP') {
              _this.sipSubmitForm();
            }
          };

          otpDismissCallback = function(err) {
            LoaderService.hideLoader();
          };

          LoaderService.showLoader();
          var modalPayload = {
            folioNumber:  _this.formData.folioNumber,
            transactionType: _this.transactionType,
            randomOTPId: _this.randomOTPId
          };

          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.secretLink = resp.data.secretLink;
                var otpDetails = {
                  secretOtpLink : _this.secretLink,
                  otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
                  otpId : resp.data.id
                };

                var payload = {
                  folioNumber:  _this.formData.folioNumber,
                  formType : _this.transactionType
                }

                if(_this.formData.sipPaymentOption === _this.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
                  var noteUpiModal = _this.dynamicDataSip.noteDTO.noteDTOMap.Note_SIP_UPI_2FA;
                  payload.paymentOption = 'UAP';
                }

                ModalService.transactionOtpModal({
                  otpPayload: otpDetails,
                  payload: payload,
                  upiModalOtp : noteUpiModal
                }, otpSuccessCallback, otpDismissCallback);
              } else {
                LoaderService.hideLoader();
                MessageService.error(resp.message)
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
          TransactionService.post2({
            controller1: 'transaction',
            controller2: 'otp'
          }, modalPayload).$promise.then(success, error);
        }

        function updateEmandateEndDate() {

          if (!_this.formData.emandateDate) {
            return;
          }

          var enabledEndDates = [];

          if(_this.formData.emandateDate)
          {
            _this.minEndDateEmandate = $window.moment(_this.formData.emandateDate, "DD-MMM-YYYY").add(_this.minEndDateGapMandate, 'year');
            _this.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
            _this.maxEndDateEmandate = $window.moment(_this.formData.emandateDate, "DD-MMM-YYYY").add(_this.emandateMaxYear, 'years').subtract(1,'days');
            _this.maxEndDateEmandateUPI = $window.moment().add(_this.upiMaxYear, 'years').subtract(1,'days');
            var endDateEmandateBoundExist = $window.moment(_this.journeyDetails.sipEndDate,'DD-MMM-YYYY').isSameOrBefore(_this.maxEndDateEmandate);
            var endDateEmandateBoundExistUPI = $window.moment(_this.journeyDetails.sipEndDate,'DD-MMM-YYYY').isSameOrBefore(_this.maxEndDateEmandateUPI);
            if (!endDateEmandateBoundExist) {
              var index = _this.sipPaymentOptions.indexOf('E-mandate');
              if(index > -1) {
                _this.sipPaymentOptions.splice(index,1);
              }
            }

            if (!endDateEmandateBoundExistUPI) {
              var upiIndex = _this.sipPaymentOptions.indexOf('UPI');
              if(upiIndex > -1) {
                _this.sipPaymentOptions.splice(upiIndex,1);
              }
            }
          }

          var freq = _this.maxEndDateEmandate.diff(_this.minEndDateEmandate, 'days');
          for (var i = 0; i <= freq; i++) {
            enabledEndDates.push(_this.minEndDateEmandate.clone().add(i, 'days'));
          }
          _this.enabledEmandateEndDatesList = enabledEndDates;
          _this.endDateViewEmandate =  _this.minEndDateEmandate.clone();
          _this.formData.endDateEmandate =  $window.moment(_this.enabledEmandateEndDatesList[_this.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
          _this.formData.sipPaymentOption = _this.sipPaymentOptions[0]? _this.sipPaymentOptions[0]: 'UPI';
          getPaymentMode(_this.formData.sipPaymentOption);
        }


        function checkAmountValidationEmandate() {
          _this.formData.emandateAmount = parseInt(_this.formData.displayAmountMandate.toString().replaceAll(",", ""));
          _this.formData.displayAmountMandate = parseInt(_this.formData.emandateAmount.toString().replaceAll(",", "")).toLocaleString('en-IN');
          _this.amountLess = _this.formData.emandateAmount < _this.emandateMinAmountLimit ? true : false;
          _this.amountMore = _this.formData.emandateAmount > _this.eMandatemaxAmountLimit ? true : false;
          _this.isLessThanSipAmount =  _this.formData.emandateAmount < _this.formData.purchaseAmount ? true : false;
          $window.NumToWord(_this.formData.emandateAmount, 'amountInwordsEmandate',_this.formData.emandateWord);
        }

        function changeEndDateEmandate(date) {
          _this.formData.endDateEmandate = date ? date : null;
          if (_this.journeyDetails.sipEndDate) {
            _this.sipDateLessEmandate =  $window.moment(_this.journeyDetails.sipEndDate, 'DD-MMM-YYYY').isAfter($window.moment(_this.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
          }
        }


        function fetchBankListForSipUPI(cb) {
          cb = cb || function () {
          };

          LoaderService.showLoader();
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.UPIbankList = resp.data.bankList;
              } else {
                _this.UPIbankList = null;
                MessageService.error(resp.message);
              }
              cb(true);
            },
            error = function (err) {
              LoaderService.hideLoader();
              _this.UPIbankList = null;
              UtilService.errorHandler(err);
              cb(false);
            };

          if (!_this.UPIbankList) {
            var payload = {
              "trnxType": 'PURCHASE',
              "folioNumber": _this.formData.folioNumber,
              "liquidSchemeFlag": _this.liquidFlag,
              "newFolio": _this.newFolio,
              "sipUpiFlow" : true
            };
            InvestorService.post({child1: 'bank', child2: 'list'}, payload).$promise.then(success, error);
          } else {
            LoaderService.hideLoader();
          }
        }

        function handleUPISipResponse(data) {
          data = data && data.data ? data.data : data;
          if (!data) {
            MessageService.error();
            return;
          }

          $window.location.href = data.redirectUrl;
        }

        function handleVpa() {
          if (_this.formData.paymentInfo.virtualAddress && this.transactionType == 'SIP') {
            _this.formData.paymentInfo.virtualAddress = _this.formData.paymentInfo.virtualAddress.toLowerCase();
          }
          _this.formData.verifyUPIResp = {};
        }

        /**
         * Function responsible for setting emandate and upi form fields data related to date and amount
         */

        function setEmandateUpiSetting() {
          _this.emandateMaxYear = _this.emandateObj.maxMandateDurationYears ? _this.emandateObj.maxMandateDurationYears : _this.defaultMandateYearDate;
          _this.upiMaxYear = _this.upiObj.maxMandateDurationYears ? _this.upiObj.maxMandateDurationYears : _this.defaultMandateYearDate;
          _this.eMandatenoOfDays = _this.emandateObj.noOfDays;
          _this.eMandatemaxAmountLimit = _this.emandateObj.maxAmountLimit;
          _this.emandateMinAmountLimit = _this.emandateObj.minAmountLimit;
          _this.formData.emandateAmount = Math.floor(_this.emandateObj.defaultMandateAmount);
          _this.formData.displayAmountMandate = parseInt(_this.formData.emandateAmount.toString().replaceAll(",", "")).toLocaleString('en-IN');
          checkAmountValidationEmandate();
          $window.NumToWord(_this.formData.emandateAmount, 'amountInwordsEmandate',_this.formData.emandateWord);
          _this.mandateInfo = _this.emandateObj.mandateInfoBasket;
          _this.minEndDateGapMandate = _this.emandateObj.minEndDateGap;
          _this.mandateMaxString = _this.emandateObj.maxAmountLimitInfo;
          _this.formData.emandateDate = $window.moment().add(_this.emandateObj.minStartDays,'days');
          updateEmandateEndDate();
        }

      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('folioDirective', folioDirective);

  /*@ngInject*/
  function folioDirective($timeout, $state, LoaderService, UtilService, MessageService, InvestmentBasketService, ModalService , InvestorService , AppConstants) {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/investment-baskets/investment-basket-directives/folio/folio.directive.html',
      link: function (scope) {
        var _this = scope
        _this.reviewModalData = {};
        _this.pattern = AppConstants;
        _this.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        _this.IFSC_REGEX = AppConstants.ifsc_regex;
        _this.soleApplicantEmail = null;
        _this.soleApplicantEmailBelongsTo = null;
        _this.soleApplicantMobile = null;
        _this.soleApplicantMobileBelongsTo = null;
        _this.isCheckedTandC = false;
        _this.belongsToCode =  {
          SP : "Spouse" ,
          DP : "Dependent Parents",
          CD : "Custodian",
          SE : "Self",
          PO : "POA",
          DS : "Dependent Siblings",
          DC : "Dependent Children",
          GD : "Guardian"
        }
        var taxStatusList = [];
        var countryList = [];
        var bankTypeList = [];
        var taxStatusCode = '';


        // dummy data for single folio creation

        // _this.reviewFormData = {
        //   "id": "3d98dba1-70e4-4234-a548-bb3c44cff281",
        //   "soleApplicantDetail": {
        //     "minorDetail": null,
        //     "selfDetail": {
        //       "panNumber": "DGXPK4947Q",
        //       "occupation": "1",
        //       "grossAnnualIncome": 33.0,
        //       "politicalStatus": "NONE",
        //       "fatca": {
        //         "birthCountry": "BD",
        //         "birthPlace": "fgrs",
        //         "payTaxInIndia": true,
        //         "addressType": "RESIDENTIAL",
        //         "fatcaTax1": {
        //           "taxPayingCountry": "AX",
        //           "taxPayingCountryDescription": "Aland Islands",
        //           "taxPayingCity": "CENTRAL DELHI",
        //           "taxId": "INDIA",
        //           "taxIdType": "ID Card"
        //         }
        //       }
        //     },
        //     "personalDetail": {
        //       "taxStatusCode": "01",
        //       "dateOfBirth": "03-Jun-1995",
        //       "email": "ttn.transaction.hdfc@gmail.com",
        //       "mobileNo": "+919999999999",
        //       "taxStatusDescription": "Individual",
        //       "kycEmail": "kswapnil03061995@gmail.com",
        //       "kycMobileNo": "9805049065",
        //       "emailBelongsTo": "SE",
        //       "mobileBelongsTo": "SE"
        //     }
        //   },
        //   "jointHolders": [
        //
        //   ],
        //   "nominees": [
        //     {
        //       "nomineeName": "dsadas",
        //       "nomineeRelation": "SPOUSE",
        //       "percentage": 50,
        //       "dob": "15-Dec-2022",
        //       "nomineeAddress": {
        //
        //       },
        //       "guardianAddress": {
        //         "addressLine1": "PUSHPANJALI ENCLAVE PITAM PURA",
        //         "addressLine2": "C-47,,",
        //         "pinCode": "110034",
        //         "city": "NORTH WEST DELHI",
        //         "state": "XX",
        //         "country": "AT"
        //       },
        //       "minor": true,
        //       "guardianName": "SAS",
        //       "panNumber": "GFBPS4591L",
        //       "guardianPanNumber": "GMIPS1999J",
        //       "guardianRelationWithNominee": "MOTHER"
        //     },
        //     {
        //       "nomineeName": "sassa",
        //       "nomineeRelation": "SPOUSE",
        //       "percentage": 50,
        //       "dob": "22-Nov-1996",
        //       "nomineeAddress": {
        //         "addressLine1": "PUSHPANJALI ENCLAVE PITAM PURA",
        //         "addressLine2": "C-47,,",
        //         "addressLine3": "",
        //         "pinCode": "110034",
        //         "city": "NORTH WEST DELHI",
        //         "state": "XX",
        //         "country": "AT"
        //       },
        //       "guardianAddress": {
        //
        //       },
        //       "minor": false,
        //       "panNumber": "GFBPS4591A"
        //     }
        //   ],
        //   "bankDetails": {
        //     "accountType": "SB",
        //     "accountNumber": "123456789",
        //     "bankName": "IDBI Bank Ltd",
        //     "bankCity": "AMRAVATI",
        //     "bankBranch": "AMRAVATI",
        //     "payoutMechanism": "DC",
        //     "chequeLeaf": "https://dev-api.hdfcfund.com/investor/v1/image/uat/uat/DGXPK4947Q/3d98dba1-70e4-4234-a548-bb3c44cff281/-ChequeLeafProof/CHEQUE_DGXPK4947Q_95e5e26e-5525-4ef3-9458-3d8df4d1a31b_jpg",
        //     "bankHolderType": "INVESTOR",
        //     "accountHolderName": "Swapnil Khanna",
        //     "pennyDropValid": false,
        //     "ifsccode": "IBKL0000507"
        //   },
        //   "brokerCode": "DIRECT",
        //   "holdmode": "SINGLE",
        //   "folioSaveStep": "FIVE",
        //   "minor": false,
        //   "firstFolio": false,
        //   "lastModifiedDate": [
        //     2022,
        //     12,
        //     16,
        //     6,
        //     19,
        //     15,
        //     12000000
        //   ],
        //   "newUserFlow": false,
        //   "standAlone": false,
        //   "panAadharVerifiedFlag": false,
        //   "nomineeOptOut": "N"
        // }


        // dummy data for minor folio creation

        // _this.reviewFormData = {
        //   "id": "7913f6dc-cc85-4571-834d-5bc2f03598d8",
        //   "soleApplicantDetail": {
        //     "minorDetail": {
        //       "minorAgeProof": "https://dev-api.hdfcfund.com/investor/v1/image/uat/uat/DGXPK4947Q/7913f6dc-cc85-4571-834d-5bc2f03598d8/-MinorAgeProof/MINOR_DOB_DGXPK4947Q_2ac7d39f-c8cb-4ff8-85c9-28db8a3ac273_jpg",
        //       "minorRelationshipProof": "https://dev-api.hdfcfund.com/investor/v1/image/uat/uat/DGXPK4947Q/7913f6dc-cc85-4571-834d-5bc2f03598d8/-MinorRelationshipProof/MINOR_REL_DGXPK4947Q_cb97f21a-3060-4bb1-8a4c-51e31318dc4d_jpg",
        //       "guardian": {
        //         "panNumber": "DGXPK4947Q",
        //         "occupation": "4",
        //         "grossAnnualIncome": 31.0,
        //         "politicalStatus": "NONE",
        //         "relation": "FATHER",
        //         "fatca": {
        //           "birthCountry": "BS",
        //           "birthPlace": "DADADADA",
        //           "payTaxInIndia": false,
        //           "addressType": "RESIDENTIAL",
        //           "fatcaTax1": {
        //             "taxPayingCountry": "AF",
        //             "taxPayingCountryDescription": "Afghanistan",
        //             "taxPayingCity": "NORTH WEST DELHI",
        //             "taxId": "121313123213",
        //             "taxIdType": "Election ID Card"
        //           }
        //         }
        //       },
        //       "minorProofType": "School leaving certificate/ Mark sheet issued by Higher Secondary Board of respective states, ICSE, CBSE etc.",
        //       "minorRelationshipProofType": "School leaving certificate/ Mark sheet issued by Higher Secondary Board of respective states, ICSE, CBSE etc."
        //     },
        //     "selfDetail": null,
        //     "personalDetail": {
        //       "firstName": "ttgdfgdfg",
        //       "taxStatusCode": "02",
        //       "dateOfBirth": "19-Jul-2022",
        //       "gender": "MALE",
        //       "taxStatusDescription": "On Behalf Of Minor",
        //       "kycEmail": "kswapnil03061995@gmail.com",
        //       "kycMobileNo": "9805049065",
        //       "emailBelongsTo": "SP",
        //       "mobileBelongsTo": "DS"
        //     }
        //   },
        //   "jointHolders": [
        //
        //   ],
        //   "nominees": [
        //
        //   ],
        //   "bankDetails": {
        //     "accountType": "CA",
        //     "accountNumber": "123456789",
        //     "bankName": "IndusInd Bank",
        //     "bankCity": "AMRITSAR",
        //     "bankBranch": "AMRITSAR",
        //     "payoutMechanism": "DC",
        //     "chequeLeaf": "https://dev-api.hdfcfund.com/investor/v1/image/uat/uat/DGXPK4947Q/7913f6dc-cc85-4571-834d-5bc2f03598d8/-ChequeLeafProof/CHEQUE_DGXPK4947Q_412d2d18-c0a0-4063-9bbf-fb2a3089726e_jpg",
        //     "bankHolderType": "MINOR",
        //     "accountHolderName": "Swapnil Khanna",
        //     "pennyDropValid": false,
        //     "ifsccode": "INDB0000119"
        //   },
        //   "brokerCode": "DIRECT",
        //   "holdmode": "SINGLE",
        //   "folioSaveStep": "FIVE",
        //   "minor": true,
        //   "firstFolio": false,
        //   "lastModifiedDate": [
        //     2022,
        //     12,
        //     20,
        //     7,
        //     54,
        //     11,
        //     874000000
        //   ],
        //   "newUserFlow": false,
        //   "standAlone": false,
        //   "panAadharVerifiedFlag": false,
        //   "nomineeOptOut": "N"
        // }

        // dummy data for join holder folio creation

        _this.reviewFormData = {
          "id": "a8cc4e8f-580b-4359-8f6d-47385ac4fabc",
          "soleApplicantDetail": {
            "minorDetail": null,
            "selfDetail": {
              "panNumber": "DGXPK4947Q",
              "occupation": "4",
              "grossAnnualIncome": 31.0,
              "politicalStatus": "NONE",
              "fatca": {
                "birthCountry": "AX",
                "birthPlace": "NORTH WEST DELHI",
                "payTaxInIndia": false,
                "addressType": "REGISTERED_OFFICE",
                "fatcaTax1": {
                  "taxPayingCountry": "AL",
                  "taxPayingCountryDescription": "Albania",
                  "taxPayingCity": "CENTRAL DELHI",
                  "taxId": "INDIA",
                  "taxIdType": "Passport"
                }
              }
            },
            "personalDetail": {
              "taxStatusCode": "01",
              "dateOfBirth": "03-Jun-1995",
              "email": "ttn.transaction.hdfc@gmail.com",
              "mobileNo": "+919999999999",
              "taxStatusDescription": "Individual",
              "kycEmail": "kswapnil03061995@gmail.com",
              "kycMobileNo": "9805049065",
              "emailBelongsTo": "SP",
              "mobileBelongsTo": "DS"
            }
          },
          "jointHolders": [
            {
              "firstName": "SUMIT",
              "middleName": "",
              "lastName": "",
              "dOB": "07-Apr-1994",
              "gender": "MALE",
              "pan": "GMIPS1999J",
              "email": "SUMITCHHN03@GMAIL.COM",
              "mobileNumber": "8826575989",
              "validPan": true,
              "occupationCode": "1",
              "occupationDescription": "BUSINESS",
              "grossAnnualIncome": 33.0,
              "politicalStatus": "NONE",
              "taxStatusCode": "21",
              "taxStatusDescription": "NRI - Repatriation",
              "fatcaDetail": {
                "birthCountry": "AX",
                "birthPlace": "CENTRAL DELHI",
                "payTaxInIndia": false,
                "addressType": "RESIDENTIAL",
                "fatcaTax1": {
                  "taxPayingCountry": "AFGHANISTAN",
                  "taxPayingCountryDescription": "",
                  "taxPayingCity": "CENTRAL DELHI",
                  "taxId": "32131321",
                  "taxIdType": "Passport"
                }
              },
              "kycverified": "Y"
            }
          ],
          "nominees": [
            {
              "nomineeName": "sasdasd",
              "nomineeRelation": "SON",
              "percentage": 100,
              "dob": "13-Dec-2022",
              "nomineeAddress": {

              },
              "guardianAddress": {
                "addressLine1": "2994/4/A/1 RANJEET NAGAR PATEL NAGAR",
                "addressLine2": "SDASAD",
                "pinCode": "110008",
                "city": "CENTRAL DELHI",
                "state": "XX",
                "country": "DZ"
              },
              "minor": true,
              "guardianName": "SASAS",
              "guardianPanNumber": "GFBPS4591L",
              "guardianRelationWithNominee": "FATHER"
            }
          ],
          "bankDetails": {
            "accountType": "SB",
            "accountNumber": "1234567890",
            "bankName": "Karur Vysya Bank",
            "bankCity": "BANGAORE URBAN",
            "bankBranch": "BANGALORE KENGERI",
            "payoutMechanism": "DC",
            "chequeLeaf": "https://dev-api.hdfcfund.com/investor/v1/image/uat/uat/DGXPK4947Q/a8cc4e8f-580b-4359-8f6d-47385ac4fabc/-ChequeLeafProof/CHEQUE_DGXPK4947Q_11c4ea42-a7b5-4311-b8f0-dfdb64772ea1_jpg",
            "bankHolderType": "MINOR",
            "accountHolderName": "Swapnil Khanna",
            "pennyDropValid": false,
            "ifsccode": "KVBL0001346"
          },
          "brokerCode": "DIRECT",
          "holdmode": "ANY_OR_SURVIVOR",
          "folioSaveStep": "FIVE",
          "minor": false,
          "firstFolio": false,
          "lastModifiedDate": [
            2022,
            12,
            20,
            8,
            31,
            14,
            789000000
          ],
          "newUserFlow": false,
          "standAlone": false,
          "panAadharVerifiedFlag": false,
          "nomineeOptOut": "N"
        }

        _this.soleApplicantEmail = _this.reviewFormData.soleApplicantDetail.personalDetail.kycEmail;
        _this.soleApplicantEmailBelongsTo = _this.belongsToCode[_this.reviewFormData.soleApplicantDetail.personalDetail.emailBelongsTo];
        _this.soleApplicantMobile = _this.reviewFormData.soleApplicantDetail.personalDetail.kycMobileNo;
        _this.soleApplicantMobileBelongsTo = _this.belongsToCode[_this.reviewFormData.soleApplicantDetail.personalDetail.mobileBelongsTo];

        _this.accountType = Object.assign({}, _this.reviewFormData.bankDetails);

        if(_this.reviewFormData.bankDetails && !_this.reviewFormData.bankDetails.bankHolderType){
          _this.reviewFormData.bankDetails.bankHolderType = 'MINOR';
        }
        if(_this.reviewFormData.bankDetails && _this.reviewFormData.bankDetails.chequeLeaf){
          var fileUrl1=(_this.reviewFormData.bankDetails && _this.reviewFormData.bankDetails.chequeLeaf);
          var myFile=fileUrl1.split('/');
          _this.chequeLeafFilename=myFile[myFile.length-1];
          _this.chequeLeafFilename =  _this.chequeLeafFilename && _this.chequeLeafFilename.replace(new RegExp('%20', 'g'), '-');
          /*
          breakFileUrl(_this.reviewFormData.bankDetails.chequeLeaf);*/
        }
        if((_this.reviewFormData.soleApplicantDetail && _this.reviewFormData.soleApplicantDetail.minorDetail && _this.reviewFormData.soleApplicantDetail.minorDetail.minorAgeProof)){
          fileUrl1=(_this.reviewFormData.soleApplicantDetail && _this.reviewFormData.soleApplicantDetail.minorDetail.minorAgeProof);
          myFile=fileUrl1.split('/');
          _this.minorAgeProofFilename=myFile[myFile.length-1];
        }

        if((_this.reviewFormData.soleApplicantDetail && _this.reviewFormData.soleApplicantDetail.minorDetail && _this.reviewFormData.soleApplicantDetail.minorDetail.minorRelationshipProof)){
          fileUrl1=(_this.reviewFormData.soleApplicantDetail && _this.reviewFormData.soleApplicantDetail.minorDetail.minorRelationshipProof);
          myFile=fileUrl1.split('/');
          _this.relationshipProofFilename=myFile[myFile.length-1];
        }
        if(_this.reviewFormData && _this.reviewFormData.minor){
          (_this.reviewFormData.soleApplicantDetail.minorDetail) && addAvailableResidency(_this.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca);
          (_this.MainFolioParent) && (_this.MainFolioParent.isSoleApplicantMinor = true);
        }else{
          (_this.reviewFormData.soleApplicantDetail) && addAvailableResidency(_this.reviewFormData.soleApplicantDetail.selfDetail.fatca);

        }




        taxStatusCode = _this.reviewFormData.soleApplicantDetail.personalDetail.taxStatusCode;


        if( _this.reviewFormData &&  _this.reviewFormData.minor){
          ( _this.reviewFormData.soleApplicantDetail.minorDetail) && addAvailableResidency( _this.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca);
          ( _this.MainFolioParent) && ( _this.MainFolioParent.isSoleApplicantMinor = true);
        }else{
          ( _this.reviewFormData.soleApplicantDetail) && addAvailableResidency( _this.reviewFormData.soleApplicantDetail.selfDetail.fatca);

        }


      function getTaxStatusList() {
        if (_this.reviewFormData.minor) {
          var data = {taxStatusFilter: 'MINOR'};
        } else {
          data = {taxStatusFilter: 'ADULT'};
        }
        var success = function (resp) {
          if (resp.status && resp.data) {
            taxStatusList = resp.data.taxStatus;
            var taxData = taxStatusList.find(function (ele) {
              return ele.taxStatusCode == _this.reviewFormData.soleApplicantDetail.personalDetail.taxStatusCode;
            });
            _this.reviewModalData.taxStatusDescription = taxData?taxData.taxStatusDescription:'';
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          UtilService.errorHandler(err);
        };
        InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
      }

      function getInvestorOccupationList() {
        var success = function (resp) {
          if (resp.status && resp.data) {
            var occupationList = resp.data.investorOccupations;
            if(_this.reviewFormData.minor){
              var occupationCode =  _this.reviewFormData.soleApplicantDetail.minorDetail.guardian.occupation;
            }else{
              occupationCode =  _this.reviewFormData.soleApplicantDetail.selfDetail.occupation;
            }
            var occupationData  = occupationList.find(function (ele) {

              return ele.occupationCode == occupationCode;
            });
            _this.reviewModalData.occupationDescription = occupationData ?occupationData .occupationDescription:'';

            if(angular.isArray(_this.reviewFormData.jointHolders) && _this.reviewFormData.jointHolders.length>0){
              _this.reviewFormData.jointHolders.forEach(function (holder) {
                var jointHolderOccupation  = occupationList.find(function (ele) {
                  return ele.occupationCode == holder.occupationCode;
                });
                holder.occupationDescription = jointHolderOccupation ?jointHolderOccupation.occupationDescription:'';
              })
            }
          }
        };
        InvestorService.get({child1: 'folio', child2: 'occupation'}).$promise.then(success);
      }


      function incomeSlab() {
        var success = function (resp) {
          if (resp.status && resp.data) {
            var incomeSlabDataList = resp.data.incomeSlabList;
            if(_this.reviewFormData.minor){
              var incomeCode =  _this.reviewFormData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
            }else{
              incomeCode =  _this.reviewFormData.soleApplicantDetail.selfDetail.grossAnnualIncome;
            }
            var incomeSlabData  = incomeSlabDataList.find(function (ele) {
              return ele.incomeCode == incomeCode;
            });
            _this.reviewModalData.incomeDescription = incomeSlabData ?incomeSlabData .incomeDescription:'';
            if(angular.isArray(_this.reviewFormData.jointHolders) && _this.reviewFormData.jointHolders.length>0){
              _this.reviewFormData.jointHolders.forEach(function (holder) {
                incomeSlabData  = incomeSlabDataList.find(function (ele) {
                  return ele.incomeCode == holder.grossAnnualIncome;
                });
                holder.incomeDescription = incomeSlabData ?incomeSlabData .incomeDescription:'';
              })
            }
          } else {
            MessageService.error(resp.message);
          }
        };

        InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success);
      }

      function addAvailableResidency(fatca) {
        _this.fatcaArray=[];
        if (fatca.fatcaTax1) {
          _this.fatcaArray.push(fatca.fatcaTax1);
        }
        if (fatca.fatcaTax2) {
          _this.fatcaArray.push(fatca.fatcaTax2);
        }
        if (fatca.fatcaTax3) {
          _this.fatcaArray.push(fatca.fatcaTax3);
        }
        if(_this.payTaxInIndia == false && _this.fatcaArray.length ===0){
          _this.fatcaArray.push({});
        }
      }


      function getCountryList() {
        var success = function (resp) {
          if (resp.status && resp.data) {
            countryList = resp.data.countries;
            if(_this.reviewFormData.minor){
              var countryCode =  _this.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry;
            }else{
              countryCode =  _this.reviewFormData.soleApplicantDetail.selfDetail.fatca.birthCountry;
            }
            var countryData  = countryList.find(function (ele) {
              return ele.countryCode ==countryCode;
            });
            _this.reviewModalData.birthCountry = countryData ?countryData.countryName:'';

            angular.forEach(_this.reviewFormData.jointHolders, function (holder) {
              if(holder.fatcaDetail && holder.fatcaDetail.birthCountry){

                countryData  = countryList.find(function (ele) {
                  return ele.countryCode == holder.fatcaDetail.birthCountry;
                });
                holder.fatcaDetail.birthCountryDescription = countryData ?countryData.countryName:'';
              }
            });



            angular.forEach(_this.reviewFormData.nominees, function (nominee) {
              if(nominee.guardianAddress && nominee.guardianAddress.country){

                countryData  = countryList.find(function (ele) {
                  return ele.countryCode ==nominee.guardianAddress.country;
                });
                nominee.guardianAddress.countryName = countryData ?countryData.countryName:'';
              }
              if(nominee.nomineeAddress && nominee.nomineeAddress.country){

                countryData  = countryList.find(function (ele) {
                  return ele.countryCode ==nominee.nomineeAddress.country;
                });
                nominee.nomineeAddress.countryName = countryData ?countryData.countryName:'';
              }
            })

          }
        };
        InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success);
      }

      function getTaxIdTypeList() {
        var success = function (resp) {
          if (resp.status && resp.data) {
            var taxIdTypeList = resp.data.taxIdTypeResponses;
            var taxIdTypeData  = taxIdTypeList.find(function (ele) {
              return ele.value == _this.reviewFormData.value;
            });
            _this.reviewModalData.description = taxIdTypeData?taxIdTypeData.description:'';
          }
        };
        InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success);
      }

      function getAddressType() {
        var success = function (resp) {
          if (resp.status && resp.data) {
            var addressTypeList = resp.data.addressTypeResponses;
            var addressTypeData  = addressTypeList.find(function (ele) {
              return ele.value == _this.reviewFormData.value;
            });
            _this.reviewModalData.addressDescription = addressTypeData?addressTypeData.addressDescription:'';

            angular.forEach(_this.reviewFormData.jointHolders, function (holder) {

              if(holder.fatcaDetail && holder.fatcaDetail.addressType){

                addressTypeData  = addressTypeList.find(function (ele) {
                  return ele.value == holder.fatcaDetail.addressType;
                });
                holder.fatcaDetail.addressType = addressTypeData ?addressTypeData.addressDescription:'';
              }
            });

            if(_this.reviewFormData.minor){
              if(_this.reviewFormData.soleApplicantDetail.minorDetail.guardian &&
                _this.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca &&
                _this.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.addressType){

                addressTypeData  = addressTypeList.find(function (ele) {
                  return ele.value == _this.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.addressType;
                });
                _this.reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.addressTypeDescription = addressTypeData?addressTypeData.addressDescription:'';
              }
            }else{
              if(_this.reviewFormData.soleApplicantDetail.selfDetail &&
                _this.reviewFormData.soleApplicantDetail.selfDetail.fatca &&
                _this.reviewFormData.soleApplicantDetail.selfDetail.fatca.addressType){

                addressTypeData  = addressTypeList.find(function (ele) {
                  return ele.value == _this.reviewFormData.soleApplicantDetail.selfDetail.fatca.addressType;
                });
                _this.reviewFormData.soleApplicantDetail.selfDetail.fatca.addressTypeDescription = addressTypeData?addressTypeData.addressDescription:'';
              }
            }

          }
        };
        InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success);
      }

      function getAcccountType() {
        var success = function (resp) {
            if (resp.status && resp.data) {
              bankTypeList = resp.data.bankAccountTypes;
              if(bankTypeList.length && bankTypeList.length >0){
                if(taxStatusCode == "01"){
                  bankTypeList&&bankTypeList.length>3 && (!_this.reviewFormData.bankDetails.accountType || _this.reviewFormData.bankDetails.accountType==="NRE" )?
                    _this.reviewFormData.bankDetails.accountType=bankTypeList[3].accountTypeCode
                    :''
                } else{
                  bankTypeList&&bankTypeList.length>0?
                    _this.reviewFormData.bankDetails.accountType=bankTypeList[0].accountTypeCode
                    :''
                }
                // _this.reviewModalData.accountType = getAccountNameByCode(_this.reviewFormData.bankDetails.accountType);

                _this.reviewModalData.accountType = getAccountNameByCode(_this.accountType.accountType);
                //to set the default value of account type field as per the requirement
              }

            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            UtilService.errorHandler(err);
          };

        InvestorService.get({
          child1: 'folio',
          child2: 'bank',
          child3: 'account-type-list',
          child4: taxStatusCode
        }).$promise.then(success, error);
      }


      function getPayoutMechanism() {
        var success = function (resp) {
          if (resp.status && resp.data) {
            var payoutMechanismList = resp.data.payoutMechanisms;
            var payoutMechanismData  = payoutMechanismList.find(function (ele) {
              return ele.payoutCode == _this.reviewFormData.bankDetails.payoutMechanism;
            });
            _this.reviewModalData.payoutDescription = payoutMechanismData?payoutMechanismData.payoutDescription:'';
          }
        };

        InvestorService.get({child1: 'folio', child2: 'payout-mechanism'}).$promise.then(success);
      }


      function getRelationship() {
        _this.applicantRelationShip = {};
        _this.minorRelationShip = {};

        var success = function (resp) {
          if (resp.status && resp.data) {
            var relationshipWithApplicant = resp.data.nomineeRelationshipList;
            var relationshipWithMinor = resp.data.guardianRelationshipList;

            relationshipWithApplicant.forEach(function(el) {
              _this.applicantRelationShip[el.value] = el.relationDesc;
            })

            relationshipWithMinor.forEach(function(el) {
              _this.minorRelationShip[el.value] = el.relationDesc;
            })

          } else {
            _this.applicantRelationShip = {};
            _this.minorRelationShip = {};
            MessageService.error(resp.message);
          }
        }, error = function () {
          _this.applicantRelationShip = {};
          _this.minorRelationShip = {};
        };
        InvestorService.get({
          child1: 'folio',
          child2: 'nominee',
          child3: 'relation'
        }).$promise.then(success, error);
      }

      function getAccountNameByCode(accCode) {
        if(!accCode || bankTypeList.length<1)return"";
        var bankTypeData  = bankTypeList.find(function (ele) {
          return ele.accountTypeCode == accCode;
        });
        return bankTypeData ?bankTypeData.accountType:'';
      }

      _this.dummyNomineeData = [
      {
        "nomineeName": "dsadas",
        "nomineeRelation": "SPOUSE",
        "percentage": 50,
        "dob": "15-Dec-2022",
        "nomineeAddress": {

      },
        "guardianAddress": {
        "addressLine1": "PUSHPANJALI ENCLAVE PITAM PURA",
          "addressLine2": "C-47,,",
          "pinCode": "110034",
          "city": "NORTH WEST DELHI",
          "state": "XX",
          "country": "AT"
      },
        "minor": true,
        "guardianName": "SAS",
        "panNumber": "GFBPS4591L",
        "guardianPanNumber": "GMIPS1999J",
        "guardianRelationWithNominee": "MOTHER"
      },
      {
        "nomineeName": "sassa",
        "nomineeRelation": "SPOUSE",
        "percentage": 50,
        "dob": "22-Nov-1996",
        "nomineeAddress": {
        "addressLine1": "PUSHPANJALI ENCLAVE PITAM PURA",
          "addressLine2": "C-47,,",
          "addressLine3": "",
          "pinCode": "110034",
          "city": "NORTH WEST DELHI",
          "state": "XX",
          "country": "AT"
      },
        "guardianAddress": {

      },
        "minor": false,
        "panNumber": "GFBPS4591A"
      }
    ]


      getTaxStatusList();
      getInvestorOccupationList();
      incomeSlab();
      getCountryList();
      getTaxIdTypeList();
      getAddressType();
      getAcccountType();
      getPayoutMechanism();
      getRelationship();

      _this.showTermConditions = function () {
        alert("TNC CLICKED")
      }


      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('basketList', basketList);

  /*@ngInject*/
  function basketList($timeout, $state, LoaderService, UtilService, MessageService, InvestmentBasketService) {
    return {
      restrict: 'E',
      scope: {

      },
      templateUrl: 'app/investment-baskets/investment-basket-directives/basket-list-directive/basket-list.directive.html',
      link: function (scope) {
        var _this = scope;
        _this.basketList = [];
        _this.fetchBasketList = fetchBasketList;
        _this.proceedToInvest = proceedToInvest;


        _this.init = function() {
          fetchBasketList();
        };
        _this.init();

        function fetchBasketList() {
          LoaderService.showLoader();
          _this.basketList = {
            baskets: [
              {
                basketName: "HDFC Balance Basket",
                basketSchemes: [
                  {
                    schemeName: "HDFC Top 100 Fund",
                    sipAmount: "7581.7",
                    riskProfile: "Moderately High Risk",
                    type: ""
                  },
                  {
                    schemeName: "HDFC Top 100 Fund",
                    sipAmount: "7581.7",
                    riskProfile: "Very High Risk",
                    type: "Hybrid"
                  },
                  {
                    schemeName: "HDFC Banking & PSU Debit Fund",
                    sipAmount: "7581.7",
                    riskProfile: "Very High Risk",
                    type: ""
                  },
                  {
                    schemeName: "HDFC Banking & PSU Debit Fund",
                    sipAmount: "7581.7",
                    riskProfile: "Very High Risk",
                    type: ""
                  }
                ]
              }
            ]
          };
          /*var success = function(response) {
            LoaderService.hideLoader();
            if (response.status && response.data) {
              scope.goalsList = response.data.goalDetailDTOList;
            }
            else {
              MessageService.error(response.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          InvestmentBasketService.get({
            child1: 'investment',
            child2: 'basket',
            child3: 'getGoalDetails'
          }).$promise.then(success, error);*/
        }

        function proceedToInvest(goalName, goalId) {
          $state.go("main.questionnaire", {goalName: goalName.replaceAll(" ", "-").toLowerCase()});
        }
      }
    }
  }
})();

/**
 * Created by ttn on 20/12/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestNowPaymentController', investNowPaymentController);

  /** @ngInject */
  function investNowPaymentController($window, $stateParams, AuthService, LoaderService, $state, ModalService, AppConstants, DynamicDataSipPurchaseReview, notesPayment) {
    var vm = this;
    vm.isLoading = false;
    var identifierData = AuthService.getInstaToken();
    vm.investorName = identifierData ? identifierData.investorName : 'Investor Name';
    vm.isExistingInvestor = true;
    vm.uniqueLink = $stateParams.id;
    vm.dynamicDataSipPurchaseReview = DynamicDataSipPurchaseReview;
    vm.notesPayment = notesPayment;
    vm.noteNetBanking = vm.notesPayment.noteDTO.noteDTOMap;
    vm.init = init;

    init();
    function init() {

    }
  }
})();

/**
 * Created by ttn on 20/12/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestNowAddFolioController', investNowAddFolioController);

  /** @ngInject */
  function investNowAddFolioController($window, $stateParams, AuthService, LoaderService, $state, ModalService, AppConstants) {
    var vm = this;
    vm.isLoading = false;
    var identifierData = AuthService.getInstaToken();
    vm.investorName = identifierData ? identifierData.investorName : 'Investor Name';
    vm.isExistingInvestor = true;
    vm.uniqueLink = $stateParams.id;
    vm.init = init;
    vm.moveToPayment = moveToPayment;

    init();
    function init() {
      if (vm.isExistingInvestor) {
        showFolioSelectionModal();
      }
    }

    function showFolioSelectionModal() {
      var success = function() {

      }, error = function() {
        vm.isLoading = true;
      };
      ModalService.fillFolioModal({
        text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_LAST_FOLIO
      }, success, error);
    }

    function moveToPayment() {
      $state.go("investNow.payment");
    }
  }
})();

/**
 * Created by ttn on 19/22/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentBasketViewController', investmentBasketViewController);

  /** @ngInject */
  function investmentBasketViewController($state) {
    var vm = this;
    var chart = c3.generate({
      data: {
        // iris data from R
        columns: [
          ['Hdfc top 100 fund', 35],
          ['Hdfc top 100 fund 2', 15],
          ['Hdfc top 100 fund 3', 20],
          ['Hdfc top 100 fund 4', 30]
        ],
        type : 'pie'
      },
      color: { pattern: ["#00c0f2", "#103880", "#2485bd", "#4d7dbd"] }
    });

    // setTimeout(function () {
    //   chart.load({
    //     columns: [
    //       ["setosa", 0.2, 0.2, 0.2, 0.2, 0.2, 0.4, 0.3, 0.2, 0.2, 0.1, 0.2, 0.2, 0.1, 0.1, 0.2, 0.4, 0.4, 0.3, 0.3, 0.3, 0.2, 0.4, 0.2, 0.5, 0.2, 0.2, 0.4, 0.2, 0.2, 0.2, 0.2, 0.4, 0.1, 0.2, 0.2, 0.2, 0.2, 0.1, 0.2, 0.2, 0.3, 0.3, 0.2, 0.6, 0.4, 0.3, 0.2, 0.2, 0.2, 0.2],
    //       ["versicolor", 1.4, 1.5, 1.5, 1.3, 1.5, 1.3, 1.6, 1.0, 1.3, 1.4, 1.0, 1.5, 1.0, 1.4, 1.3, 1.4, 1.5, 1.0, 1.5, 1.1, 1.8, 1.3, 1.5, 1.2, 1.3, 1.4, 1.4, 1.7, 1.5, 1.0, 1.1, 1.0, 1.2, 1.6, 1.5, 1.6, 1.5, 1.3, 1.3, 1.3, 1.2, 1.4, 1.2, 1.0, 1.3, 1.2, 1.3, 1.3, 1.1, 1.3],
    //       ["virginica", 2.5, 1.9, 2.1, 1.8, 2.2, 2.1, 1.7, 1.8, 1.8, 2.5, 2.0, 1.9, 2.1, 2.0, 2.4, 2.3, 1.8, 2.2, 2.3, 1.5, 2.3, 2.0, 2.0, 1.8, 2.1, 1.8, 1.8, 1.8, 2.1, 1.6, 1.9, 2.0, 2.2, 1.5, 1.4, 2.3, 2.4, 1.8, 1.8, 2.1, 2.4, 2.3, 1.9, 2.3, 2.5, 2.3, 1.9, 2.0, 2.3, 1.8],
    //     ]
    //   });
    // }, 1500);
    //
    // setTimeout(function () {
    //   chart.unload({
    //     ids: 'data1'
    //   });
    //   chart.unload({
    //     ids: 'data2'
    //   });
    // }, 2500);


  }
})();

/**
 * Created by ttn on 29/12/22.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentBasketDetailsController', InvestmentBasketDetailsController);

  /** @ngInject */
  function InvestmentBasketDetailsController($state, $window, $scope, $stateParams, AuthService, InvestmentBasketService, LoaderService, ModalService, AppConstants,
    MessageService, HDFC_API, JSShare, UtilService) {
    var vm = this;
    vm.id = $stateParams.id;
    vm.imageBaseUrl = "assets/images/icons/investor-basket/";
    vm.basketList = [];
    vm.basketDetails = {};
    vm.whatsappShare = whatsappShare;
    vm.emailShare = emailShare;
    vm.twitterShare = twitterShare;
    vm.facebookShare = facebookShare;
    init();

    function init() {
      $window.scrollTo(0, 0);
      getAllBaskets();
      setShareVariables();
    }

    function getAllBaskets() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          LoaderService.hideLoader();
          vm.basketList = resp.data.basketDetailDTOList;
          vm.basketDetails = vm.basketList.filter(function (x) { return x.basketId == vm.id })[0] || {};
          loadPreSelectedOption();
          setUrls();
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err)
      }

      LoaderService.showLoader();

      InvestmentBasketService.get({
        child1: 'investment',
        child2: 'basket',
        child3: 'getAllBaskets'
      }).$promise.then(success, error);
    }

    function loadPreSelectedOption() {
      if (vm.basketDetails.schemesInBasket) {
        vm.basketDetails.schemesInBasket.forEach(function (scheme) {
          var options = Object.keys(scheme.annualisedReturns);
          scheme.updAnnualisedReturns = [];
          scheme.updBenchmarkReturns = [];
          var orders = [11, 10, 5, 3, 1];
          orders.forEach(function(order) {
            var annualisedObj = {};
            var benchmarkObj = {};
            if (order !== 11) {
              annualisedObj = {
                key: order,
                value: scheme.annualisedReturns[order]
              };
              benchmarkObj = {
                key: order,
                value: scheme.benchmarkReturns[order]
              };
            } else {
              annualisedObj = {
                key: 'Since Inception',
                value: scheme.annualisedReturns[order]
              };
              benchmarkObj = {
                key: 'Since Inception',
                value: scheme.benchmarkReturns[order]
              };
            }
            scheme.updAnnualisedReturns.push(annualisedObj);
            scheme.updBenchmarkReturns.push(benchmarkObj);
          });

          var returns = scheme.updAnnualisedReturns[0];
          scheme.selectedOption = returns ?
            {
              id: returns.key,
              annualisedReturns: returns.value,
              benchmarkReturn: scheme.updBenchmarkReturns[0].value
            } : {};
          var fundType = scheme.direct ? 'direct' : 'regular';
          scheme.fundUrl = HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + scheme.linkUrl + '/' + fundType;
        });
      }
    }

    vm.onOptionChange = function (scheme, key, value) {
      scheme.selectedOption = {
        id: key,
        annualisedReturns: value,
        benchmarkReturn: key !== 'Since Inception' ? scheme.benchmarkReturns[key] : scheme.benchmarkReturns[11]
      };
    };

    vm.investNow = function (basket, btnId) {
      vm.containRetirementScheme = UtilService.checkForRetirementScheme(basket.schemesInBasket);
      if (sessionStorage.getItem('viaViewDetails') && btnId == 1) {
        redirectToInvestNow(basket.basketId);
        return;
      }
      var success = function (resp) {
        if (resp === "SELECT_NEW") {
          sessionStorage.setItem('folioSelectedForNewFolio', false);
          proceedToFolioSelection(basket.basketId, basket.basketName);
        } else {
          selectExistingFolio(basket.basketId, basket.basketName);
        }
      }, error = function () {
      };
      ModalService.folioChoiceModal({
        isFromPostLogin: true
      }, success, error);
    };

    function selectExistingFolio(basketId, basketName) {
      var success = function (resp) {
        if (resp === "SELECT_NEW") {
          sessionStorage.setItem('folioSelectedForNewFolio', true);
          proceedToFolioSelection(basketId, basketName);
        } else {
          sessionStorage.removeItem("folioSelected");
          sessionStorage.setItem('folioSelectedForNewFolio', false);
          saveDetails(basketId, basketName);
        }
      }, error = function () {
      };
      ModalService.fillFolioDetailsModal({
        text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
        journey: AppConstants.JOURNEY.INVESTMENT_BASKET_JOURNEY,
        isFromPostLogin: true
      }, success, error);
    }

    function proceedToFolioSelection(basketId, basketName) {
      var success = function (resp) {
        vm.folioNumber = resp;
        sessionStorage.setItem("folioSelected", vm.folioNumber);
        saveDetails(basketId, basketName);
      }, error = function () {
      };
      ModalService.selectFolioModal({
        journey: AppConstants.JOURNEY.INVESTMENT_BASKET_JOURNEY,
        retirementFlag: vm.containRetirementScheme
      }, success, error);
    }

    function redirectToInvestNow(basketId) {
      sessionStorage.setItem('investNowBackUrl', 'main.investment.basketDetails');
      sessionStorage.setItem('investNowBackParams', JSON.stringify({ id: vm.id }));
      $state.go('main.investment.investNow', {
        basketId: basketId,
        retirementFlag: vm.containRetirementScheme === true ? true : null,
        journey: 'INVESTMENT_BASKET_JOURNEY'
      });

    }

    function saveDetails(basketId, basketName) {
      var identifierData = AuthService.getToken();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          sessionStorage.setItem("journeyDraftId", resp.data.id);
          redirectToInvestNow(basketId);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err)
      }

      LoaderService.showLoader();

      var requestBody = {
        "panNumber": identifierData.investorPAN,
        "journey": "INVESTMENT_BASKET_JOURNEY",
        "step": "FIRST",
        "basket": true,
        "basketDetails": {
          "basketId": basketId,
          "basketName": basketName
        }
      }
      // var journeyDraftId = sessionStorage.getItem("journeyDraftId");
      // if(journeyDraftId){
      //  requestBody.id = journeyDraftId;
      // }

      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'saveDetails'
      }, requestBody).$promise.then(success, error);
    }

    function setShareVariables() {
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      var isAndroid = /(android)/i.test(navigator.userAgent);
      vm.options = {};
      if (isIOS || isAndroid) {
        vm.options.link_telegram = 'tg://msg';
        vm.options.link_whatsapp = 'whatsapp://send';
      }
    }

    function setUrls() {
      var corporateUrl = HDFC_API.CORPORATE_URL;
      vm.basketUrl = corporateUrl + 'investment-basket/' + vm.basketDetails.basketName.replaceAll(" ", "-").toLowerCase();
    }

    function whatsappShare(e) {
      return JSShare.go(e.currentTarget, vm.options);
    }
    function emailShare(e) {
      return JSShare.go(e.currentTarget, vm.options);
    }
    function twitterShare(e) {
      return JSShare.go(e.currentTarget, vm.options);
    }
    function facebookShare(e) {
      return JSShare.go(e.currentTarget, vm.options);
    }

  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('videosController', videosController);

  /** @ngInject */
  function videosController(InvestorService, LoaderService, MessageService, UtilService, ModalService, $sce) {
    var vm = this;
    vm.init = init();

    function init() {
      vm.videosList = [];
      JSON.parse(localStorage.getItem("videoUrl")).forEach(function (item, value) {
        if (value === 0 || value === 1) {
          vm.videosList.push({name: item.name, thumbnail: captureThumbnails(item.url), url: item.url, class: "col-xs-12 col-sm-12 col-md-6"});
        } else {
          vm.videosList.push({name: item.name, thumbnail: captureThumbnails(item.url), url: item.url, class: "col-xs-12 col-sm-12 col-md-4"});
        }
      });
    }

    function captureThumbnails(videoUrl) {
      if (videoUrl.includes("youtube")) {
        var youtube_video_id = videoUrl.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
        return $sce.trustAsResourceUrl("https://img.youtube.com/vi/" + youtube_video_id +"/0.jpg");
      } else {
        return "assets/images/youtube.png";
      }
    }


    vm.playVideo = function (videoUrl) {
      ModalService.showVideoPlayModal({url: $sce.trustAsResourceUrl(videoUrl)});
    };
  }
})
();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginTaxResidencyMinorController', firstLoginTaxResidencyMinorCtrl);

  /** @ngInject */
  function firstLoginTaxResidencyMinorCtrl(MessageService,InvestorService,$log,$state,$scope,AppConstants,LoaderService,AuthService) {
    var vm = this;
    vm.getCountryList = getCountryList;
    vm.countryList = [];
    vm.addressTypeList = [];
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.formData = {};
    vm.fatcaArray = [];
    vm.taxIdTypeList = [];

    vm.init = function () {
      LoaderService.showLoader();
      setHeader();
      $scope.FolioDetailsParent.stepsAway = 3;
      getCountryList();
      getAddressTypeList();
      getTaxIdTypeList();
      getPayload();
    };

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.FolioDetailsParent.panNumber = profile.investorPAN;
      $scope.FolioDetailsParent.firstName = profile.investorFName;
    }

    vm.addNewResidencyFields = function () {

      vm.fatcaArray.push(
        {
          "taxPayingCountry": '',
          "taxId": '',
          "taxIdNumber": ''
        });
    };

    vm.addAvailableResidency = function (fatca) {
      if(fatca.fatcaTax1){
        vm.fatcaArray.push(fatca.fatcaTax1);
      }
      if(fatca.fatcaTax2){
        vm.fatcaArray.push(fatca.fatcaTax2);
      }
      if(fatca.fatcaTax3){
        vm.fatcaArray.push(fatca.fatcaTax3);
      }
    };

    vm.setSelectedResidency = function () {
     var fatca = vm.payload.guardianDetail.fatca;

     delete fatca.fatcaTax1;
     delete fatca.fatcaTax2;
     delete fatca.fatcaTax3;

     if(vm.payload.guardianDetail.fatca.payTaxInIndia){
        return;
      }

     if(vm.fatcaArray[0]){
       fatca.fatcaTax1 = vm.fatcaArray[0];
     }

      if(vm.fatcaArray[1]){
        fatca.fatcaTax2 = vm.fatcaArray[1];
      }

      if(vm.fatcaArray[2]){
        fatca.fatcaTax3 = vm.fatcaArray[2];
      }

    }

    vm.deleteTaxResidency = function (index) {
      vm.fatcaArray.splice(index, 1);
    }

    function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            if(angular.fromJson(localStorage.getItem('minorMode')) === true){
              vm.payload = resp.data.minor;
            }else{
              vm.payload = resp.data.self;
            }
            setDefaultValues();
            LoaderService.hideLoader();
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
        };

      // InvestorService.get({child1: 'folio', child2: 'newInvestorFolio'}).$promise.then(success, error);
      InvestorService.get({
        child1: 'fresh',
        child2: 'folio',
        child3: 'get',
        child4: 'drafts'
      }).$promise.then(success, error);

    }

    vm.changePayTaxOutsideIndiaStatus = function (status) {
      if(!status){
        return;
      }
      if(vm.fatcaArray.length===0){
        vm.addNewResidencyFields();
      }
    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
        $log.info("error====", err);
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
    }

    vm.next = function () {
      if(vm.payload.soleApplicantDetail.minor){
        savePayload('folioDetails.bankDetails');
      } else {
        savePayload('folioDetails.addNominee');
      }
    }

    function getAddressTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.addressTypeList = resp.data.addressTypeResponses;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
        $log.info("error====", err);
      };
      InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success, error);
    }

    vm.back = function () {
      savePayload('folioDetails.politicalExposed');
    }

    function setDefaultValues() {

      if(vm.payload.guardianDetail.fatca && angular.isUndefined(vm.payload.guardianDetail.fatca.payTaxInIndia)){
        vm.payload.guardianDetail.fatca.payTaxInIndia = true;
      }

      var a = vm.payload.guardianDetail.fatca.fatcaTax1;
      if(a ){
        if(Object.keys(a).length===0){
          vm.addNewResidencyFields();
        } else {
          vm.addAvailableResidency(vm.payload.guardianDetail.fatca);
        }
      }
    }

    function savePayload(stateToMove) {
      vm.payload.saveStep = '4';
      vm.setSelectedResidency();


      var success = function (resp) {
          if (resp.status && resp.data) {
            $state.go(stateToMove);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
        };

      // InvestorService.post({child1: 'folio', child2: 'newInvestorFolio'}, vm.payload).$promise.then(success, error);
      InvestorService.post({
        child1: 'fresh',
        child2: 'folio',
        child3: 'save'
      }, vm.payload).$promise.then(success, error);
    }

    function getTaxIdTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdTypeList = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxIdTypeList = null;
        $log.info("error====", err);
      };
      InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success, error);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginTaxResidencyController', firstLoginTaxResidencyCtrl);

  /** @ngInject */
  function firstLoginTaxResidencyCtrl(MessageService,InvestorService,$log,$state,$scope,AppConstants,LoaderService,AuthService, $window) {
    var vm = this;
    vm.getCountryList = getCountryList;
    vm.getTaxIdTypeList = getTaxIdTypeList;
    vm.countryList = [];
    vm.taxIdTypeList = [];
    vm.addressTypeList = [];
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.formData = {};

    vm.init = function () {
      LoaderService.showLoader();
      setHeader();
      $scope.FolioDetailsParent.stepsAway = 3;
      getCountryList();
      getTaxIdTypeList();
      getAddressTypeList();
      getPayload();
    };

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.FolioDetailsParent.panNumber = profile.investorPAN;
      $scope.FolioDetailsParent.firstName = profile.investorFName;
    }

    vm.addNewResidencyFields = function () {
      if(!vm.payload.soleApplicantDetail.payOutsideIndiaAddresses)
        vm.payload.soleApplicantDetail.payOutsideIndiaAddresses = [];

      vm.payload.soleApplicantDetail.payOutsideIndiaAddresses.push(
        {
          "countryName": '',
          "birthCity": '',
          "taxIdType": '',
          "taxIdNumber": ''
        }
      )
    }

    vm.deleteTaxResidency = function (index) {
      vm.payload.soleApplicantDetail.payOutsideIndiaAddresses.splice(index, 1);
      //vm._soleApplicant.isMaxPayOutsideEntries = false;
    }

    function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            if(angular.fromJson(localStorage.getItem('minorMode')) === true){
              vm.payload = resp.data.minor;
            }else{
              vm.payload = resp.data.self;
            }
            if (vm.payload && vm.payload.soleApplicantDetail && angular.isUndefined(vm.payload.soleApplicantDetail.payTaxInIndia)) {
              vm.payload.soleApplicantDetail.payTaxInIndia = true;
            }
            var taxStatusFlag = localStorage.getItem('taxStatusFlag');
            if(taxStatusFlag == "true"){
              if (vm.payload.soleApplicantDetail.taxStatusCode == '21' || vm.payload.soleApplicantDetail.taxStatusCode == '24') {
                vm.payload.soleApplicantDetail.payTaxInIndia = false;
                $window.localStorage.setItem('taxStatusFlag',false);
              }
              else {
                vm.payload.soleApplicantDetail.payTaxInIndia = true;
                $window.localStorage.setItem('taxStatusFlag',false);
              }
            }

            if(vm.payload && vm.payload.soleApplicantDetail && !vm.payload.soleApplicantDetail.payOutsideIndiaAddresses){
              vm.payload.soleApplicantDetail.payOutsideIndiaAddresses = [];
              vm.addNewResidencyFields();
            }

            LoaderService.hideLoader();
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
        };

      // InvestorService.get({
      InvestorService.get({
        child1: 'fresh',
        child2: 'folio',
        child3: 'get',
        child4: 'drafts'
      }).$promise.then(success, error);

    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
        $log.info("error====", err);
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
    }

    function getTaxIdTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdTypeList = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxIdTypeList = null;
        $log.info("error====", err);
      };
      InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success, error);
    }

    vm.next = function () {
      savePayload('folioDetails.addNominee');
    };

    function getAddressTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.addressTypeList = resp.data.addressTypeResponses;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
        $log.info("error====", err);
      };
      InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success, error);
    }

    vm.back = function () {
      savePayload('folioDetails.politicalExposed');
    }

    function savePayload(stateToMove) {
      vm.payload.saveStep = '4';
      if(vm.payload.soleApplicantDetail.payTaxInIndia)
       delete vm.payload.soleApplicantDetail.payOutsideIndiaAddresses;


      var success = function (resp) {
          if (resp.status && resp.data) {
            $state.go(stateToMove);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
        };

      // InvestorService.post({child1: 'folio', child2: 'newInvestorFolio'}, vm.payload).$promise.then(success, error);
      InvestorService.post({
        child1: 'fresh',
        child2: 'folio',
        child3: 'save'
      }, vm.payload).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginReviewController', firstLoginReviewController);

  /** @ngInject */
  function firstLoginReviewController($stateParams, $window, ModalService, AppConstants, $state, MessageService, InvestorService, $log,$scope,
                                     LoaderService,AuthService, InvestorFileUploadService, UtilService, InvestorServiceV3) {
    var vm = this;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.pattern = AppConstants;
    vm.accModelDirty = false;
    vm.formData = {};
    vm.reviewModalData = {};
    vm.verifyAccountNumber ='';
    vm.chooseAFile = true;
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp","application/pdf"];
    vm.chequeLeafUrl = '';
    vm.savePayload = savePayload;
    vm.selfDeclaration = selfDeclaration;
    vm.getCountryNameByCode = getCountryNameByCode;
    vm.getTaxStatusNameByCode = getTaxStatusNameByCode;
    var taxStatusCode = '';
    $scope.FolioDetailsParent.stepsAway = 1;

    vm.init = function () {
      $window.scrollTo(0, 0);
      LoaderService.showLoader();
      setHeader();

      getPayload(function (status) {
        if(status){
          bankNameList();
          getTaxStatusList();
          getInvestorOccupationList();
          incomeSlab();
          getCountryList();
          getTaxIdTypeList();
          getAddressType();
          getAcccountType();
          getPayoutMechanism();
        }
      });
    };

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.MainFolioParent.panNumber = profile.investorPAN;
      $scope.MainFolioParent.firstName = profile.investorFName;
      $scope.MainFolioParent.lastName = profile.investorLName;
      $scope.MainFolioParent.currentState = 'main.folio.bankdetails';

    }

    function getPayload(cb) {
      cb = cb || function () {};
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.formData = resp.data;
            $scope.MainFolioParent.holdmode = resp.data.holdmode;
            if(vm.formData.bankDetails && !vm.formData.bankDetails.bankHolderType){
              vm.formData.bankDetails.bankHolderType = 'MINOR';
            }
            if(vm.formData.bankDetails && vm.formData.bankDetails.chequeLeaf){
              breakFileUrl(vm.formData.bankDetails.chequeLeaf);
            }
            if(vm.formData.soleApplicantDetail && vm.formData.soleApplicantDetail.minor){
              $scope.MainFolioParent.isSoleApplicantMinor = true;
            }

            taxStatusCode = vm.formData.soleApplicantDetail.taxStatusCode;
            LoaderService.hideLoader();
            cb(true);
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
            cb(false);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
          cb(false);
        };

      // InvestorService.get({child1: 'folio', child2: 'getSavedFolio', child3:localStorage.getItem('folioId')}).$promise.then(success, error);

      var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'getDetails'
      },{id:investorId}).$promise.then(success, error);
    }

    function bankNameList() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'bank-list'}).$promise.then(success, error);
    }
    var bankTypeList = [];
    function getAcccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            bankTypeList = resp.data.bankAccountTypes;
            if(bankTypeList.length && bankTypeList.length >0){
              if(taxStatusCode == "01"){
                bankTypeList&&bankTypeList.length>3 && (!vm.formData.bankDetails.accountType || vm.formData.bankDetails.accountType==="NRE" )?
                  vm.formData.bankDetails.accountType=bankTypeList[3].accountTypeCode
                  :''
              } else{
                bankTypeList&&bankTypeList.length>0?
                  vm.formData.bankDetails.accountType=bankTypeList[0].accountTypeCode
                  :''
              }
              vm.reviewModalData.accountType = getAccountNameByCode(vm.formData.bankDetails.accountType);
              //to set the default value of account type field as per the requirement
            }

          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };

      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4: taxStatusCode
      }).$promise.then(success, error);
    }

    function getAccountNameByCode(accCode) {
      if(!accCode || bankTypeList.length<1)return"";
      var bankTypeData  = bankTypeList.find(function (ele) {
        return ele.accountTypeCode == accCode;
      });
      return bankTypeData ?bankTypeData.accountType:'';
    }

    var taxStatusList =[];
    function getTaxStatusList() {
      if (vm.formData.minor) {
        var data = {taxStatusFilter: 'MINOR'};
      } else {
        data = {taxStatusFilter: 'ADULT'};
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          taxStatusList = resp.data.taxStatus;
          var taxData = taxStatusList.find(function (ele) {
            return ele.taxStatusCode == vm.formData.soleApplicantDetail.taxStatusCode;
          });
          vm.reviewModalData.taxStatusDescription = taxData?taxData.taxStatusDescription:'';
        } else {
          MessageService.error(resp.message);
        }
      }, error = function () {
      };
      InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
    }


    function getTaxStatusNameByCode(taxCode) {
      if(!taxCode || taxStatusList.length<1)return"";
      var taxData  = taxStatusList.find(function (ele) {
        return ele.taxStatusCode == taxCode;
      });
      return taxData ?taxData.taxStatusDescription:'';
    }

    function getInvestorOccupationList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          var occupationList = resp.data.investorOccupations;
          var occupationData  = occupationList.find(function (ele) {
            return ele.occupationCode == vm.formData.soleApplicantDetail.occupation;
          });
          vm.reviewModalData.occupationDescription = occupationData ?occupationData .occupationDescription:'';
        }
      };
      InvestorService.get({child1: 'folio', child2: 'occupation'}).$promise.then(success);
    }

    function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            incomeSlabData = resp.data.incomeSlabList;
            var incomeSlabData  = incomeSlabData.find(function (ele) {
              return ele.incomeCode == vm.formData.soleApplicantDetail.incomeCode;
            });
            vm.reviewModalData.incomeDescription = incomeSlabData ?incomeSlabData .incomeDescription:'';
          } else {
            MessageService.error(resp.message);
          }
        };

      InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success);
    }

    var countryList = [];
    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          countryList = resp.data.countries;
          var countryData  = countryList.find(function (ele) {
            return ele.countryCode == vm.formData.soleApplicantDetail.birthCountry;
          });
          vm.reviewModalData.birthCountry = countryData ?countryData.countryName:'';
        }
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success);
    }

    function getTaxIdTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          var taxIdTypeList = resp.data.taxIdTypeResponses;
          var taxIdTypeData  = taxIdTypeList.find(function (ele) {
            return ele.value == vm.formData.value;
          });
          vm.reviewModalData.description = taxIdTypeData?taxIdTypeData.description:'';
        }
      };
      InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success);
    }


    function getAddressType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          var addressTypeList = resp.data.addressTypeResponses;
          var addressTypeData  = addressTypeList.find(function (ele) {
            return ele.value == vm.formData.value;
          });
          vm.reviewModalData.addressDescription = addressTypeData?addressTypeData.addressDescription:'';
        }
      };
      InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success);
    }


    function getPayoutMechanism() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            var payoutMechanismList = resp.data.payoutMechanisms;
            var payoutMechanismData  = payoutMechanismList.find(function (ele) {
              return ele.payoutCode == vm.formData.bankDetails.payoutMechanism;
            });
            vm.reviewModalData.payoutDescription = payoutMechanismData?payoutMechanismData.payoutDescription:'';
          }
        };

      InvestorService.get({child1: 'folio', child2: 'payout-mechanism'}).$promise.then(success);
    }


    function getCountryNameByCode(countryCode) {
    if(!countryCode || countryList.length<1)return"";
      var countryData  = countryList.find(function (ele) {
        return ele.countryCode == countryCode;
      });
      return countryData ?countryData.countryName:'';
    }



    vm.accFocus = function () {
      vm.accModelDirty = true;
    };

    vm.copyPasteHandler=function (e) {

      var key = e.keyCode?e.keyCode:e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if ( key == 86 && ctrl ) {
        e.preventDefault();
      } else if ( key == 67 && ctrl ) {
        e.preventDefault();
      }
    };

    vm.done = function () {
      savePayload('main.folio.review');
    };

    vm.save =  function(){
      savePayloadBankDetails('');
    };

    vm.back = function () {
      if(vm.formData.soleApplicantDetail.minor){
        // localStorage.setItem('type', 'minor');
        savePayload('main.folio.soleApplicant');
        // $state.go('main.folio.soleApplicant');
      } else {
        // localStorage.setItem('type', 'self');
        savePayload('main.folio.nominee');
        //$state.go('main.folio.nominee');
      }
    }

    function savePayloadBankDetails(stateToMove) {
      LoaderService.showLoader();
      if(vm.formData){
        vm.formData.newFolioComplete = false;
        vm.formData.id = localStorage.getItem('folioId');
      }
      saveDetails(stateToMove);

    }

    function savePayload(stateToMove) {
      LoaderService.showLoader();
      if(vm.formData){
        if(!stateToMove){
          vm.formData.newFolioComplete = true;
        } else {
          vm.formData.newFolioComplete = false;
        }
        vm.formData.id = localStorage.getItem('folioId');
      }
      if(vm.formData.newFolioComplete){
        completeFolio(stateToMove);
      } else {
        saveDetails(stateToMove);
      }
    }

    function completeFolio(stateToMove) {
      var success = function (resp) {
          if (resp.status && resp.data) {
            if(stateToMove){
              LoaderService.hideLoader();
              $state.go(stateToMove,{isBack:true});
            } else {
              LoaderService.hideLoader();
              $scope.MainFolioParent.bankDetailSuccess = true;
              showPopUp(resp.data);
            }
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('Occupation Errror>>>>', err);
        };
      if(vm.formData && vm.formData.bankDetails && vm.formData.bankDetails.payoutMechanism){
        // delete vm.formData.bankDetails.verifyAccountNumber;
        delete vm.formData.bankDetails.payoutMechanism.micrMandatory;
        delete vm.formData.bankDetails.payoutMechanism.payoutDescription;
      }
      vm.formData.saveStep = 5;
      InvestorService.post({child1: 'folio', child2: 'createNewFolio'}, vm.formData).$promise.then(success, error);
    }

    function saveDetails (stateToMove) {
      LoaderService.showLoader();
      (stateToMove==='main.folio.nominee')&&(vm.formData.saveStep = 4);
      (stateToMove==='main.folio.nominee')&&(vm.formData.saveStep = 2);
      (stateToMove==='main.folio.review')&&(vm.formData.saveStep = 5);

      var success = function (resp) {
        if (resp.status && resp.data) {
          localStorage.setItem('folioId', resp.data.id);
          $scope.MainFolioParent.uuid = resp.data.id;
          if(stateToMove){
            // $scope.MainFolioParent.uuid = resp.data.id;
            LoaderService.hideLoader();
            $state.go(stateToMove,{isBack:true});

          }
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      InvestorService.post({child1: 'folio', child2: 'saveFolio'}, vm.formData).$promise.then(success, error);
    }

    function showPopUp(data) {
      var successModal = function () {
          // delete $window.sessionStorage.investorForm;
          $window.sessionStorage.removeItem("investorForm");
          $state.go('welcome')
        },
        errorModal = function (err) {
          if(err!=null){
            MessageService.error(err)
          }
        };
      data = data ||{};
      data.holdmode = vm.formData.holdmode;/////////////////////////
      ModalService.folioCreationSuccessModal(data, successModal, errorModal);
    }

    function selfDeclaration(data) {
      var successModal = function () {
          $state.go('login')
        },
        errorModal = function (err) {
          if(err!=null){
            MessageService.error(err)
          }
        };
      ModalService.selfDeclarationModal(data, successModal, errorModal);
    }

    function uploadChequeLeafFile(file) {

      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if(file){
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.formData.bankDetails.chequeLeaf = resp.data.fileUrl;

                breakFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader(err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            // DistributorProfileUploadService.post({

            InvestorFileUploadService.post({
              child1:'folio',
              child2: $scope.MainFolioParent.uuid,
              child3: 'bankDetails',
              child4: 'chequeLeaf',
              child5: 'upload'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function breakFileUrl(url) {

      url = url.replace(/ /g,'');
      var a, extension;
      if(url.split('.jp').length > 1){
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if(url.split('.png').length > 1){
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if(url.split('.pdf').length > 1){
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if(url.split('.bmp').length > 1){
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      } else if(url.split('.tiff').length > 1){
        extension = '.tiff';
        a = url.split('.tiff')[0].split('/');
      }

      if(angular.isUndefined(extension)){
        MessageService.error("Given cheque Leaf file type is not allowed, Pleaese provide a different file type.")
        vm.chequeLeafUrl = "";
      }else{
        vm.chequeLeafUrl = a[a.length-1]+extension;
      }
      vm.chooseAFile = false;

    }

    vm.openUploadedDoc = function() {
      if(angular.isUndefined(vm.formData.bankDetails.chequeLeaf)){return;}
      ModalService.showImage({docUrl: vm.formData.bankDetails.chequeLeaf});
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginPoliticalExposedController', FirstLoginPoliticalExposedCtrl);

  /** @ngInject */
  function FirstLoginPoliticalExposedCtrl(AppConstants,CreatePayloadFactory, MessageService, $state,InvestorService,$log,$scope,LoaderService,AuthService) {
    var vm = this;
    //vm.payload.soleApplicantDetail.politicalStatus = 'NONE';
    vm.POLITICAL_STATUS = AppConstants.INVESTOR_POLITICAL_STATUS;
    vm.init = function () {
      LoaderService.showLoader();
      setHeader();
      $scope.FolioDetailsParent.stepsAway = 4;
      getPayload();

    }


    function setHeader() {
      var profile = AuthService.getToken();
      $scope.FolioDetailsParent.panNumber = profile.investorPAN;
      $scope.FolioDetailsParent.firstName = profile.investorFName;
    }

    function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            if(angular.fromJson(localStorage.getItem('minorMode')) === true){
              vm.payload = resp.data.minor;
            }else{
              vm.payload = resp.data.self;
            }
            setDefaultValues();

            LoaderService.hideLoader();
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
        };

      InvestorService.get({
        child1: 'fresh',
        child2: 'folio',
        child3: 'get',
        child4: 'drafts'
      }).$promise.then(success, error);

    }

    vm.next = function () {
      if(vm.payload.soleApplicantDetail.minor){
        savePayload('folioDetails.taxResidencyMinor');
      } else {
        savePayload('folioDetails.taxResidency');
      }
    }

    vm.back = function () {

      if(vm.payload.soleApplicantDetail.minor){
        savePayload('folioDetails.incomeDetailsMinor');
      } else {
        savePayload('folioDetails.incomeDetails');
      }
    }

    function setDefaultValues() {
      if(vm.payload && vm.payload.soleApplicantDetail && !vm.payload.soleApplicantDetail.minor && !vm.payload.soleApplicantDetail.politicalStatus){
        vm.payload.soleApplicantDetail.politicalStatus = 'NONE';
      } else if(vm.payload && vm.payload.guardianDetail && !vm.payload.guardianDetail.pepStatus){
        vm.payload.guardianDetail.pepStatus = 'NONE';
      }

      if(vm.payload.soleApplicantDetail && vm.payload.soleApplicantDetail.minor){
        vm.headingText = "Guardian's Politically Exposed Person (PEP) Status ";

      } else {
        vm.headingText = "Politically Exposed Person (PEP) Status ";
      }

    }

    function savePayload(stateToMove) {
      vm.payload.saveStep = '3';

      var success = function (resp) {
          if (resp.status && resp.data) {
            $state.go(stateToMove);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
        };

      InvestorService.post({
        child1: 'fresh',
        child2: 'folio',
        child3: 'save'
      }, vm.payload).$promise.then(success, error);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginJointHoldersController', firstLoginJointHoldersCtrl);

  /** @ngInject */
  function firstLoginJointHoldersCtrl(AppConstants, $state, MessageService, InvestorService,
                                       $log, $scope, LoaderService, AuthService, InvestorFileUploadService,
                                       moment, ModalService) {
    var vm = this;
    vm.defaultMinorDob = moment().toString();
    vm.minDateMinor = moment().subtract(18, 'years').toString();
    vm.minorDobFile = null;
    vm.minorRelationshipProof = null;
    vm.uploadMinorDobFile = uploadMinorDobFile;
    vm.uploadMinorRelationshipFile = uploadMinorRelationshipFile;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.ageProofDocUrl = '';
    vm.relationshipDocUrl = '';
    // vm.payload = {soleApplicantDetail: {minor: false, taxStatusCode: '',}};
    vm.chooseAFile = true;
    vm.chooseARelationshipFile = true;
    vm.taxStatusList = [];
    vm.genderList = [{name: 'Male', value: 'MALE'}, {name: 'Female', value: 'FEMALE'}];
    vm.relationshipList = [{name: 'Father', value: 'FATHER'}, {name: 'Mother', value: 'MOTHER'}, {
      name: 'Sibling',
      value: 'SIBLING'
    }, {name: 'Other', value: 'OTHER'}];

    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.changeFolioMode = changeFolioMode;

    $scope.FolioDetailsParent.stepsAway = 4;
    vm.init = function () {
      LoaderService.showLoader();
      setHeader();
      getTaxStatusList();
      getPayload();
    };

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.FolioDetailsParent.panNumber = profile.investorPAN;
      $scope.FolioDetailsParent.firstName = profile.investorFName;
      $scope.FolioDetailsParent.lastName = profile.investorLName;
    }

    /*
    *false=>Self
    * true=Minor
    * */
    function changeFolioMode() {
      localStorage.setItem('minorMode', vm.minor);
      // localStorage.removeItem('minorMode');
      if (masterPayload) {
        vm.payload = (vm.minor === true) ? angular.copy(masterPayload.minor)
          : angular.copy(masterPayload.self);
      }
      vm.payload.soleApplicantDetail.minor = vm.minor;
      if (vm.payload.soleApplicantDetail.minorAgeProof) {
        breakFileUrl(vm.payload.soleApplicantDetail.minorAgeProof);
      }
      if (vm.payload.soleApplicantDetail.minorRelationshipProof) {
        breakRelationshipFileUrl(vm.payload.soleApplicantDetail.minorRelationshipProof);
      }
    }

    function getTaxStatusList() {
      var data = {taxStatusFilter: 'MINOR'}
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusList = resp.data.taxStatus;
        } else {
          vm.taxStatusList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxStatusList = null;
        $log.info("error====", err);
      };
      InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
    }

    vm.changeMinorDob = function (date) {
      if (!date) {
        vm.defaultMinorDob = null;
        vm.payload.soleApplicantDetail.personalDetail.dateOfBirth = null;
        return;
      }
      vm.defaultMinorDob = date.toString();
      vm.payload.soleApplicantDetail.personalDetail.dateOfBirth = date.clone().format('DD-MMM-YYYY').toString();
    };
    var masterPayload = {};

    function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            masterPayload = resp.data;
            vm.minor = angular.fromJson(localStorage.getItem('minorMode'));
            if (masterPayload) {
              vm.payload = (vm.minor === true) ? angular.copy(masterPayload.minor)
                : angular.copy(masterPayload.self);
            }
            // vm.payload.id = resp.data.id? resp.data.id : null;
            setDefaultData();
            LoaderService.hideLoader();
          } else {
            /*MessageService.error(resp.message);*/
            LoaderService.hideLoader();
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
        };

      InvestorService.get({
        child1: 'fresh',
        child2: 'folio',
        child3: 'get',
        child4: 'drafts'
      }).$promise.then(success, error);

    }

    vm.next = function () {
      if (vm.payload.soleApplicantDetail.minor) {
        savePayload('folioDetails.incomeDetailsMinor');
      } else {
        savePayload('folioDetails.incomeDetails');
      }
    };

    function setDefaultData() {
      if (vm.payload.soleApplicantDetail) {
        if (!vm.payload.soleApplicantDetail.minor) {
          vm.payload.soleApplicantDetail.minor = false;
        }
      }

      if (!vm.payload.guardianDetail) {
        createDefaultGuardian();
      }

      if (vm.payload.soleApplicantDetail.minorAgeProof) {
        breakFileUrl(vm.payload.soleApplicantDetail.minorAgeProof);
      }
      if (vm.payload.soleApplicantDetail.minorRelationshipProof) {
        breakRelationshipFileUrl(vm.payload.soleApplicantDetail.minorRelationshipProof);
      }
    }

    function createDefaultGuardian() {
      vm.payload.guardianDetail = {
        name: $scope.FolioDetailsParent.firstName + ' ' + $scope.FolioDetailsParent.lastName,
        panNumber: '',
        occupationCode: '',
        income: '',
        netWorth: '',
        relation: ''
      };

    }

      function savePayload(stateToMove) {
        vm.payload.saveStep = '1';
        var success = function (resp) {
            if (resp.status && resp.data) {
              localStorage.setItem('folioId',resp.data.id);$state.go(stateToMove);
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            $log.info('Occupation Errror>>>>', err);
          };

        if(vm.payload){
          vm.payload.id = vm.payload.id? vm.payload.id : null;
        }//fresh/folio/save
       // InvestorService.post({child1: 'folio', child2: 'newInvestorFolio'}, vm.payload).$promise.then(success, error);
        InvestorService.post({
          child1: 'fresh',
          child2: 'folio',
          child3: 'save'
        }, vm.payload).$promise.then(success, error);
    }

    function uploadMinorDobFile(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.payload.soleApplicantDetail.minorAgeProof = resp.data.fileUrl;
                  vm.payload.id = resp.data.uuid?resp.data.uuid:resp.payload.id;
                  localStorage.setItem('folioId',vm.payload.id);
                breakFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            // DistributorProfileUploadService.post({
            InvestorFileUploadService.post({
              child1: 'fresh',
              child2: 'folio',
              child3: 'minor',
              child4: 'ageProof',
              child5: 'upload',
              child6: vm.payload.id ? vm.payload.id : 'null'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function uploadMinorRelationshipFile(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.payload.soleApplicantDetail.minorRelationshipProof = resp.data.fileUrl;
                  vm.payload.id = resp.data.uuid?resp.data.uuid:resp.payload.id;
                  localStorage.setItem('folioId',vm.payload.id);

                breakRelationshipFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            // DistributorProfileUploadService.post({
            InvestorFileUploadService.post({
              child1: 'fresh',
              child2: 'folio',
              child3: 'relationship',
              child4: 'proof',
              child5: 'upload',
              child6: vm.payload.id ? vm.payload.id : 'null'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function breakRelationshipFileUrl(url) {
      if(!url){return;}
      vm.relationshipDocUrl = 'Preview Uploaded Doc';
      vm.chooseARelationshipFile = false;
      return;

      /*url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      vm.relationshipDocUrl = a[a.length - 1] + extension;
      vm.relationshipDocUrl =  vm.relationshipDocUrl && vm.relationshipDocUrl.replace(new RegExp('%20', 'g'), '-');


      vm.chooseARelationshipFile = false;*/

    }

    function breakFileUrl(url) {
      if(!url){return;}
      vm.ageProofDocUrl = 'Preview Uploaded Doc';
      vm.chooseAFile = false;
      return;

      /*url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      vm.ageProofDocUrl = a[a.length - 1] + extension;
      vm.ageProofDocUrl =  vm.ageProofDocUrl && vm.ageProofDocUrl.replace(new RegExp('%20', 'g'), '-');
      vm.chooseAFile = false;*/

    }

    vm.openUploadedDoc = function (url) {
      if(angular.isUndefined(url)){return;}
        ModalService.showImage({docUrl: url});
      // window.open(vm.payload.soleApplicantDetail.minorAgeProof);
    }

    vm.openRelationshipDoc = function () {
      // window.open(vm.payload.soleApplicantDetail.minorAgeProof);
      if(angular.isUndefined(vm.payload.soleApplicantDetail.minorAgeProof)){return;}
      ModalService.showImage({docUrl: vm.payload.soleApplicantDetail.minorAgeProof});
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginIncomeDetailsMinorController', firstLoginIncomeDetailsMinorCtrl);

  /** @ngInject */
  function firstLoginIncomeDetailsMinorCtrl(AppConstants,$state,MessageService,InvestorService,$log,$scope,LoaderService,AuthService, moment) {
    var vm = this;
    vm.defaultsoleApplicantNWDate = moment().toString();
    vm.countryList = [];
    vm.occupationList = [];
    vm.incomeSlabList = [];
    vm.taxStatusList = [];
    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.minDate = moment().subtract(1, 'years').toString();
    vm.properties = ['netWorth', 'netWorthDate','occupation','taxStatusCode','grossAnnualIncome'];

    vm.payload = {
      soleApplicantDetail: {
        taxStatusCode: '',
        occupation: '',
        grossAnnualIncome: '',
        netWorth: '',
        netWorthDate: ''
      },
      saveStep:"1"
    };

    vm.init = function () {
      LoaderService.showLoader();
      setHeader();
      $scope.FolioDetailsParent.stepsAway = 6;
      getTaxStatusList();
      getInvestorOccupationList();
      incomeSlab();
      getPayload();
    };

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.FolioDetailsParent.panNumber = profile.investorPAN;
      $scope.FolioDetailsParent.firstName = profile.investorFName;
    }

    vm.resetNetWorthDetails = function() {
      if(vm.payload.guardianDetail.income){
        vm.payload.guardianDetail.netWorth = "";
        vm.payload.guardianDetail.netWorthDate = "";
      }
    };

    function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            if(angular.fromJson(localStorage.getItem('minorMode')) === true){
              vm.payload = resp.data.minor;
            }else{
              vm.payload = resp.data.self;
            }
            LoaderService.hideLoader();
          } else {
            //MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
        };

      InvestorService.get({
        child1: 'fresh',
        child2: 'folio',
        child3: 'get',
        child4: 'drafts'
      }).$promise.then(success, error);

    }

    vm.Next = function () {
      $state.go('firstTimeFolioStep2');

    };

    vm.changeNetWorthDateForSoleApplicant = function (date) {
      if (!date) {
        return;
      }
      vm.defaultsoleApplicantNWDate = date.toString();
      vm.payload.guardianDetail.netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
    };

    function getTaxStatusList() {
      var data = {taxStatusFilter:'MINOR'}
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusList = resp.data.taxStatus;
        } else {
          vm.taxStatusList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxStatusList = null;
        $log.info("error====", err);
      };
      InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
    }

    function getInvestorOccupationList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.occupationList = resp.data.investorOccupations;
        } else {
          vm.occupationList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.occupationList = null;
        $log.info("error====", err);
      };
      InvestorService.get({child1: 'folio',child2:'occupation'}).$promise.then(success, error);
    }

    function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.incomeSlabList = resp.data.incomeSlabList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success, error);
    }

    vm.back = function () {
      savePayload('folioDetails.folioCreation');
    };

    vm.next = function () {
      savePayload('folioDetails.politicalExposed');
    };

    function savePayload(stateToMove) {
      vm.payload.saveStep = '2';

      var success = function (resp) {
          if (resp.status && resp.data) {
            $state.go(stateToMove);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
        };

      InvestorService.post({
        child1: 'fresh',
        child2: 'folio',
        child3: 'save'
      }, vm.payload).$promise.then(success, error);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginIncomeDetailsController', firstLoginIncomeDetailsCtrl);

  /** @ngInject */
  function firstLoginIncomeDetailsCtrl(AppConstants,$state,MessageService,InvestorService,$log,$scope,LoaderService,AuthService, moment, $window) {
    var vm = this;
    vm.defaultsoleApplicantNWDate = moment().toString();
    vm.countryList = [];
    vm.occupationList = [];
    vm.incomeSlabList = [];
    vm.taxStatusList = [];
    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.minDate = moment().subtract(1, 'years').toString();
    vm.changeTaxStatus =changeTaxStatus;


    vm.payload = {
      soleApplicantDetail: {
        taxStatusCode: '',
        occupation: '',
        grossAnnualIncome: '',
        netWorth: '',
        netWorthDate: ''
      },
      saveStep:"1"
    };

    vm.init = function () {
      LoaderService.showLoader();
      setHeader();
      $scope.FolioDetailsParent.stepsAway = 5;
      getTaxStatusList();
      getInvestorOccupationList();
      incomeSlab();
      getPayload();
    };

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.FolioDetailsParent.panNumber = profile.investorPAN;
       $scope.FolioDetailsParent.firstName = profile.investorFName;
    }

    vm.resetNetWorthDetails = function() {
      if(vm.payload.soleApplicantDetail.grossAnnualIncome){
        vm.payload.soleApplicantDetail.netWorth = "";
        vm.payload.soleApplicantDetail.netWorthDate = "";
      }
    };

    function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data){
            if(angular.fromJson(localStorage.getItem('minorMode')) === true){
              vm.payload = resp.data.minor;
            }else{
              vm.payload = resp.data.self;
            }
            localStorage.setItem('folioId',resp.data.id);
            if(!vm.payload.soleApplicantDetail.taxStatusCode){
              vm.payload.soleApplicantDetail.taxStatusCode= vm.taxStatusList.length && vm.taxStatusList.length >0
                ?vm.taxStatusList[0].taxStatusCode //to select the first element in the list
                :'';
            }

            LoaderService.hideLoader();
          } else {
            //MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
        };

      InvestorService.get({
        child1: 'fresh',
        child2: 'folio',
        child3: 'get',
        child4: 'drafts'
      }).$promise.then(success, error);

    }

    vm.Next = function () {
      $state.go('firstTimeFolioStep2');

    };

    vm.changeNetWorthDateForSoleApplicant = function (date) {
      if (!date) {
        return;
      }
      vm.defaultsoleApplicantNWDate = date.toString();
      vm.payload.soleApplicantDetail.netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
    };

    function getTaxStatusList() {
      var data = {taxStatusFilter:'ADULT'}
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusList = resp.data.taxStatus;
        } else {
          vm.taxStatusList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxStatusList = null;
        $log.info("error====", err);
      };
      InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
    }

    function getInvestorOccupationList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.occupationList = resp.data.investorOccupations;
        } else {
          vm.occupationList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.occupationList = null;
        $log.info("error====", err);
      };
      InvestorService.get({child1: 'folio',child2:'occupation'}).$promise.then(success, error);
    }

    function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.incomeSlabList = resp.data.incomeSlabList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success, error);
    }

    vm.back = function () {
      savePayload('folioDetails.folioCreation');
    };

    vm.next = function () {
      savePayload('folioDetails.politicalExposed');
    };

    function savePayload(stateToMove) {
      vm.payload.saveStep = '2';
      if(vm.payload.soleApplicantDetail.grossAnnualIncome){
        vm.payload.soleApplicantDetail.netWorth ='';
      }
      var success = function (resp) {
          if (resp.status && resp.data) {
            localStorage.setItem('folioId',resp.data.id);
            $state.go(stateToMove);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
        };

      // InvestorService.post({child1: 'folio', child2: 'newInvestorFolio'}, vm.payload).$promise.then(success, error);
      InvestorService.post({
        child1: 'fresh',
        child2: 'folio',
        child3: 'save'
      }, vm.payload).$promise.then(success, error);
    }

   function changeTaxStatus() {

       $window.localStorage.setItem('taxStatusFlag',true);


   }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginHoldModeController', firstLoginHoldModeCtrl);

  /** @ngInject */
  function firstLoginHoldModeCtrl(AppConstants, $state, MessageService, InvestorService, InvestorServiceV3, ModalService,
                                  InvestorFolioModel, $stateParams, $log, $scope, LoaderService, AuthService, InvestorFileUploadService, moment) {
    var vm = this;
    vm.defaultMinorDob = moment().toString();
    vm.minDateMinor = moment().subtract(18, 'years').toString();
    vm.minorDobFile = null;
    vm.minorRelationshipProof = null;
    vm.uploadMinorDobFile = uploadMinorDobFile;
    vm.uploadMinorRelationshipFile = uploadMinorRelationshipFile;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.ageProofDocUrl = '';
    vm.relationshipDocUrl = '';
    // vm.payload = {soleApplicantDetail: {minor: false, taxStatusCode: '',}};
    vm.chooseAFile = true;
    vm.chooseARelationshipFile = true;
    vm.taxStatusList = [];
    vm.genderList = [{name: 'Male', value: 'MALE'}, {name: 'Female', value: 'FEMALE'}];
    vm.relationshipList = [{name: 'Father', value: 'FATHER'}, {name: 'Mother', value: 'MOTHER'}, {
      name: 'Sibling',
      value: 'SIBLING'
    }, {name: 'Other', value: 'OTHER'}];

    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.changeFolioMode = changeFolioMode;

    vm.init = function () {
      // LoaderService.showLoader();

      // getTaxStatusList();
      getPayload(function(){
        setHeader();
        checkStepAway();
      });
    };

    function checkStepAway() {


      if(vm.formData){
        if((!vm.formData.minor) && (vm.formData.holdmode =="ANY_OR_SURVIVOR")){
          $scope.FolioDetailsParent.stepsAway = 6;
        }
        else if((!vm.formData.minor) && (vm.formData.holdmode =="SINGLE")){
          $scope.FolioDetailsParent.stepsAway = 5;
        }
        else if(vm.formData.minor){
          $scope.FolioDetailsParent.stepsAway = 4;
        }
        }

    }

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.FolioDetailsParent.panNumber = profile.investorPAN;
      $scope.FolioDetailsParent.firstName = profile.investorFName;
      $scope.FolioDetailsParent.lastName = profile.investorLName;
    }

    /*
    *false=>Self
    * true=Minor
    * */
    function changeFolioMode() {
      localStorage.setItem('minorMode', vm.minor);
      // localStorage.removeItem('minorMode');
      if (masterPayload) {
        vm.payload = (vm.minor === true) ? angular.copy(masterPayload.minor)
          : angular.copy(masterPayload.self);
      }
      vm.payload.soleApplicantDetail.minor = vm.minor;
      if (vm.payload.soleApplicantDetail.minorAgeProof) {
        breakFileUrl(vm.payload.soleApplicantDetail.minorAgeProof);
      }
      if (vm.payload.soleApplicantDetail.minorRelationshipProof) {
        breakRelationshipFileUrl(vm.payload.soleApplicantDetail.minorRelationshipProof);
      }
    }
/*
    function getTaxStatusList() {
      var data = {taxStatusFilter: 'MINOR'}
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusList = resp.data.taxStatus;
        } else {
          vm.taxStatusList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxStatusList = null;
        $log.info("error====", err);
      };
      InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
    }*/

    vm.changeMinorDob = function (date) {
      if (!date) {
        vm.defaultMinorDob = null;
        vm.payload.soleApplicantDetail.personalDetail.dateOfBirth = null;
        return;
      }
      vm.defaultMinorDob = date.toString();
      vm.payload.soleApplicantDetail.personalDetail.dateOfBirth = date.clone().format('DD-MMM-YYYY').toString();
    };
    var masterPayload = {};

    function getPayload(cb) {
      cb = cb || function () {};

      if($stateParams.investorId || localStorage.getItem('folioId')){

        var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              vm.formData = resp.data||{};
              vm.formData.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
              $scope.FolioDetailsParent.holdmode = resp.data.holdmode;
              LoaderService.hideLoader();
              cb();
            } else {
              /*MessageService.error(resp.message);*/
              LoaderService.hideLoader();
              cb();
            }
          },
          error = function (err) {
            $log.info('Occupation Errror>>>>', err);
            LoaderService.hideLoader();
            cb();
          };

        var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
        InvestorServiceV3.post({
          child1: 'folio',
          child2: 'getDetails'
        },{id:investorId}).$promise.then(success, error);
      }else{
        vm.formData = InvestorFolioModel.getNewInvestorFolioFormDataModel();
        $scope.FolioDetailsParent.holdmode  = "SINGLE";
        cb();
      }


    }

    vm.next = function () {
        savePayload('folioDetails.folioCreation');
    };
/*
    function setDefaultData() {
      if (vm.payload.soleApplicantDetail) {
        if (!vm.payload.soleApplicantDetail.minor) {
          vm.payload.soleApplicantDetail.minor = false;
        }
      }

      if (!vm.payload.guardianDetail) {
        createDefaultGuardian();
      }

      if (vm.payload.soleApplicantDetail.minorAgeProof) {
        breakFileUrl(vm.payload.soleApplicantDetail.minorAgeProof);
      }
      if (vm.payload.soleApplicantDetail.minorRelationshipProof) {
        breakRelationshipFileUrl(vm.payload.soleApplicantDetail.minorRelationshipProof);
      }
    }*/
/*
    function createDefaultGuardian() {
      vm.payload.guardianDetail = {
        name: $scope.FolioDetailsParent.firstName + ' ' + $scope.FolioDetailsParent.lastName,
        panNumber: '',
        occupationCode: '',
        income: '',
        netWorth: '',
        relation: ''
      };

    }*/

      function savePayload(stateToMove) {
        vm.payload.saveStep = '1';
        var success = function (resp) {
            if (resp.status && resp.data) {
              localStorage.setItem('folioId',resp.data.id);$state.go(stateToMove);
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            $log.info('Occupation Errror>>>>', err);
          };

        if(vm.payload){
          vm.payload.id = vm.payload.id? vm.payload.id : null;
        }//fresh/folio/save
       // InvestorService.post({child1: 'folio', child2: 'newInvestorFolio'}, vm.payload).$promise.then(success, error);
        InvestorService.post({
          child1: 'fresh',
          child2: 'folio',
          child3: 'save'
        }, vm.payload).$promise.then(success, error);
    }

    function uploadMinorDobFile(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.payload.soleApplicantDetail.minorAgeProof = resp.data.fileUrl;
                  vm.payload.id = resp.data.uuid?resp.data.uuid:resp.payload.id;
                  localStorage.setItem('folioId',vm.payload.id);
                breakFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            // DistributorProfileUploadService.post({
            InvestorFileUploadService.post({
              child1: 'fresh',
              child2: 'folio',
              child3: 'minor',
              child4: 'ageProof',
              child5: 'upload',
              child6: vm.payload.id ? vm.payload.id : 'null'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function uploadMinorRelationshipFile(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.payload.soleApplicantDetail.minorRelationshipProof = resp.data.fileUrl;
                  vm.payload.id = resp.data.uuid?resp.data.uuid:resp.payload.id;
                  localStorage.setItem('folioId',vm.payload.id);

                breakRelationshipFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            // DistributorProfileUploadService.post({
            InvestorFileUploadService.post({
              child1: 'fresh',
              child2: 'folio',
              child3: 'relationship',
              child4: 'proof',
              child5: 'upload',
              child6: vm.payload.id ? vm.payload.id : 'null'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function breakRelationshipFileUrl(url) {

      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      vm.relationshipDocUrl = a[a.length - 1] + extension;
      vm.relationshipDocUrl =  vm.relationshipDocUrl && vm.relationshipDocUrl.replace(new RegExp('%20', 'g'), '-');


      vm.chooseARelationshipFile = false;

    }

    function breakFileUrl(url) {

      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      vm.ageProofDocUrl = a[a.length - 1] + extension;
      vm.ageProofDocUrl =  vm.ageProofDocUrl && vm.ageProofDocUrl.replace(new RegExp('%20', 'g'), '-');
      vm.chooseAFile = false;

    }

    vm.openUploadedDoc = function () {
      // window.open(vm.payload.soleApplicantDetail.minorAgeProof);
      if(angular.isUndefined(vm.payload.soleApplicantDetail.minorAgeProof)){return;}
      ModalService.showImage({docUrl: vm.payload.soleApplicantDetail.minorAgeProof});
    }

    vm.openRelationshipDoc = function () {
      // window.open(vm.payload.soleApplicantDetail.minorAgeProof);
      if(angular.isUndefined(vm.payload.soleApplicantDetail.minorAgeProof)){return;}
      ModalService.showImage({docUrl: vm.payload.soleApplicantDetail.minorAgeProof});
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginFolioCreationController', firstLoginFolioCreationCtrl);

  /** @ngInject */
  function firstLoginFolioCreationCtrl($window, $stateParams, AppConstants, $state, MessageService, InvestorService, InvestorServiceV3,
                                       $log, $scope, LoaderService, AuthService, InvestorFileUploadService, moment, ModalService) {
    var vm = this;
    vm.defaultMinorDob = moment().toString();
    vm.minDateMinor = moment().subtract(18, 'years').toString();
    vm.minorDobFile = null;
    vm.minorRelationshipProof = null;
    vm.uploadMinorDobFile = uploadMinorDobFile;
    vm.uploadMinorRelationshipFile = uploadMinorRelationshipFile;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.ageProofDocUrl = '';
    vm.relationshipDocUrl = '';
    // vm.payload = {soleApplicantDetail: {minor: false, taxStatusCode: '',}};
    vm.chooseAFile = true;
    vm.chooseARelationshipFile = true;
    vm.taxStatusList = [];
    vm.genderList = [{name: 'Male', value: 'MALE'}, {name: 'Female', value: 'FEMALE'}];
    vm.relationshipList = [{name: 'Father', value: 'FATHER'}, {name: 'Mother', value: 'MOTHER'}, {
      name: 'Sibling',
      value: 'SIBLING'
    }, {name: 'Other', value: 'OTHER'}];
    vm.ekycEmail = null;
    vm.emailBelongsTo = null;
    vm.ekycMobile = null;
    vm.mobileBelongsTo = null;

    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.POLITICAL_STATUS = AppConstants.INVESTOR_POLITICAL_STATUS;
    vm.changeFolioMode = changeFolioMode;

    vm.init = function () {
      // LoaderService.showLoader();
      // getTaxStatusList();
        getPayload(function () {
        setHeader();
        checkStepAway();
      });
    };

    function checkStepAway() {

    if((!$scope.FolioDetails.formData.minor) && ($scope.FolioDetails.formData.holdmode =="ANY_OR_SURVIVOR")){
      $scope.FolioDetailsParent.stepsAway = 5;
    }
    else if((!$scope.FolioDetails.formData.minor) && ($scope.FolioDetails.formData.holdmode =="SINGLE")){
      $scope.FolioDetailsParent.stepsAway = 4;
    }
    else if($scope.FolioDetails.formData.minor){
      $scope.FolioDetailsParent.stepsAway = 3;
    }
    }

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.FolioDetailsParent.panNumber = profile.investorPAN;
      $scope.FolioDetailsParent.firstName = profile.investorFName;
      $scope.FolioDetailsParent.lastName = profile.investorLName;
    }

    /*
    *false=>Self
    * true=Minor
    * */
    function changeFolioMode() {
      localStorage.setItem('minorMode', vm.minor);
      // localStorage.removeItem('minorMode');
      if (masterPayload) {
        vm.payload = (vm.minor === true) ? angular.copy(masterPayload.minor)
          : angular.copy(masterPayload.self);
      }
      vm.payload.soleApplicantDetail.minor = vm.minor;
      if (vm.payload.soleApplicantDetail.minorAgeProof) {
        breakFileUrl(vm.payload.soleApplicantDetail.minorAgeProof);
      }
      if (vm.payload.soleApplicantDetail.minorRelationshipProof) {
        breakRelationshipFileUrl(vm.payload.soleApplicantDetail.minorRelationshipProof);
      }
    }
/*
    function getTaxStatusList() {
      var data = {taxStatusFilter: 'MINOR'}
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusList = resp.data.taxStatus;
        } else {
          vm.taxStatusList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxStatusList = null;
        $log.info("error====", err);
      };
      InvestorService.post({child1: 'folio', child2: 'tax-status'}, data).$promise.then(success, error);
    }*/

    vm.changeMinorDob = function (date) {
      if (!date) {
        vm.defaultMinorDob = null;
        vm.payload.soleApplicantDetail.personalDetail.dateOfBirth = null;
        return;
      }
      vm.defaultMinorDob = date.toString();
      vm.payload.soleApplicantDetail.personalDetail.dateOfBirth = date.clone().format('DD-MMM-YYYY').toString();
    };
    var masterPayload = {};


    function getPayload(cb) {
      cb = cb || function () {};

      if (localStorage.getItem('folioId')||$stateParams.investorId) {

        var success = function (resp) {
            if (resp.status && resp.data) {
              masterPayload = resp.data;
              masterPayload.id = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
              $scope.FolioDetailsParent.holdmode = resp.data.holdmode;
              vm.nomineesResp = resp.data.nominees || [];
              vm.ekycEmail = resp.data.soleApplicantDetail.personalDetail.kycEmail;
              vm.emailBelongsTo = resp.data.soleApplicantDetail.personalDetail.emailBelongsTo;
              vm.ekycMobile = resp.data.soleApplicantDetail.personalDetail.kycMobileNo;
              vm.mobileBelongsTo = resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo;
              if (angular.isDefined(resp.data.minor) && resp.data.minor) {
                prepareGuardianDetailFormData(resp.data);
                $scope.FolioDetailsParent.isSoleApplicantMinor = true;
                vm.status = localStorage.getItem('type');
              } else {
                prepareSoleApplicantFormData(resp.data);
                vm.status = localStorage.getItem('type');
              }
              vm.formData.holdmode = resp.data.holdmode;
              if(resp.data.jointHolders && resp.data.jointHolders.length>0){
                vm.formData.jointHolders = resp.data.jointHolders;
              }
              //setDefaultValues();
              LoaderService.hideLoader();
              cb();
            } else {
              MessageService.error(resp.message);
              LoaderService.hideLoader();
              cb();
            }
          },
          error = function () {
            LoaderService.hideLoader();
            cb();
          };

        var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
        InvestorServiceV3.post({
          child1: 'folio',
          child2: 'getDetails'
        },{id:investorId}).$promise.then(success, error);
      }else{
        cb();
      }

    }


    function prepareSoleApplicantFormData(data) {
      var d = data.soleApplicantDetail;
      vm.formData = {
        "firstName": d.selfDetail && d.selfDetail.personalDetail?d.personalDetail.firstName:'',
        "lastName": "",
        "dateOfBirth": d.personalDetail?d.personalDetail.dateOfBirth:'',
        "email": "",
        "minor": !d.minor ? false : d.minor,
        "taxStatusCode": d.personalDetail.taxStatusCode,
        "occupation": d.selfDetail.occupation,
        "panNumber": d.selfDetail.panNumber,
        "grossAnnualIncome": d.selfDetail.grossAnnualIncome,
        "netWorth": d.selfDetail.netWorth,
        "netWorthDate": d.selfDetail.netWorthDate,
        "politicalStatus": d.selfDetail.politicalStatus||vm.POLITICAL_STATUS.NONE,
        "payTaxInIndia": d.selfDetail.fatca.payTaxInIndia,
        "fatcaAddressType": d.selfDetail.fatca.addressType,
        "birthCountry": d.selfDetail.fatca.birthCountry,
        "birthCity": d.selfDetail.fatca.birthPlace
      };
      if(vm.formData.netWorth){
        $window.NumToWord(vm.formData.netWorth, 'DisplayWordsTaxAmt', vm);
      }
      addAvailableResidency(d.selfDetail.fatca);
    }

    function prepareGuardianDetailFormData(data) {
      var rData = data;
      var d = data.soleApplicantDetail.minorDetail.guardian;
      var s = data.soleApplicantDetail;
      vm.formData = {
        "holdmode":rData.holdmode,
        "firstName": s.personalDetail?s.personalDetail.firstName:'',
        "lastName": "",
        "dateOfBirth": s.personalDetail?s.personalDetail.dateOfBirth:'',
        "email": "",
        "gender": s.personalDetail?s.personalDetail.gender:'',
        "minor": !rData.minor ? false : rData.minor,
        "taxStatusCode": s.personalDetail.taxStatusCode,
        "occupation": d.occupation,
        "panNumber": d.panNumber,
        "relationship": d.relation,
        "grossAnnualIncome": d.grossAnnualIncome,
        "netWorth": d.netWorth,
        "netWorthDate": d.netWorthDate,
        "politicalStatus": d.politicalStatus||vm.POLITICAL_STATUS.NONE,
        "payTaxInIndia": d.fatca?d.fatca.payTaxInIndia:true,
        "fatcaAddressType": d.fatca.addressType,
        "birthCountry": d.fatca.birthCountry,
        "birthCity": d.fatca.birthPlace,
        "minorAgeProofUrl": s.minorDetail && s.minorDetail.minorAgeProof,
        "minorRelationshipProofUrl": s.minorDetail && s.minorDetail.minorRelationshipProof
      };
      s.minorDetail.minorAgeProof && breakFileUrl(s.minorDetail.minorAgeProof);
      s.minorDetail.minorRelationshipProof && breakRelationshipFileUrl(s.minorDetail.minorRelationshipProof);
      addAvailableResidency(d.fatca);
    }
    function addAvailableResidency(fatca) {
      vm.formData.fatcaArray=[];
      if (fatca.fatcaTax1) {
        vm.formData.fatcaArray.push(fatca.fatcaTax1);
      }
      if (fatca.fatcaTax2) {
        vm.formData.fatcaArray.push(fatca.fatcaTax2);
      }
      if (fatca.fatcaTax3) {
        vm.formData.fatcaArray.push(fatca.fatcaTax3);
      }
      if(vm.formData.payTaxInIndia == false && vm.formData.fatcaArray.length ===0){
        vm.formData.fatcaArray.push({});
      }
    }

    /*function getPayloadOld() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            masterPayload = resp.data;
            vm.minor = angular.fromJson(localStorage.getItem('minorMode'));
            if (masterPayload) {
              vm.payload = (vm.minor === true) ? angular.copy(masterPayload.minor)
                : angular.copy(masterPayload.self);
            }
            // vm.payload.id = resp.data.id? resp.data.id : null;
            setDefaultData();
            LoaderService.hideLoader();
          } else {
            /!*MessageService.error(resp.message);*!/
            LoaderService.hideLoader();
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
        };

/!*
      InvestorService.get({
        child1: 'fresh',
        child2: 'folio',
        child3: 'get',
        child4: 'drafts'
      }).$promise.then(success, error);
*!/

      var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'getDetails'
      },{id:investorId}).$promise.then(success, error);

    }*/

    vm.next = function () {
      if (vm.payload.soleApplicantDetail.minor) {
        savePayload('folioDetails.incomeDetailsMinor');
      } else {
        savePayload('folioDetails.incomeDetails');
      }
    };

    /*function setDefaultData() {
      if (vm.payload.soleApplicantDetail) {
        if (!vm.payload.soleApplicantDetail.minor) {
          vm.payload.soleApplicantDetail.minor = false;
        }
      }

      if (!vm.payload.guardianDetail) {
        createDefaultGuardian();
      }

      if (vm.payload.soleApplicantDetail.minorAgeProof) {
        breakFileUrl(vm.payload.soleApplicantDetail.minorAgeProof);
      }
      if (vm.payload.soleApplicantDetail.minorRelationshipProof) {
        breakRelationshipFileUrl(vm.payload.soleApplicantDetail.minorRelationshipProof);
      }
    }*/

    /*function createDefaultGuardian() {
      vm.payload.guardianDetail = {
        name: $scope.FolioDetailsParent.firstName + ' ' + $scope.FolioDetailsParent.lastName,
        panNumber: '',
        occupationCode: '',
        income: '',
        netWorth: '',
        relation: ''
      };

    }*/

      function savePayload(stateToMove) {
        vm.payload.saveStep = '1';
        var success = function (resp) {
            if (resp.status && resp.data) {
              localStorage.setItem('folioId',resp.data.id);$state.go(stateToMove);
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            $log.info('Occupation Errror>>>>', err);
          };

        if(vm.payload){
          vm.payload.id = vm.payload.id? vm.payload.id : null;
        }//fresh/folio/save
       // InvestorService.post({child1: 'folio', child2: 'newInvestorFolio'}, vm.payload).$promise.then(success, error);
        InvestorService.post({
          child1: 'fresh',
          child2: 'folio',
          child3: 'save'
        }, vm.payload).$promise.then(success, error);
    }

    function uploadMinorDobFile(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.payload.soleApplicantDetail.minorAgeProof = resp.data.fileUrl;
                  vm.payload.id = resp.data.uuid?resp.data.uuid:resp.payload.id;
                  localStorage.setItem('folioId',vm.payload.id);
                breakFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            // DistributorProfileUploadService.post({
            InvestorFileUploadService.post({
              child1: 'fresh',
              child2: 'folio',
              child3: 'minor',
              child4: 'ageProof',
              child5: 'upload',
              child6: vm.payload.id ? vm.payload.id : 'null'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function uploadMinorRelationshipFile(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.payload.soleApplicantDetail.minorRelationshipProof = resp.data.fileUrl;
                  vm.payload.id = resp.data.uuid?resp.data.uuid:resp.payload.id;
                  localStorage.setItem('folioId',vm.payload.id);

                breakRelationshipFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            // DistributorProfileUploadService.post({
            InvestorFileUploadService.post({
              child1: 'fresh',
              child2: 'folio',
              child3: 'relationship',
              child4: 'proof',
              child5: 'upload',
              child6: vm.payload.id ? vm.payload.id : 'null'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function breakRelationshipFileUrl(url) {

      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }
      if(angular.isUndefined(a)){return;}
      vm.formData.minorRelationshipProof = a[a.length - 1] + extension;
      // vm.formData.minorRelationshipProof =  vm.relationshipDocUrl && vm.relationshipDocUrl.replace(new RegExp('%20', 'g'), '-');

      // vm.chooseARelationshipFile = false;

    }

    function breakFileUrl(url) {

      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }
      if(angular.isUndefined(a)){return;}
      vm.formData.minorAgeProof= a[a.length - 1] + extension;
      // vm.formData.minorAgeProof =  vm.ageProofDocUrl && vm.ageProofDocUrl.replace(new RegExp('%20', 'g'), '-');
      // vm.chooseAFile = false;

    }

    vm.openUploadedDoc = function () {
      // window.open(vm.payload.soleApplicantDetail.minorAgeProof);
      if(angular.isUndefined(vm.payload.soleApplicantDetail.minorAgeProof)){return;}
      ModalService.showImage({docUrl: vm.payload.soleApplicantDetail.minorAgeProof});
    }

    vm.openRelationshipDoc = function () {
      // window.open(vm.payload.soleApplicantDetail.minorAgeProof);
      if(angular.isUndefined(vm.payload.soleApplicantDetail.minorAgeProof)){return;}
      ModalService.showImage({docUrl: vm.payload.soleApplicantDetail.minorAgeProof});
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginBankDetailsController', firstLoginBankDetailsCtrl);

  /** @ngInject */
  function firstLoginBankDetailsCtrl(ModalService, AppConstants, $state, MessageService, InvestorService,
                                     $log,$scope,$stateParams,InvestorServiceV3,
                                     LoaderService,AuthService,InvestorFileUploadService,UtilService,dynamicData) {
    var vm = this;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.accModelDirty = false;
    vm.formData = {};
    vm.verifyAccountNumber ='';
    vm.chooseAFile = true;
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp", "application/pdf"];
    vm.chequeLeafUrl = '';
    vm.accountHolderField = false;
    vm.isBuzy = false;
    var taxStatusCode = '';
    vm.dynamicData = dynamicData;

    vm.init = function () {
      LoaderService.showLoader();
      setHeader();
      $scope.FolioDetailsParent.stepsAway = 2;
      getPayload();
      // bankNameList();
      // getPayoutMechanism();

    };

    function setHeader() {
      var profile = AuthService.getToken();
      $scope.FolioDetailsParent.panNumber = profile.investorPAN;
      $scope.FolioDetailsParent.firstName = profile.investorFName;
    }

    function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data) {
              vm.payload = resp.data;
            if(vm.payload.minor){
              vm.accountHolderField = true;
            }
            if(vm.payload.bankDetails && !vm.payload.bankDetails.bankHolderType){
              if(vm.payload.soleApplicantDetail.minor){
                vm.payload.bankDetails.bankHolderType = 'MINOR';
              }else{
                vm.payload.bankDetails.bankHolderType = 'INVESTOR';
              }
            }
            taxStatusCode = vm.payload.soleApplicantDetail && vm.payload.soleApplicantDetail.personalDetail.taxStatusCode;
            setDefaultData();
            if(taxStatusCode){
            getAcccountType();
            }
            LoaderService.hideLoader();
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
        };

      var investorId = $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId');
      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'getDetails'
      },{id:investorId}).$promise.then(success, error);
    }

    function setDefaultData() {
      if(vm.payload.bankDetails.chequeLeaf){
        breakFileUrl(vm.payload.bankDetails.chequeLeaf);
      }
    }


    function getAcccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
            if(vm.payload.soleApplicantDetail.personalDetail.taxStatusCode=="01"){
              vm.bankList&&vm.bankTypeList.length>3 && (!vm.payload.bankDetails.accountType || vm.payload.bankDetails.accountType==="NRE" )?
                vm.payload.bankDetails.accountType=vm.bankTypeList[3].accountTypeCode
                :''
            }
            else{
              vm.bankList&&vm.bankTypeList.length>0?
                vm.payload.bankDetails.accountType=vm.bankTypeList[0].accountTypeCode
                :''
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };

      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.payload.soleApplicantDetail.personalDetail.taxStatusCode
      }).$promise.then(success, error);
    }

    vm.accFocus = function () {
      vm.accModelDirty = true;
    };

    vm.copyPasteHandler=function (e) {

      var key = e.keyCode?e.keyCode:e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if ( key == 86 && ctrl ) {
        e.preventDefault();
      } else if ( key == 67 && ctrl ) {
        e.preventDefault();
      }
    };

    vm.done = function () {
      savePayload('');
    }

    vm.back = function () {
      if(vm.payload.soleApplicantDetail.minor){
        savePayload('folioDetails.taxResidencyMinor');
      } else {
        savePayload('folioDetails.addNominee');
      }
    }

    function savePayload(stateToMove) {
      LoaderService.showLoader();
      vm.isBuzy = true;
      if(vm.payload){
        vm.payload.saveStep = stateToMove===''?'6':'5';
        if(!stateToMove){
          vm.payload.newFolioComplete = true;
        } else {
          vm.payload.newFolioComplete = false;
        }
      }

      var success = function (resp) {
          vm.isBuzy = false;
          if (resp.status && resp.data) {
            localStorage.removeItem('folioId');
            if(stateToMove){
              LoaderService.hideLoader();
              $state.go(stateToMove);
            } else {
              LoaderService.hideLoader();
              localStorage.removeItem('minorMode');
              var token = AuthService.getToken();
              if(token && token.investorType){
                token.investorType = AppConstants.INVESTOR_TYPE.EXISTING;
              }else{
                $state.go('sessionExpired');
              }
              AuthService.setToken(token);
              showPopUp(resp.data);
            }
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isBuzy = false;
          LoaderService.hideLoader();
          MessageService.error(err.message);
        };
        if(vm.payload && vm.payload.bankDetails && vm.payload.bankDetails.payoutMechanism){
          // delete vm.payload.bankDetails.verifyAccountNumber;
          delete vm.payload.bankDetails.payoutMechanism.micrMandatory;
          delete vm.payload.bankDetails.payoutMechanism.payoutDescription;
        }
      var params = {};
      params.child1 = 'fresh';
      params.child2 = 'folio';
      if(stateToMove){
        params.child3 = 'draft';
        params.child4 = 'save';
      }else{
        params.child3 = 'save';
      }
      InvestorService.post(params, vm.payload).$promise.then(success, error);
    }

    function showPopUp(data) {
      var successModal = function () {
        //  $state.go('login')
        },
        errorModal = function () {
         // MessageService.error(err)
        };
      ModalService.folioCreationSuccessModal(data, successModal, errorModal);
    }

    function uploadChequeLeafFile(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if(file){
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;

                breakFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            InvestorFileUploadService.post({
              child1:'fresh',
              child2:'folio',
              child3: vm.payload && vm.payload.id?vm.payload.id:'null',
              child4: 'bankDetails',
              child5: 'chequeLeaf',
              child6: 'upload'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function breakFileUrl(url) {
      if(!url){return;}
      vm.chequeLeafUrl = 'Preview Uploaded Doc';
      vm.chooseAFile = false;
      return;

    }

    vm.openUploadedDoc = function(url) {
      if(angular.isUndefined(url)){return;}
        ModalService.showImage({docUrl: url});
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginAddNomineeController', firstLoginAddNomineeCtrl);

  /** @ngInject */
  function firstLoginAddNomineeCtrl($stateParams, MessageService, InvestorService, InvestorServiceV3, $log, moment, $state, AppConstants, $scope, LoaderService, AuthService, dynamicData) {
    var vm = this;
    vm.wantToAddNominee = false;
    vm.maxNominee = 3;
    vm.activeTab = 0;
    vm.countryList = [];
    vm.defaultDob = moment().toString();
    vm.totalPercentage = 0;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.dynamicData = dynamicData;
    vm.enum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      3: 'Fourth',
      4: 'Fifth'

    }

    vm.init = function () {
      LoaderService.showLoader();
      setHeader();
      $scope.FolioDetailsParent.stepsAway = 3;
      // getCountryList();
      getPayload();

    }


    function setHeader() {
      var profile = AuthService.getToken();
      $scope.FolioDetailsParent.panNumber = profile.investorPAN;
      $scope.FolioDetailsParent.firstName = profile.investorFName;
      vm.userPan = profile.investorPAN;
    }

    vm.changeDob = function (date) {

      if (!date) {
        return;
      }
     // vm.defaultDob = date.toString();
      vm.payload.nominees[vm.activeTab].dob = date.clone().format('DD-MMM-YYYY').toString();
      var age = moment().diff(date, 'years');
      if(age < 18){
        vm.payload.nominees[vm.activeTab].minor = true;
      }else{
        vm.payload.nominees[vm.activeTab].minor = false;
      }
    };

    vm.percentage = function(data){
      if(data.percentage.split('%').length!=2)
      data.percentage = data.percentage + '%';
    }

    vm.setActiveTab = function (index) {
      vm.activeTab = index;
    }

    vm.deleteNominee = function (index) {
      vm.payload.nominees.splice(index, 1);
      vm.activeTab = 0;

      var totalPercentage = 0;
      for(var i in vm.payload.nominees){
        totalPercentage += parseInt(vm.payload.nominees[i].percentage);
      }
      vm.totalPercentage = totalPercentage;
    };

    vm.addNominee = function () {
     var msg = checkValidation();
      if(msg){
        MessageService.error(msg);
        return;
      }
      if (!vm.payload.nominees)
        vm.payload.nominees = [];
     // var percentage = null;//calculateProportion();
      vm.payload.nominees.push(
        {
          "nomineeName": "",
          "nomineeRelation": "",
          "percentage": "",
          "dob": "",
          "nomineeAddress": {
            "addressLine1": "",
            "addressLine2": "",
            "addressLine3": "",
            "pinCode": "",
            "city": "",
            "state": "",
            "country": ""
          },
          "minor":false
        }
      );

      vm.activeTab = vm.payload.nominees.length-1;

    }

    function checkValidation() {
      var arr = vm.payload.nominees, msg = '';
      for (var i = 0; i < arr.length; i++) {
        if (!arr[i]['nomineeName'] || !arr[i]['percentage']) {
          msg = 'Please fill details of ' + vm.enum[i]
            + ' nominee';
          break;
        }
      }
      return msg;
    }

    /*function calculateProportion() {
      var percentage = '', nominees = vm.payload.nominees;

      if (nominees.length === 0) {
        percentage = '';
      } else if (nominees.length === 1) {
        percentage = 100 - parseInt(nominees[0].percentage);
      } else if (nominees.length === 2) {
        percentage = 100 - (parseInt(nominees[0].percentage) + parseInt(nominees[1].percentage));
      }

      return percentage;
    }*/

    vm.calculatePercentage = function() {
      var totalPercentage = 0;
      var nominees = vm.payload.nominees;
      for(var i in nominees){
        totalPercentage += parseInt(nominees[i].percentage);
      }
      vm.totalPercentage = totalPercentage;
     /* angular.forEach(nominees.length, function(item){
        console.log(item.technologies);
      })*/
     /* if(nominees.length==1){
        vm.totalPercentage = parseInt(nominees[0].percentage) + parseInt(nominees[1].percentage);
      }*/
    };

    $scope.$watch('addNomineeForm.$error.required', function (newValue) {
      if(angular.isArray(newValue)&& newValue.length>0){
        var msg = 'Please complete the form ';
        var formTypeArray = newValue.map(function(ele){return ele.$name.split('-')[1]}).filter( function (value, index, self) {
          return self.indexOf(value) === index;
        } );
        var nomineeList = [];
        angular.forEach(formTypeArray,function(val){
          switch(val){
            case "0":nomineeList.push('First Nominee Details'); break;
            case "1":nomineeList.push('Second Nominee Details'); break;
            case "2":nomineeList.push('Third Nominee Details'); break;
            case "3":nomineeList.push('Fourth Nominee Details'); break;
            case "4":nomineeList.push('Fifth Nominee Details'); break;
            case "5":nomineeList.push('Sixth Nominee Details'); break;
          }
        });
        msg += nomineeList.join(' , ');
        vm.validationMsg = msg;
      }else{vm.validationMsg = '';}
    }, true);


    function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payload = resp.data;
            $scope.FolioDetailsParent.holdmode = resp.data.holdmode;
            localStorage.setItem('folioId',resp.data.id);
            /*if (vm.payload && !vm.payload.nominees) {
              vm.payload.nominees = [];
              vm.addNominee();
            } else */if (vm.payload && vm.payload.nominees && vm.payload.nominees.length === 0) {
              vm.payload.nominees = [];
              vm.addNominee();
              vm.wantToAddNominee = false;
            } else {
              vm.wantToAddNominee = true;
            }
            LoaderService.hideLoader();
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
          LoaderService.hideLoader();
        };

      // InvestorService.get({child1: 'folio', child2: 'newInvestorFolio'}).$promise.then(success, error);
/*
      InvestorService.get({
        child1: 'fresh',
        child2: 'folio',
        child3: 'get',
        child4: 'drafts'
      }).$promise.then(success, error);
*/
      var investorId =  $stateParams.investorId ? $stateParams.investorId : localStorage.getItem('folioId')
      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'getDetails'
      },{id:investorId}).$promise.then(success, error);

    }

    vm.next = function () {
      savePayload('folioDetails.bankDetails');
    }

    vm.back = function () {
      savePayload('folioDetails.taxResidency');
    }

    function savePayload(stateToMove) {
      if(vm.wantToAddNominee){
     var msg = checkProportionTotalSum();
     if(msg){
       MessageService.error(msg);
       return;
     }
      }
      if (!vm.wantToAddNominee) {
        //vm.payload.nominees = [];
      }
      checkNominees();
      vm.payload.saveStep = '5';

      var success = function (resp) {
          if (resp.status && resp.data) {
            $state.go(stateToMove);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Occupation Errror>>>>', err);
        };

      // InvestorService.post({child1: 'folio', child2: 'newInvestorFolio'}, vm.payload).$promise.then(success, error);
      InvestorService.post({
        child1: 'fresh',
        child2: 'folio',
        child3: 'save'
      }, vm.payload).$promise.then(success, error);
    }

    function checkProportionTotalSum() {
      var sum =0 ,msg='';
      for(var i=0;i<vm.payload.nominees.length;i++){
        sum = sum + parseInt(vm.payload.nominees[i].percentage);
      }
      if(sum != 100 ){
        msg = 'Total sum of nominee proportion should be 100';
      }

      return msg;

    }

    function checkNominees() {
      for(var i=0;i<vm.payload.nominees.length;i++){
        if(vm.payload.nominees[i].minor){
          delete vm.payload.nominees[i].nomineeAddress;
        }else{
          delete vm.payload.nominees[i].guardianName;
          delete vm.payload.nominees[i].guardianAddress;
        }
      }
    }

    /*function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
        $log.info("error====", err);
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
    }*/

    vm.selectAddNominee = function (status) {
      if(status && vm.payload.nominees.length === 0){
        vm.addNominee();
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('hdfcPreliminaryDashboardSidebar', hdfcPreliminaryDashboardSidebar);

  /** @ngInject */
  function hdfcPreliminaryDashboardSidebar() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/sidebar/preliminary-sidebar/preliminary-sidebar.html',
      scope: {
        creationDate: '='
      },
      controller: preliminaryDashboardSidebarController,
      controllerAs: 'PreliminaryDashboardSidebar',
      bindToController: true
    });

    /** @ngInject */
    function preliminaryDashboardSidebarController(HDFC_API, $timeout, $state, $rootScope, $scope, $http, MessageService, UtilService, $window,$stateParams,ModalService,AuthService,$cookies,InvestorService,AppConstants,LoaderService,NetcoreEvntService) {
      var vm = this;
      vm.active = null;
      vm.sidebarActive = null;
      vm.transactSubMenu = true;
      vm.toolsSubMenu = true;
      vm.HDFC_API = HDFC_API; 
      // vm.redirectUrl = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/distributor/generateGatePass/' + HDFC_API.THIRD_PARTY_NAME;
      vm.allCalculatorLink = HDFC_API.WEBSITE_LINK + AppConstants.CALCULATOR_LINK ;
      vm.allInvestmentBasketLink = HDFC_API.WEBSITE_LINK + AppConstants.INVESTMENT_BASKET_LINK;
      vm.learnerCorner = HDFC_API.WEBSITE_LINK + AppConstants.LEARNER_CORNER_LINK;
      vm.knowYourInvestmentPersonality = HDFC_API.WEBSITE_LINK + AppConstants.INVESTMENT_PERSONALITY_LINK;
      vm.transactionType = '';
      vm.logout = logout; 
      // dashboard select bydefalt
      var myDiv = document.getElementById('side-nav'); 
      var navItems = document.querySelectorAll('.nav-option');   
      myDiv.addEventListener('mouseleave', handleMouseLeave); 
      function handleMouseLeave() {   
        vm.transactSubMenu = true; 
        vm.active[1] = false;
        vm.toolsSubMenu = true; 
        vm.active[5] = false; 
        navItems.forEach(function (item) {item.classList.remove('active-link')});
        navItems[0].classList.add('active-link');  
        $scope.$apply();
      }
      vm.initTab = function () {
         
        $timeout(function () {
          var baseState = $state.current.name.split('.')[1];
          switch (baseState) {
            default:
              vm.active = {0: true};
              break;
            case 'dashboard':
              vm.active = {0: true};
              break;
            case 'transactions':
              vm.active = {1: true};
              break;
            case 'portfolio':
              vm.active = {2: true};
              break;
            case 'sipcorner':
              vm.active = {3: true};
              break;
            case 'reports':
              vm.active = {4: true};
              break;
            case 'leapacademy':
              vm.active = {5: true};
              break;
            case 'leadmanagement':
              vm.active = {6: true};
              break;
            case 'financialtool':
              vm.active = {7: true};
              break;
            case 'schemecalculator':
              vm.active = {8: true};
              break;
            case 'hdfcWeb':
              vm.active = {9: true};
              break;
            case 'systematiccorner':
              vm.active = {9: true};
              break;
          }
        }, 100);
      };

      vm.activateTab = function (tab) {
        vm.active = {};
        vm.active[tab] = true;
      };

      angular.element("#menuButton").click(function () {
        angular.element(".mobile-menu").addClass("expanded");
        angular.element(".main-section").css("overflow", "hidden");
        /*angular.element(".main-section").css("position", "fixed");*/
        angular.element(".mobile-header>.black-tint").fadeIn();
      });

      angular.element(".mobile-header>.black-tint").click(function () {
        angular.element(".mobile-menu").removeClass("expanded");

        angular.element(".main-section").css("overflow", "none");
        angular.element(".main-section").css("position", "static");
        angular.element(".mobile-header>.black-tint").fadeOut();
      });

      angular.element(".mobile-menu .mobile-nav ul > li").click(function () {
        angular.element(".mobile-menu").removeClass("expanded");
        angular.element(".mobile-header>.black-tint").fadeOut();
      });

      angular.element(".mobile-header .mobile-search").click(function () {
        angular.element(".mobile-search-bar").toggle();
      });

      var listener = $rootScope.$on('UpdateSideBar', vm.initTab);

      $scope.$on("$destroy", function () {
        // Unbind angular event listeners
        if (angular.isFunction(listener)) {
          listener();
        }
      });
      if($stateParams && $stateParams.pan){
        vm.panNumber = $window.atob($stateParams.pan);
      }
    // add pan
      vm.addpan = function(transactiontype){
        var successModal = function (resp) {
          if(resp.isNewInvestor){
            var successModal = function (data) { 
              vm.userDetails = AuthService.getUserCookies();
              logout(function () {
                vm.userDetails.throughPrelimanaryDashboard = true;
                vm.userDetails.transactionType = resp.transactionType;
                sessionStorage.setItem('MobilePanLoginDetails',JSON.stringify(vm.userDetails));
                $state.go('newInvestor.kycVerification');
              });
            }, errorModal = function () {
            };
            var data = {
              note:resp.note,
              throughPrelimanaryDashboard : true
            } 
            ModalService.loginWithMobileModal({STEPS:'CONFIRMATION_PROMPT',data:data}, successModal, errorModal);
          }
          if(resp.redirectOnDashboard){
              vm.existingUserDetails = {};
              vm.existingUserDetails.throughPrelimanaryDashboard = true;
              vm.existingUserDetails.transactionType = resp.transactionType;
              vm.loginMethod = 'SWITCH_MTOKEN_TO_ETOKEN';
              login();
          }
        },
        errorModal = function (err) {
          if(err && err == 'logout'){
            logout(function () {
              sessionStorage.setItem('LOGIN_WITH_USERID',true);
              $state.go('login');
            });
          }
        };
        var data = {
          throughPrelimanaryDashboard : true,
          pan:vm.panNumber
        } 
        if(transactiontype){
          data.transactiontype = transactiontype;
        }
        ModalService.loginWithMobileModal({STEPS:'VERIFY_PAN',data:data}, successModal, errorModal);
      }

      function logout(cb){
        cb = cb || function () {
        };
        LoaderService.showLoader();
        var success = function (resp) {
            if (resp && resp.status) { 
              MessageService.success(resp.message); 
              cb(true);
            } else {
              MessageService.error(resp.message); 
            } 
            LoaderService.hideLoader();
          },
          error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err.error);
          }; 
          AuthService.mobileTokenLogout().then(success, error); 
      }

      function login() {
        var successLogin = function (result) {
          vm.loginProcessFlag = false;
          LoaderService.hideLoader();
          if (result.access_token && result.access_token != "") {
      
            /*netcore script start here*/
            (typeof $window.smartech == 'function') && $window.smartech('identify', result.encryptedPanNumber);
            // NetcoreEvntService.Login_Status_IP(result, true);
            /* Please pass dynamic value of  PAN_NUMBER between '' whenever user logs in */
            /*netcore script end here*/
            sessionStorage.setItem('loggedIn', true);
            NetcoreEvntService.login_Success_Smartech();
            if (result.investorType != AppConstants.INVESTOR_TYPE.NEW) {
              if(result.loginType == "SWITCH_MTOKEN_TO_ETOKEN"){
                $window.smartech('contact', '', {
                  'pk^pan_number': result.encryptedPanNumber,
                  'email': HDFC_API.INFO_RECEIVE_IDENTIFIER ? HDFC_API.INFO_RECEIVE_IDENTIFIER.concat('@gmail.com') : result.email,
                  'mobile': HDFC_API.INV_INFO_RECEIVER ? UtilService.genericConverter(HDFC_API.INV_INFO_RECEIVER) : result.mobile,
                  'FIRST_NAME': result.investorFName,
                  'LAST_NAME': result.investorLName
                  });
                  vm.netcoreDataObj = NetcoreEvntService.Mobile_Login(result, true);
                  $window.smartech('dispatch','Mobile_login_success',vm.netcoreDataObj);
               }
              if ($stateParams.trackId) {
                if(vm.existingUserDetails.transactionType.toLowerCase() == 'purchase'){
                  $state.go('main.transactions.purchase',{
                    trackId:$stateParams.trackId,
                    transactionType:$stateParams.trxnType,
                    stepNo:$stateParams.stepNo
                  });
                }else if(vm.existingUserDetails.transactionType.toLowerCase() == 'sip'){
                  $state.go('main.transactions.sip',{
                    trackId:$stateParams.trackId,
                    transactionType:$stateParams.trxnType});
                }else{
                $state.go('home', {
                  trackId: $stateParams.trackId,
                  trxnType: $stateParams.trxnType,
                  stepNo: $stateParams.stepNo
                });
              }
              } else {
                if(vm.existingUserDetails.transactionType.toLowerCase() == 'purchase'){
                  $state.go('main.transactions.purchase');
                }else if(vm.existingUserDetails.transactionType.toLowerCase() == 'sip'){
                  $state.go('main.transactions.sip');
                }else{
                $state.go('home');
                }
              }
            } else {
              $state.go('welcome.newUserWelcome');
            }
          } else {
            if (result && result.message) {
              MessageService.error(result.message);
              if (result && result.locked) {
                vm.showUnlockID = true;
              }
            }
          }
        }, errorLogin = function (msg) {
          LoaderService.hideLoader();
        };
        var token = AuthService.getMobileLoginToken();
        var secretLink = token.access_token;
        vm.userDetails = AuthService.getUserCookies();
        var payload = {
          grant_type:'password',
          password: AuthService.encryptRSA(angular.copy(token.mobile)),
          username: AuthService.encryptRSA(angular.copy(vm.userDetails.pan)),
          folioNumber: vm.userDetails.folioNumber
        }
        LoaderService.showLoader();
        AuthService.login(payload, vm.loginMethod, secretLink).then(successLogin, errorLogin);
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('hdfcLoginSidebar', hdfcLoginSidebar);

  /** @ngInject */
  function hdfcLoginSidebar() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/sidebar/login-sidebar/login-sidebar.directive.html',
      scope: {
        sideBarClick: '&sidebarClick'
      },
      controller: loginSidebarController,
      controllerAs: 'LoginSidebar',
      bindToController: true
    });

    /** @ngInject */
    function loginSidebarController(HDFC_API, $timeout, $state, $rootScope, $scope, AppConstants, UtilService) {
      var vm = this;
      vm.constants = AppConstants.INVESTOR_SELECTION;

      vm.initTab = function (state) {
        $timeout(function () {
          var baseState = state;
          switch (baseState) {
            default:
            case vm.constants.NO_SELECTION:
              vm.active = null;
              break;
            case vm.constants.NEW_INVESTOR:
              vm.active = {1: true};
              break;
            case vm.constants.QUICK_INVEST:
              vm.active = {2: true};
              break;
            case vm.constants.UPDATE_CONTACT_DETAILS:
              vm.active = {3: true};
              break;
            case vm.constants.UPDATE_KYC:
              vm.active = {4: true};
              break;
            case vm.constants.EXISTING_USER:
              vm.active = {0: true};
              break;
          }
        }, 100);
      };

      vm.activateTab = function (state) {
        vm.active = {};
        vm.initTab(state);
      };

      vm.initTab(UtilService.getSideBarState());

      //vm.activateTab(vm.constants.EXISTING_USER);

      var listener = $rootScope.$on('UpdateSideBar', vm.initTab);
      $scope.$on("$destroy", function () {
        // Unbind angular event listeners
        if (angular.isFunction(listener)) {
          listener();
        }
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('verticalProgressSidebar', verticalProgressSidebar);

  /** @ngInject */
  function verticalProgressSidebar() {
    var directive = {
      restrict: 'E',
      scope: {
        steps: '=',
        responsive: '='
      },
      controller: verticalProgressSidebarController,
      templateUrl: 'app/components/sidebar/investor-progress-sidebar/investor-vertical-progress-sidebar.directive.html',
      link: link
    };
    return directive;

    function link($scope) {
      $scope.toggleListItems = function(index) {
        $scope.forms.steps.forEach(function(step) {
          step.stepActive = false;
        });
        $scope.forms.steps[index].stepActive = true;
        $scope.forms.steps[index].stepCompleted = false;
        if (index > 0) {
          $scope.forms.steps[index-1].stepCompleted = true;
        }
      };
    }

    /** @ngInject */
    function verticalProgressSidebarController(HDFC_API, $timeout, $state, $rootScope, $scope, AppConstants, UtilService) {
      $scope.forms = $scope.steps;
      $scope.redirectToState = function (details) {
        $state.go(details.state);
      };
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('horizontalProgressSidebar', horizontalProgressSidebar);

  /** @ngInject */
  function horizontalProgressSidebar() {
     function link($scope, $element) {
        $scope.toggleListItems = function(index) {
          $scope.forms.steps[index].stepActive = true;
          $scope.forms.steps[index - 1].stepCompleted = true;
        };
      }
      var directive = {
        restrict: 'E',
        scope: {
          steps: '='
        },
        controller: horizontalProgressSidebarController,
        templateUrl: 'app/components/sidebar/investor-progress-sidebar/investor-horizontal-progress-sidebar.directive.html',
        link: link
      };
      return directive;

    /** @ngInject */
    function horizontalProgressSidebarController(HDFC_API, $timeout, $state, $rootScope, $scope, AppConstants, UtilService) {
      $scope.forms = $scope.steps;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('WidgetStoreModalController', widgetSelectionModalController);

  /** @ngInject */
  function widgetSelectionModalController($uibModalInstance, UtilService, $rootScope, AppConstants, modalView, modalData, InvestorService, LoaderService, MessageService, moment, $interval, $cookies) {
    var vm = this;
    vm.view = modalView;
    vm.moment = moment;
    vm.modalData = modalData;
    vm.distributorWidgetsList = null;
    vm.WIDGETS_ID = AppConstants.WIDGETS_ID;
    vm.getDistributorWidgets = getDistributorWidgets;
    vm.updateWidgets = updateWidgets;
    vm.selectedCount = selectedCount;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.closeModal = function () {
      $uibModalInstance.close("updated successful");
      MessageService.success("Widgets updated successfully");
    };

    vm.init = function () {
      LoaderService.showLoader('.widget');
      var success = function (resp) {
        LoaderService.hideLoader('.widget');
        if (resp.data && resp.status) {
          vm.widgetList = resp.data.widgetList;
          vm.widgetList = vm.widgetList.filter(function( obj ) {
            vm.widgetQuickLink =  obj.widgetId == vm.WIDGETS_ID.QUICKLINK ? obj : null;
            return obj.widgetId !== vm.WIDGETS_ID.QUICKLINK;
          });
          vm.widgetIdArray = vm.widgetList.map(function(e){return e.widgetId;});
        } else {
          MessageService.error(resp.message);
        }
        vm.getDistributorWidgets();
      }, error = function (err) {
        LoaderService.hideLoader('.widget');
        UtilService.errorHandler(err);
      };
      const timeout = $interval(function () {
        if(!sessionStorage.getItem(AppConstants.IDENTIFIER)){
          $uibModalInstance.dismiss();
          $interval.cancel(timeout);
        }
      },1000);
      InvestorService.post({
        child1: 'dashboard',
        child2: 'widgets'
      }, {}).$promise.then(success, error);

      vm.submitWidgetList = function () {
        vm.selectedWidgets = [];
        var positionCount = 1;
        var previousWidgetsCount = vm.widgetIdArray.length;
        angular.forEach(vm.widgetList, function (val) {
          if (val.selected) {
            switch (val.widgetName) {
              case vm.WIDGETS_ID.INVESTMENT_NAME:
                positionCount = (vm.WIDGETS_ID.INVESTMENT_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.INVESTMENT_ORDER;
                break;
              case vm.WIDGETS_ID.SCHEME_PERFORMANCE_NAME:
                positionCount = (vm.WIDGETS_ID.SCHEME_PERFORMANCE_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.SCHEME_PERFORMANCE_ORDER;
                break;
              case vm.WIDGETS_ID.MARKETUPDATE_NAME:
                positionCount = (vm.WIDGETS_ID.MARKETUPDATE_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.MARKETUPDATE_ORDER;
                break;
              case vm.WIDGETS_ID.DIVIDENTUPDATE_NAME:
                positionCount = (vm.WIDGETS_ID.DIVIDENTUPDATE_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.DIVIDENTUPDATE_ORDER;
                break;
              case vm.WIDGETS_ID.RECENTACTIVITY_NAME:
                positionCount = (vm.WIDGETS_ID.RECENTACTIVITY_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.RECENTACTIVITY_ORDER;
                break;
              case vm.WIDGETS_ID.TRANSACTIONSTATUS_NAME:
                positionCount = (vm.WIDGETS_ID.TRANSACTIONSTATUS_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.TRANSACTIONSTATUS_ORDER;
                break;
             /* case vm.WIDGETS_ID.QUICKLINK_NAME:
                positionCount = vm.WIDGETS_ID.QUICKLINK_ORDER;
                break;*/
            }
            vm.selectedWidgets.push({position: positionCount, widgetId: val.widgetId});
          }
        });
        /*below line added to send quick link always*/
        vm.selectedWidgets.push({position:vm.selectedWidgets.length+1, widgetId:vm.widgetQuickLink.widgetId});
        vm.selectedWidgetsIdArray = vm.selectedWidgets.map(function (ele){
          return ele.widgetId;
        });
        setRestWidgetsOrder();
        vm.updateWidgets();
      }
    };

    function updateWidgets() {
      var widgetList = vm.selectedWidgets;
      var success = function (resp) {
        if (resp.status) {
          $uibModalInstance.close(resp);
          $rootScope.$broadcast('UpdateDashboard', {listUpdated: true});
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      };
      InvestorService.post({
        child1: 'dashboard',
        child2: 'widgets',
        child3: 'alignments'
      }, {widgetList: widgetList}).$promise.then(success, error);
    }

    function getDistributorWidgets() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          var count = 0;
          vm.distributorWidgetsList = resp.data.widgetList;
          angular.forEach(vm.widgetList, function (value) {
            angular.forEach(vm.distributorWidgetsList, function (v) {
              if (value.widgetId == v.widgetId) {
                value.selected = true;
                count++;
              }
            });
          });
        } else {
          MessageService.error(resp.message);
        }
        vm.selectedCounter = count;
      }, error = function (err) {
        UtilService.errorHandler(err);
      };
      InvestorService.post({
        child1: 'dashboard',
        child2: 'widgets',
        child3: 'investor'
      }, {}).$promise.then(success, error);
    }

    function setRestWidgetsOrder() {

      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.INVESTMENT) < 0) {
        vm.WIDGETS_ID.INVESTMENT_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.SCHEME_PERFORMANCE) < 0) {
        vm.WIDGETS_ID.SCHEME_PERFORMANCE_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.MARKETUPDATE) < 0) {
        vm.WIDGETS_ID.MARKETUPDATE_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.TRANSACTIONSTATUS) < 0) {
        vm.WIDGETS_ID.TRANSACTIONSTATUS_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.DIVIDENTUPDATE) < 0) {
        vm.WIDGETS_ID.DIVIDENTUPDATE_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.RECENTACTIVITY) < 0) {
        vm.WIDGETS_ID.RECENTACTIVITY_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.QUICKLINK) < 0) {
        vm.WIDGETS_ID.QUICKLINK_ORDER = 0;
      }
    }

    function selectedCount() {
      var count = 0;
      angular.forEach(vm.widgetList, function (val) {
        if (val.selected) {
          count++;
        }
      });
      vm.selectedCounter = count;
    }

  }

})();

/**
 * Created by ttn on 18/10/20.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('VideoModalController', videoModalController);

  /** @ngInject */
  function videoModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
  }
})();

/*
* Created by ttn at 28/09/2020
* */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UpdateNomineeSuccessController', UpdateNomineeSuccessController);

  /** @ngInject */
  function UpdateNomineeSuccessController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.close();
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UnsavedChangesModalController', unsavedChangesModalController);

  /** @ngInject */
  function unsavedChangesModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    if(modalData.msg){
      vm.modalData = modalData.msg;
    }

    vm.gotoSelf = function () {
      $uibModalInstance.close('Self');
    };

    vm.stayWithMinor = function () {
      $uibModalInstance.dismiss('Minor');
    };

    vm.dropJourneyContinue = function () {
      $uibModalInstance.dismiss();
    }

    vm.deleteFolio = function () {
      $uibModalInstance.close();
    }

    vm.goToPayment = function(){
      $uibModalInstance.close();
    };

    vm.updateStep = function(){
      $uibModalInstance.dismiss();
    }

  }
})();

/**
 * Created by ttn on 15/12/16.
 */


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TransactionModalController', transactionFailController);

  /** @ngInject */
  function transactionFailController($uibModalInstance, $state, modalView, modalData, AppConstants,$window,HDFC_API, NetcoreEvntService, AuthService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.modalData.paymentOption = modalData.paymentOption || "EC";
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    vm.arnHardcodedData = $window.JSON.parse(localStorage.getItem("distributorDetails"));

    if (vm.modalData.transactionType === "Flex SIP") {
      vm.tenureDiff = moment(vm.modalData.endDate,"DD-MMM-YYYY").diff(moment(vm.modalData.startDate,"DD-MMM-YYYY"), 'years') + 1;
    }

    vm.init = init;
    vm.init();
    vm.closeModal = function () {
      $uibModalInstance.close();
      if(vm.modalData.type == 'newInvestor'){
        $state.go('newInvestor.investorProfile');
        return;
      }

      if(vm.modalData.type != 'instantLogin'){
        $state.go('welcome');
      } else if (vm.modalData.type === 'instantLogin') {
        if (vm.modalData.sipFirstInstallment) {
        if(vm.arnHardcodedData) {
           $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.arnHardcodedData.chipherText;
        }else{
          $state.go('instantLoginHome.instantInvest');
        }
        } else {
          if(vm.arnHardcodedData) {
             $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.arnHardcodedData.chipherText;
          }else{
            $state.reload();
          }
        }
      }
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
      if(vm.modalData.type == 'newInvestor'){
        $state.go('newInvestor.investorProfile');
        return;
      }
      if(vm.modalData.type != 'instantLogin'){
        $state.go('welcome');
      } else if (vm.modalData.type === 'instantLogin') {
        if (vm.modalData.sipFirstInstallment) {
          $state.go('instantLoginHome.instantInvest');
        } else {
          $state.reload();
        }
      }
    };

    function init() {
      if (vm.modalData.paymentOption === "EC" || vm.modalData.paymentOption === "OTM" || vm.modalData.paymentOption === "HDFC" || vm.modalData.paymentOption === "RTGS") {
        var data = getDataToBePushed();
        NetcoreEvntService.Transaction_Success(vm.modalData.transactionType === 'PURCHASE' ? 'Purchase' : 'SIP', data);
      }

      if ((vm.modalData.type != 'newInvestor' && vm.modalData.type != 'instantLogin') && vm.modalData.paymentOption === "EC") {
        NetcoreEvntService.sip_Transaction_Success_Registration(vm.modalData, 'success');
      }
    }

    function getDataToBePushed() {
      var token = {};
      if (vm.modalData.type === 'instantLogin') {
        token = AuthService.getInstaToken();
      } else {
        token = AuthService.getToken();
      }

      var source = '';

      if (vm.modalData.paymentOption  === "EC") {
        source = 'Standing Instruction/Biller';
      } else if (vm.modalData.paymentOption === 'HDFC' ) {
        source = 'HDFC Fund Transfer';
      } else if (vm.modalData.paymentOption === 'RTGS' ) {
        source = 'NEFT/RTGS';
      } else if (vm.modalData.paymentOption === 'OTM') {
        source = 'OTM (One Time Mandate)';
      } else {
        source = vm.modalData.paymentOption;
      }


      return {
        transaction_id: vm.modalData.srnNo,
        value: vm.modalData.amount,
        tax: 0,
        currency: "INR",
        userId: sessionStorage.getItem('userId'),
        status : "success",
        transaction_time: vm.modalData.transactionInitiateDate, //yy-mm-dd hh:mm:ss
        transaction_type: vm.modalData.transactionType === 'PURCHASE' ? 'Purchase' : 'SIP',
        source : source,
        items: [{
          item_id: vm.modalData.folioNumber,
          item_name: vm.modalData.schemeName,
          item_category: vm.modalData.schemeCode,
          item_category2: vm.modalData.folioInvestorName.trim(),
          item_category3: token.encryptedPanNumber,//Encrypted value
          price: vm.modalData.amount,
          quantity: "N/A"
        }]
      };
    }

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller(  'TransactionalTermConditionModalController', transactionalTermConditionModalController);

  /** @ngInject */
  function transactionalTermConditionModalController($uibModalInstance, modalView, modalData, ModalService , LoaderService ,InvestorService,HDFC_API) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.showGeneralTnc = function () {
      ModalService.termConditionModal();
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TransactionWarningController', transactionWarningController);

  /** @ngInject */
  function transactionWarningController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.showBlueBtn = angular.copy(vm.modalData.showBlueBtn);

    if(modalData.msg){
    vm.modalData = modalData.msg;
    }

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TransactionSummaryModalController', transactionSummaryModalController);

  /** @ngInject */
  function transactionSummaryModalController($uibModalInstance, modalView, modalData, LoaderService, InvestorService, MessageService, UtilService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.transactionSummary = null;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.init = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.transactionSummary = resp.data;
        } else {
          vm.transactionSummary = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.transactionSummary = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader('.popup');
      InvestorService.post({
        child1: 'transaction',
        child2: 'summary'
      }, vm.modalData.payload).$promise.then(success, error);
    };

  }
})();

/**
 * Created by ttn on 24/03/22.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TransactionOtpModalController', transactionOtpModalController);

  /** @ngInject */
  function transactionOtpModalController($uibModalInstance, UtilService, modalView, modalData, LoaderService,
                                         TransactionService, MessageService, AppConstants,$rootScope,HDFC_API, $scope) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.otpForm = {};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.otpResendMessage = '';
    vm.isProcessing = false;
    vm.otpNumber = '';
    vm.appConstants = AppConstants;
    var otmSubmitCount = 0;
    vm.isOtmValid = true;
    vm.secretOtpLink = ""
    init();

    function init() {
      // generateOtp();
    }

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.confirmTransaction = function () {
      approveTransaction();
    };

    vm.resendOtp = function () {
      LoaderService.showLoader();
      vm.isProcessing = true;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.otpResendMessage = 'OTP sent again successfully.';
          resetTimer();
        } else {
          vm.otpResendMessage = '';
          MessageService.error(resp.message)
        }
        vm.isProcessing = false;
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.otpResendMessage = '';
        vm.isProcessing = false;
        UtilService.errorHandler(err);
      };
      var payload = {
        "id" : vm.modalData.otpPayload.secretOtpLink
      };
      TransactionService.post({
        controller1: 'transaction',
        controller2: 'resend',
        controller3: 'otp'
      }, payload).$promise.then(success, error);
    };

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

    // function generateOtp() {
    //   LoaderService.showLoader();
    //   vm.isProcessing = true;
    //   var success = function (resp) {
    //     LoaderService.hideLoader();
    //     if (resp.status && resp.data) {
    //       vm.secretOtpLink = resp.data.secretLink;
    //       vm.otpSentMessage = resp.data.message || "OTP has been sent to your registered Email ID.";
    //       vm.otpId = resp.data.id;
    //       otmSubmitCount = 1;
    //     } else {
    //       vm.otpSentMessage = '';
    //       MessageService.error(resp.message)
    //     }
    //     vm.isProcessing = false;
    //   },
    //   error = function (err) {
    //     LoaderService.hideLoader();
    //     vm.otpResendMessage = '';
    //     vm.isProcessing = false;
    //     UtilService.errorHandler(err);
    //   };
    //   var payload = vm.modalData.otpPayload;
    //   TransactionService.post({
    //     controller1: 'transaction',
    //     controller2: 'otp'
    //   }, payload).$promise.then(success, error);
    // }

    function approveTransaction() {
      LoaderService.showLoader();
      var success, failure;
      success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          $uibModalInstance.close();
        } else {
          otmSubmitCount++;
          if (otmSubmitCount === 6 ) {
            vm.isOtmValid = false;
          }
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      };
      failure = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      vm.otpPayload = {
        otp : vm.otpNumber ,
        id: vm.modalData.otpPayload.secretOtpLink,
        folioNumber:  vm.modalData.payload.folioNumber,
        transactionType : vm.modalData.payload.formType
      };
      if (vm.modalData.payload.flowName) {
        vm.otpPayload.flowName = "E_CART";
      }
      TransactionService.post({
         controller1: 'transaction',
         controller2: 'verify',
         controller3: 'otp'
      }, vm.otpPayload).$promise.then(success, failure);

    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('tpvController', tpvController);

  /** @ngInject */
  function tpvController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;


    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TermConditionModalController', termConditionModalController);

  /** @ngInject */
  function termConditionModalController($uibModalInstance, modalView, modalData ,LoaderService ,InvestorService ,UtilService ,MessageService,HDFC_API) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.dynamicTerms = null;
    vm.dynamicDataTncGeneral = {};
    vm.dynamicDataTncSip = {};

    function init() {
      var successHandler = function(resp) {
        vm.dynamicTerms = resp;
           if(vm.dynamicTerms.termAndConditionDTO.termAndConditionDTOMap.TNC_General)
           {
            vm.dynamicDataTncGeneral = vm.dynamicTerms.termAndConditionDTO.termAndConditionDTOMap.TNC_General.content;
           }

           if(vm.dynamicTerms.termAndConditionDTO.termAndConditionDTOMap.TNC_General_SIP)
           {
            vm.dynamicDataTncSip = vm.dynamicTerms.termAndConditionDTO.termAndConditionDTOMap.TNC_General_SIP.content;
           }
      }

      UtilService.fetchDynamicData("INNER_TNC").then(successHandler).catch(function(resp) {
         MessageService.error(resp)
      });
    }

    init();

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SuccessModalController', successModalController);

  /** @ngInject */
  function successModalController($uibModalInstance, modalView, modalData, AppConstants,HDFC_API,$window, InvestorService , LoaderService , UtilService,MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.headingFirst = "Applicability of Stamp Duty on Purchase/Switch In transactions:";
    vm.headingSecond = "Applicability of NAV only after realization of funds";
    vm.headingThird = "Change in Name of Dividend Option ( Effective 1 April,2021 )";
    vm.containsEmail = false;
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.DynamicDataFirstLogin = null;
    vm.dynamicData = null;
    init();
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    function init() {
      var body = vm.modalData.message.substring(0, vm.modalData.message.lastIndexOf(" "));
      var email = vm.modalData.message.substring(vm.modalData.message.lastIndexOf(" ")+1 , vm.modalData.message.length);
      if (AppConstants.email_regex.test(email)) {
        vm.containsEmail = true;
        vm.email = email;
        vm.modalData.message = body;
      }

      var successHandler = function(resp) {
        vm.DynamicDataFirstLogin = resp.popupDTO.popupDTOMap.Popup_Login_Home;
        vm.DynamicData = resp.popupDTO.popupDTOMap.Popup_Home;
      }

      UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });

    }

    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };

    }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SubscriptionModalController', subscriptionModalController);

  /** @ngInject */
  function subscriptionModalController($uibModalInstance, modalView, modalData, InvestorService, LoaderService, MessageService, UtilService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.successList = vm.modalData.successList? vm.modalData.successList : null;
    vm.failureList = vm.modalData.failureList? vm.modalData.failureList : null;
    vm.editSubscriptionSubmit = editSubscriptionSubmit;
    vm.modeChanged = modeChanged;
    vm.MODE = [{
      key: 'EMAIL',
      value: 'EMAIL'
    },
      {
        key: 'SMS',
        value: 'SMS'
      }
      ];

    var id = vm.modalData.data&&vm.modalData.data.id ? vm.modalData.data.id : null;
    var folioNumber = vm.modalData.data&&vm.modalData.data.folioNumber ? vm.modalData.data.folioNumber : null;
    vm.oldMode = vm.modalData.data&&vm.modalData.data.mode ? vm.modalData.data.mode : null;
    vm.newMode = vm.oldMode;
    vm.oldFrequency = vm.modalData.data&&vm.modalData.data.frequency ? vm.modalData.data.frequency : null;
    vm.folioFrequency = vm.oldFrequency;
    var schemeName = vm.modalData.data&&vm.modalData.data.schemeName ? vm.modalData.data.schemeName : null;
    var schemeCode = vm.modalData.data&&vm.modalData.data.schemeCode ? vm.modalData.data.schemeCode : null;
    switch(vm.oldMode){
      case 'EMAIL':
        angular.forEach(vm.MODE, function(value){
          if (value.value=='EMAIL') value.selected = true;
        });
        break;
      case 'SMS':
        angular.forEach(vm.MODE, function(value){
          if (value.value=='SMS') value.selected = true;
        });
        break;
      case 'BOTH':
        angular.forEach(vm.MODE, function(value){
          value.selected = true;
        });
        break;
    }

    vm.selectedMode = false;

    function editSubscriptionSubmit(type) {
      /*var selectedMode = null;
      angular.forEach(vm.MODE, function(value){
        if (value.selected) selectedMode=value.value;
      });
      if(selectedMode.length>1) {
        selectedMode = 'BOTH';
      }*/
      if(type=='folio'){
        var payload = {
          "folioNumber": folioNumber,
          "frequency": vm.folioFrequency,
          "id": id,
          "mode": vm.newModeToCalculate
        };
      } else {
         payload = {
          "schemeName": schemeName,
          "schemeCode": schemeCode,
          "id": id,
          "mode": vm.newModeToCalculate
        };
      }

      var success = function (resp) {
          LoaderService.hideLoader('.subscription');
          if (resp.status && resp.data) {
            vm.closeModal(resp.data.message);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.subscription');
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.subscription');
      InvestorService.post({
        child1: 'subscription',
        child2: type,
        child3: 'edit'
      }, payload).$promise.then(success, error);
    }

    function modeChanged() {
      vm.newModeToCalculate = vm.newMode;
      vm.oldModeToCalculate = vm.oldMode;
       var count = 0;
      angular.forEach(vm.MODE, function(value){
        if (value.selected) {
          count++;
          vm.newModeToCalculate = value.value;
        }
        if(count<1) {
          vm.newModeToCalculate = 'BOTH';
          vm.oldModeToCalculate = 'BOTH';
        }  else if(count>1) {
          vm.newModeToCalculate = 'BOTH';
        } else vm.oldModeToCalculate = vm.oldMode;
      });


      //vm.newMode = newMode.value;

     /* var count = 0;
      angular.forEach(vm.MODE, function(value){
        if (value.selected) count++;
      });
      if(count>1) {
        newMode.value = 'BOTH';
      }
      if(newMode.value== mode){
        vm.selectedMode = false;
      } else{
        angular.forEach(vm.MODE, function(value){
          if (value.selected) vm.selectedMode = true;
        });
      }
      return;*/
      //vm.selectedMode = false;


    }

    vm.closeModal = function (resp) {
      $uibModalInstance.close(resp);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller(  'SubscribeWhatsapp', subscribeWhatsapp);

  /** @ngInject */
  function subscribeWhatsapp($uibModalInstance, modalView, modalData, ModalService,LoaderService,InvestorService,MessageService,HDFC_API) {
    var vm = this;
    vm.HDFC_API =HDFC_API;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.isTnCchecked = false;
    vm.mobileNumberList = [];

    vm.closeModal = function () {
      $uibModalInstance.close();
      LoaderService.hideLoader();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.movetosecondstep = function () {
      $uibModalInstance.close();
      ModalService.subscribeWhatsappSecondStep();
    }

  vm.subsSecondStepModalInit = function () {
    var success = function (resp) {
      LoaderService.hideLoader();
      vm.mobileNumberList = resp.data.mobileNumbers;
    }, error = function (resp) {
      LoaderService.hideLoader();
      MessageService.error(resp.data.message);
    };

    LoaderService.showLoader();
    InvestorService.put({
      child1: 'subscribe',
      child2: 'whatsappTransaction'
    },{}).$promise.then(success, error);
  }

    vm.tnC = function () {
      ModalService.subscribeWhatsappTnC();
    }

  }
})();


/**
 * Created by ttn on 29/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SubscribeToggleController', subscribeToggleController);

  /** @ngInject */
  function subscribeToggleController(UtilService, $uibModalInstance, modalView, modalData, LoaderService, InvestorService, MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.notificationDetails = null;
    vm.reasonForOptingOut = '';

    vm.closeModal = function () {
      $uibModalInstance.close('close');
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.confirmUnsubscribe = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        MessageService.success(resp.data.message);
      }, error = function () {
        LoaderService.hideLoader();
        MessageService.error(resp.data.message);
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'marketing',
        child4: 'subscribe'
      }, {folioNumber: modalData.folioNumber, reason:vm.reasonForOptingOut}).$promise.then(success, error);
      vm.closeModal();
    }


  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('StatementModalController', statementModalController);

  /** @ngInject */
  function statementModalController($uibModalInstance, modalView) {
    var vm = this;
    vm.view = modalView;
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    }
})();

/**
 * Created by ttn on 24/10/2024.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SipTopupDetailsController', sipTopupDetailsController);

  /** @ngInject */
  function sipTopupDetailsController($uibModalInstance, modalData, modalView, $state, AppConstants, SipPurchaseHelper, $window, UtilService) {
    var vm = this;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.view = modalView;
    vm.topupAmount = {};
    vm.topupCapAmount = {};
    vm.modalData = modalData;
    vm.formData = vm.modalData.formData ? vm.modalData.formData : {};
    vm.helper = getHelper();
    vm.capDates = angular.copy(vm.modalData && vm.modalData.capDates ? vm.modalData.capDates : []);
    vm.enableCapDateView = vm.modalData && vm.modalData.enableCapDateView ? vm.modalData.enableCapDateView : null;
    vm.topupFrequencyList = vm.modalData && vm.modalData.topupFrequencyList ? vm.modalData.topupFrequencyList : [];
    vm.formData.topupDetails.capMonthYearSelect = vm.formData.topupDetails && vm.formData.topupDetails.capMonthYearSelect ? vm.formData.topupDetails.capMonthYearSelect : null;
    vm.capYearMaxYear = angular.copy(vm.capDates[vm.capDates.length - 1]);
    vm.capYearMaxYear.add(29, 'days')
    vm.minCapDate = angular.copy(vm.capDates[0]);
    vm.minCapDate.subtract(1, 'minutes')
    vm.changeCapMonthYear = changeCapMonthYear;
    vm.checkSipValidationsForTopupAmount = checkSipValidationsForTopupAmount;
    // vm.capAmountChangedCheck = capAmountChangedCheck;
    // vm.changeTopupFrequency = changeTopupFrequency;
    vm.changeTopUpFreq = changeTopUpFreq;
    vm.capAmountChanged = capAmountChanged;

    vm.init = function() {
      createCapDates();
    };

    vm.init();

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      var variableUpdate = {
        isminCapAmount: vm.isminCapAmount
      }
      $uibModalInstance.dismiss(variableUpdate);
    };

    function getHelper() {
      var helper = null;
      helper = SipPurchaseHelper;
      // helper.setViewModel(vm);
      return helper;
    }

    vm.redirectToTransaction = function (){
      $state.go('main.investment.purchaseOrSip');
    }

    function changeCapMonthYear(date) {
      vm.formData.topupDetails.capMonthYearSelect = date ? date : null;
      if(vm.formData.topupDetails && vm.formData.topupDetails.capMonthYearSelect) {
        vm.formData.topupDetails.capAmount = null;
        vm.formData.topupDetails.displayCapAmount = null;
        vm.amountInWords = "";
        $window.NumToWord('', 'capAmntDisplayInWords',vm);
      }
    }

    function checkSipValidationsForTopupAmount() {
      vm.formData.topupDetails.displayAmount = vm.formData.topupDetails.displayAmount !== '0' ? UtilService.amountInComma(vm.formData.topupDetails.displayAmount).amountInComma: null;
      vm.formData.topupDetails.amount = vm.formData.topupDetails.displayAmount? UtilService.amountInComma(vm.formData.topupDetails.displayAmount).amount: null;
      if(vm.formData.topupDetails && (vm.formData.topupDetails.amount >= 2000000)){
        vm.amountExceeded = true;
      }else {
        vm.amountExceeded = false;
      }
      $window.NumToWord(vm.formData.topupDetails.amount, "divDisplayInWords", vm.topupAmount);
      var validations = vm.helper.checkSipValidations(true);
      vm.modalData.isTopupMinAmt = validations.isTopupMinAmt;
      vm.modalData.isTopUpMultiples = validations.isTopUpMultiples;
      capAmountChanged();
    }
    //
    // function capAmountChangedCheck() {
    //   var capAmountValidation = vm.helper.capAmountChanged(true);
    //   vm.modalData.isminCapAmount = capAmountValidation.isminCapAmount;
    //   vm.modalData.minCapAmount = capAmountValidation.minCapAmount;
    // }
    //
    // function changeTopupFrequency(selectedFrequency) {
    //   var freqUpdateValidation = vm.helper.changeTopUpFreq(selectedFrequency,true);
    //   vm.capDates = freqUpdateValidation.capDates;
    //   vm.capYearMaxYear = angular.copy(vm.capDates[vm.capDates.length - 1]);
    //   vm.capYearMaxYear.add(29, 'days')
    //   vm.minCapDate = angular.copy(vm.capDates[0]);
    //   vm.minCapDate.subtract(1, 'minutes')
    // }

    function createCapDates() {
      vm.diffInMonths = parseInt($window.moment(vm.formData.endDate).diff($window.moment(vm.formData.startDate), 'months', true)) + 1;
      if (!vm.diffInMonths ? false : vm.diffInMonths >= 6 && (vm.formData.frequency == 'OM' || vm.formData.frequency == 'Q')) {
        vm.formData.showTopUpBlock = true;
        setDefaultTopupAmount();
        var capStartDate;
        if(vm.formData.topupDetails && !vm.formData.topupDetails.frequency) {
          if (vm.diffInMonths > 12) {
            capStartDate = $window.moment(vm.formData.startDate).add(12, 'months');
            vm.formData.topupDetails.frequency = 'Y';
          } else {
            capStartDate = $window.moment(vm.formData.startDate).add(6, 'months');
            vm.formData.topupDetails.frequency = 'H'
          }
        } else {
          if(vm.formData.topupDetails.frequency == 'Y') {
            capStartDate = $window.moment(vm.formData.startDate).add(12, 'months');
          } else if (vm.formData.topupDetails.frequency === 'H') {
            capStartDate = $window.moment(vm.formData.startDate).add(6, 'months');
          }
        }
        var duration = 6;
        switch (vm.formData.topupDetails.frequency){
          case 'H':duration=6;break;
          case 'Y':duration=12;break;
        }
        updateTopupFrequency();
        vm.capDates = [];
        var capLastDate = capStartDate;
        while ($window.moment(capLastDate, "MMM-YYYY").isSameOrBefore($window.moment(vm.formData.endDate, "MMM-YYYY"))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(angular.copy($window.moment(capStartDate, 'DD-MMM-YYYY').startOf('month')));
          }
          // capStartDateValue = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          capStartDate = $window.moment(capStartDate).add(duration, 'months');
          if ($window.moment(capStartDate).isSameOrBefore($window.moment(vm.formData.endDate))) {
            vm.capDates.push(angular.copy($window.moment(capStartDate, 'DD-MMM-YYYY').startOf('month')));
          } else {
            break;
          }
          capLastDate = angular.copy(vm.capDates[vm.capDates.length - 1]);
          vm.enableCapDateView = vm.capDates[0];
        }
        if(vm.formData.topupDetails && vm.formData.topupDetails.capMonthYearSelect) {
          // Check if the target date is present in the array
          var isPresent = vm.capDates.some(function(date) {
            return date.isSame(vm.formData.topupDetails.capMonthYearSelect, 'day'); // 'day' compares only the date part
          });
          if(!isPresent) {
            vm.formData.topupDetails.capMonthYearSelect = null;
          }
        }
      } else {
        vm.formData.showTopUpBlock = false;
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        vm.formData.topupDetails = {};
        vm.sipTopupEnabled = false;
        resetTopupDetails();
        // getTopupFrequencyList();
      }

      vm.capYearMaxYear = angular.copy(vm.capDates[vm.capDates.length - 1]);
      vm.capYearMaxYear.add(29, 'days')
      vm.minCapDate = angular.copy(vm.capDates[0]);
      vm.minCapDate.subtract(1, 'minutes');
      vm.capDatesView = angular.copy(vm.capDates);
    }

    function capAmountChanged(fromTopup) {
      vm.amountInWords = '';
      if(vm.formData.topupDetails.displayCapAmount) {
        vm.formData.topupDetails.displayCapAmount = vm.formData.topupDetails.displayCapAmount && vm.formData.topupDetails.displayCapAmount !== '0' ? UtilService.amountInComma(vm.formData.topupDetails.displayCapAmount).amountInComma : null;
        vm.formData.topupDetails.capAmount = vm.formData.topupDetails.displayCapAmount && vm.formData.topupDetails.displayCapAmount !== '0' ? UtilService.amountInComma(vm.formData.topupDetails.displayCapAmount).amount : null;
      }
      if(vm.formData.topupDetails.capAmount && vm.formData.topupDetails.capAmount !== 0) {
        $window.NumToWord(vm.formData.topupDetails.capAmount, "capAmntDisplayInWords", vm.topupCapAmount);
        vm.formData.topupDetails.capMonthYearSelect = null;
      }
      if(vm.formData.topupDetails && vm.formData.topupDetails.capMonthYearSelect && !vm.formData.sipTopupSelected) {
        vm.formData.topupDetails.capMonthYearSelect = null;
      }
      if(vm.formData.topupDetails.amount) {
        vm.minCapAmount = vm.formData.amount + vm.formData.topupDetails.amount;
      }
      // else if (vm.formData.topupDetails.percentage){
      //   vm.minCapAmount = vm.formData.amount + (vm.formData.topupDetails.percentage * vm.formData.amount/100)
      // }

      if(vm.formData.topupDetails.capAmount && (vm.formData.topupDetails.capAmount < vm.minCapAmount )) {
        vm.isminCapAmount = true
      }
      else{
        vm.isminCapAmount = false
      }
    }

    function updateTopupFrequency() {
      if ((vm.diffInMonths >= 6 && vm.diffInMonths <= 12 ) || (vm.formData.topupDetails.diffInMonths >= 6 && vm.formData.topupDetails.diffInMonths <= 12)) {
        vm.topupFrequencyList = [
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
      } else {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12},
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
      }
      if(vm.formData.frequency && (vm.formData.frequency === 'Q')) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12}
        ];
      }
    }

    function resetTopupDetails() {
      vm.formData.topupDetails = {};
    }

    function changeTopUpFreq(selectedFreq) {
      if(selectedFreq) {
        vm.formData.topupDetails.frequency = selectedFreq.key;
        vm.formData.topupDetails.capMonthYearSelect = null;
      }
      var duration = 6;
      switch (vm.formData.topupDetails.frequency){
        case 'H':duration=6;break;
        case 'Y':duration=12;break;
      }
      if(duration === 12){
        var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months');
      }
      else{
        capStartDate = $window.moment(vm.formData.startDate).add(6, 'months');
      }

      vm.capDates = [];
      var capLastDate = capStartDate;
      while ($window.moment(capLastDate,"MMM-YYYY").isSameOrBefore($window.moment(vm.formData.endDate,"MMM-YYYY"))) {
        if (vm.capDates.length === 0) {
          vm.capDates.push(angular.copy($window.moment(capStartDate, 'DD-MMM-YYYY').startOf('month')));
        }
        capStartDate = $window.moment(capStartDate).add(duration, 'months');
        if ($window.moment(capStartDate).isSameOrBefore($window.moment(vm.formData.endDate))) {
          vm.capDates.push(angular.copy($window.moment(capStartDate, 'DD-MMM-YYYY').startOf('month')));
        }
        else {
          break;
        }
        capLastDate = vm.capDates[vm.capDates.length - 1];
      }
      vm.capYearMaxYear = angular.copy(vm.capDates[vm.capDates.length - 1]);
      vm.capYearMaxYear.add(29, 'days')
      vm.minCapDate = angular.copy(vm.capDates[0]);
      vm.minCapDate.subtract(1, 'minutes');
      vm.capDatesView = angular.copy(vm.capDates);
    }

    function resetCapAmount() {
      if (!vm.formData.topupDetails.amount || !vm.formData.topupDetails.percentage) {
        delete vm.formData.topupDetails.capAmount;
        delete vm.formData.topupDetails.capMonthYearSelect;
      }
    }

    function setDefaultTopupAmount() {
      // Calculate 10% of SIP Amount and round up to the nearest 100
      var calculatedAmount = Math.ceil((vm.formData.amount * 0.1) / 100) * 100;

      // Ensure it meets the minimum amount logic
      if (calculatedAmount < vm.modalData.validations.topupMinAmt) {
        calculatedAmount = vm.modalData.validations.topupMinAmt;
      }

      // Ensure it's a multiple of the specified amount
      if (calculatedAmount % vm.modalData.validations.topupAmtMultples !== 0) {
        calculatedAmount = Math.ceil(calculatedAmount / vm.modalData.validations.topupAmtMultples) * vm.modalData.validations.topupAmtMultples;
      }

      vm.formData.topupDetails.amount = vm.formData.topupDetails && vm.formData.topupDetails.amount && vm.formData.topupDetails.amount !== 0 ? vm.formData.topupDetails.amount : calculatedAmount;
      vm.formData.topupDetails.displayAmount = vm.formData.topupDetails && vm.formData.topupDetails.amount && vm.formData.topupDetails.amount !== 0 ? UtilService.amountInComma(vm.formData.topupDetails.amount).amountInComma : null;
      if (vm.formData.topupDetails.amount  && vm.formData.topupDetails.amount !== 0 ) {
        $window.NumToWord(vm.formData.topupDetails.amount, "divDisplayInWords", vm.topupAmount);
      }
      if(vm.formData.topupDetails && vm.formData.topupDetails.capAmount && vm.formData.topupDetails.capAmount !== 0 ) {
        vm.formData.topupDetails.displayCapAmount = UtilService.amountInComma(vm.formData.topupDetails.capAmount).amountInComma;
          $window.NumToWord(vm.formData.topupDetails.capAmount, "capAmntDisplayInWords", vm.topupCapAmount);
      }
      checkSipValidationsForTopupAmount();
    }
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SipOrPurchaseBasketController', sipOrPurchaseBasketController);

  /** @ngInject */
  function sipOrPurchaseBasketController($uibModalInstance, modalData, modalView,$state) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.redirectToTransaction = function (){
      $state.go('main.investment.purchaseOrSip');
    }
  }
})();

/**
 * Created by ttn on 24/10/2024.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SipDetailsModalController', sipDetailsModalController);

  /** @ngInject */
  function sipDetailsModalController($uibModalInstance, modalData, modalView, $state, AppConstants, MessageService, SchemeService, UtilService, $window, InvestorService, $timeout) {
    var vm = this;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.view = modalView;
    vm.modalData = modalData;
    vm.sipTenurePlaceHolder = "Select SIP Tenure";
    vm.startDateView = "date";
    vm.endDateView = "month";
    vm.formData = vm.modalData.formData ? vm.modalData.formData : {};
    vm.formData.sipDetailsViaPurchase.sipAmount = vm.formData.sipDetailsViaPurchase && vm.formData.sipDetailsViaPurchase.sipAmount ? vm.formData.sipDetailsViaPurchase.sipAmount : vm.formData.purchaseDefaultAmount ? vm.formData.purchaseDefaultAmount : null;
    vm.formData.sipDetailsViaPurchase.sipDisplayAmount = vm.formData.sipDetailsViaPurchase.sipAmount? UtilService.amountInComma(vm.formData.sipDetailsViaPurchase.sipAmount).amountInComma: null;

    /* Method declarations */

    vm.checkSipValidations = checkSipValidations;
    vm.changeStartDate = changeStartDate;
    vm.changeEndDate = changeEndDate;
    vm.changeAmount = changeAmount;

    /* End here */

    vm.init = function() {
      fetchSipSchemeValidations(function (success) {
        if(success) {
          setUpSipValidations();
        }
      });
    };

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      if(vm.formData.sipDetailsViaPurchase && vm.formData.sipDetailsViaPurchase.sipAmount && (vm.isMin || vm.amountExceeded || (!vm.isMax && !vm.isMin && (vm.validations.amountMultiples&&!vm.isMultiples) && !vm.amountExceeded))) {
        // if(vm.formData.sipViaPurchaseSelected && vm.formData.sipDetailsViaPurchase && vm.formData.sipDetailsViaPurchase.previousValidAmount) {
        //   vm.formData.sipDetailsViaPurchase.sipAmount = vm.formData.sipDetailsViaPurchase.previousValidAmount;
        // } else {
          vm.formData.sipDetailsViaPurchase.sipAmount = vm.formData.purchaseDefaultAmount;
        // }
      }
      $uibModalInstance.dismiss();
    };

    function fetchSipSchemeValidations(cb) {
      vm.inSchemeValidations = null;
      cb = cb || function () {
      };
      if (!vm.formData.purchaseInSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;
            vm.frequencyList = vm.inSchemeValidations.additionalValidation.frequency?vm.inSchemeValidations.additionalValidation.frequency:null;
            var frequency = vm.frequencyList.find(function (f) {
              return f.code === 'OM';
            }) || {};

            // vm.formData.frequency = vm.formData.frequency ? vm.formData.frequency : frequency?frequency :vm.frequencyList[0];
            cb(true);
          } else {
            cb(false);
            vm.inSchemeValidations = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          cb(false);
          vm.inSchemeValidations = null;
          UtilService.errorHandler(err);
        };
      var params = {
        controller: 'schemeValidation',
        type: "sip"
      };
      var data = {
        schemeCode: vm.formData.purchaseInSchemeCode,
        folioNo: vm.formData.folioNumber
      };
      SchemeService.post(params, data).$promise.then(success, error);
    }

    function setUpSipValidations() {
      vm.isInvalidForm = false;
      vm.validations = {};

      if (!vm.inSchemeValidations && !vm.outSchemeValidations) {
        vm.validations = {};
      }

      if (vm.outSchemeValidations) {
        vm.validations.isEnabled = vm.outSchemeValidations ? vm.outSchemeValidations.isEnabled : '';
        extractValidationObject(vm.outSchemeValidations);
      }

      if (vm.inSchemeValidations) {
        // vm.validations.minInstallDivisionFlag = vm.inSchemeValidations.minInstallDivisionFlag;
        // vm.validations.swpTaxCode = vm.inSchemeValidations.swpTaxCode;
        // vm.validations.endingType = vm.inSchemeValidations.endingType;
        extractValidationObject(vm.inSchemeValidations);
      }
    }

    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.formData.frequency) {
        return;
      }

      vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
      vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
      vm.validations.minInstallments = vm.validations.minInstallments || 0;
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.maxAmount = vm.validations.maxAmount || 0;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > 0 && vm.validations.maxAmount < vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }
      vm.validations.sipDefaultAmount = validationsData.sipDefaultAmount;
      switch (vm.formData.frequency) {
        case 'BZ':
          vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          if(validationsData.additionalValidation.BZ){
            vm.additionalSipData = validationsData.additionalValidation.BZ;
            vm.validations.minAmount = validationsData.additionalValidation.BZ[0].min_amount_lower;
          }
          break;
        case 'OW':
          vm.validations.maxInstallments = validationsData.weeklyMaxInstallmentNumber || 0;
          if(validationsData.additionalValidation.OW){
            vm.additionalSipData = validationsData.additionalValidation.OW;
            vm.validations.minAmount = validationsData.additionalValidation.OW[0].min_amount_lower;
          }
          break;
        case 'Q':
          vm.validations.maxInstallments  = validationsData.quarterlyMaxInstallmentNumber;
          if(validationsData.additionalValidation.Q){
            vm.additionalSipData = validationsData.additionalValidation.Q;
            vm.validations.minAmount =validationsData.additionalValidation.Q[0].min_amount_lower;

          }
          break;
        case 'OM':
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
          if(validationsData.additionalValidation.OM){
            vm.additionalSipData = validationsData.additionalValidation.OM;
            vm.validations.minAmount = validationsData.additionalValidation.OM[0].min_amount_lower;
          }
          break;
        case 'H':
          vm.additionalSipData = validationsData.additionalValidation.H;
          vm.validations.minAmount = validationsData.additionalValidation.H[0].min_amount_lower;
          vm.validations.maxInstallments = 0;
          break;
        case 'Y':
          vm.additionalSipData = validationsData.additionalValidation.Y;
          vm.validations.minAmount = validationsData.additionalValidation.Y[0].min_amount_lower;
          vm.validations.maxInstallments = 0;
          break;
      }
      // if(vm.validations.minAmount > validationsData.sipDefaultAmount){
      //   vm.formData.sipDetailsViaPurchase.sipAmount =  vm.validations.minAmount;
      // } else {
      //   vm.formData.sipDetailsViaPurchase.sipAmount = vm.oldAmount > validationsData.sipDefaultAmount ? vm.oldAmount : validationsData.sipDefaultAmount;
      // }
      // if(vm.formData.amount){
      //   $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
      // }
      if(vm.additionalSipData){
        checkSipValidations(function(status){
          if(status) {
            getDateValidation()
          }
        });
      }
    }

    function checkSipValidations(cb) {
      cb = cb || function(){}
      if(vm.additionalSipData){
        var newValidation =  vm.additionalSipData;
        vm.formData.sipDetailsViaPurchase.sipAmount = vm.formData.sipDetailsViaPurchase.sipDisplayAmount? UtilService.amountInComma(vm.formData.sipDetailsViaPurchase.sipDisplayAmount).amount: vm.formData.sipDetailsViaPurchase.sipDisplayAmount;
        vm.formData.sipDetailsViaPurchase.sipDisplayAmount = vm.formData.sipDetailsViaPurchase.sipAmount? UtilService.amountInComma(vm.formData.sipDetailsViaPurchase.sipAmount).amountInComma: null;
        $window.NumToWord(vm.formData.sipDetailsViaPurchase.sipAmount,'divDisplayWords', vm);
        for (var i=0; i<newValidation.length;i++){
          var condition = vm.formData.sipDetailsViaPurchase.sipAmount < newValidation[i].min_amount_lower ||  vm.formData.sipDetailsViaPurchase.sipAmount <= newValidation[i].min_amount_upper
          if(!newValidation[i].min_amount_upper){
            var condition = true;
          }
          if(condition)
          {
            if((!vm.formData.showTopUpBlock || !vm.formData.sipTopupSelected) && !vm.backFromPayment)
            {
              if (vm.formData.frequency && vm.formData.frequency.code === 'OW') {
                //vm.formData.startDate = null;
                //vm.formData.endDate = null;
                //vm.formData.day = null;
                //vm.formData.weeklyDay = null;
              }
            }
            vm.validations.amountMultiples = newValidation[i].amt_multiples;
            vm.validations.maxAmount = newValidation[i].min_amount_upper;
            vm.validations.minAmount = newValidation[i].min_amount_lower;
            vm.validations.minInstallments = newValidation[i].min_installments;
            break;
          }
        }
      }
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }
      vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.sipDetailsViaPurchase.sipAmount);
      vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.sipDetailsViaPurchase.sipAmount);
      vm.isMultiples = vm.validations.amountMultiples && vm.formData.sipDetailsViaPurchase.sipAmount && (vm.formData.sipDetailsViaPurchase.sipAmount % vm.validations.amountMultiples === 0) || false;
      vm.isInvalidForm = vm.formData.sipDetailsViaPurchase.sipAmount <= 0 || (vm.formData.sipDetailsViaPurchase.sipAmount && ( vm.isMax || vm.isMin || (vm.validations.amountMultiples && !vm.isMultiples)));

      if(vm.formData.sipDetailsViaPurchase.sipAmount >= 2000000){
        vm.amountExceeded = true;
      }else {
        vm.amountExceeded = false;
      }
      cb(true);
    }

    function getDateValidation(cb) {
      cb = cb || function () {};
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.currentDate = resp.data.currentDate || Date();
            vm.daysList = resp.data.listOfDays;
            vm.nonBusinessDatess = resp.data.nonBuisnessDates;
            calculateStartDate();
            vm.isReseting = true;
            cb(true);
          } else {
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb(false);
        };
      InvestorService.get({
        child1: 'nonBusinessDate',
        schemeCode: vm.formData.purchaseInSchemeCode //'AFWDQ'
      }).$promise.then(success, error);
    }

    function calculateStartDate(cb) {
      cb = cb || function () {};
      var parsedDate = $window.moment(vm.currentDate, "DD-MMM-YYYY");
      vm.startMinDate = null;
      vm.startMinDate = $window.moment(Date.parse(parsedDate)).add(vm.inSchemeValidations.sipTStartDay, 'days');
      vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days').add(1, 'minutes');
      var businessDays = [];
      var count = 1;
      var today = $window.moment(); // Cache the current date
      var nonBusinessDatesArray = vm.nonBusinessDatess || []; // Fallback in case it's undefined

      // Calculate the first 5 business days (excluding non-business days)
      for (var i = 1; count <= 5 && i <= 90; i++) {
        var indexDate = today.clone().add(i, 'days');
        var formattedIndexDate = indexDate.format("DD-MMM-YYYY");
        var isNonBusinessDay = nonBusinessDatesArray.find(function (value) {
          return $window.moment(value, "DD-MMM-YYYY").format("DD-MMM-YYYY") === formattedIndexDate;
        });

        // If it's not a non-business day, add it to businessDays, include non-businessDay to businessDay if counter is 5 and Non-business day present
        if (!isNonBusinessDay || (isNonBusinessDay && count === 5)) {
          businessDays.push(indexDate);
          count++;
        }
      }

      // Set the 5th business day (T+5)
      var currentDay = businessDays[4].clone().set({ 'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0 });

      var enabledStartDates = [];

      // Generate start dates based on the selected weekly day within the next 90 days
      for (var i = 0; i <= 90; i++) {
        var checkDate = parsedDate.clone().add(i, 'days');
        var isAfterMinDate = $window.moment(vm.startMinDate, "DD-MMM-YYYY").diff(checkDate, 'days') <= 0;

        // Check if the day matches the selected day of the week
        if (isAfterMinDate && checkDate && checkDate.isSameOrAfter(currentDay)) {
          enabledStartDates.push(checkDate);
        }
      }

      // Update the enabled start dates and set the start date
      vm.enabledStartDates = angular.copy(enabledStartDates);
      if(!vm.formData.startDate && !$window.moment(vm.formData.startDate).isBetween($window.moment(vm.enabledStartDates[0]), $window.moment(vm.enabledStartDates[vm.enabledStartDates.length - 1]))) {
        vm.formData.startDate = vm.enabledStartDates[0];
      }
      updateEndDates();
      cb(true);
    }

    function updateEndDates(doNotUpdateEndDate,fromHTML) {
      if (!vm.formData.startDate) {
        return;
      }
      // configurable end year for future flexibility
      var targetEndYear = 2099; // Change this to any year if needed
      var startDate = vm.formData.startDate.clone(); // Cache start date clone to avoid multiple cloning
      // Calculate the default end date using the last day of December in the target end year
      var defaultEndDate = $window.moment({ year: targetEndYear, month: 11, day: 31 });
      var enabledEndDates = [];
      var frequency = vm.frequencyList.find(function (f) {
        return f.code === vm.formData.frequency;
      }) || {};
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var duration = frequency.duration || 1; // Default duration if frequency not found

      // Cache values that are used multiple times
      var endDate, days, months, calculatedEndDate, monthDependingUponFreq, yearDependingUponFreq, i;
      if (freq > 0) {
        var calculatedEndDate;

        // Adjust the end date calculation depending on the frequency type
        switch (vm.formData.frequency) {
          case 'BZ':
            calculatedEndDate = startDate.clone().add(freq * frequency.duration, 'days');
            break;

          case 'OW':
            calculatedEndDate = startDate.clone().add(freq > 1 ? freq - 1 : freq, 'weeks');
            break;

          case 'OM':
            calculatedEndDate = startDate.clone().add(freq, 'months');
            break;

          case 'Q':
            calculatedEndDate = startDate.clone().add(freq * frequency.duration, 'months');
            break;

          case 'H':
            calculatedEndDate = startDate.clone().add(freq * frequency.duration, 'months');
            break;

          case 'Y':
            calculatedEndDate = startDate.clone().add(freq, 'years');
            break;

          default:
            console.error("Unsupported frequency type");
        }

        // Set the calculated end date to have the same day as the start date
        if(vm.formData.frequency !== "OW" && vm.formData.frequency !== 'BZ') {
          var startDay = startDate.date();
          calculatedEndDate.date(Math.min(startDay, calculatedEndDate.daysInMonth()));
        }

        // Store as moment object for consistent use
        defaultEndDate = $window.moment(calculatedEndDate);
      }
      var minInstallments = (vm.validations && vm.validations.minInstallments || 1) - 1; // Ensure minimum installments default

      switch (vm.formData.frequency) {
        case 'OM': // Monthly
          var totalMonths = defaultEndDate.diff(startDate, 'months'); // Calculate months only once
          freq = Math.ceil(totalMonths / duration);
          for (i = 0; i <= freq; i++) {
            enabledEndDates.push(startDate.clone().add(duration * i, 'months')); // Add monthly dates
          }
          break;

        default:
          console.error("Unknown frequency");

      }

      // Remove unnecessary entries based on minInstallments
      vm.enabledEndDates = enabledEndDates.slice(minInstallments);

      // Set default view for enabled end date
      vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
      if (vm.validations.minInstallments > 0) {
        // Calculate end date based on maxInstallments and frequency
        var firstEnableEndDateYear = Math.round(vm.enabledEndDateView.diff(startDate, 'years', true));
      }
      if (!doNotUpdateEndDate) {
        vm.formData.minEndDate = angular.copy(vm.enabledEndDates[0]);
      } else {
        vm.formData.minEndDate = angular.copy(vm.enabledEndDates[0]);
      }
      vm.formData.maxEndDate = new Date(2099, 12, 31);
      changeTillPerpetuityFlag(function (selectedOther) {});
    }

    function changeTillPerpetuityFlag(cb) {
      cb = cb || function () {};
      vm.formData.endDate = vm.formData.endDate ? vm.formData.endDate : null;
      vm.resetting = true;

      $timeout(function () {
        vm.resetting = false;

        // Calculate the selected duration in years (5, 7, 10, or 99 for perpetuity)
        var selectedYear = vm.formData.isTillPerpetuity ? 99 : (vm.selectedDuration && vm.selectedDuration.value !== 0 ? vm.selectedDuration.value : 99);
        var day = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
        var month = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month() + 1; // Month is 1-indexed

        // Calculate end date based on selected duration (5, 7, 10, or 99 years)
        var endYear = selectedYear !== 99 ? $window.moment(vm.formData.startDate).add(selectedYear, 'years').year() : 2099;
        var newEndDate = day + '/' + month + '/' + endYear;
        var endDate = $window.moment(newEndDate, "DD-MM-YYYY");
        var defaultEndDateUpto30Years = $window.moment().add(30, 'years');

        // var freq = vm.validations && vm.validations.maxInstallments || 0;
        var frequency = vm.frequencyList.find(function (f) {
          return f.code === vm.formData.frequency;
        }) || {};

        // Determine behavior based on the selected frequency
        switch (vm.formData.frequency) {
          case 'OM': // Monthly frequency
            handleMonthlyFrequency(defaultEndDateUpto30Years, frequency);
            break;

          default: // other frequencies
            console.error("Unknnown frequency");
        }

        handleUPIMaxEndDate();

        // Handle max installments validation if necessary
        handleMaxInstallments(endDate, selectedYear);

        // Set endDate and invoke the callback
        vm.endDateDefaultForPerpetuity = vm.formData.endDate;
        changeEndDate(vm.formData.endDate);
        cb();

      }, 0);
    }

    function handleMonthlyFrequency(endDate, frequency) {
      var endDateMonths = UtilService.getNumberOfMonths(vm.formData.startDate, endDate);
      var totalMonths = Math.floor(endDateMonths / (frequency.duration || 1));
      var adjustedDate = vm.formData.startDate.clone().add(totalMonths * frequency.duration, 'months');
      if(!vm.formData.endDate && !$window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) {
        vm.formData.endDate = adjustedDate;
      }

      adjustEndDateIfNeeded(adjustedDate);
    }

    function adjustEndDateIfNeeded(calculatedDate) {

      // Adjust end date to stay within valid bounds
      if(vm.formData.endDate && vm.enabledEndDates && vm.enabledEndDates.length > 0) {
        if(vm.formData.endDate.isBefore(vm.enabledEndDates[0])) {
          vm.formData.endDate = $window.moment(calculatedDate);
        }
      }
    }

    function handleMaxInstallments(endDate, selectedYear) {
      if (vm.validations && vm.validations.maxInstallments && vm.formData.frequency !== 'OW' && vm.formData.endDate) {
        var lastEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
        var lastEndMonth = $window.moment(lastEndDate, 'DD-MMM-YYYY').month() + 1;
        var lastEndYear = $window.moment(lastEndDate, 'DD-MMM-YYYY').year();

        var calculatedEndMonth = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1;
        var calculatedEndYear = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').year();

        if (calculatedEndYear > lastEndYear || (calculatedEndYear === lastEndYear && calculatedEndMonth > lastEndMonth)) {
          vm.formData.endDate.set('year', Math.min(2099, lastEndYear));
        }

        // Ensure end date is within the enabled end dates
        if ((!$window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1])) || (checkDateisPresentInEnableDates(vm.formData.endDate, vm.enabledEndDates) && !vm.formData.sipDetailsViaPurchase.previousEndDate))) {
          vm.formData.endDate = angular.copy(lastEndDate);
        }
      }
    }

    function handleUPIMaxEndDate() {
      if(!vm.formData.endDate) {
        return;
      }
      var defaultEndDateUpto30Years = $window.moment().add(30, 'years').subtract(1, 'days');
      var sipDateGreaterUPI =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter(defaultEndDateUpto30Years) ? true : false;
      if (sipDateGreaterUPI && !vm.formData.backFromPaymentPage && (vm.formData.sipDetailsViaPurchase && !vm.formData.sipDetailsViaPurchase.previousEndDate)) {
        var setEndDateLess = false;
        var indexSipEndDate = vm.enabledEndDates.length - 1;
        var tempEndDate;
        while (!setEndDateLess) {
          tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
          indexSipEndDate = indexSipEndDate - 1;
          if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(defaultEndDateUpto30Years, 'DD-MMM-YYYY'))) {
            setEndDateLess = true;
            vm.formData.endDate = angular.copy(tempEndDate);
          }

          if (indexSipEndDate == 0) {
            break;
          }
        }
      }
    }

    function changeStartDate(date) {
      if(!date) {
        return;
      }
      vm.formData.startDate = date ? date : null;
      vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
      updateEndDates();
    }

    function changeEndDate(date) {
      vm.formData.endDate = date ? date : null;
    }

    function changeAmount() {
      checkSipValidations(function(status){
        if(status) {
          updateEndDates()
        }
      });
    }

    function checkDateisPresentInEnableDates(captureDate, enabledDates) {
      if(enabledDates.length == 0 || !captureDate) {
        return false;
      }

      var isExactMatch = enabledDates.some(function(date) {
        return $window.moment(date).isSame(captureDate, 'day');
      });
      return isExactMatch;
    }

    vm.init();
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ShowImageModalController', showImageModalController);

  /** @ngInject */
  function showImageModalController($uibModalInstance, UtilService, modalView, modalData, LoaderService, $timeout) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.uploaded = vm.modalData.docUrl.name === undefined;
    vm.fileType = "";
    vm.init = init();
    var browserNotSupportedFileTypes = ["tif", "tiff"];
    vm.supportedFileType = !browserNotSupportedFileTypes.includes(vm.fileType);


    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    function getFileType(url) {
      var lowerCaseUrl = url.toString().toLowerCase();
      if (lowerCaseUrl.endsWith("jpg") || lowerCaseUrl.endsWith("jpeg")) {
        return "jpg";
      } else if (lowerCaseUrl.endsWith("tif") || lowerCaseUrl.endsWith("tiff")) {
        return "tif";
      }
      if (lowerCaseUrl.endsWith("png")) {
        return "png";
      }
      if (lowerCaseUrl.endsWith("svg")) {
        return "svg";
      }
      if (lowerCaseUrl.endsWith("bmp")) {
        return "bmp";
      }
      if (lowerCaseUrl.endsWith("gif")) {
        return "gif";
      }
    }

    function init() {
      LoaderService.showLoader('.popup');
      $timeout(function () {
        LoaderService.hideLoader('.popup');
      }, 900);
      if (vm.uploaded) {
        vm.docUrl = vm.modalData.docUrl;
        vm.fileType = getFileType(vm.docUrl);
      } else {
        vm.fileType = modalData.docUrl.type.split('/')[1];
        var reader = new FileReader();
        reader.onload = function (loadEvent) {
          vm.docUrl = loadEvent.target.result;
        };
        reader.readAsDataURL(vm.modalData.docUrl);
      }
    }
  }

})();

/**
 * Created by ttn on 05/08/21.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SessionModalController', SessionModalController);

  /** @ngInject */
  function SessionModalController($uibModalInstance, modalData, modalView,HDFC_API) {
    var vm = this;
    vm.HDFC_API=HDFC_API;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function (arg) {
      $uibModalInstance.close(arg);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SelectAccountNoModalController', selectAccountNoModalController);

  /** @ngInject */
  function selectAccountNoModalController($uibModalInstance, modalView, modalData, AppConstants) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.bankAccounts = vm.modalData.bankAccounts? vm.modalData.bankAccounts : null;
    vm.message = AppConstants.ToastrMessage.VALIDATE_DATA;

    vm.closeModal = function () {
      $uibModalInstance.close(vm.formData.accountNo);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 03/01/2023.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SelectFolioModalController', selectFolioModalController);

  /** @ngInject */
  function selectFolioModalController($uibModalInstance, modalView, modalData, AppConstants, investorServiceVersion, LoaderService, UtilService, MessageService, InvestorServiceVersionBasket3, InvestorServiceVersionFolioSelection) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.formData = {};
    vm.tForm = {};
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.folioList = null;
    vm.init = init;
    vm.folioChanged = folioChanged;
    // if we dont get the value setting nri flag to false
    if (vm.modalData.nriFlag === undefined) {
      vm.modalData.nriFlag = null;
    }

    init();

    function init() {
      if (vm.modalData.journey === AppConstants.JOURNEY.GOAL_JOURNEY) {
        getGoalFolioList();
      } else if (vm.modalData.journey === "FOLIO_CREATION") {
        getGoalFolioList();
      } else {
        getFolioList();
      }
    }

    function getFolioList() {
      LoaderService.showLoader();
      var success = function(resp) {
        if (resp.status && resp.data) {
          LoaderService.hideLoader();
          var folioList = [];
          vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
          if (resp.data.kycVerifiedFlag === false) {
            vm.kycMessage = resp.data.kycMessage;
          }
          Object.keys(resp.data.folioList).forEach(function (key) {
            var obj = Object.assign({key: key}, resp.data.folioList[key]);
            if (vm.modalData.retirementFlag) {
              if (!obj.minorFlag) {
                folioList.push(angular.copy(obj));
              }
            } else  {
              folioList.push(angular.copy(obj));
            }
          });
          vm.folioList = folioList.length ? folioList : null;
        } else {
          vm.folioList = null;
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        vm.folioList = null;
        UtilService.errorHandler(err);
      };

      if (vm.modalData.nriFlag === null) {
        investorServiceVersion.get({
          child1: 'folio',
          child2: 'active-list'
        }).$promise.then(success, error);
      } else {
        InvestorServiceVersionFolioSelection.get({
          child1: 'folio',
          child2: 'active-list',
          version:'v1',
          queryParam : vm.modalData.nriFlag
        }).$promise.then(success, error);
      }
    }

    function getGoalFolioList() {
      LoaderService.showLoader();
      var success = function(resp) {
        if (resp.status && resp.data) {
          LoaderService.hideLoader();
          var folioList = [];
          vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
          if (resp.data.kycVerifiedFlag === false) {
            vm.kycMessage = resp.data.kycMessage;
          }
          Object.keys(resp.data.folioList).forEach(function (key) {
            var obj = Object.assign({key: key}, resp.data.folioList[key]);
            if (vm.modalData.minor) {
              if (obj.minorFlag) {
                folioList.push(angular.copy(obj));
              }
            } else if (vm.modalData.journey === "FOLIO_CREATION") {
              if (!obj.minorFlag) {
                folioList.push(angular.copy(obj));
              }
            } else  {
              if (!obj.minorFlag) {
                folioList.push(angular.copy(obj));
              }
            }
          });
          vm.folioList = folioList.length ? folioList : null;
        } else {
          LoaderService.hideLoader();
          vm.folioList = null;
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        vm.folioList = null;
        UtilService.errorHandler(err);
      };

      if (vm.modalData.nriFlag === null) {
        InvestorServiceVersionBasket3.get({
          child1: 'folio',
          child2: 'getFolioList'
        }).$promise.then(success, error);
      } else {
        InvestorServiceVersionFolioSelection.get({
          child1: 'folio',
          child2: 'getFolioList',
          version:'v3',
          queryParam : vm.modalData.nriFlag
        }).$promise.then(success, error);
      }
    }

    function folioChanged() {
      if (!vm.formData.folioNumber) {
        return;
      }
      vm.selectedFolio = vm.folioList.filter(function(folio) {
        return folio.folioNumber === vm.formData.folioNumber;
      });

      var selectedForNewFolio = sessionStorage.getItem('folioSelectedForNewFolio');

      if ((vm.modalData.journey === 'INVESTMENT_BASKET_JOURNEY' || vm.modalData.journey ===  'RISK_JOURNEY') && vm.modalData.retirementFlag && !vm.selectedFolio[0].holderDOBExists && selectedForNewFolio === 'false') {
        MessageService.error(vm.selectedFolio[0].retirementSchemeBlankDOBErrorMsg);
        vm.selectedFolio = null;
        vm.formData.folioNumber = null;
        return;
      }

      sessionStorage.setItem('isMinorFolioSelected', vm.selectedFolio[0].minorFlag);
    }

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.closeModal = function () {
      $uibModalInstance.close(vm.formData.folioNumber);
    };

  }
})();

/**
 * Created by ttn on 28/10/2024.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SchemeListNewModalController', schemeListNewModalController);

  /** @ngInject */
  function schemeListNewModalController($uibModalInstance, $log, UtilService, modalView, modalData, SchemeService, LoaderService, MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.schemeTypeList = null;
    vm.schemeList = null;
    vm.selectedSchemeType = '';
    vm.PARTNER_DATA =  JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
    vm.selected = 0;

    vm.fetchSchemes = function (schemeType, index) {
      vm.selectedSchemeType = schemeType.toUpperCase();
      vm.selected = index;
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.schemeList = resp.data.schemeList;
          if(vm.PARTNER_DATA){
            vm.schemeGroupCodeList(vm.schemeList);
          }
        } else {
          MessageService.error(resp.message);
          vm.schemeList = null;
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.schemeList = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader('.popup');

      var _config = {
        controller: 'scheme',
        type: vm.selectedSchemeType,
        child1: vm.modalData.enabledScheme,
        child2: vm.modalData.isMinor,
        child3: vm.modalData.isThroughDistributor,
        child4: vm.modalData.corporateFlag ? vm.modalData.corporateFlag : false
      };

      if (vm.modalData.isFlexStp) {
        _config.child1 = 'flexstpenabled';
      } else if (vm.modalData.isSwingStp) {
        _config.child1 = 'swingstpenabled';
      }
      if(vm.modalData && vm.modalData.isFlexIndex){
        _config.child1 = 'flex-index-enabled';
      }
      SchemeService.get(_config, null).$promise.then(success, error);
    };
    vm.dismissModal = function () {
      $uibModalInstance.dismiss(true);
    };

    vm.selectScheme = function (scheme) {
      scheme.isThroughDistributor = vm.modalData.isThroughDistributor;
      scheme.schemeChangedByUser = true;
      $uibModalInstance.close(scheme);
    };

    vm.init = function () {

      var payload = {
        minor : vm.modalData.isMinor,
        investThroughDistributor : vm.modalData.isThroughDistributor,
        transactionType : vm.modalData. enabledScheme
      }

      if (vm.modalData.isFlexStp) {
        payload.transactionType = 'flexstpenabled';
      } else if (vm.modalData.isSwingStp) {
        payload.transactionType = 'swingstpenabled';
      } else if(vm.modalData && vm.modalData.isFlexIndex){
        payload.transactionType = 'flex-index-enabled';
      }

      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.schemeTypeList = resp.data.schemeType;
          if (vm.schemeTypeList && vm.schemeTypeList.length > 0) {
            vm.fetchSchemes(vm.schemeTypeList[0], 0);
          }
        } else {
          vm.schemeTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.schemeTypeList = null;
        UtilService.errorHandler(err)
      };
      LoaderService.showLoader('.popup');

      SchemeService.post({
        controller: 'filteredSchemeType'
      }, payload).$promise.then(success, error);

    };
    vm.schemeGroupCodeList = function(schemeList) {
      vm.schemeCodeList = vm.PARTNER_DATA.schemeList;
      var schemeCodeList=[];
      if (schemeList && vm.schemeCodeList) {
        var key = 0;
        vm.schemeCodeList.forEach(function(item){
          var data =
            schemeList.filter(function(data){
              return data.schemeCode == item.schemeCode
            })[0];
          if(data !== undefined) {
            schemeCodeList[key] = data;
            key= key+1;
          }
        })
        vm.masterInSchemeList = null;
        vm.masterInSchemeList = schemeCodeList;
        vm.schemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      }
    }
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SchemeListInstantModalController', schemeListInstantModalController);

  /** @ngInject */
  function schemeListInstantModalController($window,$uibModalInstance, UtilService, IIHttpService , modalView, modalData, SchemeService, LoaderService, MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.schemeTypeList = null;
    vm.schemeList = null;
    vm.selectedSchemeType = '';
    vm.PARTNER_DATA =  JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
    vm.arnHardcodedData = $window.JSON.parse(localStorage.getItem("distributorDetails"));
    vm.HDFCCAMPFUND = ['HDFCEQ','HDFCLARGEF','HDFCT2'];

    vm.fetchSchemes = function (schemeType) {
      vm.selectedSchemeType = schemeType.toUpperCase();
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.schemeList = resp.data.schemeList;
          if(vm.PARTNER_DATA){
            vm.schemeGroupCodeList(vm.schemeList);
          }
          if (vm.arnHardcodedData && vm.arnHardcodedData.HDFCCAMP && vm.modalData.enabledScheme == 'sipenabled') {
            vm.filterHdfcCapmScheme(vm.schemeList);
          }
        } else {
          MessageService.error(resp.message);
          vm.schemeList = null;
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.schemeList = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader('.popup');

      IIHttpService.get({
        child1: 'scheme',
        child2: vm.selectedSchemeType,
        child3: vm.modalData.enabledScheme,
        child4: vm.modalData.isMinor,
        child5: vm.modalData.isThroughDistributor,
        child6: vm.modalData.corporateFlag ? vm.modalData.corporateFlag : false
      }, null).$promise.then(success, error);

    };
    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.selectScheme = function (scheme) {
      $uibModalInstance.close(scheme);
    };

    vm.init = function () {

      var payload = {
        minor : vm.modalData.isMinor,
        investThroughDistributor : vm.modalData.isThroughDistributor,
        transactionType : vm.modalData.enabledScheme
      }


      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.schemeTypeList = resp.data.schemeType;
          if (vm.schemeTypeList && vm.schemeTypeList.length > 0) {
            vm.fetchSchemes(vm.schemeTypeList[0]);
          }
        } else {
          vm.schemeTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.schemeTypeList = null;
        UtilService.errorHandler(err)
      };
      LoaderService.showLoader('.popup');

      IIHttpService.post({
        child1: 'filteredSchemeType'
      }, payload).$promise.then(success, error);

    };

    vm.schemeGroupCodeList = function(schemeList) {

          vm.schemeCodeList = vm.PARTNER_DATA.schemeList;
          var schemeCodeList=[];
          if (schemeList && vm.schemeCodeList) {
            var key = 0;
            vm.schemeCodeList.forEach(function(item){
              var data =
              schemeList.filter(function(data){
                return data.schemeCode == item.schemeCode
              })[0];
             if(data !== undefined) {
              schemeCodeList[key] = data;
              key= key+1;
            }
            })
              vm.masterInSchemeList = null;
              vm.masterInSchemeList = schemeCodeList;
              vm.schemeList = UtilService.getFilteredList(vm.masterInSchemeList);

        }

    }
    vm.filterHdfcCapmScheme = function(schemeList) {
      var fundCodeMap = {};
      var schemeListData = [];
      vm.HDFCCAMPFUND.forEach(function(item){
          fundCodeMap[item] = true;
      });
      schemeList.forEach(function(val){
          if(fundCodeMap.hasOwnProperty(val.fundCode)){
            schemeListData.push(val);
          }
      });

      if (vm.modalData.enabledScheme == 'sipenabled') {
        vm.masterInSchemeList = null;
        vm.masterInSchemeList = schemeListData;
        vm.schemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      }
    }

  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SchemeListModalController', schemeListModalController);

  /** @ngInject */
  function schemeListModalController($uibModalInstance, $log, UtilService, modalView, modalData, SchemeService, LoaderService, MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.schemeTypeList = null;
    vm.schemeList = null;
    vm.selectedSchemeType = '';
    vm.PARTNER_DATA =  JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
    vm.selected = 0;

    vm.fetchSchemes = function (schemeType, index) {
      vm.selectedSchemeType = schemeType.toUpperCase();
      vm.selected = index;
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.schemeList = resp.data.schemeList;
          if(vm.PARTNER_DATA){
            vm.schemeGroupCodeList(vm.schemeList);
          }
        } else {
          MessageService.error(resp.message);
          vm.schemeList = null;
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.schemeList = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader('.popup');

      var _config = {
        controller: 'scheme',
        type: vm.selectedSchemeType,
        child1: vm.modalData.enabledScheme,
        child2: vm.modalData.isMinor,
        child3: vm.modalData.isThroughDistributor,
        child4: vm.modalData.corporateFlag ? vm.modalData.corporateFlag : false
      };

      if (vm.modalData.isFlexStp) {
          _config.child1 = 'flexstpenabled';
      } else if (vm.modalData.isSwingStp) {
        _config.child1 = 'swingstpenabled';
      }
      if(vm.modalData && vm.modalData.isFlexIndex){
        _config.child1 = 'flex-index-enabled';
      }
        SchemeService.get(_config, null).$promise.then(success, error);
    };
    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.selectScheme = function (scheme) {
      $uibModalInstance.close(scheme);
    };

    vm.init = function () {

      var payload = {
        minor : vm.modalData.isMinor,
        investThroughDistributor : vm.modalData.isThroughDistributor,
        transactionType : vm.modalData. enabledScheme
      }

      if (vm.modalData.isFlexStp) {
        payload.transactionType = 'flexstpenabled';
      } else if (vm.modalData.isSwingStp) {
        payload.transactionType = 'swingstpenabled';
      } else if(vm.modalData && vm.modalData.isFlexIndex){
        payload.transactionType = 'flex-index-enabled';
      }

      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.schemeTypeList = resp.data.schemeType;
          if (vm.schemeTypeList && vm.schemeTypeList.length > 0) {
            vm.fetchSchemes(vm.schemeTypeList[0], 0);
          }
        } else {
          vm.schemeTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.schemeTypeList = null;
        UtilService.errorHandler(err)
      };
      LoaderService.showLoader('.popup');

      SchemeService.post({
        controller: 'filteredSchemeType'
      }, payload).$promise.then(success, error);

    };
    vm.schemeGroupCodeList = function(schemeList) {
      vm.schemeCodeList = vm.PARTNER_DATA.schemeList;
      var schemeCodeList=[];
      if (schemeList && vm.schemeCodeList) {
        var key = 0;
        vm.schemeCodeList.forEach(function(item){
          var data =
          schemeList.filter(function(data){
            return data.schemeCode == item.schemeCode
          })[0];
          if(data !== undefined) {
           schemeCodeList[key] = data;
           key= key+1;
         }
        })
        vm.masterInSchemeList = null;
        vm.masterInSchemeList = schemeCodeList;
        vm.schemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      }
    }
  }
})();

/**
 * Created by ttn on 06/04/20.
*/
(function () {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('ScheduleTransactionController', scheduleTransactionController);

    /** @ngInject */
    function scheduleTransactionController($uibModalInstance, modalView, modalData, TransactionService, MessageService, $window) {
        var vm = this;
        vm.view = modalView;
        vm.modalData = modalData;
        vm.scheduleTransactionForm = {};
        vm.formData = {};
        vm.formData.frequency = "One-time";
        vm.isVisibleEndDate = false;
        vm.nonBusinessDates = [];
        vm.enabledEndDates = [];
        vm.isEnableEndDate = false;

        vm.init = function() {
            vm.nonBusinessDates = modalData.nonBusinessDay.nonBuisnessDates;
            calculateStartDate();
        };
        vm.init();

        vm.closeModal = function () {
            $uibModalInstance.close();
        };

        vm.dismissModal = function () {
            $uibModalInstance.dismiss();
        };
        /* Controllers defined functions */
        vm.changeStartDate = function (date) {
            vm.formData.scheduleDate = date ? date : null;
            vm.isEnableEndDate = true;
            if (vm.formData.frequency  !== 'One-time') {
                vm.isVisibleEndDate = true;
            }
            calculateEndDate(vm.formData.frequency.toLowerCase());
        };
        vm.changeEndDate = function (date) {
            vm.formData.endDate = date ? date : null;
        };
        vm.changeFrequencies = function(frequency) {
            if ((frequency === "monthly" || frequency === "weekly")) {
                vm.isVisibleEndDate = true;
                calculateEndDate(frequency);
            } else {
                vm.isVisibleEndDate =  false;
                delete vm.formData.endDate;
            }
        };

        vm.performSubmission = function () {
            if (vm.formData.frequency !== 'One-time') {
              vm.formData['scheduleDates'] = findAllDates();
              vm.formData['endDate'] = vm.formData.endDate.format("DD-MMM-YYYY");
            }
            vm.formData['scheduleDate'] = vm.formData.scheduleDate.format("DD-MMM-YYYY");
            vm.formData['DynamicNotesScheduleReview'] = vm.modalData.notesReviewSchedule;
            vm.formData['DynamicScheduleTerms'] = vm.modalData.termsConditionReviewSchedule;
            $uibModalInstance.close(vm.formData);
        };

        /* utility function for schedule transaction initiate modal */
        function calculateStartDate() {
            var enabledStartDatesList = [];
            var currentDate = $window.moment().add(1, 'days');
            var startMaxDate = $window.moment().clone().add(30, 'days');
            var startDate = currentDate.clone();
            var freq = startMaxDate.diff($window.moment(), 'days');
            for (var i = 0; i <= freq; i++) {
                var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
                var isEnable = true;
                angular.isArray(vm.nonBusinessDates) && vm.nonBusinessDates.forEach(function (value) {
                  if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days') == 0){
                    isEnable = false;
                  }
                });
                if (isEnable) {
                    enabledStartDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
                }
            }
            vm.minStartDate = angular.copy(enabledStartDatesList[0]);
            vm.startMaxDate = startMaxDate;
            vm.enabledDates = enabledStartDatesList;
        }

        function calculateEndDate(frequency) {
            var enabledEndDatesList = [];
            var currentDate = $window.moment();
            vm.endMinDate = currentDate;
            var endDate = currentDate.clone().add(90, 'days');
            vm.endMaxDate = endDate;
            var frequencyDate = vm.formData.scheduleDate ? vm.formData.scheduleDate : $window.moment();
            var freq = 0;
            var i = 0;
            if (frequency === 'weekly') {
                freq = endDate.diff(frequencyDate, 'days');
                for (i = 7; i <= freq; i+=7) {
                    var indexDate = frequencyDate.clone().add(i, 'days').format("DD-MMM-YYYY");
                    if ($window.moment(indexDate, "DD-MMM-YYYY").diff(frequencyDate, 'days') >= 7) {
                        enabledEndDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
                    }
                }
            } else if (frequency === 'monthly') {
                freq = endDate.diff(currentDate, 'days');
                for (i = 30; i <= freq; i+=30) {
                    var indexDate = frequencyDate.clone().add(i, 'days');
                    var diff = $window.moment(indexDate.format("DD-MMM-YYYY")).diff(endDate.format("DD-MMM-YYYY"), "days");
                    if (diff <= 0) {
                        enabledEndDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
                    }
                }
            }
            vm.formData.endDate = "";
            vm.enabledEndDateView = $window.moment(enabledEndDatesList[0], "DD-MMM-YYYY");
            vm.enabledEndDates = enabledEndDatesList;
        }

        function findAllDates() {
            var scheduleDates = "";
            var selectedDates = vm.enabledEndDates.filter(function(date) {
                var selectedDate = $window.moment(date, "DD-MMM-YYYY").format("YYYY-MM-DD");
                return $window.moment(selectedDate).isBetween(vm.formData.scheduleDate.format("YYYY-MM-DD"), vm.formData.endDate.format("YYYY-MM-DD"), null, '[]');
            });
            for (var i=0; i < selectedDates.length; i++) {
                if (i !== selectedDates.length -1 ) {
                    scheduleDates += selectedDates[i].format("DD-MMM-YYYY") + ", ";
                } else {
                    scheduleDates += selectedDates[i].format("DD-MMM-YYYY");
                }
            }
            return scheduleDates;
        }


    }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('RollOverModalController', rollOverModalController);

  /** @ngInject */
  function rollOverModalController($uibModalInstance, modalView,$log, $state, modalData,$window) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    $window.NumToWord(vm.modalData.amountOrUnits, 'DisplayWordsTaxAmt', vm.modalData);

    vm.closeModal = function () {
      $uibModalInstance.close();
      $state.go('main.rolloverView');
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.submitForm =function(){
      $uibModalInstance.dismiss("cancel");
      vm.modalData && vm.modalData.saveRolloverRequest();
    }

  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ResetPasswordSuccessController', resetPasswordSuccessController);

  /** @ngInject */
  function resetPasswordSuccessController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    }
})();

/**
 * Created by ttn on 8/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ChangePasswordModalController', changePasswordModalController);

  /** @ngInject */
  function changePasswordModalController($uibModalInstance, ModalService, UtilService, InvestorService, AppConstants, modalView, modalData, AuthService) {

    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.changePasswordPayload = {
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    };
    vm.resetForm = {};
    vm.password_regex = '/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$_!@])[A-Za-z\d$@!_]{8,12}$/';
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.confirmErr = '';
    vm.processFlag = false;
    vm.passwordExpireMsg = vm.modalData.errMsg;

    vm.changePassword = function () {
      if (vm.changePasswordPayload.newPassword == vm.changePasswordPayload.oldPassword) {
        //MessageService.error("Old Password and New Password should not be same");
        vm.confirmErr = "Old and New Password cannot be the same";
        return;
      }
      var success = function (resp) {
        vm.processFlag = false;
        vm.confirmErr = '';
        if(resp.data && resp.status){
           $uibModalInstance.close(resp);
        }
       else{
          //MessageService.error(resp.message);
          vm.confirmErr = resp.message;
        }
      }, error = function (err) {
        vm.processFlag = false;
        vm.confirmErr = '';
        UtilService.errorHandler(err);
      };

      if (vm.changePasswordPayload.newPassword && vm.changePasswordPayload.confirmPassword && vm.changePasswordPayload.newPassword !== vm.changePasswordPayload.confirmPassword) {
        vm.confirmErr = vm.validateData.PASSWORD_SAME;
      } else {
        vm.confirmErr = '';
        vm.processFlag = true;

        if(vm.passwordExpireMsg === "Password Expired"){
        InvestorService.post({
          child1: 'change',
          child2: 'password-expiry'
        }, { "newPassword": AuthService.encryptRSA(angular.copy(vm.changePasswordPayload.newPassword)),
          "oldPassword": AuthService.encryptRSA(angular.copy(vm.changePasswordPayload.oldPassword)),
          "userId" : vm.modalData.userId
        }).$promise.then(success, error);

      }
      else{
          InvestorService.post({
            child1: 'change',
            child2: 'password'
          }, { "newPassword": AuthService.encryptRSA(angular.copy(vm.changePasswordPayload.newPassword)),
            "oldPassword": AuthService.encryptRSA(angular.copy(vm.changePasswordPayload.oldPassword)),
            "userId" : vm.modalData.userId
          }).$promise.then(success, error);
        }
      }

    };

    vm.resetDefaults = function () {
      vm.confirmErr = '';
    };

    vm.confirmCancel = function () {
      var confirmSuccess = function () {
        vm.closeModal();
      };
      var confirmError = function () {
        // task.done = false;
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    }

    vm.closeModal = function () {
      $uibModalInstance.close(vm.modalData);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.copyPasteHandler = function (e) {

      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    }
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('RegisterEmandateNewJourneyModalController', registerEmandateNewJourneyModalController);
  
    /** @ngInject */
    function registerEmandateNewJourneyModalController($uibModalInstance,AppConstants,LoaderService,MessageService,UtilService,TransactionService, modalData, modalView) {
      var vm = this;
      vm.view = modalView; 
      vm.modalData = modalData;
      vm.closeModal = function () {
        $uibModalInstance.close();
      };
      vm.dismissModal = function () {
        $uibModalInstance.dismiss();
      };
    }
  })();
  
/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('RegisterModalController', registerModalController);

  /** @ngInject */
  function registerModalController($uibModalInstance, modalData, modalView, LoaderService, TransactionService, UtilService, AppConstants, MessageService, $scope, $sce, $timeout) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.otpForm = {};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.otpResendMessage = '';
    vm.isProcessing = false;
    vm.isOtmValid = true;
    vm.otpNumber = '';
    vm.appConstants = AppConstants;
    var otmSubmitCount = 0;
    vm.init = init;
    init();
    vm.submitEkycForm = submitEkycForm;

    function init(){
      if(vm.view == 'REGISTER_EMANDATE' && !vm.modalData.noOtpConfirmModal) {
        generateOtp();
      }
      if (vm.modalData.ekycRequestCO) {
        vm.modalData.actionUrl = $sce.trustAsResourceUrl(vm.modalData.ekycRequestCO.camsUrl);
      }
    }
    vm.closeModal = function (arg) {
      if(modalData.type && modalData.type == "DREAMSIP"){
        var otmSubmitCount = 0;
        LoaderService.showLoader();
        var success, failure;
        success = function(resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            $uibModalInstance.close(arg);
          } else {
            otmSubmitCount++;
            if (otmSubmitCount === 6 ) {
              vm.isOtmValid = false;
            }
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        };
        failure = function(err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        vm.otpPayload = {
          otp : vm.otpNumber ,
          id: vm.singleUseURL,
          folioNumber:  modalData.folioNumber,
          transactionType : modalData.type
        }

        TransactionService.post({
           controller1: 'transaction',
           controller2: 'verify',
           controller3: 'otp'
        }, vm.otpPayload).$promise.then(success, failure);
      }else{
        $uibModalInstance.close(arg);
      }
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.confirmTransaction = function () {
      approveTransaction();
    };

    vm.resendOtp = function () {
      LoaderService.showLoader();
      // vm.isProcessing = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.otpResendMessage = 'OTP sent again successfully.';
            resetTimer();
          } else {
            vm.otpResendMessage = '';
            MessageService.error(resp.message)
          }
          vm.isProcessing = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.otpResendMessage = '';
          vm.isProcessing = false;
          UtilService.errorHandler(err);
        };
      var payload = {
        "id" : vm.singleUseURL
      };
      TransactionService.post({
        controller1: 'transaction',
        controller2: 'resend',
        controller3: 'otp'
      }, payload).$promise.then(success, error);
    };

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

    function generateOtp() {
      LoaderService.showLoader();
      vm.isProcessing = true;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.singleUseURL = resp.data.secretLink;
          vm.otpSentMessage = resp.data.message || "OTP has been sent to your registered Email ID.";
          vm.otpId = resp.data.id;
          // otmSubmitCount = 1;
        } else {
          vm.otpSentMessage = '';
          vm.dismissModal();
          MessageService.error(resp.message);
        }
        vm.isProcessing = false;
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.otpResendMessage = '';
        vm.isProcessing = false;
        UtilService.errorHandler(err);
      };
      var payload = {
        folioNumber: vm.modalData.folioNumber,
        transactionType: vm.modalData.transactionType,
        randomOTPId: modalData.randomOTPId
      };
      if (vm.modalData.flowName) {
        payload.flowName = vm.modalData.flowName;
      }
      TransactionService.post2({
        controller1: 'transaction',
        controller2: 'otp'
      }, payload).$promise.then(success, error);
    }

    function approveTransaction() {
      LoaderService.showLoader();
      var success, failure;
      success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.sendDataToModel = {
            secretLink : vm.singleUseURL
          }
          $uibModalInstance.close(vm.sendDataToModel);
        } else {
          otmSubmitCount++;
          if (otmSubmitCount === 6 ) {
            vm.isOtmValid = false;
          }
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      };
      failure = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      vm.otpPayload = {
        otp : vm.otpNumber ,
        id: vm.singleUseURL,
        folioNumber:  vm.modalData.folioNumber,
        transactionType : vm.modalData.transactionType
      };

      if (vm.modalData.flowName) {
        vm.otpPayload.flowName = vm.modalData.flowName;
      }

      TransactionService.post({
        controller1: 'transaction',
        controller2: 'verify',
        controller3: 'otp'
      }, vm.otpPayload).$promise.then(success, failure);

    }

    function submitEkycForm() {
      LoaderService.showLoader();
      $timeout(function () {
        angular.element('#ekycForm').submit();
        $timeout(function() {
          LoaderService.hideLoader();
          vm.dismissModal();
        }, 10000);
      }, 100);
    }
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('KycRejectModalController', kycRejectModalController);

  /** @ngInject */
  function kycRejectModalController($uibModalInstance, modalData, modalView, $state) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.ekycRequestCO = vm.modalData.ekycRequestCO;

    vm.closeModal = function (arg) {
      $uibModalInstance.close(arg);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.redirectToEkyc = function () {
      $uibModalInstance.dismiss();
      $state.go('ekyc', {
        ekycRequestCO: vm.ekycRequestCO
      });
    };
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ConfirmRegisterModalController', confirmRegisterModalController);

  /** @ngInject */
  function confirmRegisterModalController($uibModalInstance, modalData, modalView) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('RedemptionConfirmModalController', redemptionConfirmModalController);

  /** @ngInject */
  function redemptionConfirmModalController($uibModalInstance,$state, modalView, modalData, ModalService, LoaderService, TransactionService, UtilService, MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.gotoRedeem = gotoRedeem;
    vm.stayInvested = stayInvested;
    var res={};
    vm.closeModal = function (resp) {
      $uibModalInstance.close(resp);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    function gotoRedeem() {
      if(vm.isChecked){
        localStorage.setItem('popupDisable', false);
        res.pop_status ='false'
      }else{
        localStorage.removeItem('popupDisable');
        res.pop_status ='true'
      }
      res.status =''

      vm.closeModal(res);
    }

    function stayInvested() {
      res.status ='stay'
      if(vm.isChecked){
        res.pop_status ='false'
      }else{
        res.pop_status ='true'
      }

      vm.closeModal(res);
    }
  }
})();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('purchaseScheduleSchemesController', purchaseScheduleSchemesController);

    /** @ngInject */

    function purchaseScheduleSchemesController($uibModalInstance,$window, modalView, modalData, InvestorService,AppConstants) {
      var vm = this;
      vm.folioData = JSON.parse(localStorage.getItem('selectedFolioDataInQI'));  
      vm.view = modalView;
      vm.RISK_METER = AppConstants.RISK_METER;
      vm.riskmeterMap = new Map();
      for(var i=0;i < vm.RISK_METER.length;i++){
        vm.riskmeterMap.set(vm.RISK_METER[i].key,vm.RISK_METER[i])
      }
      vm.modalData = modalData;
      vm.resp = {};
      vm.CategoryList = [];
      vm.schemeCategory = "";
      vm.schemeData = null;
      var tempArray = [];
      var tempArray2 = []; 
      vm.getUniqueValues = function (el) {
        var uniqueObjects = [];
        var seenObjects = {};
        for (var i = 0; i < el.length; i++) {
          var obj = el[i];
          var key = obj.fundCode;
  
          if (!seenObjects[key]) {
            seenObjects[key] = true;
            uniqueObjects.push(obj);
          }
        }
        return uniqueObjects;
      }
      vm.catList = [];
      vm.setGetDraftData = function () {
        if (vm.InvestmentGoalDetails) {
          vm.InvestmentGoalDetails.forEach(function (res) {
            vm.SelectedInvestmentGoalDetailsList = res.funds;
            vm.SelectedInvestmentGoalDetailsList.forEach(function (item) {
              for (var i = 0; i < vm.fundCode.length; i++) {
                if (item.fundCode == vm.fundCode[i]) {
                  var tempObj = {};
                  tempObj.fundName = item.fundName;
                  if(vm.modalData.ARN == 'DIRECT'){
                    if(item.fundNavDirect && item.fundNavDirect.nav_amount && item.fundNavDirect.nav_amount['1']){
                      tempObj.navValue = item.fundNavDirect.nav_amount['1'];
                    }
                    if(item.fundNavDirect && item.fundNavDirect.nav_date && item.fundNavDirect.nav_date['1']){
                      tempObj.navDateTimestamp = item.fundNavDirect.nav_date['1'];
                    }
                  }else{
                    if(item.fundNavRegular && item.fundNavRegular.nav_amount && item.fundNavRegular.nav_amount['1']){
                      tempObj.navValue = item.fundNavRegular.nav_amount['1'];
                    }
                    if(item.fundNavRegular && item.fundNavRegular.nav_date && item.fundNavRegular.nav_date['1']){
                      tempObj.navDateTimestamp = item.fundNavRegular.nav_date['1'];
                    }
                  } 
                  tempObj.selected = false;
                  tempObj.minorFlag = item.minorFlag;
                  tempObj.retirementFlag = item.retirementFlag;
                  // tempObj.benchmarkForFund = item.benchmarkForFund;
                  tempObj.risk = item.riskReturnProfile;
                  tempObj.schemeData = null;
                  tempObj.fundCategory = item.fundCategory[0];
                  vm.catList.push(item.fundCategory[0]);
                  var schemeCodeList = [];
                  if(vm.modalData.ARN == "DIRECT"){
                    if (item.directSchemes) {
                      item.directSchemes.forEach(function (val) {
                        schemeCodeList.push(val);
                      });
                    }
                  }else{
                    if (item.regularSchemes) {
                      item.regularSchemes.forEach(function (val) {
                        schemeCodeList.push(val);
                      });
                    }
                  } 
                  tempObj.schemes = schemeCodeList;
                  if(tempObj.schemes && tempObj.schemes.length > 0){
                    var purchaseEnabledScheme = [];
                    tempObj.schemes.forEach(function (el) {
                      if(el.purchaseEnabled){
                        purchaseEnabledScheme.push(el);
                      }
                    });
                    tempObj.schemes = purchaseEnabledScheme;
                  }
                  if(tempObj.schemes.length > 0){
                    tempObj.schemes.forEach(function(val){
                      if(val.investmentOption && val.investmentOption.toUpperCase() == "GROWTH"){
                        tempObj.schemeData = val;
                      }
                    });
                  }
                  if(tempObj.schemeData && tempObj.schemeData.schemeCode){
                    tempObj.selected = true;
                  }
                  if(vm.riskmeterMap.has(tempObj.risk)){
                    tempObj.riskmeter = vm.riskmeterMap.get(tempObj.risk).img;
                    tempObj.riskicon = vm.riskmeterMap.get(tempObj.risk).icon;
                  }
                  tempObj.fundCode = item.fundCode;
                  if(tempObj.schemes.length > 0){
                      tempArray.push(tempObj);
                  } 
                }
                vm.catList.push(item.fundCategory[0]);
              }
            });
            if (tempArray.length > 1) {
              vm.SelectedInvestmentGoalDetailsList = vm.getUniqueValues(tempArray);
            } else {
              vm.SelectedInvestmentGoalDetailsList = tempArray;
            }
            vm.recFund = vm.SelectedInvestmentGoalDetailsList;
            vm.masterFundList = vm.SelectedInvestmentGoalDetailsList;
          });
  
          vm.InvestmentGoalDetails.forEach(function (res) {
            vm.SelectedInvestmentGoalDetailsList = res.funds;
            vm.SelectedInvestmentGoalDetailsList.forEach(function (item) {
              for (var j = 0; j < vm.otherFundCode.length; j++) {
                if (item.fundCode == vm.otherFundCode[j]) {
                  var tempObj = {};
                  tempObj.fundName = item.fundName;
                  if(vm.modalData.ARN == 'DIRECT'){
                    if(item.fundNavDirect && item.fundNavDirect.nav_amount && item.fundNavDirect.nav_amount['1']){
                      tempObj.navValue = item.fundNavDirect.nav_amount['1'];
                    }
                    if(item.fundNavDirect && item.fundNavDirect.nav_date && item.fundNavDirect.nav_date['1']){
                      tempObj.navDateTimestamp = item.fundNavDirect.nav_date['1'];
                    }
                  }else{
                    if(item.fundNavRegular && item.fundNavRegular.nav_amount && item.fundNavRegular.nav_amount['1']){
                      tempObj.navValue = item.fundNavRegular.nav_amount['1'];
                    }
                    if(item.fundNavRegular && item.fundNavRegular.nav_date && item.fundNavRegular.nav_date['1']){
                      tempObj.navDateTimestamp = item.fundNavRegular.nav_date['1'];
                    }
                  } 
                  tempObj.selected = false;
                  tempObj.minorFlag = item.minorFlag;
                  tempObj.retirementFlag = item.retirementFlag;
                  // tempObj.benchmarkForFund = item.benchmarkForFund;
                  tempObj.risk = item.riskReturnProfile;
                  tempObj.schemeData = null;
                  tempObj.fundCategory = item.fundCategory[0];
                  vm.catList.push(item.fundCategory[0]);
                  var schemeCodeList = [];
                  if(vm.modalData.ARN == "DIRECT"){
                    if (item.directSchemes) {
                      item.directSchemes.forEach(function (val) {
                        schemeCodeList.push(val);
                      });
                    }
                  }else{
                    if (item.regularSchemes) {
                      item.regularSchemes.forEach(function (val) {
                        schemeCodeList.push(val);
                      });
                    }
                  } 
                  tempObj.schemes = schemeCodeList;
                  if(tempObj.schemes && tempObj.schemes.length > 0){
                    var purchaseEnabledScheme = [];
                    tempObj.schemes.forEach(function (el) {
                      if(el.purchaseEnabled){
                        purchaseEnabledScheme.push(el);
                      }
                    });
                    tempObj.schemes = purchaseEnabledScheme;
                  }
                  if(tempObj.schemes.length > 0){
                    tempObj.schemes.forEach(function(val){
                      if(val.investmentOption && val.investmentOption.toUpperCase() == "GROWTH"){
                        tempObj.schemeData = val;
                      }
                    });
                  }
                  if(tempObj.schemeData && tempObj.schemeData.schemeCode){
                    tempObj.selected = true;
                  }
                  if(vm.riskmeterMap.has(tempObj.risk)){
                    tempObj.riskmeter = vm.riskmeterMap.get(tempObj.risk).img;
                    tempObj.riskicon = vm.riskmeterMap.get(tempObj.risk).icon;
                  }
                  tempObj.fundCode = item.fundCode;
                  if(tempObj.schemes.length > 0){
                    tempArray2.push(tempObj);
                  } 
                }
                vm.catList.push(item.fundCategory[0]);
              }
            });
            if (tempArray2.length > 1) {
              vm.SelectedInvestmentGoalDetailsList2 = vm.getUniqueValues(tempArray2);
            } else {
              vm.SelectedInvestmentGoalDetailsList2 = tempArray2;
            }
            vm.otherFund = vm.SelectedInvestmentGoalDetailsList2;
            vm.masterFundList2 = vm.SelectedInvestmentGoalDetailsList2;
          });
          vm.CategoryList = vm.distinctArray(vm.catList);
        }
      }
      vm.categoryDetailsList = function () {
        var success = function (resp) {
          if (resp.data && resp.status) {
            vm.allFund = [];
            vm.InvestmentGoalDetails = resp.data;
            vm.InvestmentGoalDetails.forEach(function (res) {
              vm.SelectedInvestmentGoalDetailsList = res.funds;
              vm.SelectedInvestmentGoalDetailsList.forEach(function (item) {
                if (item.fundCode && ((item.directSchemes && item.directSchemes.length > 0 )||
                (item.regularSchemes && item.regularSchemes.length > 0))) {
                  item.minorFlag = false;
                  item.retirementFlag = false;
                  if(item.directSchemes && item.directSchemes.length > 0){
                  item.minorFlag = item.directSchemes[0].minorFlag;
                  item.retirementFlag = item.directSchemes[0].retirementFlag;
                  }else{ 
                  item.retirementFlag = item.regularSchemes[0].retirementFlag;
                  item.minorFlag = item.regularSchemes[0].minorFlag;
                  } 
                  vm.allFund.push(item.fundCode);
                }
              });
            });
            vm.allFundList = vm.distinctArray(vm.allFund);
           var result = vm.allFundList.filter(function(x) {
              return !vm.fundCode.includes(x)
            });
            vm.otherFundCode = result;
            vm.setGetDraftData();
          } else {
            MessageService.error(resp.message);
          }
        },
          error = function (err) {
            vm.processFlag = true;
            MessageService.error(err.data.message);
          };
          InvestorService.get({
          child1: 'new',
          child2: 'user',
          child3: 'fund',
          child4: 'investmentGoal'
        }).$promise.then(success, error);
      }
      vm.recommendedFunds = function () {
        var success = function (resp) {
          if (resp.data && resp.status) {
            vm.fundCode = resp.data.fundList;
            vm.categoryDetailsList();
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          MessageService.error(err.data.message);
        }; 
        vm.distributorDetails = $window.JSON.parse(localStorage.getItem("distributorDetails"));
        var arn = (vm.distributorDetails && vm.distributorDetails.arn)?vm.distributorDetails.arn:'0005';
        InvestorService.get({
          child1: "arnRecommendedSchemes",
          child2: "ARN-"+arn,
          child3: "PURCHASE_SCHEDULER"
        }).$promise.then(success, error);
      }
      vm.recommendedFunds();
      vm.closeModal = function () {
        $uibModalInstance.close(vm.modalData);
      };
      vm.dismissModal = function () {
        $uibModalInstance.dismiss("cancel");
      };
      vm.changeSchemeCategory = function () {
        vm.recFund = [];
        vm.otherFund = [];
        var tempRecFund = [];
        var tempRecFund2 = [];
        vm.masterFundList.forEach(function (val) {
          if (val.fundCategory == vm.schemeCategory) {
            tempRecFund.push(val);
          }
        });
        vm.recFund = tempRecFund;
  
        vm.masterFundList2.forEach(function (val) {
          if (val.fundCategory == vm.schemeCategory) {
            tempRecFund2.push(val);
          }
        });
        vm.otherFund = tempRecFund2;
        if(!vm.schemeCategory){
          vm.recFund = vm.masterFundList;
          vm.otherFund = vm.masterFundList2;
        }
      }
      vm.changeScheme = function (fundCode, value) {
        if (value == null) {
          if(fundCode){
            vm.recFund.forEach(function (element, index) {
              if (element.fundCode == fundCode) {  
                vm.recFund[index].selected = false;
              }
            });
            vm.otherFund.forEach(function (element, index) {
              if (element.fundCode == fundCode) {  
                vm.otherFund[index].selected = false;
              }
            });
          }
          return;
        } 
        if (value && fundCode) {
          vm.recFund.forEach(function (element, index) {
            if (element.fundCode == fundCode) {
              element.schemes.forEach(function (element2) {
                if (element2.schemeCode == value.schemeCode) {
                  vm.recFund[index].selected = true;
                }
              })
            }
          });
        }
        if (value && fundCode) {
          vm.otherFund.forEach(function (element, index) {
            if (element.fundCode == fundCode) {
              element.schemes.forEach(function (element2) {
                if (element2.schemeCode == value.schemeCode) {
                  vm.otherFund[index].selected = true;
                }
              })
            } 
          });
        }
      }
      vm.investnow = function (cData) {
        var data = {};
        vm.schemeData = cData;
        if (vm.schemeData) {
          data = {
            investmentOption: vm.schemeData.investmentOption,
            nfoEnabled: vm.schemeData.nfoEnabled,
            scheme: vm.schemeData.schemeName,
            schemeCode: vm.schemeData.schemeCode,
            schemeType: vm.schemeData.schemeType
          }
          if (vm.schemeData.investmentOption == "Dividend") {
            data.investmentOption = "DIVIDEND";
            data.dividendPayoutApplicable = "Y";
            data.dividendReinvestmentApplicable = "Y";
          } else {
            data.investmentOption = "GROWTH";
          }
        }
  
        $uibModalInstance.close(data);
      }
      vm.distinctArray = function (value) {
        vm.fil2 = new Set();
        var tem = [];
        value.forEach(function (el) {
          if (!vm.fil2.has(el) && el !="") {
            tem.push(el);
            vm.fil2.add(el);
          }
        });
        return tem;
      }
      vm.changewithFilterName = function(){
        vm.recFund = [];
        vm.otherFund = [];
        vm.masterFundList.forEach(function(el){
          if(el.fundName.toLowerCase().includes(vm.filterwithname.toLowerCase())){
            vm.recFund.push(el);
          }
        });
        vm.masterFundList2.forEach(function(el){
          if(el.fundName.toLowerCase().includes(vm.filterwithname.toLowerCase())){
            vm.otherFund.push(el);
          }
        });
      }
    }
  })();
  
(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('purchaseScheduleCancelController', purchaseScheduleCancelController);

    /** @ngInject */

    function purchaseScheduleCancelController($uibModalInstance,InvestorService, ModalService, $state, modalView, modalData,MessageService, AuthService, AppConstants) {
      var vm = this; 
      vm.view = modalView;
      // vm.modalData = modalData.data;
      vm.proceed = function(data){ 
        $uibModalInstance.close(data);
      } 
      vm.closeModal = function () {
        $uibModalInstance.close();
      };
      }
  })();
/**
 * Created by ttn on 03/24/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UnclaimedDividendModalController', unclaimedDividendModalController);

  /** @ngInject */
  function unclaimedDividendModalController($uibModalInstance, $log,toastr, modalData, LoaderService, modalView) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.unclaimedDividend = vm.modalData.unclaimedData.unClaimedDividends;
    vm.unClaimedRedemptions = vm.modalData.unclaimedData.unClaimedRedemptions;

    vm.closeModal = function (data) {
      $uibModalInstance.close(data);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

  }
})();

/**
 * Created by ttn on 03/24/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AddTaxResidencyModalController', addTaxResidencyModalController);

  /** @ngInject */
  function addTaxResidencyModalController($uibModalInstance, $log,toastr, modalData, LoaderService, modalView, ModalService, InvestorService, MessageService, AppConstants) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.processFlag = false;
    vm.getCountryList = getCountryList;
    vm.getTaxIdTypeList = getTaxIdTypeList;
    vm.addFatca = addFatca;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.countryList = [];
    vm.taxIdTypeList = [];

    var payload= {};

    vm.closeModal = function (data) {
      $uibModalInstance.close(data);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.init = function () {
      getCountryList();
      getTaxIdTypeList();
    };

    vm.confirmCancel = function () {
      var success = function () {
        vm.closeModal();
      };
      ModalService.confirmCancelModal({}, success);
    };

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
        $log.info("error====", err);
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
    }

    function getTaxIdTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdTypeList = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxIdTypeList = null;
        $log.info("error====", err);
      };
      InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success, error);
    }

    function addFatca() {
      payload = {
        country: vm.payload.birthCountry,
        taxIdType : vm.payload.taxIdType,
        taxIdNumber: vm.payload.taxIdNumber
      };
      var success = function (resp) {
        LoaderService.hideLoader('.loader');
        if (resp.status && resp.data) {
          vm.processFlag = false;
          if(resp.data.inserted){
            vm.closeModal(resp.data);
          }
          else{
            vm.dismissModal(resp.data.fatcaErrorMessage)
          }
        } else {
          if(resp && resp.message){
            var messages = resp.message + '<span class="' + Math.random() + '"></span>';
            toastr.error(messages, '', {
              allowHtml: true,
              preventDuplicates: false,
              onHidden: function () {
                vm.processFlag = false;
              }
            });
          } else {
            MessageService.error(resp.message);
          }
        }
      }, error = function (resp) {
        LoaderService.hideLoader('.loader');
        if(resp && resp.message){
          var messages = resp.message + '<span class="' + Math.random() + '"></span>';
          toastr.error(messages, '', {
            allowHtml: true,
            preventDuplicates: false,
            onHidden: function () {
              vm.processFlag = false;
            }
          });
        } else {
          MessageService.error(resp.message);
        }
      };
      vm.processFlag = true;
      LoaderService.showLoader('.loader');
      InvestorService.post({child1: 'profile', child2: 'add', child3: 'fatca'}, payload).$promise.then(success, error);
    }

  }
})();

/**
 * Created by ttn on 03/24/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AddFatcaTaxResidencyModalController', AddFatcaTaxResidencyModalController);

  /** @ngInject */
  function AddFatcaTaxResidencyModalController($uibModalInstance, $log,toastr, modalData, LoaderService, modalView, ModalService, InvestorService, MessageService, AppConstants) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.processFlag = false;
    vm.getCountryList = getCountryList;
    vm.getTaxIdTypeList = getTaxIdTypeList;
    vm.addFatca = addFatca;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.countryList = [];
    vm.taxIdTypeList = [];

    var payload= {};

    vm.closeModal = function (data) {
      $uibModalInstance.close(data);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.init = function () {
      getCountryList();
      getTaxIdTypeList();
    };

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.countryList = null;
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
    }

    function getTaxIdTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdTypeList = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.taxIdTypeList = null;
      };
      InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success, error);
    }

    function addFatca() {
      payload = {
        country: vm.payload.birthCountry,
        taxIdType : vm.payload.taxIdType,
        taxIdNumber: vm.payload.taxIdNumber
      };
      vm.closeModal(payload);
    }

  }
})();

/**
 * Created by ttn on 13/10/2023.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PrefillFolioModalController', prefillFolioModalController);

  /** @ngInject */
  function prefillFolioModalController($uibModalInstance, modalView, modalData, AppConstants) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.formData = {};
    vm.tForm = {};
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.folioList = null;
    vm.init = init;
    vm.folioChanged = folioChanged;
    init();

    function init() {
      vm.kycMessage = vm.modalData.kycMessage;
      vm.folioList = vm.modalData.folioList;
    }

    /*function getGoalFolioList() {
      LoaderService.showLoader();
      var success = function(resp) {
        if (resp.status && resp.data) {
          LoaderService.hideLoader();
          var folioList = [];
          vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
          if (resp.data.kycVerifiedFlag === false) {
            vm.kycMessage = resp.data.kycMessage;
          }
          Object.keys(resp.data.folioList).forEach(function (key) {
            var obj = Object.assign({key: key}, resp.data.folioList[key]);
            if (vm.modalData.minor) {
              if (obj.minorFlag) {
                folioList.push(angular.copy(obj));
              }
            } else if (vm.modalData.journey === "FOLIO_CREATION") {
              if (!obj.minorFlag) {
                folioList.push(angular.copy(obj));
              }
            } else  {
              if (!obj.minorFlag) {
                folioList.push(angular.copy(obj));
              }
            }
          });
          vm.folioList = folioList.length ? folioList : null;
        } else {
          LoaderService.hideLoader();
          vm.folioList = null;
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        vm.folioList = null;
        UtilService.errorHandler(err);
      };
      InvestorServiceVersionBasket3.get({
        child1: 'folio',
        child2: 'getFolioList'
      }).$promise.then(success, error);
    }*/

    function folioChanged() {
      if (!vm.formData.folioNumber) {
        return;
      }
      vm.selectedFolio = vm.folioList.filter(function(folio) {
        return folio.folioNumber === vm.formData.folioNumber;
      });
      sessionStorage.setItem('isMinorFolioSelected', vm.selectedFolio[0].minorFlag);
    }

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.closeModal = function () {
      $uibModalInstance.close(vm.formData.folioNumber);
    };

  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PopupsModalController', popupsModalController);

  /** @ngInject */
  function popupsModalController($uibModalInstance, $window, modalView, modalData, $state, ModalService,HDFC_API) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.openLink = function () {
      $window.open("https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf");
    };
    vm.redirectToAddBank = function () {
      if(vm.modalData && vm.modalData.folioDetailsData && vm.modalData.folioDetailsData.prospectFolio){
        ModalService.addBankCobmDisabled({isAddBank:false});
        $uibModalInstance.close();
      }
      else if(vm.modalData && vm.modalData.folioDetailsData && !vm.modalData.folioDetailsData.cobmEnabled) {
        ModalService.addBankCobmDisabled({isAddBank:true});
        $uibModalInstance.close();
      }
      else if (vm.modalData && vm.modalData.folioDetailsData.bankDetails && vm.modalData.folioDetailsData.bankDetails.length && vm.modalData.folioDetailsData.bankDetails.length >= 5) {
        ModalService.addBankMsg();
        $uibModalInstance.close();
      }
      else {
        $window.sessionStorage.setItem('bankConstraints', angular.toJson({
          isFromProfile: false,
          uploadChequeLeafEnabled: vm.modalData.folioDetailsData.uploadChequeLeafEnabled
        }));
        $state.go('main.addBank');
        $uibModalInstance.close();
      }
    }

    vm.paymentNavUrl = function (event) {
       event.preventDefault();
       $window.open(vm.paymentNavURL);
    };


    }
})();

/**
 * Created by ttn on 22/02/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AutoNextInputOtpVerificationController', autoNextInputOtpVerificationController);

  /** @ngInject */
  function autoNextInputOtpVerificationController($uibModalInstance, UtilService, modalView, modalData, LoaderService, TransactionService, MessageService, AppConstants,$rootScope,HDFC_API, $scope , InvestorService, $document, $timeout) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.otpForm = {};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.appConstants = AppConstants;
    vm.otpResendMessage = '';
    vm.isProcessing = false;
    vm.otpNumber = '';
    vm.comments = '';
    vm.otpValid=true;
    vm.incorrectOtpCounter=0;
    vm.appConstants = AppConstants;
    vm.stateIdentifier = null;
    vm.otpValIndex1 = '';
    vm.otpValIndex2 = '';
    vm.otpValIndex3 = '';
    vm.otpValIndex4 = '';
    vm.otpValIndex5 = '';
    vm.otpValIndex6 = '';
    var otpSubmitCount = 0;
    vm.isOtpValid = true;
    vm.otpValChanged = otpValChanged;
    vm.reGenerateOtp = reGenerateOtp;
    vm.otpVerification = otpVerification;
    vm.resetTimer = resetTimer;
    vm.init = init;

    function init() {
      bindEvent();
    }

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.continue = function () {
      $uibModalInstance.close('success');
    };

    function otpVerification() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            $uibModalInstance.close();
          } else {
            otpSubmitCount++;
            if (otpSubmitCount === 6 ) {
              vm.isOtpValid = false;
            }
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };
      var payload = {
        otp: vm.modalData.otp,
        id: vm.modalData.secretLink,
        folioNumber: vm.modalData.folioNumber,
        transactionType: vm.modalData.transactionType
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'transaction',
        child2: 'verify',
        child3: 'otp'
      }, payload).$promise.then(success, error);
    }

    function reGenerateOtp() {
      var success = function (resp) {
          LoaderService.hideLoader();
          vm.processFlag = false;
          if (resp.status && resp.data) {
            vm.OTPResendMsg = resp.data.message;
            resetTimer();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.processFlag = false;
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
      vm.payload = {
        id: vm.modalData.secretLink
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'transaction',
        child2: 'resend',
        child3: 'otp'
      }, vm.payload).$promise.then(success, error);
    }

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

    /*
    * This function handled all single otp digit
    * */
    function otpValChanged() {
      var num1 = angular.element($document[0].querySelector('#otp-number-input-1')).val();
      var num2 = angular.element($document[0].querySelector('#otp-number-input-2')).val();
      var num3 = angular.element($document[0].querySelector('#otp-number-input-3')).val();
      var num4 = angular.element($document[0].querySelector('#otp-number-input-4')).val();
      var num5 = angular.element($document[0].querySelector('#otp-number-input-5')).val();
      var num6 = angular.element($document[0].querySelector('#otp-number-input-6')).val();
      vm.modalData.otp = parseInt(num1 + num2 + num3 + num4 + num5 + num6);
      vm.otpCodeLength = vm.modalData.otp.toString().length;
      var container = document.getElementsByClassName("input-code")[0];
      container.onkeyup = function (e) {
        var target = e.target;
        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          var next = target;
          while (next && next.nextElementSibling) {
            if (next == null)
              break;
            if (next.tagName.toLowerCase() == "input") {
              next = next.nextElementSibling;
              next.focus();
              break;
            }
          }
        } else if (myLength < maxLength) {
          var prev = target;
          while (prev && prev.previousElementSibling) {
            if (prev == null)
              break

            if (prev.tagName.toLowerCase() == "input") {
              prev = prev.previousElementSibling;
              prev.focus();
              break;
            }
          }
        }
      }
      if (vm.otpCodeLength === 6) {
        var fieldsContainer = document.getElementsByClassName("input-code-container")[0];
        fieldsContainer.children[5].focus();
      }
    }

    function bindEvent() {
      $timeout(function() {
        var inputs = document.querySelectorAll(".input-code-container input");
        inputs.forEach(function(input, index) {
          input.addEventListener("paste", function(e) {
            e.preventDefault();
            var data = e.clipboardData.getData("text");
            var value = data.split("");
            if (value.length === inputs.length) {
              inputs.forEach(function(input, index) {
                input.value = value[index];
                otpValChanged();
              });
            }
          });
        });
      });
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('OtpVerificationConfirmModalController', otpVerificationConfirmModalController);

  /** @ngInject */
  function otpVerificationConfirmModalController($uibModalInstance, modalView, modalData, LoaderService, TransactionService, MessageService, AppConstants,$rootScope,HDFC_API, $scope , InvestorService, OtpTransactionService,AuthService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.STEPS = vm.modalData.STEPS;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.close = function (data) {
      $uibModalInstance.close(data ? data:'success');
    };
    vm.removePan = function(){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {  
          vm.close(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
      }, failure = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.data.message);
      };
      if(vm.modalData.data.type == 'MY_PAN'){
        var payload = { 
          "myPan": AuthService.encryptRSA(angular.copy(vm.modalData.data.panNumber)),
          "linkedPan": AuthService.encryptRSA(angular.copy(vm.modalData.data.myPan)),  
          "linkDeLinkFlag": "MY_PAN"
        }
      }
      if(vm.modalData.data.type == 'LINKED_PAN'){
        var payload = {
          "myPan": AuthService.encryptRSA(angular.copy(vm.modalData.data.myPan)), 
          "linkedPan": AuthService.encryptRSA(angular.copy(vm.modalData.data.panNumber)),  
          "linkDeLinkFlag": "LINKED_PAN"
        }
      }
      LoaderService.showLoader();
      InvestorService.post4({ child1: 'switch', child2: 'user', child3: 'remove', child4: 'linked',child5:'pan'},payload).$promise.then(success, failure);
    }
  }
})();

/**
 * Created by ttn on 22/02/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NomineeUpdateVerificationModalController', nomineeUpdateVerificationModalController);

  /** @ngInject */
  function nomineeUpdateVerificationModalController($uibModalInstance, UtilService, modalView, modalData, LoaderService, TransactionService, MessageService, AppConstants,$rootScope,HDFC_API, $scope , InvestorService, OtpTransactionService, InvestorServiceV2) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.otpForm = {};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.otpResendMessage = '';
    vm.isProcessing = false;
    vm.otpNumber = '';
    vm.comments = '';
    vm.otpValid=true;
    vm.incorrectOtpCounter=0;
    vm.appConstants = AppConstants;
    var version = $rootScope.apiVersion?$rootScope.apiVersion : HDFC_API.VERSION;
    vm.stateIdentifier = null;
    vm.checkValidateDOB = checkValidateDOB;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.continue = function () {
      $uibModalInstance.close('success');
    };

    vm.confirmTransaction = function () {
      if (!vm.otpNumber) {
        MessageService.error(vm.validateData.OTP_REQUIRED);
        return;
      }
      vm.isProcessing = true;
      LoaderService.showLoader('.popup');
      var payload = {
        "otp": vm.otpNumber,
        "uniqueLink": vm.modalData.uniqueLink
      };
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {

            $uibModalInstance.close(resp.data);
          } else {

            vm.incorrectOtpCounter+=1;
            if(vm.incorrectOtpCounter==6){
              vm.otpValid=false;
            }
            MessageService.error(resp.message)
          }
          vm.isProcessing = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          vm.isProcessing = false;
          UtilService.errorHandler(err);
        };
      var config = {};
      if (vm.modalData.summaryType === "folio-creation") {
        config = {
          controller1: 'folio',
          controller2: 'any-or-survivor',
          controller3: 'folio',
          controller4: 'holder',
          controller5: 'otp',
          controller6: 'confirm'
        };
      } else {
        config = {
          controller1: 'transaction',
          controller2: 'otp',
          controller3: 'confirm'
        };
      }
      OtpTransactionService.post(config, payload).$promise.then(success, error);
    };

    vm.resendOtp = function () {
      LoaderService.showLoader();
      vm.isProcessing = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.otpResendMessage = 'OTP sent again successfully.';
            resetTimer();
          } else {
            vm.otpResendMessage = '';
            MessageService.error(resp.message)
          }
          vm.isProcessing = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.otpResendMessage = '';
          vm.isProcessing = false;
          UtilService.errorHandler(err);
        };
      var config = {};
      if (vm.modalData.summaryType === "folio-creation") {
        config = {
          controller1: 'transaction',
          controller2: 'otp',
          controller3: vm.modalData.uniqueLink,
          controller4: true
        }
      }  else if (vm.modalData.summaryType === 'NOMINEE_UPDATE' && vm.modalData.isSebiRegActive) {
        config = {
          child1: 'transaction',
          child2: 'otp',
          child3: 'NOMINEEADDUPDATE',
          child4: 'confirm',
        }
      } else {
        config = {
          controller1: 'transaction',
          controller2: 'otp',
          controller3: vm.modalData.uniqueLink
        }
      }

      if (vm.modalData.isSebiRegActive) {
        InvestorServiceV2.get(config, {
          uniqueLink : vm.modalData.uniqueLink
        }).$promise.then(success, error);
      } else {
        TransactionService.get2(config, null).$promise.then(success, error);
      }

    };

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

    vm.confirmOtpUpdateNominee = function () {
      if (!vm.otpNumber) {
        MessageService.error(vm.validateData.OTP_REQUIRED);
        return;
      }
      vm.isProcessing = true;
      LoaderService.showLoader('.popup');
      var payload = {
        "uniqueLink": vm.modalData.uniqueLink,
        "otp": vm.otpNumber,
        "dob": vm.dob
      };
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message)
          }
          vm.isProcessing = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          vm.isProcessing = false;
          UtilService.errorHandler(err);
        };
      var config = {};
      if(vm.modalData.summaryType === "NOMINEE_UPDATE") {
        config = {
          child1: 'transaction',
          child2: 'otp',
          child3: 'NOMINEEADDUPDATE',
          child4: 'confirm'
        }
      } else if(vm.modalData.summaryType == "NOMINEE_OPT_OUT"){
        config = {
          child1: 'transaction',
          child2: 'otp',
          child3: 'OPTOUTNOMINEE',
          child4: 'confirm'
        }
      }else {
        config = {
          child1: 'folio',
          child2: 'any-or-survivor',
          child3: 'folio',
          child4: 'holder',
          child5: 'otp',
          child6: 'confirm'
        }
      }
      InvestorService.post(config, payload).$promise.then(success, error);
    };

    vm.resendOtpNomineeUpdate = function () {
      LoaderService.showLoader();
      vm.isProcessing = true;
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.otpResendMessage = 'OTP sent again successfully.';
              resetTimer();
            } else {
              vm.otpResendMessage = '';
              MessageService.error(resp.message)
            }
            vm.isProcessing = false;
          },
          error = function (err) {
            LoaderService.hideLoader();
            vm.otpResendMessage = '';
            vm.isProcessing = false;
            UtilService.errorHandler(err);
          };
        var config = {};
        if(vm.modalData.summaryType == "NOMINEE_UPDATE" || vm.modalData.summaryType == "NOMINEE_OPT_OUT"){
          config = {
            child1: 'nominee',
            child2: 'resendOTP',
            child3: vm.modalData.summaryType,
            child4:  vm.modalData.uniqueLink
          }
        }else {
          config = {
            controller1: 'transaction',
            controller2: 'otp',
            controller3: vm.modalData.uniqueLink,
            controller4: true
          }
        }
        if(vm.modalData.summaryType == "NOMINEE_UPDATE" || vm.modalData.summaryType == "NOMINEE_OPT_OUT") {
          InvestorService.get(config, null).$promise.then(success, error);
        } else {
          TransactionService.get2(config, null).$promise.then(success, error);
        }

    };

    function checkValidateDOB(dob){
      if(vm.appConstants.DOB_FORMAT_REGEX.test(dob)){
        var parts = dob.split("/");
        var dtDOB = new Date(parts[1] + "/" + parts[0] + "/" + parts[2]);
        var dtCurrent = new Date();
        vm.dateValidationErrorMsg = vm.validateData.DOB_MAJOR_MSG;
        if (dtCurrent.getFullYear() - dtDOB.getFullYear() < 18) {
          return false;
        }
        if (dtCurrent.getFullYear() - dtDOB.getFullYear() == 18) {

          //CD: 11/06/2018 and DB: 15/07/2000. Will turned 18 on 15/07/2018.
          if (dtCurrent.getMonth() < dtDOB.getMonth()) {
            return false;
          }
          if (dtCurrent.getMonth() == dtDOB.getMonth()) {
            //CD: 11/06/2018 and DB: 15/06/2000. Will turned 18 on 15/06/2018.
            if (dtCurrent.getDate() < dtDOB.getDate()) {
              return false;
            }
          }
        }
        vm.dateValidationErrorMsg = "";
        return true;
      } else {
        if(dob){
          vm.dateValidationErrorMsg = vm.validateData.DOB_FORMAT
        }else{
          vm.dateValidationErrorMsg = "";
        }
      }
    }
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('OtpModalController', otpModalController);

  /** @ngInject */
  function otpModalController($uibModalInstance, $timeout, $scope, $log, AppConstants, MessageService, LoaderService, modalData, modalView, InvestorService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.contact = vm.modalData.contact;
    vm.email = vm.modalData.email;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.otpResendMessage = '';
    vm.formData = {};
    vm.modalOtpForm = {};

    vm.closeModal = function (message) {
      $uibModalInstance.close(message);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.resetValues = function () {
      vm.errorMessage = "";
    };

    vm.verifyOtp = function () {
      if (vm.modalData.text == 'Email Address') {
        vm.verifyOtpforEmail();
      } else if (vm.modalData.text == 'Folio Update Details') {
        vm.verifyOtpforFolioEmail();
      } else {
        vm.otpResendMessage = '';
        vm.verifyOtpforContact();
      }
    };

    vm.verifyOtpforEmail = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.closeModal(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
        vm.processFlag = false;
      }, error = function () {
        LoaderService.hideLoader();
        vm.processFlag = false;
        vm.errorMessage = AppConstants.ToastrMessage.FAILED;
      };
      var payload = {
        "otp": vm.formData.newOtpNumber
      };
      if (vm.formData.otpNumber) {
        payload.secondOtp = vm.formData.otpNumber;
      }
      LoaderService.showLoader();
      vm.errorMessage = '';

      InvestorService.post({
        child1: 'profile',
        child2: 'edit',
        child3: 'verify',
        child4: 'otp'
      }, payload).$promise.then(success, error);
    };
    vm.verifyOtpforFolioEmail = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.closeModal(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
        vm.processFlag = false;
      }, error = function () {
        LoaderService.hideLoader();
        vm.processFlag = false;
        vm.errorMessage = AppConstants.ToastrMessage.FAILED;
      };
      var payload = {
        "otp": vm.formData.newOtpNumber,
        "isThisForFolioUsedForRegistration": "false",
        "folioNumber": vm.modalData.folioNo
      };
      if (vm.formData.otpNumber) {
        payload.secondOtp = vm.formData.otpNumber;
      }
      LoaderService.showLoader();
      vm.errorMessage = '';

      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'edit',
        child4: 'verify',
        child5: 'otp'
      }, payload).$promise.then(success, error);
    };

    vm.verifyOtpforContact = function () {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.closeModal(resp.data.message);
        } else {
          //vm.errorMessage = resp.message;
          MessageService.error(resp.message);
        }
        vm.processFlag = false;
      }, error = function () {
        vm.processFlag = false;
        vm.errorMessage = AppConstants.ToastrMessage.FAILED;
      };
      var payload = {
        "otp": vm.formData.newOtpNumber
      };
      if (vm.formData.otpNumber) {
        payload.secondOtp = vm.formData.otpNumber;
      }
      vm.errorMessage = '';
      vm.processFlag = true;
      InvestorService.post({
        child1: 'profile',
        child2: 'edit',
        child3: 'verify',
        child4: 'otp'
      }, payload).$promise.then(success, error);
    };

    vm.resendOtp = function () {
      if (vm.modalData.text == "Folio Update Details") {
        vm.resendFolioOtp();
      } else {
        vm.resendDefaultOtp();
      }
    };
    vm.resendDefaultOtp = function () {
      if(vm.formData){
        vm.formData.otpNumber = '';
        vm.formData.newOtpNumber = '';
      }
      vm.modalOtpForm.otpNumber.$setPristine(false);
      vm.modalOtpForm.newOtpNumber.$setPristine(false);
      var success = function (resp) {
        LoaderService.hideLoader('.loader');
        if (resp && resp.data) {
          vm.processOTPFlag = false;
          vm.otpResendMessage = resp.data.message;
          resetTimer();
        } else {
          vm.processOTPFlag = true;
          vm.errorMessage = resp && resp.data.message || AppConstants.ToastrMessage.FAILED;
          //MessageService.error(resp.data.message || AppConstants.ToastrMessage.FAILED);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.loader');
        vm.processOTPFlag = false;
        //vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
        MessageService.error(AppConstants.ToastrMessage.FAILED);
        $log.info('Error:', err);
      };
      vm.inputReset = true;
      $timeout(function () {
        vm.inputReset = false;
      });
      vm.errorMessage = '';
      vm.processOTPFlag = true;
      vm.otpResendMessage = '';
      LoaderService.showLoader('.loader');
      InvestorService.get({
        child1: 'profile',
        child2: 'edit',
        child3: 'resend',
        child4: 'otp'
      }).$promise.then(success, error);
    };
    vm.resendFolioOtp = function () {
      if(vm.formData){
        vm.formData.otpNumber = '';
        vm.formData.newOtpNumber = '';
      }
      vm.modalOtpForm.otpNumber.$setPristine(false);
      vm.modalOtpForm.newOtpNumber.$setPristine(false);
      var success = function (resp) {
        LoaderService.hideLoader('.loader');
        if (resp && resp.data) {
          vm.processOTPFlag = false;
          vm.otpResendMessage = resp.data.message;
          resetTimer();
        } else {
          vm.processOTPFlag = true;
          vm.errorMessage = resp && resp.data.message || AppConstants.ToastrMessage.FAILED;
          //MessageService.error(resp.data.message || AppConstants.ToastrMessage.FAILED);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.loader');
        vm.processOTPFlag = false;
        //vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
        MessageService.error(AppConstants.ToastrMessage.FAILED);
        $log.info('Error:', err);
      };
      var payload = {
        "folioNumber": vm.modalData.folioNo
      };
      vm.inputReset = true;
      $timeout(function () {
        vm.inputReset = false;
      });
      vm.errorMessage = '';
      vm.processOTPFlag = true;
      vm.otpResendMessage = '';
      LoaderService.showLoader('.loader');
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'edit',
        child4: 'resend',
        child5: 'otp'
      }, payload).$promise.then(success, error);
    };
    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TnitiateTransactionModalController', initiateTransactionModalController);

  /** @ngInject */
  function initiateTransactionModalController($uibModalInstance, UtilService, modalView, modalData, LoaderService, TransactionService, MessageService, AppConstants,$rootScope,HDFC_API, $scope , InvestorService, OtpTransactionService,investorServiceVersion,AuthService,$stateParams,InvestorServiceV2) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.otpForm = {};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.otpResendMessage = '';
    vm.isProcessing = false;
    vm.otpNumber = '';
    vm.comments = '';
    vm.otpValid=true;
    vm.incorrectOtpCounter=0;
    vm.taxIdentifierNumber = "";
    vm.dob=null;
    vm.appConstants = AppConstants;
    var version = $rootScope.apiVersion?$rootScope.apiVersion : HDFC_API.VERSION;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.continue = function () {
      $uibModalInstance.close('success');
    };

    vm.confirmTransaction = function () {
      if (!vm.otpNumber) {
        MessageService.error(vm.validateData.OTP_REQUIRED);
        return;
      }
      vm.isProcessing = true;
      LoaderService.showLoader('.popup');
      var payload = {
        "otp": vm.otpNumber,
        "uniqueLink": vm.modalData.uniqueLink
      };
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.status && resp.data) {

          $uibModalInstance.close(resp.data);
        } else {

          vm.incorrectOtpCounter+=1;
          if(vm.incorrectOtpCounter==6){
            vm.otpValid=false;
          }
          MessageService.error(resp.message)
        }
        vm.isProcessing = false;
      },
      error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.isProcessing = false;
        UtilService.errorHandler(err);
      };
      var config = {};
      if (vm.modalData.summaryType === "folio-creation") {
        config = {
          controller1: 'folio',
          controller2: 'any-or-survivor',
          controller3: 'folio',
          controller4: 'holder',
          controller5: 'otp',
          controller6: 'confirm'
        };
      } else if(vm.modalData.summaryType === "one-click-schedule-purchase"){
        config = {
          controller1: 'gigworker',
          controller2: 'transaction',
          controller3: 'otp',
          controller4: 'confirm'
        };
      } else {
        config = {
          controller1: 'transaction',
          controller2: 'otp',
          controller3: 'confirm'
        };
      }
      OtpTransactionService.post(config, payload).$promise.then(success, error);
    };

    vm.resendOtp = function () {
      LoaderService.showLoader();
      vm.isProcessing = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if(vm.modalData.summaryType === "one-click-schedule-purchase"){
              vm.modalData.id = resp.data.secretLink;
              sessionStorage.setItem('OTPSecrateLink',resp.data.secretLink);
              vm.modalData.folioNumber = resp.data.folioNumber;
            }
            vm.otpResendMessage = 'OTP sent again successfully.';
            resetTimer();
          } else {
            vm.otpResendMessage = '';
            MessageService.error(resp.message)
          }
          vm.isProcessing = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.otpResendMessage = '';
          vm.isProcessing = false;
          UtilService.errorHandler(err);
        };
      var config = {};
      if (vm.modalData.summaryType === "folio-creation") {
        config = {
          controller1: 'transaction',
          controller2: 'otp',
          controller3: vm.modalData.uniqueLink,
          controller4: true
        }
      }else if(vm.modalData.summaryType === "one-click-schedule-purchase"){
        InvestorService.post({ child1: "gigworker", child2: "sendOtp", child3: $stateParams.uniqueLink}, {}).$promise.then(success, error);
        return;
      } else {
        config = {
          controller1: 'transaction',
          controller2: 'otp',
          controller3: vm.modalData.uniqueLink
        }
      }
      TransactionService.get2(config, null).$promise.then(success, error);
    };

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

    vm.confirmOtpUpdateNominee = function () {
      if (!vm.otpNumber) {
        MessageService.error(vm.validateData.OTP_REQUIRED);
        return;
      }
      vm.isProcessing = true;
      LoaderService.showLoader('.popup');
      var payload = {
        "otpNumber": vm.otpNumber,
        "secretLink": vm.modalData.uniqueLink,
        "folioNumber": vm.modalData.folioNumber
      };
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.status && resp.data) {
          $uibModalInstance.close(resp.data);
        } else {
          MessageService.error(resp.message)
        }
        vm.isProcessing = false;
      },
      error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.isProcessing = false;
        UtilService.errorHandler(err);
      };
      var config = {};
      if(vm.modalData.summaryType === "fromOptOutOfNomination") {
        config = {
          child1: 'profile',
          child2: 'opt-out',
          child3: 'otp',
          child4: 'confirm'
        }
        payload = {
          "otp": vm.otpNumber,
          "secretLink": vm.modalData.uniqueLink,
          "folioNumber": vm.modalData.folioNumber
        }
      } else{
          config = {
            child1: 'profile',
            child2: 'nominee',
            child3: 'verifyOTP'
          }
      }

      if (vm.modalData.showNomineeUpdate) {
        InvestorServiceV2.post(config, payload).$promise.then(success, error);
      } else {
        InvestorService.post(config, payload).$promise.then(success, error);
      }

    };

    vm.resendOtpNomineeUpdate = function () {
      LoaderService.showLoader();
      vm.isProcessing = true;
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.otpResendMessage = 'OTP sent again successfully.';
              resetTimer();
            } else {
              vm.otpResendMessage = '';
              MessageService.error(resp.message)
            }
            vm.isProcessing = false;
          },
          error = function (err) {
            LoaderService.hideLoader();
            vm.otpResendMessage = '';
            vm.isProcessing = false;
            UtilService.errorHandler(err);
          };
        var config = {}, payload = null;
        if(vm.modalData.summaryType == "fromOptOutOfNomination"){
          config = {
            child1: 'nominee',
            child2: 'resendOTP',
            child3: 'NOMINEE_OPT_OUT',
            child4:  vm.modalData.uniqueLink
          }
        }else {
          config = {
            child1: 'profile',
            child2: 'nominee',
            child3: 'resendOTP',
            child4:  vm.modalData.uniqueLink
          }
        }

        if (vm.modalData.showNomineeUpdate) {
          InvestorServiceV2.get(config, payload).$promise.then(success, error);
        } else {
          InvestorService.get(config, payload).$promise.then(success, error);
        }

    };

    vm.makeTransaction = function () {
      AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
      var successLogin = function (resp) {
        $uibModalInstance.close(resp);
      }, errorLogin = function (error) {
        LoaderService.hideLoader();
        MessageService.error(error.message);
      }
      var oauthpayload = {
        folioNumber: vm.modalData.folioNumber,
        secretLink: vm.modalData.id,
        otp:vm.otpNumber,
        grant_type :'password',
        panNumber: vm.taxIdentifierNumber?AuthService.encryptRSA(angular.copy(vm.taxIdentifierNumber)):""
      };
      LoaderService.showLoader();
      AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);
    }
    vm.changeStartDate = function(date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.dob = date;
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';
      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.dob = "";
      }
      return;
    }
    vm.autoDate = function() {
      var oldlength = 0 ;
      if(vm.dobString){
        oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
    }
    vm.confirmTransactionONE = function () {
      if (!vm.otpNumber) {
        MessageService.error(vm.validateData.OTP_REQUIRED);
        return;
      }
      vm.isProcessing = true;
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.invalidPanDob = false;
          if (resp.data.ekycRequestCO) {
              // sessionStorage.setItem("ekycRequestCO", JSON.stringify(resp.data.ekycRequestCO));
              // ModalService.arnPopupModal(
              //     { status: "NOT_VERIFIEDNEW" },
              //     function () { }, function () { }
              // );
              MessageService.error("KYC not verifyed.");
          }
          // for existing user
          if (resp.data.registrationType == "EXISTING" || resp.data.registrationType == "EXISTING_REGISTERED" || resp.data.registrationType == "NEW_REGISTERED") {
            if(vm.modalData.summaryType === "one-click-schedule-purchase"){
              sessionStorage.setItem('scheduleSecretLink',$stateParams.purchaseSchedular);
            }
            vm.makeTransaction();
          }
          // for new user
          if (resp.data.registrationType == "NEW") {
            MessageService.error("This PAN is not registred as a investor.");
          }
        } else {
          var bannedCountry = resp.message.match('includes banned country');
          if (bannedCountry) {
              vm.panMessage = "Unable to proceed since address in your KYC includes banned country name.";
              vm.invalidPanDob = true;
          } else {
              vm.invalidPanDob = true;
              vm.panMessage = resp.message;
          }
        }
      },error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.isProcessing = false;
        UtilService.errorHandler(err);
      };
      var payload = {
        dob: vm.dob.format('DD-MMM-YYYY'),
        panNumber: vm.taxIdentifierNumber
      };
      investorServiceVersion.post({
        child1: 'registration',
        child2: 'verifyKYC'
      }, payload).$promise.then(success, error);
    };
  }
})();

/**
 * Created by ttn on 15/02/23.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('OptOutNomineeModalController', optOutNomineeModalController);

  /** @ngInject */
  function optOutNomineeModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.oneClickNomineeoptout = false;
    if(vm.modalData.OneClickHdfcCheque){
      vm.oneClickNomineeoptout = true;
      vm.foliNumber = vm.modalData.folio;
    }
    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
  }
})();

/**
 * Created by ttn on 26/14/21.
 */

(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('OneClickPanAadharStatusController', oneClickPanAadharStatusController);
  
    /** @ngInject */
    function oneClickPanAadharStatusController($uibModalInstance,$state,$window, modalView, modalData, ModalService, LoaderService, TransactionService, UtilService, MessageService, InvestorService) {
        var vm = this;
        vm.view = modalView;
        vm.modalData = modalData;
        vm.closeModal = function () {
            $uibModalInstance.close();
        };
        vm.dismissModal = function () {
          $uibModalInstance.dismiss();
        };
    }
  })();
  
/*
* Created by ttn at 23/09/2020
* */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('OfflineNomineeFormController', OfflineNomineeFormController);

  /** @ngInject */
  function OfflineNomineeFormController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

/**
 * Created by ttn on 26/14/21.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NudgeReasonsController', nudgeReasonsController);

  /** @ngInject */
  function nudgeReasonsController($uibModalInstance,$state,$window, modalView, modalData, ModalService, LoaderService, TransactionService, UtilService, MessageService, InvestorService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.approveRedemption = approveRedemption;
    vm.approveSipCancel = approveSipCancel;
    vm.stayInvested = stayInvested;
    vm.nudgePopupData = {};
    showReasons();
    vm.nudgeReason = '';
    vm.nudgeReasonChange = nudgeReasonChange;
    vm.reasonsList = [];
    vm.showSipNudge = false;
    vm.placeHolderText = "Enter reason... Only upto 100 characters";
    vm.maxLength = 100;

    function showReasons() {
      var success = function(resp) {
        if ((vm.modalData.transactionType === 'SIP' || vm.modalData.transactionType === 'DREAMSIP' || vm.modalData.transactionType === 'FLEXSIP')) {
          if (resp.status && resp.data && angular.isDefined(resp.data.popUpDescriptionList.SIP_CANCELLATION_NUDGE_REASONS)) {
            vm.nudgePopupData = resp.data.popUpDescriptionList;
            vm.reasonsList = vm.nudgePopupData.SIP_CANCELLATION_NUDGE_REASONS.sipCancellationReasons;
            vm.showSipNudge = true;
            vm.maxLength = 200;
            vm.placeHolderText = "Enter reason... Only upto 200 characters";
          } else {
            approveSipCancel();
          }
        } else if(resp.status && resp.data && angular.isDefined(resp.data.popUpDescriptionList.REASONS)) {
          vm.nudgePopupData = resp.data.popUpDescriptionList;
          vm.reasonsList = vm.nudgePopupData.REASONS.reasonsList;
        } else if(resp.status && resp.data && angular.isUndefined(resp.data.popUpDescriptionList.REASONS)){
          approveRedemption();
        }
        else {
        MessageService.error("Somthing went wrong");
        }


      },
        error = function (err) {
          UtilService.errorHandler(err);
        };
        if(vm.modalData.transactionType === 'REDEMPTION' && localStorage.getItem('popupDisable') === null)
        {
          var valPayload = {
              "folioNumber":vm.modalData.folioNumber,
             "schemeCode":vm.modalData.schemeCode,
              "transactionType": vm.modalData.transactionType
            };
            if(vm.modalData.scheduledRedemption === true) {
              TransactionService.post({
                controller1: 'nudge',
                controller2: 'popup',
                controller3: 'scheduleRedemption'
              }, valPayload ).$promise.then(success, error);
            } else {
              TransactionService.post({
                controller1: 'nudge',
                controller2: 'popup'
              }, valPayload).$promise.then(success, error);
            }
         }
          else{
            localStorage.removeItem('popupDisable');
            TransactionService.get({
              controller1: 'nudge',
              controller2: 'popup'
            }).$promise.then(success, error);
          }

    }

    function nudgeReasonChange(reason) {
      if (vm.showSipNudge) {
        vm.nudgeReason = reason.reasonDetail;
        vm.nudgeReasonCode = reason.reasonCode;
      } else {
        vm.nudgeReason = reason;
      }
    }

    vm.closeModal = function (resp) {
      $uibModalInstance.close(resp);
    };

    vm.dismissModal = function () {
      LoaderService.hideLoader();
      $uibModalInstance.close('cancel');
    };

    function approveRedemption() {
      var data = {
        nudgeReason:vm.nudgeReason
      }
      if(vm.nudgeReason === 'Other'){
        data.nudgeOtherReason = vm.nudgeOtherReason;
      }
      if(vm.modalData.scheduledRedemption) {
        data.key = 'approveScheduleRedeem';
        vm.closeModal(data);
      } else {
        data.key = 'approveRedeem';
        vm.closeModal(data);
      }
    }

    function approveSipCancel($event) {
      if ($event) {
        $event.currentTarget.disabled = true;
        vm.modalData.payload.reasons = vm.nudgeReason;
        vm.modalData.payload.reasonCode = vm.nudgeReasonCode;
        if(vm.nudgeReason === 'Others'){
          vm.modalData.payload.nudgeOtherReason = vm.nudgeOtherReason;
        }
      }
      $uibModalInstance.close();
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.summaryDetails = resp.data.review;
            if (vm.summaryDetails.subTrxnType && vm.summaryDetails.subTrxnType === 'FS') {
              vm.summaryDetails.type = 'Flex SIP';
              vm.summaryDetails.tenureDiff = moment(vm.summaryDetails.toDate,"DD-MMM-YYYY").diff(moment(vm.summaryDetails.fromDate,"DD-MMM-YYYY"), 'years') + 1;
            }
            localStorage.setItem('summaryDetails', $window.JSON.stringify(vm.summaryDetails));
            $state.go('main.sipCancellationDetails');
            vm.closeModal();
          } else {
            LoaderService.hideLoader();
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              });
            } else {
              MessageService.error(resp.message);
            }
            vm.dismissModal();
          }
        },
        error = function (err) {
          if ($event) {
            $event.currentTarget.disabled = false;
          }
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          $state.go('main.systematicCorner');
        };

      InvestorService.post({
        child1:'transaction',
        child2: 'cancel'
      }, vm.modalData.payload).$promise.then(success, error);
    }

    function stayInvested() {
      vm.closeModal('stay');
    }
  }
})();

/**
 * Created by ttn on 13/03/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NomineeUpdateNotificationModalController', nomineeUpdateNotificationModalController);

  /** @ngInject */
  function nomineeUpdateNotificationModalController(UtilService, $uibModalInstance, modalView, modalData, MessageService, InvestorService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.init = function () {};

  }
})();

/**
 * Created by ttn on 29/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NotificationModalController', notificationModalController);

  /** @ngInject */
  function notificationModalController(UtilService, $uibModalInstance, modalView, modalData, MessageService, InvestorService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.notificationDetails = null;

    vm.closeModal = function () {
      $uibModalInstance.close('close');
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.init = function () {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.notificationDetails = resp.data;
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      InvestorService.post({
        child1: 'notification',
        child2: 'detail'
      }, {id: vm.modalData.id}).$promise.then(success, error);
    };

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller(  'NonTransactionalTncModalController', nonTransactionalTncModalController);

  /** @ngInject */
  function nonTransactionalTncModalController($uibModalInstance, modalView, modalData, ModalService ,UtilService ,MessageService,HDFC_API) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.showTerms = true;

    vm.init = function() {
        var successHandler = function(resp) {
          if(!resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General) {
            vm.showTerms = false;
          }
        }

        UtilService.fetchDynamicData("INNER_TNC").then(successHandler).catch(function(resp) {
          MessageService.error(resp)
        });
    }

    vm.init();

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.showGeneralTnc = function () {
      if(vm.showTerms) {
        ModalService.termConditionModal();
      }
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NfoTransactionNotesModalController', NfoTransactionNotesModalController);

  NfoTransactionNotesModalController.$inject = ['$uibModalInstance', 'modalView', 'modalData'];
  /** @ngInject */
  function NfoTransactionNotesModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NfoEnabledModalController', nfoEnabledModalController);

  /** @ngInject */
  function nfoEnabledModalController($uibModalInstance, modalView, modalData, AppConstants) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.message = AppConstants.ToastrMessage.VALIDATE_DATA;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NewJourneyRegisterModalController', NewJourneyRegisterModalController);

  /** @ngInject */
  function NewJourneyRegisterModalController($uibModalInstance, modalData, modalView) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ModifyBankModalController', modifyBankModalController);

  /** @ngInject */
  function modifyBankModalController($window, $uibModalInstance,  $state, modalView, modalData,LoaderService, InvestorFileUploadService, ModalService, MessageService, UtilService, InvestorService, investorServiceVersion) {

    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.selectedDefault = 0;
    vm.chooseAFile = false;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.chequeLeafUrl = '';
    vm.changeModifyDefaultBank = changeModifyDefaultBank;
    vm.changeDeleteBank = changeDeleteBank;
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.openUploadedDoc = openUploadedDoc;

    vm.folioId = (vm.modalData)?vm.modalData.modalPayload.folioNumber:undefined;
    vm.bankDetails = (vm.modalData)?vm.modalData.modalPayload.bankDetails:undefined;
    vm.requestType = vm.modalData.requestType;
    // var identifierData = AuthService.getToken();
    var bankdetails = [];
    for(var i in vm.bankDetails){
      if(!vm.bankDetails[i].defaultBank){
        bankdetails.push(vm.bankDetails[i]);
      }
    }

    if(vm.requestType == 'modify'){
      vm.selectedModifyBank = bankdetails[0];
      changeModifyDefaultBank(vm.selectedModifyBank);
    }
    else if (vm.requestType == 'delete'){
      vm.selectedDeleteBank = bankdetails[0];
      changeDeleteBank(vm.selectedDeleteBank);
    }

    vm.closeModal = function () {
      localStorage.removeItem('bankDetails');
      $uibModalInstance.close();
      $state.go('main.profile.folioDetails');
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    function changeDeleteBank (banks) {
      if(angular.isUndefined(banks)){return;}
      vm.deleteBank = {};
      vm.deleteBank.payload = {
        //bankAccountNumber: banks.accountNumber,
        folioNumber: vm.folioId,
        accountType:banks.accountType,
        payoutMechanism:banks.payoutMethod,
        accountNumber:banks.accountNumber,
        ifsccode:banks.ifscCode,
        bankCity:banks.branchCity,
        bankBranch: banks.branchName || '',
        makeDefaultBank: false,
        bankName: banks.bankName,
        payoutId:modalData.modalPayload.bankDetails[0].payoutId
      };
    }

    function deleteBankSuccess(modalPayload){
      ModalService.deleteBankSuccessModal({modalPayload : modalPayload, requestType:'delete'});
    }

    vm.submitDeleteBank = function () {
      var success = function (res) {
        LoaderService.hideLoader('.deleteBank-loader');
        if(res.status){
          vm.closeModal();
          deleteBankSuccess(vm.modalData.modalPayload);
        }
        else{
          if(res.popupEnabled) {
            ModalService.genericModal({
              text: res.message
            });
            vm.closeModal();
          } else {
            MessageService.error(res.message);
            vm.closeModal();
          }
        }
      };
      var error = function (err) {
        LoaderService.hideLoader('.deleteBank-loader');
        UtilService.errorHandler(err);
      };
      /*vm.fd = new FormData();
      vm.fd.append('bankCO', $window.JSON.stringify(vm.deleteBank.payload));*/
      /*var files = [vm.fileNew,vm.fileOld];
       vm.fd.append('proofs', files);*/
      /*vm.fd.append('bankProof', vm.fileNew);*/
      LoaderService.showLoader('.deleteBank-loader');
      investorServiceVersion.post({child1:'folio',child2:'bank',child3:'delete'}, vm.deleteBank.payload).$promise.then(success,error);
    };

    function uploadChequeLeafFile(file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        vm.closeModal();
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          vm.fileNew = file;
          vm.deleteBank.payload.chequeLeaf = file.name;
          vm.chooseAFile = false;
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
          vm.chooseAFile = false;
          vm.closeModal();
        }
      }

    }

    function openUploadedDoc() {
      // window.open(vm.deleteBank.payload.chequeLeaf);
      if(angular.isUndefined(vm.deleteBank.payload.chequeLeaf)){return;}
      ModalService.showImage({docUrl: vm.deleteBank.payload.chequeLeaf});
    }

     function changeModifyDefaultBank(banks) {
       if(angular.isUndefined(banks)){return;}
       vm.changeDefaultBank = {};
      vm.changeDefaultBank.payload = {
        bankAccountNumber: banks.accountNumber,
        folioNumber: vm.folioId,
        accountType:banks.accountType,
        payoutMechanism:banks.payoutMethod,
        accountNumber:banks.accountNumber,
        ifsccode:banks.ifscCode,
        bankCity:banks.branchCity,
        bankBranch: banks.branchName || '',
        makeDefaultBank: true,
        bankName: banks.bankName
      };
    }

    vm.submitModifyDefaultBank = function () {
      var success = function (res) {
        if(res.status){
          LoaderService.hideLoader('.defaultBank-loader');
          //here
          vm.closeModal();
          var modalPayload = {
            folioNumber: vm.folioId,
            bankDetails: vm.bankDetails
          };
          ModalService.changeBankSuccessModal({modalPayload:modalPayload});
        }
        else{
          LoaderService.hideLoader('.defaultBank-loader');
          if(res.popupEnabled) {
            ModalService.genericModal({
              text: res.message
            });
            vm.closeModal();
          } else {
            MessageService.error(res.message);
            vm.closeModal();
          }
        }
      };
      LoaderService.showLoader('.defaultBank-loader');
      var error = function (err) {
        UtilService.errorHandler(err);
      };
      InvestorService.post({child1:'folio',child2:'bank',child3:'makeDefault'},vm.changeDefaultBank.payload).$promise.then(success,error);
    }

  }
})();

(function () {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('MobileTermConditionModalController', mobiletermConditionModalController);

    /** @ngInject */
    function mobiletermConditionModalController($uibModalInstance, modalView, modalData, UtilService, MessageService, HDFC_API) {
        var vm = this;
        vm.HDFC_API = HDFC_API;
        vm.view = modalView;
        vm.modalData = modalData;
        vm.dynamicTerms = null;
        vm.dynamicDataTncGeneral = {};

        function init() {
            var successHandler = function (resp) {
                vm.dynamicTerms = resp;
                if (vm.dynamicTerms.termAndConditionDTO.termAndConditionDTOMap.MOBILE_TNC_General) {
                    vm.dynamicDataTncGeneral = vm.dynamicTerms.termAndConditionDTO.termAndConditionDTOMap.MOBILE_TNC_General.content;
                }
            }
            UtilService.fetchDynamicData("MOBILE_LOGIN_TNC").then(successHandler).catch(function (resp) {
                MessageService.error(resp);
            });
        }
        init();
        vm.closeModal = function () {
            $uibModalInstance.close();
        };
        vm.dismissModal = function () {
            $uibModalInstance.dismiss("cancel");
        };
    }
})();

  (function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('NewJourneyNoteLoginWithMobileController', newJourneyNoteLoginWithMobileController);
  
    /** @ngInject */
    function newJourneyNoteLoginWithMobileController($uibModalInstance, modalData, modalView, $state,AuthService,LoaderService,MessageService,AppConstants,InvestorService) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
  
      vm.closeModal = function () {
        vm.logoutBtn();
      };
  
      vm.dismissModal = function () {
        $uibModalInstance.dismiss();
      };
      vm.logoutBtn = function(){
        var success = function (resp) {
          if (resp.status) {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
            AuthService.clearCookies(AppConstants.MOBILE_IDENTIFIER);
            AuthService.clearCookies(AppConstants.NEW_INVESTOR_IDENTIFIER);
            sessionStorage.removeItem('MobilePanLoginDetails');
            sessionStorage.removeItem('dataLayerData');
            sessionStorage.removeItem('panDetails');
            sessionStorage.removeItem('panDetailsEncrypted');
            sessionStorage.removeItem('userData');
            sessionStorage.removeItem('verifyObj');
            $uibModalInstance.close();
            $state.go('login');
          } else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader('.logout');
        },
          error = function (err) {
            LoaderService.hideLoader('.logout');
            MessageService.error(err.data.message);
          };
        LoaderService.showLoader('.logout');
        vm.mobileLoginPandetails = sessionStorage.getItem('MobilePanLoginDetails')?JSON.parse(sessionStorage.getItem('MobilePanLoginDetails')) :null;
        var Data = {
          "panNumber": vm.mobileLoginPandetails.pan
          }
        InvestorService.post({
          child1: 'force',
          child2: 'logout'
        }, Data).$promise.then(success, error);
      }

    }
  })();

  (function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('UpdateContactLoginWithMobileController', updateContactLoginWithMobileController);
  
    /** @ngInject */
    function updateContactLoginWithMobileController($uibModalInstance, modalData, modalView, $state,AuthService,LoaderService,MessageService,AppConstants,InvestorService) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
      vm.mobileChanged = false;
      vm.closeModal = function (message) {
        $uibModalInstance.close(message);
      };
      function maskemobileNo(val) {
        if (!val || val == "null") {
            return val = "";
        }
        if (val == 'Not updated') {
            return val = val;
        }
        var endVal = val.substr(-3);
        var maskyVal = "";
        var valLength = val.length;
        while (0 < valLength - 3) {
            maskyVal += "X";
            valLength--;
        }
        return maskyVal + endVal;
      }
      vm.maskedMobileNo = maskemobileNo(vm.modalData.mobileNo);
  
    }
  })();
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('LoginWithMobileController', loginWithMobileController); 

  /** @ngInject */
  function loginWithMobileController($uibModalInstance, modalView, modalData, UtilService, MessageService, AppConstants, LoaderService, InvestorService,ModalService,InvestorServiceVersion3,AuthService,$state,$rootScope,$timeout,$window) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.appConstants = AppConstants;
    vm.otpVerify = false;
    vm.folioNumber = '';
    vm.invalidPanDob = "";
    vm.dob = '';
    vm.mobileNumber='';
    var removeListeners = {}, isRefreshing = false;
    vm.userDetails = AuthService.getUserCookies();
    vm.isMobielExistingInvestor = vm.userDetails && vm.userDetails.existingInvestor?true : false;
    vm.panNumber = vm.modalData && vm.modalData.data && 
                    vm.modalData.data.pan ?vm.modalData.data.pan:'';
    vm.dob = vm.modalData && vm.modalData.data && 
                    vm.modalData.data.dob ?vm.modalData.data.dob:'';
    vm.throughPrelimanaryDashboard = vm.modalData && vm.modalData.data && 
                      vm.modalData.data.throughPrelimanaryDashboard ?vm.modalData.data.throughPrelimanaryDashboard:false;
    vm.transactionType = vm.modalData && vm.modalData.data && vm.modalData.data.transactiontype ?vm.modalData.data.transactiontype:'';
    vm.STEPS = vm.modalData.STEPS;
    vm.showMobileBelongsTo = false;
    if(vm.STEPS == 'FOLIO_LIST'){
      vm.folioList = vm.modalData.data.folioList ? vm.modalData.data.folioList : [];
      vm.showMobileBelongsTo = vm.modalData.data.showMobileBelongsTo;
      vm.isIndividual = vm.modalData.data.isIndividual;
    }
    vm.title = vm.modalData.title;
    vm.VALIDATE_CONST = AppConstants.ToastrMessage.VALIDATE_DATA;  
    vm.startKyc = startKyc;
    vm.maskeEmail = maskeEmail;
    vm.maskemobileNo = maskemobileNo;
    vm.maskuserId = maskuserId;
    vm.getContactsBelong = getContactsBelong;
    vm.mobileBelongsTo = '';
    vm.maskid = maskid;
    vm.maskFolioList = maskFolioList;
    vm.logedInMaskMobile = maskemobileNo(vm.userDetails.mobile);
    if(vm.STEPS == 'VERIFY_DOB_AND_MOBILE'){
      getContactsBelong();
      vm.showMobileBelongsTo = true;
      vm.isIndividual = vm.modalData.data.isIndividual;
    }
    vm.dismissModal = function (val) {
      if(val == 'logout'){
        $uibModalInstance.dismiss("logout");
      }else if(val == 'HOME_STATE'){
        $uibModalInstance.dismiss("HOME_STATE");
      }else{
        $uibModalInstance.dismiss("cancel");
      }
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
    vm.verifyDOBMobile = function(){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if(resp.data.secretLink){
            vm.secretLink = resp.data.secretLink;
            vm.STEPS = 'OTP_VERIFY';
            vm.otpMessage = "Please enter OTP sent to your registered Mobile No. ("+ maskemobileNo(vm.mobileNumber) + ").";
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      }
      LoaderService.showLoader();
      var mbNumber = AuthService.encryptRSA(angular.copy(vm.mobileNumber));
      var payload = {"encryptedMobile":mbNumber}
      InvestorService.post({child1: 'mobile',child2: 'verifyMobile'}, payload).$promise.then(success, error);
    }
    vm.verifyotp = function(){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if(resp.data.status){
            vm.folioList = resp.data.folioList;
            vm.folioList = maskFolioList(vm.folioList);
            vm.STEPS = 'FOLIO_LIST';
          }else{
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function () {
        LoaderService.hideLoader();
        MessageService.error(AppConstants.ToastrMessage.FAILED);
      }
      LoaderService.showLoader()
      InvestorService.post({child1: 'mobile',child2: 'verifyOTP'}, { "otp": vm.otp, "id":vm.secretLink}).$promise.then(success, error);
    }
    vm.resendotp = function(){
      var success = function (resp) {
        LoaderService.hideLoader();
        if(resp.status && resp.data) {
          MessageService.success(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function () {
        MessageService.error(AppConstants.ToastrMessage.FAILED);
      }
      LoaderService.showLoader();
      InvestorService.post({child1: 'mobile',child2: 'resendOTP'}, { "id":vm.secretLink}).$promise.then(success, error);
    }
    vm.updateContact = function () {
      if(!vm.isIndividual){
        var userData =  AuthService.getUserCookies();
        userData.folioNumber = vm.folioNumber;
        AuthService.setUserCookies(userData); 
        var data ={
          redirectOnDashboard :true,
          panNumber: vm.panNumber,
          folioNumber:vm.folioNumber
        }
        $uibModalInstance.close(data);
      }else{
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
              if (resp.data.statusCode == 0) {
                MessageService.success(resp.data.message);
                var data ={
                  redirectOnDashboard :true,
                  panNumber: vm.panNumber,
                  transactionType:vm.transactionType ? vm.transactionType.toLowerCase() : ''
                }
                $uibModalInstance.close(data);
              }
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err.message);
        };
        LoaderService.showLoader();
        var payload ={
          "folioNumber": vm.folioNumber,
          "mobileBelongsTo":vm.mobileBelongsTo
        }
        InvestorService.post({ child1: 'mobile', child2: 'folio',child3:'contact',child4:'update' },payload).$promise.then(success, error);
      }
    }
    vm.varifyDate = function () {
      var doblength = vm.dob ? vm.dob.length : 0
      if (doblength == 10) {
        if (
          angular.isDefined(vm.dob) ||
          /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(
            vm.dob
          )
        ) {
          vm.dob = vm.dob;
          if (!vm.dob) {
            vm.dateErrorMessage = 'Please enter valid DOB';
            vm.dob = "";
          } else {
            vm.dateErrorMessage = "";
            vm.dobtrue = true
          }
        } else {
          vm.dateErrorMessage = 'Please enter valid DOB';
          vm.dob = "";
        }
        return;
      }
      else {
        vm.dobtrue = false;
      }
    }
     
    vm.verifypan = function() { 
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status){

          vm.isNewInvestor = resp.data.isExistingInvestor?false:true;
          vm.isIndividual = resp.data.isIndividual;
          vm.toUpdate = resp.data.toUpdate;
          vm.corporateFlag = resp.data.corporateFlag;
          vm.message = resp.data.message;
          vm.corporateFolioList = resp.data.corporateFolioList;          
          var userData =  AuthService.getUserCookies();
          userData.pan = vm.panNumber;
          if(typeof(vm.dob) == 'string'){
            userData.dob = vm.dob;
          }
          if(typeof(vm.dob) == 'object'){
            userData.dob = vm.dob.format('DD-MM-YYYY');
          }
          AuthService.setUserCookies(userData); 
          if(vm.isNewInvestor && !vm.throughPrelimanaryDashboard){
            //redirect on prelimanary dashboard 
            userData.disablePAN = true;
            AuthService.setUserCookies(userData); 
            var data ={
              isNewInvestor :vm.isNewInvestor,
              note : resp.data.message
            }
            $uibModalInstance.close(data); 
            return;
          }
          vm.doberrormsg = '';
          // for handle DOB error
          if(resp.data.isExistingInvestor && !resp.data.isDobValidated){
            vm.doberrormsg=resp.data.message; 
            return;
          }
          // Existing investor
          if(!vm.throughPrelimanaryDashboard){
              if(vm.toUpdate){
                  if(vm.isIndividual){
                     //in case any exception message throw then handle error message
                      if (resp.data.message && resp.data.message.length>0) {
                        MessageService.error(resp.data.message);
                        return;
                      }
                        // open DOB and mobile
                        vm.STEPS = 'VERIFY_DOB_AND_MOBILE';
                        getContactsBelong();
                        vm.showMobileBelongsTo = true;
                        // (toUpdate,isIndividual) --> DOB and Mobile --> OTP --> folio List --> Dashboard 
                  }else{
                    vm.STEPS = 'NON_INDIVIDUAL_NON_UPDATE';
                      //  open popup
                      // (~isIndividual,toUpdate) --> Popup --> redirect on existing login
                  }
              }else{
                  if(vm.isIndividual){
                      // enter DOB
                      // vm.STEPS = 'VERIFY_DOB';
                      //in case any exception message throw then handle error message
                      if (resp.data.message && resp.data.message.length>0) {
                        MessageService.error(resp.data.message);
                        return;
                      }
                      var data ={
                        redirectOnDashboard :true,
                        panNumber: vm.panNumber,
                        transactionType:vm.transactionType ? vm.transactionType.toLowerCase() : ''
                      }
                      $uibModalInstance.close(data);
                       // (~toUpdate,isIndividual) --> EnterDOB --> Dashboard
                  }else{
                      // folio list
                      vm.folioList = maskFolioList(vm.corporateFolioList);
                      vm.STEPS = 'FOLIO_LIST';
                     // (~toUpdate,~isIndividual) --> foliolist--> Dashboard
                  }
              } 
          }else{
            if(vm.isNewInvestor){
              if(vm.isIndividual){
                if(typeof(vm.dob) == 'string'){
                  var dateOfBirth = vm.dob;
                }
                if(typeof(vm.dob) == 'object'){
                  var dateOfBirth = vm.dob.format('DD-MM-YYYY');
                }
                //redirect on new investor journey
                var data ={
                  isNewInvestor :vm.isNewInvestor,
                  note : resp.data.message,
                  transactionType:vm.transactionType ? vm.transactionType.toLowerCase() : '',
                  dob: dateOfBirth
                }
                $uibModalInstance.close(data); 
              }else{
                      // --- popup ---> login  
                      // Pop up to be displayed to create folio through physical mode.
                      vm.STEPS = 'NON_INDIVIDUAL_NON_UPDATE';
              }  
            }else{
              if(vm.isIndividual){
                //in case any exception message throw then handle error message
                if (resp.data.message && resp.data.message.length>0) {
                  MessageService.error(resp.data.message);
                  return;
                }
                if(vm.toUpdate){
                  // open DOB and mobile
                  vm.STEPS = 'VERIFY_DOB_AND_MOBILE';
                  getContactsBelong();
                  vm.showMobileBelongsTo = true;
                }else{
                   // (toUpdate,isIndividual) --> DOB and Mobile --> OTP --> folio List --> Dashboard 
                  // vm.STEPS = 'VERIFY_DOB';
                  var data ={
                    redirectOnDashboard :true,
                    panNumber: vm.panNumber,
                    transactionType:vm.transactionType ? vm.transactionType.toLowerCase() : ''
                  }
                  $uibModalInstance.close(data);
                }
              }else{
                  // show popup and click and redirect on user id login page
                  vm.STEPS = 'NON_INDIVIDUAL_NOTE';
              }  
            } 
          }        
        }else{
          if(resp.popupEnabled) {
            var data ={
              redirectOnDashboard :false,
              popupEnabled: true,
              message:resp.message
            }
            $uibModalInstance.close(data);
          }else{
            MessageService.error(resp.message); 
          }
        }
      },error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.data.error);
      };
      LoaderService.showLoader();
      if(typeof(vm.dob) == 'string'){
        var dateOfBirth = vm.dob;
      }
      if(typeof(vm.dob) == 'object'){
        var dateOfBirth = vm.dob.format('DD-MM-YYYY');
      }
      var payload ={
        panNumber: AuthService.encryptRSA(angular.copy(vm.panNumber)),
        dob: dateOfBirth,
      }
      InvestorService.post({child1: 'mobile',child2: 'getVerifyPAN'},payload).$promise.then(success, error);
    }
    function startKyc(){
      $uibModalInstance.dismiss();
      $state.go('ekyc', {
        ekycRequestCO: vm.ekycRequestCO
      });
    }
    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
         oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if(vm.dobString.length == 10){
        var currentDate = $window.moment(new Date(),'DD-MMM-YYYY');
        var selectedDate = $window.moment(vm.dobString,'DD-MMM-YYYY');
        var status = selectedDate.isBefore(currentDate);
        if(status){
          vm.changeStartDate($window.moment(vm.dobString,'DD-MM-YYYY'));
        }
      } 
      if (vm.dobString.length == 0) {
        vm.dob = '';
      }
    }
    vm.changeStartDate = function(date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.dob = date;
        vm.doberrormsg = '';
        if (!date) {
          vm.dateErrorMessage = 'Please enter valid DOB';
        } else vm.dateErrorMessage = '';
      } else {
        vm.dateErrorMessage = 'Please enter valid DOB';
        vm.dob = "";
      }
      return;
    }
    vm.otpValChanged = function(myvalue) { 
      vm.otp = vm.otp1 + vm.otp2 + vm.otp3 + vm.otp4 + vm.otp5 + vm.otp6;
      vm.otpCodeLength = vm.otp.toString().length
      var container = document.getElementsByClassName("input-code")[0];
      container.onkeyup = function (e) {
        var target = e.target;

        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          var next = target;
          while (next = next.nextElementSibling) {
            if (next == null)
              break;
            if (next.tagName.toLowerCase() == "input") {
              next.focus();
              break;
            }
          }
        } else if (myLength < maxLength) {
          var prev = target;
          while (prev = prev.previousElementSibling) {
            if (prev == null)
              break

            if (prev.tagName.toLowerCase() == "input") {
              prev.focus();
              break;
            }
          }
        }
      }
    };
    vm.getMobileNumber = function(){
      if(vm.mobileNumber){
        if(vm.mobileNumber == vm.userDetails.mobile){
          MessageService.error("Please enter different mobile number which is login.");
          vm.mobileNumber = '';
        }
      }
    }
    function maskeEmail(email) {
      if (email) {
        if (!email) {
          return;
        }
        var valArray = email.split("@");
        var startVal = valArray[0];
        var endVal = valArray[1];
        var maskyVal = "";
        for (var i = 0; i < startVal.length; i++) {
          if (i == 0) {
            maskyVal += startVal[i];
          }
          if (i == 1) {
            maskyVal += "*";
          }
          if (i > 1) {
            var t = i % 2;
            if (t == 0) {
              maskyVal += startVal[i];
            } else {
              maskyVal += "*";
            }
          }
        }
        var maksemail = maskyVal + "@" + endVal;
        return maksemail;
      }
    }
    function maskid(val) {
      var endVal = val.substr(-3);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 3) {
        maskyVal += "*";
        valLength--;
      }
      return maskyVal + endVal;
    }
    function maskemobileNo(val) {
      if (!val || val == "null") {
          return val = "";
      }
      if (val == 'Not updated') {
          return val = val;
      }
      var endVal = val.substr(-4);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 4) {
          maskyVal += "*";
          valLength--;
      }
      return maskyVal + endVal;
    }
    function maskFolioList(dataList){
      if(dataList && dataList.length > 0){
        var folioListLength =  dataList.length;
        var tempList = [];
        var tempObj = {};
        for (var i = 0; i < folioListLength; i++) {
            tempObj = {};
            tempObj.folioNumber = dataList[i].id;
            tempObj.maskedFolioNumber = maskid(dataList[i].id);
            tempObj.userId = dataList[i].userId;
            tempObj.maskedUserId = maskuserId(dataList[i].userId);
            tempObj.mobile = dataList[i].mobileNo;
            tempObj.maskedMobile = maskemobileNo(dataList[i].mobileNo);
            tempObj.email = dataList[i].email;
            tempObj.maskedEmail = maskeEmail(dataList[i].email);
            tempObj.minorFlag = dataList[i].minorFlag;
            tempList.push(tempObj);
        }
        return tempList;
      }else{
        vm.folioList = [];
      }
    }
    function maskuserId(val){
      if(val){
        var maskUserId = '';
        for(var i=0;i<val.length;i++){
          if(i%2==0){
            maskUserId = maskUserId+val[i];
          }else{
            maskUserId = maskUserId+'*';
          }
        }
        return maskUserId;
      }else{
        return "";
      }
    }
    function getContactsBelong(){        
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.belongToListMobile = resp.data.mobileList;
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        MessageService.error(err.data.message);
        LoaderService.hideLoader();
      };
      LoaderService.showLoader();
      InvestorService.get({ child1: 'folio', child2: 'contactType', child3: 'details' }).$promise.then(success, error);
    }
    removeListeners["RemoveMobileToken"] = $rootScope.$on("RemoveMobileToken", function () {
      var d = sessionStorage.getItem('ErrorStep');
        sessionStorage.removeItem(AppConstants.MOBILE_IDENTIFIER);  
        $timeout(function () {
          $uibModalInstance.dismiss(); 
        }, 0);
    });
 
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('LoginVideoModalController', loginVideoModalController);

  /** @ngInject */
  function loginVideoModalController($uibModalInstance, modalView, modalData){
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('LoginLoaderModalController', loginLoaderModalController);

  /** @ngInject */
  function loginLoaderModalController($uibModalInstance, AppConstants, modalView, modalData, AuthService, $interval, $state, $stateParams, LoaderService, MessageService, UtilService, ModalService,$timeout) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    // var timer = [30000, 30000, 30000, 20000, 10000];
    // var index = 0;
    var intervalPromise = {};
    var identifierData = AuthService.getToken();

    function intervalChange() {
      (intervalPromise && intervalPromise.hasOwnProperty('$$intervalId')) && $interval.cancel(intervalPromise);
      intervalPromise = $interval(function () {
        init();
      }, 2000);
    }

    var goToDashboard = function () {
      identifierData.isDataUpdated = true;
      AuthService.setToken(identifierData);
      (intervalPromise && intervalPromise.hasOwnProperty('$$intervalId'))&& ($interval.cancel(intervalPromise));
      LoaderService.hideLoader('.main-loader');
      vm.closeModal();
      $timeout(function (){ 
        if($stateParams.trackId && $stateParams.trxnType && $stateParams.stepNo){
          redirectToTransaction();
        }else{
          $state.go('welcome');
        }
      },2000); 
    };

    function redirectToTransaction() {
      if($stateParams.trackId && $stateParams.trxnType && $stateParams.stepNo){
        if($stateParams.trxnType.toLowerCase() === 'purchase' || $stateParams.trxnType === 'SIP_PURCHASE'){
          switch ($stateParams.stepNo.toUpperCase()) {
            case "FIRST":
            case "SECOND":
              $state.go('main.transactions.purchase',{trackId:$stateParams.trackId,transactionType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
              break;
            case "THIRD":
              // $state.go('main.transactions.payment',{trackId:$stateParams.trackId,stepNo:$stateParams.stepNo});
              $state.go('main.transactions.purchase',{trackId:$stateParams.trackId,transactionType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
              break;
            case "FOURTH": break;
            default:
              $state.go('main.transactions.purchase',{trackId:$stateParams.trackId,transactionType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
          }
        }else if($stateParams.trxnType.toLowerCase() === 'sip'){
          $state.go('main.transactions.sip',{trackId:$stateParams.trackId,transactionType:$stateParams.trxnType});
        }
      }else{
        $state.go('welcome');
      }
    }

    var init = function () {
      if(angular.isUndefined(identifierData)){
        vm.dismissModal();
        (intervalPromise && intervalPromise.hasOwnProperty('$$intervalId')) && $interval.cancel(intervalPromise);
        $state.go('sessionExpired');
      }
      var fName = identifierData.investorFName ? identifierData.investorFName : "";
      var mName = identifierData.investorMName ? identifierData.investorMName : "";
      var lName = identifierData.investorLName ? identifierData.investorLName : "";
      vm.investorName = fName +' '+ mName +' '+ lName;
      //vm.investorName = identifierData.investorFName +' '+ identifierData.investorMName +' '+ identifierData.investorLName;
      vm.investorName = vm.investorName.trim() ? (vm.investorName):(vm.investorName);
      if (identifierData && identifierData.handshakeToken) {
        AuthService.callCommonServiceUrl({handshakeToken: identifierData.handshakeToken}).then(function (data) {
          data = angular.isString(data) ? angular.fromJson(data) : data;
          data = data.data || data;
          if (data.dataUpdated) {
            goToDashboard();
          } else {
            intervalChange();
          }
        }, function (err) {
          if(err && err.status==401){
            if(angular.isDefined(identifierData)){
              AuthService.getRefreshToken(identifierData).then(function () {
                if(localStorage.getItem('doLogOut')){
                  AuthService.logout().then(function () {
                    (intervalPromise && intervalPromise.hasOwnProperty('$$intervalId')) && $interval.cancel(intervalPromise);
                    AuthService.clearCookies(AppConstants.IDENTIFIER);
                    $state.go('sessionExpired');
                  }, function () {
                    (intervalPromise && intervalPromise.hasOwnProperty('$$intervalId')) && $interval.cancel(intervalPromise);
                    $state.go('sessionExpired');
                  });
                }else{$state.reload();}
              }, function () {
                (intervalPromise && intervalPromise.hasOwnProperty('$$intervalId')) && $interval.cancel(intervalPromise);
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                MessageService.clear();
                $state.go('sessionExpired');
              });
            }else{
              (intervalPromise && intervalPromise.hasOwnProperty('$$intervalId')) && $interval.cancel(intervalPromise);
              AuthService.clearCookies(AppConstants.IDENTIFIER);
              MessageService.clear();
              $state.go('sessionExpired');
            }
          }else{
            AuthService.logout().then(function () {
              $state.go('sessionExpired');
            }, function () {
              AuthService.clearCookies(AppConstants.IDENTIFIER);
              MessageService.clear();
              $state.go('sessionExpired');
            });
          }
        });
      } else {
        goToDashboard();
      }
    };

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    init();

  }
})();

/**
 * Created by ttn on 15/12/22.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentPersonalityModalController', investmentPersonalityModalController);

  /** @ngInject */
  function investmentPersonalityModalController($uibModalInstance, modalView, modalData, InvestmentBasketService, $window,
                                                $timeout, LoaderService, MessageService, UtilService) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.currentTab = 0;
    vm.formData = {};
    vm.investmentPersonalityQuestion = vm.modalData.questionAndAnswer;
    vm.showTab = showTab;
    vm.nextAndPreviousAction = nextAndPreviousAction;
    vm.submitForm = submitForm;
    vm.getLastRiskAppetite = getLastRiskAppetite;
    vm.defaultLastAppetiteOptions = defaultLastAppetiteOptions;
    vm.defaultSelection = [];
    vm.init = init;
    vm.init();

    function init(){
      showTab(vm.currentTab);
      getLastRiskAppetite();

    }

    function showTab(tab) {
      $timeout(function() {
        var tabs = angular.element($window.document.querySelectorAll(".tab"));
        angular.element(tabs[tab]).show();
      }, 100);
    }

    function nextAndPreviousAction(index) {
      var x = angular.element($window.document.querySelectorAll(".tab"));
      if (index == 1 && !validateForm()) return false;
      x[vm.currentTab].style.display = "none";
      vm.currentTab = vm.currentTab + index;
      if (vm.currentTab >= x.length) {
        return false;
      }
      showTab(vm.currentTab);
    }

    function validateForm() {
      return true;
    }

    function submitForm() {
      var payload = {
        queAndAns: []
      };
      var keys = Object.keys(vm.formData);
      keys.forEach(function(key) {
        var obj = {
          questionId: key,
          optionId: vm.formData[key]
        };
        payload.queAndAns.push(obj);
      });
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.closeModal(true);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'save',
        child4: 'QuesAndAnsDetail'
      }, payload).$promise.then(success, error);
    }

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.closeModal = function (message) {
      $uibModalInstance.close(message);
    };

    function getLastRiskAppetite(){
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status && response.data) {
          vm.getLastRiskAppetite = response.data;
          if(vm.getLastRiskAppetite) {
            defaultLastAppetiteOptions(vm.getLastRiskAppetite);
          }
        }
        else {
          MessageService.error(response.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: 'investment',
        child2: 'basket',
        child3: 'risk',
        child4: 'getLastRiskAppetite'
      }).$promise.then(success, error);
    }

    // function defaultLastAppetiteOptions(getLastRiskAppetite){
    //   getLastRiskAppetite.queAndAns.forEach(function (lastSelected,index){
    //     vm.fullLastSelected = lastSelected;
    //     vm.defaultSelection.push(vm.fullLastSelected);
    //   });
    //
    //   vm.defaultSelection.forEach(function(key,index) {
    //     // var data = {
    //     // [index]: key.optionId
    //     // };
    //     // vm.formData[index] = data;
    //     vm.formData[key.questionId] = key.optionId;
    //   });
    //   console.log(vm.formData)
    //   // vm.formData.riskProfiler = vm.fullRiskData[0].riskName;
    // }

    function defaultLastAppetiteOptions(getLastRiskAppetite){
      getLastRiskAppetite.queAndAns.forEach(function (lastSelected,index){
        vm.formData[lastSelected.questionId] = lastSelected.optionId;
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SavedTransactionModalController', savedTransactionModalController);

  /** @ngInject */
  function savedTransactionModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InitiateTransactionModalController', initiateTransactionModalController);

  /** @ngInject */
  function initiateTransactionModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close(vm.isChecked);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    }
})();

/**
 * Created by ttn on 25/11/16.
 */

 (function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('HoldHoderModalController', holdHoderModalController);
  
    /** @ngInject */
    function holdHoderModalController($uibModalInstance,InvestorService, $timeout, $state, modalView, modalData,MessageService, AuthService, AppConstants) {
      var vm = this;
      vm.stateToGo = 'sip';
      vm.view = modalView;
      vm.modalData = modalData; 
  
      vm.logoutMe = function () {
        $state.go("login");
        $uibModalInstance.dismiss();
      };
      vm.craeteNewFolio = function () {
        if(vm.modalData.holderLinkExpired){ 
          $state.go("newInvestor.folioDetails.baiscDetails");
        }
        else{
          var detailsSuccess = function (result) {
            if(result.status && result.data){
              $state.go("newInvestor.folioDetails.baiscDetails");
            }else{
              MessageService.error(result.message);
              $state.go("newInvestor.kycVerification");
            }
            
          },derror = function(err){
              MessageService.error(err);
              $state.go("newInvestor.kycVerification");
          }
          var payload = {
              "panNumber":vm.modalData.panNumber,
              "holderSecretLink":vm.modalData.holderSecretLink,
              "secondHolderSecretLink":vm.modalData.secondHolderSecretLink ? vm.modalData.secondHolderSecretLink : null
          }
          InvestorService.post({
              child1: 'new',
              child2: 'user',
              child3: 'expire',
              child4: 'jointHolder'
            }, payload).$promise.then(detailsSuccess, derror);
        }
        $uibModalInstance.close();
      };
  
      vm.closeModal = function () {
        $state.go("login");
        $uibModalInstance.close();
      };
  


      }
  })();
  

 (function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('HdfcBankModalController', hdfcBankModalController);

    /** @ngInject */

    function hdfcBankModalController($uibModalInstance,InvestorService, ModalService, $state, modalView, modalData,MessageService, AuthService, AppConstants) {
      var vm = this;
      vm.stateToGo = 'sip';
      vm.view = modalView;
      vm.modalData = modalData.data;
      vm.logoutMe = function () {
        $uibModalInstance.dismiss();
      };
      vm.proceed = function(){
        ModalService.arnAddBankModal({data: vm.modalData});
        $uibModalInstance.close();
      }
      vm.closeModal = function () {
        $uibModalInstance.close();
      };
      }
  })();
/**
 * Created by ttn on 20/07/20.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('GenericModalController', genericModalController);

  /** @ngInject */
  function genericModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ForgotPasswordController', forgotPasswordController);

  /** @ngInject */
  function forgotPasswordController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioCompletModalController', folioCompletModalController);

  /** @ngInject */
  function folioCompletModalController($uibModalInstance, $timeout, $state, modalView, modalData, AuthService, AppConstants,LoaderService,InvestorService,NetcoreEvntService,TransactionModel,$window,MessageService,HDFC_API) {
    var vm = this;
    vm.stateToGo = 'sip';
    vm.view = modalView;
    vm.modalData = modalData;
    vm.otpSended = false;
    vm.otpNumber = "";
    vm.sendOtp = sendOtp;
    vm.makeTransaction = makeTransaction;
    vm.logoutNJ = logoutNJ;
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));

    if(vm.distributorDetails && vm.distributorDetails.transactionType == 'Purchase_Scheduler'){
      sendOtp();
    }
    vm.goDashboard = function(){
      var token = AuthService.getToken();
      token.investorType = AppConstants.INVESTOR_TYPE.EXISTING;
      AuthService.setToken(token);
      $state.go('main.dashboard.widgits');
    };
    // vm.redirectToFolioCreation = function() {
    //   $timeout(function () {
    //     $state.go('folioDetails.holdMode');

    //   })
    //   $uibModalInstance.dismiss();

    // }
    vm.logoutMe = function () {
      // $state.go('newInvestor.investorProfile');
      $state.go("login");
      $uibModalInstance.dismiss();
    };
    vm.pay = function(){
      $uibModalInstance.close();
      LoaderService.showLoader();
      $timeout(function(){
        LoaderService.hideLoader();
        $state.go('newInvestor.NewInvestorPayment');
      },10000);
    }

    function sendOtp() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.otpDetails = resp.data;
          vm.otpSended = true;
          localStorage.setItem('QuickInvestmentSecreteLink',resp.data.id);
          MessageService.success(resp.data.otpSentMessage);
        }else{
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        MessageService.error(err);
      }
      vm.sendOtppayload = {
        folioNumber: vm.modalData.folioNumber,
        panNumber: vm.modalData.panNumber
      };
      InvestorService.post({ child1: "registration", child2: "otp", child3: "generate",child4:"arnHardCode" }, vm.sendOtppayload).$promise.then(success, error);
    }
    vm.verifyOtp = function(){
      makeTransaction();
    }
    vm.resendOtp = function(){
      sendOtp();
    }
    function makeTransaction() {
      var data = $window.JSON.parse(sessionStorage.getItem("distributorDetails"))
      var UserDetails = JSON.parse(sessionStorage.getItem("verifyObj"));
      AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
      var successLogin = function (resp) {
        LoaderService.hideLoader();
        localStorage.setItem('loggedIn', true);
        TransactionModel.setPayloadRawData(null);
        NetcoreEvntService.Login_Status_QI_IP(vm.sendOtppayload, true);
        data.maskedEmail = UserDetails.maskedEmail;
        data.maskedMobileNumber = UserDetails.maskedMobile;
        localStorage.setItem("distributorDetails", $window.JSON.stringify(data));
        logoutNJ();
        $uibModalInstance.close();
        sessionStorage.setItem('newFolioCreateThroughtOneClick',true);
        $state.go('instantLoginHome.instantInvest');
      }, errorLogin = function (error) {
        LoaderService.hideLoader();
        MessageService.error(error.message);
      }
      var oauthpayload = {
        folioNumber: vm.modalData.folioNumber,
        secretLink: vm.otpDetails.id,
        otp: vm.otpNumber,
        grant_type: 'password',
        panNumber: vm.modalData.panNumber ? AuthService.encryptRSA(angular.copy(vm.modalData.panNumber)) : ""
      };
      LoaderService.showLoader();
      AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);
    }
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    // vm.dismissModal = function () {
    //   $uibModalInstance.dismiss();
    // };

    function logoutNJ(){
        var success = function (resp) {
        },error = function (err) {
        };
        InvestorService.post({child1: 'force',child2: 'logout' }, {"panNumber": vm.modalData.panNumber}).$promise.then(success, error);
    }
    }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioSuccessModalController', folioSuccessModalController);

  /** @ngInject */
  function folioSuccessModalController($uibModalInstance, $timeout, $state, modalView, modalData, AuthService, AppConstants, CommonFactory) {
    var vm = this;
    vm.stateToGo = 'sip';
    vm.view = modalView;
    vm.modalData = modalData;

    vm.goDashboard = function(){
      var token = AuthService.getToken();
      token.investorType = AppConstants.INVESTOR_TYPE.EXISTING;
      AuthService.setToken(token);
      $state.go('main.dashboard.widgits');
    };
    vm.redirectToFolioCreation = function() {
      $timeout(function () {
        $state.go('folioDetails.holdMode');

      })
      $uibModalInstance.dismiss();

    }
    vm.logoutMe = function () {
      $timeout(function () {
        AuthService.logout().then(function () {
          CommonFactory.setLogoutSuccess();
          $state.go('login');
        }, function () {
          // $state.go('login');
        });
      });
      $uibModalInstance.dismiss();
    };
    vm.goToTransactionSip = function () {
      $timeout(function () {
        $state.go('main.transactions.sip');

      })
      $uibModalInstance.dismiss();


    }

    vm.goToTransactionPurcahse =function(){
      $timeout(function () {
        $state.go('main.transactions.purchase');

      });
      $uibModalInstance.dismiss();


    }

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
      if (vm.modalData.fromOtherJoruney) {
        $state.go('welcome');
      } else if (vm.modalData.holdmode ==='ANY_OR_SURVIVOR') {
        $state.go('welcome');
      }
    };

    }
})();

/**
 * Created by ttn on 20/07/20.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioChoiceModalController', folioChoiceModalController);

  /** @ngInject */
  function folioChoiceModalController($uibModalInstance, modalView, modalData, InvestorServiceV3, LoaderService, UtilService, $scope, $state, AppConstants) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.userType = sessionStorage.getItem('userType');

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
      if (!vm.modalData.isFromPostLogin) {
        if (vm.userType === 'EXISTING') {
          sessionStorage.removeItem(AppConstants.IDENTIFIER);
          $state.go('login');
        } else {
          $state.go('newInvestor');
        }
      }
    };
    vm.closeModal = function (param) {
      if (sessionStorage.getItem('isMinorFolioSelected')) {
        sessionStorage.removeItem('isMinorFolioSelected');
      }
      $uibModalInstance.close(param);
    };

  }
})();

/**
 * Created by ttn on 20/07/20.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FillFolioDetailsModalController', fillFolioDetailsModalController);

  /** @ngInject */
  function fillFolioDetailsModalController($uibModalInstance, modalView, modalData,InvestorServiceV3, LoaderService, UtilService, $scope , $state , AppConstants) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.userType = sessionStorage.getItem('userType');

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
      if (!vm.modalData.isFromPostLogin) {
        if (vm.userType === 'EXISTING') {
          if(!vm.modalData.isCheckJourneyFromPreLogin) {
            sessionStorage.removeItem(AppConstants.IDENTIFIER);
            $state.go('login');
          }else {
            $uibModalInstance.dismiss();
          }
        } else {
          $state.go('newInvestor');
        }
      }
    };
    vm.closeModal = function (param) {
      if (sessionStorage.getItem('isMinorFolioSelected')) {
        sessionStorage.removeItem('isMinorFolioSelected');
      }
      $uibModalInstance.close(param);
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FeedbackModalController', feedbackModalController);

  /** @ngInject */
  function feedbackModalController($log, $uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

 (function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('ExistinguserModalController', existinguserModalController);
  
    /** @ngInject */
    function existinguserModalController($uibModalInstance, modalData, modalView) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
      
      vm.closeModal = function () {
        $uibModalInstance.close();
      };
  
      vm.dismissModal = function () {
        $uibModalInstance.dismiss();
      };
    }
  })();
  
/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('EmailVerificationModalController', emailVerificationModalController);

  /** @ngInject */
  function emailVerificationModalController($uibModalInstance, AppConstants, $cookies, $log, $timeout, LoaderService, InvestorService, MessageService, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.modalData = 'Are you sure, you want to cancel this action?';
    //vm.folioNumber = angular.fromJson($cookies.get("token_data"))["folioNumber"];
    vm.errorMessage = "";
    vm.inputReset = false;
    if (modalData.Text) {
      vm.modalData = modalData.Text;
    }
    vm.closeModal = function (message) {
      $uibModalInstance.close(message);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.verifyEmail = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.loader');
        if (resp.data && resp.status) {
          vm.closeModal(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
        vm.processFlag = false;
      }, error = function () {
        LoaderService.hideLoader('.loader');
        vm.processFlag = false;
        vm.errorMessage = AppConstants.ToastrMessage.FAILED;
      };
      var payload = {
        "changeFor": "Folio",
        "value": vm.formData.emailId,
        "panNumber": "",
        "investorId": "",
        "folioNumber": modalData.folioNumber
      };
      vm.processFlag = false;
      LoaderService.showLoader('.loader');
      vm.errorMessage = '';

      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'edit',
        child4: 'email'
      }, payload).$promise.then(success, error);
    };

    vm.verifyOtp = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.loader');
        if (resp.data && resp.status) {
          vm.closeModal(resp.data.message);
        } else {
          vm.errorMessage = resp.message;
        }
        vm.processFlag = false;
      }, error = function () {
        LoaderService.hideLoader('.loader');
        vm.processFlag = false;
        vm.errorMessage = AppConstants.ToastrMessage.FAILED;
      };
      var payload = {
        "otp": vm.formData.otpNumber,
        "folioNumber": modalData.folioNumber,
        "investorId": "",
        "panNumber": "",
        "isThisForFolioUsedForRegistration": "true"
      };
      LoaderService.showLoader('.loader');
      vm.errorMessage = '';

      InvestorService.post({
        child1: 'type',
        child2: 'fresh',
        child3: 'change-email',
        child4: 'verify',
        child5: 'otp'
      }, payload).$promise.then(success, error);
    };


    vm.resendOtp = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.loader');
        if (resp && resp.data) {
          vm.processOTPFlag = false;
          vm.otpResendMessage = resp.data.message;
        } else {
          vm.processOTPFlag = true;
          vm.errorMessage = resp && resp.data.message || AppConstants.ToastrMessage.FAILED;
          //MessageService.error(resp.data.message || AppConstants.ToastrMessage.FAILED);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.loader');
        vm.processOTPFlag = false;
        //vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
        MessageService.error(AppConstants.ToastrMessage.FAILED);
        $log.info('Error:', err);
      };
      var payload = {
        "folioNumber": modalData.folioNumber
      };
      vm.inputReset = true;
      $timeout(function () {
        vm.inputReset = false;
      });
      vm.errorMessage = '';
      vm.processOTPFlag = true;
      vm.otpResendMessage = '';
      LoaderService.showLoader('.loader');
      InvestorService.post({
        child1: 'type',
        child2: 'fresh',
        child3: 'change-email',
        child4: 'resend',
        child5: 'otp'
      }, payload).$promise.then(success, error);
    };

    vm.resetValues = function () {
      vm.errorMessage = "";
      vm.otpResendMessage = "";
    };


  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('EditDashboardController', editDashboardController);

  /** @ngInject */
  function editDashboardController($uibModalInstance, modalView) {
    var vm = this;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('DreamSipTenureModalController', dreamSipTenureModalController);
  
    /** @ngInject */
    function dreamSipTenureModalController($uibModalInstance, $log, UtilService, modalView, modalData) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData; 
     
      vm.dismissModal = function () {
        $uibModalInstance.dismiss();
      }; 
       
    }
  })();
  
/**
 * Created on 16/02/22.
 */

 (function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('PointToNoteController', pointToNoteController);
  
    /** @ngInject */
    function pointToNoteController($uibModalInstance, modalView,modalData) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
  
      vm.dismissModal = function () {
        $uibModalInstance.dismiss("cancel");
      };

      vm.continue = function () {
        $uibModalInstance.close("success");
      };
  
  
    }
  })();
/**
 * Created on 16/02/22.
 */

 (function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('ChangeTargetSchemeController', changeTargetSchemeController);
  
    /** @ngInject */
    function changeTargetSchemeController($uibModalInstance, modalView, modalData,UtilService,MessageService, AppConstants, LoaderService, InvestorService) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
      vm.optionList = AppConstants.OPTION_LIST;
      vm.fetchTargetScheme = fetchTargetScheme; 
      vm.targetSchemeData = {};
      function fetchTargetScheme() {
        vm.modalData.optionType = vm.modalData.option == "A"? "Option A" :"Option B";
        vm.formData = vm.modalData;
        if(!vm.modalData.optionType && vm.modalData.optionType == 'Option B'){ 
           $uibModalInstance.dismiss("cancel");
        } 
          var success = function (resp) { 
            if (resp.status && resp.data) {
              vm.targetSchemeList = resp.data.targetSchemeList;
            } else{
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }, error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          var payload = {
            option: (vm.formData.optionType == 'Option B') ? 'B' : 'A',
            isBroker : vm.modalData.brokCode == "DIRECT"? true : false
          }
          LoaderService.showLoader();
          InvestorService.post({
            child1: 'dreamSip',
            child2: 'getDreamSipScheme'
          }, payload).$promise.then(success, error); 
      }
  
      vm.targetSchemeChanged = function (schemeData) {
        if (!schemeData) {
          return;
        } else { 
          vm.targetSchemeData.targetSchemeCode = schemeData.schemeCode;
          vm.targetSchemeData.targetSchemeName = schemeData.scheme;
          //vm.formData.schemeType = schemeData.schemeType;
        }
      };
      vm.changeOptionType = function () {
        vm.targetSchemeData.targetSchemeCode = null;
        vm.targetSchemeData.targetSchemeName = null; 
      }
      vm.dismissModal = function () {
        $uibModalInstance.dismiss("cancel");
      };
  
      vm.continue = function () { 

        LoaderService.showLoader();
        var success = function (resp) {
          if (resp.status && (resp.data || resp)) { 
            MessageService.success(resp.message);
               LoaderService.hideLoader();
               $uibModalInstance.close("success");
          }
          else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        }, error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader(); 
        };
        if(vm.targetSchemeData.targetSchemeCode != vm.formData.toScheme){ 
            var payload = { }; 
            payload.folioNumber = vm.formData.folioNumber;
            payload.schemeCode = vm.formData.schemeCode;
            payload.sipStpId = vm.formData.id;
            payload.brokerCode = vm.formData.brokCode; 
            payload.systematicTransactionType = "changeTargetScheme", 
            payload.oldOption = (vm.formData.optionType == 'Option B')? "B" : "";
            payload.newOption = (vm.formData.optionType == 'Option B')? "B" : "";
            payload.targetScheme = vm.formData.toScheme;
            payload.oldTargetScheme = vm.formData.toScheme;
            payload.newTargetScheme = vm.targetSchemeData.targetSchemeCode, 
            payload.applicationSource = "MF_ONLINE" ;  
          InvestorService.post({
            child1: 'dreamSip',
            child2: 'changeOptionTargetScheme'
          }, payload).$promise.then(success, error); 
        }else{
          MessageService.error("To change target scheme, Please select new target scheme.")
        }   
      };
    }
  })();
/**
 * Created on 16/02/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('OptionChangeController', optionChangeController);

  /** @ngInject */
  function optionChangeController($uibModalInstance,TransactionService,ModalService, modalView,UtilService, modalData, AppConstants, LoaderService,MessageService, InvestorService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.optionList = AppConstants.OPTION_LIST;
    var successRandomOTPIdHandler = function(resp) {
      vm.randomOTPId = resp.randomOTPId ? resp.randomOTPId : null;
    }, errorRandomOTPIdHandler = function (){}
    UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
    vm.fetchTargetScheme = fetchTargetScheme;
    function fetchTargetScheme() {
    vm.modalData.optionType = vm.modalData.option == "A"? "Option A" :"Option B";
      vm.formData = vm.modalData;
      if(!vm.modalData.optionType){
         $uibModalInstance.dismiss("cancel");
      }
      if (vm.modalData.optionType == 'Option A') {
        LoaderService.showLoader();
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.targetSchemeList = resp.data.targetSchemeList;
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        var payload = {
          option: (vm.formData.optionType == 'Option B') ? 'A' : 'B',
          isBroker : vm.modalData.brokCode == "DIRECT"? true : false
        }
        InvestorService.post({
          child1: 'dreamSip',
          child2: 'getDreamSipScheme'
        }, payload).$promise.then(success, error);

      }
    }

    vm.targetSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.formData.targetSchemeCode = schemeData.schemeCode;
        vm.formData.targetSchemeName = schemeData.scheme;
        //vm.formData.schemeType = schemeData.schemeType;
      }
    };
    vm.changeOptionType = function () {
      vm.formData.targetSchemeCode = null;
      vm.formData.targetSchemeName = null;

    }
    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.continue = function () {
      LoaderService.showLoader();
      var payload = {
          folioNumber : vm.formData.folioNumber,
          schemeCode : vm.formData.schemeCode,
          sipStpId : vm.formData.id,
          brokerCode : vm.formData.brokCode,
          systematicTransactionType : "changeOption",
          oldOption : (vm.formData.optionType == 'Option B') ? 'B' : 'A',
          newOption : (vm.formData.optionType == 'Option B') ? 'A' : 'B',
          targetScheme : (vm.formData.option == 'B')?vm.formData.toScheme: vm.formData.targetSchemeCode,
          oldTargetScheme : "",
          newTargetScheme : "",
          applicationSource : "MF_ONLINE"
        }
      var success = function (resp) {
        if (resp.status && (resp.data || resp)) {
             MessageService.success(resp.message);
             $uibModalInstance.close("success");
        }
        else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };

      var modalPayload = {
        folioNumber: vm.formData.folioNumber,
        transactionType:"DREAMSIP",
        randomOTPId: vm.randomOTPId
      };
      if(vm.formData.option == "A"){
        var success1 = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var otpSuccessCallback = function() {
              LoaderService.showLoader();
                    InvestorService.post({
                      child1: 'dreamSip',
                      child2: 'changeOptionTargetScheme'
                    }, payload).$promise.then(success, error);
            };
            var otpDismissCallback = function() {
              LoaderService.hideLoader();
            };
            var otpDetails = {
              secretOtpLink : resp.data.secretLink,
              otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
              otpId : resp.data.id
            };
            payload.formType = "DREAMSIP";
            ModalService.transactionOtpModal({
              otpPayload: otpDetails,
              config:  "changeOption",
              payload: payload
            }, otpSuccessCallback, otpDismissCallback);
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message)
          }
        },
        error1 = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        TransactionService.post2({
            controller1: 'transaction',
            controller2: 'otp'
        }, modalPayload).$promise.then(success1, error1);
      }else{
        InvestorService.post({
          child1: 'dreamSip',
          child2: 'changeOptionTargetScheme'
        }, payload).$promise.then(success, error);
      }

    };
  }
})();

/**
 * Created by HDFC on 01/02/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('DreamSchemeListModalController', dreamSchemeListModalController);

  /** @ngInject */
  function dreamSchemeListModalController($uibModalInstance, $log,InvestorService, UtilService, modalView, modalData, SchemeService, LoaderService, MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.schemeTypeList = null;
    vm.schemeList = null;
    vm.masterSchemeList = null;
    vm.selectedSchemeType = '';

    vm.getSchemeslist = function () { 
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.masterSchemeList = resp.data.sourceSchemeList; 
          vm.filterSchemes(vm.schemeTypeList[0]);
        } else {
          MessageService.error(resp.message);
          vm.schemeList = null;
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.schemeList = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader('.popup');

      InvestorService.post({
        child1: 'dreamSip',
        child2: 'getDreamSipScheme'
      }, vm.modalData.payload).$promise.then(success, error); 
    };
    vm.filterSchemes = function (schemeType) {
      vm.selectedSchemeType = schemeType.toUpperCase(); 
      if(schemeType == "ALL"){
        vm.schemeList = vm.masterSchemeList;
      }else{
        vm.schemeList = [];
        vm.masterSchemeList.forEach(function(val) {
          if(val.schemeType == schemeType){
            vm.schemeList.push(val);
          } 
        });
      } 
    }; 
    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    }; 
    vm.selectScheme = function (scheme) {
      $uibModalInstance.close(scheme);
    };

    vm.init = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.schemeTypeList = resp.data.schemeType;
          if (vm.schemeTypeList && vm.schemeTypeList.length > 0) {
            vm.getSchemeslist();
          }
        } else {
          vm.schemeTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.schemeTypeList = null;
        UtilService.errorHandler(err)
      };
      LoaderService.showLoader('.popup');

      SchemeService.post({
        controller: 'schemeType'
      }, null).$promise.then(success, error);

    };
  }
})();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('DecisionModalController', decisionModalController);
  
    /** @ngInject */
    function decisionModalController($uibModalInstance, modalData, modalView, $state) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
  
      vm.closeModal = function () {
        $uibModalInstance.close();
      };
  
      vm.dismissModal = function () {
        $uibModalInstance.dismiss();
      };
      vm.continuewithSelf = function(){
        $uibModalInstance.close({key:'continuewithSelf'});
      }
      vm.changePaymentoption = function(){
        $state.go('newInvestor.investmentDetails.amountdetails');
        $uibModalInstance.close();
      }
    }
  })();
  
/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('MapFolioController', mapFolioController);

  /** @ngInject */
  function mapFolioController($uibModalInstance, modalView, modalData, InvestorService, $log) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.fetchInvestorFolioMap = fetchInvestorFolioMap;
    vm.mapFolio = mapFolio;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.init = function () {
      fetchInvestorFolioMap();
    };

    function fetchInvestorFolioMap() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.folioMap = resp.data.folioMap;
            vm.folioMapL = Object.keys(vm.folioMap).length;
          }

        },
        error = function (err) {
          $log.info("error====", err);
        };
      InvestorService.get({child1: 'folio', 'child2': 'getInvestorFolioMap'}).$promise.then(success, error);
    }

    function mapFolio() {
      var success = function (resp) {
          if (resp.status) {
            vm.closeModal();
          }

        },
        error = function (err) {
          $log.info("error====", err);
          vm.dismissModal();
        };
      InvestorService.post({child1: 'folio', 'child2': 'mapped'}, {}).$promise.then(success, error);
    }

  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AddJointHolderModalController', addJointHolderModalController);

  /** @ngInject */
  function addJointHolderModalController($uibModalInstance, $state, modalView, modalData, InvestorService, LoaderService, AppConstants, MessageService, AuthService, panAadharService, ModalService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.formData = {};
    vm.verificationForm = {};
    vm.dismissModal = dismissModal;
    vm.continue = continueModal;
    vm.verifyPAN = verifyPAN;
    vm.verifyEmail = verifyEmail;
    vm.verifyOTP = verifyOTP;
    vm.reGenerateOtp = reGenerateOtp;
    vm.wrongMsg = '';
    vm.panVerify = false;
    vm.emailVerify = false;
    vm.otpVerify = false;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    var panDetails = {};
    vm.emailMsg = '';
    var token = AuthService.getToken();
    vm.panChanged = panChanged;
    vm.isPanBannedCountryInvalid = false;
    vm.EMAIL_PATTERN = angular.copy(AppConstants.email_regex);
    vm.panAdhaarNotLinked=null;
    vm.appConstants = AppConstants;
    vm.KYC_STATUS = AppConstants.KYC_STATUS;

    switchVerify();

    function verifyPAN() {
      var successHandler = function(resp)
      {
        LoaderService.hideLoader();
        if (resp.data && resp.data['popup-enabled']) {
          vm.panAdhaarNotLinked = resp.data.message;
          return;
        } else if(typeof resp.data === 'undefined') {
            MessageService.error(resp.message);
          }

        if(vm.formData.pan === token.investorPAN){
          MessageService.error("You can not add yourself as Joint Holder.");
          continueModal();
          return;
        }
        var success = function (resp) {
            LoaderService.hideLoader('.popup');
            vm.processFlag = false;
            // resp = {"statusCode":"OK","message":"SUCCESS","data":{"name":"Vinod Kumar Singh","pan":"EHWPS0933K","minor":false,"aadharLinked":false,"newInvestor":false,"emailExists":true,"kycverified":true},"status":true};
            if (resp.status && resp.data) {
              panDetails = resp;
              if (resp.data && resp.data.ekycStatus && (resp.data.ekycStatus === vm.KYC_STATUS.VERIFIED || resp.data.ekycStatus === vm.KYC_STATUS.IN_PROGRESS)) {
                if (resp.data && (angular.isDefined(resp.data.emailExists))
                  && (resp.data.emailExists === true)) {
                  //panDetails.data.email = "";
                  panDetails.data.nriFlag = vm.modalData.nriFlag;
                  $uibModalInstance.close(panDetails);
                } else {
                  switchVerify('emailVerify');
                }
              } else if (resp.data && resp.data.ekycStatus && (resp.data.ekycStatus === vm.KYC_STATUS.NOT_VALIDATED || resp.data.ekycStatus === vm.KYC_STATUS.ON_HOLD)) {
                ModalService.nonKycModal({
                  'text': resp.data.kycStatus === vm.KYC_STATUS.ON_HOLD ? vm.appConstants.ON_HOLD_MESSAGE : vm.appConstants.NOT_VALIDATED_MESSAGE,
                  'showHtml': true,
                  'buttonText': 'OK',
                  'ekycRequestCO': resp.data.ekycRequestCO
                }, function () {
                  vm.formData.pan = null;
                }, function () {
                  vm.formData.pan = null;
                });
              }
            } else {
              if(resp.popupEnabled) {
              vm.isPanBannedCountryInvalid = true;
              vm.bannedCountryMessage = resp.message;
            } else {
              vm.isPanBannedCountryInvalid = false;
              vm.wrongMsg = resp.message;
              MessageService.error(resp.message);}
              // $state.go('main.dashboard');
            }
          },
          error = function () {
            LoaderService.hideLoader('.popup');
            vm.processFlag = false;
            vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
          };
        var payload = {
          pan: vm.formData.pan,
          nriFlag: vm.modalData.nriFlag
        };
        LoaderService.showLoader('.popup');//folio/any-or-survivor/holder/pan/details
        InvestorService.post({
          child1: 'folio',
          child2: 'any-or-survivor',
          child3: 'holder',
          child4: 'pan',
          child5: 'details'
        }, payload).$promise.then(success, error);
      };

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };

      LoaderService.showLoader();
      var payload = {
        panNumber : vm.formData.pan,
        folioNumber : null
      };

      InvestorService.post({
        child1: 'verifyPanAadharLink'
      }, payload).$promise.then(successHandler, errorHandler);
    }

    var emailDetails = {};

    function verifyEmail() {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          if (resp.status && resp.data) {
            emailDetails = resp.data;
            vm.emailMsg = resp.data.message;
            switchVerify('otpVerify');
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
      var payload = {
        pan: vm.formData.pan,
        email: vm.formData.email
      };
      LoaderService.showLoader('.popup');//folio/any-or-survivor/holder/pan/add/email/send/otp
      InvestorService.post({
        child1: 'folio',
        child2: 'any-or-survivor',
        child3: 'holder',
        child4: 'pan',
        child5: 'add',
        child6: 'email',
        child7: 'send',
        child8: 'otp'
      }, payload).$promise.then(success, error);
    }

    function verifyOTP() {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          if (resp.status && resp.data && resp.data.verified) {
            panDetails.data.email = vm.formData.email;
            $uibModalInstance.close(panDetails);
          } else {
            vm.wrongMsg = resp.message;
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
      var payload = {
        uniqueLink: emailDetails.secretLink,
        otp: vm.formData.otp
      };
      LoaderService.showLoader('.popup');//folio/any-or-survivor/holder/pan/add/email/verify/otp
      InvestorService.post({
        child1: 'folio',
        child2: 'any-or-survivor',
        child3: 'holder',
        child4: 'pan',
        child5: 'add',
        child6: 'email',
        child7: 'verify',
        child8: 'otp'
      }, payload).$promise.then(success, error);
    }

    vm.OTPResendMsg = '';

    function reGenerateOtp() {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          if (resp.status && resp.data) {
            vm.OTPResendMsg = resp.data.message;
            vm.emailMsg = "";

          } else {
            vm.wrongMsg = resp.message;
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
      vm.payload = {
        pan: vm.formData.pan,
        secretLink: emailDetails.secretLink,
        email: vm.formData.email
      };
      LoaderService.showLoader('.popup');//folio/any-or-survivor/holder/pan/add/email/resend/otp
      InvestorService.post({
        child1: 'folio',
        child2: 'any-or-survivor',
        child3: 'holder',
        child4: 'pan',
        child5: 'add',
        child6: 'email',
        child7: 'resend',
        child8: 'otp'
      }, vm.payload).$promise.then(success, error);
    }

    function dismissModal(arg) {
      $uibModalInstance.dismiss(arg);
    }

    function continueModal() {
      $uibModalInstance.dismiss('Cancel');
    }

    function switchVerify(verify) {

      switch (verify) {
        case 'panVerify':
          vm.panVerify = true;
          vm.emailVerify = false;
          vm.otpVerify = false;
          break;
        case 'emailVerify':
          vm.panVerify = false;
          vm.emailVerify = true;
          vm.otpVerify = false;
          break;
        case 'otpVerify':
          vm.panVerify = false;
          vm.emailVerify = false;
          vm.otpVerify = true;
          break;
        default:
          vm.panVerify = true;
          vm.emailVerify = false;
          vm.otpVerify = false;
      }

    }

    function panChanged() {
      vm.wrongMsg='';
      vm.isPanBannedCountryInvalid = false;
      vm.panAdhaarNotLinked=null;
    }
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('CreateUserSuccessController', createUserSuccessController);

  /** @ngInject */
  function createUserSuccessController($uibModalInstance, modalData, modalView) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

/**
 * Created by ttn on 09/08/23.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ContactSaveModalController', contactSaveModalController);

  /** @ngInject */
  function contactSaveModalController($uibModalInstance, modalView, modalData,$state, AppConstants,UtilService,MessageService, LoaderService, InvestorServiceVersion3, AuthService) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.pattern = AppConstants;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.closeModal = function () {
      $uibModalInstance.close();
      $state.go('login');
      AuthService.clearCookies(AppConstants.IDENTIFIER);
    };

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ConfirmOtpController', confirmOtpController);

  /** @ngInject */
  function confirmOtpController($uibModalInstance, AppConstants, MessageService, modalData, ModalService, modalView, InvestorService, CreatePayloadFactory ) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.taxIdentifier = vm.modalData.pan;
    vm.email = vm.modalData.email;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.otpResendMessage = '';

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.resetValues = function () {
      vm.errorMessage = "";
    };

    vm.verifyOtp = function () {
      if(vm.modalData.text=='Email Address'){
        vm.verifyOtpforEmail();
      } else vm.verifyOtpforContact();
    };

    vm.verifyOtpforEmail = function () {
      var success = function (resp) {
        if(resp.data && resp.status){
          if(resp.data.userVerificationFlag){
            CreatePayloadFactory.setOTP('true');
            vm.closeModal();
                  var confirmSuccess = function () {
                  },
                    confirmError = function () {
                    };
                  ModalService.confirmOtpSuccessModal({}, confirmSuccess, confirmError);
                } else {
            CreatePayloadFactory.setOTP('false');
            vm.errorMessage = resp.message;
          }
        } else {
          MessageService.error(resp.message);
        }
        vm.processFlag = false;
      }, error = function () {
        vm.processFlag = false;
        vm.errorMessage = AppConstants.ToastrMessage.FAILED;
      };
      var payload = {
        "panNumber":vm.taxIdentifier,
        "value":vm.email
      };
      vm.errorMessage = '';
      vm.processFlag = true;
      InvestorService.post({
        child1: 'registration',
        child2: 'edit',
        child3: 'email',
        child4: 'verify'
      }, payload).$promise.then(success, error);
    };

    vm.verifyOtpforContact = function () {
      var success = function (resp) {
        if(resp.data && resp.status){
          if(resp.data.userVerificationFlag){
            CreatePayloadFactory.setOTP('true');
            vm.closeModal();
            var confirmSuccess = function () {
              },
              confirmError = function () {
              };
            ModalService.confirmOtpSuccessModal({}, confirmSuccess, confirmError);
          } else {
            CreatePayloadFactory.setOTP('false');
            vm.errorMessage = resp.message;
          }
        } else {
          MessageService.error(resp.message);
        }
        vm.processFlag = false;
      }, error = function () {
        vm.processFlag = false;
        vm.errorMessage = AppConstants.ToastrMessage.FAILED;
      };
      var payload = {
        "panNumber":vm.taxIdentifier,
        "value":vm.email
      };
      vm.errorMessage = '';
      vm.processFlag = true;
      InvestorService.post({
        child1: 'registration',
        child2: 'edit',
        child3: 'mobile',
        child4: 'verify'
      }, payload).$promise.then(success, error);
    };
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ConfirmLoginController', confirmLoginController);

  /** @ngInject */
  function confirmLoginController($window, $state, $scope, $timeout, $uibModalInstance,AuthService,LoaderService, AppConstants, MessageService, modalData, ModalService, modalView, InvestorService, InvestorFileUploadService ) {
    var vm = this;
    vm.init = init;
    vm.view = modalView;
    vm.modalData = modalData.data;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.otpResendMessage = '';
    var singleUseURL = "";

    function init() {
      if (vm.modalData.detail.loginType === 'OTP') {
        vm.loginType = 'PAN';
        vm.modalContent = "As per requirements of AMFI Best Practices Guidelines on Electronic Transactions Circular No. 74/ 2018-19, two factor authentication is required to complete the transaction. Request you to please provide PAN of the first holder/guardian registered in the account.";
        // vm.reGenerateOtp();
      } else if (vm.modalData.detail.loginType === 'ThroughPassword') {
        vm.loginType = 'OTP';
        vm.modalContent = "As per requirements of AMFI Best Practices Guidelines on Electronic Transactions Circular No. 74/ 2018-19, two factor authentication is required to complete the transaction. Request you to please enter OTP sent to your registered email ID and mobile number.";
        vm.reGenerateOtp();
      }
    }

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.resetValues = function () {
      vm.errorMessage = "";
    };

    var resetTimer = function () {
      $scope.$broadcast('timer-add-cd-seconds', 30);
      $timeout(function () {
        vm.sentOtpRespMsg = '';
      },29000)
    }

    vm.reGenerateOtp = function () {
      var success = function (resp) {
          vm.processFlag = false;
          if (resp.data && resp.status) {
            singleUseURL = resp.data.secretLink;
            vm.sentOtpRespMsg = resp.data.message|| 'OTP sent again successfully again.';
            // resetTimer();
          } else {
            MessageService.error(resp.message);
            vm.dismissModal();
          }
        },
        error = function () {
          vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      var payload = {
        "userId" : vm.modalData.detail.userId,
        "twoFactorOption" : vm.modalData.detail.calledOption
      };
      if(vm.modalData.detail.calledOption === 'SWITCH' || vm.modalData.detail.calledOption === 'REDEMPTION'){
        payload.folioNumber = vm.modalData.payload.folioNumber;
      }
      if(vm.modalData.detail.calledOption === 'COBM-DELETE-BANK' || vm.modalData.detail.calledOption === 'COBM-ADD-BANK' || vm.modalData.detail.calledOption === 'COBM-DEFAULT-BANK'){
        payload.twoFactorOption = 'COBM';
      }
      vm.errorMessage = '';
      vm.processFlag = true;
      vm.sentOtpRespMsg = '';
      InvestorService.post({
        child1: '2fa',
        child2: 'generate',
        child3: 'otp'
      }, payload).$promise.then(success, error);
    };

    vm.verify = function () {
      LoaderService.showLoader('.called-loader');
      if (vm.modalData.detail.loginType === 'OTP') {
        var req = {
          "twoFactorPanAuthenticationCO": {
            "pan": vm.formData.pan
          }
        }
      } else {
        req = {
          "twoFactorPinAuthenticationCO": {
            "secretLink": singleUseURL,
            "otp": vm.formData.otpNumber,
            "userId": vm.modalData.detail.userId
          }
        }
      }
      vm.setPayloadforApprove(req);
    };

    vm.setPayloadforApprove = function (req) {
      switch (vm.modalData.detail.calledOption) {
        case 'SWITCH':
          req.switchForm = vm.modalData.payload;
          req.twoFactorOption = vm.modalData.detail.calledOption;
          verifytwoFactorAuthentication(req);
          break;
        case 'REDEMPTION':
          req.redemptionForm = vm.modalData.payload;
          req.twoFactorOption = vm.modalData.detail.calledOption;
          verifytwoFactorAuthentication(req);
          break;
        case 'EMAIL':
          req.editFieldCO = vm.modalData.payload;
          req.twoFactorOption = vm.modalData.detail.calledOption;
          verifytwoFactorAuthentication(req);
          break;
        case 'COBM-ADD-BANK':
          var fd = new FormData();
          fd.append('bankCO', vm.modalData.payload.bankCO);
          fd.append('newBankProof', vm.modalData.payload.newBankProof);
          fd.append('oldBankProof', vm.modalData.payload.oldBankProof);
          if(vm.modalData.detail.loginType === 'OTP'){
            fd.append('pan', vm.formData.pan);
          } else {
            fd.append('secretLink', singleUseURL);
            fd.append('otp', vm.formData.otpNumber);
          }
          verifytwoFactorAuthenticationCOBMAddBank(fd);
          break;
        case 'COBM-DELETE-BANK':
          fd = new FormData();
          fd.append('bankCO', vm.modalData.payload.bankCO);
          fd.append('bankProof', vm.modalData.payload.oldBankProof);
          if(vm.modalData.detail.loginType === 'OTP'){
            fd.append('pan', vm.formData.pan);
          } else {
            fd.append('secretLink', singleUseURL);
            fd.append('otp', vm.formData.otpNumber);
          }
          verifytwoFactorAuthenticationCOBMDeleteBank(fd);
          break;
        case 'COBM-DEFAULT-BANK':
          req.bankCO = $window.JSON.parse(vm.modalData.payload);
          req.twoFactorOption = 'COBM';
          verifytwoFactorAuthenticationCOBMDefaultBank(req);
          break;
      }
    };

    var verifytwoFactorAuthentication = function (payload) {
      var success = function (resp) {
          LoaderService.hideLoader('.called-loader');
          if (resp.data && resp.status) {

            if(vm.modalData.detail.calledOption === 'SWITCH' || vm.modalData.detail.calledOption ==='REDEMPTION'){
              var isFavourite = (vm.modalData && vm.modalData.payload && vm.modalData.payload.isFavourite ) ? true : false;
              $state.go('main.summary-success', {
                transactionId: resp.data.data,
                transactionType: vm.modalData.detail.calledOption,
                isFavourite: isFavourite
              });
              vm.closeModal();
            } else if(vm.modalData.detail.calledOption === 'EMAIL') {
              MessageService.success(resp.data.message);
              vm.closeModal();
            }

          } else {
            vm.errorMessage = resp.message;
          }
          vm.processFlag = false;
        },
        error = function () {
          LoaderService.hideLoader('.called-loader');
          vm.processFlag = false;
          vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      vm.errorMessage = '';
      vm.processFlag = true;
      InvestorService.post({
        child1: '2fa',
        child2: 'validate',
        child3: vm.modalData.detail.loginType !== 'OTP' ? 'otp' : 'pan',
        child4: 'approve'
      }, payload).$promise.then(success, error);
    };

    var verifytwoFactorAuthenticationCOBMAddBank = function (payload) {
      var success = function (resp) {
          LoaderService.hideLoader('.called-loader');
          if (resp.data && resp.status) {
            if (resp.data.message) {
              MessageService.success(resp.data.message);
              $state.go('main.profile.folioDetails');
              vm.closeModal();
            }
          } else {
            vm.errorMessage = resp.message;
          }
          vm.processFlag = false;
        },
        error = function () {
          LoaderService.hideLoader('.called-loader');
          vm.processFlag = false;
          vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      vm.errorMessage = '';
      vm.processFlag = true;
      InvestorFileUploadService.post({
        child1: '2fa',
        child2: 'validate',
        child3: 'bank',
        child4: 'add',
        child5: vm.modalData.detail.loginType !== 'OTP' ? 'otp' : 'pan',
        child6: 'approve'
      }, payload).$promise.then(success, error);
    };

    var verifytwoFactorAuthenticationCOBMDeleteBank = function (payload) {

      var success = function (resp) {
          LoaderService.hideLoader('.called-loader');
          if (resp.data && resp.status) {
            if (resp.data.message) {
              MessageService.success(resp.data.message);
              $state.go('main.profile.folioDetails');
              vm.closeModal();
            }
          } else {
            vm.errorMessage = resp.message;
          }
          vm.processFlag = false;
        },
        error = function () {
          LoaderService.hideLoader('.called-loader');
          vm.processFlag = false;
          vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      vm.errorMessage = '';
      vm.processFlag = true;
      InvestorFileUploadService.post({
        child1: '2fa',
        child2: 'validate',
        child3: 'bank',
        child4: 'delete',
        child5: vm.modalData.detail.loginType !== 'OTP' ? 'otp' : 'pan',
        child6: 'approve'
      }, payload).$promise.then(success, error);
    };

    var verifytwoFactorAuthenticationCOBMDefaultBank = function (payload) {

      var success = function (resp) {
          LoaderService.hideLoader('.called-loader');
          if (resp.data && resp.status) {
            if (resp.data.message) {
              MessageService.success(resp.data.message);
              $state.go('main.profile.folioDetails');
              vm.closeModal();
            }
          } else {
            vm.errorMessage = resp.message;
          }
          vm.processFlag = false;
        },
        error = function () {
          LoaderService.hideLoader('.called-loader');
          vm.processFlag = false;
          vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      vm.errorMessage = '';
      vm.processFlag = true;
      InvestorService.post({
        child1: '2fa',
        child2: 'validate',
        child3: 'bank',
        child4: 'default',
        child5: vm.modalData.detail.loginType !== 'OTP' ? 'otp' : 'pan',
        child6: 'approve'
      }, payload).$promise.then(success, error);
    };

    vm.reSendOtp = function () {
      LoaderService.showLoader('.called-loader');
      vm.errorMessage = '';
      var payload = {
        secretLink: singleUseURL,
        twoFactorOption : vm.modalData.detail.calledOption
      };
      if(vm.modalData.detail.calledOption === 'SWITCH' || vm.modalData.detail.calledOption === 'REDEMPTION'){
        payload.folioNumber = vm.modalData.payload.folioNumber;
      }
      if(vm.modalData.detail.calledOption === 'COBM-DELETE-BANK' || vm.modalData.detail.calledOption === 'COBM-ADD-BANK' || vm.modalData.detail.calledOption === 'COBM-DEFAULT-BANK'){
        payload.twoFactorOption = 'COBM';
      }
      var success = function (res) {
        LoaderService.hideLoader('.called-loader');
        if (res.data && res.status) {
          resetTimer();
          MessageService.success(res.data.message);
        }
        else {
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        LoaderService.hideLoader('.called-loader');
        MessageService.error(err.message);
      };
      InvestorService.post({
        child1: '2fa',
        child2: 'resend',
        child3: 'otp'
      }, payload).$promise.then(success, error);
    }


  }

})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ConfirmCancelController', confirmCancelController);

  /** @ngInject */
  function confirmCancelController($uibModalInstance, modalView, modalData,TransactionService,UtilService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.modalData.message = 'Are you sure, you want to cancel this action?';
    if(modalData.Text) {
      vm.modalData.message = modalData.Text;
    }
    if(modalData.ButtonProceed){
      vm.buttonProceed = true;
      vm.buttonCancel = true;
    }

    vm.closeModal = function () {
      $uibModalInstance.close(vm.reason);
    };

    vm.modifySip = function (resp) {
      $uibModalInstance.close(resp);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.closeSipModal = function (resp1) {
      var success = function(resp) {
          if(resp.status && resp.data) {
            if(resp1 === 'cancel')
              $uibModalInstance.close(resp.data.requestId);
            else
              $uibModalInstance.dismiss("cancel");
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      var payload = {
        folioNumber: modalData.folioNumber,
        popUpType: 'SIP_CANCELLATION_NUDGE',
        nudgeSuccess: resp1 !== 'cancel'
      };

      TransactionService.post({
        controller1: 'nudge',
        controller2: 'request'
      }, payload).$promise.then(success, error);
    };

    vm.dismissSipModal = function (resp1) {
        var success = function(resp) {
            if(resp.status && resp.data) {
              if(resp1 === 'pause')
              $uibModalInstance.close(resp1);
              else
                $uibModalInstance.close(resp.data.requestId);
            }
          },
          error = function (err) {
            UtilService.errorHandler(err);
          };

        var payload = {
          folioNumber: modalData.folioNumber,
          nudgeSuccess: resp1 === 'pause',
          popUpType:'SIP_PAUSE_CANCELLATION_NUDGE'
        };

        TransactionService.post({
          controller1: 'nudge',
          controller2: 'request'
        }, payload).$promise.then(success, error);
    };

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ChangeDividendModalController', changeDividendModalController);

  /** @ngInject */
  function changeDividendModalController($uibModalInstance, modalView,$log, modalData,HDFC_API) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.view = modalView;
    vm.modalData = modalData;
    $log.info(vm.modalData);
    vm.schemeName = vm.modalData.schemeName? vm.modalData.schemeName : null;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('CancelSipController', cancelSipController);

  /** @ngInject */
  function cancelSipController($uibModalInstance,LoaderService,InvestorService,$log,MessageService, modalView, modalData, ModalService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    if(vm.modalData.id){
      vm.id = vm.modalData.id;
      vm.type = vm.modalData.type;
    }
    vm.cancelTransaction = cancelTransaction;

    function cancelTransaction(id,type) {
      var successAPI = function (resp) {
          LoaderService.hideLoader('.loader');
          if (resp.data && resp.status) {
            $log.info(resp.data.trnxActionFlag);
            vm.closeModal("success");
          }
          else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              });
            } else {
              MessageService.error(resp.message);
              vm.closeModal("error");
            }
          }
        },
        errorAPI = function (err) {
          LoaderService.hideLoader('.loader');
          MessageService.error(err.message);
          $log.info("cancel error====", err);
        };
      LoaderService.showLoader('.loader');
      InvestorService.post({
        child1: 'transaction',
        child2: 'cancel'
      }, {"transactionId":id, "transactionType":type}).$promise.then(successAPI, errorAPI);
    }

    vm.closeModal = function (status) {
      $uibModalInstance.close(status);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/*
* Created by ttn at 21/09/2020
* */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('CancelNomineeController', cancelNomineeController);

  /** @ngInject */
  function cancelNomineeController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.tandcCheck = false;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    vm.closeModal = function () {
      $uibModalInstance.close("cancel");
    }

    vm.tncCheck = function () {
      vm.tandcCheck = true;
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('CancelMandateController', cancelMandateController);

  /** @ngInject */
  function cancelMandateController($uibModalInstance, modalView, modalData){
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
  }

})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('BasketSipInstallmentDetails', basketSipInstallmentDetails);

  /** @ngInject */
  function basketSipInstallmentDetails($uibModalInstance,ModalService, modalView,AuthService, modalData,$state,InvestorServiceVersion3,LoaderService,$window,$timeout,MessageService){
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.installmentFrequency = 'Monthly';
    vm.viewMode = 'days';
    vm.enabledStartDatesList = [];
    vm.formData = {};
    vm.endDate = $window.moment().format('DD-MMM-YYYY')
    setStartDate();

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    function setStartDate () {
      var currentDate =  $window.moment();
      vm.daysList = ["Monday","Tuesday","Wednesday","Thursday","Friday"];
      var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
      var todayDate = $window.moment(Date.parse(parsedDate));
      var counter =0;
      vm.nonBusinessDatess = [];
      vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(11, 'days');
      vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
      var startDate = todayDate.clone();
      var freq = vm.startMaxDate.diff(todayDate, 'days');
      for (var i = 0; i <= freq; i++) {
        var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
        var isEnable = true;
        if(counter<5)
        {
          angular.isArray(vm.nonBusinessDatess) && vm.nonBusinessDatess.forEach(function (value) {
            if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')===0){
              isEnable = false;
            }
          });
        }
        if(isEnable){
          vm.enabledStartDatesList.push(startDate.clone().add(i, 'days'));
          counter++;
        }
      }

      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      });
    }

    vm.changeStartDate = function(date) {
      if (date) {
        vm.formData.startDate = date;
      }
    };

    vm.proceedToFolioCreation = function() {
      $state.go('main.folio.holdmode');
    };

  }

})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ArnPopupController', arnPopupController);

  /** @ngInject */
  function arnPopupController($uibModalInstance,ModalService, modalView,AuthService, modalData,$state,InvestorServiceVersion3,LoaderService,$window,CreatePayloadFactory,MessageService){
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    if(localStorage.getItem("distributorDetails")) {
      vm.distributorDetails = $window.JSON.parse(localStorage.getItem("distributorDetails"));
    } else if(sessionStorage.getItem("distributorDetails")){
      vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    }

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
      if(vm.modalData.status == 'EMPTYBANKLIST'){
        window.history.go(-1);
      }
    };
    vm.closeModal = function () {
      if(vm.modalData.status == 'EMPTYBANKLIST' || vm.modalData.status == 'HDFCBANKLIST'){
      $uibModalInstance.close('createNewFolio');
     }else{
      $uibModalInstance.close();
     }
    };
    vm.process = function () {
      if(vm.distributorDetails && vm.distributorDetails.flowName && vm.distributorDetails.flowName == 'E_CART'){
        verifyDetailsFromEcart();
      } else {
        verifyDetails();
      }

      // var success = function (resp) {
      //   // $state.go("newInvestor");
      //   $state.go("newInvestor.otpVerification");
      //   $uibModalInstance.close();
      // },error = function (resp) {

      // }
      // var payload = {
      //   dob: vm.modalData.data.dob,
      //   panNumber: vm.modalData.data.panNumber
      // };
      // sessionStorage.setItem("panDetails", JSON.stringify(payload));
      // vm.processFlag = true;
      // InvestorServiceVersion3.post({
      //   child1: 'registration',
      //   child2: 'new',
      //   child3: 'user',
      //   child4: 'verifyKYC'
      // }, payload).$promise.then(success, error);

    };

    vm.ekyc = function(){
      $state.go("ekyc");
      $uibModalInstance.close();
    }
    function verifyDetails() {
      // $window.sessionStorage.setItem("onotp", false);
      // vm.distributorDetails = $window.JSON.parse($window.localStorage.getItem("distributorDetails"));
      // vm.PARTNER_DATA =JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
      // if(!vm.PARTNER_DATA){
      //   $window.sessionStorage.setItem("distributorDetails", JSON.stringify(vm.distributorDetails));
      // }
      // $window.localStorage.removeItem("distributorDetails");
      // $state.go("newInvestor.kycVerification", {
      //   verificationData: {
      //     dob: vm.modalData.data.dob,
      //     panNumber: vm.modalData.data.panNumber
      //   }
      // })
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.processFlag = false;
          vm.userData = resp.data
          vm.registrationType = resp.data.registrationType;
          resp.data.PAN = vm.modalData.data.panNumber;
          resp.data.dob = vm.modalData.data.dob;
          CreatePayloadFactory.set(resp.data);
          //passing data to otp confirmation
          var verifyObj = {
            maskedEmail: resp.data.maskedEmail,
            maskedMobile: resp.data.maskedMobile,
            secretLink: resp.data.secretLink,
            panHolderName: resp.data.panHolderName,
            dob: vm.modalData.data.dob,
            panNumber: vm.modalData.data.panNumber,
            kycVerifiedFlag: resp.data.kycVerifiedFlag,
            kycStatus: resp.data.kycStatus,
            registrationType: resp.data.registrationType
          }
          vm.userDetails = verifyObj;
          $window.sessionStorage.setItem("verifyObj", JSON.stringify(verifyObj));
          $window.sessionStorage.setItem("onotp", true);
          vm.distributorDetails = $window.JSON.parse($window.localStorage.getItem("distributorDetails"));
          vm.PARTNER_DATA =JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
          if(!vm.PARTNER_DATA){
            $window.sessionStorage.setItem("distributorDetails", JSON.stringify(vm.distributorDetails));
          }
          $window.localStorage.removeItem("distributorDetails");
            $state.go("newInvestor.otpVerification")
          $uibModalInstance.close();
        } else{
          $uibModalInstance.close();
          MessageService.error(resp.message);
        }
      },
        error = function (resp) {
          if (resp && resp.message) {
            var messages = resp.message + '<span class="' + Math.random() + '"></span>';
            toastr.error(messages, '', {
              allowHtml: true,
              preventDuplicates: false,
              onHidden: function () {
                vm.processFlag = false;
              }
            });
          } else {
            MessageService.error();
          }
          LoaderService.hideLoader();
        };
      sessionStorage.setItem("panDetailsEncrypted", AuthService.encryptRSA(vm.modalData.data.panNumber));
      var payload = {
        dob: vm.modalData.data.dob,
        panNumber: vm.modalData.data.panNumber,
        nriFlag: vm.distributorDetails.nriFlag
      };
      sessionStorage.setItem("panDetails", JSON.stringify(payload));
      vm.processFlag = true;
      LoaderService.showLoader();
      InvestorServiceVersion3.post({
        child1: 'registration',
        child2: 'new',
        child3: 'user',
        child4: 'verifyKYC'
      }, payload).$promise.then(success, error);
    }

    vm.addNewFolio = function(){
      $state.go("newInvestor.investmentDetails.schemedetails.selectscheme");
      $uibModalInstance.close();
    }
    vm.home = function(){
      $uibModalInstance.close('home');
    }

    function verifyDetailsFromEcart(){
      $state.go('arnReview.select-folio', {
        pan: $window.btoa(vm.modalData.data.panNumber)
      });
    }


  }

})();



 (function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ArnAddBankModalController', ArnAddBankModalController);

  /** @ngInject */

  function ArnAddBankModalController(AuthService, $uibModalInstance,ModalService,MessageService,modalView,$log,InvestorService,modalData,AppConstants,LoaderService, UtilService, $window, InvestorFileUploadService, $filter) {
    var vm = this;
    vm.init = init;
    vm.stateToGo = 'sip';
    vm.view = modalView;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.modalData = modalData.data;
    vm.payload = {};
    vm.payload.bankDetails = {};
    vm.verifyAccountNumber = "";
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.uploadChequeLeafFileOld = uploadChequeLeafFileOld;
    vm.openUploadedDocOld = openUploadedDocOld;
    vm.breakFileUrl = breakFileUrl;
    vm.chooseAFileOld = true;
    vm.chequeLeafUrl = '';
    vm.chequeLeafUrlOld = '';
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.bankDetails =  {};
    vm.payload.folioNumber = vm.modalData.folioNumber;
    vm.payload.makeDefaultBank = false;
    vm.isCheckedCobmTandC = false;
    vm.profile = AuthService.getInstaToken();

    function init() {
      $window.scrollTo(0, 0);
      getPayoutMechanism();
      getAccountType();
      vm.constraints = angular.fromJson($window.sessionStorage.getItem('bankConstraints'));
    }

    vm.selectIFSC = function () {
      var successModal = function (data) {
        vm.payload.ifsccode = data.ifscCode;
        vm.payload.bankName = data.bankName;
        vm.payload.bankCity = data.branchCity;
        vm.payload.branchLocation = data.branch;
        if (data.branch && data.branch.length > 40)
          vm.payload.bankBranch = data.branch.slice(0, 40)
        else vm.payload.bankBranch = data.branch;
        vm.payload.accountType ="SB";
        vm.payload.bankDetails.payoutMechanism = "DC";

      },
      errorModal = function () {
        
      };
      ModalService.IFSCSelectionModalNewJourney({ bankList: vm.bankList, key : 'arn' }, successModal, errorModal);
    }
    function getDetails() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if(resp.status && resp.data && resp.data.cobmEnabled){
        vm.folioDetails = resp.data;
        vm.folioTaxStatus = resp.data.folioTaxStatusCode;
        vm.uploadChequeLeafEnabled = resp.data.uploadChequeLeafEnabled;
        vm.payload.pennyDropValid = vm.folioTaxStatus === '01' ? true : false;
        vm.defaultBank = resp.data.bankDetails;
        vm.defaultBank = $filter('filter')(resp.data.bankDetails,
          {
            defaultBank: true
          })
        getAccountType();
      }else{
        if(resp.message == 'SUCCESS'){
          MessageService.error("This folio not allowed to add new bank.");
          $uibModalInstance.close();
        }else{
          MessageService.error(resp.message);
          $uibModalInstance.close();
        }
      }
      }, error = function () {
        LoaderService.hideLoader();
        getAccountType();
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: vm.modalData.folioNumber}).$promise.then(success, error);
    }
    getDetails();
    function getAccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };
        vm.folioTaxStatus = "01";
      InvestorService.post({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list'
      },{invTypeDesc:vm.folioTaxStatus}).$promise.then(success, error);
    }
    function accFocus() {
      vm.accModelDirty = true;
      vm.chooseAFileNew = true;
      vm.bankDetails.chequeLeaf='';
      vm.bankDetails.chequeLeafUrlNew='';
      angular.element("#uploadCheckLeafNew").val("");
      if(pennyDropEnablSelectedBank){
        vm.payload.pennyDropValid = true;
      }
    }
    function getPayoutMechanism() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payoutMechanismList = resp.data.payoutMechanisms;
             resp.data.payoutMechanisms.map(function(pm){
              if(pm.payoutCode=="DC"){
                vm.payload.payoutMechanism = pm.payoutCode;
              }
            });
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'payout-mechanism', child3: 'cobm'}).$promise.then(success, error);
    }
    getPayoutMechanism();
    vm.logoutMe = function () {
      $uibModalInstance.dismiss();
    };
    vm.dismissModal = function () {
      $uibModalInstance.close();
    };

    vm.addBankSubmit = function() {
      if(vm.fileNew.type!==vm.fileOld.type){
        MessageService.error("Both Bank Proofs must be of same file extensions");
      } else {
        addBankSuccessful();
      }
    }

    function addBankSuccessful() {
      var success = function (res) {
        LoaderService.hideLoader();
        if (res.status) {
          var successModal = function () {
            $uibModalInstance.close();
          }, errorModal = function () {};
          ModalService.addBankModal({ modalPayload: vm.payload, requestType: 'add' }, successModal, errorModal);
        } else {
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        $log.info(err);
        UtilService.errorHandler(err);
      };
      vm.fd = new FormData();
      var tempFormdata = angular.copy(vm.payload);
      var panNumber = vm.payload.panNumber;
      delete tempFormdata.bankDetails;
      delete tempFormdata.branchLocation;
      vm.fd.append('bankCO', $window.JSON.stringify(tempFormdata));
      vm.fd.append('panNumber', vm.modalData.panNumber);
      vm.fd.append('newBankProof', vm.fileNew);
      vm.fd.append('oldBankProof', vm.fileOld);
      LoaderService.showLoader();
      InvestorFileUploadService.post({
        child1: 'arnHardCode',
        child2: 'bank',
        child3: 'add'
      }, vm.fd).$promise.then(success, error);
    }
    function uploadChequeLeafFile(file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          vm.fileNew = file;
          vm.bankDetails.chequeLeaf = file.name;
          vm.chooseAFileNew = false;
        }
        else {
          MessageService.error("File size should not be more than 2 MB.");
          vm.chooseAFileNew = true;
        }
      }

    }
    function uploadChequeLeafFileOld(file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          vm.fileOld = file;
          vm.bankDetails.chequeLeafOld = file.name;
          vm.chooseAFileOld = false;
        }
        else {
          MessageService.error("File size should not be more than 2 MB.");
          vm.chooseAFileOld = true;
        }
      }

    }

    function breakFileUrl(url, type) {
      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      if (type === 'add') {
        vm.chequeLeafUrlNew = a[a.length - 1] + extension;
        vm.chooseAFileNew = false;
      }
      else if (type === 'modify') {
        vm.chequeLeafUrlOld = a[a.length - 1] + extension;
        vm.chooseAFileOld = false;
      }

    }

    function openUploadedDoc() {
      if(angular.isUndefined(vm.fileNew)){return;}
      ModalService.showImage({docUrl: vm.fileNew});
    }
    function openUploadedDocOld() {
      if(angular.isUndefined(vm.fileOld)){return;}
      ModalService.showImage({docUrl: vm.fileOld});
    }
    vm.validatePennyDropDetails = function() {
      vm.payload.accountHolderName = vm.profile.investorName;
      var pennyDropValidatePayload = {
        "beneficiaryIFSC":vm.payload.ifsccode,
        "benificiaryAccountNo":vm.payload.accountNumber,
        "benificiaryName":vm.profile.investorName,
        "folioNo": vm.profile.folioNumber
      };
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if(resp.data.valid === false) {
              if (!vm.uploadChequeLeafEnabled) {
                if (resp.data.cobmMessage) {
                  MessageService.error(resp.data.cobmMessage);
                } else {
                  MessageService.error(resp.data.message || "We are unable to validate your bank account using IMPS service. Please upload cheque leaf to continue with add bank");
                }
              }else {
                MessageService.error(resp.data.message || "We are unable to validate your bank account using IMPS service. Please upload cheque leaf to continue with add bank");
              }
              vm.payload.pennyDropValid = vm.uploadChequeLeafEnabled ? false : true;
            } else {
              vm.payload.pennyDropValid = true;
              vm.disableAccntDetails = true;
              vm.payload.accountHolderName = resp.data.name;
              addBankSuccessful();
            }
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };

      InvestorService.post({
        child1: 'account',
        child2: 'validate',
        child3: 'pennyDrop'
      }, pennyDropValidatePayload).$promise.then(success, error);

    }
    vm.showCobmTermConditions = function () {
      ModalService.nonTransactionalTncModal({type:'COBM',dynamicTransactionData:vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_ADD_NEWBANK});
    };
    function getdynamicContent() {
      
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.dynamicData = resp.data;
          vm.showTerms = true;  
          if (vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK) {
            vm.note = vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK.content;
          }
          if (vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK_LIST) {
            vm.noteBankRestrict = vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK_LIST.content;
          }
          if(!vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_ADD_NEWBANK) {
            vm.showTerms = false;
          }
        }else {
           UtilService.errorHandler("Something Went wrong , please try again later");
        }
        }, failure = function(resp) {
             MessageService.error(resp)
             LoaderService.hideLoader();
        };
        var payload = {
          "pageName":"ADD_NEW_BANK"
        }
        LoaderService.showLoader();
        InvestorService.post({child1: 'dynamicContent'}, payload).$promise.then(success, failure);
    }
    getdynamicContent();
  
    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('AddLinkPanController', addLinkPanController);

  /** @ngInject */
  function addLinkPanController($uibModalInstance, modalView, modalData,AuthService,MessageService, AppConstants, LoaderService, InvestorService,  $rootScope) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;  
    vm.newLinkedPanPayload = {
      pan:'',
      mobile:''
    } 
    vm.otpVerify = false; 
    vm.resetValues = resetValues; 
    vm.resetErrorms = resetErrorms;
    vm.checkPanVerification = checkPanVerification;
    vm.resendOTP = resendOTP;
    vm.folioList = [];
    vm.processFlag = false; 
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.appConstants = AppConstants;
    vm.panMessage = "";
    vm.STEPS = "GET_PAN_MOBILE";
    vm.folioNumber = '';
    vm.maskFolioList = maskFolioList;
    vm.maskid = maskid;
    vm.maskeEmail = maskeEmail;
    vm.maskemobileNo = maskemobileNo;
    function checkPanVerification() {
        var success = function (resp) {
          LoaderService.hideLoader(); 
          if (resp.data && resp.status) { 
            if (resp.data && resp.data.length > 0) {
              vm.FolioList = maskFolioList(resp.data);
              vm.STEPS = 'SELCT_FOLIO';
            } else {
              vm.panMessage = resp.data.message;
            } 
          } else { 
            vm.FolioList =[];
            vm.panMessage = resp.message;
          }
        },error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err.data.message);
            vm.FolioList =[];
        };
        vm.processFlag = true;
        LoaderService.showLoader();
        var payload = { 
          "panNumber": AuthService.encryptRSA(angular.copy(vm.newLinkedPanPayload.pan)),
          "mobile": AuthService.encryptRSA(angular.copy(vm.newLinkedPanPayload.mobile))
        }
        InvestorService.post({child1: 'switch',child2: 'user',child3:'getListOfFolio'}, payload).$promise.then(success, error);
    }
    function resetValues() {
      vm.panMessage = "";
      if(vm.newLinkedPanPayload && vm.newLinkedPanPayload.pan){
        var token = AuthService.getToken(); 
        if(vm.newLinkedPanPayload.pan === token.investorPAN){
          MessageService.error("Please enter diffrenet PAN number which is login.");
          vm.newLinkedPanPayload.pan = '';
          return;
        }
        if($rootScope.LinkedPAN &&  $rootScope.LinkedPAN.has(vm.newLinkedPanPayload.pan)){
          vm.newLinkedPanPayload.pan = '';
          MessageService.error("The entered external PAN is already linked with logged in PAN.");
        }
      }
    }
    function resetErrorms() {
      vm.panMessage = "";
    }
    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    function resendOTP() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.otpMessage = resp.data.message;
          MessageService.success(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function () {
        LoaderService.hideLoader();  
        MessageService.error(AppConstants.ToastrMessage.FAILED);
      };
      vm.processFlag = true;
      LoaderService.showLoader();
      var payload = {
        "secretLink": vm.secretLink
      }
      InvestorService.post({ child1: 'switch', child2: 'user', child3: 'otp',child4:'resend' }, payload).$promise.then(success, error);
    } 
    function maskFolioList(dataList){
      if(dataList && dataList.length > 0){
        var folioListLength =  dataList.length;
        var tempList = [];
        var tempObj = {};
        for (var i = 0; i < folioListLength; i++) {
            tempObj = {};
            tempObj.folioNumber = dataList[i].id;
            tempObj.maskedFolioNumber = maskid(dataList[i].id);
            tempObj.mobile = dataList[i].mobileNo;
            tempObj.maskedMobile = maskemobileNo(dataList[i].mobileNo);
            tempObj.email = dataList[i].email;
            tempObj.maskedEmail = maskeEmail(dataList[i].email);
            tempObj.minorFlag = dataList[i].minorFlag;
            tempList.push(tempObj);
        }
        return tempList;
      }else{
        vm.folioList = [];
      }
    }
    function maskeEmail(email) {
      if (email) {
        if (!email) {
          return;
        }
        var valArray = email.split("@");
        var startVal = valArray[0];
        var endVal = valArray[1];
        var maskyVal = "";
        for (var i = 0; i < startVal.length; i++) {
          if (i == 0) {
            maskyVal += startVal[i];
          }
          if (i == 1) {
            maskyVal += "*";
          }
          if (i > 1) {
            var t = i % 2;
            if (t == 0) {
              maskyVal += startVal[i];
            } else {
              maskyVal += "*";
            }
          }
        }
        var maksemail = maskyVal + "@" + endVal;
        return maksemail;
      }
    }
    function maskid(val) {
      var endVal = val.substr(-3);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 3) {
        maskyVal += "*";
        valLength--;
      }
      return maskyVal + endVal;
    }
    function maskemobileNo(val) {
      if (!val || val == "null") {
          return val = "";
      }
      if (val == 'Not updated') {
          return val = val;
      }
      var endVal = val.substr(-4);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 4) {
          maskyVal += "*";
          valLength--;
      }
      return maskyVal + endVal;
    }
    vm.sendOtp = function(){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.secretLink = resp.data.secretLink;
          vm.STEPS = "VERIFY_OTP";
          vm.otpMessage = resp.data.message;
        } else {
          MessageService.error(resp.message);
        }
      }, error = function () {
        LoaderService.hideLoader();  
        MessageService.error(AppConstants.ToastrMessage.FAILED);
      };
      vm.processFlag = true;
      LoaderService.showLoader();
      var payload = {
        "folio": AuthService.encryptRSA(angular.copy(vm.folioNumber))
      }
      
      InvestorService.post4({ child1: 'switch', child2: 'user', child3: 'otp',child4:'generate' }, payload).$promise.then(success, error);
    }
    vm.verifyotp = function(){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) { 
          $uibModalInstance.close(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
      }, failure = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.data.message);
      };
      LoaderService.showLoader();
      var payload = {
        "secretLink": vm.secretLink,
        "otp": vm.otp,
        "externalPan": AuthService.encryptRSA(vm.newLinkedPanPayload.pan)
      }
      InvestorService.post({ child1: 'switch',child2:'user',child3:'verify',child4:'otp',child5:'add',child6:'update',child7:'pan'},payload).$promise.then(success, failure);
    }
    vm.otpValChanged = function(myvalue) { 
      vm.otp = vm.otp1 + vm.otp2 + vm.otp3 + vm.otp4 + vm.otp5 + vm.otp6;
      vm.otpCodeLength = vm.otp.toString().length
      var container = document.getElementsByClassName("input-code")[0];
      container.onkeyup = function (e) {
        var target = e.target;

        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          var next = target;
          while (next = next.nextElementSibling) {
            if (next == null)
              break;
            if (next.tagName.toLowerCase() == "input") {
              next.focus();
              break;
            }
          }
        } else if (myLength < maxLength) {
          var prev = target;
          while (prev = prev.previousElementSibling) {
            if (prev == null)
              break

            if (prev.tagName.toLowerCase() == "input") {
              prev.focus();
              break;
            }
          }
        }
      }
    };
    $rootScope.otpPasteInVariable = function(otp) {
      vm.otp = otp; 
      vm.otp1 = otp[0]; 
      vm.otp2 = otp[1]; 
      vm.otp3 = otp[2]; 
      vm.otp4 = otp[3]; 
      vm.otp5 = otp[4]; 
      vm.otp6 = otp[5]; 
    }
  }
})();
  
(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('AddJointHolderController', addJointHolderController);

    /** @ngInject */
    function addJointHolderController($uibModalInstance,LoaderService,InvestorService,MessageService,AppConstants, modalView, modalData, ModalService){
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
      vm.holderData = {};
      vm.emailDetails = {};
    vm.showEmail = false;
    vm.showOtp = false;
    vm.Otp = '';
    vm.tempdata= null;
    vm.formData = {
      taxStatusResident: true
    };
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    vm.appConstants = AppConstants;
    vm.changedRiNriTaxStatus = changedRiNriTaxStatus;
    vm.submit = submit;
    function submit() {
      $uibModalInstance.close(vm.tempdata);
    }
      vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
      vm.dismissModal = function () {
        $uibModalInstance.dismiss("cancel");
      };
      vm.closeModal = function () {
        $uibModalInstance.close();
      };
      vm.checkPanEmailExist = function () {
        var success = function (resp) {
          vm.processFlag = false;
          if (resp.status && resp.data) {
            vm.tempdata = resp.data;
            vm.tempdata.taxStatusResident = vm.formData.taxStatusResident;

            if (resp.data && resp.data.ekycStatus && (resp.data.ekycStatus === vm.KYC_STATUS.VERIFIED || resp.data.ekycStatus === vm.KYC_STATUS.IN_PROGRESS)) {
              if (resp.data && resp.data.emailExists === true) {
                //  console.log(resp.data);
                vm.holderData.jointHolderName = resp.data.name;
                vm.holderData.kycverified = resp.data.kycverified;
                vm.holderData.email= resp.data.email;
                vm.holderData.mobileNumber= resp.data.mobileNumber;
                vm.AllowedJointHolder = true;
                vm.processFlag = true;
                vm.wrongMsg = '';
              }else {
                vm.showEmail = true;
              }
            }  else if (resp.data && resp.data.ekycStatus && (resp.data.ekycStatus === vm.KYC_STATUS.NOT_VALIDATED || resp.data.ekycStatus === vm.KYC_STATUS.ON_HOLD)) {
              ModalService.nonKycModal({
                'text': resp.data.kycStatus === vm.KYC_STATUS.ON_HOLD ? vm.appConstants.ON_HOLD_MESSAGE : vm.appConstants.NOT_VALIDATED_MESSAGE,
                'showHtml': true,
                'buttonText': 'OK',
                'ekycRequestCO': resp.data.ekycRequestCO
              }, function () {
                vm.holderData.pan = null;
              }, function () {
                vm.holderData.pan = null;
              });
            }
          } else {
            if (resp.popupEnabled) {
              vm.panMessage = resp.message;
            } else {
              vm.wrongMsg = resp.message;
              MessageService.error(resp.message);
            }
          }
        },
        error = function () {
        vm.processFlag = false;
        vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
        var payload = {
          pan: vm.holderData.pan,
          nriFlag: !vm.formData.taxStatusResident
        };
        if(payload.pan) {
          InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'details'}, payload).$promise.then(success, error);
        }
      }
      vm.verifyOtp = function () {
        var success = function (resp) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          if (resp.status && resp.data && resp.data.verified) {
            vm.showOtp = false;
            vm.AllowedJointHolder = true;
            vm.processFlag = true;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          vm.processFlag = false;
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };

        var payload = {
          uniqueLink: vm.emailDetails.singleUseURL,
          otp: vm.Otp
        };
        InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'add',child6: 'email',child7: 'verify',child8: 'otp'}, payload).$promise.then(success, error);
      }
      vm.OTPResendMsg = '';
    vm.reGenerateOtp = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        vm.processFlag = false;
        if (resp.status && resp.data) {
          vm.OTPResendMsg = resp.data.message;
          vm.emailMsg = "";
        } else {
          vm.wrongMsg = resp.message;
          MessageService.error(resp.message);
        }
      },
      error = function () {
        LoaderService.hideLoader('.popup');
        vm.processFlag = false;
        vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
      };
      vm.payload = {
        pan: vm.holderData.pan,
        secretLink: vm.emailDetails.singleUseURL,
        email: vm.holderData.email
      };
      InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'add',child6: 'email',child7: 'resend',child8: 'otp'}, vm.payload).$promise.then(success, error);
    }
      vm.resetValues = function () {
        vm.panAdhaarNotLinked = null;
        vm.tempdata = null;
        vm.errorMessage = "";
        vm.errorMessageVerify = "";
        vm.panMessage = "";
        vm.availableMessage = "";
        vm.otpResendMessage = "";
        vm.dateErrorMessage = "";
      }
      vm.AddEmailToHolderPan = function () {
        vm.Otp = '';
        var success = function (resp) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          if (resp.status && resp.data) {
            // vm.AllowedJointHolder = false;
            vm.emailDetails.singleUseURL = resp.data.secretLink;
            vm.Otp = resp.data.otp;
            vm.showOtp = true;
          }
        },
        error = function () {
          vm.processFlag = false;
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
        var payload = {
          pan: vm.holderData.pan,
          email: vm.holderData.email
        };
        InvestorService.post({child1: 'folio',child2: 'any-or-survivor',child3: 'holder',child4: 'pan',child5: 'add',child6: 'email',child7: 'send',child8: 'otp'}, payload).$promise.then(success, error);
      }

      function changedRiNriTaxStatus(){
        vm.holderData.pan = "";
        vm.resetValues();
      }
    }

  })();


/*
* Created on 09/Dec/2019
* */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('IFSCSelectionNewJourney', IFSCSelectionNewJourney);

  /** @ngInject */
  function IFSCSelectionNewJourney(InvestorService, $uibModalInstance, modalView, modalData, AppConstants, $timeout, $filter) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.APP_CONSTANT = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.bankChange = bankChange;
    vm.clearForm = clearForm;
    vm.searchIFSC = searchIFSC;
    vm.IFSCsearchResult = [];
    vm.submitIFSC = submitIFSC;
    vm.bankList = vm.modalData.bankList;
    if(vm.modalData.bankName && vm.bankList != null){
      var bankListData = [];
      vm.bankList.forEach(function(el){
        if(el.bankName.toUpperCase() == vm.modalData.bankName){
          bankListData.push(el);
        }
      });
      vm.bankList = bankListData;
    }
    vm.disabledCity = true;
    vm.cityList;
    vm.clearBankField = clearBankField;
    vm.clearIFSCField = clearIFSCField;
    vm.searchIFSCCLicked = false;
    vm.ifsccode = "";
    vm.showFieldifsc = true;
    vm.showFieldbank = true;
    vm.modeofifscsearch = "IFSC";
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.fromFolioCreationForJourneys = vm.modalData.fromFolioCreationForJourneys;

    function clearBankField() {
      vm.showFieldbank = false;
      if (vm.bankName) vm.bankName = null;
      if (vm.cityName) vm.cityName = null;
      if (vm.IFSCsearchResult.length) vm.IFSCsearchResult = '';
      if (vm.searchIFSCCLicked) vm.searchIFSCCLicked = false;
      if (vm.distributorDetails){
        if (vm.distributorDetails.isHdfcBank){
          if (vm.ifsccode.includes('HDFC')){

          }else{
            vm.ifsccode = "";
          }
            }
      }
      if (vm.modalData.key == "arn"){
        if (vm.ifsccode.includes('HDFC')){

        }else{
          vm.ifsccode = "";
        }
      }
      $timeout(function () {
        vm.showFieldbank = true;
      })
    }

    function submitIFSC(val) {
      vm.ifscData = val;
      $uibModalInstance.close(vm.ifscData);
    }

    function clearForm() {
      clearBankField();
      clearIFSCField();
      vm.IFSCsearchResult = '';
    }
    function clearIFSCField() {
      vm.showFieldifsc = false;
      vm.ifsccode = "";
      $timeout(function () {
        vm.showFieldifsc = true;
        if (vm.IFSCsearchResult.length) vm.IFSCsearchResult = '';
        if (vm.searchIFSCCLicked) vm.searchIFSCCLicked = false;
      });
    }
    // Find City List
    function bankChange() {
      clearIFSCField();
      var bankName = vm.bankName;
      if (bankName) {
        var citySuccess = function (resp) {
          if (resp.data && resp.data.cities && resp.data.cities.length) {
            vm.disabledCity = false;
          }
          vm.cityList = resp.data.cities;
        };
        var error = function () {
          console.log('error')
        };
        InvestorService.post({
          child1: 'rbi',
          child2: 'bankCities'
        }, { bankName: vm.bankName }).$promise.then(citySuccess, error)
      } else {
        vm.disabledCity = true;
        vm.cityName = null;
      };
    }

    vm.getIfscSerchMode = function (val) {
      if (val === 'IFSC') {
        vm.modeofifscsearch = "IFSC";
      } else {
        vm.modeofifscsearch = "BANKNAME";
      }

    }

    function searchIFSC() {
      var payload = {
        bankName: vm.bankName,
        bankCity: vm.cityName,
        ifscCode: vm.ifsccode
      };

      var onSuccess = function (data) {
        vm.IFSCsearchResult = data.data.bankList;
        if(vm.modalData.bankName){
          if(vm.IFSCsearchResult[0].bankName.toUpperCase() == vm.modalData.bankName){
            vm.emandateBank = false;
          }else{
            vm.emandateBank = true;
            vm.IFSCsearchResult = [];
          }
        }
        vm.searchIFSCCLicked = true;
      };
      onerror = function () {
      };
      InvestorService.post({
        child1: 'rbi',
        child2: 'bankList'
      }, payload).$promise.then(onSuccess, onerror);
    }


    vm.dismissModal = function () {
      $uibModalInstance.dismiss(null);
    };
    //  Find Bank List
    vm.fetchBankList = function () {
      var success = function (res) {
        if (res.status && res.data) {
          vm.bankList = res.data.bankList;
          if (vm.distributorDetails){
            if (vm.distributorDetails.isHdfcBank){
              vm.bankList = $filter('filter')(res.data.bankList,
                {
                  bankName: "HDFC Bank Ltd"
                })
            }
          }
          if(vm.modalData.key == 'arn'){
            vm.bankList = $filter('filter')(res.data.bankList,
              {
                bankName: "HDFC Bank Ltd"
              })
          }
          if(vm.modalData.bankName){
            var bankListData = [];
            vm.bankList.forEach(function(el){
              if(el.bankName.toUpperCase() == vm.modalData.bankName){
                bankListData.push(el);
              }
            });
            vm.bankList = bankListData;
          }
        }
        else {
          vm.bankList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        vm.bankList = null;
        UtilService.errorHandler(err);
        MessageService.error(err);
      };

      InvestorService.get({ child1: 'rbi', child2: 'bankNames' }).$promise.then(success, error);
    }
    vm.fetchBankList();


  }
})();

/*
* Created on 09/Dec/2019
* */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('IFSCSelection', IFSCSelection);

  /** @ngInject */
  function IFSCSelection(InvestorService, $uibModalInstance, modalView, modalData, AppConstants,$timeout, MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.APP_CONSTANT = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.bankChange = bankChange;
    vm.clearForm = clearForm;
    vm.searchIFSC = searchIFSC;
    vm.IFSCsearchResult='';
    vm.submitIFSC= submitIFSC;
    vm.bankList = vm.modalData.bankList;
    vm.disabledCity =  true;
    vm.cityList;
    vm.clearBankField = clearBankField;
    vm.clearIFSCField = clearIFSCField;
    vm.searchIFSCCLicked = false;
    vm.ifsccode;
    vm.showFieldifsc = true;
    vm.showFieldbank = true;
    vm.pennyDropValidationError = false;
    vm.selectBank = selectBank;

    function clearBankField(){
      vm.showFieldbank = false;
      if(vm.bankName) vm.bankName =null;
      if(vm.cityName) vm.cityName=null;
      if(vm.IFSCsearchResult.length) vm.IFSCsearchResult = '';
      if(vm.searchIFSCCLicked) vm.searchIFSCCLicked = false;
      $timeout(function () {
        vm.showFieldbank = true;
      });
      vm.pennyDropValidationError = false;
    }

    function submitIFSC() {
      $uibModalInstance.close(vm.selectdIFSC);
    }
    function clearForm() {
      clearBankField();
      clearIFSCField();
      vm.IFSCsearchResult='';
    }
    function clearIFSCField() {
      vm.showFieldifsc = false;
      vm.ifsccode = "";
      $timeout(function () {
        vm.showFieldifsc = true;
        if(vm.IFSCsearchResult.length) vm.IFSCsearchResult = '';
        if(vm.searchIFSCCLicked) vm.searchIFSCCLicked = false;
      });
    }

    function bankChange(){
      clearIFSCField();
      var bankName = vm.bankName;
      if(bankName) {
        var citySuccess = function (resp) {
          if(resp.data && resp.data.cities && resp.data.cities.length) {
            vm.disabledCity = false;
          }
          vm.cityList = resp.data.cities;
        };
        var error = function () {
          // console.log('error')
        };
        InvestorService.post({
          child1: 'rbi',
          child2: 'bankCities'
        }, {bankName: vm.bankName}).$promise.then(citySuccess, error)
      }else {
        vm.disabledCity = true;
        vm.cityName = null;
      };
    }

    function searchIFSC(){
      var payload = {
        bankName : vm.bankName,
        bankCity : vm.cityName,
        ifscCode : vm.ifsccode
      };

      var onSuccess = function(data){
        vm.IFSCsearchResult = data.data.bankList;
        vm.searchIFSCCLicked = true;
      };
      onerror = function(){
      };
      InvestorService.post({
        child1: 'rbi',
        child2: 'bankList'
      }, payload).$promise.then(onSuccess, onerror);
    }

    vm.error = function () {
      $uibModalInstance.dismiss();
    }

    function selectBank(selectedBank) {
      if (angular.isDefined(vm.modalData.constraints) && vm.modalData.constraints.isFromProfile) {
        if (!selectedBank.pennyDropEnabled && !vm.modalData.constraints.uploadChequeLeafEnabled) {
          vm.pennyDropValidationError = true;
          MessageService.error(selectedBank.pennyDropErrorMessage);
        } else {
          vm.pennyDropValidationError = false;
        }
      }
    }
  }
})();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .directive('preliminaryHeader', preliminaryHeader);
  
    function preliminaryHeader() {
      return ({
        restrict: 'E',
        templateUrl: 'app/components/header/Preliminary-Header/preliminary-header.html',
        scope: {
          creationDate: '='
        },
        controller: preliminaryheaderController,
        controllerAs: 'Prelimaryheader',
        bindToController: true
      });
  
    }
      /** @ngInject */
      function preliminaryheaderController(UtilService,$window,LoaderService,MessageService,InvestorService,AuthService,$state) {
        var vm = this;
        vm.count = 0;
        vm.active = UtilService.headerFont.get();
        vm.changedFont = changedFont;
        vm.contrast = contrast;
        vm.fontSizeChange = fontSizeChange;
        vm.recentActivity = recentActivity;
        vm.contrastt = UtilService.darkThemeStatus.get();
        vm.logout = logout;
        function contrast () {
          if(!vm.contrastt){
            UtilService.darkThemeStatus.set(false);
            $window.document.getElementsByTagName("body")[0].classList.add("contrastClass");
          } else {
            UtilService.darkThemeStatus.set(true);
            $window.document.getElementsByTagName("body")[0].classList.remove("contrastClass");
          }
        }
        function changedFont(valType){
          vm.active = {1: false};
          switch (valType) {
            case 'increment' : {
              if(vm.count<3){
                vm.count++;
                UtilService.headerFont.set(3);
                vm.active = UtilService.headerFont.get();
                vm.fontSizeChange(vm.count);
              }
            }
              break;
            case 'decrement' : {
              if(vm.count>-3){
                vm.count--;
                UtilService.headerFont.set(2);
                vm.active = UtilService.headerFont.get();
                vm.fontSizeChange(vm.count);
              }
            }
              break;
            case 'original' : {
              vm.count = 0;
              UtilService.headerFont.set(1);
              vm.active = UtilService.headerFont.get();
              vm.fontSizeChange(vm.count);
            }
              break;
          }
        }
        function fontSizeChange(val){
          var elem = $window.document.getElementsByTagName("body")[0];
          elem.classList.add("newBigFont");
          var ele = $window.document.getElementsByClassName('newBigFont')[0];
          switch (val) {
            case -2 : {
              elem.classList.add("smallest-font");
              elem.classList.remove("small-font");
              ele.setAttribute("style","font-size: 70% !important");
            }
              break;
            case -1 : {
              elem.classList.add("small-font");
              ele.setAttribute("style","font-size: 80% !important");
            }
              break;
            case 0 : {
              elem.removeAttribute('style');
              elem.classList.remove("newBigFont");
              elem.classList.remove("big-font");
              elem.classList.remove("medium-font");
              elem.classList.remove("small-font");
              elem.classList.remove("smallest-font");
            }
              break;
            case 1 : {
              elem.classList.add("medium-font");
              ele.setAttribute("style","font-size: 97% !important");
            }
              break;
            case 2 : {
              elem.classList.add("big-font");
              elem.classList.remove("medium-font");
              ele.setAttribute("style","font-size: 110% !important");
            }
              break;
          }
        }
        function logout(){
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp && resp.status) {  
              MessageService.success(resp.message); 
              $state.go('login');
            } else {
              MessageService.error(resp.message);
            }
          },error = function (err) {
            LoaderService.hideLoader();
            if(err && err.status == 401){
              sessionStorage.clear();
              $state.go('login');
            }
          };
          LoaderService.showLoader();
          AuthService.mobileTokenLogout().then(success, error); 
        }
        recentActivity();
        function recentActivity() {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if(resp.data.lastLoginDateTime){
                  vm.lastDateTime = resp.data.lastLoginDateTime;
                  localStorage.setItem('lastLoginData', vm.lastDateTime);
                }else{
                  vm.lastDateTime = "";
                }
              }else{
                if(resp.logout){
                  // logout mobile token
                  var success = function (resp) {
                    if (resp && resp.status) { 
                      $state.reload();
                    } else {
                      $state.reload();
                    } 
                  },
                  error = function () {
                  };
                  var userDetails = AuthService.getMobileLoginToken(); 
                  if(userDetails){
                    var payload = {  
                      mobile: AuthService.encryptRSA(userDetails.mobile),
                      forceLogout:true
                    }
                  } 
                  AuthService.mobileTokenLogout(payload).then(success, error);
                  MessageService.error("Something went wrong. Please try again later.");
                }
              }
          },error = function () {
            LoaderService.hideLoader();
          };
          LoaderService.showLoader();
          InvestorService.post({
              child1: 'dashboard',
              child2: 'widgets',
              child3: 'recentActivity',
              child4: 'mobile',
              child5: 'login'
          }, {}).$promise.then(success, error);
        }
 
      }
  })();
  
(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('transactionPayment', transactionPayment);

  /*@ngInject*/
  function transactionPayment(AppConstants, PaymentHelper, $timeout, ModalService, $window) {
    return {
      restrict: 'E',
      scope: {
        formData: '='
      },
      templateUrl: function(tElement, tAttrs) {
        return getTemplate(tAttrs.screen);
      },
      link: transactionPayments
    };
    /*
    * Function responsible to return the directive template url
    * */
    function getTemplate(screen) {
      var template = "";
      switch(screen) {
        case 'TRANSACTION':
          template = 'app/components/directives/payment/templates/' + screen.toLowerCase() + '.template.html';
          break;
        default:
          template = 'app/components/directives/payment/templates/' + screen.toLowerCase() + '.template.html';
          break;
      }
      return template;
    }

    function transactionPayments(scope) {
      var vm = scope;
      vm.UPIBankList = null;
      vm.netBankingBankList = null;
      vm.UPIBankList = null;
      vm.NEFTRTGSBankList = null;
      vm.otmBankList = null;
      var TrFlowType = AppConstants.TRANSACTION_FLOW;

      vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
      vm.NRI_STATUS_CODES = AppConstants.NRI_STATUS_CODES;
      vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
      vm.purchasePaymentOptions = [
        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,
        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
      ];

      /*Directive Methods declaration starts from here*/
      vm.helper = getHelper();
      vm.changedPaymentOptionPurchase = changedPaymentOptionPurchase;
      vm.changeBank = changeBank;
      vm.selectedUpiBank = selectedUpiBank;
      vm.changeRtgsPaymentOption = changeRtgsPaymentOption;

      vm.$on('fetchBankList', function() {
        fetchBankLists();
      });

      function getHelper() {
        var helper = null;
        helper = PaymentHelper;
        helper.setViewModel(vm);
        return helper;
      }

      function fetchBankLists() {
        if (!vm.formData.liquidFlag) {
          vm.purchasePaymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          ];
        } else {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS
          ];

        }
        vm.helper.getInvestorInfo(function () {
          vm.helper.getDetails(function () {
            vm.formData.selectedPaymentOption = vm.purchasePaymentOptions[0];
            changedPaymentOptionPurchase(vm.formData.selectedPaymentOption);
          });
        });
        vm.helper.getAccountType();
      }

      function changedPaymentOptionPurchase(selectedOption) {
        vm.isCheckedDeclaration = false;
        vm.bankInfo = null;
        vm.formData.paymentInfo = {amount: vm.formData.purchaseAmount};
        vm.isOTMAmount = false;
        vm.isOTMDate = false;
        vm.isOTMStartDate = false;
        vm.isInvalidForm = false;
        vm.fileType='';
        vm.bankchequeLeafUrl = null;
        vm.isNewPayment = true;
        vm.formData.paymentInfo.chequeLeaf = null;
        vm.formData.selectedPaymentOption = selectedOption;
        switch (vm.formData.selectedPaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            vm.formData.paymentInfo.paymentMode = "WEB";
            vm.helper.fetchBankListPurchase();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
            vm.helper.fetchBankListPurchase();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
            if(vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
              vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
            }
            vm.helper.fetchBankListPurchase();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
            vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC;
            resetCheckLeaf();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            resetUPIForm();
            vm.helper.fetchBankListPurchase();
            if(vm.formData.purchaseAmount > vm.formData.upiLimit) {
              var success = function() {
                vm.formData.selectedPaymentOption = vm.purchasePaymentOptions[1];
                changedPaymentOptionPurchase(vm.formData.selectedPaymentOption);
              }
              ModalService.genericModal({
                text: vm.formData.upiErrorMessage,
                isUpi: true
              },success);
            }
            vm.formData.paymentInfo.paymentMode = "WEB";
            vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
            break;
        }
      }

      /**
       * Function responsible for resetting UPI fields
       */
      function resetUPIForm() {
        vm.verifyUPIResp = {};
        vm.isUPIVerified = false;
        (vm.formData.paymentInfo)&&(vm.formData.paymentInfo.virtualAddress = "");
      }

      /**
       * Function responsible for resetting cheque leaf
       */
      function resetCheckLeaf() {
        vm.bankchequeLeafUrl = null;
        vm.formData.paymentInfo.chequeLeaf = null;
        vm.bankChequeLeaf = null;
        vm.chooseAFile=true;
        angular.element("#uploadCheckLeaf").val("");
      }

      /**
       * Function responsible for handling bank change SIP and PURCHASE
       */

      function changeBank() {
        if (!vm.bankInfo) {
          vm.authenticationMode = null;
          return;
        }
        vm.isInvalidForm = false;
        switch (vm.formData.selectedPaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            if(!vm.bankInfo.minorBankFlag && checkForMinorBankListCondition()){
              ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
              vm.bankInfo = null;
              vm.isCheckedDeclaration = false;
              return;
            }
            vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
            vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
            vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType==""?null:vm.bankInfo.bankAcType;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
            if (vm.bankInfo.tpvEnableFlag == 'Y') {
              vm.helper.getAccountNumber(vm.bankInfo.bankCode);
            }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            if(!vm.bankInfo.minorBankFlag && checkForMinorBankListCondition()){
              ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
              vm.bankInfo = null;
              vm.isCheckedDeclaration = false;
              return;
            }
            vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
            vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
            vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
            vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
            vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
            vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
            vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
            vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
            (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
            checkOTMAmountAndDate();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            if(!vm.bankInfo.minorBankFlag && checkForMinorBankListCondition()){
              ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
              return;
            }
            vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            if(!vm.bankInfo.minorBankFlag && checkForMinorBankListCondition()){
              ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
              vm.bankInfo = null;
              vm.isCheckedDeclaration = false;
              return;
            }
            vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode ? vm.bankInfo.bankCode : null;
            vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor ? vm.bankInfo.gateWayVendor : null;
            if (vm.bankInfo.tpvEnableFlag == 'Y') {
              vm.helper.getAccountNumber(vm.bankInfo.bankCode);
            }
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly ? vm.bankInfo.bankNameOnly : null;
            vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch ? vm.bankInfo.bankBranch : null;
            vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber ? vm.bankInfo.accountNumber : null;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : null;
            vm.formData.paymentInfo.otherBank = true;
            vm.formData.paymentInfo.bankAcType = vm.bankInfo.bankAcType==""?null:vm.bankInfo.bankAcType;
            vm.formData.paymentInfo.utrNumber = null;
            vm.formData.paymentInfo.verifyUtrNumber = null;
            vm.formData.paymentInfo.verifyBankAcNo = null;
            vm.formData.paymentInfo.chequeLeaf = null;
            vm.bankChequeLeaf = null;
            vm.isAccTypeFieldDisabled = vm.formData.paymentInfo.bankAcType ? true : false;
            vm.tForm.$setPristine();
            if(!vm.bankInfo.bankAcType && vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
              vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
            }
            if(vm.isNewPayment && vm.bankInfo){
              vm.tForm.bankName.$setDirty();
              vm.tForm.bankBranch.$setDirty();
              vm.tForm.bankAcNo.$setDirty();
              vm.tForm.ifscCode.$setDirty();
              vm.tForm.accountType.$setDirty();
              vm.bankChequeLeaf = 'No File Chosen';
              vm.bankchequeLeafUrl = null;
              vm.fileType = null;
              vm.chooseAFile = true;
            }else{
              vm.tForm.bankBranch.$dirty = false;
              vm.tForm.bankAcNo.$dirty = false;
              vm.tForm.bankName.$dirty = false;
              vm.tForm.ifscCode.$dirty = false;
              vm.tForm.accountType.$dirty = false;
            }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
            vm.formData.netBankingUrl = vm.bankInfo ? vm.bankInfo.netBankingUrl : "";
            if (!vm.bankInfo.bankAcType) {
              vm.helper.getAccountType();
            }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:
            vm.formData.authMode = vm.bankInfo ? vm.bankInfo.authenticationModes[0] : null;
            vm.authenticationMode = vm.bankInfo ? vm.bankInfo.authenticationModes: null;
            vm.formData.bankAcNo = vm.bankInfo ? vm.bankInfo.bankAcNo : '';
            vm.formData.emUmrn = vm.bankInfo ? vm.bankInfo.emUmrn : '';
            vm.formData.maxAmount = vm.bankInfo ? vm.bankInfo.maxAmount : '';
            vm.formData.emExpiryDate = vm.bankInfo ? vm.bankInfo.emExpiryDate : '';
            break;
          default :
            vm.bankInfo = null;
            break;
        }
      }

      /**
       * Function responsible for handling upi bank change
       */

      function selectedUpiBank() {
        if (!vm.bankInfo) {
          return;
        }

        if(!vm.bankInfo.minorBankFlag && checkForMinorBankListCondition()){
          ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
          vm.bankInfo = null;
          vm.isCheckedDeclaration = false;
          return;
        }
        vm.upiAccountNumber = vm.bankInfo.accountNumber;
        vm.upiBankName = vm.bankInfo.bankName;
        vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
      }

      function checkForMinorBankListCondition() {
        /*if(vm.formData!=null && vm.formData.minorFlag!=null && vm.formData.cgfFlag!=null) {
          return vm.formData.minorFlag && !vm.formData.cgfFlag;
        } else {
          return false;
        }*/
        return false;
      }

      /**
       * Function responsible for checking OTM bank validations
       */

      function checkOTMAmountAndDate(flow) {

        vm.isOTMAmount = false;
        vm.isOTMDate = false;
        vm.isOTMStartDate = false;

        vm.isOTMAmountFI = false;
        vm.isOTMDateFI = false;
        vm.isOTMStartDateFI = false;

        // Check Ammout
        if (vm.formData.purchaseAmount && (vm.formData.purchaseAmount > vm.bankInfo.maxAmount)) {
          vm.isOTMAmount = true;
        } else if (vm.formData.purchaseAmount && (vm.formData.purchaseAmount < vm.bankInfo.maxAmount)){
          vm.isOTMAmount = false;
        }

        if (flow !== "FI") {
          // Check Ammout SIP
          if (vm.formData.amount && (vm.formData.amount > vm.bankInfo.maxAmount)) {
            vm.isOTMAmount = true;
          } else if (vm.formData.amount && (vm.formData.amount < vm.bankInfo.maxAmount)) {
            vm.isOTMAmount = false;
          }

          //Compare
          if (vm.formData.investmentType === 'SIP') {
            var dateToCompare = $window.moment(vm.formData.endDate,"DD-MMM-YYYY");
          } else {
            var dateToCompare = $window.moment();
          }

          if ($window.moment(vm.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore(dateToCompare)) {
            vm.isOTMDate = true;
          } else {
            vm.isOTMDate = false;
          }
          if (!($window.moment(vm.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.otmList.currentDate, 'DD-MMM-YYYY')))){
            vm.isOTMStartDate = true;
          } else {
            vm.isOTMStartDate = false;
          }

        }

        if (flow === "FI") {
          // Check Ammout FI
          if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount > vm.bankInfoFI.maxAmount)) {
            vm.isOTMAmountFI = true;
          } else if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount < vm.bankInfoFI.maxAmount)) {
            vm.isOTMAmountFI = false;
          }
          if ($window.moment(vm.bankInfoFI.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDate,"DD-MMM-YYYY"))) {
            vm.isOTMDateFI = true;
          } else {
            vm.isOTMDateFI = false;
          }
          if (!($window.moment(vm.bankInfoFI.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.otmList.currentDate, 'DD-MMM-YYYY')))){
            vm.isOTMStartDateFI = true;
          } else {
            vm.isOTMStartDateFI = false;
          }
        }
        //Check for amount or date
        if (vm.isOTMAmount || vm.isOTMDate) {
          vm.isInvalidForm = true;
        } else {
          vm.isInvalidForm = false;
        }
        if (flow === "FI" && vm.formData.sipFirstInstallment && (vm.isOTMAmountFI || vm.isOTMDateFI)) {
          vm.isInvalidFormFI = true;
        } else {
          vm.isInvalidFormFI = false;
        }
      }

      function tpv(event) {
        event.preventDefault();
        ModalService.tpvModal({});
      }

      function changeRtgsPaymentOption() {
        vm.fileType = null;
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankName){
          vm.formData.paymentInfo.bankName = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankBranch){
          vm.formData.paymentInfo.bankBranch = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.accNo){
          vm.formData.paymentInfo.accNo = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankAcType){
          vm.formData.paymentInfo.bankAcType = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyBankAcNo || (vm.formData.paymentInfo.verifyBankAcNo == undefined)){
          vm.formData.paymentInfo.verifyBankAcNo = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.ifscCode || (vm.formData.paymentInfo.ifscCode == undefined)){
          vm.formData.paymentInfo.ifscCode = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.utrNumber){
          vm.formData.paymentInfo.utrNumber = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyUtrNumber || (vm.formData.paymentInfo.verifyUtrNumber == undefined)){
          vm.formData.paymentInfo.verifyUtrNumber = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
          vm.formData.paymentInfo.chequeLeaf = null;
        }
        if (vm.isNewPayment) {
          vm.bankInfo = null;
          vm.isAccTypeFieldDisabled = false;
          resetCheckLeaf();
          if(vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
            vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
          }
        } else {
          vm.formData.paymentInfo.chequeLeaf = null;
          vm.bankChequeLeaf = null;
          vm.bankInfo = null;
        }
      }

    }
  }
})();

/**
 * Created by sumit on 19/09/24.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('PaymentHelper', paymentHelper);

  /** @ngInject */
  function paymentHelper(InvestorService, MessageService, UtilService, LoaderService, $log, $window, $timeout) {
    var vm = null;

    function setViewModel(model) {
      vm = model;
    }

    function getInvestorInfo(cb) {
      cb = cb ||function () {};
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
        } else {
          vm.investorInfo = null;
          MessageService.error(resp.message);
        }
        cb();
      }, error = function (err) {
        UtilService.errorHandler(err);
        vm.investorInfo = null;
        cb();
      };
      InvestorService.get({
        child1: 'folio',
        child3: 'info'
      }).$promise.then(success, error);
    }

    function getDetails(cb) {
      cb = cb ||function () {};
      var success = function (resp) {
        var bankDetails=[];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if(vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length>0){
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if(value.defaultBank===true){return value;}
          });
        }
        localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
        cb();
      }, error = function () {
        LoaderService.hideLoader();
        cb();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }

    function getAccountType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.bankTypeList = resp.data.bankAccountTypes;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        $log.info('Account type Errror>>>>', err);
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.formData.investorType
      }).$promise.then(success, error);
    }

    /**
     * Function responsible for setting bank list for net banking , UPI and NEFT/RTGS
     */
    function fetchBankListPurchase() {
      LoaderService.showLoader();
      var ApiConfig =  {child1: 'bank', child2: 'list'};
      var ApiPayload = {
        trnxType: vm.formData.investmentType,
        folioNumber: vm.formData.folioNumber,
        liquidSchemeFlag: vm.formData.liquidFlag
      };

      var ApiConfigOTM = {child1: 'folio', child2: 'otm'};
      var ApiPayloadOTM = {
        transactionType : vm.formData.investmentType.toLowerCase(),
        folioNo: vm.formData.folioNumber
      };


      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var bankList = resp.data.bankList;
          vm.banklist = [];
          if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
            vm.otmList = resp.data;
            vm.otmBankList = vm.formData.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList;
            vm.bankList = angular.copy(vm.otmBankList);
          }

          if(vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING){
            vm.netBankingBankList = bankList;
            vm.bankList = angular.copy(vm.netBankingBankList);
          }

          if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS) {
            vm.NEFTRTGSBankList = bankList;
            vm.bankList = angular.copy(vm.NEFTRTGSBankList);
          }

          if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            vm.UPIBankList = bankList;
            vm.bankList = angular.copy(vm.UPIBankList);
          }

          if (bankList && (bankList.length == 1 || (vm.formData.investmentType === 'SIP' && vm.formData.sipFirstInstallment && vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI))) {
            if (vm.formData.investmentType === 'SIP' && vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
              vm.bankInfo =  vm.formData.bankInfo;
              vm.formData.paymentInfo.virtualAddress = vm.formData.virtualAddress;
              vm.verifyUPIResp = vm.formData.verifyUPIResp;
              vm.name = vm.verifyUPIResp.name;
              vm.isUPIVerified = vm.verifyUPIResp.valid;
              vm.isDisableUpi = true;
            } else {
              vm.bankInfo = bankList[0];
            }

            $timeout(function() {
              vm.changeBank();

              if(vm.formData.selectedPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
                selectedUpiBank();
              }
            })

          }

        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      }, error = function (resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      }
      LoaderService.showLoader();
      switch (vm.formData.selectedPaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if (vm.UPIBankList === null)  {
            if (vm.formData.investmentType === 'SIP') {
              ApiPayload.sipUpiFlow = true;
            }
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          } else if (vm.UPIBankList && vm.UPIBankList.length === 1) {
            vm.bankInfo = vm.UPIBankList[0];
            $timeout(function() {
              vm.changeBank();
              selectedUpiBank();
            })
          } else if (vm.UPIBankList && vm.UPIBankList.length > 1) {
            vm.bankList = angular.copy(vm.UPIBankList);
          }
          LoaderService.hideLoader();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          if (vm.netBankingBankList === null)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          } else if (vm.netBankingBankList && vm.netBankingBankList.length === 1) {
            vm.bankInfo = vm.netBankingBankList[0];
            $timeout(function() {
              vm.changeBank();
            })
          } else if (vm.netBankingBankList && vm.netBankingBankList.length > 1) {
            vm.bankList = angular.copy(vm.netBankingBankList);
          }
          LoaderService.hideLoader();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          ApiPayload.neftFlag = true;
          if (vm.NEFTRTGSBankList === null)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          } else if (vm.NEFTRTGSBankList && vm.NEFTRTGSBankList.length === 1) {
            vm.bankInfo = vm.NEFTRTGSBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          } else if (vm.NEFTRTGSBankList && vm.NEFTRTGSBankList.length > 1) {
            vm.bankList = angular.copy(vm.NEFTRTGSBankList);
          }
          LoaderService.hideLoader();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if (vm.otmBankList === null)  {
            InvestorService.post(ApiConfigOTM, ApiPayloadOTM).$promise.then(success, error);
          } else if (vm.otmBankList && vm.otmBankList.length === 1) {
            vm.bankInfo = vm.otmBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          } else if (vm.otmBankList && vm.otmBankList.length > 1) {
            vm.bankList = angular.copy(vm.otmBankList);
          }
          LoaderService.hideLoader();
          break;
      }
    }

    function getAccountNumber(bankCode, flow) {
      if(vm.investorInfo && vm.investorInfo.transactionFlowVersion === TrFlowType.NEW){
        if (flow === 'FI') {
          vm.formData.paymentInfoFI.tpvEnableFlag = vm.bankInfoFI.tpvEnableFlag;
          vm.formData.paymentInfoFI.accountNumber = vm.bankInfoFI.accountNumber;
        } else {
          vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
          vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
        }
        return;
      }
      vm.bankAccounts = [];
      vm.isInvalidForm = true;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          LoaderService.hideLoader();
          vm.bankAccounts = resp.data.accountNumbers;
          if (vm.bankAccounts.length > 1) {
            var success = function (accountNo) {
              if (flow === 'FI') {
                vm.formData.paymentInfoFI.tpvEnableFlag = vm.bankInfoFI.tpvEnableFlag;
                vm.formData.paymentInfoFI.accountNumber = accountNo;
              } else {
                vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
                vm.formData.paymentInfo.accountNumber = accountNo;
              }
              vm.isInvalidForm = false;
            }, error = function () {

            };
            ModalService.selectAccountNoModal({bankAccounts: vm.bankAccounts}, success, error);
          } else {
            if (flow === 'FI') {
              vm.formData.paymentInfoFI.tpvEnableFlag = vm.bankInfoFI.tpvEnableFlag;
              vm.formData.paymentInfoFI.accountNumber = vm.bankAccounts[0];
            } else {
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankAccounts[0];
            }
            vm.isInvalidForm = false;
          }
        } else {
          vm.isInvalidForm = true;
          MessageService.error(resp.message);
          vm.bankAccounts = [];
        }
      },
      error = function (err) {
        vm.bankAccounts = [];
        vm.isInvalidForm = true;
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "bankCode": bankCode
      };
      InvestorService.post({
        child1: 'bank',
        child2: 'account'
      }, payload).$promise.then(success, error);
    }



    return {
      setViewModel: setViewModel,
      getInvestorInfo: getInvestorInfo,
      getDetails: getDetails,
      getAccountType: getAccountType,
      fetchBankListPurchase: fetchBankListPurchase,
      getAccountNumber: getAccountNumber
    }
  }
})();

(function () {
    "use strict";
    angular
      .module("hdfc-mf-investor-web")
      .controller("scheduleTransactionListController", scheduleTransactionListController);
  
    function scheduleTransactionListController($state,HDFC_API, TransactionModel, NetcoreEvntService,InvestorService,$window, $rootScope,AppConstants, LoaderService, $stateParams,AuthService, TransactionService, MessageService, IIHttpService, $filter, ModalService,InvestorServiceVersion3, CreatePayloadFactory,toastr) {
      var vm = this; 
      $rootScope.showTitle = true;
      $rootScope.modifyLogin = false;
      vm.beforotp = true;
      vm.transactionType = null;  
      $rootScope.PurchaseView = true; 
      vm.pageLoad = false;
      vm.formData = {};  
      vm.HDFC_WITH_DIRECT_ARN = angular.copy(AppConstants.HDFC_WITH_DIRECT_ARN); 
      vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
      vm.PARTNER_DATA = JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
      vm.linkdata = $window.JSON.parse(localStorage.getItem("distributorDetails"));
      vm.formData.panNumber = $window.atob($stateParams.pan); 
      vm.formData.otpDetails = {};
      vm.data = null;
      vm.schedulerIdDetails = ''; 
      function comp(a,b){
        var t1 = new Date(a.createdDateTime);
        var t2 = new Date(b.createdDateTime);
        if(t1>t2){
          return -1;
        }else{
          return 1;
        }
      }
      vm.init = function(){ 
        var success = function (resp) {
          if(resp.status && resp.data) { 
             vm.data = resp.data; 
             vm.pageLoad = true;  
             vm.data.sort(comp);
              vm.schedulerIdDetails = sessionStorage.getItem("schedulerIdDetails");
              var location = '#'+vm.schedulerIdDetails;
              window.location.hash = location;  
          }else{ 
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          MessageService.error(err);
        }
        var arnCode = vm.HDFC_WITH_DIRECT_ARN? "DIRECT":vm.linkdata.arn;
        var sendOtppayload = {
          arn: 'ARN-' + arnCode,
          pan: vm.formData.panNumber
        };
        InvestorService.post({
           child1: "gigworker",
           child2: "getTransactionDetailByPanArn" 
        }, sendOtppayload).$promise.then(success, error);
    
      }
      
      vm.init();
      vm.modify = function(data){
        vm.transactionType = 'Modify';
        vm.currentForlio = data;
        vm.folioNumber = data.folioNumber;
        vm.sendOtp();
      }
       //Canel Button Click function
      vm.cancel = function(data){ 
        vm.currentForlio = data;
        vm.folioNumber = data.folioNumber;
        var success = function(data) { 
          vm.transactionType = data;
          $rootScope.showTitle = false;
          vm.beforotp = false;
          vm.sendOtp();
        }, failure = function(resp) {
          vm.transactionType = null;
          $rootScope.showTitle = true;
          vm.beforotp = true;
          MessageService.error(resp.message);
        };
        ModalService.purchaseScheduleCancelModal({ 
        }, success, failure);
      } 
       //Icon Toggle function
      vm.changeToggleIcon = function(data){ 
        vm.schedulerIdDetails = ''; 
        vm.imgData = document.getElementById("collapseImage"+data); 
        vm.imgData.src = vm.imgData.ariaExpanded == "true"?"assets/images/arrow-up.svg":"assets/images/arrow-down.svg";
        vm.divData = document.getElementById("mainDiv"+data); 
        if(vm.imgData.ariaExpanded == "false"){
          vm.divData.style["border-bottom-left-radius"] = "12px";
          vm.divData.style["border-bottom-right-radius"] = "12px";
        }else{
          vm.divData.style["border-bottom-left-radius"] = "0px";
          vm.divData.style["border-bottom-right-radius"] = "0px";
        }
      }
       //Send OTP function
      vm.sendOtp = function () { 
        var success = function (resp) { 
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.beforotp = false;
            vm.formData.otpDetails = resp.data;
            localStorage.setItem('QuickInvestmentSecreteLink',resp.data.id);
            MessageService.success(resp.data.otpSentMessage);
          }else{
            MessageService.error(resp.message);
            vm.beforotp = true;
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          vm.beforotp = true;
          MessageService.error(err.error);
        }
        var sendOtppayload = {
           folioNumber: vm.folioNumber,
          panNumber: vm.formData.panNumber
        };
        LoaderService.showLoader();
        InvestorService.post({ child1: "registration", child2: "otp", child3: "generate",child4:"arnHardCode" }, sendOtppayload).$promise.then(success, error);
      }
       //Resend OTP function
      vm.reSendOtp = function () {
        vm.otpNumber = null;
        vm.sendOtp();
      }
      vm.loginPayload = {
        folioNumber: vm.folioNumber,
        panNumber: vm.formData.panNumber
      };
      //Go back on Pan details page function
      vm.back = function(){
        $rootScope.showTitle = true;
        vm.otpNumber = null;
        vm.beforotp = true;
      }
      //Verify OTP and redirection function
      vm.makeTransaction = function () { 
        var data = $window.JSON.parse(localStorage.getItem("distributorDetails")) 
        var successLogin = function (resp) {  
          LoaderService.hideLoader(); 
          localStorage.setItem('loggedIn', true);
          TransactionModel.setPayloadRawData(null);
          NetcoreEvntService.Login_Status_QI_IP(vm.loginPayload, true);  
          data.panNumber = vm.currentForlio.panNumber;
          data.schedulerId = vm.currentForlio.scheduler_id; 
          data.amount = vm.currentForlio.installmentAmount?vm.currentForlio.installmentAmount:data.amount;
          data.maskedEmail=vm.currentForlio.maskedEmail; 
          data.maskedMobileNumber=vm.currentForlio.maskedMobileNumber; 
          data.schedulerEndDate = vm.currentForlio.scheduleEndDate? vm.currentForlio.scheduleEndDate:null;
          data.schedulerStartDate = vm.currentForlio.scheduleStartDate? vm.currentForlio.scheduleStartDate:null;
          data.paymentOption = vm.currentForlio.payMech;
          data.euin = vm.currentForlio.euin;
          data.schemeCode = vm.currentForlio.schemeCode?vm.currentForlio.schemeCode:data.schemeCode;
          data.dividendOption = vm.currentForlio.dividendOption;
          data.chipherText = vm.currentForlio.uniqueLinkId;
          data.scheduleFrequency = vm.currentForlio.frequency;
          if(vm.currentForlio.payMech == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING || vm.currentForlio.payMech == 'OTM' || vm.currentForlio.payMech == 'UPI'){ 
            data.accountNumber = vm.currentForlio.accountNumber?vm.currentForlio.accountNumber:'';
            data.accountType = vm.currentForlio.accountType?vm.currentForlio.accountType:'';
            data.bankCity = vm.currentForlio.bankCity?vm.currentForlio.bankCity:'';
            data.bankName = vm.currentForlio.bankName?vm.currentForlio.bankName:'';
            data.branchName = vm.currentForlio.branchName?vm.currentForlio.branchName:'';
            data.ifscCode = vm.currentForlio.ifscCode?vm.currentForlio.ifscCode:'';
          }
          localStorage.setItem("distributorDetails",$window.JSON.stringify(data));
          sessionStorage.setItem("isModify", true);
          if(vm.transactionType == 'Modify'){ 
            $state.go("instantLoginHome.instantInvest");  
          }else{ 
            vm.canceSchedulelTransaction();
          } 
        }, errorLogin = function (error) { 
          localStorage.setItem("distributorDetails",$window.JSON.stringify(data));
          LoaderService.hideLoader();
          MessageService.error(error.message);
        } 
        var oauthpayload = {
          folioNumber: vm.folioNumber,
          secretLink: vm.formData.otpDetails.id,
          otp:vm.otpNumber,
          grant_type :'password',
          panNumber: vm.formData.panNumber?AuthService.encryptRSA(angular.copy(vm.formData.panNumber)):""
        };
        LoaderService.showLoader();
        AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);
      }
      //cancel Schedulel Transaction function
      vm.canceSchedulelTransaction = function(){
        var success = function (resp) {
          LoaderService.hideLoader();
          if(resp.status && resp.data){ 
            MessageService.success("Transaction Cancelled successfully");
            localStorage.setItem("cancelAcknowledementData", JSON.stringify(vm.currentForlio));
            $state.go("arnReview.successfulCancelTransaction");  
          }else{
            vm.data = null;
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err.error);
        }
        var payload = {
         purchaseSchedulerId:vm.currentForlio.scheduler_id
        };
        LoaderService.showLoader();
        InvestorService.post({
           child1: "gigworker",
           child2: "cancel"
        }, payload).$promise.then(success, error);
       
      } 
      vm.browserBackButtonClick = function(){
        $rootScope.PurchaseView = false; 
        vm.linkDetails = $window.JSON.parse(localStorage.getItem("distributorDetails"))  
        if(vm.pageLoad){
          $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.linkDetails.chipherText+"?ScheduleTransaction=true";
       }
      }
    }
  })();
  

/**
 * Created by ttn on 18/12/2024.
 */

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('dualDatePicker', dualDatePicker);

  /*@ngInject*/
  function dualDatePicker($window) {
    return {
      restrict: 'E',
      scope: {
        enabledStartDates: '=',
        enabledEndDates: '=',
        currentViewStart: '=',
        currentViewEnd: '=',
        startDate: '=',
        endDate: '=',
        onChangeStartDate: '=',
        onChangeEndDate: '=',
        inputPlaceholder: '='
      },
      templateUrl: 'app/components/directives/customDualDatePicker/dualDatePicker.html',
      link: function(scope, element){
        var vm = scope;
        vm.showCalendarView = false;
        vm.showCalender = showCalender;
        var calendarState = {
          1: {
            currentMonth: new Date().getMonth(),
            currentYear: new Date().getFullYear()
          },
          2: {
            currentMonth: new Date().getMonth(),
            currentYear: new Date().getFullYear()
          }
        };
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        // Handle calendar construction, it's view, callback method
        function updateCalendar(calendarId, enableDates, currentView, defaultDate, userChanged) {
          var monthYearDisplay = document.getElementById('calendar-month-year-' + calendarId);
          var calendarTitle = document.getElementById('calendar-title-' + calendarId);
          var calendarDays = document.getElementById('calendar-days-' + calendarId);
          var weekdays = document.getElementById('weekday-calendar-' + calendarId);
          var navigatePrevious = document.getElementById('prev-month-' + calendarId);
          var navigateNext = document.getElementById('next-month-' + calendarId);

          if(weekdays) {
            // Toggle visibility of weekdays based on view
            if (currentView === 'date') {
              weekdays.style.display = 'flex';
              weekdays.style.visibility = 'visible';
            } else {
              weekdays.style.visibility = 'hidden';
            }
          }
          calendarDays ? calendarDays.innerHTML = '' : null;

          if(defaultDate) {
            calendarState[calendarId].currentMonth = defaultDate.month();
            calendarState[calendarId].currentYear = defaultDate.year();
          }
          if (currentView === 'date') {
            // weekdays.style.display = 'block';
            if(calendarId && calendarId === 1) {
              if(userChanged) {
                monthYearDisplay.textContent = "From: " + monthNames[calendarState[calendarId].currentMonth] + ' ' + calendarState[calendarId].currentYear;
              } else {
                monthYearDisplay.textContent = "From : " + vm.startDate.format("DD MMM YYYY");
              }
            } else if (calendarId && calendarId === 2) {
              if(userChanged) {
                monthYearDisplay.textContent = "To: " + monthNames[calendarState[calendarId].currentMonth] + ' ' + calendarState[calendarId].currentYear;
              } else {
                if(vm.endDate) {
                  monthYearDisplay.textContent = "To : " + vm.endDate.format("DD MMM YYYY");
                } else {
                  monthYearDisplay.textContent = "To : Invalid End Date";
                }
              }

            }

            calendarDays.classList.remove('grid-col-update');
            var firstDay = new Date(calendarState[calendarId].currentYear, calendarState[calendarId].currentMonth, 1).getDay();
            var totalDays = new Date(calendarState[calendarId].currentYear, calendarState[calendarId].currentMonth + 1, 0).getDate();

            for (var i = 0; i < firstDay; i++) {
              var emptyCell = document.createElement('span');
              calendarDays.appendChild(emptyCell);
            }

            for (var day = 1; day <= totalDays; day++) {
              var dayButton = document.createElement('button');
              var currentDay = new Date(calendarState[calendarId].currentYear, calendarState[calendarId].currentMonth, day);

              if (isEnabledDate(currentDay, enableDates)) {
                if(defaultDate) {
                  var matchingDate = defaultDate.date() === day;
                  if(matchingDate) {
                    dayButton.classList.add('selected');
                  }
                }
                dayButton.textContent = day;
                dayButton.addEventListener('click', function () {
                  var selectedDate = this.textContent + ' ' + monthNames[calendarState[calendarId].currentMonth] + ' ' + calendarState[calendarId].currentYear;

                  if(calendarId === 1) {
                    scope.onChangeStartDate($window.moment(selectedDate));
                  } else if (calendarId === 2) {
                    scope.onChangeEndDate($window.moment(selectedDate));
                    vm.showCalendarView = false;
                  }
                });
              } else {
                dayButton.textContent = day;
                dayButton.disabled = true;
              }

              calendarDays.appendChild(dayButton);
            }
            disableNavigationIcons(calendarId, currentView, enableDates, navigatePrevious, navigateNext);
          } else if (currentView === 'month') {
            if(calendarId && calendarId === 1) {
              if(userChanged) {
                monthYearDisplay.textContent = "From: " + calendarState[calendarId].currentYear;
              } else {
                monthYearDisplay.textContent = "From : " + vm.startDate.format("DD MMM YYYY");
              }
            } else if (calendarId && calendarId === 2) {
              if(userChanged) {
                monthYearDisplay.textContent = "To: " + calendarState[calendarId].currentYear;
              } else {
                if(vm.endDate) {
                  monthYearDisplay.textContent = "To : " + vm.endDate.format("DD MMM YYYY");
                } else {
                  monthYearDisplay.textContent = "To : Invalid End Date";
                }
              }
            }

            for (var index = 0; index < monthNames.length; index++) {
              var monthButton = document.createElement('button');
              monthButton.textContent = monthNames[index];
              calendarDays.classList.add('grid-col-update');

              if (isEnabledMonth(index, calendarState[calendarId].currentYear, enableDates)) {
                if(defaultDate) {
                  var matchingMonth = defaultDate.format("MMM") === monthNames[index];
                  if(matchingMonth) {
                    monthButton.classList.add('selected');
                  }
                }
                monthButton.addEventListener('click', (function (idx) {
                  return function () {
                    calendarState[calendarId].currentMonth = idx;
                    currentView = 'date';
                    if (calendarId === 1) {
                      vm.currentViewStart = 'date';
                    } else {
                      vm.currentViewEnd = 'date';
                    }
                    updateCalendar(calendarId, enableDates, currentView, null, true);
                  };
                })(index));
              } else {
                monthButton.disabled = true;
              }

              calendarDays.appendChild(monthButton);
            }
            disableNavigationIcons(calendarId, currentView, enableDates, navigatePrevious, navigateNext);
          } else if (currentView === 'year') {
            if(calendarId && calendarId === 1) {
              if(userChanged) {
                monthYearDisplay.textContent = "From: " + calendarState[calendarId].currentYear;
              } else {
                monthYearDisplay.textContent = "From : " + vm.startDate.format("DD MMM YYYY");
              }
            } else if (calendarId && calendarId === 2) {
              if(userChanged) {
                monthYearDisplay.textContent = "To: " + calendarState[calendarId].currentYear;
              } else {
                if(vm.endDate) {
                  monthYearDisplay.textContent = "To : " + vm.endDate.format("DD MMM YYYY");
                } else {
                  monthYearDisplay.textContent = "To: Invalid End Date";
                }
              }
            }

            for (var i = calendarState[calendarId].currentYear - 5; i <= calendarState[calendarId].currentYear + 5; i++) {
              var yearButton = document.createElement('button');
              yearButton.textContent = i;

              if (isEnabledYear(i, enableDates)) {
                yearButton.addEventListener('click', (function (yr) {
                  return function () {
                    calendarState[calendarId].currentYear = yr;
                    currentView = 'month';
                    if (calendarId === 1) {
                      vm.currentViewStart = 'month';
                    } else {
                      vm.currentViewEnd = 'month';
                    }
                    updateCalendar(calendarId, enableDates, currentView, null, true);
                  };
                })(i));
              } else {
                yearButton.disabled = true;
              }

              calendarDays.appendChild(yearButton);
            }
            disableNavigationIcons(calendarId, currentView, enableDates, navigatePrevious, navigateNext);
          }
        }

        // Checks passed date lies in enableDates
        function isEnabledDate(date, enabledDates) {
          return enabledDates && enabledDates.some(function (enabledDate) {
            // Convert moment.js date to JavaScript Date if needed
            var jsDate = (typeof enabledDate.toDate === 'function') ? enabledDate.toDate() : enabledDate;
            var convertedDate = (typeof date.toDate === 'function') ? date.toDate() : date;
            return convertedDate.toDateString() === jsDate.toDateString();
          });
        }

        // Checks passed month lies in enableDates
        function isEnabledMonth(month, year, enabledDates) {
          return enabledDates && enabledDates.some(function (enabledDate) {
            // Convert moment.js object to JavaScript Date if needed
            var jsDate = (typeof enabledDate.toDate === 'function') ? enabledDate.toDate() : enabledDate;
            return jsDate.getFullYear() === year && jsDate.getMonth() === month;
          });
        }

        // Check passed year lies in enabledDates
        function isEnabledYear(year, enabledDates) {
          return enabledDates && enabledDates.some(function (enabledDate) {
            // Convert moment.js object to JavaScript Date if needed
            var jsDate = (typeof enabledDate.toDate === 'function') ? enabledDate.toDate() : enabledDate;
            return jsDate.getFullYear() === year;
          });
        }

        // Toggle calendar view in date/month/year
        function toggleCalendarView(calendarId) {
          if (calendarId === 1) {
            if(vm.currentViewStart === 'year') {
              return;
            }
            if (vm.currentViewStart === 'date') {
              vm.currentViewStart = 'month';
            } else if (vm.currentViewStart === 'month') {
              vm.currentViewStart = 'year';
            } else {
              vm.currentViewStart = 'date';
            }
            updateCalendar(calendarId, vm.enabledStartDates, vm.currentViewStart, null, true);
          } else if (calendarId === 2) {
            if(vm.currentViewEnd === 'year') {
              return;
            }
            if (vm.currentViewEnd === 'date') {
              vm.currentViewEnd = 'month';
            } else if (vm.currentViewEnd === 'month') {
              vm.currentViewEnd = 'year';
            } else {
              vm.currentViewEnd = 'date';
            }
            updateCalendar(calendarId, vm.enabledEndDates, vm.currentViewEnd, null, true);
          }
        }

        // Handle navigation through chevron icons
        function navigateMonth(calendarId, offset, enableDates, currentView) {
          // Update currentMonth based on offset
          if (currentView === "date") {
            // In date view, navigate by month
            calendarState[calendarId].currentMonth += offset;

            if (calendarState[calendarId].currentMonth < 0) {
              calendarState[calendarId].currentMonth = 11;
              calendarState[calendarId].currentYear--;
            } else if (calendarState[calendarId].currentMonth > 11) {
              calendarState[calendarId].currentMonth = 0;
              calendarState[calendarId].currentYear++;
            }
          }
          else if (currentView === "month") {
            // In month view, navigate by year
            calendarState[calendarId].currentYear += offset;
          }
          else if (currentView === "year") {
            // In year view, navigate by decades
            calendarState[calendarId].currentYear += offset * 10;
          }
          updateCalendar(calendarId, enableDates, currentView, null, true);
        }

        // Checks If endDate lies in enableEndDates array
        function validateEndDate() {
          if (vm.endDate && (vm.enabledEndDates && vm.enabledEndDates.length > 0)) {
            var isValid = isEnabledDate(vm.endDate, vm.enabledEndDates);
            if (!isValid) {
              vm.endDate = null;
              updateTenureDisplay();
              if (typeof vm.onChangeEndDate === 'function') {
                vm.onChangeEndDate(null);
              }
            }
          }
        }

        // Handle tenure to display in input element
        function updateTenureDisplay() {
          if(vm.startDate && vm.endDate) {
            vm.tenureDisplay = $window.moment(vm.startDate).format('D MMM YYYY') + ' - ' + $window.moment(vm.endDate).format('D MMM YYYY');
          } else if (vm.startDate && !vm.endDate) {
            vm.tenureDisplay = $window.moment(vm.startDate).format('D MMM YYYY') + ' - Invalid End Date';
          } else {
            vm.tenureDisplay = scope.inputPlaceholder;
          }
        }

        // Toggle the calendar View
        function showCalender() {
          vm.showCalendarView = !vm.showCalendarView;

          // Attach event listener to detect clicks outside calendar
          if (vm.showCalendarView) {
            $window.document.addEventListener('click', handleClickOutside);
          } else {
            $window.document.removeEventListener('click', handleClickOutside);
          }
        }

        // Handle click outside calendar
        function handleClickOutside(event) {
          // Check if the click target is outside the calendar element
          if (!element[0].contains(event.target)) {
            vm.showCalendarView = false;
            $window.document.removeEventListener('click', handleClickOutside);
          }
        }

        //Handle if startDate/endDate lies in enabledDatesArray
        function setDefaultDates() {
          if (vm.startDate && isEnabledDate(vm.startDate, vm.enabledStartDates)) {
            if(vm.showCalendarView) {
              updateCalendar(
                1,
                vm.enabledStartDates,
                'date',
                vm.startDate
              );
            }
          }

          if (vm.endDate && isEnabledDate(vm.endDate, vm.enabledEndDates)) {
            if(vm.showCalendarView) {
              updateCalendar(
                2,
                vm.enabledEndDates,
                'month',
                vm.endDate
              );
            }
          }
        }

        function disableNavigationIcons(calendarId, currentView, enableDates, navigatePrevious, navigateNext) {
          var currentYear = calendarState[calendarId].currentYear;
          var currentMonth = calendarState[calendarId].currentMonth;

          if (currentView === 'date') {
            // Check if any date in the previous or next month is enabled
            var prevDate = $window.moment([currentYear, currentMonth - 1]);
            var nextDate = $window.moment([currentYear, currentMonth + 1]);

            navigatePrevious.disabled = !enableDates.some(function(date) {
              return date.year() === prevDate.year() && date.month() === prevDate.month();
            });
            navigateNext.disabled = !enableDates.some(function(date) {
              return date.year() === nextDate.year() && date.month() === nextDate.month();
            });

          } else if (currentView === 'month') {
            // Check if any date in the previous or next year is enabled
            var prevYear = currentYear - 1;
            var nextYear = currentYear + 1;

            navigatePrevious.disabled = !enableDates.some(function(date) {
              return date.year() === prevYear;
            });
            navigateNext.disabled = !enableDates.some(function(date) {
              return date.year() === nextYear;
            });

          } else if (currentView === 'year') {
            var prevYearRangeStart = currentYear - 10;
            var nextYearRangeStart = currentYear + 10;

            var isPrevYearEnabled = enableDates.some(function(date) {
              var year = date.year();
              return year >= prevYearRangeStart && year < currentYear; // Check entire range of previous decade
            });

            var isNextYearEnabled = enableDates.some(function(date) {
              var year = date.year();
              return year >= currentYear && year < nextYearRangeStart; // Check entire range of next decade
            });

            navigatePrevious.disabled = !isPrevYearEnabled;
            navigateNext.disabled = !isNextYearEnabled;
          }
        }

        scope.$watchGroup(['enabledStartDates', 'enabledEndDates'], function () {
          if(vm.showCalendarView) {
            updateCalendar(1, vm.enabledStartDates, vm.currentViewStart);
            updateCalendar(2, vm.enabledEndDates, vm.currentViewEnd);
            setDefaultDates();
          }
        });

        scope.$watchGroup(['startDate', 'endDate'], function() {
          updateTenureDisplay();
          setDefaultDates();
          validateEndDate();
        })

        scope.$watch('showCalendarView', function () {
          if(vm.showCalendarView) {
            updateCalendar(1, vm.enabledStartDates, vm.currentViewStart);
            updateCalendar(2, vm.enabledEndDates, vm.currentViewEnd);
            setDefaultDates();


            // document.getElementById('calendar-title-1').addEventListener('click', function () {
            //   toggleCalendarView(1);
            // });

            document.getElementById('calendar-title-2').addEventListener('click', function () {
              toggleCalendarView(2);
            });

            document.getElementById('prev-month-1').addEventListener('click', function () {
              navigateMonth(1, -1, vm.enabledStartDates, vm.currentViewStart);
            });

            document.getElementById('next-month-1').addEventListener('click', function () {
              navigateMonth(1, 1, vm.enabledStartDates, vm.currentViewStart);
            });

            document.getElementById('prev-month-2').addEventListener('click', function () {
              navigateMonth(2, -1, vm.enabledEndDates, vm.currentViewEnd);
            });

            document.getElementById('next-month-2').addEventListener('click', function () {
              navigateMonth(2, 1, vm.enabledEndDates, vm.currentViewEnd);
            });
          } else {
            vm.currentViewStart = "date";
            vm.currentViewEnd = "month";
          }
        })

        // Cleanup event listener on scope destruction
        scope.$on('$destroy', function() {
          $window.document.removeEventListener('click', handleClickOutside);
        });
      }
    }
  }
})();

(function () {
    "use strict";
    angular
      .module("hdfc-mf-investor-web")
      .controller("successfulCancelTransactionController", successfulCancelTransactionController);
  
    function successfulCancelTransactionController($state, TransactionModel, NetcoreEvntService,InvestorService,$window, $rootScope,AppConstants, LoaderService, $stateParams,AuthService, TransactionService, MessageService, IIHttpService, $filter, ModalService,InvestorServiceVersion3, CreatePayloadFactory,toastr) {
      var vm = this;   
      $rootScope.PurchaseView = true; 
      vm.HDFC_WITH_DIRECT_ARN = angular.copy(AppConstants.HDFC_WITH_DIRECT_ARN); 
      // $rootScope.showTitle = true;
      vm.getFoiloDetails = function(){
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.folioData = resp.data; 
            vm.optOutNominee = vm.folioData.optOutNominee,
            vm.optedOutNominee = vm.folioData.optedOutNominee
          }else{
          }
        },error = function (err) {
          UtilService.errorHandler(err);
        };
        InvestorService.post({child1: 'profile',child2: 'folio',child3: 'details',
        },{"folioNumber":vm.data.folioNumber}).$promise.then(success, error);
      }
      vm.data= $window.JSON.parse(localStorage.getItem("cancelAcknowledementData"));
      vm.getFoiloDetails();
      $rootScope.modifyLogin = false; 
      $rootScope.modifyPan = ""; 
      if(!vm.data){
        $rootScope.modifyLogin = false;
      }else{
        $rootScope.modifyPan = vm.data.pan; 
        $rootScope.modifyLogin = true; 
      } 
    }
  })();
  
/**
 * Created by ttn on 29/04/24.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('WhatsappPreLoginTokenHomeController', whatsappPreLoginTokenHomeController);

  /** @ngInject */
  function whatsappPreLoginTokenHomeController(AuthService, $state, ModalService, $timeout, AppConstants ,
                                             MessageService, $scope, $rootScope) {
    var vm = this;
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    vm.isLoading = true;
    vm.init = init;
    vm.stateTitle = $state.current.title;
    vm.showLogoutBtn = false;
    var removeListeners = {}, isRefreshing = false;
    var scope = $scope;

    init();
    function init() {
      setListeners();
    }


    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        if (!token) {
          $state.go('sessionExpired');
          resetFlag();
          return;
        }

        if (token && token.refreshToken) {
          AuthService.getRefreshTokenGateway(token).then(function () {
            if (localStorage.getItem('doLogOut')) {
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                ModalService.logoutSuccess();
                $state.go('sessionExpired');
              }, function () {
                ModalService.logoutSuccess();
                $state.go('sessionExpired');
              });
            } else {
              $state.reload();
              resetFlag();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            $state.go('sessionExpired');
            resetFlag();
          });
        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          $state.go('sessionExpired');
        }
      });

      var resetFlag = function () {
        $timeout(function () {
          isRefreshing = false;
        }, 2000);
      };

      // removeListeners['disableLogout'] = $scope.$on("disableLogout", function() {
      //   vm.showLogoutBtn = false;
      // });

      removeListeners['showNewLogo'] = $scope.$on("showNewLogo", function(event, result) {
        vm.logoUrl = result;
        sessionStorage.setItem("logoUrl",vm.logoUrl);
      });

      scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in removeListeners) {
          if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
            removeListeners[key]();
          }
        }
      });
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('WhatsappPaymentController', whatsappPaymentController);

  /** @ngInject */
  function whatsappPaymentController(ModalService, AppConstants,IIHttpService, $window, $timeout, $state, $rootScope, $scope,
                                       $stateParams, TransactionModel, LoaderService, TransactionService,
                                       InvestorService, MessageService, UtilService, $log, NetcoreEvntService, HDFC_API, TransactionServiceVersion,notesPayment, FileUploadServiceVersion2,$sce, DownloadPdfService,FileSaver,AuthService,CommonFactory,investorServiceVersion) {


    var vm = this;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.PATTERN = AppConstants;
    vm.showPaymentInfo = false;
    vm.formData = {};
    vm.linkID = sessionStorage.getItem('linkId');
    vm.formData.sipFirstInstallment = false;
    vm.paymentOptions = [];
    vm.paymentOptionsFI = [];
    vm.netBankingBankList = null;
    vm.UPIBankList = null;
    vm.otmBankList = null;
    vm.disclaimer = false;
    vm.amountOverUPILimit = false;
    vm.linkHasbeenExpired = false;
    vm.fetchInSchemeValidations = fetchInSchemeValidations;
    vm.updateEndDates = updateEndDates;
    vm.durationYears = 30;
    vm.validations = {};
    vm.getUPIId = getUPIId;
    var TrFlowType = AppConstants.TRANSACTION_FLOW;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.PATTERN = AppConstants;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    $scope.billdeskUrl = HDFC_API.BILLDESK_URL;
    vm.NRI_STATUS_CODES = AppConstants.NRI_STATUS_CODES;
    vm.getFormData = getFormData;
    vm.isDisableUpi = false;
    vm.sipUpiText = vm.TRANSACTIONS_CONST.DESCRIPTIONS.UPI_AUTOPAY;
    vm.isUPIVerified = false;
    vm.isCheckedDeclaration = false;
    vm.bankInfo = null;
    vm.OTMbankInfo = null;
    vm.UPIbankInfo = null;
    vm.investorInfo = null;
    vm.debitCardType = 'visa';
    vm.isInvalidForm = false;
    vm.isInvalidFormFI = false;
    vm.selectedUpiBank = selectedUpiBank;
    vm.hideOtmOtion = false;
    vm.verifyUPI = verifyUPI;
    vm.isGreaterThanSeventeenDays = 0;
    vm.getAccountNumber = getAccountNumber;
    vm.tpv = tpv;
    vm.netBankingAndUPIList = null;
    vm.OTMList = null
    vm.isOTMAmount = false;
    vm.isOTMDate = false;
    vm.isOTMStartDate = false;
    vm.isOTMAmountFI = false;
    vm.isOTMDateFI = false;
    vm.isOTMStartDateFI = false;
    vm.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.notesApiGateWayPayment = notesPayment;
    vm.noteNetBanking = vm.notesApiGateWayPayment.noteDTO.noteDTOMap.Note_Purchase_Net_Banking;
    vm.billdeskPayload = {
      hidRequestId : "PGIME1000",
      hidOperation : "ME100",
      msg : ""
    };
    vm.isNewPayment = true;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff", "application/pdf"];
    vm.chooseAFile = true;
    vm.changedPaymentOptionPurchase =  changedPaymentOptionPurchase;
    vm.checkDuplicate = checkDuplicate;
    vm.copyPasteHandler = copyPasteHandler;
    vm.successBackUrl = sessionStorage.getItem('redirectUrl');
    vm.viewBillerPaymentMode =  false;
    vm.apiConfig = AppConstants.API_CONFIG;
    vm.isCheckedTandCeMandate = false;
    vm.formData.emandateWord = {};
    vm.formData.selectedPaymentOption = 'UPI';
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.changeEndDateEmandate =  changeEndDateEmandate;
    vm.billerBankList = null;
    vm.mandateBankList = null;
    vm.CORPORATE_URL = HDFC_API.CORPORATE_URL;
    vm.showTermConditionsemandate = showTermConditionsemandate;
    vm.changedSipPaymentOption= changedSipPaymentOption;
    vm.isTransactionDone =  sessionStorage.getItem('isTransactionDone')?true: false;
    vm.UPITabExpanded = true;
    vm.OTMTabExpanded = false;
    vm.PNetBankingTabExpanded = false;
    vm.SNetBankingTabExpanded = false;
    var Card = $window.Card || {};

    vm.init = init();

    function init() {
      if (vm.linkID) {
        sessionStorage.removeItem('redirectUrl');
        fetchUserSavedData(function () {
          if (vm.formData.investmentType === 'PURCHASE') {
            initPurchase();
          } else if (vm.formData.investmentType === 'SIP') {
            initSip();
          }
        });
      } else {
        sessionStorage.removeItem("logoUrl");
        if (vm.successBackUrl) {
          $window.location.href = vm.successBackUrl;
        } else {
          vm.linkHasbeenExpired = true;
        }
      }
    }


    function fetchUserSavedData(cb) {
      cb = cb ||function () {};

      var success = function (resp) {
        if (resp.status && resp.data) {
          if(resp.data.errorMsg && resp.data.errorMsg.toUpperCase() == "TRANSACTION LINK HAS BEEN EXPIRED."){
            vm.linkHasbeenExpired = true;
            vm.formData.investmentType = resp.data.summaryType;
            LoaderService.hideLoader();
            return;
          }
          if(resp.data.euinCode){
            resp.data.euinOpted = "Y";
          }else{
            resp.data.euinOpted = "N";
          }
          vm.savedData = resp.data;
          setInitialFormData();
          LoaderService.hideLoader();
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
          if (vm.successBackUrl) {
            $window.location.href = vm.redirectUrl;
          } else {
            $state.go("login");
          }
        }
        cb();
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.data && err.data.error);
      };
      var transactionType = sessionStorage.getItem("transactionType");
      var payload = {
        transactionId : vm.linkID,
        transactionType:transactionType
      }
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'whatsapp',
        child2: 'transaction',
        child3:'summary'
      },payload).$promise.then(success, error);
    }


    function setInitialFormData() {
      vm.formData.investmentType = vm.savedData.summaryType;
      vm.formData.purchaseInSchemeName = vm.savedData.schemeName;
      vm.formData.schemeName = vm.savedData.schemeName;
      vm.formData.folioNumber = vm.savedData.folioNumber;
      vm.formData.investorType = vm.savedData.investorType;
      if (vm.formData.investmentType === 'PURCHASE') {
        fetchOTMBankForPurchase();
        vm.formData.purchaseAmount = vm.savedData.amount;
        $window.NumToWord(vm.formData.purchaseAmount, 'TransactionPaymentInWord', vm.formData);
        vm.formData.purchaseInSchemeCode = vm.savedData.schemeCode;
      } else if (vm.formData.investmentType === 'SIP') {
        fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM);
        vm.formData.amount = vm.savedData.amount;
        vm.formData.sipFirstAmount = vm.savedData.amount;
        $window.NumToWord(vm.formData.amount, 'TransactionPaymentInWord', vm.formData);
        vm.formData.inSchemeCode = vm.savedData.schemeCode;
        vm.formData.startDate = vm.savedData.sipDate;
        vm.viewBillerPaymentMode =  false;
        vm.durationYears = vm.savedData.duration;
        vm.formData.day = vm.formData.startDate ? $window.moment(vm.formData.startDate, "DD-MMM-YYYY").format('D') : '';
        vm.formData.endDate = vm.savedData.sipEndDate;
        vm.formData.frequency = vm.savedData.sipFrequency;
        if(vm.formData.frequency.toUpperCase() == "MONTHLY"){
          vm.formData.frequency = "OM"
        }
        if(vm.formData.frequency.toUpperCase() == "DAILY"){
          vm.formData.frequency = "BZ"
        }
        if(vm.formData.frequency.toUpperCase() == "WEEKLY"){
          vm.formData.frequency = "OW"
        }
        if(vm.formData.frequency.toUpperCase() == "YEARLY"){
          vm.formData.frequency = "Y"
        }
        if(vm.formData.frequency.toUpperCase() == "HALFYEARLY" || vm.formData.frequency.toUpperCase() == "HALF YEARLY"){
          vm.formData.frequency = "H"
        }
        if(vm.formData.frequency.toUpperCase() == "QUATERLY"){
          vm.formData.frequency = "Q"
        }
        if (vm.formData.frequency === 'OW') {
          vm.formData.weeklyDay = vm.savedData.weeklyDay ? vm.savedData.weeklyDay : $window.moment(vm.formData.startDate, "DD-MMM-YYYY").format('dddd');
        }
        if (vm.savedData.topupDetails) {
          vm.formData.sipTopupEnabled = true;
          vm.formData.topupDetails = vm.savedData.topupDetails;
        }
        vm.formData.sipFirstInstallment = vm.savedData.sipWithFirstInstallment;
        if (vm.formData.sipFirstInstallment) {
          vm.formData.inSchemeName = vm.savedData.schemeName;
        }
      }
      vm.formData.secretLink = vm.savedData.secretLink;
      vm.formData.liquidFlag = vm.savedData.liquidSchemeFlag;
      if (vm.savedData.distributorDetails && !vm.savedData.distributorDetails.riaOpted && vm.savedData.distributorDetails.arnNo) {
        vm.formData.isThroughDistributor = true;
      }
      vm.formData.euin = {};
      if (vm.savedData.euinCode && vm.savedData.euinName) {
        vm.formData.euin.euinCode= vm.savedData.euinCode;
        vm.formData.euin.euinName = vm.savedData.euinName;
      }
      vm.formData.subBrokerARN = vm.savedData.distributorDetails.subBrokerArn;
      if (vm.formData.subBrokerARN && !vm.formData.subBrokerARN.includes('ARN')){
        vm.formData.subBrokerARN = 'ARN-' + vm.formData.subBrokerARN
      }
      vm.formData.subBrokerCode =  vm.savedData.distributorDetails.subBrokerCode;
      vm.formData.brokerCode = vm.savedData.distributorDetails.arnNo;
      vm.formData.brokerName = vm.savedData.distributorDetails.name;
      if (vm.formData.brokerCode && !vm.formData.brokerCode.includes('ARN') && vm.formData.brokerCode != "DIRECT"){
        if(vm.savedData.distributorDetails.riaOpted){
          vm.formData.brokerCode = vm.formData.brokerCode;
        }else{
          vm.formData.brokerCode = 'ARN-' + vm.formData.brokerCode;
        }
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
        vm.formData.isThroughDistributor = true;
      }
      if(vm.savedData.distributorDetails.riaOpted){
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
        vm.formData.isThroughDistributor = false;
      }
      if(vm.formData.brokerCode == "DIRECT"){
        vm.formData.isDirect = true;
        vm.formData.isThroughRia = false;
        vm.formData.isThroughDistributor = false;
      }
      vm.formData.transactionId = vm.savedData.transactionId;
      vm.formData.minorFlag = vm.savedData.minor;
      vm.formData.dividendOption = vm.savedData.dividendOption;
      vm.formData.investmentOption = vm.savedData.investmentOption;
      vm.formData.schemeType = vm.savedData.schemeType;
      if(vm.formData.investmentOption && vm.formData.investmentOption.toUpperCase() == 'GROWTH'){
        vm.formData.dividendOption = 'Z';
      }
      if(vm.formData.investmentOption == 'DIVIDEND') {
        vm.formData.dividendOption = vm.savedData.dividendOption;
      }
      vm.formData.retirementAgeProofURL = vm.savedData.retirementAgeProofURL;
      sessionStorage.setItem('pd', encodeURI(JSON.stringify({
        "panNumber": vm.savedData.panNumber
      })));
      vm.formData.upiLimit = vm.savedData.upiMaxAmountLimit;
      vm.formData.upiErrorMessage = vm.savedData.upiMaxAmountErrMessage;
      vm.successBackUrl = vm.savedData.homeRedirectUrl;
      if (vm.savedData.logo) {
        $scope.$emit('showNewLogo',vm.savedData.logo);
      }
      if(vm.formData.investmentType == "SIP"){
        vm.fetchInSchemeValidations(function () {
          var sipRequiredDate = new Date($window.moment(new Date()).format("DD-MMM-YYYY"));
          var addDays = vm.inSchemeValidations && vm.inSchemeValidations.sipTDay ? vm.inSchemeValidations.sipTDay: 17;
          sipRequiredDate.setDate(sipRequiredDate.getDate()+addDays);
          var startDate = new Date(vm.formData.startDate); 
          // in sip payment mode Hide Biller option for Daily and weekly frequency
          if(startDate>= sipRequiredDate && (vm.formData.frequency != "OW" &&  vm.formData.frequency != "BZ") ){
            vm.viewBillerPaymentMode =  true;
          }
          vm.updateEndDates();
        })
      }
      sessionStorage.setItem('redirectUrl',vm.successBackUrl);
    }

    /**
     * Function responsible for initial function calls for PURCHASE
     */

    function initPurchase() {
      // payment options set
      if (!vm.formData.liquidFlag) {
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      } else {
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }

      getInvestorInfo(function () {
        getDetails(function () {
          // vm.formData.selectedPaymentOption = vm.paymentOptions[0];
          changedPaymentOptionPurchase();
        });
      });

      getAccountType();

    }

    /**
     * Function responsible for initial function calls for SIP
     */

    function initSip() {
      vm.paymentOptions = [];

      getInvestorInfo(function () {
        getDetails(function () {
          fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
        });
      });

      getAccountType();
    }


    function getInvestorInfo(cb) {
      cb = cb ||function () {

      };
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
        } else {
          vm.investorInfo = null;
          MessageService.error(resp.message);
        }
        cb();
      }, error = function (err) {
        UtilService.errorHandler(err);
        vm.investorInfo = null;
        cb();
      };
      InvestorService.get({
        child1: 'folio',
        child3: 'info'
      }).$promise.then(success, error);
    }

    function getDetails(cb) {
      cb = cb ||function () {
      };
      var success = function (resp) {
        var bankDetails=[];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if(vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length>0){
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if(value.defaultBank===true){return value;}
          });
        }
        localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
        cb();
      }, error = function () {
        LoaderService.hideLoader();
        cb();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }


    function getAccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.formData.investorType
      }).$promise.then(success, error);
    }

   vm.changedPaymentOption = function(){
    vm.isUPIVerified = false;
    if(vm.formData.investmentType == 'PURCHASE'){
      LoaderService.showLoader();
      $timeout(function(){
        changedPaymentOptionPurchase();
      },1000);
    }
    if(vm.formData.investmentType == 'SIP'){
      LoaderService.showLoader();
      $timeout(function(){
        changedSipPaymentOption();
      },1000);
    }
   }

    function changedPaymentOptionPurchase() {
      vm.isCheckedDeclaration = false;
      // vm.bankInfo = null;
      vm.bankList = null;
      vm.formData.paymentInfo = {amount: vm.formData.purchaseAmount};
      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isInvalidForm = false;
      vm.fileType='';
      vm.bankchequeLeafUrl = null;
      vm.isNewPayment = true;
      vm.formData.paymentInfo.chequeLeaf = null;

      switch (vm.formData.selectedPaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          vm.formData.paymentInfo.paymentMode = "WEB";
          fetchBankListPurchase();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          fetchBankListPurchase();
          if(vm.otmBankList && vm.otmBankList.length > 0){
            vm.changeBank();
          }
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          resetUPIForm();
          fetchBankListPurchase();
          if(vm.formData.purchaseAmount > vm.formData.upiLimit) {
            vm.amountOverUPILimit=true;
            var success = function() {
              vm.formData.selectedPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING;
              changedPaymentOptionPurchase();
            }
            ModalService.genericModal({
              text: vm.formData.upiErrorMessage,
              isUpi: true
            },success);
          }
          vm.formData.paymentInfo.paymentMode = "WEB";
          vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
          break;
      }
      LoaderService.hideLoader();
    }
    function changedSipPaymentOption(){
      vm.formData.paymentInfo = null;
      vm.formData.paymentInfoFI = null;
      vm.startDateValidation = false;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      vm.isCheckedDeclaration = false;
      // vm.bankInfo = null;
      vm.formData.paymentInfo = {amount: vm.formData.amount};
      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isInvalidForm = false;
      vm.isInvalidFormFI = false;
      vm.isNewPayment = true;
      vm.isCheckedTandCeMandate = false;

      switch (vm.formData.selectedPaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
          if(!vm.billerBankList || vm.billerBankList.length == 0 ){
            fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC);
          }
          else if(vm.billerBankList && vm.billerBankList.length === 1) {
            vm.bankInfo = vm.billerBankList[0];
            $timeout(function() {
              vm.changeBank();
            })
          } 
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if(!vm.otmBankList || vm.otmBankList.length == 0 ){
            fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM);
          }
          else if(vm.otmBankList && vm.otmBankList.length === 1) {
            vm.OTMbankInfo = vm.otmBankList[0];
            $timeout(function() {
              vm.changeBank();
            })
          }
          if(vm.otmBankList && vm.otmBankList.length > 0){
            vm.changeBank();
          }
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          resetUPIForm();
          if(vm.UPIBankList && vm.UPIBankList.length === 1) {
            vm.UPIbankInfo = vm.UPIBankList[0];
            $timeout(function() {
              vm.changeBank();
              selectedUpiBank();
            })
          }

          if(vm.formData.amount > vm.formData.upiLimit) {
            vm.amountOverUPILimit = true;
            var success = function() {
              // vm.formData.selectedPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
              // vm.changedSipPaymentOption(vm.formData.selectedPaymentOption);
            }
            ModalService.genericModal({
              text: vm.formData.upiErrorMessage,
              isUpi: true
            },success);
          }
          break;
        default :

      }
      LoaderService.hideLoader();
    }


    function changeEndDateEmandate(date) {
      vm.formData.endDateEmandate = date ? date : null;
      if (vm.formData.endDate) {
        vm.sipDateLessEmandate =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
      }
    }

    function checkAmountValidationEmandate() {
      vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
      vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
      vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.formData.amount ? true : false;
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
    }


    /**
     * Function responsible for setting bank list for net banking , UPI and NEFT/RTGS
     */

    function fetchBankListPurchase() {
      LoaderService.showLoader('fetchBanklist');
      var ApiConfig =  {child1: 'bank', child2: 'list'};
      var ApiPayload = {
        trnxType: vm.formData.investmentType,
        folioNumber: vm.formData.folioNumber,
        liquidSchemeFlag: vm.formData.liquidFlag
      }
      var ApiConfigOTM = {child1: 'folio', child2: 'otm'};
      var ApiPayloadOTM = {
        transactionType : vm.formData.investmentType.toLowerCase(),
        folioNo: vm.formData.folioNumber
      }
      var success = function (resp) {
        LoaderService.hideLoader('fetchBanklist');
        if (resp.status && resp.data) {
          var bankList = resp.data.bankList;
          if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
            vm.otmList = resp.data;
            vm.otmBankList = resp.data.bankList;
            bankList = angular.copy(vm.otmBankList);
            vm.OTMbankInfo = vm.otmBankList && vm.otmBankList.length > 0 ? vm.otmBankList[0] : null;
            vm.changeBank();
          }
          if(vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING){
            vm.netBankingBankList = bankList;
            vm.bankInfo = vm.netBankingBankList && vm.netBankingBankList.length > 0 ? vm.netBankingBankList[0] : null;
            vm.changeBank();
          }
          if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            vm.UPIBankList = bankList;
            vm.UPIbankInfo = vm.UPIBankList && vm.UPIBankList.length > 0 ? vm.UPIBankList[0] : null;
            vm.changeBank();
            selectedUpiBank();
          }
          if (bankList && (bankList.length == 1 || (vm.formData.investmentType === 'SIP' && vm.formData.sipFirstInstallment && vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI))) {
            if (vm.formData.investmentType === 'SIP' && vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
              vm.bankInfo =  vm.formData.bankInfo;
              vm.formData.paymentInfo.virtualAddress = vm.formData.virtualAddress;
              vm.verifyUPIResp = vm.formData.verifyUPIResp;
              vm.name = vm.verifyUPIResp.name;
              vm.isUPIVerified = vm.verifyUPIResp.valid;
              vm.isDisableUpi = true;
            } else {
              vm.bankInfo = bankList[0];
            }
            $timeout(function() {
              vm.changeBank();
              if(vm.formData.selectedPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
                selectedUpiBank();
              }
            })
          }
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      }, error = function (resp) {
        LoaderService.hideLoader('fetchBanklist');
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      }
      switch (vm.formData.selectedPaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if (vm.UPIBankList === null)  {
            if (vm.formData.investmentType === 'SIP') {
              ApiPayload.sipUpiFlow = true;
            }
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          } else if (vm.UPIBankList && vm.UPIBankList.length === 1) {
            vm.UPIbankInfo = vm.UPIBankList[0];
            $timeout(function() {
              vm.changeBank();
              selectedUpiBank();
            })
          }
          LoaderService.hideLoader();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          if (vm.netBankingBankList === null)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          } else if (vm.netBankingBankList && vm.netBankingBankList.length === 1) {
          vm.bankInfo = vm.netBankingBankList[0];
            $timeout(function() {
              vm.changeBank();
            })
          }
          LoaderService.hideLoader();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if (vm.otmBankList === null)  {
            InvestorService.post(ApiConfigOTM, ApiPayloadOTM).$promise.then(success, error);
          } else if (vm.otmBankList && vm.otmBankList.length === 1) {
            vm.OTMbankInfo = vm.otmBankList[0];
            $timeout(function() {
              vm.changeBank();
            })
          }
          LoaderService.hideLoader();
          break;
      }
    };

    function fetchOTMBankForPurchase() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
            var bankList = resp.data.bankList;
            vm.otmList = resp.data;
            vm.otmBankList = resp.data.bankList;
            bankList = angular.copy(vm.otmBankList);
            vm.OTMbankInfo = vm.otmBankList && vm.otmBankList.length > 0 ? vm.otmBankList[0] : null;
            vm.changeBank();
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      }, error = function (resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      }
      var ApiConfigOTM = {child1: 'folio', child2: 'otm'};
      var ApiPayloadOTM = {
        transactionType : vm.formData.investmentType.toLowerCase(),
        folioNo: vm.formData.folioNumber
      }
      if (vm.otmBankList === null)  {
        LoaderService.showLoader();
        InvestorService.post(ApiConfigOTM, ApiPayloadOTM).$promise.then(success, error);
      } else if (vm.otmBankList && vm.otmBankList.length === 1) {
          vm.OTMbankInfo = vm.otmBankList[0];
        $timeout(function() {
          vm.changeBank();
        })
      }
    };
    /**
     * Function responsible for setting bank list SIP
     */

    function fetchBankListSIP(transactionType) {

      var ApiConfig =  vm.apiConfig.COMMON;

      var ApiPayload = {
        trnxType: 'PURCHASE',
        folioNumber: vm.formData.folioNumber,
        liquidSchemeFlag: vm.formData.liquidFlag,
        sipFlow : true
      }

      LoaderService.showLoader();

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {

          if (transactionType === 'EC') {
            vm.billerBankList =  resp.data.bankList ? resp.data.bankList : [];
            vm.bankInfo = vm.billerBankList && vm.billerBankList.length > 0 ?vm.billerBankList[0]:null;
            if (vm.billerBankList && vm.billerBankList.length > 0 && vm.formData.frequency !== 'OW' && vm.formData.frequency !=='BZ') {
              vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC);
            }
          }

          if (transactionType === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
            vm.otmList = resp.data;
            vm.otmBankList = vm.formData.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList;
            vm.OTMbankInfo = vm.otmBankList && vm.otmBankList.length > 0 ?vm.otmBankList[0]:null;
            if (vm.otmBankList && vm.otmBankList.length > 0) {
              vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM);
            }


          }


          if (transactionType === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            vm.UPIBankList = resp.data.bankList ? resp.data.bankList : [];
            vm.UPIbankInfo = vm.UPIBankList && vm.UPIBankList.length > 0 ?vm.UPIBankList[0]:null;
            if (vm.UPIBankList && vm.UPIBankList.length > 0) {
              vm.endDateEmandateBoundExistUPI = $window.moment(vm.formData.endDate,'DD-MMM-YYYY').isSameOrBefore(vm.maxEndDateEmandateUPI);
              if (vm.endDateEmandateBoundExistUPI) {
                vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
              }
            }
            vm.formData.selectedPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
            changedSipPaymentOption(0);

          }
            vm.changeBank();
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
          handleErrorCallback(transactionType);
        }
      }, error = function (resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
        handleErrorCallback(transactionType);
      }

      switch (transactionType) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
          if (vm.billerBankList === null)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          }
          LoaderService.hideLoader();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          ApiConfig = vm.apiConfig.OTM;

          ApiPayload = {
            transactionType : vm.formData.investmentType.toLowerCase(),
            folioNo: vm.formData.folioNumber
          }

          if (vm.otmBankList === null)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          }
          LoaderService.hideLoader();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          delete ApiPayload.sipFlow;
          ApiPayload.sipUpiFlow = true;
          if (vm.UPIBankList === null)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          }
          LoaderService.hideLoader();
          break;
      }
    };

    /**
     * Function responsible for emandate end date validation
     */


    function updateEmandateEndDate() {

      if (!vm.formData.emandateDate) {
        return;
      }

      var enabledEndDates = [];

      if(vm.formData.emandateDate)
      {
        vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
        vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateMaxYear, 'years').subtract(1,'days');
        vm.maxEndDateEmandateUPI = $window.moment().add(vm.emandateMaxYear, 'years').subtract(1,'days');
        vm.endDateEmandateBoundExist = $window.moment(vm.formData.endDate,'DD-MMM-YYYY').isSameOrBefore(vm.maxEndDateEmandate);

        if (vm.endDateEmandateBoundExist && !vm.formData.sipFirstInstallment && vm.mandateBankList && vm.mandateBankList.length > 0 && vm.folioEmandateStatus && !vm.formData.sipTopupEnabled) {
          vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
        }

      }

      if (vm.endDateEmandateBoundExist || vm.endDateEmandateBoundExistUPI) {
        var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
        for (var i = 0; i <= freq; i++) {
          enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
        }
        vm.enabledEmandateEndDatesList = enabledEndDates;
        vm.endDateViewEmandate =  vm.minEndDateEmandate.clone();
        vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
      }
    }

    /**
     * Function responsible for handling bank change SIP and PURCHASE
     */

    vm.changeBank = function (data,type) {
      if(type && data){
          if(type == 'EC' && vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC || vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING){
            vm.bankInfo = data;
          }
          if(type == 'NETBANKING' && vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING){
            vm.bankInfo = data;
          }
          if(type == 'OTM' && vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM){
            vm.OTMbankInfo = data;
          }
          if(type == 'UPI' && vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
            vm.UPIbankInfo = data;
          }
      }
      if ((!vm.bankInfo && (vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC || vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING))||
      (vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM && !vm.OTMbankInfo)||
      (vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI && !vm.UPIbankInfo)) {
        return;
      }
      if(!vm.formData.paymentInfo){
        vm.formData.paymentInfo = {amount: vm.formData.amount};
      }
      vm.isInvalidForm = false;
      switch (vm.formData.selectedPaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            return;
          }
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType==""?null:vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          if (vm.bankInfo.tpvEnableFlag == 'Y') {
            getAccountNumber(vm.bankInfo.bankCode);
          }
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if(!vm.OTMbankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.OTMbankInfo = null;
            vm.isCheckedDeclaration = false;
            return;
          }
          vm.formData.paymentInfo.otmId = vm.OTMbankInfo.otmId;
          vm.formData.paymentInfo.bankName = vm.OTMbankInfo.bankName;
          vm.formData.paymentInfo.bankBranch = vm.OTMbankInfo.bankBranch;
          vm.formData.paymentInfo.bankAcNo = vm.OTMbankInfo.bankAcNo;
          vm.formData.paymentInfo.ifscCode = vm.OTMbankInfo.ifscCode;
          vm.formData.paymentInfo.payoutId = vm.OTMbankInfo.payoutId;
          vm.formData.paymentInfo.omUmrn = vm.OTMbankInfo.omUmrn;
          vm.formData.paymentInfo.eMandatebankAcNo = vm.OTMbankInfo.eMandatebankAcNo;
          vm.formData.paymentInfo.eMandateUmrn = vm.OTMbankInfo.eMandateUmrn;
          vm.formData.paymentInfo.accType = vm.OTMbankInfo.bankAcType ? vm.OTMbankInfo.bankAcType : null;
          (angular.isDefined(vm.OTMbankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.OTMbankInfo.camsMandateIdNo);
          checkOTMAmountAndDate();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if(!vm.UPIbankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            return;
          }
          vm.formData.paymentInfo.accType = vm.UPIbankInfo.bankAcType ? vm.UPIbankInfo.bankAcType : null;
          vm.formData.paymentInfo.bankName = vm.UPIbankInfo.bankName;
          vm.formData.paymentInfo.ifscCode = vm.UPIbankInfo.ifscCode;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
          vm.formData.netBankingUrl = vm.bankInfo ? vm.bankInfo.netBankingUrl : "";
          if (!vm.bankInfo.bankAcType) {
            getAccountType();
          }
          break;
        default :
          vm.bankInfo = null;
          vm.OTMbankInfo = null;
          vm.UPIbankInfo = null;
          break;
      }
    };
    /**
     * Function responsible for handling upi bank change
     */
    function selectedUpiBank() {
      if (!vm.UPIbankInfo) {
        return;
      }

      if(!vm.UPIbankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
        ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
        vm.UPIbankInfo = null;
        vm.isCheckedDeclaration = false;
        return;
      }
      // vm.upiAccountNumber = vm.UPIbankInfo.accountNumber;
      // vm.upiBankName = vm.UPIbankInfo.bankName;
      vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
    };
    function getFormData(form) {
      vm.tForm = form;
    };
    function verifyUPI() {
      vm.verifyUPIResp = {};
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.verifyUPIResp = resp.data;
            if (resp.data.valid) {
              vm.name = resp.data.name;
              vm.isUPIVerified = true;
              vm.changeBank();
            } else {
              vm.isUPIVerified = false;
            }
          }
          else {
            vm.isUPIVerified = false;
            vm.verifyUPIResp.valid = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };
      LoaderService.showLoader();
      var payload = {
        "virtualAddress": vm.formData.paymentInfo.virtualAddress.toLowerCase()
      };
      if (vm.formData.investmentType === 'SIP') {
        payload.basketFlow = false;
        payload.folioNo = vm.formData.folioNumber;
        investorServiceVersion.post({
          child1: 'upi',
          child2: 'check',
          child3: 'virtualAddress'
        }, payload).$promise.then(success, error);
      } else {
        InvestorService.post({
          child1: 'upi',
          child2: 'check',
          child3: 'virtualAddress'
        }, payload).$promise.then(success, error);
      }
    }
    /**
     * Function responsible for checking OTM bank validations
     */
    function checkOTMAmountAndDate(flow) {
      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isOTMAmountFI = false;
      vm.isOTMDateFI = false;
      vm.isOTMStartDateFI = false;
      // Check Ammout
      if (vm.formData.purchaseAmount && (vm.formData.purchaseAmount > vm.OTMbankInfo.maxAmount)) {
        vm.isOTMAmount = true;
      } else if (vm.formData.purchaseAmount && (vm.formData.purchaseAmount < vm.OTMbankInfo.maxAmount)){
        vm.isOTMAmount = false;
      }
      if (flow !== "FI") {
        // Check Ammout SIP
        if (vm.formData.amount && (vm.formData.amount > vm.OTMbankInfo.maxAmount)) {
          vm.isOTMAmount = true;
        } else if (vm.formData.amount && (vm.formData.amount < vm.OTMbankInfo.maxAmount)) {
          vm.isOTMAmount = false;
        }
        //Compare
        if (vm.formData.investmentType === 'SIP') {
          var dateToCompare = $window.moment(vm.formData.endDate,"DD-MMM-YYYY");
        } else {
          var dateToCompare = $window.moment();
        }
        if ($window.moment(vm.OTMbankInfo.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore(dateToCompare)) {
          vm.isOTMDate = true;
        }
        else {
          vm.isOTMDate = false;
        }
        if (!($window.moment(vm.OTMbankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.otmList.currentDate, 'DD-MMM-YYYY')))){
          vm.isOTMStartDate = true;
        }
        else{
          vm.isOTMStartDate = false;
        }
      }
      if (flow === "FI") {
        // Check Ammout FI
        if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount > vm.bankInfoFI.maxAmount)) {
          vm.isOTMAmountFI = true;
        } else if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount < vm.bankInfoFI.maxAmount)) {
          vm.isOTMAmountFI = false;
        }
        //Compare Dates FI
        if ($window.moment(vm.bankInfoFI.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDate,"DD-MMM-YYYY"))) {
          vm.isOTMDateFI = true;
        }
        else {
          vm.isOTMDateFI = false;
        }
        if (!($window.moment(vm.bankInfoFI.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.otmList.currentDate, 'DD-MMM-YYYY')))){
          vm.isOTMStartDateFI = true;
        }
        else{
          vm.isOTMStartDateFI = false;
        }
      }
      //Check for amount or date
      if (vm.isOTMAmount || vm.isOTMDate) {
        vm.isInvalidForm = true;
      } else {
        vm.isInvalidForm = false;
        //tForm.$invalid
      }
      if (flow === "FI" && vm.formData.sipFirstInstallment && (vm.isOTMAmountFI || vm.isOTMDateFI)) {
        vm.isInvalidFormFI = true;
      } else {
        vm.isInvalidFormFI = false;
      }
    }

    function tpv(event) {
      event.preventDefault();
      ModalService.tpvModal({});
    }

    function getAccountNumber(bankCode,flow) {
      if(vm.investorInfo && vm.investorInfo.transactionFlowVersion === TrFlowType.NEW){
        if (flow === 'FI') {
          vm.formData.paymentInfoFI.tpvEnableFlag = vm.bankInfoFI.tpvEnableFlag;
          vm.formData.paymentInfoFI.accountNumber = vm.bankInfoFI.accountNumber;
        } else {
          vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
          vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
        }
        return;
      }
      vm.bankAccounts = [];
      vm.isInvalidForm = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            vm.bankAccounts = resp.data.accountNumbers;
            if (vm.bankAccounts.length > 1) {
              var success = function (accountNo) {
                if (flow === 'FI') {
                  vm.formData.paymentInfoFI.tpvEnableFlag = vm.bankInfoFI.tpvEnableFlag;
                  vm.formData.paymentInfoFI.accountNumber = accountNo;
                } else {
                  vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
                  vm.formData.paymentInfo.accountNumber = accountNo;
                }
                vm.isInvalidForm = false;
              }, error = function () {

              };
              ModalService.selectAccountNoModal({bankAccounts: vm.bankAccounts}, success, error);
            } else {
              if (flow === 'FI') {
                vm.formData.paymentInfoFI.tpvEnableFlag = vm.bankInfoFI.tpvEnableFlag;
                vm.formData.paymentInfoFI.accountNumber = vm.bankAccounts[0];
              } else {
                vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
                vm.formData.paymentInfo.accountNumber = vm.bankAccounts[0];
              }
              vm.isInvalidForm = false;
            }
          } else {
            vm.isInvalidForm = true;
            MessageService.error(resp.message);
            vm.bankAccounts = [];
          }
        },
        error = function (err) {
          vm.bankAccounts = [];
          vm.isInvalidForm = true;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "bankCode": bankCode
      };
      InvestorService.post({
        child1: 'bank',
        child2: 'account'
      }, payload).$promise.then(success, error);
    }
    /**
     * Function responsible for resetting UPI fields
     */
    function resetUPIForm() {
      vm.verifyUPIResp = {};
      vm.isUPIVerified = false;
      (vm.formData.paymentInfo)&&(vm.formData.paymentInfo.virtualAddress = "");
    }
    vm.checkForMinorBankListCondition = function() {
      // if(vm.formData!=null && vm.formData.minorFlag!=null && vm.formData.cgfFlag!=null)
      //   return vm.formData.minorFlag && !vm.formData.cgfFlag;
      // else
      //   return false;
      return false;
    };
    /**
     * Function responsible for checking duplicate transaction
     */
    function checkDuplicate($event) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                transactionOtpConfirmation($event);
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
            }else {
              transactionOtpConfirmation($event);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType: vm.formData.investmentType,
        folioNumber: vm.formData.folioNumber,
        schemeCode:  vm.formData &&  vm.formData.investmentType == "SIP"? vm.formData.inSchemeCode : vm.formData.purchaseInSchemeCode,
        amount: vm.formData &&  vm.formData.investmentType == "SIP"? vm.formData.amount : vm.formData.purchaseAmount
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'transaction',
        child2: 'check',
        child3: 'duplicate'
      }, payload).$promise.then(success, error);
    };


    /**
     * Function responsible for handling 2FA
     */

    function transactionOtpConfirmation($event) {
      var otpSuccessCallback, otpDismissCallback;

      otpSuccessCallback = function(resp) {
        LoaderService.hideLoader();
        submitForm($event);
      };

      otpDismissCallback = function(err) {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      var modalPayload = {
        transactionFolioNumber: vm.formData.folioNumber,
        transactionType: vm.formData.investmentType,
        lastTransactedFolioNumber: sessionStorage.getItem("folioID"),
        secretLink:vm.formData.secretLink
      };

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {

            vm.singleUseURL = resp.data.secretLink;
            if(vm.formData.secretLink !=  vm.singleUseURL){
              var otpDetails = {
                secretOtpLink : vm.singleUseURL,
                otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
                otpId : resp.data.id
              };

              var payload = {
                folioNumber:  vm.formData.folioNumber,
                formType : vm.formData.investmentType
              }

              if (vm.formData.selectedPaymentOption && vm.formData.selectedPaymentOption === 'UPI' && vm.formData.investmentType === 'SIP') {
                var noteUpiModal = vm.notesApiGateWayPayment.noteDTO.noteDTOMap.Note_SIP_UPI_2FA;
                payload.paymentOption = 'UAP';
              }

              ModalService.transactionOtpModal({
                otpPayload: otpDetails,
                payload: payload,
                upiModalOtp : noteUpiModal,
                gateWayJourney : true
              }, otpSuccessCallback, otpDismissCallback);
          }else{
            LoaderService.hideLoader();
            submitForm($event);
          }
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message)
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      TransactionService.post({
        controller1: 'whatsapp',
        controller2: 'transaction',
        controller3: 'otp'
      }, modalPayload).$promise.then(success, error);
    }


    function submitForm($event) {
      // userActivityTracking(false, function () {
        var payload = getSipPurchasePayload();
        if (!payload) {
          MessageService.error('Something went wrong while calculating purchase payload.');
          return;
        }
        if (payload.formType === 'PURCHASE' && vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING &&
          vm.formData.purchaseAmount >= 200000 && vm.formData.schemeType != 'LIQUID') {
          vm.showPurchaseNetBankingModal(payload);
        } else if (vm.formData.investmentType === 'SIP'){
          vm.finalSubmit(payload);
        }
        else {
          vm.finalSubmit(payload);
        }
      // });
    };

    function userActivityTracking(isProcessed, cb) {

      /*Netcore Event Start*/
      if(!isProcessed){
        NetcoreEvntService.Continue_To_Pay_Purchase_IP(vm.formData, true);
      }
      /*Netcore Event End*/
      cb = cb || function () {
      };
      var success = function (trackResp) {
        trackResp = trackResp.data || trackResp;
        LoaderService.hideLoader();
        cb(trackResp);
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(false);
      };

      LoaderService.showLoader();
      var userTrackerPayload = setUserTrackerPayload(isProcessed);
      InvestorService.post({
        child1: 'userBehavior',
        child2: 'addupdate'
      }, userTrackerPayload).$promise.then(success, error);
    };

    function setUserTrackerPayload(isProcessed) {
      var _payload = {
        "trxnRefNo": $stateParams.trackId?$stateParams.trackId:"", //required in case of update
        "trxnType": vm.formData.investmentType, //SIP, PURCHASE
        "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
        "step": "THIRD", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode,
        "folioNo": vm.formData.folioNumber,
        "formData": vm.formData,
        "amount": vm.formData.purchaseAmount,
        "trxnStatus": isProcessed ? "PROCESSED":"OPEN"  // OPEN,PROCESSED
      };

      return _payload;
    }

    vm.showPurchaseNetBankingModal = function (payload) {
      vm.finalSubmit(payload);
    };

    /**
     * Function responsible for handling approve call
     */

    vm.finalSubmit = function (payload) {
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            // userActivityTracking(true, function(){

            if (vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
              vm.redirectUrl = resp.data.redirectUrl;
            }
            var ackData = {
              amount : vm.formData.investmentType == 'SIP'?vm.formData.amount:vm.formData.purchaseAmount,
              schemeName : vm.formData.schemeName,
              status: resp.data.trnxActionFlag?resp.data.trnxActionFlag:false,
              investmentType:vm.formData.investmentType
            };

            if(vm.formData.investmentType === 'SIP' && !vm.formData.sipFirstInstallment) {
              if(vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM ||
                vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC){
                  //  ackData.srnNo =resp.data.srnNo;
                   sessionStorage.setItem('whatsAppPaymentAck', JSON.stringify(ackData));
                   vm.isTransactionDone = true;
                   sessionStorage.setItem('isTransactionDone', true);
                   $state.go("preLoginWhatsappHome.paymentacknowledgement");
              }else{
                handleSipResponse(resp.data);
              }
            } else {
              if(vm.formData.selectedPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM){
                sessionStorage.setItem('whatsAppPaymentAck',JSON.stringify(ackData));
                vm.isTransactionDone = true;
                sessionStorage.setItem('isTransactionDone', true);
                $state.go("preLoginWhatsappHome.paymentacknowledgement");
              }else{
                handlePurchaseResponse(resp.data);
              }
            }
            // });

          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message,
                isAadhar: true
              });
            } else {
              MessageService.error(resp.message);
            }

          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

        var invType = null;
        invType = vm.formData.investmentType.toLowerCase();
        TransactionServiceVersion.post({
          controller1: 'transaction',
          controller2: invType,
          controller3: 'approve'
        }, payload).$promise.then(success, error);
    };


    /**
     * Function responsible for handling payment success for FI and PURCHASE
     */

    function handlePurchaseResponse(data) {
      // $scope.$emit('disableLogout');
      var transactionId = data && data.transactionId ? data.transactionId : null;
      data = data && data.data ? data.data : data;
      if (!data) {
        MessageService.error();
        return;
      }

      if(vm.formData.investmentType==='SIP')
        vm.billdeskMsg = data.emandateMsg;
      else
        vm.billdeskMsg = data;

      if ((vm.formData.investmentType !=='SIP' && vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLDESK') || (vm.formData.investmentType =='SIP' && vm.formData.sipFirstInstallment && vm.formData.paymentInfoFI.paymentMode == 'WEB' && vm.formData.paymentInfoFI.webMode == 'BILLDESK')) {
        if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () { // commented as debit currently is not getting used
            // logoutMe(function () {
              angular.element('#billdeskForm').submit();
            // });
          });

        } else {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            // logoutMe(function () {
              angular.element('#billdeskForm').submit();
            // });
          });

        }

      }
      else if ((vm.formData.investmentType !=='SIP' && vm.formData.paymentInfo.paymentMode == 'WEB' && (vm.formData.paymentInfo.webMode == 'MASTERCARD' || vm.formData.paymentInfo.webMode == 'VISA')) ||  (vm.formData.investmentType ==='SIP' && vm.formData.sipFirstInstallment && vm.formData.paymentInfoFI.paymentMode == 'WEB' && (vm.formData.paymentInfoFI.webMode == 'MASTERCARD' || vm.formData.paymentInfoFI.webMode == 'VISA'))) {
        if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            // logoutMe(function () {
              angular.element('#billdeskForm').submit();
            // });
          });

        } else {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            // logoutMe(function () {
              angular.element('#billdeskForm').submit();
            // });
          });

        }
      }
      else if ((vm.formData.investmentType !=='SIP' &&  vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLJUNCTION') || (vm.formData.investmentType ==='SIP' && vm.formData.sipFirstInstallment && vm.formData.paymentInfoFI.paymentMode == 'WEB' && vm.formData.paymentInfoFI.webMode == 'BILLJUNCTION')) {
        // logoutMe(function () {
          $window.open(vm.billdeskMsg, '_self');
        // });

      } else if ((vm.formData.investmentType !=='SIP' && vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'UPI') || (vm.formData.investmentType ==='SIP' && vm.formData.sipFirstInstallment && vm.formData.paymentInfoFI.paymentMode == 'WEB' && vm.formData.paymentInfoFI.webMode == 'UPI')) {
        if(!vm.redirectUrl) {
          MessageService.error("Something went wrong");
        } else {
          // logoutMe(function () {
            $window.location.href = vm.redirectUrl;
          // });
        }
      }else {
        // normal SIP
        // OTM
        logoutMe();
        var successModal = function () {},
        errorModal = function () {};
        ModalService.selftClose({"investmentType":vm.formData.investmentType},successModal, errorModal);
      }
      // sessionStorage.removeItem('linkId');
    }
    /**
     * Function responsible for handling payment success for SIP
     */
    function handleSipResponse(data) {
      if (!data) {
        MessageService.error();
        return;
      }

      if (data.eMandateEnabled && data.paymentOption == 'EC') {
        //openPaynimo(data.trxnNo, data.srnNo, data.pNMFreq);
      } else if (vm.formData.selectedPaymentOption == 'E-mandate') {
        data = data && data.data ? data.data : data;
        if (!data) {
          MessageService.error();
          return;
        }
        $window.location.href= $scope.billdeskUrl + data.emandateMsg;
      } else if (vm.formData.selectedPaymentOption == 'UPI') {
        if (!data) {
          MessageService.error();
          return;
        }

        $window.location.href = data.redirectUrl;
      } else {
      }

    }

    function getPaymentInfo() {

      if(vm.formData.investmentType === 'SIP') {
        if (vm.formData.paymentInfoFI && vm.formData.paymentInfoFI.webMode === 'MASTER') {
          vm.formData.paymentInfoFI.webMode = 'MASTERCARD';
        }
      } else {
        if (vm.formData.paymentInfo && vm.formData.paymentInfo.webMode === 'MASTER') {
          vm.formData.paymentInfo.webMode = 'MASTERCARD';
        }
      }

      var paymentInfo={};

      if(vm.formData.investmentType==='SIP')
      {
        // paymentInfo = {
        //   paymentMode: vm.formData.paymentInfoFI.paymentMode

        // };

      }
      else
      {
        paymentInfo = {
          amount: vm.formData.paymentInfo.amount,
          paymentMode: vm.formData.paymentInfo.paymentMode

        };

        switch (vm.formData.selectedPaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.bankName = vm.bankInfo.bankName;
            if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
              paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
              paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            }
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            paymentInfo.otmId = vm.formData.paymentInfo.otmId;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.branchName = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNo = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.payoutId = vm.formData.paymentInfo.payoutId;
            paymentInfo.omUmrn = vm.formData.paymentInfo.omUmrn;
            paymentInfo.camsMandateIdNo = vm.formData.paymentInfo.camsMandateIdNo;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNo = vm.formData.paymentInfo.accNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            paymentInfo.accType = vm.formData.paymentInfo.bankAcType;
            paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
            // if(vm.isNewPayment) {
            paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            // }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.accountHolderName = vm.formData.paymentInfo.accountHolderName;
            paymentInfo.bankName = "HDFC Bank Ltd";
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.bankAcNo = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
            paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
            paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
            paymentInfo.upiReferenceNumber = '';
            paymentInfo.accountNumber = vm.UPIbankInfo.accountNumber;
            paymentInfo.accNo= vm.UPIbankInfo.accountNumber;
            paymentInfo.accType = vm.UPIbankInfo.bankAcType ? vm.UPIbankInfo.bankAcType : vm.formData.paymentInfo.accType;
            paymentInfo.bankName =  vm.UPIbankInfo.bankNameOnly;
            paymentInfo.ifscCode = vm.UPIbankInfo.ifscCode ? vm.UPIbankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
            break;
        }
      }

      return angular.copy(paymentInfo);
    }

    /**
     * Function responsible for setting sip purchase payload
     */

    function getSipPurchasePayload() {
      if (vm.formData.investmentType === 'SIP') {
        var sipPayload = {
          installmentAmount: vm.formData.amount,
          investmentOption: vm.formData.investmentOption,
          dividendOption: vm.formData.dividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          frequency: vm.formData.frequency,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          toDate: vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY').toString() : '',
          sipDate: vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY').toString() : '',
          sipDay: vm.formData.day,
          schemeType:vm.formData.schemeType?vm.formData.schemeType:"",
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          id: vm.linkID,
          subBrokerArn: vm.formData.subBrokerARN,
          subBrokerCode: vm.formData.subBrokerCode,
          brokerCode: vm.formData.brokerCode,
          secretLink: vm.singleUseURL,
          sourceAppPortal: "WHATSAPP",
          netCoreRefNo : null
        }
      } else if (vm.formData.investmentType === 'PURCHASE') {
        var purchasePayload = {
          amount: vm.formData.purchaseAmount,
          investmentOption: vm.formData.investmentOption,
          dividendOption: vm.formData.dividendOption,
          folioNumber: vm.formData.folioNumber,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          schemeCode: vm.formData.purchaseInSchemeCode,
          retirementAgeProofURL: vm.formData.retirementAgeProofURL ? vm.formData.retirementAgeProofURL : '',
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          id: vm.linkID,
          paymentInfo: getPaymentInfo(),
          subBrokerArn: vm.formData.subBrokerARN,
          subBrokerCode: vm.formData.subBrokerCode,
          checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
          autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null,
          autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null,
          secretLink: vm.singleUseURL,
          sourceAppPortal: "WHATSAPP",
          netCoreRefNo : null
        }
      }

      if (purchasePayload && purchasePayload.paymentInfo.accountNumber) {
        purchasePayload.accountNumber = purchasePayload.paymentInfo.accountNumber;
        //delete purchasePayload.paymentInfo.accountNumber;
      }
      if (purchasePayload && purchasePayload.paymentInfo.tpvEnableFlag) {
        purchasePayload.tpvEnableFlag = purchasePayload.paymentInfo.tpvEnableFlag;
        delete purchasePayload.paymentInfo.tpvEnableFlag;
      }

      if (vm.formData.investmentType === 'SIP' && vm.formData.selectedPaymentOption === 'UPI') {
        sipPayload.payerVpa = vm.formData.paymentInfo.virtualAddress;
        sipPayload.payerName = vm.name;
        sipPayload.paymentOption = 'UAP';
      }


      var payload = {};

      switch (vm.formData.investmentType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          purchasePayload = handleBrokerCode(purchasePayload);
          payload = angular.copy(purchasePayload);
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          sipPayload = handleBrokerCode(sipPayload);
          payload = angular.copy(sipPayload);
          break;
      }


      if(vm.formData.investmentType==='SIP')
      {

        if(vm.formData.selectedPaymentOption==='EC') {
          payload.bankDetailsForECS= {
            accNumber: vm.bankInfo.accountNumber,
            bankName: vm.bankInfo ? vm.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode,
            branchName: vm.bankInfo.bankBranch,
            bankCity: vm.bankInfo.bankCity,
            paymentOption: vm.formData.selectedPaymentOption,
            netBankingUrl:vm.formData.netBankingUrl,
            bankCode:vm.bankInfo ? vm.bankInfo.bankCode:null,
            accType: vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType
          }
        }
        if(vm.formData.selectedPaymentOption==='UPI') {
          payload.bankDetailsForECS= {
            accNumber: vm.UPIbankInfo.accountNumber,
            bankName: vm.UPIbankInfo ? vm.UPIbankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.UPIbankInfo.ifscCode ? vm.UPIbankInfo.ifscCode : vm.formData.paymentInfo.ifscCode,
            branchName: vm.UPIbankInfo.bankBranch,
            bankCity: vm.UPIbankInfo.bankCity,
            paymentOption: vm.formData.selectedPaymentOption,
            netBankingUrl:vm.formData.netBankingUrl,
            bankCode:vm.UPIbankInfo ? vm.UPIbankInfo.bankCode:null,
            accType: vm.UPIbankInfo.bankAcType ? vm.UPIbankInfo.bankAcType : vm.formData.paymentInfo.accType
          }

          if (vm.formData.selectedPaymentOption && vm.formData.selectedPaymentOption === 'UPI') {
            payload.bankDetailsForECS.paymentOption ='UAP';
          }
        }
        else if(vm.formData.selectedPaymentOption==='OTM') {
          payload.bankDetailsForECS= {
            accNumber: vm.OTMbankInfo.bankAcNo,
            bankName: vm.OTMbankInfo ? vm.OTMbankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.OTMbankInfo.ifscCode ? vm.OTMbankInfo.ifscCode : vm.formData.paymentInfo.ifscCode,
            branchName: vm.OTMbankInfo.bankBranch,
            bankCity: vm.OTMbankInfo.bankCity,
            paymentOption: vm.formData.selectedPaymentOption,
            payoutId:vm.OTMbankInfo.payoutId,
            bankCode:vm.OTMbankInfo ? vm.OTMbankInfo.bankCode:null,
            accType: vm.OTMbankInfo.bankAcType ? vm.OTMbankInfo.bankAcType : vm.formData.paymentInfo.accType,
            camsMandateIdNo: vm.OTMbankInfo.camsMandateIdNo,
            omUmrn: vm.OTMbankInfo.omUmrn
          }
        }


        if(vm.formData.sipTopupEnabled) {
          payload.sipTopupEnabled=vm.formData.sipTopupEnabled;
          payload.topupDetails=vm.formData.topupDetails;
        }

      }

      return payload;
    }

      /*
  Function responsible to manage the broker code for purchase and sip payload
  * */
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode;
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = true;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }


    function copyPasteHandler(e) {
      UtilService.copyPasteHandler(e);
    };

    /**
     * Function responsible for handling user logout
     */

    function logoutMe(cb) {
      cb = cb ||function () {};
      var val = {  "panNumber" : vm.savedData.panNumber };

      var success = function (resp) {
          localStorage.removeItem("userId");
          var newDataLayer = $window.dataLayer.filter(function (obj) {
            return !obj.hasOwnProperty('userId');
          });
          $window.dataLayer = newDataLayer;
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          CommonFactory.setLogoutSuccess();
          cb();
        },
        error = function (err) {
        };
      LoaderService.showLoader('.logout');
      InvestorService.post({
        child1: 'force',
        child2: 'logout'
      }, val).$promise.then(success, error);

    }

    /**
     * Function responsible for note link redirection
     */

    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };

    /**
     * Function responsible for opening mandate TNC modal
     */

    function showTermConditionsemandate() {
      ModalService.transactionalTermConditionModalEMandate({'transactionType': 'SIP-E-MANDATE','subTransactionType':vm.formData.investmentType});
    };

    /**
     * Function responsible for handling bank list api call during error
     */

    function handleErrorCallback(transactionType) {
      //handling if api call fails

      if (transactionType === 'EC') {
        fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM);
      } else if (transactionType === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
      } else if(transactionType === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
        UtilService.fetchMandateValidations(true).then(function (resp) {
          vm.emandateObj = resp.eOTM;
          vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
          vm.mandateMaxString = vm.emandateObj.maxAmountLimitInfo;
          vm.formData.emandateDate = $window.moment().add(1,'days');
          updateEmandateEndDate();
          if (vm.formData.sipFirstInstallment) {
            fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING);
          } else {
            fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
          }
        }).catch(function(resp) {
          updateEmandateEndDate();
          if (vm.formData.sipFirstInstallment) {
            fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING);
          } else {
            fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
          }
        });

      } else if (transactionType === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING) {
        fetchBankListSIP(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
      } else if (transactionType === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
        vm.formData.selectedPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
        changedSipPaymentOption(0);
      }
    }

    var stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
      TransactionModel.setPayloadRawData(null);
    });

    $scope.$on('$destroy', function () {
      stateChangeStart();
    })

    function getUPIId(){
      vm.formData.selectedPaymentOption =  "UPI";

    }
      function fetchInSchemeValidations(cb) {
        vm.inSchemeValidations = null;
        if (vm.transactionType) {
          vm.formData.investmentType = vm.transactionType;
        } else if (vm.formData.investmentType) {
          vm.transactionType = vm.formData.investmentType;
        }
        var transactionType = vm.formData.investmentType.toLowerCase();
        cb = cb || function () {
        };
        if (!vm.formData.inSchemeCode) {
          return;
        }else if (!vm.formData.inSchemeCode && !vm.inSchemeCode){
          return;
        }

        var success = function (resp) {
            if (resp.status && resp.data) {
              vm.inSchemeValidations = resp.data;
              vm.upiErrorMessage = resp.data.upiMaxAmountErrMessage;;
              vm.upiLimit = resp.data.upiMaxAmountLimit;
              if(vm.inSchemeValidations && vm.formData.minorFlag){
                vm.inSchemeValidations.cgfFlag = vm.inSchemeValidations.cgfFlag ? vm.inSchemeValidations.cgfFlag: true;
              }
              vm.frequencyList = vm.inSchemeValidations.additionalValidation.frequency?vm.inSchemeValidations.additionalValidation.frequency:null;
              cb();
            } else {
              cb('error');
              vm.inSchemeValidations = null;
              vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
              vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            cb('error');
            vm.inSchemeValidations = null;
            vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            UtilService.errorHandler(err);
          };


        IIHttpService.get({
          child1: 'schemeValidation',
          child2: 'sip',
          child3: vm.formData.inSchemeCode
        }, null).$promise.then(success, error);

      }
      function updateEndDates() {
        if (!vm.formData.startDate) {
          return;
        }
        var defaultEndDate = $window.moment(moment(vm.formData.startDate).toDate(), "DD-MM-YYYY").add(vm.durationYears, 'years');
        var defaultMonths = null;
        var endDate = null;
        var enabledEndDates = [];
        var freq = vm.validations && vm.validations.maxInstallments || 0;
        var i = 0;
        var frequency = vm.frequencyList.find(function (f) {
          return f.code === vm.formData.frequency;
        }) || {};

        switch (vm.formData.frequency) {
          case'BZ':
            var days = 0;
            endDate = moment(vm.formData.startDate).clone();//.add(minInstallments, 'days');
            defaultEndDate.add(1,"days");
            defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
            var days = getMonthsCount(endDate.clone(), defaultEndDate);
            freq = vm.formData.selectedPaymentOption === 'E-mandate' ?  defaultEndDate.clone().add(-1, 'days').diff(endDate, 'days', true) : ((defaultMonths * 30) / frequency.duration) + days;
            for (i = 0; i < freq; i++) {
              days = frequency.duration * i;
              enabledEndDates.push(endDate.clone().add(days, 'days'));
            }
            if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
              defaultEndDate = defaultEndDate.clone().add(-1, 'days');
              var n =enabledEndDates.length;
              if(n>0 && enabledEndDates[n-1].isBefore(defaultEndDate) ){
                    const date1 = new Date(enabledEndDates[n-1]);
                    const date2 = new Date(defaultEndDate);
                    const diffTime = Math.abs(date2 - date1);
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                     for (i = n; i < (n+diffDays-1); i++) {
                      days = frequency.duration * i;
                      if(endDate.clone().add(days, 'days').format("DD-MMM-YYYY") == defaultEndDate.format("DD-MMM-YYYY")){
                        break;
                      }
                      enabledEndDates.push(endDate.clone().add(days, 'days'));
                    }
              }
               n =enabledEndDates.length;
              if(n>0 &&  defaultEndDate.isBefore(enabledEndDates[n-1])){
                enabledEndDates=[];
                for (i = 0; i < freq; i++) {
                  days = frequency.duration * i;
                  if(endDate.clone().add(days, 'days').format("DD-MMM-YYYY") == defaultEndDate.format("DD-MMM-YYYY")){
                    break;
                  }
                  enabledEndDates.push(endDate.clone().add(days, 'days'));
                }
              }
            }
            break;
          case'OW':
            var days = 0;
            freq = UtilService.getNumberOfWeeks(moment(vm.formData.startDate).toDate(), new Date(defaultEndDate));
            for (i = 0; i <= freq; i++) {
              days = frequency.duration * i;
              enabledEndDates.push(moment(vm.formData.startDate).clone().add(days, 'days'));
            }
            break;
          default :
            var months = 0;
            endDate = moment(vm.formData.startDate).clone().add(frequency, 'months');
            defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
            freq = freq || (defaultMonths / frequency.duration);
            for (i = 0; i < freq; i++) {
              months = frequency.duration * i;
              enabledEndDates.push(endDate.clone().add(months, 'months'));
            }
            break;
        }
        if(enabledEndDates && enabledEndDates.length>0 ){
          vm.formData.endDate =  enabledEndDates[enabledEndDates.length-1].clone().format("DD-MMM-YYYY");
        }
        if(enabledEndDates && enabledEndDates.length>0 &&
          enabledEndDates.indexOf(moment(vm.formData.startDate).clone().add(vm.durationYears, 'years')) > -1
        ){
          vm.formData.endDate =  enabledEndDates[enabledEndDates.length-1].clone().add(vm.durationYears, 'years').format("DD-MMM-YYYY");
        }

      }
      vm.changeEndDate = function (date,calledFromOtherFlow) {
        if (date && vm.endDateDefaultForPertuity) {
          if(vm.endDateDefaultForPertuity.isSame($window.moment(date))){
            vm.formData.isTillPerpetuity = true;
          } else {
            vm.formData.isTillPerpetuity = false;
          }
        }
        vm.formData.endDate = date ? date : null;
        var diffInMonths = parseInt($window.moment(vm.formData.endDate).diff($window.moment(vm.formData.startDate), 'months', true));
        if (diffInMonths >= 6 && vm.formData.frequency != 'BZ') {
          vm.formData.showTopUpBlock = true;
          if(diffInMonths >= 12){
            var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
            // var capStartDateValue = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
          }
          else{
            capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
            // capStartDateValue = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
          }

          vm.capDates = [];
          var capLastDate = capStartDate;
          while ($window.moment(capLastDate).isBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
            if (vm.capDates.length === 0) {
              vm.capDates.push(capStartDate);
            }
            // capStartDateValue = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
            capStartDate = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
            if ($window.moment(capStartDate).isBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
              vm.capDates.push(capStartDate);
            }
            else {
              break;
            }
            capLastDate = vm.capDates[vm.capDates.length - 1];
          }
        }
        (vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) && checkOTMAmountAndDate();
       // checkSipValidations();
       if(vm.formData.sipPaymentOption == 'E-mandate'){
        if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == 'SIP' && vm.arnHardcodedData.sipEndDate){
          if($window.moment(vm.endLimit, 'DD-MMM-YYYY').isBefore(vm.formData.endDate)){
            vm.showNPCIDateError = 'As per NPCI Circular NPCI/2023-24/NACH/008, mandate can be registered for a maximum duration of 30 years from the date of issuance.';
          }else{
            vm.showNPCIDateError ='';
          }
        }

         if(vm.formData.endDateEmandate) {
           vm.sipDateLessEmandate =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
           if (vm.sipDateLessEmandate) {
             var setEndDateLess = false;
             var indexSipEndDate = vm.enabledEndDates.length - 1;
             var tempEndDate;
             while (!setEndDateLess) {
               tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
               indexSipEndDate = indexSipEndDate - 1;
               if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY'))) {
                 setEndDateLess = true;
                 var newEnabledEndDates = angular.copy(vm.enabledEndDates);
                 newEnabledEndDates.splice(indexSipEndDate + 1);
                 vm.enabledEndDates = angular.copy(newEnabledEndDates);
                 if (!calledFromOtherFlow) {
                   vm.formData.endDate = angular.copy(tempEndDate);
                   vm.changeEndDate(vm.formData.endDate);
                 }
               }

               if (indexSipEndDate == 0) {
                 break;
               }
             }

             if (calledFromOtherFlow) {
               var endDateField =  vm.formData.frequency === 'OW' ? angular.element('#endDateCalenderWeekly') : angular.element('#endDateCalender');
               endDateField.focus();
             }
           }
         }

       }


        if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI && vm.enabledEndDates) {
          var defaultEndDate = $window.moment().add(vm.emandateMaxYear, 'years').subtract(1,'days');
          var sipDateLessUPI =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter(defaultEndDate) ? true : false;
          if (sipDateLessUPI) {
            var setEndDateLess = false;
            var indexSipEndDate = vm.enabledEndDates.length - 1;
            var tempEndDate;
            while (!setEndDateLess) {
              tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
              indexSipEndDate = indexSipEndDate - 1;
              if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(defaultEndDate, 'DD-MMM-YYYY'))) {
                setEndDateLess = true;
                var newEnabledEndDates = angular.copy(vm.enabledEndDates);
                newEnabledEndDates.splice(indexSipEndDate + 1);
                vm.enabledEndDates = angular.copy(newEnabledEndDates);
                vm.formData.endDate = angular.copy(tempEndDate);
                vm.changeEndDate(vm.formData.endDate);
              }

              if (indexSipEndDate == 0) {
                break;
              }
            }
          }
        }
      };
      function getMonthsCount(startDate, endDate) {
          var daysToBeAdded = 0;
          var daysAdded = 0;
          while(startDate.isBefore(endDate)) {
            var dayInMonth = moment(startDate).daysInMonth();
            if (dayInMonth === 31) {
              daysToBeAdded = daysToBeAdded + 1;
            } else {
              daysAdded = daysAdded + 1;
            }
            startDate.add(1, 'month');
          }
          return daysToBeAdded;
        }
        //Icon Toggle function
        vm.changeToggleIcon = function(data){
          if(data == "collapseExampleUPI"){
            vm.UPITabExpanded = !vm.UPITabExpanded;
            if(vm.UPITabExpanded){
              vm.OTMTabExpanded = false;
              vm.PNetBankingTabExpanded = false;
              vm.SNetBankingTabExpanded = false;
              vm.formData.selectedPaymentOption = 'UPI';
              vm.changedPaymentOption();
            }
          }
          if(data == "collapseExampleOTM"){
            vm.OTMTabExpanded = !vm.OTMTabExpanded;
            if(vm.OTMTabExpanded){
              vm.UPITabExpanded = false;
              vm.PNetBankingTabExpanded = false;
              vm.SNetBankingTabExpanded = false;
              vm.formData.selectedPaymentOption = 'OTM';
              vm.changedPaymentOption();
            }
          }
          if(data == "collapseExamplePurchaseNetbanking"){
            vm.PNetBankingTabExpanded = !vm.PNetBankingTabExpanded;
            if(vm.PNetBankingTabExpanded){
              vm.UPITabExpanded = false;
              vm.OTMTabExpanded = false;
              vm.SNetBankingTabExpanded = false;
              vm.formData.selectedPaymentOption = 'NETBANKING';
              vm.changedPaymentOption();
            }
          }
          if(data == "collapseExampleSIPNetbanking"){
            vm.SNetBankingTabExpanded = !vm.SNetBankingTabExpanded;
            if(vm.SNetBankingTabExpanded){
              vm.UPITabExpanded = false;
              vm.OTMTabExpanded = false;
              vm.PNetBankingTabExpanded = false;
              vm.formData.selectedPaymentOption = 'EC';
              vm.changedPaymentOption();
            }
          }
        }
      vm.openWLink = function(){
        window.open(vm.TRANSACTIONS_CONST.WHATSAPP_DEEP_LINK);
      }
  }
})();

/**
 * Created by ttn on 29/04/24.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('WhatsappPreLoginTokenController', whatsappPreLoginTokenController);

  /** @ngInject */
  function whatsappPreLoginTokenController($window, $stateParams, AuthService, LoaderService, $state, ModalService, $timeout, AppConstants ,
                                        InvestmentModel,HDFC_API, InvestmentBasketService, MessageService, CommonFactory, UtilService, InvestorService, $scope, $rootScope) {
    var vm = this;
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    vm.isLoading = false;
    vm.init = init;
    vm.App_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.stateTitle = $state.current.title;
    var removeListeners = {}, isRefreshing = false;
    var scope = $scope;
    vm.linkHasbeenExpired = false;
    vm.CORPORATE_URL = HDFC_API.CORPORATE_URL;
    vm.uuid = $stateParams.uuid;
    vm.transactionType = $stateParams.tType;
    vm.successBackUrl = sessionStorage.getItem('redirectUrl');
    vm.showLogoutBtn = false;
    sessionStorage.removeItem('isTransactionDone');
    function getcipherText(cipherData) {
      var cipherText = cipherData;
      var key = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-|_x";
      var message = "";
      var shiftKey = 10;
      for (var i = 0; i < cipherText.length; i++) {
          var charPosition = key.indexOf(cipherText.charAt(i));
          var keyVal = (charPosition - shiftKey) % 39;
          if (keyVal < 0) {
              keyVal = key.length + keyVal;
          }
          var replaceVal = key.charAt(keyVal);
          message += replaceVal;
      }
      return message;
    }
    init();
    function init() {
      vm.folioID = $stateParams.folio;
      if(vm.folioID){
        vm.folioID =  vm.folioID.replace(/"/,'');
        vm.folioID =  vm.folioID.replace(/'/,'');
        vm.folioID =  getcipherText(vm.folioID);
        sessionStorage.setItem("folioID",vm.folioID);
      }else{
        vm.folioID =  sessionStorage.getItem("folioID");
      }
      getToken();
      setListeners();
    }

    function getToken() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.linkID = resp.data.linkId;
          resp.data.access_token = resp.data.accessToken;
          resp.data.investorPAN = resp.data.panNumber;
          AuthService.setToken(resp.data);
          sessionStorage.setItem("linkId",vm.linkID);
          sessionStorage.setItem("transactionType",vm.transactionType);
          vm.isLoading = true;
          $state.go('preLoginWhatsappHome.apiWhatsappPayment');
        } else {
          MessageService.error(resp.message);
          if (vm.successBackUrl) {
            $window.location.href = vm.successBackUrl;
          } else {
            vm.linkHasbeenExpired = true;
          }
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err);
      };
      InvestorService.get({
        child1: 'preLogin',
        child2: 'getToken',
        child3: vm.uuid
      }).$promise.then(success, error);
    }


    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        if (!token) {
          vm.linkHasbeenExpired = true;
          resetFlag();
          return;
        }

        if (token && token.refreshToken) {
          AuthService.getRefreshTokenGateway(token).then(function () {
            if (localStorage.getItem('doLogOut')) {
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                ModalService.logoutSuccess();
                vm.linkHasbeenExpired = true;
              }, function () {
                ModalService.logoutSuccess();
                vm.linkHasbeenExpired = true;
              });
            } else {
              $state.reload();
              resetFlag();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            vm.linkHasbeenExpired = true;
            resetFlag();
          });
        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          vm.linkHasbeenExpired = true;
        }
      });

      var resetFlag = function () {
        $timeout(function () {
          isRefreshing = false;
        }, 2000);
      };

      scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in removeListeners) {
          if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
            removeListeners[key]();
          }
        }
      });
    }
    vm.openWLink = function(){
          window.open(vm.App_CONST.WHATSAPP_DEEP_LINK);
    }
  }
})();

(function () {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('WhatsAppPaymentacknowledgementController', whatsAppPaymentacknowledgementController);

    /** @ngInject */
    function whatsAppPaymentacknowledgementController($state, $rootScope, $scope, $stateParams,$window,HDFC_API,AppConstants) {
        var vm = this; 
         vm.CORPORATE_URL = HDFC_API.CORPORATE_URL;
         vm.App_CONST = angular.copy(AppConstants.TRANSACTIONS);
         vm.Data = sessionStorage.getItem('whatsAppPaymentAck');   
         if(vm.Data && JSON.parse(vm.Data)){
             vm.Data = JSON.parse(vm.Data)
         }  
         if(!vm.Data){
             $window.location.href = "https://www.google.com";
         }
         history.pushState(null,"",location.href); 
         $window.onpopstate = function(){
             history.pushState(null,"",location.href); 
         } 
         $window.onload = function(){
             history.pushState(null,"",location.href); 
         }
         vm.closePage = closePage;
         function closePage() {  
             sessionStorage.removeItem('folioID');
             sessionStorage.removeItem('linkId');
             sessionStorage.removeItem('whatsAppPaymentAck');
             $window.location.href = "https://www.google.com";
         }   
         vm.openWLink = function(){
         window.open(vm.App_CONST.WHATSAPP_DEEP_LINK);
        } 
    }
})();
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UnlockFolioIdController', UnlockFolioIdController);

  /** @ngInject */
  function UnlockFolioIdController($state, $scope,AuthService, $timeout,  InvestorService, MessageService, AppConstants, ModalService, LoaderService, $stateParams, toastr, toastrConfig, UtilService) {
    var vm = this;
    vm.confirmCancel = confirmCancel;
    vm.type = $stateParams.type == 'userid' ? 'UserId' : $stateParams.type;
    vm.payload = {};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.showOTPForm = false;
    vm.selectedField = 'email';
    vm.processFlag = false;
    vm.processFlagOtp = false;
    vm.toggleunlock = false;
    var scope = $scope;
    vm.invalidUserId = false;
    vm.checkText = function(){
      var regex = AppConstants.valid_userId_regex;
      if(vm.payload && vm.payload.userId && (regex.test(vm.payload.userId.toLowerCase()) && vm.payload.userId.length > 30)){
        vm.invalidUserId =  true;
      } else{
        vm.invalidUserId =  false;
      }
    }
    scope.footerDate = new Date();
    vm.changeFields = function () {
      vm.payload.email = '';
      vm.payload.mobileNumber = '';
      if (vm.selectedField === 'email') {
        vm.selectedField = 'mobile';
      } else if (vm.selectedField === 'mobile') {
        vm.selectedField = 'email';
      }
    }

    vm.submit = function () {
      var dataPayload = {
        folioNumber:vm.payload && vm.payload.folioNumber ? vm.payload.folioNumber : '' ,
        userId:vm.payload && vm.payload.userId ? vm.payload.userId : ''
      };
      if(vm.payload && vm.payload.email){
        dataPayload.email = AuthService.encryptRSA(angular.copy(vm.payload.email));
      }
      if(vm.payload && vm.payload.mobileNumber){
        dataPayload.mobileNumber = AuthService.encryptRSA(angular.copy(vm.payload.mobileNumber));
      }
      LoaderService.showLoader();
      var success = function (res) {
        LoaderService.hideLoader();
        if (res && res.status) {
          vm.payload.id = res.data.id;
          vm.showOTPForm = true;
        } else {
          vm.processFlag = true;
          toastrConfig.preventDuplicates = false;
          toastr.error(res.message, '', {
            onHidden: function () {
              vm.processFlag = false;
              toastrConfig.preventDuplicates =  true;
            }
          }); 
        }

      }, error = function (err) { 
        LoaderService.hideLoader();
        MessageService.error(err.message);
      };


      InvestorService.post4({
        child1: 'unlock',
        child2: vm.type.toLowerCase(),
        child3: 'request'
      },dataPayload).$promise.then(success, error);

    };

    function confirmCancel() {
      var confirmSuccess = function () {
        $state.go("login");
      };
      var confirmError = function () {
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    }

    vm.resendOTP = function () {
      var payload = {
        id: vm.payload.id
      };
      vm.processFlagOtp = true;
      var success = function (res) {
        if (res.status && res.data) {
          vm.processFlagOtp = true
          resetTimer();
          toastrConfig.preventDuplicates = false;
          toastr.success(res.data.message, '', {
            onHidden: function () {
              vm.processFlagOtp = false;
              toastrConfig.preventDuplicates =  true;
            }
          });
        }
        else {
          vm.processFlagOtp = true;
          resetTimer();
          toastrConfig.preventDuplicates = false;
          toastr.error(res.message, '', {
            onHidden: function () {
              vm.processFlagOtp = false;
              toastrConfig.preventDuplicates =  true;
            }
          });
        }
      };
      var error = function (err) {
        resetTimer();
        vm.processFlagOtp = false;
        LoaderService.hideLoader();
        MessageService.error(err.message);
      };
      InvestorService.post({child1: 'unlock', child2: 'resend', child3: 'otp'}, payload).$promise.then(success, error);
    }

    vm.verifyOTP = function () {
      LoaderService.showLoader();
      var payload = {
        otp: vm.otp ? AuthService.encryptRSA(angular.copy(vm.otp)): '',
        id: vm.payload.id
      }; 
      var success = function (res) {
        LoaderService.hideLoader();
        if (res && res.message) {
          if (res.data && res.data.status) {
            if ($stateParams.from == 'instantLogin') {
              MessageService.success('Folio has been unlocked successfully.');
            } else {
              MessageService.success('User ID has been unlocked successfully.');
            }
            $state.go($stateParams.from);
          }
          else {
            vm.processFlag = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(res.message, '', {
              onHidden: function () {
                vm.processFlag = false;
                toastrConfig.preventDuplicates =  true;
              }
            });
          }
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      };
      InvestorService.post4({child1: 'unlock', child2: 'verify', child3: 'otp'}, payload).$promise.then(success, error);
    }

    vm.confirmCancel = function () {
      var confirmSuccess = function () {
        $state.go($stateParams.from);
      };
      var confirmError = function () {
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    }

    vm.handleSideBarClick = function(state) {
      UtilService.updateSideBar(state);
    };

    function resetTimer() {
      scope.$broadcast('timer-add-cd-seconds', vm.pattern.RESEND_OTP_COUNTER);
    }

  }
})();

/**
 * Created by TTND on 4/13/2017.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TransactionViewController', transactionViewController);

  /** @ngInject */
  function transactionViewController($window, ModalService, $scope, InvestorService, TransactionsService, LoaderService, MessageService, UtilService, $state, $log) {
    var vm = this;
    vm.fetchConstantData = fetchConstantData;
    vm.fetchOverviewTransactions = fetchOverviewTransactions;
    vm.overviewData = {};
    vm.transactionsOverview = null;

    vm.init = function () {
      vm.overviewData = $window.JSON.parse(localStorage.getItem('overviewData'));
      var schemeName = localStorage.getItem('schemeName');
      if(vm.overviewData[0]){
        var schemeCode = vm.overviewData[0].schemeCode;
      }
      $scope.TransactionViewParentCtrl.schemeName = schemeName;
      switch($state.current.name){
        case 'main.transactions-view.details':
          fetchConstantData(schemeCode);
        break;
        case 'main.transactions-view.transactions':
          if(vm.overviewData[0]){
            fetchOverviewTransactions(vm.overviewData[0].schemeCode);
          }
      }

    };

    function fetchConstantData(schemeCode) {
      var success = function (resp) {
          if (resp.data && resp.status) {
            $log.info(resp.data);
            vm.constantData = resp.data;
            vm.purchaseValueCountUnit = UtilService.getUnitSting(vm.constantData.costValue);
            vm.currentValueCountUnit = UtilService.getUnitSting(vm.constantData.marketValue);
          }
          else {
            vm.constantData = null;
            vm.purchaseValueCountUnit = '';
            vm.currentValueCountUnit = '';
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info("fetchConstantData error====", err);
        };
      InvestorService.post({
        child1: 'portfolio',
        child2: 'scheme-overview',
        child3: 'constant-data'
      }, {"schemeCode":schemeCode}).$promise.then(success, error);

    }

    vm.confirmCancelSipModal = function (id, type) {
      var success = function (status) {
        if(status=="success"){
          vm.successCancelSipModal();
        }
      },
        error = function () {

        };
      ModalService.cancelSipModal({id:id, type:type}, success, error);
    };

    vm.successCancelSipModal = function () {
      var success = function () {

        },
        error = function () {

        };
      ModalService.cancelSipSuccessModal({}, success, error);
    };

    vm.selectTransaction = function (action, overview) {

      var params = { folioNumber:overview.folioNumber, sc : overview.schemeCode };
      switch (action.toLocaleLowerCase()) {
        case 'stp':
          $state.go('main.transactions.stp', params );
          break;
        case 'swp':
          $state.go('main.transactions.swp',params);
          break;
        case 'redeem':
          $state.go('main.transactions.redemption',params);
          break;
        case 'switch':
          $state.go('main.transactions.switch',params);
          break;
        case 'sip':
          $state.go('main.transactions.sip',params);
          break;
        case 'purchase':
          $state.go('main.transactions.sip',params);
          break;
        case 'cancel':
          vm.confirmCancelSipModal(overview.id,overview.type);
      }

    }

    function fetchOverviewTransactions(schemeCode) {
      var success = function (resp) {
        LoaderService.hideLoader();
          if (resp.data && resp.status) {
            $log.info(resp.data);
            vm.transactionsOverview = resp.data.transactionsDTOs;
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info("fetchOverviewTransactions error====", err);
        };
        LoaderService.showLoader();
      InvestorService.post({
        child1: 'portfolio',
        child2: 'scheme-overview',
        child3: 'transactions'
      }, {'schemeCode':schemeCode}).$promise.then(success, error);

    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SummaryController', summaryController);

  /** @ngInject */
  function summaryController(ModalService, AppConstants, AuthService, moment, $window, $state, $rootScope, $scope, $stateParams, TransactionModel, LoaderService, TransactionService, InvestorService, MessageService, UtilService, $log, HDFC_API) {
    var vm = this;
    vm.formData = TransactionModel.getPayloadRawData() || {};
    vm.transactionType = $stateParams.transactionType;
    vm.transactionSubType = $stateParams.transactionSubType;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    vm.summaryToOpen = getSummaryToOpen();
    vm.investorInfo = '';
    vm.isCheckedTandC = false;
    var Card = $window.Card || {};
    var identifierData = AuthService.getToken();
    vm.transactionOtpConfirmation = transactionOtpConfirmation;
    vm.investorName = identifierData.investorFullName;
    vm.formData.formType = vm.transactionSubType === vm.SUMMARY_CONST.FLEX_STP.type ? vm.SUMMARY_CONST.FLEX_STP.value :
      (vm.formData && vm.formData.formType ? vm.formData.formType: '');
    if(vm.transactionType === 'SIP'){
    vm.capMonthYear = moment(vm.formData.topupDetails ? vm.formData.topupDetails.capMonthYear ? vm.formData.topupDetails.capMonthYear: '' : '').format('MMM-YYYY')
    }
    vm.sipTopupCapMonthYear = moment(vm.formData.topupCapMonthYear).format('MMM-YYYY')

    if(vm.transactionSubType === vm.SUMMARY_CONST.FLEX_STP.type){
      vm.formData.formType = vm.SUMMARY_CONST.CHECK_UPDATE.value;
    } else if(vm.transactionSubType === vm.SUMMARY_CONST.SWING_STP.type){
      vm.formData.formType = vm.SUMMARY_CONST.SWING_STP.value;
    }
    // var _isPaymentDone = false;

    function getSummaryToOpen() {
      if (vm.transactionSubType === vm.SUMMARY_CONST.FLEX_STP.type) {
        return vm.SUMMARY_CONST.FLEX_STP.type;
      } else if(vm.transactionSubType === vm.SUMMARY_CONST.SWING_STP.type){
        return vm.SUMMARY_CONST.SWING_STP.type;
      } else {
        return vm.transactionType;
      }
    }

    function getInvestorInfo() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
        } else {
          vm.investorInfo = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        vm.investorInfo = null;
      };
      InvestorService.get({
        child1: 'folio',
        child3: 'info'
      }).$promise.then(success, error);
    }

    function showSuccessModal(tid) {

      if (!vm.investorInfo) {
        vm.investorInfo = {};
        MessageService.error('Error while get investor info.');
      }
      var successModal = function (isChecked) {
          TransactionModel.setPayloadRawData(null);
          if (isChecked) {
            favrouiteApi(tid);
          }
          $state.go('welcome');
        },
        errorModal = function () {
          TransactionModel.setPayloadRawData(null);
          $state.go('welcome');
        };
      var type = vm.transactionType;
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        type = 'FLEX INDEX'
      } else if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP) {
        if (vm.formData.formType === vm.SUMMARY_CONST.FLEX_STP.value) {
          type = vm.formData.formType;
        }
      }

      ModalService.initiateSuccessModal({
        transactionType: type,
        investorName: vm.investorInfo.name,
        isFavourite: vm.formData.isFavourite
      }, successModal, errorModal);
    }

    function favrouiteApi(tid) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            //MessageService.success(resp.message);
          } else {
            //MessageService.error(resp.message);
          }
        },
        error = function () {
          //   LoaderService.hideLoader();
          // UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      TransactionService.get({
        controller1: 'makeFavouriteTransaction',
        controller2: tid
      }).$promise.then(success, error);
    }


    function getFinalPayload() {
      var payload = null;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          if(vm.formData.summaryType === "SIP_TOPUP"){
            payload = getSipTopupPayload();
          }else
          payload = getSipPayload();
          break;
      }
      return payload;
    }
/*
    function getFlexIndexPayload() {
      if (!vm.formData) {
        return null;
      }

      var payload = {
        "amountForRegistration": vm.formData.amount,
        "brokerCode": vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN?vm.formData.distributorARN:''),
        "compositeTransactionId": "",
        "dividendOption": "Z",
        "euinCode": "",
        "euinName": "",
        "euinOpted": "",
        "folioNumber": vm.formData.folioNumber,
        "formType": 'FLEXINDEX',
        "id": "",
        "investmentMode": '',
        "investorUuid": "",
        "sourcePortal": "",
        "sourceScheme": vm.formData.outSchemeCode,
        "switchExecutionDetails":getSwitchExecutionDetails() ,
        "targetScheme": vm.formData.inSchemeCode,
        "subBrokerARN": vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN:'',
        "subBrokerCode": vm.formData.subBrokerCode
      }

      if (vm.formData.investmentMode === 'Fixed') {
        payload.investmentMode = 'F';
      } else {
        payload.investmentMode = 'V';
      }

      return angular.copy(payload);

    }*/

  /*  function getSwitchExecutionDetails() {

      var obj = {
        "firstSwitchExecutionEntry": {
          "sensexLevelForSwitch": vm.formData.investmentModeData.stage1,
          "switchPercentage": vm.formData.investmentModeData.installment1
        },
        "secondSwitchExecutionEntry": {
          "sensexLevelForSwitch": vm.formData.investmentModeData.stage2,
          "switchPercentage": vm.formData.investmentModeData.installment2
        },
        "thirdSwitchExecutionEntry": {
          "sensexLevelForSwitch": vm.formData.investmentModeData.stage3,
          "switchPercentage": vm.formData.investmentModeData.installment3
        },
        "fourthSwitchExecutionEntry": {
          "sensexLevelForSwitch": vm.formData.investmentModeData.stage4,
          "switchPercentage": vm.formData.investmentModeData.installment4
        }
      }

      return obj;

    }*/

    /*function getStpPayload() {
      if (!vm.formData) {
        return null;
      }

      var payload = {
        investmentOption: vm.formData.investmentOption,
        dividendOption: vm.formData.dividendOption,
        stpType: vm.formData.stpType ? vm.formData.stpType : vm.formData.transferOption,
        folioNumber: vm.formData.folioNumber,
        sourceSchemeCode: vm.formData.outSchemeCode,
        stpDay: vm.formData.day,
        amount: vm.formData.amount,
        brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN?vm.formData.distributorARN:''),
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        targetSchemeCode: vm.formData.inSchemeCode,
        frequency: vm.formData.frequency,
        startDate: vm.formData.startDate && vm.formData.startDate.clone().format('DD-MMM-YYYY'),
        endDate: vm.formData.endDate && vm.formData.endDate.clone().format('DD-MMM-YYYY'),
        formType: vm.formData.formType,
        id: vm.formData.transactionId,
        noOfInstallments: vm.formData.noOfInstallments,
        subBrokerARN: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN:'',
        subBrokerCode: vm.formData.subBrokerCode
      };

      return angular.copy(payload);
    }*/

    function getSipPayload() {
      if (vm.formData.bankInfo && vm.formData.bankInfo.bankName == "OTHER BANKS") {
        vm.formData.bankInfo.bankName = vm.formData.bankName;
      }
      var sipPayload = {
        installmentAmount: vm.formData.amount,
        investmentOption: vm.formData.investmentOption,
        dividendOption: vm.formData.dividendOption,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
        brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN?vm.formData.distributorARN:''),
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        frequency: vm.formData.frequency,
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.inSchemeCode,
        schemeType : vm.formData.schemeType,
        primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
        toDate: vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
        sipDate: vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
        sipDay: vm.formData.day,
        weeklyDay: vm.formData.weeklyDay? vm.formData.weeklyDay : null,
        id: vm.formData.sTransactionId,
        bankDetailsForECS: {
          accNumber: vm.formData.bankAcNo,
          bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
          ifscCode: vm.formData.ifscCode,
          branchName: vm.formData.bankBranch,
          bankCity: vm.formData.bankCity,
          paymentOption: vm.formData.sipPaymentOption,
          payoutId:vm.formData.bankInfo && vm.formData.bankInfo.payoutId,
          netBankingUrl: vm.formData.netBankingUrl
        },
        bankDetailsForEMandate: {
          accNumber: vm.formData.bankAcNo,
          bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
          emUmrn: vm.formData.bankInfo ? vm.formData.bankInfo.emUmrn : vm.formData.emUmrn,
          maxAmount: vm.formData.bankInfo ? vm.formData.bankInfo.maxAmount : vm.formData.maxAmount,
          emExpiryDate: vm.formData.bankInfo ? vm.formData.bankInfo.emExpiryDate : vm.formData.emExpiryDate
        },
        subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN:'',
        subBrokerCode: vm.formData.subBrokerCode,
        sipTopupEnabled:vm.formData.sipTopupEnabled,
        topupDetails: {
          amount: vm.formData.topupDetails.amount,
          percentage: vm.formData.topupDetails.percentage,
          frequency: vm.formData.topupDetails.frequency,
          capAmount : vm.formData.topupDetails.capAmount,
          capMonthYear: vm.formData.topupDetails.capMonthYear
        }
      };

      var payload = {};
      if (!vm.formData.optionalInvestmentType && vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        payload = angular.copy(sipPayload);
      } else {
        payload = null;
      }

      return payload;
    }
/*
    function getSwpPayload() {
      if (!vm.formData) {
        return null;
      }

      var payload = {
        amount: vm.formData.amount,
        folioNumber: vm.formData.folioNumber,
        formType: vm.formData.formType,
        frequency: vm.formData.frequency,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        schemeCode: vm.formData.outSchemeCode,
        startDate: vm.formData.startDate.clone().format('DD-MMM-YYYY'),
        toDate: vm.formData.endDate.clone().format('DD-MMM-YYYY'),
        swpDay: vm.formData.day,
        swpType: vm.formData.transferOption,
        accountNumber: vm.formData.bankInfo.bankAcNo,
        ifscCode: vm.formData.bankInfo.ifscCode,
        bankName: vm.formData.bankInfo.bankName,
        branchName: vm.formData.bankInfo.bankBranch,
        payMech: vm.formData.bankInfo.payMech,
        primaryBankFlag: vm.formData.bankInfo.primaryFlag,
        payoutId: vm.formData.bankInfo.payoutId
      };

      return angular.copy(payload);
    }*/
/*
    function getRedeemPayload() {
      if (!vm.formData) {
        return null;
      }
      var payload = {
        folioNumber: vm.formData.folioNumber,
        formType: vm.transactionType,
        schemeCode: vm.formData.outSchemeCode,
        liquidFlag: vm.formData.liquidFlag,
        accountNumber: vm.formData.bankInfo.bankAcNo,
        ifscCode: vm.formData.bankInfo.ifscCode,
        bankName: vm.formData.bankInfo.bankName,
        branchName: vm.formData.bankInfo.bankBranch,
        payMech: vm.formData.bankInfo.payoutDescription,
        primaryBankFlag: vm.formData.bankInfo.primaryFlag,
        payoutId: vm.formData.bankInfo.payoutId,
        amount: vm.formData.amount,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        units: vm.formData.units
      };

      return angular.copy(payload);
    }*/
/*
    function getInstantRedemptionPayload() {
      if (!vm.formData) {
        return null;
      }
      var payload = {
        folioNumber: vm.formData.folioNumber,
        formType: vm.transactionType,
        schemeCode: vm.formData.outSchemeCode,
        accountNumber: vm.formData.bankInfo.bankAcNo,
        ifscCode: vm.formData.bankInfo.ifscCode,
        bankName: vm.formData.bankInfo.bankName,
        branchName: vm.formData.bankInfo.bankBranch,
        payMech: vm.formData.bankInfo.payMech,
        primaryBankFlag: vm.formData.bankInfo.primaryFlag,
        payoutId: vm.formData.bankInfo.payOutId,
        amount: vm.formData.amount,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        units: vm.formData.units
      };
      return angular.copy(payload);
    }*/

    function getSipTopupPayload() {
      if (!vm.formData) {
        return null;
      }
      var payload = {
        uuid :null,
        transactionId :vm.formData.transactionId ,
        folioNumber:vm.formData.folioNumber,
        schemeCode:vm.formData.schemeCode,
        amount:vm.formData.amount,
        frequency:vm.formData.frequency,
        topupAmount: vm.formData.topupAmount,
        topupPercentage:vm.formData.topupPercentage,
        topupFrequency:vm.formData.topupFrequency,
        topupCapAmount:vm.formData.topupCapAmount,
        topupCapMonthYear: vm.formData.topupCapMonthYear,
        toDate:vm.formData.toDate,
        bankDetailsForECS : {
          accType : vm.formData.bankInfo.bankAcType,
          accNumber: vm.formData.bankInfo.bankAcNo,
          bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
          ifscCode: vm.formData.bankInfo.ifscCode,
          branchName: vm.formData.bankInfo.bankBranch,
          bankCity: vm.formData.bankCity,
          paymentOption: vm.formData.bankDetailsForECS.paymentOption,
          otmId: vm.formData.otmId,
          payoutId: vm.formData.bankInfo.payoutId}
      };
      return angular.copy(payload);
    }

/*
    function getSwitchPayload() {
      var payload = {
        folioNumber: vm.formData.folioNumber,
        formType: vm.formData.formType,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        investmentOption: vm.formData.investmentOption,
        dividendOption: vm.formData.dividendOption,
        switchInSchemeCode: vm.formData.inSchemeCode,
        switchOutSchemeCode: vm.formData.outSchemeCode,
        brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN?vm.formData.distributorARN:''),
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        units: vm.formData.units,
        amount: vm.formData.amount,
        subBrokerARN: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN:'',
        subBrokerCode: vm.formData.subBrokerCode,
        checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
        autoSwitchScheme: vm.formData.isAutoSwitch? vm.formData.switchInSchemeCode : null,
        autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.autoSwitchSchemeDividendOption : null
      };
      return angular.copy(payload);

    }*/
/*
    function getDtpPayload() {
      var payload = {
        folioNumber: vm.formData.folioNumber,
        formType: vm.formData.formType,
        brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN?vm.formData.distributorARN:''),
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        dividendOption: vm.formData.dividendOption,
        sourceScheme: vm.formData.outSchemeCode,
        targetScheme: vm.formData.inSchemeCode,
        subBrokerARN: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN:'',
        subBrokerCode: vm.formData.subBrokerCode

      };
      return angular.copy(payload);
    }*/

    function handleSipResponse(data) {
      if (!data) {
        MessageService.error();
        return;
      }

      /*if (data.eMandateEnabled && data.paymentOption == 'EC') {
        openPaynimo(data.trxnNo, data.srnNo, data.pNMFreq);
      }
      else {

      }*/
      ModalService.manualInstructionsModal({
        investorName: vm.investorName,
        folioInvestorName: data ? data.investorName : '',
        srnNo: data ? data.topupRegNo : '',
        folioNumber: vm.formData.folioNumber,
        schemeName: data ? data.schemeName : '',
        investmentOption: vm.formData.investmentOption,
        amount: vm.formData.amount,
        sipDividendOption: vm.formData.sipDividendOption,
        netBankingUrl:vm.formData.netBankingUrl,
        paymentOption:data.paymentOption,
        transactionId:data.trxnNo,
        transactionInitiateDate:data.transactionInitiateDate,
        frequency:vm.formData.frequency,
        startDate:vm.formData.startDate ? vm.formData.startDate.format('DD-MMM-YYYY'):null,
        endDate:vm.formData.endDate ? vm.formData.endDate.format('DD-MMM-YYYY'):null,
        bankName:vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
        bankAcNo:vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : vm.formData.bankAcNo,
        transactionType:data ? data.transactionType : '',
        sipTopupCapAmount:data ? data.sipTopupCapAmount : '',
        sipTopupAmount:data ? data.sipTopupAmount : '',
        sipTopupFrequency:data ? data.sipTopupFrequency : '',
        summaryType :'SIP_TOPUP'
      });
    }

    function handleResponse() {
      // console.info("response======== ", res);
    }

    function approveTransaction() {
      var payload = getFinalPayload();

      if (!payload) {
        MessageService.error('Something went wrong while calculating payload.');
        return;
      }

      payload.formType = (payload.formType === vm.SUMMARY_CONST.FLEX_STP.value || payload.formType === vm.SUMMARY_CONST.SWING_STP.value) ? 'STP' : payload.formType;

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            // _isPaymentDone = true;

            if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
              userActivityTracking(true, function(){
                handleSipResponse(resp.data);
              });
            } else {
              LoaderService.hideLoader();
              showSuccessModal(resp.data.data);
            }

          } else {
              LoaderService.hideLoader();
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              });
            } else {
              MessageService.error(resp.message);
            }

          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      // var _controller2 = (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) ? vm.transactionType.toLowerCase() : 'multiple';

      var _controller2 = vm.transactionType.toLowerCase();


      var _config = {
        controller1: 'transaction',
        controller2: _controller2,
        controller3: 'approve'
      };

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP && vm.formData.summaryType === "SIP_TOPUP") {
        transactionOtpConfirmation();
      }
      else {
        TransactionService.post(_config, payload).$promise.then(success, error);
      }
    }

    vm.init = function () {
      if(angular.isDefined($stateParams.trackId) && angular.isDefined($stateParams.stepNo) && $stateParams.stepNo.toUpperCase() === "SECOND"){
        showPrefillValuesUserTracker(function () {
          if (!vm.formData) {
            $state.go('welcome');
            return null;
          }
        });
      }else{
        if (!vm.formData) {
          $state.go('welcome');
          return null;
        }
      }
      getInvestorInfo();
    };

    function showPrefillValuesUserTracker(cb) {
      cb = cb || function(){};
      vm.transactionType = $stateParams.transactionType?$stateParams.transactionType.toUpperCase():"";

      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData = resp.data.formdata || {};
            ($stateParams.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)&&(vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE);
          } else {
            MessageService.error(resp.message);
          }
          cb();
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb();
        };
      TransactionService.get({
        controller1: 'userBehavior',
        controller2: $stateParams.trackId,
        controller3: 'getFormData'
      }).$promise.then(success, error);
    }

    vm.submitForm = function () {
      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ||
        vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE){
        userActivityTracking(false, function(statusFlag){
          var params = {};
          if((statusFlag && statusFlag.transactionId)||($stateParams.trackId)){
            params.trackId = statusFlag.transactionId || $stateParams.trackId;
          }
          if (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
            console.log(vm.formData);
            TransactionModel.setPayloadRawData(angular.copy(vm.formData));
            $state.go('main.transactions.payment',params);
          }
          else if(vm.formData.sipFirstInstallment) {
            params.sipWithFirstInstallment=true;
            TransactionModel.setPayloadRawData(angular.copy(vm.formData));
            $state.go('main.transactions.payment',params);
          }
          else
          {
            approveTransaction()
          }
        });
      }else{
        if (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
          $state.go('main.transactions.payment');
        } else {
          approveTransaction()
        }
      }
    };

    function userActivityTracking(isProcessed, cb){
      cb = cb || function(){};
      if(vm.transactionType != vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP &&
        vm.transactionType != vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE){
        cb(true);
      }
      var success = function(trackResp){
        trackResp = trackResp.data || trackResp;
        LoaderService.hideLoader();
        cb(trackResp);
      }, error = function(err){
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(err);
      };
      LoaderService.showLoader();
      var userTrackerPayload = setUserTrackerPayload(isProcessed);
      InvestorService.post({
        child1: 'userBehavior',
        child2: 'addupdate'
      },userTrackerPayload).$promise.then(success, error);
    }

    function setUserTrackerPayload(isProcessed){
      var _payload = {
        "trxnRefNo": $stateParams.trackId?$stateParams.trackId:"", //required in case of update
        "trxnType": vm.formData.investmentType, //SIP, PURCHASE
        "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
        "step": "SECOND", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode, // required
        "folioNo": vm.formData.folioNumber, // required
        "formData": vm.formData, // required
        "amount": vm.formData.purchaseAmount, //required
        "trxnStatus": isProcessed ? "PROCESSED": "OPEN"  // OPEN,PROCESSED
      };
      return _payload;
    }

    vm.goToBack = function () {
      var goTo = "main.transactions."+vm.transactionType.toLowerCase();
      var params = {};
      ($stateParams.trackId)&&(params.trackId=$stateParams.trackId);
      $state.go(goTo, params);
    };

    vm.showTermConditions = function () {
      ModalService.transactionalTermConditionModal({'transactionType':vm.transactionType,'subTransactionType':vm.formData.formType});
    };

    var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState) {
      if (toState.name && $state.$previous && (toState.name !== $state.$previous.name)) {
        if (toState.name === 'main.transactions.payment' && (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)) {
          return;
        }
        TransactionModel.setPayloadRawData(null);
      }
    });

    $scope.$on('$destroy', function () {
      stateChangeStart();
    });

    function transactionOtpConfirmation() {
      var otpSuccessCallback, otpDismissCallback;

      otpSuccessCallback = function(resp) {
        approveSipTopUp();
      };

      otpDismissCallback = function(err) {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      var modalPayload = {
        folioNumber:  vm.formData.folioNumber,
        transactionType: vm.transactionType,
        randomOTPId: vm.formData.randomOTPId
      };

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.secretLink = resp.data.secretLink;
            var otpDetails = {
              secretOtpLink : vm.secretLink,
              otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
              otpId : resp.data.id
            };

            var payload = {
              folioNumber:  vm.formData.folioNumber,
              formType : vm.transactionType
            }

            ModalService.transactionOtpModal({
              otpPayload: otpDetails,
              payload: payload
            }, otpSuccessCallback, otpDismissCallback);
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message)
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      TransactionService.post2({
        controller1: 'transaction',
        controller2: 'otp'
      }, modalPayload).$promise.then(success, error);
    }

    function approveSipTopUp(){
      var payload = getFinalPayload();
      if (!payload) {
        MessageService.error('Something went wrong while calculating payload.');
        return;
      }

      payload.formType = (payload.formType === vm.SUMMARY_CONST.FLEX_STP.value || payload.formType === vm.SUMMARY_CONST.SWING_STP.value) ? 'STP' : payload.formType;
      payload.secretLink = vm.secretLink;

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            // _isPaymentDone = true;

            if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
              userActivityTracking(true, function(){
                handleSipResponse(resp.data);
              });
            } else {
              LoaderService.hideLoader();
              showSuccessModal(resp.data.data);
            }

          } else {
            LoaderService.hideLoader();
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              });
            } else {
              MessageService.error(resp.message);
            }

          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      var _controller2 = vm.transactionType.toLowerCase();
      var _config = {
        controller1: 'transaction',
        controller2: _controller2,
        controller3: 'approve'
      };
      _config.controller2 = 'existing';
      _config.controller3 = 'sip';
      _config.controller4 = 'topup';
      _config.controller5 = 'approve';
      TransactionService.post(_config, payload).$promise.then(success, error);
    }

  }
})();

/*
*
* Schedule transaction summary controller:
* used in case of summary view/completing the scheduled purchase, switch and redeem transaction.
*
*/
(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('SummaryScheduleTransactionController', summaryScheduleTransactionController);

    /** @ngInject */
    function summaryScheduleTransactionController(ModalService, AppConstants, $window, $state, $stateParams, $timeout, TransactionModel, LoaderService, TransactionService, InvestorService, MessageService, UtilService, $log, NetcoreEvntService,
      HDFC_API, TransactionServiceVersion, panAadharService , $sce, AuthService,$http,TransformResponse,investorServiceVersion, PaymentService) {
      var vm = this;
      vm.formData = TransactionModel.getPayloadRawData() || {};
      vm.tempData = TransactionModel.getPayloadRawData()
      vm.transactionType = null;
      vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
      vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
      vm.investorInfo = '';
      vm.isCheckedTandC = false;
      vm.uniqueLink = null;
      vm.showIFSCField = false;
      vm.showAccountTypeField = false;
      vm.invalidAmount = false;
      var Card = $window.Card || {};
      var TrFlowType = {NEW:'NEW',OLD:'OLD'};
      vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
      vm.paymentOptions = [
        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
      ];
      vm.hideCancel = false;
      if($stateParams && $stateParams.purchaseSchedular){
        vm.oneClickHDFCFLow = true;
        vm.hideCancel = true;
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }else{
        vm.oneClickHDFCFLow = false;
      }
      vm.bankList = null;
      vm.verifyUPI = verifyUPI;
      vm.isInvalidForm = false;
      vm.isLoaded = false;
      vm.tpv = tpv;
      vm.selectedUpiBank = selectedUpiBank;
      vm.PATTERN = AppConstants;
      vm.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
      vm.billdeskPayload = {
        hidRequestId : "PGIME1000",
        hidOperation : "ME100",
        msg : ""
      };

      function tpv() {
        ModalService.tpvModal({});
      }
      vm.confirmCancelModaltoReject = confirmCancelModaltoReject;
      vm.init = init();

      function init() {
        var popUp = $window.open("http://www.google.com", "popup_tester", "width=1,height=1,left=0,top=0");
        if (popUp == null || typeof(popUp) == 'undefined') {
          vm.isActionPerformed = false;
          alert('Please disable your pop-up blocker then submit the form.');
          return;
        }
        else {
          popUp.close();
        }
        LoaderService.showLoader();
        vm.uniqueLink = $stateParams.uniqueLink;
        vm.formData.purchasePaymentOption = vm.paymentOptions[0];
        performActionOnTransaction();
      }

      /*
      * function to identify the transaction type passed in smartlink
      */
      function identifyTransactionType() {
          if (vm.scheduleTransactionDetails.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
              return vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE;
          } else if (vm.scheduleTransactionDetails.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH) {
              return vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH;
          } else if (vm.scheduleTransactionDetails.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
              return vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION;
          }
      }

      /*
      * function to show OTP modal as per the transaction type
      */
      vm.purchaseSchedularData = null;
      function performActionOnTransaction() {
        var success = function(resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.purchaseSchedularData =  resp.data;
            if($stateParams && $stateParams.purchaseSchedular){
              sessionStorage.setItem('OTPSecrateLink',vm.purchaseSchedularData.secretLink);
              sessionStorage.setItem('ONEClickHDFCBankFlow',true);
              MessageService.success("OTP sent successfully.");
            }
            initiateOTPModal();
          } else {
            MessageService.error(resp.message)
          }
        }, error = function(err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        if($stateParams && $stateParams.purchaseSchedular){
          var linkId = $stateParams.uniqueLink;
          InvestorService.post({
            child1: "gigworker",
            child2: "sendOtp",
            child3: linkId
          }, {}).$promise.then(success, error);
        }else{
          TransactionService.get2({
            controller1: 'transaction',
            controller2: 'otp',
            controller3: vm.uniqueLink
          }, null).$promise.then(success, error);
        }
      }

      /**
       *
       * Function responsible to show OTP modal
       *
       */
      function initiateOTPModal() {
        var success = function(response) {
          if (response) {
            vm.invType = response.invType;
            if (response.status !== "PROCESSED") {
              vm.isLoaded = true;
              /* added this to verify mock data
              response['minorFlag'] = true;
              response['cgfFlag'] = false; */
              if($stateParams && $stateParams.purchaseSchedular){
                vm.invType = "EXISTING";
                vm.identifierData = response;
                 vm.getPurchaseScedulerData(function(resp){
                      response = resp;
                      response.transactionType = 'PURCHASE';
                      response.oneClickSchedulePurchase = true;
                      response.scheduleDate = response.scheduleStartDate;
                      response.amount = response.installmentAmount;
                      response.defaultSourceSchemeCode = response.schemeCode;
                      response.defaultSourceSchemeName = response.schemeName
                      response.emailID = response.maskedEmail;
                      response.mobileNumber = response.maskedMobileNumber;
                      if(response && response.liquidSchemeFlag){
                        if(response.liquidSchemeFlag == 'N'){
                          response.liquidSchemeFlag = false;
                        }else{
                          response.liquidSchemeFlag = true;
                        }
                      }
                      if(response.payMech == 'NETBANKING'){
                        vm.formData.purchasePaymentOption = vm.paymentOptions[0];
                        if(vm.paymentOptions.length > 1){
                          vm.formData.purchasePaymentOption = vm.paymentOptions[1];
                        }
                      }
                      if(response.payMech == 'OTM'){
                        vm.formData.purchasePaymentOption = vm.paymentOptions[1];
                      }
                      if(response.payMech == 'UPI'){
                        vm.formData.purchasePaymentOption = vm.paymentOptions[0];
                        if(vm.paymentOptions.length > 2){
                          vm.formData.purchasePaymentOption = vm.paymentOptions[2];
                        }
                      }
                      if(response.euin){
                        vm.fetchEuinList(response.brokerCode, response.euin);
                      }
                      vm.scheduleTransactionDetails = response;
                      vm.transactionType = identifyTransactionType();
                      vm.fetchPurchaseValidations();
                      updateJsonAsPerTransactionType();
                      vm.upiMaxAmountLimit = response.upiMaxAmountLimit;
                      vm.upiErrorMessage = response.upiMaxAmountErrMessage;
                      vm.investorName = response.investorName;
                      var successDataHandler = function(resp){
                        vm.NOTESECTIONDATA = resp;
                      }
                      UtilService.fetchDynamicData('SP_APPROVE_SCREEN').then(successDataHandler).catch(function(resp) {
                        MessageService.error(resp);
                      });
                 });
              }else{
                vm.scheduleTransactionDetails = response;
                vm.transactionType = identifyTransactionType();
                updateJsonAsPerTransactionType();
                vm.upiMaxAmountLimit = response.upiMaxAmountLimit;
                vm.upiErrorMessage = response.upiMaxAmountErrMessage;
                vm.investorName = response.investorName;
              }
            } else {
              MessageService.error("The Transaction has already been processed.")
            }
          }
        }, failure = function() {
          MessageService.error(resp.message)
        };
        if($stateParams && $stateParams.purchaseSchedular){
          ModalService.otpForApprovalModal({
            backdrop: 'static',
            summaryType: "one-click-schedule-purchase",
            uniqueLink: vm.uniqueLink,
            id : vm.purchaseSchedularData && vm.purchaseSchedularData.secretLink ? vm.purchaseSchedularData.secretLink : "",
            folioNumber:vm.purchaseSchedularData && vm.purchaseSchedularData.folioNumber ? vm.purchaseSchedularData.folioNumber : ""
          }, success, failure);
        }else{
          ModalService.otpForApprovalModal({
            backdrop: 'static',
            summaryType: vm.transactionType,
            uniqueLink: vm.uniqueLink
          }, success, failure);
        }
      }

      function updateJsonAsPerTransactionType() {
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
          vm.scheduleTransactionDetails['purchaseInvestmentOption'] = vm.scheduleTransactionDetails.dividendOption === 'Y' || vm.scheduleTransactionDetails.dividendOption === 'N' ? fetchInvestmentOption(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND) : fetchInvestmentOption(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH)
          vm.scheduleTransactionDetails['purchaseDividendOption'] = vm.scheduleTransactionDetails.dividendOption;
          fetchBankList();
          checkOtmList();
          vm.formData.paymentInfo = {amount: vm.scheduleTransactionDetails.amount};
          vm.formData.paymentInfo.paymentMode = "WEB";
        } else if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH) {
          vm.scheduleTransactionDetails['amountType'] = !angular.isUndefined(vm.scheduleTransactionDetails.amount) ? 'amount' : !angular.isUndefined(vm.scheduleTransactionDetails.units) ? 'units' : 'all_units';
        } else if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
          vm.scheduleTransactionDetails['amountType'] = !angular.isUndefined(vm.scheduleTransactionDetails.amount) ? 'amount' : !angular.isUndefined(vm.scheduleTransactionDetails.units) ? 'units' : 'all_units';
        }
        if (vm.scheduleTransactionDetails.liquidSchemeFlag === true) {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
          ];
        }
      }

      vm.changedPaymentOption = function () {
        vm.isCheckedDeclaration = false;
        vm.bankInfo = null;
        vm.bankList = null;
        vm.showIFSCField = false;
        vm.showAccountTypeField = false;
        vm.formData.paymentInfo.ifscCode = null;
        getAccountType()
        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            vm.formData.paymentInfo.paymentMode = "WEB";
            fetchBankList();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
            fetchBankList();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            if(vm.scheduleTransactionDetails.amount > vm.upiMaxAmountLimit) {
              var success = function() {
                vm.formData.purchasePaymentOption = vm.paymentOptions[0];
                vm.changedPaymentOption();
              }
              ModalService.genericModal({
                text: vm.upiErrorMessage,
                isUpi: true
              },success);
            }
            resetUPIForm();
            fetchBankList();
            vm.formData.paymentInfo.paymentMode = "WEB";
            vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
            break;
        }
      };

      function getInvestorInfo(cb) {
        cb = cb ||function () {

        };
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.investorInfo = resp.data;
          } else {
            vm.investorInfo = null;
            MessageService.error(resp.message);
          }
          cb();
        }, error = function (err) {
          UtilService.errorHandler(err);
          vm.investorInfo = null;
          cb();
        };
        InvestorService.get({
          child1: 'folio',
          child3: 'info'
        }).$promise.then(success, error);
      }

      /**
       * Function defined here are used for Net banking section
       *  */
      function fetchBankList() {
        LoaderService.showLoader();
        vm.bankList = null;
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            if($stateParams && $stateParams.purchaseSchedular){
              var tempBank = [];
                vm.bankList.forEach(function(item){
                  if(item.bankName && item.bankName.includes('HDFC')){
                    tempBank.push(item);
                  }
              })
              vm.bankList = tempBank;
              for (var i = 0; i < vm.bankList.length; i++) {
                if(vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING  && vm.scheduleTransactionDetails.payMech != vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM){
                  if(vm.bankList[i].accountNumber == vm.scheduleTransactionDetails.accountNumber){
                    vm.bankInfo = vm.bankList[i];
                  }
                }
                if(vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM && vm.scheduleTransactionDetails.payMech != vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING){
                  if(vm.bankList[i].bankAcNo == vm.scheduleTransactionDetails.accountNumber && vm.bankList[i].payoutId == vm.scheduleTransactionDetails.payoutId){
                    vm.bankInfo = vm.bankList[i];
                  }
                }
              }
              vm.changeBank();
            }
            if (vm.bankList && vm.bankList.length == 1) {
              vm.bankInfo = vm.bankList[0];
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
              vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
              vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
              vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
              vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
              (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
              checkOTMAmountAndDate();
              if(vm.formData.purchasePaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
                selectedUpiBank();
              }
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
            LoaderService.hideLoader();
            vm.bankList = null;
            UtilService.errorHandler(err);
        };
        LoaderService.showLoader();

        var config = null;
        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            config = {child1: 'schedule', child2: 'transaction', child3: 'bank', child4: 'list'};
            InvestorService.post(config, {
              trnxType: 'PURCHASE',
              folioNumber: vm.scheduleTransactionDetails.folioNumber,
              liquidSchemeFlag: vm.scheduleTransactionDetails.liquidSchemeFlag,
              panNumber: vm.scheduleTransactionDetails.panNumber
            }).$promise.then(success, error);
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            config = {child1: 'folio', child2: 'schedule', child3: 'transaction', child4: 'otm'};
            InvestorService.post(config,
              {
                folioNo:vm.scheduleTransactionDetails.folioNumber,
                transactionType: vm.transactionType,
                panNumber: vm.scheduleTransactionDetails.panNumber
              }
            ).$promise.then(success, error);
            break;
          default :
            vm.bankList = null;
            config = null;
            break;
        }
      }

      vm.changeBank = function () {
        if (!vm.bankInfo) {
          return;
        }

        vm.formData.paymentInfo.ifscCode = null;
        vm.accountType = null;

        vm.showIFSCField = vm.bankInfo.ifscCode ? false : true;
        vm.showAccountTypeField = vm.bankInfo.bankAcType ? false : true;

        if (vm.showAccountTypeField) {
          getAccountType();
        }


        vm.isInvalidForm = false;
        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            // if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
            //   ModalService.minorBankModal({isFromSmartLink: true});
            //   vm.bankInfo = null;
            //   vm.isCheckedDeclaration = false;
            //   return;
            // }
            vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
            vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
            if (vm.bankInfo.tpvEnableFlag == 'Y') {
              getAccountNumber(vm.bankInfo.bankCode);
            }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            // if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
            //   ModalService.minorBankModal({isFromSmartLink: true});
            //   vm.bankInfo = null;
            //   vm.isCheckedDeclaration = false;
            //   return;
            // }
            vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
            vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
            vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
            vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
            vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
            (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
            checkOTMAmountAndDate();
            break;
          default :
            vm.bankInfo = null;
            break;
        }
      };

      function getAccountNumber(bankCode) {
        if(vm.bankInfo.tpvEnableFlag && vm.bankInfo.accountNumber){
          vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
          vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
          return;
        }
        vm.bankAccounts = [];
        vm.isInvalidForm = true;
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            vm.bankAccounts = resp.data.accountNumbers;
            if (vm.bankAccounts.length > 1) {
              var success = function (accountNo) {
                vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
                vm.formData.paymentInfo.accountNumber = accountNo;
                vm.isInvalidForm = false;
              }, error = function () {

              };
              ModalService.selectAccountNoModal({bankAccounts: vm.bankAccounts}, success, error);
            } else {
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankAccounts[0];
              vm.isInvalidForm = false;
            }
          } else {
            vm.isInvalidForm = true;
            MessageService.error(resp.message);
            vm.bankAccounts = [];
          }
        },
        error = function (err) {
          vm.bankAccounts = [];
          vm.isInvalidForm = true;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        var payload = {
          "folioNumber": vm.scheduleTransactionDetails.folioNumber,
          "bankCode": bankCode,
          trnxType: vm.transactionType,
          panNumber: vm.scheduleTransactionDetails.panNumber,
          isquickInvestment: false
        };
        InvestorService.post({
          child1: 'schedule',
          child2: 'transaction',
          child3: 'bank',
          child4: 'account'
        }, payload).$promise.then(success, error);
      }

      /**
       * function defined here are used for UPI section only
       */
      function resetUPIForm() {
        vm.verifyUPIResp = {};
        vm.isUPIVerified = false;
        (vm.formData.paymentInfo)&&(vm.formData.paymentInfo.virtualAddress = "");
      }

      vm.showUPISuccessPopup = function () {
        var successModal = function () {
          initiateStateChangeOnSuccess();
        },
        errorModal = function () {
          $state.go('welcome');
        };
        ModalService.upiSuccessModal({}, successModal, errorModal);
      };

      function selectedUpiBank() {
        // if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
        //   ModalService.minorBankModal({isFromSmartLink: true});
        //   vm.bankInfo = null;
        //   vm.isCheckedDeclaration = false;
        //   return;
        // };
        vm.showIFSCField = vm.bankInfo.ifscCode ? false : true;
        vm.showAccountTypeField = vm.bankInfo.bankAcType ? false : true;

        if (vm.showAccountTypeField) {
          getAccountType();
        }

        vm.upiAccountNumber = vm.bankInfo.accountNumber;
        vm.upiBankName = vm.bankInfo.bankName;
        vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
      }

      function verifyUPI() {
        vm.verifyUPIResp = {};
        var success = function (resp) {
          if (resp.data && resp.status) {
            vm.verifyUPIResp = resp.data;
            if (resp.data.valid) {
              vm.name = resp.data.name;
              vm.isUPIVerified = true;
            } else {
              vm.isUPIVerified = false;
            }
          }
          else {
            vm.isUPIVerified = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

        LoaderService.showLoader();

        InvestorService.post({
          child1: 'upi',
          child2: 'check',
          child3: 'virtualAddress'
        }, {"virtualAddress": vm.formData.paymentInfo.virtualAddress}).$promise.then(success, error);
      }

      /* ****************************************************************** */
      /**
       * OTM section starts from here
       *  */
      function checkOtmList() {
        var success = function (resp) {
          if (resp.status && resp.data) {
            if (resp.data.bankList.length == 0) {
              vm.paymentOptions = [
                vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
                vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
              ];
              if($stateParams && $stateParams.purchaseSchedular){
                // vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING];
                vm.formData.purchasePaymentOption = vm.paymentOptions[0];
                vm.changedPaymentOption();
              }
            }
            if (resp.data.bankList.length > 0 && $stateParams && $stateParams.purchaseSchedular) {
              vm.formData.purchasePaymentOption = vm.paymentOptions[1];
              vm.changedPaymentOption();
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        var config = {child1: 'folio', child2: 'schedule', child3: 'transaction', child4: 'otm'};
        InvestorService.post(config, {
          folioNo:vm.scheduleTransactionDetails.folioNumber,
          transactionType: vm.transactionType,
          panNumber: vm.scheduleTransactionDetails.panNumber
        }).$promise.then(success, error);
      }

      function checkOTMAmountAndDate() {

        vm.isOTMAmount = false;
        vm.isOTMDate = false;
        // Check Ammout
        if (vm.formData.paymentInfo.amount && (vm.formData.paymentInfo.amount > vm.bankInfo.maxAmount)) {
          vm.isOTMAmount = true;
        } else {
          vm.isOTMAmount = false;
        }

        //Compare Dates
        if ($window.moment(vm.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment())) {
          vm.isOTMDate = true;
        }
        else {
          vm.isOTMDate = false;
        }
        // Compare Date for One click scedule end date
        if($stateParams && $stateParams.purchaseSchedular){
          if ($window.moment(vm.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.scheduleTransactionDetails.scheduleEndDate))) {
            vm.isOTMDate = true;
          }
          else {
            vm.isOTMDate = false;
          }
        }
        //Check for amount or date
        if (vm.isOTMAmount || vm.isOTMDate) {
          vm.isInvalidForm = true;
        } else {
          vm.isInvalidForm = false;
        }
      }

      vm.submitForm = function () {
          var payload = getPurchasePayload();
          payload.purchaseForm.secretLink = vm.uniqueLink;
          if (!payload) {
            MessageService.error('Something went wrong while calculating purchase payload.');
            return;
          }
          var successHandler=function(resp)
          {
            LoaderService.hideLoader();
            if (payload.purchaseForm.formType === 'PURCHASE' && vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING &&
              vm.scheduleTransactionDetails.amount >= 200000) {
              vm.showPurchaseNetBankingModal(payload);
            } else {
              vm.finalSubmit(payload);
            }
          };
          var errorHandler=function(resp)
          {
            LoaderService.hideLoader();
            return;
          };
        LoaderService.showLoader();
        panAadharService.fetchPanAadharLinkingStatus(payload.loginDTO.panNumber,null).then(successHandler).catch(errorHandler);
      };

      function getPurchasePayload() {
        var loginDTO = {
          "email": vm.scheduleTransactionDetails.emailID,
          "mobNum": vm.scheduleTransactionDetails.mobileNumber,
          "panNumber": vm.scheduleTransactionDetails.panNumber,
          "appType":"WEB",
          "uuid":vm.scheduleTransactionDetails.investorID
        };
        var purchasePayload = {
          scheduleJobTransactionID: vm.scheduleTransactionDetails.transactionID,
          investmentOption: fetchInvestmentOption(vm.scheduleTransactionDetails.investmentOption),
          dividendOption: vm.scheduleTransactionDetails.dividendOption,
          folioNumber: vm.scheduleTransactionDetails.folioNumber,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          primaryFlag: vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          schemeCode: vm.scheduleTransactionDetails.defaultSourceSchemeCode,
          schemeName: vm.scheduleTransactionDetails.defaultSourceSchemeName,
          retirementAgeProofURL: vm.formData.retirementAgeProofURL ? vm.formData.retirementAgeProofURL : '',
          euinOpted: (vm.scheduleTransactionDetails.euin && vm.scheduleTransactionDetails.euin.euinName) ? 'Y' : 'N',
          euinCode: vm.scheduleTransactionDetails.euin ? vm.scheduleTransactionDetails.euin.euinCode:'',
          euinName: vm.scheduleTransactionDetails.euin ? vm.scheduleTransactionDetails.euin.euinName:'',
          paymentInfo: getPaymentInfo(),
          subBrokerARN: vm.scheduleTransactionDetails.subBrokerARN ? 'ARN-' + vm.scheduleTransactionDetails.subBrokerARN : '',
          subBrokerCode: vm.scheduleTransactionDetails.subBrokerCode,
          checkedNfoAutoSwitch: vm.scheduleTransactionDetails.isAutoSwitch,
          autoSwitchScheme: vm.scheduleTransactionDetails.isAutoSwitch ? vm.scheduleTransactionDetails.inSchemeCode : null,
          autoSwitchSchemeDividendOption: vm.scheduleTransactionDetails.isAutoSwitch ? vm.scheduleTransactionDetails.switchDividendOption : null,
          schemeType: vm.scheduleTransactionDetails.liquidSchemeFlag,
          transactionMode: vm.scheduleTransactionDetails.transactionMode
        };
        if (purchasePayload.paymentInfo.accountNumber) {
          purchasePayload.accountNumber = purchasePayload.paymentInfo.accountNumber;
          purchasePayload.paymentInfo['schemeAccountNumber'] = purchasePayload.accountNumber;
        }
        if (purchasePayload.paymentInfo.tpvEnableFlag) {
          purchasePayload.tpvEnableFlag = purchasePayload.paymentInfo.tpvEnableFlag;
          delete purchasePayload.paymentInfo.tpvEnableFlag;
        }
        if (purchasePayload.paymentInfo.amount) {
          purchasePayload.amount = purchasePayload.paymentInfo.amount;
          //delete purchasePayload.paymentInfo.amount;
        }
        if($stateParams && $stateParams.purchaseSchedular){
          purchasePayload.amount = vm.scheduleTransactionDetails.amount;
          purchasePayload.euinOpted = vm.scheduleTransactionDetails && vm.scheduleTransactionDetails.euin ? 'Y' : 'N';
          purchasePayload.euinCode = vm.scheduleTransactionDetails.euin ? vm.scheduleTransactionDetails.euin :'';
          if(vm.scheduleTransactionDetails.dividendOption == 'Y' || vm.scheduleTransactionDetails.dividendOption == 'N'){
            purchasePayload.investmentOption = 'DIVIDEND';
          }
          if(vm.scheduleTransactionDetails.dividendOption == 'Z'){
            purchasePayload.investmentOption = 'GROWTH';
          }
          purchasePayload.tpvEnableFlag = "Y";
        }
        purchasePayload = handleBrokerCode(purchasePayload);
        var payload = {
          "loginDTO": loginDTO,
          "purchaseForm": angular.copy(purchasePayload)
        };

        return payload;
      }

      function getPaymentInfo() {

          if (vm.formData.paymentInfo && vm.formData.paymentInfo.webMode === 'MASTER') {
            vm.formData.paymentInfo.webMode = 'MASTERCARD';
          }
          var paymentInfo = {
            amount: vm.formData.paymentInfo.amount,
            paymentMode: vm.formData.paymentInfo.paymentMode
          };
          if($stateParams && $stateParams.purchaseSchedular){
            paymentInfo.amount = vm.scheduleTransactionDetails.amount;
          }
          switch (vm.formData.purchasePaymentOption) {
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
              paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
              paymentInfo.webMode = vm.formData.paymentInfo.webMode;
              paymentInfo.bankName = vm.bankInfo.bankName;
              paymentInfo.accNo = vm.bankInfo.accountNumber ? vm.bankInfo.accountNumber : vm.formData.paymentInfo.accountNumber;
              if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
                paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
                paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
              }
              //paymentInfo.paymentMode = vm.formData.paymentInfo.paymentMode;
              paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
              paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType;
              break;
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
              paymentInfo.otmId = vm.formData.paymentInfo.otmId;
              paymentInfo.bankName = vm.bankInfo.bankName ? vm.bankInfo.bankName : vm.formData.paymentInfo.bankName;
              paymentInfo.branchName = vm.formData.paymentInfo.bankBranch;
              paymentInfo.accNo = vm.bankInfo.bankAcNo ? vm.bankInfo.bankAcNo : vm.formData.paymentInfo.bankAcNo;
              paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
              paymentInfo.payoutId = vm.formData.paymentInfo.payoutId;
              paymentInfo.omUmrn = vm.formData.paymentInfo.omUmrn;
              paymentInfo.camsMandateIdNo = vm.formData.paymentInfo.camsMandateIdNo;
              paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType;
              paymentInfo.accountNumber = vm.bankInfo.accountNumber ? vm.bankInfo.accountNumber : vm.formData.paymentInfo.accountNumber;
              break;
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
              paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
              paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
              paymentInfo.upiReferenceNumber = vm.transactionNumber;
              paymentInfo.accountNumber = vm.upiAccountNumber;
              paymentInfo.accNo= paymentInfo.accountNumber;
              paymentInfo.bankName = vm.upiBankName? vm.upiBankName : vm.formData.paymentInfo.bankName;
              paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
              paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType;
              break;
          }

          return angular.copy(paymentInfo);
      }

      function userActivityTracking(isProcessed, cb) {

          /*Netcore Event Start*/
          if(!isProcessed){
            NetcoreEvntService.Continue_To_Pay_Purchase_IP(vm.formData, true);
          }
          /*Netcore Event End*/
          cb = cb || function () {
          };
          var success = function (trackResp) {
            trackResp = trackResp.data || trackResp;
            LoaderService.hideLoader();
            cb(trackResp);
          }, error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
            cb(false);
          };

          LoaderService.showLoader();
          var userTrackerPayload = setUserTrackerPayload(isProcessed);
          InvestorService.post({
            child1: 'userBehavior',
            child2: 'schedule',
            child3: 'transaction',
            child4: 'addUpdate'
          }, userTrackerPayload).$promise.then(success, error);
      }

      function setUserTrackerPayload(isProcessed) {
        var _payload = {
          "trxnRefNo": vm.scheduleTransactionDetails.transactionID?vm.scheduleTransactionDetails.transactionID:"", //required in case of update
          "trxnType": vm.transactionType, //PURCHASE
          "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
          "step": "THIRD", // FIRST,SECOND,THIRD,FOURTH
          "schemeCd": vm.scheduleTransactionDetails.defaultSourceSchemeCode,
          "folioNo": vm.scheduleTransactionDetails.folioNumber,
          "formData": vm.formData,
          "amount": vm.scheduleTransactionDetails.amount,
          "trxnStatus": isProcessed ? "PROCESSED":"OPEN"  // OPEN,PROCESSED
        };
        return _payload;
      }

      vm.showPurchaseNetBankingModal = function (payload) {
          vm.finalSubmit(payload);
      };

      vm.finalSubmit = function (payload) {

        LoaderService.showLoader();
        var success = function (resp) {
            if($stateParams.purchaseSchedular){
              resp = resp.data;
            }
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
               if(vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
                  if(!resp.data.redirectUrl) {
                    $state.go("welcome");
                  } else {
                    $window.location.href = resp.data.redirectUrl
                  }
               } else {
                 handlePurchaseResponse(resp.data);
               }
            } else {
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                })
              } else {
                 MessageService.error(resp.message);
              }
            }
          },
          error = function (err) {
            if($stateParams && $stateParams.purchaseSchedular && err.data.error == 'invalid_token'){
              vm.logout();
            }
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        if($stateParams.purchaseSchedular){
          payload.purchaseForm.utmSource = vm.scheduleTransactionDetails.utmSource ? vm.scheduleTransactionDetails.utmSource : "";
          payload.purchaseForm.utmMedium = vm.scheduleTransactionDetails.utmMedium ? vm.scheduleTransactionDetails.utmMedium : "";
          var payloadData = vm.makePayloadForpurchaseSchedular(payload.purchaseForm);
          payloadData.purchaseSchedulerId = $stateParams.uniqueLink;
          var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/transaction/purchase/approve';
          $http.post(_path, payloadData, {
            headers: {
              'TRACKING-ID' : vm.scheduleTransactionDetails.uniqueLinkId,
              'X-API-VERSION': '3',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer'+vm.token,
              'Cookie':"JSESSIONID=wza5x7q68egsvy5dt58hp8wc; TS013489c7=017fb9e0dc41cb7dff050c30daff3b2f269c82bdb3ee805d027130aa05a09a982094dd18fd77d6aa9ce178ee5daa4e1f9e8bd21df8; TS320243cb027=08d98d1d16ab20003a21348756fb9e50d1b2bc255bda7574132f1775941f8a9d1e247aea898a62e608a0b36ffd113000ec1a65768307bc5a1aca2e011a8c27d8b5c55c7118430c7604e524133dbb261937f2b88220015473dc7885f80755e7f5"
            },
            transformResponse: TransformResponse.transformApiResponse
          }).then(success, error);
        }else{
          if (vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING) {
            TransactionServiceVersion.post({
              controller1: 'schedule',
              controller2: 'transaction',
              controller3: 'approve'
            }, payload).$promise.then(success, error);
          } else {
            TransactionService.post({
              controller1: 'schedule',
              controller2: 'transaction',
              controller3: 'approve'
            }, payload).$promise.then(success, error);
          }
        }
      };

      function handlePurchaseResponse(data) {
        vm.cams = data.camsReferenceNumber;
        var payloadData = data;
        vm.transactionId = data && data.transactionId ? data.transactionId : null;
        vm.transactionTime = data.transactionInitiateDate;
        data = data && data.data ? data.data : data;
        if (!data) {
          MessageService.error();
          return;
        }


        if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLDESK') {
          vm.billdeskMsg = data;
          if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
            vm.billdeskPayload.msg = vm.billdeskMsg;
            $timeout(function () {
              angular.element('#billdeskForm').submit();
            });
            //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
          } else {
            vm.billdeskPayload.msg = vm.billdeskMsg;
            $timeout(function () {
              angular.element('#billdeskForm').submit();
            });
            //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
          }
        } else if (vm.formData.paymentInfo.paymentMode == 'WEB' && (vm.formData.paymentInfo.webMode == 'MASTERCARD' || vm.formData.paymentInfo.webMode == 'VISA')) {
          vm.billdeskMsg = data;
          if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
            vm.billdeskPayload.msg = vm.billdeskMsg;
            $timeout(function () {
              angular.element('#billdeskForm').submit();
            });
            //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
          } else {
            vm.billdeskPayload.msg = vm.billdeskMsg;
            $timeout(function () {
              angular.element('#billdeskForm').submit();
            });
            //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
          }
        } else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLJUNCTION') {
          $window.open(data, '_self');
        } else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'RAZORPAY') {
          if(vm.scheduleTransactionDetails.transactionType.toUpperCase() == "PURCHASE") {
            payloadData.trnxActionMsg = payloadData.data;
          }
          PaymentService.openRazorPay(payloadData);
        } else {
          initiateStateChangeOnSuccess();
        }
        if($stateParams && $stateParams.purchaseSchedular){
          vm.logout();
        }
      }

      /*
      * Function to initiate the submission of switch and redeem payment options
      */
      vm.submitSchedule = function($event) {
        $event.currentTarget.disabled = true;
        var payload = getFinalPayload();

        var successHandler=function(resp)
        {
          LoaderService.hideLoader();
          if (!payload) {
            MessageService.error('Something went wrong while calculating payload.');
            return;
          }

          payload.formType = payload.formType;

          LoaderService.showLoader();
          var success = function (resp) {
              $event.currentTarget.disabled = false;
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH) {
                  vm.transactionId = resp.data.data;
                  vm.cams = resp.data.camsReferenceNumber;
                  MessageService.success(resp.data.trnxActionMsg);
                  initiateStateChangeOnSuccess();
                }
              } else {
                LoaderService.hideLoader();
                if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                });
            } else {
              MessageService.error(resp.message);
            }
              }
            },
            error = function (err) {
              $event.currentTarget.disabled = false;
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
          var _config = {
            controller1: 'schedule',
            controller2: 'transaction',
            controller3: 'approve'
          };
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
            LoaderService.hideLoader();
            redemptionConfirmModalShow(_config, payload, $event);
            /*if (angular.isUndefined(payload.redemptionForm.liquidFlag)|| payload.redemptionForm.liquidFlag === "N") {
              commented to show nudge request for liquid scheme as well.
            } else if (angular.isUndefined(payload.redemptionForm.liquidFlag) || payload.redemptionForm.liquidFlag === "Y") {
              approveScheduleRedeem(_config, payload)
            }*/
          }
          else {
            TransactionService.post(_config, payload).$promise.then(success, error);
          }
        };
        var errorHandler=function(resp)
        {
          LoaderService.hideLoader();
          return;
        };
        LoaderService.showLoader();
        panAadharService.fetchPanAadharLinkingStatus(payload.loginDTO.panNumber,null).then(successHandler).catch(errorHandler)
      }

      /*
      * Function responsible to identify the transaction type and call their respective payload generate methods
      */
      function getFinalPayload() {
        var payload = null;
        switch (vm.transactionType) {
          case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION:
            payload = getRedeemPayload();
            break;
          case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH:
            payload = getSwitchPayload();
            break;
        }
        return payload;
      }

      /*
      * Function responsible to show the redeem confirmation modal.
      */
      function redemptionConfirmModalShow(_config, payload,$event) {
        payload.redemptionForm.popUpType = "SCHEDULE_TRANSACTION_NUDGE";
        var success = function (res) {
          if(res === 'cancel') {
            $event.currentTarget.disabled = false;
          }
          if(res.key === 'approveScheduleRedeem') {
            LoaderService.showLoader();
            $event.currentTarget.disabled = false;
            payload.redemptionForm.reasons = res.nudgeReason;
            if (res.nudgeReason === 'Other') {
              payload.redemptionForm.nudgeOtherReason = res.nudgeOtherReason;
            }
            approveScheduleRedeem(_config, payload);
          }
        };
        ModalService.showNudgeReasons({Text:'Please let us know the reason for Redemption:',scheduledRedemption:true, folioNumber:vm.scheduleTransactionDetails.folioNumber, schemeCode: vm.scheduleTransactionDetails.defaultSourceSchemeCode, transactionType:vm.transactionType }, success);
      }

      /**
       * Function responsible to show cancel transaction modal
       *   */
      function confirmCancelModaltoReject() {
        var msg = "Are you sure, you want to cancel Scheduled Transaction?";
        ModalService.confirmCancelModal({Text: msg}, successReason, function() {});
      }

      /*
      * Function responsible to cancel the schedule transaction payment
      */
      function successReason() {
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.actionTaken = true;
            var message = 'Your request for cancellation has been submitted successfully.',
            hideOKButton = $state.current.name=='main.investorApproval'?false:true,
            successReject = function () {
              $state.go('welcome');
            };
            var successHandler = function(resp) {

              if(resp.popupDTO.popupDTOMap.Popup_Home !== undefined)
              {
                ModalService.successMessageModal({message: message, hideOKButton: hideOKButton}, successReject);
              }
            }

            UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
              MessageService.error(resp);
            });
            //ModalService.successMessageModal({message: message, hideOKButton: hideOKButton}, successReject);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        var payload = {
          transactionId: vm.scheduleTransactionDetails.transactionID,
          transactionType: vm.transactionType,
          baseTransactionId: "",
          transactionStatus: 'CANCELLED'
        };
        LoaderService.showLoader();
        TransactionService.post({
          controller1: 'schedule',
          controller2: 'transaction',
          controller3: 'update',
          controller4: 'status'
        }, payload).$promise.then(success, error);
      }
      /********************* Utility methods for payment controller **************************************/
      /*
      * Function responsible to initiate api call to update the internal transaction id
      */
      function initiateInternalSaveCall( data, transactionStatus ) {
        vm.transactionId = data;
        LoaderService.showLoader();
        var success = function(response) {
          LoaderService.hideLoader();
          if (response.status) {
            MessageService.success(response.data.trnxActionMsg);
            initiateStateChangeOnSuccess();
          } else {
            LoaderService.hideLoader();
            MessageService.error(response.message);
          }
        }, error = function(response) {
          LoaderService.hideLoader();
          MessageService.error(response.message);
        };
        var payload = {
          transactionId : vm.scheduleTransactionDetails.transactionID,
          baseTransactionId: vm.transactionId,
          transactionType: vm.transactionType,
          transactionStatus: transactionStatus
        };
        TransactionService.post({
          controller1: 'schedule',
          controller2: 'transaction',
          controller3: 'update',
          controller4: 'status'
        }, payload).$promise.then(success, error);
      }

      function initiateStateChangeOnSuccess() {
        $window.sessionStorage.setItem("summayPayload", angular.toJson(createPayloadForSummary()));
        $state.go('schedule-success', {
          transactionId: vm.transactionId,
          transactionType: vm.transactionType,
          params: {
            summaryData: $window.sessionStorage.getItem("summayPayload")
          }
        });
      }

      /*
      * function responsible to create payload for summary page
      */
      function createPayloadForSummary() {
        var bankInfo = {};
        if (vm.bankInfo) {
          bankInfo = {
            bankAcNo : vm.bankInfo.accountNumber,
            ifscCode : vm.bankInfo.ifscCode,
            bankName : vm.bankInfo.bankName,
            payoutDescription: vm.scheduleTransactionDetails.payoutDesc
          };
        } else {
          bankInfo = {
            bankAcNo : vm.scheduleTransactionDetails.accountNumber,
            ifscCode : vm.scheduleTransactionDetails.ifsc,
            bankName : vm.scheduleTransactionDetails.bankName,
            payoutDescription: vm.scheduleTransactionDetails.payoutDesc
          };
        }
        var scheduleDetails = {
          scheduleDate: vm.scheduleTransactionDetails.scheduleDate
        };
        var payload = {
          amount: vm.scheduleTransactionDetails.amount,
          units: vm.scheduleTransactionDetails.units,
          euin: vm.scheduleTransactionDetails.euin,
          folioNumber: vm.scheduleTransactionDetails.folioNumber,
          scheduleDetails: scheduleDetails,
          transactionType: vm.transactionType,
          sourceSchemeName: vm.scheduleTransactionDetails.defaultSourceSchemeName,
          sourceSchemeCode :vm.scheduleTransactionDetails.defaultSourceSchemeCode,
          targetScheme: !angular.isUndefined(vm.scheduleTransactionDetails.targetSchemeName)  ? vm.scheduleTransactionDetails.targetSchemeName : "",
          investmentOption: vm.scheduleTransactionDetails.dividendOption === 'Y' || vm.scheduleTransactionDetails.dividendOption === 'N' ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH,
          dividendOption: vm.scheduleTransactionDetails.dividendOption,
          bankInfo: bankInfo,
          transactionId: $stateParams.transactionId,
          formData: vm.formData,
          isFromSmartLink: true,
          cams: vm.cams,
          transactionMode : vm.scheduleTransactionDetails.transactionMode,
          initiated: moment(vm.scheduleTransactionDetails.transactionInitiateDate, "YYYY-MMM-DD hh:mm:ss").utc().local().format("DD-MMM-YYYY hh:mm:ss A"),
          userId : vm.scheduleTransactionDetails.investorID,
          encryptedPanNumber : AuthService.encryptRSA(angular.copy(vm.scheduleTransactionDetails.panNumber)),
          transactionTime : vm.transactionTime,
          investorName : vm.investorName
        };
        payload = handleBrokerCode(payload);
        if($stateParams && $stateParams.purchaseSchedular){
          payload.gigWorkersFlow = true;
        }else{
          payload.gigWorkersFlow = false;
        }
        return payload;
      }

      /*
      * Function responsible to generate redeem payload for summary.
      */
      function getRedeemPayload() {
        var loginDTO = {
          "email": vm.scheduleTransactionDetails.emailID,
          "mobNum": vm.scheduleTransactionDetails.mobileNumber,
          "panNumber": vm.scheduleTransactionDetails.panNumber,
          "appType":"WEB",
          "uuid":vm.scheduleTransactionDetails.investorID
        };
        var bankInfo = {
          bankAcNo : vm.scheduleTransactionDetails.accountNumber,
          ifscCode : vm.scheduleTransactionDetails.ifsc,
          bankName : vm.scheduleTransactionDetails.bankName,
          payoutDescription : vm.scheduleTransactionDetails.payoutDesc,
          payoutId: vm.scheduleTransactionDetails.payoutID
        };
        var redemptionForm = {
          scheduleJobTransactionID: vm.scheduleTransactionDetails.transactionID,
          folioNumber: vm.scheduleTransactionDetails.folioNumber,
          formType: vm.transactionType,
          schemeCode: vm.scheduleTransactionDetails.defaultSourceSchemeCode,
          schemeName: vm.scheduleTransactionDetails.defaultSourceSchemeName,
          liquidFlag: vm.scheduleTransactionDetails.liquidSchemeFlag ? 'Y' : 'N',
          accountNumber: bankInfo.bankAcNo,
          ifscCode: bankInfo.ifscCode,
          bankName: bankInfo.bankName,
          branchName: bankInfo.bankBranch,
          payMech: bankInfo.payoutDescription,
          primaryBankFlag: bankInfo.primaryFlag,
          payoutId: bankInfo.payoutId,
          id: null,
          amount: vm.scheduleTransactionDetails.amount ? vm.scheduleTransactionDetails.amount: 0.0,
          units: vm.scheduleTransactionDetails.units ? vm.scheduleTransactionDetails.units : 0.0,
          transactionMode: vm.scheduleTransactionDetails.transactionMode,
          secretLink : vm.uniqueLink,
          exitLoad: vm.scheduleTransactionDetails.exitLoad? vm.scheduleTransactionDetails.exitLoad : 0,
          capitalGain: vm.scheduleTransactionDetails.capitalGain ? vm.scheduleTransactionDetails.capitalGain : 0
        };
        var payload = {
          loginDTO: loginDTO,
          redemptionForm: redemptionForm
        };
        return angular.copy(payload);
      }

      /*
      * Function responsible to generate switch payload for summary.
      */
      function getSwitchPayload() {
        var switchForm = {
          scheduleJobTransactionID: vm.scheduleTransactionDetails.transactionID,
          folioNumber: vm.scheduleTransactionDetails.folioNumber,
          formType: vm.transactionType,
          investmentOption: vm.scheduleTransactionDetails.dividendOption === 'Y' || vm.scheduleTransactionDetails.dividendOption === 'N' ? fetchInvestmentOption(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND) : fetchInvestmentOption(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH),
          dividendOption: vm.scheduleTransactionDetails.dividendOption,
          switchInSchemeCode: vm.scheduleTransactionDetails.targetSchemeCode,
          switchOutSchemeCode: vm.scheduleTransactionDetails.defaultSourceSchemeCode,
          euinOpted: (vm.scheduleTransactionDetails.euin && vm.scheduleTransactionDetails.euin.euinName) ? 'Y' : 'N',
          euinCode: vm.scheduleTransactionDetails.euin ? vm.scheduleTransactionDetails.euin.euinCode:'',
          euinName: vm.scheduleTransactionDetails.euin ? vm.scheduleTransactionDetails.euin.euinName:'',
          subBrokerARN: vm.scheduleTransactionDetails.subBrokerARN ? 'ARN-' + vm.scheduleTransactionDetails.subBrokerARN : '',
          subBrokerCode: vm.scheduleTransactionDetails.subBrokerCode,
          autoSwitchScheme: null,
          autoSwitchSchemeDividendOption: null,
          amount: vm.scheduleTransactionDetails.amount ? vm.scheduleTransactionDetails.amount: 0.0,
          units: vm.scheduleTransactionDetails.units ? vm.scheduleTransactionDetails.units : 0.0,
          transactionMode: vm.scheduleTransactionDetails.transactionMode,
          secretLink : vm.uniqueLink
        };
        switchForm = handleBrokerCode(switchForm);
        var loginDTO = {
          "email": vm.scheduleTransactionDetails.emailID,
          "mobNum": vm.scheduleTransactionDetails.mobileNumber,
          "panNumber": vm.scheduleTransactionDetails.panNumber,
          "appType":"WEB",
          "uuid":vm.scheduleTransactionDetails.investorID
        };
        var payload = {
          "switchForm": switchForm,
          "loginDTO": loginDTO
        };
        return angular.copy(payload);
      }

      vm.showTermConditions = function () {
        ModalService.transactionalTermConditionModal({'transactionType':vm.transactionType,'subTransactionType':vm.formData.formType});
      };

      vm.checkForMinorBankListCondition = function() {
        if(vm.scheduleTransactionDetails!=null && vm.scheduleTransactionDetails.minorFlag!=null && vm.scheduleTransactionDetails.cgfFlag!=null)
          return vm.scheduleTransactionDetails.minorFlag && !vm.scheduleTransactionDetails.cgfFlag;
        else
          return false;
      };

      /*
        * Function responsible to manage the broker code for purchase and sip payload
        * */
      function handleBrokerCode(payload) {
        if (!vm.scheduleTransactionDetails.riaOpted) {
          if (vm.scheduleTransactionDetails.brokerCode != "DIRECT") {
            payload['brokerCode'] = vm.scheduleTransactionDetails.brokerCode ? vm.scheduleTransactionDetails.brokerCode : (vm.scheduleTransactionDetails.distributorARN ? vm.scheduleTransactionDetails.distributorARN : '');
          }
          payload['riaConsent'] = false;
        } else if (vm.scheduleTransactionDetails.riaOpted) {
          payload['brokerCode'] = vm.scheduleTransactionDetails.brokerCode ? vm.scheduleTransactionDetails.brokerCode : (vm.scheduleTransactionDetails.distributorARN ? vm.scheduleTransactionDetails.distributorARN : '');
          payload['riaName'] = vm.scheduleTransactionDetails.brokerName;
          payload['riaConsent'] = true;
        }
        return payload;
      }

      function approveScheduleRedeem(_config, payload) {
        var success = function (resp) {
          if(resp.status && resp.data){
            vm.transactionId = resp.data.data;
            vm.cams = resp.data.camsReferenceNumber;
            LoaderService.hideLoader();
            initiateStateChangeOnSuccess();
          } else {
              LoaderService.hideLoader();
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                });
              } else {
                MessageService.error(resp.message);
              }
          }
        }
        TransactionService.post(_config, payload).$promise.then(success);
      }

      function fetchInvestmentOption(investmentOption) {
        var investmentOptionKey = "";
        Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
          if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == investmentOption) {
            investmentOptionKey = key;
          }
        });
        return investmentOptionKey;
      }

      function getAccountType() {
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.accountTypeList = resp.data.bankAccountTypes;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };
        InvestorService.get({
          child1: 'folio',
          child2: 'bank',
          child3: 'account-type-list',
          child4:  vm.invType
        }).$promise.then(success, error);
      }

      vm.changeAccountype = function () {
        if (!vm.accountType) {
          return;
        }
        vm.formData.paymentInfo.accType = vm.accountType.accountTypeCode;
      };


      vm.fetchPurchaseValidations = function() {
        vm.purchaseValidations = null;
        var success = function (resp) {
            if (resp.status && resp.data) {
                vm.purchaseValidations = resp.data;
                if (vm.purchaseValidations && vm.scheduleTransactionDetails.minorFlag) {
                    vm.scheduleTransactionDetails.cgfFlag = vm.purchaseValidations.cgfFlag ? vm.purchaseValidations.cgfFlag : true;
                }

                if (!vm.purchaseValidations.addlPurchase) {
                  vm.isPurchaseMin = vm.purchaseValidations.minFirstPurchaseAmt > vm.scheduleTransactionDetails.amount;
                  // vm.isInvalidForm = true;
                  vm.purchaseMinAmount = vm.purchaseValidations.minFirstPurchaseAmt;
                } else {
                  // vm.isInvalidForm = true;
                  vm.isPurchaseMin = vm.purchaseValidations.minAddlPurchaseAmt > vm.scheduleTransactionDetails.amount;
                  vm.purchaseMinAmount = vm.purchaseValidations.minAddlPurchaseAmt;
                }
                if (vm.purchaseValidations.schemeType == 'LIQUID') {
                  vm.scheduleTransactionDetails.liquidSchemeFlag = true
                  vm.paymentOptions = [
                    vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
                  ];
                  vm.formData.purchasePaymentOption = vm.paymentOptions[0];
                  vm.changedPaymentOption();
                }
            } else {
                vm.purchaseValidations = null;
                MessageService.error(resp.message);
            }
        }, error = function (err) {
            // vm.purchaseValidations.minAddlPurchaseAmt
            vm.purchaseValidations = null;
            UtilService.errorHandler(err);
        };
        InvestorService.get({
            child1: 'schemeValidation',
            child2: 'purchase',
            child3: vm.scheduleTransactionDetails.defaultSourceSchemeCode,
            child4: vm.scheduleTransactionDetails.folioNumber
        }, null).$promise.then(success, error);
      }
      vm.changeAmount = function(){
        if(vm.formData && vm.formData.paymentInfo){
          vm.formData.paymentInfo.amount = vm.scheduleTransactionDetails.amount;
        }
        if(vm.purchaseValidations && vm.scheduleTransactionDetails.amount){
          if(vm.purchaseValidations.minAddlPurchaseAmt > vm.scheduleTransactionDetails.amount){
            vm.isPurchaseMin = true;
            vm.isInvalidForm = true;
          }else{
            vm.isPurchaseMin = false;
            vm.isInvalidForm = false;
          }
        }
      }
      vm.getPurchaseScedulerData= function(fb){
        var success = function (resp) {
          if (resp.status && resp.data) {
            fb(resp.data);
          } else {
            MessageService.error(resp.message)
          }
        },error = function (err) {
          UtilService.errorHandler(err);
        };
        var payload = {
          uniqueLink:vm.uniqueLink
        }
        investorServiceVersion.post({
          child1: 'gigworker',
          child2: 'otp',
          child3: 'details'
        }, payload).$promise.then(success, error);
      }
      vm.makePayloadForpurchaseSchedular = function(val){
        var formInputdata = {};
        formInputdata.investmentOption = val.investmentOption;
        formInputdata.dividendOption = val.dividendOption;
        formInputdata.folioNumber = val.folioNumber;
        formInputdata.formType = "PURCHASE";
        formInputdata.primaryFlag = true;
        formInputdata.schemeCode = val.schemeCode;
        formInputdata.euinOpted = val.euinOpted;
        formInputdata.euinCode = val.euinCode;
        formInputdata.euinName = val.euinName;
        formInputdata.subBrokerArn = val.subBrokerARN;
        formInputdata.amount = val.amount;
        formInputdata.id = "";
        formInputdata.brokerCode = val.brokerCode;
        formInputdata.riaConsent = false;
        formInputdata.utmSource = val.utmSource;
        formInputdata.utmMedium = val.utmMedium ;
        formInputdata.secretLink = sessionStorage.getItem('OTPSecrateLink');
        formInputdata.scheduleSecretLink = sessionStorage.getItem('scheduleSecretLink');
        if(vm.formData.purchasePaymentOption == 'NETBANKING'){
          formInputdata.accountNumber = val.paymentInfo.accNo;
          formInputdata.paymentInfo = {
              "amount": val.paymentInfo.amount,
              "paymentMode": val.paymentInfo.paymentMode,
              "bankName": val.paymentInfo.bankName,
              "accNo": val.paymentInfo.accNo,
              "ifscCode": val.paymentInfo.ifscCode,
              "accType": val.paymentInfo.accType,
              "webMode": val.paymentInfo.webMode,
              "bankCode": val.paymentInfo.bankCode
          }
        }
        if(vm.formData.purchasePaymentOption == 'OTM'){
          formInputdata.paymentInfo = {
                "amount": val.paymentInfo.amount,
                "paymentMode": "OTM",
                "bankName": val.paymentInfo.bankName,
                "accNo": val.paymentInfo.accNo,
                "ifscCode": val.paymentInfo.ifscCode,
                "payoutId": val.paymentInfo.payoutId,
                "omUmrn": val.paymentInfo.omUmrn,
                "accType": val.paymentInfo.accType,
                "bankCode": val.paymentInfo.bankCode
            }
        }
        if(vm.formData.purchasePaymentOption == 'UPI'){
          formInputdata.accountNumber = val.paymentInfo.accNo;
          formInputdata.paymentInfo = {
            "amount": val.paymentInfo.amount,
            "paymentMode": val.paymentInfo.paymentMode,
            "virtualAddress": val.paymentInfo.virtualAddress,
            "webMode": vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,
            "accountNumber": val.paymentInfo.accNo,
            "accNo": val.paymentInfo.accNo,
            "accType": val.paymentInfo.accType,
            "bankName": val.paymentInfo.bankName,
            "ifscCode": val.paymentInfo.ifscCode,
            "bankCode": val.paymentInfo.bankCode
          }
        }
        return formInputdata;
      }
      vm.logout = function () {
        AuthService.logoutInstantLogin().then(function () {

        }, function () {

        });
      };
      vm.fetchEuinList = function (arn,euin) {
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.distributorName = resp.data.distributorName;
            vm.euinList = resp.data.euinList;
            if(vm.euinList.length > 0){
              var name = '';
              for(var i=0;i<vm.euinList.length;i++ ){
                if(vm.euinList[i].euinCode == euin){
                  name =  vm.euinList[i].euinName;
                }
                if(name){
                  vm.scheduleTransactionDetails.euinName =  name;
                  break;
                }
              }
            }
          } else {
            vm.euinList = null;
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          MessageService.error(err);
          LoaderService.hideLoader();
          vm.euinList = null;
          return "";
        };
        LoaderService.showLoader();
        InvestorService.get({child1: 'getEuin',child2: arn}).$promise.then(success, error);
      }
    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TrStatusController', trStatusController);

  /** @ngInject */
  function trStatusController(summaryData, ModalService, AppConstants, $stateParams, $timeout, $state,$window, $rootScope, $scope, TransactionModel, LoaderService, TransactionService, NetcoreEvntService, AuthService, UtilService) {
    var vm = this;
    vm.transactionId = $stateParams.transactionId;
    vm.transactionType = $stateParams.transactionType;
    vm.isFavourite = $stateParams.isFavourite;
    vm.transactionValue = localStorage.getItem('Transaction_Value');
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.ROLLOVER_MODE = angular.copy(AppConstants.TRANSACTION_LIST_FILTER.ROLLOVER_MODE);
    vm.favrouiteApi = favrouiteApi;
    vm.init = init;
    vm.riaName = sessionStorage.getItem('riaName');


    function init() {
      vm.formData = summaryData;
      switch (vm.transactionType) {
        case 'FLEX_INDEX':
          if(vm.formData.amount){
            $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
          }
          break;
        case 'PURCHASE':
          if(vm.formData.amount){
          $window.NumToWord(vm.formData.amount, 'purchasestatusDisplayWords', vm.formData);
          }
          performDataLayerPushEvent();
          // Removed code under adobe script removal
          // UtilService.performDataLayerPushEventEcart(vm.formData.schemeName).then(function (resp) {
          //   NetcoreEvntService.COMPLETE_TRANSACTION_CART({
          //     cartItemSchemeNames: resp.cartItemSchemeNames,
          //     transactionSuccessSchemeNames: resp.transactionSuccessSchemeNames
          //   })
          // })
          break;
        case 'REDEMPTION':
          if(vm.formData.sourceScheme && vm.formData.sourceScheme.withDrawalAmount){
            $window.NumToWord(vm.formData.sourceScheme.withDrawalAmount, 'reedemstatusDisplayWords', vm.formData.sourceScheme);
          }
          break;
        case 'INSTANT_REDEMPTION':
          if(vm.formData.sourceScheme && vm.formData.sourceScheme.withDrawalAmount){
            $window.NumToWord(vm.formData.sourceScheme.withDrawalAmount, 'instantRedeemstatusDisplayWords', vm.formData.sourceScheme);
          }
          break;
        case 'STP':
          if(vm.formData.stpTargetScheme && vm.formData.stpTargetScheme.amount){
            $window.NumToWord(vm.formData.stpTargetScheme.amount, 'STPstatusDisplayWords', vm.formData.stpTargetScheme);
          }
          break;
        case 'SWITCH':
          if(vm.formData.targetScheme && vm.formData.targetScheme.amount){
            $window.NumToWord(vm.formData.targetScheme.amount, 'switchstatusDisplayWords', vm.formData.targetScheme);
          }
          break;
        case 'SWP':
          if(vm.formData.sourceScheme && vm.formData.sourceScheme.withDrawalAmount){
            $window.NumToWord(vm.formData.sourceScheme.withDrawalAmount, 'SWPstatusDisplayWords', vm.formData.sourceScheme);
          }
          break;
        case 'SMART_SWAP':
          if(vm.formData.sourceScheme && vm.formData.sourceScheme.withDrawalAmount){
            $window.NumToWord(vm.formData.sourceScheme.withDrawalAmount, 'smartSwapstatusDisplayWords', vm.formData.sourceScheme);
          }
          break;
        case 'ROLLOVER':
          if(vm.formData.amount){
            $window.NumToWord(vm.formData.amount, 'RolloverstatusDisplayWords', vm.formData);
          }
          break;
      }
      vm.switchExecutionDetails = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX && vm.formData.switchExecutionDetails;
    }

    function favrouiteApi(tid) {
      if (vm.favrouitModel) {
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              //
            }
          },
          error = function () {
          };
        LoaderService.showLoader();
        TransactionService.get({
          controller1: 'makeFavouriteTransaction',
          controller2: tid
        }).$promise.then(success, error);
      }
    }

    function performDataLayerPushEvent() {
      if (vm.formData.paymentMode === "NEFT/RTGS" || vm.formData.paymentMode === "HDFC Fund Transfer" || vm.formData.paymentMode === "OTM" || vm.formData.paymentMode === "OTM(One Time Mandate)") {
        var data = getDataToBePushed();
        NetcoreEvntService.Transaction_Success('purchase', data);
      }
    }

    function getDataToBePushed() {
      console.log(vm.formData)
      var token = AuthService.getToken();
      return {
        transaction_id: vm.transactionId,
        value: vm.formData.amount,
        tax: 0,
        currency: "INR",
        userId: sessionStorage.getItem('userId'),
        status : "success",
        transaction_time: vm.formData.transactionDate, //yy-mm-dd hh:mm:ss
        transaction_type: vm.transactionType === 'PURCHASE' ? 'Purchase' : vm.transactionType,
        source : vm.formData.paymentMode === 'OTM' ? 'OTM (One Time Mandate)' : vm.formData.paymentMode,
        items: [{
          item_id: vm.formData.folioNumber,
          item_name: vm.formData.schemeName,
          item_category: vm.formData.schemeCode,
          item_category2: vm.formData.investorName.trim(),
          item_category3: token.encryptedPanNumber,//Encrypted value
          price: vm.formData.amount,
          quantity: "N/A"
        }]
      };
    }
  }
})();

(function() {
    'use strict';
    angular
    .module('hdfc-mf-investor-web')
    .controller('ScheduleTransactionStatusController', scheduleTransactionStatusController);

    /** @ngInject */
    function scheduleTransactionStatusController(AppConstants, $stateParams, LoaderService, TransactionService, $window) {
      var vm = this;
      vm.transactionId = $stateParams.transactionId;
      vm.transactionType = $stateParams.transactionType;
      vm.isFavourite = $stateParams.isFavourite;
      vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
      vm.ROLLOVER_MODE = angular.copy(AppConstants.TRANSACTION_LIST_FILTER.ROLLOVER_MODE);
      vm.init = init;
      vm.riaName = sessionStorage.getItem("riaName");

      function init() {
        vm.formData = $stateParams.summaryData || angular.fromJson($window.sessionStorage.getItem("summayPayload"));
        if(vm.formData.amount){
          $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
        }
        vm.switchExecutionDetails = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX && vm.formData.switchExecutionDetails;
      }

      vm.clearSessionStorage = function() {
          $window.sessionStorage.removeItem("summayPayload");
      }
    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('RolloverController', rolloverController);

  /** @ngInject */
  function rolloverController($window, ModalService, LoaderService, $state, $log, AppConstants, MessageService, RolloverService, InvestorService, UtilService, RolloverModel, $timeout, panAadharService,AuthService) {
    var vm = this;
    vm.fetchRolloverPlan = fetchRolloverPlan;
    vm.fetchFolioList = fetchFolioList;
    vm.saveRolloverRequest = saveRolloverRequest;
    vm.fetchRolloverData = fetchRolloverData;
    vm.cancelRolloverRequest = cancelRolloverRequest;
    vm.rolloverDetail = rolloverDetail;
    vm.rolloverConfirm = rolloverConfirm;
    vm.rolloverSuccess = rolloverSuccess;
    vm.checkSwitchValidations = checkSwitchValidations;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.slideRight = slideRight;
    vm.slideLeft = slideLeft;
    vm.slideLeftDisabled = true;
    vm.slideRightDisabled = false;
    vm.folioCount = null;
    vm.dynCapsuleboxWidth = null;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.ROLLOVER_MODE = angular.copy(AppConstants.TRANSACTION_LIST_FILTER.ROLLOVER_MODE);
    vm.tForm = {};
    vm.formData = {};
    vm.validations = {};
    vm.isInvalidForm = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.formData.isChecked = false;
    vm.totalrolloverData = 0;
    vm.currentPageRollover = 1;
    vm.pageLimitRollover = 25;
    vm.isPagination = false;
    vm.isLoading = false;
    vm.schemeList = [];
    vm.folioLimit = 11;
    vm.kycVerifiedFlag = null;
    vm.notes = {};
    vm.showNote = true;
    // var sliderWidth = null;
    var sliderRange = {start: 1, end: 11};
    AuthService.checkLinkedUserStatus();

    vm.init = function () {
      fetchKycStatus();
      fetchFolioList();
      fetchRolloverPlan(function () {

      });

       var successHandler = function(resp) {
         vm.notes = resp;
       }
       UtilService.fetchDynamicData("ROLLOVER_REVIEW").then(successHandler).catch(function(resp) {
         MessageService.error(resp)
       });
    };



    vm.summaryInit = function () {
      vm.formData = RolloverModel.getPayloadRawData();
      if (vm.formData === null) {
        $state.go('main.rolloverView');
      }
    };

    vm.goToSummary = function () {
      vm.formData.isBackFromSummary = false;
      vm.isRequired = true;
      vm.isSaving = false;
      $state.$previous = $state.current;
      $timeout(function () {
        if (vm.tForm.$valid) {
          var payloadData = angular.copy(vm.formData);
          if (!payloadData) {
            return;
          }
          RolloverModel.setPayloadRawData(payloadData);
          $state.go('main.rollOverReview');
        }
      }, 0);
    };

    vm.goToBack = function () {
      vm.formData.isBackFromSummary = true;
      if (!$state.$previous) {
        return;
      }
      history.back();
    };

    vm.initAdd = function () {
      vm.schemeData = $window.JSON.parse(RolloverModel.getSchemePayload()) || $window.JSON.parse(localStorage.getItem('rollOverRequest'));
      vm.schemeDataFromModel = RolloverModel.getPayloadRawData();
      var tmpAmount;
      var tmpAmountType;
      if (vm.schemeDataFromModel !== null) {
        tmpAmountType = vm.schemeDataFromModel.amountType;
        tmpAmount = vm.schemeDataFromModel.amount;
      }
      if (!vm.schemeData) {
        $state.go('main.rolloverView');
      }
      vm.formData = vm.schemeData;
      vm.formData.amountType = tmpAmountType || "AllUnits";
      vm.formData.amount = tmpAmount || "";
      vm.formData.units = vm.schemeDataFromModel?vm.schemeDataFromModel.units:'';
      vm.formData.totalUnits = vm.schemeData.totalUnits;
      vm.formData.freeUnits = vm.schemeData.freeUnits;
    };

    function fetchFolioList() {
      LoaderService.showLoader();
      vm.isLoading = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
            vm.folioList = resp.data.folioMap;
            vm.folioCount = vm.folioList.length - 1;
            /*vm.sliderWidth = angular.element(".capsule-box").inner;*/
            vm.dynCapsuleboxWidth = vm.folioCount * 100;
            // sliderWidth = vm.dynCapsuleboxWidth;
            //angular.element(".capsule-box").innerWidth(vm.dynCapsuleboxWidth);
            vm.selectedFolio = (vm.folioList && vm.folioList.length) ? vm.folioList[0] : '';
            if (vm.selectedFolio) {
              fetchRolloverData();
            }
          }
          else {
            vm.folioList = null;
            vm.isLoading = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('err ', err);
          vm.isLoading = false;
          MessageService.error();
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      InvestorService.get({
        child1: 'folio',
        child2: 'list'
      }, {}).$promise.then(success, error);

    }

    vm.isDisplayed = function (index) {

      if (parseInt(index) >= sliderRange.start && parseInt(index) <= sliderRange.end) {
        return true;
      } else return false;
    };

    function fetchRolloverData() {
      LoaderService.showLoader();
      vm.isLoading = true;

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var rolloverData = resp.data;
            vm.rolloverData = [];

            rolloverData && rolloverData.registered && rolloverData.registered.forEach(function (item) {
              item.type = 'registered';
              if (item.rolloverMode == "NoOfUnits") {
                item.mode = "unit";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else if (item.rolloverMode == "AllUnits") {
                item.mode = "unit";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else if (item.rolloverMode == "Amount") {
                item.mode = "amount";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else {
              //
              }
              vm.rolloverData.push(item);
              /*item.purchaseValueUnit = UtilService.getUnitSting(item.purchaseValue);
               item.currentValueUnit = UtilService.getUnitSting(item.currentValue);*/
            });
            rolloverData && rolloverData.cancelled && rolloverData.cancelled.forEach(function (item) {
              item.type = 'cancelled';

              if (item.rolloverMode == "NoOfUnits") {
                item.mode = "unit";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else if (item.rolloverMode == "AllUnits") {
                item.mode = "unit";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else if (item.rolloverMode == "Amount") {
                item.mode = "amount";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else {
                item.rolloverMode = 'NA'
                item.mode = "amount";
                item.unitValue = 'NA'
                item.amountOrUnits = item.amountOrUnits ? item.amountOrUnits : 'NA'
              }
              vm.rolloverData.push(item);
            });
            vm.totalrolloverData = vm.rolloverData.length;
            vm.isPagination = !!(vm.rolloverData && vm.rolloverData.length);
          }
          else {
            vm.rolloverData = null;
            vm.isLoading = false;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('rollover Err ', err);
          vm.isLoading = false;
          vm.isPagination = false;
          MessageService.error();
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      RolloverService.post({
        controller: 'rollover',
        type: 'get',
        child1: 'all'/*,
        child2: vm.selectedFolio*/
      }, {folioNo:vm.selectedFolio}).$promise.then(success, error);
    }

    function rolloverDetail(data) {
      var successModal = function () {
          $state.go('login')
        },
        errorModal = function () {
          // MessageService.error(err)
        };
      ModalService.rollOverOverviewModal(data, successModal, errorModal)

    }

    function rolloverConfirm(saveRolloverRequest) {
      var data = {};
      data.saveRolloverRequest = saveRolloverRequest;
      var successModal = function () {
          $state.go('login')
        },
        errorModal = function () {
          // MessageService.error(err)
        };
      ModalService.rollOverConfirmModal(data, successModal, errorModal)

    }

    function rolloverSuccess(data) {
      var successModal = function () {
          $state.go('main.rolloverView');
        },
        errorModal = function () {
          // MessageService.error(err)
        };
      ModalService.rollOverSuccessModal(data, successModal, errorModal)

    }

    function cancelRolloverRequest(data) {
      LoaderService.showLoader();
      vm.isLoading = true;
      var payload = {
        folioNumber: data.folio_no,
        schemeCode: data.schemeCode,
        schemeName: data.schemeName,
        camsReferenceNumber: data.cams_ref_no,
        msgId: data.msg_id
      };

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            MessageService.success("Rollover Request cancelled Successfully");
            $state.go('main.rolloverView');

          }
          else {
            MessageService.error(resp.message);
            $state.go('main.rolloverView');
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isLoading = false;
          MessageService.error(err);
          $state.go('main.rolloverView');
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      RolloverService.post({
        controller: 'rollover',
        type: 'cancel'
      }, payload).$promise.then(success, error);
    }

    function saveRolloverRequest() {
      vm.isRequired = false;
      vm.isSaving = true;
      var ID = vm.formData.id ? vm.formData.id : null;
      var payload = {
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        schemeName: vm.formData.schemeName,
        rolloverMode: vm.formData.amountType,
        amount: vm.formData.amount ? vm.formData.amount : 0,
        units: vm.formData.freeUnits ? vm.formData.freeUnits : 0
      };
      if (Object.keys(payload).length < 1) {
        return;
      }

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            $state.go('main.summary-success', {
              transactionId: resp.data.data,
              transactionType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.ROLLOVER,
              isFavourite: false
            });


          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              });
            } else {
              MessageService.error(resp.message);
            }
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error();
        };

      RolloverService.post({
        controller: 'rollover',
        type: 'create',
        child1: ID
      }, payload).$promise.then(success, error);
    }

    vm.getFolioData = function (folioNumber) {
      vm.rolloverData = null;
      vm.totalrolloverData = 0;
      vm.isPagination = false;
      vm.currentPageRollover = 1;
      vm.selectedFolio = folioNumber ? folioNumber : '';

      if (vm.selectedFolio) {
        fetchRolloverData();
      }
    };

    vm.rolloverForm = function (schemeData, folioNumber) {
      var scheme = {};
      if (!schemeData) {
        $state.go('main.rolloverView');
      }
      schemeData && schemeData.folioDetails && schemeData.folioDetails.forEach(function (item) {
        if (item.folioNumber == folioNumber) {
          scheme.currentValue = item.currentValue;
        }
      });

      scheme.folioNumber = folioNumber;
      scheme.totalUnits = scheme.currentValue && scheme.currentValue.totalCurrentValueUnits;
      scheme.freeUnits = scheme.currentValue && scheme.currentValue.freeValueUnits;
      scheme.freeAmount = scheme.currentValue && scheme.currentValue.freeValueAmount;
      scheme.totalAmount = scheme.currentValue && scheme.currentValue.totalCurrentValueAmount;
      scheme.rolloverExpiryDate = schemeData.rolloverExpiryDate;
      scheme.rolloverInitiatedDate = schemeData.rolloverInitiatedDate;
      scheme.schemeCode = schemeData.schemeCode;
      scheme.schemeName = schemeData.schemeName;

      localStorage.removeItem('rollOverRequest');
      RolloverModel.emptySchemePayload();
      RolloverModel.emptyFormPayload();
      localStorage.setItem('rollOverRequest', angular.toJson(scheme));
      RolloverModel.setSchemePayload(angular.toJson(scheme));
      $state.go('main.rollover');

    };

    vm.folioChanged = function () {
      fetchRolloverPlan(function () {

      });
    };

    vm.selectFolio = function (value) {
      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        $('.regBtn').prop("disabled", true);
        if(vm.kycVerifiedFlag)
          $('#registered_' + value).prop("disabled", false);
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        vm.formData.folioNumber=null;
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);

    };

    function fetchRolloverPlan(cb) {
      cb = cb || function () {
        };


      vm.schemeList = [];
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.schemeList = resp.data.schemes;

            cb();
          } else {
            vm.schemeList = [];
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.schemeList = [];
          UtilService.errorHandler(err);
        };

      RolloverService.get({
        controller: 'rollover',
        type: 'applicable'
      }, {}).$promise.then(success, error);
    }

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        e.preventDefault();
      }
      return false;
    };

    vm.amountTypeChanged = function () {
      if (vm.formData.amountType === 'Amount') {
        vm.formData.units = '';
      } else if (vm.formData.amountType === 'AllUnits') {
        vm.formData.amount = '';
        vm.formData.units = +vm.formData.freeUnits;
      } else {
        vm.formData.amount = '';
        vm.formData.units = '';
      }
    };

    function slideRight() {
      if (vm.folioCount >= sliderRange.end) {
        sliderRange.start = sliderRange.start + 11;
        sliderRange.end = sliderRange.end + 11;
        vm.slideLeftDisabled = false;
      }
      if (sliderRange.start > vm.folioCount) {
        vm.slideRightDisabled = true;
      }
    }

    function slideLeft() {
      if (sliderRange.start > 1) {
        sliderRange.start = sliderRange.start - 11;
        sliderRange.end = sliderRange.end - 11;
        vm.slideRightDisabled = false;
      }
      if (sliderRange.start <= 1) {
        vm.slideLeftDisabled = true;
      }
    }

    function checkSwitchValidations() {
      vm.validations.minAmount = 0;
      vm.validations.minUnits = 0;
      vm.validations.maxAmount = vm.schemeData && vm.schemeData.currentValue && vm.schemeData.currentValue.freeValueAmount;
      vm.validations.maxUnits = vm.schemeData && vm.schemeData.currentValue && vm.schemeData.currentValue.freeValueUnits;
      if (vm.formData.amountType == 'Amount') {
        vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
        vm.isMin = !!(vm.validations.minAmount > vm.formData.amount);
      }
      else {
        vm.isMax = !!(vm.validations.maxUnits && vm.validations.maxUnits < vm.formData.units);
        vm.isMin = !!(vm.validations.minUnits > vm.formData.units);
      }
      vm.isInvalidForm = (vm.formData.amount <= 0 && vm.formData.units <= 0) || (vm.formData.amount && (vm.isMax || vm.isMin )) || (vm.formData.units && (vm.isMax || vm.isMin))

    }

    function fetchKycStatus() {
      LoaderService.showLoader();
      var successHandler = function(resp) {
        if (resp.data && !resp.data.kycVerifiedFlag) {
          ModalService.genericModal({
            text: resp.data.kycMessage
          }, function() {
            $state.go("welcome");
          });
        }
      }, errorHandler = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      InvestorService.get({
        "child1": "folio",
        "child2": "transact-now"
      }).$promise.then(successHandler, errorHandler);
    }


  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('RolloverModel', rolloverModel);

  /** @ngInject */
  function rolloverModel() {
    var payload = null, masterRawData = {

    }, schemePayLoad = null;

    function getMasterRawData(type) {
      return angular.copy(masterRawData[type]);
    }

    function getPayloadRawData() {
      return angular.copy(payload);
    }

    function setPayloadRawData(_payload) {
      payload = angular.copy(_payload);
    }

    function setSchemePayload(_payload) {
      schemePayLoad = angular.copy(_payload);
    }

    function getSchemePayload() {
      return angular.copy(schemePayLoad);
    }

    function emptySchemePayload() {
      schemePayLoad = null;
    }

    function emptyFormPayload() {
      payload = null;
    }

    return {
      getPayloadRawData: getPayloadRawData,
      setPayloadRawData: setPayloadRawData,
      getMasterRawData: getMasterRawData,
      setSchemePayload: setSchemePayload,
      getSchemePayload: getSchemePayload,
      emptySchemePayload: emptySchemePayload,
      emptyFormPayload: emptyFormPayload
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PaymentController', paymentController);

  /** @ngInject */
  function paymentController(ModalService, AppConstants, $window, $timeout, $state, $rootScope, $scope,
                             $stateParams, TransactionModel, LoaderService, TransactionService,
                             InvestorService, MessageService, UtilService, $log, NetcoreEvntService, HDFC_API, TransactionServiceVersion, notesPayment, FileUploadServiceVersion2,$sce, DownloadPdfService,FileSaver, PaymentService) {
    var vm = this;
    vm.formData = TransactionModel.getPayloadRawData()|| {};
    if(vm.formData.purchaseAmount){
      $window.NumToWord(vm.formData.purchaseAmount, 'TransactionPaymentInWord', vm.formData);
    }
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.PATTERN = AppConstants;
    vm.downloadPdfFile=downloadPdfFile;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    $scope.billdeskUrl = HDFC_API.BILLDESK_URL;
    vm.NRI_STATUS_CODES = AppConstants.NRI_STATUS_CODES;
    vm.getFormData = getFormData;
    vm.isDisableUpi = false;
    vm.showUpiPaymentReview = $stateParams.isUpi;
    vm.sipUpiText = vm.TRANSACTIONS_CONST.DESCRIPTIONS.UPI_AUTOPAY;

    vm.checkForMinorBankListCondition = function() {
      // if(vm.formData!=null && vm.formData.minorFlag!=null && vm.formData.cgfFlag!=null)
      //   return vm.formData.minorFlag && !vm.formData.cgfFlag;
      // else
      //   return false;
      return false;
    };


    if(vm.checkForMinorBankListCondition()) {
      if(vm.formData.sipFirstInstallment || $stateParams.sipWithFirstInstallment)
      {
        if (vm.formData.investmentType === 'FLEXSIP') {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM
          ];
        } else if ($stateParams.isUpi) {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
          ]
        } else {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM
          ];
        }
      }
      else{
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }
      getDetails();
    }
    else
    {
      if(vm.formData.sipFirstInstallment || $stateParams.sipWithFirstInstallment)
      {
        if (vm.formData.investmentType === 'FLEXSIP') {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM
          ];
        } else if ($stateParams.isUpi) {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
          ]
        } else {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM
          ];
        }
      }
      else
      {
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }
    }

    var paymentOptions4Liquid=[];

    if ($stateParams.isUpi) {
      paymentOptions4Liquid = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI];
    } else {
      if(vm.checkForMinorBankListCondition()){
        if(vm.formData.sipFirstInstallment) {
          if (vm.formData.investmentType === 'FLEXSIP') {
            paymentOptions4Liquid = [];
          } else {
            paymentOptions4Liquid = [
              vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
            ];
          }
        }
        else
        {
          paymentOptions4Liquid = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
          ];
        }
      }
      else{
        if(vm.formData.sipFirstInstallment || $stateParams.sipWithFirstInstallment)
        {
          if (vm.formData.investmentType === 'FLEXSIP') {
            paymentOptions4Liquid = [];
          } else {
            paymentOptions4Liquid = [
              vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
            ];
          }
        }
        else
        {
          paymentOptions4Liquid = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
          ];
        }
      }
    }



    vm.isUPIVerified = false;
    vm.isCheckedDeclaration = false;
    vm.bankList = null;
    vm.bankInfo = null;
    vm.investorInfo = null;
    vm.debitCardType = 'visa';
    vm.isInvalidForm = false;
    vm.selectedUpiBank = selectedUpiBank;
    vm.hideOtmOtion = false;
    vm.verifyUPI = verifyUPI;
    vm.getAccountNumber = getAccountNumber;
    vm.checkOtmList = checkOtmList;
    var TrFlowType = {NEW:'NEW',OLD:'OLD'};
    vm.tpv = tpv;
    vm.netBankingAndUPIList = null;
    vm.OTMList = null
    vm.isOTMAmount = false;
    vm.isOTMDate = false;
    vm.isOTMStartDate = false;
    vm.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.notesPayment = notesPayment;
    vm.noteNetBanking = vm.notesPayment.noteDTO.noteDTOMap.Note_Purchase_Net_Banking;
    vm.billdeskPayload = {
      hidRequestId : "PGIME1000",
      hidOperation : "ME100",
      msg : ""
    };
    vm.isNewPayment = true;
    vm.changeRtgsPaymentOption = changeRtgsPaymentOption;
    vm.bankUploadChequeLeafFile = bankUploadChequeLeafFile;
    vm.openUploadedDoc = openUploadedDoc;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff", "application/pdf"];
    vm.chooseAFile = true;

    function tpv(event) {
      event.preventDefault();
      ModalService.tpvModal({});
    }
    function getInvestorInfo(cb) {
      cb = cb ||function () {

      };
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
        } else {
          vm.investorInfo = null;
          MessageService.error(resp.message);
        }
        cb();
      }, error = function (err) {
        UtilService.errorHandler(err);
        vm.investorInfo = null;
        cb();
      };
      InvestorService.get({
        child1: 'folio',
        child3: 'info'
      }).$promise.then(success, error);
    }

    function handlePurchaseResponse(data) {
      var transactionId = data && data.transactionId ? data.transactionId : null;
      var payloadData = data;
      data = data && data.data ? data.data : data;
      if (!data) {
        MessageService.error();
        return;
      }

      if(vm.formData.sipFirstInstallment && (vm.formData.sipPaymentOption==='E-mandate' || vm.formData.flexSipPaymentOption==='E-mandate'))
      {
        $window.location.href=$scope.billdeskUrl+data.emandateMsg;
        return;
      }

      if(vm.formData.investmentType==='SIP' || vm.formData.investmentType === 'FLEXSIP')
        vm.billdeskMsg = data.emandateMsg;
      else
        vm.billdeskMsg = data;
      if(vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'RAZORPAY') {
        if(vm.formData.investmentType==='PURCHASE') {
          payloadData.trnxActionMsg = payloadData.data;
        } else if(vm.formData.investmentType==='SIP') {
          payloadData.trnxActionMsg = payloadData.emandateMsg;
        }
        PaymentService.openRazorPay(payloadData);
      } else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLDESK') {
        if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () { // commented as debit currently is not getting used
            angular.element('#billdeskForm').submit();
          });
          //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
        } else {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            angular.element('#billdeskForm').submit();
          });
          //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
        }
      }
      else if (vm.formData.paymentInfo.paymentMode == 'WEB' && (vm.formData.paymentInfo.webMode == 'MASTERCARD' || vm.formData.paymentInfo.webMode == 'VISA')) {
        if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            angular.element('#billdeskForm').submit();
          });
          //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
        } else {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            angular.element('#billdeskForm').submit();
          });
          //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
        }
        // ModalService.successTransactionModal();
      }
      else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLJUNCTION') {
        $window.open(vm.billdeskMsg, '_self');
        // ModalService.successTransactionModal();
      } else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'UPI') {
        vm.showUPISuccessPopup();
        // ModalService.successTransactionModal();
      }
      else if(vm.formData.sipFirstInstallment)
      {
        $window.location.href = data.redirectUrl;
        /*ModalService.manualInstructionsModal({
          srnNo: data.srnNo,
          investorName: vm.formData.folioInvestorName,
          folioInvestorName: vm.formData.folioInvestorName,
          folioNumber: vm.formData.folioNumber,
          schemeName: vm.formData.inSchemeName,
          investmentOption: vm.formData.investmentOption,
          amount: vm.formData.amount,
          sipDividendOption: vm.formData.sipDividendOption,
          netBankingUrl:vm.formData.netBankingUrl,
          paymentOption:data.paymentOption,
          transactionId:data.trxnNo,
          transactionInitiateDate:data.transactionInitiateDate,
          frequency:vm.formData.frequency,
          startDate:vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY'):null,
          endDate:vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY'):null,
          bankName:vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
          bankAcNo:vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : vm.formData.bankAcNo,
          sipFirstInstallment:vm.formData.sipFirstInstallment,
          sipFirstAmount:vm.formData.sipFirstAmount,
          sipFirstBankName: vm.formData.purchasePaymentOption === "HDFC" ? "HDFC Bank" : vm.formData.paymentInfo.bankName,
          installmentPaymentOption: vm.TRANSACTIONS_CONST.DESCRIPTIONS[vm.formData.purchasePaymentOption]
        });*/
      }
      else {
        var isFavourite = vm.formData.isFavourite ? true : false;
        sessionStorage.setItem("riaName", vm.formData.riaBrokerName);
        $state.go('main.summary-success', {
          transactionId: transactionId,
          transactionType: vm.formData.investmentType, isFavourite: isFavourite
        });

      }
    }

    vm.showUPISuccessPopup = function () {
      var successModal = function () {
          $state.go('welcome');
        },
        errorModal = function () {
          $state.go('welcome');
        };
      //ModalService.upiSuccessModal({}, successModal, errorModal);
    };
    function getPaymentInfo() {

      if (vm.formData.paymentInfo && vm.formData.paymentInfo.webMode === 'MASTER') {
        vm.formData.paymentInfo.webMode = 'MASTERCARD';
      }

      var paymentInfo={};

      if(vm.formData.investmentType==='SIP' || vm.formData.investmentType === 'FLEXSIP' || vm.formData.investmentType==='DREAMSIP')
      {
        paymentInfo = {
          //amount: vm.formData.amount,
          paymentMode: vm.formData.paymentInfo.paymentMode

        };

        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.bankName = vm.bankInfo.bankName;
            if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
              paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
              paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            }
            paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            paymentInfo.otmId = vm.formData.paymentInfo.otmId;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.branchName = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNumber = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.payoutId = vm.formData.paymentInfo.payoutId;
            paymentInfo.omUmrn = vm.formData.paymentInfo.omUmrn;
            paymentInfo.camsMandateIdNo = vm.formData.paymentInfo.camsMandateIdNo;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNumber = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.accountHolderName = vm.formData.paymentInfo.accountHolderName;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.bankAcNo = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
            paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
            paymentInfo.upiReferenceNumber = vm.transactionNumber;
            paymentInfo.accountNumber = vm.upiAccountNumber;
            paymentInfo.accNumber= paymentInfo.accountNumber;
            paymentInfo.bankName= vm.upiBankName;
            paymentInfo.paymentMode = 'UAP';
            paymentInfo.accType = vm.formData.paymentInfo.accType ? vm.formData.paymentInfo.accType : vm.formData.bankAcType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode ? vm.formData.paymentInfo.ifscCode : vm.formData.ifscCode;
            break;
        }

      }
      else
      {
        paymentInfo = {
          amount: vm.formData.paymentInfo.amount,
          paymentMode: vm.formData.paymentInfo.paymentMode

        };

        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.bankName = vm.bankInfo.bankName;
            if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
              paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
              paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            }
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            paymentInfo.otmId = vm.formData.paymentInfo.otmId;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.branchName = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNo = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.payoutId = vm.formData.paymentInfo.payoutId;
            paymentInfo.omUmrn = vm.formData.paymentInfo.omUmrn;
            paymentInfo.camsMandateIdNo = vm.formData.paymentInfo.camsMandateIdNo;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNo = vm.formData.paymentInfo.accNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            paymentInfo.accType = vm.formData.paymentInfo.bankAcType;
            paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
            // if(vm.isNewPayment) {
              paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            // }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.accountHolderName = vm.formData.paymentInfo.accountHolderName;
            paymentInfo.bankName = "HDFC Bank Ltd";
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.bankAcNo = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
            paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
            paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
            paymentInfo.upiReferenceNumber = vm.transactionNumber;
            paymentInfo.accountNumber = vm.upiAccountNumber;
            paymentInfo.accNo= paymentInfo.accountNumber;
            paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType;
            paymentInfo.bankName = vm.upiBankName;
            paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
            break;
        }
      }

      return angular.copy(paymentInfo);
    }

    function getSipPurchasePayload() {
      var sipPayload = {
          installmentAmount: vm.formData.amount,
          investmentOption: vm.formData.investmentOption,
          dividendOption: vm.formData.dividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          frequency: vm.formData.frequency,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          toDate: vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY').toString() : '',
          sipDate: vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY').toString() : '',
          sipDay: vm.formData.day,
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          id: vm.formData.sTransactionId,
          subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode,
          brokerCode: vm.formData.brokerCode?'ARN-'+vm.formData.brokerCode:'',
          secretLink: vm.secretLink
    },
        purchasePayload = {
          amount: vm.formData.purchaseAmount,
          investmentOption: vm.formData.purchaseInvestmentOption,
          dividendOption: vm.formData.purchaseDividendOption,
          folioNumber: vm.formData.folioNumber,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          schemeCode: vm.formData.purchaseInSchemeCode,
          retirementAgeProofURL: vm.formData.retirementAgeProofURL ? vm.formData.retirementAgeProofURL : '',
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          id: vm.formData.pTransactionId,
          paymentInfo: getPaymentInfo(),
          subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode,
          checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
          autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null,
          autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null,
          secretLink: vm.secretLink
        },flexSipPayload = {
          installmentAmount: vm.formData.amount,
          investmentOption: vm.formData.investmentOption,
          dividendOption: vm.formData.dividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP,
          flexSipFrequency: vm.formData.frequency,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          primaryFlag: true,
          toDate: vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY').toString() : '',
          sipDate: vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY').toString() : '',
          sipDay: vm.formData.day,
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          id: vm.formData.sTransactionId,
          subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode,
          brokerCode: vm.formData.brokerCode?'ARN-'+vm.formData.brokerCode:'',
          flexSip: true,
          secretLink: vm.secretLink
        }

      sipPayload.netCoreRefNo = vm.netCoreRefNo;
      purchasePayload.netCoreRefNo = vm.netCoreRefNo;
      flexSipPayload.netCoreRefNo = vm.netCoreRefNo;

      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == purchasePayload.investmentOption) {
          purchasePayload.investmentOption = key;
        } else if (vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == sipPayload.investmentOption) {
          sipPayload.investmentOption = key;
        }
      });
      if (purchasePayload.paymentInfo.accountNumber) {
        purchasePayload.accountNumber = purchasePayload.paymentInfo.accountNumber;
        //delete purchasePayload.paymentInfo.accountNumber;
      }
      if (purchasePayload.paymentInfo.tpvEnableFlag) {
        purchasePayload.tpvEnableFlag = purchasePayload.paymentInfo.tpvEnableFlag;
        delete purchasePayload.paymentInfo.tpvEnableFlag;
      }

      if (vm.formData.investmentType === 'SIP' && (vm.formData.sipFirstInstallment || $stateParams.sipWithFirstInstallment) && $stateParams.isUpi) {
        sipPayload.payerVpa = vm.formData.paymentInfo.virtualAddress;
        sipPayload.payerName = vm.formData.name;
        sipPayload.paymentOption = 'UAP';
      }


      var payload = {};

      switch (vm.formData.investmentType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          purchasePayload = handleBrokerCode(purchasePayload);
          payload = angular.copy(purchasePayload);
          // if (vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
          //   payload.sipForm = angular.copy(sipPayload);
          // }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          sipPayload = handleBrokerCode(sipPayload);
          payload = angular.copy(sipPayload);
          // if (vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
          //   payload.purchaseForm = angular.copy(purchasePayload);
          // }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_SIP:
          sipPayload = handleBrokerCode(sipPayload);
          payload = angular.copy(flexSipPayload);
          // if (vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
          //   payload.purchaseForm = angular.copy(purchasePayload);
          // }
          break;
      }
      if(vm.formData.investmentType == "DREAMSIP"){

        sipPayload = handleBrokerCode(sipPayload);
        sipPayload.formType = "DREAMSIP";
        payload = angular.copy(sipPayload);
      }

      if((vm.formData.investmentType==='SIP' || vm.formData.investmentType==='FLEXSIP' || vm.formData.investmentType==='DREAMSIP') && vm.formData.sipFirstInstallment)
      {
         payload.sipWithFirstInstallment=vm.formData.sipFirstInstallment;
         payload.firstInstallmentDetails=getPaymentInfo();

         if(vm.formData.sipPaymentOption==='EC' || vm.formData.flexSipPaymentOption==='EC' || vm.formData.sipPaymentOption==='UPI')
         {
           payload.bankDetailsForECS= {
             accNumber: vm.formData.bankInfo.accountNumber,
             bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
             ifscCode: vm.formData.bankInfo.ifscCode ? vm.formData.bankInfo.ifscCode : vm.formData.ifscCode,
             branchName: vm.formData.bankInfo.bankBranch,
             bankCity: vm.formData.bankInfo.bankCity,
             paymentOption: vm.formData.sipPaymentOption ? vm.formData.sipPaymentOption : vm.formData.flexSipPaymentOption,
             netBankingUrl:vm.formData.netBankingUrl,
             bankCode:vm.formData.bankInfo ? vm.formData.bankInfo.bankCode:null,
             accType: vm.formData.bankInfo.bankAcType ? vm.formData.bankInfo.bankAcType : vm.formData.bankAcType
           }

           if (vm.formData.sipPaymentOption && vm.formData.sipPaymentOption === 'UPI') {
             payload.bankDetailsForECS.paymentOption ='UAP';
           }
         }
         else if(vm.formData.sipPaymentOption==='E-mandate' || vm.formData.flexSipPaymentOption==='E-mandate')
         {
           payload.bankDetailsForECS= {
             accNumber: vm.formData.bankInfo ? vm.formData.bankInfo.accountNumber:'',
             bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
             ifscCode: vm.formData.bankInfo.ifscCode,
             branchName: vm.formData.bankInfo.bankBranch,
             bankCity: vm.formData.bankInfo.bankCity,
             paymentOption: 'HEM',
             accType:vm.formData.bankInfo.bankAcType,
             bankCode:vm.formData.bankInfo ? vm.formData.bankInfo.bankCode:null,
             authenticationMode:vm.formData.authMode.value
           }
         }
         else if(vm.formData.sipPaymentOption==='OTM' || vm.formData.flexSipPaymentOption==='OTM')
         {
           payload.bankDetailsForECS= {
             accNumber: vm.formData.bankInfo.bankAcNo,
             bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
             ifscCode: vm.formData.bankInfo.ifscCode ? vm.formData.bankInfo.ifscCode : vm.formData.ifscCode,
             branchName: vm.formData.bankInfo.bankBranch,
             bankCity: vm.formData.bankInfo.bankCity,
             paymentOption: vm.formData.sipPaymentOption ? vm.formData.sipPaymentOption : vm.formData.flexSipPaymentOption,
             payoutId:vm.formData.bankInfo.payoutId,
             bankCode:vm.formData.bankInfo ? vm.formData.bankInfo.bankCode:null,
             accType: vm.formData.bankInfo.bankAcType ? vm.formData.bankInfo.bankAcType : vm.formData.bankAcType,
             camsMandateIdNo: vm.formData.bankInfo.camsMandateIdNo,
             omUmrn: vm.formData.bankInfo.omUmrn
           }
         }


         if(vm.formData.sipTopupEnabled)
         {
           payload.sipTopupEnabled=vm.formData.sipTopupEnabled;
           payload.topupDetails=vm.formData.topupDetails;
         }

      }
      if(vm.formData.modifyAction == 'modifySip'){
        payload.cancelTransactionRequestBody= {
          "transactionId": vm.formData.transactionId,
          "transactionType": vm.formData.investmentType
        }
      }

      return payload;
    }

    function checkBankList(){
      if (vm.bankList && vm.bankList.length == 1) {
        vm.bankInfo = vm.bankList[0];
        if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
          localStorage.setItem('folioId',vm.formData.folioNumber);
          ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
          return;
        };
        vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
        vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
        vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
        vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
        vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
        vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
        vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
        vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
        vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
        vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
        vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
        vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
        vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
        vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
        (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
        if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
          checkOTMAmountAndDate();
        }
        if(vm.formData.purchasePaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
          selectedUpiBank();
        }
      }
    }

    function fetchBankList() {
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.otmList = resp.data;
            if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
              vm.bankList = vm.formData.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList;
            } else {
              vm.bankList = resp.data.bankList;
            }
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            if(vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING ||
              vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
              vm.netBankingAndUPIList = vm.bankList;
            }
            if(vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM){
              vm.OTMList = vm.bankList;
            }

            if (vm.bankList && (vm.bankList.length == 1 ||(vm.formData.investmentType === 'SIP' && (vm.formData.sipFirstInstallment || $stateParams.sipWithFirstInstallment) && $stateParams.isUpi))) {
              if (vm.formData.investmentType === 'SIP' && $stateParams.isUpi) {
                vm.bankInfo =  vm.formData.bankInfo;
                vm.formData.paymentInfo.virtualAddress = vm.formData.virtualAddress;
                vm.verifyUPIResp = vm.formData.verifyUPIResp;
                vm.name = vm.verifyUPIResp.name;
                vm.isUPIVerified = vm.verifyUPIResp.valid;
                vm.isDisableUpi = true;
              } else {
                vm.bankInfo = vm.bankList[0];
              }
              if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
                localStorage.setItem('folioId',vm.formData.folioNumber);
                ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
                return;
              }
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
              vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
              vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
              vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
              vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
              vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
              vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
              vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
              vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
              vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
              vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
              vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
              vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
              (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
              if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
                checkOTMAmountAndDate();
              }
              if(vm.formData.purchasePaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
                selectedUpiBank();
              }
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();

      var config = null;
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
          config = {child1: 'bank', child2: 'list', child3: vm.debitCardType, child4: 'debit'};
          InvestorService.get(config, null).$promise.then(success, error);
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          if(vm.netBankingAndUPIList === null){
            config = {child1: 'bank', child2: 'list'};
            if (vm.formData.investmentType === 'SIP' && (vm.formData.sipFirstInstallment || $stateParams.sipWithFirstInstallment) && $stateParams.isUpi) {
              InvestorService.post(config, {
                trnxType: 'PURCHASE',
                folioNumber: (vm.investorInfo && vm.investorInfo.transactionFlowVersion === TrFlowType.NEW) ?
                  vm.formData.folioNumber:null,
                liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false,
                sipUpiFlow : true
              }).$promise.then(success, error);
            } else {
              InvestorService.post(config, {
                trnxType: 'PURCHASE',
                folioNumber: (vm.investorInfo && vm.investorInfo.transactionFlowVersion === TrFlowType.NEW) ?
                  vm.formData.folioNumber:null,
                liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
              }).$promise.then(success, error);
            }
          }
          vm.bankList = vm.netBankingAndUPIList;
          checkBankList();
          LoaderService.hideLoader();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if(vm.OTMList === null) {
            config = {child1: 'folio', child2: 'otm'};
            InvestorService.post(config, {
              folioNo: vm.formData.folioNumber,
              transactionType: 'purchase'
            }).$promise.then(success, error);
          }
          vm.bankList = vm.OTMList;
          checkBankList();
          LoaderService.hideLoader();
          break;
        default :
          vm.bankList = null;
          config = null;
          break;
      }
    }

    function resetUPIForm() {
      vm.verifyUPIResp = {};
      vm.isUPIVerified = false;
      (vm.formData.paymentInfo)&&(vm.formData.paymentInfo.virtualAddress = "");
    }

    vm.init = function () {
      if (angular.isDefined($stateParams.trackId) && angular.isDefined($stateParams.stepNo) && $stateParams.stepNo === "THIRD") {
        showPrefillValuesUserTracker(function () {
          initActivity();
        });
      }
      else if(angular.isDefined($stateParams.trackId) && $stateParams.sipWithFirstInstallment)
      {
        showPrefillValuesUserTracker(function () {
          initActivity();
        });
      }
      else {
        initActivity();
      }
    };

    function getDetails(cb) {
      cb = cb ||function () {
      };
      var success = function (resp) {
        var bankDetails=[];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if(vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length>0){
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if(value.defaultBank===true){return value;}
          });
        }
        localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
        cb();
      }, error = function () {
        LoaderService.hideLoader();
        cb();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }


    function showPrefillValuesUserTracker(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData = resp.data.formdata || {};
            if(vm.formData.purchaseAmount){
              $window.NumToWord(vm.formData.purchaseAmount, 'TransactionPaymentInWord', vm.formData);
            }
            vm.formData.isSummaryViewEnabled = false;
            vm.formData.fromPaymentPage = true;
            TransactionModel.setPayloadRawData(vm.formData);
          } else {
            MessageService.error(resp.message);
          }
          cb();
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb();
        };
      TransactionService.get({
        controller1: 'userBehavior',
        controller2: $stateParams.trackId,
        controller3: 'getFormData'
      }).$promise.then(success, error);
    }

    function initActivity() {
      if (!vm.formData || (vm.formData.investmentType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE && vm.formData.optionalInvestmentType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE && !vm.formData.sipFirstInstallment)) {
        $state.go('welcome');
        TransactionModel.setPayloadRawData(null);
        return null;
      }
      if (vm.formData.schemeType === 'LIQUID') {
        vm.paymentOptions = paymentOptions4Liquid;
      }

      if(vm.formData.investmentType==='SIP' && vm.formData.bankInfo.emandateEnabled && (!vm.formData.sipFirstInstallment || !$stateParams.sipWithFirstInstallment))
      {
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }
      if(vm.formData.investmentType==='DREAMSIP' && vm.formData.bankInfo.emandateEnabled && (!vm.formData.sipFirstInstallment || !$stateParams.sipWithFirstInstallment))
      {
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }

      if(vm.formData.investmentType==='SIP' && vm.formData.bankInfo.emandateEnabled && vm.formData.schemeType.toUpperCase() === 'LIQUID' && (!vm.formData.sipFirstInstallment || !$stateParams.sipWithFirstInstallment))
      {
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }
      if( vm.formData.investmentType==='DREAMSIP' && vm.formData.bankInfo.emandateEnabled && vm.formData.schemeType.toUpperCase() === 'LIQUID' && (!vm.formData.sipFirstInstallment || !$stateParams.sipWithFirstInstallment))
      {
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }

      if(vm.formData.investmentType === 'FLEXSIP' && (vm.formData.sipFirstInstallment || $stateParams.sipWithFirstInstallment))
      {
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM
        ];
      }

      vm.formData.purchasePaymentOption = vm.paymentOptions[0];
      vm.formData.trackId = $stateParams.trackId?$stateParams.trackId:vm.formData.trackId;
      getInvestorInfo(function () {
        getDetails(function () {
          vm.changedPaymentOption();
          // checkOtmList();
        });
      });
      getAccountType();
    }

    function checkOtmList() {

      var success = function (resp) {
          if (resp.status && resp.data) {
            if (resp.data.bankList.length == 0) {
              if (vm.formData.schemeType.toUpperCase() == 'LIQUID') {
                vm.paymentOptions = paymentOptions4Liquid;
              } else {
                if(vm.checkForMinorBankListCondition()) {
                  if (vm.formData.sipFirstInstallment) {
                    if (vm.formData.investmentType === 'FLEXSIP') {
                      vm.paymentOptions = [];
                    } else if ($stateParams.isUpi) {
                      vm.paymentOptions = [
                        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                      ]
                    } else {
                      vm.paymentOptions = [
                        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
                      ];
                    }
                  } else {
                    vm.paymentOptions = [
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                    ];
                  }
                }
                else
                {
                  if (vm.formData.sipFirstInstallment) {
                    if (vm.formData.investmentType === 'FLEXSIP') {
                      vm.paymentOptions = [];
                    } else if ($stateParams.isUpi) {
                      vm.paymentOptions = [
                        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                      ]
                    } else {
                      vm.paymentOptions = [
                        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
                      ];
                    }
                  } else {
                    vm.paymentOptions = [
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                    ];
                  }
                }

              }
              if(vm.formData.investmentType==='SIP'  && vm.formData.bankInfo.emandateEnabled)
              {
                vm.paymentOptions = [
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                ];
              }
              if(vm.formData.investmentType==='DREAMSIP' && vm.formData.bankInfo.emandateEnabled)
              {
                vm.paymentOptions = [
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                ];
              }

            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        }

      var config = {child1: 'folio', child2: 'otm'};
      InvestorService.post(config, {folioNo: vm.formData.folioNumber, transactionType: 'purchase'}).$promise.then(success, error);
    }

    vm.changedPaymentOption = function () {
      vm.isCheckedDeclaration = false;
      vm.bankInfo = null;
      vm.bankList = null;
      vm.formData.paymentInfo = {amount: vm.formData.purchaseAmount};
      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isInvalidForm = false;
      vm.fileType='';
      vm.bankchequeLeafUrl=null;
      vm.isNewPayment = true;
      vm.formData.paymentInfo.chequeLeaf=null;
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          vm.formData.paymentInfo.paymentMode = "WEB";
          fetchBankList();
          // $timeout(function () {
          //   if(vm.formData.modifyAction == "modifySip") {
          //     vm.bankInfo = vm.bankList && vm.bankList.find(function (bank) {
          //       if(vm.formData.firstInstallmentDetails) {
          //         return bank.accountNumber === vm.formData.firstInstallmentDetails.bankAccNo
          //       }
          //     })
          //     vm.changeBank();
          //   }
          // }, 500);
          userActivityTracking(false, function (resp) {
            var netcoreData = vm.formData;
            netcoreData.deeplink = resp.trxnUniqueLink;
            if (vm.formData.investmentType === 'PURCHASE') {
              NetcoreEvntService.purchase_Payment_Netbanking(netcoreData);
            } else if (vm.formData.investmentType === 'SIP') {
              NetcoreEvntService.sip_Payment_Method(netcoreData);
            }
          });
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          fetchBankList();
          // $timeout(function () {
          //   if(vm.formData.modifyAction == "modifySip") {
          //     vm.bankInfo = vm.bankList && vm.bankList.find(function (bank) {
          //       if(vm.formData.firstInstallmentDetails) {
          //         return bank.omUmrn === vm.formData.firstInstallmentDetails.omUmrn
          //       }
          //     })
          //     vm.changeBank();
          //   }
          // }, 500);
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
          if(vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
            vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
          }
          fetchRTGSBankList();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC;
          resetCheckLeaf();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          resetUPIForm();
          fetchBankList();
          if(vm.formData.purchaseAmount > vm.formData.upiLimit) {
            var success = function() {
              vm.formData.purchasePaymentOption = vm.paymentOptions[0];
              vm.changedPaymentOption();
            }
            ModalService.genericModal({
              text: vm.formData.upiErrorMessage,
              isUpi: true
            },success);
          }
          vm.formData.paymentInfo.paymentMode = "WEB";
          vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
          userActivityTracking(false, function (resp) {
            var netcoreData = vm.formData;
            netcoreData.deeplink = resp.trxnUniqueLink;
            if (vm.formData.investmentType === 'PURCHASE') {
              NetcoreEvntService.purchase_Payment_UPI(netcoreData);
            }
          });
          break;
      }
    };

    vm.changeBank = function () {
      if (!vm.bankInfo) {
        return;
      }
      vm.isInvalidForm = false;
      localStorage.setItem('folioId',vm.formData.folioNumber);
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            return;
          }
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType==""?null:vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          if (vm.bankInfo.tpvEnableFlag == 'Y') {
            getAccountNumber(vm.bankInfo.bankCode);
          }
          // vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
          // vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            return;
          }
          vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
          vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
          vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
          vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
          (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
          checkOTMAmountAndDate();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            return;
          }
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            return;
          }
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode ? vm.bankInfo.bankCode : null;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor ? vm.bankInfo.gateWayVendor : null;
          if (vm.bankInfo.tpvEnableFlag == 'Y') {
            getAccountNumber(vm.bankInfo.bankCode);
          }
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly ? vm.bankInfo.bankNameOnly : null;
          vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch ? vm.bankInfo.bankBranch : null;
          vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber ? vm.bankInfo.accountNumber : null;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : null;
          vm.formData.paymentInfo.otherBank = true;
          vm.formData.paymentInfo.bankAcType = vm.bankInfo.bankAcType==""?null:vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.utrNumber = null;
          vm.formData.paymentInfo.verifyUtrNumber = null;
          vm.formData.paymentInfo.verifyBankAcNo = null;
          vm.formData.paymentInfo.chequeLeaf = null;
          vm.bankChequeLeaf = null;
          vm.isAccTypeFieldDisabled = vm.formData.paymentInfo.bankAcType ? true : false;
          vm.tForm.$setPristine();
          if(!vm.bankInfo.bankAcType && vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
            vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
          }
          if(vm.isNewPayment && vm.bankInfo){
            vm.tForm.bankName.$setDirty();
            vm.tForm.bankBranch.$setDirty();
            vm.tForm.bankAcNo.$setDirty();
            vm.tForm.ifscCode.$setDirty();
            vm.tForm.accountType.$setDirty();
            vm.bankChequeLeaf = 'No File Chosen';
            vm.bankchequeLeafUrl = null;
            vm.fileType = null;
            vm.chooseAFile = true;
          }else{
            vm.tForm.bankBranch.$dirty = false;
            vm.tForm.bankAcNo.$dirty = false;
            vm.tForm.bankName.$dirty = false;
            vm.tForm.ifscCode.$dirty = false;
            vm.tForm.accountType.$dirty = false;
          }
          break;
        default :
          vm.bankInfo = null;
          break;
      }
    };

    function getAccountNumber(bankCode) {
      if(vm.investorInfo && vm.investorInfo.transactionFlowVersion === TrFlowType.NEW){
        vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
        vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
        return;
      }
      vm.bankAccounts = [];
      vm.isInvalidForm = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            vm.bankAccounts = resp.data.accountNumbers;
            if (vm.bankAccounts.length > 1) {
              var success = function (accountNo) {
                vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
                vm.formData.paymentInfo.accountNumber = accountNo;
                vm.isInvalidForm = false;
              }, error = function () {

              };
              ModalService.selectAccountNoModal({bankAccounts: vm.bankAccounts}, success, error);
            } else {
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankAccounts[0];
              vm.isInvalidForm = false;
            }
          } else {
            vm.isInvalidForm = true;
            MessageService.error(resp.message);
            vm.bankAccounts = [];
          }
        },
        error = function (err) {
          vm.bankAccounts = [];
          vm.isInvalidForm = true;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber, //'9422332',
        "bankCode": bankCode
      };
      InvestorService.post({
        child1: 'bank',
        child2: 'account'
      }, payload).$promise.then(success, error);
    }

    vm.goToBack = function () {
      if(vm.formData.modifyAction == 'modifySip'){
        var params =  { };
        params['allowBroker'] = vm.formData.isAllowBroker;
        params['action'] = 'modify';
        $window.localStorage.setItem("SummaryEnabled", true);
        $state.go("main.transactions.sip",params);
      } else if(vm.formData.investmentType === 'SIP')
      {
        $window.localStorage.setItem("SummaryEnabled", true);
        $state.go("main.transactions.sip");
      }else if(vm.formData.investmentType === 'DREAMSIP'){
        $window.localStorage.setItem("SummaryEnabled", true);
        $state.go("main.transactions.dreamSip");
      } else if (vm.formData.investmentType === 'FLEXSIP') {
        $window.localStorage.setItem("SummaryEnabled", true);
        $state.go("main.transactions.flexsip");
      } else
      {
        $window.localStorage.setItem("SummaryEnabled", true);
        $state.go("main.transactions.purchase");
      }
    }

    vm.completePurchaseFirst = function ($event) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                transactionOtmConfirmation($event);
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
            }
            else {
              transactionOtmConfirmation($event);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType: vm.formData.investmentType,
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.purchaseInSchemeCode,
        amount: vm.formData.purchaseAmount
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'transaction',
        child2: 'check',
        child3: 'duplicate'
      }, payload).$promise.then(success, error);
    };

    vm.submitForm = function ($event) {
      //userActivityTracking(false, function () {
        var payload = getSipPurchasePayload();
        if (!payload) {
          MessageService.error('Something went wrong while calculating purchase payload.');
          return;
        }
        if (payload.formType === 'PURCHASE' && vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING &&
          vm.formData.purchaseAmount >= 200000 && vm.formData.schemeType != 'LIQUID') {
          vm.showPurchaseNetBankingModal(payload);
        } else if (vm.formData.investmentType === 'SIP' || vm.formData.investmentType === 'FLEXSIP'  || vm.formData.investmentType==='DREAMSIP'){
          if(payload.bankDetailsForECS && payload.bankDetailsForECS.paymentOption==='HEM'){
            var successCallback = function () {
              vm.finalSubmit(payload);
              };
            var errorCallback = function () {
              LoaderService.hideLoader();
            };
            ModalService.registerEMandateModal({folioNumber:vm.formData.folioNumber,transactionType : vm.formData.investmentType, bankName :payload.bankDetailsForECS.bankName, authMode: payload.bankDetailsForECS.authenticationMode},successCallback,errorCallback)
          }
          else {
            vm.finalSubmit(payload);
          }
        }
        else {
          vm.finalSubmit(payload);
        }
      //});
    };


    function userActivityTracking(isProcessed, cb) {

      /*Netcore Event Start*/
      if(!isProcessed){
        //NetcoreEvntService.Continue_To_Pay_Purchase_IP(vm.formData, true);
      }
      /*Netcore Event End*/
      cb = cb || function () {
      };
      var success = function (trackResp) {
        trackResp = trackResp.data || trackResp;
        vm.netCoreRefNo = trackResp.transactionId;
        LoaderService.hideLoader();
        cb(trackResp);
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(false);
      };

      LoaderService.showLoader();
      var userTrackerPayload = setUserTrackerPayload(isProcessed);
      InvestorService.post({
        child1: 'userBehavior',
        child2: 'addupdate'
      }, userTrackerPayload).$promise.then(success, error);
    }

    function setUserTrackerPayload(isProcessed) {
      var _payload = {
        "trxnRefNo": $stateParams.trackId?$stateParams.trackId:"", //required in case of update
        "trxnType": vm.formData.investmentType, //SIP, PURCHASE
        "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
        "step": "THIRD", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode,
        "folioNo": vm.formData.folioNumber,
        "formData": vm.formData,
        "amount": vm.formData.purchaseAmount,
        "trxnStatus": isProcessed ? "PROCESSED":"OPEN"  // OPEN,PROCESSED
      };

      if (vm.formData.investmentType === 'SIP') {
        _payload.schemeCd = vm.formData.inSchemeCode;
        _payload.formData.schemeCode = vm.formData.inSchemeCode;
        _payload.formData.installmentAmount = vm.formData.amount;
      }

      if (vm.formData.investmentType === 'FLEXSIP') {
        _payload.trxnType = 'SIP';
      }
      return _payload;
    }

    vm.showPurchaseNetBankingModal = function (payload) {
      vm.finalSubmit(payload);
    };

    vm.finalSubmit = function (payload) {
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            //userActivityTracking(true, function(){
              handlePurchaseResponse(resp.data);
            //});

            if(vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
                if(!resp.data.redirectUrl) {
                  $state.go("welcome");
                } else {
                  $window.location.href = resp.data.redirectUrl
                }
            }
          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message,
                isAadhar: true
              });
            } else {
              MessageService.error(resp.message);
            }

          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        if (vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING ) {
          var invType = null;
          if(vm.formData.investmentType == "DREAMSIP"){
            invType = 'dream_sip';
            delete payload.sipTopupEnabled;
            delete payload.topupDetails;
          }else{
            invType = vm.formData.investmentType.toLowerCase();
          }
          TransactionServiceVersion.post({
            controller1: 'transaction',
            controller2: invType,
            controller3: 'approve'
          }, payload).$promise.then(success, error);
        } else {
          var invType = null;
          if(vm.formData.investmentType == "DREAMSIP"){
            invType = 'dream_sip';
            delete payload.sipTopupEnabled;
            delete payload.topupDetails;
          }else{
            invType = vm.formData.investmentType === 'FLEXSIP' ? 'flexSip' :  vm.formData.investmentType.toLowerCase();
          }
          TransactionService.post({
            controller1: 'transaction',
            controller2: invType,
            controller3: 'approve'
          }, payload).$promise.then(success, error);
         }
    };

    vm.cardTypeChanged = function () {
      fetchBankList();
    };

    vm.otherBankSelected = function () {
      vm.bankInfo = null;
    };

    vm.copyPasteHandler = function (e) {
      UtilService.copyPasteHandler(e);
    };

    var stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
      TransactionModel.setPayloadRawData(null);
    });

    $scope.$on('$destroy', function () {
      stateChangeStart();
    })

    function checkOTMAmountAndDate() {

      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      // Check Ammout
      if (vm.formData.purchaseAmount && (vm.formData.purchaseAmount > vm.bankInfo.maxAmount)) {
        vm.isOTMAmount = true;
      } else if (vm.formData.purchaseAmount && (vm.formData.purchaseAmount < vm.bankInfo.maxAmount)){
        vm.isOTMAmount = false;
      }

      if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount > vm.bankInfo.maxAmount)) {
        vm.isOTMAmount = true;
      } else if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount < vm.bankInfo.maxAmount)) {
        vm.isOTMAmount = false;
      }

      //Compare Dates
      if ($window.moment(vm.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment())) {
        vm.isOTMDate = true;
      }
      else {
        vm.isOTMDate = false;
      }
      if (!($window.moment(vm.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.otmList.currentDate, 'DD-MMM-YYYY')))){
        vm.isOTMStartDate = true;
      }
      else{
        vm.isOTMStartDate = false;
      }

      //Check for amount or date
      if (vm.isOTMAmount || vm.isOTMDate) {
        vm.isInvalidForm = true;
      } else {
        vm.isInvalidForm = false;
        //tForm.$invalid
      }
    }

    function selectedUpiBank() {
      if (!vm.bankInfo) {
        return;
      }
      if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
        localStorage.setItem('folioId',vm.formData.folioNumber);
        ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
        vm.bankInfo = null;
        vm.isCheckedDeclaration = false;
        return;
      }
      vm.upiAccountNumber = vm.bankInfo.accountNumber;
      vm.upiBankName = vm.bankInfo.bankName;
      vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
    }

    function verifyUPI() {
      vm.verifyUPIResp = {};
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.verifyUPIResp = resp.data;
            if (resp.data.valid) {
              vm.name = resp.data.name;
              vm.isUPIVerified = true;
            } else {
              vm.isUPIVerified = false;
            }
          }
          else {
            vm.isUPIVerified = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();

      InvestorService.post({
        child1: 'upi',
        child2: 'check',
        child3: 'virtualAddress'
      }, {"virtualAddress": vm.formData.paymentInfo.virtualAddress}).$promise.then(success, error);
    }

    /*
    * Function responsible to manage the broker code for purchase and sip payload
    * */
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = true;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }


    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };

    function getAccountType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.bankTypeList = resp.data.bankAccountTypes;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        $log.info('Account type Errror>>>>', err);
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.formData.investorType
      }).$promise.then(success, error);
    }

    function fetchRTGSBankList() {
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.bankList = resp.data.bankList;
          vm.bankList = vm.bankList.length ? vm.bankList : null;
          if (vm.bankList && vm.bankList.length == 1) {
            vm.bankInfo = vm.bankList[0];
            if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
              localStorage.setItem('folioId',vm.formData.folioNumber);
              ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
              return;
            }
            vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
            vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
            vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
            vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
            vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
            vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
            vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
            vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
            vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
            vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
            vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
            (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
            vm.formData.paymentInfo.bankAcType = vm.bankInfo.bankAcType;
          }
        } else {
          vm.bankList = null;
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.bankList = null;
        UtilService.errorHandler(err);
      };
      var config = {child1: 'bank', child2: 'list'};
      var payload = {
        trnxType: 'PURCHASE',
        folioNumber: (vm.investorInfo && vm.investorInfo.transactionFlowVersion === TrFlowType.NEW) ? vm.formData.folioNumber:null,
        liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false,
        neftFlag: true
      };
      InvestorService.post(config, payload).$promise.then(success, error);
    }

    function changeRtgsPaymentOption() {
      vm.tForm.$setPristine();
      vm.fileType = null;
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankName){
        vm.formData.paymentInfo.bankName = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankBranch){
        vm.formData.paymentInfo.bankBranch = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.accNo){
        vm.formData.paymentInfo.accNo = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankAcType){
        vm.formData.paymentInfo.bankAcType = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyBankAcNo || (vm.formData.paymentInfo.verifyBankAcNo == undefined)){
        vm.formData.paymentInfo.verifyBankAcNo = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.ifscCode || (vm.formData.paymentInfo.ifscCode == undefined)){
        vm.formData.paymentInfo.ifscCode = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.utrNumber){
        vm.formData.paymentInfo.utrNumber = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyUtrNumber || (vm.formData.paymentInfo.verifyUtrNumber == undefined)){
        vm.formData.paymentInfo.verifyUtrNumber = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
        vm.formData.paymentInfo.chequeLeaf = null;
      }
      if (vm.isNewPayment) {
        vm.bankInfo = null;
        vm.isAccTypeFieldDisabled = false;
        resetCheckLeaf();
        if(vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
          vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
        }
      } else {
        // vm.formData.paymentInfo.utrNumber = null;
        // vm.formData.paymentInfo.verifyUtrNumber = null;
        vm.formData.paymentInfo.chequeLeaf = null
        // vm.formData.paymentInfo = null;
        vm.bankChequeLeaf = null;
        vm.bankInfo = null;
      }
    }

    function openUploadedDoc() {
      if(angular.isUndefined(vm.formData.paymentInfo.chequeLeaf)){return;}
        ModalService.showImage({docUrl: vm.formData.paymentInfo.chequeLeaf});
    }

    function bankUploadChequeLeafFile(file) {
      var fi = document.getElementById('uploadCheckLeaf');
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be PDF, TIF, TIFF, JPG and JPEG extension.");
        fi.value = '';
        return;
      }
      if(file) {
        if (fi.files.item(0).size <= 3145728) {
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.bankchequeLeafUrl = resp.data.fileUrl;
              vm.formData.paymentInfo.chequeLeaf = vm.bankchequeLeafUrl;
              vm.fileType = resp.data.type.toLowerCase();
              breakFileUrl(vm.bankchequeLeafUrl);
            }
            else {
              vm.fileType = '';
              MessageService.error(resp.message);
              fi.value = '';
            }
          },
          error = function (err) {
            LoaderService.hideLoader(err);
            fi.value = '';
          };
          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            FileUploadServiceVersion2.post({
              child1: 'folio',
              child2: 'upload',
              child3: 'bankDetails',
              child4: 'chequeLeaf'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 3 MB.")
          fi.value = '';
          if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
            vm.formData.paymentInfo.chequeLeaf = null;
            vm.bankchequeLeafUrl = null;
            vm.fileType = null;
            vm.chooseAFile = true;
          }
        }
      }
    }

    function breakFileUrl(url) {
      vm.bankChequeLeaf = 'Preview Uploaded Leaf Doc';
      vm.fileType = url && url.split('_').reverse()[0].toLowerCase();
      vm.chooseAFile = false;
      vm.formData.paymentInfo.chequeLeaf = url;
      return;
    }

    function resetCheckLeaf() {
      vm.bankchequeLeafUrl = null;
      vm.formData.paymentInfo.chequeLeaf = null;
      vm.bankChequeLeaf = null;
      vm.chooseAFile=true;
      angular.element("#uploadCheckLeaf").val("");
    }

    function downloadPdfFile(url, fileType) {
      var success = function (resp){
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+fileType });
            FileSaver.saveAs(data, 'Cheque_Leaf.'+fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.downloadFile(payload, fileType, url).then(success, error);
    };

    function transactionOtmConfirmation($event) {
      var otpSuccessCallback, otpDismissCallback;

      otpSuccessCallback = function(resp) {
        LoaderService.hideLoader();
        vm.submitForm($event);
      };

      otpDismissCallback = function(err) {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      var modalPayload = {
        folioNumber: vm.formData.folioNumber,
        transactionType: vm.formData.investmentType
      };

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {

            vm.secretLink = resp.data.secretLink;
            var otpDetails = {
              secretOtpLink : vm.secretLink,
              otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
              otpId : resp.data.id
            };

            var payload = {
              folioNumber:  vm.formData.folioNumber,
              formType : vm.formData.investmentType
            }

            if (vm.formData.sipPaymentOption && vm.formData.sipPaymentOption === 'UPI') {
              var noteUpiModal = vm.notesPayment.noteDTO.noteDTOMap.Note_SIP_UPI_2FA;
              payload.paymentOption = 'UAP';
            }

            ModalService.transactionOtpModal({
              otpPayload: otpDetails,
              payload: payload,
              upiModalOtp : noteUpiModal
            }, otpSuccessCallback, otpDismissCallback);
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message)
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      TransactionService.post({
        controller1: 'transaction',
        controller2: 'otp'
      }, modalPayload).$promise.then(success, error);
    }

    function getFormData(form) {
      vm.tForm = form;
    }


  }
})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .factory('ListService', ListService);

    /** @ngInject */
    function ListService() {
        var vm = this;
        var getPayload = function() {
            vm.payload = {
                "searchText": "",
                "sourceType": ["ALL"],
                "transactionNature": "ALL",
                "transactionType": ["ALL"],
                "fromDate": "",
                "toDate": "",
                "fromAmount":null,
                "toAmount":null,
                "pageIndex": 0,
                "pageLimit": 25,
                "transactionStatus": ["PROCESSED"],
                "sortValue": "DESC",
                "sortKey": "transactionDateTime"
            };
            return vm.payload;
        };
        var getSnapshotList = function() {
            vm.snapshotList = {
                "processedCount": "",
                "rejectedCount": "",
                "pendingCount": "",
                "reversedCount":"",
                "scheduledCount":"",
                "canceledScheduleCount":"",
                "expiredScheduleCount":""
            }
            return vm.snapshotList;
        };
        var getTransactionListAction = function() {
            vm.transactionListAction = {
                "PROPOSED": "View Details",
                "PENDING": "Approve",
                "PROCESSED": "View Details",
                "REJECTED": "View Details",
                "REVERSED": "Re-Initiate"
            }
            return vm.transactionListAction;
        };
        return {
            getPayloadLoad: getPayload,
            getSnapshotList: getSnapshotList,
            getTransactionListAction:getTransactionListAction

        };
    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ListController', ListController);

  /** @ngInject */
  function ListController($state,$log, $stateParams, MessageService,InvestorService, TransactionService, $timeout, ModalService, AppConstants, LoaderService, UtilService, moment, ListService, $window,AuthService) {
    var vm = this;
    vm.slideRight = slideRight;
    vm.slideLeft = slideLeft;
    AuthService.checkLinkedUserStatus();
    vm.tooTipLabel = {
      'allCount': 'all count',
      'processedCount': 'Transactions that are completed',
      'rejectedCount': 'Transactions that are not processed',
      'pendingCount': 'Transactions that are under process',
      'reversedCount': 'Transactions that are reversed',
      'scheduledCount': 'Tranactions that are scheduled',
      'canceledScheduleCount': 'Scheduled Transactions that are cancelled',
      'expiredScheduleCount': 'Scheduled Transactions that are expired'
    };
    vm.title = "Select Amount";
    vm.isPagination = false;
    vm.showAmountBox = false;

    vm.currentPageTransactionList = "1";
    vm.pageLimitTransactionList = "25";
    vm.searchText = "";
    vm.isSearching = false;
    vm.dateFilter = {startDate: null, endDate: null};
    vm.selectedTransactionType = "ALL";
    vm.selectedTransactionMode = "ALL";
    vm.pageLimitDropDownList = [25, 50];
    vm.totalTransactionList = 0;
    vm.selectedStatus = "processedCount";
    vm.snapshotList = ListService.getSnapshotList();
    var payload = ListService.getPayloadLoad();
    var recentPayload = {};
    vm.transactionListAction = ListService.getTransactionListAction();
    vm.status = "PROCESSED";
    vm.transactionStatus = "";
    // var sliderWidth = null;
    var sliderRange = {start:1, end:11};

    vm.initTransactionList = function () {
      // payload.pageIndex = vm.currentPageTransactionList - 1;
      transactionSearchAPI(payload);
      $window.document.getElementById('typeSelect').focus();
    };


    vm.activateTab = function (tab) {
      vm.active = {};
      vm.active[tab] = true;
    };

    vm.filterByHeader = function () {
      //resetPayload();
      vm.sortOrder.sortValue = (vm.sortOrder.sortValue == 'ASC') ? 'DESC' : 'ASC';
      payload.sortKey = vm.sortOrder.sortKey;
      payload.sortValue = vm.sortOrder.sortValue;
      transactionSearchAPI(payload);
    };

    vm.pageLimitListChange = function (limit) {
      payload.pageLimit = limit;
      vm.currentPageTransactionList = 1;
      payload.pageIndex = vm.currentPageTransactionList - 1;
      transactionSearchAPI(payload);
      $window.document.getElementById('typeSelect').focus();
    };
    vm.allInit = function () {
      $window.scrollTo(0,0);
      vm.amountLabel = "Select Amount";
      vm.transactionTypeListDropdown = AppConstants.TRANSACTION_LIST_FILTER.LIST_TRANSACTION_TYPE;
      vm.transactionModeListDropdown = AppConstants.TRANSACTION_LIST_FILTER.TRANSACTION_MODE;
      vm.transactionSnapShotList = AppConstants.TRANSACTION_LIST_FILTER.TRANSACTION_STATUSES;

      if ($stateParams.trStatus) {
        // payload.transactionStatus = [];
        vm.selectedStatus = $stateParams.trStatus + 'Count';
        payload.transactionStatus[0] = vm.status = ($stateParams.trStatus.toUpperCase());

        payload.fromDate = ($stateParams.fromDate);
        payload.toDate = ($stateParams.toDate);
        vm.dateFilter.startDate = ($stateParams.fromDate);
        vm.dateFilter.endDate = ($stateParams.toDate);
      }
      transactionSnapshotAPI();
    };

    vm.changeTransationStatus = function (transactionStatus) {
      resetPayload();
      vm.currentPageTransactionList = 1;
      payload.pageIndex = 1;
      vm.pageLimitTransactionList = "25";
      if (!transactionStatus.toLowerCase().includes("schedule") && transactionStatus !== "expiredScheduleCount") {
        vm.status = transactionStatus.split('Count')[0].toUpperCase();
        payload.transactionStatus[0] = vm.status;
        vm.transactionStatus = vm.status;
      } else {
        payload.transactionStatus[0] = vm.transactionSnapShotList[transactionStatus].key;
        vm.transactionStatus = vm.transactionSnapShotList[transactionStatus].key;
        vm.status = vm.transactionStatus;
        payload.sortValue = "ASC";
      }
      payload.searchText = '';
      vm.searchText = '';
      vm.selectedStatus = transactionStatus;
      transactionSnapshotAPI();
    };
    vm.typeChangeDropdown = function (type) {
      payload.transactionType[0] = type;

    };
    vm.modeChangeDropdown = function (mode) {
      payload.transactionNature = mode;

    };
    vm.filterByDate = function (dateFilter) {

      if (dateFilter.startDate && dateFilter.endDate) {
        if (new Date(dateFilter.startDate.toString()) == "Invalid Date") {
          MessageService.error('invalid start date');
        } else if (new Date(dateFilter.endDate.toString()) == "Invalid Date") {
          MessageService.error('invalid end date');
        } else if (+new Date(dateFilter.startDate.toString()) > +new Date(dateFilter.endDate.toString())) {
          MessageService.error('start date should not be greater than end date');
        } else {
          vm.dateFilter.startDate = dateFilter.startDate;
          vm.dateFilter.endDate = dateFilter.endDate;

          formatDate();
        }
      } else {
        vm.dateFilter.startDate = dateFilter.startDate;
        vm.dateFilter.endDate = dateFilter.endDate;
        formatDate();
      }
    };
    vm.localSearch = function () {

      if (vm.isSearching) {
        return;
      }
      else if (vm.searchText.length > 3 || vm.searchText == '') {
        vm.currentPageTransactionList = 1;
        vm.isSearching = true;
        payload.searchText = vm.searchText;
        transactionSearchAPI(payload);
        $timeout(function () {
          vm.isSearching = false;
        }, 300);

      }

    };
    vm.setAmount = function () {
      if (vm.singleAmount!=='' && vm.singleAmount >= 0) {
        payload.toAmount = vm.singleAmount;
        payload.fromAmount = vm.singleAmount;
        vm.title = vm.singleAmount;
      } else if (vm.toAmount && vm.fromAmount) {
        payload.toAmount = vm.toAmount;
        payload.fromAmount = vm.fromAmount;
        vm.title = vm.fromAmount + '-' + vm.toAmount;
      } else {
        vm.title = "Select Amount";
        payload.toAmount = '';
        payload.fromAmount = '';
      }
      if (vm.toAmount && vm.fromAmount) {
        vm.amountLabel = "Change Amount";
      }
      //transactionSearchAPI(payload);
    };
    vm.applyFilter = function () {
      vm.currentPageTransactionList = 1;
      transactionSearchAPI(payload);
    };
    vm.resetFilter = function () {
      resetPayload();
      payload.transactionStatus[0] = vm.status;
      if (vm.status === vm.transactionSnapShotList.scheduledCount.key ||
        vm.status === vm.transactionSnapShotList.canceledScheduleCount.key ||
        vm.status === vm.transactionSnapShotList.expiredScheduleCount.key) {
          payload.sortValue = "ASC";
      }
      transactionSearchAPI(payload);
      vm.title = "Select Amount";
      if($stateParams.trStatus){
        $state.go('main.transactions.all');
      }
    };

    function resetPayload() {
      payload = ListService.getPayloadLoad();
      vm.selectedTransactionType = "ALL";
      vm.selectedTransactionMode = "ALL";
      vm.dateFilter.startDate = null;
      vm.dateFilter.endDate = null;
      vm.singleAmount = null;
      vm.fromAmount = null;
      vm.toAmount = null;
      vm.searchText = "";
      vm.currentPageTransactionList = 1;
      vm.title = "Select Amount";
      payload.toAmount = null;
      payload.fromAmount = null;
      payload.searchText = "";
    }

    function formatDate() {
      payload.fromDate = vm.dateFilter.startDate ? moment(vm.dateFilter.startDate).format('DD-MMM-YYYY').toString() : '';
      payload.toDate = vm.dateFilter.endDate ? moment(vm.dateFilter.endDate).format('DD-MMM-YYYY').toString() : '';
    }

    function transactionSnapshotAPI() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            var snapshotData = resp.data;
            // vm.snapshotList['allCount'] = 0;
            for (var key in snapshotData) {
              if (vm.snapshotList.hasOwnProperty(key) && snapshotData.hasOwnProperty(key)) {
                vm.snapshotList[key] = snapshotData[key];
                // vm.snapshotList['allCount'] = vm.snapshotList['allCount'] + vm.snapshotList[key];
              }
            }
            transactionSearchAPI(payload);
          } else {
            vm.snapshotData = null;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      TransactionService.get({
        controller1: 'transaction',
        controller2: 'snapshot'
      }, {}).$promise.then(success, error);
    }

    function transactionSearchAPI(payload) {
      var success = function (resp) {
        vm.listStatus = resp;
        if (resp.data && resp.status) {
          vm.transactionList = resp.data.transactionList;
          vm.totalTransactionList = resp.data.totalTransactions;
          vm.isPagination = !!(vm.transactionList && vm.transactionList.length);
          vm.snapshotList[vm.selectedStatus] = vm.totalTransactionList;
        } else {
          vm.transactionList = null;
          vm.totalTransactionList = 0;
          vm.response = resp.message;
          vm.isPagination = false;
          vm.snapshotList[vm.selectedStatus] = vm.totalTransactionList;
        }
        LoaderService.hideLoader();
      },
      error = function (err) {
        vm.transactionList = null;
        vm.totalTransactionList = 0;
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        vm.isPagination = false;
      };
      LoaderService.showLoader();
      vm.isLoading = true;
      payload.pageIndex = vm.currentPageTransactionList - 1;
      payload.pageLimit = vm.pageLimitTransactionList;
      TransactionService.post({
        controller1: 'transaction',
        controller2: 'list'
      }, payload).$promise.then(success, error);

    }

    vm.recentInit = function(){
      $window.scrollTo(0,0);
      fetchFolioList();
      vm.slideLeft();
    };

    vm.transactionRecentSearchAPI = function(folioNum, ref) {
      var success = function (resp) {
          vm.listStatus = resp;
          if (resp.data && resp.status) {
            vm.transactionList = resp.data.transactionList;
          } else {
            vm.transactionList = null;
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.transactionList = null;
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      recentPayload.folioNo = folioNum;
      recentPayload.refresh = ref;
      TransactionService.post({
        controller1: 'recent',
        controller2: 'transaction',
        controller3: 'list'
      }, recentPayload).$promise.then(success, error);

    };

    function fetchFolioList() {
      LoaderService.showLoader();
      vm.isLoading = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.folioList = resp.data.folioMap;
            vm.folioCount = vm.folioList.length - 1;
            /*vm.sliderWidth = angular.element(".capsule-box").inner;*/
            if(vm.folioCount>sliderRange.end){
              vm.dynCapsuleboxWidth = vm.folioCount*100;
              // sliderWidth = vm.dynCapsuleboxWidth;
              angular.element(".capsule-box").innerWidth(vm.dynCapsuleboxWidth);
            }
            vm.selectedFolio = (vm.folioList && vm.folioList.length) ? vm.folioList[0] : '';
            if(vm.selectedFolio){
              vm.transactionRecentSearchAPI(vm.selectedFolio, false);
            }
          }
          else {
            vm.folioList = null;
            vm.isLoading = false;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('err ', err);
          vm.isLoading = false;
          MessageService.error();
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      InvestorService.get({
        child1: 'folio',
        child2: 'list'
      }, {}).$promise.then(success, error);

    }

    vm.isDisplayed = function (index) {

      if(parseInt(index)>=sliderRange.start && parseInt(index)<=sliderRange.end){
        return true;
      } else return false;
    };

    vm.getFolioData = function(folioNumber){
      vm.portfolioData = null;
      vm.totalFolioData = 0;
      vm.isPagination = false;
      vm.currentPagePortfolio = 1;
      vm.pageLimitPortfolio = 25;
      vm.selectedFolio = folioNumber ? folioNumber : '';
      if(vm.selectedFolio){
        vm.transactionRecentSearchAPI(vm.selectedFolio, false);
      }
    };

    vm.refresh = function(folioNumber){
      vm.transactionRecentSearchAPI(folioNumber, true);
    };

    function slideRight() {
      if(vm.folioCount>=sliderRange.end) {
        sliderRange.start = sliderRange.start + 11;
        sliderRange.end = sliderRange.end + 11;
        vm.slideLeftDisabled = false;
      }
      if(sliderRange.end>vm.folioCount){
        vm.slideRightDisabled = true;
      }
    }

    function slideLeft() {
      if (sliderRange.start >1) {
        sliderRange.start = sliderRange.start - 11;
        sliderRange.end = sliderRange.end - 11;
        vm.slideRightDisabled = false;
      }
      if(sliderRange.start<=1){
        vm.slideLeftDisabled = true;
      }
    }

    vm.viewSummary = function (profile) {
      var payload = {
        folioNumber: profile.folioNumber,
        uuid: profile.transactionsId
      };
      var success = function () {
        },
        error = function () {
        };
      ModalService.transactionSummaryModal({payload: payload}, success, error);
    };
  }

})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .factory('FavouriteService', FavouriteService);

    /** @ngInject */
    function FavouriteService($window, $q, MessageService, TransactionService, LoaderService, UtilService, $state, ModalService) {
        var module = {
            payload: null,
            setPayload: function(payload) {
                if (payload.transactionType) {
                    module.payload.transactionType = payload.transactionType;
                }
                if (payload.fromDate) {
                    module.payload.fromDate = payload.fromDate;
                }
                if (payload.toDate) {
                    module.payload.toDate = payload.toDate;
                }
            },
            getPayload: function() {

                return module.payload
            },
            resetPayload: function() {
                var payload = {
                    "transactionType": "ALL",
                    "fromDate": "",
                    "toDate": ""
                }
                module.payload = payload;
                return true;
            },
            showMoreFavourite: function(list, limit, staticlimit) {
                var defer = $q.defer();
                var newLimit, showViewMoreFlag;
                newLimit = limit + staticlimit;
                showViewMoreFlag = newLimit < list.length;
                defer.resolve({
                    newLimit: newLimit,
                    flag: showViewMoreFlag
                });

                return defer.promise;

            },
            favouriteListAPI: function(payload) {
                var defer = $q.defer();
                var success = function(resp) {
                        LoaderService.hideLoader();
                        if (resp.status && resp.data) {
                           // MessageService.success(resp.message);
                            defer.resolve(resp.data);
                        } else {
                            // MessageService.error(resp.message);
                            defer.reject();
                        }
                    },
                    error = function(err) {
                        UtilService.errorHandler(err);
                        LoaderService.hideLoader();
                        defer.reject();
                    };
                LoaderService.showLoader();
                TransactionService.post({
                    controller1: 'transaction',
                    controller2: 'favourite',
                    controller3: 'get',
                    controller4: 'all'
                }, payload).$promise.then(success, error);

                return defer.promise;
            },
            deleteFavourite: function(obj,list) {
                var defer = $q.defer();
                var confirmSuccess = function() {
                    deleteFavouriteAPI(obj,list);
                };
                var confirmError = function() {};
                ModalService.confirmCancelModal({ Text: "Are you sure you want to delete the favourite transaction ?" }, confirmSuccess, confirmError);

                function deleteFavouriteAPI(obj, list) {
                    var newList = null;
                    var success = function(resp) {
                           // LoaderService.hideLoader();
                            if (resp.data && resp.status) {
                                var transactionData = resp.data;
                                if (transactionData.trnxActionFlag) {
                                    newList = list.filter(function(el) {
                                        return el.transactionId != obj.transactionId;
                                    });
                                    MessageService.success(transactionData.trnxActionMsg);
                                    defer.resolve(newList);
                                }

                            } else {
                                MessageService.error(resp.message);
                                defer.reject();
                            }

                        },
                        error = function(err) {
                            UtilService.errorHandler(err);
                            //LoaderService.hideLoader();
                            defer.reject();
                        };
                    ///tuid/make
                    TransactionService.get({
                        controller1: 'deleteFavouriteTransaction',
                        controller2: obj.transactionId
                    }).$promise.then(success, error);
                }
                return defer.promise;
            },
            editFavourite: function(obj) {
                var tID = obj.tID;
                var ctID = obj.ctID;
                var tType = obj.tType.toLowerCase().includes("stp") ? 'stp': obj.tType.toLowerCase() === "tip" ? "dtp" : obj.tType.toLowerCase();
                tType = tType === "flex index" ? 'FLEX_INDEX' : tType;
                var state = (tType == "purchase" ? 'purchase' : tType === 'tip' ? 'dtp' : tType);
                state = state === 'FLEX_INDEX' ? 'flexindex' : state;
                if (tType === 'smart swap') {
                  state = 'smartSwap';
                  tType = 'SMART_SWAP';
                } else if (tType === 'flex index') {
                  state = 'flexindex';
                  tType = 'FLEXINDEX';
                }
                $state.go('main.transactions.' + state, { transactionId: tID, transactionType: tType.toUpperCase(), isCompId: !!ctID
                  , isFavourite : true });
            },
            formatDate: function(dateFilter) {
                module.payload.fromDate = dateFilter.startDate ? $window.moment(dateFilter.startDate).format('DD-MMM-YYYY').toString() : '';
                module.payload.toDate = dateFilter.endDate ? $window.moment(dateFilter.endDate).format('DD-MMM-YYYY').toString() : '';
            },
            filterByDate: function(dateFilter) {
                var defer = $q.defer();
                if (dateFilter.startDate && dateFilter.endDate) {
                    if (new Date(dateFilter.startDate.toString()) == "Invalid Date") {
                        MessageService.error('invalid start date');
                    } else if (new Date(dateFilter.endDate.toString()) == "Invalid Date") {
                        MessageService.error('invalid end date');
                    } else if (+new Date(dateFilter.startDate.toString()) > +new Date(dateFilter.endDate.toString())) {
                        MessageService.error('start date should not be greater than end date');
                    } else {
                        module.formatDate(dateFilter);
                        defer.resolve(dateFilter);
                    }
                } else {
                    module.formatDate(dateFilter);
                    defer.reject(dateFilter);
                }
                return defer.promise;
            }
        }
        return {
            setPayload: module.setPayload,
            getPayload: module.getPayload,
            resetPayload: module.resetPayload,
            favouriteListAPI: module.favouriteListAPI,
            editFavourite: module.editFavourite,
            deleteFavourite: module.deleteFavourite,
            showMoreFavourite: module.showMoreFavourite,
            filterByDate: module.filterByDate
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('FavouriteTransactionsController', favouriteTransactionsController);

    /** @ngInject */
    function favouriteTransactionsController(FavouriteService, AppConstants, ModalService, panAadharService , LoaderService,$window,$state) {
        var vm = this;
        var locselectedLinkPanData = sessionStorage.getItem('selectedLinkPanData'); 
        if(locselectedLinkPanData){
            locselectedLinkPanData = $window.CryptoJS.AES.decrypt(locselectedLinkPanData.toString(), 'LinkPanData');
            locselectedLinkPanData = $window.JSON.parse(locselectedLinkPanData.toString($window.CryptoJS.enc.Utf8));
            if(locselectedLinkPanData && !locselectedLinkPanData.default){
                $state.go("welcome");
            }
        }
        var favourite = {
            getFavTrans: getFavTrans,
            payload: null,
            staticLimit: 4
        }
        vm.fav = {
            selectedTransactionType: "ALL",
            favTransList: null,
            limit: favourite.staticLimit,
            showViewMoreFlag: true,
            edit: editFavourite,
            delete: deleteFavourite,
            cart: cart,
            showMore: showMore,
            transactionTypeListDropdown: AppConstants.TRANSACTION_LIST_FILTER.TRANSACTION_TYPE,
            applyFilter: applyFilter,
            resetFilter: resetFilter,
            dateFilter: { startDate: null, endDate: null },
            filterByDate: filterByDate,
            typeChangeDropdown: typeChangeDropdown
        };
        vm.kycVerifiedFlag = true;
        vm.kycMessage = "";
        vm.init = function() {
            FavouriteService.resetPayload();
            favourite.payload = FavouriteService.getPayload();
            favourite.getFavTrans(favourite.payload);
        }

        function resetFilter() {
            vm.fav.selectedTransactionType= "ALL";
            vm.fav.dateFilter= { startDate: null, endDate: null };
            FavouriteService.resetPayload();
            favourite.payload = FavouriteService.getPayload();
            favourite.getFavTrans(favourite.payload);
        }

        function applyFilter() {
            vm.fav.limit = favourite.staticLimit;
            favourite.payload = FavouriteService.getPayload();
            favourite.getFavTrans(favourite.payload);
        }

        function typeChangeDropdown(type) {
             FavouriteService.setPayload({transactionType:type});

        }

        function filterByDate(dateFilter) {
            FavouriteService.filterByDate(dateFilter).then(function(dateFilter) {
                vm.fav.dateFilter.startDate = dateFilter.startDate;
                vm.fav.dateFilter.endDate = dateFilter.endDate;
            }, function() {
                vm.fav.dateFilter.startDate = dateFilter.startDate;
                vm.fav.dateFilter.endDate = dateFilter.endDate;
            });
        }

        function getFavTrans(payload) {
            FavouriteService.favouriteListAPI(payload).then(function(list) {
                vm.fav.showViewMoreFlag = vm.fav.limit === list.result.length ? false : (list.result.length > favourite.staticLimit);
                vm.fav.favTransList = angular.copy(list.result);
                vm.kycVerifiedFlag = list.kycVerifiedFlag;
                vm.kycMessage = list.kycMessage;
            }, function() {
                vm.fav.favTransList = [];

            });
        }

        function editFavourite(obj) {

          var successHandler=function(resp)
          {
            LoaderService.hideLoader();
            if (!vm.kycVerifiedFlag) {
              ModalService.genericModal({
                text: vm.kycMessage
              });
              return;
            }
            if(!obj.validFolio){
              ModalService.genericModal({
                text:obj.folioMsg
              });
              return;
            }
            FavouriteService.editFavourite(obj);
          };
          var errorHandler=function(resp)
          {
            LoaderService.hideLoader();
            return;
          };
          LoaderService.showLoader();
          panAadharService.fetchPanAadharLinkingStatus(null,obj.tFolio).then(successHandler).catch(errorHandler);

        }

        function deleteFavourite(obj) {
            FavouriteService.deleteFavourite(obj, vm.fav.favTransList).then(function(list) {
                vm.fav.favTransList = angular.copy(list);

            }, function() {});

        }

        function showMore() {
            FavouriteService.showMoreFavourite(vm.fav.favTransList, vm.fav.limit, favourite.staticLimit).then(function(obj) {
                vm.fav.limit = obj.newLimit;
                vm.fav.showViewMoreFlag = obj.flag;
            }, function() {});
        }

        function cart() {

        }
    }
})();

/**
 * Created by ttn on 27/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ChangeDividendController', changeDividendController);

  /** @ngInject */
  function changeDividendController(LoaderService, NotificationService, MessageService, ModalService) {
    var vm = this;
    vm.submit = submit;

    function submit(){
      var success= function () {

      },error = function () {

      };
      ModalService.changeDividendModal({},success,error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('UtilityService', utilityService);

  /** @ngInject */
  function utilityService($resource, HDFC_API, TransformResponse) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller/:child/:child1';
    return $resource(_path, {}, {
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('UtilService', utilService);

  /** @ngInject */
  function utilService($timeout, MessageService, $window, AppConstants , LoaderService ,InvestorService , $q, HDFC_API, investorServiceVersion, FormatterService) {
    var c3 = $window.c3 || {};
    var currentFocusedElement = null;
    var sideBarState = AppConstants.INVESTOR_SELECTION.EXISTING_USER;
    var active = {1: true};
    var themeActive = true;
    var isMobileActive;

    var _getUnitSting = function (value) {
      value = value || 0;
      var data = value.toString().split('.')[0];
      var length = data.length;

      if (length >= 4 && length < 6) {
        return 'K';
      } else if (length >= 6 && length < 8) {
        return 'Lacs'
      } else if (length >= 8) {
        return 'Crore'
      } else {
        return ''
      }
    };

    var _getDifferenceInDays = function (timeStamp1, timeStamp2) {
      //Get 1 day in milliseconds
      var one_day = 1000 * 60 * 60 * 24;

      // Calculate the difference in milliseconds
      var difference_ms = timeStamp2 - timeStamp1;

      // Convert back to days and return
      return Math.round(difference_ms / one_day);
    };

    var _getBarChart = function (config) {

      var graphWidth = angular.element(config.bindto).innerWidth();
      graphWidth = graphWidth - 30;
      var containerWidth = angular.element(config.bindto).innerWidth();

      if (containerWidth < 710) {
        config.rotate = 90;
        config.step = 0;
        config.x = -5;
        config.anchor = 'bottom-left';
        config.position = 'outsideGrid';
      }
      else {
        config.rotate = 0;
        config.step = -5;
        config.x = -80;
        config.anchor = 'top-left';
        config.position = 'inset';
      }
      c3.generate({
        bindto: config.bindto,
        size: {
          width: graphWidth
        },
        color: {
          pattern: config.pattern
        },
        legend: {
          show: true,
          position: config.position,
          inset: {
            anchor: config.anchor,
            x: config.x,
            y: -10,
            step: config.step
          },
          item: {
            onclick: function () {
            }
          }
        },
        data: {
          labels: false,
          columns: config.columns,
          type: 'bar',
          empty: {
            label: {
              text: "No Data Available For This FY"
            }
          }
        },
        bar: {
          width: {
            ratio: 0.3
          }
        },
        line: {
          step: {
            type: 'step-after'
          }
        },
        axis: {
          y: {
            label: {
              text: config.yAxis.text,
              position: 'outer-middle'
            },
            tick: {
              format: function (x) {
                if (config.key == 'money') {
                  return '₹ ' + x
                }
                else if (config.key == 'count') {
                  return (parseInt(x) == x) ? x : null;
                }
                else {
                  return x;
                }
              },
              count: config.count,
              values: config.tickValue,
              multiline: false,
              culling: {
                max: 5
              }
            }
          },
          x: {
            label: {
              text: config.xAxis.text,
              position: 'outer-left'
            },
            type: 'category',
            categories: config.categories,
            tick: {
              multiline: false,
              culling: {
                max: 0
              },
              rotate: config.rotate
            }
          }
        }
      });

      switch (config.bindto) {
        case '#investor-overview':
          angular.element(config.bindto).find(".c3-target-Total-Investors .c3-shape.c3-bar").attr("transform", "translate(-10,0)");
          angular.element(config.bindto).find(".c3-target-CGF-Investors .c3-shape.c3-bar").attr("transform", "translate(-5,0)");
          break;
        case '#syatematic-investor-overview':
          angular.element(config.bindto).find(".c3-shapes-Total-SIP .c3-shape.c3-bar").attr("transform", "translate(-10,0)");
          angular.element(config.bindto).find(".c3-shapes-SIP-Expired .c3-shape.c3-bar").attr("transform", "translate(-5,0)");
          break;
        case '#lumpsum-investor-overview':
          angular.element(config.bindto).find(".c3-shapes-Net-Sale-Lumpsum-Investment .c3-shape.c3-bar").attr("transform", "translate(-10,0)");
          angular.element(config.bindto).find(".c3-shapes-Funds-Mature .c3-shape.c3-bar").attr("transform", "translate(-5,0)");
          break;
      }

      if (config.categories.length == 0) {
        angular.element(config.bindto).find(".c3-axis-y .tick").css('display', 'none');
      }
      else {
        var elements = angular.element(config.bindto).find(".c3-axis-y .tick");
        if (config.columns.length > 0) {
          for (var i = 0; i < elements.length; i++) {
            if (!angular.element(elements[i]).find('text tspan').text()) {
              angular.element(elements[i]).css('display', 'none');
            }
          }
        }
      }

    };

    var _getEarnBarChart = function (config) {
      var graphWidth = angular.element(config.bindto).innerWidth();
      graphWidth = graphWidth - 30;
      var containerWidth = angular.element(config.bindto).innerWidth();
      if (containerWidth < 710) {
        config.rotate = 90;
      }
      else {
        config.rotate = 0;
      }
      config.lines = [];

      var earnChart = c3.generate({
        bindto: config.bindto,
        size: {
          width: graphWidth
        },
        legend: {
          show: false,
          inset: {
            anchor: 'top-left',
            x: 10,
            y: 10,
            step: undefined
          },
          item: {
            onclick: function () {
            }
          }
        },
        data: {
          labels: false,
          columns: config.columns,
          type: 'bar',
          empty: {
            label: {
              text: "No Data Available"
            }
          },
          color: function (color, d) {
            return config.pattern[d.index];
          }
        },
        bar: {
          width: {
            ratio: 0.3
          }
        },
        line: {
          step: {
            type: 'step-after'
          }
        },
        axis: {
          y: {
            line: false,
            label: {
              text: config.yAxis.text,
              position: 'outer-middle'
            },
            tick: {
              multiline: false,
              culling: false,
              outer: false
            }
          },
          x: {
            label: {
              text: config.xAxis.text,
              position: 'outer-left'
            },
            type: 'category',
            categories: config.categories,
            tick: {
              multiline: false,
              culling: false,
              outer: false,
              rotate: config.rotate
            }
          }
        }
      });

      angular.element(config.bindto).find(".c3-axis-y").find('path').css({stroke: '#fff'});
      angular.element(config.bindto).find(".c3-axis-y").find('.tick line').css({stroke: '#fff'});
      //angular.element(config.bindto).find(".c3-axis-x").find('path').css ({ stroke: '#fff' });
      angular.element(config.bindto).find(".c3-axis-x").find('.tick line').css({stroke: '#fff'});
      var elements = angular.element(config.bindto).find(".c3-axis-y .tick");
      if (config.columns.length > 0) {
        for (var i = 0; i < elements.length; i++) {
          config.lines.push({value: parseInt(angular.element(elements[i]).find('text tspan').text())});
        }
        $timeout(function () {
          earnChart.ygrids.add(config.lines);
        }, 0);
        angular.element(config.bindto).find(".c3-axis-x").find('path').css({stroke: '#aaa'});
      }
      else {
        angular.element(config.bindto).find(".c3-axis-x").find('path').css({stroke: '#fff'});
        angular.element(config.bindto).find(".c3-axis-y .tick").css('display', 'none');
      }


    };

    var _invesstorGrowthChart = function (config) {
      var graphWidth = angular.element(config.bindto).innerWidth();
      graphWidth = graphWidth - 30;
      var containerWidth = angular.element(config.bindto).innerWidth();
      if (containerWidth < 710) {
        config.rotate = 90;
      }
      else {
        config.rotate = 0;
      }
      config.lines = [];

      var growthChart = c3.generate({
        bindto: config.bindto,
        size: {
          width: graphWidth
        },
        legend: {
          show: false,
          inset: {
            anchor: 'top-left',
            x: 10,
            y: 10,
            step: undefined
          },
          item: {
            onclick: function () {
            }
          }
        },
        data: {
          labels: false,
          columns: config.columns,
          type: 'area',
          empty: {
            label: {
              text: "No Data Available"
            }
          },
          types: {
            EARNING: 'area'
          }
        },
        bar: {
          width: {
            ratio: 0.3
          }
        },
        line: {
          step: {
            type: 'step-after'
          }
        },
        axis: {
          y: {
            line: false,
            label: {
              text: config.yAxis.text,
              position: 'outer-middle'
            },
            tick: {
              multiline: false,
              culling: false,
              outer: false
            }
          },
          x: {
            label: {
              text: config.xAxis.text,
              position: 'outer-left'
            },
            type: 'category',
            categories: config.categories,
            tick: {
              multiline: false,
              culling: false,
              outer: false,
              rotate: config.rotate
            }
          }
        }
      });

      angular.element(config.bindto).find(".c3-axis-y").find('path').css({stroke: '#fff'});
      angular.element(config.bindto).find(".c3-axis-y").find('.tick line').css({stroke: '#fff'});
      //angular.element(config.bindto).find(".c3-axis-x").find('path').css ({ stroke: '#fff' });
      angular.element(config.bindto).find(".c3-axis-x").find('path').css({stroke: '#aaa'});
      angular.element(config.bindto).find(".c3-axis-x").find('.tick line').css({stroke: '#fff'});
      var elements = angular.element(config.bindto).find(".c3-axis-y .tick");

      if (config.columns.length > 0) {
        for (var i = 0; i < elements.length; i++) {
          config.lines.push({value: parseInt(angular.element(elements[i]).find('text tspan').text())});
        }
        $timeout(function () {
          growthChart.ygrids.add(config.lines);
        }, 0);
        angular.element(config.bindto).find(".c3-axis-x").find('path').css({stroke: '#aaa'});
      }
      else {
        angular.element(config.bindto).find(".c3-axis-x").find('path').css({stroke: '#fff'});
        angular.element(config.bindto).find(".c3-axis-y .tick").css('display', 'none');
      }

      // for(var i=0;i<elements.length;i++){
      //   config.lines.push({'value':angular.element(elements[i]).find('text tspan').text()});
      // }
      //
      // $timeout(function () {
      //   growthChart.ygrids.add( config.lines);
      // },0);

    };

    var   _getFilteredList = function (masterList, filterKey, filterValue) {
      if (!masterList || !angular.isArray(masterList)) {
        return null;
      }
      if (!filterKey || !filterValue || !angular.isString(filterKey) || !angular.isString(filterValue)) {
        return angular.copy(masterList);
      }
      var result = masterList.filter(function (item) {
        return (item[filterKey].toLowerCase().indexOf(filterValue.toLowerCase()) > -1);
      });
      return angular.copy(result);
    };

    var _getNumberOfMonths = function (fromDate, toDate) {
      var year1 = fromDate.year();
      var year2 = toDate.year();
      var month1 = fromDate.month();
      var month2 = toDate.month();
      if (month1 === 0) {
        month1++;
        month2++;
      }
      return ((year2 - year1) * 12 + (month2 - month1));
    };

    var _getNumberOfWeeks = function (fromDate, toDate) {
      var timeDiff = toDate.getTime()-fromDate.getTime();
      var daysDiff = timeDiff/(1000*3600*24);
      return Math.floor(daysDiff/7);
    };

    var _errorHandler = function (error) {
      var message = error && (error.data && error.data.message || error.message) || '';
      if (error.status !== 401) {
        MessageService.error(message);
      }
    };

    var _copyPasteHandler = function (e) {

      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : (key === 17);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    };

    var _currentFocusedElement = {
      get : function () {
        return currentFocusedElement;
      },
      set : function (ele) {
        currentFocusedElement = ele;
      },
      clear : function () {
        currentFocusedElement = null;
      }
    };

    var _updateSideBar = function(state) {
      if (state === AppConstants.INVESTOR_SELECTION.EXISTING_USER) {
        sideBarState = AppConstants.INVESTOR_SELECTION.EXISTING_USER;
      } else if (state === AppConstants.INVESTOR_SELECTION.NEW_INVESTOR) {
        sideBarState = AppConstants.INVESTOR_SELECTION.NEW_INVESTOR;
      } else if (state === AppConstants.INVESTOR_SELECTION.QUICK_INVEST) {
        sideBarState = AppConstants.INVESTOR_SELECTION.QUICK_INVEST;
      } else if (state === AppConstants.INVESTOR_SELECTION.NO_SELECTION) {
        sideBarState = AppConstants.INVESTOR_SELECTION.NO_SELECTION;
      } else if (state === AppConstants.INVESTOR_SELECTION.UPDATE_CONTACT_DETAILS) {
        sideBarState = AppConstants.INVESTOR_SELECTION.UPDATE_CONTACT_DETAILS;
      } else if (state === AppConstants.INVESTOR_SELECTION.UPDATE_KYC) {
        sideBarState = AppConstants.INVESTOR_SELECTION.UPDATE_KYC;
      }
    };

    var _getSideBarState = function() {
      return sideBarState;
    };

    var _headerFont = {
      get: function() {
        return active;
      },
      set: function(state) {
        active = {};
        active[state] = true;
      }
    };

    var _darkThemeStatus = {
      get: function() {
        return themeActive;
      },
      set: function(state) {
        themeActive = state;
      }
    };

    var _mobileActiveStatus =  {
      get: function() {
        if (isMobileActive) {
          return isMobileActive;
        } else {
          return $window.sessionStorage.getItem("mobileActive") === "false" ? false : true;
        }
      },
      set: function(status) {
        isMobileActive = status;
      }
    }

    /*
    * fetching dynamic data
    */
    var _fetchDynamicData =  function(pageName) {
      var defer = $q.defer();
      LoaderService.showLoader();
      var successHandler = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          defer.resolve(resp.data);
        } else {
          defer.reject(resp.data);
        }
      };

      var errorHandler = function(resp) {
         LoaderService.hideLoader();
         MessageService.error(resp.message);
      };

      var payload = {
        "pageName": pageName
      };
      var arnHardcodedData = $window.JSON.parse(localStorage.getItem("distributorDetails"));
      if(arnHardcodedData && arnHardcodedData.isHdfcBank){
        payload.hdfcOneClick = true;
      }
      InvestorService.post({
        "child1": "dynamicContent"
      }, payload).$promise.then(successHandler, errorHandler);

      return defer.promise;
    };

    var _addDynamicNotes = function(className, parentNode, child) {
      $timeout(function() {
        var elem = $window.document.getElementsByClassName(className)[parentNode];
        angular.forEach(AppConstants.TPV_NOTES, function(key) {
          var para = $window.document.createElement("p");
          var i = $window.document.createElement("i");
          var span = $window.document.createElement("span");
          i.classList.add("dot");
          span.innerHTML = key.note;
          para.appendChild(i);
          para.appendChild(span);
          para.id = key.id;
          var hasChild = elem.querySelector("#" + key.id) === null;
          if (hasChild) {
              elem.appendChild(para);
//            elem.insertBefore(para, elem.children[child]);
          }
        });
      });
    };

    var _removeDynamicNotes = function() {
      angular.forEach(AppConstants.TPV_NOTES, function(key) {
        $window.document.getElementById(key.id).remove();
      });
    };

    var _expandSideBar = function() {
      var sidebar = angular.element($window.document.getElementById("sidebarContainer"));
      sidebar.removeClass('sidebar-container-width-0');
      sidebar.addClass('collapse in');
      angular.element($window.document.body).addClass('hide-scroll');
    };

    var _getCommaSeperatedString = function(number) {
      if (number) {
        return parseInt(number).toLocaleString("en-IN");
      }
    };

    var _getCommaSeperatedWithFloatValue = function(number,decimal) {
      if (number) {
        var splitPart = number.toString().split('.');
        var commaSepratedPart = parseInt(splitPart[0]);
        var fractionalPart = splitPart[1] ? splitPart[1].slice(0, decimal): '';

        var multiplier = Math.pow(10, decimal);

        if (fractionalPart * 1 === 0) {
          fractionalPart = fractionalPart / multiplier;
        }

        if(fractionalPart) {
          var formattedNumber = commaSepratedPart.toLocaleString("en-IN") + '.' + fractionalPart;
          formattedNumber = formattedNumber.replace(/(\.[0-9]*?)0+$/, '$1');
        } else {
          var formattedNumber = commaSepratedPart.toLocaleString("en-IN");
        }
        return formattedNumber;
      }
    };

    var _amountInComma = function(amount) {
      if (amount) {
        if (amount === "₹") {
          return {
            amount: null,
            amountInComma: null
          }
        } else {
          return {
            amount: parseInt(amount.toString().replaceAll("₹ ", "").replaceAll(",", "")),
            amountInComma: '₹ ' + (parseInt(amount.toString().replaceAll('₹ ', "").replaceAll(",", "")) || '').toLocaleString('en-IN')
          };
        }
      }
    };
    var _checkTxnBlock =  function() {
      var defer = $q.defer();
      LoaderService.showLoader();
      var successHandler = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          defer.resolve(resp.data);
        } else {
          defer.reject(resp.data);
        }
      };

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      InvestorService.get({
        child1 : 'profile',
        child2 : 'check',
        child3 : 'nominee',
        child4 : 'details'
      }).$promise.then(successHandler, errorHandler);

      return defer.promise;
    };

    function _checkForRetirementScheme(schemes) {
      var containRetirementScheme = false;
      var containsRetirementSchemeArr = [];
      schemes.forEach(function(scheme) {
        containsRetirementSchemeArr.push(scheme.retirementFlag);
      });

      containRetirementScheme = containsRetirementSchemeArr.includes(true);

      return containRetirementScheme;
    }


    var _fetchMandateValidations =  function(dataFrom) {
      var defer = $q.defer();
      LoaderService.showLoader();
      var successHandler = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          defer.resolve(resp.data);
        } else {
          defer.reject(resp.data);
        }
      };

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      var payload = {
        name : "SIP"
      }
      if(dataFrom && dataFrom.isFromEcart){
        payload.portal = 'ARN_HARDCODED'
      }
      InvestorService.post({
        child1 : 'app',
        child2 : 'setting',
      },payload).$promise.then(successHandler, errorHandler);

      return defer.promise;
    };

    var _performDataLayerPushEventEcart = function(scheme) {
      var defer = $q.defer();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            var cartItemSchemeNames = [];
            var transactionSuccessSchemeNames = [];

            if (resp.data.cartItems) {
              resp.data.cartItems.forEach(function (el) {
                cartItemSchemeNames.push(el.schemeName)
              });
            }

            transactionSuccessSchemeNames.push(scheme);

            defer.resolve({
              cartItemSchemeNames: cartItemSchemeNames,
              transactionSuccessSchemeNames: transactionSuccessSchemeNames
            });

          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          _errorHandler(err);
          LoaderService.hideLoader();
        };
      investorServiceVersion.get({
        child1: 'cart',
        child2: 'item',
        child3: 'list'
      }).$promise.then(success, error);

      return defer.promise;
    }

    /**
     * Function responsible for setting nominee block transaction flag data for blocking transaction
     * @param {Object} data: folio list data
     */

    var _setBlockTransactionSEBINomination =  function(data) {
      if (data.blockedTrxnPopup) {
        localStorage.setItem('bTransaction', $window.JSON.stringify({
          bTransaction : true,
          bTransactionMessage : data.noNominationMsg,
          bTransactionMessageNomineeHdfcOneClick : data.hdfcOneClickNoNominationPopupMsg
        }));
      }
    }


    var _converter = function(authorizationKey){
      var originalKey = authorizationKey;
      var modifiedKey = originalKey.replace(/_/g, '/').replace(/-/g, '+');
      var crypt = new $window.JSEncrypt();
      crypt.setKey(HDFC_API.HDFC_CONFIG_ENDPOINT);
      return 'Basic'+' '+crypt.decrypt(modifiedKey);
    };

    var _genericConverter = function(value) {
      var modifiedKey = value.replace(/_/g, '/').replace(/-/g, '+');
      return FormatterService.getFormatterHDFC().decrypt(modifiedKey);
    };

    var _getRandomOTPId =  function() {
      var defer = $q.defer();
      LoaderService.showLoader();
      var successHandler = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          defer.resolve(resp.data);
        } else {
          defer.reject(resp.data);
        }
      };

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      InvestorService.get({
        child1 : 'transaction',
        child2 : 'getId'
      }).$promise.then(successHandler, errorHandler);

      return defer.promise;
    };



    return {
      getUnitSting: _getUnitSting,
      getDifferenceInDays: _getDifferenceInDays,
      getBarChart: _getBarChart,
      getEarnBarChart: _getEarnBarChart,
      invesstorGrowthChart: _invesstorGrowthChart,
      getFilteredList: _getFilteredList,
      errorHandler: _errorHandler,
      getNumberOfMonths: _getNumberOfMonths,
      copyPasteHandler: _copyPasteHandler,
      currentFocusedElement : _currentFocusedElement,
      mobileActiveStatus: _mobileActiveStatus,
      updateSideBar: _updateSideBar,
      getSideBarState: _getSideBarState,
      headerFont: _headerFont,
      darkThemeStatus: _darkThemeStatus,
      fetchDynamicData: _fetchDynamicData,
      getNumberOfWeeks:_getNumberOfWeeks,
      addDynamicNotes: _addDynamicNotes,
      removeDynamicNotes: _removeDynamicNotes,
      expandSideBar: _expandSideBar,
      getCommaSeperatedString: _getCommaSeperatedString,
      amountInComma: _amountInComma,
      checkTxnBlock : _checkTxnBlock,
      fetchMandateValidations : _fetchMandateValidations,
      checkForRetirementScheme: _checkForRetirementScheme,
      getCommaSeperatedWithFloatValue: _getCommaSeperatedWithFloatValue,
      setBlockTransactionSEBINomination : _setBlockTransactionSEBINomination,
      converter: _converter,
      performDataLayerPushEventEcart : _performDataLayerPushEventEcart,
      genericConverter : _genericConverter,
      getRandomOTPId: _getRandomOTPId
    }
  }


})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('UserService', userService);

  /** @ngInject */
  function userService($resource, HDFC_API, TransformResponse) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/user/:username/:controller';
    return $resource(_path, {},
      {
        get: {
          method: 'GET',
          params: {},
          transformResponse: TransformResponse.transformApiResponse
        },
        put: {
          method: 'PUT',
          params: {},
          transformResponse: TransformResponse.transformApiResponse
        },
        delete: {
          method: 'DELETE',
          params: {},
          transformResponse: TransformResponse.transformApiResponse
        },
        post: {
          method: 'post',
          params: {},
          transformResponse: TransformResponse.transformApiResponse
        }
      });
  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .factory('TransactionService', transactionService)
        .factory('TransactionArn', transactionArn)
        .factory('NewInvestorTransactionService', newInvestorTransactionService)
        .factory('TransactionServiceVersion', transactionServiceVersion)
        .factory('OtpTransactionService', otpTransactionService);

    /** @ngInject */
    function transactionService($resource, HDFC_API, TransformResponse) {

        var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller1/:controller2/:controller3/:controller4/:controller5';

        return $resource(_path, {}, {
            post: {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                transformResponse: TransformResponse.transformApiResponse
            },
            post2: {
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
                'X-API-VERSION': '2'
              },
              transformResponse: TransformResponse.transformApiResponse
            },
            get: {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json'
                },
                transformResponse: TransformResponse.transformApiResponse
            },
            get2: {
              method: 'get',
              headers: {
                'Content-Type': 'application/json',
                'X-API-VERSION': '2'
              },
              transformResponse: TransformResponse.transformApiResponse
            },
            delete: {
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json'
                },
                transformResponse: TransformResponse.transformApiResponse
            }
        });
    }

    /** @ngInject */
    function transactionServiceVersion($resource, HDFC_API, TransformResponse,$window) {
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller1/:controller2/:controller3/:controller4/:controller5';
      this.arnHardcodedData = $window.JSON.parse(localStorage.getItem("distributorDetails"))
      if(this.arnHardcodedData && this.arnHardcodedData.flowName && this.arnHardcodedData.flowName !== 'E_CART'){
        return $resource(_path, {}, {
          post: {
            method: 'post',
            headers: {
              'TRACKING-ID' : this.arnHardcodedData.chipherText,
              'X-API-VERSION': '3',
              'Content-Type': 'application/json'
            },
            transformResponse: TransformResponse.transformApiResponse
          },
          get: {
            method: 'get',
            headers: {
              'Content-Type': 'application/json'
            },
            transformResponse: TransformResponse.transformApiResponse
          },
          delete: {
            method: 'delete',
            headers: {
              'Content-Type': 'application/json'
            },
            transformResponse: TransformResponse.transformApiResponse
          }
        });
      }
      else{
        return $resource(_path, {}, {
        post: {
          method: 'post',
          headers: {
            'X-API-VERSION': '2',
            'Content-Type': 'application/json'
          },
          transformResponse: TransformResponse.transformApiResponse
        },
        get: {
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          },
          transformResponse: TransformResponse.transformApiResponse
        },
        delete: {
          method: 'delete',
          headers: {
            'Content-Type': 'application/json'
          },
          transformResponse: TransformResponse.transformApiResponse
        }
      });}
    }
     /** @ngInject */
     function newInvestorTransactionService($resource, HDFC_API, TransformResponse) {

      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller1/:controller2/:controller3/:controller4/:controller5';

      return $resource(_path, {}, {
          post: {
              method: 'post',
              headers: {
                  'Content-Type': 'application/json',
                  'X-API-VERSION': '2'
              },
              transformResponse: TransformResponse.transformApiResponse
          },
          get: {
              method: 'get',
              headers: {
                  'Content-Type': 'application/json'
              },
              transformResponse: TransformResponse.transformApiResponse
          },
          delete: {
              method: 'delete',
              headers: {
                  'Content-Type': 'application/json'
              },
              transformResponse: TransformResponse.transformApiResponse
          }
      });
  }

/** @ngInject */
function transactionArn($resource, HDFC_API, TransformResponse, $window) {
  var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller1/:controller2/:controller3/:controller4/:controller5';
  this.arnHardcodedData = $window.JSON.parse(sessionStorage.getItem("distributorDetails"))
  if(this.arnHardcodedData){
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'TRACKING-ID' : this.arnHardcodedData.chipherText,
          'X-API-VERSION': '3',
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      delete: {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }else{
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'X-API-VERSION': '2',
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      delete: {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }
}

  /** @ngInject */
  function otpTransactionService($resource, HDFC_API, TransformResponse) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller1/:controller2/:controller3/:controller4/:controller5/:controller6';
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      delete: {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('JSShare', jsShare);

  /** @ngInject */
  function jsShare($timeout, MessageService, $window, AppConstants, LoaderService, InvestorService, $q) {
    var defaultOptions = {
      type: 'email',
      url: '',
      title: document.title,
      image: '',
      text: '',
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      popup_width: 626,
      popup_height: 436,
      link_telegram: 'https://telegram.me/share/url',
      link_whatsapp: 'https://wa.me/'
    };

    var social = {
      // default handler
      unknown: function (options) {
        return encodeURIComponent(_getURL(options));
      },

      // vk.com - ВКонтакте
      vk: function (options) {
        return 'http://vk.com/share.php'
          + '?url=' + encodeURIComponent(_getURL(options))
          + '&title=' + encodeURIComponent(options.title)
          + '&description=' + encodeURIComponent(options.text)
          + '&image=' + encodeURIComponent(options.image)
          + '&noparse=true';
      },

      // ok.ru - Одноклассники
      ok: function (options) {
        return 'https://connect.ok.ru/offer'
          + '?url=' + encodeURIComponent(_getURL(options))
          + '&title=' + encodeURIComponent(options.title)
          + '&description=' + encodeURIComponent(options.text)
          + '&imageUrl=' + encodeURIComponent(options.image);
      },

      // Facebook
      fb: function (options) {
        return 'https://www.facebook.com/sharer.php'
          + '?u=' + encodeURIComponent(_getURL(options));
      },

      facebook: function (options) {
        return 'https://www.facebook.com/sharer.php'
          + '?u=' + encodeURIComponent(_getURL(options));
      },

      // Google bookmarks
      googlebookmarks: function (options) {
        return 'https://www.google.com/bookmarks/mark'
          + '?op=edit'
          + '&bkmk=' + encodeURIComponent(_getURL(options))
          + '&title=' + encodeURIComponent(options.title)
          + '&annotation=' + encodeURIComponent(options.text)
          + '&labels=';
      },

      // Livejournal
      livejournal: function (options) {
        return 'http://livejournal.com/update.bml'
          + '?subject=' + encodeURIComponent(options.title)
          + '&event=' + encodeURIComponent(options.text + '<br/><a href="' + _getURL(options) + '">' + options.title + '</a>')
          + '&transform=1';
      },

      // Tumblr
      tumblr: function (options) {
        return 'https://www.tumblr.com/widgets/share/tool'
          + '?canonicalUrl=' + encodeURIComponent(_getURL(options))
          + '&title=' + encodeURIComponent(options.title)
          + '&caption=' + encodeURIComponent(options.text)
          + '&tags=';
      },

      // Pinterest
      pinterest: function (options) {
        return 'http://pinterest.com/pin/create/link/'
          + '?url=' + encodeURIComponent(_getURL(options));
      },

      // linkedin
      linkedin: function (options) {
        return 'https://www.linkedin.com/shareArticle'
          + '?mini=true'
          + '&url=' + encodeURIComponent(_getURL(options))
          + '&title=' + encodeURIComponent(options.title)
          + '&summary=' + encodeURIComponent(options.text);
      },

      // Reddit
      reddit: function (options) {
        return 'https://reddit.com/submit'
          + '?url=' + encodeURIComponent(_getURL(options))
          + '&title=' + encodeURIComponent(options.title);
      },

      // Twitter
      twitter: function (options) {
        var url = _getURL(options);
        return 'http://twitter.com/share'
          + '?text=' + encodeURIComponent(options.title)
          + '&url=' + encodeURIComponent(url)
          + '&counturl=' + encodeURIComponent(url);
      },

      // Mail.ru
      mailru: function (options) {
        return 'http://connect.mail.ru/share'
          + '?url=' + encodeURIComponent(_getURL(options))
          + '&title=' + encodeURIComponent(options.title)
          + '&description=' + encodeURIComponent(options.text)
          + '&imageurl=' + encodeURIComponent(options.image);
      },

      // Google+
      googleplus: function (options) {
        return 'https://plus.google.com/share'
          + '?url=' + encodeURIComponent(_getURL(options));
      },

      // Weibo
      weibo: function (options) {
        return 'http://service.weibo.com/share/share.php'
          + '?url=' + encodeURIComponent(_getURL(options))
          + '&title=' + encodeURIComponent(options.title)
          + '&pic=' + encodeURIComponent(options.image);
      },

      // Telegram
      telegram: function (options) {
        return options.link_telegram
          + '?url=' + encodeURIComponent(_getURL(options) + "\n" + options.title);
      },

      // WhatsApp
      whatsapp: function (options) {
        return options.link_whatsapp
          + '?text=' + encodeURIComponent(_getURL(options) + "\n" + options.title);
      },

      // Viber
      viber: function (options) {
        return 'viber://forward'
          + '?text=' + encodeURIComponent(_getURL(options) + "\n" + options.title);
      },

      // Skype
      skype: function (options) {
        return 'https://web.skype.com/share'
          + '?url=' + encodeURIComponent(_getURL(options))
          + '&text=' + encodeURIComponent(options.title);
      },

      // Line.me
      line: function (options) {
        return 'https://lineit.line.me/share/ui'
          + '?url=' + encodeURIComponent(_getURL(options))
          + '&text=' + encodeURIComponent(options.title);
      },

      // E-mail
      email: function (options) {
        return 'mailto:'
          + '?subject=' + encodeURIComponent(options.title)
          + '&body=' + encodeURIComponent(_getURL(options))
          + encodeURIComponent("\n" + options.text);
      }
    };

    function init() {


      function api() {}

      api.options = defaultOptions;
      return api;
    }


    /**
     * Object Extending Functionality
     */
    function _extend(out) {
      out = out || {};
      for (var i = 1; i < arguments.length; i++) {
        if (!arguments[i]) {
          continue;
        }
        for (var key in arguments[i]) {
          if (arguments[i].hasOwnProperty(key)) {
            out[key] = arguments[i][key];
          }
        }
      }
      return out;
    }

    /**
     * Get data-attributes
     */
    function _getData(el, defaultOptions) {
      var data = {};
      for (var key in defaultOptions) {
        if (defaultOptions.hasOwnProperty(key)) {
          var value = el.getAttribute('data-' + key);
          if (value !== null && typeof value != 'undefined') {
            data[key] = value;
          }
        }
      }
      return data;
    }

    /**
     * Open a popup window with sharing info
     * @param url
     * @param _options
     * @returns {Window}
     * @private
     */
    function _popup (url, _options) {
      return window.open(url, '_blank', 'toolbar=0,status=0,scrollbars=1,width=' + _options.popup_width + ',height=' + _options.popup_height);
    }

    /**
     * Get URL for sharing based on options
     * @param options
     * @returns {string | *}
     * @private
     */
    function _getURL(options) {
      if (options.url === '') {
        options.url = location.href;
      }
      var url = options.url;
      var utm = '';
      if (options.utm_source !== '') {
        utm += '&utm_source=' + options.utm_source;
      }
      if (options.utm_medium !== '') {
        utm += '&utm_medium=' + options.utm_medium;
      }
      if (options.utm_campaign !== '') {
        utm += '&utm_campaign=' + options.utm_campaign;
      }
      if (utm !== '') {
        url = url + '?' + utm;
      }
      return url;
    }

    function go(element, options) {
      var withoutPopup = [
        'unknown',
        'viber',
        'telegram',
        'whatsapp',
        'email',
        'skype',
        'line'
      ];
      var tryLocation = true;
      var link;

      options = _extend(
        defaultOptions,
        _getData(element, defaultOptions),
        options
      );

      if (typeof social[options.type] == 'undefined') {
        options.type = 'unknown'
      }

      link = social[options.type](options);

      if (withoutPopup.indexOf(options.type) === -1) {
        tryLocation = _popup(link, options) === null;
      }

      if (tryLocation) {
        if (element.tagName === 'A'
          && element.tagName === 'a') {
          element.setAttribute('href', link);
          return true;
        } else {
          //location.href = link;
          window.open(link, '_blank', 'toolbar=0,status=0,scrollbars=1,width=' + options.popup_width + ',height=' + options.popup_height);
          return false;
        }
      } else {
        return false;
      }
    }

    return {
      go: go
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('SessionOutService', sessionOutService);

  /** @ngInject */
  function sessionOutService($rootScope, $cookies, $state, $log, AppConstants, AuthService, UtilService, $timeout) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var factory = {};
    var removeListeners = {}, isRefreshing = false;

    factory.setListeners = function () {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function (e, response) {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = $cookies.get('token_data');
        var tokenInstant = $cookies.get('token_data_instant');

        if (!token) {
          $state.go('sessionExpired');
          resetFlag();
          return;
        }

        if (!tokenInstant) {
          $state.go('instantLogin');
          resetFlag();
          return;
        }

        try {
          token = angular.fromJson(token);
        } catch (e) {
          $log.info('Json parse exception', e);
          token = '';
        }
        try {
          tokenInstant = angular.fromJson(tokenInstant);
        } catch (e) {
          $log.info('Json parse exception', e);
          tokenInstant = '';
        }

        if (token && token.refresh_token) {
          AuthService.getRefreshToken(token).then(function () {
            if(localStorage.getItem('doLogOut')){
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                $state.go('sessionExpired');
              }, function () {
                $state.go('sessionExpired');
              });
            }else{
              $state.reload();
              resetFlag();
            }
          }, function (err) {
            $state.go('sessionExpired');
            $cookies.remove('token_data');
            UtilService.errorHandler(err);
            resetFlag();
          });
        } else if (tokenInstant && tokenInstant.token) {

          $state.go('instantLogin');
          $cookies.remove('token_data_instant');
          resetFlag();

        } else {
          resetFlag();
          $state.go('sessionExpired');
          $cookies.remove('token_data');
          UtilService.errorHandler(response);
        }


      });

    };

    var resetFlag = function () {
      $timeout(function () {
        isRefreshing = false;
      }, 2000);
    };

    return factory;
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('SchemeService', schemeService);

  /** @ngInject */
  function schemeService($resource, HDFC_API, TransformResponse) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller/:type/:child1/:child2/:child3/:child4';
    return $resource(_path, {}, {
      get: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      },
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .factory('RolloverService', rolloverService);

    /** @ngInject */
    function rolloverService($resource, HDFC_API, TransformResponse) {

        var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller/:type/:child1/:child2/:child3';
        return $resource(_path, {}, {
            post: {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                transformResponse: TransformResponse.transformApiResponse
            },
            get: {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json'
                },
                transformResponse: TransformResponse.transformApiResponse
            }
        });
    }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('TransformResponse', transformResponse);

  /** @ngInject */
  function transformResponse() {
    function IsJsonString(str) {
      try {
        angular.fromJson(str);
      } catch (e) {
        return false;
      }
      return true;
    }
    return {
      transformApiResponse: function (data) {
        if (angular.isString(data) && IsJsonString(data)) {
          return angular.fromJson(data);
        } else {
          return data;
        }
      }
    }
  }

})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('PaymentService', paymentService);

  /** @ngInject */
  function paymentService(AppConstants, HDFC_API, $window) {
    var Razorpay = $window.Razorpay || {};

    function _openRazorPay(data) {
      var authKey, merchantLogoImage;
      if(data) {
        authKey = data.orderResponseDTO.razorPayKeyId;
        merchantLogoImage = AppConstants.RAZORPAY_CRADENTIALS.merchantLogoUrl;
      }

      var razorpay = new Razorpay({
        key: authKey,
        // logo, displayed in the payment processing popup
        image: merchantLogoImage,
        redirect: true
      });

      var payload = {
        callback_url: data.trnxActionMsg ,
        amount: data.orderResponseDTO.amountInPaise, // in currency subunits. Here 1000 = 1000 paise, which equals to ₹10
        currency: data.orderResponseDTO.currency,// Default is INR. We support more than 90 currencies.
        order_id: data.orderResponseDTO.orderId,// Order ID generated in Step 1
        method: data.orderResponseDTO.method,
        bank: data.orderResponseDTO.bankCode,
        email: data.orderResponseDTO.email,
        description: data.orderResponseDTO.description,
        contact: data.orderResponseDTO.contact
      };

      razorpay.createPayment(payload);
    }

    return {
      openRazorPay: _openRazorPay
    }
  }
})();

/*
* Created by TTN at 07-Aug-2020
* */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('panAadharService', panAadharService);

  /** @ngInject */
  function panAadharService($q, $state, MessageService, AppConstants, InvestorService, ModalService, LoaderService) {
    var vm = this;


    function _fetchPanAadharLinkingStatus(pan,folio,hideShowLoader) {
      var defer = $q.defer();
      if (!hideShowLoader) {
        LoaderService.showLoader();
      }
      var successHandler = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.data['popup-enabled']) {
          _showPanAadharLinkingMessage(resp.data.message);
          defer.reject(resp.data);
        } else {
          if(typeof resp.data === 'undefined') {
            MessageService.error(resp.message);
            defer.reject(resp.data);
          }else {
            defer.resolve(resp.data);
          }
        }
      };

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };

      var payload = {
        panNumber : pan ,
        folioNumber : folio
      };

      InvestorService.post({
        child1: 'verifyPanAadharLink'
      }, payload).$promise.then(successHandler, errorHandler);

      /*if (component === AppConstants.KYC_RESTRICTION.FOLIO_CREATION) {
        InvestorService.get({
          "child1": "folio",
          "child2": "create-folio"
        }).$promise.then(successHandler, errorHandler);
      } else if (component === AppConstants.KYC_RESTRICTION.TRANSACTION) {
        InvestorService.get({
          "child1": "folio",
          "child2": "transact-now"
        }).$promise.then(successHandler, errorHandler);
      }*/
      return defer.promise;
    }

    function _showPanAadharLinkingMessage(message) {
      ModalService.genericModal({
        text: message,
        isAadhar: true
      });
    }

    return {
      fetchPanAadharLinkingStatus: _fetchPanAadharLinkingStatus,
      showKycMessage: _showPanAadharLinkingMessage
    }
  }
})();

/**
 * Created by ttn on 27/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('NotificationService', notificationService);

  /** @ngInject */
  function notificationService($resource, HDFC_API, TransformResponse) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/notification/:controller';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('NetcoreEvntService', netcoreEvntService);

  /** @ngInject */
  function netcoreEvntService($timeout, MessageService, $window, AuthService, $log, AppConstants, HDFC_API, UtilService) {
    $window.dataLayer = $window.dataLayer || [];
    var identifierData = function(){ return AuthService.getToken()||{};};
    var instaidentifierData = function(){ return AuthService.getInstaToken()||{};};
    var S = 'Success', F = 'Fail';


    var _Login_Status_IP = function (data, resp) {
      var token = identifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber || data.encryptedPanNumber,
        RESPONSE: resp,
        SOURCE: 'IP',
        LOGIN_TYPE: 'Web',
        event: 'Login_Status_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Login_Status_IP ->',$window.dataLayer.filter(function(row){return row.event=='Login_Status_IP'}));

    };

    var _Login_Status_QI_IP = function (data, resp) {
      var instaToken = instaidentifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: instaToken.investorName,
        PAN_NUMBER: instaToken.encryptedPanNumber,
        RESPONSE: resp,
        SOURCE: 'QI',
        LOGIN_TYPE: 'Web',
        event: 'Login_Status_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Login_Status_IP ->',$window.dataLayer.filter(function(row){return row.event=='Login_Status_IP'}));

    };

    var _Transact_Now_Purchase_IP = function () {
      var token = identifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber,
        SOURCE: 'IP',
        event: 'Transact_Now_Purchase_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Transact_Now_Purchase_IP ->',$window.dataLayer.filter(function(row){return row.event=='Transact_Now_Purchase_IP'}));

    };

    var _Proceed_To_Transact_Purchase_IP = function (data) {
      var token = identifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'Purchase',
        SCHEME_CODE: data.purchaseInSchemeCode,
        SCHEME_NAME: data.purchaseInSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.purchaseAmount,
        TRANS_STATUS: true,
        RESPONSE: 'Success',
        SOURCE: 'IP',
        event: 'Proceed_To_Transact_Purchase_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Proceed_To_Transact_Purchase_IP ->',$window.dataLayer.filter(function(row){return row.event=='Proceed_To_Transact_Purchase_IP'}));

    };

    var _Complete_Transaction_Purchase_IP = function (data, status) {
      var token = identifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'Purchase',
        SCHEME_CODE: data.purchaseInSchemeCode,
        SCHEME_NAME: data.purchaseInSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.purchaseAmount,
        TRANS_STATUS: status? S: F,
        SOURCE: 'IP',
        event: 'Complete_Transaction_Purchase_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Complete_Transaction_Purchase_IP ->',$window.dataLayer.filter(function(row){return row.event=='Complete_Transaction_Purchase_IP'}));

    };

    var _Continue_To_Pay_Purchase_IP = function (data, status) {
      var token = identifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'Purchase',
        SCHEME_CODE: data.purchaseInSchemeCode,
        SCHEME_NAME: data.purchaseInSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.purchaseAmount,
        TRANS_MEDIUM: data.paymentInfo && data.paymentInfo.paymentMode?data.paymentInfo.paymentMode:'',
        TRANS_STATUS: status? S: F,
        SOURCE: 'IP',
        event: 'Continue_To_Pay_Purchase_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Continue_To_Pay_Purchase_IP ->',$window.dataLayer.filter(function(row){return row.event=='Continue_To_Pay_Purchase_IP'}));

    };

    var _Payment_Success_Purchase_IP = function (data, status) {
      var token = identifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber,
        STATUS: status? S: F,
        SOURCE: 'IP',
        event: 'Payment_Success_Purchase_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Payment_Success_Purchase_IP ->',$window.dataLayer.filter(function(row){return row.event=='Payment_Success_Purchase_IP'}));

    };
    var _Transact_Now_SIP_IP = function () {
      var token = identifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber,
        SOURCE: 'IP',
        event: 'Transact_Now_SIP_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Transact_Now_SIP_IP ->',$window.dataLayer.filter(function(row){return row.event=='Transact_Now_SIP_IP'}));

    };
    var _Proceed_To_Transact_SIP_IP = function (data, status) {
      var token = identifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'SIP',
        SCHEME_CODE: data.inSchemeCode,
        SCHEME_NAME: data.inSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.amount,
        TRANS_STATUS: status? S: F,
        MOBILE: data.mobileNumber,
        EMAIL: data.email,
        SOURCE: 'IP',
        event: 'Proceed_To_Transact_SIP_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Proceed_To_Transact_SIP_IP ->',$window.dataLayer.filter(function(row){return row.event=='Proceed_To_Transact_SIP_IP'}));

    };
    var _Complete_Transaction_SIP_IP = function (data, status) {
      var token = identifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'SIP',
        SCHEME_CODE: data.inSchemeCode,
        SCHEME_NAME: data.inSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.amount,
        TRANS_STATUS: status? S: F,
        SOURCE: 'IP',
        event: 'Complete_Transaction_SIP_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Complete_Transaction_SIP_IP ->',$window.dataLayer.filter(function(row){return row.event=='Complete_Transaction_SIP_IP'}));

    };

    var _Review_Purchase_QI = function (data, status) {
      var instaToken = instaidentifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: instaToken.investorName,
        PAN_NUMBER: instaToken.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'Purchase',
        SCHEME_CODE: data.purchaseInSchemeCode,
        SCHEME_NAME: data.purchaseInSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.purchaseAmount,
        TRANS_STATUS: status? S: F,
        // MOBILE: data.mobileNumber,
        // EMAIL: data.email,
        SOURCE: 'QI',
        event: 'Review_Purchase_QI'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Review_Purchase_QI ->',$window.dataLayer.filter(function(row){return row.event=='Review_Purchase_QI'}));

    };
    var _Review_SIP_QI = function (data, status) {
      var instaToken = instaidentifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: instaToken.investorName,
        PAN_NUMBER: instaToken.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'SIP',
        SCHEME_CODE: data.inSchemeCode,
        SCHEME_NAME: data.inSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.amount,
        TRANS_STATUS: status? S: F,
        // MOBILE: data.mobileNumber,
        // EMAIL: data.email,
        SOURCE: 'QI',
        event: 'Review_SIP_QI'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Review_SIP_QI ->',$window.dataLayer.filter(function(row){return row.event=='Review_SIP_QI'}));

    };

    var _Complete_Transaction_Purchase_QI = function (data, status) {
      var instaToken = instaidentifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: instaToken.investorName,
        PAN_NUMBER: instaToken.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'Purchase',
        SCHEME_CODE: data.purchaseInSchemeCode,
        SCHEME_NAME: data.purchaseInSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.purchaseAmount,
        TRANS_STATUS: status? S: F,
        SOURCE: 'QI',
        event: 'Complete_Transaction_Purchase_QI'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Complete_Transaction_Purchase_QI ->',$window.dataLayer.filter(function(row){return row.event=='Complete_Transaction_Purchase_QI'}));

    };
    var _Continue_To_Pay_Purchase_QI = function (data, status) {
      var instaToken = instaidentifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: instaToken.investorName,
        PAN_NUMBER: instaToken.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'Purchase',
        SCHEME_CODE: data.purchaseInSchemeCode,
        SCHEME_NAME: data.purchaseInSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.purchaseAmount,
        TRANS_MEDIUM: data.paymentInfo && data.paymentInfo.paymentMode?data.paymentInfo.paymentMode:'',
        TRANS_STATUS: status? S: F,
        SOURCE: 'QI',
        event: 'Continue_To_Pay_Purchase_QI'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Continue_To_Pay_Purchase_QI ->',$window.dataLayer.filter(function(row){return row.event=='Continue_To_Pay_Purchase_QI'}));

    };
    var _Payment_Success_Purchase_QI = function (data, status) {
      var instaToken = instaidentifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: instaToken.investorName,
        PAN_NUMBER: instaToken.encryptedPanNumber,
        TRANS_STATUS: status? S: F,
        SOURCE: 'QI',
        event: 'Payment_Success_Purchase_QI'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Payment_Success_Purchase_QI ->',$window.dataLayer.filter(function(row){return row.event=='Payment_Success_Purchase_QI'}));

    };

    var _Complete_Transaction_SIP_QI = function (data, status) {
      var instaToken = instaidentifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: instaToken.investorName,
        PAN_NUMBER: instaToken.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'SIP',
        SCHEME_CODE: data.inSchemeCode,
        SCHEME_NAME: data.inSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.amount,
        TRANS_STATUS: status? S: F,
        SOURCE: 'QI',
        event: 'Complete_Transaction_SIP_QI'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Complete_Transaction_SIP_QI ->',$window.dataLayer.filter(function(row){return row.event=='Complete_Transaction_SIP_QI'}));

    };

    var _Complete_Selected_Scheme_Transaction_SIP_IP = function (data) {
      var token = identifierData();
      $window.dataLayer.push({
        details:[{NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANS_TYPE: 'SIP',
        SCHEME_CODE: data.inSchemeCode,
        SCHEME_NAME: data.inSchemeName,
        SOURCE: 'IP'}],
        event: 'Scheme_Selected'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Scheme_Selected ->',$window.dataLayer.filter(function(row){return row.event=='Scheme_Selected'}));

    };

    var _Complete_Selected_Scheme_Transaction_Purchase_IP = function (data) {
      var token = identifierData();
      $window.dataLayer.push({
        details:[{NAME: token.investorFullName,
        PAN_NUMBER: token.encryptedPanNumber,
        FOLIO_NUMBER: data.folioNumber,
        TRANS_TYPE: 'Purchase',
        SCHEME_CODE: data.purchaseInSchemeCode,
        SCHEME_NAME: data.purchaseInSchemeName,
        SOURCE: 'IP'}],
        event: 'Scheme_Selected'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Scheme_Selected ->',$window.dataLayer.filter(function(row){return row.event=='Scheme_Selected'}));

    };


    function getDateFormat() {
      var date = new Date();
      var dateFormat=date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0"+date.getDate()).slice(-2) + " " + ("0"+date.getHours()).slice(-2) + ":" + ("0"+date.getMinutes()).slice(-2) + ":" + ("0"+date.getSeconds()).slice(-2);
      return dateFormat;
    }


    function removePlusSign(mobileNumber) {
      if(!mobileNumber) {
        return '';
      }
      return mobileNumber.replace('+', '');
    }

    function _transaction_Success(event, data) {
      var transactionData = {
        event: event,
        ecommerce: {
          transaction_id: data.transaction_id,
          value: data.value,
          tax: 0,
          currency: "INR",
          userId: data.userId,
          status : data.status,
          transaction_time: data.transaction_time, //yy-mm-dd hh:mm:ss
          transaction_type: data.transaction_type,
          items: data.items
        }
      };
      $window.dataLayer.push(transactionData);
    }

    var _Create_New_Folio = function (data, status) {
      var netcoreDataObj ={};
      netcoreDataObj = {
        PAGE_URL:data.oneclickurl,
        event :"Create New Folio"
      }
      // $window.dataLayer.push(netcoreDataObj);
      // (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Create New Folio ->',$window.dataLayer.filter(function(row){return row.event=='Create New Folio'}));
      return netcoreDataObj;
    }
    var _Lumpsum_Transaction = function (data, status) {
      var netcoreDataObj ={};

      netcoreDataObj = {
        TRANSACTION_TYPE: data.investmentType,
        ARN_NUMBER:data.brokerCode,
        SCHEME_NAME:data.purchaseInSchemeName,
        AMOUNT:data.purchaseAmount,
        PAGE_URL:data.trxnUniqueLink,
        event :"Lumpsum Transaction"
      }
      // $window.dataLayer.push(netcoreDataObj);
      // (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Lumpsum Transaction ->',$window.dataLayer.filter(function(row){return row.event=='Lumpsum Transaction'}));
      return netcoreDataObj;
    }
    var _SIP_Transaction = function (data, status) {
      var netcoreDataObj ={};

      netcoreDataObj = {
        TRANSACTION_TYPE: data.investmentType,
        ARN_NUMBER:data.brokerCode,
        SCHEME_NAME:data.inSchemeName,
        STARTDATE:data.startDate.format("YYYY-MM-DD HH:mm:ss"),
        ENDDATE:data.endDate.format("YYYY-MM-DD HH:mm:ss"),
        PAGE_URL:data.trxnUniqueLink,
        AMOUNT:data.amount,
        event :"SIP Transaction"
      };
      // $window.dataLayer.push(netcoreDataObj);
      // (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for SIP Transaction ->',$window.dataLayer.filter(function(row){return row.event=='SIP Transaction'}));
      return netcoreDataObj;
    }
    var _Lumpsum_Review_Transaction = function (data, status) {
      var netcoreDataObj ={};

      netcoreDataObj = {
        TRANSACTION_TYPE: data.investmentType,
        ARN_NUMBER:data.brokerCode,
        SCHEME_NAME:data.purchaseInSchemeName,
        AMOUNT:data.purchaseAmount,
        PAGE_URL:data.trxnUniqueLink,
        event :"Lumpsum Review Transaction"
      }

      // $window.dataLayer.push(netcoreDataObj);
      // (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Lumpsum Review Transaction ->',$window.dataLayer.filter(function(row){return row.event=='Lumpsum Review Transaction'}));
      return netcoreDataObj;
    }
    var _SIP_Review_Transaction = function (data, status) {
      var netcoreDataObj ={};

      netcoreDataObj = {
        TRANSACTION_TYPE: data.investmentType,
        ARN_NUMBER:data.brokerCode,
        SCHEME_NAME:data.inSchemeName,
        STARTDATE:data.startDate.format("YYYY-MM-DD HH:mm:ss"),
        ENDDATE:data.endDate.format("YYYY-MM-DD HH:mm:ss"),
        PAGE_URL:data.trxnUniqueLink,
        AMOUNT:data.amount,
        event :"SIP Review Transaction"
      }
      // $window.dataLayer.push(netcoreDataObj);
      // (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for SIP Review Transaction ->',$window.dataLayer.filter(function(row){return row.event=='SIP Review Transaction'}));
      return netcoreDataObj;
    }
    var _Lumpsum_Payment_Mode = function (data, status) {
      var netcoreDataObj ={};

      netcoreDataObj = {
        TRANSACTION_TYPE: data.investmentType,
        ARN_NUMBER:data.brokerCode,
        SCHEME_NAME:data.purchaseInSchemeName,
        AMOUNT:data.purchaseAmount,
        PAYMENT_MODE:data.purchasePaymentOption,
        PAGE_URL:data.trxnUniqueLink,
        event :"Lumpsum payment mode"
      }

      // $window.dataLayer.push(netcoreDataObj);
      // (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Lumpsum payment mode ->',$window.dataLayer.filter(function(row){return row.event=='Lumpsum payment mode'}));
      return netcoreDataObj;
    }
    var _SIP_Payment_Mode = function (data, status) {
      var netcoreDataObj ={};

      netcoreDataObj = {
        TRANSACTION_TYPE: data.investmentType,
        ARN_NUMBER:data.brokerCode,
        SCHEME_NAME:data.inSchemeName,
        AMOUNT:data.amount,
        STARTDATE:data.startDate.format("YYYY-MM-DD HH:mm:ss"),
        ENDDATE:data.endDate.format("YYYY-MM-DD HH:mm:ss"),
        PAYMENT_MODE:data.sipPaymentOption,
        INSTALLMENT_FREQUENCY:data.frequency,
        PAGE_URL:data.trxnUniqueLink,
        event :"SIP Payment mode"
      }

      // $window.dataLayer.push(netcoreDataObj);
      // (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for SIP Payment mode ->',$window.dataLayer.filter(function(row){return row.event=='SIP Payment mode'}));
      return netcoreDataObj;
    };

    /*
    * Common event for smartech.
    * Need to trigger before all smartech events.
    * */
    var contact_Event = function () {
      var token = AuthService.getToken();
      $window.smartech('contact', '', {
        'pk^pan_number': token.encryptedPanNumber,
        'email': token.email,
        'mobile': removePlusSign(token.mobile),
        'FIRST_NAME': token.investorFName,
        'LAST_NAME': token.investorLName,
        'INVESTOR_NAME': token.investorFullName
      });
    };

    /*
    * Common event for smartech.
    * Need to trigger before all smartech events.
    * */
    var contact_Event_New = function () {
      var token = AuthService.getToken();
      $window.smartech('contact', '', {
        'pk^pan_number': HDFC_API.ENCRYPTED_IDENTIFIER ? AuthService.encryptRSA(HDFC_API.ENCRYPTED_IDENTIFIER) : token.encryptedPanNumber,
        'email': HDFC_API.INFO_RECEIVE_IDENTIFIER ? HDFC_API.INFO_RECEIVE_IDENTIFIER.concat('@gmail.com') : token.email,
        'mobile': HDFC_API.INV_INFO_RECEIVER ? UtilService.genericConverter(HDFC_API.INV_INFO_RECEIVER) : removePlusSign(token.mobile),
        'INVESTOR_NAME': token.investorFullName
      });
    };

    /*
    * smartech event for login success
    * */
    var _login_Success_Smartech = function (attributes, payload) {
      contact_Event();
      $window.smartech('dispatch', 'Login_success', {});
    };

    var _click_Transact_Purchase = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'click_transact_purchase', {
        'transaction_time': payload.transaction_time, //yy-mm-dd hh:mm:ss
        'transinitiate_date': getDateFormat(),
        'journey_selected': payload.journey,
        'transaction_type': payload.investmentType,
        'deeplink': payload.deeplink,
        'source': 'WEB',
        'added_to_cart': 'N'
      });
    };

    var _scheme_Selected = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'scheme_selected', {
        'transinitiate_date': getDateFormat(),
        'transaction_time': $window.moment().format("YYYY-MM-DD:HH:MM:SS"),
        'journey-selected': payload.journey,
        'deeplink': payload.deeplink,
        'folio_number': payload.folioNumber,
        'scheme_name': payload.purchaseInSchemeName,
        'frequency': payload.frequency,
        'purchase_amount': payload.amount,
        'sip_amount': payload.mixTransactionType && payload.mixTransactionType === "SIPPURCHASE" ? payload.sipDetailsViaPurchase.sipAmount : null,
        'total_amount': payload.mixTransactionType && payload.mixTransactionType === "SIPPURCHASE" ? payload.amount + payload.sipDetailsViaPurchase.sipAmount : payload.amount,
        'sip_end_date': payload.endDate ? payload.endDate.format("YYYY-MM-DD HH:mm:ss") : null,
        'sip_start_date': payload.startDate ? payload.startDate.format("YYYY-MM-DD HH:mm:ss") : null,
        'transaction_type': payload.mixTransactionType && payload.mixTransactionType === "SIPPURCHASE" ? "PURCHASE" : payload.investmentType,
        'source': 'WEB',
        'added_to_cart': 'N'
      });
    };

    var _purchase_Payment_Netbanking = function(payload) {
      contact_Event();
      $window.smartech('dispatch', 'purchase_payment_method_netbanking', {
        'trans_type': payload.investmentType,
        'transinitiate_date': getDateFormat(),
        'folio_number': payload.folioNumber,
        'scheme_name': payload.purchaseInSchemeName,
        'trans_amount': payload.purchaseAmount,
        'deeplink': payload.deeplink
      });
    };

    var _purchase_Payment_UPI = function (payload) {
      contact_Event();
      $window.smartech('dispatch', 'purchase_payment_method_UPI', {
        'trans_type': payload.investmentType,
        'transinitiate_date': getDateFormat(),
        'folio_number':payload.folioNumber,
        'scheme_name':payload.purchaseInSchemeName,
        'trans_amount':payload.purchaseAmount,
        'deeplink': payload.deeplink
      });
    };

    var _click_Transact_Sip = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'click_transact_sip', {
        'transaction_type': payload.investmentType,
        'transinitiate_date': getDateFormat(),
        'transaction_time': $window.moment().format("YYYY-MM-DD:HH:MM:SS"),
        'journey_selected': payload.journey,
        'deeplink': payload.deeplink,
        'source': "WEB"
      });
    };

    var _scheme_Selected_Sip = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'scheme_selected', {
        'transinitiate_date': getDateFormat(),
        'transaction_time': $window.moment().format("YYYY-MM-DD:HH:MM:SS"),
        'journey_selected': payload.journey,
        'deeplink': payload.deeplink,
        'folio_number': payload.folioNumber,
        'scheme_name': payload.inSchemeName,
        'frequency': payload.frequency,
        'amount': payload.amount,
        'sip_end_date': payload.endDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_start_date': payload.startDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_first_installment': payload.sipFirstInstallment ? 'Y' : 'N',
        'transaction_type': payload.investmentType,
        'source': 'WEB',
        'added_to_cart': 'N'
      });

    };

    var _payment_Mode_Selected_Sip = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'Payment Mode Selection', {
        'transinitiate_date': getDateFormat(),
        'transaction_time': $window.moment().format("YYYY-MM-DD:HH:MM:SS"),
        'journey_selected': payload.journey,
        'folio_number': payload.folioNumber,
        'scheme_name': payload.inSchemeName,
        'amount': payload.amount,
        'payment_mode': payload.selectedPaymentOption,
        'frequency': payload.frequency,
        'sip_end_date': $window.moment(payload.endDate).format("YYYY-MM-DD HH:mm:ss"),
        'sip_start_date': $window.moment(payload.startDate).format("YYYY-MM-DD HH:mm:ss"),
        'sip_first_installment': payload.sipFirstInstallment ? 'Y' : 'N',
        'transaction_type': payload.investmentType,
        'total_amount': payload.amount,
        'deeplink': payload.deeplink,
        'source': 'WEB',
        'added_to_cart': 'N'
      });

    };

    var _payment_Mode_Selected_Purchase = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'Payment Mode Selection', {
        'transinitiate_date': getDateFormat(),
        'transaction_time': $window.moment().format("YYYY-MM-DD:HH:MM:SS"),
        'journey_selected': payload.journey,
        'folio_number': payload.folioNumber,
        'scheme_name': payload.purchaseInSchemeName,
        'purchase_amount': payload.purchaseAmount,
        'sip_amount': null,
        'payment_mode': payload.selectedPaymentOption,
        'sip_frequency': payload.frequency,
        'sip_end_date': payload.endDate ? payload.endDate.format("YYYY-MM-DD HH:mm:ss") : null,
        'sip_start_date': payload.startDate ? payload.startDate.format("YYYY-MM-DD HH:mm:ss") : null,
        'transaction_type': payload.investmentType,
        'total_amount': payload.purchaseAmount,
        'deeplink': payload.deeplink,
        'source': 'WEB',
        'added_to_cart': 'N'
      });

    };

    var _payment_Mode_Selected_Mix_Transaction = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'Payment Mode Selection', {
        'transinitiate_date': getDateFormat(),
        'transaction_time': $window.moment().format("YYYY-MM-DD:HH:MM:SS"),
        'journey_selected': payload.journey,
        'folio_number': payload.folioNumber,
        'scheme_name': payload.schemeName,
        'purchase-amount': payload.purchaseAmount,
        'sip_amount': payload.sipAmount,
        'payment_mode': payload.selectedPaymentOption,
        'sip_frequency': payload.frequency,
        'sip_end_date': $window.moment(payload.endDate).format("YYYY-MM-DD HH:mm:ss"),
        'sip_start_date': $window.moment(payload.startDate).format("YYYY-MM-DD HH:mm:ss"),
        'sip_first_installment': 'N',
        'transaction_type': "PURCHASE",
        'total_amount': payload.amount,
        'deeplink': payload.deeplink,
        'source': 'WEB',
        'added_to_cart': 'N'
      });

    };

    var _add_to_cart_event = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'added_to_cart_event', {
        'transinitiate_date': getDateFormat(),
        'transaction_time': $window.moment().format("YYYY-MM-DD:HH:MM:SS"),
        'journey_selected': payload.journey,
        'folio_number': payload.folioNumber,
        'scheme_name': payload.investmentType === "SIP" ? payload.inSchemeName : payload.purchaseInSchemeName,
        'purchase_amount': payload.investmentType === "PURCHASE" ? payload.amount : null,
        'sip_amount': payload.sipViaPurchaseSelected && payload.sipDetailsViaPurchase ? payload.sipDetailsViaPurchase.sipAmount : payload.amount,
        'payment_mode': payload.selectedPaymentOption,
        'sip_frequency': payload.frequency,
        'sip_end_date': payload.endDate ? payload.endDate.format("YYYY-MM-DD HH:mm:ss") : null,
        'sip_start_date': payload.startDate ? payload.startDate.format("YYYY-MM-DD HH:mm:ss") : null,
        'transaction_type': payload.investmentType,
        'total_amount': payload.amount,
        'source': 'WEB',
        'added_to_cart': 'Y'
      });

    };

    var _add_to_cart_event_sip = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'added_to_cart_event', {
        'transinitiate_date': getDateFormat(),
        'transaction_time': $window.moment().format("YYYY-MM-DD:HH:MM:SS"),
        'journey_selected': payload.journey,
        'folio_number': payload.folioNumber,
        'scheme_name': payload.investmentType === "SIP" ? payload.inSchemeName : payload.purchaseInSchemeName,
        'amount': payload.amount,
        'payment_mode': payload.selectedPaymentOption,
        'frequency': payload.frequency,
        'sip_end_date': payload.endDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_start_date': payload.startDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_first_installment': payload.sipFirstInstallment ? 'Y' : 'N',
        'transaction_type': payload.investmentType,
        'source': 'WEB',
        'added_to_cart': 'Y'
      });

    };

    var _add_to_cart_event_mix_transaction = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'added_to_cart_event', {
        'transinitiate_date': getDateFormat(),
        'transaction_time': $window.moment().format("YYYY-MM-DD:HH:MM:SS"),
        'journey_selected': payload.journey,
        'folio_number': payload.folioNumber,
        'scheme_name': payload.purchaseInSchemeName,
        'purchase_amount': payload.amount,
        'sip_amount': payload.sipViaPurchaseSelected && payload.sipDetailsViaPurchase ? payload.sipDetailsViaPurchase.sipAmount : null,
        'payment_mode': payload.selectedPaymentOption,
        'sip_frequency': payload.frequency,
        'sip_end_date': payload.endDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_start_date': payload.startDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_first_installment': 'N',
        'transaction_type': "SIP_PURCHASE",
        'total_amount': payload.totalAmount,
        'deeplink': payload.deeplink,
        'source': 'WEB',
        'added_to_cart': 'Y'
      });

    };

    var _transaction_Status_Event_For_SIP = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'transaction_status_event', {
        'transinitiate_date': payload.transactionDate,
        'transaction_time': payload.transactionInitiatedAt, //yy-mm-dd hh:mm:ss
        'journey_selected': payload.netCoreJourney,
        'folio_number': payload.folioNumber,
        'scheme_name': payload.schemeName,
        'frequency': payload.frequency,
        'payment_mode': payload.paymentMethod,
        'amount': payload.amount,
        'sip_end_date': payload.endDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_start_date': payload.startDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_first_installment': payload.sipWithFirstInstallment ? 'Y' : 'N',
        'transaction_type': payload.transactionType,
        'transaction_status': payload.paymentStatus === true ? "Success" : "Failure",
        'source': 'WEB',
        'added_to_cart': 'N'
      });

    };

    var _transaction_Status_Event_For_Purchase = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'transaction_status_event', {
        'transinitiate_date': payload.transactionDate,
        'transaction_time': payload.transactionInitiatedAt, //yy-mm-dd hh:mm:ss
        'journey_selected': payload.netCoreJourney,
        'folio_number': payload.folioNumber,
        'purchase_amount': payload.amount,
        'scheme_name': payload.schemeName,
        'sip_frequency': payload.transactionType === "SIP" ? payload.frequency : null,
        'payment_mode': payload.paymentMethod,
        'sip_amount': null,
        'sip_start_date': null,
        'sip_end_date': null,
        'total_amount': payload.amount,
        'transaction_type': payload.transactionType,
        'transaction_status': payload.paymentStatus === true ? "Success" : "Failure",
        'source': 'WEB',
        'added_to_cart': 'N'
      });

    };

    var _transaction_Status_Event_For_Mixtrans = function(payload) {
      contact_Event_New();
      $window.smartech('dispatch', 'transaction_status_event', {
        'transinitiate_date': payload.transactionDate,
        'transaction_time': payload.transactionInitiatedAt, //yy-mm-dd hh:mm:ss
        'journey_selected': payload.netCoreJourney,
        'folio_number': payload.folioNumber,
        'purchase_amount': payload.purchaseAmount,
        'scheme_name': payload.schemeName,
        'sip_frequency': payload.frequency,
        'payment_mode': payload.paymentMethod,
        'sip_amount': payload.sipAmount,
        'sip_start_date': payload.startDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_end_date': payload.endDate.format("YYYY-MM-DD HH:mm:ss"),
        'total_amount': payload.totalAmount,
        'transaction_type': payload.transactionType,
        'transaction_status': payload.paymentStatus,
        'source': 'WEB',
        'added_to_cart': 'N'
      });

    };

    function _upi_Transaction_Status(event, data) {
      if(event.toUpperCase() === "SIP") {
        sipTransactionStatusUpi(event, data);
      } else if(event.toUpperCase() === "PURCHASE"){
        purchaseTransactionStatusUpi(event,data);
      } else if (event.toUpperCase() === "SIP_PURCHASE") {
        event = "PURCHASE"
        mixTransactionStatusUpi(event, data);
      }
    }

    function purchaseTransactionStatusUpi(event,data) {
      contact_Event_New();
      $window.smartech('dispatch', 'transaction_status_event', {
        'transinitiate_date': data.transactionDate,
        'transaction_time': data.transactionInitiatedAt, //yy-mm-dd hh:mm:ss
        'journey_selected': data.netCoreJourney,
        'folio_number': data.folioNumber,
        'purchase_amount': data.amount,
        'scheme_name': data.schemeName,
        'sip_frequency': data.transactionType === "SIP" ? data.frequency : null,
        'payment_mode': "UPI",
        'sip_amount': null,
        'sip_start_date': null,
        'sip_end_date': null,
        'total_amount': data.amount,
        'transaction_type': event.toUpperCase(),
        'transaction_status': data.transactionStatus,
        'source': 'WEB',
        'added_to_cart': 'N'
      });
    }

    function mixTransactionStatusUpi(event,data) {
      contact_Event_New();
      $window.smartech('dispatch', 'transaction_status_event', {
        'transinitiate_date': data.transactionDate,
        'transaction_time': data.transactionInitiatedAt, //yy-mm-dd hh:mm:ss
        'journey_selected': data.netCoreJourney,
        'folio_number': data.folioNumber,
        'purchase_amount': data.sipFiAmount,
        'scheme_name': data.schemeName,
        'sip_frequency': data.frequency,
        'payment_mode': "UPI",
        'sip_amount': data.amount,
        'sip_start_date': data.startDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_end_date': data.endDate.format("YYYY-MM-DD HH:mm:ss"),
        'total_amount': data.amount + data.sipFiAmount,
        'transaction_type': event.toUpperCase(),
        'transaction_status': data.transactionStatus,
        'source': 'WEB',
        'added_to_cart': 'N'
      });
    }

    function sipTransactionStatusUpi(event,data) {
      contact_Event_New();
      $window.smartech('dispatch', 'transaction_status_event', {
        'transinitiate_date': data.transactionDate,
        'transaction_time': data.transactionInitiatedAt, //yy-mm-dd hh:mm:ss
        'journey_selected': data.netCoreJourney,
        'folio_number': data.folioNumber,
        'scheme_name': data.schemeName,
        'frequency': data.frequency,
        'payment_mode': "UPI",
        'amount': data.amount,
        'sip_end_date': data.endDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_start_date': data.startDate.format("YYYY-MM-DD HH:mm:ss"),
        'sip_first_installment': data.sipWithFi ? 'Y' : 'N',
        'transaction_type': event.toUpperCase(),
        'transaction_status': data.transactionStatus,
        'source': 'WEB',
        'added_to_cart': 'N'

      });
    }

    var _sip_Transaction_Success_Registration = function(payload, status) {
      contact_Event();
      var data = {
        'transinitiate_date': getDateFormat(),
        'scheme_name': payload.schemeName,
        'folio_number': payload.folioNumber,
        'trans_amount': payload.amount,
        'trans_type': payload.transactionType,
        'transaction_Status': status
      };
      if (status === 'failure') {
        data.deeplink = payload.deeplink;
      }
      $window.smartech('dispatch', 'sip_transaction_success_registration', data);
    };

    var _sip_Payment_Method = function(payload) {
      contact_Event();
      $window.smartech('dispatch', 'sip_payment_method', {
        'transinitiate_date': getDateFormat(),
        'scheme_name': payload.inSchemeName,
        'folio_number': payload.folioNumber,
        'trans_amount': payload.amount,
        'trans_type': payload.investmentType,
        'deeplink': payload.deeplink
      });
    };

    var _COMPLETE_TRANSACTION_CART = function (data) {

      var payload = {
        'event': 'successfulTransaction',
        'itemsLeftInCart': data.cartItemSchemeNames,
        'successfulTransactionSchemeMatches': data.transactionSuccessSchemeNames
      }

      if (data.fromDashboard) {
        payload.event = 'dashboardPageLoaded';
        payload.itemsInCart = data.cartItemSchemeNames;
        delete payload.itemsLeftInCart;
        delete payload.successfulTransactionSchemeMatches;
      }

      $window.dataLayer.push(payload);

      (AppConstants.IS_DEBUGGING) && $log.info('Event Registered for Payment Success ->',$window.dataLayer.filter(function(row){return row.event=='successfulTransaction'}));

    };

    var ack_smart_Client = function(){
      /*netcore script start here*/
      $window.smartech('create', 'ADGMOT35CHFLVDHBJNIG50K96BHPP5I34ISULH5H9GBV9GQN62M0','tin');
      $window.smartech('register', UtilService.genericConverter(HDFC_API.NSI));
      /*netcore script end here*/
    };

    function contact_Event_JSP (data) {
      var token = AuthService.getToken();
      $window.smartech('contact', '', {
        'pk^pan_number': AuthService.encryptRSA(data.panNumber),
        'email': data.email,
        'mobile': removePlusSign(data.mobile),
        'FIRST_NAME': data.name,
        'LAST_NAME': '',
        'INVESTOR_NAME': data.name
      });
    };

    var _dispatch_smartech = function(payload) {
      $window.smartech('dispatch', 'purchase_transaction_success', {
        'trans_type': 'Purchase',
        'transinitiate_date': getDateFormat(),
        'folio_number': payload.folioNumber,
        'Scheme_name': payload.schemeName,
        'trans_amount': payload.amount,
        'Transaction_status': payload.paymentStatus === true ? 'Success':'Failure',
      });
    };

    function eventify(arr, callback) {
      arr.push = function (e) {
        Array.prototype.push.call(arr, e);
        callback(arr);
      };
    }

    function performEventify() {
      eventify(dataLayer, function (updatedArr) {
        var obj = dataLayer[dataLayer.length - 1];
        _mtm.push(obj);
      });
    }

    function _ack_purchase_Netbanking_transaction_Failure(event, data) {
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name,
              'item_category3': AuthService.encryptRSA(data.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleTransactionData(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleTransactionData(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleTransactionData(event,allItems,data);
      }
    }

    function handleTransactionData(event,allItems,data) {
      var transactionData = {
        event: 'purchase',
        ecommerce: {
          transaction_id: data.transactionId,
          value: data.totalAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'failure',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTime, //yy-mm-dd hh:mm:ss
          transaction_type: 'Purchase',
          items: allItems
        }
      };
        $window.dataLayer.push(transactionData);
        performEventify();
        (AppConstants.IS_DEBUGGING) && $log.info('purchase Netbanking transaction Failure ->',$window.dataLayer.filter(function(row){return row.event=='purchase Netbanking transaction Failure'}));
    }


    var _ack_adobe_script = function(data){
      var adobeScript = $window.adobe || {};
      adobeScript.target.trackEvent({
        "mbox": "orderConfirmPage",
        "params":
          {
            "orderId": data.cartId,
            "orderTotal": data.totalAmount,
            "productPurchasedId": data.commaSeparatedSchemeCodes
          }
      });
    }


    function _ack_purchase_Netbanking_transaction_Success(event, data) {
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name,
              'item_category3': AuthService.encryptRSA(data.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleTransactionDataNetbanking(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleTransactionDataNetbanking(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleTransactionDataNetbanking(event,allItems,data);
      }
    }

    function handleTransactionDataNetbanking(event,allItems,data) {
      var transactionData = {
        event: 'purchase',
        ecommerce: {
          transaction_id: data.transactionId,
          value: data.totalAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'success',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTime, //yy-mm-dd hh:mm:ss
          transaction_type: 'Purchase',
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('Upi waiting page ->',$window.dataLayer.filter(function(row){return row.event=='Upi waiting page'}));
    }

    function _ack_Successfull_SIP_FI_Netbanking (event,data){
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name,
              'item_category3': AuthService.encryptRSA(data.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleTransactionDataSIPFI(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleTransactionDataSIPFI(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleTransactionDataSIPFI(event,allItems,data);
      }
    }

    function handleTransactionDataSIPFI(event,allItems,data) {
      var transactionData = {
        event: 'SIP With First Installment',
        ecommerce: {
          transaction_id: data.srn,
          value: data.totalAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'success',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTime, //yy-mm-dd hh:mm:ss
          transaction_type: 'SIP With First Installment',
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('purchase Netbanking transaction Success ->',$window.dataLayer.filter(function(row){return row.event=='purchase Netbanking transaction Success'}));
    }

    var _Sip_FI_dispatch_smartech = function(payload) {
      $window.smartech('dispatch', 'sip_transaction_success_first_installment', {
        'trans_type': 'SIP',
        'transinitiate_date': getDateFormat(),
        'folio_number': payload.folioNumber,
        'Scheme_name': payload.cartItems && payload.cartItems[0].schemeName,
        'trans_amount': payload.cartItems && payload.cartItems[0].amount,
        'Transaction_status': payload.paymentStatus === true ? 'Success':'Failure',
      });
    };

    function _ack_Failure_SIP_FI_SIP (event,data){
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name,
              'item_category3': AuthService.encryptRSA(data.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleTransactionDataFailureSIPFI(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleTransactionDataFailureSIPFI(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleTransactionDataFailureSIPFI(event,allItems,data);
      }
    }

    function handleTransactionDataFailureSIPFI(event,allItems,data) {
      var transactionData = {
        event: 'SIP With First Installment',
        ecommerce: {
          transaction_id: event === 'SIP'? data.srn: data.srnNumber? data.srnNumber: data.transactionId,
          value: data.totalAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'failure',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTime, //yy-mm-dd hh:mm:ss
          transaction_type: 'SIP With First Installment',
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('ack_Failure_SIP_FI_Netbanking ->',$window.dataLayer.filter(function(row){return row.event=='purchase Netbanking transaction Failure'}));
    }

    var _ack_pending_razorPay_failure = function(event,data){
      var transactionData = {
        'event': 'purchaseEvent',
        'statusCode': '' , //blank should pass
        'transactionId': event ? data.srn: data.transactionId,
        'transactionTotal': data.totalAmount ,
        'transactionTax': '',
        'userId': data.investorId
      }
      $window.dataLayer.push(transactionData);
      performEventify();
    }

    var _Complete_Transaction_SIP_Pending = function (data, status) {
      var token = identifierData();
      $window.dataLayer.push({
        INVESTOR_NAME: data.name,
        PAN_NUMBER: AuthService.encryptRSA(data.panNumber),
        FOLIO_NUMBER: data.folioNumber,
        TRANSREF_NUMBER: data.trackId,
        TRANS_TYPE: 'Purchase',
        SCHEME_CODE: data.inSchemeCode,
        SCHEME_NAME: data.inSchemeName,
        TRANSUNIQUE_LINK: '',
        TRANSINITIATE_DATE: getDateFormat(),
        TRANS_AMOUNT: data.amount,
        TRANS_STATUS: data.paymentStatus === true ? 'Success':'Failure',
        event: 'Payment_Success_Purchase_IP'
      });
      (AppConstants.IS_DEBUGGING) && $log.info('Event Registred for Payment_Success_Purchase_IP ->',$window.dataLayer.filter(function(row){return row.event=='Payment_Success_Purchase_IP'}));

    };


    function _ack_Failure_Emandate (event,data){
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name,
              'item_category3': AuthService.encryptRSA(data.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleTransactionEmandateFailure(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleTransactionEmandateFailure(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleTransactionEmandateFailure(event,allItems,data);
      }
    }

    function handleTransactionEmandateFailure(event,allItems,data) {
      var transactionData = {
        event: 'SIP',
        ecommerce: {
          transaction_id: event === 'SIP'? data.srn: data.srnNumber? data.srnNumber: data.transactionId,
          value: data.totalAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'failure',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTime, //yy-mm-dd hh:mm:ss
          transaction_type: 'SIP',
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('ack_Failure_Emandate ->',$window.dataLayer.filter(function(row){return row.event=='ack_Failure_Emandate'}));
    }


    function _ack_Success_Emandate (event,data){
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name,
              'item_category3': AuthService.encryptRSA(data.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleTransactionEmandateSuccess(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleTransactionEmandateSuccess(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleTransactionEmandateSuccess(event,allItems,data);
      }
    }

    function handleTransactionEmandateSuccess(event,allItems,data) {
      var transactionData = {
        event: 'SIP',
        ecommerce: {
          transaction_id: event === 'SIP'? data.srn: data.srnNumber? data.srnNumber: data.transactionId,
          value: data.totalAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'success',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTime, //yy-mm-dd hh:mm:ss
          transaction_type: 'SIP',
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('ack_Success_Emandate ->',$window.dataLayer.filter(function(row){return row.event=='ack_Success_Emandate'}));
    }

    var _ack_Purchase_upi_Payment = function(payload) {
      $window.smartech('dispatch', 'purchase_transaction_success', {
        'trans_type': 'Purchase',
        'transinitiate_date': getDateFormat(),
        'folio_number': payload.folioNumber,
        'Scheme_name': payload.schemeName,
        'trans_amount': payload.amount,
        'Transaction_status': payload.paymentStatus,
      });
    };

    function _ack_Purchase_upi_success(event, data) {
      var token = AuthService.getToken();
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name,
              'item_category3': AuthService.encryptRSA(item.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleTransactionDataUpiSuccess(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleTransactionDataUpiSuccess(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleTransactionDataUpiSuccess(event,allItems,data);
      }
    }

    function handleTransactionDataUpiSuccess(event,allItems,data) {
      var transactionData = {
        event: 'purchase',
        ecommerce: {
          transaction_id: event === 'SIP'? data.srn: data.srnNumber? data.srnNumber: data.transactionId,
          value: data.totalAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'success',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTimeNetCore, //yy-mm-dd hh:mm:ss
          transaction_type: 'Purchase',
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('Upi waiting page ->',$window.dataLayer.filter(function(row){return row.event=='Upi waiting page'}));
    }

    function _ack_Purchase_upi_waiting(event, data) {
      var token = AuthService.getToken();
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name? data.name: data.investorName,
              'item_category3': AuthService.encryptRSA(item.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleTransactionDataUpiWaiting(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleTransactionDataUpiWaiting(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name? data.name: data.investorName,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleTransactionDataUpiWaiting(event,allItems,data);
      }
    }

    function handleTransactionDataUpiWaiting(event,allItems,data) {
      var transactionData = {
        event: 'purchase',
        ecommerce: {
          transaction_id: event === 'SIP'? data.srn: data.srnNumber? data.srnNumber: data.transactionId,
          value: data.totalAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'waiting',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTime, //yy-mm-dd hh:mm:ss
          transaction_type: 'Purchase',
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('Upi waiting page ->',$window.dataLayer.filter(function(row){return row.event=='Upi waiting page'}));
    }


    function _ack_Purchase_upi_fail(event, data) {
      var token = AuthService.getToken();
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name? data.name: data.investorName,
              'item_category3': AuthService.encryptRSA(item.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleTransactionDataUpiFail(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleTransactionDataUpiFail(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name? data.name: data.investorName,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleTransactionDataUpiFail(event,allItems,data);
      }
    }

    function handleTransactionDataUpiFail(event,allItems,data) {
      var transactionData = {
        event: 'purchase',
        ecommerce: {
          transaction_id: event === 'SIP'? data.srn: data.srnNumber? data.srnNumber: data.transactionId,
          value: data.amount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'failure',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTimeNetCore, //yy-mm-dd hh:mm:ss
          transaction_type: 'Purchase',
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('Upi waiting page ->',$window.dataLayer.filter(function(row){return row.event=='Upi waiting page'}));
    }

    function _ack_SIP_AutoPay_Successfull (event,data){
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name? data.name: data.investorName,
              'item_category3': AuthService.encryptRSA(data.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleDataSIPAutoPaySuccessfull(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleDataSIPAutoPaySuccessfull(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name? data.name: data.investorName,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleDataSIPAutoPaySuccessfull(event,allItems,data);
      }
    }

    function handleDataSIPAutoPaySuccessfull(event,allItems,data) {
      var transactionData = {
        event: event,
        ecommerce: {
          transaction_id: data.srnNumber,
          value: data.totalAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'success',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTimeNetCore, //yy-mm-dd hh:mm:ss
          transaction_type: event,
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('_ack_SIP_AutoPay_Successfull ->',$window.dataLayer.filter(function(row){return row.event=='_ack_SIP_AutoPay_Successfull'}));
    }

    function _ack_SIPFI_AutoPay_Failed (event, data){
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name? data.name: data.investorName,
              'item_category3': AuthService.encryptRSA(data.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleDataSIPAutoPayFailed(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleDataSIPAutoPayFailed(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name? data.name: data.investorName,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleDataSIPAutoPayFailed(event,allItems,data);
      }
    }

    function handleDataSIPAutoPayFailed(event,allItems,data) {
      var transactionData = {
        event: event,
        ecommerce: {
          transaction_id:  data.srnNumber,
          value: data.totalAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'failure',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTimeNetCore, //yy-mm-dd hh:mm:ss
          transaction_type: event,
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('ack SIP or SIP With FI AutoPay failure ->',$window.dataLayer.filter(function(row){return row.event=='ack SIP or SIP With FI AutoPay failure '}));
    }

    function _ack_SIP_AutoPay_waiting(event, data) {
      var token = AuthService.getToken();
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name? data.name: data.investorName,
              'item_category3': AuthService.encryptRSA(item.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              event = 'SIP'
              handleTransactionDataUpiSipWaiting(event, allItems, data);
            }
            if(item.purchaseOpted) {
              event = 'Purchase'
              handleTransactionDataUpiSipWaiting(event, allItems, data);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name? data.name: data.investorName,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleTransactionDataUpiSipWaiting(event,allItems,data);
      }
    }

    function handleTransactionDataUpiSipWaiting(event,allItems,data) {
      var transactionData = {
        event: event,
        ecommerce: {
          transaction_id: data.srnNumber,
          value: data.amount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: 'waiting',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTime, //yy-mm-dd hh:mm:ss
          transaction_type: event,
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('Upi waiting page ->',$window.dataLayer.filter(function(row){return row.event=='Upi waiting page'}));
    }


    // Mix Transaction SIP+PURCHASE

    function _ack_Mix_transaction_Success(event, data) {
      var allItems = [];
      if(data.cartItems) {
        var cartItems = data.cartItems;
        cartItems.forEach(function (item) {
            var object = {
              'item_id': item.folioNumber,
              'item_name': item.schemeName,
              'item_category': item.schemeCode,
              'item_category2': data.name? data.name: data.investorName,
              'item_category3': AuthService.encryptRSA(data.panNumber),
              'price': item.amount,
              'quantity': 'N/A'
            };
            allItems.push(object);
            if(item.sipOpted) {
              var isSuccessOrFail = false;
              event = 'SIP'
              if(item.sipPaymentStatus === 'Successful') {
                isSuccessOrFail = true;
              }
              handleMixTransactionData(event, allItems, data, isSuccessOrFail);
            }
            if(item.purchaseOpted) {
              var isSuccessOrFail = false;
              event = 'purchase'
              if(item.purchasePaymentStatus === 'Successful') {
                isSuccessOrFail = true;
              }
              handleMixTransactionData(event, allItems, data, isSuccessOrFail);
            }
          }
        );
      } else {
        var object = {
          'item_id': data.folioNumber,
          'item_name': data.schemeName,
          'item_category': data.schemeCode,
          'item_category2': data.name? data.name: data.investorName,
          'item_category3': AuthService.encryptRSA(data.panNumber),
          'price': data.amount,
          'quantity': 'N/A'
        };
        allItems.push(object);
        handleMixTransactionData(event,allItems,data);
      }
    }

    function handleMixTransactionData(event,allItems,data, isSuccessOrFail) {
      var transactionData = {
        event: event,
        ecommerce: {
          transaction_id: data.transactionId,
          value: event ==='purchase'?data.totalAmount: data.totalInstallmentAmount,
          tax: 0,
          currency: "INR",
          userId: data.investorId,
          status: isSuccessOrFail? 'success':'failure',
          transaction_time: data.transactionDate ? data.transactionDate : data.transactionDateTime, //yy-mm-dd hh:mm:ss
          transaction_type: event,
          items: allItems
        }
      };
      $window.dataLayer.push(transactionData);
      performEventify();
      (AppConstants.IS_DEBUGGING) && $log.info('Mix Transaction page ->',$window.dataLayer.filter(function(row){return row.event=='Mix Transaction page'}));
    }

    var _Mobile_Login = function (data, status) {
      var netcoreDataObj ={};
      netcoreDataObj = {
        Investor_name: data.investorFullName,
        Mobile:HDFC_API.INV_INFO_RECEIVER ? UtilService.genericConverter(HDFC_API.INV_INFO_RECEIVER) : data.mobile,
        Email:HDFC_API.INFO_RECEIVE_IDENTIFIER ? HDFC_API.INFO_RECEIVE_IDENTIFIER.concat('@gmail.com') : data.email,
        PAN:data.encryptedPanNumber,
        event :"Mobile_login_success"
      }
      return netcoreDataObj;
    }

    return {
      Login_Status_IP: _Login_Status_IP,
      Login_Status_QI_IP: _Login_Status_QI_IP,
      Transact_Now_Purchase_IP: _Transact_Now_Purchase_IP,
      Proceed_To_Transact_Purchase_IP: _Proceed_To_Transact_Purchase_IP,
      Complete_Transaction_Purchase_IP: _Complete_Transaction_Purchase_IP,
      Continue_To_Pay_Purchase_IP: _Continue_To_Pay_Purchase_IP,
      Payment_Success_Purchase_IP: _Payment_Success_Purchase_IP,
      Transact_Now_SIP_IP: _Transact_Now_SIP_IP,
      Proceed_To_Transact_SIP_IP: _Proceed_To_Transact_SIP_IP,
      Complete_Transaction_SIP_IP: _Complete_Transaction_SIP_IP,
      Review_Purchase_QI: _Review_Purchase_QI,
      Review_SIP_QI: _Review_SIP_QI,
      Continue_To_Pay_Purchase_QI: _Continue_To_Pay_Purchase_QI,
      Complete_Transaction_Purchase_QI: _Complete_Transaction_Purchase_QI,
      Payment_Success_Purchase_QI: _Payment_Success_Purchase_QI,
      Complete_Transaction_SIP_QI: _Complete_Transaction_SIP_QI,
      Complete_Selected_Scheme_Purchase_IP:_Complete_Selected_Scheme_Transaction_Purchase_IP,
      Complete_Selected_Scheme_SIP_IP:_Complete_Selected_Scheme_Transaction_SIP_IP,
      Transaction_Success: _transaction_Success,
      Lumpsum_Transaction:_Lumpsum_Transaction,
      SIP_Transaction:_SIP_Transaction,
      Create_New_Folio:_Create_New_Folio,
      Lumpsum_Review_Transaction:_Lumpsum_Review_Transaction,
      SIP_Review_Transaction:_SIP_Review_Transaction,
      Lumpsum_Payment_Mode:_Lumpsum_Payment_Mode,
      SIP_Payment_Mode:_SIP_Payment_Mode,
      login_Success_Smartech: _login_Success_Smartech, // new events added
      /*purchase events*/
      contact_Event: contact_Event,
      click_Transact_Purchase: _click_Transact_Purchase,
      scheme_Selected: _scheme_Selected,
      purchase_Payment_Netbanking: _purchase_Payment_Netbanking,
      purchase_Payment_UPI: _purchase_Payment_UPI,
      /*SIP events*/
      click_Transact_Sip: _click_Transact_Sip,
      scheme_Selected_Sip: _scheme_Selected_Sip,
      sip_Transaction_Success_Registration: _sip_Transaction_Success_Registration,
      sip_Payment_Method: _sip_Payment_Method,
      COMPLETE_TRANSACTION_CART : _COMPLETE_TRANSACTION_CART,
      Mobile_Login:_Mobile_Login,
      payment_Mode_Selected_Sip: _payment_Mode_Selected_Sip,
      payment_Mode_Selected_Purchase: _payment_Mode_Selected_Purchase,
      payment_Mode_Selected_Mix_Transaction: _payment_Mode_Selected_Mix_Transaction,
      add_to_cart_event: _add_to_cart_event,
      add_to_cart_event_mix_transaction: _add_to_cart_event_mix_transaction,
      add_to_cart_event_sip: _add_to_cart_event_sip,
      transaction_Status_Event_For_SIP: _transaction_Status_Event_For_SIP,
      transaction_Status_Event_For_Purchase: _transaction_Status_Event_For_Purchase,
      upi_Transaction_Status: _upi_Transaction_Status,
      transaction_Status_Event_For_Mixtrans: _transaction_Status_Event_For_Mixtrans,

      //purchase netBanking failure
      ack_smart_Client: ack_smart_Client,
      contact_Event_JSP: contact_Event_JSP,
      dispatch_smartech: _dispatch_smartech,
      ack_purchase_Netbanking_transaction_Failure: _ack_purchase_Netbanking_transaction_Failure,

      //purchase netBanking success
      ack_adobe_script: _ack_adobe_script,
      ack_purchase_Netbanking_transaction_Success: _ack_purchase_Netbanking_transaction_Success,
      ack_Successfull_SIP_FI_Netbanking: _ack_Successfull_SIP_FI_Netbanking,


      //
      Sip_FI_dispatch_smartech: _Sip_FI_dispatch_smartech,

      ack_Failure_SIP_FI_SIP: _ack_Failure_SIP_FI_SIP,

      //Pending | For SIP FI Transaction, when no status code is recieved for Razorpay Gateway
      ack_pending_razorPay_failure: _ack_pending_razorPay_failure,
      Complete_Transaction_SIP_Pending: _Complete_Transaction_SIP_Pending,

      //SIP - Failure of Emandate
      ack_Failure_Emandate: _ack_Failure_Emandate,

      //Failue of Emandate - SIP FI Transaction
      //call-> _ack_Failure_SIP_FI_SIP

      //SIP FI- Emandate Success
      //call -> _ack_Successfull_SIP_FI_Netbanking

      //SIP - Emandate Success
      ack_Success_Emandate: _ack_Success_Emandate,

      // Purchase UPI

      //call -> _dispatch_smartech
      ack_Purchase_upi_success: _ack_Purchase_upi_success,
      ack_Purchase_upi_fail: _ack_Purchase_upi_fail,
      ack_Purchase_upi_waiting: _ack_Purchase_upi_waiting,

      //Purchase UPI Expired Page
      //call -> _dispatch_smartech

      //SIP UPI AutoPay success
      ack_SIP_AutoPay_Successfull: _ack_SIP_AutoPay_Successfull,
      ack_SIP_AutoPay_waiting: _ack_SIP_AutoPay_waiting,
      ack_SIPFI_AutoPay_Failed: _ack_SIPFI_AutoPay_Failed,

      ack_Purchase_upi_Payment: _ack_Purchase_upi_Payment,

      //Mix Transaction
      ack_Mix_transaction_Success:_ack_Mix_transaction_Success











    }
  }


})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('ModalService', modalService);

  /** @ngInject */
  function modalService($uibModal) {
    function openModal(success, dismiss, view, controller, data, sizeClass) {
      success = success || function () {};
      dismiss = dismiss || function () {};
      var ctrl = controller + ' as Modal';
      var modalInstance = $uibModal.open({
        templateUrl: 'app/services/modal/modal-popup.html',
        controller: ctrl,
        size: sizeClass,
        backdrop: 'static',
        keyboard  : false,// set static/true to toggle dismiss on backdrop click
        resolve: {
          modalView: function () {
            return view;
          },
          modalData: function () {
            return data;
          }
        }
      });
      modalInstance.result.then(success, dismiss || angular.noop);
    }

    return {
      registrationSuccessModal: function (data, successCallback, dismissCallback, passedClass) {
        openModal(successCallback, dismissCallback, "REGISTER_SUCCESS", "RegisterModalController", data, "md" + " " + passedClass);
      },
      olduser: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "REGISTER_USER", "ExistinguserModalController", data, "md");
      },
      nonKycModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NON_KYC", "RegisterModalController", data, "md");
      },
      schemeListModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_SCHEME_LIST", "SchemeListModalController", data, "lg");
      },
      initiateSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "INITIATE_SUCCESS", "InitiateTransactionModalController", data, "md");
      },
      successMessageModal: function (data, successCallback, dismissCallback, passedClass) {
        openModal(successCallback, dismissCallback, "SUCCESS_MESSAGE", "SuccessModalController", data, "md" + " " + passedClass);
      },
      folioCreationSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FOLIO_SUCCESS_MESSAGE", "FolioSuccessModalController", data, "md");
      },
      holdHolderModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "HOLD_HOLDER", "HoldHoderModalController", data, "md");
      },
      IFSCSelectionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "IFSC_SELECTION", "IFSCSelection", data, "lg");
      },
      IFSCSelectionModalNewJourney: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "IFSC_SELECTION_NEW_JOURNEY", "IFSCSelectionNewJourney", data, "lg");
      },
      confirmCancelModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_CANCEL", "ConfirmCancelController", data, "md");
      },
      confirmCancelPreLoginModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_CANCEL_PRELOGIN", "ConfirmCancelController", data, "md");
      },
      rejectionReasonModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "REJECTION_REASON", "ConfirmCancelController", data, "md");
      },
      addJointHolderModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ADD_JOINT_HOLDER", "AddJointHolderController", data, "md");
      },
      mapFolioModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "MAP_FOLIO", "MapFolioController", data, "md");
      },
      confirmOtpModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_OTP", "ConfirmOtpController", data, "md");
      },
      confirmOtpSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_OTP_SUCCESS", "ConfirmOtpController", data, "md");
      },
      resetPasswordDoneModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "RESET_PASSWORD_SUCCESS", "ResetPasswordSuccessController", data, "md");
      },
      forgotPasswordModal: function (data, successCallback, dismissCallback, passedClass) {
        openModal(successCallback, dismissCallback, "FORGOT_PASSWORD", "ForgotPasswordController", data, "md" + " " + passedClass);
      },
      createUserSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CREATE_USER_SUCCESS", "CreateUserSuccessController", data, "md");
      },
      createUserEmailErrorModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CREATE_USER_EMAIL_ERROR", "CreateUserSuccessController", data, "md");
      },
      changePasswordModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_PASSWORD", "ChangePasswordModalController", data, "md");
      },
      changePasswordSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_PASSWORD_SUCCESS", "ChangePasswordModalController", data, "md");
      },
      termConditionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TERM_CONDITION", "TermConditionModalController", data, "lg");
      },
      transactionalTermConditionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTIONAL_TERM_CONDITION", "TransactionalTermConditionModalController", data, "lg");
      },
      transactionalTermConditionModalEMandate: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTIONAL_TERM_CONDITION_E_MANDATE", "TransactionalTermConditionModalController", data, "lg");
      },
      nonTransactionalTncModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NON_TRANSACTIONAL_TERM_CONDITION", "NonTransactionalTncModalController", data, "lg");
      },
      manualInstructionsModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "MANUAL_INSTRUCTIONS", "TransactionModalController", data, "lg");
      },
      dreamSipChangeOptionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DREAM_SIP_CHANGE_OPTION", "OptionChangeController", data, "lg");
      },
      changeTargetSchemeModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_TARGET_SCHEME", "ChangeTargetSchemeController", data, "lg");
      },
      addLinkPanModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "Add_Link_Pan", "AddLinkPanController", data, "md");
      },
      dreamSipPointToNoteModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DREAM_SIP_POINT_TO_NOTE", "PointToNoteController", data, "lg");
      },
      successTransactionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SUCCESS_TRANSACTION", "TransactionModalController", data, "lg");
      },
      changeDividendModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_DIVIDEND", "ChangeDividendModalController", data, "md");
      },
      changeDividendModalSuccess: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_DIVIDEND_SUCCESS", "ChangeDividendModalController", data, "md");
      },
      confirmRegisterModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_REGISTER", "RegisterModalController", data, "lg");
      },
      folioSuccssModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FOLIO_SUCCESS", "FolioCompletModalController", data, "lg");
      },
      redirectToOldFolioModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "REDIRECT_TO_OLD_FOLIO", "RegisterModalController", data, "md");
      },
      OtpModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OTP_CONFIRM", "OtpModalController", data, "md");
      },
      OtpModalSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OTP_CONFIRM_SUCCESS", "OtpModalController", data, "md");
      },
      widgetStoreModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "WIDGET_SELECTION", "WidgetStoreModalController", data, "lg");
      },
      savedTransactionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SAVED_TRANSACTION", "SavedTransactionModalController", data, "md");
      },
      addTaxResidencyModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ADD_TAX_RESIDENCY", "AddTaxResidencyModalController", data, "md");
      },
      editDashboardSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DASHBOARD_EDIT_SUCCESS", "EditDashboardController", data, "md");
      },
      deleteTaxResidencyModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DELETE_TAX_RESIDENCY", "AddTaxResidencyModalController", data, "md");
      },
      notificationDetailModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NOTIFICATION_DETAILS", "NotificationModalController", data, "md");
      },
      cancelSipModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CANCEL_SIP", "CancelSipController", data, "md");
      },
      cancelSipSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CANCEL_SIP_SUCCESS", "CancelSipController", data, "md");
      },
      unclaimedDividendModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "UNCLAIMED_DIVIDEND", "UnclaimedDividendModalController", data, "md");
      },
      transactionSummaryModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_SUMMARY", "TransactionSummaryModalController", data, "md");
      },
      schemeListInstantModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_SCHEME_LIST_INSTANT", "SchemeListInstantModalController", data, "lg");
      },
      feedbackModal: function (data, successCallback, dismissCallback) {
      openModal(successCallback, dismissCallback, "FEEDBACK_SUCCESS", "FeedbackModalController", data, "md");
      },
      statementPdfModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "STATEMENT_PDF", "StatementModalController", data, "md");
      },
      rollOverOverviewModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ROLL_OVER_OVERVIEW", "RollOverModalController", data, "sm");
      },
      rollOverConfirmModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ROLL_OVER_CONFIRM", "RollOverModalController", data, "sm");
      },
      rollOverSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ROLL_OVER_SUCCESS", "RollOverModalController", data, "sm");
      },
      enterEmailVerificationModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ENTER_EMAIL_VERIFICATION", "EmailVerificationModalController", data, "md");
      },
      enterOtpVerificationModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OTP_VERIFICATION", "EmailVerificationModalController", data, "md");
      },
      emailVerificationSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "EMAIL_VERIFICATION_SUCCESS", "EmailVerificationModalController", data, "md");
      },
      selfDeclarationModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SELF_DECLARE", "FolioSuccessModalController", data, "md");
      },
      cutOffModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CUT_OFF", "PopupsModalController", data, "md");
      },
      childrenFundMessage: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHILDREN_FUND_MSG", "CancelSipController", data, "md");
      },
      PurchaseNetBankingModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "PURCHASE_NETBANKING", "PopupsModalController", data, "md");
      },
      liquidPurchaseModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "PURCHASE_LIQUID", "PopupsModalController", data, "md");
      },
      redemptionConfirmModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "REDEMPTION_CONFIRM", "RedemptionConfirmModalController", data, "md");
      },
      stayInvestedModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "STAY_INVESTED", "RedemptionConfirmModalController", data, "sm");
      },
      addfatcaTaxResidencyModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ADD_FATCA_TAX_RESIDENCY", "AddFatcaTaxResidencyModalController", data, "md");
      },
      loginloaderModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "LOGIN_LOADER", "LoginLoaderModalController", data, "md");
      },
      loginVideoModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "LOGIN_VIDEO", "LoginVideoModalController", data, "md");
      },
      upiSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "UPI_SUCCESS", "InitiateTransactionModalController", data, "mid-md");
      },
      editSubscriptionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "EDIT_SUBSCRIPTION", "SubscriptionModalController", data, "mid-md");
      },
      editSubscriptionSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "EDIT_SUBSCRIPTION_SUCCESS", "SubscriptionModalController", data, "sm");
      },
      confirmUnsubscribeModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_UNSUBSCRIBE", "SubscriptionModalController", data, "sm");
      },
      addBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ADD_BANK", "ModifyBankModalController", data, "md");
      },
      deleteBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DELETE_BANK", "ModifyBankModalController", data, "sm");
      },
      deleteBankSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DELETE_BANK_SUCCESS", "ModifyBankModalController", data, "md");
      },
      changeBankSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_BANK_SUCCESS", "ModifyBankModalController", data, "sm");
      },
      changeDefaultBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_DEFAULT_BANK", "ModifyBankModalController", data, "sm");
      },
      selectAccountNoModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SELECT_ACCOUNT_NO", "SelectAccountNoModalController", data, "md");
      },
      checkPan4Holder: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHECK_PAN", "AddJointHolderModalController", data, "md");
      },
      showImage: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SHOW_IMAGE", "ShowImageModalController", data, "md");
      },
      showImage1: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SHOW_IMAGE1", "ShowImageModalController", data, "md");
      },
      confirmLoginModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_LOGIN", "ConfirmLoginController", data, "md");
      },
      offlineUserModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OFF_LINE_USER_MSG", "ChangeDividendModalController", data, "md");
      },
      tpvModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TPV_MODAL", "tpvController", data, "md");
      },
      transactionWarningModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_WARNING", "TransactionWarningController", data, "md");
      },
      minorBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "MINOR_BANK_MODAL", "PopupsModalController", data, "md");
      },
      minorSipModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "MINOR_SIP_MODAL", "PopupsModalController", data, "md");
      },
      minorPurchaseModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "MINOR_PURCHASE_MODAL", "PopupsModalController", data, "md");
      },
      addBankMsg: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ADD_BANK_MSG", "PopupsModalController", data, "md");
      },
      addBankCobmDisabled: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ADD_BANK_COBM_DISABLED", "PopupsModalController", data, "md");
      },
      registerEMandateModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "REGISTER_EMANDATE", "RegisterModalController", data, "md");
      },
      openScheduleTransactionModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SCHEDULE_TRANSACTION", "ScheduleTransactionController", data, "md");
      },
      otpForApprovalModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OTP_FOR_APPROVAL", "TnitiateTransactionModalController", data, "md");
      },
      kycRejectModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "KYC_REJECT", "KycRejectModalController", data, "md");
      },
      cancelMandateModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CANCEL_MANDATE", "CancelMandateController", data, "md");
      },
      nfoEnabledModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NFO_ENABLED", "NfoEnabledModalController", data, "md");
      },
      genericModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "GENERIC_MODAL", "GenericModalController", data, "md");
      },
      ecartSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ECART_SUCCESS_MODAL", "PopupsModalController", data, "md");
      },
      confirmCancelModalEcart: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_CANCEL_ECART", "ConfirmCancelController", data, "md");
      },
      showVideoPlayModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "VIDEO_MODAL", "VideoModalController", data, "lg");
      },
      declarationModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DECLARATION", "NfoEnabledModalController", data, "md");
      },
      subscribeToggleModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SUBSCRIBE_TOGGLE_MODAL", "SubscribeToggleController", data, "sm");
      },
      showNudgeReasons: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NUDGE_REASONS", "NudgeReasonsController",data, "sm");
      },
      stopScheduleRedeem: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "STOP_SCHEDULE_REDEEM", "RedemptionConfirmModalController",data, "sm");
      },
      confirmPauseModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHOOSE_PAUSE", "ConfirmCancelController", data, "md");
      },
      termConditionModalSIP: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TERM_CONDITION_SIP", "TermConditionModalController", data, "lg");
      },
      subscribeWhatsapp:  function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SUBSCRIBE_WHATSAPP", "SubscribeWhatsapp", data, "md");
      },
      subscribeWhatsappSecondStep:  function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SUBSCRIBE_WHATSAPP_SECOND_STEP", "SubscribeWhatsapp", data, "md");
      },
      subscribeWhatsappTnC:  function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SUBSCRIBE_WHATSAPP_TnC", "SubscribeWhatsapp", data, "lg");
      },
      logoutSuccess: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SESSION_EXPIRE", "SessionModalController", data, "md");
      },
      sessionActive: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SESSION_ACTIVE", "SessionModalController", data, "sm");
      },
      nfoTransactionPointNotes:  function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NFO_POINT_NOTES", "NfoTransactionNotesModalController", data, "lg");
      },
      arnPopupModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ARN_POPUP", "ArnPopupController", data, "md");
      },
      cancelNominationModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CANCEL_NOMINEE", "CancelNomineeController", data, "md");
      },
      offlineNomineeFormModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OFFLINE_NOMINEE_FORM", "OfflineNomineeFormController", data, "md");
      },
      updateNomineeModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "UPDATE_NOMINEE_SUCCESS", "UpdateNomineeSuccessController", data, "md");
      },
      NomineeUpdateOtpModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OTP_NOMINEE_UPDATE", "TnitiateTransactionModalController", data, "md");
      },
      transactionOtpModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_OTP_MODAL", "TransactionOtpModalController", data, "md");
      },
      hdfcBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "HDFC_BANK_MODAL", "HdfcBankModalController", data, "mid-md");
      },
      arnAddBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ARN_ADD_BANK_MODAL", "ArnAddBankModalController", data, "lg");
      },dreamSipTenureModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "Dream_Sip_Tenure", "DreamSipTenureModalController", data, "lg");
      },
      dreamSchemeListModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_DREAM_SCHEME_LIST", "DreamSchemeListModalController", data, "lg");
      },
      registerEMandateNewJourneyModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "REGISTER_EMANDATE_NEW_INVESTOR_JOURNEY", "RegisterEmandateNewJourneyModalController", data, "md");
      },
      newJourneyRegisteredModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NEW_JOURNEY_REGISTERED", "NewJourneyRegisterModalController", data, "lg");
      },
      investmentPersonality: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "INVESTMENT_PERSONALITY_MODAL", "InvestmentPersonalityModalController", data, "lg");
      },
      installmentDetailModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "INVESTMENT_INSTALLMENT_DETAIL_MODAL", "BasketSipInstallmentDetails", data, "lg");
      },
      sipOrPurchaseBasketModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SIP_OR_PURCHASE_BASKET", "SipOrPurchaseBasketController", data, "md");
      },
      fillFolioDetailsModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FILL_FOLIO_DETAIL_MODAL", "FillFolioDetailsModalController", data, "md");
      },
      selectFolioModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SELECT_FOLIO", "SelectFolioModalController", data, "md");
      },
      unsavedChangesModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "UNSAVED_CHANGES", "UnsavedChangesModalController", data, "md");
      },
      folioChoiceModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FOLIO_CHOICE_MODAL", "FillFolioDetailsModalController", data, "md");
      },
      decisionFolioModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DECISION_FOLIO_MODAL", "DecisionModalController", data, "md");
      },
      oneClickPanAadharStatusModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ONE_CLICK_PANAADHAR_STATUS_MODAL", "OneClickPanAadharStatusController", data, "md");
      },
      prefillFolioModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "PREFILL_FOLIO", "PrefillFolioModalController", data, "md");
      },
      contactSaveModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONTACT_SAVE_MODAL", "ContactSaveModalController", data, "md");
      },
      optOutNomineeModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OPT_OUT_NOMINEE_MODAL", "OptOutNomineeModalController", data, "md");
      },
      nomineeUpdateVerificationModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NOMINEE_UPDATE_VERIFICATION_ON_SMARTLINK", "NomineeUpdateVerificationModalController", data, "md");
      },
      notificationForNomineeUpdation: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NOTIFICATION_OF_NOMINEE_ON_LOGIN", "NomineeUpdateNotificationModalController", data, "md");
      },
      contactOtpModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONTACT_OTP_MODAL", "ContactOtpModalController", data, "md");
      },
      purchaseScheduleCancelModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "PURCHASE_SCHEDULE_CANCEL", "purchaseScheduleCancelController", data, "lg");
      },
      purchaseScheduleSchemesModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "PURCHASE_SCHEDULE_SCHEMES", "purchaseScheduleSchemesController", data, "lg");
      },
      topupDetailsModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SIP_TOP_UP_DETAILS_MODAL", "SipTopupDetailsController", data, "lg" );
      },
      schemeListNewModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_SCHEME_LIST_NEW_MODAL", "SchemeListNewModalController", data, "lg");
      },
      sipDetailsModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SIP_DETAILS_MODAL", "SipDetailsModalController", data, "lg");
      },
      otpAutoMoveToNextFieldModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OTP_AUTO_MOVE_TO_NEXT_FIELD", "AutoNextInputOtpVerificationController", data, "md");
      },
      loginWithMobileModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "LOGIN_WITH_MOBILE", "LoginWithMobileController", data, "md");
      },
      otpConfirmModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OTP_VERIFY_CONFIRM", "OtpVerificationConfirmModalController", data, "md");
      },
      loginWithMobileNoteNJModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NJ_NOTE_LOGIN_WITH_MOBILE", "NewJourneyNoteLoginWithMobileController", data, "md");
      },
      mobiletermConditionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "MOBILE_TERM_AND_CONDITION", "MobileTermConditionModalController", data, "lg");
      },
      loginWithMobileContactUpdateNJModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NJ_CONTACT_UPDATE_LOGIN_WITH_MOBILE", "UpdateContactLoginWithMobileController", data, "md");
      }
    }
  }
})();

(function() {
  angular
    .module('hdfc-mf-investor-web')
    .factory('MetaTagService', metaTagService);
  function metaTagService(HDFC_API) {
    var tagsElements = [];
    var scriptTagsList = [];
    var _setMetaTags = function(tagDescription,title,keywords) {
      var tags = {
        'description': tagDescription,
        'title': title,
        'keywords': keywords
      };
      _clearTags();
      angular.forEach(tags, function(content, name) {
        var tagElement = getTagElement(content, name);
        document.head.append(tagElement);
        tagsElements.push(tagElement);
      });
    };
    var _setMetaDescription = function(tagDescription) {
      var tags = {
        'description': tagDescription,
      };
      _clearTags();
      angular.forEach(tags, function(content, name) {
        var tagElement = getTagElement(content, name);
        document.head.append(tagElement);
        tagsElements.push(tagElement);
      });
    };
    function getTagElement(content, name) {
      var nameAttr = (name.indexOf('og:') === 0) ? 'property' : 'name';
      var meta = document.createElement('meta');
      meta.setAttribute(nameAttr, name);
      meta.setAttribute('content', content);
      return meta;
    }
    function _clearTags() {
      angular.forEach(tagsElements, function(tagElement){
        document.head.removeChild(tagElement);
      });
      tagsElements.length = 0;
    }

    // function _addScriptTag() {
    //   var tags = {
    //     'script': 'script'
    //   };
    //   _removeScriptTag();
    //   angular.forEach(tags, function() {
    //     var script = document.createElement('script');
    //     script.setAttribute('id', 'allincall-script');
    //     script.setAttribute('type', 'text/javascript');
    //     script.setAttribute('src', HDFC_API.ALL_IN_CALL);
    //     document.head.append(script);
    //     scriptTagsList.push(script);
    //   });
    // }

    function _removeScriptTag() {
      angular.forEach(scriptTagsList, function(tagElement){
        document.head.removeChild(tagElement);
      });
      scriptTagsList.length = 0;
    }

    return {
      clearTags: _clearTags,
      setMetaTags: _setMetaTags,
      setMetaDescription: _setMetaDescription,
      // addScriptTag: _addScriptTag,
      removeScriptTag: _removeScriptTag
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('PreliminaryDashboardCalculatorService', preliminaryDashboardCalculatorService);

  /** @ngInject */
  function preliminaryDashboardCalculatorService($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.CMS_HOST +'en/hdfc/api/v2/'+':child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }
})();
/*
* Created by TTN at 07-Aug-2020
* */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('KycService', kycService);

    /** @ngInject */
    function kycService($q, $state, MessageService, AppConstants, InvestorService, ModalService, LoaderService) {
      var vm = this;

      function _fetchKycStatus(component) {
        var defer = $q.defer();
        LoaderService.showLoader();
        var successHandler = function(resp) {
          LoaderService.hideLoader();
          if (resp.data && !resp.data.kycVerifiedFlag) {
            _showKycMessage(resp.data.kycMessage);
            vm.kycState = resp.data.kycVerifiedFlag;
            defer.reject(resp.data.kycMessage);
          } else {
            vm.kycState = resp.data.kycVerifiedFlag;
            defer.resolve(resp.data);
          }
        };

        var errorHandler = function(resp) {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        };

        if (component === AppConstants.KYC_RESTRICTION.FOLIO_CREATION) {
          InvestorService.get({
            "child1": "folio",
            "child2": "create-folio"
          }).$promise.then(successHandler, errorHandler);
        } else if (component === AppConstants.KYC_RESTRICTION.TRANSACTION) {
          InvestorService.get({
            "child1": "folio",
            "child2": "transact-now"
          }).$promise.then(successHandler, errorHandler);
        }
        return defer.promise;
      }

      function _showKycMessage(message) {
        ModalService.genericModal({
          text: message
        });
      }

      return {
        fetchKycStatus: _fetchKycStatus,
        showKycMessage: _showKycMessage
      }
    }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('InvestorProfilePhotoService', investorProfilePhotoService);

  /** @ngInject */
  function investorProfilePhotoService($resource, HDFC_API, TransformResponse) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': undefined
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('InvestorService', investorService)
    .factory('ArnInvestorService', arnInvestorService)
    .factory('InvestorServiceV3', investorServiceV3)
    .factory('NewInvestorServiceV3', newInvestorServiceV3)
    .factory('investorServiceVersion', investorServiceVersion)
    .factory('InvestorFileUploadService', investorFileUploadService)
    .factory('InvestorFileUploadServiceV3', investorFileUploadServiceV3)
    .factory('InvestorServiceVersion3', investorServiceVersion3)
    .factory('InvestorServiceVersionBasket3', investorServiceVersionBasket3)
    .factory('InvestorServiceUpiCallback',investorServiceUpiCallback)
    .factory('FileUploadServiceVersion2', fileUploadServiceVersion2)
    .factory('HdfcKycService', hdfcKycService)
    .factory('InvestorServiceV2', investorServiceV2)
    .factory('EcartInvestorService',ecartInvestorService)
    .factory('InvestorServiceVersionFolioSelection',investorServiceVersionFolioSelection);

  /** @ngInject */
  function investorService($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    var token = localStorage.getItem('token');

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post2: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'app-type': 'W',
          'Authorization': token
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post4: {
       method: 'post',
       headers: {
         'Content-Type': 'application/json',
         'X-API-VERSION':'4'
       },
       transformResponse: TransformResponse.transformApiResponse
     },
      get: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      },
      put: {
        method: 'put',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

  /** @ngInject */
  function investorServiceVersion($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post4: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'4'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        headers: {
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

  /** @ngInject */
  function investorServiceVersion3($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'3',
          'app-type': 'W'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post4: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'4',
          'app-type': 'W'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }


  /** @ngInject */
  function investorServiceV3($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST  + 'v3/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
         // 'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }
/** @ngInject */
function newInvestorServiceV3($resource, HDFC_API, $window, TransformResponse) {
  HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
  var _path = HDFC_API.PROTOCOL + HDFC_API.HOST  + 'v3/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

  return $resource(_path, {}, {
    post: {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
       'X-API-VERSION':'2'
      },
      transformResponse: TransformResponse.transformApiResponse
    },
    get: {
      method: 'get',
      transformResponse: TransformResponse.transformApiResponse
    }
  });
}
  /** @ngInject */
  function investorFileUploadService($resource, HDFC_API) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5/:child6';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': undefined
        }
      }
    });
  }
  /** @ngInject */
  function investorFileUploadServiceV3($resource, HDFC_API) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST  + 'v3/:child1/:child2/:child3/:child4/:child5/:child6';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': undefined
        }
      },
      post4: {
        method: 'post',
        headers: {
          'Content-Type': undefined,
          'X-API-VERSION':'4'
        }
      },
      post2: {
        method: 'post',
        headers: {
          'Content-Type': undefined,
          'X-API-VERSION':'2'
        }
      }
    });
  }

  /** @ngInject */
    function investorServiceUpiCallback($resource, HDFC_API) {
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST  + 'v1/upi/callback';

      return $resource(_path, {}, {
        post: {
          method: 'get',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      });
    }

  /** @ngInject */
  function fileUploadServiceVersion2($resource, HDFC_API) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST  + 'v3/:child1/:child2/:child3/:child4/:child5/:child6';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': undefined,
          'X-API-VERSION': '2'
        }
      }
    });
  }


  /** @ngInject */
  function arnInvestorService($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    var token = localStorage.getItem('token');

    return $resource(_path, {}, {
      get: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse,
        headers:{
          'Cookie': 'JSESSIONID=1rjl1gd92jlek1dr6zfqxkjvc'
        }
      }
    });
  }

/** @ngInject */
function hdfcKycService($resource, HDFC_API, $window, TransformResponse) {
  HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
  var _path = HDFC_API.PROTOCOL + HDFC_API.MAIN_HOST + ':child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
}

  /** @ngInject */
  function investorServiceVersionBasket3($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST  + 'v3/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        headers: {
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

  /** @ngInject */
  function ecartInvestorService($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post1: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-API-VERSION':'2',
          'app-type': 'W'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        headers: {
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

  /**@ngInject */
  function investorServiceV2($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + 'v2' + '/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    var token = localStorage.getItem('token');

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post2: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'app-type': 'W',
          'Authorization': token
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post4: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'4'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      },
      put: {
        method: 'put',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }


  /** @ngInject */
  function investorServiceVersionFolioSelection($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + ':version' + '/:child1/:child2?nriFlag=:queryParam';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post4: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'4'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        headers: {
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }
})();

/**
 * Created by ttn on 01/12/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('InvestmentBasketService', investmentBasketService);

  /** @ngInject */
  function investmentBasketService($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/' + ':child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('IIHttpService', iIHttpService);


  /** @ngInject */
  function iIHttpService($resource, HDFC_API, TransformResponse,$window) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5/:child6/:child7';  
      return $resource(_path, {}, {
        post: {
          method: 'post',
          headers: {
            'Content-Type' : 'application/json'
          },
          transformResponse: TransformResponse.transformApiResponse
        },
        get: {
          method: 'get',
          transformResponse: TransformResponse.transformApiResponse
        }
      }); 
    
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .service('FormatterService', formatterService);

  /** @ngInject */
  function formatterService(HDFC_API, AppConstants, $window) {
    var formatter = new $window.JSEncrypt();
    var hash = $window.CryptoJS;

    var _getFormatter = function() {
      formatter.setKey(AppConstants.CONFIG_ENDPOINT);
      return formatter;
    };

    var _getFormatterHDFC = function() {
      formatter.setKey(HDFC_API.HDFC_CONFIG_ENDPOINT);
      return formatter;
    };

    var _getPrototype = function(data, key) {
      return hash.AES.decrypt(data, key);
    };

    function readAesResponsePayload(header, data) {
      var iv = hash.enc.Base64.parse(header.substring(0, header.lastIndexOf("|")));
      var key = hash.enc.Base64.parse(header.substring(header.lastIndexOf("|")+1, header.length));
      var decryptJson = hash.AES.decrypt({
        ciphertext: data
      }, key, {iv: iv});
      return decryptJson.toString(hash.enc.Utf8);
    }

    return {
      hash: hash,
      getFormatter: _getFormatter,
      getFormatterHDFC: _getFormatterHDFC,
      getProtoType: _getPrototype,
      readAesResponsePayload: readAesResponsePayload
    }
  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('FileUploadService', fileUploadService);

  /** @ngInject */
  function fileUploadService($http,$q) {
    var uploadFileToUrl = function(file, uploadUrl){
      var deferred = $q.defer();
      var fd = new FormData();
      fd.append('file', file);
       $http.post(uploadUrl, fd, {
       transformRequest: angular.identity,
       headers: {'Content-Type': undefined}
       })
       .then(function(resp){
         deferred.resolve(resp);
       }, function(err){
         deferred.reject(err);
       });
      return deferred.promise;
    };

    return{
      uploadFileToUrl:uploadFileToUrl
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('FeedbackService', feedbackService);

  /** @ngInject */
  function feedbackService($resource, HDFC_API, TransformResponse) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + 'v1/feedback/:controller';
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('DownloadPdfService', downloadPdfService)
    .factory('DownloadPdfServiceV2', DownloadPdfServiceV2);

  /** @ngInject */
  function downloadPdfService($http,$q, HDFC_API) {
    var downloadFile=function(payload, type, exposedUrl){
      type = type?type:'exitLoad';
      var statementPath =  exposedUrl ? exposedUrl: '/statement/';
      var _path = '';
      var deferred = $q.defer();
      if(type === 'pdf' || type === 'tif' || type === 'tiff'){
        _path = exposedUrl;
        $http.get(_path, {'responseType':'arraybuffer',headers:{'accept': undefined}}).then(function (resp) {
          deferred.resolve(resp);
        }, function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      } else{
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + statementPath + type;
        $http.post(_path,payload, {'responseType':'arraybuffer'}).then(function (resp) {
          deferred.resolve(resp);
        }, function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      }

    };

    return{
      downloadFile:downloadFile
    }
  }

  /** @ngInject */
  function DownloadPdfServiceV2($http,$q, HDFC_API) {
    var downloadFile=function(payload, type, exposedUrl){
      type = type?type:'exitLoad';
      var statementPath =  exposedUrl ? exposedUrl: '/statement/';
      var _path = '';
      var deferred = $q.defer();
      if(type === 'pdf' || type === 'tif' || type === 'tiff'){
        _path = exposedUrl;
        $http.get(_path, {'responseType':'arraybuffer', headers:{'X-API-VERSION':'2'}}).then(function (resp) {
          deferred.resolve(resp);
        }, function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      } else{
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + statementPath + type;
        $http.post(_path,payload, {'responseType':'arraybuffer', headers:{'X-API-VERSION':'2'}}).then(function (resp) {
          deferred.resolve(resp);
        }, function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      }

    };

    return{
      downloadFile:downloadFile
    }
  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('DashboardService', dashboardService);

  /** @ngInject */
  function dashboardService($resource, HDFC_API, TransformResponse) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/dashboard/:controller/:child1/:child2';
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('MessageService', messageService);

  /** @ngInject */
  function messageService(AppConstants, toastr) {
    var MessageService = {};

    MessageService = {
      /*
       * show toastr successful message
       */
      success: function (messages) {
        toastr.options = {
          'closeButton': true,
          'debug': false,
          'newestOnTop': false,
          'progressBar': true,
          'iconClasses': {
            success: 'toast-success'
          },
          'positionClass': 'toast-top-right',
          'preventDuplicates': false,
          'onclick': null,
          'showDuration': '300',
          'extendedTimeOut': '1000',
          'showEasing': 'swing',
          'hideEasing': 'linear',
          'showMethod': 'fadeIn',
          'hideMethod': 'fadeOut'
        };
        if (!messages) {
          messages = AppConstants.ToastrMessage.SUCCESS;
        }
        messages = messages + '<span class="' + Math.random() + '"></span>';
        toastr.success(messages);
      },
      /*
       * show toastr failed message
       */
      error: function (messages) {
        toastr.options = {
          'closeButton': true,
          'debug': false,
          'newestOnTop': true,
          'progressBar': true,
          'positionClass': 'toast-top-right',
          'preventDuplicates': true,
          'onclick': null,
          'showDuration': '300',
          'extendedTimeOut': '1000',
          'showEasing': 'swing',
          'hideEasing': 'linear',
          'showMethod': 'fadeIn',
          'hideMethod': 'fadeOut',
          'maxOpened': 9,
          iconClasses: {
            error: 'toast-error'
          }
        };
        if (!messages) {
          messages = AppConstants.ToastrMessage.FAILED;
        }
        messages = messages + '<span class="' + Math.random() + '"></span>';
        toastr.error(messages);
      },
      /*
       * show toastr warning message
       */
      warning: function (messages) {
        toastr.options = {
          'closeButton': true,
          'debug': false,
          'newestOnTop': true,
          'progressBar': true,
          'positionClass': 'toast-top-right',
          'preventDuplicates': true,
          'onclick': null,
          'showDuration': '300',
          'extendedTimeOut': '1000',
          'showEasing': 'swing',
          'hideEasing': 'linear',
          'showMethod': 'fadeIn',
          'hideMethod': 'fadeOut',
          'maxOpened': 9,
          iconClasses: {
            error: 'toast-error'
          }
        };
        if (!messages) {
          messages = AppConstants.ToastrMessage.FAILED;
        }
        messages = messages + '<span class="' + Math.random() + '"></span>';
        toastr.warning(messages);
      },
      /*
      * close all opened toastr
      * */
      clear: function () {
        toastr.clear();
      }

    };

    return MessageService;
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('LoaderService', loaderService);

  /** @ngInject */
  function loaderService() {
    var _showLoader = function (ele) {
      if (ele) {
        angular.element(ele).css('display', 'block');
      } else {
        angular.element('.loader.main').css('display', 'block');
        angular.element('html').css('overflow', 'hidden');
        angular.element('.sidebar').css('pointer-events', 'none');
      }
    };
    var _hideLoader = function (ele) {
      if (ele) {
        angular.element(ele).css('display', 'none');
      } else {
        angular.element('.loader.main').css('display', 'none');
        angular.element('html').css('overflow', 'auto');
        angular.element('.sidebar').css('pointer-events', 'auto');
      }
    };

    return {
      showLoader: _showLoader,
      hideLoader: _hideLoader
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('BrowserService', browserService);

  /** @ngInject */
  function browserService($timeout, $state, deviceDetector, AppConstants, uaParser) {
    var browserName = uaParser.getBrowser().name.toUpperCase();
    var browserVersion = uaParser.getBrowser().version;
    var _isCompatibleBrowser = function () {
      if ((browserName === AppConstants.BROWSERS.CHROME ) && parseInt(browserVersion, 10) < 60) {
        return false;
      }

      else if (browserName === AppConstants.BROWSERS.FIREFOX  && parseInt(browserVersion, 10) < 50) {
        return false;
      }

      else if (browserName === AppConstants.BROWSERS.MS_EDGE  && parseInt(browserVersion, 10) < 16) {
        return false;
      }

      else if (browserName === AppConstants.BROWSERS.IE || browserName === AppConstants.BROWSERS.UCBROWSER ) {
        return false;
      }
      return true;
    };

    var _isInCompatibleBrowser = function () {
      return !_isCompatibleBrowser();
    };

    var _forceUpdateForCompatibleBrowser = function () {
      if (_isCompatibleBrowser()) {
        $timeout(function () {
          $state.go('login');
        }, 0);
      }
    };


    var _forceUpdateForInCompatibleBrowser = function () {
      if (_isInCompatibleBrowser()) {
        $timeout(function () {
          $state.go('browserUpdate');
        }, 0);
      }
    };

    return {
      forceUpdateForInCompatibleBrowser: _forceUpdateForInCompatibleBrowser, forceUpdateForCompatibleBrowser: _forceUpdateForCompatibleBrowser
    };

  }


})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .service('AuthService', authService);

  /** @ngInject */
  function authService($rootScope, $q, $http, $cookies, $log,$state, $window, HDFC_API, UserService, AppConstants, InvestorService, ProfileFactory, UtilService, ModalService, LoaderService, MessageService, TransformResponse,$timeout, FormatterService) {
    var vm = this, currentUser = null, currentUserInstant = null, newInvestor = null;

    /**
     * function generatePassForSeamLessLogin
     * @return {Promise}
     */
    vm.generatePassForSeamLessLogin = function () {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/generateGatePass/' + HDFC_API.THIRD_PARTY_NAME,
        success = function (resp) {
          deferred.resolve(resp.data);
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http.get(_path, {}).then(success, error);
      return deferred.promise;
    };

    /**
     * Validate user first login only
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.firstStepLogin = function (payload,type,singleUseURL) {
      var forceLogoutPayload = angular.copy(payload);
      forceLogoutPayload.userId = forceLogoutPayload.username;
      delete forceLogoutPayload.username;
      payload.username = vm.encryptRSA(angular.copy(payload.username));
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST  + 'investor/first/login',
        success = function (resp) {
          if (resp.status && resp.data) {
            if (AppConstants.SESSION_ACTIVE === resp.data.message) {
              var success = function () {
                vm.forceLogout(forceLogoutPayload)
              }
              ModalService.sessionActive({}, success, function () {});
              deferred.resolve();
            } else {
              if(resp.data.popupEnabled) {
                ModalService.genericModal({
                  text: resp.data.message
                });
                deferred.resolve();
                LoaderService.hideLoader();
              } else {
                deferred.resolve(resp.data);
              }
            }
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      if(type === 'ThroughPassword'){
        var header = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-API-VERSION':'4'
        }
      }

      else if(type === 'OTP'){
        header = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'login-type' : type,
          'secret-link' : singleUseURL,
          'X-API-VERSION':'4'
        }
      }

      $http({
        method: 'POST',
        url: _path,
        headers: header,
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: payload
      }).then(success, error);
      return deferred.promise;
    };
    /**
     * Authenticate user and save token
     *
     */
    vm.login = function (payload,type,singleUseURL) {
      var deferred = $q.defer(),userInfo={},
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + HDFC_API.VERSION + '/oauth/token',
        // _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + HDFC_API.VERSION + '/login',
        success = function (resp) {
          if (resp.data && resp.data.access_token) {
            vm.clearCookies(AppConstants.INSTA_IDENTIFIER);
            vm.clearCookies(AppConstants.IDENTIFIER);
            sessionStorage.removeItem('selectedLinkPanData');
            if(type === 'SWITCH_MTOKEN_TO_ETOKEN'){
              var MOBILE_IDENTIFIER = vm.getMobileLoginToken();
              vm.logoutMobileToke(MOBILE_IDENTIFIER.mobile);
            }
            vm.clearCookies(AppConstants.MOBILE_IDENTIFIER);
            $window.sessionStorage.removeItem("isExposedStatementActive");
            if(type === 'MOBILE_NO'){
              resp.data.newPrelimanryUser = false;
              vm.setMobileLoginToken(resp.data);
              deferred.resolve(resp.data);
              return;
            }
            resp.data['userId'] = payload.userId;
            userInfo.userId = payload.userId;
            vm.setUserCookies(userInfo);
            vm.setToken(resp.data);
            sessionStorage.isLoggedIn = true;
            currentUser = resp.data;
            currentUserInstant = null;
            var successProfile = function (resp) {
              if (resp) {
                var encParentPan = $window.CryptoJS.AES.encrypt($window.JSON.stringify(resp.investorPAN), 'primaryPan');
                sessionStorage.primaryPan = encParentPan;
                deferred.resolve(resp);
              }
              else {
                deferred.reject(resp);
              }
            }, errorProfile = function (err) {
              deferred.reject(err);
            };
            vm.setProfileData(type).then(successProfile, errorProfile);

          } else {
            vm.clearCookies(AppConstants.IDENTIFIER);
            currentUser = null;
            if (AppConstants.SESSION_ACTIVE === resp.data.message) {
              var success = function () {
                payload.userId = payload.username;
                vm.forceLogout(payload)
                $rootScope.$emit('loginPage');
              }
              ModalService.sessionActive({}, success, function () {});
              deferred.resolve();
            }
            else {
              deferred.reject(resp.data);
            }
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      if(type === 'ThroughPassword'){
        var header = {
          'Authorization': UtilService.converter('VjzqCbz-11mcD8tdiLD9cjKj460qo_mmUYbh_tMueWaBJoqhc5_Y_efRYitICVHGdT6kGG2oI3jVL5aYTa65P1Q5cD5rRIR-0kb7vNz047SZCJVrtGgYgGfbvudJ1s3FN6kKuYtomo3reEzWwa31B-EWk933nAeHhTHsGuwn3JE='),
          'Content-Type': 'application/x-www-form-urlencoded',
          'login-type' : (payload && payload.additionalFactor) ? 'PAN_OTP' :'OTP',
          'secret-link' : singleUseURL,
          'X-API-VERSION':'4'
        }
      }

      else if(type === 'OTP'){
        header = {
          'Authorization': UtilService.converter('VjzqCbz-11mcD8tdiLD9cjKj460qo_mmUYbh_tMueWaBJoqhc5_Y_efRYitICVHGdT6kGG2oI3jVL5aYTa65P1Q5cD5rRIR-0kb7vNz047SZCJVrtGgYgGfbvudJ1s3FN6kKuYtomo3reEzWwa31B-EWk933nAeHhTHsGuwn3JE='),
          'Content-Type': 'application/x-www-form-urlencoded',
          'login-type' : (payload && payload.additionalFactor) ? 'DOB_OTP' :'OTP',
          'secret-link' : singleUseURL,
          'X-API-VERSION':'4'
        }
      }
      else if(type === 'MOBILE_NO'){
        header = {
          'Authorization': 'Basic bG9naW4tbW9iaWxlLWJhc2VkLWludi1jbGllbnQ6TG9naW5Nb2JpbGVCYXNlZEludmVzdG9y',
          'Content-Type': 'application/x-www-form-urlencoded',
          'login-type' : 'MOBILE_NO',
          'secret-link' : singleUseURL,
          'X-API-VERSION':'4'
        }
      }

      else if(type === 'SWITCH_MTOKEN_TO_ETOKEN'){
        //add berer token key
        header = {
          'Authorization': UtilService.converter('VjzqCbz-11mcD8tdiLD9cjKj460qo_mmUYbh_tMueWaBJoqhc5_Y_efRYitICVHGdT6kGG2oI3jVL5aYTa65P1Q5cD5rRIR-0kb7vNz047SZCJVrtGgYgGfbvudJ1s3FN6kKuYtomo3reEzWwa31B-EWk933nAeHhTHsGuwn3JE='),
          'Content-Type': 'application/x-www-form-urlencoded',
          'login-type' : 'MOBILE_NO',
          'app-type': 'W'
        }
      }

      if(sessionStorage.trackerId && sessionStorage.trackerSource){
        header.sessionId = sessionStorage.trackerId;
        header.source = sessionStorage.trackerSource;
      }

      $http({
        method: 'POST',
        url: _path,
        headers: header ,
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: payload
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Authenticate instant user and save token
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.InstantLogin = function (payload) {
      vm.arn = false;
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + HDFC_API.VERSION + '/oauth/token',
        success = function (resp) {
          if (resp.data && resp.data.access_token) {
            vm.clearCookies(AppConstants.INSTA_IDENTIFIER);
            if($rootScope.flowNameFromEcart && $rootScope.flowNameFromEcart == 'E_CART'){
              vm.setToken(resp.data);
            } else {
              vm.setInstaToken(resp.data);
            }
            currentUserInstant = resp.data;
            if(vm.arn){
              deferred.resolve(currentUserInstant);
            }else{
            var successProfile = function (respProfile) {
                if (respProfile.status && respProfile.data) {
                  var identifierData = vm.getInstaToken();
                  identifierData.ekycverified = respProfile.data ? respProfile.data.ekycverified : '';
                  identifierData.folioNumber = respProfile.data ? respProfile.data.folioNumber : '';
                  identifierData.investorName = respProfile.data ? respProfile.data.investorName : '';
                  identifierData.biometricVerified = respProfile.data ? respProfile.data.biometricVerified : false;
                  identifierData.minor = respProfile.data ? respProfile.data.minor : '';
                  identifierData.maxAmount = respProfile.data ? respProfile.data.maxAmount : '';
                  identifierData.investorPAN = respProfile.data ? respProfile.data.panNumber: '';
                  identifierData.encryptedPanNumber = respProfile.data ? respProfile.data.encryptedPanNumber : '';
                  identifierData.kycVerifiedFlag = respProfile.data ? respProfile.data.kycVerifiedFlag : '';
                  identifierData.kycMessage = respProfile.data ? respProfile.data.kycMessage : '';
                  identifierData.email = respProfile.data ? respProfile.data.investorEmail : 'NA';
                  identifierData.mobileNumber = respProfile.data ? respProfile.data.investorPhoneNumber : 'NA';
                  identifierData.inptType = respProfile.data.invType;
                  vm.setInstaToken(identifierData);
                  deferred.resolve(identifierData);

                } else {
                  vm.clearCookies(AppConstants.INSTA_IDENTIFIER);
                  currentUser = null;
                  deferred.reject(respProfile);
                }
              },
              errorProfile = function (err) {
                vm.clearCookies(AppConstants.INSTA_IDENTIFIER);
                currentUser = null;
                deferred.reject(err);
              };

              InvestorService.post({
                child1: 'insta',
                child2: 'investor',
                child3: 'profile'
              }, {}).$promise.then(successProfile, errorProfile);
            }
          } else {
            vm.clearCookies(AppConstants.INSTA_IDENTIFIER);
            currentUserInstant = null;
            if(resp.data.popupEnabled) {
              ModalService.genericModal({
                text: resp.data.message
              });
              deferred.reject();
            } else{
              deferred.reject(resp.data);
            }
          }
        },
        error = function (err) {
          vm.clearCookies(AppConstants.INSTA_IDENTIFIER);
          currentUser = null;
          deferred.reject(err);
        };

        if(payload.type == 'arn'){
          var header = {
            'Authorization': UtilService.converter('ObwqCoUIiFXIH4GQHm_3YvpGSxUpPKIhXswAXSucFUZxuvVFOfRUVVI5LZVaePMx9t3LBQ3eBuD4vIxoLDgfDgWCElHR-t85nKAR_OVhiPMYxnqsoRpIO9Hlhl9ekK-IzMmfmabEyzjteot4EuIkKvhn1pIgAWqf8_TadVy6kq0='),
            'Content-Type': 'application/x-www-form-urlencoded',
            'secret-link': '8b5c3102-5191-40fc-a5f4-6bb34ca798a1',
            'X-API-VERSION':'4'
          };
          delete payload['type'];
          vm.arn = true;
        }else{
          var header = {
              'Authorization': UtilService.converter('HqAjxwfhU3Nrs_BLeQ5uGEjMnJ9FS0O6x2cBVheGc332EUZey-mfQknQrofMH545_VRPVUKKsdgekeh6wS_tZYnuPO9wMc-4rx5lt0atpTEEiTui2llGkr18qDX0aRVlCaiitIGNvHy-_Rj4JxrTAFEXLfYV6G-ti2VVP03aea0='),
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-API-VERSION':'4'
            };
        }


      if(sessionStorage.trackerId && sessionStorage.trackerSource){
        header.sessionId = sessionStorage.trackerId;
        header.source = sessionStorage.trackerSource;
      }

      $http({
        method: 'POST',
        url: _path,
        headers: header ,
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: payload
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * function callCommonServiceUrl
     *
     * @return {Promise}
     */
    vm.callCommonServiceUrl = function (payload) {
      var deferred = $q.defer(),
      _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/data/status',
      success = function (resp) {
        deferred.resolve(resp.data);
      }, error = function (err) {
        deferred.reject(err);
      };
      $http({
        url: _path,
        method: 'POST',
        data: payload,
        transformResponse: [function (data) {
          return data;
        }]
      }).then(success, error);
      /*$http.post(_path, payload, {
        timeout: 120000
      }).then(success, error);*/
      return deferred.promise;
    };
    /**
     * Check validation of user track id
     *
     * @return {Promise}
     */
    vm.verifyTrackId = function (payload) {
      vm.logout();
      vm.logoutInstantLogin()
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/userBehavior/'+ payload.trackId+'/validate',
        success = function (resp) {
          deferred.resolve(resp.data);

        }, error = function (err) {
          deferred.reject(err);
        };
      $http.get(_path).then(success, error);
      return deferred.promise;
    };

    /**
     * Get refresh token
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.getRefreshToken = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + HDFC_API.VERSION + '/oauth/token',
        success = function (resp) {
          if (resp.data && resp.data.access_token) {
            resp.data['userId'] = payload.userId;
            if(payload.type && payload.type ==="instaToken"){//check for insta login
              var identifierData = vm.getInstaToken();
              if(angular.isDefined(identifierData)){
                identifierData.access_token = resp.data.access_token;
                vm.setInstaToken(identifierData);
                sessionStorage.isLoggedIn = true;
                currentUser = resp.data;
                deferred.resolve(resp.data);
              }else{
                deferred.reject(resp.data);
              }
            }else{
              identifierData = vm.getToken();
              if(angular.isDefined(identifierData)){
                identifierData.access_token = resp.data.access_token;
                vm.setToken(identifierData);
                sessionStorage.isLoggedIn = true;
                currentUser = resp.data;
                deferred.resolve(resp.data);
              }else{
                deferred.reject(resp.data);
              }
            }
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
            deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: {
          'Authorization': UtilService.converter('VjzqCbz-11mcD8tdiLD9cjKj460qo_mmUYbh_tMueWaBJoqhc5_Y_efRYitICVHGdT6kGG2oI3jVL5aYTa65P1Q5cD5rRIR-0kb7vNz047SZCJVrtGgYgGfbvudJ1s3FN6kKuYtomo3reEzWwa31B-EWk933nAeHhTHsGuwn3JE='),
          'Content-Type': 'application/x-www-form-urlencoded',
          'app-type': 'W'
        },
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: {
          "grant_type": "refresh_token",
          "refresh_token": payload.refresh_token
        }
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Get refresh token new investor
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.getRefreshTokenForNewInvestor = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + HDFC_API.VERSION + '/oauth/token',
        success = function (resp) {
          if (resp.data && resp.data.access_token) {
            resp.data['userId'] = payload.userId;
             var identifierData = vm.getToken();
              if(angular.isDefined(identifierData)){
                identifierData.access_token = resp.data.access_token;
                vm.setToken(identifierData);
                sessionStorage.isLoggedIn = true;
                currentUser = resp.data;
                deferred.resolve(resp.data);
              }else{
                deferred.reject(resp.data);
              }
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };
      $http({
        method: 'POST',
        url: _path,
        headers: {
          'Authorization': UtilService.converter('MgMTejkFeIh5e1bLdRf_nAp8kOX27OjjkDl3LoJwHwiH0jFDu7aHeRPCTp2eUeUdzESpOemA4Ge1yma6S9T5JPsMy6_vtU_eyN5yAbSq82GiSvEff0RM_Lr7C6czy8d3DQ_otggJgC_5wGMqQSmj5jb2-E6MRxTbYFT8DFU-1qk='), //new Auth for new-investor journey
          'Content-Type': 'application/x-www-form-urlencoded',
          'app-type': 'W'
        },
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: {
          "grant_type": "refresh_token",
          "refresh_token": payload.refresh_token
        }
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Get refresh token for insta
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.getRefreshToken4Insta = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + HDFC_API.VERSION + '/oauth/token',
        success = function (resp) {
          if (resp.data && resp.data.access_token) {
            // resp.data['userId'] = payload.userId;
            var identifierData = vm.getInstaToken();
            if(angular.isDefined(identifierData)){
              identifierData.access_token = resp.data.access_token;
              vm.setInstaToken(identifierData);
              sessionStorage.isLoggedIn = true;
              currentUser = resp.data;
              deferred.resolve(resp.data);
            }else{
              deferred.reject(resp.data);
            }
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: {
          'Authorization': UtilService.converter('HqAjxwfhU3Nrs_BLeQ5uGEjMnJ9FS0O6x2cBVheGc332EUZey-mfQknQrofMH545_VRPVUKKsdgekeh6wS_tZYnuPO9wMc-4rx5lt0atpTEEiTui2llGkr18qDX0aRVlCaiitIGNvHy-_Rj4JxrTAFEXLfYV6G-ti2VVP03aea0='),
          'Content-Type': 'application/x-www-form-urlencoded',
          'app-type': 'W'
        },
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: {
          "grant_type": "refresh_token",
          "refresh_token": payload.refresh_token
        }
      }).then(success, error);
      return deferred.promise;
    };


    /**
     * Get refresh token
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.getRefreshTokenGateway = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + HDFC_API.VERSION + '/oauth/token',
        success = function (resp) {
          if (resp.data && resp.data.access_token) {
            resp.data['userId'] = payload.userId;
            if(payload.type && payload.type ==="instaToken"){//check for insta login
              var tokenData = vm.getInstaToken();
              if(angular.isDefined(tokenData)){
                tokenData.access_token = resp.data.access_token;
                vm.setInstaToken(tokenData);
                sessionStorage.isLoggedIn = true;
                currentUser = resp.data;
                deferred.resolve(resp.data);
              }else{
                deferred.reject(resp.data);
              }
            }else{
              tokenData = vm.getToken();
              if(angular.isDefined(tokenData)){
                tokenData.access_token = resp.data.access_token;
                vm.setToken(tokenData);
                sessionStorage.isLoggedIn = true;
                currentUser = resp.data;
                deferred.resolve(resp.data);
              }else{
                deferred.reject(resp.data);
              }
            }
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: {
          'Authorization': 'Basic Z3ctY2xpZW50Omd3LXNlY3JldA==',
          'Content-Type': 'application/x-www-form-urlencoded',
          'app-type': 'W'
        },
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: {
          "grant_type": "refresh_token",
          "refresh_token": payload.refreshToken
        }
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Will send an email with new password
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
    vm.forgotPassword = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/password/forgot',
        success = function (resp) {
          if (resp.data) {
            deferred.resolve(resp.data);
          }
          // else {
          //   deferred.reject(resp.data);
          // }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: {'app-type': 'W'},
        transformResponse: [function (data) {
          return data;
        }],
        data: {userId: payload.userId}
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Will verify new password
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
    vm.verifyForgotPassword = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/distributor/' + payload.userId + '/password/forgot/request/' + payload.secretKey + '/verify',
        success = function (resp) {
          if (resp.data && resp.data.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: {'app-type': 'W'},
        data: {userId: payload.userId, secretKey: payload.secretKey},
        transformResponse: [function (data) {
          return data;
        }]
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Will reset password
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
    vm.resetPassword = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/password/reset',
        success = function (resp) {
          if (resp.data && resp.data.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({method: 'POST', url: _path, data: payload, transformResponse: [function (data) {
        return data;
      }]}).then(success, error);
      return deferred.promise;
    };

    vm.changePassword = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/change-password',
        success = function (resp) {
          if (resp && resp.data) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({method: 'POST', url: _path, data: payload, transformResponse: [function (data) {
        return data;
      }]}).then(success, error);
      return deferred.promise;
    };

    /**
     * Get refresh token
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.getRefreshTokenGateway = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + HDFC_API.VERSION + '/oauth/token',
        success = function (resp) {
          if (resp.data && resp.data.access_token) {
            resp.data['userId'] = payload.userId;
            if(payload.type && payload.type ==="instaToken"){//check for insta login
              var identifierData = vm.getInstaToken();
              if(angular.isDefined(identifierData)){
                identifierData.access_token = resp.data.access_token;
                vm.setInstaToken(identifierData);
                sessionStorage.isLoggedIn = true;
                currentUser = resp.data;
                deferred.resolve(resp.data);
              }else{
                deferred.reject(resp.data);
              }
            }else{
              identifierData = vm.getToken();
              if(angular.isDefined(identifierData)){
                identifierData.access_token = resp.data.access_token;
                vm.setToken(identifierData);
                sessionStorage.isLoggedIn = true;
                currentUser = resp.data;
                deferred.resolve(resp.data);
              }else{
                deferred.reject(resp.data);
              }
            }
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: {
          'Authorization': 'Basic Z3ctY2xpZW50Omd3LXNlY3JldA==',
          'Content-Type': 'application/x-www-form-urlencoded',
          'app-type': 'W'
        },
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: {
          "grant_type": "refresh_token",
          "refresh_token": payload.refreshToken
        }
      }).then(success, error);
      return deferred.promise;
    };
    /**
     * Will generate a new one time password
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
    vm.generateOtp = function (payload, from) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/registration/otp/generate';
        var headers = {'X-API-VERSION':'2'};
      if (from === 'fromLogin') {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/login/otp/generate';
        headers= {'X-API-VERSION':'4'}
      }

      if (from === 'fromLoginMobile') {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/mobile/login/otp/generate';
        headers= {'X-API-VERSION':'4'}
      }
      if (from === 'fromExposedStatements') {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/exposed/statement/authenticateFolioNumber'
      }

      if (from === 'fromPanDob') {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/instant/investment/send/otp'
      }

      var success = function (resp) {
        if (resp.data && resp.status) {
          if (AppConstants.SESSION_ACTIVE === resp.data.message) {
            var success = function () {
              vm.forceLogout(payload)
            }
            ModalService.sessionActive({}, success, function () {});
            deferred.resolve();
          }
          else  {
            if(resp.data.popupEnabled) {
              ModalService.genericModal({
                text: resp.data.message
              });
              deferred.resolve();
              LoaderService.hideLoader();
            } else {
              deferred.resolve(resp.data);
            }
          }
        } else {
          deferred.reject(resp);
        }
      },
        error = function (err) {
          deferred.reject(err);
        };

      $http({method: 'POST', url: _path,headers:headers, data: payload, transformResponse: TransformResponse.transformApiResponse}).then(success, error);
      return deferred.promise;
    };



    vm.forceLogout = function (payload){
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp && resp.status) {
            var mobileTokenData = vm.getMobileLoginToken();
            sessionStorage.clear();
            if(mobileTokenData && payload && !payload.mobile){
              MessageService.success(resp.message)
              vm.setMobileLoginToken(mobileTokenData);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      if(payload.userIdDetails){
        var tempPayload = {
          pan:payload.username,
          userId:payload.userIdDetails
        }
        payload = tempPayload;
      }
      if(payload && payload.mobile){
        InvestorService.post({child1: 'mobile', child2: 'force', child3: 'logout'}, payload).$promise.then(success, error);
      }else{
        InvestorService.post({child1: 'force', child2: 'logout'}, payload).$promise.then(success, error);
      }
    }

    /* vm.verifyDetails = function (payload) {
     var deferred = $q.defer(),
     _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/registration/verifyKYC';
     var success = function (resp) {
     if (resp.data && resp.status) {
     deferred.resolve(resp.data);
     } else {
     deferred.reject(resp);
     }
     },
     error = function (err) {
     deferred.reject(err);
     };

     $http({method: 'POST', url: _path, data: payload}).then(success, error);
     return deferred.promise;
     };*/

    /**
     * Will regenerate a new one time password
     *
     * @param registrationRequestId     - user registration Id
     * @return {Promise}
     */
    vm.reGenerateOtp = function (registrationRequestId,payload,from) {
      var deferred = $q.defer();
        if(from === 'fromLogin'){
        var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/login/otp/resend';
        var data = payload;
      }else if(from === 'fromMobileLogin'){
        var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/mobile/login/otp/resend';
        var data = payload;
      }
      else{
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/registration/otp/regenerate';
        data = {registrationRequestId: registrationRequestId};
      }
       var success = function (resp) {
          if (resp.data && resp.data.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

        $http({method: 'POST', url: _path, data: data, transformResponse: TransformResponse.transformApiResponse}).then(success, error);
      return deferred.promise;
    };

    /**
     * Will verify new generated otp
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
    vm.verifyOtp = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/registration/otp/verify',
        success = function (resp) {
          if (resp.data && resp.data.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({method: 'POST', url: _path, data: payload, transformResponse: [function (data) {
          return data;
      }]}).then(success, error);
      return deferred.promise;
    };

    /**
     * removes token when user logged out
     */
    vm.logout = function (from) {
      sessionStorage.setItem('doLogOut',true);//variable to handle logout after session expired
      var deferred = $q.defer(),
        token = vm.getToken(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/logout',
        success = function (resp) {
          if (resp.data && resp.status) {
            vm.clearCookies(AppConstants.IDENTIFIER);
            sessionStorage.removeItem('shownPopupOfNomination');
            if (from !== 'pre-login') {
              ModalService.logoutSuccess();
            }
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      if (token && token.access_token) {
        $http.post(_path, null, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(success, error);
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    };
    /**
     * removes token when user logged out
     */
    vm.logoutInstantLogin = function () {
      var deferred = $q.defer(),
        token = vm.getInstaToken(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/instant/investor/logout',
        success = function (resp) {
          currentUserInstant = null;
          vm.clearCookies(AppConstants.INSTA_IDENTIFIER);
          localStorage.setItem('loggedIn', false);
          localStorage.removeItem('QuickInvestmentSecreteLink');
          if (resp.data && resp.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.status);
          }
        },
        error = function (err) {
          currentUserInstant = null;
          vm.clearCookies(AppConstants.INSTA_IDENTIFIER);
          deferred.reject(err);
        };

      if (token && token.access_token) {
        $http.post(_path, {}).then(success, error);
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    };

    /**
     * Verify password reset token
     *
     * @param  {String}   token
     * @return {Promise}
     */
    vm.verifyToken = function (token) {
      var deferred = $q.defer();
      UserService.verifyToken({
        token: token
      }, function (user) {
        deferred.resolve(user);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    /**
     * Gets all available info on authenticated user
     *
     * @return {Object} user
     */
    vm.getCurrentUser = function () {
      var deferred = $q.defer();
      if (currentUser) {
        deferred.resolve(currentUser);
      } else if (!currentUser && vm.getToken()) {
        currentUser = vm.getToken();
        deferred.resolve(currentUser);
      } else {
        deferred.reject('User not logged-in');
      }
      return deferred.promise;
    };

    /**
     * get role of logged in user
     *
     * @return {String}
     */
    vm.getRole = function () {
      if (currentUser && currentUser.hasOwnProperty('role')) {
        return currentUser.role;
      }
      return null;
    };

    /**
     * Waits for currentUser to resolve before checking if user is logged in
     */
    vm.isLoggedIn = function () {
      var deferred = $q.defer(), resp = {isLoggedIn: false};/*, isAuthorized: false*/
      if (!sessionStorage.isLoggedIn) {
        deferred.resolve(resp);
      } else if (!currentUser) {
        vm.getCurrentUser().then(function (user) {
          currentUser = user;
          //resp.isAuthorized = vm.hasFolioAuthorizationCheck(currentUser, toState);
          resp.isLoggedIn = true;
          deferred.resolve(resp);
        }, function () {
          currentUser = null;
          deferred.resolve(resp);
        });
      } else if (currentUser && vm.getToken()) {
        //resp.isAuthorized = vm.hasFolioAuthorizationCheck(currentUser, toState);
        resp.isLoggedIn = true;
        deferred.resolve(resp);
      } else if (currentUser.hasOwnProperty('role')) {
        //resp.isAuthorized = vm.hasFolioAuthorizationCheck(currentUser, toState);
        resp.isLoggedIn = true;
        deferred.resolve(resp);
      } else {
        deferred.resolve(resp);
      }
      return deferred.promise;
    };

    vm.isInstantLoggedIn = function () {
      var deferred = $q.defer(), resp = {isLoggedIn: false};
      if (!currentUserInstant) {
        currentUserInstant = vm.getInstaToken();
        if (currentUserInstant && currentUserInstant.access_token) {
          resp.isLoggedIn = true;
        }
      } else if (currentUserInstant && currentUserInstant.access_token) {
        resp.isLoggedIn = true;
      }
      deferred.resolve(resp);
      return deferred.promise;
    };

    /**
     * Get user token
     */
    vm.getToken = function () {
      var ciphertext = sessionStorage.getItem(AppConstants.IDENTIFIER);
      /*Decrypt*/
      if(ciphertext){
        var bytes = FormatterService.getProtoType(ciphertext.toString(), AppConstants.IDENTIFIER);
        var cookieData = $window.JSON.parse(bytes.toString(FormatterService.hash.enc.Utf8));
        return cookieData;
      }else{
        return;
      }
    };
    /**
     * Get user Insta token
     */
    vm.getInstaToken = function () {
      var ciphertext = $cookies.get(AppConstants.INSTA_IDENTIFIER);
      /*Decrypt*/
      if(ciphertext){
        var bytes = FormatterService.getProtoType(ciphertext.toString(), AppConstants.INSTA_IDENTIFIER);
        var cookieData = $window.JSON.parse(bytes.toString(FormatterService.hash.enc.Utf8));
        return cookieData;
      }else{
        return;
      }
    };
    /**
     * Set the cookies with encrypted token name
     */
    vm.setToken = function (data) {
      /*Encrypt*/
      var ciphertext = FormatterService.hash.AES.encrypt($window.JSON.stringify(data), AppConstants.IDENTIFIER);
      //$cookies.put(AppConstants.IDENTIFIER, ciphertext);
      sessionStorage.setItem(AppConstants.IDENTIFIER, ciphertext);
    }
    /**
     * Set the cookies with encrypted user info
     */
    vm.setUserCookies = function (data) {
      /*Encrypt*/
      var ciphertext = FormatterService.hash.AES.encrypt($window.JSON.stringify(data), AppConstants.USER_CONFIG);
      //AppConstants.COOKIE_CONFIG.path = HDFC_API.PATH;
      $cookies.put(AppConstants.USER_CONFIG, ciphertext);

    }
    /**
     * GET the cookies of user info
     */
    vm.getUserCookies = function () {
      var ciphertext = $cookies.get(AppConstants.USER_CONFIG);
      /*Decrypt*/
      if(ciphertext){
        var bytes = FormatterService.getProtoType(ciphertext.toString(), AppConstants.USER_CONFIG);
        return $window.JSON.parse(bytes.toString(FormatterService.hash.enc.Utf8));
      }else{
        return;
      }
    }

    /**
     * Set the cookies with encrypted token name
     */
    vm.setInstaToken = function (data) {
      /*Encrypt*/
      if (vm.getInstaToken()) {
        vm.clearCookies(AppConstants.INSTA_IDENTIFIER);
      }
      var ciphertext = FormatterService.hash.AES.encrypt($window.JSON.stringify(data), AppConstants.INSTA_IDENTIFIER);
      //AppConstants.COOKIE_CONFIG.path = HDFC_API.PATH;
      $cookies.put(AppConstants.INSTA_IDENTIFIER, ciphertext, AppConstants.COOKIE_CONFIG);

    }

    /**
     * Set the cookies with encrypted token name
     */
    vm.setNewInvestorToken = function (data) {
      /*Encrypt*/
      var ciphertext = FormatterService.hash.AES.encrypt($window.JSON.stringify(data), AppConstants.NEW_INVESTOR_IDENTIFIER);
      //AppConstants.COOKIE_CONFIG.path = HDFC_API.PATH;
      $cookies.put(AppConstants.NEW_INVESTOR_IDENTIFIER, ciphertext, AppConstants.COOKIE_CONFIG);

    }

    vm.clearCookies = function (token) {
      $cookies.remove(token, AppConstants.COOKIE_CONFIG);
      $log.info("After deleting from cookies service", vm.getInstaToken(token));
      if (token === AppConstants.INSTA_IDENTIFIER) {
        var instaTokenEncoded = encodeURIComponent(token);
        if (instaTokenEncoded) {
          $cookies.remove(instaTokenEncoded, AppConstants.COOKIE_CONFIG);
          $cookies.remove(instaTokenEncoded, {path: "/instantInvest"});
          $cookies.remove(AppConstants.INSTA_IDENTIFIER, {path: "/"});
          $cookies.remove(AppConstants.INSTA_IDENTIFIER, {path: "/instantInvest"});
        }
        $cookies.remove(token, {path: "/instantInvest"});
        $log.info("After deleting from encode URI service", vm.getInstaToken(instaTokenEncoded));
      }
      currentUser = null;
      sessionStorage.setItem('loggedIn', false);
      sessionStorage.isLoggedIn = false;
      localStorage.removeItem('folioId');
      localStorage.removeItem('transactionData');
      localStorage.removeItem('summaryReview');
      localStorage.removeItem('summaryDetails');
      sessionStorage.removeItem('emailIdExist');
      localStorage.removeItem('schemeName');
      localStorage.removeItem('overviewData');
      localStorage.removeItem('updateIFSC');
      localStorage.removeItem('deletedSubscriptions');
      localStorage.removeItem('bankDetails');
      localStorage.removeItem('rollOverRequest');
      localStorage.removeItem('isRefreshing');
      localStorage.removeItem('wantToAddNomineeLater');
      localStorage.removeItem('type');
      localStorage.removeItem('cobmDetailList');
      localStorage.removeItem('panNo');
      localStorage.removeItem('dob');
      sessionStorage.removeItem('doLogOut');
      localStorage.removeItem('isWelcomeMessageShown');
      localStorage.removeItem('folioTaxStatusCode');
      localStorage.removeItem('distributorDetails');
      sessionStorage.removeItem('contactUpdateCo');
      sessionStorage.removeItem('savedFromFirstStep');
      sessionStorage.removeItem('isFolioSelected');
      localStorage.removeItem('identifierData');
      sessionStorage.removeItem('folioNumber');
      sessionStorage.removeItem(token);
      sessionStorage.removeItem('investorDetails');
      sessionStorage.removeItem('brokerDetailsUpdated');
      sessionStorage.removeItem('folioNumber');
      sessionStorage.removeItem('brokerDetailsSelected');
      sessionStorage.removeItem('ecartObj');
    };
    /**
     * Get instant login user token
     */
    vm.getInstantLoginToken = function () {

      var ciphertext = $cookies.get(AppConstants.INSTA_IDENTIFIER);
      /*Decrypt*/
      if(ciphertext){
        var bytes = FormatterService.getProtoType(ciphertext.toString(), AppConstants.INSTA_IDENTIFIER);
        return $window.JSON.parse(bytes.toString(FormatterService.hash.enc.Utf8));
      }else{
        return;
      }


      var tokenInstant = $cookies.get('token_data_instant');
      try {
        tokenInstant = angular.fromJson(tokenInstant);
      } catch (e) {
        $log.info('Json parse exception', e);
        tokenInstant = '';
      }
      if (tokenInstant && tokenInstant.token) {
        return tokenInstant;
      } else {
        return {};
      }
    };

    /**
     * Set the password with RSA encrypted
     */
    vm.encryptRSA = function (data) {
      return FormatterService.getFormatter().encrypt(data);
    }

    /**
     * This function is used to check initial login by user
     * @param userId
     * @returns {Function}
     */
    vm.isInitialLogin = function (userId) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/profile',
        success = function (resp) {
          (resp && resp.data) ? deferred.resolve(resp.data) : deferred.resolve(resp);
        },
        error = function (err) {
          deferred.reject(err);
        };
      $http.post(_path,
        {userId: userId}
      ).then(success, error);
      return deferred.promise;
    };

    vm.newInvestorLogin = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + HDFC_API.VERSION + '/oauth/token',
        success = function (resp) {
          if (resp.data && resp.data.access_token) {
            vm.clearCookies(AppConstants.NEW_INVESTOR_IDENTIFIER);
            vm.setNewInvestorToken(resp.data);
            newInvestor = resp.data;
            deferred.resolve(resp.data);
          } else {
            vm.clearCookies(AppConstants.NEW_INVESTOR_IDENTIFIER);
            newInvestor = null;
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          vm.clearCookies(AppConstants.NEW_INVESTOR_IDENTIFIER);
          newInvestor = null;
          deferred.reject(err);
        };


      var header = {
        'Authorization': UtilService.converter('MgMTejkFeIh5e1bLdRf_nAp8kOX27OjjkDl3LoJwHwiH0jFDu7aHeRPCTp2eUeUdzESpOemA4Ge1yma6S9T5JPsMy6_vtU_eyN5yAbSq82GiSvEff0RM_Lr7C6czy8d3DQ_otggJgC_5wGMqQSmj5jb2-E6MRxTbYFT8DFU-1qk='),
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-api-version': '4'
      };


      if(sessionStorage.trackerId && sessionStorage.trackerSource){
        header.sessionId = sessionStorage.trackerId;
        header.source = sessionStorage.trackerSource;
      }

      $http({
        method: 'POST',
        url: _path,
        headers: header ,
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: payload
      }).then(success, error);
      return deferred.promise;
    };


    /**
     * Get mobile login user token
     */
    vm.getMobileLoginToken = function () {
      var ciphertext = sessionStorage.getItem(AppConstants.MOBILE_IDENTIFIER);
      /*Decrypt*/
      if(ciphertext){
        var bytes = $window.CryptoJS.AES.decrypt(ciphertext.toString(), AppConstants.MOBILE_IDENTIFIER);
        var sessionData = $window.JSON.parse(bytes.toString($window.CryptoJS.enc.Utf8));
        return sessionData;
      }else{
        return;
      }
    };
     /**
     * Set the cookies with encrypted mobile login  token name
     */
    vm.setMobileLoginToken = function (data) {
      /*Encrypt*/
      var ciphertext = $window.CryptoJS.AES.encrypt($window.JSON.stringify(data), AppConstants.MOBILE_IDENTIFIER);
      //$cookies.put(AppConstants.IDENTIFIER, ciphertext);
      sessionStorage.setItem(AppConstants.MOBILE_IDENTIFIER, ciphertext);
    }
    vm.logoutMobileToke = function (mobile){
      var success = function (resp) {
          if (resp && resp.status) {
          } else {
          }
        },error = function () {
        };
        InvestorService.post({child1: 'mobile', child2: 'force', child3: 'logout'}, {"mobile":vm.encryptRSA(angular.copy(mobile))}).$promise.then(success, error);
      }

    // Mobile Token logout
    vm.mobileTokenLogout = function (payload){
      var deferred = $q.defer()
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp && resp.status) {
            sessionStorage.clear();
            $cookies.remove(AppConstants.USER_COOKIES);
            deferred.resolve(resp);
            return;
          } else {
            MessageService.error(resp.message);
            deferred.reject(resp);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          deferred.reject(err);
        };
      LoaderService.showLoader();
      if(payload && payload.forceLogout){
        delete payload.forceLogout;
        InvestorService.post({child1: 'mobile', child2: 'force', child3: 'logout'}, payload).$promise.then(success, error);
      }else{
        InvestorService.post({child1: 'mobile', child2:'logout'}, {}).$promise.then(success, error);
      }
      return deferred.promise;
    }
    /**
     * get user linked account data  from api and save data
     *
     */
      vm.getLinkedPanDetails = function () {
        var deferred = $q.defer()
        var success = function (resp) {
          if (resp.data && resp.status) {
            // set current session
            var locselectedLinkPanData = sessionStorage.getItem('selectedLinkPanData');
            var selectedLinkPan = {};
            if(locselectedLinkPanData){
              locselectedLinkPanData = $window.CryptoJS.AES.decrypt(locselectedLinkPanData.toString(), 'LinkPanData');
              locselectedLinkPanData = $window.JSON.parse(locselectedLinkPanData.toString($window.CryptoJS.enc.Utf8));
              selectedLinkPan = locselectedLinkPanData;
            }
            //
            var linkPanData = resp.data;
            var result = {
              'status':true,
              'data':[]
            };
            var data = {};
            data.panNumber = linkPanData.panNumber;
            data.default = true;
            data.investorName = linkPanData.primaryPanInvestorName;
            data.investorFirstName =  data.investorName? data.investorName.split(' ')[0]:'';
            result.data.push(data);
            // check selected pan is valid or not
            var isSelectedPanValid = false;
            if(linkPanData && linkPanData.panNameList && linkPanData.panNameList.length > 0){
            for (var i = 0; i < linkPanData.panNameList.length; i++) {
              if(selectedLinkPan && selectedLinkPan.panNumber == linkPanData.panNameList[i].panNumber){
                isSelectedPanValid = true;
                linkPanData.panNameList[i].selected = true;
              }
              result.data.push(linkPanData.panNameList[i]);
              }
            }
            // if not selected then set default pan
            if(!isSelectedPanValid){
              result.data[0].selected = true;
              if(selectedLinkPan && selectedLinkPan.panNumber){
                vm.checkLinkedUserStatus();
              }
            }
            deferred.resolve(result);
            return;
          } else {
            MessageService.error(resp.message);
            deferred.reject(resp);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };
        var isLoggedInUser = vm.getToken();
        if(isLoggedInUser && isLoggedInUser.access_token){
          InvestorService.post({
            child1: 'switch',
            child2: 'user',
            child3: 'get',
            child4: 'linked',
            child5: 'pan',
            child6: 'list',
            child7: 'LINKED_PANS_LIST'
          }, {}).$promise.then(success, error);
        }else{
          deferred.reject();
        }
        return deferred.promise;
      }
    /**
    * Switch account pan
    */
    vm.switchAccountInLinkedPan = function (payload) {
      var deferred = $q.defer()
      var success = function (resp) {
        if (resp.status && resp.data) {
          resp.selectedLinkPan = payload;
          var encData = $window.CryptoJS.AES.encrypt($window.JSON.stringify(payload), 'LinkPanData');
          sessionStorage.setItem('selectedLinkPanData',encData);
          var successProfile = function (resp1) {
            if (resp1) {
              deferred.resolve(resp);
            }else {
              deferred.reject(resp1);
            }
          }, errorProfile = function (err1) {
            deferred.reject(err1);
          };
          vm.setProfileData().then(successProfile, errorProfile);
        }else{
          deferred.reject(resp);
        }
      },
      error = function (err) {
        deferred.reject(err);
      };
      var payload1 = {
        "panNumber": vm.encryptRSA(angular.copy(payload.panNumber))  ,
        "switchPanFlow":true
      }
      InvestorService.post({
        child1: 'switch',
        child2: 'user',
        child3: 'switch',
        child4: 'pan'
      },payload1).$promise.then(success, error);
      return deferred.promise;
    }

    // set Profile Data
    vm.setProfileData = function (type){
      var deferred = $q.defer()
      var successProfile = function (respProfile) {
        if (respProfile.status && respProfile.data.investorType) {
          ProfileFactory.set(respProfile.data);
          var identifierData = vm.getToken();
          identifierData.handshakeToken = respProfile.data ? respProfile.data.handshakeToken : '';
          identifierData.emailIdExist = respProfile.data ? respProfile.data.registrationDetails.emailIdExist : '';
          if (!identifierData.emailIdExist) {
            identifierData.folioNumber = respProfile.data ? respProfile.data.registrationDetails.folioNumber : '';
          }
          var taxIdentifier = respProfile.data ? (respProfile.data.panNumber || respProfile.data.investorPAN): '';
          respProfile.data.panNumber = taxIdentifier;
          if (respProfile.data.panNumber) {
            var header = respProfile.data.panNumber.substring(0, respProfile.data.panNumber.lastIndexOf("|"));
            var data = FormatterService.hash.enc.Base64.parse(respProfile.data.panNumber.substring(respProfile.data.panNumber.lastIndexOf("|") + 1, respProfile.data.panNumber.length));
            identifierData.investorPAN = FormatterService.readAesResponsePayload(FormatterService.getFormatterHDFC().decrypt(header), data);
          } else  {
            identifierData.investorPAN = '';
          }
          identifierData.investorFName = respProfile.data && respProfile.data.firstName ? respProfile.data.firstName : '';
          identifierData.investorMName = respProfile.data && respProfile.data.middleName ? respProfile.data.middleName : '';
          identifierData.investorLName = respProfile.data && respProfile.data.lastName ? respProfile.data.lastName : '';
          identifierData.investorFullName = identifierData.investorFName+' '+identifierData.investorMName+' '+identifierData.investorLName;
          identifierData.investorFullName = identifierData.investorFullName ? identifierData.investorFullName.trim() : '';
          identifierData.firstTimeLogin = respProfile.data ? respProfile.data.firstTimeLogin : false;
          identifierData.investorType = respProfile.data ? respProfile.data.investorType : '';
          identifierData.folioCreationEnabled = respProfile.data ? respProfile.data.folioCreationEnabled : '';
          identifierData.loginType = type ? type : 'ThroughPassword';
          identifierData.encryptedPanNumber = respProfile.data ? respProfile.data.encryptedPanNumber : '';
          identifierData.asPendingApprovalCount = respProfile.data ? respProfile.data.asPendingApprovalCount : 0;
          identifierData.profileImageUrl = respProfile.data ? respProfile.data.profileImageUrl : '';
          identifierData.hufUserFlag = respProfile.data.hufUserFlag;
          identifierData.landingPageType = respProfile.data ? respProfile.data.landingPageType : '';
          identifierData.email = respProfile.data ? respProfile.data.email : 'NA';
          identifierData.mobile = respProfile.data ? respProfile.data.mobile : 'NA';
          identifierData.corporateUserFlag = respProfile.data && respProfile.data.corporateUserFlag ? respProfile.data.corporateUserFlag  : false;
          // $cookies.put('token_data', angular.toJson(identifierData));
          vm.setToken(identifierData);
          sessionStorage.setItem('emailIdExist', identifierData.emailIdExist);
          currentUser = identifierData;
          deferred.resolve(identifierData);
          /*TRAI mobile check*/
          if (respProfile.data.hasOwnProperty("mobileActive")) {
            UtilService.mobileActiveStatus.set(respProfile.data.mobileActive);
            $window.sessionStorage.setItem('mobileActive', respProfile.data.mobileActive);
          }

        } else {
          vm.clearCookies(AppConstants.IDENTIFIER);
          currentUser = null;
          deferred.reject(respProfile.message);
        }
        sessionStorage.setItem("userId", respProfile.data.investorId);
        $window.dataLayer.push({'userId': respProfile.data.investorId});
      },
      errorProfile = function (err) {
        vm.clearCookies(AppConstants.IDENTIFIER);
        currentUser = null;
        deferred.reject(err);
      };

    InvestorService.post({
      child1: 'profile'
    }, {}).$promise.then(successProfile, errorProfile);
      return deferred.promise;
    }

      var accountLinkedListeners = {};
      accountLinkedListeners["SwitchPrimeInvestor"] = $rootScope.$on("SwitchPrimeInvestor", function () {
          var success = function(resp) {
            if (resp.status && resp.data) {
              MessageService.success(resp.data);
              $window.location.reload();
            }else{
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          }
          var error = function(err) {
            LoaderService.hideLoader();
            MessageService.error(err.message);
          }
          var primaryPan = sessionStorage.getItem('primaryPan');
          if(primaryPan){
            primaryPan = $window.CryptoJS.AES.decrypt(primaryPan.toString(), 'primaryPan');
            primaryPan = $window.JSON.parse(primaryPan.toString($window.CryptoJS.enc.Utf8));
          }
          var payload = {
            panNumber : primaryPan,
            default:true
          }
          LoaderService.showLoader();
          vm.switchAccountInLinkedPan(payload).then(success, error);
      });

      vm.checkLinkedUserStatus = function () {
        var success = function (resp) {
          LoaderService.hideLoader();
        }, error = function (err) {
          LoaderService.hideLoader();
        };
        var primaryPan = sessionStorage.getItem('primaryPan');
        if(primaryPan){
          primaryPan = $window.CryptoJS.AES.decrypt(primaryPan.toString(), 'primaryPan');
          primaryPan = $window.JSON.parse(primaryPan.toString($window.CryptoJS.enc.Utf8));
        }
        var profile = vm.getToken();
        var payload = {
          parentPanNumber: vm.encryptRSA(primaryPan),
          panNumber: vm.encryptRSA(profile.investorPAN)
        }
        if(primaryPan && profile && profile.investorPAN != primaryPan){
          LoaderService.showLoader();
          InvestorService.post({ child1: 'switch', child2: 'user',child3:'check',child4:'pan',child5:'linked' }, payload).$promise.then(success, error);
        }
      }
  }
})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .directive('savedItemsTupple', savedItemsTupple);

    /** @ngInject */
    function savedItemsTupple() {
        return {
            restrict: 'E',
            scope: {
                list: '=',
                view:'=',
                showMore:'=',
                showViewMoreFlag:'=',
                limit:"=",
                delete:"=",
                type:"@"
            },
            templateUrl: 'app/savedItems/components/savedItemsTupple.html'
        };
    }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PortfolioDetailController', PortfolioDetailController);

  /** @ngInject */
  function PortfolioDetailController(LoaderService, $scope, toastr, $log, AppConstants, MessageService, TransactionsService, UtilService, InvestorService,$state, TransactionModel,AuthService) {
    var vm = this;
    vm.fetchConstantData = fetchConstantData;
    vm.fetchSchemeType = fetchSchemeType;
    vm.fetchPortfolioData = fetchPortfolioData;
    vm.statusSchemeType = statusSchemeType;
    vm.transactionOverview = transactionOverview;
    vm.SCHEMETYPES = [{key: 'Scheme Type', value: 'ALL'}];
    vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.totalPortfolioData = 0;
    vm.currentPagePortfolio = 1;
    vm.pageLimitPortfolio = 25;
    vm.isPagination = false;
    vm.isLoading = false;
    vm.xirrInfo = AppConstants.XIRR_INFORMATION;
    vm.top_Up_label=AppConstants.ToastrMessage.VALIDATE_DATA.TOP_UP_LABEL;
    vm.fetchTopUpLabel=fetchTopUpLabel;
    AuthService.checkLinkedUserStatus();
    vm.init = function () {
      vm.pageLimitPortfolio = 25;
      fetchSchemeType();
      fetchPortfolioData();
      fetchTopUpLabel();
    };

    function statusSchemeType() {
      fetchPortfolioData();
    }


    function fetchConstantData() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            $log.info(resp.data);
            vm.constantData = resp.data;

            vm.purchaseValueCountUnit = UtilService.getUnitSting(vm.constantData.totalPurchaseValue);
            vm.constantData.totalPurchaseValue = vm.constantData.totalPurchaseValue?vm.constantData.totalPurchaseValue.toFixed(2):'';
            vm.currentValueCountUnit = UtilService.getUnitSting(vm.constantData.totalCurrentValue);
            vm.constantData.totalCurrentValue = vm.constantData.totalCurrentValue?vm.constantData.totalCurrentValue.toFixed(2):'';
          }
          else {
            vm.constantData = null;
            vm.purchaseValueCountUnit = '';
            vm.currentValueCountUnit = '';
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info("fetchConstantData error====", err);
        };
      InvestorService.post({
        child1: 'folio',
        child2: 'portfolio',
        child3: 'constantData'
      }, {}).$promise.then(success, error);

    }

    function fetchSchemeType() {
      var success = function (resp) {
          //vm.SCHEMETYPES = [{key: 'Scheme Type', value: 'ALL'}];
          if (resp.status && resp.data && resp.data.schemeType) {
            for (var i = 0; i < resp.data.schemeType.length; i++) {
              var obj = {
                key: resp.data.schemeType[i].charAt(0).toUpperCase() + resp.data.schemeType[i].substr(1),
                value: resp.data.schemeType[i]
              };
              vm.SCHEMETYPES.push(obj);
              //vm.SCHEMETYPES = vm.SCHEMETYPES.concat(resp.data.schemeType);
            }
            vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
          }
        },
        error = function (err) {
          $log.info('err ', err);
          vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
        };
      InvestorService.post({
        child1: 'schemeType'
      }, {}).$promise.then(success, error);
    }

    vm.selectTransaction = function (action, data) {

      var params = { folioNumber:data.folioNumber, sc : data.schemeCode };
      switch (action.toLocaleLowerCase()) {
        case 'stp':
          $state.go('main.transactions.stp', params );
          break;
        case 'swp':
          $state.go('main.transactions.swp',params);
          break;
        case 'redeem':
          $state.go('main.transactions.redemption',params);
          break;
        case 'switch':
          $state.go('main.transactions.switch',params);
          break;
        case 'sip':
          $state.go('main.transactions.sip',params);
          break;
      }

    }

    function fetchPortfolioData() {
      LoaderService.showLoader(".portfolio-loader");
      vm.isLoading = true;
      var portfolioPayload = {
        schemeType: vm.selectedSchemeType.toUpperCase(),
        pageIndex: vm.currentPagePortfolio - 1,
        pageLimit: vm.pageLimitPortfolio
      };
      var success = function (resp) {
          LoaderService.hideLoader(".portfolio-loader");
          if (resp.status && resp.data) {
            vm.portfolioData = resp.data.portfolioDTOs;
            vm.totalMarketValueCount = 0;
            vm.totalCostValueCount = 0;
            vm.portfolioData && vm.portfolioData.forEach(function (item) {
              item.purchaseValueUnit = UtilService.getUnitSting(item.purchaseValue);
              vm.totalMarketValueCount += +item.purchaseValue;
              item.currentValueUnit = UtilService.getUnitSting(item.currentValue);
              vm.totalCostValueCount += +item.currentValue;
            });

            vm.totalMarketValueCountUnit = UtilService.getUnitSting(vm.totalMarketValueCount);
            vm.totalCostValueCountUnit = UtilService.getUnitSting(vm.totalCostValueCount);
            vm.totalCostValueCount = vm.totalCostValueCount;
            vm.totalMarketValueCount = vm.totalMarketValueCount;

            if(resp.data && resp.data.portfolioConstantDataDTO){
              vm.constantDataDTO = resp.data.portfolioConstantDataDTO;
              $scope.Portfolio.constData = resp.data.portfolioConstantDataDTO.dematSchemeAvailable;
              vm.purchaseValueCountUnit = UtilService.getUnitSting(resp.data.portfolioConstantDataDTO.totalPurchaseValue);
              vm.totalPurchaseValue = resp.data.portfolioConstantDataDTO.totalPurchaseValue?resp.data.portfolioConstantDataDTO.totalPurchaseValue:'';
              vm.currentValueCountUnit = UtilService.getUnitSting(resp.data.portfolioConstantDataDTO.totalCurrentValue);
              vm.totalCurrentValue = resp.data.portfolioConstantDataDTO.totalCurrentValue?resp.data.portfolioConstantDataDTO.totalCurrentValue:'';
              vm.xirrValueUnit = UtilService.getUnitSting(resp.data.portfolioConstantDataDTO.xirrValue);
              vm.xirrValue = resp.data.portfolioConstantDataDTO.xirrValue?resp.data.portfolioConstantDataDTO.xirrValue:'';
            }

            vm.totalPortfolioData = resp.data.count;
            vm.isPagination = !!(vm.portfolioData && vm.portfolioData.length);
          }
          else {
            vm.portfolioData = null;
            vm.isLoading = false;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader(".portfolio-loader");
          $log.info('err ', err);
          vm.isLoading = false;
          vm.isPagination = false;
          err.message &&  MessageService.error(err.message);
        };
      LoaderService.showLoader(".portfolio-loader");
      vm.isLoading = true;
      InvestorService.post({
        child1: 'folio',
        child2: 'portfolio'
      }, portfolioPayload).$promise.then(success, error);
    }

    function transactionOverview(schemeName, schemeCode) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            localStorage.setItem('schemeName', schemeName);
            TransactionsService.setTransactionOverview(resp.data.schemeOverviewDTOs);
            localStorage.setItem('overviewData', angular.toJson(resp.data.schemeOverviewDTOs));
            $state.go('main.transactions-view.details');
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info("fetchConstantData error====", err);
        };
      LoaderService.showLoader();
      localStorage.removeItem('overviewData');
      InvestorService.post({
        child1: 'portfolio',
        child2: 'scheme-overview'
      }, {"schemeCode": schemeCode}).$promise.then(success, error);
    }

    vm.pageLimitListChange = function() {
      vm.currentPagePortfolio = 1;
      vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
      fetchConstantData();
      fetchPortfolioData();
    };
    vm.initPortfolioList = function() {
      fetchConstantData();
      fetchPortfolioData();
    };

    vm.selectPortfolioTransaction = function (action,data) {
      TransactionModel.setPayloadRawData(null);
      var params = { folioNumber : data.folioNumber, sc : data.schemeCode, action: 'portfolio' };
      switch (action.toLocaleLowerCase()) {
        case 'sip':
          $state.go('main.transactions.sip',params);
          break;
        case 'purchase':
          $state.go('main.transactions.purchase',params);
          break;
      }
    };

    function fetchTopUpLabel() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.topUpLabel=resp.data.noteDTO.noteDTOMap.Port_Folio_Topup_Button_Label.content;
        } else {
          MessageService.error(resp);
        }
      }, failure = function(resp) {
        MessageService.error(resp)
        LoaderService.hideLoader();
      };
      var payload = {
        "pageName": "PORT_FOLIO"
      }
      InvestorService.post({child1: 'dynamicContent'}, payload).$promise.then(success, failure);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FoliosDetailController', foliosDetailController);

  /** @ngInject */
  function foliosDetailController(LoaderService,$scope, $log, AppConstants, MessageService, TransactionsService, UtilService, InvestorService,$state, ModalService, panAadharService,AuthService) {
    var vm = this;
    vm.fetchConstantData = fetchConstantData;
    vm.fetchSchemeType = fetchSchemeType;
    vm.fetchFolioData = fetchFolioData;
    vm.statusSchemeType = statusSchemeType;
    vm.fetchFolioList = fetchFolioList;
    vm.transactionOverview = transactionOverview;
    vm.slideRight = slideRight;
    vm.slideLeft = slideLeft;
    vm.slideLeftDisabled = true;
    vm.slideRightDisabled = false;
    vm.folioCount = null;
    vm.dynCapsuleboxWidth = null;
    vm.SCHEMETYPES = [{key: 'Scheme Type', value: 'ALL'}];
    vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.totalFolioData = 0;
    vm.currentPagePortfolio = 1;
    vm.pageLimitPortfolio = 25;
    vm.isPagination = false;
    vm.isLoading = false;
    vm.folioLimit = 11;
    // var sliderWidth = null;
    var sliderRange = {start:1, end:11};
    vm.kycVerifiedFlag = true;
    vm.kycMessage = "";
    vm.validFolio = false;
    vm.xirrInfo = AppConstants.XIRR_INFORMATION;
    AuthService.checkLinkedUserStatus();
    vm.init = function () {
      vm.pageLimitPortfolio = 25;
      fetchSchemeType();
      fetchFolioList();
    };



    function statusSchemeType() {

      if(vm.selectedFolio){
        fetchConstantData();
        fetchFolioData();
      }
    }

    function fetchFolioList() {
      LoaderService.showLoader();
      vm.isLoading = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.folioList = resp.data.folioTaxDetailLists;
            vm.folioCount = vm.folioList.length - 1;
            /*vm.sliderWidth = angular.element(".capsule-box").inner;*/
            if(vm.folioCount>sliderRange.end){
              vm.dynCapsuleboxWidth = vm.folioCount*100;
              // sliderWidth = vm.dynCapsuleboxWidth;
              angular.element(".capsule-box").innerWidth(vm.dynCapsuleboxWidth);
            }
            vm.selectedFolio = (vm.folioList && vm.folioList.length) ? vm.folioList[0].folioNumber : '';
            for(var i=0; i<vm.folioList.length; i++) {
              if(vm.folioList[i].folioNumber === vm.selectedFolio){
                vm.validFolio = vm.folioList[i].validFolio;
                break;
              }
            }
            if(vm.selectedFolio){
              fetchConstantData();
              fetchFolioData();
            }
          }
          else {
            vm.folioList = null;
            vm.isLoading = false;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
            vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('err ', err);
          vm.isLoading = false;
          //vm.isPagination = false;
          MessageService.error();
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      InvestorService.get({
        child1: 'folio',
        child2: 'list'
      }, {}).$promise.then(success, error);

    }

    vm.isDisplayed = function (index) {

      if(parseInt(index)>=sliderRange.start && parseInt(index)<=sliderRange.end){
        return true;
      } else return false;
    };


    function fetchConstantData() {
      var success = function (resp) {
            if (resp.data && resp.status) {
              vm.constantData = resp.data;
              vm.purchaseValueCountUnit = UtilService.getUnitSting(vm.constantData.totalPurchaseValue);
              vm.constantData.totalPurchaseValue = vm.constantData && vm.constantData.totalPurchaseValue?vm.constantData.totalPurchaseValue.toFixed(2):0;
              vm.currentValueCountUnit = UtilService.getUnitSting(vm.constantData.totalCurrentValue);
              vm.constantData.totalCurrentValue = vm.constantData && vm.constantData.totalCurrentValue?vm.constantData.totalCurrentValue.toFixed(2):0;
            }
            else {
              vm.constantData = null;
              vm.purchaseValueCountUnit = '';
              vm.currentValueCountUnit = '';
              MessageService.error(resp.message);
            }
          },
          error = function () {
          };
      InvestorService.post({
        child1: 'folio',
        child2: 'portfolio',
        child3: 'constantData'
      }, {folioNumber:vm.selectedFolio}).$promise.then(success, error);

    }

    function fetchSchemeType() {
      var success = function (resp) {
          //vm.SCHEMETYPES = [{key: 'Scheme Type', value: 'ALL'}];
          if (resp.status && resp.data && resp.data.schemeType) {
            for (var i = 0; i < resp.data.schemeType.length; i++) {
              var obj = {
                key: resp.data.schemeType[i].charAt(0).toUpperCase() + resp.data.schemeType[i].substr(1),
                value: resp.data.schemeType[i]
              };
              vm.SCHEMETYPES.push(obj);
              //vm.SCHEMETYPES = vm.SCHEMETYPES.concat(resp.data.schemeType);
            }
            vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
          }
        },
        error = function (err) {
          $log.info('err ', err);
          vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
        };
      InvestorService.post({
        child1: 'schemeType'
      }, {}).$promise.then(success, error);
    }

    vm.selectTransaction = function (action, data) {

      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        if (!vm.kycVerifiedFlag) {
        ModalService.genericModal({
          text: vm.kycMessage
        });
        return;
      }

      var folioNumber = vm.selectedFolio?vm.selectedFolio:data.folioNumber;
      var params = { folioNumber: folioNumber, sc : data.schemeCode};
      action = action.toLocaleLowerCase();
      switch (action) {
        case 'stp':
          params.referrer = 'normalStp';
          $state.go('main.transactions.stp', params );
          break;
        case 'flexstp':
          params.referrer = 'flexStp';
          $state.go('main.transactions.stp', params );
          break;
        case 'swp':
          $state.go('main.transactions.swp',params);
          break;
        case 'redeem':
          $state.go('main.transactions.redemption',params);
          break;
        case 'switch':
          $state.go('main.transactions.switch',params);
          break;
        case 'sip':
          params.action = 'portfolio';
          $state.go('main.transactions.sip',params);
          break;
        case 'purchase':
          params.action = 'portfolio';
          $state.go('main.transactions.purchase',params);
          break;
        case 'change dividend option':
          $state.go('main.changeDividendOption',params);
          break;
        case 'dtp':
          $state.go('main.transactions.dtp',params);
          break;
        case 'smart swap':
          $state.go('main.transactions.smartSwap',params);
          break;
        case 'flex sip':
          $state.go('main.transactions.flexsip',params);
          break;
      }

      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.selectedFolio?vm.selectedFolio:data.folioNumber).then(successHandler).catch(errorHandler);

    };
    vm.getFolioData = function(folioNumber){
      vm.portfolioData = null;
      vm.totalFolioData = 0;
      vm.isPagination = false;
      vm.currentPagePortfolio = 1;
      vm.pageLimitPortfolio = 25;
      vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
      vm.selectedFolio = folioNumber ? folioNumber : '';

      for(var i=0; i<vm.folioList.length; i++) {
        if(vm.folioList[i].folioNumber === folioNumber){
          vm.validFolio = vm.folioList[i].validFolio;
          break;
        }
      }
      if(vm.selectedFolio){
        fetchConstantData();
        fetchFolioData();
      }
    };

    function fetchFolioData() {
      LoaderService.showLoader();
      vm.isLoading = true;
      var portfolioPayload = {
        schemeType: vm.selectedSchemeType.toUpperCase(),
        folioNumber:vm.selectedFolio,
        pageIndex: vm.currentPagePortfolio - 1,
        pageLimit: vm.pageLimitPortfolio
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.portfolioData = resp.data.portfolioDTOs;
            vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
            vm.kycMessage = resp.data.kycMessage;

            vm.totalMarketValueCount = 0;
            vm.totalCostValueCount = 0;

            vm.portfolioData && vm.portfolioData.forEach(function (item) {
             item.purchaseValueUnit = UtilService.getUnitSting(item.purchaseValue);
             vm.totalMarketValueCount += +item.purchaseValue;
             item.currentValueUnit = UtilService.getUnitSting(item.currentValue);
             vm.totalCostValueCount += +item.currentValue;
             item.irrUnit=UtilService.getUnitSting(item.irr);
             });
            vm.totalMarketValueCountUnit = UtilService.getUnitSting(vm.totalMarketValueCount);
            vm.totalMarketValueCount = vm.totalMarketValueCount;
            vm.totalCostValueCountUnit = UtilService.getUnitSting(vm.totalCostValueCount);
            vm.totalCostValueCount = vm.totalCostValueCount;
            vm.totalFolioData = resp.data.count;
            vm.isPagination = !!(vm.portfolioData && vm.portfolioData.length);
            if(resp.data && resp.data.portfolioConstantDataDTO){
              vm.constantDataDTO = resp.data.portfolioConstantDataDTO;
              $scope.Portfolio.constData = resp.data.portfolioConstantDataDTO.dematSchemeAvailable;
              vm.purchaseValueCountUnit = UtilService.getUnitSting(resp.data.portfolioConstantDataDTO.totalPurchaseValue);
              vm.totalPurchaseValue = resp.data.portfolioConstantDataDTO.totalPurchaseValue?resp.data.portfolioConstantDataDTO.totalPurchaseValue:0;
              vm.currentValueCountUnit = UtilService.getUnitSting(resp.data.portfolioConstantDataDTO.totalCurrentValue);
              vm.totalCurrentValue = resp.data.portfolioConstantDataDTO.totalCurrentValue?resp.data.portfolioConstantDataDTO.totalCurrentValue:0;
              vm.xirrValueUnit = UtilService.getUnitSting(resp.data.portfolioConstantDataDTO.xirrValue);
              vm.xirrValue = resp.data.portfolioConstantDataDTO.xirrValue?resp.data.portfolioConstantDataDTO.xirrValue:'';
            }
          }
          else {
            vm.portfolioData = null;
            vm.isLoading = false;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('err ', err);
          vm.isLoading = false;
          vm.isPagination = false;
          err.message &&  MessageService.error(err.message);
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      InvestorService.post({
        child1: 'folio',
        child2: 'portfolio'
      }, portfolioPayload).$promise.then(success, error);
    }

    function transactionOverview(schemeName, schemeCode) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            //var overviewData = resp.data.schemeOverviewDTOs;
            /*for(var i in resp.data.schemeOverviewDTOs){
              resp.data.schemeOverviewDTOs[i].schemeName = schemeName;
            }*/
            localStorage.setItem('schemeName', schemeName);
            TransactionsService.setTransactionOverview(resp.data.schemeOverviewDTOs);
            localStorage.setItem('overviewData', angular.toJson(resp.data.schemeOverviewDTOs));
            $state.go('main.transactions-view.details');
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.showLoader();
          $log.info("fetchConstantData error====", err);
        };
      LoaderService.showLoader();
      localStorage.removeItem('overviewData');
      InvestorService.post({
        child1: 'portfolio',
        child2: 'scheme-overview'
      }, {"schemeCode": schemeCode}).$promise.then(success, error);
    }

    vm.pageLimitListChange = function() {
      vm.currentPagePortfolio = 1;
      vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
      if(vm.selectedFolio){
        fetchConstantData();
        fetchFolioData();
      }
    };
    vm.initFolioList = function() {
      if(vm.selectedFolio){
        // fetchConstantData();
        fetchFolioData();
      }
    };

    function slideRight() {
      if(vm.folioCount>=sliderRange.end) {
        sliderRange.start = sliderRange.start + 11;
        sliderRange.end = sliderRange.end + 11;
        vm.slideLeftDisabled = false;
      }
      if(sliderRange.start>vm.folioCount){
        vm.slideRightDisabled = true;
      }
    }

    function slideLeft() {
      if (sliderRange.start >1) {
        sliderRange.start = sliderRange.start - 11;
        sliderRange.end = sliderRange.end - 11;
        vm.slideRightDisabled = false;
      }
      if(sliderRange.start<=1){
        vm.slideLeftDisabled = true;
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('DematFoliosDetailController', DematFoliosDetailController);

  /** @ngInject */
  function DematFoliosDetailController(LoaderService, $log, AppConstants, MessageService, TransactionsService, UtilService, InvestorService,$state,AuthService) {
    var vm = this;
    vm.fetchSchemeType = fetchSchemeType;
    vm.fetchFolioData = fetchFolioData;
    vm.statusSchemeType = statusSchemeType;
    vm.fetchFolioList = fetchFolioList;
    vm.transactionOverview = transactionOverview;
    vm.slideRight = slideRight;
    vm.slideLeft = slideLeft;
    vm.slideLeftDisabled = true;
    vm.slideRightDisabled = false;
    vm.folioCount = null;
    vm.dynCapsuleboxWidth = null;
    vm.SCHEMETYPES = [{key: 'Scheme Type', value: 'ALL'}];
    vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.totalFolioData = 0;
    vm.currentPagePortfolio = 1;
    vm.pageLimitPortfolio = 25;
    vm.isPagination = false;
    vm.isLoading = false;
    vm.folioLimit = 11;
    // var sliderWidth = null;
    var sliderRange = {start:1, end:11};
    AuthService.checkLinkedUserStatus();

    vm.init = function () {
      vm.pageLimitPortfolio = 25;
      fetchSchemeType();
      fetchFolioList();
    };



    function statusSchemeType() {

      if(vm.selectedFolio){
        fetchFolioData();
      }
    }

    function fetchFolioList() {
      LoaderService.showLoader();
      vm.isLoading = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.folioList = resp.data.folioMap;
            vm.folioCount = vm.folioList.length - 1;
            if(vm.folioCount>sliderRange.end){
              vm.dynCapsuleboxWidth = vm.folioCount*100;
              // sliderWidth = vm.dynCapsuleboxWidth;
              angular.element(".capsule-box").innerWidth(vm.dynCapsuleboxWidth);
            }
            vm.selectedFolio = (vm.folioList && vm.folioList.length) ? vm.folioList[0] : '';
            if(vm.selectedFolio){
              fetchFolioData();
            }
          }
          else {
            vm.folioList = null;
            vm.isLoading = false;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
            vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('err ', err);
          vm.isLoading = false;
          MessageService.error();
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      InvestorService.get({
        child1: 'folio',
        child2: 'demat',
        child3: 'list'
      }, {}).$promise.then(success, error);

    }

    vm.isDisplayed = function (index) {

      if(parseInt(index)>=sliderRange.start && parseInt(index)<=sliderRange.end){
        return true;
      } else return false;
    };



    function fetchSchemeType() {
      var success = function (resp) {
          if (resp.status && resp.data && resp.data.schemeType) {
            for (var i = 0; i < resp.data.schemeType.length; i++) {
              var obj = {
                key: resp.data.schemeType[i].charAt(0).toUpperCase() + resp.data.schemeType[i].substr(1),
                value: resp.data.schemeType[i]
              };
              vm.SCHEMETYPES.push(obj);
            }
            vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
          }
        },
        error = function (err) {
          $log.info('err ', err);
          vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
        };
      InvestorService.post({
        child1: 'schemeType'
      }, {}).$promise.then(success, error);
    }

    vm.selectTransaction = function (action, data) {

      var folioNumber = vm.selectedFolio?vm.selectedFolio:data.folioNumber;
      var params = { folioNumber: folioNumber, sc : data.schemeCode};
      action = action.toLocaleLowerCase();
      switch (action) {
        case 'stp':
          params.referrer = 'normalStp';
          $state.go('main.transactions.stp', params );
          break;
        case 'flexstp':
          params.referrer = 'flexStp';
          $state.go('main.transactions.stp', params );
          break;
        case 'swp':
          $state.go('main.transactions.swp',params);
          break;
        case 'redeem':
          $state.go('main.transactions.redemption',params);
          break;
        case 'switch':
          $state.go('main.transactions.switch',params);
          break;
        case 'sip':
          $state.go('main.transactions.sip',params);
          break;
        case 'purchase':
          $state.go('main.transactions.purchase',params);
          break;
        case 'change dividend option':
          $state.go('main.changeDividendOption',params);
          break;
      }

    }
    vm.getFolioData = function(folioNumber){
      vm.portfolioData = null;
      vm.totalFolioData = 0;
      vm.isPagination = false;
      vm.currentPagePortfolio = 1;
      vm.pageLimitPortfolio = 25;
      vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
      vm.selectedFolio = folioNumber ? folioNumber : '';

      if(vm.selectedFolio){
        fetchFolioData();
      }
    };

    function fetchFolioData() {
      LoaderService.showLoader();
      vm.isLoading = true;
      var portfolioPayload = {
        schemeType: vm.selectedSchemeType.toUpperCase(),
        folioNumber:vm.selectedFolio,
        pageIndex: vm.currentPagePortfolio - 1,
        pageLimit: vm.pageLimitPortfolio
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.portfolioData = resp.data.portfolioDTOs;
            vm.totalMarketvalue = resp.data.totalMarketvalue;
            vm.totalMarketValueCount = 0;
            vm.totalCostValueCount = 0;

            vm.portfolioData && vm.portfolioData.forEach(function (item) {
             item.purchaseValueUnit = UtilService.getUnitSting(item.purchaseValue);
             vm.totalMarketValueCount += +item.purchaseValue;
             item.currentValueUnit = UtilService.getUnitSting(item.currentValue);
             vm.totalCostValueCount += +item.currentValue;
             });
            vm.totalMarketValueCountUnit = UtilService.getUnitSting(vm.totalMarketValueCount);
            vm.totalMarketValueCount = vm.totalMarketValueCount.toFixed(2);
            vm.totalCostValueCountUnit = UtilService.getUnitSting(vm.totalCostValueCount);
            vm.totalCostValueCount = vm.totalCostValueCount.toFixed(2);
            vm.totalFolioData = resp.data.count;
            vm.isPagination = !!(vm.portfolioData && vm.portfolioData.length);
          }
          else {
            vm.portfolioData = null;
            vm.isLoading = false;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('err ', err);
          vm.isLoading = false;
          vm.isPagination = false;
          err.message &&  MessageService.error(err.message);
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      InvestorService.post({
        child1: 'folio',
        child2: 'demat',
        child3: 'portfolio'
      }, portfolioPayload).$promise.then(success, error);
    }

    function transactionOverview(schemeName, schemeCode) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {

            localStorage.setItem('schemeName', schemeName);
            TransactionsService.setTransactionOverview(resp.data.schemeOverviewDTOs);
            localStorage.setItem('overviewData', angular.toJson(resp.data.schemeOverviewDTOs));
            $state.go('main.transactions-view.details');
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.showLoader();
          $log.info("fetchConstantData error====", err);
        };
      LoaderService.showLoader();
      localStorage.removeItem('overviewData');
      InvestorService.post({
        child1: 'portfolio',
        child2: 'scheme-overview'
      }, {"schemeCode": schemeCode}).$promise.then(success, error);
    }

    vm.pageLimitListChange = function() {
      vm.currentPagePortfolio = 1;
      vm.selectedSchemeType = vm.SCHEMETYPES[0].value;
      if(vm.selectedFolio){
        fetchFolioData();
      }
    };
    vm.initFolioList = function() {
      if(vm.selectedFolio){
        fetchFolioData();
      }
    };

    function slideRight() {
      if(vm.folioCount>=sliderRange.end) {
        sliderRange.start = sliderRange.start + 11;
        sliderRange.end = sliderRange.end + 11;
        vm.slideLeftDisabled = false;
      }
      if(sliderRange.start>vm.folioCount){
        vm.slideRightDisabled = true;
      }
    }

    function slideLeft() {
      if (sliderRange.start >1) {
        sliderRange.start = sliderRange.start - 11;
        sliderRange.end = sliderRange.end - 11;
        vm.slideRightDisabled = false;
      }
      if(sliderRange.start<=1){
        vm.slideLeftDisabled = true;
      }
    }
  }
})();

/**
 * Created by ttn on 23/10/24.
 */


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PaymentPreLoginTokenHomeController', paymentPreLoginTokenHomeController);

  /** @ngInject */
  function paymentPreLoginTokenHomeController($window, $stateParams, AuthService, LoaderService, $state, ModalService, $timeout, AppConstants ,
                                                 InvestmentModel, InvestmentBasketService, MessageService, CommonFactory, UtilService, InvestorService, $scope, $rootScope, HDFC_API) {
    var vm = this;
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    vm.isLoading = true;
    vm.init = init;
    var token = AuthService.getToken();
    vm.stateTitle = $stateParams.journey;
    vm.showLogoutBtn = false;
    vm.currentState = $state.current.name;
    vm.CORPORATE_URL = HDFC_API.CORPORATE_URL;
    vm.flowName = AppConstants.PRE_LOGIN_JOURNEY_ENUM;
    var removeListeners = {}, isRefreshing = false;
    var scope = $scope;

    init();
    function init() {
      setListeners();
    }


    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        if (!token) {
          if (vm.stateTitle && vm.stateTitle === vm.flowName.WHATSAPP) {
            $state.go('linkExpired');
          } else {
            $state.go('sessionExpired');
          }
          resetFlag();
          return;
        }

        if (token && token.refresh_token) {
          AuthService.getRefreshTokenGateway(token).then(function () {
            if (localStorage.getItem('doLogOut')) {
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                ModalService.logoutSuccess();
                if (vm.stateTitle && vm.stateTitle === vm.flowName.WHATSAPP) {
                  $state.go('linkExpired');
                } else {
                  $state.go('sessionExpired');
                }
              }, function () {
                ModalService.logoutSuccess();
                if (vm.stateTitle && vm.stateTitle === vm.flowName.WHATSAPP) {
                  $state.go('linkExpired');
                } else {
                  $state.go('sessionExpired');
                }
              });
            } else {
              $state.reload();
              resetFlag();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            if (vm.stateTitle && vm.stateTitle === vm.flowName.WHATSAPP) {
              $state.go('linkExpired');
            } else {
              $state.go('sessionExpired');
            }
            resetFlag();
          });
        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          if (vm.stateTitle && vm.stateTitle === vm.flowName.WHATSAPP) {
            $state.go('linkExpired');
          } else {
            $state.go('sessionExpired');
          }
        }
      });

      var resetFlag = function () {
        $timeout(function () {
          isRefreshing = false;
        }, 2000);
      };

      // removeListeners['disableLogout'] = $scope.$on("disableLogout", function() {
      //   vm.showLogoutBtn = false;
      // });

      removeListeners['showNewLogo'] = $scope.$on("showNewLogo", function(event, result) {
        vm.logoUrl = result;
        sessionStorage.setItem("logoUrl",vm.logoUrl);
      });

      scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in removeListeners) {
          if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
            removeListeners[key]();
          }
        }
      });
    }

  }
})();

/**
 * Created by ttn on 23/10/24.
 */


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ExpiredTokenHomeController', expiredTokenHomeController);

  /** @ngInject */
  function expiredTokenHomeController(HDFC_API,$window) {
    var vm = this;
    vm.CORPORATE_URL = HDFC_API.CORPORATE_URL;
    vm.successBackUrl = sessionStorage.getItem('redirectUrl');
    vm.handleBackRedirection = handleBackRedirection;


    function handleBackRedirection() {
      $window.location.href = vm.successBackUrl;
    }

  }
})();

/**
 * Created by ttn on 23/10/24.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PaymentPreLoginTokenController', paymentPreLoginTokenController);

  /** @ngInject */
  function paymentPreLoginTokenController($window, $stateParams, AuthService, LoaderService, $state, ModalService, $timeout, AppConstants ,
                                             InvestmentModel, InvestmentBasketService, MessageService, CommonFactory, UtilService, InvestorService, $scope, $rootScope) {
    var vm = this;
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    vm.isLoading = false;
    vm.init = init;
    vm.stateTitle = $state.current.name;
    var removeListeners = {}, isRefreshing = false;
    var scope = $scope;


    vm.uuid = $stateParams.uuid;
    vm.successBackUrl = sessionStorage.getItem('redirectUrl');
    vm.showLogoutBtn = false;
    vm.flowName = AppConstants.PRE_LOGIN_JOURNEY_ENUM;

    init();

    function init() {
      getToken();
      setListeners();
    }

    function getToken() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.flowNameResponse = resp.data.sourcePortal;
          if (vm.flowNameResponse === vm.flowName.WHATSAPP) {
            setWhatsappFolioID2FA();
            vm.journey = vm.flowName.WHATSAPP;
          }
          vm.linkID = resp.data.linkId;
          resp.data.access_token = resp.data.accessToken;
          resp.data.investorPAN = resp.data.panNumber;
          AuthService.setToken(resp.data);
          sessionStorage.setItem("linkId",vm.linkID);
          vm.isLoading = true;
          $state.go('preLoginPaymentHome.paymentHome', {
            journey: vm.journey,
            type: $stateParams.tType
          });
        } else {
          MessageService.error(resp.message);
          if (vm.successBackUrl) {
            $window.location.href = vm.successBackUrl;
          } else {
            if (vm.stateTitle && vm.stateTitle === 'preLoginWhatsapp') {
              $state.go('linkExpired');
            } else {
              $state.go('login');
            }
          }
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err);
      };
      InvestorService.get({
        child1: 'preLogin',
        child2: 'getToken',
        child3: vm.uuid
      }).$promise.then(success, error);
    }


    function getcipherText(cipherData) {
      var cipherText = cipherData;
      var key = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-|_x";
      var message = "";
      var shiftKey = 10;
      for (var i = 0; i < cipherText.length; i++) {
        var charPosition = key.indexOf(cipherText.charAt(i));
        var keyVal = (charPosition - shiftKey) % 39;
        if (keyVal < 0) {
          keyVal = key.length + keyVal;
        }
        var replaceVal = key.charAt(keyVal);
        message += replaceVal;
      }
      return message;
    }


    function setWhatsappFolioID2FA() {
      vm.folioID = $stateParams.folio;
      if(vm.folioID){
        vm.folioID =  vm.folioID.replace(/"/,'');
        vm.folioID =  vm.folioID.replace(/'/,'');
        vm.folioID =  getcipherText(vm.folioID);
        sessionStorage.setItem("folioID",vm.folioID);
      }else{
        vm.folioID =  sessionStorage.getItem("folioID");
      }
    }


    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        if (!token) {
          if (vm.stateTitle && vm.stateTitle === 'preLoginWhatsapp') {
            $state.go('linkExpired');
          } else {
            $state.go('login');
          }
          resetFlag();
          return;
        }

        if (token && token.refresh_token) {
          AuthService.getRefreshTokenGateway(token).then(function () {
            if (localStorage.getItem('doLogOut')) {
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                ModalService.logoutSuccess();
                if (vm.stateTitle && vm.stateTitle === 'preLoginWhatsapp') {
                  $state.go('linkExpired');
                } else {
                  $state.go('login');
                }
              }, function () {
                ModalService.logoutSuccess();
                if (vm.stateTitle && vm.stateTitle === 'preLoginWhatsapp') {
                  $state.go('link-expired');
                } else {
                  $state.go('login');
                }
              });
            } else {
              $state.reload();
              resetFlag();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            if (vm.stateTitle && vm.stateTitle === 'preLoginWhatsapp') {
              $state.go('linkExpired');
            } else {
              $state.go('login');
            }
            resetFlag();
          });
        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          if (vm.stateTitle && vm.stateTitle === 'preLoginWhatsapp') {
            $state.go('linkExpired');
          } else {
            $state.go('login');
          }
        }
      });

      var resetFlag = function () {
        $timeout(function () {
          isRefreshing = false;
        }, 2000);
      };

      scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in removeListeners) {
          if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
            removeListeners[key]();
          }
        }
      });
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NewInvestorPaymentController', NewInvestorPaymentController);

  /** @ngInject */
  function NewInvestorPaymentController(TransactionArn,$window, $rootScope, $timeout, $state, $stateParams, $scope, AuthService, HDFC_API, toastr, LoaderService,
    AppConstants, TransactionService, MessageService, ModalService, UtilService, CommonFactory, CreatePayloadFactory, InvestorService,
    deviceDetector, $http, $sce, NetcoreEvntService, NewInvestorTransactionService,InvestorFileUploadServiceV3, TransactionServiceVersion, TransactionModel, $log, NewInvestorServiceV3, BrowserService, investorServiceVersion, InvestorServiceVersion3, MetaTagService,DownloadPdfService,FileSaver, PaymentService) {

    var vm = this;
    vm.userName = '';
    vm.PaymentMode = "Net Banking";
    vm.upiPaymet = {};
    vm.hdfcFundTransferObj = {};
    vm.upiPaymet.bank = '';
    vm.upiPaymet.upiID = '';
    vm.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
    $scope.billdeskUrl = HDFC_API.BILLDESK_URL;
    vm.billdeskPayload = {
      hidRequestId : "PGIME1000",
      hidOperation : "ME100",
      msg : ""
    };
    vm.bankList = [];
    vm.bankInfo = {};
    vm.formData = {};
    vm.tpv = tpv;
    vm.folioBankData = null;
    vm.sipFirstInstallmentVisible = false;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.PATTERN = AppConstants;
    vm.isUPIVerified = false;
    vm.confirmation = false;
    vm.onlySipSummary = false;
    vm.onlySipInvestment = false;
    vm.netBankingAndUPIList = '';
    vm.formData.purchasePaymentOption = 'NETBANKING';
    vm.selectedUpiBank = selectedUpiBank;
    vm.getbankData = getbankData;
    vm.isUPIVerified = false;
    vm.rtgsForm = {};
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.investorInfo = null;
    vm.folioDraftId = "";
    vm.disableUpiBank = false;
    vm.paymentOptions = [
      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
    ];
    $rootScope.testObj.steps[2].stepCompleted = true;
    vm.setFormDataForNeft = setFormDataForNeft;
    vm.mobileLoginPandetails = sessionStorage.getItem('MobilePanLoginDetails')?JSON.parse(sessionStorage.getItem('MobilePanLoginDetails')) :null;
    vm.disableUserButton = false;
    if(vm.mobileLoginPandetails && vm.mobileLoginPandetails.throughPrelimanaryDashboard){
      vm.disableUserButton = true;
    }else{
    vm.disableUserButton = false;
    }
    vm.init = function () {
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[1].stepCompleted = true;
      $rootScope.testObj.steps[2].stepCompleted = true;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepActive = false;
      $rootScope.testObj.steps[2].stepActive = false;
      vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
      var detailsSuccess = function (result) {
        vm.folioDraftId = result.data.folioCreationDraftId;
        vm.partialData = result.data;
        if (result.data.step != "FOURTH") {
          // $state.go("welcome");
        }
        if (result.data.folioNumber) {
          var success = function (resp) {
            vm.formData = resp.data;
            if(vm.formData && vm.formData.minorFlag){
              vm.formData.cgfFlag = vm.formData.cgfFlag? vm.formData.cgfFlag: true;
            }
            if(vm.formData && vm.formData.paymentOption == 'HEM' && vm.formData.investmentType == 'SIP'){
              vm.formData.sipPaymentOption = 'E-mandate';
            }
            if(vm.formData.paymentOption == 'UAP' && vm.formData.investmentType == 'SIP'){
              vm.paymentOptions = [
                vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
              ];
            }
            getbankData();
            var verifyObjData = JSON.parse(sessionStorage.getItem("verifyObj"));
            vm.investorInfo = verifyObjData;
            vm.formData.maskedMobile = resp.data.maskedMobile;
            vm.formData.maskedEmail = resp.data.maskedEmail;
            vm.formData.folioNumber = result.data.folioNumber;
            // vm.investmentType = vm.formData.investmentType;
            vm.transactionType = vm.formData.investmentType;
            vm.userName = verifyObjData.panHolderName.replace(/ .*/, '');
            if (resp.data.investmentType == "SIP" && resp.data.sipFI == false) {
              vm.onlySipInvestment = true;
              vm.getBankForSip();
              getNormalSIPBank();
            } else {
              // alert('New journey working on purchase!');
              // $state.go('welcome');
              if (resp.data.investmentType == "SIP" && resp.data.sipFI == true) {
                vm.sipFirstInstallmentVisible = true;
              } else {
                vm.sipFirstInstallmentVisible = false;
              }
              initActivity();

              vm.onlySipInvestment = false;
            }
          },
            error = function (err) {
              MessageService.error(AppConstants.ToastrMessage.FAILED);
            };
          vm.processFlag = false;
          var Data = {};
          Data.id = result.data.transactionDraftId;
          if(Data && Data.id){
            LoaderService.showLoader('.pan-loader');
            InvestorService.post({
              child1: 'new',
              child2: 'user',
              child3: 'saved',
              child4: 'draft'
            }, Data).$promise.then(success, error);
          }
        } else {
          MessageService.error("Please create first folio");
          $state.go('newInvestor.folioDetails.baiscDetails');
        }
      },
        derror = function (err) {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      try {
        var verifyObjData = JSON.parse(sessionStorage.getItem("verifyObj"))
        // vm.userFllName = verifyObjData.panHolderName.replace(/ .*/,'');
        vm.userFllName = verifyObjData.panHolderName;
        var payload = {};
        payload.panNumber = verifyObjData.panNumber;
      } catch (e) { }
      vm.processFlag = false;
      InvestorService.post({
        child1: 'new',
        child2: 'user',
        child3: 'getDetails'
      }, payload).$promise.then(detailsSuccess, derror);
      // getInvestorInfo();

      var successHandler = function(resp) {
        vm.noteUpiModal =  resp.noteDTO.noteDTOMap.Note_SIP_UPI_2FA;
      }

      UtilService.fetchDynamicData("SIP_REVIEW").then(successHandler).catch(function(resp) {
        MessageService.error(resp)
      });
    }

    vm.submitSipForm = function ($event) {
      // userSipActivityTracking(false, function (statusFlag) {
      if(vm.formData.paymentOption == 'HEM' && vm.formData.investmentType == 'SIP'){
        var success = function(){
          approveTransaction($event);
        },error = function(){

        };
        ModalService.registerEMandateNewJourneyModal({'bankName':vm.sipBankData[0].bankNameOnly, randomOTPId: sessionStorage.getItem('randomOTPIdForNewInvestorJourney')},success,error);
      }else{
        approveTransaction($event);
      }
      // });
    };
    function userSipActivityTracking(isProcessed, cb) {

      // /*Netcore Event Start*/
      // if (isProcessed && (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP)) {
      //   NetcoreEvntService.Complete_Transaction_SIP_IP(vm.formData, true);
      // }
      // /*Netcore Event End*/

      cb = cb || function () { };
      if (vm.transactionType != vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        cb(true);
      }
      var success = function (trackResp) {
        trackResp = trackResp.data || trackResp;
        LoaderService.hideLoader();
        cb(trackResp);
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(err);
      };
      LoaderService.showLoader();
      var userTrackerPayload = setUserTrackerPayload(isProcessed);
      InvestorService.post({
        child1: 'userBehavior',
        child2: 'addupdate'
      }, userTrackerPayload).$promise.then(success, error);
    }
  function getNormalSIPBank(){
    var success = function (resp) {
      if(resp.status && resp.data){
        vm.formData.bankInfo = resp.data.bankList[0];
      }else{
        MessageService.error(error.message);
      }
    },
    error = function (error) {
      MessageService.error(error.message);
    };
    InvestorService.post({child1: 'bank', child2: 'list'}, {
      trnxType: 'PURCHASE',
       folioNumber: vm.formData.folioNumber,
      liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
    }).$promise.then(success, error);
  }
    function setUserTrackerPayload(isProcessed) {
      var _payload = {
        "trxnRefNo": $stateParams.trackId ? $stateParams.trackId : "", //required in case of update
        "trxnType": vm.formData.investmentType, //SIP, PURCHASE
        "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
        "step": "THIRD", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode, // required
        "folioNo": vm.formData.folioNumber, // required
        "formData": vm.formData, // required
        "amount": vm.formData.purchaseAmount, //required
        "trxnStatus": isProcessed ? "PROCESSED" : "OPEN"  // OPEN,PROCESSED
      };
      return _payload;
    }
    function approveTransaction($event) {
      var payload = vm.formData && vm.formData.sipFI == true && vm.formData.sipPaymentOption != 'E-mandate' ? getSipPurchasePayload() : getSipPayload();
      if (!payload) {
        MessageService.error('Something went wrong while calculating payload.');
        return;
      }
      var success = function (resp) {
        // $event.currentTarget.disabled = false;
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          LoaderService.hideLoader();
          vm.srnNo = resp.data.srnNo;
          if (vm.formData.paymentOption == 'UAP' && vm.formData.investmentType == 'SIP'){
            vm.handleUpiSipResponse(resp);
          } else if(vm.formData.paymentOption == 'HEM' && vm.formData.investmentType == 'SIP'){
            vm.handleEmandateSipResponse(resp.data);
          }else{
            if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP && vm.formData.sipFI) {
              vm.redirectUrl = resp.data.redirectUrl;
              vm.redirectionDataForRazorPay = resp.data;
              handlePurchaseResponse(resp.data);
            }else{
              vm.sip_response = resp.data;
              vm.SIPtransactionInitiateDate = resp.data.transactionInitiateDate.slice(0, 11);
              vm.showSummary = true;
              var data = {
                transactionId: vm.srnNo,
                amount: vm.formData.amount,
                transactionDate: vm.sip_response.transactionInitiateDate,
                folioNumber: vm.formData.folioNumber,
                paymentMode: AppConstants.TRANSACTIONS.DESCRIPTIONS.EC,
                schemeCode: vm.formData.schemeCode,
                schemeName: vm.formData.schemeName
              };
              var data = getDataToBePushed(data);
              NetcoreEvntService.Transaction_Success('SIP', data);
            }
          }
        } else {
          LoaderService.hideLoader();
          if (resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            });
          } else {
            if(resp.popupEnabled){
              ModalService.genericModal({
                text: resp.message
              });
              } else{
                MessageService.error(resp.message);
              }
          }
          // /*Netcore Event Start*/
          // if (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
          //   NetcoreEvntService.Complete_Transaction_SIP_IP(vm.formData, true);
          // }
          // /*Netcore Event End*/
        }
      },
       error = function (err) {
          // $event.currentTarget.disabled = false;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        $window.smartech('dispatch', 'user id creation post kyc', {});
        LoaderService.showLoader();
      var _config = {
        controller1: 'transaction',
        controller2: 'sip',
        controller3: 'approve'
      };
        if(vm.distributorDetails){
          payload.utmSource = vm.distributorDetails.utmSource;
          payload.utmMedium = vm.distributorDetails.utmMedium;
          TransactionArn.post(_config, payload).$promise.then(success, error);
        }else{
          TransactionService.post(_config, payload).$promise.then(success, error);
        }
    }

    function getSipPayload() {
      if (vm.formData.bankInfo && vm.formData.bankInfo.bankName == "OTHER BANKS") {
        vm.formData.bankInfo.bankName = vm.formData.bankName;
      }
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if (vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == vm.formData.investmentOption)
          vm.formData.investmentOption = key;
      });
      if(vm.formData.investmentType === 'PURCHASE' || (vm.formData.investmentType === 'SIP' &&  vm.formData.sipFI)){
        vm.formData.bankInfo = vm.folioBankData && vm.folioBankData.bankList?vm.folioBankData.bankList[0]:null;
        }
      var sipPayload = {
        installmentAmount: vm.formData.amount,
        investmentOption: vm.formData.investmentOption ? vm.formData.investmentOption.toUpperCase() : '',
        dividendOption: vm.formData.investmentOption && vm.formData.investmentOption.toUpperCase() == 'GROWTH' ? 'Z' : vm.formData.dividendOption,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
        euinOpted: vm.formData.euinOpted ? vm.formData.euinOpted : 'N',
        // euinName: vm.formData.euinName ? vm.formData.euinName : '',
        // euinCode: vm.formData.euinCode ? vm.formData.euinCode : '',
        frequency: vm.formData.installmentFrequency,
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        schemeType: vm.formData.schemeType,
        primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
        toDate: vm.formData.installmentEndDate ? vm.formData.installmentEndDate : '',
        sipDate: vm.formData.installmentStartDate ? vm.formData.installmentStartDate : '',
        sipDay: (moment(vm.formData.installmentStartDate, 'DD-MMM-YYYY').date()).toString(),
        weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
        id: vm.formData.id ? '' : '',
        bankDetailsForECS: {
          // accNumber: vm.formData.bankInfo.accountNumber,
          // bankName: vm.formData.bankName,
          // ifscCode: vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : null,
          // branchName: vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '',
          // bankCity: vm.formData.bankInfo ? vm.formData.bankInfo.bankCity : '',
          paymentOption:  vm.formData.investmentType == "SIP" ? vm.formData.paymentOption : '',

          bankName:vm.sipBankData[0] && vm.sipBankData[0].bankNameOnly ? vm.sipBankData[0].bankNameOnly : null ,
          ifscCode: vm.sipBankData[0] && vm.sipBankData[0].ifscCode  ? vm.sipBankData[0].ifscCode : null,
          branchName: vm.sipBankData[0] && vm.sipBankData[0].bankBranch ? vm.sipBankData[0].bankBranch : null,
          bankCity: vm.sipBankData[0] &&  vm.sipBankData[0].bankCity ? vm.sipBankData[0].bankCity : null,
          accType:vm.sipBankData[0] && vm.sipBankData[0].bankAcType? vm.sipBankData[0].bankAcType : null,
          accNo:vm.sipBankData[0] ? vm.sipBankData[0].accountNumber : null,
          accNumber: vm.sipBankData[0] ? vm.sipBankData[0].accountNumber : null,
          // payoutId: vm.formData.bankInfo && vm.formData.bankInfo.payoutId,
          netBankingUrl: vm.sipBankData[0] && vm.sipBankData[0].netBankingUrl ? vm.sipBankData[0].netBankingUrl : null,
          bankCode: vm.sipBankData[0] ? vm.sipBankData[0].bankCode : null
        },
        subBrokerArn: vm.formData.subBrokerArn ? 'ARN-' + vm.formData.subBrokerArn : '',
        subBrokerCode: vm.formData.subBrokerCode ? vm.formData.subBrokerCode : '',
        sipTopupEnabled: vm.formData.topUpEnable ? vm.formData.topUpEnable : false ,
        brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : '',
        riaConsent: vm.formData.riaConsent,
        topupDetails: {
          amount: vm.formData.topUpDetails.amount,
          percentage: vm.formData.topUpDetails.percentage,
          frequency: vm.formData.topUpDetails.frequency ? 'Y' : 'Y',
          capAmount: vm.formData.topUpDetails.capAmount,
          capMonthYear: vm.formData.topUpDetails.capMonthYear
        },
        secretLink: vm.singleUseURL
      };
      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          sipPayload.bankDetailsForECS.accNumber = vm.formData.bankInfo.accountNumber;
          sipPayload.bankDetailsForECS.accType = vm.formData.bankInfo.bankAcType;
          sipPayload.bankDetailsForECS.authenticationMode = 'NET_BANKING';
          sipPayload.bankDetailsForECS.bankCode = vm.sipBankData[0] ? vm.sipBankData[0].emBankCode : null;
          sipPayload.bankDetailsForECSbankCode = vm.sipBankData[0] ? vm.sipBankData[0].emBankCode : null;
      }
      (vm.formData.bankInfo && angular.isDefined(vm.formData.bankInfo.camsMandateIdNo))
        && (sipPayload.bankDetailsForECS.camsMandateIdNo = vm.formData.bankInfo.camsMandateIdNo);
      (vm.formData.bankInfo && angular.isDefined(vm.formData.bankInfo.omUmrn))
        && (sipPayload.bankDetailsForECS.omUmrn = vm.formData.bankInfo.omUmrn);
      if (vm.formData.paymentOption === 'UAP') {
        sipPayload.bankDetailsForECS.paymentOption = 'UAP';
        sipPayload.paymentOption = 'UAP';
        sipPayload.payerVpa = vm.formData.payerVpa;
        sipPayload.payerName = vm.formData.payerName;

        if (vm.sipFirstInstallmentVisible) {
          sipPayload.sipWithFirstInstallment = true;
          sipPayload.firstInstallmentDetails = getPaymentInfo();
        }
      }

      var payload = {};
      if (!vm.formData.optionalInvestmentType && vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        payload = angular.copy(sipPayload);
      } else {
        payload = null;
      }
      payload = handleBrokerCode(payload);
      return payload;
    }
    vm.sipBankData = [];
    vm.getBankForSip = function(){
      var success = function (resp) {
        if(resp.status && resp.data){
          vm.sipBankData = resp.data.bankList;
        }else{
          MessageService.error(resp.message);
        }
      },error = function (err) {

      }
      InvestorService.post({child1: 'bank', child2: 'list'}, {
        trnxType: 'PURCHASE',
        folioNumber: vm.formData.folioNumber,
        liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
      }).$promise.then(success, error);
    }
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.riaConsent) {
        payload['brokerCode'] = vm.formData.riaCode;
        payload['riaConsent'] = true;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }
    function handleSipResponse(data) {
      if (!data) {
        MessageService.error();
        return;
      }

      if (vm.formData.investmentOption == Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS)[1])
        vm.formData.investmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND;

      ModalService.manualInstructionsModal({
        investorName: vm.investorName,
        folioInvestorName: vm.formData.folioInvestorName,
        srnNo: data.srnNo,
        folioNumber: vm.formData.folioNumber,
        schemeName: vm.formData.inSchemeName,
        investmentOption: vm.formData.investmentOption,
        amount: vm.formData.amount,
        sipDividendOption: vm.formData.sipDividendOption,
        netBankingUrl: vm.bankInfo.netBankingUrl,
        paymentOption: data.paymentOption,
        transactionId: data.trxnNo,
        transactionInitiateDate: data.transactionInitiateDate,
        frequency: vm.formData.frequency,
        weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
        startDate: vm.formData.startDate ? vm.formData.startDate.format('DD-MMM-YYYY') : null,
        endDate: vm.formData.endDate ? vm.formData.endDate.format('DD-MMM-YYYY') : null,
        bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
        bankAcNo: vm.formData.bankInfo ? vm.formData.bankInfo.accountNumber : vm.formData.bankAcNo,
        type: 'newInvestor',
      });

    }

    vm.showTermConditions = function () {
      ModalService.transactionalTermConditionModal({ 'transactionType': 'sip' });
    };
    vm.goToBack = function () {
      $state.go('newInvestor.folioDetails.baiscDetails');
    };

    // THIS FUNCTION CALL ON PURCHASE TYPE
    function initActivity() {
      if (!vm.formData || (vm.formData.investmentType.toUpperCase() !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE && vm.formData.investmentType.toUpperCase() !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP)) {
        $state.go('welcome');
        TransactionModel.setPayloadRawData(null);
        return null;
      }
      // if (vm.formData.schemeType === 'LIQUID') {
      //   vm.paymentOptions = paymentOptions4Liquid;
      // }

      vm.formData.purchasePaymentOption = vm.paymentOptions[0];
      vm.formData.trackId = $stateParams.trackId ? $stateParams.trackId : vm.formData.trackId;

      getDetails(function () {
        vm.changedPaymentOption();
      });

    }


    function getDetails(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
        var bankDetails = [];
        if(resp.data && resp.data){
          vm.folioTaxStatusCode = resp.data.folioTaxStatusCode;
          vm.bankAccountTypes();
        }
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if (vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length > 0) {
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if (value.defaultBank === true) { return value; }
          });
        }
        localStorage.setItem('bankDetails', $window.JSON.stringify(bankDetails));
        if (vm.formData.paymentOption === 'UAP' && !vm.formData.purchasePaymentOption)  {
          vm.formData.purchasePaymentOption = vm.paymentOptions[0];
        }
        cb();
      }, error = function () {
        LoaderService.hideLoader();
        cb();
      };
      var myData = {
        folioNumber: vm.formData.folioNumber,
        newUser:true
      }
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, myData).$promise.then(success, error);
    }

    vm.bankAccountTypes  = function() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.bankAccountType = resp.data.bankAccountTypes;
          $rootScope.AccountTypes = resp.data.bankAccountTypes;
        }
        else {
           vm.panMessage = resp.message;
        }
      },
        error = function () {
          MessageService.error("Bank account type service error!");
        };
      InvestorService.get({ child1: 'folio', child2: 'bank', child3: 'account-type-list', child4: vm.folioTaxStatusCode }).$promise.then(success, error);
    }
    function getbankData(){
        var success = function (resp) {
          if(resp.data && resp.data){
            vm.folioBankData =  resp.data;
          }
          LoaderService.hideLoader();
        }, error = function () {
          LoaderService.hideLoader();
        };
        var myData = {
          trnxType: "PURCHASE",
           folioNumber: vm.formData.folioNumber,
           liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
        }
        LoaderService.showLoader();
        InvestorService.post({
          child1: 'bank',
          child2: 'list'
        }, myData).$promise.then(success, error);
      };
    vm.changedPaymentOption = function () {
      vm.isCheckedDeclaration = false;
      vm.bankInfo = null;
      vm.bankList = null;
      vm.formData.paymentInfo = { amount: vm.formData.purchaseAmount };
      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isInvalidForm = false;
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          vm.formData.paymentInfo.paymentMode = "WEB";
          vm.fetchBankList();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          vm.fetchBankList();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
          vm.rtgsBankTogg = true;
          vm.fetchBankList();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          resetUPIForm();
          vm.fetchBankList();
          if (vm.formData.investmentType === 'SIP') {
            vm.formData.paymentInfo.paymentMode = "UAP";
          } else {
            vm.formData.paymentInfo.paymentMode = "WEB";
          }
          vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
          break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.CHEQUE:
            vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.CHEQUE;
            vm.chequeBankTogg = true;
            vm.fetchBankList();
            break;
      }
    };
    function resetUPIForm() {
      vm.verifyUPIResp = {};
      vm.isUPIVerified = false;
      (vm.formData.paymentInfo) && (vm.formData.paymentInfo.virtualAddress = "");
    }
    vm.loaderCounter = 0;
    vm.callBankList = function(){
      LoaderService.showLoader();
      vm.fetchBankList();
    }
    vm.fetchBankList = function() {
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.otmList = resp.data;
          if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
            vm.bankList = vm.formData.sipFI ? resp.data.nonCOTMBankList : resp.data.bankList;
          } else {
            vm.bankList = resp.data.bankList;
          }
          vm.bankList = vm.bankList.length ? vm.bankList : null;
          if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING ||
            vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            vm.netBankingAndUPIList = vm.bankList;
          }
          // if(vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM){
          //   vm.OTMList = vm.bankList;
          // }
          if (vm.bankList && vm.bankList.length == 1) {
            vm.bankInfo = vm.bankList[0];
            if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
              localStorage.setItem('folioId', vm.formData.folioNumber);
              ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
              return;
            }
            vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
            vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
            vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
            vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
            vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
            vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
            vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
            vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
            vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
            vm.formData.paymentInfo.bankAcType = vm.bankInfo.bankAcType;
            vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
            vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
            (angular.isDefined(vm.bankInfo.camsMandateIdNo)) && (vm.formData.paymentInfo.camsMandateIdNo = vm.bankInfo.camsMandateIdNo);
            // if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
            //   // checkOTMAmountAndDate();
            // }
            if (vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
              vm.sipBankData = angular.copy(vm.netBankingAndUPIList);
              selectedUpiBank();
            }
            if (vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS) {
              vm.changeBank();
              if(!vm.rtgsBankTogg){
                vm.formData.paymentInfo.bankName = null;
                vm.formData.paymentInfo.ifscCode = null;
                vm.formData.paymentInfo.branchName = null;
                vm.formData.paymentInfo.accountNumber = null;
                vm.formData.paymentInfo.accNo = null;
                vm.formData.paymentInfo.bankAcType = null;
                vm.formData.paymentInfo.accType = null;
                vm.bankInfo = null;
              }
            }

            if (vm.formData.paymentOption === 'UAP') {
              vm.formData.paymentInfo.virtualAddress = vm.formData.payerVpa;
              vm.name = vm.formData.payerName;
              vm.showUPIStatus = true;
              vm.isUPIVerified = true;
              vm.disableUpiBank = true;
              vm.verifyUPIResp.valid = true;
            }

            if (vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.CHEQUE) {
              vm.changeBank();
              if(!vm.chequeBankTogg){
                vm.formData.paymentInfo.bankName = null;
                vm.formData.paymentInfo.ifscCode = null;
                vm.formData.paymentInfo.branchName = null;
                vm.formData.paymentInfo.accountNumber = null;
                vm.formData.paymentInfo.accNo = null;
                vm.formData.paymentInfo.bankAcType = null;
                vm.formData.paymentInfo.accType = null;
                vm.bankInfo = null;
              }
            }
          }
        } else {
          vm.bankList = null;
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.bankList = null;
          MessageService.error("Folio creation is in process please wait.");
          if(vm.loaderCounter < 4 && vm.netBankingAndUPIList === ""){
            $timeout(function(){
              vm.callBankList();
            }, 15000);
            vm.loaderCounter = vm.loaderCounter + 1;
          }
        };
      LoaderService.showLoader();

      var config = null;
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
          config = { child1: 'bank', child2: 'list', child3: vm.debitCardType, child4: 'debit' };
          InvestorService.get(config, null).$promise.then(success, error);
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          if (vm.netBankingAndUPIList === "") {
            if (vm.formData.paymentOption === 'UAP') {
              InvestorService.post({ child1: 'bank', child2: 'list' }, {
                trnxType: 'PURCHASE',
                folioNumber: vm.formData.folioNumber,
                liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false,
                sipUpiFlow : true
              }).$promise.then(success, error);
            } else {
              InvestorService.post({ child1: 'bank', child2: 'list' }, {
                trnxType: 'PURCHASE',
                folioNumber: vm.formData.folioNumber,
                liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
              }).$promise.then(success, error);
            }
          }else{
            if(vm.formData.paymentInfo && !vm.formData.paymentInfo.webMode){
              vm.formData.paymentInfo.webMode = vm.netBankingAndUPIList[0].gateWayVendor;
            }
            vm.bankInfo = vm.netBankingAndUPIList[0];
          }
          // vm.bankList = vm.netBankingAndUPIList;
          checkBankList();
          LoaderService.hideLoader();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          InvestorService.post({ child1: 'bank', child2: 'list' }, {
            trnxType: 'PURCHASE',
            folioNumber: vm.formData.folioNumber,
            liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
          }).$promise.then(success, error);
          // vm.bankList = vm.netBankingAndUPIList;
          checkBankList();
          LoaderService.hideLoader();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if (vm.OTMList === null) {
            config = { child1: 'folio', child2: 'otm' };
            InvestorService.post(config, {
              folioNo: vm.formData.folioNumber,
              transactionType: 'purchase'
            }).$promise.then(success, error);
          }
          vm.bankList = vm.OTMList;
          checkBankList();
          LoaderService.hideLoader();
          break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.CHEQUE:
          InvestorService.post({ child1: 'bank', child2: 'list' }, {
            trnxType: 'PURCHASE',
            folioNumber: vm.formData.folioNumber,
            liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
          }).$promise.then(success, error);
          checkBankList();
          LoaderService.hideLoader();
          break;
        default:
          vm.bankList = null;
          config = null;
          break;
      }
    }

    function checkBankList() {
      if (vm.bankList && vm.bankList.length == 1) {
        vm.bankInfo = vm.bankList[0];
        if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
          localStorage.setItem('folioId', vm.formData.folioNumber);
          ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
          return;
        };
        vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
        vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
        vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
        vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
        vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
        vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
        vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
        vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
        vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
        vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
        vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
        vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
        vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
        (angular.isDefined(vm.bankInfo.camsMandateIdNo)) && (vm.formData.paymentInfo.camsMandateIdNo = vm.bankInfo.camsMandateIdNo);
        // checkOTMAmountAndDate();
        if (vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
          selectedUpiBank();
        }
      }
    }

    // function selectedUpiBank() {
    //   if (!vm.bankInfo) {
    //     return;
    //   }
    //   if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
    //     localStorage.setItem('folioId', vm.formData.folioNumber);
    //     ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
    //     vm.bankInfo = null;
    //     vm.isCheckedDeclaration = false;
    //     return;
    //   }
    //   vm.upiAccountNumber = vm.bankInfo.accountNumber;
    //   vm.upiBankName = vm.bankInfo.bankName;
    //   vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
    // }


    vm.checkForMinorBankListCondition = function () {
      if (vm.formData != null && vm.formData.minorFlag != null && vm.formData.cgfFlag != null)
        return vm.formData.minorFlag && !vm.formData.cgfFlag;
      else
        return false;
    };
    vm.verifyUPI = function () {
      vm.verifyUPIResp = {};
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.verifyUPIResp = resp.data;
          if (resp.data.valid) {
            vm.name = resp.data.name;
            vm.showUPIStatus = true;
            vm.isUPIVerified = true;
          } else {
            vm.isUPIVerified = false;
          }
        }
        else {
          vm.isUPIVerified = false;
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      },
        error = function (err) {
          vm.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();

      InvestorService.post({
        child1: 'upi',
        child2: 'check',
        child3: 'virtualAddress'
      }, { "virtualAddress": vm.formData.paymentInfo.virtualAddress }).$promise.then(success, error);
    }
    vm.copyPasteHandler = function (e) {
      UtilService.copyPasteHandler(e);
    };

    vm.changeBank = function () {
      if (!vm.bankInfo) {
        return;
      }
      vm.isInvalidForm = false;
      localStorage.setItem('folioId', vm.formData.folioNumber);
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          // if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
          //   ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
          //   vm.bankInfo = null;
          //   vm.isCheckedDeclaration = false;
          //   return;
          // };
          vm.formData.paymentInfo.paymentMode = 'WEB';
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          // if (vm.bankInfo.tpvEnableFlag == 'Y') {
          //   getAccountNumber(vm.bankInfo.bankCode);
          // }
          vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
          vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
          vm.formData.paymentInfo.bankNameWithAccountNumber = vm.bankInfo.bankName ? vm.bankInfo.bankName : null;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly ? vm.bankInfo.bankNameOnly : null;
          vm.formData.paymentInfo.branchName = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
          vm.isAccTypeFieldDisabled = vm.formData.paymentInfo.accType ? true : false;
          if(vm.rtgsBankTogg){
            vm.rtgsFormData.bankName.$setDirty();
            vm.rtgsFormData.bankBranch.$setDirty();
            vm.rtgsFormData.bankAcNo.$setDirty();
            vm.rtgsFormData.accountType.$setDirty();
            vm.rtgsFormData.ifscCode.$setDirty();
          }else{
            vm.rtgsFormData.bankName.$dirty = false;
            vm.rtgsFormData.bankBranch.$dirty = false;
            vm.rtgsFormData.bankAcNo.$dirty = false;
            vm.rtgsFormData.accountType.$dirty = false;
            vm.rtgsFormData.ifscCode.$dirty = false;
          }
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
            ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            return;
          };
          vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
          vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
          vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
          vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
          (angular.isDefined(vm.bankInfo.camsMandateIdNo)) && (vm.formData.paymentInfo.camsMandateIdNo = vm.bankInfo.camsMandateIdNo);
          checkOTMAmountAndDate();

          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
            ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
            return;
          };
          break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.CHEQUE:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.CHEQUE;
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
          vm.formData.paymentInfo.bankNameWithAccountNumber = vm.bankInfo.bankName ? vm.bankInfo.bankName : null;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly ? vm.bankInfo.bankNameOnly : null;
          vm.formData.paymentInfo.branchName = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankCity = vm.bankInfo.bankCity;
          vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
          vm.isAccTypeFieldDisabled = vm.formData.paymentInfo.accType ? true : false;
          if(vm.chequeBankTogg){
           if(vm.chequeFormData){
            vm.chequeFormData.bankName.$setDirty();
            vm.chequeFormData.bankBranch.$setDirty();
            vm.chequeFormData.bankAcNo.$setDirty();
            vm.chequeFormData.accountType.$setDirty();
            vm.chequeFormData.ifscCode.$setDirty();
           }
          }else{
            vm.chequeFormData.bankName.$dirty = false;
            vm.chequeFormData.bankBranch.$dirty = false;
            vm.chequeFormData.bankAcNo.$dirty = false;
            vm.chequeFormData.accountType.$dirty = false;
            vm.chequeFormData.ifscCode.$dirty = false;
          }
          break;
        default:
          vm.bankInfo = null;
          break;
      }
    };
    function tpv() {
      ModalService.tpvModal({});
    }
    function getAccountNumber(bankCode) {
      // if(vm.investorInfo && vm.investorInfo.transactionFlowVersion === TrFlowType.NEW){
      //   vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
      //   vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
      //   return;
      // }
      // alert(bankCode);
      vm.bankAccounts = [];
      vm.isInvalidForm = true;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          LoaderService.hideLoader();
          vm.bankAccounts = resp.data.accountNumbers;
          if (vm.bankAccounts.length > 1) {
            var success = function (accountNo) {
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = accountNo;
              vm.isInvalidForm = false;
            }, error = function () {

            };
            ModalService.selectAccountNoModal({ bankAccounts: vm.bankAccounts }, success, error);
          } else {
            vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
            vm.formData.paymentInfo.accountNumber = vm.bankAccounts[0];
            vm.isInvalidForm = false;
          }
        } else {
          vm.isInvalidForm = true;
          MessageService.error(resp.message);
          vm.bankAccounts = [];
        }
      },
        error = function (err) {
          vm.bankAccounts = [];
          vm.isInvalidForm = true;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber, //'9422332',
        "bankCode": vm.formData.bankCode
      };
      InvestorService.post({
        child1: 'bank',
        child2: 'account'
      }, payload).$promise.then(success, error);
    }
// Existing functions
    vm.getconfirmation = function(){
      vm.confirmation = !vm.confirmation;
    }
    vm.getPaymenMode = function (val) {
      vm.formData.purchasePaymentOption = val;
      vm.changedPaymentOption();
    }

    // UPI
    function selectedUpiBank() {
      if (!vm.bankInfo) {
        return;
      }
      if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
        localStorage.setItem('folioId', vm.formData.folioNumber);
        ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
        vm.bankInfo = null;
        vm.isCheckedDeclaration = false;
        return;
      }
      vm.upiAccountNumber = vm.bankInfo.accountNumber;
      vm.upiBankName = vm.bankInfo.bankName;
      vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
    }


    vm.purchaseSubmitForm = function ($event) {
      var payload = getSipPurchasePayload();
      if (!payload) {
        MessageService.error('Something went wrong while calculating purchase payload.');
        return;
      }
      if (payload.formType === 'PURCHASE' && vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING &&
        vm.formData.amount >= 200000 && vm.formData.schemeType != 'LIQUID') {
        vm.showPurchaseNetBankingModal(payload);
      } else if (vm.formData.investmentType === 'SIP') {
        if (payload.bankDetailsForECS.paymentOption === 'HEM') {
          var successCallback = function (resp) {
            vm.singleUseURL = resp.secretLink;
            vm.finalSubmit(payload);
          };
          var errorCallback = function () {
            LoaderService.hideLoader();
          };
          ModalService.registerEMandateModal({folioNumber:vm.formData.folioNumber,transactionType : vm.formData.investmentType, bankName :payload.bankDetailsForECS.bankName, authMode: payload.bankDetailsForECS.authenticationMode, randomOTPId: sessionStorage.getItem('randomOTPIdForNewInvestorJourney')}, successCallback, errorCallback)
        }
        else
          vm.finalSubmit(payload);
      }
      else {
        vm.finalSubmit(payload);
      }
    };
    vm.showPurchaseNetBankingModal = function (payload) {
      var success = function () {
        vm.finalSubmit(payload);
      }, error = function () {

      };
      ModalService.PurchaseNetBankingModal({}, success, error);
    };

    function getSipPurchasePayload() {
      var sipPayload = {
        installmentAmount: vm.formData.amount,
        investmentOption: vm.formData.investmentOption ? vm.formData.investmentOption.toUpperCase() : '',
        dividendOption: vm.formData.investmentOption && vm.formData.investmentOption.toUpperCase() == 'GROWTH' ? 'Z' : vm.formData.dividendOption,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
        frequency: vm.formData.installmentFrequency,
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
        toDate: vm.formData.installmentEndDate ? $window.moment(vm.formData.installmentEndDate).format('DD-MMM-YYYY').toString() : '',
        sipDate: vm.formData.installmentStartDate ? $window.moment(vm.formData.installmentStartDate).format('DD-MMM-YYYY').toString() : '',
        sipDay: moment(vm.formData.installmentStartDate, 'DD-MMM-YYYY').date(),
        weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
        euinOpted: vm.formData.euinOpted ? vm.formData.euinOpted : 'N',
        euinCode: vm.formData.euinCode ? vm.formData.euinCode : '',
        euinName: vm.formData.euinName ? vm.formData.euinName : '',
        id: '',
        subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
        subBrokerCode: vm.formData.subBrokerCode ? vm.formData.subBrokerCode : '',
        brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : '',
        secretLink: vm.singleUseURL
      },
        purchasePayload = {
          amount: vm.formData.amount,
          investmentOption: vm.formData.investmentOption ? vm.formData.investmentOption.toUpperCase() : '',
          dividendOption: vm.formData.investmentOption && vm.formData.investmentOption.toUpperCase() == 'GROWTH' ? 'Z' : vm.formData.dividendOption,
          folioNumber: vm.formData.folioNumber,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          primaryFlag: vm.formData.investmentType.toUpperCase() === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          schemeCode: vm.formData.schemeCode,
          retirementAgeProofURL: vm.formData.retirementAgeProofURL ? vm.formData.retirementAgeProofURL : '',
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
          euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
          id: '',
          paymentInfo: getPaymentInfo(),
          subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode ? vm.formData.subBrokerCode : '',
          brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : '',
          checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
          autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null,
          riaConsent: vm.formData.riaConsent,
          autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null,
          secretLink: vm.singleUseURL
        };
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if (vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == purchasePayload.investmentOption) {
          purchasePayload.investmentOption = key;
        } else if (vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == sipPayload.investmentOption) {
          sipPayload.investmentOption = key;
        }
      });
      if (purchasePayload.paymentInfo.accountNumber && vm.formData.investmentType.toUpperCase() == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
        purchasePayload.accountNumber = purchasePayload.paymentInfo.accountNumber;
        delete purchasePayload.paymentInfo.accountNumber;
      }
      if (purchasePayload.paymentInfo.tpvEnableFlag) {
        purchasePayload.tpvEnableFlag = purchasePayload.paymentInfo.tpvEnableFlag;
        delete purchasePayload.paymentInfo.tpvEnableFlag;
      }
      var payload = {};

      switch (vm.formData.investmentType.toUpperCase()) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          purchasePayload = handleBrokerCode(purchasePayload);
          payload = angular.copy(purchasePayload);
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          sipPayload = handleBrokerCode(sipPayload);
          payload = angular.copy(sipPayload);
          break;
      }

      if (vm.formData.investmentType === 'SIP' && vm.formData.sipFI) {
        payload.sipWithFirstInstallment = vm.formData.sipFI;
        payload.firstInstallmentDetails = getPaymentInfo();
        vm.formData.sipPaymentOption = vm.formData.paymentOption;

        if (vm.formData.sipPaymentOption === 'EC' || vm.formData.sipPaymentOption === 'UAP') {
          payload.bankDetailsForECS = {
            accNumber: vm.bankInfo.accountNumber,
            bankName: vm.bankInfo ? vm.bankInfo.bankNameOnly : vm.bankNameOnly,
            ifscCode: vm.bankInfo.ifscCode,
            branchName: vm.bankInfo.bankBranch,
            bankCity: vm.bankInfo.bankCity,
            paymentOption: vm.formData.paymentOption,
            netBankingUrl: vm.bankInfo.netBankingUrl,
            bankCode: vm.bankInfo ? vm.bankInfo.bankCode : null,
            accType: vm.bankInfo && vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo && vm.formData.paymentInfo.bankAcType ? vm.formData.paymentInfo.bankAcType : null
          }
        }
        else if (vm.formData.sipPaymentOption === 'E-mandate') {
          payload.bankDetailsForECS = {
            accNumber: vm.formData.bankInfo ? vm.formData.bankInfo.accountNumber : '',
            bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.formData.bankInfo.ifscCode,
            branchName: vm.formData.bankInfo.bankBranch,
            bankCity: vm.formData.bankInfo.bankCity,
            paymentOption: 'HEM',
            accType: vm.formData.bankInfo.bankAcType,
            bankCode: vm.formData.bankInfo ? vm.formData.bankInfo.bankCode : null,
            authenticationMode: vm.formData.authMode.value
          }
        }
        else if (vm.formData.sipPaymentOption === 'OTM') {
          payload.bankDetailsForECS = {
            accNumber: vm.formData.bankInfo.bankAcNo,
            bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.formData.bankInfo.ifscCode,
            branchName: vm.formData.bankInfo.bankBranch,
            bankCity: vm.formData.bankInfo.bankCity,
            paymentOption: vm.formData.sipPaymentOption,
            payoutId: vm.formData.bankInfo.payoutId,
            bankCode: vm.formData.bankInfo ? vm.formData.bankInfo.bankCode : null,
            accType: vm.formData.bankInfo.bankAcType,
            camsMandateIdNo: vm.formData.bankInfo.camsMandateIdNo,
            omUmrn: vm.formData.bankInfo.omUmrn
          }
        }


        if (vm.formData.sipTopupEnabled) {
          payload.sipTopupEnabled = vm.formData.sipTopupEnabled;
          payload.topupDetails = vm.formData.topupDetails;
        }

        if (vm.formData.paymentOption === 'UAP') {
          payload.bankDetailsForECS.paymentOption = 'UAP';
          payload.paymentOption = 'UAP';
          payload.payerVpa = vm.formData.payerVpa;
          payload.payerName = vm.formData.payerName;
        }

      }

      return payload;
    }

    function getPaymentInfo() {

      if (vm.formData.paymentInfo && vm.formData.paymentInfo.webMode === 'MASTER') {
        vm.formData.paymentInfo.webMode = 'MASTERCARD';
      }

      var paymentInfo = {};

      if (vm.formData.investmentType === 'SIP') {
        paymentInfo = {
          //amount: vm.formData.amount,
          paymentMode: vm.formData.paymentInfo.paymentMode

        };

        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            paymentInfo.paymentMode = 'WEB';
        paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
        paymentInfo.webMode = vm.formData.paymentInfo.webMode;
        paymentInfo.bankName = vm.formData.paymentInfo.bankName;
        paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
        paymentInfo.accType = vm.formData.paymentInfo.bankAcType;
        paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
        if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
          paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
          paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
        }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            if (vm.rtgsBankTogg) {
              paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.bankBranch = vm.formData.paymentInfo.branchName;
              paymentInfo.accNo = vm.formData.paymentInfo.accNo;
              paymentInfo.accType = vm.formData.paymentInfo.accType;
              paymentInfo.otherBank = true;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
              paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
              paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            } else {
              paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.accountNumber;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
              paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
              paymentInfo.accType = vm.formData.paymentInfo.bankAcType;
              paymentInfo.otherBank = false;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
              paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            }
            break;
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
              paymentInfo.amount = vm.formData.amount;
              paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
              paymentInfo.accountHolderName = vm.formData.paymentInfo.accountHolderName;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
              paymentInfo.accType = vm.formData.paymentInfo.accType;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
              paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
              paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
              paymentInfo.bankName = "HDFC Bank Ltd";
              paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
              break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
              paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
              paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
              paymentInfo.upiReferenceNumber = vm.transactionNumber;
              paymentInfo.accountNumber = vm.upiAccountNumber;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.accNumber= paymentInfo.accountNumber;
              //paymentInfo.accNo = paymentInfo.accountNumber; // wrong here for upi autopay
              //paymentInfo.accType = paymentInfo.accountNumber; // wrong here
              paymentInfo.accType = vm.formData.paymentInfo.bankAcType ? vm.formData.paymentInfo.bankAcType : vm.formData.bankAcType;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode ? vm.formData.paymentInfo.ifscCode : vm.formData.ifscCode;
        }

      }
      else {
        paymentInfo = {
          amount: vm.formData.paymentInfo.amount ? vm.formData.paymentInfo.amount : vm.formData.amount,
          paymentMode: vm.formData.paymentInfo.paymentMode

        };

        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            paymentInfo.paymentMode = 'WEB';
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.accType =  vm.formData.paymentInfo.bankAcType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode
            paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
            if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
              paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
              paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            if (!vm.rtgsBankTogg) {
              paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.accNo;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.bankBranch = vm.formData.paymentInfo.branchName;
              paymentInfo.accType = vm.formData.paymentInfo.accType;
              paymentInfo.accNo = vm.formData.paymentInfo.accNo;
              paymentInfo.otherBank = true;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
              paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
              paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            } else {
              paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.accNo;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.bankBranch = vm.formData.paymentInfo.branchName;
              paymentInfo.accNo = vm.formData.paymentInfo.accNo;
              paymentInfo.accType = vm.formData.paymentInfo.accType;
              paymentInfo.otherBank = false;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
              paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
              paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
            paymentInfo.amount = vm.formData.amount;
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.accountHolderName = vm.formData.paymentInfo.accountHolderName;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            paymentInfo.bankName = "HDFC Bank Ltd";
            paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
            paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
            paymentInfo.upiReferenceNumber = vm.transactionNumber;
            if (vm.formData.paymentInfo && !vm.formData.paymentInfo.bank) {
              vm.formData.paymentInfo.bank = angular.copy(vm.bankInfo);
            }
            paymentInfo.accountNumber = vm.formData.paymentInfo.bank.accountNumber;

            paymentInfo.bankName = vm.formData.paymentInfo.bank.bankNameOnly;
            paymentInfo.accNo = vm.formData.paymentInfo.bank.accountNumber;
            paymentInfo.accType = vm.formData.paymentInfo.bank.bankAcType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.bank.ifscCode;
            break;
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.CHEQUE:
            if (!vm.chequeBankTogg) {
              paymentInfo.accNo = vm.formData.paymentInfo.accNo;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
              paymentInfo.accType = vm.formData.paymentInfo.accType;
              paymentInfo.accNo = vm.formData.paymentInfo.accNo;
              paymentInfo.otherBank = true;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
              paymentInfo.chequeNo = vm.formData.paymentInfo.chequeNumber;
              paymentInfo.bankCity = vm.formData.paymentInfo.bankCity;
            } else {
              paymentInfo.accNo = vm.formData.paymentInfo.accNo;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
              paymentInfo.accNo = vm.formData.paymentInfo.accNo;
              paymentInfo.accType = vm.formData.paymentInfo.accType;
              paymentInfo.otherBank = false;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
              paymentInfo.chequeNo = vm.formData.paymentInfo.chequeNumber;
              paymentInfo.bankCity = vm.formData.paymentInfo.bankCity;
            }
            break;
        }
      }

  return angular.copy(paymentInfo);
}
vm.showTransactionSummaryForRTGSorHDFC = false;
vm.showUPIStatus = false;
vm.redirectUrl =null;
vm.finalSubmit = function (payload) {
    LoaderService.showLoader();
  var success = function (resp) {
      LoaderService.hideLoader();
      if (resp.status && resp.data) {
        vm.srnNo = resp.data.srnNo;
        vm.redirectUrl = resp.data.redirectUrl;
        MessageService.success('Success');
        // userActivityTracking(true, function(){
        vm.redirectionDataForRazorPay = resp.data;
          handlePurchaseResponse(resp.data);
          // });
        } else {
          if(resp.popupEnabled){
            ModalService.genericModal({
              text: resp.message
            });
          } else{
            MessageService.error(resp.message);
          }
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          MessageService.error('Error');
        };

      $window.smartech('dispatch', 'user id creation post kyc', {});

      if (vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING) {
        if(vm.distributorDetails){
          payload.utmsource = vm.distributorDetails.utmsource;
          payload.utmmedium = vm.distributorDetails.utmmedium;
          TransactionArn.post({
            controller1: 'transaction',
            controller2: vm.formData.investmentType.toLowerCase(),
            controller3: 'approve'
          }, payload).$promise.then(success, error);
        }else{
         TransactionServiceVersion.post({
            controller1: 'transaction',
            controller2: vm.formData.investmentType.toLowerCase(),
            controller3: 'approve'
          }, payload).$promise.then(success, error);
        }
      } else {
        if(vm.distributorDetails){
          payload.utmsource = vm.distributorDetails.utmsource;
          payload.utmmedium = vm.distributorDetails.utmmedium;
          TransactionArn.post({
            controller1: 'transaction',
            controller2: vm.formData.investmentType.toLowerCase(),
            controller3: 'approve'
          }, payload).$promise.then(success, error);
        }else{
        NewInvestorTransactionService.post({
          controller1: 'transaction',
          controller2: vm.formData.investmentType.toLowerCase(),
          controller3: 'approve'
        }, payload).$promise.then(success, error);
       }
      }
    };

vm.userdata = null;
vm.transactionDetails=  null;
function handlePurchaseResponse(data) {
  vm.userdata  = data;
  var transactionId = data && data.transactionId ? data.transactionId : null;
  var payloadData = data;
  data = data && data.data ? data.data : data;
  if (!data) {
    MessageService.error();
    return;
  }

      if (vm.formData.sipFirstInstallment && vm.formData.sipPaymentOption === 'E-mandate') {
        $window.location.href = $scope.billdeskUrl + data.emandateMsg;
        return;
      }

  if(vm.formData.investmentType==='SIP')
    vm.billdeskMsg = data.emandateMsg;
  else
    vm.billdeskMsg = data;
  if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLDESK') {
    if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
      vm.billdeskPayload.msg = vm.billdeskMsg;
      $timeout(function () { // commented as debit currently is not getting used
        angular.element('#billdeskForm').submit();
      });
      //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
    } else {
      vm.billdeskPayload.msg = vm.billdeskMsg;
      $timeout(function () {
        angular.element('#billdeskForm').submit();
      });
      //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
    }
  }
  else if (vm.formData.paymentInfo.paymentMode == 'WEB' && (vm.formData.paymentInfo.webMode == 'MASTERCARD' || vm.formData.paymentInfo.webMode == 'VISA')) {
    if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
      vm.billdeskPayload.msg = vm.billdeskMsg;
      $timeout(function () {
        angular.element('#billdeskForm').submit();
      });
      //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
    } else {
      vm.billdeskPayload.msg = vm.billdeskMsg;
      $timeout(function () {
        angular.element('#billdeskForm').submit();
      });
      //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
    }
    // ModalService.successTransactionModal();
  }
  else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLJUNCTION') {
    $window.open(vm.billdeskMsg, '_self');
    // ModalService.successTransactionModal();
  } else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'UPI') {
    // vm.showUPISuccessPopup();
    // ModalService.successTransactionModal();
    if(!vm.redirectUrl) {
      MessageService.error("something went wrong");
    } else {
      // $window.location.href = vm.redirectUrl
      $window.location.href = vm.redirectUrl;
    }
  } else if(vm.formData.paymentInfo.paymentMode == "WEB" && vm.formData.paymentInfo.webMode == "RAZORPAY") {
    if(vm.formData.investmentType.toUpperCase() == "PURCHASE") {
      vm.redirectionDataForRazorPay.trnxActionMsg = vm.redirectionDataForRazorPay.data;
    } else if(vm.formData.investmentType.toUpperCase() == "SIP") {
      vm.redirectionDataForRazorPay.trnxActionMsg = vm.redirectionDataForRazorPay.emandateMsg;
    }
    PaymentService.openRazorPay(vm.redirectionDataForRazorPay);
  } else if(vm.formData.sipFirstInstallment)
  {
    $window.location.href = data.redirectUrl;
    /*ModalService.manualInstructionsModal({
      srnNo: data.srnNo,
      investorName: vm.formData.folioInvestorName,
      folioInvestorName: vm.formData.folioInvestorName,
      folioNumber: vm.formData.folioNumber,
      schemeName: vm.formData.inSchemeName,
      investmentOption: vm.formData.investmentOption,
      amount: vm.formData.amount,
      sipDividendOption: vm.formData.sipDividendOption,
      netBankingUrl:vm.formData.netBankingUrl,
      paymentOption:data.paymentOption,
      transactionId:data.trxnNo,
      transactionInitiateDate:data.transactionInitiateDate,
      frequency:vm.formData.frequency,
      startDate:vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY'):null,
      endDate:vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY'):null,
      bankName:vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
      bankAcNo:vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : vm.formData.bankAcNo,
      sipFirstInstallment:vm.formData.sipFirstInstallment,
      sipFirstAmount:vm.formData.sipFirstAmount,
      sipFirstBankName: vm.formData.purchasePaymentOption === "HDFC" ? "HDFC Bank" : vm.formData.paymentInfo.bankName,
      installmentPaymentOption: vm.TRANSACTIONS_CONST.DESCRIPTIONS[vm.formData.purchasePaymentOption]
    });*/
  }
  else {
    if(vm.formData.purchasePaymentOption == 'HDFC' || vm.formData.purchasePaymentOption == 'RTGS' || vm.formData.purchasePaymentOption == 'Q'){
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if( vm.formData.purchasePaymentOption == 'Q'){
            vm.chequeAcknowledgeSuccess = true;
            vm.transactionDetails = resp.data;
            if(resp.data.paymentMode == "Q"){
              vm.transactionDetails.paymentMode = "Cheque"
            }
          }else{
          vm.showTransactionSummaryForRTGSorHDFC = true;
          vm.transactionDetails = resp.data;
          var data = getDataToBePushed(vm.transactionDetails);
          NetcoreEvntService.Transaction_Success('purchase', data);
          }
        } else {
          MessageService.error(resp.message);
          deferred.reject(null);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        deferred.reject(null);
      };
      var payload = {
        transactionId: vm.userdata.transactionId,
        transactionType: 'PURCHASE'
      }
      InvestorService.post({
        child1: 'transaction',
        child2: 'approved',
        child3: 'summary'
      }, payload).$promise.then(success, error);
    }else{
      if(vm.mobileLoginPandetails && vm.mobileLoginPandetails.throughPrelimanaryDashboard){
        vm.data ={
          text:"You can use your mobile number for login",
          buttonText: "Proceed to login"
        }
        ModalService.loginWithMobileNoteNJModal(vm.data,function(){},function(){});
      }else{
      $state.go('newInvestor.investorProfile');
    }
    }

    // var isFavourite = vm.formData.isFavourite ? true : false;
    // sessionStorage.setItem("riaName", vm.formData.riaBrokerName);
    // // $state.go('main.summary-success', {
    //   transactionId: transactionId,
    //   transactionType: vm.formData.investmentType, isFavourite: isFavourite
    // });

      }
    }
    vm.showUPISuccessPopup = function () {
      var successModal = function () {
        // $state.go('welcome');
        $state.go('newInvestor.investorProfile');
      },
        errorModal = function () {
          // $state.go('welcome');
          $state.go('newInvestor.investorProfile');
        };
      ModalService.upiSuccessModal({}, successModal, errorModal);
    };


    vm.showSummary = false;

    vm.gotoprofile = function () {
      if(vm.mobileLoginPandetails && vm.mobileLoginPandetails.throughPrelimanaryDashboard){
        vm.data ={
          text:"You can use your mobile number for login",
          buttonText: "Proceed to login"
        }
        ModalService.loginWithMobileNoteNJModal(vm.data,function(){},function(){});
      }else{
      $state.go('newInvestor.investorProfile');
      }
    }
    vm.gotoLogin = function(){
      vm.logoutBtn();

    }

    vm.rtgsBankTogg = true;
    vm.selectRtgsBank = function () {
      vm.rtgsBankTogg = !vm.rtgsBankTogg;
      vm.bankchequeLeafUrl = null;
      vm.rtgsFormData.$setPristine();
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankName){
        vm.formData.paymentInfo.bankName = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.branchName){
        vm.formData.paymentInfo.branchName = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.accNo){
        vm.formData.paymentInfo.accNo = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.accType){
        vm.formData.paymentInfo.accType = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyBankAcNo || (vm.formData.paymentInfo.verifyBankAcNo == undefined)){
        vm.formData.paymentInfo.verifyBankAcNo = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.ifscCode || (vm.formData.paymentInfo.ifscCode == undefined)){
        vm.formData.paymentInfo.ifscCode = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.utrNumber){
        vm.formData.paymentInfo.utrNumber = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyUtrNumber || (vm.formData.paymentInfo.verifyUtrNumber == undefined)){
        vm.formData.paymentInfo.verifyUtrNumber = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
        vm.formData.paymentInfo.chequeLeaf = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankNameWithAccountNumber){
        vm.formData.paymentInfo.bankNameWithAccountNumber = null;
      }
      if(vm.rtgsBankTogg){
        // if(vm.formData && vm.formData.paymentInfo){
        //   if(vm.formData.paymentInfo.bankName){
        //     vm.formData.paymentInfo.bankName = "";
        //   }
        //   if(vm.formData.paymentInfo.ifscCode){
        //     vm.formData.paymentInfo.ifscCode = "";
        //   }
        // }
        // vm.formData.paymentInfo.chequeLeaf = vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf ? null : null;
        // vm.formData.paymentInfo = {};
        vm.bankchequeLeafUrl = null;
        vm.isAccTypeFieldDisabled = false;
        if(vm.bankInfo){
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.branchName = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
        }
      }else{
        // vm.formData.paymentInfo = vm.folioBankData && vm.folioBankData.bankList?vm.folioBankData.bankList[0]:null;
        vm.bankInfo = null;
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.tpvEnableFlag){
          vm.formData.paymentInfo.tpvEnableFlag = null;
        }
        // vm.formData.paymentInfo = {};
      }
    }
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff","application/pdf"];
    vm.bankUploadChequeLeafFile = function (file) {
      var fi = document.getElementById('chequesleafImage');
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be PDF, TIF, TIFF, JPG and JPEG extension.");
        fi.value = '';
        return;
      }
      if (file) {
        if (fi.files[0].size <= 3145728) {
          var success = function (resp) {
            // LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.bankchequeLeafUrl = resp.data.fileUrl;
              vm.formData.paymentInfo.chequeLeaf = resp.data.fileUrl;
              vm.fileType = file.type.split('/')[1];
            }
            else {
              vm.fileType = '';
              MessageService.error(resp.message);
              fi.value = '';
            }
          },
            error = function (err) {
              // LoaderService.hideLoader(err);
              fi.value = '';
            };

          if (file) {
            // LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            // https://dev-api.hdfcfund.com/investor/v3/folio/upload/bankDetails/chequeLeaf
            InvestorFileUploadServiceV3.post2({
              child1: 'folio',
              child2: 'upload',
              child3: 'bankDetails',
              child4: 'chequeLeaf',
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 3 MB.")
          file.value = '';
          if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
            vm.formData.paymentInfo.chequeLeaf = null;
            vm.bankchequeLeafUrl = null;
            vm.fileType = null;
          }
        }
      }

    }
    vm.openUploadedDoc = function () {
      if (angular.isUndefined(vm.bankchequeLeafUrl)) { return; }
        ModalService.showImage1({ docUrl: vm.bankchequeLeafUrl });
    };

    vm.downloadPdfFile = function(url, fileType){
      var success = function (resp){
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+fileType });
            FileSaver.saveAs(data, 'Cheque_Leaf.'+fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.downloadFile(payload, fileType, url).then(success, error);
    }

    vm.transactionOtpConfirmation = function () {
      var otpSuccessCallback, otpDismissCallback;

      otpSuccessCallback = function(resp) {
        if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP){
          vm.submitSipForm();
        }else {
          vm.purchaseSubmitForm();
        }
      };

      otpDismissCallback = function(err) {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      var modalPayload = {
        folioNumber:  vm.formData.folioNumber,
        transactionType: vm.transactionType.toUpperCase(),
        randomOTPId: sessionStorage.getItem('randomOTPIdForNewInvestorJourney')
      };

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.singleUseURL = resp.data.secretLink;
            var otpDetails = {
              secretOtpLink : vm.singleUseURL,
              otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
              otpId : resp.data.id
            };

            var payload = {
              folioNumber:  vm.formData.folioNumber,
              formType : vm.transactionType.toUpperCase()
            }

            if (vm.formData.paymentOption === 'UAP') {
              var noteUpiModal = vm.noteUpiModal;
              payload.paymentOption = 'UAP';
            }

            ModalService.transactionOtpModal({
              otpPayload: otpDetails,
              payload: payload,
              upiModalOtp : noteUpiModal
            }, otpSuccessCallback, otpDismissCallback);
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message)
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      TransactionService.post2({
        controller1: 'transaction',
        controller2: 'otp'
      }, modalPayload).$promise.then(success, error);
    }

    vm.handleEmandateSipResponse = function(data) {
      data = data && data.data ? data.data : data;
      if (!data) {
        MessageService.error();
        return;
      }
      $window.location.href=$scope.billdeskUrl+data.emandateMsg;
    }
    function getDataToBePushed(details) {
      var panDetails = JSON.parse(sessionStorage.getItem('dataLayerData'));
      $window.sessionStorage.removeItem('dataLayerData');
      return {
        transaction_id: details.transactionId,
        value: details.amount,
        tax: 0,
        currency: "INR",
        userId: vm.partialData.investorPartialRegistrationId,
        status : "success",
        transaction_time: details.transactionDate, //yy-mm-dd hh:mm:ss
        transaction_type: vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE ? 'Purchase' : vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
        source : details.paymentMode,
        items: [{
          item_id: details.folioNumber,
          item_name: details.schemeName,
          item_category: details.schemeCode,
          item_category2: panDetails.panHolderName,
          item_category3: panDetails.panNumber,//Encrypted value
          price: details.amount,
          quantity: "N/A"
        }]
      };
    }

    function setFormDataForNeft(form) {
      vm.rtgsFormData = form
    }

    vm.selectChequeBank = function () {
      vm.chequeBankTogg = !vm.chequeBankTogg;
      if(vm.chequeFormData){
        vm.chequeFormData.$setPristine();
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankName){
        vm.formData.paymentInfo.bankName = "HDFC Bank Ltd";
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.branchName){
        vm.formData.paymentInfo.branchName = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.accNo){
        vm.formData.paymentInfo.accNo = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.accType){
        vm.formData.paymentInfo.accType = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyBankAcNo || (vm.formData.paymentInfo.verifyBankAcNo == undefined)){
        vm.formData.paymentInfo.verifyBankAcNo = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.ifscCode || (vm.formData.paymentInfo.ifscCode == undefined)){
        vm.formData.paymentInfo.ifscCode = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeNumber){
        vm.formData.paymentInfo.chequeNumber = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyChequeNumber || (vm.formData.paymentInfo.verifyChequeNumber == undefined)){
        vm.formData.paymentInfo.verifyChequeNumber = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankNameWithAccountNumber){
        vm.formData.paymentInfo.bankNameWithAccountNumber = null;
      }
      if(vm.chequeBankTogg){
        vm.bankchequeLeafUrl = null;
        vm.isAccTypeFieldDisabled = false;
        if(vm.bankInfo){
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.branchName = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
        }
      }else{
        vm.bankInfo = null;
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.tpvEnableFlag){
          vm.formData.paymentInfo.tpvEnableFlag = null;
        }
      }
    }
    vm.selectIFSC = function () {
      var successModal = function (data) {
        if(data){
          vm.formData.paymentInfo.bankName = data.bankName;
          vm.formData.paymentInfo.branchName = data.branch;
          vm.formData.paymentInfo.ifscCode = data.ifscCode;
        }else{
          MessageService.error(resp.message);
        }
      },
      errorModal = function (err) {

      };
      ModalService.IFSCSelectionModalNewJourney({ bankList: vm.bankList, key : 'arn'}, successModal, errorModal);
    }
    vm.manualIfscSearch = function(){

      if (vm.formData.paymentInfo.ifscCode.includes('HDFC')){

      }else{
        vm.formData.paymentInfo.ifscCode = "";
      }
      vm.showInvalidIfscerror = false;
      var onSuccess = function (data) {
        vm.IFSCsearchResult = data.data.bankList;
        if(vm.IFSCsearchResult[0]){
          vm.formData.paymentInfo.branchName = vm.IFSCsearchResult[0].branch;
          vm.formData.paymentInfo.ifscCode = vm.IFSCsearchResult[0].ifscCode;
        }
        else{
          vm.showInvalidIfscerror = true;
          vm.formData.paymentInfo.bankBranch = "";
          vm.formData.paymentInfo.ifscCode = "";
        }
      };
      onerror = function () {
      };
      var payload = {
        ifscCode: vm.formData.paymentInfo.ifscCode
      };
      InvestorService.post({
        child1: 'rbi',
        child2: 'bankList'
      }, payload).$promise.then(onSuccess, onerror);
    }
    vm.handleUpiSipResponse = function(data) {
      data = data && data.data ? data.data : data;
      if (!data) {
        MessageService.error();
        return;
      }
      $window.location.href= data.redirectUrl;
    }
    vm.logoutBtn = function(){
      var success = function (resp) {
        if (resp.status) {
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
          AuthService.clearCookies(AppConstants.MOBILE_IDENTIFIER);
          AuthService.clearCookies(AppConstants.NEW_INVESTOR_IDENTIFIER);
          sessionStorage.removeItem('MobilePanLoginDetails');
          sessionStorage.removeItem('dataLayerData');
          sessionStorage.removeItem('panDetails');
          sessionStorage.removeItem('panDetailsEncrypted');
          sessionStorage.removeItem('userData');
          sessionStorage.removeItem('verifyObj');
          $state.go('login');
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader('.logout');
      },
        error = function (err) {
          LoaderService.hideLoader('.logout');
          MessageService.error(err.data.message);
        };
      LoaderService.showLoader('.logout');
      var Data = {
        "panNumber": vm.mobileLoginPandetails.pan
        }
      InvestorService.post({
        child1: 'force',
        child2: 'logout'
      }, Data).$promise.then(success, error);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('OtpVerificationController', OtpVerificationController);

  /** @ngInject */
  function OtpVerificationController($window, $rootScope, $state, $stateParams, $scope, toastr, AuthService, HDFC_API, LoaderService,
    AppConstants, TransactionService, MessageService, ModalService, UtilService, CommonFactory, CreatePayloadFactory, InvestorService,
    deviceDetector, $http, $sce, NetcoreEvntService, $log, BrowserService, investorServiceVersion, InvestorServiceVersion3, MetaTagService, $document,NewInvestorServiceV3) {
    var vm = this;

    /*----------------function declarations----------------*/
    vm.init = init;
    vm.appConstants = AppConstants;
    vm.otpValChanged = otpValChanged;
    vm.reGenerateOtp = reGenerateOtp;
    vm.resetTimer = resetTimer;
    vm.resetValues = resetValues;
    vm.verifyOTP = verifyOTP;
    vm.createmap = createmap;
    vm.otpVal1 = '';
    vm.otpVal2 = '';
    vm.otpVal3 = '';
    vm.otpVal4 = '';
    vm.otpVal5 = '';
    vm.otpVal6 = '';
    vm.otpCodeLength = 0;
    vm.loginProcessFlag = false;
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.mobileLoginPandetails = sessionStorage.getItem('MobilePanLoginDetails')?JSON.parse(sessionStorage.getItem('MobilePanLoginDetails')) :null;
    function init() {
      if($state.current.url == "/kyc-verification"){
        $rootScope.cUrl = true;
        }else{
        $rootScope.cUrl = false;
        }
      var verifyObjData = $state.params.verificationData ? $state.params.verificationData : JSON.parse(sessionStorage.getItem("verifyObj"))
      vm.email = verifyObjData.maskedEmail;
      vm.mobile = verifyObjData.maskedMobile;
      vm.userName = verifyObjData.panHolderName;
      vm.singleUseURL = verifyObjData.secretLink;
      vm.taxIdentifierNumber = verifyObjData.panNumber;
      vm.dob = verifyObjData.dob;
      vm.kycVerified = verifyObjData.kycVerifiedFlag;
      vm.kycStatus = verifyObjData.kycStatus;
      vm.registrationType = verifyObjData.registrationType;
      vm.taxStatusResident = verifyObjData.taxStatusResident;
    }

    init();

    vm.verifyCodeOtp = '';

    function otpValChanged(myvalue) {
      var num1 = angular.element($document[0].querySelector('#otp-number-input-1')).val();
      var num2 = angular.element($document[0].querySelector('#otp-number-input-2')).val();
      var num3 = angular.element($document[0].querySelector('#otp-number-input-3')).val();
      var num4 = angular.element($document[0].querySelector('#otp-number-input-4')).val();
      var num5 = angular.element($document[0].querySelector('#otp-number-input-5')).val();
      var num6 = angular.element($document[0].querySelector('#otp-number-input-6')).val();

      vm.verifyCodeOtp = parseInt(num1 + num2 + num3 + num4 + num5 + num6);
      vm.otpCodeLength = vm.verifyCodeOtp.toString().length

      var container = document.getElementsByClassName("input-code")[0];
      container.onkeyup = function (e) {
        var target = e.target;

        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          var next = target;
          while (next = next.nextElementSibling) {
            if (next == null)
              break;
            if (next.tagName.toLowerCase() == "input") {
              next.focus();
              break;
            }
          }
        } else if (myLength < maxLength) {
          var prev = target;
          while (prev = prev.previousElementSibling) {
            if (prev == null)
              break

            if (prev.tagName.toLowerCase() == "input") {
              prev.focus();
              break;
            }
          }
        }
      }
    };

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

    function resetValues() {
      vm.otpVal1 = '';
      vm.otpVal2 = '';
      vm.otpVal3 = '';
      vm.otpVal4 = '';
      vm.otpVal5 = '';
      vm.otpVal6 = '';
      vm.verifyCodeOtp = '';
      vm.otpCodeLength = 0;
    }

    function reGenerateOtp() {
      LoaderService.showLoader();
      resetValues();
      resetTimer();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.data.isOtpSent) {
          MessageService.success(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
      };
      InvestorService.post({
        child1: 'registration',
        child2: 'resendOTP'
      }, { id: vm.singleUseURL }).$promise.then(success, error);
    }

    function verifyOTP() {
      var success = function (result) {
        LoaderService.hideLoader();
        vm.loginProcessFlag = false;
        if (result.access_token && result.access_token != "") {
          AuthService.setToken(result);
          switch (vm.registrationType) {
            case 'NEW':
              if ((vm.kycStatus === vm.KYC_STATUS.VERIFIED || vm.kycStatus === vm.KYC_STATUS.IN_PROGRESS)) {
                var verifyObjData = $state.params.verificationData ? $state.params.verificationData : JSON.parse(sessionStorage.getItem("verifyObj"));

                var detailsSuccess = function (result) {
                   if (result.data.step != "HOLD") {
                     getRandomOTPId();
                     if(result.data.folioCreationDraftId) {
                       fetchSavedDraftFolioData(result,function (resp) {
                         // vm.taxStatusResident == true means user selected Resident Individual and vm.taxStatusResident == false means user selected NRI
                         if (((vm.taxStatusResident == true && resp.data.nriFlag === true) || (vm.taxStatusResident == false && resp.data.nriFlag === false)) && !vm.distributorDetails && !result.data.folioNumber) {
                           var successModalHandler = function (response) {
                             updatedDeleteFolioApi();
                             result.data.folioCreationDraftId = null;
                             $rootScope.stepperSecondary.steps[0].stepActive = false;
                             $rootScope.stepperSecondary.steps[1].stepActive = false;
                             $rootScope.stepperSecondary.steps[2].stepActive = false;
                             $rootScope.stepperSecondary.steps[0].stepCompleted = true;
                             $rootScope.stepperSecondary.steps[1].stepCompleted = true;
                             $rootScope.stepperSecondary.steps[2].stepCompleted = true;
                             var data = result.data;
                             data.newInvestorStatus = true;
                             $window.sessionStorage.setItem("userData", JSON.stringify(data));
                             $state.go('newInvestor.folioDetails.baiscDetails');
                           }, errorModalHandler = function () {
                             var userData = JSON.parse(sessionStorage.getItem('verifyObj'));
                             userData.taxStatusResident = !userData.taxStatusResident;
                             sessionStorage.setItem("verifyObj", JSON.stringify(userData));
                              redirectionToStep(result);
                           };
                           var data = {
                             nriFlag: resp.data.nriFlag
                           };
                           ModalService.unsavedChangesModal({misMatchNriData: data}, successModalHandler, errorModalHandler);
                         } else if(((vm.taxStatusResident == true && resp.data.nriFlag === true) || (vm.taxStatusResident == false && resp.data.nriFlag === false)) && !vm.distributorDetails && result.data.folioNumber) {
                           var successPayentHandler = function() {
                             $state.go('newInvestor.NewInvestorPayment');
                           }, errorPaymentHandler = function() {
                             updateStep(result);
                           };
                           var dataForPayment = {
                             nriFlag: resp.data.nriFlag
                           };
                           ModalService.unsavedChangesModal({misMatchNriDataAtPayment: dataForPayment}, successPayentHandler, errorPaymentHandler);
                         }else {
                           redirectionToStep(result);
                         }
                       });
                     } else {
                       redirectionToStep(result);
                     }
                     if(vm.distributorDetails) {
                       result.data.step = "FIRST";
                       if(result.data.folioCreationDraftId) {
                         updatedDeleteFolioApi();
                         result.data.folioCreationDraftId = null;
                       }
                       if(result.data.folioNumber){
                         result.data.folioNumber = null;
                       }
                       var userData = JSON.parse(sessionStorage.getItem('verifyObj'));
                       userData.taxStatusResident = !vm.distributorDetails.nriFlag;
                       sessionStorage.setItem("verifyObj", JSON.stringify(userData));
                       redirectionToStep(result);
                     }
                  } else {
                    redirectionToStep(result);
                  }
                },
                  derror = function (err) {
                    MessageService.error(AppConstants.ToastrMessage.FAILED);
                  };
                var payload = {};
                payload.panNumber = verifyObjData.panNumber;
                vm.processFlag = false;
                InvestorService.post({
                  child1: 'new',
                  child2: 'user',
                  child3: 'getDetails'
                }, payload).$promise.then(detailsSuccess, derror);
              } else if (vm.kycStatus === vm.KYC_STATUS.NOT_VERIFIED || vm.kycStatus === vm.KYC_STATUS.INCOMPLETE) {
                sessionStorage.setItem("ekycRequestCO", JSON.stringify(resp.data.ekycRequestCO));
                $state.go('ekyc', {
                  ekycRequestCO: resp.data.ekycRequestCO
                });
              } else if (resp.data.kycStatus === vm.KYC_STATUS.SUSPENDED) {
                ModalService.nonKycModal({
                  'text': resp.data.message,
                  'buttonText': 'OK'
                }, function () { }, function () { });
              } else {
                ModalService.nonKycModal({
                  'text': 'Your KYC status is not verified, please update KYC with your current KRA through Point of Service of any KRA intermediary.',
                  'buttonText': 'OK'
                }, function () { }, function () { });
              }
              break;
            case 'NEW_REGISTERED':
              var successNew = function () {
                vm.formData = {};
                UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.EXISTING_USER); //aplicable only for sidebar
                $state.go('login');
              },
                errorNew = function () {
                  $state.go('registration.kycVerification');
                };
              ModalService.registrationSuccessModal({
                'text': 'Your PAN is already registered. Please continue to login',
                'buttonText': 'Proceed to login'
              }, successNew, errorNew);
              break;
            case 'EXISTING_REGISTERED':
              var successExisting = function () {
                vm.formData = {};
                UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.EXISTING_USER); //aplicable only for sidebar
                $state.go('login');
              },
                errorExisting = function () {
                  $state.go('registration.kycVerification');
                };
              ModalService.registrationSuccessModal({
                'text': 'Your PAN is already registered. Please continue to login',
                'buttonText': 'Proceed to login'
              }, successExisting, errorExisting);
              break;
          }
          localStorage.setItem('loggedIn', true);
        } else {
          if (result && result.message) {
            MessageService.error(result.message);
          } else {
            UtilService.errorHandler(result);
          }
        }
      },
      error = function (msg) {
        LoaderService.hideLoader();
        vm.loginProcessFlag = false;
        if(msg.message == "Session for this User is already active"){
          vm.logout();
        }
        if (msg && msg.message) {
          if(msg.message == "Session for this User is already active"){

          }else{
            var messages = msg.message + '<span class="' + Math.random() + '"></span>';
            toastr.error(messages, '', {
            allowHtml: true,
            preventDuplicates: false,
            onHidden: function () {
              vm.loginProcessFlag = false;
            }
          });
          }
        } else {
          UtilService.errorHandler(msg);
        }
      };

      var payload = {
        otp: AuthService.encryptRSA(angular.copy(vm.verifyCodeOtp.toString())),
        panNumber: AuthService.encryptRSA(angular.copy(vm.taxIdentifierNumber)),
        secretLink: vm.singleUseURL,
        dob: AuthService.encryptRSA(angular.copy(vm.dob)),
        grant_type: 'password'
      }

      vm.loginProcessFlag = true;
      LoaderService.showLoader();

      AuthService.newInvestorLogin(payload).then(success, error);

    }
    function createmap() {
      var success = function (resp) {
      },
        error = function () {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.processFlag = false;
      LoaderService.showLoader('.pan-loader');
      InvestorService.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'create',
        child5: 'map'
      }).$promise.then(success, error);
    }

    vm.logout = function(){
      var success = function (resp) {
        if (resp.status) {
          vm.verifyOTP();
        } else {
        }
        LoaderService.hideLoader('.logout');
      },
        error = function (err) {
          LoaderService.hideLoader('.logout');
        };
      LoaderService.showLoader('.logout');

      var oneClickcUser = sessionStorage.getItem('oneClickcUser');
      var Data = {
        "panNumber": vm.taxIdentifierNumber
        }
      if(oneClickcUser){
        Data.isDpOnclickFLow = true;
      }
      InvestorService.post({
        child1: 'force',
        child2: 'logout'
      }, Data).$promise.then(success, error);
    }

    vm.deleteFolio = function(uuid){
      var success = function (resp) {
      },error = function (err) {
      };
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'draftFolio', child3: 'delete' }, { id: uuid }).$promise.then(success, error);
    }

    function fetchSavedDraftFolioData(result, cb) {
      cb = cb || function () {};
      var success = function (resp) {
          if (resp.data && resp.status) {
            cb(resp);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.processFlag = false;
      var payload = {};
      payload.id = result.data.transactionDraftId;
      LoaderService.showLoader('.pan-loader');
      if(payload.id) {
        InvestorService.post({
          child1: 'new',
          child2: 'user',
          child3: 'saved',
          child4: 'draft'
        }, payload).$promise.then(success, error);
      }
    }

    function redirectionToStep(result) {
      var data = result.data;
      data.newInvestorStatus = true;
      $window.sessionStorage.setItem("userData", JSON.stringify(data));
      createmap();
      if(result.data.step == "FIRST" || result.data.step == "SECOND" || result.data.step == "THIRD"){
        if(vm.distributorDetails && vm.distributorDetails.transactionType == 'Purchase_Scheduler'){
          $rootScope.stepperSecondary.steps[0].stepActive = false;
          $rootScope.stepperSecondary.steps[1].stepActive = false;
          $rootScope.stepperSecondary.steps[2].stepActive = false;
          $rootScope.stepperSecondary.steps[0].stepCompleted = true;
          $rootScope.stepperSecondary.steps[1].stepCompleted = true;
          $rootScope.stepperSecondary.steps[2].stepCompleted = true;
          $state.go('newInvestor.folioDetails.baiscDetails');
        } else {
          $state.go("newInvestor.investmentDetails.schemedetails.selectscheme");
        }
      }
      if(result.data.step == "HOLD"){
        var successModal = function () {

          },
          errorModal = function () {
            $state.go('newInvestor.kycVerification');
          };
        ModalService.holdHolderModal(result.data, successModal, errorModal);
      }
      if(result.data.step == "FOURTH"){
        $state.go("newInvestor.NewInvestorPayment");
      }
      if(result.data.step == "FIFTH"){
        if(vm.mobileLoginPandetails && vm.mobileLoginPandetails.throughPrelimanaryDashboard){
          vm.data ={
            text:"You can use your mobile number for login",
            buttonText: "Proceed to login"
          }
          ModalService.loginWithMobileNoteNJModal(vm.data,function(){},function(){});
        }else{
        $state.go("newInvestor.investorProfile");
      }
      }
      vm.errorMessageVerify = '';
    }

    // Added because existing delete folio functionality not working as communicated by backend
    function updatedDeleteFolioApi(){
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            MessageService.success("Successfully delete folio draft data.");
          } else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          LoaderService.hideLoader();
        };
      var payload = {
        panNumber: vm.taxIdentifierNumber
      };
      LoaderService.showLoader();
      InvestorServiceVersion3.post({
        child1: 'new',
        child2: 'user',
        child3: 'delete',
        child4: 'folio'
      }, payload).$promise.then(success, error);
    }

    function updateStep(result){
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            if(vm.mobileLoginPandetails && vm.mobileLoginPandetails.throughPrelimanaryDashboard){
              vm.data ={
                text:"You can use your mobile number for login",
                buttonText: "Proceed to login"
              }
              ModalService.loginWithMobileNoteNJModal(vm.data,function(){},function(){});
            }else{
            $state.go('newInvestor.investorProfile');
            }
          } else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'update',
        child2: 'step',
        child3: result.data.folioNumber
      }).$promise.then(success, error);
    }

    function getRandomOTPId() {
      var successRandomOTPIdHandler = function(resp) {
        sessionStorage.setItem('randomOTPIdForNewInvestorJourney', resp.randomOTPId);
      }, errorRandomOTPIdHandler = function (){}
      UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('KycVerificationController', KycVerificationController);
  /** @ngInject */
  function KycVerificationController($window, $state,$rootScope, $stateParams, $scope, toastr, AuthService, HDFC_API, LoaderService,
    AppConstants, TransactionService, MessageService, ModalService, UtilService, CommonFactory, CreatePayloadFactory, InvestorService,
    deviceDetector, $http, $sce, NetcoreEvntService, $log, BrowserService, investorServiceVersion, InvestorServiceVersion3, MetaTagService) {
    var vm = this;
    vm.panMessage = "";
    vm.dateErrorMessage = "";
    vm.formData = {};
    vm.mobileLoginPandetails = sessionStorage.getItem('MobilePanLoginDetails')?JSON.parse(sessionStorage.getItem('MobilePanLoginDetails')) :null;
    vm.prefillPan = vm.mobileLoginPandetails && vm.mobileLoginPandetails.pan ? true:false;
    if(vm.prefillPan){
      vm.formData.pan = vm.mobileLoginPandetails.pan;
    }
    vm.viewMode = "days";
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.prefillMobile = vm.mobileLoginPandetails && vm.mobileLoginPandetails.dob ? true:false;
      if(vm.prefillMobile){
      vm.formData.dob = vm.mobileLoginPandetails.dob;
    }
    vm.taxStatusList = {
      RESIDENT_INDIVIDUAL: "Resident Individual",
      NON_RESIDENT_INDIVIDUAL: "Non-Resident Individual"
    };
    // Folio data
    vm.tab1 = true;
    vm.tog = function(){
      vm.tab1 = false;
    }
    // history.pushState(null, null, location.href);
    // window.onpopstate = function () {
    //     history.go(1);
    // };
    /*----------------function declarations----------------*/
    vm.init = init;

    vm.verifyDetails = verifyDetails;
    vm.resetValues = resetValues;
    vm.checkPanVerification = checkPanVerification;
    vm.changeStartDate = changeStartDate;
    function init() {

      var fromarnHardcoded = JSON.parse(sessionStorage.getItem("onotp"));
      var verificationData = $state.params.verificationData ? $state.params.verificationData: null;
      if (verificationData) {
        vm.formData.pan = verificationData.panNumber;
        vm.formData.dob = $window.moment(verificationData.dob);
      }
      if(fromarnHardcoded){
        var verifyObjData = $state.params.verificationData ? $state.params.verificationData : JSON.parse(sessionStorage.getItem("verifyObj"))
        if(verifyObjData){
          $state.go("newInvestor.otpVerification")
        }
      }
      if(vm.mobileuserData && vm.mobileuserData.pan){
        vm.formData.pan = vm.mobileuserData.pan;
      }
      if($state.current.url == "/kyc-verification"){
        $rootScope.cUrl = true;
        }else{
        $rootScope.cUrl = false;
        }
      $rootScope.testObj.steps[0].stepCompleted = false;
      $rootScope.testObj.steps[1].stepCompleted = false;
      $rootScope.testObj.steps[2].stepCompleted = false;
      $rootScope.testObj.steps[0].stepActive = true;
      $rootScope.testObj.steps[1].stepActive = false;
      $rootScope.testObj.steps[2].stepActive = false;
      $rootScope.resertvalue();
      vm.formData.taxStatusResident = true;
    }
    init();
    function verifyDetails() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if(angular.isString(vm.formData.dob)){
            vm.encdob = $window.moment(vm.formData.dob, 'DD-MM-YYYY');
            vm.encdob = vm.encdob.format('DD-MMM-YYYY');
          }else{
            vm.encdob = vm.formData.dob.format('DD-MMM-YYYY');
          }
          vm.processFlag = false;
          vm.userData = resp.data
          vm.registrationType = resp.data.registrationType;
          // console.log(vm.registrationType);
          resp.data.PAN = vm.formData.pan;
          resp.data.dob = vm.encdob;
          CreatePayloadFactory.set(resp.data);
          //passing data to otp confirmation
          var verifyObj = {
            maskedEmail: resp.data.maskedEmail,
            maskedMobile: resp.data.maskedMobile,
            secretLink: resp.data.secretLink,
            panHolderName: resp.data.panHolderName,
            dob: vm.encdob,
            panNumber: vm.formData.pan,
            kycVerifiedFlag: resp.data.kycVerifiedFlag,
            kycStatus: resp.data.kycStatus,
            registrationType: resp.data.registrationType,
            taxStatusResident: vm.formData.taxStatusResident
          }
          vm.userDetails = verifyObj;
          $window.sessionStorage.setItem("verifyObj", JSON.stringify(verifyObj));
          $window.sessionStorage.setItem('dataLayerData', JSON.stringify({
            panHolderName: resp.data.panHolderName,
            panNumber: resp.data.encryptedPanNumber,
          }));


          switch (vm.registrationType) {
            case 'NEW':
              if ((resp.data.kycStatus === vm.KYC_STATUS.VERIFIED || resp.data.kycStatus === vm.KYC_STATUS.IN_PROGRESS)) {
                  if(!resp.data.emailId && !resp.data.contactNumber){
                      vm.checkPanVerification();
                      ModalService.nonKycModal({
                        'text': 'To proceed with Folio creation contact details of investor are mandatory. Kindly get in touch with our ISC or CAMS to update CKYC.',
                        'buttonText': 'OK'
                      }, function () { }, function () { });
                  }else{
                      $state.go("newInvestor.otpVerification")
                      vm.errorMessageVerify = '';
                  }
              } else if (resp.data.kycStatus === vm.KYC_STATUS.NOT_VERIFIED || resp.data.kycStatus === vm.KYC_STATUS.INCOMPLETE) {
                sessionStorage.setItem("ekycRequestCO", JSON.stringify(resp.data.ekycRequestCO));
                $state.go('ekyc', {
                  ekycRequestCO: resp.data.ekycRequestCO
                });
              } else if (resp.data.kycStatus === vm.KYC_STATUS.SUSPENDED) {
                ModalService.nonKycModal({
                  'text': resp.data.message,
                  'buttonText': 'OK'
                }, function () { }, function () { });
              } else if (resp.data.kycStatus === vm.KYC_STATUS.NOT_VALIDATED || resp.data.kycStatus === vm.KYC_STATUS.ON_HOLD) {
                ModalService.nonKycModal({
                  'text': resp.data.kycStatus === vm.KYC_STATUS.ON_HOLD ? vm.appConstants.ON_HOLD_MESSAGE : vm.appConstants.NOT_VALIDATED_MESSAGE,
                  'showHtml': true,
                  'buttonText': 'OK',
                  'ekycRequestCO': resp.data.ekycRequestCO
                }, function () { }, function () { });
              } else {
                ModalService.nonKycModal({
                  'text': 'Your KYC status is not verified, please update KYC with your current KRA through Point of Service of any KRA intermediary.',
                  'buttonText': 'OK'
                }, function () { }, function () { });
              }
              break;

            // case 'NEW_REGISTERED':
            //   var successNew = function () {
            //     vm.formData = {};
            //     UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.EXISTING_USER); //aplicable only for sidebar
            //     $state.go('login');
            //   },
            //     errorNew = function () {
            //       // $state.go('registration.kycVerification');
            //     };
            //   ModalService.registrationSuccessModal({
            //     'text': 'Your PAN is already registered. Please continue to login',
            //     'buttonText': 'Proceed to login'
            //   }, successNew, errorNew);
            //   break;
            // case 'EXISTING_REGISTERED':
            //   console.log("ex reg");
            //   var successExisting = function () {
            //     vm.formData = {};
            //     UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.EXISTING_USER); //aplicable only for sidebar
            //     $state.go('login');
            //   },
            //     errorExisting = function () {
            //       // $state.go('registration.kycVerification');
            //     };
            //   ModalService.registrationSuccessModal({
            //     'text': 'Your PAN is already registered. Please continue to login',
            //     'buttonText': 'Proceed to login'
            //   }, successExisting, errorExisting);
            //   break;
          }

          if(vm.registrationType == 'EXISTING'){
            $window.smartech('dispatch', 'Exisiting offline investor register', {});
            var panevent = $('#panevent');
            panevent.click();
          }
          if(vm.registrationType == 'NEW_REGISTERED' || vm.registrationType == 'EXISTING_REGISTERED'){
            $window.smartech('dispatch', 'Exisiting online investor register', {});
            var panevent = $('#panevent');
            panevent.click();
          }

        } else {
          if (resp && resp.message) {
            if (resp.message === "REDIRECT_TO_OLD") {
              ModalService.redirectToOldFolioModal({});
            } else if(resp.popupEnabled){
              ModalService.genericModal({
                text: resp.message,
                isAadhar: true
              });
            }else {
              var messages = resp.message + '<span class="' + Math.random() + '"></span>';
              toastr.error(messages, '', {
                allowHtml: true,
                preventDuplicates: false,
                onHidden: function () {
                  vm.processFlag = false;
                }
              });
            }
          } else {
            MessageService.error();
          }
        }
      },
        error = function (resp) {
          if (resp && resp.message) {
            var messages = resp.message + '<span class="' + Math.random() + '"></span>';
            toastr.error(messages, '', {
              allowHtml: true,
              preventDuplicates: false,
              onHidden: function () {
                vm.processFlag = false;
              }
            });
          } else {
            MessageService.error();
          }
          LoaderService.hideLoader();
        };
        if(angular.isString(vm.formData.dob)){
          vm.dateOfBirth = vm.formData.dob;
        }else{
          vm.dateOfBirth = vm.formData.dob.format('DD-MM-YYYY');
        }
      sessionStorage.setItem("panDetailsEncrypted", AuthService.encryptRSA(vm.formData.pan));
      var contactData = {
        'pk^pan_number': sessionStorage.getItem("panDetailsEncrypted"),
        'DOB': vm.dateOfBirth
      };
      $window.smartech('contact', '7', contactData, function () {
        $window.smartech('identify', sessionStorage.getItem("panDetailsEncrypted"));
        $window.smartech('dispatch', 'Registration_Initiated_1', {});
      });
      $window.smartech('dispatch', 'Verify kyc', {"PAN":sessionStorage.getItem("panDetailsEncrypted"), "DateofBirth":vm.dateOfBirth});
      $window.smartech('dispatch', 'Verify contact details', {});
      if(angular.isString(vm.formData.dob)){
        vm.encdob = $window.moment(vm.formData.dob, 'DD-MM-YYYY');
        vm.encdob = vm.encdob.format('DD-MMM-YYYY');
      }else{
        vm.encdob = vm.formData.dob.format('DD-MMM-YYYY');
      }
      var payload = {
        encdob: vm.encdob,
        panNumber:vm.formData && vm.formData.pan ? AuthService.encryptRSA(angular.copy(vm.formData.pan)) : '',
        nriFlag: vm.formData && vm.formData.taxStatusResident ? false : true
      };
      sessionStorage.setItem("panDetails", JSON.stringify(payload));
      vm.processFlag = true;
      // if(vm.formData && vm.formData.dob){
      //   vm.formData.dob = AuthService.encryptRSA(angular.copy(vm.formData.dob));
      // }
      if(payload && payload.encdob){
        payload.encdob = AuthService.encryptRSA(angular.copy(payload.encdob));
      }
      LoaderService.showLoader();

      InvestorServiceVersion3.post4({
        child1: 'registration',
        child2: 'new',
        child3: 'user',
        child4: 'verifyKYC'
      }, payload).$promise.then(success, error);
    }


    function resetValues() {
      vm.errorMessage = "";
      vm.errorMessageVerify = "";
      vm.panMessage = "";
      vm.availableMessage = "";
      vm.otpResendMessage = "";
      vm.dateErrorMessage = "";
    }
    vm.getModal = function () {
      if(vm.registrationType == 'EXISTING'){
        var success = function () {
          $state.go('createUserId.verifyAccountDetails');
        },
          error = function () {
            // $state.go('registration.kycVerification');
          };
        ModalService.olduser({
          'name':'',
          'email':'',
          'mobile':'',
          'text': 'To start your investment journey simply create your user ID and get started.',
          'buttonText': 'Create user id'
        }, success, error);
      }else if(vm.registrationType == 'NEW_REGISTERED' || vm.registrationType == 'EXISTING_REGISTERED'){
        var success = function () {
          $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH;
            sessionStorage.clear();
          },
            error = function () {
              // $state.go('registration.kycVerification');
            };

          ModalService.olduser({
            'name':vm.userDetails.panHolderName.split(' ')[0],
            'email':vm.userDetails.maskedEmail,
            'mobile':vm.userDetails.maskedMobile,
            'text': 'Please login to create new folio or transaction with us online.',
            'buttonText': 'Login'
          }, success, error);
      }
    }
    vm.conformation = "";
    vm.btnClose = true;
    vm.getconformation = function(){
      if($("#confirmfoliocreate").prop("checked")){
        $("#confirmfoliocreate1").prop("checked", false);
        vm.conformation = 'US_CANADA';
        vm.btnClose = true;
      }else{
        vm.conformation = '';
        vm.btnClose = true;
      }
      // if(vm.conformation){
      //   var successModal = function () {

      //   },
      //   errorModal = function () {
      //     $state.go('login')
      //   };
      // ModalService.confirmRegisterModal({}, successModal, errorModal)
      // }
    }
    vm.getconformation1 = function(){
      if($("#confirmfoliocreate1").prop("checked")){
        $("#confirmfoliocreate").prop("checked", false);
        vm.conformation = 'NOT_US_CANADA';
        vm.btnClose = false;
      }else{
        vm.conformation = '';
        vm.btnClose = true;
      }
    }


    vm.termandCondition = function(){
      ModalService.termConditionModal();
    }
    function checkPanVerification() {
      if (vm.formData.pan) {
        var success = function (resp) {
          LoaderService.hideLoader('.pan-loader');
          if (resp.data && resp.status) {
            $log.info("resp.data=== ", resp.data);
            if (resp.data.panVerifiedFlag) {
              vm.panMessage = "";
            } else {
              vm.panMessage = resp.data.message;
            }
            vm.processFlag = false;
          } else {
            vm.processFlag = true;
            vm.panMessage = resp.message;
          }
        },
          error = function () {
            LoaderService.hideLoader('.pan-loader');
            vm.processFlag = true;
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        vm.processFlag = false;
        LoaderService.showLoader('.pan-loader');
        InvestorService.post({
          child1: 'registration',
          child2: 'verifyPan'
        }, { "panNumber": vm.formData.pan }).$promise.then(success, error);
      }
    }
    function changeStartDate(date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.formData.dob = date;
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';
      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.formData.dob = "";
      }
      return;
    }

    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
         oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
    }
    vm.changesTaxStatus = function(){
      if(vm.formData.taxStatusResident == vm.taxStatusList.RESIDENT_INDIVIDUAL){
        vm.formData.taxStatusResident = true;
      }else{
        vm.formData.taxStatusResident = false;
      }
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestorProfileController', InvestorProfileController);

  /** @ngInject */
  function InvestorProfileController($window, $rootScope, $timeout, $state, $stateParams, $scope, AuthService, HDFC_API, toastr, LoaderService,
    AppConstants, TransactionService, MessageService, ModalService, UtilService, CommonFactory, CreatePayloadFactory, InvestorService,
    deviceDetector, $http, $sce, NetcoreEvntService, $log, BrowserService, investorServiceVersion, InvestorServiceVersion3, MetaTagService) {
      HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var vm = this;
    vm.mainPassword = "";
    vm.Cpassword = "";
    vm.passwordMatchSuccess = false;
    vm.userName = ""
    vm.appConstants = AppConstants;
    vm.peocessOTPFlag = false;
    vm.showPassword = false;
    vm.showConfirmPassword = false;
    vm.profiledata = {}
    vm.appConstants = AppConstants,
    vm.processOTPFlag = false;
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    vm.errorMessage = '';
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.inputReset = false;
    vm.otpNumber = "";
    vm.showotPindow = false;
    vm.otpResendMessage = "";
    vm.init = init;
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
        history.go(1);
    };
    vm.avaiableMessage = "";
    $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[1].stepCompleted = true;
      $rootScope.testObj.steps[2].stepCompleted = true;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepActive = false;
      $rootScope.testObj.steps[2].stepActive = false;

    function init() {
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[1].stepCompleted = true;
      $rootScope.testObj.steps[2].stepCompleted = true;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepActive = false;
      $rootScope.testObj.steps[2].stepActive = false;
      vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
      if(vm.distributorDetails) {
        if(vm.distributorDetails.isHdfcBank){
          ModalService.arnPopupModal({ status: "EXISTINGUSER"},
          function (data) {if(data == 'home'){ $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.distributorDetails.chipherText;}},function (data) { });
        }else{
          $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.distributorDetails.chipherText;
        }
      }
      vm.currentUserPayload = JSON.parse(sessionStorage.getItem("verifyObj"));
      // console.log(vm.currentUserPayload);
      vm.panNumber = vm.currentUserPayload.panNumber;
      localStorage.setItem('userEmail', vm.currentUserPayload.emailid);
      getUserDetails();
      vm.ModeOfHold = sessionStorage.getItem('ModeOfHold');
      vm.holdmode = localStorage.getItem('holdmode');

    }

    $('#newuserPassword').bind("cut copy paste",function(e) {
      e.preventDefault();
    });
    $('#confirmPassword').bind("cut copy paste",function(e) {
      e.preventDefault();
    });
    function getUserDetails() {

      if (!vm.currentUserPayload) {
        $state.go("login");
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          if ((resp.data.kycStatus === vm.KYC_STATUS.VERIFIED || resp.data.kycStatus === vm.KYC_STATUS.IN_PROGRESS)) {
            if (Object.keys(resp.data).length != 0) {
              vm.UserData = resp.data;
              vm.userName = vm.UserData.suggestedUserId;
              // console.log(vm.Cpassword.UserData);
              // console.log(vm.userName);
            } else {
              $state.go("login");
            }
          }
        } else if (!resp.status) {
          $state.go("login");
        }
      }, error = function (resp) {
        MessageService.error(resp.message);
        $state.go("login");
      };
      var data = {
        panNumber : vm.currentUserPayload.panNumber,
        dob : vm.currentUserPayload.dob
      };

      $window.smartech('dispatch', 'user id creation post kyc', {});

      investorServiceVersion.post({
        child1: 'registration',
        child2: 'verifyKyc',
        child3: 'generate',
        child4: 'userId'
      }, data).$promise.then(success, error);
    }

    vm.resetData = function () {
      vm.avaiableMessage = "";
      vm.mainPassword = "";
      vm.Cpassword = "";
    }
    vm.resetValues = function () {
      vm.errorMessage = "";
      vm.panMessage = "";
      vm.availableMessage = "";
      vm.otpResendMessage = "";
      vm.dateErrorMessage = "";
    }

    vm.matchPassword = function () {
      if (vm.mainPassword == vm.Cpassword) {
        vm.passwordMatchSuccess = true;
      }
      else {
        vm.passwordMatchSuccess = false;
      }
    }

    vm.togglePassword = function () {
      vm.showPassword = !vm.showPassword;
    }
    vm.toggleConfirmPassword = function () {
      vm.showConfirmPassword = !vm.showConfirmPassword;
    }

    vm.checkAvailability = function() {
      if (vm.userName) {
        var success = function (resp) {
          LoaderService.hideLoader('.availability-loader');
          if (resp.data && resp.status) {
            $log.info(resp.data.userIdAvailableFlag);
            if (resp.data.userIdAvailableFlag) {
              vm.availableMessage = "";
            } else {
              vm.availableMessage = resp.data.message || 'User ID not available';
            }
          } else {
            MessageService.error(resp.message);
          }
        },
          error = function () {
            LoaderService.hideLoader('.availability-loader');
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        LoaderService.showLoader('.availability-loader');
        InvestorService.get({
          child1: 'registration',
          child2: 'userId',
          child3: 'availability',
          child4: vm.userName
        }).$promise.then(success, error);
      }
    }

    vm.registerNewUser = function(){
      var success = function (resp) {
        if(resp.status && resp.data){
          var success = function () {
            vm.formData = {};
            AuthService.clearCookies(AppConstants.TOKEN) ;
            $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH;
          };
          var dismiss = function () {
            vm.formData = {};
            AuthService.clearCookies(AppConstants.TOKEN) ;
            $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH;
          };
          ModalService.newJourneyRegisteredModal({ 
          'text': 'UserID Created Successfully. Please Proceed to Login',
          'buttonText': 'Proceed to login'}, success, dismiss ,"custom");
        }else{
          if(resp.status){
            MessageService.success(resp.message);
            var success = function () {
              vm.formData = {};
              AuthService.clearCookies(AppConstants.TOKEN) ;
              $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH;
            };
            var dismiss = function () {
              vm.formData = {};
              AuthService.clearCookies(AppConstants.TOKEN) ;
              $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH;
            };
            ModalService.newJourneyRegisteredModal({ 
            'text': 'UserID Created Successfully. Please Proceed to Login',
            'buttonText': 'Proceed to login'}, success, dismiss ,"custom");
          }else{
            MessageService.error(resp.message);
            $state.go('login')
          }
        }
      },
        error = function (error) {
          MessageService.error(error);
        };
        var payload = {
          password: AuthService.encryptRSA(vm.mainPassword),
          panNumber: vm.currentUserPayload.panNumber,
          userId: vm.userName,
          registrationType: "NEW_USER",
          panHolderName: vm.UserData.panHolderName,
          emailId: vm.UserData.emailId.toLowerCase(),
          contactNumber: vm.UserData.contactNumber
      }

      InvestorService.post({
        child1: 'registration',
        child2: 'new',
        child3: 'user'
      }, payload).$promise.then(success, error);
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioDetailsController', FolioDetailsController);

  /** @ngInject */
  function FolioDetailsController($window, $rootScope, $timeout, $state, $stateParams, $scope, AuthService, HDFC_API, toastr, LoaderService,
    AppConstants, TransactionService, MessageService, ModalService, UtilService, CommonFactory, CreatePayloadFactory, InvestorService,
    deviceDetector, $http, $sce,NetcoreEvntService,$location, $log, BrowserService, investorServiceVersion,InvestorServiceV3, InvestorServiceVersion3, MetaTagService) {

    var vm = this;
    vm.init = init;
    vm.showholderdetails = false;
    vm.shownomineedetails = false;
    $rootScope.previousState;
    $rootScope.currentState;
    $rootScope.historyLocation = [];
    vm.taxStatusData = [];
    vm.investorOccupations = [];
    vm.incomeSlabList = [];
    vm.countries = [];
    vm.addressType = [];
    $rootScope.showSaveTag = false;
    $rootScope.folioBasicDetail = {};
    $rootScope.folioBasicDetail.folioHoldingMode = 'SINGLE';
    vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
    vm.taxIdType = [];
    function init() {
      getOccupations();
      getTaxStatus();
      getIncomeSlab();
      getCountry();
      getAddressType();
      getTaxIdType();
      // createFolio();
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[1].stepCompleted = true;
      $rootScope.testObj.steps[2].stepCompleted = false;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepActive = false;
      $rootScope.testObj.steps[2].stepActive = true;
    }


    function getOccupations() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorOccupations = resp.data.investorOccupations;
      } else {
        vm.investorOccupations = null;
         MessageService.error(resp.message);
      }
      },
        error = function () {
          // MessageService.error("Error in occupation list!");
        };
      InvestorService.get({ child1: 'folio', child2: 'occupation' }).$promise.then(success, error);
    }

    // Tax status
    function getTaxStatus() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusData = resp.data.taxStatus;
      } else {
        vm.taxStatusData = null;
         MessageService.error(resp.message);
      }
      },
        error = function () {
          // MessageService.error("Error in tax status!");
        };
      var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
      var nriFlag = UserData ? !UserData.taxStatusResident : null;
      var data = { taxStatusFilter: 'ADULT', nriFlag: nriFlag };
      InvestorService.post({ child1: 'folio', child2: 'tax-status', }, data).$promise.then(success, error);
    }
    // Income
    function getIncomeSlab() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.incomeSlabList = resp.data.incomeSlabList;
      } else {
        vm.incomeSlabList = null;
         MessageService.error(resp.message);
      }
      },
        error = function () {
          // MessageService.error("Error in income slab list!");
        };
      InvestorService.get({ child1: 'folio', child2: 'income-slab' }).$promise.then(success, error);
    }
    // Country
    function getCountry() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countries = resp.data.countries;
      } else {
        vm.countries = null;
         MessageService.error(resp.message);
      }
      },
        error = function () {
          // MessageService.error("Error in country list!");
        };
      InvestorService.get({ child1: 'folio', child2: 'country-list' }, null).$promise.then(success, error);
    }
    // AddressTYpe
    function getAddressType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.addressType = resp.data.addressTypeResponses;
       } else {
          vm.addressType = null;
         MessageService.error(resp.message);
      }
      },
        error = function () {
          // MessageService.error("Error in address type list!");
        };
      InvestorService.post({ child1: 'folio', child2: 'address-type' }, null).$promise.then(success);
    }
    // Tax Id Type
    function getTaxIdType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdType = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdType = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          // MessageService.error("Error in tax id type list!");
        };
      InvestorService.post({ child1: 'folio', child2: 'taxId-type' }, null).$promise.then(success);
    }

    // selft + sigle
    vm.stepperThird = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
      }, {
        step: 2,
        name: "Income Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 3,
        name: "Nominee Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      },{
        step: 4,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }
      ]
    };
    // minor
    vm.stepperForMinor = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
      }, {
        step: 2,
        name: "Guardian Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      },{
        step: 3,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }
      ]
    };

    vm.stepperForAnyoneSurvivor = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
      }, {
        step: 2,
        name: "Income Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 3,
        name: "Holder Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 4,
        name: "Nominee Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      },{
        step: 5,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }
      ]
    };
    $rootScope.addholder = {
      steps: [
        { step: 1, isactive: false },
        { step: 2, isactive: false },
        { step: 3, isactive: false }
      ]
    }

    $rootScope.nextStep = function (val) {
      if ($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE') {
        vm.stepperThird.steps[val].stepActive = false;
        vm.stepperThird.steps[val].stepCompleted = true;
        vm.stepperThird.steps[val + 1].stepActive = true;
      }
      else {
        vm.stepperForAnyoneSurvivor.steps[val].stepActive = false;
        vm.stepperForAnyoneSurvivor.steps[val].stepCompleted = true;
        vm.stepperForAnyoneSurvivor.steps[val + 1].stepActive = true;
      }

      if (vm.stepperThird.steps[0].stepActive && vm.stepperForAnyoneSurvivor.steps[0].stepActive) {
        vm.showincomedetails = false;
        vm.shownominidetails = false;
      }
      if (vm.stepperThird.steps[1].stepActive || vm.stepperForAnyoneSurvivor.steps[1].stepActive) {
        vm.showincomedetails = true;
        vm.shownominidetails = false;
      }
      if (vm.stepperThird.steps[2].stepActive) {
        vm.showincomedetails = false;
        vm.shownomineedetails = true;
      }
      if (vm.stepperForAnyoneSurvivor.steps[2].stepActive) {
        vm.showincomedetails = false;
        vm.showholderdetails = true;
      }
      if ($rootScope.folioBasicDetail.folioHoldingMode == 'ANY_OR_SURVIVOR' && val == 2) {
        $rootScope.addholder.steps[2].isactive = false;
        vm.stepperForAnyoneSurvivor.steps[2].stepActive = false;
        vm.stepperForAnyoneSurvivor.steps[2].stepCompleted = true;
        vm.stepperForAnyoneSurvivor.steps[3].stepActive = true;
      }
      if (vm.stepperForAnyoneSurvivor.steps[3].stepActive) {
        vm.showholderdetails = false;
        vm.shownomineedetails = true;
      }
    }

    $rootScope.minornext = function (val) {
      vm.stepperForMinor.steps[val].stepCompleted = true;
      vm.stepperForMinor.steps[val + 1].stepActive = true;
    }
    $rootScope.setProgress = function(){

    }

    vm.getTransactionDetails = function(){
      var success = function (resp) {
        if (resp.data && resp.status) {
          $rootScope.testObj.steps[1].schemeName = resp.data.fundName;
          switch(resp.data.installmentFrequency){
            case'OM':
               $rootScope.testObj.steps[1].frequency = "Monthly";
               break;
            case 'Q':
              $rootScope.testObj.steps[1].frequency = "Quarterly";
              break;
              case'H':
               $rootScope.testObj.steps[1].frequency = "Half Yearly";
               break;
            case 'Y':
              $rootScope.testObj.steps[1].frequency = "Yearly";
              break;
          }
          $rootScope.testObj.steps[1].schemeInfo.amount = resp.data.amount;
          $rootScope.testObj.steps[0].stepActive = false;
          $rootScope.testObj.steps[0].stepCompleted = true;
          $rootScope.testObj.steps[1].stepActive = false;
          $rootScope.testObj.steps[1].stepCompleted = true;
          $rootScope.testObj.steps[2].stepActive = true;
          $rootScope.testObj.steps[1].schemeInfo.investmentType = resp.data.investmentType;

          if(vm.distributorDetails && vm.distributorDetails.transactionType == 'Purchase_Scheduler'){
            $rootScope.testObj.steps[1].schemeName = "";
            $rootScope.testObj.steps[1].frequency = "";
            $rootScope.testObj.steps[1].schemeInfo.amount = "";
            $rootScope.testObj.steps[1].schemeInfo.investmentType = "";
          }
        } else {

          MessageService.error(resp.message);

        }

      },

      error = function (err) {

        MessageService.error(AppConstants.ToastrMessage.FAILED);

      };

      try{
      vm.processFlag = false;
      var Details =  JSON.parse(sessionStorage.getItem("userData"));
      if(Details && Details.transactionDraftId){
          InvestorService.post({child1: 'new',child2: 'user',child3: 'saved',child4: 'draft'
        },{"id":Details.transactionDraftId}).$promise.then(success, error);
      } 
    }catch(e){}
    }
    vm.getTransactionDetails();
    $rootScope.setBasicDetails = function () {
      vm.stepperThird.steps[0].stepActive = true;
      vm.stepperThird.steps[0].stepCompleted = false;
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('MobileTpvController', mobileTpvController);

  function mobileTpvController() {
    var vm = this;
    vm.date = new Date();
    vm.scroll = function (id) {
      var elmnt = document.getElementById(id);
      elmnt.scrollIntoView();
    }

  }
})();

/**
 * Created by ttn on 12/09/19.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller(  'MobileTncController', mobileTncController);

  /** @ngInject */
  function mobileTncController($stateParams , dynamicDataGeneral , dynamicDataCOBM) {
    var vm = this;
    vm.dynamicDataGeneral = dynamicDataGeneral.termAndConditionDTO.termAndConditionDTOMap.TNC_General.content;
    vm.dynamicDataCOBM = dynamicDataCOBM.termAndConditionDTO.termAndConditionDTOMap.TNC_ADD_NEWBANK.content;

    vm.init = function() {
      vm.transactionType = $stateParams.tncType;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('MobileFaqController', mobileFaqController);

  function mobileFaqController(faqData) {
    var vm = this;
    vm.date = new Date();
    vm.scroll = function (id) {
      var elmnt = document.getElementById(id);
      elmnt.scrollIntoView();

    }
    if (faqData.faqDTO.faqDTOMap.FAQ_Content) {
      vm.faqData = faqData.faqDTO.faqDTOMap.FAQ_Content.content;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('KycUpdateController', kycUpdateController);
  /** @ngInject */
  function kycUpdateController($window, $state, $rootScope, AppConstants, AuthService, ModalService, MessageService, LoaderService, UtilService, $log, InvestorService, $sce, $timeout) {
    var vm = this;
    vm.formData = {};
    vm.ekycRequestCO = {};
    vm.viewMode = "days";
    vm.panMessage = "";
    vm.actionUrl = "";
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.init = init;
    vm.checkPanVerification = checkPanVerification;
    vm.resetValues = resetValues;
    vm.changeStartDate = changeStartDate;
    vm.autoDate = autoDate;
    vm.verifyDetails = verifyDetails;
    init();

    UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.UPDATE_KYC);

    vm.handleSideBarClick = function(state) {
      UtilService.updateSideBar(state);
    };

    function init() {
      var dt = new Date();
      dt.setFullYear(new Date().getFullYear()-18);
      vm.maxDate = $window.moment(dt, "DD-MM-YYYY");
    }

    function checkPanVerification() {
      if (vm.formData.pan) {
        var success = function (resp) {
          LoaderService.hideLoader('.pan-loader');
          if (resp.data && resp.status) {
            $log.info("resp.data=== ", resp.data);
            if (resp.data.panVerifiedFlag) {
              vm.panMessage = "";
            } else {
              vm.panMessage = resp.data.message;
            }
            vm.processFlag = false;
          } else {
            vm.processFlag = false;
            vm.panMessage = resp.message;
          }
        },
        error = function () {
          LoaderService.hideLoader('.pan-loader');
          vm.processFlag = false;
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
        vm.processFlag = false;
        LoaderService.showLoader('.pan-loader');
        InvestorService.post({
          child1: 'registration',
          child2: 'verifyPan'
        }, { "panNumber": vm.formData.pan }).$promise.then(success, error);
      }
    }

    function resetValues() {
      vm.errorMessage = "";
      vm.errorMessageVerify = "";
      vm.panMessage = "";
      vm.availableMessage = "";
      vm.otpResendMessage = "";
      vm.dateErrorMessage = "";
    }

    function changeStartDate(date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.formData.dob = date;
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';
      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.formData.dob = "";
      }
      return;
    }

    function autoDate() {
      var oldlength = 0 ;
      if(vm.dobString){
        oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
    }

    function verifyDetails() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.processFlag = false;
          vm.ekycRequestCO = {
            url : resp.data.url,
            sess_id : resp.data.sess_id,
            ekyctype : resp.data.ekyctype,
            plkyc_type : resp.data.plkyc_type,
            kyc_data : resp.data.kyc_data,
            camsUrl: resp.data.camsUrl
          };
          $window.sessionStorage.setItem("onotp", false);
          if(!resp.data.alreadyInvestor){
            $state.go("newInvestor.kycVerification", {
              verificationData: {
                dob: vm.formData.dob,
                panNumber: vm.formData.pan,
                isFromKycUpdate: true
              }
            });
          } else if ((resp.data.ekycStatus === vm.KYC_STATUS.VERIFIED)) { //02 and 07
            vm.actionUrl = $sce.trustAsResourceUrl(vm.ekycRequestCO.camsUrl);
            LoaderService.showLoader();
            $timeout(function () {
              angular.element('#ekycForm').submit();
              $timeout(function() {
                LoaderService.hideLoader();
              }, 10000);
            }, 100);
            vm.errorMessageVerify = '';
          } else if (resp.data.ekycStatus === vm.KYC_STATUS.NOT_VERIFIED || resp.data.ekycStatus === vm.KYC_STATUS.INCOMPLETE) { // 04 and 05
            sessionStorage.setItem("ekycRequestCO", JSON.stringify(vm.ekycRequestCO));
            $state.go('ekyc', {
              ekycRequestCO: vm.ekycRequestCO
            });
          } else if (resp.data.ekycStatus === vm.KYC_STATUS.NOT_VALIDATED || resp.data.ekycStatus === vm.KYC_STATUS.ON_HOLD) {
            vm.actionUrl = $sce.trustAsResourceUrl(vm.ekycRequestCO.camsUrl);
            LoaderService.showLoader();
            $timeout(function () {
              angular.element('#ekycForm').submit();
              $timeout(function() {
                LoaderService.hideLoader();
              }, 10000);
            }, 100);
            vm.errorMessageVerify = '';
          } else {
            MessageService.error(AppConstants.UPDATE_KYC_ERROR);
          }
        } else {
          vm.processFlag = false;
          MessageService.error(resp.message);
        }
      },
      error = function (resp) {
        LoaderService.hideLoader();
        vm.processFlag = false;
        MessageService.error(resp.message);
      };
      var payload = {
        encdob: vm.formData && vm.formData.dob ? AuthService.encryptRSA(angular.copy(vm.formData.dob.format('DD-MMM-YYYY'))): '',
        panNumber:vm.formData && vm.formData.pan ? AuthService.encryptRSA(angular.copy(vm.formData.pan)) : ''
      };
      vm.processFlag = true;
      LoaderService.showLoader();
      InvestorService.post2({
        child1: 'ekyc',
        child2: 'updatekyc'
      }, payload).$promise.then(success, error);
    }
  }
})();

/**
 * Created by ttn on 6/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ProfileController', profileCtrl);

  /** @ngInject */
  function profileCtrl(InvestorService, investorServiceVersion, $scope, $state, $stateParams, $cookies, $window, AppConstants, UtilService, AuthService, $log, LoaderService,
                       InvestorFolioModel, $rootScope, InvestorProfilePhotoService, MessageService, ModalService, $timeout, KycService, CommonFactory, dynamicData, dynamicDataStandalone, panAadharService, $sce) {
    var vm = this;
    vm.basic = {};
    vm.idCreated = true;
    vm.currentNomineeIndx = 0;
    vm.currentJdHolderIndx = 0;
    vm.profileImage = null; 
    var locselectedLinkPanData = sessionStorage.getItem('selectedLinkPanData'); 
    if(locselectedLinkPanData){
      locselectedLinkPanData = $window.CryptoJS.AES.decrypt(locselectedLinkPanData.toString(), 'LinkPanData');
      locselectedLinkPanData = $window.JSON.parse(locselectedLinkPanData.toString($window.CryptoJS.enc.Utf8));
      if(locselectedLinkPanData && !locselectedLinkPanData.default){
        $state.go("welcome");
      }
    }
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.basicDetails = basicDetails;
    vm.folioDetails = folioDetails;
    vm.contactDetails = contactDetails;
    vm.mobileListData = [];
    vm.emailListData = [];
    vm.uploadProfileImage = uploadProfileImage;
    vm.changePassword = changePassword;
    vm.getDetails = getDetails;
    vm.getFolioDetailsInit = getFolioDetailsInit;
    vm.updateContact = updateContact;
    vm.saveNewContact = saveNewContact;
    vm.updateEmail = updateEmail;
    vm.saveNewEmail = saveNewEmail;
    vm.registerMandate = registerMandate;
    vm.cancelMandate = cancelMandate;
    vm.getInfo = getInfo;
    vm.redirectToFolioCreation = redirectToFolioCreation;
    vm.nameFull = '';
    vm.contactEdit = false;
    vm.emailEdit = false;
    vm.formData = {};
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.addTaxResidency = addTaxResidency;
    vm.deleteBank = deleteBank;
    vm.changeDefaultBank = changeDefaultBank;
    vm.deleteBankSuccess = deleteBankSuccess;
    vm.deleteTaxResidency = deleteTaxResidency;
    vm.folioNo = null;
    vm.dividendFlag = false;
    vm.redemptionFlag = false;
    vm.folioEmailEdit = false;
    vm.isCheckedKycTandC = false;
    vm.isCheckedFatcaTandC = false;
    vm.subscribeToggle = true;
    vm.updateFolioEmail = updateFolioEmail;
    vm.saveNewFolioEmail = saveNewFolioEmail;
    vm.updateFolioContact = updateFolioContact;
    vm.saveNewFolioContact = saveNewFolioContact;
    var identifierData = AuthService.getToken();
    vm.redirectToAddBank = redirectToAddBank;
    vm.redirectToCobmStatus = redirectToCobmStatus;
    vm.changePayoutSwitch = false;
    vm.disableLinkNow = false;
    vm.payoutSwitch = payoutSwitch;
    vm.getPayoutMechanism = getPayoutMechanism;
    vm.UpdatePayoutMethod = UpdatePayoutMethod;
    vm.redirectIFSCUpdate = redirectIFSCUpdate;
    vm.redirectToChangeBank = redirectToChangeBank;
    vm.updatePayOut = updatePayOut;
    vm.toggleMarketing = toggleMarketing;
    vm.subscribed = true;
    vm.subscribedWhatsapp = true;
    vm.isDisabled = true;
    vm.registerForWhatsapp = registerForWhatsapp;
    vm.folioCreationEnabled = identifierData ? identifierData.folioCreationEnabled : false;
    vm.mobileActive = !UtilService.mobileActiveStatus.get();
    vm.dynamicDataStandalone = dynamicDataStandalone;
    vm.fetchBelongsToDropdown = fetchBelongsToDropdown;
    vm.updateMobileChange = updateMobileChange;
    vm.mobile_regex_digits = new RegExp(/^\+91[6-9][0-9]{9}$/);
    vm.mobile_regex_sameDigits = new RegExp(/^(\d)\1*$/);
    vm.isValid = true;
    vm.isMobileNotValid = false;
    AuthService.checkLinkedUserStatus();
    vm.toggleWhatsapp=toggleWhatsapp;
    if (dynamicData.noteDTO.noteDTOMap.Note_Profile_Detail) {
      vm.dynamicDataNote = dynamicData.noteDTO.noteDTOMap.Note_Profile_Detail.content;
    }

    vm.cancelMandateUrl = null;
    vm.saveContactBtn = false;
    vm.saveEmailBtn = false;
    vm.saveFolioContactBtn = false;
    vm.saveFolioEmailBtn = false;
    vm.hideChangePayoutOpt = false;
    sessionStorage.removeItem('setFolioInitiateState');
    vm.ekycRequestCO = {};
    vm.actionUrl = "";

    function redirectToAddBank() {
      var successHandler = function (resp) {
        LoaderService.hideLoader();
        var bankDetails = [];
        localStorage.setItem('folioId', vm.folioNo);
        localStorage.setItem('folioNo', vm.folioNo);
        localStorage.setItem('index', vm.currentFolioIndx);
        (vm.folioDetailsData) && (localStorage.setItem('folioTaxStatus', vm.folioDetailsData.folioTaxStatus));
        (vm.folioDetailsData) && (localStorage.setItem('folioTaxStatusCode', vm.folioDetailsData.folioTaxStatusCode));
        if (vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length > 0) {
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if (value.defaultBank === true) {
              return value;
            }
          });
        }
        localStorage.setItem('bankDetails', $window.JSON.stringify(bankDetails));
        $window.sessionStorage.setItem('bankConstraints', angular.toJson({
          isFromProfile: true,
          uploadChequeLeafEnabled: vm.uploadChequeLeafEnabled
        }));
        $state.go('main.addBank');
      };
      var errorHandler = function (resp) {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber, null).then(successHandler).catch(errorHandler);

    }


    function toggleMarketing() {
      if (!vm.subscribed) {
        vm.subscribed = true;
        var success = function (resp) {
          LoaderService.hideLoader();
          MessageService.success(resp.data.message);
        }, error = function () {
          LoaderService.hideLoader();
          MessageService.error(resp.data.message);
        };

        LoaderService.showLoader();
        InvestorService.post({
          child1: 'profile',
          child2: 'folio',
          child3: 'marketing',
          child4: 'subscribe'
        }, {folioNumber: vm.folioNo, reason: ""}).$promise.then(success, error);
      } else {
        vm.subscribed = false;
        error = function () {
          vm.subscribedToggleFlag = true;
          vm.subscribed = true;
        };
        ModalService.subscribeToggleModal({folioNumber: vm.folioNo}, success, error);
      }
    }

    function redirectToChangeBank() {
      var bankDetails = [];
      localStorage.setItem('folioId', vm.folioNo);
      localStorage.setItem('folioNo', vm.folioNo);
      localStorage.setItem('index', vm.currentFolioIndx);
      if (vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length > 0) {
        bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
          if (value.defaultBank === true) {
            return value;
          }
        });
      }
      localStorage.setItem('bankDetails', $window.JSON.stringify(bankDetails));
    }

    function registerForWhatsapp() {
      var success = function () {
        vm.disableLinkNow = true;
      }

      var error = function () {
      }
      ModalService.subscribeWhatsapp({}, success, error);
    }

    function redirectToCobmStatus() {
      LoaderService.showLoader();
      var success = function (res) {
        LoaderService.hideLoader();
        if (res.status && res.data) {
          vm.cobmDetailList = res.data.cobmDetailList;
          localStorage.setItem('cobmDetailList', angular.toJson(res.data.cobmDetailList));
          $state.go('main.cobmStatus');
        } else {
          if (localStorage.getItem('cobmDetailList')) {
            localStorage.removeItem('cobmDetailList');
          }
          vm.cobmDetailList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        if (localStorage.getItem('cobmDetailList')) {
          localStorage.removeItem('cobmDetailList');
        }
        vm.cobmDetailList = null;
        UtilService.errorHandler(err);
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'cobm',
        child3: 'status',
        child4: vm.folioNo
      }).$promise.then(success, error);
    }

    vm.occupationList = [];
    vm.incomeSlabList = [];
    vm.minDate = $window.moment().subtract(1, 'years').toString();
    vm.defaultdate = $window.moment().toString();
    vm.saveKYCUpdate = saveKYCUpdate;
    vm.addFatcaTaxResidency = addFatcaTaxResidency;
    vm.POLITICAL_STATUS = AppConstants.INVESTOR_POLITICAL_STATUS;
    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.kycStatus = '';

    vm.countryList = [];
    vm.addressTypeList = [];
    vm.taxIdTypeList = [];
    vm.formData.payOutsideIndiaAddresses = [];
    vm.isResetting = true;
    vm.changePayTaxOutsideIndiaStatus = changePayTaxOutsideIndiaStatus;
    vm.saveFatcaUpdate = saveFatcaUpdate;
    vm.deleteFatcaTaxResidency = deleteFatcaTaxResidency;
    vm.fetchTaxIdTypeFromKey = fetchTaxIdTypeFromKey;
    vm.fetchCountryNameFromCode = fetchCountryNameFromCode;
    vm.fatcaStatus = '';


    if ($stateParams) {
      vm.folioNumberforKyc = $stateParams.folioNumber ? $stateParams.folioNumber : '';
    }

    function basicDetails() {
      var stateName = $state.current.name;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp && resp.data) {
          vm.fetchBelongsToDropdown();
          vm.basic = resp.data;
          vm.formData.contact = vm.basic.basicInfo.mobileNo; //.slice(-10);
          vm.formData.emailAddress = vm.basic.accountDetails.emailId;
          vm.mobileNoExists = vm.basic.mobileNoExists;
          vm.whatsappTransactionSubscribed = vm.basic.whatsappTransactionSubscribed;
          resp.data.profileImageUrl = resp.data && resp.data.profileImageUrl ? resp.data.profileImageUrl : AppConstants.DEFAULT_PROFILE_IMAGE;
          vm.basic.profileImageUrl = resp.data.profileImageUrl;
          vm.nameFull = vm.basic && vm.basic.basicInfo && vm.basic.basicInfo.name;
          identifierData.profileImageUrl = vm.basic.profileImageUrl;
          vm.subscribedWhatsapp = (vm.basic && vm.basic.whatsAppNotification);
          vm.subscribedToggleFlagForWhatsapp=vm.subscribedWhatsapp;
          vm.isDisabled = vm.basic.whatsAppNotificationButtonDisabled;
          AuthService.setToken(identifierData);
          $scope.ProfileParentCtrl.nameFull = vm.nameFull;
          $scope.ProfileParentCtrl.pendingApprovalCount = angular.isDefined(vm.basic.pendingApprovalCount) ?
            vm.basic.pendingApprovalCount : 0;
          if (stateName == $state.current.name) {
            LoaderService.hideLoader();
          }
          if(vm.basic && vm.basic.accountDetails && vm.basic.accountDetails.userId){
            vm.idCreated = true;
            var regex = /^temp_/;
            if(regex.test(vm.basic.accountDetails.userId) && vm.basic.accountDetails.userId.length > 30){
              vm.idCreated = false;
            }
          }else{
            vm.idCreated = false;
          }
        } else {
          MessageService.error(resp.message);
        }

      }, error = function () {
        LoaderService.hideLoader();
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'basicProfile'
      }, {}).$promise.then(success, error);

    }

    function getFolioDetailsInit() {
      var isBack = localStorage.getItem('isBack');
      vm.contactUpdateAllowed = false;
      if (isBack) {
        var folio = {};
        folio.folioNo = localStorage.getItem('folioNo');
        var index = localStorage.getItem('index');
        if (!folio.folioNo && !index) {
          getDetails(vm.folioListData[0], 0);
        } else {
          localStorage.removeItem('folioNo');
          localStorage.removeItem('index');
          getDetails(folio, index);
        }
        localStorage.removeItem('isBack');
      } else {
        getDetails(vm.folioListData[0], 0);
      }
    }

    function getDetails(folio, index) {
      vm.selectedFolio = folio.folioNo;
      vm.folioNo = folio.folioNo;
      vm.currentFolioIndx = index;
      vm.emailBelongsTo = null;
      vm.mobileBelongsTo = null;
      getSupplementaryKycDetailStatus();

      var success = function (resp) {

        LoaderService.hideLoader();
        if(resp && resp.data){
          vm.folioDetailsData = resp.data;
          vm.nomineeLength = (vm.folioDetailsData && vm.folioDetailsData.nominees)?vm.folioDetailsData.nominees.length:0;
          vm.subscribed = (vm.folioDetailsData && vm.folioDetailsData.subscription);
          vm.subscribedToggleFlag = vm.subscribed;
          vm.formData.folioEmailAddress = (vm.folioDetailsData && vm.folioDetailsData.contactDetails) ? vm.folioDetailsData.contactDetails.emailId : '';
          vm.formData.folioMobileContact = (vm.folioDetailsData && vm.folioDetailsData.contactDetails) ? vm.folioDetailsData.contactDetails.mobileNumber : '';
          vm.contactUpdateAllowed = vm.folioDetailsData.contactDetails.isContactUpdateAllowed;
          vm.contactUpdateErrorMessage = vm.folioDetailsData.contactDetails.contactUpdateErrorMessage;
          vm.showJointHolderDetails(vm.folioDetailsData.jointHolders ? vm.folioDetailsData.jointHolders[0] : '', 0);
          vm.showBankDetails(vm.folioDetailsData.bankDetails ? vm.folioDetailsData.bankDetails[0] : '', 0);
          vm.showOtmDetails(vm.folioDetailsData.otm ? vm.folioDetailsData.otm[0] : '', 0);
          vm.showCamsOtmDetails(vm.folioDetailsData.camsOTM ? vm.folioDetailsData.camsOTM[0]:'', 0);
          getPersonalIdentifier(function(resp) {
            if (resp) {
              vm.showNomineeDetails(vm.folioDetailsData.nominees ? vm.folioDetailsData.nominees[0] : null, 0);
            }
          });
          for (var i in vm.folioDetailsData.investments) {
            vm.folioDetailsData.investments[i].redemptionSum = null;
            vm.folioDetailsData.investments[i].dividendSum = null;
          }
          vm.cancelMandateUrl = vm.folioDetailsData.cancelMandateUrl;
          vm.uploadChequeLeafEnabled = vm.folioDetailsData.uploadChequeLeafEnabled;
        }else {
          if(resp && resp.message){
            MessageService.error(resp.message);
            vm.folioDetailsData = null;
          }
        }
      }, error = function () {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: folio.folioNo}).$promise.then(success, error);
      vm.folioEmailEdit = false;
      vm.folioMobileEdit = false;

    }

    vm.unclaimedDetailsModal = function (data) {
      var success = function () {

        },
        error = function () {

        };
      ModalService.unclaimedDividendModal({unclaimedData: data}, success, error);
    };

    function addTaxResidency() {
      var successModal = function (data) {
          if (data && data.inserted) {
            basicDetails();
          } else {
            $state.go('main.profile.basicInfo');
          }
        },
        errorModal = function () {
        };
      ModalService.addTaxResidencyModal({}, successModal, errorModal)
    }

    function addFatcaTaxResidency() {
      var successModal = function (data) {
          vm.formData.payOutsideIndiaAddresses = vm.formData.payOutsideIndiaAddresses || [];
          var addressOutSideIndia = vm.formData.payOutsideIndiaAddresses;
          var pushStatus = false;
          addressOutSideIndia && addressOutSideIndia.length && addressOutSideIndia.forEach(function (item) {
            if ((item.country == data.country) && (item.taxIdType == data.taxIdType) && (item.taxIdNumber == data.taxIdNumber)) {
              MessageService.error("Duplicate Tax Residency Entry");
            } else {
              if (item.taxIdNumber == data.taxIdNumber) {
                MessageService.error("Tax Residency for this Tax ID Number is already added.")
              } else {
                if ((item.country == data.country) && (item.taxIdType == data.taxIdType)) {
                  MessageService.error("Country can not have same Tax ID Type with Different Tax ID Number")
                } else {
                  pushStatus = true;
                }
              }
            }
          });
          if (vm.formData.payOutsideIndiaAddresses.length == 0) {
            vm.formData.payOutsideIndiaAddresses.push(data);
          }

          if (pushStatus) {
            vm.formData.payOutsideIndiaAddresses.push(data);
          }

        },
        errorModal = function () {

        };
      ModalService.addfatcaTaxResidencyModal({}, successModal, errorModal)
    }

    function deleteTaxResidency(taxIdNumber) {
      var successModal = function () {
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              if (resp.data.inserted) {
                basicDetails();
              } else {
                MessageService.error(resp.data.fatcaErrorMessage)
              }
            } else {
              MessageService.error(resp.message);
            }
          }, error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err.message);
          };
          LoaderService.showLoader();
          InvestorService.post({
            child1: 'profile',
            child2: 'delete',
            child3: 'fatca'
          }, {taxIdNumber: taxIdNumber}).$promise.then(success, error);
        },
        errorModal = function () {
          //MessageService.error(err)
        };
      ModalService.deleteTaxResidencyModal({}, successModal, errorModal)

    }

    vm.currentBankIndx = 0;
    vm.showBankDetails = function (banks, index) {
      vm.currentBankIndx = index;
      vm.bankDetails = banks;
    };
    vm.currentNomineeIndx = 0;
    vm.showNomineeDetails = function (nominee, index) {
      vm.currentNomineeIndx = index;
      vm.nomineeDetails = nominee;
      if (vm.nomineeDetails) {
        var date = vm.nomineeDetails.dateOfBirth;
        var age = $window.moment().diff(date, 'years');
        if(vm.nomineeDetails.dateOfBirth){
          if (age < 18) {
            vm.nomineeDetails.minor = true;
          } else {
            vm.nomineeDetails.minor = false;
          }
        }else{
          vm.nomineeDetails.minor = false;
        }
      }
    };
    vm.currentOtpIndx = 0;
    vm.showOtmDetails = function (otm, index) {
      vm.currentOtpIndx = index;
      vm.otpDetails = otm;
    };
    vm.showCamsOtmDetails = function (otm, index) {
      vm.currentOtpIndx = index;
      vm.cotmDetail = otm;
    };

    vm.currentJdHolderIndx = 0;
    vm.showJointHolderDetails = function (jointHolder, index) {
      vm.currentOtpIndx = index;
      vm.jointHoldersDetails = jointHolder;
    };

    function changePassword() {
      var success = function (resp) {

        if (resp.data && resp.status) {
          var changeSuccess = function () {
              vm.logoutMe();
            },
            changeError = function () {
            };

          ModalService.changePasswordSuccessModal({message: resp.data.message}, changeSuccess, changeError);
        } else {
          $state.go("main.profile.basicInfo")
        }

        /*} else {
         MessageService.error(resp.message);
         }*/
      };
      ModalService.changePasswordModal({}, success);
    }

    vm.logoutMe = function () {
      AuthService.logout().then(function () {
        CommonFactory.setLogoutSuccess();
        $state.go('login');
      }, function () {
        // $state.go('login');
      });
    };

    vm.isObjectEmpty = function (obj) {
      try {
        return Object.keys(obj).length === 0;
      } catch (e) {
        return true;
      }
    }

    function folioDetails() {
      vm.folioListData = [];
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var folio = [];
          for (var i in resp.data.folioMap) {
            var obj = {};
            obj.key = i;
            obj.folioNo = resp.data.folioMap[i];
            folio.push(obj);
          }
          vm.folioListData = folio;
        } else {
          vm.folioListData = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.folioListData = null;
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      InvestorService.get({
        child1: 'folio',
        child2: 'getInvestorFolioMap'
      }).$promise.then(success, error);
      vm.getPayoutMechanism();
      vm.fetchBelongsToDropdown();
    }

    function contactDetails() {
      vm.investorPAN = vm.basic.basicInfo.panNumber;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var contactList = resp.data.folios;
          var emailList = [];
          var mobileList = [];
          for (var i = 0; i < contactList.length; i++) {
            if (contactList[i].emailId)
              emailList.push(contactList[i]);
            if (contactList[i].mobileNumber)
              mobileList.push(contactList[i]);
          }
          vm.emailListData = emailList.length ? emailList : null;
          vm.mobileListData = mobileList.length ? mobileList : null;
        } else {
          vm.emailListData = null;
          vm.mobileListData = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.emailListData = null;
        vm.mobileListData = null;
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'linkedFolio',
        // child3: vm.investorPAN
      },{
        // added dummy empty payload data for encrypted response , no payload is required for this api
        payloadData : ''
      }).$promise.then(success, error);
    }

    function redirectToFolioCreation() {
      var successHandler = function () {
        var successHandlerFolioCreation=function(resp) {
          LoaderService.hideLoader();
          localStorage.removeItem('folioId');
          InvestorFolioModel.resetInvestorFolioModel();
          $state.go('main.folio.holdmode');
          $rootScope.setFolioInitiateState = $state.current.name;
          sessionStorage.setItem('setFolioInitiateState', $rootScope.setFolioInitiateState);
        };
        var errorHandlerFolioCreation=function(resp)
        {
          LoaderService.hideLoader();
          return;
        };
        LoaderService.showLoader();
        panAadharService.fetchPanAadharLinkingStatus(AuthService.getToken().investorPAN,null).then(successHandlerFolioCreation).catch(errorHandlerFolioCreation);
      };
      KycService.fetchKycStatus(AppConstants.KYC_RESTRICTION.FOLIO_CREATION).then(successHandler).catch(function (resp) {
        $log.info(resp);
      });
    }


    function uploadProfileImage(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.basic.profileImageUrl = "";
                $timeout(function () {
                  vm.basic.profileImageUrl = resp.data.logoUrl;
                });
                identifierData.profileImageUrl = resp.data.logoUrl;
                AuthService.setToken(identifierData);
                $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            InvestorProfilePhotoService.post({
              child1: 'profile',
              child2: 'upload',
              child3: 'logo'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function updateContact() {

      var successHandler=function (resp) {
        LoaderService.hideLoader();
        if (!vm.formData.emailAddress && !vm.formData.contact) {
          ModalService.genericModal({
            text: "Your email ID and mobile number are not updated. Kindly download the form to update contact details by <a class='update-contact-folio' target='_blank' href='https://files.hdfcfund.com/s3fs-public/2018-04/CTR_Non_Financial_Transaction_15062016_6.pdf'>clicking here</a> and submit to our nearest Investor Service Center (ISC) or you can write to us at <a href='mailto:Hello@hdfcfund.com' class=text-blue'>Hello@hdfcfund.com</a> with your queries for updating contact details."
          });
          return;
        } else {
          vm.contactEdit = true;
          vm.saveContactBtn = true;
          vm.formData.contactEdited = vm.formData.contact;
          vm.mobileBelongsToProfile = null;
          contactDetails();
        }
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return ;
      }
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);
    }

    function updateFolioContact() {
      if (vm.contactUpdateAllowed) {
        var successHandler=function(resp) {
          LoaderService.hideLoader();
          if (!vm.formData.folioEmailAddress && !vm.formData.folioMobileContact) {
            ModalService.genericModal({
              text: "Your email ID and mobile number are not updated. Kindly download the form to update contact details by <a class='update-contact-folio' target='_blank' href='https://files.hdfcfund.com/s3fs-public/2018-04/CTR_Non_Financial_Transaction_15062016_6.pdf'>clicking here</a> and submit to our nearest Investor Service Center (ISC) or you can write to us at <a href='mailto:Hello@hdfcfund.com' class=text-blue'>Hello@hdfcfund.com</a> with your queries for updating contact details."
            });
            return;
          } else {
            vm.folioMobileEdit = true;
            vm.saveFolioContactBtn = true;
            vm.formData.folioMobileEdited = vm.formData.folioMobileContact;
          }
        };
        var errorHandler=function(resp)
        {
          LoaderService.hideLoader();
          return;
        };
        LoaderService.showLoader();
        panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);
      } else {
        MessageService.error(vm.contactUpdateErrorMessage);
        return;
      }

    }
    function updateEmail() {
      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        if (!vm.formData.emailAddress && !vm.formData.contact) {
          ModalService.genericModal({
            text: "Your email ID and mobile number are not updated. Kindly download the form to update contact details by <a class='update-contact-folio' target='_blank' href='https://files.hdfcfund.com/s3fs-public/2018-04/CTR_Non_Financial_Transaction_15062016_6.pdf'>clicking here</a> and submit to our nearest Investor Service Center (ISC) or you can write to us at <a href='mailto:Hello@hdfcfund.com' class=text-blue'>Hello@hdfcfund.com</a> with your queries for updating contact details."
          });
          return;
        } else {
          vm.emailEdit = true;
          vm.saveEmailBtn = true;
          vm.formData.emailAddressEdited = vm.formData.emailAddress;
          vm.emailBelongsToProfile = null;
          contactDetails();
        }
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);
    }

    function updateFolioEmail() {
      if (vm.contactUpdateAllowed) {
        var successHandler=function(resp) {
          LoaderService.hideLoader();
          if (!vm.formData.folioEmailAddress && !vm.formData.folioMobileContact) {
            ModalService.genericModal({
              text: "Your email ID and mobile number are not updated. Kindly download the form to update contact details by <a class='update-contact-folio' target='_blank' href='https://files.hdfcfund.com/s3fs-public/2018-04/CTR_Non_Financial_Transaction_15062016_6.pdf'>clicking here</a> and submit to our nearest Investor Service Center (ISC) or you can write to us at <a href='mailto:Hello@hdfcfund.com' class=text-blue'>Hello@hdfcfund.com</a> with your queries for updating contact details."
            });
            return;
          } else {
            vm.folioEmailEdit = true;
            vm.saveFolioEmailBtn = true;
            vm.formData.folioEmailAddressEdited = vm.formData.folioEmailAddress;
          }
        };
        var errorHandler=function(resp)
        {
          LoaderService.hideLoader();
          return;
        };
        LoaderService.showLoader();
        panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);
      } else {
        MessageService.error(vm.contactUpdateErrorMessage);
        return;
      }
    }


    function saveNewContact() {
      if (vm.formData.contactEdited && vm.formData.contactEdited != vm.formData.contact) {
        vm.saveContactBtn = false;
        var successContact = function (resp) {
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              var confirmSuccess = function (message) {
                var success = function () {
                    basicDetails();
                    vm.contactEdit = false;
                    UtilService.mobileActiveStatus.set(true);
                    $window.sessionStorage.setItem('mobileActive', true);
                    vm.mobileBelongsToProfile = null;
                    vm.mobileActive = !UtilService.mobileActiveStatus.get();
                  },
                  error = function () {
                  };
                ModalService.OtpModalSuccessModal({message: message}, success, error);
              };
              var confirmError = function () {
                vm.contactEdit = false;
              };
              ModalService.OtpModal({
                text: 'Mobile Number',
                previousContact: vm.formData.contact,
                message: resp.data.message,
                contact: vm.formData.contactEdited,
                mail: vm.formData.emailAddress,
                level: 'profileLevel'
              }, confirmSuccess, confirmError);
            } else {
              vm.contactEdit = false;
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text:resp.message
                })
              } else {
                MessageService.error(resp.message);
              }
            }
          },
          errorContact = function () {
            LoaderService.hideLoader();
            vm.emailEdit = false;
            vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          };
        var payload = {
          "value": vm.formData.contactEdited,
          "mobileBelongsTo" : vm.mobileBelongsToProfile
        };
        if(vm.formData.contact){
          payload.oldValue = vm.formData.contact;
        }
        LoaderService.showLoader();
        investorServiceVersion.post({
          child1: 'profile',
          child2: 'edit',
          child3: 'mobile'
        }, payload).$promise.then(successContact, errorContact);
      } else {
        vm.formData.contact = vm.formData.contactEdited;
        vm.contactEdit = false;
        vm.saveContactBtn = false;
      }
    }

    function saveNewFolioContact() {
      if (vm.formData.folioMobileEdited && vm.formData.folioMobileEdited != vm.formData.folioMobileContact) {
        vm.saveFolioContactBtn = false;
        var successContact = function (resp) {
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              var confirmSuccess = function (message) {
                var success = function () {
                    basicDetails();
                    vm.folioMobileEdit = false;
                    vm.formData.folioMobileContact = vm.formData.folioMobileEdited;
                    vm.contactUpdateAllowed = true;
                  },
                  error = function () {
                  };
                ModalService.OtpModalSuccessModal({message: message}, success, error);
              };
              var confirmError = function () {
                vm.folioMobileEdit = false;
              };
              ModalService.OtpModal({
                text: 'Folio Update Details',
                previousContact: vm.formData.folioMobileContact,
                message: resp.data.message,
                contact: vm.formData.folioMobileEdited,
                mail: vm.formData.folioEmailAddress,
                folioNo: vm.folioNo,
                level: 'folioLevel'
              }, confirmSuccess, confirmError);
            } else {
              vm.folioMobileEdit = false;
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text:resp.message
                })
              } else {
                MessageService.error(resp.message);
              }
            }
          },
          errorContact = function () {
            LoaderService.hideLoader();
            //vm.emailEdit = false;
            vm.folioMobileEdit = false;
            vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          };
        var payload = {
          "changeFor": "Folio",
          "folioNumber": vm.folioNo,
          "panNumber": "",
          "value": vm.formData.folioMobileEdited,
          "mobileBelongsTo" : vm.mobileBelongsTo
        };
        if(vm.formData.folioMobileContact){
          payload.oldValue = vm.formData.folioMobileContact;
        }
        LoaderService.showLoader();
        investorServiceVersion.post({
            child1: 'profile',
            child2: 'folio',
            child3: 'edit',
            child4: 'mobile'
          }, payload).$promise.then(successContact, errorContact);
      } else {
        vm.formData.folioMobileContact = vm.formData.folioMobileEdited;
        vm.folioMobileEdit = false;
        vm.saveFolioContactBtn = false;
        vm.mobileBelongsTo = null;
      }
    }


    function saveNewEmail() {
      if (vm.formData.emailAddressEdited && vm.formData.emailAddressEdited != vm.formData.emailAddress) {
        vm.saveEmailBtn = false;
        var successEmail = function (resp) {
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              var confirmSuccess = function (message) {
                var success = function () {
                    //vm.formData.emailAddress = vm.formData.emailAddressEdited;
                    vm.emailEdit = false;
                    vm.emailBelongsToProfile = null;
                    basicDetails();
                  },
                  error = function () {
                  };
                ModalService.OtpModalSuccessModal({message: message}, success, error);
              };
              var confirmError = function () {
                vm.emailEdit = false;
              };
              ModalService.OtpModal({
                text: 'Email Address',
                mail: vm.formData.emailAddress,
                message: resp.data.message,
                email: vm.formData.emailAddressEdited,
                previousContact: vm.formData.contact,
                level: 'profileLevel'
              }, confirmSuccess, confirmError);

            } else {
              vm.emailEdit = false;
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text:resp.message
                })
              } else {
                MessageService.error(resp.message);
              }
            }
          },
          errorEmail = function () {
            LoaderService.hideLoader();
            vm.emailEdit = false;
            vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          };
        var payload = {
          "value": vm.formData.emailAddressEdited,
          "emailBelongsTo" : vm.emailBelongsToProfile
        };
        if(vm.formData.emailAddress) {
          payload.oldValue = vm.formData.emailAddress;
        }
        LoaderService.showLoader();
        investorServiceVersion.post({
          child1: 'profile',
          child2: 'edit',
          child3: 'email'
        }, payload).$promise.then(successEmail, errorEmail);
      } else {
        vm.formData.emailAddress = vm.formData.emailAddressEdited;
        vm.emailEdit = false;
        vm.saveEmailBtn = false;
      }
    }

    function saveNewFolioEmail() {
      if (vm.formData.folioEmailAddressEdited && vm.formData.folioEmailAddressEdited != vm.formData.folioEmailAddress) {
        vm.saveFolioEmailBtn = false;
        var successEmail = function (resp) {
            if (resp.data && resp.status) {
              var confirmSuccess = function (message) {
                var success = function () {
                    vm.folioEmailEdit = false;
                    vm.formData.folioEmailAddress = vm.formData.folioEmailAddressEdited;
                    vm.contactUpdateAllowed = true;
                    basicDetails();
                  },
                  error = function () {
                  };
                ModalService.OtpModalSuccessModal({message: message}, success, error);
              };
              var confirmError = function () {
                vm.folioEmailEdit = false;
              };
              ModalService.OtpModal({
                text: 'Folio Update Details',
                folioNo: vm.folioNo,
                mail: vm.formData.folioEmailAddress,
                message: resp.data.message,
                email: vm.formData.folioEmailAddressEdited,
                previousContact: vm.formData.folioMobileContact,
                level: 'folioLevel'
              }, confirmSuccess, confirmError);

            } else {
              vm.folioEmailEdit = false;
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text:resp.message
                })
              } else {
                MessageService.error(resp.message);
              }
            }

          },
          errorEmail = function () {
            vm.folioEmailEdit = false;
            vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          };
        var payload = {
          "changeFor": "Folio",
          "folioNumber": vm.folioNo,
          "panNumber": "",
          "value": vm.formData.folioEmailAddressEdited,
          "emailBelongsTo" : vm.emailBelongsTo
        };
        if(vm.formData.folioEmailAddress){
          payload.oldValue = vm.formData.folioEmailAddress;
        }
        investorServiceVersion.post({
            child1: 'profile',
            child2: 'folio',
            child3: 'edit',
            child4: 'email'
        }, payload).$promise.then(successEmail, errorEmail);
      } else {
        vm.formData.folioEmailAddress = vm.formData.folioEmailAddressEdited;
        vm.folioEmailEdit = false;
        vm.saveFolioEmailBtn = false;
        vm.emailBelongsTo = null;
      }
    }

    vm.showDetails = {};
    function getInfo(data) {
      var payload = {
        "folioNumber": vm.folioNo, /*'59727',*/
        "schemeCode": data.schemeCode /*'BFD'*/
      };
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp && resp.data) {
          vm.unclaimedDetailsModal(resp.data);
        } else {
          MessageService.error(resp.message);
        }

      }, error = function (resp) {
        MessageService.error(resp.message);
        LoaderService.hideLoader();
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'folio',
        child2: 'unclaimed',
        child3: 'info'
      }, payload).$promise.then(success, error);
    }

    vm.redirecToKycUpdate = function (folio) {
      var successHandler=function(resp) {
        LoaderService.hideLoader();
        $state.go('main.KycUpdate', {
          folioNumber: folio
        });
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);
    };

    vm.redirecToFatcaUpdate = function (folio) {
      var successHandler=function(resp) {
        LoaderService.hideLoader();
        $state.go('main.fatcaUpdate', {
          folioNumber: folio
        });
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);
    };

    vm.goToBack = function () {
      $state.go('main.profile.folioDetails');
    };

    vm.kyc_init = function () {
      var profileDetail = AuthService.getToken();
      vm.fullName = profileDetail && profileDetail.investorFullName;

      if (vm.folioNumberforKyc) {
        AppConstants.COOKIE_CONFIG.path = location.pathname;
        $cookies.put('kyc_folio', vm.folioNumberforKyc, AppConstants.COOKIE_CONFIG);
        vm.formData.folioNumber = vm.folioNumberforKyc;
      }
      var folioNumber = $cookies.get('kyc_folio');
      if (folioNumber) {
        vm.formData.folioNumber = folioNumber;
      }
      if (!vm.formData.folioNumber) {
        $state.go('main.profile.folioDetails');
      }

      getInvestorOccupationList();
      incomeSlab();
      getKycSupplementaryDetail();
      vm.formData.politicalStatus = vm.POLITICAL_STATUS.NONE;
    }

    function getInvestorOccupationList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.occupationList = resp.data.investorOccupations;
        } else {
          vm.occupationList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.occupationList = null;
      };
      InvestorService.get({child1: 'folio', child2: 'occupation'}).$promise.then(success, error);
    }

    function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.incomeSlabList = resp.data.incomeSlabList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
        };

      InvestorService.get({child1: 'folio', child2: 'income-slab'}).$promise.then(success, error);
    }

    function getKycSupplementaryDetail() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var kycdata = resp.data;
            vm.formData.grossAnnualIncome = (kycdata && kycdata.annualIncomeSlab) ? +kycdata.annualIncomeSlab : '';
            vm.formData.netWorth = (vm.formData.grossAnnualIncome) ? '' : (kycdata && kycdata.netWorth) ? +kycdata.netWorth : '';
            vm.formData.netWorthDate = (vm.formData.grossAnnualIncome) ? '' : (kycdata && kycdata.netWorthDate) ? $window.moment(kycdata.netWorthDate).format('DD-MMM-YYYY') : '';
            vm.formData.occupation = kycdata && kycdata.occupation;
            vm.formData.politicalStatus = kycdata && kycdata.politicalStatus;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'get',
        child3: 'fatca',
        child4: 'complete',
        child5: 'details'/*,
        child6: vm.formData.folioNumber //2207504*/
      }, {folioNo:vm.formData.folioNumber}).$promise.then(success, error);
    }

    vm.changeStartDate = function (date) {
      if (!date) {
        return;
      }
      vm.formData.netWorthDate = date.clone().format('DD-MMM-YYYY').toString();
    }

    vm.showKycTermConditions = function () {
      ModalService.nonTransactionalTncModal({type:'KYC'});
    };
    vm.showFatcaTermConditions = function () {
      ModalService.nonTransactionalTncModal({type:'FATCA'});
    };

    function saveKYCUpdate() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            MessageService.success(resp.data);
            $state.go('main.profile.folioDetails');

          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text:resp.message
              }, function () {
                $state.go('main.profile.folioDetails');
              } , function () {})
            } else {
              MessageService.error(resp.message);
            }
          }
        },
        error = function () {
          LoaderService.hideLoader();

          vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      var payload = {};
      payload.folioNumber = vm.formData.folioNumber;
      payload.annualIncomeSlab = vm.formData.grossAnnualIncome;
      payload.netWorth = vm.formData.netWorth;
      payload.netWorthDate = vm.formData.netWorthDate;
      payload.occupation = vm.formData.occupation;
      payload.politicalStatus = vm.formData.politicalStatus;
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'supplementaryKYC',
        child3: 'update'
      }, payload).$promise.then(success, error);
    }

    vm.fatca_init = function () {
      var profileDetail = AuthService.getToken();//$cookies.get('token_data');
      // profileDetail = angular.fromJson(profileDetail);
      vm.fullName = profileDetail && profileDetail.investorFullName;

      if (vm.folioNumberforKyc) {
        AppConstants.COOKIE_CONFIG.path = location.pathname;
        $cookies.put('fatca_folio', vm.folioNumberforKyc, AppConstants.COOKIE_CONFIG);
        vm.formData.folioNumber = vm.folioNumberforKyc;
      }
      var folioNumber = $cookies.get('fatca_folio');
      if (folioNumber) {
        vm.formData.folioNumber = folioNumber;
      }
      if (!vm.formData.folioNumber) {
        $state.go('main.profile.folioDetails');
      }

      vm.formData.payTaxInIndia = true;
      getCountryList();
      getAddressType();
      getFatcaDetail();
      getTaxIdTypeList();
    }

    function getFatcaDetail() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var fatcaData = resp.data;
            vm.formData.payOutsideIndiaAddresses = conversionFlatkeysToArray(fatcaData);
            vm.formData.fatcaAddressType = fatcaData && fatcaData.addressType;
            vm.formData.birthCity = fatcaData && fatcaData.placeOfBirth;
            vm.formData.birthCountry = fatcaData && fatcaData.countryOfBirth;
            vm.formData.fatherName = fatcaData && fatcaData.fatherName;
            vm.formData.spouseName = fatcaData && fatcaData.spouseName;
            vm.formData.payTaxInIndia = (fatcaData && fatcaData.taxOutsideIndia && fatcaData.taxOutsideIndia == "Y") ? false : true;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          //$log.info('Occupation Errror>>>>', err);
        };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'get',
        child3: 'fatca',
        child4: 'complete',
        child5: 'details'/*,
        child6: vm.formData.folioNumber //2207504*/
      }, {folioNo:vm.formData.folioNumber}).$promise.then(success, error);
    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = [];
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.countryList = [];
      };
      InvestorService.get({child1: 'folio', child2: 'country-list'}, null).$promise.then(success, error);
    }

    function getAddressType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.addressTypeList = resp.data.addressTypeResponses;
        } else {
          vm.addressTypeList = [];
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.addressTypeList = [];
      };
      InvestorService.post({child1: 'folio', child2: 'address-type'}, null).$promise.then(success, error);
    }

    function changePayTaxOutsideIndiaStatus(status) {
      if (!status) {
        return;
      }
    }

    vm.deleteTaxResidencyUpdate = function (index) {
      vm.formData.payOutsideIndiaAddresses.splice(index, 1);
    };

    function saveFatcaUpdate() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            MessageService.success(resp.data);
            $state.go('main.profile.folioDetails');

          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      var payload = {};
      payload.folioNumber = vm.formData.folioNumber;
      payload.addressType = vm.formData.fatcaAddressType;
      payload.placeOfBirth = vm.formData.birthCity;
      payload.countryOfBirth = vm.formData.birthCountry;
      payload.fatherName = vm.formData.fatherName;
      payload.spouseName = vm.formData.spouseName;
      payload.taxOutsideIndia = vm.formData.payTaxInIndia ? 'N' : 'Y';
      if (!vm.formData.payTaxInIndia) {
        var addresses = vm.formData.payOutsideIndiaAddresses;
        addresses && addresses.forEach(function (item, index) {
          if (index == 0) {
            payload.taxCountry = item.country;
            payload.taxIdentificationNumber = item.taxIdNumber;
            payload.taxIdentificationType = item.taxIdType;
          } else {
            var num = index + 1;
            payload['taxCountry' + num] = item.country;
            payload['taxIdentificationNumber' + num] = item.taxIdNumber;
            payload['taxIdentificationType' + num] = item.taxIdType;
          }
        });
      }
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'fatca',
        child3: 'update'
      }, payload).$promise.then(success, error);
    }

    function deleteFatcaTaxResidency(index) {
      var successModal = function () {
          vm.deleteTaxResidencyUpdate(index)
        },
        errorModal = function () {
          //MessageService.error(err)
        };
      ModalService.deleteTaxResidencyModal({}, successModal, errorModal)
    }

    function getTaxIdTypeList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdTypeList = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdTypeList = [];
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.taxIdTypeList = [];
      };
      InvestorService.post({child1: 'folio', child2: 'taxId-type'}, null).$promise.then(success, error);
    }

    function conversionFlatkeysToArray(data) {
      var finalResult = [];
      if (data) {
        if (data.taxCountry || data.taxIdentificationNumber || data.taxIdentificationType) {
          finalResult[0] = {};
          finalResult[0].country = data.taxCountry ? data.taxCountry : "";
          finalResult[0].taxIdNumber = data.taxIdentificationNumber ? data.taxIdentificationNumber : "";
          finalResult[0].taxIdType = data.taxIdentificationType ? data.taxIdentificationType : "";
        }
        if (data.taxCountry2 || data.taxIdentificationNumber2 || data.taxIdentificationType2) {
          finalResult[1] = {};
          finalResult[1].country = data.taxCountry2 ? data.taxCountry2 : "";
          finalResult[1].taxIdNumber = data.taxIdentificationNumber2 ? data.taxIdentificationNumber2 : "";
          finalResult[1].taxIdType = data.taxIdentificationType2 ? data.taxIdentificationType2 : "";
        }
        if (data.taxCountry3 || data.taxIdentificationNumber3 || data.taxIdentificationType3) {
          finalResult[2] = {};
          finalResult[2].country = data.taxCountry3 ? data.taxCountry3 : "";
          finalResult[2].taxIdNumber = data.taxIdentificationNumber3 ? data.taxIdentificationNumber3 : "";
          finalResult[2].taxIdType = data.taxIdentificationType3 ? data.taxIdentificationType3 : "";
        }
        if (data.taxCountry4 || data.taxIdentificationNumber4 || data.taxIdentificationType4) {
          finalResult[3] = {};
          finalResult[3].country = data.taxCountry4 ? data.taxCountry4 : "";
          finalResult[3].taxIdNumber = data.taxIdentificationNumber4 ? data.taxIdentificationNumber4 : "";
          finalResult[3].taxIdType = data.taxIdentificationType4 ? data.taxIdentificationType4 : "";
        }
      }
      return finalResult;
    }

    function fetchTaxIdTypeFromKey(key) {
      var finalkeytax = key;
      vm.taxIdTypeList && vm.taxIdTypeList.length && vm.taxIdTypeList.forEach(function (item) {
        if (item.value == key) {
          finalkeytax = item.description;
        }
      });
      return finalkeytax;
    }

    function fetchCountryNameFromCode(key) {
      var finalkey = key;
      vm.countryList && vm.countryList.length && vm.countryList.forEach(function (item) {
        if (item.countryCode == key) {
          finalkey = item.countryName;
        }
      });
      return finalkey;
    }

    function getFatcaDetailStatus() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.fatcaStatus = resp.data;
        } else {
          MessageService.error(resp.message);
        }
      }, error = function () {

      };
      InvestorService.post({
        child1: 'profile',
        child2: 'get',
        child3: 'fatca',
        child4: 'status'
      }, {folioNo:vm.selectedFolio}).$promise.then(success, error);
    }


    function getSupplementaryKycDetailStatus() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.kycStatus = resp.data && resp.data.supplementaryKycFlag;
          getFatcaDetailStatus();
        } else {
          MessageService.error(resp.message);
        }
      }, error = function () {

      };
      InvestorService.post({
        child1: 'profile',
        child2: 'get',
        child3: 'supplementaryKYC',
        child4: 'status'
      }, {folioNo:vm.selectedFolio}).$promise.then(success, error);
    }


    function deleteBank(){
      var successHandler=function(resp) {
        LoaderService.hideLoader();
        var banktoDelete = [vm.folioDetailsData.bankDetails[vm.currentBankIndx]];
        var modalPayload = {
          folioNumber: vm.folioNo,
          bankDetails: banktoDelete
        };
        var success = function () {
        }, error = function () {

        };
        ModalService.deleteBankModal({modalPayload: modalPayload, requestType: 'delete'}, success, error);
      };
      var errorHandler=function(resp) {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);

    }

    function deleteBankSuccess(modalPayload){
      ModalService.deleteBankSuccessModal({modalPayload : modalPayload, requestType:'delete'});
    }

    function changeDefaultBank(){
      var successHandler=function(resp) {
        LoaderService.hideLoader();
        var banktoMakeDefault = [vm.folioDetailsData.bankDetails[vm.currentBankIndx]];
        var modalPayload = {
          folioNumber: vm.folioNo,
          bankDetails: banktoMakeDefault
        };
        ModalService.changeDefaultBankModal({modalPayload: modalPayload, requestType: 'modify'});
      };
      var errorHandler=function(resp) {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);

    }

    function payoutSwitch() {
      var successHandler=function(resp) {
        LoaderService.hideLoader();
        vm.changePayoutSwitch = !vm.changePayoutSwitch;
      };
      var errorHandler=function(resp) {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);

    }

    function getPayoutMechanism() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payoutMechanismList = resp.data.payoutMechanisms;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'payout-mechanism', child3:'cobm'}).$promise.then(success, error);
    }

    function UpdatePayoutMethod() {
      payoutSwitch();
      updatePayOut();
    }

    function updatePayOut() {
      var payload = {
        bankAccountNumber: vm.bankDetails.accountNumber,
        folioNumber: vm.folioNo,
        payMech: vm.newPayoutMethod
      };
      var success = function (res) {
        if (res.status) {
          // ModalService.addBankModal(vm.payload);
          var modalSuccess = function(){
            //$state.go('main.profile.folioDetails');
            vm.folioDetails();
            vm.basicDetails();
          };
          ModalService.forgotPasswordModal({message:res.data.message},modalSuccess);
        }
        else {
          if(res.popupEnabled) {
            ModalService.genericModal({
              text:res.message
            })
          } else {
            MessageService.error(res.message);
          }
        }
      };
      var error = function (err) {
        UtilService.errorHandler(err);
      };

      InvestorService.post({
        child1: 'folio',
        child2: 'bank',
        child3: 'update',
        child4: 'pay-mech'
      }, payload).$promise.then(success, error);
    }

    function redirectIFSCUpdate() {
      var successHandler=function(resp) {
        LoaderService.hideLoader();
        localStorage.setItem('updateIFSC', $window.JSON.stringify(vm.bankDetails));
        localStorage.setItem('folioNo', vm.folioNo);
        localStorage.setItem('index', vm.currentFolioIndx);
        $state.go('main.updateIFSC', {folioNumber: vm.folioNo});
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);

    }

    function registerMandate() {
      var successHandler=function(resp) {
        LoaderService.hideLoader();
        if (vm.folioDetailsData.kycVerifiedFlag) {
          if (!vm.folioDetailsData.contactDetails.emailId && !vm.folioDetailsData.contactDetails.mobileNumber) {
            ModalService.genericModal({
              text: vm.validateData.MANDATE_REQUIRED
            });
          } else if (!vm.folioDetailsData.contactDetails.emailId) {
            ModalService.genericModal({
              text: vm.validateData.MANDATE_EMAIL_REQUIRED
            });
          } else if (!vm.folioDetailsData.contactDetails.mobileNumber) {
            ModalService.genericModal({
              text: vm.validateData.MANDATE_MOBILE_REQUIRED
            });
          } else {
            var payload = {
              folioNo: vm.folioNo,
              emailid: vm.folioDetailsData.contactDetails.emailId,
              mobileNo: vm.folioDetailsData.contactDetails.mobileNumber,
              investorName: vm.folioDetailsData.contactDetails.folioHolderName
            };
            sessionStorage.setItem("details", JSON.stringify(payload));
            $state.go('main.emandate');
          }
        } else {
          KycService.showKycMessage(vm.folioDetailsData.kycMessage);
        }
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);

    }

    function cancelMandate() {
       if(vm.dynamicDataStandalone.termAndConditionDTO.termAndConditionDTOMap.TNC_Standalone_Cancel && vm.cancelMandateUrl)
       {
          ModalService.cancelMandateModal({dynamicData:vm.dynamicDataStandalone.termAndConditionDTO.termAndConditionDTOMap.TNC_Standalone_Cancel,cancelMandateUrl: vm.cancelMandateUrl},function(){}, function(){})
       }
    }

    vm.redirectToUpdateNominee = function () {
      var successHandler=function(resp) {
        LoaderService.hideLoader();
        var payload = {
          folioDetailsData: vm.folioDetailsData,
          isNomineeData : vm.folioDetailsData.nominees && vm.folioDetailsData.nominees.length > 0 ? true : false
        };
        if(!vm.formData.folioEmailAddress && !vm.folioDetailsData.contactDetails.mobileNumber) {
          MessageService.error("Please update contact details in folio to proceed")
        } else {
          $window.sessionStorage.setItem('folioData', JSON.stringify(payload));
          $state.go('main.updateNominee', {
            folioNo: vm.selectedFolio
          });
        }
      }

      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);

    }

    vm.goToNomineeOptOut = function() {

      var successHandler = function() {
        $state.go('main.optoutNominee', {
          folioNo : vm.selectedFolio
        });
      }

      var errorHandler = function () {
        return;
      }

      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);
    }

    vm.cancelNominee = function() {
      var success = function(resp) {
        if (resp == "cancel") {
          cancelNominationSubmission();
        }
      };
      ModalService.cancelNominationModal({
        message: AppConstants.ToastrMessage.VALIDATE_DATA.CANCEL_NOMINATION
      }, success);
    };
    vm.offlineNomineeForm = function() {
      var successHandler=function(resp) {
        LoaderService.hideLoader();
        ModalService.offlineNomineeFormModal({
          message: AppConstants.ToastrMessage.VALIDATE_DATA.OFFLINE_NOMINEE_FORM
        });
      }
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.basic.basicInfo.panNumber,null).then(successHandler).catch(errorHandler);
    };

    function cancelNominationSubmission() {
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status) {
          $state.reload();
        } else {
          MessageService.error(response.message);
        }
      }, failure = function(response) {
        LoaderService.hideLoader();
        MessageService.error(response.message);
      };
      InvestorService.get({
        'child1': 'profile',
        'child2': 'cancel',
        'child3': 'nomination',
        'child4': vm.folioNo
      }).$promise.then(success, failure);
    }



    function fetchBelongsToDropdown() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.belongToListEmail = resp.data.emailList;
            vm.belongToListMobile = resp.data.mobileList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Belongs Dropdown error >>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
    }


    function updateMobileChange() {

      vm.isValid = vm.mobile_regex_digits.test(vm.formData.folioMobileEdited)


      if(vm.isValid && vm.formData.folioMobileEdited && vm.formData.folioMobileEdited.length == 13) {
         vm.isMobileNotValid = vm.mobile_regex_sameDigits.test(vm.formData.folioMobileEdited.substring(3))
      }

    }


    function toggleWhatsapp() {
      var success = function (resp) {
        if(vm.subscribedToggleFlagForWhatsapp) {
          LoaderService.hideLoader();
          MessageService.success(resp.data.message);
          vm.subscribedToggleFlagForWhatsapp=true;
        }else{
          LoaderService.hideLoader();
          MessageService.success(resp.data.message);
          vm.subscribedToggleFlagForWhatsapp=false;
        }
        }, error = function () {
        MessageService.error(resp.data.message);
        LoaderService.hideLoader();
        };
      if(vm.subscribedToggleFlagForWhatsapp==true){
        vm.subscribedWhatsapp = false;
      }else{
        vm.subscribedWhatsapp = true;
      }
      var payload = {
        "panNumber": vm.basic.basicInfo.panNumber,
        "whatsAppNotification": vm.subscribedWhatsapp
      }
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'whatsapp',
        child2: 'subscribe',
      }, payload).$promise.then(success, error);
    }

    vm.updateKYC = function(url){
      //'https://camskra.com/PanDetailsUpdate.aspx' //earlier url used
      /*window.open(url, "_blank");*/
      if (!vm.basic.basicInfo.dob || !vm.basic.basicInfo.panNumber) {
        return;
      }
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.ekycRequestCO = {
            url : resp.data.url,
            sess_id : resp.data.sess_id,
            ekyctype : resp.data.ekyctype,
            plkyc_type : resp.data.plkyc_type,
            kyc_data : resp.data.kyc_data,
            camsUrl: resp.data.camsUrl
          };
          if (resp.data.ekycStatus === AppConstants.KYC_STATUS.VERIFIED) { //02 and 07
            vm.actionUrl = $sce.trustAsResourceUrl(vm.ekycRequestCO.camsUrl);
            $timeout(function () {
              LoaderService.showLoader();
              angular.element('#ekycForm').submit();
              $timeout(function() {
                LoaderService.hideLoader();
              }, 10000);
            }, 100);
            vm.errorMessageVerify = '';
          } else if (resp.data.ekycStatus === AppConstants.NOT_VERIFIED || resp.data.ekycStatus === AppConstants.INCOMPLETE) { // 04 and 05
            sessionStorage.setItem("ekycRequestCO", JSON.stringify(vm.ekycRequestCO));
            $state.go('ekyc', {
              ekycRequestCO: vm.ekycRequestCO
            });
          } else {
            MessageService.error(resp.data.message ? resp.data.message : AppConstants.UPDATE_KYC_ERROR);
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(resp) {
        MessageService.error(resp.message);
        LoaderService.hideLoader();
      };
      var payload = {
        panNumber: AuthService.encryptRSA(angular.copy(vm.basic.basicInfo.panNumber)),
        encdob: AuthService.encryptRSA(angular.copy(vm.basic.basicInfo.dob))
      };
      InvestorService.post2({
        child1: 'ekyc',
        child2: 'updatekyc'
      }, payload).$promise.then(success, error);
    }

    function getPersonalIdentifier(cb) {
      cb = cb || function() {};
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.applicantPersonalIdentifiers = resp.data.identityProofs;
          if (vm.folioDetailsData.nominees && vm.folioDetailsData.nominees.length > 0) {
            vm.folioDetailsData.nominees.forEach(function(obj, index) {
              vm.applicantPersonalIdentifiers.forEach(function(identity) {
                if (obj.identityProofType === identity.identityProofType) {
                  obj.identityProofDescription = identity.identityProof;
                }
              });
            });
          }
          cb(true);
        } else {
          vm.applicantPersonalIdentifiers = [];
          MessageService.error(resp.message);
          cb(false);
        }
      }, error = function () {
        vm.applicantPersonalIdentifiers = [];
        cb(false);
      };
      InvestorService.get({
        child1: 'identity-proofs'
      }).$promise.then(success, error);
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('HolderApprovalForNomineeController', holderApprovalForNomineeController);

  /** @ngInject */
  function holderApprovalForNomineeController($stateParams, $state, $window, AppConstants, ModalService, MessageService,
                              InvestorService, UtilService, LoaderService, InvestorFolioModel,moment,InvestorServiceV2) {
    var vm = this;
    // var investorId = InvestorModel.getInvestorId();
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.confirmReject = confirmReject;
    vm.approveFolioSubmit = approveFolioSubmit;
    vm.minDate = moment().subtract(1, 'years').format("DD-MMM-YYYY").toString();
    vm.defaultDateNetWorthDate = $window.moment().toString();
    vm.init = init;
    vm.isLoaded = false;
    vm.activeTab = 0;
    vm.hideApproveReject = false;
    vm.nomineeEnum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      3: 'Fourth',
      4: 'Fifth',
      5: 'Sixth',
      6: 'Seventh',
      7: 'Eighth',
      8: 'Ninth',
      9: 'Tenth'
    };
    vm.isOptout = false;
    vm.folioNo = "23232443";
    vm.unitHolderName = "Preet";
    vm.Tnc = false;
    vm.setActiveTab = setActiveTab;
    vm.nomineeCountryList = null;
    vm.otpIdentifier = null;
    vm.fetchBelongsToDropdown = fetchBelongsToDropdown;
    vm.hideApproveReject = false;
    vm.approvalType = $stateParams.approvalType;
    vm.isSebiRegActive = $stateParams.sebi_reg;
    init();

    function init() {
      if($state.current.name == 'holderApprovalForNomineeAddUpdate' || ($stateParams.approvalType && $stateParams.approvalType == "NOMINEE_ADD_UPDATE")){
        vm.otpIdentifier = 'NOMINEE_UPDATE';
      }else if ($state.current.name == 'holderApprovalForNomineeOptOut' || ($stateParams.approvalType && $stateParams.approvalType == "NOMINEE_OPT_OUT")){
        vm.otpIdentifier = 'NOMINEE_OPT_OUT';
      }
      if($stateParams.type == undefined) {
        checkForModalAccess();
      } else {
        proceedToGetDetails();
      }
    }

    function checkForModalAccess() {
      var popUp = $window.open("http://www.google.com", "popup_tester", "width=1,height=1,left=0,top=0");
      if (popUp == null || typeof(popUp) == 'undefined') {
        vm.isActionPerformed = false;
        alert('Please disable your pop-up blocker then submit the form.');
        return;
      }
      else {
        popUp.close();
      }
      LoaderService.showLoader();
      if (!$stateParams.uuid) {
        UtilService.errorHandler('Not a valid link');
        return;
      } else {
        vm.uniqueLink = $stateParams.uuid;
      }
      proceedToGenerateOtp();
    }

    function proceedToGenerateOtp() {
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          initiateOTPModal();
        } else {
          MessageService.error(resp.message)
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };

      if (vm.isSebiRegActive) {
        InvestorServiceV2.post({
          child1: 'profile',
          child2: 'nominee',
          child3: 'sendOTP',
          child4: vm.otpIdentifier,
          child5: $stateParams.uuid
        },null).$promise.then(success, error);
      } else {
        InvestorService.post({
          child1: 'profile',
          child2: 'nominee',
          child3: 'sendOTP',
          child4: vm.otpIdentifier,
          child5: $stateParams.uuid
        },null).$promise.then(success, error);
      }

    }

    function initiateOTPModal() {
      var success = function(resp) {
        vm.isLoaded = true;
        if(resp && resp.linkId){
          vm.linkId = resp.linkId;
        }
        vm.summaryData = resp;
        vm.investorEmail = resp.inv_Email;
        vm.investorMobile = resp.inv_Mobile;
        vm.folioNo = resp.folioNumber ? resp.folioNumber : null;
        vm.optOutMsg = resp.message ? resp.message : null;
        vm.nomineePayload = resp.nomineeList ? resp.nomineeList : null;
        vm.isOptout = resp.summaryType !== 'NOMINEEADDUPDATE' ? true : false;
        proceedToGetDetails();
      }, failure = function(resp) {
        MessageService.error(resp.message);
      };
      ModalService.nomineeUpdateVerificationModal({
        summaryType: vm.otpIdentifier,
        uniqueLink: vm.uniqueLink,
        isSebiRegActive : vm.isSebiRegActive
      }, success, failure);
    }

    function proceedToGetDetails() {
      fetchBelongsToDropdown();
      getStateList();
      if($stateParams.type){
        getNomineeData();
      }
    }

    function confirmReject() {
      var success = function () {
        var successReason = function (respModal) {
          var successFolioReject = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.actionTaken = true;
              vm.hideApproveReject = true;
              var message = 'Your request for rejection has been submitted successfully.',
                hideOKButton = $state.current.name=='main.holderApprovalForNomination'?false:true,
                successReject = function () {
                  $state.current.name=='main.holderApprovalForNomination' && $state.go('main.profile.pendingApprovals')
                };
              var successHandler = function(resp) {

                if(resp.popupDTO.popupDTOMap.Popup_Home !== undefined)
                {
                  ModalService.successMessageModal({message: message, hideOKButton: hideOKButton}, successReject);
                }
              }

              UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
                MessageService.error(resp);
              });
              //ModalService.successMessageModal({message: message, hideOKButton: hideOKButton}, successReject);
              // MessageService.success('Your request for rejection has been submitted successfully.')
              //$state.go('approval.folio.rejected');
            } else {
              MessageService.error(resp.message);
            }
          }
          , errorFolioReject = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          var payload = {
            summaryType : vm.summaryData.summaryType ? vm.summaryData.summaryType : $stateParams.approvalType && $stateParams.approvalType == "NOMINEE_ADD_UPDATE" ? 'NOMINEEADDUPDATE' : 'NOMINEEOPTOUT',
            rejectionReason: respModal ? respModal : 'Rejected',
            approved: false,
            jH_mail: vm.investorEmail ? vm.investorEmail : null,
            jh_Mobile: vm.investorMobile ? vm.investorMobile : null,
            jH_mail_belongs_to: vm.emailBelongsTo ? vm.emailBelongsTo : null,
            jH_Mobile_belongs_to: vm.mobileBelongsTo ? vm.mobileBelongsTo : null,
            folioNo : vm.folioNo
          };
          LoaderService.showLoader();//folio/any-or-survivor/reject/holder

          if (vm.isSebiRegActive) {
            InvestorServiceV2.post({
              child1: 'transaction',
              child2: 'otp',
              child3: 'nominee',
              child4: 'action',
              child5: $stateParams.uuid
            }, payload).$promise.then(successFolioReject, errorFolioReject);
          } else {
            InvestorService.post({
              child1: 'transaction',
              child2: 'otp',
              child3: 'nominee',
              child4: 'action',
              child5: $stateParams.uuid
            }, payload).$promise.then(successFolioReject, errorFolioReject);
          }



        }, dismissReason = function () {
          //UtilService.errorHandler(err);

        };
        ModalService.rejectionReasonModal({type: 'NominationRejection'}, successReason, dismissReason);

      }, dismiss = function () {
        //UtilService.errorHandler(err);

      };
      var msg = "";
      if(vm.summaryData.summaryType == 'NOMINEEADDUPDATE' || $stateParams.approvalType == "NOMINEE_ADD_UPDATE"){
        msg = "Are you sure, you want to reject Nomination?"
      }else {
        msg = "Are you sure, you want to reject Opt-out of Nomination"
      }
      ModalService.confirmCancelModal({Text: msg}, success, dismiss);
    }

    vm.actionTaken = false;

    function approveFolioSubmit() {
      var success = function () {
        // sanitizingFormData();
        var successFolioApprove = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.actionTaken = true;
            vm.hideApproveReject = true;
            var updateNomineeError = resp.data.nomineeRegistrationFailureMessage;
            vm.hideApproveReject = true;
            var message = 'Your request for approval has been submitted successfully.',
              hideOKButton = $state.current.name=='main.holderApprovalForNomination'?false:true,
              successApprove = function () {
                $state.current.name=='main.holderApprovalForNomination' && $state.go('main.profile.pendingApprovals')
              };
            var successHandler = function(resp) {

              if(resp.popupDTO.popupDTOMap.Popup_Home !== undefined)
              {
                ModalService.successMessageModal({message: message, updateNomineeError: updateNomineeError, hideOKButton: hideOKButton}, successApprove);
              }
            }

            UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
              MessageService.error(resp);
            });
            //ModalService.successMessageModal({message: message, hideOKButton: hideOKButton}, successApprove);
          } else {
            MessageService.error(resp.message);
          }
        }, errorFolioApprove = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        //var tmp = formData.jointHolders[0];delete formData.jointHolders;
        // formData.jointHolders = [vm.holder];//folio/any-or-survivor/approve/holder/{linkId}
        var payload = {
          summaryType: vm.summaryData.summaryType ? vm.summaryData.summaryType : $stateParams.approvalType && $stateParams.approvalType == "NOMINEE_ADD_UPDATE" ? 'NOMINEEADDUPDATE' : 'NOMINEEOPTOUT',
          approved: true,
          jH_mail: vm.investorEmail,
          jh_Mobile: vm.investorMobile,
          jH_mail_belongs_to: vm.emailBelongsTo,
          jH_Mobile_belongs_to: vm.mobileBelongsTo,
          folioNo : vm.folioNo
        };

        if (vm.isSebiRegActive) {
          InvestorServiceV2.post({
            child1: 'transaction',
            child2: 'otp',
            child3: 'nominee',
            child4: 'action',
            child5: $stateParams.uuid
          }, payload).$promise.then(successFolioApprove, errorFolioApprove);
        } else {
          InvestorService.post({
            child1: 'transaction',
            child2: 'otp',
            child3: 'nominee',
            child4: 'action',
            child5: $stateParams.uuid
          }, payload).$promise.then(successFolioApprove, errorFolioApprove);
        }

      }, dismiss = function () {};
      var msg = "Are you sure, you want to approve your details?";
      ModalService.confirmCancelModal({Text: msg}, success, dismiss);
    }

    function setActiveTab(index){
      vm.activeTab = index;
      // if(typeof vm.nomineePayload[vm.activeTab].panNumber !== 'undefined' && vm.nomineePayload[vm.activeTab].panNumber != "" && vm.nomineePayload[vm.activeTab].panNumber != null) {
      //   vm.nomineePanChanged(index,vm.nomineePayload.nominees[vm.activeTab].panNumber);
      // }
      //
      // if(typeof vm.nomineePayload[vm.activeTab].guardianPanNumber!== 'undefined' && vm.nomineePayload[vm.activeTab].guardianPanNumber != "" && vm.nomineePayload[vm.activeTab].guardianPanNumber != null) {
      //   vm.minorPanChanged(index,vm.nomineePayload.nominees[vm.activeTab].guardianPanNumber , true)
      // }
    }

    function fetchBelongsToDropdown(){
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.belongToListEmail = resp.data.emailList;
            vm.belongToListMobile = resp.data.mobileList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          // $log.info('Belongs Dropdown error >>>>', err);
        };

      InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
    }

    function getStateList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.stateList = resp.data.states;
          if(vm.nomineePayload){
            for(var i = 0; i < vm.nomineePayload.length; i++){
              vm.stateList.forEach(function (data) {
                if(data.stateCode == vm.nomineePayload[i].stateCode){
                  vm.stateData = data;
                }
              });
              vm.nomineePayload[i].state = vm.stateData.stateName;
            }
          }
        } else {
          vm.stateList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.stateList = null;
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'state',
        child3: 'list'
      }).$promise.then(success, error);
    }

    function getNomineeData() {
      LoaderService.showLoader();
      var success = function (resp) {
        vm.isLoaded = true;
        LoaderService.hideLoader();
        if(resp.status && resp.data){
          vm.summaryData = resp.data;
          vm.investorEmail = resp.data.inv_Email;
          vm.investorMobile = resp.data.inv_Mobile;
          vm.folioNo = resp.data.folioNumber ? resp.data.folioNumber : null;
          vm.optOutMsg = resp.data.message ? resp.data.message : null;
          vm.nomineePayload = resp.data.nomineeList ? resp.data.nomineeList : null;
          vm.isOptout = $stateParams.approvalType !== "NOMINEE_ADD_UPDATE" ? true : false;
          if (vm.isSebiRegActive) {
            getPersonalIdentifier();
          }
        }else {
          vm.summaryData = null;
          vm.nomineePayload = null;
          if(resp.message) MessageService.error(resp.message);
        }
      },error = function (err) {
        vm.summaryData = null;
        vm.nomineePayload = null;
        LoaderService.hideLoader();
        MessageService.error(err.message);
      };
      InvestorServiceV2.get({
        child1 : 'getNomineeDetails',
        child2 : 'pendingApproval',
        child3 : $stateParams.uuid
      },null).$promise.then(success, error);
    }

    function getPersonalIdentifier(cb) {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.applicantPersonalIdentifiers = resp.data.identityProofs;
          vm.nomineePayload.forEach(function(obj, index) {
            vm.applicantPersonalIdentifiers.forEach(function(identity) {
              if (obj.identityProofType === identity.identityProofType) {
                obj.identityProofDescription = identity.identityProof;
              }
            });
          });
        } else {
          vm.applicantPersonalIdentifiers = [];
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.applicantPersonalIdentifiers = [];
      };
      InvestorService.get({
        child1: 'identity-proofs'
      }).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('HolderApprovalController', holderApprovalCtrl);

  /** @ngInject */
  function holderApprovalCtrl($stateParams, $state, $window, AppConstants, ModalService, MessageService,
                              InvestorService, UtilService, LoaderService, InvestorFolioModel,moment, AuthService, TransactionService, dynamicData) {
    var vm = this;
    // var investorId = InvestorModel.getInvestorId();
    var formData = {};
    vm.CONST = AppConstants;
    vm.confirmCancelModaltoReject = confirmCancelModaltoReject;
    vm.changeStartDateJointHolder = changeStartDateJointHolder;
    vm.fileTaxActionJointHolder = fileTaxActionJointHolder;
    vm.addMoreTaxResidencyJointHolder = addMoreTaxResidencyJointHolder;
    vm.deleteTaxResidencyJointHolder = deleteTaxResidencyJointHolder;
    vm.approveFolioSubmit = approveFolioSubmit;
    vm.minDate = moment().subtract(1, 'years').format("DD-MMM-YYYY").toString();
    vm.defaultDateNetWorthDate = $window.moment().toString();
    vm.init = init;
    vm.fetchBelongsToDropdown=fetchBelongsToDropdown;
    vm.isLoaded = false;
    vm.dynamicNote = dynamicData.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT;
    vm.hideApproveReject = false;
    init();

    function init() {
      if($stateParams.type == undefined) {
        checkForModalAccess();
      } else {
        proceedToGetDetails();
      }
    }

    function checkForModalAccess() {
      var popUp = $window.open("http://www.google.com", "popup_tester", "width=1,height=1,left=0,top=0");
      if (popUp == null || typeof(popUp) == 'undefined') {
        vm.isActionPerformed = false;
        alert('Please disable your pop-up blocker then submit the form.');
        return;
      }
      else {
        popUp.close();
      }
      LoaderService.showLoader();
      if (!$stateParams.uuid) {
        UtilService.errorHandler('Not a valid link');
        return;
      } else {
        vm.uniqueLink = $stateParams.uuid;
      }
      proceedToGenerateOtp();
    }

    function proceedToGenerateOtp() {
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          initiateOTPModal();
        } else {
          MessageService.error(resp.message)
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      TransactionService.get2({
        controller1: 'transaction',
        controller2: 'otp',
        controller3: vm.uniqueLink,
        controller4: true // passing true for folio creation otherwise value will be null for other transactions
      }, null).$promise.then(success, error);
    }

    function initiateOTPModal() {
      var success = function(data) {
        vm.isLoaded = true;
        InvestorFolioModel.setInvestorFolioModel(data);
        if(data && data.linkId){
          vm.linkId = data.linkId;
        }
        proceedToGetDetails();
      }, failure = function(resp) {
        MessageService.error(resp.message);
      };
      ModalService.nomineeUpdateVerificationModal({
        summaryType: 'folio-creation',
        uniqueLink: vm.uniqueLink
      }, success, failure);
    }

    function proceedToGetDetails() {
      getFolioInfo();
      lookupList();
      getCountryList();
      // getCityList();
      taxStatusLookup();
      getTaxIdType();
      fetchBelongsToDropdown();
    }

    function lookupList() {
      occupationLookup();
      incomeSlab();
      addressTypeLookup();
      AuthService.isLoggedIn().then(function (resp) {
        vm.isLoggedInStatus = resp.isLoggedIn;
      }, function () {
      });
    }

    function getFolioInfo() {

      /* LoaderService.showLoader();
       var success = function (resp) {*/
      formData = InvestorFolioModel.getInvestorFolioFormDataModel();//angular.copy(InvestorModel.getInvestorModel());
      if (formData) {
        vm.folioDetails = angular.copy(formData);
        var holder = formData.jointHolders ? formData.jointHolders.filter(function (ele) {
          return ele && angular.isDefined(ele.email);
        }) : [];
        vm.holder = holder.length > 0 ? holder[0] : [];
        vm.holder.netWorth && $window.NumToWord(vm.holder.netWorth, 'divDisplayWords', vm);
        if (vm.holder) {
          vm.holder.fatcaDetail.payTaxInIndia = (vm.holder.fatcaDetail) && (angular.isUndefined(vm.holder.fatcaDetail.payTaxInIndia)) ?
            true : vm.holder.fatcaDetail.payTaxInIndia;
          if(!vm.holder.fatcaDetail.payTaxInIndia){
            if(vm.holder.fatcaDetail && !isEmpty(vm.holder.fatcaDetail.fatcaTax2)){
              vm.holder.fatcaDetail.secondTax = isEmpty(vm.holder.fatcaDetail.fatcaTax2) ? false : true;
            }
            if(vm.holder.fatcaDetail && !isEmpty(vm.holder.fatcaDetail.fatcaTax3)){
              vm.holder.fatcaDetail.thirdTax = isEmpty(vm.holder.fatcaDetail.fatcaTax3) ? false : true;
            }
          }
        }
        vm.nominees = formData && formData.nominees;
        vm.defaultDateNetWorthDate = vm.holder.netWorthDate || vm.defaultDateNetWorthDate;
        vm.nriFlag = angular.copy(vm.holder.nriFlag);
        if (vm.folioDetails.sebiNomineeRegulatory01650Active) {
          getPersonalIdentifier();
        }
      }
      else {
        MessageService.error('Invalid request');
      }
    }

    function isEmpty(obj) {
      for(var key in obj) {
        if(obj.hasOwnProperty(key))
          return false;
      }
      return true;
    }

    function changeStartDateJointHolder(date) {

      if (date && date._i) {
        vm.holder.netWorthDate = date && date._i ? date._i : '';
        vm.defaultDateNetWorthDate = date.toString();
      }
    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
        UtilService.errorHandler(err);
      };
      var payload = {
        id: $stateParams.uuid
      };

      InvestorService.post({
        child1: 'folio',
        child2: 'any-or-survivor',
        child3: 'country-list'
      }, payload).$promise.then(success, error);
    }

    /*function getCityList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.cityList = resp.data.cities;
        } else {
          vm.cityList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.cityList = null;
        UtilService.errorHandler(err);
      };
      var payload = {
        id: $stateParams.uuid
      };
      InvestorService.post({
        child1: 'city',
        child2: 'list',
        child3: 'holder'
      }, payload).$promise.then(success, error);
    }*/

    function taxStatusLookup() {
      var successTaxStatus = function (resp) {
          if (resp.status && resp.data) {
            vm.taxStatusList = resp.data.taxStatus;
          } else {
            MessageService.error(resp.message);
          }
        },
        errorTaxStatus = function (err) {
          UtilService.errorHandler(err);
        };
      var payloadTaxStatus = {
        taxStatusFilter: 'ADULT',
        id: $stateParams.uuid,
        nriFlag : vm.nriFlag
      };
      InvestorService.post({
        child1: 'folio',
        child2: 'any-or-survivor',
        child3: 'tax-status'
      }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);

    }

    function occupationLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.occupationList = resp.data.investorOccupations;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: $stateParams.uuid
      }

      InvestorService.post({
        child1: 'folio',
        child2: 'any-or-survivor',
        child3: 'occupation'
      }, payload).$promise.then(success, error);
    }

    function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.incomeSlabList = resp.data.incomeSlabList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: $stateParams.uuid
      };

      InvestorService.post({
        child1: 'folio',
        child2: 'any-or-survivor',
        child3: 'income-slab'
      }, payload).$promise.then(success, error);
    }

    function addressTypeLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.addressTypeList = resp.data.addressTypeResponses;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: $stateParams.uuid
      };

      InvestorService.post({
        child1: 'folio',
        child2: 'any-or-survivor',
        child3: 'address-type'
      }, payload).$promise.then(success, error);
    }

    function confirmCancelModaltoReject() {
      var success = function () {
        var successReason = function (respModal) {
          var successFolioReject = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.actionTaken = true;
              vm.hideApproveReject = true;
              var message = 'Your request for rejection has been submitted successfully.',
                hideOKButton = $state.current.name=='main.investorApproval'?false:true,
                successReject = function () {
                  $state.current.name=='main.investorApproval' && $state.go('main.profile.pendingApprovals')
                };
              var successHandler = function(resp) {

                if(resp.popupDTO.popupDTOMap.Popup_Home !== undefined)
                {
                  ModalService.successMessageModal({message: message, hideOKButton: hideOKButton}, successReject);
                }
              }

              UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
                MessageService.error(resp);
              });
              //ModalService.successMessageModal({message: message, hideOKButton: hideOKButton}, successReject);
              // MessageService.success('Your request for rejection has been submitted successfully.')
              //$state.go('approval.folio.rejected');
            } else {
              MessageService.error(resp.message);
            }
          }, errorFolioReject = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          var payload = {
            id: formData.id,
            reason: respModal.reason ? respModal.reason : 'Rejected',
            linkId: $stateParams.uuid
          };
          if($stateParams.type == undefined){
            payload.uniqueLink = $stateParams.uuid;
            payload.linkId = vm.linkId;
          }
          LoaderService.showLoader();//folio/any-or-survivor/reject/holder
          InvestorService.post({
            child1: 'folio',
            child2: 'any-or-survivor',
            child3: 'reject',
            child4: 'holder'
          }, payload).$promise.then(successFolioReject, errorFolioReject);


        }, dismissReason = function () {
          //UtilService.errorHandler(err);

        };
        ModalService.rejectionReasonModal({type: 'folioRejection'}, successReason, dismissReason);

      }, dismiss = function () {
        //UtilService.errorHandler(err);

      };
      var msg = "Are you sure, you want to reject Folio Creation?";
      ModalService.confirmCancelModal({Text: msg}, success, dismiss);
    }

    function sanitizingFormData() {
      // formData.id = InvestorModel.getInvestorId();
      formData.changed = false;
      if($stateParams.type==undefined){
        formData.linkId = vm.linkId?vm.linkId:"";
      } else {
        formData.linkId = $stateParams.uuid;
      }

      // angular.forEach(vm.formData.jointHolders, function (holder) {
        if(vm.holder.fatcaDetail.fatcaTax1 && vm.holder.fatcaDetail.fatcaTax1.taxPayingCountry===''){
          delete vm.holder.fatcaDetail.fatcaTax1;
        }if(vm.holder.fatcaDetail.fatcaTax2 && vm.holder.fatcaDetail.fatcaTax2.taxPayingCountry===''){
          delete vm.holder.fatcaDetail.fatcaTax2;
        }if(vm.holder.fatcaDetail.fatcaTax3 && vm.holder.fatcaDetail.fatcaTax3.taxPayingCountry===''){
          delete vm.holder.fatcaDetail.fatcaTax3;
        }
      // });

    }

    vm.actionTaken = false;

    function approveFolioSubmit() {
      var success = function () {
        sanitizingFormData();
        var successFolioApprove = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.actionTaken = true;
            var updateNomineeError = resp.data.nomineeRegistrationFailureMessage;
            vm.hideApproveReject = true;
            var message = 'Your request for approval has been submitted successfully.',
              hideOKButton = $state.current.name=='main.investorApproval'?false:true,
              successApprove = function () {
                $state.current.name=='main.investorApproval' && $state.go('main.profile.pendingApprovals')
              };
            var successHandler = function(resp) {

              if(resp.popupDTO.popupDTOMap.Popup_Home !== undefined)
              {
                ModalService.successMessageModal({message: message, updateNomineeError: updateNomineeError, hideOKButton: hideOKButton}, successApprove);
              }
            }

            UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
              MessageService.error(resp);
            });
            //ModalService.successMessageModal({message: message, hideOKButton: hideOKButton}, successApprove);
          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message,
                isAadhar: true
              },function () {
                $state.go('main.profile.pendingApprovals');
              } , function () {});
            } else {
              MessageService.error(resp.message);
            }
          }
        }, errorFolioApprove = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        //var tmp = formData.jointHolders[0];delete formData.jointHolders;
        formData.jointHolders = [vm.holder];//folio/any-or-survivor/approve/holder/{linkId}
        if($stateParams.type == undefined){
          formData.linkId = vm.linkId?vm.linkId:"";
          formData.uniqueLink= $stateParams.uuid;
        }
        InvestorService.post({
          child1: 'folio',
          child2: 'any-or-survivor',
          child3: 'approve',
          child4: 'holder',
          child5: $stateParams.type==undefined?vm.linkId:$stateParams.uuid
        }, formData).$promise.then(successFolioApprove, errorFolioApprove);

      }, dismiss = function () {};
      var msg = "Are you sure, you want to approve your details?";
      ModalService.confirmCancelModal({Text: msg}, success, dismiss);
    }

    function getTaxIdType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.taxIdTypeList = resp.data.taxIdTypeResponses;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorService.post({
        child1: 'folio',
        child2: 'any-or-survivor',
        child3: 'taxId-type'
      }, {"id": $stateParams.uuid}).$promise.then(success, error);
    }

    vm.deleteSecond = function(detail) {
      if(detail.fatcaTax3){
        detail.fatcaTax2 = detail.fatcaTax3;
        delete detail.fatcaTax3;
        detail.thirdTax = false;
      } else {
        delete detail.fatcaTax2;
        detail.secondTax = false;
      }
      vm.holder.fatcaDetail = angular.copy(detail);
    }

    vm.deleteThird = function(detail) {
      detail.fatcaTax2 = detail.fatcaTax2;
      delete detail.fatcaTax3;
      detail.thirdTax = false;
      vm.holder.fatcaDetail = angular.copy(detail);
    }


    function fileTaxActionJointHolder() {
      if (!vm.holder.payTaxInIndia) {
        vm.holder.payOutsideIndiaAddresses = [{}];
      } else {
        var array = vm.holder.payOutsideIndiaAddresses || [];
        vm.holder.payOutsideIndiaAddresses.splice(0, array.length);
      }

    }

    function addMoreTaxResidencyJointHolder() {
      var array = vm.holder.payOutsideIndiaAddresses || [];
      array.length < 3 ? array.push({}) : '';
    }
    function fetchBelongsToDropdown(cb) {
      cb = cb ||function () {

      };
      LoaderService.showLoader();
      var success = function (resp) {
          if (resp.status && resp.data) {
            var tempData = JSON.parse(sessionStorage.getItem("verifyObj"));
            vm.holders  = {};
            vm.belongToListEmail = resp.data.emailList;
            vm.belongToListMobile = resp.data.mobileList;
            LoaderService.hideLoader();
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
          cb();
        },
        error = function (err) {
          $log.info('Belongs Dropdown error >>>>', err);
          LoaderService.hideLoader();
          cb();
        };

      InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
    }


    function deleteTaxResidencyJointHolder(index) {
      var array = vm.holder.payOutsideIndiaAddresses || [];
      array.splice(index, 1);
    }

    function getPersonalIdentifier(cb) {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.applicantPersonalIdentifiers = resp.data.identityProofs;
          vm.nominees.forEach(function(obj, index) {
            vm.applicantPersonalIdentifiers.forEach(function(identity) {
              if (obj.identityProofType === identity.identityProofType) {
                obj.identityProofDescription = identity.identityProof;
              }
            });
          });
        } else {
          vm.applicantPersonalIdentifiers = [];
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.applicantPersonalIdentifiers = [];
      };
      InvestorService.get({
        child1: 'identity-proofs'
      }).$promise.then(success, error);
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('MainFolioController', mainFolioController);

  /** @ngInject */
  function mainFolioController(AppConstants, $state) {
    var vm = this;
    vm.CONST = AppConstants;
    vm.isSoleApplicantMinor = false;
    vm.$state = $state;

  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('InvestorFolioModel', investorFolioModel);

  /** @ngInject */
  function investorFolioModel() {

    var masterPayload = {
        "soleApplicantDetail": {
          "minorDetail": {
            "minorAgeProof": null,
            "minorRelationshipProof": null,
            "guardian": {
              "panNumber": null,
              "occupation": null,
              "taxStatusCode": null,
              "grossAnnualIncome": null,
              "politicalStatus": null,
              "netWorth": null,
              "netWorthDate": null,
              "kycVerified": null,
              "name": null,
              "gender": null,
              "panValid": null,
              "relation": null,
              "fatca": {
                "birthCountry": null,
                "birthPlace": null,
                "countryCitizenship": null,
                "payTaxInIndia": false,
                "addressType": null,
                "fatcaTax1": {
                  "taxPayingCountry": null,
                  "taxPayingCity": null,
                  "taxIdNumber": null,
                  "taxId": null,
                  "taxIdType": null
                },
                "fatcaTax2": {
                  "taxPayingCountry": null,
                  "taxPayingCity": null,
                  "taxIdNumber": null,
                  "taxId": null,
                  "taxIdType": null
                },
                "fatcaTax3": {
                  "taxPayingCountry": null,
                  "taxPayingCity": null,
                  "taxIdNumber": null,
                  "taxId": null,
                  "taxIdType": null
                }
              },
              "guardianRelationshipProofUrl": null
            }
          },
          "selfDetail": {
            "panNumber": null,
            "occupation": null,
            "taxStatusCode": null,
            "grossAnnualIncome": null,
            "politicalStatus": null,
            "netWorth": null,
            "netWorthDate": null,
            "kycVerified": null,
            "address": {
              "addressLine1": null,
              "addressLine2": null,
              "addressLine3": null,
              "pinCode": null,
              "city": null,
              "state": null,
              "country": null
            },
            "fatca": {
              "birthCountry": null,
              "birthPlace": null,
              "countryCitizenship": null,
              "payTaxInIndia": false,
              "addressType": null,
              "fatcaTax1": {
                "taxPayingCountry": null,
                "taxPayingCity": null,
                "taxIdNumber": null,
                "taxId": null,
                "taxIdType": null
              },
              "fatcaTax2": {
                "taxPayingCountry": null,
                "taxPayingCity": null,
                "taxIdNumber": null,
                "taxId": null,
                "taxIdType": null
              },
              "fatcaTax3": {
                "taxPayingCountry": null,
                "taxPayingCity": null,
                "taxIdNumber": null,
                "taxId": null,
                "taxIdType": null
              }
            }
          },
          "personalDetail": {
            "dateOfBirth": null,
            "firstName": null,
            "gender": null,
            "taxStatusCode": null
          }
        },
       /* "nominees": [],*/
        "nominees": [
          {
            "title": null,
            "nomineeName": null,
            "nomineeRelation": null,
            "percentage": null,
            "dob": null,
            "nomineeAddress": {
              "addressLine1": null,
              "addressLine2": null,
              "addressLine3": null,
              "pinCode": null,
              "city": null,
              "state": null,
              "country": null
            },
            "guardianAddress": {
              "addressLine1": null,
              "addressLine2": null,
              "addressLine3": null,
              "pinCode": null,
              "city": null,
              "state": null,
              "country": null
            },
            "minor": null,
            "guardianName": null,
            "soleAddressApplicable": null
          }
        ],
        "holdmode": ""
      },
      /*guardianDetailsPayload = {
        "basicDetails": {
          "birthCity": "",
          "birthCountry": "",
          "dob": "",
          "fatcaAddressType": "",
          "grossAnnualIncome": "",
          "netWorth": "",
          "netWorthDate": "",
          "occupation": "",
          "panNumber": "",
          "payOutsideIndiaAddresses": [],
          "payTaxInIndia": false,
          "politicalStatus": "NONE",
          "taxStatusCode": ""
        },
        "citizenship": "",
        "kycStatus": true,
        "relationship": ""
      },*/
      jointHolderMasterPayload = {
          "email": "",
          "fatcaDetail":{
            "birthPlace": "",
            "birthCountry": "",
            "payTaxInIndia": true,
            "addressType": "",
            "countryCitizenship": "",
            "fatcaTax1" :{"taxPayingCountry":"","taxId":"", "taxIdType":""},
            "fatcaTax2" :{"taxPayingCountry":"","taxId":"", "taxIdType":""},
            "fatcaTax3" :{"taxPayingCountry":"","taxId":"", "taxIdType":""}
           },
          "grossAnnualIncome": "",
          "netWorth": "",
          "netWorthDate": "",
          "occupationCode": "",
          "pan": "",
          "politicalStatus": "NONE",
          "taxStatusCode": "",
        "jointHolderName": "",
        "kycverified": false,
        "mobileNumber":""
      },
      nomineeMasterPayload = {
        "nomineeName": "B",
        "nomineeRelation": "M",
        "percentage": 50,
        "dob": "26-Jan-1977",
        "nomineeAddress": {
          "addressLine1": "A11",
          "addressLine2": "A21",
          "addressLine3": "A31",
          "pinCode": "1234516",
          "city": "DL",
          "state": "DL",
          "country": "IN"
        }
      },
      payOutsideMasterPayload = {
        "countryName": "",
        "taxIdNumber": "",
        "taxIdType": ""
      },
      bankDetailsMasterPayload = {
        "bankDetails": {
          "accountNumber": "",
          "accountType": "",
          "bankBranch": "",
          "bankCity": "",
          "bankName": "",
          "bankRGTSCode": "",
          "ifsccode": "",
          "micrnumber": "",
          "payoutMechanism": "",
          "emailId":"",
          "mobileNumber":"",
          "name":"",
          "payoutId":""
        }
      }, newInvestor = null,

      formData = {
        "soleApplicantDetail": {
          "minorDetail": {
            "minorAgeProof": null,
            "minorRelationshipProof": null,
            "guardian": {
              "panNumber": "",
              "occupation": null,
              "grossAnnualIncome": null,
              // "politicalStatus": null,
              "netWorth": null,
              "netWorthDate": null,
              "kycVerified": null,
              "panValid": null,
              "relation": null,
              "fatca": {},
              "guardianRelationshipProofUrl": null
            }
          },
          "selfDetail": {
            "panNumber": "",
            "occupation": "",
            "grossAnnualIncome": null,
            // "politicalStatus": "",
            "fatca": {
              "payTaxInIndia": true
            }
          },
          "personalDetail": {
            "nameTitle": null,
            "firstName": null,
            "middleName": null,
            "lastName": null,
            "taxStatusCode": "",
            "dateOfBirth": null,
            "gender": null,
            "email": null
          }
        },
        "jointHolders": [],
        "nominees": [],
        "bankDetails": {},
        "holdmode": "SINGLE",
        "sourcePlatform": null,
        "sourcePortal": null,
        "folioSaveStep": null,
        "minor": false,
        "firstFolio": false
      },
      fromDistributor = {panVerifyScreen: false};

    function getNewJointHolder() {
      return angular.copy(jointHolderMasterPayload);
    }

    function getNewNominee() {
      return angular.copy(nomineeMasterPayload);
    }

    function getNewGuardianDetails() {
      return angular.copy();
    }

    function getNewPayOutsideModel() {
      return angular.copy(payOutsideMasterPayload);
    }

    function getNewInvestorFolioModel() {
      return angular.copy(masterPayload);
    }

    function getBankDetailsModel() {
      return angular.copy(bankDetailsMasterPayload);
    }

    function getInvestorFolioModel() {
      return angular.copy(newInvestor);
    }

    function getNewInvestorFolioFormDataModel() {
      return angular.copy(formData);
    }

    function getInvestorFolioFormDataModel() {
      return angular.copy(newInvestor);
    }

    function setInvestorFolioModel(_newInvestor) {
      newInvestor = _newInvestor;
    }

    function resetInvestorFolioModel() {
      newInvestor = null;
    }

    function getFromDistributorModel() {
      return angular.copy(fromDistributor);
    }
    function setFromDistributorModel(_fromDistributor) {
      fromDistributor.panVerifyScreen = _fromDistributor.panVerifyScreen;
    }

    function resetFromDistributorModel() {
      fromDistributor.panVerifyScreen = false;
    }

    function getUpdatedNomineeObject() {
      return {
        "firstName": "",
        "nomineeRelation": "",
        "percentage": "",
        "dob": "",
        "panNumber" : null,
        "minor":false,
        "nomineeAddress": {
          "addressLine1": "",
          "addressLine2": "",
          "addressLine3": "",
          "pinCode": "",
          "city": "",
          "state": "",
          "country": ""
        },
        "guardianName": null,
        "guardianAddress": {
          "addressLine1": "",
          "addressLine2": "",
          "addressLine3": "",
          "pinCode": "",
          "city": "",
          "state": "",
          "country": ""
        },
        "guardianPanNumber" : null,
        "guardianRelationWithNominee": null
      };
    }

    function getNomineeObject() {
      return {
        "nomineeName": "",
        "nomineeRelation": "",
        "percentage": "",
        "dob": "",
        "panNumber" : null,
        "minor":false,
        "nomineeAddress": {
          "addressLine1": "",
          "addressLine2": "",
          "addressLine3": "",
          "pinCode": "",
          "city": "",
          "state": "",
          "country": ""
        },
        "guardianName": null,
        "guardianAddress": {
          "addressLine1": "",
          "addressLine2": "",
          "addressLine3": "",
          "pinCode": "",
          "city": "",
          "state": "",
          "country": ""
        },
        "guardianPanNumber" : null,
        "guardianRelationWithNominee": null
      };
    }

    return {
      getNewInvestorFolioModel: getNewInvestorFolioModel,
      getNewJointHolder: getNewJointHolder,
      getNewNominee: getNewNominee,
      getNewGuardianDetails: getNewGuardianDetails,
      getNewPayOutsideModel: getNewPayOutsideModel,
      getInvestorFolioModel: getInvestorFolioModel,
      setInvestorFolioModel: setInvestorFolioModel,
      resetInvestorFolioModel: resetInvestorFolioModel,
      getBankDetailsModel: getBankDetailsModel,
      getNewInvestorFolioFormDataModel: getNewInvestorFolioFormDataModel,
      getInvestorFolioFormDataModel: getInvestorFolioFormDataModel,
      getFromDistributorModel: getFromDistributorModel,
      setFromDistributorModel: setFromDistributorModel,
      resetFromDistributorModel: resetFromDistributorModel,
      getUpdatedNomineeObject: getUpdatedNomineeObject,
      getNomineeObject: getNomineeObject
    };
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('investorFolioTab', investorFolioTab);

  /** @ngInject */
  function investorFolioTab(){
    return {
      template : '<ul class="mobile-hide nav nav-tabs"> ' +
      '<li ui-sref-active="active"><a ui-sref="main.folio.soleApplicant">Sole Applicant Details</a></li>' +
      '<li ui-sref-active="active">' +
      '<a ui-sref="main.investors.add.nominee" style="display:none;"></a>' +
      '<a ui-sref="main.investors.add.nominee" >Nominee Details</a>' +
      '</li>' +
      '<li ui-sref-active="active">' +
      '<a ui-sref="main.investors.add.jointholders" style="display:none;"></a>' +
      '<a  ui-sref="main.investors.add.jointholders"><i class="expand-icon"></i>Add Joint Holder</a>' +
      '</li>' +
      '</ul>'
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .config(addInverstorRoute);

  /** @ngInject */
  function addInverstorRoute($stateProvider) {
    $stateProvider
      .state('main.folio', {
        url: '/folio',
        templateUrl: 'app/investor/addFolio/add.html',
        controller: 'MainFolioController',
        controllerAs: 'MainFolioParent',
        authenticate: true
        //defaultRoute: '.appdetails',
      })
      .state('main.folio.holdmode', {
        url: '/holdMode?investorId&isBack',
        templateUrl: 'app/investor/addFolio/holdmode/holdmode.html',
        controller: 'AddHoldModeController',
        controllerAs: 'HoldMode',
        authenticate: true
      })
      .state('main.folio.soleApplicant', {
        url: '/soleApplicant/:investorId?isBack',
        templateUrl: 'app/investor/addFolio/soleApplicant/sole.applicant.html',
        controller: 'AddFolioController',
        controllerAs: 'SoleDetails',
        authenticate: true
      })
      .state('main.folio.jointholders', {
        url: '/jointHolders/:investorId',
        // templateUrl: 'app/investor/holderApproval/holder.html',
        templateUrl: 'app/investor/addFolio/jointHolders/jointHolders.html',
        controller: 'AddJointHoldersFolioController',
        controllerAs: 'JointHolders',
        authenticate: true,
        resolve: {
          jhPANDetails: ['$q', '$state', '$timeout', '$window', 'MessageService', 'InvestorFolioModel', 'ModalService',
            function ($q, $state, $timeout, $window, MessageService, InvestorFolioModel, ModalService) {
              var deferred = $q.defer(),
                model = angular.fromJson($window.sessionStorage.investorForm) || InvestorFolioModel.getInvestorFolioFormDataModel() || InvestorFolioModel.getNewInvestorFolioModel(),
                successPanDetails = function (result) {
                  if (result.data && result.data.kycverified) {
                    /!*Check repeated pan number*!/
                    if (
                      model.soleApplicantDetail.selfDetail
                      && model.soleApplicantDetail.selfDetail.panNumber
                      && model.soleApplicantDetail.selfDetail.panNumber != result.data.pan
                    ) {

                      var newModel = InvestorFolioModel.getNewJointHolder();
                      model.jointHolders = angular.isDefined(model.jointHolders)?
                        model.jointHolders:[];
                      model.jointHolders[0] = newModel;
                      model.jointHolders[0].jointHolderName = result.data.name;
                      model.jointHolders[0].pan = result.data.pan;
                      model.jointHolders[0].email = result.data.email;
                      model.jointHolders[0].mobileNumber = result.data.mobileNumber;
                      model.jointHolders[0].nriFlag = result.data.nriFlag;
                      InvestorFolioModel.setInvestorFolioModel(model);
                      $window.sessionStorage.investorForm = angular.toJson(model);
                      deferred.resolve();

                    } else {
                      MessageService.error("A valid PAN details required to add joint holder");
                      $timeout(function () {
                        $state.go('main.folio.soleApplicant');
                      });
                      deferred.reject();
                    }
                  }
                },
                errorPanDetails = function (arg) {
                  (angular.isUndefined(arg)||arg==='viaCrossButton') && MessageService.error("A valid PAN details required to add joint holder");
                  $timeout(function () {
                    $state.go('main.folio.soleApplicant');
                  });
                  deferred.reject();
                };
              if ((model.jointHolders
                  && model.jointHolders.length == 0)||angular.isUndefined(model.jointHolders)) {
                var labelSetter = {
                  type: 'jointholders',
                  label: {header: 'ADD JOINT HOLDER', pan: 'PAN', dob: 'Joint Holder DOB'},
                  nriFlag: model.jointHolders.nriFlag || false
                };
                ModalService.checkPan4Holder(labelSetter, successPanDetails, errorPanDetails);
              } else {
                deferred.resolve();
              }

              return deferred.promise;
            }]
        }
      })

      .state('main.folio.guardianDetails', {
        url: '/guardianDetails',
        templateUrl: 'app/investor/addFolio/soleApplicant/guardianDetails.html',
        controller: 'AddFolioController',
        controllerAs: 'GuardianDetails',
        authenticate: true,
        resolve: {
          gdPANDetails: ['$q', '$state', 'MessageService', 'InvestorFolioModel', 'ModalService', 'UtilService',
            function ($q, $state, MessageService, InvestorFolioModel, ModalService, UtilService) {
              var deferred = $q.defer(),
                model = InvestorFolioModel.getInvestorFolioFormDataModel() || InvestorFolioModel.getNewInvestorFolioFormDataModel(),
                successPanDetails = function (result) {
                  if (result.status && result.data && result.data.kycverified) {
                    var guardianModel = InvestorFolioModel.getNewGuardianDetails();
                    model.guardianDetails = guardianModel;
                    model.guardianDetails.basicDetails.dob = result.data.dob;
                    model.guardianDetails.basicDetails.panNumber = result.data.pan;
                    model.guardianDetails.basicDetails.kycStatus = true;
                    // InvestorFolioModel.setInvestorModel(model);
                    InvestorFolioModel.setInvestorFolioModel(model);
                    InvestorFolioModel.setTab({tab4: true});
                    deferred.resolve();
                  } else {
                    UtilService.errorHandler(result);
                    $state.go('main.folio.soleApplicant');
                    deferred.reject();
                  }
                },
                errorPanDetails = function (err) {
                  UtilService.errorHandler(err);
                  $state.go('main.folio.soleApplicant');
                  deferred.reject();
                };

              if (model.folioCreationRequestCO.guardianDetails
                && model.folioCreationRequestCO.guardianDetails.basicDetails
                && model.folioCreationRequestCO.guardianDetails.basicDetails.panNumber
                && model.folioCreationRequestCO.guardianDetails.basicDetails.dob
              ) {
                deferred.resolve();
              } else {
                var labelSetter = {
                  type: 'guardianDetails',
                  label: {header: 'ADD GUARDIAN DETAILS', pan: 'PAN', dob: 'Guardian DOB'}
                };
                ModalService.checkPan4Holder(labelSetter, successPanDetails, errorPanDetails);
              }

              return deferred.promise;
            }]
        }
      })
      .state('main.folio.nominee', {
        url: '/nominee/:investorId?isBack',
        templateUrl: 'app/investor/addFolio/addNominee/nominee.html',
        //templateUrl: 'app/investor/addFolio/addNominee/addNominee.html',
        controller: 'ExistingUserAddNomineeController',
        controllerAs: 'Nominee',
        authenticate: true,
        resolve:{dynamicData : _fetchDynamicData}
      })
      .state('main.folio.bankdetails', {
        url: '/bankDetails/:investorId?isBack',
        templateUrl: 'app/investor/addFolio/bankDetails/bankDetails.html',
        controller: 'BankDetailsFolioAddController',
        controllerAs: 'BankDetails',
        authenticate: true,
        resolve : { dynamicData : _fetchDynamicData}
      })
      .state('main.folio.review', {
        url: '/review/:investorId',
        templateUrl: 'app/investor/addFolio/review/review.html',
        controller: 'AddFolioReviewController',
        controllerAs: 'Review',
        authenticate: true
      })
  }

    function _fetchDynamicData(UtilService) {
        return UtilService.fetchDynamicData("FOLIO_CREATION")
    }

})();

/**
 * Created by ttn on 06/01/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SipTransactionSuccessController', sipTransactionSuccessController);

  /** @ngInject */
  function sipTransactionSuccessController($state, $window, $stateParams, AppConstants, LoaderService, MessageService, InvestmentBasketService, AuthService, NetcoreEvntService) {
    var vm = this;
    vm.note = AppConstants.INVESTMENT_BASKET.SIP_SUCCESS_NOTE;
    vm.importantNote = AppConstants.INVESTMENT_BASKET.SIP_IMPORTANT_NOTE;
    vm.installmentSteps = AppConstants.INVESTMENT_BASKET.SIP_INSTALLMENT_STEPS;
    vm.isExistingInvestor = $stateParams.existingInvestor;
    vm.convertToLocalString = convertToLocalString;


    vm.TRANSACTIONS_CONST = angular.copy(AppConstants);
    var q = localStorage.getItem('q')||"";
    var a = decodeURI(q);
    vm.formData = angular.isDefined(a) ? JSON.parse(a):{};
    vm.transData = {};

    init();
    function init() {
      var token = AuthService.getToken();
      sessionStorage.removeItem('FolioCreated');
      if (token) {
        vm.loggedIn = true;
      } else {
        vm.loggedIn = false;
      }
      vm.transData = vm.formData;
      vm.transData.paymentMode = vm.TRANSACTIONS_CONST.TRANSACTIONS.DESCRIPTIONS[vm.transData.paymentMode];
      vm.transData.noOfInstallments =  $window.moment($window.moment(vm.transData.endDate, "DD-MMM-YYYY")).diff($window.moment(vm.transData.startDate, "DD-MMM-YYYY"),'months') + 1;
      if (vm.formData.paymentMode === "Standing Instruction/Biller" || vm.formData.paymentMode === "OTM (One Time Mandate)") {
        var data = getDataToBePushed();
        NetcoreEvntService.Transaction_Success('SIP', data);
      }
    }

    function convertToLocalString(number) {
      if (number) {
        return parseInt(number).toLocaleString("en-IN");
      }
    }

    function getDataToBePushed() {
      var token = AuthService.getToken();
      var payload = {
        transaction_id: vm.formData.srnNo,
        value: vm.formData.amount,
        tax: 0,
        currency: "INR",
        userId: sessionStorage.getItem('userId'),
        status : "success",
        transaction_time: vm.formData.transactionInitiatedDate, //yy-mm-dd hh:mm:ss
        transaction_type: vm.formData.transactionType,
        source : vm.transData.paymentMode
      };
      var itemsArray = [];
      if (vm.formData.basketTrue) {
        vm.formData.basketDetails.schemesInBasket.forEach(function(details) {
          var item = {
            item_id: vm.formData.folioNumber,
            item_name: details.schemeName,
            item_category: details.schemeCode,
            item_category2: vm.formData.folioInvestorName.trim(),
            item_category3: token.encryptedPanNumber,//Encrypted value
            price: details.amount,
            quantity: "N/A"
          };
          itemsArray.push(item);
        });
      } else {
        vm.formData.schemes.forEach(function(details) {
          var item = {
            item_id: vm.formData.folioNumber,
            item_name: details.schemeName,
            item_category: details.schemeCode,
            item_category2: vm.formData.folioInvestorName.trim(),
            item_category3: token.encryptedPanNumber,//Encrypted value
            price: vm.formData.amount,
            quantity: "N/A"
          };
          itemsArray.push(item);
        });
      }
      payload.items = itemsArray;
      return payload;
    }
  }
})();

/**
 * Created by ttn on 06/01/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PurchaseTransactionSuccessController', purchaseTransactionSuccessController);

  /** @ngInject */
  function purchaseTransactionSuccessController($state, $stateParams, AppConstants, LoaderService, MessageService, summaryData, $window, AuthService) {
    var vm = this;
    vm.note = AppConstants.INVESTMENT_BASKET.PURCHASE_SUCCESS_NOTE;
    vm.isExistingInvestor = $stateParams.existingInvestor;
    vm.transactionId = $stateParams.transactionId;
    vm.transactionType = $stateParams.transactionType;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.isFavourite = $stateParams.isFavourite;
    vm.convertToLocalString = convertToLocalString;

    init();
    function init() {
      var token = AuthService.getToken();
      sessionStorage.removeItem('FolioCreated');
      if (token) {
        vm.loggedIn = true;
      } else {
        vm.loggedIn = false;
      }
      vm.transData = {
        folioNumber: summaryData.folioNumber,
        totalAmount: summaryData.amount,
        tranNumber: summaryData.tranNumber,
        paymentMethod: summaryData.paymentMode,
        bankName: summaryData.bankName,
        paymentDate: $window.moment(summaryData.transactionDate, "DD-MMM-YYYY").format("DD-MMM-YYYY"),
        schemeName: summaryData.schemeName,
        amount: summaryData.amount,
        subTranNumber: summaryData.subTranNumber,
        CAMSRefNumber: summaryData.camsReferenceNumber,
        distributorRIA: "DIRECT"
      };
    }
    function convertToLocalString(number) {
      if (number) {
        return parseInt(number).toLocaleString("en-IN");
      }
    }
  }
})();

/**
 * Created by ttn on 05/01/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TransactionFailureController', transactionFailureController);

  /** @ngInject */
  function transactionFailureController($state, $stateParams, AppConstants, LoaderService, MessageService,InvestmentBasketService) {
    var vm = this;
    vm.transType = String($stateParams.type).toUpperCase();
    vm.note = AppConstants.INVESTMENT_BASKET.NOTE;
    vm.contactMessage = AppConstants.INVESTMENT_BASKET.CONTACT_MESSAGE;
    vm.TRANSACTION_TYPE = vm.disclaimer = AppConstants.INVESTMENT_BASKET.TRANSACTION_TYPE;
    vm.errorMessage = 'Fund transfer terminated by the user.'
  }
})();

/**
 * Created by ttn on 08/12/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SuggestionController', suggestionController);

  /** @ngInject */
  function suggestionController($state, $rootScope) {
    var vm = this;
    vm.init = init;
    vm.init();
    function init() {
      $rootScope.$emit('updateTitle');
    }
  }
})();

/**
 * Created by ttn on 02/01/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentInvestNowController', investmentInvestNowController);

  /** @ngInject */
  function investmentInvestNowController($state, $stateParams, LoaderService,MessageService,InvestmentBasketService) {
    var vm = this;
    vm.containRetirementScheme = $stateParams.retirementFlag;
    vm.journey = $stateParams.journey;
  }
})();

/**
 * Created by ttn on 29/12/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ReviewController', reviewController);

  /** @ngInject */
  function reviewController($state, $window, AppConstants, ModalService, InvestorService , InvestmentBasketService , LoaderService , UtilService , $stateParams, MessageService, HDFC_API) {
    var vm = this;
    vm.formData = {};
    vm.viewMode = 'days';
    vm.enabledStartDatesList = [];
    vm.constants = AppConstants;
    vm.basketTitle = vm.basketDetails ? vm.basketDetails.basketName : null;
    vm.isCheckedTandC = false;

    vm.init = init;
    vm.showTermConditions = showTermConditions;
    vm.proceedToTransact = proceedToTransact;
    vm.backToReview = backToReview;
    vm.changeStartDate = changeStartDate;
    vm.changeEndDate = changeEndDate;
    vm.isFromPreLogin = $stateParams.fromPreLogin;
    vm.formData.frequency = 'OM';
    vm.formData.startDate = null;
    vm.basketSchemes = [];
    vm.basketSchemesDetails = [];
    vm.validationsBasket = [];

    vm.amountOptions = [];
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.amountInWords = '';
    vm.changeTillPerpetuityFlag = changeTillPerpetuityFlag;
    vm.formData.isTillPerpetuity = false;
    vm.convertToLocalString = convertToLocalString;
    vm.disclaimer = null;
    vm.retirement = null;
    vm.checkDateValidation = checkDateValidation;

    init();

    function init() {
      vm.journeyDetails = sessionStorage.getItem('reviewDataFromGoalJourney') ? JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')) : {};
      if (vm.journeyDetails) {
        vm.schemesDetails = vm.journeyDetails.schemeDetails ? vm.journeyDetails.schemeDetails : null;
        vm.goal = vm.journeyDetails.goalName ? vm.journeyDetails.goalName : null;
        if(vm.journeyDetails.schemeDetails) {
          var fundType = vm.journeyDetails.schemeDetails.direct ? 'direct' : 'regular';
          vm.fundUrl = HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + vm.journeyDetails.schemeDetails.linkUrl + '/' + fundType;
        }
      }
      getDetails();

      UtilService.fetchMandateValidations().then(function (resp) {
        vm.emandateObj = resp.eOTM;
        vm.mandateInfo = vm.emandateObj.mandateInfo;
      }).catch(function(resp) {
        MessageService.error(resp)
      });
    }

    function calculateStartDate() {
      var currentDate =  $window.moment();
      var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
      parsedDate.set({hour:0,minute:0,second:0,millisecond:0})
      parsedDate.toISOString()
      parsedDate.format();
      var todayDate = $window.moment(Date.parse(parsedDate));
      var counter = 0;
      vm.nonBusinessDatess = [];
      vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.sipTDay, 'days');
      console.log(vm.startMinDateBiller)
      vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
      var startDate = todayDate.clone();
      var freq = vm.startMaxDate.diff(todayDate, 'days');
      for (var i = 0; i <= freq; i++) {
        var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
        var isEnable = true;
        if(counter<5)
        {
          angular.isArray(vm.nonBusinessDatess) && vm.nonBusinessDatess.forEach(function (value) {
            if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')===0){
              isEnable = false;
            }
          });
        }
        if(isEnable){
          vm.enabledStartDatesList.push(startDate.clone().add(i, 'days'));
          counter++;
        }
      }
    }

    function indentifyEndDate() {
      var endDate = $window.moment(vm.formData.startDate, "DD-MMM-YYYY").add(vm.journeyDetails.additionalData.timeInMonths, 'months');
      vm.formData.endDate = $window.moment(endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
    }

    function changeStartDate(date , passedFrom) {
      if(!date) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.isTillPerpetuity = false;
        return;
      }
      if (date) {
        vm.formData.startDate = date;
      }

      if (!passedFrom) {
        vm.formData.endDate = null;
      }

      if (vm.journey === 'INVESTMENT_BASKET_JOURNEY' || vm.journey === 'RISK_JOURNEY' || (vm.journey === AppConstants.JOURNEY.GOAL_JOURNEY && vm.isBasketCustomized)) {
        updateEndDatesForBasket();
      } else {
        indentifyEndDate();
      }
    }

    function changeEndDate(date) {
      if(!date) {
        vm.formData.endDate =  null;
        vm.formData.isTillPerpetuity = false;
        return;
      }
      if (date) {
        vm.formData.endDate = date;
        var month = $window.moment(vm.formData.endDate,'DD-MMM-YYYY').month() + 1;
        var year = $window.moment(vm.formData.endDate,'DD-MMM-YYYY').year();
        var startDateMonth = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month() + 1;

        if ((month !== startDateMonth && year !== 2099) || (month !== startDateMonth && year === 2099) || (month == startDateMonth && year !== 2099)) {
          vm.formData.isTillPerpetuity = false;
          changeTillPerpetuityFlag('eventFromMethod');
        } else if (month === startDateMonth && year === 2099) {
          vm.formData.isTillPerpetuity = true;
          changeTillPerpetuityFlag('eventFromMethod');
        }
      }
    }

    function showTermConditions() {
      ModalService.transactionalTermConditionModal({ 'transactionType': vm.transactionType , fromBasket : true });
    }

    function backToReview() {
      if (vm.isFromPreLogin) {
        $state.go('preLoginBasket.investNow',{basketId: vm.basketId, journey: vm.journey, retirementFlag: vm.retirement});
      } else {
        $state.go('main.investment.investNow',{basketId: vm.basketId, journey: vm.journey, retirementFlag: vm.retirement});
      }
    }

    function getDetails() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        vm.journeySavedDetails = resp.data;
        vm.customizedBasketDetails = vm.journeySavedDetails.customizedBasketDetails;
        vm.isBasketCustomized = vm.journeySavedDetails.isBasketCustomized || false;
        vm.customizedEditedAllSchemeAmount = vm.customizedBasketDetails && vm.customizedBasketDetails.totalAmount;
        vm.journey = vm.journeySavedDetails.journey;
        if (vm.journey === 'INVESTMENT_BASKET_JOURNEY' && sessionStorage.getItem("folioSelected")) {
          vm.showBackButton = true;
        } else if (vm.journey === 'RISK_JOURNEY' && sessionStorage.getItem("folioSelected")) {
          vm.showBackButton = true;
        } else if (vm.journey === 'INVESTMENT_BASKET_JOURNEY') {
          vm.showBackButton = false;
        } else if (vm.journey === 'RISK_JOURNEY') {
          vm.showBackButton = false;
        }
        vm.formData.amount = vm.isBasketCustomized ? vm.customizedEditedAllSchemeAmount : vm.journeySavedDetails.amount;
        vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
        if(vm.formData.amount) {
          $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
          vm.formData.amountInWord = vm.formData.amountInWords;
        }
        vm.transactionType = vm.journeySavedDetails.transactionType;
        vm.journeyDetails.folioNumber = vm.journeySavedDetails.folioNumber ? vm.journeySavedDetails.folioNumber : sessionStorage.getItem("folioSelected");
        vm.totalAmount = vm.isBasketCustomized ? vm.customizedEditedAllSchemeAmount : vm.journeySavedDetails.amount;
        vm.isBasket = vm.journeySavedDetails.basket ? true : false;
        if (vm.journeySavedDetails.sipStartDate && vm.journeySavedDetails.sipEndDate) {
          vm.formData.startDate = vm.journeySavedDetails.sipStartDate;
          vm.formData.endDate = vm.journeySavedDetails.sipEndDate;
        }
        if (vm.isBasket) {
          vm.basketId = vm.journeySavedDetails.basketDetails.basketId;
          getBasketDetails();
        } else  {
          schemeValidations();
        }
        fetchDisclaimer();
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: "investment",
        child2: 'basket',
        child3: 'getDetails',
        child4: sessionStorage.getItem('journeyDraftId')
      }).$promise.then(success, error);
    }

    function proceedToTransact() {
      // $state.go('main.investment.folio');

      var Payload = getPayload(vm.transactionType);

      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (vm.isFromPreLogin) {
            $state.go("preLoginBasket.payment", {
              journeyId: vm.journeySavedDetails.id
            });
          } else {
            $state.go("main.investment.payment", {
              journeyId: vm.journeySavedDetails.id
            });
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };

      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'saveDetails'
      }, Payload).$promise.then(success, error);
    }


    function getPayload(transactionType) {
      var payload = {};
      payload = {
        "id": vm.journeySavedDetails.id,
        "folioNumber" : vm.journeyDetails.folioNumber,
        "panNumber": vm.journeySavedDetails.panNumber,
        "journey": vm.journeySavedDetails.journey,
        "step": "SECOND",
        "transactionType": transactionType === "SIP" ? 'SIP' : 'PURCHASE',
      };

      if (vm.journeySavedDetails.journey === 'GOAL_JOURNEY') {
        payload.goalId = vm.journeyDetails.goalId;
        payload.goalQuesAndAnsSet = vm.journeyDetails.goalQuesAndAnsSet;
      }
      if (vm.journeySavedDetails.journey === 'RISK_JOURNEY') {
        payload.riskAppetite = vm.journeySavedDetails.riskAppetite;
        payload.riskQuesAndAnsSet = vm.journeySavedDetails.riskQuesAndAnsSet;
      }

     if (vm.journeyDetails.additionalData && vm.journeyDetails.additionalData.basket) {
       payload.amount = vm.formData.amount;
       payload.basket = true;
       payload.basketDetails = {
         "basketId" : vm.journeyDetails.additionalData.basketDetails.basketId,
         "schemesInBasket" : []
       };

       var sumOfLastSchemes = 0;
       vm.journeyDetails.additionalData.basketDetails.schemesInBasket.forEach(function (el , index) {

         if (index !== vm.journeyDetails.additionalData.basketDetails.schemesInBasket.length - 1) {
           payload.basketDetails.schemesInBasket.push({
             "schemeCode": el.schemeCode ,
             "schemeName": el.schemeName,
             "schemeType": el.schemeType,
             "amount": vm.isBasketCustomized ? el.amount : Math.round(vm.formData.amount * (el.allocation / 100))
           });
           if(!vm.isBasketCustomized) {
             sumOfLastSchemes = sumOfLastSchemes + Math.round((vm.formData.amount * el.allocation / 100));
           }
        } else if (index === vm.journeyDetails.additionalData.basketDetails.schemesInBasket.length - 1)  {
           payload.basketDetails.schemesInBasket.push({
             "schemeCode": el.schemeCode,
             "schemeName": el.schemeName,
             "schemeType": el.schemeType,
             "amount": vm.isBasketCustomized ? el.amount : Math.round(vm.formData.amount - sumOfLastSchemes)
           })
         }
       });
     } else if (vm.isBasket) {
       payload.amount = vm.formData.amount;
       payload.basket = true;
       payload.basketDetails = {
         "basketId" : vm.journeySavedDetails.basketDetails.basketId,
         "schemesInBasket" : []
       };
       var sumOfLastSchemes = 0;
       var basketSchmemes = null;
       if(vm.journeySavedDetails && vm.isBasketCustomized) {
         basketSchmemes = vm.journeySavedDetails.basketDetails.schemesInBasket;
       } else {
         basketSchmemes = vm.basketDetails;
       }
       // vm.basketDetails.schemesInBasket = vm.journeySavedDetails && vm.isBasketCustomized && vm.journeySavedDetails.basketDetails.schemesInBasket;
       basketSchmemes.forEach(function (el, index) {
         if (index !== vm.basketDetails.length - 1) {
           payload.basketDetails.schemesInBasket.push({
             "schemeCode": el.schemeCode ,
             "schemeName": el.schemeName,
             "schemeType": el.schemeType,
             "amount": vm.isBasketCustomized ? el.amount : Math.round(vm.formData.amount * (el.allocation / 100))
           });
           if(!vm.isBasketCustomized) {
             sumOfLastSchemes = sumOfLastSchemes + Math.round((vm.formData.amount * el.allocation / 100));
           }
         } else if (index === vm.basketDetails.length - 1) {
           payload.basketDetails.schemesInBasket.push({
             "schemeCode": el.schemeCode ,
             "schemeName": el.schemeName,
             "schemeType": el.schemeType,
             "amount": vm.isBasketCustomized ? el.amount : Math.round(vm.formData.amount - sumOfLastSchemes)
           });
         }
       });
     } else {
       payload.amount = vm.formData.amount;
       payload.basket = false;
       payload.schemes = [
         {
           "schemeCode": vm.journeyDetails.schemeDetails ? vm.journeyDetails.schemeCode : vm.journeyDetails.additionalData.schemes[0].schemeCode,
           "schemeName": vm.journeyDetails.schemeDetails ? vm.journeyDetails.schemeDetails.schemeName : vm.journeyDetails.additionalData.schemes[0].schemeCode.schemeName,
           "schemeType": vm.journeyDetails.schemeDetails ? vm.journeyDetails.schemeDetails.schemeType : vm.journeyDetails.additionalData.schemes[0].schemeCode.schemeType,
         }
       ]
     }

     if (transactionType === 'SIP') {
       payload.sipStartDate =  $window.moment(vm.formData.startDate,"DD-MMM-YYYY").format("DD-MMM-YYYY"),
       payload.sipEndDate = $window.moment(vm.formData.endDate,"DD-MMM-YYYY").format("DD-MMM-YYYY")
     }

     payload.frequency = "MONTHLY";
     if(vm.isBasketCustomized) {
       payload.amount = vm.journeySavedDetails.amount;
       payload.isBasketCustomized = true;
       payload.customizedBasketDetails = {
         "totalAmount": vm.formData.amount,
         "basketName": vm.basketName,
         "schemesInBasket": vm.customizedBasketDetails.schemesInBasket.map(function (scheme) {
           return {
             "schemeCode": scheme.schemeCode,
             "schemeName": scheme.schemeName,
             "schemeType": scheme.schemeType,
             "amount": scheme.amount
           }
         })
       }
     }

      return payload;
    }

    function schemeValidations() {
      if (!vm.isBasket) {
        fetchSchemeValidationSingleScheme(vm.journeySavedDetails.schemes[0].schemeCode,vm.journeySavedDetails.folioNumber);
      } else {
        fetchSchemeValidationMultpleScheme();
      }
    }

    function fetchSchemeValidationSingleScheme(schemeCode, folioNumber) {
      LoaderService.showLoader();
      vm.validations = {};
      var payload = {
        "schemeCode": schemeCode ,
        "folioNo" : folioNumber
      }

      var success = function(resp) {
        if (resp.data && resp.status) {
          LoaderService.hideLoader();
          vm.validationsData = resp.data;
          sessionStorage.setItem('validationObject', JSON.stringify(vm.validationsData));
          resp.data.amountArray.forEach(function (el) {
            vm.amountOptions.push({
              text : el,
              value : el
            })
          })

          setValidationSchemes();

        }
      } , error  = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      }

      InvestmentBasketService.post({
        child1: 'schemeValidation',
        child2: vm.transactionType == 'SIP' ? 'sip' : 'purchase'
      },payload).$promise.then(success, error);
    }


    function fetchSchemeValidationMultpleScheme() {
      LoaderService.showLoader();
      var schemeCodes = [];

      vm.basketSchemesDetails.forEach(function (el) {
        schemeCodes.push(el.schemeCode);
      })

      var payload  = {
        schemeCodes : schemeCodes,
        transactionType : vm.transactionType
      }

      var success = function(resp) {
        LoaderService.hideLoader();
        vm.basketSchemeValidations = resp.data.validationDTOMap;
        sessionStorage.setItem('validationObject', JSON.stringify(resp.data));
        setValidationsObjectBasket();
      } , error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      }

      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'validate',
        child4: 'schemes'
      },payload).$promise.then(success, error);
    }

    function setValidationSchemes() {
      if (vm.transactionType == 'SIP') {
        vm.frequencyList = vm.validationsData.additionalValidation.frequency ? vm.validationsData.additionalValidation.frequency : null;
        vm.validations.minAmount = vm.validationsData.additionalValidation.OM[0].min_amount_lower;
        vm.additionalSipData = vm.validationsData.additionalValidation.OM;
        vm.validations.maxInstallments = vm.validationsData.monMaxInstallmentNumber;
        vm.sipTDay = vm.validationsData.sipTDay;
        fetchValidationsSip();
        calculateStartDate();
      } else {
        if (vm.validationsData) {

          if (!vm.validationsData.addlPurchase) {
            vm.isPurchaseMin = vm.validationsData.minFirstPurchaseAmt > vm.formData.purchaseAmount;
            vm.purchaseMinAmount = vm.validationsData.minFirstPurchaseAmt;
          } else {
            vm.isPurchaseMin = vm.validationsData.minAddlPurchaseAmt > vm.formData.purchaseAmount;
            vm.purchaseMinAmount = vm.validationsData.minAddlPurchaseAmt;
          }
          vm.isMultiples = vm.validationsData.purchaseMultiple && vm.formData.purchaseAmount && (vm.formData.purchaseAmount % vm.validationsData.purchaseMultiple === 0) || false;
          if(vm.formData.purchaseAmount%1 != 0){
            vm.isPurchaseAmountDecimal = true;
          }
          else{
            vm.isPurchaseAmountDecimal = false;
          }
        }
      }
    }

    function setValidationsObjectBasket() {

      if (vm.transactionType == 'SIP') {
        // calculateStartDate();
        vm.basketSchemesDetails.forEach(function (el) {
          el.minAmount = vm.basketSchemeValidations[el.schemeCode].additionalValidation.OM[0].min_amount_lower;
          el.additionalSipData = vm.basketSchemeValidations[el.schemeCode].additionalValidation.OM;
          el.maxInstallments = vm.basketSchemeValidations[el.schemeCode].monMaxInstallmentNumber;
          el.validationData = vm.basketSchemeValidations[el.schemeCode];
        });

        vm.sipTDay = vm.basketSchemesDetails[0].validationData.sipTDay;
        calculateStartDate();
        vm.frequencyList = vm.basketSchemesDetails[0].validationData.additionalValidation.frequency ? vm.basketSchemesDetails[0].validationData.additionalValidation.frequency : null;
        if (vm.journey === 'INVESTMENT_BASKET_JOURNEY' || vm.journey === 'RISK_JOURNEY' || (vm.journey === AppConstants.JOURNEY.GOAL_JOURNEY && vm.isBasketCustomized)) {
          changeStartDate(moment(vm.formData.startDate,"DD-MMM-YYYY"),'controller');
        }
        if (vm.amountOptions.length == 0) {
          vm.basketSchemesDetails[0].validationData.amountArray.forEach(function (el) {
            vm.amountOptions.push({
              text :  el,
              value : el
            })
          })
        }
        fetchValidationsSipBasketSchemes();
      } else {
        vm.basketSchemesDetails.forEach(function (el) {
          if (!vm.basketSchemeValidations[el.schemeCode].addlPurchase) {
            el.isPurchaseMin = vm.basketSchemeValidations[el.schemeCode].minFirstPurchaseAmt > el.amount;
            el.purchaseMinAmount = vm.basketSchemeValidations[el.schemeCode].minFirstPurchaseAmt;
          } else {
            el.isPurchaseMin = vm.basketSchemeValidations[el.schemeCode].minAddlPurchaseAmt > el.amount;
            el.purchaseMinAmount = vm.basketSchemeValidations[el.schemeCode].minAddlPurchaseAmt;
          }

          el.isMultiples = vm.basketSchemeValidations[el.schemeCode].purchaseMultiple && el.amount && (el.amount % vm.basketSchemeValidations[el.schemeCode].purchaseMultiple === 0) || false;
          el.purchaseMultiple = vm.basketSchemeValidations[el.schemeCode].purchaseMultiple;
          if(el.amount % 1 != 0){
            el.isPurchaseAmountDecimal = true;
          }
          else{
            el.isPurchaseAmountDecimal = false;
          }
        });

        vm.amountMultiples = null;
        // setting button disable for purchase basket
        for (var i = 0 ; i < vm.basketSchemesDetails.length ; i ++) {
          if (vm.basketSchemesDetails[i].isPurchaseMin) {
            vm.disabledBtn = true;
            break;
          } else if (vm.basketSchemesDetails[i].purchaseMultiple && !vm.basketSchemesDetails[i].isMultiples) {
            vm.amountMultiples = vm.basketSchemesDetails[i].purchaseMultiple;
            vm.disabledBtn = true;
            break;
          }else if(vm.formData.amount < vm.minBasketAmount){
            vm.disabledBtn = true;
          } else {
            vm.disabledBtn = false;
          }
        }
      }
    }


    function getBasketDetails() {
      vm.minBasketAmount = null;
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        vm.basketName = vm.isBasketCustomized ? vm.customizedBasketDetails.basketName : resp.data.basketName;
        vm.basketDetails = vm.isBasketCustomized ? vm.customizedBasketDetails.schemesInBasket : resp.data.schemesInBasket;
        vm.minBasketAmount = vm.isBasketCustomized ? null : resp.data.minBasketAmount;
        var sumOfLastSchemes = 0;
        vm.retirement = UtilService.checkForRetirementScheme(vm.basketDetails);
        vm.basketDetails.forEach(function (el,index) {
          var fundType = el.direct ? 'direct' : 'regular';
          if (index !== vm.basketDetails.length - 1) {
            vm.basketSchemesDetails.push({
              "schemeCode": el.schemeCode,
              "schemeName": el.schemeName,
              "schemeType": el.schemeType,
              "amount": vm.isBasketCustomized ? el.amount : Math.round((vm.formData.amount * el.allocation / 100)),
              fundUrl: HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + el.linkUrl + '/' + fundType
            });
            if(!vm.isBasketCustomized) {
              sumOfLastSchemes = sumOfLastSchemes + Math.round((vm.formData.amount * el.allocation / 100));
            }
          } else if (index === vm.basketDetails.length - 1) {
            vm.basketSchemesDetails.push({
              "schemeCode": el.schemeCode,
              "schemeName": el.schemeName,
              "schemeType": el.schemeType,
              "amount": vm.isBasketCustomized ? el.amount : Math.round(vm.formData.amount - sumOfLastSchemes),
              fundUrl: HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + el.linkUrl + '/' + fundType
            });
          }
        });
        resp.data.amountArray.forEach(function (el) {
          vm.amountOptions.push({
            text : el,
            value : el
          })
        })

        schemeValidations();
      } , error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      }

      InvestmentBasketService.get({
        child1: 'investment',
        child2: 'basket',
        child3: 'getBasketDetails',
        child4: vm.basketId
      },{}).$promise.then(success, error);
    }


    vm.amountChanged = function () {
      vm.formData.amount = parseInt(vm.formData.displayAmount.toString().replaceAll(",", ""));
      vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
      if (vm.isBasket) {
        vm.basketSchemesDetails = [];
        var sumOfLastSchemes = 0;
        vm.basketDetails.forEach(function (el,index) {
          var fundType = el.direct ? 'direct' : 'regular';
          if (index !== vm.basketDetails.length - 1) {
            vm.basketSchemesDetails.push({
              "schemeCode": el.schemeCode,
              "schemeName": el.schemeName,
              "schemeType": el.schemeType,
              "amount": vm.formData.amount && !vm.isBasketCustomized ? Math.round((vm.formData.amount * el.allocation / 100)) : el.amount,
              fundUrl: HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + el.linkUrl + '/' + fundType
            });
            if(!vm.isBasketCustomized) {
              sumOfLastSchemes = sumOfLastSchemes + Math.round((vm.formData.amount * el.allocation / 100));
            }
          } else if (index === vm.basketDetails.length - 1) {
            vm.basketSchemesDetails.push({
              "schemeCode": el.schemeCode,
              "schemeName": el.schemeName,
              "schemeType": el.schemeType,
              "amount": vm.formData.amount && !vm.isBasketCustomized ? Math.round(vm.formData.amount - sumOfLastSchemes) : el.amount,
              fundUrl: HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + el.linkUrl + '/' + fundType
            })
          }
        });

        setValidationsObjectBasket();
      } else {
        setValidationSchemes();
      }
      if(vm.formData.amount == "" || vm.formData.amount == null) {
        resetNumInWords();
      } else {
        $window.NumToWord(vm.formData.amount,'divDisplayWords', vm.formData);
        vm.formData.amountInWord = vm.formData.amountInWords;
      }
    }

    vm.onAmountChange = function(value){
      vm.formData.amount = value;
      vm.formData.displayAmount = parseInt(vm.formData.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
      if(vm.formData.amount){
        $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
        vm.formData.amountInWord = vm.formData.amountInWords;
      }
      vm.amountChanged();
    }

    function fetchValidationsSip() {
      if(vm.additionalSipData){
        var newValidation =  vm.additionalSipData;
        for (var i=0; i<newValidation.length;i++){
          var condition = vm.formData.amount < newValidation[i].min_amount_lower ||  vm.formData.amount <= newValidation[i].min_amount_upper
          if(!newValidation[i].min_amount_upper){
            var condition = true;
          }
          if(condition)
          {
            // vm.formData.startDate = null;
            // vm.enabledStartDates = null;
            // vm.formData.endDate = null;
            // vm.enabledEndDates = null;
            vm.validations.amountMultiples = newValidation[i].amt_multiples;
            vm.validations.maxAmount = newValidation[i].min_amount_upper;
            // vm.validations.minAmount = newValidation[i].min_amount_lower;
            vm.validations.minInstallments = newValidation[i].min_installments;
            break;
          }
        }
      }

      vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
      vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
      vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
    }

    function fetchValidationsSipBasketSchemes() {
      if (vm.transactionType == 'SIP') {
        vm.basketSchemesDetails.forEach(function (el, index) {
          if(el.additionalSipData){
            var newValidation =  el.additionalSipData;
            for (var i = 0; i < newValidation.length ; i++){
              var condition = el.amount < newValidation[i].min_amount_lower ||  el.amount <= newValidation[i].min_amount_upper
              if(!newValidation[i].min_amount_upper){
                var condition = true;
              }
              if(condition)
              {

                el.amountMultiples = newValidation[i].amt_multiples;
                el.maxAmount = newValidation[i].min_amount_upper;
                el.minInstallments = newValidation[i].min_installments;
                el.isMax = !!(newValidation[i].min_amount_upper && newValidation[i].min_amount_upper < el.amount);
                el.isMin = !!(el.minAmount && el.minAmount > el.amount);
                el.isMultiples = newValidation[i].amt_multiples && newValidation[i].amt_multiples && (el.amount % newValidation[i].amt_multiples === 0) || false
                break;
              }
            }
          }
        });


        // iterating again for setting the button disabled
        vm.amountMultiples = null;

        for (var i = 0 ; i < vm.basketSchemesDetails.length ; i ++) {
          if (vm.basketSchemesDetails[i].isMin) {
            vm.disabledBtn = true;
            break;
          } else if (!vm.basketSchemesDetails[i].isMultiples) {
            vm.amountMultiples = vm.basketSchemesDetails[i].amountMultiples;
            vm.disabledBtn = true;
            break;
          } else if(vm.formData.amount < vm.minBasketAmount){
            vm.disabledBtn = true;
          } else {
            vm.disabledBtn = false;
          }
        }
      }
    }


    function setErrorMessage() {

    }

    function updateEndDatesForBasket() {
      if (!vm.formData.startDate) {
        return;
      }

      var defaultEndDate = $window.moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      //var defaultEndDate = new Date(2036, 12, 31);
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;
      var frequency = vm.frequencyList.find(function (f) {
        return f.code === vm.formData.frequency;
      }) || {};

      var months = 0;
      endDate = vm.formData.startDate.clone().add(frequency, 'months');
      defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
      freq = freq || (defaultMonths / frequency.duration);
      for (i = 0; i < freq; i++) {
        months = frequency.duration * i;
        enabledEndDates.push(endDate.clone().add(months, 'months'));
      }

      // var minInstallments = vm.basketSchemesDetails && vm.basketSchemesDetails[0].additionalSipData[0].min_installments && (vm.basketSchemesDetails[0].additionalSipData[0].min_installments - 1) || 0;
      var minInstallments = null;
      var maxOfAllSchemes = vm.basketSchemesDetails && vm.basketSchemesDetails[0].additionalSipData[0].min_installments && (vm.basketSchemesDetails[0].additionalSipData[0].min_installments) || 0;
      vm.basketSchemesDetails && vm.basketSchemesDetails.forEach(function (scheme) {
        if(scheme.additionalSipData[0].min_installments && (scheme.additionalSipData[0].min_installments  > maxOfAllSchemes)) {
          maxOfAllSchemes = scheme.additionalSipData[0].min_installments;
        }
      });
      minInstallments = maxOfAllSchemes - 1 || 0;
      vm.enabledEndDates = angular.copy(enabledEndDates.slice(minInstallments));
      vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
      vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
      var month = $window.moment(vm.journeySavedDetails.sipEndDate,'DD-MMM-YYYY').month() + 1;
      var year = $window.moment(vm.journeySavedDetails.sipEndDate,'DD-MMM-YYYY').year();
      var startDateMonth = $window.moment(vm.journeySavedDetails.sipStartDate, 'DD-MMM-YYYY').month() + 1;

      if (month === startDateMonth && year === 2099) {
        vm.formData.isTillPerpetuity = true;
        changeTillPerpetuityFlag();
      }
    }
    function resetNumInWords() {
      vm.amountInWords = '';
      vm.formData.amountInWord = '';
      var inWordsDiv = $window.document.getElementById('divDisplayWords');
      var inWordsFirstInstallmentDiv = $window.document.getElementById('divDisplayWordFirstInstallment');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '';
      }
      if (inWordsFirstInstallmentDiv) {
        inWordsFirstInstallmentDiv.innerHTML = '';
      }
    }

    function changeTillPerpetuityFlag(from) {
      if (vm.formData.isTillPerpetuity) {
        vm.formData.endDate = null;
        var day = moment(vm.formData.startDate,'DD-MMM-YYYY').date();
        var month = moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
        var newEndDate = day + '/'+ (month + 1) +'/2099';
        vm.formData.endDate = moment(newEndDate,'DD-MM-YYYY');
        // vm.formData.endDate = moment(vm.formData.startDate,'DD-MMM-YYYY').add(90,'years')
      } else if (from !== 'eventFromMethod') {
        vm.formData.endDate = null;
      }
    }

    function convertToLocalString(number) {
      if (number) {
        return parseInt(number).toLocaleString("en-IN");
      }
    }

    function fetchDisclaimer() {
      var successHandler = function(resp) {
        if (vm.journey === AppConstants.JOURNEY.INVESTMENT_BASKET_JOURNEY && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket &&
          resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket !== undefined) {
          vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket.content;
        } else if (vm.journey === AppConstants.JOURNEY.GOAL_JOURNEY && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey &&
          resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey !== undefined) {
          vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey.content;
        } else if ((vm.journey === "PERSONALITY" || vm.journey === AppConstants.JOURNEY.RISK_JOURNEY) && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile &&
          resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile !== undefined) {
          vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile.content;
        }
      };
      UtilService.fetchDynamicData("INVESTMENT_BASKET").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function checkDateValidation() {
      if (vm.formData.endDate && vm.enabledEndDates && !(($window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || ($window.moment(vm.formData.endDate).isSame($window.moment(vm.enabledEndDates[0]))) || ($window.moment(vm.formData.endDate).isSame($window.moment(vm.enabledEndDates.length - 1))))) {
        vm.formData.endDate = null;
      }
    }


  }
})();

/**
 * Created by ttn on 20/12/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('BasketPreLoginController', BasketPreLoginController);

  /** @ngInject */
  function BasketPreLoginController($window, $stateParams, AuthService, LoaderService, $state, ModalService, $timeout, AppConstants ,
                               InvestmentModel, InvestmentBasketService, MessageService, CommonFactory, UtilService, InvestorService, $scope, $rootScope,HDFC_API) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.isLoading = false;
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    var identifierData = AuthService.getInstaToken();
    vm.investorName = identifierData ? identifierData.investorName : 'Investor Name';
    vm.isExistingInvestor = true;
    vm.uniqueLink = $stateParams.id;
    vm.init = init;
    vm.logoutMe = logoutMe;
    vm.routeRedirect = false;
    var removeListeners = {}, isRefreshing = false;
    var scope = $scope;


    init();
    function init() {
      setListeners();
    }

    function logoutMe() {
      var user = sessionStorage.getItem('userType');
      var val = JSON.parse(decodeURI(sessionStorage.getItem('pd')));
      if (user === 'NEW') {
        var success = function (resp) {
          localStorage.removeItem("userId");
          var newDataLayer = $window.dataLayer.filter(function (obj) {
            return !obj.hasOwnProperty('userId');
          });
          $window.dataLayer = newDataLayer;
          CommonFactory.setLogoutSuccess();
          $state.go('login');
        },
          error = function (err) {
        };
        LoaderService.showLoader('.logout');
        InvestorService.post({
          child1: 'force',
          child2: 'logout'
        }, val).$promise.then(success, error);
      } else {
        AuthService.logout('pre-login').then(function () {
          localStorage.removeItem("userId");
          var newDataLayer = $window.dataLayer.filter(function (obj) {
            return !obj.hasOwnProperty('userId');
          });
          $window.dataLayer = newDataLayer;
          CommonFactory.setLogoutSuccess();
          $state.go('login');
        }, function () {});
      }
    }

    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        if (!token) {
          $state.go('login');
          resetFlag();
          return;
        }

        if (token && token.refresh_token) {
          AuthService.getRefreshToken(token).then(function () {
            if (localStorage.getItem('doLogOut')) {
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                ModalService.logoutSuccess();
                $state.go('login');
              }, function () {
                ModalService.logoutSuccess();
                $state.go('login');
              });
            } else {
              $state.reload();
              resetFlag();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            $state.go('login');
            resetFlag();
          });
        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          $state.go('login');
        }
      });

      var resetFlag = function () {
        $timeout(function () {
          isRefreshing = false;
        }, 2000);
      };

      scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in removeListeners) {
          if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
            removeListeners[key]();
          }
        }
      });
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PersonalityController', personalityController);

  /** @ngInject */
  function personalityController(InvestorService, LoaderService, UtilService, $window, ModalService, $sce, AppConstants, AuthService, $rootScope, $log,$stateParams, $state, InvestmentBasketService, InvestmentModel, MessageService, $timeout, HDFC_API) {
    var vm = this;
    vm.formData = InvestmentModel.getPayload();
    vm.dataFromGoal = InvestmentModel.getGoalPayload();
    vm.investmentPersonalityQuestion = [];
    vm.fullRiskData = [];
    vm.isEvaluated = false;
    vm.riskProfileOptions = [];
    vm.formData = {};
    vm.isQuestionTourTourEnd = false;
    vm.icon = "";
    var token = AuthService.getToken();
    vm.disclaimer = null;
    vm.allSteps = [
      {
        id : 0,
        name : 'Questions',
        completed : false
      },
      /*{
        id : 1,
        name : 'Score',
        completed :false
      },*/
      {
        id : 2,
        name : 'Investment Personality',
        completed : false
      }
    ];
    vm.isIntroShown = true;
    vm.journey = null;
    vm.goalId = null;
    vm.evaluatePersonality = evaluatePersonality;
    vm.showTab = showTab;
    vm.nextAndPreviousAction = nextAndPreviousAction;
    vm.submitForm = submitForm;
    vm.goToRecomendation = goToRecomendation;
    vm.startInvesting = startInvesting;
    vm.changeStep = changeStep;
    vm.goToQuestionaire = goToQuestionaire;
    vm.currentTab = 0;
    vm.scoreChecked = false;
    vm.questionCounter = 1;
    vm.checkDisable = {};
    vm.validateObject = {};
    vm.init = init;
    vm.isValueSelected = isValueSelected;
    vm.saveDetails = saveDetails;
    vm.getDetails = getDetails;

    init();
    function init() {
      $window.scrollTo(0, 0);
      sessionStorage.removeItem('FolioCreated');
      sessionStorage.removeItem('transactionSuccess');
      vm.allSteps[0].completed = true;
      InvestmentModel.resetPayloadFolio();
      sessionStorage.removeItem('journeyDraftId');
      sessionStorage.removeItem('reviewDataFromGoalJourney');
      $rootScope.$emit('updateTitle');
      if ($stateParams.journey && $stateParams.goalId) {
        vm.journey = $stateParams.journey;
        vm.goalId = $stateParams.goalId;
        evaluatePersonality();
      }
      if ($stateParams.journey && $stateParams.viaBack) {
        vm.idAfterSaveDetails = $stateParams.journey;
        getQuestionAnswserDetails(true);
      }
      sessionStorage.removeItem('cgfFlagFromGoalJourney');
      sessionStorage.removeItem('onlyIndividualFolioCreation');
      // fetchRiskAppetites();
      var successHandler = function(resp) {
        if(resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile !== undefined) {
          vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Risk_Profile.content;
        }
      };
      UtilService.fetchDynamicData("INVESTMENT_BASKET").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function getQuestionAnswserDetails(viaBack) {
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status && response.data) {
          vm.isIntroShown = false;
          vm.investmentPersonalityQuestion = response.data.questionAndAnswerDetail;
          vm.investmentPersonalityQuestion.questionAndAnswers.forEach(function (question) {
            question.riskQuestionsDTO.sort(function(a, b) {
              var keyA = a.optionId, keyB = b.optionId;
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
          });

          vm.investmentPersonalityQuestion.questionAndAnswers.sort(function(a, b) {
            var keyA = a.sequence, keyB = b.sequence;
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
          // showModal();
          showTab(vm.currentTab);
          if (viaBack) {
            getLastRiskAppetite(viaBack);
          }
          vm.isQuestionTourTourEnd = false;
          // nextAndPreviousAction(vm.currentTab);
        }
        else {
          MessageService.error(response.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: 'risk',
        child2: 'quesAndAnsDetail'
      }).$promise.then(success, error);
    }

    function evaluatePersonality(){
      getQuestionAnswserDetails();
      changeStep(0);
    }

    function showTab(tab) {
      $timeout(function() {
        var tabs = angular.element($window.document.querySelectorAll(".tab"));
        angular.element(tabs[tab]).show();
        if(vm.questionCounter == 1){
          angular.element($window.document.querySelector(".progress-div")).css('width',((100 / vm.investmentPersonalityQuestion.questionAndAnswers.length) + '%'));
        }else {
          angular.element($window.document.querySelector(".progress-div")).css('width',((vm.questionCounter/vm.investmentPersonalityQuestion.questionAndAnswers.length)*100 + '%'));
        }
      }, 100);
    }

    function nextAndPreviousAction(index) {
      var x = angular.element($window.document.querySelectorAll(".tab"));
      if (index == 1 && !validateForm()) return false;
      if (x[vm.currentTab]) {
        x[vm.currentTab].style.display = "none";
      }
      vm.currentTab = vm.currentTab + index;
      vm.questionCounter = vm.questionCounter + index;
      if (vm.currentTab >= x.length) {
        return false;
      }else if(vm.currentTab == -1){
        vm.isIntroShown = true;
        vm.currentTab = 0;
        vm.questionCounter = 1;
        return;
      }
      showTab(vm.currentTab);
      if(vm.formData[vm.investmentPersonalityQuestion.questionAndAnswers[vm.currentTab].riskQuestionsDTO[0].questionId]){
        vm.validateObject[vm.currentTab] =  true;
      }
      // angular.element($window.document.querySelector(".progress-div")).css('width',((vm.currentTab/vm.investmentPersonalityQuestion.questionAndAnswers.length)*100 + '%'));
    }

    function validateForm() {
      return true;
    }

    function getLastRiskAppetite(viaBack){
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status && response.data) {
          vm.getLastRiskAppetite = response.data;
          if(vm.getLastRiskAppetite && Object.keys(vm.getLastRiskAppetite).length > 0) {
            defaultLastAppetiteOptions(vm.getLastRiskAppetite);
          }
          if (viaBack) {
            submitForm();
          }
        }
        else {
          MessageService.error(response.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: 'risk',
        child2: 'getLastRiskAppetite'
      }).$promise.then(success, error);
    }

    function defaultLastAppetiteOptions(getLastRiskAppetite){
      getLastRiskAppetite.queAndAns.forEach(function (lastSelected){
        vm.formData[lastSelected.questionId] = lastSelected.optionId;
      });
      if(vm.formData[vm.investmentPersonalityQuestion.questionAndAnswers[vm.currentTab].riskQuestionsDTO[0].questionId]){
        vm.validateObject[vm.currentTab] =  true;
      }
    }

    function submitForm() {
      var payload = {
        queAndAns: []
      };
      var keys = Object.keys(vm.formData);
      keys.forEach(function(key) {
        var obj = {
          questionId: key,
          optionId: vm.formData[key]
        };
        payload.queAndAns.push(obj);
      });
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.calculatedRiskAppetite = resp.data;
          vm.icon = "assets/images/icons/riskometer/" + vm.calculatedRiskAppetite.riskAppetite.toLowerCase() + ".svg";
          sessionStorage.setItem('USER_APPETITE', vm.calculatedRiskAppetite.riskAppetite);
          vm.showScoreSection = false;
          vm.allSteps[0].completed = false;
          vm.allSteps[1].completed = true;
          vm.isQuestionTourTourEnd = true;
          if (!vm.journey && !vm.goalId) {
            getRecommendation(payload);
            changeStep(2);
          } else {
            $state.go('main.investment.goals', {
              goalId: vm.goalId
            });
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.post({
        child1: 'risk',
        child2: 'evaluateRiskAppetite'
      }, payload).$promise.then(success, error);
    }

    function goToRecomendation(){
      vm.showScoreSection = false;
      vm.showRecommendScreen = true;
      vm.allSteps[1].completed = true;
      //vm.allSteps[1].completed = false;
      vm.scoreChecked = true;
    }

    function startInvesting() {
      vm.containRetirementScheme = UtilService.checkForRetirementScheme(vm.suggestedBasket.schemesInBasket);
      var success = function(resp) {
        if (resp === "SELECT_NEW") {
          sessionStorage.setItem('folioSelectedForNewFolio', false);
          proceedToFolioSelection();
        } else {
          selectExistingFolio();
        }
      }, error = function () {
      };
      ModalService.folioChoiceModal({
        isFromPostLogin: true
      }, success, error);
    }

    function selectExistingFolio() {
      var success = function (resp) {
        if (resp === "SELECT_NEW") {
          sessionStorage.setItem('folioSelectedForNewFolio', true);
          proceedToFolioSelection();
        } else {
          sessionStorage.removeItem("folioSelected");
          sessionStorage.setItem('folioSelectedForNewFolio', false);
          redirectToInvestNow();
        }
      }, error = function() {
      };
      ModalService.fillFolioDetailsModal({
        text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
        journey: AppConstants.JOURNEY.RISK_JOURNEY,
        isFromPostLogin: true
      }, success, error);
    }

    function proceedToFolioSelection() {
      var success = function(resp) {
        vm.folioNumber = resp;
        sessionStorage.setItem("folioSelected", vm.folioNumber);
        redirectToInvestNow();
      }, error = function() {
      };
      ModalService.selectFolioModal({
        journey:  AppConstants.JOURNEY.RISK_JOURNEY,
        retirementFlag: vm.containRetirementScheme
      }, success, error);
    }

    function redirectToInvestNow(){
      sessionStorage.setItem('investNowBackUrl','main.investment.personality');
      sessionStorage.setItem('investNowBackParams', JSON.stringify({journey:vm.idAfterSaveDetails}));
      $state.go('main.investment.investNow',{
        basketId: vm.suggestedBasket.basketId,
        retirementFlag: vm.containRetirementScheme === true ? true : null,
        journey: 'PERSONALITY'
      });
    }

    function changeStep(step){
      if(step == 0){
        vm.allSteps[0].completed = true;
        //vm.allSteps[1].completed = false;
        vm.allSteps[1].completed = false;
        vm.showRecommendScreen = false;
        vm.showScoreSection = false;
        vm.isQuestionTourTourEnd = false;
        vm.scoreChecked = false;
        vm.currentTab = 0;
        vm.questionCounter = 1;
        //showTab(vm.currentTab);
        $timeout(function () {
          nextAndPreviousAction(vm.currentTab);
        }, 10)
      }else if(step == 1 && vm.isQuestionTourTourEnd){
        vm.allSteps[0].completed = false;
        //vm.allSteps[1].completed = true;
        vm.allSteps[1].completed = false;
        vm.showScoreSection = true;
        vm.showRecommendScreen = false;
      }else if(step == 2 && vm.isQuestionTourTourEnd){
        vm.allSteps[0].completed = false;
        //vm.allSteps[1].completed = false;
        vm.allSteps[1].completed = true;
        vm.showScoreSection = false;
        vm.showRecommendScreen = true;
        vm.scoreChecked = true;
      }
      if(!vm.showScoreSection && !vm.showRecommendScreen && (vm.allSteps[0].completed /*&& !vm.allSteps[1].completed*/ && !vm.allSteps[1].completed && !vm.isQuestionTourTourEnd)){
        vm.checkDisable = {1 : true, 2 : true};
      }else if(vm.showScoreSection && !vm.showRecommendScreen && (!vm.allSteps[0].completed /*&& vm.allSteps[1].completed*/ && !vm.allSteps[1].completed)){
        vm.checkDisable = {2 : true};
      }else if(!vm.showScoreSection && !vm.showRecommendScreen && (vm.allSteps[0].completed /*&& !vm.allSteps[1].completed*/ && !vm.allSteps[1].completed)){
        vm.checkDisable = {2: true};
      }
      // if(!vm.showScoreSection && !vm.showRecommendScreen){
      //   vm.checkDisable = {1:true, 2:true};
      // }if(vm.scoreChecked && vm.showRecommendScreen){
      //   vm.checkDisable = {};
      // }
    }

    function goToQuestionaire(){
      changeStep(0);
    }

    function isValueSelected(questionId, optionId) {
      if (optionId) {
        vm.validateObject[vm.currentTab] =  true;
      }
    }

    function getRecommendation(submitedForm) {
      var payload = {
        riskAppetite: vm.calculatedRiskAppetite.riskAppetite
      };
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.suggestedBasket = resp.data;
          vm.suggestedBasket.schemesInBasket.forEach(function (scheme) {
            var fundType = scheme.direct ? 'direct' : 'regular';
            scheme.fundUrl = HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + scheme.linkUrl + '/' + fundType;
          });
          saveDetails(submitedForm);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.post({
        child1: 'risk',
        child2: 'getBasket'
      }, payload).$promise.then(success, error);
    }

    function getDetails() {
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status && response.data) {
          console.log('getresponse',response)
        }
        else {
          MessageService.error(response.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: 'investment',
        child2: 'basket',
        child3: 'getDetails',
        child4: vm.idAfterSaveDetails
      }).$promise.then(success, error);
    }

    function saveDetails(submitFormData) {
      var payload = {
        "panNumber": token.investorPAN,
        "journey": AppConstants.JOURNEY.RISK_JOURNEY,
        "step": "FIRST",
        "riskAppetite": vm.calculatedRiskAppetite.riskAppetite,
        "riskQuesAndAnsSet": submitFormData.queAndAns
      };
      if (vm.suggestedBasket.basketId) {
        payload.basket = vm.suggestedBasket.basketId ? true : false;
        payload.basketDetails = {
          "basketId": vm.suggestedBasket.basketId,
          "basketName": vm.suggestedBasket.basketName
        };
      }
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.idAfterSaveDetails = resp.data.id;
          sessionStorage.setItem('journeyDraftId', resp.data.id);
          // getDetails(resp.data.id);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'saveDetails'
      }, payload).$promise.then(success, error);
    }

    vm.viewDetails = function () {
      $state.go('main.investment.basketDetails', { id: vm.suggestedBasket.basketId });
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentSipPurchaseController', investmentSipPurchaseController);

  /** @ngInject */
  function investmentSipPurchaseController(InvestorService, LoaderService, UtilService, $window, ModalService, $sce, AppConstants, AuthService, $rootScope, $log,$stateParams, $state, InvestmentBasketService, InvestmentModel) {
    var vm = this;
    vm.formData = InvestmentModel.getPayload();
    vm.init = init;
    vm.suggestionList = {
      goalAmount: "7000000",
      duration: "5 Years",
      schemes: [
        {
          schemeName: "HDFC Mid Cap Opportunities Fund",
          schemeType: "Open-ended Thematic Equity Scheme",
          numberOfInvestor: "246876345",
          details: ["Direct plan", "Thematic/Secroral Equity"],
          sipAmount: "33,333.3"
        },
        {
          schemeName: "HDFC Mid Cap Opportunities Fund",
          schemeType: "Open-ended Thematic Equity Scheme",
          numberOfInvestor: "246876345",
          details: ["Direct plan", "Thematic/Secroral Equity"],
          sipAmount: "33,333.3"
        }
      ],
      baskets: [
        {
          basketName: "HDFC Balance Basket",
          basketSchemes: [
            {
              schemeName: "HDFC Top 100 Fund",
              sipAmount: "7581.7",
              riskProfile: "Moderately High Risk",
              type: ""
            },
            {
              schemeName: "HDFC Top 100 Fund",
              sipAmount: "7581.7",
              riskProfile: "Very High Risk",
              type: "Hybrid"
            },
            {
              schemeName: "HDFC Banking & PSU Debit Fund",
              sipAmount: "7581.7",
              riskProfile: "Very High Risk",
              type: ""
            },
            {
              schemeName: "HDFC Banking & PSU Debit Fund",
              sipAmount: "7581.7",
              riskProfile: "Very High Risk",
              type: ""
            }
          ]
        }
      ]
    };
    init();
    function init(){
      vm.formData.investmentType = 'PURCHASE'
      console.log(vm.formData)
    }
  }
})();

/**
 * Created by ttn on 20/12/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestNowController', InvestNowController);

  /** @ngInject */
  function InvestNowController($window, $stateParams, AuthService, LoaderService, $state, ModalService, $timeout, AppConstants ,
                               InvestmentModel, InvestmentBasketService, MessageService, CommonFactory, UtilService, $scope, $rootScope) {
    var vm = this;
    vm.isLoading = false;
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    var identifierData = AuthService.getInstaToken();
    vm.investorName = identifierData ? identifierData.investorName : 'Investor Name';
    vm.isExistingInvestor = true;
    vm.uniqueLink = $stateParams.id;
    vm.init = init;
    vm.routeRedirect = false;
    var removeListeners = {}, isRefreshing = false;
    var scope = $scope;


    init();
    function init() {
      InvestmentModel.resetPayloadFolio();
      setListeners();
      if ($stateParams && $stateParams.id) {
        vm.uuid = $stateParams.id;
        vm.isLoading = false;
        sessionStorage.removeItem('randomOTPIdForGoalKYIPAndBasket');
        getToken();
      }
    }

    function getToken() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.isLoading = true;
          resp.data.access_token = resp.data.accessToken;
          AuthService.setToken(resp.data);
          vm.journey = resp.data.journey;
          vm.journeyId = resp.data.basketId;
          vm.investorType = resp.data.registrationType;
          sessionStorage.setItem('userType',vm.investorType);
          getDetails();
        } else {
          MessageService.error(resp.message);
          $state.go('login');
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err)
      };
      sessionStorage.removeItem('FolioCreated');
      InvestmentBasketService.get({
        child1: 'preLogin',
        child2: 'getToken',
        child3: vm.uuid
      }).$promise.then(success, error);
    }

    function decideStateAndJourney() {
      if (vm.journey === 'GOAL_JOURNEY') {
        vm.dataForReviewScreen = {
          "goalName" : vm.journeyDetails.goalName,
          "additionalData" : {
            timeInMonths: vm.journeyDetails.timeInMonths,
            returnRate: '',
            transactionType: vm.journeyDetails.transactionType,
            newUser: vm.journeyDetails.newUser,
            basket: vm.journeyDetails.basket,
            schemes: vm.journeyDetails.schemes
          },
          "goalId" : vm.journeyDetails.goalId,
          "goalQuesAndAnsSet" : vm.journeyDetails.goalQuesAndAnsSet,
          "transactionType" : vm.journeyDetails.transactionType,
          "amount" : vm.journeyDetails.amount,
        };
        if (!vm.journeyDetails.basket) {
          vm.dataForReviewScreen.schemeDetails = {
            amount: vm.journeyDetails.amount,
            schemeCode: vm.journeyDetails.schemes[0].schemeCode,
            schemeName: vm.journeyDetails.schemes[0].schemeName,
            schemeType: vm.journeyDetails.schemes[0].schemeType
          }
        } else {
          vm.dataForReviewScreen.additionalData.amount = vm.journeyDetails.amount;
          vm.dataForReviewScreen.timeInMonths = vm.journeyDetails.timeInMonths;
          delete vm.dataForReviewScreen.additionalData.basket;

          if (vm.journey === 'RISK_JOURNEY') {
            vm.dataForReviewScreen.riskAppetite = vm.journeyDetails.riskAppetite;
          }
        }
        sessionStorage.setItem('reviewDataFromGoalJourney', JSON.stringify(vm.dataForReviewScreen));
        sessionStorage.setItem('journeyDraftId', vm.journeyId);
        if (vm.investorType === 'NEW') {
          vm.routeRedirect = true;
          if (vm.journeyDetails.basket) {
            $state.go('preLoginBasket.investNow',{
              basketId: vm.journeyDetails.basketDetails.basketId,
              journey: vm.journey
            });
          } else {
            $state.go('preLoginBasket.investNowScheme',{
              journey: vm.journey
            });
          }
        } else {
          var success = function(resp) {
            if (resp === "SELECT_NEW") {
              proceedToFolioSelection();
            } else {
              vm.routeRedirect = true;
              if (vm.journeyDetails.basket) {
                $state.go('preLoginBasket.investNow',{
                  basketId: vm.journeyDetails.basketDetails.basketId,
                  journey: vm.journey
                });
              } else {
                $state.go('preLoginBasket.investNowScheme',{
                  journey: vm.journey
                });
              }
            }
          }, error = function() {};
          ModalService.fillFolioDetailsModal({
            text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
            journey:  vm.journey,
            isFromPostLogin: false
          }, success, error);
        }
      } else if (vm.journey === 'INVESTMENT_BASKET_JOURNEY') {

        if (vm.investorType === 'NEW') {
          sessionStorage.removeItem("folioSelected");
          saveDetails(vm.journeyDetails.basketDetails.basketId, vm.journeyDetails.basketDetails.basketName);
        } else {
          var success = function (resp) {
            if (resp === "SELECT_NEW") {
              sessionStorage.setItem('folioSelectedForNewFolio', false);
              proceedToFolioSelection(vm.journeyDetails.basketDetails.basketId, vm.journeyDetails.basketDetails.basketName);
            } else {
              selectExistingFolio(vm.journeyDetails.basketDetails.basketId, vm.journeyDetails.basketDetails.basketName);
            }
          }, error = function () {
          };
          ModalService.folioChoiceModal({
            isFromPostLogin: false
          }, success, error);
        }
      } else if (vm.journey === 'RISK_JOURNEY') {

        if (vm.investorType === 'NEW') {
          sessionStorage.removeItem("folioSelected");
          redirectToInvestNow();
        } else {
          var success = function (resp) {
            if (resp === "SELECT_NEW") {
              sessionStorage.setItem('folioSelectedForNewFolio', false);
              proceedToFolioSelection(vm.journeyDetails.basketDetails.basketId, vm.journeyDetails.basketDetails.basketName);
            } else {
              var success = function(resp) {
                if (resp === "SELECT_NEW") {
                  sessionStorage.setItem('folioSelectedForNewFolio', true);
                  proceedToFolioSelectionRisk();
                } else {
                  sessionStorage.removeItem("folioSelected");
                  sessionStorage.setItem('folioSelectedForNewFolio', false);
                  redirectToInvestNow();
                }
              }, error = function() {
                decideStateAndJourney();
              };
              ModalService.fillFolioDetailsModal({
                text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
                journey:  vm.journey,
                isFromPostLogin: false,
                isCheckJourneyFromPreLogin: true
              }, success, error);
            }
          }, error = function () {
          };
          ModalService.folioChoiceModal({
            isFromPostLogin: false
          }, success, error);
        }
        /*var success = function(resp) {
          if (resp === "SELECT_NEW") {
            proceedToFolioSelectionRisk();
          } else {
            sessionStorage.removeItem("folioSelected");
            redirectToInvestNow();
          }
        }, error = function() {
        };
        ModalService.fillFolioDetailsModal({
          text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
          journey:  vm.journey,
          isFromPostLogin: false
        }, success, error);*/
      }
    }

    function selectExistingFolio(basketId, basketName) {
      var success = function (resp) {
        if (resp === "SELECT_NEW") {
          sessionStorage.setItem('folioSelectedForNewFolio', true);
          proceedToFolioSelectionBasket(vm.journeyDetails.basketDetails.basketId, vm.journeyDetails.basketDetails.basketName);
        } else {
          sessionStorage.removeItem("folioSelected");
          sessionStorage.setItem('folioSelectedForNewFolio', false);
          saveDetails(basketId, basketName);
        }
      }, error = function () {
        decideStateAndJourney();
      };
      ModalService.fillFolioDetailsModal({
        text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
        journey: AppConstants.JOURNEY.INVESTMENT_BASKET_JOURNEY,
        isFromPostLogin: false,
        isCheckJourneyFromPreLogin: true
      }, success, error);
    }

    function getDetails() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        vm.journeyDetails = resp.data;
        if(vm.journeyDetails.journey === 'GOAL_JOURNEY' && vm.journeyDetails.goalName === 'Children & Education'){
          vm.journeyDetails.minor = true;
        }else{
          vm.journeyDetails.minor = false;
        }
        vm.retirementSchemeExists = vm.journeyDetails.retirementSchemeExists;
        sessionStorage.setItem('journeyDraftId', vm.journeyDetails.id);
        sessionStorage.setItem('pd', encodeURI(JSON.stringify({
          "panNumber": vm.journeyDetails.panNumber
        })));

        var token = AuthService.getToken();
        token.nriFlag = vm.journeyDetails.nriFlag;
        AuthService.setToken(token);

        decideStateAndJourney();
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: "investment",
        child2: 'basket',
        child3: 'getDetails',
        child4: vm.journeyId
      }).$promise.then(success, error);
    }

    function proceedToFolioSelection() {
      var success = function(resp) {
        vm.folioNumber = resp;
        // vm.dataForReviewScreen.folio = vm.folioNumber;
        sessionStorage.setItem("folioSelected", vm.folioNumber);
        // sessionStorage.setItem('reviewDataFromGoalJourney', JSON.stringify(vm.dataForReviewScreen))
        vm.routeRedirect = true;
        if (vm.journeyDetails.basket) {
          $state.go('preLoginBasket.investNow',{
            basketId: vm.journeyDetails.basketDetails.basketId,
            journey: vm.journey
          });
        } else {
          $state.go('preLoginBasket.investNowScheme',{
            journey: vm.journey
          });
        }
      }, error = function() {
        decideStateAndJourney()
      };
      ModalService.selectFolioModal({
        journey:  vm.journey,
        minor : vm.journeyDetails.minor,
        retirementFlag: vm.retirementSchemeExists,
        nriFlag : vm.journeyDetails.nriFlag
      }, success, error);
    }

    function saveDetails(basketId, basketName) {
      var identifierData = AuthService.getToken();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          sessionStorage.setItem('investNowBackUrl', 'main.investment.basket');
          sessionStorage.setItem('investNowBackParams', JSON.stringify({}));
          sessionStorage.setItem("journeyDraftId", resp.data.id);
          $state.go('preLoginBasket.investNow',{
            basketId: vm.journeyDetails.basketDetails.basketId,
            journey: vm.journey
          });
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err)
      }

      LoaderService.showLoader();

      var requestBody = {
        "panNumber": identifierData.investorPAN,
        "journey": "INVESTMENT_BASKET_JOURNEY",
        "step": "FIRST",
        "basket": true,
        "basketDetails": {
          "basketId": basketId,
          "basketName": basketName
        }
      }
      // var journeyDraftId = sessionStorage.getItem("journeyDraftId");
      // if(journeyDraftId){
      // requestBody.id = journeyDraftId;
      // }

      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'saveDetails'
      }, requestBody).$promise.then(success, error);
    }

    function proceedToFolioSelectionBasket(basketId, basketName) {
      var success = function (resp) {
        vm.folioNumber = resp;
        sessionStorage.setItem("folioSelected", vm.folioNumber);
        saveDetails(basketId, basketName);
      }, error = function () {
        decideStateAndJourney()
      };
      ModalService.selectFolioModal({
        journey: AppConstants.JOURNEY.INVESTMENT_BASKET_JOURNEY,
        retirementFlag: vm.retirementSchemeExists
      }, success, error);
    }

    function proceedToFolioSelectionRisk() {
      var success = function(resp) {
        vm.folioNumber = resp;
        sessionStorage.setItem("folioSelected", vm.folioNumber);
        redirectToInvestNow();
      }, error = function() {
      };
      ModalService.selectFolioModal({
        journey:  AppConstants.JOURNEY.RISK_JOURNEY,
        retirementFlag: vm.retirementSchemeExists
      }, success, error);
    }

    function redirectToInvestNow(){
      sessionStorage.setItem('investNowBackUrl','main.investment.personality');
      sessionStorage.setItem('investNowBackParams',JSON.stringify({}));
      $state.go('preLoginBasket.investNow',{
        basketId: vm.journeyDetails.basketDetails.basketId,
        journey: 'PERSONALITY'
      });
    }

    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        if (!token) {
          $state.go('login');
          resetFlag();
          return;
        }

        if (token && token.refresh_token) {
          AuthService.getRefreshToken(token).then(function () {
            if(localStorage.getItem('doLogOut')){
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                ModalService.logoutSuccess();
                $state.go('login');
              }, function () {
                ModalService.logoutSuccess();
                $state.go('login');
              });
            }else{
              $state.reload();
              resetFlag();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            $state.go('login');
            resetFlag();
          });
        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          $state.go('login');
        }
      });

      var resetFlag = function () {
        $timeout(function () {
          isRefreshing = false;
        }, 2000);
      };

      scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in removeListeners) {
          if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
            removeListeners[key]();
          }
        }
      });

    }
  }
})();

/**
 * Created by ttn on 30/11/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('GoalsController', GoalsController);

  /** @ngInject */
  function GoalsController($window, $stateParams, AppConstants, MessageService, LoaderService, UtilService, InvestmentBasketService, $rootScope, ModalService, $state, AuthService, InvestmentModel, $timeout, HDFC_API) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.isShown = false;
    vm.isReview = false;
    vm.appConstants = AppConstants;
    vm.activeTab = {};
    vm.questionModelData = InvestmentModel.getGoalPayload() || [];
    vm.goalsList = null;
    vm.questionsList = null;
    vm.fetchQuestions = fetchQuestions;
    vm.goToRecommendation = goToRecommendation;
    vm.changeStep = changeStep;
    vm.goToBack = goToBack;
    vm.evaluatePersonality = evaluatePersonality;
    vm.startInvesting = startInvesting;
    vm.changeInput = changeInput;
    vm.changeRange = changeRange;
    vm.showSuggestion = showSuggestion;
    vm.startInvestingInScheme = startInvestingInScheme;
    vm.bindChangeAction = bindChangeAction;
    vm.convertToLocalString = convertToLocalString;
    vm.suggestionScreenEnabled = false;
    vm.showRiskProfileSection = false;
    vm.checkDisable = {};
    vm.symbolCheck = [];
    vm.formData = {};
    vm.allSteps = [
      {
        id : 0,
        name : 'Select Goal',
        completed : false
      },
      {
        id : 1,
        name : 'Calculate',
        completed :false
      },
      {
        id : 2,
        name : 'Review & Invest',
        completed : false
      }
     ];
    vm.allGoalsList = null;
    vm.questionData = null;
    vm.init = init;
    vm.showInfoGoal = false;
    vm.Math = Math;
    vm.parseInt = parseInt;
    //vm.disclaimer = AppConstants.INVESTMENT_BASKET.DISCLAIMER;

    init();
    vm.showQuestionaire = showQuestionaire;
    vm.token = AuthService.getToken();
    vm.editBasket = editBasket;
    vm.isEdit = false;
    vm.TRANSACTION_TYPE = AppConstants.INVESTMENT_BASKET.TRANSACTION_TYPE;
    vm.editSchemeAmount = editSchemeAmount;
    vm.changeBasketName = changeBasketName;
    vm.resetBasketDetails = resetBasketDetails;
    vm.basketForm = {};
    vm.editAllSchemeSumAmount = null;
    vm.schemeAmountError = false;
    vm.editBasketDetailsSaved = false;

    if ($stateParams && $stateParams.goalName) {
      vm.goalName = $stateParams.goalName;
      vm.goalName = vm.goalName.replaceAll("-", " ");
      vm.subTitle = "Plan for your holidays and travel."
    }

    vm.isFromPreLogin = $stateParams.fromPreLogin;



    function showQuestionaire(selectedData){
      vm.isShown = true;
      vm.formData.goalId = selectedData.goalId;
      vm.formData.goalCategory = selectedData.goalCategory;
      vm.formData.goalName = selectedData.goalName == 'My Home' ? selectedData.goalName: selectedData.goalName == 'My Nest (Home)' ? 'My Home' : selectedData.goalName;
      var goalSelected = vm.appConstants.INVESTMENT_BASKET.GOAL_VALUE_IN_MONTHS.filter(function(goal) {
        return goal.goalCategory === selectedData.goalCategory;
      })[0];
      vm.GOALS_WITH_MONTH_VALUE = {};
      if (goalSelected) {
        vm.GOALS_WITH_MONTH_VALUE = goalSelected;
      }
      var nameUpdated = vm.formData.goalCategory;
      switch (nameUpdated) {
        case 'TRAVEL' :
          vm.activeTab = {1:true};
          break;
        case 'RETIREMENT' :
          vm.activeTab = {2 : true};
          break;
        case 'CHILD_EDUCATION' :
          vm.activeTab = {3 : true};
          break;
        case 'WEALTH_CREATION' :
          vm.activeTab = {4 : true};
          break;
        case 'TAX_PLANNING' :
          vm.activeTab = {5 : true};
          break;
        case 'REGULAR_INCOME' :
          vm.activeTab = {6 : true};
          break;
        case 'MY_NEST' :
          vm.activeTab = {7:true};
          break;
        case 'EMERGENCY_CORPUS' :
          vm.activeTab = {8 : true};
          break;
        default :
          vm.activeTab = {1 : true};
      }
      // vm.allSteps[0].completed = false;
      // vm.allSteps[1].completed = true;
      fetchQuestions(vm.formData.goalId);
      vm.stepId = 1
      changeStep(vm.stepId);
    }

    function init() {
      $window.scrollTo(0, 0);
      sessionStorage.removeItem('FolioCreated');
      sessionStorage.removeItem('transactionSuccess');
      LoaderService.showLoader();
      if (sessionStorage.getItem('investNowBackParams')) {
        vm.token = AuthService.getToken();
        vm.formData.goalId = JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')).goalId;
        vm.formData.goalName = JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')).goalName;
        vm.formData.riskProfiler = JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')).riskProfiler;
        vm.showRiskProfileSection = JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')).showRisk;
        vm.formData.goalCategory = JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')).goalCategory;
        vm.journeyId = sessionStorage.getItem('journeyDraftId') ? sessionStorage.getItem('journeyDraftId') : null;
        getAllGoals(function () {});
        var goalSelected = vm.appConstants.INVESTMENT_BASKET.GOAL_VALUE_IN_MONTHS.filter(function(goal) {
          return goal.goalName === vm.formData.goalName;
        })[0];
        vm.GOALS_WITH_MONTH_VALUE = {};
        if (goalSelected) {
          vm.GOALS_WITH_MONTH_VALUE = goalSelected;
        }
        fetchQuestions(vm.formData.goalId);
        fetchRiskAppetites();
        goToRecommendation(true, vm.journeyId);
        if(sessionStorage.getItem('isEvaluated') === 'true') {
          vm.investorRiskProfile = vm.formData.riskProfiler;
        }
      } else {
        InvestmentModel.resetPayloadFolio();
        localStorage.removeItem('folioId');
        sessionStorage.removeItem('reviewDataFromGoalJourney');
        vm.allSteps[0].completed = true;
        $rootScope.$emit('updateTitle');
        //getDetails();
        getAllGoals(function() {
          if ($stateParams.goalId) {
            var selectedGoal = vm.goalsList.filter(function(goal) {
              return goal.goalId === $stateParams.goalId;
            });
            vm.investorRiskProfile = sessionStorage.getItem('USER_APPETITE');
            showQuestionaire(selectedGoal[0]);
          }
        });
        changeStep();
      }
      sessionStorage.removeItem('cgfFlagFromGoalJourney');
      var successHandler = function(resp) {
        if(resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey !== undefined) {
          vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Goal_Journey.content;
        }
      };
      UtilService.fetchDynamicData("INVESTMENT_BASKET").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function getDetails(id) {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        vm.journeyDetails = resp.data;
        vm.isBasketCustomized = vm.journeyDetails && vm.journeyDetails.isBasketCustomized || false;
        if (sessionStorage.getItem('investNowBackParams')) {
          prefillData();
          submitBtnHandler();
        }
        showSuggestion();
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: "investment",
        child2: 'basket',
        child3: 'getDetails',
        child4: id
      }).$promise.then(success, error);
    }

    function getAllGoals(cb){
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.goalsList = resp.data.goalDetailDTOList;
          vm.goalsList.sort(function(a, b) {
            var keyA = a.sequence, keyB = b.sequence;
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
          cb();
        }
        else {
          vm.goalsList = null;
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        vm.goalsList = null;
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: 'goal',
        child2: 'getAllGoals'
      }).$promise.then(success, error);
    }

    function fetchQuestions(goalId) {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.questionData = resp.data;
          vm.questionsList = vm.questionData.goalQuestions;
          vm.questionsList.sort(function(a, b) {
            var keyA = a.sequence, keyB = b.sequence;
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
          vm.riskAppetite = vm.questionData.riskAppetiteQues;
          initializeDataForModel();
          if(vm.appConstants.LONG_TERM_GOAL.includes(vm.formData.goalName)){
            fetchRiskAppetites()
          }
        }
        else {
          vm.questionsList = null;
          vm.questionData = null;
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        vm.questionsList = null;
        vm.questionData = null;
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: 'goal',
        child2: 'getGoalDetails',
        child3:  goalId
      }).$promise.then(success, error);
    }

    function goToRecommendation(fromBack, journeyId) {
      if(fromBack) {
        getDetails(journeyId);
      } else {
        saveDetails();
      }
      // vm.allSteps[0].completed = false;
      // vm.allSteps[1].completed = false;
      // vm.allSteps[2].completed = true;
      // fetchRiskAppetites();
    }

    function changeStep(stepId , stepName, from){
      sessionStorage.removeItem('investNowBackParams');
      if(stepId == 0){
        if(vm.formData.goalId){
          vm.allSteps[0].completed = true;
          vm.allSteps[1].completed = false;
          vm.allSteps[2].completed = false;
          vm.isShown = false;
          vm.isReview = false;
          vm.questionModelData = [];
          vm.symbolCheck = [];
          vm.showRiskProfileSection = false;
          vm.isEdit = false;
          vm.editAllSchemeSumAmount = null;
          vm.schemeAmountError = false;
        }
      }else if(stepId == 1){
        if(vm.formData.goalId){
          vm.allSteps[0].completed = false;
          vm.allSteps[1].completed = true;
          vm.allSteps[2].completed = false;
          vm.isShown = true;
          vm.isReview = false;
        }
        bindChangeAction();
        vm.isEdit = false;
        vm.resetBasketDetails();
        vm.editAllSchemeSumAmount = null;
        vm.schemeAmountError = false;
      }else {
        if(vm.formData.goalId && vm.isReview){
          vm.allSteps[0].completed = false;
          vm.allSteps[1].completed = false;
          vm.allSteps[2].completed = true;
          vm.isShown = false;
          vm.isReview = true;
        }
      }
      if(!vm.isShown && !vm.isReview && (vm.allSteps[0].completed && !vm.allSteps[1].completed && !vm.allSteps[2].completed && !vm.formData.goalId)){
        vm.checkDisable = {1 : true, 2 : true};
      }else if(vm.isShown && !vm.isReview && (!vm.allSteps[0].completed && vm.allSteps[1].completed && !vm.allSteps[2].completed)){
        vm.checkDisable = {2 : true};
      }else if(!vm.isShown && !vm.isReview && (vm.allSteps[0].completed && !vm.allSteps[1].completed && !vm.allSteps[2].completed && vm.formData.goalId)){
        vm.checkDisable = {2: true};
      }

      if (stepName === 'Select Goal') {
        vm.formData.goalId = null;
        vm.allSteps[0].completed = true;
        vm.checkDisable = {1 : true, 2 : true};
      }
      if (from === 'USER_ACTION') {
        if (stepName !== 'Calculate') {
          vm.investorRiskProfile = null;
        }
        sessionStorage.removeItem('USER_APPETITE');
      }
    }

    function goToBack(){
      if(vm.allSteps[1].completed){
        vm.allSteps[0].completed = true;
        vm.allSteps[1].completed = false;
        vm.allSteps[2].completed = false;
        vm.isShown = false;
      }
      vm.formData.goalId = null;
      vm.questionModelData = [];
      vm.symbolCheck = [];
      vm.showRiskProfileSection = false;
      vm.checkDisable = {1 : true, 2 : true};
    }

    function fetchRiskAppetites() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.riskProfileOptions = resp.data.allRiskAppetites;
          if (vm.questionData.goalName !== 'Retirement') {
            vm.showRiskProfileSection = true;
          } else {
            checkForAgeDifference();
          }
          defaultRiskProfile(vm.riskProfileOptions);
        }
        else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: 'risk',
        child2: 'getRiskAppetites'
      }).$promise.then(success, error);
    }

    function evaluatePersonality() {
      InvestmentModel.setGoalPayload(vm.questionModelData);
      $state.go('main.investment.personality', {
        journey: 'GOAL_JOURNEY',
        goalId: vm.formData.goalId
      });
    }

    function showModal() {
      var success = function(resp) {
        if (resp) {
          vm.isEvaluated = true;
          getInvestorRiskAppetite();
        }
      }, error = function(err) {
        MessageService.error(err.message);
      };
      ModalService.investmentPersonality({
        questionAndAnswer: vm.investmentPersonalityQuestion
      }, success, error);
    }

    function getInvestorRiskAppetite() {
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status && response.data) {
          vm.isEvaluated = true;
          vm.formData.riskProfiler = response.data.riskAppetiteDetails.riskAppetite;
        } else {
          vm.isEvaluated = false;
          MessageService.error(response.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: 'investment',
        child2: 'basket',
        child3: 'getInvestorRiskAppetite'
      }).$promise.then(success, error);
    }

    function startInvesting(isBasketCustomized) {

      var goalPayload = getPayload();
      vm.containRetirementScheme = UtilService.checkForRetirementScheme(vm.suggestionData.basketDetails.schemesInBasket);
      vm.dataForReviewScreen = {
        "goalName" : vm.formData.goalName,
        "additionalData" : vm.suggestionData,
        "goalId" : goalPayload.goalId,
        "goalQuesAndAnsSet" : goalPayload.goalQuestionDetailSet,
        "timeInMonths" : vm.suggestionData.timeInMonths,
        "riskProfiler" : vm.formData.riskProfiler,
        "showRisk" : sessionStorage.getItem('investNowBackParams') ? JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney')).showRisk : vm.showRiskProfileSection,
        "goalCategory": vm.formData.goalCategory,
        "isBasketCustomized": vm.showReset ? true : false
      };

      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();

        var success = function(resp) {
          vm.editBasketDetailsSaved = vm.showReset ? true: false;
          if (resp === "SELECT_NEW") {
            proceedToFolioSelection('basket');
          } else {
            sessionStorage.setItem('reviewDataFromGoalJourney', JSON.stringify(vm.dataForReviewScreen));
            sessionStorage.removeItem("folioSelected");
            if (vm.isFromPreLogin) {
              $state.go('preLoginBasket.review');
            } else {
              sessionStorage.setItem('investNowBackUrl', 'main.investment.goals');
              sessionStorage.setItem('investNowBackParams', angular.toJson({ showGoalSuggestion: true }));
              $state.go('main.investment.investNow',{
                basketId: vm.suggestionData.basketDetails.basketId,
                retirementFlag: vm.containRetirementScheme === true ? true : null,
                journey: 'GOAL_JOURNEY'
              });
            }

          }
        }, error = function() {
        };

        if (resp.status && resp.data) {
          sessionStorage.setItem('journeyDraftId', resp.data.id);
          /*getDetails(resp.data.id);*/   // Comment the getDetail() because it is getting called unnessarly
          ModalService.fillFolioDetailsModal({
            text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
            journey: AppConstants.JOURNEY.GOAL_JOURNEY,
            isFromPostLogin: true
          }, success, error);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };

      var payload = {
        "id" : vm.journeyDetails.id,
        "panNumber" : vm.journeyDetails.panNumber,
        "journey" : vm.journeyDetails.journey,
        "step": "FIRST",
        "goalId" : goalPayload.goalId,
        "goalQuesAndAnsSet" : goalPayload.goalQuestionDetailSet,
        "amount" : vm.suggestionData.amount,
        "transactionType": vm.suggestionData.transactionType
      }

      if (vm.suggestionData.basketDetails) {
        payload.basketDetails = {
          "basketId": vm.suggestionData.basketDetails.basketId,
          "basketName": vm.recommendedBasketName,
          "schemesInBasket": vm.suggestionData.basketDetails.schemesInBasket.map(function (scheme) {
            return {
              "schemeCode": scheme.schemeCode,
              "schemeName": scheme.schemeName,
              "schemeType": scheme.schemeType,
              "amount": scheme.initialAmount
            }
          })
        }
        payload.basket = true;
      }

      if(isBasketCustomized && vm.showReset) {
        payload.isBasketCustomized = true;
        payload.customizedBasketDetails = {
          "totalAmount": vm.editAllSchemeSumAmount ? vm.editAllSchemeSumAmount : vm.suggestionData.amount,
          "basketName": vm.customBasketName,
          "schemesInBasket": vm.basketData.schemesInBasket.map(function(scheme) {
            return {
              "schemeCode": scheme.schemeCode,
              "schemeName": scheme.schemeName,
              "schemeType": scheme.schemeType,
              "amount": scheme.customSchemeAmount
            }
          })
        }
      }

      if(goalPayload && goalPayload.riskAppetite){
        payload.riskAppetite = goalPayload.riskAppetite;
      }

      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'saveDetails'
      }, payload).$promise.then(success, error);
    }

    function changeInput(step, id, questionType) {
      for(var i = 0; i < vm.questionModelData.length; i++){
        if(step){
          if(vm.questionModelData[i].id == id){
            if(vm.questionModelData[i].measurement !== "INR" && typeof step == "string"){
              step = parseInt(step);
            }
            if(vm.questionModelData[i].inputRange || vm.questionModelData[i].displayValue){
              /*if(step < Math.floor(vm.questionsList[i].defaultValue/12)){
                if(vm.questionModelData[i].minValue && (vm.questionModelData[i].minValue > step)){
                  //vm.questionModelData[i].inputRange = vm.questionModelData[i].minValue;
                }else {
                  vm.questionModelData[i].inputRange = step;
                }
                break;
              }else {

              }*/
              if (vm.questionModelData[i].measurement !== "INR") {
                if (vm.questionModelData[i].measurement == "MONTHS" && vm.questionModelData[i].minValue >= 12) {
                  vm.questionModelData[i].inputRange = step * 12;
                  vm.questionModelData[i].displayValue = step;
                  changeRange(step, vm.questionModelData[i].id, 'input');
                } else if (vm.questionModelData[i].measurement == "MONTHS" && vm.questionModelData[i].minValue < 12) {
                  if (vm.formData.goalCategory === vm.GOALS_WITH_MONTH_VALUE.goalCategory && vm.questionModelData[i].questionType === vm.GOALS_WITH_MONTH_VALUE.questionType) {
                    vm.questionModelData[i].inputRange = step;
                    vm.questionModelData[i].displayValue = step;
                    changeRange(step, vm.questionModelData[i].id, 'input');
                  } else {
                    vm.questionModelData[i].inputRange = vm.questionModelData[i].measurement == "MONTHS" && step > 12 ? Math.ceil(step/12) * 12 : step;
                    vm.questionModelData[i].displayValue = vm.questionModelData[i].measurement == "MONTHS" && step >= 12 ? Math.ceil(step/12) : step;
                    changeRange(step, vm.questionModelData[i].id, 'input');
                  }
                } else if(vm.questionModelData[i].measurement === "YEARS") {
                  vm.questionModelData[i].inputRange = step;
                } else if (vm.questionModelData[i].measurement === "PERCENTAGE") {
                  vm.questionModelData[i].inputRange = step;
                  vm.questionModelData[i].rangeValue = step;
                }
              } else {
                vm.questionModelData[i].inputRange = (parseInt(step.toString().replaceAll(",", "")) || '').toLocaleString('en-IN');
              }
              break;
            }else {
              vm.questionModelData[i].inputRange = step;
            }
          }
        }else {
          if(vm.questionModelData[i].id == id){
            if (vm.questionModelData[i].measurement == "MONTHS") {
              vm.questionModelData[i].inputRange = 0;
            }
          }
        }
      }
      if(vm.formData.goalCategory == "MY_NEST"){
        changeDefaultInput(questionType)
      }

      if (vm.formData.goalCategory === 'RETIREMENT') {
        vm.showRiskProfileSection = false;
        var ageArr = [];
        vm.questionModelData.forEach(function (el) {
          if (el.questionType === 'AGE' && el.inputRange) {
            ageArr.push({
              'key' : 'age',
              'value' : el.inputRange
            })
          }

          if (el.questionType === 'RETIREMENT_AGE' && el.inputRange) {
            ageArr.push({
              'key' : 'retireAge',
              'value' : el.inputRange
            })
          }
        });

        if (ageArr.length === 2) {
          checkAgeDifference(ageArr);
        }
      }

      updateSymbolType();
      submitBtnHandler();
      if (ageArr && ageArr.length === 2) {
        checkAgeValidation(ageArr);
      }
    }

    function checkAgeDifference(ageArr) {
      var diff = ageArr[1].value - ageArr[0].value;
      if (diff > 3) {
        vm.showRiskProfileSection = true;
      } else {
        vm.showRiskProfileSection = false;
      }
    }

    function checkAgeValidation(ageArr) {
      if (ageArr[0].value >= ageArr[1].value) {
        vm.isBtnDisable = true;
      }
    }

    function initializeDataForModel() {
      if (vm.questionModelData.length === 0) {
        for(var i = 0; i < vm.questionsList.length; i++){
          if(vm.questionsList[i].defaultValue){
            if(vm.questionsList[i].minValue && vm.questionsList[i].maxValue && (vm.questionsList[i].measurement == "YEARS" || vm.questionsList[i].measurement == "MONTHS")){
              vm.questionModelData.push({
                inputRange : vm.questionsList[i].defaultValue,
                id : vm.questionsList[i].id,
                questionType : vm.questionsList[i].questionType ? vm.questionsList[i].questionType : null,
                minValue : vm.questionsList[i].minValue,
                maxValue : vm.questionsList[i].maxValue,
                questionName : vm.questionsList[i].questionName,
                measurement : vm.questionsList[i].measurement ? vm.questionsList[i].measurement : null,
                displayValue: vm.questionsList[i].defaultValue > 11 && vm.formData.goalCategory !== 'TRAVEL' ? Math.floor(vm.questionsList[i].defaultValue/12) : vm.questionsList[i].defaultValue,
                rangeValue: vm.questionsList[i].defaultValue,
                maxValueInWords: {},
                minValueInWords: {}
              });
            } else if (vm.questionsList[i].questionType == "INFLATION" || vm.questionsList[i].questionType == "WITHDRAWAL_RATE") {
              vm.questionModelData.push({
                inputRange : vm.questionsList[i].defaultValue,
                id : vm.questionsList[i].id,
                questionType : vm.questionsList[i].questionType ? vm.questionsList[i].questionType : null,
                minValue : vm.questionsList[i].minValue,
                maxValue : vm.questionsList[i].maxValue,
                questionName : vm.questionsList[i].questionName,
                measurement : vm.questionsList[i].measurement ? vm.questionsList[i].measurement : null,
                rangeValue: vm.questionsList[i].defaultValue,
                maxValueInWords: {},
                minValueInWords: {}
              });
            }else{
              vm.questionModelData.push({
                inputRange : parseInt(vm.questionsList[i].defaultValue.toString().replaceAll(",", "")).toLocaleString('en-IN'),
                id : vm.questionsList[i].id,
                questionType : vm.questionsList[i].questionType ? vm.questionsList[i].questionType : null,
                minValue : vm.questionsList[i].minValue ? vm.questionsList[i].minValue : null,
                maxValue : vm.questionsList[i].maxValue ? vm.questionsList[i].maxValue : null,
                questionName : vm.questionsList[i].questionName,
                measurement : vm.questionsList[i].measurement ? vm.questionsList[i].measurement : null,
                maxValueInWords: {},
                minValueInWords: {}
              });
            }
          }else {
            vm.questionModelData.push({
              inputRange : null,
              id : vm.questionsList[i].id,
              questionType : vm.questionsList[i].questionType ? vm.questionsList[i].questionType : null,
              questionName : vm.questionsList[i].questionName,
              minValue : vm.questionsList[i].minValue ? vm.questionsList[i].minValue : null,
              maxValue : vm.questionsList[i].maxValue ? vm.questionsList[i].maxValue : null,
              measurement : vm.questionsList[i].measurement ? vm.questionsList[i].measurement : null,
              maxValueInWords: {},
              minValueInWords: {}
            });
          }
          $window.NumToWord(vm.questionModelData[i].maxValue, 'displayInWordsForGoalsForMaxValue', vm.questionModelData[i].maxValueInWords);
          $window.NumToWord(vm.questionModelData[i].minValue, 'displayInWordsForGoalsForMinValue', vm.questionModelData[i].minValueInWords);
        }
      }
      if (vm.formData.goalCategory == "MY_NEST") {
        var inputValue = null;
        for(var i = 0; i < vm.questionModelData.length; i++) {
          if(vm.questionModelData[i].questionType == "COST_HOME" && vm.questionModelData[i].inputRange){
            inputValue = parseInt(vm.questionModelData[i].inputRange.toString().replaceAll(",", ""));
            break;
          }
        }
        for(var j = 0; j < vm.questionModelData.length; j++) {
          if(vm.questionModelData[j].questionType == "PV"){
            if(inputValue){
              var calculatedValue = (inputValue * 0.2).toFixed(0);
              if(parseInt(calculatedValue) > 0){
                vm.questionModelData[j].inputRange = parseInt(calculatedValue.toString().replaceAll(",", "")).toLocaleString('en-IN');
              }else{
                vm.questionModelData[j].inputRange = null;
              }
            }else{
              vm.questionModelData[j].inputRange = null;
            }
          }
        }
      }
      checkForSymbol();
      submitBtnHandler();
      bindChangeAction();
    }

    function submitBtnHandler(){
      for(var i = 0; i < vm.questionModelData.length; i++){
        if(vm.questionModelData[i].inputRange) {
          if (vm.questionModelData[i].minValue && parseInt(vm.questionModelData[i].inputRange.toString().replaceAll(",", "")) < vm.questionModelData[i].minValue) {
            vm.isBtnDisable = true;
            break;
          } else if (vm.questionModelData[i].maxValue && parseInt(vm.questionModelData[i].inputRange.toString().replaceAll(",", "")) > vm.questionModelData[i].maxValue) {
            vm.isBtnDisable = true;
            break;
          }else if(vm.formData.goalCategory == 'MY_NEST' && vm.questionModelData[i].questionType == 'PV' &&
            (parseInt(vm.questionModelData[0].inputRange.toString().replaceAll(",", "")) < parseInt(vm.questionModelData[1].inputRange.toString().replaceAll(",", ""))) &&
            (parseInt(vm.questionModelData[i].inputRange.toString().replaceAll(",", "")) <= vm.questionModelData[i].maxValue)){
            vm.isBtnDisable = true;
            break;
          } else {
            vm.isBtnDisable = false;
          }
          getPayload();
        }else {
           return  vm.isBtnDisable = true;
        }
      }
    }

    function getPayload() {
      var payload = {};
      if(vm.formData.riskProfiler && vm.showRiskProfileSection){
        payload = {
          goalId : vm.formData.goalId,
          riskAppetite : vm.formData.riskProfiler,
          goalQuestionDetailSet : []
        }
      }else {
        payload = {
          goalId : vm.formData.goalId,
          goalQuestionDetailSet : []
        }
      }
      if (sessionStorage.getItem('investNowBackParams')) {
        var data = JSON.parse(sessionStorage.getItem('reviewDataFromGoalJourney'));
        payload.goalId = data.goalId;
        payload.goalQuestionDetailSet = data.goalQuesAndAnsSet;
        if(data.riskProfiler && data.showRisk){
          payload.riskAppetite = vm.formData.riskProfiler;
        }else {
          delete payload.riskAppetite;
        }
      } else {
        for(var i = 0; i < vm.questionModelData.length; i++){
          if(vm.questionModelData[i].measurement == "MONTHS"){
            payload.goalQuestionDetailSet.push({
              questionId : vm.questionModelData[i].id,
              answer : vm.questionModelData[i].inputRange > 12 ? Math.floor(vm.questionModelData[i].inputRange/12) * 12 : vm.questionModelData[i].inputRange,
              questionType : vm.questionModelData[i].questionType
            });
          } else if (vm.questionModelData[i].measurement == "INR") {
            if (vm.questionModelData[i].inputRange) {
              payload.goalQuestionDetailSet.push({
                questionId : vm.questionModelData[i].id,
                answer : parseInt(vm.questionModelData[i].inputRange.toString().replaceAll(",", "")),
                questionType : vm.questionModelData[i].questionType
              });
            }
          } else {
            payload.goalQuestionDetailSet.push({
              questionId : vm.questionModelData[i].id,
              answer : vm.questionModelData[i].inputRange,
              questionType : vm.questionModelData[i].questionType
            });
          }
        }
        if(vm.formData.riskProfiler && vm.showRiskProfileSection) {
          payload.riskAppetite = vm.formData.riskProfiler;
        }
      }
      return payload;
    }

    function showSuggestion() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.suggestionScreenEnabled = true;
          vm.basketData = resp.data.basketDetails ? resp.data.basketDetails : null;
          vm.recommendedBasketName = resp.data.basketDetails ? resp.data.basketDetails.basketName : '';
          vm.customBasketName = vm.journeyDetails && vm.journeyDetails.customizedBasketDetails ? vm.journeyDetails.customizedBasketDetails.basketName : resp.data.suggestedBasketName ? resp.data.suggestedBasketName : null;
          vm.schemesInBasket  = vm.isBasketCustomized && vm.journeyDetails ? vm.journeyDetails.customizedBasketDetails.schemesInBasket : vm.basketData ? vm.basketData.schemesInBasket : null;
          if(vm.isBasketCustomized && vm.journeyDetails && vm.journeyDetails.customizedBasketDetails) {
            vm.basketData.schemesInBasket = vm.journeyDetails.customizedBasketDetails.schemesInBasket;
            vm.showReset = true;
            vm.isEditBasketName = true;
          }
          if (vm.formData.goalId && vm.suggestionScreenEnabled) {
            if (vm.schemesInBasket) {
              var sum = 0;
              vm.basketData.schemesInBasket.sort(function (b, a) { return a.allocation - b.allocation; });
              vm.basketData.schemesInBasket.forEach(function (scheme, index) {
                if(!vm.isBasketCustomized) {
                  if (vm.basketData.schemesInBasket.length - 1 !== index) {
                    scheme.amount = Math.round((resp.data.amount * scheme.allocation) / 100);
                    sum += scheme.amount;
                  } else {
                    scheme.amount = resp.data.amount - sum;
                  }
                } else {
                  scheme.amount = (scheme.amount).toFixed(2);
                  var floatValue = parseFloat(scheme.amount);
                  var typeConvertedAmt = Math.floor(floatValue);
                  vm.editAllSchemeSumAmount += typeConvertedAmt ? typeConvertedAmt : 0;
                }

                var fundType = scheme.direct ? 'direct' : 'regular';
                scheme.fundUrl = HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + scheme.linkUrl + '/' + fundType;
                scheme.customSchemeAmount = Math.floor(parseFloat(scheme.amount));
                scheme.customSchemeAmountDisplay = parseInt(scheme.amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
                scheme.initialAmount = vm.journeyDetails && vm.journeyDetails.isBasketCustomized ? vm.journeyDetails.basketDetails.schemesInBasket[index].amount : resp.data.basketDetails.schemesInBasket[index].amount;
                if(vm.isBasketCustomized && vm.journeyDetails && vm.journeyDetails.customizedBasketDetails) {
                  if(!vm.journeyDetails.basketDetails.schemesInBasket[index].customSchemeAmountDisplay && !vm.journeyDetails.basketDetails.schemesInBasket[index].customSchemeAmount) {
                    var customAmount = angular.copy(vm.journeyDetails.basketDetails.schemesInBasket[index].amount);
                    vm.journeyDetails.basketDetails.schemesInBasket[index].customSchemeAmountDisplay = parseInt(customAmount.toString().replaceAll(",", "")).toLocaleString('en-IN');
                    vm.journeyDetails.basketDetails.schemesInBasket[index].customSchemeAmount = parseInt(customAmount.toString().replaceAll(",", ""));
                  }
                }
              });
            }
            vm.isReview = true;
            vm.allSteps[0].completed = false;
            vm.allSteps[1].completed = false;
            vm.allSteps[2].completed = true;
          }else {
            vm.isReview = false;
            vm.allSteps[0].completed = false;
            vm.allSteps[1].completed = true;
            vm.allSteps[2].completed = false;
          }
          vm.suggestionData = resp.data;
          vm.schemesList = resp.data.schemes ? resp.data.schemes : null;
          if (vm.schemesList) {
            vm.schemesList.forEach(function(scheme, index) {
              if (scheme.schemeType === 'ELSS') {
                scheme.sequence = vm.schemesList.length;
              } else {
                scheme.sequence = index;
              }
              var fundType = scheme.direct ? 'direct' : 'regular';
              scheme.fundUrl = HDFC_API.CORPORATE_URL + 'product-solutions/overview/' + scheme.linkUrl + '/' + fundType;
            });
            vm.schemesList.sort(function(a, b) {
              var keyA = a.sequence, keyB = b.sequence;
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            if (vm.formData.goalCategory === 'TAX_PLANNING') {
              var schemesList = vm.schemesList.filter(function (scheme) {
                return scheme.schemeType === 'ELSS';
              });
              vm.schemesList = schemesList.length > 0 ? schemesList : null;
            }
          }
          vm.copyBasketData = vm.isBasketCustomized && vm.journeyDetails ? angular.copy(vm.journeyDetails.basketDetails) : angular.copy(vm.basketData);
          if(vm.basketData && vm.basketData.schemesInBasket) {
            getValidations();
          }
        } else {
          vm.suggestionScreenEnabled = false;
          vm.suggestionData = null;
          vm.schemesList = null
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        vm.suggestionScreenEnabled = false;
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var payload = getPayload();
      if(vm.journeyDetails.panNumber) {
        payload.panNumber = vm.journeyDetails.panNumber;
      }
      InvestmentBasketService.post({
        child1: 'goal',
        child2: 'getSuggestion'
      }, payload).$promise.then(success, error);
    }

    function defaultRiskProfile(riskOptions) {
      if (vm.investorRiskProfile) {
        vm.formData.riskProfiler = vm.investorRiskProfile;
        sessionStorage.setItem('isEvaluated', true);
        return;
      }
      var defaultRiskOption = riskOptions.find(function (data) {
        if(data.value == "Moderate"){
          return data;
        }
      });
      vm.formData.riskProfiler = defaultRiskOption.name;
    }

    function startInvestingInScheme(schemeData){

      var goalPayload = getPayload();
      vm.containRetirementScheme = schemeData.retirementFlag;
      vm.dataForReviewScreen = {
        "goalName" : vm.formData.goalName,
        "transactionType" : vm.suggestionData.transactionType,
        "amount" : schemeData.amount,
        "schemeDetails" : schemeData,
        "goalId" : goalPayload.goalId,
        "goalQuesAndAnsSet" : goalPayload.goalQuestionDetailSet,
        "additionalData" : vm.suggestionData,
        "goalCategory": vm.formData.goalCategory
      };

      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();

        var success = function(resp) {
          if (resp === "SELECT_NEW") {
            proceedToFolioSelection('scheme');
          } else {
            sessionStorage.setItem('reviewDataFromGoalJourney', JSON.stringify(vm.dataForReviewScreen));
            sessionStorage.removeItem("folioSelected");
            if (vm.isFromPreLogin) {
              $state.go('preLoginBasket.folioCreation');
            } else {
              sessionStorage.setItem('investNowBackUrl', 'main.investment.goals');
              sessionStorage.setItem('investNowBackParams', angular.toJson({ showGoalSuggestion: true }));
              $state.go('main.investment.investNowScheme',{
                retirementFlag: vm.containRetirementScheme === true ? true : null,
                journey: 'GOAL_JOURNEY'
              });
            }
          }
        }, error = function() {
        };

        if (resp.status && resp.data) {
          sessionStorage.setItem('journeyDraftId', resp.data.id);
          getDetails(resp.data.id);
          ModalService.fillFolioDetailsModal({
            text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
            journey: AppConstants.JOURNEY.GOAL_JOURNEY,
            isFromPostLogin: true
          }, success, error);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };

      var payload = {
        "id" : vm.journeyDetails.id,
        "panNumber" : vm.journeyDetails.panNumber,
        "journey" : vm.journeyDetails.journey,
        "step": "FIRST",
        "goalId" : goalPayload.goalId,
        "goalQuesAndAnsSet" : goalPayload.goalQuestionDetailSet,
        "amount" : schemeData.amount,
        "timeInMonths": vm.suggestionData.timeInMonths,
        "transactionType": vm.suggestionData.transactionType
      };

      if (vm.suggestionData.schemes) {
        payload.schemes = [schemeData];
      }

      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'saveDetails'
      }, payload).$promise.then(success, error);
    }

    function proceedToFolioSelection(type) {
      var success = function(resp) {
        vm.folioNumber = resp;
        vm.dataForReviewScreen.folio = vm.folioNumber;
        // vm.dataForReviewScreen.folio = 14418490;
        sessionStorage.setItem("folioSelected", vm.folioNumber);
        // localStorage.setItem("folioSelected", 14418490);
        sessionStorage.setItem('reviewDataFromGoalJourney', JSON.stringify(vm.dataForReviewScreen));
        if (vm.isFromPreLogin) {
          $state.go('preLoginBasket.review');
        } else {

          if (type === 'basket') {
            sessionStorage.setItem('investNowBackUrl', 'main.investment.goals');
            sessionStorage.setItem('investNowBackParams', angular.toJson({ showGoalSuggestion: true }));
            $state.go('main.investment.investNow',{
              basketId: vm.suggestionData.basketDetails.basketId,
              retirementFlag: vm.containRetirementScheme === true ? true : null,
              journey: 'GOAL_JOURNEY'
            });
          } else {
            sessionStorage.setItem('investNowBackUrl', 'main.investment.goals');
            sessionStorage.setItem('investNowBackParams', angular.toJson({ showGoalSuggestion: true }));
            $state.go('main.investment.investNowScheme',{
              retirementFlag: vm.containRetirementScheme === true ? true : null,
              journey: 'GOAL_JOURNEY'
            });
          }
        }
      }, error = function() {
        startInvesting(vm.editBasketDetailsSaved);
      };
      ModalService.selectFolioModal({
        journey:  AppConstants.JOURNEY.GOAL_JOURNEY,
        minor : vm.questionData.minor,
        retirementFlag: vm.containRetirementScheme
      }, success, error);
    }

    function changeDefaultInput(questionType) {
      var inputValue = null;
      for(var i = 0; i < vm.questionModelData.length; i++){
        if(vm.questionModelData[i].questionType == "COST_HOME" && vm.questionModelData[i].inputRange){
          inputValue = parseInt(vm.questionModelData[i].inputRange.toString().replaceAll(",", ""));
          break;
        }
      }
      for(var j = 0; j < vm.questionModelData.length; j++){
        if(vm.questionModelData[j].questionType == "PV" && (questionType && questionType !== "PV")){
          if(inputValue){
            var calculatedValue = (inputValue * 0.2).toFixed(0);
            if(parseInt(calculatedValue) > 0){
                vm.questionModelData[j].inputRange = parseInt(calculatedValue.toString().replaceAll(",", "")).toLocaleString('en-IN');
            }else{
              vm.questionModelData[j].inputRange = null;
            }
          }else{
            vm.questionModelData[j].inputRange = null;
          }
        }
      }
    }

    function checkForSymbol(){
      for(var i = 0; i < vm.questionModelData.length; i++){
        if(!vm.appConstants.QUESTION_TYPE_EXCLUDING_RUPEE.includes(vm.questionModelData[i].questionType)){
          if(vm.questionModelData[i].measurement == "INR" && vm.questionModelData[i].questionType !== "EXPENSE_MONTHS"){
            vm.symbolCheck.push({
              rupeeSymbol : true
            })
          }else {
            vm.symbolCheck.push({
              rupeeSymbol : false
            })
          }
        }
        if(vm.questionModelData[i].questionType && (vm.questionModelData[i].questionType == 'TIME' || vm.questionModelData[i].questionType == 'AGE' || vm.questionModelData[i].questionType == 'LIFE_EXPECTANCY' || vm.questionModelData[i].questionType == 'RETIREMENT_AGE' || vm.questionModelData[i].questionType == "EXPENSE_MONTHS")){
          if(vm.questionModelData[i].inputRange){
            vm.symbolCheck.push({
              yearSymbol : true
            })
          }else {
            vm.symbolCheck.push({
              yearSymbol : false
            })
          }
        }
        if(vm.questionModelData[i].questionType && (vm.questionModelData[i].questionType == 'INFLATION' || vm.questionModelData[i].questionType == 'WITHDRAWAL_RATE')){
          if(vm.questionModelData[i].inputRange){
            vm.symbolCheck.push({
              percentSymbol : true
            })
          }else {
            vm.symbolCheck.push({
              percentSymbol : false
            })
          }
        }
      }
    }

    function updateSymbolType() {
      for(var i = 0; i < vm.questionModelData.length; i++){
        if(!vm.appConstants.QUESTION_TYPE_EXCLUDING_RUPEE.includes(vm.questionModelData[i].questionType)){
          vm.symbolCheck[i].rupeeSymbol = true;
        }
        if(vm.questionModelData[i].questionType && (vm.questionModelData[i].questionType == 'TIME' || vm.questionModelData[i].questionType == 'AGE' || vm.questionModelData[i].questionType == 'LIFE_EXPECTANCY' || vm.questionModelData[i].questionType == 'RETIREMENT_AGE' || vm.questionModelData[i].questionType == 'EXPENSE_MONTH')){
          if(vm.questionModelData[i].inputRange){
            vm.symbolCheck[i].yearSymbol = true;
          }else {
            vm.symbolCheck[i].yearSymbol = false;
          }
        }
        if(vm.questionModelData[i].questionType && (vm.questionModelData[i].questionType == 'INFLATION' || vm.questionModelData[i].questionType == 'WITHDRAWAL_RATE')){
          if(vm.questionModelData[i].inputRange){
            vm.symbolCheck[i].percentSymbol = true;
          }else {
            vm.symbolCheck[i].percentSymbol = false;
          }
        }
      }
    }


    function saveDetails() {

      var goalPayload = getPayload();

      var finalPaylaod = {
        "panNumber" : vm.token.investorPAN,
        "journey" : "GOAL_JOURNEY",
        "step" : "FIRST" ,
        "goalId" : goalPayload.goalId,
        "goalQuesAndAnsSet" : goalPayload.goalQuestionDetailSet
      };
      if(goalPayload && goalPayload.riskAppetite) {
        finalPaylaod.riskAppetite = goalPayload.riskAppetite;
      }

      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          sessionStorage.setItem('journeyDraftId', resp.data.id);
          getDetails(resp.data.id);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };

      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'saveDetails'
      }, finalPaylaod).$promise.then(success, error);
    }

    function convertBackToMonth(inputRange) {
      var convertedValue = null;
      if(inputRange == 1){
        convertedValue = inputRange * 12;
        return convertedValue;
      }else if(inputRange < 1){
        convertedValue = (inputRange - Math.floor(inputRange))*10;
        return convertedValue;
      }else if(inputRange > 1){
        if(inputRange % 1 !== 0){
          var floorValue = Math.floor(inputRange);
          var decimalValue = (inputRange - Math.floor(inputRange))*10;
          convertedValue = floorValue * 12 + decimalValue;
          return convertedValue;
        }else {
          convertedValue = inputRange * 12;
          return convertedValue;
        }
      }
    }

    function bindChangeAction() {
      $timeout(function() {
        var element = angular.element($window.document.querySelectorAll('#range-selector'));
        element.on("input change", function(event) {
          changeRange(event.currentTarget.value, event.currentTarget.dataset.elemid, 'sliders');
        });
      });
    }

    function performEditAction(event) {
      var dataset = event.currentTarget.dataset;
      var enteredValue = parseInt(event.currentTarget.innerText.trim());
      for(var i = 0; i < vm.questionModelData.length; i++) {
        if (vm.questionModelData[i].measurement == 'MONTHS') {
          vm.questionModelData[i].inputRange = enteredValue;
        }
      }
    }

    function convertToLocalString(number) {
      if (number) {
        return parseInt(number).toLocaleString("en-IN");
      }
    }

    function changeRange(step, id, from) {
      for(var i = 0; i < vm.questionModelData.length; i++) {
        if (step) {
          if (vm.questionModelData[i].id == id) {
            var step = parseInt(step);
            if (vm.questionModelData[i].measurement == "MONTHS" && vm.questionModelData[i].minValue >= 12) {
              if (from !== 'sliders') {
                vm.questionModelData[i].inputRange = step * 12;
                vm.questionModelData[i].displayValue = step;
                vm.questionModelData[i].rangeValue = step * 12;
              } else {
                vm.questionModelData[i].inputRange = vm.questionModelData[i].measurement == "MONTHS" && step > 12 ? Math.ceil(step/12) * 12 : step;
                vm.questionModelData[i].displayValue = vm.questionModelData[i].measurement == "MONTHS" && step >= 12 ? Math.ceil(step/12) : step;
                vm.questionModelData[i].rangeValue = Math.ceil(step/12) * 12;
              }
            } else if (vm.questionModelData[i].measurement == "MONTHS" && vm.questionModelData[i].minValue < 12) {
              if (vm.formData.goalCategory === vm.GOALS_WITH_MONTH_VALUE.goalCategory && vm.questionModelData[i].questionType === vm.GOALS_WITH_MONTH_VALUE.questionType) {
                vm.questionModelData[i].inputRange = step;
                vm.questionModelData[i].displayValue = step;
                vm.questionModelData[i].rangeValue = step;
              } else {
                vm.questionModelData[i].inputRange = vm.questionModelData[i].measurement == "MONTHS" && step > 12 ? Math.ceil(step/12) * 12 : step;
                vm.questionModelData[i].displayValue = vm.questionModelData[i].measurement == "MONTHS" && step >= 12 ? Math.ceil(step/12) : step;
                vm.questionModelData[i].rangeValue = vm.questionModelData[i].measurement == "MONTHS" && step > 12 ? Math.ceil(step/12) * 12 : step;
              }
            } else if (vm.questionModelData[i].measurement == "PERCENTAGE") {
              vm.questionModelData[i].inputRange = step;
              vm.questionModelData[i].rangeValue = step;
            }
          }
        }
        updateSymbolType();
        submitBtnHandler();
      }
    }

    function prefillData() {
      for(var i=0; i<vm.journeyDetails.goalQuesAndAnsSet.length; i++) {
        for(var j=0; j< vm.questionModelData.length; j++) {
          if(vm.questionModelData[j].id === vm.journeyDetails.goalQuesAndAnsSet[i].questionId) {
            vm.questionModelData[j].inputRange = vm.journeyDetails.goalQuesAndAnsSet[i].answer;
          }
        }
      }
    }

    function checkForAgeDifference() {
      vm.showRiskProfileSection = false;
      var ageArr = [];
      vm.questionModelData.forEach(function (el) {
        if (el.questionType === 'AGE' && el.inputRange) {
          ageArr.push({
            'key' : 'age',
            'value' : el.inputRange
          })
        }

        if (el.questionType === 'RETIREMENT_AGE' && el.inputRange) {
          ageArr.push({
            'key' : 'retireAge',
            'value' : el.inputRange
          })
        }
      });

      if (ageArr.length === 2) {
        checkAgeDifference(ageArr);
      }
    }

    function editBasket(editValue) {
      vm.isEdit = !editValue;
      vm.disableFields = compareBasketAmount();
      vm.basketData.basketName = vm.customBasketName && vm.customBasketName.length > 0 ? angular.copy(vm.customBasketName): vm.basketData.basketName;
      vm.showReset = true;
      if (vm.isEdit) {
        vm.isEditBasketName = true;
      } else {
        checkValidation();
        vm.isBasketCustomized = true;
        vm.isEditBasketName = false;
      }
    }

    function changeBasketName(name) {
      vm.customBasketName = name;
    }

    function editSchemeAmount(scheme) {
      if (!scheme) {
        return;
      }
      if (scheme.customSchemeAmountDisplay) {
        scheme.customSchemeAmountDisplay = parseInt(scheme.customSchemeAmountDisplay.toString().replaceAll(",", "")).toLocaleString('en-IN');
        scheme.customSchemeAmount = parseInt(scheme.customSchemeAmountDisplay.toString().replaceAll(",", ""));
        scheme.amount = Math.floor(parseFloat(scheme.customSchemeAmount));
        if (scheme.minAmount > scheme.amount) {
          scheme.errorMsg = 'Minimum amount should be ₹' + scheme.minAmount;
        } else if ((scheme.amount % scheme.multiplesOf) != 0) {
          scheme.errorMsg = 'Please provide amount in multiples of ₹' + scheme.multiplesOf;
        } else if (scheme.maxSipAmount && (scheme.customSchemeAmount >= scheme.maxSipAmount)) {
          scheme.errorMsg = AppConstants.ToastrMessage.VALIDATE_DATA.AMOUNT_EXCEEDED;
        } else {
          scheme.errorMsg = null;
        }
      } else {
        scheme.customSchemeAmount = null;
        scheme.customSchemeAmountDisplay = null;
        scheme.errorMsg = 'Minimum amount should be ₹' + scheme.minAmount;
        // vm.isEditBasketName = false;
      }
      if (vm.isEdit === true) { //executed on save button click and on amount change in scheme level
        vm.formData.amount = null;
        var schemeError = [];
        vm.editAllSchemeSumAmount = null;
        vm.basketData.schemesInBasket.forEach(function(scheme) {
          vm.editAllSchemeSumAmount += scheme.customSchemeAmount ? scheme.customSchemeAmount : 0;
          if(angular.isUndefined(scheme.errorMsg) || scheme.errorMsg === null) {
            schemeError.push(false);
          } else {
            schemeError.push(true);
          }
        });
        vm.schemeAmountError = schemeError.includes(true);
      }
    }

    function compareBasketAmount() {
      var exactValue = [];
      vm.basketData.schemesInBasket.forEach(function(scheme, index) {
        if (vm.copyBasketData.schemesInBasket[index].schemeCode === scheme.schemeCode) {
          if (parseInt(vm.copyBasketData.schemesInBasket[index].amount, 10) == scheme.customSchemeAmount) {
            exactValue.push(false);
          } else {
            exactValue.push(true);
          }
        }
      });
      vm.isAmountEdited = exactValue.includes(true);
      return vm.isAmountEdited;
    }

    function resetBasketDetails() {
      vm.basketData = angular.copy(vm.copyBasketData);
      vm.isEdit = false;
      vm.showReset = false;
      vm.isEditBasketName = false;
      vm.customBasketName = vm.journeyDetails.suggestedBasketName;
      vm.editAllSchemeSumAmount = null;
      vm.editBasketDetailsSaved = false;
      vm.basketData.basketName = vm.recommendedBasketName;
      vm.isBasketCustomized = false;
      vm.schemeAmountError = false;
      checkValidation();
    }

    function getValidations() {
      vm.schemeCodes = vm.basketData.schemesInBasket.map(function (scheme) { return scheme.schemeCode });
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.validations = resp.data.validationDTOMap;
          checkValidation();
        }
      }, error = function (err) {
        MessageService.error(err);
      };

      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'validate',
        child4: 'schemes'
      },
      {
        "schemeCodes": vm.schemeCodes,
        "transactionType": vm.suggestionData.transactionType
      }).$promise.then(success, error);
    }

    function checkValidation() {
      if (vm.suggestionData.transactionType == vm.TRANSACTION_TYPE.SIP) {
        vm.formData.frequency = "OM";
        vm.basketData.schemesInBasket.forEach(function (scheme) {
          scheme.maxSipAmount = vm.validations[scheme.schemeCode].monMaxAmt;
          var newValidation = vm.validations[scheme.schemeCode].additionalValidation.OM;
          var lowerMinAmt = Infinity;
          for (var i = 0; i < newValidation.length; i++) {
            if (newValidation[i].hasOwnProperty('min_amount_lower') && newValidation[i].min_amount_lower < lowerMinAmt) {
              lowerMinAmt = newValidation[i].min_amount_lower;
              scheme.minAmount = lowerMinAmt;
              scheme.multiplesOf = newValidation[i].amt_multiples;
            }
          }
        });

      } else {
        vm.basketData.schemesInBasket.forEach(function (scheme) {
          scheme.multiplesOf = vm.validations[scheme.schemeCode].purchaseMultiple || 1;
          if (!vm.validations[scheme.schemeCode].addlPurchase) {
            scheme.isPurchaseMin = vm.validations[scheme.schemeCode].minFirstPurchaseAmt > vm.formData.amount;
            scheme.minAmount = vm.validations[scheme.schemeCode].minFirstPurchaseAmt;
          } else {
            scheme.isPurchaseMin = vm.validations[scheme.schemeCode].minAddlPurchaseAmt > vm.formData.amount;
            scheme.minAmount = vm.validations[scheme.schemeCode].minAddlPurchaseAmt;
          }
        });
      }
    }

  }
})();

/**
 * Created by ttn on 26/12/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioController', folioController);

  /** @ngInject */
  function folioController($state , InvestmentModel , $rootScope, $window, LoaderService, InvestmentBasketService, UtilService , InvestorServiceV3 , AuthService , AppConstants ,  ModalService , MessageService, $scope , $stateParams ,  NewInvestorServiceV3, InvestorService) {
    var vm = this;
    vm.showBasicDownIcon = true;
    vm.showincomeDownIcon = true;
    vm.showholderDownIcon = true;
    vm.shownomineeDownIcon = true;
    vm.showbankDownIcon = true;
    vm.enableBtn = false;
    vm.showSaveButton = true;
    vm.journey = $stateParams.journey;
    vm.retirement = $stateParams.retirement === 'true' ? true : false;
    vm.fromPreLogin = false;
    vm.arnCartSave = arnCartSave;
    vm.receivedData = {
      folioForUser: 'Self',
      folioHoldingMode: 'Single'
    };
    var identifierData = AuthService.getToken();
    vm.panNumber = identifierData.investorPAN;

    if(localStorage.getItem("distributorDetails")) {
      vm.linkdata = $window.JSON.parse(localStorage.getItem("distributorDetails"));
    } else if(sessionStorage.getItem("distributorDetails")){
      vm.linkdata = $window.JSON.parse(sessionStorage.getItem("distributorDetails"));
    }

    var removeListeners = {};
    sessionStorage.removeItem('contactUpdateCo');


    // handling down up button icon change
    vm.downIconClick = function(id) {
      switch (id) {
        case 'basicDetails':
          vm.showBasicDownIcon = false;
          break;
        case 'incomeDetails':
          vm.showincomeDownIcon = false;
          break;
        case 'guardianDetails':
          vm.showincomeGuardianDownIcon = false;
          break;
        case 'holderDetails':
          vm.showholderDownIcon = false;
          break;
        case 'nomineeDetails':
          vm.shownomineeDownIcon = false;
          break;
        case 'bankDetails':
          vm.showbankDownIcon = false;
          break;
      }
    };

    vm.upIconClick = function(id) {
      switch (id) {
        case 'basicDetails':
          vm.showBasicDownIcon = true;
          break;
        case 'incomeDetails':
          vm.showincomeDownIcon = true;
          break;
        case 'guardianDetails':
          vm.showincomeGuardianDownIcon = false;
          break
        case 'holderDetails':
          vm.showholderDownIcon = true;
          break;
        case 'nomineeDetails':
          vm.shownomineeDownIcon = true;
          break;
        case 'bankDetails':
          vm.showbankDownIcon = true;
          break;
      }
    };

    // initial ui view set
    angular.element($window.document.querySelector("#basicDetails")).addClass("in");
    vm.downIconClick("basicDetails");

    vm.showIncomeGuardian = false;
    vm.showHolder = false;
    vm.showNominee = false;
    vm.showBank = false;

    // handling save actions
    vm.saveBasic = true;
    vm.saveIncomeGuardian = false;
    vm.saveHolder = false;
    vm.saveNominee = false;
    vm.saveBank = false;
    vm.isEditing = false;
    $window.scrollTo(0, 0);



    removeListeners['buttonEnable'] = $scope.$on("buttonEnable", function() {
      vm.enableBtn = true;
    });

    removeListeners['buttonDisable'] = $scope.$on("buttonDisable", function() {
      vm.enableBtn = false;
    });

    removeListeners['buttonEnableProceed'] = $scope.$on("buttonEnableProceed", function() {
      vm.showSaveButton = false;
    });

    // this is used for enabling edit button from directive
    vm.getStepperInfo = function () {
      vm.stepper = InvestmentModel.getPayload();
    }

    removeListeners['updateHoldMode'] = $scope.$on('updateHoldMode', function (event, result) {
      vm.receivedData = result.data;

      if (vm.receivedData.folioForUser === 'Minor' && result.forFolioChanged) {
        vm.getStepperInfo();
        vm.stepper.FOLIO_CREATION_STEP.income_details_completed = false;
        vm.stepper.FOLIO_CREATION_STEP.holder_details_completed = false;
        vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed = false;
        // vm.stepper.FOLIO_CREATION_STEP.guardian_details_completed = false;
        vm.stepper.FOLIO_CREATION_STEP.bank_details_completed = false;
        vm.showIncomeGuardian = false;
        vm.showHolder = false;
        vm.showNominee = false;
        vm.showBank = false;
        InvestmentModel.setPayload(vm.stepper);
        vm.upIconClick('incomeDetails');
        vm.upIconClick('guardianDetails');
        vm.upIconClick('bankDetails');
      } else if(vm.receivedData.folioForUser === 'Self' && result.forFolioChanged) {
        vm.getStepperInfo();
        vm.stepper.FOLIO_CREATION_STEP.income_details_completed = false;
        vm.stepper.FOLIO_CREATION_STEP.holder_details_completed = false;
        vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed = false;
        // vm.stepper.FOLIO_CREATION_STEP.guardian_details_completed = false;
        vm.stepper.FOLIO_CREATION_STEP.bank_details_completed = false;
        vm.showIncomeGuardian = false;
        vm.showHolder = false;
        vm.showNominee = false;
        vm.showBank = false;
        InvestmentModel.setPayload(vm.stepper);
        vm.upIconClick('incomeDetails');
        vm.upIconClick('guardianDetails');
        vm.upIconClick('bankDetails');
      }

    });


    removeListeners['taxStatusChanged'] = $scope.$on('taxStatusChanged', function (event, result) {
      vm.getStepperInfo();
      vm.stepper.FOLIO_CREATION_STEP.bank_details_completed = false;
      vm.showBank = false;
      InvestmentModel.setPayload(vm.stepper);
      vm.upIconClick('bankDetails');
    });

    //Handling basic details

    vm.handleEditBasicDetails = function () {
      angular.element($window.document.querySelector("#basicDetails")).addClass("in");
      vm.downIconClick("basicDetails");
      vm.showBasic = true;
      vm.getStepperInfo();
      vm.stepper.FOLIO_CREATION_STEP.basic_details_completed = false;
      InvestmentModel.setPayload(vm.stepper);
      $scope.$broadcast('enableEditBasicDetails');

      vm.isEditing = true;

      vm.saveBasic = true;
      vm.saveIncomeGuardian = false;
      vm.saveHolder = false;
      vm.saveNominee = false;
      vm.saveBank = false;

      if (vm.receivedData.folioForUser === 'Self') {

        if (!vm.stepper.FOLIO_CREATION_STEP.income_details_completed) {
          angular.element($window.document.querySelector("#incomeDetails")).removeClass("in");
          vm.upIconClick("incomeDetails");
          vm.showIncomeGuardian = false;
        }

        if (vm.receivedData.folioHoldingMode && !vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
          angular.element($window.document.querySelector("#holderDetails")).removeClass("in");
          vm.upIconClick("holderDetails");
          vm.showHolder = false;
        }

        if (vm.receivedData.folioForUser !== 'Minor' && !vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed) {
          angular.element($window.document.querySelector("#nomineeDetails")).removeClass("in");
          vm.upIconClick("nomineeDetails");
          vm.showNominee = false;
        }

        if (!vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
          angular.element($window.document.querySelector("#bankDetails")).removeClass("in");
          vm.upIconClick("bankDetails");
          vm.showBank = false;
        }
      } else if (vm.receivedData.folioForUser === 'Minor') {
        if (!vm.stepper.FOLIO_CREATION_STEP.guardian_details_completed) {
          angular.element($window.document.querySelector("#incomeDetails")).removeClass("in");
          vm.upIconClick("incomeDetails");
          vm.showIncomeGuardian = false;
        }

        if (vm.receivedData.folioHoldingMode && !vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
          angular.element($window.document.querySelector("#holderDetails")).removeClass("in");
          vm.upIconClick("holderDetails");
          vm.showHolder = false;
        }

        if (vm.receivedData.folioForUser !== 'Minor' && !vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed) {
          angular.element($window.document.querySelector("#nomineeDetails")).removeClass("in");
          vm.upIconClick("nomineeDetails");
          vm.showNominee = false;
        }

        if (!vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
          angular.element($window.document.querySelector("#bankDetails")).removeClass("in");
          vm.upIconClick("bankDetails");
          vm.showBank = false;
        }
      }
      vm.showSaveButton = true;
    }


    //Handing Income details

    vm.handleEditIncomeDetails = function () {
      angular.element($window.document.querySelector("#incomeDetails")).addClass("in");
      vm.downIconClick("incomeDetails");
      vm.showIncomeGuardian = true;
      vm.getStepperInfo();
      vm.stepper.FOLIO_CREATION_STEP.income_details_completed= false;
      InvestmentModel.setPayload(vm.stepper);
      $scope.$broadcast('enableEditIncomeDetail');

      vm.isEditing = true;

      vm.saveBasic = false;
      vm.saveIncomeGuardian = true;
      vm.saveHolder = false;
      vm.saveNominee = false;
      vm.saveBank = false;

      if (!vm.stepper.FOLIO_CREATION_STEP.basic_details_completed) {
        angular.element($window.document.querySelector("#basicDetails")).removeClass("in");
        vm.upIconClick("basicDetails");
        vm.showBasic = false;
      }

      if (vm.receivedData.folioHoldingMode === 'ANY_OR_SURVIVOR' && !vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
        angular.element($window.document.querySelector("#holderDetails")).removeClass("in");
        vm.upIconClick("holderDetails");
        vm.showHolder = false;
      }

      if (vm.receivedData.folioForUser !== 'Minor' && !vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed) {
        angular.element($window.document.querySelector("#nomineeDetails")).removeClass("in");
        vm.upIconClick("nomineeDetails");
        vm.showNominee = false;
      }

      if (!vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
        angular.element($window.document.querySelector("#bankDetails")).removeClass("in");
        vm.upIconClick("bankDetails");
        vm.showBank = false;
      }

      vm.showSaveButton = true;
    }

    //Handling guardian details

    vm.handleEditGuardianIncomeDetails = function () {
      angular.element($window.document.querySelector("#incomeDetails")).addClass("in");
      vm.downIconClick("incomeDetails");
      vm.showIncomeGuardian = true;
      vm.getStepperInfo();
      vm.stepper.FOLIO_CREATION_STEP.guardian_details_completed = false;
      InvestmentModel.setPayload(vm.stepper);
      $scope.$broadcast('enableEditGuardianDetail');

      vm.isEditing = true;


      vm.saveBasic = false;
      vm.saveIncomeGuardian = true;
      vm.saveHolder = false;
      vm.saveNominee = false;
      vm.saveBank = false;

      if (!vm.stepper.FOLIO_CREATION_STEP.basic_details_completed) {
        angular.element($window.document.querySelector("#basicDetails")).removeClass("in");
        vm.upIconClick("basicDetails");
        vm.showBasic = false;
      }

      if (vm.receivedData.folioHoldingMode && !vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
        angular.element($window.document.querySelector("#holderDetails")).removeClass("in");
        vm.upIconClick("holderDetails");
        vm.showHolder = false;
      }

      if (vm.receivedData.folioForUser !== 'Minor' && !vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed) {
        angular.element($window.document.querySelector("#nomineeDetails")).removeClass("in");
        vm.upIconClick("nomineeDetails");
        vm.showNominee = false;
      }

      if (!vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
        angular.element($window.document.querySelector("#bankDetails")).removeClass("in");
        vm.upIconClick("bankDetails");
        vm.showBank = false;
      }

      vm.showSaveButton = true;

    }


    // handling holder
    vm.handleEditHolder = function () {
      angular.element($window.document.querySelector("#holderDetails")).addClass("in");
      vm.downIconClick("holderDetails");
      vm.showHolder = true;
      vm.getStepperInfo();
      vm.stepper.FOLIO_CREATION_STEP.holder_details_completed = false;
      InvestmentModel.setPayload(vm.stepper);
      $scope.$broadcast('enableEditHolder');

      vm.isEditing = true;

      vm.saveBasic = false;
      vm.saveIncomeGuardian = false;
      vm.saveHolder = true;
      vm.saveNominee = false;
      vm.saveBank = false;

      if (!vm.stepper.FOLIO_CREATION_STEP.basic_details_completed) {
        angular.element($window.document.querySelector("#basicDetails")).removeClass("in");
        vm.upIconClick("basicDetails");
        vm.showBasic = false;
      }

      if (vm.receivedData.folioForUser === 'Self') {
        if (!vm.stepper.FOLIO_CREATION_STEP.income_details_completed) {
          angular.element($window.document.querySelector("#incomeDetails")).removeClass("in");
          vm.upIconClick("incomeDetails");
          vm.showIncomeGuardian = false;
        }
      }

      if (vm.receivedData.folioForUser === 'Minor') {
        if (!vm.stepper.FOLIO_CREATION_STEP.guardian_details_completed) {
          angular.element($window.document.querySelector("#incomeDetails")).removeClass("in");
          vm.upIconClick("incomeDetails");
          vm.showIncomeGuardian = false;
        }
      }

      if (vm.receivedData.folioForUser !== 'Minor' && !vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed) {
        angular.element($window.document.querySelector("#nomineeDetails")).removeClass("in");
        vm.upIconClick("nomineeDetails");
        vm.showNominee = false;
      }

      if (!vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
        angular.element($window.document.querySelector("#bankDetails")).removeClass("in");
        vm.upIconClick("bankDetails");
        vm.showBank = false;
      }

      vm.showSaveButton = true;
    }


    // handling edit nominee

    vm.handleEditNominee = function () {
      angular.element($window.document.querySelector("#nomineeDetails")).addClass("in");
      vm.downIconClick("nomineeDetails");
      vm.showNominee = true;
      vm.getStepperInfo();
      vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed = false;
      InvestmentModel.setPayload(vm.stepper);
      $scope.$broadcast('enableEditNominee');
      vm.isEditing = true;

      vm.saveBasic = false;
      vm.saveIncomeGuardian = false;
      vm.saveHolder = false;
      vm.saveNominee = true;
      vm.saveBank = false;

      if (!vm.stepper.FOLIO_CREATION_STEP.basic_details_completed) {
        angular.element($window.document.querySelector("#basicDetails")).removeClass("in");
        vm.upIconClick("basicDetails");
        vm.showBasic = false;
      }

      if (vm.receivedData.folioHoldingMode === 'ANY_OR_SURVIVOR' && !vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
        angular.element($window.document.querySelector("#holderDetails")).removeClass("in");
        vm.upIconClick("holderDetails");
        vm.showHolder = false;
      }

      if (vm.receivedData.folioForUser === 'Self') {
        if (!vm.stepper.FOLIO_CREATION_STEP.income_details_completed) {
          angular.element($window.document.querySelector("#incomeDetails")).removeClass("in");
          vm.upIconClick("incomeDetails");
          vm.showIncomeGuardian = false;
        }
      }

      if (vm.receivedData.folioForUser === 'Minor') {
        if (!vm.stepper.FOLIO_CREATION_STEP.guardian_details_completed) {
          angular.element($window.document.querySelector("#incomeDetails")).removeClass("in");
          vm.upIconClick("incomeDetails");
          vm.showIncomeGuardian = false;
        }
      }

      if (!vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
        angular.element($window.document.querySelector("#bankDetails")).removeClass("in");
        vm.upIconClick("bankDetails");
        vm.showBank = false;
      }
      vm.showSaveButton = true;
    }

    // handling edit bank
    vm.handleEditBank = function () {
      vm.getStepperInfo();
      vm.stepper.FOLIO_CREATION_STEP.bank_details_completed = false;
      InvestmentModel.setPayload(vm.stepper);
      $scope.$broadcast('enableEditBank');
      vm.isEditing = true;
      vm.showSaveButton = true;
    }



    vm.saveData = function () {
      vm.isEditing = false;


      // if(vm.saveBasic) {
      //   continueBasicDetails();
      // } else if(vm.saveIncomeGuardian){
      //   if (vm.receivedData.folioForUser === 'Self') {
      //     continueIncomeDetails();
      //   } else {
      //     continueGuardianIncomeDetails();
      //   }
      // } else if (vm.saveHolder) {
      //   continueHolder();
      // } else if (vm.saveNominee) {
      //   continueNominee();
      // } else if (vm.saveBank) {
      //   contineBankDetails();
      // }
    };


    // function continueBasicDetails() {
    //   $scope.$broadcast('continueButtonBasicDetails');
    // }


    // function continueIncomeDetails() {
    //   $scope.$broadcast('continueButtonIncomeDetails');
    //   // vm.showIncomeGuardian = false;
    // }

    // function continueGuardianIncomeDetails(){
    //   $scope.$broadcast('continueButtonGuardianIncomeDetails');
    //   // vm.showIncomeGuardian = false;
    // }

    // function continueHolder() {
    //   $scope.$broadcast('continueButtonHolder');
    // }


    // function continueNominee() {
    //   $scope.$broadcast('continueButtonNominee');
    // }


    // function contineBankDetails() {
    //   $scope.$broadcast('continueButtonFolio');
    // }

    /*
    * Method to handle action after basic details has been saved
    * */
    vm.proceedToIncomeDetails = function() {
      vm.isEditing = false;
      if (!vm.showIncomeGuardian) {
        vm.showIncomeGuardian = true;
        vm.saveBasic = false;
        vm.saveIncomeGuardian = true;
        vm.saveHolder = false;
        vm.saveNominee = false;
        vm.saveBank = false;
        angular.element($window.document.querySelector("#incomeDetails")).addClass("in");
        vm.downIconClick("incomeDetails");

      } else if (vm.showIncomeGuardian) {
        if (vm.receivedData.folioHoldingMode === 'ANY_OR_SURVIVOR' && !vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
          angular.element($window.document.querySelector("#holderDetails")).addClass("in");
          vm.downIconClick("holderDetails");
          vm.showHolder = true;

          vm.saveBasic = false;
          vm.saveIncomeGuardian = false;
          vm.saveHolder = true;
          vm.saveNominee = false;
          vm.saveBank = false;

        } else if (vm.receivedData.folioForUser !== 'Minor' && !vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed) {
          angular.element($window.document.querySelector("#nomineeDetails")).addClass("in");
          vm.downIconClick("nomineeDetails");
          vm.showNominee = true;

          vm.saveBasic = false;
          vm.saveIncomeGuardian = false;
          vm.saveHolder = false;
          vm.saveNominee = true;
          vm.saveBank = false;

        } else if (!vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
          angular.element($window.document.querySelector("#bankDetails")).addClass("in");
          vm.downIconClick("bankDetails");
          vm.showBank = true;
          vm.saveBasic = false;
          vm.saveIncomeGuardian = false;
          vm.saveHolder = false;
          vm.saveNominee = false;
          vm.saveBank = true;
        }
        vm.showSaveButton = true;
      }
      if (vm.showHolder && vm.receivedData.folioHoldingMode === 'ANY_OR_SURVIVOR' && !vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
        vm.showSaveButton = true;
        vm.enableBtn = false;
      } else if (vm.stepper.FOLIO_CREATION_STEP.bank_details_completed && vm.stepper.FOLIO_CREATION_STEP.income_details_completed) {
        vm.showSaveButton = false;
      }
      if (vm.receivedData.folioForUser === 'Minor' && !vm.stepper.FOLIO_CREATION_STEP.guardian_details_completed) {
        vm.showSaveButton = true;
        vm.enableBtn = false;
      }

      if (vm.receivedData.folioForUser === 'Minor' && vm.stepper.FOLIO_CREATION_STEP.guardian_details_completed && vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
        vm.showSaveButton = false;
      }
    };

    vm.performIncomeDetailsActions = function() {
      vm.isEditing = false;
      if (vm.receivedData.folioHoldingMode === 'ANY_OR_SURVIVOR') {
        if (!vm.showHolder) {
          vm.showHolder = true;
          vm.saveBasic = false;
          vm.saveIncomeGuardian = false;
          vm.saveHolder = true;
          vm.saveNominee = false;
          vm.saveBank = false;
          vm.enableBtn = false;
          angular.element($window.document.querySelector("#holderDetails")).addClass("in");
          vm.downIconClick("holderDetails");
        } else if (vm.showHolder) {

          if (!vm.stepper.FOLIO_CREATION_STEP.basic_details_completed) {
            angular.element($window.document.querySelector("#basicDetails")).addClass("in");
            vm.downIconClick("basicDetails");
            vm.showBasic = true;

            vm.saveBasic = true;
            vm.saveIncomeGuardian = false;
            vm.saveHolder = false;
            vm.saveNominee = false;
            vm.saveBank = false;

          } else if (vm.receivedData.folioForUser !== 'Minor' && !vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed) {
            angular.element($window.document.querySelector("#nomineeDetails")).addClass("in");
            vm.downIconClick("nomineeDetails");
            vm.showNominee = true;

            vm.saveBasic = false;
            vm.saveIncomeGuardian = false;
            vm.saveHolder = false;
            vm.saveNominee = true;
            vm.saveBank = false;

          } else if (!vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
            angular.element($window.document.querySelector("#bankDetails")).addClass("in");
            vm.downIconClick("bankDetails");
            vm.showBank = true;

            vm.saveBasic = false;
            vm.saveIncomeGuardian = false;
            vm.saveHolder = false;
            vm.saveNominee = false;
            vm.saveBank = true;

          } else if (!vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
            angular.element($window.document.querySelector("#holderDetails")).addClass("in");
            vm.downIconClick("holderDetails");
            vm.showHolder = true;
            vm.saveBasic = false;
            vm.saveIncomeGuardian = false;
            vm.saveHolder = true;
            vm.saveNominee = false;
            vm.saveBank = false;
            vm.enableBtn = false;
          }

          vm.showSaveButton = true;
        }

        if (vm.stepper.FOLIO_CREATION_STEP.bank_details_completed && vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
          vm.showSaveButton = false;
        }
        // vm.enableBtn = false;
      } else {
        if (!vm.showNominee) {
          vm.showNominee = true;

          vm.saveBasic = false;
          vm.saveIncomeGuardian = false;
          vm.saveHolder = false
          vm.saveNominee = true;
          vm.saveBank = false;

          angular.element($window.document.querySelector("#nomineeDetails")).addClass("in");
          vm.downIconClick("nomineeDetails");
        } else if (vm.showNominee) {

          if (!vm.stepper.FOLIO_CREATION_STEP.basic_details_completed) {
            angular.element($window.document.querySelector("#basicDetails")).addClass("in");
            vm.downIconClick("basicDetails");
            vm.showBasic = true;

            vm.saveBasic = true;
            vm.saveIncomeGuardian = false;
            vm.saveHolder = false;
            vm.saveNominee = false;
            vm.saveBank = false;

          } else if (vm.receivedData.folioHoldingMode === 'ANY_OR_SURVIVOR' && !vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
            angular.element($window.document.querySelector("#holderDetails")).addClass("in");
            vm.downIconClick("holderDetails");
            vm.showHolder = true;

            vm.saveBasic = false;
            vm.saveIncomeGuardian = false;
            vm.saveHolder = false;
            vm.saveNominee = true;
            vm.saveBank = false;

          } else if (!vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
            angular.element($window.document.querySelector("#bankDetails")).addClass("in");
            vm.downIconClick("bankDetails");
            vm.showBank = true;

            vm.saveBasic = false;
            vm.saveIncomeGuardian = false;
            vm.saveHolder = false;
            vm.saveNominee = false;
            vm.saveBank = true;

          }

          vm.showSaveButton = true;
        }
        // vm.enableBtn = false;

        if (vm.stepper.FOLIO_CREATION_STEP.bank_details_completed && vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed) {
          vm.showSaveButton = false;
        }
      }

    };

    vm.proceedGuardianDetailsActions = function() {
      vm.isEditing = false;
      if (!vm.showBank) {
        vm.showBank = true;


        vm.saveBasic = false;
        vm.saveIncomeGuardian = false;
        vm.saveHolder = false
        vm.saveNominee = false;
        vm.saveBank = true;

        angular.element($window.document.querySelector("#bankDetails")).addClass("in");
        vm.downIconClick("bankDetails");
      } else if (vm.showBank) {

        if (!vm.stepper.FOLIO_CREATION_STEP.basic_details_completed) {
          angular.element($window.document.querySelector("#basicDetails")).addClass("in");
          vm.downIconClick("basicDetails");
          vm.showBasic = true;

          vm.saveBasic = true;
          vm.saveIncomeGuardian = false;
          vm.saveHolder = false;
          vm.saveNominee = false;
          vm.saveBank = false;

        } else if (vm.receivedData.folioHoldingMode === 'ANY_OR_SURVIVOR' && !vm.stepper.FOLIO_CREATION_STEP.holder_details_completed) {
          angular.element($window.document.querySelector("#holderDetails")).addClass("in");
          vm.downIconClick("holderDetails");
          vm.showHolder = true;

          vm.saveBasic = false;
          vm.saveIncomeGuardian = false;
          vm.saveHolder = false;
          vm.saveNominee = true;
          vm.saveBank = false;

        } else if (vm.receivedData.folioForUser !== 'Minor' && !vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed) {
          angular.element($window.document.querySelector("#nomineeDetails")).addClass("in");
          vm.downIconClick("nomineeDetails");
          vm.showNominee = true;

          vm.saveBasic = false;
          vm.saveIncomeGuardian = false;
          vm.saveHolder = false;
          vm.saveNominee = true;
          vm.saveBank = false;

        }
        vm.showSaveButton = true;
      }

      if (vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
        vm.showSaveButton = false;
      }
    }

    vm.performNomineeAction = function() {
      vm.isEditing = false;
      if (!vm.showBank) {
        vm.showBank = true;
        vm.saveBasic = false;
        vm.saveIncomeGuardian = false;
        vm.saveHolder = false
        vm.saveNominee = false;
        vm.saveBank = true;

        angular.element($window.document.querySelector("#bankDetails")).addClass("in");
        vm.downIconClick("bankDetails");
      } else if (vm.showBank) {
        vm.showSaveButton = false;
      }
      // vm.enableBtn = false;
    };

    vm.performHolderAction = function() {
      vm.isEditing = false;
      if (!vm.showNominee) {
        vm.showNominee = true;

        vm.saveBasic = false;
        vm.saveIncomeGuardian = false;
        vm.saveHolder = false
        vm.saveNominee = true;
        vm.saveBank = false;

        angular.element($window.document.querySelector("#nomineeDetails")).addClass("in");
        vm.downIconClick("nomineeDetails");
      } else if (vm.showNominee) {


        if (!vm.stepper.FOLIO_CREATION_STEP.basic_details_completed) {
          angular.element($window.document.querySelector("#basicDetails")).addClass("in");
          vm.downIconClick("basicDetails");
          vm.showBasic = true;

          vm.saveBasic = true;
          vm.saveIncomeGuardian = false;
          vm.saveHolder = false;
          vm.saveNominee = false;
          vm.saveBank = false;

        } else if (!vm.stepper.FOLIO_CREATION_STEP.income_details_completed && !vm.stepper.FOLIO_CREATION_STEP.guardian_details_completed) {

          angular.element($window.document.querySelector("#incomeDetails")).addClass("in");
          vm.downIconClick("incomeDetails");
          vm.showIncomeGuardian = true;

          vm.saveBasic = false;
          vm.saveIncomeGuardian = true;
          vm.saveHolder = false;
          vm.saveNominee = false;
          vm.saveBank = false;

        } else if (!vm.stepper.FOLIO_CREATION_STEP.bank_details_completed) {
          angular.element($window.document.querySelector("#bankDetails")).addClass("in");
          vm.downIconClick("bankDetails");
          vm.showBank = true;

          vm.saveBasic = false;
          vm.saveIncomeGuardian = false;
          vm.saveHolder = false;
          vm.saveNominee = false;
          vm.saveBank = true;

        }

        vm.showSaveButton = true;
      }

      if (vm.stepper.FOLIO_CREATION_STEP.bank_details_completed && vm.stepper.FOLIO_CREATION_STEP.nominee_details_completed) {
        vm.showSaveButton = false;
      }
    }


    vm.performBankAction = function() {
      vm.isEditing = false;
    }

    init();
    function init() {
      vm.fromPreLogin = $stateParams.fromPreLogin;
      var folioCreated = sessionStorage.getItem('FolioCreated') === "true" ? true: false;
      if (folioCreated) {
        if ($stateParams.fromPreLogin) {
          if ($stateParams.journey && $stateParams.journey === 'ECART') {
            $state.go("preLoginEcartJourney.cartReview");
          } else {
            $state.go("preLoginBasket.review");
          }
        } else {
          $state.go("main.investment.review");
        }
      }
      if ($stateParams.existingInvestor) {
        vm.firstFlow = false;
      } else {
         var invType = sessionStorage.getItem('userType');

         if (invType === 'NEW') {
           vm.firstFlow = true;
         } else {
           vm.firstFlow = false;
         }
      }
      var journeyDraftId = sessionStorage.getItem('journeyDraftId');
      var folioSelected = sessionStorage.getItem('folioSelected');
      if (journeyDraftId && angular.isDefined(journeyDraftId)) {
        getDetails(journeyDraftId,folioSelected);
      } else {
        // for other journeys which are not basket , setting initial value to show basic details
        vm.showBasic = true;
        vm.otherJourney = true;
        var invType = sessionStorage.getItem('userType');

        if (invType === 'NEW') {
          vm.firstFlow = true;
        } else {
          vm.firstFlow = false;
        }
      }
    }

    function getDetails(id, folioSelected) {
      LoaderService.showLoader();
      localStorage.removeItem('folioId');
      var success = function(resp) {
        LoaderService.hideLoader();
        vm.journeyDetails = resp.data;
        if (resp.data.folioCreationDraftId) {
          localStorage.setItem('folioId', resp.data.folioCreationDraftId);
        }

        if (folioSelected) {
          fetchFolioData();
        } else {
          vm.showBasic = true;
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: "investment",
        child2: 'basket',
        child3: 'getDetails',
        child4: id
      }).$promise.then(success, error);
    }

    vm.createNewFolio = function () {
      getPayload();
    };

    function initiatecreateNewFolio() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          $window.sessionStorage.setItem("folioNumberFromArn", resp.data.folioNumber);
          if (resp.data.folioDataInvalid) {
            LoaderService.hideLoader();
            ModalService.genericModal({
              text: resp.data.message
            }, function() {
              if (!vm.fromPreLogin) {
                if (vm.journey === "GOAL_JOURNEY") {
                  sessionStorage.removeItem('investNowBackParams');
                  $state.go('main.investment.goals');
                } else if (vm.journey === "INVESTMENT_BASKET_JOURNEY") {
                  $state.go('main.investment.basket');
                } else if (vm.journey === "PERSONALITY") {
                  $state.go('main.investment.personality');
                }
              } else {
                sessionStorage.clear();
                $state.go('login');
              }
            }, function() {
              $state.go('welcome');
            });
            return;
          }
          LoaderService.hideLoader();
          localStorage.removeItem('optOutNominee');
          localStorage.removeItem("wantToAddNomineeLater");
          localStorage.removeItem('minorMode');
          localStorage.removeItem('folioId');
          sessionStorage.removeItem('contactUpdateCo');

          var token = AuthService.getToken();
          if (token && token.investorType &&  vm.reviewFormData.holdmode != "ANY_OR_SURVIVOR") {
            token.investorType = AppConstants.INVESTOR_TYPE.EXISTING;
          }

          AuthService.setToken(token);


          showPopUp(resp.data);


        } else {
          LoaderService.hideLoader();
          if(vm.reviewFormData.holdmode == "ANY_OR_SURVIVOR" ){
            localStorage.removeItem('optOutNominee');
            localStorage.removeItem("wantToAddNomineeLater");
          }
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };

      LoaderService.showLoader();

      var invType = sessionStorage.getItem('userType');
      var payload = {
        id : localStorage.getItem('folioId')
      };
      if (vm.journey === 'ECART') {
        payload.ignoreDraftFolio = true;
        payload.newFolioCreationFlow = true;
        payload.cartFlow = true;
      }
      if (invType === 'NEW') {
        NewInvestorServiceV3.post({child1: 'folio', child2: 'createNew'}, payload).$promise.then(success, error);
      } else {
        InvestorServiceV3.post({child1: 'folio', child2: 'createNew'}, payload).$promise.then(success, error);
      }
    }

    function getPayload(cb) {
      cb = cb || function () {};
      LoaderService.showLoader();
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.reviewFormData = resp.data;
            LoaderService.hideLoader();
            cb(true);
            initiatecreateNewFolio();
          } else {
            MessageService.error(resp.message);
            LoaderService.hideLoader();
            cb(false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };


      var investorId = localStorage.getItem('folioId');
      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'getDetails'
      },{id:investorId}).$promise.then(success, error);
    }

    function showPopUp(data) {
      data.fromOtherJoruney = true;
      data.fromJourney =  AppConstants.JOURNEY.GOAL_JOURNEY;
      // sessionStorage.setItem("folioSelected", data.folioNumber);
      var successModal = function () {
        $window.sessionStorage.removeItem("investorForm");
        if (vm.reviewFormData.holdmode !== "ANY_OR_SURVIVOR") {
          sessionStorage.setItem('FolioCreated', true);
          if (vm.journey === 'ECART') {
            sessionStorage.setItem("folioNumber", data.folioNumber);
            sessionStorage.setItem("minorFlag" , vm.receivedData.folioForUser == 'Minor' ? true : false);
            if(vm.linkdata && vm.linkdata.flowName &&vm.linkdata.flowName == 'E_CART' && data.folioNumber) {
              arnCartSave(data.folioNumber);
            }
            $state.go("preLoginEcartJourney.cartReview");
          } else if ($stateParams.fromPreLogin) {
            $state.go("preLoginBasket.review");
          } else {
            $state.go("main.investment.review");
          }
        } else {
          if ($stateParams.fromPreLogin) {
            $state.go('login');
          } else {
            $state.go('welcome');
          }
        }
      },
      errorModal = function (err) {
        if(err!=null){
          MessageService.error(err)
        }
      };
      data.holdmode = vm.reviewFormData.holdmode;
      data.firstFlow = vm.reviewFormData.newUserFlow ? 'YES' : 'NO';
      data.fromPreLogin = $stateParams.fromPreLogin ? true : false;
      ModalService.folioCreationSuccessModal(data, successModal, errorModal);
    }
    function fetchFolioData() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.selecteFolioData = resp.data;
          vm.showBasic = true;
        } else {
          MessageService.error("Something went wrong")
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err)
      }


      InvestorServiceV3.get({
        child1: 'folio',
        child2: 'getFolioDetails',
        child3: sessionStorage.getItem('folioSelected')
      },{}).$promise.then(success, error)
    }

    function arnCartSave(folioNumber) {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {

        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err);
      };
      var arnPayload = {
        folioNumber: folioNumber ? folioNumber: null,
        linkId: vm.linkdata.chipherText,
      }
      InvestorService.post({
        child1: 'arn',
        child2: 'cart',
        child3: 'save'
      },arnPayload).$promise.then(success, error);
    }
    $scope.$on("$destroy", function() {
      sessionStorage.removeItem('contactUpdateCo');
    });

  }
})();

/**
 * Created by ttn on 02/01/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentInvestNowController', investmentInvestNowController);

  /** @ngInject */
  function investmentInvestNowController($state, $stateParams, $rootScope) {
    var vm = this;
    vm.id = $stateParams.basketId;
    vm.containRetirementScheme = $stateParams.retirementFlag;
    vm.journey = $stateParams.journey;
    vm.isFromPreLogin = $stateParams.fromPreLogin;
    vm.isResetVisible = false;
    vm.resetBasketDetails = resetBasketDetails;
    vm.showReset = showReset;

    function resetBasketDetails() {
      $rootScope.$broadcast('resetBasketDetails', true);
    }

    function showReset(data) {
      vm.isResetVisible = data;
    }
  }
})();

/**
 * Created by ttn on 19/22/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentBasketController', investmentBasketController);

  /** @ngInject */
  function investmentBasketController($state, LoaderService, AuthService, AppConstants, MessageService, InvestmentBasketService, ModalService, InvestmentModel, $window, UtilService) {
    var vm = this;
    vm.imageBaseUrl = "assets/images/icons/investor-basket/";
    vm.basketList = [];
    vm.journeyDetails = null;
    //vm.disclaimer = AppConstants.INVESTMENT_BASKET.DISCLAIMER;
    init();

    function init() {
      $window.scrollTo(0, 0);
      sessionStorage.removeItem('FolioCreated');
      sessionStorage.removeItem('transactionSuccess');
      sessionStorage.removeItem('folioSelected');
      InvestmentModel.resetPayloadFolio();
      getAllBaskets();
      sessionStorage.removeItem('reviewDataFromGoalJourney');
      sessionStorage.removeItem('cgfFlagFromGoalJourney');
      sessionStorage.removeItem('onlyIndividualFolioCreation');
      // getDetails();
      var successHandler = function(resp) {
        if(resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket && resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket !== undefined) {
          vm.disclaimer = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_Investment_Basket.content;
        }
      };
      UtilService.fetchDynamicData("INVESTMENT_BASKET").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function getAllBaskets() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.basketList = resp.data.basketDetailDTOList;
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err)
      }

      LoaderService.showLoader();

      InvestmentBasketService.get({
        child1: 'investment',
        child2: 'basket',
        child3: 'getAllBaskets'
      }).$promise.then(success, error);
    }

    vm.viewDetails = function () {
      $state.go('main.investment.basketView');
    }

    vm.investNow = function (basket) {
      vm.containRetirementScheme = UtilService.checkForRetirementScheme(basket.schemesInBasket);
      var success = function (resp) {
        if (resp === "SELECT_NEW") {
          sessionStorage.setItem('folioSelectedForNewFolio', false);
          proceedToFolioSelection(basket.basketId, basket.basketName);
        } else {
          selectExistingFolio(basket.basketId, basket.basketName);
        }
      }, error = function () {
      };
      ModalService.folioChoiceModal({
        isFromPostLogin: true
      }, success, error);
    };

    function selectExistingFolio(basketId, basketName) {
      var success = function (resp) {
        if (resp === "SELECT_NEW") {
          sessionStorage.setItem('folioSelectedForNewFolio', true);
          proceedToFolioSelection(basketId, basketName);
        } else {
          sessionStorage.removeItem("folioSelected");
          sessionStorage.setItem('folioSelectedForNewFolio', false);
          saveDetails(basketId, basketName);
        }
      }, error = function () {
      };
      ModalService.fillFolioDetailsModal({
        text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
        journey: AppConstants.JOURNEY.INVESTMENT_BASKET_JOURNEY,
        isFromPostLogin: true
      }, success, error);
    }

    function proceedToFolioSelection(basketId, basketName) {
      var success = function (resp) {
        vm.folioNumber = resp;
        sessionStorage.setItem("folioSelected", vm.folioNumber);
        saveDetails(basketId, basketName);
      }, error = function () {
      };
      ModalService.selectFolioModal({
        journey: AppConstants.JOURNEY.INVESTMENT_BASKET_JOURNEY,
        retirementFlag: vm.containRetirementScheme
      }, success, error);
    }

    function saveDetails(basketId, basketName) {
      var identifierData = AuthService.getToken();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          sessionStorage.setItem('investNowBackUrl', 'main.investment.basket');
          sessionStorage.setItem('investNowBackParams', JSON.stringify({}));
          sessionStorage.setItem("journeyDraftId", resp.data.id);
          $state.go('main.investment.investNow',{
            basketId:basketId,
            retirementFlag: vm.containRetirementScheme === true ? true : null,
            journey: 'INVESTMENT_BASKET_JOURNEY'
          });
         }
        }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err)
        }

      LoaderService.showLoader();

      var requestBody = {
        "panNumber": identifierData.investorPAN,
        "journey": "INVESTMENT_BASKET_JOURNEY",
        "step": "FIRST",
        "basket": true,
        "basketDetails": {
          "basketId": basketId,
          "basketName": basketName
        }
      }
      // var journeyDraftId = sessionStorage.getItem("journeyDraftId");
      // if(journeyDraftId){
      // requestBody.id = journeyDraftId;
      // }

      InvestmentBasketService.post({
        child1: 'investment',
        child2: 'basket',
        child3: 'saveDetails'
      }, requestBody).$promise.then(success, error);
    }

    function getDetails() {
      var journeyDraftId = sessionStorage.getItem("journeyDraftId");
      if (!journeyDraftId) {
        return;
      }

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.journeyDetails = resp.data;
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err)
      }

      LoaderService.showLoader();

      InvestmentBasketService.get({
        child1: 'investment',
        child2: 'basket',
        child3: 'getDetails',
        child4: journeyDraftId,
      }).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('sipPurchaseInstaSummary', sipPurchaseInstaSummary);

  /*@ngInject*/
  function sipPurchaseInstaSummary(ModalService, AppConstants, AuthService, moment, $window, $state,
                                   $rootScope, $stateParams, TransactionModel, LoaderService, TransactionService,
                                   MessageService, UtilService, $log, HDFC_API, IIHttpService, NetcoreEvntService,TransactionServiceVersion) {
    return {
      restrict: 'E',
      scope: {formData: '=', isSummaryViewEnabled: '=', transactionType: '@' , notes : '='},
      templateUrl: 'app/instant-investment/summary-directive/sip-purchase-summary.html',
      link: function (scope) {
        scope.billdeskUrl=HDFC_API.BILLDESK_URL;
        scope.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
        scope.investorInfo = {};
        scope.isCheckedTandC = false;
        var Card = $window.Card || {};
        var identifierData = AuthService.getInstaToken();
        scope.investorName = identifierData.name;
        scope.investorInfo.name = identifierData ? identifierData.investorName : '';
        scope.investorEmail = identifierData ? identifierData.email : 'Not Updated';
        scope.investorNumber = identifierData ? identifierData.mobileNumber : 'Not Updated';
        var _isPaymentDone = false;
        scope.isCheckedTandCeMandate = false;
        scope.NAV_APPLICABILITY_NOTE = AppConstants.NAV_APPLICABILITY_NOTE;
        scope.showTerms = true;
        scope.secretLink = localStorage.getItem('QuickInvestmentSecreteLink');
        scope.arnHardcodedData = $window.JSON.parse(localStorage.getItem("distributorDetails"));
        if (scope.formData && scope.formData.emandateDate) {
          scope.formData.emandateDate = moment(scope.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
        }

        if (scope.formData && scope.formData.endDateEmandate) {
          scope.formData.endDateEmandate = moment(scope.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
        }

        if (scope.formData && scope.formData.emandateAmount) {
          scope.emandateAmountDetails = {};
          $window.NumToWord(scope.formData.emandateAmount, 'amountInwordsEmandateSummary',scope.emandateAmountDetails);
          scope.emandateAmountInWords = scope.emandateAmountDetails.amountInWords;
        }

        if (scope.formData && scope.formData.amount) {
          $window.NumToWord(scope.formData.amount, 'amountInwords',scope.formData);
        }


        scope.paymentNavUrl = function () {
          $window.open(HDFC_API.PAYMENT_NAV_URL);
        };

        var successHandler = function(resp) {
          if(scope.transactionType == 'PURCHASE' && !resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General)
          {
              scope.showTerms = false;
          }else if(scope.transactionType == 'SIP' && !resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General_SIP) {
            scope.showTerms = false;
          }
        }

        UtilService.fetchDynamicData("INNER_TNC").then(successHandler).catch(function(resp) {
          MessageService.error(resp)
         });

        /*
            function getInvestorInfo() {
              var success = function (resp) {
                if (resp.status && resp.data) {
                  scope.investorInfo = resp.data;
                } else {
                  scope.investorInfo = null;
                  MessageService.error(resp.message);
                }
              }, error = function (err) {
                UtilService.errorHandler(err);
                scope.investorInfo = null;
              };
              InvestorService.get({
                child1: 'folio',
                child3: 'info'
              }).$promise.then(success, error);
            }
        */

        function showSuccessModal(tid) {


          if (!scope.investorInfo) {
            scope.investorInfo = {};
            MessageService.error('Error while get investor info.');
          }
          var successModal = function(isChecked) {
              TransactionModel.setPayloadRawData(null);
              if (isChecked) {
                favrouiteApi(tid);
              }
              $state.reload();
            },
            errorModal = function() {
              TransactionModel.setPayloadRawData(null);
              $state.reload();
            };

          ModalService.initiateSuccessModal({
            transactionType: scope.transactionType,
            investorName: scope.investorInfo.name
          }, successModal, errorModal);
        }

        function favrouiteApi(tid) {
          var success = function(resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                //MessageService.success(resp.message);
              } else {
                //MessageService.error(resp.message);
              }
            },
            error = function() {
              //   LoaderService.hideLoader();
              // UtilService.errorHandler(err);
            };
          LoaderService.showLoader();
          TransactionService.get({
            controller1: 'makeFavouriteTransaction',
            controller2: tid
          }).$promise.then(success, error);
        }


        function getFinalPayload() {
          var payload = null;
          switch (scope.transactionType) {
            case scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
              payload = getSipPayload();
              break;
          }
          return payload;
        }

        function getSipPayload() {
          var sipPayload = {
            installmentAmount: scope.formData.amount,
            investmentOption: scope.formData.investmentOption,
            dividendOption: scope.formData.dividendOption,
            formType: scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
            euinOpted: (scope.formData.euin && scope.formData.euin.euinName) ? 'Y' : 'N',
            euinName: scope.formData.euin ? scope.formData.euin.euinName : '',
            euinCode: scope.formData.euin ? scope.formData.euin.euinCode : '',
            frequency: scope.formData.frequency,
            folioNumber: scope.formData.folioNumber,
            schemeCode: scope.formData.inSchemeCode,
            schemeType : scope.formData.schemeType,
            primaryFlag: scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
            toDate: scope.formData.endDate ? scope.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            sipDate: scope.formData.startDate ? scope.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            sipDay: scope.formData.day,
            weeklyDay: scope.formData.weeklyDay ? scope.formData.weeklyDay : null,
            id: scope.formData.sTransactionId,
            bankDetailsForECS: {
              accType: scope.formData.bankInfo && scope.formData.bankInfo.bankAcType ? scope.formData.bankInfo.bankAcType : scope.formData.accountType.accountTypeCode,
              accNumber: scope.formData.sipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM ? scope.formData.bankInfo.bankAcNo: scope.formData.bankInfo.accountNumber,
              ifscCode: scope.formData.bankInfo && scope.formData.bankInfo.ifscCode ? scope.formData.bankInfo.ifscCode : scope.formData.ifscCode,
              bankName: scope.formData.bankInfo ? scope.formData.bankInfo.bankName : scope.formData.bankName,
              bankCode: scope.formData.bankInfo ? scope.formData.bankInfo.bankCode : scope.formData.bankCode,
              branchName: scope.formData.bankInfo ? scope.formData.bankInfo.bankBranch : scope.formData.bankBranch,
              bankCity: scope.formData.bankInfo ? scope.formData.bankInfo.bankCity : scope.formData.bankCity,
              paymentOption: scope.formData.sipPaymentOption,
              payoutId: scope.formData.bankInfo ? scope.formData.bankInfo.payoutId : scope.formData.payoutId
            },
            subBrokerARN: scope.formData.subBrokerARN ? 'ARN-' + scope.formData.subBrokerARN:'',
            subBrokerCode: scope.formData.subBrokerCode,
            sipTopupEnabled:scope.formData.sipTopupEnabled,
            topupDetails: {},
            secretLink: scope.secretLink
          };
          if(scope.formData.sipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              sipPayload.bankDetailsForECS.accNumber= scope.formData.bankInfo.accountNumber,
              sipPayload.bankDetailsForECS.accType=scope.formData.bankInfo.bankAcType,
              sipPayload.bankDetailsForECS.authenticationMode=scope.formData.authMode?scope.formData.authMode.value:'',
              sipPayload.bankDetailsForECSbankCode=scope.formData.bankInfo.bankCode;
              sipPayload.mandateStartDate = scope.formData.emandateDate;
              sipPayload.mandateEndDate = scope.formData.endDateEmandate;
              sipPayload.mandateAmount = scope.formData.emandateAmount;
          }
          (scope.formData.bankInfo && angular.isDefined(scope.formData.bankInfo.camsMandateIdNo))
          &&(sipPayload.bankDetailsForECS.camsMandateIdNo=scope.formData.bankInfo.camsMandateIdNo);
          if (scope.formData.sipPaymentOption == 'UPI') {
            sipPayload.bankDetailsForECS.paymentOption = 'UAP';
            sipPayload.paymentOption = 'UAP';
            sipPayload.payerVpa = scope.formData.virtualAddress;
            sipPayload.payerName = scope.formData.name;
          }
          var payload = {};
          if (!scope.formData.optionalInvestmentType && scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            // payload.sipForm = angular.copy(sipPayload);
            payload = handleBrokerCode(sipPayload);
            payload = angular.copy(sipPayload);
          } else {
            payload = null;
          }
          Object.keys(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
            if(scope.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == payload.investmentOption)
              payload.investmentOption = key;
          });
          payload.netCoreRefNo = scope.formData.trackId;
          return payload;
        }


        function handleSipResponse(data) {
          if (!data) {
            MessageService.error();
            return;
          }

          /*if (data.eMandateEnabled && data.paymentOption == 'EC') {
            openPaynimo(data.trxnNo, data.srnNo);
          }
          else if (!data.eMandateEnabled && (data.paymentOption == 'STANDING' || data.paymentOption == 'EC')) {
            ModalService.manualInstructionsModal({name: scope.investorName, trxnNo: data.trxnNo});
          }
          else {
            MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_APPROVED);
          }*/
          if (scope.arnHardcodedData && scope.arnHardcodedData.isHdfcBank) {
            if(scope.formData.investmentType === 'SIP'){
              scope.netcoreDataObj = NetcoreEvntService.SIP_Payment_Mode(scope.formData, true);
              $window.smartech('dispatch','SIP Payment mode',scope.netcoreDataObj)
            }
          }
          /*if (data.eMandateEnabled && data.paymentOption == 'EC') {
            openPaynimo(data.trxnNo, data.srnNo, data.pNMFreq);
          } else */
          if (scope.formData.sipPaymentOption == 'UPI') {
            $window.location.href= data.redirectUrl;
          } else {
            ModalService.manualInstructionsModal({
              investorName: scope.investorInfo.name,
              folioInvestorName: scope.investorInfo.name,
              srnNo: data.srnNo,
              netBankingUrl:scope.formData.netBankingUrl,
              folioNumber: scope.formData.folioNumber,
              schemeName: scope.formData.inSchemeName,//
              investmentOption: scope.formData.investmentOption,
              amount: scope.formData.amount,
              sipDividendOption: scope.formData.dividendOption,
              paymentOption:data.paymentOption,
              transactionId:data.trxnNo,
              transactionInitiateDate:data.transactionInitiateDate,
              frequency:scope.formData.frequency,
              startDate:scope.formData.startDate ? scope.formData.startDate.format('DD-MMM-YYYY'):null,
              endDate:scope.formData.endDate ? scope.formData.endDate.format('DD-MMM-YYYY'):null,
              bankName:scope.formData.bankInfo ? scope.formData.bankInfo.bankName : scope.formData.bankName,
              bankAcNo:scope.formData.bankInfo ? scope.formData.bankInfo.bankAcNo : scope.formData.bankAcNo,
              type: 'instantLogin',
              schemeCode: scope.formData.inSchemeCode
            });
            TransactionModel.setPayloadRawData(null);
            // Removed code under adobe script removal
            // UtilService.performDataLayerPushEventEcart(scope.formData.inSchemeName).then(function (resp) {
            //   NetcoreEvntService.COMPLETE_TRANSACTION_CART({
            //     cartItemSchemeNames: resp.cartItemSchemeNames,
            //     transactionSuccessSchemeNames: resp.transactionSuccessSchemeNames
            //   })
            // });
          }
        }

        function handleResponse() {
          // console.info("response======== ", res);
        }

        function approveTransaction($event) {
          var payload = getFinalPayload();

          if (!payload) {
            MessageService.error('Something went wrong while calculating payload.');
            return;
          }

          LoaderService.showLoader();
          var success = function (resp) {
              $event.currentTarget.disabled = false;
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _isPaymentDone = true;
                userActivityTracking(function(){
                  if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
                    handleSipResponse(resp.data);
                  } else {
                    showSuccessModal(resp.data.data);
                  }
                });
                      NetcoreEvntService.Complete_Transaction_SIP_QI(scope.formData, true);
              } else {
                if(resp.popupEnabled) {
                  ModalService.genericModal({
                    text: resp.message
                  });
                } else {
                  MessageService.error(resp.message);
                }
                  NetcoreEvntService.Complete_Transaction_SIP_QI(scope.formData, false);
              }
            },
            error = function (err) {
              $event.currentTarget.disabled = false;
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
              NetcoreEvntService.Complete_Transaction_SIP_QI(scope.formData, false);
            };

          // var _controller2 = (scope.transactionType !== scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) ? scope.transactionType.toLowerCase() : 'multiple';

          if (scope.formData.sipPaymentOption === scope.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            var successCallback = function () {
              if(payload.bankDetailsForECS.paymentOption=="E-mandate")
                payload.bankDetailsForECS.paymentOption="HEM";
              finalSubmit(payload);};
            var errorCallback = function () {
              LoaderService.hideLoader();
              scope.isCheckedTandC=true;
              scope.isCheckedTandCeMandate = true;
            };
            ModalService.registerEMandateModal({bankName:payload.bankDetailsForECS.bankName.substring(0,payload.bankDetailsForECS.bankName.indexOf("-")), noOtpConfirmModal: true, authMode: payload.bankDetailsForECS.authenticationMode},successCallback,errorCallback)
            LoaderService.hideLoader();
          }
          else {
            if(scope.arnHardcodedData){
              payload.utmSource = scope.arnHardcodedData.utmSource;
              payload.utmMedium = scope.arnHardcodedData.utmMedium;
            }
            TransactionServiceVersion.post({
              controller1: 'transaction',
              controller2: scope.transactionType.toLowerCase(),
              controller3: 'approve'
            }, payload).$promise.then(success, error);
          }
        }

        function finalSubmit (payload) {
          LoaderService.showLoader();
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                userActivityTracking(function(){
                  handleEmandateSipResponse(resp.data);
                });
              } else {
                MessageService.error(resp.message);
                scope.netcoreDataObj = NetcoreEvntService.SIP_Review_Transaction(scope.formData, false);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
            if(scope.arnHardcodedData){
              payload.utmSource = scope.arnHardcodedData.utmSource;
              payload.utmMedium = scope.arnHardcodedData.utmMedium;
            }
            TransactionServiceVersion.post({
            controller1: 'transaction',
            controller2: 'sip',
            controller3: 'approve'
          }, payload).$promise.then(success, error);
        }

        function handleEmandateSipResponse(data) {
          data = data && data.data ? data.data : data;
          if (!data) {
            MessageService.error();
            return;
          }
          if (scope.arnHardcodedData && scope.arnHardcodedData.isHdfcBank && scope.formData.investmentType === 'SIP') {
              scope.netcoreDataObj = NetcoreEvntService.SIP_Payment_Mode(scope.formData, true);
              $window.smartech('dispatch','SIP Payment mode',scope.netcoreDataObj)
          }
          $window.location.href=scope.billdeskUrl+data.emandateMsg;
        }

        function userActivityTracking(cb){
          cb = cb || function(){};
          var success = function(trackResp){
            trackResp = trackResp.data || trackResp;
            LoaderService.hideLoader();
            if (trackResp.transactionId) {
              scope.formData.trackId = trackResp.transactionId;
            }
            if (scope.arnHardcodedData) {
              if (scope.arnHardcodedData.isHdfcBank) {
                if(trackResp.trxnUniqueLink){
                  scope.formData.trxnUniqueLink = trackResp.trxnUniqueLink;
                }
              }
            }
            // if(scope.transactionType===scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP){
            //   NetcoreEvntService.Complete_Transaction_SIP_QI(scope.formData, true);
            // }else{
            //   NetcoreEvntService.Complete_Transaction_Purchase_QI(scope.formData, true);
            // }
            cb(trackResp);
          }, error = function(err){
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
            cb(err);
          };
          LoaderService.showLoader();
          var userTrackerPayload = setUserTrackerPayload();
          IIHttpService.post({
            child1: 'userBehavior',
            child2: 'addupdateQI'
          },userTrackerPayload).$promise.then(success, error);
        }

        function setUserTrackerPayload(){
          var _payload = {
            "trxnRefNo": $stateParams.trackId?$stateParams.trackId:"", //required in case of update
            "trxnType": scope.formData.investmentType, //SIP, PURCHASE
            "loginType": AppConstants.LOGIN_TYPE.QUICK, //QI_WEB, IP_WEB, DP_WEB
            "step": "SECOND", // FIRST,SECOND,THIRD,FOURTH
            "schemeCd": scope.formData.purchaseInSchemeCode, // required
            "folioNo": scope.formData.folioNumber, // required
            "formData": scope.formData, // required
            "amount": scope.formData.purchaseAmount, //required
            "trxnStatus": _isPaymentDone ? "PROCESSED" : "OPEN"  // OPEN,PROCESSED
          };
          if(scope.arnHardcodedData){
            if(scope.arnHardcodedData.isHdfcBank){
              _payload.loginType= AppConstants.LOGIN_TYPE.HDFC_ONE_CLICK;
              _payload.formData.chipherText = scope.arnHardcodedData.chipherText;
              _payload.schemeCd = scope.formData.purchaseInSchemeCode||scope.formData.inSchemeCode;
            }
          }else{
            _payload.loginType= AppConstants.LOGIN_TYPE.QUICK;
          }
          return _payload;
        }

        scope.init = function () {
          if(angular.isDefined($stateParams.trackId) && angular.isDefined($stateParams.stepNo) && $stateParams.stepNo.toUpperCase() === "SECOND"){
            showPrefillValuesUserTracker(function () {
              if (!scope.formData) {
                $state.reload();
                return null;
              }
            });
          }else{
            if (!scope.formData) {
              $state.reload();
              return null;
            }
          }
        };
        if (scope.arnHardcodedData) {
          if (scope.arnHardcodedData.isHdfcBank) {
        scope.init();
          }
        }


        function showPrefillValuesUserTracker(cb) {
          cb = cb || function(){};
          scope.transactionType = $stateParams.trxnType?$stateParams.trxnType.toUpperCase():scope.transactionType;

          var success = function (resp) {
              if (resp.data && resp.status) {
                scope.formData = resp.data.formdata || {};
                scope.investmentType = scope.formData.investmentType;
                ($stateParams.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)&&(scope.formData.investmentType = scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE);
              } else {
                MessageService.error(resp.message);
              }
              cb();
            },
            error = function (err) {
              UtilService.errorHandler(err);
              cb();
            };
          IIHttpService.get({
            child1: 'userBehavior',
            child2: $stateParams.trackId,
            child3: 'getFormDataQI'
          }).$promise.then(success, error);
        }

        scope.submitForm = function ($event) {
          $event.currentTarget.disabled = true;
          userActivityTracking(function(statusFlag){
            var params = {};
            TransactionModel.setPayloadRawData(angular.copy(scope.formData));
            if((statusFlag && statusFlag.transactionId)||($stateParams.trackId)){
              params.trackId = statusFlag.transactionId || $stateParams.trackId;
            }
            if (scope.formData.investmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || scope.formData.optionalInvestmentType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
              if (scope.arnHardcodedData && scope.arnHardcodedData.isHdfcBank) {
                  scope.netcoreDataObj = NetcoreEvntService.Lumpsum_Review_Transaction(scope.formData, true);
                  $window.smartech('dispatch','Lumpsum Review Transaction',scope.netcoreDataObj)
                  $state.go('instantLoginHome.payment',params);
              }else{
              NetcoreEvntService.Complete_Transaction_Purchase_QI(scope.formData, true);
              $state.go('instantLoginHome.payment',params);
            }
            }
            else if (scope.formData.sipFirstInstallment) {
              params.sipWithFirstInstallment = true;
              if (scope.formData.sipPaymentOption == 'UPI') {
                params.isUpi = true;
              }
              $state.go('instantLoginHome.payment',params);
            }
            else {
              if(scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP){
                if (scope.arnHardcodedData && scope.arnHardcodedData.isHdfcBank) {
                    scope.netcoreDataObj = NetcoreEvntService.SIP_Review_Transaction(scope.formData, true);
                    $window.smartech('dispatch','SIP Review Transaction',scope.netcoreDataObj)
                }
              }
              approveTransaction($event);
            }
          })
        };

        scope.goToBack = function () {
          scope.isSummaryViewEnabled = false;/*
          var params = {};
          ($stateParams.trackId)&&(params.trackId=$stateParams.trackId);
          ($stateParams.trxnType)&&(params.trxnType=$stateParams.trxnType);
          $state.go("instantLoginHome.instantInvest", params);*/

        };

        scope.showTermConditions = function () {
          if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
            ModalService.termConditionModal();
          } else if (scope.transactionType === scope.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            ModalService.termConditionModalSIP({type: 'SIP'});
          }
        };

        scope.showTermConditionsemandate = function () {
          ModalService.transactionalTermConditionModalEMandate();
        }

        scope.ischeckedem = function () {
          if(scope.isCheckedTandCeMandate === false) {
            scope.isCheckedTandCeMandate = true;
          }
          else{
            scope.isCheckedTandCeMandate = false;
          }
        }

        /*
        * Function responsible to manage the broker code for purchase and sip payload
        * */
        function handleBrokerCode(payload) {
          if (scope.formData.isThroughDistributor) {
            payload['brokerCode'] = scope.formData.brokerCode ? 'ARN-' + scope.formData.brokerCode : (scope.formData.distributorARN ? vm.formData.distributorARN : '');
            payload['riaConsent'] = false;
          } else if (scope.formData.isThroughRia) {
            payload['brokerCode'] = scope.formData.brokerCode ? scope.formData.brokerCode : (scope.formData.distributorARN ? scope.formData.distributorARN : '');
            payload['riaConsent'] = true;
          } else if (scope.formData.isDirect) {
            payload['brokerCode'] = '';
            payload['riaConsent'] = false;
          }
          return payload;
        }

      }
    }
  }



})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InstantPaymentController', instantPaymentController);

  /** @ngInject */
  function instantPaymentController($stateParams, ModalService, AppConstants, AuthService, $window, $timeout,
                                    $state, $rootScope, $scope, TransactionModel, IIHttpService, LoaderService,
                                    TransactionService, InvestorService, MessageService, UtilService, $log, NetcoreEvntService,
                                    HDFC_API, TransactionServiceVersion, notesInstantPayment , InvestorFileUploadService , FileUploadServiceVersion2, $sce,DownloadPdfService,FileSaver,$filter,$compile, PaymentService) {
    var vm = this;
    vm.notTransfurringFund = true;
    var transactionFlowVersion;
    vm.formData = TransactionModel.getPayloadRawData();
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.PATTERN = AppConstants;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.redirectUrl = null;
    vm.billdeskUrl = HDFC_API.BILLDESK_URL;
    vm.resendOtp = resendOtp;
    vm.isOtmValid = true;
    vm.isNewPayment = true;
    vm.changeRtgsPaymentOption = changeRtgsPaymentOption;
    vm.showIFSCField = false;
    vm.showAccountTypeField = false;
    vm.bankUploadChequeLeafFile = bankUploadChequeLeafFile;
    vm.openUploadedDoc = openUploadedDoc;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff", "application/pdf"];
    vm.chooseAFile = true;
    vm.rFileType= false;
    vm.downloadPdfFile=downloadPdfFile;
    vm.checkleaf=null;
    vm.NRI_STATUS_CODES = AppConstants.NRI_STATUS_CODES;
    vm.arnHardcodedData = $window.JSON.parse(localStorage.getItem("distributorDetails"));
    vm.secretLink = localStorage.getItem('QuickInvestmentSecreteLink');
    vm.setForm = setForm;
    vm.changeBankRegisterOption = changeBankRegisterOption;
    vm.isDisableUpi = false;
    vm.showUpiPaymentReview = $stateParams.isUpi;
    vm.sipUpiText = vm.TRANSACTIONS_CONST.DESCRIPTIONS.UPI_AUTOPAY;

    vm.init = function () {
      vm.token = AuthService.getInstaToken();
      if (angular.isDefined($stateParams.trackId) && angular.isDefined($stateParams.stepNo) && $stateParams.stepNo === "THIRD") {
        showPrefillValuesUserTracker(function () {
          initActivity();
        });
      } else if(angular.isDefined($stateParams.trackId) && $stateParams.sipWithFirstInstallment)
      {
        showPrefillValuesUserTracker(function () {
          initActivity();
        });
        vm.isOtmOtpVerified = vm.formData.otmOtpVerified;
      } else {
        initActivity();
      }
    };

    var paymentOptions4Liquid=[];
    if ($stateParams.isUpi) {
      paymentOptions4Liquid = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI];
    }


    vm.checkForMinorBankListCondition = function() {
      if(vm.formData!=null && vm.formData.minorFlag!=null && vm.formData.cgfFlag!=null)
        return vm.formData.minorFlag && !vm.formData.cgfFlag;
      else
        return false;
    };

    if (vm.checkForMinorBankListCondition()) {

      if((vm.formData && vm.formData.sipFirstInstallment) || $stateParams.sipWithFirstInstallment) {
          if ($stateParams.isUpi) {
            vm.paymentOptions = [
              vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
            ]

            paymentOptions4Liquid = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI];
          } else {
            paymentOptions4Liquid = [
              vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
            ];
            vm.paymentOptions = [
              vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
              vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM
            ];
          }
      }
      else{
        paymentOptions4Liquid = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }

    } else{
      if((vm.formData && vm.formData.sipFirstInstallment) || $stateParams.sipWithFirstInstallment)
      {
        if ($stateParams.isUpi) {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
          ]
          paymentOptions4Liquid = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI];
        } else {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM
          ];
          paymentOptions4Liquid = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
          ];
        }
      }
      else
      {
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
        paymentOptions4Liquid = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
        if(vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank && vm.formData && vm.formData.investmentType &&
          vm.formData.investmentType.toUpperCase() == "PURCHASE"){
            vm.paymentOptions = [
              vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
              vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.CHEQUE
            ];
        }
      }
  }

    vm.bankList = null;
    vm.bankInfo = null;
    vm.accountType = null;
    vm.otmOtp = null;
    vm.investorInfo = {};
    var identifierData = AuthService.getInstaToken();
    vm.investorName = identifierData ? identifierData.investorName : '';
    vm.investorInfo.name = identifierData ? identifierData.investorName : '';
    vm.showPaymentInfo = false;
    vm.debitCardType = 'visa';
    vm.isUPIVerified = false;
    vm.isOtmOtpVerified = false;
    vm.verifyUPI = verifyUPI;
    vm.getAccountNumber = getAccountNumber;
    vm.generateOtp = generateOtp;
    vm.submitOtmOtp = submitOtmOtp;
    vm.checkOTMAmountAndDate = checkOTMAmountAndDate;
    vm.checkOtmList = checkOtmList;
    vm.selectedUpiBank = selectedUpiBank;
    vm.isCheckedDeclaration = false;
    vm.tpv = tpv;
    vm.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    if (notesInstantPayment) {
      vm.notesInstantPayment = notesInstantPayment;
    } else {
      vm.notesInstantPayment = null;
    }
    vm.billdeskPayload = {
      hidRequestId : "PGIME1000",
      hidOperation : "ME100",
      msg : ""
    };

    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };

    function tpv() {
      ModalService.tpvModal({});
    }
    vm.paymentHDFCSchemeCollectionURL = HDFC_API.HDFC_SCHEME_ACC_LIST;
    vm.paymentHDFCSchemeCollectionAccountsUrl = function(){
      $window.open(vm.paymentHDFCSchemeCollectionURL);
    }
    function handlePurchaseResponse(data) {
      vm.transactionId = data.transactionId;
      var payloadData = data;
      data = data && data.data ? data.data : data;
      if (!data) {
        MessageService.error();
        return;
      }
      if(vm.formData.sipFirstInstallment && vm.formData.sipPaymentOption === 'E-mandate') {
       $window.location.href = vm.billdeskUrl + data.emandateMsg;
       return;
      }
      TransactionModel.setPayloadRawData(null);
      if(vm.formData.investmentType == 'SIP')
        vm.billdeskMsg = data.emandateMsg;
      else
        vm.billdeskMsg = data;
      if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLDESK') {

        if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () { // commented as debit currently is not getting used
            angular.element('#billdeskForm').submit();
          });
          //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
        } else {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () { // commented as debit currently is not getting used
            angular.element('#billdeskForm').submit();
          });
          //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
        }
      }
      else if (vm.formData.paymentInfo.paymentMode == 'WEB' && (vm.formData.paymentInfo.webMode == 'MASTERCARD' || vm.formData.paymentInfo.webMode == 'VISA')) {
        if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () { // commented as debit currently is not getting used
            angular.element('#billdeskForm').submit();
          });
          //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
        } else {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () { // commented as debit currently is not getting used
            angular.element('#billdeskForm').submit();
          });
          //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
        }
      }
      else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLJUNCTION') {
        $window.open(vm.billdeskMsg , '_self');
      }  else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'UPI') {
            if(!vm.redirectUrl) {
              MessageService.error("something went wrong");
            } else {
              $window.location.href = vm.redirectUrl
            }
      } else if(vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'RAZORPAY') {
        if(vm.formData.investmentType.toUpperCase() == "PURCHASE") {
          vm.redirectionDataForRazorPay.trnxActionMsg = vm.redirectionDataForRazorPay.data;
        } else if(vm.formData.investmentType.toUpperCase() == "SIP") {
          vm.redirectionDataForRazorPay.trnxActionMsg = vm.redirectionDataForRazorPay.emandateMsg;
        }
        PaymentService.openRazorPay(payloadData);
      } else if(vm.formData.sipFirstInstallment)
      {
        $window.location.href = data.redirectUrl;
        /*ModalService.manualInstructionsModal({
          srnNo: data.srnNo,
          investorName: vm.investorName,
          folioNumber: vm.formData.folioNumber,
          schemeName: vm.formData.inSchemeName,
          investmentOption: vm.formData.investmentOption,
          amount: vm.formData.amount,
          sipDividendOption: vm.formData.sipDividendOption,
          netBankingUrl:vm.formData.netBankingUrl,
          paymentOption:data.paymentOption,
          transactionId:data.trxnNo,
          transactionInitiateDate:data.transactionInitiateDate,
          frequency:vm.formData.frequency,
          startDate:vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY'):null,
          endDate:vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY'):null,
          bankName:vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
          bankAcNo:vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : vm.formData.bankAcNo,
          sipFirstInstallment:vm.formData.sipFirstInstallment,
          sipFirstAmount:vm.formData.sipFirstAmount,
          sipFirstBankName: vm.formData.purchasePaymentOption === "HDFC" ? "HDFC Bank" : vm.formData.paymentInfo.bankName,
          installmentPaymentOption: vm.TRANSACTIONS_CONST.DESCRIPTIONS[vm.formData.purchasePaymentOption],
          type: 'instantLogin'
        });*/
      }
      else {
        if(vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank && vm.formData.purchasePaymentOption == 'Q'){
            vm.chequeAcknowledgeSuccess = false;
              if(vm.formData.investmentType === 'PURCHASE'){
                vm.transactionTypeModified = vm.formData.investmentType
              }
              var success = function (resp) {
                LoaderService.hideLoader();
                if (resp.status && resp.data) {
                  vm.summaryData = {}
                  if(resp.data.paymentMode == "Q"){
                    vm.summaryData.paymentMethod = "Cheque"
                }
                vm.summaryData.folioNumber =resp.data.folioNumber;
                vm.summaryData.amount = resp.data.amount;
                vm.summaryData.bankName = resp.data.folioBankDetails.bankName;
                vm.summaryData.transactionNo =resp.data.transactionNo;
                vm.summaryData.chequeNo = resp.data.chequeNo;
                vm.summaryData.transactionDate = resp.data.transactionDate;
                vm.summaryData.arn = resp.data.distributorDetails.arnNo;
                vm.summaryData.schemeName = resp.data.schemeName;
                vm.summaryData.camsreferenceNo = resp.data.camsReferenceNumber;
                vm.summaryData.subTransactionNumber = resp.data.subTransactionNumber;
                vm.chequeAcknowledgeSuccess = true;
                } else {
                  MessageService.error(resp.message);
                  vm.chequeAcknowledgeSuccess = false;
                }
              }, error = function (err) {
                LoaderService.hideLoader();
                UtilService.errorHandler(err);
              };
              LoaderService.showLoader();
              var payload = {
                transactionId: vm.transactionId,
                transactionType: vm.transactionTypeModified
              }
              InvestorService.post({
                child1: 'transaction',
                child2: 'approved',
                child3: 'summary'
              }, payload).$promise.then(success, error);
        }else{
        var successModalResp = function(){
          vm.showPaymentInfo = true;
        },errorModalResp = function(){
          vm.showPaymentInfo = true;
        };
        ModalService.successTransactionModal({
          type:'instantLogin',
          amount : vm.formData.investmentType === 'PURCHASE' ? vm.formData.purchaseAmount : vm.formData.amount,
          srnNo : data.srnNo ? data.srnNo : data.transactionId ? data.transactionId : '',
          transactionInitiateDate : data.transactionInitiateDate,
          transactionType : vm.formData.investmentType,
          folioNumber : vm.formData.folioNumber,
          schemeName : vm.formData.investmentType === 'PURCHASE' ? vm.formData.purchaseInSchemeName : vm.formData.inSchemeName,
          schemeCode : vm.formData.investmentType === 'PURCHASE' ? vm.formData.purchaseInSchemeCode : vm.formData.inSchemeCode,
          folioInvestorName : vm.token.investorName,
          encryptedPanNumber : AuthService.encryptRSA(vm.token.investorPAN),
          paymentOption : vm.formData.investmentType === 'PURCHASE' ? vm.formData.purchasePaymentOption :  vm.formData.sipPaymentOption
        },successModalResp,errorModalResp);


        var schemeName = vm.formData.investmentType === 'PURCHASE' ? vm.formData.purchaseInSchemeName : vm.formData.inSchemeName

        // Removed code under adobe script removal
        // UtilService.performDataLayerPushEventEcart(schemeName).then(function (resp) {
        //   NetcoreEvntService.COMPLETE_TRANSACTION_CART({
        //     cartItemSchemeNames: resp.cartItemSchemeNames,
        //     transactionSuccessSchemeNames: resp.transactionSuccessSchemeNames
        //   })
        // });
      }
    }
    }

    function selectedUpiBank() {
      vm.showIFSCField = vm.bankInfo.ifscCode ? false : true;
      vm.showAccountTypeField = vm.bankInfo.bankAcType ? false : true;
      if (vm.showAccountTypeField) {
        getAccountType();
      }
      if(vm.bankInfo && !vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
        ModalService.minorBankModal({instantInvestment:true});
        return;
      }
      vm.upiAccountNumber = vm.bankInfo.accountNumber;
      vm.upiBankName = vm.bankInfo.bankName;
      vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
    }

    vm.showUPISuccessPopup = function () {
      var successModal = function() {
          $state.reload();
        },
        errorModal = function() {
          $state.reload();
        };

      // var type = vm.transactionType;

      ModalService.upiSuccessModal({}, successModal, errorModal);
    };

    function getPaymentInfo() {
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.webMode === 'MASTER'){
        vm.formData.paymentInfo.webMode = 'MASTERCARD';
      }
      var paymentInfo  = {};

      if (vm.formData.investmentType === 'SIP') {
        paymentInfo = {
          //amount:vm.formData.amount,
          paymentMode:vm.formData.paymentInfo.paymentMode
        };
        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.bankName = vm.bankInfo.bankName;
            if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
              paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
              paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            }
            paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            paymentInfo.otmId = vm.formData.paymentInfo.otmId;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.branchName = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNumber = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.bankAcType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.payoutId = vm.formData.paymentInfo.payoutId;
            paymentInfo.omUmrn = vm.formData.paymentInfo.omUmrn;
            paymentInfo.camsMandateIdNo = vm.formData.paymentInfo.camsMandateIdNo;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNumber = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.accountHolderName = vm.formData.paymentInfo.accountHolderName;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.bankAcNo = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
            paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
            paymentInfo.upiReferenceNumber = vm.transactionNumber;
            paymentInfo.accountNumber = vm.upiAccountNumber;
            paymentInfo.accNumber= paymentInfo.accountNumber;
            paymentInfo.bankName= vm.upiBankName;
            paymentInfo.paymentMode = 'UAP';
            paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.accountType.accountTypeCode;
            paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.ifscCode;
            break;
        }
      } else {
         paymentInfo = {
          amount: vm.formData.paymentInfo.amount,
          paymentMode: vm.formData.paymentInfo.paymentMode
        };
        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.accountNumber = vm.bankInfo.accountNumber ? vm.bankInfo.accountNumber : vm.formData.paymentInfo.accountNumber;
            paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            paymentInfo.bankName = vm.bankInfo.bankName;
            paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
            paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            paymentInfo.otmId = vm.formData.paymentInfo.otmId;
            paymentInfo.bankName = vm.bankInfo.bankName ? vm.bankInfo.bankName : vm.formData.paymentInfo.bankName;
            paymentInfo.branchName = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNo = vm.bankInfo.bankAcNo ? vm.bankInfo.bankAcNo : vm.formData.paymentInfo.bankAcNo;
            paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
            paymentInfo.payoutId = vm.formData.paymentInfo.payoutId;
            paymentInfo.omUmrn = vm.formData.paymentInfo.omUmrn;
            paymentInfo.camsMandateIdNo = vm.formData.paymentInfo.camsMandateIdNo;
            paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType;
            paymentInfo.accountNumber = vm.bankInfo.accountNumber ? vm.bankInfo.accountNumber : vm.formData.paymentInfo.accountNumber;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            if(!vm.isNewPayment) {
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
              paymentInfo.accNo = vm.formData.paymentInfo.bankAcNo;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
              paymentInfo.accType = vm.formData.paymentInfo.accType;
              paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
              paymentInfo.otherBank = true;
              paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            } else {
              paymentInfo.bankName = vm.bankInfo.bankNameOnly ? vm.bankInfo.bankNameOnly : null;
              paymentInfo.bankBranch = vm.bankInfo.bankBranch;
              paymentInfo.accNo = vm.bankInfo.accountNumber;
              paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
              paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType;
              paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
              paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf
            }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
            paymentInfo.bankName = "HDFC Bank Ltd";
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.bankAcNo = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.upiReferenceNumber = vm.transactionNumber;
            paymentInfo.accountNumber = vm.upiAccountNumber;
            paymentInfo.accNo= paymentInfo.accountNumber;
            paymentInfo.bankName = vm.upiBankName;
            paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
            paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS:
            paymentInfo = {};
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.CHEQUE:
            if(!vm.notTransfurringFund) {
              paymentInfo.bankName = "HDFC Bank Ltd";
              paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
              paymentInfo.bankCity = vm.formData.paymentInfo.bankCity;
              paymentInfo.accNo = vm.formData.paymentInfo.bankAcNo;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
              paymentInfo.accType = vm.formData.paymentInfo.accType;
              paymentInfo.chequeNo = vm.formData.paymentInfo.chequeNumber;
              paymentInfo.otherBank = true;
            } else {
              paymentInfo.bankName = vm.bankInfo.bankNameOnly ? vm.bankInfo.bankNameOnly : null;
              paymentInfo.bankBranch = vm.bankInfo.bankBranch ? vm.bankInfo.bankBranch : vm.formData.paymentInfo.bankBranch;
              paymentInfo.accNo = vm.bankInfo.accountNumber;
              paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
              paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType;
              paymentInfo.chequeNo = vm.formData.paymentInfo.chequeNumber;
              paymentInfo.bankCity = vm.bankInfo.bankCity ? vm.bankInfo.bankCity : vm.formData.paymentInfo.bankCity;
            }
            break;
        }
      }
      return angular.copy(paymentInfo);
    }

    function getSipPurchasePayload() {
      var sipPayload = {
          installmentAmount: vm.formData.amount,
          investmentOption: vm.formData.investmentOption,
          dividendOption: vm.formData.dividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          frequency: vm.formData.frequency,
          folioNumber: /*'9907939',*/ vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          schemeType : vm.formData.schemeType,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          toDate: vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY').toString() : '',
          sipDate: vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY').toString() : '',
          sipDay: vm.formData.day,
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          id: vm.formData.sTransactionId,
          subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN:'',
          subBrokerCode: vm.formData.subBrokerCode,
          sipTopupEnabled: vm.formData.sipTopupEnabled,
          sipWithFirstInstallment: vm.formData.sipFirstInstallment,
          topupDetails: {},
          secretLink: vm.secretLink
        },
        purchasePayload = {
          amount: vm.formData.purchaseAmount,
          investmentOption: vm.formData.purchaseInvestmentOption,
          dividendOption: vm.formData.purchaseDividendOption,
          folioNumber: /*'9907939',*/ vm.formData.folioNumber,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          schemeCode: vm.formData.purchaseInSchemeCode,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN:'',
          subBrokerCode: vm.formData.subBrokerCode,
          id: vm.formData.pTransactionId,
          paymentInfo: getPaymentInfo(),
          secretLink: vm.secretLink
        };


      sipPayload.netCoreRefNo = vm.formData.trackId;
      purchasePayload.netCoreRefNo = vm.formData.trackId;

      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == purchasePayload.investmentOption) {
          purchasePayload.investmentOption = key;
        } else if (vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == sipPayload.investmentOption) {
          sipPayload.investmentOption = key;
        }
      });

      if (purchasePayload.paymentInfo && purchasePayload.paymentInfo.accountNumber) {
        purchasePayload.accountNumber = purchasePayload.paymentInfo.accountNumber;
      }

      if (purchasePayload.paymentInfo && purchasePayload.paymentInfo.tpvEnableFlag) {
        purchasePayload.tpvEnableFlag = purchasePayload.paymentInfo.tpvEnableFlag;
        delete purchasePayload.paymentInfo.tpvEnableFlag;
      }

      if (vm.formData.investmentType === 'SIP' && (vm.formData.sipFirstInstallment || $stateParams.sipWithFirstInstallment) && $stateParams.isUpi) {
        sipPayload.payerVpa = vm.formData.paymentInfo.virtualAddress;
        sipPayload.payerName = vm.formData.name;
        sipPayload.paymentOption = 'UAP';
      }

      var payload = {};

      switch (vm.formData.investmentType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          purchasePayload = handleBrokerCode(purchasePayload);
          payload = angular.copy(purchasePayload);
          if (vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            payload.sipForm = angular.copy(sipPayload);
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          sipPayload = handleBrokerCode(sipPayload);
          payload = angular.copy(sipPayload);
          if (vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
            payload = angular.copy(purchasePayload);
          }
          break;
      }
      if(vm.formData.investmentType === 'SIP' && vm.formData.sipFirstInstallment)
      {
        payload.sipWithFirstInstallment = vm.formData.sipFirstInstallment;
        payload.firstInstallmentDetails = getPaymentInfo();

        if(vm.formData.sipPaymentOption==='EC' || vm.formData.sipPaymentOption==='UPI')
        {
          payload.bankDetailsForECS= {
            accNumber: vm.formData.bankInfo.accountNumber,
            bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.formData.bankInfo.ifscCode ? vm.formData.bankInfo.ifscCode : vm.formData.ifscCode,
            branchName: vm.formData.bankInfo.bankBranch,
            bankCity: vm.formData.bankInfo.bankCity,
            paymentOption: vm.formData.sipPaymentOption === 'UPI' ? 'UAP' :  vm.formData.sipPaymentOption,
            netBankingUrl:vm.formData.netBankingUrl,
            bankCode:vm.formData.bankInfo ? vm.formData.bankInfo.bankCode:null,
            accType: vm.formData.bankInfo.bankAcType ? vm.formData.bankInfo.bankAcType: vm.formData.accountType.accountTypeCode
          }
        }
        else if(vm.formData.sipPaymentOption==='E-mandate')
        {
          payload.bankDetailsForECS= {
            accNumber: vm.formData.bankInfo ? vm.formData.bankInfo.accountNumber:'',
            bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.formData.bankInfo.ifscCode,
            branchName: vm.formData.bankInfo.bankBranch,
            bankCity: vm.formData.bankInfo.bankCity,
            paymentOption: 'HEM',
            accType:vm.formData.bankInfo.bankAcType,
            bankCode:vm.formData.bankInfo ? vm.formData.bankInfo.bankCode:null,
            authenticationMode:vm.formData.authMode.value
          }
        }
        else if(vm.formData.sipPaymentOption==='OTM')
        {
          payload.bankDetailsForECS= {
            accNumber: vm.formData.bankInfo.bankAcNo,
            accType: vm.formData.bankInfo.bankAcType ? vm.formData.bankInfo.bankAcType : vm.formData.accountType.accountTypeCode,
            bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.formData.bankInfo.ifscCode ? vm.formData.bankInfo.ifscCode : vm.formData.ifscCode,
            branchName: vm.formData.bankInfo.bankBranch,
            bankCity: vm.formData.bankInfo.bankCity,
            paymentOption: vm.formData.sipPaymentOption,
            payoutId:vm.formData.bankInfo.payoutId,
            bankCode:vm.formData.bankInfo ? vm.formData.bankInfo.bankCode:null,
            camsMandateIdNo: vm.formData.bankInfo.camsMandateIdNo,
            omUmrn: vm.formData.bankInfo.omUmrn
          }
        }

      }
      return payload;
    }

    function fetchBankList() {
      // LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
          // LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.bankList = $stateParams.sipWithFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList;
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            if(vm.bankList && vm.bankList.length == 1){
              vm.bankInfo = vm.bankList[0];
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
              vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
              vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
              vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
              vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
              vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
              vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
              vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
              vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
              vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
              vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
              vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
              (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
              checkOTMAmountAndDate();
              if(vm.formData.purchasePaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
                selectedUpiBank();
              }
            } else {
              if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM && vm.bankList === null) {
                vm.bankList = [];
                vm.isOtmOtpVerified = true;
              }
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          // LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
        };
      // LoaderService.showLoader();

      var config = null;
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
          config = {child1: 'bank', child2: 'list', child3: vm.debitCardType, child4: 'debit'};
          IIHttpService.get(config, null).$promise.then(success, error);
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          GetNetBankingFlag()
        break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          config = {
            child1: 'folio',
            child2: 'otm'
          };
          IIHttpService.post(config, {folioNo: vm.formData.folioNumber, transactionType: 'purchase', arnHardCodeFlow: vm.arnHardcodedData ? true : false}).$promise.then(success, error);
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          GetNetBankingFlag();
          break;
        default :
          vm.bankList = null;
          config = null;
          break;
      }
    }


    function initActivity() {
      if (!vm.formData || (vm.formData.investmentType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE && vm.formData.investmentType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP && vm.formData.optionalInvestmentType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE && !vm.formData.sipFirstInstallment)) {
        $state.go('instantLoginHome.instantInvest');
        TransactionModel.setPayloadRawData(null);
        return null;
      }

      if(vm.formData.schemeType.toUpperCase() == 'LIQUID'){
        if(vm.checkForMinorBankListCondition()) vm.paymentOptions = paymentOptions4Liquid;
        else vm.paymentOptions = paymentOptions4Liquid;
      }

      if(vm.formData.investmentType === 'SIP' && vm.formData.bankInfo.emandateEnabled && (!vm.formData.sipFirstInstallment || !$stateParams.sipWithFirstInstallment)) {
        vm.paymentOptions =[
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }

      if(vm.formData.investmentType === 'SIP' && vm.formData.bankInfo.emandateEnabled && vm.formData.schemeType.toUpperCase() === 'LIQUID' && (!vm.formData.sipFirstInstallment || !$stateParams.sipWithFirstInstallment))
      {
        vm.paymentOptions =[
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
        ];
      }

        vm.formData.purchasePaymentOption = vm.paymentOptions[0];

      vm.changedPaymentOption();
      //getInvestorInfo();
      //checkOtmList()
    }

    function GetNetBankingFlag(){
      var success = function(resp){
        if(resp.status && resp.data){
          transactionFlowVersion = resp.data.transactionFlowVersion;
          fetchNetBankingBankList()

        }
        else{
          MessageService.error(resp.message);
        }
      }

      var error = function(err){
        UtilService.errorHandler(err);
      }

      var config = {child1: 'transactionFlowVersion'};
      IIHttpService.get(config, null).$promise.then(success, error);

    }

    function fetchNetBankingBankList() {
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            if (vm.bankList && (vm.formData.investmentType === 'SIP' && (vm.formData.sipFirstInstallment || $stateParams.sipWithFirstInstallment) && $stateParams.isUpi)) {
              if (vm.formData.investmentType === 'SIP' && $stateParams.isUpi) {
                vm.bankInfo = vm.bankList.find(function (el) {
                  return el.accountNumber === vm.formData.bankInfo.accountNumber
                });
                vm.upiAccountNumber = vm.bankInfo.accountNumber;
                vm.upiBankName = vm.bankInfo.bankName;
                vm.formData.paymentInfo.virtualAddress = vm.formData.virtualAddress;
                vm.verifyUPIResp = vm.formData.verifyUPIResp;
                vm.name = vm.verifyUPIResp.name;
                vm.isUPIVerified = vm.verifyUPIResp.valid;
                vm.showIFSCField = false
                vm.showAccountTypeField = false;
                vm.isDisableUpi = true;
              }
            }
            if (vm.arnHardcodedData) {
              if(vm.arnHardcodedData.isHdfcBank){
                vm.bankList = $filter('filter')(resp.data.bankList,
                  {
                    bankCode: "HDF"
                  })
              }
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var config = { child1: 'bank', child2: 'list'};
      var payloadBankList;

      if(vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS) {
        payloadBankList = {
          trnxType: 'PURCHASE',
          folioNumber: (transactionFlowVersion === vm.TRANSACTIONS_CONST.PAYMENT_TRANS_VERSION.NEW) ?
          vm.formData.folioNumber:null,
          liquidSchemeFlag : vm.formData.schemeType == 'LIQUID' ? true : false,
          neftFlag : true,
          arnHardCodeFlow: vm.arnHardcodedData ? true : false
        }
      } else if (vm.formData.investmentType === 'SIP' && (vm.formData.sipFirstInstallment || $stateParams.sipWithFirstInstallment) && $stateParams.isUpi) {
        payloadBankList = {
          trnxType: 'PURCHASE',
          folioNumber: (transactionFlowVersion === vm.TRANSACTIONS_CONST.PAYMENT_TRANS_VERSION.NEW) ?
            vm.formData.folioNumber:null,
          liquidSchemeFlag : vm.formData.schemeType == 'LIQUID' ? true : false,
          sipUpiFlow : true,
          arnHardCodeFlow: vm.arnHardcodedData ? true : false
        }
      } else {
        payloadBankList = {
          trnxType: 'PURCHASE',
          folioNumber: (transactionFlowVersion === vm.TRANSACTIONS_CONST.PAYMENT_TRANS_VERSION.NEW) ?
          vm.formData.folioNumber:null,
          liquidSchemeFlag : vm.formData.schemeType == 'LIQUID' ? true : false,
          arnHardCodeFlow: vm.arnHardcodedData ? true : false
        }
      }

      IIHttpService.post(config,payloadBankList).$promise.then(success, error);

    }


    function checkOtmList() {
      var success = function(resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var otmBankList = {};
            if ($stateParams.sipWithFirstInstallment) {
              otmBankList.currentDate = resp.data.currentDate;
              otmBankList.bankList = resp.data.nonCOTMBankList;
              vm.otmList = otmBankList;
            } else {
              vm.otmList = resp.data;
            }
            if(vm.otmList.bankList && vm.otmList.bankList.length == 1) {
              vm.bankInfo = vm.otmList.bankList[0];
              vm.changeBank();
            }
            if (resp.data.bankList.length == 0) {
              if(vm.formData.schemeType.toUpperCase() == 'LIQUID'){
                vm.paymentOptions = paymentOptions4Liquid;
              }else{
                if(vm.checkForMinorBankListCondition()) {
                  if (vm.formData.sipFirstInstallment) {
                    if ($stateParams.isUpi) {
                      vm.paymentOptions = [
                        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                      ]
                    } else {
                      vm.paymentOptions = [
                        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
                      ];
                    }
                  } else {
                    vm.paymentOptions = [
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                    ];
                  }
                }
                else
                {
                  if (vm.formData.sipFirstInstallment) {
                    if ($stateParams.isUpi) {
                      vm.paymentOptions = [
                        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                      ]
                    } else {
                      vm.paymentOptions = [
                        vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
                      ];
                    }
                  } else {
                    vm.paymentOptions = [
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                    ];
                  }
                }
              }
              if(vm.formData.investmentType === 'SIP' && vm.formData.bankInfo.emandateEnabled && vm.formData.schemeType.toUpperCase() === 'LIQUID' && (!vm.formData.sipFirstInstallment || !$stateParams.sipWithFirstInstallment))
              {
                vm.paymentOptions = [
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                ];
              }
              vm.formData.purchasePaymentOption = vm.paymentOptions[0];
              vm.changedPaymentOption();
            }
          }
        },
        error = function(err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        }

      LoaderService.showLoader();
      var  config = {
        child1: 'folio',
        child2: 'otm'
      };
      LoaderService.showLoader();
      IIHttpService.post(config, {folioNo: vm.formData.folioNumber,transactionType: 'purchase', arnHardCodeFlow: vm.arnHardcodedData ? true : false}).$promise.then(success, error);
    }

    vm.changedPaymentOption = function () {
      vm.isCheckedDeclaration = false;
      vm.bankInfo = null;
      vm.bankList = null;
      vm.formData.paymentInfo = {amount: vm.formData.purchaseAmount};
      vm.otmOtp = null;
      vm.showIFSCField = false;
      vm.showAccountTypeField = false;
      vm.fileName = null;
      vm.isNewPayment = true;
      vm.notTransfurringFund = true;
      vm.accountType = null;
      vm.checkleaf=null;
      vm.fileType='';
      vm.bankchequeLeafUrl=null;
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          vm.formData.paymentInfo.paymentMode = "WEB";
          fetchBankList();
          break;
        case "Q":
            vm.formData.paymentInfo.paymentMode = "Q";
            fetchNetBankingBankList();
            getAccountType();
            break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          if (!vm.formData.otmOtpVerified) {
            vm.isOtmOtpVerified = false;
            generateOtp();
          } else {
            vm.isOtmOtpVerified = true;
            checkOtmList();
          }
          fetchBankList();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
          fetchBankList();
          getAccountType();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC;
          getAccountType();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS:
          vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if(vm.formData.purchaseAmount > vm.formData.upiLimit) {
            var success = function() {
              vm.formData.purchasePaymentOption = vm.paymentOptions[0];
              vm.changedPaymentOption();
            }
            ModalService.genericModal({
              text: vm.formData.upiErrorMessage,
              isUpi: true
            },success);
          }
          resetUPIForm();
          fetchBankList();
          vm.formData.paymentInfo.paymentMode = "WEB";
          vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
          break;
      }
    };

    vm.changeBank = function () {
      if (!vm.bankInfo) {
        // vm.formData.paymentInfo = null;
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankName){
          vm.formData.paymentInfo.bankName = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankBranch){
          vm.formData.paymentInfo.bankBranch = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankAcNo){
          vm.formData.paymentInfo.bankAcNo = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyBankAcNo || (vm.formData.paymentInfo.verifyBankAcNo == undefined)){
          vm.formData.paymentInfo.verifyBankAcNo = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.ifscCode){
          vm.formData.paymentInfo.ifscCode = null;
        }
        vm.accountType = null;
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.utrNumber){
          vm.formData.paymentInfo.utrNumber = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyUtrNumber || (vm.formData.paymentInfo.verifyUtrNumber == undefined)){
          vm.formData.paymentInfo.verifyUtrNumber = null;
        }
        if(vm.accountType){
          vm.accountType = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
          vm.formData.paymentInfo.chequeLeaf = null;
        }
        if(vm.fileType){
          vm.fileType = null;
        }
        if(vm.tForm){
          vm.tForm.$setPristine();
        }
        vm.isAccTypeFieldDisabled = false;
        return;
      }
      vm.fileType = null;

      vm.showIFSCField = vm.bankInfo.ifscCode ? false : true;
      vm.showAccountTypeField = vm.bankInfo.bankAcType ? false : true;

      if (vm.showAccountTypeField) {
        getAccountType();
      }

      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({instantInvestment:true});
            return;
          }
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          if (vm.bankInfo.tpvEnableFlag == 'Y') {
            getAccountNumber(vm.bankInfo.bankCode);
          }
          break;
        case "Q":
            if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
              ModalService.minorBankModal({instantInvestment:true});
              return;
            }
            vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
            vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
            if (vm.bankInfo.tpvEnableFlag == 'Y') {
              getAccountNumber(vm.bankInfo.bankCode);
            }
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly ? vm.bankInfo.bankNameOnly : null;
            vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch ? vm.bankInfo.bankBranch : null;
            vm.formData.paymentInfo.bankAcNo = vm.bankInfo.accountNumber;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : null;
              vm.accountType = vm.bankInfo.bankAcType && vm.accountTypeList && vm.accountTypeList.find(function (data) {
                return data.accountTypeCode === vm.bankInfo.bankAcType;
              })
            vm.formData.paymentInfo.otherBank = true;
            vm.formData.paymentInfo.chequeNumber = null;
            vm.formData.paymentInfo.verifyChequeNumber = null;
            vm.formData.paymentInfo.verifyBankAcNo = null;
            vm.isAccTypeFieldDisabled = vm.accountType ? true : false;
            if(vm.bankInfo.bankBranch){
              vm.branchbankfield = true;
            }else{
              vm.branchbankfield = false;
            }
            vm.tForm.$setPristine();
            if(vm.showAccountTypeField && vm.NRI_STATUS_CODES.includes(vm.token.inptType)) {
              vm.accountType = vm.accountTypeList[0];
              vm.changeAccountype();
            }
            if(vm.notTransfurringFund && vm.bankInfo){
              if(vm.tForm.bankBranch || vm.tForm.ifscCode || vm.tForm.accountType){
              vm.tForm.bankBranch.$setDirty();
              vm.tForm.ifscCode.$setDirty();
              vm.tForm.accountType.$setDirty();
              }
            }else{
              vm.tForm.bankBranch.$dirty = false;
              vm.tForm.bankAcNo.$dirty = false;
              vm.tForm.bankName.$dirty = false;
              vm.tForm.ifscCode.$dirty = false;
              vm.tForm.accountType.$dirty = false;
            }
            break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({instantInvestment:true});
            return;
          }
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
          vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
          vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
          vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
          vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
          (vm.bankInfo && angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo = vm.bankInfo ? vm.bankInfo.camsMandateIdNo : '');
          checkOTMAmountAndDate();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({instantInvestment:true});
            return;
          };
          break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
              ModalService.minorBankModal({instantInvestment:true});
              vm.bankInfo = null;
              vm.isCheckedDeclaration = false;
              return;
            }
            vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode ? vm.bankInfo.bankCode : null;
            vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
            if (vm.bankInfo.tpvEnableFlag == 'Y') {
              getAccountNumber(vm.bankInfo.bankCode);
            }
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly ? vm.bankInfo.bankNameOnly : null;
            vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch ? vm.bankInfo.bankBranch : null;
            vm.formData.paymentInfo.bankAcNo = vm.bankInfo.accountNumber ? vm.bankInfo.accountNumber : null;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : null;
            vm.accountType = vm.bankInfo.bankAcType && vm.accountTypeList && vm.accountTypeList.find(function (data) {
              return data.accountTypeCode === vm.bankInfo.bankAcType;
            })
            vm.formData.paymentInfo.otherBank = true;
            vm.formData.paymentInfo.utrNumber = null;
            vm.formData.paymentInfo.verifyUtrNumber = null;
            vm.formData.paymentInfo.verifyBankAcNo = null;
            vm.formData.paymentInfo.chequeLeaf = null;
            vm.isAccTypeFieldDisabled = vm.accountType ? true : false;
            vm.tForm.$setPristine();
            if(vm.showAccountTypeField && vm.NRI_STATUS_CODES.includes(vm.token.inptType)) {
              vm.accountType = vm.accountTypeList[0];
              vm.changeAccountype();
            }
            if(vm.isNewPayment && vm.bankInfo){
              vm.tForm.bankName.$setDirty();
              vm.tForm.bankBranch.$setDirty();
              vm.tForm.bankAcNo.$setDirty();
              vm.tForm.ifscCode.$setDirty();
              vm.tForm.accountType.$setDirty();
              vm.bankChequeLeaf = 'No File Chosen';
              vm.bankchequeLeafUrl = null;
              vm.fileName = null;
            }else{
              vm.tForm.bankBranch.$dirty = false;
              vm.tForm.bankAcNo.$dirty = false;
              vm.tForm.bankName.$dirty = false;
              vm.tForm.ifscCode.$dirty = false;
              vm.tForm.accountType.$dirty = false;
            }
            break;
        default :
          vm.bankInfo = null;
          break;
      }
    };

    function resetUPIForm() {
      vm.verifyUPIResp = {};
      vm.isUPIVerified = false;
      (vm.formData.paymentInfo)&&(vm.formData.paymentInfo.virtualAddress = "");
    }
    function getAccountNumber(bankCode) {
      if(transactionFlowVersion === vm.TRANSACTIONS_CONST.PAYMENT_TRANS_VERSION.NEW){
        vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
        vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
        return;
      }
      vm.bankAccounts = [];
      vm.isInvalidForm = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            vm.bankAccounts = resp.data.accountNumbers;
            if (vm.bankAccounts.length > 1) {
              var success = function (accountNo) {
                vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
                vm.formData.paymentInfo.accountNumber = accountNo;
                vm.isInvalidForm = false;
              }, error = function () {

              };
              ModalService.selectAccountNoModal({bankAccounts: vm.bankAccounts}, success, error);
            } else {
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankAccounts[0];
              vm.isInvalidForm = false;
            }
          } else {
            vm.isInvalidForm = true;
            MessageService.error(resp.message);
            vm.bankAccounts = [];
          }
        },
        error = function (err) {
          vm.bankAccounts = [];
          vm.isInvalidForm = true;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber, //'9422332',
        "bankCode": bankCode
      };
      InvestorService.post({
        child1: 'bank',
        child2: 'account'
      }, payload).$promise.then(success, error);
    }

    function checkOTMAmountAndDate() {
      vm.isOTMAmount= false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      // Check Ammout
      if(vm.formData.purchaseAmount && (vm.formData.purchaseAmount > vm.bankInfo.maxAmount)){
        vm.isOTMAmount= true;
      }else if (vm.formData.purchaseAmount && (vm.formData.purchaseAmount < vm.bankInfo.maxAmount)){
        vm.isOTMAmount= false;
      }

      if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount > vm.bankInfo.maxAmount)) {
        vm.isOTMAmount = true;
      } else if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount < vm.bankInfo.maxAmount)){
        vm.isOTMAmount = false;
      }

      //Compare Dates
      if (!($window.moment(vm.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.otmList.currentDate, 'DD-MMM-YYYY')))){
        vm.isOTMStartDate = true;
      }
      else{
        vm.isOTMStartDate = false;
      }

      if($window.moment(vm.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment())){
        vm.isOTMDate = true;
      }
      else {
        vm.isOTMDate = false;
      }
      //Check for amount or date
      if(vm.isOTMAmount || vm.isOTMDate){
        vm.isInvalidForm = true;
      }else{
        vm.isInvalidForm = false;
        //tForm.$invalid
      }
    }

    function generateOtp() {
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.otpSentMessage = resp.data.message || "OTP has been sent to your registered Email ID.";
            vm.otpId = resp.data.id;
            vm.isOtmValid = true;
            otmSubmitCount = 1;
          } else {
            MessageService.error(resp.message);
            vm.isOtmValid = false;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      IIHttpService.get({
        child1: 'instant',
        child2: 'investment',
        child3: 'payment',
        child4: 'otm',
        child5: 'otp'
      }).$promise.then(success, error);
    }

    var otmSubmitCount = 1;
    function submitOtmOtp() {
      var payload = {
        otp: vm.otmOtp,
        id: vm.otpId
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
              vm.isOtmOtpVerified = true;
              vm.formData.otmOtpVerified = vm.isOtmOtpVerified;
              checkOtmList();
              vm.isOtmValid = true;
              otmSubmitCount = 1;
          }
          else {
            vm.isOtmOtpVerified = false;
            vm.formData.otmOtpVerified = vm.isOtmOtpVerified;
            otmSubmitCount++;
            if (otmSubmitCount === 7 ) {
              vm.isOtmValid = false;
            }
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.isOtmOtpVerified = false;
          vm.formData.otmOtpVerified = vm.isOtmOtpVerified;
          vm.isOtmValid = true;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();

      IIHttpService.post({
        child1: 'instant',
        child2: 'investment',
        child3: 'payment',
        child4: 'otm',
        child5: 'otp',
        child6: 'confirm'
      }, payload).$promise.then(success, error);
    }

    vm.goToBack = function () {
      $window.sessionStorage.setItem("SummaryReviewEnabled", true);
      $state.go("instantLoginHome.instantInvest");
    }

    vm.submitForm = function () {
      userActivityTracking(false, function () {
        var payload = getSipPurchasePayload();
        if (!payload) {
          MessageService.error('Something went wrong while calculating purchase payload.');
          return;
        }
        if(payload.formType === 'PURCHASE' && vm.formData.purchasePaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING &&
          vm.formData.purchaseAmount>=200000 && vm.formData.schemeType!='LIQUID'){
          vm.showPurchaseNetBankingModal(payload);
        }
        else if(payload.formType==='SIP' && vm.formData.sipFirstInstallment) {
          if(payload.bankDetailsForECS.paymentOption==='HEM'){
            var successCallback = function () {
              vm.finalSubmit(payload);
            };
            var errorCallback = function () {
              LoaderService.hideLoader();
            };
            ModalService.registerEMandateModal({bankName: payload.bankDetailsForECS.bankName, noOtpConfirmModal: true, authMode: payload.bankDetailsForECS.authenticationMode},successCallback,errorCallback)
          }
          else
            vm.finalSubmit(payload);
        }
        else
          vm.finalSubmit(payload);

      });
    };

    vm.showPurchaseNetBankingModal = function (payload) {
      vm.finalSubmit(payload);
    };

    vm.finalSubmit = function (payload) {
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            TransactionModel.setPayloadRawData(null);
            userActivityTracking(true, function () {
              vm.redirectionDataForRazorPay = resp.data;
              handlePurchaseResponse(resp.data);
            });
            vm.redirectUrl = resp.data.redirectUrl;
          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message,
                isAadhar: true
              });
            } else {
              MessageService.error(resp.message);
            }
            NetcoreEvntService.Payment_Success_Purchase_QI(vm.formData, false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          NetcoreEvntService.Payment_Success_Purchase_QI(vm.formData, false);
        };
      var typeOfInvestment = vm.formData.investmentType.toLowerCase();
      if(vm.arnHardcodedData){
        payload.utmSource = vm.arnHardcodedData.utmSource;
        payload.utmMedium = vm.arnHardcodedData.utmMedium;
      }
      if(vm.formData.investmentType === 'PURCHASE' && vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING){
        TransactionServiceVersion.post({
          controller1: 'transaction',
          controller2: 'purchase',
          controller3: 'approve'
        },payload).$promise.then(success,error);
      } else if(vm.formData.investmentType === 'SIP'){
        TransactionServiceVersion.post({
          controller1: 'transaction',
          controller2: typeOfInvestment,
          controller3: 'approve'
        },payload).$promise.then(success,error);
      } else {
        TransactionServiceVersion.post({
          controller1: 'transaction',
          controller2: typeOfInvestment,
          controller3: 'approve'
        },payload).$promise.then(success,error);
      }
    };

    function userActivityTracking(isProcessed, cb) {
      if(isProcessed){
        NetcoreEvntService.Payment_Success_Purchase_QI(vm.formData, true);
      }else{
        NetcoreEvntService.Continue_To_Pay_Purchase_QI(vm.formData, true);
      }
      cb = cb || function () {
      };
      var success = function (trackResp) {
        trackResp = trackResp.data || trackResp;
        LoaderService.hideLoader();
        if (trackResp.transactionId) {
          vm.formData.trackId = trackResp.transactionId;
        }
        if(vm.arnHardcodedData){
          if(vm.arnHardcodedData.isHdfcBank){
            if(trackResp.trxnUniqueLink){
              vm.formData.trxnUniqueLink = trackResp.trxnUniqueLink;
            }

            if(vm.formData.investmentType === 'PURCHASE'){
              vm.netcoreDataObj = NetcoreEvntService.Lumpsum_Payment_Mode(vm.formData, true);
              $window.smartech('dispatch','Lumpsum payment mode',vm.netcoreDataObj)
            }
            if(vm.formData.investmentType === 'SIP'){
              vm.netcoreDataObj = NetcoreEvntService.SIP_Payment_Mode(vm.formData, true);
              $window.smartech('dispatch','SIP Payment mode',vm.netcoreDataObj)
            }
          }
        }
        if(isProcessed){
          NetcoreEvntService.Payment_Success_Purchase_QI(vm.formData, true);
        }else{
          NetcoreEvntService.Continue_To_Pay_Purchase_QI(vm.formData, true);
        }
        cb(trackResp);
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(false);
      };

      LoaderService.showLoader();
      var userTrackerPayload = setUserTrackerPayload(isProcessed);
      InvestorService.post({
        child1: 'userBehavior',
        child2: 'addupdateQI'
      }, userTrackerPayload).$promise.then(success, error);
    }

    function setUserTrackerPayload(isProcessed) {
      var _payload = {
        "trxnRefNo": $stateParams.trackId?$stateParams.trackId:"", //required in case of update
        "trxnType": vm.formData.investmentType, //SIP, PURCHASE
        // "loginType": AppConstants.LOGIN_TYPE.QUICK, //QI_WEB, IP_WEB, DP_WEB
        "step": "THIRD", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode,
        "folioNo": vm.formData.folioNumber,
        "formData": vm.formData,
        "amount": vm.formData.purchaseAmount,
        "trxnStatus": isProcessed ? "PROCESSED":"OPEN"// OPEN,PROCESSED
      };
      if(vm.arnHardcodedData){
        if(vm.arnHardcodedData.isHdfcBank){
          _payload.loginType= AppConstants.LOGIN_TYPE.HDFC_ONE_CLICK;
          _payload.formData.chipherText = vm.arnHardcodedData.chipherText;
        }
      }else{
        _payload.loginType= AppConstants.LOGIN_TYPE.QUICK;
      }
      return _payload;
    }

    function showPrefillValuesUserTracker(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData = resp.data.formdata || {};
          } else {
            MessageService.error(resp.message);
          }
          cb();
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb();
        };
      IIHttpService.get({
        child1: 'userBehavior',
        child2: $stateParams.trackId,
        child3: 'getFormDataQI'
      }).$promise.then(success, error);
    }

    vm.otherBankSelected = function () {
      vm.bankInfo = null;
    };

    vm.cardTypeChanged = function () {
      fetchBankList();
    };

    vm.copyPasteHandler = function (e) {
      UtilService.copyPasteHandler(e);
    };

    var stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
      TransactionModel.setPayloadRawData(null);
    });

    function verifyUPI() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.verifyUPIResp = resp.data;
            if(resp.data.valid){
              vm.name = resp.data.name;
              vm.isUPIVerified = true;
            } else {
              vm.isUPIVerified = false;
            }
          }
          else {
            vm.isUPIVerified = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();

      InvestorService.post({
        child1: 'upi',
        child2: 'check',
        child3: 'virtualAddress'
      }, {"virtualAddress":vm.formData.paymentInfo.virtualAddress}).$promise.then(success, error);
    }

    $scope.$on('$destroy', function () {
      stateChangeStart();
    })
    /*
    * Function responsible to manage the broker code for purchase and sip payload
    * */
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.brokerCode ? vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = true;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }

    function resendOtp() {
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.otpResendMessage = 'OTP sent again successfully.';
          resetTimer();
        } else {
          vm.otpResendMessage = '';
          MessageService.error(resp.message)
        }
        vm.isProcessing = false;
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.otpResendMessage = '';
        vm.isProcessing = false;
        UtilService.errorHandler(err);
      };
      IIHttpService.post({
        child1: 'instant',
        child2: 'investment',
        child3: 'payment',
        child4: 'otm',
        child5: 'resend',
        child6: 'otp'
      }, {
        id: vm.otpId
      }).$promise.then(success, error);
    }

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.PATTERN.RESEND_OTP_COUNTER);
    }

    function changeRtgsPaymentOption() {
      vm.bankChequeLeaf = 'No File Chosen';
      vm.bankchequeLeafUrl = null;
      vm.fileType = null;
      vm.tForm.$setPristine();
      vm.accountType = null;
      vm.formData.paymentInfo.chequeLeaf = null;
      if (vm.isNewPayment) {
        vm.bankInfo = null;
        vm.accountType = null;
        vm.isAccTypeFieldDisabled = false;
      } else {
        vm.bankInfo = null;
        if(vm.NRI_STATUS_CODES.includes(vm.token.inptType)) {
          vm.accountType = vm.accountTypeList[0];
          vm.changeAccountype();
        }
      }

      vm.formData.paymentInfo.bankName = null;
      vm.formData.paymentInfo.bankBranch = null;
      vm.formData.paymentInfo.bankAcNo = null;
      vm.formData.paymentInfo.verifyBankAcNo = null;
      vm.formData.paymentInfo.ifscCode = null;
      vm.formData.paymentInfo.utrNumber = null;
      vm.formData.paymentInfo.verifyUtrNumber = null;
      vm.fileName = null;
    }


    vm.changeAccountype = function () {
      if (!vm.accountType) {
        return;
      }
      vm.formData.paymentInfo.accType = vm.accountType.accountTypeCode;
    };

    function openUploadedDoc() {
      if(angular.isUndefined(vm.bankchequeLeafUrl)){return;}
        ModalService.showImage({docUrl: vm.bankchequeLeafUrl});
    }

    function bankUploadChequeLeafFile(file) {
      var fi = document.getElementById('uploadCheckLeaf');
      vm.checkleaf = file;
      vm.fileName = file.name;
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be PDF, TIF, TIFF, JPG and JPEG extension.");
        vm.rFileType=true;
        fi.value = '';
        return;
      }
      if(file){
        if (fi.files.item(0).size <= 3145728) {
          vm.rFileType=false;
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.bankchequeLeafUrl = resp.data.fileUrl;
              vm.formData.paymentInfo.chequeLeaf = vm.bankchequeLeafUrl;
              vm.fileType = resp.data.type.toLowerCase();
              breakFileUrl(vm.bankchequeLeafUrl);
            }
            else {
              vm.fileType = '';
              MessageService.error(resp.message);
              fi.value = '';
            }
          },
          error = function (err) {
            LoaderService.hideLoader(err);
            fi.value = '';
          };
          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            FileUploadServiceVersion2.post({
              child1: 'folio',
              child2: 'upload',
              child3: 'bankDetails',
              child4: 'chequeLeaf'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          vm.rFileType=true;
          MessageService.error("File size should not be more than 3 MB.")
          fi.value = '';
          if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
            vm.formData.paymentInfo.chequeLeaf = null;
            vm.bankchequeLeafUrl = null;
            vm.fileType = null;
          }
          vm.chooseAFile = true;
          vm.fileName = null;
        }
      }
    }

    function breakFileUrl(url) {
      vm.bankChequeLeaf = 'Preview Uploaded Leaf Doc';
      vm.fileType = url && url.split('_').reverse()[0].toLowerCase();
      vm.chooseAFile = false;
      vm.bankchequeLeafUrl = url;
      return;
    }

    function getStatusCode() {
      var success = function (resp) {
      },
      error = function (err) {
        $log.info('Account type Errror>>>>', err);
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'active-list'
      }).$promise.then(success, error);
    }

    function getAccountType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.accountTypeList = resp.data.bankAccountTypes;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        $log.info('Account type Errror>>>>', err);
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.token.inptType
      }).$promise.then(success, error);
    }

    function downloadPdfFile(url, fileType) {
      var success = function (resp){
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+fileType });
            FileSaver.saveAs(data, 'Cheque_Leaf.'+fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.downloadFile(payload, fileType, url).then(success, error);
    };

    function setForm(form) {
      vm.tForm = form
    }

    vm.addNote = function () {
      $timeout(function () {
        if(vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank){
          if(document.querySelector(".point-to-note")){
            angular.element(document.querySelector(".point-to-note")).append($compile("<p><i class=\"dot\"></i> <span> This facility allows payments to be made through or installments to be debited from HDFC Bank only. For payments through any other bank as Payee Bank, kindly visit HDFC MF website <a href='"+HDFC_API.WEBSITE_LINK+"' target='_blank' style='color:blue !important'>"+HDFC_API.WEBSITE_LINK+"</a>.\n</span>\n </p>\n")($scope));
          }else{
            vm.addNote();
          }
        }
      }, 2000);
    }
    vm.addNote();

    function changeBankRegisterOption(){
      vm.tForm.$setPristine();
      vm.accountType = null;
      if (vm.notTransfurringFund) {
        vm.bankInfo = null;
        vm.accountType = null;
        vm.isAccTypeFieldDisabled = false;
        vm.formData.paymentInfo.bankName = "HDFC Bank Ltd";
      } else {
        vm.bankInfo = null;
        vm.formData.paymentInfo.bankName = null;
        if(vm.NRI_STATUS_CODES.includes(vm.token.inptType)) {
          vm.accountType = vm.accountTypeList[0];
          vm.changeAccountype();
        }
      }

      vm.formData.paymentInfo.bankBranch = null;
      vm.formData.paymentInfo.bankAcNo = null;
      vm.formData.paymentInfo.verifyBankAcNo = null;
      vm.formData.paymentInfo.ifscCode = null;
      vm.formData.paymentInfo.chequeNumber = null;
      vm.formData.paymentInfo.verifyChequeNumber = null;
    }

    vm.selectIFSC = function () {
      var successModal = function (data) {
        if(data){
          vm.formData.paymentInfo.bankName = data.bankName;
          vm.formData.paymentInfo.bankBranch = data.branch;
          vm.formData.paymentInfo.ifscCode = data.ifscCode;
        }else{
          MessageService.error(resp.message);
        }
      },
      errorModal = function (err) {

      };
      ModalService.IFSCSelectionModalNewJourney({ bankList: vm.bankList, key : 'arn'}, successModal, errorModal);
    }
    vm.manualIfscSearch = function(){

      if (vm.formData.paymentInfo.ifscCode.includes('HDFC')){

      }else{
        vm.formData.paymentInfo.ifscCode = "";
      }
      vm.showInvalidIfscerror = false;
      var onSuccess = function (data) {
        vm.IFSCsearchResult = data.data.bankList;
        if(vm.IFSCsearchResult[0]){
          vm.formData.paymentInfo.bankBranch = vm.IFSCsearchResult[0].branch;
          vm.formData.paymentInfo.ifscCode = vm.IFSCsearchResult[0].ifscCode;
        }
        else{
          vm.showInvalidIfscerror = true;
          vm.formData.paymentInfo.bankBranch = "";
          vm.formData.paymentInfo.ifscCode = "";
        }
      };
      onerror = function () {
      };
      var payload = {
        ifscCode: vm.formData.paymentInfo.ifscCode
      };
      InvestorService.post({
        child1: 'rbi',
        child2: 'bankList'
      }, payload).$promise.then(onSuccess, onerror);
    }
    vm.gotohome = function(){
      $state.go("instantLoginHome.instantInvest");
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InstantLoginController', instantLoginController);

  /** @ngInject */
  function instantLoginController(AuthService, toastr, $state, $stateParams, $timeout, $scope, AppConstants,
                                  MessageService, LoaderService, ModalService, UtilService,InvestorService,
                                  CommonFactory, TransactionModel, NetcoreEvntService, MetaTagService, $rootScope, $window, $log, InvestorServiceVersion3, $sce, TransactionService, panAadharService) {
    var vm = this;
    vm.loginProcessFlag = false;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.confirmRegister = confirmRegister;
    vm.reset = reset;
    vm.confirmCancel = confirmCancel;
    var scope = $scope;
    scope.footerDate = new Date();
    UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.QUICK_INVEST);

    MetaTagService.setMetaDescription(AppConstants.META_TAGS.QUICK_INVEST_DESCRIPTION);

    if(CommonFactory.getSessionExpired()){
      ModalService.logoutSuccess();
    }

    vm.loginPayload = {
      folioNumber: "",
      panNumber: "",
      bankAccountNumber: "",
      dob : "",
      folioList : {},
      maskedFolioList : []
    };

    // PAN & DOB Change Variables
    vm.viewMode = "years";
    vm.invalidPanDob = false;
    vm.panMessage = "";
    vm.changeStartDate = changeStartDate;
    vm.panAndDobFrame = true;
    vm.folioFrame = false;
    vm.IsFolio = true;
    vm.folioNumber;
    vm.showSecStep = false;
    vm.dob;
    vm.dobtrue = false;


    vm.login = function () {
      var successHandler = function (result) {
        LoaderService.hideLoader();
        getFoliosAgainstPan();
      }
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.loginPayload.panNumber,null).then(successHandler).catch(errorHandler);
    };

    vm.copyPasteHandler=function (e) {

      var key = e.keyCode?e.keyCode:e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if ( key == 86 && ctrl ) {
        e.preventDefault();
      } else if ( key == 67 && ctrl ) {
        e.preventDefault();
      }
    }

    function confirmRegister() {

      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        var successModal = function () {
            $state.go('registration.main')
          },
          errorModal = function () {
            $state.go('login')
          };
        ModalService.confirmRegisterModal({}, successModal, errorModal)
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      }
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.loginPayload.panNumber,null).then(successHandler).catch(errorHandler);


    }


    function redirectToTransaction() {

      var bTransactionData =  $window.JSON.parse(sessionStorage.getItem('bTransaction'));
      var bTrnsaction = false;

      if (bTransactionData && bTransactionData.bTransaction && $stateParams.trackId && $stateParams.trxnType && ($stateParams.trxnType === 'REDEMPTION' || $stateParams.trxnType === 'SWITCH')) {
        bTrnsaction = true;
      }

      if($stateParams.trackId && $stateParams.trxnType && $stateParams.stepNo && !bTrnsaction){
        $state.go('instantLoginHome.instantInvest',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
        switch ($stateParams.stepNo.toUpperCase()) {
          case "FIRST":
            $state.go('instantLoginHome.instantInvest',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
            break;
          case "SECOND":
            $state.go('instantLoginHome.review',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
            break;
          case "THIRD":
            $state.go('instantLoginHome.payment',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
            break;
          default:
            $state.go('instantLoginHome.instantInvest',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
        }
      }else {
        $state.go('instantLoginHome.instantInvest');
      }
    }

    function reset() {
      vm.loginPayload.password = '';
    }

    function confirmCancel() {
      var confirmSuccess = function () {
        $state.go("login");
      };
      var confirmError = function () {
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    }

    vm.handleSideBarClick = function(state) {
      UtilService.updateSideBar(state);
    };

    // PAN & DOB Change

    vm.varifyDate = function(date, typedDate) {
      if(typedDate){
        vm.loginPayload.dob = typedDate;
        vm.dobtrue = true;
      } else if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
          vm.dob = date;
          vm.dobtrue = true;
          vm.loginPayload.dob = vm.dob.format("DD-MM-YYYY") ;
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';
      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.dobtrue = false;
        vm.dob = "";
        vm.loginPayload.dob = "";
      }
      return;
    }

      function changeStartDate(date) {
        if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
          vm.loginPayload.dob = date;
          vm.dob = date;
          vm.dobtrue = true
          if (!date) {
            vm.dateErrorMessage = vm.validateData.DOB_FIELD;
          } else vm.dateErrorMessage = '';
        } else {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
          vm.loginPayload.dob = "";
        }
        return;
      }

      vm.autoDate = function(){
        var oldlength = 0 ;
        if(vm.dobString){
           oldlength = vm.dobString.length;
        }
        vm.dobString = $("#dobId").val();
        var newlength = vm.dobString.length;
        if( vm.dobString.length == 2){
          if((newlength== (oldlength - 1)) || (newlength == oldlength)){
          } else{
            $("#dobId").val(vm.dobString+"-");
          }
        }
        if( vm.dobString.length == 5){
          if((newlength== (oldlength - 1)) || (newlength == oldlength)){
          } else{
            $("#dobId").val(vm.dobString+"-");
          }
        }
        if(vm.dobString.length == 10){
          vm.varifyDate("",vm.typedDate);
        }else{
          vm.dobtrue = false;
        }
      }

      vm.panVerifiedFlag = false;
      vm.checkPanVerification = function(){
        if (vm.loginPayload.panNumber) {
          var success = function (resp) {
            vm.panVerifiedFlag = resp.data.panVerifiedFlag;
            LoaderService.hideLoader(".pan-loader");
            if (resp.data && resp.status) {
              $log.info("resp.data:", resp.data);
              if (resp.data.panVerifiedFlag) {
                vm.panMessage = "";
              } else {
                vm.panMessage = resp.data.message;
              }
              vm.processFlag = false;
            } else {
              vm.processFlag = true;
              vm.panMessage = resp.message;
            }
          },
            error = function () {
              LoaderService.hideLoader(".pan-loader");
              vm.processFlag = true;
              MessageService.error(AppConstants.ToastrMessage.FAILED);
            };
          vm.processFlag = false;
          LoaderService.showLoader(".pan-loader");
          var payload = {
            panNumber: vm.loginPayload.panNumber
          };
          InvestorService.post({ child1: "registration", child2: "verifyPan" },payload).$promise.then(success, error);
        }
      }

      function getFoliosAgainstPan(){
        var success = function(resp){
          LoaderService.hideLoader();
          if(resp.status && resp.data){
            if(resp.data.length == 0){
              vm.IsFolio = false;
              MessageService.error('Folios not found for this PAN. <span class="' + Math.random() + '"></span>');
            }else{
              vm.folioFrame = true;
              vm.panAndDobFrame = false;
              vm.loginPayload.maskedFolioList = [];
              vm.loginPayload.folioList = resp.data;
              for (var j = 0; j < vm.loginPayload.folioList.length; j++) {
                if (vm.loginPayload.folioList[j]) {
                  if (vm.loginPayload.folioList[j].id) {
                    var id = vm.maskid(vm.loginPayload.folioList[j].id);
                  }
                  if (vm.loginPayload.folioList[j].email && vm.loginPayload.folioList[j].email !== "null" && vm.loginPayload.folioList[j].email !== null) {
                    var valArray = vm.loginPayload.folioList[j].email.split("@");
                    var startVal = valArray[0];
                    var endVal = valArray[1];
                    var maskyVal = "";
                    for (var i = 0; i < startVal.length; i++) {
                      if (i == 0) {
                        maskyVal += startVal[i];
                      }
                      if (i == 1) {
                        maskyVal += "*";
                      }
                      if (i > 1) {
                        var t = i % 2;
                        if (t == 0) {
                          maskyVal += startVal[i];
                        } else {
                          maskyVal += "*";
                        }
                      }
                    }
                    var email = maskyVal + "@" + endVal;
                  } else {
                    email = null;
                  }
                  if (vm.loginPayload.folioList[j].mobileNo && vm.loginPayload.folioList[j].mobileNo !== "null" && vm.loginPayload.folioList[j].mobileNo !== null) {
                    var mobileNo = vm.maskemobileNo(vm.loginPayload.folioList[j].mobileNo);
                  } else {
                    mobileNo = null;
                  }
                  var obj = {
                    "id": id,
                    "email": email ? email : "Not available",
                    "mobileNo": mobileNo ? mobileNo : "Not available",
                    "folioNumber":vm.loginPayload.folioList[j].id,
                    "emailId": vm.loginPayload.folioList[j].email && (vm.loginPayload.folioList[j].email !== "null" || vm.loginPayload.folioList[j].email !== null) ? vm.loginPayload.folioList[j].email : null,
                    "mobile": vm.loginPayload.folioList[j].mobileNo && (vm.loginPayload.folioList[j].mobileNo !== "null" || vm.loginPayload.folioList[j].mobileNo !== null) ? vm.loginPayload.folioList[j].mobileNo : null
                    // "blockedTrxnPopup" : vm.loginPayload.folioList[j].blockedTrxnPopup,
                    // "noNominationMsg" : vm.loginPayload.folioList[j].noNominationMsg
                  };

                  obj.holderDOBExists = vm.loginPayload.folioList[j].holderDOBExists ? vm.loginPayload.folioList[j].holderDOBExists : false;
                  obj.corporateInvestor = vm.loginPayload.folioList[j].corporateInvestor ? vm.loginPayload.folioList[j].corporateInvestor : false;

                  if (vm.loginPayload.folioList[j].retirementSchemeBlankDOBErrorMsg) {
                    obj.retirementSchemeBlankDOBErrorMsg = vm.loginPayload.folioList[j].retirementSchemeBlankDOBErrorMsg
                  }
                  vm.loginPayload.maskedFolioList.push(obj);
                  obj = {}
                }
              }
              vm.folioNumber = vm.loginPayload.folioList[0].id;
              vm.chooseFolio(vm.loginPayload.maskedFolioList[0]);
            }
          }else{
            MessageService.error(resp.message);
          }
        },
        error = function(err){
          LoaderService.hideLoader();
          vm.loginProcessFlag = false;
          if (err && err.message) {
            MessageService.error(err.message);
          }else{
            MessageService.error(err);
          }
        }

        var payload = {
          panNumber: vm.loginPayload.panNumber,
          isHdfcFilter:"N",
          dob : vm.loginPayload.dob
        };
        LoaderService.showLoader();
        TransactionService.post({ controller1: "getListOfFolio" }, payload).$promise.then(success, error);
      }

      vm.maskid = function (val) {
        var endVal = val.substr(-3);
        var maskyVal = "";
        var valLength = val.length;
        while (0 < valLength - 3) {
          maskyVal += "*";
          valLength--;
        }
        return maskyVal + endVal;
      }

      vm.maskemobileNo = function (val) {
        var endVal = val.substr(-4);
        var maskyVal = "";
        var valLength = val.length;
        while (0 < valLength - 4) {
          maskyVal += "*";
          valLength--;
        }
        return maskyVal + endVal;
      }

      vm.backtoPanDobFrame = function(){
        vm.panAndDobFrame = true;
        vm.folioFrame = false;
      }

      vm.chooseFolio = function (x) {
        vm.selectedFolioData = x;
        vm.loginPayload.emailID = x.email;
        vm.loginPayload.mobile = x.mobileNo;
        vm.loginPayload.email = x.emailId;
        vm.loginPayload.mobileNo = x.mobile;
        vm.isInvalid = vm.folioNumber && x.email === "Not available" && x.mobileNo === "Not available" ? true : false;
        // if (x.blockedTrxnPopup) {
        //   UtilService.setBlockTransactionSEBINomination(x);
        // } else {
        //   var isoldData = localStorage.getItem('bTransaction');
        //   if (isoldData) {
        //     localStorage.removeItem('bTransaction');
        //   }
        // }
      }

      vm.QuickInvestmentSecreteLink = null;
      vm.sendOtp = function() {
        var success = function(resp) {
          LoaderService.hideLoader();
          if(resp.status){
            var messages = resp.data.otpSentMessage + '<span class="' + Math.random() + '"></span>';
              toastr.success(messages, '', {
                allowHtml: true,
                preventDuplicates: false,
                onHidden: function () {
                  vm.loginProcessFlag = false;
                }
              });
            vm.QuickInvestmentSecreteLink = resp.data.id;
            localStorage.setItem('QuickInvestmentSecreteLink',vm.QuickInvestmentSecreteLink);
            LoaderService.hideLoader();
            vm.loginPayload.mobile
            vm.OTPFrame = true;
            vm.folioFrame  = false;
            vm.showOtpField = true;
            vm.showSecStep = true;
            vm.loginPayload.otp = "";
            var html = 'Please enter OTP sent to your registered Email Id ('+vm.loginPayload.emailID+') and Mobile Number ('+vm.loginPayload.mobile+'). In case your email ID or mobile number is not updated, please <a href='+'/update-user-contact'+'>click here</a> to update.';
            vm.sentOtpRespMsg = $sce.trustAsHtml(html);
          } else {
            var messages = resp.message + '<span class="' + Math.random() + '"></span>';
            toastr.error(messages, '', {
              allowHtml: true,
              preventDuplicates: false,
              onHidden: function () {
                vm.loginProcessFlag = false;
              }
            });
          }
        },error = function () {
          LoaderService.hideLoader();
          vm.OTPFrame = false;
          vm.folioFrame  = true;
          vm.showOtpField = false;
          vm.showSecStep = false;
        };
        var payload = {
          folioNumber: vm.folioNumber,
          panNumber : vm.loginPayload.panNumber,
          email: vm.loginPayload.email,
          mobileNo: vm.loginPayload.mobileNo
        };
        LoaderService.showLoader();
        AuthService.generateOtp(payload, 'fromPanDob').then(success, error);
      }

      vm.loginWithOTP = function () {
        AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
          var successLogin = function (result) {
            localStorage.setItem("QuickInvestmentSecreteLink",vm.QuickInvestmentSecreteLink);
              if (result.access_token && result.access_token != "") {
                if (!result.kycVerifiedFlag) {
                  ModalService.genericModal({
                    text: result.kycMessage
                  }, function () {
                    AuthService.logoutInstantLogin();
                  });
                  return;
                }
                localStorage.setItem('loggedIn', true);
                TransactionModel.setPayloadRawData(null);
                NetcoreEvntService.Login_Status_QI_IP(vm.loginPayload, true);
                if(vm.selectedFolioData && (!vm.selectedFolioData.holderDOBExists || vm.selectedFolioData.corporateInvestor)) {
                  localStorage.setItem('selectedFolioDataInQI', $window.JSON.stringify(vm.selectedFolioData));
                } else {
                  var existingData = localStorage.getItem('selectedFolioDataInQI');
                  if (existingData) {
                    localStorage.removeItem('selectedFolioDataInQI');
                  }
                }
                redirectToTransaction();
              } else {
                if (result && result.message) {
                  MessageService.error(result.message);
                } else {
                  UtilService.errorHandler(result);
                }
                NetcoreEvntService.Login_Status_QI_IP(vm.loginPayload, false);
              }
              LoaderService.hideLoader();
          },
          errorLogin = function (msg) {
            LoaderService.hideLoader();
            vm.loginProcessFlag = false;
            if (msg && msg.message) {
              var messages = msg.message + '<span class="' + Math.random() + '"></span>';
              toastr.error(messages, '', {
                allowHtml: true,
                preventDuplicates: false,
                onHidden: function () {
                  vm.loginProcessFlag = false;
                }
              });
            } else {
              UtilService.errorHandler(msg);
            }
            NetcoreEvntService.Login_Status_QI_IP(vm.loginPayload, false);
          };
          var payload = {
            folioNumber : vm.folioNumber,
            panNumber   : AuthService.encryptRSA(angular.copy(vm.loginPayload.panNumber)),
            otp         : vm.loginPayload.otp,
            grant_type  : "password",
            secretLink  : vm.QuickInvestmentSecreteLink
          };
          vm.loginProcessFlag = true;
          LoaderService.showLoader();
          AuthService.InstantLogin(payload).then(successLogin, errorLogin);
      };

      vm.showPreviousStep = function() {
        vm.panAndDobFrame = false;
        vm.OTPFrame = false;
        vm.folioFrame = true;
        vm.folioNumber = vm.folioNumber;
      }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ResetPasswordController', resetPasswordController);

  /** @ngInject */
  function resetPasswordController(AppConstants,MessageService,ModalService,$stateParams,$state,InvestorService, LoaderService, AuthService) {
    var vm = this;
    vm.password = '';
    vm.confirmPassword = '';
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.checkPattern = checkPattern;
    vm.checkConfirmpassword = checkConfirmpassword;
    vm.isMatching = true;
    vm.isConfirmMatched = true;
    vm.isRequired = false;
    vm.formData = {};

    vm.resetPassword = function () {
      if(vm.formData && vm.formData.newPassword){
        vm.formData.newPassword = AuthService.encryptRSA(angular.copy(vm.formData.newPassword));
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp && resp.status) {
            var successModal = function () {
                $state.go('login')
              },
              errorModal = function (err) {  
                MessageService.error(err)
              };
            ModalService.resetPasswordDoneModal({}, successModal, errorModal)
          } else {  
            MessageService.error(resp.message);
          }
        },
        error = function () { 
          LoaderService.hideLoader();
          vm.processFlag = true;
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      var payload = {
        newPassword: vm.formData.newPassword,
        urlKey: $stateParams.secretKey/*,
        userName: $stateParams.userName*/
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'forgot',
        child2:'password',
        child3:'reset'
      }, payload).$promise.then(success, error);

    };

    function checkPattern() {
      //vm.formData.newPassword = pwd;
      //vm.isMatching = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$_!@])[A-Za-z\d$@!_]{8,12}$/.test(vm.formData.newPassword);
      vm.isMatching = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[$_!@])[A-Za-z\d$@!_]{8,15}$/.test(vm.formData.newPassword);


      if(vm.formData.newPassword== null){
        vm.isRequired = true;
        vm.isMatching = true;
      } else{
        vm.isRequired = false;
        checkConfirmpassword();
      }
    }

    function checkConfirmpassword() {
      if(vm.formData.confirmPassword){
        vm.isConfirmMatched = (vm.formData.newPassword == vm.formData.confirmPassword) ? true : false;
      } else{
        vm.isConfirmMatched = true;
      }

    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ForgotPwdController', ForgotPwdController);

  /** @ngInject */
  function ForgotPwdController(AppConstants,AuthService, $state, $scope, $timeout, InvestorService, MessageService, ModalService, LoaderService, toastrConfig, toastr, UtilService) {
    var vm = this;
    vm.confirmCancel = confirmCancel;
    vm.payload = {userId: '', PAN: ''};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.validateData.pattern = AppConstants.ToastrMessage;
    var scope = $scope;
    vm.processFlag = false;
    scope.footerDate = new Date();
    vm.invalidUserId = false;
    vm.checkText = function(){
      var regex = AppConstants.valid_userId_regex;
      if(vm.payload && vm.payload.userId && (regex.test(vm.payload.userId.toLowerCase()) && vm.payload.userId.length > 30)){
        vm.invalidUserId =  true;
      } else{
        vm.invalidUserId =  false;
      }
    }
    vm.submit = function () {
      LoaderService.showLoader();
      var payload = {
        userID: vm.payload.userId,
        panNumber:vm.payload && vm.payload.PAN ? AuthService.encryptRSA(angular.copy(vm.payload.PAN)) : ''
      };
      var success = function (res) {
        LoaderService.hideLoader();
        if (res.status) {
          var successModal = function () {
              $state.go('login')
            },
            errorModal = function (err) {
              MessageService.error(err)
            };
          var message = res.message;
          var email = message.substring(message.lastIndexOf(" "), message.length);
          message = message.substring(0, message.lastIndexOf(" "));
          message = message + "<span class='notification-email'>" + email + "</span>";
          ModalService.forgotPasswordModal({'message': message}, successModal, errorModal, "custom")
        }else{
          vm.processFlag = true;
          toastrConfig.preventDuplicates = false;
          toastr.error(res.message, '', {
            onHidden: function () {
              vm.processFlag = false;
              toastrConfig.preventDuplicates =  true;
            }
          });  
        }

      }, error = function (res) {
        LoaderService.hideLoader();
        vm.processFlag = true;
        toastrConfig.preventDuplicates = false;
        toastr.error(res.message, '', {
          onHidden: function () {
            vm.processFlag = false;
            toastrConfig.preventDuplicates =  true;
          }
        }); 
       // MessageService.success(err.message);
      };
      LoaderService.showLoader();
      InvestorService.post4({
        child1: 'forgot',
        child2: 'password'
      }, payload).$promise.then(success, error);

    };

    function confirmCancel() {
      var confirmSuccess = function () {
        $state.go("login");
      };
      var confirmError = function () {
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    }

    vm.handleSideBarClick = function(state) {
      UtilService.updateSideBar(state);
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ForgotIdController', ForgotIdController);

  /** @ngInject */
  function ForgotIdController($state, $scope, $timeout,AuthService, InvestorService, MessageService, AppConstants, ModalService, LoaderService, UtilService) {
    var vm = this;
    vm.confirmCancel = confirmCancel;
    vm.text = 'Forgot User ID ?';
    vm.payload = {email: '', PAN: ''};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    var scope = $scope;
    scope.footerDate = new Date();
    vm.submit = function () {
      LoaderService.showLoader();
      var payload = {
          emailID:vm.payload && vm.payload.email ? AuthService.encryptRSA(angular.copy(vm.payload.email)) : '',
          panNumber: vm.payload && vm.payload.PAN ? AuthService.encryptRSA(angular.copy(vm.payload.PAN)) : ''
        },
        success = function (res) {
          LoaderService.hideLoader();
          if (res && res.status) {
            var successModal = function () {
                $state.go('login')
              },
              errorModal = function () {
                $state.go('login');
                //MessageService.error(err)
              };
            var message = 'User ID has been sent to your registered email ID';
            var successHandler = function(resp) {
              if(resp.popupDTO.popupDTOMap.Popup_Home !== undefined)
              {
                ModalService.successMessageModal({message: message}, successModal, errorModal, "custom")
              }
            }

            UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
              MessageService.error(resp);
            });
            //ModalService.successMessageModal({message: message}, successModal, errorModal, "custom")
          } else { 
            if (res.message === "REDIRECT_TO_OLD") {
              ModalService.redirectToOldFolioModal({});
            } else {
              MessageService.error(res.message);
            }
          }

        }, error = function (err) { 
          LoaderService.hideLoader();
          MessageService.error(err.message);
        };

      InvestorService.post4({
        child1: 'forgot',
        child2: 'userid'
      }, payload).$promise.then(success, error);

    };

    function confirmCancel() {
      var confirmSuccess = function () {
        $state.go("login");
      };
      var confirmError = function () {
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    }

    vm.handleSideBarClick = function(state) {
      UtilService.updateSideBar(state);
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ForgotFolioController', ForgotFolioController);

  /** @ngInject */
  function ForgotFolioController($state, $scope, $timeout,AuthService, InvestorService, MessageService, AppConstants, ModalService, LoaderService, $stateParams,investorServiceVersion, toastrConfig, toastr, UtilService) {
    var vm = this;
    vm.confirmCancel = confirmCancel;
    vm.text = 'Forgot User Id ?';
    vm.payload = {};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.showOTPForm = false;
    vm.selectedField = 'email';
    vm.processFlag = false;
    vm.processFlagOtp = false;
    vm.processFlagVerifyOtp = false;
    var scope = $scope;
    scope.footerDate = new Date();

    vm.changeFields = function () {
      vm.payload.email = null;
      vm.payload.mobileNumber = null;
      if (vm.selectedField === 'email') {
        vm.selectedField = 'mobile';
      } else if (vm.selectedField === 'mobile') {
        vm.selectedField = 'email';
      }
    }

    vm.submit = function () {
      LoaderService.showLoader();
      var success = function (res) {
          LoaderService.hideLoader();
          if (res && res.status) {
            vm.payload.requestId=res.data.id;
            vm.showOTPForm = true;
            vm.msgTOShow = res.data.msg;
          }else{
            vm.processFlag = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(res.message, '', {
              onHidden: function () {
                vm.processFlag = false;
                toastrConfig.preventDuplicates =  true;
              }
            });
          }

        }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err.message);
        };
        var dataPayload = {}
        if( vm.payload && vm.payload.email){
          dataPayload.email = AuthService.encryptRSA(angular.copy(vm.payload.email));
        }
        if( vm.payload && vm.payload.panNumber){
          dataPayload.panNumber = AuthService.encryptRSA(angular.copy(vm.payload.panNumber));
        }
        if( vm.payload && vm.payload.mobileNumber){
          dataPayload.mobileNumber = AuthService.encryptRSA(angular.copy(vm.payload.mobileNumber));
        }
      investorServiceVersion.post4({
        child1: 'folio',
        child2: 'forgot',
        child3: 'otp-request'
      }, dataPayload).$promise.then(success, error);

    };

    function confirmCancel() {
      var confirmSuccess = function () {
        $state.go("login");
      };
      var confirmError = function () {
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    }

    vm.resendOTP = function() {
      var payload = {
        requestId: vm.payload.requestId
      };
      var success = function (res) {
        if(res.status && res.message){
          vm.processFlagOtp = true;
          toastrConfig.preventDuplicates = false;
          toastr.success(res.message, '', {
            onHidden: function () {
              vm.processFlagOtp = false;
              toastrConfig.preventDuplicates =  true;
            }
          });
          resetTimer();
        }
        else{
          vm.processFlagOtp = true;
          toastrConfig.preventDuplicates = false;
          toastr.error(res.message, '', {
            onHidden: function () {
              vm.processFlagOtp = false;
              toastrConfig.preventDuplicates =  true;
            }
          });
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      };
      InvestorService.post({child1:'folio',child2:'forgot',child3:'otp-request',child4:'resend'},payload).$promise.then(success,error);
    }

    vm.verifyOTP = function () {
      LoaderService.showLoader();
      var payload = {
        otpNumber: vm.otpNumber ? AuthService.encryptRSA(angular.copy(vm.otpNumber)) : '',
        requestId: vm.payload.requestId
      };
      var success = function (res) {
        LoaderService.hideLoader();
        if(res && res.message){
          if(res.status){
            vm.processFlagVerifyOtp = true;
            toastrConfig.preventDuplicates = false;
            toastr.success(res.message, '', {
              onHidden: function () {
                vm.processFlagVerifyOtp = false;
                toastrConfig.preventDuplicates =  true;
              }
            });
            $state.go($stateParams.from);
          }else{
            vm.processFlagVerifyOtp = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(res.message, '', {
              onHidden: function () {
                vm.processFlagVerifyOtp = false;
                toastrConfig.preventDuplicates =  true;
              }
            });

          }
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      };
      InvestorService.post4({child1:'folio',child2:'forgot',child3:'otp',child4:'verify'},payload).$promise.then(success,error);
    }

    vm.confirmCancel = function() {
      var confirmSuccess = function () {
        $state.go($stateParams.from);
      };
      var confirmError = function () {
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    }

    vm.handleSideBarClick = function(state) {
      UtilService.updateSideBar(state);
    };

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.pattern.RESEND_OTP_COUNTER);
      $timeout(function () {
      },29000)
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .config(welcome);

  /** @ngInject */
  function welcome($stateProvider) {
    $stateProvider.state('welcome.existingUserWelcome.widgets', {
      url: '',
      views: {
        "headerWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/header/header-banner.html',
          controller: 'FirstLoginWelcomeController',
          controllerAs: 'Welcome'
        },
        "investmentWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/investment-widget/investment-widget.html',
          controller: 'InvestmentWidgetController',
          controllerAs: 'Investment'
        },
        "basketWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/basket-widget/basket-widget.html',
          controller: 'BasketWidgetController',
          controllerAs: 'Basket'
        },
        "transactionWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/transaction-widget/transaction-widget.html',
          controller: 'TransactionWidgetController',
          controllerAs: 'Transaction'
        },
        "systematicWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/systematic-widget/systematic-widget.html',
          controller: 'SystematicWidgetController',
          controllerAs: 'Systematic'
        },
        "statementWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/statement-widget/statement-widget.html',
          controller: 'StatementWidgetController',
          controllerAs: 'Statements'
        },
        "calculatorWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/calculator-widget/calculator-widget.html'
        },
        "videoWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/video-widget/video-widget.html',
          controller: 'VideoWidgetController',
          controllerAs: 'Video'
        },
        "bannerWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/banner-widget/banner-widget.html',
          controller: 'BannerWidgetController',
          controllerAs: 'Banner'
        },
        "quickLinkWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/quick-link-widget/quick-link-widget.html',
          controller: 'QuickLinkWidgetController',
          controllerAs: 'QuickLink'
        },
        "transactNowWidget": {
          templateUrl: 'app/firstLogin/welcome/widgets/transact-now-widget/transact-now.html'
        }
      },
      authenticate: true
    })
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FirstLoginWelcomeController', firstLoginWelcomeCtrl);

  /** @ngInject */
  function firstLoginWelcomeCtrl($window, $state, ModalService, MessageService, $log, AppConstants, LoaderService,
                                 AuthService, InvestorService, InvestorProfilePhotoService, TransactionService, ProfileFactory,
                                 TransactionModel, $rootScope, UtilService, $timeout, $scope, InvestorServiceV3, NetcoreEvntService, KycService, $sce,HDFC_API) {
    var scope = $scope;
    scope.footerDate = new Date();
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.fetchMarketData = fetchMarketData;
    vm.fetchMarketNews = fetchMarketNews;
    vm.text = 'Welcome user - You came here first time';
    vm.basic = {};
    vm.basicDetails = basicDetails;
    vm.uploadProfileImage = uploadProfileImage;
    vm.profileImage = null;
    // vm.basic.profileImageUrl = AppConstants.DEFAULT_PROFILE_IMAGE;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.todayDate = new Date();
    var removeListeners = {}, isRefreshing = false;
    var token = AuthService.getToken();
    vm.emailIdExist = token ? token.emailIdExist : false;
    vm.enterEmailModal = enterEmailModal;
    vm.enterOtpModal = enterOtpModal;
    vm.emailVerifySuccessModal = emailVerifySuccessModal;
    vm.goToFirstFolioCreation = goToFirstFolioCreation;
    vm.savedItems = 0;
    vm.savedFolio = 0;
    vm.checkImpNotification = checkImpNotification;
    vm.asPendingApprovalCount = token && token.asPendingApprovalCount? token.asPendingApprovalCount: 0;
    AuthService.checkLinkedUserStatus();
    vm.Next = function () {
      //$state.go('firstTimeFolioStep1');
    };
    vm.appConstants = AppConstants;

    /*---------------- welcome page update variables------------------------*/
    vm.userFirstName = token.investorFName;
    vm.videoPlaylist = [
      {name: "", title: "", url: "", class: "col-xs-12 col-sm-12 col-md-6"},
      {name: "", title: "", url: "", class: "col-xs-12 col-sm-12 col-md-6"}
    ];
    vm.prospectFolioWidgets = [
      { widgetName: "", classes: ""},
      { widgetName: "", classes: ""},
      { widgetName: "", classes: ""}
    ];
    vm.existingUserWidgets = [
      [
        { widgetName: "investmentWidget", classes: "col-xs-12 col-md-6"},
        { widgetName: "bannerWidget", classes: "col-xs-12 col-md-6"}
      ],
      [{ widgetName: "basketWidget", classes: "col-xs-12 col-md-12"}],
      [{ widgetName: "transactionWidget", classes: "col-xs-12 col-md-12"}],
      [{ widgetName: "systematicWidget", classes: "col-xs-12 col-md-6"},
      { widgetName: "statementWidget", classes: "col-xs-12 col-md-6"}],
      [{ widgetName: "calculatorWidget", classes: "col-xs-12 col-md-6"},
      { widgetName: "videoWidget", classes: "col-xs-12 col-md-6"}]
    ];

    vm.newUserWidgets = [
      [{widgetName: "transactNowWidget", classes: "col-xs-12 col-md-6"},
        {widgetName: "bannerWidget", classes: "col-xs-12 col-md-6"}],
      [{ widgetName: "basketWidget", classes: "col-xs-12 col-md-12"}],
      [{widgetName: "videoWidget", classes: "col-xs-12 col-md-6"},
        {widgetName: "calculatorWidget", classes: "col-xs-12 col-md-6"}]];

    vm.offlineUserWidgets = [
      [{ widgetName: "investmentWidget", classes: "col-xs-12 col-md-6"},
        { widgetName: "bannerWidget", classes: "col-xs-12 col-md-6"}],
      [{ widgetName: "basketWidget", classes: "col-xs-12 col-md-12"}],
      [{widgetName: "transactNowWidget", classes: "col-xs-12 col-md-6"},
        { widgetName: "statementWidget", classes: "col-xs-12 col-md-6"}],
      [{ widgetName: "videoWidget", classes: "col-xs-12 col-md-6"},
        { widgetName: "quickLinkWidget", classes: "col-xs-12 col-md-6"}]
    ];
    vm.widgetAsPerUser = setWidget();
    /*----------- welcome page variable declaration ends here ----------------------------------*/
    vm.openTncModal = function () {
      var success = function () {

      }, error = function () {

      };
      ModalService.tncModal({}, success, error);
    };
    vm.init = function () {
      localStorage.removeItem('minorMode');
      sessionStorage.removeItem('FolioCreated');
      sessionStorage.removeItem('transactionSuccess');
      setListeners();
      if($state.current.name === 'welcome.newUserWelcome'){
        (vm.emailIdExist === false) && emailVerificationCheck();
      }else if($state.current.name === 'welcome.existingUserWelcome.widgets' || $state.current.name === 'welcome.existingUserWelcome') {
        /*After 1 April the method will be depricated*/
        (localStorage.getItem('isWelcomeMessageShown')=== null) && showSomeMessage();
        /*basicDetails();
        unfinishedTransactionAPI();
        unfinishedFoliosAPI();
        favoriteTransactionCountAPI();*/
        if (token.emailIdExist) {
          var firstTimeLogin = token.firstTimeLogin;
          vm.name = token.investorFName;
          if (firstTimeLogin) {
            var successModal = function () {
                if (token && token.firstTimeLogin) {
                  token.firstTimeLogin = false;
                } else {
                  $state.go('login');
                }
                AuthService.setToken(token);
                $state.go('welcome.existingUserWelcome.widgets')
              },
              errorModal = function (err) {
                MessageService.error(err)
              };
            ModalService.mapFolioModal({name: token.investorFName}, successModal, errorModal);
          }
          //fetchMarketData();
          //fetchMarketNews();
          // basicDetails();
          //vm.getTotalNotificationCount();
        } else {
          (vm.emailIdExist === false) && emailVerificationCheck();
        }
      }
      if (!UtilService.mobileActiveStatus.get()) {
        declareProfileUpdateToolTip();
      }
      vm.isImpInfoShown = sessionStorage.getItem('shownPopupOfNomination') ? sessionStorage.getItem('shownPopupOfNomination') : 'false';
      checkImpNotification();

      // Removed code under adobe script removal
      // UtilService.performDataLayerPushEventEcart().then(function (resp) {
      //   NetcoreEvntService.COMPLETE_TRANSACTION_CART({
      //     cartItemSchemeNames: resp.cartItemSchemeNames,
      //     fromDashboard : true
      //   })
      // });
    };

    function showSomeMessage() {
      // var a = $window.moment();//today //dynamic day
      // if((a.isBetween('2020-04-06', '2020-05-01','day'))){ // .isBetween(lower limit, upper limit) //not consider lower/upper limit
        var successModal = function () {
            localStorage.setItem('isWelcomeMessageShown', "true");
        },
        errorModal = function () {
          localStorage.setItem('isWelcomeMessageShown', "true");
        };
        /*should remove after 30th-April-2020*/
        var message = "As per SEBI communication dated November 6, 2020 and further to our Addendum dated October 18, 2020, the cut off timing for acceptance of transaction requests and applicability of Net Asset Value (NAV) for HDFC Mutual Fund Schemes effective from November 9, 2020 is as follows:";

      var successHandler = function(resp) {

        if(resp.popupDTO.popupDTOMap.Popup_Login_Home !== undefined)
        {
            ModalService.successMessageModal({message: message, firstLogin:true}, successModal, errorModal);
        }
      }

      UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
        //ModalService.successMessageModal({message: message, firstLogin:true}, successModal, errorModal);
      // }
    }

    /*function showWarningMessage() {
      var messages = "Alert: Dear Patron, we are currently facing issues on displaying information with" +
        " regards to liquid schemes in the portfolio view section on the website. Our Teams are in the " +
        "process of fixing the same. This should however NOT prevent you from transacting in those" +
        " schemes online via the Transaction section on the website . In the event you face any issues " +
        "while transacting, please write to us or reach out to us via the chat facility right away by" +
        " clicking the icon below. We apologize for the inconvenience and will try and address it at the earliest.";
      MessageService.clear();
      MessageService.warning(messages);
    }*/

    function emailVerificationCheck() {
      var successEmailVerification = function (message) {
          enterOtpModal(message)
        },
        errorEmailVErification = function () {
        };
      ModalService.enterEmailVerificationModal({folioNumber: token.folioNumber}, successEmailVerification, errorEmailVErification);
    }

    vm.getTotalNotificationCount = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            vm.notificationCount = resp.data.count;
          } else {
            //MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info("error====", err);
        };
      InvestorService.get({
        child1: 'notification',
        child2: 'count'
      }).$promise.then(success, error);
    };

    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        if (!token) {
          $state.go('login');
          resetFlag();
          return;
        }

        if (token && token.refresh_token) {
          AuthService.getRefreshToken(token).then(function () {
            if(localStorage.getItem('doLogOut')){
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                ModalService.logoutSuccess();
                $state.go('login');
              }, function () {
                ModalService.logoutSuccess();
                $state.go('login');
              });
            }else{
              $state.reload();
              resetFlag();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            $state.go('sessionExpired');
            resetFlag();
          });
        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          $state.go('sessionExpired');
        }
      });

    }

    var resetFlag = function () {
      $timeout(function () {
        isRefreshing = false;
      }, 2000);
    };

    scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in removeListeners) {
        if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
          removeListeners[key]();
        }
      }
    });

    vm.goToState = function (_state) {
      var successHandler = function() {
        TransactionModel.setPayloadRawData(null);
        if (_state === 'purchase') {
          NetcoreEvntService.Transact_Now_Purchase_IP()
        }else if(_state === 'sip'){
          NetcoreEvntService.Transact_Now_SIP_IP()
        }
        if (_state === 'changeDividendOption' || _state === 'rolloverView') {
          $state.go('main.' + _state);
        } else {
          $state.go('main.transactions.' + _state);
        }
      };
      KycService.fetchKycStatus(AppConstants.KYC_RESTRICTION.TRANSACTION).then(successHandler).catch(function(resp) {
        $log.info(resp);
      });
    };

    function fetchMarketData() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            $log.info('market data>>>>> ', resp);
            vm.marketTrendData = resp.data;
          }

        },
        error = function (err) {
          $log.info("error====", err);
        };
      InvestorService.post({child1: 'dashboard', 'child2': 'market-data'}, {}).$promise.then(success, error);
    }

    function fetchMarketNews() {
      var payload = {
        fromDate: "",
        toDate: ""
      };
      var success = function (resp) {
          LoaderService.hideLoader(".market-updates .popup");
          if (resp.status && resp.data) {
            vm.marketNewsList = resp.data.items;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (res) {
          LoaderService.hideLoader(".market-updates .popup");
          MessageService.error(res.message);
        };
      LoaderService.showLoader(".market-updates .popup");
      InvestorService.post({
        child1: 'dashboard',
        child2: 'market-news'
      }, payload).$promise.then(success, error);
    }

    function basicDetails() {
      /*Need to add profileImageUrl nameFull=firstName+middleName+lastName*/
      vm.basic.profileImageUrl = token.profileImageUrl ? token.profileImageUrl : AppConstants.DEFAULT_PROFILE_IMAGE;
      vm.nameFull = token.investorFullName?token.investorFullName:'';
      $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: vm.basic.profileImageUrl});
    }

    function uploadProfileImage(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.basic.profileImageUrl = "";
                $timeout(function () {
                vm.basic.profileImageUrl = resp.data.logoUrl;
                });
                token.profileImageUrl = vm.basic.profileImageUrl;
                AuthService.setToken(token);
                $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            // DistributorProfileUploadService.post({
            InvestorProfilePhotoService.post({
              child1: 'profile',
              child2: 'upload',
              child3: 'logo'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function enterEmailModal() {
      var successModal = function () {
          $state.go('login')
        },
        errorModal = function () {
        };
      ModalService.enterEmailVerificationModal({}, successModal, errorModal)
    }

    function enterOtpModal(message) {
      var successModal = function (message) {
          emailVerifySuccessModal(message)
        },
        errorModal = function () {
        };
      ModalService.enterOtpVerificationModal({
        Text: message,
        folioNumber: token.folioNumber
      }, successModal, errorModal)
    }

    function emailVerifySuccessModal(message) {
      var successModalEmail = function () {
          vm.emailIdExist = true;
          var identifierData = AuthService.getToken();
          identifierData.emailIdExist = true;
          AuthService.setToken(identifierData);
          localStorage.removeItem('emailIdExist');
          if(token.investorType != AppConstants.INVESTOR_TYPE.NEW){
                // $state.go('welcome.existingUserWelcome')
            var successModal = function () {
              },
              errorModal = function (err) {
                MessageService.error(err)
              };
            ModalService.mapFolioModal({name: token.investorFName}, successModal, errorModal);
          }
        },
        errorModalEmail = function () {
        };
      ModalService.emailVerificationSuccessModal({Text: message}, successModalEmail, errorModalEmail)
    }

    function unfinishedTransactionAPI() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.savedItems = resp.data && resp.data.length;
          } else {
            //
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'transaction',
        controller2: 'saved',
        controller3: 'get',
        controller4: 'all'

      }).$promise.then(success, error);
    }

    function unfinishedFoliosAPI() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.savedFolio = resp.data.count;
          }
        },
        error = function () {

        };
      InvestorService.post({
        child1: 'folio',
        child2: 'unsaved'
      }, {}).$promise.then(success, error);
    }

    function favoriteTransactionCountAPI() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.favoriteCount = resp.data;
          }
        },
        error = function () {

        };
      TransactionService.get({
        controller1: 'transaction',
        controller2: 'favourite',
        controller3: 'count'
      }, {}).$promise.then(success, error);
    }

    function goToFirstFolioCreation() {
      // $state.go('folioDetails.folioCreation',{investorId:'3b907fd3-9466-4b25-a115-abe8ee882490'})

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            if(angular.isDefined(resp.data.id)){
              $state.go('folioDetails.holdMode',{investorId:resp.data.id});
            }else{
              $state.go('folioDetails.holdMode');
            }
          } else {
            // vm.folios.unfinishedFoliosList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info("error====", err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      InvestorServiceV3.get({
        child1: 'folio',
        child2: 'draftFolios'
      }).$promise.then(success, error);


    }

    function declareProfileUpdateToolTip() {
      vm.hasFocus = true;
      $timeout(function() {
        angular.element('.basic-profile').tooltip({
          trigger: 'manual',
          placement: 'top auto',
          delay: {show: 50, hide: 400},
          title: AppConstants.TRAI.PROFILE_TOOLTIP_TEXT
        });
        showProfileUpdateToolTip();
      });
    }

    function showProfileUpdateToolTip() {
      angular.element('.basic-profile').tooltip('show');
      angular.element('.basic-profile').on('mouseenter', function() {
        angular.element('.basic-profile').tooltip('show');
      });
      angular.element('.basic-profile').on('mouseeleave', function() {
        angular.element('.basic-profile').tooltip('show');
      });
    }
    /*------------------------------- welcome page updates------------------------------------------*/
    function setWidget() {
      userGreeting();
      vm.user = token ? token.landingPageType : 'Invalid Request';
      switch (vm.user) {
        case AppConstants.LANDING_PAGE_TYPE.EXISTING:
          vm.isExistingInvestor = true;
          return vm.existingUserWidgets;
        case AppConstants.LANDING_PAGE_TYPE.NEW_FIRST_TIME_PROSPECT_FOLIO:
          vm.isExistingInvestor = false;
          return vm.newUserWidgets;
        case AppConstants.LANDING_PAGE_TYPE.OFFLINE:
          vm.isExistingInvestor = false;
          return vm.offlineUserWidgets;
        default:
          return 'Invalid Request';
      }
    }

    function userGreeting() {
      var d = new Date();
      var time = d.getHours();
      if(time>=6 && time<12) {
        vm.greetings = 'Good Morning';
      } else if(time>=12 && time<18) {
        vm.greetings = 'Good Afternoon';
      } else {
        vm.greetings = 'Good Evening';
      }
    }

    function checkImpNotification(){
      if(vm.isImpInfoShown !== 'true'){
        var successHandler = function(resp){
          if(resp.status && resp.data){
            if(resp.data.showPopup && resp.data.folioList){
              var success = function(){
                sessionStorage.setItem('shownPopupOfNomination' , true);
                $state.go('main.profile.folioDetails');
              }, error = function(){};
              ModalService.notificationForNomineeUpdation({text : resp.data.popUpMessage, folioList : resp.data.folioList}, success, error);
            }
          }
        }, errorHandler = function(err){
          MessageService.error(err.message);
        };
        InvestorService.get({
          child1 : 'profile',
          child2 : 'check',
          child3 : 'nominee',
          child4 : 'details'
        }).$promise.then(successHandler, errorHandler);
      }
    }
    /*------------------------------- welcome page updates ends here ------------------------------------------*/

  }
})();

(function () {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('FirstLoginFolioDetailsController', firstLoginFolioDetailsCtrl);

    /** @ngInject */
    function firstLoginFolioDetailsCtrl($state, $scope, $rootScope, $timeout, AuthService, AppConstants, MessageService, UtilService, ModalService) {
      var vm = this;
      vm.stepsAway =0;
      var scope = $scope;
      scope.uiState = $state;

      var removeListeners = {};
      var token = AuthService.getToken();
      localStorage.setItem('isRefreshingFolioToken', false);
      var resetFlag = function () {
        $timeout(function () {
          localStorage.setItem('isRefreshingFolioToken', false);
        }, 2000);
      };

      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (localStorage.getItem('isRefreshingFolioToken') === 'true') {
          return;
        }
        localStorage.setItem('isRefreshingFolioToken',true);

        if (!token) {
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          $timeout(function () {
            $state.go('sessionExpired');
          },0);
          resetFlag();
          return;
        }

        if (token && token.refresh_token) {
          AuthService.getRefreshToken(token).then(function () {
            if(localStorage.getItem('doLogOut')){
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                $state.go('sessionExpired');
              }, function () {
                $state.go('sessionExpired');
              });
            }else{
              $state.reload();
              resetFlag();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            $state.go('sessionExpired');
            resetFlag();
          });
        } else {
          resetFlag();
          AuthService.getRefreshToken(token).then(function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            $state.go('sessionExpired');
          })
        }
      });


      scope.$on("$destroy", function () {
        for (var key in removeListeners) {
          if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
            removeListeners[key]();
          }
        }
      });

    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('EcartReviewController', ecartReviewController);

  /** @ngInject */
  function ecartReviewController($stateParams, LoaderService,TransactionModel, $timeout,investorServiceVersion,ModalService,MessageService,UtilService,AppConstants,$state,$window, HDFC_API ,toastr,$rootScope, $sce, $scope , EcartModel, InvestorService ,notesEcart,DynamicDataSipPurchaseReview, TransactionService) {
    var vm = this;
    vm.formData = TransactionModel.getPayloadRawData()|| {};
    vm.isNavCollapsed = true;
    vm.isCollapsed = false;
    vm.isCollapsedHorizontal = false;
    vm.cartItemList = [];
    vm.investmentArray = AppConstants.ECART_CART_ITEM_NUMBER;
    vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ALL_FUNDS;
    vm.expandSidebar = expandSidebar;
    vm.init = init;
    vm.showSideBarCart = false;
    vm.showSideBarInvest = false;
    vm.showSideAllFunds = false;
    vm.utilService = UtilService;
    vm.moveToPayment = moveToPayment;
    vm.showPopupScreen = showPopupScreen;
    vm.removeCartItem = removeCartItem;
    vm.fetchCartItemList = fetchCartItemList;
    vm.filterEuinList = filterEuinList;
    vm.selectEuin = selectEuin;
    vm.cartError = false;
    vm.notesEcart = notesEcart;
    vm.formData.folioError = null;
    vm.formData.isExceedingEmandateDate = false;
    vm.formData.isExceedingUPIDate = false;
    vm.checkEmandateDateForNPCI = checkEmandateDateForNPCI;
    vm.brokerDetailsFromArn = {};
    vm.resetEuinData = resetEuinData;
    vm.getFoiloDetails = getFoiloDetails;
    vm.checkEuinNameValid = checkEuinNameValid;
    vm.valueExists = true;
    vm.currentDate = $window.moment(Date());

    if(localStorage.getItem("distributorDetails")) {
      vm.linkdata = $window.JSON.parse(localStorage.getItem("distributorDetails"));
    } else if(sessionStorage.getItem("distributorDetails")){
      vm.linkdata = $window.JSON.parse(sessionStorage.getItem("distributorDetails"));
    }
    vm.investThrough = null;
    vm.isNewUser = false;
    init();

    vm.ecartFolioList = [];

    function init() {
      vm.dynamicDataSipPurchaseReview = DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap;
      vm.ecartObj = JSON.parse(sessionStorage.getItem("ecartObj"));
      if(sessionStorage.getItem('userType')) {
        var user = sessionStorage.getItem('userType');
        if(user === 'NEW') {
          vm.isNewUser = true;
        }
      }
      fetchCartItemList('initial');
      $scope.$parent.$parent.Ecart.stateTitle = $state.current.title;
      sessionStorage.removeItem('cgfFlagFromGoalJourney');
      sessionStorage.removeItem('onlyIndividualFolioCreation');
      // expandSidebar();
      var ecartRandomOTPId = EcartModel.getPayloadPayment() || [];
      if(!ecartRandomOTPId.randomOTPId) {
        getRandomOTPId();
      } else {
        vm.randomOTPId = ecartRandomOTPId.randomOTPId ? ecartRandomOTPId.randomOTPId : null;
      }
    }

    function expandSidebar() {
      $window.scrollTo(0,0);
      UtilService.expandSideBar();
    }

    function moveToPayment() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (resp.data.errorExists) {
            vm.cartDetails.errorExists = resp.data.errorExists;
            vm.cartDetails.message = resp.data.message;
            vm.cartError = true;
            resp.data.cartItems.forEach(function (el, index) {
              if (el.errorExists) {
                vm.cartItemList[index].errorExists = el.errorExists;
                vm.cartItemList[index].message = el.message;
                vm.cartError = true;
                $window.scrollTo(0, 0);
              }
            });
          } else {
            if (!vm.cartError) {
              var tncArray = [];
              vm.cartDetails.cartItems.forEach(function (el, index) {

                if (el.sipOpted && el.purchaseOpted) {
                  vm.formData.tncType = 'SIPPURCHASE';
                  return;
                } else if (el.sipOpted && !el.purchaseOpted) {
                  tncArray.push('SIP');
                } else if (!el.sipOpted && el.purchaseOpted) {
                  tncArray.push('PURCHASE');
                }
              });


              if (!vm.formData.tncType) {
                var sipInstanceArr = tncArray.filter(function (el) {
                  return el === 'SIP'
                });

                var purchaseInstanceArr = tncArray.filter(function (el) {
                  return el === 'PURCHASE'
                });


                if (sipInstanceArr.length >= 1 && purchaseInstanceArr.length >= 1) {
                  vm.formData.tncType = 'SIPPURCHASE';
                } else if (sipInstanceArr.length === 0 && purchaseInstanceArr.length >= 1) {
                  vm.formData.tncType = 'PURCHASE';
                } else if (sipInstanceArr.length >= 1 && purchaseInstanceArr.length === 0) {
                  vm.formData.tncType = 'SIP';
                }

              }
              var ecartSummaryData = {
                folioNumber: vm.formData.folioNumber,
                cartItemsInfo: vm.cartDetails.cartItems,
                investThrough: vm.cartDetails.previousTransactionStatus,
                isMinor: vm.cartDetails.minorFlag,
                transactionType: vm.formData.tncType,
                amount: vm.totalSum,
                emandateValidate: vm.emandateEmailMobileValidateObject,
                brokerDetailsPayload: vm.cartDetails.brokerDetailsDTO,
                preLogin: true,
                purchaseAmount: vm.cartDetails.totalAmount,
                isExceedingEmandateDate: vm.formData.isExceedingEmandateDate,
                emandateTotalAmount: vm.emandateTotalAmount,
                startEmandateDate: vm.startEmandateDate,
                endEmandateDate: vm.endEmandateDate,
                isExceedingUPIDate: vm.formData.isExceedingUPIDate,
                upiAmountLimit: vm.upiAmountLimit,
                upiErrorMessage: vm.upiErrorMessage,
                isFromJanNivesh: vm.isFromJanNivesh,
                randomOTPId: vm.randomOTPId
              }
              EcartModel.setPayloadPayment(ecartSummaryData);
              $state.go("preLoginEcartJourney.paymentPage");
            }
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      }

      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART') {
        if(vm.brokerDetailsFromArn.euinNameCode) {
          var euinName = vm.brokerDetailsFromArn.euinNameCode.split('-');
          vm.newCartItemList = vm.cartItemList.map(function (item) {
            item.euinOpted = vm.brokerDetailsFromArn.isEuin ? 'Y' : 'N';
            if (item.euinOpted === 'Y') {
              item.euinName = euinName[0];
              item.euinCode = euinName[1];
            } else {
              if (item.euinCode) {
                delete item.euinCode;
              }

              if (item.euinName) {
                delete item.euinName;
              }
            }
            return item;
          });
        }
        var payload = {
          "folioNumber": vm.formData.folioNumber,
          "cartItems": vm.newCartItemList ? vm.newCartItemList:vm.cartItemList
        };
        payload.linkId= vm.linkdata.chipherText;
      } else {
        vm.cartItemList.forEach(function(item){
          if (!item.brokerCode) {
            item.brokerCode = vm.investThrough;
          }
        });

        var payload = {
          "folioNumber": vm.formData.folioNumber,
          "cartItems": vm.cartItemList
        };
      }
      if (vm.ecartObj && vm.ecartObj.flowName && vm.ecartObj.flowName === "INVEST_NOW_WEBSITE" && vm.ecartObj.linkId) {
        payload.flowName = vm.ecartObj.flowName;
        payload.linkId = vm.ecartObj.linkId
      }
        payload.janNiveshOpted = vm.isFromJanNivesh? vm.isFromJanNivesh: false;
      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART') {
        investorServiceVersion.post({
          child1: 'arn',
          child2: 'cart',
          child3: 'validate'
        }, payload).$promise.then(success, error);
      } else {
        investorServiceVersion.post({
          child1: 'cart',
          child2: 'validate'
        }, payload).$promise.then(success, error);
      }
    }

    function showPopupScreen(screen, item) {
      vm.investorData = setInvestorData();
      switch (screen) {
        case 'INVEST_THROUGH':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.INVEST_THROUGH;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = true;
          vm.showSideAllFunds = false;
          $scope.$broadcast('updatedTitle');
          break;
        case 'CART_DETAILS':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.CART_DETAILS;
          vm.showSideBarCart = true;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = false;
          vm.itemToBeEdited = item;
          vm.showAddCart = false;
          $scope.$broadcast('updatedTitle');
          break;
        case 'ALL_FUNDS':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ALL_FUNDS;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = true;
          vm.showAddCart = true;
          $scope.$broadcast('updatedTitle');
          break;
      }
      expandSidebar();
    }

    function fetchCartItemList(action, payload) {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.cartError = false;
          vm.cartDetails = resp.data;
          vm.maxMandateDurationYears = resp.data.sipSettings && resp.data.sipSettings.eOTM.maxMandateDurationYears;
          vm.maxMandateUPIDurationYears = resp.data.sipSettings && resp.data.sipSettings.upi.maxMandateDurationYears;
          vm.upiAmountLimit = resp.data.sipSettings && resp.data.sipSettings.upi.maxAmountLimit;
          vm.upiErrorMessage = resp.data.sipSettings && resp.data.sipSettings.upiMaxAmountErrMessage;
          vm.isFromJanNivesh = resp.data.janNiveshOpted;
          var investorDetails = JSON.parse(sessionStorage.getItem('investorDetails'));
          if(action === 'initial') {
            var folioNumber = investorDetails ? investorDetails.folioNumber : null;
            if (!resp.data.brokerDetailsDTO) {
              vm.cartDetails.brokerDetailsDTO = investorDetails ? investorDetails.brokerDetailsDTO : null;
            }
            vm.formData.folioNumber = folioNumber ? folioNumber :  resp.data.folioNumber ? resp.data.folioNumber : null;
            if (vm.formData.folioNumber) {
              vm.ecartFolioList = [{
                "folioNumber": vm.formData.folioNumber
              }];

              getFoiloDetails();
            }
          }
          var minorFlag =  sessionStorage.getItem("minorFlag") === "true" ? true : false;
          if (vm.linkdata) {
            minorFlag = vm.linkdata.isMinor ? vm.linkdata.isMinor : false;
            vm.cartDetails.minorFlag = minorFlag;
          }
          vm.formData.minorFlag = minorFlag ? minorFlag : resp.data.minorFlag;
          vm.selectedFolioEmail = resp.data.email;
          vm.selectedFolioMobile = resp.data.mobileNumber;
          vm.cartItemList = resp.data.cartItems ? resp.data.cartItems : [];
          if (resp.data.errorExists) {
            vm.cartError = true;
          }
          if (resp.data.cartItems) {
            resp.data.cartItems.forEach(function (el, index) {
              vm.formData.invType = el.invType;
              if (el.errorExists) {
                vm.cartError = true;
              }
            });
          }
          if(vm.cartItemList){
            var sum = 0;
            vm.totalSum = sum;
            vm.cartItemList.forEach(function (item,index) {
              sum = sum + item.amount;
              /*if (item.sipOpted && item.purchaseOpted) {
                vm.formData.tncType = 'SIPPURCHASE';
              } else if (item.sipOpted && !item.purchaseOpted) {
                vm.formData.tncType = 'SIP';
              } else if (!item.sipOpted && item.purchaseOpted) {
                vm.formData.tncType = 'PURCHASE';
              }*/
              if(payload && payload.cartItems.length > 0) {
                payload.cartItems.forEach(function(obj) {
                  if (item.schemeCode === obj.schemeCode) {
                    item.errorExists = obj.errorExists;
                    item.message = obj.message;
                    if (obj.errorExists) {
                      vm.cartError = true;
                    }
                  }
                });
              }
            });
            vm.totalSum = vm.cartDetails.totalAmount + vm.cartDetails.totalInstallmentAmount;
            checkEmandateDateForNPCI(vm.cartDetails.cartItems);
          } else {
            vm.formData.isExceedingEmandateDate = false;
            vm.formData.isExceedingUPIDate = false;
          }
          vm.showSideAllFunds = false;
          vm.showSideBarInvest = false;
          vm.showSideBarCart = false;
          vm.showAddEcart = false;
          vm.updatedInvestThrough = payload;
          if (action === 'invest') {
            sessionStorage.setItem('brokerDetailsUpdated', true);
          }
          identifyInvestThrough(action);
          if (action === 'initial') {
            vm.emandateEmailMobileValidateObject = {};
            if(vm.selectedFolioMobile === null || vm.selectedFolioMobile === ''){
              if(vm.selectedFolioEmail === null || vm.selectedFolioEmail === ''){
                vm.emandateEmailMobileValidateObject.isEmailMobileinValid = true;
                vm.emandateEmailMobileValidateObject.emandateDisplay = false;
              }
              else {
                vm.emandateEmailMobileValidateObject.isMobileinValid = true;
                vm.emandateEmailMobileValidateObject.emandateDisplay = false;
              }
            }
            else if(vm.selectedFolioEmail === null || vm.selectedFolioEmail === ''){
              if(vm.selectedFolioMobile === null || vm.selectedFolioMobile === ''){
                vm.emandateEmailMobileValidateObject.isEmailMobileinValid = true;
                vm.emandateEmailMobileValidateObject.emandateDisplay = false;
              }
              else {
                vm.emandateEmailMobileValidateObject.isEmailinValid = true;
                vm.emandateEmailMobileValidateObject.emandateDisplay = false;
              }
            }
            if (resp.data.kycVerifiedFlag === false) {
              vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
              ModalService.genericModal({
                text: resp.data.kycMessage
              });
            }
          }
          if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART') {
            preFilledInvestThroughData(resp.data);
          }
        } else {
          vm.cartItemList = [];
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        vm.cartItemList = [];
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART'){
        var arnPayload = {
          linkId: vm.linkdata.chipherText,
        };
        investorServiceVersion.post({
          child1: 'arn',
          child2: 'cart',
          child3: 'item',
          child4: 'list'
        },arnPayload).$promise.then(success, error);
      } else if (vm.ecartObj && vm.ecartObj.flowName && vm.ecartObj.flowName === "INVEST_NOW_WEBSITE" && vm.ecartObj.linkId) {
        investorServiceVersion.get({
          child1: 'cart',
          child2: 'item',
          child3: 'list',
          child4: vm.ecartObj.linkId
        }).$promise.then(success, error);
      } else {
        investorServiceVersion.get({
          child1: 'cart',
          child2: 'item',
          child3: 'list'
        }).$promise.then(success, error);
      }
    }

    function identifyInvestThrough(action) {
      var brokerDetailUpdated = sessionStorage.getItem('brokerDetailsUpdated') === "true" ? true : false;
      if (action === 'initial' && !brokerDetailUpdated) {
        var distributorDetails = vm.cartDetails.previousTransactionStatus;
        if (distributorDetails) {
          if (distributorDetails && distributorDetails.investThroughDistributor && distributorDetails.previousDistributorDetails.brokerCode.indexOf('ARN-') === 0) {
            vm.investThrough = AppConstants.INVEST_THROUGH.DISTRIBUTOR;
            var brokerCode = distributorDetails.previousDistributorDetails.brokerCode ? distributorDetails.previousDistributorDetails.brokerCode.split('-') : [];
            vm.brokerCode = distributorDetails.previousDistributorDetails.brokerCode;
            vm.brokerName = distributorDetails.previousDistributorDetails.brokerName;
            var subBrokerArn = distributorDetails.previousDistributorDetails.subBrokerArn;
            var subBrokerARNArray = subBrokerArn ? subBrokerArn.split('-') : [];
            vm.subBrokerARN = subBrokerARNArray ? subBrokerARNArray[1] : '';
            vm.subBrokerCode = distributorDetails.previousDistributorDetails.subBrokerCode;
            vm.subBrokerName = distributorDetails.previousDistributorDetails.subBrokerName;
            vm.euinMasterList = distributorDetails.previousDistributorDetails.euinDetailList;
            vm.euinList = vm.euinMasterList;
            vm.euin = vm.euinList.length === 1 ? vm.euinList[0] : null;
            vm.euin = distributorDetails.previousDistributorDetails.euinPreviousUsed ? vm.euinList[0] : null;
            vm.euinData = vm.euin ? vm.euin : {};
            if (vm.euinData) {
              vm.euinData.euinNameCode = vm.formData.euin ? vm.formData.euin.euinNameCode : null;
            }
          } else if (distributorDetails && distributorDetails.investThroughRIA) {
            vm.brokerCode = distributorDetails.previousDistributorDetails.brokerCode ? distributorDetails.previousDistributorDetails.brokerCode : "";
            vm.investThrough = AppConstants.INVEST_THROUGH.RIA;
          } else {
            vm.investThrough = AppConstants.INVEST_THROUGH.DIRECT;
          }
        } else if (vm.cartDetails && vm.cartDetails.brokerDetailsDTO) {
          if (vm.cartDetails.brokerDetailsDTO.investThroughRIA) {
            vm.investThrough = 'RIA';
            vm.brokerCode = vm.cartDetails.brokerDetailsDTO.brokerCode;
          } else {
            vm.investThrough = vm.cartDetails.brokerDetailsDTO.brokerCode === 'DIRECT' ? 'DIRECT' : 'DISTRIBUTOR';
            vm.brokerCode = vm.cartDetails.brokerDetailsDTO.brokerCode === 'DIRECT' ? null: vm.cartDetails.brokerDetailsDTO.brokerCode;
          }
        } else {
          vm.investThrough = null;
        }
      } else if (vm.cartDetails && vm.cartDetails.brokerDetailsDTO && brokerDetailUpdated) {
        if (vm.cartDetails && vm.cartDetails.brokerDetailsDTO) {
          if (vm.cartDetails.brokerDetailsDTO.investThroughRIA) {
            vm.investThrough = 'RIA';
            vm.brokerCode = vm.cartDetails.brokerDetailsDTO.brokerCode;
          } else {
            vm.investThrough = vm.cartDetails.brokerDetailsDTO.brokerCode === 'DIRECT' ? 'DIRECT' : 'DISTRIBUTOR';
            vm.brokerCode = vm.cartDetails.brokerDetailsDTO.brokerCode === 'DIRECT' ? null: vm.cartDetails.brokerDetailsDTO.brokerCode;
          }
        } else if (vm.updatedInvestThrough && vm.updatedInvestThrough.brokerDetailsDTO) {
          if (vm.updatedInvestThrough.brokerDetailsDTO.investThroughRIA) {
            vm.investThrough = 'RIA';
            vm.brokerCode = vm.updatedInvestThrough.brokerDetailsDTO.brokerCode;
          } else {
            vm.investThrough = vm.updatedInvestThrough.brokerDetailsDTO.brokerCode === 'DIRECT' ? 'DIRECT' : 'DISTRIBUTOR';
            vm.brokerCode = vm.updatedInvestThrough.brokerDetailsDTO.brokerCode === 'DIRECT' ? null: vm.updatedInvestThrough.brokerDetailsDTO.brokerCode;
          }
        }
      }
      sessionStorage.setItem("investorDetails", JSON.stringify({
        folioNumber: vm.formData.folioNumber,
        brokerDetailsDTO: vm.cartDetails.brokerDetailsDTO ? vm.cartDetails.brokerDetailsDTO : vm.updatedInvestThrough && vm.updatedInvestThrough.brokerDetailsDTO ? vm.updatedInvestThrough.brokerDetailsDTO : null
      }));
    }

    function removeCartItem(item) {
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.cartDetails = resp.data;
          vm.cartItemList = resp.data.cartItems ? resp.data.cartItems : [];
          if (vm.cartItemList) {
            vm.totalSum = vm.cartDetails.totalAmount + vm.cartDetails.totalInstallmentAmount;
          }
        } else {
          vm.cartItemList = [];
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        vm.cartItemList = [];
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var confirmSuccess = function () {
        LoaderService.showLoader();
        if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART'){
          var payload = {
            linkId: vm.linkdata.chipherText
          }
          investorServiceVersion.post({
            child1: 'arn',
            child2: 'cart',
            child3: 'delete',
            child4: 'item',
            child5: item.cartItemId
          },payload).$promise.then(success, error);
        } else if (vm.ecartObj && vm.ecartObj.flowName && vm.ecartObj.flowName === "INVEST_NOW_WEBSITE" && vm.ecartObj.linkId) {
          investorServiceVersion.get({
            child1: 'cart',
            child2: 'delete',
            child3: 'item',
            child4: item.cartItemId,
            child5: vm.ecartObj.linkId
          }).$promise.then(success, error);
        } else {
          investorServiceVersion.get({
            child1: 'cart',
            child2: 'delete',
            child3: 'item',
            child4: item.cartItemId
          }).$promise.then(success, error);
        }
      } , confirmError = function () {};
      ModalService.confirmCancelModalEcart({Text: "Are you sure you want to remove <strong>" + item.schemeName + "</strong> from the cart?"}, confirmSuccess, confirmError);
    }

    function setInvestorData() {
      var payload = {
        folioNumber: vm.formData.folioNumber,
        brokerCode: vm.investThrough === 'DIRECT'? 'DIRECT' : vm.brokerCode,
        euinOpted: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.euinOpted ? vm.cartDetails.brokerDetailsDTO.euinOpted: "N",
        euinCode: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.euinCode ? vm.cartDetails.brokerDetailsDTO.euinCode: null,
        euinName: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.euinName ? vm.cartDetails.brokerDetailsDTO.euinName: null,
        minorFlag: vm.formData.minorFlag,
        brokerKey: null,
        brokerValue: null,
        newUser: false,
        invType: vm.formData.invType,
        subBrokerARN: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.subBrokerArn ? vm.cartDetails.brokerDetailsDTO.subBrokerArn: null,
        subBrokerCode: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.subBrokerCode ? vm.cartDetails.brokerDetailsDTO.subBrokerCode: null,
        investThroughRIA: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.investThroughRIA ? vm.cartDetails.brokerDetailsDTO.investThroughRIA : vm.investThrough === 'RIA'? true : false,
        riaConsent: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.riaConsent ? vm.cartDetails.brokerDetailsDTO.riaConsent
          : vm.investThrough === 'RIA'? true : false,
        directOpted: vm.cartDetails.directOpted && vm.cartDetails.brokerDetailsDTO.directOpted ?
          vm.cartDetails.brokerDetailsDTO.directOpted : vm.investThrough === 'DIRECT' ? true : false,
        investThroughDirect: vm.cartDetails.directOpted && vm.cartDetails.brokerDetailsDTO.directOpted ?
          vm.cartDetails.brokerDetailsDTO.directOpted : vm.investThrough === 'DIRECT' ? true : false,
        investThroughDistributor: vm.investThrough !== 'RIA' && vm.investThrough !== 'DIRECT' ? true: false,
        isFromJanNivesh: vm.isFromJanNivesh
      };
      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART' && vm.brokerDetailsFromArn){
        payload.brokerCode = vm.brokerDetailExist.brokerCode;
        payload.investThroughRIA = vm.brokerDetailsFromArn.investThroughRIA;
      }
      return payload;
    }

    function preFilledInvestThroughData(data){
      vm.brokerDetailExist = data.brokerDetailsDTO;
      vm.brokerDetailsFromArn.directOpted = data.brokerDetailsDTO.directOpted;
      vm.brokerDetailsFromArn.investThroughRIA = data.brokerDetailsDTO.investThroughRIA;
      if(data.brokerDetailsDTO.investThroughRIA){
        vm.brokerDetailsFromArn.riaCode = data.brokerDetailsDTO.brokerCode;
        vm.riaMessage = vm.dynamicDataSipPurchaseReview.TNC_SIP_Review_Through_RIA;
      } else {
        if (data.brokerDetailsDTO.brokerCode && data.brokerDetailsDTO.brokerCode.indexOf('ARN-') === 0) {
          vm.brokerDetailsFromArn.brokerCode = data.brokerDetailsDTO.brokerCode.replace('ARN-', '');
          if(vm.brokerDetailsFromArn.brokerCode) {
            fetchEuinList(vm.brokerDetailsFromArn.brokerCode,"brokerCode");
          }
          vm.brokerDetailsFromArn.subBrokerARN = data.brokerDetailsDTO.subBrokerArn && data.brokerDetailsDTO.subBrokerArn.replace('ARN-', '');
          if(vm.brokerDetailsFromArn.subBrokerARN) {
            fetchEuinList(vm.brokerDetailsFromArn.brokerCode,"subBrokerARN");
          }
          vm.brokerDetailsFromArn.subBrokerCode = data.brokerDetailsDTO.subBrokerArn && data.brokerDetailsDTO.subBrokerArn.replace('ARN-', '');
          vm.brokerDetailsFromArn.isEuin = data.brokerDetailsDTO.euinOpted == 'Y' ? true : false;
          if (data.brokerDetailsDTO.euinName && data.brokerDetailsDTO.euinCode) {
            selectEuin({
              euinNameCode:  data.brokerDetailsDTO.euinName+ '-' +data.brokerDetailsDTO.euinCode
            });
          }
          vm.distributorMessage = vm.dynamicDataSipPurchaseReview.TNC_SIP_Through_Distributor;
        }
      }
    }

    function fetchEuinList(brokerCode,type) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterListARN = resp.data.euinList;
            vm.euinListARN = vm.euinMasterListARN;
          } else {
            vm.euinListARN = [];
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinListARN = null;
        };

      LoaderService.showLoader();
      var path = {};
      if(type == "brokerCode") {
        path = {
          controller1: 'getEuin',
          controller2: 'ARN-' + brokerCode
        };
      } else if(type == "subBrokerARN"){
        path = {
          controller1: 'getEuin',
          controller2: 'ARN-' + brokerCode,
          isSubBroker: true
        };
      }

      TransactionService.get(path).$promise.then(success, error);
    }

    function filterEuinList() {
      vm.brokerDetailsFromArn.euin = {};
      vm.isSelectedEuin = false;
      if(vm.brokerDetailsFromArn.euinNameCode){
        if(vm.brokerDetailsFromArn.euinNameCode.length>=3){
          vm.euinListARN = UtilService.getFilteredList(vm.euinMasterListARN, 'euinNameCode', vm.brokerDetailsFromArn.euinNameCode);
        }
      }
      vm.euinListARN = vm.brokerDetailsFromArn.euinNameCode == '' || vm.brokerDetailsFromArn.euinNameCode == undefined || vm.brokerDetailsFromArn.euinNameCode.length<3 ? vm.euinMasterListARN : vm.euinListARN;
    }

    function selectEuin(data) {
      if (!data) {
        return;
      }
      vm.euinData = {};
      vm.brokerDetailsFromArn.euinNameCode = data.euinNameCode;
      vm.isSelectedEuin = vm.brokerDetailsFromArn.euinNameCode ? true : false;
      checkEuinNameValid(data.euinNameCode);
    }

    function resetEuinData() {
      vm.brokerDetailsFromArn.euinCode = null;
      vm.brokerDetailsFromArn.euinName = null;
      vm.brokerDetailsFromArn.euinNameCode = null;
    }

    function checkEmandateDateForNPCI(cartItems){
      vm.startEmandateDate = findMinDate(cartItems);
      vm.endEmandateDate = findMaxDate(cartItems);
      vm.emandateTotalAmount = findMaxAmount(cartItems);

      var emandateEndDate = $window.moment(vm.startEmandateDate,'DD-MMM-YYYY').add(vm.maxMandateDurationYears,'years');
      var selectedEndDate = $window.moment(vm.endEmandateDate,'DD-MMM-YYYY');
      var endDateEmandateBoundExist = selectedEndDate.isBefore(emandateEndDate);
      vm.found = cartItems.some(function (ele){
        return ele.sipOpted == true
      });
      if (!endDateEmandateBoundExist && vm.found) {
        vm.formData.isExceedingEmandateDate = true;
      } else {
        vm.formData.isExceedingEmandateDate = false;
      }

      var upiEndDate = $window.moment(vm.currentDate,'DD-MMM-YYYY').add(vm.maxMandateUPIDurationYears,'years');
      var selectedUpiEndDate = $window.moment(vm.endEmandateDate,'DD-MMM-YYYY');
      var upiEmandateBoundExist = selectedUpiEndDate.isBefore(upiEndDate);
      vm.upiFound = cartItems.some(function (ele){
        return ele.sipOpted == true
      });
      if (!upiEmandateBoundExist && vm.upiFound) {
        vm.formData.isExceedingUPIDate = true;
      } else {
        vm.formData.isExceedingUPIDate = false;
      }
    }

    function findMinDate(items){
      var min_dt = items[0].sipDate,
        min_dtObj = new Date(items[0].sipDate);
      items.forEach(function(dt, index) {
        if ( new Date( dt.sipDate ) < min_dtObj) {
          min_dt = dt.sipDate;
          min_dtObj = new Date(dt.sipDate);
        }
      });
      return min_dt;
    }

    function findMaxDate(items) {
      var max_dt = items[0].toDate,
        max_dtObj = new Date(items[0].toDate);
      items.forEach(function(dt, index) {
        if ( new Date( dt.toDate ) > max_dtObj) {
          max_dt = dt.toDate;
          max_dtObj = new Date(dt.toDate);
        }
      });
      return max_dt;
    }

    function findMaxAmount(items){
      var totalEmandateAmount = 0;
      items.forEach(function(amt, index) {
        totalEmandateAmount = totalEmandateAmount + amt.installmentAmount
      });
      return totalEmandateAmount
    }

    /**
     * Function responsible for fetching folio data related t0 nominee being added or not
     */

    function getFoiloDetails(){
      var success = function (resp) {
        if (resp.status && resp.data) {

          vm.folioData = resp.data;
          vm.noNomination = vm.folioData.noNomination;

          if(vm.noNomination == null || vm.noNomination == "") {
            ModalService.optOutNomineeModal({
              OneClickHdfcCheque : true,
              folio:vm.formData.folioNumber,
              redirectionalLink:"https://digital.camsonline.com/changeofnomination"
            }, success, error)
          }

        }else{
          MessageService.error(resp.message);
        }
      },error = function (err) {
        UtilService.errorHandler(err);
      };
      InvestorService.post({child1: 'profile',child2: 'folio',child3: 'details',
      },{"folioNumber":vm.formData.folioNumber}).$promise.then(success, error);
    }

    function checkEuinNameValid(euinName) {
      if(euinName) {
        vm.valueExists = vm.euinListARN.some(function (euin) {
          return euin.euinNameCode == euinName
        });
      }
    }

    function getRandomOTPId() {
      var successRandomOTPIdHandler = function(resp) {
        vm.randomOTPId = resp.randomOTPId ? resp.randomOTPId : null;
      }, errorRandomOTPIdHandler = function (){}
      UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
    }

  }

})();

/**
 * Created by ttn on 21/03/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('EcartPreLoginTokenController', ecartPreLoginTokenController);

  /** @ngInject */
  function ecartPreLoginTokenController($window, $stateParams, AuthService, LoaderService, $state, ModalService, $timeout, AppConstants ,
                                   InvestmentModel, InvestmentBasketService, MessageService, CommonFactory, UtilService, InvestorService, $scope, $rootScope,HDFC_API) {
    var vm = this;
    vm.HDFC_API =HDFC_API;
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    vm.isLoading = true;
    vm.init = init;
    vm.arnCartSave = arnCartSave;
    vm.stateTitle = $state.current.title;
    var removeListeners = {}, isRefreshing = false;
    var scope = $scope;
    var isMinor = JSON.parse(sessionStorage.getItem("minorFlag"));
    if(localStorage.getItem("distributorDetails")) {
      vm.linkdata = $window.JSON.parse(localStorage.getItem("distributorDetails"));
      if (isMinor) {
        vm.linkdata.isMinor = isMinor;
        localStorage.setItem("distributorDetails",$window.JSON.stringify(vm.linkdata));
      }
    } else if(sessionStorage.getItem("distributorDetails")){
      vm.linkdata = $window.JSON.parse(sessionStorage.getItem("distributorDetails"));
      if (isMinor) {
        vm.linkdata.isMinor = isMinor;
        sessionStorage.setItem("distributorDetails",$window.JSON.stringify(vm.linkdata));
      }
    }
    vm.folioNumberFromArn = $window.sessionStorage.getItem("folioNumberFromArn");
    vm.uuid = $stateParams.uuid;
    sessionStorage.setItem('basketUuid', $stateParams.uuid);
    init();
    function init() {
      getToken();
      setListeners();
      //redirectToEcartReview();
    }

    function getToken() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.isLoading = true;
          resp.data.access_token = resp.data.accessToken;
          resp.data.investorPAN = resp.data.panNumber;
          AuthService.setToken(resp.data);
          vm.investorType = resp.data.registrationType;
          vm.userPan = resp.data.panNumber;
          if (resp.data.linkId && resp.data.flowName) {
            var ecartObj = {
              linkId: resp.data.linkId ? resp.data.linkId: "",
              flowName: resp.data.flowName ? resp.data.flowName: ""
            };
            sessionStorage.setItem("ecartObj", JSON.stringify(ecartObj));
          } else {
            sessionStorage.removeItem("ecartObj");
          }
          sessionStorage.setItem('userType',vm.investorType);
          if(vm.linkdata && vm.linkdata.flowName == "E_CART") {
            sessionStorage.setItem('cgfFlagFromGoalJourney',vm.linkdata.cgfSchemeOpted);
            sessionStorage.setItem('onlyIndividualFolioCreation',vm.linkdata.retirementSchemeOpted);
          } else {
            sessionStorage.setItem('cgfFlagFromGoalJourney',resp.data.cgfSchemeOpted);
            sessionStorage.setItem('onlyIndividualFolioCreation',resp.data.retirementSchemeOpted);
          }
          sessionStorage.setItem('pd', encodeURI(JSON.stringify({
            "panNumber": vm.userPan
          })));
          if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART' && vm.folioNumberFromArn){
            arnCartSave();
          }
          vm.getNewUserDetails(resp.data.investorPAN);
        } else {
          MessageService.error(resp.message);
          $state.go('login');
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err);
      };
      sessionStorage.removeItem('FolioCreated');
      sessionStorage.removeItem("minorFlag");
      sessionStorage.removeItem('investorDetails');
      InvestorService.get({
        child1: 'preLogin',
        child2: 'getToken',
        child3: vm.uuid
      }).$promise.then(success, error);
    }

    function redirectToEcartReview(invType) {
      vm.isLoading = true;
      var verifyObj = {
        panNumber: vm.userPan,
        dob: $window.moment(vm.dob,"YYYY-MM-DD").format('DD-MMM-YYYY'),
        uuid: vm.uuid,
        flowName: 'ECART'
      };
      $window.sessionStorage.setItem("verifyObj", JSON.stringify(verifyObj));
      if (invType === 'NEW') {
        vm.stateTitle = vm.stateTitle ? vm.stateTitle :'Folio';
        $state.go('preLoginEcartJourney.folio', {
          journey: 'ECART'
        });
      } else {
        $state.go('preLoginEcartJourney.cartReview');
      }
    }

    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        if (!token) {
          $state.go('login');
          resetFlag();
          return;
        }

        if (token && token.refreshToken) {
          token.refresh_token = token.refreshToken;
          AuthService.getRefreshToken(token).then(function () {
            if (localStorage.getItem('doLogOut')) {
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                ModalService.logoutSuccess();
                $state.go('login');
              }, function () {
                ModalService.logoutSuccess();
                $state.go('login');
              });
            } else {
              $state.reload();
              resetFlag();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            $state.go('login');
            resetFlag();
          });
        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          $state.go('login');
        }
      });

      var resetFlag = function () {
        $timeout(function () {
          isRefreshing = false;
        }, 2000);
      };

      scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in removeListeners) {
          if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
            removeListeners[key]();
          }
        }
      });
    }
    function arnCartSave() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {

        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err);
      };
      var arnPayload = {
        folioNumber: vm.folioNumberFromArn ? vm.folioNumberFromArn: null,
        linkId: vm.linkdata.chipherText,
      }
      InvestorService.post({
        child1: 'arn',
        child2: 'cart',
        child3: 'save'
      },arnPayload).$promise.then(success, error);
    }

    vm.getNewUserDetails = function(pan){
      var success = function (resp) {
        vm.dob = resp.data.dob;
          redirectToEcartReview(vm.investorType);
        },
        error = function (error) {
          MessageService.error(error.message);
        };
      vm.taxIdentifier = pan;
      var payload = {
        "panNumber": vm.taxIdentifier
      }
      InvestorService.post({child1: 'new',child2: 'user',child3: 'getDetails'},payload).$promise.then(success, error);
    }

  }
})();

/**
 * Created by ttn on 21/03/23.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('EcartPreLoginController', ecartPreLoginController);

  /** @ngInject */
  function ecartPreLoginController($window, $stateParams, AuthService, LoaderService, $state, ModalService, $timeout, AppConstants ,
                                    InvestmentModel, InvestmentBasketService, MessageService, CommonFactory, UtilService, InvestorService, $scope, $rootScope,HDFC_API) {
    var vm = this;
    vm.HDFC_API =HDFC_API;
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    vm.isLoading = true;
    vm.init = init;
    vm.stateTitle = $state.current.title;
    var removeListeners = {}, isRefreshing = false;
    var scope = $scope;
    vm.uuid = $stateParams.uuid;
    vm.logoutMe = logoutMe;
    init();
    function init() {
      setListeners();
    }

    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (isRefreshing) {
          return;
        }
        isRefreshing = true;
        var token = AuthService.getToken();

        if (!token) {
          $state.go('login');
          resetFlag();
          return;
        }

        if (token && token.refreshToken) {
          token.refresh_token = token.refreshToken;
          AuthService.getRefreshToken(token).then(function () {
            if (localStorage.getItem('doLogOut')) {
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                ModalService.logoutSuccess();
                $state.go('login');
              }, function () {
                ModalService.logoutSuccess();
                $state.go('login');
              });
            } else {
              $state.reload();
              resetFlag();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            $state.go('login');
            resetFlag();
          });
        } else {
          resetFlag();
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          $state.go('login');
        }
      });

      var resetFlag = function () {
        $timeout(function () {
          isRefreshing = false;
        }, 2000);
      };

      scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in removeListeners) {
          if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
            removeListeners[key]();
          }
        }
      });
    }

    function logoutMe() {
      var user = sessionStorage.getItem('userType');
      var val = JSON.parse(decodeURI(sessionStorage.getItem('pd')));
      val.flowName = 'E_CART';
      if (user === 'NEW') {
        var success = function (resp) {
          localStorage.removeItem("userId");
          var newDataLayer = $window.dataLayer.filter(function (obj) {
            return !obj.hasOwnProperty('userId');
          });
          $window.dataLayer = newDataLayer;
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          CommonFactory.setLogoutSuccess();
          $state.go('login');
        },
        error = function (err) {
        };
        LoaderService.showLoader('.logout');
        InvestorService.post({
          child1: 'force',
          child2: 'logout'
        }, val).$promise.then(success, error);
      } else {
        AuthService.logout('pre-login').then(function () {
          localStorage.removeItem("userId");
          var newDataLayer = $window.dataLayer.filter(function (obj) {
            return !obj.hasOwnProperty('userId');
          });
          $window.dataLayer = newDataLayer;
          CommonFactory.setLogoutSuccess();
          $state.go('login');
        }, function () {});
      }
    }

  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('EcartModel', ecartModel);

  /** @ngInject */
  function ecartModel() {
    var paymentpayload = {
      folioNumber : '',
      cartItemsInfo : [],
      investThrough : {},
      isMinor : false,
      transactionType: '',
      amount:'',
      emandateValidate: {}
    };

    function setPaymentPayload(payload) {
      paymentpayload.folioNumber = payload && payload.folioNumber || null;
      paymentpayload.cartItemsInfo = payload && payload.cartItemsInfo || null;
      paymentpayload.investThrough = payload && angular.copy(payload.investThrough) || null;
      paymentpayload.isMinor = payload && payload.isMinor || false;
      paymentpayload.transactionType = payload && payload.transactionType || null;
      paymentpayload.amount = payload && payload.amount || null;
      paymentpayload.emandateValidate = payload && angular.copy(payload.emandateValidate) || null;
      paymentpayload.brokerDetailsPayload = payload && payload.brokerDetailsPayload || null;
      paymentpayload.preLogin = payload && payload.preLogin || false
      paymentpayload.purchaseAmount = payload && payload.purchaseAmount || null;
      paymentpayload.isExceedingEmandateDate = payload && payload.isExceedingEmandateDate || false;
      paymentpayload.emandateTotalAmount = payload && payload.emandateTotalAmount || null;
      paymentpayload.startEmandateDate = payload && payload.startEmandateDate || null;
      paymentpayload.endEmandateDate = payload && payload.endEmandateDate || null;
      paymentpayload.isExceedingUPIDate = payload && payload.isExceedingUPIDate || false ;
      paymentpayload.upiAmountLimit = payload && payload.upiAmountLimit || null;
      paymentpayload.upiErrorMessage = payload && payload.upiErrorMessage || "";
      paymentpayload.isFromJanNivesh = payload && payload.isFromJanNivesh || false;
      paymentpayload.randomOTPId = payload && payload.randomOTPId || null;

    }

    function getPaymentPayload() {
      return angular.copy(paymentpayload);
    }

    return {
      setPayloadPayment : setPaymentPayload,
      getPayloadPayment : getPaymentPayload
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FolioSelectController', folioSelectController);

  /** @ngInject */
  function folioSelectController($stateParams, LoaderService,TransactionModel, $timeout,InvestorService,ModalService,MessageService,UtilService,AppConstants,$state,$window, HDFC_API ,toastr,$rootScope, $sce , TransactionService , FolioModel , investorServiceVersion , EcartModel, $scope) {
    var vm = this;
    vm.chooseFolio = chooseFolio;
    vm.maskid = maskid;
    vm.maskemail = maskemail;
    vm.maskemobileNo = maskemobileNo;
    vm.maskedFolioList = [];

    vm.folioList = [];

    for (var j = 0; j < vm.folioList.length; j++) {
      if (vm.folioList[j]) {
        if (vm.folioList[j].id) {
          var id = maskid(vm.folioList[j].id);
        }
        if (vm.folioList[j].email) {
          if(vm.folioList[j].email == "null"){
            vm.folioList[j].email="";
          }else{
            var email = maskemail(vm.folioList[j].email);
          }
        }
        if (vm.folioList[j].mobileNo) {
          var mobileNo = maskemobileNo(vm.folioList[j].mobileNo);
        }
        var obj = {
          "id": id,
          "email": email ? email : "",
          "mobileNo": mobileNo ? mobileNo : "",
          "folioNumber":vm.folioList[j].id
        }

        vm.maskedFolioList.push(obj);
        console.log(vm.maskedFolioList)
        obj = {}

      }
    }

    function chooseFolio(val) {

    }

    function maskid(val) {
      var endVal = val.substr(-3);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 3) {
        maskyVal += "*";
        valLength--;
      }
      return maskyVal + endVal;
    }

    function maskemail(val) {
      if(val == "null"){
        return val="";
      }
      var valArray = val.split("@");
      var startVal = valArray[0];
      var endVal = valArray[1];
      var maskyVal = "";
      for (var i = 0; i < startVal.length; i++) {
        if (i == 0) {
          maskyVal += startVal[i];
        }
        if (i == 1) {
          maskyVal += "*";
        }
        if (i > 1) {
          if (i % 2 == 0) {
            maskyVal += "*";
          } else {
            maskyVal += startVal[i];
          }
        }
      }
      return maskyVal + "@" + endVal;
    }

    function maskemobileNo(val) {
      if(val == "null"){
        return val="";
      }
      var endVal = val.substr(-4);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 4) {
        maskyVal += "*";
        valLength--;
      }
      return maskyVal + endVal;
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('EcartPaymentController', ecartPaymentController);

  /** @ngInject */
  function ecartPaymentController(ModalService, AppConstants, $window, $timeout, $state, $rootScope, $scope,
                                  $stateParams, TransactionModel, LoaderService, TransactionService,
                                  InvestorService, MessageService, UtilService, $log, HDFC_API, TransactionServiceVersion, FileUploadServiceVersion2,$sce, DownloadPdfService,FileSaver ,  notesEcart , EcartModel, AuthService , CommonFactory, $filter, PaymentService, investorServiceVersion){
    var vm = this;
    vm.formDataPayment = EcartModel.getPayloadPayment() || [];
    vm.setInitialFormData = setInitialFormData;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.PATTERN = AppConstants;
    vm.downloadPdfFile=downloadPdfFile;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    $scope.billdeskUrl = HDFC_API.BILLDESK_URL;
    vm.NRI_STATUS_CODES = AppConstants.NRI_STATUS_CODES;
    vm.isOTMEndDate= false;
    vm.showTermConditions = showTermConditions;
    vm.showTermConditionsemandate = showTermConditionsemandate;
    vm.showTerms = true;
    vm.isCheckedTandCeMandate = false;
    vm.isCheckedTandC = false;
    vm.showTermsEmandate = true;
    vm.utilService = UtilService;
    vm.emandateMinAmountLimit = null;
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.isLessThanSipAmount = false;
    vm.sipDateLessEmandate = false;
    vm.changeEndDateEmandate = changeEndDateEmandate;
    vm.viewMode = 'days';
    vm.minEmandateDate = null;
    vm.defaultMandateYearDate = AppConstants.DEFAULT_EMANDATE_MAX_YEAR;
    vm.emandateWord = {};
    vm.initialPaymentModeSet = true;
    vm.setPaymentModesForHDFC = setPaymentModesForHDFC;
    vm.handleBankOnlyHdfcBank = handleBankOnlyHdfcBank;
    vm.currentDate =  $window.moment(Date());
    vm.sipUpiText = vm.TRANSACTIONS_CONST.DESCRIPTIONS.UPI_AUTOPAY;
    vm.isNewUser = false;


    vm.checkForMinorBankListCondition = function() {
      /*if(vm.formData!=null && vm.formData.minorFlag!=null && vm.formData.cgfFlag!=null)
        return vm.formData.minorFlag && !vm.formData.cgfFlag;
      else*/
      return false;
    };


    vm.isUPIVerified = false;
    vm.isCheckedDeclaration = false;
    vm.bankList = null;
    vm.bankInfo = null;
    vm.investorInfo = null;
    vm.debitCardType = 'visa';
    vm.isInvalidForm = false;
    vm.selectedUpiBank = selectedUpiBank;
    vm.hideOtmOtion = false;
    vm.verifyUPI = verifyUPI;
    vm.getAccountNumber = getAccountNumber;
    vm.checkOtmList = checkOtmList;
    var TrFlowType = {NEW:'NEW',OLD:'OLD'};
    vm.tpv = tpv;
    vm.netBankingAndUPIList = null;
    vm.OTMList = null
    vm.isOTMAmount = false;
    vm.isOTMDate = false;
    vm.isOTMStartDate = false;
    vm.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.notesPayment = notesEcart;
    vm.notesSIP =  notesEcart;
    vm.noteNetBanking = vm.notesPayment.noteDTO.noteDTOMap.Note_Purchase_Net_Banking;
    vm.billdeskPayload = {
      hidRequestId : "PGIME1000",
      hidOperation : "ME100",
      msg : ""
    };
    vm.isNewPayment = true;
    if(localStorage.getItem("distributorDetails")) {
      vm.linkdata = $window.JSON.parse(localStorage.getItem("distributorDetails"));
    } else if(sessionStorage.getItem("distributorDetails")){
      vm.linkdata = $window.JSON.parse(sessionStorage.getItem("distributorDetails"));
    }

    vm.changeRtgsPaymentOption = changeRtgsPaymentOption;
    vm.bankUploadChequeLeafFile = bankUploadChequeLeafFile;
    vm.openUploadedDoc = openUploadedDoc;
    vm.verifyVirtualUPI = verifyVirtualUPI;
    vm.handleVpa = handleVpa;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff", "application/pdf"];
    vm.chooseAFile = true;
    var token = AuthService.getToken();
    vm.nriFlag = token ? token.nriFlag: null;

    function tpv(event) {
      event.preventDefault();
      ModalService.tpvModal({});
    }

    function handlePurchaseResponse(data) {
      var redirectionDataForRazorPay = data;
      var transactionId = data && data.transactionId ? data.transactionId : null;
      data = data && data.data ? data.data : data;
      vm.billdeskMsg = data;
      if (!data) {
        MessageService.error();
        return;
      }
      LoaderService.showLoader();
      if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
        handleEmandateRedirection();
      } else if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM || vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC || vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
        handleOtherRedirection();
      } else if(vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING && vm.formData.paymentInfo.gatewayVendor.toUpperCase() === 'BILLDESK') {
        handleBillDeskRedirection();
      } else if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING && vm.formData.paymentInfo.gatewayVendor.toUpperCase() === 'BILLJUNCTION') {
        handleBillJunctionRedirection();
      } else if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING && vm.formData.paymentInfo.gatewayVendor.toUpperCase() === 'RAZORPAY') {
        if(vm.formData.investmentType.toUpperCase() == "SIPPURCHASE" || vm.formData.investmentType.toUpperCase() == "PURCHASE") {
          redirectionDataForRazorPay.trnxActionMsg = redirectionDataForRazorPay.redirectUrl;
        }
        handleRazorPayRedirection(redirectionDataForRazorPay);
      }
    }

    function handleBillDeskRedirection() {
      if (vm.billdeskMsg.cartId) {
        $window.open(vm.billdeskMsg.redirectUrl, '_self');
      } else {
        vm.billdeskPayload.msg = vm.billdeskMsg.redirectUrl;
        $timeout(function () {
          angular.element('#billdeskForm').submit();
          if (vm.formDataPayment.preLogin) {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
          }
        });
      }
    }

    function handleBillJunctionRedirection() {
      if (vm.formDataPayment.preLogin) {
        AuthService.clearCookies(AppConstants.IDENTIFIER);
      }
      $window.open(vm.billdeskMsg.redirectUrl, '_self');
    }

    function handleEmandateRedirection() {
      if (vm.formDataPayment.preLogin) {
        AuthService.clearCookies(AppConstants.IDENTIFIER);
      }
      $window.location.href = $scope.billdeskUrl + vm.billdeskMsg.redirectUrl;
    }

    function handleOtherRedirection() {
      if (vm.formDataPayment.preLogin) {
        AuthService.clearCookies(AppConstants.IDENTIFIER);
      }
      $window.location.href = vm.billdeskMsg.redirectUrl;
    }

    vm.showUPISuccessPopup = function () {
      var successModal = function () {
          $state.go('welcome');
        },
        errorModal = function () {
          $state.go('welcome');
        };
      //ModalService.upiSuccessModal({}, successModal, errorModal);
    };
    /*function getPaymentInfo() {
      var paymentInfo={};
      paymentInfo = {
        folioNumber: vm.formData.folioNumber,
        flowName: 'E_CART'
      };


      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          paymentInfo.amount = vm.formDataPayment.amount;
          paymentInfo.paymentOption = vm.formData.purchasePaymentOption;
          paymentInfo.gatewayVendor = vm.formData.paymentInfo.webMode;
          paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
          paymentInfo.accType = vm.formData.paymentInfo.accType;
          paymentInfo.bankName = vm.bankInfo.bankNameOnly;
          paymentInfo.branchName = vm.bankInfo.branchName;
          paymentInfo.bankCity = vm.bankInfo.bankBranch;
          paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
          paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          paymentInfo.otmId = vm.formData.paymentInfo.otmId;
          paymentInfo.bankName = vm.formData.paymentInfo.bankName;
          paymentInfo.branchName = vm.formData.paymentInfo.bankBranch;
          paymentInfo.accNo = vm.formData.paymentInfo.bankAcNo;
          paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
          paymentInfo.payoutId = vm.formData.paymentInfo.payoutId;
          paymentInfo.omUmrn = vm.formData.paymentInfo.omUmrn;
          paymentInfo.camsMandateIdNo = vm.formData.paymentInfo.camsMandateIdNo;
          paymentInfo.accType = vm.formData.paymentInfo.accType;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
          paymentInfo.bankName = vm.formData.paymentInfo.bankName;
          paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
          paymentInfo.accNo = vm.formData.paymentInfo.accNo;
          paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
          paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
          paymentInfo.accType = vm.formData.paymentInfo.bankAcType;
          paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
          if(vm.isNewPayment) {
            paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
          }
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
          paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
          paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
          paymentInfo.accountHolderName = vm.formData.paymentInfo.accountHolderName;
          paymentInfo.bankName = "HDFC Bank Ltd";
          paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
          paymentInfo.bankAcNo = vm.formData.paymentInfo.bankAcNo;
          paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
          paymentInfo.accType = vm.formData.paymentInfo.accType;
          paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
          paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
          paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
          paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
          paymentInfo.upiReferenceNumber = vm.transactionNumber;
          paymentInfo.accountNumber = vm.upiAccountNumber;
          paymentInfo.accNo= paymentInfo.accountNumber;
          paymentInfo.accType = vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType;
          paymentInfo.bankName = vm.upiBankName;
          paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
          paymentInfo.paymentModeSip = "EC";
          paymentInfo.accNo = paymentInfo.accNo;
          paymentInfo.accType = paymentInfo.accType;
          paymentInfo.bankName = paymentInfo.bankName;
          paymentInfo.branchName = paymentInfo.branchName;
          paymentInfo.bankCity = paymentInfo.bankCity;
          paymentInfo.bankCity = vm.bankInfo.bankCode;
          paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:
          break;
      }
      return angular.copy(paymentInfo);
    }*/

    function getPayload() {
      var payload = vm.formData.paymentInfo;
      payload.folioNumber =  vm.formData.folioNumber;
      payload.flowName = 'E_CART';
      payload.cartItems = vm.formDataPayment.cartItemsInfo;
      payload.preLogin = vm.formDataPayment.preLogin;
      payload.cartItems.forEach(function (el) {
        if (el.camsReferenceNo) {
          delete el.camsReferenceNo;
        }
        //el = handleBrokerCode(el);
      });
      payload.secretLink = vm.secretLink;
      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART'){
        payload.linkId = vm.linkdata.chipherText;
      }
      if(vm.formData.purchasePaymentOption == 'E-mandate') {
        payload.emandateStartDate = moment(vm.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
        payload.emandateEndDate = moment(vm.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
        payload.mandateAmount = vm.formData.emandateAmount;
      }
      if(vm.formData.investmentType == 'SIP' && vm.formData.purchasePaymentOption === 'UPI'){
        payload.paymentModeSip = "UAP";
      } else if (vm.formData.investmentType === 'PURCHASE' && vm.formData.purchasePaymentOption === 'UPI') {
        payload.paymentOption = "UPI";
      } else if(vm.formData.investmentType == 'SIPPURCHASE' && vm.formData.purchasePaymentOption === 'UPI') {
        payload.paymentModeSip = "UAP";
        payload.paymentOption = "UAP";
      }
      if(vm.formData.purchasePaymentOption === 'UPI') {
        payload.payerVpa = vm.formData.virtualAddress;
        payload.payerName = vm.formData.verifyUPIResp.name;
      }

      if (vm.ecartObj && vm.ecartObj.flowName && vm.ecartObj.flowName === "INVEST_NOW_WEBSITE" && vm.ecartObj.linkId) {
        payload.flowName = vm.ecartObj.flowName;
        payload.linkId = vm.ecartObj.linkId
      }
      return payload;
    }

    function checkBankList(){
      if (vm.bankList && vm.bankList.length == 1) {
        vm.bankInfo = vm.bankList[0];
        if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
          localStorage.setItem('folioId',vm.formData.folioNumber);
          ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
          return;
        };
        if(vm.formData.investmentType === 'SIPPURCHASE') {
          vm.formData.paymentInfo.paymentModeSip = "EC";
          vm.formData.paymentInfo.paymentOption = vm.formData.purchasePaymentOption;
        } else if (vm.formData.investmentType === 'PURCHASE') {
          vm.formData.paymentInfo.paymentOption = vm.formData.purchasePaymentOption;
        }
        vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
        vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
        vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
        vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
        vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
        vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
        vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
        vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
        vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
        vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
        vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
        vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
        vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
        (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
        if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
          checkOTMAmountAndDate();
        }
        if(vm.formData.purchasePaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
          selectedUpiBank();
        }
      }
    }

    function fetchBankList(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.otmList = resp.data;
            if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
              vm.bankList = vm.formData.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList;
            } else {
              vm.bankList = resp.data.bankList;
            }
            handleBankOnlyHdfcBank();
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            if(vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING ||
              vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
              vm.netBankingAndUPIList = vm.bankList;
            }
            if(vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM){
              vm.OTMList = vm.bankList;
            }
            if (vm.bankList && vm.bankList.length == 1) {
              if(!vm.formData.paymentInfo) {
                vm.formData.paymentInfo = {};
              }
              vm.bankInfo = vm.bankList[0];
              if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
                localStorage.setItem('folioId',vm.formData.folioNumber);
                ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
                return;
              }
              vm.changeBank();
              (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
              if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
                checkOTMAmountAndDate();
              }
              if(vm.formData.purchasePaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
                selectedUpiBank();
              }
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
          cb(true);
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();

      var config = null;
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          if(vm.netBankingAndUPIList === null){
            config = {child1: 'bank', child2: 'list'};
            InvestorService.post(config, {
              trnxType: 'PURCHASE',
              folioNumber: vm.formData.folioNumber,
              liquidSchemeFlag: vm.formData.schemeTypeLiquid ? true : false
            }).$promise.then(success, error);} else {
            cb(true)
            LoaderService.hideLoader();
          }
          vm.bankList = vm.netBankingAndUPIList;
          handleBankOnlyHdfcBank();
          checkBankList();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if(vm.OTMList === null) {
            config = {child1: 'folio', child2: 'otm'};
            InvestorService.post(config, {
              folioNo: vm.formData.folioNumber,
              transactionType: 'purchase'
            }).$promise.then(success, error);
          } else {
            LoaderService.hideLoader();
          }
          vm.bankList = vm.OTMList;
          checkBankList();
          break;
        default :
          vm.bankList = null;
          config = null;
          break;
      }
    }

    function resetUPIForm() {
      vm.verifyUPIResp = {};
      vm.isUPIVerified = false;
      (vm.formData.paymentInfo)&&(vm.formData.paymentInfo.virtualAddress = "");
    }

    vm.init = function () {
      if (vm.formDataPayment.folioNumber === "") {
        $state.go('preLoginEcartJourney.cartReview');
        return;
      }
      vm.ecartObj = JSON.parse(sessionStorage.getItem("ecartObj"));
      if(sessionStorage.getItem('userType')) {
        var user = sessionStorage.getItem('userType');
        if(user === 'NEW') {
          vm.isNewUser = true;
        }
      }
      $window.scrollTo(0,0);
      initActivity();
    };

    function getDetails(cb) {
      cb = cb ||function () {
      };
      var success = function (resp) {
        var bankDetails=[];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if(vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length>0){
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if(value.defaultBank===true){return value;}
          });
        }
        localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
        cb();
      }, error = function () {
        LoaderService.hideLoader();
        cb();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }


    function initActivity() {
      setInitialFormData();

      if(vm.formData.investmentType==='SIP')
      {
        vm.paymentOptions = [
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE
        ];
      } else if (vm.formData.investmentType==='PURCHASE') {
        // vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING]
        if (vm.formData.schemeTypeLiquid) {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
          ];
        } else {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          ];
        }
      } else {
        if (vm.formData.schemeTypeLiquid) {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
          ];
        } else {
          vm.paymentOptions = [
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
            vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,
          ];
        }
      }
      setPaymentModesForHDFC();
      vm.formData.purchasePaymentOption = vm.paymentOptions[0];
      vm.formData.trackId = $stateParams.trackId?$stateParams.trackId:vm.formData.trackId;
      getDetails(function () {
        if (vm.formData.investmentType==='PURCHASE') {
          vm.changedPaymentOption();
          fetchBankList(function (success) {
            if(success){
              checkOTM();
            }
            showHideUpi();
          });
        } else if (vm.formData.investmentType==='SIP') {
          fetchBankListForUPI();
          fetchBankListForSip(function (success) {
            if(success){
              checkOTM(function (success){
                if(success){
                  if (!vm.nriFlag) {
                    checkEMandate();
                  }
                }
                if(vm.formDataPayment.isExceedingEmandateDate || vm.nriFlag){
                  var isEmandate = vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
                  if(isEmandate){
                    var paymentIndex = vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
                    if (paymentIndex !== -1) {
                      vm.paymentOptions.splice(paymentIndex, 1);
                    }
                  }
                }
                showHideUpi();
              });
            }
          })
        } else {
          fetchBankListForUPI();
          fetchBankList(function (success) {
            if(success){
              checkOTM(function (success){
                if(success){
                  if(vm.linkdata && vm.linkdata.isHdfcBank) {
                    checkEMandate();
                  }
                }
                showHideUpi();
              });
            }
          });
        }
      });
      getAccountType();

      var successHandler = function(resp) {
        if (Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || !resp.termAndConditionDTO.termAndConditionDTOMap['TNC_ECART_IP']) {
          vm.showTerms = false;
        }
      }

      UtilService.fetchDynamicData("PURCHASE_ECART").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });

      var successHandlerEmandate = function(resp) {
        if (Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || !resp.termAndConditionDTO.termAndConditionDTOMap['TNC_SIP_Review_Registration_eOTM']) {
          vm.showTermsEmandate = false;
        }
      }

      UtilService.fetchDynamicData("SIP_REVIEW").then(successHandlerEmandate).catch(function(resp) {
        MessageService.error(resp);
      });

    }

    function checkOtmList() {

      var success = function (resp) {
          LoaderService.showLoader();
          if (resp.status && resp.data) {
            if (resp.data.bankList.length == 0) {
              if (vm.formData.schemeType.toUpperCase() == 'LIQUID') {
                vm.paymentOptions = paymentOptions4Liquid;
              } else {
                if(vm.checkForMinorBankListCondition()) {
                  if (vm.formData.sipFirstInstallment) {
                    vm.paymentOptions = [
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
                    ];
                  } else if (vm.formData.investmentType === 'PURCHASE') {
                    vm.paymentOptions = [
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
                      // vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                    ];
                  } else {
                    vm.paymentOptions = [
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
                    ];
                  }
                }
                else
                {
                  if (vm.formData.sipFirstInstallment) {
                    vm.paymentOptions = [
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
                    ];
                  } else if (vm.formData.investmentType === 'PURCHASE') {
                    vm.paymentOptions = [
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING,
                      // vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
                      // vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
                      // vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                    ];
                  } else {
                    vm.paymentOptions = [
                      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
                    ];
                  }
                }
                setPaymentModesForHDFC();
              }
              if(vm.formData.investmentType==='SIP' && vm.formData.bankInfo.emandateEnabled)
              {
                vm.paymentOptions = [
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS,
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC,
                  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI
                ];
                setPaymentModesForHDFC();
              }

            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var config = {child1: 'folio', child2: 'otm'};
      InvestorService.post(config, {folioNo: vm.formData.folioNumber, transactionType: 'purchase'}).$promise.then(success, error);
    }

    vm.changedPaymentOption = function (value) {

      if ((vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)) {
        if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART'){
          vm.dataFrom = {
            isFromEcart : true
          }

        }
        UtilService.fetchMandateValidations(vm.dataFrom).then(function (resp) {
          vm.emandateObj = resp.eOTM;
          vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
          vm.eMandatenoOfDays = vm.emandateObj.noOfDays;
          vm.eMandatemaxAmountLimit = vm.emandateObj.maxAmountLimit;
          vm.emandateMinAmountLimit = vm.emandateObj.minAmountLimit;
          vm.formData.emandateAmount = Math.floor(vm.emandateObj.defaultMandateAmount);
          $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
          checkAmountValidationEmandate();
          vm.mandateInfo = vm.emandateObj.mandateInfoBasket;
          vm.minEndDateGapMandate = vm.emandateObj.minEndDateGap;
          vm.mandateMaxString = vm.emandateObj.maxAmountLimitInfo;
          vm.formData.emandateDate = $window.moment().add(vm.emandateObj.minStartDays,'days');
          updateEmandateEndDate();
        }).catch(function(resp) {
          MessageService.error(resp)
        });
      }

      vm.isCheckedDeclaration = false;
      vm.bankInfo = null;
      vm.bankList = null;
      vm.formData.paymentInfo = {amount: vm.formData.amount};
      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isInvalidForm = false;
      vm.fileType='';
      vm.bankchequeLeafUrl=null;
      vm.isNewPayment = true;
      vm.isOTMAmount = false;
      vm.isOTMEndDate = false;
      vm.formData.paymentInfo.chequeLeaf=null;
      vm.isCheckedTandC =  false;
      vm.isCheckedTandCeMandate= false;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      if (vm.emandateObj) {
        vm.formData.emandateAmount = Math.floor(vm.emandateObj.defaultMandateAmount);
      }

      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          vm.formData.paymentInfo.paymentOption = "WEB";
          fetchBankList();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          vm.formData.paymentInfo.paymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          if(vm.formData.investmentType === 'PURCHASE') {
            fetchBankList();
          }
          if(vm.OTMbankList && vm.OTMbankList.length === 1) {
            vm.bankList = vm.OTMbankList;
            checkBankList();
          }
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          vm.formData.paymentInfo.paymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
          if(vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
            vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
          }
          fetchRTGSBankList();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
          vm.formData.paymentInfo.paymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC;
          resetCheckLeaf();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          resetUPIForm();
          fetchBankList();
          if(vm.formData.amount > vm.formData.upiLimit) {
            var success = function() {
              vm.formData.purchasePaymentOption = vm.paymentOptions[0];
              vm.changedPaymentOption();
            }
            ModalService.genericModal({
              text: vm.formData.upiErrorMessage,
              isUpi: true
            },success);
          }
          vm.formData.paymentInfo.paymentOption = "WEB";
          vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
          vm.formData.paymentInfo.paymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          vm.bankList = vm.ecBankList;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:
          //vm.formData.paymentInfo.paymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
          if (vm.formData.amount && (vm.formData.amount > vm.emandateValidateData.maxAmountLimit)) {
            vm.showEmandateError = true;
          } else {
            vm.showEmandateError = false;
          }
          if (vm.formData.amount && (vm.formData.amount < vm.emandateValidateData.minAmountLimit)) {
            vm.minAmountLimitError = true;
          } else {
            vm.minAmountLimitError = false;
          }
          if(vm.formDataPayment.startEmandateDate && (moment(vm.formDataPayment.startEmandateDate).isBefore(vm.emandateValidateData.minStartDate)) || vm.formDataPayment.startEmandateDate && (moment(vm.formDataPayment.startEmandateDate).isAfter(vm.emandateValidateData.maxStartDate))){
            vm.minStartDateLimitError = true;
          } else {
            vm.minStartDateLimitError = false;
          }
          if(vm.formDataPayment.startEmandateDate && (moment(vm.formDataPayment.startEmandateDate).isBefore(vm.emandateValidateData.minStartDate)) || vm.formDataPayment.endEmandateDate && (!moment(vm.formDataPayment.endEmandateDate).isSameOrBefore(vm.emandateValidateData.maxEndDate))){
            vm.maxEndDateLimitError = true;
          } else {
            vm.maxEndDateLimitError = false;
          }

          if (vm.enabledEmandateEndDatesList) {
            vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
            changeEndDateEmandate(vm.formData.endDateEmandate);
          }

          break;
      }
      if(vm.bankInfo) {
        vm.changeBank();
      }
      if(value === 'fromHtml') {
        handleUpiError();
      }
    };

    vm.changeBank = function () {
      if (!vm.bankInfo) {
        return;
      }
      vm.isInvalidForm = false;
      localStorage.setItem('folioId',vm.formData.folioNumber);
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          if(!vm.formData.paymentInfo) {
            vm.formData.paymentInfo = {};
          }
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            return;
          }
          if(vm.formData.investmentType === 'SIPPURCHASE') {
            vm.formData.paymentInfo.paymentModeSip = "EC";
            vm.formData.paymentInfo.paymentOption = vm.formData.purchasePaymentOption;
          } else if (vm.formData.investmentType === 'PURCHASE') {
            vm.formData.paymentInfo.paymentOption = vm.formData.purchasePaymentOption;
          }
          vm.formData.paymentInfo.amount = vm.formDataPayment.amount;
          vm.formData.paymentInfo.gatewayVendor = vm.bankInfo.gateWayVendor;
          vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType === null || vm.bankInfo.bankAcType === "" ? vm.formData.paymentInfo.accType : vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly;
          vm.formData.paymentInfo.branchName = vm.bankInfo.branchName;
          vm.formData.paymentInfo.bankCity = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode === null || vm.bankInfo.ifscCode === "" ? vm.formData.paymentInfo.ifscCode : vm.bankInfo.ifscCode;
          /*if (vm.bankInfo.tpvEnableFlag == 'Y') {
            getAccountNumber(vm.bankInfo.bankCode);
          }*/
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if(!vm.formData.paymentInfo) {
            vm.formData.paymentInfo = {};
          }
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            return;
          }
          (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
          if(vm.formData.investmentType === 'SIPPURCHASE') {
            vm.formData.paymentInfo.paymentOption = "OTM";
            vm.formData.paymentInfo.paymentModeSip = "OTM";
          } else if (vm.formData.investmentType === 'PURCHASE') {
            vm.formData.paymentInfo.paymentOption = "OTM";
          } else {
            vm.formData.paymentInfo.paymentModeSip = "OTM";
          }
          vm.formData.paymentInfo.accNo = vm.bankInfo.bankAcNo;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType === null || vm.bankInfo.bankAcType === "" ? vm.formData.paymentInfo.accType : vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.branchName = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankCity = vm.bankInfo.bankCity;
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode === null || vm.bankInfo.ifscCode === "" ? vm.formData.paymentInfo.ifscCode : vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
          vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
          vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
          vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
          checkOTMAmountAndDate();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if(!vm.formData.paymentInfo) {
            vm.formData.paymentInfo = {};
          }
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            return;
          }
            vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
          vm.formData.paymentInfo.branchName = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankCity = vm.bankInfo.bankCity;
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            return;
          }
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          if (vm.bankInfo.tpvEnableFlag == 'Y') {
            getAccountNumber(vm.bankInfo.bankCode);
          }
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.otherBank = true;
          vm.formData.paymentInfo.bankAcType = vm.bankInfo.bankAcType==""?null:vm.bankInfo.bankAcType;
          if(!vm.bankInfo.bankAcType && vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
            vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
          }
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
          if(!vm.formData.paymentInfo) {
            vm.formData.paymentInfo = {};
          }
          vm.formData.paymentInfo.netBankingUrl = vm.bankInfo ? vm.bankInfo.netBankingUrl : "";
          if (!vm.bankInfo.bankAcType) {
            getAccountType();
          }
          vm.formData.paymentInfo.paymentModeSip = "EC";
          vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType === null || vm.bankInfo.bankAcType === "" ? vm.formData.paymentInfo.accType : vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly;
          vm.formData.paymentInfo.branchName = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankCity = vm.bankInfo.bankCity;
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode === null || vm.bankInfo.ifscCode === "" ? vm.formData.paymentInfo.ifscCode : vm.bankInfo.ifscCode;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:
          if(!vm.formData.paymentInfo) {
            vm.formData.paymentInfo = {};
          }
          vm.authenticationMode = vm.bankInfo ? vm.bankInfo.authenticationModes: null;
          vm.formData.paymentInfo.paymentModeSip =  "HEM";
          vm.formData.paymentInfo.accNo = vm.bankInfo ? vm.bankInfo.accountNumber : '';
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType === null || vm.bankInfo.bankAcType === "" ? vm.formData.paymentInfo.accType : vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly;
          vm.formData.paymentInfo.branchName = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankCity = vm.bankInfo.bankCity;
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode === null || vm.bankInfo.ifscCode === "" ? vm.formData.paymentInfo.ifscCode : vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.authMode = vm.bankInfo ? vm.bankInfo.authenticationModes[0] : null;
          vm.formData.paymentInfo.bankDetailsForECSbankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.authenticationMode = vm.formData.paymentInfo.authMode.value;
          break;
        default :
          vm.bankInfo = null;
          break;
      }
    };

    function getAccountNumber(bankCode) {
      vm.bankAccounts = [];
      vm.isInvalidForm = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            vm.bankAccounts = resp.data.accountNumbers;
            if (vm.bankAccounts.length > 1) {
              var success = function (accountNo) {
                vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
                vm.formData.paymentInfo.accountNumber = accountNo;
                vm.isInvalidForm = false;
              }, error = function () {

              };
              ModalService.selectAccountNoModal({bankAccounts: vm.bankAccounts}, success, error);
            } else {
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankAccounts[0];
              vm.isInvalidForm = false;
            }
          } else {
            vm.isInvalidForm = true;
            MessageService.error(resp.message);
            vm.bankAccounts = [];
          }
        },
        error = function (err) {
          vm.bankAccounts = [];
          vm.isInvalidForm = true;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber, //'9422332',
        "bankCode": bankCode
      };
      InvestorService.post({
        child1: 'bank',
        child2: 'account'
      }, payload).$promise.then(success, error);
    }

    vm.goToBack = function () {
      var state = $state.current.name;
      if (state === 'main.transactions.paymentPage') {
        $state.go('main.transactions.cart');
      } else {
        $state.go('preLoginEcartJourney.cartReview');
      }
    }

    vm.completePurchaseFirst = function ($event) {
      if(vm.formData.investmentType === 'SIP' && vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
        var successCallback = function (data) {
          vm.secretLink = data.secretLink;
          vm.submitForm();
        };
        var errorCallback = function () {
          LoaderService.hideLoader();
        };
        ModalService.registerEMandateModal({folioNumber:vm.formData.folioNumber,transactionType : vm.formData.investmentType, bankName :vm.formData.paymentInfo.bankName, flowName: 'E_CART', authMode: vm.formData.paymentInfo.authMode.value, randomOTPId: vm.formDataPayment.randomOTPId},successCallback,errorCallback)
      } else {
        transactionOtmConfirmation($event);
      }
    };

    vm.submitForm = function ($event) {
      var payload = getPayload();
      if(vm.formData.investmentType === 'SIP') {
        delete payload.paymentOption;
      } else if (vm.formData.investmentType === 'PURCHASE') {
        delete payload.paymentModeSip;
      }
      if(payload.paymentOption === 'NETBANKING') {
        payload.paymentOption = "NET_BANKING";
      }
      if (payload.authMode) {
        delete payload.authMode;
      }
      if (!payload) {
        MessageService.error('Something went wrong while calculating purchase payload.');
        return;
      }
      vm.finalSubmit(payload);
    };

    vm.finalSubmit = function (payload) {
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var state = $state.current.name;
          if(state !== 'main.transactions.paymentPage') {
            logoutMe();
          }
          handlePurchaseResponse(resp.data);
        } else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            });
          } else {
            MessageService.error(resp.message);
          }

        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        $state.go('welcome');
      };
      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART'){
        TransactionServiceVersion.post({
          controller1: 'arn',
          controller2: 'cart',
          controller3: 'checkout'
        }, payload).$promise.then(success, error);
      } else {
        TransactionServiceVersion.post({
          controller1: 'cart',
          controller2: 'checkout'
        }, payload).$promise.then(success, error);
      }
    };

    vm.cardTypeChanged = function () {
      fetchBankList();
    };

    vm.otherBankSelected = function () {
      vm.bankInfo = null;
    };

    vm.copyPasteHandler = function (e) {
      UtilService.copyPasteHandler(e);
    };

    var stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
      TransactionModel.setPayloadRawData(null);
    });

    $scope.$on('$destroy', function () {
      stateChangeStart();
    })

    function checkOTMAmountAndDate() {

      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      // Check Ammout
      var cartItemArr = [];
      vm.formDataPayment.cartItemsInfo.forEach(function (el) {
        cartItemArr.push(el.installmentAmount);
        cartItemArr.push(el.amount);

      });
      cartItemArr = cartItemArr.filter(function(item) {
        return item !== undefined && item !== null;
      });
      cartItemArr.sort(function(a, b){return a - b});
      var maxCartItem = cartItemArr[cartItemArr.length - 1];

      if (parseInt(vm.bankInfo.maxAmount) >= maxCartItem) {
        vm.isOTMAmount = false;
      } else if (parseInt(vm.bankInfo.maxAmount) < maxCartItem){
        vm.isOTMAmount = true;
      }

      if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount > parseInt(vm.bankInfo.maxAmount))) {
        vm.isOTMAmount = true;
      } else if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount < parseInt(vm.bankInfo.maxAmount))) {
        vm.isOTMAmount = false;
      }

      var yearArr = [];
      var otmStartDateError = [];
      var otmDateError = [];
      vm.formDataPayment.cartItemsInfo.forEach(function (el) {
        if(el.toDate && $window.moment(el.toDate,'DD-MMM-YYYY').isValid()) {
          yearArr.push({
            date: el.toDate,
            year: moment(el.toDate, 'DD-MMM-YYYY').format('YYYY')
          });
        }
        //Compare Dates
        if (vm.formData.investmentType !== 'PURCHASE' && el.sipDate && !($window.moment(vm.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(el.sipDate, 'DD-MMM-YYYY')))){
          otmStartDateError.push(true);
        } else if (vm.formData.investmentType == 'PURCHASE' && vm.currentDate && !($window.moment(vm.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.currentDate, 'DD-MMM-YYYY').format("DD-MMM-YYYY")))){
          otmStartDateError.push(true);
        }
        else{
          otmStartDateError.push(false);
        }

        if (el.toDate && $window.moment(vm.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(el.toDate, "DD-MMM-YYYY"))) {
          otmDateError.push(true);
        }
        else {
          otmDateError.push(false);
        }
      });

      if (otmStartDateError.includes(true)) {
        vm.isOTMStartDate = true;
      } else {
        vm.isOTMStartDate = false;
      }

      if (otmDateError.includes(true)) {
        vm.isOTMDate = true;
      } else {
        vm.isOTMDate = false;
      }

      yearArr.sort(function(a, b){return a.year - b.year});
      var maxYear = yearArr[yearArr.length - 1];

      if (vm.bankInfo && maxYear && $window.moment(vm.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isBefore(new Date($window.moment((maxYear.date))))) {
        vm.isOTMEndDate = true;
      }
      else {
        vm.isOTMEndDate = false;
      }


      //Check for amount or date
      if ((vm.isOTMAmount || vm.isOTMDate)) {
        vm.isInvalidForm = true;
      } else {
        vm.isInvalidForm = false;
        //tForm.$invalid
      }
    }

    function selectedUpiBank() {
      if (!vm.bankInfo) {
        return;
      }
      if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
        localStorage.setItem('folioId',vm.formData.folioNumber);
        ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
        vm.bankInfo = null;
        vm.isCheckedDeclaration = false;
        return;
      }
      vm.upiAccountNumber = vm.bankInfo.accountNumber;
      vm.upiBankName = vm.bankInfo.bankName;
      vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
    }

    function verifyUPI() {
      vm.verifyUPIResp = {};
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.verifyUPIResp = resp.data;
            if (resp.data.valid) {
              vm.name = resp.data.name;
              vm.isUPIVerified = true;
            } else {
              vm.isUPIVerified = false;
            }
          }
          else {
            vm.isUPIVerified = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();

      InvestorService.post({
        child1: 'upi',
        child2: 'check',
        child3: 'virtualAddress'
      }, {"virtualAddress": vm.formData.paymentInfo.virtualAddress}).$promise.then(success, error);
    }

    /*
    * Function responsible to manage the broker code for purchase and sip payload
    * */
    function handleBrokerCode(payload) {
      if (vm.formDataPayment.brokerDetailsPayload.euinOpted === 'Y') {
        payload['brokerCode'] = payload.brokerCode ? payload.brokerCode : (vm.formDataPayment.distributorARN ? vm.formDataPayment.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formDataPayment.brokerDetailsPayload.riaConsent) {
        payload['brokerCode'] = payload.brokerCode;
        payload['riaConsent'] = true;
      } else if (!vm.formDataPayment.brokerDetailsPayload.brokerCode === 'DIRECT') {
        payload['brokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }


    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };

    function getAccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.formData.investorType
      }).$promise.then(success, error);
    }

    function fetchRTGSBankList() {
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
            handleBankOnlyHdfcBank();
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            if (vm.bankList && vm.bankList.length == 1) {
              vm.bankInfo = vm.bankList[0];
              if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
                localStorage.setItem('folioId',vm.formData.folioNumber);
                ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
                return;
              }
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
              vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
              vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
              vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
              vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
              vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
              vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
              vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
              vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
              vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
              vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
              vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
              (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
        };
      var config = {child1: 'bank', child2: 'list'};
      var payload = {
        trnxType: 'PURCHASE',
        folioNumber: vm.formData.folioNumber,
        liquidSchemeFlag: vm.formData.schemeTypeLiquid ? true : false,
        neftFlag: true
      };
      InvestorService.post(config, payload).$promise.then(success, error);
    }

    function changeRtgsPaymentOption() {
      if (vm.isNewPayment) {
        vm.bankInfo = null;
        vm.formData.paymentInfo.bankName = null;
        vm.formData.paymentInfo.bankBranch = null;
        vm.formData.paymentInfo.accNo = null;
        vm.formData.paymentInfo.verifyBankAcNo = null;
        vm.formData.paymentInfo.ifscCode = null;
        vm.formData.paymentInfo.utrNumber = null;
        vm.formData.paymentInfo.verifyUtrNumber = null;
        vm.formData.paymentInfo.chequeLeaf = null;
        resetCheckLeaf();
        if(vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
          vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
        }
      } else {
        vm.formData.paymentInfo.utrNumber = null;
        vm.formData.paymentInfo.verifyUtrNumber = null;
        vm.formData.paymentInfo.chequeLeaf = null
      }
    }

    function openUploadedDoc() {
      if(angular.isUndefined(vm.formData.paymentInfo.chequeLeaf)){return;}
      ModalService.showImage({docUrl: vm.formData.paymentInfo.chequeLeaf});
    }

    function bankUploadChequeLeafFile(file) {
      var fi = document.getElementById('uploadCheckLeaf');
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be PDF, TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if(file) {
        if (fi.files.item(0).size <= 3145728) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.bankchequeLeafUrl = resp.data.fileUrl;
                vm.formData.paymentInfo.chequeLeaf = vm.bankchequeLeafUrl;
                vm.fileType = resp.data.type.toLowerCase();
                breakFileUrl(vm.bankchequeLeafUrl);
              }
              else {
                vm.fileType = '';
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader(err);
            };
          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            FileUploadServiceVersion2.post({
              child1: 'folio',
              child2: 'upload',
              child3: 'bankDetails',
              child4: 'chequeLeaf'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 3 MB.")
        }
      }
    }

    function breakFileUrl(url) {
      vm.bankChequeLeaf = 'Preview Uploaded Leaf Doc';
      vm.fileType = url && url.split('_').reverse()[0].toLowerCase();
      vm.chooseAFile = false;
      vm.formData.paymentInfo.chequeLeaf = url;
      return;
    }

    function resetCheckLeaf() {
      vm.bankchequeLeafUrl = null;
      vm.formData.paymentInfo.chequeLeaf = null;
      vm.bankChequeLeaf = null;
      vm.chooseAFile=true;
      angular.element("#uploadCheckLeaf").val("");
    }

    function downloadPdfFile(url, fileType) {
      var success = function (resp){
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+fileType });
            FileSaver.saveAs(data, 'Cheque_Leaf.'+fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.downloadFile(payload, fileType, url).then(success, error);
    };

    function transactionOtmConfirmation($event) {
      var otpSuccessCallback, otpDismissCallback;

      otpSuccessCallback = function(resp) {
        LoaderService.hideLoader();
        vm.submitForm($event);
      };

      otpDismissCallback = function(err) {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      var modalPayload = {
        folioNumber: vm.formData.folioNumber,
        flowName:"E_CART",
        randomOTPId: vm.formDataPayment.randomOTPId
      };

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {

            vm.secretLink = resp.data.secretLink;
            var otpDetails = {
              secretOtpLink : vm.secretLink,
              otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
              otpId : resp.data.id
            };

            var payload = {
              folioNumber:  vm.formData.folioNumber,
              flowName:"E_CART"
            };

            ModalService.transactionOtpModal({
              otpPayload: otpDetails,
              payload: payload
            }, otpSuccessCallback, otpDismissCallback);
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message)
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      TransactionService.post2({
        controller1: 'transaction',
        controller2: 'otp'
      }, modalPayload).$promise.then(success, error);
    }


    function checkOTM(cb){
      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.bankList.length == 0) {
              vm.isOTMEnabled = false;
              if(!(vm.checkForMinorBankListCondition())) {
                if (vm.formData.frequency !== 'OW'){
                  if(vm.sipFirstInstallment) {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                  } else if(vm.formData.investmentType === 'SIPPURCHASE' || vm.formData.investmentType === 'PURCHASE') {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING];
                  } else {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                  }
                }
                else
                {
                  if(vm.sipFirstInstallment) {
                    vm.paymentOptions = [];
                  }
                  else if(vm.formData.investmentType === 'SIPPURCHASE' || vm.formData.investmentType === 'PURCHASE') {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING];
                  } else {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                  }
                }
                setPaymentModesForHDFC();
                var index = vm.paymentOptions.indexOf('OTM');
                if(index > -1) {
                  vm.paymentOptions.splice(index,1);
                }
                vm.formData.purchasePaymentOption = vm.paymentOptions[0];
                if(!vm.bankList) {
                  if (vm.paymentOptions.includes("EC")) {
                    var index = vm.paymentOptions.indexOf('EC');
                    if (index > -1) {
                      vm.paymentOptions.splice(index, 1);
                    }
                  }
                }
              } else if(vm.checkForMinorBankListCondition()) {
                if(vm.formData.investmentType === 'SIPPURCHASE' || vm.formData.investmentType === 'PURCHASE' )  {
                  vm.paymentOptions = [
                    vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
                  ];
                  setPaymentModesForHDFC();
                } else {
                  vm.paymentOptions = [];
                }
              }
              if(vm.formData.isBackFromSummary || $stateParams.transactionId)
              {
                var frequency = vm.frequencyList && vm.frequencyList.find(function (item) {
                  return vm.formData.frequency === item.code;
                }) || {};
                vm.formData.frequency = frequency.code || '';

              }

            }
            else {
              if (vm.sipFirstInstallment && resp.data.nonCOTMBankList.length === 0) {
                vm.isOTMEnabled = false;
                if (vm.checkForMinorBankListCondition() || vm.formData.frequency === 'OW')
                  vm.paymentOptions = [];
                else {
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                  setPaymentModesForHDFC();
                }
              } else {
                vm.isOTMEnabled = true;
                if (vm.checkForMinorBankListCondition()) {
                  if(vm.sipFirstInstallment) {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                  }
                  else if(vm.formData.investmentType === 'SIPPURCHASE' || vm.formData.investmentType === 'PURCHASE') {
                    if (vm.formData.schemeTypeLiquid) {
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING];
                    } else {
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING , vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                    }
                    setPaymentModesForHDFC();
                  } else {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                    setPaymentModesForHDFC();
                  }
                } else {
                  if(vm.sipFirstInstallment) {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                  } else if(vm.formData.investmentType === 'SIPPURCHASE' || vm.formData.investmentType === 'PURCHASE') {
                    if (vm.formData.schemeTypeLiquid) {
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING];
                    } else {
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING , vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                    }
                    setPaymentModesForHDFC();
                  } else {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                    setPaymentModesForHDFC();
                  }
                }
              }
              vm.formData.showTopUpBlock =  vm.formData.showTopUpBlock ? true : false;

              if(!vm.backFromPayment)
                vm.formData.purchasePaymentOption = vm.paymentOptions ? vm.paymentOptions[0] : '';

              if(vm.formData.isBackFromSummary || $stateParams.transactionId)
              {
                frequency = vm.frequencyList && vm.frequencyList.find(function (item) {
                  return vm.formData.frequency === item.code;
                }) || {};
                vm.formData.frequency = frequency.code || '';

              }
              vm.otmList = resp.data;
              vm.OTMbankList = vm.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList;
              handleBankOnlyHdfcBank();
            }
          }

          cb(true);
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();//need to check
      var payload = {
        transactionType: 'purchase',
        folioNo: vm.formData.folioNumber,
        newFolio: false
      };
      InvestorService.post({
        child1: 'folio',
        child2: 'otm'
      }, payload).$promise.then(success, error);
    }

    function fetchBankListForSip(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if(vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              vm.eMandatenoOfDays = resp.data.noOfDays;
              vm.eMandatemaxAmountLimit=resp.data.maxAmountLimit;
              vm.formData.showTopUpBlock = false;
              // if(vm.formData.inSchemeCode)
              //   getDateValidation();
              // checkEMandateValidation();
            }
            if (vm.formData.purchasePaymentOption == 'OTM' && resp.data.bankList.length == 0) {
              vm.formData.purchasePaymentOption = vm.paymentOptions[0];
              vm.hideOtmRadio = true;
              //fetchBankList();
            }
            else if (vm.formData.purchasePaymentOption == 'OTM' && resp.data.bankList.length > 0) {
              vm.hideOtmRadio = false;
            }
            else if (vm.formData.purchasePaymentOption == 'EC') {
              vm.ECbankList = resp.data.bankList;
              handleBankOnlyHdfcBank();
              if (vm.hideOtmRadio) {
                if(vm.sipFirstInstallment) {
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                } else if(vm.formData.investmentType === 'SIPPURCHASE' || vm.formData.investmentType === 'PURCHASE') {
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING];
                } else {
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                }
                setPaymentModesForHDFC();
                vm.formData.purchasePaymentOption = vm.paymentOptions[0];
                // if(vm.formData.inSchemeCode)
                //   getDateValidation();
              }
              else {
                if(vm.checkForMinorBankListCondition())
                {
                  if(vm.sipFirstInstallment) {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                  } else if(vm.formData.investmentType === 'SIPPURCHASE' || vm.formData.investmentType === 'PURCHASE') {
                    if (vm.formData.schemeTypeLiquid) {
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING];
                    } else {
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING , vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                    }
                  } else {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                  }
                }
                else {
                  if (vm.sipFirstInstallment) {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                  } else if(vm.formData.investmentType === 'SIPPURCHASE' || vm.formData.investmentType === 'PURCHASE') {
                    if (vm.formData.schemeTypeLiquid) {
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING];
                    } else {
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING , vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                    }
                  } else {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                  }
                }
                setPaymentModesForHDFC();
                vm.hideOtmRadio = false;
                // if(vm.formData.inSchemeCode)
                //   getDateValidation();
              }
            }

            vm.ecBankList = resp.data.bankList;
            vm.bankList = vm.ecBankList;
            handleBankOnlyHdfcBank();

            if (vm.formData.purchasePaymentOption == 'EC') {
              for(var i = 0 ;  i < vm.bankList.length ; i++) {
                vm.bankList[i].id = i;
              }
            }

            if(vm.formData.purchasePaymentOption ===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              vm.formData.authMode = vm.formData.bankInfo? (vm.formData.bankInfo.authenticationModes.length === 1 ? vm.formData.bankInfo.authenticationModes[0] : null) :null;
              vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
          cb(true);
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      // LoaderService.showLoader();

      if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC || vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
        if(!vm.ECbankList) {
          var payload = {
            "trnxType": 'PURCHASE',
            "folioNumber": vm.formData.folioNumber,
            "liquidSchemeFlag": vm.formData.schemeTypeLiquid ? true : false,
            "sipFlow": true,
            newFolio: false
          };
          InvestorService.post({child1: 'bank', child2: 'list'}, payload).$promise.then(success, error);
        } else {
          LoaderService.hideLoader();
          if (vm.hideOtmRadio) {
            if(vm.sipFirstInstallment)
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            else
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            setPaymentModesForHDFC();
            vm.formData.purchasePaymentOption = vm.paymentOptions[0];
            // if(vm.formData.inSchemeCode)
            //   getDateValidation();
          }
          else {
            if(vm.checkForMinorBankListCondition())
            {
              if(vm.sipFirstInstallment)
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
              else
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            }
            else {
              if(vm.sipFirstInstallment)
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
              else
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];

            }
            setPaymentModesForHDFC();
            vm.hideOtmRadio = false;

          }
          vm.bankList = vm.ECbankList;
          handleBankOnlyHdfcBank();
        }
      }
      else{
        if (vm.formData.investmentType === 'SIPPURCHASE' || vm.linkdata.isHdfcBank && vm.formData.investmentType === 'SIP') {
          vm.ecBankList = vm.bankList;
          cb(true);
        } else {
          vm.bankList = null;
        }
      }
    }

    function checkEMandate(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            resp.data.bankList = resp.data.bankList ? resp.data.bankList : [];
            vm.emandateValidateData = resp.data;
            vm.isEMandateEnabled = resp.data.folioEmandateStatus;
            if (resp.data.bankList.length == 0 || !vm.isEMandateEnabled) {
              // vm.isEMandateEnabled = false;
              vm.EMbankList = null;
              var index = vm.paymentOptions.indexOf('E-mandate');
              if(index > -1) {
                vm.paymentOptions.splice(index,1);
              }

              if(vm.formData.purchasePaymentOption === 'E-mandate') {
                vm.formData.purchasePaymentOption = null;
              }
              if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
                if (vm.paymentOptions.length > 1) {
                  vm.formData.purchasePaymentOption = vm.paymentOptions[0];
                } else {
                  vm.formData.purchasePaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
                }
              }

              if (vm.paymentOptions.includes("OTM") && !vm.isOTMEnabled) {
                var index = vm.paymentOptions.indexOf('OTM');
                if (index > -1) {
                  vm.paymentOptions.splice(index, 1);
                }
              }
              if(vm.formData.cgfFlag && !vm.folioMinor && vm.formData.frequency !== 'OW' && vm.formData.frequency !== 'BZ') {
                if (vm.OTMbankList && vm.OTMbankList.length !== 0) {
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                }
                setPaymentModesForHDFC();
                vm.formData.purchasePaymentOption = vm.paymentOptions[0];
                // changedPaymentOption();
              }
            }
            else{
              if(vm.sipFirstInstallment)
              {
                vm.isEMandateEnabled = false;
              }
              else {
                vm.EMbankList = resp.data.bankList;
                handleBankOnlyHdfcBank();
                // vm.isEMandateEnabled = true;
              }
            }
          }
          cb(true);
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };
      var data = {
        trnxType: 'SIP',
        liquidSchemeFlag: vm.formData.schemeTypeLiquid ? true : false,
        folioNumber: vm.formData.folioNumber,
        newFolio: false
      };
      InvestorService.post({
        child1: 'folio',
        child2: 'emandate'
      }, data).$promise.then(success, error);
    }

    function setInitialFormData() {

      vm.formData = {
        "folioNumber" : vm.formDataPayment.folioNumber,
        //"isThroughDistributor": vm.formDataPayment.investThrough.investThroughDistributor,
        //"isDirect": !vm.formDataPayment.investThrough.investThroughDistributor &&  !vm.formDataPayment.investThrough.investThroughRIA ? true : false,
        //"isThroughRia": vm.formDataPayment.investThrough.investThroughRIA,
        //"isEuin": vm.formDataPayment.investThrough.investThroughDistributor && vm.formDataPayment.investThrough.subBrokerArn ? true : false,
        //"brokerCode": vm.formDataPayment.investThrough.subBrokerCode ? vm.formDataPayment.investThrough.subBrokerCode : "",
        //"riaBrokerCode": vm.formDataPayment.investThrough.riaBrokerCode ? vm.formDataPayment.investThrough.riaBrokerCode : "",
        //"riaBrokerName": "",
        //"brokerName": vm.formDataPayment.investThrough.brokerName ? vm.formDataPayment.investThrough.brokerName : "",
        //"euin": vm.formDataPayment.investThrough.euin ? vm.formDataPayment.investThrough.euin : {},
        "investmentType": vm.formDataPayment.transactionType,
        "frequency" : 'OM',
        "amount" : vm.formDataPayment.amount,
        "minorFlag" : vm.formDataPayment.isMinor,
        "investorType" : vm.formDataPayment.cartItemsInfo[0].invType
      };
      var liquidFlagArray = [];
      vm.formDataPayment.cartItemsInfo.forEach(function(items) {
        liquidFlagArray.push(items.liquid);
      });

      vm.formData.schemeTypeLiquid = liquidFlagArray.includes(true);

      if ((vm.formData.euin && vm.formData.euin.euinName)) {
        vm.formData.euinOpted = 'Y';
      } else {
        vm.formData.euinOpted = 'N';
      }

      vm.formDataPayment.cartItemsInfo.forEach(function (el) {
        if (el.cgfApplicable) {
          vm.formData.cgfFlag = true;
          return;
        } else {
          vm.formData.cgfFlag = false;
        }
      });
      if (vm.formData.investmentType === 'SIPPURCHASE') {
        $window.NumToWord(vm.formDataPayment.purchaseAmount, 'amountInWords', vm.formDataPayment);
      } else {
        $window.NumToWord(vm.formData.amount, 'amountInWords', vm.formData);
      }
      vm.formData.isUPIVerified = false;
      if(vm.formDataPayment && vm.formDataPayment.cartItemsInfo && vm.formDataPayment.cartItemsInfo.length > 0) {
        findUpiMaxAmount(vm.formDataPayment.cartItemsInfo);
      }
    }

    function findUpiMaxAmount(cartItems){
      vm.selectUpiMaxAmount  = "";
      if(vm.formData.investmentType == 'SIP'){
        vm.selectUpiMaxAmount = cartItems.reduce(function(max, obj) {
          return obj.installmentAmount > max ? obj.installmentAmount : max;
        }, 0);
      }

      if(vm.formData.investmentType == 'SIPPURCHASE' && vm.formDataPayment.cartItemsInfo && vm.formDataPayment.cartItemsInfo.length === 1){
        vm.selectUpiMaxAmount = Math.max(vm.formDataPayment.cartItemsInfo[0].installmentAmount, vm.formDataPayment.cartItemsInfo[0].amount);
      }

      if(vm.formData.investmentType == 'PURCHASE' && vm.formDataPayment.cartItemsInfo && vm.formDataPayment.cartItemsInfo.length === 1){
        vm.selectUpiMaxAmount = vm.formDataPayment.cartItemsInfo[0].amount;
      }
    }

    function showTermConditions() {
      ModalService.transactionalTermConditionModal({'transactionType': 'ECART'});
    };

    function showTermConditionsemandate() {
      ModalService.transactionalTermConditionModal({'transactionType': 'SIP-E-MANDATE'});
    };

    function logoutMe() {
      var user = sessionStorage.getItem('userType');
      var token = AuthService.getToken();
      var val = {
        "panNumber": token.panNumber,
        "flowName":"E_CART"
      };


      if (user === 'NEW') {
        var success = function (resp) {
            localStorage.removeItem("userId");
            var newDataLayer = $window.dataLayer.filter(function (obj) {
              return !obj.hasOwnProperty('userId');
            });
            $window.dataLayer = newDataLayer;
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            CommonFactory.setLogoutSuccess();
          },
          error = function (err) {
          };
        LoaderService.showLoader('.logout');
        InvestorService.post({
          child1: 'force',
          child2: 'logout'
        }, val).$promise.then(success, error);
      } else {
        var success = function (resp) {
          localStorage.removeItem("userId");
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          CommonFactory.setLogoutSuccess();
          // $state.go("preLoginEcartJourney.cartReview");
        },
        error = function (err) {
        };
        LoaderService.showLoader('.logout');
        InvestorService.post({
          child1: 'force',
          child2: 'logout'
        }, val).$promise.then(success, error);
      }
    }

    function updateEmandateEndDate() {

      if (!vm.formData.emandateDate) {
        return;
      }

      var enabledEndDates = [];

      if(vm.formData.emandateDate)
      {
        vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
        vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateMaxYear, 'years').subtract(1,'days');
        var endDateEmandateBoundExist = $window.moment(vm.formDataPayment.endEmandateDate,'DD-MMM-YYYY').isSameOrBefore(vm.maxEndDateEmandate);
        if (!endDateEmandateBoundExist) {
          var index = vm.formData.purchasePaymentOption.indexOf('E-mandate');
          if(index > -1) {
            vm.paymentOptions.splice(index,1);
          }
        } else {
          var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
          for (var i = 0; i <= freq; i++) {
            enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
          }
          vm.enabledEmandateEndDatesList = enabledEndDates;
          vm.endDateViewEmandate = vm.minEndDateEmandate.clone();
          vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
          changeEndDateEmandate(vm.formData.endDateEmandate);
        }
      }
    }


    function checkAmountValidationEmandate() {
      vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
      vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
      vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.formData.amount ? true : false;
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.emandateWord);
    }

    function changeEndDateEmandate(date) {
      vm.formData.endDateEmandate = date ? date : null;
      if (vm.formDataPayment.endEmandateDate) {
        vm.sipDateLessEmandate =  $window.moment(vm.formDataPayment.endEmandateDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
      }
    }

    function setPaymentModesForHDFC(){
      if(vm.linkdata && vm.linkdata.isHdfcBank) {
        //For purchase Transaction
        if (vm.formData.investmentType === 'PURCHASE') {
          if (vm.formData.schemeTypeLiquid) {
            vm.paymentOptions = [
              vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
            ];
          } else if (!vm.formData.schemeTypeLiquid) {
            vm.paymentOptions = [
              vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM
            ];
          }
        }

        //For SIP Transaction
        if (vm.formData.investmentType === 'SIP') {
          if (vm.formDataPayment.cartItemsInfo[0].invType == '02' || vm.formDataPayment.cartItemsInfo[0].invType == '24') {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
          } else if (vm.formDataPayment.cartItemsInfo[0].invType == '01') {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
          }
        }

        //  For MIX Transaction

        if (vm.formData.investmentType === 'SIPPURCHASE') {
          if (vm.formDataPayment.cartItemsInfo[0].invType == '02' && vm.formData.schemeTypeLiquid || vm.formDataPayment.cartItemsInfo[0].invType == '24' && vm.formData.schemeTypeLiquid) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING];
          } else if (vm.formDataPayment.cartItemsInfo[0].invType == '02' && !vm.formData.schemeTypeLiquid || vm.formDataPayment.cartItemsInfo[0].invType == '24' && !vm.formData.schemeTypeLiquid) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
          } else if (vm.formDataPayment.cartItemsInfo[0].invType == '01' && vm.formData.schemeTypeLiquid) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING];
          } else if (vm.formDataPayment.cartItemsInfo[0].invType == '01' && !vm.formData.schemeTypeLiquid) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
          }

          if (vm.formDataPayment.isExceedingEmandateDate) {
            var isEmandate = vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
            if (isEmandate) {
              var paymentIndex = vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
              if (paymentIndex !== -1) {
                vm.paymentOptions.splice(paymentIndex, 1);
              }
            }
          }
        }
      }

      if(!vm.linkdata) {
        handlePaymentOptionForEcart();
      }
    }

    function handleBankOnlyHdfcBank(){
      if(vm.linkdata && vm.linkdata.isHdfcBank){
        if(vm.EMbankList) {
          vm.EMbankList = $filter('filter')(vm.EMbankList,
            {
              bankCode: "HDFC"
            });
        }
        if(vm.OTMbankList) {
          vm.OTMbankList = $filter('filter')(vm.OTMbankList, function(bank) {
            return bank.bankName && bank.bankName.startsWith("HDFC");
          });
        }
        if(vm.bankList){
          vm.bankList = $filter('filter')(vm.bankList, function(bank) {
            return bank.bankName && bank.bankName.startsWith("HDFC");
          });
        }
        if(vm.ECbankList) {
          vm.ECbankList = $filter('filter')(vm.ECbankList,
            {
              bankCode: "HDF"
            });
        }
      }

      if (angular.isArray(vm.OTMbankList) && vm.OTMbankList.length == 0 ){
        vm.paymentOptions = vm.paymentOptions.filter(function(item,index){
          return item !== 'OTM'
        });
        if(vm.initialPaymentModeSet) {
          vm.formData.purchasePaymentOption = vm.paymentOptions[0];
          vm.initialPaymentModeSet = false;
        }
      }
    }

    function handleRazorPayRedirection(gatewayResponse) {
      PaymentService.openRazorPay(gatewayResponse);
    }

    function handlePaymentOptionForEcart(){
      if(vm.formData.investmentType === 'SIP'){
        vm.paymentOptions.splice(0, 0, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);

        if (vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC)) {
          vm.paymentOptions.push(vm.paymentOptions.splice(vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC), 1)[0]);
        }
        if(vm.formDataPayment.isFromJanNivesh && vm.isNewUser) {
          vm.paymentOptions = vm.paymentOptions.filter(function(obj){
            return obj !== 'OTM' && obj !== 'EC'
          });
        }

        vm.formData.purchasePaymentOption = vm.paymentOptions[0];
        vm.changedPaymentOption();
      }

      if(vm.formData.investmentType === 'SIPPURCHASE'){
        if(vm.formDataPayment.cartItemsInfo && vm.formDataPayment.cartItemsInfo.length === 1){
        vm.paymentOptions.splice(0, 0, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
        }

        if (vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING)) {
          vm.paymentOptions.push(vm.paymentOptions.splice(vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING), 1)[0]);
        }
        vm.formData.purchasePaymentOption = vm.paymentOptions[0];
        vm.changedPaymentOption();
      }

      if (vm.formData.investmentType === 'PURCHASE') {
        if(vm.formDataPayment.cartItemsInfo && vm.formDataPayment.cartItemsInfo.length === 1){
          vm.paymentOptions.splice(0, 0, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
        }
        if (vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING)) {
          vm.paymentOptions.push(vm.paymentOptions.splice(vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING), 1)[0]);
        }
        vm.formData.purchasePaymentOption = vm.paymentOptions[0];
        vm.changedPaymentOption();
      }
    }

    function handleUpiError() {
      if(vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI && vm.selectUpiMaxAmount > vm.formDataPayment.upiAmountLimit) {
        var success = function() {
          if(vm.paymentOptions.includes("OTM")) {
            vm.formData.purchasePaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
            vm.changedPaymentOption();
          } else if(vm.paymentOptions.includes("E-mandate")) {
            vm.formData.purchasePaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
            vm.changedPaymentOption();
          } else if(vm.paymentOptions.includes("NETBANKING")) {
            vm.formData.purchasePaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING;
            vm.changedPaymentOption();
          }else {
            vm.formData.purchasePaymentOption = null;
          }
        }
        ModalService.genericModal({
          text: vm.formDataPayment.upiErrorMessage,
          isUpi: true
        },success);
      }
    }

    function fetchBankListForUPI(){
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            //vm.upiBankList = resp.data.bankList;
            vm.bankList = resp.data.bankList;
            var isUpiEnabled = vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
            if (vm.bankList && vm.bankList.length === 1 && isUpiEnabled) {
              vm.bankInfo = vm.bankList[0];
              if(!vm.formData.paymentInfo) {
                vm.formData.paymentInfo = {};
              }
              vm.changeBank();
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();//need to check
      var payload = {
        "trnxType": 'PURCHASE',
        "folioNumber": vm.formData.folioNumber,
        "liquidSchemeFlag": vm.formData.schemeTypeLiquid == 'LIQUID' ? true : false,
        "sipUpiFlow" : true
      };
      InvestorService.post({
        child1: 'bank',
        child2: 'list'
      }, payload).$promise.then(success, error);
    }

    function verifyVirtualUPI() {
      vm.formData.verifyUPIResp = {};
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData.verifyUPIResp = resp.data;
            if (resp.data.valid) {
              vm.formData.name = resp.data.name;
              vm.formData.isUPIVerified = true;
            } else {
              vm.formData.isUPIVerified = false;
            }
          }
          else {
            vm.formData.isUPIVerified = false;
            vm.formData.verifyUPIResp.valid = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.formData.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();
      if (vm.formData.investmentType.toUpperCase() == "SIPPURCHASE" || vm.formData.investmentType.toUpperCase() == "SIP") {
        var payload = {
          "virtualAddress": vm.formData.virtualAddress,
          "folioNo": vm.formData.folioNumber,
          "ecartFlow": true
        };
        investorServiceVersion.post({
          child1: 'upi',
          child2: 'check',
          child3: 'virtualAddress'
        }, payload).$promise.then(success, error);
      } else {
        var payload = {
          "virtualAddress": vm.formData.virtualAddress
        };
        InvestorService.post({
          child1: 'upi',
          child2: 'check',
          child3: 'virtualAddress'
        }, payload).$promise.then(success, error);
      }
    }

    function handleVpa() {
      if (vm.formData.virtualAddress) {
        vm.formData.virtualAddress = vm.formData.virtualAddress.toLowerCase();
        vm.formData.verifyUPIResp={};
      }
    }

    function showHideUpi(){
      if(vm.formDataPayment.isExceedingUPIDate){
        var isUpi = vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
        if(isUpi){
          var paymentIndex = vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
          if (paymentIndex !== -1) {
            vm.paymentOptions.splice(paymentIndex, 1);
          }
          $timeout(function () {
          vm.formData.purchasePaymentOption = vm.paymentOptions[0];
          vm.changedPaymentOption();
          },100);
        }
      }
      $timeout(function () {
        handleUpiError();
      },200);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-investor-web')
    .directive('hdfcEcartSidebar', hdfcEcartSidebarDirective);

  /*@ngInject*/
  function hdfcEcartSidebarDirective($state, $window, AuthService, LoaderService, AppConstants, MessageService, UtilService, ModalService, TransactionService, InvestorService, investorServiceVersion, EcartModel , $rootScope , $stateParams) {
    return {
      restrict: 'EA',
      scope: {
        sideTitle: "=",
        euinDeclaration: "=",
        cartItem: "=",
        investThrough: "=",
        updateInfo: "&",
        investorData: '=',
        closeAction : "&",
        showAddCart: '=',
        pendingState: '=',
        isFromJanNivesh:'='
      },
      templateUrl: 'app/e-cart/directives/sidebar.directive.html',
      link: function ($scope, element, attrs) {
        var _this = $scope;
        _this.$on('updatedTitle', function() {
          init();
        });
        var initialAnimSkip = false;
        _this.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
        _this.formData = {};
        _this.startDateError = false;
        _this.investThroughFormData = {};
        _this.formAction = {};
        _this.investThroughFormData.isCheckedTandC = false;
        _this.sipWithFi = false;
        _this.appConstants = AppConstants;
        _this.transactionTypeList = [
          AppConstants.TRANSACTIONS.TRANSACTION_TYPE.SIP,
          AppConstants.TRANSACTIONS.TRANSACTION_TYPE.PURCHASE
        ];
        _this.transactionInFund = [];
        _this.amountSuggestion = [5000, 7000, 10000];
        _this.purchaseAmountSuggestion = [30000, 40000, 50000];
        _this.viewMode = "days";
        _this.investmentList = [];
        _this.suggestionList = [];
        _this.filterList = angular.copy(AppConstants.ALL_FUNDS_FILTER);
        _this.filterValues = [];
        _this.investmentOptions = [];
        _this.moment = $window.moment;
        //_this.formData.sipOpted = true;
        //_this.formData.purchaseOpted = true;
        _this.formData.yearSelected = "Since Inception";
        _this.allFundForm = {};
        _this.allFundForm.isRegular = false;
        _this.allFundForm.regularDirectError = null;
        _this.isExceedingEmandateDate = false;
        _this.isExceedingUPIDate = false;
        _this.isDateAvailable = false;
        _this.isPurchaseFieldClick = false;
        _this.enabledDefaultYear = true;
        _this.currentDate = $window.moment(Date());
        _this.collapse = collapse;
        _this.init = init;
        _this.changeThroughDistributor = changeThroughDistributor;
        _this.changeDistributorCode = changeDistributorCode;
        _this.searchDistributor = searchDistributor;
        _this.selectEuin = selectEuin;
        _this.searchDistributorByName = searchDistributorByName;
        _this.distributorListChanged = distributorListChanged;
        _this.changeSubBrokerArn = changeSubBrokerArn;
        _this.fetchEuinListSubBroker = fetchEuinListSubBroker;
        _this.setTandCVariable = setTandCVariable;
        _this.updateCartViaInvestThrough = updateCartViaInvestThrough;
        _this.filterEuinList = filterEuinList;

        _this.addTransactionFields = addTransactionFields;
        _this.addPurchaseClick = addPurchaseClick;
        _this.removeTransactionFromList = removeTransactionFromList;
        _this.utilService = UtilService;
        _this.allFormData = {};
        _this.allFormData.searchModel = null;
        _this.changeInstallmentAmount = changeInstallmentAmount;
        _this.changeStartDate = changeStartDate;
        _this.changeEndDate = changeEndDate;
        _this.fetchSchemeList = fetchSchemeList;
        _this.filterInSchemeList = filterInSchemeList;
        _this.showCagrValue = showCagrValue;
        _this.displayCagrValue = displayCagrValue;
        _this.openFilter = openFilter;
        _this.filterFunds = filterFunds;
        _this.changeFundsListing = changeFundsListing;
        _this.moveToCartDetails = moveToCartDetails;
        _this.searchRecords = searchRecords;

        _this.setSideBarState = setSideBarState;
        _this.redirectToSummary = redirectToSummary;
        _this.changeInvestmentOptions = changeInvestmentOptions;
        _this.inSchemeChanged = inSchemeChanged;
        _this.changeSelectedScheme = changeSelectedScheme;
        _this.changeTillPerpetuity = changeTillPerpetuity;
        _this.saveCartEdited = saveCartEdited;
        _this.getNote = '';
        _this.fetchDynamicDataEcart = fetchDynamicDataEcart;
        _this.addToCart = addToCart;
        _this.checkEnableEndDate = checkEnableEndDate;
        _this.showRecommendedFundOnTop = showRecommendedFundOnTop;
        _this.isNewUser = false;
        if(localStorage.getItem("distributorDetails")) {
          _this.linkdata = $window.JSON.parse(localStorage.getItem("distributorDetails"));
        } else if(sessionStorage.getItem("distributorDetails")){
          _this.linkdata = $window.JSON.parse(sessionStorage.getItem("distributorDetails"));
        }
        if(sessionStorage.getItem('userType')) {
          var user = sessionStorage.getItem('userType');
          if(user === 'NEW') {
            _this.isNewUser = true;
          }
        }
        init();

        function init() {
          //collapse();
          _this.sidebarTitle = _this.sideTitle;
          _this.setSideBarState();
          _this.ecartObj = JSON.parse(sessionStorage.getItem('ecartObj'));
        }

        function collapse(action) {
          _this.allFormData.searchModel = null;
          if (initialAnimSkip) {
            initialAnimSkip = false;
            collapseDone();
            element.addClass('sidebar-container-width-0');
            angular.element($window.document.body).removeClass('hide-scroll');
          } else {
            element.removeClass('collapse in').addClass('collapsing-width');
            element.addClass('sidebar-container-width-0');
            collapseDone();
            angular.element($window.document.body).removeClass('hide-scroll');
          }
          resetValues();
          _this.closeAction({action: action});
        }

        function collapseDone() {
          element.removeClass('collapsing-width');
          element.addClass('collapse');
        }


        function setSideBarState(state) {
          var state = state ? state :_this.sideTitle.replaceAll(" ", "_").replaceAll("-", "").toUpperCase();
          _this.sidebarSection = state;
          if (_this.sidebarSection === "INVEST_THROUGH") {
            _this.distributorMessage = _this.euinDeclaration.TNC_SIP_Through_Distributor;
            _this.riaMessage = _this.euinDeclaration.TNC_SIP_Review_Through_RIA;
            $scope.$watch('investThrough', function(value) {
              changeThroughDistributor(_this.investThrough);
            });
          } else if (_this.sidebarSection === 'ECART') {
            fetchInvestmentAdded();
            fetchSuggestion();
            _this.sidebarTitle = 'E-Cart';
          } else if(_this.sidebarSection === 'ALL_FUNDS') {
            fetchFunds();
            fetchFundsFilters();
            _this.sidebarTitle = 'All Funds';
          } else if (_this.sidebarSection === 'CART_DETAILS') {
            _this.sidebarTitle = 'Cart Details';
            fetchDynamicDataEcart(function(){
              if (_this.cartItem) {
                $scope.$watch('cartItem', function(value) {
                  _this.fundName =  value.fundName;
                  _this.fundCode = value.fundCode;
                  initializeData();
                });
              } else {
                initializeData();
              }
            });
          }
        }

        function changeThroughDistributor(investThrough) {
          if (investThrough === 'DIRECT') {
            _this.investThroughFormData.isThroughDistributor = false;
            _this.investThroughFormData.isThroughRia = false;
            _this.investThroughFormData.isDirect = true;
            _this.investThroughFormData.euin = null;
            _this.investThroughFormData.subBrokerCode = null;
            _this.investThroughFormData.brokerCode = null;
            _this.investThroughFormData.subBrokerName = null;
            _this.investThroughFormData.subBrokerARN = null;
            _this.investThroughFormData.isEuin = false;
            _this.investThroughFormData.euin = null;
            _this.investThroughFormData.isCheckedTandC = false;
            _this.investThroughFormData.riaBrokerName = null;
          } else if (investThrough === 'DISTRIBUTOR') {
            _this.investThroughFormData.isThroughDistributor = true;
            _this.investThroughFormData.isDirect = false;
            _this.investThroughFormData.isThroughRia = false;
            _this.investThroughFormData.isEuin = true;
            _this.investThroughFormData.euin = null;
            _this.investThroughFormData.isCheckedTandC = false;
            _this.investThroughFormData.brokerCode = null;
            _this.investThroughFormData.riaBrokerName = null;
            if (_this.cartItem.brokerDetailsDTO && _this.cartItem.brokerDetailsDTO.brokerCode !== 'DIRECT' && !_this.cartItem.brokerDetailsDTO.riaConsent) {
              _this.investThroughFormData.brokerCode = _this.cartItem.brokerDetailsDTO ? _this.cartItem.brokerDetailsDTO.brokerCode.split('-')[1] : null;
              fetchEuinList();
              _this.investThroughFormData.subBrokerCode = _this.cartItem.brokerDetailsDTO ? _this.cartItem.brokerDetailsDTO.subBrokerCode : null;
              _this.investThroughFormData.subBrokerName = _this.cartItem.brokerDetailsDTO ? _this.cartItem.brokerDetailsDTO.subBrokerName : null;
              _this.investThroughFormData.subBrokerARN = _this.cartItem.brokerDetailsDTO && _this.cartItem.brokerDetailsDTO.subBrokerArn ? _this.cartItem.brokerDetailsDTO.subBrokerArn.split('-')[1] : null;
              if (_this.cartItem.brokerDetailsDTO.euinOpted === 'N' && _this.cartItem.brokerDetailsDTO.brokerCode !== 'DIRECT' ) {
                _this.investThroughFormData.isEuin = false;
                _this.investThroughFormData.isCheckedTandC = true;
              }
            } else {
              _this.investThroughFormData.brokerCode = _this.investorData.brokerCode ? _this.investorData.brokerCode.split('-')[1] : null;
              fetchEuinList();
              _this.investThroughFormData.subBrokerARN = _this.investorData.subBrokerARN ? _this.investorData.subBrokerARN.split('-')[1] : null;
              _this.investThroughFormData.subBrokerCode = _this.investorData.subBrokerCode ? _this.investorData.subBrokerCode : null;
              _this.investThroughFormData.subBrokerName = _this.investorData.subBrokerCode ? _this.investorData.subBrokerCode : null;
              if (_this.investorData.euinOpted === 'N' && _this.investorData.investThroughDistributor) {
                _this.investThroughFormData.isEuin = false;
                _this.investThroughFormData.isCheckedTandC = true;
              }
            }
            if (_this.cartItem.brokerDetailsDTO && _this.cartItem.brokerDetailsDTO.euinCode) {
              selectEuin({
                euinNameCode: _this.cartItem.brokerDetailsDTO.euinName +'-'+ _this.cartItem.brokerDetailsDTO.euinCode
              });
            } else if (_this.investorData.euinName && _this.investorData.euinCode) {
              selectEuin({
                euinNameCode: _this.investorData.euinName +'-'+ _this.investorData.euinCode
              });
            }
          } else if (investThrough === 'RIA') {
            _this.investThroughFormData.isThroughDistributor = false;
            _this.investThroughFormData.isDirect = false;
            _this.investThroughFormData.isThroughRia = true;
            _this.investThroughFormData.euin = null;
            _this.investThroughFormData.subBrokerCode = null;
            _this.investThroughFormData.brokerCode = null;
            _this.investThroughFormData.subBrokerName = null;
            _this.investThroughFormData.isEuin = false;
            _this.investThroughFormData.subBrokerARN = null;
            _this.investThroughFormData.isCheckedTandC = false;
            if (_this.cartItem.brokerDetailsDTO && _this.cartItem.brokerDetailsDTO.investThroughRIA) {
              _this.investThroughFormData.riaBrokerCode = _this.cartItem.brokerDetailsDTO ? _this.cartItem.brokerDetailsDTO.brokerCode : null;
              _this.investThroughFormData.isCheckedTandC = _this.cartItem.brokerDetailsDTO.riaConsent;
              changeDistributorCode();
            } else if (_this.investorData && _this.investorData.investThroughRIA) {
              _this.investThroughFormData.riaBrokerCode = _this.investorData ? _this.investorData.brokerCode : null;
              _this.investThroughFormData.isCheckedTandC = _this.investorData ? _this.investorData.riaConsent: false;
              changeDistributorCode();
            }
            fetchEuinList();
          }

          if (!_this.investThroughFormData.isThroughDistributor) {
            _this.investThroughFormData.euin = {};
            _this.investThroughFormData.brokerCode = '';
            _this.investThroughFormData.brokerName = '';
            _this.euinList = null;
            _this.investThroughFormData.distributorARN = '';
            _this.investThroughFormData.distributorName = '';
            _this.investThroughFormData.subBrokerARN = '';
            //_this.investThroughFormData.isCheckedTandC = false;
            _this.isArnSuccess = true;
            _this.investThroughFormData.subBrokerCode = '';
            _this.isSelectedEuin = true;
            _this.subBrokerName = '';
          }
        }

        function changeDistributorCode() {
          _this.investThroughFormData.brokerName = '';
          _this.investThroughFormData.distributorARN = '';
          _this.investThroughFormData.distributorName = '';
          _this.euinList = null;
          _this.isArnSuccess = true;
          _this.riaCodeError = "";
        }

        function searchDistributor() {
          if (_this.investThroughFormData.isThroughDistributor) {
            if (!_this.investThroughFormData.brokerCode) {
              return;
            }
          } else if (_this.investThroughFormData.isThroughRia) {
            if (!_this.investThroughFormData.riaBrokerCode) {
              return;
            }
          }
          fetchEuinList();
        }

        function fetchEuinList() {
          if (_this.investThroughFormData.isThroughDistributor) {
            if (!_this.investThroughFormData.brokerCode) {
              return;
            }
          } else if (_this.investThroughFormData.isThroughRia) {
            if (!_this.investThroughFormData.riaBrokerCode) {
              return;
            }
          }
          _this.investThroughFormData.brokerName = null;
          _this.investThroughFormData.riaBrokerName = null;
          _this.subBrokerCodeError = '';
          _this.euinData = {};
          _this.isArnSuccess = true;
          _this.distributorList = null;

          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.euinMasterList = resp.data.euinList;
              _this.euinList = _this.euinMasterList;
              _this.euinData = _this.investThroughFormData.euin ? _this.investThroughFormData.euin : {};
              _this.brokerCodeError = '';
              _this.riaCodeError = '';
              _this.isArnSuccess = false;
              if (_this.investThroughFormData.isThroughDistributor) {
                _this.investThroughFormData.brokerName = resp.data.distributorName;
              } else if (_this.investThroughFormData.isThroughRia) {
                _this.investThroughFormData.riaBrokerName = resp.data.distributorName;
              }
            } else {
              _this.euinList = null;
              if (_this.investThroughFormData.isThroughDistributor) {
                _this.brokerCodeError = resp.message;
              } else if (_this.investThroughFormData.isThroughRia) {
                _this.riaCodeError = resp.message;
                _this.investThroughFormData.isCheckedTandC = false;
                _this.investThroughFormData.isCheckedTandC = false;
              }
              //MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader();
            _this.euinList = null;
          };
          LoaderService.showLoader();
          var path = {};
          if (_this.investThroughFormData.isThroughDistributor) {
            path  = {
              controller1: 'getEuin',
              controller2: 'ARN-' + _this.investThroughFormData.brokerCode
            };
          } else if (_this.investThroughFormData.isThroughRia) {
            path = {
              controller1: 'getEuin',
              controller2: _this.investThroughFormData.riaBrokerCode,
              riaOpted: _this.investThroughFormData.isThroughRia
            };
          }
          TransactionService.get(path).$promise.then(success, error);
        }

        function filterEuinList() {
          _this.investThroughFormData.euin = {};
          _this.isSelectedEuin = false ;
          if(_this.investThroughFormData.euinNameCode){
            if(_this.investThroughFormData.euinNameCode.length>=3){
              _this.euinList = UtilService.getFilteredList(_this.euinMasterList, 'euinNameCode', _this.investThroughFormData.euinNameCode);
            }
          }
          _this.euinList = _this.investThroughFormData.euinNameCode == '' || _this.investThroughFormData.euinNameCode == undefined || _this.investThroughFormData.euinNameCode.length<3 ? _this.euinMasterList : _this.euinList;
        }

        function selectEuin(data) {
          if (!data) {
            return;
          }
          _this.euinData = {};
          _this.investThroughFormData.euinNameCode = data.euinNameCode;
          _this.isSelectedEuin = _this.investThroughFormData.euinNameCode ? true : false;
        }

        function searchDistributorByName() {
          _this.investThroughFormData.brokerName = '';
          _this.investThroughFormData.distributorARN = '';
          _this.investThroughFormData.brokerCode = '';
          _this.brokerCodeError = '';
          _this.isArnSuccess = true;
          if ((!_this.investThroughFormData.distributorName) || (_this.investThroughFormData.distributorName && _this.investThroughFormData.distributorName.length < 3)) {
            _this.distributorList = null;
            _this.euinList = null;
            _this.investThroughFormData.euin = null;
            return;
          }
          fetchARNByName();
        }

        function fetchARNByName() {
          if ((!_this.investThroughFormData.distributorName) || (_this.investThroughFormData.distributorName && _this.investThroughFormData.distributorName.length < 3)) {
            return;
          }
          _this.investThroughFormData.distributorARN = '';
          _this.distributorList = null;
          _this.isArnSuccess = true;
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.distributorList = resp.data.distributorList;
              if (_this.distributorList.length == 0) {
                _this.investThroughFormData.euin = {};
                _this.investThroughFormData.isCheckedTandC = false;
              }
            } else {
              _this.distributorList = null;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            _this.distributorList=null;
            UtilService.errorHandler(err);
          };

          LoaderService.showLoader();
          TransactionService.get({
            controller1: 'getDistributor',
            controller2: _this.investThroughFormData.distributorName
          }).$promise.then(success, error);
        }

        function distributorListChanged(data) {
          if (!data) {
            return;
          } else {
            _this.brokerCodeError = '';
            _this.investThroughFormData.distributorARN = data.arnCode;
            _this.investThroughFormData.distributorName = data.name + ' - ' + data.arnCode;
            _this.showArnLabel = false;
            if (_this.investThroughFormData.distributorARN) {
              _this.isArnSuccess = false;
            }
            else {
              _this.isArnSuccess = true;
            }
            fetchEuinListThroughDistributor(_this.investThroughFormData.distributorARN);
          }

          function fetchEuinListThroughDistributor(arnCode) {
            if (!arnCode) {
              return;
            }
            _this.investThroughFormData.brokerName = '';
            var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.euinMasterList = resp.data.euinList;
                _this.euinList = _this.euinMasterList;
                _this.euinData = _this.investThroughFormData.euin;
              } else {
                _this.euinList = null;
              }
            },
            error = function () {
              LoaderService.hideLoader();
              _this.euinList = null;
            };

            LoaderService.showLoader();
            TransactionService.get({
              controller1: 'getEuin',
              controller2: arnCode
            }).$promise.then(success, error);
          }
        };

        function changeSubBrokerArn() {
          _this.investThroughFormData.subBrokerCode = '';
          _this.investThroughFormData.isSubarnSuccess = _this.investThroughFormData.subBrokerARN ? true : false;
          _this.investThroughFormData.isCheckedTandC = false;
          _this.subBrokerName = '';
        }

        function fetchEuinListSubBroker() {
          if (!_this.investThroughFormData.subBrokerARN) {
            _this.subBrokerCodeError = '';
            _this.subBrokerName = '';
            _this.isSubarnSuccess = false;
            _this.investThroughFormData.euin = {};
            _this.euinData = {};
            fetchEuinList();
            return;
          }
          if(_this.investThroughFormData.brokerCode !== _this.investThroughFormData.subBrokerARN){
            _this.investThroughFormData.euin = {};
            _this.euinData = {};
          }
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.euinMasterList = resp.data.euinList;
              _this.euinList = _this.euinMasterList;
              for(var i = 0; i<_this.euinList.length; i++){
                if(_this.euinData.euinNameCode === _this.euinList[i].euinNameCode){
                  _this.investThroughFormData.euin = _this.euinList[i];
                  break;
                } else {
                  _this.investThroughFormData.euin = {};
                }
              }
              _this.euinData = _this.investThroughFormData.euin;
              _this.subBrokerName = resp.data.distributorName;
              _this.subBrokerCodeError = '';
              _this.isSubarnSuccess = false;
            } else {
              _this.euinList = null;
              _this.subBrokerCodeError = resp.message;
              _this.isSubarnSuccess = true;
              _this.investThroughFormData.euin = {};
              MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader();
            _this.subBrokerCodeError = '';
          };

          LoaderService.showLoader();
          TransactionService.get({
            controller1: 'getEuin',
            controller2: 'ARN-' + _this.investThroughFormData.subBrokerARN,
            isSubBroker: _this.investThroughFormData.isThroughDistributor
          }).$promise.then(success, error);
        }

        function setTandCVariable() {
          _this.investThroughFormData.isCheckedTandC = _this.investThroughFormData.isCheckedTandC;
        }

        function updateCartViaInvestThrough() {
          var payload = getInvestThroughPayload();
          if (_this.cartItem && _this.cartItem.cartItems) {
            LoaderService.showLoader();
            var success = function(resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.updateInfo({data: resp.data});
                collapse();
              } else {
                MessageService.error(resp.message);
              }
            }, error = function(err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
            investorServiceVersion.post({
              child1: "cart",
              child2: "update",
              child3: "invest-through"
            }, payload).$promise.then(success, error);
          } else {
            _this.updateInfo({data: payload});
            collapse();
          }
        }

        function getInvestThroughPayload() {
          var payload = {
            "brokerDetailsDTO": {
              "directOpted": _this.investThroughFormData.isThroughDistributor ? false : true,
              "brokerCode": identifyBrokerCode(),
              "subBrokerCode": _this.investThroughFormData.isThroughDistributor && _this.investThroughFormData.subBrokerCode ? _this.investThroughFormData.subBrokerCode : null,
              "subBrokerArn": _this.investThroughFormData.isThroughDistributor && _this.investThroughFormData.subBrokerARN ? 'ARN-'+_this.investThroughFormData.subBrokerARN : null,
              "euinOpted": _this.investThroughFormData.isEuin ? 'Y' : 'N',
              "euinCode": _this.investThroughFormData.isThroughDistributor && _this.investThroughFormData.isEuin ? _this.investThroughFormData.euinNameCode.split("-")[1] : null,
              "euinName": _this.investThroughFormData.isThroughDistributor && _this.investThroughFormData.isEuin ? _this.investThroughFormData.euinNameCode.split("-")[0] : null,
              "investThroughRIA": _this.investThroughFormData.isThroughRia ? _this.investThroughFormData.isThroughRia : false,
              "riaConsent": _this.investThroughFormData.isThroughRia ? _this.investThroughFormData.isCheckedTandC : false,
              "isEuin" : _this.investThroughFormData.isEuin ? _this.investThroughFormData.isEuin : false,
              investThroughDirect: _this.investThroughFormData.isDirect,
              investThroughDistributor: _this.investThroughFormData.isThroughDistributor
            }
          };
          if (_this.cartItem.folioNumber) {
           payload.cartItemListCo =  {
              "folioNumber": _this.cartItem.folioNumber,
              "cartItems": _this.cartItem.cartItems,
              "totalAmount": _this.cartItem.totalAmount
            };
            if (_this.ecartObj && _this.ecartObj.flowName && _this.ecartObj.flowName === "INVEST_NOW_WEBSITE" && _this.ecartObj.linkId) {
              payload.cartItemListCo.linkId = _this.ecartObj.linkId;
              payload.cartItemListCo.flowName = _this.ecartObj.flowName;
            }
            payload.cartItemListCo.janNiveshOpted = _this.isFromJanNivesh? _this.isFromJanNivesh: false;
          }
          return payload;
        }

        function identifyBrokerCode() {
          if (_this.investThroughFormData.isDirect) {
            return "DIRECT";
          } else if (_this.investThroughFormData.isThroughDistributor) {
            return _this.investThroughFormData.brokerCode ? 'ARN-'+_this.investThroughFormData.brokerCode : _this.investThroughFormData.distributorARN;
          } else if (_this.investThroughFormData.isThroughRia) {
            return _this.investThroughFormData.riaBrokerCode;
          }
        }

        /*---------------------------------------- CART DETAILS SECTION ----------------------------------------------*/
        function initializeData() {
          //_this.formData.inSchemeName = _this.cartItem && _this.cartItem.schemeName;
          _this.fundName = _this.fundName ? _this.fundName: _this.cartItem.fundName;
          _this.fundCode = _this.fundCode ? _this.fundCode: _this.cartItem.fundCode;
          if (_this.cartItem) {
            _this.formData.schemeCode = _this.cartItem.schemeCode;
            _this.formData.cartItemId = _this.cartItem.cartItemId;
          }
          if (!angular.isUndefined(_this.cartItem)) {
            _this.allFundForm.isRegular = identifyRegular();
          }
          if(_this.cartItem && !_this.cartItem.sipOpted) {
            _this.formData.sipOpted = false;
          }
          if (_this.cartItem && !_this.cartItem.purchaseOpted) {
            _this.formData.purchaseOpted = false;
          }
          if (_this.cartItem && _this.cartItem.brokerCode === 'DIRECT') {
            _this.formData.isDirectFund = true;
          }
          if ( _this.cartItem && _this.cartItem.sipDate) {
            _this.formData.startDate = moment(_this.cartItem.sipDate ,'DD-MMM-YYYY');
            _this.setFromData = true;
          }
          fetchSchemeList();
        }

        function addTransactionFields(transaction) {
          if (transaction === 'PURCHASE') {
            _this.formData.purchaseOpted = true;
            angular.element(document.getElementById('scrollTo')).animate({scrollTop: 0}, 500);
          } else if (transaction === 'SIP') {
            _this.formData.sipOpted = true;
          }
          if(_this.formData.sipOpted) {
            //_this.formData.installmentDisplayAmount = _this.cartItem && _this.cartItem.installmentAmount ? _this.cartItem.installmentAmount : _this.formData.installmentDisplayAmount ? _this.formData.installmentDisplayAmount : _this.sipValidation.sipDefaultAmount;
            _this.formData.installmentDisplayAmount = _this.formData.installmentDisplayAmount ? UtilService.amountInComma(_this.formData.installmentDisplayAmount).amountInComma : _this.cartItem && _this.cartItem.installmentAmount ? UtilService.amountInComma(_this.cartItem.installmentAmount).amountInComma : UtilService.amountInComma(_this.sipValidation.sipDefaultAmount).amountInComma;
            changeInstallmentAmount('SIP');
          }
          if (_this.formData.purchaseOpted) {
            _this.formData.displayAmount = _this.formData.displayAmount ? UtilService.amountInComma(_this.formData.displayAmount).amountInComma : _this.cartItem && _this.cartItem.amount ? UtilService.amountInComma(_this.cartItem.amount).amountInComma : UtilService.amountInComma(_this.purchaseValidation.defaultAmount).amountInComma;
            changeInstallmentAmount('PURCHASE');
          }
        }

        function addPurchaseClick(){
          _this.isPurchaseFieldClick = true;
        }

        function removeTransactionFromList(transaction) {
          if (transaction === 'PURCHASE') {
            _this.formData.purchaseOpted = false;
            _this.formData.displayAmount = null;
            _this.formData.amount = null;
          } else if (transaction === 'SIP') {
            _this.formData.sipOpted = false;
            _this.formData.installmentDisplayAmount = null;
            _this.formData.installmentAmount = null;
            delete _this.formData.startDate;
            delete _this.formData.endDate;
            delete _this.formData.installmentAmount;
          }
        }

        /*
        *  scheme list methods defined here
        * */
        function fetchSchemeList() {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.inSchemeList = resp.data.schemeDetails;
              _this.masterSchemeList = _this.inSchemeList;
              _this.fundName = resp.data.fundName;
              _this.fundCode = resp.data.fundCode;
              _this.maxMandateDurationYears = resp.data.sipSettings && resp.data.sipSettings.eOTM.maxMandateDurationYears;
              _this.maxMandateUPIDurationYears = resp.data.sipSettings && resp.data.sipSettings.upi.maxMandateDurationYears;
              _this.NPCINote = _this.getNote.noteDTO.noteDTOMap.Note_NPCI_Info.content.replace('%@', _this.maxMandateDurationYears);
              _this.sipJanNiveshMinInstallments = resp.data.janNiveshRules;
              if (_this.formData.schemeCode) {
                var schemeData = _this.inSchemeList.filter(function(scheme) {
                  return scheme.schemeCode === _this.formData.schemeCode;
                });
                _this.inSchemeChanged(schemeData[0]);
              } else if(_this.inSchemeList.length === 1) {
                _this.inSchemeList.forEach(function(list, index) {
                  _this.inSchemeChanged(list);
                });
              } else {
                _this.inSchemeList.forEach(function(list, index) {
                  if(list.investmentOption === "GROWTH") {
                    _this.inSchemeChanged(list);
                  }
                });
              }
            } else {
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          InvestorService.post({
            child1: 'validate',
            child2: 'fund'
          }, {
            fundCode: _this.fundCode,
            directFund: !_this.allFundForm.isRegular
          }).$promise.then(success, error);
        }

        function filterInSchemeList() {
          _this.formData.schemeCode = '';
          _this.inSchemeList = UtilService.getFilteredList(_this.masterSchemeList, 'schemeName', _this.formData.schemeName);
        }

        function changeSelectedScheme() {
          if (_this.formData.schemeName) {
            var filteredList = UtilService.getFilteredList(_this.inSchemeList, 'schemeName', _this.formData.schemeName);
            inSchemeChanged(filteredList[0]);
          } else {
            _this.formData.schemeCode = null;
          }
        }

        function inSchemeChanged(schemeData) {
          if (!schemeData) {
            return;
          } else {
            _this.formData.schemeCode = schemeData.schemeCode;
            _this.formData.schemeName = schemeData.schemeName;
            _this.formData.schemeType = schemeData.schemeType;
            _this.formData.isDividend = schemeData.investmentOption && schemeData.investmentOption === 'DIVIDEND' ? true : false;
            _this.purchaseValidation = schemeData.purchaseValidation;
            _this.sipValidation = schemeData.sipValidation;
            _this.schemeType = schemeData.schemeType;
            _this.investmentOptions = [];
            if (schemeData.dividendReinvestmentApplicable) {
              _this.investmentOptions.push(AppConstants.IDCW_OPTIONS[0]);
            }
            if (schemeData.dividendPayoutApplicable) {
              _this.investmentOptions.push(AppConstants.IDCW_OPTIONS[1]);
            }
            if (_this.formData.isDividend) {
              if (_this.cartItem && _this.cartItem.dividendOption && (_this.cartItem.dividendOption == AppConstants.IDCW_OPTIONS[0].value || _this.cartItem.dividendOption == AppConstants.IDCW_OPTIONS[1].value)) {
                var dividendObject = _this.investmentOptions.find(function (el) {
                  return el.value === _this.cartItem.dividendOption;
                })
                _this.changeInvestmentOptions(dividendObject);
              } else {
                _this.changeInvestmentOptions(_this.investmentOptions[0]);
              }
            }
            _this.purchaseValidation = schemeData.purchaseValidation;
            _this.sipValidation = schemeData.sipValidation;
            if (_this.sipValidation.sipEnabled === 'Y') {
              _this.formData.sipOpted = true;
            } else {
              _this.formData.sipOpted = false;
            }
            if(_this.cartItem && !_this.cartItem.sipOpted) {
              _this.formData.sipOpted = false;
            } else if (angular.isDefined(_this.formData.sipOpted)) {
              _this.formData.sipOpted = _this.formData.sipOpted;
            } else {
              if (_this.sipValidation.sipEnabled === 'Y') {
                _this.formData.sipOpted = true;
              } else {
                _this.formData.sipOpted = false;
              }
            }
            if (_this.purchaseValidation.webPurchaseEnabled === 'Y') {
              _this.formData.purchaseOpted = true;
            } else {
              _this.formData.purchaseOpted = false;
            }
            if (_this.cartItem && !_this.cartItem.purchaseOpted) {
              _this.formData.purchaseOpted = false;
            } else if (angular.isDefined(_this.formData.purchaseOpted)) {
              _this.formData.purchaseOpted = _this.formData.purchaseOpted;
            } else {
              if (_this.purchaseValidation.webPurchaseEnabled === 'Y') {
                _this.formData.purchaseOpted = true;
              } else {
                _this.formData.purchaseOpted = false;
              }
            }
            if(_this.formData.sipOpted) {
              _this.formData.installmentDisplayAmount = _this.formData.installmentDisplayAmount ? UtilService.amountInComma(_this.formData.installmentDisplayAmount).amountInComma : _this.cartItem && _this.cartItem.installmentAmount ? UtilService.amountInComma(_this.cartItem.installmentAmount).amountInComma : UtilService.amountInComma(_this.sipValidation.sipDefaultAmount).amountInComma;
              changeInstallmentAmount('SIP');
            }
            if (_this.formData.purchaseOpted) {
              _this.formData.displayAmount = _this.formData.displayAmount ? UtilService.amountInComma(_this.formData.displayAmount).amountInComma : _this.cartItem && _this.cartItem.amount ? UtilService.amountInComma(_this.cartItem.amount).amountInComma : UtilService.amountInComma(_this.purchaseValidation.defaultAmount).amountInComma;
              changeInstallmentAmount('PURCHASE');
            }
          }
        }

        function changeInvestmentOptions(data) {
          if (!data) {
            return;
          }
          _this.formData.investmentOptionName = data.key;
          _this.formData.dividendOption = data.value;
        }

        /*
        *
        * Amount fields methods defined here
        *
        * */

        function changeInstallmentAmount(transaction,calledFromHtml) {
          if (transaction === 'PURCHASE') {
            var amountObj = UtilService.amountInComma(_this.formData.displayAmount);
            if (!calledFromHtml) {
              _this.formData.displayAmount = _this.formData.displayAmount ? _this.formData.displayAmount : amountObj.amountInComma;
              _this.formData.amount = _this.formData.amount ? _this.formData.amount : amountObj.amount;
            } else {
              _this.formData.displayAmount = amountObj.amountInComma;
              _this.formData.amount = amountObj.amount;
            }
            calculateValidations();
          } else if (transaction === 'SIP') {
            var amountObj = UtilService.amountInComma(_this.formData.installmentDisplayAmount);
            if (!calledFromHtml) {
              _this.formData.installmentDisplayAmount = _this.formData.installmentDisplayAmount ? _this.formData.installmentDisplayAmount: amountObj.amountInComma;
              _this.formData.installmentAmount = _this.formData.installmentAmount ? _this.formData.installmentAmount : amountObj.amount;
            } else {
              _this.formData.installmentDisplayAmount = amountObj.amountInComma;
              _this.formData.installmentAmount = amountObj.amount;
            }
            calculateValidations();
            getDateValidation(function() {
              if (calledFromHtml) {
                _this.setFromData = false;
              }
              changeStartDate(_this.formData.startDate);
            });
          }
        }

        /*
        *
        * Date fields methods defined here
        *
        * */

        function changeStartDate(date) {
          if (_this.setFromData) {

            var diff = date.isSame(_this.formData.startDate);

            if (!diff) {
              _this.setFromData = false;
            }
          }
          _this.formData.startDate = date ? date : null;
          _this.formData.day = _this.formData.startDate ? $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format('D') : '';
          _this.formData.endDate = null;
          // _this.startDateError = _this.formData.startDate && !_this.formData.startDate.isSameOrAfter(_this.enabledStartDates[_this.sipValidation.sipTDay]);
          _this.startDateError = _this.formData.startDate && _this.formData.startDate.isBefore(_this.startMinDateBiller);
          updateEndDates();
        }

        function changeEndDate(date) {
          if (date) {
            _this.formData.endDate = date ? date : null;
            if ($window.moment(_this.formData.endDate, "DD-MMM-YYYY").isSame($window.moment(_this.tillPerpetuityEndDate, "DD-MMM-YYYY"))) {
              _this.formData.isTillPerpetuity = true;
            } else {
              var isDefaultTo = $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]).year() >= 2099? true: false;
              if($window.moment(_this.formData.endDate, "DD-MMM-YYYY").isSame($window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1], "DD-MMM-YYYY")) && isDefaultTo) {
                _this.formData.isTillPerpetuity = true;
              } else {
                _this.formData.isTillPerpetuity = false;
              }
            }
            var emandateEndDate = $window.moment(_this.formData.startDate,'DD-MMM-YYYY').add(_this.maxMandateDurationYears,'years');
            var selectedEndDate = $window.moment(_this.formData.endDate,'DD-MMM-YYYY');
            var endDateEmandateBoundExist = selectedEndDate.isBefore(emandateEndDate);
            if (!endDateEmandateBoundExist) {
              _this.isExceedingEmandateDate = true;
            } else {
              _this.isExceedingEmandateDate = false;
            }

            var upiEndDate = $window.moment(_this.currentDate,'DD-MMM-YYYY').add(_this.maxMandateUPIDurationYears,'years');
            var selectedUPIEndDate = $window.moment(_this.formData.endDate,'DD-MMM-YYYY');
            var endDateUPIBoundExist = selectedUPIEndDate.isBefore(upiEndDate);
            if (!endDateUPIBoundExist) {
              _this.isExceedingUPIDate = true;
            } else {
              _this.isExceedingUPIDate = false;
            }

          } else {
            _this.isExceedingEmandateDate = false;
            _this.isExceedingUPIDate = false;
          }
          checkEnableEndDate();
        }

        function getDateValidation(cb) {
          cb = cb || function () {
          };
          LoaderService.showLoader();
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              var currentDate = resp.data.currentDate || Date();
              var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
              var todayDate = $window.moment(Date.parse(parsedDate));
              var counter =0;
              _this.enabledStartDates = [];
              _this.nonBusinessDatess = resp.data.nonBuisnessDates;
              _this.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(_this.sipValidation.sipTDay, 'days'); // t+17 need to change it to dynamically variable.
              _this.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
              var startDate = todayDate.clone();
              var freq = _this.startMaxDate.diff(todayDate, 'days');
              for (var i = 0; i <= freq; i++) {
                var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
                var isEnable = true;
                if(counter<5)
                {
                  // angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                  //   if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')===0){
                  //     isEnable = false;
                  //   }
                  // });
                }
                if(isEnable){
                  _this.enabledStartDates.push(startDate.clone().add(i, 'days'));
                  counter++;
                }
              }
              _this.formData.startDate =  _this.formData.startDate ?  _this.formData.startDate : _this.enabledStartDates[_this.sipValidation.sipTDay];
              cb();
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          InvestorService.get({
            child1: 'nonBusinessDate',
            schemeCode: _this.formData.schemeCode //'AFWDQ'
          }).$promise.then(success, error);
        }

        function updateEndDates() {
          if (!_this.formData.startDate) {
            return;
          }
          var defaultEndDate = $window.moment((new Date()), "DD-MM-YYYY").add(99, 'years');
          var defaultMonths = null;
          var endDate = null;
          var enabledEndDates = [];
          var freq = _this.sipValidation && _this.sipValidation.monMaxInstallmentNumber || 0;
          var i = 0;
          var frequency = {
            "name": "Monthly",
            "code": "OM",
            "duration": 1
          };
          var months = 0;
          endDate = _this.formData.startDate.clone().add(frequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.duration);
          for (i = 0; i < freq; i++) {
            months = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }

          if(_this.isFromJanNivesh && _this.isNewUser && _this.sipJanNiveshMinInstallments) {
           var minInstallments = _this.sipJanNiveshMinInstallments && _this.sipJanNiveshMinInstallments.sipMinInstallments || 0;
          } else {
            var minInstallments = _this.validations && _this.validations.minInstallments && (_this.validations.minInstallments - 1) || 0;
          }
          _this.enabledEndDates = enabledEndDates.slice(minInstallments);
          _this.enabledEndDateView = angular.copy(_this.enabledEndDates[0]);
          if (_this.setFromData) {
            if ( _this.cartItem && _this.cartItem.toDate) {
              _this.formData.endDate = moment(_this.cartItem.toDate ,'DD-MMM-YYYY');
                _this.tillPerpetuityEndDate = $window.moment(_this.formData.startDate).date() + '-' + ($window.moment(_this.formData.startDate).month() + 1) + '-' + $window.moment(_this.formData.endDate).year();
                _this.tillPerpetuityEndDate = $window.moment(_this.tillPerpetuityEndDate, "DD-MM-YYYY");
              if(_this.isPurchaseFieldClick) {
                _this.formData.isTillPerpetuity = true;
                changeTillPerpetuity();
                _this.isPurchaseFieldClick = false;
              }
            }
          } else {
            //_this.formData.isTillPerpetuity = true; //HMF-24034
            //changeTillPerpetuity();//HMF-24034
            var duration = _this.sipValidation.monMaxInstallmentNumber < _this.maxMandateUPIDurationYears*12 ? parseInt(_this.sipValidation.monMaxInstallmentNumber/12) : _this.maxMandateUPIDurationYears;
            var enabledDates = [];
            var fre = null;
            var endDateDefault = $window.moment($window.moment().clone(), "DD-MM-YYYY").add(duration, 'years').add(1, 'months');
            fre = fre || (UtilService.getNumberOfMonths(_this.formData.startDate, $window.moment(endDateDefault)) / frequency.duration);
            for (i = 0; i < fre; i++) {
              months = frequency.duration * i;
              enabledDates.push(endDate.clone().add(months, 'months'));
            }
            enabledDates.slice(minInstallments);
            _this.formData.endDate = $window.moment(enabledDates[enabledDates.length - 1], 'DD-MMM-YYYY');
            handleUPIMaxEndDate();
          }
          checkEnableEndDate();
        }

        function changeTillPerpetuity(value) {
          if (_this.formData.isTillPerpetuity) {
            _this.isDateAvailable = false;
            var enabledEndDateMaxYear = $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]).year();
            _this.tillPerpetuityEndDate = $window.moment(_this.formData.startDate).date() + '-' + ($window.moment(_this.formData.startDate).month() + 1) + '-' + enabledEndDateMaxYear;
            var endDatePerpetuity = $window.moment(_this.tillPerpetuityEndDate, "DD-MMM-YYYY");
            _this.enabledEndDates.forEach(function(date){
              if(date.isSame(endDatePerpetuity)){
                _this.isDateAvailable = true;
              }
            })
            if(_this.isDateAvailable) {
              if($window.moment(endDatePerpetuity).month() !== $window.moment(_this.formData.startDate).month()){
                _this.tillPerpetuityEndDate = $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]);
              } else {
                _this.tillPerpetuityEndDate = $window.moment(endDatePerpetuity, "DD-MM-YYYY");
              }
            } else {
              _this.tillPerpetuityEndDate = $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]);
            }
            var calculatedEndDate = $window.moment(_this.tillPerpetuityEndDate, "DD-MMM-YYYY");
            if (calculatedEndDate && (($window.moment(calculatedEndDate).isBetween($window.moment(_this.enabledEndDates[0]), $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]))) || (calculatedEndDate.isSame($window.moment(_this.enabledEndDates[0]))) || (calculatedEndDate.isSame($window.moment(_this.enabledEndDates.length - 1))))) {
              _this.formData.endDate = angular.copy(calculatedEndDate);
            } else {
              calculatedEndDate.set('year', enabledEndDateMaxYear);
              _this.tillPerpetuityEndDate = angular.copy(calculatedEndDate);
              _this.formData.endDate = angular.copy(calculatedEndDate);
            }
            if ($window.moment(_this.formData.endDate).year() > 2099) {
              _this.formData.endDate = _this.formData.startDate.clone().set('year', 2099);
              _this.tillPerpetuityEndDate = angular.copy(_this.formData.endDate);
            }
            if (_this.formData.endDate) {
              var calculateEndYear = _this.formData.startDate.clone().set('year', 2099);
              _this.initialUpiEndDateSelected = $window.moment(_this.formData.startDate, "DD-MM-YYYY").add(_this.maxMandateUPIDurationYears, 'years');
              _this.formData.endDate = value === 'fromHtml'? calculateEndYear : _this.initialUpiEndDateSelected;
              _this.tillPerpetuityEndDate = _this.formData.startDate.clone().set('year', 2099);
            }
            if($window.moment([$window.moment(_this.formData.endDate).year()]).isLeapYear() && $window.moment(_this.formData.endDate, "DD-MMM-YYYY").format('D') == 29 && $window.moment(_this.formData.endDate).month() == 1){
              _this.formData.endDate.set('date', 28);
              _this.tillPerpetuityEndDate = angular.copy(_this.formData.endDate);
            }
          } else {
            _this.formData.endDate = null;
          }
          checkEnableEndDate();
        }

        function saveCartEdited() {
          LoaderService.showLoader();
          var payload = getUpdatePayload();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.updateInfo();
              collapse();
            } else {
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          if(_this.linkdata && _this.linkdata.flowName == 'E_CART'){
            payload.linkId = _this.linkdata.chipherText;
            payload.euinCode = _this.cartItem.euinCode ? _this.cartItem.euinCode: '';
            payload.euinName = _this.cartItem.euinName ? _this.cartItem.euinName: '';
            investorServiceVersion.post({
              child1: 'arn',
              child2: 'cart',
              child3: 'update',
              child4: 'item'
            }, payload).$promise.then(success, error);
          } else if (_this.ecartObj && _this.ecartObj.flowName && _this.ecartObj.flowName === "INVEST_NOW_WEBSITE" && _this.ecartObj.linkId) {
            payload.linkId = _this.ecartObj.linkId;
            payload.flowName = _this.ecartObj.flowName;
            investorServiceVersion.post({
              child1: 'cart',
              child2: 'update',
              child3: 'item'
            }, payload).$promise.then(success, error);
          } else {
            investorServiceVersion.post({
              child1: 'cart',
              child2: 'update',
              child3: 'item'
            }, payload).$promise.then(success, error);
          }
        }

        function addToCart() {
          var payload = getPayload();
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.updateInfo();
              MessageService.success(resp.data.message);
              collapse('saved');
              $rootScope.$broadcast('UpdateCart', {listUpdated: true});
              if(_this.pendingState) {
                $state.go(_this.pendingState);
              }
              /*ModalService.ecartSuccessModal({
                message: resp.data.message
              }, function() {
                //$state.reload();
              });*/
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          }
          if(_this.linkdata && _this.linkdata.flowName == 'E_CART'){
            payload.linkId = _this.linkdata.chipherText;
            investorServiceVersion.post({
              child1: 'arn',
              child2: 'cart',
              child3: 'add',
              child4: 'item'
            }, payload).$promise.then(success, error);
          } else if (_this.ecartObj && _this.ecartObj.flowName && _this.ecartObj.flowName === "INVEST_NOW_WEBSITE" && _this.ecartObj.linkId) {
            payload.linkId = _this.ecartObj.linkId;
            payload.flowName = _this.ecartObj.flowName;
            investorServiceVersion.post({
              child1: 'cart',
              child2: 'add',
              child3: 'item'
            }, payload).$promise.then(success, error);
          } else {
            investorServiceVersion.post({
              child1: 'cart',
              child2: 'add',
              child3: 'item'
            }, payload).$promise.then(success, error);
          }
        }

        function getPayload() {
          if (_this.cartItem && _this.cartItem.addTocart) {
            var payload = _this.cartItem;
            payload.purchaseOpted = _this.formData.purchaseOpted;
            payload.sipOpted = _this.formData.sipOpted;
            payload.amount = _this.formData.amount;
            payload.dividendOption = _this.formData.isDividend ? _this.formData.dividendOption : _this.appConstants.TRANSACTIONS.DIVIDEND_OPTIONS.GROWTH;
            payload.cgfApplicable =  _this.inSchemeList[0].cgfApplicable;
            payload.retirementApplicable = _this.inSchemeList[0].retirementApplicable;
            payload.frequency =  "OM";
            payload.schemeCode = _this.formData.schemeCode;
            if (_this.cartItem.sipOpted) {
              payload.sipDate = $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
              payload.toDate = $window.moment(_this.formData.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
              payload.sipDay = _this.formData.day;
              payload.installmentAmount = _this.formData.installmentAmount;
            }
          } else {
            var payload = {
              "schemeCode": typeof _this.formData.schemeCode === 'object' ? _this.formData.schemeCode.schemeCode : _this.formData.schemeCode,
              "amount": _this.formData.amount,
              "dividendOption": _this.formData.isDividend ? _this.formData.dividendOption : _this.appConstants.TRANSACTIONS.DIVIDEND_OPTIONS.GROWTH,
              "brokerCode": _this.investorData && _this.investorData.brokerCode ? _this.investorData.brokerCode: 'DIRECT',
              "subBrokerCode": _this.investorData && _this.investorData.subBrokerCode ? _this.investorData.subBrokerCode: null,
              "subBrokerArn": _this.investorData && _this.investorData.subBrokerArn ? _this.investorData.subBrokerArn: null,
              "euinOpted": _this.investorData.euinOpted,
              "euinCode": _this.investorData && _this.investorData.euinCode ? _this.investorData.euinCode: null,
              "euinName": _this.investorData && _this.investorData.euinName ? _this.investorData.euinName: null,
              "liquid": _this.schemeType === 'LIQUID' ? true: false,
              "folioNumber": _this.investorData && _this.investorData.folioNumber ? _this.investorData.folioNumber: null,
              "cgfApplicable": _this.inSchemeList[0].cgfApplicable,
              "minorFlag": _this.investorData && _this.investorData.minorFlag ? _this.investorData.minorFlag: false,
              "riaConsent": _this.investorData && _this.investorData.riaConsent ? _this.investorData.riaConsent: false,
              "brokerKey": _this.investorData && _this.investorData.brokerKey ? _this.investorData.brokerKey: null,
              "brokerValue": _this.investorData && _this.investorData.brokerValue ? _this.investorData.brokerValue: null,
              "newUser": false,
              "invType": _this.investorData && _this.investorData.invType ? _this.investorData.invType: null,
              "purchaseOpted": _this.formData.purchaseOpted,
              "sipOpted": _this.formData.sipOpted,
              "frequency": "OM",
              "numberOfInstallment": $window.moment($window.moment(_this.formData.endDate, "DD-MMM-YYYY")).diff($window.moment(_this.formData.startDate, "DD-MMM-YYYY"),'months') + 1,
              "installmentAmount": _this.formData.installmentAmount,
              "investmentOption": _this.formData.isDividend ? 'DIVIDEND': 'GROWTH',
              "retirementApplicable": _this.inSchemeList[0].retirementApplicable
            };

            if (_this.formData.sipOpted) {
              payload.sipDate = $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
              payload.toDate = $window.moment(_this.formData.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
              payload.sipDay = _this.formData.day;
            }
          }
          return payload;
        }

        function getUpdatePayload() {
          var payload = {};
          payload.cartItemId = _this.cartItem.cartItemId;
          payload.schemeCode = typeof _this.formData.schemeCode === 'object' ? _this.formData.schemeCode.schemeCode : _this.formData.schemeCode;
          payload.schemeName = _this.formData.schemeName;
          payload.dividendOption = _this.formData.isDividend ? _this.formData.dividendOption : _this.appConstants.TRANSACTIONS.DIVIDEND_OPTIONS.GROWTH;
          payload.folioNumber = _this.cartItem && _this.cartItem.folioNumber ? _this.cartItem.folioNumber : null;
          payload.sipOpted = _this.formData.sipOpted;
          payload.purchaseOpted = _this.formData.purchaseOpted;
          payload.minorFlag = _this.investorData.minorFlag;
          payload.brokerCode = _this.investorData.brokerCode;
          payload.installmentAmount = _this.formData.installmentAmount;
          payload.amount = _this.formData.amount;
          payload.invType = _this.investorData.invType;
          payload.euinOpted = _this.investorData.euinOpted;
          payload.euinCode = _this.investorData && _this.investorData.euinCode ? _this.investorData.euinCode: null;
          payload.frequency = "OM";
          payload.riaConsent = _this.investorData && _this.investorData.riaConsent ? _this.investorData.riaConsent: false;
          payload.liquid = _this.schemeType === 'LIQUID' ? true: false;
          if (_this.formData.sipOpted) {
            payload.sipDate = $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
            payload.toDate = $window.moment(_this.formData.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
            payload.sipDay = _this.formData.startDate ? $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format('D') : '';
          }
          payload.janNiveshOpted = _this.isFromJanNivesh? _this.isFromJanNivesh: false;
          return payload;
        }

        function resetValues() {
          _this.formData = {};
          _this.investThroughFormData = {};
          _this.formData.sipOpted = true;
          _this.formData.purchaseOpted = true;
          _this.allFundForm.regularDirectError = null;
        }

        /*--------------------------------------- All funds section starts from here ---------------------------------*/
        function fetchFunds() {
          LoaderService.showLoader();
          var success = function(resp) {
            if (resp.status && resp.data) {
              if(_this.linkdata && _this.linkdata.flowName == 'E_CART' && _this.linkdata.isHdfcBank){
                _this.allFunds = showRecommendedFundOnTop(resp.data.funds);
              } else {
                _this.allFunds = resp.data.funds;
              }
              if(_this.linkdata && _this.investorData && _this.investorData.investThroughRIA == true){
                _this.allFundForm.isRegular = false;
              } else if(_this.linkdata && _this.investorData && _this.investorData.investThroughRIA == false){
                _this.allFundForm.isRegular = true;
              } else {
                _this.allFundForm.isRegular = _this.investorData.investThroughDistributor ? true : false;
              }
              filterDirectAndRegularFunds(function() {
                _this.funds = _this.allFundForm.isRegular ? _this.regularFunds : _this.directFunds;
                LoaderService.hideLoader();
              });
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          InvestorService.get({
            child1: 'new',
            child2: 'user',
            child3: 'fund',
            child4: 'detail'
          }).$promise.then(success, error);
        }

        function fetchFundsFilters() {
          LoaderService.showLoader();
          var success = function(resp) {
            if (resp.status && resp.data) {
              var filters = resp.data;
              _this.filterList = [];
              Object.keys(filters).forEach(function(filter) {
                var filterOptions = [];
                filters[filter].forEach(function(option) {
                  var filterOption = {
                    key: option,
                    value: option,
                    checked: false
                  };
                  filterOptions.push(filterOption);
                });
                var obj = {
                  filterName: titleCase(filter),
                  filterKey: filter.replaceAll(" ", "") === 'riskRating' ? 'riskReturnProfile' : filter.replaceAll(" ", "") === "fundCategories" || filter.replaceAll(" ", "") === "fundCategory" ? 'fundCategory' : filter.replaceAll(" ", ""),
                  filterOptions: filterOptions
                };
                _this.filterList.push(obj);
              });
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          InvestorService.get({
            child1: 'new',
            child2: 'user',
            child3: 'fund',
            child4: 'filter',
            child5: 'option'
          }).$promise.then(success, error);
        }

        function displayCagrValue(fund) {
          if (_this.allFundForm.isRegular) {
            fund.regularCagrReturns.forEach(function (x) {
              if(x.key === fund.selectedYear) {
                fund.regularCagr = x.value;
              }
            });
          } else if (!_this.allFundForm.isRegular) {
            fund.directCagrReturns.forEach(function (x) {
              if(x.key === fund.selectedYear) {
                fund.directCagr = x.value;
              }
            });
          }
        }

        function openFilter() {
          //angular.element(document.getElementsByClassName('filter-row')).toggle();
          angular.element(document.getElementsByClassName('filter-row')).toggleClass('showSidebar');
        }

        function filterDirectAndRegularFunds(cb) {
          _this.regularFunds = [];
          _this.directFunds= [];
          _this.allFunds.forEach(function(funds) {
            funds.selectedYear = 'Since Inception';
            if (funds.regularScheme.length > 0) {
              var returnsArray = [];
              funds.regularCagrReturns = [];
              if (!angular.equals(funds.fundNavRegular) && !angular.equals(funds.fundNavRegular.annualisedreturns)) {
                Object.keys(funds.fundNavRegular.annualisedreturns).forEach(function(key) {
                  if (key === '5') {
                    funds.regularCagr = funds.fundNavRegular.annualisedreturns[key];
                  }
                  var obj = {
                    key: key === 11 || key === '11' ? 'Since Inception' : key === 1 || key === '1' ? key + ' Year' : key + ' Years',
                    value: funds.fundNavRegular.annualisedreturns[key]
                  };
                  returnsArray.push(obj);
                });
              }
              funds.regularCagrReturns = returnsArray;
              if(_this.linkdata && _this.linkdata.flowName == 'E_CART' && funds.fundCode !== 'HDFCGF') {
                _this.regularFunds.push(funds);
              } else if(!_this.linkdata) {
                _this.regularFunds.push(funds);
              }
            }
            if(funds.directScheme.length > 0) {
              var returnsArray = [];
              funds.directCagrReturns = [];
              if (!angular.equals(funds.fundNavDirect) && !angular.equals(funds.fundNavDirect.annualisedreturns)) {
                Object.keys(funds.fundNavDirect.annualisedreturns).forEach(function(key) {
                  if (key === '5') {
                    funds.directCagr = funds.fundNavDirect.annualisedreturns[key];
                  }
                  var obj = {
                    key: key === "11" || key === 11 ? 'Since Inception' : key === 1 || key === '1' ? key + ' Year' : key + ' Years',
                    value: funds.fundNavDirect.annualisedreturns[key]
                  };
                  returnsArray.push(obj);
                });
              }
              funds.directCagrReturns = returnsArray;
              if(_this.linkdata && _this.linkdata.flowName == 'E_CART' && funds.fundCode !== 'HDFCGF') {
                _this.directFunds.push(funds);
              } else if(!_this.linkdata) {
                _this.directFunds.push(funds);
              }
            }
          });
          cb();
        }

        function changeFundsListing() {
          /*_this.allFundForm.isRegular = !_this.allFundForm.isRegular;*/
          if (_this.investorData && _this.investorData.investThroughDistributor && !_this.allFundForm.isRegular) {
            _this.allFundForm.regularDirectError = 'You have opted invest through Distributor in your cart. Please select Regular fund to proceed.';
            _this.funds = [];
          } else if (_this.investorData && _this.investorData.investThroughDirect && _this.allFundForm.isRegular) {
            _this.allFundForm.regularDirectError = 'You have opted invest through Direct in your cart. Please select Direct fund to proceed.';
            _this.funds = [];
          } else if (_this.investorData && _this.investorData.investThroughRIA && _this.allFundForm.isRegular) {
            _this.allFundForm.regularDirectError = 'You have opted invest through RIA in your cart. Please select Direct fund to proceed.';
            _this.funds = [];
          } else {
            _this.allFundForm.regularDirectError = null;
            _this.funds = _this.allFundForm.isRegular ? _this.regularFunds : _this.directFunds;
          }
          //_this.funds = _this.allFundForm.isRegular ? _this.regularFunds : _this.directFunds;
          if(angular.element(document.getElementsByClassName('filter-row')).hasClass('showSidebar')) {
            angular.element(document.getElementsByClassName('filter-row')).removeClass('showSidebar');
            _this.filterList = angular.copy(AppConstants.ALL_FUNDS_FILTER);
            _this.filterValues = [];
            _this.filterList.forEach(function(list){
              list.filterOptions.forEach(function(option) {
                option.checked = false;
              });
            });
          }
        }

        function filterFunds(key, filterOptions) {
          if (_this.allFundForm.regularDirectError === null) {
            var fundsToBeFiltered = _this.allFundForm.isRegular ? _this.regularFunds : _this.directFunds;
            filterOptions.forEach(function(option) {
              if (option.checked) {
                if (!_this.filterValues.includes(option.value)) {
                  _this.filterValues.push(option.value);
                }
              } else if (!option.checked && _this.filterValues.includes(option.value)) {
                var index = _this.filterValues.indexOf(option.value);
                if (index > -1) {
                  _this.filterValues.splice(index, 1);
                }
              }
            });
            if (_this.filterValues.length > 0) {
              if (key === 'timeHorizons') {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  return _this.filterValues.includes(funds.timeHorizon);
                });
              } else if (key === 'riskRatings') {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  return _this.filterValues.includes(funds.riskReturnProfile[0]);
                });
              } else if (key === 'goalTypes') {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  if (funds.goalsType.length > 0) {
                    return isEqual(funds.goalsType, _this.filterValues);
                  }
                });
              } else {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  return _this.filterValues.includes(funds[key][0]);
                });
              }
              _this.funds = filteredFunds;
            } else {
              _this.funds = fundsToBeFiltered;
            }
          }
        }

        function moveToCartDetails(fund) {
          _this.fundName = fund.fundName;
          _this.fundCode = fund.fundCode;
          setSideBarState('CART_DETAILS');
        }

        function searchRecords() {
          var fundsToBeFiltered = _this.allFundForm.isRegular ? _this.regularFunds : _this.directFunds;
          if (_this.allFormData.searchModel.length > 0) {
            var filteredFunds = fundsToBeFiltered.filter(function(fund) {
              return fund.fundName.toLowerCase().includes(_this.allFormData.searchModel.toLowerCase());
            });
            _this.funds = filteredFunds;
          } else {
            _this.funds = fundsToBeFiltered;
          }
        }

        /*--------------------------------------- ECART section starts from here -------------------------------------*/
        function fetchInvestmentAdded() {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.cartDetails = resp.data;
              _this.maximumItemAllowed = _this.cartDetails.maximumItemAllowed;
              _this.investmentList = _this.cartDetails.cartItems;
              if(_this.cartDetails.cartItems){
                var sum = 0;
                _this.totalSum = sum;

                _this.cartDetails.cartItems.forEach(function (item,index) {
                  sum = sum + item.amount + item.installmentAmount;
                });

                _this.totalSum = sum;
              }
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          investorServiceVersion.get({
            child1: 'cart',
            child2: 'item',
            child3: 'list'
          }).$promise.then(success, error);
        }

        function fetchSuggestion() {
          _this.suggestionList = [
            {
              fund: 'HDFC Capital Builder Value Fund',
              riskType: 'Very High',
              cagrValue: 19.5,
              cagrReturns: [
                {key: '1 Year', value: 16.5},
                {key: '3 Years', value: 18.5},
                {key: '5 Years', value: 19.5},
                {key: '10 Years', value: 120.5},
                {key: 'Since Inception', value: 15.5},
              ]
            }
          ];
        }

        function showCagrValue(index) {
          _this.suggestionList[index].cagrReturns.forEach(function (x) {
            if(x.key === _this.formData.yearSelected) {
              _this.suggestionList[index].cagrValue = x.value;
            }
          });
        }

        function redirectToSummary() {
          var tncArray = [];
          _this.cartDetails.cartItems.forEach(function (el, index) {

            if (el.sipOpted && el.purchaseOpted) {
              _this.formData.tncType = 'SIPPURCHASE';
              return;
            } else if (el.sipOpted && !el.purchaseOpted) {
              tncArray.push('SIP');
            } else if (!el.sipOpted && el.purchaseOpted) {
              tncArray.push('PURCHASE');
            }
          });


          if (!_this.formData.tncType) {
            var sipInstanceArr = tncArray.filter(function (el) {
              return el === 'SIP';
            });

            var purchaseInstanceArr = tncArray.filter(function (el) {
              return el === 'PURCHASE';
            });


            if (sipInstanceArr.length >= 1 && purchaseInstanceArr.length >= 1) {
              _this.formData.tncType = 'SIPPURCHASE';
            } else if (sipInstanceArr.length === 0 && purchaseInstanceArr.length >= 1) {
              _this.formData.tncType = 'PURCHASE';
            } else if (sipInstanceArr.length >= 1 && purchaseInstanceArr.length === 0) {
              _this.formData.tncType = 'SIP';
            }

          }
          var ecartSummaryData = {
            folioNumber: _this.investorData.folioNumber,
            cartItemsInfo: _this.cartDetails.cartItems,
            investThrough: _this.cartDetails.previousTransactionStatus,
            isMinor: _this.cartDetails.minorFlag,
            transactionType: _this.formData.tncType,
            amount: _this.totalSum
          }
          EcartModel.setPayloadPayment(ecartSummaryData);
          $state.go("main.transactions.paymentPage");
        }

        function calculateValidations() {
          _this.validations = {};
          if(_this.sipValidation.additionalValidation && _this.sipValidation.additionalValidation.OM){
            var newValidation =  _this.sipValidation.additionalValidation.OM;
            for (var i = 0; i < newValidation.length; i++){
              var condition = _this.formData.installmentAmount < newValidation[i].min_amount_lower ||  _this.formData.installmentAmount <= newValidation[i].min_amount_upper
              if(!newValidation[i].min_amount_upper){
                var condition = true;
              }
              if(condition)
              {
                _this.validations.amountMultiples = newValidation[i].amt_multiples;
                _this.validations.maxAmount = newValidation[i].min_amount_upper;
                _this.validations.minAmount = newValidation[i].min_amount_lower;
                _this.validations.minInstallments = newValidation[i].min_installments;
                break;
              }
            }
          }
          _this.isMax = !!(_this.validations.maxAmount && _this.validations.maxAmount < _this.formData.installmentAmount);
          _this.isMin = !!(_this.validations.minAmount && _this.validations.minAmount > _this.formData.installmentAmount);
          _this.isMultiples = _this.validations.amountMultiples && _this.formData.installmentAmount && (_this.formData.installmentAmount % _this.validations.amountMultiples === 0) || false;

          if(_this.formData.installmentAmount >= 2000000){
            _this.amountExceeded = true;
          }else {
            _this.amountExceeded = false;
          }


          if (_this.purchaseValidation) {
            _this.isPurchaseMin = _this.purchaseValidation.minFirstPurchaseAmt > _this.formData.amount ;
            _this.purchaseMinAmount = _this.purchaseValidation.minFirstPurchaseAmt;
            _this.isMultiplesPurchase = _this.purchaseValidation.purchaseMultiple && _this.formData.amount  && (_this.formData.amount  % _this.purchaseValidation.purchaseMultiple === 0) || false;
            if(_this.formData.amount % 1 != 0){
              _this.isPurchaseAmountDecimal = true;
            }
            else{
              _this.isPurchaseAmountDecimal = false;
            }
          }
        }

        function titleCase(str) {
          str = str.split(/(?=[A-Z])/);
          for (var i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
          }
          return str.join(' ');
        }

        function isEqual(a, b) {
          var arr = [];
          for (var i = 0; i < b.length; i++) {
            if (a.includes(b[i])) {
              arr.push(true);
            } else {
              arr.push(false);
            }
          }
          return arr.includes(true);
        }

        function identifyRegular() {
          if(_this.linkdata && _this.investorData && _this.investorData.investThroughRIA == true){
            return false;
          } else if(_this.linkdata && _this.investorData && _this.investorData.investThroughRIA == false){
            return true;
          } else {
            if (_this.investorData && (_this.investorData.directOpted || _this.investorData.riaConsent)) {
              return false;
            } else {
              return true;
            }
          }
        }

        function fetchDynamicDataEcart(cb) {
          cb = cb || function () {
          };
          var successHandler = function(resp) {
            _this.getNote = resp;
            cb(true);
          }
          UtilService.fetchDynamicData("PURCHASE_ECART").then(successHandler).catch(function(resp) {
            MessageService.error(resp);
          });
        }

        _this.autoDate = function(type){
          if(type=='startDate') {
            var oldlength = 0;
            if (_this.startDateString) {
              oldlength = _this.startDateString.length;
            }
            _this.startDateString = $("#startDateId").val();
            var newlength = _this.startDateString.length;
            if (_this.startDateString.length == 2) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#startDateId").val(_this.startDateString + "-");
              }
            }
            if (_this.startDateString.length == 6) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#startDateId").val(_this.startDateString + "-");
              }
            }

          } else if(type=='endDate'){
            var oldlength = 0;
            if (_this.endDateString) {
              oldlength = _this.endDateString.length;
            }
            _this.endDateString = $("#endDateId").val();
            var newlength = _this.endDateString.length;
            if (_this.endDateString.length == 2) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#endDateId").val(_this.endDateString + "-");
              }
            }
            if (_this.endDateString.length == 6) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#endDateId").val(_this.endDateString + "-");
              }
            }
          }
        }

        function checkEnableEndDate(){
          _this.isEndDateFound = true;
          /*if(_this.enabledEndDates) {
            _this.enabledEndDates.forEach(function (item) {
              if (item.isSame(_this.formData.endDate)) {
                _this.isEndDateFound = true;
              }
            });
          }*/
          if (_this.formData.endDate && $window.moment(_this.tillPerpetuityEndDate).year() < 2099 && _this.sipValidation.monMaxInstallmentNumber < _this.maxMandateUPIDurationYears * 12) { // 30*12
            _this.enabledDefaultYear = false;
          } else {
            _this.enabledDefaultYear = true;
          }
          if(_this.formData.endDate && $window.moment(_this.tillPerpetuityEndDate).year() < 2099) {
            _this.formData.isTillPerpetuity = false;
          }
        }

        function showRecommendedFundOnTop(getAllFund){
          if(getAllFund) {
            getAllFund.sort(function (a, b) {
              if (a.recommended && !b.recommended) {
                return -1;
              } else if (!a.recommended && b.recommended) {
                return 1;
              } else {
                return 0;
              }
            });
            return getAllFund;
          }
        }

        function handleUPIMaxEndDate() {
          if(!_this.formData.endDate) {
            return;
          }
          var defaultEndDateUpto30Years = $window.moment().add(30, 'years').subtract(1, 'days');
          var sipDateGreaterUPI =  $window.moment(_this.formData.endDate, 'DD-MMM-YYYY').isAfter(defaultEndDateUpto30Years) ? true : false;
          if (sipDateGreaterUPI) {
            var setEndDateLess = false;
            var indexSipEndDate = _this.enabledEndDates.length - 1;
            var tempEndDate;
            while (!setEndDateLess) {
              tempEndDate = angular.copy(_this.enabledEndDates[indexSipEndDate - 1]);
              indexSipEndDate = indexSipEndDate - 1;
              if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(defaultEndDateUpto30Years, 'DD-MMM-YYYY'))) {
                setEndDateLess = true;
                _this.formData.endDate = angular.copy(tempEndDate);
              }

              if (indexSipEndDate == 0) {
                break;
              }
            }
          }
        }
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('EditCartController', editCartController);

  /** @ngInject */
  function editCartController($log, $timeout, $stateParams, HDFC_API, MessageService, ModalService, InvestorService, DownloadPdfService,
                                                    SchemeService, TransactionService, AppConstants, $state, LoaderService, UtilService,
                                                    TransactionModel, AuthService, SipPurchaseHelper, NetcoreEvntService,
                                                    InvestorFileUploadService, $window, FileSaver, Blob ,InvestorFolioModel , cutoffData, $rootScope, EcartModel) {


    var vm = this;
    vm.formData = {};
    vm.purchaseInSchemeList = null;
    vm.masterPurchaseInSchemeList = null;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.devidendOptionsOther = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT];
    vm.devidendOptionsELSS = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];
    vm.devidendOptions = angular.copy(vm.devidendOptionsOther);
    vm.updateEcartItem=updateEcartItem;
    vm.cutoffData = cutoffData.popupDTO.popupDTOMap.Popup_Purchase_Update_To_ECART;
    vm.today = $window.moment($window.moment(),"DD-MMM-YYYY HH:mm A");
    if (vm.cutoffData) {
      checkEndPopup(vm.cutoffData.endDate,vm.cutoffData.startDate);
    }
    vm.isCheckedTandC = false;
    vm.euinData = {};
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);

    function setStateParams() {
      vm.formData.folioNumber = $stateParams.folioNumber;
      vm.formData.purchaseInSchemeCode = $stateParams.schemeCode;
      vm.formData.purchaseAmount = parseFloat($stateParams.amount);
      vm.formData.minorFlag = $stateParams.minorFlag;
      vm.formData.cartItemId = $stateParams.cartItemId;
      if ($stateParams.brokerCode!=='DIRECT') {
        if($stateParams.riaConsent)
        {
          vm.formData.isThroughDistributor = false;
          vm.formData.isDirect = false;
          vm.formData.isThroughRia = true;
          vm.formData.riaBrokerCode=$stateParams.brokerCode;
          vm.isCheckedTandC=true;
        }
        else {
          vm.formData.isThroughDistributor = true;
          vm.formData.isDirect = false;
          vm.formData.isThroughRia = false;
          vm.formData.brokerCode = $stateParams.brokerCode;
          vm.formData.euin={euinName:$stateParams.euinName || "",euinCode:$stateParams.euinCode || "",euinNameCode:$stateParams.euinName+"-"+$stateParams.euinCode || ""};
          vm.euinData = vm.formData.euin;
        }
      } else {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = true;
        vm.formData.isThroughRia = false;
        vm.formData.brokerCode = null;
      }

      if($stateParams.euinName && $stateParams.euinCode)
        vm.formData.isEuin=true;

      vm.formData.subBrokerARN=$stateParams.subBrokerARN || null;
      vm.formData.subBrokerCode=$stateParams.subBrokerCode || null;
      vm.formData.purchaseDividendOption=$stateParams.dividendOption;

    }

    vm.purchaseInSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.formData.purchaseDividendOption=null;
        vm.formData.purchaseInSchemeCode = schemeData.schemeCode;
        vm.formData.purchaseInSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        if (schemeData.nfoEnabled == 'Y') {
          vm.nfoEnabled = true;
        } else {
          vm.nfoEnabled = false;
        }
        if (vm.formData.purchaseInSchemeName.toLowerCase().includes("retirement")) {
          vm.showChequeLeaf = true;
        } else vm.showChequeLeaf = false;
        vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
        fetchPurchaseValidations();
      }
      vm.formData.purchaseAmount = '';
    };


    vm.purchaseSchemeListModal = function () {
      vm.formData.purchaseAmount = '';
      var successSchemeList = function (result) {
          vm.formData.purchaseInSchemeCode = result.schemeCode;
          vm.formData.purchaseInSchemeName = result.scheme;
          vm.formData.schemeType = result.schemeType;
          if (result.nfoEnabled == 'Y') {
            vm.nfoEnabled = true;
          } else {
            vm.nfoEnabled = false;
          }
          fetchPurchaseValidations();
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
          resetNumInWords();
        },
        errorSchemeList = function () {
          vm.formData.purchaseInSchemeCode = '';
          vm.formData.purchaseInSchemeName = '';
          vm.purchaseValidations = null;
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
        };
      ModalService.schemeListModal({
        enabledScheme: 'purchaseenabled',
        isMinor: vm.formData.minorFlag, //vm.investorInfo.minor,
        isThroughDistributor: vm.formData.isThroughDistributor
      }, successSchemeList, errorSchemeList);
    };

    function fetchPurchaseValidations(cb) {
      vm.purchaseValidations = null;
      cb = cb || function () {
      };
      if (!vm.formData.purchaseInSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.purchaseValidations = resp.data;
            _setPurchaseDividendOptionsVali(vm.purchaseValidations);
            vm.formData.schemeType = vm.purchaseValidations.schemeType;
            cb(null);
          } else {
            cb('error');
            vm.purchaseValidations = null;
            vm.isSchemeTypeELSS = (vm.purchaseValidations && vm.purchaseValidations.schemeType == "ELSS") ? true : false;
            vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption || vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.purchaseInvestmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH;
            vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
            MessageService.error(resp.message);
          }
          vm.checkPurchaseValidations();
        },
        error = function (err) {
          cb('error');
          vm.purchaseValidations = null;
          vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption || vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.purchaseInvestmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH;
          vm.isSchemeTypeELSS = (vm.purchaseValidations && vm.purchaseValidations.schemeType == "ELSS") ? true : false;
          vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
          UtilService.errorHandler(err);
        };

      var data = {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.purchaseInSchemeCode
      };
      SchemeService.post({
        controller: 'schemeValidation',
        type: 'purchase'
      }, data).$promise.then(success, error);
    }

    vm.checkPurchaseValidations = function () {
      vm.isInvalidForm=false;
      if (vm.purchaseValidations) {

        if (!vm.purchaseValidations.addlPurchase) {
          vm.isPurchaseMin = vm.purchaseValidations.minFirstPurchaseAmt > vm.formData.purchaseAmount;
          vm.purchaseMinAmount = vm.purchaseValidations.minFirstPurchaseAmt;
        } else {
          vm.isPurchaseMin = vm.purchaseValidations.minAddlPurchaseAmt > vm.formData.purchaseAmount;
          vm.purchaseMinAmount = vm.purchaseValidations.minAddlPurchaseAmt;
        }
        vm.isMultiples = vm.purchaseValidations.purchaseMultiple && vm.formData.purchaseAmount && (vm.formData.purchaseAmount % vm.purchaseValidations.purchaseMultiple === 0) || false;

        if(vm.formData.purchaseAmount < vm.purchaseMinAmount)
          vm.isInvalidForm=true;

        if(vm.purchaseValidations.purchaseMultiple && !vm.isMultiples)
          vm.isInvalidForm=true;

      }
    };


    function _setPurchaseDividendOptionsVali(purchaseValidations) {
      vm.purchaseValidations = purchaseValidations;
      vm.isSchemeTypeELSS = (vm.purchaseValidations && vm.purchaseValidations.schemeType == "ELSS") ? true : false;
      vm.formData.purchaseInvestmentOption = vm.purchaseValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : (vm.formData.purchaseInvestmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH && vm.formData.purchaseInvestmentOption || vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
      vm.formData.cgfFlag = vm.purchaseValidations ? vm.purchaseValidations.cgfFlag : null;
      vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
      if (!vm.formData.isBackFromSummary) {
        if (vm.purchaseValidations.isGrowth) {
          vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
        } else if(vm.formData.purchaseDividendOption===null) {
          if (vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === false) {
            vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
          } else if (vm.purchaseValidations.dividendPayoutApplicable === false && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
            vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          } else if (vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
            vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          }
        }
      }
    }


    vm.redirectToFolioCreation = function () {
      localStorage.removeItem('folioId');
      InvestorFolioModel.resetInvestorFolioModel();
      $rootScope.setFolioInitiateState = $state.current.name;
      sessionStorage.setItem('setFolioInitiateState', $rootScope.setFolioInitiateState);
      $state.go('main.folio.holdmode');
    }

    vm.filterPurchaseInSchemeList = function () {
      vm.formData.purchaseInSchemeCode = '';
      vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
      resetNumInWords();
    };

    function resetNumInWords() {
      vm.amountInWords = '';
      var inWordsDiv = $window.document.getElementById('divDisplayWords');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
    }

    function fetchPurchaseInSchemes(cb) {
      cb = cb || function () {
      };

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.masterPurchaseInSchemeList = resp.data.schemeList;
            vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
            var scheme = vm.purchaseInSchemeList && vm.purchaseInSchemeList.find(function (item) {
              return vm.formData.purchaseInSchemeCode === item.schemeCode;
            }) || {};
            vm.formData.purchaseInSchemeName = scheme.scheme || '';
            cb();
          } else {
            vm.masterPurchaseInSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.masterPurchaseInSchemeList = null;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'purchaseenabled',
        child2: vm.formData.minorFlag,//vm.investorInfo.minor,
        child3: vm.formData.isThroughDistributor
      }, null).$promise.then(success, error);
    }

    vm.init = function () {
      $state.$previous = null;
      vm.formData.isEuin = true;
      setStateParams();
      fetchPurchaseInSchemes();
      fetchEuinList();
      fetchPurchaseValidations();
      fetchFolioList();
      if(vm.formData.subBrokerARN){
        vm.fetchEuinListSubBroker();
      }
      sessionStorage.removeItem('setFolioInitiateState');
    };

    function fetchEuinList() {
      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      vm.formData.brokerName = vm.formData.brokerName ? vm.formData.brokerName : '';
      vm.formData.riaBrokerName = vm.formData.riaBrokerName ? vm.formData.riaBrokerName : '';
      vm.subBrokerCodeError = '';
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      vm.distributorList = null;
      // vm.formData.euinInput = '';

      //vm.isInvalidForm = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.brokerCodeError = '';
            vm.riaCodeError = '';
            vm.isArnSuccess = false;
            if (vm.formData.isThroughDistributor) {
              vm.formData.brokerName = resp.data.distributorName;
            } else if (vm.formData.isThroughRia) {
              vm.formData.riaBrokerName = resp.data.distributorName;
            }
            //vm.isInvalidForm = false;
          } else {
            vm.euinList = null;
            if (vm.formData.isThroughDistributor) {
              vm.brokerCodeError = resp.message;
            } else if (vm.formData.isThroughRia) {
              vm.riaCodeError = resp.message;
              vm.isCheckedTandC = false;
              vm.formData.isCheckedTandC = false;
            }
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      var path = {};
      if (vm.formData.isThroughDistributor) {
        path = {
          controller1: 'getEuin',
          controller2: 'ARN-' + vm.formData.brokerCode
        };
      } else if (vm.formData.isThroughRia) {
        path = {
          controller1: 'getEuin',
          controller2: vm.formData.riaBrokerCode,
          riaOpted: vm.formData.isThroughRia
        };
      }
      TransactionService.get(path).$promise.then(success, error);
    }


    vm.searchDistributor = function () {
      //vm.isInvalidForm = vm.formData.brokerCode ? false : (vm.isArnSuccess ? true : false);
      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      fetchEuinList();
    };

    vm.searchDistributorByName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      //vm.isInvalidForm = true;
      vm.brokerCodeError = '';
      vm.isArnSuccess = true;
      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        vm.distributorList = null;
        vm.euinList = null;
        //vm.formData.euinInput = '';
        vm.formData.euin = '';
        return;
      }
      fetchARNByName();

    };

    vm.changeDistributorCode = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.euinList = null;
      vm.isArnSuccess = true;
    }

    vm.changeDistributorName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      vm.euinList = null;
    }

    vm.distributorListChanged = function (data) {
      if (!data) {
        // vm.isArnSuccess = true;
        return;
      } else {
        vm.brokerCodeError = '';
        vm.formData.distributorARN = data.arnCode;
        vm.formData.distributorName = data.name + ' - ' + data.arnCode;
        vm.showArnLabel = false;
        if (vm.formData.distributorARN) {
          //vm.isInvalidForm = false;
          vm.isArnSuccess = false;
        } else {
          vm.isArnSuccess = true;
        }
        fetchEuinListThroughDistributor(vm.formData.distributorARN);
      }
    };
    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
    }


    vm.fetchEuinListSubBroker = function () {
      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        vm.formData.euin = '';
        vm.euinData = {};
        fetchEuinList();
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            for(var i = 0; i<vm.euinList.length; i++){
              if(vm.euinData.euinNameCode === vm.euinList[i].euinNameCode){
                vm.formData.euin = vm.euinList[i];
                break;
              } else {
                vm.formData.euin = {};
              }
            }
            vm.euinData.euinNameCode = vm.formData.euin.euinNameCode;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
          } else {
            vm.euinList = null;
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = '';
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: vm.formData.isThroughDistributor
      }).$promise.then(success, error);
    }

    vm.setTandCVariable = function () {
      vm.formData.isCheckedTandC = true;
    };

    function fetchEuinListThroughDistributor(arnCode) {
      if (!arnCode) {
        return;
      }
      vm.formData.brokerName = '';
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin;
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.euinList = null;
            //MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: arnCode
      }).$promise.then(success, error);
    }

    function fetchARNByName() {

      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        return;
      }
      vm.formData.distributorARN = '';
      vm.distributorList = null;
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.distributorList = resp.data.distributorList;
            if (vm.distributorList.length == 0) {
              //vm.isInvalidForm = true;
              vm.formData.euin = '';
              vm.isCheckedTandC = false;
            }
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.distributorList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.distributorList = null;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getDistributor',
        controller2: vm.formData.distributorName
      }).$promise.then(success, error);
    }

    vm.isCheckedEuin = function () {
      if (vm.isCheckedTandC) {
        vm.formData.euin = '';
      }
    }

    vm.isSelectEuin = function () {
      if (vm.formData.euin) {
        vm.isCheckedTandC = false;
      }
    }


    vm.changeThroughDistributor = function (investThrough) {
      vm.transactionType = "PURCHASE";
      if (investThrough === 'DIRECT') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
        vm.formData.euin = {};
        vm.euinData = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
      } else if (investThrough === 'ARN') {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
      } else if (investThrough === 'RIA') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
        vm.isCheckedTandC = false;
        vm.formData.euin = {};
        vm.euinData = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
        vm.formData.purchaseInSchemeCode = '';
        vm.formData.purchaseInSchemeName = '';
        fetchPurchaseInSchemes();
      }

    };


    function beforeSummary(data) {
        vm.showCutOffModal({cutoffData:data});
      /*var currentTime = $window.moment(new Date(), "HH:mm:ss a");
      var dow = currentTime.format('dddd');
      var d = new Date();
      var notAllowedDays = ['Saturday', 'Sunday'];
      if (vm.formData.schemeType != 'LIQUID' && notAllowedDays.indexOf(dow) == -1) {
        d.setHours(13);
        d.setMinutes(0);
        d.setSeconds(0);
        var timeToCompareNonLiquid = $window.moment(d, "HH:mm:ss a");
        var status = currentTime.isAfter(timeToCompareNonLiquid);
        status ? vm.showCutOffModal() : $state.go('main.transactions.cart');
      } else if (vm.formData.schemeType == 'LIQUID') {
        d.setHours(12);
        d.setMinutes(30);
        d.setSeconds(0);
        var timeToCompareNonLiquid = $window.moment(d, "HH:mm:ss a");
        var status = currentTime.isAfter(timeToCompareNonLiquid);
        status ? vm.showLiquidPurchaseModal() : $state.go('main.transactions.cart');
      } else {
        vm.showCutOffModal();
      }*/
    }


    vm.showCutOffModal = function (message) {
      if (message.cutoffData) {
        var success = function () {
          EcartModel.setPayloadPayment(null);
          $state.go('main.transactions.cart');
        }, error = function () {

        };
        ModalService.cutOffModal({message: message}, success, error);
      } else {
        EcartModel.setPayloadPayment(null);
        $state.go('main.transactions.cart');
      }
    };


    vm.showLiquidPurchaseModal = function () {
      var success = function () {
        EcartModel.setPayloadPayment(null);
        $state.go('main.transactions.cart');
      }, error = function () {

      };
      ModalService.liquidPurchaseModal({}, success, error);
    };


    function updateEcartItem() {

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            beforeSummary(vm.cutoffData);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };


      if (vm.formData.isDirect || vm.formData.isThroughRia ) {
        vm.formData.euin = '';
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        if(!vm.formData.isThroughRia)
          vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.formData.isEuin = false;
      }

      var payload = {
            folioNumber: vm.formData.folioNumber,
            schemeCode: vm.formData.purchaseInSchemeCode||vm.formData.inSchemeCode,
            amount: vm.formData.purchaseAmount||vm.formData.amount,
            dividendOption: vm.formData.purchaseDividendOption || vm.formData.dividendOptions,
            brokerCode: vm.formData.brokerCode && vm.formData.brokerCode!==""?"ARN-"+vm.formData.brokerCode:null,
            subBrokerCode: vm.formData.subBrokerCode && vm.formData.subBrokerCode!==""?vm.formData.subBrokerCode:null,
            subBrokerArn: vm.formData.subBrokerARN && vm.formData.subBrokerARN!=="" && vm.formData.subBrokerARN!=='DIRECT'?"ARN-"+vm.formData.subBrokerARN:null,
            euinOpted:(vm.formData.euin && vm.formData.euin.euinCode && vm.formData.euin.euinName) ? 'Y' : 'N',
            euinCode:vm.formData.euin ? vm.formData.euin.euinCode:null,
            euinName: vm.formData.euin ? vm.formData.euin.euinName:null,
            minorFlag: vm.formData.minorFlag,
            cartItemId: vm.formData.cartItemId
          };

      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = vm.isCheckedTandC ? true : false;
      }


      if(vm.formData.brokerCode && vm.formData.brokerCode!=="" && !vm.formData.isEuin)
        payload.euinOpted="Z";



          InvestorService.post({
            child1: 'cart',
            child2: 'update',
            child3: 'item'
          }, payload).$promise.then(success, error);


    }



    function fetchFolioList(cb) {

      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioList = [];
            Object.keys(resp.data.folioList).forEach(function (key) {
              var obj = Object.assign({key: key}, resp.data.folioList[key]);
              folioList.push(angular.copy(obj));
            });
            vm.folioList = folioList.length ? folioList : null;
            vm.folioData  = folioList.find(function (ele) {
              return ele.folioNumber == vm.formData.folioNumber;
            });
            vm.formData.folioInvestorName=vm.folioData.investorName;
            cb(true);
          } else {
            vm.folioList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'folio',
        child2: 'active-list'
      }).$promise.then(success, error);
    }

    function checkEndPopup(endDate,startDate) {
         if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
           vm.showpopup = true;
           } else {
           vm.showpopup = false;
         }
     }

    vm.isSelectedEuin = true;

    vm.filterEuinList = function () {
      vm.formData.euin = {};
      vm.isSelectedEuin = false ;
      if(vm.euinData.euinNameCode){
        if(vm.euinData.euinNameCode.length>=3){
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.euinData.euinNameCode);
        }
      }
      vm.euinList = vm.euinData.euinNameCode == '' || vm.euinData.euinNameCode == undefined || vm.euinData.euinNameCode.length<3 ? vm.euinMasterList : vm.euinList;
    };

    vm.selectEuin = function(data) {
      if (!data) {
        return;
      }
      vm.euinData = {};
      vm.euinData.euinNameCode = data.euinNameCode;
      vm.isSelectedEuin = vm.euinData.euinNameCode ? true : false;
    }

   }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('EcartController', ecartController);

  /** @ngInject */
  function ecartController($stateParams, LoaderService,TransactionModel, $timeout,InvestorService,ModalService,MessageService,UtilService,AppConstants,$state,$window, HDFC_API , notesEcart,toastr,$rootScope , $sce, TransactionService, FolioModel , investorServiceVersion , EcartModel, $scope, DynamicDataSipPurchaseReview, panAadharService,AuthService) {
    var vm = this;
    vm.formData = TransactionModel.getPayloadRawData()|| {};
    vm.actionUrl = "";
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.paymentOptions = [
      vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING
    ];

    vm.bankList = null;
    vm.deleteCart = deleteCart;
    vm.fetchCartList = fetchCartList;
    vm.approve=approve;
    vm.bankInfo=null;
    vm.isCheckedDeclaration = false;
    vm.isCheckedTandC=false;
    vm.isInvalidForm=false;
    vm.showTermConditions=showTermConditions;
    vm.isDisabled=false;
    vm.cancel=cancel;
    vm.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
    vm.NAV_APPLICABILITY_NOTE = AppConstants.NAV_APPLICABILITY_NOTE;
    vm.notesEcart = notesEcart;
    vm.showTerms = true;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ALL_FUNDS;
    vm.showAddEcart = false;
    vm.indexToNumberArray = AppConstants.ECART_CART_ITEM_NUMBER;
    vm.expandSidebar = expandSidebar;
    vm.showSideBarCart = false;
    vm.showSideBarInvest = false;
    vm.showSideAllFunds = false;
    vm.moveToPayment = moveToPayment;
    vm.showPopupScreen = showPopupScreen;
    vm.utilService = UtilService;
    vm.fetchCartItems = fetchCartItems;
    vm.removeCartItem = removeCartItem;
    vm.identifyInvestThrough = identifyInvestThrough;
    vm.fetchFolioList = fetchFolioList;
    vm.ecartFolioList = FolioModel.getFolioData() || null;
    vm.folioChanged = folioChanged;
    vm.cartError = false;
    vm.formData.folioError = null;
    vm.formData.isExceedingEmandateDate = false;
    vm.formData.isExceedingUPIDate = false;
    vm.checkEmandateDateForNPCI = checkEmandateDateForNPCI;
    AuthService.checkLinkedUserStatus();
    vm.currentDate = $window.moment(Date());

    vm.billdeskPayload = {
      hidRequestId : "PGIME1000",
      hidOperation : "ME100",
      msg : ""
    };
    vm.transactionOtmConfirmation = transactionOtmConfirmation;
    vm.formData.liquidSchemeFlag = false;

    if(vm.notesEcart.noteDTO.noteDTOMap.Note_Purchase_Review)
    {
      vm.notepurchaseReview = vm.notesEcart.noteDTO.noteDTOMap.Note_Purchase_Review.content;
    }

    if(vm.notesEcart.noteDTO.noteDTOMap.Note_Purchase_Payment)
    {
      vm.notepurchasePayment = vm.notesEcart.noteDTO.noteDTOMap.Note_Purchase_Payment.content;
    }

    if(vm.notesEcart.noteDTO.noteDTOMap.Note_Purchase_Summary)
    {
      vm.noteSummary = vm.notesEcart.noteDTO.noteDTOMap.Note_Purchase_Summary.content;
    }


    var successHandler = function(resp) {
      if(!resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General) {
        vm.showTerms = false;
      }
    }

    UtilService.fetchDynamicData("INNER_TNC").then(successHandler).catch(function(resp) {
      MessageService.error(resp)
    });


    vm.tpv = tpv;
    function tpv() {
      ModalService.tpvModal({});
    }

    vm.checkForMinorBankListCondition = function(cb) {
      if(vm.formData.minorFlag!=null && cb.cgfApplicable!=null)
        return vm.formData.minorFlag && !cb.cgfApplicable;
      else
        return false;
    };



    vm.cartItem = {
      totalLength: null,
      cartItemList: null,
      cartItemTotalAmount: null,
      editCartItem: editCartItem,
      deleteCartItem: deleteCartItem
    };

    /** --------------------------------------ecart initialisation section----------------------------------------------------------*/

    vm.init = function () {
      vm.dynamicDataSipPurchaseReview = DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap;
      if($window.performance && $window.performance.getEntriesByType( 'navigation' ).map( function (nav){return  nav.type} ).includes( 'back_forward' )){
        $window.location.reload();
      }
      // fetchCartList('');
      fetchCartItems('initial');
      var ecartRandomOTPId = EcartModel.getPayloadPayment() || [];
      if(!ecartRandomOTPId.randomOTPId) {
        getRandomOTPId();
      } else {
        vm.randomOTPId = ecartRandomOTPId.randomOTPId ? ecartRandomOTPId.randomOTPId : null;
      }
    };
    vm.init();

    /* ---------------------------------------ecart action section start from here--------------------------------------------------*/

    vm.handleProceedAction = function () {
      LoaderService.showLoader();
      $timeout(function () {
        angular.element('#').submit();
      }, 100);
    };


    /*fetch ecart list*/

    function fetchCartList(onAction) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.cartItem.cartItemList = resp.data.cartItems;
            var liquidCheckArray = [];
            if(vm.cartItem.cartItemList){
              var sum = 0;
              vm.cartItem.cartItemList.forEach(function (item,index) {
                $window.NumToWord(item.amount, 'DisplayWordsTaxAmt', vm.cartItem.cartItemList[index]);
                sum = sum + item.amount;
                liquidCheckArray.push(item.liquid);
              });

              vm.totalSum = vm.cartItem.totalAmount + vm.cartItem.totalInstallmentAmount;
            }
            vm.formData.liquidSchemeFlag = liquidCheckArray.includes(true);
            vm.investorType = vm.cartItem.cartItemList ? vm.cartItem.cartItemList[0].invType : null;
            vm.cartItem.totalLength = resp.data.total;
            vm.cartItem.cartItemTotalAmount = resp.data.totalAmount;
            vm.formData.minorFlag = resp.data.minorFlag;
            vm.formData.folioInvestorName = resp.data.folioInvestorName;
            vm.formData.folioNumber = resp.data.folioNumber;
            vm.formData.kycVerifiedFlag=resp.data.kycVerifiedFlag;
            vm.formData.message=resp.data.message;
            if (onAction === "AFTER_DELETE") {
              stateChangeDecision();
            } else {
              fetchBankList();
            }
            if(vm.investorType !== null) {
              getAccountType();
            }
          } else {
            vm.cartItem.cartItemList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      InvestorService.get({
        child1: 'cart',
        child2: 'item',
        child3: 'list'
      }).$promise.then(success, error);

    }

    vm.changeBank = function () {
      if (!vm.bankInfo) {
        return;
      }

      var cartItemHavingLiquidFlagTrue = vm.cartItem.cartItemList.filter(function (row) {
        return row.liquid === true;
      })[0];

      // vm.cartItem.cartItemList.filter(function (row) {
      //   if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition(row)){
      //     ModalService.minorBankModal();
      //     vm.bankInfo = null;
      //     vm.isCheckedDeclaration = false;
      //   }
      // });

      if(cartItemHavingLiquidFlagTrue && !vm.bankInfo.liquid)
      {
        MessageService.error(AppConstants.ToastrMessage.VALIDATE_DATA.LIQUID_FLAG_FALSE_FOR_LIQUID_SCHEME_ECART);
        vm.isInvalidForm = true;
        vm.isCheckedDeclaration = false;
        vm.isCheckedTandC=false;
        return;
      }
      if (vm.bankInfo.tpvEnableFlag === 'Y') {
        getAccountNumber(vm.bankInfo.bankCode);
      }
      vm.isInvalidForm = false;
      vm.isCheckedDeclaration = false;
      vm.isCheckedTandC=false;
    };


    function getAccountNumber(bankCode) {
      if(vm.bankInfo.tpvEnableFlag && vm.bankInfo.accountNumber){
        vm.formData.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
        vm.formData.accountNumber = vm.bankInfo.accountNumber;
        return;
      }
      vm.bankAccounts = [];
      vm.isInvalidForm = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            vm.bankAccounts = resp.data.accountNumbers;
            if (vm.bankAccounts.length > 1) {
              var success = function (accountNo) {
                vm.formData.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
                vm.formData.accountNumber = accountNo;
                vm.isInvalidForm = false;
              }, error = function () {

              };
              ModalService.selectAccountNoModal({bankAccounts: vm.bankAccounts}, success, error);
            } else {
              vm.formData.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.accountNumber = vm.bankAccounts[0];
              vm.isInvalidForm = false;
            }
          } else {
            vm.isInvalidForm = true;
            MessageService.error(resp.message);
            vm.bankAccounts = [];
          }
        },
        error = function (err) {
          vm.bankAccounts = [];
          vm.isInvalidForm = true;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber, //'9422332',
        "bankCode": bankCode
      };
      InvestorService.post({
        child1: 'bank',
        child2: 'account'
      }, payload).$promise.then(success, error);
    }



    function fetchBankList() {
      if(vm.cartItem.totalLength===0)
      {
        return;
      }
      vm.formData.purchasePaymentOption = vm.paymentOptions[0];
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            if (vm.bankList && vm.bankList.length == 1) {
              vm.bankInfo = vm.bankList[0];
              vm.formData.accountNumber = vm.bankInfo.accountNumber;
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();

      var config = null;
      switch (vm.formData.purchasePaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
          config = {child1: 'bank', child2: 'list', child3: vm.debitCardType, child4: 'debit'};
          InvestorService.get(config, null).$promise.then(success, error);
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
          config = {child1: 'bank', child2: 'list'};
          InvestorService.post(config, {
            trnxType: 'PURCHASE',
            folioNumber: vm.formData.folioNumber,
            liquidSchemeFlag: vm.formData.liquidSchemeFlag
          }).$promise.then(success, error);
          break;
        default :
          vm.bankList = null;
          config = null;
          break;
      }
    }


    function editCartItem(obj) {

      var tID = obj.tID;

      if (vm.formData.kycVerifiedFlag === false) {
        ModalService.genericModal({
          text: "Transaction is restricted in the folio, Kindly update your KYC to experience uninterrupted services"
        });
        return;
      }

      var selectedCartItem = vm.cartItem.cartItemList.filter(function (row) {
        return row.cartItemId == tID
      })[0];
      $state.go('main.transactions.edit', {
        cartItemId: tID,
        folioNumber: selectedCartItem.folioNumber || null,
        schemeCode: selectedCartItem.schemeCode || null,
        brokerCode: selectedCartItem.brokerCode.substring(selectedCartItem.brokerCode.indexOf("-")+1,selectedCartItem.brokerCode.length)|| "",
        amount: selectedCartItem.amount || null,
        euinCode: selectedCartItem.euinCode || null,
        euinName: selectedCartItem.euinName || null,
        euinOpted: selectedCartItem.euinOpted || null,
        subBrokerCode: selectedCartItem.subBrokerCode || null,
        subBrokerARN:selectedCartItem.subBrokerArn && selectedCartItem.subBrokerArn!=='DIRECT'?selectedCartItem.subBrokerArn.substring(selectedCartItem.subBrokerArn.indexOf("-")+1,selectedCartItem.subBrokerArn.length) : null,
        minorFlag: vm.formData.minorFlag,
        folioInvestorName: vm.formData.folioInvestorName,
        dividendOption:selectedCartItem.dividendOption,
        riaConsent:selectedCartItem.riaConsent?selectedCartItem.riaConsent:null,
        riaOpted:selectedCartItem.riaOpted?selectedCartItem.riaOpted:null
      });

    }


    function deleteCartItem(obj) {
      var tID = obj.tID;

      var confirmSuccess = function () {

        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              fetchCartList('AFTER_DELETE');
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };

        InvestorService.get({
          child1: 'cart',
          child2: 'delete',
          child3: 'item',
          child4: tID
        }).$promise.then(success, error);

      };
      var confirmError = function () {
      };

      ModalService.confirmCancelModalEcart({Text: "Are you sure you want to remove investment item from the cart?"}, confirmSuccess, confirmError);

    }

    function deleteCart() {

      var confirmSuccess = function () {

        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              $state.go('welcome');
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader();
          };

        InvestorService.get({
          child1: 'cart',
          child2: 'delete'
        }).$promise.then(success, error);

      };
      var confirmError = function () {
      };

      ModalService.confirmCancelModalEcart({Text: "By deleting E-cart, all investment items shall get removed from the E-cart. Do you wish to proceed?"}, confirmSuccess, confirmError);

    }

    function approve() {
      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        vm.isDisabled=true;
        if (vm.formData.kycVerifiedFlag === false) {
          ModalService.genericModal({
            text: "Transaction is restricted in the folio, Kindly update your KYC to experience uninterrupted services"
          });
          return;
        }
        LoaderService.showLoader();
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              $rootScope.$broadcast('UpdateCartCount', {listUpdated: true});
              vm.isDisabled=true;
              if(!resp.data.redirectUrl)
              {
                MessageService.error(resp.data.message);
                $state.go('main.transactions.purchase');
              }

              if(vm.bankInfo.gateWayVendor==="BILLDESK")
              {
                LoaderService.showLoader();
                vm.billdeskPayload.msg = resp.data.redirectUrl;
                $timeout(function () {
                  angular.element('#billdeskForm').submit();
                });
                //$window.location.href=vm.billDeskpayload;
              }
              else if (vm.bankInfo.gateWayVendor == 'BILLJUNCTION') {
                LoaderService.showLoader();
                $window.open(resp.data.redirectUrl, '_self');
              }

            } else {
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                });
              } else {
                toastr.error(resp.message, '', {
                  allowHtml: true,
                  onHidden: function () {
                    $state.reload();
                  }
                });
              }
              vm.isDisabled = false;
              LoaderService.hideLoader();
            }
          },
          error = function (err) {
            toastr.error(err, '', {
              allowHtml: true,
              onHidden: function () {
                $state.reload();
              }
            });
            $rootScope.$broadcast('UpdateCartCount', {listUpdated: true});
            vm.isDisabled = false;
            LoaderService.hideLoader();
          };
       var payload = {
         folioNumber:vm.formData.folioNumber ,
         paymentOption: "NET_BANKING",
         gatewayVendor:vm.bankInfo.gateWayVendor,
         accNo: vm.formData.accountNumber,
         accType: vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.bankAcType,
         bankName: vm.bankInfo.bankNameOnly,
         branchName: vm.bankInfo.bankBranch,
         bankCity: vm.bankInfo.bankCity,
         bankCode: vm.bankInfo.bankCode,
         ifscCode: vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.ifscCode,
         payoutId: vm.bankInfo.payoutId,
         cartItems: modifyCartItemList(),
         secretLink: vm.singleUseURL
       };

        InvestorService.post({
          child1: 'cart',
          child2: 'checkout'
        },payload).$promise.then(success, error);
      };

      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);
    }



    vm.goToStatePurchase = function (_state) {
      if (vm.formData.kycVerifiedFlag === false) {
        ModalService.genericModal({
          text: "Transaction is restricted in the folio, Kindly update your KYC to experience uninterrupted services"
        });
        return;
      }
      $state.go('main.transactions.' + _state, {folioNumber:vm.formData.folioNumber,eCart:true});
    }


    function cancel() {
      $state.go('main.transactions.purchase');
    }

    function showTermConditions() {
      ModalService.termConditionModal();
    }

    function modifyCartItemList() {
      var cartItemsList = [];
      var keyArray = ["folioNumber", "schemeCode", "schemeName", "amount", "dividendOption", "brokerCode", "subBrokerCode",
        "subBrokerArn", "euinOpted", "euinCode", "euinName", "minorFlag", "riaConsent", "cartItemId", "cgfApplicable",
        "liquid"];
      for (var i = 0; i < vm.cartItem.cartItemList.length; i++) {
        var cartItem = {};
        Object.keys(vm.cartItem.cartItemList[i]).forEach(function (key) {
          if (keyArray.includes(key) && (angular.isDefined(vm.cartItem.cartItemList[i][key]) && vm.cartItem.cartItemList[i][key] !== "")) {
            cartItem[key] = vm.cartItem.cartItemList[i][key];
          }
        });
        cartItemsList.push(cartItem);
      }
      return cartItemsList;
    }
    function stateChangeDecision() {
      if (!vm.cartItem.cartItemList) {
        $state.go("welcome");
      } else {
        $state.reload();
      }
    }

    function getAccountType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.bankTypeList = resp.data.bankAccountTypes;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        MessageService.error(err.message);
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.investorType
      }).$promise.then(success, error);
    }

    function transactionOtmConfirmation() {
      var otpSuccessCallback, otpDismissCallback;

      otpSuccessCallback = function(resp) {
        vm.approve();
      };

      otpDismissCallback = function(err) {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      var modalPayload = {
        folioNumber: vm.formData.folioNumber,
        transactionType: 'PURCHASE',
        randomOTPId: vm.randomOTPId
      };

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.singleUseURL = resp.data.secretLink;
            var otpDetails = {
              secretOtpLink : vm.singleUseURL,
              otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
              otpId : resp.data.id
            };

            var payload = {
              folioNumber:  vm.formData.folioNumber,
              formType : 'PURCHASE'
            }

            ModalService.transactionOtpModal({
              otpPayload: otpDetails,
              payload: payload
            }, otpSuccessCallback, otpDismissCallback);
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message)
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      TransactionService.post2({
        controller1: 'transaction',
        controller2: 'otp'
      }, modalPayload).$promise.then(success, error);
    }

    function expandSidebar() {
      if (vm.cartItem.totalLength === 0) {
        vm.showAddEcart = true;
      }
      $window.scrollTo(0,0);
      UtilService.expandSideBar();
    }

    function moveToPayment() {
      LoaderService.showLoader();
      var success = function(resp) {
        if (resp.status && resp.data) {
          LoaderService.hideLoader();
          if (resp.data.errorExists) {
            vm.cartDetails.errorExists = resp.data.errorExists;
            vm.cartDetails.message = resp.data.message;
            vm.cartError = true;
            resp.data.cartItems.forEach(function (el, index) {
              if (el.errorExists) {
                vm.cartItem.cartItemList[index].errorExists = el.errorExists;
                vm.cartItem.cartItemList[index].message = el.message;
                vm.cartError = true;
                $window.scrollTo(0, 0);
              }
            });
          } else {

            if (!vm.cartError) {
              var tncArray = [];
              vm.cartItem.cartItemList.forEach(function (el, index) {

                if (el.sipOpted && el.purchaseOpted) {
                  vm.formData.tncType = 'SIPPURCHASE';
                  return;
                } else if (el.sipOpted && !el.purchaseOpted) {
                  tncArray.push('SIP');
                } else if (!el.sipOpted && el.purchaseOpted) {
                  tncArray.push('PURCHASE');
                }
              });


              if (!vm.formData.tncType) {
                var sipInstanceArr = tncArray.filter(function (el) {
                  return el === 'SIP';
                });

                var purchaseInstanceArr = tncArray.filter(function (el) {
                  return el === 'PURCHASE';
                });


                if (sipInstanceArr.length >= 1 && purchaseInstanceArr.length >= 1) {
                  vm.formData.tncType = 'SIPPURCHASE';
                } else if (sipInstanceArr.length === 0 && purchaseInstanceArr.length >= 1) {
                  vm.formData.tncType = 'PURCHASE';
                } else if (sipInstanceArr.length >= 1 && purchaseInstanceArr.length === 0) {
                  vm.formData.tncType = 'SIP';
                }

              }
              var ecartSummaryData = {
                folioNumber: vm.formData.folioNumber,
                cartItemsInfo: vm.cartItem.cartItemList,
                investThrough: vm.cartDetails.previousTransactionStatus,
                isMinor: vm.cartDetails.minorFlag,
                transactionType: vm.formData.tncType,
                amount: vm.totalSum,
                emandateValidate: vm.emandateEmailMobileValidateObject,
                brokerDetailsPayload: vm.cartDetails.brokerDetailsDTO,
                preLogin: false,
                purchaseAmount: vm.cartDetails.totalAmount,
                isExceedingEmandateDate: vm.formData.isExceedingEmandateDate,
                emandateTotalAmount: vm.emandateTotalAmount,
                startEmandateDate: vm.startEmandateDate,
                endEmandateDate: vm.endEmandateDate,
                isExceedingUPIDate: vm.formData.isExceedingUPIDate,
                upiAmountLimit: vm.upiAmountLimit,
                upiErrorMessage: vm.upiErrorMessage,
                randomOTPId: vm.randomOTPId
              }
              EcartModel.setPayloadPayment(ecartSummaryData);
              $state.go("main.transactions.paymentPage");
            }
          }
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      }

      var payload = {
        "folioNumber" : vm.formData.folioNumber,
        "cartItems" : vm.cartItem.cartItemList,
      }

      investorServiceVersion.post({
        child1: 'cart',
        child2: 'validate'
      }, payload).$promise.then(success, error);

    }

    function showPopupScreen(screen, item) {
      vm.investorData = setInvestorData();
      switch (screen) {
        case 'INVEST_THROUGH':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.INVEST_THROUGH;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = true;
          vm.showSideAllFunds = false;
          $scope.$broadcast('updatedTitle');
          break;
        case 'CART_DETAILS':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.CART_DETAILS;
          vm.showSideBarCart = true;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = false;
          vm.itemToBeEdited = item;
          vm.showAddCart = false;
          $scope.$broadcast('updatedTitle');
          break;
        case 'ALL_FUNDS':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ALL_FUNDS;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = true;
          vm.showAddCart = true;
          $scope.$broadcast('updatedTitle');
          break;
      }
      expandSidebar();
    }

    function fetchCartItems(action, payload) {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.cartError = false;
          vm.cartDetails = resp.data;
          vm.maximumItemAllowed = vm.cartDetails.maximumItemAllowed;
          vm.cartItem.cartItemList = vm.cartDetails.cartItems;
          vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
          vm.maxMandateDurationYears = resp.data.sipSettings && resp.data.sipSettings.eOTM.maxMandateDurationYears;
          vm.maxMandateUPIDurationYears = resp.data.sipSettings && resp.data.sipSettings.upi.maxMandateDurationYears;
          vm.upiErrorMessage = resp.data.sipSettings && resp.data.sipSettings.upiMaxAmountErrMessage;
          vm.upiAmountLimit = resp.data.sipSettings && resp.data.sipSettings.upi.maxAmountLimit;
          if (resp.data.errorExists) {
            vm.cartError = true;
          }
          if (resp.data.cartItems) {
            resp.data.cartItems.forEach(function (el, index) {
              if (el.errorExists) {
                vm.cartError = true;
              }
            });
          }
          $rootScope.$broadcast('UpdateCart', {listUpdated: true});
          if(vm.cartItem.cartItemList) {
            var sum = 0;
            vm.totalSum = sum;

            vm.cartItem.cartItemList.forEach(function (item, index) {
              sum = sum + item.amount + item.installmentAmount;
              /*if (item.sipOpted && item.purchaseOpted) {
                vm.formData.tncType = 'SIPPURCHASE';
              } else if (item.sipOpted && !item.purchaseOpted) {
                vm.formData.tncType = 'SIP';
              } else if (!item.sipOpted && item.purchaseOpted) {
                vm.formData.tncType = 'PURCHASE';
              }*/
              if(payload && payload.cartItems.length > 0) {
                payload.cartItems.forEach(function(obj) {
                  if (item.schemeCode === obj.schemeCode) {
                    item.errorExists = obj.errorExists;
                    item.message = obj.message;
                    if (obj.errorExists) {
                      vm.cartError = true;
                    }
                  }
                });
              }
            });

            vm.totalSum = vm.cartDetails.totalAmount + vm.cartDetails.totalInstallmentAmount;
            checkEmandateDateForNPCI(vm.cartItem.cartItemList);
          } else {
            vm.formData.isExceedingEmandateDate = false;
            vm.formData.isExceedingUPIDate = false;
          }

          vm.action = action;
          fetchFolioList(function () {
            if (vm.cartItem.cartItemList) {

              vm.ecartFolioList.forEach(function (el, index) {
                  if (el.folioNumber !== vm.cartDetails.folioNumber) {
                    vm.ecartFolioList[index].activeFlag = false;
                  }
              });

              vm.formData.folioNumber = vm.cartDetails.folioNumber;
              if (action === 'initial' && vm.formData.folioNumber) {
                vm.folioChanged();
              }
            }
            if (action !== 'invest') {
              var selectedDistributor = JSON.parse(sessionStorage.getItem('brokerDetailsSelected'));
              if (selectedDistributor) {
                payload = {};
                payload.brokerDetailsDTO = selectedDistributor;
              }
            }
            if (vm.formData.folioNumber && !vm.cartItem.cartItemList && !payload) {
              fetchPreviousTransactionDetails();
            } else {
              vm.updatedInvestThrough = payload;
              identifyInvestThrough();
            }
          });
          vm.investorType = vm.cartItem.cartItemList ? vm.cartItem.cartItemList[0].invType : null;
          vm.cartItem.totalLength = resp.data.total;
          vm.cartItem.cartItemTotalAmount = resp.data.totalAmount;
          updateMinorFlag();
          identifyInvestThrough();
          vm.showSideAllFunds = false;
          vm.showSideBarInvest = false;
          vm.showSideBarCart = false;
          vm.showAddEcart = false;
          if (vm.kycVerifiedFlag === false) {
            ModalService.genericModal({
              text: resp.data.kycMessage
            });
          }

        } else {
          vm.cartItem.cartItemList = [];
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        vm.cartItem.cartItemList = [];
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      }
      investorServiceVersion.get({
        child1: 'cart',
        child2: 'item',
        child3: 'list'
      }).$promise.then(success, error);
    }


    function removeCartItem(item) {
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          fetchCartItems('remove');
        } else {
          vm.cartItem.cartItemList = [];
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        vm.cartItem.cartItemList = [];
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      }

      var confirmSuccess = function () {
        LoaderService.showLoader();
        investorServiceVersion.get({
          child1: 'cart',
          child2: 'delete',
          child3: 'item',
          child4: item.cartItemId
        }).$promise.then(success, error);
      } , confirmError = function () {};

      ModalService.confirmCancelModalEcart({Text: "Are you sure you want to remove <strong>" + item.schemeName + "</strong> from the cart?"}, confirmSuccess, confirmError);
    }

    function identifyInvestThrough() {
      if (vm.cartDetails && vm.cartDetails.brokerDetailsDTO) {
        if (vm.cartDetails.brokerDetailsDTO.investThroughRIA) {
          vm.investThrough = 'RIA';
          vm.brokerCode = vm.cartDetails.brokerDetailsDTO.brokerCode;
        } else {
          vm.investThrough = vm.cartDetails.brokerDetailsDTO.brokerCode === 'DIRECT' ? 'DIRECT' : 'DISTRIBUTOR';
          vm.brokerCode = vm.cartDetails.brokerDetailsDTO.brokerCode === 'DIRECT' ? null: vm.cartDetails.brokerDetailsDTO.brokerCode;
        }
        sessionStorage.setItem('brokerDetailsSelected', JSON.stringify(vm.cartDetails.brokerDetailsDTO));
      } else if (vm.updatedInvestThrough && vm.updatedInvestThrough.brokerDetailsDTO) {
        if (vm.updatedInvestThrough.brokerDetailsDTO.investThroughRIA) {
          vm.investThrough = 'RIA';
          vm.brokerCode = vm.updatedInvestThrough.brokerDetailsDTO.brokerCode;
          vm.updatedInvestThrough.brokerDetailsDTO.investThroughRIA = true;
        } else {
          vm.investThrough = vm.updatedInvestThrough.brokerDetailsDTO.brokerCode === 'DIRECT' ? 'DIRECT' : 'DISTRIBUTOR';
          vm.brokerCode = vm.updatedInvestThrough.brokerDetailsDTO.brokerCode === 'DIRECT' ? null: vm.updatedInvestThrough.brokerDetailsDTO.brokerCode;
          vm.updatedInvestThrough.brokerDetailsDTO.investThroughDirect = vm.updatedInvestThrough.brokerDetailsDTO.brokerCode === 'DIRECT' ? true : false;
          vm.updatedInvestThrough.brokerDetailsDTO.investThroughDistributor = vm.updatedInvestThrough.brokerDetailsDTO.brokerCode !== 'DIRECT' ? true : false;
        }
        sessionStorage.setItem('brokerDetailsSelected', JSON.stringify(vm.updatedInvestThrough.brokerDetailsDTO));
      }
    }

    function fetchFolioList(cb) {

      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioList = [];
            vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
            if (resp.data.kycVerifiedFlag === false) {
              ModalService.genericModal({
                text: resp.data.kycMessage
              }, function() {
                $state.go("welcome");
              });
            }
            Object.keys(resp.data.folioList).forEach(function (key) {
              var obj = Object.assign({key: key}, resp.data.folioList[key]);
              folioList.push(angular.copy(obj));
            });
            FolioModel.setFolioData(folioList);
            vm.ecartFolioList = folioList.length ? folioList : null;
            if (vm.ecartFolioList && vm.ecartFolioList.length === 1 && vm.action === 'initial') {
              if(vm.ecartFolioList[0].activeFlag === true){
                vm.formData.folioNumber = vm.ecartFolioList[0].folioNumber;
                vm.folioChanged();
              }
            }

            cb(true);
          } else {
            vm.ecartFolioList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.ecartFolioList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      investorServiceVersion.get({
        child1: 'folio',
        child2: 'active-list'
      }).$promise.then(success, error);
    }

    function folioChanged() {
      var successHandler = function() {
        LoaderService.hideLoader();
        vm.ecartFolioList.forEach(function (el, index) {
          if (el.folioNumber === vm.formData.folioNumber) {
            vm.formData.minorFlag = el.minorFlag;
            vm.formData.invType = el.invType;
            vm.selectedFolioEmail = el.email;
            vm.selectedFolioMobile = el.mobileNumber;
            vm.formData.taxStatusSelected = el.taxStatus;
            vm.updatedInvestThrough = null;
          }
        });

        var selectedFolio = vm.ecartFolioList.filter(function(folio) {
          return folio.folioNumber === vm.formData.folioNumber;
        });

        if (selectedFolio.length === 0) {
          vm.formData.folioError = AppConstants.DEEMAT_FOLIO_ERROR;
        } else {
          vm.formData.folioError = null;
        }

        vm.emandateEmailMobileValidateObject = {};

        if(vm.selectedFolioMobile === null || vm.selectedFolioMobile === ''){
          if(vm.selectedFolioEmail === null || vm.selectedFolioEmail === ''){
            vm.emandateEmailMobileValidateObject.isEmailMobileinValid = true;
            vm.emandateEmailMobileValidateObject.emandateDisplay = false;
          }
          else {
            vm.emandateEmailMobileValidateObject.isMobileinValid = true;
            vm.emandateEmailMobileValidateObject.emandateDisplay = false;
          }
        }
        else if(vm.selectedFolioEmail === null || vm.selectedFolioEmail === ''){
          if(vm.selectedFolioMobile === null || vm.selectedFolioMobile === ''){
            vm.emandateEmailMobileValidateObject.isEmailMobileinValid = true;
            vm.emandateEmailMobileValidateObject.emandateDisplay = false;
          }
          else {
            vm.emandateEmailMobileValidateObject.isEmailinValid = true;
            vm.emandateEmailMobileValidateObject.emandateDisplay = false;
          }
        }

        if (vm.formData.folioNumber && !vm.cartItem.cartItemList) {
          fetchPreviousTransactionDetails();
        }
      }, errorHandler = function() {
        LoaderService.hideLoader();
        vm.formData.folioNumber=null;
        return;
      };
      if (vm.formData.folioNumber) {
        LoaderService.showLoader();
        panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);
      }

    }


    function setInvestorData() {
      var payload = {};
      if (vm.cartDetails &&  vm.cartDetails.brokerDetailsDTO) {
        payload = {
          folioNumber: vm.formData.folioNumber,
          brokerCode: vm.investThrough === 'DIRECT'? 'DIRECT' : vm.brokerCode,
          euinOpted: vm.cartDetails.brokerDetailsDTO.euinOpted ? vm.cartDetails.brokerDetailsDTO.euinOpted : 'N',
          euinCode: vm.cartDetails.brokerDetailsDTO.euinCode,
          euinName: vm.cartDetails.brokerDetailsDTO.euinName,
          minorFlag: vm.formData.minorFlag,
          brokerKey: null,
          brokerValue: null,
          newUser: false,
          invType: vm.formData.invType,
          subBrokerARN: vm.cartDetails.brokerDetailsDTO.subBrokerArn,
          subBrokerCode: vm.cartDetails.brokerDetailsDTO.subBrokerCode,
          subBrokerName: vm.cartDetails.brokerDetailsDTO.subBrokerName,
          riaConsent: vm.cartDetails.brokerDetailsDTO.riaConsent,
          directOpted: vm.cartDetails.brokerDetailsDTO.directOpted,
          investThroughRIA: vm.cartDetails.brokerDetailsDTO.investThroughRIA,
          investThroughDirect: vm.cartDetails.brokerDetailsDTO.directOpted,
          investThroughDistributor: !vm.cartDetails.brokerDetailsDTO.investThroughRIA && !vm.cartDetails.brokerDetailsDTO.directOpted ? true : false
        };
      } else if (vm.updatedInvestThrough && vm.updatedInvestThrough.brokerDetailsDTO) {
        payload = {
          folioNumber: vm.formData.folioNumber,
          brokerCode: vm.investThrough === 'DIRECT'? 'DIRECT' : vm.brokerCode,
          euinOpted: vm.updatedInvestThrough.brokerDetailsDTO.euinOpted ? vm.updatedInvestThrough.brokerDetailsDTO.euinOpted : 'N',
          euinCode: vm.updatedInvestThrough.brokerDetailsDTO.euinCode,
          euinName: vm.updatedInvestThrough.brokerDetailsDTO.euinName,
          minorFlag: vm.formData.minorFlag,
          brokerKey: null,
          brokerValue: null,
          newUser: false,
          invType: vm.formData.invType,
          subBrokerARN: vm.updatedInvestThrough.brokerDetailsDTO.subBrokerArn,
          subBrokerCode: vm.updatedInvestThrough.brokerDetailsDTO.subBrokerCode,
          subBrokerName: vm.updatedInvestThrough.brokerDetailsDTO.subBrokerName,
          investThroughRIA: vm.updatedInvestThrough.brokerDetailsDTO.investThroughRIA,
          riaConsent: vm.updatedInvestThrough.brokerDetailsDTO.riaConsent,
          directOpted: vm.updatedInvestThrough.brokerDetailsDTO.directOpted,
          investThroughDirect: vm.updatedInvestThrough.brokerDetailsDTO.investThroughDirect,
          investThroughDistributor: vm.updatedInvestThrough.brokerDetailsDTO.investThroughDistributor
        };
      } else {
        payload = {
          folioNumber: vm.formData.folioNumber,
          brokerCode: vm.investThrough === 'DIRECT'? 'DIRECT' : vm.brokerCode,
          euinOpted: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.euinOpted ?
            vm.cartDetails.brokerDetailsDTO.euinOpted: vm.investThrough === AppConstants.INVEST_THROUGH.DISTRIBUTOR ? 'Y': 'N',
          euinCode: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.euinCode ?
            vm.cartDetails.brokerDetailsDTO.euinCode: vm.investThrough === AppConstants.INVEST_THROUGH.DISTRIBUTOR ? vm.euinList.length > 0 && vm.euinList[0].euinCode: null,
          euinName: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.euinName ?
            vm.cartDetails.brokerDetailsDTO.euinName: vm.investThrough === AppConstants.INVEST_THROUGH.DISTRIBUTOR ? vm.euinList.length > 0 && vm.euinList[0].euinName: null,
          minorFlag: vm.formData.minorFlag,
          brokerKey: null,
          brokerValue: null,
          newUser: false,
          invType: vm.formData.invType,
          subBrokerARN: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.subBrokerARN ?
            vm.cartDetails.brokerDetailsDTO.subBrokerARN: vm.investThrough === AppConstants.INVEST_THROUGH.DISTRIBUTOR ? vm.subBrokerARN : null,
          subBrokerCode: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.subBrokerCode ?
            vm.cartDetails.brokerDetailsDTO.subBrokerCode: vm.investThrough === AppConstants.INVEST_THROUGH.DISTRIBUTOR ? vm.subBrokerCode : null,
          subBrokerName: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.subBrokerName ?
            vm.cartDetails.brokerDetailsDTO.subBrokerName: vm.investThrough === AppConstants.INVEST_THROUGH.DISTRIBUTOR ? vm.subBrokerName: null,
          investThroughRIA: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.riaConsent ? vm.cartDetails.brokerDetailsDTO.riaConsent
            : vm.investThrough === 'RIA'? true : false,
          riaConsent: false,
          directOpted: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.directOpted ?
            vm.cartDetails.brokerDetailsDTO.directOpted : vm.investThrough === 'DIRECT' ? true : false,
          investThroughDirect: vm.cartDetails.brokerDetailsDTO && vm.cartDetails.brokerDetailsDTO.directOpted ?
            vm.cartDetails.brokerDetailsDTO.directOpted : vm.investThrough === 'DIRECT' ? true : false,
          investThroughDistributor: vm.investThrough !== 'RIA' && vm.investThrough !== 'DIRECT' ? true: false
        };
      }
      return payload;
    }

    function fetchPreviousTransactionDetails() {
      LoaderService.showLoader();
      var payload = {
        folioNo: vm.formData.folioNumber
      };
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var distributorDetails = resp.data;
          if (distributorDetails.investThroughDistributor && distributorDetails.previousDistributorDetails.brokerCode.indexOf('ARN-') === 0) {
            vm.investThrough = AppConstants.INVEST_THROUGH.DISTRIBUTOR;
            var brokerCode = distributorDetails.previousDistributorDetails.brokerCode ? distributorDetails.previousDistributorDetails.brokerCode.split('-') : [];
            vm.brokerCode = distributorDetails.previousDistributorDetails.brokerCode;
            vm.brokerName = distributorDetails.previousDistributorDetails.brokerName;
            var subBrokerArn = distributorDetails.previousDistributorDetails.subBrokerArn;
            var subBrokerARNArray = subBrokerArn ? subBrokerArn.split('-') : [];
            vm.subBrokerARN = subBrokerARNArray ? subBrokerARNArray[1] : '';
            vm.subBrokerCode = distributorDetails.previousDistributorDetails.subBrokerCode;
            vm.subBrokerName = distributorDetails.previousDistributorDetails.subBrokerName;
            vm.euinMasterList = distributorDetails.previousDistributorDetails.euinDetailList;
            vm.euinList = vm.euinMasterList;
            vm.euin = vm.euinList.length === 1 ? vm.euinList[0] : null;
            vm.euin = distributorDetails.previousDistributorDetails.euinPreviousUsed ? vm.euinList[0] : null;
            vm.euinData = vm.euin ? vm.euin : {};
            if (vm.euinData) {
              vm.euinData.euinNameCode = vm.formData.euin ? vm.formData.euin.euinNameCode : null;
            }
          } else if (distributorDetails.investThroughRIA) {
            vm.brokerCode = distributorDetails.previousDistributorDetails.brokerCode ? distributorDetails.previousDistributorDetails.brokerCode : "";
            vm.investThrough = AppConstants.INVEST_THROUGH.RIA;
          } else {
            vm.investThrough = AppConstants.INVEST_THROUGH.DIRECT;
          }
        } else {
          MessageService.error(resp.message);
          cb(false);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        cb(false);
      };
      InvestorService.post({
        child1: 'folio',
        child2: 'status',
        child3: 'previous',
        child4: 'transaction'
      },payload).$promise.then(success, error);
    }

    function updateMinorFlag() {
      if (vm.ecartFolioList && vm.ecartFolioList.length > 0) {
        vm.ecartFolioList.forEach(function (el, index) {
          if (el.folioNumber === vm.formData.folioNumber) {
            vm.formData.minorFlag = el.minorFlag;
          }
        });
      }
    }
    function checkEmandateDateForNPCI(cartItems){

      vm.startEmandateDate = findMinDate(cartItems);
      vm.endEmandateDate = findMaxDate(cartItems);
      vm.emandateTotalAmount = findMaxAmount(cartItems);

      var emandateEndDate = $window.moment(vm.startEmandateDate,'DD-MMM-YYYY').add(vm.maxMandateDurationYears,'years');
      var selectedEndDate = $window.moment(vm.endEmandateDate,'DD-MMM-YYYY');
      var endDateEmandateBoundExist = selectedEndDate.isBefore(emandateEndDate);
      vm.found = cartItems.some(function (ele){
        return ele.sipOpted == true
      });
      if (!endDateEmandateBoundExist && vm.found) {
        vm.formData.isExceedingEmandateDate = true;
      } else {
        vm.formData.isExceedingEmandateDate = false;
      }


      var upiEndDate = $window.moment(vm.currentDate,'DD-MMM-YYYY').add(vm.maxMandateUPIDurationYears,'years');
      var selectedUpiEndDate = $window.moment(vm.endEmandateDate,'DD-MMM-YYYY');
      var upiEmandateBoundExist = selectedUpiEndDate.isBefore(upiEndDate);
      vm.upiFound = cartItems.some(function (ele){
        return ele.sipOpted == true
      });
      if (!upiEmandateBoundExist && vm.upiFound) {
        vm.formData.isExceedingUPIDate = true;
      } else {
        vm.formData.isExceedingUPIDate = false;
      }

    }

    function findMinDate(items){
      var min_dt = items[0].sipDate,
        min_dtObj = new Date(items[0].sipDate);
      items.forEach(function(dt, index) {
        if ( new Date( dt.sipDate ) < min_dtObj) {
          min_dt = dt.sipDate;
          min_dtObj = new Date(dt.sipDate);
        }
      });
      return min_dt;
    }

    function findMaxDate(items) {
      var max_dt = items[0].toDate,
        max_dtObj = new Date(items[0].toDate);
      items.forEach(function(dt, index) {
        if ( new Date( dt.toDate ) > max_dtObj) {
          max_dt = dt.toDate;
          max_dtObj = new Date(dt.toDate);
        }
      });
      return max_dt;
    }

    function findMaxAmount(items){
      var totalEmandateAmount = 0;
      items.forEach(function(amt, index) {
        totalEmandateAmount = totalEmandateAmount + amt.installmentAmount
      });
      return totalEmandateAmount
    }

    function getRandomOTPId() {
      var successRandomOTPIdHandler = function(resp) {
        vm.randomOTPId = resp.randomOTPId ? resp.randomOTPId : null;
      }, errorRandomOTPIdHandler = function (){}
      UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
    }

  }

})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('TransactionStatusController', transactionStatusCtrl);

    /** @ngInject */
    function transactionStatusCtrl(TransactionService, UtilService, $window, LoaderService, MessageService, $location) {
        var vm = this;
        vm.url = $location.url();
        vm.toDate = new $window.moment().format("DD-MMM-YYYY");
        vm.fromDate = $window.moment().subtract(14, "days").format("DD-MMM-YYYY");
        vm.checkLocation = checkLocation;
        vm.init = function() {
          transactionSnapshotAPI();
        };

      function checkLocation(){
        if (vm.url == '/dashboard/edit') {
          return true
        }
        else {
          return false
        }
      }

      function transactionSnapshotAPI() {
        var success = function (resp) {
            LoaderService.hideLoader(".assetmng-loader");
            if (resp.data && resp.status) {
              vm.snapshotData = resp.data;
            } else {
              vm.snapshotData = null;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader(".assetmng-loader");
            UtilService.errorHandler(err);
          };
        LoaderService.showLoader(".assetmng-loader");
        TransactionService.get({
          controller1: 'transaction',
          controller2: 'recentSnapshot'
        }, {}).$promise.then(success, error);
      }


    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('contributorWidgitController', contributorWidgitController);

  /** @ngInject */
  function contributorWidgitController(AppConstants, InvestorService, LoaderService, $window, MessageService, $location) {
    var vm = this;
    var c3 = $window.c3 || {};
    vm.url = $location.url();
    vm.fetchContributorData = fetchContributorData;
    vm.showGraph = showGraph;
    vm.frequencyChanged = frequencyChanged;
    vm.contributorsChanged = contributorsChanged;
    vm.AppConstants = AppConstants;
    vm.CONTRIBUTORS_FREQUENCY = AppConstants.CONTRIBUTORS_FREQUENCY;
    vm.selectedFrequency = AppConstants.CONTRIBUTORS_FREQUENCY[3].value;
    vm.NO_OF_CONTRIBUTORS = AppConstants.NO_OF_CONTRIBUTORS;
    vm.selectedContributors = AppConstants.NO_OF_CONTRIBUTORS[0].value;
    vm.currentIndex = 0;
    vm.checkLocation = checkLocation;
    var payload = {
      "frequencyFilter": vm.selectedFrequency,
      "numberOfContributors": vm.selectedContributors
    };

    vm.init = function () {
      fetchContributorData(payload);
    };

    function frequencyChanged() {
      vm.currentIndex = 0;
      payload.frequencyFilter = vm.selectedFrequency;
      fetchContributorData(payload)
    }

    function checkLocation(){
      if (vm.url == '/dashboard/edit') {
        return true
      }
      else {
        return false
      }
    }
    function contributorsChanged() {
      vm.currentIndex = 0;
      payload.numberOfContributors = vm.selectedContributors;
      fetchContributorData(payload)
    }

    function fetchContributorData(payload) {
      var success = function (resp) {
          LoaderService.hideLoader(".contributor-loader");
          if (resp.status && resp.data) {
            vm.contributorData = resp.data.contributorList;
            //vm.navDateList = resp.data.navDateList;
            vm.navDateList = vm.contributorData[0].navDateList;
            // var navDateList = angular.copy(vm.navDateList);
            var arrayfirstList = [];
            var listfirst = vm.contributorData[0];
            arrayfirstList.push(listfirst);
            var navDateListfirst = angular.copy(vm.navDateList);
            setGraphData(arrayfirstList, navDateListfirst);
            //setGraphData(vm.contributorData, navDateList);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (res) {
          LoaderService.hideLoader(".contributor-loader");
          MessageService.error(res.message);
        };
      LoaderService.showLoader(".contributor-loader");
      InvestorService.post({
        child1: 'dashboard',
        child2: 'contributorChange'
      }, payload).$promise.then(success, error);
    }

    vm.changeGraph = function (index) {
      if (parseInt(index) > -1) {
        var arrayList = [];
        var list = vm.contributorData[index];
        arrayList.push(list);
        vm.navDateList = list.navDateList;
        //var navDateList = vm.contributorData[index].navDateList;
        var navDateList = angular.copy(vm.navDateList);
        vm.currentIndex = index;
        setGraphData(arrayList, navDateList);
      }
    }

    function setGraphData(dataList, navDateList) {
      // var navDateList = navDateList || [];
      // var category1 = navDateList[0];
      //var category = navDateList.shift();
      for (var i in navDateList) {
        if (i <= navDateList.length) {
          navDateList[i] = navDateList[i].slice(0, 2) + navDateList[i].slice(3, 6) + navDateList[i].slice(7, 11);
        }
      }
      var category = angular.copy(navDateList);
      navDateList.splice(0, 0, 'x');
      var areaList = [navDateList], areaName = {};
      var maxList = [], minList = [], min = 0, max = 0;
      angular.forEach(dataList, function (value) {
        var tmpMax, tmpMin;
        tmpMax = Math.max.apply(null, value.navDataList);
        maxList.push(tmpMax);
        // if(tmpMax > max){max=tmpMax;}
        tmpMin = Math.min.apply(null, value.navDataList);
        // if(tmpMin < min){min=tmpMin;}
        minList.push(tmpMin);
        value.navDataList = value.navDataList.map(function (ele) {
          return parseFloat(ele);
        });
        var tmp = [];
        tmp.push(value.schemeName.toString());
        tmp = tmp.concat(value.navDataList);
        areaList.push(tmp);
        areaName[value.schemeName.toString()] = 'area';
      });
      max = Math.max.apply(null, maxList);
      min = Math.min.apply(null, minList);

      showGraph(areaList, areaName, category, category.length, min, max);
    }

    function showGraph(contributorColumnList, areaName, category, listLength, min, max) {
      vm.chart = c3.generate({
        bindto: '#areachart',
        size: {height: 260, width: 350},
        padding: {left: 69, right: 25},
        margin: {left: 0, bottom: 10},
        color: {pattern: vm.AppConstants.AREA_CHART_COLOR},
        point: {
          show: false
        },
        data: {
          x: 'x',
          columns: contributorColumnList,
          types: areaName,
          empty: {
            label: {
              text: "No Data Available"
            }
          }
        },
        legend: {show: false},
        axis: {
          x: {
            type: 'category',
            categories: category,
            tick: {
              fit: listLength > 7 ? false : false,
              height: 60,
              centered: true,
              culling: true,
              count: 3
            },
            label: {
              text: 'Date',
              position: 'outer-center'
            }
          },
          y: {
            tick: {
              format: function (d) {
                return $window.d3.format(',.2f')(d);
              }
            },
            min: min,
            max: max,
            label: {
              text: 'NAV',
              position: 'outer-middle'
            }
          }
        },
        tooltip: {
          position: function (data, width, height, element) {
            var top = $window.d3.mouse(element)[1] + 15;
            return {top: top, left: parseInt(element.getAttribute('x')) + 10}
          }
        }
      });
    }

  }
})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('recentActivityWidgitController', recentActivityWidgitController);

    /** @ngInject */
    function recentActivityWidgitController(InvestorService, LoaderService, MessageService, $location) {
        var vm = this;
        vm.url = $location.url();
        vm.recentActivity = recentActivity;
        vm.checkLocation = checkLocation;

        vm.init = function() {
          recentActivity();
        };
      function checkLocation(){
        if (vm.url == '/dashboard/edit') {
          return true
        }
        else {
          return false
        }
      }
        function recentActivity() {
            var success = function(resp) {
                    LoaderService.hideLoader(".assetmng-loader");
                    if (resp.status && resp.data) {
                        vm.recentActivity = resp.data.activity;
                    } else {
                        MessageService.error(resp.message);
                    }
                },
                error = function(res) {
                    LoaderService.hideLoader(".assetmng-loader");
                    MessageService.error(res.message);
                };
            LoaderService.showLoader(".assetmng-loader");
            InvestorService.post({
                child1: 'dashboard',
                child2: 'widgets',
                child3: 'recentActivity'
            },{}).$promise.then(success, error);
        }
    }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('quickLinkWidgitController', quickLinkWidgitController);

  /** @ngInject */
  function quickLinkWidgitController(InvestorService, LoaderService, MessageService, UtilService, $location, AppConstants, KycService, $log, $state, TransactionModel) {
    var vm = this;
    vm.url = $location.url();
    vm.checkLocation = checkLocation;
    vm.checkKycStatus = checkKycStatus;

    function checkLocation(){
      if (vm.url == '/dashboard/edit') {
        return true
      }
      else {
        return false
      }
    }

    function checkKycStatus(_state) {
      var successHandler = function() {
        if (_state === 'sip' || _state === 'purchase') {
          TransactionModel.setPayloadRawData(null);
          $state.go('main.transactions.' + _state);
        }
      };
      KycService.fetchKycStatus(AppConstants.KYC_RESTRICTION.TRANSACTION).then(successHandler).catch(function(resp) {
        $log.info(resp);
      });
    }

  }
})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('marketUpdateWidgitController', marketUpdateWidgitController);

    /** @ngInject */
    function marketUpdateWidgitController(InvestorService, LoaderService, MessageService, $location) {
        var vm = this;
        vm.url = $location.url();
        vm.fetchMarketOverview = fetchMarketOverview;
        vm.fetchMarketNews = fetchMarketNews;
        vm.marketNewsList = [];
        vm.checkLocation = checkLocation;
        function fetchMarketOverview() {
            var payload = {
                fromDate: "",
                toDate: ""
            };
            var success = function(resp) {
                    LoaderService.hideLoader(".market-updates .popup");
                    if (resp.status && resp.data) {
                        var data = resp.data;
                        vm.bseRate = data.bseRate;
                        vm.nseRate = data.nseRate;
                    } else {
                        MessageService.error(resp.message);
                    }
                },
                error = function(res) {
                    LoaderService.hideLoader(".market-updates .popup");
                    MessageService.error(res.message);
                };
            LoaderService.showLoader(".market-updates .popup");
            InvestorService.post({
                child1: 'dashboard',
                child2: 'market-data'
            }, payload).$promise.then(success, error);
        }
      function checkLocation(){
        if (vm.url == '/dashboard/edit') {
          return true
        }
        else {
          return false
        }
      }
      function fetchMarketNews() {
        var payload = {
          fromDate: "",
          toDate: ""
        };
        var success = function(resp) {
            LoaderService.hideLoader(".market-updates .popup");
            if (resp.status && resp.data) {
              vm.marketNewsList = resp.data.items;
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function(res) {
            LoaderService.hideLoader(".market-updates .popup");
            MessageService.error(res.message);
          };
        LoaderService.showLoader(".market-updates .popup");
        InvestorService.post({
          child1: 'dashboard',
          child2: 'market-news'
        }, payload).$promise.then(success, error);
      }

    }
})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('investmentWidgitController', investmentWidgitController);

    /** @ngInject */
    function investmentWidgitController(InvestorService, LoaderService, $window, $location ,$timeout, $scope, MessageService, UtilService, AppConstants) {
        var vm = this;
        var c3 = $window.c3 || {};
      vm.url = $location.url();
        vm.fetchInvestmentOverview = fetchInvestmentOverview;
        vm.makeDonutOfInvester = makeDonutOfInvester;
        vm.clickTotalInsvester = clickTotalInsvester;
        vm.checkLocation = checkLocation;
        vm.xirrInfo = AppConstants.XIRR_INFORMATION;
        vm.init = function() {

            fetchInvestmentOverview();
        };

          function clickTotalInsvester() {
            $timeout(function() {
                angular.element($window.document.querySelector('.c3-chart-arcs-title')).on('click', function() {
                    $scope.$apply(function() {
                        vm.investmentSelected = vm.key;

                    })
                });
            }, 0)
        }
        function checkLocation(){
          if (vm.url == '/dashboard/edit') {
            return true
          }
          else {
            return false
          }
        }
        function makeDonutOfInvester(data) {
            var graphData = data;
            vm.donutTitle = '';
            $timeout(function() {
                // var totalVal = vm.getValue(vm.investmentTotal.amount);
               // vm.donutTitle = '₹' + $filter('currency')(totalVal, "");
                //vm.donutTitle = '₹' + totalVal;
                // vm.investmentSelected = 1;
                vm.assetChart = c3.generate({
                    bindto: '#donutchart-asset',
                    donut: {
                        width: 39,
                        title: vm.donutTitle
                    },
                    padding: { top:0 },
                    size: { height: 200, width: 200 },
                    color: { pattern: ["#00c0f2", "#103880", "#2485bd", "#4d7dbd"] },
                    data: {
                        columns: [],
                        type: 'donut',
                        onclick: function(d) { //d=>object i=>path
                            $scope.$apply(function() {
                                vm.investmentSelected = d.index;
                            })
                        }
                    },
                    legend: {
                        item: {
                            onclick: function() {}
                        }
                    }
                });
                vm.assetChart.load({ columns: graphData });

            })
        }

      vm.getValue = function (input) {

          if(!input)
            return '0';

          var value = input.toString().split('.');
          var x = value[0],decimal ='', finalStr = '';

          if(value.length > 1){
            decimal = value[1].substring(0, 2);
          }
          var lastThree = x.substring(x.length-3);
          var otherNumbers = x.substring(0,x.length-3);

          if(otherNumbers != '')
            lastThree = ',' + lastThree;

          var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

          if(value.length > 1){
            finalStr = res+'.'+decimal;
          } else {
            finalStr = res;
          }
          return finalStr ;

      };

        function fetchInvestmentOverview() {
            var success = function(resp) {
                    var graphData = [];
                    LoaderService.hideLoader(".transsnap");
                    if (resp.status && resp.data) {
                        vm.constantDataDTO = resp.data.constantDataDTO;
                        vm.xirrValueUnit = UtilService.getUnitSting(resp.data.constantDataDTO.xirrValue);
                        vm.xirrValue = resp.data.constantDataDTO.xirrValue?resp.data.constantDataDTO.xirrValue:'';
                        vm.investmentData = resp.data.schemesResponseDTO.aumAndSchemesStatsList || [];
                      //vm.b = vm.investmentData(function(ele){ if(ele.topSchemesList&&ele.topSchemesList.length>0){return ele;}});
                        vm.purchaseValueUnit = vm.constantDataDTO.totalPurchaseValue;
                        vm.constantDataDTO.totalPurchaseValue = vm.constantDataDTO.totalPurchaseValue;
                        vm.currentValueUnit = vm.constantDataDTO.totalCurrentValue;
                        vm.constantDataDTO.totalCurrentValue = vm.constantDataDTO.totalCurrentValue;
                        vm.totalCurrentPercentageUnit = vm.constantDataDTO.totalCurrentPercentage;
                        vm.schemeCount = resp.data.schemeCount;
                        vm.open = false;
                        var perList = [];
                        vm.investmentData.forEach(function(val, key) {
                            if (vm.investmentData[key].aumType && vm.investmentData[key].aumType !== 'Total') {
                                var tmp = [];
                              perList.push(val.percentage);
                                var aumType = val.aumType[0].toUpperCase() + val.aumType.slice(1).toLowerCase();
                                vm.investmentData[key].aumType = aumType;
                                tmp.push(aumType);
                                tmp.push(val.percentage);
                                graphData.push(tmp);
                                vm.data = graphData;
                            } else {
                                vm.key = key;
                                vm.investmentTotal = val;
                            }
                        });
                      var maxVal = Math.max.apply(null, perList);
                      var indexOfMax = perList.indexOf(maxVal)
                      vm.investmentSelected = parseInt(indexOfMax)>-1?indexOfMax:0;
                        makeDonutOfInvester(graphData);
                        clickTotalInsvester();
                    } else {
                        MessageService.error(resp.message);
                    }
                },
                error = function(res) {
                    LoaderService.hideLoader(".transsnap");
                    MessageService.error(res.message);
                };
            LoaderService.showLoader(".transsnap");
            InvestorService.post({
                child1: 'dashboard',
                child2: 'widgets',
                child3: 'investment'
            }, {}).$promise.then(success, error);
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('dividendUpdateWidgitController', dividendUpdateWidgitController);

    /** @ngInject */
    function dividendUpdateWidgitController(InvestorService, LoaderService, MessageService, UtilService, $location, $state, AppConstants, TransactionModel) {
        var vm = this;
        vm.fetchNavDividend = fetchNavDividend;
        vm.checkLocation = checkLocation;
      vm.url = $location.url();
      vm.top_Up_label=AppConstants.ToastrMessage.VALIDATE_DATA.TOP_UP_LABEL;
      vm.fetchTopUpLabel=fetchTopUpLabel;
        vm.init = function() {
            fetchNavDividend();
        };

      function checkLocation(){
        if (vm.url == '/dashboard/edit') {
          return true
        }
        else {
          return false
        }
      }
        function fetchNavDividend() {
            var success = function(resp) {
                    LoaderService.hideLoader(".dividend-loader");
                    if (resp.status && resp.data) {
                        vm.navDividend = resp.data;
                      vm.navDividend && vm.navDividend.forEach(function (item) {
                        item.costValueUnit = UtilService.getUnitSting(item.costValue);
                        item.marketValueUnit = UtilService.getUnitSting(item.marketValue);
                        item.changeInValueUnit = UtilService.getUnitSting(item.changeInValue);
                        item.navValueUnit = UtilService.getUnitSting(item.navValue);
                        item.changeInNavUnit = UtilService.getUnitSting(item.changeInNav);
                      });
                    } else {
                        MessageService.error(resp.message);
                    }
                },
                error = function(res) {
                    LoaderService.hideLoader(".dividend-loader");
                    MessageService.error(res.message);
                };
            LoaderService.showLoader(".dividend-loader");
            InvestorService.post({
                child1: 'dashboard',
                child2: 'navDividendValue'
            },{}).$promise.then(success, error);
        }
      vm.selectTransaction = function (action,data){
        TransactionModel.setPayloadRawData(null);
        var params = { folioNumber : data.folio, sc : data.schemeCode, action: 'dashboard' };
        switch (action.toLocaleLowerCase()) {
          case 'sip':
            $state.go('main.transactions.sip',params);
            break;
          case 'purchase':
            $state.go('main.transactions.purchase',params);
            break;
        }
      };

      function fetchTopUpLabel() {
        LoaderService.showLoader();
        var success = function(resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.topUpLabel = resp.data.noteDTO.noteDTOMap.Topup_Button_Label.content;
          } else {
            MessageService.error(resp.message);
          }
        }, failure = function(resp) {
          MessageService.error(resp)
          LoaderService.hideLoader();
        };
        var payload = {
          "pageName": "HOME_SCREEN"
        }
        InvestorService.post({child1: 'dynamicContent'}, payload).$promise.then(success, failure);
      }
    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('hdfcSidebar', hdfcSidebar);

  /** @ngInject */
  function hdfcSidebar() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/sidebar/sidebar.html',
      scope: {
        creationDate: '='
      },
      controller: sidebarController,
      controllerAs: 'Sidebar',
      bindToController: true
    });

    /** @ngInject */
    function sidebarController(HDFC_API, $timeout, $state, $rootScope, $scope, $http, MessageService, UtilService, $window) {
      var vm = this;
      vm.active = null;
      vm.sidebarActive = null;
      vm.HDFC_API = HDFC_API;
      // vm.redirectUrl = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/distributor/generateGatePass/' + HDFC_API.THIRD_PARTY_NAME;

      function openLeadmanagement() {
        var _link = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/generateGatePass/' + HDFC_API.THIRD_PARTY_NAME;
        $http.get(_link, {}, {
          headers: {}
        })
          .then(function (resp) {
            if (resp.status && resp.data) {
              $window.open(resp.data, '_blank');
            } else {
              MessageService.error(resp.message);
            }
          }, function (err) {
            UtilService.errorHandler(err);
          });
      }

      /*function openFinancialPlanning() {
       var _link = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/distributor/fivenance/redirect';
       $http.post(_link, {fivenanceInvestorId: null}, {
       headers: {'Content-Type': 'application/json'}
       })
       .success(function (resp) {
       if (resp.status && resp.data) {
       $window.open(resp.data, '_blank');
       } else {
       MessageService.error(resp.message);
       }
       })
       .error(function (err) {
       UtilService.errorHandler(err);
       });
       }*/

      vm.initTab = function () {
        $timeout(function () {
          var baseState = $state.current.name.split('.')[1];
          switch (baseState) {
            default:
              vm.active = {'-1': true};
              break;
            case 'dashboard':
              vm.active = {0: true};
              break;
            case 'transactions':
              vm.active = {1: true};
              break;
            case 'portfolio':
              vm.active = {2: true};
              break;
            case 'sipcorner':
              vm.active = {3: true};
              break;
            case 'reports':
              vm.active = {4: true};
              break;
            case 'leapacademy':
              vm.active = {5: true};
              break;
            case 'leadmanagement':
              vm.active = {6: true};
              break;
            case 'financialtool':
              vm.active = {7: true};
              break;
            case 'schemecalculator':
              vm.active = {8: true};
              break;
            case 'hdfcWeb':
              vm.active = {9: true};
              break;
            case 'systematiccorner':
              vm.active = {9: true};
              break;
          }
        }, 100);
      };

      vm.activateTab = function (tab) {
        vm.active = {};
        vm.active[tab] = true;
        if (tab == 6) {
          openLeadmanagement();
        }
      };

      angular.element("#menuButton").click(function () {
        angular.element(".mobile-menu").addClass("expanded");
        angular.element(".main-section").css("overflow", "hidden");
        /*angular.element(".main-section").css("position", "fixed");*/
        angular.element(".mobile-header>.black-tint").fadeIn();
      });

      angular.element(".mobile-header>.black-tint").click(function () {
        angular.element(".mobile-menu").removeClass("expanded");

        angular.element(".main-section").css("overflow", "none");
        angular.element(".main-section").css("position", "static");
        angular.element(".mobile-header>.black-tint").fadeOut();
      });

      angular.element(".mobile-menu .mobile-nav ul > li").click(function () {
        angular.element(".mobile-menu").removeClass("expanded");
        angular.element(".mobile-header>.black-tint").fadeOut();
      });

      angular.element(".mobile-header .mobile-search").click(function () {
        angular.element(".mobile-search-bar").toggle();
      });

      var listener = $rootScope.$on('UpdateSideBar', vm.initTab);

      $scope.$on("$destroy", function () {
        // Unbind angular event listeners
        if (angular.isFunction(listener)) {
          listener();
        }
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('footerLogin', footerLogin)
    .directive('sideImageLandingPage', sideImageLandingPage);

  /** @ngInject */
  function sideImageLandingPage() {
    return ({
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/sideImage/sideImage.html',
      link : function (scope,HDFC_API) { 
        scope.HDFC_API = HDFC_API;
        scope.switchImage = function () {
          scope.switchImageFlag = true;
        };
      },
      controller: sideImageController,
      controllerAs: 'SideImage',
      bindToController: true
    });
  }

  /** @ngInject */
  function footerLogin() {
    return ({
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/footer/footer-login.html',
      link : function (scope,HDFC_API) {
        scope.HDFC_API =HDFC_API;
        scope.switchImage = function () {
          scope.switchImageFlag = true;
        };
      },
      controller: sideImageController,
      controllerAs: 'SideImageFooter',
      bindToController: true
    });

  }

  function sideImageController(ModalService,HDFC_API) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.openVideo = openVideo;
    function openVideo() {
      ModalService.loginVideoModal();
    }
  }
})();


(function () {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .directive('slideImageMb', slideImageMb);

    function slideImageMb() {
        return ({
            restrict: 'E',
            templateUrl: 'app/components/new-slide-image-mb/slide-image-mb.html',
            scope: {
                creationDate: '='
            },
            controller: slideImageMbController,
            controllerAs: 'slideImageMb',
            bindToController: true
        });


        /** @ngInject */
        function slideImageMbController($window,$interval) {
            var vm = this;
            var slideIndex = 1;
            vm.showSlides = function(n) {
                var i;
                var slides = document.getElementsByClassName("mySlidesMb");
                var dots = document.getElementsByClassName("dotMb");
                if(slides.length > 0 && dots.length > 0){
                    if (n > slides.length) { 
                        slideIndex = 1 
                    }
                    if (n < 1) { slideIndex = slides.length }
                    for (i = 0; i < slides.length; i++) {
                        slides[i].style.display = "none";
                    }
                    for (i = 0; i < dots.length; i++) {
                        dots[i].className = dots[i].className.replace(" activeMb", "");
                    }
                    slides[slideIndex - 1].style.display = "block";
                    dots[slideIndex - 1].className += " activeMb";
                }
            }
            vm.showSlides(slideIndex);
            $interval(function () {
                slideIndex = slideIndex + 1;
                if(slideIndex == 4){
                    slideIndex = 1;
                }
                vm.showSlides(slideIndex);
              },8000);
            angular.element($window.document.querySelector('#dotMb1')).on('click', function() {
                slideIndex = 1;
                vm.showSlides(1);
            });
            angular.element($window.document.querySelector('#dotMb2')).on('click', function() {
                slideIndex = 2;
                vm.showSlides(2);
            });
            angular.element($window.document.querySelector('#dotMb3')).on('click', function() {
                slideIndex = 3;
                vm.showSlides(3);
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .directive('slideImage', slideImage);

    function slideImage() {
        return ({
            restrict: 'E',
            templateUrl: 'app/components/new-slide-image/slide-image.html',
            scope: {
                creationDate: '='
            },
            controller: slideImageController,
            controllerAs: 'slideImage',
            bindToController: true
        });


        /** @ngInject */
        function slideImageController($window,$interval) {
            var vm = this;
            var slideIndex = 1;
            vm.showSlides = function(n) {
                var i;
                var slides = document.getElementsByClassName("mySlides");
                var dots = document.getElementsByClassName("dot");
                if(slides.length > 0 && dots.length > 0){
                    if (n > slides.length) { 
                        slideIndex = 1 
                    }
                    if (n < 1) { slideIndex = slides.length }
                    for (i = 0; i < slides.length; i++) {
                        slides[i].style.display = "none";
                    }
                    for (i = 0; i < dots.length; i++) {
                        dots[i].className = dots[i].className.replace(" activeWeb", "");
                    }
                    slides[slideIndex - 1].style.display = "block";
                    dots[slideIndex - 1].className += " activeWeb";
                }
            }
            vm.showSlides(slideIndex);
            $interval(function () {
                slideIndex = slideIndex + 1;
                if(slideIndex == 4){
                    slideIndex = 1;
                }
                vm.showSlides(slideIndex);
              },8000);
            angular.element($window.document.querySelector('#dot1')).on('click', function() {
                slideIndex = 1;
                vm.showSlides(1);
            });
            angular.element($window.document.querySelector('#dot2')).on('click', function() {
                slideIndex = 2;
                vm.showSlides(2);
            });
            angular.element($window.document.querySelector('#dot3')).on('click', function() {
                slideIndex = 3;
                vm.showSlides(3);
            });
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    });

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;
      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }
})();

/**
 * Created by ttn on 21/01/21.
 * Implement the following:
 * * CryptoJS for AES ecnryption and decryption.
 * * JSscript for RSA encryption and decryption.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('ApiInterceptor', apiInterceptor);

  /** @ngInject */
  function apiInterceptor($rootScope, $cookies, $window, $q, FormatterService) {

    /*function to identify html template calls*/
    function isTemplateCall(config) {
      if (!config || !config.url) {
        return;
      }
      return config.url.lastIndexOf('.html') !== -1;
    }

    /*function to identify get call*/
    function isGetCall(config) {
      if (!config || !config.method) {
        return;
      }
      return config.method === 'GET';
    }

    /*function to check empty request body and content-type of calls*/
    function isRequestBodyEmpty(config) {
      if (!config || !config.data) {
        return;
      }
      return Object.keys(config.data).length !== 0;
    }

    /*function to check for content type*/
    function contentTypeCheck(config) {
      if (!config || !config.headers) {
        return;
      }
      return config.headers["Content-Type"] === "application/x-www-form-urlencoded";
    }

    function createAesRequestPayload(jsonRequiredToEncrypt) {
      if(jsonRequiredToEncrypt.request || jsonRequiredToEncrypt.checksum){
        return jsonRequiredToEncrypt;
      }
      var key =  FormatterService.hash.lib.WordArray.random(128/8); //16bit
      var IV =  FormatterService.hash.lib.WordArray.random(128/8); //8bit
      var aesEncrypted = FormatterService.hash.AES.encrypt(angular.toJson(jsonRequiredToEncrypt), key, { iv: IV });
      var ivAndKey = FormatterService.hash.enc.Base64.stringify(IV) + "|" + FormatterService.hash.enc.Base64.stringify(key);
      return (FormatterService.getFormatter().encrypt(ivAndKey) + "|" + FormatterService.hash.enc.Base64.stringify(aesEncrypted.ciphertext));
    }

    return {
      'request': function(config) {
        if (!isTemplateCall(config) && !isGetCall(config) && isRequestBodyEmpty(config) && !contentTypeCheck(config)) {
          if (config.url && config.url.includes("res.cloudinary.com")) {
            delete config.headers['encrypted'];
          } else {
            config.headers['archived'] = 'enabled';
          }
          //config.data = btoa(JSON.stringify(config.data)); //for only base 64
          var aesEncryptedString = createAesRequestPayload(config.data);
          config.data = aesEncryptedString;
        }
        return config;
      },

      'requestError': function(rejection) {
        if (!isTemplateCall(rejection.config)) {
          return $q.reject(rejection);
        }
      },

      'response': function(response) {
        if((response && response.config.url.includes("/investor/v1/mobile/checkExistingInvestor")) ||
          (response && response.config.url.includes("/investor/v1/dashboard/widgets/recentActivity/mobile/login"))){
            // to check data is string 
            if (angular.isString(response.data)) {
              var header = response.data.substring(0, response.data.lastIndexOf("|"));
              var data = FormatterService.hash.enc.Base64.parse(response.data.substring(response.data.lastIndexOf("|")+1, response.data.length));
              var responseData = FormatterService.readAesResponsePayload(FormatterService.getFormatterHDFC().decrypt(header), data);
              if(!responseData){
                response.data = {};
                response.data.logout = true;
                return response;
              }
              response.data = angular.fromJson(responseData);
              return response;
            }
            // to check data is object
            if (angular.isObject(response.data)) {
              if (response.data.key && response.data.request) {
                return response;
              } else { 
                response.data = {};
                response.data.logout = true;
                return response;
              }
            }
        }
        if (!isTemplateCall(response.config) && !isGetCall(response.config) && isRequestBodyEmpty(response.config)
          && !contentTypeCheck(response.config)) {
          //response.data = angular.fromJson(atob(response.data)); // for only base64
          if (response.config.responseType && response.config.responseType === "arraybuffer") {
            response.data = response.data;
          } else {
            if(response.data.key && response.data.request){
              return response;
            }
            var header = response.data.substring(0, response.data.lastIndexOf("|"));
            var data = FormatterService.hash.enc.Base64.parse(response.data.substring(response.data.lastIndexOf("|")+1, response.data.length));
            var responseData = FormatterService.readAesResponsePayload(FormatterService.getFormatterHDFC().decrypt(header), data);
            response.data = angular.fromJson(responseData);
          }
          return response;
        } else {
          return response;
        }
      }
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('hdfcHeaderPreLogin', hdfcHeaderHeaderPreLogin)

  /** @ngInject */
  function hdfcHeaderHeaderPreLogin() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/header-pre-login/header-pre-login.html',
      scope: {
        creationDate: '=',
        showLogoutBtn: '=',
        logoUrl : '='
      },
      controller: headerController,
      controllerAs: 'Header',
      bindToController: true
    });
  }

  /** @ngInject */
  function headerController(InvestorService,LoaderService,CommonFactory,AuthService,AppConstants,$state,$window,HDFC_API) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.format = 'dd-MMM-yyyy h:mm:ss a';

    vm.logoutMe = logoutMe;

    /**
     * Function responsible for handling user logout
     */
    function logoutMe() {

      var val = JSON.parse(decodeURI(sessionStorage.getItem('pd')));

      var success = function (resp) {
          localStorage.removeItem("userId");
          var newDataLayer = $window.dataLayer.filter(function (obj) {
            return !obj.hasOwnProperty('userId');
          });
          $window.dataLayer = newDataLayer;
          AuthService.clearCookies(AppConstants.TOKEN);
          CommonFactory.setLogoutSuccess();
          $state.go('login');
        },
        error = function (err) {
        };
      LoaderService.showLoader('.logout');
      InvestorService.post({
        child1: 'force',
        child2: 'logout'
      }, val).$promise.then(success, error);

    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('hdfcHeader', hdfcHeader)
    .directive('welcomeHeader', welcomeHeader)
    .directive('newInvestorHeader', newInvestorHeader)
    .directive('myCurrentTime', ['$interval', 'dateFilter',
    function($interval, dateFilter) {

      return function(scope, element, attrs) {
        var format,
          stopTime;
        function updateTime() {
          element.text(dateFilter(new Date(), format));
        }
        scope.$watch(attrs.myCurrentTime, function(value) {
          format = value;
          updateTime();
        });

        stopTime = $interval(updateTime, 1000);
        element.on('$destroy', function() {
          $interval.cancel(stopTime);
        });
      }
    }]);

  function hdfcHeader() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/header/header.html',
      scope: {
        creationDate: '='
      },
      controller: headerController,
      controllerAs: 'Header',
      bindToController: true
    });
  }

  function welcomeHeader() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/header/welcome-header.html',
      scope: {
        creationDate: '='
      },
      controller: headerController,
      controllerAs: 'Header',
      bindToController: true
    });
  }


  /** @ngInject */
  function headerController($window, $state, AuthService, TransactionModel, AppConstants, ModalService, $scope,
                            InvestorService, LoaderService, UtilService, MessageService, $timeout, NetcoreEvntService, KycService, $log, CommonFactory, $stateParams, investorServiceVersion,HDFC_API,$rootScope, EcartModel) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    var listeners = {};
    vm.customizeWidgets = customizeWidgets;
    vm.getTotalNotificationCount = getTotalNotificationCount;
    vm.getCartCount = getCartCount;
    vm.latestNotification = latestNotification;
    vm.changedFont = changedFont;
    vm.fontSizeChange = fontSizeChange;
    vm.count = 0;
    vm.contrast = contrast;
    vm.notificationCount = 0;
    vm.latestNotificationList = null;
    getTotalNotificationCount();
    latestNotification();
    getCartCount();
    vm.iconClicked = false;
    vm.contrastt = UtilService.darkThemeStatus.get();
    vm.viewAllClicked = viewAllClicked;
    var token = AuthService.getToken();
    vm.corporateUserFlag = token && token.corporateUserFlag ? token.corporateUserFlag : false;
    vm.profilePhotoUrl = token && token.profileImageUrl?token.profileImageUrl:AppConstants.DEFAULT_PROFILE_IMAGE;
    // setInterval(startTime, 1000);
    destroyLoginHeader();
    vm.constants = AppConstants;

    vm.cartCount = 0;
    listeners['UpdateProfileImage'] = $scope.$on('UpdateProfileImage', function (event, args) {
      vm.profilePhotoUrl = "";
      $timeout(function () {
        vm.profilePhotoUrl = args.profilePhotoUrl;
      })
    });

    listeners['UpdateCart'] = $scope.$on('UpdateCart', function (event, args) {
      if (args.listUpdated) {
        vm.getCartCount();
      }
    });

    listeners['UpdateCartCount'] = $scope.$on('UpdateCartCount', function (event, args) {
      if (args.listUpdated) {
        vm.cartCount=0;
      }
    });
    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });

    vm.goToState = function (_state, option) {
      var successHandler = function() {
        TransactionModel.setPayloadRawData(null);

        var fromJourney = _state ? _state.toUpperCase(): ''
        if(fromJourney === 'PURCHASE' || fromJourney === 'SIP'){
          vm.formData = TransactionModel.getMasterRawData(fromJourney);
          vm.formData.journey = 'Transact Now';
          TransactionModel.setPayloadRawData(vm.formData);
        }

        if (_state === 'purchase') {
          NetcoreEvntService.Transact_Now_Purchase_IP()
        }else if(_state === 'sip'){
          NetcoreEvntService.Transact_Now_SIP_IP()
        }
        if(option){
          EcartModel.setPayloadPayment(null);
          if(_state==='edit') {
            $state.go('main.transactions.' + _state, {option:option});
          }
          if(_state==='cart') {
            $state.go('main.transactions.' + _state, {option:option});
          }
          else
          {
            $state.go('main.transactions.' + _state, {option:option});
          }
        } else
        {
          if (_state === 'changeDividendOption' || _state === 'rolloverView') {
            $state.go('main.' + _state);
          } else {
            if($stateParams.action && $stateParams.action == 'modify'){
              $state.go('main.transactions.' + _state,{
                action: null,
                allowBroker: null
              });
            } else {
              $state.go('main.transactions.' + _state);
            }
          }
        }
      };
      KycService.fetchKycStatus(AppConstants.KYC_RESTRICTION.TRANSACTION).then(successHandler).catch(function(resp) {
        $log.info(resp);
      });
    };

    function contrast () {
      vm.contrastt = !vm.contrastt;
      if(!vm.contrastt){
        UtilService.darkThemeStatus.set(false);
        $window.document.getElementsByTagName("body")[0].classList.add("contrastClass");
      } else {
        UtilService.darkThemeStatus.set(true);
        $window.document.getElementsByTagName("body")[0].classList.remove("contrastClass");
      }
    }

    vm.logoutMe = function () {
      AuthService.logout().then(function () {
        localStorage.removeItem("userId");
        var newDataLayer = $window.dataLayer.filter(function (obj) {
          return !obj.hasOwnProperty('userId');
        });
        $window.dataLayer = newDataLayer;
        CommonFactory.setLogoutSuccess();
        $state.go('login');
      }, function () {
        // $state.go('login');
      });
    };

    function customizeWidgets() {
      var Success = function () {

      },Error = function () {

      }
      ModalService.widgetStoreModal({}, Success, Error);
    }



    /*function startTime() {
      var today = new Date();
      var h = today.getHours();
      var m = today.getMinutes();
      var s = today.getSeconds();
      m = checkTime(m);
      s = checkTime(s);
      vm.currentTime = h + ":" + m + ":" + s;

    }*/

    /*function checkTime(i) {
      if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
      return i;
    }*/

    function getCartCount() {
      var success = function (resp) {
          if (resp.status) {
            vm.cartCount = resp.data.total;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          //UtilService.errorHandler(err);
        };
      investorServiceVersion.get({
        child1: 'cart',
        child2: 'item',
        child3: 'count'
      }).$promise.then(success, error);
    }



    function getTotalNotificationCount() {
      var success = function (resp) {
          // LoaderService.hideLoader();
          if (resp.status) {
            vm.notificationCount = resp.data.count;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          // LoaderService.hideLoader();
          //UtilService.errorHandler(err);
        };
      InvestorService.get({
        child1: 'notification',
        child2: 'count'
      }).$promise.then(success, error);
    }

    function viewAllClicked() {
      vm.iconClicked = true;
    }

    function changedFont(valType){
      switch (valType) {
        case 'increment' : {
          if(vm.count<3){
            vm.count++;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'decrement' : {
          if(vm.count>-3){
            vm.count--;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'original' : {
          vm.count = 0;
          vm.fontSizeChange(vm.count);
        }
          break;
      }
    }
    function fontSizeChange(val){
      var elem = document.getElementsByTagName("body")[0];
      elem.classList.add("newBigFont");
      var ele = document.getElementsByClassName('newBigFont')[0];

      switch (val) {
        case -2 : {
          ele.setAttribute("style","font-size: 70% !important");
          addSizeClass(elem,"font-small-xs");
        }
          break;
        case -1 : {
          ele.setAttribute("style","font-size: 80% !important");
          addSizeClass(elem,"font-small-s");
        }
          break;
        case 0 : {
          elem.removeAttribute('style');
          elem.classList.remove("newBigFont");
          addSizeClass(elem,"");
        }
          break;
        case 1 : {
          ele.setAttribute("style","font-size: 97% !important");
          addSizeClass(elem,"font-large-l");
        }
          break;
        case 2 : {
          ele.setAttribute("style","font-size: 110% !important");
          addSizeClass(elem,"font-large-xl");
        }
          break;
      }
    }
    var sizeClassList = ["font-small-s","font-small-xs","font-large-l","font-large-xl"];
    function addSizeClass (elem,sizeClass) {
     if(sizeClass) elem.classList.add(sizeClass);
      sizeClassList.forEach(function(item){
        if(item != sizeClass){
         elem.classList.remove(item);
        }
      });
    }

    function latestNotification() {
      var success = function (resp) {
          // LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.latestNotificationList = resp.data.notificationList;
            vm.notificationData = sortDate(resp.data.notificationList);
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          // LoaderService.hideLoader();
          //UtilService.errorHandler(err);
        };
      InvestorService.get({
        child1: 'notification',
        child2: 'latest'
      }).$promise.then(success, error);
    }

    function sortDate(arr) {
      arr.filter(function (item) {
        var date = $window.moment();
        date.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        var created = $window.moment(item.createdDate).set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        var diff = Math.abs(date.diff(created, 'days'));
        item.diff = diff;
        if(diff==0){
          date = $window.moment();
          created = $window.moment(item.createdDate);
          var end = $window.moment.utc(date, "HH:mm");
          // created = $window.moment(item.createdDate);
          var start = $window.moment.utc(created, "HH:mm");

          if (start.isBefore(end)) start.add(1, 'day');

// calculate the duration
          var d = $window.moment.duration(end.diff(start));
          vm.hourDifference = $window.moment.utc(+d).format('HH:mm');
          var mystring = vm.hourDifference.substring(0, 2);
          if(mystring == '00'){
            var mins = vm.hourDifference.slice(-2);
            if(mins.charAt(0)=='0'){
              var time = vm.hourDifference.slice(-1) + 'min ago';
            } else{
              time = vm.hourDifference.slice(-2) + 'min ago';
            }
          } else if(mystring.charAt(0)=='0'){
            time = vm.hourDifference.substring(1,2) + 'hr ago';
          } else {
            time = vm.hourDifference.substring(0,2) + 'hr ago';
          }
          item.time = time;
        } else {
          created = $window.moment(item.createdDate, 'DD/mm/YYYY');
          var date1 = $window.moment(created).format('DD/MM/YYYY');
          var time1 = $window.moment(created).format("hh:mm a");
          item.date1 = date1;
          item.time1 = time1;
        }

      });
    }

    function destroyLoginHeader() {
      var elem = document.getElementsByTagName("body")[0];
      elem.classList.remove("menu-expanded");
    }
    vm.selectedLinkPan = {};
    vm.linkedPanList = [];
    vm.getLinkedPanList = getLinkedPanList;
    vm.changeLinkedPan = changeLinkedPan;
    vm.maskLinkPan = maskLinkPan;
    getLinkedPanList();
    //getLinkedPanList
    function getLinkedPanList(){
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.linkedPanList = [];
          vm.linkedPanList =  resp.data;
          $rootScope.LinkedPAN = new Set();
          // set Mask pan and set selected pan
          for (var i = 0; i < vm.linkedPanList.length; i++) {
            vm.linkedPanList[i].maskedPan = vm.maskLinkPan(vm.linkedPanList[i].panNumber);
            if(vm.linkedPanList[i].selected){
              vm.selectedLinkPan = vm.linkedPanList[i];
            }
            $rootScope.LinkedPAN.add(vm.linkedPanList[i].panNumber);
          }
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        LoaderService.hideLoader();
      };
      LoaderService.showLoader();
      AuthService.getLinkedPanDetails().then(success, error);
    }
    function maskLinkPan(val){
      if(val == "null" || !val){
        return val="";
      }
      if(val == 'Not updated'){
        return val = val;
      }
      var endVal = val.substr(-2);
      var startVal = val.substr(0,2);
      var maskyVal = "";
      for(var i=0;i<val.length-4;i++){
        maskyVal += "*";
      }
      return startVal + maskyVal + endVal;
    }
    // changed Linked pan
    function changeLinkedPan(data){
      if(data == "Add"){
          var success1 = function (resp) {
            ModalService.genericModal({
              text: resp,
              showBlueBtn:true
            }, function() {
              $window.location.reload();
            }, function() {
              $window.location.reload();
            });
           },error1 = function () {
           };
           if( vm.linkedPanList && vm.linkedPanList.length < 6){
            ModalService.addLinkPanModal({}, success1, error1);
          }else{
            MessageService.error("Maximum 5 external accounts can be added.");
          }
      }else if(data == "ManagedAccounts"){
        $state.go('main.managed-accounts');
      }else{
        var success = function(resp) {
          if (resp.status && resp.data) {
            vm.selectedLinkPan = resp.data.selectedLinkPan;
            MessageService.success(resp.data);
            $window.location.reload();
          }else{
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        }
        var error = function(err) {
          LoaderService.hideLoader();
          MessageService.error(err.message);
        }
        LoaderService.showLoader();
        AuthService.switchAccountInLinkedPan(data).then(success, error)
      }
  }

    $scope.uiState = $state
  }

  function newInvestorHeader() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/header/new-investor-header.html',
      scope: {
        creationDate: '='
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .filter('truncateDecimal', function() {
      return function(input, decimalPlaces) {
        // Parse the input as a float
        var floatValue = parseFloat(input);

        // Check if the input is a valid number
        if (!isNaN(floatValue)) {

          var splitPart = input.toString().split('.');

          var commaSepratedPart = splitPart[0];
          var fractionalPart = splitPart[1] ? splitPart[1].slice(0, decimalPlaces): '';

          var multiplier = Math.pow(10, decimalPlaces);

          if (fractionalPart * 1 === 0) {
            fractionalPart = fractionalPart / multiplier;
          }

          if(fractionalPart) {
            var truncatedValue = commaSepratedPart + '.' + fractionalPart;
            truncatedValue = truncatedValue.replace(/(\.[0-9]*?)0+$/, '$1');
          } else {
            var truncatedValue = commaSepratedPart;
          }

          return truncatedValue.toString();
        }

        // Return the original input if it's not a valid number
        return input;
      };
    });
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .filter('number2words', number2Words);

  /** @ngInject */

  function number2Words() {

    function isInteger(x) {
      return x % 1 === 0;
    }

    return function (value) {
      if (value && isInteger(value))
        return toWords(value);

      return value;
    };
  }


  var th = ['', 'thousand', 'million', 'billion', 'trillion'];
  var dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  var tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  var tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];


  function toWords(s) {
    s = s.toString();
    s = s.replace(/[\, ]/g, '');
    if (s != parseFloat(s)) return 'not a number';
    var x = s.indexOf('.');
    if (x == -1) x = s.length;
    if (x > 15) return 'too big';
    var n = s.split('');
    var str = '';
    var sk = 0;
    var i = 0;
    for (i = 0; i < x; i++) {
      if ((x - i) % 3 == 2) {
        if (n[i] == '1') {
          str += tn[Number(n[i + 1])] + ' ';
          i++;
          sk = 1;
        }
        else if (n[i] != 0) {
          str += tw[n[i] - 2] + ' ';
          sk = 1;
        }
      }
      else if (n[i] != 0) {
        str += dg[n[i]] + ' ';
        if ((x - i) % 3 == 0) str += 'hundred ';
        sk = 1;
      }

      if ((x - i) % 3 == 1) {
        if (sk) str += th[(x - i - 1) / 3] + ' ';
        sk = 0;
      }
    }
    if (x != s.length) {
      var y = s.length;
      str += 'point ';
      for (i = x + 1; i < y; i++) str += dg[n[i]] + ' ';
    }
    return str.replace(/\s+/g, ' ');
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .filter('unit', unitFilter)
    .filter('unitValue', unitValueFilter)
    .filter('Percentage', percentage)
    .filter('frequency', frequencyFilter)
    .filter('dividendOption', dividendOptionFilter)
    .filter('schemetype', schemetypeFilter)
    .filter('investmentOption', investmentOptionFilter)
    .filter('removeCountry', removeCountryFilter)
    .filter('filterCity', filterCity)
    .filter('searchFor', searchForFilter)
    .filter('linebreak', linebreak)
    .filter('camelcase', camelcase)
    .filter('dateformatter', dateformatter)
    .filter('formatImageUrl', formatImageUrl);

  /** @ngInject */
  function unitFilter() {
    return function (input) {
      var isNegative = false;
      if(!input)
        return '0';

      if(input<0){
        input = input.toString().slice(1);
        isNegative = true;
      }

      var value = input.toString().split('.');
      var x = value[0],decimal ='', finalStr = '';

      if(value.length > 1){
        decimal = value[1].substring(0, 3);
      }
      var lastThree = x.substring(x.length-3);
      var otherNumbers = x.substring(0,x.length-3);

      if(otherNumbers != '')
        lastThree = ',' + lastThree;

      var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

      if(value.length > 1){
        finalStr = res+'.'+decimal;
      } else {
        finalStr = res;
      }
      return isNegative?"-"+finalStr:finalStr ;
    }
  }

  function searchForFilter() {
    return function (arr, searchString) {
      if (!searchString) {
        return arr;
      }
      var result = [];
      searchString = searchString.toLowerCase();
      // Using the forEach helper method to loop through the array
      angular.forEach(arr, function (item) {
        if (item.scheme.toLowerCase().indexOf(searchString) !== -1) {
          result.push(item);
        }
      });
      return result;
    };
  }

  /** @ngInject */
  function unitValueFilter() {
    return function () {
      return '';
      /*if (input === 'K') {
        return '';
      }
      return input;*/
    }
  }

  /** @ngInject */

  function percentage($filter) {
    return function (input, decimals) {
      return $filter('number')(input * 100, decimals) + '%';
    };
  }

  /** @ngInject */
  function frequencyFilter() {
    return function (input) {
      switch (input) {
        case 'D':
        case 'DZ':
          return 'Daily';
        case 'OW':
          return 'Weekly';
        case 'OM':
          return 'Monthly';
        case 'Q':
          return 'Quaterly';
        case 'H':
          return 'Half yearly';
        case 'Y':
          return 'Yearly';
        default :
          return input;
      }
    }
  }

  /** @ngInject */
  function dividendOptionFilter() {
    return function (input) {
      switch (input) {
        case 'Y':
          return 'Re-invest';
        case 'N':
          return 'Payout';
        default :
          return 'N/A';
      }
    }
  }

  /** @ngInject */
  function investmentOptionFilter() {
    return function (input) {
      switch (input) {
        case 'GROWTH':
          return 'Growth';
        case 'DIVIDEND':
          return 'Dividend';
        default :
          return input;
      }
    }
  }

  /** @ngInject */
  function schemetypeFilter() {
    return function (input) {
      switch (input) {
        case 'F':
          return 'Fixed Amount';
        case 'V':
          return 'Capital Appreciation';
        default :
          return input;
      }
    }
  }

  /** @ngInject */
  function removeCountryFilter() {
    return function (input, country) {
      var _result = null;
      if (input && angular.isArray(input)) {
        _result = input.filter(function (item) {
          return item.countryName.toLowerCase() !== country.toLowerCase();
        })
      } else {
        _result = input;
      }
      return _result;
    }
  }

  /** @ngInject */
  function filterCity() {
    return function (input, city) {
      var _result = null;
      if (input && angular.isArray(input)) {
        _result = input.filter(function (item) {
          return item.cityName.toLowerCase().indexOf(city.toLowerCase()) !== -1;
        })
      } else {
        _result = input;
      }
      return _result;
    }
  }

  /** @ngInject */
  function linebreak() {
    return function(data,sepNumber) {
      sepNumber = sepNumber?parseInt(sepNumber):0;
      if (!data || data.split(" ").length <= sepNumber){
        return data;
      }else{
        var textArr = data.split(" ");
        if(textArr.length>sepNumber){
          var text=[];
          for(var i=0;i<=textArr.length;i= i + sepNumber){
            text.push(textArr.slice(i,i+sepNumber).join(" "));
          }
          return text.join(" <br/> ");
        }else{return data;}
      }
    };
  }

  /** @ngInject */
  function camelcase() {
    return function(input) {
      input = input || '';
      return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    };
  }

  /** @ngInject */
  function dateformatter($window) {
    return function(date, format) {
      if(!$window.moment) {
        console.log('Error: momentJS is not loaded as a global');
        return '!momentJS';
      }
      $window.moment.locale('de');
      if(!format) {
        return $window.moment(date, 'DD-MMM-YYYY').fromNow();
      } else {
        return $window.moment(date, "DD-MMM-YYYY").format(format);
      }
    };
  }

  /** @ngInject */

    function formatImageUrl() {
      return function (input) {
        return input ? input.split(' ').join('-').toLowerCase() : '';
      };
    }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('termsCondition', commonFactory);

  /** @ngInject */
  function commonFactory(UtilService) {
    var factory = {};
    var key = null;
      factory.fetchData = function (transactionType) {
            switch (transactionType) {
                   case 'PURCHASE':
                     key = "TNC_Review_Purchase_Investment"
                     return UtilService.fetchDynamicData("PURCHASE_REVIEW")
                     break;
                   case 'SIP':
                      key = "TNC_SIP_Review_Registration"
                      return UtilService.fetchDynamicData("SIP_REVIEW")
                      break;
                   case 'SWITCH':
                      key = "TNC_Review_Transaction_Switch"
                      return UtilService.fetchDynamicData("SWITCH_REVIEW")
                      break;
                   case 'REDEMPTION':
                      key = "TNC_Review_transaction_Redemption"
                      return UtilService.fetchDynamicData("REDEMPTION_REVIEW")
                      break;
                   case 'STP':
                      key = "TNC_Review_STP"
                      return UtilService.fetchDynamicData("STP_REVIEW")
                      break;
                   case 'FLEX_INDEX':
                      key = "TNC_Review_FLEXINDEX"
                      return UtilService.fetchDynamicData("FLEXINDEX_REVIEW")
                      break;
                   case 'SWP':
                      key = "TNC_Review_SWAP"
                      return UtilService.fetchDynamicData("SWAP_REVIEW")
                      break;
                   case 'DTP':
                      key = "TNC_Review_TIP"
                      return UtilService.fetchDynamicData("TIP_REVIEW");
                      break;
                   case 'SMART_SWAP':
                      key = "TNC_Smart_Swap"
                      return UtilService.fetchDynamicData("SMARTSWAP_REVIEW")
                      break;
                   case 'SIP-E-MANDATE':
                      key = "TNC_SIP_Review_Registration_eOTM"
                      return UtilService.fetchDynamicData("SIP_REVIEW");
                      break;
                   case 'Flex_STP':
                       key = "TNC_FLEXSTP"
                       return UtilService.fetchDynamicData("FLEXSTP_REVIEW")
                       break;
                   case 'FLEX_SIP':
                       key = "TNC_FLEX_SIP_Review_Registration"
                       return UtilService.fetchDynamicData("FLEX_SIP_REVIEW")
                       break;
                   default:
                      console.log("not found");
                  }
      };
    return factory;
  }

})();

/**
 * Created by ttn on 6/12/16.
 */

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('ProfileFactory', profileFactory);

  /** @ngInject */
  function profileFactory() {
    var factory = {};
    var profileData = {};

    factory.set = function (data) {
      profileData = data;
    };
    factory.get = function () {
      return profileData;
    };

    factory.reset = function () {
      profileData = {};
    };

    return factory;
  }


})();

/**
 * Created by ttn on 6/12/16.
 */

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('CreatePayloadFactory', createPayloadFactory);

  /** @ngInject */
  function createPayloadFactory() {
    var factory = {};
    var payload = {},
        isvalidOTP = false;
    factory.set = function (data) {
      payload = data;
    };
    factory.get = function () {
      return payload;
    };
    factory.reset = function () {
      payload = {};
    };
    factory.setOTP = function (data) {
      isvalidOTP = data;
    };
    factory.getOTP = function () {
      var tempOTP = isvalidOTP;
      isvalidOTP = false;
      return tempOTP;
    };

    return factory;
  }


})();

/**
 * Created by ttn on 6/12/16.
 */

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('CommonFactory', commonFactory);

  /** @ngInject */
  function commonFactory() {
    var factory = {};
    var sessionExpired = false;
    var loggedOutSuccess = false;

    factory.setSessionExpired = function () {
      sessionExpired = true;
    };

    factory.setLogoutSuccess = function() {
      loggedOutSuccess = true;
    };

    factory.resetSessionExpired = function () {
      sessionExpired = false;
    };

    factory.resetLogoutSuccess = function() {
      loggedOutSuccess = true;
    };

    factory.getSessionExpired = function () {
      var temp = sessionExpired;
      factory.resetSessionExpired();
      return temp;
    };

    factory.getLogoutAction = function() {
      factory.resetLogoutSuccess();
      return loggedOutSuccess;
    };

    return factory;
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('tooltip', tooltip);

  /** @ngInject */
  function tooltip() {
    return {
      restrict: 'A',
      link: function(scope, element){
        $(element).hover(function(){
          // on mouseenter
          $(element).tooltip('show');
        }, function(){
          // on mouseleave
          $(element).tooltip('hide');
        });
      }
    };
  }

})();

(function () {
  'use strict';
  angular
      .module('hdfc-mf-investor-web')
      .directive('stopcopypaste', stopcopypaste);

  /** @ngInject */
  function stopcopypaste() {
    return {
      restrict: 'A',
      link : function(scope,element) {
        element.on('copy paste', function (event) {
          event.preventDefault();
        });
      }
    };
  }

})();
(function () {
  'use strict';
  angular
      .module('hdfc-mf-investor-web')
      .directive('restrictSpecialCharcter', restrictSpecialCharcter);

  /** @ngInject */
  function restrictSpecialCharcter() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          var transformedInput = text.replace(/[^A-Za-z0-9]/g, '');

          if(transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('removeSpace', removeSpace);

  /** @ngInject */
  function removeSpace() {
    return {
      restrict: 'A',
      link : function(scope,element) {
        var name = scope.data.goalCategory === 'MY_NEST' ? 'my nest' : scope.data.goalName;
        var updatedValue = scope.data.goalCategory.toLowerCase();
        element.addClass(updatedValue);
      }
    };
  }

})();

(function () {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .directive('percentage', percentage);

    /** @ngInject */
    function percentage() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                var capitalize = function(inputValue) {
                    if (inputValue == undefined) inputValue = '';
                    var capitalized = inputValue + '%';
                    if (capitalized !== inputValue) {
                        modelCtrl.$setViewValue(capitalized);
                        //modelCtrl.$render();
                    }
                    return capitalized;
                }
                modelCtrl.$parsers.push(capitalize);
                capitalize(scope[attrs.ngModel]); // capitalize initial value
            }
        };
    }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('checkStrength', checkStrength);

  /** @ngInject */
  function checkStrength() {
    return {
      replace: false,
      restrict: 'EACM',
      link: function (scope, iElement, iAttrs) {
        var strength = {
          colors: ['#F00', '#F90', '#FF0', '#46a040'],

          mesureStrength: function (p) {
            if (p) {
              var _force = 0;
              var _regex = /^(?=.*[@#$%_!])/g;

              var _lowerLetters = /[a-z]+/.test(p);
              var _upperLetters = /[A-Z]+/.test(p);
              var _numbers = /[0-9]+/.test(p);
              var _symbols = _regex.test(p);

              var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];

              for (var i = 0; i < _flags.length; i++) {
                if (_flags[i]) {
                  _force++;
                }
              }

              return _force*10;

            }
          },
          getColor: function (s) {
            var idx = 0;
            if (s <= 10) {
              idx = 0;
            }
            else if (s <= 20) {
              idx = 1;
            }
            else if (s <= 30) {
              idx = 2;
            }
            else if (s <= 40) {
              idx = 3;
            }
            else {
              idx = 4;
            }

            return {idx: idx + 1, col: this.colors[idx]};

          }
        };

        scope.$watch(iAttrs.checkStrength, function () {
          if (!scope.pw) {
            iElement.css({"display": "none"});
          } else {
            var c = strength.getColor(strength.mesureStrength(scope.pw));
            iElement.css({"display": "block"});
            iElement.children('li')
              .css({"background": "#DDD"})
              .slice(0, c.idx)
              .css({"background": c.col});
          }
        });

      },
      template: '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>'
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('onlyAlphabets', onlyAlphabets);

  /** @ngInject */
  function onlyAlphabets() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function (scope, element, attrs, ngModel) {
        if (!ngModel) {
          return;
        }
        ngModel.$parsers.unshift(function (inputValue) {
          var alphabets = inputValue.split('').filter(function (s) {
            return (isALetter(s));
          }).join('');
          ngModel.$viewValue = alphabets;
          ngModel.$render();
          return alphabets;
        });
      }
    };

    function isALetter(charVal)
    {
      if( (charVal.toUpperCase() != charVal.toLowerCase()) || charVal === ' ' ) {
        return true;
      }
      else {
        return false;
      }
    }
  }

})();

/**
 * Created by ttn on 14/06/21.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('listDropDown', listDropDownDirective);

  /** @ngInject */
  function listDropDownDirective($timeout) {
    return {
      restrict: 'EA',
      template: '<div class="suggestion box-shadow"  ng-keydown="handleKeyPress($event)"><ul id="list" ng-if="listData !== null || listData.length > 0">' +
        '<li ng-repeat="_data in listData track by $index" ng-click="selectData(_data)">' +
        '<span>{{_data[displayKey]}}</span> - <span>{{_data[displayKeySecond]}}</li>' +
        '</ul><ul ng-if="listData === null || listData.length ===0"><li>No Euin Available</li></ul></div>',
      scope: {listData: '=', hdfcClick: '&', for: '@', displayKey: '@', model: '=', displayKeySecond: '@'},
      link: function (scope, element) {
        var _isSelectedData = false;
        var forEle = angular.element("#" + scope.for);
        var isNewData = function (listData) {
          var flag = false;
          if (angular.isArray(listData) && listData.length) {
            var _text = forEle.val();
            listData.forEach(function (item) {
              if (item[scope.displayKey].indexOf(_text) === -1) {
                flag = true;
              }
            });
          }

          return flag;
        };

        var active_id = '0';
        var Element = document.getElementById(active_id);
        if(Element) Element.focus();
        scope.handleKeyPress = function(Key) {
          var old_id = active_id;
          switch (Key.keyCode) {
            case 40:
              active_id++;
              break;
            case 38:
              active_id--;
              break;
          }
          if(active_id < 0) active_id = scope.listData.length-1;
          if(active_id > scope.listData.length-1) active_id = 0;
          document.getElementById(old_id).blur();
          document.getElementById(active_id).focus();
        }

        scope.selectData = function (data) {
          _isSelectedData = true;
          scope.model = data;
          scope.hdfcClick({data: data});
          if(_isSelectedData){
            _isSelectedData = false;
            element.hide();
          }
        };

        element.hide();

        forEle.click(function () {
          element.show();
        });

        forEle.focus(function() {
          element.show();
        })

        forEle.blur(function () {
          $timeout(function () {
            if (!_isSelectedData || !scope.model) {
              scope.hdfcClick({data: null});
            }
            if(!_isSelectedData){
              _isSelectedData = false;
              element.hide();
            }
          }, 500);
        });

        scope.$watch(function () {
          return scope.listData;
        }, function (newValue, oldValue) {
          if (!angular.equals(newValue, oldValue) && isNewData(newValue)) {
            _isSelectedData = false;
          }
        });
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('limitTo', limitTo);

  /** @ngInject */
  function limitTo() {
    return {
      restrict: "A",
      link: function (scope, elem, attrs) {
        var limit = parseInt(attrs.limitTo);
        angular.element(elem).on("keypress", function (e) {
          if (this.value.length == limit) e.preventDefault();
        });
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('isNumber', isNumber);

  /** @ngInject */
  function isNumber() {
    return {
      require: 'ngModel',
      link: function (scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          if (text) {
            var transformedInput = text.replace(/[^0-9]/g, '');

            if (transformedInput !== text) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            return transformedInput;
          }
          return false;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive("directive.mask", mask);

  /** @ngInject */
  function mask($compile) {
    var expose = {};
    expose.require = "ngModel";
    expose.restrict = "A";

    expose.link = function (scope, element, attributes, controller) {

      var maskedInputElement;

      var maskValue = function (value) {
        // replace all characters with the mask character
        return (value || "").replace(/[\S]/g, "\u2022");
      };

      var createMaskedInputElement = function () {
        if (!maskedInputElement || !maskedInputElement.length) {
          maskedInputElement = element.clone(true);
          maskedInputElement.attr("type", "password"); // ensure the value is masked
          maskedInputElement.removeAttr("name"); // ensure the password save prompt won't show
          maskedInputElement.attr("ng-model");
          maskedInputElement.removeAttr("directive.mask"); // ensure an infinite loop of clones isn't created
          maskedInputElement.bind("blur", function () {
            element.removeClass("ng-hide");
            maskedInputElement.remove();
            maskedInputElement = null;
          });
          $compile(maskedInputElement)(scope);
          element.after(maskedInputElement);
        }
      };

      element.bind("focus", function () {
        createMaskedInputElement();
        element.addClass("ng-hide");
        maskedInputElement[0].focus();
        scope.modelDirty = true;
        controller.modelDirty = true;
      });

      controller.$formatters.push(function (value) {
        // ensure the displayed value is still masked when the clone is hidden
        return maskValue(value);
      });

    };

    return expose;
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('ignoreMouseWheel', ignoreMouseWheel);

  /** @ngInject */
  function ignoreMouseWheel($window) {
    return {
      restrict: 'A',
      link: function( scope, element ){
        element.bind('wheel', function () {
          element.blur();
        });
        element.bind('keydown', function (evt) {
          evt = (evt) ? evt : $window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105) && charCode !== 190 && charCode !==110) {
            return false;
          }
          if(evt.shiftKey && ((charCode >= 48 && charCode <= 57) || (charCode > 96 && charCode < 105))){
            return false;
          }
          return true;
        });
      }
    }
  }


})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('httpSrc', httpSrc);

  /** @ngInject */
  function httpSrc($http) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var defaultProfile = false;
        if (attrs.httpSrc.includes("assets")) {
          defaultProfile = true;
        } else {
          defaultProfile = false;
        }
        var requestConfig = {
          method: 'Get',
          url: attrs.httpSrc,
          responseType: 'arraybuffer',
          cache: 'true'
        };
        if (!defaultProfile) {
          $http(requestConfig)
            .then(function(response) {
              var arr = new Uint8Array(response.data);
              var raw = '';
              var i, j, subArray, chunk = 5000;
              for (i = 0, j = arr.length; i < j; i += chunk) {
                subArray = arr.subarray(i, i + chunk);
                raw += String.fromCharCode.apply(null, subArray);
              }
              var b64 = raw.replace(/^"(.*)"$/, '$1');
              attrs.$set('src', "data:image/jpeg;base64," + b64);
            });
        } else {
          attrs.$set('src', attrs.httpSrc);
        }
      }
    };
  }

  /*function link(scope, element, attrs) {
    var requestConfig = {
      method: 'Get',
      url: attrs.httpSrc,
      responseType: 'arraybuffer',
      cache: 'true'
    };

    $http(requestConfig)
      .then(function(response) {
        var arr = new Uint8Array(response.data);
        var raw = '';
        var i, j, subArray, chunk = 5000;
        for (i = 0, j = arr.length; i < j; i += chunk) {
          subArray = arr.subarray(i, i + chunk);
          raw += String.fromCharCode.apply(null, subArray);
        }
        var b64 = btoa(raw);
        attrs.$set('src', "data:image/jpeg;base64," + b64);
      });
  }*/

  /*app.directive('httpSrc', [
    '$http', function ($http) {
      var directive = {
        link: link,
        restrict: 'A'
      };
      return directive;

      function link(scope, element, attrs) {
        var requestConfig = {
          method: 'Get',
          url: attrs.httpSrc,
          responseType: 'arraybuffer',
          cache: 'true'
        };

        $http(requestConfig)
          .then(function(response) {
            var arr = new Uint8Array(response.data);
            var raw = '';
            var i, j, subArray, chunk = 5000;
            for (i = 0, j = arr.length; i < j; i += chunk) {
              subArray = arr.subarray(i, i + chunk);
              raw += String.fromCharCode.apply(null, subArray);
            }
            var b64 = btoa(raw);
            attrs.$set('src', "data:image/jpeg;base64," + b64);
          });
      }

    }
  ]);*/

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('gridsterDynamicHeight', gridsterDynamicHeight);

  /** @ngInject */
  gridsterDynamicHeight.$inject = [];
  function gridsterDynamicHeight() {
    var directive = {
      scope: {
        item: "=" //gridster item
      },
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element) {

      scope.$watch(function() {

          return element[0].scrollHeight;
        },
        function(newVal) {

          var rowHeightOption = 200; // Change this value with your own rowHeight option
          var height = rowHeightOption * scope.item.sizeY;
          if(newVal > height){

            var div = Math.floor(newVal / rowHeightOption);
            div++;
            scope.item.sizeY = div;
          }
        });
    }
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('fileModelProfile', fileUploadProfileDirective);

  /** @ngInject */
  function fileUploadProfileDirective($window){
    return {
      restrict: 'A',
        scope:{upload:'&',canvasattr: '&'},
      link: function(scope, element, attr) {
        element.bind('change', function(){
          if(attr.serial){
            scope.upload( {file:element[0].files[0],serial:attr.serial});
          }else {
            if (element[0].files[0].type == 'image/jpeg') {
              var canvas = $window.document.createElement('canvas');
              canvas.style.visibility = 'hidden';
              var img = new Image();
              var reader = new FileReader();
              reader.onload = function (e) {
                img.src = e.target.result;
                img.onload = function () {
                  canvas.width = this.width;
                  canvas.height = this.height;
                  canvas.getContext('2d').drawImage(img, 0, 0);
                  canvas.toBlob(function (blob) {
                    var file = new File([blob], element[0].files[0].name, {
                      type: element[0].files[0].type,
                      lastModified: element[0].files[0].lastModifiedDate
                    });
                    scope.upload({file: file});
                  }, element[0].files[0].type, 0.2);
                };
              };
              reader.readAsDataURL(element[0].files[0]);
            }
            else{
              scope.upload( {file:element[0].files[0]});
            }
          }
        });
      }
    };
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('fileModel', fileUploadDirective);

  /** @ngInject */
  function fileUploadDirective($parse,$window){
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var model = $parse(attrs.fileModel);
        var modelSetter = model.assign;

        element.bind('change', function(){
          scope.$apply(function(){
            modelSetter(scope, element[0].files[0]);
              var reader = new FileReader();
              reader.onload = function (e) {
                if(attrs.targetimg){
                  $window.jQuery('#'+attrs.targetimg).attr('src', e.target.result)
                      .width(250)
                      .height(190);
                }
              };
              reader.readAsDataURL(element[0].files[0]);
          });
        });
      }
    };
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('dropDown', fileUploadProfileDirective);

  /** @ngInject */
  function fileUploadProfileDirective($timeout) {
    return {
      restrict: 'EA',
      template: '<div ng-if="listData.length" class="suggestion box-shadow"  ng-keyup="handleKeyPress($event)"><ul id="list"><li ng-repeat="_data in listData' +
      ' track by $index" href="" id={{$index}}  ng-click="selectData(_data)" class="scheme-drop-list" ng-class="{\'anything-disabled\': isFromJanNivesh && isNewUser && _data.investmentOption !== \'GROWTH\'}"> {{_data[displayKey]}}{{displayKeySecond?   " -   "+_data[displayKeySecond]:""}}</li></ul></div>',
      scope: {listData: '=', hdfcClick: '&', for: '@', displayKey: '@', model: '=', displayKeySecond: '@', isFromJanNivesh:'=', isNewUser: '='},
      link: function (scope, element, $window) {

        var _isSelectedData = false;
        scope.isTabClicked = false;
        var previous = '';
        var forEle = angular.element("#" + scope.for);
        var isNewData = function (listData) {
          var flag = false;
          if (angular.isArray(listData) && listData.length) {
            var _text = forEle.val();
            listData.forEach(function (item) {
              if (item[scope.displayKey].indexOf(_text) === -1) {
                flag = true;
              }
            });
          }

          return flag;
        };

        var active_id = 0;
        var old_id = 0;
        var Element = document.getElementById(active_id);
        if(Element) Element.focus();
        scope.handleKeyPress = function(Key) {
          var old_id = active_id;
          switch (Key.keyCode) {
            case 40:
              active_id++;
              break;
            case 9:
              active_id++;
              scope.isTabClicked = true;
              break;
            case 38:
              active_id--;
              break;
          }
          if(active_id < 0) active_id = scope.listData.length;
          if(active_id > scope.listData.length) active_id = 0;
          if(document.getElementById(old_id)) {
            document.getElementById(old_id).blur();
          }
          if(active_id > 0) {
            document.getElementById(active_id - 1).focus();
          }
        }

        scope.selectData = function (data) {
          _isSelectedData = true;
          // scope.model = data;
          scope.hdfcClick({data: data});
          if(_isSelectedData){
            _isSelectedData = false;
            element.hide();
          }
        };

        element.hide();

        forEle.on('click', function (e) {
          if (e.target.tagName == 'INPUT') {
            e.stopPropagation();
            element.show();
            active_id = 0;
            old_id = 0;
            previous = e.target.name;
          }
        });



        forEle.focus(function() {
          element.show();
          scope.isTabClicked = false;
        })

        $(document).on('click', function (e) {
          if(e.target.name !== previous){
            scope.isTabClicked = false;
            element.hide();
            previous = '';
          }
        });

        forEle.blur(function () {
          $timeout(function () {
            if (!_isSelectedData || !scope.model) {
              scope.hdfcClick({data: null});
            }
            if(!_isSelectedData){
              if(!scope.isTabClicked) {
                _isSelectedData = false;
                element.hide();
              }
            }
            scope.isTabClicked = false;
          }, 500);
        });



        scope.$watch(function () {
          return scope.listData;
        }, function (newValue, oldValue) {
          if (!angular.equals(newValue, oldValue) && isNewData(newValue)) {
            _isSelectedData = false;
          }
        });
      }
    };
  }

})();

/**
 * Created by ttn on 15/04/24.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('disableRightClick', disableRightClick);

  /** @ngInject */
  function disableRightClick() {
    return {
      restrict: "A",
      link: function (scope, elem) {
        angular.element(elem).on("contextmenu", function (e) {
          e.preventDefault();
        });
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('dateRange', dateRangePicker)
    .directive('dateCalendar', dateCalendarPicker);

  /** @ngInject */
  function dateRangePicker($timeout) {
    return {
      scope: {dateDefault: '=', onDateChange: '='},
      restrict: 'EA',
      link: function (scope, element) {
        var opts = {
          locale: {
            fromLabel: 'Od', toLabel: 'Do', separator: ' -> ', format: 'DD-MMM-YYYY'
          },
          autoApply: true,
          autoUpdateInput: true,
          maxDate: new Date(),
          minDate: new Date('01/01/1900'),
          showDropdowns:true,
          linkedCalendars: false
        };
        var isApplied = false;

        if (scope.dateDefault && scope.dateDefault.startDate && scope.dateDefault.endDate) {
          opts.startDate = scope.dateDefault.startDate;
          opts.endDate = scope.dateDefault.endDate;
          element.daterangepicker(opts);
        } else {
          element.daterangepicker(opts);
          element.val('');
        }

        element.on('apply.daterangepicker', function (ev, picker) {
          var _date = {
            startDate: picker.startDate,
            endDate: picker.endDate
          };
          scope.onDateChange(_date);
          isApplied = true;
        });

        element.on('show.daterangepicker', function () {
          angular.element('.input-mini.form-control').attr('readonly',true);
        });

        element.on('hide.daterangepicker', function (ev, picker) {
          $timeout(function () {
            if (!isApplied && !scope.dateDefault.startDate && !scope.dateDefault.endDate) {
              picker.setEndDate(new Date());
              picker.setStartDate(new Date());
              picker.oldStartDate = null;
              picker.oldEndDate = null;
              isApplied = false;
              element.val('');
            }
          }, 0);
        });

        scope.$watch(function () {
          return scope.dateDefault
        }, function () {
          if (!scope.dateDefault || !scope.dateDefault.startDate || !scope.dateDefault.endDate) {
            var picker = element.data('daterangepicker');
            picker.setEndDate(new Date());
            picker.setStartDate(new Date());
            picker.oldStartDate = null;
            picker.oldEndDate = null;
            element.val('');
            isApplied = false;
          }
        }, true);
      }
    };
  }

  /** @ngInject */
  function dateCalendarPicker($timeout, moment, $log, UtilService) {
    return {
      scope: {maxDate: '=', viewDate: '=', minDate: '=', dateDefault: '=', enable: '=',
        enabledDates: '=', onDateChange: '=',  daysOfWeekDisabled: '=',  focusOn : '@', dateMode: '@'},
      restrict: 'EA',
      link: function (scope, element, attr) {
        var options = {
            // inline: true,
            format: 'DD-MMM-YYYY',
            useCurrent: false,
            viewMode: scope.dateMode === 'year-month' ? 'years' : 'months',
            ignoreReadonly: true,
            defaultDate: '',
            minDate: new Date('01/01/1900'),
            viewDate: new Date()
          },
          isDateSent = false;
        if (attr.format) {
          options.format = attr.format;
        }
        if (attr.viewmode || scope.viewMode) {
          options.viewMode = attr.viewmode;
        }
        if (attr.maxdate || scope.maxDate) {
          options.maxDate = scope.maxDate || attr.maxdate;
        }

        if (scope.minDate) {
          options.minDate = scope.minDate;
        }
        if (scope.viewDate) {
          options.viewDate = scope.viewDate;
        }

        var updateView = function () {
          scope.dateDefault = scope.dateDefault || null;
          if (scope.dateDefault && attr.showdefault == 'true') {
            element.data('DateTimePicker').defaultDate(moment(scope.dateDefault));
          } else {
          element.data('DateTimePicker').date(scope.dateDefault);
            //element.data('DateTimePicker').date(); // now we dont need any date to be auto selected
          }

          if (scope.enabledDates) {
            element.data('DateTimePicker').enabledDates(scope.enabledDates);
          }

          if (scope.daysOfWeekDisabled) {

            if (!(scope.daysOfWeekDisabled instanceof Array)) {
              throw new TypeError('daysOfWeekDisabled() expects an array parameter');
            }
            element.data('DateTimePicker').daysOfWeekDisabled(scope.daysOfWeekDisabled);
          }

          if (scope.dateDefault && (scope.enabledDates || attr.showdefault == 'true')) {
            element.data('DateTimePicker').enable();
          }

          if (scope.enable == true) {
            element.data('DateTimePicker').enable();
          }
          if(scope.focusOn && scope.focusOn === UtilService.currentFocusedElement.get()) {
            angular.element('.' + scope.focusOn).focus();
          }
          if (scope.minDate) {
            element.data('DateTimePicker').minDate(scope.minDate);
          }
          if (scope.maxDate) {
            element.data('DateTimePicker').maxDate(scope.maxDate);
          }
          if (scope.viewDate) {
            element.data('DateTimePicker').viewDate(scope.viewDate);
          }
        }

        // Function to get all unique enabled years from scope.enabledDates
        function getEnabledYears() {
          // Extract unique years from scope.enabledDates
          var clonedDates = angular.copy(scope.enabledDates);
          var years = clonedDates.map(function (date) {
            return moment(date).clone().year();
          });

          // Remove duplicates manually
          var uniqueYears = [];
          years.forEach(function (year) {
            if (uniqueYears.indexOf(year) === -1) {
              uniqueYears.push(year);
            }
          });

          return uniqueYears;
        }

        // Function to update enabled years based on persistent enabledYears array
        function updateEnabledYears() {
          var enabledYears = getEnabledYears();
          element.find('.year').each(function (index, yearButton) {
            var year = parseInt($(yearButton).text(), 10);
            if (enabledYears.includes(year)) {
              $(yearButton).removeClass('disabled');
            } else {
              $(yearButton).addClass('disabled');
            }
          });
        }

        // Function to get enabled months for a specific year
        function getEnabledMonthsForYear(year) {
          var enabledMonths = angular.copy(scope.enabledDates)
            .filter(function (date) {
              return moment(date).clone().year() === year;
            })
            .map(function (date) {
              return moment(date).month(); // Extract month as integer (0 = January, 11 = December)
            });
          // Manually filter out duplicates
          return enabledMonths.filter(function (month, index) {
            return enabledMonths.indexOf(month) === index;
          });
        }

        // Function to update enabled months based on the selected year
        function updateEnabledMonths() {
          var datePicker = element.data('DateTimePicker');
          if (datePicker.viewMode() === 'years') {
            var enabledMonths = [];
            var selectedYear = datePicker.viewDate() ? datePicker.viewDate().year() : moment().year();
            enabledMonths = getEnabledMonthsForYear(selectedYear);

            // Update month buttons once
            var $months = element.find('.month');
            $months.each(function (index, monthButton) {
              if (enabledMonths.includes(index)) {
                $(monthButton).removeClass('disabled');
              } else {
                $(monthButton).addClass('disabled');
              }
            });
            updateEnabledYears();
          }
        }

        // Listener for when the date picker view changes (e.g., year clicked, navigation)
        element.on('dp.update', function () {
          var datePicker = element.data('DateTimePicker');
          if (datePicker && scope.dateMode === 'year-month' && datePicker.viewMode() === 'years') {
            updateEnabledMonths();
          }
        });

        element.datetimepicker(options);
        updateView();
        element.on('dp.change', function (e) {
          if (isDateSent) {
            return;
          }
          isDateSent = true;
          if(e.date && scope.dateMode === 'year-month') {
            e.date.startOf('month');
          }
          scope.onDateChange(e.date);
          $timeout(function () {
            isDateSent = false;
          }, 0);
        });

        element.on('dp.hide', function () {
          element.removeClass('currentdatepicker');
          element.removeClass('high-index');
          isDateSent = true;
          $timeout(function () {
            if (element.data('DateTimePicker')) {
              element.data('DateTimePicker').destroy();
            }
            element.datetimepicker(options);
            updateView();
            isDateSent = false;
          }, 0);
        });

        element.on('dp.show', function () {
          element.addClass('currentdatepicker');
          element.addClass('high-index');
          if (!scope.dateDefault && !scope.enable) {
            element.data('DateTimePicker').disable();
          } else {
            element.data('DateTimePicker').enable();
          }
          if(scope.enabledDates && scope.enabledDates.length > 0 && scope.dateMode == 'year-month') {
            updateEnabledYears();
          }
        });

        scope.$watch(function () {
          return scope.dateDefault
        }, function () {
          updateView()
        }, false);

        scope.$watch(function () {
          return scope.enabledDates
        }, function () {
          updateView()
        }, false);

        scope.$watch(function () {
          return scope.enable
        }, function () {
          updateView()
        }, false);

        scope.$watch(function () {
          return scope.minDate
        }, function () {
          updateView()
        }, false);

        scope.$watch(function () {
          return scope.maxDate
        }, function () {
          updateView()
        }, false);

        scope.$watch(function () {
          return scope.viewDate
        }, function () {
          updateView()
        }, false);
      }
    };
  }
})();

/*
* Directive for dynamic content , makes angular directives work
*/
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('dynamic', function($compile) {
      return {
        restrict: 'A',
        replace: true,
        link: function (scope, element, attrs) {
          scope.$watch(attrs.dynamic, function(html) {
            $compile(element.html(html).contents())(scope);
          });
        }
      };
    })
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('capitalize', capitalize);

  /** @ngInject */
  function capitalize() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
        var capitalize = function(inputValue) {
          if (inputValue == undefined) inputValue = '';
          var capitalized = inputValue.toUpperCase();
          if (capitalized !== inputValue) {
            modelCtrl.$setViewValue(capitalized);
            modelCtrl.$render();
          }
          return capitalized;
        }
        modelCtrl.$parsers.push(capitalize);
        capitalize(scope[attrs.ngModel]);
      }
    };
  }

})();

/**
 * Created by ttn on 19/01/21.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('bankDropDown', bankDropDownDirective);

  /** @ngInject */
  function bankDropDownDirective($timeout) {
    return {
      restrict: 'EA',
      template: '<div class="suggestion box-shadow"  ng-keydown="handleKeyPress($event)"><ul id="list" ng-if="listData !== null || listData.length > 0">' +
        '<li ng-repeat="_data in listData track by $index" ng-click="selectData(_data)">' +
        '<span>{{_data[displayKey]}}</span> - <span easyassist-key="mask-element-2">{{_data[displayKeySecond]}}</li>' +
        '</ul><ul ng-if="listData === null || listData.length ===0"><li>No Bank Available</li></ul></div>',
      scope: {listData: '=', hdfcClick: '&', for: '@', displayKey: '@', model: '=', displayKeySecond: '@'},
      link: function (scope, element) {
        var _isSelectedData = false;
        var forEle = angular.element("#" + scope.for);
        var isNewData = function (listData) {
          var flag = false;
          if (angular.isArray(listData) && listData.length) {
            var _text = forEle.val();
            listData.forEach(function (item) {
              if (item[scope.displayKey].indexOf(_text) === -1) {
                flag = true;
              }
            });
          }

          return flag;
        };

        var active_id = '0';
        var Element = document.getElementById(active_id);
        if(Element) Element.focus();
        scope.handleKeyPress = function(Key) {
          var old_id = active_id;
          switch (Key.keyCode) {
            case 40:
              active_id++;
              break;
            case 38:
              active_id--;
              break;
          }
          if(active_id < 0) active_id = scope.listData.length-1;
          if(active_id > scope.listData.length-1) active_id = 0;
          document.getElementById(old_id).blur();
          document.getElementById(active_id).focus();
        }

        scope.selectData = function (data) {
          _isSelectedData = true;
          scope.model = data;
          scope.hdfcClick();
          if(_isSelectedData){
            _isSelectedData = false;
            element.hide();
          }
        };

        element.hide();

        forEle.click(function () {
          element.show();
        });

        forEle.focus(function() {
          element.show();
        })

        forEle.blur(function () {
          $timeout(function () {
            if (!_isSelectedData || !scope.model) {
              scope.hdfcClick({data: null});
            }
            if(!_isSelectedData){
              _isSelectedData = false;
              element.hide();
            }
          }, 500);
        });

        scope.$watch(function () {
          return scope.listData;
        }, function (newValue, oldValue) {
          if (!angular.equals(newValue, oldValue) && isNewData(newValue)) {
            _isSelectedData = false;
          }
        });
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('autofocus', autofocus)
    .directive('selectOnClick', selectOnClick)
    .directive('blurOnClick', blurOnClick);

  /** @ngInject */
  function autofocus($timeout) {
    return {
      restrict: 'A',
      link : function($scope, $element) {
        $timeout(function() {
          $element[0].focus();
        });
      }
    };
  }

  /** @ngInject */
  function selectOnClick() {
    return {
      restrict: 'A',
      link: function (scope, element) {
        var focusedElement;
        element.on('click', function () {
          if (focusedElement != this) {
            this.select();
            focusedElement = this;
          }
        });
        element.on('blur', function () {
          focusedElement = null;
        });
      }
    };
  }

  /** @ngInject */
  function blurOnClick() {
    return {
      restrict: 'A',
      link: function($scope, ele){
        ele.click(function(){
          ele[0].blur()
        });
      }
    }
  }


  })();

(function () {
  "use strict";
  angular
    .module("hdfc-mf-investor-web")
    .controller("SelectFolioController", selectFolioController);

  function selectFolioController($state, TransactionModel, NetcoreEvntService,InvestorService,$window, $scope,AppConstants, LoaderService, $stateParams,AuthService, TransactionService, MessageService, IIHttpService, $filter, ModalService,InvestorServiceVersion3, CreatePayloadFactory,toastr,HDFC_API, $timeout, EcartInvestorService, UtilService) {
    var vm = this;
    vm.appConstants = AppConstants;
    vm.folioNumber = "";
    vm.beforotp = true;
    vm.otpNumber = "";
    vm.formData = {}
    vm.formData.panNumber = $window.atob($stateParams.pan);
    vm.formData.otpDetails = {};
    vm.formData.folioList = [];
    vm.formData.maskedFolioList = [];
    vm.startTimer = false;
    if(localStorage.getItem("distributorDetails")) {
      vm.linkdata = $window.JSON.parse(localStorage.getItem("distributorDetails"));
    } else if(sessionStorage.getItem("distributorDetails")){
      vm.linkdata = $window.JSON.parse(sessionStorage.getItem("distributorDetails"));
    }
    vm.userPanDetail = $window.JSON.parse(sessionStorage.getItem("userPanDetail"));
    vm.PARTNER_DATA = JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
    vm.userFolioListFromECart = JSON.parse(sessionStorage.getItem("userFolioListFromECart"));
    vm.panRegisteredData = JSON.parse($window.sessionStorage.getItem("verifyObjFromPopup"));
    vm.init = init;
    vm.noHdfcBank = false;
    vm.IsFolio = true;
    vm.handleFolioListing = handleFolioListing;
    vm.resetTimer = resetTimer;

    vm.schedulerTempId  = "6a2d3fc3-0601-4426-83e0-b5c09efa5717";
    vm.nonArnAuth = function () {
      var successLogin = function (resp) {
        LoaderService.hideLoader();
        init();
        if(vm.formData.riaCode){
          vm.getEuinRIA();
        }
      }, errorLogin = function (error) {
        MessageService.error(error.message);
      }
      var oauthpayload = {
        arnCode: "ARN-DIRECT",
        grant_type: 'password',
        panNumber: null,
        appType: 'W',
        type: 'arn'
      };
      LoaderService.showLoader();
      AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);
    }
    vm.callAuth = function () {
      var successLogin = function (resp) {
        LoaderService.hideLoader();
        init();
      }, errorLogin = function (error) {
        MessageService.error(error.message);
      }
      var oauthpayload = {
        arnCode: "ARN-"+vm.formData.arn,
        grant_type: 'password',
        panNumber: null,
        appType: 'W',
        type: 'arn'
      };
      LoaderService.showLoader();
      AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);
    }
    init();
    function init() {
      $window.onload = function(){
        if (vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART' && vm.panRegisteredData.registrationType == 'NEW') {
          $window.sessionStorage.removeItem("verifyObjFromPopup")
          $state.go('arnReview.verifyPan', {
            arn: vm.linkdata.chipherText
          });
          vm.isReload = true;
        }
      }
      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART' && vm.panRegisteredData && vm.panRegisteredData.registrationType == 'NEW'){
        vm.beforotp = false;
        vm.formData.emailID = vm.panRegisteredData.maskedEmail;
        vm.formData.mobile = vm.panRegisteredData.maskedMobile;
        if(!vm.isReload) {
          MessageService.success(vm.panRegisteredData.message);
        }
      } else if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART'){
        $timeout(function (){
          handleFolioListing();
        })
      } else {
        var success = function (resp) {
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            if (resp.data.length == 0) {
              vm.IsFolio = false;
              if (vm.linkdata && vm.linkdata.isHdfcBank) {
                // MessageService.error("This PAN have not any folio with HDFC Bank.");
                // window.history.go(-1)
                // vm.noHdfcBank = true;
                ModalService.arnPopupModal({ status: "EMPTYBANKLIST"},
                function (data) {if(data == 'createNewFolio'){vm.createNewFolio();}},function (data) { });
              } else {
                MessageService.error("This PAN have not any folio.");
                window.history.go(-1)
              }
            } else {
              if (vm.linkdata && vm.linkdata.isHdfcBank) {
                vm.noHdfcBank = true;
              }
              vm.formData.folioList = resp.data;
              var retirementSchemeExists = sessionStorage.getItem('retirementSchemeExists') === 'true' ? true : false;
              if (retirementSchemeExists) {
                var folioList = [];
                for(var i=0; i< vm.formData.folioList.length; i++) {
                  if (!vm.formData.folioList[i].minorFlag) {
                    folioList.push(vm.formData.folioList[i]);
                  }
                }
                vm.formData.folioList = folioList;
              }
              for (var j = 0; j < vm.formData.folioList.length; j++) {
                if (vm.formData.folioList[j]) {
                  if (vm.formData.folioList[j].id) {
                    var id = vm.maskid(vm.formData.folioList[j].id);
                  }
                  if (vm.formData.folioList[j].email) {
                    if (vm.formData.folioList[j].email == "null") {
                      vm.formData.folioList[j].email = "";
                    } else {
                      var valArray = vm.formData.folioList[j].email.split("@");
                      var startVal = valArray[0];
                      var endVal = valArray[1];
                      var maskyVal = "";
                      for (var i = 0; i < startVal.length; i++) {
                        if (i == 0) {
                          maskyVal += startVal[i];
                        }
                        if (i == 1) {
                          maskyVal += "*";
                        }
                        if (i > 1) {
                          var t = i % 2;
                          if (t == 0) {
                            maskyVal += startVal[i];
                          } else {
                            maskyVal += "*";
                          }
                        }
                      }
                      var email = maskyVal + "@" + endVal;
                    }
                  }
                  if (vm.formData.folioList[j].mobileNo) {
                    var mobileNo = vm.maskemobileNo(vm.formData.folioList[j].mobileNo);
                  }
                  var obj = {
                    "id": id,
                    "email": email ? email : "",
                    "mobileNo": mobileNo ? mobileNo : "",
                    "folioNumber": vm.formData.folioList[j].id,
                    "minorFlag" : vm.formData.folioList[j].minorFlag
                    // "blockedTrxnPopup" : vm.formData.folioList[j].blockedTrxnPopup,
                    // "noNominationMsg" : vm.formData.folioList[j].noNominationMsg,
                    // "hdfcOneClickNoNominationPopupMsg" : vm.formData.folioList[j].hdfcOneClickNoNominationPopupMsg
                  }

                  obj.holderDOBExists = vm.formData.folioList[j].holderDOBExists ? vm.formData.folioList[j].holderDOBExists : false;
                  obj.corporateInvestor = vm.formData.folioList[j].corporateInvestor ? vm.formData.folioList[j].corporateInvestor : false;

                  if (!obj.holderDOBExists && vm.formData.folioList[j].retirementSchemeBlankDOBErrorMsg) {
                    obj.retirementSchemeBlankDOBErrorMsg = vm.formData.folioList[j].retirementSchemeBlankDOBErrorMsg;
                  }

                  vm.formData.maskedFolioList.push(obj);
                  obj = {}

                }
              }
              vm.folioNumber = vm.formData.folioList[0].id;
              vm.chooseFolio(vm.formData.folioList[0]);
            }
          } else {
            MessageService.error(resp.message);
            window.history.go(-1);
            LoaderService.hideLoader();
          }


        }, error = function (resp) {
          if (resp.data.error == 'invalid_token') {
            if (vm.PARTNER_DATA) {
              vm.nonArnAuth();
            } else if (vm.linkdata) {
              if (vm.linkdata.key == "MFD") {
                vm.formData.arn = vm.linkdata.arn;
                vm.callAuth();
              } else if (vm.linkdata.key == "RIA") {
                vm.nonArnAuth();
              } else if (vm.linkdata.key == "E_CODE") {
                if (vm.formData.arn) {
                  vm.formData.arn = vm.linkdata.arn;
                  vm.callAuth();
                } else {
                  vm.nonArnAuth();
                }
              }
            }
            LoaderService.hideLoader();
          } else {
            MessageService.error(resp.message);
          }

        }
        var payload = {
          panNumber: vm.formData.panNumber,
          dob: vm.userPanDetail.DateOfBirth
        };
        if (vm.linkdata && vm.linkdata.isHdfcBank) {
          payload.isHdfcFilter = 'Y'
        } else {
          payload.isHdfcFilter = 'N'
        }
        LoaderService.showLoader();
        TransactionService.post({controller1: "getListOfFolio"}, payload).$promise.then(success, error);
      }
    }
    vm.maskid = function (val) {
      var endVal = val.substr(-3);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 3) {
        maskyVal += "*";
        valLength--;
      }
      return maskyVal + endVal;
    }
    vm.maskemail = function (val) {
      if(val == "null"){
        return val="";
      }
      var valArray = val.split("@");
      var startVal = valArray[0];
      var endVal = valArray[1];
      var maskyVal = "";
      for (var i = 0; i < startVal.length; i++) {
        if (i == 0) {
          maskyVal += startVal[i];
        }
        if (i == 1) {
          maskyVal += "*";
        }
        if (i > 1) {
          if (i / 2 == 0) {
            maskyVal += "*";
          } else {
            maskyVal += startVal[i];
          }
        }
      }
      return maskyVal + "@" + endVal;
    }
    vm.maskemobileNo = function (val) {
      if(val == "null"){
        return val="";
      }
      if(val == 'Not updated'){
        return val = val;
      }
      var endVal = val.substr(-4);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 4) {
        maskyVal += "*";
        valLength--;
      }
      return maskyVal + endVal;
    }

    vm.chooseFolio = function (x) {
      vm.formData.emailID = x.email;
      vm.formData.mobile = x.mobileNo;
      sessionStorage.setItem("minorFlag",x.isMinor);

      if (!x.holderDOBExists || x.corporateInvestor) {
        localStorage.setItem('selectedFolioDataInQI',JSON.stringify(x));
      } else if (x.holderDOBExists && !x.corporateInvestor && localStorage.getItem('selectedFolioDataInQI')) {
        localStorage.removeItem('selectedFolioDataInQI');
      }

      // if (x.blockedTrxnPopup) {
      //   UtilService.setBlockTransactionSEBINomination(x);
      // } else {
      //   var isoldData = localStorage.getItem('bTransaction');
      //   if (isoldData) {
      //     localStorage.removeItem('bTransaction');
      //   }
      // }
    }

    vm.sendOtp = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.beforotp = false;
          vm.formData.otpDetails = resp.data;
          localStorage.setItem('QuickInvestmentSecreteLink',resp.data.id);
          sessionStorage.setItem('arnSecreteLink', resp.data.secretLink);
          if(vm.startTimer) {
            resetTimer();
          }
          if(resp.data.message){
            MessageService.success("OTP has been sent successfully to your registered Email Id and Mobile Number.");
          } else {
            MessageService.success(resp.data.otpSentMessage);
          }
        }else{
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        MessageService.error(err);
      }

      if(vm.linkdata){
        if(vm.linkdata.isHdfcBank){
          vm.encryptedPan =sessionStorage.getItem("encryptedPanNumber");
          if(vm.folioNumber){
            vm.formData.folioList.forEach(function(item){
              if(vm.folioNumber == item.id){
                vm.choosedfolioEmail =item.email;
                vm.choosedfolioMobile =item.mobileNo;
              }
            })
          }
          vm.oneclickurl = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.linkdata.chipherText;
          $window.smartech('contact', '331', {
            'pk^pan_number': vm.encryptedPan,
            'email': vm.choosedfolioEmail,
            'mobile': vm.choosedfolioMobile
            });
            $window.smartech('identify', vm.encryptedPan);
            $window.smartech('dispatch', 'Quick Login_2', {
            'page_url':vm.oneclickurl
            });
        }
      }

      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART'){
        var sendOtppayload = {
          folioNo: vm.folioNumber,
        };
        $window.sessionStorage.setItem("folioNumberFromArn", vm.folioNumber);
      } else {
        var sendOtppayload = {
          folioNumber: vm.folioNumber,
          panNumber: vm.formData.panNumber
        };
      }
      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART'){
        EcartInvestorService.post({
          child1: "ecart",
          child2: "folio",
          child3: "sendotp",
        }, sendOtppayload).$promise.then(success, error);
      } else {
        InvestorService.post({
          child1: "registration",
          child2: "otp",
          child3: "generate",
          child4: "arnHardCode"
        }, sendOtppayload).$promise.then(success, error);
      }
    }
    vm.ecartResendOtp = function () {
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.beforotp = false;
          vm.formData.otpDetails = resp.data;
          resetTimer();
          if(resp.message){
            MessageService.success(resp.message);
          } else {
            MessageService.success(resp.data.otpSentMessage);
          }
        }else{
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err);
      }
      var resendOtpPayload = {
        id: sessionStorage.getItem('arnSecreteLink')
      };
      EcartInvestorService.post({
        child1: "registration",
        child2: "resendOTP"
      }, resendOtpPayload).$promise.then(success, error);
    }

    vm.verifyOtp = function () {
      // vm.makeTransaction();
      // var success = function (resp) {
      //   if(resp.status && resp.data){
          if(vm.PARTNER_DATA){
            vm.getBrokerCode();
          } else if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART'){
            vm.ecartJourney();
          } else if (vm.linkdata && vm.linkdata.flowName !== 'E_CART'){
            vm.makeTransaction();
          } else if (vm.linkdata && vm.linkdata.flowName === undefined){
            vm.makeTransaction();
          } else {
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          }
      //   }else{
      //     MessageService.error(resp.message);
      //   }
      // },error = function(){
      //   MessageService.error(resp.message);
      // }
      // var payload = {
      //   folioNumber: vm.folioNumber,
      //   otpId: vm.formData.otpDetails.id,
      //   otpNumber:vm.otpNumber,
      //   panNumber: vm.formData.otpDetails.panNumber
      // };
      // InvestorService.post({child1: "registration",child2: "otp",child3:"verifyArnHardCoded"},payload).$promise.then(success, error);

    }
    vm.reSendOtp = function () {
      vm.otpNumber = null;
      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART'){
        vm.ecartResendOtp();
      } else {
        vm.startTimer = true;
        vm.sendOtp();
      }
    }

    vm.loginPayload = {
      folioNumber: vm.folioNumber,
      panNumber: vm.formData.panNumber
    };

    vm.makeTransaction = function () {
      sessionStorage.removeItem("isModify");
      var data = $window.JSON.parse(localStorage.getItem("distributorDetails"))
      vm.localData = data;
      AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
      var successLogin = function (resp) {
        LoaderService.hideLoader();
        localStorage.setItem('loggedIn', true);
        TransactionModel.setPayloadRawData(null);
        NetcoreEvntService.Login_Status_QI_IP(vm.loginPayload, true);
        // if(vm.localData.isHdfcBank){
        //   if(vm.localData.schemeCode){
        //     fetchValidations();
        //   }else{
        //       getBankList();
        //   }
        // }else{
          if($stateParams.trackId && $stateParams.trxnType && $stateParams.stepNo){
            redirectToTransaction();
          }else{
            $state.go("instantLoginHome.instantInvest");
          }
        // }
        if(vm.PARTNER_DATA){
          localStorage.removeItem("distributorDetails");
        }else{
          data.maskedEmail = vm.formData.emailID;
          data.maskedMobileNumber = vm.formData.mobile;
          localStorage.setItem("distributorDetails",$window.JSON.stringify(data));
        }
      }, errorLogin = function (error) {
        localStorage.setItem("distributorDetails",$window.JSON.stringify(data));
        LoaderService.hideLoader();
        MessageService.error(error.message);
      }
      // var oauthpayload = {
      //   grant_type: 'password',
      //   panNumber: vm.formData.panNumber?AuthService.encryptRSA(angular.copy(vm.formData.panNumber)):"",
      //   folioNumber: vm.folioNumber,
      //   appType: 'W'
      // };
      var oauthpayload = {
        folioNumber: vm.folioNumber,
        secretLink: vm.formData.otpDetails.id,
        otp:vm.otpNumber,
        grant_type :'password',
        panNumber: vm.formData.panNumber?AuthService.encryptRSA(angular.copy(vm.formData.panNumber)):""
      };
      LoaderService.showLoader();
      AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);
    }


    vm.back = function(){
      vm.otpNumber = null;
      vm.beforotp = true;
      if(vm.linkdata && vm.linkdata.flowName && vm.linkdata.flowName == 'E_CART' && vm.panRegisteredData.registrationType == 'NEW'){
          $state.go('arnReview.verifyPan',{
            arn: vm.linkdata.chipherText
          });
      }
    }

    function fetchValidations() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            LoaderService.hideLoader();
            vm.schemeType=resp.data.schemeType;
            getBankList();
          }else{
              MessageService.error(resp.message);
          }
        },error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err);
        };
        LoaderService.showLoader();
        if(vm.localData.transactionType == "SIP"){
          var path = {
          child1: 'schemeValidation',
          child2: 'sip',
          child3: vm.localData.schemeCode
          };
          IIHttpService.get(path).$promise.then(success, error);
        }else{
          var data = {
           schemeCode: vm.localData.schemeCode
          };
          IIHttpService.post({
          child1: 'schemeValidation',
          child2: 'purchase'
          }, data).$promise.then(success, error);
        }

    }
    function getBankList(){
      var success = function (resp) {
        LoaderService.hideLoader();
        $state.go("instantLoginHome.instantInvest");
        // if(resp.status && resp.data){
        //   if(resp.data.bankList){
        //     vm.bankList = resp.data.bankList;
        //   }
        // }
            // vm.bankList = $filter('filter')(resp.data.bankList,
            //     {
            //       bankCode: "HDF"
            //     })
            // if(vm.bankList.length == 0){
            //   vm.modalData = {
            //     folioNumber:vm.folioNumber,
            //     panNumber:vm.formData.panNumber
            //   }
            //   ModalService.hdfcBankModal({data : vm.modalData});
            // }else{

            // }
          // }else{
          //  vm.modalData = {
          //     folioNumber:vm.folioNumber,
          //     panNumber:vm.formData.panNumber
          //   }
          //   ModalService.hdfcBankModal({data : vm.modalData});
          // }
        // }else{
        // LoaderService.hideLoader();
        //   vm.modalData = {
        //     folioNumber:vm.folioNumber,
        //     panNumber:vm.formData.panNumber
        //   }
        //   ModalService.hdfcBankModal({data : vm.modalData});
        // }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.message)
      }

      vm.payload = {
        trnxType: vm.localData.transactionType.toUpperCase(),
        folioNumber: vm.folioNumber,
        liquidSchemeFlag: vm.schemeType == 'LIQUID' ? true : false
      }
      if(vm.localData.transactionType == 'SIP'){
        vm.payload.sipFlow = true;
      }
      LoaderService.showLoader();
        IIHttpService.post({
          child1: 'bank',
          child2: 'list'
          }, vm.payload).$promise.then(success, error);
    }

    vm.createNewFolio = function (){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.processFlag = false;
          vm.userData = resp.data
          vm.registrationType = resp.data.registrationType;
          resp.data.PAN = vm.userPanDetail.panNumber;
          resp.data.dob = vm.userPanDetail.dob;
          CreatePayloadFactory.set(resp.data);
          //passing data to otp confirmation
          var verifyObj = {
            maskedEmail: resp.data.maskedEmail,
            maskedMobile: resp.data.maskedMobile,
            secretLink: resp.data.secretLink,
            panHolderName: resp.data.panHolderName,
            dob: vm.userPanDetail.dob,
            panNumber: vm.userPanDetail.panNumber,
            kycVerifiedFlag: resp.data.kycVerifiedFlag,
            kycStatus: resp.data.kycStatus,
            registrationType: resp.data.registrationType
          }
          vm.userDetails = verifyObj;
          $window.sessionStorage.setItem("verifyObj", JSON.stringify(verifyObj));
          $window.sessionStorage.setItem("onotp", true);
          vm.distributorDetails = $window.JSON.parse($window.localStorage.getItem("distributorDetails"));
          $window.sessionStorage.setItem("distributorDetails", JSON.stringify(vm.distributorDetails));
          $window.localStorage.removeItem("distributorDetails");
          if (localStorage.getItem('selectedFolioDataInQI')) {
            localStorage.removeItem('selectedFolioDataInQI');
          }
          $state.go("newInvestor.otpVerification")
        } else{
          MessageService.error(resp.message);
        }
      },
        error = function (resp) {
          if (resp && resp.message) {
            var messages = resp.message + '<span class="' + Math.random() + '"></span>';
            toastr.error(messages, '', {
              allowHtml: true,
              preventDuplicates: false,
              onHidden: function () {
                vm.processFlag = false;
              }
            });
          } else {
            MessageService.error();
          }
          LoaderService.hideLoader();
        };
      sessionStorage.setItem("panDetailsEncrypted", AuthService.encryptRSA(vm.userPanDetail.panNumber));
      var payload = {
        dob: vm.userPanDetail.dob,
        panNumber: vm.userPanDetail.panNumber,
        isFlowFromArnHdfc : 'Y'
      };
      sessionStorage.setItem("panDetails", JSON.stringify(payload));
      vm.processFlag = true;
      LoaderService.showLoader();
      InvestorServiceVersion3.post({
        child1: 'registration',
        child2: 'new',
        child3: 'user',
        child4: 'verifyKYC'
      }, payload).$promise.then(success, error);
    }

    vm.getBrokerCode = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if(resp.status && resp.data){
          sessionStorage.removeItem("PARTNER_DATA");
          var data = {
            schemeGroupCode : vm.PARTNER_DATA.schemeGroupCode,
            arnFlag : vm.PARTNER_DATA.arnFlag,
            schemeList : resp.data.schemes
          }
          if(resp.data.arnCode){
              if(resp.data.arnCode.includes('ARN')){
                var arnArray = resp.data.arnCode.split('-');
                data.arnCode = arnArray[1];
              }else{
                data.arnCode = "";
              }
          }else{
            data.arnCode = "";
          }
          sessionStorage.setItem("PARTNER_DATA", JSON.stringify(data));
          vm.makeTransaction();
        }else{
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      }, error = function (error) {
          MessageService.error(error.message);
          LoaderService.hideLoader();
      };
      var payload = {
        folioNumber: vm.folioNumber ? vm.folioNumber : null,
        schemeCode: vm.PARTNER_DATA.schemeGroupCode,
        arnFlag: vm.PARTNER_DATA.arnFlag
      };
      LoaderService.showLoader();
      InvestorService.post({ child1: "arnHardCode", child2: "schemeList" }, payload).$promise.then(success, error);
  }

  vm.makeTransactionPARTNER = function () {
      AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
      var successLogin = function (resp) {
        LoaderService.hideLoader();
        localStorage.setItem('loggedIn', true);
        TransactionModel.setPayloadRawData(null);
        NetcoreEvntService.Login_Status_QI_IP(vm.loginPayload, true);
        $state.go("instantLoginHome.instantInvest");
      }, errorLogin = function (error) {
        LoaderService.hideLoader();
        MessageService.error(error.message);
      }
      var oauthpayload = {
        grant_type: 'password',
        panNumber: vm.formData.panNumber?AuthService.encryptRSA(angular.copy(vm.formData.panNumber)):"",
        folioNumber: vm.folioNumber,
        appType: 'W'
      };
      LoaderService.showLoader();
      AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);
  }
  vm.addNewFolio = function(){
    if(vm.linkdata){
      if(vm.linkdata.isHdfcBank){
        vm.createnewFolioUrl = {}
        vm.createnewFolioUrl.oneclickurl = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.linkdata.chipherText
        vm.netcoreDataObj = NetcoreEvntService.Create_New_Folio(vm.createnewFolioUrl, true);
        $window.smartech('dispatch', 'Create New Folio',vm.netcoreDataObj)
      }
    }
    ModalService.arnPopupModal({ status: "HDFCBANKLIST"},
    function (data) {if(data == 'createNewFolio'){vm.createNewFolio();}},function (data) { });
  }
  function redirectToTransaction() {
    if($stateParams.trackId && $stateParams.trxnType && $stateParams.stepNo){
      $state.go('instantLoginHome.instantInvest',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
      switch ($stateParams.stepNo.toUpperCase()) {
        case "FIRST":
          $state.go('instantLoginHome.instantInvest',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
          break;
        case "SECOND":
          if($stateParams.trxnType == "SIP"){
            $state.go('instantLoginHome.instantInvest',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
          }else{
            $state.go('instantLoginHome.instantInvest',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
          }
          break;
        case "THIRD":
          $state.go('instantLoginHome.payment',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
          break;
        default:
          $state.go('instantLoginHome.instantInvest',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,stepNo:$stateParams.stepNo});
      }
    }else {
      $state.go('instantLoginHome.instantInvest');
    }
  }

  vm.ecartJourney = function(){
    var success = function (resp) {
      if (resp.status && resp.data) {
        $state.go("preLoginEcart",{
          uuid: resp.data.uuid,
        })
      }else{
        MessageService.error(resp.message);
      }
    }, error = function (err) {
      MessageService.error(err);
    }
      var sendOtppayload = {
        folioNumber: vm.folioNumber,
        panNumber: vm.userPanDetail.panNumber,
        dob: vm.userPanDetail.dob,
        otp: vm.otpNumber,
        secretLink: sessionStorage.getItem('arnSecreteLink') ? sessionStorage.getItem('arnSecreteLink') : vm.panRegisteredData.secretLink,
        registrationType: vm.panRegisteredData && vm.panRegisteredData.registrationType ? vm.panRegisteredData.registrationType: 'EXISTING',
        journey: 'E_CART',
        sourcePortal: 'ARN_HARDCODED',
        linkId: vm.linkdata.chipherText,
        nriFlag: vm.linkdata.nriFlag
  };

    EcartInvestorService.post1({
        child1: "preLogin",
        child2: "verifyOTP",
      }, sendOtppayload).$promise.then(success, error);
  }

    function handleFolioListing(){
      if(vm.linkdata && vm.linkdata.cgfSchemeOpted && !vm.linkdata.retirementSchemeOpted){
        var filteredFolios = vm.userFolioListFromECart.filter(function(folio) {
          return folio.minorFlag == true;
        });
      } else if(vm.linkdata && vm.linkdata.retirementSchemeOpted && !vm.linkdata.cgfSchemeOpted){
        var filteredFolios = vm.userFolioListFromECart.filter(function(folio) {
          return folio.minorFlag == false;
        });
      }
      vm.formData.folioList = filteredFolios ? filteredFolios: vm.userFolioListFromECart;
      for (var j = 0; j < vm.formData.folioList.length; j++) {
        if (vm.formData.folioList[j]) {
          if (vm.formData.folioList[j].folioNumber) {
            var id = vm.maskid(vm.formData.folioList[j].folioNumber);
          }
          if (vm.formData.folioList[j].email) {
            if (vm.formData.folioList[j].email == "null") {
              vm.formData.folioList[j].email = "";
            } else {
              var valArray = vm.formData.folioList[j].email.split("@");
              var startVal = valArray[0];
              var endVal = valArray[1];
              var maskyVal = "";
              for (var i = 0; i < startVal.length; i++) {
                if (i == 0) {
                  maskyVal += startVal[i];
                }
                if (i == 1) {
                  maskyVal += "*";
                }
                if (i > 1) {
                  var t = i % 2;
                  if (t == 0) {
                    maskyVal += startVal[i];
                  } else {
                    maskyVal += "*";
                  }
                }
              }
              var email = maskyVal + "@" + endVal;
            }
          }
          if (vm.formData.folioList[j].mobileNumber) {
            var mobileNo = vm.maskemobileNo(vm.formData.folioList[j].mobileNumber);
          }
          var obj = {
            "id": id,
            "email": email ? email : "",
            "mobileNo": mobileNo ? mobileNo : "",
            "folioNumber": vm.formData.folioList[j].folioNumber,
            "isMinor" : vm.formData.folioList[j].minorFlag
          }

          vm.formData.maskedFolioList.push(obj);
          obj = {}

        }
      }
      vm.folioNumber = vm.formData.maskedFolioList[0].folioNumber;
      vm.chooseFolio(vm.formData.maskedFolioList[0]);
    }
    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

  }
})();

(function () {
  "use strict";
  angular
    .module("hdfc-mf-investor-web")
    .controller("PanVerifyController", panVerifyController);
  function panVerifyController(LoaderService, TransactionService, AuthService, InvestorService, $window, InvestorServiceVersion3, $state, $stateParams, MessageService, AppConstants, $log, ModalService,$rootScope,UtilService,$filter,  InvestorFolioModel, EcartInvestorService, CommonFactory) {
    var vm = this;
    $rootScope.showTitle = false;
    vm.formData = {
      arn: "",
      euin: "",
      ecode: "",
      ria: "",
      eamc: "",
      pan: "",
      dob: ""
    };
    if($stateParams && $stateParams.ScheduleTransaction == "true"){
      sessionStorage.setItem("schedulerIdDetails",$stateParams.ScheduleId);
    }
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    vm.panMessage = "";
    vm.viewMode = "days";
    vm.dateErrorMessage = "";
    vm.changeStartDate = changeStartDate;
    vm.resetValues = resetValues;
    vm.checkPanVerification = checkPanVerification;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.appConstants = AppConstants;
    vm.btnClose = true;
    vm.isFromPanVerifyScreen = InvestorFolioModel.getFromDistributorModel();
    $rootScope.$on('EcartFLow', function(event,value) {
      if(value == true) {
        InvestorFolioModel.setFromDistributorModel({panVerifyScreen: true});
        if (localStorage.getItem("distributorDetails")) {
          vm.distributorDetails = $window.JSON.parse(localStorage.getItem("distributorDetails"));
        } else if (sessionStorage.getItem("distributorDetails")) {
          vm.distributorDetails = $window.JSON.parse(sessionStorage.getItem("distributorDetails"));
        }
      }
    });
    if(vm.isFromPanVerifyScreen.panVerifyScreen == true) {
      if (localStorage.getItem("distributorDetails")) {
        vm.distributorDetails = $window.JSON.parse(localStorage.getItem("distributorDetails"));
      } else if (sessionStorage.getItem("distributorDetails")) {
        vm.distributorDetails = $window.JSON.parse(sessionStorage.getItem("distributorDetails"));
      }
    }

    vm.getcipherText = function (cipherData) {
      var cipherText = cipherData;
      var key = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-|_";
      var message = "";
      var shiftKey = 10;
      for (var i = 0; i < cipherText.length; i++) {
        var charPosition = key.indexOf(cipherText.charAt(i));
        var keyVal = (charPosition - shiftKey) % 39;
        if (keyVal < 0) {
          keyVal = key.length + keyVal;
        }
        var replaceVal = key.charAt(keyVal);
        message += replaceVal;
      }
      return message;
    }
    vm.linkdata = $window.JSON.parse(localStorage.getItem("distributorDetails"));
    vm.init = function () {
      $window.sessionStorage.removeItem("verifyObjFromPopup")
      vm.PARTNER_DATA =JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
      if(!vm.PARTNER_DATA){
        vm.chipherText = $stateParams.arn;
        var linkCode = vm.getcipherText(vm.chipherText);
      }
      if(angular.isDefined($stateParams.trackId)){
        getTrackedInfo();
      }
      vm.formData.taxStatusResident = true;
    };
    vm.init();


    vm.invalidPanDob = false;
    vm.panKycInvalid = false;
    vm.submit = function () {
      if(vm.linkdata && vm.linkdata.isHdfcBank){
        vm.encryptedPan =sessionStorage.getItem("encryptedPanNumber");
        $window.smartech('contact', '331', {
        'pk^pan_number': vm.encryptedPan,
        'DOB':vm.formData.dob.format("DD-MM-YYYY"),
        'NAME':""
        });
        $window.smartech('identify',vm.encryptedPan);
        vm.currentTime =new Date();
        vm.formattedCurrentTime =$filter("date")(vm.currentTime, "yyyy-MM-dd HH:mm:ss");
        $window.smartech('dispatch', 'Quick Login_1', {
        'login_date': vm.formattedCurrentTime
      });
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data) {
          if(resp.data['popup-enabled']){
            var successModal = function(){
            },errorModal = function(){
            }
            ModalService.oneClickPanAadharStatusModal({text:resp.data.message}, successModal,errorModal);
          }else{
            vm.kycVerify();
          }
        }else{
          MessageService.error(resp.message);
        }
      },error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      var payload  = {"panNumber":vm.formData.pan ,"folioNumber":null};
      LoaderService.showLoader();
      vm.localLinkData = $window.JSON.parse(localStorage.getItem("distributorDetails"));
      if (vm.localLinkData && vm.localLinkData.key == "CONNECT_PARTNER" && vm.localLinkData.arn == '0014' && vm.localLinkData.transactionType == 'SIP' && vm.localLinkData.CAMP) {
        MessageService.error("Invalid Link");
      }else{
        InvestorService.post({child1: "verifyPanAadharLink"},payload).$promise.then(success, error);
      }
    };

    function resetValues() {
      vm.errorMessage = "";
      vm.errorMessageVerify = "";
      vm.panMessage = "";
      vm.availableMessage = "";
      vm.dateErrorMessage = "";
      vm.invalidPanDob = "";
      if (vm.formData.pan) {
        if (vm.formData.pan[3] == "P") {
          vm.panPStatus = false;
        } else {
          vm.panPStatus = true;
        }
      }
    }
    function checkPanVerification() {
      if (vm.formData.pan) {
        var success = function (resp) {
          LoaderService.hideLoader(".pan-loader");
          if (resp.data && resp.status) {
            $log.info("resp.data:", resp.data);
            if(resp.data.encryptedPanNumber){
              sessionStorage.setItem("encryptedPanNumber", resp.data.encryptedPanNumber);
            }
            if (resp.data.panVerifiedFlag) {
              vm.panMessage = "";
            } else {
              vm.panMessage = resp.data.message;
            }
            vm.processFlag = false;
          } else {
            vm.processFlag = true;
            vm.panMessage = resp.message;
          }
        },
          error = function () {
            LoaderService.hideLoader(".pan-loader");
            vm.processFlag = true;
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        vm.processFlag = false;
        LoaderService.showLoader(".pan-loader");
        InvestorService.post(
          {
            child1: "registration",
            child2: "verifyPan"
          },
          { panNumber: vm.formData.pan }
        ).$promise.then(success, error);
      }
    }
    function changeStartDate(date) {
      if (
        angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(
          date._i
        )
      ) {
        vm.dobtrue = true
        vm.formData.dob = date;
        vm.dob = date._i;
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = "";
        vm.invalidPanDob = "";
      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.formData.dob = "";
        vm.dobtrue = false
        vm.invalidPanDob = "";
      }
      return;
    }
    vm.dob = null;
    vm.dobtrue = false;
    vm.varifyDate = function () {
      var doblength = vm.dob ? vm.dob.length : 0
      if (doblength == 10) {
        if (
          angular.isDefined(vm.dob) ||
          /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(
            vm.dob
          )
        ) {
          vm.formData.dob = vm.dob;
          if(vm.formData.dob && typeof vm.formData.dob === "string"){
            vm.formData.dob =$window.moment(vm.formData.dob, 'DD-MM-YYYY');
          }        
          if (!vm.dob) {
            vm.dateErrorMessage = vm.validateData.DOB_FIELD;
          } else {
            vm.dateErrorMessage = "";
            vm.dobtrue = true
          }
        } else {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
          vm.formData.dob = "";
        }
        return;
      }
      else {
        vm.dobtrue = false;
      }
    }

    vm.getBrokerCode = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if(resp.status && resp.data){
          sessionStorage.removeItem("PARTNER_DATA");
          var data = {
            schemeGroupCode : vm.PARTNER_DATA.schemeGroupCode,
            arnFlag : vm.PARTNER_DATA.arnFlag,
            schemeList : resp.data.schemes
          }
          if(resp.data.arnCode){
            if(resp.data.arnCode.includes('ARN')){
              var arnArray = resp.data.arnCode.split('-');
              data.arnCode = arnArray[1];
            }else{
              data.arnCode = "";
            }
        }else{
          data.arnCode = "";
        }
          sessionStorage.setItem("PARTNER_DATA", JSON.stringify(data));
          vm.panKycInvalid = false;
          var data = {
            dob: vm.formData.dob.format("DD-MMM-YYYY"),
            panNumber: vm.formData.pan
          }
          ModalService.arnPopupModal(
            { status: "VERIFIEDNEW", data: data },
            function () { }, function () { }
          );
        }
      }, error = function (error) {
        LoaderService.hideLoader();
        MessageService.error(error.message);
      };
      var payload = {
        folioNumber: '',
        schemeCode: vm.PARTNER_DATA.schemeGroupCode,
        arnFlag: vm.PARTNER_DATA.arnFlag
      };
      LoaderService.showLoader();
      InvestorService.post({ child1: "arnHardCode", child2: "schemeList" }, payload).$promise.then(success, error);
    }

    vm.kycVerify = function(){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.invalidPanDob = false;
          if (resp.data.ekycRequestCO && !(resp.data.kycStatus === vm.KYC_STATUS.NOT_VALIDATED || resp.data.kycStatus === vm.KYC_STATUS.ON_HOLD)) {
            sessionStorage.setItem("ekycRequestCO", JSON.stringify(resp.data.ekycRequestCO));
            ModalService.arnPopupModal(
              { status: "NOT_VERIFIEDNEW" },
              function () { }, function () { }
            );
          } else {

          }
          vm.distributor_data = $window.JSON.parse(localStorage.getItem("distributorDetails"));
          vm.distributor_data.nriFlag = !vm.formData.taxStatusResident;
          // for existing user
          if (resp.data.registrationType == "EXISTING" || resp.data.registrationType == "EXISTING_REGISTERED"|| resp.data.registrationType == "NEW_REGISTERED") {
            vm.distributor_data.user = "EXISTING";
            sessionStorage.setItem('oneClickcUser','true');
            var payload = {
              dob: vm.formData.dob.format("DD-MMM-YYYY"),
              panNumber: vm.formData.pan,
              DateOfBirth: vm.formData.dob.format("DD-MM-YYYY")
            }
            sessionStorage.setItem("userPanDetail", JSON.stringify(payload));
            if(vm.distributorDetails && vm.distributorDetails.flowName && vm.distributorDetails.flowName == 'E_CART'){
              sessionStorage.setItem("userFolioListFromECart", JSON.stringify(resp.data.folioList));
            }
            if ($stateParams.trackId && $stateParams.trxnType && $stateParams.stepNo) {
              $state.go('arnReview.select-folio', {
              pan: $window.btoa(vm.formData.pan),
              trackId: $stateParams.trackId,
              trxnType: $stateParams.trxnType,
              stepNo: $stateParams.stepNo
            });
            }else{
              if($stateParams && $stateParams.ScheduleTransaction){
                $state.go('arnReview.purchaseScheduleTransaction', {
                  pan: $window.btoa(vm.formData.pan)
                });
              }else{
                $state.go('arnReview.select-folio', {
                  pan: $window.btoa(vm.formData.pan)
                });
              } 
            }
          }
          // for new user
          if (resp.data.registrationType == "NEW") {
            vm.distributor_data.user = "NEW";
            if (resp.data.kycStatus == "NOT_VERIFIED") {
              vm.panKycInvalid = true;
              ModalService.arnPopupModal(
                { status: "NOT_VERIFIEDNEW" },
                function () { }, function () { }
              );
            }  else if (resp.data.kycStatus === vm.KYC_STATUS.NOT_VALIDATED || resp.data.kycStatus === vm.KYC_STATUS.ON_HOLD) {
              ModalService.nonKycModal({
                'text': resp.data.kycStatus === vm.KYC_STATUS.ON_HOLD ? AppConstants.ON_HOLD_MESSAGE : AppConstants.NOT_VALIDATED_MESSAGE,
                'showHtml': true,
                'buttonText': 'OK',
                'ekycRequestCO': resp.data.ekycRequestCO
              }, function () { }, function () { });
            }
            if (resp.data.kycStatus == "VERIFIED" || resp.data.kycStatus == vm.KYC_STATUS.IN_PROGRESS) {
              vm.PARTNER_DATA = JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
              if (vm.PARTNER_DATA) {
                vm.getBrokerCode();
              } else {
                vm.panKycInvalid = false;
                var data = {
                  dob: vm.formData.dob.format("DD-MMM-YYYY"),
                  panNumber: vm.formData.pan
                }
                if(vm.distributorDetails && vm.distributorDetails.flowName == 'E_CART'){
                  var verifyObj = {
                    maskedEmail: resp.data.maskedEmail,
                    maskedMobile: resp.data.maskedMobile,
                    secretLink: resp.data.secretLink,
                    panHolderName: resp.data.panHolderName,
                    dob: data.dob,
                    panNumber: data.panNumber,
                    kycVerifiedFlag: resp.data.kycVerifiedFlag,
                    kycStatus: resp.data.kycStatus,
                    registrationType: resp.data.registrationType,
                    message: resp.data.message
                  }
                  vm.userDetails = verifyObj;
                  $window.sessionStorage.setItem("verifyObjFromPopup", JSON.stringify(verifyObj));
                  sessionStorage.setItem('arnSecreteLink', resp.data.secretLink);
                  if(!resp.data.contactNumber || !resp.data.emailId) {
                    ModalService.contactSaveModal({status: "VERIFIEDNEW", responseData: resp.data, data: data }, function () {
                    })
                  } else {
                    sessionStorage.setItem("userPanDetail", JSON.stringify(data));
                    ModalService.arnPopupModal(
                      { status: "VERIFIEDNEW", data: data },
                      function () { }, function () { }
                    );
                  }
                } else {
                  sessionStorage.setItem("userPanDetail", JSON.stringify(data));
                  ModalService.arnPopupModal(
                    {status: "VERIFIEDNEW", data: data},
                    function () {
                    }, function () {
                    }
                  );
                }
              }
            }
          }
          localStorage.setItem("distributorDetails",$window.JSON.stringify(vm.distributor_data));
          if(vm.distributorDetails && vm.distributorDetails.flowName && vm.distributorDetails.flowName == 'E_CART'){
            logoutMe();
          }
        } else {
          var bannedCountry = resp.message.match('includes banned country');
          if(bannedCountry){
            vm.panMessage = "Unable to proceed since address in your KYC includes banned country name.";
            vm.invalidPanDob = true;
          }else{
            vm.invalidPanDob = true;
            vm.panMessage = resp.message;
          }
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };

      if(vm.distributorDetails && vm.distributorDetails.flowName && vm.distributorDetails.flowName == 'E_CART'){
        var payload = {
          encdob: AuthService.encryptRSA(vm.formData.dob.format("DD-MMM-YYYY")),
          panNumber: AuthService.encryptRSA(vm.formData.pan),
          nriFlag: !vm.formData.taxStatusResident
        };
        if(vm.distributorDetails.isHdfcBank){
          payload.isHdfcFilter = 'Y'
        }
      } else {
        var payload = {
          dob: vm.formData.dob.format("DD-MMM-YYYY"),
          panNumber: vm.formData.pan,
          nriFlag: !vm.formData.taxStatusResident
        };
      }
      LoaderService.showLoader();
      if(vm.distributorDetails && vm.distributorDetails.flowName && vm.distributorDetails.flowName == 'E_CART'){
        EcartInvestorService.post(
          {
            child1: "ecart",
            child2: "kyc",
            child3: "verify"
          },
          payload
        ).$promise.then(success, error);
      } else {
        InvestorServiceVersion3.post(
          {
            child1: "registration",
            child2: "verifyKYC"
          },
          payload
        ).$promise.then(success, error);
      }
    }
    function getTrackedInfo(){
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData = resp.data.formData;
          } else {
            vm.tracked = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'userBehavior',
        controller2: $stateParams.trackId,
        controller3: 'validate'
      }).$promise.then(success, error);
    }

    function logoutMe() {
      var payload = {
        "panNumber": vm.formData.pan,
        "isDpOnclickFLow": true,
        "flowName": 'E_CART'
      }
      var success = function (resp) {
          localStorage.removeItem("userId");
          var newDataLayer = $window.dataLayer.filter(function (obj) {
            return !obj.hasOwnProperty('userId');
          });
          $window.dataLayer = newDataLayer;
          CommonFactory.setLogoutSuccess();
        },
        error = function (err) {
        };
      LoaderService.showLoader('.logout');
      InvestorService.post({
        child1: 'force',
        child2: 'logout'
      }, payload).$promise.then(success, error);
    }

    vm.getconformation1 = function(){
      if($("#confirmfoliocreate1").prop("checked")){
        $("#confirmfoliocreate").prop("checked", false);
        vm.conformation = 'NOT_US_CANADA';
        vm.btnClose = false;
      }else{
        vm.conformation = '';
        vm.btnClose = true;
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UpdateContactController', UpdateContactController);

  function UpdateContactController() {
    var vm=this;
    vm.panValidate =function (panNumber) {
      var panVal = panNumber.val();
      var regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

      if(regpan.test(panVal)){
        // valid pan card number
      } else {
        // invalid pan card number
      }
    };

  }
})();

/**
 * Created by VINOD SINGH AT 23-Oct-2019.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('UpdateContactController', updateContactController);

  /** @ngInject */
  function updateContactController($state, $timeout,AuthService, $scope, $window, $stateParams, AppConstants, LoaderService, MessageService, ModalService, InvestorService,HDFC_API,toastr,toastrConfig, UtilService, investorServiceVersion, dynamicNotes, panAadharService ,  $log) {
    var vm = this;
    vm.CONST = AppConstants;
    vm.submitDetails = submitDetails;
    vm.verifyEmail = verifyEmail;
    vm.verifyMobile = verifyMobile;
    vm.resetDetails=resetDetails;
    vm.verifyOTP = verifyOTP;
    vm.verifyFolioOTP = verifyFolioOTP;
    vm.reGenerateOtp = reGenerateOtp;
    vm.reGenerateFolioOtp=reGenerateFolioOtp;
    vm.confirmCancel = confirmCancel;
    vm.processFlag = false;
    vm.processFlagOtp = false;
    vm.timerShowFlag = true;
    vm.UPDATE_FORM_STATE = {DEFAULT: 'DEFAULT', EMAIL: 'EMAIL', MOBILE: 'MOBILE', OTP: 'OTP', FOLIO_PROFILE: 'FOLIO_PROFILE',
      UPDATE_FOLIO: 'UPDATE_FOLIO', UPDATE_ONLINE_ACCOUNT: 'UPDATE_ONLINE_ACCOUNT',OTPFOLIO: 'OTPFOLIO'};
    vm.changeUserSelection = changeUserSelection;
    vm.updateProfileContact = updateProfileContact;
    vm.CURR_STATE = vm.UPDATE_FORM_STATE.DEFAULT;
    var CURR_VALIDATION = "NONE";
    var singleUseURL;
    vm.payload = {};
    vm.init = init;
    var incorrectCount = 0;
    vm.disableContinue = false;
    vm.emailSelected = false;
    vm.mobileSelected = false;
    vm.emailSelectedProfile = false;
    vm.mobileSelectedProfile = false;
    vm.emailSelectedFolio = false;
    vm.mobileSelectedFolio = false;
    vm.folioAccountFlag = false;
    vm.onlineAccountFlag = false;
    vm.emailEnabled = false;
    vm.mobileEnabled = false;
    vm.isFolio = false;
    vm.isOnlineAccount = false;
    vm.submitUserSelection = submitUserSelection;
    vm.moveToAccountSelection = moveToAccountSelection;
    vm.verifyEmailID=null;
    vm.verifyMobileNumber=null;
    vm.emailListData=null;
    vm.mobileListData=null;
    vm.newUpdatedEmail=null;
    vm.newUpdatedMobile=null;
    vm.selectFocus = selectFocus;
    vm.selectBlur = selectBlur;
    vm.fetchBelongsToDropdown = fetchBelongsToDropdown;
    vm.mobile_regex_digits = new RegExp(/^\+91[6-9][0-9]{9}$/);
    vm.mobile_regex_sameDigits = new RegExp(/^(\d)\1*$/);
    vm.isValid = true;
    vm.isMobileNotValid = false;
    if (dynamicNotes.noteDTO.noteDTOMap.Note_Update_Contact_Detail) {
      vm.dynamicNotes = dynamicNotes.noteDTO.noteDTOMap.Note_Update_Contact_Detail.content;
    }
     if (dynamicNotes.noteDTO.noteDTOMap.Note_Update_Contact) {
       vm.dynamicNote = dynamicNotes.noteDTO.noteDTOMap.Note_Update_Contact.content;
     }
    var counterForIncorrectValue = 0;
    var resetTimeout;
    vm.redirectToDefaultState=redirectToDefaultState;
    init();

    function init() {
      if($state.current.name === 'updateContact.update'){

        getPaylad();
      }
      UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.UPDATE_CONTACT_DETAILS);
    }


    function getPaylad(){
      var q = $stateParams.q;
      var a = q? decodeURI(q):q;
      vm.payload = angular.isDefined(a) ? $window.JSON.parse(a):{};
    }

    //removed on 10602
    /*function changeState(state) {
      if(state === vm.UPDATE_FORM_STATE.EMAIL){
        vm.payload.emailNew = angular.copy(vm.payload.email);
        if(vm.payload.emailNew===vm.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_MOBILE_NOT_UPDATED){
        vm.payload.emailNew='';
        }
      }
      if(state === vm.UPDATE_FORM_STATE.MOBILE){
        vm.payload.mobileNew = angular.copy(vm.payload.mobile);
        if(vm.payload.mobileNew===vm.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_MOBILE_NOT_UPDATED){
        vm.payload.mobileNew='';
        }
      }
      vm.CURR_STATE = vm.UPDATE_FORM_STATE[state] ? vm.UPDATE_FORM_STATE[state] : vm.UPDATE_FORM_STATE.DEFAULT;

    }*/

    function submitDetails() {

      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        var success = function (resp) {
            incorrectCount = 0;
            LoaderService.hideLoader();
            if(resp.data && resp.status){
              var payload = {};
              payload.email = resp.data.emailId?resp.data.emailId:"Not Available";
              payload.mobile = resp.data.contactNumber?resp.data.contactNumber:"Not Available";
              payload.investorId = resp.data.id;
              payload.userIdType=resp.data.userIdType;
              payload.folioNumberMasked = resp.data.folioNumber;
              payload.panNumberMasked = resp.data.encryptedPanNumber;
              payload.folioNumber = vm.payload.folioNumber;
              payload.panNumber = vm.payload.panNumber;
              clearTimeout(resetTimeout);
              $state.go('updateContact.update', {q:encodeURI($window.JSON.stringify(payload))})
            }else{
              LoaderService.hideLoader();
              if(resp&&resp.message&&resp.message.includes("Transaction Bot")){
                var successModal = function(){
                  $state.go('sessionExpired');
                };
                ModalService.offlineUserModal({text:resp.message},successModal);}
              else{if(resp.popupEnabled) {
            ModalService.genericModal({
              text:resp.message
            })
          } else {
            MessageService.error(resp.message);
            }}
          }
          },error = function (err) {
            incorrectCount++;
            LoaderService.hideLoader();
            if(err&&err.message&&err.message.includes("Transaction Bot")){
              var successModal = function(){
                $state.go('sessionExpired');
              }
              ModalService.offlineUserModal({text:err.message},successModal);
            }
            else{
              MessageService.error(err.message);
            }
            if (incorrectCount === 4) {
              vm.disableContinue = true;
              resetTimerForUpdateContact();
            }
          };

        var payload = {
          folioNumber: vm.payload.folioNumber,
          panNumber: vm.payload && vm.payload.panNumber ? AuthService.encryptRSA(angular.copy(vm.payload.panNumber)) : ''
          //bankAccountNumber: vm.payload.bankAccountNumber //removed for 10602
        };
        LoaderService.showLoader();
        InvestorService.post4({child1: 'contact', child2: 'user', child3: 'verify'}, payload).$promise.then(success, error);
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.payload.folioNumber).then(successHandler).catch(errorHandler);

    }

    function verifyEmail() {

      var success = function (resp) {
          LoaderService.hideLoader();
          if(resp.data && resp.status){
            vm.payload.otp='';
            vm.CURR_STATE = vm.UPDATE_FORM_STATE.OTP;
            CURR_VALIDATION = vm.UPDATE_FORM_STATE.EMAIL;
            singleUseURL = resp.data.secretLink;
            vm.sentOtpRespMsg = resp.data.message;
            // MessageService.success(resp.data.message);
          }else{
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };
      var payload = {
        fieldType: 'EMAIL',
        value: vm.payload.emailNew,
        panNumber: vm.payload.panNumber,
        folioNumber:vm.payload.folioNumber
      };
      LoaderService.showLoader();
      InvestorService.post({child1: 'contact', child2: 'edit'}, payload).$promise.then(success, error);
    }

    function resetDetails() {
      vm.emailEnabled = false;
      vm.mobileEnabled = false;
      vm.verifyEmailID = null;
      vm.verifyMobileNumber = null;
      vm.newUpdatedEmail = null;
      vm.newUpdatedMobile = null;
      vm.payload.mobileNew = null;
      vm.payload.emailNew = null;
      vm.payload.otpFolio = null;
      vm.payload.otp = null;
      vm.emailSelectedProfile = false;
      vm.mobileSelectedProfile = false;
      vm.emailSelectedFolio = false;
      vm.mobileSelectedFolio = false;
    }


    function verifyMobile() {

      var success = function (resp) {
          LoaderService.hideLoader();
        if(resp.data && resp.status){
          vm.payload.otp='';
          vm.CURR_STATE = vm.UPDATE_FORM_STATE.OTP;
          CURR_VALIDATION = vm.UPDATE_FORM_STATE.MOBILE;
          singleUseURL = resp.data.secretLink;
          vm.sentOtpRespMsg = resp.data.message;
          // MessageService.success(resp.data.message);
        }else{
         MessageService.error(resp.message);
        }
        },
        error = function () {
          LoaderService.hideLoader();
        };
      var payload = {
        fieldType: 'MOBILE',
        value: vm.payload.mobileNew,
        investorId: vm.payload.investorId,
        panNumber: vm.payload.panNumber,
        userIdType: vm.payload.userIdType
      };
      LoaderService.showLoader();
      InvestorService.post({child1: 'contact', child2: 'edit'}, payload).$promise.then(success, error);
    }

    function verifyOTP() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if(resp.data && resp.status){
            redirectToInitialState(vm.UPDATE_FORM_STATE.FOLIO_PROFILE);
          }else{
            vm.processFlag = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(resp.message, '', {
              onHidden: function () {
                vm.processFlag = false;
                toastrConfig.preventDuplicates = true;
              }
            });
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };
      var payload = {
        secretLink: singleUseURL,
        otp: vm.payload && vm.payload.otp ? AuthService.encryptRSA(angular.copy(vm.payload.otp)) : '' ,
        panNumber: vm.payload && vm.payload.panNumber ? AuthService.encryptRSA(angular.copy(vm.payload.panNumber)) : ''
      };
      LoaderService.showLoader();
      investorServiceVersion.post4({child1: 'contact', child2: 'edit', child3: 'verify', child4: 'otp'}, payload).$promise.then(success, error);
   }


    function verifyFolioOTP() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if(resp.data && resp.status){
            vm.isOnlineAccount=false;
            vm.isFolio = false;
            vm.folioAccountFlag = false;
            vm.onlineAccountFlag = false;
            var changeSuccess = function () {
                redirectToInitialState(vm.UPDATE_FORM_STATE.FOLIO_PROFILE);
              },
              changeError = function () {
                redirectToInitialState(vm.UPDATE_FORM_STATE.FOLIO_PROFILE);
              };
            ModalService.changePasswordSuccessModal({message: resp.data.message}, changeSuccess, changeError);
          }else{
            vm.processFlag = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(resp.message, '', {
              onHidden: function () {
                vm.processFlag = false;
                toastrConfig.preventDuplicates = true;
              }
            });
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };
      var payload = {
        folioNumber: vm.payload.folioNumber,
        isThisForFolioUsedForRegistration:"false",
        otp: vm.payload && vm.payload.otpFolio ? AuthService.encryptRSA(angular.copy(vm.payload.otpFolio)) : '',
        panNumber:vm.payload && vm.payload.panNumber ? AuthService.encryptRSA(angular.copy(vm.payload.panNumber)) : ''
      };
      LoaderService.showLoader();
      investorServiceVersion.post4({child1: 'contact', child2: 'update', child3: 'folio', child4: 'edit',child5: 'verify',child6:'otp'}, payload).$promise.then(success, error);
    }


    function mask(data){
      if(angular.isDefined(data)){
        if (data.startsWith("+", 0)) {
            var mobileSubstring = data.substring(0, 9);
            data=data.replace(mobileSubstring, "*********");
          } else {
            for (var i = 1 ; i<data.indexOf('@') ; i = i+2) {
              data=data.substr(0,i) + '*' + data.substr(i+1);}
          }
        }
        return data;
    }

    function reGenerateOtp() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if(resp.data && resp.status){
            resetTimer();
            vm.payload.otp = '';
            vm.sentOtpRespMsg = resp.data.message|| 'OTP sent again successfully again.';
            // MessageService.success(resp.data.message);
          }else{
            vm.processFlagOtp = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(resp.message, '', {
              onHidden: function () {
                vm.processFlagOtp = false;
                toastrConfig.preventDuplicates = true;
              }
            });
            if(resp.message === "Unable to resend OTP as you have exceeded the maximum OTP try limit. Please try again after 15 mins."){
              vm.timerShowFlag=false;
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err.message);
        };

      var payload = {
        folioNumber: vm.payload.folioNumber,
        panNumber: vm.payload && vm.payload.panNumber ? AuthService.encryptRSA(angular.copy(vm.payload.panNumber)) : '' ,
        fieldType: vm.emailEnabled?'EMAIL':'MOBILE',
        secretLink:singleUseURL
      };
      vm.sentOtpRespMsg = '';

      LoaderService.showLoader();
      InvestorService.post4({child1: 'contact', child2: 'edit', child3: 'resend', child4: 'otp'}, payload).$promise.then(success, error);
    }


    function reGenerateFolioOtp() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if(resp.data && resp.status){
            resetTimer();
            vm.payload.otp = '';
            vm.sentOtpRespMsg = resp.data.message|| 'OTP sent again successfully again.';
            // MessageService.success(resp.data.message);
          }else{
            vm.processFlagOtp = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(resp.message, '', {
              onHidden: function () {
                vm.processFlagOtp = false;
                toastrConfig.preventDuplicates = true;
              }
            });
            if(resp.message === "Unable to resend OTP as you have exceeded the maximum OTP try limit. Please try again after 15 mins."){
              vm.timerShowFlag=false;
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err.message);
        };
      var payload = {
        folioNumber: vm.payload.folioNumber,
        panNumber: vm.payload && vm.payload.panNumber ? AuthService.encryptRSA(angular.copy(vm.payload.panNumber)) : ''
      };
      vm.sentOtpRespMsg = '';

      LoaderService.showLoader();
      InvestorService.post4({child1: 'contact', child2: 'update', child3: 'folio', child4: 'contact',child5:'resend',child6:'otp'}, payload).$promise.then(success, error);
    }


    var resetTimer = function () {
      $scope.$broadcast('timer-add-cd-seconds', vm.CONST.RESEND_OTP_COUNTER);
    };

    function confirmCancel(state) {
      var confirmSuccess = function () {
        resetDetails();
        vm.emailSelected = false;
        vm.mobileSelected = false;
        vm.emailSelectedProfile = false;
        vm.mobileSelectedProfile = false;
        vm.emailSelectedFolio = false;
        vm.mobileSelectedFolio = false;
        vm.folioAccountFlag = false;
        vm.onlineAccountFlag = false;
        switch (state) {
          case vm.UPDATE_FORM_STATE.DEFAULT:
            $state.go("updateContactLogin");
            break;
          case vm.UPDATE_FORM_STATE.EMAIL:
          case vm.UPDATE_FORM_STATE.MOBILE:
          case vm.UPDATE_FORM_STATE.OTP:
            vm.CURR_STATE = vm.UPDATE_FORM_STATE.DEFAULT;
            $state.go("updateContactLogin");
            break;
          case vm.UPDATE_FORM_STATE.OTPFOLIO:
            vm.CURR_STATE = vm.UPDATE_FORM_STATE.DEFAULT;
            $state.go("updateContactLogin");
            break;
          default:
            vm.CURR_STATE = vm.UPDATE_FORM_STATE.DEFAULT
        }
      };
      var confirmError = function () {
      };
      ModalService.confirmCancelPreLoginModal({Text: 'Do you want to exit this page ?'}, confirmSuccess, confirmError);
    }

    vm.handleSideBarClick = function(state) {
      UtilService.updateSideBar(state);
    };

    var resetTimerForUpdateContact = function () {
      $timeout(function () {
        vm.disableContinue = false;
      }, 900000)
    };

    function changeUserSelection(type) {
      clearTimeout(resetTimeout);
      if (type === "email") {
        vm.emailEnabled = true;
        vm.verifyMobileNumber = null;
        vm.mobileEnabled = false;
      } else if (type === "mobile") {
        vm.emailEnabled = false;
        vm.verifyEmailID = null;
        vm.mobileEnabled = true;
      } else if (type === "isOnlineAccount") {
        vm.isFolio = false;
        vm.isOnlineAccount = true;
        redirectToDefaultState();
      } else if (type === "isFolio") {
        vm.isOnlineAccount=false;
        vm.isFolio=true;
        redirectToDefaultState();
      }
      if (type === "emailChange") {
        vm.emailEnabled = true;
        vm.verifyMobileNumber = null;
        vm.mobileEnabled = false;
        vm.newUpdatedMobile = null;
        vm.payload.emailNew = null;
        vm.emailBelongsTo = null;
        vm.emailBelongsToProfile = null;
        redirectToDefaultState();
      } else if (type === "mobileChange") {
        vm.emailEnabled = false;
        vm.verifyEmailID = null;
        vm.mobileEnabled = true;
        vm.newUpdatedEmail = null;
        vm.payload.mobileNew = null;
        vm.mobileBelongsTo = null;
        vm.mobileBelongsToProfile = null;
        redirectToDefaultState();
      }
    }


    function updateProfileContact() {

      if (vm.isFolio) {
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              vm.isOnlineAccount=false;
              vm.isFolio = false;
              vm.folioAccountFlag = false;
              vm.onlineAccountFlag = false;
              redirectToInitialState(vm.UPDATE_FORM_STATE.OTPFOLIO);
              vm.sentOtpRespMsg = resp.data.message;
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader();
          };
        var payload = {
          changeFor: 'Folio',
          folioNumber: vm.payload.folioNumber,
          fieldType: vm.mobileEnabled ? 'MOBILE' : 'EMAIL',
          value: vm.mobileEnabled ? vm.payload && vm.payload.mobileNew ?AuthService.encryptRSA(angular.copy(vm.payload.mobileNew)):'' : vm.payload && vm.payload.emailNew? AuthService.encryptRSA(angular.copy(vm.payload.emailNew)):'',
          panNumber: vm.payload && vm.payload.panNumber ? AuthService.encryptRSA(angular.copy(vm.payload.panNumber)) : ''
        };

        if(vm.mobileEnabled) {
          payload.mobileBelongsTo = vm.mobileBelongsTo;
          delete payload.emailBelongsTo;
        } else {
          payload.emailBelongsTo = vm.emailBelongsTo;
          delete payload.mobileBelongsTo;
        }

        LoaderService.showLoader();
        InvestorService.post4({
          child1: 'contact',
          child2: 'update',
          child3: 'contact',
          child4: 'details'
        }, payload).$promise.then(success, error);
      }
       else if (vm.isOnlineAccount) {
        var successProfile = function (resp) {
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              MessageService.success(resp.data.message);
              vm.isOnlineAccount=false;
              vm.isFolio = false;
              vm.folioAccountFlag = false;
              vm.onlineAccountFlag = false;
              redirectToInitialState(vm.UPDATE_FORM_STATE.FOLIO_PROFILE);
            } else {
              MessageService.error(resp.message);
            }
          },
          errorProfile = function () {
            LoaderService.hideLoader();
          };

        var payloadProfile = {
          changeFor: 'Investor',
          fieldType: vm.mobileEnabled ? 'MOBILE' : 'EMAIL',
          investorId: vm.payload.investorId,
          value: vm.mobileEnabled ? vm.newUpdatedMobile ? AuthService.encryptRSA(angular.copy(vm.newUpdatedMobile)):'' : vm.newUpdatedEmail ? AuthService.encryptRSA(angular.copy(vm.newUpdatedEmail)) : '',
          panNumber: vm.payload && vm.payload.panNumber ? AuthService.encryptRSA(angular.copy(vm.payload.panNumber)) : ''
        };


        if(vm.mobileEnabled) {
          payloadProfile.mobileBelongsTo = vm.mobileBelongsToProfile;
          delete payloadProfile.emailBelongsTo;
        } else {
          payloadProfile.emailBelongsTo = vm.emailBelongsToProfile;
          delete payloadProfile.mobileBelongsTo;
        }

        LoaderService.showLoader();
        InvestorService.post4({
          child1: 'contact',
          child2: 'update',
          child3: 'contact',
          child4: 'details'
        }, payloadProfile).$promise.then(successProfile, errorProfile);
      }
      }

    /* api implementation needs to be implemented here*/
    function submitUserSelection() {

      var success = function (resp) {
          LoaderService.hideLoader();
          if(resp.data && resp.status){
            counterForIncorrectValue=0;
            vm.payload.otp='';
            redirectToInitialState(vm.UPDATE_FORM_STATE.OTP);
            singleUseURL = resp.data.secretLink;
            vm.sentOtpRespMsg = resp.data.message;
          }else{
            counterForIncorrectValue=counterForIncorrectValue+1;
            if(counterForIncorrectValue>3)
              $state.go("updateContactLogin");
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
        };
      var payload = {
        fieldType: vm.emailEnabled?'EMAIL':'MOBILE',
        value: vm.emailEnabled?AuthService.encryptRSA(angular.copy(vm.verifyEmailID)):AuthService.encryptRSA(angular.copy(vm.verifyMobileNumber)),
        panNumber:vm.payload && vm.payload.panNumber ? AuthService.encryptRSA(angular.copy(vm.payload.panNumber)) : '',
        folioNumber:vm.payload.folioNumber
      };
      LoaderService.showLoader();
      investorServiceVersion.post4({child1: 'contact', child2: 'edit'}, payload).$promise.then(success, error);
    }

    /* api implementation needs to be implemented here if required*/
    function moveToAccountSelection() {
      if (vm.isFolio) {
        var success = function (resp) {
            LoaderService.hideLoader();
            if(resp.data && resp.status){
              fetchBelongsToDropdown()
              vm.payload.emailFolio=resp.data.email?resp.data.email:'Not Available';
              vm.payload.mobileFolio=resp.data.mobileNumber?resp.data.mobileNumber:'Not Available';
              redirectToInitialState(vm.UPDATE_FORM_STATE.UPDATE_FOLIO);
            }else{
              MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader();
          };

          resetDetails();
        var payload = {
          changeFor:'Folio',
          panNumber: vm.payload && vm.payload.panNumber ? AuthService.encryptRSA(angular.copy(vm.payload.panNumber)) : '',
          folioNumber:vm.payload.folioNumber
        };
        LoaderService.showLoader();
        InvestorService.post4({child1: 'contact', child2: 'update',child3:'folio',child4:'profile'}, payload).$promise.then(success, error);
     } else if (vm.isOnlineAccount) {
        var successProfile = function (resp) {
            LoaderService.hideLoader();
            if(resp.data && resp.status){
              fetchBelongsToDropdown()
              vm.payload.emailProfile = resp.data.email?resp.data.email:"Not Available";
              vm.payload.mobileProfile = resp.data.mobileNumber?resp.data.mobileNumber:"Not Available";
              redirectToInitialState(vm.UPDATE_FORM_STATE.UPDATE_ONLINE_ACCOUNT);
              var folioList = resp.data.folios;
              var emailList = [];
              var mobileList = [];
              for (var i = 0; i < folioList.length; i++) {
                if(folioList[i].emailId)
                  emailList.push(folioList[i]);
                if(folioList[i].mobileNumber)
                  mobileList.push(folioList[i]);
              }
              vm.emailListData = emailList.length ? emailList : null;
              vm.mobileListData = mobileList.length ? mobileList : null;
            }else{
              MessageService.error(resp.message);
            }
          },
          errorProfile = function () {
            LoaderService.hideLoader();
          };

        resetDetails();
        var payloadProfile = {
          changeFor:'Investor',
          panNumber: vm.payload && vm.payload.panNumber ? AuthService.encryptRSA(angular.copy(vm.payload.panNumber)) : '',
          folioNumber:vm.payload.folioNumber
        };
        LoaderService.showLoader();

        InvestorService.post4({child1: 'contact', child2: 'update',child3:'folio',child4:'profile'}, payloadProfile).$promise.then(successProfile, errorProfile);

      }
    }


    function redirectToDefaultState() {
      clearTimeout(resetTimeout);
      if ($window.sessionStorage.getItem("timeoutIds") !== "") {
        clearTimeout($window.sessionStorage.getItem("timeoutIds"));
        $window.sessionStorage.setItem("timeoutIds", "");
      }
      resetTimeout = $window.setTimeout(performRedirection, 900000);
      $window.sessionStorage.setItem("timeoutIds", resetTimeout);

      if(vm.mobileEnabled && vm.payload.mobileNew !== null) {
        vm.isValid = vm.mobile_regex_digits.test(vm.payload.mobileNew)

        if(vm.isValid && vm.payload.mobileNew && vm.payload.mobileNew.length == 13) {
          vm.isMobileNotValid = vm.mobile_regex_sameDigits.test(vm.payload.mobileNew.substring(3))
        }

      }

    }

    function performRedirection() {
      $state.go("updateContactLogin");
    }


    function redirectToInitialState(state) {

      if(state!==vm.UPDATE_FORM_STATE.OTP)
        redirectToDefaultState();

      switch (state) {
        case vm.UPDATE_FORM_STATE.MOBILE:
          vm.CURR_STATE = vm.UPDATE_FORM_STATE.MOBILE;
          break;
        case vm.UPDATE_FORM_STATE.EMAIL:
          vm.CURR_STATE = vm.UPDATE_FORM_STATE.EMAIL;
          break;
        case vm.UPDATE_FORM_STATE.UPDATE_ONLINE_ACCOUNT:
          vm.CURR_STATE = vm.UPDATE_FORM_STATE.UPDATE_ONLINE_ACCOUNT;
          break;
        case vm.UPDATE_FORM_STATE.OTP:
          vm.CURR_STATE = vm.UPDATE_FORM_STATE.OTP;
          break;
        case vm.UPDATE_FORM_STATE.OTPFOLIO:
          vm.CURR_STATE = vm.UPDATE_FORM_STATE.OTPFOLIO;
          break;
        case vm.UPDATE_FORM_STATE.FOLIO_PROFILE:
          vm.CURR_STATE = vm.UPDATE_FORM_STATE.FOLIO_PROFILE;
          break;
        case vm.UPDATE_FORM_STATE.UPDATE_FOLIO:
          vm.CURR_STATE = vm.UPDATE_FORM_STATE.UPDATE_FOLIO;
          break;
        case vm.UPDATE_FORM_STATE.DEFAULT:
          break;
      }

    }

    vm.redirectToLogin = function() {
      clearTimeout(resetTimeout);
      if ($window.sessionStorage.getItem("timeoutIds") !== "") {
        clearTimeout($window.sessionStorage.getItem("timeoutIds"));
        $window.sessionStorage.setItem("timeoutIds", "");
      }
      $state.go("login");
    }


    function selectFocus(id) {
      angular.element("#" + id).css("color", "#619ADE");
    }

    function selectBlur(id) {
      angular.element("#" + id).css("color", "#505050");
    }

    function fetchBelongsToDropdown() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.belongToListEmail = resp.data.emailList;
          vm.belongToListMobile = resp.data.mobileList;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        $log.info('Belongs Dropdown error >>>>', err);
      };

      InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
    }

  }
})();

(function () {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('wekycController', wekycController);
    /** @ngInject */
    function wekycController($stateParams, LoaderService, $timeout, $sce, AppConstants, InvestorService, UtilService, MessageService, InvestorServiceVersion3) {
        var vm = this;
        vm.ekycData = {};
        vm.formData = {};
        vm.actionUrl = "";
        vm.init = init;
        vm.payload = { email: '', mobile: '', sessId: '' };
        vm.pattern = AppConstants;
        vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
        function getcipherText(cipherData) {
            var cipherText = cipherData;
            var key = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-|_x";
            var message = "";
            var shiftKey = 10;
            for (var i = 0; i < cipherText.length; i++) {
                var charPosition = key.indexOf(cipherText.charAt(i));
                var keyVal = (charPosition - shiftKey) % 39;
                if (keyVal < 0) {
                    keyVal = key.length + keyVal;
                }
                var replaceVal = key.charAt(keyVal);
                message += replaceVal;
            }
            return message;
        }
        function init() {
            if ($stateParams.key) {
                var success = function (resp) {
                    if (resp.status && resp.data) {
                        if(resp.data.ekycRequestCO && resp.data.registrationType == "NEW"){
                            LoaderService.hideLoader();
                            vm.ekycData = resp.data.ekycRequestCO;
                            vm.actionUrl = $sce.trustAsResourceUrl(vm.ekycData.camsUrl);
                            vm.formData = {
                                url: vm.ekycData.url,
                                sess_id: vm.ekycData.sess_id,
                                ekyctype: vm.ekycData.ekyctype,
                                plkyc_type: vm.ekycData.plkyc_type,
                                kyc_data: vm.ekycData.kycData
                            };
                        }else{
                            MessageService.error("The PAN is already kyc verified.");
                        }
                    } else {
                        MessageService.error(resp.message);
                    }
                }, error = function (err) {
                    UtilService.errorHandler(err);
                };
                var taxIdentifier = '';
                taxIdentifier =  $stateParams.key.replace(/"/,'');
                taxIdentifier =  $stateParams.key.replace(/'/,'');
                var taxIdentifierNumber = getcipherText(taxIdentifier);
                vm.payload = {};
                vm.payload.panNumber = taxIdentifierNumber;
                LoaderService.showLoader();
                InvestorServiceVersion3.post({ child1: "registration", child2: "verifyKYC" }, vm.payload).$promise.then(success, error);
            } else {
                MessageService.error("Something Went wrong.Please check url.");
                LoaderService.showLoader();
            }
        }
        init();
        vm.handleProceedAction = function () {
            var success = function (resp) {
                LoaderService.hideLoader();
                if (resp.status && resp.data) {
                    LoaderService.showLoader();
                    vm.formData = {
                        url: vm.ekycData.url,
                        sess_id: vm.ekycData.sess_id,
                        ekyctype: vm.ekycData.ekyctype,
                        plkyc_type: vm.ekycData.plkyc_type,
                        kyc_data: resp.data.kycData
                    };
                    $timeout(function () {
                        angular.element('#ekycForm').submit();
                    }, 100);
                } else {
                    MessageService.error(resp.message);
                }
            },
                error = function (err) {
                    LoaderService.hideLoader();
                    UtilService.errorHandler(err);
                };
            vm.payload.sessId = vm.ekycData.sess_id;
            InvestorService.post({
                child1: 'registration',
                child2: 'save',
                child3: 'contact',
                child4: 'details',
                child5: 'eKyc'
            }, vm.payload).$promise.then(success, error);
        };
    }
})();

/**
 * Created by ttn on 6/12/16.
 */

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('TransactionsService', transactionsService);

  /** @ngInject */
  function transactionsService() {
    var factory = {};
    var overviewData = {};

    factory.setTransactionOverview = function (data) {
      overviewData = data;
    };
    factory.getTransactionOverview = function () {
      return overviewData;
    };
    factory.resetTransactionOverview = function () {
      overviewData = {};
    };

    return factory;
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('TransactionModel', transactionModel)
    .factory('FolioModel', folioModel);

  /** @ngInject */
  function transactionModel() {
    var payload = null,dreamSipPayload = null, masterRawData = {
      STP: {
        isThroughDistributor: false,
        isDirect: true,
        isThroughRia: false,
        brokerCode: '',
        brokerName: '',
        euin: '',
        euinOpted: 'N',
        folioNumber: '',
        outSchemeCode: '',
        outSchemeName: '',
        inSchemeCode: '',
        inSchemeName: '',
        dividendOption: '',
        transferOption: 'F',
        frequency: '',
        day: '',
        startDate: '',
        endDate: '',
        amount: '',
        transactionId: '',
        noOfInstallments: '',
        isBackFromSummary: false
      },
      SWP: {
        folioNumber: '',
        outSchemeCode: '',
        outSchemeName: '',
        transferOption: 'F',
        amount: '',
        frequency: '',
        day: '',
        startDate: '',
        endDate: '',
        minEndDate:null,
        transactionId: '',
        bankInfo: '',
        isBackFromSummary: false
      },
      SMART_SWAP: {
        folioNumber: '',
        outSchemeCode: '',
        outSchemeName: '',
        transferOption: 'F',
        amount: '',
        frequency: null,
        day: '',
        startDate: '',
        endDate: '',
        minEndDate:null,
        transactionId: '',
        bankInfo: '',
        isBackFromSummary: false
      },
      REDEMPTION: {
        folioNumber: '',
        outSchemeCode: '',
        outSchemeName: '',
        amountType: 'amount',
        amount: '',
        units: '',
        transactionId: '',
        bankInfo: '',
        isBackFromSummary: false
      },
      INSTANT_REDEMPTION: {
        folioNumber: '',
        outSchemeCode: '',
        outSchemeName: '',
        amountType: 'amount',
        amount: '',
        units: '',
        transactionId: '',
        bankInfo: '',
        isBackFromSummary: false
      },
      SWITCH: {
        isThroughDistributor: false,
        isDirect: true,
        isThroughRia: false,
        brokerCode: '',
        brokerName: '',
        euin: '',
        euinOpted: 'N',
        folioNumber: '',
        outSchemeCode: '',
        outSchemeName: '',
        inSchemeCode: '',
        inSchemeName: '',
        dividendOption: '',
        amountType: 'amount',
        amount: '',
        units: '',
        transactionId: '',
        isBackFromSummary: false
      },
      'SIP': {
        folioNumber: '',
        isThroughDistributor: false,
        isDirect: true,
        isThroughRia: false,
        isEuin:true,
        brokerCode: '',
        riaBrokerCode: '',
        riaBrokerName: '',
        brokerName: '',
        euin: '',
        euinOpted: 'N',
        optionalInvestmentType: '',
        investmentType:'SIP',
        dividendOption: '',
        frequency: '',
        day: '',
        month:'',
        endMonthYear:'',
        startDate: '',
        endDate: '',
        minEndDate:null,
        sipPaymentOption: '',
        bankAcNo: '',
        ifscCode: '',
        bankBranch: '',
        bankCity: '',
        bankName: '',
        bankInfo: '',
        otmId: '',
        purchaseInSchemeCode: '',
        purchaseInSchemeName: '',
        purchaseAmount: '',
        purchaseDividendOption: '',
        purchaseInvestmentOption: '',
        purchasePaymentOption: '',
        pTransactionId: '',
        sTransactionId: '',
        isTillPerpetuity: false,
        isBackFromSummary: false,
        sipDividendOption:'N',
        dynamicData : { readOnly : false },
        topupDetails: {},
        sipTopupSelected : false,
        sipTopupEnabled:false,
        sipFirstInstallment:true,
        sipFirstAmount:'',
        journey: ''
      },
      'PURCHASE': {
        folioNumber: '',
        isThroughDistributor: false,
        isDirect: true,
        isThroughRia: false,
        isEuin:true,
        brokerCode: '',
        brokerName: '',
        riaBrokerCode: '',
        riaBrokerName: '',
        euin: '',
        euinOpted: 'N',
        optionalInvestmentType: '',
        investmentType:'PURCHASE',
        dividendOption: '',
        frequency: '',
        day: '',
        startDate: '',
        endDate: '',
        sipPaymentOption: '',
        bankAcNo: '',
        ifscCode: '',
        bankBranch: '',
        bankCity: '',
        bankName: '',
        bankInfo: '',
        otmId: '',
        purchaseInSchemeCode: '',
        purchaseInSchemeName: '',
        purchaseAmount: '',
        purchaseDividendOption: '',
        purchaseInvestmentOption: '',
        purchasePaymentOption: '',
        pTransactionId: '',
        sTransactionId: '',
        isTillPerpetuity: false,
        isBackFromSummary: false,
        retirementAgeProofURL: '',
        dynamicData : { readOnly : false },
        isCheckedTandC: false,
        sipDetailsViaPurchase: {},
        sipViaPurchaseEnabled: false,
        sipViaPurchaseSelected: false,
        journey: ''
      },
      DTP: {
        isThroughDistributor: false,
        brokerCode: '',
        brokerName: '',
        euin: '',
        euinOpted: 'N',
        folioNumber: '',
        outSchemeCode: '',
        outSchemeName: '',
        inSchemeCode: '',
        inSchemeName: '',
        dividendOption: '',
        transactionId: '',
        isBackFromSummary: false
      },
      'FLEX_INDEX':{
          isThroughDistributor: false,
          isDirect: true,
          isThroughRia: false,
          brokerCode: '',
          brokerName: '',
          euin: '',
          euinOpted: 'N',
          folioNumber: '',
          outSchemeCode: '',
          outSchemeName: '',
          inSchemeCode: '',
          inSchemeName: '',
          dividendOption: '',
          transferOption: 'F',
          frequency: '',
          day: '',
          startDate: '',
          endDate: '',
          amount: '',
          transactionId: '',
          noOfInstallments: 0,
          isBackFromSummary: false
      },
      'DREAMSIP': {
          folioNumber: '',
          isThroughDistributor: false,
          isDirect: true,
          isThroughRia: false,
          isEuin:true,
          brokerCode: '',
          riaBrokerCode: '',
          riaBrokerName: '',
          brokerName: '',
          euin: '',
          euinOpted: 'N',
          optionalInvestmentType: '',
          investmentType:'SIP',
          dividendOption: '',
          frequency: 'OM',
          startDate: '',
          endDate: '',
          minEndDate:null,
          sipPaymentOption: '',
          bankAcNo: '',
          ifscCode: '',
          bankBranch: '',
          bankCity: '',
          bankName: '',
          bankInfo: '',
          otmId: '',
          isBackFromSummary: false,
          sipDividendOption:'Y',
          dynamicData : { readOnly : false },
          topupDetails: {},
          sipTopupSelected : false,
          sipTopupEnabled:false
      },
      'FLEX_SIP': {
        folioNumber: '',
        isThroughDistributor: false,
        isDirect: true,
        isThroughRia: false,
        isEuin:true,
        brokerCode: '',
        riaBrokerCode: '',
        riaBrokerName: '',
        brokerName: '',
        euin: '',
        euinOpted: 'N',
        optionalInvestmentType: '',
        dividendOption: '',
        frequency: '',
        day: '',
        month:'',
        endMonthYear:'',
        startDate: '',
        endDate: '',
        minEndDate:null,
        sipPaymentOption: '',
        bankAcNo: '',
        ifscCode: '',
        bankBranch: '',
        bankCity: '',
        bankName: '',
        bankInfo: '',
        otmId: '',
        purchaseInSchemeCode: '',
        purchaseInSchemeName: '',
        purchaseAmount: '',
        purchaseDividendOption: '',
        purchaseInvestmentOption: '',
        purchasePaymentOption: '',
        pTransactionId: '',
        sTransactionId: '',
        isTillPerpetuity: false,
        isBackFromSummary: false,
        sipDividendOption:'Y',
        dynamicData : { readOnly : false }
      },
      'SCHEDULE_TRANSACTION': {
        folioNumber: '',
        isThroughDistributor: false,
        isDirect: true,
        isThroughRia: false,
        isEuin:false,
        brokerCode: '',
        brokerName: '',
        riaBrokerCode: '',
        riaBrokerName: '',
        euin: '',
        euinOpted: 'N',
        optionalInvestmentType: '',
        investmentType:'Schedule_Transaction',
        dividendOption: '',
        frequency: 'OM',
        day: '',
        startDate: '',
        endDate: '',
        sipPaymentOption: '',
        bankAcNo: '',
        ifscCode: '',
        bankBranch: '',
        bankCity: '',
        bankName: '',
        bankInfo: '',
        otmId: '',
        purchaseInSchemeCode: '',
        purchaseInSchemeName: '',
        purchaseAmount: 5000,
        purchaseDividendOption: '',
        purchaseInvestmentOption: '',
        purchasePaymentOption: '',
        pTransactionId: '',
        sTransactionId: '',
        isTillPerpetuity: false,
        isBackFromSummary: false,
        retirementAgeProofURL: '',
        dynamicData : { readOnly : false },
        isCheckedTandC: false
      }
    };

    var specificProperties = {
      STP:{
        stpType : 'normalStp',
        showDateOfTransfer : false,
        showDayOfTransfer : false,
        showStartEndDate : false,
        showInstallment : false
      },
      SWP:{}, REDEMPTION : {}, SWITCH: {},'SIP-PURCHASE': {}, DTP:{},
      'FLEX_INDEX':{
        investmentMode : 'Fixed',
        validations:{
          stagesValid : false,
          installmentsValid :false,
          installmentsSumHundred:false,
          installment1:true,
          installment2:true,
          installment3:true,
          installment4:true,
          stage1:true,
          stage2:true,
          stage3:true,
          stage4:true
        },
        investmentModeData : {
          installment1:'',
          installment2:'',
          installment3:'',
          installment4:'',
          stage1:'',
          stage2:'',
          stage3:'',
          stage4:''
        }
      }
    }
    function getTransactionSpecificProperties(type) {
      return angular.copy(specificProperties[type]);
    }

    function getMasterRawData(type) {
      type = type?type.toUpperCase():type;
      // if (type.toUpperCase() === 'SIP' || type === 'PURCHASE') {
      //   return angular.copy(masterRawData['SIP-PURCHASE']);
      // }
      return angular.copy(masterRawData[type]);
    }

    function getPayloadRawData() {
      return angular.copy(payload);
    }

    function setPayloadRawData(_payload) {
      payload = angular.copy(_payload);
    }

    function getDreamSipPayloadRawData() {
      return angular.copy(dreamSipPayload);
    }

    function setDreamSipPayloadRawData(_dreamSipPayload) {
      dreamSipPayload = angular.copy(_dreamSipPayload);
    }

    return {
      getDreamSipPayloadRawData: getDreamSipPayloadRawData,
      setDreamSipPayloadRawData: setDreamSipPayloadRawData,
      getPayloadRawData: getPayloadRawData,
      setPayloadRawData: setPayloadRawData,
      getMasterRawData: getMasterRawData,
      getTransactionSpecificProperties: getTransactionSpecificProperties
    };
  }

  /** @ngInject */
  function folioModel() {
    var payload = null;

    function  getFolioData() {
        return angular.copy(payload);
    }

    function setFolioData(_payload) {
      payload = angular.copy(_payload);
    }

    return {
      getFolioData: getFolioData,
      setFolioData: setFolioData
    };
  }



})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TransactionController', transactionController);

  /** @ngInject */
  function transactionController($log, $timeout, $stateParams, MessageService, ModalService, InvestorService, DownloadPdfService,
                                 SchemeService, TransactionService, AppConstants, $state, LoaderService, UtilService,
                                 moment, TransactionModel, AuthService, StpHelper, FileSaver, Blob,
                                 FlexIndexHelper, SwpHelper, InvestorFileUploadService, InstantRedemptionHelper, SwitchHelper, $window, investorServiceVersion ,DynamicDataReview ,termsCondition,panAadharService) {
    var vm = this;
    vm.fill_end_date = '';
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    vm.transactionType = getTransactionTypeFromStateParams() || getTransactionType();
    vm.formData = TransactionModel.getPayloadRawData() || TransactionModel.getMasterRawData(vm.transactionType) || {};
    vm.devidendOptionsOther = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT];
    vm.devidendOptionsELSS = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];
    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.specificProperties = TransactionModel.getTransactionSpecificProperties(vm.transactionType);
    vm.folioList = null;
    vm.unitsDetails = null;
    vm.inSchemeValidations = null;
    vm.outSchemeValidations = null;
    vm.validations = {};
    vm.isRequired = false;
    vm.bankList = null;
    vm.outSchemeList = null;
    vm.inSchemeList = null;
    vm.masterInSchemeList = null;
    vm.masterOutSchemeList = null;
    vm.masterPurchaseInSchemeList = null;
    vm.tForm = {};
    vm.isSaving = false;
    vm.isReseting = false;
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.minStartDate = $window.moment();
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.daysList = getDaysList();
    vm.weekList = vm.TRANSACTIONS_CONST.WEEKS_LISTS;
    vm.isSchemeDisabled = false;
    vm.isShowDefault = 'false';
    vm.purchaseMinAmount = 0;
    vm.isPurchaseMin = false;
    vm.viewMode = 'days';
    vm.euinList = null;
    vm.distributorList = null;
    vm.isInvalidForm = false;
    vm.stpType = 'normalStp';
    vm.isCheckedTandC = false;
    vm.profile = AuthService.getToken();
    var name = vm.profile && vm.profile.investorFName ? vm.profile.investorFName.toLowerCase() : '';
    vm.investorName = name.charAt(0).toUpperCase() + name.slice(1);
    vm.calenderEndDateString = '31-Dec-2036';
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.retirementAgeProofURL = '';
    vm.chooseAFile = true;
    vm.amountInWords = '';
    vm.isSourceSchemeGrowth = false;
    vm.isSchemeTypeELSS = false;
    vm.showBankInfo = false;

    vm.schemeTypeForValidation = '';
    vm.checkRedeemValidations = checkRedeemValidations;
    vm.checkSipValidations = checkSipValidations;
    vm.checkSwpStpValidations = checkSwpStpValidations;
    vm.checkSwitchValidations = checkSwitchValidations;
    vm.checkInstantRedeemValidations = checkInstantRedeemValidations;
    vm.updateEndDates = updateEndDates;
    vm.checkValidations = checkValidations;
    vm.extractValidationObject = extractValidationObject;
    vm.fetchSwitchInSchemes = fetchSwitchInSchemes;
    vm.fetchSwitchInSchemeValidations = fetchSwitchInSchemeValidations;
    vm.resetAll = resetAll;
    vm.amountChanged = amountChanged;
    vm.blured = blured;
    vm.helper = getHelper();
    vm.isOTMAmount = false;
    vm.isOTMDate = false;
    vm.isArnSuccess = true;
    vm.isSubarnSuccess = false;
    vm.brokerCodeError = '';
    vm.subBrokerCodeError = '';
    vm.showCalender = true;
    vm.validationsApi = {};
    vm.isMinApi = false;
    vm.isMaxApi = false;
    vm.changeBank = changeBank;
    vm.scheduleTransactionDetails = null;
    vm.kycVerifiedFlag = null;
    vm.riaCodeError = "";
    vm.redeemNudgeDetails = {};
    vm.nudgePayload = {};
    vm.requestId = '';
    vm.nudgeMessage = '';
    vm.DynamicDataReview = DynamicDataReview ;
    vm.notes = {};
    vm.popup = {};
    vm.TermsCondition = {};
    vm.TermsConditionSchedule = {};
    vm.notesReview = {};
    vm.noteReviewSchedule = {};
    vm.notesSchedule = {};
    vm.euinBoxMessage = {};
    vm.riaMessage = {};
    vm.setDynamicData = setDynamicData;
    vm.showTerms = true;
    vm.euinData = {};
    vm.appConstantsData = angular.copy(AppConstants);
    AuthService.checkLinkedUserStatus();


    /*
    * setting up dynamic data variables
    */
    setDynamicData();
    var successHandler = function(resp) {
      if(Object.keys(resp.termAndConditionDTO.termAndConditionDTOMap).length == 0 || !resp.termAndConditionDTO.termAndConditionDTOMap[vm.key])
         {
           vm.showTerms = false;
         }
      }

      if(vm.transactionType !== 'INSTANT_REDEMPTION')
        {
            termsCondition.fetchData(vm.transactionType).then(successHandler).catch(function(resp) {
              MessageService.error(resp);
           });
        }


    if (vm.formData.stpType === 'T') {
      vm.specificProperties.stpType = 'flexStp';
    } else if (vm.formData.stpType === 'Q') {
      vm.specificProperties.stpType = 'swingStp';
    }

    function getHelper() {
      var helper = null;

      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP:
          helper = StpHelper;
          helper.setViewModel(vm);
          vm.specificProperties.stpType = $stateParams.referrer ? $stateParams.referrer : 'normalStp';
          getRandomOTPID();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX:
          helper = FlexIndexHelper;
          helper.setViewModel(vm);
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          helper = SwpHelper;
          helper.setViewModel(vm);
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION:
          helper = InstantRedemptionHelper;
          helper.setViewModel(vm);
          getRandomOTPID();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH:
          helper = SwitchHelper;
          helper.setViewModel(vm);
          getRandomOTPID();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP:
          getRandomOTPID();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION:
          getRandomOTPID();
          break;
      }


      return helper;

    }

    /**
     * Function responsible for setting data when getting data from state parameters
     */

    function setStateParams() {

      if($stateParams.folioNumber){
        vm.formData.folioNumber = $stateParams.folioNumber ? $stateParams.folioNumber : vm.formData.folioNumber;
        if(vm.folioListToBlockTxnsaction && vm.folioListToBlockTxnsaction.includes(vm.formData.folioNumber)){
          if(vm.appConstantsData.TRANSACTION_CONST_LIST_TO_BLOCK.includes(vm.transactionType)){
            var success = function(){
              if(vm.blockFolioForTransaction){
                vm.formData.folioNumber = null;
                var oldData = angular.copy(vm.formData);
                resetAll();
                recoverFromResetting(oldData);
              }
            }, error = function(){};
            ModalService.genericModal({isUpi : true, text : vm.popUpMessage}, success, error);
          }
        }
        vm.formData.outSchemeCode = $stateParams.sc ? $stateParams.sc : vm.formData.outSchemeCode;
        fetchOutSchemes();
      }

      if ($stateParams.isFavourite) {
        vm.formData.isFavourite = true;
      } else {
        vm.formData.isFavourite = vm.formData.isFavourite || false;
      }
    }
    function getDaysList() {
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
        return vm.TRANSACTIONS_CONST.SIP_DAYS_LIST;
      } else {
        return vm.TRANSACTIONS_CONST.DAYS_LIST;
      }

    }

    function amountChanged(className) {
      UtilService.currentFocusedElement.set(className);
      vm.checkSwpStpValidations();
    }

    function blured() {
      UtilService.currentFocusedElement.clear();
    }


    function resetAll() {
      vm.formData.amountType = vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT;
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.inSchemeType = '';
      vm.formData.outSchemeCode = '';
      vm.formData.outSchemeName = '';
      vm.formData.dividendOption = '';
      vm.formData.frequency = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? vm.frequencyList[0].key : null;
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.bankInfo = null;
      vm.formData.day = null;
      vm.formData.isTillPerpetuity = false;
      vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
      vm.formData.month = '';

      vm.formData.euin = {};
      vm.formData.brokerCode = '';
      vm.formData.brokerName = '';
      vm.euinList = null;
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.formData.distributerName = '';
      vm.formData.subBrokerARN = '';
      vm.formData.subBrokerCode = '';
      vm.isCheckedTandC = false;
      vm.isArnSuccess = true;

      vm.inSchemeValidations = null;
      vm.outSchemeValidations = null;
      vm.validations = {};
      vm.isRequired = false;
      vm.bankList = null;
      vm.outSchemeList = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList);
      // vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
      vm.unitsDetails = null;
      vm.formData.noOfInstallments = '';
      vm.distributorList = [];
      resetNumInWords(); //reset the number in text form on folio change or form reset

      resetBankDetails();
      if (vm.specificProperties && vm.specificProperties.investmentModeData) {
        vm.specificProperties.investmentModeData.stage1 = '';
        vm.specificProperties.investmentModeData.stage2 = '';
        vm.specificProperties.investmentModeData.stage3 = '';
        vm.specificProperties.investmentModeData.stage4 = '';
      }
      manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
      vm.formData.bankInfo = null;
      if (vm.tForm.$pristine) {
        vm.tForm.$setPristine();
      }
    }

    function resetNumInWords() {
      vm.amountInWords = '';
      var inWordsDiv = document.getElementById('divDisplayWords');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
    }

    function reSetting() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function extractValidationObject(validationsData) {

      if (!validationsData || !vm.formData.frequency) {
        return;
      }

      vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
      vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
      vm.validations.minInstallments = vm.validations.minInstallments || 6;
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.maxAmount = vm.validations.maxAmount || 0;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > 0 && vm.validations.maxAmount < vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }

      var amountMultiples = 1;
      var maxAmount = 0;
      var maxInstallments = 0;
      var minInstallments = 0;
      var minAmount = 0;

      switch (vm.formData.frequency) {
        case 'DZ':
          amountMultiples = validationsData.dailyAmtMultiples;
          maxAmount = validationsData.dailyMaxAmt;
          maxInstallments = validationsData.dailyMaxInstallmentNumber;
          minAmount = validationsData.dailyMinAmt;
          minInstallments = validationsData.dailyMinInstallmentNumber;
          break;
        case 'OW':
          amountMultiples = validationsData.weeklyAmtMultiples;
          maxAmount = validationsData.weeklyMaxAmt;
          maxInstallments = validationsData.weeklyMaxInstallmentNumber;
          minAmount = validationsData.weeklyMinAmt;
          minInstallments = validationsData.weeklyMinInstallmentNumber;
          break;
        case 'Q':
          amountMultiples = validationsData.quarterlyAmtMultiples;
          maxAmount = validationsData.quarterlyMaxAmt;
          maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
          minAmount = validationsData.quarterlyMinAmt;
          minInstallments = validationsData.quarterlyMinInstallmentNumber;
          break;
        case 'OM':
          amountMultiples = validationsData.monAmtMultiples;
          maxAmount = validationsData.monMaxAmt;
          maxInstallments = validationsData.monMaxInstallmentNumber;
          minAmount = validationsData.monMinAmt;
          minInstallments = validationsData.monMinInstallmentNumber;
          break;
        case 'H':
          amountMultiples = validationsData.halfYearlyAmtMultiples;
          maxAmount = validationsData.halfYearlyMaxAmt;
          maxInstallments = validationsData.halfYearlyMaxInstallmentNumber;
          minAmount = validationsData.halfYearlyMinAmt;
          minInstallments = validationsData.halfYearlyMinInstallmentNumber;
          break;
        case 'Y':
          amountMultiples = validationsData.yearlyAmtMultiples;
          maxAmount = validationsData.yearlyMaxAmt;
          maxInstallments = validationsData.yearlyMaxInstallmentNumber;
          minAmount = validationsData.yearlyMinAmt;
          minInstallments = validationsData.yearlyMinInstallmentNumber;
          break;
      }

      vm.validations.amountMultiples = amountMultiples;
      vm.validations.maxInstallments = maxInstallments;
      vm.validations.minInstallments = minInstallments;
      vm.validations.minAmount = minAmount;
      vm.validations.maxAmount = maxAmount;
      vm.validations.amountMultiples = null;
      vm.isMultiples = null;
    }

    function checkSwpStpValidations() {
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }

      if (vm.formData.transferOption === vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION) {
        vm.isMax = false;
        vm.isMin = false;
        vm.isInvalidForm = false;
        vm.isMultiples = true;
      } else {
        vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
        vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
        vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
        vm.isInvalidForm = !vm.unitsDetails || vm.formData.amount <= 0 || (vm.formData.amount && (vm.isMax || vm.isMin || (!vm.isMultiples && vm.validations.amountMultiples))) || !vm.unitsDetails.freeValueUnits
      }
      $log.info('Fro vali>>', vm.validations);
    }

    function checkFlexIndexValidations() {
      vm.isMax = false;
      vm.isMin = false;
      vm.isMultiples = true;
      vm.validations = vm.validations || {};
      vm.outSchemeValidations = vm.outSchemeValidations || {};
      vm.validations.minAmount = vm.outSchemeValidations ? vm.outSchemeValidations.minAmount : '20000';
      vm.validations.amountMultiples = vm.outSchemeValidations ? vm.outSchemeValidations.multiples : '1000';
      if (parseInt(vm.formData.amount) < parseInt(vm.validations.minAmount)) {
        vm.isMin = true;
      }
      if (parseFloat(vm.formData.amount) % parseInt(vm.validations.amountMultiples)) {
        vm.isMultiples = false;
      }

    }

    function checkSipValidations() {

      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }

      vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
      vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
      vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
      vm.isInvalidForm = vm.formData.amount <= 0 || (vm.formData.amount && (vm.isMax || vm.isMin || (vm.validations.amountMultiples && !vm.isMultiples)));
      checkOTMAmountAndDate();
    }

    function checkRedeemValidations() {
      if (vm.outSchemeValidations) {
        vm.validations.minAmount = vm.outSchemeValidations.minRedemptionAmt;
        vm.validations.minUnits = vm.outSchemeValidations.minRedemptionUnit;
        vm.validations.amountMultiples = vm.outSchemeValidations.redeemAmtMultiples;
      }

      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
        vm.validations.maxUnits = vm.validations.maxUnits > vm.unitsDetails.freeValueUnits ? vm.validations.maxUnits : +vm.unitsDetails.freeValueUnits;
      }

      if (vm.formData.amountType == vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT) {
        vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
        vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
        vm.isMultiples = (!vm.validations.amountMultiples && vm.formData.amount ? true : false) ||(vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0)) || false;
      } else {
        vm.isMax = !!(vm.validations.maxUnits && vm.validations.maxUnits < vm.formData.units);
        vm.isMin = !!(vm.validations.minUnits && vm.validations.minUnits > vm.formData.units);
        vm.isMultiples = false;
      }

      // vm.isInvalidForm = !vm.unitsDetails || (vm.formData.amount <= 0 && vm.formData.units <= 0) || (vm.formData.amount && (vm.isMax || vm.isMin || (!vm.isMultiples && vm.validations.amountMultiples))) || !vm.unitsDetails.freeValueUnits || (vm.formData.units && (vm.isMax || vm.isMin))
    }

    function checkInstantRedeemValidations() {
      vm.isMax = false;
      vm.isMin = false;
      vm.validations.minAmount = 5000;
      if (parseInt(vm.formData.amount) < vm.validations.minAmount) {
        vm.isMin = true;
      }else if (parseFloat(vm.formData.amount) > vm.validations.maxAmount) {
        vm.isMax = true;
      }

      vm.isInvalidForm = !vm.unitsDetails || (vm.formData.amount <= 0 && vm.formData.units <= 0)
        || (vm.formData.amount && (vm.isMax || vm.isMin || (!vm.isMultiples && vm.validations.amountMultiples)))
        || (vm.formData.units && (vm.isMax || vm.isMin));
    }

    function checkSwitchValidations() {

      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.minUnits = vm.validations.minUnits || 0;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
        vm.validations.maxUnits = vm.validations.maxUnits > vm.unitsDetails.freeValueUnits ? vm.validations.maxUnits : +vm.unitsDetails.freeValueUnits.toFixed(2);
      }

      var minAmount = 0;
      var minUnits = 0;
      var maxAmount = 0;
      var maxUnits = 0;

      if (vm.outSchemeValidations) {
        // minAmount = vm.outSchemeValidations.switchOutMinAmt && (vm.outSchemeValidations.switchOutMinAmt > minAmount) ? vm.outSchemeValidations.switchOutMinAmt : minAmount;
        minAmount = vm.outSchemeValidations.switchOutMinAmt ? vm.outSchemeValidations.switchOutMinAmt : minAmount;

        minAmount = vm.outSchemeValidations.switchOutMinUnit && ((vm.outSchemeValidations.switchOutMinUnit * vm.outSchemeValidations.navValue) > minAmount) ?
          (vm.outSchemeValidations.switchOutMinUnit * vm.outSchemeValidations.navValue) : minAmount;

        vm.validations.minAmount = minAmount > vm.validations.minAmount ? minAmount : vm.validations.minAmount;

        maxAmount = vm.outSchemeValidations.switchOutMaxUnit && (vm.outSchemeValidations.switchOutMaxUnit * vm.outSchemeValidations.navValue) || maxAmount;
        maxAmount = vm.outSchemeValidations.switchOutMaxAmt && (vm.outSchemeValidations.switchOutMaxAmt < maxAmount) ? vm.outSchemeValidations.switchOutMaxAmt : maxAmount;
        vm.validations.maxAmount = (maxAmount > 0 && maxAmount < vm.validations.maxAmount) ? maxAmount : vm.validations.maxAmount;

        minUnits = vm.outSchemeValidations.switchOutMinAmt && (vm.outSchemeValidations.switchOutMinAmt / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = vm.outSchemeValidations.switchOutMinUnit && (vm.outSchemeValidations.switchOutMinUnit > minUnits) ? vm.outSchemeValidations.switchOutMinUnit : minUnits;
        vm.validations.minUnits = minUnits > vm.validations.minUnits ? minUnits : vm.validations.minUnits;

        maxUnits = vm.outSchemeValidations.switchOutMaxAmt && (vm.outSchemeValidations.switchOutMaxAmt / vm.outSchemeValidations.navValue) || maxUnits;
        maxUnits = vm.outSchemeValidations.switchOutMaxUnit && (vm.outSchemeValidations.switchOutMaxUnit < maxUnits) ? vm.outSchemeValidations.switchOutMaxUnit : maxUnits;
        vm.validations.maxUnits = (maxUnits > 0 && maxUnits < vm.validations.maxUnits) ? maxUnits : vm.validations.maxUnits;
      }

      if (vm.inSchemeValidations) {
        minAmount = vm.inSchemeValidations.switchInMinUnit && (vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue > minAmount)
          ? (vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue) : minAmount;

        /*minAmount = vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt < minAmount) ? vm.inSchemeValidations.switchInMinAmt : minAmount;*/
        minAmount = vm.inSchemeValidations.addlswitchInPurchase ? vm.inSchemeValidations.switchInMinAddlPurchaseAmt : (vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt > minAmount) ? vm.inSchemeValidations.switchInMinAmt : minAmount);
        vm.validations.minAmount = minAmount > vm.validations.minAmount ? minAmount : vm.validations.minAmount;

        maxAmount = vm.inSchemeValidations.switchInMaxUnit && (vm.inSchemeValidations.switchInMaxUnit * vm.inSchemeValidations.navValue) || maxAmount;
        maxAmount = vm.inSchemeValidations.switchInMaxAmt && (vm.inSchemeValidations.switchInMaxAmt < maxAmount) ? vm.inSchemeValidations.switchInMaxAmt : maxAmount;
        vm.validations.maxAmount = (maxAmount > 0 && maxAmount < vm.validations.maxAmount) ? maxAmount : vm.validations.maxAmount;

        var _minUnits = vm.inSchemeValidations.switchInMinUnit && ((vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue) / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = vm.inSchemeValidations.addlswitchInPurchase && angular.isDefined(vm.inSchemeValidations.switchInMinAddlPurchaseUnit) ? vm.inSchemeValidations.switchInMinAddlPurchaseUnit : minUnits;
        minUnits = minUnits > _minUnits ? minUnits : _minUnits;
        vm.validations.minUnits = minUnits > vm.validations.minUnits ? minUnits : vm.validations.minUnits;

        var _maxUnits = vm.inSchemeValidations.switchInMaxUnit && ((vm.inSchemeValidations.switchInMaxUnit * vm.inSchemeValidations.navValue) / vm.outSchemeValidations.navValue) || maxAmount;
        maxUnits = vm.inSchemeValidations.switchInMaxAmt && (vm.inSchemeValidations.switchInMaxAmt / vm.outSchemeValidations.navValue) || maxAmount;
        maxUnits = maxUnits < _maxUnits ? maxUnits : _maxUnits;
        vm.validations.maxUnits = (maxUnits > 0 && maxUnits < vm.validations.maxUnits) ? maxUnits : vm.validations.maxUnits;
        vm.validations.amountMultiples = vm.inSchemeValidations.switchAmtMultiples || 1;

        vm.validations.isEnabled = vm.inSchemeValidations.switchInUnitEnabled;
      }

      if (vm.formData.amountType == vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT) {
        vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
        vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
        vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
      } else {
        vm.isMax = !!(vm.validations.maxUnits && vm.validations.maxUnits < vm.formData.units);
        vm.isMin = !!(vm.validations.minUnits && vm.validations.minUnits > vm.formData.units);
        vm.isMultiples = false;
      }
      $log.info('Fro vali>>', vm.validations);

      vm.isInvalidForm = !vm.unitsDetails || (vm.formData.amount <= 0 && vm.formData.units <= 0) || (vm.formData.amount && (vm.isMax || vm.isMin || (!vm.isMultiples && vm.validations.amountMultiples))) || !vm.unitsDetails.freeValueUnits || (vm.formData.units && (vm.isMax || vm.isMin))
    }

    function checkDtpValidations() {
      if (vm.inSchemeValidations) {
        vm.validations.isEnabled = vm.inSchemeValidations.dtpEnabled;
      }
    }

    function fetchFolioList(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioList = [];
            vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
            if (resp.data.kycVerifiedFlag === false && $stateParams.initiatedBy != "schedule") {
              ModalService.genericModal({
                text: resp.data.kycMessage
              }, function() {
                $state.go("welcome");
              });
              return;
            }
            Object.keys(resp.data.folioList).forEach(function (key) {
              var obj = Object.assign({key: key}, resp.data.folioList[key]);
              folioList.push(angular.copy(obj));
            });
            vm.folioList = folioList.length ? folioList : null;
            if (vm.folioList && vm.folioList.length === 1 &&  !$stateParams.transactionId) {
              vm.formData.folioNumber = vm.folioList[0].folioNumber;
              if (!vm.formData.isBackFromSummary && !vm.formData.outSchemeCode) {
                vm.folioChanged();
              }
            }
            if (vm.formData.dynamicData && vm.formData.dynamicData.folioNumber) {
              vm.formData.folioNumber = vm.formData.dynamicData.folioNumber;
              vm.folioChanged();
            }
            cb(true);
          } else {
            vm.folioList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      if ($state.current.name === 'main.transactions.instantRedemption') {
        var path = {
          child1: 'folio',
          child2: 'active-list',
          trxnType: 'IAF'
        }
      }
      else if ($state.current.name === 'main.transactions.dtp') {
        var path = {
          child1: 'folio',
          child2: 'active-list',
          trxnType: 'DTP'
        }
      }

      else {
        path = {
          child1: 'folio',
          child2: 'active-list'
        }
      }
      investorServiceVersion.get(path).$promise.then(success, error);
    }

    function fetchEuinList() {
      if (!vm.formData.brokerCode) {
        return;
      }
      vm.formData.brokerName = '';
      vm.subBrokerCodeError = '';
      vm.euinData = {};
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      vm.distributorList = null;
      // vm.formData.euinInput = '';
      if (!vm.formData.isBackFromSummary && !vm.riaConsent) {
        vm.isCheckedTandC = false;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin ? vm.formData.euin : {};
            vm.formData.brokerName = resp.data.distributorName;
            vm.brokerCodeError = '';
            vm.riaCodeError = '';
            vm.isArnSuccess = false;
            //vm.isInvalidForm = false;
          } else {
            vm.euinList = null;
            if (vm.formData.isThroughDistributor) {
              vm.brokerCodeError = resp.message;
            } else if (vm.formData.isThroughRia) {
              vm.riaCodeError = resp.message;
            }
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      var path = {};
      if (vm.formData.isThroughDistributor) {
        path  = {
          controller1: 'getEuin',
          controller2: 'ARN-' + vm.formData.brokerCode
        };
      } else if (vm.formData.isThroughRia) {
        path = {
          controller1: 'getEuin',
          controller2: vm.formData.brokerCode,
          riaOpted: vm.formData.isThroughRia
        };
      }
      TransactionService.get(path).$promise.then(success, error);
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        vm.formData.euin = {};
        vm.euinData = {};
        fetchEuinList();
        return;
      }
      if(vm.formData.brokerCode !== vm.formData.subBrokerARN){
        vm.formData.euin = {};
        vm.euinData = {};
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            for(var i = 0; i<vm.euinList.length; i++){
              if(vm.euinData.euinNameCode === vm.euinList[i].euinNameCode){
                vm.formData.euin = vm.euinList[i];
                break;
              } else {
                vm.formData.euin = {};
              }
            }
            vm.euinData = vm.formData.euin;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
          } else {
            vm.euinList = null;
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = {};
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: vm.formData.isThroughDistributor
      }).$promise.then(success, error);
    }

    function fetchEuinListThroughDistributor(arnCode) {
      if (!arnCode) {
        return;
      }
      vm.formData.brokerName = '';
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin;
            vm.isArnSuccess=false;
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.euinList = null;
            //MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getEuin',
        controller2: arnCode
      }).$promise.then(success, error);
    }

    function fetchARNByName() {

      if ((!vm.formData.distributerName) || (vm.formData.distributerName && vm.formData.distributerName.length < 3)) {
        return;
      }
      vm.formData.distributorARN = '';
      vm.distributorList = null;
      vm.isArnSuccess = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.distributorList = resp.data.distributorList;
            if (vm.distributorList.length == 0) {
              //vm.isInvalidForm = true;
              vm.formData.euin = {};
              vm.isCheckedTandC = false;
            }
          } else {
            vm.distributorList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.distributorList = null;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        /*controller1: 'transaction',*/
        controller1: 'getDistributor',
        controller2: vm.formData.distributerName
      }).$promise.then(success, error);
    }

    function checkValidations() {

      vm.isInvalidForm = false;

      if (!vm.inSchemeValidations && !vm.outSchemeValidations) {
        vm.validations = {};
      }
      if (vm.outSchemeValidations) {
        vm.validations.isEnabled = vm.outSchemeValidations ? vm.outSchemeValidations.isEnabled : '';
        extractValidationObject(vm.outSchemeValidations);
      }

      if (vm.inSchemeValidations) {
        vm.validations.minInstallDivisionFlag = vm.inSchemeValidations.minInstallDivisionFlag;
        vm.validations.swpTaxCode = vm.inSchemeValidations.swpTaxCode;
        vm.validations.endingType = vm.inSchemeValidations.endingType;
        extractValidationObject(vm.inSchemeValidations);
      }

      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          checkSwpStpValidations();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          checkSipValidations();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION:
          checkRedeemValidations();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION:
          checkInstantRedeemValidations();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH:
          checkSwitchValidations();
          if (vm.formData.inSchemeCode && vm.formData.outSchemeCode) {
            fetchCalculatedSwitchValidations();
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP:
          checkDtpValidations();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX:
          checkFlexIndexValidations();
          break;
      }
    }

    function fetchInSchemes(cb) {
      cb = cb || function () {
      };

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.masterInSchemeList = resp.data.schemeList;
            vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
            if (vm.formData.inSchemeCode) {
              var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                return vm.formData.inSchemeCode === item.schemeCode;
              }) || {};
              vm.formData.inSchemeName = scheme.scheme || '';
              if (scheme.nfoEnabled == 'Y') {
                vm.nfoEnabled = true;
              } else {
                vm.nfoEnabled = false;
              }
            }
            cb(true);
          } else {
            vm.masterInSchemeList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          vm.masterInSchemeList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      var _config = {
        controller: 'scheme',
        type: 'ALL',
        child1: vm.transactionType.toLowerCase() + 'enabled',
        child2: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
        child3: vm.formData.isThroughDistributor,
        child4: vm.formData.corporateInvestor
      };

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP) {
        if (vm.specificProperties.stpType === 'flexStp') {
          _config.child1 = 'flexstpenabled';
        } else if (vm.specificProperties.stpType === 'swingStp') {
          _config.child1 = 'swingstpenabled';
        }
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        _config.child1 = 'flex-index-enabled';
      }
      SchemeService.get(_config, null).$promise.then(success, error);
    }

    function fetchSwitchInSchemes(cb) {
      if (vm.formData.isAutoSwitch) {
        cb = cb || function () {
        };

        var success = function (resp) {
            if (resp.status && resp.data) {
              vm.autoSwitchInSchemes = resp.data.schemeList;
              vm.autoSwitchInSchemeList = UtilService.getFilteredList(vm.autoSwitchInSchemes);
              if (!vm.formData.switchInSchemeName) {
                for (var i in vm.autoSwitchInSchemeList) {
                  if (vm.autoSwitchInSchemeList[i].schemeCode == 'LFGTN') {
                    vm.formData.switchInSchemeName = vm.autoSwitchInSchemeList[i].scheme;
                    vm.formData.switchInSchemeCode = vm.autoSwitchInSchemeList[i].schemeCode;
                    vm.isSwitchInScheme = !!(vm.selectedInScheme);
                    //vm.inSchemeChanged(vm.inSchemes[i])
                    if (vm.autoSwitchInSchemeList[i].schemeType == 'ELSS' && vm.autoSwitchInSchemeList[i].scheme.toLowerCase().includes('dividend')) {
                      vm.formData.autoSwitchSchemeDividendOption = AppConstants.TRANSACTIONS.DIVIDEND_OPTIONS.PAYOUT;
                    }
                    fetchSwitchInSchemeValidations();
                  }
                }
              }
              cb(true);
            } else {
              vm.autoSwitchInSchemes = null;
              MessageService.error(resp.message);
              cb(false);
            }
          },
          error = function (err) {
            vm.autoSwitchInSchemes = null;
            UtilService.errorHandler(err);
            cb(false);
          };
        vm.nfoEnabled = true;
        var _config = {
          controller: 'scheme',
          type: 'ALL',
          child1: 'autoSwitchenabled',
          child2: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
          child3: vm.formData.isThroughDistributor
        };

        SchemeService.get(_config, null).$promise.then(success, error);
      }
    }

    function fetchOutSchemeValidations(cb) {
      vm.outSchemeValidations = null;
      cb = cb || function () {
      };

      if (!vm.formData.outSchemeCode) {
        cb(false)
        return;
      }
      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.enabledStartDates = null;
        vm.enabledEndDates = null;
        vm.formData.day = null;
        vm.formData.frequency = null;
        vm.validations = {};
        vm.isMultiples = false;
        vm.isMin = false;
        vm.isMax = false;
        reSetting();
      }
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.outSchemeValidations = resp.data;
            var schemeTypeCheck = vm.outSchemeValidations && vm.outSchemeValidations.investmentOption;
            vm.isSourceSchemeGrowth = schemeTypeCheck == "GROWTH" ? true : false;

            cb(true);
          } else {
            cb(false);
            vm.outSchemeValidations = null;
            (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) && MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.outSchemeValidations = null;
          cb(false);
          UtilService.errorHandler(err);
        };

      var _config = {};

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        _config = {
          controller: 'validation',
          type: 'flexIndex'
        }

        var data = {
          folioNo: vm.formData.folioNumber,
          schemeCode: vm.formData.outSchemeCode,
          transactionType: 'FLEXINDEX'
        }

        SchemeService.post(_config, data).$promise.then(success, error);

      } else {

        _config.controller = 'schemeValidation';
        _config.type = vm.transactionType.toLowerCase();
        // _config.child1 = vm.formData.outSchemeCode;

        data = {
          schemeCode: vm.formData.outSchemeCode,
          folioNo: vm.formData.folioNumber
        }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP) {

          if (vm.specificProperties.stpType === 'normalStp') {
            data.transactionType = 'STP';
          } else if (vm.specificProperties.stpType === 'flexStp') {
            data.transactionType = 'STPFLEX';
          }

          if (vm.specificProperties.stpType === 'swingStp') {
            _config.type = 'swingStp';
          }
        /*_config.child2 = vm.formData.folioNumber;*/

        }

        SchemeService.post(_config, data).$promise.then(success, error);
      }

    }


    function fetchCalculatedSwitchValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.formData.inSchemeCode && !vm.formData.outSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            // vm.inSchemeValidations = resp.data;

            (angular.isDefined(resp.data.minAmount)) && (vm.validationsApi.minAmount = resp.data.minAmount);
            (angular.isDefined(resp.data.maxAmount)) && (vm.validationsApi.maxAmount = resp.data.maxAmount);
            (angular.isDefined(resp.data.minUnits)) && (vm.validationsApi.minUnits = resp.data.minUnits);
            (angular.isDefined(resp.data.maxUnits)) && (vm.validationsApi.maxUnits = resp.data.maxUnits);
            $log.info('Ser vali>>', vm.validationsApi);
            cb(null);
          } else {
            cb('error');
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          cb('error');
          UtilService.errorHandler(err);
        };

      var valPayload = {
        "folioNo":vm.formData.folioNumber,
        "inSchemeCode":vm.formData.inSchemeCode,
        "outSchemeCode":vm.formData.outSchemeCode,
        "transactionType":vm.transactionType
      };
      SchemeService.post({
        controller: 'schemeValidation',
        child1: 'validationCal'
      }, valPayload).$promise.then(success, error);
    }

    function fetchInSchemeValidations(cb) {
      vm.inSchemeValidations = null;

      if (vm.transactionType) {
        vm.formData.investmentType = vm.transactionType;
      } else if (vm.formData.investmentType) {
        vm.transactionType = vm.formData.investmentType;
      }
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        return;
      }

      var transactionType = vm.formData.investmentType.toLowerCase();

      cb = cb || function () {
      };
      if (!vm.formData.inSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;
            if(vm.inSchemeValidations.investmentOption == Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS)[1])
              vm.inSchemeValidations.investmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND;
            vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
            var investmentOption = vm.inSchemeValidations.investmentOption || (vm.inSchemeValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
            vm.validations.investmentOption = investmentOption;
            vm.formData.sipDividendOption = (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : ((vm.inSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (transactionType == "sip" && vm.isSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;

            if (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) {
              vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            } else if (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND ){

              // if((vm.inSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (vm.isSchemeTypeELSS)){
                if(vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === false){
                  vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
                }else if(vm.inSchemeValidations.dividendPayoutApplicable === false && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
                  vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
                }else if(vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
                  vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
                } else {
                  vm.isInvalidForm = true;
                }
            }
            cb(true);
          } else {
            cb(false);
            vm.inSchemeValidations = null;
            vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
            vm.formData.dividendOption = vm.isSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.dividendOption;
            vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
            MessageService.error(resp.message);
          }
          // checkValidations();
        },
        error = function (err) {
          cb(false);
          vm.inSchemeValidations = null;
          vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
          vm.formData.dividendOption = vm.isSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.dividendOption;
          vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
          UtilService.errorHandler(err);
        };

      var data = {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.inSchemeCode
      }

      if (vm.specificProperties.stpType === 'normalStp') {
        data.transactionType = 'STP';
      } else if (vm.specificProperties.stpType === 'flexStp') {
        data.transactionType = 'STPFLEX';
      }

      SchemeService.post({
        controller: 'schemeValidation',
        type: transactionType/*,
        child1: vm.formData.inSchemeCode,
        child2: (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH) ? vm.formData.folioNumber : ''*/
      }, data).$promise.then(success, error);
    }

    function fetchSwitchInSchemeValidations(cb) {
      vm.switchInSchemeValidations = null;

      if (vm.transactionType) {
        vm.formData.investmentType = vm.transactionType;
      } else if (vm.formData.investmentType) {
        vm.transactionType = vm.formData.investmentType;
      }

      var transactionType = vm.formData.investmentType.toLowerCase();

      cb = cb || function () {
      };
      if (!vm.formData.inSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.switchInSchemeValidations = resp.data;
            vm.isSwitchInSchemeTypeELSS = (vm.switchInSchemeValidations && vm.switchInSchemeValidations.schemeType == "ELSS") ? true : false;
            var switchInInvestmentOption = vm.switchInSchemeValidations.investmentOption || (vm.switchInSchemeValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
            vm.switchInSchemeValidations.switchInInvestmentOption = switchInInvestmentOption;
            vm.formData.autoSwitchSchemeDividendOption = (switchInInvestmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : ((vm.switchInSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (transactionType == "sip" && vm.isSwitchInSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            vm.dividendOptions = vm.isSwitchInSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;

            if (switchInInvestmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) {
              vm.formData.autoSwitchSchemeDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            } else if (((switchInInvestmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND) && (vm.formData.autoSwitchSchemeDividendOption == vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH)
                || (!vm.formData.autoSwitchSchemeDividendOption))) {
              vm.formData.autoSwitchSchemeDividendOption = ((vm.switchInSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (vm.isSwitchInSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : (vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST);
            }
            cb(true);
          } else {
            cb(false);
            vm.switchInSchemeValidations = null;
            vm.switchInSchemeValidations.switchInInvestmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.autoSwitchSchemeDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.isSwitchInSchemeTypeELSS = (vm.switchInSchemeValidations && vm.switchInSchemeValidations.schemeType == "ELSS") ? true : false;
            vm.formData.autoSwitchSchemeDividendOption = vm.isSwitchInSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.autoSwitchSchemeDividendOption;
            vm.dividendOptions = vm.isSwitchInSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
            MessageService.error(resp.message);
          }
          // checkValidations();
        },
        error = function (err) {
          cb(false);
          vm.switchInSchemeValidations = null;
          vm.switchInSchemeValidations.switchInInvestmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.autoSwitchSchemeDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.isSwitchInSchemeTypeELSS = (vm.switchInSchemeValidations && vm.switchInSchemeValidations.schemeType == "ELSS") ? true : false;
          vm.formData.autoSwitchSchemeDividendOption = vm.isSwitchInSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.autoSwitchSchemeDividendOption;
          vm.dividendOptions = vm.isSwitchInSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
          UtilService.errorHandler(err);
        };

      SchemeService.post({
        controller: 'schemeValidation',
        type: transactionType
      }, null).$promise.then(success, error);
    }
    function fetchUnitDetails(cb) {

      cb = cb || function () {
      };

      vm.unitsDetails = null;
      if (!vm.formData.outSchemeCode) {
        return;
      }
      LoaderService.showLoader();

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.unitsDetails = resp.data;
            vm.unitsDetails.message = resp.message || '';
            vm.unitsDetails.isDisabled = !resp.data.freeValueUnits;
            vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
            vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
            vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
            checkValidations();
            cb(true);
          } else {
            vm.unitsDetails = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.unitsDetails = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      InvestorService.post({
        child1: 'transaction',
        child2: 'folio',
        child3: 'scheme-value'
      }, {
        schemeCode: vm.formData.outSchemeCode,
        transactionType: vm.transactionType.toLowerCase(),
        folioNo: vm.formData.folioNumber
      }).$promise.then(success, error);
    }

    function getInSchemesInfo() {
      if (!$stateParams.transactionId) {
        switch (vm.transactionType) {
          case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP:
          case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH:
          case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP:
          case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX:
            fetchInSchemes(function () {
            });
            break;
        }
      }
    }

    function getTransactionDetails() {
      if (!$stateParams.transactionId) {
        MessageService.error("TransactionId is missing for saved transaction.");
        $state.go('main.dashboard');
        return;
      }

      var success = function (resp) {
          if (resp.data && resp.status) {
            showPrefillValues(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'transaction',
        controller2: 'saved',
        controller3: $stateParams.transactionId,
        controller4: $stateParams.isCompId
      }).$promise.then(success, error);
    }

    function getTransactionTypeFromStateParams() {
      if ($stateParams.transactionType === 'FLEXINDEX') {
        return 'FLEX_INDEX';
      }
      return $stateParams.transactionType;
    }

    function getTransactionType() {
      var transactionType = '';
      switch ($state.current.name) {
        case 'main.transactions.redemption':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION;
          break;
        case 'main.transactions.switch':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH;
          break;
        case 'main.transactions.swp':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP;
          break;
        case 'main.transactions.stp':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP;
          break;
        case 'main.transactions.dtp':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP;
          break;
        case 'main.transactions.flexindex':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX;
          break;
        case 'main.transactions.nfoswitchout':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.NFO_SWITCH_OUT;
          break;
        case 'main.transactions.instantRedemption':
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION;
          break;
        default :
          $state.go('welcome');
          break;
      }
      return transactionType;
    }

    function getFinalPayloadData() {
      var payload = null;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP:
          payload = vm.isSaving ? getStpPayloadToSave() : getStpPayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          payload = vm.isSaving ? getSwpPayloadToSave() : getSwpPayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION:
          payload = vm.isSaving ? getRedeemPayloadToSave() : getRedeemPayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH:
          payload = vm.isSaving ? getSwitchPayloadToSave() : getSwitchPayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP:
          payload = vm.isSaving ? getDtpPayloadToSave() : getDtpPayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX:
          payload = vm.isSaving ? geFlexIndexPayloadToSave() : getFlexIndexPayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION:
          payload = vm.isSaving ? getInstantRedemptionPayloadToSave() : getInstantRedemptionPayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SCHEDULE_TRANSACTION_REDEMPTION:
          payload = vm.isSaving ? getRedeemPayloadToSave() : getRedeemPayloadToSubmit();
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SCHEDULE_TRANSACTION_SWITCH:
          payload = vm.isSaving ? getSwitchPayloadToSave() : getSwitchPayloadToSubmit();
          break;
      }
      return angular.copy(payload);
    }

    function getStpPayloadToSave() {
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == vm.validations.investmentOption)
          vm.validations.investmentOption = key;
      });
      var payload = {
        "investmentOption": vm.validations.investmentOption,
        "dividendOption": vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.dividendOption,
        "stpType": vm.formData.transferOption,
        "folioNumber": vm.formData.folioNumber,
        "sourceSchemeCode": vm.formData.outSchemeCode,
        "stpDay": vm.formData.day,
        "amount": vm.formData.amount,
        "euinOpted": vm.formData.euin ? 'Y' : 'N',
        "euinName": vm.formData.euin ? vm.formData.euin.euinName : '',
        "euinCode": vm.formData.euin ? vm.formData.euin.euinCode : '',
        "targetSchemeCode": vm.formData.inSchemeCode,
        "frequency": vm.formData.frequency,
        "startDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
        "endDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
        "formType": vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP,
        "id": vm.formData.isFavourite ? "" : vm.formData.transactionId,
        "noOfInstallments": vm.formData.frequency === 'DZ' ? vm.formData.noOfInstallments : 0,
        "subBrokerArn": vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
        "subBrokerCode": vm.formData.subBrokerCode
      };

      if (vm.specificProperties && vm.specificProperties.stpType === 'flexStp') {
        payload.stpType = 'T';
      }

      if (vm.specificProperties && vm.specificProperties.stpType === 'swingStp') {
        payload.stpType = 'Q';
      }
      payload = handleBrokerCode(payload);
      return angular.copy(payload);
    }

    function getSwpPayloadToSave() {
      var payload = {
        amount: vm.formData.amount,
        folioNumber: vm.formData.folioNumber,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP,
        frequency: vm.formData.frequency,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        schemeCode: vm.formData.outSchemeCode,
        startDate: vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
        toDate: vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
        swpDay: vm.formData.day,
        swpType: vm.formData.transferOption,
        accountNumber: vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '',
        ifscCode: vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : '',
        bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : '',
        branchName: vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '',
        payMech: vm.formData.bankInfo ? vm.formData.bankInfo.payMech : '',
        primaryBankFlag: vm.formData.bankInfo ? vm.formData.bankInfo.primaryFlag : '',
        payoutId: vm.formData.bankInfo ? vm.formData.bankInfo.payoutId : ''
      };

      return angular.copy(payload);
    }

    function getRedeemPayloadToSave() {
      var payload = {
        folioNumber: vm.formData.folioNumber,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION,
        schemeCode: vm.formData.outSchemeCode,
        accountNumber: vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '',
        ifscCode: vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : '',
        bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : '',
        branchName: vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '',
        payMech: vm.formData.bankInfo ? vm.formData.bankInfo.payMech : '',
        primaryBankFlag: vm.formData.bankInfo ? vm.formData.bankInfo.primaryFlag : '',
        payoutId: vm.formData.bankInfo ? vm.formData.bankInfo.payoutId : '',
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId
      };

      if (vm.formData.amountType == vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS) {
        payload.units = vm.formData.units;
        payload.amount = 0;
      } else if (vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS) {
        payload.units = +vm.unitsDetails.freeValueUnits;
        payload.amount = 0;
      } else {
        payload.amount = vm.formData.amount;
        payload.units = 0;
      }

      return angular.copy(payload);
    }

    function getInstantRedemptionPayloadToSave() {
      var payload = {
        isInstantRedemption: true,
        folioNumber: vm.formData.folioNumber,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION,
        schemeCode: vm.formData.outSchemeCode,
        accountNumber: vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '',
        ifscCode: vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : '',
        bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : '',
        branchName: vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '',
        payMech: vm.formData.bankInfo ? vm.formData.bankInfo.payMech : '',
        primaryBankFlag: vm.formData.bankInfo ? vm.formData.bankInfo.primaryFlag : '',
        payoutId: vm.formData.bankInfo ? vm.formData.bankInfo.payoutId : '',
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId
      };

      if (vm.formData.amountType == vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS) {
        payload.units = vm.formData.units;
        payload.amount = 0;
      } else if (vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS) {
        payload.units = +vm.unitsDetails.freeValueUnits;
        payload.amount = 0;
      } else {
        payload.amount = vm.formData.amount;
        payload.units = 0;
      }

      return angular.copy(payload);

    }

    function getSwitchPayloadToSave() {
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == vm.validations.investmentOption)
          vm.validations.investmentOption = key;
      });
      var payload = {
        folioNumber: vm.formData.folioNumber,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        investmentOption: vm.validations.investmentOption,
        dividendOption: vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.dividendOption,
        switchOutSchemeCode: vm.formData.outSchemeCode,
        switchInSchemeCode: vm.formData.inSchemeCode,
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
        subBrokerCode: vm.formData.subBrokerCode,
        checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
        autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.switchInSchemeCode : null,
        autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.autoSwitchSchemeDividendOption : null
      };

      if (vm.formData.amountType == vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS) {
        payload.units = vm.formData.units;
        payload.amount = 0;
      } else if (vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS) {
        payload.units = +vm.unitsDetails.freeValueUnits;
        payload.amount = 0;
      } else {
        payload.amount = vm.formData.amount;
        payload.units = 0;
      }
      payload = handleBrokerCode(payload);
      return angular.copy(payload);
    }

    function getDtpPayloadToSave() {

      var payload = {
        folioNumber: vm.formData.folioNumber,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        dividendOption: vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.dividendOption,
        sourceScheme: vm.formData.outSchemeCode,
        targetScheme: vm.formData.inSchemeCode,
        brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : ''),
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
        subBrokerCode: vm.formData.subBrokerCode
      };
      if (vm.formData.isThroughRia) {
        payload.brokerCode = "";
      }
      return angular.copy(payload);
    }

    function geFlexIndexPayloadToSave() {
      if (!vm.formData) {
        return null;
      }

      var payload = {
        "amountForRegistration": vm.formData.amount,
        "compositeTransactionId": "",
        "dividendOption": "Y",
        "euinCode": "",
        "euinName": "",
        "euinOpted": "",
        "folioNumber": vm.formData.folioNumber,
        "formType": 'FLEXINDEX',
        "id": vm.formData.isFavourite ? "" : vm.formData.transactionId,
        "investmentMode": '',
        "investorUuid": "",
        "sourcePortal": "",
        "sourceScheme": vm.formData.outSchemeCode,
        "switchExecutionDetails": getSwitchExecutionDetails(),
        "targetScheme": vm.formData.inSchemeCode,
        "subBrokerArn": vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
        "subBrokerCode": vm.formData.subBrokerCode
      }

      if (vm.specificProperties.investmentMode === 'Fixed') {
        payload.investmentMode = 'F';
      } else {
        payload.investmentMode = 'V';
      }
      payload = handleBrokerCode(payload);
      return angular.copy(payload);
    }

    function getSwitchExecutionDetails() {
      if (!vm.specificProperties || !vm.specificProperties.investmentModeData) {
        return {};
      }

      var data = vm.specificProperties.investmentModeData;
      var obj = {
        "firstSwitchExecutionEntry": {
          "sensexLevelForSwitch": data.stage1,
          "switchPercentage": data.installment1
        },
        "secondSwitchExecutionEntry": {
          "sensexLevelForSwitch": data.stage2,
          "switchPercentage": data.installment2
        },
        "thirdSwitchExecutionEntry": {
          "sensexLevelForSwitch": data.stage3,
          "switchPercentage": data.installment3
        },
        "fourthSwitchExecutionEntry": {
          "sensexLevelForSwitch": data.stage4,
          "switchPercentage": data.installment4
        }
      };

      return obj;

    }

    function getStpPayloadToSubmit() {

      if (vm.specificProperties && vm.specificProperties.stpType == 'flexStp') {
        vm.formData.stpType = 'T';
      } else vm.formData.stpType = '';

      if (vm.specificProperties && vm.specificProperties.stpType == 'swingStp') {
        vm.formData.stpType = 'Q';
      }

      // vm.formData.noOfInstallments = vm.formData.frequency === 'DZ' || vm.formData.frequency === 'OW' ? vm.formData.noOfInstallments : 0;
      // !vm.validations.investmentOption
      if ((vm.specificProperties.stpType != 'swingStp' && vm.specificProperties.stpType != 'flexStp') &&
        (vm.inSchemeValidations && !vm.inSchemeValidations.investmentOption)
        || (!vm.outSchemeValidations.investmentOption && vm.specificProperties.stpType != 'swingStp')) {
        MessageService.error('Invalid Investment option is selected.');
        return false;
      }
      vm.formData.formType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP;
      vm.formData.investmentOption = !vm.validations.investmentOption ? vm.inSchemeValidations.investmentOption : vm.validations.investmentOption;
      // if (!vm.formData.investmentOption)
      if (!vm.formData.dividendOption) {
        vm.formData.dividendOption = vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.dividendOption;
      }
      vm.formData.id = vm.formData.isFavourite ? "" : vm.formData.transactionId;
      return angular.copy(vm.formData);
    }

    function getSwpPayloadToSubmit() {
      vm.formData.formType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP;
      vm.formData.id = vm.formData.isFavourite ? "" : vm.formData.transactionId;
      return angular.copy(vm.formData);
    }

    function getRedeemPayloadToSubmit() {
      vm.formData.formType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION;

      if (vm.formData.amountType == vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS) {
        vm.formData.amount = 0;
      } else if (vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS) {
        vm.formData.units = +vm.unitsDetails.freeValueUnits;
        vm.formData.amount = 0;
      } else {
        vm.formData.units = 0;
      }
      vm.formData.id = vm.formData.isFavourite ? "" : vm.formData.transactionId;

      return angular.copy(vm.formData);
    }

    function getInstantRedemptionPayloadToSubmit() {
      vm.formData.formType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION;

      if (vm.formData.amountType == vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS) {
        vm.formData.amount = 0;
      } else if (vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS) {
        vm.formData.units = +vm.unitsDetails.freeValueUnits.toFixed(2);
        vm.formData.amount = 0;
      } else {
        vm.formData.units = 0;
      }
      vm.formData.id = vm.formData.isFavourite ? "" : vm.formData.transactionId;

      return angular.copy(vm.formData);
    }

    function getSwitchPayloadToSubmit() {
      if (!vm.validations.investmentOption) {
        MessageService.error('Invalid Investment option is selected.');
        return false;
      }
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == vm.validations.investmentOption)
          vm.validations.investmentOption = key;
      });
      vm.formData.formType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH;
      vm.formData.investmentOption = vm.validations.investmentOption;
      vm.formData.dividendOption = vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.dividendOption;
      vm.formData.checkedNfoAutoSwitch = vm.formData.isAutoSwitch;

      if (vm.formData.amountType == vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS) {
        vm.formData.amount = 0;
      } else if (vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS) {
        vm.formData.units = +vm.unitsDetails.freeValueUnits;
        vm.formData.amount = 0;
      } else {
        vm.formData.units = 0;
      }
      vm.formData.id = vm.formData.isFavourite ? "" : vm.formData.transactionId;
      vm.formData.euinOpted = (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N';
      return angular.copy(vm.formData);
    }

    function getDtpPayloadToSubmit() {
      if (!vm.validations.investmentOption) {
        MessageService.error('Invalid Investment option is selected.');
        return false;
      }
      vm.formData.formType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP;
      vm.formData.investmentOption = vm.validations.investmentOption;
      vm.formData.dividendOption = vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.dividendOption;
      vm.formData.id = vm.formData.isFavourite ? "" : vm.formData.transactionId;
      if (vm.formData.isThroughRia) {
        vm.formData.brokerCode = "";
      }
      return angular.copy(vm.formData);
    }

    function getFlexIndexPayloadToSubmit() {
      vm.formData.investmentMode = vm.specificProperties.investmentMode;
      vm.specificProperties.investmentModeData.installment1 = vm.formData.investmentMode == 'Fixed' ? '25' : vm.specificProperties.investmentModeData.installment1;
      vm.specificProperties.investmentModeData.installment2 = vm.formData.investmentMode == 'Fixed' ? '25' : vm.specificProperties.investmentModeData.installment2;
      vm.specificProperties.investmentModeData.installment3 = vm.formData.investmentMode == 'Fixed' ? '25' : vm.specificProperties.investmentModeData.installment3;
      vm.specificProperties.investmentModeData.installment4 = vm.formData.investmentMode == 'Fixed' ? '25' : vm.specificProperties.investmentModeData.installment4;
      vm.formData.investmentModeData = vm.specificProperties.investmentModeData;
      vm.formData.id = vm.formData.isFavourite ? "" : vm.formData.transactionId ;
      return angular.copy(vm.formData);

    }

    function updateEndDates(doNotUpdateEndDate) {
      if (!vm.formData.startDate) {
        return;
      }
      if (vm.formData.isTillPerpetuity) {
        vm.formData.endDate = moment("12/31/2036");
        vm.enabledEndDates = [moment("12/31/2036")];
        return;
      }

      // var defaultEndDate = new Date(2040, 12, 31);
      var defaultEndDate = moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations.maxInstallments || 0;
      var i = 0;
      if (!vm.frequencyList) {
        vm.frequencyList = getFrequencyList();
      }
      var frequency = vm.frequencyList.find(function (f) {
        return f.key === vm.formData.frequency;
      }) || {};

      switch (vm.formData.frequency) {
        case'DZ':
        case'OW':
          var days = 0;
          var minInstallmentsDays = vm.validations.minInstallments || 6;
          minInstallmentsDays =  minInstallmentsDays - 1;
          endDate = vm.formData.startDate.clone().add(minInstallmentsDays, 'weeks');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / frequency.dayfreq);
          for (i = 0; i < freq; i++) {//minimum installment 6
            days = frequency.dayfreq * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          var minInstallmentsMonths = (vm.validations.minInstallments && (vm.validations.minInstallments * frequency.monthfreq) )
            || (vm.formData.frequency === 'OM' ? 4:1);
          minInstallmentsMonths = minInstallmentsMonths - 1 * frequency.monthfreq;
          endDate = vm.formData.startDate.clone().add(minInstallmentsMonths, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.monthfreq);
          for (i = 0; i < freq; i++) {
            months = frequency.monthfreq * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      // var minInstallments = vm.validations.minInstallments && (vm.validations.minInstallments - 2) || 0;
      vm.enabledEndDates = enabledEndDates;//enabledEndDates.slice(minInstallments);
      vm.enabledEndDateView=angular.copy(vm.enabledEndDates[0]);
      vm.maxEndDate = new Date(2099, 12, 31);
      if (!doNotUpdateEndDate) {
        if (vm.formData.isBackFromSummary) {
          if (vm.formData.frequency != 'DZ') {
            vm.formData.endDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
          }
        }
        vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
      } else {
        //vm.formData.endDate = null;
        vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);

      }
      if(vm.specificProperties.stpType == "normalStp" && vm.formData.frequency == 'OW'){
        if (vm.formData.isBackFromSummary) {
          vm.addNoOfInstallments = vm.formData.noOfInstallments - 1;
          vm.newEndDate = vm.formData.startDate.clone().add(vm.addNoOfInstallments, 'weeks');
          vm.formData.endDate = vm.formData.endDate ? vm.formData.endDate : vm.newEndDate;
        }else{
          vm.addNoOfInstallments = vm.formData.noOfInstallments - 1;
          vm.formData.endDate = vm.formData.startDate.clone().add(vm.addNoOfInstallments, 'weeks');
        }
      }
      reSetting();
    }

    function fetchOutSchemes(cb) {
      cb = cb || function () {
      };

      if (!vm.formData.folioNumber) {
        return;
      }

      vm.outSchemeList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {

            vm.masterOutSchemeList = resp.data.schemes;
            vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList);
            if (vm.formData.outSchemeCode && !vm.formData.isBackFromSummary) {
              var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
                return vm.formData.outSchemeCode === item.schemeCode;
              }) || {};
              vm.formData.outSchemeName = scheme.scheme || '';
              vm.outSchemeChanged();
            }
            cb(true);
          } else {
            vm.outSchemeList = null;
            vm.masterOutSchemeList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.outSchemeList = null;
          vm.masterOutSchemeList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();

      var _config = {child1: 'folio', child2: 'schemes'};
      var transactionType = vm.transactionType.toLowerCase();
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP) {
        _config.child3 = 'dtp';
      } else if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        _config.child3 = 'flex-index-enabled';
      } else if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP) {
        if (vm.specificProperties.stpType === 'flexStp') {
          transactionType = vm.specificProperties.stpType.toLowerCase();
          _config.child3 = 'flex';
            _config.child4 = 'stp';
        } else if (vm.specificProperties.stpType === 'swingStp') {
          transactionType = vm.specificProperties.stpType.toLowerCase();
          _config.child3 = 'swing';
            _config.child4 = 'stp';
        }
      }

      InvestorService.post(_config,
        {
          folioNumber: vm.formData.folioNumber,
          transactionType: transactionType
        }).$promise.then(success, error);
    }

    function fetchBankList(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            var isPrimary = false;
            angular.forEach(vm.bankList, function (bank) {
              if(bank.primaryFlag){
                vm.formData.bankInfo = bank;
                checkOTMAmountAndDate();
                changeBank();
                isPrimary = true;
              }
            });
            if ((vm.bankList && vm.bankList.length == 1) || !isPrimary) {
              vm.formData.bankInfo = vm.bankList[0];
              checkOTMAmountAndDate();
              changeBank();
            }
            for(var i = 0 ;  i < vm.bankList.length ; i++) {
              vm.bankList[i].id = i;
            }
            cb();
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();

      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        InvestorService.get({child1: 'bank', child2: 'list', child3: 'sip'}, null).$promise.then(success, error);
      } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        var payload = {
          folioNo:vm.formData.folioNumber,
          transactionType: vm.transactionType.toLowerCase()
        };

        InvestorService.post({
          child1: 'folio',
          child2: 'otm'
        }, payload).$promise.then(success, error);
      } else {
        InvestorService.post({
          child1: 'folio',
          child2: 'scheme',
          child3: 'bankList'
        }, {
          schemeCode: vm.formData.outSchemeCode,
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }
    }

    function updateDatesForDaily() {
      var currentDay = moment().add(3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.minStartDate = angular.copy(vm.enabledStartDates[0]);

      if (vm.formData.isBackFromSummary) {
        vm.formData.startDate = vm.formData.startDate ? vm.formData.startDate : vm.enabledStartDates[0];
      } else {
        vm.formData.startDate = vm.enabledStartDates[0];
      }
      vm.formData.day = +(vm.formData.startDate.format('DD'));

      if (vm.transactionType !== 'STP') {
        updateEndDates();
      }
    }

    function updateDatesForWeekly() {
      if(vm.specificProperties.stpType == "normalStp"){
      var currentDay = moment().add(3, 'days');
      }else{
      currentDay = moment().add(2, 'days');
      }
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});

      var enabledStartDates = [];
      var _day = vm.daysList.find(function (d) {
        return d.value === vm.formData.day;
      }) || {};
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd') === _day.name) {
          enabledStartDates.push(_date.clone());
        }
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.minStartDate = angular.copy(vm.enabledStartDates[0]);
      if (vm.formData.isBackFromSummary) {
        vm.formData.startDate = vm.formData.startDate ? vm.formData.startDate : vm.enabledStartDates[0];
      }
      if(vm.specificProperties.stpType == "normalStp"){
        vm.formData.startDate = vm.enabledStartDates[0];
      }
      vm.maxStartDate = angular.copy($window.moment(vm.enabledStartDates[vm.enabledStartDates.length - 1]).add(1, 'minutes'));
      updateEndDates();
    }

    function updateDatesForOthers() {
      var currentDay = moment();
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      if(vm.specificProperties.stpType === 'normalStp'){
        var parsedDate = $window.moment(updatedDate, "DD-MMM-YYYY");
        vm.minStartDate = parsedDate.clone().add(10, 'days');
        vm.maxStartDate = $window.moment(Date.parse(parsedDate)).add(90, 'days').add(1, 'minutes');
        if (vm.formData.isBackFromSummary) {
          vm.formData.startDate = vm.formData.startDate ? vm.formData.startDate : vm.minStartDate;
        }
      }else{
      updatedDate.set('date', vm.formData.day);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      var tDays = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? 15 : 10;
      while (_diff < tDays) {
        updatedDate.add(1, 'months').set('date', vm.formData.day);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }

      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }

      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.minStartDate = angular.copy(vm.enabledStartDates[0]);
      vm.maxStartDate = angular.copy($window.moment(vm.enabledStartDates[vm.enabledStartDates.length - 1]).add(1, 'minutes'));
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
        calculateMonthsForSip();
      } else {
        if (vm.formData.isBackFromSummary) {
          vm.formData.startDate = vm.formData.startDate ? vm.formData.startDate : vm.enabledStartDates[0];
        }
        }
      }
      updateEndDates();
    }

    function calculateMonthsForSip() {
      var arr = [];
      for (var i = 0; i < vm.enabledStartDates.length; i++) {
        var str1 = vm.enabledStartDates[i].format('MMM') + ', ' + vm.enabledStartDates[i].format('YYYY');
        var str2 = i;
        arr.push({name: str1, value: str2});

      }
      vm.formData.monthList = arr;
    }

    function changeFrequency() {
      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        vm.formData.day = null;
        vm.formData.month = null;
        vm.fill_end_date = null;
        vm.formData.noOfInstallments = null;
        reSetting();
      }
      vm.formData.amount = getFinalAmount();
      checkValidations();
      if (vm.formData.frequency === 'DZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        vm.showCalender = false;
        if (vm.specificProperties.stpType == 'flexStp') {
          vm.specificProperties.showDayOfTransfer = false;
          vm.specificProperties.showDateOfTransfer = false;
        }
        updateDatesForDaily()
      } else if (vm.formData.frequency === 'OW') {
        vm.daysList = vm.TRANSACTIONS_CONST.WEEKS_LISTS;
        vm.viewMode = 'days';
        if(vm.specificProperties.stpType == "normalStp"){
          vm.showCalender = false;
        }else{
        vm.showCalender = true;
        }
        if (vm.specificProperties.stpType == 'flexStp') {
          vm.specificProperties.showDayOfTransfer = true;
          vm.specificProperties.showDateOfTransfer = false;
        }
      } else {
        if(vm.specificProperties.stpType === 'normalStp'){
        vm.daysList = null;
        }else{
        vm.daysList = getDaysList();
        }
        vm.viewMode = 'months';
        vm.showCalender = true;
        if (vm.specificProperties && vm.specificProperties.stpType == 'flexStp') {
          vm.specificProperties.showDayOfTransfer = false;
          vm.specificProperties.showDateOfTransfer = true;
        }
      }
      /*fetch validations form API*/
      // fetchCalculatedSTPValidations();
    }

    function resetDefaults(doNotEmptyValidations) {
      vm.isReseting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      if (!doNotEmptyValidations) {
        vm.validations = {};
      }
      checkValidations();
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function getFrequencyList() {
      var frequencyList = null;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP:
          frequencyList = (vm.formData.transferOption == vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT) ? angular.copy(vm.TRANSACTIONS_CONST.STP_FREQ_LIST_FOR_FIXED) : angular.copy(vm.TRANSACTIONS_CONST.STP_FREQ_LIST_FOR_CAPITAL);
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          frequencyList = (vm.formData.transferOption == vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT) ? angular.copy(vm.TRANSACTIONS_CONST.SWP_FREQ_LIST_FOR_FIXED) : angular.copy(vm.TRANSACTIONS_CONST.SWP_FREQ_LIST_FOR_CAPITAL);
          break;
      }
      return frequencyList;
    }

    function getAmountForStpType() {
      if (vm.formData.frequency === 'OM' || vm.formData.frequency === 'Q') {
        return '';//0.01;
      }
      return '';
    }

    function getFinalAmount() {
      var amount = vm.formData.amount;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP:
          amount = (vm.formData.transferOption == vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION) ? getAmountForStpType() : amount;
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          amount = (vm.formData.transferOption == vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION) ? 300 : amount;
          break;
      }
      return amount;
    }

    function showPrefillValues(rawData) {

      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP:
          if (rawData) {
            stpPrefillValues(rawData)
          } else {
            fetchPreviousTrSelectedDistrubutor(function () {
              vm.isCheckedTandC = (vm.formData.euin && vm.formData.euin.euinName) ? false : true;
              vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
              if (vm.formData.distributorARN) {
                fetchEuinListThroughDistributor(vm.formData.distributorARN)
              }
              vm.frequencyList = getFrequencyList();
              fetchFolioList(function (success) {
                if (success) {
                  var selectedFolioObj = vm.folioList.filter(function (row) {
                    return row.folioNumber == vm.formData.folioNumber;
                  })[0];
                  if (selectedFolioObj) {
                    vm.selectedFolioData = selectedFolioObj;
                    vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
                  }
                  fetchOutSchemes(function (success) {
                    if (success) {
                      fetchOutSchemeValidations(function (success) {
                        if (success) {
                          fetchInSchemes(function (success) {
                            if (success) {
                              fetchInSchemeValidations(function (success) {
                                if (success) {
                                  checkValidations();
                                  changeFrequency();
                                  vm.changeDay();
                                  vm.formData.isBackFromSummary = false;
                                  fetchUnitDetails();
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
            });
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP:
          if (rawData) {
            swpPrefillValues(rawData)
          } else {
            vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
            vm.frequencyList = getFrequencyList();
            fetchFolioList(function (success) {
              if (success) {
                var selectedFolioObj = vm.folioList.filter(function (row) {
                  return row.folioNumber == vm.formData.folioNumber;
                })[0];
                if (selectedFolioObj) {
                  vm.selectedFolioData = selectedFolioObj;
                  vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
                }
                fetchOutSchemes(function (success) {
                  if (success) {
                    fetchOutSchemeValidations(function (success) {
                      if (success) {
                        checkValidations();
                        changeFrequency();
                        vm.changeDay();
                        vm.formData.isBackFromSummary = false;
                        fetchUnitDetails();
                      }
                    });
                    fetchBankList();
                  }
                });
              }
            });
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH:
          if (rawData) {
            switchPrefillValues(rawData)
          } else {
            fetchPreviousTrSelectedDistrubutor(function () {
              vm.isCheckedTandC = (vm.formData.euin && vm.formData.euin.euinName) ? false : true;
              vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
              if (vm.formData.distributorARN) {
                fetchEuinListThroughDistributor(vm.formData.distributorARN)
              }
              fetchFolioList(function (success) {
                if (success) {
                  var selectedFolioObj = vm.folioList.filter(function (row) {
                    return row.folioNumber == vm.formData.folioNumber;
                  })[0];
                  if (selectedFolioObj) {
                    vm.selectedFolioData = selectedFolioObj;
                    vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
                  }
                  fetchOutSchemes(function (success) {
                    if (success) {
                      fetchOutSchemeValidations(function (success) {
                        if (success) {
                          fetchInSchemes(function (success) {
                            if (success) {
                              fetchInSchemeValidations(function (success) {
                                if (success) {
                                  checkValidations();
                                  fetchUnitDetails();
                                  fetchSwitchInSchemes(function (success) {
                                    if (success) {
                                      fetchSwitchInSchemeValidations();
                                      vm.formData.isBackFromSummary = false;
                                    }
                                  });
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
            });
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP:
          if (rawData) {
            dtpPrefillValues(rawData)
          } else {
            fetchPreviousTrSelectedDistrubutor(function () {
              vm.isCheckedTandC = (vm.formData.euin && vm.formData.euin.euinName) ? false : true;
              // $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
              if (vm.formData.distributorARN) {
                fetchEuinListThroughDistributor(vm.formData.distributorARN)
              }
              LoaderService.showLoader(".dtp-loader");
              fetchFolioList(function (success) {
                LoaderService.hideLoader(".dtp-loader");
                if (success) {
                  var selectedFolioObj = vm.folioList.filter(function (row) {
                    return row.folioNumber == vm.formData.folioNumber;
                  })[0];
                  if (selectedFolioObj) {
                    vm.selectedFolioData = selectedFolioObj;
                    vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
                  }
                  fetchOutSchemes(function () {
                    fetchInSchemes(function (success) {
                      if (success) {
                        fetchInSchemeValidations(function (success) {
                          if (success) {
                            checkValidations();
                            vm.formData.isBackFromSummary = false;
                          }
                        });
                      }
                    });
                  });
                }
              });
            });
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION:
          if (rawData) {
            redemptionPrefillValues(rawData)
          } else {
            vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
            fetchFolioList(function (success) {
              if (success) {
                fetchOutSchemes(function (success) {
                  if (success) {
                    fetchOutSchemeValidations(function (success) {
                      if (success) {
                        checkValidations();
                        vm.formData.isBackFromSummary = false;
                        fetchUnitDetails();
                      }
                    });
                    fetchBankList();
                  }
                });
              }
            });
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION:
          if (rawData) {
            instantRedemptionPrefillValues(rawData)
          } else {
            vm.formData.amount &&  $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
            fetchFolioList(function (success) {
              if (success) {
                vm.helper.fetchOutSchemesForInstantRed();
              }
            });
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX:
          if (rawData) {
            flexIndexPrefillValues(rawData);
          } else {
            fetchPreviousTrSelectedDistrubutor(function () {
              vm.isCheckedTandC = (vm.formData.euin && vm.formData.euin.euinName) ? false : true;
              vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
              fetchFolioList(function (success) {
                if (success) {
                  getInSchemesInfo();
                  fetchOutSchemes(function (success) {
                    if (success) {
                      fetchOutSchemeValidations(function () {
                        if (success) {
                          checkValidations();
                          vm.formData.isBackFromSummary = false;
                          fetchUnitDetails();
                        }
                      });
                    }
                  });
                }
              });

            });
          }
          break;
      }
    }

    function redemptionPrefillValues(rawData) {


      fetchFolioList(function (success) {
        if (success) {
          vm.formData.transactionId = rawData.id;
          vm.formData.folioNumber = rawData.folioNumber;
          var outSchemeCode = rawData.schemeCode || rawData.outSchemeCode;
          vm.folioChanged();
          fetchOutSchemes(function () {
            var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
              return outSchemeCode === item.schemeCode;
            }) || {};
            vm.formData.liquidFlag = scheme.liquidFlag;
            vm.formData.outSchemeName = scheme.schemeName || '';
            vm.formData.outSchemeCode = outSchemeCode;
            fetchOutSchemeValidations(function (success) {
              if (success) {
                vm.formData.amount = rawData.amount;
                vm.formData.units = rawData.units;
                vm.formData.isBackFromSummary = false;
                fetchUnitDetails(function(response){
                  if(response){
                    if (vm.unitsDetails) {
                      vm.formData.amountType = !vm.formData.units ? vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT : (vm.formData.units < vm.unitsDetails.freeValueUnits) ? vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS : vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS;
                      checkValidations();
                    }
                  }

                });

              }
            });
          });
          fetchBankList(function () {
            vm.formData.bankInfo = vm.bankList.find(function (i) {
              return i.payoutId === rawData.payoutId;
            }) || null;
          });
          $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
        }
      });
    }

    function instantRedemptionPrefillValues(rawData) {

      fetchFolioList(function (success) {
        if (success) {
          vm.formData.transactionId = rawData.id;
          vm.formData.folioNumber = rawData.folioNumber;
          vm.formData.amount = rawData.amount;
          vm.folioChanged();
          var outSchemeCode = rawData.schemeCode || rawData.outSchemeCode;
          vm.helper.fetchOutSchemesForInstantRed(function () {
            var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
              return outSchemeCode === item.schemeCode;
            }) || {};
            vm.formData.outSchemeName = scheme.schemeName || '';
            vm.formData.outSchemeCode = outSchemeCode;
            vm.validations.maxAmount = scheme.maxAmount ? parseFloat(scheme.maxAmount) : 0;
            vm.helper.setInstantRedSchemeValidations(scheme);
            vm.formData.bankInfo = vm.bankList.find(function (i) {
              return i.accountNo === rawData.bankInfo.accountNo;
            }) || null;
          });
          $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);


        }
      });
    }


    function stpPrefillValues(rawData) {

      fetchFolioList(function (success) {
        if (success) {
          vm.frequencyList = getFrequencyList();
          if (rawData.stpType === 'T') {
            vm.specificProperties.stpType = 'flexStp';
            vm.formData.frequency = rawData.frequency;
            vm.helper.changeStpType('T', rawData);
            vm.formData.amount = rawData.amount;
          } else if (rawData.stpType === 'Q') {
            vm.specificProperties.stpType = 'swingStp';
            vm.formData.frequency = rawData.frequency;
            vm.helper.changeStpType('Q', rawData);
            vm.formData.amount = rawData.amount;
          }
          vm.formData.transactionId = rawData.id;
          vm.formData.folioNumber = rawData.folioNumber;
          vm.folioChanged();
          var outSchemeCode = rawData.sourceSchemeCode || rawData.outSchemeCode;
          var inSchemeCode = rawData.targetSchemeCode || rawData.inSchemeCode;
          if (rawData.euinOpted === 'Y') {
            vm.formData.euin = {euinCode: rawData.euinCode, euinName: rawData.euinName,euinNameCode: rawData.euinName+"-"+rawData.euinCode}
          }
          if (rawData.riaOpted) {
            vm.formData.isThroughDistributor = false;
            vm.formData.isThroughRia = true;
            vm.formData.isDirect = false;
            vm.isArnSuccess = false;
            vm.riaConsent = rawData.riaConsent;
            vm.isCheckedTandC = rawData.riaConsent;
            vm.formData.brokerCode = rawData.brokerCode;
            vm.searchDistributor();
          }
          if (rawData.brokerCode && !rawData.riaOpted) {
            vm.formData.brokerCode = rawData.brokerCode ? rawData.brokerCode.replace('ARN-', ''):'';
            vm.formData.isThroughDistributor = true;
            vm.searchDistributor();
          }
          fetchOutSchemes(function () {
            var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
              return outSchemeCode === item.schemeCode;
            }) || {};
            vm.formData.outSchemeCode = outSchemeCode;
            vm.formData.outSchemeName = scheme.schemeName || '';
            fetchOutSchemeValidations(function (success) {
              if (success) {
                vm.formData.inSchemeCode = rawData.targetSchemeCode;
                var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                    return item.schemeCode === inSchemeCode;
                }) || {};vm.formData.inSchemeCode= inSchemeCode;
                vm.formData.inSchemeName = scheme.scheme || '';
                if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && scheme.retirementFlag) {
                  MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
                  vm.formData.inSchemeCode = '';
                  vm.formData.inSchemeName = '';
                  vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
                  return;
                }
                vm.formData.inSchemeType = scheme.schemeType || '';
                vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
                vm.frequencyList = getFrequencyList();
                fetchUnitDetails();
                fetchInSchemeValidations(function (success) {
                  if (success) {
                    vm.formData.dividendOption = rawData.dividendOption;
                    vm.formData.frequency = rawData.frequency;
                    changeFrequency();
                    vm.isShowDefault = 'true';
                    vm.formData.day = $window.parseInt(rawData.stpDay || rawData.day);
                    vm.changeDay();
                    vm.formData.amount = rawData.amount;
                    checkValidations();
                    vm.formData.isBackFromSummary = false;
                    vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
                  }
                });
              }
            });
          });

          fetchInSchemes(function (success) {
            if (success) {
              var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                return vm.formData.inSchemeCode === item.schemeCode;
              }) || {};
              vm.formData.inSchemeName = scheme.scheme || '';
              if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && scheme.retirementFlag) {
                MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
                vm.formData.inSchemeCode = '';
                vm.formData.inSchemeName = '';
                vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
                return;
              }
              fetchInSchemeValidations(function (success) {
                if (success) {
                  // vm.validations.investmentOption = investmentOption;
                  fetchUnitDetails();
                }
              });
            }
          });

        }
      });

    }

    function flexIndexPrefillValues(rawData) {

      fetchFolioList(function (success) {
        if (success) {
          vm.formData.transactionId = rawData.id;
          vm.formData.folioNumber = rawData.folioNumber;
          vm.formData.outSchemeCode = rawData.sourceScheme;
          vm.formData.inSchemeCode = rawData.targetScheme;
          vm.formData.amount = rawData.amountForRegistration;
          vm.folioChanged();
          if (rawData.investmentMode === 'F') {
            vm.specificProperties.investmentMode = 'Fixed';
          } else {
            vm.specificProperties.investmentMode = 'Flexible';
          }

          if (rawData.switchExecutionDetails) {
            vm.helper.fillSwitchExecutionDetails(rawData.switchExecutionDetails);
          }

          if (rawData.euinOpted === 'Y') {
            vm.formData.euin = {euinCode: rawData.euinCode, euinName: rawData.euinName,euinNameCode: rawData.euinName+"-"+rawData.euinCode}
          }
          if (rawData.riaOpted) {
            vm.formData.isThroughDistributor = false;
            vm.formData.isThroughRia = true;
            vm.formData.isDirect = false;
            vm.isArnSuccess = false;
            vm.formData.brokerCode = rawData.brokerCode;
            vm.riaConsent = rawData.riaConsent;
            vm.isCheckedTandC = rawData.riaConsent;
            vm.searchDistributor();
          }
          if (rawData.brokerCode && !rawData.riaOpted) {
            vm.formData.brokerCode = rawData.brokerCode ? rawData.brokerCode.replace('ARN-', ''):'';
            vm.formData.isThroughDistributor = true;
            vm.searchDistributor();
          }
          fetchOutSchemes(function () {
            var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
              return vm.formData.outSchemeCode === item.schemeCode;
            }) || {};
            vm.formData.outSchemeName = scheme.schemeName || '';
            fetchOutSchemeValidations(function (success) {
              if (success) {
                vm.formData.inSchemeCode = rawData.targetScheme;
                var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                  return item.schemeCode === vm.formData.inSchemeCode;
                }) || {};
                vm.formData.inSchemeName = scheme.scheme || '';
                vm.formData.transferOption = rawData.stpType;
                vm.frequencyList = getFrequencyList();
                vm.formData.amount = rawData.amountForRegistration;
                fetchInSchemeValidations(function (success) {
                  if (success) {
                    vm.formData.dividendOption = rawData.dividendOption;
                    vm.formData.frequency = rawData.frequency;
                    changeFrequency();
                    vm.isShowDefault = 'true';
                    vm.formData.day = rawData.stpDay ? +rawData.swpDay : '';
                    vm.changeDay();
                    vm.formData.amount = rawData.amount;
                    checkValidations();
                    vm.formData.isBackFromSummary = false;
                  }
                });
              }
            });
          });
          // fetchUnitDetails();

          fetchInSchemes(function (success) {
            if (success) {
              var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                return vm.formData.inSchemeCode === item.schemeCode;
              }) || {};
              vm.formData.inSchemeName = scheme.scheme || '';
              if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && scheme.retirementFlag) {
                MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
                vm.formData.inSchemeCode = '';
                vm.formData.inSchemeName = '';
                vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
                return;
              }
            }
          });

        }
      });

    }

    function swpPrefillValues(rawData) {

      fetchFolioList(function (success) {
        if (success) {
          vm.formData.transactionId = rawData.id;
          vm.formData.folioNumber = rawData.folioNumber;
          vm.formData.outSchemeCode = rawData.schemeCode;
          fetchOutSchemes(function () {
            var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
              return vm.formData.outSchemeCode === item.schemeCode;
            }) || {};
            vm.formData.outSchemeName = scheme.schemeName || '';
            fetchOutSchemeValidations(function (success) {
              if (success) {
                vm.formData.transferOption = rawData.swpType;
                vm.frequencyList = getFrequencyList();
                vm.formData.frequency = rawData.frequency;
                changeFrequency();
                vm.isShowDefault = 'true';
                vm.formData.day = rawData.swpDay ? +rawData.swpDay : '';
                vm.changeDay();
                vm.formData.amount = rawData.amount;
                checkValidations();
                vm.formData.isBackFromSummary = false;
                fetchUnitDetails();
              }
            });
          });
          fetchBankList(function () {
            vm.formData.bankInfo = vm.bankList.find(function (i) {
              return i.payoutId === rawData.payoutId;
            }) || null;
          });
        }
      });
    }

    function switchPrefillValues(rawData) {
      fetchFolioList(function (success) {
        if (success) {
          vm.formData.transactionId = rawData.id;
          vm.formData.folioNumber = rawData.folioNumber;
          vm.folioChanged();
          var outSchemeCode = rawData.switchOutSchemeCode || rawData.outSchemeCode;
          if (rawData.euinOpted === 'Y') {
            vm.formData.euin = {euinCode: rawData.euinCode, euinName: rawData.euinName,euinNameCode: rawData.euinName+"-"+rawData.euinCode}
          }
          if (rawData.riaOpted) {
            vm.formData.isThroughDistributor = false;
            vm.formData.isThroughRia = true;
            vm.formData.isDirect = false;
            vm.isArnSuccess = false;
            vm.isCheckedTandC = rawData.riaConsent;
            vm.riaConsent = rawData.riaConsent;
            vm.formData.brokerCode = rawData.brokerCode;
            vm.searchDistributor();
          }
          if (rawData.brokerCode && !rawData.riaOpted) {
            vm.formData.brokerCode = rawData.brokerCode?rawData.brokerCode.replace('ARN-', ''):'';
            vm.formData.isThroughDistributor = true;
            vm.searchDistributor();
          }
          fetchOutSchemes(function () {
            var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
              return outSchemeCode === item.schemeCode;
            }) || {};
            vm.formData.outSchemeName = scheme.schemeName || '';
            vm.formData.outSchemeCode = outSchemeCode;

            fetchOutSchemeValidations(function (success) {
              if (success) {
                fetchInSchemes(function (success) {
                  if (success) {
                    var inSchemeCode = rawData.switchInSchemeCode || rawData.inSchemeCode;
                    var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                      return item.schemeCode.trim() === inSchemeCode;
                    }) || {};
                    vm.formData.inSchemeName = scheme.scheme || '';
                    vm.formData.inSchemeCode = inSchemeCode;
                    if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && scheme.retirementFlag) {
                      MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
                      vm.formData.inSchemeCode = '';
                      vm.formData.inSchemeName = '';
                      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
                      return;
                    }
                    vm.formData.dividendOption = rawData.dividendOption;
                    fetchInSchemeValidations(function (success) {
                      if (success) {
                        vm.formData.amount = rawData.amount;
                        vm.formData.units = rawData.units;
                        //vm.formData.amountType = !vm.formData.units ? vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT : (vm.formData.units < vm.unitsDetails.freeValueUnits) ? vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS : vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS;
                        // checkValidations();
                        vm.formData.isBackFromSummary = false;
                        vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
                        fetchUnitDetails(function (response){
                          if(response){
                            if (vm.unitsDetails) {
                              localStorage.setItem("unitsSave",rawData.units)
                              vm.formData.amountType = !vm.formData.units ? vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT : (vm.formData.units < vm.unitsDetails.freeValueUnits) ? vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS : vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS;
                              // checkValidations();
                              vm.amountTypeChanged();
                              localStorage.removeItem("unitsSave")
                            }
                          }

                        });

                      }
                    });
                  }
                });
              }
            });
          });
        }
      });
    }

    function dtpPrefillValues(rawData) {

      fetchFolioList(function (success) {
        if (success) {
          vm.formData.transactionId = rawData.id;
          vm.formData.folioNumber = rawData.folioNumber;
          var selectedFolioObj = vm.folioList.filter(function (row) {
            return row.folioNumber == vm.formData.folioNumber
          })[0];
          if (selectedFolioObj) {
            vm.selectedFolioData = selectedFolioObj;
            vm.formData.corporateInvestor = angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
          }
          vm.formData.outSchemeCode = rawData.sourceScheme;
          if (rawData.euinOpted === 'Y') {
            vm.formData.euin = {euinCode: rawData.euinCode, euinName: rawData.euinName,euinNameCode: rawData.euinName+"-"+rawData.euinCode}
          }
          if (rawData.brokerCode) {
            vm.formData.brokerCode = rawData.brokerCode?rawData.brokerCode.replace('ARN-', ''):'';
            vm.formData.isThroughDistributor = true;
            vm.searchDistributor();
          }
          fetchOutSchemes(function () {
            var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
              return vm.formData.outSchemeCode === item.schemeCode;
            }) || {};
            vm.formData.outSchemeName = scheme.schemeName || '';

            fetchInSchemes(function (success) {
              if (success) {
                vm.formData.inSchemeCode = rawData.targetScheme;
                var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                  return item.schemeCode === vm.formData.inSchemeCode;
                }) || {};
                vm.formData.inSchemeName = scheme.scheme || '';
                if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && scheme.retirementFlag) {
                  MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
                  vm.formData.inSchemeCode = '';
                  vm.formData.inSchemeName = '';
                  vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
                  return;
                }
                vm.formData.dividendOption = rawData.dividendOption;
                fetchInSchemeValidations(function (success) {
                  if (success) {
                    vm.formData.isBackFromSummary = false;
                  }
                });
              }
            });
          });

        }
      });

    }

    vm.init = function () {

      $state.$previous = null;
      TransactionModel.setPayloadRawData(null);
      // checkIsTxnBlock(function () {
        if ($stateParams) {
          /* Check if stateparam variable initiated by has value schedule then redirecting to action designated to perform schedule action
          * Otherwise perform the normal operations
          */
          $stateParams.initiatedBy === 'schedule' ? getScheduleTransactionDetails() : setStateParams();
        }
      // });
      // getInSchemesInfo();

      if (vm.formData.isBackFromSummary || $stateParams.sc) {
        vm.isArnSuccess = false;
        vm.showArnLabel = vm.formData.brokerCode ? true : false;
        showPrefillValues();
      } else if ($stateParams.transactionId && $stateParams.initiatedBy !== 'schedule') {
        vm.frequencyList = getFrequencyList();
        getTransactionDetails();
      } else if ($stateParams.initiatedBy !== 'schedule') {
        fetchFolioList();
        vm.formData.transferOption = vm.formData.transferOption || vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
        vm.frequencyList = getFrequencyList();
      }

      if (vm.formData.inSchemeCode && !vm.formData.isBackFromSummary) {
        fetchInSchemeValidations();
      }
      if (vm.formData.frequency === 'DZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        updateDatesForDaily()
      } else if (vm.formData.frequency === 'OW') {
        vm.daysList = vm.TRANSACTIONS_CONST.WEEKS_LISTS;
        vm.viewMode = 'days';
      } else {
        if(vm.specificProperties.stpType === 'normalStp'){
          vm.daysList = null;
        }else{
        vm.daysList = getDaysList();
        }
        vm.viewMode = 'months';
      }
      if(localStorage.getItem('popupDisable') === 'false'){
        localStorage.removeItem('popupDisable');
      }
    };

    vm.checkPurchaseValidations = function () {
      if (vm.purchaseValidations) {

        if (!vm.purchaseValidations.addlPurchase) {
          vm.isPurchaseMin = vm.purchaseValidations.minFirstPurchaseAmt > vm.formData.purchaseAmount;
          vm.purchaseMinAmount = vm.purchaseValidations.minFirstPurchaseAmt;
        } else {
          vm.isPurchaseMin = vm.purchaseValidations.minAddlPurchaseAmt > vm.formData.purchaseAmount;
          vm.purchaseMinAmount = vm.purchaseValidations.minAddlPurchaseAmt;
        }
      }
    };

    vm.confirmCancel = function () {
      var success = function () {
        $state.go('welcome')
      };
      ModalService.confirmCancelModal({}, success);
    };

    /**
     * Function responsible for handling folio selection change
     */

    vm.folioChanged = function () {

      var successHandler = function(resp) {
        LoaderService.hideLoader();

        MessageService.clear();
        var oldData = angular.copy(vm.formData);
        resetAll();
        recoverFromResetting(oldData);
        var selectedFolioObj = vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        if (selectedFolioObj) {
          vm.selectedFolioData = selectedFolioObj;
        }
        vm.folioMinor = selectedFolioObj && !angular.isUndefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
        vm.formData.corporateInvestor = selectedFolioObj && angular.isDefined(selectedFolioObj.corporateInvestor) ? angular.copy(selectedFolioObj.corporateInvestor) : false;
        vm.transactionType = getTransactionType();
        if(vm.folioListToBlockTxnsaction && vm.folioListToBlockTxnsaction.includes(selectedFolioObj.folioNumber)){
          if(vm.appConstantsData.TRANSACTION_CONST_LIST_TO_BLOCK.includes(vm.transactionType)){
            var success = function(){
              if(vm.blockFolioForTransaction){
                vm.formData.folioNumber = null;
                var oldData = angular.copy(vm.formData);
                resetAll();
                recoverFromResetting(oldData);
              }
            }, error = function(){};
            ModalService.genericModal({isUpi : true, text : vm.popUpMessage}, success, error);
          }
        }
        if (vm.transactionType != vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
          fetchPreviousTrSelectedDistrubutor(function () {
            if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION) {
              vm.helper.getInstantRedSchemes();

            } else {
              fetchOutSchemes(function () {
              });
            }
            if ((vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) && (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION)) {
              fetchInSchemes(function () {
              });
            }
          });
        }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
          fetchOutSchemes(function () {
          });
        }
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        vm.formData.folioNumber=null;
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);


    };


    function fetchPreviousTrSelectedDistrubutor(cb) {

      cb = cb || function () {
      };
      if(!vm.formData.folioNumber){
        resetAll();
        cb(true);return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var distributorDetails = resp.data;
            if (distributorDetails.investThroughDistributor
              && distributorDetails.previousDistributorDetails.brokerCode.indexOf('ARN-') === 0) {
              var brokerCode = distributorDetails.previousDistributorDetails.brokerCode
                ? distributorDetails.previousDistributorDetails.brokerCode.split('-') : [];
              vm.formData.brokerCode = brokerCode.length > 0 ? brokerCode[1] : '';
              manipulateInvestThrough(AppConstants.INVEST_THROUGH.DISTRIBUTOR);
              vm.formData.brokerName = distributorDetails.previousDistributorDetails.brokerName;
              var subBrokerArn = distributorDetails.previousDistributorDetails.subBrokerArn;
              var subBrokerARNArray = subBrokerArn ? subBrokerArn.split('-') : [];
              vm.formData.subBrokerARN = subBrokerARNArray ? subBrokerARNArray[1] : '';
              vm.formData.subBrokerCode = distributorDetails.previousDistributorDetails.subBrokerCode;
              vm.subBrokerName = distributorDetails.previousDistributorDetails.subBrokerName;
              vm.euinMasterList = distributorDetails.previousDistributorDetails.euinDetailList;
              vm.euinList = vm.euinMasterList;
              vm.formData.euin = vm.euinList.length ===1 ? vm.euinList[0]:null;
              vm.formData.euin = distributorDetails.previousDistributorDetails.euinPreviousUsed ? vm.euinList[0] : null;
              vm.euinData.euinNameCode = vm.formData.euin ? vm.formData.euin.euinNameCode : null;
              vm.isCheckedTandC = false;
              vm.isArnSuccess = false;
              vm.showArnLabel = false;
              vm.searchDistributor();
            } else if (distributorDetails.investThroughRIA) {
              vm.formData.brokerCode = distributorDetails.previousDistributorDetails.brokerCode
                ? distributorDetails.previousDistributorDetails.brokerCode : '';
              vm.formData.brokerName = distributorDetails.previousDistributorDetails.brokerName;
              vm.isArnSuccess = false;
              vm.showArnLabel = false;
              vm.riaCodeError = "";
              manipulateInvestThrough(AppConstants.INVEST_THROUGH.RIA);
            } else {
              manipulateInvestThrough(AppConstants.INVEST_THROUGH.DIRECT);
              (angular.isUndefined($stateParams.sc)) && resetAll();
            }
            cb(true);
          } else {
            // vm.folioList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          // vm.folioList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'folio',
        child2: 'status',
        child3: 'previous',
        child4: 'transaction'
      },{folioNo:vm.formData.folioNumber}).$promise.then(success, error);
    }


    function recoverFromResetting(oldData) {
      if (vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP) {
        vm.formData.transferOption = oldData.transferOption;
      }
    }

    vm.schemeListModal = function () {
      var successHandler =function(resp)
      {
        LoaderService.hideLoader();
        if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
          MessageService.error('No free available units');
          return;
        }
        var successSchemeList = function (result) {
            vm.inSchemeChanged(result);
          },
          errorSchemeList = function () {
            vm.formData.inSchemeCode = '';
            vm.formData.inSchemeName = '';
            vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
          };

        var isFlexStp = false;
        var isSwingStp = false;

        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP && vm.specificProperties.stpType === 'flexStp') {
          isFlexStp = true;
        } else if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP && vm.specificProperties.stpType === 'swingStp') {
          isSwingStp = true;
        }

        ModalService.schemeListModal({
          enabledScheme: vm.transactionType.toLowerCase() + 'enabled',
          isMinor: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
          isFlexStp: isFlexStp,
          isSwingStp: isSwingStp,
          isThroughDistributor: vm.formData.isThroughDistributor,
          corporateFlag : vm.formData.corporateInvestor
        }, successSchemeList, errorSchemeList);
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      }
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);


    };

    vm.switchInSchemeListModal = function () {
      if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
        MessageService.error('No free available units');
        return;
      }
      var successSchemeList = function (result) {
          vm.switchInSchemeChanged(result);
        },
        errorSchemeList = function () {
          vm.formData.switchInSchemeCode = '';
          vm.formData.switchInSchemeName = '';
          vm.autoSwitchInSchemeList = UtilService.getFilteredList(vm.autoSwitchInSchemes);
        };

      var isFlexStp = false;

      ModalService.schemeListModal({
        enabledScheme: 'autoSwitchenabled',
        isMinor: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
        isFlexStp: isFlexStp,
        isThroughDistributor: vm.formData.isThroughDistributor,
        corporateFlag : vm.formData.corporateInvestor
      }, successSchemeList, errorSchemeList);
    };

    vm.flexIndexschemeListModal = function () {
      if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
        MessageService.error('No free available units');
        return;
      }
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.amountType = vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT;
      vm.formData.bankInfo = null;
      var successSchemeList = function (result) {
          vm.formData.inSchemeCode = result.schemeCode;
          vm.formData.inSchemeName = result.scheme;
          if (vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && result.retirementFlag) {
            MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
            vm.formData.inSchemeCode = '';
            vm.formData.inSchemeName = '';
            vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
            return;
          }
          fetchInSchemeValidations();
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            vm.formData.sipPaymentOption = vm.paymentOptions[0];
            fetchBankList();
          }
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
        },
        errorSchemeList = function () {
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
        };

      var isFlexIndex = false;

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        isFlexIndex = true;
      }

      ModalService.schemeListModal({
        enabledScheme: 'flex-index-enabled',
        isMinor: vm.folioMinor != undefined ? vm.folioMinor : false,//vm.investorInfo.minor,
        isFlexIndex: isFlexIndex,
        isThroughDistributor: vm.formData.isThroughDistributor,
        portalName: '',
        taxStatusCode: '',
        corporateFlag : vm.formData.corporateInvestor
      }, successSchemeList, errorSchemeList);
    };

    vm.outSchemeChanged = function (schemeData) {

      if (!schemeData) {
        return;
      }

      if(schemeData) {
        vm.formData.outSchemeCode = schemeData.schemeCode;
        vm.formData.outSchemeName = schemeData.schemeName;
      }
      if(vm.masterOutSchemeList) {
        vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList, 'schemeName', vm.formData.outSchemeName);
        fetchInSchemeValidations(function (success) {
          if (success) {
            // vm.validations.investmentOption = investmentOption;
          }
        });
      }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
          vm.formData.sipPaymentOption = vm.paymentOptions[0];
          fetchBankList();
        }
        vm.transactionType = getTransactionType();
        vm.formData.inSchemeCode = '';
        vm.formData.inSchemeName = '';
        vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
        vm.formData.amount = '';
        vm.formData.units = '';
        vm.formData.amountType = vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT;
        if (vm.transactionType != vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION) {
          vm.formData.bankInfo = null;
          vm.bankList = null;
        }
        vm.unitsDetails = null;
        vm.formData.dividendOption = '';
        vm.formData.frequency = '';
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.day = null;
        vm.formData.noOfInstallments = null;
        if (vm.tForm && vm.tForm.frequency) {
          vm.tForm.frequency.$setPristine();
        }
        if (vm.tForm && vm.tForm.day) {
          vm.tForm.day.$setPristine();
        }
        vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
        if (!vm.formData.outSchemeCode) {
          vm.formData.outSchemeName = '';
          return;
        }

        var scheme = vm.outSchemeList.find(function (item) {
          return item.schemeCode === vm.formData.outSchemeCode;
        }) || {};
        vm.formData.outSchemeName = scheme.schemeName || '';

        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
          vm.formData.liquidFlag = scheme.liquidFlag ? scheme.liquidFlag : 'N';
        }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION) {
          vm.helper.setInstantRedSchemeValidations(scheme);
        } else {
          if (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP) {
            fetchOutSchemeValidations(function (success) {
              if (success) {
                fetchUnitDetails();
              } else if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
                fetchUnitDetails();

              }
            });
          }
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
            fetchBankList();
          }
        }
    };

    vm.filterInSchemeList = function () {
      vm.transactionType = getTransactionType();
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeType = '';
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
      vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
      vm.transferOptionChanged(vm.formData.transferOption)
      resetNumInWords();

    };

    vm.filterOutSchemeList = function () {
      vm.transactionType = getTransactionType();
      vm.formData.outSchemeCode = '';
      vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList, 'schemeName', vm.formData.outSchemeName);
      resetNumInWords();
    };

    vm.filterSwitchInSchemeList = function () {
      vm.formData.switchInSchemeCode = '';
      vm.autoSwitchInSchemeList = UtilService.getFilteredList(vm.autoSwitchInSchemes, 'scheme', vm.formData.switchInSchemeName);
      // resetNumInWords();

    };

    vm.uploadRetirementProofFile = function (file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.formData.retirementAgeProofURL = resp.data.fileUrl;

                vm.breakFileUrl(resp.data.fileUrl);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              $log.info("err=== ", err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            InvestorFileUploadService.post({
              child1: 'transaction',
              child2: 'retirement',
              child3: 'ageProof',
              child4: 'upload'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    };

    vm.breakFileUrl = function (url) {

      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      vm.retirementAgeProofURL = a[a.length - 1] + extension;
      vm.chooseAFile = false;

    };
    vm.inSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.formData.inSchemeCode = schemeData.schemeCode;
        vm.formData.inSchemeName = schemeData.scheme;
        vm.formData.inSchemeType = schemeData.schemeType;
        if(vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
          return;
        }
        vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
        vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
        vm.transferOptionChanged(vm.formData.transferOption)
        if (schemeData.nfoEnabled == 'Y') {
          vm.nfoEnabled = true;
        } else {
          vm.nfoEnabled = false;
        }

        fetchInSchemeValidations(function (success) {
          if (success) {
            // vm.validations.investmentOption = investmentOption;
          }
        });

        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
          vm.formData.sipPaymentOption = vm.paymentOptions[0];
          fetchBankList();
        }
        if(vm.transactionType ==='STP' && schemeData.schemeType === 'NFO') {
          ModalService.nfoTransactionPointNotes();
        }
      }
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.day = null;
      vm.formData.bankInfo = null;
      vm.formData.frequency = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? vm.frequencyList[0].key : null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.amountType = vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT;
      vm.formData.noOfInstallments = '';
      if (vm.tForm && vm.tForm.amount) {
        vm.tForm.amount.$setPristine();
      }
      if (vm.tForm && vm.tForm.frequency) {
        vm.tForm.frequency.$setPristine();
      }
      if (vm.tForm && vm.tForm.day) {
        vm.tForm.day.$setPristine();
      }
      reSetting();
      resetDefaults();
      resetNumInWords();
    };

    vm.switchInSchemeChanged = switchInSchemeChanged;

    function switchInSchemeChanged(schemeData) {

      if (!schemeData) {
        return;
      } else {
        vm.formData.switchInSchemeCode = schemeData.schemeCode;
        vm.formData.switchInSchemeName = schemeData.scheme;
        vm.formData.switchInSchemeType = schemeData.schemeType;
        vm.autoSwitchInSchemeList = UtilService.getFilteredList(vm.autoSwitchInSchemes, 'scheme', vm.formData.switchInSchemeName);

        fetchSwitchInSchemeValidations(function (success) {
          if (success) {
            // vm.validations.investmentOption = investmentOption;
          }
        });
      }

      reSetting();
      //resetDefaults();
      //resetNumInWords();
    }

    vm.amountTypeChanged = function () {
      if (vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT) {
        vm.formData.units = '';
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH) {
          checkSwitchValidations();
        }
      } else if (vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS) {
        vm.formData.amount = '';
        vm.formData.units = +vm.unitsDetails.freeValueUnits.toFixed(2);
        // checkValidations();
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH) {
          checkSwitchValidations();
        }
      } else {
        vm.formData.amount = '';
        vm.formData.units = vm.formData.units ? vm.formData.units : '';
        localStorage.getItem("unitsSave") ? vm.formData.units = parseFloat(localStorage.getItem("unitsSave")) : vm.formData.units = '';
        // checkValidations();
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH) {
          checkSwitchValidations();
        } else if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
          vm.isRequired = true;
        }
      }
    };

    vm.transferOptionChanged = function (transferType) {
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.day = null;
      vm.formData.amount = '';
      vm.formData.frequency = null;
      vm.formData.bankInfo = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.formData.noOfInstallments = null;
      vm.formData.transferOption = transferType ? transferType : vm.formData.transferOption;
      vm.frequencyList = getFrequencyList();
    };

    vm.changeFrequency = function () {
      resetDefaults(true);
      vm.formData.amount = null;
      changeFrequency();
      resetNumInWords();
      if((vm.specificProperties.stpType === 'normalStp') && (vm.formData.frequency == "OM" || vm.formData.frequency == "Q")){
        updateDatesForOthers();
      }
    };

    vm.changeDay = function () {
      if (!vm.formData.frequency || !vm.formData.day) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        vm.fill_end_date = '';
        vm.formData.noOfInstallments = null;
        reSetting();
        return;
      }
      else {
        if (!vm.formData.isBackFromSummary) {
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          vm.fill_end_date = '';
          vm.formData.noOfInstallments = null;
          reSetting();
        }
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.month = '';
        vm.formData.enabledEndDates = [];
      }

      vm.formData.amount = '';

      switch (vm.formData.frequency) {
        case 'DZ':
          reSetting();
          break;
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default :
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          reSetting();
          break;
      }
    };

    vm.changeStartDate = function (date) {
      vm.formData.amount = "";
      if (vm.tForm && vm.tForm.amount) {
        vm.tForm.amount.$setPristine();
      }
      vm.formData.startDate = date ? date : null;
      vm.formData.endDate = null;
      vm.isReseting = true;
      vm.fill_end_date="";
      $timeout(function () {
        vm.isReseting = false;
      });
      if((vm.specificProperties.stpType === 'normalStp') && (vm.formData.frequency == "OM" || vm.formData.frequency == "Q")){
        vm.formData.day = +(vm.formData.startDate.format('DD'))
      }
      updateEndDates();
    };

    vm.changeEndDate = function (date) {
      vm.formData.amount = "";
      if (vm.tForm && vm.tForm.amount) {
        vm.tForm.amount.$setPristine();
      }
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
        vm.formData.endDate = date.set('Date', vm.formData.day);
      } else {
        vm.formData.endDate = date ? date : null;
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP) {
        if (vm.formData.frequency === 'DZ' || vm.formData.frequency === 'OW') {
          vm.helper.calculateNumberOfInstallmentForStpDaysWeek();
        }else if (vm.formData.frequency === 'OM' || vm.formData.frequency === 'Q') {
          vm.helper.calculateNumberOfInstallmentForStp();
        }
          if (vm.specificProperties.stpType === 'flexStp' && vm.formData.frequency === 'DZ') {
            calculateSTPMinAmountAndMultples('BZ');
            if(vm.formData.noOfInstallments >= 6 && vm.formData.noOfInstallments < 12) {
              vm.fill_end_date = "Since your selected no. of installments are "+ vm.formData.noOfInstallments +" so please keep your minimum " +
                "installment amount as Rs "+ (vm.validations.minAmount).toFixed(2) +".";
            } else if(vm.formData.noOfInstallments >= 12){
              vm.fill_end_date = "Since your selected no. of installments are more than or equal to 12, so please keep your minimum installment amount as Rs " + vm.validations.minAmount +".";
            }
          }

          if (vm.formData.frequency === 'OW') {

            calculateSTPMinAmountAndMultples(vm.formData.frequency,vm.validations.minInstallments);
            if (vm.formData.inSchemeType === "ELSS") {
              vm.fill_end_date = "Since your selected ELSS scheme so please keep your minimum installment amount as Rs " +  vm.validations.minAmount + ".";
            }else if(vm.formData.noOfInstallments >= 6 && vm.formData.noOfInstallments < 12) {
              vm.fill_end_date = "Since your selected no. of installments are "+ vm.formData.noOfInstallments +" so please keep your minimum " +
                "installment amount as Rs "+ (vm.validations.minAmount).toFixed(2) +".";
            }else if(vm.formData.noOfInstallments >= 12){
              vm.fill_end_date = "Since your selected no. of installments are more than or equal to 12, so please keep your minimum installment amount as Rs " + vm.validations.minAmount +".";
            }

          }else if (vm.formData.frequency === 'OM') {
            calculateSTPMinAmountAndMultples(vm.formData.frequency,vm.validations.minInstallments);
            if (vm.formData.inSchemeType === "ELSS" && (vm.formData.noOfInstallments >= 6)) {
              vm.fill_end_date = "Since your selected ELSS scheme so please keep your minimum installment amount as Rs " +  vm.validations.minAmount + ".";
            }
          }else if (vm.formData.frequency === 'Q') {
            calculateSTPMinAmountAndMultples(vm.formData.frequency,vm.validations.minInstallments);
            if (vm.formData.inSchemeType === "ELSS" && (vm.formData.noOfInstallments >= 2)) {
              vm.fill_end_date = "Since your selected ELSS scheme so please keep your minimum installment amount as Rs " +  vm.validations.minAmount + ".";
            }
          }
      }

    };

    vm.changeInvestmentType = function () {         // specific to sip-purchase transaction only
      var folioNumber = vm.formData.folioNumber;
      var investmentType = vm.formData.investmentType;
      var sipPaymentOption = vm.formData.sipPaymentOption;
      var sTransactionId = vm.formData.sTransactionId;
      var pTransactionId = vm.formData.pTransactionId;
      vm.transactionType = investmentType;
      if (investmentType === 'SIP') {
        fetchInSchemes(function (succ) {
          if (succ) {
            vm.formData.sipDividendOption = vm.devidendOptionsOther[0];
          }
        });
      }

      vm.formData = TransactionModel.getMasterRawData(vm.transactionType);
      vm.formData.folioNumber = folioNumber;
      vm.formData.sTransactionId = sTransactionId;
      vm.formData.pTransactionId = pTransactionId;
      vm.formData.investmentType = investmentType;
      vm.formData.sipPaymentOption = sipPaymentOption;
      $state.$previous = null;
      // vm.formData.frequency = vm.frequencyList[0].key;
      TransactionModel.setPayloadRawData(null);
      reSetting();
    };

    vm.changeThroughDistributor = function (investThrough) {
      vm.transactionType = getTransactionType();
      if (investThrough === 'DIRECT') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
      } else if (investThrough === 'ARN') {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
      } else if (investThrough === 'RIA') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
      }
      if (!vm.formData.isThroughDistributor) {
        vm.formData.euin = {};
        vm.euinData = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributerName = '';
        vm.distributorList = [];
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        vm.formData.euinInput = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.isSelectedEuin = true;
        vm.subBrokerName = '';
      }
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      fetchInSchemes();
      if (!vm.formData.isThroughRia) {
        resetRIAValues();
      }
    };

    vm.addOptionalTransaction = function () {
      vm.formData.optionalInvestmentType = (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) ? vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE : vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP
      fetchInSchemes();
    };

    vm.changeTillPerpetuityFlag = function () {
      vm.formData.endDate = null;
      vm.enabledEndDates = null;
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
        updateEndDates();
      }, 0);
    };

    vm.searchDistributor = function () {
      //vm.isInvalidForm = vm.formData.brokerCode ? false : (vm.isArnSuccess ? true : false);
      //vm.isInvalidForm = true;
      if (!vm.formData.brokerCode) {
        return;
      }
        fetchEuinList();

    };

    vm.searchDistributorByName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      //vm.isInvalidForm = true;
      vm.brokerCodeError = '';
      vm.isArnSuccess = true;
      if ((!vm.formData.distributerName) || (vm.formData.distributerName && vm.formData.distributerName.length < 3)) {
        vm.distributorList = null;
        vm.euinList = null;
        //vm.formData.euinInput = '';
        vm.formData.euin = {};
        return;
      }
      fetchARNByName();

    };

    vm.saveForm = function () {
      vm.isRequired = false;
      vm.isSaving = true;
      /* get_no_of_installments();*/
      var payload = getFinalPayloadData();
      if (!payload) {
        return;
      }

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (angular.isArray(resp.data)) {
              var data = {};
              resp.data.forEach(function (_form) {
                if (_form) {
                  switch (_form.transactionType) {
                    case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
                      data.sipForm = _form;
                      break;
                    case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
                      data.purchaseForm = _form;
                      break;
                  }
                }
              });

              vm.formData.sTransactionId = data.sipForm ? data.sipForm.transactionId : '';
              vm.formData.pTransactionId = data.purchaseForm ? data.purchaseForm.transactionId : '';
            } else {
              vm.formData.transactionId = resp.data.transactionId;
            }


            var successModal= function () {
                $state.go('welcome')
              };
            ModalService.savedTransactionModal({},successModal);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      // var _controller2 = (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) ? vm.transactionType.toLowerCase() : 'multiple';
      var _controller2 = vm.transactionType.toLowerCase();

      if (vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SCHEDULE_TRANSACTION_SWITCH) {
        _controller2 = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH.toLowerCase();
      } else if (vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SCHEDULE_TRANSACTION_REDEMPTION) {
        _controller2 = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION.toLowerCase();
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        _controller2 = 'flex-index';
      }

      TransactionService.post({
        controller1: 'transaction',
        controller2: _controller2,
        controller3: 'save'
      }, payload).$promise.then(success, error);
    };

    vm.saveInstaForm = function () {
      vm.isRequired = false;
      vm.isSaving = true;
      var payload = getFinalPayloadData();
      if (!payload) {
        return;
      }

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.formData.transactionId = resp.data.transactionId;

            var successModal= function () {
              $state.go('welcome')
            };
            ModalService.savedTransactionModal({},successModal);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      TransactionService.post({
        controller1: 'transaction',
        controller2: 'redemption',
        controller3: 'save'
      }, payload).$promise.then(success, error);
    };

    vm.changedPaymentOption = function () {
      vm.formData.bankInfo = null;
      vm.formData.otmId = '';
      fetchBankList()
    };

    function resetBankDetails() {
      vm.formData.bankCity = '';
      vm.formData.bankBranch = '';
      vm.formData.bankAcNo = '';
      vm.formData.verifyBankAcNo = '';

    }

    vm.otherBankSelected = function () {
      //vm.formData.bankInfo = '';
    };

    vm.checkSwitchSummary = function () {
      /*if (vm.formData.inSchemeName && vm.formData.inSchemeName.includes('Children')) {
        var success = function () {
            //pass data here
            vm.goToSummary();
          },
          error = function () {

          };
        var message = AppConstants.TRANSACTIONS.CGF_SCHEME_MSG;
        ModalService.childrenFundMessage({message: message}, success, error);
      } else {
        vm.goToSummary();
      }*/
      vm.goToSummary();
    };

    vm.goToSummary = function (data) {
      vm.transactionType = getTransactionType();
      if (vm.transactionType === 'SWITCH') {
        var message = '';
        //pass data here
        vm.showCutOffModal({cutoffData:vm.popup});
        /*var currentTime = moment(new Date(), "HH:mm:ss a");
        var dow = currentTime.format('dddd');
        var d = new Date();
        var notAllowedDays = ['Saturday', 'Sunday'];*/
        vm.outSchemeLiquidFlag = vm.outSchemeList.filter(function (item) {
          if (item.schemeCode == vm.formData.outSchemeCode) {
            return item.liquidFlag;
          }
        });

        /*if ((vm.formData.inSchemeType != 'LIQUID' && vm.outSchemeLiquidFlag[0].liquidFlag == 'N') && notAllowedDays.indexOf(dow) == -1) {
          d.setHours(15);
          d.setMinutes(0);
          d.setSeconds(0);
          var timeToCompareNonLiquid = moment(d, "HH:mm:ss a");
          var status = currentTime.isAfter(timeToCompareNonLiquid);
        } else if (vm.formData.inSchemeType == 'LIQUID' || vm.outSchemeLiquidFlag[0].liquidFlag == 'Y') {
          status = false;
        } else {
          status = true;
        }*/

        /*if (notAllowedDays.indexOf(dow) == -1) {
          d.setHours(13);
          d.setMinutes(0);
          d.setSeconds(0);
          var timeToCompareNonLiquid = moment(d, "HH:mm:ss a");
          var status = currentTime.isAfter(timeToCompareNonLiquid);
        }*/
        /*if (status) {
          message = 'The NAV applicable for this transaction would be of the next business day.';
          vm.showCutOffModal(message)
        } else vm.moveToSummary();*/

      } else if (vm.transactionType === 'REDEMPTION') {
        /*currentTime = moment(new Date(), "HH:mm:ss a");
        dow = currentTime.format('dddd');
        d = new Date();
        message = '';
        notAllowedDays = ['Saturday', 'Sunday'];*/
        //vm.showCutOffModal(message);
        fetchNudgeDetails(function(status) {
          if (status) {
            /*vm.outSchemeLiquidFlag = vm.outSchemeList.filter(function (item) { // code commented to show nudge modal for liquid scheme
              if (item.schemeCode == vm.formData.outSchemeCode) {
                return item.liquidFlag;
              }
            });
            if (vm.formData.inSchemeType == 'LIQUID' || vm.outSchemeLiquidFlag[0].liquidFlag == 'Y' ) {
              vm.moveToSummary();
            } else {
              redemptionConfirmModalShow();
            }*/
            redemptionConfirmModalShow();
          }
        });
      } else {
        vm.moveToSummary();
      }
    };

    function redemptionConfirmModalShow() {
      vm.nudgePayload = {
        folioNumber: vm.formData.folioNumber,
        popUpType: "REDEMPTION_NUDGE"

      };
      if(angular.isUndefined(vm.redeemNudgeDetails.REDEMPTION_NUDGE)){
        vm.nudgePayload.nudgeSuccess = false;
        vm.nudgePayload.nudgePopup = true;
        nudgeRequest(vm.nudgePayload);
      }
      else {
      var success = function (resp) {
        if(resp.pop_status=='false') {
          vm.nudgePayload.nudgePopup = false;
        } else {
          vm.nudgePayload.nudgePopup = true;
        }
        if(resp.status=='stay'){
          vm.nudgePayload.nudgeSuccess = true;
          nudgeRequest(vm.nudgePayload);
        } else {
          vm.nudgePayload.nudgeSuccess = false;
          nudgeRequest(vm.nudgePayload);
        }
      }, error = function () {

      };
      ModalService.redemptionConfirmModal({message: vm.redeemNudgeDetails.REDEMPTION_NUDGE.popUpDescription,folioNumber: vm.formData.folioNumber},success, error);
    }
    }

    vm.moveToSummary = function () {
      vm.isRequired = true;
      vm.isSaving = false;

      if (vm.formData.euin && !vm.formData.euin.euinName && !vm.formData.euin.euinCode && vm.formData.euinInput) {
        vm.formData.euin.euinName = (vm.formData.euinInput.split('-')[0]).trim();
        vm.formData.euin.euinCode = (vm.formData.euinInput.split('-')[1]).trim();
      }

      $state.$previous = $state.current;
      // if (vm.tForm.$valid) {
      var payloadData = getFinalPayloadData();
      if (!payloadData) {
        return;
      }
      var selectedFolioObj = vm.folioList.filter(function (row) {
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      payloadData.email = selectedFolioObj.email ? selectedFolioObj.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
      payloadData.mobileNumber = selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;
      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
        payloadData.nudgeRequestID = vm.requestId;
      }
      payloadData.randomOTPId = vm.randomOTPId;
      TransactionModel.setPayloadRawData(payloadData);
      vm.summaryData = payloadData;
      vm.summaryData['scheduleDetails'] = vm.scheduleTransactionDetails;
      //vm.summaryData = {...payloadData, scheduleDetails: vm.scheduleTransactionDetails};
      vm.formData.isSummaryViewEnabled = true;
      // $state.go('main.summary', data);
      // }
    };

    vm.showCutOffModal = function (message) {
      if (message.cutoffData) {
        var success = function () {
          vm.moveToSummary();
        }, error = function () {

        };
        ModalService.cutOffModal({message: message,transactionType:vm.transactionType}, success, error);
      } else {
        vm.moveToSummary();
      }
    };

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        e.preventDefault();
      }
      return false;
    };

    vm.copyPasteHandler = function (e) {
      UtilService.copyPasteHandler(e);
    };

    vm.accModelDirty = false;
    vm.accFocus = function () {
      vm.accModelDirty = true;
    };

    vm.isCheckedEuin = function () {
      if (vm.isCheckedTandC) {
        vm.formData.euin = {};
        vm.euinData.euinNameCode = '';
        vm.filterEuinList();
        vm.isSelectedEuin = true;
      }
    };

    vm.isSelectEuin = function () {
      if (vm.formData.euin) {
        vm.isCheckedTandC = false;
      }
    };

    function checkOTMAmountAndDate() {

      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      // Check Ammout
      if (vm.formData.amount && (vm.formData.amount > vm.formData.bankInfo.maxAmount)) {
        vm.isOTMAmount = true;
      } else {
        vm.isOTMAmount = false;
      }

      //Compare Dates
      if (new Date(vm.formData.bankInfo.omExpiryDate) < new Date(vm.formData.startDate)) {
        vm.isOTMDate = true;
      }
      else {
        vm.isOTMDate = false;
      }
      //Check for amount or date
      if (vm.isOTMAmount || vm.isOTMDate) {
        vm.isInvalidForm = true;
      } else {
        vm.isInvalidForm = false;
      }
    }

    vm.downloadReport = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/pdf' });
            FileSaver.saveAs(data, 'exitLoad.pdf');
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "schemeCode": vm.formData.outSchemeCode,
        "commonReportCO": {
          "docDestination": "download"
        }
      };

      DownloadPdfService.downloadFile(payload).then(success, error);
    }

    vm.changeDistributorCode = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.distributerName = '';
      vm.euinList = null;
      vm.isArnSuccess = true;
      vm.formData.subBrokerCode = '';
      vm.formData.subBrokerARN = '';
      vm.formData.isSubarnSuccess = false;
      vm.isCheckedTandC = false;
      vm.formData.euin = {};
      vm.subBrokerName = '';
      vm.riaCodeError = "";
    }

    vm.changeDistributorName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      vm.euinList = null;
    }

    vm.distributorListChanged = function (data) {
      if (!data) {
        // vm.isArnSuccess = true;
        return;
      } else {
        vm.brokerCodeError = '';
        vm.formData.distributorARN = data.arnCode;
        vm.formData.distributerName = data.name + ' - ' + data.arnCode;
        if (vm.formData.distributorARN) {
          //vm.isInvalidForm = false;
          vm.isArnSuccess = false;
        }
        else {
          vm.isArnSuccess = true;
        }
        fetchEuinListThroughDistributor(vm.formData.distributorARN);
      }
    };

    if (vm.formData.stpType === 'T') {
      vm.specificProperties.stpType = 'flexStp';
      //vm.changeFrequency();
    }
    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';

    }

    vm.instantRedeemBankValidation = function (bank){
      $timeout(function(){
        vm.formData.bankInfo = bank;
        changeBank()
      },10);
      if(vm.formData.bankInfo && vm.formData.bankInfo.bankEligible === 'N'){
        vm.showBankInfo = true;
      }else{
        vm.showBankInfo = false;
      }
    }

    vm.onChangeSTPInstallment = function(){
      vm.formData.amount = "";
      if (vm.tForm && vm.tForm.amount) {
        vm.tForm.amount.$setPristine();
      }
      if(vm.formData.frequency == 'OW' && vm.specificProperties.stpType === 'normalStp'){
        calculateSTPMinAmountAndMultples('OW', vm.validations.minInstallments);
        if(vm.formData.noOfInstallments >= 6 && vm.formData.noOfInstallments < 12) {
          vm.fill_end_date = "Since your selected no. of installments are "+ vm.formData.noOfInstallments +" so please keep your minimum " +
            "installment amount as Rs "+ (vm.validations.minAmount).toFixed(2) +".";
        }else if(vm.formData.noOfInstallments >= 12){
          vm.fill_end_date = "Since your selected no. of installments are more than or equal to 12, so please keep your minimum installment amount as Rs " + vm.validations.minAmount +".";
        }
        updateDatesForWeekly();
      }else{
      calculateSTPMinAmountAndMultples('BZ', vm.validations.minInstallments);
      }

    };


    function getDetails(folioNumber, cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
        var bankDetails=[];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if(vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length>0){
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if(value.defaultBank===true){return value;}
          });
          cb(true);
        }
        localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
      }, error = function () {
        LoaderService.hideLoader();
        cb(false);
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: folioNumber}).$promise.then(success, error);
    }
    function changeBank() {
      vm.selectedFolioObj = vm.folioList.filter(function (row) {
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      localStorage.setItem('folioId',vm.selectedFolioObj.folioNumber);
      if(vm.selectedFolioObj && vm.selectedFolioObj.minorFlag && !vm.formData.bankInfo.minorBankFlag) {
        getDetails(vm.selectedFolioObj.folioNumber, function (success) {
            if (success) {
              ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            }
          });
      }
    }
    /*----------- Schedule transaction section starts from here ------------*/
    /* Schedule transaction button event handler */
    vm.goToScheduleTransaction = function() {
      vm.transactionType = getTransactionType();
      var transactionType = vm.transactionType;
      var success = function(response) {
        if(transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
          fetchNudgeDetails(function(status) {
            if (status) {
              scheduleRedemption(response);
            }
          });
        } else {
          var success = function(result) {
              vm.transactionType = "SCHEDULE_TRANSACTION_" + transactionType.toUpperCase();
              vm.scheduleTransactionDetails = result;
              vm.scheduleTransactionDetails['transactionAction'] = "REVIEW";
              vm.scheduleTransactionDetails['state'] = transactionType.toUpperCase();
              vm.moveToSummary();
            },
            failure = function() {
              $log.info("modal has been cancelled");
            };
          ModalService.openScheduleTransactionModal({
            title: "Schedule Transaction",
            schemeType: vm.formData.inSchemeType,
            amountType: vm.formData.amountType,
            initiatedController: vm.formData.investmentType,
            nonBusinessDay: response.data,
            notesDynamic : vm.notesSchedule,
            termsConditionReviewSchedule : vm.TermsConditionSchedule,
            notesReviewSchedule : vm.noteReviewSchedule
          }, success, failure);
        }
      }, failure = function (response) {
        MessageService.error(response.message);
      };
      TransactionService.get({
        controller1: 'nonBusinessDate',
        schemeCode:  transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH ? vm.formData.inSchemeCode : vm.formData.outSchemeCode,
      }).$promise.then(success, failure);
    }

    function scheduleRedemption(response) {
      var outSchemeLiquidFlag = vm.outSchemeList.filter(function (item) {
        if (item.schemeCode == vm.formData.outSchemeCode) {
          return item.liquidFlag;
        }
      });
      vm.nudgePayload = {
        folioNumber: vm.formData.folioNumber,
        popUpType: "SCHEDULE_TRANSACTION_NUDGE"
      };
      if(angular.isUndefined(vm.redeemNudgeDetails.REDEMPTION_NUDGE)){
        vm.nudgePayload.nudgeSuccess = false;
        vm.nudgePayload.nudgePopup = true;
        nudgeRequest(vm.nudgePayload);
        approveScheduleRedeem(response);
      }
      else {
        var success = function (resp) {
          if(resp.pop_status === 'false') {
            vm.nudgePayload.nudgePopup = false;
          } else {
            vm.nudgePayload.nudgePopup = true;
          }
          if (resp.status=='stay') {
            vm.nudgePayload.nudgeSuccess = true;
            nudgeRequest(vm.nudgePayload);
          } else {
            localStorage.removeItem('popupDisable');
            vm.nudgePayload.nudgeSuccess = false;
            nudgeRequest(vm.nudgePayload);
            approveScheduleRedeem(response);
          }
        }, error = function () {

        };
        ModalService.stopScheduleRedeem({message: vm.redeemNudgeDetails.SCHEDULE_TRANSACTION_NUDGE.popUpDescription},success, error);
      }
    }

    /*
    * Function to fetch the schedule transaction details for view and cancel transaciton action
    */
    function getScheduleTransactionDetails() {
      LoaderService.showLoader();
      var success = function(response) {
        vm.scheduleTransactionDetails = response.data.summary;
        $stateParams.transactionAction === 'view' ? handleViewScheduleTransaction() : handleCancelScheduleTransactionAction();
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var payload = {
        transactionId: $stateParams.transactionId,
        transactionType: $stateParams.transactionType
      };
      TransactionService.post({
        controller1: 'schedule',
        controller2: 'transaction',
        controller3: 'summary'
      }, payload).$promise.then(success, error);
    }

    /*
    * Function to handle view schedule transaction action
    * responsible to enable schedule transaction summary view to perform view action.
    */
    function handleViewScheduleTransaction() {
      LoaderService.showLoader();
      vm.scheduleTransactionDetails['transactionAction'] = "VIEW";
      vm.scheduleTransactionDetails['state'] = vm.scheduleTransactionDetails.transactionType;
      vm.transactionType = "SCHEDULE_TRANSACTION_PURCHASE";
      moveToScheduleView();
    }

    /**
     * Function to handle cancel action for schedule transaction
     * responsible to enable schedule transaction summary view to perform cancel action.
    * */
    function handleCancelScheduleTransactionAction() {
      vm.transactionType = "SCHEDULE_TRANSACTION_PURCHASE";
      vm.scheduleTransactionDetails['transactionAction'] = "CANCEL";
      vm.scheduleTransactionDetails['state'] = vm.scheduleTransactionDetails.transactionType;
      moveToScheduleView();
    }

    /*
    * function to create purchase payload for view/cancel schedule transaction
    */
    function moveToScheduleView() {
      var payloadData = vm.scheduleTransactionDetails.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH ? createScheduleSwitchPayloadData() : createScheduleRedeemPayloadData();
      if (!payloadData) {
        return;
      }
      vm.summaryData = payloadData;
      vm.summaryData['scheduleDetails'] = vm.scheduleTransactionDetails;
      vm.formData.isSummaryViewEnabled = true;
      LoaderService.hideLoader();
    }

    function createScheduleSwitchPayloadData() {
      var payload = {
        folioNumber: vm.scheduleTransactionDetails.folioNumber,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH,
        id: $stateParams.isFavourite ? "" : $stateParams.transactionId,
        dividendOption: vm.scheduleTransactionDetails.dividendOption,
        outSchemeName: vm.scheduleTransactionDetails.defaultSourceSchemeName,
        inSchemeName: vm.scheduleTransactionDetails.targetSchemeName,
        brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : ''),
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        subBrokerARN: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
        subBrokerCode: vm.formData.subBrokerCode,
        checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
        autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.switchInSchemeCode : null,
        autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.autoSwitchSchemeDividendOption : null,
        units: vm.scheduleTransactionDetails.units,
        amount: vm.scheduleTransactionDetails.amount,
        mobileNumber: vm.scheduleTransactionDetails.mobileNumber,
        email: vm.scheduleTransactionDetails.emailID,
        investmentOption: vm.scheduleTransactionDetails.dividendOption === 'Y' ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH,
      };
      return angular.copy(payload);
    }

    function createScheduleRedeemPayloadData() {
      var bankInfo = {
        bankAcNo : vm.scheduleTransactionDetails.accountNumber,
        ifscCode : vm.scheduleTransactionDetails.ifsc,
        bankName : vm.scheduleTransactionDetails.bankName,
        payoutDescription : vm.scheduleTransactionDetails.payoutDesc
      };
      var payload = {
        folioNumber: vm.scheduleTransactionDetails.folioNumber,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION,
        schemeCode: vm.formData.outSchemeCode,
        bankInfo: bankInfo,
        payoutId: vm.scheduleTransactionDetails.payoutID,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        mobileNumber: vm.scheduleTransactionDetails.mobileNumber,
        email: vm.scheduleTransactionDetails.emailID,
        amount: vm.scheduleTransactionDetails.amount,
        units: vm.scheduleTransactionDetails.units,
        outSchemeName:  vm.scheduleTransactionDetails.defaultSourceSchemeName,
        amountType: !angular.isUndefined(vm.scheduleTransactionDetails.amount) ? 'amount' : !angular.isUndefined(vm.scheduleTransactionDetails.units) ? 'units' : 'all_units',
        investmentOption: vm.scheduleTransactionDetails.dividendOption === 'Y' ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH
      };
      return angular.copy(payload);
    }

    /*
    * Function responsible to set invest through check
    * */
    function manipulateInvestThrough(investThrough) {
      if (investThrough === AppConstants.INVEST_THROUGH.DIRECT) {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
      } else if (investThrough === AppConstants.INVEST_THROUGH.DISTRIBUTOR) {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
      } else if (investThrough === AppConstants.INVEST_THROUGH.RIA) {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
      }
    }

    /*
    * Function responsible to reset value set for RIA code
    * */
    function resetRIAValues() {
      vm.formData.brokerCode = '';
      vm.formData.brokerName = '';
      vm.formData.distributorName = '';
      vm.isCheckedTandC = false;
      vm.isArnSuccess = true;
    }

    /*
    * Function responsible to manage the broker code for purchase and sip payload
    * */
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.brokerCode ? vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = vm.isCheckedTandC ? true : false;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }

    function fetchNudgeDetails(cb) {
      LoaderService.showLoader();
      var success = function(response) {
        vm.redeemNudgeDetails = response.data.popUpDescriptionList;
        vm.formData.exitLoad = response.data.exitLoad;
        vm.formData.capitalGain = response.data.capitalGain;
        LoaderService.hideLoader();
        cb(true);
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var valPayload = {
        "folioNumber":vm.formData.folioNumber,
        "schemeCode":vm.formData.outSchemeCode,
        "transactionType": vm.transactionType,
        "redemptionAmount": vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT ? vm.formData.amount : 0,
        "redemptionUnits": vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS ? vm.formData.units :
          vm.formData.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS ? vm.formData.units : 0
      };
      TransactionService.post({
        controller1: 'nudge',
        controller2: 'popup'
      },valPayload).$promise.then(success, error);
    }

    function nudgeRequest(nudgePayload) {

      LoaderService.showLoader();
      var successCallback = function(resp) {

          if(resp.status && resp.data) {
            if(!nudgePayload.nudgePopup){
              fetchNudgeDetails();
              LoaderService.hideLoader();
            }
            LoaderService.hideLoader();
            vm.requestId = resp.data.requestId;
            vm.nudgeMessage = resp.data.message;
            if(nudgePayload.nudgeSuccess == true) {
              var success = function () {

              }, error = function () {
                $state.go('welcome')
              };
              ModalService.stayInvestedModal({message:vm.nudgeMessage}, success, error);
            } else {
              if(nudgePayload.popUpType === "REDEMPTION_NUDGE") {
                vm.moveToSummary();
              }
            }
          } else {
               MessageService.error("Something went wrong");
          }
        },
        errorCallback = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      TransactionService.post({
        controller1: 'nudge',
        controller2: 'request'
      }, nudgePayload).$promise.then(successCallback, errorCallback);
    }

    function approveScheduleRedeem(response) {
      vm.transactionType = getTransactionType();
      var transactionType = vm.transactionType;
      var success = function(result) {
          vm.transactionType = "SCHEDULE_TRANSACTION_" + transactionType.toUpperCase();
          vm.scheduleTransactionDetails = result;
          vm.scheduleTransactionDetails['transactionAction'] = "REVIEW";
          vm.scheduleTransactionDetails['state'] = transactionType.toUpperCase();
          vm.moveToSummary();
        },
        failure = function() {
          $log.info("modal has been cancelled");
        };
      ModalService.openScheduleTransactionModal({
        title: "Schedule Transaction",
        schemeType: vm.formData.inSchemeType,
        amountType: vm.formData.amountType,
        initiatedController: vm.formData.investmentType,
        nonBusinessDay: response.data,
        notesDynamic : vm.notesSchedule,
        termsConditionReviewSchedule : vm.TermsConditionSchedule,
        notesReviewSchedule : vm.noteReviewSchedule
      }, success, failure);
    }

    /*
    * setting up dynamic data variables
    */
    function setDynamicData() {
        if(vm.transactionType == 'REDEMPTION') {
          vm.notesSchedule = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Review_Redemption;
          vm.noteRedemption = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Review_Schedule_Redemption;
          vm.key = "TNC_Review_transaction_Redemption"
        } else if(vm.transactionType == 'SWITCH') {
           vm.popup = vm.DynamicDataReview.popupDTO.popupDTOMap.Popup_Review_Switch;
           vm.notesSchedule = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Review_Switch;
           vm.notesReview = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Review_Transaction_Switch;
           vm.noteReviewSchedule = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Review_Schedule_Switch;
           vm.notes = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Switch;
           vm.euinBoxMessage = vm.DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Switch_Through_Distributor;
           vm.riaMessage = vm.DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_Switch_Through_RIA;
           vm.key="TNC_Review_Transaction_Switch"
        } else if(vm.transactionType == 'STP') {
           vm.euinBoxMessage = vm.DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_STP_Through_Distributor;
           vm.riaMessage = vm.DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_STP_Through_RIA;
           vm.notesReview = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Review_STP;
           vm.key = 'TNC_Review_STP'
        } else if(vm.transactionType == 'FLEX_INDEX') {
           vm.euinBoxMessage = vm.DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_FLEXINDEX_Through_Distributor;
           vm.riaMessage = vm.DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_FLEXINDEX_Through_RIA;
           vm.key = "TNC_Review_FLEXINDEX"
        } else if(vm.transactionType == 'DTP') {
           vm.euinBoxMessage = vm.DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap.TNC_TIP_Through_Distributor;
           vm.notesReview = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Review_TIP;
           vm.key = "TNC_Review_TIP"
        } else if(vm.transactionType == 'INSTANT_REDEMPTION') {
           vm.notes = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_IAF;
        }

    }



    vm.isSelectedEuin = true;

    vm.filterEuinList = function () {
      vm.formData.euin = {};
      vm.isSelectedEuin = false ;
      if(vm.euinData.euinNameCode){
        if(vm.euinData.euinNameCode.length>=3){
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.euinData.euinNameCode);
        }
      }
      vm.euinList = vm.euinData.euinNameCode == '' || vm.euinData.euinNameCode == undefined || vm.euinData.euinNameCode.length<3 ? vm.euinMasterList : vm.euinList;
    }

    vm.selectEuin = function(data) {
      if (!data) {
        return;
      }
      vm.isCheckedTandC = false;
      vm.euinData = {};
      vm.euinData.euinNameCode = data.euinNameCode;
      vm.isSelectedEuin = vm.euinData.euinNameCode ? true : false;
    }

    /**
     * Function responsible for checking blocked transaction flag for blocking transaction
     */

    function checkIsTxnBlock(cb) {
      cb = cb || function () {};
      var successHandler = function(resp){
        if(resp){
          vm.folioListToBlockTxnsaction = resp.folioList ? resp.folioList :null;
          vm.popUpMessage = resp.popUpMessage ? resp.popUpMessage : null;
          vm.blockFolioForTransaction = resp.blockFolioForTransaction ? resp.blockFolioForTransaction : false;
          cb();
        }else{
          MessageService.error();
          cb();
        }
      };
      UtilService.checkTxnBlock().then(successHandler).catch(function(resp) {
        MessageService.error(resp)
      });
    }

    function calculateSTPMinAmountAndMultples(frequency,freqInstallmentNumber) {

      var stopLoop = false;

      if (vm.formData.noOfInstallments && freqInstallmentNumber && (vm.formData.noOfInstallments >= freqInstallmentNumber)) {
        vm.inSchemeValidations.additionalValidation[frequency].forEach(function (el) {

          if (stopLoop) {
            return;
          }

          if (el.min_installments && el.max_installments) {
            if (vm.formData.noOfInstallments >= el.min_installments && vm.formData.noOfInstallments <= el.max_installments) {
              vm.validations.minAmount = el.min_amount_lower;
              vm.validations.amountMultiples = el.amt_multiples;
              stopLoop = true;
            }
          } else {
            vm.validations.minAmount = el.min_amount_lower;
            vm.validations.amountMultiples = el.amt_multiples;
            stopLoop = true;
          }

        })
      }
    }

    function getRandomOTPID() {
      var successRandomOTPIdHandler = function(resp) {
        vm.randomOTPId = resp.randomOTPId ? resp.randomOTPId : null;
      }, errorRandomOTPIdHandler = function (){}
      UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TrackerController', trackerController);

  function trackerController($http, $q, $state, $stateParams, InvestorService, AppConstants, LoaderService, HDFC_API, UtilService, MessageService) {
    var vm = this;
    vm.date = new Date();
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.fetchSessionID = fetchSessionID;
    vm.verifyPan = verifyPan;
    /*vm.authorize = authorize;*/
    sessionStorage.trackerSource = $stateParams.source;
    vm.init = function () {
      fetchSessionID();
    }

    function fetchSessionID() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp && resp.data) {
            vm.trackerId = resp.data;
            sessionStorage.trackerId = vm.trackerId;
          }
          else {
            MessageService.error(resp.message);
          }
        },

        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        }

      LoaderService.showLoader();
      InvestorService.get({
        child1: 'utm',
        child2: 'generateSessionId',
        child3: $stateParams.source
      }, {}).$promise.then(success, error);
    }

    function verifyPan() {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/registration/searchPan',

        success = function (resp) {
          LoaderService.hideLoader();
          if (resp && resp.data.data) {
            if(resp.data.data.panVerifiedFlag){
              var data = {
                trackerId : vm.trackerId,
                source : $stateParams.source
              }
              $state.go('login',data)
            }else{
              sessionStorage.panNumber = vm.panNumber;
              $state.go('registration.main',{from:"tracker"});
            }
          }

          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        }


      var header = {
        'Content-Type': 'application/json',
        "sessionId": vm.trackerId,
        "source": $stateParams.source
      }


      LoaderService.showLoader();

      $http({
        method: 'POST',
        url: _path,
        headers: header,
        data: {
          "panNumber": vm.panNumber
        }
      }).then(success, error);
      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TermNConditionController', termNConditionController);

  function termNConditionController(ModalService, HDFC_API, UtilService, MessageService) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.dynamicTerms = null;
    vm.dynamicDataTncGeneral = {};

    function init() {
      var successHandler = function (resp) {
        vm.dynamicTerms = resp;
        if (vm.dynamicTerms.termAndConditionDTO.termAndConditionDTOMap.MOBILE_TNC_General) {
          vm.dynamicDataTncGeneral = vm.dynamicTerms.termAndConditionDTO.termAndConditionDTOMap.MOBILE_TNC_General.content;
        }
      }
      UtilService.fetchDynamicData("MOBILE_LOGIN_TNC").then(successHandler).catch(function (resp) {
        MessageService.error(resp);
      });
    }
    init();
  }
})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('SystematicController', SystematicController);

    /** @ngInject */
    function SystematicController($state, $timeout, MessageService, InvestorService, ModalService, AppConstants, LoaderService,$window, UtilService, investorServiceVersion, AuthService, TransactionService, panAadharService, TransactionModel ) {
      var vm = this;
      vm.profile = AuthService.getToken();
      AuthService.checkLinkedUserStatus();
      vm.isPagination = false;
      vm.pageLimitTransactionList = "25";
      vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
      vm.searchText = "";
      vm.isSearching = false;
      vm.transactionTypeListDropdown = AppConstants.SYSTEMATIC_TRANSACTION_TYPES;
      vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
      vm.statusTypeListDropdown = AppConstants.SYSTEMATIC_STATUS_TYPES;
      vm.SYSTEMATIC_CANCEL_FLEX = angular.copy(AppConstants.SYSTEMATIC_CANCEL_FLEX);
      vm.SYSTEMATIC_CANCEL_SWINGSTP = angular.copy(AppConstants.SYSTEMATIC_CANCEL_SWINGSTP);
      vm.selectedTransactionType = vm.transactionTypeListDropdown[0].value;
      vm.selectedStatusType = vm.statusTypeListDropdown[0].value;
      vm.getSystematicList = getSystematicList;
      vm.cancelTransaction = cancelTransaction;
      vm.confirmCancelTransaction = confirmCancelTransaction;
      vm.confirmPauseTransaction = confirmPauseTransaction;
      vm.confirmCancelSmartSwapTransaction = confirmCancelSmartSwapTransaction;
      vm.sanitizedType = sanitizedType;
      vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
      vm.currentPageSystematicList = 1;
      vm.nextFlag = false;
      vm.selectedPageLimit = vm.PAGE_LIMITS[0];
      var systematicPayload = {
        "type" : "ALL",
        "status" : "ALL",
        'pageIndex': vm.currentPageSystematicList,
        'pageLimit': vm.selectedPageLimit
      };
      vm.startDate = null;
      vm.startMinDateBiller = null;
      vm.startMaxDate = null;
      var defaultEndDate = null;
      vm.noOfInstallment = null;
      vm.noInstallment = false;
      vm.isSipPauseStartDate = false;
      vm.kycMessageShowed = false;
      vm.redeemNudgeDetails = {};
      vm.requestId = '';
      vm.Dynamicdata = {};
      vm.noteSipCancellation = {};
      vm.noteSipPause = {};
      vm.isModifySipEnabled = true;
      vm.formData = TransactionModel.getMasterRawData('SIP');
      vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);

      vm.init = function() {

        switch($state.current.name){
          case 'main.systematicCorner':
            vm.amountLabel = "Select Amount";
            getSystematicList(systematicPayload);
            if(localStorage.getItem('transactionData')){
              localStorage.removeItem('transactionData');
            }
            if(localStorage.getItem('summaryReview')){
              localStorage.removeItem('summaryReview');
            }
            if(localStorage.getItem('summaryDetails')){
              localStorage.removeItem('summaryDetails');
            }
                break;
          case 'main.sipCancellation':
            vm.summary = $window.JSON.parse(localStorage.getItem('summaryReview'));
            if (vm.summary.type === 'DREAMSIP') {
              vm.summary.type = "DREAM SIP";
            }
            break;
          case 'main.sipCancellationDetails':
            vm.review = $window.JSON.parse(localStorage.getItem('summaryDetails'));
            break;
          case 'main.smartSwap-cancel-summary':
            vm.review = $window.JSON.parse(sessionStorage.getItem('summaryDetails'));
            vm.smartSwapReview.type =vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP;
            break;
          case 'main.sip-pause'  :
            vm.pause = $window.JSON.parse(localStorage.getItem('pauseSipReview'))
            vm.changeStartDate();
            vm.noOfInstallmentList =[];
            for(var i = 0; i < vm.pause.maxInstallmentsPauseSip; i++){vm.noOfInstallmentList.push(i+1)}
            vm.isSipPauseStartDate = false;
            break;
          case 'main.pause-summary'  :
            vm.pause = $window.JSON.parse(localStorage.getItem('pauseSipReview'))
            break;
          case 'main.smartSwap-cancel'  :
            vm.data = $window.JSON.parse(sessionStorage.getItem('smartSwapReview'));
            break;
        }
        fetchNudgeDetails();
        var successHandler = function(resp) {
           vm.Dynamicdata = resp;
           if (vm.Dynamicdata.noteDTO.noteDTOMap.Note_SIP_Cancel_Topup) {
             vm.noteSipCancellation = vm.Dynamicdata.noteDTO.noteDTOMap.Note_SIP_Cancel_Topup;
           }
           if (vm.Dynamicdata.noteDTO.noteDTOMap.Note_SIP_Pause_Topup) {
             vm.noteSipPause = vm.Dynamicdata.noteDTO.noteDTOMap.Note_SIP_Pause_Topup;
           }
        }
        UtilService.fetchDynamicData("SIP_TOPUP").then(successHandler).catch(function(resp) {
          MessageService.error(resp)
        });
      };

      vm.changeStartDate = function (date) {
        vm.endDate = date;
        updateEndDates();
      };

      vm.changeInstallment = function () {
        if(localStorage.getItem("selDate")){
          vm.changeStartDate(localStorage.getItem("selDate"))
        }
        if(!(vm.SipPauseEndDate && vm.SipPauseEndDate.isValid()))
            vm.isSipPauseStartDate = false;
      }

      function updateEndDates() {
        defaultEndDate = $window.moment(localStorage.getItem("date"), "DD-MMM-YYYY");
        var endDate = null;
        var enabledEndDates = [];
        var freq = 0;
        var i = 0;
        endDate = $window.moment(localStorage.getItem("mindate"), "DD-MMM-YYYY");
        freq = UtilService.getNumberOfMonths(endDate, defaultEndDate);
        if(vm.pause.summary.frequency.toLowerCase() == 'monthly'){
          for (i = 0; i <= freq; i++) {
          enabledEndDates.push(endDate.clone().add(i, 'months'));
          }}
        else {
          for (i = 0; i <= freq; i+=3) {
            enabledEndDates.push(endDate.clone().add(i, 'months'));
          }}
        vm.enabledEndDates = enabledEndDates;
        vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
        vm.maxEndDate = defaultEndDate;
        updateInstallment();
        vm.isSipPauseStartDate = true;
      }

      function updateInstallment() {
        localStorage.setItem("selDate",vm.endDate);
        var selectedDate=localStorage.getItem("selDate");
        switch (vm.noOfInstallment) {
          case "1":
            vm.SipPauseEndDate=$window.moment(selectedDate).add(1,'months');
            vm.noInstallment = false;
            break;
          case "2":
            vm.SipPauseEndDate=$window.moment(selectedDate).add(2,'months');
            vm.noInstallment = false;
            break;
          case "3":
            vm.SipPauseEndDate=$window.moment(selectedDate).add(3,'months');
            vm.noInstallment = false;
            break;
          default : vm.noInstallment = true;break;
        }
        if(!vm.noInstallment)
          vm.SipPauseEndDate=$window.moment(vm.SipPauseEndDate).subtract(1,'days');
        if(vm.pause.summary.frequency.toLowerCase() != 'monthly'){
          vm.SipPauseEndDate=$window.moment(selectedDate).add(3,'months');
          vm.SipPauseEndDate=$window.moment(vm.SipPauseEndDate).subtract(1,'days');
          vm.noInstallment = false;
        }
      }


      function cancelTransaction(id,type) {
        var successAPI = function (resp) {
            LoaderService.hideLoader('.loader');
            if (resp.data && resp.status) {
              vm.summaryReview = resp.data.summary;
              vm.summaryReview.requestId = vm.requestId;
              if (vm.summaryReview.subTrxnType && vm.summaryReview.subTrxnType === 'FS') {
                vm.summaryReview.type = 'Flex SIP';
                vm.summaryReview.tenureDiff = moment(vm.summaryReview.toDate,"DD-MMM-YYYY").diff(moment(vm.summaryReview.fromDate,"DD-MMM-YYYY"), 'years') + 1;
              }
              localStorage.setItem('summaryReview', $window.JSON.stringify(vm.summaryReview));
              $state.go('main.sipCancellation');
            }
            else {
              vm.summaryReview = null;
              MessageService.error(resp.message);
            }
          },
          errorAPI = function (err) {
            vm.summaryReview = null;
            LoaderService.hideLoader('.loader');
            MessageService.error(err.message);
            $state.go('main.systematicCorner');
          };
        LoaderService.showLoader('.loader');
        InvestorService.post({
          child1: 'transaction',
          child2: 'cancel',
          child3: 'summary'
        }, {"transactionId":id, "transactionType":type}).$promise.then(successAPI, errorAPI);
      }

      function confirmCancelTransaction() {
        var transactionDetails = $window.JSON.parse(localStorage.getItem('transactionData'));
        if(transactionDetails){
          var transactionId = transactionDetails.transactionId;
          if((transactionDetails.transactionType !== 'FLEXSTP' )){
            var transactionType = transactionDetails.transactionType
          }
          else{
            var transactionType = vm.SYSTEMATIC_CANCEL_FLEX.FLEXSTP;
            vm.nextFlag = true;
          }

          if((transactionDetails.transactionType !== 'SWINGSTP') && vm.nextFlag === false){
            var transactionType = transactionDetails.transactionType
          }
          else{
            if(vm.nextFlag === false) {
              var transactionType = vm.SYSTEMATIC_CANCEL_SWINGSTP.SWINGSTP;
            }
          }


        }
        vm.data = $window.JSON.parse(sessionStorage.getItem('smartSwapReview'));
        if (vm.data && 'SMARTSWAP' == vm.data.summary.type.replace(/\s/g, '')) {
          transactionId = vm.data.id;
          transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP;
        }
          var payload = {
        "transactionId": transactionId,
          "transactionType":transactionType
        };
        if(transactionType === 'SIP' || transactionType === 'DREAMSIP' || transactionType === 'FLEXSIP') {
        /*  var _config: {
            child1: 'transaction',
            child2: 'cancel'
          };*/
          payload.requestId = vm.summary.requestId;
          var tncType = '';

          switch (transactionType) {
            case "SIP":
              tncType = 'SIP'
              break;
            case "DREAMSIP":
              tncType = 'DREAM SIP'
              break;
            case "FLEXSIP":
              tncType = 'Flex SIP'
              break;
          }

          var Text = 'Please let us know the reason for Cancelling ' + tncType + ' :';

          ModalService.showNudgeReasons({Text:Text, payload:payload,transactionType:transactionType,buttonProceed:true});
        } else {

          var successAPI = function (resp) {
              LoaderService.hideLoader('.loader');
              if (resp.data && resp.status) {
                vm.summaryDetails = resp.data.review;
                sessionStorage.setItem('summaryDetails', $window.JSON.stringify(vm.summaryDetails));
              if(transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP)
                $state.go('main.smartSwap-cancel-summary')
              else
                $state.go('main.sipCancellationDetails');
            }
            else {
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                });
              } else {
                MessageService.error(resp.message);
              }
                // $state.go('main.systematicCorner');
              }
            },
            errorAPI = function (err) {
              LoaderService.hideLoader('.loader');
              MessageService.error(err.message);
              $state.go('main.systematicCorner');
            };
          LoaderService.showLoader('.loader');
          InvestorService.post({
            child1: 'transaction',
            child2: 'cancel'
          }, payload).$promise.then(successAPI, errorAPI);
        }
      }

      function confirmPauseTransaction() {
        var frequency;
        if(vm.pause.summary.frequency.toLowerCase()=='monthly')
          frequency='OM';
        else {frequency='Q',vm.noOfInstallment="1"}
        var payload = {
          "folioNumber":vm.pause.summary.folioNumber,
          "frequency":frequency,
          "pauseToDate":$window.moment(vm.SipPauseEndDate).format("DD-MMM-YYYY"),
          "pauseFromDate":$window.moment(localStorage.getItem("selDate")).format("DD-MMM-YYYY"),
          "amount":vm.pause.summary.amount,
          "schemeCode":vm.pause.schemeCode,
          "arnCode": 'DIRECT',
          "atrxnNo": vm.pause.aTrxnNo,
          "installmentsPaused" : vm.noOfInstallment
        };
        var successAPI = function (resp) {
            LoaderService.hideLoader('.loader');
            if (resp.data && resp.status) {
              vm.pause = $window.JSON.parse(localStorage.getItem('pauseSipReview'));
              vm.pause.sipPausetoDate =  $window.moment(localStorage.getItem("selDate")).format("DD-MMM-YYYY");
              vm.pause.sipPauseFromDate =  $window.moment(vm.SipPauseEndDate).format("DD-MMM-YYYY");
              vm.pause.noOfInstallment=vm.noOfInstallment;
              localStorage.setItem('pauseSipReview', $window.JSON.stringify(vm.pause));
              $state.go('main.pause-summary');
            }
            else {
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                });
              } else {
                MessageService.error(resp.message);
              }
            }
          },
          errorAPI = function (err) {
            LoaderService.hideLoader('.loader');
            MessageService.error(err.message);
            $state.go('main.systematicCorner');
          };
        LoaderService.showLoader('.loader');
        InvestorService.post({
          child1: 'pauseSip'
        }, payload).$promise.then(successAPI, errorAPI);
      }

      function confirmCancelSmartSwapTransaction() {
        var payload = {
          "transactionId": vm.data.id,
          "transactionType": vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP
        };
        var successAPI = function (resp) {
            LoaderService.hideLoader('.loader');
            if (resp.data && resp.status) {
              vm.data = resp.data;
              $state.go('main.smartSwap-cancel-summary');
            } else {
              MessageService.error(resp.message);
            }
          },
          errorAPI = function (err) {
            LoaderService.hideLoader('.loader');
            MessageService.error(err.message);
            $state.go('main.systematicCorner');
          };
        LoaderService.showLoader('.loader');
        InvestorService.post({
          child1: 'transaction',
          child2: 'cancel',
          child3: 'summary'
        }, payload).$promise.then(successAPI, errorAPI);
      }


      vm.typeChangeDropdown = function(type) {
        systematicPayload.type = type;
      };

      vm.statusChangeDropdown = function(status) {
        systematicPayload.status = status;
      };

      vm.applyFilter = function() {
        vm.currentPageSystematicList = 1;
        getSystematicList(systematicPayload);
      };
      vm.resetFilter = function() {
        vm.selectedTransactionType = vm.transactionTypeListDropdown[0].value;
        vm.selectedStatusType = vm.statusTypeListDropdown[0].value;
        vm.searchText = '';
        resetPayload();
        getSystematicList(systematicPayload);
      };

      function resetPayload() {
        systematicPayload = {
          "type" : vm.selectedTransactionType,
          "status" : vm.selectedTransactionType,
          'pageIndex': vm.currentPageSystematicList,
          'pageLimit': vm.selectedPageLimit
        };
      }

      vm.pageLimitListChange = function(limit) {
        systematicPayload.pageLimit = limit;
        vm.currentPageSystematicList = 1;
        systematicPayload.pageIndex = vm.currentPageSystematicList - 1;
        getSystematicList(systematicPayload);
        $window.document.getElementById('typeSelect').focus();
      };

      vm.initSystematicList = function() {
        // payload.pageIndex = vm.currentPageSystematicList - 1;
        getSystematicList(systematicPayload);
        $window.document.getElementById('typeSelect').focus();
      };

      function getSystematicList(systematicPayload) {
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              vm.systematicList = resp.data.schemeOverviewDTOs;
              vm.totalSystematicListData = resp.data.count;
              vm.isPagination = !!(vm.systematicList && vm.systematicList.length);
              if (!vm.kycMessageShowed && !resp.data.kycVerifiedFlag) {
                ModalService.genericModal({
                  text: resp.data.kycMessage
                }, function() {
                  vm.kycMessageShowed = true;
                });
              }
            }
            else {
              vm.systematicList = null;
              vm.isPagination = false;
              MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader();
            vm.isPagination = false;
          };
        LoaderService.showLoader();
        systematicPayload.pageIndex = vm.currentPageSystematicList - 1;
        systematicPayload.pageLimit = vm.selectedPageLimit;
        investorServiceVersion.post({
          child1: 'portfolio',
          child2: 'systematic-corner'
        }, systematicPayload).$promise.then(success, error);
      }

      vm.selectTransaction = function (action, overview) {
        if(action == 'Change Option'){
          var success = function () {
          //  alert("done");
          vm.applyFilter();
          },
          error = function () {
          };
        ModalService.dreamSipChangeOptionModal(overview, success, error);
        }
        if(action == 'Change Target Scheme'){
          var success1 = function () {
            // alert("done");
            vm.applyFilter();
           },
           error1 = function () {
           };
         ModalService.changeTargetSchemeModal(overview, success1, error1);
        }
        var params =  { folioNumber:overview.folioNumber, sc : overview.schemeCode};
        if(action.toLocaleLowerCase() === 'pause' || action.toLocaleLowerCase() === 'smart swap'){
          params['transactionType'] = overview.type;
          params['transactionId']=overview.id;}
        if (action.toLocaleLowerCase() === 'renew') {
          params['allowBroker'] = overview.allowBoker;
          params['action'] = 'renew';
          params['amount']= overview.amount;
          params['frequency']= overview.sipFrequency;
        }
        if (action.toLocaleLowerCase() === 'modify') {
          params['allowBroker'] = overview.allowBoker;
          params['action'] = 'modify';
        }
        if(action.toLocaleLowerCase() === 'cancel' && overview.type == 'SMART_SWAP'){
          params['transactionType'] = overview.type;
          params['transactionId']=overview.id;
        }
        switch (action.toLocaleLowerCase()) {
          case 'stp':
            $state.go('main.transactions.stp', params );
            break;
          case 'swp':
            $state.go('main.transactions.swp',params);
            break;
          case 'redeem':
            $state.go('main.transactions.redemption',params);
            break;
          case 'switch':
            $state.go('main.transactions.switch',params);
            break;
          case 'sip':
            $state.go('main.transactions.sip',params);
            break;
          case 'purchase':
            $state.go('main.transactions.sip',params);
            break;
          case 'top-up':
            var successHandler=function(resp) {
              LoaderService.hideLoader();
              redirectToSipTopup(action, overview);
            };
            var errorHandler=function(resp)
            {
              LoaderService.hideLoader();
              return;
            };
            LoaderService.showLoader();
            panAadharService.fetchPanAadharLinkingStatus(null,overview.folioNumber).then(successHandler).catch(errorHandler);
            break;
          case 'renew':
            var successHandlerRenew=function(resp) {
              LoaderService.hideLoader();

              /*localStorage.setItem('allowBroker',overview.allowBoker);
              localStorage.setItem('Action','renew');*/
              TransactionModel.setPayloadRawData(null);
              $state.go('main.transactions.' + (overview.type).toLowerCase(), params);
            };
            var errorHandlerRenew=function(resp)
            {
              LoaderService.hideLoader();
              return;
            };
            LoaderService.showLoader();
            panAadharService.fetchPanAadharLinkingStatus(null,overview.folioNumber).then(successHandlerRenew).catch(errorHandlerRenew);

            break;
          case 'pause' :
            redirectToPauseSip(params);
            break;
          case 'cancel': {
            if(overview.type == 'SMART_SWAP'){
              redirectToSmartSwapCancel(params)
            } else if(overview.type === 'SIP' || overview.type === 'DREAMSIP' || overview.type === 'FLEXSIP' || overview.type === 'SIP_TOP_UP') {
              if(overview.actions.length > 1 && (overview.actions.includes('Pause'))) {
                var success = function (resp) {
                  if (resp === 'pause') {
                    params['transactionType'] = overview.type;
                    params['transactionId']=overview.id;
                    redirectToPauseSip(params);
                  } else if(resp === 'modify'){
                    var successHandlerModify = function (resp) {
                      LoaderService.hideLoader();
                      var success = function (resp) {
                        redirectToModifySip();
                      }, error = function (err) {}
                      ModalService.genericModal({
                        text: vm.redeemNudgeDetails.SIP_MODIFY_MESSAGE_NUDGE.popUpDescription, modifySipAction: true
                      }, success, error);
                    }
                    var errorHandlerModify = function(resp) {
                      LoaderService.hideLoader();
                      return;
                    };
                    LoaderService.showLoader();
                    panAadharService.fetchPanAadharLinkingStatus(null,overview.folioNumber).then(successHandlerModify).catch(errorHandlerModify);
                  } else {
                    successReason(resp);
                  }
                }
                if (overview.type === 'DREAMSIP') {
                  ModalService.confirmPauseModal({
                    heardAbout: vm.redeemNudgeDetails.DREAM_SIP_PAUSE_CANCELLATION_NUDGE.popUpDescription,
                    pauseSipText: vm.redeemNudgeDetails.DREAM_SIP_PAUSE_NUDGE.popUpDescription,
                    ButtonProceed: true,
                    investorName: vm.profile.investorFullName,
                    folioNumber: params.folioNumber,
                    transactionType: overview.type,
                    ButtonPause : true
                  }, function (resp) {
                    if (resp === 'pause') {
                      params['transactionType'] = overview.type;
                      params['transactionId']=overview.id;
                      redirectToPauseSip(params);
                    } else {
                      successReason(resp);
                    }
                  }, function () {
                  });
                } else {
                  ModalService.confirmPauseModal({heardAbout: vm.redeemNudgeDetails.SIP_MODIFY_PAUSE_CANCELLATION_NUDGE.popUpDescription,modifySipText: vm.redeemNudgeDetails.SIP_MODIFY_NUDGE.popUpDescription, pauseSipText: vm.redeemNudgeDetails.SIP_PAUSE_NUDGE.popUpDescription, ButtonProceed: true, investorName: vm.profile.investorFullName, folioNumber: params.folioNumber, isModifySipEnabled: vm.isModifySipEnabled}, success, function () {});
                }
              } else {
                if (overview.type === 'SIP' || overview.type === 'SIP_TOP_UP') {
                  ModalService.confirmCancelModal({heardAbout: vm.redeemNudgeDetails.SIP_MODIFY_PAUSE_CANCELLATION_NUDGE.popUpDescription.replace('or Pause',''), modifySipText: vm.redeemNudgeDetails.SIP_MODIFY_NUDGE.popUpDescription, ButtonProceed: true, investorName: vm.profile.investorFullName, folioNumber:params.folioNumber, isModifySipEnabled: vm.isModifySipEnabled}, successReason, function () {
                  });
                } else if (overview.type === 'DREAMSIP') {
                  ModalService.confirmCancelModal({
                    Text: vm.redeemNudgeDetails.DREAM_SIP_CANCELLATION_NUDGE.popUpDescription,
                    ButtonProceed: true,
                    investorName: vm.profile.investorFullName,
                    folioNumber: params.folioNumber,
                    transactionType: overview.type
                  }, successReason, function () {
                  });
                } else if (overview.type === 'FLEXSIP') {
                  ModalService.confirmCancelModal({
                    Text: vm.redeemNudgeDetails.FLEX_SIP_CANCELLATION_NUDGE.popUpDescription,
                    ButtonProceed: true,
                    investorName: vm.profile.investorFullName,
                    folioNumber: params.folioNumber,
                    transactionType: overview.type
                  }, successReason, function () {
                  });
                }
              }
            } else {
              successReason();
            }
          }
          break;
          case 'modify':
            var successHandlerModify = function (resp) {
              LoaderService.hideLoader();
              var success = function (resp) {
                  redirectToModifySip();
                },
                error = function (err) {
                }
              ModalService.genericModal({
                text: vm.redeemNudgeDetails.SIP_MODIFY_MESSAGE_NUDGE.popUpDescription, modifySipAction: true
              }, success, error);
            }
            var errorHandlerModify=function(resp)
            {
              LoaderService.hideLoader();
              return;
            };
            LoaderService.showLoader();
            panAadharService.fetchPanAadharLinkingStatus(null,overview.folioNumber).then(successHandlerModify).catch(errorHandlerModify);
            break;
        }

        function successReason(resp) {
          if(resp === 'modify'){
            var success = function (resp) {
                redirectToModifySip();
              },
              error = function (err){
              }
            ModalService.genericModal({
              text: vm.redeemNudgeDetails.SIP_MODIFY_MESSAGE_NUDGE.popUpDescription, modifySipAction: true
            },success,error);
          } else {
            var transactionData = {
              transactionId: overview.id,
              transactionType: overview.type == 'SIP_TOP_UP' ? 'SIP' :overview.type
          };
          vm.requestId = resp;
          if((transactionData.transactionType !== 'FLEXSTP')) {
              vm.transtype = transactionData.transactionType
            } else {
              vm.transtype = vm.SYSTEMATIC_CANCEL_FLEX.FLEXSTP;
              vm.nextFlag = true;
            }

            if ((transactionData.transactionType !== 'SWINGSTP') && vm.nextFlag === false) {
              vm.transtype = transactionData.transactionType
            } else {
              if (vm.nextFlag === false) {
                vm.transtype = vm.SYSTEMATIC_CANCEL_SWINGSTP.SWINGSTP;
              }
            }

            if (transactionData.transactionType === 'DREAMSIP') {
              vm.transtype = transactionData.transactionType
            }

            localStorage.setItem('transactionData', $window.JSON.stringify(transactionData));
            cancelTransaction(transactionData.transactionId, vm.transtype);
          }
        }

        function redirectToPauseSip() {
          var successAPI = function (resp) {
              LoaderService.hideLoader('.loader');
              if (resp.data && resp.status) {
                vm.pauseSipReview = resp.data;
                vm.pauseSipReview.startMinDateBiller = vm.pauseSipReview.nextInstallmentDate;
                vm.pauseSipReview.startMaxDate =  vm.pauseSipReview.lastInstallmentDate;
                vm.pauseSipReview.sipPausetoDate =  $window.moment(localStorage.getItem("selDate")).format("DD-MMM-YYYY");
                vm.pauseSipReview.sipPauseFromDate =  $window.moment(vm.SipPauseEndDate).format("DD-MMM-YYYY");
                localStorage.setItem('pauseSipReview', $window.JSON.stringify(vm.pauseSipReview));
                vm.startMinDateBiller = vm.pauseSipReview.nextInstallmentDate;
                vm.startMaxDate =  vm.pauseSipReview.lastInstallmentDate;
                localStorage.setItem("date", vm.startMaxDate);
                localStorage.setItem("mindate", vm.startMinDateBiller);
                $state.go('main.sip-pause');
              }
              else {
                vm.pauseSipReview = null;
                MessageService.error(resp.message);
              }
            },
            errorAPI = function (err) {
              vm.pauseSipReview = null;
              LoaderService.hideLoader('.loader');
              MessageService.error(err.message);
              $state.go('main.systematicCorner');
            };
          LoaderService.showLoader('.loader');
          var transactionType = sanitizedType(params.transactionType);
          InvestorService.post({
            child1: 'transaction',
            child2: 'pause',
            child3: 'summary'
          }, {"transactionId":params.transactionId, "transactionType":transactionType}).$promise.then(successAPI, errorAPI);
        }


        function redirectToSmartSwapCancel() {
          var successAPI = function (resp) {
              LoaderService.hideLoader('.loader');
              if (resp.data && resp.status) {
                vm.data = resp.data;
                vm.data.id = params.transactionId;
                sessionStorage.setItem('smartSwapReview', $window.JSON.stringify(vm.data));
                $state.go('main.smartSwap-cancel');
              } else {
                vm.smartSwapReview = null;
                MessageService.error(resp.message);
              }
            },
            errorAPI = function (err) {
              vm.smartSwapReview = null;
              LoaderService.hideLoader('.loader');
              MessageService.error(err.message);
              $state.go('main.systematicCorner');
            };
          LoaderService.showLoader('.loader');
          InvestorService.post({
            child1: 'transaction',
            child2: 'cancel',
            child3: 'summary'
          }, {
            "transactionId": params.transactionId,
            "transactionType": params.transactionType
          }).$promise.then(successAPI, errorAPI);
        }

        function redirectToModifySip(){
          var params2 =  { };
          params2['allowBroker'] = overview.allowBoker;
          params2['action'] = 'modify';
          vm.formData.modifyAction = 'modifySip';
          vm.formData.isAllowBroker = overview.allowBoker;
          vm.formData.transactionId = overview.id;
          vm.formData.folioNumber = overview.folioNumber;
          vm.formData.inSchemeCode = overview.schemeCode;
          vm.formData.inSchemeName = overview.sourceScheme;
          vm.formData.amount = overview.amount;
          vm.formData.startDate = overview.startDate;
          vm.formData.endDate = overview.endDate;
          vm.formData.frequency = overview.sipFrequency;
          if(overview.paymentOption && overview.paymentOption.length > 0) {
            vm.formData.sipPaymentOption = overview.paymentOption[0].code == 'HEM' ?'E-mandate':overview.paymentOption[0].code;
          }
          vm.formData.dividendOption = overview.dividendOption;
          if(overview.brokerCode) {
            vm.formData.brokerCode = overview.brokerCode && overview.brokerCode.replace('ARN-','');
            vm.formData.distributorName = null;
          } else if(overview.distributorName) {
            vm.formData.distributorName = overview.distributorName + ' - ' + overview.brokerCode;
          }
          vm.formData.subBrokerARN = overview.subBrokerArn && overview.subBrokerArn.replace('ARN-','');
          vm.formData.subBrokerCode = overview.subBrokerCode;
          if(overview.euinOpted == 'Y'){
            vm.formData.isEuin = true;
            vm.formData.euinCode = overview.euinCode;
            vm.formData.euinName = overview.euinName;
            vm.formData.euinNameCode = vm.formData.euinCode && vm.formData.euinName ? overview.euinName + '-' + overview.euinCode : '';
          } else if(overview.euinOpted == 'N') {
            vm.formData.isEuin = false;
          }
          vm.formData.riaBrokerCode = overview.riaCode
          vm.formData.isThroughRia = overview.throughRia;
          vm.formData.riaBrokerName = overview.riaName;
          vm.formData.isThroughDistributor = overview.throughDistributor;
          vm.formData.isDirect = overview.direct;
          vm.formData.bankInfo = overview.folioBankDetails;
          vm.formData.sipTopupEnabled = overview.sipTopupEnabled;
          if(overview.topupDetails) {
            vm.formData.topupDetails = overview.topupDetails;
          }
          if(overview.topupDetails && overview.topupDetails.capAmount) {
            overview.topupDetails.capAmount = null;
          }
          vm.formData.investmentOption = overview.investmentOption && (overview.investmentOption == 'Growth' ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
          vm.formData.sipFirstInstallment = overview.sipWithFirstInstallment;
          vm.formData.firstInstallmentDetails = overview.firstInstallmentDetails;
          overview.type = overview.type === 'SIP_TOP_UP' ? 'SIP' : overview.type;
          TransactionModel.setPayloadRawData(vm.formData);
          sessionStorage.setItem('systematicData',$window.JSON.stringify(vm.formData));
          $state.go('main.transactions.'+(overview.type).toLowerCase(),params2);
        }


       function redirectToSipTopup(action,data) {
        localStorage.setItem('transactionDataSipTopup', $window.JSON.stringify(data));
        $state.go('main.transactions.sip-topup');
      }};

      vm.confirmCancelSipModal = function (id, type) {
        var success = function (status) {
            if(status=="success"){
              vm.successCancelSipModal();
            }
          },
          error = function () {

          };
        ModalService.cancelSipModal({id:id, type:type}, success, error);
      };

      vm.successCancelSipModal = function () {
        var success = function () {

          },
          error = function () {

          };
        ModalService.cancelSipSuccessModal({}, success, error);
      };

      vm.localSearch = function(){
        if (vm.isSearching) {
          return;
        }
        else if (vm.searchText.length > 3 || vm.searchText == '') {
          vm.currentPageTransactionList = 1;
          vm.isSearching = true;
          systematicPayload.searchText = vm.searchText;
          getSystematicList(systematicPayload);
          $timeout(function () {
            vm.isSearching = false;
          }, 300);

        }

      };
      vm.changeEndDate = function(){};

      function fetchNudgeDetails() {
        var success = function(response) {
          vm.redeemNudgeDetails = response.data.popUpDescriptionList;
        }, error = function(err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

        TransactionService.get({
          controller1: 'nudge',
          controller2: 'popup'
        }).$promise.then(success, error);
      }

      function sanitizedType(type){
        var trType;
        type = angular.copy(type);
        switch (type){
          case 'SIP_TOP_UP':
            trType = 'SIP';
            break;
          default:
            trType=type;
        }
        return trType;
      }

    }
})();

/**
 * Created by ttn on 6/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SubscriptionValuationController', subscriptionValuation);

  /** @ngInject */
  function subscriptionValuation($window, ModalService, $timeout, $state, LoaderService, InvestorService, MessageService, UtilService,$filter) {
    var vm = this;
    vm.folioList = null;

    vm.editSubscription = editSubscription;
    vm.editSubscriptionSuccess = editSubscriptionSuccess;
    vm.modeChanged = modeChanged;
    vm.getFolios = getFolios;
    vm.checkAll = checkAll;
    vm.subscribeFolios = subscribeFolios;
    vm.subscribeSchemes = subscribeSchemes;
    vm.getSubscriptionList = getSubscriptionList;
    vm.deleteSubscription = deleteSubscription;
    vm.deleteSchemeSubscription = deleteSchemeSubscription;
    vm.unsubscribeSubscription = unsubscribeSubscription;
    vm.getSchemes = getSchemes;

    vm.init = function () {
      switch($state.current.name){
        case 'main.subscriptionValuation.folio-valuation':
          vm.mode = 'EMAIL';
          vm.frequency = 'DAILY';
          getFolios();
          getSubscriptionList('folio');
          break;
        case 'main.subscriptionStatus':
          var subscribeData = $window.JSON.parse(localStorage.getItem('Subscribedata'));
          vm.subscriptionType = subscribeData.type? subscribeData.type : 'Folio';
          vm.successSet = subscribeData.successSet;
          vm.failureSet = subscribeData.failureSet;
          break;
        case 'main.unsubscription':
          var unSubscribedData = $window.JSON.parse(localStorage.getItem('deletedSubscriptions'));
          vm.subscriptionType = unSubscribedData.type? unSubscribedData.type : 'Folio';
          vm.successSet = unSubscribedData.successSet;
          vm.failureSet = unSubscribedData.failureSet;
          break;
        case 'main.subscriptionValuation.nav':
          vm.mode = 'EMAIL';
          getSchemes();
          getSubscriptionList('scheme');
          break;
      }
    };

    function modeChanged(type) {
      if(type == 'folio') {
        getFolios();
        vm.checkall = false;
        vm.checkAll(type);
      }
      else {
        vm.checkall = false;
        vm.checkAll(type);
        getSchemes();
      }
    }
    vm.checkedFolio = 0;
    vm.checkedScheme = 0;
    vm.calculateChecked = function (type) {
      $timeout(function () {
        if(type=='folio'){
          var trues = $filter("filter")(vm.folioList, {
            selected: true
          });
          vm.checkedFolio = trues.length
          if( vm.checkedFolio == vm.folioList.length) vm.checkall = true;
          else vm.checkall = false;
        }
        if(type=='scheme') {
          trues = $filter("filter")(vm.schemeList, {
            selected: true
          });
          vm.checkedScheme = trues.length;
          if( vm.checkedScheme == vm.schemeList.length) vm.checkall = true;
          else vm.checkall = false;
        }
      },100)

    };

    function getFolios() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.folioList = resp.data.folioNumbers;
            vm.folioList = vm.folioList.map(function(e) {
              return { folio: e, selected:false };
            });
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'get',
        child2: 'unsubscribed',
        child3: 'folio',
        child4: vm.mode
      }).$promise.then(success, error);
    }

    function getSubscriptionList(type) {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.subscriptions = resp.data.subscriptions;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      InvestorService.get({
        child1: 'subscription',
        child2: type,
        child3: 'get',
        child4: 'all'
      }).$promise.then(success, error);
    }

    function checkAll(type) {
     $timeout(function () {
       if(vm.checkall){
         if(type=='folio'){
           angular.forEach(vm.folioList, function (value) {
             value.selected = true;
           });
           vm.checkedFolio = vm.folioList.length;
         }
         else {
           angular.forEach(vm.schemeList, function (value) {
             value.selected = true;
           });
           vm.checkedScheme = vm.schemeList.length;
         }
       } else {
         if(type=='folio'){
           angular.forEach(vm.folioList, function (value) {
             value.selected = false;
           });
           vm.checkedFolio = 0;
         } else {
           angular.forEach(vm.schemeList, function (value) {
             value.selected = false;
           });
           vm.checkedScheme = 0;
         }
       }
     },100);

    }

    function subscribeFolios() {
      var folioList = [];
      angular.forEach(vm.folioList, function (value) {
        if(value.selected){
          folioList.push(value.folio);
        }
      });
      var payload = {
        folioNumbers : folioList,
        frequency: vm.frequency,
        mode: vm.mode
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var Subscribedata = resp.data;
            localStorage.setItem('Subscribedata',$window.JSON.stringify(Subscribedata));
            $state.go('main.subscriptionStatus');
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'subscribe',
        child2: 'folio'
      }, payload).$promise.then(success, error);
    }

    function unsubscribeSubscription(type,data) {
      var success = function () {
        if(type == 'folio'){
          deleteSubscription(data.folioNumber);
        } else deleteSchemeSubscription(data);

      }, error = function () {

      };
      ModalService.confirmUnsubscribeModal({}, success, error);
    }

    function deleteSubscription(folio) {
      var folioNumbers = [];
      folioNumbers.push(folio);
      var payload = {
        "folioNumbers": folioNumbers
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.deletedSubscriptions = resp.data;
            localStorage.setItem('deletedSubscriptions',$window.JSON.stringify(vm.deletedSubscriptions));
            $state.go('main.unsubscription');
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'subscription',
        child2: 'folio',
        child3: 'multiple',
        child4: 'delete'
      }, payload).$promise.then(success, error);
    }

    function editSubscription(type, data) {
      var success = function (resp) {
        if(resp){
          MessageService.success(resp||' Subsription successfully edited');
          if(type=='folio'){
            getSubscriptionList('folio');
          } else  getSubscriptionList('scheme');

        }
        },
        error = function () {

        };
      ModalService.editSubscriptionModal({data:data}, success, error);

    }

    function editSubscriptionSuccess(data) {

      var success = function () {

        },
        error = function () {

        };
      ModalService.editSubscriptionModal({data:data}, success, error);

    }

    //for schemes
    function getSchemes() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            //  vm.notificationData = sortEvent(resp.data.notificationList);
            vm.schemeList = resp.data.schemes;
            angular.forEach(vm.schemeList, function (value) {
              value.selected = false;
            })
          } else {
            vm.schemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.schemeList = null;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'get',
        child2: 'unsubscribed',
        child3: 'scheme',
        child4: vm.mode
      }).$promise.then(success, error);
    }

    function subscribeSchemes() {
      var schemeList = [];
      angular.forEach(vm.schemeList, function (value) {
        if(value.selected){
          schemeList.push(value);
        }
      });
      var payload = {
        schemes : schemeList,
        mode: vm.mode
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var Subscribedata = resp.data;
            Subscribedata.type="Scheme";
            localStorage.setItem('Subscribedata',$window.JSON.stringify(Subscribedata));
            $state.go('main.subscriptionStatus');
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'subscribe',
        child2: 'schemes'
      }, payload).$promise.then(success, error);
    }

    function deleteSchemeSubscription(data) {
      var schemeDetails = [];
      schemeDetails.push(data);
      var payload = {
        "schemes": schemeDetails
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            //  vm.notificationData = sortEvent(resp.data.notificationList);
            vm.deletedSubscriptions = resp.data;
            vm.deletedSubscriptions.type = 'Scheme';
            localStorage.setItem('deletedSubscriptions',$window.JSON.stringify(vm.deletedSubscriptions));
            $state.go('main.unsubscription');
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'subscription',
        child2: 'scheme',
        child3: 'multiple',
        child4: 'delete'
      }, payload).$promise.then(success, error);
    }

  }

})();

/**
 * Created by ttn on 27/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('StatementsController', statementsController);

  /** @ngInject */
  function statementsController($scope, $stateParams, $state, $rootScope, AuthService, LoaderService, DownloadPdfService,
                                AppConstants, InvestorService, MessageService, ModalService, UtilService, $timeout, FileSaver,
                                Blob, $window, investorServiceVersion, DownloadPdfServiceV2,HDFC_API) {
    $window.document.getElementById('_first')
    var vm = this;
    vm.HDFC_API = HDFC_API;
    AuthService.checkLinkedUserStatus();
    // vm.viewStatement = viewStatement;
    vm.generateStatement = generateStatement;
    vm.downloadStatement = downloadStatement;
    vm.selectedTab = 'classic';
    vm.changeSelectedTab = changeSelectedTab;
    vm.fetchFolioList = fetchFolioList;
    vm.fetchOutSchemes = fetchOutSchemes;
    vm.folioChanged = folioChanged;
    vm.updateEndDate = updateEndDate;
    vm.changeStartDate = changeStartDate;
    vm.changeCaptailGainStartDate = changeCaptailGainStartDate;
    vm.changeEndDate = changeEndDate;
    vm.statementOptionChanged = statementOptionChanged;
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.viewMode = 'days';
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isShowDefault = 'false';
    vm.folioList = null;
    vm.STATEMENT_OPTIONS = {
      'CURRENT': 'CFY',
      'PREVIOUS': 'PFY',
      'FULL': 'FS',
      'PERIOD': 'P'
    };
    vm.CAPITAL_GAIN_STATEMENT_OPTION = {
      'CURRENT': 'CY',
      'PREVIOUS': 'PY',
      'FULL': 'SI',
      'PERIOD': 'SD'
    };
    vm.formData = {
      minEndDate: null,
      startDate: null,
      endDate: null
    };
    vm.startMaxDate = $window.moment();
    vm.endMaxDate = $window.moment();
    var isStateReloaded = sessionStorage.getItem('isStatementStateReloaded');
    vm.enableDownloadCTA = true;
    vm.schemeNotAvailable = AppConstants.STATEMENT_SCHEME_NOT_AVAILABLE;


    vm.init = function () {
      if($window.performance && $window.performance.getEntriesByType( 'navigation' ).map( function (nav){return  nav.type} ).includes( 'reload' )){
        if (!isStateReloaded) {
          sessionStorage.setItem('isStatementStateReloaded','true');
          $state.reload();
        } else {
          initStatement();
        }
      } else {
        initStatement();
      }

    };


    function initStatement() {
      vm.sessionId = $window.sessionStorage.getItem("isExposedStatementActive");
      if ($window.sessionStorage.getItem("isExposedStatementActive")) {
        vm.selectedTab = $stateParams.tabType;
        vm.formData.folioNumber = $stateParams.folioNumber;
        vm.folioList = [{
          activeFlag: true,
          folioId: $stateParams.folioNumber,
          folioNumber: $stateParams.folioNumber,
          investorName: null,
          minorFlag: false
        }];

        folioChanged(vm.formData.folioNumber);
      }
      else {
        fetchFolioList();
      }

      vm.formData.statementOption = vm.STATEMENT_OPTIONS.CURRENT;
      if ($stateParams.type) {
        changeSelectedTab($stateParams.type);
      }
    }

    function updateEndDate(date) {
      // var day = null;
      var enabledEndDates = [];

      var currentDay = $window.moment();
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var startDay = angular.copy($window.moment(date)).set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var diff = Math.abs(startDay.diff(currentDay, 'days'));

      //  var diff = startDay.diff(currentDay, 'days');
      for (var i = 1; i <= diff; i++) {
        var _date = startDay.clone().add(i, 'days');
        enabledEndDates.push(_date.clone());
      }

      // if start date selected is current date setting end date same
      if (enabledEndDates.length === 0) {
        enabledEndDates.push(date.clone());
      }

      vm.enabledEndDates = angular.copy(enabledEndDates);
      vm.formData.minEndDate = vm.enabledEndDates[0];
      vm.formData.endDate = '';
    }

    function fetchFolioList() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.folioList = resp.data.folioTaxDetailLists;
          } else {
            vm.folioList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          //UtilService.errorHandler(err);
        };
      LoaderService.showLoader();

      if (vm.selectedTab == 'classic') {
        investorServiceVersion.get({
          child1: 'folio',
          child2: 'list'
        }).$promise.then(success, error);
      } else {
        InvestorService.get({
          child1: 'folio',
          child2: 'list'
        }).$promise.then(success, error);
      }

    }

    function folioChanged(folioNo) {
      if (folioNo && (vm.selectedTab == 'exitLoad') || vm.selectedTab == 'balance') { //vm.selectedTab == 'classic' || //Commented for HMF-24569
        fetchOutSchemes(folioNo);
      }
    }

    function fetchOutSchemes(folioNo) {
      vm.schemeList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemeList = resp.data.schemes;
            /*if (vm.selectedTab == 'classic' && vm.schemeList.length > 0) { //Commented for HMF-24569
              vm.schemeList.unshift({schemeCode: 'ALL', schemeName: 'All Schemes'});
              vm.formData.scheme = vm.schemeList[0].schemeCode;
            }*/
          } else {
            vm.schemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.schemeList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();

      var _config = {child1: 'folio', child2: 'schemes'};

      if ($window.sessionStorage.getItem("isExposedStatementActive")) {
        _config = {child1: 'exposed', child2: 'statement', child3: 'folio', child4: 'schemes'};
      }

      if (vm.selectedTab == 'classic') {
        investorServiceVersion.post(_config, {folioNumber: folioNo}).$promise.then(success, error);
      } else {
        InvestorService.post(_config, {folioNumber: folioNo}).$promise.then(success, error);
      }
    }

    function changeSelectedTab(selectedTab) {

      vm.selectedTab = selectedTab;
      vm.enableDownloadCTA = true;
      vm.resetFormData();
    }

    vm.resetFormData = function () {
      !$window.sessionStorage.getItem("isExposedStatementActive") && fetchFolioList();

        switch (vm.selectedTab) {
          case 'classic':
              vm.formData.scheme = null;
              vm.formData.minEndDate = null;
              vm.formData.startDate = null;
              vm.formData.endDate = null;
              vm.formData.statementOption = vm.STATEMENT_OPTIONS.CURRENT;
              vm.formData.folioNumber = vm.STATEMENT_OPTIONS.CURRENT;
            break;
          case 'capital':
              vm.formData.minEndDate =  null;
              vm.formData.startDate =  null;
              vm.formData.endDate =  null;
              vm.formData.statementOption =  vm.CAPITAL_GAIN_STATEMENT_OPTION.CURRENT;
              vm.formData.folioNumber =  vm.STATEMENT_OPTIONS.CURRENT;
            break;
          case 'balance':
              vm.formData.scheme =  null;
              vm.formData.folioNumber =  null;
            break;
          case 'dividend':
            vm.formData.minEndDate =  null;
            vm.formData.startDate =  null;
            vm.formData.endDate =  null;
            vm.formData.statementOption =  vm.STATEMENT_OPTIONS.CURRENT;
            vm.formData.folioNumber =  vm.STATEMENT_OPTIONS.CURRENT;
            break;
          case 'exitLoad':
            vm.formData.scheme =  null;
            vm.formData.folioNumber =  null;
            break;
        }

      !$window.sessionStorage.getItem("isExposedStatementActive") && (vm.formData.folioNumber = null);

      var tmp = vm.selectedTab;
      vm.selectedTab = null;
      $timeout(function () {
        vm.selectedTab = tmp;
      });
    };


    function generateStatement(type) {
      var reportName = null;
      switch (type) {
        case 'classic':
          var payload = {
            "folioNumber": vm.formData.folioNumber, //'10006184'
            "schemeCode": !vm.formData.scheme || vm.formData.scheme === 'ALL' ? '': vm.formData.scheme,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "email"
            },
            "onScreenType": 'EMAIL'
          };
          reportName = 'accountStatement';
          break;
        case 'capital':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "email"
            }
          };
          reportName = 'capitalGain';
          break;
        case 'balance':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "scheme": vm.formData.scheme.schemeCode,
            "schemeName": vm.formData.scheme.schemeName,
            "commonReportCO": {
              "docDestination": "email"
            }
          };
          reportName = 'balanceConfirmation';
          break;
        case 'dividend':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "email"
            }
          };
          reportName = 'dividend';
          break;
        case 'exitLoad':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "schemeCode": vm.formData.schemeCode,
            "commonReportCO": {
              "docDestination": "email"
            }
          };
          reportName = "exitLoad";
          break;
      }

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp && resp.status) {
          var msg = resp.message
            var success = function () {
                vm.resetFormData();
            $state.reload();  },
              error = function () {
              };
          var successHandler = function(resp) {

           if(resp.popupDTO.popupDTOMap.Popup_Home !== undefined)
            {
             ModalService.successMessageModal({message: msg}, success, error);
            }
         }

         UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
           MessageService.error(resp);
         });
         //ModalService.successMessageModal({message: resp.message}, success, error);
        } else {
          vm.folioList = null;
          MessageService.error(resp.message);
          vm.resetFormData();
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.folioList = null;
        UtilService.errorHandler(err);
        vm.resetFormData();
      };
      LoaderService.showLoader();

      if ($window.sessionStorage.getItem("isExposedStatementActive")) {
        var _config = {child1: 'exposed', child2: 'statement', child3: reportName};
      }
      else {
        _config = {child1: 'statement', child2: reportName};
      }
      if (type !== 'capital' && type !== 'classic') {
        InvestorService.post(_config, payload).$promise.then(success, error);
      } else if (type === 'capital' || type === 'classic') {
        investorServiceVersion.post(_config, payload).$promise.then(success, error);
      }
    }

    function downloadStatement(type) {
      var reportName = null;
      switch (type) {
        case 'classic':
          var payload = {
            "folioNumber": vm.formData.folioNumber, //'10006184'
            "schemeCode": !vm.formData.scheme || vm.formData.scheme === 'ALL' ? '': vm.formData.scheme,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "download"
            },
            "onScreenType": 'DOWNLOAD'
          };
          reportName = 'accountStatement';
          break;
        case 'capital':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "download"
            }
          };
          reportName = 'capitalGain';
          break;
        case 'balance':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "scheme": vm.formData.scheme.schemeCode,
            "schemeName": vm.formData.scheme.schemeName,
            "commonReportCO": {
              "docDestination": "download"
            }
          };
          reportName = 'balanceConfirmation';
          break;
        case 'dividend':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "download"
            }
          };
          reportName = 'dividend';
          break;
        case 'exitLoad':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "schemeCode": vm.formData.schemeCode,
            "commonReportCO": {
              "docDestination": "download"
            }
          };
          reportName = "exitLoad";
          break;
      }


      var decode= function (arr) {
        var d = "";
        for (var i = 0; i < arr.length; i += 1) {
          d += String.fromCharCode(arr[i]);
        }
        return d;
      };

      var success = function (resp) {
        var status = false;
        try {
          var decodedString = decode(new Uint8Array(resp.data));
          if (decodedString.indexOf('PDF') === -1) {
            if (angular.isObject(decodedString)) {
              var obj = $window.JSON.parse(decodedString);
              var message = obj['message'];
              status = false;
            } else {
              var crypt = new $window.JSEncrypt();
              crypt.setKey(HDFC_API.PRIV_KEY);
              var header = decodedString.substring(0, decodedString.lastIndexOf("|"));
              var data = $window.CryptoJS.enc.Base64.parse(decodedString.substring(decodedString.lastIndexOf("|")+1, decodedString.length));
              var responseData = readAesResponsePayload(crypt.decrypt(header), data);
              decodedString = angular.fromJson(responseData);
              var message = decodedString['message'];
              status = false;
            }
          }
          else {
            status = true;
          }
        }
        catch (error) {
          status = false;
        }
        if (resp.data && status) {
          var data = new Blob([resp.data], { type: 'application/pdf' });
          FileSaver.saveAs(data, reportName=='dividend'? 'IDCWStatement': reportName +'.pdf');
          LoaderService.hideLoader();
          vm.resetFormData();
          sessionStorage.removeItem('isStatementStateReloaded');
          $timeout(function () {
            $state.reload();
          },500)
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message || message || 'No Data Available');
          vm.resetFormData();
        }
      }, error = function (err) {
        vm.resetFormData();
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      if ($window.sessionStorage.getItem("isExposedStatementActive")) {
        var _pathExposed = '/exposed/statement/';
      }
      LoaderService.showLoader();
      if (type !== 'capital' && type !== 'classic') {
        DownloadPdfService.downloadFile(payload, reportName, _pathExposed).then(success, error);
      } else if (type === 'capital' || type === 'classic') {
        DownloadPdfServiceV2.downloadFile(payload, reportName, _pathExposed).then(success, error);
      }
    }

    function changeStartDate(date) {

      if (date) {
        vm.formData.startDate = date;
        updateEndDate(date);
      } else {
        vm.errorMessage = 'Enter valid Date';
        vm.formData.startDate = null;
      }
    }

    function changeEndDate(date) {

      if (date) {
        vm.formData.endDate = date;
        if (vm.selectedTab === 'classic') {
          var diffInDays = date.diff(vm.formData.startDate, 'days');
          if (diffInDays <= 365) {
            vm.enableDownloadCTA = true;
          } else {
            vm.enableDownloadCTA = false;
          }
        } else {
          vm.enableDownloadCTA = true;
        }
      } else {
        vm.errorMessage = 'Enter valid Date';
        vm.formData.endDate = null;
      }
    }

    function statementOptionChanged() {
      $timeout(function () {
        vm.enableDownloadCTA = true;

        if (vm.formData.statementOption != 'PE') {
          vm.formData.startDate = null;
          vm.formData.endDate = null;
        }

        if (vm.formData.statementOption === 'FS') {
          vm.enableDownloadCTA = false;
        }

      })
    }

    var removeListeners = {};
    removeListeners["UpdateExposedStatementToken"] = $rootScope.$on("UpdateExposedStatementToken", function () {
      var modalSuccess = function(){
        $window.sessionStorage.removeItem("isExposedStatementActive");
        AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
        $state.go('validateFolio');
      };
      var message = 'Your session has been expired. Please verify your Folio Number to continue.';
      ModalService.forgotPasswordModal({message: message},modalSuccess);
    });

    vm.redirectToLogin = function () {
      AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
      $window.sessionStorage.removeItem("isExposedStatementActive");
      $state.go("validateFolio");

    }
    $scope.$on("$destroy", function() {
     if($window.sessionStorage.getItem("isExposedStatementActive")){
       AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
       $window.sessionStorage.removeItem("isExposedStatementActive");
     }
    });

    /*
    * Capital Gain start date changes handler
    * */
    function changeCaptailGainStartDate(date) {
      if (date) {
        vm.formData.startDate = date;
        updateCaptialGainEndDate(date);
      } else {
        vm.errorMessage = 'Enter valid Date';
        vm.formData.startDate = null;
      }
    }

    /*
    * Function responsible to identify enabled dates.
    * */
    function updateCaptialGainEndDate(date) {
      // var day = null;
      var enabledEndDates = [];

      var endDate = $window.moment(date).add(365, 'days');
      endDate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var startDay = angular.copy($window.moment(date)).set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});

      var diff = Math.abs(startDay.diff(endDate, 'days'));
      for (var i = 1; i <= diff; i++) {
        var _date = startDay.clone().add(i, 'days');
        if ($window.moment(_date).isSameOrBefore($window.moment())) {
          enabledEndDates.push(_date.clone());
        }
      }
      if ($window.moment(endDate).isSameOrBefore($window.moment())) {
        vm.endMaxDate = endDate.add(1, 'minutes');
      } else {
        vm.endMaxDate = $window.moment().add(1, 'minutes');
      }

      // if start date selected is current date setting end date same
      if (enabledEndDates.length === 0) {
        enabledEndDates.push(date.clone());
      }

      vm.capitalGainEnabledEndDates = angular.copy(enabledEndDates);
      vm.formData.minEndDate = vm.capitalGainEnabledEndDates[0];
      vm.formData.endDate = '';
    }

    function readAesResponsePayload(header, data) {
      var iv = $window.CryptoJS.enc.Base64.parse(header.substring(0, header.lastIndexOf("|")));
      var key = $window.CryptoJS.enc.Base64.parse(header.substring(header.lastIndexOf("|")+1, header.length));
      var decryptJson = $window.CryptoJS.AES.decrypt({
        ciphertext: data
      }, key, {iv: iv});
      return decryptJson.toString($window.CryptoJS.enc.Utf8);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('SavedItemsController', savedItemsCtrl);

  /** @ngInject */
  function savedItemsCtrl(MessageService, InvestorServiceV3, TransactionService, InvestorService, LoaderService, UtilService, $state, ModalService, $rootScope,panAadharService,$window) {
    var vm = this;
    vm.kycMessage = "";
    var locselectedLinkPanData = sessionStorage.getItem('selectedLinkPanData'); 
    if(locselectedLinkPanData){
        locselectedLinkPanData = $window.CryptoJS.AES.decrypt(locselectedLinkPanData.toString(), 'LinkPanData');
        locselectedLinkPanData = $window.JSON.parse(locselectedLinkPanData.toString($window.CryptoJS.enc.Utf8));
        if(locselectedLinkPanData && !locselectedLinkPanData.default){
            $state.go("welcome");
        }
    }
    var unFinTrans = {
      unfinishedTransactionAPI: unfinishedTransactionAPI,
      deleteUnfinishedTransactionAPI: deleteUnfinishedTransactionAPI,
      transactionlimit: 6
    };
    var unFinFolios = {
      unfinishedFoliosAPI: unfinishedFoliosAPI,
      deleteUnfinishedFoliosAPI: deleteUnfinishedFoliosAPI,
      folioslimit: 6
    };
    var unFinScheduleTransaction = {
      unfinishedScheduleAPI: unfinishedScheduleAPI,
      scheduledTransactionLimit: 6
    };
    vm.trans = {
      showViewMoreFlag: true,
      unfinishedTransactionListLimit: unFinTrans.transactionlimit,
      unFinTransTotalLength: null,
      unfinishedTransactionList: null,
      viewTransactions: viewTransactions,
      deleteTransactions: deleteTransactions,
      showMore: showMore
    };
    vm.scheduledTransaction = {
      showViewMoreFlag: true,
      unfinishedScheduledTransactionListLimit: unFinScheduleTransaction.scheduledTransactionLimit,
      scheduledTransactionTotalLength: null,
      scheduledTransactionList: null,
      viewSchduledTransactions: viewSchduledTransactions,
      cancelScheduledTransactions: cancelScheduledTransactions,
      showMore: showMoreScheduleTransaction
    };
    vm.folios = {
      showViewMoreFlag: true,
      unfinishedFoliosLimit: unFinFolios.folioslimit,
      unFinFoliosTotalLength: null,
      unfinishedFoliosList: null,
      viewFolios: viewFolios,
      deleteFolios: deleteFolios,
      showMoreFolio: showMoreFolio,
      kycVerifiedFlag: true,
      kycMessage: ""
    };
    vm.init = function () {
      unFinFolios.unfinishedFoliosAPI();
      unFinTrans.unfinishedTransactionAPI();
      unFinScheduleTransaction.unfinishedScheduleAPI();
      sessionStorage.removeItem('setFolioInitiateState');
      sessionStorage.removeItem('contactUpdateCo');
    };

    function viewTransactions(obj) {
      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        if (!vm.kycVerifiedFlag) {
          ModalService.genericModal({
            text: vm.kycMessage
          });
          return;
        }
        if(!obj.validFolio){
        ModalService.genericModal({
          text:obj.folioMsg
        });
        return;
      }
        var tID = obj.tID;
        var ctID = obj.ctID;
        var tType = obj.tType.toLowerCase();
        var state = tType; //(tType == "purchase" ? 'sip' : tType);
        if (tType == 'stpflex') {
          state = 'stp';
          obj.tType = 'STP';
        }else if(tType === 'instantaccessfacility'){
          state = 'instantRedemption';
          obj.tType = 'INSTANT_REDEMPTION';
        }
        else if(tType === 'smart_swap'){
          state = 'smartSwap';
          obj.tType = 'SMART_SWAP';
        }
        else if(tType === 'dreamsip'){
          state = 'dreamSip';
          obj.tType = 'DREAMSIP';
        }
        $state.go('main.transactions.' + state, {
          transactionId: tID,
          transactionType: obj.tType,
          ctId: ctID,
          isCompId: !!ctID
        });
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,obj.tFolio).then(successHandler).catch(errorHandler);
    }

    function viewFolios(obj) {

      if(!obj.panAadharVerifiedFlag)
      {
        ModalService.genericModal({
          text: obj.panAadharMessage,
          isAadhar: true
        });
        return;
      }
      if (!obj.kycVerifiedFlag) {
        ModalService.genericModal({
          text: obj.kycMessage
        });
        return;
      }
      var uuid = obj.uuid;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            localStorage.removeItem('folioId');
            $rootScope.setFolioInitiateState = $state.current.name;
            sessionStorage.setItem('setFolioInitiateState', $rootScope.setFolioInitiateState);
            $state.go('main.folio.holdmode', {investorId: uuid});
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();

      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'getDetails'
      },{id:uuid}).$promise.then(success, error);
    }

    function deleteTransactions(obj) {
      var confirmSuccess = function () {
        unFinTrans.deleteUnfinishedTransactionAPI(obj);
      };
      var confirmError = function () {
      };
      ModalService.confirmCancelModal({Text: "Are you sure you want to delete the saved transaction ?"}, confirmSuccess, confirmError);
    }

    function deleteFolios(obj) {
      var confirmSuccess = function () {
        localStorage.removeItem("wantToAddNomineeLater");
        localStorage.removeItem("optOutNominee");
        unFinFolios.deleteUnfinishedFoliosAPI(obj);
      };
      var confirmError = function () {
      };
      ModalService.confirmCancelModal({Text: "Are you sure you want to delete the saved folio ?"}, confirmSuccess, confirmError);
    }

    function showMore() {
      vm.trans.unfinishedTransactionListLimit = vm.trans.unfinishedTransactionListLimit + unFinTrans.transactionlimit;
      vm.trans.showViewMoreFlag = vm.trans.unfinishedTransactionListLimit < vm.trans.unFinTransTotalLength;

    }

    function showMoreFolio() {
      vm.folios.unfinishedFoliosLimit = vm.folios.unfinishedFoliosLimit + unFinFolios.folioslimit;
      vm.folios.showViewMoreFlag = vm.folios.unfinishedFoliosLimit < vm.folios.unFinFoliosTotalLength;
    }

    function unfinishedTransactionAPI() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.trans.unfinishedTransactionList = resp.data.result;
            vm.trans.unFinTransTotalLength = vm.trans.unfinishedTransactionList.length;
            vm.trans.showViewMoreFlag = vm.trans.unFinTransTotalLength > unFinTrans.transactionlimit;
            vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
            vm.kycMessage = resp.data.kycMessage;
          } else {
            vm.trans.unfinishedTransactionList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      TransactionService.get({
        controller1: 'transaction',
        controller2: 'saved',
        controller3: 'get',
        controller4: 'all'

      }).$promise.then(success, error);
    }

    function unfinishedFoliosAPI() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.folios.unfinishedFoliosList = resp.data && resp.data.folioDTOs ?resp.data.folioDTOs:[];
            vm.folios.unFinFoliosTotalLength = resp.data && resp.data.folioDTOs && resp.data.folioDTOs.length
              ?resp.data.folioDTOs.length:0;
            vm.folios.showViewMoreFlag = vm.folios.unFinFoliosTotalLength > unFinFolios.folioslimit;
            vm.folios.kycVerifiedFlag = resp.data.kycVerifiedFlag;
            vm.folios.kycMessage = resp.data.kycMessage;
          } else {
            vm.folios.unfinishedFoliosList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      InvestorServiceV3.get({
        child1: 'folio',
        child2: 'list',
        child3: 'draftFolios'
      }).$promise.then(success, error);
    }

    function deleteUnfinishedTransactionAPI(obj) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            var transactionData = resp.data;
            if (transactionData.trnxActionFlag) {
              vm.trans.unfinishedTransactionList = vm.trans.unfinishedTransactionList.filter(function (el) {
                return el.transactionId != obj.transactionId;
              });
              vm.trans.unFinTransTotalLength = vm.trans.unfinishedTransactionList.length;
              MessageService.success(transactionData.trnxActionMsg);
            }

          } else {
            MessageService.error(resp.message);
          }

        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      TransactionService.get({
        controller1: 'delete',
        controller2: obj.transactionId
      }).$promise.then(success, error);
    }

    function deleteUnfinishedFoliosAPI(obj) {
      var uuid = obj.folioId;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            vm.folios.unfinishedFoliosList = vm.folios.unfinishedFoliosList.filter(function (el) {
              return el.folioId != obj.folioId;
            });
            vm.folios.unFinFoliosTotalLength = vm.folios.unfinishedFoliosList.length;
            MessageService.success(resp.message);
          } else {
            MessageService.error(resp.message);
          }

        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      InvestorServiceV3.post({
        child1: 'folio',
        child2: 'draftFolio',
        child3: 'delete'
      }, {id: uuid}).$promise.then(success, error);
    }

    /* Schedule transaction section starts from here */
    /*
    * function to make http request to get the saved schedule transaction list
    */
    function unfinishedScheduleAPI() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.scheduledTransaction.scheduledTransactionList = resp.data.scheduleTransactionSaveDTOList;
          vm.scheduledTransaction.scheduledTransactionTotalLength = vm.scheduledTransaction.scheduledTransactionList.length;
          vm.scheduledTransaction.showViewMoreFlag = vm.scheduledTransaction.scheduledTransactionTotalLength > unFinScheduleTransaction.scheduledTransactionLimit;
        } else {
          vm.scheduledTransaction.scheduledTransactionList = null;
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      LoaderService.showLoader();
      TransactionService.get({
        controller1: 'schedule',
        controller2: 'transaction',
        controller3: 'saved',
        controller4: 'get',
        controller5: 'all'
      }).$promise.then(success, error);
    }

    /*
    * Function to hande click on view for saved scheduled transactions
    */
    function viewSchduledTransactions(obj) {
      var tID = obj.tID;
      var ctID = obj.ctID;
      var tType = obj.tType.toLowerCase();
      var state = tType;
      $state.go('main.transactions.schedule-' + state, {
        transactionId: tID,
        transactionType: obj.tType,
        ctId: ctID,
        isCompId: !!ctID,
        transactionAction: 'view',
        state: state,
        initiatedBy: 'schedule'
      });
    }

    /*
    * Function to handle click on delete for saved scheduled transaction
    */
    function cancelScheduledTransactions(obj) {
      console
      var tID = obj.tID;
      var ctID = obj.ctID;
      var tType = obj.tType.toLowerCase();
      var state = tType;
      $state.go('main.transactions.schedule-' + state, {
        transactionId: tID,
        transactionType: obj.tType,
        ctId: ctID,
        isCompId: !!ctID,
        transactionAction: 'cancel',
        state: state,
        initiatedBy: 'schedule'
      });
    }
    function showMoreScheduleTransaction() {
      vm.scheduledTransaction.unfinishedScheduledTransactionListLimit = vm.scheduledTransaction.unfinishedScheduledTransactionListLimit + unFinScheduleTransaction.scheduledTransactionLimit;
      vm.scheduledTransaction.showViewMoreFlag = vm.scheduledTransaction.unfinishedScheduledTransactionListLimit < vm.scheduledTransaction.scheduledTransactionTotalLength;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .config(registration);

  /** @ngInject */
  function registration($stateProvider) {
    $stateProvider

      .state('registration', {
        url: '/registration',
        templateUrl: 'app/registration/registration.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration',
        authenticate: false,
        defaultRoute: '.main'
      })
      .state('registration.main', {
        url: '/main?from',
        templateUrl: 'app/registration/registration.main.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration',
        authenticate: false
      })
      .state('registration.kycVerification', {
        url: '/kycVerification',
        templateUrl: 'app/registration/registration.kycVerification.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration',
        authenticate: false
      })
      .state('registration.newInvestor', {
        url: '/newInvestor',
        templateUrl: 'app/registration/registration.newInvestor.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration',
        authenticate: false
      })
      .state('registration.otp', {
        url: '/otp',
        templateUrl: 'app/registration/registration.otp.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration',
        authenticate: false
      })
      .state('registration.success', {
        url: '/success',
        templateUrl: 'app/registration/registration.success.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration',
        authenticate: false
      })
  }
})();

/**
 * Created by ttn on 6/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('RegistrationController', registrationController);

  /** @ngInject */
  function registrationController($state, $stateParams, $log, $timeout, toastr, CreatePayloadFactory, ModalService, InvestorService, AppConstants, LoaderService, MessageService, investorServiceVersion, toastrConfig,AuthService,InvestorServiceVersion3,$window, UtilService, $scope) {
    var vm = this;
    vm.formData = {};
    vm.verifyForm = {};
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.EMAIL_PATTERN = angular.copy(AppConstants.email_regex);
    vm.processFlag = false;
    vm.otpResendMessage = '';
    vm.errorMessage = '';
    vm.isShowDefault = 'false';
    vm.viewMode = 'days';
    vm.processOTPFlag = false;
    vm.disableVerifyButton = false;
    vm.changeStartDate = changeStartDate;
    vm.verifyDetails = verifyDetails;
    vm.getUserNameSuggestion = getUserNameSuggestion;
    vm.checkAvailability = checkAvailability;
    vm.confirmRegister = confirmRegister;
    vm.updateEmailId = updateEmailId;
    vm.updateContact = updateContact;
    vm.verifyUser = verifyUser;
    vm.confirmOtp = confirmOtp;
    vm.checkPanVerification = checkPanVerification;
    vm.resetValues = resetValues;
    vm.confirmCancel = confirmCancel;
    vm.saveNewEmail = saveNewEmail;
    vm.saveNewContact = saveNewContact;
    vm.checkPattern = checkPattern;
    vm.reGenerateOtp = reGenerateOtp;
    vm.showTermConditions = showTermConditions;
    vm.resetCreateUserId=resetCreateUserId;
    vm.formData.dob = null;
    vm.isPanValid = false;
    vm.panMessage = "";
    vm.dateErrorMessage = "";
    vm.availableMessage = "";
    var details = {};
    vm.emailEdit = false;
    vm.contactEdit = false;
    vm.verifyForm.emailAddress = "";
    vm.verifyForm.emailAddressEdited = "";
    vm.isMatching = true;
    vm.isRequired = false;
    vm.inputReset = false;
    vm.otpSentMessage="";
    vm.status = "Verified or In Progress";
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    vm.isUserId=true;
    vm.showTerms = true;
    //var processFlag = false;

    var successHandler = function(resp) {
      if(!resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General) {
        vm.showTerms = false;
      }
    }

    UtilService.fetchDynamicData("INNER_TNC").then(successHandler).catch(function(resp) {
      MessageService.error(resp)
    });

    vm.Init = function () {
      details = CreatePayloadFactory.get();
      switch ($state.current.name) {
        case 'registration.main':
          break;
        case 'registration.kycVerification':
          if (Object.keys(details).length == 0) {
            $state.go("registration.main");
          } else {
            vm.panToShow = details.PAN;
          }
          break;
        case 'registration.newInvestor':
          getUserDetails();
          break;
        case 'registration.otp':
          vm.otpSentMessage= localStorage.getItem("otpSentMessage");
          if (Object.keys(details).length == 0) {
            $state.go("registration.main");
          }
          break;
      }

      if(sessionStorage.panNumber && $stateParams.from == 'tracker'){
        vm.formData.pan = sessionStorage.panNumber
      }
    };

    function changeStartDate(date) {
      if (angular.isDefined(date._i)||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.formData.dob = date;
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.formData.dob = "";
      }
      return;
    }

    function reGenerateOtp() {
      var success = function (resp) {
        vm.processOTPFlag = false;
        LoaderService.hideLoader();
        if (resp.data && resp.data.isOtpSent) {
          localStorage.removeItem("otpSentMessage");
          //vm.otpSentMessage = " ";
          vm.processOTPFlag = true;
          toastrConfig.preventDuplicates = false;
          toastr.success(resp.message, '', {
            allowHtml: true,
            onHidden: function () {
              vm.processOTPFlag = false;
              toastrConfig.preventDuplicates = true;
            }
          });
          resetTimer();
        } else {
          vm.processOTPFlag = true;
          toastrConfig.preventDuplicates = false;
          toastr.error(resp.message, '', {
            allowHtml: true,
            onHidden: function () {
              vm.processOTPFlag = false;
              toastrConfig.preventDuplicates = true;
            }
          });
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.processOTPFlag = false;
        vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
        $log.info('Error:', err);
      };
      vm.inputReset = true;
      $timeout(function () {
        vm.inputReset = false;
      });
      vm.errorMessage = '';
      vm.otpResendMessage = '';
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'registration',
        child2: 'resendOTP'
      }, {panNumber: details.PAN, id: details.id}).$promise.then(success, error);
    }

    function confirmRegister() {
      var successModal = function () {
          $state.go('registration.main')
        },
        errorModal = function () {
          $state.go('registerUser')
        };
      ModalService.confirmRegisterModal({}, successModal, errorModal)
    }

    function confirmCancel() {
      var confirmSuccess = function () {
        $state.go("login");
      };
      var confirmError = function () {
        //task.done = false;
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    }

    function resetValues() {
      vm.errorMessage = "";
      vm.panMessage = "";
      vm.availableMessage = "";
      vm.otpResendMessage = "";
      vm.dateErrorMessage = "";
    }

    function confirmOtp() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            $log.info("resp.data=== ", resp.data);
            if (resp.data.userVerificationFlag) {
              //  MessageService.success(resp.message);
              var success = function () {
                  CreatePayloadFactory.reset();
                  UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.EXISTING_USER); //aplicable only for sidebar
                  $state.go("login");
                },
                error = function () {
                };
              $state.go('createUserId.userIdSuccessAcknowledgement');
            } else {
              vm.processFlag = true;
              toastrConfig.preventDuplicates = false;
              toastr.error(resp.data.message, '', {
                allowHtml: true,
                onHidden: function () {
                  vm.processFlag = false;
                  toastrConfig.preventDuplicates = true;
                }
              });
            }
            //resp.data.dob = vm.payload.dob;
          } else {
            vm.processFlag = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(resp.message, '', {
              allowHtml: true,
              onHidden: function () {
                vm.processFlag = false;
                toastrConfig.preventDuplicates = true;
              }
            });
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
          //vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      var payload = {
        otp: vm.otpVerificationForm.otpNumber,
        panNumber: details.PAN,
        id: details.id,
        fieldType: "USER_ID",
        emailId: AuthService.encryptRSA(angular.copy(localStorage.getItem('userEmail'))),
        panHolderName: details.panHolderName,
        dob: details.dob,
        registrationType: "NEW",
        password: AuthService.encryptRSA(angular.copy(details.password)),
        userId: localStorage.getItem('userName'),
        corporateUser: false,
        folioNo: ''
      };

      if(details.contactNumber) {
        payload.contactNumber = AuthService.encryptRSA(angular.copy(details.contactNumber))
      }


      LoaderService.showLoader();
      InvestorServiceVersion3.post({
        child1: 'registration',
        child2: 'otp',
        child3: 'verify'
      }, payload).$promise.then(success, error);

    }

    function verifyUser() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.isAvailable = resp.data.userVerificationFlag;
            details.id = resp.data.id;
            localStorage.setItem("otpSentMessage",resp.data.otpSentMessage);
            details.password = vm.verifyForm.password;
            CreatePayloadFactory.set(details);
            if (resp.data.userVerificationFlag) {
              // MessageService.success(resp.message);
              $state.go("registration.otp");
              vm.errorMessage = '';
            } else {
              vm.disableVerifyButton = true;
              toastrConfig.preventDuplicates = false;
              toastr.error(resp.data.message, '', {
                onHidden: function () {
                  vm.disableVerifyButton = false;
                  toastrConfig.preventDuplicates =  true;
                }
              });
            }
          } else {
            vm.disableVerifyButton = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(resp.message, '', {
              onHidden: function () {
                vm.disableVerifyButton = false;
                toastrConfig.preventDuplicates =  true;
              }
            });
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      localStorage.setItem('userName',vm.verifyForm.userId);
      localStorage.setItem('userEmail',vm.verifyForm.emailId||details.emailId);
      var payload = {
        "password": AuthService.encryptRSA(angular.copy(vm.verifyForm.password)),
        "panNumber": details.PAN,
        "userId": vm.verifyForm.userId,
        "investorRegistrationType": details.registrationType,
        "panHolderName": details.panHolderName,
        "email": AuthService.encryptRSA(angular.copy(details.emailId || localStorage.getItem('userEmail')))
      };

      if(details.contactNumber) {
        payload.mobileNumber = AuthService.encryptRSA(angular.copy(details.contactNumber))
      }
      var contactData = {
        'pk^pan_number':sessionStorage.getItem("panDetailsEncrypted"),
        //'USERID':vm.verifyForm.userId,
        'email':details.emailId || localStorage.getItem('userEmail'),
        'mobile':details.contactNumber || ""
      };
      $window.smartech('contact', '7', contactData, function() {
        $window.smartech('identify', sessionStorage.getItem("panDetailsEncrypted"));
        $window.smartech('dispatch', 'Registration_Initiated_2',{});
      });

      LoaderService.showLoader();
      InvestorServiceVersion3.post({
        child1: 'registration',
        child2: 'otp',
        child3: 'generate'
      }, payload).$promise.then(success, error);
    }

    function updateEmailId() {
      vm.emailEdit = true;
      vm.verifyForm.emailAddressEdited = vm.verifyForm.emailAddress;
      // angular.element(document.getElementById("emailEdit")).focus();
    }

    function saveNewEmail() {
      if (vm.verifyForm.emailAddressEdited && vm.verifyForm.emailAddressEdited != vm.verifyForm.emailAddress) {

        var successEmail = function (resp) {
            if (resp.status) {
              $log.info("email updated");
              vm.verifyForm.emailAddress = vm.verifyForm.emailAddressEdited;
              vm.emailEdit = false;
            } else {
              vm.emailEdit = false;
              MessageService.error(resp.message);
            }
          },
          errorEmail = function () {
            //vm.verifyForm.emailAddress = vm.verifyForm.emailAddressEdited;
            vm.emailEdit = false;
            //   MessageService.error(resp.message);
            vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          };
        var payload = {
          "panNumber": details.PAN,
          "emailId": vm.verifyForm.emailAddressEdited
        };
        InvestorService.post({
          child1: 'registration',
          child2: 'updateUserEmail'
        }, payload).$promise.then(successEmail, errorEmail);
      }
      else {
        vm.verifyForm.emailAddress = vm.verifyForm.emailAddressEdited;
        vm.emailEdit = false;
      }
    }

    function saveVerifiedContact() {
      var successEmail = function (resp) {
          if (resp.data && resp.status) {
            $log.info("email updated");
            vm.verifyForm.contact = vm.verifyForm.contactEdited;
            vm.contactEdit = false;
          } else {
            vm.contactEdit = false;
            MessageService.error(resp.message);
          }
        },
        errorEmail = function () {
          vm.verifyForm.contact = vm.verifyForm.contactEdit;
          vm.contactEdit = false;
          //   MessageService.error(resp.message);
          vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      var payload = {
        "panNumber": details.panNumber,
        "emailId": vm.formData.contactEdited
      };
      InvestorService.post({
        child1: 'registration',
        child2: 'edit',
        child3: 'mobile'
      }, payload).$promise.then(successEmail, errorEmail);

    }

    function saveNewContact() {
      if (vm.verifyForm.contactEdited && vm.verifyForm.contactEdited != vm.verifyForm.contact) {
        var successContact = function (resp) {
            if (resp.data && resp.status) {
              if (resp.data.userVerificationFlag) {
                var confirmSuccess = function () {
                  var isOtpValid = CreatePayloadFactory.getOTP();
                  if (isOtpValid) {
                    saveVerifiedContact();
                  } else {
                    //  vm.verifyForm.emailAddress = vm.verifyForm.emailAddressEdited;
                    vm.contactEdit = false;
                  }
                };
                var confirmError = function () {
                  vm.contactEdit = false;
                };
                ModalService.confirmOtpModal({
                  text: 'Mobile Number',
                  pan: resp.data.panNumber,
                  email: vm.verifyForm.contactEdited
                }, confirmSuccess, confirmError);

              } else {
                $log.info("contact updated");
                //vm.verifyForm.emailAddress = vm.verifyForm.emailAddressEdited;
                vm.contactEdit = false;
                //    vm.errorMessage = 'Some problem';
                //MessageService.error(resp.data.message);
              }
            } else {
              vm.contactEdit = false;
              MessageService.error(resp.message);
            }
          },
          errorContact = function () {
            vm.emailEdit = false;
            vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          };
        var payload = {
          "panNumber": details.PAN,
          "value": vm.verifyForm.contactEdited
        };
        InvestorService.post({
          child1: 'registration',
          child2: 'edit',
          child3: 'mobile'
        }, payload).$promise.then(successContact, errorContact);
      } else {
        vm.verifyForm.contact = vm.verifyForm.contactEdited;
        vm.contactEdit = false;
      }
    }

    function updateContact() {
      vm.contactEdit = true;
      // angular.element(document.getElementById("emailEdit")).focus();
      vm.verifyForm.contactEdited = vm.verifyForm.contact;
    }

    function getUserNameSuggestion() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.suggestedName = resp.data.userId;
            vm.verifyForm.userId = resp.data.userId;
            details.userId = resp.data.userId;
            CreatePayloadFactory.set(details);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
          // vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      InvestorService.post({
        child1: 'registration',
        child2: 'generateUserId'
      }, {"userName": details.panHolderName}).$promise.then(success, error);
    }

    function checkAvailability() {
      vm.isUserId=true;
      if (vm.verifyForm.userId != null && vm.verifyForm.userId != vm.suggestedName) {
        var success = function (resp) {
            LoaderService.hideLoader('.availability-loader');
            if (resp.data && resp.status) {
              $log.info(resp.data.userIdAvailableFlag);
              if (resp.data.userIdAvailableFlag) {
                vm.availableMessage = "";
              } else {
                vm.availableMessage = resp.data.message || 'User ID not available';
              }
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader('.availability-loader');
            MessageService.error(AppConstants.ToastrMessage.FAILED);
            //vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          };
        LoaderService.showLoader('.availability-loader');
        InvestorService.get({
          child1: 'registration',
          child2: 'userId',
          child3: 'availability',
          child4: vm.verifyForm.userId
        }).$promise.then(success, error);
      }
    }

    function checkPanVerification() {
      if (vm.formData.pan) {
        var success = function (resp) {
            LoaderService.hideLoader('.pan-loader');
            //  if (resp.status  && !resp.hasOwnProperty('data')) {
            if (resp.data && resp.status) {
              $log.info("resp.data=== ", resp.data);
              if (resp.data.panVerifiedFlag) {
                vm.panMessage = "";
              } else {
                vm.panMessage = resp.data.message;
              }
              vm.processFlag = false;
            } else {
              vm.processFlag = true;
              vm.panMessage = resp.message;
            }
          },
          error = function () {
            LoaderService.hideLoader('.pan-loader');
            vm.processFlag = true;
            //vm.errorMessage = AppConstants.ToastrMessage.FAILED;
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        vm.processFlag = false;
        LoaderService.showLoader('.pan-loader');
        InvestorService.post({
          child1: 'registration',
          child2: 'verifyPan'
        }, {"panNumber": vm.formData.pan}).$promise.then(success, error);
      }
    }

    function verifyDetails() {
      // $state.go("registration.otp");
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.processFlag = false;
            $log.info("resp.data=== ", resp.data);
            vm.registrationType = resp.data.registrationType;
            resp.data.PAN = vm.formData.pan;
            CreatePayloadFactory.set(resp.data);
            switch (vm.registrationType) {
              case 'NEW':
                if (resp.data.kycVerifiedFlag) {
                  $state.go("registration.newInvestor");
                  vm.errorMessage = '';
                } else {
                  //MessageService.error(resp.data.message);
                  $state.go('registration.kycVerification');
                }
                break;
              case 'EXISTING':
                var success = function (flag) {
                    if (flag == 'login') {
                      UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.EXISTING_USER); //aplicable only for sidebar
                      $state.go('login');
                    } else {
                      $state.go('createUserId.verifyAccountDetails');
                    }
                  },
                  error = function () {
                    $state.go('registration.kycVerification');
                  };
                ModalService.registrationSuccessModal({
                  'text': 'You are already an investor with HDFC Mutual Fund. Please proceed to create a User ID incase you do not have one.',
                  'buttonText': 'Create User ID',
                  'buttonTextCancel': 'Proceed to Login'
                }, success, error, "custom");
                break;
              case 'NEW_REGISTERED':
                var successNew = function () {
                    UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.EXISTING_USER); //aplicable only for sidebar
                    $state.go('login');
                  },
                  errorNew = function () {
                    $state.go('registration.kycVerification');
                  };
                ModalService.registrationSuccessModal({
                  'text': 'Your PAN is already registered. Please continue to login',
                  'buttonText': 'Proceed to login'
                }, successNew, errorNew);
                break;
              case 'EXISTING_REGISTERED':
                var successExisting = function () {
                    UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.EXISTING_USER); //aplicable only for sidebar
                    $state.go('login');
                  },
                  errorExisting = function () {
                    $state.go('registration.kycVerification');
                  };
                ModalService.registrationSuccessModal({
                  'text': 'Your PAN is already registered. Please continue to login',
                  'buttonText': 'Proceed to login'
                }, successExisting, errorExisting);
                break;

            }
          } else {
            if (resp && resp.message) {
              if(resp.message==="REDIRECT_TO_OLD"){
                ModalService.redirectToOldFolioModal({});
              }else{
                var messages = resp.message + '<span class="' + Math.random() + '"></span>';
                toastr.error(messages, '', {
                  allowHtml: true,
                  onHidden: function () {
                    vm.processFlag = false;
                  }
                });
              }
            } else {
              MessageService.error();
            }
            // MessageService.error(resp.message);
          }
        },
        error = function (resp) {
          if (resp && resp.message) {
            var messages = resp.message + '<span class="' + Math.random() + '"></span>';
            toastr.error(messages, '', {
              allowHtml: true,
              onHidden: function () {
                vm.processFlag = false;
              }
            });
          } else {
            MessageService.error();
          }

          LoaderService.hideLoader();
          //vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          //  MessageService.error(resp.message);
        };
      var payload = {
        dob: vm.formData.dob.format('DD-MMM-YYYY'),
        panNumber: vm.formData.pan
      };
      vm.processFlag = true;
      LoaderService.showLoader();
      investorServiceVersion.post({
        child1: 'registration',
        child2: 'verifyKYC'
      }, payload).$promise.then(success, error);
    }


    function checkPattern(pwd) {
      vm.verifyForm.password = pwd;
      vm.check4CofirmPW = pwd?pwd.replace(/\$/gi, "\\$"):'';
      //vm.isMatching = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%_!]).{8,12})/.test(vm.verifyForm.password);
      vm.isMatching = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[$_!@])[A-Za-z\d$@!_]{8,15}$/.test(vm.verifyForm.password);

      if (vm.verifyForm.password == null) {
        vm.isRequired = true;
        vm.isMatching = true;
      } else {
        vm.isRequired = false;
      }
    }

    function showTermConditions() {
      ModalService.termConditionModal();
    }


    function getUserDetails() {
      var payload = JSON.parse(sessionStorage.getItem("panDetails"));
      if (!payload) {
        $state.go("login");
      }
      var success = function(resp) {
        if (resp.status && resp.data) {
          if ((resp.data.kycStatus === vm.KYC_STATUS.VERIFIED || resp.data.kycStatus === vm.KYC_STATUS.IN_PROGRESS)) {
           //vm.status = resp.data.kycStatus === "IN_PROGRESS" ? "In Progress" : "Verified";
            if (Object.keys(details).length != 0) {
              details = resp.data;
              details.PAN = payload.panNumber;
              details.dob = payload.dob;
              vm.suggestedName = resp.data.suggestedUserId;
              vm.verifyForm.userId = resp.data.suggestedUserId;
              details.userId = resp.data.suggestedUserId;
              vm.verifyForm.emailAddress = vm.EMAIL_PATTERN.test(details.emailId)? details.emailId : false;
              vm.verifyForm.contact = details.contactNumber;
              vm.verifyForm.maskedEmail = details.maskedEmail;
              vm.verifyForm.maskedMobile = details.maskedMobile;
              CreatePayloadFactory.set(details);
            } else {
              $state.go("login");
            }
          } else if (resp.data.kycStatus === vm.KYC_STATUS.NOT_VERIFIED || resp.data.kycStatus === vm.KYC_STATUS.INCOMPLETE) {
            sessionStorage.setItem("ekycRequestCO", JSON.stringify(resp.data.ekycRequestCO));
            $state.go('ekyc', {
              ekycRequestCO: resp.data.ekycRequestCO
            });
          } else {
            ModalService.nonKycModal({
              'text': 'Your KYC status is not verified, please update KYC with your current KRA through Point of Service of any KRA intermediary.',
              'buttonText': 'OK'
            }, function() {
              $state.go("login");
            }, function() {
            });
          }
        } else if (!resp.status) {
          $state.go("login");
        }
      }, error = function(resp) {
        $state.go("login");
      };
      investorServiceVersion.post({
        child1: 'registration',
        child2: 'verifyKyc',
        child3: 'generate',
        child4: 'userId'
      }, payload).$promise.then(success, error);
    }

    vm.handleSideBarClick = function(state) {
      UtilService.updateSideBar(state);
    };

    function resetCreateUserId() {
      vm.isUserId=false;
    }

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

  }
})();

(function() {
    'use strict';
    angular
        .module('hdfc-mf-investor-web')
        .controller('ChangeDividendOptionController', changeDividendOptionController);

  /** @ngInject */
  function changeDividendOptionController(ModalService, $state, $stateParams, LoaderService, AppConstants, MessageService, UtilService, InvestorService, investorServiceVersion , dynamicDataReview , $window, panAadharService,AuthService) {
    var vm = this;
    vm.fetchFolioList = fetchFolioList;
    vm.submitChangeDividend = submitChangeDividend;
    vm.getDetails = getDetails;
    vm.masterOutSchemeList = null;
    vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList);
    vm.folioChangedFlag = false;
    vm.formData={
      folioNumber : '',
      outSchemeObj : '',
      dividendOption : '',
      isCheckedTandC : ''
    };
    vm.kycVerifiedFlag = null;
    vm.dynamicDataReview = dynamicDataReview;
    vm.showTerms = true;
    vm.isValidScheme=false;
    AuthService.checkLinkedUserStatus();

    if($stateParams){
      setStateParams();
    }
    function setStateParams() {
      vm.formData.folioNumber = $stateParams.folioNumber;
      getDetails();
    }
    vm.CONST = AppConstants.TRANSACTIONS;
    vm.dividendOptions = [vm.CONST.DIVIDEND_OPTIONS.REINVEST, vm.CONST.DIVIDEND_OPTIONS.PAYOUT];
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;

    vm.init = function () {
      fetchFolioList();
      var successHandler = function(resp) {
        if(!resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General)
        {
          vm.showTerms = false;
        }
      }

      UtilService.fetchDynamicData("INNER_TNC").then(successHandler).catch(function(resp) {
        MessageService.error(resp)
      });
    };

      function fetchFolioList(cb) {
        cb = cb || function () {
        };
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              var folioList = [];
              vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
              if (resp.data.kycVerifiedFlag === false) {
                ModalService.genericModal({
                  text: resp.data.kycMessage
                }, function() {
                  $state.go("welcome");
                });
                return;
              }
              Object.keys(resp.data.folioList).forEach(function (key) {
                var obj = Object.assign({key: key}, resp.data.folioList[key]);
                folioList.push(angular.copy(obj));
              });
              vm.folioList = folioList.length ? folioList : null;
              if (vm.folioList && vm.folioList.length === 1 &&  !$stateParams.transactionId) {
                vm.formData.folioNumber = vm.folioList[0].folioNumber;
                if (!vm.formData.isBackFromSummary && !vm.formData.outSchemeCode) {
                  vm.folioChanged();
                }
              }
              if (vm.formData.dynamicData && vm.formData.dynamicData.folioNumber) {
                vm.formData.folioNumber = vm.formData.dynamicData.folioNumber;
                vm.folioChanged();
              }
              cb(true);
            } else {
              vm.folioList = null;
              MessageService.error(resp.message);
              cb(false);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            vm.folioList = null;
            UtilService.errorHandler(err);
            cb(false);
          };
      LoaderService.showLoader();
      investorServiceVersion.get({
        child1: 'folio',
        child2: 'active-list',
        trxnType: 'CDO'
      }).$promise.then(success, error);
    }

    vm.folioChanged = function () {

      vm.folioChangedFlag = true;
      if (!vm.formData.folioNumber) {
        vm.formData = {};
        return;
      }
      var successHandler=function(resp)
      {
        LoaderService.hideLoader();
        getDetails();
        vm.formData.outSchemeName = null;
        vm.formData.outSchemeCode = null;
      };
      var errorHandler=function(resp)
      {
        LoaderService.hideLoader();
        vm.formData.folioNumber=null;
        return;
      }
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(null,vm.formData.folioNumber).then(successHandler).catch(errorHandler);

    };


    vm.filterOutSchemeList = function () {
      vm.formData.outSchemeObj = '';
      vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList, 'schemeName', vm.formData.outSchemeName);
      vm.isValidScheme = false;
    };

    vm.outSchemeChanged = function (schemeData) {
      if(schemeData) {
        if (schemeData.reinvest == 'Y') {
          vm.reInvest = 'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option';
          vm.formData.dividendOption = 'Payout';
        } else {
          vm.reInvest = 'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option';
          vm.formData.dividendOption = 'Reinvest'
        }
      }

      if(schemeData) {
        vm.formData.outSchemeCode = schemeData.schemeCode;
        vm.formData.outSchemeName = schemeData.schemeName;
        vm.isValidScheme=true;
      }
    };

    function getDetails() {
      if (!vm.formData.folioNumber) {
        return;
      }
      vm.details = null;
      vm.isCheckedTandC = '';
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            for(var i in resp.data.reinvestSchemeDTOs){
              resp.data.reinvestSchemeDTOs[i].index = i;
            }
            vm.details = resp.data.reinvestSchemeDTOs;
            vm.masterOutSchemeList = vm.details;
            vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList);
            if($stateParams && !vm.folioChangedFlag){
              var schemeCode = $stateParams.sc;
              vm.selected = vm.details.filter(function (el) {
                return el.schemeCode == schemeCode;
              });
                vm.formData.outSchemeObj = vm.selected[0];
              vm.outSchemeChanged();
            }
          } else {
              vm.details = null;
              vm.masterOutSchemeList = null;
              vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList);
              MessageService.error(resp.message);
            vm.isValidScheme=false;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorService.get({
        child1: vm.formData.folioNumber,
        child2: 'scheme',
        child3: 'reinvest'
      }).$promise.then(success, error);
    }

    function submitChangeDividend(){
      var successModal = function () {
        var payload = {
          "folioNo": vm.formData.folioNumber,
          "reInvestOpt": vm.formData.dividendOption === 'Payout'? 'N' : 'Y',
          "schemeCode": vm.formData.outSchemeCode
        };
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.showSuccess(resp.data, vm.formData.outSchemeObj.schemeName);
              } else {
                if(resp.popupEnabled) {
                  ModalService.genericModal({
                    text: resp.message,
                    isAadhar: true
                  });
                } else {
                  MessageService.error(resp.message);
                }
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
          LoaderService.showLoader();
          InvestorService.post({
            child1: 'transaction',
            child2: 'reinvest'
          }, payload).$promise.then(success, error);
        },
        errorModal = function () {
          //  MessageService.error(err)
        };
      ModalService.changeDividendModal({text:'Do you want to change the IDCW Option?'}, successModal, errorModal)
    }

    vm.showSuccess = function(data, schemeName) {
      var successModal = function () {
       vm.formData = {};
        vm.isCheckedTandC = '';
          $state.go('welcome');

        },
       errorModal = function () {
         vm.formData = {};
         vm.isCheckedTandC = '';
         $state.go('welcome');
       // MessageService.error(err)
       };
       ModalService.changeDividendModalSuccess({schemeName:schemeName}, successModal, errorModal);
    };

    vm.showTermConditions = function () {
      ModalService.termConditionModal();
    };

  }
})();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('PreliminaryDashboardController', preliminaryDashboardController);
  
    /** @ngInject */
    function preliminaryDashboardController(HDFC_API,$state,UtilService,$window,LoaderService,MessageService,InvestmentBasketService,ModalService, $stateParams,InvestorService,AuthService,$cookies,AppConstants,$rootScope,$timeout,NetcoreEvntService,PreliminaryDashboardCalculatorService) {
      var vm = this;
      vm.transactSubMenu = true;
      vm.toolsSubMenu = true;
      vm.HDFC_API = HDFC_API; 
      vm.token = AuthService.getMobileLoginToken(); 
      vm.logout = logout;
      vm.login = login;
      vm.userDetails = AuthService.getUserCookies(); 
      vm.recentActivity = recentActivity;
      var removeListeners = {};
      // Greeting text
      vm.greeting = '';
      var todayDay = new Date();
      var curHr = todayDay.getHours();
      if (curHr >= 0 && curHr < 12) {
        vm.greeting = 'Good Morning!';
      } else if (curHr >= 12 && curHr < 17) {
          vm.greeting = 'Good Afternoon!';
      } else if (curHr >= 17 && curHr < 24) {
          vm.greeting = 'Good Evening!';
      }else{
        vm.greeting = '';
      }
    // add pan
      vm.addpan = function(){
        var successModal = function (resp) {
          if(resp.isNewInvestor){
            var successModal = function (data) { 
              vm.userDetails = AuthService.getUserCookies();
              logout(false,function () {
                vm.userDetails.throughPrelimanaryDashboard = true;
                vm.userDetails.transactionType = resp.transactionType;
                vm.userDetails.dob = resp.dob;
                sessionStorage.setItem('MobilePanLoginDetails',JSON.stringify(vm.userDetails));
                $state.go('newInvestor.kycVerification');
              });
            }, errorModal = function () {
            };
            var data = {
              note:resp.note,
              throughPrelimanaryDashboard : true
            } 
            ModalService.loginWithMobileModal({STEPS:'CONFIRMATION_PROMPT',data:data}, successModal, errorModal);
          }
          if(resp.redirectOnDashboard){
            vm.existingUserDetails = {};
            vm.existingUserDetails.throughPrelimanaryDashboard = true;
            vm.existingUserDetails.transactionType = resp.transactionType;
            vm.loginMethod = 'SWITCH_MTOKEN_TO_ETOKEN';
            login();
          }else{
            if(resp && resp.popupEnabled){
              ModalService.genericModal({
                text: resp.message
              });
            }
          }
        },errorModal = function (err) {
          if(err && err == 'logout'){
            logout(false,function () {
              sessionStorage.setItem('LOGIN_WITH_USERID',true);
              $state.go('login');
            });
          }
          if(err && err == 'HOME_STATE'){
            logout(false,function () {
              $state.go('login');
            });
          }
        };
        vm.userDetails = AuthService.getUserCookies(); 
        if(vm.userDetails && vm.userDetails.disablePAN){
          var data = {
            pan: vm.userDetails.pan,
            dob: vm.userDetails.dob,
            throughPrelimanaryDashboard : true
          }
        }else{
          var data = {
            throughPrelimanaryDashboard : true
          }
        }
        ModalService.loginWithMobileModal({STEPS:'VERIFY_PAN',data:data}, successModal, errorModal);
      }
      vm.allCalculatorLink = HDFC_API.WEBSITE_LINK + AppConstants.CALCULATOR_LINK ;
      vm.allInvestmentBasketLink = HDFC_API.WEBSITE_LINK + AppConstants.INVESTMENT_BASKET_LINK;
      vm.learnerCorner = HDFC_API.WEBSITE_LINK + AppConstants.LEARNER_CORNER_LINK;
      vm.knowYourInvestmentPersonality = HDFC_API.WEBSITE_LINK + AppConstants.INVESTMENT_PERSONALITY_LINK;
      vm.basket_widget = AppConstants.PRE_DASH_BASKET_WIDGET;
      vm.goalsCardsList = AppConstants.GOAL_CARDS_LIST;
      init();
    vm.count = 0;
    vm.active = UtilService.headerFont.get();
    vm.changedFont = changedFont;
    vm.fontSizeChange = fontSizeChange;
    vm.contrast = contrast;
    vm.contrastt = UtilService.darkThemeStatus.get();
    vm.contrastmobile = UtilService.darkThemeStatus.get();
    function contrast () {
      if(!vm.contrastt){
        UtilService.darkThemeStatus.set(true);
        $window.document.getElementsByTagName("body")[0].classList.remove("contrastClass");
      } else {
        UtilService.darkThemeStatus.set(false);
        $window.document.getElementsByTagName("body")[0].classList.add("contrastClass");
      }
    }
    function changedFont(valType){
      vm.active = {1: false};
      switch (valType) {
        case 'increment' : {
          if(vm.count<3){
            vm.count++;
            UtilService.headerFont.set(3);
            vm.active = UtilService.headerFont.get();
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'decrement' : {
          if(vm.count>-3){
            vm.count--;
            UtilService.headerFont.set(2);
            vm.active = UtilService.headerFont.get();
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'original' : {
          vm.count = 0;
          UtilService.headerFont.set(1);
          vm.active = UtilService.headerFont.get();
          vm.fontSizeChange(vm.count);
        }
          break;
      }
    }
    function fontSizeChange(val){
      var elem = $window.document.getElementsByTagName("body")[0];
      elem.classList.add("newBigFont");
      var ele = $window.document.getElementsByClassName('newBigFont')[0];
      switch (val) {
        case -2 : {
          elem.classList.add("smallest-font");
          elem.classList.remove("small-font");
          ele.setAttribute("style","font-size: 70% !important");
        }
          break;
        case -1 : {
          elem.classList.add("small-font");
          ele.setAttribute("style","font-size: 80% !important");
        }
          break;
        case 0 : {
          elem.removeAttribute('style');
          elem.classList.remove("newBigFont");
          elem.classList.remove("big-font");
          elem.classList.remove("medium-font");
          elem.classList.remove("small-font");
          elem.classList.remove("smallest-font");
        }
          break;
        case 1 : {
          elem.classList.add("medium-font");
          ele.setAttribute("style","font-size: 97% !important");
        }
          break;
        case 2 : {
          elem.classList.add("big-font");
          elem.classList.remove("medium-font");
          ele.setAttribute("style","font-size: 110% !important");
        }
          break;
      }
    }
    function init() {
      getAllBaskets();
      getAllGoals(function () {});
      getAllCalculator();
    }

    function getAllBaskets() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investmentBasketCollection = resp.data.basketDetailDTOList;
          vm.basketRedirectionUrl = '';
          vm.investmentBasket =[];
          vm.investmentBasketCollection.forEach(function (item) {
           if(item.basketName){
            item.basketRedirectionUrl = HDFC_API.WEBSITE_LINK +'product-solutions/'+item.basketName.split(' ').join('-').toLowerCase();
           }
           vm.investmentBasket.push(item);
          });
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err)
      }

      LoaderService.showLoader();

      InvestmentBasketService.get({
        child1: 'investment',
        child2: 'basket',
        child3: 'getAllBaskets'
      }).$promise.then(success, error);
    }


    function logout(redirectOnLogin,cb){
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
          if (resp && resp.status) { 
            MessageService.success(resp.message); 
            if(redirectOnLogin){
              $state.go('login');
            }
            cb(true);
          } else {
            MessageService.error(resp.message); 
          } 
          LoaderService.hideLoader();
        },
        error = function (err) {
          LoaderService.hideLoader();
        }; 
        AuthService.mobileTokenLogout().then(success, error); 
    }
    function getAllGoals(cb){
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {   
          vm.goalsListCollection = resp.data.goalDetailDTOList;
          vm.goalsList =[];
          vm.goalsListCollection.sort(function(a, b) {
            var keyA = a.sequence, keyB = b.sequence;
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
          vm.goalsListCollection.forEach(function (item) {
            if(item.goalId){
             item.goalRedirectionUrl = HDFC_API.WEBSITE_LINK +'goal-planning/'+item.goalId;
            }
            vm.goalsCardsList.forEach(function(val){
              if(item.goalId == val.goalId){
                item.imageUrl = val.imageUrl;
              }
            })
            vm.goalsList.push(item);
           });
          cb();
        }
        else {
          vm.goalsList = null;
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        vm.goalsList = null;
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestmentBasketService.get({
        child1: 'goal',
        child2: 'getAllGoals'
      }).$promise.then(success, error);
    }
    function login() {
      var successLogin = function (result) {
        vm.loginProcessFlag = false;
        LoaderService.hideLoader();
        if (result.access_token && result.access_token != "") {
    
          /*netcore script start here*/
          (typeof $window.smartech == 'function') && $window.smartech('identify', result.encryptedPanNumber);
          // NetcoreEvntService.Login_Status_IP(result, true);
          /* Please pass dynamic value of  PAN_NUMBER between '' whenever user logs in */
          /*netcore script end here*/
          sessionStorage.setItem('loggedIn', true);
          NetcoreEvntService.login_Success_Smartech();
          if (result.investorType != AppConstants.INVESTOR_TYPE.NEW) {
            if(result.loginType == "SWITCH_MTOKEN_TO_ETOKEN"){
              $window.smartech('contact', '', {
                'pk^pan_number': result.encryptedPanNumber,
                'email': HDFC_API.INFO_RECEIVE_IDENTIFIER ? HDFC_API.INFO_RECEIVE_IDENTIFIER.concat('@gmail.com') : result.email,
                'mobile': HDFC_API.INV_INFO_RECEIVER ? UtilService.genericConverter(HDFC_API.INV_INFO_RECEIVER) : result.mobile,
                'FIRST_NAME': result.investorFName,
                'LAST_NAME': result.investorLName
                });
                vm.netcoreDataObj = NetcoreEvntService.Mobile_Login(result, true);
                $window.smartech('dispatch','Mobile_login_success',vm.netcoreDataObj);
             }
            if ($stateParams.trackId) {
              if(vm.existingUserDetails.transactionType.toLowerCase() == 'purchase'){
                $state.go('main.transactions.purchase',{
                  trackId:$stateParams.trackId,
                  transactionType:$stateParams.trxnType,
                  stepNo:$stateParams.stepNo
                });
              }else if(vm.existingUserDetails.transactionType.toLowerCase() == 'sip'){
                $state.go('main.transactions.sip',{
                  trackId:$stateParams.trackId,
                  transactionType:$stateParams.trxnType
                });
              }else{
              $state.go('home', {
                trackId: $stateParams.trackId,
                trxnType: $stateParams.trxnType,
                stepNo: $stateParams.stepNo
              });
            }
            } else {
              if(vm.existingUserDetails.transactionType.toLowerCase() == 'purchase'){
                $state.go('main.transactions.purchase');
              }else if(vm.existingUserDetails.transactionType.toLowerCase() == 'sip'){
                $state.go('main.transactions.sip');
              }else{
              $state.go('home');
              }
            }
          } else {
            $state.go('welcome.newUserWelcome');
          }
        } else {
          if (result && result.message) {
            MessageService.error(result.message);
            if (result && result.locked) {
              vm.showUnlockID = true;
            }
          }
        }
      }, errorLogin = function () {
        LoaderService.hideLoader();
      };
      var token = AuthService.getMobileLoginToken();
      var secretLink = token.access_token;
      vm.userDetails = AuthService.getUserCookies();
      var payload = {
        grant_type:'password',
        password: AuthService.encryptRSA(angular.copy(token.mobile)),
        username: AuthService.encryptRSA(angular.copy(vm.userDetails.pan)),
        folioNumber: vm.userDetails && vm.userDetails.folioNumber ? vm.userDetails.folioNumber : ''
      }
      LoaderService.showLoader();
      AuthService.login(payload, vm.loginMethod, secretLink).then(successLogin, errorLogin);
    }
    removeListeners["RemoveMobileToken"] = $rootScope.$on("RemoveMobileToken", function () {
        sessionStorage.removeItem(AppConstants.MOBILE_IDENTIFIER);  
        $timeout(function () {
          sessionStorage.removeItem('ErrorStep');
          MessageService.error('Session has been expired. Please login to continue.');          
          $state.go('login');
        }, 0);
    });
    function getAllCalculator() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data) {
          vm.calculatorcardsCollection = resp.data.calculatorScreens;
          vm.calculatorcards = [];
          vm.calculatorcardsCollection.forEach(function (item) {
            if(item.attributes.is_checked){
              if(item.routeConstant.charAt(0) == '/'){
                item.routeConstant = item.routeConstant.slice(1);
              }
              vm.calculatorcards.push(item);
            }
          });
          vm.calculatorcards;
        }
      }, error = function (err) {
        LoaderService.hideLoader();
      }
      LoaderService.showLoader();
      PreliminaryDashboardCalculatorService.get({
        child1: 'learnersCorner',
        child2: 'calculators'
      }).$promise.then(success, error);
    }
    recentActivity();
    function recentActivity() {
      var lastLoginData = localStorage.getItem('lastLoginData');
      vm.lastDateTime = lastLoginData ? lastLoginData : "";
    }
    vm.redirect = function (url){
      $window.open(url +'?journeyPage=1','_blank');
    }
  }
})();
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PortfolioController', PortfolioController);

  /** @ngInject */
  function PortfolioController(LoaderService, $log, MessageService, InvestorService, TransactionsService, $state) {
    var vm = this;
    vm.$state = $state;

    /*function transactionOverview(schemeCode) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            //var overviewData = resp.data.schemeOverviewDTOs;
            TransactionsService.setTransactionOverview(resp.data.schemeOverviewDTOs);
            localStorage.setItem('overviewData', angular.toJson(resp.data.schemeOverviewDTOs));
            $state.go('main.transactions-view.details');
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.showLoader();
          $log.info("fetchConstantData error====", err);
        };
        LoaderService.showLoader();
      localStorage.removeItem('overviewData');
      InvestorService.post({
        child1: 'portfolio',
        child2: 'scheme-overview'
      }, {"schemeCode": schemeCode}).$promise.then(success, error);
    }*/

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('PaymentJourneyController', paymentJourneyController);

  /** @ngInject */
  function paymentJourneyController(ModalService, AppConstants, $window, $timeout, $state, $rootScope, $scope,
                                       $stateParams, TransactionModel, LoaderService, TransactionService,
                                       InvestorService, MessageService, UtilService, $log, NetcoreEvntService, HDFC_API, TransactionServiceVersion,notesPayment, FileUploadServiceVersion2,$sce, DownloadPdfService,FileSaver,AuthService,CommonFactory,investorServiceVersion, PaymentService, $location, IIHttpService) {


    var vm = this;
    vm.showLoader = true;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.showPaymentInfo = false;
    vm.formData = {};
    if ($stateParams.linkId) {
      vm.linkID = $stateParams.linkId;
    } else if (sessionStorage.getItem('linkId')) {
      vm.linkID = sessionStorage.getItem('linkId');
    }
    vm.formData.sipFirstInstallment = false;
    vm.paymentOptions = [];
    vm.netBankingBankList = [];
    vm.UPIBankList = null;
    vm.NEFTRTGSBankList = null;
    vm.otmBankList = [];
    var TrFlowType = AppConstants.TRANSACTION_FLOW;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.PATTERN = AppConstants;
    vm.downloadPdfFile = downloadPdfFile;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    $scope.billdeskUrl = HDFC_API.BILLDESK_URL;
    vm.NRI_STATUS_CODES = AppConstants.NRI_STATUS_CODES;
    vm.getFormData = getFormData;
    vm.getFormDataUpi = getFormDataUpi;
    vm.isDisableUpi = false;
    vm.sipUpiText = vm.TRANSACTIONS_CONST.DESCRIPTIONS.UPI_AUTOPAY;
    vm.isUPIVerified = false;
    vm.isCheckedDeclaration = false;
    vm.isCheckedTNC = false;
    vm.bankInfo = null;
    vm.bankInfoUPI = null;
    vm.investorInfo = null;
    vm.debitCardType = 'visa';
    vm.isInvalidForm = false;
    vm.isInvalidFormFI = false;
    vm.selectedUpiBank = selectedUpiBank;
    vm.hideOtmOtion = false;
    vm.verifyUPI = verifyUPI;
    vm.getAccountNumber = getAccountNumber;
    vm.tpv = tpv;
    vm.netBankingAndUPIList = null;
    vm.OTMList = null
    vm.isOTMAmount = false;
    vm.isOTMDate = false;
    vm.isOTMStartDate = false;
    vm.isOTMAmountFI = false;
    vm.isOTMDateFI = false;
    vm.isOTMStartDateFI = false;
    vm.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.notesApiGateWayPayment = notesPayment;
    vm.noteNetBanking = vm.notesApiGateWayPayment.noteDTO.noteDTOMap.Note_Purchase_Net_Banking;
    vm.billdeskPayload = {
      hidRequestId : "PGIME1000",
      hidOperation : "ME100",
      msg : ""
    };
    vm.isNewPayment = true;
    vm.changeRtgsPaymentOption = changeRtgsPaymentOption;
    vm.bankUploadChequeLeafFile = bankUploadChequeLeafFile;
    vm.openUploadedDoc = openUploadedDoc;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff", "application/pdf"];
    vm.chooseAFile = true;
    vm.changedPaymentOptionPurchase =  changedPaymentOptionPurchase;
    vm.checkDuplicate = checkDuplicate;
    vm.copyPasteHandler = copyPasteHandler;
    vm.successBackUrl = sessionStorage.getItem('redirectUrl');
    vm.apiConfig = AppConstants.API_CONFIG;
    vm.isCheckedTandCeMandate = false;
    vm.formData.emandateWord = {};
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.changeEndDateEmandate =  changeEndDateEmandate;
    vm.billerBankList = null;
    vm.mandateBankList = null;
    vm.showTermConditionsemandate = showTermConditionsemandate;
    vm.changedSipPaymentOption= changedSipPaymentOption;
    vm.PAYMENT_OPTIONS = AppConstants.PAYMENT_OPTIONS_ENUM;
    vm.fromPreLoginFlow = true;
    vm.selectPaymentOption = selectPaymentOption;
    var Card = $window.Card || {};
    var tokenData = AuthService.getToken();
    if ($stateParams.linkId) {
      vm.sourcePortal = 'INVESTOR';
    } else {
      vm.sourcePortal = tokenData.sourcePortal;
    }
    vm.isIntent = false;
    if (sessionStorage.getItem('intent')) {
      sessionStorage.removeItem('intent');
    }
    vm.selectedUpiOption = 'OTHERS';
    vm.isOpenedonMobile = setShareVariables();
    vm.payNow = payNow;

    // if payment page opened on mobile setting isIntent true and deselecting set selected upi option
    if (vm.isOpenedonMobile) {
      vm.isIntent = true;
      vm.selectedUpiOption = 'PHONE_PE';
    }

    vm.intentList = AppConstants.UPI_INTENT_LIST;
    vm.selectedUpiBlock = selectedUpiBlock;
    vm.submitForm = submitForm;
    vm.handleBackRedirection = handleBackRedirection;
    vm.tncUrl = HDFC_API.WEBSITE_LINK + 'information/terms-and-conditions-investor-portal';
    vm.redirectToTnc = redirectToTnc;
    vm.chequeLeafReadMore = chequeLeafReadMore;
    vm.utilService = UtilService;
    vm.durationYears = 30;
    vm.fetchInSchemeValidations = fetchInSchemeValidations;
    vm.finalSubmitCart = finalSubmitCart;
    vm.detailPageData = TransactionModel.getPayloadRawData();
    if (vm.detailPageData) {
      sessionStorage.setItem('fData',JSON.stringify(vm.detailPageData));
    }


    vm.init = init();

    /**
     * Function responsible for setting initial code logic
     */

    function init() {

      if (vm.linkID) {
        sessionStorage.removeItem('redirectUrl');
        fetchUserSavedData(function () {
          if (vm.formData.investmentType === 'PURCHASE') {
            initPurchase();
          } else if (vm.formData.investmentType === 'SIP') {
            initSip();
          }
        });
      } else {
        sessionStorage.removeItem("logoUrl");
        if (vm.successBackUrl) {
          $window.location.href = vm.successBackUrl;
        } else {
          $state.go('login');
        }
      }
      if(vm.sourcePortal && vm.sourcePortal === 'WHATSAPP') {
        getRandomOTPId();
      }
    }

    /**
     * Function responsible for fetching user saved data
     */

    function fetchUserSavedData(cb) {
      cb = cb ||function () {};

      var success = function (resp) {
        if (resp.status && resp.data) {
          if(resp.data.errorMsg && resp.data.errorMsg.toUpperCase() == "TRANSACTION LINK HAS BEEN EXPIRED."){
            $state.go('linkExpired');
            LoaderService.hideLoader();
            return;
          }
          vm.savedData = resp.data;
          vm.isSipPurchase = $stateParams.type && $stateParams.type === 'SIPPURCHASE';
          if (vm.detailPageData) {
            vm.savedData.journey = vm.detailPageData.journey;
            vm.savedData.sipViaPurchaseSelected = vm.detailPageData.sipViaPurchaseSelected || false ;
            var data = $window.JSON.parse(sessionStorage.getItem('fData'));
            vm.detailPageData = angular.copy(data);
          } else if (!vm.detailPageData) {
            var data = $window.JSON.parse(sessionStorage.getItem('fData'));
            vm.detailPageData = angular.copy(data);
            vm.savedData.journey = vm.detailPageData && vm.detailPageData.journey ? vm.detailPageData.journey : null;
            vm.savedData.sipViaPurchaseSelected = vm.detailPageData && vm.detailPageData.sipViaPurchaseSelected || false ;
          }

          /*if (sessionStorage.getItem('pageCalledOnce')) {
            sessionStorage.removeItem('pageCalledOnce');
            $window.history.back();
          } else {
            sessionStorage.setItem('pageCalledOnce','true');
          }*/

          if (vm.isSipPurchase) {
            if (vm.savedData.cartItems) {
              setCartData();
              vm.fetchInSchemeValidations(function () {
                vm.sipTDay = vm.inSchemeValidations && vm.inSchemeValidations.sipTDay ? vm.inSchemeValidations.sipTDay: 17;
                fetchPaymentModes(function () {
                  cb(true);
                })
              })
            } else {
              $state.go('main.transactions.purchase');
            }
          } else {
            setInitialFormData();
            if (vm.sourcePortal && vm.sourcePortal === 'WHATSAPP' && !vm.formData.endDate && vm.formData.investmentType === 'SIP') {

              if (vm.savedData.duration !== 0) {
                vm.durationYears = vm.savedData.duration;
              }
              vm.fetchInSchemeValidations(function () {
                vm.sipTDay = vm.inSchemeValidations && vm.inSchemeValidations.sipTDay ? vm.inSchemeValidations.sipTDay: 17;
                updateEndDates();
                fetchPaymentModes(function () {
                  cb(true);
                })
              })

            } else if (vm.formData.investmentType === 'SIP') {
              vm.fetchInSchemeValidations(function () {
                vm.sipTDay = vm.inSchemeValidations && vm.inSchemeValidations.sipTDay ? vm.inSchemeValidations.sipTDay: 17;
                fetchPaymentModes(function () {
                  cb(true);
                })
              })
            } else {
              fetchPaymentModes(function () {
                cb(true);
              })
            }
          }

          LoaderService.hideLoader();
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
          if (vm.successBackUrl) {
            $window.location.href = vm.redirectUrl;
          } else {
            $state.go("login");
          }
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };

      LoaderService.showLoader();

      var payload = {
        transactionId : vm.linkID,
        apiGatewayFlow : vm.sourcePortal === 'API_GATEWAY',
        transactionType: $stateParams.type
      }

      if ($stateParams.type && $stateParams.type === 'SIPPURCHASE') {
        investorServiceVersion.get({
          child1: 'cart',
          child2: 'get',
          child3: 'saved',
          child4: 'item',
          child5: $stateParams.linkId
        }).$promise.then(success, error);
      } else {
        InvestorService.post({
          child1: 'transaction',
          child2: 'saved',
          child3: 'data',
          child4: 'summary'
        },payload).$promise.then(success, error);
      }


    }

    /**
     * Function responsible for setting form data from summary saved data response
     */

    function setInitialFormData() {
      vm.formData.investmentType = vm.savedData.summaryType;
      vm.formData.purchaseInSchemeName = vm.savedData.schemeName;
      vm.formData.investorName = vm.savedData.investorName;
      vm.formData.secretLink = vm.savedData.secretLink;
      vm.formData.journey = vm.savedData.journey;
      if (vm.formData.investmentType === 'PURCHASE') {
        vm.formData.purchaseAmount = vm.savedData.amount;
        $window.NumToWord(vm.formData.purchaseAmount, 'TransactionPaymentInWord', vm.formData);
        vm.formData.purchaseInSchemeCode = vm.savedData.schemeCode;
      } else if (vm.formData.investmentType === 'SIP') {
        vm.formData.inSchemeName = vm.savedData.schemeName;
        vm.formData.amount = vm.savedData.amount;
        $window.NumToWord(vm.formData.amount, 'TransactionPaymentInWord', vm.formData);
        vm.formData.inSchemeCode = vm.savedData.schemeCode;
        vm.formData.startDate = vm.savedData.sipDate;
        vm.formData.day = vm.formData.startDate ? $window.moment(vm.formData.startDate, "DD-MMM-YYYY").format('D') : '';
        vm.formData.endDate = vm.savedData.sipEndDate;
        vm.formData.frequency = vm.savedData.sipFrequency;
        if (vm.formData.frequency === 'OW') {
          vm.formData.weeklyDay = vm.savedData.weeklyDay ? vm.savedData.weeklyDay : $window.moment(vm.formData.startDate, "DD-MMM-YYYY").format('dddd');
        }
        if (vm.savedData.topupDetails) {
          vm.formData.sipTopupEnabled = true;
          vm.formData.topupDetails = vm.savedData.topupDetails;

          if (vm.formData.topupDetails.capMonthYear && vm.formData.topupDetails.capAmount) {
            delete vm.formData.topupDetails.capAmount;
            vm.formData.topupDetails.capMonthYear = $window.moment(vm.formData.topupDetails.capMonthYear,'YYYY-MM-DD').format('DD-MMM-YYYY');
          }
        }
        vm.formData.sipFirstInstallment = vm.savedData.sipWithFirstInstallment ? vm.savedData.sipWithFirstInstallment : false;
        if (vm.formData.sipFirstInstallment) {
          vm.formData.inSchemeName = vm.savedData.schemeName;
          vm.formData.sipFirstAmount = vm.savedData.amount;
        }

        if (vm.savedData.cancelTransactionRequestBody) {
          vm.cancelTransactionRequestBody = {
            "transactionId": vm.savedData.cancelTransactionRequestBody.transactionId,
            "transactionType": vm.savedData.cancelTransactionRequestBody.transactionType
          };
        }
      }
      vm.formData.folioNumber = vm.savedData.folioNumber;
      vm.formData.investorType = vm.savedData.investorType;
      vm.formData.liquidFlag = vm.savedData.liquidSchemeFlag;
      if (vm.savedData.distributorDetails && !vm.savedData.distributorDetails.riaOpted && vm.savedData.distributorDetails.arnNo && vm.savedData.distributorDetails.arnNo.includes('ARN')) {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
        vm.investThrough = 'Distributor';
      } else if (vm.savedData.distributorDetails && vm.savedData.distributorDetails.riaOpted && vm.savedData.distributorDetails.arnNo && vm.savedData.distributorDetails.arnNo.includes('INA')) {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
        vm.formData.riaBrokerCode = vm.savedData.distributorDetails.arnNo;
        vm.formData.riaBrokerName = vm.savedData.distributorDetails.name ? vm.savedData.distributorDetails.name : '';
        vm.investThrough = 'RIA';
      } else {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = true;
        vm.formData.isThroughRia = false;
        vm.investThrough = 'DIRECT';
      }
      vm.formData.euin = {};
      if (vm.savedData.euinCode && vm.savedData.euinName) {
        vm.formData.euin.euinCode= vm.savedData.euinCode;
        vm.formData.euin.euinName = vm.savedData.euinName;
      }
      vm.formData.subBrokerARN = vm.savedData.distributorDetails && vm.savedData.distributorDetails.subBrokerArn;
      if (vm.formData.subBrokerARN && !vm.formData.subBrokerARN.includes('ARN')){
        vm.formData.subBrokerARN = 'ARN-' + vm.formData.subBrokerARN
      }
      vm.formData.subBrokerCode =  vm.savedData.distributorDetails && vm.savedData.distributorDetails.subBrokerCode;
      vm.formData.brokerCode = vm.savedData.distributorDetails && vm.savedData.distributorDetails.arnNo;
      if (vm.formData.brokerCode && !vm.formData.brokerCode.includes('ARN')){
        vm.formData.brokerCode = 'ARN-' + vm.formData.brokerCode;
      }
      vm.formData.transactionId = vm.savedData.transactionId;
      vm.formData.minorFlag = vm.savedData.isMinor;
      vm.formData.dividendOption = vm.savedData.dividendOption;
      if (vm.formData.dividendOption !== 'Z') {
        vm.formData.investmentOption = vm.savedData.investmentOption ? vm.savedData.investmentOption.toUpperCase()  : 'DIVIDEND';
      } else if (vm.formData.dividendOption === 'Z') {
        vm.formData.investmentOption = vm.savedData.investmentOption ? vm.savedData.investmentOption.toUpperCase() : 'GROWTH';
      }
      vm.formData.retirementAgeProofURL = vm.savedData.retirementAgeProofURL;
      sessionStorage.setItem('pd', encodeURI(JSON.stringify({
        "panNumber": vm.savedData.panNumber
      })));
      vm.formData.upiLimit = vm.savedData.upiMaxAmountLimit;
      vm.formData.upiErrorMessage = vm.savedData.upiMaxAmountErrMessage;
      if (vm.sourcePortal && vm.sourcePortal === 'WHATSAPP') {
        vm.successBackUrl = AppConstants.TRANSACTIONS.WHATSAPP_DEEP_LINK;
      } else if (vm.sourcePortal && vm.sourcePortal === 'INVESTOR') {
        vm.successBackUrl =  'main.transaction' + vm.formData.investmentType === 'PURCHASE' ? 'purchase' : 'sip';
      } else if (vm.savedData && vm.savedData.homeRedirectUrl) {
        vm.successBackUrl = vm.savedData.homeRedirectUrl;
      }
      if (vm.savedData.logo) {
        $scope.$emit('showNewLogo',vm.savedData.logo);
      }
      if (vm.savedData.profileImageUrl) {
        vm.profileImageUrl = vm.savedData.profileImageUrl;
      } else {
        vm.profileImageUrl = '../../../../assets/images/icons/default-user-icon.svg'
      }

      if (vm.sourcePortal && vm.sourcePortal === 'INVESTOR') {
        var secretLink = sessionStorage.getItem('sl');
        vm.secretLink = angular.copy(secretLink);
      }

      sessionStorage.setItem('redirectUrl',vm.successBackUrl);

    }


    function fetchPaymentModes(cb) {
      cb = cb || function () {}

      var success = function (resp) {
        if (resp.status && resp.data) {

          var dynamicPaymentOptions = resp.data.PAYMENT_MODES;

          vm.dynamicPaymentOptionArray = dynamicPaymentOptions.sort(function(a,b) {
            return a.order - b.order;
          });

          cb(true);

        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      } , error = function (resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      }

      var flowName = angular.copy(vm.formData.investmentType);

      if (vm.formData.investmentType === 'SIP' && vm.formData.sipFirstInstallment) {
        flowName = 'SIP_FI';
      } else if (vm.isSipPurchase) {
        flowName = 'SIP_PURCHASE';
      }

      InvestorService.post({
        child1: 'all',
        child2: 'payment',
        child3:'mode'
      }, {
        "portal": vm.sourcePortal,
        "flowName" : flowName
      }).$promise.then(success, error);



    }

    /**
     * Function responsible for initial function calls for PURCHASE
     */

    function initPurchase() {
      // payment options set

      getInvestorInfo(function () {
        getDetails(function () {
          fetchBankListPurchase(0);
        });
      });

      getAccountType();

    }

    /**
     * Function responsible for initial function calls for SIP
     */

    function initSip() {
      vm.paymentOptions = [];

      getInvestorInfo(function () {
        getDetails(function () {
          fetchBankListSIP(0);
        });
      });

      getAccountType();
    }

    /**
     * Function responsible for fetching investor info
     */

    function getInvestorInfo(cb) {
      cb = cb ||function () {

      };
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
        } else {
          vm.investorInfo = null;
          MessageService.error(resp.message);
        }
        cb();
      }, error = function (err) {
        UtilService.errorHandler(err);
        vm.investorInfo = null;
        cb();
      };
      InvestorService.get({
        child1: 'folio',
        child3: 'info'
      }).$promise.then(success, error);
    }

    /**
     * Function responsible for fetching folio details
     */

    function getDetails(cb) {
      cb = cb ||function () {
      };
      var success = function (resp) {
        var bankDetails=[];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if(vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length>0){
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if(value.defaultBank===true){return value;}
          });
        }
        localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
        cb();
      }, error = function () {
        LoaderService.hideLoader();
        cb();
      };

      LoaderService.showLoader();
      InvestorService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }

    /**
     * Function responsible for fetching account type list
     */

    function getAccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.formData.investorType
      }).$promise.then(success, error);
    }

    /**
     * Function responsible for handling purchase payment option change
     * @param {Object} value : selected payment option object
     */

    function changedPaymentOptionPurchase(value) {
      // vm.activeIndex = index;
      vm.formData.selectedPaymentOption = value.key;
      vm.isCheckedDeclaration = false;
      vm.formData.paymentInfo = {amount: vm.formData.purchaseAmount};
      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isInvalidForm = false;
      vm.fileType='';
      vm.bankchequeLeafUrl = null;
      vm.isNewPayment = true;
      vm.formData.paymentInfo.chequeLeaf = null;
      vm.bankInfo = null;
      vm.camsCode = value.camsCode;

      switch (vm.formData.selectedPaymentOption) {
        case vm.PAYMENT_OPTIONS.NETBANKING:
          resetUPIForm();
          vm.bankInfoUPI = null;

          if(vm.netBankingBankList && vm.netBankingBankList.length === 1) {
            vm.bankInfo = vm.netBankingBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          }

          vm.formData.paymentInfo.paymentMode = value.camsCode;

          break;
        case vm.PAYMENT_OPTIONS.OTM:
          resetUPIForm();
          vm.bankInfoUPI = null;

          if(vm.otmBankList && vm.otmBankList.length === 1) {
            vm.bankInfo = vm.otmBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          }

          vm.formData.paymentInfo.paymentMode = value.camsCode;
          break;
        case vm.PAYMENT_OPTIONS.RTGS:
          resetUPIForm();
          vm.bankInfoUPI = null;
          if(vm.isNewPayment && vm.NEFTRTGSBankList && vm.NEFTRTGSBankList.length === 1) {
            vm.bankInfo = vm.NEFTRTGSBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          }
          vm.formData.paymentInfo.paymentMode = value.camsCode;
          if(vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
            vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
          }
          break;
        case vm.PAYMENT_OPTIONS.HDFC:
          resetUPIForm();
          vm.bankInfoUPI = null;
          vm.formData.paymentInfo.paymentMode = value.camsCode;
          resetCheckLeaf();
          break;
        case vm.PAYMENT_OPTIONS.UPI:
          // resetUPIForm();
          if(vm.formData.purchaseAmount > vm.formData.upiLimit) {
            var success = function() {
              vm.formData.selectedPaymentOption = vm.paymentOptions[1];
              selectPaymentOption(vm.formData.selectedPaymentOption,1);
            }
            ModalService.genericModal({
              text: vm.formData.upiErrorMessage,
              isUpi: true,
              showBlueBtn: true
            },success);
          } else {
            if(vm.UPIBankList && vm.UPIBankList.length === 1) {
              vm.bankInfoUPI = vm.UPIBankList[0];
              $timeout(function() {
                vm.changeBank();
                selectedUpiBank();
              });
            }
            vm.formData.paymentInfo.paymentMode = "WEB";
            vm.formData.paymentInfo.webMode = value.camsCode;
          }

          break;
      }
    }

    /**
     * Function responsible for handling NEFT/RTGS toggle change
     */

    function changeRtgsPaymentOption() {
      vm.tForm.$setPristine();
      vm.fileType = null;
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankName){
        vm.formData.paymentInfo.bankName = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankBranch){
        vm.formData.paymentInfo.bankBranch = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.accNo){
        vm.formData.paymentInfo.accNo = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankAcType){
        vm.formData.paymentInfo.bankAcType = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyBankAcNo || (vm.formData.paymentInfo.verifyBankAcNo == undefined)){
        vm.formData.paymentInfo.verifyBankAcNo = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.ifscCode || (vm.formData.paymentInfo.ifscCode == undefined)){
        vm.formData.paymentInfo.ifscCode = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.utrNumber){
        vm.formData.paymentInfo.utrNumber = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyUtrNumber || (vm.formData.paymentInfo.verifyUtrNumber == undefined)){
        vm.formData.paymentInfo.verifyUtrNumber = null;
      }
      if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
        vm.formData.paymentInfo.chequeLeaf = null;
      }
      if (vm.isNewPayment) {
        vm.bankInfo = null;
        vm.bankInfoUPI = null;
        vm.isAccTypeFieldDisabled = false;
        resetCheckLeaf();

        if(vm.NEFTRTGSBankList && vm.NEFTRTGSBankList.length === 1) {
          vm.bankInfo = vm.NEFTRTGSBankList[0];
          $timeout(function() {
            vm.changeBank();
          });
        }

        if(vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
          vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
        }
      } else {
        // vm.formData.paymentInfo.utrNumber = null;
        // vm.formData.paymentInfo.verifyUtrNumber = null;
        vm.formData.paymentInfo.chequeLeaf = null
        // vm.formData.paymentInfo = null;
        vm.bankChequeLeaf = null;
        vm.bankInfo = null;
        vm.bankInfoUPI = null;
      }
    }

    /**
     * Function responsible for handling sip payment option change
     * @param {Object} value : selected payment option object
     */

    function changedSipPaymentOption(value){
      vm.formData.selectedPaymentOption = value.key;
      vm.camsCode = value.camsCode;
      var virtualAddress = vm.formData.paymentInfo && vm.formData.paymentInfo.virtualAddress && angular.copy(vm.formData.paymentInfo.virtualAddress);
      vm.formData.paymentInfo = null;
      vm.startDateValidation = false;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      vm.isCheckedDeclaration = false;
      vm.isCheckedTNC = false;
      vm.bankInfo = null;
      vm.formData.paymentInfo = {amount: vm.formData.amount};
      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isInvalidForm = false;
      vm.isInvalidFormFI = false;
      vm.isNewPayment = true;
      vm.isCheckedTandCeMandate = false;

      switch (vm.formData.selectedPaymentOption) {
        case vm.PAYMENT_OPTIONS.EC:
          vm.formData.paymentInfo.paymentMode = value.camsCode;
          resetUPIForm();
          vm.bankInfoUPI = null;
          if(vm.billerBankList && vm.billerBankList.length === 1) {
            vm.bankInfo = vm.billerBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          }
          break;
        case vm.PAYMENT_OPTIONS.OTM:
          vm.formData.paymentInfo.paymentMode = value.camsCode;
          resetUPIForm();
          vm.bankInfoUPI = null;
          if(vm.otmBankList && vm.otmBankList.length === 1) {
            vm.bankInfo = vm.otmBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          }
          break;
        case vm.PAYMENT_OPTIONS.EMANDATE:
          vm.formData.paymentInfo.paymentMode = value.camsCode;
          resetUPIForm();
          vm.bankInfoUPI = null;
          if(vm.mandateBankList && vm.mandateBankList.length === 1) {
            vm.bankInfo = vm.mandateBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          }
          vm.formData.authMode = vm.bankInfo ? vm.bankInfo.authenticationModes[0] : null;
          vm.authenticationMode = vm.bankInfo ? vm.bankInfo.authenticationModes: null;
          vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
          vm.changeEndDateEmandate(vm.formData.endDateEmandate);
          if (vm.emandateObj) {
            vm.formData.emandateAmount = Math.floor(vm.emandateObj.defaultMandateAmount);
            vm.formData.displayAmountMandate = parseInt(vm.formData.emandateAmount.toString().replaceAll(",", "")).toLocaleString('en-IN');
            checkAmountValidationEmandate();
          }
          break;
        case vm.PAYMENT_OPTIONS.UPISIP:
          vm.formData.paymentInfo.paymentMode = value.camsCode;
          if (virtualAddress) {
            vm.formData.paymentInfo.virtualAddress = angular.copy(virtualAddress);
          }
          if(vm.UPIBankList && vm.UPIBankList.length === 1) {
            vm.bankInfoUPI = vm.UPIBankList[0];
            $timeout(function() {
              vm.changeBank();
              selectedUpiBank();
            });
          }


          if (vm.isSipPurchase) {
            if (vm.formData.sipAmount > vm.formData.upiLimit || vm.formData.purchaseAmount > vm.formData.upiLimit) {

              if ((vm.formData.sipAmount > vm.formData.upiLimit && vm.formData.purchaseAmount > vm.formData.upiLimit) || vm.formData.purchaseAmount > vm.formData.upiLimit) {
                vm.formData.upiErrorMessage =  vm.savedData.sipSettings.upiMaxAmountErrMessage;
              } else if (vm.formData.sipAmount > vm.formData.upiLimit) {
                vm.formData.upiErrorMessage =  vm.savedData.sipSettings.sipUPIMaxAmountErrMessage;
              }

              var success = function() {

                if (vm.paymentOptions.length > 1) {
                  vm.formData.selectedPaymentOption = vm.paymentOptions[1];
                  selectPaymentOption(vm.formData.selectedPaymentOption,1);
                } else {
                  vm.formData.selectedPaymentOption = null;
                  vm.activeIndex = null;
                }
              }
              ModalService.genericModal({
                text: vm.formData.upiErrorMessage,
                isUpi: true,
                showBlueBtn: true
              },success);
            }
          } else if(vm.formData.amount > vm.formData.upiLimit) {
            var success = function() {
              if (vm.paymentOptions.length > 1) {
                vm.formData.selectedPaymentOption = vm.paymentOptions[1];
                selectPaymentOption(vm.formData.selectedPaymentOption,1);
              } else {
                vm.formData.selectedPaymentOption = null;
                vm.activeIndex = null;
              }
            }
            ModalService.genericModal({
              text: vm.formData.upiErrorMessage,
              isUpi: true,
              showBlueBtn: true
            },success);
          } else {
            vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
            vm.changeEndDateEmandate(vm.formData.endDateEmandate);
            if (vm.emandateObj) {
              vm.formData.emandateAmount = Math.floor(vm.emandateObj.defaultMandateAmount);
              vm.formData.displayAmountMandate = parseInt(vm.formData.emandateAmount.toString().replaceAll(",", "")).toLocaleString('en-IN');
              checkAmountValidationEmandate();
            }
          }

          break;
        case vm.PAYMENT_OPTIONS.NETBANKING:
          resetUPIForm();
          vm.bankInfoUPI = null;
          vm.formData.paymentInfo.paymentMode = value.camsCode;
          if(vm.netBankingBankList && vm.netBankingBankList.length === 1) {
            vm.bankInfo = vm.netBankingBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          }

          break;
        default :

      }
    }

    /**
     * Function responsible for checking mandate end date validation - sip date is less then mandate date in case of emandate payment option
     */

    function changeEndDateEmandate(date) {
      vm.formData.endDateEmandate = date ? date : null;
      if (vm.formData.endDate) {
        vm.sipDateLessEmandate =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
      }
    }

    function checkAmountValidationEmandate(calledFromHtml) {

      if (calledFromHtml) {
        var amountObj = UtilService.amountInComma(vm.formData.displayAmountMandate);
        vm.formData.emandateAmount = amountObj.amount;
        vm.formData.displayAmountMandate = parseInt(vm.formData.emandateAmount.toString().replaceAll(",", "")).toLocaleString('en-IN');
      }

      vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
      vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
      vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.formData.amount ? true : false;
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
    }


    /**
     * Function responsible for setting bank list for net banking , UPI and NEFT/RTGS
     */

    function fetchBankListPurchase(index) {
      LoaderService.showLoader();

      var transactionType = angular.copy(vm.dynamicPaymentOptionArray[index].key);

      var ApiConfig =  vm.apiConfig.COMMON;

      var ApiPayload = {
        trnxType: vm.formData.investmentType,
        folioNumber: vm.formData.folioNumber,
        liquidSchemeFlag: vm.formData.liquidFlag
      }


      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var bankList = resp.data.bankList;

          if (transactionType === vm.PAYMENT_OPTIONS.OTM) {
            vm.otmList = resp.data;
            bankList = angular.copy(vm.formData.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList);
            if (bankList.length !== 0 && !vm.formData.liquidFlag) {

              // filtering otm bank list with validations

              var flow = vm.formData.sipFirstInstallment ? 'FI' : '';
              bankList.forEach(function (bankInfo) {
                checkOTMAmountAndDate(flow,bankInfo);
              })

              if (vm.otmBankList && vm.otmBankList.length > 0) {
                vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
              }

            }

            // incrementing index for next call
            index = index + 1;

            // if index exceeds length of payment options , break flow
            if (index < vm.dynamicPaymentOptionArray.length) {
              fetchBankListPurchase(index);
            } else {
              checkPaymentOptionNotSelected();
              LoaderService.hideLoader();
              vm.showLoader = false;
            }

          }

          if(transactionType === vm.PAYMENT_OPTIONS.NETBANKING){

            var netbankingList = bankList;

            if (bankList.length !== 0) {
              netbankingList.forEach(function (bank) {
                if (bank.tpvEnableFlag === 'Y') {
                  bank.maskedBankName = angular.copy(bank.bankNameOnly + '-' + bank.maskedAccountNumber);
                  vm.netBankingBankList.push(bank);
                }
              })
              vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
            }

            // incrementing index for next call
            index = index + 1;

            // if index exceeds length of payment options , break flow
            if (index < vm.dynamicPaymentOptionArray.length) {
              fetchBankListPurchase(index);
            } else {
              checkPaymentOptionNotSelected();
              LoaderService.hideLoader();
              vm.showLoader = false;
            }
          }

          if (transactionType === vm.PAYMENT_OPTIONS.RTGS) {
            vm.NEFTRTGSBankList = bankList;

            if (vm.NEFTRTGSBankList && vm.NEFTRTGSBankList.length !== 0) {
              vm.NEFTRTGSBankList.forEach(function (bank) {
                bank.maskedBankName = angular.copy(bank.bankNameOnly + '-' + bank.maskedAccountNumber);
              });
              vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
            }

            // incrementing index for next call
            index = index + 1;

            // if index exceeds length of payment options , break flow
            if (index < vm.dynamicPaymentOptionArray.length) {
              fetchBankListPurchase(index);
            } else {
              checkPaymentOptionNotSelected();
              LoaderService.hideLoader();
              vm.showLoader = false;
            }
          }


          if (transactionType === vm.PAYMENT_OPTIONS.UPI) {
            vm.UPIBankList = bankList;
            vm.upiPaymentModeObj = angular.copy(vm.dynamicPaymentOptionArray[index]);

            if (vm.UPIBankList && vm.UPIBankList.length > 0) {
              vm.UPIBankList.forEach(function (bank) {
                bank.maskedBankName = angular.copy(bank.bankNameOnly + '-' + bank.maskedAccountNumber);
              });
              vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
              vm.activeIndex = index;
              changedPaymentOptionPurchase(vm.upiPaymentModeObj);
            }

            // incrementing index for next call
            index = index + 1;

            // if index exceeds length of payment options , break flow
            if (index < vm.dynamicPaymentOptionArray.length) {
              fetchBankListPurchase(index);
            } else {
              checkPaymentOptionNotSelected();
              LoaderService.hideLoader();
              vm.showLoader = false;
            }
          }


          // if last index hide loader
          if (index === vm.dynamicPaymentOptionArray.length - 1) {
            LoaderService.hideLoader();
            vm.showLoader = false;
          }

        } else {
          LoaderService.hideLoader();
          // MessageService.error(resp.message);
          handleErrorCallback(index);
        }
      }, error = function (resp) {
        LoaderService.hideLoader();
        // MessageService.error(resp.message);
        handleErrorCallback(index);
      }

      switch (transactionType) {
        case vm.PAYMENT_OPTIONS.UPI:
          if (vm.UPIBankList === null)  {
            if (vm.formData.investmentType === 'SIP') {
              ApiPayload.sipUpiFlow = true;
            }
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          } else if (vm.UPIBankList && vm.UPIBankList.length === 1) {
            vm.bankInfoUPI = vm.UPIBankList[0];
            $timeout(function() {
              vm.changeBank();
              selectedUpiBank();
            });
          }
          LoaderService.hideLoader();
          break;
        case vm.PAYMENT_OPTIONS.NETBANKING:
          if (vm.netBankingBankList && vm.netBankingBankList.length === 0)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          } else if (vm.netBankingBankList && vm.netBankingBankList.length === 1) {
            vm.bankInfo = vm.netBankingBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          }
          LoaderService.hideLoader();
          break;
        case vm.PAYMENT_OPTIONS.RTGS:
          ApiPayload.neftFlag = true;
          if (vm.NEFTRTGSBankList === null)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          } else if (vm.NEFTRTGSBankList && vm.NEFTRTGSBankList.length === 1) {
            vm.bankInfo = vm.NEFTRTGSBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          }
          LoaderService.hideLoader();
          break;
        case vm.PAYMENT_OPTIONS.OTM:
          if (vm.otmBankList && vm.otmBankList.length === 0 && !vm.formData.liquidFlag)  {

            ApiConfig = vm.apiConfig.OTM;

            var ApiPayloadOTM = {
              transactionType : vm.formData.investmentType.toLowerCase(),
              folioNo: vm.formData.folioNumber
            }

            InvestorService.post(ApiConfig, ApiPayloadOTM).$promise.then(success, error);
          } else if (vm.otmBankList && vm.otmBankList.length === 1 && !vm.formData.liquidFlag) {
            vm.bankInfo = vm.otmBankList[0];
            $timeout(function() {
              vm.changeBank();
            });
          } else {
            // incrementing index for next call
            index = index + 1;

            // if index exceeds length of payment options , break flow
            if (index < vm.dynamicPaymentOptionArray.length) {
              fetchBankListPurchase(index);
            } else {
              LoaderService.hideLoader();
              vm.showLoader = false;
            }
          }
          LoaderService.hideLoader();
          break;
        case vm.PAYMENT_OPTIONS.HDFC:
          vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);


          // incrementing index for next call
          index = index + 1;

          // if index exceeds length of payment options , break flow
          if (index < vm.dynamicPaymentOptionArray.length) {
            fetchBankListPurchase(index);
          } else {
            checkPaymentOptionNotSelected();
            LoaderService.hideLoader();
            vm.showLoader = false;
          }

          // if last index hide loader
          if (index === vm.dynamicPaymentOptionArray.length - 1) {
            checkPaymentOptionNotSelected();
            LoaderService.hideLoader();
            vm.showLoader = false;
          }

          break;
      }
    };

    /**
     * Function responsible for setting bank list SIP
     * @param {Number} index : current index of payment option for which bank list have to be fetched
     */

    function fetchBankListSIP(index) {

      var transactionType = angular.copy(vm.dynamicPaymentOptionArray[index].key);

      LoaderService.showLoader();

      var ApiConfig =  vm.apiConfig.COMMON;

      var ApiPayload = {
        trnxType: 'PURCHASE',
        folioNumber: vm.formData.folioNumber,
        liquidSchemeFlag: vm.formData.liquidFlag,
        sipFlow : true
      }

      LoaderService.showLoader();

      var success = function (resp) {

        if (resp.status && resp.data) {

          if (transactionType === vm.PAYMENT_OPTIONS.EC) {
            vm.billerBankList =  resp.data.bankList ? resp.data.bankList : [];
            if (vm.billerBankList && vm.billerBankList.length > 0 && vm.formData.frequency !== 'OW' && vm.formData.frequency !=='BZ') {
              vm.billerBankList.forEach(function (bank) {
                bank.maskedBankName = angular.copy(bank.bankNameOnly + '-' + bank.maskedAccountNumber);
              });

              var sipRequiredDate = new Date($window.moment(new Date()).format("DD-MMM-YYYY"));
              var addDays = vm.sipTDay;
              sipRequiredDate.setDate(sipRequiredDate.getDate()+addDays);
              var startDate = new Date(vm.formData.startDate);
              if(startDate>= sipRequiredDate){
                vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
              }
              // else if (vm.sourcePortal && vm.sourcePortal !== 'WHATSAPP') {
              //   vm.showDatesManupilateError = true;
              //   vm.billerDateRequired = angular.copy(sipRequiredDate);
              //   vm.displayDate =  angular.copy($window.moment(sipRequiredDate).format('DD-MM-YYYY').toString());
              //   vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
              // }

            }

            // incrementing index for next call
            index = index + 1;

            // if index exceeds length of payment options , break flow
            if (index < vm.dynamicPaymentOptionArray.length) {
              fetchBankListSIP(index);
            } else {
              checkPaymentOptionNotSelected();
              LoaderService.hideLoader();
              vm.showLoader = false;
            }

          }

          if (transactionType === vm.PAYMENT_OPTIONS.OTM) {
            vm.otmList = resp.data;

            var bankList = angular.copy(vm.formData.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList);
            if (bankList && bankList.length > 0) {

              // filtering otm bank list with validations

              var flow = vm.formData.sipFirstInstallment ? 'FI' : '';
              bankList.forEach(function (bankInfo) {
                checkOTMAmountAndDate(flow,bankInfo);
              })


              if (vm.otmBankList && vm.otmBankList.length > 0 && ((vm.formData.sipFirstInstallment  && !vm.formData.liquidFlag) || (!vm.formData.sipFirstInstallment && !vm.isSipPurchase) || (vm.isSipPurchase && !vm.formData.liquidFlag))) {
                vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
              }

            }

            // incrementing index for next call
            index = index + 1;
            // if index exceeds length of payment options , break flow
            if (index < vm.dynamicPaymentOptionArray.length) {
              fetchBankListSIP(index);
            } else {
              checkPaymentOptionNotSelected();
              LoaderService.hideLoader();
              vm.showLoader = false;
            }
          }

          if(transactionType === vm.PAYMENT_OPTIONS.EMANDATE){
            vm.folioEmandateStatus = resp.data.folioEmandateStatus;
            vm.emailExist = resp.data.emailExist;
            vm.mobileExist = resp.data.mobileExist;
            vm.isEmailMobileinValid = !vm.emailExist && !vm.mobileExist;
            vm.mandateBankList =  resp.data.bankList ? resp.data.bankList : [];

            if (vm.mandateBankList && vm.mandateBankList.length > 0) {
              vm.mandateBankList.forEach(function (bank) {
                bank.maskedBankName = angular.copy(bank.bankNameOnly + '-' + bank.maskedBankAcNo);
              });
            }

            if (!vm.emandateObj && !vm.upiObj) {
              UtilService.fetchMandateValidations(true).then(function (resp) {
                vm.emandateObj = resp.eOTM;
                vm.upiObj = resp.upi;
                setEmandateUpiSetting();

                if (vm.endDateEmandateBoundExist && !vm.formData.sipFirstInstallment && vm.mandateBankList && vm.mandateBankList.length > 0 && vm.folioEmandateStatus && !vm.formData.sipTopupEnabled) {
                  vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
                }

                // incrementing index for next call
                index = index + 1;
                // if index exceeds length of payment options , break flow
                if (index < vm.dynamicPaymentOptionArray.length) {
                  fetchBankListSIP(index);
                } else {
                  checkPaymentOptionNotSelected();
                  LoaderService.hideLoader();
                  vm.showLoader = false;
                }

              }).catch(function(resp) {
                updateEmandateEndDate();

                if (vm.endDateEmandateBoundExist && !vm.formData.sipFirstInstallment && vm.mandateBankList && vm.mandateBankList.length > 0 && vm.folioEmandateStatus && !vm.formData.sipTopupEnabled) {
                  vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
                }

                // incrementing index for next call
                index = index + 1;
                // if index exceeds length of payment options , break flow
                if (index < vm.dynamicPaymentOptionArray.length) {
                  fetchBankListSIP(index);
                } else {
                  checkPaymentOptionNotSelected();
                  LoaderService.hideLoader();
                  vm.showLoader = false;
                }

              });
            } else {

              if (vm.endDateEmandateBoundExist && !vm.formData.sipFirstInstallment && vm.mandateBankList && vm.mandateBankList.length > 0 && vm.folioEmandateStatus && !vm.formData.sipTopupEnabled) {
                vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
              }

              // incrementing index for next call
              index = index + 1;
              // if index exceeds length of payment options , break flow
              if (index < vm.dynamicPaymentOptionArray.length) {
                fetchBankListSIP(index);
              } else {
                checkPaymentOptionNotSelected();
                LoaderService.hideLoader();
                vm.showLoader = false;
              }
            }

          }

          if (transactionType === vm.PAYMENT_OPTIONS.UPISIP) {
            vm.UPIBankList = resp.data.bankList ? resp.data.bankList : [];
            if (vm.UPIBankList && vm.UPIBankList.length > 0) {
              vm.UPIBankList.forEach(function (bank) {
                bank.maskedBankName = angular.copy(bank.bankNameOnly + '-' + bank.maskedAccountNumber);
              });
              if (!vm.emandateObj && !vm.upiObj) {
                UtilService.fetchMandateValidations(true).then(function (resp) {
                  vm.emandateObj = resp.eOTM;
                  vm.upiObj = resp.upi;
                  setEmandateUpiSetting();

                  vm.endDateEmandateBoundExistUPI = $window.moment(vm.formData.endDate,'DD-MMM-YYYY').isSameOrBefore(vm.maxEndDateEmandateUPI);

                  if (vm.endDateEmandateBoundExistUPI) {
                    vm.enableUPI = true;
                    vm.upiPaymentModeObj = angular.copy(vm.dynamicPaymentOptionArray[index]);
                    vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
                    vm.activeIndex = index;
                    vm.changedSipPaymentOption(vm.upiPaymentModeObj);
                  } else {
                    vm.enableUPI = false;
                  }


                  // incrementing index for next call
                  index = index + 1;
                  // if index exceeds length of payment options , break flow
                  if (index < vm.dynamicPaymentOptionArray.length) {
                    fetchBankListSIP(index);
                  } else {
                    LoaderService.hideLoader();
                    vm.showLoader = false;
                  }

                }).catch(function(resp) {
                  updateEmandateEndDate();
                  if (vm.formData.sipFirstInstallment) {
                    // incrementing index for next call
                    index = index + 1;
                    // if index exceeds length of payment options , break flow
                    if (index < vm.dynamicPaymentOptionArray.length) {
                      fetchBankListSIP(index);
                    } else {
                      checkPaymentOptionNotSelected();
                      LoaderService.hideLoader();
                      vm.showLoader = false;
                    }
                  } else {
                    // incrementing index for next call
                    index = index + 1;
                    // if index exceeds length of payment options , break flow
                    if (index < vm.dynamicPaymentOptionArray.length) {
                      fetchBankListSIP(index);
                    } else {
                      checkPaymentOptionNotSelected();
                      LoaderService.hideLoader();
                      vm.showLoader = false;
                    }
                  }
                });
              } else  {

                vm.endDateEmandateBoundExistUPI = $window.moment(vm.formData.endDate,'DD-MMM-YYYY').isSameOrBefore(vm.maxEndDateEmandateUPI);

                if (vm.endDateEmandateBoundExistUPI) {
                  vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
                }

                vm.formData.selectedPaymentOption = vm.paymentOptions[0];

                if (vm.paymentOptions && vm.paymentOptions.length > 0) {
                  changedSipPaymentOption(0);
                }

                // if index exceeds length of payment options , break flow
                if (index < vm.dynamicPaymentOptionArray.length) {
                  fetchBankListSIP(index);
                } else {
                  checkPaymentOptionNotSelected();
                  LoaderService.hideLoader();
                  vm.showLoader = false;
                }
              }

            }

          }

          if (transactionType === vm.PAYMENT_OPTIONS.NETBANKING) {

            var netbankingList = resp.data.bankList ? resp.data.bankList : [];

            netbankingList.forEach(function (bank) {
              if (bank.tpvEnableFlag === 'Y') {
                vm.netBankingBankList.push(bank);
              }
            })

            if (vm.netBankingBankList && vm.netBankingBankList.length > 0) {
              vm.netBankingBankList.forEach(function (bank) {
                bank.maskedBankName = angular.copy(bank.bankNameOnly + '-' + bank.maskedAccountNumber);
              });

              var sipRequiredDate = new Date($window.moment(new Date()).format("DD-MMM-YYYY"));
              var addDays = vm.sipTDay;
              sipRequiredDate.setDate(sipRequiredDate.getDate()+addDays);
              var startDate = new Date(vm.formData.startDate);
              if(startDate>= sipRequiredDate){
                vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
              }
              // else if (vm.sourcePortal && vm.sourcePortal !== 'WHATSAPP') {
              //   vm.showDatesManupilateError = true;
              //   vm.billerDateRequired = angular.copy(sipRequiredDate);
              //   vm.displayDate =  angular.copy($window.moment(sipRequiredDate).format('DD-MM-YYYY').toString());
              //   vm.paymentOptions.push(vm.dynamicPaymentOptionArray[index]);
              // }

            }

            vm.FIPaymentEmpty = vm.paymentOptions.length === 0 ? true : false;

            // incrrmenting index for next call
            index = index + 1;
            // if index exceeds length of payment options , break flow
            if (index < vm.dynamicPaymentOptionArray.length) {
              fetchBankListSIP(index);
            } else {
              checkPaymentOptionNotSelected();
              LoaderService.hideLoader();
              vm.showLoader = false;
            }
          }


          // if last index hide loader
          if (index === vm.dynamicPaymentOptionArray.length - 1) {
            LoaderService.hideLoader();
            vm.showLoader = false;
          }


        } else {
          LoaderService.hideLoader();
          // MessageService.error(resp.message);
          handleErrorCallback(index);
        }
      }, error = function (resp) {
        LoaderService.hideLoader();
        // MessageService.error(resp.message);
        handleErrorCallback(index);
      }

      switch (transactionType) {
        case vm.PAYMENT_OPTIONS.EC:
          if (vm.billerBankList === null)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          }
          LoaderService.hideLoader();
          break;
        case vm.PAYMENT_OPTIONS.OTM:
          ApiConfig = vm.apiConfig.OTM;

          ApiPayload = {
            transactionType : vm.formData.investmentType.toLowerCase(),
            folioNo: vm.formData.folioNumber
          }


          if (vm.isSipPurchase) {
            ApiPayload.transactionType = 'purchase';
            ApiPayload.newFolio = false;
          }

          if (vm.otmBankList && vm.otmBankList.length === 0)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          }
          LoaderService.hideLoader();
          break;
        case vm.PAYMENT_OPTIONS.EMANDATE:
          ApiConfig = vm.apiConfig.EMANDATE;
          ApiPayload.trnxType = 'SIP'
          delete ApiPayload.sipFlow;

          if (vm.mandateBankList === null)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          }
          LoaderService.hideLoader();
          break;
        case vm.PAYMENT_OPTIONS.UPISIP:
          delete ApiPayload.sipFlow;
          ApiPayload.sipUpiFlow = true;
          if (vm.UPIBankList === null)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          }
          LoaderService.hideLoader();
          break;
        case vm.PAYMENT_OPTIONS.NETBANKING:
          delete ApiPayload.sipFlow;
          if (vm.netBankingBankList && vm.netBankingBankList.length === 0)  {
            InvestorService.post(ApiConfig, ApiPayload).$promise.then(success, error);
          }
          LoaderService.hideLoader();
      }
    };


    function setEmandateUpiSetting() {
      vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
      vm.upiMaxYear = vm.upiObj.maxMandateDurationYears ? vm.upiObj.maxMandateDurationYears : vm.defaultMandateYearDate
      vm.eMandatenoOfDays = vm.emandateObj.noOfDays;
      vm.eMandatemaxAmountLimit = vm.emandateObj.maxAmountLimit;
      vm.emandateMinAmountLimit = vm.emandateObj.minAmountLimit;
      vm.formData.emandateAmount = Math.floor(vm.emandateObj.defaultMandateAmount);
      vm.formData.displayAmountMandate = parseInt(vm.formData.emandateAmount.toString().replaceAll(",", "")).toLocaleString('en-IN');
      checkAmountValidationEmandate();
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
      vm.mandateInfo = vm.emandateObj.mandateInfoBasket;
      vm.minEndDateGapMandate = vm.emandateObj.minEndDateGap;
      vm.mandateMaxString = vm.emandateObj.maxAmountLimitInfo;
      vm.formData.emandateDate = $window.moment().add(1,'days');
      vm.displayMandateDate = angular.copy(vm.formData.emandateDate.format('DD-MMM-YYYY'));
      updateEmandateEndDate();
    }

    /**
     * Function responsible for emandate end date validation
     */


    function updateEmandateEndDate() {

      if (!vm.formData.emandateDate) {
        return;
      }

      var enabledEndDates = [];

      if(vm.formData.emandateDate)
      {
        vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
        vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateMaxYear, 'years').subtract(1,'days');
        vm.maxEndDateEmandateUPI = $window.moment().add(vm.upiMaxYear, 'years').subtract(1,'days');
        vm.endDateEmandateBoundExist = $window.moment(vm.formData.endDate,'DD-MMM-YYYY').isSameOrBefore(vm.maxEndDateEmandate);
      }

      if (vm.endDateEmandateBoundExist || vm.endDateEmandateBoundExistUPI) {
        var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
        for (var i = 0; i <= freq; i++) {
          enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
        }
        vm.enabledEmandateEndDatesList = enabledEndDates;
        vm.endDateViewEmandate =  vm.minEndDateEmandate.clone();
        vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
      }
    }

    /**
     * Function responsible for handling bank change SIP and PURCHASE
     */

    vm.changeBank = function () {
      if (!vm.bankInfo) {
        return;
      }

      if(!vm.bankInfo) {
        vm.authenticationMode = null;
      }

      vm.isInvalidForm = false;
      switch (vm.formData.selectedPaymentOption) {
        case vm.PAYMENT_OPTIONS.NETBANKING:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            vm.isCheckedTNC = false;
            return;
          }
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType==""?null:vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          if (vm.bankInfo.tpvEnableFlag == 'Y') {
            getAccountNumber(vm.bankInfo.bankCode);
          }
          break;
        case vm.PAYMENT_OPTIONS.OTM:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            vm.isCheckedTNC = false;
            return;
          }
          vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
          vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
          vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
          vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
          vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType == "" ? null : vm.bankInfo.bankAcType;
          (angular.isDefined(vm.bankInfo.camsMandateIdNo))&&(vm.formData.paymentInfo.camsMandateIdNo=vm.bankInfo.camsMandateIdNo);
          // checkOTMAmountAndDate();
          break;
        case vm.PAYMENT_OPTIONS.UPI:
          if(!vm.bankInfoUPI.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            return;
          }
          vm.formData.paymentInfo.accType = vm.bankInfoUPI.bankAcType;
          vm.formData.paymentInfo.bankName = vm.bankInfoUPI.bankName;
          vm.formData.paymentInfo.ifscCode = vm.bankInfoUPI.ifscCode;
          break;
        case vm.PAYMENT_OPTIONS.RTGS:
          if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            vm.bankInfo = null;
            vm.isCheckedDeclaration = false;
            vm.isCheckedTNC = false;
            return;
          }
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode ? vm.bankInfo.bankCode : null;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor ? vm.bankInfo.gateWayVendor : null;
          if (vm.bankInfo.tpvEnableFlag == 'Y') {
            getAccountNumber(vm.bankInfo.bankCode);
          }
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly ? vm.bankInfo.bankNameOnly : null;
          vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch ? vm.bankInfo.bankBranch : null;
          vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber ? vm.bankInfo.accountNumber : null;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : null;
          vm.formData.paymentInfo.otherBank = true;
          vm.formData.paymentInfo.bankAcType = vm.bankInfo.bankAcType==""?null:vm.bankInfo.bankAcType;
          vm.formData.paymentInfo.utrNumber = null;
          vm.formData.paymentInfo.verifyUtrNumber = null;
          vm.formData.paymentInfo.verifyBankAcNo = null;
          vm.formData.paymentInfo.chequeLeaf = null;
          vm.bankChequeLeaf = null;
          vm.isAccTypeFieldDisabled = vm.formData.paymentInfo.bankAcType ? true : false;
          vm.tForm.$setPristine();
          if(!vm.bankInfo.bankAcType && vm.NRI_STATUS_CODES.includes(vm.formData.investorType)) {
            vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
          }


          var keyExists = false;

          if (vm.bankInfo.bankAcType) {
            for (var i = 0; i <  vm.bankTypeList.length; i++) {
              if (vm.bankTypeList[i].accountTypeCode === vm.bankInfo.bankAcType) {
                keyExists = true;
              }
            }

            if (!keyExists && vm.bankInfo.bankAcType) {
              vm.bankInfo.bankAcType = angular.copy(vm.bankTypeList[0]);
              vm.formData.paymentInfo.bankAcType = vm.bankTypeList[0].accountTypeCode;
            }

          }


          if(vm.isNewPayment && vm.bankInfo){
            $timeout(function () {
              vm.tForm.bankName.$setDirty();
              vm.tForm.bankBranch.$setDirty();
              vm.tForm.bankAcNo.$setDirty();
              vm.tForm.ifscCode.$setDirty();
              vm.tForm.accountType.$setDirty();
            })
            vm.bankChequeLeaf = 'No File Chosen';
            vm.bankchequeLeafUrl = null;
            vm.fileType = null;
            vm.chooseAFile = true;
          }else{
            $timeout(function () {
              vm.tForm.bankBranch.$dirty = false;
              vm.tForm.bankAcNo.$dirty = false;
              vm.tForm.bankName.$dirty = false;
              vm.tForm.ifscCode.$dirty = false;
              vm.tForm.accountType.$dirty = false;
            })
          }
          break;
        case vm.PAYMENT_OPTIONS.EC:
          vm.formData.netBankingUrl = vm.bankInfo ? vm.bankInfo.netBankingUrl : "";
          if (!vm.bankInfo.bankAcType) {
            getAccountType();
          }
          break;
        case vm.PAYMENT_OPTIONS.EMANDATE:
          vm.formData.authMode = vm.bankInfo ? vm.bankInfo.authenticationModes[0] : null;
          vm.authenticationMode = vm.bankInfo ? vm.bankInfo.authenticationModes: null;
          vm.formData.bankAcNo = vm.bankInfo ? vm.bankInfo.bankAcNo : '';
          vm.formData.emUmrn = vm.bankInfo ? vm.bankInfo.emUmrn : '';
          vm.formData.maxAmount = vm.bankInfo ? vm.bankInfo.maxAmount : '';
          vm.formData.emExpiryDate = vm.bankInfo ? vm.bankInfo.emExpiryDate : '';
          break;
        default :
          vm.bankInfo = null;
          vm.bankInfoUPI = null;
          break;
      }
    };


    /**
     * Function responsible for handling upi bank change
     */

    function selectedUpiBank() {
      if (!vm.bankInfoUPI) {
        return;
      }

      resetUPIForm();

      // set upi as payment mode on bank change
      if (vm.isIntent && vm.formData.investmentType === 'SIP') {
        vm.selectedUpiOption = 'PHONE_PE';
      } else {
        vm.selectedUpiOption = 'OTHERS';
      }

      if(!vm.bankInfoUPI.minorBankFlag && vm.checkForMinorBankListCondition()){
        ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
        vm.bankInfo = null;
        vm.bankInfoUPI = null;
        vm.isCheckedDeclaration = false;
        return;
      }
      vm.upiAccountNumber = vm.bankInfoUPI.accountNumber;
      vm.upiBankName = vm.bankInfoUPI.bankName;
      vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
    };

    /**
     * Function responsible for getting html form data
     */

    function getFormData(form) {
      vm.tForm = form;
    };

    /**
     * Function responsible for getting html form data upi
     */

    function getFormDataUpi(form) {
      vm.tFormUPI = form;
    };


    /**
     * Function responsible for handling pdf file download
     */

    function downloadPdfFile(url, fileType) {
      var success = function (resp){
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+fileType });
            FileSaver.saveAs(data, 'Cheque_Leaf.'+fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.downloadFile(payload, fileType, url).then(success, error);
    };

    /**
     * Function responsible for handling cheque leaf upload
     */

    function bankUploadChequeLeafFile(file,currentUi) {
      var fi;
      if (currentUi === 'web') {
        fi = document.getElementById('uploadCheckLeaf');
      } else if (currentUi === 'mobile') {
        fi = document.getElementById('uploadCheckLeaf1');
      }
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be PDF, TIF, TIFF, JPG and JPEG extension.");
        fi.value = '';
        return;
      }
      if(file) {
        if (fi.files.item(0).size <= 3145728) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.bankchequeLeafUrl = resp.data.fileUrl;
                vm.formData.paymentInfo.chequeLeaf = vm.bankchequeLeafUrl;
                vm.fileType = resp.data.type.toLowerCase();
                vm.fileName = file.name;
                vm.dateUploaded = $window.moment().format('DD-MMM-YYYY');
                var fileSize = angular.copy(fi.files.item(0).size);
                var fileSizeKB = fileSize / 1024;
                var fileSizeMB = fileSizeKB / 1024;
                if (fileSizeMB < 1) {
                  vm.displaySize = fileSizeKB.toFixed(2) + ' KB';
                } else {
                  vm.displaySize = fileSizeMB.toFixed(2) + ' MB';
                }
                breakFileUrl(vm.bankchequeLeafUrl);
              }
              else {
                vm.fileType = '';
                MessageService.error(resp.message);
                fi.value = '';
              }
            },
            error = function (err) {
              LoaderService.hideLoader(err);
              fi.value = '';
            };
          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            FileUploadServiceVersion2.post({
              child1: 'folio',
              child2: 'upload',
              child3: 'bankDetails',
              child4: 'chequeLeaf'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 3 MB.")
          fi.value = '';
          if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
            vm.formData.paymentInfo.chequeLeaf = null;
            vm.bankchequeLeafUrl = null;
            vm.fileType = null;
            vm.chooseAFile = true;
          }
        }
      }
    };

    /**
     * Function responsible for setting uploaded file url
     */

    function breakFileUrl(url) {
      vm.bankChequeLeaf = 'Preview Uploaded Leaf Doc';
      vm.fileType = url && url.split('_').reverse()[0].toLowerCase();
      vm.chooseAFile = false;
      vm.formData.paymentInfo.chequeLeaf = url;
      return;
    }

    /**
     * Function responsible for uploaded image preview
     */

    function openUploadedDoc() {
      if(angular.isUndefined(vm.formData.paymentInfo.chequeLeaf)){return;}
      ModalService.showImage({
        docUrl: vm.formData.paymentInfo.chequeLeaf,
        showBlueBtn: true
      });
    }

    /**
     * Function responsible for handling upi id verification
     */

    function verifyUPI() {
      vm.verifyUPIResp = {};
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.verifyUPIResp = resp.data;
            if (resp.data.valid) {
              vm.name = resp.data.name;
              vm.isUPIVerified = true;
            } else {
              vm.isUPIVerified = false;
            }
          }
          else {
            vm.isUPIVerified = false;
            vm.verifyUPIResp.valid = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();

      var payload = {
        "virtualAddress": vm.formData.paymentInfo.virtualAddress.toLowerCase()
      };

      if (vm.formData.investmentType === 'SIP') {
        payload.basketFlow = false;
        payload.folioNo = vm.formData.folioNumber;

        investorServiceVersion.post({
          child1: 'upi',
          child2: 'check',
          child3: 'virtualAddress'
        }, payload).$promise.then(success, error);

      } else {
        InvestorService.post({
          child1: 'upi',
          child2: 'check',
          child3: 'virtualAddress'
        }, payload).$promise.then(success, error);
      }
    }

    /**
     * Function responsible for checking OTM bank validations
     */

    function checkOTMAmountAndDate(flow,bankInfo) {

      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;

      vm.isOTMAmountFI = false;
      vm.isOTMDateFI = false;
      vm.isOTMStartDateFI = false;

      // Check Ammout
      if (vm.formData.purchaseAmount && (vm.formData.purchaseAmount > bankInfo.maxAmount)) {
        vm.isOTMAmount = true;
      } else if (vm.formData.purchaseAmount && (vm.formData.purchaseAmount < bankInfo.maxAmount)){
        vm.isOTMAmount = false;
      }

      if (flow !== "FI") {
        // Check Ammout SIP

        if (vm.isSipPurchase) {
          vm.maxAmount = vm.formData.purchaseAmount > vm.formData.sipAmount ? vm.formData.purchaseAmount : vm.formData.sipAmount;
        }

        var amountToCompare = vm.isSipPurchase ? vm.maxAmount : vm.formData.amount;


        if (amountToCompare && (amountToCompare > bankInfo.maxAmount)) {
          vm.isOTMAmount = true;
        } else if (amountToCompare && (amountToCompare < bankInfo.maxAmount)) {
          vm.isOTMAmount = false;
        }

        //Compare

        if (vm.formData.investmentType === 'SIP') {
          var dateToCompare = $window.moment(vm.formData.endDate,"DD-MMM-YYYY");
        } else {
          var dateToCompare = $window.moment();
        }

        if ($window.moment(bankInfo.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore(dateToCompare)) {
          vm.isOTMDate = true;
        }
        else {
          vm.isOTMDate = false;
        }


        if (vm.formData.investmentType === 'SIP' && !vm.isSipPurchase) {
          var dateToCompareSDate = angular.copy(vm.formData.startDate);
          if (!($window.moment(bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(dateToCompareSDate, 'DD-MMM-YYYY')))){
            vm.isOTMStartDate = true;
          }
          else{
            vm.isOTMStartDate = false;
          }
        } else {
          var dateToCompareSDate = angular.copy(vm.otmList.currentDate);
          if ($window.moment(bankInfo.omStartDate, 'DD-MMM-YYYY').isAfter($window.moment(dateToCompareSDate, 'DD-MMM-YYYY'))){
            vm.isOTMStartDate = true;
          }
          else{
            vm.isOTMStartDate = false;
          }
        }

      }

      if (flow === "FI") {
        // Check Ammout FI
        if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount > bankInfo.maxAmount)) {
          vm.isOTMAmountFI = true;
        } else if (vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount < bankInfo.maxAmount)) {
          vm.isOTMAmountFI = false;
        }

        //Compare Dates FI

        if ($window.moment(bankInfo.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDate,"DD-MMM-YYYY"))) {
          vm.isOTMDateFI = true;
        }
        else {
          vm.isOTMDateFI = false;
        }

        if ($window.moment(bankInfo.omStartDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.otmList.currentDate, 'DD-MMM-YYYY'))){
          vm.isOTMStartDateFI = true;
        }
        else{
          vm.isOTMStartDateFI = false;
        }

      }

      //Check for amount, dates

      if (vm.formData.investmentType === 'PURCHASE' || (vm.formData.investmentType === 'SIP' && !vm.formData.sipFirstInstallment)) {
        if (vm.isOTMAmount || vm.isOTMDate || vm.isOTMStartDate) {
          // vm.isInvalidForm = true;
        } else {
          // vm.isInvalidForm = false;
          bankInfo.maskedBankName = angular.copy(bankInfo.bankName + '-' + bankInfo.maskedBankAcNo);
          vm.otmBankList.push(bankInfo);
        }
      }

      if (vm.formData.investmentType === 'SIP' && vm.formData.sipFirstInstallment) {
        if (flow === "FI" && vm.formData.sipFirstInstallment && (vm.isOTMAmountFI || vm.isOTMDateFI || vm.isOTMStartDateFI)) {
          vm.isInvalidFormFI = true;
        } else {
          vm.isInvalidFormFI = false;
          bankInfo.maskedBankName = angular.copy(bankInfo.bankName + '-' + bankInfo.maskedBankAcNo);
          vm.otmBankList.push(bankInfo);
        }
      }

    }


    /**
     * Function responsible for opening tpv bank modal
     */

    function tpv(event) {
      event.preventDefault();
      ModalService.tpvModal({});
    }

    function getAccountNumber(bankCode,flow) {
      if(vm.investorInfo && vm.investorInfo.transactionFlowVersion === TrFlowType.NEW){
        vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
        vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
        return;
      }
      vm.bankAccounts = [];
      vm.isInvalidForm = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            vm.bankAccounts = resp.data.accountNumbers;
            if (vm.bankAccounts.length > 1) {
              var success = function (accountNo) {
                vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
                vm.formData.paymentInfo.accountNumber = accountNo;
                vm.isInvalidForm = false;
              }, error = function () {

              };
              ModalService.selectAccountNoModal({bankAccounts: vm.bankAccounts}, success, error);
            } else {
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankAccounts[0];
              vm.isInvalidForm = false;
            }
          } else {
            vm.isInvalidForm = true;
            MessageService.error(resp.message);
            vm.bankAccounts = [];
          }
        },
        error = function (err) {
          vm.bankAccounts = [];
          vm.isInvalidForm = true;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "bankCode": bankCode
      };
      InvestorService.post({
        child1: 'bank',
        child2: 'account'
      }, payload).$promise.then(success, error);
    }

    /**
     * Function responsible for resetting UPI fields
     */

    function resetUPIForm() {
      vm.verifyUPIResp = {};
      vm.isUPIVerified = false;
      vm.selectedUpiOption = null;
      (vm.formData.paymentInfo)&&(vm.formData.paymentInfo.virtualAddress = "");
      vm.tFormUPI && vm.tFormUPI.virtualAddress && vm.tFormUPI.virtualAddress.$setPristine();
    }

    /**
     * Function responsible for resetting cheque leaf
     */

    function resetCheckLeaf() {
      vm.bankchequeLeafUrl = null;
      vm.formData.paymentInfo.chequeLeaf = null;
      vm.bankChequeLeaf = null;
      vm.chooseAFile=true;
      angular.element("#uploadCheckLeaf").val("");
    }

    /**
     * Function responsible for checking minor bank condition currently it will always return false
     */

    vm.checkForMinorBankListCondition = function() {
      // if(vm.formData!=null && vm.formData.minorFlag!=null && vm.formData.cgfFlag!=null)
      //   return vm.formData.minorFlag && !vm.formData.cgfFlag;
      // else
      //   return false;
      return false;
    };

    /**
     * Function responsible for checking duplicate transaction
     */

    function checkDuplicate($event) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                transactionOtpConfirmation($event);
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({
                msg: resp.data.warningMessage,
                showBlueBtn: true
              }, successModal, errorModal)
            }
            else {
              if (vm.formData.selectedPaymentOption==='E_Mandate') {
                transactionOtpConfirmationEmandate($event);
              } else {
                transactionOtpConfirmation($event);
              }
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType: vm.formData.investmentType,
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.purchaseInSchemeCode,
        amount: vm.formData.purchaseAmount
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'transaction',
        child2: 'check',
        child3: 'duplicate'
      }, payload).$promise.then(success, error);
    };


    /**
     * Function responsible for handling 2FA
     */

    function transactionOtpConfirmation($event) {
      var otpSuccessCallback, otpDismissCallback;''

      otpSuccessCallback = function(resp) {
        LoaderService.hideLoader();
        submitForm($event);
      };

      otpDismissCallback = function(err) {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();

      var modalPayload;

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {

            vm.secretLink = resp.data.secretLink;

            if(vm.formData.secretLink !=  vm.secretLink){
              var otpDetails = {
                secretOtpLink : vm.secretLink,
                otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
                otpId : resp.data.id
              };

              var payload = {
                folioNumber:  vm.formData.folioNumber,
                formType : vm.formData.investmentType
              }

              if (vm.formData.selectedPaymentOption && vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.UPISIP && vm.formData.investmentType === 'SIP') {
                var noteUpiModal = vm.notesApiGateWayPayment.noteDTO.noteDTOMap.Note_SIP_UPI_2FA;
                payload.paymentOption = 'UAP';
              }

              ModalService.transactionOtpModal({
                otpPayload: otpDetails,
                payload: payload,
                upiModalOtp : noteUpiModal,
                gateWayJourney : true,
                showBlueBtn: true
              }, otpSuccessCallback, otpDismissCallback);
            } else{
              LoaderService.hideLoader();
              submitForm($event);
            }
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message)
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      if (vm.sourcePortal && vm.sourcePortal === 'WHATSAPP') {

        modalPayload = {
          transactionFolioNumber: vm.formData.folioNumber,
          transactionType: vm.formData.investmentType,
          lastTransactedFolioNumber: sessionStorage.getItem("folioID"),
          secretLink : vm.formData.secretLink
        };


        TransactionService.post({
          controller1: 'whatsapp',
          controller2: 'transaction',
          controller3: 'otp'
        }, modalPayload).$promise.then(success, error);

      } else {


        modalPayload = {
          folioNumber: vm.formData.folioNumber,
          transactionType: vm.formData.investmentType,
          randomOTPId: vm.randomOTPId
        };


        TransactionService.post2({
          controller1: 'transaction',
          controller2: 'otp'
        }, modalPayload).$promise.then(success, error);

      }
    }

    /**
     * Function responsible for handling mandate 2FA
     */

    function transactionOtpConfirmationEmandate($event) {

      var successCallback = function (resp) {
        vm.secretLink = resp.secretLink;
        submitForm($event);
      };
      var errorCallback = function (err) {
        LoaderService.hideLoader();
      };

      ModalService.registerEMandateModal({
          folioNumber : vm.formData.folioNumber,
          transactionType : vm.formData.investmentType,
          bankName : vm.bankInfo.bankName.substring(0,vm.bankInfo.bankName.indexOf("-")),
          authMode: vm.formData.authMode.value,
          showBlueBtn : true,
          randomOTPId: vm.randomOTPId
        },
        successCallback,errorCallback)
    }

    function submitForm($event) {
      // userActivityTracking(false, function () {
      var payload = vm.isSipPurchase ? getPayloadCart() : getSipPurchasePayload();
      if (!payload) {
        MessageService.error('Something went wrong while calculating purchase payload.');
        return;
      }
      if (payload.formType === 'PURCHASE' && vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.NETBANKING &&
        vm.formData.purchaseAmount >= 200000 && vm.formData.schemeType != 'LIQUID') {
        vm.showPurchaseNetBankingModal(payload);
      } else if (vm.formData.investmentType === 'SIP'){
          vm.isSipPurchase ? vm.finalSubmitCart(payload) : vm.finalSubmit(payload);
      }
      else {
        vm.finalSubmit(payload);
      }
      // });
    };

    function userActivityTracking(isProcessed, cb) {

      /*Netcore Event Start*/
      if(!isProcessed){
        // NetcoreEvntService.Continue_To_Pay_Purchase_IP(vm.formData, true);
      }
      /*Netcore Event End*/
      cb = cb || function () {
      };
      var success = function (trackResp) {
        trackResp = trackResp.data || trackResp;
        // LoaderService.hideLoader();
        cb(trackResp);
      }, error = function (err) {
        UtilService.errorHandler(err);
        // LoaderService.hideLoader();
        cb(false);
      };

      // LoaderService.showLoader();
      var userTrackerPayload = setUserTrackerPayload(isProcessed);
      InvestorService.post({
        child1: 'userBehavior',
        child2: 'addupdate'
      }, userTrackerPayload).$promise.then(success, error);
    };

    function setUserTrackerPayload(isProcessed) {
      var _payload = {
        "trxnRefNo": $stateParams.trackId?$stateParams.trackId: vm.formData.trackId? vm.formData.trackId : '', //required in case of update
        "trxnType": vm.isSipPurchase ? "SIP_PURCHASE" : vm.formData.investmentType, //SIP, PURCHASE
        "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
        "step": "THIRD", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.investmentType === "PURCHASE" ? vm.formData.purchaseInSchemeCode : vm.formData.inSchemeCode,
        "schemeName": vm.formData.purchaseInSchemeName || vm.formData.inSchemeName || vm.formData.schemeName,
        "netCoreJourney": vm.formData.journey == "Transact Now" ? "TRANSACT_NOW" : null,
        "folioNo": vm.formData.folioNumber,
        "formData": getSipPurchasePayloadForAddUpdate("USER_BEHAVIOUR"),
        "amount": vm.formData.amount || vm.formData.purchaseAmount,
        "trxnStatus": isProcessed ? "PROCESSED":"OPEN"  // OPEN,PROCESSED
      };

      return _payload;
    }

    vm.showPurchaseNetBankingModal = function (payload) {
      vm.finalSubmit(payload);
    };

    /**
     * Function responsible for handling approve call
     */

    vm.finalSubmit = function (payload) {
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {

            vm.newTransID = resp.data.transactionId;

            if (vm.sourcePortal && vm.sourcePortal === 'INVESTOR') {
              userActivityTracking(true, function(){});
            }

            // userActivityTracking(true, function(){
            sessionStorage.removeItem('linkId');
            if (vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.UPI || vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.UPISIP) {

              if (vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.UPISIP && vm.isIntent) {
                vm.redirectUrl = resp.data.mobileDeepLink;
              } else {
                vm.redirectUrl = resp.data.redirectUrl;
              }
            }

            if(vm.formData.investmentType === 'SIP' && !vm.formData.sipFirstInstallment) {
              if(vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.OTM ||
                vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.EC){
                $state.go("payment-status",{
                  cart_id : vm.newTransID,
                  pt : vm.camsCode,
                  tType: vm.formData.investmentType
                });
              }else{
                handleSipResponse(resp.data);
              }
            } else if(vm.formData.investmentType === 'SIP' && vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.UPISIP) {
              handleSipResponse(resp.data);
            } else {
              if(vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.OTM){
                $state.go("payment-status",{
                  cart_id : vm.newTransID,
                  pt : vm.camsCode,
                  tType: vm.formData.investmentType
                });
              }else{
                handlePurchaseResponse(resp.data);
              }
            }
            // });

          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message,
                isAadhar: true,
                showBlueBtn: true
              });
            } else {
              MessageService.error(resp.message);
            }

          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      var invType = null;
      invType = vm.formData.investmentType.toLowerCase();
      TransactionService.post({
        controller1: 'transaction',
        controller2: invType,
        controller3: 'approve'
      }, payload).$promise.then(success, error);
    };


    /**
     * Function responsible for handling payment success for FI and PURCHASE
     */

    function handlePurchaseResponse(data) {
      sessionStorage.removeItem('linkId');
      // $scope.$emit('disableLogout');
      var transactionId = data && data.transactionId ? data.transactionId : null;

      var payloadData = angular.copy(data);

      data = data && data.data ? data.data : data;
      if (!data) {
        MessageService.error();
        return;
      }

      if(vm.formData.sipFirstInstallment && (vm.formData.selectedPaymentOption==='E-mandate'))
      {
        $window.location.href=$scope.billdeskUrl+data.emandateMsg;
        return;
      }

      if(vm.formData.investmentType==='SIP')
        vm.billdeskMsg = data.emandateMsg;
      else
        vm.billdeskMsg = data;

      if(vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'RAZORPAY') {
        if(vm.formData.investmentType==='PURCHASE') {
          payloadData.trnxActionMsg = payloadData.data;
        } else if(vm.formData.investmentType==='SIP') {
          payloadData.trnxActionMsg = payloadData.emandateMsg;
        }
        PaymentService.openRazorPay(payloadData);
      } else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLDESK') {
        if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () { // commented as debit currently is not getting used
            // logoutMe(function () {
            angular.element('#billdeskForm').submit();
            // });
          });

        } else {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            // logoutMe(function () {
            angular.element('#billdeskForm').submit();
            // });
          });

        }

      }
      else if (vm.formData.paymentInfo.paymentMode == 'WEB' && (vm.formData.paymentInfo.webMode == 'MASTERCARD' || vm.formData.paymentInfo.webMode == 'VISA')) {
        if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            // logoutMe(function () {
            angular.element('#billdeskForm').submit();
            // });
          });

        } else {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            // logoutMe(function () {
            angular.element('#billdeskForm').submit();
            // });
          });

        }
      }
      else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLJUNCTION') {
        // logoutMe(function () {
        $window.open(vm.billdeskMsg, '_self');
        // });

      } else if ((vm.formData.paymentInfo.paymentMode == 'WEB' || vm.formData.paymentInfo.paymentMode == 'UAP') && vm.formData.paymentInfo.webMode == 'UPI') {
        if(!vm.redirectUrl) {
          MessageService.error("Something went wrong");
        } else {
          // logoutMe(function () {
          $window.location.href = vm.redirectUrl;
          // });
        }
      }
      else if(vm.formData.sipFirstInstallment)
      {
        // logoutMe(function () {
        $window.location.href = data.redirectUrl;
        // })
      } else {
        $state.go("payment-status",{
          cart_id : vm.newTransID,
          pt : vm.camsCode,
          tType: vm.formData.investmentType
        });
      }

    }

    /**
     * Function responsible for handling payment success for SIP
     */

    function handleSipResponse(data) {
      if (!data) {
        MessageService.error();
        return;
      }

      if (vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.EMANDATE) {
        data = data && data.data ? data.data : data;
        if (!data) {
          MessageService.error();
          return;
        }
        $window.location.href= $scope.billdeskUrl + data.emandateMsg;
      } else if (vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPI || vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP) {
        if (!data) {
          MessageService.error();
          return;
        }

        if (vm.isIntent) {
          if (data.mobileDeepLink) {
            sessionStorage.setItem('intent',data.mobileDeepLink);
          }
          // $window.location.href = data.redirectUrl;

          // Create a URL object
          var urlObj = new URL(data.redirectUrl);

          // Extract parameters from the URL using searchParams
          var id = urlObj.searchParams.get('id');   // Get 'id' parameter
          var type = urlObj.searchParams.get('type'); // Get 'type' parameter

          $state.go('upi.waiting',{
            id: id,
            type: type
          })

        } else {
          $window.location.href = data.redirectUrl;
        }
      }

    }


    /**
     * Function responsible for setting payment info payload for FI and PURCHASASE
     */

    function getPaymentInfo() {

      if (vm.formData.paymentInfo && vm.formData.paymentInfo.webMode === 'MASTER') {
        vm.formData.paymentInfo.webMode = 'MASTERCARD';
      }

      var paymentInfo={};

      if(vm.formData.investmentType==='SIP') {

        // if OTM - BOTH OTM WILL BE SET
        // if UPI - BOTH UPI WILL BE SET
        // if NETBANKING - EC WILL BE SET


        paymentInfo = {
          paymentMode: vm.formData.paymentInfo.paymentMode
        };

        switch (vm.formData.selectedPaymentOption) {
          case vm.PAYMENT_OPTIONS.NETBANKING:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.bankName = vm.bankInfo.bankName;
            if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
              paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
              paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            }
            paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            break;
          case vm.PAYMENT_OPTIONS.OTM:
            paymentInfo.otmId = vm.formData.paymentInfo.otmId;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.branchName = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNumber = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.payoutId = vm.formData.paymentInfo.payoutId;
            paymentInfo.omUmrn = vm.formData.paymentInfo.omUmrn;
            paymentInfo.camsMandateIdNo = vm.formData.paymentInfo.camsMandateIdNo;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            break;
          case vm.PAYMENT_OPTIONS.UPISIP:
            paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
            paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
            paymentInfo.upiReferenceNumber = vm.transactionNumber;
            paymentInfo.accountNumber = vm.upiAccountNumber;
            paymentInfo.accNumber= paymentInfo.accountNumber;
            paymentInfo.bankName= vm.upiBankName;
            paymentInfo.paymentMode = vm.camsCode;
            paymentInfo.accType = vm.bankInfoUPI.bankAcType ? vm.bankInfoUPI.bankAcType : vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.bankInfoUPI.ifscCode ? vm.bankInfoUPI.ifscCode : vm.formData.paymentInfo.ifscCode;
            break;
        }

      }
      else
      {
        paymentInfo = {
          amount: vm.formData.paymentInfo.amount,
          paymentMode: vm.formData.paymentInfo.paymentMode

        };

        switch (vm.formData.selectedPaymentOption) {
          case vm.PAYMENT_OPTIONS.NETBANKING:
            paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
            paymentInfo.webMode = vm.formData.paymentInfo.webMode;
            paymentInfo.bankName = vm.bankInfo.bankName;
            if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
              paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
              paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
            }
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            break;
          case vm.PAYMENT_OPTIONS.OTM:
            paymentInfo.otmId = vm.formData.paymentInfo.otmId;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.branchName = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNo = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.payoutId = vm.formData.paymentInfo.payoutId;
            paymentInfo.omUmrn = vm.formData.paymentInfo.omUmrn;
            paymentInfo.camsMandateIdNo = vm.formData.paymentInfo.camsMandateIdNo;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            break;
          case vm.PAYMENT_OPTIONS.RTGS:
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.bankName = vm.formData.paymentInfo.bankName;
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.accNo = vm.formData.paymentInfo.accNo;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            paymentInfo.accType = vm.formData.paymentInfo.bankAcType;
            paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
            // if(vm.isNewPayment) {
            paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            // }
            break;
          case vm.PAYMENT_OPTIONS.HDFC:
            paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
            paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.accountHolderName = vm.formData.paymentInfo.accountHolderName;
            paymentInfo.bankName = "HDFC Bank Ltd";
            paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
            paymentInfo.bankAcNo = vm.formData.paymentInfo.bankAcNo;
            paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
            paymentInfo.accType = vm.formData.paymentInfo.accType;
            paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
            paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
            paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
            break;
          case vm.PAYMENT_OPTIONS.UPI:
            paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
            paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
            paymentInfo.upiReferenceNumber = vm.transactionNumber;
            paymentInfo.accountNumber = vm.upiAccountNumber;
            paymentInfo.accNo= paymentInfo.accountNumber;
            paymentInfo.accType = vm.bankInfoUPI.bankAcType ? vm.bankInfoUPI.bankAcType : vm.formData.paymentInfo.accType;
            paymentInfo.bankName = vm.upiBankName;
            paymentInfo.ifscCode = vm.bankInfoUPI.ifscCode ? vm.bankInfoUPI.ifscCode : vm.formData.paymentInfo.ifscCode;
            break;
        }
      }

      return angular.copy(paymentInfo);
    }

    /**
     * Function responsible for setting sip purchase payload
     */

    function getSipPurchasePayload() {
      if (vm.formData.investmentType === 'SIP') {
        var sipPayload = {
          installmentAmount: vm.formData.amount,
          investmentOption: vm.formData.investmentOption,
          dividendOption: vm.formData.dividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          frequency: vm.formData.frequency,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          toDate: vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY').toString() : '',
          sipDate: vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY').toString() : '',
          sipDay: vm.formData.day,
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          id: vm.linkID ? vm.linkID : vm.formData.sTransactionId,
          subBrokerArn: vm.formData.subBrokerARN ? vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode ? vm.formData.subBrokerCode : '',
          brokerCode: vm.formData.brokerCode,
          secretLink: vm.secretLink,
          netCoreRefNo : $stateParams.trackId ? $stateParams.trackId : null
        }
      } else if (vm.formData.investmentType === 'PURCHASE') {
        var purchasePayload = {
          amount: vm.formData.purchaseAmount,
          investmentOption: vm.formData.investmentOption,
          dividendOption: vm.formData.dividendOption,
          folioNumber: vm.formData.folioNumber,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          schemeCode: vm.formData.purchaseInSchemeCode,
          retirementAgeProofURL: vm.formData.retirementAgeProofURL ? vm.formData.retirementAgeProofURL : '',
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          id: vm.linkID ? vm.linkID : vm.formData.pTransactionId,
          paymentInfo: getPaymentInfo(),
          subBrokerArn: vm.formData.subBrokerARN ? vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode ? vm.formData.subBrokerCode : '',
          checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
          autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null,
          autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null,
          secretLink: vm.secretLink,
          netCoreRefNo : $stateParams.trackId ? $stateParams.trackId : null
        }
      }

      // Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
      //   if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == purchasePayload.investmentOption) {
      //     purchasePayload.investmentOption = key;
      //   } else if (vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == sipPayload.investmentOption) {
      //     sipPayload.investmentOption = key;
      //   }
      // });

      if (purchasePayload && purchasePayload.paymentInfo.accountNumber) {
        purchasePayload.accountNumber = purchasePayload.paymentInfo.accountNumber;
        //delete purchasePayload.paymentInfo.accountNumber;
      }
      if (purchasePayload && purchasePayload.paymentInfo.tpvEnableFlag) {
        purchasePayload.tpvEnableFlag = purchasePayload.paymentInfo.tpvEnableFlag;
        delete purchasePayload.paymentInfo.tpvEnableFlag;
      }

      if (vm.formData.investmentType === 'SIP' && vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP) {
        sipPayload.payerVpa = vm.formData.paymentInfo.virtualAddress;
        sipPayload.payerName = vm.name;
        sipPayload.paymentOption = vm.camsCode;
      }


      var payload = {};

      switch (vm.formData.investmentType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          purchasePayload = handleBrokerCode(purchasePayload);
          payload = angular.copy(purchasePayload);
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          sipPayload = handleBrokerCode(sipPayload);
          payload = angular.copy(sipPayload);
          break;
      }


      if(vm.formData.investmentType==='SIP')
      {

        if (vm.formData.sipFirstInstallment) {
          payload.sipWithFirstInstallment = vm.formData.sipFirstInstallment;
          payload.firstInstallmentDetails = getPaymentInfo();
        }

        if(vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.EC || vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP || (vm.formData.sipFirstInstallment && vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.NETBANKING)) {

          // setting bankinfo for upi and biller
          var bankInfo = vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP ? angular.copy(vm.bankInfoUPI) : angular.copy(vm.bankInfo);

          payload.bankDetailsForECS= {
            accNumber: bankInfo.accountNumber,
            bankName: bankInfo ? bankInfo.bankName : vm.formData.bankName,
            ifscCode: bankInfo.ifscCode ? bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode,
            branchName: bankInfo.bankBranch,
            bankCity: bankInfo.bankCity,
            paymentOption: vm.camsCode,
            netBankingUrl:vm.formData.netBankingUrl,
            bankCode: bankInfo ? bankInfo.bankCode:null,
            accType: bankInfo.bankAcType ? bankInfo.bankAcType : vm.formData.paymentInfo.accType
          }

          if (vm.formData.sipFirstInstallment && vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.NETBANKING) {
            payload.bankDetailsForECS.paymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          }
        }
        else if(vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.EMANDATE) {
          payload.bankDetailsForECS= {
            accNumber: vm.bankInfo ? vm.bankInfo.accountNumber:'',
            bankName: vm.bankInfo ? vm.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.bankInfo.ifscCode,
            branchName: vm.bankInfo.bankBranch,
            bankCity: vm.bankInfo.bankCity,
            paymentOption: vm.camsCode,
            accType:vm.bankInfo.bankAcType,
            bankCode:vm.bankInfo ? vm.bankInfo.bankCode:null,
            authenticationMode:vm.formData.authMode.value
          }

          payload.mandateStartDate = vm.formData.emandateDate ? $window.moment(vm.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null;
          payload.mandateEndDate = vm.formData.endDateEmandate ? $window.moment(vm.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null;
          payload.mandateAmount = vm.formData.emandateAmount ? vm.formData.emandateAmount : null;
        }
        else if(vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.OTM) {

          payload.bankDetailsForECS= {
            accNumber: vm.bankInfo.bankAcNo,
            bankName: vm.bankInfo ? vm.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode,
            branchName: vm.bankInfo.bankBranch,
            bankCity: vm.bankInfo.bankCity,
            paymentOption: vm.camsCode,
            payoutId:vm.bankInfo.payoutId,
            bankCode:vm.bankInfo ? vm.bankInfo.bankCode:null,
            accType: vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType,
            camsMandateIdNo: vm.bankInfo.camsMandateIdNo,
            omUmrn: vm.bankInfo.omUmrn
          }
        }


        if(vm.formData.sipTopupEnabled) {
          payload.sipTopupEnabled=vm.formData.sipTopupEnabled;
          payload.topupDetails=vm.formData.topupDetails;
        }

        if (vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP) {
          payload.intent = vm.isIntent && vm.selectedUpiOption && vm.selectedUpiOption !== 'OTHERS'? 'Y' : 'N';
          payload.paymentGatewayType = vm.selectedUpiOption && vm.selectedUpiOption === 'OTHERS' ? null : vm.selectedUpiOption;
        }

      }

      if (vm.sourcePortal && vm.sourcePortal === 'WHATSAPP') {
        payload.sourceAppPortal = angular.copy(vm.sourcePortal);
        payload.id = vm.linkID;
      }


      if (vm.sourcePortal && vm.sourcePortal === 'API_GATEWAY') {
        payload.gatewayTransactionDraftID = vm.linkID;
      }


      // if (vm.sourcePortal && vm.sourcePortal === 'INVESTOR' && vm.showDatesManupilateError && vm.formData.investmentType === 'SIP' && (vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.EC || vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.NETBANKING)) {
      //   vm.formData.startDate =  angular.copy(vm.billerDateRequired);
      //   payload.sipDate = vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY').toString() : '';
      //   updateEndDates();
      //   payload.toDate = vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY').toString() : '';
      //   vm.formData.day = vm.formData.startDate ? $window.moment(vm.formData.startDate, "DD-MMM-YYYY").format('D') : '';
      //   payload.sipDay = vm.formData.day;
      // }


      payload.newAcknowledgeScreen = true;


      if(vm.cancelTransactionRequestBody){
        payload.cancelTransactionRequestBody = vm.cancelTransactionRequestBody;
      }

      return payload;
    }

    /**
    Function responsible to manage the broker code for purchase and sip payload
    * */
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode;
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = true;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }


    function copyPasteHandler(e) {
      UtilService.copyPasteHandler(e);
    };

    /**
     * Function responsible for handling user logout
     */

    function logoutMe(cb) {
      cb = cb ||function () {};
      var val = {  "panNumber" : vm.savedData.panNumber };

      var success = function (resp) {
          localStorage.removeItem("userId");
          var newDataLayer = $window.dataLayer.filter(function (obj) {
            return !obj.hasOwnProperty('userId');
          });
          $window.dataLayer = newDataLayer;
          AuthService.clearCookies(AppConstants.TOKEN);
          CommonFactory.setLogoutSuccess();
          cb();
        },
        error = function (err) {
        };
      LoaderService.showLoader('.logout');
      InvestorService.post({
        child1: 'force',
        child2: 'logout'
      }, val).$promise.then(success, error);

    }

    /**
     * Function responsible for note link redirection
     */

    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };


    /**
     * Function responsible for opening mandate TNC modal
     */

    function showTermConditionsemandate() {
      ModalService.transactionalTermConditionModalEMandate({'transactionType': 'SIP-E-MANDATE','subTransactionType':vm.formData.investmentType});
    };


    /**
     * Function responsible for handling bank list api call during error
     * @param {Number} index : index of the payment options array
     */

    function handleErrorCallback(index) {
      //handling if api call fails

      // incrementing index for next call
      index = index + 1;
      // if index exceeds length of payment options , break flow
      if (index < vm.dynamicPaymentOptionArray.length) {
        if (vm.formData.investmentType === 'SIP') {
          fetchBankListSIP(index);
        } else {
          fetchBankListPurchase(index);
        }
      } else {
        checkPaymentOptionNotSelected();
        LoaderService.hideLoader();
        vm.showLoader = false;
      }
    }

    /**
     * Function responsible for handling payment mode change based on transaction type
     * @param {String} paymentOption : transaction type SIP or PURCHASE or PURCHASESIP
     * @param {Number} index : index of the payment option selected
     */

    function selectPaymentOption(paymentOption,index) {
      if (vm.formData.investmentType === 'SIP' && vm.formData.selectedPaymentOption !== paymentOption.key) {
        vm.changedSipPaymentOption(paymentOption);
      } else if (vm.formData.investmentType === 'PURCHASE' && vm.formData.selectedPaymentOption !== paymentOption.key) {
        vm.changedPaymentOptionPurchase(paymentOption);
      }
      vm.activeIndex = index;
    }

    /**
     * Function responsible for handling upi intent ui based on selection
     * @param {String} type : transaction type SIP or PURCHASE or PURCHASESIP
     */

    function selectedUpiBlock(type) {
      vm.selectedUpiOption = type;
      vm.formData.selectedPaymentOption = vm.formData.investmentType === 'PURCHASE' ? vm.PAYMENT_OPTIONS.UPI : vm.PAYMENT_OPTIONS.UPISIP;
    }

    /**
     * Function responsible for handling pay now functionality
     */


    function payNow($event) {
      if (vm.sourcePortal && vm.sourcePortal === 'WHATSAPP') {
        vm.checkDuplicate($event);
      } else if (vm.sourcePortal && vm.sourcePortal === 'INVESTOR') {
        userActivityTracking(false, function (resp) {
          var netcoreData = vm.formData;
          if ((resp && angular.isDefined(resp.transactionId))) {
            vm.formData.trackId = resp.transactionId;
          }
          netcoreData.deeplink = resp.trxnUniqueLink;
          if(vm.formData.journey && vm.formData.journey === "Transact Now") {
            if(vm.isSipPurchase) {
              NetcoreEvntService.payment_Mode_Selected_Mix_Transaction(netcoreData);
            } else if (vm.formData.investmentType === 'PURCHASE') {
              NetcoreEvntService.payment_Mode_Selected_Purchase(netcoreData);
            } else if (vm.formData.investmentType === 'SIP') {
              NetcoreEvntService.payment_Mode_Selected_Sip(netcoreData);
            }
          }
        });
        submitForm($event);
      }
    }

    /**
     * Function responsible for identifying platform on which device is opened
     */

    function setShareVariables() {
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      var isAndroid = /(android)/i.test(navigator.userAgent);

      return isIOS || isAndroid
    }


    /**
     * Function responsible for redirection to TNC
     */

    function redirectToTnc(){
      $window.open(vm.tncUrl, '_blank');
    }


    /**
     * Function responsible for opening read more modal for cheque leaf
     */

    function chequeLeafReadMore() {
      ModalService.genericModal({
        text: 'Supported file formats are .jpeg, .jpg, .tiff, .tif, .pdf. <br> File size should not be more than 3 MB.',
        showBlueBtn: true
      })
    }

    /**
     * Function responsible for back button reidrection handling
     */

    function handleBackRedirection() {
      if (vm.sourcePortal && vm.sourcePortal === 'INVESTOR') {
        if (!vm.detailPageData) {
          var data = $window.JSON.parse(sessionStorage.getItem('fData'));
          vm.detailPageData = angular.copy(data);
        }
        vm.detailPageData.backFromPaymentPage = true;
        if(vm.detailPageData && vm.detailPageData.startDate) {
          vm.detailPageData.startDate = $window.moment(vm.detailPageData.startDate);
        }
        if(vm.detailPageData && vm.detailPageData.endDate) {
          vm.detailPageData.endDate = $window.moment(vm.detailPageData.endDate);
        }
        if(vm.detailPageData && vm.detailPageData.topupDetails && vm.detailPageData.topupDetails.capMonthYearSelect) {
          vm.detailPageData.topupDetails.capMonthYearSelect = $window.moment(vm.detailPageData.topupDetails.capMonthYearSelect);
        }
        TransactionModel.setPayloadRawData(vm.detailPageData);
        $window.history.back();
      } else {
        $window.location.href = vm.successBackUrl;
      }
    }

    /**
     * Function responsible for fetching scheme validation
     */


    function fetchInSchemeValidations(cb) {
      vm.inSchemeValidations = null;
      if (vm.transactionType) {
        vm.formData.investmentType = vm.transactionType;
      } else if (vm.formData.investmentType) {
        vm.transactionType = vm.formData.investmentType;
      }
      var transactionType = vm.formData.investmentType.toLowerCase();
      cb = cb || function () {
      };

      if (vm.formData.investmentType === 'PURCHASE' && !vm.formData.purchaseInSchemeCode) {
        return;
      } else if (vm.formData.investmentType === 'SIP' && !vm.formData.inSchemeCode) {
        return;
      }

      var schemeCode = vm.formData.investmentType === 'PURCHASE' ? vm.formData.purchaseInSchemeCode : vm.formData.inSchemeCode;

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;
            if(vm.inSchemeValidations && vm.formData.minorFlag){
              vm.inSchemeValidations.cgfFlag = vm.inSchemeValidations.cgfFlag ? vm.inSchemeValidations.cgfFlag: true;
            }
            vm.frequencyList = vm.inSchemeValidations.additionalValidation.frequency?vm.inSchemeValidations.additionalValidation.frequency:null;
            cb();
          } else {
            cb('error');
            vm.inSchemeValidations = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          cb('error');
          vm.inSchemeValidations = null;
          UtilService.errorHandler(err);
        };


      IIHttpService.get({
        child1: 'schemeValidation',
        child2: 'sip',
        child3: schemeCode
      }, null).$promise.then(success, error);

    }

    /**
     * Function responsible for calculating end dats array
     */

    function updateEndDates() {
      if (!vm.formData.startDate) {
        return;
      }
      var defaultEndDate = $window.moment(moment(vm.formData.startDate).toDate(), "DD-MM-YYYY").add(vm.durationYears, 'years');
      var defaultEndDateUpto30Years = $window.moment().add(30, 'years').subtract(1, 'days');
      var sipDateGreaterUPI =  $window.moment(defaultEndDate, 'DD-MMM-YYYY').isAfter(defaultEndDateUpto30Years) ? true : false;
      if (sipDateGreaterUPI) {
        defaultEndDate = angular.copy(defaultEndDateUpto30Years);
      }
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;
      var frequency = vm.frequencyList.find(function (f) {
        return f.code === vm.formData.frequency;
      }) || {};

      switch (vm.formData.frequency) {
        case'BZ':
          var days = 0;
          endDate = moment(vm.formData.startDate).clone();//.add(minInstallments, 'days');
          defaultEndDate.add(1,"days");
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          var days = getMonthsCount(endDate.clone(), defaultEndDate);
          freq = vm.formData.selectedPaymentOption === 'E-mandate' ?  defaultEndDate.clone().add(-1, 'days').diff(endDate, 'days', true) : ((defaultMonths * 30) / frequency.duration) + days;
          for (i = 0; i < freq; i++) {
            days = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          if (vm.formData.selectedPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPISIP || !vm.formData.selectedPaymentOption) {
            defaultEndDate = defaultEndDate.clone().add(-1, 'days');
            var n =enabledEndDates.length;
            if(n>0 && enabledEndDates[n-1].isBefore(defaultEndDate) ){
              const date1 = new Date(enabledEndDates[n-1]);
              const date2 = new Date(defaultEndDate);
              const diffTime = Math.abs(date2 - date1);
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              for (i = n; i < (n+diffDays-1); i++) {
                days = frequency.duration * i;
                if(endDate.clone().add(days, 'days').format("DD-MMM-YYYY") == defaultEndDate.format("DD-MMM-YYYY")){
                  break;
                }
                enabledEndDates.push(endDate.clone().add(days, 'days'));
              }
            }
            n =enabledEndDates.length;
            if(n>0 &&  defaultEndDate.isBefore(enabledEndDates[n-1])){
              enabledEndDates=[];
              for (i = 0; i < freq; i++) {
                days = frequency.duration * i;
                if(endDate.clone().add(days, 'days').format("DD-MMM-YYYY") == defaultEndDate.format("DD-MMM-YYYY")){
                  break;
                }
                enabledEndDates.push(endDate.clone().add(days, 'days'));
              }
            }
          }
          break;
        case'OW':
          var days = 0;
          freq = UtilService.getNumberOfWeeks(moment(vm.formData.startDate).toDate(), new Date(defaultEndDate));
          for (i = 0; i <= freq; i++) {
            days = frequency.duration * i;
            enabledEndDates.push(moment(vm.formData.startDate).clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          endDate = moment(vm.formData.startDate).clone().add(frequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.duration);
          for (i = 0; i < freq; i++) {
            months = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      if(enabledEndDates && enabledEndDates.length>0 ){
        vm.formData.endDate =  enabledEndDates[enabledEndDates.length-1].clone().format("DD-MMM-YYYY");
      }
      if(enabledEndDates && enabledEndDates.length>0 &&
        enabledEndDates.indexOf(moment(vm.formData.startDate).clone().add(vm.durationYears, 'years')) > -1
      ){
        vm.formData.endDate =  enabledEndDates[enabledEndDates.length-1].clone().add(vm.durationYears, 'years').format("DD-MMM-YYYY");
      }

    }

    /**
     * Function responsible for setting end date
     */

    vm.changeEndDate = function (date,calledFromOtherFlow) {
      if (date && vm.endDateDefaultForPertuity) {
        if(vm.endDateDefaultForPertuity.isSame($window.moment(date))){
          vm.formData.isTillPerpetuity = true;
        } else {
          vm.formData.isTillPerpetuity = false;
        }
      }
      vm.formData.endDate = date ? date : null;
      var diffInMonths = parseInt($window.moment(vm.formData.endDate).diff($window.moment(vm.formData.startDate), 'months', true));
      if (diffInMonths >= 6 && vm.formData.frequency != 'BZ') {
        vm.formData.showTopUpBlock = true;
        if(diffInMonths >= 12){
          var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
          // var capStartDateValue = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
        }
        else{
          capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
          // capStartDateValue = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
        }

        vm.capDates = [];
        var capLastDate = capStartDate;
        while ($window.moment(capLastDate).isBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(capStartDate);
          }
          // capStartDateValue = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          capStartDate = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          if ($window.moment(capStartDate).isBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
            vm.capDates.push(capStartDate);
          }
          else {
            break;
          }
          capLastDate = vm.capDates[vm.capDates.length - 1];
        }
      }
      (vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) && checkOTMAmountAndDate();
      // checkSipValidations();
      if(vm.formData.sipPaymentOption == 'E-mandate'){
        if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == 'SIP' && vm.arnHardcodedData.sipEndDate){
          if($window.moment(vm.endLimit, 'DD-MMM-YYYY').isBefore(vm.formData.endDate)){
            vm.showNPCIDateError = 'As per NPCI Circular NPCI/2023-24/NACH/008, mandate can be registered for a maximum duration of 30 years from the date of issuance.';
          }else{
            vm.showNPCIDateError ='';
          }
        }

        if(vm.formData.endDateEmandate) {
          vm.sipDateLessEmandate =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
          if (vm.sipDateLessEmandate) {
            var setEndDateLess = false;
            var indexSipEndDate = vm.enabledEndDates.length - 1;
            var tempEndDate;
            while (!setEndDateLess) {
              tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
              indexSipEndDate = indexSipEndDate - 1;
              if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY'))) {
                setEndDateLess = true;
                var newEnabledEndDates = angular.copy(vm.enabledEndDates);
                newEnabledEndDates.splice(indexSipEndDate + 1);
                vm.enabledEndDates = angular.copy(newEnabledEndDates);
                if (!calledFromOtherFlow) {
                  vm.formData.endDate = angular.copy(tempEndDate);
                  vm.changeEndDate(vm.formData.endDate);
                }
              }

              if (indexSipEndDate == 0) {
                break;
              }
            }

            if (calledFromOtherFlow) {
              var endDateField =  vm.formData.frequency === 'OW' ? angular.element('#endDateCalenderWeekly') : angular.element('#endDateCalender');
              endDateField.focus();
            }
          }
        }

      }


      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI && vm.enabledEndDates) {
        var defaultEndDate = $window.moment().add(vm.emandateMaxYear, 'years').subtract(1,'days');
        var sipDateLessUPI =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter(defaultEndDate) ? true : false;
        if (sipDateLessUPI) {
          var setEndDateLess = false;
          var indexSipEndDate = vm.enabledEndDates.length - 1;
          var tempEndDate;
          while (!setEndDateLess) {
            tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
            indexSipEndDate = indexSipEndDate - 1;
            if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(defaultEndDate, 'DD-MMM-YYYY'))) {
              setEndDateLess = true;
              var newEnabledEndDates = angular.copy(vm.enabledEndDates);
              newEnabledEndDates.splice(indexSipEndDate + 1);
              vm.enabledEndDates = angular.copy(newEnabledEndDates);
              vm.formData.endDate = angular.copy(tempEndDate);
              vm.changeEndDate(vm.formData.endDate);
            }

            if (indexSipEndDate == 0) {
              break;
            }
          }
        }
      }
    };


    /**
     * Function responsible for setting months count
     */

    function getMonthsCount(startDate, endDate) {
      var daysToBeAdded = 0;
      var daysAdded = 0;
      while(startDate.isBefore(endDate)) {
        var dayInMonth = moment(startDate).daysInMonth();
        if (dayInMonth === 31) {
          daysToBeAdded = daysToBeAdded + 1;
        } else {
          daysAdded = daysAdded + 1;
        }
        startDate.add(1, 'month');
      }
      return daysToBeAdded;
    }

    /**
     * Function responsible for setting payment mode when only one is enabled
     */

    function checkPaymentOptionNotSelected() {
      if(vm.detailPageData && vm.detailPageData.payment_mode_key) {
        var index = 0;
        var matchedPaymentOption = vm.paymentOptions.find(function (option,paymentIndex) {
          index = paymentIndex;
          return option.key === vm.detailPageData.payment_mode_key;
        })
        if(matchedPaymentOption) {
          vm.formData.selectedPaymentOption = vm.detailPageData.payment_mode_key;
          selectPaymentOption(matchedPaymentOption, index);
        } else {
          vm.formData.selectedPaymentOption = vm.paymentOptions[0];
          selectPaymentOption(vm.formData.selectedPaymentOption,0);
        }
      } else {
        if (!vm.formData.selectedPaymentOption && vm.paymentOptions && vm.paymentOptions.length > 0) {
          vm.formData.selectedPaymentOption = vm.paymentOptions[0];
          selectPaymentOption(vm.formData.selectedPaymentOption,0);
        }
      }
    }


    /**
     * Function responsible for setting cart data form
     */

    function setCartData() {
      vm.formData.upiLimit = vm.savedData.sipSettings.upi.maxAmountLimit;
      vm.formData.upiErrorMessageObj =  vm.savedData.sipSettings;
      vm.formData.investmentType = 'SIP';
      vm.cartData = vm.savedData.cartItems[0];
      vm.formData.folioNumber = vm.cartData.folioNumber;
      vm.formData.liquidFlag = vm.cartData.liquid;
      vm.formData.investorType = vm.cartData.invType;
      vm.formData.purchaseAmount = vm.cartData.amount;
      vm.formData.sipAmount =  vm.cartData.installmentAmount;
      vm.formData.amount = vm.formData.purchaseAmount +  vm.formData.sipAmount;
      vm.formData.startDate = vm.cartData.sipDate;
      vm.cartData.toDate = vm.cartData.toDate;
      vm.formData.endDate = vm.cartData.toDate;
      vm.formData.inSchemeCode = vm.cartData.schemeCode;
      vm.formData.schemeName = vm.cartData.schemeName;
      vm.formData.frequency = vm.cartData.frequency;
      vm.successBackUrl =  'main.transaction.purchase';
      vm.formData.journey = vm.savedData.journey;
      vm.formData.sipViaPurchaseSelected = vm.savedData.sipViaPurchaseSelected;
      vm.formData.investmentOption = fetchInvestmentOption(vm.detailPageData.purchaseInvestmentOption);
      vm.formData.dividendOption = vm.savedData.cartItems[0].dividendOption;
    }


    /**
     * Function responsible for setting cart payload for final submit
     */

    function getPayloadCart() {
      var payload = vm.formData.paymentInfo;
      payload.paymentOption = angular.copy(payload.paymentMode);
      delete payload.paymentMode;
      payload.gatewayVendor = angular.copy(payload.webMode);
      delete payload.webMode;
      payload.accNo = angular.copy(payload.accountNumber);
      delete payload.accountNumber;
      payload.folioNumber =  vm.formData.folioNumber;
      payload.flowName = 'SIP_PURCHASE';
      payload.cartItems = [];

      var keyArray = ["folioNumber", "schemeCode", "schemeName", "amount", "dividendOption", "brokerCode", "subBrokerCode",
        "subBrokerArn", "euinOpted", "euinCode", "euinName", "minorFlag", "riaConsent", "cartItemId", "cgfApplicable",
        "liquid", "sipDate", "toDate", "installmentAmount", "sipDay", "frequency", "sipOpted", "purchaseOpted", "retirementApplicable", "fundCode", "fundName", "riaOpted", "sourcePortal", "invType"];
      for (var i = 0; i < vm.savedData.cartItems.length; i++) {
        var cartItem = {};
        Object.keys(vm.savedData.cartItems[i]).forEach(function (key) {
          if (keyArray.includes(key) && (angular.isDefined(vm.savedData.cartItems[i][key]) && vm.savedData.cartItems[i][key] !== "")) {
            cartItem[key] = vm.savedData.cartItems[i][key];
          }
        });
        payload.cartItems.push(cartItem);
      }

      delete payload.cartItems[0].camsReferenceNo;

      if (payload.cartItems[0].brokerCode === 'DIRECT') {
        payload.cartItems[0].brokerCode = '';
      }

      payload.secretLink = sessionStorage.getItem('sl');

      if(vm.formData.selectedPaymentOption && vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.EMANDATE) {
        payload.emandateStartDate = moment(vm.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
        payload.emandateEndDate = moment(vm.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY');
        payload.mandateAmount = vm.formData.emandateAmount;
      }


      if (vm.formData.selectedPaymentOption && vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP) {
        payload.paymentModeSip = "UAP";
        payload.payerName = vm.name;
        payload.branchName =  angular.copy(vm.bankInfoUPI.bankBranch);
        payload.bankCity = angular.copy(vm.bankInfoUPI.bankCity);
        payload.bankCode = angular.copy(vm.bankInfoUPI.bankCode);
        payload.payerVpa = vm.formData.paymentInfo.virtualAddress;
        payload.upiReferenceNumber = vm.transactionNumber;
        payload.accNo = vm.upiAccountNumber;
        payload.bankName= vm.upiBankName;
        payload.accType = vm.bankInfoUPI.bankAcType ? vm.bankInfoUPI.bankAcType : vm.formData.paymentInfo.accType;
        payload.ifscCode = vm.bankInfoUPI.ifscCode ? vm.bankInfoUPI.ifscCode : vm.formData.paymentInfo.ifscCode;
        payload.gatewayVendor = null;
        delete payload.virtualAddress;

        payload.intent = vm.isIntent && vm.selectedUpiOption && vm.selectedUpiOption !== 'OTHERS'? 'Y' : 'N';
        payload.paymentGatewayType = vm.selectedUpiOption && vm.selectedUpiOption === 'OTHERS' ? null : vm.selectedUpiOption;

      } else if (vm.formData.selectedPaymentOption && vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.OTM) {
        payload.paymentModeSip = 'OTM';
        payload.branchName =  angular.copy(vm.bankInfo.bankBranch);
        payload.bankCity = angular.copy(vm.bankInfo.bankCity);
        payload.bankCode = angular.copy(vm.bankInfo.bankCode);
        payload.bankName = angular.copy(vm.bankInfo.bankName);
        payload.accNo = angular.copy(vm.bankInfo.bankAcNo);
        delete payload.bankAcNo;
        delete payload.virtualAddress;
      } else if (vm.formData.selectedPaymentOption && vm.formData.selectedPaymentOption === 'Net_Banking') {
        payload.paymentModeSip = 'EC';
        payload.bankName = angular.copy(vm.bankInfo.bankNameOnly);
        payload.branchName =  angular.copy(vm.bankInfo.bankBranch);

        // if (vm.showDatesManupilateError) {
        //   vm.formData.startDate =  angular.copy(vm.billerDateRequired);
        //   payload.cartItems[0].sipDate = vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY').toString() : '';
        //   updateEndDates();
        //   payload.cartItems[0].toDate = vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY').toString() : '';
        //   vm.formData.day = vm.formData.startDate ? $window.moment(vm.formData.startDate, "DD-MMM-YYYY").format('D') : '';
        //   payload.cartItems[0].sipDay = vm.formData.day;
        // }
      }


      payload.preLogin = false;
      payload.newAcknowledgeScreen = true;
      payload.netCoreRefNo = $stateParams.trackId ? $stateParams.trackId : null;


      return payload;
    }


    /**
     * Function responsible for handling final call for final submit
     */

    function finalSubmitCart(payload) {

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.cartID = resp.data.cartId;
            userActivityTracking(true, function(){

              if(!resp.data.redirectUrl)
              {
                MessageService.error(resp.data.message);
                $state.go('main.transactions.purchase');
              }

              if(vm.bankInfo && vm.bankInfo.gateWayVendor==="BILLDESK")
              {
                LoaderService.showLoader();
                vm.billdeskPayload.msg = resp.data.redirectUrl;
                $timeout(function () {
                  angular.element('#billdeskForm').submit();
                });

              }
              else if (vm.bankInfo && vm.bankInfo.gateWayVendor == 'BILLJUNCTION') {
                LoaderService.showLoader();
                $window.open(resp.data.redirectUrl, '_self');
              } else if (vm.bankInfo && vm.bankInfo.gateWayVendor === "RAZORPAY") {
                var payloadData = resp.data;
                payloadData.trnxActionMsg = payloadData.redirectUrl;
                PaymentService.openRazorPay(payloadData);
              } else if (vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP){
                if (vm.isIntent) {
                  if (resp.data.mobileDeepLink) {
                    sessionStorage.setItem('intent', resp.data.mobileDeepLink);
                  }
                  // $window.location.href = data.redirectUrl;

                  // Create a URL object
                  var urlObj = new URL(resp.data.redirectUrl);

                  // Extract parameters from the URL using searchParams
                  var id = urlObj.searchParams.get('id');   // Get 'id' parameter
                  var type = urlObj.searchParams.get('type'); // Get 'type' parameter

                  $state.go('upi.waiting',{
                    id: id,
                    type: type
                  })

                } else {
                  $window.location.href = resp.data.redirectUrl;
                }
              } else if(vm.formData.selectedPaymentOption == vm.PAYMENT_OPTIONS.OTM) {
                $state.go("payment-status", {
                  cart_id: resp.data.cartId,
                  tType: vm.formData.investmentType
                });
              }
            });

            } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message,
                showBlueBtn: true
              });
            } else {
              MessageService.error(resp.message);
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

        TransactionServiceVersion.post({
          controller1: 'cart',
          controller2: 'checkout'
        }, payload).$promise.then(success, error);

    }

    var stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
      TransactionModel.setPayloadRawData(null);
    });

    $scope.$on('$destroy', function () {
      stateChangeStart();
    })

    /**
     * Function responsible for AddUpdate/Behaviour data form
     */
    function getSipPurchasePayloadForAddUpdate(from) {
      if (vm.formData.investmentType === 'SIP') {
        var sipPayload = {
          amount: vm.formData.amount,
          investmentOption: vm.formData.investmentOption,
          dividendOption: vm.formData.dividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          frequency: vm.formData.frequency,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          schemeType: vm.formData.schemeType,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          toDate: vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY').toString() : '',
          sipDate: vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY').toString() : '',
          sipDay: vm.formData.day,
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          id: vm.linkID ? vm.linkID : vm.formData.sTransactionId,
          subBrokerArn: vm.formData.subBrokerARN ? vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode ? vm.formData.subBrokerCode : '',
          brokerCode: vm.formData.brokerCode,
          secretLink: vm.secretLink,
          netCoreRefNo : $stateParams.trackId ? $stateParams.trackId : null,
          payment_mode_key: vm.formData.selectedPaymentOption
        }
      }
      if (vm.formData.investmentType === 'PURCHASE' || (from === "USER_BEHAVIOUR" && vm.isSipPurchase)) {
        var purchasePayload = {
          amount: vm.formData.purchaseAmount,
          investmentOption: vm.formData.investmentOption,
          dividendOption: vm.formData.dividendOption,
          folioNumber: vm.formData.folioNumber,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          schemeCode: vm.isSipPurchase ? vm.formData.inSchemeCode : vm.formData.purchaseInSchemeCode,
          retirementAgeProofURL: vm.formData.retirementAgeProofURL ? vm.formData.retirementAgeProofURL : '',
          euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
          euinCode:vm.formData.euin?vm.formData.euin.euinCode:'',
          euinName:vm.formData.euin?vm.formData.euin.euinName:'',
          id: vm.linkID ? vm.linkID : vm.formData.pTransactionId,
          paymentInfo: getPaymentInfo(vm.isSipPurchase ? from : null),
          subBrokerArn: vm.formData.subBrokerARN ? vm.formData.subBrokerARN : '',
          subBrokerCode: vm.formData.subBrokerCode ? vm.formData.subBrokerCode : '',
          checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
          autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null,
          autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null,
          secretLink: vm.secretLink,
          netCoreRefNo : $stateParams.trackId ? $stateParams.trackId : null,
          payment_mode_key: vm.formData.selectedPaymentOption
        }
      }

      if (purchasePayload && purchasePayload.paymentInfo.accountNumber) {
        purchasePayload.accountNumber = purchasePayload.paymentInfo.accountNumber;
        //delete purchasePayload.paymentInfo.accountNumber;
      }
      if (purchasePayload && purchasePayload.paymentInfo.tpvEnableFlag) {
        purchasePayload.tpvEnableFlag = purchasePayload.paymentInfo.tpvEnableFlag;
        delete purchasePayload.paymentInfo.tpvEnableFlag;
      }

      if (vm.formData.investmentType === 'SIP' && vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP) {
        sipPayload.payerVpa = vm.formData.paymentInfo.virtualAddress;
        sipPayload.payerName = vm.name;
        sipPayload.paymentOption = vm.camsCode;
      }


      var payload = {};

      switch (vm.formData.investmentType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          purchasePayload = handleBrokerCode(purchasePayload);
          payload = angular.copy(purchasePayload);
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          if(from === "USER_BEHAVIOUR" && vm.isSipPurchase) {
            purchasePayload = handleBrokerCode(purchasePayload);
            payload = angular.copy(purchasePayload);
            if(vm.cartID) {
              payload.id = vm.cartID;
            } else {
              payload.id = vm.savedData.cartItems[0].cartItemId;
            }
            payload.startSipDetails = {
              "amount" : vm.isSipPurchase && vm.formData.sipAmount,
              "frequency": vm.formData.frequency,
              "startDate": $window.moment(vm.formData.startDate).format("DD-MMM-YYYY"),
              "endDate": $window.moment(vm.formData.endDate).format("DD-MMM-YYYY")
            };
            payload.startSipEnabled = vm.formData.sipViaPurchaseSelected;
          } else {
            sipPayload = handleBrokerCode(sipPayload);
            payload = angular.copy(sipPayload);
          }
          break;
      }


      if(vm.formData.investmentType==='SIP' && !vm.isSipPurchase) {
        if (vm.formData.sipFirstInstallment) {
          payload.sipWithFirstInstallment = vm.formData.sipFirstInstallment;
          payload.firstInstallmentDetails = getPaymentInfo();
        }

        if(vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.EC || vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP || (vm.formData.sipFirstInstallment && vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.NETBANKING)) {

          // setting bankinfo for upi and biller
          var bankInfo = vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP ? angular.copy(vm.bankInfoUPI) : angular.copy(vm.bankInfo);

          payload.bankDetailsForECS= {
            accNumber: bankInfo.accountNumber,
            bankName: bankInfo ? bankInfo.bankName : vm.formData.bankName,
            ifscCode: bankInfo.ifscCode ? bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode,
            branchName: bankInfo.bankBranch,
            bankCity: bankInfo.bankCity,
            paymentOption: vm.camsCode,
            netBankingUrl:vm.formData.netBankingUrl,
            bankCode: bankInfo ? bankInfo.bankCode:null,
            accType: bankInfo.bankAcType ? bankInfo.bankAcType : vm.formData.paymentInfo.accType
          }

          if (vm.formData.sipFirstInstallment && vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.NETBANKING) {
            payload.bankDetailsForECS.paymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          }
        }
        else if(vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.EMANDATE) {
          payload.bankDetailsForECS= {
            accNumber: vm.bankInfo ? vm.bankInfo.accountNumber:'',
            bankName: vm.bankInfo ? vm.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.bankInfo.ifscCode,
            branchName: vm.bankInfo.bankBranch,
            bankCity: vm.bankInfo.bankCity,
            paymentOption: vm.camsCode,
            accType:vm.bankInfo.bankAcType,
            bankCode:vm.bankInfo ? vm.bankInfo.bankCode:null,
            authenticationMode:vm.formData.authMode.value
          }

          payload.mandateStartDate = vm.formData.emandateDate ? $window.moment(vm.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null;
          payload.mandateEndDate = vm.formData.endDateEmandate ? $window.moment(vm.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null;
          payload.mandateAmount = vm.formData.emandateAmount ? vm.formData.emandateAmount : null;
        }
        else if(vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.OTM) {
          payload.bankDetailsForECS= {
            accNumber: vm.bankInfo.bankAcNo,
            bankName: vm.bankInfo ? vm.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.bankInfo.ifscCode ? vm.bankInfo.ifscCode : vm.formData.paymentInfo.ifscCode,
            branchName: vm.bankInfo.bankBranch,
            bankCity: vm.bankInfo.bankCity,
            paymentOption: vm.camsCode,
            payoutId:vm.bankInfo.payoutId,
            bankCode:vm.bankInfo ? vm.bankInfo.bankCode:null,
            accType: vm.bankInfo.bankAcType ? vm.bankInfo.bankAcType : vm.formData.paymentInfo.accType,
            camsMandateIdNo: vm.bankInfo.camsMandateIdNo,
            omUmrn: vm.bankInfo.omUmrn
          }
        }
        if(vm.formData.sipTopupEnabled) {
          payload.sipTopupEnabled=vm.formData.sipTopupEnabled;
          payload.topupDetails=vm.formData.topupDetails;
        }
        if (vm.formData.selectedPaymentOption === vm.PAYMENT_OPTIONS.UPISIP) {
          payload.intent = vm.isIntent && vm.selectedUpiOption && vm.selectedUpiOption !== 'OTHERS'? 'Y' : 'N';
          payload.paymentGatewayType = vm.selectedUpiOption && vm.selectedUpiOption === 'OTHERS' ? null : vm.selectedUpiOption;
        }

      }
      payload.newAcknowledgeScreen = true;
      if(vm.cancelTransactionRequestBody){
        payload.cancelTransactionRequestBody = vm.cancelTransactionRequestBody;
      }
      return payload;
    }

    function fetchInvestmentOption(investmentOption) {
      var investmentOptionKey = "";
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == investmentOption) {
          investmentOptionKey = key;
        }
      });
      return investmentOptionKey;
    }

    function getRandomOTPId() {
      var successRandomOTPIdHandler = function(resp) {
        vm.randomOTPId = resp.randomOTPId ? resp.randomOTPId : null;
      }, errorRandomOTPIdHandler = function (){}
      UtilService.getRandomOTPId().then(successRandomOTPIdHandler, errorRandomOTPIdHandler);
    }

  }
})();

/**
 * Created by ttn on 27/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NotificationController', notificationController);

  /** @ngInject */
  function notificationController($window, LoaderService, InvestorService, MessageService, ModalService, UtilService) {

    var vm = this;

    vm.notificationData = {};
    vm.init = init;

    /*var months = {
      'Jan': 0,
      'Feb': 1,
      'Mar': 2,
      'Apr': 3,
      'May': 4,
      'Jun': 5,
      'Jul': 6,
      'Aug': 7,
      'Sep': 8,
      'Oct': 9,
      'Nov': 10,
      'Dec': 11
    };*/

    /*function sortEvent(arr) {
      var today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setHours(0);
      today.setMilliseconds(0);
      var todayDate = today.getTime();
      var lastSevenDays = ((new Date()).getTime()) - (7 * 24 * 60 * 60 * 1000);
      var notificatioArr = {today: [], lastsevendays: [], history: []};
      arr.filter(function (item) {
        var dateArr = item.createdDate.split(' ');
        var dateMonthArr = dateArr[0].split('-');
        var date = new Date(parseInt(dateMonthArr[2]), parseInt(months[dateMonthArr[1]]), parseInt(dateMonthArr[0]), 0, 0, 0, 0);
        item.timestamp = date.getTime();
        if (item.timestamp == todayDate) {
          notificatioArr.today.push(item);
        }
        else if (item.timestamp < todayDate && item.timestamp >= lastSevenDays) {
          notificatioArr.lastsevendays.push(item);
        }
        else {
          notificatioArr.history.push(item);
        }
        return item;
      });
      return notificatioArr;
    }*/

    function sortDate(arr) {
      var notificatioArr = {today: [], lastsevendays: [], history: []};
      arr.filter(function (item) {
        var date = $window.moment();
        date.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        var created = $window.moment(item.createdDate).set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        var diff = Math.abs(date.diff(created, 'days'));

        if(diff == 0){
          notificatioArr.today.push(item);
        } else if (diff<=7) {
          notificatioArr.lastsevendays.push(item);
        } else {
          notificatioArr.history.push(item);
        }
      });
      return notificatioArr;
    }

    function init() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
          //  vm.notificationData = sortEvent(resp.data.notificationList);
            vm.notificationData = sortDate(resp.data.notificationList);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorService.get({
        child1: 'notification',
        child2: 'all'
      }).$promise.then(success, error);
    }

    vm.notificationDetails = function (notification) {
      ModalService.notificationDetailModal(notification);
    };

  }
})();

/**
 * Created by ttn on 22/11/2021.
 */

(function () {
    'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NfsservicesController', nfsservicesController);

    /** @ngInject */
    function nfsservicesController($scope, $stateParams, $state,$http,HDFC_API, $rootScope,LoaderService,InvestorService, MessageService,$log, $q, $window, AuthService){
      var vm = $scope;
      vm.basic = {};
      vm.banner = [];
      vm.desktop_banner;
      vm.mobile_banner;
      vm.nfsservices = [];

      vm.fetchDynamicData =  function() {
        var defer = $q.defer();
        LoaderService.showLoader();
          var successHandler = function(resp) {
          LoaderService.hideLoader();
            if (resp.status && resp.data) {
              defer.resolve(resp.data);
              vm.basic = resp.data;
              vm.banner = vm.basic.tileDTO.headerImageUrl.split("|");
              vm.desktop_banner = vm.banner[0];
              vm.mobile_banner = vm.banner[1];
              vm.nfsservices = vm.basic.tileDTO.servicesList;
            } else {
              defer.reject(resp.data);
            }
          };
                   
          var errorHandler = function(resp) {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          };       
          var payload = {
            "pageName":"SERVICE_SCREEN",
            "portal":"InvestorPortal",
             "platform":"WEB"
          };
          InvestorService.post({"child1": "dynamicContent"}, payload)
            .$promise.then(successHandler, errorHandler);
        return defer.promise;
      };
      vm.trackApiRequest = function(mappingid){
      try{
        var defer = $q.defer();
        var data = AuthService.getToken();
        var token = data.token_type+' '+data.access_token; 
        localStorage.setItem('token', token);
        LoaderService.showLoader();
        var successHandler = function(resp) {
        localStorage.removeItem('token');
        LoaderService.hideLoader();
          if (resp.status && resp.$resolved) {
            defer.resolve(resp.data);
          } else {
            defer.reject(resp.data);
          }
        };
                 
        var errorHandler = function(resp) {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        };       
        
        var payload = {
          "mappingId": mappingid
        }
        InvestorService.post2({"child1": "trackApiRequest"}, payload).$promise.then(successHandler, errorHandler);
      return defer.promise;
      }
        catch(e){
            
        }
      }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('NewInvestorController', NewInvestorController);

  /** @ngInject */
  function NewInvestorController($window, $rootScope, $timeout, $state, $stateParams, $scope, AuthService, HDFC_API, toastr, LoaderService,
    AppConstants, TransactionService, MessageService, ModalService, UtilService, CommonFactory, CreatePayloadFactory, InvestorService,
    deviceDetector, $http, $sce, NetcoreEvntService, $log, BrowserService, investorServiceVersion, InvestorServiceVersion3, MetaTagService) {
    var vm = this;
    vm.panMessage = "";
    var removeListeners = {};
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    vm.backStateList = AppConstants.BACK_ROUTE;
    vm.folioBackStat = AppConstants.BACK_ROUTE2;
    vm.folioBackStateAnyor = AppConstants.BACK_ROUTE3;
    vm.folioBackStateMinor = AppConstants.BACK_ROUTE4;
    $rootScope.refreshme = false;
    $rootScope.currentstate = $state.current.url;
    $rootScope.myState = $state.current.url;
    /*----------------function declarations----------------*/
    sessionStorage.removeItem("investorIsBackButtonClick");
    vm.init = init;

    history.pushState(null, null, location.href);
    window.onpopstate = function (e) {
      history.go(1);
      e.preventDefault();
      if ($rootScope.refreshme) {
        $window.location.reload();
      }

    };

    $rootScope.testObj = {
      "steps": [{
        step: 1,
        name: "KYC Verification",
        expanded: true,
        stepActive: true,
        investorName: '',
        panNumber: '',
        stepCompleted: false,
        state: 'newInvestor.kycVerification'
      }, {
        step: 2,
        name: "Investment Details",
        expanded: true,
        stepActive: false,
        schemeName: '',
        frequency: '',
        schemeInfo: {
          amount: null,
          investmentType: ''
        },
        stepCompleted: false,
        state: 'newInvestor.investmentDetails.schemedetails.selectscheme'
      }, {
        step: 3,
        name: "Folio Creation",
        expanded: true,
        stepActive: false,
        stepCompleted: false,
        state: 'newInvestor.folioDetails.baiscDetails'
      }]
    };

    $rootScope.$on("moveforward", function () {
      $rootScope.testObj.steps[2].stepCompleted = true;
      $state.go('newInvestor.NewInvestorPayment');
    });


    $rootScope.stepperSecondary = {
      "steps": [{
        step: 1,
        name: "Scheme Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
        // state: 'newInvestor.investmentDetails.schemedetails'
      }, {
        step: 2,
        name: "Investment Mode",
        expanded: true,
        stepActive: false,
        stepCompleted: false,
        // state: 'newInvestor.investmentDetails.investmentmode'
      }, {
        step: 3,
        name: "Amount Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false,
        // state: 'newInvestor.investmentDetails.amountdetails'
      }
      ]
    };

    $rootScope.logoutBtn = function(){
      var success = function (resp) {
        if (resp.status) {
          MessageService.success(resp.message);
          $state.go('newInvestor.kycVerification');
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader('.logout');
      },
        error = function (err) {
          LoaderService.hideLoader('.logout');
          MessageService.error(err.data.message);
        };
      LoaderService.showLoader('.logout');

      var Details = JSON.parse(sessionStorage.getItem("userData"));
      var Data = {
        "panNumber": Details.panNumber
        }
      InvestorService.post({
        child1: 'force',
        child2: 'logout'
      }, Data).$promise.then(success, error);
    }
    $rootScope.backbtn = function () {
      sessionStorage.setItem("investorIsBackButtonClick", true);
      sessionStorage.removeItem("onotp");
      var backData = sessionStorage.getItem('folioStateData');
      if($state.current.url == "/folio-basic-details" || $state.current.url == "/folio-basic-minor-details"){
        if(vm.distributorDetails && vm.distributorDetails.transactionType == 'Purchase_Scheduler'){

        }else{
          sessionStorage.setItem('folioStateData','BACK_ROUTE');
          $state.go('newInvestor.investmentDetails.amountdetails');
        }
      }else{
      switch (backData) {
        case 'BACK_ROUTE':
          // Investment details
          vm.backStateList.forEach(function (item, Length) {
            if ($state.current.url == item.url && $state.current.url != "/schemedetails") {
              $state.go(vm.backStateList[Length - 1].state);
            }
            $rootScope.currentstate = $state.current.url;
          });
        break;
        case 'BACK_ROUTE2':
          // self single
          vm.folioBackStat.forEach(function (item, Length) {
            if ($state.current.url == item.url && $state.current.url != "/folio-basic-details") {
              $state.go(vm.folioBackStat[Length - 1].state);
            }
            $rootScope.currentstate = $state.current.url;
          });
          break;
        case 'BACK_ROUTE3':
          // any or survivor
          vm.folioBackStateAnyor.forEach(function (item, Length) {
            if ($state.current.url == item.url && $state.current.url != "/folio-basic-details") {
              $state.go(vm.folioBackStateAnyor[Length - 1].state);
            }
            $rootScope.currentstate = $state.current.url;
          });
          break;
        case 'BACK_ROUTE4':
          // minor
          vm.folioBackStateMinor.forEach(function (item, Length) {
            if ($state.current.url == item.url && $state.current.url != "/folio-basic-minor-details") {
              $state.go(vm.folioBackStateMinor[Length - 1].state);
            }
            $rootScope.currentstate = $state.current.url;
          });
          break;
        default:

      }
    }
    }

    $rootScope.handleSideBarClick = function(state) {
      sessionStorage.setItem("previousState", vm.investorSelection);
      $rootScope.previousLocation = vm.investorSelection;
      if (state === AppConstants.INVESTOR_SELECTION.EXISTING_USER) {
        vm.investorSelection = AppConstants.INVESTOR_SELECTION.EXISTING_USER;
        UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.EXISTING_USER);
      } else if (state === AppConstants.INVESTOR_SELECTION.NEW_INVESTOR) {
        vm.investorSelection = AppConstants.INVESTOR_SELECTION.NEW_INVESTOR;
        UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.NEW_INVESTOR);
        // vm.init();
      } else if (state === AppConstants.INVESTOR_SELECTION.QUICK_INVEST) {
        UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.QUICK_INVEST);
      }
    };
    $rootScope.handleSideBarClick("NEW_INVESTOR");
    init();
    function init() {
      if($state.current.url == "/new-investor"){
        $state.go("newInvestor.kycVerification");
      }
      vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
      if(vm.distributorDetails){
        vm.showHeaderFooter = false;
      }else{
        vm.showHeaderFooter = true;
      }
      if($state.current.url == "/kyc-verification"){

        $rootScope.cUrl = true;

        }else{

        $rootScope.cUrl = false;

        }
      var verifyObjDataFrom = JSON.parse(sessionStorage.getItem("verifyObj"));
      if(verifyObjDataFrom && (verifyObjDataFrom.flowName === 'ECART')){
        $state.go("newInvestor.investorProfile");
      } else {
        callingFromInit();
      }
    }

    $rootScope.setUsetInfo = function () {
      var verifyObjData = $state.params.verificationData ? $state.params.verificationData : JSON.parse(sessionStorage.getItem("verifyObj"));
      $rootScope.testObj.steps[0].panNumber = verifyObjData.panNumber;
      $rootScope.testObj.steps[0].investorName = verifyObjData.panHolderName;
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepActive = true;
    }
    /* function responsible to identify the device width and add attribute to date input*/
    function checkDeviceSize() {
      if ($(window).width() <= 767) {
        $(".newinvestor-dob").attr({
          'readonly': 'true'
        });
      } else {
        $(".newinvestor-dob").removeAttr('readonly');
      }
    }

    removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
      // if (localStorage.getItem('isRefreshing') === 'true') {
      //   AuthService.clearCookies(AppConstants.IDENTIFIER);
      //   return;
      // }
      // localStorage.setItem('isRefreshing', true);
      var token = AuthService.getToken();
      var d = sessionStorage.getItem('ErrorStep');
      if (!token) {
        AuthService.clearCookies(AppConstants.IDENTIFIER);
        $timeout(function () {
          if(!d){
            // UtilService.errorHandler({ message: "Session has been expired. Please login to continue." });
        }
        sessionStorage.removeItem('ErrorStep');
          $rootScope.resertvalue();
          // MessageService.error('Session has been expired. Please login to continue.');
          $state.go('newInvestor.kycVerification');
        }, 0);
        //resetFlag();
        return;
      }
      if (token && token.refresh_token) {
        AuthService.getRefreshTokenForNewInvestor(token).then(function () {
          if (localStorage.getItem('doLogOut')) {
            AuthService.logout().then(function () {
              AuthService.clearCookies(AppConstants.IDENTIFIER);
              $rootScope.resertvalue();
              // MessageService.error('Session has been expired. Please login to continue.');
              $state.go('newInvestor.kycVerification');
            }, function () {
              // UtilService.errorHandler({ message: "Session has been expired. Please login to continue." });
              $rootScope.resertvalue();
              // MessageService.error('Session has been expired. Please login to continue.');
              $state.go('newInvestor.kycVerification');
            });
          } else {
            //resetFlag();
            $state.reload();
          }
        }, function () {
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          MessageService.clear();
          UtilService.errorHandler({ message: "Session has been expired. Please login to continue." });
          $rootScope.resertvalue();
          // MessageService.error('Session has been expired. Please login to continue.');
          $state.go('newInvestor.kycVerification');
          // resetFlag();
        });
      } else {
        //resetFlag();
        AuthService.clearCookies(AppConstants.IDENTIFIER);
        MessageService.clear();
        // UtilService.errorHandler({ message: "Session has been expired. Please login to continue." });
        $rootScope.resertvalue();
        // MessageService.error('Session has been expired. Please login to continue.');
        $state.go('newInvestor.kycVerification');
      }
    });


    $rootScope.resertvalue = function () {
      sessionStorage.removeItem("investorIsBackButtonClick");
      $rootScope.testObj.steps[0].stepCompleted = false;
      $rootScope.testObj.steps[1].stepCompleted = false;
      $rootScope.testObj.steps[2].stepCompleted = false;
      $rootScope.testObj.steps[0].stepActive = true;
      $rootScope.testObj.steps[1].stepActive = false;
      $rootScope.testObj.steps[2].stepActive = false;
      $rootScope.testObj.steps[0].investorName = '';
      $rootScope.testObj.steps[0].panNumber = '';
      $rootScope.testObj.steps[1].investorName = '';
      $rootScope.testObj.steps[1].panNumber = '';
      $rootScope.testObj.steps[1].schemeName = '';
      $rootScope.testObj.steps[1].frequency = '';
      $rootScope.testObj.steps[1].schemeInfo.amount = null;
      $rootScope.testObj.steps[1].schemeInfo.investmentType = '';
    }

    function callingFromInit(){
      var identifierData = AuthService.getToken();
      if (CommonFactory.getSessionExpired()) {
        MessageService.error('Session has been expired');
      }
      if (localStorage.getItem('panNo')) {
        localStorage.removeItem('panNo');
      }
      if (localStorage.getItem('dob')) {
        localStorage.removeItem('dob');
      }
      MetaTagService.setMetaTags(AppConstants.META_TAGS.LOGIN_DESCRIPTION, AppConstants.META_TAGS.LOGIN_TITLE, AppConstants.META_TAGS.KEYWORDS);
      checkDeviceSize();

      LoaderService.showLoader();
      var detailsSuccess = function (result) {
          $window.sessionStorage.setItem("userData", JSON.stringify(result.data));
          if (vm.distributorDetails) {
            $state.current.url
            if ($state.current.url == '/selectscheme' || $state.current.url == '/investmentGoal'
              || $state.current.url == '/amountdetails' || $state.current.url == '/investmentmode') {
              result.data.step = "FIRST";
            }
            if ($state.current.url == '/bankdetails' || $state.current.url == '/folio-nominee-details' ||
              $state.current.url == '/folio-joint-holder-details' || $state.current.url == '/folio-income-details' ||
              '/folio-guardian-minor-details' || $state.current.url == '/folio-basic-minor-details' ||
              $state.current.url == '/folio-guardian-minor-details' ||
              $state.current.url == '/folio-guardian-minor-details') {
              result.data.step = "FIRST";
            }
          }
          var data = result.data;
          if (identifierData && data && data.step) {
            if (data.step == "FIRST" || data.step == "SECOND" || data.step == "THIRD") {
            }else if (data.step == "HOLD") {
              $state.go('login')
            }
            else if (data.step == "FOURTH") {
              vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
              if(vm.distributorDetails && vm.distributorDetails.transactionType == 'Purchase_Scheduler'){

              }else{
                $state.go("newInvestor.NewInvestorPayment");
              }
            }
            else if (data.step == "FIFTH") {
              vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
              vm.mobileLoginPandetails = sessionStorage.getItem('MobilePanLoginDetails')?JSON.parse(sessionStorage.getItem('MobilePanLoginDetails')) :null;
              if(vm.distributorDetails && vm.distributorDetails.transactionType == 'Purchase_Scheduler'){
                
              }else if(vm.mobileLoginPandetails && vm.mobileLoginPandetails.throughPrelimanaryDashboard){
                vm.data ={
                  text:"You can use your mobile number for login",
                  buttonText: "Proceed to login"
                }
                ModalService.loginWithMobileNoteNJModal(vm.data,function(){},function(){});
              }else{
                $state.go("newInvestor.investorProfile");
              }
            }
            else {
              $state.go("newInvestor.kycVerification");
            }
          } else {
            $state.go("newInvestor.kycVerification");
          }

          LoaderService.hideLoader();
        },
        derror = function (err) {
          // MessageService.error(AppConstants.ToastrMessage.FAILED);
          LoaderService.hideLoader();
        };
      var payload = {};
      var verifyObjData = $state.params.verificationData ? $state.params.verificationData : JSON.parse(sessionStorage.getItem("verifyObj"));
      if(verifyObjData && verifyObjData.panNumber && !verifyObjData.isFromKycUpdate){
        payload.panNumber = verifyObjData.panNumber;
        InvestorService.post({
          child1: 'new',
          child2: 'user',
          child3: 'getDetails'
        }, payload).$promise.then(detailsSuccess, derror);
      }else{
        $state.go("newInvestor.kycVerification");
        LoaderService.hideLoader();
      }
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .config(newInvestor);

  /** @ngInject */
  function newInvestor($stateProvider) {
    $stateProvider
      .state('newInvestor.kycVerification', {
        url: '/kyc-verification',
        params: {
          verificationData: null
        },
        templateUrl: 'app/new-investors/kyc-verification/kyc-verification.html',
        controller: 'KycVerificationController',
        controllerAs: 'KycVerification',
        authenticate: true
      })
      .state('newInvestor.otpVerification', {
        url: '/otp-verification',
        params: {
          verificationData: null
        },
        templateUrl: 'app/new-investors/otp-verification/otp-verification.html',
        controller: 'OtpVerificationController',
        controllerAs: 'OtpVerification',
      })
      .state('newInvestor.folioDetails', {
        url:'/folio-details',
        templateUrl: 'app/new-investors/folio-details/folio-details.html',
        controller: 'FolioDetailsController',
        controllerAs: 'FolioDetails',
        defaultRoute: '.baiscDetails',
        authenticate: true
      })
      .state('newInvestor.folioDetails.baiscDetails', {
        url:'/folio-basic-details',
        templateUrl: 'app/new-investors/folio-details/folio-basic-details/folio-basic-details.html',
        controller: 'FolioBasicDetailsController',
        controllerAs: 'FolioBasicDetails',
        authenticate: true
      })
      .state('newInvestor.folioDetails.baiscMinorDetails', {
        url:'/folio-basic-minor-details',
        templateUrl: 'app/new-investors/folio-details/folio-basic-minor/folio-basic-minor.html',
        controller: 'FolioBasicMinorDetailsController',
        controllerAs: 'FolioBasicMinorDetails',
        authenticate: true
      })
      .state('newInvestor.folioDetails.guardianMinorDetails', {
        url:'/folio-guardian-minor-details',
        templateUrl: 'app/new-investors/folio-details/folio-basic-minor-guardian/folio-basic-minor-guardian.html',
        controller: 'FolioMinorGuardianDetailsController',
        controllerAs: 'FolioMinorGuardianDetails',
        authenticate: true
      })
      .state('newInvestor.folioDetails.incomeDetails', {
        url:'/folio-income-details',
        templateUrl: 'app/new-investors/folio-details/folio-income-details/folio-income-details.html',
        controller: 'FolioIncomeDetailsController',
        controllerAs: 'FolioIncomeDetails',
        authenticate: true
      })
      .state('newInvestor.folioDetails.jointHolderDetails', {
        url:'/folio-joint-holder-details',
        templateUrl: 'app/new-investors/folio-details/folio-holder-details/folio-holder-details.html',
        controller: 'FolioJointHolderDetailsController',
        controllerAs: 'FolioJointHolderDetails',
        authenticate: true,
        resolve: {
          dynamicData : _fetchDynamicData
        }
      })
      .state('newInvestor.folioDetails.nomineeDetails', {
        url:'/folio-nominee-details',
        templateUrl: 'app/new-investors/folio-details/folio-nominee-details/folio-nominee-details.html',
        controller: 'FolioNomineeDetailsController',
        controllerAs: 'FolioNomineeDetails',
        authenticate: true,
        resolve: {
          DynamicDataNominee : _fetchDynamicData
        }
      })
      .state('newInvestor.folioDetails.bankdetails', {
        url:'/bankdetails',
        templateUrl: 'app/new-investors/folio-details/bank-details/bank-details.html',
        controller: 'BankDetailsController',
        controllerAs: 'BankDetails',
        authenticate: true
      })
      .state('newInvestor.summarypage', {
        url:'/summary',
        templateUrl: 'app/new-investors/folio-details/summary/summary-page.html',
        controller: 'SummaryPageController',
        controllerAs: 'SummaryPage',
        authenticate: true
      })
      .state('newInvestor.NewInvestorPayment',{
        url:'/pay-now',
        templateUrl: 'app/new-investors/payment/new-investor-payment.html',
        controller: 'NewInvestorPaymentController',
        controllerAs: 'NewInvestorPayment',
        authenticate: true
      })
      .state('newInvestor.investorProfile',{
        url:'/investor-profile',
        templateUrl: 'app/new-investors/investo-profile/investo-profile.html',
        controller: 'InvestorProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true
      })
      .state('newInvestor.otp',{
        url:'/otp',
        templateUrl: 'app/new-investors/investo-profile/investor-profile-otp-verify.html',
        controller: 'InvestorProfileController',
        controllerAs: 'InvestorProfileOtp',
        authenticate: true
      })
      .state('newInvestor.investmentDetails', {
        url: '/investment-details',
        templateUrl: 'app/new-investors/investment-details/investment-detail.html',
        controller: 'KycVerificationController',
        controllerAs: 'KycVerification',
        defaultRoute: '.schemedetails',
        authenticate: true
      })
      .state('newInvestor.investmentDetails.investmentmode',{
        url:'/investmentmode',
        templateUrl: 'app/new-investors/investment-details/investment-mode/investment-mode.html',
        controller: 'InvestmentModeController',
        controllerAs: 'InvestmentMode',
        authenticate: true
      })
      .state('newInvestor.investmentDetails.amountdetails',{
        url:'/amountdetails',
        templateUrl: 'app/new-investors/investment-details/amount-details/amount-details.html',
        controller: 'AmountDetailsController',
        controllerAs: 'AmountDetails',
        authenticate: true,
        resolve: {
          DynamicDataSip : _fetchDynamicData
        }
      })
      .state('newInvestor.investmentDetails.schemedetails',{
        url:'/schemedetails',
        templateUrl: 'app/new-investors/investment-details/scheme-details/scheme-investment-goal.html',
        controller: 'SchemeInvestmentController',
        controllerAs: 'schemeInvestmentGoal',
        defaultRoute: '.selectscheme',
        authenticate: true
      })
      .state('newInvestor.investmentDetails.schemedetails.investmentGoal',{
        url:'/investmentGoal',
        templateUrl: 'app/new-investors/investment-details/scheme-details/investment-goal/investment-goal.html',
        controller: 'InvestmentGoalController',
        controllerAs: 'InvestmentGoal',
        authenticate: true
      })
      .state('newInvestor.investmentDetails.schemedetails.selectscheme',{
        url:'/selectscheme',
        templateUrl: 'app/new-investors/investment-details/scheme-details/select-scheme/select-scheme.html',
        controller: 'SelectSchemeController',
        controllerAs: 'SelectScheme',
        authenticate: true
      })
  }

  /** @ngInject */
  function _fetchDynamicData(UtilService) {
    return UtilService.fetchDynamicData("NEW_INVESTOR_JOURNEY");
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('MobileController', mobileController);

  function mobileController() {
    // var vm = this;
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ManageAccountsController', manageAccountsCtrl);

  /** @ngInject */
  function manageAccountsCtrl(InvestorService,LoaderService,MessageService,ModalService,$state,AuthService,$window) {
    var vm = this;
    var locselectedLinkPanData = sessionStorage.getItem('selectedLinkPanData'); 
    if(locselectedLinkPanData){
      locselectedLinkPanData = $window.CryptoJS.AES.decrypt(locselectedLinkPanData.toString(), 'LinkPanData');
      locselectedLinkPanData = $window.JSON.parse(locselectedLinkPanData.toString($window.CryptoJS.enc.Utf8));
      if(locselectedLinkPanData && !locselectedLinkPanData.default){
        $state.go("welcome");
      }
    } 
    vm.myPan = false;
    vm.linedPanList=[];
    vm.myPanList=[];
    vm.getMyLinkedPan = getMyLinkedPan;
    vm.getLinkedPan = getLinkedPan;
    vm.maskPanList = maskPanList;
    vm.addAccount = addAccount;
    vm.primaryPanDetails = {};
    vm.init = function () { 
      getLinkedPan();
    }
    vm.removePan = function (panData) { 
      var successModal = function (resp) { 
        if(resp){ 
          MessageService.success(resp);
        }
        if(vm.myPan){
          getMyLinkedPan();
        }else{
          $state.reload();
        } 
      }, errorModal = function (err) {
      };
      var token = AuthService.getToken();
      panData.myPan = token.investorPAN;// login in pan 
      if(vm.myPan){
        panData.type='MY_PAN';
      }else{
        panData.type='LINKED_PAN';
      }
      ModalService.otpConfirmModal({STEPS:'CONFIRMATION_PROMPT',data:panData}, successModal, errorModal);
    } 
    vm.changeTabs = function (data) {
      vm.myPan =  data;
      if(vm.myPan){ 
        getMyLinkedPan();
      }else{
        getLinkedPan();
      }
    }; 
    function maskPanList(val){  
      if(val == "null" || !val){
        return val="";
      }
      if(val == 'Not updated'){
        return val = val;
      } 
      var endVal = val.substr(-2);
      var startVal = val.substr(0,2); 
      var maskyVal = ""; 
      for(var i=0;i<val.length-4;i++){
        maskyVal += "*"; 
      }
      return startVal + maskyVal + endVal;
    }
    function getMyLinkedPan(val){     
      var success = function (resp) {
        LoaderService.hideLoader(); 
        if (resp.status && resp.data) {
          var panList = resp.data.panNameList;
          vm.primaryPanDetails.panNumber = resp.data.panNumber; 
          vm.primaryPanDetails.primaryPanInvestorName = resp.data.primaryPanInvestorName;
          vm.primaryPanDetails.maskedPan =  maskPanList(vm.primaryPanDetails.panNumber);
          vm.myPanList = [];
          for (var i = 0; i < panList.length; i++) {
            var tempObj = {};
            tempObj = panList[i];  
            var val = panList[i].panNumber;
            if(val){ 
              tempObj.maskedPan = maskPanList(val); 
            } 
            vm.myPanList.push(tempObj);
          } 
        } else {
          MessageService.error(resp.message);
        }
      }, failure = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.data.message);
      };
      LoaderService.showLoader();
      InvestorService.post({ child1: 'switch',child2:'user',child3:'get',child4:'linked',child5:'pan',child6:'list',child7:'MY_PANS_LINKED_LIST'},{}).$promise.then(success, failure);
    }
    function getLinkedPan(val){     
      var success = function (resp) { 
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var panList = resp.data.panNameList;
          vm.primaryPanDetails.panNumber = resp.data.panNumber; 
          vm.primaryPanDetails.primaryPanInvestorName = resp.data.primaryPanInvestorName;
          vm.primaryPanDetails.maskedPan =  maskPanList(vm.primaryPanDetails.panNumber);
          vm.linedPanList = [];
          for (var i = 0; i < panList.length; i++) {
            var tempObj = {};
            tempObj = panList[i];  
            var val = panList[i].panNumber;
            if(val){ 
              tempObj.maskedPan = maskPanList(val); 
            } 
            vm.linedPanList.push(tempObj);
          } 
        } else {
          MessageService.error(resp.message);
        }
      }, failure = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.data.message);
      };
      LoaderService.showLoader();
      InvestorService.post({ child1: 'switch',child2:'user',child3:'get',child4:'linked',child5:'pan',child6:'list',child7:'LINKED_PANS_LIST'},{}).$promise.then(success, failure);
    }
    function addAccount(){ 
          var success1 = function (resp) { 
            ModalService.genericModal({
              text: resp,
              showBlueBtn:true
            }, function() { 
              $window.location.reload();
            }, function() { 
              $window.location.reload();
            });  
           },error1 = function () {
           }; 
            ModalService.addLinkPanModal({}, success1, error1);  
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('MaintainanceController', maintainanceController);

  function maintainanceController($state) {
    $state.go('login');
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('MainController', mainController);

  /** @ngInject */
  function mainController($scope, $rootScope, $state, AuthService, AppConstants, $window, UtilService, $timeout, MessageService, ModalService) {

    var removeListeners = {},timeoutListeners={};
    localStorage.setItem('isRefreshing', false);
    var resetFlag = function () {
      $timeout(function () {
    localStorage.setItem('isRefreshing', false);
      }, 2000);
    };
    var vm = this;
    var scope = $scope;
    scope.footerDate = new Date();
    if ($window.innerWidth > 1024) {
      vm.tooltipClass = 'right';
    } else {
      vm.tooltipClass = 'bottom';
    }

    /*    Tooltip
     * ----------------*/

    removeListeners["404"] = $rootScope.$on("404", function () {
      $state.go('404');
    });

    removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
    if (localStorage.getItem('isRefreshing') === 'true') {
        return;
      }
      localStorage.setItem('isRefreshing',true);
      var token = AuthService.getToken();
      // sessionStorage.isRefreshing = true;

      if (!token) {
        AuthService.clearCookies(AppConstants.IDENTIFIER);
        $timeout(function () {
          $state.go('sessionExpired');
        },0);
        resetFlag();
        return;
      }

        if (token && token.refresh_token) {
          AuthService.getRefreshToken(token).then(function () {
            if(localStorage.getItem('doLogOut')){
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.IDENTIFIER);
                $state.go('sessionExpired');
              }, function () {
                $state.go('sessionExpired');
              });
            }else{
              resetFlag();
              $state.reload();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            $state.go('sessionExpired');
            resetFlag();
          });
        } else {
          resetFlag();
          // AuthService.getRefreshToken(token).then(function () {
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            MessageService.clear();
            $state.go('sessionExpired');
          // })
        }
      });

    timeoutListeners["UpdateTimeOut"] = $rootScope.$on("UpdateTimeOut", function () {
      MessageService.clear();
      MessageService.warning('Your request can not be processed at this moment, Please try after sometime.');
    });
      scope.$on("$destroy", function () {
        for (var key in timeoutListeners) {
          if (timeoutListeners.hasOwnProperty(key) && angular.isFunction(timeoutListeners[key])) {
            timeoutListeners[key]();
          }
        }
      });
    }
  })();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('LogoutController', LogoutController);

  /** @ngInject */
  function LogoutController() {
    var vm = this;
    init();
    function init() {
      sessionStorage.clear();
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .directive('loginHeader', loginHeader)
    .directive('welcomeLoginHeader', WelcomeLoginHeader)
    .directive('myCurrentTime', ['$interval', 'dateFilter',
    function($interval, dateFilter) {

      return function(scope, element, attrs) {
        var format,
          stopTime;
        function updateTime() {
          element.text(dateFilter(new Date(), format));
        }
        scope.$watch(attrs.myCurrentTime, function(value) {
          format = value;
          updateTime();
        });

        stopTime = $interval(updateTime, 1000);
        element.on('$destroy', function() {
          $interval.cancel(stopTime);
        });
      }
    }]);

  /** @ngInject */
  function loginHeader() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/header/login-header.html',
      scope: {
        creationDate: '='
      },
      controller: loginController,
      controllerAs: 'Header',
      bindToController: true
    });

    /** @ngInject */
    function loginController($state, $window, AuthService, moment, $log, TransactionModel, UtilService, InvestorService,
                             MessageService, NetcoreEvntService,  LoaderService, AppConstants, CommonFactory, investorServiceVersion, KycService,HDFC_API,ModalService,ProfileFactory,$timeout,$rootScope, EcartModel) {
      var vm = this;
       vm.HDFC_API = HDFC_API;
      vm.init = init();
      if($state.$current.name=='instantLogin'){
        vm.instaLogin = true;
      }
      if($state.$current.name=='faq'){
        vm.faqVisible = true;
      }
      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.format = 'dd-MMM-yyyy h:mm:ss a';
      vm.relativeDate = moment(vm.creationDate).fromNow();
      vm.investorType = AuthService.getToken()?AuthService.getToken().investorType:null;
      vm.isLoggedIn = isLoggedIn;
      vm.changedFont = changedFont;
      vm.openMobileMenu = openMobileMenu;
      vm.fontSizeChange = fontSizeChange;
      vm.contrast = contrast;
      vm.contrast2 = contrast2;
      vm.contrasts = contrasts;
      vm.gotoHome = gotoHome;
      vm.contrastt = UtilService.darkThemeStatus.get();
      vm.contrastt2 = !vm.contrastt;
      vm.isLoggedIn();
      vm.count = 0;
      vm.active = UtilService.headerFont.get();
      var token = AuthService.getToken();
      vm.corporateUserFlag = token && token.corporateUserFlag ? token.corporateUserFlag : false;
      if($state.current){
        if($state.current.name == "checkUser" && $state.current.controllerAs == "Checkuser"){
          vm.HideQuickInveBtn = false;
        }else{
          vm.HideQuickInveBtn = true;
        }
      }
      vm.constants = AppConstants;
      if (AuthService.getToken()) {
        vm.userFirstName = AuthService.getToken().investorFName;
        var splitValue = vm.userFirstName.split(' ')[0];;
        vm.userFirstName = splitValue;
        var w = $(window).width();
        if(w > 1366 ){
          if(vm.userFirstName.length >= 26){
            vm.userFirstName = vm.userFirstName.slice(0,23);
            vm.userFirstName = vm.userFirstName + '...';
          }
        }
        if( 1357 < w && w < 1366 ){
          if(vm.userFirstName.length > 25){
            vm.userFirstName = vm.userFirstName.slice(0,22);
            vm.userFirstName = vm.userFirstName + '...';
          }
        }
        if( 1350 < w && w < 1356 ){
          if(vm.userFirstName.length > 24){
            vm.userFirstName = vm.userFirstName.slice(0,21);
            vm.userFirstName = vm.userFirstName + '...';
          }
        }
        if( 1346 < w && w < 1349 ){
          if(vm.userFirstName.length > 24){
            vm.userFirstName = vm.userFirstName.slice(0,20);
            vm.userFirstName = vm.userFirstName + '...';
          }
        }
        if( 1241 < w && w < 1252 ){
          if(vm.userFirstName.length > 22){
            vm.userFirstName = vm.userFirstName.slice(0,19);
            vm.userFirstName = vm.userFirstName + '...';
          }
        }
        if( 1233 < w && w < 1240 ){
          if(vm.userFirstName.length > 21){
            vm.userFirstName = vm.userFirstName.slice(0,18);
            vm.userFirstName = vm.userFirstName + '...';
          }
        }
        if( 1192 < w && w < 1232 ){
          if(vm.userFirstName.length > 20){
            vm.userFirstName = vm.userFirstName.slice(0,17);
            vm.userFirstName = vm.userFirstName + '...';
          }
        }
        vm.landingPageType = AuthService.getToken().landingPageType;
      }

      destroyLoginHeader();

      function init() {
        if (($state.$current.name === "welcome.existingUserWelcome" || $state.$current.name === "welcome.existingUserWelcome.widgets" || $state.$current.name === "videos")) {
          recentActivity();
        }
      }

      vm.changeLinkedPan = changeLinkedPan;
      vm.readAesResponsePayload = readAesResponsePayload;
      vm.maskLinkPan = maskLinkPan;
      vm.selectedLinkPan = {};
      vm.linkedPanList = [];
      vm.getLinkedPanList = getLinkedPanList;
      getLinkedPanList();
      //getLinkedPanList
      function getLinkedPanList(reload){
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.linkedPanList = [];
            vm.linkedPanList =  resp.data;
            $rootScope.LinkedPAN = new Set();
            // set Mask pan and set selected pan
            for (var i = 0; i < vm.linkedPanList.length; i++) {
              vm.linkedPanList[i].maskedPan = vm.maskLinkPan(vm.linkedPanList[i].panNumber);
              if(vm.linkedPanList[i].selected){
                vm.selectedLinkPan = vm.linkedPanList[i];
              }
              $rootScope.LinkedPAN.add(vm.linkedPanList[i].panNumber);
            }
          } else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        }, error = function (err) {
          LoaderService.hideLoader();
        };
        LoaderService.showLoader();
        AuthService.getLinkedPanDetails(reload).then(success, error);
      }
      function maskLinkPan(val){
        if(val == "null" || !val){
          return val="";
        }
        if(val == 'Not updated'){
          return val = val;
        }
        var endVal = val.substr(-2);
        var startVal = val.substr(0,2);
        var maskyVal = "";
        for(var i=0;i<val.length-4;i++){
          maskyVal += "*";
        }
        return startVal + maskyVal + endVal;
      }
      // changed Linked pan
      function changeLinkedPan(data){
          if(data == "Add"){
              var success1 = function (resp) {
                ModalService.genericModal({
                  text: resp,
                  showBlueBtn:true
                }, function() {
                  $window.location.reload();
                }, function() {
                  $window.location.reload();
                });
              },error1 = function () {
              };
              if( vm.linkedPanList && vm.linkedPanList.length < 6){
                ModalService.addLinkPanModal({}, success1, error1);
              }else{
                MessageService.error("Maximum 5 external accounts can be added.");
              }
          }else if(data == "ManagedAccounts"){
            $state.go('main.managed-accounts');
          }else{
            var success = function(resp) {
              if (resp.status && resp.data) {
                vm.selectedLinkPan = resp.selectedLinkPan;
                MessageService.success(resp.data);
                $window.location.reload();
              }else{
                MessageService.error(resp.message);
              }
              LoaderService.hideLoader();
            }
            var error = function(err) {
              LoaderService.hideLoader();
              MessageService.error(err.message);
            }
            LoaderService.showLoader();
            AuthService.switchAccountInLinkedPan(data).then(success, error)
          }
      }
      vm.logoutMe = function () {
        AuthService.logout().then(function () {
          sessionStorage.removeItem('selectedLinkPanData');
          localStorage.removeItem("userId");
          var newDataLayer = $window.dataLayer.filter(function (obj) {
            return !obj.hasOwnProperty('userId');
          });
          $window.dataLayer = newDataLayer;
          CommonFactory.setLogoutSuccess();
          $state.go('login');
        }, function () {
          // $state.go('login');
        });
      };
      function isLoggedIn() {
        AuthService.isLoggedIn().then(function (resp) {
          vm.isLoggedInStatus = resp.isLoggedIn;
          if (($state.$current.name === "welcome.existingUserWelcome" || $state.$current.name === "welcome.existingUserWelcome.widgets" || $state.current.name === "faq") && vm.isLoggedInStatus) {
            latestNotification();
            getCartCount();
            recentActivity();
            getTotalNotificationCount();
            getTransactionTypes();
          }
          if (($state.$current.name === "welcome.existingUserWelcome" || $state.$current.name === "welcome.existingUserWelcome.widgets")  && !vm.isLoggedInStatus) {
            vm.logoutMe();
          }
        }, function (err) {
          $log.info('isLogin error>>>>',err);
        });

      }

      function gotoHome() {
        UtilService.updateSideBar('EXISTING_USER');
      }
      function destroyLoginHeader() {
        var elem = document.getElementsByTagName("body")[0];
        elem.classList.remove("menu-expanded");
      }

      /** color contrast */
      function contrast () {
        if(!vm.contrastt){
          UtilService.darkThemeStatus.set(false);
          $window.document.getElementsByTagName("body")[0].classList.add("contrastClass");
        } else {
          UtilService.darkThemeStatus.set(true);
          $window.document.getElementsByTagName("body")[0].classList.remove("contrastClass");
        }
      }
      function contrast2 () {
        if(vm.contrastt2){
          vm.contrastt = false;
        }else{
          vm.contrastt = true;
        }
        contrast();
      }

      /** color contrast for welcome page */
      function contrasts () {
        vm.contrastt = !vm.contrastt;
        if(!vm.contrastt){
          UtilService.darkThemeStatus.set(false);
          $window.document.getElementsByTagName("body")[0].classList.add("contrastClass");
        } else {
          UtilService.darkThemeStatus.set(true);
          $window.document.getElementsByTagName("body")[0].classList.remove("contrastClass");
        }
      }


      /*vm.goToState = function (_state, option) {
        TransactionModel.setPayloadRawData(null);
        if(option){
          $state.go('main.transactions.' + _state, {option:option});
        } else
        {
          $state.go('main.transactions.' + _state);
        }
      };*/

      function changedFont(valType){
        vm.active = {1: false};
        switch (valType) {
          case 'increment' : {
            if(vm.count<3){
              vm.count++;
              UtilService.headerFont.set(3);
              vm.active = UtilService.headerFont.get();
              vm.fontSizeChange(vm.count);
            }
          }
            break;
          case 'decrement' : {
            if(vm.count>-3){
              vm.count--;
              UtilService.headerFont.set(2);
              vm.active = UtilService.headerFont.get();
              vm.fontSizeChange(vm.count);
            }
          }
            break;
          case 'original' : {
            vm.count = 0;
            UtilService.headerFont.set(1);
            vm.active = UtilService.headerFont.get();
            vm.fontSizeChange(vm.count);
          }
            break;
        }
      }
      function openMobileMenu(){
        var threeDot = document.getElementById("three-dot");
        if(threeDot){
          if(threeDot.ariaExpanded == 'true'){
            document.getElementById("three-dot-icon").style.background = "rgba(235, 242, 249, 1)";
            document.getElementById("three-dot-icon").style.width = "34px";
            document.getElementById("three-dot-icon").style.borderRadius = "100px";
          }else{
            document.getElementById("three-dot-icon").style.background = "none";
          }
        }
      }
      angular.element(document).ready(function(){
        $(document).on("click",function(){
          openMobileMenu();
        })
      })
      function fontSizeChange(val){
        var elem = $window.document.getElementsByTagName("body")[0];
        elem.classList.add("newBigFont");
        var ele = $window.document.getElementsByClassName('newBigFont')[0];
        switch (val) {
          case -2 : {
            elem.classList.add("smallest-font");
            elem.classList.remove("small-font");
            ele.setAttribute("style","font-size: 70% !important");
          }
            break;
          case -1 : {
            elem.classList.add("small-font");
            ele.setAttribute("style","font-size: 80% !important");
          }
            break;
          case 0 : {
            elem.removeAttribute('style');
            elem.classList.remove("newBigFont");
            elem.classList.remove("big-font");
            elem.classList.remove("medium-font");
            elem.classList.remove("small-font");
            elem.classList.remove("smallest-font");
          }
            break;
          case 1 : {
            elem.classList.add("medium-font");
            ele.setAttribute("style","font-size: 97% !important");
          }
            break;
          case 2 : {
            elem.classList.add("big-font");
            elem.classList.remove("medium-font");
            ele.setAttribute("style","font-size: 110% !important");
          }
            break;
        }
      }

      /*
      * function responsible to change the state.
      * */
      vm.goToState = function (_state) {
        var successHandler = function() {
          TransactionModel.setPayloadRawData(null);
          var fromJourney = _state ? _state.toUpperCase(): ''
          if(fromJourney === 'PURCHASE' || fromJourney === 'SIP'){
            vm.formData = TransactionModel.getMasterRawData(fromJourney);
            vm.formData.journey = 'Transact Now';
            TransactionModel.setPayloadRawData(vm.formData);
          }
          if (_state === 'purchase') {
            NetcoreEvntService.Transact_Now_Purchase_IP()
          } else if (_state === 'sip') {
            NetcoreEvntService.Transact_Now_SIP_IP()
          }
          if (_state === 'changeDividendOption' || _state === 'rolloverView') {
            $state.go('main.' + _state);
          } else {
            if(_state === "tip") {
              _state = "dtp";
            } else if (_state === "rollover") {
              $state.go('main.rolloverView');
            } else if (_state === "iaf") {
              _state = "instantRedemption";
            } else if (_state === 'changeidcwoption') {
              $state.go('main.changeDividendOption');
            } else if (_state === 'smartswap') {
              _state = "smartSwap";
            } else if (_state === 'dreamsip') {
              _state = "dreamSip";
            }
            EcartModel.setPayloadPayment(null);
            $state.go('main.transactions.' + _state);
          }
        };
        KycService.fetchKycStatus(vm.constants.KYC_RESTRICTION.TRANSACTION).then(successHandler).catch(function(resp) {
          $log.info(resp);
        });
      }

      vm.handleNavBar = function(status) {
        var elem = document.getElementsByTagName("body")[0];
        if (status) {
          elem.classList.add("menu-expanded");
          elem.classList.remove("menu-collapsed");
        } else {
          elem.classList.add("menu-collapsed");
          elem.classList.remove("menu-expanded");
        }
      };

      vm.slideSubMenu = function(menuName, status) {
        var elem = $('.' + menuName);
        var body = document.getElementsByTagName("body")[0];
        if (status) {
          elem.addClass('show-submenu');
          if (menuName === "mobile-transact-section") {
            body.classList.add("menu-expanded", "menu-height");
            body.classList.remove("menu-collapsed");
          }
        } else {
          elem.removeClass('show-submenu');
          if (menuName === "mobile-transact-section") {
            body.classList.add("menu-collapsed");
            body.classList.remove("menu-expanded", "menu-height");
          }
        }
      };

      function getTotalNotificationCount() {
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            vm.notificationCount = resp.data.count;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          //UtilService.errorHandler(err);
        };
        InvestorService.get({
          child1: 'notification',
          child2: 'count'
        }).$promise.then(success, error);
      }

      function latestNotification() {
        var success = function (resp) {
            if (resp.status && resp.data) {
              vm.latestNotificationList = resp.data.notificationList;
              vm.notificationData = sortDate(resp.data.notificationList);
            }
            else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            //UtilService.errorHandler(err);
          };
        InvestorService.get({
          child1: 'notification',
          child2: 'latest'
        }).$promise.then(success, error);
      }
      function sortDate(arr) {
        arr.filter(function (item) {
          var date = $window.moment();
          date.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
          var created = $window.moment(item.createdDate).set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
          var diff = Math.abs(date.diff(created, 'days'));
          item.diff = diff;
          if(diff==0) {
            date = $window.moment();
            created = $window.moment(item.createdDate);
            var end = $window.moment.utc(date, "HH:mm");
            // created = $window.moment(item.createdDate);
            var start = $window.moment.utc(created, "HH:mm");
            if (start.isBefore(end)) start.add(1, 'day');
            var d = $window.moment.duration(end.diff(start));
            vm.hourDifference = $window.moment.utc(+d).format('HH:mm');
            var mystring = vm.hourDifference.substring(0, 2);
            if(mystring == '00'){
              var mins = vm.hourDifference.slice(-2);
              if(mins.charAt(0)=='0'){
                var time = vm.hourDifference.slice(-1) + 'min ago';
              } else{
                time = vm.hourDifference.slice(-2) + 'min ago';
              }
            } else if(mystring.charAt(0)=='0'){
              time = vm.hourDifference.substring(1,2) + 'hr ago';
            } else {
              time = vm.hourDifference.substring(0,2) + 'hr ago';
            }
            item.time = time;
          } else {
            created = $window.moment(item.createdDate);
            var date1 = $window.moment(created).format('DD/MM/YYYY');
            var time1 = $window.moment(created).format("hh:mm a");
            item.date1 = date1;
            item.time1 = time1;
          }

        });
      }

      function getCartCount() {
        vm.cartCount = 0;
        if(token) {
          var success = function (resp) {
            if (resp.status) {
              vm.cartCount = resp.data.total;
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            //UtilService.errorHandler(err);
          };
          investorServiceVersion.get({
            child1: 'cart',
            child2: 'item',
            child3: 'count'
          }).$promise.then(success, error);
        }
      }

      function recentActivity() {
        var success = function(resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var message = resp.data.activity[0].message;
            message = message.substring(message.lastIndexOf(" ") + 1, message.length).trim();
            vm.recentActivities = resp.data.activity[0].date;
            vm.time = message;
            //vm.time = moment(message, "HH:mm:ss").format("HH:MM:SS");
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function(res) {
          LoaderService.hideLoader();
          //MessageService.error(res.message);
        };
        LoaderService.showLoader();
        InvestorService.post({
          child1: 'dashboard',
          child2: 'widgets',
          child3: 'recentActivity'
        },{}).$promise.then(success, error);
      }

      function getTransactionTypes() {
        var success = function (resp) {
            if (resp.status && resp.data) {
              vm.popularTransactions = resp.data.popularTransactions;
              vm.otherTransactions = resp.data.otherTransactions
            } else {
              MessageService.error(resp.message);
              vm.popularTransactions = [];
              vm.otherTransactions = [];
            }
          },
          error = function (err) {
            MessageService.error(err.message);
            vm.popularTransactions = [];
            vm.otherTransactions = [];
          };
        if(!vm.popularTransactions) {
          InvestorService.get({
            child1: 'fetch',
            child2: 'transaction',
            child3: 'type'
          }).$promise.then(success, error);
        }
      }
      function readAesResponsePayload(header, data){
        var iv = $window.CryptoJS.enc.Base64.parse(header.substring(0, header.lastIndexOf("|")));
        var key = $window.CryptoJS.enc.Base64.parse(header.substring(header.lastIndexOf("|")+1, header.length));
        var decryptJson = $window.CryptoJS.AES.decrypt({
          ciphertext: data
        }, key, {iv: iv});
        return decryptJson.toString($window.CryptoJS.enc.Utf8);
      }

    }
  }
  /** @ngInject */
  function WelcomeLoginHeader() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/header/welcome-first-login-header.html',
      scope: {
        creationDate: '='
      },
      controller: WelcomeLoginController,
      controllerAs: 'Header',
      bindToController: true
    });

    /** @ngInject */
    function WelcomeLoginController($state, $window, AuthService, moment, $log, TransactionModel, UtilService, AppConstants) {
      var vm = this;
      if($state.$current.name=='instantLogin'){
        vm.instaLogin = true;
      }
      if($state.$current.name=='faq'){
        vm.faqVisible = true;
      }
      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.format = 'dd-MMM-yyyy h:mm:ss a';
      vm.relativeDate = moment(vm.creationDate).fromNow();
      vm.investorType = AuthService.getToken()?AuthService.getToken().investorType:null;
      vm.isLoggedIn = isLoggedIn;
      vm.changedFont = changedFont;
      vm.fontSizeChange = fontSizeChange;
      vm.contrast = contrast;
      vm.contrastt = UtilService.darkThemeStatus.get();

      vm.isLoggedIn();
      vm.count = 0;
      vm.active = UtilService.headerFont.get();
      vm.constants = AppConstants;

      vm.logoutMe = function () {
        AuthService.logout().then(function () {
          localStorage.removeItem("userId");
          var newDataLayer = $window.dataLayer.filter(function (obj) {
            return !obj.hasOwnProperty('userId');
          });
          $window.dataLayer = newDataLayer;
          $state.go('login');
        }, function () {
          // $state.go('login');
        });
      };
      function isLoggedIn() {
        AuthService.isLoggedIn().then(function (resp) {
          vm.isLoggedInStatus = resp.isLoggedIn;
        }, function (err) {
          $log.info('isLogin error>>>>',err);
        });

      }

      /** color contrast */
      function contrast () {
        if(!vm.contrastt){
          UtilService.darkThemeStatus.set(false);
          $window.document.getElementsByTagName("body")[0].classList.add("contrastClass");
        } else {
          UtilService.darkThemeStatus.set(true);
          $window.document.getElementsByTagName("body")[0].classList.remove("contrastClass");
        }
      }

      function changedFont(valType){
        vm.active = {1: false};
        switch (valType) {
          case 'increment' : {
            if(vm.count<3){
              vm.count++;
              UtilService.headerFont.set(3);
              vm.active = UtilService.headerFont.get();
              vm.fontSizeChange(vm.count);
            }
          }
            break;
          case 'decrement' : {
            if(vm.count>-3){
              vm.count--;
              UtilService.headerFont.set(2);
              vm.active = UtilService.headerFont.get();
              vm.fontSizeChange(vm.count);
            }
          }
            break;
          case 'original' : {
            vm.count = 0;
            UtilService.headerFont.set(1);
            vm.active = UtilService.headerFont.get();
            vm.fontSizeChange(vm.count);
          }
            break;
        }
      }
      function fontSizeChange(val){
        var elem = $window.document.getElementsByTagName("body")[0];
        elem.classList.add("newBigFont");
        var ele = $window.document.getElementsByClassName('newBigFont')[0];
        switch (val) {
          case -2 : {
            elem.classList.add("smallest-font");
            elem.classList.remove("small-font");
            ele.setAttribute("style","font-size: 70% !important");
          }
            break;
          case -1 : {
            elem.classList.add("small-font");
            ele.setAttribute("style","font-size: 80% !important");
          }
            break;
          case 0 : {
            elem.removeAttribute('style');
            elem.classList.remove("newBigFont");
            elem.classList.remove("big-font");
            elem.classList.remove("medium-font");
            elem.classList.remove("small-font");
            elem.classList.remove("smallest-font");
          }
            break;
          case 1 : {
            elem.classList.add("medium-font");
            ele.setAttribute("style","font-size: 97% !important");
          }
            break;
          case 2 : {
            elem.classList.add("big-font");
            elem.classList.remove("medium-font");
            ele.setAttribute("style","font-size: 110% !important");
          }
            break;
        }
      }

      vm.showMenu = function(isVisible) {
        var elem = $('.mobile-welcome-section');
        if (isVisible) {
          elem.addClass('show-submenu');
        } else {
          elem.removeClass('show-submenu');
        }
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($window, $rootScope, $timeout, $state,$document, $stateParams, $scope, AuthService, HDFC_API, toastr, LoaderService,
                           AppConstants, TransactionService, MessageService, ModalService, UtilService, CommonFactory,CreatePayloadFactory, InvestorService,
                           deviceDetector, $http, $sce, NetcoreEvntService, $log, BrowserService, investorServiceVersion, InvestorServiceVersion3, MetaTagService, panAadharService,FormatterService) {
    var vm = this;
    vm.HDFC_API =HDFC_API;
    vm.loginUsingOtpFlag = false;
    vm.loginTabRegister=true;
    vm.loginTab=true;
    vm.loginTabUpdate=true;
    vm.isPanValid = false;
    vm.resetValues = resetValues;   
    vm.loginWith = 'MOBILE_NUMBER';
    vm.maskMobileNumber = maskMobileNumber;
    vm.chooseLogin = chooseLogin;
    vm.mobileTknLogout = mobileTknLogout;
    vm.gRecaptchaResponse = '';
    vm.showUnlockID = false;
    vm.uniqueDeviceID = genFingerprintDeviceID();
    vm.isAdditionalFactorRequired = false;
    vm.dateErrorMessage = "";
    vm.availableMessage = "";
    vm.viewMode = 'days';
    var details = {};
    vm.formData = {};
    vm.formData.dob = null;
    vm.showOtpField = false;
    vm.loginProcessFlag = false; 
    vm.appConstants = AppConstants;
    vm.publicKey = vm.appConstants.CAPTCHA_PUB_KEY;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    if(vm.appConstants && vm.appConstants.ENABLE_RISK_BASED_AUTHENTICATION){ 
      vm.uniqueDeviceID = genFingerprintDeviceID();
    }
    vm.confirmRegister = confirmRegister;
    vm.reset = reset;
    var userInfo = AuthService.getUserCookies();
    vm.userId = userInfo ? userInfo.userId : '';
    vm.RUNNING_MODE = AppConstants.RUNNING_MODE;
    vm.ENV = HDFC_API.ENV;
    vm.tracked = false;
    vm.isResetLoginForm = true;
    vm.showSecStep = false;
    var  scope = $scope;
    scope.footerDate = new Date();
    vm.loginPayload = {
      userId: vm.userId ? vm.userId : "",
      password: ""
    };
    var loginType ;
    var loginMethod = "MOBILE_NO";
    vm.otpWrongAttempts = 0;
    vm.myRecaptchaResponse = '';
    var singleUseURL;
    vm.loginViaOtp = loginViaOtp;
    vm.loginPayload.otp = '';
    vm.loginPayload.otp1 = '';
    vm.loginPayload.otp2 = '';
    vm.loginPayload.otp3 = '';
    vm.loginPayload.otp4 = '';
    vm.loginPayload.otp5 = '';
    vm.loginPayload.otp6 = ''; 
    vm.otpCodeLength = 0; 
    vm.otpValChanged = otpValChanged;
    vm.loginViaPassword = loginViaPassword;
    vm.loginViaUpdate = loginViaUpdate;
    vm.forceUpdateForInCompatibleBrowser = BrowserService.forceUpdateForInCompatibleBrowser;
    vm.forceUpdateForInCompatibleBrowser();
    vm.isMactive = $stateParams.isMactive==="true"?true:null;
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    vm.showPreviousStep = showPreviousStep;
    vm.showPassword= showPassword;
    vm.showPasswordFlag = false;
    vm.passwordType = 'Password';
    vm.changedFont = changedFont;
    vm.fontSizeChange = fontSizeChange;
    vm.count = 0;
    vm.contrast = contrast;
    vm.contrastt = UtilService.darkThemeStatus.get();
    vm.imageUrls = [];
    vm.redirectTo = redirectTo; 
    vm.createAesRequestPayloadData = createAesRequestPayloadData; 
    vm.showTerms = true;
    vm.redirectUrl = null;  
    vm.checkDobDate = checkDobDate;
    vm.invalidUserId = false;
    vm.checkText = function(){
      var regex = AppConstants.valid_userId_regex;
      if(vm.loginPayload && vm.loginPayload.username && (regex.test(vm.loginPayload.username.toLowerCase()) && vm.loginPayload.username.length > 30)){
        vm.invalidUserId =  true;
      } else{
        vm.invalidUserId =  false;
      }
    }
    var init = function () {
      //fetching images
      fetchImage();
      sessionStorage.removeItem("ekycRequestCO");
      if (CommonFactory.getSessionExpired()) {
        ModalService.logoutSuccess();
      }
      if(localStorage.getItem('panNo')){
        localStorage.removeItem('panNo');
      }
      if(localStorage.getItem('dob')){
        localStorage.removeItem('dob');
      }
      if(angular.isDefined($stateParams.trackId)){
        getTrackedInfo();
      }
      MetaTagService.setMetaTags(AppConstants.META_TAGS.LOGIN_DESCRIPTION, AppConstants.META_TAGS.LOGIN_TITLE, AppConstants.META_TAGS.KEYWORDS);
      if ($state.current.name === "newInvestor") {
        vm.investorSelection = AppConstants.INVESTOR_SELECTION.NEW_INVESTOR;
      } else if ($state.current.name === "login") {
        vm.investorSelection = AppConstants.INVESTOR_SELECTION.EXISTING_USER;
      }
      /*vm.investorSelection = UtilService.getSideBarState() === AppConstants.INVESTOR_SELECTION.QUICK_INVEST ?
        $rootScope.previousLocation : UtilService.getSideBarState() === AppConstants.INVESTOR_SELECTION.UPDATE_CONTACT_DETAILS ?
          AppConstants.INVESTOR_SELECTION.EXISTING_USER : UtilService.getSideBarState();*/

      UtilService.updateSideBar(vm.investorSelection);
      checkDeviceSize();
      var LOGIN_WITH_USERID = sessionStorage.getItem('LOGIN_WITH_USERID');
      if(LOGIN_WITH_USERID){
        chooseLogin('USER_ID');
        sessionStorage.removeItem('LOGIN_WITH_USERID');
      }
    };
    init();


    function getTrackedInfo(){

      var success = function (resp) {
          if (resp.data && resp.status) {
            loginType = resp.data.loginType;
            // var trxnType = resp.data.trxnType;
            // var stepNo = resp.data.stepNo;
            vm.loginPayload.username = resp.data.userId;

            if(loginType =='IP_WEB'){
              vm.tracked = true; 
              chooseLogin('USER_ID');
              //$state.go('login-user-tracker',{trackId:$stateParams.trackId});
              /*$state.go('home',{trackId:$stateParams.trackId,trxnType:$stateParams.trxnType,step:$stateParams.step});*/
            }else if(loginType === 'QI_WEB'){
              vm.tracked = false;
              $state.go('instantLogin',{trackId:$stateParams.trackId})
            }
          } else {
            vm.tracked = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'userBehavior',
        controller2: $stateParams.trackId,
        controller3: 'validate'
      }).$promise.then(success, error);
    }

    vm.removeReadOnly = function () {
      angular.element(".passwordId").removeAttr('readonly');
    };

    function showTermConditions() {
       ModalService.termConditionModal();
    }

    function showPassword() {
      if(vm.showPasswordFlag) {
        vm.passwordType = 'password';
        vm.showPasswordFlag = false;
      }
      else{
        vm.passwordType = 'text';
        vm.showPasswordFlag = true;
      }
    }

    function resetValues() {
      vm.errorMessage = "";
      vm.errorMessageVerify="";
      vm.panMessage = "";
      vm.availableMessage = "";
      vm.otpResendMessage = "";
      vm.dateErrorMessage = "";
      vm.loginPayload.otp = '';
      vm.loginPayload.otp1 = '';
      vm.loginPayload.otp2 = '';
      vm.loginPayload.otp3 = '';
      vm.loginPayload.otp4 = '';
      vm.loginPayload.otp5 = '';
      vm.loginPayload.otp6 = ''; 
      vm.otpCodeLength = 0;
      vm.showUnlockID =false;
    }

    vm.reGenerateOtp = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          singleUseURL = resp.data.secretLink;
          vm.showOtpField = true;
          vm.showResendBtn = false;
          resetValues();
          vm.loginPayload.otp = "";
          vm.sentOtpRespMsg = $sce.trustAsHtml(resp.data.message) || 'OTP sent again successfully again.';
          resetTimer();
        } else {
          MessageService.error(resp.message);
        }
        vm.errorMessage = resp.message || AppConstants.ToastrMessage.FAILED;
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
        MessageService.error(vm.errorMessage);
      }, payload = {
        arnCode: 'ARN-' + vm.loginPayload.arnCode,
         secretLink: singleUseURL
      };
      vm.errorMessage = '';
      vm.processOTPFlag = true;
      vm.sentOtpRespMsg = '';
      LoaderService.showLoader();
      if(vm.loginWith == 'MOBILE_NUMBER'){
        AuthService.reGenerateOtp(null, payload, 'fromMobileLogin').then(success, error);
      }else{
        AuthService.reGenerateOtp(null, payload, 'fromLogin').then(success, error);
      }
    }; 
    vm.generateOtp = function () {
      sessionStorage.removeItem('primaryPan');
      var success = function (resp) {
        LoaderService.hideLoader();
        vm.isAdditionalFactorRequired = false;
        if (resp.data && resp.status) {
          vm.isAdditionalFactorRequired = resp.data.isAdditionalFactorRequired;
          if (resp.data.ekycStatus === vm.KYC_STATUS.INCOMPLETE) {
            sessionStorage.setItem("ekycRequestCO", JSON.stringify(resp.data.ekycRequestCO));
            initiateRejectModal("login", resp.data.ekycRequestCO);
          } else if (resp.data.ekycStatus === vm.KYC_STATUS.ON_HOLD) {
            initiateOnHoldModal("login");
          } else if (resp.data.ekycStatus === vm.KYC_STATUS.VERIFIED || resp.data.ekycStatus === vm.KYC_STATUS.IN_PROGRESS) {
            vm.showOtpField = true;
            vm.showSecStep = true;
            vm.sentOtpRespMsg = $sce.trustAsHtml(resp.data.message);
            singleUseURL = resp.data.secretLink; 
          } else {
            if(vm.loginWith == 'MOBILE_NUMBER'){
              if(resp.data.secretLink){
                vm.showOtpField = true;
                vm.showSecStep = true;
                vm.sentOtpRespMsg = $sce.trustAsHtml(resp.data.message);
                singleUseURL = resp.data.secretLink;
              }
            }else{
              initiateGenericMessage("login"); 
            }
          }
        } else {
          MessageService.error(resp.message);
          if(resp && resp.locked){
            vm.showUnlockID = true;
          }
        }
      },
      error = function () {
        vm.isAdditionalFactorRequired = false;
        LoaderService.hideLoader();
        MessageService.error(AppConstants.ToastrMessage.FAILED);
      };
      if(vm.loginWith == 'MOBILE_NUMBER'){
        vm.maskedMobileNo = maskMobileNumber(vm.loginPayload.mobileNumber);
      }
      sessionStorage.setItem('payLoadUserName', vm.loginPayload.username);
      if(vm.loginWith == 'MOBILE_NUMBER'){
        var payload = {
          "mobile": AuthService.encryptRSA(angular.copy(vm.loginPayload.mobileNumber))
        };
        LoaderService.showLoader();
        AuthService.generateOtp(payload, 'fromLoginMobile').then(success, error);
      }else{
        var payload = {
          "userId": vm.loginPayload.username,
          "pan": vm.loginPayload && vm.loginPayload.panNumber ? AuthService.encryptRSA(angular.copy(vm.loginPayload.panNumber)) : '',
        };
        if(vm.appConstants && vm.appConstants.ENABLE_RISK_BASED_AUTHENTICATION){ 
          vm.deviceInfo = vm.getDeviceInfo();
          payload.deviceInfo = vm.deviceInfo;
        }
        LoaderService.showLoader();
        AuthService.generateOtp(payload, 'fromLogin').then(success, error);
      }
    };

    vm.firstStepLogin = function(){
      sessionStorage.removeItem('primaryPan');
      if(vm.loginPayload && vm.loginPayload.password){
        vm.loginPayload.password = AuthService.encryptRSA(angular.copy(vm.loginPayload.password));
      }
      if(vm.loginPayload && vm.loginPayload.username){
        var userName = vm.loginPayload.username;
      }
      var success = function (resp) {
        if(vm.loginPayload && vm.loginPayload.password){
          vm.loginPayload.password = '';
        }
        vm.loginProcessFlag = false;
        LoaderService.hideLoader();
        if (resp.status && resp.data) { 
        vm.isAdditionalFactorRequired = false;
          singleUseURL = resp.data.secretLink;
          if(!vm.loginUsingOtpFlag) {
            if (resp.data.ekycStatus === vm.KYC_STATUS.INCOMPLETE) {
              sessionStorage.setItem("ekycRequestCO", JSON.stringify(resp.data.ekycRequestCO));
              initiateRejectModal("login", resp.data.ekycRequestCO);
            } else if (resp.data.ekycStatus === vm.KYC_STATUS.ON_HOLD) {
              initiateOnHoldModal("login");
            } else if (resp.data.ekycStatus === vm.KYC_STATUS.VERIFIED || resp.data.ekycStatus === vm.KYC_STATUS.IN_PROGRESS) {
              vm.showSecStep = true;
              vm.showOtpField = true;
              vm.isAdditionalFactorRequired = resp.data.isAdditionalFactorRequired;
              vm.sentOtpRespMsg = $sce.trustAsHtml(resp.data.message)|| 'OTP has been sent successfully to your registered Email Id and Mobile Number.';
            } else {
              initiateGenericMessage("login");
            }
          }
        else
            vm.login();
        } else {
          if (resp && resp.message) {
            MessageService.error(resp.message);
            vm.loginPayload.password = '';
            $('#password').focus();
            if(resp && resp.locked){
              vm.showUnlockID = true;
            }
          }
        }
      },
      error = function (msg) { 
        vm.isAdditionalFactorRequired = false;
        LoaderService.hideLoader();
        UtilService.errorHandler(msg);
      };
      sessionStorage.setItem('payLoadUserName',vm.loginPayload.username);
      if (loginMethod === 'ThroughPassword') {
        var payload = {
          username: userName,
          password: vm.loginPayload.password
        };
      }
      else if (loginMethod === 'OTP') {
        payload = {
          username: userName,
          password: vm.loginPayload.otp
        };
      }
      vm.loginProcessFlag = true;
      if(vm.appConstants && vm.appConstants.ENABLE_RISK_BASED_AUTHENTICATION){ 
        vm.deviceInfo = vm.getDeviceInfo();
        payload.device_info=vm.createAesRequestPayloadData(vm.deviceInfo);
      }
      LoaderService.showLoader();
      AuthService.firstStepLogin(payload, loginMethod, singleUseURL).then(success, error);
    };
    $rootScope.otpPasteInVariable = function(otp) {
      vm.loginPayload.otp = otp; 
      vm.loginPayload.otp1 = otp[0]; 
      vm.loginPayload.otp2 = otp[1]; 
      vm.loginPayload.otp3 = otp[2]; 
      vm.loginPayload.otp4 = otp[3]; 
      vm.loginPayload.otp5 = otp[4]; 
      vm.loginPayload.otp6 = otp[5]; 
    }
    vm.confirmCancel = function() {
      var confirmSuccess = function () {
        resetForm();
      };
      var confirmError = function () {
        //task.done = false;
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    };

    vm.db = function(){
      $state.go('preliminaryDashboard', {pan:''});
    }
    vm.getTnc = function(){
      ModalService.mobiletermConditionModal();
    } 
    vm.login = function () {
      var successLogin = function (result) {
          vm.loginProcessFlag = false;
          LoaderService.hideLoader(); 
          if (result.access_token && result.access_token != "") {
            if(loginMethod === 'MOBILE_NO'){ 
              result.mobile = vm.loginPayload.mobileNumber;
              AuthService.clearCookies(AppConstants.MOBILE_IDENTIFIER);
              AuthService.setMobileLoginToken(result);  
              vm.redirectToMobileTokenBased(result);
              return;
            }else{
              /*netcore script start here*/
              (typeof $window.smartech == 'function') && $window.smartech('identify', result.encryptedPanNumber);
              // NetcoreEvntService.Login_Status_IP(result, true);
              /* Please pass dynamic value of  PAN_NUMBER between '' whenever user logs in */
              /*netcore script end here*/
              sessionStorage.setItem('loggedIn', true);
              NetcoreEvntService.login_Success_Smartech();
              if (result.investorType != AppConstants.INVESTOR_TYPE.NEW) {
                if ($stateParams.trackId) {
                  $state.go('home', {
                    trackId: $stateParams.trackId,
                    trxnType: $stateParams.trxnType,
                    stepNo: $stateParams.stepNo
                  });
                } else {
                  $state.go('home');
                }
              } else {
                $state.go('welcome.newUserWelcome');
              }
            }
          } else {
            if (result && result.message) {
              MessageService.error(result.message);
              // NetcoreEvntService.Login_Status_IP({}, false);
              if(resp && resp.locked){
                vm.showUnlockID = true;
              }
            }
          }
        },
        errorLogin = function (msg) { 
          // vm.myRecaptchaResponse = ''; 
          LoaderService.hideLoader();
          if(loginMethod === 'MOBILE_NO'){ 
            if(msg.wrongOtpCount){
              vm.otpWrongAttempts = msg.wrongOtpCount;
              var leftAttempts =(5-parseInt(msg.wrongOtpCount));
              var invalidOTP =("Incorrect OTP. "+ leftAttempts.toString() +" attempts left. OTP is valid for 15 minutes.").toString();
              MessageService.error(invalidOTP);
              vm.myRecaptchaResponse ='';
              vm.loginPayload.otp1 = '';
              vm.loginPayload.otp2 = '';
              vm.loginPayload.otp3 = '';
              vm.loginPayload.otp4 = '';
              vm.loginPayload.otp5 = '';
              vm.loginPayload.otp6 = '';
              vm.loginPayload.otp = '';
              vm.showGCaptcha = false;
              if(vm.otpWrongAttempts >= vm.appConstants.OTP_WRONG_ATTEMPTS){
                $timeout(function(){
                  vm.showGCaptcha = true;
                },1000);
              }
              if(leftAttempts <= 0){  
                $state.reload();
              }
            }else{ 
              MessageService.error(msg.message);   
              $state.reload();
            }
            return;    
          }
          if (msg.message === 'Password Expired') {
            var payload = {userId: vm.loginPayload.username, errMsg: msg.message};
            ModalService.changePasswordModal(payload);
            vm.loginProcessFlag = false;
          }else if (msg.message === "REDIRECT_TO_OLD") {
            ModalService.redirectToOldFolioModal({});
            vm.loginProcessFlag = false;
          }else{
            if (msg && msg.message) {
              var messages = msg.message + '<span class="' + Math.random() + '"></span>';
              toastr.error(messages, '', {
                allowHtml: true,
                preventDuplicates: false,
                onHidden: function () {
                  vm.loginProcessFlag = false;
                }
              });
            } else {
              if (!$rootScope.online) {
                MessageService.error("No Internet Connection");
              } else {
                UtilService.errorHandler(msg);
              }
              vm.loginProcessFlag = false;
            }
          }
          // NetcoreEvntService.Login_Status_IP({}, false);
        };
        vm.loginPayload.otp = vm.loginPayload.otp1+vm.loginPayload.otp2+vm.loginPayload.otp3+vm.loginPayload.otp4+vm.loginPayload.otp5+vm.loginPayload.otp6;
        vm.loginPayload.otp = vm.loginPayload.otp;
      var userName = sessionStorage.getItem("payLoadUserName") || vm.loginPayload.username;
      if (loginMethod === 'ThroughPassword') {
        var payload = {
          grant_type : "password",
          username: AuthService.encryptRSA(angular.copy(userName)),
          password: vm.loginPayload && vm.loginPayload.otp ? AuthService.encryptRSA(angular.copy(vm.loginPayload.otp)) : ''
        };
        if(vm.appConstants && vm.appConstants.ENABLE_RISK_BASED_AUTHENTICATION){ 
          vm.deviceInfo = vm.getDeviceInfo();
          payload.device_info = vm.createAesRequestPayloadData(vm.deviceInfo);
        } 
        if(vm.isAdditionalFactorRequired){
          payload.additionalFactor = AuthService.encryptRSA(angular.copy(vm.loginPayload.authPanNumber));
        }
      }
      else if (loginMethod === 'OTP') {
        payload = {
          grant_type : "password",
          username: AuthService.encryptRSA(angular.copy(userName)),
          password: vm.loginPayload && vm.loginPayload.otp ? AuthService.encryptRSA(angular.copy(vm.loginPayload.otp)) : ''
        }
        if(vm.appConstants && vm.appConstants.ENABLE_RISK_BASED_AUTHENTICATION){ 
          vm.deviceInfo = vm.getDeviceInfo();
          payload.device_info = vm.createAesRequestPayloadData(vm.deviceInfo);
        }
        if(vm.isAdditionalFactorRequired){
          payload.additionalFactor = AuthService.encryptRSA(vm.loginPayload.authdob.format('YYYY-MM-DD'));
        }
      }
      else if (loginMethod === 'MOBILE_NO') {
        payload = {
          grant_type : "password",
          username: AuthService.encryptRSA(angular.copy(vm.loginPayload.mobileNumber)),
          password: vm.loginPayload && vm.loginPayload.otp ? AuthService.encryptRSA(angular.copy(vm.loginPayload.otp)) : ''
        }
        if(vm.otpWrongAttempts && vm.otpWrongAttempts >= 3){
          payload.gRecaptchaResponse = vm.myRecaptchaResponse;
        }
      }else if(loginMethod === 'SWITCH_MTOKEN_TO_ETOKEN'){
        // switch mobile token to existing login token
        var MToken = AuthService.getMobileLoginToken();
        singleUseURL = MToken.access_token;
        var userData = AuthService.getUserCookies(); 
        var payload = {
          grant_type : "password",
          password:AuthService.encryptRSA(angular.copy(MToken.mobile)),
          username:AuthService.encryptRSA(angular.copy(userData.pan)),
          folioNumber: userData && userData.folioNumber ? userData.folioNumber : ''
        }; 
      }
      vm.loginProcessFlag = true;
      LoaderService.showLoader();
      AuthService.login(payload, loginMethod, singleUseURL).then(successLogin, errorLogin);
    };

    var loginEvent = $rootScope.$on('loginPage', function (event) {
      vm.showPreviousStep();
    });

    function loginViaOtp() {
      vm.loginUsingOtpFlag = true;
      vm.showResendBtn=false;
      loginMethod = "OTP";
      resetForm();
    }

    function loginViaPassword() {
      vm.loginUsingOtpFlag = false;
      loginMethod = "ThroughPassword";
      resetForm();
    }

    function loginViaUpdate(val) {
      if(val == 'PAN'){
        vm.loginUsingOtpFlag = true;
      }else{
        vm.loginUsingOtpFlag = false;
      }
      if (vm.loginUsingOtpFlag) {
        vm.loginUsingOtpFlag = true;
        vm.showResendBtn=false;
        vm.isChecked = true;
        loginMethod = "OTP";
        resetForm();
      } else {
        vm.loginUsingOtpFlag = false;
        vm.isChecked = false;
        loginMethod = "ThroughPassword";
        resetForm();
      }
    }

    function showPreviousStep() {
      vm.showSecStep = false;
      if (vm.loginUsingOtpFlag) {
        vm.loginUsingOtpFlag = true;
        vm.showResendBtn=false;
        loginMethod = "OTP";
        vm.isChecked = true;
        resetForm();
      } else {
        vm.loginUsingOtpFlag = false;
        loginMethod = "ThroughPassword";
        vm.isChecked = false;
        resetForm();
      }
    }

    var resetTimer = function () {
      scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
      $timeout(function () {
        //vm.sentOtpRespMsg = '';
      },29000)
    };

    function confirmRegister() {
      var successModal = function () {

        },
        errorModal = function () {
          vm.formData={};
          $state.reload();
        };
      ModalService.confirmRegisterModal({}, successModal, errorModal)
    }

    function reset() {
      vm.loginPayload.password = '';
    }

    function resetForm() {
      vm.loginPayload.password = null;
      vm.loginPayload.panNumber = null;
      resetValues();
      vm.loginPayload.authPanNumber = null;
      vm.loginPayload.authdob = null;
      vm.loginPayload.otp = null;
      vm.showOtpField=false;
      vm.sentOtpRespMsg='';
      vm.isResetLoginForm = false;
      vm.showSecStep = false;
      singleUseURL = '';
      $timeout(function () {
        vm.isResetLoginForm = true;
      });
      sessionStorage.removeItem("payLoadUserName");
    }


    vm.getMaintenanceContent = function () {
      var _path = AppConstants.MAINTENANCE_CONTENT_URL,
        success = function (resp) {
        if(resp.status===200){
          if(resp.data && resp.data.data && resp.data.data.body){
            vm.mContent = $sce.trustAsHtml(resp.data.data.body);
          }
        }
        }, error = function () {};
      $http.get(_path).then(success, error);
    };

    function initiateOnHoldModal(screen) {
      ModalService.nonKycModal({
        'text': 'Cannot proceed with '+ screen +' since your KYC status is on hold.',
        'buttonText': 'OK'
      }, function() {}, function() {});
    }

    function initiateRejectModal(screen, ekycRequestCO) {
      ModalService.kycRejectModal({
        'screen': screen,
        'ekycRequestCO': ekycRequestCO,
        'buttonText': 'OK'
      }, function() {}, function() {});
    }

    function initiateGenericMessage(screen) {
      ModalService.nonKycModal({
        'text': 'Cannot proceed with ' + screen + ' since your KYC status is not verified.',
        'buttonText': 'OK'
      }, function() {}, function() {});
    }

    vm.handleSideBarClick = function(state) {
      sessionStorage.setItem("previousState", vm.investorSelection);
      $rootScope.previousLocation = vm.investorSelection;
      if (state === AppConstants.INVESTOR_SELECTION.EXISTING_USER) {
        vm.investorSelection = AppConstants.INVESTOR_SELECTION.EXISTING_USER;
        UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.EXISTING_USER);
      } else if (state === AppConstants.INVESTOR_SELECTION.NEW_INVESTOR) {
        vm.investorSelection = AppConstants.INVESTOR_SELECTION.NEW_INVESTOR;
        UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.NEW_INVESTOR);
      } else if (state === AppConstants.INVESTOR_SELECTION.QUICK_INVEST) {
        UtilService.updateSideBar(AppConstants.INVESTOR_SELECTION.QUICK_INVEST);
      }
    };

    function changedFont(valType){
      debugger;
      switch (valType) {
        case 'increment' : {
          if(vm.count<3){
            vm.count++;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'decrement' : {
          if(vm.count>-3){
            vm.count--;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'original' : {
          vm.count = 0;
          vm.fontSizeChange(vm.count);
        }
          break;
      }
    }

    function fontSizeChange(val){
      debugger;
      var elem = document.getElementsByTagName("body")[0];
      elem.classList.add("newBigFont");
      var ele = document.getElementsByClassName('newBigFont')[0];
      switch (val) {
        case -2 : {
          ele.setAttribute("style","font-size: 70% !important");
        }
          break;
        case -1 : {
          ele.setAttribute("style","font-size: 80% !important");
        }
          break;
        case 0 : {
          elem.removeAttribute('style');
          elem.classList.remove("newBigFont");
        }
          break;
        case 1 : {
          ele.setAttribute("style","font-size: 97% !important");
        }
          break;
        case 2 : {
          ele.setAttribute("style","font-size: 110% !important");
        }
          break;
      }
    }

    function contrast (){
      vm.contrastt = !vm.contrastt;
      if(!vm.contrastt){
        UtilService.darkThemeStatus.set(false);
        document.getElementsByTagName("body")[0].classList.add("contrastClass");
      } else {
        UtilService.darkThemeStatus.set(true);
        document.getElementsByTagName("body")[0].classList.remove("contrastClass");
      }
    }

    /* function responsible to identify the device width and add attribute to date input*/
    function checkDeviceSize() {
      if($(window).width() <= 767) {
        $(".newinvestor-dob").attr({
          'readonly': 'true'
        });
      } else {
        $(".newinvestor-dob").removeAttr('readonly');
      }
    }

     /*
     * function to fetch images dynamically
     */

     function fetchImage() {
       LoaderService.showLoader();
       var success = function(resp) {
         LoaderService.hideLoader();
         if (resp.status && resp.data) {
           if (resp.data.imageDTO.imageDTOMap.IMAGE_Existing_Investor && resp.data.imageDTO.imageDTOMap.IMAGE_Existing_Investor.contentPath !== undefined) {
             resp.data.imageDTO.imageDTOMap.IMAGE_Existing_Investor.contentPath = JSON.parse(resp.data.imageDTO.imageDTOMap.IMAGE_Existing_Investor.contentPath);
             var imageResponse = resp.data.imageDTO.imageDTOMap.IMAGE_Existing_Investor;
             if (imageResponse) {
               vm.imageUrls = imageResponse.contentPath;
               vm.redirectUrl = imageResponse.redirectUrl;
             }
           } else {
             vm.imageUrls = [];
           }
         } else {
            UtilService.errorHandler("Something Went wrong , please try again later");
         }
       }, failure = function(resp) {
              MessageService.error(resp)
              LoaderService.hideLoader();
       };
       var payload = {
         "pageName": "EXISTING_INVESTOR"
       }
       InvestorService.post({child1: 'dynamicContent'}, payload).$promise.then(success, failure);
     }

     function redirectTo(url) {
       $window.location.href = url;
     } 
    function createAesRequestPayloadData(jsonRequiredToEncrypt) {
      if(jsonRequiredToEncrypt.request || jsonRequiredToEncrypt.checksum){
        return jsonRequiredToEncrypt;
      }
      var key =  FormatterService.hash.lib.WordArray.random(128/8); //16bit
      var IV =  FormatterService.hash.lib.WordArray.random(128/8); //8bit
      var aesEncrypted = FormatterService.hash.AES.encrypt(angular.toJson(jsonRequiredToEncrypt), key, { iv: IV });
      var ivAndKey = FormatterService.hash.enc.Base64.stringify(IV) + "|" + FormatterService.hash.enc.Base64.stringify(key);
      return (FormatterService.getFormatter().encrypt(ivAndKey) + "|" + FormatterService.hash.enc.Base64.stringify(aesEncrypted.ciphertext));
    }

     function chooseLogin(val){
      vm.singleUseURL = '';
      vm.showSecStep = false;
      vm.showOtpField = false;
      vm.maskedMobileNo = '';
      vm.loginPayload.otp1 = '';
      vm.loginPayload.otp2 = '';
      vm.loginPayload.otp3 = '';
      vm.loginPayload.otp4 = '';
      vm.loginPayload.otp5 = '';
      vm.loginPayload.otp6 = '';
      vm.loginPayload.otp = '';
      vm.loginPayload.authPanNumber='';
      vm.loginPayload.authdob='';
      vm.loginWith = val;
      if(!vm.tracked){ 
        vm.loginPayload.username = null;
      }
      vm.loginPayload.mobileNumber = null;
      vm.loginPayload.password = null;
      vm.loginPayload.panNumber = null;
      vm.tnc = false;
      if(vm.loginWith == 'MOBILE_NUMBER'){
        loginMethod = 'MOBILE_NO';
      }else{
        loginMethod = 'ThroughPassword';
      } 
     }   
    function maskMobileNumber(val){
      var maskMobile = '';
      for(var i = 0;i<10;i++){
        if(i<6){
          maskMobile = maskMobile + '*';
        }else{
          maskMobile = maskMobile+val[i];
        }
      }
      return maskMobile;
    } 
    vm.changeMobileNo = function(){
      vm.loginPayload.otp = '';
      vm.loginPayload.mobileNumber = '';
      vm.tnc = false;
      chooseLogin('MOBILE_NUMBER');
    } 
    vm.verifyCodeOtp = ''; 
    function otpValChanged(myvalue) { 
      vm.loginPayload.otp = vm.loginPayload.otp1 + vm.loginPayload.otp2 + vm.loginPayload.otp3 + vm.loginPayload.otp4 + vm.loginPayload.otp5 + vm.loginPayload.otp6;
      vm.otpCodeLength = vm.loginPayload.otp.toString().length
      var container = document.getElementsByClassName("input-code")[0];
      container.onkeyup = function (e) {
        var target = e.target;

        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          var next = target;
          while (next = next.nextElementSibling) {
            if (next == null)
              break;
            if (next.tagName.toLowerCase() == "input") {
              next.focus();
              break;
            }
          }
        } else if (myLength < maxLength) {
          var prev = target;
          while (prev = prev.previousElementSibling) {
            if (prev == null)
              break

            if (prev.tagName.toLowerCase() == "input") {
              prev.focus();
              break;
            }
          }
        }
      }
    }; 


      // redirect to add pan flow or preliminary dashboard
      vm.redirectToMobileTokenBased = function (data) {  
        var successIsExisting = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {   
            vm.token = AuthService.getMobileLoginToken(); 
            vm.timestampMatch = sessionStorage.getItem('timestampMatch');
            if(vm.token.mobile == resp.data.investorMobile && vm.timestampMatch == resp.data.timestamp){ 
              sessionStorage.removeItem('timestampMatch'); 
              var userData = {
                mobile : angular.copy(resp.data.investorMobile), 
                encryptedMobile : AuthService.encryptRSA(angular.copy(resp.data.investorMobile)), 
                existingInvestor : resp.data.existingInvestor
              }
              AuthService.setUserCookies(userData);
              if(resp.data.existingInvestor){ 
                // call VERIFY_PAN modal 
                // vm.openLoginWithMobileModal();
                $state.go('checkUser');
                } else{ 
                  var data = AuthService.getMobileLoginToken();
                  data.newPrelimanryUser = true;
                  AuthService.setMobileLoginToken(data); 
                  $state.go('preliminaryDashboard'); 
              }
            }else{
              MessageService.error("Data request not match.");
              sessionStorage.removeItem('timestampMatch');
               // logout mobile token
               var success = function (resp) {
                if (resp && resp.status) { 
                  $state.reload();
                } else {
                  $state.reload();
                } 
              },
              error = function () {
              }; 
              var userDetails = AuthService.getMobileLoginToken(); 
              if(userDetails){
                var payload = {  
                  mobile: AuthService.encryptRSA(userDetails.mobile),
                  forceLogout:true
                }
              }
              AuthService.mobileTokenLogout(payload).then(success, error);
            }  
          } else {
            sessionStorage.removeItem('timestampMatch');
            if(resp.logout){
              // logout mobile token
              var success = function (resp) {
                if (resp && resp.status) { 
                  $state.reload();
                } else {
                  $state.reload();
                } 
              },
              error = function () {
              };
              var userDetails = AuthService.getMobileLoginToken(); 
              if(userDetails){
                var payload = {  
                  mobile: AuthService.encryptRSA(userDetails.mobile),
                  forceLogout:true
                }
              } 
              AuthService.mobileTokenLogout(payload).then(success, error);
              MessageService.error("Something went wrong. Please try again later.");
            }
          }
        }, failureIsExisting = function (resp) {
          MessageService.error(resp)
          LoaderService.hideLoader();
        }; 
        LoaderService.showLoader();
        var timestampData = new Date().valueOf().toString();
        sessionStorage.setItem('timestampMatch', timestampData);
        var payload = {
          timestamp : timestampData
        }; 
        InvestorService.post({ child1: 'mobile',child2:"checkExistingInvestor" },payload).$promise.then(successIsExisting, failureIsExisting);   
    }

    //logout mobile token session
    function mobileTknLogout(forceLogout){ 
      var successLogin = function (resp) {  
        $state.reload();
      },
      errorLogin = function (err) { 
      }
      LoaderService.showLoader(); 
      var userDetails = AuthService.getUserCookies();
      var payload = {  
        mobile: userDetails.encryptedMobile,
        forceLogout:forceLogout?true:false
      }  
      AuthService.mobileTokenLogout(payload).then(successLogin, errorLogin);
    } 

     vm.getDeviceInfo = function(){      
      var deviceDataPayload = {
        "userId": vm.loginPayload.username,
        "language": navigator.language,
        "platform": "WEB",
        "time_zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
        "user_Agent": navigator.userAgent,
        "network_type": navigator.connection ? navigator.connection.effectiveType : 'Not available',
        "device_memory": navigator.deviceMemory || 'Not available',
        "viewportWidth": $window.innerWidth,
        "uniqueDeviceId": vm.uniqueDeviceID,
        "viewportHeight": $window.innerHeight,
        "max_touchpoints": navigator.maxTouchPoints || 'Not available',
        "screen_resolution": $window.screen.width+'x'+$window.screen.height,
        "hardware_Concurrency": navigator.hardwareConcurrency || 'Not available'
      }
      return deviceDataPayload;
     }
     function checkDobDate(date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.loginPayload.authdob = date;
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';
      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.loginPayload.authdob = "";
      }
      return;
    }
    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
         oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
     }
  }
})();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .controller('KycverifyController', kycverifyController);
  
    /** @ngInject */
    function kycverifyController($stateParams, LoaderService, $timeout,$http,HDFC_API, $sce,AppConstants,InvestorService,UtilService,MessageService,HdfcKycService) {
      var vm=this;
      vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
      vm.payload = {email: '', mobile: '',sessId: ''};
      vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
      vm.pattern = AppConstants;
    
      vm.userData = JSON.parse(sessionStorage.getItem('userDataForKyc'));
      if(vm.userData){
        LoaderService.hideLoader();
      }else{
        LoaderService.showLoader();
        MessageService.error("Required data not found!");
      }

      vm.handleProceedAction = function () {
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.request && resp.checksum && resp.key) {
            vm.encData = {};
            vm.encData.request = resp.request;
            vm.encData.checksum = resp.checksum;
            vm.encData.key = resp.key;
            vm.gotoEkyc();
          } else {
            MessageService.error("PAN data is Invalid");
          }
        }, error = function (err) {
          MessageService.error(err);
        };
        var payload = {
          panNumber:vm.userData.panNumber,
          arn_code: vm.userData.arn_code,
          source : vm.userData.source,
          unique_id:vm.getUniqueId(),
          emailId: vm.payload.email,
          mobile : vm.payload.mobile
        };
  
        LoaderService.showLoader();
        HdfcKycService.post({
          child1: 'api-gateway',
          child2: 'partner',
          child3: 'v1',
          child4: 'encryptRequest',
          child5: HDFC_API.PARTNER_ARN,
          child6: payload.source
        }, payload).$promise.then(success, error);
      };
      vm.getUniqueId = function () {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = String(today.getFullYear());
        var hh = String(today.getHours());
        var min = String(today.getMinutes());
        var ss = String(today.getSeconds());
        return dd + mm + yyyy + hh + min + ss;
      }
      vm.gotoEkyc = function(){
        var dataPayloa = {
          request: vm.encData.request,
          checksum: vm.encData.checksum
        }
        LoaderService.showLoader();
        var _path = HDFC_API.PROTOCOL + HDFC_API.MAIN_HOST + 'api-gateway/partner/v1/newInvestor/eKyc'
        $http.post(_path, dataPayloa, {
          headers: {
            'Content-Type': 'application/json',
            'token': vm.encData.key
          }
        }).then(
          function (resp) {
            if (resp.data) {
              LoaderService.hideLoader();
              vm.decryptUserData(resp.data);
            } else {
              MessageService.error(resp.message);
            }
          },
          function (err) {
            MessageService.error(err);
          });
      }
      vm.decryptUserData = function (data) {
        var success = function (resp) {
          if(resp.data){
            var element = document.getElementById("mainEkyc");
            element.innerHTML += resp.data;
            $timeout(function () {
              angular.element('#ekycForm').submit();
              sessionStorage.removeItem('userDataForKyc');
            }, 100);
            $timeout(function () {
              LoaderService.hideLoader();
            }, 9000);
          }
        }, error = function (err) {
          if(err.data){
            if(err.data.message){
              MessageService.error(err.data.message);
            }else{
              MessageService.error(err);
            }
          }
          LoaderService.hideLoader();
        };
        var payload = {
          "text": data.request,
          "key": data.key
        };
        LoaderService.showLoader();
        HdfcKycService.post({
          child1: 'api-gateway',
          child2: 'partner',
          child3: 'v1',
          child4: 'decryptRequest'
        }, payload).$promise.then(success, error);
      }

    }
  })();
  
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('KycController', kycController);

  /** @ngInject */
  function kycController($stateParams, $window, $state, $http, toastr, HDFC_API, LoaderService, $timeout, $sce, AppConstants, InvestorService, UtilService, MessageService, $log, AuthService, CreatePayloadFactory, ModalService, InvestorServiceVersion3, HdfcKycService) {
    var vm = this;
    vm.resetValues = resetValues;
    vm.checkPanVerification = checkPanVerification;
    vm.changeStartDate = changeStartDate;
    vm.viewMode = "days";
    vm.dateErrorMessage = "";
    vm.proceedKyc = false;
    vm.payload = { email: '', mobile: '', sessId: '' };
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.formData = {
      pan: "",
      dob: ""
    };

    vm.init = function () {
    
    }
    vm.init();
    function checkPanVerification() {
      if (vm.formData.pan) {
        var success = function (resp) {
          LoaderService.hideLoader('.pan-loader');
          if (resp.data && resp.status) {
            $log.info("resp.data=== ", resp.data);
            if (resp.data.panVerifiedFlag) {
              vm.panMessage = "";
            } else {
              vm.panMessage = resp.data.message;
            }
            vm.processFlag = false;
          } else {
            vm.processFlag = true;
            vm.panMessage = resp.message;
          }
        },
          error = function () {
            LoaderService.hideLoader('.pan-loader');
            vm.processFlag = true;
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        vm.processFlag = false;
        LoaderService.showLoader('.pan-loader');
        InvestorService.post({
          child1: 'registration',
          child2: 'verifyPan'
        }, { "panNumber": vm.formData.pan }).$promise.then(success, error);
      }
    }

    function resetValues() {
      vm.errorMessage = "";
      vm.errorMessageVerify = "";
      vm.panMessage = "";
      vm.availableMessage = "";
      vm.otpResendMessage = "";
      vm.dateErrorMessage = "";
    }
    //First
    vm.verifyDetails = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.request && resp.checksum && resp.key) {
          vm.encryptData = {};
          vm.encryptData = {
            request: resp.request,
            checksum: resp.checksum,
            key: resp.key
          }
          sessionStorage.setItem('kycToken', vm.encryptData.key);
          vm.verifyPan();
        } else {
          LoaderService.hideLoader();
          MessageService.error("PAN data is Invalid");
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        if(err.data){
          MessageService.error(err.data.message);
        }else{
          MessageService.error("Something went wrong");
        }
      };
      var payload = {
        arn_code: HDFC_API.PARTNER_ARN,
        source: "HE",
        unique_id: vm.getUniqueId(),
        panNumber: vm.formData.pan,
        dob: vm.formData.dob
      };
      sessionStorage.setItem('userDataForKyc', JSON.stringify(payload));
      LoaderService.showLoader();
      HdfcKycService.post({
        child1: 'api-gateway',
        child2: 'partner',
        child3: 'v1',
        child4: 'encryptRequest',
        child5: HDFC_API.PARTNER_ARN,
        child6: 'HE'
      }, payload).$promise.then(success, error);
    }
    //Second
    vm.verifyPan = function () {
      var dataPayloa = {
        request: vm.encryptData.request,
        checksum: vm.encryptData.checksum
      }
      LoaderService.showLoader();
      var _path = HDFC_API.PROTOCOL + HDFC_API.MAIN_HOST + 'api-gateway/partner/v1/newInvestor/verifyKyc'
      $http.post(_path, dataPayloa, {
        headers: {
          'Content-Type': 'application/json',
          'token': vm.encryptData.key
        }
      }).then(
        function (resp) {
          if (resp.data.key && resp.data.request) {
            vm.checkPanData(resp.data);
          } else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        function (err) {
          LoaderService.hideLoader();
          if(err.data){
            MessageService.error(err.data.message);
          }else{
            MessageService.error("Somthing went wrong");
          }
          
        });
    }
    //Third
    vm.checkPanData = function (data) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.kycStatus == 'NOT_VERIFIED') {
          vm.proceedKyc = true;
          $state.go('verifykyc');
        } 
        if (resp.kycStatus == 'VERIFIED') {
          MessageService.success("Your PAN is kyc verified!");
        }
      }, error = function (err) {
        MessageService.error(err);
        LoaderService.hideLoader();
      };
      var payload = {
        "text": data.request,
        "key": data.key
      };
      LoaderService.showLoader();
      HdfcKycService.post({
        child1: 'api-gateway',
        child2: 'partner',
        child3: 'v1',
        child4: 'decryptRequest'
      }, payload).$promise.then(success, error);
    }
    vm.getUniqueId = function () {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, "0");
      var yyyy = String(today.getFullYear());
      var hh = String(today.getHours());
      var min = String(today.getMinutes());
      var ss = String(today.getSeconds());
      return dd + mm + yyyy + hh + min + ss;
    }
    function changeStartDate(date) {
      if (
        angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(
          date._i
        )
      ) {
        vm.dobtrue = true
        vm.formData.dob = date._i;
        vm.dob = date._i;
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = "";
      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.formData.dob = "";
        vm.dobtrue = false
      }
      return;
    }
    vm.varifyDate = function () {
      var doblength = vm.dob ? vm.dob.length : 0
      if (doblength == 10) {
        if (
          angular.isDefined(vm.dob) ||
          /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(
            vm.dob
          )
        ) {
          vm.formData.dob = vm.dob;
          if (!vm.dob) {
            vm.dateErrorMessage = vm.validateData.DOB_FIELD;
          } else {
            vm.dateErrorMessage = "";
            vm.dobtrue = true
          }
        } else {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
          vm.formData.dob = "";
        }
        return;
      }
      else {
        vm.dobtrue = false;
      }
    }

  vm.gototp = function(){
    $window.scrollTo(0, 0);
  }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestorProfileUserIdController', InvestorProfileUserIdController);

  /** @ngInject */
  function InvestorProfileUserIdController($window, $rootScope, $timeout, $state, $stateParams, $scope, AuthService, HDFC_API, toastr, LoaderService,
                                           AppConstants, TransactionService, MessageService, ModalService, UtilService, CommonFactory, CreatePayloadFactory, InvestorService,
                                           deviceDetector, $http, $sce, NetcoreEvntService, $log, BrowserService, investorServiceVersion, InvestorServiceVersion3, MetaTagService) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var vm = this;
    vm.mainPassword = "";
    vm.Cpassword = "";
    vm.passwordMatchSuccess = false;
    vm.userName = ""
    vm.appConstants = AppConstants;
    vm.peocessOTPFlag = false;
    vm.showPassword = false;
    vm.showConfirmPassword = false;
    vm.profiledata = {}
    vm.appConstants = AppConstants,
      vm.processOTPFlag = false;
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    vm.errorMessage = '';
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.inputReset = false;
    vm.otpNumber = "";
    vm.showotPindow = false;
    vm.otpResendMessage = "";
    vm.init = init;
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
    vm.avaiableMessage = "";

    function init() {
      vm.distributorDetails = JSON.parse(sessionStorage.getItem("distributorDetails"));
      if(vm.distributorDetails) {
        if(vm.distributorDetails.isHdfcBank){
          ModalService.arnPopupModal({ status: "EXISTINGUSER"},
            function (data) {if(data == 'home'){ $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.distributorDetails.chipherText;}},function (data) { });
        }else{
          $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.distributorDetails.chipherText;
        }
      }
      vm.currentUserPayload = JSON.parse(sessionStorage.getItem("verifyObj"))
      if(!vm.currentUserPayload){
        $state.go("newInvestor.kycVerification");
      } else {
        // console.log(vm.currentUserPayload);
        vm.panNumber = vm.currentUserPayload.panNumber;
        localStorage.setItem('userEmail', vm.currentUserPayload.emailid);
        getUserDetails();
        vm.ModeOfHold = sessionStorage.getItem('ModeOfHold');
        vm.holdmode = localStorage.getItem('holdmode');
      }

    }

    $('#newuserPassword').bind("cut copy paste",function(e) {
      e.preventDefault();
    });
    $('#confirmPassword').bind("cut copy paste",function(e) {
      e.preventDefault();
    });
    function getUserDetails() {

      if (!vm.currentUserPayload) {
        $state.go("login");
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          if ((resp.data.kycStatus === vm.KYC_STATUS.VERIFIED || resp.data.kycStatus === vm.KYC_STATUS.IN_PROGRESS)) {
            if (Object.keys(resp.data).length != 0) {
              vm.UserData = resp.data;
              vm.userName = vm.UserData.suggestedUserId;
              sessionStorage.removeItem("verifyObj");
              // console.log(vm.Cpassword.UserData);
              // console.log(vm.userName);
            } else {
              $state.go("login");
              sessionStorage.removeItem("verifyObj");
            }
          }
        } else if (!resp.status) {
          $state.go("login");
          sessionStorage.removeItem("verifyObj");
        }
      }, error = function (resp) {
        MessageService.error(resp.message);
        $state.go("login");
        sessionStorage.removeItem("verifyObj");
      };
      var data = {
        panNumber : vm.currentUserPayload.panNumber,
        dob : vm.currentUserPayload.dob
      };

      $window.smartech('dispatch', 'user id creation post kyc', {});

      investorServiceVersion.post({
        child1: 'registration',
        child2: 'verifyKyc',
        child3: 'generate',
        child4: 'userId'
      }, data).$promise.then(success, error);
    }

    vm.resetData = function () {
      vm.avaiableMessage = "";
      vm.mainPassword = "";
      vm.Cpassword = "";
    }
    vm.resetValues = function () {
      vm.errorMessage = "";
      vm.panMessage = "";
      vm.availableMessage = "";
      vm.otpResendMessage = "";
      vm.dateErrorMessage = "";
    }

    vm.matchPassword = function () {
      if (vm.mainPassword == vm.Cpassword) {
        vm.passwordMatchSuccess = true;
      }
      else {
        vm.passwordMatchSuccess = false;
      }
    }

    vm.togglePassword = function () {
      vm.showPassword = !vm.showPassword;
    }
    vm.toggleConfirmPassword = function () {
      vm.showConfirmPassword = !vm.showConfirmPassword;
    }

    vm.checkAvailability = function() {
      if (vm.userName) {
        var success = function (resp) {
            LoaderService.hideLoader('.availability-loader');
            if (resp.data && resp.status) {
              $log.info(resp.data.userIdAvailableFlag);
              if (resp.data.userIdAvailableFlag) {
                vm.availableMessage = "";
              } else {
                vm.availableMessage = resp.data.message || 'User ID not available';
              }
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader('.availability-loader');
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        LoaderService.showLoader('.availability-loader');
        InvestorService.post({
          child1: 'registration',
          child2: 'userId',
          child3: 'availability'
        },{
          userId: vm.userName
        }).$promise.then(success, error);
      }
    }

    vm.registerNewUser = function(){
      var success = function (resp) {
          if(resp.status){
            var success = function () {
              vm.formData = {};
              AuthService.clearCookies(AppConstants.IDENTIFIER) ;
              $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH;
            };
            var dismiss = function () {
              vm.formData = {};
              AuthService.clearCookies(AppConstants.IDENTIFIER) ;
              $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH;
            };
            ModalService.newJourneyRegisteredModal({
              'text': 'UserID Created Successfully. Please Proceed to Login',
              'buttonText': 'Proceed to login'}, success, dismiss ,"custom");
          }else{
            MessageService.error(resp.message);
            // $state.go('login');
          }
        },
        error = function (error) {
          MessageService.error(error);
        };
      var payload = {
        password: AuthService.encryptRSA(vm.mainPassword),
        panNumber: vm.currentUserPayload.panNumber,
        userId: vm.userName,
        registrationType: "NEW_USER",
        panHolderName: vm.UserData.panHolderName,
        emailId: vm.UserData.emailId.toLowerCase(),
        contactNumber: vm.UserData.contactNumber
      }

      InvestorService.post({
        child1: 'registration',
        child2: 'new',
        child3: 'user'
      }, payload).$promise.then(success, error);
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .config(profile);

  /** @ngInject */
  function profile($stateProvider) {
    $stateProvider
      .state('main.profile', {
        url: '/profile',
        templateUrl: 'app/investor/profile/profile.html',
        controller: 'ProfileController',
        controllerAs: 'ProfileParentCtrl',
        authenticate: true,
        defaultRoute: '.basicInfo',
        resolve : {
          dynamicData : _fetchDynamicDataBasic,
          dynamicDataStandalone: _fetchDynamicDataEmandate
        }
      })

      .state('main.profile.basicInfo', {
        url: '/basicInfo',
        templateUrl: 'app/investor/profile/profileDetails/basicInfo.html',
        controller: 'ProfileController',
        controllerAs: 'Profile',
        // parent:'main.profile',
        authenticate: true,
        resolve : {
          dynamicData : _fetchDynamicDataBasic,
          dynamicDataStandalone: _fetchDynamicDataEmandate
        }
      })
      .state('main.profile.folioDetails', {
        url: '/folioDetails',
        templateUrl: 'app/investor/profile/profileDetails/folioDetails.html',
        controller: 'ProfileController',
        controllerAs: 'Profile',
        // parent:'main.profile',
        authenticate: true,
        resolve : {
          dynamicData : _fetchDynamicDataBasic,
          dynamicDataStandalone: _fetchDynamicDataEmandate
        }
      })
      .state('main.profile.pendingApprovals', {
        url: '/pendingApprovals',
        templateUrl: 'app/investor/profile/profileDetails/pendingApprovals/pendingApprovals.html',
        controller: 'ProfileApprovalController',
        controllerAs: 'Profile',
        // parent:'main.profile',
        authenticate: true
      })
      .state('main.fatcaUpdate', {
        url: '/fatcaUpdate',
        templateUrl: 'app/investor/profile/fatcaUpdate.html',
        controller: 'ProfileController',
        controllerAs: 'Profile',
        params: {folioNumber: null},
        authenticate: true,
        resolve : {
          dynamicData : _fetchDynamicDataBasic,
          dynamicDataStandalone: _fetchDynamicDataEmandate
        }
      })
      .state('main.KycUpdate', {
        url: '/KycUpdate',
        templateUrl: 'app/investor/profile/kycUpdate.html',
        controller: 'ProfileController',
        controllerAs: 'Profile',
        params: {folioNumber: null},
        authenticate: true,
        resolve : {
          dynamicData : _fetchDynamicDataBasic,
          dynamicDataStandalone: _fetchDynamicDataEmandate
        }
      })
      .state('main.updateIFSC', {
        url: '/profile/updateIFSC/:folioNumber',
        templateUrl: 'app/investor/profile/modifyBank/updateIFSC/updateIFSC.html',
        controller: 'UpdateIFSCController',
        controllerAs: 'UpdateIFSC',
        authenticate: true
      })
      .state('main.changeBank', {
        url: '/profile/changeBank',
        templateUrl: 'app/investor/profile/modifyBank/changeBank/changeBank.html',
        controller: 'ChangeBankController',
        controllerAs: 'ChangeBank',
        authenticate: true
      })
      .state('main.addBank', {
        url: '/profile/addNewBank',
        templateUrl: 'app/investor/profile/modifyBank/addBank/addBank.html',
        controller: 'AddBankController',
        controllerAs: 'AddBank',
        authenticate: true,
        resolve : { dynamicData: _fetchDynamicDataAddBank }
      })
      .state('main.updateNominee',{
        url: '/profile/updateNominee/:folioNo',
        templateUrl: 'app/investor/profile/modifyNominee/updateNominee.html',
        controller: 'UpdateNomineeController',
        controllerAs: 'UpdateNominee',
        authenticate: true
      })
      .state('main.optoutNominee',{
        url: '/profile/optoutNominee/:folioNo',
        templateUrl: 'app/investor/profile/optoutNominee/optoutNominee.html',
        controller: 'OptoutNomineeController',
        controllerAs: 'OptoutNominee',
        authenticate: true,
        resolve : {
          dynamicData : _fetchDynamicDataFolioApproval
        }
      })
      .state('main.changeMultipleBank', {
        url: '/profile/changeMultipleBank',
        templateUrl: 'app/investor/profile/modifyBank/changeMultipleBank/changeMultipleBank.html',
        controller: 'AddBankController',
        controllerAs: 'AddBank',
        authenticate: true,
        resolve : { dynamicData: _fetchDynamicDataAddBank }
      })
      .state('main.cobmStatus', {
        url: '/profile/cobmStatus',
        templateUrl: 'app/investor/profile/modifyBank/cobmStatus/cobmStatus.html',
        controller: 'CobmStatusController',
        controllerAs: 'CobmStatus',
        authenticate: true
      })
      .state('holderApproval', {
        url: '/initiate/summary/holder-approval/:uuid?version',
        templateUrl: 'app/investor/holderApproval/holder-smartlink.html',
        controller: 'HolderApprovalController',
        controllerAs: 'Approval',
        authenticate: false,
        resolve : {
          // checkValidHolder:_checkValidHolder
          dynamicData : _fetchDynamicDataFolioApproval
        }
      })
      .state('main.investorApproval', {
        url: '/approval/folio/:uuid/investor/:type',
        templateUrl: 'app/investor/holderApproval/holder.html',
        controller: 'HolderApprovalController',
        controllerAs: 'Approval',
        authenticate:  false,
        resolve : {
          checkValidHolder:_checkValidHolder,
          dynamicData : _fetchDynamicDataFolioApproval
        }
      })
      .state('main.profile.declaration', {
        url: '/declaration',
        templateUrl: 'app/investor/profile/declaration/declaration.html',
        controller: 'Declaration',
        controllerAs: 'Declaration',
        authenticate: true,
        resolve : {  dynamicData : _fetchDynamicDataBasic}
      })
      .state('holderApprovalForNomineeOptOut', {
        url: '/initiate/summary/NomineeOptOut/:uuid?version',
        templateUrl: 'app/investor/holderApprovalForNominee/holderApprovalForNominee.html',
        controller: 'HolderApprovalForNomineeController',
        controllerAs: 'ApprovalForNominee'
      })
      .state('holderApprovalForNomineeAddUpdate', {
        url: '/initiate/summary/NomineeAddUpdate/:uuid?version&sebi_reg',
        templateUrl: 'app/investor/holderApprovalForNominee/holderApprovalForNominee.html',
        controller: 'HolderApprovalForNomineeController',
        controllerAs: 'ApprovalForNominee'
      })
      .state('main.holderApprovalForNomination', {
        url: '/approval/nominee/:uuid/investor/:type/:approvalType?sebi_reg',
        templateUrl: 'app/investor/holderApprovalForNominee/holderApprovalForNominee.html',
        controller: 'HolderApprovalForNomineeController',
        controllerAs: 'ApprovalForNominee'
      })
  }

  /** @ngInject */
  function _checkValidHolder($stateParams, $q, MessageService, InvestorFolioModel, InvestorService, UtilService) {
    if (!$stateParams.uuid) {
      UtilService.errorHandler('Not a valid link');
      return;
    } else {
      var deferred = $q.defer(),
        success = function (resp) {
          if (resp.status && resp.data) {
            InvestorFolioModel.setInvestorFolioModel(resp.data);
            deferred.resolve(true);
          } else {
            MessageService.error(resp.message);
            deferred.reject(resp.message);
          }
        }, error = function (err) {
          MessageService.error('An unauthorized access');
          deferred.reject(err);
        };
      InvestorService.post({
        child1: 'folio',
        child2: 'any-or-survivor',
        child3: 'get',
        child4: 'joint',
        child5: 'holder',
        child6: 'data'
      }, {linkId: $stateParams.uuid}).$promise.then(success, error);
      return deferred.promise;
    }
  }

    /** @ngInject */
  function _fetchDynamicDataBasic(UtilService) {
    return UtilService.fetchDynamicData('PROFILE');
  }

  /** @ngInject */
  function _fetchDynamicDataAddBank(UtilService) {
    return UtilService.fetchDynamicData('ADD_NEW_BANK');
  }

  /** @ngInject */
  function _fetchDynamicDataEmandate(UtilService) {
    return UtilService.fetchDynamicData('STANDALONE_EMANDATE');
  }
  function _fetchDynamicDataFolioApproval(UtilService){
    return UtilService.fetchDynamicData('FOLIO_CREATION')
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .config(profile);

  /** @ngInject */
  function profile($stateProvider) {
    $stateProvider
      .state('main.investment', {
        url: '/investment',
        templateUrl: 'app/investment-baskets/investment.html',
        controller: 'InvestmentController',
        controllerAs: 'Investment',
        authenticate: true
      })
      .state('main.investment.goals', {
        url: '/goals?goalId',
        // templateUrl: 'app/investment-baskets/goals/goals-list/goals-list.html',
        templateUrl : 'app/investment-baskets/goals/goals.html',
        controller: 'GoalsController',
        controllerAs: 'GoalsCtrl',
        authenticate: true
      })
      .state('main.questionnaire', {
        url: '/goal-planners/:goalName',
        templateUrl: 'app/investment-baskets/goals/goals-questionnaires/goals-questionnaires.html',
        controller: 'GoalsController',
        controllerAs: 'GoalsController',
        authenticate: true
      })
      .state('main.investment.suggestions', {
        url: '/suggestions',
        templateUrl: 'app/investment-baskets/suggestions/suggestion.html',
        controller: 'SuggestionController',
        controllerAs: 'Suggestion',
        authenticate: true,
        title: "Our Suggestions"
      })
      .state('main.investment.basket', {
        url: '/basket',
        templateUrl: 'app/investment-baskets/basket/basket.html',
        controller: 'InvestmentBasketController',
        controllerAs: 'BasketCtrl',
        authenticate: true
      })
      .state('main.investment.basketView', {
        url: '/basket/view',
        templateUrl: 'app/investment-baskets/basket/basketView/basket.view.html',
        controller: 'InvestmentBasketViewController',
        controllerAs: 'BasketCtrl',
        authenticate: true
      })
      .state('main.investment.basketDetails', {
        url: '/basket/details/:id',
        templateUrl: 'app/investment-baskets/basket/basket-details/basket.details.html',
        controller: 'InvestmentBasketDetailsController',
        controllerAs: 'BasketDetailsCtrl',
        authenticate: true
      })
      .state('main.investment.investNow', {
        url:'/invest-now/:basketId/:retirementFlag?journey',
        templateUrl: 'app/investment-baskets/basket-invest-now/invest.now.html',
        controller: 'InvestmentInvestNowController',
        controllerAs: 'InvestNowCtrl',
        authenticate: true
      })
      .state('main.investment.investNowScheme', {
        url:'/invest-now-scheme/:retirementFlag?journey',
        templateUrl: 'app/investment-baskets/scheme-invest/scheme-invest.html',
        controller: 'InvestmentInvestNowController',
        controllerAs: 'InvestNowCtrl',
        authenticate: true
      })
      .state('main.investment.transactionFailure', {
        url:'/transaction-failure/:type',
        templateUrl: 'app/investment-baskets/transaction-failure/transaction.failure.html',
        controller: 'TransactionFailureController',
        controllerAs: 'TransFailureCtrl',
        authenticate: true
      })
      .state('main.investment.purchaseTransactionSuccess', {
        url:'/transaction-success/purchase/:transactionId/:transactionType/:isFavourite?existingInvestor',
        templateUrl: 'app/investment-baskets/transaction-success/purchase.transaction.success.html',
        controller: 'PurchaseTransactionSuccessController',
        controllerAs: 'PurchaseSuccessCtrl',
        authenticate: true,
        resolve: {summaryData: _transactionSummary}
      })
      .state('main.investment.sipTransactionSuccess', {
        url:'/transaction-success/sip',
        templateUrl: 'app/investment-baskets/transaction-success/sip.transaction.success.html',
        controller: 'SipTransactionSuccessController',
        controllerAs: 'SipTranSuccessCtrl',
        authenticate: true,
        params: {
          existingInvestor : true
        }
      })
      .state('main.investment.purchaseOrSip', {
        url: '/purchase',
        templateUrl: 'app/investment-baskets/investment-transaction/investmentSipPurchase.html',
        controller: 'InvestmentSipPurchaseController',
        controllerAs: 'Investment',
        authenticate: true,
        title: "Transact now"
      })
      .state('main.investment.payment', {
        url:'/payment?journeyId',
        templateUrl: 'app/investment-baskets/invest-now/payment/payment.html',
        controller: 'InvestNowPaymentController',
        controllerAs: 'InvestNowPayment',
        authenticate: true,
        resolve: {
          DynamicDataSipPurchaseReview : _fetchDynamicDataSip,
          notesPayment : _fetchDynamicDataPurchasePayment
        },
        params: {
          existingInvestor : true
        }
      })
      .state('investNow', {
        url:'/invest-now?id',
        templateUrl: 'app/investment-baskets/invest-now/invest-now.html',
        controller: 'InvestNowController',
        controllerAs: 'InvestNow',
        authenticate: false
      })

      .state('preLoginBasket', {
        url:'/investNowJourney',
        templateUrl: 'app/investment-baskets/pre-login/pre-login.html',
        controller: 'BasketPreLoginController',
        controllerAs: 'InvestNow',
        authenticate: false
      })

      .state('preLoginBasket.investNow', {
        url:'/invest-now/:basketId?journey',
        templateUrl: 'app/investment-baskets/basket-invest-now/invest.now.html',
        controller: 'InvestmentInvestNowController',
        controllerAs: 'InvestNowCtrl',
        authenticate: true,
        params: {
          fromPreLogin : true
        }
      })
      .state('preLoginBasket.investNowScheme', {
        url:'/invest-now-scheme?journey',
        templateUrl: 'app/investment-baskets/scheme-invest/scheme-invest.html',
        controller: 'InvestmentInvestNowController',
        controllerAs: 'InvestNowCtrl',
        authenticate: true,
        params: {
          fromPreLogin : true
        }
      })
      .state('preLoginBasket.goals', {
        url: '/goals?goalId',
        templateUrl : 'app/investment-baskets/goals/goals.html',
        controller: 'GoalsController',
        controllerAs: 'GoalsCtrl',
        authenticate: true,
        params: {
          fromPreLogin : true
        }
      })
      .state('preLoginBasket.folioCreation', {
        url: '/folio/:retirement?journey',
        templateUrl: 'app/investment-baskets/folio/folio.html',
        controller: 'FolioController',
        controllerAs: 'Folio',
        authenticate: true,
        title:'Folio',
        params: {
          fromPreLogin : true
        }
      })
      .state('preLoginBasket.payment', {
        url:'/payment?journeyId',
        templateUrl: 'app/investment-baskets/invest-now/payment/payment.html',
        controller: 'InvestNowPaymentController',
        controllerAs: 'InvestNowPayment',
        authenticate: false,
        resolve: {
          DynamicDataSipPurchaseReview : _fetchDynamicDataSip,
          notesPayment : _fetchDynamicDataPurchasePayment
        },
        params: {
          fromPreLogin : true
        }
      })
      .state('preLoginBasket.review', {
        url:'/review',
        templateUrl: 'app/investment-baskets/review/review.controller.html',
        controller: 'ReviewController',
        controllerAs: 'Review',
        authenticate: false,
        params: {
          fromPreLogin : true
        }
      })
      .state('preLoginBasket.purchaseTransactionSuccess', {
        url:'/transaction-success/purchase/:transactionId/:transactionType/:isFavourite?existingInvestor',
        templateUrl: 'app/investment-baskets/transaction-success/purchase.transaction.success.html',
        controller: 'PurchaseTransactionSuccessController',
        controllerAs: 'PurchaseSuccessCtrl',
        authenticate: true,
        resolve: {summaryData: _transactionSummary}
      })
      .state('preLoginBasket.sipTransactionSuccess', {
        url:'/transaction-success/sip?existingInvestor',
        templateUrl: 'app/investment-baskets/transaction-success/sip.transaction.success.html',
        controller: 'SipTransactionSuccessController',
        controllerAs: 'SipTranSuccessCtrl',
        authenticate: true,
      })
      .state('main.investment.personality', {
        url: '/personality?journey&goalId&viaBack',
        templateUrl: 'app/investment-baskets/personality/personality.html',
        controller: 'PersonalityController',
        controllerAs: 'Personality',
        authenticate: true
      })
      .state('main.investment.folio', {
        url: '/folio/:retirement?journey',
        templateUrl: 'app/investment-baskets/folio/folio.html',
        controller: 'FolioController',
        controllerAs: 'Folio',
        authenticate: true,
        title:'Folio',
        params: {
          existingInvestor : true
        }
      })
      .state('main.investment.review', {
        url:'/review',
        templateUrl: 'app/investment-baskets/review/review.controller.html',
        controller: 'ReviewController',
        controllerAs: 'Review',
        authenticate: true
      })
  }
  /** @ngInject */
  function _fetchDynamicDataSip(UtilService) {
    return UtilService.fetchDynamicData("SIP_REVIEW");
  }

  /** @ngInject */
  function _fetchDynamicDataPurchasePayment(UtilService) {
    return UtilService.fetchDynamicData('PURCHASE_PAYMENT');
  }

  /** @ngInject */
  function _transactionSummary($q, LoaderService, InvestorService, $stateParams, AppConstants, MessageService, UtilService) {

    var deferred = $q.defer();
    var TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    var transactionId = $stateParams.transactionId;
    var transactionType = $stateParams.transactionType;

    LoaderService.showLoader();
    var success = function (resp) {
      LoaderService.hideLoader();
      if (resp.status && resp.data) {
        deferred.resolve(resp.data);
      } else {
        MessageService.error(resp.message);
        deferred.reject(null);
      }
    }, error = function (err) {
      LoaderService.hideLoader();
      UtilService.errorHandler(err);
      deferred.reject(null);
    };
    var payload = {
      transactionId: transactionId,
      transactionType: transactionType
    }
    InvestorService.post({
      child1: 'transaction',
      child2: 'approved',
      child3: 'summary'
    }, payload).$promise.then(success, error);

    return deferred.promise;

  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('InvestmentModel', investmentModel);

  /** @ngInject */
  function investmentModel() {
    var goalPayload = [];
    var payload = {
      'SIP': {
        folioNumber: '',
        isThroughDistributor: false,
        isDirect: true,
        isThroughRia: false,
        isEuin:true,
        brokerCode: '',
        riaBrokerCode: '',
        riaBrokerName: '',
        brokerName: '',
        euin: '',
        euinOpted: 'N',
        optionalInvestmentType: '',
        investmentType:'SIP',
        dividendOption: '',
        frequency: '',
        day: '',
        month:'',
        endMonthYear:'',
        startDate: '',
        endDate: '',
        minEndDate:null,
        sipPaymentOption: '',
        bankAcNo: '',
        ifscCode: '',
        bankBranch: '',
        bankCity: '',
        bankName: '',
        bankInfo: '',
        otmId: '',
        purchaseInSchemeCode: '',
        purchaseInSchemeName: '',
        purchaseAmount: '',
        purchaseDividendOption: '',
        purchaseInvestmentOption: '',
        purchasePaymentOption: '',
        pTransactionId: '',
        sTransactionId: '',
        isTillPerpetuity: false,
        isBackFromSummary: false,
        sipDividendOption:'Y',
        dynamicData : { readOnly : false },
        topupDetails: {},
        sipTopupSelected : false,
        sipTopupEnabled:false,
        sipFirstInstallment:true,
        sipFirstAmount:''
      },
      'PURCHASE': {
        folioNumber: '',
        isThroughDistributor: false,
        isDirect: true,
        isThroughRia: false,
        isEuin:true,
        brokerCode: '',
        brokerName: '',
        riaBrokerCode: '',
        riaBrokerName: '',
        euin: '',
        euinOpted: 'N',
        optionalInvestmentType: '',
        investmentType:'PURCHASE',
        dividendOption: '',
        frequency: '',
        day: '',
        startDate: '',
        endDate: '',
        sipPaymentOption: '',
        bankAcNo: '',
        ifscCode: '',
        bankBranch: '',
        bankCity: '',
        bankName: '',
        bankInfo: '',
        otmId: '',
        purchaseInSchemeCode: '',
        purchaseInSchemeName: '',
        purchaseAmount: '',
        purchaseDividendOption: '',
        purchaseInvestmentOption: '',
        purchasePaymentOption: '',
        pTransactionId: '',
        sTransactionId: '',
        isTillPerpetuity: false,
        isBackFromSummary: false,
        retirementAgeProofURL: '',
        dynamicData : { readOnly : false },
        isCheckedTandC: false
      },
      'FOLIO_CREATION_STEP' : {
        basic_details_completed : false,
        income_details_completed : false,
        guardian_details_completed: false,
        holder_details_completed : false,
        nominee_details_completed : false,
        bank_details_completed : false
      }
    };
    var dataPayload = {
      soleApplicantDetail: {
        minorDetail: {
          minorAgeProof: null,
          minorRelationshipProof: null,
          guardian: {
            panNumber: null,
            occupation: null,
            taxStatusCode: null,
            grossAnnualIncome: null,
            politicalStatus: null,
            netWorth: null,
            netWorthDate: null,
            kycVerified: null,
            name: null,
            gender: null,
            panValid: null,
            relation: null,
            fatca: {
              birthCountry: null,
              birthPlace: null,
              countryCitizenship: null,
              payTaxInIndia: false,
              addressType: null,
              fatcaTax1: {
                taxPayingCountry: null,
                taxPayingCity: null,
                taxIdNumber: null,
                taxId: null,
                taxIdType: null
              },
              fatcaTax2: {
                taxPayingCountry: null,
                taxPayingCity: null,
                taxIdNumber: null,
                taxId: null,
                taxIdType: null
              },
              fatcaTax: {
                taxPayingCountry: null,
                taxPayingCity: null,
                taxIdNumber: null,
                taxId: null,
                taxIdType: null
              }
            },
            guardianRelationshipProofUrl: null
          }
        },
        selfDetail: {
          panNumber: '',
          occupation: null,
          taxStatusCode: null,
          grossAnnualIncome: null,
          politicalStatus: "NONE",
          netWorth: null,
          netWorthDate: null,
          kycVerified: null,
          address: {
            addressLine1: null,
            addressLine2: null,
            addressLine3: null,
            pinCode: null,
            city: null,
            state: null,
            country: null
          },
          fatca: {
            birthCountry: null,
            birthPlace: null,
            countryCitizenship: null,
            payTaxInIndia: true,
            addressType: null
          }
        },
        personalDetail: {
          dateOfBirth: null,
          firstName: null,
          gender: null,
          taxStatusCode: null
        }
      },

      nominees: [
        {
          title: null,
          nomineeName: null,
          nomineeRelation: null,
          percentage: null,
          dob: null,
          nomineeAddress: {
            addressLine1: null,
            addressLine2: null,
            addressLine3: null,
            pinCode: null,
            city: null,
            state: null,
            country: null
          },
          guardianAddress: {
            addressLine1: null,
            addressLine2: null,
            addressLine3: null,
            pinCode: null,
            city: null,
            state: null,
            country: null
          },
          minor: null,
          guardianName: null,
          soleAddressApplicable: null
        }],

      holdmode: "SINGLE",
      minor: false,
      folioSaveStep: "ONE",
      firstFolio: true,
      newUserFlow:true
    };
    function setPayload(_payload) {
      payload = angular.copy(_payload);
    }

    function getPayload() {
      return angular.copy(payload);
    }

    function getDataPayload() {
      return angular.copy(dataPayload);
    }

    function setGoalPayload(payload) {
      goalPayload = payload;
    }

    function getGoalPayload() {
      return angular.copy(goalPayload);
    }

    function resetPayload() {
      payload.FOLIO_CREATION_STEP.guardian_details_completed = false;
      payload.FOLIO_CREATION_STEP.income_details_completed = false;
      payload.FOLIO_CREATION_STEP.basic_details_completed = false;
      payload.FOLIO_CREATION_STEP.nominee_details_completed = false;
      payload.FOLIO_CREATION_STEP.bank_details_completed = false;
      payload.FOLIO_CREATION_STEP.holder_details_completed = false;
    }

    return {
      setPayload: setPayload,
      getPayload: getPayload,
      getDataPayload: getDataPayload,
      setGoalPayload: setGoalPayload,
      getGoalPayload: getGoalPayload,
      resetPayloadFolio : resetPayload
    }
  }
})();

/**
 * Created by ttn on 30/11/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InvestmentController', investmentController);

  /** @ngInject */
  function investmentController($state, $rootScope) {
    var vm = this;
    var listner = $rootScope.$on("updateTitle", function() {
      vm.screenTitle = $state.current.title;
    });
  }
})();

/**
 * Created by sonakshi on 17/4/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('SipPurchaseInstantHelper', sipPurchaseInstantHelper);


  /** @ngInject */
  function sipPurchaseInstantHelper() {
    var vm = null;

    function setViewModel(model) {
      vm = model;
    }

    function isFormValid() {
      var isValid = false;
      var form = vm.formData;

      if(form.investmentType === 'PURCHASE'){
        if(form.purchaseInSchemeName && form.purchaseAmount){

          if(vm.purchaseMaxAmount){
            if(form.purchaseAmount <= vm.purchaseMaxAmount && form.purchaseAmount >= vm.purchaseMinAmount){
              isValid = true;
            }
          }else {
            if(form.purchaseAmount >= vm.purchaseMinAmount){
              isValid = true;
            }
          }

        }
      }

     else if(form.investmentType === 'SIP'){
        if(form.inSchemeName && form.amount && form.startDate && form.endDate) {
          if(form.sipPaymentOption == 'EC') {
            if (form.amount >= vm.validations.minAmount) {
              if(form.bankInfo && form.bankInfo.bankName != 'HDFC BANK') {
                  isValid = true;
              }
              if(form.bankInfo && form.bankInfo.bankName == 'HDFC BANK') {
                if(form.bankAcNo && form.verifyBankAcNo){
                  isValid = true;
                }
              }
            }
          } else if (form.sipPaymentOption == 'OTM') {
              if (form.bankInfo && form.bankInfo.bankName && form.bankInfo.bankAcNo && (form.ifscCode || form.bankInfo.ifscCode) && (form.amount >= vm.validations.minAmount)) {
                isValid = true;
              }
            }
          else if(form.sipPaymentOption == 'UPI') {
            if (form.amount >= vm.validations.minAmount) {
              if(form.bankInfo && form.bankInfo.bankName != 'HDFC BANK') {
                isValid = true;
              }
              if(form.bankInfo && form.bankInfo.bankName == 'HDFC BANK') {
                if(form.bankAcNo && form.verifyBankAcNo){
                  isValid = true;
                }
              }
            }
          }
          if(vm.isInvalidForm){
            isValid = false;
          }
        }
      }

      return isValid;


    }

    function calculateSipStartDate() {
      vm.formData.startDate = vm.enabledStartDates[vm.formData.month];
      vm.updateEndDates(true);

    }

    return {

      setViewModel: setViewModel,
      isFormValid:isFormValid,
      calculateSipStartDate:calculateSipStartDate
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InstantInvestmentSummaryController', instantInvestmentSummaryController);

  /** @ngInject */
  function instantInvestmentSummaryController(ModalService, AppConstants, IIHttpService, AuthService, $window, $state, $rootScope, $scope, $stateParams, TransactionModel, LoaderService, TransactionService, MessageService, UtilService, HDFC_API) {
    var vm = this;
    vm.formData = TransactionModel.getPayloadRawData();
    vm.transactionType = $stateParams.trxnType;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.investorInfo = {};
    vm.isCheckedTandC = false;
    var Card = $window.Card || {};
    var identifierData = AuthService.getInstaToken();
    vm.investorName = identifierData.name;
    vm.investorInfo.name = identifierData ? identifierData.investorName : '';
    var _isPaymentDone = false;

/*
    function getInvestorInfo() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
        } else {
          vm.investorInfo = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        vm.investorInfo = null;
      };
      InvestorService.get({
        child1: 'folio',
        child3: 'info'
      }).$promise.then(success, error);
    }
*/

    function showSuccessModal(tid) {


      if (!vm.investorInfo) {
        vm.investorInfo = {};
        MessageService.error('Error while get investor info.');
      }
      var successModal = function(isChecked) {
          TransactionModel.setPayloadRawData(null);
          if (isChecked) {
            favrouiteApi(tid);
          }
          $state.reload();
        },
        errorModal = function() {
          TransactionModel.setPayloadRawData(null);
          $state.reload();
        };

      ModalService.initiateSuccessModal({
        transactionType: vm.transactionType,
        investorName: vm.investorInfo.name
      }, successModal, errorModal);
    }

    function favrouiteApi(tid) {
      var success = function(resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            //MessageService.success(resp.message);
          } else {
            //MessageService.error(resp.message);
          }
        },
        error = function() {
          //   LoaderService.hideLoader();
          // UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      TransactionService.get({
        controller1: 'makeFavouriteTransaction',
        controller2: tid
      }).$promise.then(success, error);
    }


    function getFinalPayload() {
      var payload = null;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          payload = getSipPayload();
          break;
      }
      return payload;
    }

    function getSipPayload() {
      var sipPayload = {
        installmentAmount: vm.formData.amount,
        investmentOption: vm.formData.investmentOption,
        dividendOption: vm.formData.dividendOption,
        formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
        brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN?vm.formData.distributorARN:''),
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        frequency: vm.formData.frequency,
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.inSchemeCode,
        primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
        toDate: vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
        sipDate: vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
        sipDay: vm.formData.day,
        id: vm.formData.sTransactionId,
        bankDetailsForECS: {
          accType: vm.formData.bankInfo ? vm.formData.bankInfo.bankAcType : vm.formData.bankAcType,
          accNumber: vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : vm.formData.bankAcNo,
          ifscCode: vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : vm.formData.ifscCode,
          bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
          branchName: vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : vm.formData.bankBranch,
          bankCity: vm.formData.bankInfo ? vm.formData.bankInfo.bankCity : vm.formData.bankCity,
          paymentOption: vm.formData.sipPaymentOption,
          payoutId: vm.formData.bankInfo ? vm.formData.bankInfo.payoutId : vm.formData.payoutId
        },
        subBrokerARN: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN:'',
        subBrokerCode: vm.formData.subBrokerCode
      };

      var payload = {};
      if (!vm.formData.optionalInvestmentType && vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        // payload.sipForm = angular.copy(sipPayload);
        payload = angular.copy(sipPayload);
      } else {
        payload = null;
      }

      return payload;
    }


    function handleSipResponse(data) {
      if (!data) {
        MessageService.error();
        return;
      }

      /*if (data.eMandateEnabled && data.paymentOption == 'EC') {
        openPaynimo(data.trxnNo, data.srnNo);
      }
      else if (!data.eMandateEnabled && (data.paymentOption == 'STANDING' || data.paymentOption == 'EC')) {
        ModalService.manualInstructionsModal({name: vm.investorName, trxnNo: data.trxnNo});
      }
      else {
        MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_APPROVED);
      }*/

      /*if (data.eMandateEnabled && data.paymentOption == 'EC') {
        openPaynimo(data.trxnNo, data.srnNo, data.pNMFreq);
      }
      else {

      }*/

      ModalService.manualInstructionsModal({
        investorName: vm.investorInfo.name,
        folioInvestorName: vm.investorInfo.name,
        srnNo: data.srnNo,
        netBankingUrl:vm.formData.netBankingUrl,
        folioNumber: vm.formData.folioNumber,
        schemeName: vm.formData.inSchemeName,//
        investmentOption: vm.formData.investmentOption,
        amount: vm.formData.amount,
        sipDividendOption: vm.formData.dividendOption,
        paymentOption:data.paymentOption,
        transactionId:data.trxnNo,
        transactionInitiateDate:data.transactionInitiateDate,
        frequency:vm.formData.frequency,
        startDate:vm.formData.startDate ? vm.formData.startDate.format('DD-MMM-YYYY'):null,
        endDate:vm.formData.endDate ? vm.formData.endDate.format('DD-MMM-YYYY'):null,
        bankName:vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
        bankAcNo:vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : vm.formData.bankAcNo,
        type: 'instantLogin'
      });
    }

    function handleResponse() {
      // console.info("response======== ", res);
    }

    function approveTransaction() {
      var payload = getFinalPayload();

      if (!payload) {
        MessageService.error('Something went wrong while calculating payload.');
        return;
      }

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            _isPaymentDone = true;
            userActivityTracking(function(){
              if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
                handleSipResponse(resp.data);
              } else {
                showSuccessModal(resp.data.data);
              }
            });
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

      // var _controller2 = (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) ? vm.transactionType.toLowerCase() : 'multiple';
      TransactionServiceVersion.post({
        controller1: 'transaction',
        controller2: vm.transactionType.toLowerCase(),
        controller3: 'approve'
      }, payload).$promise.then(success, error);
    }


    function userActivityTracking(cb){
      cb = cb || function(){};
      var success = function(trackResp){
        trackResp = trackResp.data || trackResp;
        LoaderService.hideLoader();
        cb(trackResp);
      }, error = function(err){
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(err);
      };
      LoaderService.showLoader();
      var userTrackerPayload = setUserTrackerPayload();
      IIHttpService.post({
        child1: 'userBehavior',
        child2: 'addupdateQI'
      },userTrackerPayload).$promise.then(success, error);
    }

    function setUserTrackerPayload(){
      var _payload = {
        "trxnRefNo": $stateParams.trackId?$stateParams.trackId:"", //required in case of update
        "trxnType": vm.formData.investmentType, //SIP, PURCHASE
        "loginType": AppConstants.LOGIN_TYPE.QUICK, //QI_WEB, IP_WEB, DP_WEB
        "step": "SECOND", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode, // required
        "folioNo": vm.formData.folioNumber, // required
        "formData": vm.formData, // required
        "amount": vm.formData.purchaseAmount, //required
        "trxnStatus": _isPaymentDone ? "PROCESSED" : "OPEN"  // OPEN,PROCESSED
      };
      return _payload;
    }

    vm.init = function () {
      if(angular.isDefined($stateParams.trackId) && angular.isDefined($stateParams.stepNo) && $stateParams.stepNo.toUpperCase() === "SECOND"){
        showPrefillValuesUserTracker(function () {
          if (!vm.formData) {
            $state.go('instantLoginHome.instantInvest');
            return null;
          }
        });
      }else{
        if (!vm.formData) {
          $state.go('instantLoginHome.instantInvest');
          return null;
        }
      }
    };


    function showPrefillValuesUserTracker(cb) {
      cb = cb || function(){};
      vm.transactionType = $stateParams.trxnType?$stateParams.trxnType.toUpperCase():vm.transactionType;

      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData = resp.data.formdata || {};
            vm.investmentType = vm.formData.investmentType;
            ($stateParams.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)&&(vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE);
          } else {
            MessageService.error(resp.message);
          }
          cb();
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb();
        };
      IIHttpService.get({
        child1: 'userBehavior',
        child2: $stateParams.trackId,
        child3: 'getFormDataQI'
      }).$promise.then(success, error);
    }


    vm.submitForm = function () {

      userActivityTracking(function(statusFlag){
        var params = {};
        TransactionModel.setPayloadRawData(angular.copy(vm.formData));
        if((statusFlag && statusFlag.transactionId)||($stateParams.trackId)){
          params.trackId = statusFlag.transactionId || $stateParams.trackId;
        }

        if (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
          $state.go('instantLoginHome.payment',params);
        } else {
          approveTransaction();
        }
      })
    };

    vm.goToBack = function () {
      var params = {};
      ($stateParams.trackId)&&(params.trackId=$stateParams.trackId);
      ($stateParams.trxnType)&&(params.trxnType=$stateParams.trxnType);
      $state.go("instantLoginHome.instantInvest", params);

      /*if (!$state.$previous) {
        return;
      }
      $state.go($state.$previous.name, $state.$previous.param);*/
    };

    vm.showTermConditions = function () {
      ModalService.termConditionModal();
    };

    var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState) {
      if (toState.name && $state.$previous && (toState.name !== $state.$previous.name)) {
        if (toState.name === 'instantLoginHome.payment' && (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)) {
          return;
        }
        TransactionModel.setPayloadRawData(null);
      }
    });

    $scope.$on('$destroy', function () {
      stateChangeStart();
    });

  }
})();

/**
 * Created by sandeepchhapola on 19/11/16.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InstantInvestController', instantInvestController);

  /** @ngInject */
  function instantInvestController($timeout, $stateParams, $rootScope, UtilService, AuthService, $window,
                                   SipPurchaseInstantHelper, LoaderService, $state, ModalService, TransactionModel, AppConstants,
                                   IIHttpService, MessageService, TransactionService, NetcoreEvntService,HDFC_API,dynamicData, $scope, InvestorService , $cookies, $filter, $log, SchemeService,$compile,DownloadPdfService,FileSaver,investorServiceVersion) { /*, investorProfile*/
    var vm = this;
    vm.emandateDetail = null;
    vm.showNPCIDateError = '';
    vm.isLoading = false;
    vm.billdeskUrl = HDFC_API.BILLDESK_URL;
    vm.showTransactionSuccessfulPage = false;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    vm.HDFC_WITH_DIRECT_ARN = angular.copy(AppConstants.HDFC_WITH_DIRECT_ARN);
    vm.TRANSACTIONS_CONST.DESCRIPTIONS['UPI'] = "UPI Autopay";
    vm.transactionType = $stateParams.trxnType? $stateParams.trxnType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE;
    vm.formData = TransactionModel.getPayloadRawData() || TransactionModel.getMasterRawData(vm.transactionType);
    vm.transactionType = vm.formData ? vm.formData.investmentType : vm.transactionType;
    /* vm.transactionType = vm.formData.investmentType ? vm.formData.investmentType : vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE;*/
    vm.devidendOptions = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT];
    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
    vm.devidendOptionsOther = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT];
    vm.devidendOptionsELSS = [vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT, vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST];
   // vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    // vm.helper = getHelper();
    vm.folioList = null;
    vm.masterNonBusinessDate = null;
    vm.EmandateBankData = null;
    vm.calledEmandate = false;
    vm.unitsDetails = null;
    vm.inSchemeValidations = null;
    vm.outSchemeValidations = null;
    vm.validations = {};
    vm.investorInfo = null;
    vm.isRequired = false;
    vm.bankList = null;
    vm.outSchemeList = null;
    vm.inSchemeList = null;
    vm.masterInSchemeList = null;
    vm.purchaseInSchemeList = null;
    vm.scheduledPurchaseSchemeList = null;
    vm.masterPurchaseInSchemeList = null;
    vm.tForm = {};
    vm.isSaving = false;
    vm.isReseting = false;
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.daysList = vm.TRANSACTIONS_CONST.SIP_DAYS_LIST;
    vm.isSchemeDisabled = false;
    vm.isShowDefault = 'false';
    vm.purchaseMinAmount = 0;
    vm.isPurchaseMin = false;
    vm.isPurchaseMax = false;
    vm.viewMode = 'days';
    vm.euinList = null;
    vm.isInvalidForm = false;
    vm.isCheckedTandC = false;
    vm.isOTMEnabled = false;
    vm.isEMandateEnabled = false;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.checkAmountValidation = checkAmountValidation;
    vm.changeFrequency =changeFrequency;
    vm.daysList = getDaysList();
    vm.emandateDisplay = true;
    var removeListeners = {};
    vm.euinDesable = false;
    //vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
    vm.checkSipValidations = checkSipValidations;
    vm.updateEndDates = updateEndDates;
    vm.amountInWords = '';
    // vm.startMinDateBiller = moment().add(30, 'days');
    // vm.startMaxDate = moment().add(120, 'days');
    vm.isArnSuccess = true;
    vm.isSubarnSuccess = false;
    vm.brokerCodeError = '';
    vm.subBrokerCodeError = '';
    vm.eMandatenoOfDays=null;
    //vm.formData.distributorARN = '';
    vm.sipFirstInstallment=false;
    vm.sipFirstInstallmentAmount=[];
    vm.scheduleFrequencyList = angular.copy(AppConstants.TRANSACTIONS.SCHEDULE_TRANSACTION_FREQUENCY);
    vm.changeFirstInstallment = changeFirstInstallment;
    //vm.checkSipFirstValidations = checkSipFirstValidations;
    vm.showPurchaseSchedulerSuccess = false;
    var identifierData = AuthService.getInstaToken();
    vm.formData.folioNumber = identifierData?identifierData.folioNumber:'';
    vm.formData.minorFlag = identifierData?identifierData.minor:null;
    vm.helper = SipPurchaseInstantHelper;
    vm.helper.setViewModel(vm);
    // vm.token = $cookies.get('token_data_instant') ? JSON.parse($cookies.get('token_data_instant')) : null;
    vm.token = AuthService.getInstaToken();
    vm.isSchemeTypeELSS = false;
    var enabledOTMStartDatesList = [];
    vm.riaCodeError = "";
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.dynamicData = dynamicData;
    vm.showpopup = true;
    vm.today = $window.moment($window.moment(),"DD-MMM-YYYY HH:mm A");
    vm.euinData = {};
    vm.backFromPayment=false;
    vm.isOtmOtpVerified = false;
    vm.isOtmVisible = false;
    vm.resendOtpCounter = AppConstants.RESEND_OTP_COUNTER;
    vm.otmOtp = null;
    vm.PATTERN = AppConstants;
    vm.resendOtp = resendOtp;
    vm.generateOtp = generateOtp;
    vm.submitOtmOtp = submitOtmOtp;
    vm.getPurchaseSchedulePayload = getPurchaseSchedulePayload;
    vm.selectedUpiBank = selectedUpiBank;
    vm.resetUPIForm = resetUPIForm;
    vm.verifyUPI = verifyUPI;
    vm.hideUPIDetails = hideUPIDetails;
    vm.showInvestThrough = true;
    vm.arnHardcodedData = $window.JSON.parse(localStorage.getItem("distributorDetails"));
    vm.isModify = sessionStorage.getItem("isModify");
    vm.PARTNER_DATA =  JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
    vm.Scheduled_Purchase = false;
    vm.HDFCCAMPFUND = ['HDFCEQ','HDFCLARGEF','HDFCT2'];
    if(vm.arnHardcodedData && vm.arnHardcodedData.SCHEMEWISECAMP){
      if(vm.arnHardcodedData.transactionType == 'SIP'){
          vm.purchaseDisabled = true;
          vm.switchDisabled = true;
      }
      if(vm.arnHardcodedData.transactionType == 'PURCHASE'){
        vm.sipDisabled = true;
        vm.switchDisabled = true;
      }
    }
    vm.emandateMinAmountLimit = null;
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.isLessThanSipAmount = false;
    vm.sipDateLessEmandate = false;
    vm.changeEndDateEmandate = changeEndDateEmandate;
    vm.emandateWord = {};
    vm.handleMandateCalender = handleMandateCalender;
    vm.checkRedeemValidations = checkRedeemValidations;
    // vm.changedBank = changedBank;
    vm.showRedeemPreview = false;
    vm.showRedeemSuccess = false;
    vm.callApprove = callApprove;
    vm.handleVpa = handleVpa;
    vm.defaultMandateYearDate = AppConstants.DEFAULT_EMANDATE_MAX_YEAR;
    vm.restrictRedemptionSwitch = false;

    if(vm.arnHardcodedData){
      if(vm.arnHardcodedData.transactionType == "Purchase_Scheduler"){
        vm.Scheduled_Purchase = true;
      }else{
        vm.Scheduled_Purchase = false;
      }
      if(vm.arnHardcodedData.isHdfcBank){
        vm.restrictOTMEmandate = true;
        vm.restrictRepeatCall = false;
      }else{
        vm.restrictOTMEmandate = false;
      }
      if(vm.arnHardcodedData.CAMP && vm.arnHardcodedData.transactionType == "SIP"){
        vm.SIPCAMP = true;
      }
      if(vm.arnHardcodedData.CAMP && vm.arnHardcodedData.transactionType == "PURCHASE"){
        vm.PURCHASECAMP = true;
      }
      if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "SIP" && vm.arnHardcodedData.HDFCCAMP){
        vm.HDFCCAMP = true;
      }
    }else{
      vm.restrictOTMEmandate = false;
    }
    vm.showIFSCField = false;
    vm.showAccountTypeField = false;
    vm.token = AuthService.getInstaToken();
    vm.upiErrorMessage = '';
    vm.upiLimit = '';
    if(vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank){
      if(vm.dynamicData && vm.dynamicData.termAndConditionDTO && vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap && vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_Quick_Investment_HDFCBankOneClick){
        vm.hdfcOneClickDisclaimerNote = vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_Quick_Investment_HDFCBankOneClick.content;
      }
    }
    if (vm.arnHardcodedData) {
      var localidentifierData = $window.JSON.parse(localStorage.getItem("identifierData"));
      if (!localidentifierData) {
        localStorage.setItem('identifierData', $window.JSON.stringify(identifierData));
      } else {
        AuthService.setInstaToken(localidentifierData);
        identifierData = localidentifierData;
        vm.token = identifierData;
        vm.formData.folioNumber = identifierData ? identifierData.folioNumber : '';
        vm.formData.minorFlag = identifierData ? identifierData.minor : null;
      }

      vm.localData = {
        key: vm.arnHardcodedData.key,
      }
      if (vm.arnHardcodedData.key == 'MFD') {
        vm.localData.ARN = vm.arnHardcodedData.arn;
        if(vm.arnHardcodedData.euin){
          vm.localData.Euin = vm.arnHardcodedData.euin;
          vm.euinDesable = true;
        }else{
          vm.formData.isEuin = false;
          vm.euinDesable = false;
        }
        vm.localData.subBrokerARN = vm.arnHardcodedData.subBrokerARN;
        vm.localData.subBrokerCode = vm.arnHardcodedData.subBrokerCode;
      }
      if (vm.arnHardcodedData.key == 'E_CODE') {
        vm.localData.empCode = vm.arnHardcodedData.empCode;
        vm.localData.ARN = vm.arnHardcodedData.arn;
        if(vm.arnHardcodedData.euin){
          vm.localData.Euin = vm.arnHardcodedData.euin;
          vm.euinDesable = true;
        }else{
          vm.formData.isEuin = false;
          vm.euinDesable = false;
        }
        vm.localData.subBrokerARN = vm.arnHardcodedData.subBrokerARN;
        vm.localData.subBrokerCode = vm.arnHardcodedData.subBrokerCode;
      }
      if (vm.arnHardcodedData.key == 'RIA') {
        vm.localData.riaCode = vm.arnHardcodedData.riaCode;
      }
      if (vm.arnHardcodedData.key == 'CONNECT_PARTNER') {
        vm.localData.ARN = vm.arnHardcodedData.arn;
        if(vm.arnHardcodedData.euin){
          vm.localData.Euin = vm.arnHardcodedData.euin;
          vm.euinDesable = true;
        }else{
          vm.formData.isEuin = false;
          vm.euinDesable = false;
        }
      }

    }
    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };

    if (vm.dynamicData.popupDTO.popupDTOMap.Popup_Quick_Investment) {
       vm.cutoffData = vm.dynamicData.popupDTO.popupDTOMap.Popup_Quick_Investment;
    }

     if (vm.dynamicData.noteDTO.noteDTOMap.Note_Quick_Investment_SIP) {
       vm.notesInstantInvestement = vm.dynamicData.noteDTO.noteDTOMap.Note_Quick_Investment_SIP;
     }
     if (vm.dynamicData.noteDTO.noteDTOMap.Note_Quick_Investment_SIP_One_Click) {
       vm.Note_Quick_Investment_SIP_One_Click = vm.dynamicData.noteDTO.noteDTOMap.Note_Quick_Investment_SIP_One_Click;
      }
     if (vm.dynamicData.noteDTO.noteDTOMap.Note_Summary_Quick_Investment) {
      vm.noteSummaryQuickInvestment = vm.dynamicData.noteDTO.noteDTOMap.Note_Summary_Quick_Investment;
    }
     if (vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_Quick_Investment_Through_Distributor) {
        vm.euinDeclaration = vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_Quick_Investment_Through_Distributor.content;
     }

      if (vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_Quick_Investment_Through_RIA) {
        vm.riaDeclaration = vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_Quick_Investment_Through_RIA.content;
      }

    if (vm.dynamicData.noteDTO.noteDTOMap.Note_Quick_Investment_SIP) {
      vm.notesInstantInvestementEmandate = vm.dynamicData.noteDTO.noteDTOMap.Note_Quick_Investment_Emandate;
    }

    // Switch Variabels
      vm.masterOutSchemeList = null;
      vm.setDynamicData = setDynamicData;
      vm.validationsApi = {};
      vm.unitsDetails = null;
      vm.inSchemeValidations = null;
      vm.outSchemeValidations = null;
      vm.checkSwitchValidations = checkSwitchValidations;
      vm.amountValidation = false;
      vm.showSwitchPreview = false;
      vm.showSwitchSuccess = false;
      vm.switchReviewData = {};
      vm.showTerms = true;
      vm.isCheckedTandC = false;
      vm.fetchAutoSwitch = fetchAutoSwitch;
      vm.amountType = vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT;
      vm.transactionId = null;
      vm.switchArnData = false;
    // Switch Variabels

    vm.init = function () {
      // checkIsTxnBlock();
      var folioData = localStorage.getItem('selectedFolioDataInQI');
      if (folioData) {
        vm.selectedFolioData = $window.JSON.parse(folioData);
      }

      if (!vm.arnHardcodedData) {
      if(vm.formData.minorFlag && !$stateParams.trxnType){
        // if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)
        //   ModalService.minorPurchaseModal({});
        // else
        //   ModalService.minorSipModal({});
      }
      setListeners();
      if (vm.formData.isBackFromSummary) {
        vm.isArnSuccess = false;
        vm.showArnLabel = vm.formData.brokerCode ? true : false;
        prefill();
      } else if(angular.isDefined($stateParams.trxnType) && $stateParams.trackId && !vm.formData.isBackFromSummary){
        showPrefillValuesUserTracker();
      } else {
        vm.formData.isSummaryViewEnabled=false;
        if($window.sessionStorage.hasOwnProperty("SummaryReviewEnabled")){
          if($window.sessionStorage.getItem("SummaryReviewEnabled") === "false") {
            fetchPreviousTrSelectedDistrubutor(function () {
              if (!vm.formData.investmentType) {
                vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE;
                vm.changeInvestmentType();
              }
              if (vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
                fetchPurchaseInSchemes();
                if (vm.formData.purchaseInSchemeCode) {
                  fetchPurchaseValidations();
                }
              } else {
                fetchInSchemes();
                if (vm.formData.inSchemeCode) {
                  checkEMandate();
                  checkOTM();
                  fetchInSchemeValidations();
                  fetchBankList();
                }
              }
            });
            $window.sessionStorage.removeItem("SummaryReviewEnabled");
          } else {
            if (vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
              if (vm.formData.purchaseInSchemeCode) {
                if($window.sessionStorage.getItem("SummaryReviewEnabled")){
                  vm.backFromPayment=true;
                }
                fetchPurchaseValidations();
              }
            } else {
              fetchInSchemes();
              if (vm.formData.inSchemeCode) {
                checkOTM();
                fetchInSchemeValidations();
                fetchBankList();
              }
            }
          }
        }
         else {
          if (!vm.formData.inSchemeCode) {
            fetchPreviousTrSelectedDistrubutor(function () {
              if (!vm.formData.investmentType) {
                vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE;
                vm.changeInvestmentType();
              }
              if (vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
                fetchPurchaseInSchemes();
                if (vm.formData.purchaseInSchemeCode) {
                  fetchPurchaseValidations();
                }
              } else {
                fetchInSchemes();
                if (vm.formData.inSchemeCode) {
                  checkOTM();
                  fetchInSchemeValidations();
                  fetchBankList();
                }
              }
            });
          } else {
            fetchInSchemes();
            if (vm.formData.inSchemeCode) {
              checkOTM();
              if($window.sessionStorage.getItem("SummaryReviewEnabled"))
                vm.backFromPayment=true;
              fetchInSchemeValidations();
              fetchBankList();
            }
          }
        }
        }
       if ($stateParams.trxnType && !$stateParams.trackId) {
        vm.changeInvestmentType($stateParams.trxnType);
        }
       vm.formData.sipPaymentOption = (!vm.formData.sipPaymentOption) ? vm.paymentOptions[0] : vm.formData.sipPaymentOption;

      if ((vm.formData.sipPaymentOption=='UPI' || vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) && !vm.emandateObj) {
        UtilService.fetchMandateValidations().then(function (resp) {
          vm.emandateUpiData = resp;
          if (vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            vm.emandateObj = vm.emandateUpiData.eOTM;
          } else if (vm.formData.sipPaymentOption=='UPI') {
            vm.emandateObj = vm.emandateUpiData.upi;
          }
          vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
        }).catch(function(resp) {
          MessageService.error(resp)
        });
      }

       if($window.sessionStorage.getItem("SummaryReviewEnabled")) {
        if(vm.formData.purchaseInSchemeName && vm.formData.purchaseAmount) {
          vm.moveToSummary();
          $window.sessionStorage.setItem("SummaryReviewEnabled", false);
        } else if (vm.formData.inSchemeName && vm.formData.amount) {
          vm.validations.investmentOption = vm.formData.investmentOption;
          vm.backFromPayment=true;
          vm.moveToSummary();
          $window.sessionStorage.setItem("SummaryReviewEnabled", false);
        }
        }
      }else {
        if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler"){
            vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction;
            vm.transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction;
            vm.Scheduled_Purchase = true;
            vm.TRANSACTIONS_CONST.DESCRIPTIONS['UPI'] = "UPI";
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI];
            vm.formData.purchaseDividendOption = (vm.arnHardcodedData.dividendOption == 'N' || vm.arnHardcodedData.dividendOption == 'Y')? vm.arnHardcodedData.dividendOption: null;
          }
        if(vm.arnHardcodedData.transactionType == "SIP"){
          vm.changeInvestmentType("SIP");
        }else if(vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction){
          vm.changeInvestmentType(vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction);
        }else{
          vm.changeInvestmentType("PURCHASE");
        }
        if(vm.arnHardcodedData.transactionType == "Switch"){
          vm.switchArnData = true;
          vm.formData.investmentType = 'SWITCH';
          vm.transactionType = 'SWITCH';
          vm.changeInvestmentType("SWITCH");
        }
        if(vm.arnHardcodedData.transactionType == "Redemption"){
          vm.formData.investmentType = 'REDEMPTION';
          vm.transactionType = 'Redemption';
          vm.changeInvestmentType("REDEMPTION");
        }
        if(vm.arnHardcodedData.isHdfcBank){
          if(angular.isDefined($stateParams.trxnType) && $stateParams.trackId && !vm.formData.isBackFromSummary){
            showPrefillValuesUserTracker();
          }
        }
        if ((vm.formData.sipPaymentOption=='UPI' || vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) && !vm.emandateObj) {
          UtilService.fetchMandateValidations().then(function (resp) {
            vm.emandateUpiData = resp;
            if (vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
              vm.emandateObj = vm.emandateUpiData.eOTM;
            } else if (vm.formData.sipPaymentOption=='UPI') {
              vm.emandateObj = vm.emandateUpiData.upi;
            }
            vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
          }).catch(function(resp) {
            MessageService.error(resp)
          });
        }
      }

      if(vm.PARTNER_DATA){
        if(vm.PARTNER_DATA.arnCode){
        vm.formData.isThroughDistributor = true;
        vm.changeThroughDistributor('ARN');
        vm.formData.brokerCode = vm.PARTNER_DATA.arnCode;
        vm.searchDistributor();
        }else{
          vm.formData.isThroughDistributor = true;
          vm.changeThroughDistributor('ARN');
          vm.formData.brokerCode = '';
        }
        if(vm.PARTNER_DATA.arnFlag){
          vm.showInvestThrough = false;
          vm.changeThroughDistributor('ARN');
        }else{
          vm.showInvestThrough = true;
          vm.changeThroughDistributor('DIRECT');
        }
      }

    };

    vm.arnHardcodData = function () {

      if (vm.localData.key !== null) {
        if (vm.localData.key == 'MFD') {
          if(vm.formData.investmentType == 'Schedule_Transaction' && vm.HDFC_WITH_DIRECT_ARN ){
            vm.changeThroughDistributor('DIRECT');
          }else{
            vm.formData.isThroughDistributor = true;
            vm.changeThroughDistributor('ARN');
            vm.formData.brokerCode = vm.localData.ARN;
            vm.searchDistributor();
            if (vm.localData.subBrokerARN) {
              vm.formData.subBrokerARN = vm.localData.subBrokerARN;
              vm.fetchEuinListSubBroker()
              vm.formData.subBrokerCode = vm.localData.subBrokerCode
           }
          }
        }
        if (vm.localData.key == 'RIA') {
          //vm.formData.isThroughDistributor
          vm.changeThroughDistributor('RIA');
          vm.formData.brokerCode = vm.localData.riaCode;
          vm.searchDistributor();
        }
        if (vm.localData.key == 'CONNECT_PARTNER') {
          vm.formData.isThroughDistributor = true;
          vm.changeThroughDistributor('ARN');
          vm.formData.brokerCode = vm.localData.ARN;
          vm.searchDistributor();
        }
        if (vm.localData.key == 'E_CODE') {
          if (vm.localData.ARN) {
          vm.formData.isThroughDistributor = true;
          vm.changeThroughDistributor('ARN');
          vm.formData.brokerCode = vm.localData.ARN;
          vm.searchDistributor();
          if (vm.localData.subBrokerARN) {
            vm.formData.subBrokerARN = vm.localData.subBrokerARN;
            vm.fetchEuinListSubBroker()
            vm.formData.subBrokerCode = vm.localData.subBrokerCode
          }
        }else{
          if (vm.localData.empCode) {
            vm.changeThroughDistributor('DIRECT')
            //fetchInSchemes();
          }
        }

        }
      }
      vm.formData.sipPaymentOption = (!vm.formData.sipPaymentOption) ? vm.paymentOptions[0] : vm.formData.sipPaymentOption;
      if ($window.sessionStorage.getItem("SummaryReviewEnabled")) {
        vm.formData.isSummaryViewEnabled = false;
      }
      if(vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE){
        fetchPurchaseInSchemes();
      }else if(vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction){
        fetchPurchaseInSchemes();
      }else if(vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION){
        fetchOutSchemes();
      }else{
        fetchInSchemes();
      }

      if(vm.localData.Euin){
        fetchEuinList();
      }
    }
    function showPrefillValuesUserTracker() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData = resp.data && resp.data.formdata ? resp.data.formdata: {};
            // showPrefillValues(formData);
            vm.formData.investmentType = vm.formData.investmentType || vm.formData.formType;
            if(vm.arnHardcodedData){
              if(vm.arnHardcodedData.isHdfcBank){
                if(vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE){
                  if(angular.isDefined($stateParams.trxnType) && $stateParams.trackId && !vm.formData.isBackFromSummary && angular.isDefined($stateParams.stepNo) && $stateParams.stepNo.toUpperCase() === "SECOND"){
                    if(vm.formData.isSummaryViewEnabled){
                      vm.summaryData = vm.formData;
                    }
                  }
                }else{
                  vm.formData.isSummaryViewEnabled = false;
                  prefill();
                }
              }
            }
            prefill();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      TransactionService.get({
        controller1: 'userBehavior',
        controller2: $stateParams.trackId,
        controller3: 'getFormDataQI'
      }).$promise.then(success, error);
    }

    function userActivityTracking(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && (resp.data || resp)) {
          resp = resp.data || resp;
          LoaderService.hideLoader();
          if (resp.transactionId) {
            vm.formData.trackId = resp.transactionId;
          }

          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            if(vm.arnHardcodedData){
              if(vm.arnHardcodedData.isHdfcBank){
                if(resp.trxnUniqueLink){
                  vm.formData.trxnUniqueLink = resp.trxnUniqueLink;
                }
                vm.netcoreDataObj = NetcoreEvntService.SIP_Transaction(vm.formData, true)
                $window.smartech('dispatch','SIP Transaction',vm.netcoreDataObj)
              }else{
            NetcoreEvntService.Review_SIP_QI(vm.formData, true);
              }
            }else{
              NetcoreEvntService.Review_SIP_QI(vm.formData, true);
            }
          } else {
            if(vm.arnHardcodedData){
              if(vm.arnHardcodedData.isHdfcBank){
                if(resp.trxnUniqueLink){
                  vm.formData.trxnUniqueLink = resp.trxnUniqueLink;
                }
                vm.netcoreDataObj = NetcoreEvntService.Lumpsum_Transaction(vm.formData, true);
                $window.smartech('dispatch','Lumpsum Transaction',vm.netcoreDataObj)
              }else{
                NetcoreEvntService.Review_Purchase_QI(vm.formData, true);
              }
            }else{
            NetcoreEvntService.Review_Purchase_QI(vm.formData, true);
          }
          }
          cb(resp);
        }
        else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(err);
      };

      var userTrackerPayload = setUserTrackerPayload();
      IIHttpService.post({
        child1: 'userBehavior',
        child2: 'addupdateQI'
      }, userTrackerPayload).$promise.then(success, error);
    }

    vm.checkForMinorBankListCondition = function(){
      return vm.formData.minorFlag && !vm.formData.cgfFlag
    };

    function setUserTrackerPayload() {
      var _formData = getSipPurchasePayloadToSubmit();
      var _payload = {
        "trxnRefNo": $stateParams.trackId?$stateParams.trackId:"", //required in case of update
        "trxnType": vm.formData.investmentType, //SIP, PURCHASE
        "step": "FIRST", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode||vm.formData.inSchemeCode, // required
        "folioNo": vm.formData.folioNumber, // required
        "formData": _formData,//vm.formData.investmentType == "SIP"? _formData.sipForm:_formData.purchaseForm, // required
        "amount": vm.formData.purchaseAmount || vm.formData.amount, //required
        "trxnStatus": "OPEN",  // OPEN,PROCESSED
        "promoterCode": "" // capture from the transaction link
      };
      if(vm.arnHardcodedData){
        if(vm.arnHardcodedData.isHdfcBank){
          _payload.loginType= AppConstants.LOGIN_TYPE.HDFC_ONE_CLICK;
          _payload.formData.chipherText = vm.arnHardcodedData.chipherText;
        }
      }else{
        _payload.loginType= AppConstants.LOGIN_TYPE.QUICK;
      }
      if(vm.formData.investmentType == "SIP"){
        delete _payload.formData.sipDate;
        delete _payload.formData.toDate;
        delete _payload.formData.startDate;
        delete _payload.formData.endDate;
      }
      return _payload;
    }

    function getDateValidation(cb){
      enabledOTMStartDatesList = [];
      cb = cb || function () {};
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.masterNonBusinessDate = resp;
            var currentDate = resp.data.currentDate || Date();
            var parsedDate = $window.moment(currentDate, 'DD-MMM-YYYY');
            var todayDate = $window.moment(Date.parse(parsedDate));
            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
            }else if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC){
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.inSchemeValidations.sipTDay, 'days');
              if(vm.arnHardcodedData){
                if (vm.formData.frequency == vm.arnHardcodedData.frequency) {
                  if(!vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate){
                    vm.formData.startDate = vm.startMinDateBiller;
                    vm.changeStartDate(vm.formData.startDate);
                    vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
                    if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                      vm.formData.isTillPerpetuity=true;
                    }
                    vm.changeTillPerpetuityFlag();
                  }else{
                    if(vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate){
                      vm.formData.startDate = vm.arnHardcodedData.sipStartDate;
                      vm.changeStartDate(vm.formData.startDate);
                      vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
                      if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                        vm.formData.isTillPerpetuity=true;
                      }
                      vm.changeTillPerpetuityFlag();
                      }
                      if(vm.arnHardcodedData.sipStartDate && vm.arnHardcodedData.sipEndDate){
                        vm.formData.startDate = moment(vm.arnHardcodedData.sipStartDate);
                        vm.changeStartDate(vm.formData.startDate);
                        vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
                        vm.setEndDate = moment(vm.arnHardcodedData.sipEndDate);
                        $timeout(function () {
                          var EndDate = moment(vm.arnHardcodedData.sipEndDate);
                          vm.changeEndDate(EndDate);
                        }, 1000);
                        vm.formData.minEndDate = vm.setEndDate;
                      }
                  }
                }else{
                  vm.formData.startDate = vm.startMinDateBiller;
                  vm.changeStartDate(vm.formData.startDate);
                  vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
                  if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                    vm.formData.isTillPerpetuity=true;
                  }
                  vm.changeTillPerpetuityFlag();
                }
              }else{
                vm.formData.startDate = vm.startMinDateBiller;
                vm.changeStartDate(vm.formData.startDate);
                vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
                if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                  vm.formData.isTillPerpetuity=true;
                }
                vm.changeTillPerpetuityFlag();
              }
            }else {
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(11, 'days');
            }
            vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
            vm.daysList = resp.data.listOfDays;
            // vm.startMaxDate = moment(currentDate).add(120, 'days');

            var startDate = todayDate.clone();
            var freq = vm.startMaxDate.diff(todayDate, 'days');
            for (var i = 0; i <= freq; i++) {
              var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
              var isEnable = true;
              angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')==0){
                  isEnable = false;
                }
              });
              if(isEnable){
                enabledOTMStartDatesList.push(indexDate);
              }
            }
            vm.startMinDateOTM = enabledOTMStartDatesList[5];
            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              vm.startMinDateBiller = enabledOTMStartDatesList[vm.eMandatenoOfDays];
              vm.enabledBillerStartDatesList = enabledOTMStartDatesList;
              if(vm.formData.frequency != 'OW')
                {
                  if(vm.arnHardcodedData){
                    if (vm.formData.frequency == vm.arnHardcodedData.frequency) {
                      if(!vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate){
                        vm.formData.startDate = $window.moment(vm.startMinDateBiller);
                        vm.changeStartDate(vm.formData.startDate);
                        vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
                        if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                          vm.formData.isTillPerpetuity=true;
                        }
                        vm.changeTillPerpetuityFlag();
                      }else{
                          if(vm.arnHardcodedData.sipStartDate && vm.arnHardcodedData.sipEndDate){
                            vm.formData.startDate = moment(vm.arnHardcodedData.sipStartDate);
                            vm.changeStartDate(vm.formData.startDate);
                            vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
                            vm.setEndDate = moment(vm.arnHardcodedData.sipEndDate);
                            $timeout(function () {
                              if(vm.showNPCIDateError == ''){
                                var EndDate = moment(vm.arnHardcodedData.sipEndDate);
                                vm.changeEndDate(EndDate);
                              }else{
                                vm.formData.endDate = null;
                              }
                                  vm.updateEndDates();
                            }, 1000);
                            vm.formData.minEndDate = vm.setEndDate;
                          }
                          if(vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate){
                            vm.formData.startDate = moment(vm.arnHardcodedData.sipStartDate);
                            vm.changeStartDate(vm.formData.startDate);
                            vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
                            if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                              vm.formData.isTillPerpetuity=true;
                            }
                            vm.changeTillPerpetuityFlag();
                            }
                            if(!vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate){
                              vm.formData.startDate = $window.moment(vm.startMinDateBiller);
                              vm.changeStartDate(vm.formData.startDate);
                              vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
                              if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                                vm.formData.isTillPerpetuity=true;
                              }
                              vm.changeTillPerpetuityFlag();
                            }
                      }
                    }else{
                      vm.formData.startDate = moment(vm.startMinDateBiller);
                      vm.changeStartDate(vm.formData.startDate);
                      vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
                      if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                        vm.formData.isTillPerpetuity=true;
                      }
                      vm.changeTillPerpetuityFlag();
                    }
                  }else{
                    vm.formData.startDate = $window.moment(vm.startMinDateBiller);
                    vm.changeStartDate(vm.formData.startDate);
                    vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
                    if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                      vm.formData.isTillPerpetuity=true;
                    }
                    vm.changeTillPerpetuityFlag();
                  }
                }
            }

            if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
              if ((vm.formData.frequency === 'OW' && vm.formData.weeklyDay) || vm.formData.frequency !== 'OW') {
                vm.startMinDateBiller = angular.copy(vm.startMinDateOTM);
                vm.formData.startDate = moment(vm.startMinDateBiller);
                vm.changeStartDate(vm.formData.startDate);
                vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
              }
              vm.disableEndDateSelection = false;
            }

            vm.updateEndDates();
            vm.isReseting = true;
            $timeout(function () {
              vm.isReseting = false;
            });
            cb(true);
          } else {
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb(false);
        };
        if(vm.formData.inSchemeCode && !vm.masterNonBusinessDate){
          IIHttpService.get({
            child1: 'nonBusinessDate',
            schemeCode: vm.formData.inSchemeCode //'AFWDQ'
          }).$promise.then(success, error);
        }
        if(vm.masterNonBusinessDate){
          success(vm.masterNonBusinessDate);
        }
    }

    function fetchPreviousTrSelectedDistrubutor(cb) {

      cb = cb || function () {
      };
      if(!vm.formData.folioNumber){
        return ''||cb(true);
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var distributorDetails = resp.data;
            if (distributorDetails.investThroughDistributor
              && distributorDetails.previousDistributorDetails.brokerCode.indexOf('ARN-') === 0) {
              var brokerCode = distributorDetails.previousDistributorDetails.brokerCode
                ? distributorDetails.previousDistributorDetails.brokerCode.split('-') : [];
              vm.formData.brokerCode = brokerCode.length > 0 ? brokerCode[1] : '';
              manipulateInvestThrough('ARN');
              vm.formData.brokerName = distributorDetails.previousDistributorDetails.brokerName;
              var subBrokerArn = distributorDetails.previousDistributorDetails.subBrokerArn;
              var subBrokerARNArray = subBrokerArn ? subBrokerArn.split('-') : [];
              vm.formData.subBrokerARN = subBrokerARNArray ? subBrokerARNArray[1] : '';
              vm.formData.subBrokerCode = distributorDetails.previousDistributorDetails.subBrokerCode;
              vm.subBrokerName = distributorDetails.previousDistributorDetails.subBrokerName;
              vm.euinMasterList = distributorDetails.previousDistributorDetails.euinDetailList;
              vm.euinList = vm.euinMasterList;
              vm.formData.euin = vm.euinList.length ===1 ? vm.euinList[0]:null;
              vm.formData.euin = distributorDetails.previousDistributorDetails.euinPreviousUsed ? vm.euinList[0] : null;
              vm.euinData.euinNameCode = vm.formData.euin ? vm.formData.euin.euinNameCode : null;
              vm.isCheckedTandC = false;
              vm.isArnSuccess = false;
              vm.showArnLabel = false;
            } else if (distributorDetails.investThroughRIA) {
              vm.formData.brokerCode = distributorDetails.previousDistributorDetails.brokerCode
                ? distributorDetails.previousDistributorDetails.brokerCode : '';
              vm.formData.brokerName = distributorDetails.previousDistributorDetails.brokerName;
              vm.isArnSuccess = false;
              vm.showArnLabel = false;
              manipulateInvestThrough('RIA');
            } else {
              manipulateInvestThrough('DIRECT');
              //resetAll();
              if(vm.PARTNER_DATA){
                vm.formData.brokerCode = vm.PARTNER_DATA.arnCode;
                if(vm.PARTNER_DATA.arnFlag){
                  manipulateInvestThrough('ARN');
                }else{
                  manipulateInvestThrough('DIRECT');
                }
              }
            }
            cb(true);
          } else {
            vm.folioList = null;
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      IIHttpService.post({//v1/folio/status/previous/transaction/{folioNumber}
        child1: 'folio',
        child2: 'status',
        child3: 'previous',
        child4: 'transaction'
      },{folioNo: vm.formData.folioNumber}).$promise.then(success, error);
    }

    function prefill() {
      if (vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
        $window.NumToWord(vm.formData.purchaseAmount, 'divDisplayWords', vm);
      } else if (vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
        if(vm.arnHardcodedData){
          if(vm.arnHardcodedData.isHdfcBank){
            if(angular.isDefined($stateParams.trxnType) && $stateParams.trackId && !vm.formData.isBackFromSummary){
              vm.transactionType = vm.formData.investmentType;
              fetchInSchemeValidations();
                checkOTM();
                updateEndDates();
                getDateValidation(function (success) {
                  if(success){
                    vm.formData.isBackFromSummary = false;
                  }
                });
            }
          }
       }else{
        if (vm.formData.inSchemeCode) {
          fetchInSchemeValidations();
          changeFrequency();
          fetchBankList(function(success){
            if(success){
              var bankList= vm.bankList && vm.bankList.find(function(item){
                return vm.formData.bankInfo === item;
              })|| {};
              vm.formData.bankInfo.bankName = bankList.bankName || '';
            }
          });
          checkOTM();
          updateEndDates();
          getDateValidation(function (success) {
            if(success){
              vm.formData.isBackFromSummary = false;
            }
          });
        }
      }
    }

      vm.formData.isThroughDistributor && fetchEuinList();
      if (vm.formData.distributorARN || vm.formData.brokerCode) {
        fetchEuinListThroughDistributor(vm.formData.distributorARN)
      }
      // if (!vm.formData.isEuin) {
      //   vm.isCheckedTandC = true;
      // }
    }

    vm.schemeListModal = function () {
      if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
        MessageService.error('No free available units');
        return;
      }
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.amountType = 'amount';
      vm.formData.bankInfo = null;
      if (!vm.token) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var successSchemeList = function (result) {
          vm.formData.inSchemeCode = result.schemeCode;
          vm.formData.inSchemeName = result.scheme;
          vm.formData.schemeType = result.schemeType;
          if (vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && result.retirementFlag) {
            MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
            vm.formData.inSchemeCode = '';
            vm.formData.inSchemeName = '';
            vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
            return;
          }
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
          vm.inSchemeChanged(result);
          /*fetchInSchemeValidations();
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            // vm.formData.sipPaymentOption = vm.paymentOptions[0];
            fetchBankList();
            getDateValidation();

          }*/
          //checkEMandate(function () {});
        },
        errorSchemeList = function () {
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
        };
      ModalService.schemeListInstantModal({
        enabledScheme: vm.transactionType.toLowerCase() + 'enabled',
        isMinor: vm.token.minor,
        isThroughDistributor: vm.formData.isThroughDistributor,
        corporateFlag : vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
      }, successSchemeList, errorSchemeList);
    };

    vm.purchaseSchemeListModal = function () {
      vm.formData.purchaseAmount = '';
      if (!vm.token) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var successSchemeList = function (result) {
          vm.formData.purchaseInSchemeCode = result.schemeCode;
          vm.formData.purchaseInSchemeName = result.scheme;
          vm.formData.schemeType = result.schemeType;
          if(vm.formData.purchaseInSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && result.retirementFlag) {
            MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
            vm.formData.purchaseInSchemeCode = '';
            vm.formData.purchaseInSchemeName = '';
            vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
            return;
          }
          fetchPurchaseValidations();
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
          if(vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction){
            vm.dateDiff =  yearDiff(new Date($window.moment(vm.arnHardcodedData.schedulerStartDate)),
                            new Date($window.moment(vm.arnHardcodedData.schedulerEndDate)));
            if(vm.formData.minorFlag || vm.dateDiff >vm.emandateMaxYear){
              vm.noEmandateBank = true;
              vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING;
            }else{
              vm.noEmandateBank = false;
              vm.formData.sipPaymentOption = vm.arnHardcodedData && vm.arnHardcodedData.paymentOption && vm.arnHardcodedData.paymentOption != "HEM"?vm.arnHardcodedData.paymentOption : vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
            }
            vm.formData.frequency = vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler" &&
            vm.arnHardcodedData.scheduleFrequency?vm.arnHardcodedData.scheduleFrequency : vm.formData.frequency;
            vm.fetchScheduleBankList();
            vm.checkECBankForPurchaseScheduler();
            vm.checkOTMForPurchaseScheduler();
            vm.schedulePurchaseChangeFrequency();
          }
        },
        errorSchemeList = function () {
          vm.formData.purchaseInSchemeCode = '';
          vm.formData.purchaseInSchemeName = '';
          vm.purchaseValidations = null;
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
        };
        if(vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction){
          ModalService.purchaseScheduleSchemesModal({
            "ARN": vm.HDFC_WITH_DIRECT_ARN? "DIRECT" : vm.formData.brokerCode
          }, successSchemeList, errorSchemeList);
        }else{
          ModalService.schemeListInstantModal({
            enabledScheme: 'purchaseenabled',
            isMinor: vm.token.minor,
            isThroughDistributor: vm.formData.isThroughDistributor,
 corporateFlag : vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
          }, successSchemeList, errorSchemeList);
        }
    };

    vm.searchDistributorByName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      //vm.isInvalidForm = true;
      vm.brokerCodeError = '';
      vm.isArnSuccess = true;
      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        vm.distributorList = null;
        vm.euinList = null;
        //vm.formData.euinInput = '';
        vm.formData.euin = '';
        return;
      }
      fetchARNByName();

    };

    function fetchARNByName() {

      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        vm.distributorList = null;
        vm.euinList = null;
        //vm.formData.euinInput = '';
        vm.formData.euin = '';
        return;
      }
      vm.formData.distributorARN = '';
      vm.distributorList = null;
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.distributorList = resp.data.distributorList;
            if (vm.distributorList.length == 0) {
              //vm.isInvalidForm = true;
              vm.formData.euin = '';
              vm.isCheckedTandC = false;
              if(vm.arnHardcodedData){
                // vm.isCheckedTandC = true;
              }
            }
            //vm.formData.brokerName = resp.data.distributorName;
            LoaderService.hideLoader();
          } else {
            vm.distributorList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.distributorList = null;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      IIHttpService.get({
        child1: 'getDistributor',
        child2: vm.formData.distributorName
      }).$promise.then(success, error);
    }

    vm.distributorListChanged = function (data) {
      if (!data) {
        return;
      } else {
        vm.brokerCodeError = '';
        vm.formData.distributorARN = data.arnCode;
        vm.formData.distributorName = data.name + ' - ' + data.arnCode;
        vm.showArnLabel = false;
        if (vm.formData.distributorARN) {
          //vm.isInvalidForm = false;
          vm.isArnSuccess = false;
        }
        else {
          vm.isArnSuccess = true;
        }
        fetchEuinListThroughDistributor(vm.formData.distributorARN);
      }
    };

    function fetchEuinListThroughDistributor(arnCode) {
      if (!arnCode) {
        return;
      }
      vm.formData.brokerName = '';
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin ? vm.formData.euin : {};
          } else {
            vm.euinList = null;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
        };

      LoaderService.showLoader();
      IIHttpService.get({
        child1: 'getEuin',
        child2: arnCode
      }).$promise.then(success, error);
    }

    function changeFirstInstallment(installmentActivated) {
      vm.formData.startDate = null;
       vm.formData.endDate = null;
      vm.formData.bankInfo = null;
      if (installmentActivated === false) {
        vm.sipFirstInstallment = false;
        vm.formData.sipFirstInstallment = false;
        vm.formData.sipFirstAmount='';
        if(vm.restrictOTMEmandate){
          if (vm.paymentOptions[1]) {
            if(vm.formData.investmentType == 'SIP'){
              vm.formData.sipPaymentOption = vm.paymentOptions[1];
            }else{
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
            }
            vm.changedPaymentOption();
          } else {
            vm.formData.sipPaymentOption = vm.paymentOptions[0];
            vm.changedPaymentOption();
          }
        }
      } else {
        vm.sipFirstInstallment = true;
        vm.formData.sipFirstInstallment = true;
        vm.formData.sipFirstAmount= vm.formData.amount?vm.formData.amount:"";
        if(vm.arnHardcodedData || vm.PARTNER_DATA || vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank){
          vm.formData.sipPaymentOption = vm.paymentOptions? vm.paymentOptions[0]: 'EC';
        } else {
          vm.formData.sipPaymentOption = 'UPI';
        }
      }
      checkOTM(function (success) {
        if (success) {
          fetchBankList();
          checkEMandateValidation();
          checkOTMAmountAndDate();
        }
      });
      $scope.$broadcast('timer-set-countdown-seconds', 0);
      resetTimer();
    }


    /**
     * Function responsible for setting nominee block transaction flag data for blocking transaction
     * @param {String} investmentType : transaction type
     */

    vm.changeInvestmentType = function (investmentType) {

      vm.masterNonBusinessDate = null;
      vm.EmandateBankData = null;
      vm.calledEmandate = false;
      vm.outSchemeName = "";
      vm.outSchemeCode = "";
      vm.unitsDetails = null;
      vm.inSchemeName = "";
      if(investmentType == ("PURCHASE" || vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction)){
        vm.isCheckedTandCeMandate = false;
        vm.formData.sipPaymentOption = null;
      }
      vm.inSchemeCode = "";
      vm.validations = {};
      vm.amountType = 'amount';
      // if(vm.formData.minorFlag){
      //   if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE)
      //     ModalService.minorSipModal({});
      //   else
      //     ModalService.minorPurchaseModal({});
      // }
      var folioNumber = vm.formData.folioNumber;
      var isThroughDistributor = false;
      var sipPaymentOption = vm.formData.sipPaymentOption;
      var sTransactionId = vm.formData.sTransactionId;
      var pTransactionId = vm.formData.pTransactionId;
      vm.transactionType = investmentType;
      vm.formData.isThroughDistributor = vm.formData.isThroughDistributor ? vm.formData.isThroughDistributor : isThroughDistributor;
      vm.otmGenerated = false;
      if(investmentType == "REDEMPTION"){
        vm.bankList = null;
      }
      vm.amount=null;
      vm.unit=null;

      // if ((investmentType === 'SWITCH' || investmentType === 'REDEMPTION') && vm.restrictRedemptionSwitch) {
      //
      //   if (!calledFromController) {
      //     if(vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank) {
      //       if (vm.folioData) {
      //         if (vm.noNomination == null || vm.noNomination == "") {
      //           ModalService.genericModal({
      //             text: vm.popUpMessage,
      //             isHdfcNomineePopup : true,
      //             hdfcNomineePopupMessage : vm.popUpMessageHDFCNominee,
      //             isUpi : true,
      //             folioNumber : vm.formData.folioNumber
      //           }, NomineePopupSuccess);
      //         } else {
      //           ModalService.genericModal({text : vm.popUpMessage,isUpi : true}, NomineePopupSuccess);
      //         }
      //       }
      //     } else {
      //       ModalService.genericModal({text : vm.popUpMessage,isUpi : true}, NomineePopupSuccess);
      //     }
      //   }
      //
      // } else {
        if (!vm.localData) {
          if (investmentType === 'SIP') {
            vm.bankList = [];
            //changeFirstInstallment();
            fetchInSchemes();
            checkOTM();
            fetchBankList();
            //changeFrequency();
            vm.formData.sipDividendOption = vm.devidendOptions[0];

          } else if ((investmentType === 'PURCHASE' || investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction)) {
            fetchPurchaseInSchemes();
          }
        }
        vm.formData = TransactionModel.getMasterRawData(vm.transactionType);
        if(vm.transactionType == 'REDEMPTION'){
          vm.formData.isThroughDistributor = false;
          vm.formData.isDirect = true;
          vm.formData.isThroughRia = false;
          vm.formData.brokerCode = '';
          vm.formData.brokerName = '';
          vm.formData.euin = '';
          vm.formData.euinOpted = 'N';
        }
        if(vm.arnHardcodedData){
          if(vm.arnHardcodedData.euin == undefined){
            vm.formData.isEuin = false;
            vm.euinData = {};
            vm.euinDesable = false;
          }else{
            vm.euinDesable = true;
          }
          if(vm.arnHardcodedData.euin){
            vm.formData.isEuin = true;
          }
        }else{
          vm.formData.isEuin = true;
          vm.euinData = {};
        }
        vm.formData.folioNumber = folioNumber;
        vm.formData.minorFlag = identifierData?identifierData.minor:null;
        vm.formData.sTransactionId = sTransactionId;
        vm.formData.pTransactionId = pTransactionId;
        vm.formData.investmentType = investmentType;
        $state.$previous = null;
        TransactionModel.setPayloadRawData(null);
        reSetting();
        vm.formData.sipPaymentOption = sipPaymentOption ? sipPaymentOption: vm.paymentOptions[0];
        vm.resetNumInWords();
        if (vm.localData) {
          vm.arnHardcodData();
        }
        if(vm.PARTNER_DATA){
          if(vm.PARTNER_DATA.arnFlag){
            if(vm.PARTNER_DATA.arnCode){
              vm.formData.isThroughDistributor = true;
              vm.changeThroughDistributor('ARN');
              vm.formData.brokerCode = vm.PARTNER_DATA.arnCode;
              vm.searchDistributor();
            }else{
              vm.formData.isThroughDistributor = true;
              vm.changeThroughDistributor('ARN');
              vm.formData.brokerCode = '';
            }
          }
        }
        if (investmentType === 'SWITCH'){
          fetchOutSchemes();
          setDynamicData();
        }
        if (investmentType === 'REDEMPTION'){
          fetchOutSchemes();
          setDynamicData();
        }
        if(vm.localData && (investmentType === 'PURCHASE' || investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction)){
          vm.isCheckedTandCeMandate = false;
          vm.formData.sipPaymentOption = null;
        }
      // }

    };

    vm.changeDistributorCode = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.euinList = null;
      vm.isArnSuccess = true;
    }

    vm.changeDistributorName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      vm.euinList = null;
    }

    function fetchInSchemes(cb) {
      cb = cb || function () {
      };
      //const isThroughDistributor = vm.formData.isThroughDistributor;
       var success = function (resp) {
          if (resp.status && resp.data) {
            //vm.formData.isThroughDistributor = isThroughDistributor;
            vm.masterInSchemeList = resp.data.schemeList;
            vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);

            if(vm.arnHardcodedData){
                vm.filterArnScheme(vm.inSchemeList);
            }

            if (vm.formData.inSchemeCode) {
              var schemeData = vm.inSchemeList.filter(function(scheme) {
                return scheme.schemeCode === vm.formData.inSchemeCode;
              });
              vm.inSchemeChanged(schemeData[0]);
            }
            cb();
            if (vm.arnHardcodedData) {
              if (vm.arnHardcodedData.schemeGroupCode) {
                schemeGroupCodeList(vm.inSchemeList , "sip")
              }
              if (vm.arnHardcodedData.HDFCCAMP) {
                vm.filterHdfcCapmScheme(vm.inSchemeList , "sip")
              }
            }
            if(vm.PARTNER_DATA){
              if(vm.PARTNER_DATA.schemeGroupCode){
                schemeGroupCodeData(vm.inSchemeList , "sip")
              }
            }
          } else {
            vm.masterInSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.masterInSchemeList = null;
          UtilService.errorHandler(err);
        };
      if(vm.arnHardcodedData && vm.arnHardcodedData.CAMP){
        IIHttpService.post({
          child1: 'scheme',
          child2: 'All',
          child3: 'connecktsipenabled',
          child4: 'schemes',
          child5: identifierData && identifierData.minor != 'undefined' ? identifierData.minor : false,
          child6: vm.formData.isThroughDistributor
        }, null).$promise.then(success, error);
      }else{
        IIHttpService.get({
          child1: 'scheme',
          child2: 'ALL',//vm.transactionType.toLowerCase(),
          child3: vm.transactionType.toLowerCase() + 'enabled',
          child4: identifierData && identifierData.minor != 'undefined' ? identifierData.minor : false/*vm.investorInfo.minor|| */,
          child5: vm.formData.isThroughDistributor,
          child6: vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
        }, null).$promise.then(success, error);
      }
    }

    vm.filterArnScheme = function(data){
      if(data){
        vm.inSchemeList = [];
        vm.purchaseInSchemeList = [];
        angular.forEach(data, function(value){
          if (value.schemeCode == vm.arnHardcodedData.schemeCode) {
            if(vm.formData.investmentType == "SIP"){
              vm.inSchemeList.push(value);
            }else{
              vm.purchaseInSchemeList.push(value);
            }
          }
          if(!vm.arnHardcodedData.schemeCode){
            if(vm.formData.investmentType == "SIP"){
              vm.inSchemeList.push(value);
            }else{
              vm.purchaseInSchemeList.push(value);
            }
          }
        });
        if(vm.formData.investmentType == "SIP"){
          if(vm.arnHardcodedData.schemeCode){
            vm.inSchemeChanged(vm.inSchemeList[0]);
          }
        }else{
          if(vm.arnHardcodedData.schemeCode){
            vm.purchaseInSchemeChanged(vm.purchaseInSchemeList[0]);
          }
          vm.formData.purchaseAmount = vm.arnHardcodedData.amount ? vm.arnHardcodedData.amount : 5000;
          if(vm.formData.purchaseAmount){
            $window.NumToWord( vm.formData.purchaseAmount, 'divDisplayWords');
          }

        }
      }
    }

    function fetchPurchaseInSchemes(cb) {
      cb = cb || function () {
      };
      // const isThroughDistributor = vm.formData.isThroughDistributor;
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            // vm.formData.isThroughDistributor = isThroughDistributor;
            vm.masterPurchaseInSchemeList = resp.data.schemeList;
            vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
            LoaderService.hideLoader();
            cb();
            if (vm.arnHardcodedData) {
              if (vm.arnHardcodedData.schemeGroupCode) {
                schemeGroupCodeList(vm.purchaseInSchemeList , "purchase")
              }
              if(vm.arnHardcodedData.schemeCode){
                vm.filterArnScheme(vm.purchaseInSchemeList);
              }
            }
            if(vm.PARTNER_DATA){
              if(vm.PARTNER_DATA.schemeGroupCode){
                schemeGroupCodeData(vm.purchaseInSchemeList , "purchase")
              }
            }
          } else {
            vm.masterPurchaseInSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.masterPurchaseInSchemeList = null;
          UtilService.errorHandler(err);
        };
        if(vm.arnHardcodedData && vm.arnHardcodedData.CAMP){
          IIHttpService.post({
            child1: 'scheme',
            child2: 'All',
            child3: 'connecktsipenabled',
            child4: 'schemes',
            child5: identifierData && identifierData.minor != 'undefined' ? identifierData.minor : false,
            child6: vm.formData.isThroughDistributor
          }, null).$promise.then(success, error);
        }else{
          IIHttpService.get({
            child1: 'scheme',
            child2: 'ALL',//vm.transactionType.toLowerCase(),
            child3: 'purchaseenabled',
            child4: identifierData && identifierData.minor != 'undefined' ? identifierData.minor : false /*vm.investorInfo.minor|| */,
            child5: vm.formData.isThroughDistributor,
            child6: vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
          }, null).$promise.then(success, error);
        }
    }

    vm.filterInSchemeList = function () {
      vm.formData.inSchemeCode = '';
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
      vm.resetNumInWords();
      //checkEMandate();
    };

    vm.filterPurchaseInSchemeList = function () {
      vm.formData.purchaseInSchemeCode = '';
      vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
      vm.resetNumInWords();
    };


    function reSetting() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    vm.dateDiff = null;
    function yearDiff(dt1, dt2)
    {
      var diffYear =(dt2.getTime() - dt1.getTime()) / 1000;
      diffYear /= (60 * 60 * 24);
      return Math.abs(Math.round(diffYear/365.25));
    }
    vm.purchaseInSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.formData.purchaseInSchemeCode = schemeData.schemeCode;
        vm.formData.purchaseInSchemeName = schemeData.scheme;
        vm.formData.investmentOption = schemeData.investmentOption;
        vm.validations.investmentOption = schemeData.investmentOption;
        vm.formData.schemeType = schemeData.schemeType;
        if(vm.formData.purchaseInSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.purchaseInSchemeCode = '';
          vm.formData.purchaseInSchemeName = '';
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
          return;
        }
        vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.purchaseInSchemeName);
        fetchPurchaseValidations();
      }
      vm.formData.purchaseAmount = vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler" &&
                                  vm.arnHardcodedData.amount?vm.arnHardcodedData.amount : 5000;
      vm.resetNumInWords(); //reset the number in text form on scheme change or form reset
      if(vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction){
        vm.dateDiff =  yearDiff(new Date($window.moment(vm.arnHardcodedData.schedulerStartDate)),
                        new Date($window.moment(vm.arnHardcodedData.schedulerEndDate)));
        if(vm.formData.minorFlag || vm.dateDiff >vm.emandateMaxYear){
          vm.noEmandateBank = true;
          vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING;
        }else{
          vm.noEmandateBank = false;
          vm.formData.sipPaymentOption = vm.arnHardcodedData && vm.arnHardcodedData.paymentOption && vm.arnHardcodedData.paymentOption != "HEM"?vm.arnHardcodedData.paymentOption :
          vm.emandateDetail && vm.emandateDetail.bankList && vm.emandateDetail.bankList.length > 0? vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING;
        }
        vm.formData.frequency = vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler" &&
        vm.arnHardcodedData.scheduleFrequency?vm.arnHardcodedData.scheduleFrequency : vm.formData.frequency;
        vm.fetchScheduleBankList();
        vm.checkECBankForPurchaseScheduler();
        vm.checkOTMForPurchaseScheduler();
        vm.schedulePurchaseChangeFrequency();
      }
    };

    vm.resetNumInWords = function () {
      vm.amountInWords = '';
      var inWordsDiv = document.getElementById('divDisplayWords');
      var inWordsFirstInstallmentDiv = $window.document.getElementById('divDisplayWordFirstInstallment');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
      if (inWordsFirstInstallmentDiv) {
        inWordsFirstInstallmentDiv.innerHTML = '(In Words)';
      }
    };

    vm.changeThroughDistributor = function (investThrough) {
      vm.inSchemeName = "";
      vm.inSchemeCode = "";
      if(vm.validations && vm.formData.investmentType == 'SWITCH'){
        vm.validations.investmentOption = '';
      }
      if(!vm.formData.investmentType == 'SWITCH'){
        changeFrequency();
      }
      if (investThrough === 'DIRECT') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
        vm.formData.euin = {};
        vm.euinData = {};
      } else if (investThrough === 'ARN') {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
      } else if (investThrough === 'RIA') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
        vm.formData.euin = {};
        vm.euinData = {};
      }

      if (!vm.formData.isThroughDistributor) {
        vm.formData.euin = '';
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        //vm.formData.euinInput = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
        vm.formData.subBrokerCode = '';
        vm.isSelectedEuin = true;
        vm.subBrokerName = '';

      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
        vm.formData.purchaseInSchemeCode = '';
        vm.formData.purchaseInSchemeName = '';
        if(!vm.arnHardcodedData){
          fetchPurchaseInSchemes();
        }
      } else {
        vm.formData.inSchemeCode = '';
        vm.formData.inSchemeName = '';
        if(!vm.arnHardcodedData){
        if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION){
            fetchOutSchemes();
            setDynamicData();
        }else{
        fetchInSchemes();
        }
        }
        //vm.folioChanged();
      }
      if(!vm.arnHardcodedData){
        if (!vm.formData.isThroughRia) {
          resetRIAValues();
        }
      }
      vm.formData.amount = null;
      vm.resetNumInWords();
      if(vm.tForm){
        if(vm.tForm.sAmount){
          vm.tForm.sAmount.$setPristine(true);
        }
      }
    };

    vm.searchDistributor = function () {
      //vm.isInvalidForm = vm.formData.brokerCode?false:(vm.isArnSuccess?true:false);
      if (!vm.formData.brokerCode) {
        return;
      }
      fetchEuinList();

    };

    function fetchEuinList() {
      if (!vm.formData.brokerCode) {
        return;
      }
      vm.formData.brokerName = '';
      vm.subBrokerCodeError = '';
      vm.euinData = {};
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      vm.distributorList = null;
      // vm.formData.euinInput = '';
      if (!vm.formData.isBackFromSummary) {
        if(vm.arnHardcodedData){
          // vm.isCheckedTandC = true;
        }else{
          vm.isCheckedTandC = false;
        }
      }
      //vm.isInvalidForm = true;
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.euinData = vm.formData.euin ? vm.formData.euin : {};
            vm.formData.brokerName = resp.data.distributorName;
            vm.brokerCodeError = '';
            vm.riaCodeError = "";
            vm.isArnSuccess = false;
            //vm.isInvalidForm = false;
            if (vm.localData) {
              var euinData = vm.euinMasterList.filter(function (value) {
                if (value.euinCode == vm.localData.Euin) { return value; }
              })[0];
              vm.selectEuin(euinData);
            }
            if (vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank) {
              if(angular.isDefined($stateParams.trxnType) && $stateParams.trackId){
                var euinData = vm.euinMasterList.filter(function (value) {
                  if (value.euinCode ==  vm.formData.euin.euinCode) { return value; }
                })[0];
                vm.selectEuin(euinData);
              }
            }
          } else {
            vm.euinList = null;
            if (vm.formData.isThroughDistributor) {
              vm.brokerCodeError = resp.message;
            } else if (vm.formData.isThroughRia) {
              vm.riaCodeError = resp.message;
              vm.isCheckedTandC = false;
            }
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
          if(vm.arnHardcodedData && vm.arnHardcodedData.arn){
            if(vm.formData.subBrokerARN){
              vm.fetchEuinListSubBroker();
            }

          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.euinList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var path = {};
      if (vm.formData.isThroughDistributor) {
        path  = {
          child1: 'getEuin',
          child2: 'ARN-' + vm.formData.brokerCode
        };
      } else if (vm.formData.isThroughRia) {
        path = {
          child1: 'getEuin',
          child2: vm.formData.brokerCode,
          riaOpted: vm.formData.isThroughRia
        };
      }
      IIHttpService.get(path).$promise.then(success, error);
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
            vm.isArnSuccess = false;
            if (vm.localData) {
              var euinData = vm.euinMasterList.filter(function (value) {
                if (value.euinCode == vm.localData.Euin) {
                  return value;
                }
              })[0];
              vm.selectEuin(euinData);
            }
          } else {
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = '';
            MessageService.error(resp.message);
            vm.isArnSuccess = true;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      IIHttpService.get({
        child1: 'getEuin',
        child2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: vm.formData.isThroughDistributor
      }).$promise.then(success, error);
    }


    vm.inSchemeChanged = function (schemeData) {

      if (!schemeData) {
        return;
      } else {
        if (vm.formData.inSchemeCode !== schemeData.schemeCode) {
          vm.masterNonBusinessDate = null;
          vm.EmandateBankData = null;
          vm.calledEmandate = false;
          vm.formData.startDate = null;
          vm.formData.endDate = null;
          vm.formData.day = '';
          vm.formData.bankInfo = null;
          // Commented due to otm bank feature
          // vm.formData.frequency = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? vm.frequencyList[0].key : null;
          vm.enabledStartDates = null;
          vm.enabledEndDates = null;
          vm.formData.amount = '';
          vm.formData.sipFirstAmount = '';
          vm.formData.units = '';
          vm.formData.amountType = 'amount';
          vm.disableEndDateSelection = false;
          vm.formData.weeklyDay = null;
          reSetting();
          vm.resetNumInWords();
          //checkEMandate(function () {
          //});
          /*checkOTM(function (success) {
            if(success){
              vm.changedPaymentOption();
            }
          });*/
        }
        if(!vm.backFromPayment)
        {
          vm.sipFirstInstallment=false;
          vm.formData.sipFirstInstallment=false;
        }
        else
        {
          vm.sipFirstInstallment=true;
          vm.formData.sipFirstInstallment=true;
        }
        vm.formData.inSchemeCode = schemeData.schemeCode;
        vm.formData.inSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        if (vm.formData.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
          return;
        }

        vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
        fetchInSchemeValidations(function (investmentOption) {
          vm.validations.investmentOption = investmentOption;
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            getDateValidation();
            // vm.formData.sipPaymentOption = vm.paymentOptions[0];
            fetchBankList();
            if(schemeData.schemeType === 'NFO') {
              var message = schemeData.message;
              ModalService.nfoEnabledModal({message: message});
            }
            //checkEMandate(function () {});
          }
          if(vm.checkForMinorBankListCondition() && vm.isOTMEnabled) {
            //vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE]; // to be used once otm is enabled for quick investment
            vm.formData.sipPaymentOption = (vm.formData.sipPaymentOption !== vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) ? vm.paymentOptions[0] : vm.formData.sipPaymentOption;
            //vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if(vm.isOTMEnabled || !vm.checkForMinorBankListCondition()) {
            if(vm.formData.frequency === 'OW') {
              //vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE]; // to be used once otm is enabled for quick investment
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
              if(vm.inSchemeValidations.cgfFlag && !vm.isOTMEnabled) {
                 vm.paymentOptions = [];
                 vm.formData.sipPaymentOption = null;
               }
            } else {
              //vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];// to be used once otm is enabled for quick investment
              if(vm.restrictOTMEmandate){
                if (vm.paymentOptions[1]) {
                  if(vm.formData.investmentType == 'SIP'){
                    vm.formData.sipPaymentOption = vm.paymentOptions[1];
                  }else{
                    vm.formData.sipPaymentOption = vm.paymentOptions[0];
                  }
                  vm.changedPaymentOption();
                } else {
                  vm.formData.sipPaymentOption = vm.paymentOptions[0];
                  vm.changedPaymentOption();
                }
              }
              else{
                vm.formData.sipPaymentOption = vm.formData.sipPaymentOption ? vm.formData.sipPaymentOption : vm.paymentOptions[0];
              }
            }
            checkEMandate();
          } else {
            vm.formData.sipPaymentOption = null;
            vm.paymentOptions = [];
          }
          checkValidations();
          if (vm.formData.bankInfo) {
            updateEndDates();
            vm.changeEndDate(vm.formData.endDate);
          }
        });
      }
    };

    function getDetails() {
      var success = function (resp) {
        var bankDetails=[];
        LoaderService.hideLoader();
        vm.folioDetailsData = resp.data;
        if(vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length>0){
          bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
            if(value.defaultBank===true){return value;}
          });
        }
        localStorage.setItem('bankDetails',$window.JSON.stringify(bankDetails));
      }, error = function () {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      IIHttpService.post({
        child1: 'profile',
        child2: 'folio',
        child3: 'details'
      }, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }

    function checkOTM(cb){
      cb = cb || function () {
      };
      var success = function (resp) {
          if (resp.status && resp.data) {
            LoaderService.hideLoader();
            if (resp.data.bankList.length == 0) {
              vm.isOTMEnabled = false;
              if(!(vm.checkForMinorBankListCondition())) {
                if (vm.formData.frequency !== 'OW'){
                  if(vm.sipFirstInstallment)
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                  else {
                  if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                    vm.formData.frequency !== 'OW' && vm.formData.frequency !== 'BZ'){
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                    vm.formData.sipPaymentOption = vm.paymentOptions[0];
                  }else if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                    (vm.formData.frequency == 'OW' || vm.formData.frequency == 'BZ')){
                    vm.paymentOptions = [];
                    vm.formData.sipPaymentOption = null;
                  } else if(vm.restrictOTMEmandate && !vm.formData.minorFlag){
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                  }else{
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                  }
                    if (!vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) {
                      vm.paymentOptions.unshift(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
                    }
                    hideUPIDetails();
                  }
                }
                else
                {
                  if(vm.sipFirstInstallment)
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI];
                  else
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                }
                hideUPIDetails();
                var index = vm.paymentOptions.indexOf('OTM');
                if(index > -1) {
                  vm.paymentOptions.splice(index,1);
                }
                if(vm.restrictOTMEmandate){
                  if (vm.paymentOptions[1]) {
                    if(vm.formData.investmentType == 'SIP'){
                      vm.formData.sipPaymentOption = vm.paymentOptions[1];
                    }else{
                      vm.formData.sipPaymentOption = vm.paymentOptions[0];
                    }
                  } else {
                    vm.formData.sipPaymentOption = vm.paymentOptions[0];
                  }
                }else{
                  vm.formData.sipPaymentOption = vm.paymentOptions[0];
                }
                vm.changedPaymentOption(true);
              }
              if (vm.frequencyList) {
              if(vm.formData.isBackFromSummary || $stateParams.transactionId)
              {
                var frequency = vm.frequencyList && vm.frequencyList.find(function (item) {
                  return vm.formData.frequency === item.code;
                }) || {};
                vm.formData.frequency = frequency.code || '';

              }
              else{
                vm.formData.frequency = vm.formData.frequency ? vm.formData.frequency : vm.frequencyList ? vm.frequencyList[0].code : 'OM';
              }
             }

           }
            else {
              if (vm.sipFirstInstallment && resp.data.nonCOTMBankList.length === 0) {
                vm.isOTMEnabled = false;
                if (vm.checkForMinorBankListCondition() || vm.formData.frequency === 'OW')
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI];
                else
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
              } else {
                vm.isOTMEnabled = true;
                if (vm.checkForMinorBankListCondition()) {
                  if(vm.sipFirstInstallment){
                    if(vm.restrictOTMEmandate){
                      vm.paymentOptions = [];
                      vm.formData.sipPaymentOption = null;
                    }else{
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                    }
                  }else {
                    if (vm.isEMandateEnabled) {
                      if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                        vm.formData.frequency !== 'OW' && vm.formData.frequency !== 'BZ'){
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                        vm.formData.sipPaymentOption = vm.paymentOptions[0];
                        vm.changedPaymentOption(true);
                      }else if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                        (vm.formData.frequency == 'OW' || vm.formData.frequency == 'BZ')){
                        vm.paymentOptions = [];
                        vm.formData.sipPaymentOption = null;
                      }else if(vm.restrictOTMEmandate && !vm.formData.minorFlag){
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                        hideUPIDetails();
                        vm.formData.sipPaymentOption = vm.paymentOptions[0];
                        vm.changedPaymentOption(true);
                      }else{
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                        hideUPIDetails();
                      }
                    } else {
                      if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                        vm.formData.frequency !== 'OW' && vm.formData.frequency !== 'BZ'){
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                        vm.formData.sipPaymentOption = vm.paymentOptions[0];
                      }else if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                        (vm.formData.frequency == 'OW' || vm.formData.frequency == 'BZ')){
                        vm.paymentOptions = [];
                        vm.formData.sipPaymentOption = null;
                      }else if(vm.restrictOTMEmandate && !vm.formData.minorFlag){
                        vm.paymentOptions = [];
                        vm.formData.sipPaymentOption = null;
                      }else{
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                      }
                      hideUPIDetails();
                    }
                  }
                } else {
                  if (vm.formData.frequency === 'OW' || vm.folioMinor) {
                    if(vm.sipFirstInstallment){
                      if(vm.restrictOTMEmandate){
                        vm.paymentOptions = [];
                        vm.formData.sipPaymentOption = null;
                      }else{
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                      }
                      hideUPIDetails();
                    }
                    else {
                      if (vm.isEMandateEnabled) {
                        if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                          vm.formData.frequency !== 'OW' && vm.formData.frequency !== 'BZ'){
                          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                          vm.formData.sipPaymentOption = vm.paymentOptions[0];
                          vm.changedPaymentOption(true);
                        }else if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                          (vm.formData.frequency == 'OW' || vm.formData.frequency == 'BZ')){
                          vm.paymentOptions = [];
                          vm.formData.sipPaymentOption = null;
                        }else if(vm.restrictOTMEmandate && !vm.formData.minorFlag){
                          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                          hideUPIDetails();
                          vm.formData.sipPaymentOption = vm.paymentOptions[0];
                          vm.changedPaymentOption(true);
                        }else{
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                          hideUPIDetails();
                        }
                      } else {
                        if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                          vm.formData.frequency !== 'OW' && vm.formData.frequency !== 'BZ'){
                          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                          vm.formData.sipPaymentOption = vm.paymentOptions[0];
                          vm.changedPaymentOption(true);
                        }else if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                          (vm.formData.frequency == 'OW' || vm.formData.frequency == 'BZ')){
                          vm.paymentOptions = [];
                          vm.formData.sipPaymentOption = null;
                        }else if(vm.restrictOTMEmandate && !vm.formData.minorFlag){
                          vm.paymentOptions = [];
                          vm.formData.sipPaymentOption = null;
                        }else{
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                        }
                        hideUPIDetails();
                      }
                    }
                  } else {
                    if(vm.sipFirstInstallment){
                      if(vm.restrictOTMEmandate){
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                      }else{
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                      }
                      hideUPIDetails();
                    }
                    else {
                      if (vm.isEMandateEnabled) {
                        if(vm.formData.investmentType == "SIP" && vm.formData.minorFlag && vm.formData &&
                        vm.formData.frequency !== 'OW' && vm.formData.frequency !== 'BZ'){
                          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                          vm.formData.sipPaymentOption = vm.paymentOptions[0];
                          vm.changedPaymentOption(true);
                        }else if(vm.restrictOTMEmandate && vm.otmForHDFCWithoutFI && vm.formData.investmentType == "SIP" && !vm.formData.minorFlag){
                          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                          hideUPIDetails();
                          vm.formData.sipPaymentOption = vm.paymentOptions[0];
                          vm.changedPaymentOption(true);
                        }else if(vm.restrictOTMEmandate && !vm.otmForHDFCWithoutFI && vm.formData.investmentType == "SIP" && !vm.formData.minorFlag){
                          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                          hideUPIDetails();
                          vm.formData.sipPaymentOption = vm.paymentOptions[0];
                          vm.changedPaymentOption(true);
                        }else{
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                          hideUPIDetails();
                        }
                      } else {
                        if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                          vm.formData.frequency !== 'OW' && vm.formData.frequency !== 'BZ'){
                          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                          vm.formData.sipPaymentOption = vm.paymentOptions[0];
                          vm.changedPaymentOption(true);
                        }else if(vm.restrictOTMEmandate && vm.formData.minorFlag && vm.formData &&
                          (vm.formData.frequency == 'OW' || vm.formData.frequency == 'BZ')){
                          vm.paymentOptions = [];
                          vm.formData.sipPaymentOption = null;
                        }else if(vm.restrictOTMEmandate && !vm.formData.minorFlag){
                          vm.paymentOptions = [];
                          vm.formData.sipPaymentOption = null;
                        }else{
                          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                        }
                        hideUPIDetails();
                      }
                    }
                  }
                }
              }
              vm.formData.showTopUpBlock =  vm.formData.showTopUpBlock ? true : false;

              if(!vm.backFromPayment)
                vm.formData.sipPaymentOption= vm.formData.sipPaymentOption ? vm.formData.sipPaymentOption : vm.paymentOptions[0];

              if(vm.formData.isBackFromSummary || $stateParams.transactionId)
              {
                frequency = vm.frequencyList && vm.frequencyList.find(function (item) {
                  return vm.formData.frequency === item.code;
                }) || {};
                vm.formData.frequency = frequency.code || '';

              }
              else{
                vm.formData.frequency = vm.formData.frequency ? vm.formData.frequency : vm.frequencyList ? vm.frequencyList[0].code : 'OM';
              }
              if (vm.formData.sipPaymentOption == 'OTM') {
                vm.OTMbankList = vm.sipFirstInstallment ? resp.data.nonCOTMBankList : resp.data.bankList;
                vm.bankList = vm.OTMbankList;
                if (vm.arnHardcodedData) {
                  if(vm.arnHardcodedData.isHdfcBank){
                    vm.bankList = $filter('filter')(resp.data.bankList,
                        {
                          bankCode: "HDF"
                        })
                    }
                  }
                }
              }
            }
          if (!vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) {
            vm.paymentOptions.unshift(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
          }
          cb(true);
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      var payload = {
        transactionType:vm.transactionType.toLowerCase(),
        folioNo:vm.formData.folioNumber,
        arnHardCodeFlow: vm.arnHardcodedData ? true : false
      };
      IIHttpService.post({
        child1: 'folio',
        child2: 'otm'
      }, payload).$promise.then(success, error);
    }

    function checkEMandateValidation(){
      if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
        vm.validations.maxAmount=vm.eMandatemaxAmountLimit;
        vm.isMax = !!(vm.validations.maxAmount && vm.formData.amount > vm.validations.maxAmount);
      }
      else vm.isMax=false;
    }

    function checkEMandate(cb) {
      LoaderService.showLoader();
      cb = cb || function () {
      };
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.isEMandateEnabled = resp.data.folioEmandateStatus;
          if ((resp.data.bankList && resp.data.bankList.length == 0) || !vm.isEMandateEnabled) {
            // vm.isEMandateEnabled = false;
            var index = vm.paymentOptions.indexOf('E-mandate');
              if(index > -1) {
               vm.paymentOptions.splice(index,1);
            }
            if(vm.restrictOTMEmandate){
              vm.restrictRepeatCall = false;
            }
          }
          else {
            if(vm.restrictOTMEmandate){
              vm.restrictRepeatCall = true;
              vm.EmandateBankData = resp;
              fetchBankList();
            }
            // vm.isEMandateEnabled = true;
            if (!vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) && !vm.sipFirstInstallment && vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP && vm.isEMandateEnabled) {
                // vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
                paymentOptionOrdering();
                if(vm.restrictOTMEmandate){
                  if (vm.paymentOptions[1]) {
                    if(vm.formData.investmentType == 'SIP'){
                      vm.formData.sipPaymentOption = vm.paymentOptions[1];
                    }else{
                      vm.formData.sipPaymentOption = vm.paymentOptions[0];
                    }
                      vm.changedPaymentOption();
                  } else {
                    vm.formData.sipPaymentOption = vm.paymentOptions[0];
                    vm.changedPaymentOption();
                  }
                }
                if (vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) {
                  var index = vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
                  if (index > -1) {
                    vm.paymentOptions.splice(index, 1);
                  }
                }
              if (!vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) {
                vm.paymentOptions.unshift(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
              }
              hideUPIDetails();
            }
          }
          // vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)
        }
        cb(true);
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        cb(false);
      };
      var data = {
        trnxType: 'SIP',
        liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false,
        folioNumber:vm.formData.folioNumber,
        arnHardCodeFlow: vm.arnHardcodedData ? true : false
      };
      IIHttpService.post({
        child1: 'folio',
        child2: 'emandate'
      }, data).$promise.then(success, error);
    }

    function fetchBankList(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {

            if(vm.sipFirstInstallment && vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)
              vm.formData.sipPaymentOption='UPI';

            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              if(vm.arnHardcodedData){
                if(vm.restrictOTMEmandate){
                  if(vm.calledEmandate){
                    vm.EmandateBankData = resp;
                  }
                }
              }
              vm.eMandatenoOfDays=resp.data.noOfDays;
              vm.eMandatemaxAmountLimit=resp.data.maxAmountLimit;
              vm.formData.showTopUpBlock = false;
              if(vm.formData.inSchemeCode)
                getDateValidation();
              checkEMandateValidation();
            }

            if (vm.formData.sipPaymentOption == 'OTM' && resp.data.bankList.length == 0) {
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
              vm.hideOtmRadio = true;
              //fetchBankList();
            }
            else if (vm.formData.sipPaymentOption == 'OTM' && resp.data.bankList.length > 0) {
              vm.hideOtmRadio = false;
              vm.isOtmOtpVerified = vm.formData.otmOtpVerified === true ? vm.formData.otmOtpVerified : false;
              vm.otmOtp = null;
              vm.isOtmVisible = true;
              if (!vm.formData.otmOtpVerified && !vm.otmGenerated) {
                generateOtp();
              }
              if(vm.arnHardcodedData){
              if(!vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate){
                  if(vm.formData.frequency != 'OW'){
                    vm.formData.startDate =  $window.moment(vm.startMinDateOTM);
                    vm.changeStartDate(vm.formData.startDate);
                    vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
                    if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                      vm.formData.isTillPerpetuity=true;
                    }
                    vm.changeTillPerpetuityFlag();
                  }
              }
              }else{
                if(vm.formData.frequency != 'OW'){
                vm.formData.startDate = $window.moment(vm.startMinDateOTM);
                vm.changeStartDate(vm.formData.startDate);
                vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
                if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                  vm.formData.isTillPerpetuity=true;
                }
                vm.changeTillPerpetuityFlag();
                }
              }
            }
            else if (vm.formData.sipPaymentOption == 'EC') {
              if (vm.hideOtmRadio) {
                if(vm.sipFirstInstallment)
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                else {
                  if (vm.isEMandateEnabled) {
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                  } else {
                    vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                  }
                }
                hideUPIDetails();
                vm.formData.sipPaymentOption = vm.paymentOptions[0];
                if(vm.formData.inSchemeCode)
                  getDateValidation();
              }
              else {
                if(vm.checkForMinorBankListCondition())
                {
                  if(vm.sipFirstInstallment){
                    if(vm.restrictOTMEmandate){
                      vm.paymentOptions = [];
                      vm.formData.sipPaymentOption = null;
                    }else{
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                    }
                  } else {
                    if (vm.isEMandateEnabled) {
                      if(vm.restrictOTMEmandate){
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                        hideUPIDetails();
                        vm.formData.sipPaymentOption = vm.paymentOptions[0];
                      }else{
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,  vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                      }
                    } else {
                      if(vm.restrictOTMEmandate){
                        vm.paymentOptions = [];
                        vm.formData.sipPaymentOption = null;
                      }else{
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
                      }
                    }
                    hideUPIDetails();
                  }
                }
                else {
                  if(vm.sipFirstInstallment){
                    if(vm.restrictOTMEmandate){
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                      hideUPIDetails();
                      vm.formData.sipPaymentOption = vm.paymentOptions[0];
                    }else{
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                    }
                  }else{
                    if (vm.isEMandateEnabled) {
                      if(vm.restrictOTMEmandate){
                        vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                        hideUPIDetails();
                        vm.formData.sipPaymentOption = vm.paymentOptions[0];
                      }else{
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                      }
                    } else {
                      if(vm.restrictOTMEmandate){
                        if(vm.formData.minorFlag && vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank ){
                          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                          vm.formData.sipPaymentOption = vm.paymentOptions[0];
                        }else{
                          vm.paymentOptions = [];
                          vm.formData.sipPaymentOption = null;
                        }
                      }else{
                      vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                      }
                    }
                  }
                  hideUPIDetails();

                }
                vm.hideOtmRadio = false;
                if(vm.formData.inSchemeCode)
                  getDateValidation();
              }
            }
            else if(vm.formData.sipPaymentOption == 'UPI' || vm.formData.sipPaymentOption == "E-mandate"){
              if(vm.formData.inSchemeCode)
                getDateValidation();
            }

            vm.bankList = resp.data.bankList;
            if (vm.arnHardcodedData) {
              if(vm.arnHardcodedData.isHdfcBank){
                if(vm.EmandateBankData){
                  vm.bankList = vm.EmandateBankData.data.bankList;
                }
                if(vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
                  vm.bankList = $filter('filter')(vm.bankList,
                    {
                      bankCode: "HDFC"
                    })
                }
                else{
                vm.bankList = $filter('filter')(vm.bankList,
                  {
                    bankCode: "HDF"
                  })
                }
              }
            }
            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
              for (var i = 0 ; i < vm.bankList.length ; i ++) {
                vm.bankList[i].uniqueId = i;
              }
              vm.formData.authMode = vm.formData.bankInfo? (vm.formData.bankInfo.authenticationModes.length === 1 ? vm.formData.bankInfo.authenticationModes[0] : null) :null;
              vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
            }
            if (vm.sipFirstInstallment && vm.formData.sipPaymentOption == 'OTM') {
              checkOTM();
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
          if (!vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) {
            vm.paymentOptions.unshift(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
          }
          cb(true);
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        if(vm.arnHardcodedData){
          if(vm.restrictOTMEmandate){
            vm.calledEmandate = false;
            vm.EmandateBankData = null;
          }
        }
        IIHttpService.post({
          child1: 'bank',
          child2: 'list'
          },
          {
            trnxType: 'PURCHASE',
            folioNumber: vm.formData.folioNumber ,
            liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false,
            sipFlow : true,
            arnHardCodeFlow: vm.arnHardcodedData ? true : false
          }).$promise.then(success, error);
      } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
        if(vm.arnHardcodedData){
          if(vm.restrictOTMEmandate){
            vm.calledEmandate = false;
            vm.EmandateBankData = null;
          }
        }
        var payload = {
          transactionType:vm.transactionType.toLowerCase(),
          folioNo:vm.formData.folioNumber,
          arnHardCodeFlow: vm.arnHardcodedData ? true : false
        };
        IIHttpService.post({
          child1: 'folio',
          child2: 'otm'
        }, payload).$promise.then(success, error);
      }
      else if(vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
        var data = {
          trnxType: 'SIP',
          liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false,
          folioNumber:vm.formData.folioNumber,
          arnHardCodeFlow: vm.arnHardcodedData ? true : false
        };
        if(vm.arnHardcodedData){
          if(vm.restrictOTMEmandate){
            if(!vm.calledEmandate && !vm.EmandateBankData){
              vm.calledEmandate = true
              IIHttpService.post({
                child1: 'folio',
                child2: 'emandate'
              }, data).$promise.then(success, error);
            }else{
              if(vm.calledEmandate && vm.EmandateBankData){
                success(vm.EmandateBankData);
              }else{
                LoaderService.hideLoader();
              }
            }
          }else{
            if(!vm.calledEmandate){
              IIHttpService.post({
                child1: 'folio',
                child2: 'emandate'
              }, data).$promise.then(success, error);
            }
          }

        }else{
          IIHttpService.post({
            child1: 'folio',
            child2: 'emandate'
          }, data).$promise.then(success, error);
        }
      } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
        vm.isSipBanksFetch = true;
        IIHttpService.post({
            child1: 'bank',
            child2: 'list'
          },
          {
            trnxType: 'PURCHASE',
            folioNumber: vm.formData.folioNumber ,
            liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false,
            sipUpiFlow : true,
            arnHardCodeFlow: vm.arnHardcodedData ? true : false
          }).$promise.then(success, error);
      }
      else{
        IIHttpService.get({
          child1: 'bank',
          child2: 'list',
          child3: 'sip'
        }, null).$promise.then(success, error);
      }
    }

    function checkValidations() {

      vm.isInvalidForm = false;

      if (!vm.inSchemeValidations && !vm.outSchemeValidations) {
        vm.validations = {};
      }

      if (vm.outSchemeValidations) {
        vm.validations.isEnabled = vm.outSchemeValidations ? vm.outSchemeValidations.isEnabled : '';
        extractValidationObject(vm.outSchemeValidations);
      }

      if (vm.inSchemeValidations) {
        vm.validations.minInstallDivisionFlag = vm.inSchemeValidations.minInstallDivisionFlag;
        vm.validations.swpTaxCode = vm.inSchemeValidations.swpTaxCode;
        vm.validations.endingType = vm.inSchemeValidations.endingType;
        extractValidationObject(vm.inSchemeValidations);
      }

      if (vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        checkSipValidations();
      }
      if (vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH){
        checkSwitchValidations();
        if (vm.inSchemeCode && vm.outSchemeCode) {
          fetchCalculatedSwitchValidations();
        }
      }
    }

    function checkSipValidations() {
      if(vm.additionalSipData){
        var newValidation =  vm.additionalSipData;
       for (var i=0; i<newValidation.length;i++){
        var condition = vm.formData.amount < newValidation[i].min_amount_lower ||  vm.formData.amount <= newValidation[i].min_amount_upper
          if(!newValidation[i].min_amount_upper){
            var condition = true;
          }
          if(condition)
          {
           //  vm.formData.startDate = vm.formData.startDate ? vm.formData.startDate : null;
           // vm.enabledStartDates = null;
           // vm.formData.endDate = vm.formData.endDate ? vm.formData.endDate : null;
           //  vm.enabledEndDates = null;
           //  vm.formData.day = null;
           //  vm.formData.weeklyDay = null;
           //  vm.formData.month = null;
            vm.validations.amountMultiples = newValidation[i].amt_multiples;
            vm.validations.maxAmount = newValidation[i].min_amount_upper;
            vm.validations.minAmount = newValidation[i].min_amount_lower;
            vm.validations.minInstallments = newValidation[i].min_installments;
           break;
          }
        }
        if(vm.arnHardcodedData){
          if(vm.arnHardcodedData.frequency == "OW"){
            if(vm.formData.frequency == "OW"){
              if(vm.arnHardcodedData.sipStartDate){
                vm.formData.startDate = vm.arnHardcodedData.sipStartDate;
              }
              if (vm.formData.startDate) {
                vm.changeStartDate(moment(vm.formData.startDate));
                if (vm.arnHardcodedData.frequency == "OW") {
                  vm.Day = vm.formData.startDate.day();
                  switch (vm.Day) {
                    case 1:
                      vm.formData.weeklyDay = "Monday";
                      break;
                    case 2:
                      vm.formData.weeklyDay = "Tuesday";
                      break;
                    case 3:
                      vm.formData.weeklyDay = "Wednesday";
                      break;
                    case 4:
                      vm.formData.weeklyDay = "Thursday";
                      break;
                    case 5:
                      vm.formData.weeklyDay = "Friday";
                      break;
                    case 6:
                      vm.formData.weeklyDay = "Saturday";
                      break;
                    case 7:
                      vm.formData.weeklyDay = "Sunday";
                      break;
                  }
                }
              }
            }
          }


                }
      }
      if(vm.formData.amount) {
        if (vm.unitsDetails) {
          vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
        }

        vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
        vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
        vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
        vm.isInvalidForm = vm.formData.amount <= 0 || (vm.formData.amount && (vm.isMax || vm.isMin || (vm.validations.amountMultiples && !vm.isMultiples)));
        $window.NumToWord(vm.formData.amount,'divDisplayWords',vm);
        checkEMandateValidation()
      }

      /*if(vm.sipFirstInstallment)
       checkSipFirstValidations();*/


      if(vm.formData.amount == "") {
        vm.resetNumInWords();
      }
      if(vm.sipFirstInstallment)
      vm.formData.sipFirstAmount = vm.formData.amount;

      if(vm.formData.amount >= 2000000){
        vm.amountExceeded = true;
      }else {
        vm.amountExceeded = false;
      }


      if (vm.formData.startDate) {
        vm.changeStartDate(vm.formData.startDate,true);
      }

      if (vm.formData.amount && vm.formData.emandateAmount) {
        checkAmountValidationEmandate();
      }

      if(vm.formData.sipPaymentOption=='UPI' && vm.formData.amount > vm.upiLimit) {
        var success = function() {
          if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if(vm.paymentOptions.includes("E-mandate") && vm.isEMandateEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
          } else if(vm.paymentOptions.includes("EC")){
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          } else {
            vm.formData.sipPaymentOption = null;
          }
          vm.changedPaymentOption();
        }
        ModalService.genericModal({
          text: vm.upiErrorMessage,
          isUpi: true
        },success);

      }
    }

    /*function checkSipFirstValidations() {
      vm.isFirstMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.sipFirstAmount);
      vm.isFirstMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.sipFirstAmount);
      vm.isFirstMultiples = vm.validations.amountMultiples && vm.formData.sipFirstAmount && (vm.formData.sipFirstAmount % vm.validations.amountMultiples === 0) || false;
      vm.isInvalidForm = vm.formData.sipFirstAmount <= 0 || (vm.formData.sipFirstAmount && ( vm.isFirstMax || vm.isFirstMin || (vm.validations.amountMultiples && !vm.isFirstMultiples)));

      $window.NumToWord(vm.formData.sipFirstAmount,'divDisplayWordFirstInstallment',vm);
      if(vm.formData.sipFirstAmount == "") {
        vm.resetNumInWords();
      }
    }*/

    function fetchInSchemeValidations(cb) {
      vm.inSchemeValidations = null;
      if (vm.transactionType) {
        vm.formData.investmentType = vm.transactionType;
      } else if (vm.formData.investmentType) {
        vm.transactionType = vm.formData.investmentType;
      }
      var transactionType = vm.formData.investmentType.toLowerCase();
      cb = cb || function () {
      };
      if (!vm.formData.inSchemeCode) {
        return;
      }else if (!vm.formData.inSchemeCode && !vm.inSchemeCode){
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;
            vm.upiErrorMessage = resp.data.upiMaxAmountErrMessage;;
            vm.upiLimit = resp.data.upiMaxAmountLimit;
            if(vm.inSchemeValidations && vm.formData.minorFlag){
              vm.inSchemeValidations.cgfFlag = vm.inSchemeValidations.cgfFlag ? vm.inSchemeValidations.cgfFlag: true;
            }
            vm.frequencyList = vm.inSchemeValidations.additionalValidation.frequency?vm.inSchemeValidations.additionalValidation.frequency:null;
            var frequency = vm.frequencyList.find(function (f) {
              return f.code === 'OM';
            }) || {};
            if(vm.arnHardcodedData){
              if(vm.formData.minorFlag && vm.arnHardcodedData.isHdfcBank && (vm.arnHardcodedData.frequency == "OW" || vm.arnHardcodedData.frequency == "BZ")){
                vm.formData.frequency = "OM";
                if(!vm.weeklyNotePopup){
                  vm.weeklyNotePopup = true;
                  var message = vm.arnHardcodedData.frequency == "OW" ? "Weekly frequency is not applicable for minor folio.":"Daily frequency is not applicable for minor folio.";
                  var success = function() {
                    }, error = function(resp) {
                    };
                    ModalService.genericModal({
                      text: message
                    }, success, error);
                }
              }else{
                if(vm.arnHardcodedData.isHdfcBank){
                  if(angular.isDefined($stateParams.trxnType =="SIP") && $stateParams.trackId){
                    vm.formData.frequency = vm.formData.frequency ? vm.formData.frequency : "OM";
                  }else{
                vm.formData.frequency = vm.arnHardcodedData.frequency ? vm.arnHardcodedData.frequency : "OM";
                  }
                }else{
                vm.formData.frequency = vm.arnHardcodedData.frequency ? vm.arnHardcodedData.frequency : "OM";
                }
                changeFrequency()
              }
            }else{
              vm.formData.frequency = frequency?frequency.code:vm.frequencyList[0].code;
            }
            vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
            var investmentOption = vm.inSchemeValidations.investmentOption || (vm.inSchemeValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
            vm.validations.investmentOption = investmentOption;
            vm.formData.dividendOption = (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : (vm.inSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : (vm.formData.dividendOption || vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST));
            vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
            if(vm.backFromPayment){
              vm.formData.sipDividendOption = vm.formData.dividendOption;
            }
            else{
              vm.formData.sipDividendOption = (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : ((vm.inSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (transactionType == "sip" && vm.isSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
              _setSipDividendOptionsVali(vm.inSchemeValidations);
            }
            vm.formData.cgfFlag = vm.inSchemeValidations ? vm.inSchemeValidations.cgfFlag : null;
            if(vm.inSchemeValidations.amountArray){
              vm.sipFirstInstallmentAmount = vm.inSchemeValidations.amountArray;
            }
            checkOTM();
            cb(investmentOption);
          } else {
            cb('error');
            vm.inSchemeValidations = null;
            vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            MessageService.error(resp.message);
          }
          checkValidations();
        },
        error = function (err) {
          cb('error');
          vm.inSchemeValidations = null;
          vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          UtilService.errorHandler(err);
        };


      IIHttpService.get({
        child1: 'schemeValidation',
        child2: 'sip',
        child3: vm.formData.inSchemeCode
      }, null).$promise.then(success, error);

    }


    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.formData.frequency) {
        return;
      }

      vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
      vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
      vm.validations.minInstallments = vm.validations.minInstallments || 0;
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.maxAmount = vm.validations.maxAmount || 0;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > 0 && vm.validations.maxAmount < vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
      }

      switch (vm.formData.frequency) {
        case 'BZ':
          vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          if(validationsData.additionalValidation.BZ){
            vm.additionalSipData = validationsData.additionalValidation.BZ;
            vm.validations.minAmount = validationsData.additionalValidation.BZ[0].min_amount_lower;
          }
          break;
        case 'OW':
          vm.validations.maxInstallments = validationsData.weeklyMaxInstallmentNumber;
          if(validationsData.additionalValidation.OW){
            vm.additionalSipData = validationsData.additionalValidation.OW;
            vm.validations.minAmount = validationsData.additionalValidation.OW[0].min_amount_lower;
          }
          break;
        case 'Q':
          vm.validations.maxInstallments  = validationsData.quarterlyMaxInstallmentNumber;
          vm.validations.topupMinAmt = validationsData.topupMinAmt;
          vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
          vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
          if(validationsData.additionalValidation.Q){
            vm.additionalSipData = validationsData.additionalValidation.Q;
            vm.validations.minAmount =validationsData.additionalValidation.Q[0].min_amount_lower;

          }
          break;
        case 'OM':
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.validations.topupMinAmt = validationsData.topupMinAmt;
          vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
          vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
         if(validationsData.additionalValidation.OM){
           vm.additionalSipData = validationsData.additionalValidation.OM;
           vm.validations.minAmount = validationsData.additionalValidation.OM[0].min_amount_lower;
        }
          break;
        case 'H':
          vm.additionalSipData = validationsData.additionalValidation.H;
          vm.validations.minAmount = validationsData.additionalValidation.H[0].min_amount_lower;
          vm.validations.maxInstallments = 0;
          break;
        case 'Y':
          vm.additionalSipData = validationsData.additionalValidation.Y;
          vm.validations.minAmount = validationsData.additionalValidation.Y[0].min_amount_lower;
          vm.validations.maxInstallments = 0;
          break;
      }

      if(!vm.backFromPayment)
      {
       if( vm.validations.minAmount > validationsData.sipDefaultAmount){
        if(angular.isDefined($stateParams.trxnType) && $stateParams.trackId && vm.formData.amount){
          vm.formData.amount = vm.formData.amount;
        }else{
        vm.formData.amount =  vm.arnHardcodedData && vm.arnHardcodedData.amount ? vm.arnHardcodedData.amount : vm.validations.minAmount;
        }
      }else{
        if(angular.isDefined($stateParams.trxnType) && $stateParams.trackId && vm.formData.amount){
          vm.formData.amount = vm.formData.amount;
      }else{
        vm.formData.amount = vm.arnHardcodedData && vm.arnHardcodedData.amount ? vm.arnHardcodedData.amount : validationsData.sipDefaultAmount;
        }
      }
    }
    }

    function fetchPurchaseValidations(cb) {
      vm.purchaseValidations = null;
      cb = cb || function () {
      };
      if (!vm.formData.purchaseInSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.purchaseValidations = resp.data;
            if(vm.purchaseValidations && vm.formData.minorFlag){
              vm.purchaseValidations.cgfFlag = vm.purchaseValidations.cgfFlag? vm.purchaseValidations.cgfFlag: true;
            }
            _setPurchaseDividendOptionsVali(vm.purchaseValidations);
             // vm.formData.purchaseDividendOption = vm.purchaseValidations.isGrowth ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : ((vm.formData.purchaseDividendOption !== vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH && vm.formData.purchaseDividendOption) || (vm.purchaseValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (vm.isSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            vm.formData.upiErrorMessage = resp.data.upiMaxAmountErrMessage;
            vm.formData.upiLimit = resp.data.upiMaxAmountLimit;
            cb(null);
          } else {
            cb('error');
            vm.purchaseValidations = null;
            vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption || vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.purchaseInvestmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH;
            MessageService.error(resp.message);
          }
          vm.checkPurchaseValidations();
        },
        error = function (err) {
          cb('error');
          vm.purchaseValidations = null;
          vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption || vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.purchaseInvestmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH;
          UtilService.errorHandler(err);
        };
      IIHttpService.get({
        child1: 'schemeValidation',
        child2: 'purchase',
        child3: vm.formData.purchaseInSchemeCode,
        child4: vm.formData.folioNumber
      }, null).$promise.then(success, error);
    }


    vm.checkPurchaseValidations = function () {
      vm.maxAmount = vm.token.maxAmount;
      if (vm.purchaseValidations) {
        if (!vm.purchaseValidations.addlPurchase) {
          vm.isPurchaseMin = vm.purchaseValidations.minFirstPurchaseAmt > vm.formData.purchaseAmount;
          vm.purchaseMinAmount = vm.purchaseValidations.minFirstPurchaseAmt;
        } else {
          vm.isPurchaseMin = vm.purchaseValidations.minAddlPurchaseAmt > vm.formData.purchaseAmount;
          vm.purchaseMinAmount = vm.purchaseValidations.minAddlPurchaseAmt;
        }
        vm.isMultiples = vm.purchaseValidations.purchaseMultiple && vm.formData.purchaseAmount && (vm.formData.purchaseAmount % vm.purchaseValidations.purchaseMultiple === 0) || false;
        if(vm.formData.purchaseAmount%1 != 0){
          vm.isPurchaseAmountDecimal = true;
        }
        else{
          vm.isPurchaseAmountDecimal = false;
        }
      }
      if(vm.formData && vm.formData.investmentType == "Schedule_Transaction"){
        vm.checkAmountValidationSchedule();
      }
    };


    vm.changeDay = function () {
      vm.disableEndDateSelection = false;
      if (!vm.formData.frequency || (!vm.formData.day && !vm.formData.weeklyDay)) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        vm.formData.month = '';
        reSetting();
        return;
      }

      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.month = '';
        vm.formData.enabledEndDates = [];
      }

      switch (vm.formData.frequency) {
        case 'BZ':
          reSetting();
          break;
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default :
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          reSetting();
          break;
      }
    };


    vm.changeStartDate = function (date,calledFromAmountChanged) {
      vm.formData.startDate = date ? date : null;
      vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
      if (vm.formData.isTillPerpetuity) {
        vm.changeTillPerpetuityFlag();
      }
      if(vm.arnHardcodedData){
        if(!vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate && vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
          vm.formData.isTillPerpetuity=true;
          vm.changeTillPerpetuityFlag();
        }else{
          vm.formData.isTillPerpetuity=false;
        }
      }else{
        if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
          vm.formData.isTillPerpetuity=true;
          vm.changeTillPerpetuityFlag();
        }
      }
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      });
      if (calledFromAmountChanged) {
        updateEndDates(false,true);
      } else {
        updateEndDates();
      }
    };

    vm.changeEndDate = function (date,calledFromOtherFlow) {
      if (date && vm.endDateDefaultForPertuity) {
        if(vm.endDateDefaultForPertuity.isSame($window.moment(date))){
          vm.formData.isTillPerpetuity = true;
        } else {
          vm.formData.isTillPerpetuity = false;
        }
      }
      vm.formData.endDate = date ? date : null;
      var diffInMonths = parseInt($window.moment(vm.formData.endDate).diff($window.moment(vm.formData.startDate), 'months', true));
      if (diffInMonths >= 6 && vm.formData.frequency != 'BZ') {
        vm.formData.showTopUpBlock = true;
        if(diffInMonths >= 12){
          var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
          // var capStartDateValue = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
        }
        else{
          capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
          // capStartDateValue = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
        }

        vm.capDates = [];
        var capLastDate = capStartDate;
        while ($window.moment(capLastDate).isBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(capStartDate);
          }
          // capStartDateValue = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          capStartDate = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          if ($window.moment(capStartDate).isBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
            vm.capDates.push(capStartDate);
          }
          else {
            break;
          }
          capLastDate = vm.capDates[vm.capDates.length - 1];
        }
      }
      (vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) && checkOTMAmountAndDate();
     // checkSipValidations();
     if(vm.formData.sipPaymentOption == 'E-mandate'){
      if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == 'SIP' && vm.arnHardcodedData.sipEndDate){
        if($window.moment(vm.endLimit, 'DD-MMM-YYYY').isBefore(vm.formData.endDate)){
          vm.showNPCIDateError = 'As per NPCI Circular NPCI/2023-24/NACH/008, mandate can be registered for a maximum duration of 30 years from the date of issuance.';
        }else{
          vm.showNPCIDateError ='';
        }
      }

       if(vm.formData.endDateEmandate) {
         vm.sipDateLessEmandate =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
         if (vm.sipDateLessEmandate) {
           var setEndDateLess = false;
           var indexSipEndDate = vm.enabledEndDates.length - 1;
           var tempEndDate;
           while (!setEndDateLess) {
             tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
             indexSipEndDate = indexSipEndDate - 1;
             if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY'))) {
               setEndDateLess = true;
               var newEnabledEndDates = angular.copy(vm.enabledEndDates);
               newEnabledEndDates.splice(indexSipEndDate + 1);
               vm.enabledEndDates = angular.copy(newEnabledEndDates);
               if (!calledFromOtherFlow) {
                 vm.formData.endDate = angular.copy(tempEndDate);
                 vm.changeEndDate(vm.formData.endDate);
               }
             }

             if (indexSipEndDate == 0) {
               break;
             }
           }

           if (calledFromOtherFlow) {
             var endDateField =  vm.formData.frequency === 'OW' ? angular.element('#endDateCalenderWeekly') : angular.element('#endDateCalender');
             endDateField.focus();
           }
         }
       }

     }


      if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI && vm.enabledEndDates) {
        var defaultEndDate = $window.moment().add(vm.emandateMaxYear, 'years').subtract(1,'days');
        var sipDateLessUPI =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter(defaultEndDate) ? true : false;
        if (sipDateLessUPI) {
          var setEndDateLess = false;
          var indexSipEndDate = vm.enabledEndDates.length - 1;
          var tempEndDate;
          while (!setEndDateLess) {
            tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
            indexSipEndDate = indexSipEndDate - 1;
            if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(defaultEndDate, 'DD-MMM-YYYY'))) {
              setEndDateLess = true;
              var newEnabledEndDates = angular.copy(vm.enabledEndDates);
              newEnabledEndDates.splice(indexSipEndDate + 1);
              vm.enabledEndDates = angular.copy(newEnabledEndDates);
              vm.formData.endDate = angular.copy(tempEndDate);
              vm.changeEndDate(vm.formData.endDate);
            }

            if (indexSipEndDate == 0) {
              break;
            }
          }
        }
      }
    };


    vm.updateDatesForDaily = function(){
      var currentDay = $window.moment().add(3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.formData.startDate = vm.formData.isBackFromSummary?vm.formData.startDate:vm.enabledStartDates[0];
      vm.formData.day = +(vm.formData.startDate.format('DD'));
      updateEndDates();
    }

    function updateDatesForWeekly() {
      var indexDates = $window.moment();
      var businessDays = [];
      var count = 1;
      //calculating non business days
      for (var i = 1; i <= 90; i++) {
      var indexDate = $window.moment().add(i, 'days').format("DD-MMM-YYYY");
      var isEnable = true;
      if (count <= 5) {
        angular.isArray(vm.nonBusinessDatess) && vm.nonBusinessDatess.forEach(function (value) {
          if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')==0){
            isEnable = false;
          }
        });
       }

       if(isEnable){
         businessDays.push($window.moment().add(i, 'days'));
           count++;
         }
       }
       //setting the 5th day as part of T+5
       var currentDay = businessDays[4];
       currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
       var enabledStartDates = [];
       var _day = vm.daysList.find(function (d) {
         return d === vm.formData.weeklyDay;
       }) || {};
       for (var i = 0; i < 90; i++) {
         var _date = currentDay.clone().add(i, 'days');
        if (($window.moment(vm.startMinDateOTM,"DD-MMM-YYYY").diff(_date.format("DD-MMM-YYYY"),'days')<=0) &&(_date.format('dddd').toLowerCase() === _day.toLowerCase())) {
          enabledStartDates.push(_date.clone());
        }
       }
       vm.enabledStartDates = angular.copy(enabledStartDates);
       vm.formData.startDate = vm.enabledStartDates[0];
       updateEndDates();
    }

    function updateDatesForOthers() {
      var currentDay = $window.moment();
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.formData.day);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      var tDays = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? 15 : 10;
      while (_diff < tDays) {
        updatedDate.add(1, 'months').set('date', vm.formData.day);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }

      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }

      vm.enabledStartDates = angular.copy(enabledStartDates);
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        calculateMonthsForSip();
      } else {
        vm.formData.startDate = vm.enabledStartDates[0];
      }
      updateEndDates();
    }

    function calculateMonthsForSip() {
      var arr = [];
      for (var i = 0; i < vm.enabledStartDates.length; i++) {
        var str1 = vm.enabledStartDates[i].format('MMM') + ', ' + vm.enabledStartDates[i].format('YYYY');
        var str2 = i;
        arr.push({name: str1, value: str2});

      }
      vm.formData.monthList = arr;
    }

    function updateEndDates(doNotUpdateEndDate,amountDateCheck,calledFromOtherFlow) {
      if (!vm.formData.startDate) {
        return;
      }

      if(vm.formData.sipPaymentOption == "E-mandate" || vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
        vm.formData.isTillPerpetuity=false;
        tempDate = $window.moment(new Date(vm.formData.startDate), 'DD-MMM-YYYY');
        var defaultEndDate = $window.moment(new Date(tempDate), "DD-MM-YYYY").add(vm.emandateMaxYear, 'years');
      }else{
        var defaultEndDate = $window.moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      }
      //var defaultEndDate = new Date(2036, 12, 31);
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;

      var frequency = vm.frequencyList.find(function (f) {
        return f.code === vm.formData.frequency;
      }) || {};


      switch (vm.formData.frequency) {
        case'BZ':
          var days = 0;
          endDate = vm.formData.startDate.clone();//.add(minInstallments, 'days');
          defaultEndDate.add(1,"days");
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          var days = getMonthsCount(endDate.clone(), defaultEndDate);
          freq = vm.formData.sipPaymentOption === 'E-mandate' ?  defaultEndDate.clone().add(-1, 'days').diff(endDate, 'days', true) : ((defaultMonths * 30) / frequency.duration) + days;
          for (i = 0; i < freq; i++) {
            days = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE || vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            defaultEndDate = defaultEndDate.clone().add(-1, 'days');
            var n =enabledEndDates.length;
            if(n>0 && enabledEndDates[n-1].isBefore(defaultEndDate) ){
                  const date1 = new Date(enabledEndDates[n-1]);
                  const date2 = new Date(defaultEndDate);
                  const diffTime = Math.abs(date2 - date1);
                  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                   for (i = n; i < (n+diffDays-1); i++) {
                    days = frequency.duration * i;
                    if(endDate.clone().add(days, 'days').format("DD-MMM-YYYY") == defaultEndDate.format("DD-MMM-YYYY")){
                      break;
                    }
                    enabledEndDates.push(endDate.clone().add(days, 'days'));
                  }
            }
             n =enabledEndDates.length;
            if(n>0 &&  defaultEndDate.isBefore(enabledEndDates[n-1])){
              enabledEndDates=[];
              for (i = 0; i < freq; i++) {
                days = frequency.duration * i;
                if(endDate.clone().add(days, 'days').format("DD-MMM-YYYY") == defaultEndDate.format("DD-MMM-YYYY")){
                  break;
                }
                enabledEndDates.push(endDate.clone().add(days, 'days'));
              }
            }
          }
          break;
        case'OW':
          var days = 0;
          defaultEndDate =defaultEndDate?new Date(defaultEndDate): new Date("12/31/2099");
          freq = UtilService.getNumberOfWeeks(vm.formData.startDate.toDate(), defaultEndDate);
          for (i = 0; i <= freq; i++) {
            days = frequency.duration * i;
            enabledEndDates.push(vm.formData.startDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          endDate = vm.formData.startDate.clone().add(frequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.duration);
          for (i = 0; i < freq; i++) {
            months = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
      vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      vm.enabledEndDateView=angular.copy(vm.enabledEndDates[0]);
      if(vm.formData.sipPaymentOption == 'E-mandate' || vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
        vm.endLimit =  vm.enabledEndDates? vm.enabledEndDates[vm.enabledEndDates.length-1]:null;
        if(vm.enabledEndDates && vm.arnHardcodedData && vm.arnHardcodedData.transactionType == 'SIP' && vm.arnHardcodedData.sipEndDate){
          if($window.moment(vm.enabledEndDates[vm.enabledEndDates.length-1], 'DD-MMM-YYYY').isBefore(vm.arnHardcodedData.sipEndDate)){
              vm.showNPCIDateError = 'As per NPCI Circular NPCI/2023-24/NACH/008, mandate can be registered for a maximum duration of 30 years from the date of issuance.';
              vm.formData.endDate = null;
          }else{
            vm.showNPCIDateError = '';
            vm.formData.endDate = $window.moment(new Date(vm.arnHardcodedData.sipEndDate), 'DD-MMM-YYYY');
          }
        }else{
          if (!calledFromOtherFlow) {
            vm.formData.endDate = vm.enabledEndDates &&  vm.enabledEndDates.length >0 ? vm.enabledEndDates[vm.enabledEndDates.length-1]: null;
          }
        }

        if (vm.formData.endDate) {
          vm.changeEndDate(vm.formData.endDate,calledFromOtherFlow);
        }
      }else{
          vm.showNPCIDateError = '';
          vm.changeEndDate(vm.formData.endDate);
      }
      if (!doNotUpdateEndDate) {
        if(vm.arnHardcodedData && vm.arnHardcodedData.sipEndDate ){
          vm.setEndDate = moment(vm.arnHardcodedData.sipEndDate);
          $timeout(function () {
            if(vm.showNPCIDateError == ''){
              var EndDate = moment(vm.arnHardcodedData.sipEndDate);
              vm.changeEndDate(EndDate);
            }else{
              vm.formData.endDate = null;
            }
          }, 1000);
          vm.formData.minEndDate = vm.setEndDate;
        }else{
          vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
        }
      } else {
        if(vm.arnHardcodedData){
          vm.setEndDate = moment(vm.arnHardcodedData.sipEndDate);
          $timeout(function () {
            if(vm.showNPCIDateError == ''){
              var EndDate = moment(vm.arnHardcodedData.sipEndDate);
              vm.changeEndDate(EndDate);
            }else{
              vm.formData.endDate = null;
            }
          }, 1000);
          vm.formData.minEndDate = vm.setEndDate;
        }else{
          vm.formData.minEndDate = angular.copy(vm.enabledEndDates[0]);
        }
    }

    if (amountDateCheck && vm.formData.endDate && (($window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates[0]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates.length - 1))))) {
      if (vm.formData.endDate.isSame($window.moment(vm.endDateDefaultForPertuity))) {
        vm.formData.isTillPerpetuity = true;
      } else {
        vm.formData.isTillPerpetuity = false;
      }
    } else if(vm.formData.sipPaymentOption !== 'E-mandate' && vm.formData.sipPaymentOption !== 'UPI') {
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = true;
      vm.changeTillPerpetuityFlag();
      if(vm.arnHardcodedData){
        if(!vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate){
          vm.formData.isTillPerpetuity=true;
          vm.changeTillPerpetuityFlag();
        }else{
          vm.formData.isTillPerpetuity=false;
        }
      }else{
        vm.formData.isTillPerpetuity=true;
        vm.changeTillPerpetuityFlag();
      }
    }

      //reSetting();
    }

    function getDaysList() {
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        return vm.TRANSACTIONS_CONST.SIP_DAYS_LIST;
      } else {
        return vm.TRANSACTIONS_CONST.DAYS_LIST;
      }

    }

    function changeFrequency() {
      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        vm.formData.day = null;
        vm.formData.weeklyDay = null;
        vm.formData.month = null;
        vm.authenticationMode = null;
        vm.formData.isTillPerpetuity = false;
        vm.formData.bankInfo = null;
        resetBankDetails();
        reSetting();
      }
      vm.disableEndDateSelection = false;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      if(angular.isDefined($stateParams.trxnType) && $stateParams.trackId && vm.formData.amount){
        vm.formData.amount = vm.formData.amount;
      }else{
      vm.formData.amount = vm.arnHardcodedData && vm.arnHardcodedData.amount ? vm.arnHardcodedData.amount : vm.formData.amount;
      }
      vm.resetNumInWords();
      checkValidations();
      if (vm.formData.frequency === 'BZ') {
        // vm.daysList = null;
        vm.viewMode = 'days';
        vm.formData.showTopUpBlock = false;
        vm.updateDatesForDaily();
        if(vm.restrictOTMEmandate){
          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
          hideUPIDetails();
          vm.formData.sipPaymentOption = vm.paymentOptions[0];
          vm.changedPaymentOption();
        }else{
          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
        }
        hideUPIDetails();
        if(vm.formData.sipPaymentOption === vm.paymentOptions[1]) {
          vm.formData.sipPaymentOption = vm.paymentOptions[1];
          vm.changedPaymentOption();
        } else {
          // if(vm.isEMandateEnabled) {
          //   vm.formData.sipPaymentOption = vm.paymentOptions[1];
          //   vm.changedPaymentOption();
          // } else {
            vm.formData.sipPaymentOption = vm.paymentOptions[0];
            vm.changedPaymentOption();
          // }
        }
        $timeout(function(){
          vm.formData.sipPaymentOption = vm.formData.sipPaymentOption ? vm.formData.sipPaymentOption : vm.paymentOptions[0];
          //fetchBankList();
        },100);
        changeFirstInstallment(false);
        checkEMandate();
        if(vm.restrictOTMEmandate){
          if (vm.paymentOptions[0] == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            vm.changedPaymentOption();
          }
        }
      } else if (vm.formData.frequency === 'OW') {
        checkEMandate(function() {
          changeFirstInstallment(false);
          if (vm.isEMandateEnabled && vm.isOTMEnabled) {
            if(vm.restrictOTMEmandate){
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
              hideUPIDetails();
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
              vm.changedPaymentOption();
            }else{
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            }
          } else if (vm.isEMandateEnabled && !vm.isOTMEnabled) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
          } else if (!vm.isEMandateEnabled && vm.isOTMEnabled) {
            if(vm.restrictOTMEmandate){
              vm.paymentOptions = [];
              vm.formData.sipPaymentOption = null;
            }else{
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
            }
          }
          hideUPIDetails();
          vm.viewMode = 'days';
          vm.formData.showTopUpBlock = false;
          if (vm.formData.sipPaymentOption === vm.paymentOptions[1]) {
            vm.formData.sipPaymentOption = vm.paymentOptions[1];
            vm.changedPaymentOption();
          } else {
            vm.formData.sipPaymentOption = vm.paymentOptions[0];
            vm.changedPaymentOption();
          }
          //fetchBankList();
        });
        if(vm.inSchemeValidations.cgfFlag && !vm.isOTMEnabled) {
          if(vm.formData.minorFlag && vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank ){
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            vm.formData.sipPaymentOption = vm.paymentOptions[0];
          }else{
            vm.paymentOptions = [];
            vm.formData.sipPaymentOption = null;
          }
        } else if(vm.inSchemeValidations.cgfFlag && vm.isOTMEnabled) {
          if(vm.restrictOTMEmandate){
            vm.paymentOptions = [];
            vm.formData.sipPaymentOption = null;
          }else{
          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM];
          }
          hideUPIDetails();
          vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;

        }
        if(vm.restrictOTMEmandate){
          if (vm.paymentOptions[0] == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            vm.changedPaymentOption();
          }
        }
      } else {
        vm.daysList = getDaysList();
        vm.viewMode = 'months';
        if(!vm.checkForMinorBankListCondition())
          vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
        hideUPIDetails();
        if(vm.isOTMEnabled=== true){
          if(vm.restrictOTMEmandate){
          }else{
            if (vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) {
              vm.paymentOptions.splice(vm.paymentOptions.length - 1,1);
            }
            vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM);
            if (!vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) {
              vm.paymentOptions.unshift(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
            }
            hideUPIDetails();
          }
        }
        if (vm.isEMandateEnabled) {
            if (vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) {
              vm.paymentOptions.splice(vm.paymentOptions.length - 1,1);
            }
            // vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
            paymentOptionOrdering();
          if (!vm.paymentOptions.includes(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) {
            vm.paymentOptions.unshift(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
          }
          hideUPIDetails();
            if(vm.restrictOTMEmandate){
              if(!vm.sipFirstInstallment){
                vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
                hideUPIDetails();
                vm.formData.sipPaymentOption = vm.paymentOptions[0];
              }else{
              if (vm.paymentOptions[1]) {
                if(vm.formData.investmentType == 'SIP'){
                  vm.formData.sipPaymentOption = vm.paymentOptions[1];
                }else{
                  vm.formData.sipPaymentOption = vm.paymentOptions[0];
                }
                  vm.changedPaymentOption();
              } else {
                vm.formData.sipPaymentOption = vm.paymentOptions[0];
              }
             }
            }
        }
        if(vm.restrictOTMEmandate){
          if (vm.paymentOptions[1]) {
            if(vm.formData.investmentType == 'SIP'){
              vm.formData.sipPaymentOption = vm.paymentOptions[1];
            }else{
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
            }
              vm.changedPaymentOption();
          } else {
            vm.formData.sipPaymentOption = vm.paymentOptions[0];
          }
        }
        else{
          vm.formData.sipPaymentOption = vm.formData.sipPaymentOption ? vm.formData.sipPaymentOption : vm.paymentOptions[0];
          vm.formData.sipPaymentOption = vm.paymentOptions[0];
        }
        // fetchBankList();
        checkEMandate();
        changeFirstInstallment(false);
        getDateValidation();
      }

      if(vm.isBackFromSummary){
        checkOTM();
      }
      fetchBankList();
    }

    function resetBankDetails() {
      vm.formData.bankCity = '';
      vm.formData.bankBranch = '';
      vm.formData.bankAcNo = '';
      vm.formData.verifyBankAcNo = '';
    }

    vm.changedPaymentOption = function () {

      if ((vm.arnHardcodedData || vm.PARTNER_DATA) && vm.formData.sipPaymentOption=='UPI') {
        vm.formData.sipPaymentOption = vm.paymentOptions[0];
      }

      if(vm.formData.sipPaymentOption=='UPI' && vm.formData.amount > vm.upiLimit) {
        var success = function() {
          if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if(vm.paymentOptions.includes("E-mandate") && vm.isEMandateEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE;
          } else if(vm.paymentOptions.includes("EC")){
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          } else {
            vm.formData.sipPaymentOption = null;
          }
          vm.changedPaymentOption();
        }
        ModalService.genericModal({
          text: vm.upiErrorMessage,
          isUpi: true
        },success);

      }


      if ((vm.formData.sipPaymentOption=='UPI' || vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) && !vm.emandateObj) {
        UtilService.fetchMandateValidations().then(function (resp) {
          vm.emandateUpiData = resp;
          if (vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
            vm.emandateObj = vm.emandateUpiData.eOTM;
          } else if (vm.formData.sipPaymentOption=='UPI') {
            vm.emandateObj = vm.emandateUpiData.upi;
          }
          setEmandateUpiSetting();
        }).catch(function(resp) {
          MessageService.error(resp)
        });
      }

      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        vm.formData.day = null;
        vm.formData.isTillPerpetuity = false;
        vm.formData.authMode = null;
        vm.authenticationMode = null;
        vm.enabledBillerStartDatesList=null;
        vm.formData.weeklyDay = null;
        reSetting();
      }
      if (vm.arnHardcodedData) {
        if (!vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate) {
          if (vm.formData.frequency != "OW") {
              vm.formData.startDate = $window.moment(vm.startMinDateBiller);
              vm.updateEndDates();
              vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
              if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                vm.formData.isTillPerpetuity=true;
              }
              vm.changeTillPerpetuityFlag();
          }
        } else {
          if (vm.formData.frequency != "OW") {
            if (vm.formData.frequency == vm.arnHardcodedData.frequency) {
              if(vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate){
              vm.formData.startDate = moment(vm.arnHardcodedData.sipStartDate);
              vm.updateEndDates();
              vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
              if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                vm.formData.isTillPerpetuity=true;
              }
              vm.changeTillPerpetuityFlag();
              }
              if(vm.arnHardcodedData.sipStartDate && vm.arnHardcodedData.sipEndDate){
                vm.formData.startDate =moment(vm.arnHardcodedData.sipStartDate);
                vm.updateEndDates();
                vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
                vm.setEndDate = moment(vm.arnHardcodedData.sipEndDate);
                $timeout(function () {
                  if(vm.showNPCIDateError == ''){
                    var EndDate = moment(vm.arnHardcodedData.sipEndDate);
                    vm.changeEndDate(EndDate);
                  }else{
                    vm.formData.endDate = null;
                  }
                     vm.updateEndDates();
                }, 1000);
                vm.formData.minEndDate = vm.setEndDate;
              }
              if(!vm.arnHardcodedData.sipStartDate && !vm.arnHardcodedData.sipEndDate){
                vm.formData.startDate = $window.moment(vm.startMinDateBiller);
                vm.updateEndDates();
                vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
                if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                  vm.formData.isTillPerpetuity=true;
                }
                vm.changeTillPerpetuityFlag();
              }
            } else {
              vm.formData.startDate = $window.moment(vm.startMinDateBiller);
              vm.updateEndDates();
              vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
              if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
                vm.formData.isTillPerpetuity=true;
              }
              vm.changeTillPerpetuityFlag();
            }
          }
        }
      } else {
        if (vm.formData.frequency != "OW") {
          vm.formData.startDate = $window.moment(vm.startMinDateBiller);
          vm.updateEndDates();
          vm.formData.day = vm.formData.startDate ? vm.formData.startDate .format('D') : '';
          if(vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI"){
            vm.formData.isTillPerpetuity=true;
          }
          vm.changeTillPerpetuityFlag();
        } else {
          vm.formData.startDate = null;
          vm.formData.endDate = null;
        }
      }
      if (vm.arnHardcodedData) {
      if(vm.arnHardcodedData.frequency == "OW"){
        if(vm.formData.frequency == "OW"){
          if(vm.arnHardcodedData.sipStartDate){
            vm.formData.startDate = vm.arnHardcodedData.sipStartDate;
          }
          if (vm.formData.startDate) {
            vm.changeStartDate(moment(vm.formData.startDate));
            if (vm.arnHardcodedData.frequency == "OW") {
              vm.Day = vm.formData.startDate.day();
              switch (vm.Day) {
                case 1:
                  vm.formData.weeklyDay = "Monday";
                  break;
                case 2:
                  vm.formData.weeklyDay = "Tuesday";
                  break;
                case 3:
                  vm.formData.weeklyDay = "Wednesday";
                  break;
                case 4:
                  vm.formData.weeklyDay = "Thursday";
                  break;
                case 5:
                  vm.formData.weeklyDay = "Friday";
                  break;
                case 6:
                  vm.formData.weeklyDay = "Saturday";
                  break;
                case 7:
                  vm.formData.weeklyDay = "Sunday";
                  break;
              }
            }
          }
        }
      }


      }

      vm.disableEndDateSelection = false;
      vm.formData.bankInfo = null;
      vm.formData.otmId = '';
      vm.isOtmVisible = false;
      vm.formData.otmOtpVerified = vm.formData.otmOtpVerified === true ? vm.formData.otmOtpVerified: false;
      vm.isOtmOtpVerified = vm.formData.otmOtpVerified === true ? vm.formData.otmOtpVerified : false;
      vm.formData.ifscCode = null;
      vm.formData.accountType = null;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      if (vm.emandateUpiData && vm.emandateObj) {
        if (vm.formData.sipPaymentOption==vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          vm.emandateObj = vm.emandateUpiData.eOTM;
        } else if (vm.formData.sipPaymentOption=='UPI') {
          vm.emandateObj = vm.emandateUpiData.upi;
        }
        setEmandateUpiSetting();
      }
      fetchBankList();
      vm.resetUPIForm();
      checkEMandateValidation();
      checkOTMAmountAndDate();
      if (vm.formData.sipPaymentOption === "E-mandate" && vm.enabledEmandateEndDatesList) {
        vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
        changeEndDateEmandate(vm.formData.endDateEmandate);
      }
    };
    vm.OtmAmountMax = false;
    vm.changeBank = function () {
      vm.showIFSCField = vm.formData.bankInfo.ifscCode ? false : true;
      vm.showAccountTypeField = vm.formData.bankInfo.bankAcType ? false : true;
      if (vm.showAccountTypeField) {
        getAccountType();
      }

      switch (vm.formData.sipPaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC:
          vm.isInvalidForm = false;
          vm.formData.netBankingUrl = vm.formData.bankInfo && vm.formData.bankInfo.netBankingUrl?vm.formData.bankInfo.netBankingUrl:'';
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:
          vm.formData.authMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes[0] : null;
          vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
          vm.formData.bankAcNo = vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '';
          vm.formData.emUmrn = vm.formData.bankInfo ? vm.formData.bankInfo.emUmrn : '';
          vm.formData.maxAmount = vm.formData.bankInfo ? vm.formData.bankInfo.maxAmount : '';
          vm.formData.emExpiryDate = vm.formData.bankInfo ? vm.formData.bankInfo.emExpiryDate : '';
          vm.isInvalidForm = false;
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          if(vm.formData.bankInfo && !vm.formData.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({instantInvestment:true});
            vm.formData.bankInfo = null;
            return;
          };
          if( vm.formData.bankInfo) {
            vm.formData.otmId = vm.formData.bankInfo.otmId;
            vm.formData.bankName = vm.formData.bankInfo.bankName;
            vm.formData.bankBranch = vm.formData.bankInfo.bankBranch;
            vm.formData.bankAcNo = vm.formData.bankInfo.bankAcNo;
            vm.formData.ifscCode = vm.formData.bankInfo.ifscCode;
          }
          vm.isInvalidForm = false;
          if(vm.formData.investmentType == "Schedule_Transaction"){
            if(vm.formData.startDate){
              vm.formData.startDate = '';
            }
            if(vm.formData.endDate){
              vm.formData.endDate = '';
            }
          }
          if(( vm.formData.bankInfo && vm.formData.bankInfo.otmFrequency !== 'AWP') && (vm.formData.frequency === 'BZ')){
            vm.isInvalidForm = true;
            MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
          }
          delete vm.formData.netBankingUrl;
          if(  vm.formData.bankInfo && !vm.formData.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({instantInvestment:true});
            return;
          };
          checkOTMAmountAndDate();
          break;
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          if(  vm.formData.bankInfo && !vm.formData.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            ModalService.minorBankModal({instantInvestment:true});
            return;
          };
        default :
          vm.formData.netBankingUrl = vm.formData.bankInfo && vm.formData.bankInfo.netBankingUrl?vm.formData.bankInfo.netBankingUrl:'';
          vm.formData.bankName = '';
          vm.formData.otmId = '';
          break;
      }

      resetBankDetails();   // need for sip transaction

      if(vm.formData && vm.formData.sipPaymentOption == "OTM" && vm.formData.investmentType == "Schedule_Transaction" &&
      vm.formData.bankInfo && vm.formData.bankInfo.maxAmount && vm.formData.purchaseAmount &&
      vm.formData.purchaseAmount > vm.formData.bankInfo.maxAmount){
        vm.OtmAmountMax = true;
      }else{
        vm.OtmAmountMax = false;
      }
    };
/* check biometric false and purchase amount not greater than 50,000 */
    function isBiometrycCheckFailed(){
      return !vm.token.biometricVerified && (vm.maxAmount < vm.formData.purchaseAmount) ? true : false;
    }

    vm.goToSummary = function () {
      if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler"){
        vm.isCheckedTandC =false
        vm.email = vm.token && vm.token.email ? vm.maskEmail(vm.token.email) : 'N/A';
        vm.mobileNumber = vm.token && vm.token.mobileNumber ? vm.maskemobileNo(vm.token.mobileNumber) : 'N/A';
      }
      if (vm.formData.investmentType == 'PURCHASE' &&  isBiometrycCheckFailed()) {
        MessageService.error('Sorry! You can not invest further as you are exceeding investment amount of 50,000 ' +
          'for the current financial year. Get you biometric verification done to invest further.');
        return false;
      }
      // vm.formData.isBackFromSummary = true;
      vm.isRequired = true;
      vm.isSaving = false;
      $state.$previous = $state.current;
      $timeout(function () {
        //  if (vm.tForm.$valid) {
        var payloadData = vm.isSaving ? getSipPurchasePayloadToSave() : getSipPurchasePayloadToSubmit();
        if (!payloadData) {
          return;
        }
        if(vm.formData.investmentType == "Schedule_Transaction" ){
          vm.formData.endDate = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY');
          vm.formData.emandateDate = $window.moment(vm.formData.emandateDate, 'DD-MMM-YYYY');
          vm.formData.startDate =$window.moment(vm.formData.startDate, 'DD-MMM-YYYY');
          vm.formData.endDateEmandate =$window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY');
        }
        TransactionModel.setPayloadRawData(payloadData);
        if (vm.formData.investmentType == 'PURCHASE') {
          /*if (vm.formData.purchaseInSchemeName && vm.formData.purchaseInSchemeName.includes('Children')) {
            var success = function () {
                vm.beforeSummary(vm.cutoffData);
              },
              error = function () {

              };
            var message = AppConstants.TRANSACTIONS.CGF_SCHEME_MSG;
            ModalService.childrenFundMessage({message: message}, success, error);
          } else {
            vm.beforeSummary(vm.cutoffData);
          }*/
          vm.beforeSummary(vm.cutoffData);
        } else {
          /*if (vm.formData.inSchemeName && vm.formData.inSchemeName.includes('Children')) {
            success = function () {
              vm.beforeSummary(vm.cutoffData);
              },
              error = function () {

              };
            message = AppConstants.TRANSACTIONS.CGF_SCHEME_MSG;
            ModalService.childrenFundMessage({message: message}, success, error);
          } else if (vm.formData.sipFirstInstallment) {
            vm.beforeSummary(vm.cutoffData);
          }
          else {
            vm.beforeSummary(vm.cutoffData);
          }*/
          vm.beforeSummary(vm.cutoffData);
        }
        //  }
      }, 0);
    };

    vm.beforeSummary = function (data) {
      vm.showCutOffModal({cutoffData:data});
     /* var currentTime = $window.moment(new Date(), "HH:mm:ss a");
      var dow = currentTime.format('dddd');
      var d = new Date();
      var message = '';
      var notAllowedDays = ['Saturday', 'Sunday'];
      if (vm.formData.schemeType != 'LIQUID' && notAllowedDays.indexOf(dow) == -1) {
        d.setHours(13);
        d.setMinutes(0);
        d.setSeconds(0);
        var timeToCompareNonLiquid = $window.moment(d, "HH:mm:ss a");
        var status = currentTime.isAfter(timeToCompareNonLiquid);
        status ? vm.showCutOffModal() : vm.moveToSummary();
      } else if (vm.formData.schemeType == 'LIQUID') {
        d.setHours(12);
        d.setMinutes(30);
        d.setSeconds(0);
        var timeToCompareNonLiquid = $window.moment(d, "HH:mm:ss a");
        var status = currentTime.isAfter(timeToCompareNonLiquid);
        status ? vm.showLiquidPurchaseModal() : vm.moveToSummary();
      } else {
        vm.showCutOffModal();
      }*/
    };

    vm.showCutOffModal = function (message) {
      if (message.cutoffData) {
        var success = function () {
          vm.moveToSummary();
        }, error = function () {

        };
        ModalService.cutOffModal({message: message}, success, error);
      } else {
        vm.moveToSummary();
      }
    };

    vm.showLiquidPurchaseModal = function () {
      var success = function () {
        vm.moveToSummary();
      }, error = function () {

      };
      ModalService.liquidPurchaseModal({}, success, error);
    };

    vm.moveToSummary = function () {
      if(vm.formData.investmentType == "Schedule_Transaction"){
        vm.formData.isSummaryViewEnabled = true;
        vm.showPurchaseSchedulerSuccess = true;
        vm.summaryData = angular.copy(vm.formData);
      }else{
        userActivityTracking(function () {
          vm.formData.isSummaryViewEnabled = true;
          if(vm.formData.investmentType == 'REDEMPTION'){
            vm.showRedeemPreview = true;
          }
          if (vm.formData.sipFirstInstallment && vm.isOtmOtpVerified) {
            vm.formData.otmOtpVerified = vm.isOtmOtpVerified;
          }
          vm.summaryData = angular.copy(vm.formData);
        });
      }
    };


    function getSipPurchasePayloadToSave() {
      var sipPayload = {
          installmentAmount: vm.formData.amount,
          investmentOption: vm.validations.investmentOption,
          dividendOption: vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.sipDividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          frequency: vm.formData.frequency,
          schemeType: vm.formData.schemeType,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          toDate: vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
          sipDate: vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
          sipDay: vm.formData.day,
          weeklyDay: vm.formData.weeklyDay? vm.formData.weeklyDay:null,
          brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : '',
          euinOpted: vm.formData.euin ? 'Y' : 'N',
          euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
          euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
          id: vm.formData.sTransactionId,
          compositeTransactionId: $stateParams.ctId ? $stateParams.ctId : '',
          isTillPerpetuityvm: vm.formData.isTillPerpetuity && vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI" ? vm.formData.isTillPerpetuity : false,
          bankDetailsForECS: {
            accNumber: vm.formData.bankAcNo,
            bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
            ifscCode: vm.formData.ifscCode,
            branchName: vm.formData.bankBranch,
            bankCity: vm.formData.bankCity,
            paymentOption: vm.formData.sipPaymentOption,
            otmId: vm.formData.otmId,
            netBankingUrl: vm.formData.netBankingUrl
          }
        },
        purchasePayload = {
          amount: vm.formData.purchaseAmount,
          investmentOption: vm.formData.purchaseInvestmentOption,
          dividendOption: vm.formData.purchaseDividendOption,
          folioNumber: vm.formData.folioNumber,
          schemeType: vm.formData.schemeType,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
          brokerCode: vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : '',
          euinOpted: vm.formData.euin ? 'Y' : 'N',
          euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
          euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
          id: vm.formData.pTransactionId,
          compositeTransactionId: $stateParams.ctId ? $stateParams.ctId : '',
          schemeCode: vm.formData.purchaseInSchemeCode
        };

      if (!sipPayload.investmentOption) {
        sipPayload.investmentOption = vm.formData.sipPaymentOption;
      }

      if (!sipPayload.dividendOption) {
        sipPayload.dividendOption = vm.formData.sipDividendOption;
      }

      if(vm.formData.sipFirstInstallment)
      {
        sipPayload.sipWithFirstInstallment=vm.formData.sipFirstInstallment;
        sipPayload.firstInstallmentDetails={amount:vm.formData.amount};
      }

      var payload = {};

      switch (vm.formData.investmentType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
          payload.purchaseForm = angular.copy(purchasePayload);
          if (vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            payload.sipForm = angular.copy(sipPayload);
          }
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
          payload.sipForm = angular.copy(sipPayload);
          if (vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
            payload.purchaseForm = angular.copy(purchasePayload);
          }
          break;
      }

      return payload;
    }

    function getSipPurchasePayloadToSubmit() {

      if (!vm.validations.investmentOption && (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP )) {
        MessageService.error('Invalid Investment option for sip is selected.');
        return false;
      }
      /*|| vm.formData.optionalInvestmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE*/
      if (!vm.formData.purchaseInvestmentOption && (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE )) {
        MessageService.error('Invalid Investment option for purchase is selected.');
        return false;
      }
      vm.formData.euinOpted= vm.formData.euin && vm.formData.euin.euinCode ? 'Y' : 'N';
      vm.formData.investmentOption = vm.validations.investmentOption;
      vm.formData.dividendOption = vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.dividendOption;
      if (vm.formData.investmentType == 'SIP') {
        vm.formData.dividendOption = vm.formData.sipDividendOption;
      }
      return angular.copy(vm.formData);
    }

    vm.changeTillPerpetuityFlag = function () {
      if (vm.formData.sipPaymentOption != "E-mandate" && vm.formData.sipPaymentOption != "UPI") {
        vm.formData.endDate = null;
        vm.resetting = true;
      }
      $timeout(function () {
        vm.resetting = false;
        if (vm.formData.isTillPerpetuity) {
          // vm.disableEndDateSelection = true;
          var defaultMonths = null;
          var day = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
          var month = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month() + 1;
          var defaultEndate = day + '/'+ month +'/2099';
          var endDate = $window.moment(defaultEndate,"DD-MM-YYYY");
          var freq = vm.validations && vm.validations.maxInstallments || 0;
          var frequency = vm.frequencyList.find(function (f) {
            return f.code === vm.formData.frequency;
          }) || {};

          switch (vm.formData.frequency) {
            case'BZ':
              var day = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
              var endDateYear = $window.moment((vm.enabledEndDates[vm.enabledEndDates.length - 1]), "DD-MMM-YYYY").year();
              if (endDateYear > 2099) {
                endDateYear = 2099
              }
              defaultEndate = month + '/' + day + '/' + endDateYear;
              endDate = $window.moment(new Date(defaultEndate));
              vm.formData.endDate = endDate;

              //check end date exists between enabled end dates
              var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
              if (!isBetween) {

                if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1 < $window.moment(vm.enabledEndDates[0], 'DD-MMM-YYYY').month() + 1) {
                  vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
                } else {
                  endDateYear = endDateYear - 1;
                  if (endDateYear < $window.moment((vm.enabledEndDates[0]), "DD-MMM-YYYY").year()) {
                    vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
                  } else {
                    defaultEndate = month + '/' + day + '/' + endDateYear;
                    endDate = $window.moment(new Date(defaultEndate));
                    vm.formData.endDate = endDate;
                  }
                }
              }
              break;
            case'OW':
              // var days = 0;
              defaultEndate = month + '/31' + '/2099';
              endDate = new Date(defaultEndate);
              var startDate = vm.formData.startDate.toDate();
              var weeksDiff = UtilService.getNumberOfWeeks(startDate,endDate);
              vm.formData.endDate = vm.formData.startDate.clone().add(weeksDiff*7, 'days');
              break;
            default :

              var endday = moment().date();
              var endmonth = moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
              var endnewEndDate = endday + '/'+ (endmonth + 1) +'/2099';
              var endDate = $window.moment(endnewEndDate, "DD-MM-YYYY");
              if (!moment(endDate).isValid()) {
                var initialStartDate = vm.formData.startDate.clone().day(1)
                endDate = initialStartDate.endOf(endmonth + 1).year(2099);
              }

              // var months = 0;
              defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate.clone().add(frequency, 'months'), $window.moment(endDate));
              freq = freq || Math.floor(defaultMonths / frequency.duration);
              freq = vm.validations && vm.validations.maxInstallments ? freq - 1 : freq;
              var months = frequency.duration * freq;
              vm.formData.endDate = vm.formData.startDate.clone().add(months, 'months');

              var calculatedEndDateMonth = moment(vm.formData.endDate, 'DD-MMM-YYYY').month();

              if(calculatedEndDateMonth > (month - 1)) {
                var endDateCalculated = angular.copy(vm.formData.endDate);
                var checkDate = angular.copy(endDateCalculated.set('month', (month - 1)));

                var DateisBetween = $window.moment(checkDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))
                if (DateisBetween) {
                  vm.formData.endDate = checkDate;
                }

              }
              break;
          }
          if(vm.formData.sipPaymentOption == 'E-mandate'){
            vm.endLimit =  vm.enabledEndDates? vm.enabledEndDates[vm.enabledEndDates.length-1]:null;
            if(vm.enabledEndDates && vm.arnHardcodedData && vm.arnHardcodedData.transactionType == 'SIP' && vm.arnHardcodedData.sipEndDate){
              if($window.moment(vm.enabledEndDates[vm.enabledEndDates.length-1], 'DD-MMM-YYYY').isBefore(vm.arnHardcodedData.sipEndDate)){
                  vm.showNPCIDateError = 'As per NPCI Circular NPCI/2023-24/NACH/008, mandate can be registered for a maximum duration of 30 years from the date of issuance.';
                  vm.formData.endDate = null;
              }else{
                vm.showNPCIDateError ='';
                vm.formData.endDate = $window.moment(new Date(vm.arnHardcodedData.sipEndDate), 'DD-MMM-YYYY');
              }
            }else{
              vm.formData.endDate =  vm.enabledEndDates && vm.enabledEndDates.length >0 ? vm.enabledEndDates[vm.enabledEndDates.length-1]: null;
            }
         }else{
          vm.showNPCIDateError = '';
          if (vm.validations && vm.validations.maxInstallments && vm.formData.frequency !== 'OW') {
            var lastEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
            var EndDatemonth = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').month() + 1);
            var EndDateYear = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').year());

            var EndDateCalculatedMonth = angular.copy(moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1);
            var EndDateCalculatedYear = angular.copy(moment(vm.formData.endDate, 'DD-MMM-YYYY').year());

            if (EndDateCalculatedYear <= EndDateYear) {
              if (EndDatemonth < EndDateCalculatedMonth) {
                if (moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                  EndDateYear = EndDateYear - 1;
                  var newEndDate = day + '/'+ month +'/' + EndDateYear;
                  vm.formData.endDate = $window.moment(newEndDate, "DD-MM-YYYY");
                }
                var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                if (!isBetween) {
                  vm.formData.endDate = angular.copy(lastEndDate);
                }
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              } else if (EndDatemonth === EndDateCalculatedMonth) {
                if (moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                  EndDateYear = EndDateYear - 1;
                  var newEndDate = day + '/'+ month +'/' + EndDateYear;
                  vm.formData.endDate = $window.moment(newEndDate, "DD-MM-YYYY");
                }
                var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                if (!isBetween) {
                  vm.formData.endDate = angular.copy(lastEndDate);
                }
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              } else {
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              }
            } else if ((EndDateCalculatedYear > EndDateYear)) {
              if (EndDateCalculatedYear <= 2099) {
                vm.formData.endDate.set('year', EndDateYear);
              } else {
                vm.formData.endDate.set('year', 2099);
              }

            }
          }
          vm.endDateDefaultForPertuity = vm.formData.endDate;
          vm.changeEndDate(vm.formData.endDate);
          }
        } else {
          vm.disableEndDateSelection = false;
          // vm.formData.startDate && updateEndDates();
        }
      }, 0);
    };

    vm.isCheckedEuin = function () {
      if (vm.isCheckedTandC) {
        vm.formData.euin = '';
      }
    };

    vm.isSelectEuin = function () {
      if (vm.formData.euin) {
        vm.isCheckedTandC = false;
      }
    };

    function checkOTMAmountAndDate() {
      vm.isOTMAmount= false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      // Check Ammout
      if(vm.formData.amount && (vm.formData.amount >  (vm.formData.bankInfo && vm.formData.bankInfo.maxAmount))){
        vm.isOTMAmount= true;
      }else{
        vm.isOTMAmount= false;
      }

      //Compare Start Dates
      if (!(vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore(vm.formData.startDate))) {
        if(vm.formData.startDate ==  null)
        {
          vm.isOTMStartDate = false;
        }
        else {
          vm.isOTMStartDate = true;
        }
      }
      else{
        vm.isOTMStartDate = false;
      }
      if (vm.formData.bankInfo && vm.formData.bankInfo.omExpiryDate && $window.moment(vm.formData.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isBefore(vm.formData.startDate)) {
        vm.isOTMDate = true;
      }
      else {
        vm.isOTMDate = false;
      }
      //Compare End Dates
      if (vm.formData.bankInfo && vm.formData.bankInfo.omExpiryDate && $window.moment(vm.formData.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isBefore(vm.formData.endDate)) {
        vm.isOTMEndDate = true;
      }
      else {
        vm.isOTMEndDate = false;
      }
      //Check for amount or date
      if (vm.isOTMAmount || vm.isOTMDate || vm.isOTMEndDate) {
        vm.isInvalidForm = true;
      } else {
        vm.isInvalidForm = false;
      }

    }
    localStorage.setItem('isRefreshing', false);
    var resetFlag = function () {
      $timeout(function () {
        localStorage.setItem('isRefreshing', false);
      }, 2000);
    };
    function setListeners() {
      removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function () {
        if (localStorage.getItem('isRefreshing') === 'true') {
          return;
        }
        localStorage.setItem('isRefreshing',true);
        var token = AuthService.getInstaToken();

        if (!token) {
          AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
          $timeout(function () {
            $state.go('instantLogin');
          },0);
          resetFlag();
          return;
        }



        if (token && token.refresh_token) {
          AuthService.getRefreshToken4Insta(token).then(function () {
            if(localStorage.getItem('doLogOut')){
              AuthService.logout().then(function () {
                AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
                $state.go('instantLogin');
              }, function () {
                $state.go('instantLogin');
              });
            }else{
              resetFlag();
              $state.reload();
            }
          }, function () {
            AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
            MessageService.clear();
            $state.go('instantLogin');
            resetFlag();
          });
        } else {
          resetFlag();
          // AuthService.getRefreshToken(token).then(function () {
          AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
          MessageService.clear();
          $state.go('instantLogin');
          // })
        }
      });

    }

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';

    }

    /*
    * Function responsible to set invest through check
    * */
    function manipulateInvestThrough(investThrough) {
      if (investThrough === 'DIRECT') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isThroughRia = false;
        vm.formData.isDirect = true;
      } else if (investThrough === 'ARN') {
        vm.formData.isThroughDistributor = true;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = false;
      } else if (investThrough === 'RIA') {
        vm.formData.isThroughDistributor = false;
        vm.formData.isDirect = false;
        vm.formData.isThroughRia = true;
      }
    }

    /*
    * Function responsible to reset value set for RIA code
    * */
    function resetRIAValues() {
      vm.formData.brokerCode = '';
      vm.formData.brokerName = '';
      vm.formData.distributorName = '';
      vm.isCheckedTandC = false;
      vm.isArnSuccess = true;
    }

     function checkEndPopup(endDate,startDate) {
       if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showpopup = true;
        } else {
          vm.showpopup = false;
        }
     }

    vm.isSelectedEuin = true;

    vm.filterEuinList = function () {
      vm.formData.euin = {};
      vm.isSelectedEuin = false ;
      if(vm.euinData.euinNameCode){
        if(vm.euinData.euinNameCode.length>=3){
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.euinData.euinNameCode);
        }
      }
      vm.euinList = vm.euinData.euinNameCode == '' || vm.euinData.euinNameCode == undefined || vm.euinData.euinNameCode.length<3 ? vm.euinMasterList : vm.euinList;
    }

    vm.selectEuin = function(data) {
      $(".dropdown-content").hide();
      if (!data) {
        vm.euinDesable = false;
        vm.euinData.euinNameCode = '';
        return;
      }
      vm.euinData = {};
      vm.euinData.euinNameCode = data.euinNameCode;
      vm.isSelectedEuin = vm.euinData.euinNameCode ? true : false;
      if(data){
        if(vm.arnHardcodedData){
          vm.formData.euin =  data;
          vm.formData.euinOpted = "Y";
          if(vm.arnHardcodedData.arn && vm.arnHardcodedData.euin){
            vm.euinDesable = true;
          }
        }else{
          vm.formData.euin =  data;
          vm.euinDesable = false;
        }
      }else{
        vm.formData.euin = {};
        vm.formData.euinOpted = "N";
      }
    }

    function resendOtp() {
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.otpResendMessage = 'OTP sent again successfully.';
          vm.otmOtp = null;
          resetTimer();
        } else {
          vm.otpResendMessage = '';
          MessageService.error(resp.message)
        }
        vm.isProcessing = false;
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.otpResendMessage = '';
        vm.isProcessing = false;
        UtilService.errorHandler(err);
      };
      IIHttpService.post({
        child1: 'instant',
        child2: 'investment',
        child3: 'payment',
        child4: 'otm',
        child5: 'resend',
        child6: 'otp'
      }, {
        id: vm.otpId
      }).$promise.then(success, error);
    }

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.resendOtpCounter);
    }
    vm.otmGenerated = false;
    function generateOtp() {
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.otpSentMessage = resp.data.message || "OTP has been sent to your registered Email ID.";
          vm.otpId = resp.data.id;
          vm.isOtmVisible = true;
          otmSubmitCount = 1;
          vm.otmGenerated = true;
        } else {
          MessageService.error(resp.message);
          vm.isOtmVisible = false;
          vm.otmGenerated = false;
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.otmGenerated = false;
      };
      if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler"){
        vm.isOtmOtpVerified = true;
          vm.formData.otmOtpVerified = vm.isOtmOtpVerified;
          vm.isOtmVisible = false;
          otmSubmitCount = 1;
      }else{
        IIHttpService.get({
          child1: 'instant',
          child2: 'investment',
          child3: 'payment',
          child4: 'otm',
          child5: 'otp'
        }).$promise.then(success, error);
      }
    }

    var otmSubmitCount = 1;
    function submitOtmOtp() {
      var payload = {
        otp: vm.otmOtp,
        id: vm.otpId
      };
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.isOtmOtpVerified = true;
          vm.formData.otmOtpVerified = vm.isOtmOtpVerified;
          vm.isOtmVisible = false;
          otmSubmitCount = 1;
        }
        else {
          vm.isOtmOtpVerified = false;
          vm.formData.otmOtpVerified = vm.isOtmOtpVerified;
          otmSubmitCount++;
          if (otmSubmitCount === 7 ) {
            vm.isOtmVisible = false;
          }
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      },
      error = function () {
        vm.isOtmOtpVerified = false;
        vm.formData.otmOtpVerified = vm.isOtmOtpVerified;
        vm.isOtmVisible = true;
        LoaderService.hideLoader();
      };
      LoaderService.showLoader();
      IIHttpService.post({
        child1: 'instant',
        child2: 'investment',
        child3: 'payment',
        child4: 'otm',
        child5: 'otp',
        child6: 'confirm'
      }, payload).$promise.then(success, error);
    }

    function schemeGroupCodeList(schemeList , schemeType) {
      var success = function (resp) {
        if (resp.data && resp.status){
          vm.schemeCodeList = resp.data;
          if(vm.arnHardcodedData && vm.arnHardcodedData.SCHEMEWISECAMP){
            vm.schemeCodeList = resp.data.schemes;
          }
          var schemeCodeList=[];
          if (schemeList && vm.schemeCodeList) {
            var key = 0;
            vm.schemeCodeList.forEach(function(item){
              var data =
              schemeList.filter(function(data){
                if(vm.arnHardcodedData && vm.arnHardcodedData.SCHEMEWISECAMP){
                  return data.schemeCode == item.schemeCode
                }else{
                  return data.schemeCode == item.schemeCd
                }
              })[0];
             if(data !== undefined) {
              schemeCodeList[key] = data;
              key= key+1;
            }
            })
            if(schemeType == 'sip'){
              vm.masterInSchemeList = null;
              vm.masterInSchemeList = schemeCodeList;
              vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
          }
          if(schemeType == 'purchase'){
            vm.masterPurchaseInSchemeList = null;
            vm.masterPurchaseInSchemeList = schemeCodeList;
            vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
          }
        }
      }
      }, error = function (err) {
        UtilService.errorHandler(err);
      }
      if(vm.arnHardcodedData && vm.arnHardcodedData.SCHEMEWISECAMP){
        InvestorService.post({ child1: "arnHardCode", child2: "schemeList" }, {
          folioNumber: vm.formData.folioNumber ? vm.formData.folioNumber : null,
          schemeCode: vm.arnHardcodedData.schemeGroupCode,
          arnFlag: vm.formData.isThroughDistributor ? vm.formData.isThroughDistributor : false
        }).$promise.then(success, error);
      }else{
        IIHttpService.post({
          child1: 'getListOfSchemes',
        }, { schemeCode: vm.arnHardcodedData.schemeGroupCode}).$promise.then(success, error);
      }
    }
    function getAccountType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.accountTypeList = resp.data.bankAccountTypes;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        $log.info('Account type Errror>>>>', err);
      };
      InvestorService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list',
        child4:  vm.token.inptType
      }).$promise.then(success, error);
    }

    vm.changeAccountype = function () {
      if (!vm.accountType) {
        return;
      }
    };

    function _setPurchaseDividendOptionsVali(purchaseValidations) {
      vm.purchaseValidations = purchaseValidations;
      vm.isSchemeTypeELSS = (vm.purchaseValidations && vm.purchaseValidations.schemeType == "ELSS") ? true : false;
      vm.formData.purchaseInvestmentOption = vm.purchaseValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : (vm.formData.purchaseInvestmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH && vm.formData.purchaseInvestmentOption || vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
      vm.formData.cgfFlag = vm.purchaseValidations  ? vm.purchaseValidations.cgfFlag:null;
      vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
        if(vm.purchaseValidations.isGrowth){
          vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
        }else {
          /*if((vm.formData.purchaseDividendOption !== vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH && vm.formData.purchaseDividendOption)
            || (vm.purchaseValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED)
            || (vm.isSchemeTypeELSS)){*/

          if(vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === false){
            vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
          }else if(vm.purchaseValidations.dividendPayoutApplicable === false && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
            vm.formData.purchaseDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          }else if(vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
            vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption && vm.backFromPayment ?vm.formData.purchaseDividendOption:vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          }
          if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler"){
            vm.formData.purchaseDividendOption = (vm.arnHardcodedData.dividendOption == 'N' || vm.arnHardcodedData.dividendOption == 'Y')? vm.arnHardcodedData.dividendOption: vm.formData.purchaseDividendOption;
           }
        }
        if(vm.arnHardcodedData && vm.arnHardcodedData.dividendOption == "Y" &&
        vm.purchaseValidations && vm.purchaseValidations.dividendReinvestmentApplicable == true){
          vm.formData.purchaseDividendOption = vm.arnHardcodedData.dividendOption ;
        }
        if(vm.arnHardcodedData && vm.arnHardcodedData.dividendOption == "N" &&
        vm.purchaseValidations && vm.purchaseValidations.dividendPayoutApplicable == true){
          vm.formData.purchaseDividendOption = vm.arnHardcodedData.dividendOption ;
        }
    }

    function _setSipDividendOptionsVali(inSchemeValidations) {
      // var transactionType = vm.formData.investmentType.toLowerCase();
      vm.inSchemeValidations = inSchemeValidations;
      var investmentOption = vm.inSchemeValidations.investmentOption || (vm.inSchemeValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
      if (!vm.backFromPayment) {
        if(investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH){
          vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
        }else {
          if(vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === false){
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
          }else if(vm.inSchemeValidations.dividendPayoutApplicable === false && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          }else if(vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
            vm.formData.sipDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
          }
          if(vm.arnHardcodedData && vm.arnHardcodedData.dividendOption == "Y" &&
            vm.inSchemeValidations && vm.inSchemeValidations.dividendReinvestmentApplicable == true){
            vm.formData.sipDividendOption = vm.arnHardcodedData.dividendOption ;
          }
          if(vm.arnHardcodedData && vm.arnHardcodedData.dividendOption == "N" &&
             vm.inSchemeValidations && vm.inSchemeValidations.dividendPayoutApplicable == true){
              vm.formData.sipDividendOption = vm.arnHardcodedData.dividendOption ;
          }
        }
      }

    }

    function schemeGroupCodeData(schemeList , schemeType) {

      vm.schemeCodeList = vm.PARTNER_DATA.schemeList ;
      var schemeCodeList=[];
      if (schemeList && vm.schemeCodeList) {
        var key = 0;
        vm.schemeCodeList.forEach(function(item){
          var data =
          schemeList.filter(function(data){
            return data.schemeCode == item.schemeCode
          })[0];
         if(data !== undefined) {
          schemeCodeList[key] = data;
          key= key+1;
        }
        })
        if(schemeType == 'sip'){
          vm.masterInSchemeList = null;
          vm.masterInSchemeList = schemeCodeList;
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      }
      if(schemeType == 'purchase'){
        vm.masterPurchaseInSchemeList = null;
        vm.masterPurchaseInSchemeList = schemeCodeList;
        vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
      }
  }
}
    function selectedUpiBank() {
      vm.showIFSCField = false;
      vm.showAccountTypeField = false;
      if (vm.formData.bankInfo) {
        vm.showIFSCField = vm.formData.bankInfo.ifscCode ? false : true;
        vm.showAccountTypeField = vm.formData.bankInfo.bankAcType ? false : true;
      }
      if (vm.showAccountTypeField) {
        getAccountType();
      }
      if(vm.formData.bankInfo && !vm.formData.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
        ModalService.minorBankModal({instantInvestment:true});
        return;
      }

      if (vm.formData.bankInfo) {
        vm.upiAccountNumber = vm.formData.bankInfo.accountNumber;
        vm.upiBankName = vm.formData.bankInfo.bankName;
      }
      vm.formData.bankInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
      vm.isInvalidForm = false;
    }

    function resetUPIForm() {
      vm.formData.verifyUPIResp = {};
      vm.formData.isUPIVerified = false;
      vm.formData.bankInfo = null;
      vm.formData.virtualAddress = null;
    }

    function verifyUPI() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData.verifyUPIResp = resp.data;
            if(resp.data.valid){
              vm.formData.name = resp.data.name;
              vm.formData.isUPIVerified = true;
            } else {
              vm.formData.isUPIVerified = false;
              vm.formData.verifyUPIResp.valid = false;
            }
          }
          else {
            vm.formData.isUPIVerified = false;
            vm.formData.verifyUPIResp.valid = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();

        };

      LoaderService.showLoader();

      investorServiceVersion.post({
        child1: 'upi',
        child2: 'check',
        child3: 'virtualAddress'
      }, {
        "virtualAddress":vm.formData.virtualAddress,
        "basketFlow": false,
        "folioNo": vm.formData.folioNumber,
        "transactionType": vm.formData.investmentType,
        "ecartFlow": false
      }).$promise.then(success, error);
    }

  // HMF-15077 Add Switch Transactions

    function fetchOutSchemes() {
      if (!vm.formData.folioNumber) {
        return;
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          // fetchSwitchInSchemes();
          vm.masterOutSchemeList = resp.data.schemes;
          vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList);
          if(vm.arnHardcodedData && vm.arnHardcodedData.schemeCode && vm.formData.investmentType && vm.formData.investmentType == 'REDEMPTION'){
            var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
            return vm.arnHardcodedData.schemeCode === item.schemeCode;
            }) || {};
            if(!scheme.schemeCode){
            }else{
              vm.outSchemeCode = scheme.schemeCode || ''
              vm.outSchemeName = scheme.schemeName || '';
              vm.outSchemeChanged(scheme);
            }

        }else{
          if (vm.formData.outSchemeCode && !vm.formData.isBackFromSummary) {
            var scheme = vm.outSchemeList && vm.outSchemeList.find(function (item) {
            return vm.formData.outSchemeCode === item.schemeCode;
            }) || {};
            vm.formData.outSchemeName = scheme.scheme || '';
            vm.outSchemeChanged();
          }
          }
        } else {
          vm.outSchemeList = null;
          vm.masterOutSchemeList = null;
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
          vm.outSchemeList = null;
          vm.masterOutSchemeList = null;
          UtilService.errorHandler(err);
      };
      if(vm.formData.investmentType == "REDEMPTION" && vm.arnHardcodedData){
        var payload = {
          folioNumber: vm.formData.folioNumber,
          transactionType: vm.formData.investmentType.toLowerCase(),
          arnCode : vm.arnHardcodedData.arn ? 'ARN-'+vm.arnHardcodedData.arn : "DIRECT",
          schemeRegularDirect : vm.arnHardcodedData.arn ? "REGULAR" : "DIRECT"
        }
      }else{
      var payload = {
        folioNumber: vm.formData.folioNumber,
        transactionType: vm.formData.investmentType.toLowerCase()
      }
      }
      LoaderService.showLoader();
      if(vm.formData.investmentType == "REDEMPTION" && vm.arnHardcodedData){
        InvestorService.post({ child1: 'folio', child2: 'schemes',child3:'regular',child4:'direct'},payload).$promise.then(success, error);
      }else{
      InvestorService.post({ child1: 'folio', child2: 'schemes' },payload).$promise.then(success, error);
      }
    }

    function fetchSwitchInSchemes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.masterInSchemeList = resp.data.schemeList;
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
          if (vm.arnHardcodedData && vm.arnHardcodedData.schemeCode && vm.formData.investmentType && vm.formData.investmentType == 'SWITCH') {
            var schemeData = vm.inSchemeList.filter(function (scheme) {
              return scheme.schemeCode === vm.arnHardcodedData.schemeCode;
            });
            vm.inSchemeChangedSwitch(schemeData[0]);
          }if(vm.PARTNER_DATA){
            if(vm.PARTNER_DATA.schemeGroupCode){
              schemeGroupCodeData(vm.inSchemeList , "sip")
            }
          }
          if (vm.arnHardcodedData) {
            if (vm.arnHardcodedData.schemeGroupCode) {
              schemeGroupCodeList(vm.inSchemeList , "sip")
            }
            if (vm.arnHardcodedData.HDFCCAMP) {
              vm.filterHdfcCapmScheme(vm.inSchemeList , "sip")
            }
          }
        } else {
          vm.masterInSchemeList = null;
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.masterInSchemeList = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      IIHttpService.get({
        child1: 'scheme',
        child2: 'ALL',//vm.transactionType.toLowerCase(),
        child3: vm.formData.investmentType.toLowerCase() + 'enabled',
        child4: identifierData && identifierData.minor != 'undefined' ? identifierData.minor : false/*vm.investorInfo.minor|| */,
        child5: vm.formData.isThroughDistributor,
        child6: vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
      }, null).$promise.then(success, error);
    }

    vm.outSchemeChanged = function (schemeData) {
      if(vm.masterOutSchemeList) {
        vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList, 'schemeName', vm.outSchemeName);
        if(!vm.inSchemeCode){
          fetchSwitchInSchemeValidations();
        }
      }
      if (schemeData) {
        vm.outSchemeCode = schemeData.schemeCode;
        vm.outSchemeName = schemeData.schemeName;
        fetchOutSchemeValidations();
        var scheme = vm.outSchemeList.find(function (item) {
          return item.schemeCode === vm.outSchemeCode;
        }) || {};
        if(vm.formData.investmentType == 'SWITCH'){
        fetchSwitchInSchemes();
        }
        if(vm.formData.investmentType == 'REDEMPTION'){
          fetchBankListRedeem();
        }
      }else{
      }
    };

    function fetchOutSchemeValidations(cb) {
      vm.outSchemeValidations = null;
      cb = cb || function () {
      };

      if (!vm.outSchemeCode) {
        cb(false)
        return;
      }

      var success = function (resp) {
        fetchUnitDetails();
        vm.transactionType = vm.formData.investmentType;
        if (resp.status && resp.data) {
          vm.outSchemeValidations = resp.data;
          var schemeTypeCheck = vm.outSchemeValidations && vm.outSchemeValidations.investmentOption;
          vm.isSourceSchemeGrowth = schemeTypeCheck == "GROWTH" ? true : false;
          cb(true);
        } else {
          cb(false);
          vm.outSchemeValidations = null;
          (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) && MessageService.error(resp.message);
        }
      },
      error = function (err) {
        vm.outSchemeValidations = null;
        cb(false);
        UtilService.errorHandler(err);
      };

      var _config = {};
      _config.controller = 'schemeValidation';
      _config.type = vm.transactionType.toLowerCase();
      // _config.child1 = vm.formData.outSchemeCode;

      var data = {
        schemeCode: vm.outSchemeCode,
        folioNo: vm.formData.folioNumber
      }
      SchemeService.post(_config, data).$promise.then(success, error);
    }

    function fetchUnitDetails(cb) {

      cb = cb || function () {
      };

      vm.unitsDetails = null;
      if (!vm.outSchemeCode) {
        return;
      }
      // LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.unitsDetails = resp.data;
          vm.unitsDetails.message = resp.message || '';
          vm.unitsDetails.isDisabled = !resp.data.freeValueUnits;
          vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
          vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
          vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
          checkValidations();
          cb(true);
        } else {
          vm.unitsDetails = null;
          MessageService.error(resp.message);
          cb(false);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.unitsDetails = null;
        UtilService.errorHandler(err);
        cb(false);
      };
      var payload = {
        schemeCode: vm.outSchemeCode,
        transactionType: vm.formData.investmentType.toLowerCase(),
        folioNo: vm.formData.folioNumber
      };
      InvestorService.post({child1: 'transaction',child2: 'folio',child3: 'scheme-value'}, payload).$promise.then(success, error);
    }

    vm.transferOptionChanged = function (transferType) {
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.day = null;
      vm.amount = '';
      vm.frequency = null;
      vm.bankInfo = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.transferOption = transferType ? transferType : vm.transferOption;
    };


    vm.inSchemeChangedSwitch = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.inSchemeCode = schemeData.schemeCode;
        vm.inSchemeName = schemeData.scheme;
        vm.inSchemeType = schemeData.schemeType;
        if (vm.inSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.inSchemeCode = '';
          vm.inSchemeName = '';
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
          return;
        }
        vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.inSchemeName);
        vm.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
        // vm.transferOptionChanged(vm.transferOption)
        if (schemeData.nfoEnabled == 'Y') {
          vm.nfoEnabled = true;
        } else {
          vm.nfoEnabled = false;
        }
        fetchInSchemeValues();
      }
      vm.amount = '';
      vm.units = '';
      vm.amountType = vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT;
      vm.noOfInstallments = '';
      reSetting();
      resetDefaults();
      vm.resetNumInWords();
    };

    function fetchSwitchInSchemeValidations(cb) {
      vm.switchInSchemeValidations = null;

      if (vm.transactionType) {
        vm.formData.investmentType = vm.transactionType;
      } else if (vm.formData.investmentType) {
        vm.transactionType = vm.formData.investmentType;
      }

      var transactionType = vm.formData.investmentType.toLowerCase();

      cb = cb || function () {
      };
      if (!vm.inSchemeCode) {
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.switchInSchemeValidations = resp.data;
            vm.isSwitchInSchemeTypeELSS = (vm.switchInSchemeValidations && vm.switchInSchemeValidations.schemeType == "ELSS") ? true : false;
            var switchInInvestmentOption = vm.switchInSchemeValidations.investmentOption || (vm.switchInSchemeValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
            vm.switchInSchemeValidations.switchInInvestmentOption = switchInInvestmentOption;
            vm.autoSwitchSchemeDividendOption = (switchInInvestmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : ((vm.switchInSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (transactionType == "sip" && vm.isSwitchInSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
            vm.dividendOptions = vm.isSwitchInSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;

            if (switchInInvestmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) {
              vm.autoSwitchSchemeDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            } else if (((switchInInvestmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND) && (vm.autoSwitchSchemeDividendOption == vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH)
                || (!vm.autoSwitchSchemeDividendOption))) {
              vm.autoSwitchSchemeDividendOption = ((vm.switchInSchemeValidations.endingType === vm.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (vm.isSwitchInSchemeTypeELSS)) ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : (vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST);
            }
            cb(true);
          } else {
            cb(false);
            vm.switchInSchemeValidations = null;
            vm.switchInSchemeValidations.switchInInvestmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.autoSwitchSchemeDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.isSwitchInSchemeTypeELSS = (vm.switchInSchemeValidations && vm.switchInSchemeValidations.schemeType == "ELSS") ? true : false;
            vm.autoSwitchSchemeDividendOption = vm.isSwitchInSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.autoSwitchSchemeDividendOption;
            vm.dividendOptions = vm.isSwitchInSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
            MessageService.error(resp.message);
          }
      },
      error = function (err) {
        cb(false);
        vm.switchInSchemeValidations = null;
        vm.switchInSchemeValidations.switchInInvestmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
        vm.autoSwitchSchemeDividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
        vm.isSwitchInSchemeTypeELSS = (vm.switchInSchemeValidations && vm.switchInSchemeValidations.schemeType == "ELSS") ? true : false;
        vm.autoSwitchSchemeDividendOption = vm.isSwitchInSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.autoSwitchSchemeDividendOption;
        vm.dividendOptions = vm.isSwitchInSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
        UtilService.errorHandler(err);
      };

      var data = {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.switchInSchemeCode
      }
      SchemeService.post({
        controller: 'schemeValidation',
        type: transactionType
      }, data).$promise.then(success, error);
    }

    function fetchInSchemeValues(cb) {
      vm.inSchemeValidations = null;

      if (vm.formData.investmentType) {
        vm.transactionType = vm.formData.investmentType;
      }
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX) {
        return;
      }

      var transactionType = vm.formData.investmentType.toLowerCase();
      cb = cb || function () {
      };
      if (!vm.inSchemeCode) {
        return;
      }

      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.inSchemeValidations = resp.data;
          if(vm.inSchemeValidations.investmentOption == Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS)[1])
            vm.inSchemeValidations.investmentOption = vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND;
          vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
          var investmentOption = vm.inSchemeValidations.investmentOption || (vm.inSchemeValidations.isGrowth ? vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH : vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND);
          vm.validations.investmentOption = investmentOption;
          vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
          if (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) {
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          } else if (investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND ){
            if(vm.arnHardcodedData && vm.arnHardcodedData.schemeCode == vm.inSchemeCode
              && ((vm.arnHardcodedData.dividendOption == vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT && vm.inSchemeValidations.dividendPayoutApplicable === true ) || (vm.arnHardcodedData.dividendOption == vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && vm.inSchemeValidations.dividendReinvestmentApplicable === true))){
              vm.formData.dividendOption = vm.arnHardcodedData.dividendOption;
            }else{
              if(vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === false){
                vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT;
              }else if(vm.inSchemeValidations.dividendPayoutApplicable === false && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
                vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
              }else if(vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
                vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST;
              } else {
                vm.isInvalidForm = true;
              }
            }
          }

          cb(true);
        } else {
          cb(false);
          vm.inSchemeValidations = null;
          vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
          vm.formData.dividendOption = vm.isSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.dividendOption;
          vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          cb(false);
          vm.inSchemeValidations = null;
          vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
          vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
          vm.formData.dividendOption = vm.isSchemeTypeELSS ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT : vm.formData.dividendOption;
          vm.devidendOptions = vm.isSchemeTypeELSS ? vm.devidendOptionsELSS : vm.devidendOptionsOther;
          UtilService.errorHandler(err);
        };

      var data = {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.inSchemeCode
      }
      SchemeService.post({
        controller: 'schemeValidation',
        type: transactionType
      }, data).$promise.then(success, error);
    }

    function resetDefaults(doNotEmptyValidations) {
      vm.isReseting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      if (!doNotEmptyValidations) {
        vm.validations = {};
      }
      checkValidations();
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function fetchCalculatedSwitchValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.inSchemeCode && !vm.outSchemeCode) {
        return;
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          (angular.isDefined(resp.data.minAmount)) && (vm.validationsApi.minAmount = resp.data.minAmount);
          (angular.isDefined(resp.data.maxAmount)) && (vm.validationsApi.maxAmount = resp.data.maxAmount);
          (angular.isDefined(resp.data.minUnits)) && (vm.validationsApi.minUnits = resp.data.minUnits);
          (angular.isDefined(resp.data.maxUnits)) && (vm.validationsApi.maxUnits = resp.data.maxUnits);
          $log.info('Ser vali>>', vm.validationsApi);
          cb(null);
        } else {
          cb('error');
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          cb('error');
          UtilService.errorHandler(err);
        };

      var valPayload = {
        "folioNo": vm.formData.folioNumber,
        "inSchemeCode": vm.inSchemeCode,
        "outSchemeCode": vm.outSchemeCode,
        "transactionType": vm.transactionType
      };
      SchemeService.post({
        controller: 'schemeValidation',
        child1: 'validationCal'
      }, valPayload).$promise.then(success, error);
    }

    vm.amountTypeChanged = function () {
      vm.amountValidation = false;
      vm.transactionType = vm.formData.investmentType;
      if (vm.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT) {
        vm.units = '';
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH) {
          checkSwitchValidations();
        }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
          checkRedeemValidations();
        }
      } else if (vm.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS) {
        vm.amountValidation = true;
        vm.amount = '';
        vm.units = +vm.unitsDetails.freeValueUnits.toFixed(2);
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH) {
          checkSwitchValidations();
        }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
          checkRedeemValidations();
        }
      } else {
        vm.amount = '';
        vm.units = vm.units ? vm.units : '';
        localStorage.getItem("unitsSave") ? vm.units = parseFloat(localStorage.getItem("unitsSave")) : vm.units = '';
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH) {
          checkSwitchValidations();
        }
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
          checkRedeemValidations();
        }
      }
    };

    function checkSwitchValidations() {
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.minUnits = vm.validations.minUnits || 0;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
        vm.validations.maxUnits = vm.validations.maxUnits > vm.unitsDetails.freeValueUnits ? vm.validations.maxUnits : +vm.unitsDetails.freeValueUnits.toFixed(2);
      }

      var minAmount = 0;
      var minUnits = 0;
      var maxAmount = 0;
      var maxUnits = 0;
      if (vm.outSchemeValidations) {
        minAmount = vm.outSchemeValidations.switchOutMinAmt ? vm.outSchemeValidations.switchOutMinAmt : minAmount;

        minAmount = vm.outSchemeValidations.switchOutMinUnit && ((vm.outSchemeValidations.switchOutMinUnit * vm.outSchemeValidations.navValue) > minAmount) ?
          (vm.outSchemeValidations.switchOutMinUnit * vm.outSchemeValidations.navValue) : minAmount;

        vm.validations.minAmount = minAmount > vm.validations.minAmount ? minAmount : vm.validations.minAmount;

        maxAmount = vm.outSchemeValidations.switchOutMaxUnit && (vm.outSchemeValidations.switchOutMaxUnit * vm.outSchemeValidations.navValue) || maxAmount;
        maxAmount = vm.outSchemeValidations.switchOutMaxAmt && (vm.outSchemeValidations.switchOutMaxAmt < maxAmount) ? vm.outSchemeValidations.switchOutMaxAmt : maxAmount;
        vm.validations.maxAmount = (maxAmount > 0 && maxAmount < vm.validations.maxAmount) ? maxAmount : vm.validations.maxAmount;

        minUnits = vm.outSchemeValidations.switchOutMinAmt && (vm.outSchemeValidations.switchOutMinAmt / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = vm.outSchemeValidations.switchOutMinUnit && (vm.outSchemeValidations.switchOutMinUnit > minUnits) ? vm.outSchemeValidations.switchOutMinUnit : minUnits;
        vm.validations.minUnits = minUnits > vm.validations.minUnits ? minUnits : vm.validations.minUnits;

        maxUnits = vm.outSchemeValidations.switchOutMaxAmt && (vm.outSchemeValidations.switchOutMaxAmt / vm.outSchemeValidations.navValue) || maxUnits;
        maxUnits = vm.outSchemeValidations.switchOutMaxUnit && (vm.outSchemeValidations.switchOutMaxUnit < maxUnits) ? vm.outSchemeValidations.switchOutMaxUnit : maxUnits;
        vm.validations.maxUnits = (maxUnits > 0 && maxUnits < vm.validations.maxUnits) ? maxUnits : vm.validations.maxUnits;
      }
      if (vm.inSchemeValidations) {
        minAmount = vm.inSchemeValidations.switchInMinUnit && (vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue > minAmount)
          ? (vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue) : minAmount;
        minAmount = vm.inSchemeValidations.addlswitchInPurchase ? vm.inSchemeValidations.switchInMinAddlPurchaseAmt : (vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt > minAmount) ? vm.inSchemeValidations.switchInMinAmt : minAmount);
        vm.validations.minAmount = minAmount > vm.validations.minAmount ? minAmount : vm.validations.minAmount;

        maxAmount = vm.inSchemeValidations.switchInMaxUnit && (vm.inSchemeValidations.switchInMaxUnit * vm.inSchemeValidations.navValue) || maxAmount;
        maxAmount = vm.inSchemeValidations.switchInMaxAmt && (vm.inSchemeValidations.switchInMaxAmt < maxAmount) ? vm.inSchemeValidations.switchInMaxAmt : maxAmount;
        vm.validations.maxAmount = (maxAmount > 0 && maxAmount < vm.validations.maxAmount) ? maxAmount : vm.validations.maxAmount;

        var _minUnits = vm.inSchemeValidations.switchInMinUnit && ((vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue) / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = vm.inSchemeValidations.addlswitchInPurchase && angular.isDefined(vm.inSchemeValidations.switchInMinAddlPurchaseUnit) ? vm.inSchemeValidations.switchInMinAddlPurchaseUnit : minUnits;
        minUnits = minUnits > _minUnits ? minUnits : _minUnits;
        vm.validations.minUnits = minUnits > vm.validations.minUnits ? minUnits : vm.validations.minUnits;

        var _maxUnits = vm.inSchemeValidations.switchInMaxUnit && ((vm.inSchemeValidations.switchInMaxUnit * vm.inSchemeValidations.navValue) / vm.outSchemeValidations.navValue) || maxAmount;
        maxUnits = vm.inSchemeValidations.switchInMaxAmt && (vm.inSchemeValidations.switchInMaxAmt / vm.outSchemeValidations.navValue) || maxAmount;
        maxUnits = maxUnits < _maxUnits ? maxUnits : _maxUnits;
        vm.validations.maxUnits = (maxUnits > 0 && maxUnits < vm.validations.maxUnits) ? maxUnits : vm.validations.maxUnits;
        vm.validations.amountMultiples = vm.inSchemeValidations.switchAmtMultiples || 1;

        vm.validations.isEnabled = vm.inSchemeValidations.switchInUnitEnabled;
      }

      if (vm.amountType == vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT) {
        vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.amount);
        vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.amount);
        vm.isMultiples = vm.validations.amountMultiples && vm.amount && (vm.amount % vm.validations.amountMultiples === 0) || false;
      } else {
        vm.isMax = !!(vm.validations.maxUnits && vm.validations.maxUnits < vm.units);
        vm.isMin = !!(vm.validations.minUnits && vm.validations.minUnits > vm.units);
        vm.isMultiples = false;
      }
      $log.info('Fro vali>>', vm.validations);

      vm.isInvalidForm = !vm.unitsDetails || (vm.amount <= 0 && vm.units <= 0) || (vm.amount && (vm.isMax || vm.isMin || (!vm.isMultiples && vm.validations.amountMultiples))) || !vm.unitsDetails.freeValueUnits || (vm.units && (vm.isMax || vm.isMin))
    }

    vm.checkSwitchValidationsForPreview = function () {
      vm.amountValidation = false;
      if(vm.amountType == 'amount'){
        if(vm.amount <= vm.validationsApi.maxAmount && vm.amount >= vm.validationsApi.minAmount){
          $window.NumToWord(vm.amount, vm.amountInWords, vm);
          vm.amountValidation = true;
        }
      }else{
        if(vm.units <= vm.validationsApi.maxUnits && vm.units >= vm.validationsApi.minUnits){
          vm.amountValidation = true;
        }
      }
    }

    vm.showReviewSummary = function(){
      vm.showSwitchPreview = true;
      vm.isCheckedTandC = false;
      vm.formData.isSummaryViewEnabled = true;
      vm.email = vm.token.email ? vm.maskEmail(vm.token.email) : 'N/A';
      vm.mobileNumber = vm.token.mobileNumber ? vm.maskemobileNo(vm.token.mobileNumber) : 'N/A';
      vm.switchReviewData.dividendOption = vm.TRANSACTIONS_CONST.DESCRIPTIONS[vm.formData.dividendOption];
      vm.euinName = vm.formData.euin ? vm.formData.euin.euinName : '';
    }

    vm.maskEmail = function(email){
      if (email) {
        var valArray = email.split("@");
        var startVal = valArray[0];
        var endVal = valArray[1];
        var maskyVal = "";
        for (var i = 0; i < startVal.length; i++) {
          if (i == 0) {
            maskyVal += startVal[i];
          }
          if (i == 1) {
            maskyVal += "*";
          }
          if (i > 1) {
            var t = i % 2;
            if (t == 0) {
              maskyVal += startVal[i];
            } else {
              maskyVal += "*";
            }
          }
        }
        return maskyVal + "@" + endVal;
      }
    }

    vm.maskemobileNo = function (val) {
      var endVal = val.substr(-4);
      var maskyVal = "";
      var valLength = val.length;
      while (0 < valLength - 4) {
        maskyVal += "*";
        valLength--;
      }
      return maskyVal + endVal;
    }
    setSchedulePurchaseDynamicData();
    vm.setSchedulePurchaseDynamicDetails = null;
    function setSchedulePurchaseDynamicData() {
      if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler") {
        var successHandler = function(resp){
          if(resp.data && resp.status){
            vm.setSchedulePurchaseDynamicDetails = resp.data;
          }
        };
        var errorHandler = function() {
          vm.setSchedulePurchaseDynamicDetails = null;
        }

        var payload = {
          "pageName" : "SP_APPROVE_SCREEN"
        };
        InvestorService.post({
          "child1": "dynamicContent"
        }, payload).$promise.then(successHandler, errorHandler);
      }
    }
    vm.tpv = tpv;
    function tpv() {
      ModalService.tpvModal({});
    }
    function setDynamicData() {
      if(vm.formData.investmentType == 'SWITCH') {
        var successHandler = function(resp){
          if(resp.data && resp.status){
            vm.DynamicDataReview = resp.data;
            vm.notesReview = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Review_Transaction_Switch;
            vm.notes = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Switch;
            if(Object.keys(vm.DynamicDataReview.termAndConditionDTO.termAndConditionDTOMap).length == 0){
              vm.showTerms = false;
            }
          }
        };

        var errorHandler = function() {
          vm.notes = null;
        }

        var payload = {
          "pageName" : "SWITCH_REVIEW"
        };
        InvestorService.post({
          "child1": "dynamicContent"
        }, payload).$promise.then(successHandler, errorHandler);
      }
      if(vm.formData.investmentType == 'REDEMPTION') {
        var successHandler = function(resp){
          if(resp.data && resp.status){
            vm.DynamicDataReview = resp.data;
            vm.notesSchedule = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Review_Redemption;
            vm.noteRedemption = vm.DynamicDataReview.noteDTO.noteDTOMap.Note_Review_Schedule_Redemption;
            vm.key = "TNC_Review_transaction_Redemption"
          }
        };

        var errorHandler = function() {
          vm.notes = null;
        }

        var payload = {
          "pageName" : "REDEMPTION_REVIEW"
        };
        InvestorService.post({
          "child1": "dynamicContent"
        }, payload).$promise.then(successHandler, errorHandler);
      }
    }

    vm.showTermConditions = function(){
      var transactionType = vm.formData.investmentType;
      ModalService.transactionalTermConditionModal({'transactionType':transactionType,'subTransactionType':transactionType});
    }

    vm.goToBack = function () {
      vm.formData.isSummaryViewEnabled = false;
      vm.showSwitchPreview = false;
      vm.isCheckedTandC = false;
      vm.showPurchaseSchedulerSuccess = false;
      if(vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION){
        vm.showRedeemPreview = false;
      }
    }

    vm.filterOutSchemeList = function () {
      vm.transactionType = vm.formData.investmentType;
      vm.outSchemeCode = '';
      vm.outSchemeList = UtilService.getFilteredList(vm.masterOutSchemeList, 'schemeName', vm.outSchemeName);
      vm.resetNumInWords();
      if(vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION){
      vm.amount = '';
      vm.units = '';
      vm.amountType = vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT;
      }
    };

    vm.filterInSchemeListTwo = function () {
      vm.transactionType = vm.formData.investmentType;
      vm.inSchemeCode = '';
      vm.inSchemeType = '';
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.inSchemeName);
      vm.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;
      vm.transferOptionChanged(vm.transferOption)
      vm.resetNumInWords();
    };


    vm.schemeFilterListModal = function () {
      if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
        MessageService.error('No free available units');
        return;
      }
     var successSchemeList = function (result) {
          vm.inSchemeChangedSwitch(result);
        },
        errorSchemeList = function () {
          vm.inSchemeCode = '';
          vm.inSchemeName = '';
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
        };
      var isFlexStp = false;
      var isSwingStp = false;
      ModalService.schemeListModal({
        enabledScheme: vm.transactionType.toLowerCase() + 'enabled',
        isMinor: vm.token.minor != undefined ? vm.token.minor : false,//vm.investorInfo.minor,
        isFlexStp: isFlexStp,
        isSwingStp: isSwingStp,
        isThroughDistributor: vm.formData.isThroughDistributor,
        corporateFlag : vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
      }, successSchemeList, errorSchemeList);
    };

    vm.switchInSchemeListModal = function () {
      if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
        MessageService.error('No free available units');
        return;
      }
      var successSchemeList = function (result) {
          vm.inSchemeChangedSwitch(result);
        },
        errorSchemeList = function () {
          vm.inSchemeCode = '';
          vm.inSchemeName = '';
          vm.autoSwitchInSchemeList = UtilService.getFilteredList(vm.autoSwitchInSchemes);
        };

      var isFlexStp = false;

      ModalService.schemeListModal({
        enabledScheme: 'autoSwitchenabled',
        isMinor: vm.token.minor != undefined ? vm.token.minor : false,//vm.investorInfo.minor,
        isFlexStp: isFlexStp,
        isThroughDistributor: vm.formData.isThroughDistributor,
        corporateFlag : vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
      }, successSchemeList, errorSchemeList);
    };

    vm.submitFormSwitchFirst = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.submitForm();
          } else {
            MessageService.error(resp.message);
          }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var payload = {
        transactionType: vm.formData.investmentType,
        folioNumber: vm.formData.folioNumber,
        targetSchemeCode: vm.inSchemeCode,
        schemeCode: vm.outSchemeCode,
        amount: vm.amountType==='amount'? vm.amount:undefined,
        units: vm.amountType === 'all_units'|| vm.amountType==='units'? vm.units:undefined
      };
      payload.units = payload.units? payload.units : (Number(0).toFixed(1));
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'transaction',
        child2: 'check',
        child3: 'duplicate'
      }, payload).$promise.then(success, error);
    };

    vm.submitForm = function(){
      approveTransaction()
    };

    function approveTransaction($event) {
      var payload = null;
      if(vm.formData.investmentType == "Schedule_Transaction"){
        payload = vm.getPurchaseSchedulePayload();
      } else if(vm.formData.investmentType == 'REDEMPTION'){
        payload = getRedeemPayload();
      }else{
        if(vm.formData.investmentType){
          payload = getSwitchPayload();
        }
      }
      if (!payload) {
        MessageService.error('Something went wrong while calculating payload.');
        return;
      }

      payload.formType = (payload.formType === 'Flex STP' || payload.formType === 'Swing STP') ? 'STP' : payload.formType;
      LoaderService.showLoader();
      var success = function (resp) {

        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (resp.data.trnxActionFlag && resp.data.transactionId) {
            vm.transactionId = resp.data.transactionId;
            localStorage.setItem('Transaction_Value',vm.amountType);
            vm.getSwitchTransactionSummary();
          }else{
            LoaderService.hideLoader();
            MessageService.error(resp.data.trnxActionMsg);
          }
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var _controller2 = vm.formData.investmentType.toLowerCase();
      payload.units = payload.units? payload.units : (Number(0).toFixed(1));
      var _config = {
        controller1: 'transaction',
        controller2: _controller2,
        controller3: 'approve'
      };
      if(vm.arnHardcodedData){
        payload.utmSource = vm.arnHardcodedData.utmSource;
        payload.utmMedium = vm.arnHardcodedData.utmMedium;
      }
      if(vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH){
      TransactionService.post(_config, payload).$promise.then(success, error);
    }
      if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION) {
        LoaderService.hideLoader();
        var nudgeSuccess = function (res) {
          if(res === 'cancel') {
          }
          if(res.key === 'approveRedeem') {
            LoaderService.showLoader();
            payload.reasons = res.nudgeReason;
            if (res.nudgeReason === 'Other') {
              payload.nudgeOtherReason = res.nudgeOtherReason;
            }
            transactionOtmConfirmation($event, _config, payload);
          }
        };
        ModalService.showNudgeReasons({Text:'Please let us know the reason for Redemption:',folioNumber:vm.formData.folioNumber, schemeCode: vm.outSchemeCode, transactionType: vm.transactionType },nudgeSuccess);
      }
      }

    vm.getSwitchTransactionSummary = function(){
      var transactionTypeModified;
      switch (vm.transactionType) {
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX:
          transactionTypeModified = 'FLEXINDEX';
          break;
        case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION:
          transactionTypeModified = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION;
          break;
        default:
          transactionTypeModified = vm.transactionType;
      }

      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.camsReferenceNumber = resp.data.camsReferenceNumber;
          vm.transactionType = resp.data.distributorDetails.transactionType;
          if(vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION){
            vm.redeemScheme = resp.data.sourceScheme.schemeName;
            vm.showRedeemSuccess = true;
          }else{
          vm.investmentOption = resp.data.targetScheme.investmentOption;
          vm.showSwitchSuccess = true;
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        if(vm.transactionType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION){
          vm.showRedeemSuccess = false;
        }
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var payload = {
        transactionId: vm.transactionId,
        transactionType: transactionTypeModified
      }
      InvestorService.post({
        child1: 'transaction',
        child2: 'approved',
        child3: 'summary'
      }, payload).$promise.then(success, error);
    }

    function getSwitchPayload() {
      vm.formData.investmentOption = vm.validations.investmentOption;
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == vm.formData.investmentOption)
          vm.formData.investmentOption = key;
      });
      var payload = {
        folioNumber: vm.formData.folioNumber,
        formType:  vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        investmentOption: vm.formData.investmentOption,
        dividendOption: vm.formData.dividendOption,
        switchInSchemeCode: vm.inSchemeCode,
        switchOutSchemeCode: vm.outSchemeCode,
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        units: vm.units,
        amount: vm.amount,
        subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN:'',
        subBrokerCode: vm.formData.subBrokerCode,
        checkedNfoAutoSwitch: vm.isAutoSwitch,
        autoSwitchScheme: vm.isAutoSwitch? vm.switchInSchemeCode : null,
        autoSwitchSchemeDividendOption: vm.isAutoSwitch ? vm.autoSwitchSchemeDividendOption : null,
        transactionMode: vm.amountType.toUpperCase()
      };if (vm.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS) {
        payload.units = +vm.unitsDetails.freeValueUnits;
      }
      payload.secretLink = localStorage.getItem("QuickInvestmentSecreteLink");
      payload = handleBrokerCode(payload);
      return angular.copy(payload);
    }

    function handlePurchaseResponse(data) {
      if (!data) {
        MessageService.error();
        return;
      }
      if(vm.formData.sipPaymentOption === 'E-mandate') {
       $window.location.href = vm.billdeskUrl + data.emandateRequestMsg;
       return;
      }
      TransactionModel.setPayloadRawData(null);
      if(vm.formData.investmentType == 'SIP')
        vm.billdeskMsg = data.emandateRequestMsg;
      else
        vm.billdeskMsg = data.data;
      if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLDESK') {

        if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            angular.element('#billdeskForm').submit();
          });
        } else {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            angular.element('#billdeskForm').submit();
          });
        }
      }
      else if (vm.formData.paymentInfo.paymentMode == 'WEB' && (vm.formData.paymentInfo.webMode == 'MASTERCARD' || vm.formData.paymentInfo.webMode == 'VISA')) {
        if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            angular.element('#billdeskForm').submit();
          });
        } else {
          vm.billdeskPayload.msg = vm.billdeskMsg;
          $timeout(function () {
            angular.element('#billdeskForm').submit();
          });
        }
      }
      else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLJUNCTION') {
        $window.open(vm.billdeskMsg , '_self');
      } else{
        $window.location.href = data.redirectUrl;
      }
    }
    /*
    * Function responsible to manage the broker code for purchase and sip payload
    * */
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.brokerCode ? vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        sessionStorage.setItem('riaName',  vm.formData.brokerName);
        payload['riaConsent'] = true;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }

      /*
    * Function responsible to manage the broker code for Schedule Purchase payload
    * */
    function handleBrokerCodeForSchedulePurchase(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brok_Code'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brok_Code'] = vm.formData.brokerCode ? vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        sessionStorage.setItem('riaName',  vm.formData.brokerName);
        payload['riaConsent'] = true;
      } else if (vm.formData.isDirect) {
        payload['brok_Code'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }

    function fetchAutoSwitch(cb) {
      if (vm.isAutoSwitch) {
        cb = cb || function () {
        };

        var success = function (resp) {
            if (resp.status && resp.data) {
              vm.autoSwitchInSchemes = resp.data.schemeList;
              vm.autoSwitchInSchemeList = UtilService.getFilteredList(vm.autoSwitchInSchemes);
              if (!vm.switchInSchemeName) {
                for (var i in vm.autoSwitchInSchemeList) {
                  if (vm.autoSwitchInSchemeList[i].schemeCode == 'LFGTN') {
                    vm.switchInSchemeName = vm.autoSwitchInSchemeList[i].scheme;
                    vm.switchInSchemeCode = vm.autoSwitchInSchemeList[i].schemeCode;
                    vm.isSwitchInScheme = !!(vm.selectedInScheme);
                    //vm.inSchemeChanged(vm.inSchemes[i])
                    if (vm.autoSwitchInSchemeList[i].schemeType == 'ELSS' && vm.autoSwitchInSchemeList[i].scheme.toLowerCase().includes('dividend')) {
                      vm.autoSwitchSchemeDividendOption = AppConstants.TRANSACTIONS.DIVIDEND_OPTIONS.PAYOUT;
                    }
                    fetchSwitchInSchemeValidations();
                  }
                }
              }
              cb(true);
            } else {
              vm.autoSwitchInSchemes = null;
              MessageService.error(resp.message);
              cb(false);
            }
        },
        error = function (err) {
          vm.autoSwitchInSchemes = null;
          UtilService.errorHandler(err);
          cb(false);
        };
        vm.nfoEnabled = true;
        var _config = {
          controller: 'scheme',
          type: 'ALL',
          child1: 'autoSwitchenabled',
          child2: vm.token.minor != undefined ? vm.token.minor : false,//vm.investorInfo.minor,
          child3: vm.formData.isThroughDistributor,
          child4: vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
        };

        SchemeService.get(_config, null).$promise.then(success, error);
      }
    }

    vm.filterAutoSwitchInSchemeList = function(){
      vm.switchInSchemeCode = '';
      vm.autoSwitchInSchemeList = UtilService.getFilteredList(vm.autoSwitchInSchemes, 'scheme', vm.switchInSchemeName);
      // resetNumInWords();
    }

    vm.autoInSchemeChanged = autoInSchemeChanged;
    function autoInSchemeChanged(schemeData) {

      if (!schemeData) {
        return;
      } else {
        vm.switchInSchemeCode = schemeData.schemeCode;
        vm.switchInSchemeName = schemeData.scheme;
        vm.switchInSchemeType = schemeData.schemeType;
        if (vm.switchInSchemeName && vm.selectedFolioData && !vm.selectedFolioData.holderDOBExists && schemeData.retirementFlag) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.switchInSchemeCode = '';
          vm.formData.switchInSchemeName = '';
          vm.autoSwitchInSchemeList = UtilService.getFilteredList(vm.autoSwitchInSchemes, 'scheme', vm.switchInSchemeName);
          return;
        }
        vm.autoSwitchInSchemeList = UtilService.getFilteredList(vm.autoSwitchInSchemes, 'scheme', vm.switchInSchemeName);
        fetchSwitchInSchemeValidations(function (success) {
          if (success) {
            // vm.validations.investmentOption = investmentOption;
          }
        });
      }
      reSetting();
    }

    vm.favrouiteApi = function(tid) {
      if (vm.favrouitModel) {
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              //
            }
          },
          error = function () {
          };
        LoaderService.showLoader();
        TransactionService.get({
          controller1: 'makeFavouriteTransaction',
          controller2: tid
        }).$promise.then(success, error);
      }
    }
    vm.getFoiloDetails = function(){
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.folioData = resp.data;
          vm.optOutNominee = vm.folioData.optOutNominee;
          vm.optedOutNominee = vm.folioData.optedOutNominee;
          vm.noNomination = vm.folioData.noNomination;
            // var success = function () {
            //   if ((vm.formData.investmentType === 'SWITCH' || vm.formData.investmentType === 'REDEMPTION') && vm.restrictRedemptionSwitch) {
            //     NomineePopupSuccess();
            //   }
            // }

            if(vm.noNomination == null || vm.noNomination == "") {

              // if (vm.restrictRedemptionSwitch) {
              //   ModalService.genericModal({
              //     text: vm.popUpMessage,
              //     isHdfcNomineePopup : true,
              //     hdfcNomineePopupMessage : vm.popUpMessageHDFCNominee,
              //     isUpi : true,
              //     folioNumber : vm.formData.folioNumber
              //   }, success);
              // } else {
            ModalService.optOutNomineeModal({
              OneClickHdfcCheque : true,
              folio:vm.formData.folioNumber,
              redirectionalLink:"https://digital.camsonline.com/changeofnomination"
            }, success, error)
          // }
            }
            // else if ((vm.formData.investmentType === 'SWITCH' || vm.formData.investmentType === 'REDEMPTION') && vm.restrictRedemptionSwitch) {
            //   ModalService.genericModal({text : vm.popUpMessage,isUpi : true}, NomineePopupSuccess);
            // }

        }else{
          MessageService.error(resp.message);
        }
      },error = function (err) {
        UtilService.errorHandler(err);
      };
      var payload = {
        "folioNumber":vm.formData.folioNumber
      }
      if(vm.arnHardcodedData){
        payload.oneClick = true;
        payload.arnCode = vm.arnHardcodedData && vm.arnHardcodedData.arn ? "ARN-"+vm.arnHardcodedData.arn : 'DIRECT';
      }
      vm.newFolioCreateThroughtOneClick = sessionStorage.getItem('newFolioCreateThroughtOneClick');
      if(vm.newFolioCreateThroughtOneClick){
        payload.arnCode = vm.arnHardcodedData && vm.arnHardcodedData.arn ? "ARN-"+vm.arnHardcodedData.arn : 'DIRECT';
      }
      InvestorService.post({child1: 'profile',child2: 'folio',child3: 'details',
      },payload).$promise.then(success, error);
    }
    vm.goToHome = function(){
      vm.outSchemeName = '';
      vm.outSchemeCode = '';
      vm.unitsDetails = '';
      vm.inSchemeName = '';
      vm.inSchemeList = [];
      vm.devidendOptions = [];
      vm.nfoEnabled = false;
      vm.isAutoSwitch = false;
      vm.autoSwitchInSchemeList = [];
      vm.switchInSchemeCode = '';
      vm.switchInSchemeValidations = null;
      vm.autoSwitchSchemeDividendOption = null;
      vm.amountType = 'amount';
      vm.amount = null;
      vm.units = null;
      vm.formData.investmentType = 'PURCHASE';
      vm.validations = {};
      vm.formData.isDirect = true;
      vm.isInvalidForm = false;
      vm.isCheckedTandC = false;
      vm.formData.isThroughDistributor = false;
      vm.formData.isThroughRia = false;
      vm.formData.isSummaryViewEnabled = false;
      vm.showSwitchPreview = false;
      vm.showSwitchSuccess = false;
      vm.outSchemeValidations = null;
      vm.inSchemeValidations = null;
      vm.validations.investmentOption = '';
      vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND = null;
      vm.showRedeemPreview = false;
      vm.showRedeemSuccess = false;
      if(!identifierData.minor){
        vm.getFoiloDetails();
      }
    }

  // HMF-15077 Add Switch Transactions

  angular.element(document).ready(function(){
    $(document).on("click",function(){
      $(".dropdown-content").hide();
    })
  })
  vm.myFunction = function(event){
    if(event){
      event.stopPropagation();
      event.preventDefault();
    }
    $(".dropdown-content").show();
  }

    function getMonthsCount(startDate, endDate) {
      var daysToBeAdded = 0;
      var daysAdded = 0;
      while(startDate.isBefore(endDate)) {
        var dayInMonth = moment(startDate).daysInMonth();
        if (dayInMonth === 31) {
          daysToBeAdded = daysToBeAdded + 1;
        } else {
          daysAdded = daysAdded + 1;
        }
        startDate.add(1, 'month');
      }
      return daysToBeAdded;
    }
    function updateEmandateEndDate() {

      if (!vm.formData.emandateDate) {
        return;
      }

      var enabledEndDates = [];
      vm.formData.endDateEmandate = '';
      if(vm.formData.emandateDate)
      {
        vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
        vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateMaxYear, 'years').subtract(1,'days');
      }

      var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
      for (var i = 0; i <= freq; i++) {
        enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
      }
      vm.enabledEmandateEndDatesList = enabledEndDates;
      vm.endDateViewEmandate = enabledEndDates[0].clone();
      vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
    }


    function checkAmountValidationEmandate() {
      vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
      vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
      vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.formData.amount ? true : false;
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.emandateWord);
    }

    function changeEndDateEmandate(date) {
      vm.formData.endDateEmandate = date ? date : null;
      if (vm.formData.endDate) {
        updateEndDates(false, false, true);
      }
    }

    function handleMandateCalender() {
      if (vm.formData.sipPaymentOption == 'E-mandate' && vm.sipDateLessEmandate) {
        vm.formData.endDate = null;
      }
    }
    vm.filterHdfcCapmScheme = function(schemeList, schemeType) {
      var fundCodeMap = {};
      var schemeListData = [];
      vm.HDFCCAMPFUND.forEach(function(item){
          fundCodeMap[item] = true;
      });
      schemeList.forEach(function(val){
          if(fundCodeMap.hasOwnProperty(val.fundCode)){
            schemeListData.push(val);
          }
      });

      if (schemeType == 'sip') {
          vm.masterInSchemeList = null;
          vm.masterInSchemeList = schemeListData;
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      }
      if (schemeType == 'purchase') {
          vm.masterPurchaseInSchemeList = null;
          vm.masterPurchaseInSchemeList = schemeListData;
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList);
      }
    }
    function fetchBankListRedeem(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      vm.bankList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            var isPrimary = false;
            angular.forEach(vm.bankList, function (bank) {
              if(bank.primaryFlag){
                vm.formData.bankInfo = bank;
                // changedBank();
                isPrimary = true;
              }
            });
            if ((vm.bankList && vm.bankList.length == 1) || !isPrimary) {
              vm.formData.bankInfo = vm.bankList[0];
              // changedBank();
            }
            cb();
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
      }
      LoaderService.showLoader();
        InvestorService.post({
          child1: 'folio',
          child2: 'scheme',
          child3: 'bankList'
        }, {
          schemeCode: vm.outSchemeCode,
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
    }

    vm.downloadReport = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/pdf' });
            FileSaver.saveAs(data, 'exitLoad.pdf');
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "schemeCode": vm.outSchemeCode,
        "commonReportCO": {
          "docDestination": "download"
        }
      };

      DownloadPdfService.downloadFile(payload).then(success, error);
    }

    function checkRedeemValidations() {
      if (vm.outSchemeValidations) {
        vm.validations.minAmount = vm.outSchemeValidations.minRedemptionAmt;
        vm.validations.minUnits = vm.outSchemeValidations.minRedemptionUnit;
        vm.validations.amountMultiples = vm.outSchemeValidations.redeemAmtMultiples;
      }

      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
        vm.validations.maxUnits = vm.validations.maxUnits > vm.unitsDetails.freeValueUnits ? vm.validations.maxUnits : +vm.unitsDetails.freeValueUnits;
      }

      if (vm.amountType == vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT) {
        vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.amount);
        vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.amount);
        vm.isMultiples = (!vm.validations.amountMultiples && vm.amount ? true : false) ||(vm.validations.amountMultiples && vm.amount && (vm.amount % vm.validations.amountMultiples === 0)) || false;
        $window.NumToWord(vm.amount, 'amountInWords', vm);
      } else {
        vm.isMax = !!(vm.validations.maxUnits && vm.validations.maxUnits < vm.units);
        vm.isMin = !!(vm.validations.minUnits && vm.validations.minUnits > vm.units);
        vm.isMultiples = false;
      }
      // vm.isInvalidForm = !vm.unitsDetails || (vm.amount <= 0 && vm.units <= 0) || (vm.amount && (vm.isMax || vm.isMin || (!vm.isMultiples && vm.validations.amountMultiples))) || !vm.unitsDetails.freeValueUnits || (vm.units && (vm.isMax || vm.isMin))
    }

    vm.redemSummary = function(){

        fetchNudgeDetails(function(status) {
          if (status) {
            redemptionConfirmModalShow();
          }
        });
        vm.isCheckedTandC = false;
        vm.email = vm.token.email ? vm.maskEmail(vm.token.email) : 'N/A';
        vm.mobileNumber = vm.token.mobileNumber ? vm.maskemobileNo(vm.token.mobileNumber) : 'N/A';
        vm.euinName = vm.formData.euin ? vm.formData.euin.euinName : '';
    }

    function fetchNudgeDetails(cb) {
      LoaderService.showLoader();
      var success = function(response) {

        vm.redeemNudgeDetails = response.data.popUpDescriptionList;
        vm.formData.exitLoad = response.data.exitLoad;
        vm.formData.capitalGain = response.data.capitalGain;
        LoaderService.hideLoader();
        cb(true);
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var valPayload = {
        "folioNumber":vm.formData.folioNumber,
        "schemeCode":vm.outSchemeCode,
        "transactionType": vm.transactionType,
        "redemptionAmount": vm.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT ? vm.amount : 0,
        "redemptionUnits": vm.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS ? vm.units :
          vm.amountType === vm.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS ? vm.units : 0
      };
      TransactionService.post({
        controller1: 'nudge',
        controller2: 'popup'
      },valPayload).$promise.then(success, error);
    }

    function redemptionConfirmModalShow() {
      vm.nudgePayload = {
        folioNumber: vm.formData.folioNumber,
        popUpType: "REDEMPTION_NUDGE"

      };
      if(angular.isUndefined(vm.redeemNudgeDetails.REDEMPTION_NUDGE)){
        vm.nudgePayload.nudgeSuccess = false;
        vm.nudgePayload.nudgePopup = true;
        nudgeRequest(vm.nudgePayload);
      }
      else {
      var success = function (resp) {
        if(resp.pop_status=='false') {
          vm.nudgePayload.nudgePopup = false;
        } else {
          vm.nudgePayload.nudgePopup = true;
        }
        if(resp.status=='stay'){
          vm.nudgePayload.nudgeSuccess = true;
          nudgeRequest(vm.nudgePayload);
        } else {
          vm.nudgePayload.nudgeSuccess = false;
          vm.showRedeemPreview = true;
          vm.formData.isSummaryViewEnabled = true;
          nudgeRequest(vm.nudgePayload);

        }
      }, error = function () {

      };
      ModalService.redemptionConfirmModal({message: vm.redeemNudgeDetails.REDEMPTION_NUDGE.popUpDescription,folioNumber: vm.formData.folioNumber},success, error);
    }
    }

    function nudgeRequest(nudgePayload) {

      LoaderService.showLoader();
      var successCallback = function(resp) {

          if(resp.status && resp.data) {
            if(!nudgePayload.nudgePopup){
              fetchNudgeDetails();
              LoaderService.hideLoader();
            }
            LoaderService.hideLoader();
            vm.requestId = resp.data.requestId;
            vm.nudgeMessage = resp.data.message;
            if(nudgePayload.nudgeSuccess == true) {
              var success = function () {
              }, error = function () {
                if( vm.arnHardcodedData){
                  AuthService.logoutInstantLogin().then(function () {
                    $state.go('logoutArn');
                  }, function () {
                    $state.go('logoutArn');
                  });
                }else{
                 vm.goToHome();
                }
              };
              ModalService.stayInvestedModal({message:vm.nudgeMessage}, success, error);
            } else {
              if(nudgePayload.popUpType === "REDEMPTION_NUDGE") {
                vm.moveToSummary();
              }
            }
          } else {
               MessageService.error("Something went wrong");
          }
        },
        errorCallback = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      TransactionService.post({
        controller1: 'nudge',
        controller2: 'request'
      }, nudgePayload).$promise.then(successCallback, errorCallback);
    }
    vm.showTermConditions = function () {
      ModalService.transactionalTermConditionModal({'transactionType':vm.transactionType,'subTransactionType':vm.formData.formType});
    };
    vm.submitRedeemFirst = function ($event) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                vm.submitForm($event);
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
            }
            else {
              vm.submitForm($event);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType: vm.formData.investmentType||vm.formData.formType,
        folioNumber: vm.formData.folioNumber,
        targetSchemeCode: vm.formData.inSchemeCode,
        schemeCode: vm.outSchemeCode,
        amount: vm.amountType==='amount'? vm.amount:undefined,
        units: vm.amountType === 'all_units'|| vm.amountType==='units'? vm.units:undefined
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'transaction',
        child2: 'check',
        child3: 'duplicate'
      }, payload).$promise.then(success, error);
    };

    function getRedeemPayload() {
      if (!vm.formData) {
        return null;
      }
      var payload = {
        folioNumber: vm.formData.folioNumber,
        formType: vm.formData.investmentType,
        schemeCode: vm.outSchemeCode,
        liquidFlag: vm.formData.liquidFlag,
        accountNumber: vm.formData.bankInfo.bankAcNo,
        ifscCode: vm.formData.bankInfo.ifscCode,
        bankName: vm.formData.bankInfo.bankName,
        branchName: vm.formData.bankInfo.bankBranch,
        payMech: vm.formData.bankInfo.payoutDescription,
        primaryBankFlag: vm.formData.bankInfo.primaryFlag,
        payoutId: vm.formData.bankInfo.payoutId,
        amount: vm.amount,
        id: vm.formData.isFavourite ? "" : vm.formData.transactionId,
        units: vm.units,
        transactionMode: vm.amountType.toUpperCase(),
        requestId: vm.formData.nudgeRequestID,
        exitLoad: vm.formData.exitLoad,
        capitalGain: vm.formData.capitalGain,
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        subBrokerArn: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN:'',
        subBrokerCode: vm.formData.subBrokerCode,
      };
      if(payload.amount == null || payload.amount == ''){
        payload.amount= 0;
      }
      payload = handleBrokerCode(payload);
      return angular.copy(payload);
    }

    function transactionOtmConfirmation($event, _config, payload) {
      var otpSuccessCallback, otpDismissCallback;
      otpSuccessCallback = function(resp) {
        LoaderService.hideLoader();
          vm.callApprove(_config, payload)
      };
      otpDismissCallback = function(err) {
        LoaderService.hideLoader();
      };
      LoaderService.showLoader();
      var modalPayload = {
        folioNumber: vm.formData.folioNumber,
        transactionType: vm.transactionType
      };
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var otpDetails = {
            secretOtpLink : resp.data.secretLink,
            otpSentMessage : resp.data.message || "OTP has been sent to your registered Email ID.",
            otpId : resp.data.id
          };
          var config = _config;
          payload.secretLink = resp.data.secretLink;
          ModalService.transactionOtpModal({
            otpPayload: otpDetails,
            config:  config,
            payload: payload
          }, otpSuccessCallback, otpDismissCallback);
        } else {
          LoaderService.hideLoader();
          vm.otpSentMessage = '';
          MessageService.error(resp.message)
        }
        vm.isProcessing = false;
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.otpResendMessage = '';
        vm.isProcessing = false;
        UtilService.errorHandler(err);
      };
      TransactionService.post({
        controller1: 'transaction',
        controller2: 'otp'
      }, modalPayload).$promise.then(success, error);
    }
    function callApprove(config,payload) {
      LoaderService.showLoader();
      var success, failure;
      success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (resp.status && resp.data) {
            localStorage.setItem('Transaction_Value',vm.amountType);
              vm.outSchemeValidations.transactionId=resp.data.data;
              vm.transactionType=vm.transactionType;
              vm.transactionId = resp.data.transactionId;
              vm.getSwitchTransactionSummary();
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        } else {
          LoaderService.hideLoader();
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message,
              isAadhar: true
            });
          } else {
            MessageService.error(resp.message);
          }
        }
      };
      failure = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      TransactionService.post(config,payload).$promise.then(success, failure);
    }


    function handleVpa() {
      if (vm.formData.virtualAddress) {
        vm.formData.virtualAddress = vm.formData.virtualAddress.toLowerCase();
        vm.formData.verifyUPIResp={};
      }
    }

    /**
     * Function responsible for setting emandate and upi form fields data related to date and amount
     * @param {Object} parsedDate : todayDate
     */


    function setEmandateUpiSetting(parsedDate) {
      vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
      vm.eMandatenoOfDays = vm.emandateObj.noOfDays;
      vm.eMandatemaxAmountLimit = vm.emandateObj.maxAmountLimit;
      vm.emandateMinAmountLimit = vm.emandateObj.minAmountLimit;
      vm.formData.emandateAmount = Math.floor(vm.emandateObj.defaultMandateAmount);
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
      checkAmountValidationEmandate();
      vm.mandateInfo = vm.emandateObj.mandateInfo;
      vm.minEndDateGapMandate = vm.emandateObj.minEndDateGap;
      vm.mandateMaxString = vm.emandateObj.maxAmountLimitInfo;
      vm.formData.emandateDate = $window.moment().add(vm.emandateObj.minStartDays,'days');
      updateEmandateEndDate();
      if (vm.enabledEndDates && vm.enabledEndDates.length === 0 && vm.formData.startDate) {
        updateEndDates();
      }
    }

    /**
     * Function responsible for checking blocked transaction flag for blocking transaction
     */

    function checkIsTxnBlock() {

      var bTransactionData =  $window.JSON.parse(localStorage.getItem('bTransaction'));

      if (bTransactionData && bTransactionData.bTransaction) {
        vm.blockFolioForTransaction = true;
        vm.popUpMessage = bTransactionData.bTransactionMessage;
        vm.popUpMessageHDFCNominee = bTransactionData.bTransactionMessageNomineeHdfcOneClick;
        vm.restrictRedemptionSwitch = true;
      }
    }

    /**
     * Function responsible for handling nominee sebi popup ok cta click for default transaction set up
     */

    function NomineePopupSuccess(){
      if(vm.blockFolioForTransaction){
        vm.formData.investmentType = "PURCHASE";
        vm.changeInvestmentType("PURCHASE");

        if (vm.arnHardcodedData && vm.arnHardcodedData.transactionType) {
          vm.arnHardcodedData.transactionType = 'PURCHASE';
          vm.arnHardcodedData.flowName = 'PURCHASE';
          localStorage.setItem("distributorDetails",$window.JSON.stringify(vm.arnHardcodedData));
        }
      }
    }

    // $scope.$on('$viewContentLoaded', function(){
    //   $timeout(function () {
    //     if ((vm.formData.investmentType === 'SWITCH' || vm.formData.investmentType === 'REDEMPTION') && vm.restrictRedemptionSwitch) {
    //
    //       if(vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank) {
    //
    //         if (vm.folioData) {
    //           if (vm.noNomination == null || vm.noNomination == "") {
    //             ModalService.genericModal({
    //               text: vm.popUpMessage,
    //               isHdfcNomineePopup : true,
    //               hdfcNomineePopupMessage : vm.popUpMessageHDFCNominee,
    //               isUpi : true,
    //               folioNumber : vm.formData.folioNumber
    //             }, NomineePopupSuccess);
    //           } else {
    //             ModalService.genericModal({text : vm.popUpMessage,isUpi : true}, NomineePopupSuccess);
    //           }
    //         }
    //       } else {
    //         ModalService.genericModal({text : vm.popUpMessage,isUpi : true}, NomineePopupSuccess);
    //       }
    //     }
    //   })
    // });
    vm.updateAmount = function(amount) {
      vm.formData.purchaseAmount = amount;
      vm.checkPurchaseValidations();
    }
    vm.schedulePurchaseChangeFrequency = function() {
      if (!vm.formData.isBackFromSummary) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        vm.formData.day = null;
        vm.formData.weeklyDay = null;
        vm.formData.month = null;
        vm.authenticationMode = null;
        vm.formData.isTillPerpetuity = false;
        vm.formData.bankInfo = null;
        resetBankDetails();
        reSetting();
      }
      vm.frequency = vm.formData.frequency;
      vm.calculateStartDate();
    }
    vm.calculateStartDate = function () {
      var success = function (resp) {
          if (resp.status && resp.data) {
              LoaderService.hideLoader();
              vm.nonBusinessDatess = resp.data.nonBuisnessDates;
              var enabledOTMStartDatesList = [];
              var currentDate = $window.moment().add(1, 'days');
              var startMaxDate = $window.moment().clone().add(30, 'days');
              var startDate = currentDate.clone();
              var freq = startMaxDate.diff($window.moment(), 'days');
              for (var i = 0; i <= freq; i++) {
                  var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
                  var isEnable = true;
                  // angular.isArray(vm.nonBusinessDatess) && vm.nonBusinessDatess.forEach(function (value) {
                  //     if ($window.moment(value, "DD-MMM-YYYY").diff(indexDate, 'days') == 0) {
                  //         isEnable = false;
                  //     }
                  // });
                  if (isEnable) {
                      enabledOTMStartDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
                  }
              }
              vm.enabledMINStartDates = angular.copy(enabledOTMStartDatesList[0]);
              vm.startMaxDate = startMaxDate;
              vm.enabledOTMStartDatesList = enabledOTMStartDatesList;
              for (var i = 0; i <= vm.enabledOTMStartDatesList.length; i++) {
                  if(moment(vm.arnHardcodedData.schedulerStartDate).format('DD-MMM-YYYY') == moment(vm.enabledOTMStartDatesList[i]).format('DD-MMM-YYYY')){
                    vm.formData.startDate = vm.arnHardcodedData && moment(vm.arnHardcodedData.schedulerStartDate).format('DD-MMM-YYYY');
                    break;
                  }else{
                    vm.formData.startDate = null;
                  }
              }

          } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
          }
      }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err);
      };
      LoaderService.showLoader();
      InvestorService.get({
          child1: 'nonBusinessDate',
          schemeCode: vm.formData.purchaseInSchemeCode
      }).$promise.then(success, error);
    }
    vm.changeScheduleStartDate = function (date) {
      vm.formData.startDate = date ? date : null;
      vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
      vm.formData.endDate = null;
      if(vm.formData.startDate){
        vm.updatePurchaseSchedulerEndDate();
     }
   };
   vm.updatePurchaseSchedulerEndDate = function () {
    var enabledEndDatesList = [];
    var currentDate = $window.moment();
    vm.endMinDate = currentDate;
    if(vm.formData.sipPaymentOption == "E-mandate"){
      vm.formData.isTillPerpetuity=false;
      var endDate = currentDate.clone().add(vm.emandateMaxYear, 'years');
    }else if(vm.formData.sipPaymentOption == "OTM"){
      var endDate = $window.moment(vm.formData.bankInfo.omExpiryDate);
    }else{
      var endDate = currentDate.clone().add(99, 'years');
    }
    // var endDate = $window.moment((new Date()), "DD-MMM-YYYY").add(99, 'years');
    vm.endMaxDate = endDate;
    currentDate = $window.moment(vm.formData.startDate);
    var frequencyDate = vm.formData.startDate ? vm.formData.startDate : $window.moment();
    var freq = 0;
    var i = 0;
    if (vm.formData.frequency === 'OW') {
        freq = endDate.diff(frequencyDate, 'days');
        for (i = 7; i <= freq; i += 7) {
            var indexDate = frequencyDate.clone().add(i, 'days').format("DD-MMM-YYYY");
            if ($window.moment(indexDate, "DD-MMM-YYYY").diff(frequencyDate, 'days') >= 7) {
                enabledEndDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
            }
        }
    } else if (vm.formData.frequency === 'OM') {
        freq = endDate.diff(currentDate, 'months');
        for (i = 1; i <= freq; i++) {
            var indexDate = frequencyDate.clone().add(i, 'months');
            var diff = $window.moment(indexDate.format("DD-MMM-YYYY")).diff(endDate.format("DD-MMM-YYYY"), "days");
            if (diff <= 0) {
                enabledEndDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
            }
        }
    } else if (vm.formData.frequency === 'FN') {
        freq = endDate.diff(currentDate, 'days');
        for (i = 15; i <= freq; i += 15) {
            var indexDate = frequencyDate.clone().add(i, 'days');
            var diff = $window.moment(indexDate.format("DD-MMM-YYYY")).diff(endDate.format("DD-MMM-YYYY"), "days");
            if (diff <= 0) {
                enabledEndDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
            }
        }
    }
    vm.formData.endDate = "";
    if (vm.formData.frequency == 'OM') {
        vm.minEndDate = angular.copy(enabledEndDatesList[0]);
        vm.enabledEndDateView = $window.moment(enabledEndDatesList[0], "DD-MMM-YYYY");
    }
    if (vm.formData.frequency == 'FN') {
        vm.minEndDate = angular.copy(enabledEndDatesList[2]);
        vm.enabledEndDateView = $window.moment(enabledEndDatesList[2], "DD-MMM-YYYY");
    }
    if (vm.formData.frequency == 'OW') {
        vm.minEndDate = angular.copy(enabledEndDatesList[2]);
        vm.enabledEndDateView = $window.moment(enabledEndDatesList[2], "DD-MMM-YYYY");
    }
    vm.enabledEndDates = enabledEndDatesList;
    for (var i = 0; i <= vm.enabledEndDates.length; i++) {
        if(moment(vm.arnHardcodedData.schedulerEndDate).format('DD-MMM-YYYY') == moment(vm.enabledEndDates[i]).format('DD-MMM-YYYY')){
          vm.formData.endDate = vm.arnHardcodedData && moment(vm.arnHardcodedData.schedulerEndDate).format('DD-MMM-YYYY');
          break;
        }else{
          vm.formData.endDate = null;
        }
    }
    if(vm.formData.startDate && vm.formData.endDate && new Date($window.moment(vm.formData.endDate)).getFullYear() == 2099){
      vm.formData.isTillPerpetuity = true;
      vm.setDec2099Date();
    }else{
      vm.formData.isTillPerpetuity = false;
    }
    // vm.changeTillPerpetuityFlag();
  }
  vm.setDec2099Date = function (tempData) {
    if(vm.formData.isTillPerpetuity && tempData != -1 && vm.formData.startDate){
      var ar = [];
      vm.enabledEndDates.forEach(function (el) {
          var one = el.format("DD-MM-YYYY");
          var two = one.split("-");
          if (two[1] == 12 && two[2] == '2099') {
              ar.push(two[0]);
          }
      });
      if(ar.length == 0 && vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM){
        MessageService.error("Schedule Purchase transaction end date cannot be greater than OTM Expiry date.");
        vm.formData.endDate = null;
        vm.isOTMEndDate = true;
        vm.formData.isTillPerpetuity = false;
        return;
      }
      vm.formData.endDate = moment("12/" + ar[ar.length - 1] + "/2099");
    }else{
      vm.formData.isTillPerpetuity = false;
      vm.formData.endDate = null;
       vm.changeScheduleEndDate(false);
    }

  }
  vm.amountErrorEmandate = false;
   vm.changeScheduleEndDate = function (enddate) {
    if(enddate && vm.formData.startDate){
      if(vm.formData.startDate && enddate){
        vm.dateDiff =  yearDiff(new Date($window.moment(vm.formData.startDate)),
                        new Date($window.moment(enddate)));
      }
      if((enddate && vm.formData.endDate && $window.moment(enddate).isBefore($window.moment($window.moment(vm.formData.endDate).format("MMM-YYYY"))))){
        vm.errorEmandate = true;
      }else{
        vm.errorEmandate = false;
      }
      vm.formData.endDate = enddate ? enddate : null;
      if((enddate && vm.formData.sipPaymentOption == "E-mandate" &&  vm.formData.endDateEmandate && $window.moment(vm.formData.endDateEmandate).isBefore($window.moment(enddate.format("MMM-YYYY"))))){
        vm.amountErrorEmandate = true;
      }else{
        vm.amountErrorEmandate = false;
        if(vm.formData.endDateEmandate && vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && ($window.moment(vm.formData.endDateEmandate, "MMM-YYYY").isBefore($window.moment(vm.formData.endDate, "MMM-YYYY")))){
          // MessageService.error("Schedule Purchase transaction end date cannot be greater than Mandate end date.");
          vm.formData.endDate = null;
          vm.noEmandateBank = true;
          if(vm.noECBank == false){
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING;
            if(!vm.noOTMBank){
              vm.formData.sipPaymentOption = "OTM";
              if(!vm.isOtmOtpVerified){
                generateOtp();
              }
            }
          }else{
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING;
          }
        }
        if(vm.formData.bankInfo && vm.formData.bankInfo.omExpiryDate && vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM && ($window.moment(vm.formData.bankInfo.omExpiryDate, "DD-MMM-YYYY").isBefore($window.moment(vm.formData.endDate, "DD-MMM-YYYY")))){
          MessageService.error("Schedule Purchase transaction end date cannot be greater than OTM Expiry date.");
          vm.formData.endDate = null;
          vm.isOTMEndDate = true;
          vm.formData.isTillPerpetuity = false;
          vm.setDec2099Date(-1);
        }else{
          vm.isOTMEndDate = false;
        }
      }
    }else{
      vm.amountErrorEmandate = false;
      if(vm.enabledEndDates && vm.enabledEndDates.length > 0 && enddate){
        for (var i = 0; i <= vm.enabledEndDates.length; i++) {
            if(moment(vm.arnHardcodedData.schedulerEndDate).format('DD-MMM-YYYY') == moment(vm.enabledEndDates[i]).format('DD-MMM-YYYY')){
              vm.formData.endDate = vm.arnHardcodedData && moment(vm.arnHardcodedData.schedulerEndDate).format('DD-MMM-YYYY');
              break;
            }else{
              vm.formData.endDate = null;
            }
        }
        if(vm.formData.startDate && vm.formData.endDate && new Date($window.moment(vm.formData.endDate)).getFullYear() == 2099){
          vm.formData.isTillPerpetuity = true;
          vm.setDec2099Date();
        }
      }else{
        vm.formData.endDate = null;
      }

      vm.formData.isTillPerpetuity = false;
    }
  }
  vm.changeEmgScheduleEndDate = function (enddate) {
    vm.formData.EmgendDate = enddate ? enddate : null;
  }
  vm.changedSchedulePaymentOption = function () {
    if (!vm.formData.isBackFromSummary) {
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.day = null;
      vm.formData.isTillPerpetuity = false;
      vm.formData.authMode = null;
      vm.authenticationMode = null;
      vm.enabledBillerStartDatesList=null;
      vm.formData.weeklyDay = null;
      reSetting();
      vm.schedulePurchaseChangeFrequency();
    }
    vm.disableEndDateSelection = false;
    vm.formData.bankInfo = null;
    vm.formData.otmId = '';
    vm.isOtmVisible = false;
    vm.formData.otmOtpVerified = vm.formData.otmOtpVerified === true ? vm.formData.otmOtpVerified: false;
    vm.isOtmOtpVerified = vm.formData.otmOtpVerified === true ? vm.formData.otmOtpVerified : false;
    vm.formData.ifscCode = null;
    vm.formData.accountType = null;
    // if(vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM){
    //   if(!vm.isOtmOtpVerified){
    //     generateOtp();
    //   }
    // }
    if(vm.formData.sipPaymentOption == "E-mandate"){
      vm.updatePurchaseEmandateEndDate();
      vm.formData.bankInfo = null;
      vm.formData.bankName = null;
    }
  };

  vm.fetchScheduleBankList = function(cb) {
    vm.formData.EmgAmount = null;
    cb = cb || function () {
    };
    LoaderService.showLoader();
    var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.emandateDetail = resp.data;
          vm.emandateMaxYear = vm.emandateDetail.maxMandateDurationYears;
          vm.formData.EmgAmount = 100000;
          vm.formData.emandateDate = $window.moment(new Date()).add(1, 'days');
          if(vm.formData.sipPaymentOption == "E-mandate"){
            vm.updatePurchaseEmandateEndDate();
          }
          if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
            vm.eMandatenoOfDays=resp.data.noOfDays;
            vm.eMandatemaxAmountLimit=resp.data.maxAmountLimit;
            vm.formData.showTopUpBlock = false;
            checkEMandateValidation();
          }
          vm.bankList = resp.data.bankList;
          if (vm.arnHardcodedData) {
            if (vm.arnHardcodedData.isHdfcBank) {
              vm.bankList = [];
              vm.bankList = $filter('filter')(resp.data.bankList,
                {
                  bankCode: 'HDFC'
                })
            }
          }
          for (var i = 0 ; i < vm.bankList.length ; i++) {
              vm.bankList[i].uniqueId = i;
            }
            vm.formData.authMode = vm.formData.bankInfo? (vm.formData.bankInfo.authenticationModes.length === 1 ? vm.formData.bankInfo.authenticationModes[0] : null) :null;
            vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
            if(vm.bankList.length == 0){
              vm.noEmandateBank = true;
            }else{
              vm.noEmandateBank = false;
            }
          if(vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction){
            vm.dateDiff =  yearDiff(new Date($window.moment(vm.arnHardcodedData.schedulerStartDate)),
                            new Date($window.moment(vm.arnHardcodedData.schedulerEndDate)));
            if(vm.formData.minorFlag || vm.dateDiff >vm.emandateMaxYear || (vm.purchaseValidations && vm.purchaseValidations.schemeType == "LIQUID") || vm.bankList == null || vm.bankList.length == 0){
              vm.noEmandateBank = true
              vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING;
            }else{
              vm.noEmandateBank = false;
              vm.formData.sipPaymentOption = vm.arnHardcodedData && vm.arnHardcodedData.paymentOption && vm.arnHardcodedData.paymentOption != "HEM"?vm.arnHardcodedData.paymentOption :
              !vm.noEmandateBank? vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE:vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING;
            }
          }
          if(vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
            vm.changedSchedulePaymentOption();
          }
        } else {
          vm.bankList = null;
          MessageService.error(resp.message);
        }
        cb(true);
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.bankList = null;
        UtilService.errorHandler(err);
        cb(false);
      };
      var data = {
        trnxType: vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler"?'PURCHASE':'SIP',
        liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false,
        folioNumber:vm.formData.folioNumber
      };
      IIHttpService.post({
        child1: 'folio',
        child2: 'emandate'
      }, data).$promise.then(success, error);
  }
  vm.checkECBankForPurchaseScheduler = function () {
    LoaderService.showLoader();
    var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.bankECList = resp.data.bankList;
          if (vm.arnHardcodedData) {
            if (vm.arnHardcodedData.isHdfcBank) {
              vm.bankECList = [];
              vm.bankECList = $filter('filter')(resp.data.bankList,
                {
                  bankCode: 'HDF'
                })
            }
          }
            if(vm.bankECList.length == 0){
              vm.noECBank = true;
            }else{
              vm.noECBank = false;
              if(vm.purchaseValidations && vm.purchaseValidations.schemeType == "LIQUID"){
                   vm.formData.sipPaymentOption = 'NETBANKING';
              }
            }
            if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler" &&
                (vm.arnHardcodedData.paymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING || vm.arnHardcodedData.paymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)){
                var tempVBankData = vm.bankECList.filter(function (value) {
                  if (value.accountNumber == vm.arnHardcodedData.accountNumber && value.ifscCode == vm.arnHardcodedData.ifscCode) { return value; }
                })[0];
                vm.formData.bankInfo = tempVBankData?tempVBankData:vm.formData.bankInfo;
              }
        } else {
          vm.bankECList = null;
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        vm.bankList = null;
        UtilService.errorHandler(err);
        cb(false);
      };
    var payload = {
      "trnxType": 'PURCHASE',
      "folioNumber": vm.formData.folioNumber,
      "liquidSchemeFlag": vm.formData.schemeType == 'LIQUID' ? true : false,
      "sipFlow": true
    };
    InvestorService.post({child1: 'bank', child2: 'list'}, payload).$promise.then(success, error);
  }
  vm.checkOTMForPurchaseScheduler = function () {
    var success = function (resp) {
      if (resp.status && resp.data) {
        LoaderService.hideLoader();
          if (resp.data.bankList.length != 0) {
            vm.isOTMEnabled = true;
            vm.noOTMBank = false;
            vm.OTMbankList = resp.data.nonCOTMBankList;
            if (vm.arnHardcodedData) {
              if (vm.arnHardcodedData.isHdfcBank) {
                vm.OTMbankList = resp.data.bankList;
                var tempBank = [];
                vm.OTMbankList.forEach(function(item){
                  if(item.bankName && item.bankName.includes('HDFC')){
                    tempBank.push(item);
                  }
              })
              vm.OTMbankList = tempBank;
              }

              if(vm.arnHardcodedData && vm.arnHardcodedData.transactionType == "Purchase_Scheduler" &&
                vm.arnHardcodedData.paymentOption == 'OTM'){
                var tempVBankData = vm.OTMbankList.filter(function (value) {
                  if (value.bankAcNo == vm.arnHardcodedData.accountNumber && value.ifscCode == vm.arnHardcodedData.ifscCode) { return value; }
                })[0];
                vm.formData.bankInfo = tempVBankData?tempVBankData:vm.formData.bankInfo;
              }
            }
          }else{
            vm.isOTMEnabled = false;
            vm.noOTMBank = true;
          }
      }
    }, error = function (err) {
      LoaderService.hideLoader();
      UtilService.errorHandler(err);
      cb(false);
    };
    LoaderService.showLoader();
    var payload = {
      transactionType: vm.transactionType.toLowerCase(),
      folioNo: vm.formData.folioNumber
    };
    IIHttpService.post({
      child1: 'folio',
      child2: 'otm'
    }, payload).$promise.then(success, error);
  }
  vm.errorEmandate = false;
  vm.changeScheduleEndDateEmandate = function(date) {
    if((date && vm.formData.sipPaymentOption == "E-mandate" &&  vm.formData.endDateEmandate && $window.moment(vm.formData.endDateEmandate).isBefore($window.moment(date.format("MMM-YYYY"))))){
      vm.amountErrorEmandate = true;
    }else{
      vm.amountErrorEmandate = false;
    }
    vm.formData.endDateEmandate = date ? date : null;
    if((date && vm.formData.endDate && $window.moment(date).isBefore($window.moment($window.moment(vm.formData.endDate).format("MMM-YYYY"))))){
      vm.errorEmandate = true;
    }else{
      vm.errorEmandate = false;
      if (vm.formData.endDate) {
        vm.changeScheduleEndDate(vm.formData.endDate);
      }
    }
  }
  vm.updatePurchaseEmandateEndDate= function() {
    if (!vm.formData.emandateDate) {
      return;
    }

    var enabledEndDates = [];
    vm.formData.endDateEmandate = '';
    if(vm.formData.emandateDate)
    {
      vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateDetail.minEndDateGap, 'year');
      vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateDetail.maxMandateDurationYears, 'years').subtract(1,'days');
    }

    var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
    for (var i = 0; i <= freq; i++) {
      enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
    }
    vm.enabledEmandateEndDatesList = enabledEndDates;
    vm.endDateViewEmandate = enabledEndDates[0].clone();
    vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
  }
  function checkAmountValidation() {
    if(vm.formData.EmgAmount && vm.formData.purchaseAmount && vm.formData.EmgAmount < vm.formData.purchaseAmount){
      vm.amountLess = true;
    }
    else{
      vm.amountLess = false;
    }
    if(vm.emandateDetail && vm.formData.EmgAmount && vm.formData.EmgAmount > vm.emandateDetail.maxAmountLimit){
      vm.amountMore = true;
    }
    else{
      vm.amountMore = false;
    }
  }
  function getPurchaseSchedulePayload() {
    var payload = {
      "folio_number": vm.formData.folioNumber,
      "panNumber":vm.token.investorPAN,
      "scheme_code": vm.formData.purchaseInSchemeCode,
      "dividend_option": vm.formData.purchaseDividendOption,
      "frequency":vm.formData.frequency,
      "purchase_scheduler_start_date": $window.moment(vm.formData.startDate, "DD-MMM-YYYY").format("DD-MMM-YYYY"),
      "purchase_scheduler_end_date":$window.moment(vm.formData.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY"),
      "installment_amount": vm.formData.purchaseAmount,
      "sub_brok_Code": vm.formData.subBrokerCode,
      "euin": vm.formData.euin && vm.formData.euin.euinCode? vm.formData.euin.euinCode : "",
      "euin_preference": vm.formData.euinOpted,
      "purchaseDay":"",
      "paymentOption":vm.formData.sipPaymentOption == 'E-mandate'? 'HEM':vm.formData.sipPaymentOption
    };
    if(vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM){
      payload.omStartDate=vm.formData.bankInfo.omStartDate;
      payload.omEndDate=vm.formData.bankInfo.omExpiryDate;
      payload.payoutId = vm.formData.bankInfo.payoutId;
    }
    if(vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE){
      payload.emandate_amount=vm.formData.EmgAmount;
      payload.omStartDate =$window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
      payload.omEndDate=  $window.moment(vm.formData.endDateEmandate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
    }

    payload = handleBrokerCodeForSchedulePurchase(payload);
    payload = vm.addSchedulePurchaseBankInfo(payload)
    return payload;
  }
  vm.addSchedulePurchaseBankInfo = function(payload) {
    payload.payoutId= vm.formData && vm.formData.bankInfo && vm.formData.bankInfo.payoutId ? vm.formData.bankInfo.payoutId : "";
    if(vm.formData.bankInfo){
      if(vm.formData.sipPaymentOption == 'OTM'){
        payload.bankDetails = {
          "accNumber": vm.formData.bankInfo.bankAcNo,
          "accType": vm.formData.bankInfo.bankAcType,
          "bankName": vm.formData.bankInfo.bankName,
          "branchName": vm.formData.bankInfo.bankBranch,
          "ifscCode": vm.formData.bankInfo.ifscCode,
          "payMech": vm.formData.sipPaymentOption,
        }
      }
      if(vm.formData.sipPaymentOption == 'NETBANKING' || vm.formData.sipPaymentOption == 'UPI'){
        payload.bankDetails = {
          "accNumber": vm.formData.bankInfo.accountNumber,
          "accType": vm.formData.bankInfo.bankAcType,
          "bankCity": vm.formData.bankInfo.bankCity,
          "bankName": vm.formData.bankInfo.bankNameOnly,
          "branchName": vm.formData.bankInfo.bankBranch,
          "ifscCode": vm.formData.bankInfo.ifscCode,
          "payMech": vm.formData.sipPaymentOption,
          "authenticationMode": "",
          "paymentOption": vm.formData.sipPaymentOption
        }
      }
      if(vm.formData.sipPaymentOption == 'E-mandate'){
          payload.bankDetails = {
            "accNumber": vm.formData.bankInfo.accountNumber,
            "accType": vm.formData.bankInfo.bankAcType,
            "bankCity": vm.formData.bankInfo.bankCity,
            "bankName": vm.formData.bankInfo.bankNameOnly,
            "branchName": vm.formData.bankInfo.bankBranch,
            "ifscCode": vm.formData.bankInfo.ifscCode,
            "bankCode": vm.formData.bankInfo.bankCode,
            "payMech": 'HEM',
            "authenticationMode": vm.formData.authMode &&  vm.formData.authMode.value ? vm.formData.authMode.value:null,
            "paymentOption": 'HEM'
        }
      }
    }
    return payload;
  }
  vm.modifyTransaction = function() {
    var payload = null;
    payload = vm.getPurchaseSchedulePayload();
    if (!payload) {
      MessageService.error('Something went wrong while calculating payload.');
      return;
    }
    LoaderService.showLoader();
    var success = function (resp) {
      LoaderService.hideLoader();
      if (resp.status && resp.data) {
        if (resp.data.scheduleId) {
          vm.showTransactionSuccessfulPage = true;
          vm.schedulerResponseData = resp.data;
          if(vm.formData.sipPaymentOption === 'E-mandate') {
            vm.showTransactionSuccessfulPage = false;
            handlePurchaseResponse(vm.schedulerResponseData);
          }
        }else{
          MessageService.error(resp.data.trnxActionMsg);
        }
      } else {
        MessageService.error(resp.message);
      }
    },error = function (err) {
      LoaderService.hideLoader();
      UtilService.errorHandler(err);
      if(!err){
        MessageService.error("Something went wrong. Please try again later.");
      }
    };
    if(vm.arnHardcodedData){
      payload.utmSource = vm.arnHardcodedData.utmSource;
      payload.utmMedium = vm.arnHardcodedData.utmMedium;
      if(vm.arnHardcodedData.transactionType == 'Purchase_Scheduler' && vm.arnHardcodedData.schedulerId){
        payload.purchaseScheduleId = vm.arnHardcodedData.schedulerId;
      }
      payload.uniqueLinkId = vm.arnHardcodedData.chipherText;
    }
    vm.schedulePurchasePayload = payload;
    if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
      var successCallback = function () {
        InvestorService.post({
          child1: 'gigworker',
          child2: 'save'
        }, payload).$promise.then(success, error);
      };
      var errorCallback = function () {
        LoaderService.hideLoader();
        vm.isCheckedTandC=true;
        vm.isCheckedTandCeMandate = true;
      };
      ModalService.registerEMandateModal(
        {bankName:vm.formData.bankInfo.bankName.substring(0,vm.formData.bankInfo.bankName.indexOf("-")),
          noOtpConfirmModal: true,
          authMode: vm.formData.authMode.value
        },successCallback,errorCallback)
      LoaderService.hideLoader();
    }else{
      InvestorService.post({
        child1: 'gigworker',
        child2: 'save'
      }, payload).$promise.then(success, error);
    }
  }


  vm.showTermConditionsEmandateForSchedulePurchase = function(){
    ModalService.transactionalTermConditionModalEMandate({'transactionType': 'Purchase_Scheduler','subTransactionType':"Purchase_Scheduler"});
  }
  if(!identifierData.minor){
  vm.getFoiloDetails();
  }
  vm.amountEMgMore = false;
  vm.checkAmountValidationSchedule = function() {
    if(vm.emandateDetail && vm.formData.EmgAmount && vm.formData.EmgAmount < vm.emandateDetail.minAmountLimit){
      vm.amountLess = true;
    }
    else{
      vm.amountLess = false;
    }
    if(vm.emandateDetail && vm.formData.EmgAmount && vm.formData.EmgAmount > vm.emandateDetail.maxAmountLimit){
      vm.amountMore = true;
    }
    else{
      vm.amountMore = false;
    }
    if( vm.emandateDetail && vm.formData.purchaseAmount && vm.formData.EmgAmount && vm.formData.purchaseAmount > vm.formData.EmgAmount){
      vm.amountEMgMore = true;
    }
    else{
      vm.amountEMgMore = false;
    }
    if(vm.formData && vm.formData.sipPaymentOption == "OTM" && vm.formData.investmentType == "Schedule_Transaction" &&
      vm.formData.bankInfo && vm.formData.bankInfo.maxAmount && vm.formData.purchaseAmount &&
      vm.formData.purchaseAmount > vm.formData.bankInfo.maxAmount){
      vm.OtmAmountMax = true;
    }else{
      vm.OtmAmountMax = false;
    }
  }

  function paymentOptionOrdering(){
    // Get the index of OTM and EC in the array
    var otmIndex = vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM);
    var ecIndex = vm.paymentOptions.indexOf(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC);

    // Check if OTM exists and add EMANDATE after OTM, else add it before EC, or at the end if both don't exist
    if (otmIndex !== -1) {
      vm.paymentOptions.splice(otmIndex + 1, 0, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
    } else if (ecIndex !== -1) {
      vm.paymentOptions.splice(ecIndex, 0, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE);
    } else {
      vm.paymentOptions.push(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE); // Add to the end if neither exist
    }
  }
    function hideUPIDetails() {
      if(vm.paymentOptions && ( vm.arnHardcodedData || vm.PARTNER_DATA || vm.arnHardcodedData && vm.arnHardcodedData.isHdfcBank)) {
        var index = vm.paymentOptions.indexOf('UPI');
        if(index > -1) {
          vm.paymentOptions.splice(index,1);
        }
      }
    }
  }
})();

/**
 * Created by sandeepchhapola on 19/11/16.
 */
 (function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('InstantLoginHomeController', instantLoginHomeController);

  /** @ngInject */
  function instantLoginHomeController($rootScope, $timeout, AuthService,$window, LoaderService, $interval, $state,HDFC_API) {
    var vm = this;
    vm.isLoading = false;
    var identifierData = AuthService.getInstaToken();
    // var removeListeners = {};
    vm.arnHardcodedData = $window.JSON.parse(localStorage.getItem("distributorDetails"));
    vm.PARTNER_DATA =  JSON.parse(sessionStorage.getItem("PARTNER_DATA"));
    if(vm.arnHardcodedData && !identifierData){
      var identifierData = $window.JSON.parse(localStorage.getItem("identifierData"));
    }
    vm.investorName = identifierData ? identifierData.investorName : 'Investor Name';
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    /*var resetFlag = function () {
      $timeout(function () {
        localStorage.setItem('isRefreshing', false);
      }, 2000);
    };*/

    //This code is added for testin commonservice of uat environment and will be removed very soon
    vm.init = function () {
      // setListeners();
      vm.isLoading = true;
      LoaderService.showLoader('.main-loader');
      // init();
    };


    vm.logoutMe = function () {
      if( vm.arnHardcodedData ){
        AuthService.logoutInstantLogin().then(function () {
          if(vm.arnHardcodedData.transactionType == 'Purchase_Scheduler'){
            $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.arnHardcodedData.chipherText+"?ScheduleTransaction=true";
          }else{
            $state.go('logoutArn');
          }
        }, function () {
          if(vm.arnHardcodedData.transactionType == 'Purchase_Scheduler'){
            $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.arnHardcodedData.chipherText+"?ScheduleTransaction=true";
          }else{
            $state.go('logoutArn');
          }
        });
      }else{
        AuthService.logoutInstantLogin().then(function () {
          $state.go('instantLogin');
        }, function () {
          $state.go('instantLogin');
        });
      }
      if(vm.PARTNER_DATA){
        sessionStorage.removeItem('PARTNER_DATA');
      }

    };
  }
})();

/**
 * Created by sandeepchhapola on 19/11/16.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('HomeController', homeController);

  /** @ngInject */
  function homeController(ModalService) {
    // var vm = this;
    var successModal = function () {
      },
      errorModal = function () {
      };

    ModalService.loginloaderModal({}, successModal, errorModal);
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('GolbalSearchController', golbalSearchController);

  function golbalSearchController(HDFC_API, UtilService, AppConstants, $state, LoaderService, MessageService, $stateParams, $timeout, $http) {
    var vm = this;
    vm.searchResult = null;
    vm.isPagination = false;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.isLoading = false;
    vm.searchResult = null;

    vm.count = 0;
    vm.currentPage = 1;
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];
    vm.searchPayload = {
      count: vm.count,
      pageIndex: vm.currentPage,
      pageLimit: vm.selectedPageLimit
    };
    vm.searchString = $stateParams.searchString;
    vm.isSearching = false;

    vm.init = function () {
      vm.getSearchList(vm.searchPayload);
    };

    vm.investorDetails = function (result) {
      $state.go('main.investors.profile.portfolio', {investorId: result.uuid});
    };

    vm.limitChanged = function () {
      vm.currentPage = 1;
      vm.searchPayload.pageIndex = vm.currentPage;
      vm.searchPayload.pageLimit = vm.selectedPageLimit;
      vm.getSearchList(vm.searchPayload);
    };

    vm.getSearchList = function (searchPayload) {
      var success = function (resp) {
          resp = resp.data;
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.searchResult = resp.data.searchResponse;
            vm.count = resp.data.count;
            vm.isPagination = !!(vm.searchResult && vm.searchResult.length);
          } else {
            vm.searchResult = null;
            vm.count = 0;
            vm.isPagination = false;
            !resp.status && MessageService.error(resp.message)
          }
          LoaderService.hideLoader();
          vm.isLoading = false;
          angular.element('#searchbox').trigger("blur");
        },
        error = function (err) {
          vm.searchResult = null;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.isLoading = false;
          vm.isPagination = false;
        };
      if (vm.isSearching || !vm.searchString || vm.searchString.length < 1) {
        return;
      }

      vm.searchResult = null;
      vm.isSearching = true;
      LoaderService.showLoader();
      vm.isLoading = true;
      searchPayload.pageIndex = vm.currentPage - 1;
      searchPayload.pageLimit = vm.selectedPageLimit;
      searchPayload.count = vm.count;
      $timeout(function () {
        vm.isSearching = false;
      }, 200);

      LoaderService.showLoader('.popup');

      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/search/' + vm.searchString;
      $http.post(_path, searchPayload, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .config(firstLogin);

  /** @ngInject */
  function firstLogin($stateProvider) {
    $stateProvider
      .state('welcome', {
        url: '/welcome',
        template: '<ui-view></ui-view>',
        controller: 'FirstLoginWelcomeController',
        controllerAs: 'Welcome',
        authenticate: true,
        resolve: {welcomeScreen: _welcomeScreen}
      })
      .state('welcome.newUserWelcome', {
        url: '',
        templateUrl: 'app/firstLogin/welcome/firstLogin.welcome.html',
        controller: 'FirstLoginWelcomeController',
        controllerAs: 'Welcome',
        authenticate: true
      })
      .state('welcome.existingUserWelcome', {
        url: '',
        templateUrl: 'app/firstLogin/welcome/existingLogin.welcome.html',
        controller: 'FirstLoginWelcomeController',
        controllerAs: 'Welcome',
        authenticate: true
      })
      .state('folioDetails', {
        url: '/folioDetails',
        templateUrl: 'app/firstLogin/folioDetails/folioDetails.html',
        controller: 'FirstLoginFolioDetailsController',
        controllerAs: 'FolioDetailsParent',
        defaultRoute: '.folioCreation',
        authenticate: true
      })
      .state('folioDetails.holdMode', {
        url: '/holdMode?investorId',
        templateUrl: 'app/firstLogin/folioDetails/holdMode/holdMode.html',
        controller: 'FirstLoginHoldModeController',
        controllerAs: 'HoldMode',
        // parent: 'folioDetails',
        authenticate: true,
        resolve: {checkUserAccess: _checkUserAccess}
      })
      .state('folioDetails.folioCreation', {
        url: '/folioCreation?investorId',
        templateUrl: 'app/firstLogin/folioDetails/folioCreation/folioCreation.html',
        controller: 'FirstLoginFolioCreationController',
        controllerAs: 'FolioDetails',
        // parent: 'folioDetails',
        authenticate: true,
        resolve: {checkUserAccess: _checkUserAccess}
      })
      .state('folioDetails.incomeDetails', {
        url: '/incomeDetails?investorId',
        templateUrl: 'app/firstLogin/folioDetails/incomeDetails/incomeDetails.html',
        controller: 'FirstLoginIncomeDetailsController',
        controllerAs: 'FolioDetails',
        // parent: 'folioDetails',
        authenticate: true,
        resolve: {checkUserAccess: _checkUserAccess}
      })
      .state('folioDetails.incomeDetailsMinor', {
        url: '/incomeDetailsMinor',
        templateUrl: 'app/firstLogin/folioDetails/incomeDetails/incomeDetails.minor.html',
        controller: 'FirstLoginIncomeDetailsMinorController',
        controllerAs: 'FolioDetails',
        // parent: 'folioDetails',
        authenticate: true,
        resolve: {checkUserAccess: _checkUserAccess}
      })
      .state('folioDetails.politicalExposed', {
        url: '/politicalExposed',
        templateUrl: 'app/firstLogin/folioDetails/politicalExposed/politicalExposed.html',
        controller: 'FirstLoginPoliticalExposedController',
        controllerAs: 'FolioDetails',
        // parent: 'folioDetails',
        authenticate: true,
        resolve: {checkUserAccess: _checkUserAccess}
      })
      .state('folioDetails.taxResidency', {
        url: '/taxResidency',
        templateUrl: 'app/firstLogin/folioDetails/taxResidency/taxResidency.html',
        controller: 'FirstLoginTaxResidencyController',
        controllerAs: 'FolioDetails',
        // parent: 'folioDetails',
        authenticate: true,
        resolve: {checkUserAccess: _checkUserAccess}
      })
      .state('folioDetails.taxResidencyMinor', {
        url: '/taxResidencyMinor',
        templateUrl: 'app/firstLogin/folioDetails/taxResidency/taxResidency.minor.html',
        controller: 'FirstLoginTaxResidencyMinorController',
        controllerAs: 'FolioDetails',
        // parent: 'folioDetails',
        authenticate: true,
        resolve: {checkUserAccess: _checkUserAccess}
      })

      .state('folioDetails.jointholders', {
        url: '/jointHolders/:investorId',
        templateUrl: 'app/firstLogin/folioDetails/jointHolders/jointHolders.html',
        controller: 'FirstLoginJointHoldersController',
        controllerAs: 'JointHolders',
        authenticate: true,
        resolve: {
          jhPANDetails: ['$q', '$state', '$timeout', '$window', 'MessageService', 'InvestorFolioModel', 'ModalService',
            function ($q, $state, $timeout, $window, MessageService, InvestorFolioModel, ModalService) {
              var deferred = $q.defer(),
                model = angular.fromJson($window.sessionStorage.investorForm) || InvestorFolioModel.getInvestorFolioFormDataModel() || InvestorFolioModel.getNewInvestorFolioModel(),
                successPanDetails = function (result) {
                  if (result.data && result.data.kycverified) {
                    /!*Check repeated pan number*!/
                    if (
                      model.soleApplicantDetail.selfDetail
                      && model.soleApplicantDetail.selfDetail.panNumber
                      && model.soleApplicantDetail.selfDetail.panNumber != result.data.pan
                    ) {

                      var newModel = InvestorFolioModel.getNewJointHolder();
                      model.jointHolders = angular.isDefined(model.jointHolders)?
                        model.jointHolders:[];
                      model.jointHolders[0] = newModel;
                      model.jointHolders[0].jointHolderName = result.data.name;
                      model.jointHolders[0].pan = result.data.pan;
                      model.jointHolders[0].email = result.data.email;
                      model.jointHolders[0].mobileNumber = result.data.mobileNumber;
                      InvestorFolioModel.setInvestorFolioModel(model);
                      $window.sessionStorage.investorForm = angular.toJson(model);
                      deferred.resolve();

                    } else {
                      MessageService.error("A valid PAN details required to add joint holder");
                      $timeout(function () {
                        $state.go('folioDetails.folioCreation');
                      });
                      deferred.reject();
                    }
                  }
                },
                errorPanDetails = function (arg) {
                  (angular.isUndefined(arg)||arg==='viaCrossButton') && MessageService.error("A valid PAN details required to add joint holder");
                  $timeout(function () {
                    $state.go('folioDetails.folioCreation');
                  });
                  deferred.reject();
                };
              if ((model.jointHolders
                  && model.jointHolders.length == 0)||angular.isUndefined(model.jointHolders)) {
                var labelSetter = {
                  type: 'jointholders',
                  label: {header: 'ADD JOINT HOLDER', pan: 'PAN', dob: 'Joint Holder DOB'}
                };
                ModalService.checkPan4Holder(labelSetter, successPanDetails, errorPanDetails);
              } else {
                deferred.resolve();
              }

              return deferred.promise;
            }]
        }
      })
      .state('folioDetails.addNominee', {
        url: '/addNominee/:investorId',
        templateUrl: 'app/firstLogin/folioDetails/addNominee/addNominee.html',
        controller: 'FirstLoginAddNomineeController',
        controllerAs: 'FolioDetails',
        // parent: 'folioDetails',
        authenticate: true,
        resolve: {
          checkUserAccess: _checkUserAccess,
          dynamicData : _fetchDynamicData}
      })
      .state('folioDetails.bankDetails', {
        url: '/bankDetails/:investorId',
        templateUrl: 'app/firstLogin/folioDetails/bankDetails/bankDetails.html',
        controller: 'FirstLoginBankDetailsController',
        controllerAs: 'FolioDetails',
        // parent: 'folioDetails',
        authenticate: true,
        resolve: {
        checkUserAccess: _checkUserAccess,
        dynamicData: _fetchDynamicData
        }
      })
      .state('folioDetails.review', {
        url: '/review/:investorId',
        templateUrl: 'app/firstLogin/folioDetails/review/review.html',
        controller: 'FirstLoginReviewController',
        controllerAs: 'FolioDetails',
        // parent: 'folioDetails',
        authenticate: true,
        resolve: {checkUserAccess: _checkUserAccess}
      })
  }


  /** @ngInject */
  function _welcomeScreen($state, $timeout, AppConstants, AuthService, HDFC_API, MessageService, UtilService) {

    var identifierData = AuthService.getToken();
    //identifierData.investorType = AppConstants.INVESTOR_TYPE.NEW;
    if (identifierData && identifierData.investorType) {
      if (identifierData.investorType === AppConstants.INVESTOR_TYPE.NEW) {
        if (identifierData.landingPageType === AppConstants.LANDING_PAGE_TYPE.FOLIO_CREATION) {
          $timeout(function () {
            $state.go('welcome.newUserWelcome');
          });
        } else {
          $timeout(function () {
            $state.go('welcome.existingUserWelcome.widgets');
          });
        }
      } else {
        if((identifierData && angular.isUndefined(identifierData.isDataUpdated)) && (HDFC_API.ENV == 'prod' || HDFC_API.ENV == 'beta')){
          $timeout(function () {
            $state.go('home');
          });
        } else {
          $timeout(function () {
            $state.go('welcome.existingUserWelcome.widgets');
          });
        }
      }

    } else {
      $timeout(function () {
        AuthService.logout().then(function () {
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          $state.go('sessionExpired');
        }, function (err) {
          if(err && err.status==401){
            AuthService.getRefreshToken(identifierData).then(function () {
              if(localStorage.getItem('doLogOut')){
                AuthService.logout().then(function () {
                  AuthService.clearCookies(AppConstants.IDENTIFIER) ;
                  $state.go('sessionExpired');
                }, function () {
                  $state.go('sessionExpired');
                });
              }else{$state.reload();}
            }, function () {
              AuthService.clearCookies(AppConstants.IDENTIFIER);
              MessageService.clear();
              $state.go('sessionExpired');
            });
          }else{
            AuthService.logout().then(function () {
              $state.go('sessionExpired');
            }, function () {
              AuthService.clearCookies(AppConstants.IDENTIFIER);
              MessageService.clear();
              $state.go('sessionExpired');
            });
          }
        });
      }, 0)
    }
  }

  /** @ngInject */
  function _checkUserAccess($state, $timeout, AppConstants, AuthService) {

    var identifierData = AuthService.getToken();
    if (identifierData && identifierData.investorType) {
      if (identifierData.investorType != AppConstants.INVESTOR_TYPE.NEW) { // Existing user should be avoided
        $timeout(function () {
          $state.go('main.dashboard.widgits');
        }, 0);
      } else {
        return true;
      }
    } else {
      $timeout(function () {
        AuthService.logout().then(function () {
          AuthService.clearCookies(AppConstants.IDENTIFIER);
          $state.go('sessionExpired');
        }, function () {
          //$state.go('login');
        });
      }, 0)
    }
  }

   /** @ngInject */
   function _fetchDynamicData(UtilService) {
     return UtilService.fetchDynamicData("FOLIO_CREATION");
   }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FeedbackController', feedbackController);

  function feedbackController(FeedbackService, MessageService, $state, $log, LoaderService, ModalService, AppConstants,$window) {
    var vm = this;
    var locselectedLinkPanData = sessionStorage.getItem('selectedLinkPanData'); 
    if(locselectedLinkPanData){
        locselectedLinkPanData = $window.CryptoJS.AES.decrypt(locselectedLinkPanData.toString(), 'LinkPanData');
        locselectedLinkPanData = $window.JSON.parse(locselectedLinkPanData.toString($window.CryptoJS.enc.Utf8));
        if(locselectedLinkPanData && !locselectedLinkPanData.default){
            $state.go("welcome");
        }
    }
    vm.formData = {
      feedback: 'IMPROVEMENT',
      feedbackArea: ""
    };
    vm.changeFeedback = changeFeedback;
    vm.submitFeedback = submitFeedback;
    vm.confirmCancel = confirmCancel;
    vm.special_Char = new RegExp(/[#$%^+\=\[\];\\|<>\/]+/);
    vm.formInputChange = formInputChange;
    vm.constant = AppConstants;


    function changeFeedback() {
      vm.formData.feedbackArea = "";
    }

    function submitFeedback() {
      var payload={
        "category": vm.formData.feedback,
        "suggestion": vm.formData.feedbackArea
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            var success = function () {
                vm.formData = {
                  feedback: 'IMPROVEMENT',
                  feedbackArea: ""
                };
              };
            var failure = function() {
              vm.formData = {
                feedback: 'IMPROVEMENT',
                feedbackArea: ""
              };
            };
            ModalService.feedbackModal({}, success, failure);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('error: ', err);
          LoaderService.hideLoader();
          MessageService.error();
        };
      LoaderService.showLoader();
      FeedbackService.post({controller: 'save'}, payload).$promise.then(success, error);
    }

    function confirmCancel() {
      var success = function () {
          $state.go('main.dashboard')
        };
      ModalService.confirmCancelModal({}, success);
    }

    function formInputChange() {
      if (vm.formData.feedbackArea) {
        vm.isInValid = vm.special_Char.test(vm.formData.feedbackArea);
      }
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('FaqController', faqController);

  function faqController(faqData) {
    var vm = this;
    vm.date = new Date();
    vm.scroll = function (id) {
      var elmnt = document.getElementById(id);
      elmnt.scrollIntoView();
    }
    if (faqData.faqDTO.faqDTOMap.FAQ_Content) {
      vm.faqData = faqData.faqDTO.faqDTOMap.FAQ_Content.content;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ExposedStatementsController', ExposedStatementsController);

  /** @ngInject */
  function ExposedStatementsController($state, $stateParams,  $window, LoaderService, MessageService, AppConstants, AuthService, InvestorService) {
    var vm = this;
    vm.authenticateUsingOtpFlag = true;
    vm.showOtpField = false;
    vm.loginUsingOtpFlag = false;
    vm.generateOtp = generateOtp;
    vm.validateOtp = validateOtp;
    vm.requestId = "";

    function generateOtp() {
      var success = function (resp) {
          vm.showOtpField = true;
          vm.loginUsingOtpFlag = true;
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.sentOtpRespMsg = resp.message;
            vm.requestId = resp.data.requestId;
            vm.exposedToken = resp.data.token;
            AuthService.setInstaToken(resp.data);
            $window.sessionStorage.setItem("isExposedStatementActive", true);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      var payload= {
        "folioNumber": vm.folioNumber
      };
      LoaderService.showLoader();
      AuthService.generateOtp(payload, 'fromExposedStatements').then(success, error);
    }


    function validateOtp() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            MessageService.clear();
            $state.go('exposedStatements',{folioNumber:vm.folioNumber,tabType : $stateParams.tab});
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      var payload= {
        "otpNumber": vm.otp,
        "requestId": vm.requestId
      };
      LoaderService.showLoader();
      InvestorService.post({
        child1: 'exposed',
        child2: 'statement',
        child3: 'otp',
        child4: 'verify'
      }, payload).$promise.then(success, error);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('ekycController', ekycController);

  /** @ngInject */
  function ekycController($stateParams, LoaderService, $timeout, $sce,AppConstants,InvestorService,UtilService,MessageService, $window, InvestorServiceVersion3, AuthService, toastr, ModalService, $state, FormatterService) {
    var vm=this;
    vm.ekycData = {};
    vm.formData = {};
    vm.actionUrl = "";
    vm.payload = {email: '', mobile: '',sessId: ''};
    vm.init = init();
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.pattern = AppConstants;
    vm.KYC_STATUS = AppConstants.KYC_STATUS;
    /** --------------------------------------ekyc initialisation section----------------------------------------------------------*/

    function init() {
      if ($stateParams.prefill) {
        LoaderService.showLoader();
        readObject($stateParams.prefill);
      } else {
        vm.ekycData = $stateParams.ekycRequestCO || JSON.parse(sessionStorage.getItem("ekycRequestCO"));
        vm.mobileLoginPandetails = sessionStorage.getItem('MobilePanLoginDetails')?JSON.parse(sessionStorage.getItem('MobilePanLoginDetails')) :null;
        vm.prefillMobile = vm.mobileLoginPandetails && vm.mobileLoginPandetails.mobile ? true:false;
        if(vm.prefillMobile){
          vm.payload.mobile = vm.mobileLoginPandetails.mobile;
        }
        if (vm.ekycData) {
          vm.actionUrl = $sce.trustAsResourceUrl(vm.ekycData.camsUrl);
          vm.formData = {
            url : vm.ekycData.url,
            sess_id : vm.ekycData.sess_id,
            ekyctype : vm.ekycData.ekyctype,
            plkyc_type : vm.ekycData.plkyc_type,
            kyc_data : vm.ekycData.kyc_data
          };
        }
      }
    }

    /* ---------------------------------------ekyc action section start from here--------------------------------------------------*/

    vm.handleProceedAction = function() {


      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            LoaderService.showLoader();
            vm.formData = {
              url : vm.ekycData.url,
              sess_id : vm.ekycData.sess_id,
              ekyctype : vm.ekycData.ekyctype,
              plkyc_type : vm.ekycData.plkyc_type,
              kyc_data : resp.data.kycData
            };
            $timeout(function () {
              angular.element('#ekycForm').submit();
            }, 100);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      vm.payload.sessId=vm.ekycData.sess_id;
      InvestorService.post({
        child1: 'registration',
        child2: 'save',
        child3: 'contact',
        child4: 'details',
        child5: 'eKyc'
      },vm.payload).$promise.then(success, error);
    };

    function readObject(id) {
      var id = (decodeURIComponent(id)).replaceAll(' ', '+');

      var header = id.substring(0, id.lastIndexOf("|"));
      var data = FormatterService.hash.enc.Base64.parse(id.substring(id.lastIndexOf("|")+1, id.length));
      var responseData = FormatterService.readAesResponsePayload(FormatterService.getFormatterHDFC().decrypt(header), data);

      /*var bytes = FormatterService.getProtoType(id.toString(), AppConstants.OBJECT_CONFIG);
      var cookieData = $window.JSON.parse(bytes.toString(FormatterService.hash.enc.Utf8));*/
      getRequestCOObject(angular.fromJson(responseData));
    }

    function getRequestCOObject(data) {
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.registrationType = 'NEW';
          switch (vm.registrationType) {
            case 'NEW':
              if ((resp.data.kycStatus === vm.KYC_STATUS.VERIFIED || resp.data.kycStatus === vm.KYC_STATUS.IN_PROGRESS)) {
                $state.go("login");
              } else if (resp.data.kycStatus === vm.KYC_STATUS.NOT_VERIFIED || resp.data.kycStatus === vm.KYC_STATUS.INCOMPLETE) {
                vm.payload.email = resp.data.emailId ? resp.data.emailId : data.email;
                vm.payload.mobile = resp.data.contactNumber ? resp.data.contactNumber : data.mobile;
                vm.ekycData = resp.data.ekycRequestCO;
                if (vm.ekycData) {
                  vm.actionUrl = $sce.trustAsResourceUrl(vm.ekycData.camsUrl);
                  vm.formData = {
                    url: vm.ekycData.url,
                    sess_id: vm.ekycData.sess_id,
                    ekyctype: vm.ekycData.ekyctype,
                    plkyc_type: vm.ekycData.plkyc_type,
                    kyc_data: vm.ekycData.kyc_data
                  };
                }
              } else if (resp.data.kycStatus === vm.KYC_STATUS.SUSPENDED) {
                ModalService.nonKycModal({
                  'text': resp.data.message,
                  'buttonText': 'OK'
                }, function () {
                }, function () {
                });
              } else {
                ModalService.nonKycModal({
                  'text': 'Your KYC status is not verified, please update KYC with your current KRA through Point of Service of any KRA intermediary.',
                  'buttonText': 'OK'
                }, function () {
                }, function () {
                });
              }
              break;
          }
        } else {
          if (resp.message == "You have exceeded the maximum number of attempts to initiate registration in a day. Please try to register on next date.") {
            MessageService.error(resp.message);
          } else {
            MessageService.error("Please wait for some time.");
          }
        }
      }, error = function(resp) {
        if (resp && resp.message) {
          var messages = resp.message + '<span class="' + Math.random() + '"></span>';
          toastr.error(messages, '', {
            allowHtml: true,
            preventDuplicates: false,
            onHidden: function () {
              vm.processFlag = false;
            }
          });
          LoaderService.hideLoader();
        } else {
          MessageService.error();
        }
        LoaderService.hideLoader();
      };
      var date = $window.moment(data.dob, "DD-MMM-YYYY").format('DD-MMM-YYYY');
      var payload = {
        encdob: AuthService.encryptRSA(date),
        panNumber: data && data.pan ? AuthService.encryptRSA(angular.copy(data.pan)) : ''
      };
      InvestorServiceVersion3.post4({
        child1: 'registration',
        child2: 'new',
        child3: 'user',
        child4: 'verifyKYC'
      }, payload).$promise.then(success, error);
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('deeplinkController', deeplinkController);

  /** @ngInject */
  function deeplinkController($stateParams, $window, uaParser, LoaderService, $state,HDFC_API) {
    var vm = this;
    vm.HDFC_API =HDFC_API;
    vm.appStoreLink = "https://apps.apple.com/in/app/hdfc-mf-online-investors/id1380088205";
    vm.playStoreLink = "https://play.google.com/store/apps/details?id=com.hdfcfund.investor";

    vm.init = function() {
      vm.transactionType = $stateParams.type;
      identifyUserAgent();
    }

    function identifyUserAgent() {
      var os = uaParser.getOS();
      if (os.name.toUpperCase() === "IOS") {
        LoaderService.showLoader();
        $window.location.href = vm.appStoreLink;
        $state.go('login');
      } else if (os.name.toUpperCase() === 'ANDROID') {
        LoaderService.showLoader();
        $window.location.href = vm.playStoreLink;
        $state.go('login');
      } else {
        $state.go('login');
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('TodosController', todosController);

  /** @ngInject */
  function todosController(UtilService, DashboardService, AppConstants, ModalService, MessageService, TransactionService, LoaderService) {
    var vm = this;
    vm.init = init;
    vm.fetchTodosList = fetchTodosList;
    //vm.getTaskString  = getTaskString;
    vm.checkPendingDoneItems = checkPendingDoneItems;
    vm.checkBirthdayDoneItems = checkBirthdayDoneItems;
    vm.increasePendingLimit = increasePendingLimit;
    vm.increaseBirthdayLimit = increaseBirthdayLimit;
    vm.wishSomeone = wishSomeone;
    vm.birthdayQuantity = 5;
    vm.pendingQuantity = 5;
    vm.REMIND_SUCCESS_MESSAGE = AppConstants.REMIND_SUCCESS_MESSAGE;

    vm.birthdayList = [];
    vm.pendingTransactionList = [];
    vm.completedTodoList = null;
    vm.birthdayCount = null;
    vm.pendingTransactionCount = null;
    vm.pendingTodoTaskId = null;
    vm.completedItemDescription = null;
    vm.completedDate = null;
    vm.completedArray = [];
    vm.pendingTodoList = [];
    vm.pendingCount = 0;
    vm.sendReminder = sendReminder;
    //vm.taskStr = "";

    function init() {
      vm.fetchTodosList();
      // vm.getTaskString(vm.pendingCount);
    }

    function increasePendingLimit() {
      vm.pendingQuantity = vm.pendingQuantity + 5;
    }

    function increaseBirthdayLimit() {
      vm.birthdayQuantity = vm.birthdayQuantity + 5;
    }


    function checkBirthdayDoneItems(task, index) {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.completedDate = resp.data.completedDate;
            vm.completedItemDescription = resp.data.itemDescription;
            vm.birthdayList.splice(index, 1);
            vm.birthdayCount = vm.birthdayCount - 1;
            vm.completedTodoList.push(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      var confirmSuccess = function () {
        DashboardService.post({
          controller: 'markComplete'
        }, {taskId: task.taskId}).$promise.then(success, error);
      };
      var confirmError = function () {
        task.done = false;
      };
      ModalService.confirmCancelModal({Text: 'Are you sure you have completed the task ?'}, confirmSuccess, confirmError);
    }

    function checkPendingDoneItems(task, index) {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.completedDate = resp.data.completedDate;
            vm.completedItemDescription = resp.data.itemDescription;
            vm.pendingTransactionList.splice(index, 1);
            vm.pendingTransactionCount = vm.pendingTransactionCount - 1;
            vm.completedTodoList.push(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      var confirmSuccess = function () {
        DashboardService.post({
          controller: 'markComplete'
        }, {taskId: task.taskId}).$promise.then(success, error);
      };
      var confirmError = function () {
        task.done = false;
      };
      ModalService.confirmCancelModal({Text: 'Are you sure you have completed the task ?'}, confirmSuccess, confirmError);
    }


    function wishSomeone(pending) {
      var success = function (res) {
        if (res.data && res.status) {
          MessageService.success(res.message);
        } else {
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        UtilService.errorHandler(err);
      };

      DashboardService.post({
        controller: 'investor',
        child1: 'birthDayWish'
      }, {'taskId': pending.taskId}).$promise.then(success, error);

    }

    function sendReminder(transactionId) {
      var success = function (resp) {
          if (resp && resp.status) {
            // var name = (listData && listData.name)?'for '+listData.name.toUpperCase():'';
            MessageService.success(vm.REMIND_SUCCESS_MESSAGE);
          }
          else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      TransactionService.post({controller1: 'remind'}, {
        transactionId: transactionId,
        type: null
      }).$promise.then(success, error);
    }

    function fetchTodosList() {

      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.birthdayList = resp.data.birthdayList;
            vm.pendingTransactionList = resp.data.pendingTransactionList;
            vm.birthdayCount = resp.data.birthdayCount;
            vm.completedTodoList = resp.data.completedTodoList;
            vm.pendingTransactionCount = resp.data.pendingTransactionCount;
            vm.pendingTodoList.push(vm.birthdayList);
            vm.pendingTodoList.push(vm.pendingTransactionList);
            vm.pendingCount = vm.birthdayCount + vm.pendingTransactionCount;
          }else{
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      DashboardService.post({
        controller: 'todos',
        child1: 'all'
      }, {}).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .config(dashboard);

  /** @ngInject */
  function dashboard($stateProvider) {
    $stateProvider

      .state('main.dashboard.widgits', {
        url: '',
        views: {
          "investmentWidgit": {
            templateUrl: 'app/dashboard/widgits/investmentWidgit.html',
            controller: 'investmentWidgitController',
            controllerAs: 'Investment'
          },
          "marketUpdateWidgit": {
            templateUrl: 'app/dashboard/widgits/marketUpdateWidgit.html',
            controller: 'marketUpdateWidgitController',
            controllerAs: 'Market'
          },
          "schemePerformanceEvaluation": {
            templateUrl: 'app/dashboard/widgits/schemePerformanceEvaluation.html',
            controller: 'contributorWidgitController',
            controllerAs: 'Contributor'
          },
          "dividentUpdateWidgit": {
            templateUrl: 'app/dashboard/widgits/dividentUpdateWidgit.html',
            controller: 'dividendUpdateWidgitController',
            controllerAs: 'Dividend'
          },
          "recentActivityWidgit": {
            templateUrl: 'app/dashboard/widgits/recentActivityWidgit.html',
            controller: 'recentActivityWidgitController',
            controllerAs: 'RecentActivity'
          },
          "transactionStatusWidgit": {
            templateUrl: 'app/dashboard/widgits/transactionStatusWidgit.html',
            controller: 'TransactionStatusController',
            controllerAs: 'Snapshot'
          },
          "quickLinkWidgit": {
            templateUrl: 'app/dashboard/widgits/quickLinkWidgit.html',
            controller: 'quickLinkWidgitController',
            controllerAs: 'quickLinkWidgit'
          }
        },

        authenticate: true
      })
      .state('main.dashboardEdit.widgits', {
        url: '',
        views: {
          "investmentWidgit": {
            templateUrl: 'app/dashboard/widgits/investmentWidgit.html',
            controller: 'investmentWidgitController',
            controllerAs: 'Investment'
          },
          "marketUpdateWidgit": {
            templateUrl: 'app/dashboard/widgits/marketUpdateWidgit.html',
            controller: 'marketUpdateWidgitController',
            controllerAs: 'Market'
          },
          "schemePerformanceEvaluation": {
            templateUrl: 'app/dashboard/widgits/schemePerformanceEvaluation.html',
            controller: 'contributorWidgitController',
            controllerAs: 'Contributor'
          },
          "dividentUpdateWidgit": {
            templateUrl: 'app/dashboard/widgits/dividentUpdateWidgit.html',
            controller: 'dividendUpdateWidgitController',
            controllerAs: 'Dividend'
          },
          "recentActivityWidgit": {
            templateUrl: 'app/dashboard/widgits/recentActivityWidgit.html',
            controller: 'recentActivityWidgitController',
            controllerAs: 'RecentActivity'
          },
          "transactionStatusWidgit": {
            templateUrl: 'app/dashboard/widgits/transactionStatusWidgit.html',
            controller: 'TransactionStatusController',
            controllerAs: 'Snapshot'
          },
          "quickLinkWidgit": {
            templateUrl: 'app/dashboard/widgits/quickLinkWidgit.html',
            controller: 'quickLinkWidgitController',
            controllerAs: 'quickLinkWidgit'
          }
        },

        authenticate: true
      })
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('DashboardController', dashboardController);

  /** @ngInject */
  function dashboardController($scope, $state, $filter, ModalService, UtilService, LoaderService, MessageService, InvestorService, AppConstants , NetcoreEvntService,AuthService) {
    var vm = this;
    var scope = $scope;
    vm.WIDGETS_ID = AppConstants.WIDGETS_ID;
    vm.getDistributorWidgets = getDistributorWidgets;
    vm.init = init;
    vm.draggedPayload = null;
    vm.cancelDragEdit = cancelDragEdit;
    vm.applyDragEdit = applyDragEdit;
    vm.widgetSelection = widgetSelection;
    vm.redemptionConfirmModalShow = redemptionConfirmModalShow;
    AuthService.checkLinkedUserStatus();
    function init() {
      vm.getDistributorWidgets();
      vm.draggedPayload = null;

      // Removed code under adobe script removal
      // UtilService.performDataLayerPushEventEcart().then(function (resp) {
      //   NetcoreEvntService.COMPLETE_TRANSACTION_CART({
      //     cartItemSchemeNames: resp.cartItemSchemeNames,
      //     fromDashboard : true
      //   })
      // });
    }

    function widgetSelection() {
      ModalService.widgetStoreModal();
    }

    function getDistributorWidgets() {
      var success = function (resp) {
          LoaderService.hideLoader('.dash-loader');
          if (resp.data && resp.status) {
            vm.distributorWidgetsList = resp.data.widgetList;
            vm.gridsterOpts.maxRows = vm.distributorWidgetsList.length + 1;
            vm.widgetsIdList = vm.distributorWidgetsList.map(function (ele) {
              return ele.widgetId;
            });
            vm.distributorWidgetsListLeft = [];
            vm.distributorWidgetsListRight = [];
             angular.forEach(vm.distributorWidgetsList, function (value, key) {
               //var position = parseInt(value.position);
               if(parseInt(key) % 2 == 0){
                 vm.distributorWidgetsListLeft.push(value);
               }
               else {
                 vm.distributorWidgetsListRight.push(value);
               }
             value.col = (key * 1) % 6;
             value.sizeX = 3;
             value.sizeY = 2;
             });
            setRestWidgetsOrder();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.dash-loader');
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.dash-loader');
      InvestorService.post({
        child1: 'dashboard',
        child2: 'widgets',
        child3: 'investor'
      }, {}).$promise.then(success, error);
    }


    function setRestWidgetsOrder() {

      if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.INVESTMENT) < 0) {
        vm.WIDGETS_ID.INVESTMENT_ORDER = 0;
      }
      if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.SCHEME_PERFORMANCE) < 0) {
        vm.WIDGETS_ID.SCHEME_PERFORMANCE_ORDER = 0;
      }
      if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.MARKETUPDATE) < 0) {
        vm.WIDGETS_ID.MARKETUPDATE_ORDER = 0;
      }
      if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.TRANSACTIONSTATUS) < 0) {
        vm.WIDGETS_ID.TRANSACTIONSTATUS_ORDER = 0;
      }
      if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.DIVIDENTUPDATE) < 0) {
        vm.WIDGETS_ID.DIVIDENTUPDATE_ORDER = 0;
      }
      if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.RECENTACTIVITY) < 0) {
        vm.WIDGETS_ID.RECENTACTIVITY_ORDER = 0;
      }
      if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.QUICKLINK) < 0) {
        vm.WIDGETS_ID.QUICKLINK_ORDER = 0;
      }
    }

    function cancelDragEdit() {
      var success = function () {
        $state.go('main.dashboard.widgits');
      }, error = function () {
      };
      ModalService.confirmCancelModal({Text: 'Do you want to exit this page ?'}, success, error);
    }

    function applyDragEdit() {
      if (vm.draggedPayload) {
        LoaderService.showLoader('.edit');
        var success = function (resp) {
          LoaderService.hideLoader('.edit');
          if (resp.status) {
            var success = function () {
              $state.go('main.dashboard.widgits');
            }, error = function () {
              // MessageService.error(err);
            };
            ModalService.editDashboardSuccessModal({}, success, error);


          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.edit');
          UtilService.errorHandler(err);
        };

        angular.forEach(vm.draggedPayload, function (val) {
          switch (val.widgetId) {
            case vm.WIDGETS_ID.INVESTMENT:
              vm.WIDGETS_ID.INVESTMENT_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.SCHEME_PERFORMANCE:
              vm.WIDGETS_ID.SCHEME_PERFORMANCE_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.MARKETUPDATE:
              vm.WIDGETS_ID.MARKETUPDATE_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.TRANSACTIONSTATUS:
              vm.WIDGETS_ID.TRANSACTIONSTATUS_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.DIVIDENTUPDATE:
              vm.WIDGETS_ID.DIVIDENTUPDATE_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.RECENTACTIVITY:
              vm.WIDGETS_ID.RECENTACTIVITY_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.QUICKLINK:
              vm.WIDGETS_ID.QUICKLINK_ORDER = val.position;
              break;
          }
        });

        InvestorService.post({
          child1:'dashboard',
          child2: 'widgets',
          child3: 'alignments'
        }, {widgetList: vm.draggedPayload}).$promise.then(success, error);

      }
    }

    vm.gridsterOpts = {
      resizable: {enabled: false},
      rowHeight: '230',
      // colWidth: '290',
      sparse: true,
      pushing: false,
      maxSizeX: 3,
      maxRows:8,
      swapping: true,// whether or not to have items of the same size switch places instead of pushing down if they are the same size
      draggable: {
        enabled: true, // whether dragging items is supported
        handle: '.drag-icon', // optional selector for drag handle
        stop: function (event, $element, widget) {// optional callback fired when item is finished dragging
          if (widget.col == 1) {
            widget.col = 0;
          }
          if (widget.col == 2) {
            widget.col = 3;
          }
          var dragged = angular.copy($filter('orderBy')(vm.distributorWidgetsList, 'row'));
          var rowLength = 0, final = [], payload = [];
          angular.forEach(dragged, function (value) {
            (rowLength < value.row) && (rowLength = value.row);
          });
          for (var i = 0; i <= rowLength; i++) {
            var slice = dragged.filter(function (ele) {
              return ele.row == i;
            });
            var arr3 = $filter('orderBy')(slice, 'col');
            final = final.concat(arr3);
          }
          angular.forEach(final, function (value, key) {
            var tmp = {};
            tmp.position = (key * 1) + 1;
            tmp.widgetId = value.widgetId;
            payload.push(tmp);
          });
          vm.draggedPayload = payload;
          // updateWidgets(payload);
        }
      }
    };

    var listeners = {};

    listeners['UpdateDashboard'] = scope.$on('UpdateDashboard', function (event, args) {
      if (args.listUpdated) {
        vm.init();
      }
    });

    scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });

    scope.uiState = $state;

    function redemptionConfirmModalShow() {
      ModalService.redemptionConfirmModal();
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .config(createUserId);

  /** @ngInject */
  function createUserId($stateProvider) {
    $stateProvider
      .state('createUserId', {
        url: '/createUserId',
        templateUrl: 'app/createUserId/createUserId-landing.html',
        controller: 'CreateUserIdController',
        controllerAs: 'CreateUserId',
        defaultRoute:'.verifyAccountDetails',
        authenticate: false
      })
      .state('createUserId.verifyAccountDetails', {
        url: '/verifyAccountDetails',
        templateUrl: 'app/createUserId/verifyDetails/verifyAccountDetails.html',
        controller: 'CreateUserIdController',
        controllerAs: 'CreateUserId',
        // parent:'createUserId',
        authenticate: false
      })
      .state('createUserId.verifyUserIdDetails', {
        url: '/verifyUserIdDetails',
        templateUrl: 'app/createUserId/verifyDetails/verifyUserIdDetails.html',
        controller: 'CreateUserIdController',
        controllerAs: 'CreateUserId',
        authenticate: false
      })
      .state('createUserId.verifyOTP', {
        url: '/verifyOTP',
        templateUrl: 'app/createUserId/verifyDetails/verifyOTP.html',
        controller: 'CreateUserIdController',
        controllerAs: 'CreateUserId',
        authenticate: false
      })
      .state('createUserId.userIdSuccessAcknowledgement', {
        url: '/userIdSuccess',
        templateUrl: 'app/createUserId/verifyDetails/userIdSuccessAcknowledgement.html',
        controller: 'CreateUserIdController',
        controllerAs: 'CreateUserId',
        authenticate: false
      })
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('CreateUserIdController', createUserIdController);

  /** @ngInject */
  function createUserIdController(AppConstants, $timeout, ModalService, $log, InvestorService, LoaderService, MessageService, CreatePayloadFactory, $state, $window, investorServiceVersion, toastrConfig, toastr,InvestorServiceVersion3,AuthService, $scope, UtilService, panAadharService) {
    var vm = this;
    vm.text = 'Dont Have UserId ?';
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.EMAIL_PATTERN = angular.copy(AppConstants.email_regex);
    vm.MOBILE_PATTERN = angular.copy(AppConstants.mobile_regex_eKyc);
    vm.errorMessage = '';
    vm.creationSuccess = creationSuccess;
    vm.verifyAccountDetails = verifyAccountDetails;
    vm.getUserNameSuggestion = getUserNameSuggestion;
    vm.checkAvailability = checkAvailability;
    vm.updateEmailId = updateEmailId;
    vm.saveNewEmail = saveNewEmail;
    vm.updateContact = updateContact;
    vm.saveNewContact = saveNewContact;
    vm.generateOtp = generateOtp;
    vm.confirmOtp = confirmOtp;
    vm.confirmCancel = confirmCancel;
    vm.resetValues= resetValues;
    vm.saveVerifiedEmail = saveVerifiedEmail;
    vm.saveVerifiedContact = saveVerifiedContact;
    vm.checkPattern = checkPattern;
    vm.reGenerateOtp = reGenerateOtp;
    vm.showTermConditions = showTermConditions;
    vm.formData = {};
    var details ={};
    vm.emailEdit = false;
    vm.contactEdit = false;
    vm.isMatching = true;
    vm.isRequired = false;
    vm.processFlag = false;
    vm.inputReset = false;
    vm.otpSentMessage="";
    vm.isUserId=true;
    vm.resetCreateUserId=resetCreateUserId;
    vm.showTerms = true;
    vm.missingContactDetail = false;
    vm.missingEmail = false;
    vm.submitCreateUserIdForm = submitCreateUserIdForm;
    var otpSubmitCount = 0;
    vm.isOtpInValid = false;

    vm.Init = function() {
      details = CreatePayloadFactory.get();
      switch ($state.current.name) {
        case 'createUserId.verifyAccountDetails':
          break;
        case 'createUserId.verifyUserIdDetails':
          if(Object.keys(details).length != 0){
            getUserNameSuggestion();
            vm.formData.emailAddress = vm.EMAIL_PATTERN.test(details.emailId)? details.emailId : false;
            vm.formData.contact = details.contactNumber;
            vm.formData.maskedEmail = details.maskedEmail;
            vm.formData.maskedMobile = details.maskedMobile;
          } else {
            $state.go("createUserId.verifyAccountDetails");
          }
          break;
        case 'createUserId.verifyOTP':
          vm.otpSentMessage= localStorage.getItem("otpSentMessage");
          vm.updatedContactOtpSentMessage = sessionStorage.getItem('updatedContactOtpSentMessage');
          vm.details = details;
          if(Object.keys(details).length == 0) {
            $state.go("createUserId.verifyAccountDetails");
          }
          break;
      }

      var successHandler = function(resp) {
        if(!resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General) {
          vm.showTerms = false;
        }
      }

        UtilService.fetchDynamicData("INNER_TNC").then(successHandler).catch(function(resp) {
          MessageService.error(resp)
        });
    };

    function resetValues() {
      vm.errorMessage = "";
      vm.availableMessage = "";
      vm.otpResendMessage = "";
      vm.missingContactDetail = false;
      vm.missingEmail = false;
      vm.formData.emailId = null;
      vm.formData.emailBelongsTo = null;
      vm.formData.contactNumber = null;
      vm.formData.mobileBelongsTo = null;
    }

    function updateEmailId() {
      vm.emailEdit = true;
      vm.formData.emailAddressEdited = vm.formData.emailAddress;
    }

    function saveVerifiedEmail() {
        var successEmail = function (resp) {
            if(resp.data && resp.status){
              $log.info("email updated");
              vm.formData.emailAddress = vm.formData.emailAddressEdited;
              vm.emailEdit = false;
            } else {
              vm.emailEdit = false;
              MessageService.error(resp.message);
            }
          },
          errorEmail = function () {
            vm.formData.emailAddress = vm.formData.emailAddressEdited;
            vm.emailEdit = false;
            //   MessageService.error(resp.message);
            vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          };
        var payload = {
          "panNumber":details.panNumber,
          "emailId":vm.formData.emailAddressEdited
        };
        InvestorService.post({
          child1: 'registration',
          child2: 'edit',
          child3: 'email'
        }, payload).$promise.then(successEmail, errorEmail);

    }

    function saveNewEmail() {
      if(vm.formData.emailAddressEdited && vm.formData.emailAddressEdited!=vm.formData.emailAddress){
        var successEmail = function (resp) {
            if(resp.data && resp.status){
              if(resp.data.userVerificationFlag){
                var confirmSuccess = function () {
                 var isOtpValid = CreatePayloadFactory.getOTP();
                  if(isOtpValid){
                    saveVerifiedEmail();
                  } else{
                    vm.emailEdit = false;
                  }
                };
                var confirmError = function () {
                  vm.emailEdit = false;
                };
                ModalService.confirmOtpModal({text: 'Mobile Number', pan: resp.data.panNumber, email: vm.formData.emailAddressEdited}, confirmSuccess, confirmError);

              } else {
                $log.info("email updated");
                vm.emailEdit = false;
              }
            } else {
              vm.emailEdit = false;
              MessageService.error(resp.message);
            }
          },
          errorEmail = function () {
            vm.emailEdit = false;
            vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          };
        var payload = {
          "panNumber":details.panNumber,
          "value":vm.formData.emailAddressEdited
        };
        InvestorService.post({
          child1: 'registration',
          child2: 'edit',
          child3: 'email'
        }, payload).$promise.then(successEmail, errorEmail);
      } else {
        vm.formData.emailAddress = vm.formData.emailAddressEdited;
        vm.emailEdit = false;
      }
    }

    function updateContact() {
      vm.contactEdit = true;
      vm.formData.contactEdited = vm.formData.contact;
    }

    function saveVerifiedContact() {
      var successEmail = function (resp) {
          if(resp.data && resp.status){
            $log.info("email updated");
            vm.formData.contact = vm.formData.contactEdited;
            vm.contactEdit = false;
          } else {
            vm.contactEdit = false;
            MessageService.error(resp.message);
          }
        },
        errorEmail = function () {
          vm.formData.contact = vm.formData.contactEdit;
          vm.contactEdit = false;
          vm.errorMessage = AppConstants.ToastrMessage.FAILED;
        };
      var payload = {
        "panNumber":details.panNumber,
        "emailId":vm.formData.contactEdited
      };
      InvestorService.post({
        child1: 'registration',
        child2: 'edit',
        child3: 'mobile'
      }, payload).$promise.then(successEmail, errorEmail);

    }

    function saveNewContact() {
      if(vm.formData.contactEdited && vm.formData.contactEdited!=vm.formData.contact){
        var successContact = function (resp) {
            if(resp.data && resp.status){
              if(resp.data.userVerificationFlag){
                var confirmSuccess = function () {
                  var isOtpValid = CreatePayloadFactory.getOTP();
                  if(isOtpValid){
                    saveVerifiedContact();
                  } else{
                    vm.contactEdit = false;
                  }
                };
                var confirmError = function () {
                  vm.contactEdit = false;
                };
                ModalService.confirmOtpModal({text: 'Mobile Number', pan: resp.data.panNumber, email: vm.formData.contactEdited}, confirmSuccess, confirmError);

              } else {
                $log.info("email updated");
                vm.contactEdit = false;
              }
            } else {
              vm.contactEdit = false;
              MessageService.error(resp.message);
            }
          },
          errorContact = function () {
            vm.emailEdit = false;
            vm.errorMessage = AppConstants.ToastrMessage.FAILED;
          };
        var payload = {
          "panNumber":details.panNumber,
          "value":vm.formData.emailAddressEdited
        };
        InvestorService.post({
          child1: 'registration',
          child2: 'edit',
          child3: 'mobile'
        }, payload).$promise.then(successContact, errorContact);
      } else {
        vm.formData.contact = vm.formData.contactEdited;
        vm.contactEdit = false;
      }
    }

    function confirmCancel() {
      var confirmSuccess = function () {
        $state.go("login");
      };
      var confirmError = function () {
       // task.done = false;
      };
      ModalService.confirmCancelModal({}, confirmSuccess, confirmError);
    }

    function confirmOtp() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            if(resp.data.userVerificationFlag){
              var success = function () {
                  CreatePayloadFactory.reset();
                  $state.go("login");
                },
                error = function () {
                };
             $state.go('createUserId.userIdSuccessAcknowledgement');
              vm.errorMessage = '';
            } else
            {
              vm.processFlag = true;
              toastrConfig.preventDuplicates = false;
              toastr.error(resp.data.message, '', {
                onHidden: function () {
                  vm.processFlag = false;
                  toastrConfig.preventDuplicates =  true;
                }
              });
            }
          } else {
            vm.processFlag = true;
            toastrConfig.preventDuplicates = false;
            otpSubmitCount++;
            if (otpSubmitCount === 6 ) {
              vm.isOtpInValid = true;
            }
            toastr.error(resp.message, '', {
              onHidden: function () {
                vm.processFlag = false;
                toastrConfig.preventDuplicates =  true;
              }
            });
            if (resp.message === "You have exceeded the maximum OTP try limit. Please try again after 15 mins."){
              vm.otpSentMessage = '';
            }
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.formDataTemp = $window.JSON.parse(localStorage.getItem("useridFormData"));
      vm.folioNoLocalStorage=sessionStorage.getItem("folioNoForUserID");
      vm.emailIDForOtpVerication=localStorage.getItem("emailIDForOTPVerification");
      vm.bankAccNoForOtpVerification=localStorage.getItem("bankAccNo");
      var payload = {
        panNumber: details.panNumber ? AuthService.encryptRSA(angular.copy(details.panNumber)) : '',
        otp: vm.formData.otpNumber ? AuthService.encryptRSA(angular.copy(vm.formData.otpNumber)) : '',
        id: localStorage.getItem("id"),
        fieldType:"USER_ID",
        emailId: vm.emailIDForOtpVerication ? AuthService.encryptRSA(angular.copy(vm.emailIDForOtpVerication)) : '',
        panHolderName:details.panHolderName,
        dob: details.dob ? AuthService.encryptRSA(angular.copy(details.dob)) : '',
        message:"",
        registrationType:"EXISTING",
        password: vm.formDataTemp.password ? AuthService.encryptRSA(angular.copy(vm.formDataTemp.password)) : '',
        userId: vm.formDataTemp.userId,
        corporateUser: details.corporateFlag,
        folioNo : vm.folioNoLocalStorage,
        bankAccNo : vm.bankAccNoForOtpVerification ? AuthService.encryptRSA(angular.copy(vm.bankAccNoForOtpVerification)) : ''
      };

      if (details.contactNumber) {
        payload['contactNumber'] = AuthService.encryptRSA(angular.copy(details.contactNumber));
      }

      if (vm.details.missingDetail) {
        payload["isContactDetailUpdated"] = true;
        payload["otp2"] = vm.formData.otpNumber2 ? AuthService.encryptRSA(angular.copy(vm.formData.otpNumber2)) : '';
        payload["otp2Id"] =  sessionStorage.getItem('otp2Id');
      }

      LoaderService.showLoader();
      InvestorServiceVersion3.post4({
        child1: 'registration',
        child2: 'otp',
        child3: 'verify'
      }, payload).$promise.then(success, error);

    }

    function reGenerateOtp() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if(resp.data && resp.data.isOtpSent){
          localStorage.removeItem("otpSentMessage");
          vm.processOTPFlag = true;
          vm.isOtpInValid = false;
          otpSubmitCount = 0;
          resetTimer();
          toastrConfig.preventDuplicates = false;
          toastr.success(resp.message, '', {
            onHidden: function () {
              vm.processOTPFlag = false;
              toastrConfig.preventDuplicates =  true;
            }
          });
        } else {
          vm.processOTPFlag = true;
          resetTimer();
          toastrConfig.preventDuplicates = false;
          toastr.error(resp.message, '', {
            onHidden: function () {
              vm.processOTPFlag = false;
              toastrConfig.preventDuplicates =  true;
            }
          });
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.processOTPFlag = false;
        resetTimer();
        MessageService.error(AppConstants.ToastrMessage.FAILED);
        $log.info('Error:', err);
      };
      vm.inputReset = true;
      $timeout(function () {
        vm.inputReset = false;
      });
      vm.errorMessage = '';
      vm.processOTPFlag = true;
      vm.otpResendMessage = '';
      var payload = {
        panNumber: details.panNumber ? AuthService.encryptRSA(angular.copy(details.panNumber)) : '',
        id:localStorage.getItem("id"),
        otp2Id: sessionStorage.getItem('otp2Id')
      };
      LoaderService.showLoader();
      InvestorService.post4({
        child1: 'registration',
        child2: 'resendOTP'
      }, payload).$promise.then(success, error);
    }

    function generateOtp() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.isAvailable = resp.data.userVerificationFlag;
            localStorage.setItem("otpSentMessage",resp.data.otpSentMessage);
            localStorage.setItem("id",resp.data.id);
            sessionStorage.setItem('updatedContactOtpSentMessage', resp.data.updatedContactOtpSentMessage);
            sessionStorage.setItem('otp2Id', resp.data.otp2Id);
            if(resp.data.userVerificationFlag){
             // MessageService.success(resp.message);
              $state.go("createUserId.verifyOTP");
              vm.errorMessage = '';
            } else
            {
              MessageService.error(resp.data.message);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      var payload= {
        "password": AuthService.encryptRSA(angular.copy(vm.formData.password)),
        "panNumber": details.panNumber ? AuthService.encryptRSA(angular.copy(details.panNumber)):"",
        "userId": vm.formData.userId,
        "id":details.id,
        "email": AuthService.encryptRSA(angular.copy(vm.formData.emailAddress ? vm.formData.emailAddress : vm.formData.emailId)),
        "panHolderName":details.panHolderName,
        "investorRegistrationType":"EXISTING",
        "folioNumber":sessionStorage.getItem("folioNoForUserID"),
        "isContactDetailUpdated": details.missingMobileNumber || details.missingEmailId ? true : false,
        "mobileNumber": AuthService.encryptRSA(angular.copy(details.contactNumber)),
        "emailBelongsTo": details.missingEmailId ? details.emailBelongsTo: null,
        "mobileBelongsTo": details.missingMobileNumber ? details.mobileBelongsTo: null,
        "fieldType": details.missingMobileNumber ? 'MOBILE' : details.missingEmailId ? 'EMAIL' : null
      };
      localStorage.setItem("useridFormData", $window.JSON.stringify(vm.formData));
      localStorage.setItem("emailIDForOTPVerification",vm.formData.emailAddress ? vm.formData.emailAddress : vm.formData.emailId);
      LoaderService.showLoader();
      InvestorServiceVersion3.post4({
        child1: 'registration',
        child2: 'otp',
        child3: 'generate'
      }, payload).$promise.then(success, error);
    }

    vm.invalidUserId = false;
    vm.checkText = function(){
      var regex = AppConstants.valid_userId_regex;
      if(vm.formData && vm.formData.userId && (regex.test(vm.formData.userId.toLowerCase()) && vm.formData.userId.length > 30)){
        vm.invalidUserId =  true;
      } else{
        vm.invalidUserId =  false;
      }
    }

    function checkAvailability () {
      vm.isUserId=true;
      if(vm.formData.userId!=null && vm.formData.userId!=vm.suggestedName) {
        var success = function (resp) {
            LoaderService.hideLoader('.availability-loader');
            if (resp.data && resp.status) {
              $log.info(resp.data.userIdAvailableFlag);
              if(resp.data.userIdAvailableFlag){
                vm.availableMessage = "";
              } else {
                vm.availableMessage = resp.data.message || 'User ID not available';
              }
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader('.availability-loader');
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        LoaderService.showLoader('.availability-loader');
        InvestorService.get({
          child1: 'registration',
          child2: 'userId',
          child3: 'availability',
          child4: vm.formData.userId
        }).$promise.then(success, error);
      }
    }

    function getUserNameSuggestion() {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status) {
            vm.suggestedName = resp.data.userId;
            vm.formData.userId = resp.data.userId;
          } else {
            vm.errorMessage = resp.message;
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      InvestorService.post({
        child1: 'registration',
        child2: 'generateUserId'
      }, {"userName":details.panHolderName,
          "dob":details.dob,
          "emailId":details.emailId,
          "pan":details.panNumber
      }).$promise.then(success, error);
    }

    function verifyAccountDetails() {
      var successHandlerCreateUserId=function(resp) {
        LoaderService.hideLoader();
        vm.processFlag = true;
        var success = function (resp) {
            vm.processFlag = false;
            LoaderService.hideLoader();
            if (resp.data && resp.status) {
              CreatePayloadFactory.set(resp.data);
              if (resp.data.contactNumber && resp.data.emailId) {
                $state.go("createUserId.verifyUserIdDetails");
              } else if (!resp.data.contactNumber && !resp.data.emailId) {
                ModalService.genericModal({
                  text: vm.validateData.MISSING_CONTACT_DETAIL_ERROR
                });
              } else {
                vm.formData.termNcondition = false;
                fetchBelongsToDropdown();
                if (!resp.data.contactNumber) {
                  vm.missingContactDetail = true;
                }
                if(!resp.data.emailId) {
                  vm.missingEmail = true;
                }
              }
            } else {
              var message = resp.message;
              if (message == "User is already registered") {
                var successRegistered = function () {
                    $state.go('login');
                  },
                  errorRegistered = function () {
                  };
                ModalService.registrationSuccessModal({
                  'text': 'You already have a User ID. Please proceed with login',
                  'buttonText': 'Login'
                }, successRegistered, errorRegistered, "custom");
              } else if (message === "REDIRECT_TO_OLD") {
                ModalService.redirectToOldFolioModal({});
              } else {
                vm.processFlag = true;
                toastrConfig.preventDuplicates = false;
                if(resp.popupEnabled) {
                  ModalService.genericModal({
                    text: resp.message
                  });
                  vm.processFlag = false;
                } else {
                  toastr.error(resp.message, '', {
                    onHidden: function () {
                      vm.processFlag = false;
                      toastrConfig.preventDuplicates = true;
                    }
                  });
                }
              }
            }
          },
          error = function () {
            vm.processFlag = false;
            LoaderService.hideLoader();
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        sessionStorage.setItem("folioNoForUserID", vm.formData.folioNo);
        localStorage.setItem("bankAccNo", vm.formData.bankAccountNumber);
        var payload = {
          "bankAccountNo": vm.formData.bankAccountNumber,
          "folioNo": vm.formData.folioNo,
          "pan": AuthService.encryptRSA(angular.copy(vm.formData.pan))
        };
        if(payload && payload.bankAccountNo){
          payload.bankAccountNo = AuthService.encryptRSA(angular.copy(vm.formData.bankAccountNumber));
        }
        LoaderService.showLoader();
        investorServiceVersion.post4({
          child1: 'registration',
          child2: 'verify'
        }, payload).$promise.then(success, error);
      };
      var errorHandlerCreateUserId=function(resp)
      {
        LoaderService.hideLoader();
        return;
      };
      LoaderService.showLoader();
      panAadharService.fetchPanAadharLinkingStatus(vm.formData.pan,null).then(successHandlerCreateUserId).catch(errorHandlerCreateUserId);

    }

    function creationSuccess() {
      var success = function () {
          $state.go("login");
        },
        error = function () {
        };
      ModalService.registrationSuccessModal({}, success, error, "custom");
    }

    function checkPattern(pwd) {
      vm.formData.password = pwd; //
      vm.check4CofirmPW = pwd?pwd.replace(/\$/gi, "\\$"):'';
      vm.isMatching = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[$_!@])[A-Za-z\d$@!_]{8,15}$/.test(vm.formData.password);

      if(vm.formData.password == null){
        vm.isRequired = true;
        vm.isMatching = true;
      } else{
        vm.isRequired = false;
      }
    }
    function showTermConditions() {
      ModalService.termConditionModal();
    }
    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

    function resetCreateUserId() {
      vm.isUserId=false;
    }

    vm.handleSideBarClick = function(state) {
      UtilService.updateSideBar(state);
    };

    function fetchBelongsToDropdown() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.belongToListEmail = resp.data.emailList;
          vm.belongToListMobile = resp.data.mobileList;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        $log.info('Belongs Dropdown error >>>>', err);
      };
      InvestorService.get({child1: 'folio', child2: 'contactType', child3:'details'}).$promise.then(success, error);
    }

    function submitCreateUserIdForm() {
      var payload = CreatePayloadFactory.get();
      if (vm.missingContactDetail) {
        payload.contactNumber = vm.formData.contactNumber;
        payload.mobileBelongsTo = vm.formData.mobileBelongsTo;
        payload.missingMobileNumber = true;
        payload.missingDetail = true;
      }
      if (vm.missingEmail) {
        payload.emailId = vm.formData.emailId;
        payload.emailBelongsTo = vm.formData.emailBelongsTo;
        payload.missingEmailId = true;
        payload.missingDetail = true;
      }
      CreatePayloadFactory.set(payload);
      $state.go("createUserId.verifyUserIdDetails");
    }
  }
})();


(function () {
    "use strict";
    angular
      .module("hdfc-mf-investor-web")
      .controller("ThanksController", thanksController);

    function thanksController(LoaderService, AuthService,$timeout, TransactionService, $window,$state, $stateParams, InvestorService, MessageService, AppConstants, $log, ModalService) {
     AuthService.clearCookies(AppConstants.INSTA_IDENTIFIER);
    }
  })();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-investor-web')
      .config(arnReview);

    /** @ngInject */
    function arnReview($stateProvider) {
      $stateProvider
      .state('arnReview.verifyPan', {
        url: '/:arn?Euin?x?trackId?trxnType?stepNo',
        templateUrl: 'app/arn-review/panVerify/verifyPan.html',
        controller: 'PanVerifyController',
        controllerAs: 'PanVerify',
        authenticate: true
      })
      .state('arnReview.verifyPan1', {
        url: '?schemeGroupCode?arnFlag',
        templateUrl: 'app/arn-review/panVerify/verifyPan.html',
        controller: 'PanVerifyController',
        controllerAs: 'PanVerify',
        authenticate: true
      })
      .state('arnReview.verifyPan2', {
        url: '/:arn?ScheduleTransaction&ScheduleId',
        templateUrl: 'app/arn-review/panVerify/verifyPan.html',
        controller: 'PanVerifyController',
        controllerAs: 'PanVerify',
        authenticate: true
      })
      .state('arnReview.select-folio', {
        url:'/select-folio/:pan?trackId?trxnType?stepNo',
        templateUrl: 'app/arn-review/select-folio/select-folio.html',
        controller: 'SelectFolioController',
        controllerAs: 'SelectFolio'
        })
      .state('arnReview.purchaseScheduleTransaction', {
        url:'/purchaseScheduleTransaction/:pan',
        templateUrl: 'app/arn-review/scheduleTransaction/purchaseScheduleTransaction/scheduleTransactionList.html',
        controller: 'scheduleTransactionListController',
        controllerAs: 'scheduleTransactionList'
        })
      .state('arnReview.successfulCancelTransaction', {
        url:'/purchaseScheduleTransaction/successfulCancelTransaction',
        templateUrl: 'app/arn-review/scheduleTransaction/successfulCancelTransaction/successfulCancelTransaction.html',
        controller: 'successfulCancelTransactionController',
        controllerAs: 'successfulCancelTransaction'
        })
    }
})();


(function () {
  "use strict";
  angular
    .module("hdfc-mf-investor-web")
    .controller("ArnReviewController", arnReviewController);

  function arnReviewController(LoaderService,ArnInvestorService, AuthService,$timeout,HDFC_API, TransactionService, $window,$state, $stateParams, InvestorService, MessageService, AppConstants, $log, ModalService,IIHttpService,$rootScope, InvestorFolioModel) {
    var vm = this;
    vm.formData = {};
    $stateParams;
    $rootScope.PurchaseView = false;
    vm.stateParmsData = $stateParams;
    $rootScope.modifyLogin = false; 
    vm.HDFC_WITH_DIRECT_ARN = angular.copy(AppConstants.HDFC_WITH_DIRECT_ARN);
    vm.format = 'dd-MMM-yyyy h:mm:ss a';
    InvestorFolioModel.resetFromDistributorModel();
    vm.getcipherText = function (cipherData) {
      var cipherText = cipherData;
      var key = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-|_x";
      var message = "";
      var shiftKey = 10;
      for (var i = 0; i < cipherText.length; i++) {
        var charPosition = key.indexOf(cipherText.charAt(i));
        var keyVal = (charPosition - shiftKey) % 39;
        if (keyVal < 0) {
          keyVal = key.length + keyVal;
        }
        var replaceVal = key.charAt(keyVal);
        message += replaceVal;
      }
      return message;
    }
    vm.fetchEuinList = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.formData.distributorName = resp.data.distributorName;
          vm.formData.euinList = resp.data.euinList;
        } else {
          vm.euinList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        MessageService.error(err);
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      var path = {
        controller1: 'getEuin',
        controller2: 'ARN-' + vm.formData.arn
      };
      TransactionService.get(path).$promise.then(success, error);
    }
    vm.getDistributerProfile = function () {
      var success = function (resp) {
        if (vm.formData.key == "CONNECT_PARTNER" && vm.formData.arn == '0014' && vm.formData.transactionType == 'SIP' && vm.formData.CAMP) {
        }else{
          LoaderService.hideLoader();
        }
        if (resp.status && resp.data) {
          vm.formData.distributorName = resp.data.distributorName;
          vm.formData.distributorMail = resp.data.email;
          vm.formData.distributorMobile = resp.data.mobile;
          vm.formData.distributorImage = resp.data.imageName;
          localStorage.setItem("distributorDetails",$window.JSON.stringify(vm.formData));
          if(vm.formData.flowName && vm.formData.flowName == 'E_CART'){
            $rootScope.$broadcast('EcartFLow', true);
          }
        } else {
          vm.euinList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        MessageService.error(err);
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      InvestorService.get({
        child1: "getDistributorProfile",
        child2: 'ARN-' + vm.formData.arn
      }).$promise.then(success, error);
    }
    vm.callAuth = function () {
      var successLogin = function (resp) {
        if (vm.formData.key == "CONNECT_PARTNER" && vm.formData.arn == '0014' && vm.formData.transactionType == 'SIP' && vm.formData.CAMP) {
        }else{
          LoaderService.hideLoader();
        }
        // var modalData = {
        //   folioNumber:'4035279'
        // }
        // ModalService.arnAddBankModal({data:modalData});
        if(vm.formData.arn == "DIRECT"){
          if(vm.formData.riaCode){
            vm.getEuinRIA();
          }
          localStorage.setItem("distributorDetails",$window.JSON.stringify(vm.formData));
        }else{
          vm.getDistributerProfile();
        }
      }, errorLogin = function (error) {
        MessageService.error(error.message);
      }
      var oauthpayload = {
        arnCode: "ARN-"+vm.formData.arn,
        grant_type: 'password',
        panNumber: null,
        appType: 'W',
        type: 'arn'
      };
      LoaderService.showLoader();
      AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);
    }
    vm.nonArnAuth = function () {
      var successLogin = function (resp) {
        LoaderService.hideLoader();
        localStorage.setItem("distributorDetails",$window.JSON.stringify(vm.formData));
        if(vm.formData.flowName && vm.formData.flowName == 'E_CART'){
          $rootScope.$broadcast('EcartFLow', true);
        }
        if(vm.formData.riaCode){
          vm.getEuinRIA();
        }
      }, errorLogin = function (error) {
        MessageService.error(error.message);
      }
      var oauthpayload = {
        arnCode: "ARN-DIRECT",
        grant_type: 'password',
        panNumber: null,
        appType: 'W',
        type: 'arn'
      };
      LoaderService.showLoader();
      AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);
    }
    vm.getArnDataById = function(chipherTextID){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {  
          vm.formData.key = resp.data.key;
          vm.formData.isHdfcBank = false;
          vm.formData.flowName = resp.data.flowName;
          $rootScope.flowNameFromEcart = vm.formData.flowName;
          vm.formData.retirementSchemeOpted= resp.data.retirementSchemeOpted;
          vm.formData.cgfSchemeOpted = resp.data.cgfSchemeOpted;
          sessionStorage.setItem('retirementSchemeExists', resp.data.retirementSchemeOpted);
          if(vm.formData.key == "MFD"){
            if($stateParams.x){
              var HDFCCAMP = $window.atob($stateParams.x)
              if(HDFCCAMP == 'HDFCCAMP'){
                vm.formData.HDFCCAMP = true;
              }
            }
            if(vm.stateEuinActive){
              vm.formData.euin = $stateParams.Euin;
            }else{
              vm.formData.euin = resp.data.euin;
            }
            var dataList = resp.data.arnCode.split("-");  
            vm.formData.arn = dataList[1];  
            if(vm.formData.arn == '0005' && vm.formData.key == "MFD"){
              vm.formData.isHdfcBank = true;
              $rootScope.isHdfcBank = true;
            } 
            vm.callAuth();
            if(resp.data.subBrokerArn){
              var subBrokerarn = resp.data.subBrokerArn.split("-");
              vm.formData.subBrokerARN = subBrokerarn[1];
              vm.formData.subBrokerCode = resp.data.subBrokerCode;
            }
          }
          if(vm.formData.key == "RIA"){
            vm.formData.riaCode = resp.data.riaCode;
            vm.nonArnAuth();
          }
          if(vm.formData.key == "E_CODE"){
            if(resp.data.arnCode && resp.data.arnCode != "ARN-DIRECT" ){
              if(vm.stateEuinActive){
                vm.formData.euin = $stateParams.Euin;
              }else{
                vm.formData.euin = resp.data.euin;
              }
              var dataList = resp.data.arnCode.split("-");
              vm.formData.arn = dataList[1];
              vm.formData.empCode = resp.data.empCode;
              vm.callAuth();
              if(resp.data.subBrokerArn){
                var subBrokerarn = resp.data.subBrokerArn.split("-");
              vm.formData.subBrokerARN = subBrokerarn[1];
                vm.formData.subBrokerCode = resp.data.subBrokerCode;
              }
            }else{
              vm.nonArnAuth();
              vm.formData.empCode = resp.data.empCode;
            }
          }
          if(vm.formData.key == "CONNECT_PARTNER"){
            if(vm.stateEuinActive){
              vm.formData.euin = $stateParams.Euin;
            }else{
              vm.formData.euin = resp.data.euin;
            }
            var dataList = resp.data.arnCode.split("-");
            vm.formData.arn = dataList[1];
            vm.callAuth();
          }
          if(resp.data.schemeGroupCode){
            vm.formData.schemeGroupCode = resp.data.schemeGroupCode;
          }
          if(resp.data.transactionType == "SIP"){
            vm.formData.transactionType = "SIP";
            vm.formData.schemeCode = resp.data.schemeCode;
            vm.formData.amount = resp.data.amount;
            vm.formData.frequency = resp.data.frequency;
            if(resp.data.sipStartDate){
              vm.formData.sipStartDate = moment(resp.data.sipStartDate).format("DD-MMM-YYYY");
            }
            if(resp.data.sipEndDate){
              vm.formData.sipEndDate = moment(resp.data.sipEndDate).format("DD-MMM-YYYY");
            }
            vm.formData.dividendOption = resp.data.dividendOption;
          }
          if(resp.data.transactionType == "PURCHASE"){
            vm.formData.transactionType = "Purchase",
            vm.formData.schemeCode = resp.data.schemeCode,
            vm.formData.amount = resp.data.amount;
            vm.formData.dividendOption = resp.data.dividendOption;
          }
          if(resp.data.transactionType === 'SWITCH'){
            vm.formData.dividendOption = resp.data.dividendOption;
            vm.formData.transactionType = "Switch";
            vm.formData.schemeCode = resp.data.schemeCode;
          } 
          if(resp.data.transactionType == "PURCHASE_SCHEDULER"){
            vm.formData.transactionType = "Purchase_Scheduler";
            vm.formData.schemeCode = resp.data.schemeCode;
            vm.formData.amount = resp.data.amount;
            vm.formData.scheduleFrequency = resp.data.scheduleFrequency;
            vm.formData.schedulerStartDate= resp.data.schedulerStartDate;
            vm.formData.schedulerEndDate= resp.data.schedulerEndDate;
            vm.formData.dividendOption= resp.data.dividendOption;
            if(vm.formData.scheduleFrequency == 'W'){
              vm.formData.scheduleFrequency = 'OW';
            }
          }
          if(resp.data.transactionType === 'REDEMPTION'){
            vm.formData.transactionType = "Redemption";
            vm.formData.schemeCode = resp.data.schemeCode;
          }   
          vm.formData.utmSource = resp.data.utmSource ? resp.data.utmSource : '';
          vm.formData.utmMedium = resp.data.utmMedium ? resp.data.utmMedium : '';
          if(resp.data && resp.data.transactionType == "PURCHASE_SCHEDULER" && (!resp.data.euin || resp.data.euin == "")){
            vm.formData.modifyEuinEnabled = true;
          } 
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function () {
        MessageService.error();
      };
      InvestorService.get(
        {
          child1: 'arnHardCode',
          child2: 'getArnDataByUId',
          child3: chipherTextID
        }).$promise.then(success, error);
    }
    vm.shortCode = function(chipherText){
      vm.chipherText = chipherText;
      if(vm.chipherText) {
        vm.formData.chipherText = vm.chipherText;
        localStorage.setItem("chipherText", vm.chipherText);
      } else {
        vm.formData.chipherText = vm.chipherText;
        vm.chipherText = localStorage.getItem("chipherText");
      }
      var linkCode = vm.getcipherText(vm.chipherText);
      var dataList = linkCode.split("|");
      if(dataList[0] == "RIA" || dataList[0] == "E_AMC"){
        vm.formData.arn = "DIRECT";
      }
      vm.formData.key = dataList[0]
      for (var i = 1; i < dataList.length; i++) {
        var arnList = dataList[i].split("x");
        getData(arnList[0], arnList[1]);
      }
      function getData(index, value) {
        switch (index) {
          case "1":
            vm.formData.arn = value;
            vm.callAuth();
            break;
          case "2":
            vm.formData.euin = value;
            break;
          case "3":
            vm.formData.empCode = value;
          if(!vm.formData.arn){
             vm.nonArnAuth();
            }
            break;
          case "4":
            vm.formData.riaCode = value;
            vm.callAuth();
            break;
            case "5":
              vm.formData.schemeGroupCode = value;
              break;
          case "6":
            vm.formData.subBrokerARN = value;
            break;
          case "7":
            vm.formData.subBrokerCode = value;
            break;
          case "8":
            vm.formData.transactionType = value;
            break;
          case "9":
            vm.formData.CAMP = true;
            break;
          case "10":          
            vm.formData.SCHEMEWISECAMP = true;
            delete vm.formData.CAMP;
            break;
          case "11":
              vm.formData.schemeGroupCode = value;
              break;
          default:
             alert("Required values not availabe in this link. Please get correct link from your distributer!");
             $window.history.back();
        }
      }
      if(vm.formData.key == "CONNECT_PARTNER"){
        if(vm.formData.arn == '0014'){
          if(vm.formData.transactionType == 'SIP'){
            if(vm.formData.CAMP){
              MessageService.error("Invalid Link");
              LoaderService.showLoader();
            }
          }
        }
      }
    }
    vm.init = function () {

      vm.chipherText = $stateParams.arn;
      if($stateParams.Euin){
        vm.stateEuinActive = true;
        sessionStorage.setItem("stateParamsEuin", $stateParams.Euin);
        vm.formData.euin = $stateParams.Euin;
      }else{
        vm.stateParamsEuin = sessionStorage.getItem("stateParamsEuin");
        if(vm.stateParamsEuin){
          vm.formData.euin = vm.stateParamsEuin;
        }else{
          vm.stateEuinActive = false;
        }
      }
      if(vm.chipherText) {
        vm.formData.chipherText = vm.chipherText;
        localStorage.setItem("chipherText", vm.chipherText);
      } else {
        vm.chipherText = localStorage.getItem("chipherText");
        vm.formData.chipherText = vm.chipherText;
      }
      if($stateParams.schemeGroupCode){
        var data = {};
        data.schemeGroupCode = $stateParams.schemeGroupCode;
        if($stateParams.arnFlag.toUpperCase() == "TRUE"){
          data.arnFlag = true
        }
         if($stateParams.arnFlag.toUpperCase() == "FALSE"){
          data.arnFlag = false
        }
        sessionStorage.setItem("PARTNER_DATA", JSON.stringify(data));
        localStorage.setItem("distributorDetails",$window.JSON.stringify(vm.formData));
      }else{
        if(vm.chipherText.length == 14 && !vm.chipherText.includes("|")){
          vm.getArnDataById(vm.chipherText);
        }else{
          vm.shortCode(vm.chipherText);
          vm.formData.flowName = null;
          localStorage.setItem("distributorDetails",$window.JSON.stringify(vm.formData));
        }
      }
    };
    vm.init();

    vm.getEuinRIA = function(){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.formData.rianame = resp.data.distributorName;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function () {
        LoaderService.hideLoader();
        MessageService.error();
      };
      var path = {
        child1: 'getEuin',
        child2: vm.formData.riaCode,
        riaOpted: true
      };
      IIHttpService.get(path).$promise.then(success, error);
    }  
    vm.Logout = function(){
          vm.linkDetails = $window.JSON.parse(localStorage.getItem("distributorDetails"))
          AuthService.logoutInstantLogin().then(function () {
              localStorage.removeItem("cancelAcknowledementData"); 
              $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.linkDetails.chipherText+"?ScheduleTransaction=true";
          }, function () {
              localStorage.removeItem("cancelAcknowledementData"); 
              $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/RT/"+vm.linkDetails.chipherText+"?ScheduleTransaction=true";
          });
        } 
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .controller('BrowserUpdateController', browserUpdateController);

  function browserUpdateController(deviceDetector, BrowserService, uaParser, AppConstants) {

    var vm = this;
    vm.AppConstants = angular.copy(AppConstants.BROWSERS);
    vm.deviceDetector = deviceDetector;
    vm.forceUpdateForCompatibleBrowser = BrowserService.forceUpdateForCompatibleBrowser;
    vm.forceUpdateForCompatibleBrowser();
    vm.browserName=uaParser.getBrowser().name;
    vm.browserNameUPC=vm.browserName.toUpperCase();
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .run(runBlock)
    // .run(paynimoLoadScript);

  /** @ngInject */
  function runBlock($state, $window, $rootScope, $cookies, $uibModalStack, AuthService, LoaderService, AppConstants, MetaTagService, $transitions, HDFC_API, $stateParams, UtilService) {
    var allowNav = false;
    var checkNav = false;
    $rootScope.WEBSITE_LINK = HDFC_API.WEBSITE_LINK;
    var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState) {

      $rootScope.$state = $state;
      $uibModalStack.dismissAll();
      LoaderService.hideLoader();

      $rootScope.$state = $state;
      if (!$state.current.name && toState.defaultRoute) {
        event.preventDefault();
        $state.go(toState.name + toState.defaultRoute);
        return;
      }
      if (toState.name != "main.rollover") {
        localStorage.removeItem('rollOverRequest');
      }
      var loggedIn = localStorage.getItem('loggedIn');
      if (loggedIn == "true") {
        if (toState.name && toState.name.indexOf('welcome') > -1) {
        //put condition here
        }
        else {
          var emailcheck = localStorage.getItem('emailIdExist');
          if (emailcheck && emailcheck == "false") {
            $state.go('welcome');
          }
        }
      }

      var folioNumberKyc = $cookies.get('kyc_folio');
      if (folioNumberKyc) {
        if (toState.name != "main.KycUpdate") {
          $cookies.remove('kyc_folio');
        }
      }

      var folioNumberFatca = $cookies.get('fatca_folio');
      if (folioNumberFatca) {
        if (toState.name != "main.fatcaUpdate") {
          $cookies.remove('fatca_folio');
        }
      }


      $rootScope.online = navigator.onLine;
      $window.addEventListener("offline", function () {
        $rootScope.$apply(function () {
          $rootScope.online = false;
        });
      }, false);
      $window.addEventListener("online", function () {
        $rootScope.$apply(function () {
          $rootScope.online = true;
        });
      }, false);

      if (toState.instantAauthenticate) {
        AuthService.isInstantLoggedIn(toState.name).then(function (loggedIn) {
          if ((toState.instantAauthenticate && !loggedIn.isLoggedIn)) { /*&& !loggedIn*/
            event.preventDefault();
            $state.go('instantLogin');
          }
        });
      } else {
        AuthService.isLoggedIn(toState.name).then(function (loggedIn) {

          if ((toState.authenticate && !loggedIn.isLoggedIn && !sessionStorage.isLoggedIn)) { /* && !loggedIn*/
            event.preventDefault();
            AuthService.logout().then(function () {
              localStorage.removeItem('emailIdExist');
              localStorage.setItem('loggedIn', false);
              // $cookies.remove('token_data');
              AuthService.clearCookies(AppConstants.IDENTIFIER)
              $state.go('login');
            }, function () {
              // localStorage.removeItem('emailIdExist');
              // localStorage.setItem('loggedIn', false);
              // AuthService.clearCookies(AppConstants.IDENTIFIER)
              // // $cookies.remove('token_data');
              // $state.go('login');
            });
          }

          if (loggedIn && loggedIn.isLoggedIn) {

            /*if ( toState.name != '404') {/!*!loggedIn.isAuthorized &&*!/
              event.preventDefault();
              $state.go('404');
            }*/

            AuthService.getCurrentUser().then(function (user) {
              if (toState.roles && !(toState.roles.indexOf(user.role) > -1)) {
                $rootScope.$emit('404');
              }
            }, function () {
              $rootScope.$emit('404');
            })
          }
        });
      }
    });


    var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function () {
      allowNav = checkNav;
      checkNav = true;
      $rootScope.$emit('UpdateSideBar');
      /*netcore script end here*/
      (typeof $window.smartech == 'function') && $window.smartech('dispatch',1,{});
      /*netcore script start here*/
    });

    $rootScope.$on('$locationChangeStart', function (event) {
      // Prevent the browser default action (Going back)
      //Reference https://stackoverflow.com/questions/31308958/disable-browser-back-button-for-one-page-application
      if (checkNav) {
        if (!allowNav) {
          event.preventDefault();
        } else {
          allowNav = false;
        }
      }

      if($state.current.name !== "login") {
        var top = $uibModalStack.getTop();
          if (top) {
          $uibModalStack.dismiss(top.key);
          event.preventDefault();
        }
      }

      if ($state.current.name && $state.current.name !== 'main.statements') {
        sessionStorage.removeItem('isStatementStateReloaded');
      }
    });

    $window.NumToWord = function (inputNumber, outputControl, model) {

      var afterDecimal = '', str = '';
      var num = inputNumber.toString().replace(/[\, ]/g, '');
      var x = num.indexOf('.');
      if (x !== -1) {
        str = num.split('.')[0];
        str = num.length > 0 ? str : '';
        afterDecimal = num.split('.')[1];
      } else {
        str = num;
      }

      if (str.length < 14) {
        var aboveCrore = "", aboveCroreWord = "";
        var belowCrore = "", belowCroreWord = "", finalResult = '';
        if (str.length > 7) {
          aboveCrore = str.substring(0, str.length - 7);
          belowCrore = str.substring(aboveCrore.length);
          aboveCroreWord = inWordUpToLack(aboveCrore) ? inWordUpToLack(aboveCrore) + ' Crore ' : '';
          belowCroreWord = inWordUpToLack(belowCrore);
        } else {
          belowCroreWord = inWordUpToLack(str);
        }

        if (aboveCroreWord || belowCroreWord) {
          finalResult = aboveCroreWord + belowCroreWord;
          if (finalResult != " One") {
            finalResult = finalResult + ' Rupees ';
          } else {
            finalResult = finalResult + ' Rupee ';
          }
        } else {
          finalResult = '';
        }
        finalResult += afterDecimalWord(afterDecimal);
        finalResult = finalResult ? finalResult + ' Only' : '';
      } else {
        finalResult = 'Too long';
      }
      if ($window.document.getElementById(outputControl)) {
        $window.document.getElementById(outputControl).innerHTML = finalResult;
      } else if (model) {
        model.amountInWords = finalResult;
      }
    };

    function afterDecimalWord(afterDecimal) {
      var afterDecimalWord = '';
      if (afterDecimal.length > 0 && afterDecimal.length <= 2) {
        afterDecimalWord = ' and ' + inWordUpToLack(afterDecimal) + ' Paise ';
      } else if (afterDecimal.length > 0 && afterDecimal.length > 2) {
        afterDecimalWord = ' and ' + inWordUpToLack(afterDecimal.substring(0, 2)) + ' Paise ';
      }
      return afterDecimalWord;
    }

    function inWordUpToLack(inputNumber) {

      var str = '' + inputNumber;
      var splt = str.split("");
      var rev = splt.reverse();
      var once = ['Zero', ' One', ' Two', ' Three', ' Four', ' Five', ' Six', ' Seven', ' Eight', ' Nine'];
      var twos = ['Ten', ' Eleven', ' Twelve', ' Thirteen', ' Fourteen', ' Fifteen', ' Sixteen', ' Seventeen', ' Eighteen', ' Nineteen'];
      var tens = ['', 'Ten', ' Twenty', ' Thirty', ' Forty', ' Fifty', ' Sixty', ' Seventy', ' Eighty', ' Ninety'];

      var numLength = rev.length;
      var word = [];
      var j = 0;

      for (var i = 0; i < numLength; i++) {
        switch (i) {

          case 0:
            if ((rev[i] == 0) || (rev[i + 1] == 1)) {
              word[j] = '';
            }
            else {
              word[j] = '' + once[rev[i]];
            }
            word[j] = word[j];
            break;

          case 1:
            aboveTens();
            break;

          case 2:
            if (rev[i] == 0) {
              word[j] = '';
            }
            else if ((rev[i - 1] == 0) || (rev[i - 2] == 0)) {
              word[j] = once[rev[i]] + " Hundred ";
            }
            else {
              word[j] = once[rev[i]] + " Hundred ";
            }
            break;

          case 3:
            if (rev[i] == 0 || rev[i + 1] == 1) {
              word[j] = '';
            }
            else {
              word[j] = once[rev[i]];
            }
            if ((rev[i + 1] != 0) || (rev[i] > 0)) {
              word[j] = word[j] + " Thousand";
            }
            break;

          case 4:
            aboveTens();
            break;

          case 5:
            if ((rev[i] == 0) || (rev[i + 1] == 1)) {
              word[j] = '';
            }
            else {
              word[j] = once[rev[i]];
            }
            if (rev[i + 1] !== '0' || rev[i] > '0') {
              word[j] = word[j] + " Lakh";
            }

            break;

          case 6:
            aboveTens();
            break;

          case 7:
            if ((rev[i] == 0) || (rev[i + 1] == 1)) {
              word[j] = '';
            }
            else {
              word[j] = once[rev[i]];
            }
            if (rev[i + 1] !== '0' || rev[i] > '0') {
              word[j] = word[j] + " Crore";
            }
            break;

          case 8:
            aboveTens();
            break;

          default:
            break;
        }
        j++;
      }

      function aboveTens() {
        if (rev[i] == 0) {
          word[j] = '';
        }
        else if (rev[i] == 1) {
          word[j] = twos[rev[i - 1]];
        }
        else {
          word[j] = tens[rev[i]];
        }
      }

      word.reverse();
      var finalOutput = '';
      for (i = 0; i < numLength; i++) {
        finalOutput = finalOutput + word[i];
      }

      return finalOutput;
    }

    angular.element(document).ready(function () {
      angular.element('[data-bs-toggle="tooltip"]').tooltip();
    });

    $rootScope.$on("$destroy", function () {
      stateChangeStart();
      stateChangeSuccess();
    });
    $window.onload = function() {
      var userId = localStorage.getItem('userId') || "";
      if(userId) {window.dataLayer.push({'userId': userId})}
    };

    /*Transitions service injected to identify the current state*/
    $transitions.onSuccess({}, function(transition) {
      var toState = transition.to().name;
      // var restrictedState = ['login', 'instantLogin', 'updateContactLogin', 'instantLoginHome.instantInvest', 'unlockfolioid',
      //   'forgotfolio', 'updateContact.update', 'forgotUserId', 'forgotPassword', 'faq', 'createUserId.verifyAccountDetails',
      //   'createUserId.verifyOTP', 'registration.newInvestor', 'registration.kycVerification', 'registration.main', 'registration.otp',
      //   'registration.success','breadcrumb', 'instantLoginHome.payment','arnReview','arnReview.verifyPan','arnReview.select-folio','logoutArn','kyc','verifykyc','arnReview.verifyPan1',
      //   'investNow', 'preLoginBasket', 'preLoginBasket.investNow', 'preLoginBasket.investNowScheme', 'preLoginBasket.goals', 'preLoginBasket.folioCreation', 'preLoginBasket.payment',
      //   'preLoginBasket.review', 'preLoginBasket.purchaseTransactionSuccess', 'preLoginBasket.sipTransactionSuccess','preLoginWhatsapp','preLoginWhatsappHome','preLoginWhatsappHome.apiWhatsappPayment','preLoginWhatsappHome.paymentacknowledgement','wekyc'
      // ];
      var uiViewElement = angular.element(document.querySelector('body > .height100'));
      angular.element($window.document.body).removeClass('hide-scroll');
      if (toState !== "login" && toState !== "instantLogin") {
        MetaTagService.clearTags();
      }
      // if (HDFC_API.ENV != 'dev' && HDFC_API.ENV != 'qa' && HDFC_API.ENV != 'development') {
      //   if (!restrictedState.includes(toState)) {
      //     uiViewElement.removeAttr('id');
      //     if($('#allincall-script').length == 0) {
      //       MetaTagService.addScriptTag();
      //     }
      //   } else {
      //     uiViewElement.attr('id',"easyassist_block_page");
      //     MetaTagService.removeScriptTag();
      //   }
      // }
      if (toState !== "welcome.existingUserWelcome.widgets") {
        consoleWarningExecution();
      }
      if (toState === 'ekyc') {
        if (!$stateParams.prefill && !$stateParams.ekycRequestCO && !JSON.parse(sessionStorage.getItem("ekycRequestCO"))) {
          $state.go('login');
        }
      }
    });

    smartech('create', 'ADGMOT35CHFLVDHBJNIG50K96BHPP5I34ISULH5H9GBV9GQN62M0','tin');
    smartech('register',UtilService.genericConverter(HDFC_API.NSI) );
    smartech('identify', '');
  }

  /* @ngInject*/
  // function paynimoLoadScript($ocLazyLoad, $timeout, HDFC_API) {
  //   if (HDFC_API.ENV == 'prod' || HDFC_API.ENV == 'beta') {
  //     $timeout(function () {
  //       var Tawk_API = Tawk_API || {};
  //       (function () {
  //         var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
  //         s1.async = true;
  //         s1.src = 'https://embed.tawk.to/58b50e856b2ec15bd9f16083/default';
  //         s1.charset = 'UTF-8';
  //         s1.setAttribute('crossorigin', '*');
  //         s0.parentNode.insertBefore(s1, s0);
  //       })();
  //     },1000);

  //     /*var a = "(function(){" +
  //       "var s1=document.createElement('script'),s0=document.getElementsByTagName('script')[0];" +
  //       "s1.async=true;" +
  //       "s1.src='https://embed.tawk.to/58b50e856b2ec15bd9f16083/default';" +
  //       "s1.charset='UTF-8';" +
  //       "s1.setAttribute('crossorigin','*');" +
  //       "s0.parentNode.insertBefore(s1,s0);});";
  //     eval(a);*/
  //   } else if(HDFC_API.ENV == 'maintenance') {
  //     $ocLazyLoad.load('https://cx.camsonline.com/unfyd-webchat-hdfc/smarttalk.js');
  //   }
  // }

  function consoleWarningExecution() {
    console.API;
    if (typeof console._commandLineAPI !== 'undefined') {
      console.API = console._commandLineAPI; //chrome
    } else if (typeof console._inspectorCommandLineAPI !== 'undefined') {
      console.API = console._inspectorCommandLineAPI; //Safari
    } else if (typeof console.clear !== 'undefined') {
      console.API = console;
    }
    //console.API.clear();
    setTimeout(console.log.bind (console,"%cStop!","color: red; font-size: 43px; font-weight: bolder;"), 100);
    setTimeout(console.log.bind (console,'%cThis is a browser feature intended for developers. ' +
      'If someone told you to copy and paste something here to enable a feature or "hack" ' +
      "someone's account, it is a scam.","font-size: 22px; font-weight: bolder;"), 100);
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .factory('AuthInterceptor', authInterceptor)
    .config(routerConfig);

  /** @ngInject */
  function authInterceptor($rootScope, $cookies, $window, $q, AppConstants, $state, FormatterService) {
    var count = 0;
    function isTemplateCall(config) {
      if (!config || !config.url) {
        return;
      }
      return config.url.lastIndexOf('.html') !== -1;
    }

    return {
      request: function (config) {

        if (config.url && (config.url.indexOf("res.cloudinary.com") >= 0 || config.url.indexOf("maintenancePage") >= 0)) {
          delete config.headers['app-type'];
        } else {
          config.headers['app-type'] = 'W';
        }

        // config.headers['app-type'] = 'W';

        if (!isTemplateCall(config)) {

          if (config && config.url && config.url.indexOf('oauth/token') > -1) {
            if (config.data.grant_type === "password") {
              // $cookies.remove('token_data');
              $cookies.remove(AppConstants.IDENTIFIER);
              sessionStorage.removeItem(AppConstants.IDENTIFIER);
              $cookies.remove(AppConstants.INSTA_IDENTIFIER);
              $cookies.remove(AppConstants.NEW_INVESTOR_IDENTIFIER);
              $cookies.remove(AppConstants.MOBILE_IDENTIFIER);
            }
            return config;
          }
          /*
           if (!config.headers['token']) {

           } else {*/

          var ciphertext = sessionStorage.getItem(AppConstants.IDENTIFIER);
          var ciphertextInsta = $cookies.get(AppConstants.INSTA_IDENTIFIER);
          var ciphertextNewInvestor = $cookies.get(AppConstants.NEW_INVESTOR_IDENTIFIER);
          var ciphertextMobile = sessionStorage.getItem(AppConstants.MOBILE_IDENTIFIER);
          /*Decrypt*/
          if (ciphertext) {
            var bytes = FormatterService.getProtoType(ciphertext.toString(), AppConstants.IDENTIFIER);
            var token = $window.JSON.parse(bytes.toString(FormatterService.hash.enc.Utf8));
          }
          if (ciphertextInsta) {
            var bytesInsta = FormatterService.getProtoType(ciphertextInsta.toString(), AppConstants.INSTA_IDENTIFIER);
            var tokenInstant = $window.JSON.parse(bytesInsta.toString(FormatterService.hash.enc.Utf8));
          }
          if (ciphertextNewInvestor) {
            var bytesNewINvestor = FormatterService.getProtoType(ciphertextNewInvestor.toString(), AppConstants.NEW_INVESTOR_IDENTIFIER);
            var tokenNewINvestor = $window.JSON.parse(bytesNewINvestor.toString(FormatterService.hash.enc.Utf8));
          }
          if (ciphertextMobile) {
            var bytesMobileLoginINvestor = $window.CryptoJS.AES.decrypt(ciphertextMobile.toString(), AppConstants.MOBILE_IDENTIFIER);
            var tokenMobileLoginINvestor = $window.JSON.parse(bytesMobileLoginINvestor.toString($window.CryptoJS.enc.Utf8));
          }


          if (token && token.access_token) {
            if (config.url && config.url.includes("res.cloudinary.com")) {
              delete config.headers['Authorization'];
            } else {
              config.headers['Authorization'] = 'Bearer ' + token.access_token;
            }
          } else if (tokenInstant && tokenInstant.access_token) {
            config.headers['Authorization'] = 'Bearer ' + tokenInstant.access_token;
          }else if (tokenNewINvestor && tokenNewINvestor.access_token) {
            config.headers['Authorization'] = 'Bearer ' + tokenNewINvestor.access_token;
          }
          else if (tokenMobileLoginINvestor && tokenMobileLoginINvestor.access_token) {
            config.headers['Authorization'] = 'Bearer ' + tokenMobileLoginINvestor.access_token;
          }

          if (sessionStorage.trackerId) {
            config.headers['sessionId'] = sessionStorage.trackerId;
            config.headers['source'] = sessionStorage.trackerSource;
          }
        }
        return config;
      },

      response: function (response) {
        if(response && response.data){
          var isLoggedIn = sessionStorage.getItem('isLoggedIn');
          if(isLoggedIn === "true"){
            if(response.data.message === AppConstants.LINKED_PAN_STATUS){
              $rootScope.$emit('SwitchPrimeInvestor', {});
            }
          }
        }
        return response;
      },

      responseError: function (response) {
        if (!isTemplateCall(response.config)) {
          if (response.status === 401) {
            if ($window.sessionStorage.getItem("isExposedStatementActive")) {
              $window.sessionStorage.removeItem("isExposedStatementActive")
              $rootScope.$emit('UpdateExposedStatementToken', response);
            } else {
              localStorage.removeItem('emailIdExist');
              localStorage.setItem('loggedIn', false);
              var ciphertextInsta = $cookies.get(AppConstants.INSTA_IDENTIFIER);
              var tokenInstant = null;
              if (ciphertextInsta) {
                var bytesInsta = FormatterService.getProtoType(ciphertextInsta.toString(), AppConstants.INSTA_IDENTIFIER);
                tokenInstant = $window.JSON.parse(bytesInsta.toString(FormatterService.hash.enc.Utf8));
              }
              var ciphertextInsta1 = $cookies.get(AppConstants.NEW_INVESTOR_IDENTIFIER);
              if (ciphertextInsta1) {
                var bytesInsta = FormatterService.getProtoType(ciphertextInsta1.toString(), AppConstants.NEW_INVESTOR_IDENTIFIER);
                tokenInstant = $window.JSON.parse(bytesInsta.toString(FormatterService.hash.enc.Utf8));
              }
              var ciphertextMobileLogin = sessionStorage.getItem(AppConstants.MOBILE_IDENTIFIER);
              if (ciphertextMobileLogin) {
                var bytesInsta = $window.CryptoJS.AES.decrypt(ciphertextMobileLogin.toString(), AppConstants.MOBILE_IDENTIFIER);
                tokenInstant = $window.JSON.parse(bytesInsta.toString($window.CryptoJS.enc.Utf8));
              }
              if (tokenInstant) {
                count++;
                if(ciphertextMobileLogin){
                  $rootScope.$emit('RemoveMobileToken', response);
                }else if (count <= AppConstants.API_RETRY_COUNT) {
                  $rootScope.$emit('UpdateRefreshToken', response);
                } else {
                  count = 0;
                  if(ciphertextInsta1){
                    $state.go("sessionExpired");
                    instaForceLogoutNewJourney();
                  }else{
                    $state.go('login');
                    instaForceLogout();
                  }
                }
              } else {
                $rootScope.$emit('UpdateRefreshToken', response);
              }
            }
          } else if (response.status === 504) {
            $rootScope.$emit('UpdateTimeOut', response);
          }
        }
        return $q.reject(response);
      }
    };
  }

  /** @ngInject */
  function routerConfig($httpProvider, $locationProvider, $sceDelegateProvider, $stateProvider, $urlRouterProvider) {

    $httpProvider.interceptors.push('AuthInterceptor');
    $httpProvider.interceptors.push('ApiInterceptor');
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });
    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      // Allow loading from our assets domain.  Notice the difference between * and **.
      'http://hdfc-dev-distributor.tothenew.com/**'
    ]);
    $urlRouterProvider.otherwise('/404');

    $stateProvider
      .state('404', {
        url: '/404',
        templateUrl: '404.html'
      })
      .state('browserUpdate', {
        url: '/Update-browser',
        templateUrl: 'app/browser-update/browser-update.html',
        controller: 'BrowserUpdateController',
        controllerAs: 'BrowserUpdate'
      })
      .state('login', {
        url: '/?trackId&trxnType&stepNo?isMactive',
        templateUrl: 'app/login/landing-new.html',
        controller: 'LoginController',
        controllerAs: 'Login',
        resolve: {
          isLoggedIn: _isLoggedIn
        }
      })
      .state('register', {
        url: '/register',
        templateUrl: 'app/login/landing-new.html',
        controller: 'LoginController',
        controllerAs: 'Login',
        resolve: {
          isLoggedIn: _isLoggedIn
        }
      })
      .state('loginPage', {
        url: '/login',
        resolve: {
          isRedirect: _isRedirect
        }
      })
      .state('breadcrumb', {
        url: '/sidebar',
        templateUrl: 'app/login/login-components/breadcrumb.html',
        controller: 'LoginController',
        controllerAs: 'Login',
      })
      .state('login-user-tracker', {
        url: '/activity/:trackId?trxnType&stepNo',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'Login',
        resolve: {
          isLoggedIn: _isValidTrackId
        }
      })
      .state('validateFolio', {
        url: '/validate-folio?tab',
        templateUrl: 'app/exposed-statements/authenticate.html',
        controller: 'ExposedStatementsController',
        controllerAs: 'ExposedStatements',
        authenticate: false
      })
      .state('exposedStatements', {
        url: '/exposed-statements/:folioNumber/:tabType',
        templateUrl: 'app/statements/statements.html',
        controller: 'StatementsController',
        controllerAs: 'Statements',
        resolve: {
          _isSessionActive: _isSessionActive
        },
        authenticate: false
      })
      .state('instantLogin', {
        url: '/instant-login?trackId&trxnType&stepNo',
        templateUrl: 'app/instant-investment/login/login.html',
        controller: 'InstantLoginController',
        controllerAs: 'InstantLogin',
        resolve: {
          isLoggedIn: _isInstantLoggedIn
        }
      })
      .state('newInvestor', {
        url: '/new-investor',
        templateUrl: 'app/new-investors/new-investor-registration.html',
        controller: 'NewInvestorController',
        controllerAs: 'NewInvestor',
        resolve: {
          isLoggedIn: _isBackLoggedIn
        }
      })
      .state('instantLoginHome', {
        url: '/instantInvest',
        templateUrl: 'app/instant-investment/home.html',
        controller: 'InstantLoginHomeController',
        controllerAs: 'HomeInstant',
        instantAauthenticate: true,
        resolve: {
          isLoggedIn: _isInstantLoggedIn
        }
      })
      .state('updateContactLogin', {
        url: '/update-user-contact',
        templateUrl: 'app/update-contact/update-contact-login.html',
        controller: 'UpdateContactController',
        controllerAs: 'UpdateContact',
        resolve : {
          dynamicNotes: _fetchDynamicDataUpdateContact
        }
      })
      .state('sessionExpired', {
        url: '/session-expired',
        templateUrl: 'app/logout/logout.html',
        controller: 'LogoutController',
        controllerAs: 'Logout'
      })
      .state('registerUser', {
        url: '/register-user',
        templateUrl: 'app/registration/registration.user.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration'
      })
      .state('instantLoginHome.instantInvest', {
        url: '/investment?trackId&trxnType&stepNo',
        templateUrl: 'app/instant-investment/instant-investment.html',
        controller: 'InstantInvestController',
        controllerAs: 'InstantInvest',
        instantAauthenticate: true,
        resolve: {
           dynamicData : _fetchDynamicDataQuickInvestement,
           isLoggedIn: _isInstantLoggedIn
        }
      })
      .state('instantLoginHome.review', {
        url: '/review?trackId&trxnType&stepNo',
        templateUrl: 'app/instant-investment/folio-review-directive.html',
        controller: 'InstantInvestmentSummaryController', /*InstantInvestController*/
        controllerAs: 'Summary',
        instantAauthenticate: true
      })
      .state('instantLoginHome.info', {
        url: '/info',
        templateUrl: 'app/instant-investment/paymentInfo.html',
        controller: 'InstantInvestController',
        controllerAs: 'InstantInvest',
        instantAauthenticate: true
      })
      .state('instantLoginHome.payment', {
        url: '/payment?trackId&trxnType&stepNo&sipWithFirstInstallment&isUpi',
        templateUrl: 'app/instant-investment/purchase/payment-screen.html',
        controller: 'InstantPaymentController',
        controllerAs: 'Payment',
        instantAauthenticate: true,
        resolve: {
          notesInstantPayment : _fetchDynamicDataQuickInvestement,
          isLoggedIn: _isInstantLoggedIn
        }
      })
      .state('home', {
        url: '/home?trackId&trxnType&stepNo',
        templateUrl: 'app/home/home.html',
        controller: 'HomeController',
        controllerAs: 'Home',
        authenticate: true
      })

      .state('tracker', {
        url: '/tracker?source',
        templateUrl: 'app/tracker/tracker.html',
        controller: 'TrackerController',
        controllerAs: 'Tracker',
        authenticate: false
      })
      .state('updateContact', {
        url: '/update-contact',
        templateUrl: 'app/update-contact/update-contact-index.html',
        controller: 'UpdateContactController',
        controllerAs: 'UpdateContact',
        resolve : {
          dynamicNotes: _fetchDynamicDataUpdateContact
        }
      })
      .state('updateContact.updateContactSuccess', {
        url: '/update-contact-success',
        templateUrl: 'app/update-contact/updateContactSuccessAcknowledgement.html',
        controller: 'UpdateContactController',
        controllerAs: 'UpdateContact',
        resolve : {
          dynamicNotes: _fetchDynamicDataUpdateContact
        }
      })
      .state('updateContact.update', {
        url: '/update?q',
        templateUrl: 'app/update-contact/contact-update.html',
        controller: 'UpdateContactController',
        controllerAs: 'UpdateContact',
        resolve : {
          dynamicNotes: _fetchDynamicDataUpdateContact
        }
      })

      .state('main', {
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'Main',
        authenticate: false,
        resolve: {
          checkDataUpdate: _checkDataUpdate
        }
      })
      .state('main.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'Dashboard',
        authenticate: true,
        abstract: true
      })
      .state('main.dashboardEdit', {
        url: '/dashboard/edit',
        templateUrl: 'app/dashboard/edit.dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'Dashboard',
        authenticate: true,
        abstract: true
      })
      .state('main.unclaimedDividend', {
        url: '/unclaimedDividend',
        templateUrl: 'app/quick-links/unclaimedDividend.html',
        authenticate: false
      })
      .state('main.changeDividendOption', {
        url: '/changeDividendOption?folioNumber&&sc',
        templateUrl: 'app/quick-links/changeDividendOption.html',
        controller: 'ChangeDividendOptionController',
        controllerAs: 'ChangeDividendOption',
        resolve : {
          dynamicDataReview : _fetchDynamicDataChangeIcdw
        },
        authenticate: false
      })
      .state('main.rollover', {
        url: '/rollover',
        params: {
          schemeData: null
        },
        templateUrl: 'app/transactions/roll-over/rollover.html',
        controller: 'RolloverController',
        controllerAs: 'Rollover',
        authenticate: true
      })
      .state('main.rolloverView', {
        url: '/rollover-view',
        templateUrl: 'app/transactions/roll-over/rollover-view.html',
        controller: 'RolloverController',
        controllerAs: 'Rollover',
        authenticate: true
      })
      .state('main.systematicCorner', {
        url: '/systematicCorner',
        templateUrl: 'app/systematic-corner/systematicCorner.html',
        controller: 'SystematicController',
        controllerAs: 'Systematic',
        authenticate: true
      })

      .state('main.rollOverReview', {
        url: '/rollover-review',
        templateUrl: 'app/transactions/roll-over/rollOverReview.html',
        controller: 'RolloverController',
        controllerAs: 'Rollover',
        authenticate: true
      })

      .state('main.todos', {
        url: '/dashboard/todos',
        templateUrl: 'app/dashboard/todos.html',
        controller: 'TodosController',
        controllerAs: 'Todos',
        authenticate: true
      })
      .state('admin', {
        url: '/admin',
        templateUrl: 'app/admin/admin.html',
        authenticate: false
      })
      .state('main.transactions', {
        url: '/transactions?trStatus&&fromDate&&toDate',
        templateUrl: 'app/transactions/transactions.html',
        authenticate: true,
        //defaultRoute: '.list'
        abstract: true
      })
      // .state('main.transactions.list', {
      //   url: '',
      //   templateUrl: 'app/transactions/list/list.html',
      //   controller: 'ListController',
      //   controllerAs: 'List',
      //   cache: false,
      //   authenticate: true
      // })
      .state('main.transactions.recent', {
        url: '/recent',
        templateUrl: 'app/transactions/list/recentList.html',
        controller: 'ListController',
        controllerAs: 'List',
        cache: false,
        authenticate: true
      })
      .state('main.transactions.all', {
        url: '/all',
        templateUrl: 'app/transactions/list/allList.html',
        controller: 'ListController',
        controllerAs: 'List',
        cache: false,
        authenticate: true
      })
      .state('main.transactions.sip', {
        url: '/initiate/sip?trackId&folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId?option?isFavourite?allowBroker&action&amount&frequency',
        templateUrl: 'app/transactions/initiate/sip-purchase/sip/sip.html',
        controller: 'InitiateTransactionSipController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataSipPurchaseReview : _fetchDynamicDataSip
        }
      })
      .state('main.transactions.dreamSip', {
        url: '/initiate/dream-sip?trackId&folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId?option?isFavourite?allowBroker&action',
        templateUrl: 'app/transactions/initiate/dream-sip/dream-sip.html',
        controller: 'DreamSipController',
        controllerAs: 'DreamSip',
        authenticate: true,
        resolve: {
          DynamicDataSipPurchaseReview : _fetchDynamicDataSip
        }
      })
      .state('main.transactions.sip-topup', {
        url: '/initiate/sip-topup?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId?option?isFavourite',
        templateUrl: 'app/transactions/initiate/sip-topup/sip-topup.html',
        controller: 'InitiateTransactionSipTopupController',
        controllerAs: 'SipTopup',
        authenticate: true,
        params: {
          transactionData: null
        }
      })
      .state('main.transactions.purchase', {
        url: '/initiate/purchase?trackId&folioNumber&&trStatus&transactionId&stepNo&transactionType&isCompId&sc&ctId&eCart?option?isFavourite&action',
        templateUrl: 'app/transactions/initiate/sip-purchase/purchase/purchase.html',
        controller: 'InitiateTransactionPurchaseController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataSipPurchaseReview : _fetchDynamicDataPurchase
        }
      })
      .state('main.transactions.switch', {
        url: '/initiate/switch?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId?isFavourite',
        templateUrl: 'app/transactions/initiate/switch/switch.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
           DynamicDataReview : _fetchDynamicDataSwitch
        }
      })
      .state('main.transactions.swp', {
        url: '/initiate/swp?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId?isFavourite',
        templateUrl: 'app/transactions/initiate/swp/swp.html',
        controller: 'InitiateTransactionSwpController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataReview : _fetchDynamicDataSwap
        }

      })
      .state('main.transactions.smartSwap', {
        url: '/initiate/smartSwap?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId?isFavourite',
        templateUrl: 'app/transactions/initiate/smart-swap/smartSwp.html',
        controller: 'InitiateTransactionSmartSwpController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataReview : _fetchDynamicDataSmartSwap
        }
      })
      .state('main.transactions.stp', {
        url: '/initiate/stp?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId&referrer&isFavourite',
        templateUrl: 'app/transactions/initiate/stp/stp.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataReview : _fetchDynamicDataSTP
        }
      })
      .state('main.transactions.dtp', {
        url: '/initiate/tip?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId&isFavourite',
        templateUrl: 'app/transactions/initiate/dtp/dtp.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataReview : _fetchDynamicDataTip
        }
      })
      .state('main.transactions.redemption', {
        url: '/initiate/redemption?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId&isFavourite',
        templateUrl: 'app/transactions/initiate/redemption/redemption.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataReview : _fetchDynamicDataRedemption
        }
      })
      .state('main.transactions.instantRedemption', {
        url: '/initiate/instantAccessFacility?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&isFavourite',
        templateUrl: 'app/transactions/initiate/instant-redemption/instant-redemption.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataReview : _fetchDynamicDataIAF
        }
      })
      .state('main.transactions.nfoswitchout', {
        url: '/initiate/nfoswitchout?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId&isFavourite',
        templateUrl: 'app/transactions/initiate/nfoSwitchOut/nfoswitchout.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
         resolve: {
          DynamicDataReview : _fetchDynamicDataSwitch
         }
      })
      .state('main.transactions.flexindex', {
        url: '/initiate/flexindex?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId&isFavourite',
        templateUrl: 'app/transactions/initiate/flexindex/flexindex.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataReview : _fetchDynamicDataFlexIndex
        }
      })
      .state('main.transactions.flexsip', {
        url: '/initiate/flexsip?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId&isFavourite',
        templateUrl: 'app/transactions/initiate/flexsip/flexsip.html',
        controller: 'InitiateTransactionFlexSipController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataFlexSipReview : _fetchDynamicDataFlexSip
        }
      })
      .state('main.transactions.payment', {
        url: '/payment?trackId&stepNo&sipWithFirstInstallment&isUpi',
        templateUrl: 'app/transactions/payments/payment-screen.html',
        controller: 'PaymentController',
        controllerAs: 'Payment',
        authenticate: true,
        resolve: {
          notesPayment : _fetchDynamicDataPurchasePayment
        }
      })

      .state('main.transactions.cart', {
        url: '/checkout',
        templateUrl: 'app/e-cart/checkout/cart.html',
        controller: 'EcartController',
        controllerAs: 'Ecart',
        authenticate: true,
        resolve: {
          notesEcart : _fetchDynamicDataEcart,
          DynamicDataSipPurchaseReview : _fetchDynamicDataSip
        }
      })

      .state('main.transactions.edit', {
        url: '/edit?folioNumber&cartItemId&schemeCode&brokerCode&subBrokerARN&amount&euinCode&euinName&subBrokerCode&minorFlag&folioInvestorName&dividendOption&riaConsent&riaOpted',
        templateUrl: 'app/e-cart/checkout/cartEdit.html',
        controller: 'EditCartController',
        controllerAs: 'EditEcart',
        authenticate: true,
        resolve :  {
          cutoffData : _fetchDynamicDataEcart
        }
      })

      .state('main.sipCancellation', {
        url: '/sip-cancellation',  //?transactionId&transactionType
        templateUrl: 'app/systematic-corner/cancellation-review.html',
        controller: 'SystematicController',
        controllerAs: 'Systematic',
        authenticate: true
      })

      .state('main.sipCancellationDetails', {
        url: '/sip-cancellation-details',
        templateUrl: 'app/systematic-corner/cancellation-details.html',
        controller: 'SystematicController',
        controllerAs: 'Systematic',
        authenticate: true
      })

      .state('main.pause-summary', {
        url: '/sip-pause-summary',
        templateUrl: 'app/systematic-corner/pause-summary.html',
        controller: 'SystematicController',
        controllerAs: 'Systematic',
        authenticate: true
      })

      .state('main.sip-pause', {
        url: '/sip-pause-details',
        templateUrl: 'app/systematic-corner/sip-pause.html',
        controller: 'SystematicController',
        controllerAs: 'Systematic',
        authenticate: true
      })

      .state('main.smartSwap-cancel', {
        url: '/smart-swp-cancel-details',
        templateUrl: 'app/systematic-corner/smartSwap-cancel.html',
        controller: 'SystematicController',
        controllerAs: 'Systematic',
        authenticate: true
      })

      .state('main.smartSwap-cancel-summary', {
        url: '/smart-swp-cancel-details-summary',
        templateUrl: 'app/systematic-corner/cancellation-details.html',
        controller: 'SystematicController',
        controllerAs: 'Systematic',
        authenticate: true
      })

      .state('main.transactions-view', {
        url: '/scheme-overview',
        templateUrl: 'app/transactions/view/transaction-view.html',
        controller: 'TransactionViewController',
        controllerAs: 'TransactionViewParentCtrl',
        authenticate: true,
        defaultRoute: '.details'
      })
      .state('main.transactions-view.details', {
        url: '/details',
        templateUrl: 'app/transactions/view/schemeOverview/details.html',
        controller: 'TransactionViewController',
        controllerAs: 'TransactionView',
        // parent: 'main.transactions-view',
        authenticate: true
      })
      .state('main.transactions-view.transactions', {
        url: '/transactions',
        templateUrl: 'app/transactions/view/schemeOverview/transactions.html',
        controller: 'TransactionViewController',
        controllerAs: 'TransactionView',
        // parent: 'main.transactions-view',
        authenticate: true
      })

      .state('main.changeDividend', {
        url: '/change-dividend',
        templateUrl: 'app/transactions/changeDividend/change-dividend.html',
        controller: 'ChangeDividendController',
        controllerAs: 'ChangeDividend',
        authenticate: true
      })

      .state('resetpassword', {
        url: '/resetpassword/:secretKey',
        templateUrl: 'app/forgot/resetPassword/resetPassword.html',
        controller: 'ResetPasswordController',
        controllerAs: 'ResetPassword',
        authenticate: false
      })
      .state('forgotfolio', {
        url: '/forgot-folio?from',
        templateUrl: 'app/forgot/forgotFolio/forgotFolio.html',
        controller: 'ForgotFolioController',
        controllerAs: 'ForgotFolio',
        authenticate: false
      })
      .state('unlockfolioid', {
        url: '/unlock/:type?from',
        templateUrl: 'app/unlock/unlockFolioId/unlockFolioId.html',
        controller: 'UnlockFolioIdController',
        controllerAs: 'UnlockFolioId',
        authenticate: false
      })
      .state('main.investors', {
        url: '/investors',
        templateUrl: 'app/investors/investors.html',
        controller: 'InvestorsController',
        controllerAs: 'Investors',
        authenticate: true,
        defaultRoute: '.list'
      })
      .state('main.investors.list', {
        url: '/list?type',
        templateUrl: 'app/investors/list/investors-list.html',
        controller: 'InvestorsController',
        controllerAs: 'Investors',
        authenticate: true
      })
      .state('main.investors.profile', {
        url: '/profile/:investorId',
        templateUrl: 'app/investors/profile/investor-profile.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true,
        defaultRoute: '.portfolio',
        resolve: {
          investorProfile: _investorProfile
        }
      })
      .state('main.investors.profile.basicinfo', {
        url: '/info',
        templateUrl: 'app/investors/profile/basicinfo/basic-info.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true
      })
      .state('main.investors.profile.portfolio', {
        url: '/portfolio',
        templateUrl: 'app/investors/profile/portfolio/portfolio.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true
      })
      .state('main.investors.profile.transactions', {
        url: '/transactions',
        templateUrl: 'app/investors/profile/transactions/transactions.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true
      })
      .state('main.investors.profile.financialgoals', {
        url: '/financialgoals',
        templateUrl: 'app/investors/profile/financialgoals/financial-goals.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true
      })

      .state('main.summary', {
        url: '/summary/:transactionType?transactionSubType&trackId&stepNo',
        templateUrl: 'app/transactions/summary/summary.html',
        controller: 'SummaryController',
        controllerAs: 'Summary',
        authenticate: true
      })
      .state('main.emandate', {
        url:'/registerEMandate',
        templateUrl: 'app/investor/profile/registerMandate/registerMandate.html',
        controller: 'RegisterMandateController',
        controllerAs: 'RegisterMandate',
        authenticate: true,
    resolve : { dynamicData : _fetchDynamicDataStandloneEmandate}
      })
      .state('main.emandatereview', {
        url:'/registerEMandateReview',
        templateUrl: 'app/investor/profile/registerMandate/summary.registerMandate.html',
        controller: 'RegisterMandateReviewController',
        controllerAs: 'RegisterMandateReview',
        authenticate: true
      })
      /*.state('main.summary-tracked', {
        url: '/summary/:transactionType?trackId&transactionSubType&stepNo',
        templateUrl: 'app/transactions/summary/summary.html',
        controller: 'SummaryController',
        controllerAs: 'Summary',
        authenticate: true
      })*/
      .state('main.summary-success', {
        url: '/transaction/:transactionId/:transactionType/:isFavourite',
        templateUrl: 'app/transactions/status/transaction-status.html',
        controller: 'TrStatusController',
        controllerAs: 'Summary',
        authenticate: true,
        resolve: {summaryData: _transactionSummary}
      })
      .state('manual', {
        url: '/manual/:name/:sip',
        templateUrl: 'app/transactions/summary/transactionFail/fail-transaction.html',
        controller: 'TransactionFailController',
        controllerAs: 'TransactionFail',
        authenticate: true
      })
      .state('payment-billdesk', {
        url: '/payment/billdesk/summary?msg',
        templateUrl: 'app/transactions/summary/payment/payment.billdesk.html',
        controller: 'PaymentBillDeskController',
        controllerAs: 'PaymentBillDesk',
        authenticate: true
      })
      /*.state('payment-paynimo', {
        url: '/payment/paynimo/summary?txthdnMsg&txthdntpslmrctcd',
        templateUrl: 'app/transactions/summary/payment/payment.paynimo.html',
        controller: 'PaymentPaynimoController',
        controllerAs: 'PaymentPaynimo',
        authenticate: true
      })*/
      .state('payment-billjunction', {
        url: '/payment/billjunction/summary?msg',
        templateUrl: 'app/transactions/summary/payment/payment.billjunction.html',
        controller: 'PaymentBillJunctionController',
        controllerAs: 'PaymentBillJunction',
        authenticate: true
      })
      .state('main.statements', {
        url: '/statements?type',
        templateUrl: 'app/statements/statements.html',
        controller: 'StatementsController',
        controllerAs: 'Statements',
        authenticate: true
      })
      .state('main.services', {
        url: '/services',
        templateUrl: 'app/nfsservices/nfsservices.html',
        controller: 'NfsservicesController',
        controllerAs: 'Nfsservices',
        authenticate: true
      })
      .state('main.financialtool', {
        url: '/financial-tool',
        templateUrl: 'app/financialPlanningTool/financial-planning-tool.html',
        controller: 'FinancialPlanningToolController',
        controllerAs: 'FinancialPlanningTool',
        authenticate: true
      })
      .state('main.schemecalculator', {
        url: '/scheme-calculator',
        templateUrl: 'app/schemeCalculator/schemeCalculator.html',
        controller: 'SchemeCalculatorController',
        controllerAs: 'SchemeCalculator',
        authenticate: true
      })
      .state('main.sipcorner', {
        url: '/sipcorner?status',
        templateUrl: 'app/sip-corner/sip-corner.html',
        controller: 'SipCornerController',
        controllerAs: 'SipCorner',
        authenticate: true
      })
      .state('distributorempanellment', {
        url: '/distributor-empanellment',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: true,
        defaultRoute: '.arn'
      })
      .state('distributorempanellment.arn', {
        url: '/arn?removeData',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment-arn.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: true
      })
      .state('distributorempanellment.nomineedetails', {
        url: '/nominee-details',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment-nomineedetails.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: true
      })
      .state('distributorempanellment.otp', {
        url: '/otp',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment-otp.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: true
      })
      .state('main.distributorProfile', {
        url: '/distributor-profile',
        templateUrl: 'app/distributor/profile/profile.html',
        controller: 'DistributorProfileController',
        controllerAs: 'DistributorProfile',
        authenticate: true
      })
      .state('main.leapacademy', {
        url: '/leapacademy',
        templateUrl: 'app/leap-academy/leap-academy.html',
        controller: 'LeapAcademyController',
        controllerAs: 'LeapAcademy',
        authenticate: true,
        defaultRoute: '.training-classes'
      })
      .state('main.globalSearch', {
        url: '/search-result/:searchString',
        templateUrl: 'app/globalSearch/search-result.html',
        controller: 'GolbalSearchController',
        controllerAs: 'GlobalSearch',
        authenticate: true
      })
      .state('main.leapacademy.training-classes', {
        url: '/training-classes',
        templateUrl: 'app/leap-academy/training-classes/training-classes.html',
        controller: 'LeapAcademyController',
        controllerAs: 'LeapAcademy',
        authenticate: true
      })
      .state('main.leapacademy.pdf-articles', {
        url: '/pdf-articles',
        templateUrl: 'app/leap-academy/pdf-articles/pdf-articles.html',
        controller: 'LeapAcademyController',
        controllerAs: 'LeapAcademy',
        authenticate: true
      })
      .state('main.notifications', {
        url: '/notifications',
        templateUrl: 'app/notifications/notifications.html',
        controller: 'NotificationController',
        controllerAs: 'Notification',
        authenticate: true
      })


      .state('main.feedback', {
        url: '/feedback',
        templateUrl: 'app/feedback/feedback.html',
        controller: 'FeedbackController',
        controllerAs: 'Feedback',
        authenticate: true
      })
      .state('main.saved-items', {
        url: '/saved-items',
        templateUrl: 'app/savedItems/savedItems.html',
        controller: 'SavedItemsController',
        controllerAs: 'SavedItems',
        authenticate: true
      })
      .state('main.managed-accounts', {
        url: '/managed-accounts',
        templateUrl: 'app/manageAccounts/manageAccounts.html',
        controller: 'ManageAccountsController',
        controllerAs: 'ManageAccounts',
        authenticate: true
      })

      .state('main.favourite-transactions', {
        url: '/favourite-transactions',
        templateUrl: 'app/transactions/favourite/favourite-transactions.html',
        controller: 'FavouriteTransactionsController',
        controllerAs: 'FavTrans',
        authenticate: true
      })

      .state('transactionsuccess', {
        url: '/transaction-success',
        templateUrl: 'app/transactions/summary/transactionFail/transaction.success.html',
        authenticate: true
      })
      .state('faq', {
        url: '/faq',
        templateUrl: 'app/faq/faq.html',
        controller: 'FaqController',
        controllerAs: 'Faq',
        authenticate: false,
        resolve: {
          faqData : _fetchDynamicDataFaq
        }
      })
      .state('forgotUserId', {
        url: '/forgotUserId',
        templateUrl: 'app/forgot/forgotId/forgotId.html',
        controller: 'ForgotIdController',
        controllerAs: 'ForgotId',
        authenticate: false
      })
      .state('forgotPassword', {
        url: '/forgotPassword',
        templateUrl: 'app/forgot/forgotPassword/forgotPassword.html',
        controller: 'ForgotPwdController',
        controllerAs: 'ForgotPassword',
        authenticate: false
      })
      .state('main.portfolio', {
        url: '/portfolio',
        templateUrl: 'app/portfolio/portfolio.html',
        controller: 'PortfolioController',
        controllerAs: 'Portfolio',
        defaultRoute: '.list',
        authenticate: true
      })
      .state('main.portfolio.list', {
        url: '/list',
        templateUrl: 'app/portfolio/portfolioDetail/portfolioDetail.html',
        controller: 'PortfolioDetailController',
        controllerAs: 'PortfolioDetail',
        // parent: 'main.portfolio',
        authenticate: true
      })
      .state('main.portfolio.folios', {
        url: '/folios',
        templateUrl: 'app/portfolio/foliosDetail/foliosDetail.html',
        controller: 'FoliosDetailController',
        controllerAs: 'FoliosDetail',
        // parent: 'main.portfolio',
        authenticate: true
      })
      .state('main.portfolio.demat-folios', {
        url: '/demat-folios',
        templateUrl: 'app/portfolio/dematFoliosDetail/dematFoliosDetail.html',
        controller: 'DematFoliosDetailController',
        controllerAs: 'DematFoliosDetail',
        // parent: 'main.portfolio',
        authenticate: true
      })

      .state('main.subscriptionValuation', {
        url: '/subscriptionValuation',
        templateUrl: 'app/subscription-valuation/subscriptionValuation.html',
        controller: 'SubscriptionValuationController',
        controllerAs: 'SubscriptionValuation',
        defaultRoute: '.folio-valuation',
        authenticate: true
      })
      .state('main.subscriptionValuation.folio-valuation', {
        url: '/folio-valuation',
        templateUrl: 'app/subscription-valuation/subscriptions/folio-valuation.html',
        controller: 'SubscriptionValuationController',
        controllerAs: 'SubscriptionValuation',
        // parent: 'main.subscriptionValuation',
        authenticate: true
      })
      .state('main.subscriptionValuation.nav', {
        url: '/NAVs',
        templateUrl: 'app/subscription-valuation/subscriptions/NAVs.html',
        controller: 'SubscriptionValuationController',
        controllerAs: 'SubscriptionValuation',
        // parent: 'main.subscriptionValuation',
        authenticate: true
      })
      .state('main.subscriptionStatus', {
        url: '/subscriptionStatus',
        templateUrl: 'app/subscription-valuation/Subscription-status.html',
        controller: 'SubscriptionValuationController',
        controllerAs: 'SubscriptionValuation',
        authenticate: true
      })

      .state('main.unsubscription', {
        url: '/un-subscription',
        templateUrl: 'app/subscription-valuation/Subscription-unsubscribe.html',
        controller: 'SubscriptionValuationController',
        controllerAs: 'SubscriptionValuation',
        authenticate: true
      })

      .state('mobile', {
        url: '/mobile',
        templateUrl: 'app/mobile/mobile.html',
        controller: 'MobileController',
        controllerAs: 'Mobile',
        authenticate: false
      })

      .state('mobile.faq', {
        url: '/faq',
        templateUrl: 'app/mobile/faq/faq.html',
        controller: 'MobileFaqController',
        controllerAs: 'Faq',
        authenticate: false,
        resolve: {
          faqData : _fetchDynamicDataFaq
        }
      })

      .state('mobile.tnc', {
        url: '/:tncType',
        templateUrl: 'app/mobile/tnc/transactionalTermcondition.html',
        controller: 'MobileTncController',
        controllerAs: 'MobileTnc',
        authenticate: false,
        resolve: {
        dynamicDataGeneral : _fetchDynamicDataGeneral,
        dynamicDataCOBM : _fetchDynamicDataCOBM
        }
      })
      .state('mobile.tpv', {
        url: '/tpv',
        templateUrl: 'app/mobile/tpv/tpv.html',
        controller: 'mobileTpvController',
        controllerAs: 'MobileTpv',
        authenticate: false
      })
      .state('main.schedule-transaction-success', {
        url: '/transaction/:transactionId/:transactionType',
        templateUrl: 'app/transactions/schedule-transaction-status/schedule-transaction-status.html',
        controller: 'ScheduleTransactionStatusController',
        controllerAs: 'ScheduleSummary',
        authenticate: true,
        params: {
          summaryData: null
        }
      })
      .state('main.transactions.schedule-purchase', {
        url: '/schedule-audit/purchase?trackId&folioNumber&&trStatus&transactionId&stepNo&transactionType&isCompId&sc&ctId?option?isFavourite?initiatedBy?transactionAction',
        templateUrl: 'app/transactions/initiate/sip-purchase/purchase/purchase.html',
        controller: 'InitiateTransactionPurchaseController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataSipPurchaseReview : _fetchDynamicDataPurchase
        }
      })
      .state('main.transactions.schedule-switch', {
        url: '/schedule-audit/switch?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId?isFavourite?initiatedBy?transactionAction',
        templateUrl: 'app/transactions/initiate/switch/switch.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataReview : _fetchDynamicDataSwitch
        }
      })
      .state('main.transactions.schedule-redemption', {
        url: '/schedule-audit/redemption?folioNumber&&trStatus&transactionId&transactionType&isCompId&sc&ctId&isFavourite?initiatedBy?transactionAction',
        templateUrl: 'app/transactions/initiate/redemption/redemption.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        resolve: {
          DynamicDataReview : _fetchDynamicDataRedemption
        }
      })
      .state('schedule', {
        url: '/initiate/schedule/:uniqueLink?version?purchaseSchedular',
        templateUrl: 'app/transactions/summary/summary.schedule.transaction.html',
        controller: 'SummaryScheduleTransactionController',
        controllerAs: 'SummarySchedule',
        authenticate: false
      })
      .state('schedule-success', {
        url: '/transaction/:transactionId/:transactionType',
        templateUrl: 'app/transactions/status/schedule-transaction-success/schedule-transaction-success.html',
        controller: 'ScheduleTransactionSuccessController',
        controllerAs: 'ScheduleSummary',
        authenticate: false
      })
      .state('ekyc', {
        url: '/ekyc?prefill',
        templateUrl: 'app/ekyc/ekyc.html',
        controller: 'ekycController',
        controllerAs: 'EKYCController',
        authenticate: false,
        params: {
          ekycRequestCO: null
        }
      })
      .state('kyc', {
        url: '/kyc',
        templateUrl: 'app/kyc/kyc.html',
        controller: 'KycController',
        controllerAs: 'kyc',
        authenticate: false
      })
      .state('wekyc', {
        url: '/wekyc?key',
        templateUrl: 'app/wekyc/wekyc.html',
        controller: 'wekycController',
        controllerAs: 'WEKYCController',
        authenticate: false,
      })
      .state('verifykyc', {
        url: '/verifykyc',
        templateUrl: 'app/kycverify/kycverify.html',
        controller: 'KycverifyController',
        controllerAs: 'kycverify',
        authenticate: false,
        params: {
          ekycRequestCO: null
        }
      })
      .state('videos', {
        url: '/videos',
        templateUrl: 'app/firstLogin/welcome/all-videos/all-videos.html',
        controller: 'videosController',
        controllerAs: 'VideosController',
        authenticate: true
      })
      .state('arnReview', {
        url:'/RT',
        templateUrl: 'app/arn-review/arn-review.html',
        controller: 'ArnReviewController',
        controllerAs: 'ArnReview'
        })
        .state('logoutArn', {
          url:'/logoutArn',
          templateUrl: 'app/arn-review/thanks.html',
          controller: 'ThanksController',
          controllerAs: 'Thanks',
          authenticate: true
          })

      .state('preLoginEcart', {
        url:'/ecart/:uuid',
        templateUrl: 'app/e-cart/pre-login-token/pre-login-token.html',
        controller: 'EcartPreLoginTokenController',
        controllerAs: 'Ecart',
        authenticate: false
      })

      .state('preLoginEcartJourney', {
        url:'/ecartJourney',
        templateUrl: 'app/e-cart/pre-login/pre-login.html',
        controller: 'EcartPreLoginController',
        controllerAs: 'Ecart',
        authenticate: false
      })

      .state('preLoginEcartJourney.cartReview', {
        url: '/review',
        templateUrl: 'app/e-cart/review/ecart.review.html',
        controller: 'EcartReviewController',
        controllerAs: 'EcartReview',
        authenticate: false,
        resolve: {
          DynamicDataSipPurchaseReview : _fetchDynamicDataSip,
          notesEcart : _fetchDynamicDataEcart
        }
      })

      .state('main.transactions.cartReview', {
        url: '/review',
        templateUrl: 'app/e-cart/review/ecart.review.html',
        controller: 'EcartReviewController',
        controllerAs: 'EcartReview',
        authenticate: false,
        resolve: {
          DynamicDataSipPurchaseReview : _fetchDynamicDataSip
        }
      })

      .state('preLoginEcartJourney.paymentPage', {
        url: '/payment',
        templateUrl: 'app/e-cart/ecart-payment/ecart-payment-screen.html',
        controller: 'EcartPaymentController',
        controllerAs: 'Payment',
        resolve: {
          notesEcart : _fetchDynamicDataEcart
        }
      })

      .state('main.transactions.paymentPage', {
        url: '/payment',
        templateUrl: 'app/e-cart/ecart-payment/ecart-payment-screen.html',
        controller: 'EcartPaymentController',
        controllerAs: 'Payment',
        resolve: {
          notesEcart : _fetchDynamicDataEcart
        }
      })

      .state('preLoginEcartJourney.folio', {
        url: '/folio?journey',
        templateUrl: 'app/investment-baskets/folio/folio.html',
        controller: 'FolioController',
        controllerAs: 'Folio',
        authenticate: true,
        title:'Folio',
        params: {
          fromPreLogin : true
        }
      })

      .state('folioSelection', {
        url: '/select-folio',
        templateUrl: 'app/e-cart/ecart-pre-login-folio/ecart-pre-login-folio.html',
        controller: 'FolioSelectController',
        controllerAs: 'Folio'
      })
      .state('newInvestorinvestorProfile', {
        url: '/create/investor-profile',
        templateUrl: 'app/investor-profile-userid/investor-profile-userid.html',
        controller: 'InvestorProfileUserIdController',
        controllerAs: 'InvestorProfile',
        authenticate: false,
        title:'InvestorProfile',
      })
      // .state('preLoginWhatsapp', {
      //   url:'/whatsapp/:tType/:uuid/:folio',
      //   templateUrl: 'app/whatsapp-payment/landing-token/whatsapp-landing-token.html',
      //   controller: 'WhatsappPreLoginTokenController',
      //   controllerAs: 'WhatsappApiGateWay',
      //   authenticate: false
      // })
      //
      // .state('preLoginWhatsappHome', {
      //   url:'/whatsappJourney',
      //   templateUrl: 'app/whatsapp-payment/pre-login-landing/whatsapp-pre-login-landing.html',
      //   controller: 'WhatsappPreLoginTokenHomeController',
      //   controllerAs: 'WhatsappApiGateWay',
      //   authenticate: true
      // })
      // .state('preLoginWhatsappHome.apiWhatsappPayment', {
      //   url: '/whatsapp-payment',
      //   templateUrl: 'app/whatsapp-payment/payment/whatsappPayment.html',
      //   controller: 'WhatsappPaymentController',
      //   controllerAs: 'Payment',
      //   authenticate: true,
      //   resolve: {
      //     notesPayment : _fetchDynamicDataPurchasePayment
      //   }
      // })
      // .state('preLoginWhatsappHome.paymentacknowledgement', {
      //   url: '/whatsapp-acknowledgement',
      //   templateUrl: 'app/whatsapp-payment/acknowledgement/paymentacknowledgement.html',
      //   controller: 'WhatsAppPaymentacknowledgementController',
      //   controllerAs: 'WhatsAppPaymentAck',
      //   authenticate: true,
      // })
      .state('deeplinks', {
        url: '/deeplinks/:type',
        templateUrl: 'app/deeplinks/deeplinks.html',
        controller: 'deeplinkController',
        controllerAs: 'Deeplink',
        authenticate: false
      })
      .state('kycUpdate', {
        url: '/kyc-verification',
        templateUrl: 'app/kyc/kyc-update/kyc-update.html',
        controller: 'KycUpdateController',
        controllerAs: 'KycUpdate',
        authenticate: true,
        resolve: {
          isLoggedIn: _isUserLoggedIn
        }
      })

      // token generation page for whatsapp

      .state('preLoginWhatsapp', {
        url:'/whatsapp/:tType/:uuid/:folio',
        templateUrl: 'app/payment/landing-token/landing-token.html',
        controller: 'PaymentPreLoginTokenController',
        controllerAs: 'Payment',
        authenticate: false
      })

      // token generation page for api gateway

      // .state('preLoginGateway', {
      //   url:'/gateway/:uuid',
      //   templateUrl: 'app/payment/landing-token/landing-token.html',
      //   controller: 'PaymentPreLoginTokenController',
      //   controllerAs: 'Payment',
      //   authenticate: false
      // })

      // session set and redirection to payment page

      .state('preLoginPaymentHome', {
        url:'/payment',
        templateUrl: 'app/payment/pre-login-landing/pre-login-landing.html',
        controller: 'PaymentPreLoginTokenHomeController',
        controllerAs: 'Payment',
        authenticate: true
      })

      .state('preLoginPaymentHome.paymentHome', {
        url: '/pay-now?journey?type',
        templateUrl: 'app/payment/payment.html',
        controller: 'PaymentJourneyController',
        controllerAs: 'Payment',
        authenticate: true,
        resolve: {
          notesPayment : _fetchDynamicDataPurchasePayment
        }
      })

      .state('linkExpired', {
        url: '/link-expired',
        templateUrl: 'app/payment/link-expired/link-expired.html',
        controller: 'ExpiredTokenHomeController',
        controllerAs: 'Payment',
        authenticate: true
      })

      .state('main.paymentHome', {
        url: '/investors/pay-now/:linkId/:type/:trackId',
        templateUrl: 'app/payment/payment.html',
        controller: 'PaymentJourneyController',
        controllerAs: 'Payment',
        authenticate: true,
        resolve: {
          notesPayment : _fetchDynamicDataPurchasePayment
        }
      })

      .state('payment-status', {
        url: '/investors/payment/redirect?cart_id&&pt&&tType&&platform&&status', //payment/status?card_id
        templateUrl: 'app/transactions/status/payment-status/payment.status.html',
        controller: 'PaymentStatusController',
        controllerAs: 'PaymentStatus',
        authenticate: false
      })
      .state('upi', {
        url: '/investors/upi/payment',
        templateUrl: 'app/transactions/status/payment-status/upi/upi.html',
        controller: 'UpiController',
        controllerAs: 'Upi',
        authenticate: false
      })
      .state('upi.waiting', {
        url: '/redirect?id&type&platform',
        templateUrl: 'app/transactions/status/payment-status/upi/upi-waiting/upi.waiting.html',
        controller: 'UpiWaitingController',
        controllerAs: 'UpiWaiting',
        authenticate: false
      })

      .state('upi.expired', {
        url: '/expired?id&type&platform',
        templateUrl: 'app/transactions/status/payment-status/upi/upi-expired/upi.expired.html',
        controller: 'UpiExpiredController',
        controllerAs: 'UpiExpired',
        authenticate: false
      })

      .state('upi.failed', {
        url: '/failed?id&type&platform',
        templateUrl: 'app/transactions/status/payment-status/upi/upi-failed/upi.failed.html',
        controller: 'UpiFailedController',
        controllerAs: 'UpiFailed',
        authenticate: false
      })

      .state('upi.success', {
        url: '/success?id&type&platform',
        templateUrl: 'app/transactions/status/payment-status/upi/upi-success/upi.success.html',
        controller: 'UpiSuccessController',
        controllerAs: 'UpiSuccess',
        authenticate: false
      })

      .state('preliminaryDashboard', {
        url: '/preliminaryDashboard',
        templateUrl: 'app/preliminary-dashboard/preliminary-dashboard.html',
        controller: 'PreliminaryDashboardController',
        controllerAs: 'PreliminaryDashboard',
        resolve: {
          isLoggedIn: _isLoggedIn
        }
      })
      .state('preliminarySidebar', {
        url: '/preliminarySidebar',
        templateUrl: 'app/components/sidebar/preliminary-sidebar/preliminarySidebarBreadcum.html',
        controller: 'PreliminaryDashboardController',
        controllerAs: 'PreliminaryDashboard'
      })
      .state('checkUser', {
        url: '/checkUser',
        templateUrl: 'app/components/modal/loginWithMobile/existingUser/verify-pan-dob.html',
        controller: 'CheckuserController',
        controllerAs: 'Checkuser',
        authenticate: true,
        resolve: {
          isLoggedIn: _isLoggedIn
        }
      })
      .state('tnc', {
        url: '/tnc',
        templateUrl: 'app/tnc-page/tnc.html',
        controller: 'TermNConditionController',
        controllerAs: 'TermNCondition'
      })
  }

  /** Redirection to login **/
  function _isRedirect($q, $state, $timeout) {
    var deferred = $q.defer();
    $timeout(function () {
      $state.go('login');
    });
    deferred.resolve(false);
    return deferred.promise;
  }


  /** @ngInject */
  function _isLoggedIn($q, $state, $timeout, $stateParams, AuthService) {
    var deferred = $q.defer();
    /* $cookies.get('token_data_instant');*/

    try {
      var token = AuthService.getToken();
    } catch (e) {
      token = '';
    }
    try {
      var tokenMobileLogin = AuthService.getMobileLoginToken();
    } catch (e) {
      tokenMobileLogin = '';
    }
    try {
      var tokenInstant = AuthService.getInstaToken();
    } catch (e) {
      tokenInstant = '';
    }
    if (token && token.access_token) {
      $timeout(function () {
        $state.go('welcome');
      }, 0);
      deferred.resolve(true);
    }else if (tokenMobileLogin && tokenMobileLogin.access_token) {
      $timeout(function () {
        var data = AuthService.getMobileLoginToken();
        if(data.newPrelimanryUser){
          $state.go('preliminaryDashboard');
        }else{
          $state.go('checkUser');
        }
      }, 0);
      deferred.resolve(true);
    } else if (tokenInstant && tokenInstant.access_token) {
      $timeout(function () {
        if ($stateParams.trackId && $stateParams.trxnType && $stateParams.stepNo) {
          $state.go('instantLoginHome.instantInvest', {
            trackId: $stateParams.trackId,
            transactionType: $stateParams.trxnType,
            stepNo: $stateParams.stepNo
          });
        } else {
          $state.go('instantLoginHome.instantInvest');
        }
      }, 0);
      deferred.resolve(true);
    } else {
      $timeout(function () {
        $state.go('login');
      }, 0);
      deferred.resolve(false);
    }
    return deferred.promise;
  }

  /** @ngInject */
  function _isValidTrackId($q, $state, $stateParams, $timeout, MessageService, AuthService, AppConstants) {
    var deferred = $q.defer();
    var payload = {};
    payload.trackId = $stateParams.trackId;
    var success = function (resp) {
      if (resp.status && resp.data) {
        $timeout(function () {
          if (resp.data.loginType === AppConstants.LOGIN_TYPE.IP) {
            $state.go('login', {trackId: $stateParams.trackId, trxnType: resp.data.trxnType, stepNo: resp.data.stepNo});
          } else if(resp.data.loginType === AppConstants.LOGIN_TYPE.HDFC_ONE_CLICK){
            $state.go('arnReview.verifyPan', {
              arn: resp.data.formdata.chipherText,
              trackId: $stateParams.trackId,
              trxnType: resp.data.trxnType,
              stepNo: resp.data.stepNo
            })
          } else {
            $state.go('instantLogin', {
              trackId: $stateParams.trackId,
              trxnType: resp.data.trxnType,
              stepNo: resp.data.stepNo
            });
          }
        }, 100);
        deferred.resolve(true);
      } else {
        MessageService.error(resp.message || "The link has been expired.");
        deferred.reject();
      }
    }, error = function (err) {
      MessageService.error(err.message || "The link has been expired.");
      deferred.reject();
    };
    AuthService.verifyTrackId(payload).then(success, error);

    return deferred.promise;
  }

  /** @ngInject */
  function _isInstantLoggedIn($q, $state, $timeout, $stateParams, AuthService, $window) {
    var deferred = $q.defer(),
      tokenInstant = AuthService.getInstaToken();
    if (tokenInstant && tokenInstant.access_token) {
      $timeout(function () {
        if ($stateParams.trackId && $stateParams.trxnType && $stateParams.stepNo && $state.router.urlRouter.router.locationService.$location.$$path !== '/instantInvest/investment') {
          $state.go('instantLoginHome.instantInvest', {
            trackId: $stateParams.trackId,
            trxnType: $stateParams.trxnType,
            stepNo: $stateParams.stepNo
          });
        } else if ($state.router.urlRouter.router.locationService.$location.$$path !== '/instantInvest/investment') {
          $state.go('instantLoginHome.instantInvest');
        }
      });
      deferred.resolve(true);
    } else {
      deferred.resolve(false);
      var arnHardcodedData = $window.JSON.parse(localStorage.getItem("distributorDetails"));
      if (!arnHardcodedData) {
        $state.go('instantLogin');
      }
    }
    return deferred.promise;
  }

  /** @ngInject */
  function _isSessionActive($q, $state, $timeout, AuthService) {
    var deferred = $q.defer(),
      tokenInstant = AuthService.getInstaToken();// $cookies.get('token_data_instant');

    if (tokenInstant && tokenInstant.access_token) {
      deferred.resolve(true);
    } else {
      $timeout(function () {
        $state.go('validateFolio');
      }, 0);
      deferred.resolve(false);
    }
    return deferred.promise;
  }

  /** @ngInject */
  function _investorProfile($q, $timeout, $state, $stateParams, MessageService, InvestorService, LoaderService) {
    var deferred = $q.defer(),
      success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          deferred.resolve(resp.data);
        } else {
          deferred.reject();
          MessageService.error(resp.message);
          $timeout(function () {
            $state.go('main.investors.list');
          }, 0);
        }
      },
      error = function () {
        LoaderService.hideLoader();
        deferred.reject();
        $timeout(function () {
          $state.go('main.investors.list');
        }, 0);
      };
    LoaderService.showLoader();
    InvestorService.post({child1: 'profile'}, {
      "appType": "W",
      "investorUUID": $stateParams.investorId
    }).$promise.then(success, error);
    return deferred.promise;
  }

  /** @ngInject */
  function _checkDataUpdate($q, $state, $timeout, AuthService, AppConstants, HDFC_API) {
    var deferred = $q.defer();
    var identifierData = AuthService.getToken();
    if (!identifierData) {
      deferred.reject();
    } else if (identifierData.investorType === AppConstants.INVESTOR_TYPE.NEW) {
      if (identifierData.landingPageType === AppConstants.LANDING_PAGE_TYPE.FOLIO_CREATION) {
        deferred.reject();
        $timeout(function () {
          $state.go('welcome.newUserWelcome');
        });
      } else {
        deferred.resolve();
      }
    } else {
      if ((identifierData && angular.isUndefined(identifierData.isDataUpdated)) && (HDFC_API.ENV == 'prod' || HDFC_API.ENV == 'beta')) {
        deferred.reject();
        $timeout(function () {
          $state.go('home');
        });
      } else {
        deferred.resolve();
      }
    }

    return deferred.promise;
  }

  /** @ngInject */
  function _transactionSummary($q, LoaderService, InvestorService, $stateParams, AppConstants, MessageService, UtilService) {

    var deferred = $q.defer();
    var TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTIONS);
    var transactionId = $stateParams.transactionId;
    var transactionType = $stateParams.transactionType;


    var transactionTypeModified;
    switch (transactionType) {
      case TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX:
        transactionTypeModified = 'FLEXINDEX';
        break;
      case TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION:
        transactionTypeModified = TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION;
        break;
      default:
        transactionTypeModified = transactionType;
    }

    if (transactionType === TRANSACTIONS_CONST.TRANSACTION_TYPE.ROLLOVER) {

      LoaderService.showLoader();
      var successR = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          deferred.resolve(resp.data);
        } else {
          MessageService.error(resp.message);
          deferred.reject(null);
        }
      }, errorR = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        deferred.reject(null);
      };

      InvestorService.get({
        child1: 'rollover',
        child2: 'approved',
        child3: 'summary',
        child4: transactionId
      }).$promise.then(successR, errorR);

    } else {

      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          // vm.formData = resp.data;
          deferred.resolve(resp.data);
        } else {
          MessageService.error(resp.message);
          deferred.reject(null);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        deferred.reject(null);
      };
      var payload = {
        transactionId: transactionId,
        transactionType: transactionTypeModified
      }
      InvestorService.post({
        child1: 'transaction',
        child2: 'approved',
        child3: 'summary'
      }, payload).$promise.then(success, error);

    }
    return deferred.promise;

  }

   /** @ngInject */
   function _fetchDynamicData(UtilService) {
      return UtilService.fetchDynamicData()
   }

    /** @ngInject */
    function _fetchDynamicDataPurchase(UtilService) {
       return UtilService.fetchDynamicData('PURCHASE_REVIEW');
    }

    /** @ngInject */
    function _fetchDynamicDataSip(UtilService) {
      return UtilService.fetchDynamicData("SIP_REVIEW");
    }

     /** @ngInject */
     function _fetchDynamicDataSwitch(UtilService) {
       return UtilService.fetchDynamicData("SWITCH_REVIEW");
     }


     /** @ngInject */
     function _fetchDynamicDataRedemption(UtilService) {
       return UtilService.fetchDynamicData("REDEMPTION_REVIEW");
     }

     /** @ngInject */
     function _fetchDynamicDataSTP(UtilService) {
       return UtilService.fetchDynamicData("STP_REVIEW");
     }

     /** @ngInject */
     function _fetchDynamicDataFlexIndex(UtilService) {
       return UtilService.fetchDynamicData("FLEXINDEX_REVIEW");
     }

     /** @ngInject */
     function _fetchDynamicDataSwap(UtilService) {
       return UtilService.fetchDynamicData('SWAP_REVIEW');
     }

     /** @ngInject */
     function _fetchDynamicDataTip(UtilService) {
       return UtilService.fetchDynamicData('TIP_REVIEW');
     }

     /** @ngInject */
     function _fetchDynamicDataIAF(UtilService) {
       return UtilService.fetchDynamicData('IAF_REVIEW');
     }

     /** @ngInject */
     function _fetchDynamicDataSmartSwap(UtilService) {
       return UtilService.fetchDynamicData('SMARTSWAP_REVIEW');
     }

     /** @ngInject */
     function _fetchDynamicDataQuickInvestement(UtilService) {
       return UtilService.fetchDynamicData('QUICK_INVESTMENT');
     }

     /** @ngInject */
     function _fetchDynamicDataChangeIcdw(UtilService) {
       return UtilService.fetchDynamicData('CHANGE_IDCW_OPTION');
     }

     /** @ngInject */
     function _fetchDynamicDataFaq(UtilService) {
       return UtilService.fetchDynamicData("FAQ");
     }

     /** @ngInject */
     function _fetchDynamicDataGeneral(UtilService) {
       return UtilService.fetchDynamicData("INNER_TNC");
     }

     /** @ngInject */
     function _fetchDynamicDataCOBM(UtilService) {
       return UtilService.fetchDynamicData('ADD_NEW_BANK');
     }

      /** @ngInject */
      function _fetchDynamicDataStandloneEmandate(UtilService) {
        return UtilService.fetchDynamicData('STANDALONE_EMANDATE');
      }

      /** @ngInject */
      function _fetchDynamicDataEcart(UtilService) {
        return UtilService.fetchDynamicData('PURCHASE_ECART');
      }

      /** @ngInject */
      function _fetchDynamicDataPurchasePayment(UtilService) {
        return UtilService.fetchDynamicData('PURCHASE_PAYMENT');
      }

      /** @ngInject */
      function _fetchDynamicDataUpdateContact(UtilService) {
       return UtilService.fetchDynamicData("UPDATE_CONTACT_DETAIL");
      }

      /** @ngInject */
      function _fetchDynamicDataFlexSip(UtilService) {
       return UtilService.fetchDynamicData("FLEX_SIP_REVIEW");
      }

    /** @ngInject */
    function instaForceLogout($cookies, AppConstants, AuthService, InvestorService, $state, MessageService, LoaderService) {
      var token = AuthService.getInstaToken();
      if (token) {
        var payload = {
          folioNumber: token.folioNumber
        };
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp && resp.status) {
            $cookies.remove(AppConstants.INSTA_IDENTIFIER);
            localStorage.removeItem('QuickInvestmentSecreteLink');
            $state.go('login');
          } else {
            MessageService.error(resp.message);
            localStorage.removeItem('QuickInvestmentSecreteLink');
            $cookies.remove(AppConstants.INSTA_IDENTIFIER);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          $cookies.remove(AppConstants.INSTA_IDENTIFIER);
        };
        InvestorService.post({child1: 'force', child2: 'logout'}, payload).$promise.then(success, error);
      }
    }
    /** @ngInject */
    function instaForceLogoutNewJourney($cookies, AppConstants, AuthService, InvestorService, $state, MessageService, LoaderService) {
      var token = AuthService.getInstaToken();
      if (token) {
        var payload = {
          panNumber: token.panNumber
        };
        var success = function (resp) {
          LoaderService.hideLoader();
            $cookies.remove(AppConstants.NEW_INVESTOR_IDENTIFIER);
            AuthService.clearCookies(AppConstants.IDENTIFIER);
            localStorage.removeItem('QuickInvestmentSecreteLink');
            $state.go('login');
        },
        error = function () {
          LoaderService.hideLoader();
          $cookies.remove(AppConstants.NEW_INVESTOR_IDENTIFIER);
          localStorage.removeItem('QuickInvestmentSecreteLink');
        };
        InvestorService.post({
          child1: 'force',
          child2: 'logout'
        }, payload).$promise.then(success, error);
      }
    }
/** @ngInject */
  function _isBackLoggedIn($q, $state, $timeout, AuthService,AppConstants) {
    var deferred = $q.defer(),
      identifierData = AuthService.getToken();
    if (identifierData) {
      $timeout(function () {
        if ($state.router.urlRouter.router.locationService.$location.$$path == '/' || $state.router.urlRouter.router.locationService.$location.$$path == '/instant-login' || $state.router.urlRouter.router.locationService.$location.$$path == '/update-user-contact') {
          AuthService.clearCookies(AppConstants.IDENTIFIER);
        }
      });
      deferred.resolve(false);
    } else {
      deferred.resolve(false);
    }
    return deferred.promise;
  }

  /** @ngInject */
  function _isUserLoggedIn($q, $state, $timeout, $stateParams, AuthService) {
    var deferred = $q.defer();
    try {
      var token = AuthService.getToken();
    } catch (e) {
      token = '';
    }
    try {
      var tokenInstant = AuthService.getInstaToken();
    } catch (e) {
      tokenInstant = '';
    }
    if (token && token.access_token) {
      $timeout(function () {
        $state.go('main.profile.basicInfo');
      }, 0);
      deferred.resolve(true);
    } else {
      $timeout(function () {
        $state.go('kycUpdate');
      }, 0);
      deferred.resolve(false);
    }
    return deferred.promise;
  }


})();

(function () {
'use strict';
 angular.module("hdfc-mf-investor-web")

.constant("HDFC_API", {
	"PROTOCOL": "https://",
	"OAUTH_HOST": "api.hdfcfund.com/authorization/",
	"HOST": "api.hdfcfund.com/investor/",
	"MAIN_HOST": "api.hdfcfund.com/",
	"PARTNER_ARN": "ARN-0005",
	"VERSION": "v1",
	"ENV": "prod",
	"THIRD_PARTY_NAME": "sales-panda",
	"BILLDESK_URL": "https://www.billdesk.in/billpay/APIEMandateController?action=APIEMandateHDFCOTMReg&msg=",
	"BILLDESK_PURCHASE_URL": "https://www.billdesk.com/pgidsk/PGIMerchantRequestHandler",
	"PAYMENT_NAV_URL": "https://www.hdfcfund.com/information/payment-mode-information",
	"HDFC_CONFIG_ENDPOINT": "MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBAKX8ucv6DDtzTUO3NWYnFvyavpvhVNCGwQ8tZFXgtpRmvGieo/fD5oq7F8u0uldJDvERNDJbZV5r7xmvsb0ZuzOC7Bp9XGPSDRtd7CF0K8oz83YWMlrt30pBpBGtfGBWyoGO7H/HFpqhryCiQMKJdfWw0m3+oHPAuSdbq8F0SjXDAgMBAAECgYEAkkrw8i8a0tbnlTQG81amctJsBnUNzI/H3fmSwgHAyYDWs5qGR1u4eDM3YMmTplR0v9D64Rsed57HaCsqitD/5JFZKbVESIIn0St06Scw537+eK1z8rLL4tNY3wG931ekY27fEupqAjoRr6G2jWc24bIwCLgCbvL44NP759qCuOkCQQDyt8V3eUMrwMhvII0Jc6lXi3zz7Yv4sdiUjhV2ZPj8zfrPJxfknF0crHmrl4l9kGN53dtPL3wNm4K/Rrp4KAKvAkEArxIJX/AR9JSB5eiaQyZMIIyVWvX7z68lOf7e11wK58hLU870EYYsSZKLbyr2P1+zh7aK1yN24nSR329ivo1TLQJACEM3RqzrG3cxm47ZHkRAtIk8FLW2eR3cyJnZozEmxLxiWGD1UEP+a3Z3od7DwHGE4WYrDBQKvg/YMJjAykxaYwJBAJEagvioc0ljmXKkYs+LO4ey3cvhm8+cXF+AVtTq7gMEaSLSokqwCZ8FPlpqomUOfi/a5aLBOzUg5xLpME+9tRUCQQDAsgApPlR0w9IfWYZ82rfc0w7uqfUIi9ZDfJSKF7X+cTLWNQXQVcisb7nA6JN6jd8ES+DmU8u5nfmcJ3RELZMT",
	"PATH": "investor-web.hdfcfund.com",
	"ALL_IN_CALL": "https://cobrowse-hdfcamc.allincall.in/static/EasyAssistApp/js/easy-assist-v6.js?key=085aac6a-9ea4-4266-b664-f4ba201a5b78",
	"CORPORATE_URL": "https://www.hdfcfund.com/",
	"HDFC_SCHEME_ACC_LIST": "https://distributor.hdfcfund.com/assets/documents/HDFC_Scheme_Collection_Accounts.pdf",
	"NSI": "kl6JgtAAgiocmYmexERWJmZASPmYhMHhLyeVB5QUNmK04lT4WLip+8fnc89GvonwVCaJtXTObon/+/4+FNjDAZufxAx18fXixu0dxN6q3uNqpV6+lZGP4oFJzU5J97HxnJCG2MKzx703xnsk8uWAb6xfGvNMp5q+MmuNMVmkpNA=",
	"WEBSITE_LINK": "https://hdfcfund.com/",
	"CMS_HOST": "cms.hdfcfund.com/"
})

; 
})();
/* global moment:false */
(function () {
  'use strict';
  angular.module('hdfc-mf-investor-web')
    .constant('moment', moment)
    .constant("AppConstants", {
      IS_DEBUGGING:false,// TODO : KEEP THIS FALS AT PRODUCTION
      ToastrMessage: {
        VALIDATE_DATA: {
          'BLANK_IN_SCHEME': 'PLease select an in scheme first',
          'AMOUNT_REQUIRED': 'Amount is required',
          'UTR_REQUIRED': 'UTR is required',
          'SAME_UTR_REQUIRED': 'UTR number should be same',
          'UTR_RANGE': 'UTR number should be alphanumeric',
          'UTR_INVALID': 'Please enter valid UTR number',
          'BROKER_REQUIRED': 'Broker Code is required',
          'SUB_BROKER_REQUIRED': 'Sub Broker code is required',
          'DISTRIBUTOR_REQUIRED': 'Distributor name is required',
          'BROKER_VALID': 'Broker Code is not valid',
          'EUIN_REQUIRED': 'EUIN is required',
          'MINIMUM_AMOUNT': 'Minimum amount should be ',
          'MAX_AMOUNT': 'Exceeding available free amount',
          'MINIMUM_UNIT': 'Minimum units should be greater than ',
          'MAX_UNIT': 'Exceeding available free units',
          'UNITS_REQUIRED': 'Number of unit is required',
          'SCHEME_REQUIRED': 'Source Scheme is required',
          'TARGET_SCHEME_REQUIRED': 'Target Scheme is required',
          'FOLIO_REQUIRED': 'Folio Number is required.',
          'TAX_STATUS': 'Tax status is required',
          'PAN_FIELD': 'Please enter valid PAN',
          'PAN_FIELD_MIN': 'Please enter valid PAN of Minimum 10 digits',
          'PAN_FIELD_MAX': 'Please enter valid PAN of Maximum 10 digits',
          'PAN_REQUIRED': 'PAN is required',
          'USER_ID_REQUIRED': 'User ID is required.',
          'INVALID_USER_ID_ERROR': 'Please enter valid User ID.',
          'USER_ID_FIELD': 'User ID should be between 6 to 38 characters',
          'USER_ID_MIN': 'Minimum Length of User ID should be 6.',
          'USER_ID_MAX': 'Maximum Length of User ID should be 6.',
          'USER_ID_FIELD_PATTERN': 'Please enter USER ID without space',
          'PASSWORD_REQUIRED': 'Password is required.',
          'PASSWORD_FIELD': 'Please enter a valid Password',
          'PASSWORD_SAME': 'New Passwords should be same',
          'PASSWORD_MIN': 'Minimum Length of Password should be 8.',
          'CONFIRM_PASSWORD_REQUIRED': 'Confirm Password is required.',
          'PASSWORD_MATCH': 'Passwords should be same.',
          'EMAIL_REQUIRED': 'Email ID is required.',
          'EMAIL_FIELD': 'Please enter a valid Email ID',
          'MOBILE_REQUIRED': 'Mobile Number is required.',
          'FREQUENCY_REQUIRED': 'Frequency is required',
          'MONTH_REQUIRED': 'Month is required',
          'DAY_REQUIRED': 'Day is required',
          'START_DATE_REQUIRED': 'Start date is required',
          'END_DATE_REQUIRED': 'End date is required',
          'SELECT_COUNTRY': 'Please select a country',
          'BIRTH_CITY': 'Birth city is required',
          'BIRTH_COUNTRY': 'Birth country is required',
          'FATHER_NAME': 'Father Name is required',
          'SPOUSE_NAME': 'Spouse Name is required',
          'TAX_ID_TYPE': 'Tax id type is required',
          'TAX_ID_NUMBER': 'Tax id number is required',
          'NOMINEE_PROPORTION_REQUIRED': 'Proportion is required',
          'FATCA_ADDRESS_TYPE_REQUIRED': 'Address type is required',
          'KYC_VERIFIED_EMAIL': 'Please provide KYC verified Email ID',
          'MOBILE_FIELD': 'Please enter valid Mobile Number',
          'MOBILE_ISD': 'Please enter valid Mobile Number including ISD code (eg +91XXXXXXXXXX)',
          'OTP_REQUIRED': 'OTP is required.',
          'OTP_FIELD': 'Please enter valid OTP',
          'EKYC_REQUIRED': 'Aadhaar No is required.',
          'EKYC_FIELD': 'Please enter valid Aadhaar No',
          'FOLIO_FIELD': 'Please enter valid Folio No.',
          'FOLIO_FIELD_MAX': 'Please enter a Folio Number of Maximum 12 digits',
          'NET_WORTH': 'Net worth is required',
          'NET_WORTH_DATE': 'Net worth date is required',
          'BANK_REQUIRED': 'Bank is required.',
          'BANK_ACCOUNT_REQUIRED': 'Bank Account Number is required.',
          'BANK_ACCOUNT_FIELD': 'Please enter valid account number',
          'SCHEME_ACCOUNT_NUMBER_REQUIRED': 'HDFC MF Scheme Account Number is required',
          'SCHEME_ACCOUNT_NUMBER_FIELD': 'Please enter valid Scheme account number',
          'UPI_ACCOUNT_NUMBER_REQUIRED': 'Virtual Payment Address is required (eg. abc@xyz)',
          'UPI_ACCOUNT_NUMBER_NOT_VERIFIED': 'Entered Virtual Payment Address (VPA) cannot be verified',
          'BANK_NAME_REQUIRED': 'Bank Name is required',
          'BANK_CITY_REQUIRED': 'Bank City is required',
          'BANK_CITY_VALIDATION': 'Please enter valid Bank City',
          'BANK_BRANCH_REQUIRED': 'Bank Branch is required',
          'BANK_BRANCH_VALIDATION': 'Please enter valid Bank Branch',
          'ACCOUNT_TYPE_REQUIRED': 'Account Type is required',
          'PAYOUT_MECH_REQUIRED': 'Payout mechanism is required',
          'MICR_NUMBER_FIELD': 'Please enter valid MICR number',
          'MICR_NUMBER_RANGE': 'MICR number should be maximum 9 digits',
          'DIGITS_ONLY': 'Text should be digits only',
          'MICR_NUMBER_REQUIRED': 'MICR Number is required',
          'ACCOUNT_NUMBER_REQUIRED': 'Account Number is required',
          'ACCOUNT_HOLDER_REQUIRED': 'Account Holder name is required',
          'ACCOUNT_NUMBER_RANGE': 'Account Number should be minimum 9 digits.',
          'ACCOUNT_NUMBER_RANGE_MAX': 'Maximum Length of Bank Account No. should be 20',
          'ACCOUNT_NUMBER_RANGE_MIN': 'Minimum Length of Bank Account No. should be 1',
          'ACCOUNT_NUMBER_MIN': 'Account Number should be minimum 4 digit',
          'INVESTOR_ACCOUNT_NUMBER_REQUIRED': 'Investor Account Number is required',
          'INVESTOR_ACCOUNT_NUMBER_RANGE': 'Investor Account Number should be maximum 20 digit',
          'SAME_INVESTOR_ACCOUNT_NUMBER_RANGE': 'Investor Account Number should be same',
          'BANK_REFERENCE_NUMBER_REQUIRED': 'Bank Reference Number is required',
          'BANK_REFERENCE_NUMBER_RANGE': 'Bank Reference Number should be minimum 9 digit',
          'SAME_BANK_REFERENCE_NUMBER_RANGE': 'Bank Reference Number should be same',
          'SAME_ACCOUNT_NUMBER_RANGE': 'Account Number should be same',
          'IFSC_CODE_FIELD': 'Please enter valid IFSC code.',
          'IFSC_CODE_REGEX': 'Please enter 11 alphanumeric characters, Fifth character must be 0(zero).',
          'IFSC_MODAL_CITY_BLANK': 'There is no city available for this bank',
          'BRANCH_LOCATION_REQUIRED': 'Bank Location is required',
          'OCCUPATION': 'Occupation is required',
          'GROSS_ANNUAL_INCOME': 'Gross annual income is required',
          'CITY_REQUIRED': 'Branch City is required',
          'CITY_FIELD': 'Please enter valid Branch City',
          'NOMINEE_NAME_REQUIRED': 'Nominee Name is required',
          'NOMINEE_RELATIONSHIP': 'Relationship is required',
          'ADDRESS_REQUIRED': 'Address type is required',
          'GENDER_REQUIRED': 'Gender is required',
          'ADDRESS1_REQUIRED': 'Address Line1 is required',
          'CITY': 'City name is required',
          'STATE_REQUIRED': 'State is required',
          'PINCODE_REQUIRED': 'Pin code is required',
          'PINCODE_LENGTH_REQUIRED': 'Please enter valid pin code of 6 digits',
          'GUARDIAN_NAME': 'Guardian Name is required',
          'MINOR_NAME': 'Minor name is required',
          'MINOR_VALID_NAME': 'Please enter a valid name.',
          'MINOR_DOB': 'Minor dob is required',
          'DOB_FIELD': 'Please enter valid DOB (Eg. 01-JAN-1990)',
          'MAX_AMOUNT_VALIDATION_ERROR': 'SIP amount is exceeding maximum OTM amount, please select another OTM or payment mode to proceed',
          'MAX_AMOUNT_VALIDATION_PURCHASE_ERROR': 'Purchase transaction amount is exceeding maximum OTM amount, please select another OTM or payment mode to proceed',
          'EXPIRY_DATE_VALIDATION_ERROR': 'Selected date is greater than OTM expiry date.',
          'DATE_VALIDATION_ERROR': 'This is expiry date',
          'EXPIRY_DATE_VALID_ERROR':'Cannot initiate payment using selected OTM. You can initiate payment for purchase transaction on or before OTM expiry date which is,',
          'DATE_START_VALIDATION_ERROR': 'Cannot initiate payment using selected OTM. You can initiate payment for purchase transaction on or after OTM start date which is,',
          'DATE_SIP_VALIDATION_ERROR': 'Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or after OTM start date which is,',
          'PERCENT_REQUIRED': 'Percentage is required',
          'MAXIMUM_AMOUNT_ERROR' : 'Maximum amount should be ₹ ',
          'MAXIMUM_PERCENT_ERROR' : 'Maximum percent should be ',
          'OTM_VALIDATION_ERROR' : 'SIP Top Up is allowed for banks with OTM of frequency - As and when presented',
          'MAX_AMOUNT_OTM_VALIDATION_ERROR' : 'You can not proceed with this bank, Please choose other bank/payment option',
          'INVALID_AMOUNT': 'Not a valid amount',
          'UPDATE_CONTACT_FOLIO_FIELD_MAX': 'Please enter a Folio Number of Maximum 15 digits',
          'EMAIL_MOBILE_NOT_UPDATED':'Not updated',
          'SAVING_ACCOUNT':'SB',
          'NO_OF_INSTALLMENT_REQUIRED': 'Number of Installment is required',
          'SIP_PAUSED_START_DATE': 'SIP Pause Start Date is required',
          'AUTHENTICATION_MODE_REQUIRED': 'Authentication mode is required.',
          'INVALID_EMAIL_EMANDATE': 'Please add email ID in the folio before proceeding with e-mandate registration. If you have already requested to add email ID, then wait for it to be updated in your folio.',
          'INVALID_MOBILE_EMANDATE': 'Please add mobile number in the folio before proceeding with e-mandate registration. If you have already requested to add mobile number, then wait for it to be updated in your folio.',
          'INVALID_EMAIL_MOBILE_EMANDATE': 'Please add email ID and mobile number in the folio before proceeding with e-mandate registration. If you have already requested to add email ID and mobile number, then wait for it to be updated in your folio.',
          'MANDATE_REQUIRED': 'Please add email ID and mobile number in folio before registering e-mandate.',
          'MANDATE_EMAIL_REQUIRED': 'Please add email ID in folio before registering e-mandate.',
          'MANDATE_MOBILE_REQUIRED': 'Please add mobile number in folio before registering e-mandate.',
          'LIQUID_FLAG_FALSE_FOR_LIQUID_SCHEME_ECART':' Purchase in liquid/overnight funds is not supported through selected bank. Please select another bank or remove liquid/overnight fund from e-cart for completing payment through selected bank.',
          'RIA_REQUIRED': 'RIA Code is required.',
          'RIA_INVALID': 'Please enter valid 12 character RIA Code.',
          'BANK_DATA_MISSING': 'Some Bank Data(Bank Acc.no or IFSC Code) is Missing',
          'MAX_AMOUNT_VALIDATION_SIP_ERROR': 'SIP transaction amount is exceeding maximum OTM amount, please select another OTM or payment mode to proceed',
          'EXPIRY_DATE_FIRST_INSTALLMENT_VALID_ERROR':'Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or before OTM expiry date which is,',
          'DATE_START_FIRST_INSTALLMENT_VALIDATION_ERROR': 'Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or after OTM start date which is,',
          'RESTRICT_HUF': "Cannot proceed with folio creation for HUF PAN (fourth letter 'H') with 'Resident Individual' tax status.",
          'ESTIMATED_INCOME_REQUIRED': "Estimated Income Amount is required.",
          'DECLARATION_CATEGORY_REQUIRED': "Declaration Category is required.",
          'DECLARATION_YEAR_REQUIRED': "Year of Declaration is required.",
          'ESTIMATED_TOTAL_INCOME_REQUIRED': "Estimated Total Income Amount is required.",
          'ESTIMATED_INCOME_GREATER_THAN_TOTAL_INCOME': "Estimated income should not be greater than Total Estimated Income.",
          'TWO_DECIMAL_ALLOWED': "Only two decimal input allowed.",
          'REGISTRATION_NO_REQUIRED': 'Registration Number is required.',
          'CANCEL_SUCCESS':'Record cancel Successfully.',
          'VALIDATION_15H': 'Form 15H registration applicable for age is greater than 60.',
          'VALIDATION_15G': 'Form 15G registration applicable for age is less than 60.',
          'PENNYDROP_VALIDATION': 'Cannot proceed with Add Bank request for selected bank, since bank does not support bank account validation using IMPS.',
          "CANCEL_NOMINATION": 'Please note, by cancelling nomination for the folio there would not be any transfer of units to nominee in case of death of unit holder. If you stll want to go ahead with cancellation of nomination, then please agree to the below Terms and Conditions by ticking the checkbox.',
          "PROPORTION_PERCENTAGE": 'Sum of percentage proportion of all nominees should be equal to 100%',
          "OFFLINE_NOMINEE_FORM":'To update nominee details for folios with mode of holding as "Anyone or Survivor" or "Joint", kindly submit offline form available here: ',
          'PROPORTION_NOT_ZERO': 'Proportion of nominee can not be zero',
          "NOMINEE_SAME_INVESTOR" : 'You cannot add yourself as Nominee',
          "NOMINEE_PAN_SAME" : 'PAN is already added as a Nominee',
          "GUARDIAN_SAME_INVESTOR" : 'You cannot add yourself as Guardian',
          "GUARDIAN_SAME_NOMINEE" : 'Guardian PAN cannot be same as Nominee Pan',
          "TOP_UP_LABEL" : 'Top up',
          "AMOUNT_EXCEEDED" : "This is a high value registration, we request you to contact (hello@hdfcfund.com) for assistance to complete your registration.",
          'FILL_FOLIO_DETAILS': 'Would you like to pre-fill your folio detail from existing folio?',
          'INVALID_AMOUNT_BASKET': "Please enter a valid amount",
          'MIN_AMOUNT_BASKET' : "Minimum Basket Amount should be",
          'BASKET_NO_FOLIO' : 'No Folio Found',
          "INVESTMENT_OPTIONS_REQUIRED":  "IDCW Options is required",
          'MAX_AMOUNT_VALIDATION_ECART': 'Transaction amount is exceeding maximum OTM amount, please select another OTM or payment mode to proceed.',
          'TENURE_EMPTY' : 'Please Select Tenure',
          "DOB_MAJOR_MSG" : 'Entered DOB should not be less than 18 years',
          "DOB_FORMAT" : "Enter date in DD/MM/YYYY format only",
          "DOB_REQUIRED_MSG" : 'DOB is required',
          "EMAIL_BELONGS_TO" : 'Select Email Id Belongs To',
          "MOBILE_BELONGS_TO": 'Select Mobile No. Belongs To',
          "EMANDATE_DATE_EXCEED_ERROR" : 'SIP end date cannot be more than E-mandate end date.',
          "EMANDATE_MIN_ERROR": 'Amount of e-mandate cannot be less than ₹',
          "EMANDATE_MAX_ERROR": 'Amount of e-mandate cannot be greater than ₹',
          "EMANDATE_SIP_AMOUNT_ERROR": 'Mandate amount cannot be less than SIP entered amount.',
          "MANDATE_DATE_EXCEED_ERROR": 'E-mandate end date cannot be less than SIP end date.',
          "MANDATE_DATE_EXCEED_ERROR_TENURE" : 'E-mandate End Date cannot be less than SIP End Date. Kindly change E-mandate End Date.',
          "MISSING_MOBILE_NUMBER": "Your Mobile Number is not updated in folio. Please enter mobile number to receive OTP for login & important notifications.",
          "MISSING_EMAIL": "Your Email ID is not updated in folio. Please enter email ID to receive OTP for login & important notifications.",
          "MISSING_CONTACT_DETAIL_ERROR": "Contact details are not updated in entered folio. Kindly use different folio for user ID creation or get in touch with our ISE or CAMS to update CKYC.",
          "CHEQUE_NUMBER_REQUIRED":'Cheque Number is required',
          'SAME_CHEQUE_NUMBER_RANGE': 'Cheque Number should be same',
          "MANDATE_AMOUNT_REQUIRED" : "Mandate amount is required.",
          "EMANDATE_MIN_ERROR_FLEX_SIP": 'Mandate amount cannot be less than twice the SIP amount for Flex SIP registration.',
          'ACCOUNT_NUMBER_RANGE_NEW': 'Account Number should be minimum 4 digits',
          'INVESTOR_ACCOUNT_NUMBER_RANGE_NEW': 'Investor Account Number should be minimum 4 digits',
          "RELATIONSHIP_WITH_APPLICANT_OTHER": 'Relation with Applicant is required.',
          "PERSONAL_IDENTIFIER_REQUIRED": "Please select personal identifier of nominee.",
          "EMAILID_SAME_INVESTOR" : 'Nominee’s email ID cannot be the same as the investor’s. Please provide a different ID.',
          "MOBILE_SAME_INVESTOR": 'Nominee’s mobile no. cannot be the same as the investor’s. Please provide a different number.',
          "DRIVING_LICENSE_ALREADY_EXIST": "Driver License no. is already added as a nominee.",
          "DRIVING_LICENSE_INVALID": "Please enter valid driving license no.",
          "AADHAAR_ALREADY_EXIST": "Aadhaar No. is already added as a nominee.",
          "AADHAAR_INVALID": "Please enter valid last four digits number of nominee's Aadhaar.",
          "PASSPORT_REQUIRED": "Please enter valid passport number.",
          "PASSPORT_ALREADY_EXIST": "Passport number is already added as a nominee.",
          "STATEMENT_HOLDING_DECLARATION_REQUIRED": "Please choose one of the options for the statement of holding declaration.",
        },
        FAILED: 'Something went wrong. Please try again later.'
      },
      /* password_regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!_])([a-zA-Z0-9@$!_]){8,12}$/,*/
      password_regex: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$_!@])[A-Za-z\d$@!_]{8,12}$/,
      email_regex: /^[a-zA-Z0-9](?!.*\.\.)+[a-zA-Z0-9._%+-]{1,256}@[a-zA-Z0-9.-]{1,64}\.[a-zA-Z]{1,25}$/i,
      valid_userId_regex:/^temp_/,
      arn_regex: /^[0-9]{1,10}$/,
      mobile_regex: /^\+91[1-9]{1}\d{9}$/,
      mobile_regex_with_country: /^(?:\+|\+1|\+\d+|(?!(\d)\1+$)\d+)$/,
      mobile_regex_eKyc: /^[0-9]{10}$/,
      accNo_regex: /^[0-9]{1,9}$/,
      folio_regex: /^[0-9]{1,12}$/,
      UTR_REGEX: /^([a-zA-Z0-9]*)$/,
      name_regex: /^[a-zA-Z ]{1,30}$/,
      upi_virtual_addr_regex: /^[a-zA-Z0-9.-]+@[a-zA-Z0-9]+$/,
      userId_regex: /^\S+$/,
      USERNAME_PATTERN: 'Invalid User ID',
      ifsc_regex: new RegExp("^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$"),
      DEFAULT_PROFILE_IMAGE: '/assets/images/bg_profile.png',
      otp_regex:/^[0-9]{6}$/,
      DOB_FORMAT_REGEX : /(((0|1)[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/((19|20)\d\d))$/,
      TRANSACTIONS: {
        PAYMENT_TRANS_VERSION:{NEW:'NEW',OLD:'OLD'},
        DESCRIPTIONS: {
          F: 'Fixed Amount',
          V: 'Capital Appreciation',
          Z: 'Growth',
          Y: 'Re-invest',
          N: 'Payout',
          EC: 'Standing Instruction/Biller',
          OTM: 'OTM (One Time Mandate)',
          EM: 'e-Mandate',
          Q: 'Cheque',
          //DEBIT: 'Debit Card',
          RTGS: 'NEFT/RTGS',
          NETBANKING: 'Net Banking',
          HDFC: 'HDFC Fund Transfer',
          UPI: 'UPI',
          'E-mandate': 'Register E-mandate (eOTM)',
          UPI_AUTOPAY : 'UPI Autopay',
          FREQ: {
            DZ: 'Daily',
            BZ: 'Daily',
            OW: 'Weekly',
            OM: 'Monthly',
            Q: 'Quarterly',
            H: 'Half Yearly',
            Y: 'Yearly'
          },
          SIPFREQ: {
            BZ: 'Daily',
            OW: 'Weekly',
            OM: 'Monthly',
            Q: 'Quarterly',
            H: 'Half Yearly',
            Y: 'Yearly'
          },
          WEEK_DAYS: {
            '2': 'Monday',
            '3': 'Tuesday',
            '4': 'Wednesday',
            '5': 'Thursday',
            '6': 'Friday'
          }
        },
        TRANSFER_OPTIONS: {
          FIXED_AMOUNT: 'F',
          CAPITAL_APPRECIATION: 'V'
        },
        INVESTMENT_OPTIONS: {
          GROWTH: 'GROWTH',
          DIVIDEND: 'Income Distribution cum Capital Withdrawal (IDCW) Option'
        },
        DIVIDEND_OPTIONS: {
          GROWTH: 'Z',
          REINVEST: 'Y',
          PAYOUT: 'N'
        },
        INVESTMENT_MODE: {
          F: 'Fixed',
          V: 'Variable'
        },
        DIVIDEND_OPTIONS_STATUS: {
          Z: 'Growth',
          N: 'Dividend Payout',
          Y: 'Dividend Reinvest'
        },
        TRANSACTION_TYPE: {
          STP: 'STP',
          SIP: 'SIP',
          PURCHASE: 'PURCHASE',
          SWITCH: 'SWITCH',
          REDEMPTION: 'REDEMPTION',
          NFO_SWITCH_OUT: 'NFO_SWITCH_OUT',
          FLEX_INDEX: 'FLEX_INDEX',
          DTP: 'DTP',
          SWP: 'SWP',
          INSTANT_REDEMPTION: 'INSTANT_REDEMPTION',
          ROLLOVER: 'ROLLOVER',
          SIP_TOPUP: 'SIP-TOPUP',
          SCHEDULE_TRANSACTION_PURCHASE: 'SCHEDULE_TRANSACTION_PURCHASE',
          SCHEDULE_TRANSACTION_SWITCH: "SCHEDULE_TRANSACTION_SWITCH",
          SCHEDULE_TRANSACTION_REDEMPTION: "SCHEDULE_TRANSACTION_REDEMPTION",
          SMART_SWAP: 'SMART_SWAP',
          DREAM_SIP: "DREAM_SIP",
          Schedule_Transaction:"Schedule_Transaction",
          FLEX_SIP: 'FLEXSIP'
        },
        SCHEDULE_TRANSACTION_FREQUENCY:[
          {key: 'OM', value: 'Monthly'},
          {key: 'FN', value: 'Fortnightly' },
          {key: 'OW', value: 'Weekly' }
        ],
        STP_FREQ_LIST_FOR_CAPITAL: [
          {key: 'OM', value: 'Monthly', monthfreq: 1},
          {key: 'Q', value: 'Quarterly', monthfreq: 3}
        ],
        STP_FREQ_LIST_FOR_FIXED: [
          {key: 'DZ', value: 'Daily', dayfreq: 1},
          {key: 'OW', value: 'Weekly', dayfreq: 7},
          {key: 'OM', value: 'Monthly', monthfreq: 1},
          {key: 'Q', value: 'Quarterly', monthfreq: 3}
        ],
        STP_TYPE: {F:'FIXED PLAN',V:'VARIABLE PLAN',T:'FLEX STP',Q:'SWING STP'},
        SWP_FREQ_LIST_FOR_CAPITAL: [
          {key: 'Q', value: 'Quarterly', monthfreq: 3},
          {key: 'H', value: 'Half Yearly', monthfreq: 6},
          {key: 'Y', value: 'Yearly', monthfreq: 12}
        ],
        SWP_FREQ_LIST_FOR_FIXED: [
          {key: 'OM', value: 'Monthly', monthfreq: 1},
          {key: 'Q', value: 'Quarterly', monthfreq: 3},
          {key: 'H', value: 'Half Yearly', monthfreq: 6},
          {key: 'Y', value: 'Yearly', monthfreq: 12}

        ],
        SIP_FREQ_LIST: [
          {key: 'OM', value: 'Monthly', monthfreq: 1, isEnabled:true},
          {key: 'Q', value: 'Quarterly', monthfreq: 3, isEnabled:true},
          {key: 'OW', value: 'Weekly', dayfreq:7, isEnabled: true},
          {key: 'BZ', value: 'Daily', dayfreq: 1, isEnabled:true}

        ],
        Dynamic_SIP_FREQ_LIST: [
          {code: 'OM', value: 'Monthly', duration: 1},
        ],
        Dynamic_FLEX_SIP_FREQ_LIST: [
          {code: 'OM', value: 'Monthly', duration: 1},
          {code: 'Q', value: 'Quarterly', duration: 3},
        ],
        emailList : [
          {
            "familyCode": "SP",
            "familyDescription": "Spouse"
          },
          {
            "familyCode": "DP",
            "familyDescription": "Dependent Parents"
          },
          {
            "familyCode": "SE",
            "familyDescription": "Self"
          },
          {
            "familyCode": "PO",
            "familyDescription": "POA"
          },
          {
            "familyCode": "DS",
            "familyDescription": "Dependent Siblings"
          },
          {
            "familyCode": "DC",
            "familyDescription": "Dependent Children"
          },
          {
            "familyCode": "GD",
            "familyDescription": "Guardian"
          }
        ],
        mobileList: [
          {
            "familyCode": "DS",
            "familyDescription": "Dependent Siblings"
          },
          {
            "familyCode": "DC",
            "familyDescription": "Dependent Children"
          },
          {
            "familyCode": "GD",
            "familyDescription": "Guardian"
          },
          {
            "familyCode": "SP",
            "familyDescription": "Spouse"
          },
          {
            "familyCode": "DP",
            "familyDescription": "Dependent Parents"
          },
          {
            "familyCode": "SE",
            "familyDescription": "Self"
          },
          {
            "familyCode": "PO",
            "familyDescription": "POA"
          }
        ],
        NEW_INVESTOR_JOURNY: [
          { "name": "Monthly","code": "OM","duration": 1 },
          { "name": "Quarterly","code": "Q","duration": 3},
          { "name": "Half Yearly","code": "H","duration": 6},
          { "name": "Yearly","code": "Y", "duration": 12 }
        ],
        PURCHASE_FREQ_LIST: [
          {key: 'OM', value: 'Monthly', monthfreq: 1, isEnabled:true},
          {key: 'Q', value: 'Quarterly', monthfreq: 3, isEnabled:true},
          {key: 'BZ', value: 'Daily', dayfreq: 1, isEnabled:true}
        ],
        DAYS_LIST: [
          {name: 1, value: 1},
          {name: 5, value: 5},
          {name: 10, value: 10},
          {name: 15, value: 15},
          {name: 20, value: 20},
          {name: 25, value: 25}
        ],
        SIP_DAYS_LIST: [
          {name: 1, value: 1},
          {name: 2, value: 2},
          {name: 3, value: 3},
          {name: 4, value: 4},
          {name: 5, value: 5},
          {name: 6, value: 6},
          {name: 7, value: 7},
          {name: 8, value: 8},
          {name: 9, value: 9},
          {name: 10, value: 10},
          {name: 11, value: 11},
          {name: 12, value: 12},
          {name: 13, value: 13},
          {name: 14, value: 14},
          {name: 15, value: 15},
          {name: 16, value: 16},
          {name: 17, value: 17},
          {name: 18, value: 18},
          {name: 19, value: 19},
          {name: 20, value: 20},
          {name: 21, value: 21},
          {name: 22, value: 22},
          {name: 23, value: 23},
          {name: 24, value: 24},
          {name: 25, value: 25},
          {name: 26, value: 26},
          {name: 27, value: 27},
          {name: 28, value: 28}
        ],
        WEEKS_LISTS: [
          {name: 'Monday', value: 2},
          {name: 'Tuesday', value: 3},
          {name: 'Wednesday', value: 4},
          {name: 'Thursday', value: 5},
          {name: 'Friday', value: 6}
        ],
        WEEKS_LIST: ["Monday","Tuesday","Wednesday","Thursday","Friday"],
        SCHEME_ENDING_TYPE: {
          OPEN: 'OPEN',
          CLOSED: 'CLOSED'
        },
        PAYMENT_OPTIONS: {
          EC: 'EC',
          SI: 'SI',
          OTM: 'OTM',
          EM: 'EM',
          //DEBIT: 'DEBIT',
          RTGS: 'RTGS',
          NETBANKING: 'NETBANKING',
          HDFC: 'HDFC',
          UPI: 'UPI',
          EMANDATE: 'E-mandate',
          CHEQUE: 'Q'
        },
        EMANDATE_MAX_AMOUNT:100000,
        AMOUNT_TYPE: {
          AMOUNT: 'amount',
          UNITS: 'units',
          ALL_UNITS: 'all_units'
        },
        CGF_SCHEME_MSG: "I am parent/legal guardian of the minor child for which the investment is being made in HDFC Children\'s Gift Fund.",
        WHATSAPP_DEEP_LINK: "https://wa.me/8270682706",
        PAYMENT_CONSTANTS: {
          RTGS: 'NEFT/RTGS',
          NETBANKING: 'Net Banking',
          HDFC: 'HDFC Bank Transfer',
          UPI: 'UPI',
          OTM: 'Existing Mandate',
        }
      },
      // new investor back state manage
      BACK_ROUTE:[
      {url:"/schemedetails",state:"newInvestor.investmentDetails.schemedetails"},
      {url:"/investmentmode",state:"newInvestor.investmentDetails.investmentmode"},
      {url:"/amountdetails",state:"newInvestor.investmentDetails.amountdetails"}
      ],
      BACK_ROUTE2:[
        {url:"/folio-basic-details",state:"newInvestor.folioDetails.baiscDetails"},
        {url:"/folio-income-details",state:"newInvestor.folioDetails.incomeDetails"},
        {url:"/folio-nominee-details",state:"newInvestor.folioDetails.nomineeDetails"},
        {url:"/bankdetails",state:"newInvestor.folioDetails.bankdetails"}
        ],
      BACK_ROUTE3:[
          {url:"/folio-basic-details",state:"newInvestor.folioDetails.baiscDetails"},
          {url:"/folio-income-details",state:"newInvestor.folioDetails.incomeDetails"},
          {url:"/folio-joint-holder-details",state:"newInvestor.folioDetails.jointHolderDetails"},
          {url:"/folio-nominee-details",state:"newInvestor.folioDetails.nomineeDetails"},
          {url:"/bankdetails",state:"newInvestor.folioDetails.bankdetails"}
          ],
      BACK_ROUTE4:[
            {url:"/folio-basic-minor-details",state:"newInvestor.folioDetails.baiscMinorDetails"},
            {url:"/folio-guardian-minor-details",state:"newInvestor.folioDetails.guardianMinorDetails"},
            {url:"/bankdetails",state:"newInvestor.folioDetails.bankdetails"}
            ],
      RAZORPAY_CRADENTIALS: {
        'merchantLogoUrl': 'https://investor.hdfcfund.com/mfonline/images/logo.gif'
      },
      TRANSACTION_LIST_FILTER: {
        TRANSACTION_TYPE: [
          {key: 'Transaction Type (All)', value: 'ALL'},
          {key: 'SIP', value: 'SIP'},
          {key: 'Flex SIP' , value: 'FLEXSIP'},
          {key: 'STP', value: 'STP'},
          {key: 'SWP', value: 'SWP'},
          {key: 'TIP', value: 'DTP'},
          {key: 'Redemption', value: 'REDEMPTION'},
          {key: 'Purchase', value: 'PURCHASE'},
          {key: 'Switch', value: 'SWITCH'},
          {key: 'SMART SWAP', value: 'SMART_SWAP'},
          {key: 'DREAMSIP', value: 'DREAMSIP'}
          //{ key: 'Switch In', value: 'SWITCH_IN' },
          //{ key: 'Switch Out', value: 'SWITCH_OUT' },
          //{ key: 'STP Index', value: 'STPINDEX' },
          //{ key: 'STP Swing', value: 'STPSWING' },
          //{ key: 'STP Flex', value: 'STPFLEX' },
          //{ key: 'Flex Index', value: 'FLEXINDEX' }
        ],
          LIST_TRANSACTION_TYPE: [
            {key: 'Transaction Type (All)', value: 'ALL'},
            {key: 'SIP', value: 'SIP'},
            {key: 'Flex SIP' , value: 'FLEXSIP'},
            {key: 'STP', value: 'STP'},
            {key: 'SWP', value: 'SWP'},
            {key: 'TIP', value: 'DTP'},
            {key: 'Redemption', value: 'REDEMPTION'},
            {key: 'Purchase', value: 'PURCHASE'},
            {key: 'Switch', value: 'SWITCH'}
          ],
        TRANSACTION_MODE: [
          {key: 'Mode (All)', value: 'ALL'},
          {key: 'Online', value: 'ONLINE'},
          {key: 'Offline', value: 'OFFLINE'}
        ],
        ROLLOVER_MODE: {
          'Amount': 'Amount',
          'AllUnits': 'All Free units',
          'NoOfUnits': 'No Of units'
        },
        TRANSACTION_STATUSES: {
          "allCount": {
            label: "All",
            key: "ALL",
            action: ""
          },
          "proposedCount": {
            label: "In Process",
            key: "PROPOSED",
            action: ""
          },
          "pendingCount": {
            label: "Pending",
            key: "PENDING",
            action: "Approve"
          },
          "rejectedCount": {
            label: "Rejected",
            key: "REJECTED",
            action: "view Details"
          },
          "processedCount": {
            label: "Processed",
            key: "PROCESSED",
            action: "View Details"
          },
          "reversedCount": {
            label: "Reversed",
            key: "REVERSED",
            action: "Re-Initiate"
          },
          "scheduledCount": {
            label: "Scheduled",
            key: "SCHEDULED",
            action: ""
          },
          "canceledScheduleCount": {
            label: "Cancelled",
            key: "CANCELLED",
            action: ""
          },
          "expiredScheduleCount": {
            label: "Expired",
            key: "EXPIRED",
            action: ""
          }
        },
        TRANSACTION_ACTION: {
          "allCount": {
            label: "All",
            action: "ALL"
          },
          "proposedCount": {
            label: "In Process",
            action: "PROPOSED"

          },
          "pendingCount": {
            label: "Pending Aproval",
            action: "PENDING"
          },
          "rejectedCount": {
            label: "Rejected",
            action: "REJECTED"
          },
          "processedCount": {
            label: "Processed",
            action: "PROCESSED"
          },
          "reversedCount": {
            label: "Reversed",
            action: "REVERSED"
          }
        }
      },
      LOGIN_TYPE: {IP: 'IP_WEB', QUICK: 'QI_WEB',HDFC_ONE_CLICK:'HDFC_ONE_CLICK'},
      RETIREMENT_IMAGE_TYPE: [
        'retirement_age_proof_jh0,',
        'retirement_age_proof_jh1,',
        'retirement_age_proof_jh2,',
        'retirement_age_proof_jh3,'
      ],
      INVESTOR_TYPE: {NEW: 'NEW', EXISTING: 'EXISTING'},
      INVESTOR_POLITICAL_STATUS: {POLITICAL: 'POLITICAL', RELATED: 'POLITICALLY_RELATED', NONE: 'NONE'},
      INVESTOR_HOLD_MODE: {SINGLE: 'SINGLE', AOS: 'ANY_OR_SURVIVOR'},
      FIRST_FOLIO_URI: ['login', 'home', 'welcome', 'welcome.newUserWelcome', 'welcome.existingUserWelcome', 'folioDetails', 'folioDetails.folioCreation', 'folioDetails.incomeDetails', 'folioDetails.incomeDetailsMinor',
        'folioDetails.politicalExposed', 'folioDetails.taxResidency', 'folioDetails.taxResidencyMinor', 'folioDetails.addNominee', 'folioDetails.bankDetails'
      ],
      PAGE_LIMITS: [25, 50],
      AREA_CHART_COLOR: ["#4a7acf", "#00c0f2", "#56add5", "#2485bd", "#103880"],
      /* CONTRIBUTORS_FREQUENCY: [
         {key: 'Last 7 Days', value: 'WEEKLY'},
         {key: 'Last 30 Days', value: 'MONTHLY'}
       ],*/
      CONTRIBUTORS_FREQUENCY: [
        {key: '1 Month', value: 'LAST_30_DAYS'},
        {key: '3 Months', value: 'LAST_90_DAYS'},
        {key: '6 Months', value: 'LAST_SIX_MONTHS'},
        {key: '1 Year', value: 'LAST_ONE_YEAR'},
        {key: '3 Years', value: 'LAST_THREE_YEAR'},
        {key: '5 Years', value: 'LAST_FIVE_YEAR'}
      ],
      NO_OF_CONTRIBUTORS: [
        {key: 'Top 3', value: 3},
        {key: 'Top 5', value: 5}
      ],
      WIDGETS_ID: {
        INVESTMENT: "686aa75c-0b7e-4c3c-b4c3-c526de4010d8",
        INVESTMENT_NAME: 'Investment Overview',
        INVESTMENT_ORDER: 1,
        SCHEME_PERFORMANCE: "b189c176-62d0-475f-9a8b-746e1da7cf2f",
        SCHEME_PERFORMANCE_NAME: 'Scheme Performance Evaluation',
        SCHEME_PERFORMANCE_ORDER: 2,
        MARKETUPDATE: "d261cfbf-fc75-431e-b919-9a0c2a3e39f3",
        MARKETUPDATE_NAME: 'Market Updates',
        MARKETUPDATE_ORDER: 3,
        DIVIDENTUPDATE: "0e3d2e17-495b-4e3e-aa29-b765f8fa26b4",
        DIVIDENTUPDATE_NAME: 'Nav & Dividend Updates',
        DIVIDENTUPDATE_ORDER: 4,
        RECENTACTIVITY: "ce0557d4-7610-4ff5-8208-a6005eaa3014",
        RECENTACTIVITY_NAME: 'Recent Activites',
        RECENTACTIVITY_ORDER: 5,
        TRANSACTIONSTATUS: "27f7e919-1dcf-44e8-83fd-87d293227115",
        TRANSACTIONSTATUS_NAME: 'Transaction Status',
        TRANSACTIONSTATUS_ORDER: 6,
        QUICKLINK: "bbbae025-60d9-4908-9798-8f330d37c7e5",
        QUICKLINK_NAME: 'Quick Links',
        QUICKLINK_ORDER: 7
      },
      SYSTEMATIC_TRANSACTION_TYPES: [
        {key: 'TRANSACTION TYPE (ALL)', value: 'ALL'},
        {key: 'SIP', value: 'SIP'},
        {key: 'SIP WITH TOP UP' , value: 'SIP_TOP_UP'},
        {key: 'Flex SIP' , value: 'FLEXSIP'},
        {key: 'STP', value: 'STP'},
        {key: 'SWP', value: 'SWP'},
        {key: 'TIP', value: 'DTP'},
        {key: 'FLEXSTP', value: 'FLEXSTP'},
        {key: 'FLEXINDEX', value: 'FLEXINDEX'},
        {key: 'SWINGSTP', value: 'SWINGSTP'},
        {key: 'SMART SWAP', value: 'SMART_SWAP'},
        {key: 'DREAM SIP', value: 'DREAMSIP'},
      ],
      SYSTEMATIC_STATUS_TYPES: [
        {key: 'STATUS(ALL)', value: 'ALL'},
        {key: 'ACTIVE', value: 'ACTIVE'},
        {key: 'CEASED', value: 'CEASED'},
        {key: 'CANCELLED', value: 'CANCELLED'},
        {key: 'COMPLETED', value: 'COMPLETED'},
        {key: 'PAUSED', value: 'PAUSED'}
      ],
      SUMMARY_TYPES:{
        FLEX_STP : {key:'flexStp', value:'Flex STP', type:'FlexSTP'},
        CHECK_UPDATE: {key:'notUpdated', value:'Not Updated'},
        SWING_STP: {key:'SwingStp', value:'Swing STP', type:'SwingSTP'}
      },
      SYSTEMATIC_CANCEL_FLEX: {
        FLEXSTP: 'STPFLEX'
      },
      SYSTEMATIC_CANCEL_SWINGSTP: {
        SWINGSTP: 'STPSWING'
      },
      IDENTIFIER: '+TgK8UUnAebCkA==',//%2BTgK8UUnAebCkA%3D%3D
      INSTA_IDENTIFIER: '+RsM2BBmBrcZrX##',
      NEW_INVESTOR_IDENTIFIER : '+PsM2FQmBrcZoY##',
      MOBILE_IDENTIFIER: '+CSAsMddvCSAAZrX##',
      USER_CONFIG: '@QxJ156#YfX++',
      CONFIG_ENDPOINT: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCl/LnL+gw7c01DtzVmJxb8mr6b4VTQhsEPLWRV4LaUZrxonqP3w+aKuxfLtLpXSQ7xETQyW2Vea+8Zr7G9GbszguwafVxj0g0bXewhdCvKM/N2FjJa7d9KQaQRrXxgVsqBjux/xxaaoa8gokDCiXX1sNJt/qBzwLknW6vBdEo1wwIDAQAB',
      OBJECT_CONFIG: "tgkpdi45sd",
      RUNNING_MODE: {
        MAINTENANCE: 'maintenance',
        CAMS_DOWN:'cams_down',
        UP:'up'
      },
      CAPTCHA_PUB_KEY:'6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX',
      MAINTENANCE_CONTENT_URL:"https://cms.hdfcfund.com/en/hdfc/api/v1/maintenancePage/ip",
      BROWSERS: {
        UCBROWSER: 'UCBROWSER',
        CHROME: 'CHROME',
        IE: 'IE',
        FIREFOX: 'FIREFOX',
        MS_EDGE: 'EDGE'
      },
      KYC_STATUS: {
        IN_PROGRESS: "IN_PROGRESS",
        VERIFIED: "VERIFIED",
        NOT_VERIFIED: "NOT_VERIFIED",
        INCOMPLETE: "INCOMPLETE",
        REJECTED: "REJECTED",
        ON_HOLD: "HOLD",
        SUSPENDED: "SUSPENDED",
        NOT_VALIDATED: "NOT_VALIDATED"
      },
      META_TAGS: {
        LOGIN_DESCRIPTION: "You can register as an HDFC Mutual Fund Investor through MF Online Investor Login with Password or Login OTP. Our HPIN or Existing users can reset their password or create a new User ID. Investing in HDFC Mutual fund online is easy and reliable.",
        QUICK_INVEST_DESCRIPTION: "Instant login to your HDFC mutual fund account for quick investments. You can start your SIP or Lumpsum investments in mutual funds with ease using your Folio number, PAN and Bank account number.",
        LOGIN_TITLE: "Welcome to HDFC Mutual Fund - MF Online Investors",
        KEYWORDS: "hdfc mutual fund login, hdfcmf login, hdfc mf login, mutual fund login, mutual fund website, invest in mutual fund"
      },
      TRAI: {
        NOTIFICATION: "As per TRAI Mobile Number Revocation List, the mentioned number is <span>not active</span>. Please update your Mobile Number to receive notifications.",
        PROFILE_TOOLTIP_TEXT: "Please update contact details."
      },
      INVEST_THROUGH: {
        DIRECT: 'DIRECT',
        DISTRIBUTOR: 'DISTRIBUTOR',
        RIA: 'RIA'
      },
      INVESTOR_SELECTION: {
        EXISTING_USER: "EXISTING_USER",
        NEW_INVESTOR: "NEW_INVESTOR",
        QUICK_INVEST: "QUICK_INVEST",
        UPDATE_CONTACT_DETAILS: "UPDATE_CONTACT_DETAILS",
        NO_SELECTION: "NO_SELECTION",
        UPDATE_KYC: 'UPDATE_KYC'
      },
      KYC_RESTRICTION: {
        FOLIO_CREATION: "FOLIO_CREATION",
        TRANSACTION: "TRANSACTION"
      },
      LANDING_PAGE_TYPE: {
        NEW_FIRST_TIME_PROSPECT_FOLIO: "NEW_FIRST_TIME_PROSPECT_FOLIO",
        OFFLINE: "OFFLINE",
        EXISTING: "EXISTING",
        FOLIO_CREATION: "FOLIO_CREATION"
      },
      SIP_Period: [
        {name: '07 years', value: 7,multiple:1},
        {name: '10 years', value: 10,multiple:1.5},
        {name: '12 years', value: 12,multiple:2},
        {name: '15 years', value: 15,multiple:3},
        {name: '20 years', value: 20,multiple:5},
        {name: '25 years', value: 25,multiple:8},
        {name:'30 years', value: 30,multiple:12}
      ],
      WELCOME_VIDEO_LIST: {
        "name3": "https://www.youtube.com/embed/rbUkR-8yCBc?autoplay=1&amp;showinfo=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fhdfcfund.com&amp;widgetid=1",
        "name2": "https://www.youtube.com/embed/eFftRxVMea4?autoplay=1&amp;showinfo=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fhdfcfund.com&amp;widgetid=1",
        "name1": "https://www.youtube.com/embed/3MOVqfUCdm0?autoplay=1&amp;showinfo=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fhdfcfund.com&amp;widgetid=1",
        "name4": "https://www.youtube.com/embed/m98Pk9NfFNU?autoplay=1&amp;showinfo=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fhdfcfund.com&amp;widgetid=1",
        "name5": "https://www.youtube.com/embed/j53EYWtoB6I?autoplay=1&amp;showinfo=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fhdfcfund.com&amp;widgetid=1",
        "name6": "https://www.youtube.com/embed/eaA1Wdjt2Sk?autoplay=1&amp;showinfo=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fhdfcfund.com&amp;widgetid=1"
      },
      WELCOME_BANNER_LIST: [
        "assets/images/welcome-banner.png",
        "assets/images/Banner_Welcome_screen.jpg"
      ],
      OPTION_LIST:[
        {key: 'OPTA', value: 'Option A'},
          {key: 'OPTB', value: 'Option B'}
      ],
      NAV_APPLICABILITY_MESSAGE: "Approved text needs to be added on the Banner",
      NAV_APPLICABILITY_NOTE: "For purchase /switch-in request received within cut-off time on a Business Day, irrespective of the amount, the below NAV shall apply:" +
        "<div>For all Scheme(s) except liquid funds - NAV of the day on which the funds are available for utilization.</div>" +
        "<div>For liquid funds - NAV of the day prior to the Business Day on which the funds are available for utilization.</div>" +
        "For more information <a href='https://www.hdfcfund.com/information/uniform-nav-applicability' target='_blank' class='faq-link'>click here</a>.",
      UPDATE_CONTACT_URL: " please <a href='/update-user-contact'>click here</a> to update.",
      XIRR_INFORMATION: "XIRR denotes return on investment computed on active units.",
      SESSION_ACTIVE: "Session for this User is already active",
      LINKED_PAN_STATUS: 'PanNumber No Longer Linked With Parent PanNumber.',
      RESEND_OTP_COUNTER: 60, //applicable for only HMF-11260 list shared
      COOKIE_CONFIG: {
        path: "",
        secure: true
      },
      API_RETRY_COUNT: 3,
      NOMINEE_REGISTRATION_FAILURE: "Nominee Details could not be updated in your folio due to error at RTA. Please write to us at <a href='mailto:hello@hdfcfund.com'>hello@hdfcfund.com</a> if you have an query or concerns.",
      RTGS_MESSAGE: "Have you transferred funds from a registered bank account:",
      TPV_NOTES: [
        { note: " IFSC update may take time to reflect in your bank details", id: 'tpv_note_ifsc'} ,
        { note: " Your transaction shall be validated at RTA, whereby, if your name in bank account used for payment and " +
          "name in folio does not match and RTA is unable to verify due to lack of proof submission, allotment of units " +
          "will be delayed/withheld/transaction will be considered as NIGO. Units allotted if any, will be refunded in " +
          "case if AMC / RTA could not verify the source of funds proof for the said transaction, as mandated by SEBI vide its circular dated: 04-Oct-2021",
          id : 'tpv_note_message'
        }
      ],
      NRI_STATUS_CODES: ['11','21','24','26','27','28','42'],
      BANK_STATEMENT_INFO: "Name, Debit Bank Account No. and UTR number should be visible on the Bank Statement. Max file size should be less than or equal to 3 MB. File format/extension should be tiff, tif, pdf, jpg and jpeg.",
      TOP_UP:['SIP','PURCHASE'],
      FEEDBACK_FORM_ERR0R: " Message should not contain special characters - # , $ , % , ^ , + , \\ , = , ; , | , <> , / ",
      SET_TOP_UP_PERCENTAGE_VIEW : false,
      DURATION: [
        {value: 1, text: '1 month' },
        {value: 2, text: '2 month' },
        {value: 3, text: '3 month' },
        {value: 4, text: '4 month' },
        {value: 5, text: '5 month' },
        {value: 6, text: '6 month' },
        {value: 7, text: '7 month' },
        {value: 8, text: '8 month' },
        {value: 9, text: '9 month' },
        {value: 10, text: '10 month' },
        {value: 11, text: '11 month' },
        {value: 12, text: '12 month' },
        {value: 13, text: '13 month' },
        {value: 14, text: '14 month' },
        {value: 15, text: '15 month' },
        {value: 16, text: '16 month' },
        {value: 17, text: '17 month' },
        {value: 18, text: '18 month' },
        {value: 19, text: '19 month' },
        {value: 20, text: '20 month' },
        {value: 21, text: '21 month' },
        {value: 22, text: '22 month' },
        {value: 23, text: '23 month' },
        {value: 24, text: '24 month' }
      ],
      AMOUNT_LIST: [
        {value: 100000, text: "1lcs"},
        {value: 200000, text: "2lcs"}
      ],
      QUESTIONNAIRE_OPTIONS: {
        TRAVEL_DURATION: "duration.value as duration.text  for duration in timeInMonths",
        TRAVEL_AMOUNT: "amount.value as amount.text for amount in amountList"
      },
      BASKET_WIDGET:[
        {
          image:'https://files.hdfcfund.com/s3fs-public/2022-06/advanced_1.jpg',
          label:'Plan Your Goal',
          description:'Ideal for experienced investors looking to sharpen their investing skills with knowledge of advanced financial concepts.',
          buttonText:'Explore',
          type:'main.investment.goals'
        },
        {
          image:'https://files.hdfcfund.com/s3fs-public/2022-06/shutterstock_94296382-min_0.jpg',
          label:'Know Your Investment Personality',
          description:'Suitable for users, who have started their investing journey but need to enhance their knowledge.',
          buttonText:'Evaluate',
          type:'main.investment.personality'
        },
        {
          image:'https://files.hdfcfund.com/s3fs-public/2022-06/shutterstock_672298081_1-min.jpg',
          label:'Explore Investment Basket',
          description:'First time investor get familiar with the world of mutual funds. One of the best and safe investment instruments for achieving financial goals.',
          buttonText:'Explore',
          type:'main.investment.basket'
        },
      ],


      GOALS_CONSTANTS : [
        'TRAVEL', 'RETIREMENT', 'CHILD_EDUCATION', 'WEALTH_CREATION', 'TAX_PLANNING', 'REGULAR_INCOME', 'MY_NEST', 'EMERGENCY_CORPUS'
      ],
      RISK_APPETITE : [
        { key: 0, riskName: "Conservative",tab_key:'CONSERVATIVE', photo: "/assets/images/target.svg", description:'You are a moderate investor primarily seeking income with some potential for capital growth. You prefer a low level of investment value volatility and therefore you are willing to accept lower potential investment returns.' },
        { key: 1, riskName: "Moderately Conservative",tab_key:'MODERATELY_CONSERVATIVE', photo: "/assets/images/child-calc.svg", description:'You are a moderate investor primarily seeking income with some potential for capital growth. You prefer a low level of investment value volatility and therefore you are willing to accept lower potential investment returns.' },
        { key: 2, riskName: "Moderate",tab_key:'MODERATE', photo: "/assets/images/newInvestor.svg" , description:'You are a moderate investor primarily seeking income with some potential for capital growth. You prefer a low level of investment value volatility and therefore you are willing to accept lower potential investment returns.' },
        { key: 3, riskName: "Aggressive",tab_key:'AGGRESSIVE', photo: "/assets/images/child-calc.svg", description:'You are a moderate investor primarily seeking income with some potential for capital growth. You prefer a low level of investment value volatility and therefore you are willing to accept lower potential investment returns.' },
        { key: 4, riskName: "Very Aggressive",tab_key:'VERY_AGGRESSIVE', photo: "/assets/images/child-calc.svg", description:'You are a moderate investor primarily seeking income with some potential for capital growth. You prefer a low level of investment value volatility and therefore you are willing to accept lower potential investment returns.' },
      ],
      JOURNEY: {
        INVESTMENT_BASKET_JOURNEY: "INVESTMENT_BASKET_JOURNEY",
        GOAL_JOURNEY: "GOAL_JOURNEY",
        RISK_JOURNEY: "RISK_JOURNEY"
      },
      JOURNEY_CODE: {
        IB: "INVESTMENT_BASKET_JOURNEY",
        GJ: "GOAL_JOURNEY",
        IP: "RISK_PROFILER"
      },
      BASKET_NOTE: "Transaction acknowledgement email and SMS will be sent to the email and mobile number registered in the folio shown above.",
      INCOME_TAB:['ANNUAL_GROSS_INCOME','NET_WORTH'],
      LONG_TERM_GOAL : ['Retirement', 'Wealth Creation', 'Regular Income', 'My Home'],
      QUESTION_TYPE_EXCLUDING_RUPEE : ['TIME', 'INFLATION', 'WITHDRAWAL_RATE', 'LIFE_EXPECTANCY', 'RETIREMENT_AGE', 'AGE', 'EXPENSE_MONTHS'],
      INVESTMENT_BASKET: {
        TRANSACTION_TYPE : {
          LUMPSUM : 'PURCHASE',
          SIP : 'SIP'
        },
        DISCLAIMER: "<div><p>Investors are requested to note that the above investment solution(s) should not be construed as financial planning solution/recommendation by HDFC Mutual Fund/ HDFC AMC. They do not in any manner, indicate or imply either the quality of any particular Scheme or guarantee any specific performance/returns. Such solutions must be tailored to investor’s individual situation and objectives and risk profile and therefore, investors should consult their financial advisors to ascertain whether the product is suitable for them.</p></div> <div><p>The information contained herein is for general purposes only and not an investment advice. It does not have regard to specific investment objectives, financial situation and the particular needs of any specific person. The information/ data herein alone is not sufficient and should not be used for the development or implementation of an investment strategy. Neither HDFC AMC and HDFC Mutual Fund nor any person connected with them, accepts any liability arising from the use of this document. Investor before acting on any information herein should make his/her/their own investigation and seek appropriate professional advice and shall alone be fully responsible / liable for any decision taken on the basis of information contained herein.</p></div><div>For Complete details refer to the product pages.</div>",
        NOTE: "The transaction amount debited from your account will be refunded in 5 working days",
        CONTACT_MESSAGE: "For clarification please write to <a href='mailto:hello@hdfcfund.com'>Hello@hdfcfund.com</a> or call <a href='tel:180030106767'>1800 3010 6767</a> / <a href='tel:18004197676'>1800 419 7676</a> (Toll free)",
        PURCHASE_SUCCESS_NOTE: "In case of any queries or concern with your transaction, please quote transaction number in your communication. CAMS Reference number with ‘Awaiting’ status indicates that the transaction is pending to be proceeded at CAMS. Kindly do not initiate payment again.",
        SIP_SUCCESS_NOTE:"NOTE: In case of any queries or concern with your transaction, please quote transaction number in your communication. CAMS Reference number with ‘Awaiting’ status indicates that the transaction is pending to be proceeded at CAMS. Kindly do not initiate payment again give a missed call 9436194361 for any query related to HDFC MF Online investors & we’ll call back",
        SIP_IMPORTANT_NOTE:[
          "Investors shall not hold HDFC Mutual fund/HDFC Asset management company limited, its  registrars and other service providers responsible if the transaction is delayed or not affected or if the invested bank account’s is debited in advance or after the specific SIP Date due to local holidays or any other reason.",
          "Please complete your SIP Registration from bank within 70 day from today. The SRN will be invalid if the registration on your bank’s website is not completed within the specified period.",
          "If the SIP Registration with your bank is completed by you, units created for your folio for the aforesaid SIP, If any will be reversed."
        ],
        SIP_INSTALLMENT_STEPS:[
          {
            stepNo:'01',
            description:'In order to complete the SIP Registration process, kindly login to your bank’s Netbanking facility and register for auto debit instructions of the SIP installment directly from the bank account.',
            imgUrl:'assets/images/icon1.png'
          },
          {
            stepNo:'02',
            description:'Go to Bill pay/Biller payments/Biller registration section. Select HDFC Mutual fund as a biller.',
            imgUrl:'assets/images/icon2.png'
          },
          {
          stepNo:'03',
          description:'Please input the SIP Registration number in the field requesting biller reference number on net banking facility.',
          imgUrl:'assets/images/icon3.png'
        },
          {
          stepNo:'04',
          description:'We recommend that you select an auto-payment plan.',
          imgUrl:'assets/images/icon4.png'
        }
        ],
        GOAL_VALUE_IN_MONTHS: [
          { goalName: 'Travel', goalCategory: 'TRAVEL', measurement: 'MONTHS', questionType: 'TIME'},
          { goalName: 'Emergency Corpus', goalCategory: 'EMERGENCY_CORPUS', measurement: 'MONTHS', questionType: 'EXPENSE_MONTHS'}
        ]
      },
      CART_DETAILS_SECTION: {
        CART_DETAILS: 'Cart Details',
        INVEST_THROUGH: 'Invest Through',
        ECART: 'E-Cart',
        ALL_FUNDS: 'All Funds'
      },
      ALL_FUNDS_FILTER: [
        {
          filterName: "Fund Category", filterKey: 'fundCategory', filterOptions: [
            {key: 'Diversified Equity', value: 'Diversified Equity', checked: false},
            {key: 'Index', value: 'Index', checked: false},
            {key: 'Thematic/Sectoral Equity', value: 'Thematic/Sectoral Equity', checked: false},
            {key: 'Equity Linked Savings Scheme (ELSS)', value: 'Equity Linked Savings Scheme (ELSS)', checked: false},
            {key: 'Hybrid', value: 'Hybrid', checked: false},
            {key: 'Solution Oriented', value: 'Solution Oriented', checked: false},
            {key: 'Theme Based Debt', value: 'Theme Based Debt', checked: false},
            {key: 'Duration Based Debt', value: 'Duration Based Debt', checked: false},
            {key: 'ETF', value: 'ETF', checked: false},
            {key: 'Fund of Funds', value: 'Fund of Funds', checked: false}
          ]
        }, {
          filterName: "Time Horizon", filterKey: 'timeHorizon', filterOptions: [
            {key: 'Short Term (1 year)', value: 'Short Term (1 year)', checked: false},
            {key: 'Medium Term ( 1-3 year)', value: 'Medium Term ( 1-3 year)', checked: false},
            {key: 'Long Term (3 year +)', value: 'Long Term (3 year +)', checked: false}
          ]
        }, {
          filterName: "Goals", filterKey: 'goals', filterOptions: [
            {key: 'Wealth Creation', value: 'Wealth Creation', checked: false},
            {key: 'Tax Saving', value: 'Tax Saving', checked: false},
            {key: 'Children’s Fund', value: 'Children’s Fund', checked: false},
            {key: 'Retirement Planning', value: 'Retirement Planning', checked: false},
            {key: 'Income Solutions', value: 'Income Solutions', checked: false}
          ]
        }, {
          filterName: "Risk Rating", filterKey: 'riskReturnProfile', filterOptions: [
            {key: 'Low', value: 'Low risk', checked: false},
            {key: 'Low to Moderate', value: 'Low to Moderate', checked: false},
            {key: 'Moderate', value: 'Moderate', checked: false},
            {key: 'Moderate to High', value: 'Moderately high', checked: false},
            {key: 'High', value: 'High Risk', checked: false},
            {key: 'Very High', value: 'Very High', checked: false}
          ]
        }
      ],
      ECART_CART_ITEM_NUMBER : ['First' , 'Second' , 'Third' , 'Forth' , 'Fifth'],
      IDCW_OPTIONS: [
        {key: 'Re-investment', value: "Y"},
        {key: 'Payout', value: "N"}
      ],
      DEEMAT_FOLIO_ERROR: 'Selected Folio is not available for Transaction.',
      FLEXSIP_NO_PAYMENT_MODE_ERROR : "OTM is mandatory to proceed with Flex SIP Transaction. There is no OTM in the Selected folio." ,
      FLEX_SIP_OTM_DOUBLE_AMOUNT_ERROR : "OTM limit should be twice the SIP amount to proceed with the transaction.",
      TAX_STATUS_CODES_FOR_ADDUPDATE : ['01', '11', '13', '21', '24'],
      TRANSACTION_CONST_LIST_TO_BLOCK : ['REDEMPTION','INSTANT_REDEMPTION', 'SWITCH', 'STP', 'SWP','SMART_SWAP','FLEX_INDEX'],
      DEFAULT_EMANDATE_MAX_YEAR : 99,
      UPDATE_KYC_ERROR: 'Unable to proceed with KYC modification request as per your KYC status.',
      EMANDATE_BASKET_ERROR : 'If the SIP end date extends beyond the mandate end date, the Register E-mandate payment option will not be accessible, in accordance with the latest NPCI circular stating that the mandate period should not exceed 30 years.',
      UPDATE_CONTACT_ERROR: 'You can update contact details only twice in a month.',
      UPDATE_CONTANCT_BOTH_MISSING: 'To proceed with Folio creation both contact details of investor are mandatory. Kindly update missing contact detail by getting in touch with our ISC or CAMS to update CKYC.',
      UPDATE_CONTACT_SINGLE_MISSING: 'Kindly add missing contact detail to proceed with folio creation.',
      HDFC_WITH_DIRECT_ARN:false,
      RISK_METER : [
        { key : "Low risk",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/Low.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/Low.png"
        },
        {
          key : "Low to Moderate Risk",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/Moderately+Low.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/Low-Moderate.png"
        },
        {
          key : "Moderate Risk",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/Moderate.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/Moderate.png"
        },
        {
          key : "Moderately High Risk",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/Moderately+High.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/Moderately-High.png"
        },
        {
          key : "High Risk",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/high.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/High.png"
        },
        {
          key : "Very High Risk",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/very+high.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/Very-High.png"
        }
      ],
      MINOR_FOLIO_WARNING: "Only Self Folio can be created",
      ON_HOLD_MESSAGE: "<p>Your KYC Status is 'On hold'. <a class='click-here-action' ng-click='Modal.submitEkycForm()'>Click here</a> to initiate modify KYC process to change KYC status to 'Validated'.</p>",
      NOT_VALIDATED_MESSAGE: "<p>Your KYC Status is 'Registered'. <a class='click-here-action' ng-click='Modal.submitEkycForm()'>Click here</a> to initiate update KYC process to change KYC status to 'Validated'.</p>",
      NO_HDFC_FOLIO_MESSAGE: "You do not have any folio in which HDFC bank is registered. Kindly create new folio to proceed.",
      TAX_STATUS_INDIVIDUAL: {
        RESIDENT_INDIVIDUAL: "Resident Individual ",
        NON_RESIDENT_INDIVIDUAL: "Non-Resident Individual",
        NRI_ON_MOBILE: "NRI"
      },
      TRANSACTION_FLOW : {NEW:'NEW',OLD:'OLD'},
      API_CONFIG : {
        COMMON : {child1: 'bank', child2: 'list'},
        OTM : {child1: 'folio', child2: 'otm'},
        EMANDATE : { child1: 'folio', child2: 'emandate'},
      },
      PAYMENT_OPTIONS_ENUM : {
        UPISIP :  'UPI_Autopay',
        UPI: 'UPI',
        OTM : 'OTM',
        NETBANKING: 'Net_Banking',
        RTGS: 'NEFT_RTGS',
        HDFC: 'HDFC_Fund_Transfer',
        EC: 'Biller',
        EMANDATE: 'E_Mandate'
      },
      PRE_LOGIN_JOURNEY_ENUM : {
        WHATSAPP : 'WHATSAPP',
        GATEWAY: 'API_GATEWAY'
      },
      UPI_TRANSACTION_STATUS: {
        PENDING: 'PENDING',
        WAITING: 'WAITING',
        EXPIRED: 'EXPIRED',
        SUCCESS: 'SUCCESS',
        FAILED: 'FAILED',
        CAPTURED: 'CAPTURED',
        ACTIVE: 'ACTIVE'
      },
      UPI_INTENT_LIST : [
        {
          key : 'PHONE_PE',
          iconUrl: '../../../../assets/images/icons/payment-journey/upi-icons/phone-pay.svg',
          name : 'Phone Pay',
        },
        {
          key: 'GOOGLE_PAY',
          iconUrl: '../../../../assets/images/icons/payment-journey/upi-icons/gpay.svg',
          name : 'Google Pay',
        },
        {
          key: 'PAYTM',
          iconUrl: '../../../../assets/images/icons/payment-journey/upi-icons/paytm.svg',
          name : 'Paytm',
        },
        {
          key: 'OTHERS',
          iconUrl: '../../../../assets/images/icons/payment-journey/upi-icons/others.svg',
          name : 'Others',
        }
      ],
      PAYMENT_METHODS_LIST: {
        NET_BANKING: 'Net Banking',
        UPI_Autopay :  'UPI Autopay',
        UPI: 'UPI',
        OTM : 'Existing Bank Mandate',
        NEFT_RTGS: 'NEFT/RTGS',
        HDFC_Fund_Transfer: 'HDFC Bank Transfer',
        EC: 'Biller',
        E_Mandate: 'Register e-Mandate'

      },
      STATEMENT_SCHEME_NOT_AVAILABLE: 'Scheme is not available under the selected folio.',
      OTP_WRONG_ATTEMPTS:3,
      CALCULATOR_LINK : 'learners-corner/calculator',
      LEARNER_CORNER_LINK : 'learners-corner',
      INVESTMENT_PERSONALITY_LINK : 'know-your-investment-personality',
      INVESTMENT_BASKET_LINK : 'product-solutions/investment-basket',
      PRE_DASH_BASKET_WIDGET: [
        {
          image:'https://files.hdfcfund.com/s3fs-public/2022-06/shutterstock_672298081_1-min.jpg',
          label:'Explore Investment Basket',
          description:'First time investor get familiar with the world of mutual funds. One of the best and safe investment instruments for achieving financial goals.',
          link:'learners-corner/beginner'
        },
        {
          image:'https://files.hdfcfund.com/s3fs-public/2022-06/shutterstock_94296382-min_0.jpg',
          label:'Know Your Investment Personality',
          description:'Suitable for users, who have started their investing journey but need to enhance their knowledge.',
          link:'learners-corner/intermediate'
        },
        {
          image:'https://files.hdfcfund.com/s3fs-public/2022-06/advanced_1.jpg',
          label:'Plan Your Goal',
          description:'Ideal for experienced investors looking to sharpen their investing skills with knowledge of advanced financial concepts.',
          link:'learners-corner/advanced'
        }
      ],
      GOAL_CARDS_LIST : [
        {
          goalName:'Emergency Corpus',
          imageUrl:'assets/images/preliminary-dashboard/goal1.svg',
          goalId: "3d2ba94c-996a-4b25-85da-031d62c7a64e"
        },
        {
          goalName:'Travel',
          imageUrl:'assets/images/preliminary-dashboard/goal2.svg',
          goalId: "52669b57-b1bc-46fc-a3c9-8945590836dc"
        },
        {
          goalName:'Children & Education',
          imageUrl:'assets/images/preliminary-dashboard/goal3.svg',
          goalId: "03258fc6-268e-41ed-85f0-03b23637503a"
        },
        {
          goalName:'My Nest (Home)',
          imageUrl:'assets/images/preliminary-dashboard/goal4.svg',
          goalId: "d6310685-a332-4507-bc68-3b1aa4800a11"
        },
        {
          goalName:'Retirement',
          imageUrl:'assets/images/preliminary-dashboard/goal5.svg',
          goalId: "5a6182b7-dc18-49cd-8580-f8f6c568c309"
        },
        {
          goalName:'Regular Income',
          imageUrl:'assets/images/preliminary-dashboard/goal6.svg',
          goalId: "d4d70b80-867a-4243-ade6-e77871a673d8"
        },
        {
          goalName:'Tax Planning',
          imageUrl:'assets/images/preliminary-dashboard/goal7.svg',
          goalId: "e6f9b0a9-9601-49e5-9051-aea9fd525ec0"
        },
        {
          goalName:'Wealth Creation',
          imageUrl:'assets/images/preliminary-dashboard/goal8.svg',
          goalId: "3c19802b-d09c-47e1-941b-bcfef21aa3da"
        }
      ],
      ENABLE_RISK_BASED_AUTHENTICATION:true
    });
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-investor-web')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);
    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 9000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }
})();

angular.module("hdfc-mf-investor-web").run(["$templateCache", function($templateCache) {$templateCache.put("app/arn-review/arn-review.html","<div class=arnMain ng-if=!PurchaseView><div class=row><div class=\"col-sm-6 col-md-6\"><div class=left-section style=\"margin: 10px 0px 0px 30px\"><a href=\"\" class=logo-main-web><img src=assets/images/hdfcmf-Main.svg alt=\"MF online investors\" class=\"logo-main-hdfcmf pull-left\" style=\"width: 100px\"></a></div></div></div><div class=row style=\"text-align: center;padding-top: 80px;padding-bottom: 20px\"><div class=\"col-sm-10 col-md-10\"><h5 style=\"margin-left: 18%;color: #0c4c87\"></h5></div></div><div style=\"display: flex;justify-content: center;align-items: center;width: 99%\"><div style=\"width: 80%\"><div class=topDetails><div ng-if=ArnReview.formData.distributorImage><img src={{ArnReview.formData.distributorImage}} alt=\"\" srcset=\"\" style=\"width: 180px; margin: 15px 0px 15px 10px\"></div><div style=font-size:18px class=distributor-name-main-div><p class=\"note p-10\" ng-if=ArnReview.formData.distributorName>{{ArnReview.formData.distributorName}}</p><p class=\"note p-10\" ng-if=ArnReview.formData.rianame>{{ArnReview.formData.rianame}}</p></div><div style=\"text-align: left;margin: 5px 50px 5px 5px; font-size:18px\" class=arn-no-main-div><p class=fs-10 ng-if=\"ArnReview.formData.arn && ArnReview.formData.arn != \'DIRECT\'\">ARN-{{ArnReview.formData.arn}}</p><p class=fs-10 ng-if=ArnReview.formData.riaCode>RIA-{{ArnReview.formData.riaCode}}</p><!-- <p class=\"fs-10\" ng-If=\"ArnReview.formData.empCode && !ArnReview.formData.arn\">Employee Code-{{ArnReview.formData.empCode}}</p> --><!-- <p class=\"fs-10 p-10\">EUIN -<b>{{ArnReview.formData.euin}}</b></p>\n          <p class=\"fs-10 p-10\">Employee Code -<b>{{ArnReview.formData.empCode}}</b></p> --><!-- <p class=\"fs-10\" ng-If=\"ArnReview.formData.distributorMail\">Email ID - {{ArnReview.formData.distributorMail}}</p>\n          <p class=\"fs-10\" ng-If=\"ArnReview.formData.distributorMobile\">Mobile Number - {{ArnReview.formData.distributorMobile}}</p> --></div></div><div class=secondDiv><div ui-view style=\"margin: 1%\"></div></div></div></div></div><div ng-class=arnMain2 ng-if=PurchaseView><div class=row style=\"box-shadow: 0px 2px 10px 0px #dad7d7\"><div class=\"col-sm-6 col-md-6\"><div class=left-section style=\"margin: 10px 0px 0px 30px\"><a href=\"\" class=logo-main-web><img src=assets/images/hdfcmf-Main.svg alt=\"MF online investors\" class=\"logo-main-hdfcmf pull-left\" style=\"width: 100px;margin-bottom: 12px\"></a></div></div><div ng-if=modifyLogin class=\"col-sm-6 col-md-6\" style=\"position: absolute;\n    right: 0px;\n    width: 300px; \n    padding: 10px\"><div ng-if=modifyLogin class=\"pull-right right-part\" style=\"position: absolute;\n      right: 0px; \n      padding: 10px\"><span class=server-clock my-current-time=ArnReview.format></span> <span class=sign-out ng-click=ArnReview.Logout() style=\"color: #004B8B;\n        font-family: Proxima Nova;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 24px;\n        letter-spacing: 0em;\n        text-align: left;\n        padding-left: 24px\">Logout <img src=assets/images/icons/arrow-right.png></span></div></div></div><div class=sHeadingDiv ng-if=showTitle><div style=\"width: 80%\"><p class=sHeading>Scheduled Transactions</p><p class=sSubHeading>You can see all your scheduled transactions here</p></div></div><div ui-view style=\"margin: 1%\"></div></div><style>.sHeadingDiv{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 99%;\n    margin-top: 30px;\n  } \n  .sHeading{\n    font-family: Proxima Nova;\n    font-size: 30px;\n    font-weight: 600;\n    line-height: 40px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #1397B6;\n  }\n  .sSubHeading{\n    font-family: Inter;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 29px;\n    letter-spacing: 0em;\n    text-align: left;\n  }\n  .leftDiv {\n    margin-top: 15%;\n  }\n  .arnMain {\n    width: 100vw;\n    background-image: url(\'../../assets/images/newinvestorbg2.png\');\n    background-position-y: bottom;\n    background-repeat: no-repeat;\n    background-size: inherit;\n    background-color: #f4fcff;\n    opacity: 0.9;\n    height: auto;\n  }\n  .arnMain2 {\n    width: 100vw; \n    background-position-y: bottom;\n    background-repeat: no-repeat;\n    background-size: inherit;\n    background-color: white !important;\n    opacity: 0.9;\n    height: auto;\n  }\n  .topDetails{\n    background-color: #0c4c87;\n    display: flex;\n    justify-content: space-between;\n    text-align: center;\n    align-items: center;\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    box-shadow: 0px 1px 6px 0px grey;\n    height:80px;\n  }\n.loading{\n  background-image: url(\"assets/images/loader_web.gif\");\n}\n  .p-10 {\n    padding: 10px;\n  }\n\n  .fs-10 {\n    color: white;\n    font-size: 18px;\n  }\n  .note {\n    font-weight: bolder;\n    color: white;\n    padding: 20px;\n  }\n\n  .secondDiv {\n    background-color: white;\n    border-bottom-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n    height: auto;\n    box-shadow: 0px 1px 6px 0px grey;\n    padding: 10px 10px 5px 10px;\n    margin-bottom: 30px;\n  }\n  @media (max-width: 500px) {\n    .topDetails{\n    justify-content: flex-start;\n    flex-direction: column;\n    text-align: left;\n    align-items: flex-start;\n  }\n  }</style>");
$templateCache.put("app/arn-review/thanks.html","<p style=\"text-align: center;\nposition: relative;\ntop: 45%;\nfont-size: 30px;\nfont-weight: bold\">You have successfully logged out. Thank you for using One Click Link Generation facility.</p><script>$(document).ready(function() {\n      window.history.pushState(null, \"\", window.location.href);        \n      window.onpopstate = function() {\n          window.history.pushState(null, \"\", window.location.href);\n      };\n  });</script>");
$templateCache.put("app/browser-update/browser-update.html","<div><header class=\"header header1 container-fluid\"><div class=\"row main-head\"><div class=col-md-12 style=\"padding-bottom: 10px\"><img src=assets/images/logo.png alt=HDFC class=\"logo pull-left\"></div></div></header><div class=update-browser><h1 class=heading ng-hide=\"(BrowserUpdate.browserNameUPC === BrowserUpdate.AppConstants.IE || BrowserUpdate.browserNameUPC === BrowserUpdate.AppConstants.UCBROWSER)\">This version of {{BrowserUpdate.browserName}} is not supported.</h1><div ng-show=\"(BrowserUpdate.browserNameUPC == BrowserUpdate.AppConstants.IE || BrowserUpdate.browserNameUPC == BrowserUpdate.AppConstants.UCBROWSER)\"><h1 class=heading>Your current browser {{BrowserUpdate.browserName}} does not support an optimal experience for MF Online Investors.</h1><h3 class=\"col-md-8 col-md-offset-2\" ng-if=\"(BrowserUpdate.browserNameUPC == BrowserUpdate.AppConstants.IE || BrowserUpdate.browserNameUPC == BrowserUpdate.AppConstants.UCBROWSER)\">Please use one of the following browsers instead.</h3><br><br><div class=\"col-md-6 col-md-offset-3\"><table class=\"table-bordered table\"><thead><tr><th class=text-center>Browser Name</th><th class=text-center>Link to download/update</th></tr></thead><tbody><tr><td>Google Chrome</td><td><a target=_blank href=https://www.google.co.in/chrome/ >Download</a></td></tr><tr><td>Mozilla Firefox</td><td><a target=_blank href=https://www.mozilla.org/en-US/firefox/new/ >Download</a></td></tr><tr><td>Microsoft Edge</td><td><a target=_blank href=https://www.microsoft.com/en-in/windows/microsoft-edge>Download</a></td></tr></tbody></table></div></div><ul class=\"list-group col-md-6 col-md-offset-3\"><li class=list-group-item ng-if=\"BrowserUpdate.browserNameUPC == BrowserUpdate.AppConstants.CHROME\"><a target=_blank href=\"https://support.google.com/chrome/answer/95414?co=GENIE.Platform%3DDesktop&hl=en\">Click here to update your Google Chrome.</a></li><li class=list-group-item ng-if=\"BrowserUpdate.browserNameUPC == BrowserUpdate.AppConstants.FIREFOX\"><a target=_blank href=https://support.mozilla.org/en-US/kb/update-firefox-latest-version>Click here to update your Mozilla Firefox.</a></li><li class=list-group-item ng-if=\"BrowserUpdate.browserNameUPC == BrowserUpdate.AppConstants.MS_EDGE\"><a target=_blank href=https://www.microsoft.com/en-in/windows/microsoft-edge>Click here to update your Microsoft Edge.</a></li></ul></div><div class=col-md-12 style=\"padding: 0\" ng-include=\"\'app/components/footer/footer-pre-login.html\'\"></div></div>");
$templateCache.put("app/createUserId/createUserId-landing.html","<div><!-- <div class=\"header-form-resp\">\n    <div class=\"back-to-login-header\"><a href=\"/\" style=\"color:#5290DB\" class=\"contrastDarkFont\">\n      <img src=\"assets/images/back-arrow-icon.svg\" class=\"arrowBackIcon resp-head-icon loginBckImg\"/> Back to login</a>\n    </div>\n  </div> --><div class=\"row side-nav-main-height margin-side row-no-gutters\"><!-- <div class=\"side-nav-container col-md-3\">\n      <div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\">\n        <div class=\"col-md-12 height100\">\n          <div class=\"side-nav-wrap\">\n            <hdfc-login-sidebar sidebar-click=\"Login.handleSideBarClick(message)\"></hdfc-login-sidebar>\n          </div>\n        </div>\n      </div>\n    </div> --><div class=\"col-xs-12 col-sm-12 widthContainer\" style=\"padding: 0px\"><br><login-header></login-header><br><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=\"forms-container row\" style=\"border-radius: 120px !important;\n      width: 90%;\n      margin: auto\"><div class=\"container-fluid global-login col-xs-12 login-userid\" style=\"padding: 0px\"><div ui-view></div></div></div></div><div class=\"new-carosal-web widthContainer\"><slide-image></slide-image></div></div><!-- <footer-login></footer-login> --></div><style>.forms-container{\n    margin-top: auto !important;\n  }\n  input{\n    border-radius: 100px !important;\n    height: 48px !important;\n  }\n  .wBtn:disabled {\n    opacity: 60% !important;\n  }\n  @media only screen and (max-width: 767px) {\n    .header-form-resp{\n    position: relative;\n    }\n    .login-userid {\n      margin-top: 2% !important;\n    }\n    .margin-side{\n      margin-left: 0px;\n      margin-right: 0px;\n    }\n  }\n  .contrastClass .form-existing-wrap{\n    background: #000 !important;\n  }\n  @media only screen and (max-width: 1024px){\n    .form-existing-wrap{\n      border-radius: 16px;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n    .forms-container{\n      margin-top: -30% !important;\n    }\n  }</style>");
$templateCache.put("app/dashboard/dashboard.html","<div class=\"dashboard main-section clearfix\" ng-init=Dashboard.init();><div class=\"loader dash-loader\" style=\"width:calc(100% - 72px) !important;position: absolute;top:90px;left:71px\"><span class=loading></span></div><div class=container-fluid><div class=row><div class=\"col-sm-12 col-md-6 column\"><div ng-repeat=\"data in Dashboard.distributorWidgetsListLeft\"><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.INVESTMENT\"><div ui-view=investmentWidgit></div></div><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.SCHEME_PERFORMANCE\"><div ui-view=schemePerformanceEvaluation></div></div><!--<div class=\"col-md-12\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.MARKETUPDATE\">\n              <div ui-view=\"marketUpdateWidgit\"></div>\n            </div>--><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.RECENTACTIVITY\"><div ui-view=recentActivityWidgit></div></div><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.TRANSACTIONSTATUS\"><div ui-view=transactionStatusWidgit></div></div><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.DIVIDENTUPDATE\"><div ui-view=dividentUpdateWidgit></div></div><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.QUICKLINK\"><div ui-view=quickLinkWidgit></div></div></div></div><div class=\"col-sm-12 col-md-6 column\"><div ng-repeat=\"data in Dashboard.distributorWidgetsListRight\"><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.INVESTMENT\"><div ui-view=investmentWidgit></div></div><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.SCHEME_PERFORMANCE\"><div ui-view=schemePerformanceEvaluation></div></div><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.MARKETUPDATE\"><div ui-view=marketUpdateWidgit></div></div><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.RECENTACTIVITY\"><div ui-view=recentActivityWidgit></div></div><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.TRANSACTIONSTATUS\"><div ui-view=transactionStatusWidgit></div></div><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.DIVIDENTUPDATE\"><div ui-view=dividentUpdateWidgit></div></div><div class=\"col-md-12 column\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.QUICKLINK\"><div ui-view=quickLinkWidgit></div></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/edit.dashboard.html","<div class=\"dashboard edit-dashboard main-section clearfix\" ng-init=Dashboard.init();><div class=\"loader edit\" style=\"display: none\"><span class=loading></span></div><div class=edit-overlay></div><div class=container-fluid><div class=\"form-content text-center\"><p style=\"margin-bottom: 10px\">Do you wish to save the widget reordering changes?</p><button class=\"btn btn-secondary-action\" ng-click=Dashboard.cancelDragEdit();>Cancel</button> <button class=\"btn btn-primary-action\" ng-disabled=!Dashboard.draggedPayload ng-click=Dashboard.applyDragEdit();>Apply</button></div><div class=row gridster=Dashboard.gridsterOpts style=\"padding: 0 20px 0 0\"><div gridster-item=data ng-repeat=\"data in Dashboard.distributorWidgetsList\"><!--<div gridster-dynamic-height item=\"data\">--><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.INVESTMENT\"><div ui-view=investmentWidgit></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.SCHEME_PERFORMANCE\"><div ui-view=schemePerformanceEvaluation></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.RECENTACTIVITY\"><div ui-view=recentActivityWidgit></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.TRANSACTIONSTATUS\"><div ui-view=transactionStatusWidgit></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.DIVIDENTUPDATE\"><div ui-view=dividentUpdateWidgit></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.QUICKLINK\"><div ui-view=quickLinkWidgit></div></div><!--</div>--></div></div><div ng-click=Dashboard.widgetSelection() class=order-dashcards><i class=edit-icon></i> Select Widgets</div></div></div>");
$templateCache.put("app/dashboard/todos.html","<div class=\"todos main-section clearfix\" ng-init=Todos.init();><div class=content-header><h3 class=page-title>To-Do\'s</h3><ul class=list-inline><li><a ui-sref=main.dashboard href=/dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>To-Do List</li></ul></div><div class=\"col-md-8 todos-card\"><div class=row><ul class=todo-list ng-if=Todos.birthdayList.length><li class=\"list-group-item group-head\"><p>Birthday Alerts</p></li><li class=list-group-item ng-repeat=\"pending in Todos.birthdayList | limitTo:Todos.birthdayQuantity\"><span class=checkbox><input type=checkbox ng-model=pending.done ng-change=Todos.checkBirthdayDoneItems(pending,$index);> <span class=icon-checkbox></span> </span><span ng-bind=pending.itemDescription></span><!--<span class=\"text-center\"><button class=\"btn btn-secondary-action\" ng-bind=\"pending.itemAction\"></button></span>--> <span class=text-center ng-bind=pending.itemAction ng-click=Todos.wishSomeone(pending)></span></li><li class=\"list-group-item group-bottom\" ng-if=\"Todos.birthdayCount>Todos.birthdayQuantity\"><p>More <i class=expand-icon ng-click=Todos.increaseBirthdayLimit();></i></p></li></ul><ul class=todo-list ng-if=Todos.pendingTransactionList.length><li class=\"list-group-item group-head\"><p>Pending Transaction</p></li><li class=list-group-item ng-repeat=\"pending in Todos.pendingTransactionList | limitTo:Todos.pendingQuantity\"><span class=checkbox><input type=checkbox ng-model=pending.done ng-change=\"Todos.checkPendingDoneItems(pending, $index);\"> <span class=icon-checkbox></span> </span><span ng-bind=pending.itemDescription></span><!--<span class=\"text-center\"><button class=\"btn btn-secondary-action\" ng-bind=\"pending.itemAction\"></button></span>--> <span class=text-center ng-click=Todos.sendReminder(pending.transactionId) ng-bind=pending.itemAction></span></li><li class=\"list-group-item group-bottom\" ng-if=\"Todos.pendingTransactionCount>Todos.pendingQuantity\"><p>More <i class=\"expand-icon cursor-pointer\" ng-click=Todos.increasePendingLimit();></i></p></li></ul><div class=if-error ng-if=\"Todos.birthdayCount == 0 && Todos.pendingTransactionCount == 0\"><i class=smile-icon></i><p>Yippee!!! You have no pending work items!!!</p></div></div></div><div class=col-md-4 ng-if=Todos.completedTodoList.length><div class=completed-tasks><div class=head>Completed Tasks</div><div class=task ng-repeat=\"completed in Todos.completedTodoList\"><p ng-bind=completed.itemDescription></p><p><span ng-if=Todos.completedArray.length>Completed on </span>{{completed.completedDate}}</p></div></div></div></div>");
$templateCache.put("app/deeplinks/deeplinks.html","<header class=\"header affix instant-header container-fluid new-folio-creation-header\"><div class=\"left-item pull-left flex-style\"><a href={{Deeplink.HDFC_API.WEBSITE_LINK}} target=_blank><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo></a></div></header><div ng-init=Deeplink.init() class=\"deeplink-container height100\"><section><div><span>Download the APP</span></div><div><div class=social-container-index><a href=\"https://play.google.com/store/apps/details?id=com.hdfcfund.investor&amp;hl=en_IN\" target=_blank><img src=assets/images/google-play.png class=gp-icon> </a><a href=https://apps.apple.com/in/app/hdfc-mf-online-investors/id1380088205 target=_blank><img src=assets/images/app-store.svg class=istore-icon></a></div></div></section></div><footer class=\"summary-footer main-footer deeplink-footer\"><div class=row><div class=\"col-md-12 pull-left flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <span>{{Investors.date | date:\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</span></div></div></footer><style>.deeplink-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 768px;\n    margin: auto;\n  }\n  .deeplink-container > section {\n    width: 100%;\n  }\n  .deeplink-container > section > div:first-of-type {\n    text-align: center;\n    font-size: 32px;\n    font-weight: 500;\n    font-family: Poppins;\n    line-height: 16px;\n    padding-bottom: 25px;\n  }\n  .deeplink-container > section > div > .social-container-index {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;;\n  }\n  .deeplink-container > section > div > .social-container-index > a {\n    width: 50%;\n    text-align: center;\n  }\n  .deeplink-container > section > div > .social-container-index > a > img {\n    width: 75%;\n  }\n  .deeplink-footer {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n  }</style>");
$templateCache.put("app/ekyc/ekyc.html","<login-header></login-header><div class=login-screen><section class=ekyc-wrapper><div class=container><div class=row><div class=col-12><h1 class=ekycHeading>eKYC using Aadhaar</h1><div class=ekycHeadingUnderline></div></div></div><div class=row><div class=col-12><div class=ekycText>Thank you for choosing HDFC Mutual Fund as your investment partner. Your KYC is not complete, please read below instructions to initiate eKYC process. You can now complete your KYC formalities online in a seamless and convenient manner using your Aadhaar.</div><div class=ekycMainSection><h4 class=\"ekycHeading headingItalic paddingOfFirstInstruction\">Instructions for completing eKYC using Aadhaar:</h4><ul class=\"instructionEKYC lineHeightInstruction\"><li>Enter Mobile number and Email ID and validate the same with One-time password (OTP) sent. At least one should be registered/seeded with your Aadhaar.</li><form autocomplete=off name=ekyc><div class=input-normal><input type=email style=\"margin-left: 46px ;width: 50%\" no-focus name=email ng-pattern=EKYCController.pattern.email_regex ng-model=EKYCController.payload.email maxlength=150 required> <span class=highlight></span> <span class=bar></span><label style=\"margin-left: 46px\">Email ID<span class=req>*</span></label><span ng-show=\"ekyc.email.$dirty && ekyc.email.$invalid\" style=\"margin-left: 46px\"><span class=error-input ng-show=ekyc.email.$error.required></span> <span class=error-input ng-show=ekyc.email.$error.pattern class=help-block ng-bind=EKYCController.validateData.EMAIL_FIELD></span></span></div><div class=input-normal><input type=tel style=\"margin-left: 46px ;width: 50%\" no-focus name=phone ng-pattern=EKYCController.pattern.mobile_regex_eKyc maxlength=10 ng-model=EKYCController.payload.mobile required ng-disabled=EKYCController.prefillMobile> <span class=highlight></span> <span class=bar></span><label style=\"margin-left: 46px\">Mobile Number<span class=req>*</span></label><span ng-show=\"ekyc.phone.$dirty && ekyc.phone.$invalid\" style=\"margin-left: 46px\"><span class=error-input ng-show=ekyc.phone.$error.pattern class=help-block ng-bind=EKYCController.validateData.MOBILE_FIELD></span></span></div></form><li>Enter PAN, validate with KRA system, validate Online with Income Tax database through NSDL.</li><li>Upload PAN card copy (for upload to CKYC).</li><li>Validate your Aadhaar using One-time Password(OTP) through UIDAI Website</li><li>eSign the completed KYC form with an OTP and upload to CAMS eKYC portal.</li></ul><p class=note-ekyc><span>NOTE:</span> On clicking \'Proceed\' button, you shall be redirected to an external application of CAMS Limited for completing your eKYC process.</p><p class=ekycFaqLinkOne><a href=https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/faq/EKYC+Step-by-step+Guide+for+HDFC+MF+Investors.pdf target=_blank>Click here</a> for step by step guide for completing eKYC using Aadhaar</p><p class=ekycFaqLink><a href=https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/faq/ekyc-faq.pdf target=_blank>Click here</a> for FAQs on eKYC using Aadhaar</p></div><div class=ekycButtonSection><button ng-disabled=\"!(EKYCController.payload.email && EKYCController.payload.mobile)\" ng-click=EKYCController.handleProceedAction() class=\"btn btn-primary-action\">Proceed</button></div></div></div></div></section><form autocomplete=off name=ekycForm id=ekycForm method=POST enctype=multipart/form-data action={{EKYCController.actionUrl}}><input id=url type=hidden name=url ng-value=EKYCController.formData.url> <input id=sess_id type=hidden name=sess_id ng-value=EKYCController.formData.sess_id> <input id=ekyctype type=hidden name=ekyctype ng-value=EKYCController.formData.ekyctype> <input id=Plkyc_type type=hidden name=Plkyc_type ng-value=EKYCController.formData.plkyc_type> <input id=kyc_data type=hidden name=kyc_data ng-value=EKYCController.formData.kyc_data></form></div><script>$(document).ready(function() {\n    window.history.pushState(null, \"\", window.location.href);\n    window.onpopstate = function() {\n        window.history.pushState(null, \"\", window.location.href);\n    };\n});</script>");
$templateCache.put("app/exposed-statements/authenticate.html","<login-header></login-header><div class=\"container-fluid login-screen global-login\"><div class=\"row flex-style\"><!--Left Section--><side-image-landing-page></side-image-landing-page><!--Right Section--><section class=\"col-xs-12 pull-right col-md-3 login-form authenticate-folio\"><form autocomplete=off name=loginForm ng-submit=ExposedStatements.validateOtp() novalidate><h3>Validate Folio Number</h3><div class=\"text-success text-center form-group\" ng-if=ExposedStatements.sentOtpRespMsg ng-bind=ExposedStatements.sentOtpRespMsg></div><div class=input-normal ng-class=\"{error:loginForm.userId.$dirty && loginForm.userId.$invalid}\"><input no-focus tabindex=1 name=userId ng-model=ExposedStatements.folioNumber type=text id=userId required> <span class=highlight></span> <span class=bar></span><label>Folio Number</label><span ng-show=\"loginForm.userId.$dirty && loginForm.userId.$invalid\"><span class=error-input ng-show=loginForm.userId.$error.required ng-bind=Login.validateData.USER_ID_REQUIRED></span> <span class=error-input ng-show=\"loginForm.userId.$error.pattern && loginForm.userId.$invalid\" class=help-block>{{ Login.validateData.USERNAME_PATTERN }}</span></span></div><div ng-if=ExposedStatements.authenticateUsingOtpFlag><div class=input-normal ng-if=ExposedStatements.showOtpField ng-class=\"{error:loginForm.password.$dirty && loginForm.password.$invalid}\"><input id=otpId type=text ng-model=ExposedStatements.otp required minlength=6 maxlength=6 name=otpNumber autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=forgot><a href=\"\" ng-click=ExposedStatements.reGenerateOtp() class=forgot-pwd>Resend OTP</a></span><label>Enter OTP</label><span ng-show=\"loginForm.password.$dirty && loginForm.password.$invalid\"><span class=error-input ng-show=loginForm.password.$error.required ng-bind=ExposedStatements.validateData.OTP_REQUIRED></span></span></div></div><input id=submitLogin1 tabindex=3 type=button ng-disabled=\"loginForm.$invalid || ExposedStatements.loginProcessFlag\" ng-if=\"ExposedStatements.showOtpField === false\" class=\"btn btn-primary-action btn-block btn-login\" ng-click=ExposedStatements.generateOtp() value=\"Send OTP\"> <input id=submitLogin tabindex=3 type=submit ng-if=ExposedStatements.loginUsingOtpFlag ng-disabled=\"ExposedStatements.loginForm.$invalid || !ExposedStatements.showOtpField\" class=\"btn btn-primary-action btn-block btn-login\" value=\"Validate OTP\"> <input type=hidden id=hiddenEle></form></section></div></div><div ng-include=\"\'app/components/footer/footer-pre-login.html\'\"></div>");
$templateCache.put("app/faq/faq.html","<login-header></login-header><div class=login-screen><div dynamic=Faq.faqData></div></div><style>.mb10{padding-bottom: 5px;display: inline-block;margin-top: 10px;}\n  .btn-position-align{float:right; margin-top:-69px;color: #efefef !important; width:80px; padding: 10px}\n  .btn-position-align:hover{color: #efefef !important; text-decoration: none !important;}\n  @media only screen and (max-width: 768px) {\n    .visit-link {\n      display : block;\n    }\n\n    .faq-wrapper {\n      padding: 20px 5px !important;\n    }\n\n    .faq-wrapper.main-section .faq-wrap > li div:first-child span:first-child {\n      margin-right: 10px;\n    }\n\n    .faq-wrapper.main-section .faq-list li span:first-child {\n      margin-right: 10px;\n    }\n\n    .faq-wrapper.main-section .faq-wrap > li div {\n      padding-left: 32px;\n    }\n\n    .faq-wrapper.main-section .faq-wrap > li ul {\n      padding-left: 48px;\n    }\n\n    .v-link {\n      text-align: left !important;\n      word-spacing: 4px;\n    }\n\n    .two-factor th {\n      padding: 6px !important;\n    }\n\n    .set-padding {\n      padding-left: 18px !important;\n    }\n}</style>");
$templateCache.put("app/feedback/feedback.html","<div class=\"main-section feedback\"><div class=content-area><div class=content-head><h3>Investor Feedback</h3><p>Please leave your valuable feedback about our website and help us in becoming better.</p></div><div class=content-body><form autocomplete=off name=feedbackForm novalidate ng-submit=Feedback.submitFeedback()><div class=row><div class=col-md-1><strong>Subject&nbsp;: </strong></div><div class=col-md-11><div class=feedback-radio><input type=radio checked name=feedback ng-model=Feedback.formData.feedback id=improvement ng-change=Feedback.changeFeedback() value=IMPROVEMENT><label for=improvement>Suggestions</label></div><div class=feedback-radio><input type=radio name=feedback ng-model=Feedback.formData.feedback id=newFeature ng-change=Feedback.changeFeedback() value=NEW_FEATURE><label for=newFeature>Queries</label></div><div class=feedback-radio><input type=radio name=feedback ng-model=Feedback.formData.feedback id=others ng-change=Feedback.changeFeedback() value=OTHERS><label for=others>Others</label></div></div></div><div class=row><div class=col-md-1><strong>Message&nbsp;: </strong></div><div class=col-md-11><textarea ng-model=Feedback.formData.feedbackArea placeholder=\"Please type your message here...\" maxlength=300 ng-change=Feedback.formInputChange()></textarea><p class=error-input ng-if=\"Feedback.formData.feedbackArea && Feedback.isInValid\" style=\"padding: 10px 0px\" ng-bind=Feedback.constant.FEEDBACK_FORM_ERR0R></p><span class=limits>Remaining characters {{300-(Feedback.formData.feedbackArea.length)}}</span><p><button type=submit class=\"btn btn-primary-action\" ng-disabled=\"!Feedback.formData.feedbackArea || (Feedback.formData.feedbackArea && Feedback.isInValid)\">Submit</button></p></div></div></form></div></div></div>");
$templateCache.put("app/globalSearch/search-result.html","<div class=\"search-results main-section clearfix\" ng-init=GlobalSearch.init()><p class=search-count>Total {{GlobalSearch.count}} Search Results</p><div class=row><div class=col-md-12><div class=result-head><h5><strong>Investors</strong></h5></div><div class=result-body><div class=result-block ng-repeat=\"result in GlobalSearch.searchResult\"><p class=text-blue><span ng-click=GlobalSearch.investorDetails(result)>{{result.name}}</span></p><table class=\"table borderless\"><tr><td>Email:</td><td>{{result.email}}</td></tr><tr><td>Mobile:</td><td>{{result.mobileNumber}}</td></tr><tr><td>PAN:</td><td>{{result.panNumber}}</td></tr></table></div><div class=\"text-center no-record\" ng-if=\"!(GlobalSearch.count >0) && !GlobalSearch.isLoading\">No Record found</div></div><div ng-if=GlobalSearch.isPagination><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"GlobalSearch.count <= GlobalSearch.PAGE_LIMITS[0]\" ng-bind=GlobalSearch.count></span><select ng-if=\"GlobalSearch.count > GlobalSearch.PAGE_LIMITS[0]\" ng-change=GlobalSearch.limitChanged() ng-model=GlobalSearch.selectedPageLimit ng-options=\"_limit as _limit for _limit in GlobalSearch.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black ng-bind=GlobalSearch.count></span></div><ul uib-pagination total-items=GlobalSearch.count ng-model=GlobalSearch.currentPage max-size=5 items-per-page=GlobalSearch.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=GlobalSearch.init() rotate=false></ul></div></div></div></div>");
$templateCache.put("app/home/home.html","<!--\n<div ng-init=\"Home.init()\">\n  <div class=\"main-loader\">\n    &lt;!&ndash;<img ng-show=\"Home.isLoading\" src=\"assets/images/please_wait.gif\">&ndash;&gt;\n\n    <div class=\"loader-box\">\n      <div class=\"loader-box-content\">\n        <img src=\"../assets/images/logo-main.png\" alt=\"HDFC\">\n        <img src=\"../assets/images/logo.png\" alt=\"Partner\'s Logo\">\n\n        <h3>Welcome {{Home.investorProfile?Home.investorProfile.distributorName:\'Distributor\'}}!</h3>\n\n        <p>Please wait while we fetch your details.</p>\n\n        &lt;!&ndash;<span class=\"outbar\">&ndash;&gt;\n          &lt;!&ndash;<span class=\"progress-bar innerbar progress-bar-striped active\" role=\"progressbar\">&ndash;&gt;\n\n          &lt;!&ndash;</span>&ndash;&gt;\n        &lt;!&ndash;</span>&ndash;&gt;\n        <img src=\"../assets/images/loader_web.gif\" alt=\"loader\" class=\"loader-gif\" />\n      </div>\n    </div>\n  </div>\n</div>\n-->");
$templateCache.put("app/instant-investment/home.html","<header class=\"header affix instant-header container-fluid\"><div class=\"left-item pull-left flex-style\" ng-if=!HomeInstant.arnHardcodedData><img src=assets/images/logo.png alt=HDFC class=logo></div><div class=\"pull-right right-part\"><span class=server-clock my-current-time=HomeInstant.format></span> <span class=\"faq cursor-pointer\" ng-if=!HomeInstant.arnHardcodedData><a href=javaScript:void(0) ui-sref=faq>FAQ</a> </span><span class=sign-out ng-click=HomeInstant.logoutMe();>Logout</span></div></header><section class=\"main-section instant-invest initiate-transaction sipPurchase\"><div class=page-head><p>Make Investment for:</p><p ng-bind=HomeInstant.investorName>Aakash Sharma</p></div><div ui-view></div></section><div ng-if=!HomeInstant.arnHardcodedData ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div>");
$templateCache.put("app/instant-investment/instant-investment.html","<div class=content-area ng-init=InstantInvest.init(); ng-hide=\"InstantInvest.formData.isSummaryViewEnabled || InstantInvest.showSwitchSuccess\"><form name=InstantInvest.tForm novalidate autocomplete=off><div class=col-md-12><div class=\"row borderline\"><div class=\"col-md-12 row\"><table class=\"table borderless top-part\"><tr><td>Investment Type</td><td>:</td><td><div class=radio-block ng-if=\"InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.transactionType == \'Purchase_Scheduler\'\"><span class=radio><input type=radio id=Scheduled_Purchase name=investmentType ng-model=InstantInvest.formData.investmentType ng-click=InstantInvest.changeInvestmentType(InstantInvest.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction) ng-value=InstantInvest.TRANSACTIONS_CONST.TRANSACTION_TYPE.Schedule_Transaction> <span class=check></span><!--ng-disabled=\"!fForm.$valid\"--> </span><span class=radio-label>Schedule Transaction</span></div><div class=radio-block ng-if=\"!(InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.transactionType == \'Purchase_Scheduler\')\" ng-class=\"{\'anything-disabled\': (InstantInvest.arnHardcodedData && InstantInvest.SIPCAMP) || (InstantInvest.arnHardcodedData && InstantInvest.HDFCCAMP) || (InstantInvest.arnHardcodedData && InstantInvest.purchaseDisabled)}\"><span class=radio><input type=radio id=purchase name=investmentType ng-model=InstantInvest.formData.investmentType ng-click=InstantInvest.changeInvestmentType(InstantInvest.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) ng-value=InstantInvest.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE> <span class=check></span><!--ng-disabled=\"!fForm.$valid\"--> </span><span class=radio-label>Purchase</span></div><div class=radio-block ng-if=\"!(InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.transactionType == \'Purchase_Scheduler\')\" ng-class=\"{\'anything-disabled\': (InstantInvest.arnHardcodedData && InstantInvest.PURCHASECAMP) || (InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.transactionType == \'PURCHASE_SCHEDULER\') || (InstantInvest.arnHardcodedData && InstantInvest.sipDisabled)}\"><span class=radio><input type=radio id=sip name=investmentType ng-model=InstantInvest.formData.investmentType ng-click=InstantInvest.changeInvestmentType(InstantInvest.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) ng-value=InstantInvest.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP> <span class=check></span><!--ng-disabled=\"!fForm.$valid\"--> </span><span class=radio-label>SIP</span></div><!-- Switch Transaction --><div class=radio-block ng-if=\"!(InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.transactionType == \'Purchase_Scheduler\')\" ng-class=\"{\'anything-disabled\': InstantInvest.arnHardcodedData && ((InstantInvest.PURCHASECAMP || InstantInvest.SIPCAMP) || InstantInvest.HDFCCAMP) || (InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.transactionType == \'PURCHASE_SCHEDULER\') || (InstantInvest.arnHardcodedData && InstantInvest.switchDisabled)}\"><span class=radio><input type=radio id=switch name=investmentType ng-model=InstantInvest.formData.investmentType ng-click=\"InstantInvest.changeInvestmentType(\'SWITCH\')\" ng-value=InstantInvest.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH> <span class=check></span><!--ng-disabled=\"!fForm.$valid\"--></span> <span class=radio-label>Switch</span></div><!-- Switch Transaction --><!-- redemption Transaction --><div class=radio-block ng-if=\"!(InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.transactionType == \'Purchase_Scheduler\')\" ng-class=\"{\'anything-disabled\': (InstantInvest.arnHardcodedData && InstantInvest.SIPCAMP) || (InstantInvest.arnHardcodedData && InstantInvest.HDFCCAMP) || (InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.SCHEMEWISECAMP)}\"><span class=radio><input type=radio id=redemption name=investmentType ng-model=InstantInvest.formData.investmentType ng-click=\"InstantInvest.changeInvestmentType(\'REDEMPTION\')\" ng-value=InstantInvest.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION> <span class=check></span><!--ng-disabled=\"!fForm.$valid\"--></span> <span class=radio-label>Redemption</span></div><!-- redemption Transaction --></td></tr><tr ng-if=!InstantInvest.localData.key ng-hide=\"InstantInvest.formData.investmentType == \'REDEMPTION\' && !InstantInvest.arnHardcodedData\"><td>Invest through</td><td>:</td><td ng-class=\"{\'anything-disabled\': InstantInvest.localData}\"><div class=radio-block ng-if=InstantInvest.showInvestThrough><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=InstantInvest.formData.isDirect ng-click=\"InstantInvest.changeThroughDistributor(\'DIRECT\')\"><!--ng-disabled=\"!fForm.$valid\"--> <span class=check></span> </span><span class=radio-label>Direct</span></div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=InstantInvest.formData.isThroughDistributor ng-click=\"InstantInvest.changeThroughDistributor(\'ARN\')\"><!--ng-disabled=\"!fForm.$valid\"--> <span class=check></span> </span><span class=radio-label>Distributor</span></div><div class=radio-block ng-if=InstantInvest.showInvestThrough><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=InstantInvest.formData.isThroughRia ng-click=\"InstantInvest.changeThroughDistributor(\'RIA\')\"><!--ng-disabled=\"!fForm.$valid\"--> <span class=check></span> </span><span class=radio-label>RIA</span></div></td></tr><tr ng-if=InstantInvest.formData.isThroughDistributor><td></td><td></td><td ng-class=\"{\'anything-disabled\': InstantInvest.localData}\"><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class=\"{error:(InstantInvest.tForm.brokerCode.$dirty&&InstantInvest.tForm.brokerCode.$invalid)||(InstantInvest.brokerCodeError != \'\')}\"><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=InstantInvest.formData.brokerCode ng-change=InstantInvest.changeDistributorCode() autocomplete=off ng-blur=\"InstantInvest.searchDistributor();InstantInvest.showArnLabel=false;\" ng-required=!InstantInvest.formData.distributorARN ng-focus=\"InstantInvest.showArnLabel=true\"> <span class=highlight></span> <span class=bar></span> <span class=arn ng-show=\"InstantInvest.showArnLabel || InstantInvest.formData.brokerCode\">ARN -</span><label>ARN</label><p ng-if=InstantInvest.formData.brokerName class=info-primary>Distributor Name: {{InstantInvest.formData.brokerName}}</p><span class=error-input ng-show=\"(InstantInvest.tForm.brokerCode.$dirty && InstantInvest.tForm.brokerCode.$invalid &&InstantInvest.tForm.brokerCode.$error.required) && (!InstantInvest.formData.distributorName)\" ng-bind=InstantInvest.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"InstantInvest.brokerCodeError !== \'\' && !InstantInvest.tForm.brokerCode.$invalid\" ng-bind=InstantInvest.brokerCodeError></span></div></div><span class=\"col-sm-12 col-md-1 or-part text-center\">OR</span><div class=\"col-sm-12 col-md-3\"><div class=\"input-select input-normal\" ng-class=\"{error:InstantInvest.tForm.distributorName.$dirty && InstantInvest.tForm.distributorName.$invalid}\"><!--<input type=\"text\" name=\"inScheme\" id=\"inScheme\"\n                                 ng-change=\"InstantInvest.filterInSchemeList()\"\n                                 ng-model=\"InstantInvest.formData.inSchemeName\"\n                                 autocomplete=\"off\" required>--> <input type=text name=distributorName id=distributorName ng-change=\"InstantInvest.searchDistributorByName();InstantInvest.formData.isEuin=true\" ng-model=InstantInvest.formData.distributorName autocomplete=off ng-required=!InstantInvest.formData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><label>Search Distributor</label><drop-down list-data=InstantInvest.distributorList display-key=name display-key-second=arnCode hdfc-click=InstantInvest.distributorListChanged(data) model=InstantInvest.formData.distributorARN for=distributorName></drop-down><!--<p class=\"info-primary\">ARN - 348787</p>--></div></div></td></tr><!--RIA sections--><tr ng-if=InstantInvest.formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-class=\"{\'anything-disabled\': InstantInvest.localData}\"><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class=\"{error:(InstantInvest.tForm.brokerCode.$dirty && InstantInvest.tForm.brokerCode.$invalid)||(InstantInvest.brokerCodeError != \'\')}\"><input type=text name=riaCode id=riaCode ng-model=InstantInvest.formData.brokerCode ng-change=InstantInvest.changeDistributorCode() autocomplete=off ng-blur=\"InstantInvest.searchDistributor(); InstantInvest.showRiaLabel=false\" ng-required=!InstantInvest.formData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span><!--<p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name: {{Transaction.formData.brokerName}}</p>--> <span class=error-input ng-show=\"(InstantInvest.tForm.riaCode.$dirty && InstantInvest.tForm.riaCode.$invalid &&InstantInvest.tForm.riaCode.$error.required)\" ng-bind=InstantInvest.VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(InstantInvest.tForm.riaCode.$dirty && InstantInvest.tForm.riaCode.$invalid &&InstantInvest.tForm.riaCode.$error.pattern)\" ng-bind=InstantInvest.VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"InstantInvest.riaCodeError !== \'\' && !InstantInvest.tForm.riaCode.$invalid\" ng-bind=InstantInvest.riaCodeError></span></div></div></td></tr><!--RIA sections ends here--></table><fieldset><table class=\"table borderless top-part\"><tr ng-if=InstantInvest.formData.isThroughDistributor><td></td><td></td><td ng-class=\"{\'anything-disabled\': InstantInvest.isArnSuccess || InstantInvest.brokerCodeError !==\'\' || InstantInvest.localData}\"><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class=\"{error:(InstantInvest.tForm.subBrokerARN.$dirty&&InstantInvest.tForm.subBrokerARN.$invalid)||(InstantInvest.subBrokerCodeError !== \'\')}\"><!--<input type=\"text\" name=\"brokerCode\" id=\"brokerCode\"\n                                 ng-model=\"InstantInvest.formData.brokerCode\"\n                                 ng-change=\"InstantInvest.formData.brokerName=\'\'\"\n                                 autocomplete=\"off\" ng-blur=\"InstantInvest.searchDistributor()\"\n                                 required>--> <input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=InstantInvest.formData.subBrokerARN ng-change=InstantInvest.changeSubBrokerArn() ng-blur=InstantInvest.fetchEuinListSubBroker() autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>Sub Broker ARN</label><p ng-if=InstantInvest.subBrokerName class=info-primary>Sub Broker Name: {{InstantInvest.subBrokerName}}</p><span class=error-input ng-show=\"InstantInvest.subBrokerCodeError != \'\'\" ng-bind=InstantInvest.subBrokerCodeError></span></div></div><span class=\"col-sm-12 col-md-1\"></span><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class={error:InstantInvest.tForm.subBrokerCode.$dirty&&InstantInvest.tForm.subBrokerCode.$invalid}><!--<input type=\"text\" name=\"brokerCode\" id=\"brokerCode\"\n                                 ng-model=\"InstantInvest.formData.brokerCode\"\n                                 ng-change=\"InstantInvest.formData.brokerName=\'\'\"\n                                 autocomplete=\"off\" ng-blur=\"InstantInvest.searchDistributor()\"\n                                 required>--> <input type=text name=subBrokerCode id=subBrokerCode ng-model=InstantInvest.formData.subBrokerCode autocomplete=off ng-disabled=\"!InstantInvest.formData.subBrokerARN || InstantInvest.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<!-- <span class=\"req text-red\" ng-if=\"InstantInvest.formData.subBrokerARN\">*</span> --></label><span class=error-input ng-show=InstantInvest.tForm.subBrokerCode.$dirty&&InstantInvest.tForm.subBrokerCode.$error.required ng-bind=InstantInvest.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></td></tr><tr ng-if=InstantInvest.formData.isThroughDistributor><td></td><td></td><td ng-class=\"{\'anything-disabled\':InstantInvest.euinDesable && !(InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.modifyEuinEnabled)}\"><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=true ng-model=InstantInvest.formData.isEuin ng-click=\"InstantInvest.isCheckedTandC=false\" required> <span class=check></span> </span><span class=radio-label>EUIN</span></div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=false ng-model=InstantInvest.formData.isEuin ng-click=\"InstantInvest.euinData.euinNameCode=\'\';InstantInvest.filterEuinList();InstantInvest.isSelectedEuin=true;\"> <span class=check></span> </span><span class=radio-label>EUIN Declaration</span></div></td></tr><tr ng-if=\"InstantInvest.formData.isEuin != null && InstantInvest.formData.isEuin === false && InstantInvest.formData.isThroughDistributor\"><td></td><td></td><td ng-class=\"{\'anything-disabled\':InstantInvest.euinDesable && !(InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.modifyEuinEnabled)}\"><div class=checkbox ng-show=InstantInvest.euinDeclaration><input ng-model=InstantInvest.isCheckedTandC type=checkbox ng-disabled=InstantInvest.formData.isEuin ng-required=\"(InstantInvest.formData.brokerCode || !InstantInvest.isArnSuccess) && !InstantInvest.formData.isEuin\"> <i class=icon-checkbox></i><ng-bind-html ng-bind-html=InstantInvest.euinDeclaration></ng-bind-html></div></td></tr><tr ng-if=\"InstantInvest.formData.isEuin != null && InstantInvest.formData.isEuin === true &&  InstantInvest.formData.isThroughDistributor\"><td></td><td></td><td ng-class=\"{\'anything-disabled\':InstantInvest.euinDesable && !(InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.modifyEuinEnabled)}\"><!-- <div class=\"input-select input-normal selectfield\" ng-class=\"{error:InstantInvest.tForm.euin.$dirty&&InstantInvest.tForm.euin.$invalid}\">\n                       <input type=\"text\" name=\"euin\" id=\"euin\"\n                                 ng-model=\"InstantInvest.euinData.euinNameCode\"\n                                 ng-change=\"InstantInvest.filterEuinList()\"\n                                 ng-required=\"(InstantInvest.formData.brokerCode || InstantInvest.formData.distributorName) && !InstantInvest.isCheckedTandC\"\n                                 autocomplete=\"off\">\n                           <span class=\"highlight\"></span>\n                           <span class=\"bar\"></span>\n                           <label>Select Euin</label> --><!--ng-disabled=\"!InstantInvest.euinList.length || InstantInvest.isArnSuccess || (InstantInvest.formData.subBrokerARN && InstantInvest.isSubarnSuccess)\"--><!-- <span class=\"error-input\" ng-show=\"InstantInvest.tForm.euin.$dirty&&InstantInvest.tForm.euin.$error.required || !InstantInvest.isSelectedEuin\"\n                     ng-bind=\"InstantInvest.VALIDATE_DATA.EUIN_REQUIRED\"></span>\n                       <list-drop-down list-data=\"InstantInvest.euinList\"\n                                       display-key=\"euinName\"\n                                       display-key-second=\"euinCode\"\n                                       hdfc-click=\"InstantInvest.selectEuin(data)\"\n                                       model=\"InstantInvest.formData.euin\"\n                                       for=\"euin\">\n                       </list-drop-down>\n                     </div> --><div class=\"dropdown input-select input-normal selectfield\"><input type=text class=euinInputBox ng-model=InstantInvest.euinData.euinNameCode ng-click=InstantInvest.myFunction($event) name=euin id=euin onkeyup=filterFunction() ng-required=\"(InstantInvest.formData.brokerCode || InstantInvest.formData.distributorName) && !InstantInvest.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Select Euin</label><span class=error-input ng-show=\"InstantInvest.tForm.euin.$dirty&&InstantInvest.tForm.euin.$error.required || !InstantInvest.isSelectedEuin\" ng-bind=InstantInvest.VALIDATE_DATA.EUIN_REQUIRED></span><div id=myDropdown class=dropdown-content><a ng-repeat=\"euin in InstantInvest.euinList track by $index\" ng-click=\"InstantInvest.selectEuin(euin) \" style=\"text-transform: uppercase;font-size: 14px !important;color: #3f3c3c !important;cursor: pointer\">{{euin.euinNameCode}}</a></div></div></td></tr><!-- For HDFC One Click EUIN Declaration is activated --><tr ng-if=\"InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.isHdfcBank && InstantInvest.formData && InstantInvest.formData.isThroughDistributor && !InstantInvest.formData.isEuin\"><td></td><td></td><td ng-class=\"{\'anything-disabled\':InstantInvest.euinDesable && !(InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.modifyEuinEnabled)}\"><div class=checkbox><input ng-model=hdfcTnc type=checkbox name=hdfcTnc1 id=hdfcTnc2 required> <i class=icon-checkbox></i><ng-bind-html ng-bind-html=InstantInvest.hdfcOneClickDisclaimerNote></ng-bind-html></div></td></tr></table><fieldset ng-class=\"{\'anything-disabled\': !InstantInvest.formData.brokerCode || InstantInvest.riaCodeError !== \'\'}\" ng-show=InstantInvest.riaDeclaration><table class=\"table borderless top-part\"><tr ng-if=InstantInvest.formData.isThroughRia><td><div class=checkbox><input ng-model=InstantInvest.isCheckedTandC type=checkbox ng-disabled=\"!InstantInvest.formData.brokerCode || InstantInvest.riaCodeError !== \'\'\" ng-required=InstantInvest.formData.brokerCode> <i class=icon-checkbox></i><ng-bind-html style=\"margin-top: -10px\" ng-bind-html=InstantInvest.riaDeclaration></ng-bind-html></div></td></tr></table></fieldset></fieldset></div></div><div data-ng-switch=InstantInvest.formData.investmentType><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/instant-investment/purchase/purchase.html\'\"></div></div><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/instant-investment/sip/sip.html\'\"></div></div><div data-ng-switch-when=SWITCH><div data-ng-include=\"\'app/instant-investment/switch/switch.html\'\"></div></div><!-- Schedule Transaction --><div data-ng-switch-when=Schedule_Transaction><div data-ng-include=\"\'app/instant-investment/schedule_purchase/schedule_purchase.html\'\"></div></div><div data-ng-switch-when=REDEMPTION><div data-ng-include=\"\'app/instant-investment/redemption/redemption.html\'\"></div></div></div><div class=row ng-if=false><div class=add-button ng-if=!InstantInvest.formData.optionalInvestmentType ng-click=fForm.$valid&&InstantInvest.addOptionalTransaction()><i class=expand-block-icon></i> Add {{InstantInvest.formData.investmentType===InstantInvest.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE?\'Sip\':\'Lumpsum\'}} Transaction (Optional)</div><div class=add-button ng-if=InstantInvest.formData.optionalInvestmentType ng-click=InstantInvest.removeOptionalScheme()><i class=collapse-block-icon></i> Remove {{InstantInvest.formData.investmentType===InstantInvest.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE?\'Sip\':\'Lumpsum\'}} Transaction (Optional)</div></div><div data-ng-switch=InstantInvest.formData.optionalInvestmentType><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/transactions/initiate/sip-purchase/purchase/purchase.html\'\"></div></div><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/transactions/initiate/sip-purchase/sip/sip.html\'\"></div></div></div></div><div class=form-footer><!--<button type=\"button\"\n              ui-sref=\"instantLoginHome.review\" class=\" btn btn-primary-action\">Review\n      </button>--> <button type=button ng-if=\"InstantInvest.formData.investmentType==\'PURCHASE\'\" ng-disabled=\"!InstantInvest.tForm.$valid || !InstantInvest.helper.isFormValid() || !InstantInvest.formData.purchaseInSchemeCode || ((InstantInvest.formData.brokerCode || InstantInvest.formData.distributorARN) && InstantInvest.isArnSuccess) || (InstantInvest.formData.subBrokerARN && InstantInvest.isSubarnSuccess) || (InstantInvest.isPurchaseAmountDecimal) || !InstantInvest.isSelectedEuin || InstantInvest.purchaseValidations.purchaseMultiple && !InstantInvest.isMultiples\" ng-click=InstantInvest.goToSummary() class=\"btn btn-primary-action\">Review</button> <button type=button ng-if=\"InstantInvest.formData.investmentType==\'Schedule_Transaction\' && !InstantInvest.HDFC_WITH_DIRECT_ARN\" ng-disabled=\"!InstantInvest.tForm.$valid || ( InstantInvest.formData.sipPaymentOption == \'OTM\' && InstantInvest.OtmAmountMax ) || (InstantInvest.formData.sipPaymentOption == \'OTM\' && InstantInvest.isOTMEndDate || InstantInvest.amountErrorEmandate) || !InstantInvest.formData.purchaseInSchemeCode || InstantInvest.maxAmount || InstantInvest.isPurchaseMin || !InstantInvest.formData.startDate || !InstantInvest.formData.endDate || ((InstantInvest.formData.brokerCode || InstantInvest.formData.distributorARN) && InstantInvest.isArnSuccess) || (InstantInvest.formData.subBrokerARN && InstantInvest.isSubarnSuccess) || (InstantInvest.isPurchaseAmountDecimal) || !InstantInvest.isSelectedEuin || InstantInvest.purchaseValidations.purchaseMultiple && !InstantInvest.isMultiples || \n              (InstantInvest.formData.sipPaymentOption ==  \'E-mandate\'&& ( InstantInvest.amountEMgMore || InstantInvest.amountMore || InstantInvest.amountLess || InstantInvest.errorEmandate || InstantInvest.amountErrorEmandate) )\" ng-click=InstantInvest.goToSummary() class=\"btn btn-primary-action\">Review</button> <button type=button ng-if=\"InstantInvest.formData.investmentType==\'Schedule_Transaction\' && InstantInvest.HDFC_WITH_DIRECT_ARN\" ng-disabled=\"!InstantInvest.tForm.$valid || ( InstantInvest.formData.sipPaymentOption == \'OTM\' && InstantInvest.OtmAmountMax ) || (InstantInvest.formData.sipPaymentOption == \'OTM\' && InstantInvest.isOTMEndDate || InstantInvest.amountErrorEmandate) || !InstantInvest.formData.purchaseInSchemeCode || InstantInvest.maxAmount || InstantInvest.isPurchaseMin || !InstantInvest.formData.startDate || !InstantInvest.formData.endDate\n                || (InstantInvest.isPurchaseAmountDecimal) || !InstantInvest.isSelectedEuin || InstantInvest.purchaseValidations.purchaseMultiple && !InstantInvest.isMultiples || \n              (InstantInvest.formData.sipPaymentOption ==  \'E-mandate\'&& ( InstantInvest.amountEMgMore || InstantInvest.amountMore || InstantInvest.amountLess || InstantInvest.errorEmandate || InstantInvest.amountErrorEmandate) )\" ng-click=InstantInvest.goToSummary() class=\"btn btn-primary-action\">Review</button> <button type=button ng-if=\"InstantInvest.formData.investmentType==\'SIP\' && InstantInvest.formData.sipPaymentOption!==\'E-mandate\'\" ng-disabled=\"!InstantInvest.tForm.$valid ||  !InstantInvest.formData.inSchemeCode || InstantInvest.isInvalidForm || !InstantInvest.helper.isFormValid()  || !InstantInvest.formData.startDate || !InstantInvest.formData.endDate || ((InstantInvest.formData.brokerCode || InstantInvest.formData.distributorARN) && InstantInvest.isArnSuccess) || (InstantInvest.formData.subBrokerARN && InstantInvest.isSubarnSuccess) || (InstantInvest.formData.bankInfo.otmFrequency != null && InstantInvest.formData.bankInfo.otmFrequency != \'AWP\'\n                              && InstantInvest.formData.frequency === \'BZ\') || (!InstantInvest.formData.bankInfo.minorBankFlag && InstantInvest.checkForMinorBankListCondition()) || !InstantInvest.isSelectedEuin || !InstantInvest.isMultiples || InstantInvest.amountExceeded || (InstantInvest.formData.sipPaymentOption==\'UPI\' && !InstantInvest.formData.isUPIVerified)\" ng-click=InstantInvest.goToSummary() class=\"btn btn-primary-action\">Review</button> <button type=button ng-if=\"InstantInvest.formData.investmentType==\'SIP\' && InstantInvest.formData.sipPaymentOption ===\'E-mandate\'\" ng-disabled=\"!InstantInvest.tForm.$valid || !InstantInvest.formData.inSchemeCode || InstantInvest.isInvalidForm || !InstantInvest.formData.startDate || !InstantInvest.formData.endDate || ((InstantInvest.formData.brokerCode || InstantInvest.formData.distributorARN) && InstantInvest.isArnSuccess) || (InstantInvest.formData.subBrokerARN && InstantInvest.isSubarnSuccess) ||\n               (InstantInvest.formData.bankInfo.otmFrequency != null && InstantInvest.formData.bankInfo.otmFrequency != \'AWP\' && InstantInvest.formData.frequency === \'BZ\') || (!Transaction.formData.bankInfo.minorBankFlag && Transaction.checkForMinorBankListCondition()) || !InstantInvest.isMultiples || InstantInvest.amountExceeded || InstantInvest.isMax  || InstantInvest.amountLess || InstantInvest.amountMore || InstantInvest.isLessThanSipAmount || InstantInvest.sipDateLessEmandate\" ng-click=InstantInvest.goToSummary() class=\"btn btn-primary-action\">Review</button> <button type=button ng-if=\"InstantInvest.formData.investmentType==\'SWITCH\'\" ng-disabled=\"!InstantInvest.tForm.$valid ||InstantInvest.isInvalidForm || !InstantInvest.inSchemeCode || ((InstantInvest.formData.brokerCode || InstantInvest.formData.distributorARN) && InstantInvest.isArnSuccess) || (InstantInvest.formData.subBrokerARN && InstantInvest.isSubarnSuccess) || !InstantInvest.isSelectedEuin || !InstantInvest.outSchemeCode\" ng-click=InstantInvest.showReviewSummary() class=\"btn btn-primary-action\">Proceed to Transact</button> <button type=button ng-if=\"InstantInvest.formData.investmentType==\'REDEMPTION\'\" ng-disabled=\"(!InstantInvest.tForm.$valid || InstantInvest.isInvalidForm) ||((InstantInvest.formData.brokerCode || InstantInvest.formData.distributorARN) && InstantInvest.isArnSuccess) || (InstantInvest.formData.subBrokerARN && InstantInvest.isSubarnSuccess) || !InstantInvest.isSelectedEuin || !InstantInvest.outSchemeName || (InstantInvest.amountType==InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS && InstantInvest.isMin) || (InstantInvest.amountType==InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS && InstantInvest.isMax) || (InstantInvest.amountType==InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && InstantInvest.isMin)|| (InstantInvest.amountType==InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && InstantInvest.isMax)|| (InstantInvest.amountType==InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && !InstantInvest.isMultiples)|| (InstantInvest.amountType==InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && (InstantInvest.unitsDetails.freeValueAmount < InstantInvest.outSchemeValidations.minRedemptionAmt))|| (InstantInvest.amountType==InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS && (InstantInvest.unitsDetails.freeValueUnits < InstantInvest.outSchemeValidations.minRedemptionUnit))\" ng-click=InstantInvest.redemSummary() class=\"btn btn-primary-action\">Proceed to Transact</button><!--ng-disabled=\"!InstantInvest.tForm.$valid || !InstantInvest.helper.isFormValid()\"--><!--ng-disabled=\"!InstantInvest.helper.isFormValid()\"--><!-- ng-click=\"InstantInvest.goToSummary()\"  ng-disabled=\"!InstantInvest.helper.isFormValid()\"--></div></form></div><!-- Switch Preview --><div ng-if=\"InstantInvest.showSwitchPreview && !InstantInvest.showSwitchSuccess\"><div data-ng-include=\"\'app/instant-investment/switch/summary.switch.html\'\"></div></div><!-- Switch Preview --><!-- Switch success page --><div ng-if=InstantInvest.showSwitchSuccess><div data-ng-include=\"\'app/instant-investment/switch/switch.success.html\'\"></div></div><!-- Switch success page --><!-- Redeem Preview --><div ng-if=\"InstantInvest.showRedeemPreview && !InstantInvest.showRedeemSuccess\"><div data-ng-include=\"\'app/instant-investment/redemption/summary.redeem.html\'\"></div></div><!-- Redeem Preview --><!-- Redeem success page --><div ng-if=InstantInvest.showRedeemSuccess><div data-ng-include=\"\'app/instant-investment/redemption/redeem.success.html\'\"></div></div><!-- Redeem success page --><!-- Purchase sccheduler Preview start--><div ng-if=\"InstantInvest.showPurchaseSchedulerSuccess && !InstantInvest.showTransactionSuccessfulPage\"><div data-ng-include=\"\'app/instant-investment/schedule_purchase/summary.schedulepurchase.html\'\"></div></div><!-- Purchase sccheduler Preview end--><div ng-if=\"InstantInvest.formData.isSummaryViewEnabled && !InstantInvest.showSwitchSuccess && !InstantInvest.showPurchaseSchedulerSuccess\" ng-hide=\"InstantInvest.showSwitchPreview || InstantInvest.showSwitchSuccess || InstantInvest.showRedeemPreview || InstantInvest.showRedeemSuccess\"><sip-purchase-insta-summary form-data=InstantInvest.summaryData is-summary-view-enabled=InstantInvest.formData.isSummaryViewEnabled transaction-type={{InstantInvest.transactionType}} notes=InstantInvest.noteSummaryQuickInvestment></sip-purchase-insta-summary></div><!-- Purchase Schduler Success page --><div ng-if=\"InstantInvest.showPurchaseSchedulerSuccess && InstantInvest.showTransactionSuccessfulPage\"><div data-ng-include=\"\'app/instant-investment/schedule_purchase/response_purchase.html\'\"></div></div><style>.dropdown {\n    width: 94%;\n    padding: 0px;\n    border-bottom: 1 px solid black;\n    position: relative;\n    display: inline-block;\n  }\n\n  .dropdown-content {\n    display: none;\n    position: absolute;\n    background-color: #ffff;\n    min-width: 230px;\n    max-height: 300px;\n    overflow: auto;\n    border: 1px solid #ddd;\n    z-index: 10;\n  }\n\n  .dropdown-content a {\n    color: black;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n  }\n\n  .dropdown a:hover {\n      cursor: pointer;\n      background: #f5f5f5;\n      color: #166bb9;\n    }\n\n  .hdfcCheckBoxNote{\n    left: 20px;\n    width: 96%;\n    float: right;\n    line-height: 20px;\n    font-weight: bold;\n  }</style><script>function filterFunction() {\n    var input, filter, ul, li, a, i;\n    input = document.getElementById(\"euin\");\n    filter = input.value.toUpperCase();\n    div = document.getElementById(\"myDropdown\");\n    a = div.getElementsByTagName(\"a\");\n    for (i = 0; i < a.length; i++) {\n      txtValue = a[i].textContent || a[i].innerText;\n      if (txtValue.toUpperCase().indexOf(filter) > -1) {\n        a[i].style.display = \"\";\n      } else {\n        a[i].style.display = \"none\";\n      }\n    }\n  }</script>");
$templateCache.put("app/instant-investment/paymentInfo.html","<div class=content-area><div class=imp-info><strong>Important:</strong><p><i class=dot></i> <span>You now have 10 min to complete the transaction and return to this page. If you exceed this time, you may not get a transaction confirmation number. In such a scenario, please contact your ISC immediately. (Please Click here to view list.) If a new window has not opened, please check again if your pop-up blockers are disabled by following the below steps. Go to Tools. Select popup blocker. Disable/ turn off pop-up blockers and try again.</span></p><p><i class=dot></i> <span>If a new window has not opened, please check again if your pop-up blockers are disabled by following the below steps. Go to Tools. Select popup blocker. Disable/ turn off pop-up blockers and try again.</span></p></div><div class=text-center><button class=\"btn-primary-action btn-small\">Make New Investment</button></div></div>");
$templateCache.put("app/instant-investment/review.html","<div class=\"content-area clearfix instant-review\" ng-init=Summary.init()><div class=col-md-6><table ng-if=\"Summary.transactionType == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\" class=\"table borderless\"><tr ng-if=Summary.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=Summary.formData.isThroughDistributor>{{Summary.formData.brokerCode?\'ARN-\'+Summary.formData.brokerCode:(Summary.formData.distributorARN?Summary.formData.distributorARN:\'\')}}</td><td ng-if=!Summary.formData.isThroughDistributor>N/A</td></tr><tr ng-if=Summary.formData.subBrokerARN><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+Summary.formData.subBrokerARN}}</td></tr><tr ng-if=Summary.formData.subBrokerCode><td>Sub Broker Code</td><td>:</td><td>{{Summary.formData.subBrokerCode}}</td></tr><tr ng-if=\"Summary.formData.euin && Summary.formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{Summary.formData.euin.euinCode}}</td></tr><tr ng-if=\"Summary.formData.euin && Summary.formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{Summary.formData.euin.euinName}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Summary.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.transactionType}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Summary.formData.purchaseInSchemeName}}</td></tr><tr ng-if=\"Summary.formData.purchaseInvestmentOption===Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>IDCW Option</td><td>:</td><td><span ng-if=\"Summary.formData.purchaseInvestmentOption===Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.purchaseDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.purchaseAmount}}</td></tr></table><table ng-if=\"Summary.transactionType == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\" class=\"table borderless\"><tr ng-if=Summary.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=Summary.formData.isThroughDistributor>{{Summary.formData.brokerCode?\'ARN-\'+Summary.formData.brokerCode:(Summary.formData.distributorARN?Summary.formData.distributorARN:\'\')}}</td><td ng-if=!Summary.formData.isThroughDistributor>N/A</td></tr><tr ng-if=Summary.formData.subBrokerARN><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+Summary.formData.subBrokerARN}}</td></tr><tr ng-if=Summary.formData.subBrokerCode><td>Sub Broker Code</td><td>:</td><td>{{Summary.formData.subBrokerCode}}</td></tr><tr ng-if=\"Summary.formData.euin && Summary.formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{Summary.formData.euin.euinCode}}</td></tr><tr ng-if=\"Summary.formData.euin && Summary.formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{Summary.formData.euin.euinName}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Summary.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.transactionType}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Summary.formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{Summary.formData.investmentOption | camelcase}}</td></tr><tr ng-if=\"Summary.formData.investmentOption===Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Dividend Option</td><td>:</td><td><span ng-if=\"Summary.formData.investmentOption===Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.sipDividendOption] | camelcase}}</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.amount}}</td></tr><tr><td>Installment Frequency</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Summary.formData.frequency]}}</td></tr><tr><td>Start Date</td><td>:</td><td>{{Summary.formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>End Date</td><td>:</td><td>{{Summary.formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"Summary.formData.sipPaymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"Summary.formData.sipPaymentOption ==\'OTM\'\">OTM (One Time Mandate)</td><td ng-if=\"Summary.formData.sipPaymentOption == \'E- mandate\'\">E-Mandate</td></tr><tr><td>Bank Name</td><td>:</td><td>{{Summary.formData.bankInfo.bankName}}</td></tr><tr ng-if=\"(Summary.formData.bankInfo.bankName==\'HDFC BANK\' && Summary.formData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{Summary.formData.bankAcNo}}</td></tr><tr ng-if=\"Summary.formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{Summary.formData.bankInfo.omUmrn}}</td></tr></table></div><div class=tc-block><div><h6>Terms & Conditions</h6><div class=checkbox><input ng-model=Summary.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=Summary.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=\"col-md-12 form-footer\"><div><a href=\"\" ng-click=Summary.goToBack() class=\"cursor-pointer text-primary pull-left\"><i class=arrow-blue-back-icon></i>Back</a> <button ng-disabled=!Summary.isCheckedTandC||!Summary.formData ng-click=Summary.submitForm() class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div>");
$templateCache.put("app/instant-investment/sip-purchase.html","<div class=\"main-section clearfix\"><section class=\"initiate-transaction sipPurchase\" ng-init=Transaction.init()><p class=page-title>INVEST</p><header><form name=fForm novalidate ng-keypress=Transaction.handleEnter($event) autocomplete=off><div class=\"folio-check pull-left\">Proceed With Existing Folio No:<select name=folio ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" ng-init=\"Transaction.formData.folioNumber = Transaction.formData.folioNumber ? Transaction.formData.folioNumber : null\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Folio</option></select><span class=req>*</span></div><div class=\"pull-left or-part\">OR</div><div class=\"pull-left text-primary\">Proceed with a New Folio</div></form></header><fieldset ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\"><div class=content-area><form name=Transaction.tForm novalidate autocomplete=off><div class=col-md-12><div class=\"row borderline\"><div class=\"col-md-5 row\"><table class=\"table borderless\"><tr><td>Investment Type</td><td>:</td><td><div class=radio-block><span class=radio><input type=radio id=purchase name=investmentType ng-model=Transaction.formData.investmentType ng-disabled=!fForm.$valid ng-click=Transaction.changeInvestmentType() ng-value=Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE> <span class=check></span> </span><span class=radio-label>Lumpsum</span></div><div class=radio-block><span class=radio><input type=radio id=sip name=investmentType ng-model=Transaction.formData.investmentType ng-disabled=!fForm.$valid ng-click=Transaction.changeInvestmentType() ng-value=Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP> <span class=check></span> </span><span class=radio-label>SIP</span></div></td></tr><tr><td>Investor Name</td><td>:</td><td>{{Transaction.investorName}}</td></tr><tr><td>Invest through Distributor</td><td>:</td><td><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isThroughDistributor ng-disabled=!fForm.$valid ng-change=Transaction.changeThroughDistributor(true)> <span class=check></span> </span><span class=radio-label>Yes</span></div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=false ng-model=Transaction.formData.isThroughDistributor ng-disabled=!fForm.$valid ng-change=Transaction.changeThroughDistributor(false)> <span class=check></span> </span><span class=radio-label>No</span></div></td></tr><tr ng-if=Transaction.formData.isThroughDistributor><td></td><td></td><td><div class=col-md-3><div class=input-normal ng-class={error:Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid}><input type=text minlength=4 class=arn-no name=brokerCode id=brokerCode onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=Transaction.formData.brokerCode ng-change=\"Transaction.formData.brokerName=\'\'\" autocomplete=off ng-blur=Transaction.searchDistributor() required> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>ARN</label><p class=info-primary>Distributor Name</p><span class=error-input ng-show=Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$error.required ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid && Transaction.tForm.brokerCode.$error.minlength\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span></div></div><span class=\"col-md-1 or-part text-center\">OR</span><div class=col-md-3><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid}\"><input type=text name=inScheme id=inScheme ng-change=Transaction.filterInSchemeList() ng-model=Transaction.formData.inSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Search Distributor</label><p class=info-primary>ARN - 348787</p><span class=error-input ng-show=\"Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid && Transaction.tForm.inScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.inSchemeList display-key=scheme hdfc-click=Transaction.inSchemeChanged(data) model=Transaction.formData.inSchemeCode for=inScheme></drop-down><p class=info-primary>{{Transaction.formData.inSchemeName}}</p></div></div></td></tr><tr ng-if=Transaction.formData.isThroughDistributor><td></td><td></td><td><div class=col-md-3><div class=input-normal ng-class={error:Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid}><input type=text name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=\"Transaction.formData.brokerName=\'\'\" autocomplete=off ng-blur=Transaction.searchDistributor() required> <span class=highlight></span> <span class=bar></span><label>Sub Broker ARN</label><span class=error-input ng-show=Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$error.required ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span></div></div><span class=col-md-1></span><div class=col-md-3><div class=input-normal ng-class={error:Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid}><input type=text name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=\"Transaction.formData.brokerName=\'\'\" autocomplete=off ng-blur=Transaction.searchDistributor() required> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code</label><span class=error-input ng-show=Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$error.required ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span></div></div></td></tr><tr ng-if=Transaction.formData.isThroughDistributor><td></td><td></td><td><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=true ng-model=Transaction.formData.isEuin ng-click=Transaction.changeThroughDistributor(Transaction.formData.isThroughDistributor) required> <span class=check></span> </span><span class=radio-label>EUIN</span></div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=false ng-model=Transaction.formData.isEuin ng-click=Transaction.changeThroughDistributor(Transaction.formData.isThroughDistributor)> <span class=check></span> </span><span class=radio-label>EUIN Declaration</span></div></td></tr><tr ng-if=\"!Transaction.formData.isEuin && Transaction.formData.isThroughDistributor\"><td></td><td></td><td><div class=checkbox><input ng-model=Transaction.isCheckedTandC type=checkbox ng-disabled=Transaction.formData.isEuin ng-required=!Transaction.formData.isEuin> <i class=icon-checkbox></i> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></div></td></tr><tr ng-if=\"Transaction.formData.isEuin &&  Transaction.formData.isThroughDistributor\"><td></td><td></td><td><div class=selectfield ng-class={error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}><label ng-if=Transaction.formData.euin>Select EUIN {{(Transaction.formData.brokerCode && Transaction.formData.isEuin) || Transaction.formData.isEuin ? \"\" : \"(Optional)\" }}</label><select name=euin id=euin ng-model=Transaction.formData.euin ng-options=\"_euin as (_euin.euinName+\' - \'+_euin.euinCode) for _euin in Transaction.euinList track by _euin.euinCode\" ng-init=\"Transaction.formData.euin = Transaction.formData.euin ? Transaction.formData.euin :null\" required autocomplete=off><option value=\"\" selected>Select EUIN {{(Transaction.formData.brokerCode && Transaction.formData.isEuin) || Transaction.formData.isEuin ? \"\" : \"(Optional)\" }}</option></select><span class=error-input ng-show=\"Transaction.tForm.euin.$dirty && Transaction.tForm.euin.$error.required\" ng-bind=Transaction.VALIDATE_DATA.EUIN_REQUIRED></span></div></td></tr></table></div></div><div data-ng-switch=Transaction.formData.investmentType><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/transactions/initiate/sip-purchase/purchase/purchase.html\'\"></div></div><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/transactions/initiate/sip-purchase/sip/sip.html\'\"></div></div></div><div class=row ng-if=false><div class=add-button ng-if=!Transaction.formData.optionalInvestmentType ng-click=fForm.$valid&&Transaction.addOptionalTransaction()><i class=expand-block-icon></i> Add {{Transaction.formData.investmentType===Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE?\'Sip\':\'Lumpsum\'}} Transaction (Optional)</div><div class=add-button ng-if=Transaction.formData.optionalInvestmentType ng-click=Transaction.removeOptionalScheme()><i class=collapse-block-icon></i> Remove {{Transaction.formData.investmentType===Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE?\'Sip\':\'Lumpsum\'}} Transaction (Optional)</div></div><div data-ng-switch=Transaction.formData.optionalInvestmentType><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/transactions/initiate/sip-purchase/purchase/purchase.html\'\"></div></div><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/transactions/initiate/sip-purchase/sip/sip.html\'\"></div></div></div></div><div class=\"form-footer row\"><button class=\"btn btn-secondary-action\" type=button ng-click=Transaction.saveForm()>Save for Later</button> <button type=button ng-disabled=!Transaction.helper.isFormValid() ng-click=Transaction.goToSummary() class=\"btn btn-primary-action\">Proceed to Transact</button></div></form></div></fieldset></section></div>");
$templateCache.put("app/investment-baskets/investment.html","<section class=\"main-section clearfix investment-basket\"><h3 class=screen-title>{{Investment.screenTitle}}</h3><div class=content-area><div class=row><div class=col-md-12><div ui-view></div></div></div></div></section>");
$templateCache.put("app/investor-profile-userid/investor-profile-userid.html","<div class=new-investors><new-investor-header></new-investor-header><div ng-attr-class=\"{{testObj.steps[2].stepCompleted ? \'progress-nav-containerTwo row\' : \'progress-nav-containerTwo row\'}}\"><div class=\"progressBar col-xs-12 col-sm-4 col-md-3 newInvestorSideBarCss\" ng-if=cUrl><hdfc-login-sidebar sidebar-click=handleSideBarClick(message)></hdfc-login-sidebar></div><div class=\"col-xs-12 col-md-9 col-sm-12 container-responsive\"><div class=payment style=\"margin-left: 20px\" ng-init=InvestorProfile.init()><br><br><div class=main style=\"width: 85vw;box-shadow: -1px 1px 5px 1px lightgrey\"><div class=row><!-- ng-If=\"InvestorProfile.ModeOfHold == \'SINGLE\' || InvestorProfile.ModeOfHold == \'\' || InvestorProfile.holdmode == \'SINGLE\'\" --><div class=\"note col-sm-12 col-md-12\" style=\"margin: auto;margin-bottom: 50px;margin-left: 25px\"><img src=../../../assets/images/congratulation.png alt=\"\" style=\"height: 50px; margin-top: 5px\"><p style=\"font-weight: 600;\n                color: #000000;\n                text-align: center;\n                line-height: 20px;\n                letter-spacing: 0px;\n                padding: 5px\"><!-- You have successfully made your investments with HDFC MF</p> --><!-- <p class=\"headnotes\"> --> Take a step further towards consolidated Dashboard, Multiple Statements/Reports, Online Bank<br>Mandate Registration & more such online services by creating a User ID.</p></div><div class=\"col-xs-12 col-md-12\" style=\"margin-bottom: 35px\"><div class=row><div class=\"col-sm-12 col-md-6\" style=\"display: flex;justify-content: center;align-items: center\"><img src=../../../assets/images/BannerProfileImage.jpg alt=\"\"></div><div class=\"col-sm-12 col-md-6\"><form class=profileform name=userForm id=userForm style=\"width: 70%;margin-top: 10px;margin-left: 10%\" ng-submit=InvestorProfile.registerNewUser()><div class=row><div class=\"col-xs-12 col-md-12\"><p class=profileTitle>User ID</p></div><div class=\"col-xs-12 col-md-12\"><input class=\"form-control profileInput\" type=text name=userName id=userName minlength=6 maxlength=38 ng-change=InvestorProfile.resetData() ng-model=InvestorProfile.userName autofocus required autocomplete=off ng-pattern=InvestorProfile.appConstants.userId_regex ng-blur=InvestorProfile.checkAvailability() easyassist-key=mask-element> <span class=showPassword style=\"position: absolute;top:10px;right: 35px\"><img src=../../../assets/images/new-investor/pencil.png alt=\"\" srcset=\"\"> </span><span ng-if=InvestorProfile.availableMessage>{{InvestorProfile.availableMessage}}</span> <span class=error-input ng-show=\"userForm.userName.$dirty && userForm.userName.$invalid\"><span ng-show=userForm.userName.$error.required ng-bind=InvestorProfile.validateData.USER_ID_REQUIRED></span> <span ng-show=userForm.userName.$error.minlength>{{ InvestorProfile.validateData.USER_ID_FIELD}}</span> <span ng-show=userForm.userName.$error.pattern>{{ InvestorProfile.validateData.USER_ID_FIELD_PATTERN}}</span> <span ng-show=InvestorProfile.availableMessage>{{ InvestorProfile.availableMessage}}</span></span></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><p class=profileTitle>Password</p></div><div class=\"col-xs-12 col-md-12\"><input class=\"form-control profileInput\" ng-attr-type=\"{{ InvestorProfile.showPassword ? \'text\' : \'password\' }}\" id=newuserPassword name=newuserPassword ng-model=InvestorProfile.mainPassword ng-minlength=8 ng-maxlength=15 ng-pattern=\"/^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[$_!@])[A-Za-z\\d$@!_]{8,15}$/\" required> <span class=showPassword ng-click=InvestorProfile.togglePassword() style=\"position: absolute;top:10px;right: 35px\"><img ng-src=\"{{ InvestorProfile.showPassword ? \'../../../assets/images/showpassword.svg\' : \'../../../assets/images/blind-1.svg\'}}\" alt=\"\" srcset=\"\"></span><br><div class=row ng-if=userForm.newuserPassword.$dirty style=\"margin-left: 2px\"><div class=col><span ng-if=userForm.newuserPassword.$error.required style=\"color: red;margin-left: 0px\">Password required!</span></div><!-- check pattern --><div class=row ng-if=!userForm.newuserPassword.$error.required><div class=\"col-xs-12 col-md-6 flex-start\"><img class=passicon ng-src=\"{{userForm.newuserPassword.$error.minlength || userForm.newuserPassword.$error.maxlength ? \'../../../assets/images/nav-tick2.png\' : \'../../../assets/images/icons/nav-tick.png\'}}\"><p class=fs-13>Between 8 and 15 characters</p></div><div class=\"col-xs-12 col-md-6 flex-start\"><img class=passicon ng-src=\"{{userForm.newuserPassword.$error.pattern ? \'../../../assets/images/nav-tick2.png\' : \'../../../assets/images/icons/nav-tick.png\'}}\"><p class=fs-13>A number</p></div><div class=\"col-xs-12 col-md-6 flex-start\"><img class=passicon ng-src=\"{{userForm.newuserPassword.$error.pattern ? \'../../../assets/images/nav-tick2.png\' : \'../../../assets/images/icons/nav-tick.png\'}}\"><p class=fs-13>An uppercase character</p></div><div class=\"col-xs-12 col-md-6 flex-start\"><img class=passicon ng-src=\"{{userForm.newuserPassword.$error.pattern ? \'../../../assets/images/nav-tick2.png\' : \'../../../assets/images/icons/nav-tick.png\'}}\"><p class=fs-13>An lowercase character</p></div><div class=\"col-xs-12 col-md-6 flex-start\"><img class=passicon ng-src=\"{{userForm.newuserPassword.$error.pattern ? \'../../../assets/images/nav-tick2.png\' : \'../../../assets/images/icons/nav-tick.png\'}}\"><p class=fs-13>Special characters($@!_)</p></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><p class=profileTitle>Confirm Password</p></div><div class=\"col-xs-12 col-md-12\"><input class=\"form-control profileInput\" ng-attr-type=\"{{ InvestorProfile.showConfirmPassword ? \'text\' : \'password\' }}\" name=confirmPassword id=confirmPassword ng-model=InvestorProfile.Cpassword ng-pattern=InvestorProfile.mainPassword ng-change=InvestorProfile.matchPassword() required> <span class=showPassword ng-click=InvestorProfile.toggleConfirmPassword() style=\"position: absolute;top:10px;right: 35px\"><img ng-src=\"{{ InvestorProfile.showConfirmPassword ? \'../../../assets/images/showpassword.svg\' : \'../../../assets/images/blind-1.svg\'}}\" alt=\"\" srcset=\"\"> </span><!-- <span class=\"error-input\" ng-show=\"userForm.confirmPassword.$error.pattern\">Password does not match above</span> --> <span></span></div></div><br><span ng-if=\"!InvestorProfile.passwordMatchSuccess && userForm.confirmPassword.$dirty\" style=\"color: red\">Password does not match above</span><br><div class=row ng-if=!InvestorProfile.showOtPWindow><div class=\"col-xs-12 col-md-12\"><button type=submit class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-disabled=\"!InvestorProfile.passwordMatchSuccess ||\n                                    !InvestorProfile.Cpassword ||\n                                    !InvestorProfile.mainPassword ||\n                                    !InvestorProfile.userName\">CREATE USER ID</button></div></div></form></div></div></div></div></div></div></div></div></div><footer-login></footer-login><style>.newInvestorSideBarCss{\n    padding-top: 80px;\n  }\n  @media only screen and (max-width: 767px) {\n    .newInvestorSideBarCss{\n      padding-top: 0px;\n      display: none;\n    }\n  }\n  .profileInput{\n    height: 40px;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border: 1px solid #B8C6D1;\n    border-radius: 5px;\n    opacity: 1;\n  }\n  .headnotes{\n    text-align: center;\n    font-size: 14px;\n    padding: 5px 5px 10px 5px;\n  }</style>");
$templateCache.put("app/kyc/kyc.html","<div class=mainContainer id=mainEkyc><!-- header --><div><div class=header-blue id=top><div class=resp-container><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 logo-l\"><div class=iphone-mockup><img class=device src=assets/images/logo2.jpg></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 logo-r\"><div class=iphone-mockup><img class=device src=assets/images/logo.jpg></div></div></div></div><div class=\"resp-container hero\"><div class=row><div class=\"col-12 col-lg-6 col-xl-6\"><h1 class=hero-heading>Complete your Digital Mutual Fund KYC in a few clicks</h1><p>Digital Mutual Fund KYC verification is an essential step for any investor. You can begin transacting immediately, once your Digital Mutual Fund KYC is completed. Take a step towards your financial freedom and enable us to serve you better in the long run.<br></p><p><span class=blue>All you need is</span><br>• PAN<br>• Aadhaar<br>• Bank Account Details</p><small>Verification and Authentication can be done through a one-time-password (OTP)</small></div><div class=\"col-12 col-lg-6 col-xl-6 d-lg-block phone-holder\"><div class=iphone-mockup><img class=device src=assets/images/hero-img.png></div></div></div></div></div></div><div><!-- MAin --><div class=\"form-page-container one\" ng-if=!kyc.proceedKyc><div class=p-15><form name=arnReviewForm class=verification-form><!-- <div class=\"col-md-1\"></div> --><div class=\"resp-container forms\"><div class=row><div class=radio-box><div class=form-check><p class=\"col-xs-12 col-sm-6 col-md-4 d-lg-block pb20\"><input class=\"big-inputtxt form-control-inputtxt pb20\" id=pan aria-colspan=arnInput tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=kyc.formData.pan ng-pattern=/^[A-Z]{5}[0-9]{4}[A-Z]$/ ng-change=kyc.resetValues() ng-blur=kyc.checkPanVerification() placeholder=\"Enter PAN\" autocomplete=off capitalize required> <span class=error-input ng-if=kyc.panPStatus>This facility is only applicable for individual investor. Please enter valid PAN.</span> <span ng-show=\"arnReviewForm.pan.$dirty && arnReviewForm.pan.$invalid\"><span class=error-input ng-show=arnReviewForm.pan.$error.required ng-bind=kyc.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=arnReviewForm.pan.$error.maxlength ng-bind=kyc.validateData.PAN_FIELD></span> <span class=error-input ng-show=arnReviewForm.pan.$error.pattern ng-bind=kyc.validateData.PAN_FIELD></span></span></p><!-- DOB --><div class=\"col-xs-12 col-sm-6 col-md-4 d-lg-block pb20\"><div class=\"input-select input-normal input-group date date-picker dateInputReg datepicker-borderbtm\" name=dob date-calendar data-enable=true data-viewmode={{kyc.viewMode}} data-date-default=kyc.formData.dob data-on-date-change=kyc.changeStartDate maxdate=now format=DD-MM-YYYY id=endDate><input class=\"newinvestor-dob webview big-inputtxt form-control-inputtxt pb20\" tabindex=2 id=dobId name=dob type=text autocomplete=off placeholder=\"Date of Birth (DD-MM-YYYY)\" required ng-model=kyc.dob ng-change=kyc.varifyDate()> <span class=input-group-addon for=dob style=\"padding: 9px 14px\"><img class=calender-icon-register src=assets/images/icons/dateIcon.png> </span><span class=error-input ng-if=kyc.invalidPanDob>{{kyc.panMessage}}</span></div></div><!-- btn --><div class=\"col-xs-12 col-md-4 col-lg-4 d-lg-block\"><button href=# class=\"btn-learn-more anchr-link pro-btn\" ng-click=kyc.verifyDetails() ng-disabled=\"kyc.dateErrorMessage ||\n                        kyc.panPStatus || arnReviewForm.$invalid ||\n                        !kyc.formData.dob || !kyc.dobtrue\">Proceed</button><!-- <div class=\"myDIV\"><img src=\"assets/images/tooltip.jpg\"></div> --><!-- <div class=\"warntxt\">I am shown when someone hovers over the div above.</div> --></div></div></div></div></div></form></div></div></div><!-- ======= services ======= --><div class=\"resp-container services\"><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 col-xl-12\"><h1>Why Digital Mutual Fund KYC?</h1></div><div class=icon-box><div class=box><img src=assets/images/kycservice1.jpg alt=\"\"><p>Complete Folio</p></div><div class=box><img src=assets/images/kycservice2.jpg alt=\"\"><p>Invest in Life Goals</p></div><div class=box><img src=assets/images/kycservice3.jpg alt=\"\"><p>Time Efficient</p></div><div class=box><img src=assets/images/kycservice4.jpg alt=\"\"><p>Skip Queues</p></div><div class=box><img src=assets/images/kycservice5.jpg alt=\"\"><p>Paperless</p></div></div></div></div><!-- ======= Services END ======= --><!-- ======= Footer ======= --><footer id=footerKyc><div class=container-fluid><p class=text-center>MUTUAL FUND INVESTMENTS ARE SUBJECT TO MARKET RISKS, READ ALL SCHEME RELATED DOCUMENTS CAREFULLY.</p></div></footer><!-- ======= Footer END ======= --> <a href=# class=\"back-to-top d-flex align-items-center justify-content-center\" ng-click=kyc.gototp()><i class=\"glyphicon glyphicon-arrow-up\"></i></a></div><style>.form-control-inputtxt{\n    border-radius: 10px;\n  }\n  p {\n    color: black;\n  }\n.error-input{\n  color: red !important;\n}\n  .headerIcon {\n    padding: 15px;\n  }\n\n  .p-15 {\n    padding: 15px 0px 15px 0px;\n  }\n\n  .arn-responsive-div {\n    width: 80%;\n    margin: auto;\n    padding: 50px;\n  }\n\n  .form-control {\n    height: 40px;\n    width: 336px;\n  }\n\n  .pro-btn {\n    border: none;\n    letter-spacing: 0px;\n    color: #FFFFFF;\n    background: #014c8c 0% 0% no-repeat padding-box;\n    font-size: 18px;\n  }\n\n  button:disabled,\n  button[disabled] {\n    opacity: 0.43;\n  }\n\n  .ekyc-wrapper {\n    width: 70%;\n  }\n\n  @media only screen and (max-width: 700px) {\n    .arn-responsive-div {\n      width: 100%;\n      margin: auto;\n      padding: 0px;\n    }\n  }</style><script>/*** Easy selector helper function */\n  const select = (el, all = false) => {\n  el = el.trim()\n  if (all) {\n    return [...document.querySelectorAll(el)]\n  } else {\n    return document.querySelector(el)\n  }\n}\n\n/*** Easy event listener function */\nconst on = (type, el, listener, all = false) => {\n  var selectEl = select(el, all)\n  if (selectEl) {\n    if (all) {\n      selectEl.forEach(e => e.addEventListener(type, listener))\n    } else {\n      selectEl.addEventListener(type, listener)\n    }\n  }\n}\n\n/*** Easy on scroll event listener */\nconst onscroll = (el, listener) => {\n  el.addEventListener(\'scroll\', listener)\n}\n\n/*** Navbar links active state on scroll */\nvar navbarlinks = select(\'#navbar .scrollto\', true)\nconst navbarlinksActive = () => {\n  var position = window.scrollY + 200\n  navbarlinks.forEach(navbarlink => {\n    if (!navbarlink.hash) return\n    var section = select(navbarlink.hash)\n    if (!section) return\n    if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {\n      navbarlink.classList.add(\'active\')\n    } else {\n      navbarlink.classList.remove(\'active\')\n    }\n  })\n}\nwindow.addEventListener(\'load\', navbarlinksActive)\nonscroll(document, navbarlinksActive)\n\n/*** Scrolls to an element with header offset */\nconst scrollto = (el) => {\n  var header = select(\'#header\')\n  var offset = header.offsetHeight\n\n  var elementPos = select(el).offsetTop\n  window.scrollTo({\n    top: elementPos - offset,\n    behavior: \'smooth\'\n  })\n}\n\n/*** Toggle .header-scrolled class to #header when page is scrolled */\nvar selectHeader = select(\'#header\')\nif (selectHeader) {\n  const headerScrolled = () => {\n    if (window.scrollY > 100) {\n      selectHeader.classList.add(\'header-scrolled\')\n    } else {\n      selectHeader.classList.remove(\'header-scrolled\')\n    }\n  }\n  window.addEventListener(\'load\', headerScrolled)\n  onscroll(document, headerScrolled)\n}\n\n/*** Back to top button */\nvar backtotop = select(\'.back-to-top\')\nif (backtotop) {\n  const toggleBacktotop = () => {\n    if (window.scrollY > 100) {\n      backtotop.classList.add(\'active\')\n    } else {\n      backtotop.classList.remove(\'active\')\n    }\n  }\n  window.addEventListener(\'load\', toggleBacktotop)\n  onscroll(document, toggleBacktotop)\n}\n\n/*** Mobile nav toggle ***/\non(\'click\', \'.mobile-nav-toggle\', function(e) {\n  select(\'#navbar\').classList.toggle(\'navbar-mobile\')\n  this.classList.toggle(\'bi-list\')\n  this.classList.toggle(\'bi-x\')\n})\n\n/*** Mobile nav dropdowns activate ***/\non(\'click\', \'.navbar .dropdown > a\', function(e) {\n  if (select(\'#navbar\').classList.contains(\'navbar-mobile\')) {\n    e.preventDefault()\n    this.nextElementSibling.classList.toggle(\'dropdown-active\')\n  }\n}, true)\n\n\n/*** Scrool with ofset on links with a class name .scrollto ***/\non(\'click\', \'.scrollto\', function(e) {\n  if (select(this.hash)) {\n    e.preventDefault()\n\n    var navbar = select(\'#navbar\')\n    if (navbar.classList.contains(\'navbar-mobile\')) {\n      navbar.classList.remove(\'navbar-mobile\')\n      var navbarToggle = select(\'.mobile-nav-toggle\')\n      navbarToggle.classList.toggle(\'bi-list\')\n      navbarToggle.classList.toggle(\'bi-x\')\n    }\n    scrollto(this.hash)\n  }\n}, true)\n\n\n/*** Preloader ***/\nvar preloader = select(\'#preloader\');\nif (preloader) {\n  window.addEventListener(\'load\', () => {\n    preloader.remove()\n  });\n}</script>");
$templateCache.put("app/kycverify/kycverify.html","<login-header></login-header><div class=login-screen id=mainEkyc><section class=ekyc-wrapper><div class=container><div class=row><div class=col-12><h1 class=ekycHeading>eKYC using Aadhaar</h1><div class=ekycHeadingUnderline></div></div></div><div class=row><div class=col-12><div class=ekycText>Thank you for choosing HDFC Mutual Fund as your investment partner. Your KYC is not complete, please read below instructions to initiate eKYC process. You can now complete your KYC formalities online in a seamless and convenient manner using your Aadhaar.</div><div class=ekycMainSection><h4 class=\"ekycHeading headingItalic paddingOfFirstInstruction\">Instructions for completing eKYC using Aadhaar:</h4><ul class=\"instructionEKYC lineHeightInstruction\"><li>Enter Mobile number and Email ID and validate the same with One-time password (OTP) sent. At least one should be registered/seeded with your Aadhaar.</li><form autocomplete=off name=ekyc><div class=input-normal><input type=email style=\"margin-left: 46px ;width: 50%\" no-focus name=email ng-pattern=kycverify.pattern.email_regex ng-model=kycverify.payload.email maxlength=150 required> <span class=highlight></span> <span class=bar></span><label style=\"margin-left: 46px\">Email ID<span class=req>*</span></label><span ng-show=\"ekyc.email.$dirty && ekyc.email.$invalid\" style=\"margin-left: 46px\"><span class=error-input ng-show=ekyc.email.$error.required></span> <span class=error-input ng-show=ekyc.email.$error.pattern class=help-block ng-bind=kycverify.validateData.EMAIL_FIELD></span></span></div><div class=input-normal><input type=tel style=\"margin-left: 46px ;width: 50%\" no-focus name=phone ng-pattern=kycverify.pattern.mobile_regex_eKyc maxlength=10 ng-model=kycverify.payload.mobile required> <span class=highlight></span> <span class=bar></span><label style=\"margin-left: 46px\">Mobile Number<span class=req>*</span></label><span ng-show=\"ekyc.phone.$dirty && ekyc.phone.$invalid\" style=\"margin-left: 46px\"><span class=error-input ng-show=ekyc.phone.$error.pattern class=help-block ng-bind=kycverify.validateData.MOBILE_FIELD></span></span></div></form><li>Enter PAN, validate with KRA system, validate Online with Income Tax database through NSDL.</li><li>Upload PAN card copy (for upload to CKYC).</li><li>Validate your Aadhaar using One-time Password(OTP) through UIDAI Website</li><li>eSign the completed KYC form with an OTP and upload to CAMS eKYC portal.</li></ul><p class=note-ekyc><span>NOTE:</span> On clicking \'Proceed\' button, you shall be redirected to an external application of CAMS Limited for completing your eKYC process.</p><p class=ekycFaqLinkOne><a href=https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/faq/EKYC+Step-by-step+Guide+for+HDFC+MF+Investors.pdf target=_blank>Click here</a> for step by step guide for completing eKYC using Aadhaar</p><p class=ekycFaqLink><a href=https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/faq/ekyc-faq.pdf target=_blank>Click here</a> for FAQs on eKYC using Aadhaar</p></div><div class=ekycButtonSection><button ng-disabled=\"!(kycverify.payload.email && kycverify.payload.mobile)\" ng-click=kycverify.handleProceedAction() class=\"btn btn-primary-action\">Proceed</button></div></div></div></div></section></div>");
$templateCache.put("app/login/landing-new.html","<div ng-if=\"Login.ENV != Login.RUNNING_MODE.MAINTENANCE\" class=height100><!-- <login-header></login-header> --><div class=side-nav-main-wrap><!-- <div class=\"side-nav-container col-md-3\">\n      <div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\">\n        <div class=\"col-md-12 height100\">\n          <div class=\"side-nav-wrap\">\n            <hdfc-login-sidebar sidebar-click=\"Login.handleSideBarClick(message)\"></hdfc-login-sidebar>\n          </div>\n        </div>\n      </div>\n    </div> --><div class=\"col-md-12 col-sm-12 backgroundBgLoginSlider\" style=\"width: 100%;padding: 0px;margin: 0px\"><div class=forms-container><div data-ng-switch=Login.investorSelection><div data-ng-switch-when=EXISTING_USER><!-- Add new HTML page for new view --><div data-ng-include=\"\'app/login/login-components/existing-investor-login-new-mobile.html\'\"></div></div><!--          <div data-ng-switch-when=\"NEW_INVESTOR\">--><!--            <div data-ng-include=\"\'app/login/login-components/new-investor-registration.html\'\"></div>--><!--          </div>--></div></div></div></div><!-- <footer-login></footer-login> --></div><div ng-if=\"Login.ENV == Login.RUNNING_MODE.MAINTENANCE\"><div ng-include=\"\'app/maintainance/maintainance.html\'\"></div></div><style>.forms-container{\n    margin: 0px !important;\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .backgroundBgLoginSlider{\n    background-color: white;\n  }</style>");
$templateCache.put("app/login/login-new.html","<div ng-if=\"Login.ENV != Login.RUNNING_MODE.MAINTENANCE && Login.isMactive !==true\"><login-header></login-header><div class=login-sceen-container><div class=\"container login-screen global-login\"><div class=row><div class=\"col-md-4 col-xs-12 align-right-padding\"><div class=\"page-tabs page-tab-left-border login-text-primary pointer\" ui-sref=registerUser><img src=../../assets/images/reg-Icon.png class=tabImg>REGISTER</div></div><div class=\"col-md-4 col-xs-12 align-center-padding\"><div class=\"page-tabs page-tabs TabActive login-text-active\"><img src=../../assets/images/log-icon.png class=tabImg>LOGIN</div></div><div class=\"col-md-4 col-xs-12 align-left-padding\"><div class=\"page-tabs page-tab-right-bottom login-text-primary pointer\" ui-sref=updateContactLogin><img src=../../assets/images/update-icon.png class=tabImgUpdate>UPDATE CONTACT</div></div></div><div class=\"row flex-style login-body\"><!--Left Section--><section class=\"col-xs-12 pull-left col-md-6 login-form animate\"><div class=\"login-switch clearfix\"><div class=\"col-xs-6 active text-center login-text-primary login-with\" ng-class=\"{active:!Login.loginUsingOtpFlag, \'click-disabled\':!Login.loginUsingOtpFlag}\" ng-click=Login.loginViaPassword() tabindex=10>Login with Password</div><div class=selectedArrow ng-class=\"{active:Login.loginUsingOtpFlag, noneDisp:Login.loginUsingOtpFlag}\"></div><div class=\"col-xs-6 text-center login-text-primary login-with\" ng-class=\"{active:Login.loginUsingOtpFlag, \'click-disabled\':Login.loginUsingOtpFlag}\" ng-click=Login.loginViaOtp() tabindex=11>Login via OTP</div><div class=\"selectedArrow positionOfArrow\" ng-class=\"{active:!Login.loginUsingOtpFlag, noneDisp:!Login.loginUsingOtpFlag}\"></div></div><div id=clickText class=\"text-success text-center form-group\" ng-if=Login.sentOtpRespMsg ng-bind-html=Login.sentOtpRespMsg></div><div id=login-via-password ng-if=!Login.loginUsingOtpFlag><form class=login-form autocomplete=off name=loginForm ng-if=Login.isResetLoginForm novalidate><div ng-hide=Login.showSecStep class=\"input-normal form-bottom-margin\" ng-class=\"{error:loginForm.userId.$dirty && loginForm.userId.$invalid}\"><span class=prefilled ng-if=Login.tracked ng-bind=Login.loginPayload.username></span> <input no-focus tabindex=12 name=userId ng-model=Login.loginPayload.username type=text id=userId ng-change=Login.reset() required stopcopypaste ng-if=!Login.tracked> <span class=highlight></span> <span class=bar></span> <span class=forgot><a href=javascript:void(0) ui-sref=forgotUserId class=forgot-pwd tabindex=15>Forgot ID ?</a> </span><span class=unlock-id><a href=javascript:void(0) ui-sref=\"unlockfolioid({type:\'userid\',from:\'login\'})\" class=forgot-pwd tabindex=14>Unlock ID &nbsp;</a> <span class=border-right></span></span><label class=InputTitle>User ID</label><span ng-show=\"loginForm.userId.$dirty && loginForm.userId.$invalid\"><span class=\"error-input mobile-error\" ng-show=loginForm.userId.$error.required ng-bind=Login.validateData.USER_ID_REQUIRED></span> <span class=\"error-input mobile-error\" ng-show=\"loginForm.userId.$error.pattern && loginForm.userId.$invalid\" class=help-block>{{ Login.validateData.USERNAME_PATTERN }}</span></span></div><div ng-hide=Login.showSecStep class=\"input-normal form-bottom-margin\" ng-class=\"{error:loginForm.password.$dirty && loginForm.password.$invalid}\"><input id=passwordId class=passwordId name=password type=password tabindex=16 ng-model=Login.loginPayload.password required readonly ng-focus=Login.removeReadOnly() autocomplete=off stopcopypaste> <span class=highlight></span> <span class=bar></span> <span class=forgot><a href=javascript:void(0) ui-sref=forgotPassword class=forgot-pwd tabindex=16>Forgot Password ?</a> </span><!--              <i class=\"lock-icon\"></i>--><label class=InputTitle>Password</label><span ng-show=\"loginForm.password.$dirty && loginForm.password.$invalid\"><span class=error-input ng-show=loginForm.password.$error.required ng-bind=Login.validateData.PASSWORD_REQUIRED></span></span></div><div class=\"input-normal form-bottom-margin\" ng-if=Login.showSecStep ng-class=\"{error:loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid}\"><input type=text ng-model=Login.loginPayload.otp required minlength=6 maxlength=6 name=otpNumber is-number autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=forgot><timer countdown=30 interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span> <a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Login.reGenerateOtp(); class=forgot-pwd>Resend OTP</a></timer></span><label class=InputTitle>Enter OTP</label><span ng-show=\"loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid\"><span class=error-input ng-show=loginForm.otpNumber.$error.required ng-bind=Login.validateData.OTP_REQUIRED></span></span></div><input type=button ng-if=!Login.showSecStep ng-disabled=\"loginForm.$invalid || Login.loginProcessFlag\" class=\"btn btn-block btn-login btn-login-custom btnNew\" ng-click=Login.firstStepLogin() value=\"CONTINUE TO LOGIN\"> <input type=button ng-if=Login.showSecStep ng-disabled=\"loginForm.$invalid || Login.loginProcessFlag || !Login.showSecStep\" ng-click=Login.login() class=\"btn btn-block btn-login btn-login-custom btnNew\" value=LOGIN><div class=\"login-text-primary needAsst\">NEED ASSISTANCE? <span class=faqNeedAsst><a ui-sref=faq>&nbsp;FAQS</a></span></div></form></div><div id=login-via-otp ng-if=Login.loginUsingOtpFlag><form autocomplete=off class=login-form name=loginForm ng-if=Login.isResetLoginForm novalidate><div ng-hide=Login.showOtpField class=\"input-normal form-bottom-margin\" ng-class=\"{error:loginForm.userId.$dirty && loginForm.userId.$invalid}\"><span class=prefilled ng-if=Login.tracked ng-bind=Login.loginPayload.username></span> <input no-focus tabindex=12 name=userId ng-model=Login.loginPayload.username type=text ng-change=Login.reset() required stopcopypaste ng-if=!Login.tracked> <span class=highlight></span> <span class=bar></span> <span class=forgot><a href=javascript:void(0) ui-sref=forgotUserId class=forgot-pwd tabindex=15>Forgot ID ?</a> </span><span class=unlock-id><a href=javascript:void(0) ui-sref=\"unlockfolioid({type:\'userid\',from:\'login\'})\" class=forgot-pwd tabindex=14>Unlock ID &nbsp;</a> <span class=border-right></span></span><label class=InputTitle>User ID</label><span ng-show=\"loginForm.userId.$dirty && loginForm.userId.$invalid\"><span class=\"error-input mobile-error\" ng-show=loginForm.userId.$error.required ng-bind=Login.validateData.USER_ID_REQUIRED></span> <span class=\"error-input mobile-error\" ng-show=\"loginForm.userId.$error.pattern && loginForm.userId.$invalid\" class=help-block>{{ Login.validateData.USERNAME_PATTERN }}</span></span></div><div class=\"input-normal form-bottom-margin\" ng-hide=Login.showOtpField ng-class=\"{error:loginForm.panNumber.$dirty && loginForm.panNumber.$invalid && loginForm.panNumber.$touched}\"><input type=text name=panNumber maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=Login.loginPayload.panNumber capitalize required autocomplete=off> <span class=highlight></span> <span class=bar></span><label class=InputTitle>User PAN</label><span ng-messages=loginForm.panNumber.$error ng-show=\"loginForm.panNumber.$dirty && loginForm.panNumber.$invalid\"><span class=error-input ng-message=required ng-bind=Login.validateData.PAN_REQUIRED></span> <span class=error-input ng-message=minlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=error-input ng-message=maxlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=error-input ng-message=pattern ng-bind=Login.validateData.PAN_FIELD></span></span></div><input type=button ng-disabled=\"!Login.loginPayload.username || !Login.loginPayload.panNumber\" ng-if=\"Login.showOtpField === false\" class=\"btn send-otp-btn cursor-pointer btnNew\" ng-click=Login.generateOtp() value=\"Send OTP\"><div class=\"input-normal form-bottom-margin\" ng-if=Login.showOtpField ng-class=\"{error:loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid}\"><input id=otpId type=text ng-model=Login.loginPayload.otp required minlength=6 maxlength=6 name=otpNumber is-number autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=forgot><timer countdown=30 interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span> <a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Login.reGenerateOtp(); class=forgot-pwd>Resend OTP</a></timer></span><label class=InputTitle>Enter OTP</label><span ng-show=\"loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid\"><span class=error-input ng-show=loginForm.otpNumber.$error.required ng-bind=Login.validateData.OTP_REQUIRED></span></span></div><input id=submitLogin1 type=button ng-disabled=\"loginForm.$invalid || Login.loginProcessFlag || !Login.showOtpField\" class=\"btn btn-block btn-login btn-login-custom btnNew\" ng-click=Login.firstStepLogin() value=LOGIN><div class=\"login-text-primary needAsst\">NEED ASSISTANCE? <span class=faqNeedAsst><a ui-sref=faq>&nbsp;FAQS</a></span></div></form></div><input type=hidden id=hiddenEle></section><section class=\"col-xs-12 col-md-6 col-lg-offset-3 pull-left\"><div class=side-image-container><img src=../../assets/images/reg-img.jpg class=\"side-image side-image-setup\"></div></section></div></div></div><footer-login></footer-login></div><div ng-if=\"Login.ENV == Login.RUNNING_MODE.MAINTENANCE || Login.isMactive===true\"><div ng-include=\"\'app/maintainance/maintainance.html\'\"></div></div><style>.login-screen .login-form form .btn-login{margin-top:31px;}\n  .investor-login-h3 {padding-top:40px;}\n  #login-via-password .login-form,#login-via-otp .login-form{padding-top:30px;}\n  .form-group.re_cap{margin-top:0px;}\n  div.text-center.cancel-btn.strong{padding-bottom:20px;padding-top:0px;}\n  div.text-center.cancel-btn.strong i.cancel-icon{top:7px;}\n  span.forgot span.forgot-pwd{position: absolute;top: 45px;right: 0px;}</style>");
$templateCache.put("app/login/login.html","<div ng-if=\"Login.ENV != Login.RUNNING_MODE.MAINTENANCE && Login.isMactive !==true\"><login-header></login-header><div class=\"container-fluid login-screen global-login\"><div class=\"row flex-style\"><!--Left Section--><side-image-landing-page></side-image-landing-page><!--Right Section--><section class=\"col-xs-12 pull-right col-md-6 login-form\"><h3 class=investor-login-h3>Investor Login</h3><div class=\"login-switch clearfix\"><div class=\"col-xs-6 active text-center text-primary\" ng-class=\"{active:!Login.loginUsingOtpFlag, \'click-disabled\':!Login.loginUsingOtpFlag}\" ng-click=Login.loginViaPassword() tabindex=10>Login with Password</div><div class=\"col-xs-6 text-center text-primary\" ng-class=\"{active:Login.loginUsingOtpFlag, \'click-disabled\':Login.loginUsingOtpFlag}\" ng-click=Login.loginViaOtp() tabindex=11>Login via OTP</div></div><div class=\"text-success text-center form-group\" ng-if=Login.sentOtpRespMsg ng-bind-html=Login.sentOtpRespMsg></div><div id=login-via-password ng-if=!Login.loginUsingOtpFlag><form class=login-form autocomplete=off name=loginForm ng-if=Login.isResetLoginForm novalidate><div ng-hide=Login.showSecStep class=input-normal ng-class=\"{error:loginForm.userId.$dirty && loginForm.userId.$invalid}\"><span class=prefilled ng-if=Login.tracked ng-bind=Login.loginPayload.username></span> <input no-focus tabindex=12 name=userId ng-model=Login.loginPayload.username type=text id=userId ng-change=Login.reset() required stopcopypaste ng-if=!Login.tracked> <span class=highlight></span> <span class=bar></span> <span class=forgot><a href=javascript:void(0) ui-sref=forgotUserId class=forgot-pwd tabindex=15>Forgot ID ?</a> </span><span class=unlock-id><a href=javascript:void(0) ui-sref=\"unlockfolioid({type:\'userid\',from:\'login\'})\" class=forgot-pwd tabindex=14>Unlock ID &nbsp;</a> <span class=border-right style=right:73px></span> </span><span class=unlock-id><a href=javascript:void(0) ui-sref=createUserId.verifyAccountDetails class=forgot-pwd tabindex=13 style=\"right: 155px; color: #fc5c5e\">Create User ID &nbsp;</a> <span class=border-right></span> </span><i class=user-icon></i><label>User ID</label><span ng-show=\"loginForm.userId.$dirty && loginForm.userId.$invalid\"><span class=\"error-input mobile-error\" ng-show=loginForm.userId.$error.required ng-bind=Login.validateData.USER_ID_REQUIRED></span> <span class=\"error-input mobile-error\" ng-show=\"loginForm.userId.$error.pattern && loginForm.userId.$invalid\" class=help-block>{{ Login.validateData.USERNAME_PATTERN }}</span></span></div><div ng-hide=Login.showSecStep class=input-normal ng-class=\"{error:loginForm.password.$dirty && loginForm.password.$invalid}\"><input id=passwordId class=passwordId name=password type=password tabindex=16 ng-model=Login.loginPayload.password required readonly ng-focus=Login.removeReadOnly() autocomplete=off stopcopypaste> <span class=highlight></span> <span class=bar></span> <span class=forgot><a href=javascript:void(0) ui-sref=forgotPassword class=forgot-pwd tabindex=16>Forgot Password ?</a> </span><i class=lock-icon></i><label>Password</label><span ng-show=\"loginForm.password.$dirty && loginForm.password.$invalid\"><span class=error-input ng-show=loginForm.password.$error.required ng-bind=Login.validateData.PASSWORD_REQUIRED></span></span></div><div class=input-normal ng-if=Login.showSecStep ng-class=\"{error:loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid}\"><input type=text ng-model=Login.loginPayload.otp required minlength=6 maxlength=6 name=otpNumber is-number autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=forgot><timer countdown=30 interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span> <a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Login.reGenerateOtp(); class=forgot-pwd>Resend OTP</a></timer></span><i class=lock-icon></i><label>Enter OTP</label><span ng-show=\"loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid\"><span class=error-input ng-show=loginForm.otpNumber.$error.required ng-bind=Login.validateData.OTP_REQUIRED></span></span></div><input type=button ng-if=!Login.showSecStep ng-disabled=\"loginForm.$invalid || Login.loginProcessFlag\" class=\"btn btn-primary-action btn-block btn-login\" ng-click=Login.firstStepLogin() value=\"Continue to Login\"> <input type=button ng-if=Login.showSecStep ng-disabled=\"loginForm.$invalid || Login.loginProcessFlag || !Login.showSecStep\" ng-click=Login.login() class=\"btn btn-primary-action btn-block btn-login\" value=Login><div class=\"text-center cancel-btn strong\" ng-if=Login.showSecStep><a ng-click=Login.confirmCancel() href=javascript:void(0) tabindex=16 class=cursor-pointer>Cancel<i class=cancel-icon></i></a></div></form></div><div id=login-via-otp ng-if=Login.loginUsingOtpFlag><form autocomplete=off class=login-form name=loginForm ng-if=Login.isResetLoginForm novalidate><div ng-hide=Login.showOtpField class=input-normal ng-class=\"{error:loginForm.userId.$dirty && loginForm.userId.$invalid}\"><span class=prefilled ng-if=Login.tracked ng-bind=Login.loginPayload.username></span> <input no-focus tabindex=12 name=userId ng-model=Login.loginPayload.username type=text ng-change=Login.reset() required stopcopypaste ng-if=!Login.tracked> <span class=highlight></span> <span class=bar></span> <span class=forgot><a href=javascript:void(0) ui-sref=forgotUserId class=forgot-pwd tabindex=15>Forgot ID ?</a> </span><span class=unlock-id><a href=javascript:void(0) ui-sref=\"unlockfolioid({type:\'userid\',from:\'login\'})\" class=forgot-pwd tabindex=14>Unlock ID &nbsp;</a> <span class=border-right style=right:73px></span> </span><span class=unlock-id><a href=javascript:void(0) ui-sref=createUserId.verifyAccountDetails class=forgot-pwd tabindex=13 style=\"right: 155px; color: #fc5c5e\">Create User ID &nbsp;</a> <span class=border-right></span> </span><i class=user-icon></i><label>User ID</label><span ng-show=\"loginForm.userId.$dirty && loginForm.userId.$invalid\"><span class=\"error-input mobile-error\" ng-show=loginForm.userId.$error.required ng-bind=Login.validateData.USER_ID_REQUIRED></span> <span class=\"error-input mobile-error\" ng-show=\"loginForm.userId.$error.pattern && loginForm.userId.$invalid\" class=help-block>{{ Login.validateData.USERNAME_PATTERN }}</span></span></div><input type=button ng-disabled=!Login.loginPayload.username ng-if=\"Login.showOtpField === false\" class=\"btn btn-secondary-action send-otp-btn cursor-pointer\" ng-click=Login.generateOtp() value=\"Send OTP\"><div class=input-normal ng-if=\"Login.showOtpField && !Login.showSecStep\" ng-class=\"{error:loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid}\"><input id=otpId type=text ng-model=Login.loginPayload.otp required minlength=6 maxlength=6 name=otpNumber is-number autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=forgot><timer countdown=30 interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span> <a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Login.reGenerateOtp(); class=forgot-pwd>Resend OTP</a></timer></span><i class=lock-icon></i><label>Enter OTP</label><span ng-show=\"loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid\"><span class=error-input ng-show=loginForm.otpNumber.$error.required ng-bind=Login.validateData.OTP_REQUIRED></span></span></div><div class=input-normal ng-if=\"Login.showOtpField && Login.showSecStep\" ng-class=\"{error:loginForm.panNumber.$dirty && loginForm.panNumber.$invalid && loginForm.panNumber.$touched}\"><input type=text name=panNumber maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=Login.loginPayload.panNumber capitalize required autocomplete=off> <span class=highlight></span> <span class=bar></span> <i class=lock-icon></i><label>User PAN</label><span ng-messages=loginForm.panNumber.$error ng-show=\"loginForm.panNumber.$dirty && loginForm.panNumber.$invalid\"><span class=error-input ng-message=required ng-bind=Login.validateData.PAN_REQUIRED></span> <span class=error-input ng-message=minlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=error-input ng-message=maxlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=error-input ng-message=pattern ng-bind=Login.validateData.PAN_FIELD></span></span></div><input id=submitLogin1 type=button ng-hide=Login.showSecStep ng-disabled=\"loginForm.$invalid || Login.loginProcessFlag || !Login.showOtpField\" class=\"btn btn-primary-action btn-block btn-login\" ng-click=Login.firstStepLogin() value=\"Continue to Login\"> <input id=submitLogin2 type=button ng-show=Login.showSecStep ng-disabled=\"loginForm.$invalid || Login.loginProcessFlag\" ng-click=Login.login() class=\"btn btn-primary-action btn-block btn-login\" value=Login><div class=\"text-center cancel-btn strong\" ng-show=Login.showOtpField><a ng-click=Login.confirmCancel() href=javascript:void(0) tabindex=16 class=cursor-pointer>Cancel<i class=cancel-icon></i></a></div></form></div><input type=hidden id=hiddenEle><div class=\"col-md-12 register-block\"><!--  <a href=\"javascript:void(0)\" ui-sref=\"registration.main\">--> <a href=javascript:void(0) ng-click=Login.confirmRegister() class=investor-registration><!--            <img src=\"assets/images/newInvestor.png\" alt=\"HDFC\" class=\"logo pull-left\" />--><div class=\"col-md-12 text-center\"><i class=\"fa fa-chevron-right glyphicon glyphicon-chevron-right\" style=\"float: left;\n    position: relative;\n    top: 14px;\n    left: 0px;\n    color: white;\n    font-size: 35px\"></i> <span class=text-left><p class=\"strong first\"><span style=\"color: white\">New Investor</span></p><p class=\"strong second\">Register Now</p></span></div></a></div></section></div></div><div ng-include=\"\'app/components/footer/footer-pre-login.html\'\"></div></div><div ng-if=\"Login.ENV == Login.RUNNING_MODE.MAINTENANCE || Login.isMactive===true\"><div ng-include=\"\'app/maintainance/maintainance.html\'\"></div></div><style>.login-form form .input-normal {\n    margin-bottom: 17px;\n    border-radius: 5px;\n  }\n  .login-screen .login-form form .btn-login{margin-top:31px;}\n  .investor-login-h3 {padding-top:40px;}\n  #login-via-password .login-form,#login-via-otp .login-form{padding-top:0px;}\n  .form-group.re_cap{margin-top:0px;}\n  div.text-center.cancel-btn.strong{padding-bottom:20px;padding-top:0px;}\n  div.text-center.cancel-btn.strong i.cancel-icon{top:7px;}\n  span.forgot span.forgot-pwd{position: absolute;top: 45px;right: 0px;}</style>");
$templateCache.put("app/logout/logout.html","<div class=\"height100 logout-section\"><div class=\"row row-no-gutters\"><!-- <div class=\"side-nav-container col-md-3\">\n      <div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\">\n        <div class=\"col-md-12 height100\">\n          <div class=\"side-nav-wrap\">\n            <hdfc-login-sidebar sidebar-click=\"InstantLogin.handleSideBarClick(message)\"></hdfc-login-sidebar>\n          </div>\n        </div>\n      </div>\n    </div> --><div class=\"col-xs-12 col-sm-12 widthContainer p-0\"><br><login-header></login-header><br><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=forms-container style=\"margin: auto\"><div class=row><div class=\"col-md-12 logout-section-container\"><div class=row><div class=\"col-sm-12 col-md-12\"><div class=logout-header><h3>Session Expired.</h3><p>You\'ve been inactive for a while or started another active session.<br>Please try to re-login if you don\'t have any other active sessions.</p></div></div></div><div class=row><div class=\"col-sm-12 col-md-12\"><div class=logout-available-action><a ui-sref=login class=\"btn btn-primary-action\" style=\"background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n      border: none\">Login</a></div></div></div><div class=row><div class=\"col-sm-12 bottom-section\" style=\"margin-top: 15px\"><p style=\"font-weight: bolder;text-decoration: underline\">For any queries / assistance:</p><br><p>Email @ <span><a style=\"color: #337ab7\" href=mailto:Hello@hdfcfund.com>Hello@hdfcfund.com</a> </span>| Call @ <a style=color:#505050 href=tel:180030106767>180030106767</a> / <a style=color:#505050 href=tel:18004197676>18004197676</a> (Toll Free Number) <span><!-- <img style=\"vertical-align: middle;height: 20px;\" id=\"bot_img\" src=\"assets/images/chat.gif\" alt=\"chat-bot\"/> --></span></p></div></div></div></div></div></div><div class=\"new-carosal-web widthContainer p-0\"><slide-image></slide-image></div></div><!-- <div class=\"mobile-footer-blue mobile-footer-blue-quick-invest\">\n    <div class=\"mobile-footer-blue-container\"\n         ng-click=\"InstantLogin.handleSideBarClick(InstantLogin.appConstants.INVESTOR_SELECTION.EXISTING_USER)\"\n         ui-sref=\"login\">\n      <img src=\"assets/images/newInvestor.svg\" class=\"investorIcon body-img-color\"/>\n      <img src=\"assets/images/existingInvestorBW.svg\" style=\"display: none;\" class=\"body-img-bw\"/>\n      <div class=\"mainmenu-text mobile-footer-blue-text\">Existing Investor</div>\n    </div>\n    <div class=\"mobile-footer-blue-container mobile-footer-seperator\"\n         ng-click=\"InstantLogin.handleSideBarClick(InstantLogin.appConstants.INVESTOR_SELECTION.NEW_INVESTOR)\"\n         ui-sref=\"newInvestor\">\n      <img src=\"assets/images/quickinvest.svg\" class=\"investorIcon mobile-footer-icon body-img-color\"/>\n      <img src=\"assets/images/ic_newinvestor2bw.svg\" style=\"display: none;\" class=\"body-img-bw\"/>\n      <div class=\"mainmenu-text mobile-footer-blue-text\">New Investor?</div>\n    </div>\n  </div>\n  <footer-login></footer-login> --></div><style>.p-l-0{\n    padding-left: 0px !important;\n  }\n  .logout-section-container{\n    border-radius: 16px;\n  }\n  .contrastClass .logout-section-container{\n    background: black !important;\n    box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n  }\n  .forms-container{\n    background: none !important;\n  }\n  @media screen and (max-width: 1024px) {\n    .logout-section-container{\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%) !important;\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n    .contrastClass .logout-section-container{\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n    .forms-container{\n      margin-top: -30% !important;\n      width: 95%;\n      border-radius: 16px ;\n      background: none !important;\n    }\n    .forms-container .forgot-password-forms{\n      padding: 5% 5% 20px 5% !important;\n    }\n    .logout-section .logout-section-container .logout-available-action{\n      text-align: left;\n    }\n  }</style>");
$templateCache.put("app/main/main.html","<hdfc-header></hdfc-header><hdfc-sidebar></hdfc-sidebar><section><div ui-view></div></section><div ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div>");
$templateCache.put("app/maintainance/maintainance.html","<div class=distributor-empanellment ng-init=Login.getMaintenanceContent()><header class=header style=\"overflow: hidden;padding: 15px\"><img style=\"width: 116px;height:40px;margin:0px\" src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <img style=\"max-width: 150px;height:25px;position: relative;top: 10px;left: 20px;margin:0px\" src=assets/images/logo.png alt=HDFC class=\"logo pull-left\"></header><div class=\"maintainance-wrapper text-center\" ng-if=!Login.mContent><i class=maintainance-icon></i><p>Due to scheduled maintenance activity, MFOnline Investors website and mobile app will not be accessible for the next few hours.</p><p style=\"line-height: 4;font-weight: bold\">In the Interim, please use our all new Chat Bot <img style=\"max-width: 150px;height:30px;position: relative;top: 10px;margin:0px\" src=assets/images/chat.gif alt=chat-bot> for all your investment needs.</p></div><div class=\"maintainance-wrapper text-center\" ng-if=Login.mContent ng-bind-html=Login.mContent></div><div ng-include=\"\'app/components/footer/footer-pre-login.html\'\"></div></div><style>div.maintainance-wrapper {\n    min-height:75vh;\n    padding-top:25px;\n    line-height: 1.3;\n    font-size: 1em;\n    font-weight: 400;\n  }\n  p{\n    font-size: 1em;\n    font-weight: 400;\n  }</style>");
$templateCache.put("app/manageAccounts/manageAccounts.html","<div class=container-fluid><div class=\"main-section clearfix saved-items\" ng-init=ManageAccounts.init()><div class=frame><h3 class=screen-title style=\"margin-bottom: 6px\">Manage Accounts</h3><div><p>Primary: {{ManageAccounts.primaryPanDetails.primaryPanInvestorName}}&nbsp;-&nbsp;{{ManageAccounts.primaryPanDetails.maskedPan}}</p></div><br><div class=tab><button class=tablinks style=\"padding-left: 0px\" ng-class={activeTablinks:!ManageAccounts.myPan} ng-click=ManageAccounts.changeTabs(false)><span>Linked PANs</span></button> <button class=tablinks ng-class={activeTablinks:ManageAccounts.myPan} ng-click=ManageAccounts.changeTabs(true)><span>My PAN</span></button></div><div ng-if=\"!ManageAccounts.myPan && ManageAccounts.linedPanList && ManageAccounts.linedPanList.length > 0\"><p style=\"margin-top: 25px\">Below external PANs are linked in your account.Click on \'Remove\' to delink a PAN.</p><div class=card ng-repeat=\"linkedPanList in ManageAccounts.linedPanList\"><div class=row><div class=\"col-md-1 alignRight\"><img src=../../assets/images/icons/panuserId.svg alt=\"\">&nbsp;</div><div class=\"col-md-8 alignCenter\"><span style=\"float: left\">{{linkedPanList.investorName}}<br>{{linkedPanList.maskedPan}}</span></div><div class=col-md-3><button class=\"btn removeButton\" ng-click=ManageAccounts.removePan(linkedPanList)><img src=../../../assets/images/icons/delete-black.svg alt=\"\">&nbsp; Remove</button></div></div></div></div><div ng-if=\"!ManageAccounts.myPan && ( !ManageAccounts.linedPanList || ManageAccounts.linedPanList.length == 0)\"><div class=emptyStateMainDiv><div style=\"text-align: center\"><img src=assets/images/icons/empty_state.svg alt=empty_state><br><h3>Link Other Accounts Here</h3><br><p>Easily link other PANs (eg: family members) to view portfolio and manage their investments.</p><br><button class=\"btn btn-primary-action mt-3\" ng-click=ManageAccounts.addAccount() style=\"font-weight: bold; border-radius: 100px !important; background:linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%)\">Add Account</button></div></div></div><div ng-if=\"ManageAccounts.myPan && ManageAccounts.myPanList && ManageAccounts.myPanList.length > 0\"><p style=\"margin-top: 25px\">Your PAN is linked in below accounts.Click on \'Remove\' to delink your PAN from respective accounts</p><div class=card ng-repeat=\"linkedPanList in ManageAccounts.myPanList\"><div class=row><div class=\"col-md-1 alignRight\"><img src=../../assets/images/icons/panuserId.svg alt=\"\">&nbsp;</div><div class=\"col-md-8 alignCenter\"><span style=\"float: left\">{{linkedPanList.investorName}}<br>{{linkedPanList.maskedPan}}</span></div><div class=col-md-3><button class=\"btn removeButton\" ng-click=ManageAccounts.removePan(linkedPanList)><img src=../../../assets/images/icons/delete-black.svg alt=\"\">&nbsp; Remove</button></div></div></div></div><div ng-if=\"ManageAccounts.myPan && ( !ManageAccounts.myPanList || ManageAccounts.myPanList.length == 0)\"><div class=emptyStateMainDiv><div style=\"text-align: center\"><img src=assets/images/icons/empty_state.svg alt=empty_state><br><h3>Your Account Is Not Linked To Anyone</h3><br><p>Once someone requests to link your account and upon your approval, their name will appear here.</p></div></div></div></div></div></div><style>.emptyStateMainDiv{\n        min-height: 200px;\n        display: flex;    \n        padding-top: 4%; \n        justify-content: center; \n        align-items: center;\n  }\n  .card {\n    background: white;\n    padding: 12px;\n    margin-top: 8px;\n    border-radius: 8px;\n    margin-bottom: 12px;\n  }\n\n  .screen-title {\n    font-size: 22px;\n    font-weight: bold;\n    color: black;\n  }\n\n  .tab {\n    overflow: hidden;\n    border-bottom: 1px solid #ccc;\n    background-color: #f1f1f1;\n  }\n\n  .tablinks {\n    border: none;\n    font-size: 18px;\n    font-weight: bold;\n    background: transparent;\n    border-color: transparent !important;\n    height: 40px;\n  }\n\n  .activeTablinks {\n    height: 40px;\n    border: none;\n    font-size: 18px;\n    font-weight: bold;\n    color: #0b75d2;\n    background: transparent;\n    border-color: transparent !important;\n    border-bottom: 1px solid #0b75b2 !important;\n  }\n\n  .frame {\n    margin: 30px;\n  }\n\n  .removeButton {\n    position: relative;\n    float: right;\n    width: 100px;\n    border: 1px solid #D3D2D2; \n    background: transparent;\n    color: black;\n    padding: 16px;\n    padding-bottom: 6px;\n    padding-top: 6px;\n    text-align: center;\n    text-decoration: none;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n  } \n  .alignCenter {\n    align-items: center;\n    display: flex;\n  } \n  .alignRight{\n    display: flex;\n    justify-content: right;\n    align-items: center;\n  }\n  body,p,div,span{ \n    line-height: normal;\n  }\n  @media screen and (max-width: 767px) {\n    .tablinks{\n      width: 49% !important; \n    }\n    .removeButton{\n      width: 100% !important;\n    }\n    .alignRight{\n      display: flex;\n      justify-content: right;\n      align-items: center;\n    }\n    .card .row{\n      display: flex;\n      align-items: center;\n      .col-md-1{\n        padding: 0px;\n        width: 16%;\n      }\n      .col-md-8{\n        padding: 0px;\n        width: 54%;\n      }\n      .col-md-3{\n        padding: 0px;\n        width: 25%;\n      }\n    }\n    .main-section {\n      padding: 85px 0px 50px 0px;\n      margin: 0px  !important;\n    }\n    .frame{\n      margin: 5px !important;\n    }\n  }\n  @media only screen and (max-width: 424px) {\n    .card .row{\n      .col-md-1{\n        width: 18vw !important;\n      }\n      .col-md-8{\n        width: 40vw;\n      }\n      .col-md-3{\n        display: flex;\n        justify-content: center;\n        margin: 4%;\n        width: 90% !important;\n        padding-top: 6px;\n        padding-bottom: 6px;\n        button{\n          display: flex;\n          justify-content: center;\n        }\n      }\n    }\n  }</style>");
$templateCache.put("app/mobile/mobile.html","<div ui-view></div><style>#st_notification_sticky{display: none !important;}</style>");
$templateCache.put("app/new-investors/new-investor-registration.html","<div class=new-investors><new-investor-header ng-if=\"!cUrl && NewInvestor.showHeaderFooter\"></new-investor-header><!-- <login-header  ng-If=\"(!testObj.steps[2].stepCompleted && !cUrl)\"></login-header > --><div ng-attr-class=\"{{testObj.steps[2].stepCompleted ? \'progress-nav-containerTwo row\' : (!testObj.steps[2].stepCompleted && !cUrl)? \'progress-nav-container1 row\': \'progress-nav-container-WithBgColor row\'}}\"><!-- <div class=\"progressBar col-xs-12 col-sm-4 col-md-3 newInvestorSideBarCss\" ng-If=\"cUrl\">\n    <hdfc-login-sidebar sidebar-click=\"handleSideBarClick(message)\"></hdfc-login-sidebar>\n  </div> --><div class=\"progressBar col-xs-12 col-sm-4 col-md-3\" ng-if=\"!testObj.steps[2].stepCompleted && !cUrl \"><div class=\"row height100\"><!--style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\"--><div class=\"col-md-12 height100\"><div class=progress-nav><vertical-progress-sidebar steps=testObj responsive=false></vertical-progress-sidebar><vertical-progress-sidebar steps=testObj responsive=true></vertical-progress-sidebar></div></div></div></div><div class=\"col-xs-12 col-sm-8 p-0\" ng-class=\"(!testObj.steps[2].stepCompleted && !cUrl)? \'col-md-9\': \'col-md-6 table-width100\'\"><login-header ng-if=\"cUrl || !NewInvestor.showHeaderFooter\"></login-header><div ui-view></div></div><div class=\"col-xs-12 col-sm-12 new-carosal-web widthContainer p-0\" ng-if=\"!(!testObj.steps[2].stepCompleted && !cUrl) \" ng-hide=testObj.steps[2].stepCompleted><slide-image></slide-image></div></div></div><footer-login ng-if=\"!cUrl && NewInvestor.showHeaderFooter\"></footer-login><style>.new-mobile-carousel {\n      display: none !important;\n    }\n  .newInvestorSideBarCss{\n      padding-top: 40px;\n    }\n    @media only screen and (max-width: 767px) {\n      .newInvestorSideBarCss{\n      padding-top: 0px;\n      display: none;\n    }\n}\n@media only screen and (max-width: 1024px) {\n    .new-mobile-carousel {\n      display: block !important;\n    }\n  .hide-tablet{\n    display: none;\n  }\n  .table-width100{\n    width: 100% !important;\n  }\n  .new-investors .progress-nav-container-WithBgColor{\n    background-color: #f4fcff;\n  }\n}\n@media only screen and (max-width: 425px) {\n  .new-investors .kyc-form-container .form-page-container .col-xs-12 .verification-form .pan-input-container .form-control{\n    width: 100%;\n  }\n  .new-investors .kyc-form-container .form-page-container .col-xs-12 .verification-form .dob-input-container .newinvestor-dob{\n    width: 100%;\n  }\n  }</style>");
$templateCache.put("app/nfsservices/nfsservices.html","<div class=\"main-section nfsservices\" ng-init=fetchDynamicData();><div class=banner><img src=\"{{ desktop_banner }}\" class=bannerimg></div><div class=mobilebanner><img src=\"{{ mobile_banner }}\" class=bannerimg></div><div class=content-area><div class=innercontent><div class=\"row cards\"><div ng-repeat=\"data in nfsservices track by $index\" class=\"col col-sm-12 col-md-6 col-lg-6\"><div class=servicecard><div class=cardhead><img class=service_logo src={{data.logoURL}} alt=\"\" srcset=\"\"><div class=service_header><p>{{data.header}}</p></div></div><div class=service_content><p ng-bind-html=data.content></p></div><div class=btnproceed><a href={{data.redirectionUrl}} ng-click=trackApiRequest(data.contentMappingId); target=_blank>Proceed</a></div></div></div></div></div></div></div>");
$templateCache.put("app/notifications/notifications.html","<div class=\"notifications main-section clearfix\" ng-init=Notification.init()><h3 class=\"notification-align page-head\">Notifications</h3><div class=notify-block ng-if=Notification.notificationData.today.length><!--  ng-if=\"Notification.notificationData.today.length\"  --><p>Today</p><ul><li ng-repeat=\"notification in Notification.notificationData.today\">{{notification.description}}</li><!--<li>Notification 1</li>\n      <li>Notification 2</li>--></ul></div><div class=notify-block ng-if=Notification.notificationData.lastsevendays.length><!-- ng-if=\"Notification.notificationData.lastsevendays.length\" --><p>Last 7 Days</p><ul><li ng-repeat=\"notification in Notification.notificationData.lastsevendays\">{{notification.description}}</li></ul></div><div class=notify-block ng-if=Notification.notificationData.history.length><!-- ng-if=\"Notification.notificationData.history.length\" --><p>History</p><ul><li ng-repeat=\"notification in Notification.notificationData.history\">{{notification.description}}</li></ul></div><div class=notify-block ng-if=\"Notification.notificationData.today.length === 0 && Notification.notificationData.history.length === 0 && Notification.notificationData.lastsevendays.length === 0\"><!-- ng-if=\"Notification.notificationData.history.length\" --><p class=text-center>No record found</p></div></div>");
$templateCache.put("app/payment/payment.html","<div ng-class=\"{\'payment-journey\':Payment.sourcePortal === \'INVESTOR\',\'payment-journey-post-login\': Payment.sourcePortal === \'INVESTOR\'}\"><div class=payment-section-container><!--showing loader--><div ng-if=Payment.showLoader data-ng-include=\"\'app/payment/templates/loader/loader.html\'\"></div><!--showing loader ends here--><div ng-if=!Payment.showLoader ng-class=\"{\'no-payment-mode\': !Payment.formData.selectedPaymentOption}\"><!-- payment header starts here--><div class=\"row payment-header-container\"><div class=col-md-12 data-ng-include=\"\'app/payment/templates/header/header.html\'\"></div></div><!-- payment header starts here--><div class=pre-login-payment ng-class=\"{\'main-section-padding\': Payment.sourcePortal === \'INVESTOR\'}\" ng-if=!Payment.showLoader><!-- payment ui starts here--><div class=\"row justify-content-center\"><div class=col-md-6 data-ng-include=\"\'app/payment/templates/common/payment-common.html\'\"></div></div><!-- payment ui ends here--><!-- tnc starts here--><div class=\"row justify-content-center set-margin-bottom-24 set-margin-top-32 tnc-checkbox\" ng-if=Payment.formData.selectedPaymentOption><div class=\"col-md-6 px-0\"><div class=\"checkbox align-items-center\"><input id=declaration ng-model=Payment.isCheckedTNC type=checkbox> <i class=icon-checkbox></i><label for=declaration class=\"label-black f-family-inter fweight-400 mt-0\">I accept the <a ng-click=Payment.redirectToTnc()>Terms & Conditions</a> of investment.</label></div></div></div><!--tnc ends here--><!--pay now cta starts here--><div class=\"row justify-content-center\"><div class=\"col-md-6 px-0\"><div class=transaction-action><button ng-click=Payment.payNow($event) ng-disabled=\"(Payment.formData.investmentType === \'SIP\' && Payment.formData.selectedPaymentOption === Payment.PAYMENT_OPTIONS.UPISIP && ((Payment.selectedUpiOption && Payment.selectedUpiOption === \'OTHERS\' && !Payment.isUPIVerified) || Payment.tFormUPI.$invalid || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition()))) ||\n                           (Payment.formData.investmentType === \'SIP\' && Payment.formData.selectedPaymentOption !== Payment.PAYMENT_OPTIONS.UPISIP && (Payment.tForm.$invalid  || Payment.isInvalidForm || (Payment.formData.selectedPaymentOption == Payment.PAYMENT_OPTIONS.NETBANKING && Payment.bankInfo.tpvEnableFlag==\'N\') || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition()) || (Payment.formData.investmentType === \'SIP\' && Payment.formData.selectedPaymentOption === Payment.PAYMENT_OPTIONS.EMANDATE && (Payment.amountLess || Payment.amountMore || Payment.isLessThanSipAmount || Payment.sipDateLessEmandate || !Payment.emailExist || !Payment.mobileExist)))) ||\n                           (Payment.formData.investmentType === \'PURCHASE\' && Payment.formData.selectedPaymentOption === Payment.PAYMENT_OPTIONS.UPI && (!Payment.isUPIVerified || Payment.tFormUPI.$invalid || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition()))) ||\n                           (Payment.formData.investmentType === \'PURCHASE\' && Payment.formData.selectedPaymentOption !== Payment.PAYMENT_OPTIONS.UPI && (Payment.tForm.$invalid || (Payment.formData.selectedPaymentOption == Payment.PAYMENT_OPTIONS.NETBANKING && Payment.bankInfo.tpvEnableFlag==\'N\') || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition()))) || !Payment.isCheckedTNC\">Pay Now <img src=../../../../assets/images/icons/payment-journey/right-arrow.svg></button></div></div></div><!--pay now cta ends here--></div></div></div></div>");
$templateCache.put("app/portfolio/portfolio.html","<div class=\"main-section portfolio clearfix\"><i class=\"cursor-pointer subscribe-icon pull-right\" ui-sref=main.subscriptionValuation.folio-valuation ng-if=\"Portfolio.$state.current.name != \'main.portfolio.demat-folios\' \"></i><ul class=\"nav nav-tabs\"><li ui-sref-active=active><a ui-sref=main.portfolio.list>Portfolio</a></li><li ui-sref-active=active><a ui-sref=main.portfolio.folios>Folios</a></li><li ui-sref-active=active ng-if=\"Portfolio.constData != false\"><a ui-sref=main.portfolio.demat-folios>Demat Folios</a></li></ul><div ui-view></div></div>");
$templateCache.put("app/preliminary-dashboard/preliminary-dashboard.html","<div class=dashboardBg><preliminary-header></preliminary-header><hdfc-preliminary-dashboard-sidebar></hdfc-preliminary-dashboard-sidebar><div class=dashboard-body><div class=row><!-- Row 1 --><div class=\"col-md-5 col-lg-5 col-sm-12 mb-sm-2\"><div class=\"card-bg greetcard\"><p class=\"pt-2 pb-2 greetingHeading\">Hello, <span>{{PreliminaryDashboard.greeting}}</span></p><p class=\"pt-2 pb-4 greetingSubtext\">You have successfully registered with us.</p><div class=pan-box><p class=\"pt-3 pb-3 greetsubtext\">Enter your PAN to start investing.</p><div class=\"pt-2 pb-3\"><button type=button class=\"btn btn-primary-action bluelinearButton fs-8\" ng-click=PreliminaryDashboard.addpan() style=\"min-width:113px !important;max-width: 170px\">Start Investing</button></div></div></div></div><div class=\"col-md-7 col-lg-7 col-sm-12 col-xs-12\"><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-6 p-0\"><p class=\"SectionHeader pt-2 pb-3 pl-0 xs-padding\">Calculators</p></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-6 p-0\"><a href={{PreliminaryDashboard.allCalculatorLink}} target=_blank><span class=\"pt-2 pb-3 pull-right viewAlltext xs-padding\">View All <span class=\"glyphicon glyphicon-menu-right viewarrow\"></span></span></a></div><div class=hidden-xs><div class=\"col-md-4 col-lg-4 col-sm-4 col-xs-12 p-0\" ng-repeat=\"calculatorcard in PreliminaryDashboard.calculatorcards\"><a class=\"card-bg m-1 calculatorCardheight d-block calculatorCard\" href={{PreliminaryDashboard.HDFC_API.WEBSITE_LINK}}{{calculatorcard.routeConstant}} target=_blank><div class=\"col-md-12 col-lg-12 col-sm-12 pb-1 p-0\"><img src={{calculatorcard.attributes.icon_path}} class=\"pull-right contrastImage\"></div><div><p class=\"sectionSubHeader pb-2\">{{calculatorcard.linkName}}</p><span class=sectionSubtext>{{calculatorcard.linkDescription}}</span></div></a></div></div><!-- mobile view --><div class=\"visible-xs col-sm-12 col-xs-12 p-0\"><div class=scrollableCard><div class=\"card-bg m-1 cardsmall calculatorCard\" ng-repeat=\"calculatorcard in PreliminaryDashboard.calculatorcards\"><div class=\"d-flex justify-content-center align-items-center\"><div><img src={{calculatorcard.attributes.icon_path}} class=\"pull-right contrastImage\"></div><div style=\"padding-left: 8px\"><p class=\"sectionSubHeader pb-3\">{{calculatorcard.linkName}}</p><span class=sectionSubtext>{{calculatorcard.linkDescription}}</span></div></div></div></div></div></div><!-- Row 2 --><div class=\"col-md-5 col-lg-5 col-sm-12 col-xs-12 cardTopPadding\"><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-6 p-0\"><p class=\"SectionHeader pt-2 pb-3 pl-0\">Invesment Baskets</p></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-6 p-0\"><a href={{PreliminaryDashboard.allInvestmentBasketLink}} target=_blank><span class=\"pt-2 pb-3 pull-right viewAlltext d-flex align-items-center\">View All <span class=\"glyphicon glyphicon-menu-right viewarrow\"></span></span></a></div><div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0 card-bg-carousel hidden-xs\"><div class=height100><div class=\"height100 banner-col fundcarosalcontainer\"><div id=bannerCarousel class=\"carousel slide height100 fundcarosal-innercontainer\"><ol class=\"carousel-indicators contrastindicator\"><li data-bs-target=#bannerCarousel ng-repeat=\"basket in PreliminaryDashboard.investmentBasket\" data-bs-slide-to={{$index}} ng-class=\"{\'active\': $first}\"></li></ol><!-- Wrapper for slides --><div class=\"carousel-inner height100 carousel-inner-card-bg\"><div class=\"carousel-item height100\" ng-repeat=\"basket in PreliminaryDashboard.investmentBasket track by $index\" ng-class=\"{\'active\': $first}\"><div class=sectionSubHeader><span class=\"d-flex investmentBasketFundname\">{{basket.basketName}} <span style=\"padding-left: 10px\"><a href={{basket.basketRedirectionUrl}} class=nofocus target=_blank><span class=\"fi_arrowRight nonconstrastImg nofocus\"></span> <span class=\"fi_arrowRightactive constrastImg nofocus\"></span></a></span></span></div><div class=\"d-flex justify-content-center\"><div class=fundSection-inner><div ng-repeat=\"fund in basket.schemesInBasket track by $index\"><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-6 p-0 d-flex justify-content-start align-items-center\"><div class=fund-card-bg><div class=\"d-flex align-items-center justify-content-start\"><div class=d-flex><div><img src=../../../assets/images/preliminary-dashboard/tickgreen.svg alt=\"\" class=fundtick></div><div><p class=fundSchemename style=\"display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden\">&nbsp;{{fund.schemeName}}</p></div></div></div></div></div></div></div></div><div class=\"col-12 col-md-12 col-lg-12 col-sm-12 d-flex justify-content-center pt-3\"><div ng-click=PreliminaryDashboard.redirect(basket.basketRedirectionUrl)><button class=\"btn btn-primary-action bluelinearButton\">Invest Now</button></div></div></div></div><!-- Left and right controls --></div></div></div><!-- Controls --> <a class=\"left carousel-control leftfundcarousel\" data-bs-target=#bannerCarousel data-bs-slide=prev><span class=\"glyphicon glyphicon-menu-left carousel-arrow-left contrastarrow\"></span> <span class=sr-only>Previous</span> </a><a class=\"right carousel-control rightfundcarousel\" data-bs-target=#bannerCarousel data-bs-slide=next><span class=\"glyphicon glyphicon-menu-right carousel-arrow-right contrastarrow\"></span> <span class=sr-only>Next</span></a></div><!-- Mobile View --><div class=\"visible-xs col-sm-12 col-xs-12 p-0\"><div class=scrollableCard><div class=\"card-bg m-1 calculatorCard fundcarosalMobcontainer\" ng-repeat=\"basket in PreliminaryDashboard.investmentBasket track by $index\"><div class=sectionSubHeader><span class=\"d-flex investmentBasketFundname justify-content-between\">{{basket.basketName}} <span><a href={{basket.basketRedirectionUrl}} class=nofocus target=_blank><span class=\"fi_arrowRight nonconstrastImg nofocus\"></span> <span class=\"fi_arrowRightactive constrastImg nofocus\"></span></a></span></span></div><div class=\"d-flex justify-content-center\"><div class=fundSection-inner><div ng-repeat=\"fund in basket.schemesInBasket track by $index\"><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-6 col-xxs-12 p-0 d-flex justify-content-start align-items-center\"><div class=fund-card-bg><div class=\"d-flex align-items-center justify-content-start\"><div class=d-flex><div><img src=../../../assets/images/preliminary-dashboard/tickgreen.svg alt=\"\" class=fundtick></div><div><p class=fundSchemename style=\"display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden\">&nbsp;{{fund.schemeName}}</p></div></div></div></div></div></div></div></div><div class=\"col-12 col-md-12 col-lg-12 col-sm-12 d-flex justify-content-center pt-3\" style=\"width: 100%\"><div ng-click=PreliminaryDashboard.redirect(basket.basketRedirectionUrl)><button class=\"btn btn-primary-action bluelinearButton\">Invest Now</button></div></div></div></div></div></div><div class=\"col-md-7 col-lg-7 col-sm-12 mt-4\"><div class=\"col-sm-12 col-md-12 col-lg-12 p-0 goal-card\"><p class=\"SectionHeader pt-2 pb-3 pl-0\">Plan Your Goal</p></div><div class=\"col-md-4 col-lg-4 col-sm-6 col-xs-6 p-0 d-block\" ng-repeat=\"goalcard in PreliminaryDashboard.goalsList track by $index\"><a href={{goalcard.goalRedirectionUrl}} target=_blank><div class=\"card-bg text-center goal-card imgIconGoals d-flex-xs\"><img src={{goalcard.imageUrl}} class=\"pb-2 goaliconpadding\"><p class=greetsubtext>{{goalcard.goalName}}</p></div></a></div></div><!-- Row 3 --><div class=\"col-md-5 col-lg-5 col-sm-12 cardTopPadding mb-4\"><div class=\"col-sm-12 col-md-12 col-lg-12 p-0\"><p class=\"SectionHeader pt-2 pb-3 pl-0\">Know Your Investment Personality</p></div><div class=position-relative><div class=\"col-md-12 col-lg-12 col-sm-12 card-bg minCardHeight\"><div class=\"col-md-8 col-lg-8 col-sm-8 col-xs-8\"><div class=\"d-flex flex-column mt-4\"><p class=\"unlockTxt pb-2\">Unlock your investment style</p><a href={{PreliminaryDashboard.knowYourInvestmentPersonality}} target=_blank class=\"findText pt-3 nofocus d-flex\">Find Out <img src=assets/images/preliminary-dashboard/arrowfind.svg class=arrowImagePersonality></a></div></div><div class=\"col-md-4 col-lg-4 col-sm-4 col-xs-4 p-0\"><div class=circlebg></div><img src=assets/images/preliminary-dashboard/personality.png class=\"personalityimg contrastImage\"></div></div></div></div><div class=\"col-md-7 col-lg-7 col-sm-12 cardTopPadding mb-4\"><div class=\"col-sm-12 col-md-12 col-lg-12 p-0\"><p class=\"SectionHeader pt-2 pb-3 pl-0\">Keep Yourself Updated</p></div><div class=hidden-xs><div class=\"col-md-4 col-lg-4 col-sm-12 p-0\" ng-repeat=\"baskettype in PreliminaryDashboard.basket_widget\"><a class=\"pr-2 marginSmall d-block\" href={{PreliminaryDashboard.HDFC_API.WEBSITE_LINK}}{{baskettype.link}} target=_blank><div style=\"position: relative;box-shadow:0px 2px 12px 0px #E5E5E5\"><img class=\"profile minCardHeight rounded\" width=100% src={{baskettype.image}} alt=basket_image><p class=\"textImgDescription rounded-bottom\">{{baskettype.description.substring(0,30)}} <span class=readmoretxt>Read More...</span></p></div></a></div></div><!-- Mobile view --><div class=\"visible-xs p-0\"><div class=scrollableCard><div class=\"cardsmallImg d-flex\"><div ng-repeat=\"baskettype in PreliminaryDashboard.basket_widget\"><a class=\"marginSmall d-block\" href={{baskettype.link}} target=_blank><div style=\"position: relative;box-shadow:0px 2px 12px 0px #E5E5E5\"><img class=\"profile minCardHeight rounded\" width=150px src={{baskettype.image}} alt=basket_image><p class=\"textImgDescription rounded-bottom\">{{baskettype.description.substring(0,37)}} <span class=readmoretxt>Read More...</span></p></div></a></div></div></div></div></div></div></div></div><style>.contrastClass .goaliconpadding , .contrastClass .arrowImagePersonality,.contrastClass .contrastImage{\n    background: transparent !important;\n  }\n  .carousel-control{\n    opacity: 1;\n  }</style>");
$templateCache.put("app/quick-links/changeDividendOption.html","<div class=main-section ng-init=ChangeDividendOption.init()><section class=change-dividend-option><p class=\"screen-title text-uppercase\">Change IDCW option</p><div class=content-area><form name=dividendForm autocomplete=off><p>Select Scheme</p><div class=row><div class=col-md-4><div class=selectfield ng-class={error:dividendForm.folio.$dirty&&dividendForm.folio.$invalid}><select name=folio ng-change=ChangeDividendOption.folioChanged() ng-model=ChangeDividendOption.formData.folioNumber ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in ChangeDividendOption.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio</option></select><label ng-if=ChangeDividendOption.formData.folioNumber>Select Folio</label><span ng-show=\"dividendForm.folio.$dirty && dividendForm.folio.$invalid\"><span class=error-input ng-show=dividendForm.folio.$error.required ng-bind=ChangeDividendOption.VALIDATE_DATA.FOLIO_REQUIRED></span></span></div><!--              <div ng-class=\"{error:dividendForm.outScheme.$dirty && dividendForm.outScheme.$invalid, \'anything-disabled\': !ChangeDividendOption.formData.folioNumber}\" class=\"selectfield\">--><!--                <select name=\"outScheme\"--><!--                        ng-model=\"ChangeDividendOption.formData.outSchemeObj\"--><!--                        ng-change=\"ChangeDividendOption.outSchemeChanged()\"--><!--                        ng-options=\"_scheme as _scheme.schemeName for _scheme in ChangeDividendOption.details track by _scheme.reinvest\"--><!--                        ng-init=\"ChangeDividendOption.formData.outSchemeObj = ChangeDividendOption.formData.outSchemeObj? ChangeDividendOption.formData.outSchemeObj: null\"--><!--                        required>--><!--                  <option value=\"\" selected=\"\">Select Scheme</option>--><!--                </select>--><!--                <span ng-show=\"dividendForm.outScheme.$dirty && dividendForm.outScheme.$invalid\">--><!--                    <span class=\"error-input\" ng-show=\"dividendForm.outScheme.$error.required\"--><!--                          ng-bind=\"ChangeDividendOption.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--                </span>--><!--              </div>--><div class=\"input-select input-normal margin-align-left\" ng-class=\"{\'anything-disabled\': !ChangeDividendOption.formData.folioNumber }\" ng-class={error:ChangeDividendOption.tForm.outScheme.$invalid}><input type=text name=outScheme id=outScheme ng-change=ChangeDividendOption.filterOutSchemeList() ng-model=ChangeDividendOption.formData.outSchemeName autocomplete=off ng-required=Transaction.isRequired> <span class=highlight></span> <span class=bar></span><label>Select Source Scheme</label><span class=error-input ng-show=ChangeDividendOption.tForm.outScheme.$error.required ng-bind=ChangeDividendOption.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=ChangeDividendOption.outSchemeList display-key=schemeName hdfc-click=ChangeDividendOption.outSchemeChanged(data) model=ChangeDividendOption.formData.outSchemeCode for=outScheme></drop-down></div></div></div><p ng-if=ChangeDividendOption.formData.outSchemeName class=text-warn>(Currently Chosen IDCW Option: <span ng-bind=ChangeDividendOption.reInvest>Payout</span>)</p><p>Choose Income Distribution cum Capital Withdrawal (IDCW) Option:</p><div ng-class=\"{\'anything-disabled\': !ChangeDividendOption.formData.outSchemeName}\"><span class=radio-block ng-class=\"{\'anything-disabled\': ChangeDividendOption.reInvest==\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\'}\"><span class=radio><input type=radio ng-model=ChangeDividendOption.formData.dividendOption name=dividendOption value=Reinvest ng-disabled=\"ChangeDividendOption.reInvest==\'Reinvest\'\"> <span class=check></span></span><label>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label></span><span class=radio-block ng-class=\"{\'anything-disabled\': ChangeDividendOption.reInvest==\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}\"><span class=radio><input type=radio ng-model=ChangeDividendOption.formData.dividendOption name=dividendOption value=Payout ng-disabled=\"ChangeDividendOption.reInvest==\'Payout\'\"> <span class=check></span></span><label>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</label></span></div><!--          <div class=\"imp-info\">--><!--            <strong>Notes:</strong>--><!--              <div>--><!--                <ng-bind-html--><!--                  ng-bind-html=\"ChangeDividendOption.dynamicDataReview.noteDTO.noteDTOMap.Note_Change_IDCW_Option_Payout.content\"--><!--                  ng-if = \"ChangeDividendOption.showNote\"--><!--                ></ng-bind-html>--><!--              </div>--><!--            <p>--><!--              <i class=\"dot\"></i>--><!--              <span>--><!--                Under this section you can change the IDCW option of your scheme(s) (if--><!--                applicable) from Payout to Re-Invest or vice versa.--><!--              </span>--><!--            </p>--><!--            <p>--><!--              <i class=\"dot\"></i>--><!--              <span>--><!--                However if you wish to change from a IDCW option to a Growth option, you--><!--                need to place a request under the Switch section.--><!--              </span>--><!--            </p>--><!--          </div>--><ng-bind-html dynamic=ChangeDividendOption.dynamicDataReview.noteDTO.noteDTOMap.Note_Change_IDCW_Option_Payout.content></ng-bind-html><div class=\"row form-footer\" ng-if=ChangeDividendOption.showTerms><div class=col-md-9><p class=strong>Terms &amp; Conditions</p><span class=checkbox><input type=checkbox ng-model=ChangeDividendOption.isCheckedTandC> <span class=icon-checkbox></span> <span class=\"checkbox-text tnc\">I have read and understood <a ng-click=ChangeDividendOption.showTermConditions() href=javaScript:void(0)>Terms &amp; Conditions</a> of Investment</span></span></div><div class=col-md-3><button class=\"btn btn-primary-action pull-right common-btn-padding\" ng-disabled=\"!ChangeDividendOption.isCheckedTandC || dividendForm.$invalid  || (!ChangeDividendOption.kycVerifiedFlag) || !ChangeDividendOption.isValidScheme || !ChangeDividendOption.formData.outSchemeName\" ng-click=ChangeDividendOption.submitChangeDividend()>Submit</button></div></div></form></div></section></div><style>.diabled-class{\n    color: #ccc;\n  }</style>");
$templateCache.put("app/quick-links/unclaimedDividend.html","<div class=\"main-section clearfix ng-scope\"><section class=unclaimed-transaction ng-init=Transaction.init()><p class=\"page-title text-uppercase\">Unclaimed IDCW / Redemption</p><div class=content-area><form autocomplete=off><div class=row><div class=col-md-4><div class=selectfield><select><option value=\"\" selected>Select Folio</option></select></div><div class=selectfield><select><option value=\"\" selected>Select Scheme</option></select></div></div><div class=\"col-md-8 with-border\"><div class=row><div class=col-md-6><div class=input-normal><input type=text required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Bank Name</label></div></div><div class=col-md-6><div class=input-normal><input type=text required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Account Number</label></div></div></div><div class=row><div class=col-md-6><div class=selectfield><select><option value=\"\" selected>Account Type</option></select></div></div><div class=col-md-6><div class=selectfield><select><option value=\"\" selected>Payment Mode</option></select></div></div></div><div class=row><div class=col-md-6><div class=input-normal><input type=text required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>IFSC</label></div><div class=input-normal><input type=text required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>MICR Number</label></div><div class=input-normal><input type=text required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Branch Location</label></div></div><div class=col-md-6><div class=drop-image><div class=browse-edit><span><i class=cheque-icon></i></span><p class=drop-text>Drag and drop your cancelled cheque leaf<br>or</p><span class=browse-edit><input type=file id=changeImg accept=.jpeg,.jpg,.png file-model-profile=\"\" upload=\"\"><label for=changeImg></label><a class=\"browse cursor-pointer\">Browse</a></span></div></div></div></div></div></div><div class=\"row form-footer\"><div class=col-md-8><p class=strong>Terms &amp; Conditions</p><span class=checkbox><input type=checkbox> <span class=icon-checkbox></span> <span class=\"checkbox-text tnc\">I have read and understood <a href=\"\">Terms &amp; Conditions</a> of Investment</span></span></div><div class=col-md-4><button class=\"btn btn-secondary-action common-btn-padding\">Save</button> <button class=\"btn btn-primary-action common-btn-padding\">Submit</button></div></div></form></div></section></div>");
$templateCache.put("app/registration/registration.html","<div><login-header></login-header><div class=\"side-nav-main-wrap row\"><div class=\"side-nav-container col-md-3\"><div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap\"><div class=\"col-md-12 height100\"><div class=side-nav-wrap><hdfc-login-sidebar></hdfc-login-sidebar></div></div></div></div><div class=\"col-md-offset-2 col-md-6 col-sm-12\"><div class=forms-container><div ui-view></div></div></div></div><footer-login></footer-login><div class=mobile-footer-blue><div class=mobile-footer-blue-container ui-sref=registerUser><img src=assets/images/newInvestor.svg class=investorIcon><div class=\"mainmenu-text mobile-footer-blue-text\">New Investor?</div></div><div class=\"mobile-footer-blue-container mobile-footer-seperator\" ui-sref=instantLogin><img src=assets/images/quickinvest.svg class=\"investorIcon mobile-footer-icon\"><div class=\"mainmenu-text mobile-footer-blue-text\">Quick Invest</div></div></div></div>");
$templateCache.put("app/registration/registration.kycVerification.html","<div class=\"row row-no-gutters\"><div class=\"col-md-12 form-existing-wrap\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=registration-forms><div class=login-header><div><h4>PAN Details</h4></div></div><div><form autocomplete=off ng-init=Registration.Init()><table class=table-data><tbody><tr><td>PAN</td><td>:</td><td class=text-uppercase>{{Registration.panToShow}}</td></tr><tr><td>KYC</td><td>:</td><td class=text-red>Not Available / Verified</td></tr></tbody></table><p>Please get your KYC Updated / Verified from respective KRA.</p><div class=\"btnContainer loginpwdBtn registraton-main-action\"><button type=submit class=\"loginBtn btn btn-bloc\" ui-sref=login>OK</button></div></form></div></div></div></div>");
$templateCache.put("app/registration/registration.main.html","<div class=\"row row-no-gutters\"><div class=\"col-md-12 form-existing-wrap\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=login-forms><div class=login-header><div><h4 class=existing-login-title>New Investor Registration</h4><div>Thanks for showing interest in investing with us.<br>To proceed with registration, Let us verify your details.</div></div></div><div><div class=\"loader pan-loader\" style=\"position: absolute\"><span class=loading></span></div><form autocomplete=off class=login-form name=signupForm ng-init=Registration.Init() ng-submit=Registration.verifyDetails() novalidate><div class=\"input-normal userID-input-container\" ng-class=\"{error:signupForm.pan.$dirty && signupForm.pan.$invalid || Registration.panMessage}\"><input tabindex=10 type=text placeholder=\"e.g. ABCDE1234A\" name=pan maxlength=10 minlength=10 ng-model=Registration.formData.pan ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-change=Registration.resetValues() ng-blur=Registration.checkPanVerification() capitalize required><label>PAN<span class=req>*</span></label><span ng-show=\"signupForm.pan.$dirty && signupForm.pan.$invalid\"><span class=error-input ng-show=signupForm.pan.$error.required ng-bind=Registration.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=signupForm.pan.$error.minlength ng-bind=Registration.validateData.PAN_FIELD></span> <span class=error-input ng-show=signupForm.pan.$error.maxlength ng-bind=Registration.validateData.PAN_FIELD></span> <span class=error-input ng-show=signupForm.pan.$error.pattern ng-bind=Registration.validateData.PAN_FIELD></span> </span><span class=error-input ng-if=Registration.panMessage ng-bind=Registration.panMessage></span> <span class=highlight></span> <span class=bar></span></div><div><div class=password-input-container><label>DOB (DD-MMM-YYYY)<span class=req>*</span></label><div class=\"input-select input-normal input-group date date-picker\" date-calendar data-enable=true data-viewmode={{Registration.viewMode}} data-date-default=Registration.formData.dob data-on-date-change=Registration.changeStartDate maxdate=now format=DD-MMM-YYYY id=endDate><input tabindex=11 id=dobId name=dob type=text autocomplete=off placeholder=DD-MMM-YYYY required> <span class=input-group-addon><img class=calender-icon-register src=assets/images/icons/dateIcon.png></span></div><span class=error ng-if=Registration.errorMessage><span class=\"error-message help-block\">{{ Registration.errorMessage }}</span></span></div></div><div class=\"checkbox form-check\"><input tabindex=12 type=checkbox style=\"width: 33%\" id=termNcondition name=termNcondition href=javascript:void(0) ng-click=Login.confirmRegister() ng-model=Registration.formData.termNcondition required> <i class=icon-checkbox></i> <span class=checkbox-text ng-show=Registration.showTerms>I have read and accepted the <a tabindex=13 ng-click=Registration.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a></span></div><div class=\"btnContainer loginpwdBtn registraton-main-action otp-button-placing\"><button tabindex=14 type=submit class=\"loginBtn btn btn-bloc\" ng-disabled=\"signupForm.pan.$invalid || !Registration.formData.dob || Registration.panMessage || Registration.processFlag || !Registration.formData.termNcondition \">Verify KYC</button> <a href=\"\" ng-click=Registration.confirmCancel() tabindex=15 class=cursor-pointer>Cancel<i class=cancel-icon></i></a></div></form></div></div></div></div>");
$templateCache.put("app/registration/registration.newInvestor.html","<div class=\"row row-no-gutters\"><div class=\"col-md-12 form-existing-wrap\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=registration-forms><div class=login-header><div><h4 class=existing-login-title>New Investor Registration</h4><div>Create User ID & Password to register successfully</div><div class=kyc-status><i class=verify-icon></i><span>Kyc {{Registration.status}}</span></div></div></div><div><form name=signupVerifyForm ng-init=\"Registration.Init(); Registration.pw=\'\';pw=\'\';\" ng-submit=Registration.verifyUser() autocomplete=off novalidate><div class=\"input-normal userID-input-container\" ng-class=\"{error:signupVerifyForm.userId.$dirty && signupVerifyForm.userId.$invalid || Registration.availableMessage}\"><input type=text ng-model=Registration.verifyForm.userId name=userId required minlength=6 maxlength=38 autofocus autocomplete=off ng-change=Registration.resetValues() ng-disabled=Registration.isUserId ng-blur=Registration.checkAvailability() ng-pattern=Registration.appConstants.userId_regex class=edit-input-padding> <img src=../../assets/images/icons/pencil.png ng-click=Registration.resetCreateUserId() class=input-edit-icon><label>User ID</label><span class=error-input ng-show=\"signupVerifyForm.userId.$dirty && signupVerifyForm.userId.$invalid\"><span ng-show=signupVerifyForm.userId.$error.required ng-bind=Registration.validateData.USER_ID_REQUIRED></span> <span ng-show=signupVerifyForm.userId.$error.minlength>{{ Registration.validateData.USER_ID_FIELD }}</span> <span ng-show=signupVerifyForm.userId.$error.pattern>{{ Registration.validateData.USER_ID_FIELD_PATTERN }}</span> </span><span class=error-input ng-if=Registration.availableMessage ng-bind=Registration.availableMessage></span> <span class=highlight></span> <span class=bar></span></div><div class=\"input-normal password-input-container\" ng-class=\"{error:signupVerifyForm.password.$dirty && signupVerifyForm.password.$invalid || Registration.isRequired || !Registration.isMatching}\" tooltips tooltip-template=\"Password should contain minimum 8 & maximum 15 characters, atleast one capital letter, one small letter, one number and one special character($@!_)\" tooltip-show-trigger=focusin , tooltip-show-trigger=focusout tooltip-side=left><input type=password ng-model=pw name=pwName id=pwId maxlength=15 ng-change=Registration.checkPattern(pw) autocomplete=off required><label>Password</label><span class=error-input ng-if=Registration.isRequired ng-bind=Registration.validateData.PASSWORD_REQUIRED></span> <span class=error-input ng-if=!Registration.isMatching ng-bind=Registration.validateData.PASSWORD_FIELD></span> <span class=highlight></span> <span class=bar></span><ul id=strength check-strength=pw></ul></div><div class=\"input-normal password-input-container\" ng-class=\"{error:signupVerifyForm.confirmPassword.$dirty && signupVerifyForm.confirmPassword.$invalid}\"><input type=password ng-model=Registration.verifyForm.confirmPassword name=confirmPassword ng-pattern=Registration.check4CofirmPW required autocomplete=off><label>Confirm Password</label><span ng-show=\"signupVerifyForm.confirmPassword.$dirty && signupVerifyForm.confirmPassword.$invalid\"><span class=error-input ng-show=signupVerifyForm.confirmPassword.$error.required ng-bind=Registration.validateData.CONFIRM_PASSWORD_REQUIRED></span> <span class=error-input ng-show=signupVerifyForm.confirmPassword.$error.pattern>{{ Registration.validateData.PASSWORD_MATCH }}</span> </span><span class=highlight></span> <span class=bar></span></div><div class=\"input-normal password-input-container\" ng-if=!Registration.verifyForm.emailAddress><input type=email name=email ng-pattern=Registration.EMAIL_PATTERN ng-model=Registration.verifyForm.emailId maxlength=150 required><label>Email ID</label><span ng-show=\"signupVerifyForm.email.$dirty && signupVerifyForm.email.$invalid\"><span class=error-input ng-show=signupVerifyForm.email.$error.pattern class=help-block ng-bind=Registration.validateData.EMAIL_FIELD></span> </span><span class=highlight></span> <span class=bar></span></div><div class=\"get-otp register-info-container\"><p>Verification link & OTP will be sent on the following:</p><div class=input-normal ng-if=Registration.verifyForm.emailAddress><i class=mail-icon></i> <input no-focus type=text ng-model=Registration.verifyForm.maskedEmail name=emailAddress class=pd40 disabled> <span class=highlight></span> <span class=bar></span></div><div class=\"input-normal get-otp\"><i class=mobile-icon></i> <input type=text ng-model=Registration.verifyForm.maskedMobile name=contact class=pd40 disabled> <span class=highlight></span> <span class=bar></span></div></div><span class=error ng-if=Registration.errorMessage><span class=\"error-all-message help-block\">{{ Registration.errorMessage }}</span></span><div class=\"btnContainer loginpwdBtn\" ng-class=\"{\'button-placing\' : Login.showSecStep}\"><button type=submit class=\"loginBtn btn btn-bloc\" ng-disabled=\"signupVerifyForm.$invalid || !Registration.isMatching || Registration.emailEdit || Registration.contactEdit ||\n              Registration.availableMessage || Registration.disableVerifyButton\">Verify</button></div></form></div></div></div></div>");
$templateCache.put("app/registration/registration.otp.html","<div class=\"row row-no-gutters\"><div class=\"col-md-12 form-existing-wrap\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=login-forms><div class=login-header><div class=header-action><a href=javascript:void(0) ui-sref=login ng-click=\"Registration.handleSideBarClick(\'EXISTING_USER\')\"><img src=assets/images/back-button.svg> Back to Login</a></div></div><div class=\"otm-container form-placing\"><form name=otpForm class=login-form ng-submit=Registration.confirmOtp() autocomplete=off novalidate ng-init=Registration.Init()><div class=\"input-normal userpan-input-container\" ng-class=\"{error:otpForm.otpNumber.$dirty && otpForm.otpNumber.$invalid}\"><input type=text ng-model=Registration.otpVerificationForm.otpNumber is-number ng-if=!Registration.inputReset ng-click=Registration.resetValues() autofocus minlength=6 maxlength=6 name=otpNumber autocomplete=off required><label>Enter OTP</label><span class=highlight></span> <span class=bar></span><div class=input-controls style=\"top: 45%\"><timer countdown=Registration.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a href=\"\" ng-click=Registration.reGenerateOtp() ng-class={anchorDisable:Registration.processOTPFlag} ng-show=\"countdown ==0\">Resend OTP</a></span></div></timer></div><span ng-show=\"otpForm.otpNumber.$dirty && otpForm.otpNumber.$invalid\"><span class=error-input ng-show=otpForm.otpNumber.$error.required ng-bind=Registration.appConstants.ToastrMessage.VALIDATE_DATA.OTP_REQUIRED></span> <span class=error-input ng-show=otpForm.otpNumber.$error.maxlength>{{ Registration.appConstants.ToastrMessage.VALIDATE_DATA.OTP_FIELD }}</span> <span class=error-input ng-show=otpForm.otpNumber.$error.minlength>{{ Registration.appConstants.ToastrMessage.VALIDATE_DATA.OTP_FIELD }}</span></span></div><div class=resend-otp-message style=\"margin-top: 20px\" ng-if=\"Registration.otpResendMessage || Registration.otpSentMessage\"><span ng-if=Registration.otpResendMessage class=\"form-group otpSucessText\">{{Registration.otpResendMessage}}</span> <span ng-if=Registration.otpSentMessage class=\"form-group otpSucessText\">{{Registration.otpSentMessage}}</span></div><span class=error ng-if=Registration.errorMessage><span class=\"error-all-message help-block\">{{ Registration.errorMessage }}</span> </span><!--<input id=\"submit\" type=\"submit\" class=\"btn btn-primary-action btn-block btn-submit\" value=\"Submit\">--><div class=\"btnContainer loginpwdBtn button-placing\"><button type=submit class=\"loginBtn btn btn-bloc\" ng-disabled=\"otpForm.$invalid || Registration.processFlag\">Submit</button></div></form></div></div></div></div>");
$templateCache.put("app/registration/registration.success.html","<form autocomplete=off><h3>New Investor Registration</h3><p>We have sent you an OTP on your registered email ID and mobile number.</p><div class=input-normal><input no-focus type=text required> <span class=highlight></span> <span class=bar></span> <span class=resend><a href=\"\" class=resend-otp>Resend OTP</a></span><label>Enter OTP</label></div><input id=submit type=submit class=\"btn btn-primary-action btn-block btn-submit\" value=Submit></form><!--v--><!--<div class=\"form-wrapper\">--><!--<h1>New Investor Registration</h1>--><!--<p class=\"info\">--><!--We have sent you an OTP on your registered email and mobile number.--><!--</p>--><!--<br/>--><!--<div class=\"input-normal\" ng-class=\"{error:Registration.otpForm.otpNumber.$dirty && Registration.otpForm.otpNumber.$invalid}\">--><!--<input ng-model=\"Registration.otpVerificationPayload.otpNumber\" ng-if=\"!Registration.inputReset\" ng-click=\"Registration.resetValues()\" type=\"text\" minlength=\"6\" maxlength=\"6\" name=\"otpNumber\" autocomplete=\"off\" required>--><!--<span class=\"highlight\"></span>--><!--<span class=\"bar\"></span>--><!--<span class=\"forgot\">--><!--<span ng-if=\"Registration.otpResendMessage\" style=\"color: #1bb898\">{{Registration.otpResendMessage}}</span>--><!--<span class=\"error\" ng-if=\"Registration.errorMessage!=\'SUCCESS\' && !Registration.otpForm.otpNumber.$error.required\">--><!--<span class=\"error-message help-block\">{{ Registration.errorMessage }}</span>--><!--</span>--><!--<a ng-click=\"Registration.reGenerateOtp()\" ng-disabled=\"Registration.processOTPFlag\" class=\"resend-otp cursor-pointer\">Resend OTP</a>--><!--</span>--><!--<label>Enter OTP</label>--><!--<span ng-show=\"Registration.otpForm.otpNumber.$dirty && Registration.otpForm.otpNumber.$invalid\">--><!--<span class=\"error-input\" ng-show=\"Registration.otpForm.otpNumber.$error.required\" ng-bind=\"Registration.appConstants.ToastrMessage.VALIDATE_DATA.OTP_REQUIRED\"></span>--><!--<span class=\"error-input\" ng-show=\"Registration.otpForm.otpNumber.$error.maxlength\">{{ Registration.appConstants.ToastrMessage.VALIDATE_DATA.OTP_FIELD }}</span>--><!--<span class=\"error-input\" ng-show=\"Registration.otpForm.otpNumber.$error.minlength\">{{ Registration.appConstants.ToastrMessage.VALIDATE_DATA.OTP_FIELD }}</span>--><!--</span>--><!--</div>--><!--<form>--><!--<button ui-sref=\"login\" class=\"btn btn-primary-action btn-block verify\">Submit</button>--><!--</form>--> <!--</div>-->");
$templateCache.put("app/registration/registration.user.html","<login-header></login-header><div class=login-sceen-container><div class=\"container login-screen global-login\"><div class=row><div class=\"col-md-4 align-right-padding col-xs-12\"><div class=\"page-tabs page-tab-left-border TabActive login-text-active\"><img src=../../assets/images/reg-Icon.png class=tabImg>REGISTER</div></div><div class=\"col-md-4 align-center-padding col-xs-12\"><div class=\"page-tabs page-tab-center-border login-text-primary pointer\" ui-sref=login><img src=../../assets/images/log-icon.png class=tabImg>LOGIN</div></div><div class=\"col-md-4 align-left-padding col-xs-12\"><div class=\"page-tabs page-tab-right-bottom login-text-primary pointer\" ui-sref=updateContactLogin><img src=../../assets/images/update-icon.png class=tabImgUpdate>UPDATE CONTACT</div></div></div><div class=\"row flex-style login-body\"><!--Left Section--><section class=\"col-xs-12 pull-left col-md-10\"><div class=\"cardBody col-md-5 animate\"><img src=../../assets/images/register-img.png class=iconRegister><br><span class=\"login-text-primary card-text\">New Investors</span><br><button class=\"card-button card-button-invest\" href=javascript:void(0) ng-click=Registration.confirmRegister()>REGISTER NOW</button></div><div class=\"cardBody col-lg-offset-1 col-md-5 animate\"><img src=../../assets/images/userId-Img.png class=iconRegister><br><span class=\"login-text-primary card-text\">Existing Offline /<br>Old Portal Investors</span><br><button class=card-button href=javascript:void(0) ui-sref=createUserId.verifyAccountDetails>CREATE USER ID</button></div></section><section class=\"col-xs-12 col-md-6 pull-left\"><div class=side-image-container><img src=../../assets/images/reg-img.jpg class=\"side-image reg-side-image-setup\"></div></section></div><div class=\"login-text-primary needAsst registrationNeedAsst\">NEED ASSISTANCE? <span class=faqNeedAsst><a ui-sref=faq>&nbsp;FAQS</a></span></div></div></div><footer-login></footer-login>");
$templateCache.put("app/savedItems/savedItems.html","<div class=\"main-section clearfix saved-items\" ng-init=SavedItems.init()><h3 class=screen-title>Saved Items</h3><div class=content-area><div class=unfinished-schedule-transactions ng-if=\"SavedItems.scheduledTransaction.scheduledTransactionList && SavedItems.scheduledTransaction.scheduledTransactionTotalLength > 0\"><p class=strong>Scheduled Transactions</p><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Transaction</th><th>Scheme name</th><th>Scheduled On</th><th>Scheduled date</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in SavedItems.scheduledTransaction.scheduledTransactionList | limitTo: SavedItems.scheduledTransaction.unfinishedScheduledTransactionListLimit\"><td data-th=Transaction>{{item.transactionType}}</td><td data-th=\"Scheme name\"><span ng-if=\"item.defaultSourceSchemeName == null\">--</span>{{item.defaultSourceSchemeName}}</td><td data-th=\"Initiate date\">{{item.createdDate | dateformatter: \'DD-MMM-YYYY\'}}</td><td data-th=\"Schedule transaction date\">{{item.scheduleDate | dateformatter: \'DD-MMM-YYYY\'}}</td><td data-th=Action><span class=delete ng-click=SavedItems.scheduledTransaction.cancelScheduledTransactions({tID:item.transactionId,ctID:item.compositeTransactionId,tType:item.transactionType})>Cancel</span>&nbsp|&nbsp<span class=view ng-click=SavedItems.scheduledTransaction.viewSchduledTransactions({tID:item.transactionId,ctID:item.compositeTransactionId,tType:item.transactionType})>View</span></td></tr></tbody></table><span ng-show=SavedItems.scheduledTransaction.showViewMoreFlag ng-click=SavedItems.scheduledTransaction.showMore() class=\"pull-right view-more\"><i class=expand-block-icon></i> View More</span></div><div class=unfinished-transactions ng-if=\"SavedItems.trans.unfinishedTransactionList && SavedItems.trans.unFinTransTotalLength>0\"><p class=strong>Unfinished Transactions</p><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Folio Number</th><th>Transaction</th><th>Scheme name</th><th>Initiate date</th><th>Last modified date</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in SavedItems.trans.unfinishedTransactionList | limitTo: SavedItems.trans.unfinishedTransactionListLimit\"><td data-th=\"Folio Number\">{{item.folioNumber}}</td><td ng-if=\"item.type !==\'FLEXSIP\'\" data-th=Transaction>{{item.type == \'DTP\' ? \'TIP\' : item.type}}</td><td ng-if=\"item.type ===\'FLEXSIP\'\" data-th=Transaction>Flex SIP</td><td data-th=\"Scheme name\"><span ng-if=\"item .schemeName == null\">--</span>{{item.schemeName}}</td><td data-th=\"Initiate date\">{{item.initiateDate}}</td><td data-th=\"Last modified date\">{{item.lastModificationDate}}</td><td data-th=Action><span class=delete ng-click=SavedItems.trans.deleteTransactions(item)>Delete</span>&nbsp|&nbsp <span class=view ng-click=\"SavedItems.trans.viewTransactions({\n                    tID:item.transactionId,\n                    ctID:item.compositeTransactionId,\n                    tType:item.transactionType,\n                    tFolio:item.folioNumber,\n                    validFolio:item.validFlag,folioMsg:item.invalidFolioMessage})\">View</span></td></tr></tbody></table><span ng-show=SavedItems.trans.showViewMoreFlag ng-click=SavedItems.trans.showMore() class=\"pull-right view-more\"><i class=expand-block-icon></i> View More</span></div><div class=unfinished-folios ng-if=\"SavedItems.folios.unfinishedFoliosList && SavedItems.folios.unFinFoliosTotalLength > 0\"><p class=strong>Unfinished Folio</p><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Holding mode</th><th>Tax status</th><th>Last modified date</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in SavedItems.folios.unfinishedFoliosList\" ng-if=item.folioId><td data-th=\"Holding mode\">{{item.holdingStatusDescription}}</td><td data-th=\"Tax status\">{{item.taxStatusDescription}}</td><td data-th=\"Last modified date\">{{item.lastModified}}</td><td data-th=Action><span class=delete ng-click=SavedItems.folios.deleteFolios(item)>Delete</span>&nbsp|&nbsp <span class=view ng-click=\"SavedItems.folios.viewFolios({\n                    uuid:item.folioId,\n                    kycVerifiedFlag: SavedItems.folios.kycVerifiedFlag,\n                    kycMessage: SavedItems.folios.kycMessage,\n                    panAadharVerifiedFlag: item.panAadharVerifiedFlag,\n                    panAadharMessage: item.panAadharMessage\n                  })\">View</span></td></tr></tbody></table></div><div class=no-data ng-if=\"(SavedItems.folios.unFinFoliosTotalLength === 0) && (SavedItems.trans.unFinTransTotalLength === 0) &&  (SavedItems.scheduledTransaction.scheduledTransactionTotalLength === 0)\"><p class=strong>No Scheduled Transaction, Unfinished Transactions or Folio</p></div></div></div>");
$templateCache.put("app/statements/statements.html","<login-header ng-if=\"$state.current.name === \'exposedStatements\'\"></login-header><div class=\"main-section statements\" ng-class=\"{\'exposed\':Statements.sessionId}\" ng-init=Statements.init()><h3 class=screen-title>Statements</h3><div class=content-area><div class=tabheads><div id=_first class=tabhead ng-class=\"{\'active-tab\':Statements.selectedTab==\'classic\'}\" ng-click=\"Statements.changeSelectedTab(\'classic\')\">Account Statement</div><div id=_capital class=tabhead ng-class=\"{\'active-tab\':Statements.selectedTab==\'capital\'}\" ng-click=\"Statements.changeSelectedTab(\'capital\')\">Capital Gain Statement</div><div class=tabhead ng-class=\"{\'active-tab\':Statements.selectedTab==\'balance\'}\" ng-click=\"Statements.changeSelectedTab(\'balance\')\">Balance Confirmation Report</div><div class=tabhead ng-class=\"{\'active-tab\':Statements.selectedTab==\'dividend\'}\" ng-click=\"Statements.changeSelectedTab(\'dividend\')\">IDCW Statement</div><div class=tabhead ng-class=\"{\'active-tab\':Statements.selectedTab==\'exitLoad\'}\" ng-click=\"Statements.changeSelectedTab(\'exitLoad\')\">Exit Load Statement</div></div><div class=\"tab-body clearfix\" id=classicStatements ng-if=\"Statements.selectedTab==\'classic\'\"><form name=tForm><!--<div class=\"row form-group\">\n      <div class=\"col-md-6\">\n        <a target=\"_blank\" href=\"{{Statements.HDFC_API.WEBSITE_LINK}}investorcorner/requesting-a-statement\">Download Reports in other than English language.</a>\n      </div>\n    </div>--><div class=\"row form-group\" ng-if=!Statements.sessionId><div class=col-md-3><div class=selectfield ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\"><select name=folio ng-change=Statements.folioChanged(Statements.formData.folioNumber) ng-model=Statements.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.validFolio) for folio in Statements.folioList\" ng-init=\"Statements.formData.folioNumber = Statements.formData.folioNumber? Statements.formData.folioNumber: null\" required><option value=\"\">Folio Number</option></select><label ng-if=Statements.formData.folioNumber>Folio Number</label><span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\"><span class=error-input ng-show=tForm.folio.$error.required ng-bind=Statements.VALIDATE_DATA.FOLIO_REQUIRED></span></span></div></div></div><div class=\"row form-group\" ng-if=Statements.sessionId><div class=col-md-3><strong>Folio Number : </strong><span ng-bind=Statements.formData.folioNumber></span></div></div><!--Commented for HMF-24569--><!--<div class=\"row form-group\" >\n      <div class=\"col-md-3\" ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber, \'anything-disabled schemeDisabled\':  Statements.formData.folioNumber && Statements.schemeList.length === 0}\">\n        <div class=\"selectfield\"\n             ng-class=\"{error:tForm.scheme.$dirty && tForm.scheme.$invalid}\">\n          <select name=\"scheme\" ng-if=\"!Statements.formData.folioNumber\">\n            <option value=\"\">Select Scheme</option>\n          </select>\n          <select name=\"scheme\" ng-if=\"Statements.formData.folioNumber\"\n                  ng-change=\"Statements.schemeChanged(Statements.formData.scheme)\"\n                  ng-model=\"Statements.formData.scheme\"\n                  ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Statements.schemeList\"\n                  ng-init=\"Statements.formData.scheme = Statements.formData.scheme? Statements.formData.scheme: null\"\n                  ng-disabled=\"Statements.schemeList.length === 0\" ng-required=\"Statements.schemeList.length > 0\">\n            <option value=\"\">Select Scheme</option>\n          </select>\n          <label ng-if=\"Statements.formData.folioNumber && Statements.formData.scheme\">Select Scheme</label>\n          <p class=\"info-primary\" ng-if=\"Statements.formData.folioNumber && Statements.schemeList.length === 0\"><i class=\"info-icon\"></i><span>{{Statements.schemeNotAvailable}}</span></p>\n          <span ng-show=\"tForm.scheme.$dirty && tForm.scheme.$invalid\">\n          <span class=\"error-input\" ng-show=\"tForm.scheme.$error.required\"\n                ng-bind=\"Statements.VALIDATE_DATA.SCHEME_REQUIRED\"></span>\n            </span>\n        </div>\n      </div>\n    </div>--><div class=\"row form-group\"><p class=\"form-group col-md-12\"><strong>Statement Options</strong></p><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.FULL ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Full Statement</span></div></div><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.PREVIOUS ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Previous F.Y</span></div></div><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.CURRENT ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Current F.Y</span></div></div><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.PERIOD ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Period</span></div></div></div><div class=\"row form-group\" ng-if=\"Statements.formData.statementOption==\'P\'\"><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker Statements-cal\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.startDate data-on-date-change=Statements.changeStartDate maxdate=now format=DD-MMM-YYYY id=startDateClassic ng-class={error:Statements.tForm.startDate.$invalid}><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.startDate.$error.required ng-bind=Statements.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div><div class=\"col-md-1 text-center mid-text\">To</div><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker Statements-cal\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.endDate data-enabled-dates=Statements.enabledEndDates data-on-date-change=Statements.changeEndDate min-date=Statements.formData.minEndDate max-date=now data-format=DD-MMM-YYYY data-showdefault=false id=endDateClassic1 ng-class={error:Statements.tForm.endDate.$invalid}><input type=text name=endDate placeholder=\"End Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.endDate.$error.required ng-bind=Statements.VALIDATE_DATA.END_DATE_REQUIRED></span></div></div></div><div class=\"form-footer col-md-12\"><!--<button class=\" btn btn-secondary-action\" ng-click=\"Statements.saveForm()\">Cancel</button>--> <button ng-if=\"Statements.selectedTab==\'classic\'\" ng-disabled=\"tForm.$invalid||(Statements.formData.statementOption==\'P\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=\"Statements.generateStatement(\'classic\')\" class=\"btn btn-primary-action\">Email</button> <button ng-if=\"Statements.selectedTab==\'classic\' && Statements.enableDownloadCTA\" ng-disabled=\"tForm.$invalid||(Statements.formData.statementOption==\'P\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=\"Statements.downloadStatement(\'classic\')\" class=\"btn btn-primary-action\">Download</button></div></form></div><div class=tab-body id=capitalStatements ng-if=\"Statements.selectedTab==\'capital\'\"><form name=tForm><div class=\"row form-group\" ng-if=!Statements.sessionId><div class=col-md-3><div class=selectfield ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\"><select name=folio ng-change=Statements.folioChanged(Statements.formData.folioNumber) ng-model=Statements.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.validFolio) for folio in Statements.folioList\" ng-init=\"Statements.formData.folioNumber = Statements.formData.folioNumber? Statements.formData.folioNumber: null\" required><option value=\"\">Folio Number</option></select><label ng-if=Statements.formData.folioNumber>Folio Number</label><span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\"><span class=error-input ng-show=tForm.folio.$error.required ng-bind=Statements.VALIDATE_DATA.FOLIO_REQUIRED></span> </span></div></div></div><div class=\"row form-group\" ng-if=Statements.sessionId><div class=col-md-3><strong>Folio Number : </strong><span ng-bind=Statements.formData.folioNumber></span></div></div><div class=\"row form-group\"><p class=\"form-group col-md-12\"><strong>Statement Options</strong></p><div class=col-md-2><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.CAPITAL_GAIN_STATEMENT_OPTION.FULL ng-click=Statements.transferOptionChanged();> <span class=check></span> </span><span class=radio-label>Full Statement</span></div></div><div class=col-md-2><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.CAPITAL_GAIN_STATEMENT_OPTION.CURRENT ng-click=Statements.transferOptionChanged();> <span class=check></span> </span><span class=radio-label>Current F.Y</span></div></div><div class=col-md-2><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.CAPITAL_GAIN_STATEMENT_OPTION.PREVIOUS ng-click=Statements.transferOptionChanged();> <span class=check></span> </span><span class=radio-label>Previous F.Y</span></div></div><div class=col-md-2><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.CAPITAL_GAIN_STATEMENT_OPTION.PERIOD ng-click=Statements.transferOptionChanged();> <span class=check></span> </span><span class=radio-label>Period</span></div></div></div><div class=\"row form-group\" ng-if=\"Statements.formData.statementOption==\'SD\'\"><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker Statements-cal\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.startDate data-on-date-change=Statements.changeCaptailGainStartDate data-max-date=Statements.startMaxDate format=DD-MMM-YYYY id=startDateCapital ng-class={error:Statements.tForm.startDate.$invalid}><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.startDate.$error.required ng-bind=Statements.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div><div class=\"col-md-1 text-center mid-text\">To</div><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker Statements-cal\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.endDate data-enabled-dates=Statements.capitalGainEnabledEndDates data-on-date-change=Statements.changeEndDate min=Statements.formData.minEndDate data-format=DD-MMM-YYYY data-max-date=Statements.endMaxDate data-showdefault=false id=endDateCapital ng-class={error:Statements.tForm.endDate.$invalid}><input type=text name=endDate placeholder=\"End Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.endDate.$error.required ng-bind=Statements.VALIDATE_DATA.END_DATE_REQUIRED></span></div></div></div><div class=\"form-footer col-md-12\"><!--<button class=\" btn btn-secondary-action\" ng-click=\"Statements.saveForm()\">Cancel</button>--> <button ng-if=\"Statements.selectedTab==\'capital\'\" ng-disabled=\"tForm.$invalid||(Statements.formData.statementOption==\'SD\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=\"Statements.generateStatement(\'capital\')\" class=\"btn btn-primary-action\">Email</button> <button ng-if=\"Statements.selectedTab==\'capital\' && Statements.formData.statementOption !== Statements.CAPITAL_GAIN_STATEMENT_OPTION.FULL && Statements.enableDownloadCTA\" ng-disabled=\"tForm.$invalid||(Statements.formData.statementOption==\'SD\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=\"Statements.downloadStatement(\'capital\')\" class=\"btn btn-primary-action\">Download</button></div></form></div><div class=tab-body id=balanceStatements ng-if=\"Statements.selectedTab==\'balance\'\"><form name=tForm><div class=\"row form-group\" ng-if=!Statements.sessionId><div class=col-md-3><div class=selectfield ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\"><select name=folio ng-change=Statements.folioChanged(Statements.formData.folioNumber) ng-model=Statements.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.validFolio) for folio in Statements.folioList\" ng-init=\"Statements.formData.folioNumber = Statements.formData.folioNumber? Statements.formData.folioNumber: null\" required><option value=\"\">Folio Number</option></select><label ng-if=Statements.formData.folioNumber>Folio Number</label><span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\"><span class=error-input ng-show=tForm.folio.$error.required ng-bind=Statements.VALIDATE_DATA.FOLIO_REQUIRED></span></span></div></div></div><div class=\"row form-group\" ng-if=Statements.sessionId><div class=col-md-3><strong>Folio Number : </strong><span ng-bind=Statements.formData.folioNumber></span></div></div><div class=\"row form-group\"><div class=col-md-3 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=selectfield ng-class=\"{error:tForm.scheme.$dirty && tForm.scheme.$invalid && Statements.formData.folioNumber}\"><select name=scheme ng-change=Statements.schemeChanged(Statements.formData.scheme) ng-model=Statements.formData.scheme ng-options=\"_scheme.schemeName for _scheme in Statements.schemeList track by _scheme.schemeCode\" ng-init=\"Statements.formData.scheme = Statements.formData.scheme? Statements.formData.scheme: null\" required><option value=\"\">Select Scheme</option></select><label ng-if=\"Statements.formData.folioNumber && Statements.formData.scheme\">Select Scheme</label><span ng-show=\"tForm.scheme.$dirty && tForm.scheme.$invalid && Statements.formData.folioNumber\"><span class=error-input ng-show=tForm.scheme.$error.required ng-bind=Statements.VALIDATE_DATA.SCHEME_REQUIRED></span></span></div></div></div><div class=\"form-footer col-md-12\"><!--<button class=\" btn btn-secondary-action\" ng-click=\"Statements.saveForm()\">Cancel</button>--> <button ng-if=\"Statements.selectedTab==\'balance\'\" ng-disabled=\"tForm.$invalid \" ng-click=\"Statements.generateStatement(\'balance\')\" class=\"btn btn-primary-action\">Send</button> <button ng-if=\"Statements.selectedTab==\'balance\' && Statements.enableDownloadCTA\" ng-disabled=\"tForm.$invalid \" ng-click=\"Statements.downloadStatement(\'balance\')\" class=\"btn btn-primary-action\">Download</button></div></form></div><div class=tab-body id=dividendStatements ng-if=\"Statements.selectedTab==\'dividend\'\"><form name=tForm><div class=\"row form-group\" ng-if=!Statements.sessionId><div class=col-md-3><div class=selectfield ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\"><select name=folio ng-change=Statements.folioChanged(Statements.formData.folioNumber) ng-model=Statements.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.validFolio) for folio in Statements.folioList\" ng-init=\"Statements.formData.folioNumber = Statements.formData.folioNumber? Statements.formData.folioNumber: null\" required><option value=\"\">Folio Number</option></select><label ng-if=Statements.formData.folioNumber>Folio Number</label><span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\"><span class=error-input ng-show=tForm.folio.$error.required ng-bind=Statements.VALIDATE_DATA.FOLIO_REQUIRED></span></span></div></div></div><div class=\"row form-group\" ng-if=Statements.sessionId><div class=col-md-3><strong>Folio Number : </strong><span ng-bind=Statements.formData.folioNumber></span></div></div><div class=\"row form-group\"><p class=\"form-group col-md-12\"><strong>Statement Options</strong></p><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.FULL ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Full Statement</span></div></div><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.PREVIOUS ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Previous F.Y</span></div></div><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.CURRENT ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Current F.Y</span></div></div><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.PERIOD ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Period</span></div></div></div><div class=\"row form-group\" ng-if=\"Statements.formData.statementOption==\'P\'\"><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker Statements-cal\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.startDate data-on-date-change=Statements.changeStartDate maxdate=now format=DD-MMM-YYYY id=startDateDividend ng-class={error:Statements.tForm.startDate.$invalid}><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.startDate.$error.required ng-bind=Statements.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div><div class=\"col-md-1 text-center mid-text\">To</div><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker Statements-cal\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.endDate data-enabled-dates=Statements.enabledEndDates data-on-date-change=Statements.changeEndDate min=Statements.formData.minEndDate data-format=DD-MMM-YYYY max=now data-showdefault=false id=endDateDividend ng-class={error:Statements.tForm.endDate.$invalid}><input type=text name=endDate placeholder=\"End Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.endDate.$error.required ng-bind=Statements.VALIDATE_DATA.END_DATE_REQUIRED></span></div></div></div><div class=\"form-footer col-md-12\"><!--<button class=\" btn btn-secondary-action\" ng-click=\"Statements.saveForm()\">Cancel</button>--> <button ng-if=\"Statements.selectedTab==\'dividend\'\" ng-disabled=\"tForm.$invalid||(Statements.formData.statementOption==\'P\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=\"Statements.generateStatement(\'dividend\')\" class=\"btn btn-primary-action\">Send</button> <button ng-if=\"Statements.selectedTab==\'dividend\' && Statements.enableDownloadCTA\" ng-disabled=\"tForm.$invalid||(Statements.formData.statementOption==\'P\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=\"Statements.downloadStatement(\'dividend\')\" class=\"btn btn-primary-action\">Download</button></div></form></div><div class=tab-body id=exitLoadStatements ng-if=\"Statements.selectedTab==\'exitLoad\'\"><form name=tForm><div class=\"row form-group\" ng-if=!Statements.sessionId><div class=col-md-3><div class=selectfield ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\"><select name=folio ng-change=Statements.folioChanged(Statements.formData.folioNumber) ng-model=Statements.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.validFolio) for folio in Statements.folioList\" ng-init=\"Statements.formData.folioNumber = Statements.formData.folioNumber? Statements.formData.folioNumber: null\" required><option value=\"\">Folio Number</option></select><label ng-if=Statements.formData.folioNumber>Folio Number</label><span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\"><span class=error-input ng-show=tForm.folio.$error.required ng-bind=Statements.VALIDATE_DATA.FOLIO_REQUIRED></span></span></div></div></div><div class=\"row form-group\" ng-if=Statements.sessionId><div class=col-md-3><strong>Folio Number : </strong><span ng-bind=Statements.formData.folioNumber></span></div></div><div class=\"row form-group\"><div class=col-md-3 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=selectfield ng-class=\"{error:tForm.scheme.$dirty && tForm.scheme.$invalid && Statements.formData.folioNumber}\"><select name=scheme ng-change=Statements.schemeChanged(Statements.formData.scheme) ng-model=Statements.formData.schemeCode ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Statements.schemeList\" ng-init=\"Statements.formData.schemeCode = Statements.formData.schemeCode? Statements.formData.schemeCode: null\" required><option value=\"\">Select Scheme</option></select><label ng-if=\"Statements.formData.folioNumber && Statements.formData.scheme\">Select Scheme</label><span ng-show=\"tForm.scheme.$dirty && tForm.scheme.$invalid && Statements.formData.folioNumber\"><span class=error-input ng-show=tForm.scheme.$error.required ng-bind=Statements.VALIDATE_DATA.SCHEME_REQUIRED></span></span></div></div></div><div class=\"form-footer col-md-12\"><button ng-if=Statements.sessionId type=button class=\"pull-left btn btn-secondary-action\" ng-click=Statements.redirectToLogin()>Cancel</button><!--<button class=\" btn btn-secondary-action\" ng-click=\"Statements.saveForm()\">Cancel</button>--> <button ng-if=\"Statements.selectedTab==\'exitLoad\'\" ng-disabled=\"tForm.$invalid \" ng-click=\"Statements.generateStatement(\'exitLoad\')\" class=\"btn btn-primary-action\">Send</button> <button ng-if=\"Statements.selectedTab==\'exitLoad\' && Statements.enableDownloadCTA\" ng-disabled=\"tForm.$invalid \" ng-click=\"Statements.downloadStatement(\'exitLoad\')\" class=\"btn btn-primary-action\">Download</button></div></form></div></div></div>");
$templateCache.put("app/subscription-valuation/Subscription-status.html","<section class=\"main-section clearfix subscription-valuation\" ng-init=SubscriptionValuation.init()><div class=subscription-header><p class=screen-title>Subscriptions of {{SubscriptionValuation.subscriptionType}} Valuation</p></div><div class=content-area><table class=table ng-if=\"SubscriptionValuation.subscriptionType==\'Folio\'\"><thead><tr><th>Folio</th><th>Status</th><th>Reason</th></tr></thead><tbody><tr ng-if=SubscriptionValuation.successSet ng-repeat=\"success in SubscriptionValuation.successSet\"><td>{{success}}</td><td><strong class=text-success>SUCCESS</strong></td><td>NA</td></tr><tr ng-if=SubscriptionValuation.failureSet ng-repeat=\"failure in SubscriptionValuation.failureSet\"><td>{{failure.folioNumber}}</td><td><strong class=text-danger>FAILED</strong></td><td>{{failure.message}}</td></tr></tbody></table><table class=table ng-if=\"SubscriptionValuation.subscriptionType==\'Scheme\'\"><thead><tr><th>Scheme</th><th>Status</th><th>Reason</th></tr></thead><tbody><tr ng-if=SubscriptionValuation.successSet ng-repeat=\"success in SubscriptionValuation.successSet\"><td>{{success.schemeName}}</td><td><strong class=text-success>SUCCESS</strong></td><td>NA</td></tr><tr ng-if=SubscriptionValuation.failureSet ng-repeat=\"failure in SubscriptionValuation.failureSet\"><td>{{failure.schemeName}}</td><td><strong class=text-danger>FAILED</strong></td><td>{{failure.message}}</td></tr></tbody></table><div class=content-foot><a href=\"\" ng-if=\"SubscriptionValuation.subscriptionType==\'Folio\'\" class=\"cursor-pointer text-primary\" ui-sref=main.subscriptionValuation.folio-valuation><i class=arrow-blue-back-icon></i>Back</a> <a href=\"\" ng-if=\"SubscriptionValuation.subscriptionType==\'Scheme\'\" class=\"cursor-pointer text-primary\" ui-sref=main.subscriptionValuation.nav><i class=arrow-blue-back-icon></i>Back</a> <button class=\"btn-primary-action btn pull-right\" ui-sref=home>Go to home</button></div></div></section>");
$templateCache.put("app/subscription-valuation/Subscription-unsubscribe.html","<section class=\"main-section clearfix subscription-valuation\" ng-init=SubscriptionValuation.init()><div class=subscription-header><p class=screen-title>Unsubscriptions of {{SubscriptionValuation.subscriptionType}} Valuation</p></div><div class=content-area><table class=table ng-if=\"SubscriptionValuation.subscriptionType==\'Folio\'\"><thead><tr><th>Folio</th><th>Status</th><th>Reason</th></tr></thead><tbody><tr ng-if=SubscriptionValuation.successSet ng-repeat=\"success in SubscriptionValuation.successSet\"><td>{{success}}</td><td><strong class=text-success>SUCCESS</strong></td><td>NA</td></tr><tr ng-if=SubscriptionValuation.failureSet ng-repeat=\"failure in SubscriptionValuation.failureSet\"><td>{{failure.folioNumber}}</td><td><strong class=text-danger>FAILED</strong></td><td>{{failure.message}}</td></tr></tbody></table><table class=table ng-if=\"SubscriptionValuation.subscriptionType==\'Scheme\'\"><thead><tr><th>Scheme</th><th>Status</th><th>Reason</th></tr></thead><tbody><tr ng-if=SubscriptionValuation.successSet ng-repeat=\"success in SubscriptionValuation.successSet\"><td>{{success}}</td><td><strong class=text-success>SUCCESS</strong></td><td>NA</td></tr><tr ng-if=SubscriptionValuation.failureSet ng-repeat=\"failure in SubscriptionValuation.failureSet\"><td>{{failure.schemeName}}</td><td><strong class=text-danger>FAILED</strong></td><td>{{failure.message}}</td></tr></tbody></table><div class=content-foot><a href=\"\" ng-if=\"SubscriptionValuation.subscriptionType==\'Folio\'\" class=\"cursor-pointer text-primary\" ui-sref=main.subscriptionValuation.folio-valuation><i class=arrow-blue-back-icon></i>Back</a> <a href=\"\" ng-if=\"SubscriptionValuation.subscriptionType==\'Scheme\'\" class=\"cursor-pointer text-primary\" ui-sref=main.subscriptionValuation.nav><i class=arrow-blue-back-icon></i>Back</a> <button class=\"btn-primary-action btn pull-right\" ui-sref=home>Go to home</button></div></div></section>");
$templateCache.put("app/subscription-valuation/subscriptionValuation.html","<section class=\"main-section clearfix subscription-valuation\"><div class=subscription-header><p class=screen-title>Subscriptions</p><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.portfolio.list>Portfolio </span><i class=breadcrumb-icon></i><span> Subscription Valuation</span></p></div><ul class=\"nav nav-tabs\"><li ui-sref-active=active><a ui-sref=main.subscriptionValuation.folio-valuation>Folio Valuation</a></li><li ui-sref-active=active><a ui-sref=main.subscriptionValuation.nav>NAVs</a></li></ul><div ui-view></div></section>");
$templateCache.put("app/systematic-corner/cancellation-details.html","<div class=\"main-section summary\" ng-init=Systematic.init()><div data-ng-switch=Systematic.review.type><div data-ng-switch-when=SIP><p class=page-title>SIP Cancellation Summary</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"Systematic.review.type===\'SIP\'\"><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have cancelled the following SIP</td></tr><!--              <tr>--><!--                <td>Status</td>--><!--                <td>:</td>--><!--                <td>Cancelled</td>--><!--              </tr>--><tr ng-if=Systematic.review.sipRegistrationNumber><td>SIP Registration Number</td><td>:</td><td>{{Systematic.review.sipRegistrationNumber}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Systematic.review.folioNumber}}</td></tr><tr><td>SIP Mode</td><td>:</td><td>{{Systematic.review.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.review.camsTransactionNumber}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Systematic.review.schemeName}}</td></tr><tr><td>SIP From Date</td><td>:</td><td>{{Systematic.review.fromDate}}</td></tr><tr><td>SIP To Date</td><td>:</td><td>{{Systematic.review.toDate}}</td></tr><tr><td>Number of Installments</td><td>:</td><td>{{Systematic.review.noOfInstallment}}</td></tr><tr><td>SIP Frequency</td><td>:</td><td>{{Systematic.review.frequency}}</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.review.amount}}</td></tr><tr ng-if=Systematic.review.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.review.distributor}}</td></tr></table></div></div></div></div><div data-ng-switch-when=DREAMSIP><p class=page-title>SIP Cancellation Summary</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"Systematic.review.type===\'DREAMSIP\'\"><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have cancelled the following SIP</td></tr><tr><td>Status</td><td>:</td><td>Cancelled</td></tr><tr><td>SIP Registration Number</td><td>:</td><td>{{Systematic.review.sipRegistrationNumber}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Systematic.review.folioNumber}}</td></tr><tr><td>SIP Mode</td><td>:</td><td>{{Systematic.review.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.review.camsTransactionNumber}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Systematic.review.schemeName}}</td></tr><tr><td>SIP From Date</td><td>:</td><td>{{Systematic.review.fromDate}}</td></tr><tr><td>SIP To Date</td><td>:</td><td>{{Systematic.review.toDate}}</td></tr><tr><td>Number of Installments</td><td>:</td><td>{{Systematic.review.noOfInstallment}}</td></tr><tr><td>SIP Frequency</td><td>:</td><td>{{Systematic.review.frequency}}</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.review.amount}}</td></tr><tr ng-if=Systematic.review.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.review.distributor}}</td></tr></table></div></div></div></div><div data-ng-switch-when=DTP><p class=page-title>DTP Cancellation Summary</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"Systematic.review.type===\'DTP\'\"><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have cancelled the following Transaction</td></tr><tr><td>Status</td><td>:</td><td>Cancelled</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Systematic.review.folioNumber}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Systematic.review.sourceScheme}}</td></tr><tr ng-if=Systematic.review.targetScheme><td>Target Scheme</td><td>:</td><td>{{Systematic.review.targetScheme}}</td></tr><tr><td>Mode</td><td>:</td><td>{{Systematic.review.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.review.camsTransactionNumber}}</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.review.amount}}</td></tr><tr><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.review.distributor}}</td></tr></table></div></div></div></div><div data-ng-switch-when=FLEXINDEX><p class=page-title>Flex Index Cancellation Summary</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"Systematic.review.type===\'FLEXINDEX\'\"><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have cancelled the following Transaction</td></tr><tr><td>Status</td><td>:</td><td>Cancelled</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Systematic.review.folioNumber}}</td></tr><tr><td>Mode</td><td>:</td><td>{{Systematic.review.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.review.camsTransactionNumber}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Systematic.review.sourceScheme}}</td></tr><tr ng-if=Systematic.review.targetScheme><td>Target Scheme</td><td>:</td><td>{{Systematic.review.targetScheme}}</td></tr><tr><td>From Date</td><td>:</td><td>{{Systematic.review.startDate}}</td></tr><tr><td>To Date</td><td>:</td><td>{{Systematic.review.endDate}}</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.review.amount}}</td></tr><tr><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.review.distributor}}</td></tr></table><table class=\"flex-table table\"><thead><tr><th>Installments</th><th>Stages of Switch Execution<br><span style=color:#737373>S&P BSE SENSEX Levels</span></th></tr></thead><tbody><tr><td>{{Systematic.review.switchExecutionDetails.firstSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(I) </span>{{Systematic.review.switchExecutionDetails.firstSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{Systematic.review.switchExecutionDetails.secondSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(II) </span>{{Systematic.review.switchExecutionDetails.secondSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{Systematic.review.switchExecutionDetails.thirdSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(III) </span>{{Systematic.review.switchExecutionDetails.thirdSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{Systematic.review.switchExecutionDetails.fourthSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(IV) </span>{{Systematic.review.switchExecutionDetails.fourthSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr></tbody></table></div></div></div></div><div data-ng-switch-when=SWP><p class=page-title>SWP Cancellation Summary</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"Systematic.review.type===\'SWP\'\"><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have cancelled the following Transaction</td></tr><tr><td>Status</td><td>:</td><td>Cancelled</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Systematic.review.folioNumber}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Systematic.review.sourceScheme}}</td></tr><tr ng-if=Systematic.review.targetScheme><td>Target Scheme</td><td>:</td><td>{{Systematic.review.targetScheme}}</td></tr><tr><td>Mode</td><td>:</td><td>{{Systematic.review.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.review.camsTransactionNumber}}</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.review.amount}}</td></tr><tr><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.review.distributor}}</td></tr><tr><td>Frequency</td><td>:</td><td>{{Systematic.review.frequency}}</td></tr><tr><td>From Date</td><td>:</td><td>{{Systematic.review.startDate}}</td></tr><tr><td>End Date</td><td>:</td><td>{{Systematic.review.endDate}}</td></tr></table></div></div></div></div><div data-ng-switch-when=\"SMART SWAP\"><p class=page-title>SMART SWAP Cancellation Summary</p><div class=content-area><div class=row><div class=col-md-7 ng-if=\"Systematic.review.type===\'SMART SWAP\'\"><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have cancelled the following SMART SWAP</td></tr><tr><td>Status</td><td>:</td><td>Cancelled</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Systematic.review.folioNumber}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Systematic.review.sourceScheme}}</td></tr><!--              <tr>--><!--                <td>Target Scheme</td>--><!--                <td>:</td>--><!--                <td>{{Systematic.review.targetScheme}}</td>--><!--              </tr>--><tr><td>Mode</td><td>:</td><td>{{Systematic.review.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.review.camsTransactionNumber}}</td></tr><tr><td>SMART SWAP Amount</td><td>:</td><td>{{Systematic.review.amount}}</td></tr><tr><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.review.distributor}}</td></tr><tr><td>Frequency</td><td>:</td><td>{{Systematic.review.frequency}}</td></tr><tr><td>SMART SWAP Start Date</td><td>:</td><td>{{Systematic.review.startDate}}</td></tr></table></div></div></div></div><div data-ng-switch-when=STP><p class=page-title>STP Cancellation Summary</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"Systematic.review.type===\'STP\'\"><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have cancelled the following Transaction</td></tr><tr><td>Status</td><td>:</td><td>Cancelled</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Systematic.review.folioNumber}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Systematic.review.sourceScheme}}</td></tr><tr ng-if=Systematic.review.targetScheme><td>Target Scheme</td><td>:</td><td>{{Systematic.review.targetScheme}}</td></tr><tr><td>Mode</td><td>:</td><td>{{Systematic.review.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.review.camsTransactionNumber}}</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.review.amount}}</td></tr><tr><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.review.distributor}}</td></tr><tr ng-if=Systematic.review.investmentOption><td>Investment Option</td><td>:</td><td>{{Systematic.review.investmentOption}}</td></tr><tr><td>Frequency</td><td>:</td><td>{{Systematic.review.frequency}}</td></tr><tr><td>From Date</td><td>:</td><td>{{Systematic.review.startDate}}</td></tr><tr><td>End Date</td><td>:</td><td>{{Systematic.review.endDate}}</td></tr></table></div></div></div></div><div data-ng-switch-when=FLEXSTP><p class=page-title>Flex STP Cancellation Summary</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"Systematic.review.type===\'FLEXSTP\'\"><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have cancelled the following Transaction</td></tr><tr><td>Status</td><td>:</td><td>Cancelled</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Systematic.review.folioNumber}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Systematic.review.sourceScheme}}</td></tr><tr ng-if=Systematic.review.targetScheme><td>Target Scheme</td><td>:</td><td>{{Systematic.review.targetScheme}}</td></tr><tr><td>Mode</td><td>:</td><td>{{Systematic.review.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.review.camsTransactionNumber}}</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.review.amount}}</td></tr><tr><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.review.distributor}}</td></tr><tr ng-if=Systematic.review.investmentOption><td>Investment Option</td><td>:</td><td>{{Systematic.review.investmentOption}}</td></tr><tr><td>Frequency</td><td>:</td><td>{{Systematic.review.frequency}}</td></tr><tr><td>From Date</td><td>:</td><td>{{Systematic.review.startDate}}</td></tr><tr><td>End Date</td><td>:</td><td>{{Systematic.review.endDate}}</td></tr></table></div></div></div></div><div data-ng-switch-when=\"Flex SIP\"><p class=page-title>{{Systematic.review.type}} Cancellation Summary</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"Systematic.review.type===\'Flex SIP\'\"><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have cancelled the following {{Systematic.review.type}}</td></tr><tr><td>Status</td><td>:</td><td>Cancelled</td></tr><tr><td>{{Systematic.review.type}} Registration Number</td><td>:</td><td>{{Systematic.review.sipRegistrationNumber}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Systematic.review.folioNumber}}</td></tr><tr><td>{{Systematic.review.type}} Mode</td><td>:</td><td>{{Systematic.review.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.review.camsTransactionNumber}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Systematic.review.schemeName}}</td></tr><tr><td>{{Systematic.review.type}} From Date</td><td>:</td><td>{{Systematic.review.fromDate}}</td></tr><tr><td>Flex SIP Tenure</td><td>:</td><td>{{Systematic.review.tenureDiff}} years</td></tr><tr><td>{{Systematic.review.type}} To Date</td><td>:</td><td>{{Systematic.review.toDate}}</td></tr><tr><td>Number of Installments</td><td>:</td><td>{{Systematic.review.noOfInstallment}}</td></tr><tr><td>{{Systematic.review.type}} Frequency</td><td>:</td><td>{{Systematic.review.frequency}}</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.review.amount}}</td></tr><tr ng-if=Systematic.review.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.review.distributor}}</td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/systematic-corner/cancellation-review.html","<div class=\"main-section summary\" ng-init=Systematic.init()><p class=page-title>Cancellation Details</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"Systematic.summary.type===\'SIP\' || Systematic.summary.type===\'Flex SIP\' || Systematic.summary.type===\'DREAM SIP\'\"><table class=\"table borderless\"><tr ng-if=Systematic.summary.sipRegistrationNumber><td>{{Systematic.summary.type}} Registration Number</td><td>:</td><td>{{Systematic.summary.sipRegistrationNumber}}</td></tr><tr ng-if=Systematic.summary.folioNumber><td>Folio Number</td><td>:</td><td>{{Systematic.summary.folioNumber}}</td></tr><tr ng-if=Systematic.summary.mode><td>{{Systematic.summary.type}} Mode</td><td>:</td><td>{{Systematic.summary.mode}}</td></tr><tr ng-if=Systematic.summary.camsTransactionNumber><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.summary.camsTransactionNumber}}</td></tr><tr ng-if=Systematic.summary.schemeName><td>Scheme Name</td><td>:</td><td>{{Systematic.summary.schemeName}}</td></tr><tr ng-if=Systematic.summary.fromDate><td>{{Systematic.summary.type}} From Date</td><td>:</td><td>{{Systematic.summary.fromDate}}</td></tr><tr ng-if=\"Systematic.summary.type === \'Flex SIP\'\"><td>Flex SIP Tenure</td><td>:</td><td>{{Systematic.summary.tenureDiff}} years</td></tr><tr ng-if=Systematic.summary.toDate><td>{{Systematic.summary.type}} To Date</td><td>:</td><td>{{Systematic.summary.toDate}}</td></tr><tr ng-if=Systematic.summary.noOfInstallment><td>Number of Installments</td><td>:</td><td>{{Systematic.summary.noOfInstallment}}</td></tr><tr ng-if=Systematic.summary.frequency><td>{{Systematic.summary.type}} Frequency</td><td>:</td><td>{{Systematic.summary.frequency}}</td></tr><tr ng-if=Systematic.summary.amount><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.summary.amount}}</td></tr><tr ng-if=Systematic.summary.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.summary.distributor}}</td></tr></table></div><div class=col-md-6 ng-if=\"Systematic.summary.type===\'DTP\'\"><table class=\"table borderless\"><tr ng-if=Systematic.summary.folioNumber><td>Folio Number</td><td>:</td><td>{{Systematic.summary.folioNumber}}</td></tr><tr ng-if=Systematic.summary.sourceScheme><td>Source Scheme</td><td>:</td><td>{{Systematic.summary.sourceScheme}}</td></tr><tr ng-if=Systematic.summary.targetScheme><td>Target Scheme</td><td>:</td><td>{{Systematic.summary.targetScheme}}</td></tr><tr ng-if=Systematic.summary.mode><td>Mode</td><td>:</td><td>{{Systematic.summary.mode}}</td></tr><tr ng-if=Systematic.summary.camsTransactionNumber><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.summary.camsTransactionNumber}}</td></tr><tr ng-if=Systematic.summary.amount><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.summary.amount}}</td></tr><tr ng-if=Systematic.summary.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.summary.distributor}}</td></tr></table></div><div class=col-md-6 ng-if=\"Systematic.summary.type===\'STP\'\"><table class=\"table borderless\"><tr ng-if=Systematic.summary.folioNumber><td>Folio Number</td><td>:</td><td>{{Systematic.summary.folioNumber}}</td></tr><tr ng-if=Systematic.summary.sourceScheme><td>Source Scheme</td><td>:</td><td>{{Systematic.summary.sourceScheme}}</td></tr><tr ng-if=Systematic.summary.targetScheme><td>Target Scheme</td><td>:</td><td>{{Systematic.summary.targetScheme}}</td></tr><tr ng-if=Systematic.summary.mode><td>Mode</td><td>:</td><td>{{Systematic.summary.mode}}</td></tr><tr ng-if=Systematic.summary.camsTransactionNumber><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.summary.camsTransactionNumber}}</td></tr><tr ng-if=Systematic.summary.amount><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.summary.amount}}</td></tr><tr ng-if=Systematic.summary.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.summary.distributor}}</td></tr><tr ng-if=Systematic.summary.frequency><td>Frequency</td><td>:</td><td>{{Systematic.summary.frequency}}</td></tr><tr ng-if=Systematic.summary.startDate><td>From Date</td><td>:</td><td>{{Systematic.summary.startDate}}</td></tr><tr ng-if=Systematic.summary.endDate><td>End Date</td><td>:</td><td>{{Systematic.summary.endDate}}</td></tr></table></div><div class=col-md-6 ng-if=\"Systematic.summary.type===\'SWP\'\"><table class=\"table borderless\"><tr ng-if=Systematic.summary.folioNumber><td>Folio Number</td><td>:</td><td>{{Systematic.summary.folioNumber}}</td></tr><tr ng-if=Systematic.summary.sourceScheme><td>Source Scheme</td><td>:</td><td>{{Systematic.summary.sourceScheme}}</td></tr><tr ng-if=Systematic.summary.targetScheme><td>Target Scheme</td><td>:</td><td>{{Systematic.summary.targetScheme}}</td></tr><tr ng-if=Systematic.summary.mode><td>Mode</td><td>:</td><td>{{Systematic.summary.mode}}</td></tr><tr ng-if=Systematic.summary.camsTransactionNumber><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.summary.camsTransactionNumber}}</td></tr><tr ng-if=Systematic.summary.amount><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.summary.amount}}</td></tr><tr ng-if=Systematic.summary.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.summary.distributor}}</td></tr><tr ng-if=Systematic.summary.investmentOption><td>Investment Option</td><td>:</td><td>{{Systematic.summary.investmentOption}}</td></tr><tr ng-if=Systematic.summary.frequency><td>Frequency</td><td>:</td><td>{{Systematic.summary.frequency}}</td></tr><tr ng-if=Systematic.summary.startDate><td>From Date</td><td>:</td><td>{{Systematic.summary.startDate}}</td></tr><tr ng-if=Systematic.summary.endDate><td>End Date</td><td>:</td><td>{{Systematic.summary.endDate}}</td></tr></table></div><div class=col-md-6 ng-if=\"Systematic.summary.type===\'FLEXSTP\'\"><table class=\"table borderless\"><tr ng-if=Systematic.summary.folioNumber><td>Folio Number</td><td>:</td><td>{{Systematic.summary.folioNumber}}</td></tr><tr ng-if=Systematic.summary.sourceScheme><td>Source Scheme</td><td>:</td><td>{{Systematic.summary.sourceScheme}}</td></tr><tr ng-if=Systematic.summary.targetScheme><td>Target Scheme</td><td>:</td><td>{{Systematic.summary.targetScheme}}</td></tr><tr ng-if=Systematic.summary.mode><td>Mode</td><td>:</td><td>{{Systematic.summary.mode}}</td></tr><tr ng-if=Systematic.summary.camsTransactionNumber><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.summary.camsTransactionNumber}}</td></tr><tr ng-if=Systematic.summary.amount><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.summary.amount}}</td></tr><tr ng-if=Systematic.summary.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.summary.distributor}}</td></tr><tr ng-if=Systematic.summary.investmentOption><td>Investment Option</td><td>:</td><td>{{Systematic.summary.investmentOption}}</td></tr><tr ng-if=Systematic.summary.frequency><td>Frequency</td><td>:</td><td>{{Systematic.summary.frequency}}</td></tr><tr ng-if=Systematic.summary.startDate><td>From Date</td><td>:</td><td>{{Systematic.summary.startDate}}</td></tr><tr ng-if=Systematic.summary.endDate><td>End Date</td><td>:</td><td>{{Systematic.summary.endDate}}</td></tr></table></div><div class=col-md-6 ng-if=\"Systematic.summary.type===\'FLEXINDEX\'\"><table class=\"table borderless\"><tr ng-if=Systematic.summary.folioNumber><td>Folio Number</td><td>:</td><td>{{Systematic.summary.folioNumber}}</td></tr><tr ng-if=Systematic.summary.mode><td>Mode</td><td>:</td><td>{{Systematic.summary.mode}}</td></tr><tr ng-if=Systematic.summary.camsTransactionNumber><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.summary.camsTransactionNumber}}</td></tr><tr ng-if=Systematic.summary.sourceScheme><td>Source Scheme</td><td>:</td><td>{{Systematic.summary.sourceScheme}}</td></tr><tr ng-if=Systematic.summary.targetScheme><td>Target Scheme</td><td>:</td><td>{{Systematic.summary.targetScheme}}</td></tr><tr ng-if=Systematic.summary.startdate><td>From Date</td><td>:</td><td>{{Systematic.summary.startdate}}</td></tr><tr ng-if=Systematic.summary.endDate><td>To Date</td><td>:</td><td>{{Systematic.summary.endDate}}</td></tr><tr ng-if=Systematic.summary.amount><td>Installment Amount(INR)</td><td>:</td><td>{{Systematic.summary.amount}}</td></tr><tr ng-if=Systematic.summary.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.summary.distributor}}</td></tr></table><table class=\"flex-table table\"><thead><tr><th>Installments</th><th>Stages of Switch Execution<br><span style=color:#737373>S&P BSE SENSEX Levels</span></th></tr></thead><tbody><tr ng-if=Systematic.summary.switchExecutionDetails.firstSwitchExecutionEntry><td>{{Systematic.summary.switchExecutionDetails.firstSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(I) </span>{{Systematic.summary.switchExecutionDetails.firstSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr ng-if=Systematic.summary.switchExecutionDetails.secondSwitchExecutionEntry><td>{{Systematic.summary.switchExecutionDetails.secondSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(II) </span>{{Systematic.summary.switchExecutionDetails.secondSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr ng-if=Systematic.summary.switchExecutionDetails.thirdSwitchExecutionEntry><td>{{Systematic.summary.switchExecutionDetails.thirdSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(III) </span>{{Systematic.summary.switchExecutionDetails.thirdSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr ng-if=Systematic.summary.switchExecutionDetails.fourthSwitchExecutionEntry><td>{{Systematic.summary.switchExecutionDetails.fourthSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(IV) </span>{{Systematic.summary.switchExecutionDetails.fourthSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr></tbody></table></div><ng-bind-html ng-if=\"Systematic.summary.type === \'SIP\' || Systematic.summary.type === \'DREAM SIP\' || Systematic.summary.type === \'Flex SIP\' \" ng-bind-html=Systematic.noteSipCancellation.content></ng-bind-html></div><div class=content-foot><div><a href=\"\" ui-sref=main.systematicCorner class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button class=\"btn-primary-action btn pull-right\" ng-click=Systematic.confirmCancelTransaction()>Confirm</button></div></div></div></div>");
$templateCache.put("app/systematic-corner/pause-summary.html","<div class=\"main-section summary\" ng-init=Systematic.init()><div><div><p class=page-title>SIP Pause Summary</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have paused the following SIP</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Systematic.pause.summary.folioNumber}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Systematic.pause.summary.schemeName}}</td></tr><tr><td>Status</td><td>:</td><td>Paused</td></tr><tr><td>Mode</td><td>:</td><td>{{Systematic.pause.summary.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.pause.summary.camsTransactionNumber}}</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td><i class=rupee-small-icon></i>{{Systematic.pause.summary.amount}}</td></tr><tr><td>SIP From Date</td><td>:</td><td>{{Systematic.pause.summary.fromDate}}</td></tr><tr><td>SIP To Date</td><td>:</td><td>{{Systematic.pause.summary.toDate}}</td></tr><tr><td>Number Of Installment To Be Paused</td><td>:</td><td>{{Systematic.pause.noOfInstallment}}</td></tr><tr><td>SIP Frequency</td><td>:</td><td>{{Systematic.pause.summary.frequency}}</td></tr><tr ng-if=Systematic.pause.summary.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.pause.summary.distributor}}</td></tr><tr><td>Pause SIP Start Date</td><td>:</td><td>{{Systematic.pause.sipPausetoDate}}</td></tr><tr><td>Pause SIP End Date</td><td>:</td><td>{{Systematic.pause.sipPauseFromDate}}</td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/systematic-corner/sip-pause.html","<div class=\"main-section summary\" ng-init=Systematic.init()><p class=page-title>SIP Pause Details</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr><td>Folio Number</td><td>:</td><td>{{Systematic.pause.summary.folioNumber}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Systematic.pause.summary.schemeName}}</td></tr><tr><td>Mode</td><td>:</td><td>{{Systematic.pause.summary.mode}}</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>{{Systematic.pause.summary.camsTransactionNumber}}</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td><i class=rupee-small-icon></i>{{Systematic.pause.summary.amount}}</td></tr><tr ng-if=Systematic.pause.summary.distributor><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.pause.summary.distributor}}</td></tr><tr><td>Frequency</td><td>:</td><td>{{Systematic.pause.summary.frequency}}</td></tr><tr><td>From Date</td><td>:</td><td>{{Systematic.pause.summary.fromDate}}</td></tr><tr><td>SIP To Date</td><td>:</td><td>{{Systematic.pause.summary.toDate}}</td></tr><tr ng-if=\"Systematic.pause.summary.frequency.toLowerCase()===\'monthly\'\"><td>Number Of Installment To Be Paused</td><td>:</td><td><select ng-model=Systematic.noOfInstallment ng-click=Systematic.changeInstallment()><option value=\"\">Select Number Of Installment</option><option ng-repeat=\"item in Systematic.noOfInstallmentList\" ng-init=\"Systematic.noOfInstallment = Systematic.noOfInstallment ? Systematic.noOfInstallment :null\">{{item}}</option></select><div><span class=error-input ng-if=\"Systematic.noInstallment && Systematic.endDate\" ng-bind=Systematic.VALIDATE_DATA.NO_OF_INSTALLMENT_REQUIRED></span></div></td></tr><tr><td>Pause SIP Start Date</td><td>:</td><td><div class=\"row borderline\"><div class=\"col-md-10 row\" style=\"margin: 0\"><div class=form-group ng-if=!Transaction.isReseting><div style=\"padding: 0;margin: 0\" class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:Transaction.tForm.endDate.$dirty && Transaction.tForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=Systematic.endDate data-enabled-dates=Systematic.enabledEndDates data-view-date=Systematic.enabledEndDateView data-min-date=Systematic.enabledEndDates[0] data-max-date=Systematic.maxEndDate data-on-date-change=Systematic.changeStartDate data-enable=true id=endDate-OTM showdefault=false><!-- data-min-date=\"Transaction.formData.minEndDate\"--> <input type=text name=endDate autocomplete=off placeholder=\"Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span><label ng-if=Transaction.formData.endDate>Start Date - DD-MMM-YYYY</label><span class=bar></span> <span class=error-input ng-show=\"Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\" ng-bind=Transaction.VALIDATE_DATA.MONTH_REQUIRED></span> <span class=error-input ng-show=Transaction.isOTMEndDate ng-bind=Transaction.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div></div></div></div></td></tr><tr><td>Pause SIP End Date</td><td>:</td><td><div class=\"col-md-10 row\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" style=\"padding: 0;margin: 0\" ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\" date-calendar data-date-default=Systematic.SipPauseEndDate id=startDate-OTM data-enable=true data-on-date-change=Systematic.changeEndDate style=\"position: relative\"><input type=text name=startDate placeholder=\"End Date - DD-MMM-YYYY\" readonly><label ng-if=Transaction.formData.startDate>End Date - DD-MMM-YYYY</label></div></div></td></tr></table></div><ng-bind-html ng-bind-html=Systematic.noteSipPause.content></ng-bind-html></div><div class=content-foot><div><a href=\"\" ui-sref=main.systematicCorner class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button class=\"btn-primary-action btn pull-right\" ng-disabled=\"Systematic.noInstallment || !Systematic.isSipPauseStartDate\" ng-click=Systematic.confirmPauseTransaction()>Confirm</button></div></div></div></div>");
$templateCache.put("app/systematic-corner/smartSwap-cancel.html","<div class=\"main-section summary\" ng-init=Systematic.init()><p class=page-title>SMART SWAP Cancel Details</p><div class=content-area><div class=row><div class=col-md-12><table class=\"table borderless\"><tr><td class=col-md-3>Folio Number</td><td>:</td><td class=col-md-9>{{Systematic.data.summary.folioNumber}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Systematic.data.summary.sourceScheme}}</td></tr><tr><td>Mode</td><td>:</td><td>{{Systematic.data.summary.mode}}</td></tr><tr><td>CAMS Transaction No.</td><td>:</td><td>{{Systematic.data.summary.camsTransactionNumber}}</td></tr><tr><td>Distributor Code/Name</td><td>:</td><td>{{Systematic.data.summary.distributor}}</td></tr><tr><td>SMART SWAP Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{Systematic.data.summary.amount}}</td></tr><tr><td>Frequency</td><td>:</td><td>{{Systematic.data.summary.frequency}}</td></tr><tr><td>% Percentage (per annum)</td><td>:</td><td>{{Systematic.data.summary.percentage}}</td></tr><tr><td>SMART SWAP Start Date</td><td>:</td><td>{{Systematic.data.summary.startDate}}</td></tr></table></div><div class=\"imp-info col-md-12\"><strong>Important:</strong><p><i class=dot></i> <span>It takes 10 working days for the cancellation to be effective. Thus, if a SMART SWAP is due within 10 working days from the date of cancellation, that transaction will be processed.</span></p></div></div><div class=content-foot><div><a href=\"\" ui-sref=main.systematicCorner class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button class=\"btn-primary-action btn pull-right\" ng-click=Systematic.confirmCancelTransaction()>Confirm</button></div></div></div></div>");
$templateCache.put("app/systematic-corner/systematicCorner.html","<section class=\"main-section clearfix transaction-list\" ng-init=Systematic.init()><h6 class=page-title>Systematic Corner</h6><div class=\"content-area clearfix\"><div class=\"bottom-flow d-flex justify-content-between flex-wrap\"><span class=search-box><i class=search-grey-icon></i> <input placeholder=\"Search Folio No. or Scheme\" class=search-input type=text ng-model=Systematic.searchText select-on-click ng-change=Systematic.localSearch()></span><div class=filters-group><select id=typeSelect ng-model=Systematic.selectedTransactionType ng-change=Systematic.typeChangeDropdown(Systematic.selectedTransactionType) ng-options=\"data.value as data.key for data in Systematic.transactionTypeListDropdown\"></select><select id=statusSelect ng-model=Systematic.selectedStatusType ng-change=Systematic.statusChangeDropdown(Systematic.selectedStatusType) ng-options=\"data.value as data.key for data in Systematic.statusTypeListDropdown\"></select><button class=apply-btn ng-click=Systematic.applyFilter()>Apply</button> <button class=apply-btn ng-click=Systematic.resetFilter()>Reset</button></div></div><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Folio</th><th>Type</th><th style=\"width: 370px\">Source Scheme</th><th style=\"width: 370px\">Target Scheme</th><th>Start Date</th><th>End Date</th><th>Ceased Date</th><th>Pause Start Date</th><th>Pause End Date</th><th>Amount</th><th>Status</th><th>Action</th></tr></thead><tbody><tr ng-if=Systematic.systematicList ng-repeat=\"data in Systematic.systematicList\"><td>{{data.folioNumber}}</td><td ng-if=\"data.type===\'SMART_SWAP\'\" style=\"white-space: nowrap\">SMART SWAP</td><td ng-if=\"data.type!==\'SMART_SWAP\' && data.type!==\'FLEXSIP\' && data.type!==\'SIP_TOP_UP\'\">{{data.type == \'DTP\' ? \'TIP\' : data.type}} <span ng-if=\"data.type ==\'DREAMSIP\'\">(Option:{{data.option}})</span></td><td ng-if=\"data.type===\'FLEXSIP\'\" style=\"white-space: nowrap\">Flex SIP</td><td ng-if=\"data.type===\'SIP_TOP_UP\'\" style=\"white-space: nowrap\">SIP WITH TOP UP</td><td>{{data.sourceScheme}}</td><td ng-if=data.targetScheme><span ng-if=\"data.option == \'B\'\">{{data.targetScheme}}</span></td><td ng-if=!data.targetScheme>{{data.toScheme}}</td><td class=date-width>{{data.startDate}}</td><td class=date-width>{{data.endDate}}</td><td class=date-width ng-if=data.ceasedDate>{{data.ceasedDate}}</td><td class=date-width ng-if=!data.ceasedDate>NA</td><td class=date-width ng-if=data.pauseFromDate>{{data.pauseFromDate}}</td><td class=date-width ng-if=!data.pauseFromDate>NA</td><td class=date-width ng-if=data.pauseToDate>{{data.pauseToDate}}</td><td class=date-width ng-if=!data.pauseToDate>NA</td><td class=date-width ng-if=\"data.type!=\'DTP\'\"><div ng-if=\"data.amount != \'0\'\"><i class=rupee-small-icon></i>{{data.amount|unit:data.amount}}</div><div ng-if=\"data.amount == \'0\' || data.amount == \'0.0\'\">NA</div><div class=small-grey ng-bind=data.frequency>Monthly</div></td><td ng-if=\"data.type==\'DTP\'\"><div>{{\'NA\'}}</div></td><td ng-bind=data.status>Completed</td><!--<td class=\"text-primary text-bold\" data-th=\"Scheme\">{{data.scheme}}</td>--><td data-th=Action><div ng-if=\"data.actions.length>0\"><span class=\"dropdown action-dropper\" ng-if=\"!(data.actions.indexOf(\'Renew\') > -1)\"><button data-bs-toggle=dropdown ng-class={disabled:!data.validFolio} class=\"btn btn-secondary-action\">Transact <i class=black-down-icon></i> <span ng-if=\"data.validFolio===false\" style=\"display: initial !important\" class=\"base-tooltip folio-tooltip\" data-bs-html=true data-bs-toggle=tooltip tooltip data-bs-placement=top title=\"Transactions cannot be done for this folio\"></span></button><ul class=dropdown-menu><li ng-repeat=\"action in data.actions track by $index\" ng-click=Systematic.selectTransaction(action,data)>{{action}} <i class=\"arrow-right-icon pull-right\"></i></li><!-- <li ng-click=\"Systematic.redirectToSipTopup(\'topup\',data)\">Top-up<i class=\"arrow-right-icon pull-right\"></i></li>--><!-- <li ng-repeat=\"action in data.actions track by $index\" ng-click=\"Systematic.selectTransaction(\'Change Option\',data)\">Change Option<i\n                  class=\"arrow-right-icon pull-right\"></i></li>\n                  <li ng-repeat=\"action in data.actions track by $index\" ng-click=\"Systematic.selectTransaction(\'Change Target Scheme\',data)\">Change Target Scheme<i\n                    class=\"arrow-right-icon pull-right\"></i></li>  --></ul></span><span ng-if=\"data.actions.indexOf(\'Renew\') > -1  && data.type !=\'DREAMSIP\'\"><button style=\"position: relative\" ng-disabled=!data.validFolio ng-class={disabled:!data.validFolio} ng-click=\"Systematic.selectTransaction(\'Renew\',data)\" class=\"btn btn-secondary-action\">Renew <span ng-if=\"data.validFolio===false\" class=\"base-tooltip folio-tooltip\" data-bs-html=true data-bs-toggle=tooltip tooltip data-bs-placement=top title=\"Transactions cannot be done for this folio\"></span></button></span></div></td></tr><tr ng-if=\"Systematic.totalSystematicListData==0\"><td colspan=9 class=text-center>No data available</td></tr></tbody></table><div class=col-md-12 ng-if=Systematic.isPagination><div class=total-data><span style=\"margin-right: 7px\">Showing</span><select ng-if=\"Systematic.totalSystematicListData>=25\" ng-change=Systematic.pageLimitListChange(Systematic.pageLimitTransactionList) ng-model=Systematic.pageLimitTransactionList><option ng-repeat=\"value in Systematic.PAGE_LIMITS\" value={{value}}>{{value}}</option></select><span ng-if=\"Systematic.totalSystematicListData<25\">{{Systematic.totalSystematicListData}}</span> <span>of</span> <span class=t-black>{{Systematic.totalSystematicListData}}</span></div><ul uib-pagination total-items=Systematic.totalSystematicListData ng-model=Systematic.currentPageSystematicList max-size=5 items-per-page=Systematic.pageLimitTransactionList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Systematic.initSystematicList() rotate=false></ul></div></div></section>");
$templateCache.put("app/tnc-page/tnc.html","<div class=modal-content id=tnc><div class=modal-head><h3 class=modal-title>TERMS AND CONDITIONS</h3></div><ng-bind-html dynamic=TermNCondition.dynamicDataTncGeneral></ng-bind-html></div>");
$templateCache.put("app/transactions/transactions.html","<div ui-view></div>");
$templateCache.put("app/tracker/tracker.html","<header class=\"header header1 container-fluid\"><div class=\"row main-head\"><div class=col-md-12><div class=left-section><img src=assets/images/logo.png style=\"margin-bottom: 12px\" alt=HDFC class=\"logo pull-left\"></div></div></div></header><div class=\"main-section feedback tracker\" ng-init=Tracker.init()><div class=content-area><div class=content-head><h3>Please share following detail to continue.</h3></div><div class=content-body><form autocomplete=off name=trackerForm novalidate ng-submit=Tracker.submitPan()><div class=\"row tracker-pan\"><div class=col-md-8><div class=input-normal ng-class=\"{error:trackerForm.pan.$dirty && trackerForm.pan.$invalid || Tracker.panMessage}\"><input type=text name=pan maxlength=10 minlength=10 ng-model=Tracker.panNumber ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-change=Tracker.resetValues() ng-blur=Tracker.checkPanVerification() capitalize required> <span ng-show=\"trackerForm.pan.$dirty && trackerForm.pan.$invalid\"><span class=error-input ng-show=trackerForm.pan.$error.required ng-bind=Tracker.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=trackerForm.pan.$error.minlength ng-bind=Tracker.validateData.PAN_FIELD_MIN></span> <span class=error-input ng-show=trackerForm.pan.$error.maxlength ng-bind=Tracker.validateData.PAN_FIELD_MAX></span> <span class=error-input ng-show=trackerForm.pan.$error.pattern ng-bind=Tracker.validateData.PAN_FIELD></span> </span><span class=error-input ng-if=Tracker.panMessage ng-bind=Tracker.panMessage></span> <span class=highlight></span> <span class=bar></span><label>PAN<span class=req>*</span></label></div></div><div class=col-md-4><button class=\"btn-small btn-primary-action\" ng-disabled=trackerForm.$invalid ng-click=Tracker.verifyPan()>Continue -></button></div></div></form></div></div></div><footer class=\"container-fluid footer\"><div class=\"browser-support text-center\">For best experience use Chrome (version 60 and above), Firefox (version 50 and above), Safari(Latest version), Microsoft Edge(Latest version).</div><div class=row><div class=\"col-md-7 flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"footer-logo pull-left\"><p>{{Tracker.date | date: \'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"col-md-5 clearfix\"><div style=padding-top:18px>Email Us: <a href=mailto:Hello@hdfcfund.com class=text-blue>Hello@hdfcfund.com</a> | Call Us: 1800 3010 6767 / 1800 419 7676 (Toll - Free)</div></div></div></footer>");
$templateCache.put("app/update-contact/contact-update.html","<div class=\"row row-no-gutters\"><div class=\"col-sm-12 col-md-12 form-existing-wrap res-form-exis\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=\"forgot-password-forms update-step-forms update-step-forms-updateContact\"><div class=login-header><!-- <div class=\"header-action header-action-bottom-margin\">\n          <a href=\"javascript:void(0)\" ng-click=\"UpdateContact.redirectToLogin();\">\n            <img src=\"assets/images/back-button.svg\">\n            Back to Login\n          </a>\n        </div> --><div><h4 ng-if=\"UpdateContact.CURR_STATE === UpdateContact.UPDATE_FORM_STATE.DEFAULT\">Update Contact Details</h4><h4 ng-if=\"UpdateContact.CURR_STATE === UpdateContact.UPDATE_FORM_STATE.EMAIL\">Verify Email ID</h4><h4 ng-if=\"UpdateContact.CURR_STATE === UpdateContact.UPDATE_FORM_STATE.MOBILE\">Verify Mobile Number</h4><h4 ng-if=\"UpdateContact.CURR_STATE === UpdateContact.UPDATE_FORM_STATE.OTP\">Verify OTP</h4><h4 ng-if=\"UpdateContact.CURR_STATE === UpdateContact.UPDATE_FORM_STATE.OTPFOLIO\">Verify OTP</h4><h4 ng-if=\"UpdateContact.CURR_STATE === UpdateContact.UPDATE_FORM_STATE.FOLIO_PROFILE ||\n            UpdateContact.CURR_STATE === UpdateContact.UPDATE_FORM_STATE.UPDATE_FOLIO ||\n            UpdateContact.CURR_STATE === UpdateContact.UPDATE_FORM_STATE.UPDATE_ONLINE_ACCOUNT\">Please select to update your details</h4><div class=Investor-sub-headline ng-if=\"UpdateContact.CURR_STATE === UpdateContact.UPDATE_FORM_STATE.DEFAULT\">Select and enter your Email ID or Mobile Number registered in your folio to verify your identity.</div></div></div><div data-ng-switch=UpdateContact.CURR_STATE><!-------------------- Default state section ----------------------------------------------------------------><div data-ng-switch-when=DEFAULT class=update-form><div>Email ID and Mobile Number registered in your folio {{UpdateContact.payload.folioNumberMasked}}.</div><form name=contactForm class=update-contact-form autocomplete=false novalidate><div class=\"input-normal field-section update-contact-field-section\" style=\"min-height:30px; justify-content: revert\"><div class=update-contact-fields><div class=update-contact-masking-field><input type=radio ng-model=UpdateContact.emailSelected name=selection ng-click=\"UpdateContact.changeUserSelection(\'email\')\" ng-disabled=\"UpdateContact.payload.email===\'Not Available\'\"><label>Email</label></div><div class=\"pull-right update-contact-masking\">{{UpdateContact.payload.email}}</div></div><div><div><input type=text ng-if=UpdateContact.emailEnabled ng-model=UpdateContact.verifyEmailID name=email class=\"pd40 contactProfile updateContact\" placeholder=\"Enter Email ID shown above\" ng-pattern=UpdateContact.CONST.email_regex style=\"border: 1px solid gray;border-radius: 100px\"> <span ng-show=\"contactForm.email.$dirty && contactForm.email.$invalid\"><span class=mod-error-msg ng-show=contactForm.email.$error.required ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_REQUIRED></span> <span class=mod-error-msg ng-show=contactForm.email.$error.pattern class=help-block ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_FIELD></span></span></div></div></div><div class=\"input-normal field-section update-contact-field-section\" style=\"min-height:30px ;justify-content: revert\"><div class=update-contact-fields><div class=update-contact-masking-field><input type=radio ng-model=UpdateContact.mobileSelected name=selection ng-click=\"UpdateContact.changeUserSelection(\'mobile\')\" ng-disabled=\"UpdateContact.payload.mobile===\'Not Available\'\"><label>Mobile Number</label></div><div class=\"pull-right update-contact-masking\">{{UpdateContact.payload.mobile}}</div></div><div><div><input type=text ng-if=UpdateContact.mobileEnabled ng-model=UpdateContact.verifyMobileNumber name=mobile maxlength=13 ng-pattern=UpdateContact.CONST.mobile_regex class=\"pd40 contactProfile updateContact\" placeholder=\"Enter mobile number shown above\" style=\"border: 1px solid gray !important;border-radius: 100px\"> <span ng-show=\"contactForm.mobile.$dirty && contactForm.mobile.$invalid\"><span class=mod-error-msg ng-show=contactForm.mobile.$error.required ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.MOBILE_REQUIRED></span> <span class=mod-error-msg ng-show=contactForm.mobile.$error.pattern class=help-block ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.MOBILE_ISD></span></span></div></div></div><div class=\"btnContainer loginpwdBtn button-placing\"><input id=editEmail type=submit ng-disabled=\"contactForm.mobile.$invalid || contactForm.email.$invalid || (!UpdateContact.verifyMobileNumber && !UpdateContact.verifyEmailID)\" class=\"btn btn-block btn-login loginBtn loginBtnNewTheme loginBtnTheme\" value=\"Send OTP\" ng-click=UpdateContact.submitUserSelection()> <span class=\"inputTxt txtCancel\"><span class=\"inputTxt updateContactCancelButton\"><a ng-click=UpdateContact.confirmCancel(UpdateContact.UPDATE_FORM_STATE.DEFAULT) class=btn-login>Cancel</a></span></span></div><!--            <div class=\"point-to-note imp-info\">--><!--              Please Note: <br />--><!--              <p>--><!--                <span>If both details, Email ID and Mobile Number, are not updated with us, then kindly download the form to update contact details by--><!--                  <a href=\"https://files.hdfcfund.com/s3fs-public/2018-04/CTR_Non_Financial_Transaction_15062016_6.pdf\" target=\"_blank\">clicking here</a>--><!--                  and submit to our nearest Investor Service Center (ISC) or you can write to us at <a href=\"mailto:Hello@hdfcfund.com\" class=\"text-blue\">Hello@hdfcfund.com</a>--><!--                  on queries for updating contact details.--><!--                </span>--><!--              </p>--><!--            </div>--><ng-bind-html ng-bind-html=UpdateContact.dynamicNote></ng-bind-html></form></div><!--------------------- Email id section-----------------------------------------------------------------------><div data-ng-switch-when=EMAIL class=edit-email><form name=editEmailForm class=update-contact-form autocomplete=false novalidate><div class=\"input-normal userpan-input-container\"><input type=text ng-model=UpdateContact.payload.emailNew name=emailNew class=\"pd40 contactProfile\" ng-pattern=UpdateContact.CONST.email_regex required autofocus placeholder=\"{{(UpdateContact.payload.email === UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_MOBILE_NOT_UPDATED) && \'Not updated\' || \'\'}}\"> <span ng-show=\"editEmailForm.emailNew.$dirty && editEmailForm.emailNew.$invalid\"><span class=mod-error-msg ng-show=editEmailForm.emailNew.$error.required ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_REQUIRED></span> <span class=mod-error-msg ng-show=editEmailForm.emailNew.$error.pattern class=help-block ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_FIELD></span></span></div><div class=\"btnContainer loginpwdBtn\" ng-class=\"{\'button-placing\' : Login.showSecStep}\"><input id=editEmail type=submit ng-disabled=\"editEmailForm.$invalid || (UpdateContact.payload.email == UpdateContact.payload.emailNew)\" class=\"btn btn-primary-action btn-block btn-login loginBtn loginBtnNewTheme loginBtnTheme\" value=Verify ng-click=UpdateContact.verifyEmail()> <span class=\"inputTxt txtCancel\"><a ng-click=UpdateContact.confirmCancel(UpdateContact.UPDATE_FORM_STATE.EMAIL) class=cursor-pointer>Cancel</a></span></div></form></div><!--------------------- Mobile section ------------------------------------------------------------------------><div data-ng-switch-when=MOBILE class=edit-mobile><form name=mobileForm autocomplete=false novalidate class=update-contact-form><div class=\"input-normal userpan-input-container\" ng-class=\"{error:mobileForm.mobileNew.$dirty && mobileForm.mobileNew.$invalid}\"><input type=tel ng-model=UpdateContact.payload.mobileNew ng-pattern=UpdateContact.CONST.mobile_regex name=mobileNew autofocus placeholder=\"{{(UpdateContact.payload.mobile === UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_MOBILE_NOT_UPDATED) && \'Not updated\' || \'\'}}\" class=\"pd40 contactProfile\" maxlength=13 required> <span ng-show=\"mobileForm.mobileNew.$dirty && mobileForm.mobileNew.$invalid\"><span class=mod-error-msg ng-show=mobileForm.mobileNew.$error.required ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.MOBILE_REQUIRED></span> <span class=mod-error-msg ng-show=mobileForm.mobileNew.$error.pattern class=help-block ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.MOBILE_ISD></span></span></div><div class=\"btnContainer loginpwdBtn\" ng-class=\"{\'button-placing\' : Login.showSecStep}\"><input id=editMoile type=submit ng-disabled=\"mobileForm.$invalid || (UpdateContact.payload.mobile ===  UpdateContact.payload.mobileNew)\" class=\"btn btn-primary-action btn-block btn-login loginBtn loginBtnNewTheme loginBtnTheme\" value=Verify ng-click=UpdateContact.verifyMobile()> <span class=\"inputTxt txtCancel\"><a ng-click=UpdateContact.confirmCancel(UpdateContact.UPDATE_FORM_STATE.EMAIL) class=cursor-pointer>Cancel</a></span></div></form></div><!--------------------- folio and account profile selection section ---------------------------------------------------------------------------><div data-ng-switch-when=FOLIO_PROFILE class=edit-folio-profile><form name=folio autocomplete=false novalidate class=update-contact-form><div><div><div class=update-contact-details><p>PAN</p><p>{{UpdateContact.payload.panNumberMasked}}</p></div><div class=update-contact-details><p>Folio</p><p>{{UpdateContact.payload.folioNumberMasked}}</p></div></div></div><div class=select-contact-update-level><div class=radio-block><span class=radio><input type=radio ng-model=UpdateContact.folioAccountFlag name=selection ng-click=\"UpdateContact.changeUserSelection(\'isFolio\')\"> <span class=check></span> </span><span class=radio-label>Update contact details in folio</span></div><div class=radio-block ng-if=UpdateContact.payload.investorId><span class=radio><input type=radio ng-model=UpdateContact.onlineAccountFlag name=selection ng-click=\"UpdateContact.changeUserSelection(\'isOnlineAccount\')\"> <span class=check></span> </span><span class=radio-label>Update contact details in online account profile</span></div></div><div class=\"btnContainer loginpwdBtn\" ng-class=\"{\'button-placing\' : Login.showSecStep}\"><input id=editMoile type=submit ng-disabled=\"mobileForm.$invalid || (!UpdateContact.isOnlineAccount && !UpdateContact.isFolio) \" class=\"btn btn-primary-action btn-block btn-login loginBtn loginBtnNewTheme loginBtnTheme\" value=Continue ng-click=UpdateContact.moveToAccountSelection()> <span class=\"inputTxt txtCancel\"><a ng-click=UpdateContact.confirmCancel(UpdateContact.UPDATE_FORM_STATE.DEFAULT) class=cursor-pointer>Cancel</a></span></div><div class=\"point-to-note imp-info\">Please Note:<br><p><i class=dot></i> <span>You can update email ID and mobile number registered in your folio and profile of your online account if registered using entered PAN.</span></p><p><i class=dot></i> <span>Contact details update is not available for non-individuals.</span></p></div></form></div><!--------------------- Update details on folio selection section ---------------------------------------------------------------------------><div data-ng-switch-when=UPDATE_FOLIO class=edit-folio-profile><form name=folio autocomplete=false novalidate class=\"update-contact-form form-alignment\"><div><div><div class=update-contact-details><p>PAN</p><p>{{UpdateContact.payload.panNumberMasked}}</p></div><div class=update-contact-details><p>Folio</p><p>{{UpdateContact.payload.folioNumberMasked}}</p></div></div></div><div class=\"input-normal field-section\"><div><input type=radio ng-model=UpdateContact.emailSelectedFolio name=selection ng-click=\"UpdateContact.changeUserSelection(\'emailChange\')\"><label>Email</label></div><div><div class=pull-right>{{UpdateContact.payload.emailFolio}}</div></div></div><div class=\"input-normal field-section\"><div><input type=radio ng-model=UpdateContact.mobileSelectedFolio name=selection ng-click=\"UpdateContact.changeUserSelection(\'mobileChange\')\"><label>Mobile Number</label></div><div><div class=pull-right>{{UpdateContact.payload.mobileFolio}}</div></div></div><div class=\"input-normal userpan-input-container\" ng-if=UpdateContact.emailEnabled><input type=text ng-model=UpdateContact.payload.emailNew name=emailNew class=\"pd40 contactProfile\" ng-pattern=UpdateContact.CONST.email_regex ng-change=UpdateContact.redirectToDefaultState() required autofocus placeholder=\"{{(UpdateContact.payload.email === UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_MOBILE_NOT_UPDATED) && \'Not updated\' || \'\'}}\"><label>Email ID (Enter new email ID)<span class=req>*</span></label><span ng-show=\"folio.emailNew.$dirty && folio.emailNew.$invalid\"><span class=mod-error-msg ng-show=folio.emailNew.$error.required ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_REQUIRED></span> <span class=mod-error-msg ng-show=folio.emailNew.$error.pattern class=help-block ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.EMAIL_FIELD></span></span></div><div class=\"input-normal userpan-input-container\" style=\"margin-top: 0px\" ng-if=UpdateContact.emailEnabled><label id=email>Email ID Belongs To<span class=req>*</span></label><select name=emailBelongsTo id=emailBelongsTo style=\"padding: 8px 15px ; border-radius: 5px; border: 1px solid #b8c6d1 !important\" ng-model=UpdateContact.emailBelongsTo ng-options=\"data.familyCode as data.familyDescription for data in UpdateContact.belongToListEmail\" ng-init=\"UpdateContact.emailBelongsTo = UpdateContact.emailBelongsTo ? UpdateContact.emailBelongsTo: null\" ng-focus=\"UpdateContact.selectFocus(\'email\')\" ng-blur=\"UpdateContact.selectBlur(\'email\')\" required><option value=\"\">Select</option></select></div><div class=\"input-normal userpan-input-container\" ng-if=UpdateContact.mobileEnabled ng-class=\"{error:folio.mobileNew.$dirty && folio.mobileNew.$invalid}\"><input type=tel ng-model=UpdateContact.payload.mobileNew name=mobileNew ng-change=UpdateContact.redirectToDefaultState() autofocus class=\"pd40 contactProfile\" maxlength=13 required><label>Mobile Number (Enter new mobile number)<span class=req>*</span></label><span ng-show=\"folio.mobileNew.$dirty && folio.mobileNew.$invalid\"><span class=mod-error-msg ng-show=folio.mobileNew.$error.required ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.MOBILE_REQUIRED></span> </span><span class=mod-error-msg ng-if=\"(!UpdateContact.isValid || UpdateContact.isMobileNotValid) && !folio.mobileNew.$invalid\" class=help-block ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.MOBILE_ISD></span></div><div class=\"input-normal userpan-input-container\" style=\"margin-top: 0px\" ng-if=UpdateContact.mobileEnabled><label id=mobile>Mobile No. Belongs To<span class=req>*</span></label><select name=mobileBelongsTo id=mobileBelongsTo style=\"padding: 8px 15px; border-radius: 5px; border: 1px solid #b8c6d1 !important\" ng-model=UpdateContact.mobileBelongsTo ng-options=\"data.familyCode as data.familyDescription for data in UpdateContact.belongToListMobile\" ng-init=\"UpdateContact.mobileBelongsTo = UpdateContact.mobileBelongsTo ? UpdateContact.mobileBelongsTo: null\" ng-focus=\"UpdateContact.selectFocus(\'mobile\')\" ng-blur=\"UpdateContact.selectBlur(\'mobile\')\" required><option value=\"\">Select</option></select></div><div class=\"btnContainer loginpwdBtn\" ng-class=\"{\'button-placing\' : Login.showSecStep}\"><input id=editMoile type=submit ng-disabled=\"folio.$invalid || (UpdateContact.isFolio && UpdateContact.mobileEnabled && (!UpdateContact.isValid || UpdateContact.isMobileNotValid))\" class=\"btn btn-primary-action btn-block btn-login loginBtn loginBtnNewTheme loginBtnTheme\" value=Continue ng-click=UpdateContact.updateProfileContact()> <span class=\"inputTxt txtCancel\"><a ng-click=UpdateContact.confirmCancel(UpdateContact.UPDATE_FORM_STATE.DEFAULT) class=cursor-pointer>Cancel</a></span></div></form></div><!--------------------- Update details on online account selection section ---------------------------------------------------------------------------><div data-ng-switch-when=UPDATE_ONLINE_ACCOUNT class=edit-online-profile><form name=onlineAccount autocomplete=false novalidate class=\"update-contact-form form-alignment\"><div><div><div class=update-contact-details><p>PAN</p><p>{{UpdateContact.payload.panNumberMasked}}</p></div><div class=update-contact-details><p>Folio</p><p>{{UpdateContact.payload.folioNumberMasked}}</p></div></div></div><div class=\"input-normal field-section\"><div><input type=radio ng-model=UpdateContact.emailSelectedProfile name=selection ng-click=\"UpdateContact.changeUserSelection(\'emailChange\')\" ng-disabled=\"UpdateContact.payload.emailProfile==\'Not Available\' && UpdateContact.payload.mobileProfile==\'Not Available\'\"><label>Email</label></div><div><div class=pull-right>{{UpdateContact.payload.emailProfile}}</div></div></div><div class=\"input-normal field-section\"><div><input type=radio ng-model=UpdateContact.mobileSelectedProfile name=selection ng-click=\"UpdateContact.changeUserSelection(\'mobileChange\')\" ng-disabled=\"UpdateContact.payload.mobileProfile==\'Not Available\' && UpdateContact.payload.emailProfile==\'Not Available\'\"><label>Mobile Number</label></div><div><div class=pull-right>{{UpdateContact.payload.mobileProfile}}</div></div></div><div class=input-normal ng-if=UpdateContact.emailEnabled><p>Select the Email ID registered in your folio(s) to be updated in your online account profile:</p><div class=selectfield ng-class=\"{error:(UpdateContact.onlineAccount.emailId.$dirty && UpdateContact.onlineAccount.emailId.$invalid)}\"><label style=\"width: 130px\">Email ID:</label><select name=emailId id=_first ng-model=UpdateContact.newUpdatedEmail ng-options=\"contact.emailId as contact.emailId for contact in UpdateContact.emailListData\" ng-change=UpdateContact.redirectToDefaultState() options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Email ID</option></select><span class=mod-error-msg ng-show=\"UpdateContact.onlineAccount.emailId.$dirty && UpdateContact.tForm.emailId.$invalid && UpdateContact.onlineAccount.emailId.$error.required\" ng-bind=UpdateContact.VALIDATE_DATA.FOLIO_REQUIRED></span></div><div class=selectfield><label style=\"width: 140px\">Email ID Belongs To:</label><select name=emailBelongsToProfile id=emailBelongsToProfile ng-init=\"UpdateContact.emailBelongsToProfile = UpdateContact.emailBelongsToProfile ? UpdateContact.emailBelongsToProfile: null\" ng-model=UpdateContact.emailBelongsToProfile ng-options=\"data.familyCode as data.familyDescription for data in UpdateContact.belongToListEmail\"><option value=\"\">Select</option></select></div></div><div class=input-normal ng-if=UpdateContact.mobileEnabled><p>Select the Mobile number registered in your folio(s) to be updated in your online account profile:</p><div class=selectfield ng-class=\"{error:(UpdateContact.onlineAccount.mobileNumber.$dirty && UpdateContact.onlineAccount.mobileNumber.$invalid)}\"><label style=\"width: 140px\">Mobile number:</label><select name=mobileNumber id=_second ng-model=UpdateContact.newUpdatedMobile ng-options=\"contact.mobileNumber as contact.mobileNumber for contact in UpdateContact.mobileListData\" ng-change=UpdateContact.redirectToDefaultState() options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Mobile number</option></select><span class=mod-error-msg ng-show=\"UpdateContact.onlineAccount.mobileNumber.$dirty && UpdateContact.tForm.mobileNumber.$invalid && UpdateContact.onlineAccount.mobileNumber.$error.required\" ng-bind=UpdateContact.VALIDATE_DATA.FOLIO_REQUIRED></span></div><div class=selectfield><label style=\"width: 140px\">Mobile No. Belongs To:</label><select name=mobileBelongsToProfile id=mobileBelongsToProfile ng-init=\"UpdateContact.mobileBelongsToProfile = UpdateContact.mobileBelongsToProfile ? UpdateContact.mobileBelongsToProfile: null\" ng-model=UpdateContact.mobileBelongsToProfile ng-options=\"data.familyCode as data.familyDescription for data in UpdateContact.belongToListMobile\"><option value=\"\">Select</option></select></div></div><div class=\"btnContainer loginpwdBtn\" ng-class=\"{\'button-placing\' : Login.showSecStep}\"><input id=editMoile type=submit ng-disabled=\"mobileForm.$invalid || ((!UpdateContact.newUpdatedMobile || !UpdateContact.mobileBelongsToProfile) && (!UpdateContact.newUpdatedEmail || !UpdateContact.emailBelongsToProfile))\" class=\"btn btn-primary-action btn-block btn-login loginBtn loginBtnNewTheme loginBtnTheme\" value=Update ng-click=UpdateContact.updateProfileContact()> <span class=\"inputTxt txtCancel\"><a ng-click=UpdateContact.confirmCancel(UpdateContact.UPDATE_FORM_STATE.DEFAULT) class=cursor-pointer>Cancel</a></span></div><div class=\"point-to-note imp-info\">Please Note:<br><p><i class=dot></i> <span>You can update email ID and mobile number registered in your folio and profile of your online account if registered using entered PAN.</span></p><p><i class=dot></i> <span>Contact details update is not available for non-individuals.</span></p><p><i class=dot></i> <span>Email ID and mobile number to be updated in your online account profile should be registered in one of your folio(s), One-time Password (OTP) for login will be sent to updated contact details.</span></p></div></form></div><!--------------------- OTP section ---------------------------------------------------------------------------><div data-ng-switch-when=OTP class=edit-otp><form name=otpForm autocomplete=false novalidate class=update-contact-form><div class=\"input-normal otp-input-container otp-unlock-id\"><input type=text ng-model=UpdateContact.payload.otp name=otp minlength=6 maxlength=6 is-number autocomplete=off class=\"pd40 contactProfile\" required style=\"border: 1px solid gray;border-radius: 100px\"><label>Enter OTP</label><div class=input-controls style=\"top: 43%\"><span><timer countdown=UpdateContact.CONST.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0 || UpdateContact.timerShowFlag\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=UpdateContact.reGenerateOtp(); ng-class={anchorDisable:UpdateContact.processFlagOtp}>Resend OTP</a></span></div></timer></span></div></div><div class=resend-otp-message ng-if=UpdateContact.sentOtpRespMsg><div id=clickText class=\"form-group otpSucessText\" ng-if=UpdateContact.sentOtpRespMsg ng-bind=UpdateContact.sentOtpRespMsg></div></div><div class=\"btnContainer loginpwdBtn\" ng-class=\"{\'button-placing\' : Login.showSecStep}\"><input id=editOTP type=submit ng-disabled=\"otpForm.$invalid || UpdateContact.processFlag\" class=\"btn btn-primary-action btn-block btn-login loginBtn loginBtnNewTheme loginBtnTheme\" value=Verify ng-click=UpdateContact.verifyOTP()> <span class=\"inputTxt txtCancel\"><a ng-click=UpdateContact.confirmCancel(UpdateContact.UPDATE_FORM_STATE.OTP) class=cursor-pointer>Cancel</a></span></div></form></div><!---------------------------OTPFOLIO SECTION------------------------------------------------------------><div data-ng-switch-when=OTPFOLIO class=edit-otp><form name=otpForm autocomplete=false novalidate class=update-contact-form><div class=\"input-normal otp-input-container otp-unlock-id\"><input type=text ng-model=UpdateContact.payload.otpFolio name=otp minlength=6 maxlength=6 is-number autocomplete=off ng-change=UpdateContact.redirectToDefaultState() class=\"pd40 contactProfile\" required><label>Enter OTP</label><div class=input-controls style=\"top: 43%\"><span><timer countdown=UpdateContact.CONST.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0 || UpdateContact.timerShowFlag\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=UpdateContact.reGenerateFolioOtp(); ng-class={anchorDisable:UpdateContact.processFlagOtp}>Resend OTP</a></span></div></timer></span></div></div><div class=resend-otp-message ng-if=UpdateContact.sentOtpRespMsg><div id=clickText class=\"form-group otpSucessText\" ng-if=UpdateContact.sentOtpRespMsg ng-bind=UpdateContact.sentOtpRespMsg></div></div><div class=\"btnContainer loginpwdBtn\" ng-class=\"{\'button-placing\' : Login.showSecStep}\"><input id=editOTP type=submit ng-disabled=\"otpForm.$invalid || UpdateContact.processFlag\" class=\"btn btn-primary-action btn-block btn-login loginBtn loginBtnNewTheme loginBtnTheme\" value=Verify ng-click=UpdateContact.verifyFolioOTP()> <span class=\"inputTxt txtCancel\"><a ng-click=UpdateContact.confirmCancel(UpdateContact.UPDATE_FORM_STATE.OTPFOLIO) class=cursor-pointer>Cancel</a></span></div></form></div></div></div></div></div><style>.otp-response-msg {\n    background: #46a040;\n    color: #fff;\n    padding: 5px;\n    border-radius: 4px;\n  }\n  .loginBtn{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border-radius: 100px !important;\n  }\n  @media screen and (max-width: 991px) {\n    .forgot-password-forms{\n      padding: 1% 10% 20px 10% !important;\n    }\n    .form-existing-wrap{\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      border-radius: 16px;\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n    .contrastClass .form-existing-wrap {\n      background: black !important;\n      border-radius: 16px;\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n  }</style>");
$templateCache.put("app/update-contact/update-contact-index.html","<div><div class=row><!-- <div class=\"side-nav-container col-md-3\">\n      <div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\">\n        <div class=\"col-md-12 height100\">\n          <div class=\"side-nav-wrap\">\n            <hdfc-login-sidebar sidebar-click=\"UpdateContact.handleSideBarClick(message)\"></hdfc-login-sidebar>\n          </div>\n        </div>\n      </div>\n    </div> --><div class=\"col-md-6 col-sm-12 col-xs-12\"><br><login-header></login-header><br><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=forms-container><div ui-view></div></div></div><div class=\"col-sm-6 col-md-6 existing-investor-carousel\"><slide-image></slide-image></div></div><!-- <footer-login></footer-login> --><!--  <div class=\"mobile-footer-blue\">--><!--    <div class=\"mobile-footer-blue-container\" ui-sref=\"login\" ng-click=\"UpdateContact.handleSideBarClick(\'NEW_INVESTOR\')\">--><!--      <img src=\"assets/images/newInvestor.svg\" class=\"investorIcon\"/>--><!--      <div class=\"mainmenu-text mobile-footer-blue-text\">New Investor?</div>--><!--    </div>--><!--    <div class=\"mobile-footer-blue-container mobile-footer-seperator\" ui-sref=\"instantLogin\">--><!--      <img src=\"assets/images/quickinvest.svg\" class=\"investorIcon mobile-footer-icon\"/>--><!--      <div class=\"mainmenu-text mobile-footer-blue-text\">Quick Invest</div>--><!--    </div>--><!--  </div>--></div><style>@media screen and (max-width: 991px) {\n    .form-existing-wrap{\n      border-radius: 16px;\n    }\n    .forms-container{\n      margin-top: -30% !important;\n      width: 90%;\n      margin: auto;\n      background: none;\n    }\n    .existing-investor-carousel{\n      display: none;\n    }\n  }</style>");
$templateCache.put("app/update-contact/update-contact-login.html","<div><!-- <div class=\"header-form-resp\">\n    <div class=\"back-to-login-header\"><a href=\"/\" class=\"header-resp-arrow-text\">\n      <img src=\"assets/images/back-arrow-icon.svg\" class=\"arrowBackIcon resp-head-icon loginBckImg\"/> Back to login</a>\n    </div>\n  </div> --><div class=\"row row-no-gutters\"><!-- <div class=\"side-nav-container col-md-3\">\n      <div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\">\n        <div class=\"col-md-12 height100\">\n          <div class=\"side-nav-wrap\">\n            <hdfc-login-sidebar sidebar-click=\"UpdateContact.handleSideBarClick(message)\"></hdfc-login-sidebar>\n          </div>\n        </div>\n      </div>\n    </div> --><div class=\"widthContainer col-sm-12 p-0\"><br><login-header></login-header><br><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=forms-container><div class=\"row row-no-gutters\"><div class=\"col-md-12 form-existing-wrap res-form-exis\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=forgot-password-forms><div class=login-header><!-- <div class=\"header-action header-action-resp\">\n                  <a href=\"javascript:void(0)\" ui-sref=\"login\">\n                    <img src=\"assets/images/back-button.svg\" class=\"loginBckImg\">\n                    Back to Login\n                  </a>\n                </div> --><div class=padding0-container><h4>Update Contact Details</h4></div></div><div><div class=login-header><div class=\"header-action header-action-resp p-0\"><a href=javascript:void(0) ui-sref=login><img src=assets/images/back-button.svg class=loginBckImg width=30px> Back to Login</a></div></div><form class=update-contact-form autocomplete=off name=contactForm><div class=\"input-normal pan-input-container input-web-width\" ng-class=\"{error:contactForm.panNumber.$dirty && contactForm.panNumber.$invalid && contactForm.panNumber.$touched}\"><input placeholder=\"e.g. ABCDE1234A\" type=text name=panNumber maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=UpdateContact.payload.panNumber capitalize required autocomplete=off autofocus style=\"border-radius: 100px;height: 48px\"><label>PAN<span class=req> *</span></label><span ng-messages=contactForm.panNumber.$error ng-show=\"contactForm.panNumber.$dirty && contactForm.panNumber.$invalid\"><span class=mod-error-msg ng-message=required ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.PAN_REQUIRED></span> <span class=mod-error-msg ng-message=minlength ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.PAN_FIELD></span> <span class=mod-error-msg ng-message=maxlength ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.PAN_FIELD></span> <span class=mod-error-msg ng-message=pattern ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.PAN_FIELD></span></span></div><div class=\"input-normal folio-input-container input-web-width\" ng-class=\"{error:contactForm.folioNumber.$dirty && contactForm.folioNumber.$invalid && contactForm.folioNumber.$touched}\"><!--<span class=\"prefilled\" ng-if=\"Login.tracked\" ng-bind=\"Login.loginPayload.username\"></span>--> <input placeholder=\"e.g. 546321\" ng-model=UpdateContact.payload.folioNumber type=text id=folioNumber maxlength=15 is-number required autocomplete=off style=\"border-radius: 100px;height: 48px\"><label>Folio Number<span class=req> *</span></label><div class=\"input-controls input-controls-login\"><span class=\"inputTxt inputTxtLogin\"><a href=javascript:void(0) ui-sref=\"forgotfolio({from:\'updateContactLogin\'})\" class=forgtId tabindex=15>Forgot Folio</a></span></div><span class=mod-error-msg ng-messages=contactForm.folioNumber.$error ng-show=\"contactForm.folioNumber.$dirty && contactForm.folioNumber.$invalid && contactForm.folioNumber.$touched\"><span ng-message=required ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.FOLIO_REQUIRED></span> <span ng-message=maxlength ng-bind=UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.UPDATE_CONTACT_FOLIO_FIELD_MAX></span></span></div><!--<div class=\"input-normal acc-input-container\"\n                       ng-class=\"{error:contactForm.bankAccountNumber.$dirty && contactForm.bankAccountNumber.$invalid && contactForm.bankAccountNumber.$touched}\">\n                    <input placeholder=\"Enter your bank account number\" type=\"text\" minlength=\"1\" maxlength=\"20\" is-number\n                           ng-model=\"UpdateContact.payload.bankAccountNumber\"\n                           name=\"bankAccountNumber\"\n                           required autocomplete=\"off\">\n                    <label>Bank Account Number<span class=\"req\"> *</span></label>\n                    <span ng-messages=\"contactForm.bankAccountNumber.$error\"\n                          ng-show=\"contactForm.bankAccountNumber.$dirty && contactForm.bankAccountNumber.$invalid\">\n                      <span class=\"mod-error-msg\" ng-message=\"required\"\n                                  ng-bind=\"UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED\"></span>\n                      <span class=\"mod-error-msg\" ng-message=\"minlength\"\n                            ng-bind=\"UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE_MIN\"></span>\n                      <span class=\"mod-error-msg\" ng-message=\"maxlength\"\n                            ng-bind=\"UpdateContact.CONST.ToastrMessage.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE_MAX\"></span>\n                    </span>\n                  </div>--><div class=\"btnContainer loginpwdBtn button-placing input-web-width\"><button type=submit class=\"btn-login btn-unlock-form loginBtn loginBtnNewTheme\" ng-disabled=\"contactForm.$invalid || UpdateContact.disableContinue\" ng-click=UpdateContact.submitDetails()>CONTINUE</button></div><div class=\"point-to-note imp-info\" ng-if=UpdateContact.dynamicNotes><!--If both details, Email Address and Mobile number, are not updated with us, then kindly\n                    download the form to update contact details by\n                    <span><a href=\"https://files.hdfcfund.com/s3fs-public/2018-04/CTR_Non_Financial_Transaction_15062016_6.pdf \"\n                      style=\"color: #2485bd\" target=\"_blank\" class=\"updateContactFormLink\">clicking here</a>\n                    </span> and submit to our nearest Investor Service Centre(ISC).--><!--                       Please Note: <br />--><!--                    <p>--><!--                       <span>--><!--                          Update Email ID and mobile number in your folio and online profile to receive One-time Password (OTP)--><!--                          for login. This facility is only available for individual investors.--><!--                        </span>--><!--                    </p>--><!--                    <br>--><!--                    <p>--><!--                      <span>--><!--                          Enter your PAN and Folio number to receive One-time Password (OTP) on email ID or mobile number--><!--                          registered in folio to verify your identity.--><!--                        </span>--><!--                    </p>--><ng-bind-html ng-bind-html=UpdateContact.dynamicNotes></ng-bind-html></div></form></div></div></div></div></div></div><div class=\"col-sm-6 widthContainer new-carosal-web p-0\"><slide-image></slide-image></div></div><!-- <footer-login></footer-login> --></div><style>.loginBtn{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border-radius: 100px !important;\n  }\n  .forgot-password-forms{\n    padding: 1% 10% 20px 10% !important;\n  }\n  .forms-container{\n    margin-top: 0% !important;\n    margin-bottom: 0px !important;\n  }\n  .padding0-container{\n    padding-top: 0px !important;\n  }\n   @media screen and (max-width: 1024px) {\n    .forms-container{\n      margin-top: -30% !important;\n      width: 90%;\n      margin: auto;\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n    .form-existing-wrap{\n      border-radius: 16px;\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n    }\n    .forgot-password-forms{\n      padding: 1% 5% 20px 5% !important;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    .header-form-resp{\n      position: relative;\n    }\n  }\n  @media only screen and (max-width: 767px) {\n    .login-header{\n      padding-top: 10px;\n    }\n  }\n  @media only screen and (min-width: 767px) and (max-width:1024px) {\n    .login-header{\n      padding-top: 30px;\n    }\n  }</style>");
$templateCache.put("app/update-contact/updateContactSuccessAcknowledgement.html","<div class=\"row row-no-gutters update-success-row\"><div class=\"col-md-12 form-existing-wrap res-form-exis\" style=\"margin-top: 15px\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=\"forgot-password-forms formSuccessAcknowledgement\"><img src=../../../assets/images/successImage.svg><div class=\"successFormHeading successFormHeadingResp\">Updated Successfully!</div><button class=\"loginBtn btn btn-bloc inputLoginBtn loginBtnNewThemeSuccess\" href=javascript:void(0) ui-sref=login tabindex=-1>OK</button></div></div></div>");
$templateCache.put("app/wekyc/wekyc.html","<login-header></login-header><div class=login-screen><section class=ekyc-wrapper><div class=container><div class=row><div class=col-12><h1 class=ekycHeading>eKYC using Aadhaar</h1><div class=ekycHeadingUnderline></div></div></div><div class=row><div class=col-12><div class=ekycText>Thank you for choosing HDFC Mutual Fund as your investment partner. Your KYC is not complete, please read below instructions to initiate eKYC process. You can now complete your KYC formalities online in a seamless and convenient manner using your Aadhaar.</div><div class=ekycMainSection><h4 class=\"ekycHeading headingItalic paddingOfFirstInstruction\">Instructions for completing eKYC using Aadhaar:</h4><ul class=\"instructionEKYC lineHeightInstruction\"><li>Enter Mobile number and Email ID and validate the same with One-time password (OTP) sent. At least one should be registered/seeded with your Aadhaar.</li><form autocomplete=off name=ekyc><div class=input-normal><input type=email style=\"margin-left: 46px ;width: 50%\" no-focus name=email ng-pattern=WEKYCController.pattern.email_regex ng-model=WEKYCController.payload.email maxlength=150 required> <span class=highlight></span> <span class=bar></span><label style=\"margin-left: 46px\">Email ID<span class=req>*</span></label><span ng-show=\"ekyc.email.$dirty && ekyc.email.$invalid\" style=\"margin-left: 46px\"><span class=error-input ng-show=ekyc.email.$error.required></span> <span class=error-input ng-show=ekyc.email.$error.pattern class=help-block ng-bind=WEKYCController.validateData.EMAIL_FIELD></span></span></div><div class=input-normal><input type=tel style=\"margin-left: 46px ;width: 50%\" no-focus name=phone ng-pattern=WEKYCController.pattern.mobile_regex_eKyc maxlength=10 ng-model=WEKYCController.payload.mobile required> <span class=highlight></span> <span class=bar></span><label style=\"margin-left: 46px\">Mobile Number<span class=req>*</span></label><span ng-show=\"ekyc.phone.$dirty && ekyc.phone.$invalid\" style=\"margin-left: 46px\"><span class=error-input ng-show=ekyc.phone.$error.pattern class=help-block ng-bind=WEKYCController.validateData.MOBILE_FIELD></span></span></div></form><li>Enter PAN, validate with KRA system, validate Online with Income Tax database through NSDL.</li><li>Upload PAN card copy (for upload to CKYC).</li><li>Validate your Aadhaar using One-time Password(OTP) through UIDAI Website</li><li>eSign the completed KYC form with an OTP and upload to CAMS eKYC portal.</li></ul><p class=note-ekyc><span>NOTE:</span> On clicking \'Proceed\' button, you shall be redirected to an external application of CAMS Limited for completing your eKYC process.</p><p class=ekycFaqLinkOne><a href=https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/faq/EKYC+Step-by-step+Guide+for+HDFC+MF+Investors.pdf target=_blank>Click here</a> for step by step guide for completing eKYC using Aadhaar</p><p class=ekycFaqLink><a href=https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/faq/ekyc-faq.pdf target=_blank>Click here</a> for FAQs on eKYC using Aadhaar</p></div><div class=ekycButtonSection><button ng-disabled=\"!(WEKYCController.payload.email && WEKYCController.payload.mobile)\" ng-click=WEKYCController.handleProceedAction() class=\"btn btn-primary-action\">Proceed</button></div></div></div></div></section><form autocomplete=off name=ekycForm id=ekycForm method=POST enctype=multipart/form-data action={{WEKYCController.actionUrl}}><input id=url type=hidden name=url ng-value=WEKYCController.formData.url> <input id=sess_id type=hidden name=sess_id ng-value=WEKYCController.formData.sess_id> <input id=ekyctype type=hidden name=ekyctype ng-value=WEKYCController.formData.ekyctype> <input id=Plkyc_type type=hidden name=Plkyc_type ng-value=WEKYCController.formData.plkyc_type> <input id=kyc_data type=hidden name=kyc_data ng-value=WEKYCController.formData.kyc_data></form></div><script>$(document).ready(function() {\n    window.history.pushState(null, \"\", window.location.href);\n    window.onpopstate = function() {\n        window.history.pushState(null, \"\", window.location.href);\n    };\n});</script>");
$templateCache.put("app/arn-review/panVerify/verifyPan.html","<div class=arn-review-main><div class=arn-review-body><form name=arnReviewForm ng-submit=PanVerify.submit()><!-- <div class=\"col-md-1\"></div> --><div class=\"row arn-responsive-div tax-status-wrapper\"><div class=\"col-xs-12 col-md-6\"><div class=tax-input-container><label class=s-label>Tax Status</label><div class=tax-field-container><div style=\"display: flex;justify-content: flex-start\"><input class=nomineeCheckbox type=radio id=resident-tax-status name=tax-status ng-value=true ng-model=PanVerify.formData.taxStatusResident><label for=resident-tax-status class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\">{{PanVerify.appConstants.TAX_STATUS_INDIVIDUAL.RESIDENT_INDIVIDUAL}}</label></div><div style=\"display: flex;justify-content: flex-start\"><input class=nomineeCheckbox type=radio id=tax-status name=tax-status ng-value=false ng-model=PanVerify.formData.taxStatusResident><label for=tax-status class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\">{{PanVerify.appConstants.TAX_STATUS_INDIVIDUAL.NON_RESIDENT_INDIVIDUAL}}</label></div></div></div></div></div><div class=\"row arn-responsive-div\"><p class=\"col-xs-12 col-sm-6 col-md-6\" style=\"margin-top: 15px\"><input id=pan aria-colspan=arnInput tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=PanVerify.formData.pan ng-pattern=/^[A-Z]{5}[0-9]{4}[A-Z]$/ ng-change=PanVerify.resetValues() ng-blur=PanVerify.checkPanVerification() placeholder=\"ENTER PAN *\" capitalize required style=\"border: none;border-radius: 0px;border-bottom: 1px solid rgb(128 128 128);width: 100%; font-size:18px\"><br><span class=error-input ng-if=PanVerify.panPStatus>This facility is only applicable for individual investor. Please enter valid PAN.</span> <span ng-show=\"arnReviewForm.pan.$dirty && arnReviewForm.pan.$invalid\"><span class=error-input ng-show=arnReviewForm.pan.$error.required ng-bind=PanVerify.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=arnReviewForm.pan.$error.maxlength ng-bind=PanVerify.validateData.PAN_FIELD></span> <span class=error-input ng-show=arnReviewForm.pan.$error.pattern ng-bind=PanVerify.validateData.PAN_FIELD></span></span></p><!-- DOB --><div class=\"col-xs-12 col-sm-6 col-md-6\" style=margin-top:3px><div class=\"input-select input-normal input-group date date-picker dateInputReg\" name=dob date-calendar data-enable=true data-viewmode={{PanVerify.viewMode}} data-date-default=PanVerify.formData.dob data-on-date-change=PanVerify.changeStartDate maxdate=now format=DD-MM-YYYY id=endDate><input class=\"newinvestor-dob webview\" tabindex=2 id=dobId name=dob type=text autocomplete=off placeholder=\"Date of Birth(dd-mm-yyyy) *\" required style=\"padding-bottom: 4px; font-size:18px\" ng-model=PanVerify.dob ng-change=PanVerify.varifyDate()> <input class=\"newinvestor-dob mobview\" tabindex=2 id=dobId name=dob type=text autocomplete=off placeholder=\"Date of Birth\" required style=\"padding-bottom: 4px; font-size:18px\" ng-model=PanVerify.dob ng-change=PanVerify.varifyDate()> <span class=input-group-addon for=dob><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><!-- <span class=\"error-input\" ng-if=\"PanVerify.dateErrorMessage\"\n                        ng-bind=\"PanVerify.dateErrorMessage\"></span> --> <span class=error-input ng-if=PanVerify.invalidPanDob>{{PanVerify.panMessage}}</span></div><!-- <span class=\"input-group-addon\" for=\"dob\" >\n                <img class=\"calender-icon-register\" src=\"../../assets/images/icons/dateIcon.png\" />\n              </span> --></div><!-- btn --><div class=confirmation-checkbox><input class=nomineeCheckbox type=checkbox id=confirmfoliocreate1 name=confirmfoliocreate1 ng-click=PanVerify.getconformation1() ng-checked=\"PanVerify.conformation == \'NOT_US_CANADA\'\"><label for=confirmfoliocreate1 class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\">I am not a US Person/Resident of Canada.</label></div><div class=\"col-xs-12 col-sm-12 col-md-12 text-center\" style=margin-top:40px><button class=pro-btn type=submit ng-disabled=\"PanVerify.dateErrorMessage ||\n        PanVerify.panPStatus || arnReviewForm.$invalid || !PanVerify.formData.dob || !PanVerify.dobtrue  || PanVerify.btnClose\">Proceed</button></div></div></form></div></div><style>.arn-review-main {\n    width: auto;\n  }\n.arn-responsive-div{\n  width: 80%;margin: auto;padding: 50px;\n}\n.webview{\n  display: block !important;\n}\n.mobview{\n  display: none !important;\n}\n@media only screen and (max-width: 700px) {\n      .arn-responsive-div {\n        width: 100%;margin: auto;padding: 0px;\n      }\n      .webview{\n        display: none  !important;\n      }\n      .mobview{\n        display: block !important;\n      }\n    }\n  .pro-btn {\n    width: 163px;\n    height:  45px;\n    border: none;\n    letter-spacing: 0px;\n    color: #FFFFFF;\n    background: #FD5C5E 0% 0% no-repeat padding-box;\n    border-radius: 18px;\n    font-size: 18px;\n  }\n\n  button:disabled,\n  button[disabled] {\n    opacity: 0.43;\n  }\n\n  input {\n    text-align: center;\n  }\n\n  .tax-field-container {\n    display: flex;\n    align-items: center;\n    column-gap: 40px;\n  }\n\n  label {\n    padding-bottom: 10px;\n    font-weight: 600;\n  }\n\n  .nomineeCheckbox+.confirmationnote {\n    display: block;\n    margin: 0.2em;\n    cursor: pointer;\n    padding: 0.2em;\n  }\n\n  .nomineeCheckbox {\n    display: none;\n  }\n\n  .nomineeCheckbox+.confirmationnote:before {\n    content: \"\\2714\";\n    border: 0.1em solid #000;\n    border-radius: 5px;\n    font-size: 8px;\n    padding-left: 3px;\n    padding-top: 1px;\n    padding-right: 3px;\n    padding-bottom: 1px;\n    margin-right: 0.2em;\n    vertical-align: bottom;\n    color: transparent;\n    transition: .2s;\n  }\n\n  .nomineeCheckbox:checked+.confirmationnote:before {\n    background-color: #38e574;\n    color: #fff;\n    border: 0.1em solid #38e574;\n  }\n\n  .note {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  .tax-status-wrapper {\n    padding: 20px 40px 0px 40px;\n  }\n\n  .confirmation-checkbox {\n    display: flex;\n    margin-top: 30px;\n  }\n\n  .s-label {\n    font-weight: 700;\n    font-size: 16px;\n  }</style>");
$templateCache.put("app/arn-review/select-folio/select-folio.html","<!-- <header class=\"header affix instant-header container-fluid\" style=\"position: fixed;top: 0%;left: 0%;\">\n    <div class=\"left-item pull-left flex-style\">\n      <img src=\"assets/images/logo.png\" alt=\"HDFC\" class=\"logo \" />\n    </div>\n    <div class=\"pull-right right-part\">\n      <span class=\"server-clock\" my-current-time=\"HomeInstant.format\"></span>\n      <span class=\"faq cursor-pointer\">\n        <a href=\"javaScript:void(0)\" ui-sref=\"faq\"> FAQ</a>\n      </span>\n      <span class=\"sign-out\" ng-click=\"\">\n        Logout\n      </span>\n    </div>\n  </header> --><div style=\"align-items: center;text-align: center;margin-top:20px\" ng-if=SelectFolio.beforotp><div class=\"row rdiv1\" style=\"width: 100%; margin: auto\" ng-if=\"SelectFolio.formData.maskedFolioList && SelectFolio.formData.maskedFolioList.length > 0\"><div class=\"row col-xs-12 col-sm-12 col-md-12\" style=\"border: 1px solid gray;border-top-left-radius: 15px;border-top-right-radius: 15px;padding: 5px\"><p class=\"col-xs-12 col-sm-1 col-md-1\"></p><p class=\"col-xs-12 col-sm-3 col-md-3\" style=\"font-weight: 600\">Folio Number</p><p class=\"col-xs-12 col-sm-3 col-md-3\" style=\"font-weight: 600\">Mobile Number</p><p class=\"col-xs-12 col-sm-5 col-md-5\" style=\"font-weight: 600\">Email ID</p></div><div class=\"row col-xs-12 col-sm-12 col-md-12\" style=\"border: 1px solid gray;border-bottom-left-radius: 15px;border-bottom-right-radius: 15px\"><div class=\"row col-xs-12 col-sm-12 col-md-12\" style=\"padding: 5px\" ng-repeat=\"x in SelectFolio.formData.maskedFolioList\"><input class=\"col-xs-12 col-sm-1 col-md-1\" type=radio ng-model=SelectFolio.folioNumber ng-change=SelectFolio.chooseFolio(x) name=folioNumber value={{x.folioNumber}}><p class=\"col-xs-12 col-sm-3 col-md-3\">{{x.id}}</p><p class=\"col-xs-12 col-sm-3 col-md-3\">{{x.mobileNo ? x.mobileNo : x.mobileNumber}}</p><p class=\"col-xs-12 col-sm-5 col-md-5\">{{x.email}}</p></div></div></div><p style=\"padding-top: 26px\" ng-if=\"SelectFolio.formData.maskedFolioList && SelectFolio.formData.maskedFolioList.length == 0\">{{SelectFolio.appConstants.NO_HDFC_FOLIO_MESSAGE}}</p><!-- <p>{{SelectFolio.folioNumber}}</p> --><div style=\"margin-top: 50px\"><button type=button ng-click=SelectFolio.addNewFolio() ng-if=\"SelectFolio.linkdata && SelectFolio.linkdata.isHdfcBank\" style=\"width: 163px;height:  45px;border: none;letter-spacing: 0px;color: #FFFFFF;    background: #FD5C5E 0% 0% no-repeat padding-box;border-radius: 18px;font-size: 18px\">Create New Folio</button> <button type=button ng-disabled=!SelectFolio.folioNumber ng-click=SelectFolio.sendOtp() ng-if=\"SelectFolio.IsFolio && !SelectFolio.linkdata.isHdfcBank || (SelectFolio.IsFolio && SelectFolio.linkdata.isHdfcBank && SelectFolio.formData.maskedFolioList && SelectFolio.formData.maskedFolioList.length > 0)\" style=\"width: 163px;height:  45px;border: none;letter-spacing: 0px;color: #FFFFFF;    background: #FD5C5E 0% 0% no-repeat padding-box;border-radius: 18px;font-size: 18px\">Send OTP</button></div></div><div class=otpDiv ng-if=!SelectFolio.beforotp><div class=\"group otpInput input-normal\" ng-class=\"{error:ModalOtpForm.otpNumber.$dirty && ModalOtpForm.otpNumber.$invalid}\"><!-- <P style=\"text-align: left;font-size: 12px;font-weight: bold;padding: 5px 5px 5px 0px; color: blue;\">Enter OTP</p> --> <input type=text ng-model=SelectFolio.otpNumber name=otpNumber is-number style=\"cursor: auto; font-size: 18px\" ng-change=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off placeholder=\"ENTER OTP\" autofocus> <span class=forgot><timer countdown=SelectFolio.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Resend OTP in &nbsp;<br class=break>{{countdown}}s</span> <a href=javascript:void(0); ng-show=\"countdown == 0\" ng-click=SelectFolio.reSendOtp(); class=forgot-pwd>Resend&nbsp;&nbsp;OTP</a></timer></span></div><div><span class=error-input ng-messages=ModalOtpForm.otpNumber.$error ng-show=ModalOtpForm.otpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span></div><div><p style=\"font-size: 14px;text-align: justify;padding: 0px 0px 30px 0px\">Please enter OTP sent on your folio registered <span ng-if=SelectFolio.formData.emailID>email ID ({{SelectFolio.formData.emailID}}) and </span><span ng-if=SelectFolio.formData.mobile>mobile number({{SelectFolio.formData.mobile}}) </span>.OTP is valid for 15 minutes only.</p></div><div class=flex><button type=button class=btn-pro ng-click=SelectFolio.back()>Back</button> <button type=button class=btn-pro ng-disabled=!SelectFolio.otpNumber ng-click=SelectFolio.verifyOtp()>Submit</button></div><style>.break{\n    display: none;\n  }\n   .rdiv1{\n    border: none;\n    margin: auto;\n   }\n   @media only screen and (max-width: 1150px) {\n    .rdiv1{\n    width: 100%;\n    margin: 15px;\n   }\n  }\n  @media only screen and (max-width: 450px) {\n    .break{\n    display: initial;\n  }\n  .forgot-pwd {\n    top: 7%;\n  }\n  .input-normal input {\n    width: 65% !important;\n  }\n  }\n      .col {\n        text-align: center;\n      }\n\n      .btn {\n        margin-right: 30px;\n      }\n\n      .otpInput {\n        border: 1px solid gray;\n        border-radius: 30px;\n      }\n\n      .input-normal input {\n        border-bottom: none !important;\n        border-right: 1px solid gray;\n        background: transparent;\n        text-align: center;\n        width: 70%;\n      }\n\n      .input-normal input:focus {\n        border-right: 1px solid gray !important;\n        border-bottom: none !important;\n        text-align: center;\n        width: 70% !important;\n      }\n\n      .otpDiv {\n        align-items: center;\n        text-align: center;\n        width: 50%;\n        margin-left: 25%;\n        margin-top: 10%;\n      }\n\n  .btn-pro {\n      width: 163px;\n      height:  45px;\n      border: none;\n      letter-spacing: 0px;\n      color: #FFFFFF;\n      background: #FD5C5E 0% 0% no-repeat padding-box;\n      border-radius: 18px;\n      font-size: 18px;\n    }\n\n\n    button:disabled,\n    button[disabled] {\n      opacity: 0.43;\n    }\n\n\n    .forgot-pwd {\n      position: absolute;\n      top: 20%;\n      right: 2%;\n      font-size: 12px;\n      padding: 5px 5px 5px 0px;\n      color: blue;\n    }\n    .input-normal .forgot a{\n      position: absolute;\n      top: 20%;\n      right: 2%;\n      font-size: 12px;\n      padding: 5px 5px 5px 0px;\n      color: blue;\n    }\n\n    @media (max-width: 900px) {\n      .otpDiv {\n        align-items: center;\n        text-align: center;\n        width: 100%;\n        margin-left: 0px;\n        margin-top: 10%;\n      }\n      .forgot-pwd {\n        top: 15%;\n        right: 2%;\n      }\n      .input-normal .forgot a{\n      top: 15%;\n      right: 2%;\n    }\n    }\n\n    @media only screen and (max-width: 480px) {\n      .input-normal input:focus{\n        width: 64% !important;\n      }\n    }</style></div>");
$templateCache.put("app/components/footer/footer-login.html","<footer class=\"container-fluid footer\"><div class=row><div class=\"col-md-12 footer-main-wrap\"><div class=footer-inner-wrap><div class=footer-data-container style=\"flex-direction: column\"><img src=assets/images/MF-Online-Investors.svg alt=\"MF online investors\" class=logo-main-mf style=\"width: 70%\"><div class=footer-copyright-text>Copyright © 2024. All rights reserved</div></div><div class=footer-data-container><img src=assets/images/toll.svg class=\"toll-icon icon-align-footer body-img-color\"> <img src=assets/images/phoneBW.svg style=\"display: none\" class=\"toll-icon icon-align-footer body-img-bw\"> <span class=footer-text-common>1800 3010 6767 / 1800 419 7676 (Toll - Free)</span></div><div class=footer-data-container><img src=assets/images/mail.svg class=\"mail-icon-new icon-align-footer body-img-color\"> <img src=assets/images/mailBW.svg style=\"display: none\" class=\"mail-icon-new icon-align-footer body-img-bw\"> <span class=\"footer-text-common footer-link\"><a href=mailto:Hello@hdfcfund.com class=text-blue>Hello@hdfcfund.com</a></span></div><div class=footer-data-container><span class=footer-text-common>For more info, visit <span class=footer-link><a href={{WEBSITE_LINK}} target=_blank>hdfcfund.com</a></span></span></div><div class=footer-data-container><div class=\"footer-text-common social-text-index\">FOLLOW US</div><div class=social-container-index><a href=https://www.linkedin.com/company/hdfc-mutual-fund/ target=_blank><img src=assets/images/linkedin.svg class=social-icon> </a><a href=https://twitter.com/hdfcmf target=_blank><img src=\"assets/images/Twitter Logo.svg\" class=social-icon width=26px> </a><a href=https://www.youtube.com/channel/UCiuV2NCrpHzhQogNvK1FZ_A target=_blank><img src=assets/images/youtube.svg class=social-icon></a></div></div><div class=download-app-footer><div class=\"footer-text-common social-text-index\">DOWNLOAD THE APP</div><div class=social-container-index><a href=\"https://play.google.com/store/apps/details?id=com.hdfcfund.investor&hl=en_IN\" target=_blank><img src=assets/images/google-play.png class=gp-icon> </a><a href=\"https://itunes.apple.com/us/app/mfonline-investors/id1380088205?mt=8\" target=_blank><img src=assets/images/app-store.svg class=istore-icon></a></div></div></div></div></div><div class=row><div class=experiance-footer>For best experience use Chrome (version 60 and above), Firefox (version 50 and above), Safari(Latest version), Microsoft Edge(Latest version)</div></div></footer>");
$templateCache.put("app/components/footer/footer-post-login.html","<footer class=\"container-fluid footer main-footer\"><div class=\"browser-support text-center\">For best experience use Chrome (version 60 and above), Firefox (version 50 and above), Safari(Latest version), Microsoft Edge(Latest version).</div><div class=row><div class=\"col-md-5 flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"footer-logo pull-left\"><p>{{ footerDate | date: \'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"col-md-2 flex-style\"><div class=hdfc-mutualfund><img src=assets/images/hdfc-mutualfund.jpg alt=\"HDFC Mutual Fund\" class=\"footer-logo1 pull-left\"></div><div class=app-store><a href=\"https://itunes.apple.com/us/app/mfonline-investors/id1380088205?mt=8\" target=_blank><svg id=livetype xmlns=http://www.w3.org/2000/svg width=60 height=22 margin-top=5 viewBox=\"0 0 119.66407 40\"><g><g><g><path d=M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z style=\"fill: #a6a6a6\"/><path d=M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z /></g><g id=_Group_ data-name=&lt;Group&gt;><g id=_Group_2 data-name=&lt;Group&gt;><g id=_Group_3 data-name=&lt;Group&gt;><path id=_Path_ data-name=&lt;Path&gt; d=M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z style=\"fill: #fff\"/><path id=_Path_2 data-name=&lt;Path&gt; d=M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z style=\"fill: #fff\"/></g></g><g><path d=M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z style=\"fill: #fff\"/><path d=M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z style=\"fill: #fff\"/><path d=M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z style=\"fill: #fff\"/><path d=M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z style=\"fill: #fff\"/><path d=M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z style=\"fill: #fff\"/><path d=M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z style=\"fill: #fff\"/><path d=M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z style=\"fill: #fff\"/><path d=M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z style=\"fill: #fff\"/></g></g></g><g id=_Group_4 data-name=&lt;Group&gt;><g><path d=M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z style=\"fill: #fff\"/><path d=M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z style=\"fill: #fff\"/><path d=M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z style=\"fill: #fff\"/><path d=M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z style=\"fill: #fff\"/><path d=M59.09377,8.437h.88867v6.26074h-.88867Z style=\"fill: #fff\"/><path d=M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z style=\"fill: #fff\"/><path d=M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z style=\"fill: #fff\"/><path d=M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z style=\"fill: #fff\"/><path d=M79.23,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C82.12453,13.99463,82.563,13.42432,82.563,12.44434Z style=\"fill: #fff\"/><path d=M84.66945,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915H87.605V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z style=\"fill: #fff\"/><path d=M93.51516,9.07373v1.1416h.97559v.74854h-.97559V13.2793c0,.47168.19434.67822.63672.67822a2.96657,2.96657,0,0,0,.33887-.02051v.74023a2.9155,2.9155,0,0,1-.4834.04541c-.98828,0-1.38184-.34766-1.38184-1.21582v-2.543h-.71484v-.74854h.71484V9.07373Z style=\"fill: #fff\"/><path d=M95.70461,8.437h.88086v2.48145h.07031a1.3856,1.3856,0,0,1,1.373-.80664,1.48339,1.48339,0,0,1,1.55078,1.67871v2.90723H98.69v-2.688c0-.71924-.335-1.0835-.96289-1.0835a1.05194,1.05194,0,0,0-1.13379,1.1416v2.62988h-.88867Z style=\"fill: #fff\"/><path d=M104.76125,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,100.73,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688h-3.17969v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,101.63527,12.03076Z style=\"fill: #fff\"/></g></g></g></svg> </a><a href=\"https://play.google.com/store/apps/details?id=com.hdfcfund.investor&hl=en_IN\" target=_blank><img src=assets/images/google-play-badge.png alt=\"Google Play\" class=\"footer-logo1 pull-left\"></a></div></div><div class=\"col-md-5 clearfix\"><div style=\"padding-top:18px; text-align: center\">Email Us: <a href=mailto:Hello@hdfcfund.com class=text-blue>Hello@hdfcfund.com</a> | Call Us: 1800 3010 6767 / 1800 419 7676 (Toll - Free)</div></div></div></footer>");
$templateCache.put("app/components/footer/footer-pre-login.html","<footer class=\"container-fluid footer\"><div class=\"browser-support text-center\">For best experience use Chrome (version 60 and above), Firefox (version 50 and above), Safari(Latest version), Microsoft Edge(Latest version).</div><div class=row><div class=\"col-md-5 flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"footer-logo pull-left\"><p>{{ footerDate | date: \'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"col-md-2 flex-style\"><div class=hdfc-mutualfund><img src=assets/images/hdfc-mutualfund.jpg alt=\"HDFC Mutual Fund\" class=\"footer-logo1 pull-left\"></div><div class=app-store><a href=\"https://itunes.apple.com/us/app/mfonline-investors/id1380088205?mt=8\" target=_blank><svg id=livetype xmlns=http://www.w3.org/2000/svg width=60 height=22 margin-top=5 viewBox=\"0 0 119.66407 40\"><g><g><g><path d=M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z style=\"fill: #a6a6a6\"/><path d=M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z /></g><g id=_Group_ data-name=&lt;Group&gt;><g id=_Group_2 data-name=&lt;Group&gt;><g id=_Group_3 data-name=&lt;Group&gt;><path id=_Path_ data-name=&lt;Path&gt; d=M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z style=\"fill: #fff\"/><path id=_Path_2 data-name=&lt;Path&gt; d=M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z style=\"fill: #fff\"/></g></g><g><path d=M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z style=\"fill: #fff\"/><path d=M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z style=\"fill: #fff\"/><path d=M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z style=\"fill: #fff\"/><path d=M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z style=\"fill: #fff\"/><path d=M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z style=\"fill: #fff\"/><path d=M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z style=\"fill: #fff\"/><path d=M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z style=\"fill: #fff\"/><path d=M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z style=\"fill: #fff\"/></g></g></g><g id=_Group_4 data-name=&lt;Group&gt;><g><path d=M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z style=\"fill: #fff\"/><path d=M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z style=\"fill: #fff\"/><path d=M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z style=\"fill: #fff\"/><path d=M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z style=\"fill: #fff\"/><path d=M59.09377,8.437h.88867v6.26074h-.88867Z style=\"fill: #fff\"/><path d=M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z style=\"fill: #fff\"/><path d=M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z style=\"fill: #fff\"/><path d=M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z style=\"fill: #fff\"/><path d=M79.23,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C82.12453,13.99463,82.563,13.42432,82.563,12.44434Z style=\"fill: #fff\"/><path d=M84.66945,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915H87.605V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z style=\"fill: #fff\"/><path d=M93.51516,9.07373v1.1416h.97559v.74854h-.97559V13.2793c0,.47168.19434.67822.63672.67822a2.96657,2.96657,0,0,0,.33887-.02051v.74023a2.9155,2.9155,0,0,1-.4834.04541c-.98828,0-1.38184-.34766-1.38184-1.21582v-2.543h-.71484v-.74854h.71484V9.07373Z style=\"fill: #fff\"/><path d=M95.70461,8.437h.88086v2.48145h.07031a1.3856,1.3856,0,0,1,1.373-.80664,1.48339,1.48339,0,0,1,1.55078,1.67871v2.90723H98.69v-2.688c0-.71924-.335-1.0835-.96289-1.0835a1.05194,1.05194,0,0,0-1.13379,1.1416v2.62988h-.88867Z style=\"fill: #fff\"/><path d=M104.76125,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,100.73,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688h-3.17969v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,101.63527,12.03076Z style=\"fill: #fff\"/></g></g></g></svg> </a><a href=\"https://play.google.com/store/apps/details?id=com.hdfcfund.investor&hl=en_IN\" target=_blank><img src=assets/images/google-play-badge.png alt=\"Google Play\" class=\"footer-logo1 pull-left\"></a></div></div><div class=\"col-md-5 clearfix\"><div style=padding-top:18px>Email Us: <a href=mailto:Hello@hdfcfund.com class=text-blue>Hello@hdfcfund.com</a> | Call Us: 1800 3010 6767 / 1800 419 7676 (Toll - Free)</div></div></div></footer>");
$templateCache.put("app/components/header/header.html","<div class=headStyle><ul><li ng-click=\"Header.changedFont(\'increment\')\" title=\"Increase font-size\">A+</li><li ng-click=\"Header.changedFont(\'original\')\" title=\"Reset font size\">A</li><li ng-click=\"Header.changedFont(\'decrement\')\" title=\"Decrease font size\">A-</li><li ng-click=Header.contrast() class=box title=\"High Contrast\"><span class=\"glyphicon glyphicon-adjust\"></span></li></ul></div><header class=\"header header2 container-fluid\"><div class=\"row main-head\"><div class=\"left-item pull-left flex-style\"><img src=assets/images/logo.png alt=HDFC class=logo ui-sref=welcome></div><!-- Temporary changes done for HMF-9350 --><!--<span class=\"scheme-pdf\"><a href=\"assets/documents/HDFC-Mutual-Fund-Scheme-Positioning-and-Categorization.pdf\" target=\"blank\" tabindex=\"0\">New Categorization and Rationalization of Schemes</a></span>--><!--<span class=\"scheme-pdf\">{{Header.constants.NAV_APPLICABILITY_MESSAGE}}</span>--><nav class=\"right-nav pull-right\"><span class=server-clock><!--{{Header.currentTime}} PM (IST)--></span><ul><li class=server-clock><span my-current-time=Header.format></span></li><li ui-sref=welcome.existingUserWelcome class=home-link><a href=\"\"><i class=home-icon></i></a></li><li class=dropdown id=menuDropdown><a data-bs-toggle=dropdown aria-haspopup=true aria-expanded=false href=\"\"><i class=transactions-icon></i> <span class=block>Transact Now</span></a><div class=\"dropdown-menu transact-dropdown dropdown-options\"><ul><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'purchase\')\">Purchase</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'sip\')\">Systematic Investment Plan (SIP)</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'flexsip\')\">Flex SIP</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'switch\')\">Switch</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'redemption\')\">Redemption</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'stp\')\">Systematic Transfer Plan (STP)</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'flexindex\')\">Flex Index</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'swp\')\">Systematic Withdrawal Advantage Plan (SWAP)</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'dtp\')\">Transfer IDCW Plan (TIP)</a></li><li><a href=javascript:void(0) ng-click=\"Header.goToState(\'rolloverView\')\">Roll Over</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'instantRedemption\')\">Instant Access Facility</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'changeDividendOption\')\">Change IDCW Option</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'smartSwap\')\">SMART SWAP</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'dreamSip\')\">DREAM SIP</a></li><!--<li data-toggle=\"tooltip\" title=\"This service is temporarily unavailable. Inconvenience regretted!\"><a  style=\"cursor: not-allowed\" >Instant Access Facility</a></li>--></ul></div></li><li ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><a ui-sref=main.favourite-transactions><i class=favourites-icon></i></a></li><li class=dropdown><a href=\"\" data-bs-toggle=dropdown class=notification-dropdown aria-haspopup=true aria-expanded=false><i class=notification-icon></i> <span class=count tabindex=-1 ng-if=\"Header.notificationCount>0 && !Header.iconClicked && uiState.current.name!=\'main.notifications\'\" ng-click=Header.latestNotification()>{{Header.notificationCount}}</span></a><div class=\"dropdown-menu notify-dropdown dropdown-options\"><ul><li ng-repeat=\"notification in Header.latestNotificationList\">{{notification.title}}<p class=time-stamp ng-if=\"notification.diff===0\">{{notification.time}}</p><p class=time-stamp ng-if=\"notification.diff>0\">{{notification.date1}} at {{notification.time1}}</p></li><li ng-if=!Header.latestNotificationList.length class=text-center>You currently do not have any notifications</li></ul><p class=\"view-all cursor-pointer\" ng-if=Header.latestNotificationList.length ui-sref=main.notifications class=cursor-pointer><a href=\"\" ng-click=Header.viewAllClicked()>View All <i class=arrow-blue-right-icon></i></a></p></div></li><li class=dropdown><a href=javaScript:void(0) ng-click=\"Header.goToState(\'cart\')\" data-bs-toggle=dropdown class=notification-dropdown aria-haspopup=true aria-expanded=false style=\"display: flex;align-items: center\"><span>Cart</span><i class=cart-icon></i> <span class=countEcart tabindex=-1 ng-if=!Header.iconClicked>{{Header.cartCount}}</span></a></li><li class=\"dropdown contentAlignCenter\" style=\"padding: 2px\"><div><div id=custom-select data-list=1><div class=select-tab data-bs-toggle=dropdown><div><div class=select-text><p style=\"color:white;font-size: 14px;  font-weight: 600\">{{Header.selectedLinkPan.investorFirstName[0]}}</p></div></div></div><div class=\"dropdown-menu select-list\"><!-- display linked list --><div class=list-item ng-class=\"{\'currentActiveUser\': _option.panNumber == Header.selectedLinkPan.panNumber}\" ng-repeat=\"_option in Header.linkedPanList\" ng-click=\"!_option.selected?Header.changeLinkedPan(_option):\'\'\" style=\"color: #231F20;  display: flex;   justify-content: space-between;  text-align: left;   align-items: center\"><span style=\"display: flex;color: black;align-items: center\">{{_option.investorFirstName.split(\' \')[0]}} <span ng-if=_option.default style=\"color: #7B7979;font-size: 10px\">&nbsp;(Primary)</span> </span><img ng-if=\"_option.panNumber == Header.selectedLinkPan.panNumber\" src=../../../assets/images/icons/blue-check.svg style=\"height: 16px;padding-right: 12px;margin:0px\" alt=\"\"></div><!-- my profile --><div class=\"list-item dropDownButton\" style=\"border-top:1px solid #ccc\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><a ui-sref=main.profile.basicInfo class=webProlieOptionList><img src=../../../assets/images/icons/profile-blue.svg style=\"height: 16px;margin: 0px\" alt=\"\">&nbsp;&nbsp;My Profile</a></div><!-- Add Account --><div class=\"list-item dropDownButton\" class=contentAlignCenter ng-click=\"Header.changeLinkedPan(\'Add\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber && !Header.corporateUserFlag\"><img src=../../../assets/images/icons/blue-add-icon.svg style=\"height: 16px; margin : 0px\" alt=\"\">&nbsp;&nbsp;Add Account</div><!-- Managed Acconts --><div class=\"list-item dropDownButton\" class=contentAlignCenter ng-click=\"Header.changeLinkedPan(\'ManagedAccounts\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber && !Header.corporateUserFlag\"><img src=../../../assets/images/icons/blue-setting-icon.svg style=\"height: 16px; margin: 0px\" alt=\"\">&nbsp;&nbsp;Manage Accounts</div><!-- More option list start--><div ng- class=moreselect-list id=moreselectList4 ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><div class=\"list-item dropDownButton\"><a ui-sref=main.favourite-transactions class=webProlieOptionList><img src=../../../assets/images/icons/fav.svg style=\"height: 16px;margin: 0px\" alt=\"\">&nbsp;Favorites</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none\"><a ui-sref=main.saved-items class=webProlieOptionList><img src=../../../assets/images/icons/saveItem.svg style=\"height: 16px;margin: 0px\" alt=\"\">&nbsp;Saved Items</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none;color:#347ABC\"><a ui-sref=main.feedback class=webProlieOptionList><img src=../../../assets/images/icons/feedback.svg style=\"height: 16px;margin: 0px\" alt=\"\">&nbsp;Feedback</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none;color:#347ABC\"><a ui-sref=main.dashboardEdit.widgits class=webProlieOptionList style=\"line-height: normal !important\"><img src=../../../assets/images/icons/customize-dashboard-icon.svg style=\"height: 16px;margin: 0px\" alt=\"\">&nbsp;Customize Dashboard</a></div></div><!-- More option list End--><!-- More option --><div class=\"list-item dropDownButton\" id=moreOptionButton4 onclick=\"toggleMoreList(event, \'list4Data\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\" style=\"border-bottom:1px solid #ccc; display: flex;    justify-content: space-between;\n                                  text-align: left;     align-items: center\"><span style=\"display: flex;  color: #347ABC\"><img src=../../../assets/images/icons/more-icon.svg style=\"height: 16px; margin: 0px\" alt=\"\">&nbsp;&nbsp;More </span><img src=../../../assets/images/icons/arrow-blue-right.png style=\"width: 20px;height: 16px;padding-right: 12px;margin:0px\" alt=\"\"></div><!-- Logout --><div class=\"list-item dropDownButton\" style=color:#EB1C24><a ng-click=Header.logoutMe(); href=javascript:void(0) style=\"display: inline-flex;color:#EB1C24 !important;margin: 0px;padding: 0px; align-items: center\" class=btn-nohover><img src=../../../assets/images/icons/logout-red.svg style=\"height: 16px;margin: 0px;padding: 0px\" alt=\"\">&nbsp;&nbsp;Logout</a></div></div></div></div></li></ul></nav></div></header><!--    Mobile Header\n------------------------------><header class=\"mobile-header container-fluid common affix\"><ul><li id=menuButton><a href=\"\"><i class=menu-icon></i></a></li><li ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><a ui-sref=main.favourite-transactions><i class=favourites-icon></i></a></li><li><a href=\"\" data-bs-toggle=dropdown aria-haspopup=true aria-expanded=false><i class=transactions-icon></i></a><div class=\"dropdown-menu transact-dropdown dropdown-options\"><ul><li ng-click=\"Header.goToState(\'purchase\')\"><a href=javaScript:void(0)>Purchase</a></li><li ng-click=\"Header.goToState(\'sip\')\"><a href=javaScript:void(0)>Systematic Investment Plan (SIP)</a></li><li ng-click=\"Header.goToState(\'flexsip\')\"><a href=javaScript:void(0)>Flex SIP</a></li><li ng-click=\"Header.goToState(\'switch\')\"><a href=javaScript:void(0)>Switch</a></li><li ng-click=\"Header.goToState(\'redemption\')\"><a href=javaScript:void(0)>Redemption</a></li><li ng-click=\"Header.goToState(\'stp\')\"><a href=javaScript:void(0)>Systematic Transfer Plan (STP)</a></li><li ng-click=\"Header.goToState(\'flexindex\')\"><a href=javaScript:void(0)>Flex Index</a></li><li ng-click=\"Header.goToState(\'swp\')\"><a href=javaScript:void(0)>Systematic Withdrawal Advantage Plan (SWAP)</a></li><li ng-click=\"Header.goToState(\'dtp\')\"><a href=javaScript:void(0)>Transfer IDCW Plan (TIP)</a></li><li ui-sref=main.rolloverView><a href=javascript:void(0)>Roll Over</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'instantRedemption\')\">Instant Access Facility</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'changeDividendOption\')\">Change IDCW Option</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'smartSwap\')\">SMART SWAP</a></li><li><a href=javaScript:void(0) ng-click=\"Header.goToState(\'dreamSip\')\">DREAM SIP</a></li><!--<li ng-click=\"Header.goToState(\'instantRedemption\')\">\n            <a href=\"javaScript:void(0)\">Instant Redemption</a>\n          </li>--></ul></div></li><li><a href=\"\" data-bs-toggle=dropdown class=notification-dropdown aria-haspopup=true aria-expanded=false><i class=notification-icon></i> <span class=count tabindex=-1 ng-if=\"Header.notificationCount>0 && !Header.iconClicked && uiState.current.name!=\'main.notifications\'\" ng-click=Header.latestNotification()>{{Header.notificationCount}}</span></a><div class=\"dropdown-menu notify-dropdown dropdown-options\"><ul><li ng-repeat=\"notification in Header.latestNotificationList\">{{notification.title}}<p class=time-stamp ng-if=\"notification.diff===0\">{{notification.time}}</p><p class=time-stamp ng-if=\"notification.diff>0\">{{notification.date1}} at {{notification.time1}}</p></li><li ng-if=!Header.latestNotificationList.length class=text-center>You currently do not have any notifications</li></ul><p class=\"view-all cursor-pointer\" ui-sref=main.notifications ng-click=Header.viewAllClicked() class=cursor-pointer ng-if=Header.latestNotificationList.length>View All <i class=arrow-blue-right-icon></i></p></div></li><li class=mobile-cart><a href=javaScript:void(0) ng-click=\"Header.goToState(\'cart\')\" data-bs-toggle=dropdown class=notification-dropdown aria-haspopup=true aria-expanded=false style=\"display: flex\"><i class=cart-icon></i> <span class=countEcart tabindex=-1 ng-if=!Header.iconClicked>{{Header.cartCount}}</span></a></li><!-- mobile screen --><li class=\"dropdown sub-actions contentAlignCenter\"><div id=custom-select data-list=1><div class=select-tab data-bs-toggle=dropdown><div><div class=select-text><p style=\"color: white; font-size: 14px;  font-weight: 600\">{{Header.selectedLinkPan.investorFirstName[0]}}</p></div></div></div><div class=\"dropdown-menu select-list\"><!-- display linked list --><div class=list-item ng-class=\"{\'currentActiveUser\': _option.panNumber == Header.selectedLinkPan.panNumber}\" ng-repeat=\"_option in Header.linkedPanList\" ng-click=\"!_option.selected?Header.changeLinkedPan(_option):\'\'\" style=\"color: #231F20 !important;  display: flex;   justify-content: space-between;  text-align: left;   align-items: center\"><span style=\"display: flex;align-items: center\">{{_option.investorFirstName.split(\' \')[0]}} <span ng-if=_option.default style=\"color: #7B7979;font-size: 10px\">&nbsp;(Primary)</span> </span><img ng-if=\"_option.panNumber == Header.selectedLinkPan.panNumber\" src=../../../assets/images/icons/blue-check.svg style=\"height: 16px;padding-right: 12px\" alt=\"\"></div><!-- my profile --><div class=\"list-item dropDownButton\" style=\"border-top:1px solid #ccc\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><a ui-sref=main.profile.basicInfo style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/profile-blue.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;My Profile</a></div><!-- Add Account --><div class=\"list-item dropDownButton\" ng-click=\"Header.changeLinkedPan(\'Add\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber && !Header.corporateUserFlag\"><img src=../../../assets/images/icons/blue-add-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Add Account</div><!-- Managed Acconts --><div class=\"list-item dropDownButton\" ng-click=\"Header.changeLinkedPan(\'ManagedAccounts\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber && !Header.corporateUserFlag\"><img src=../../../assets/images/icons/blue-setting-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Manage Accounts</div><!-- More option --><div class=\"list-item dropDownButton\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\" id=moreOptionButton3 onclick=\"toggleMoreList(event, \'list3Data\')\" style=\"border-bottom:1px solid #ccc;\n                          display: flex;\n                          justify-content: space-between;\n                          text-align: left;\n                          align-items: center\"><span style=\"display: flex\"><img src=../../../assets/images/icons/more-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;More </span><img src=../../../assets/images/icons/arrow-blue-right.png style=\"width: 20px;padding-right: 12px\" alt=\"\"></div><!-- More option list start--><div ng- class=moreselect-list id=moreselectList3 ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><div class=\"list-item dropDownButton\"><a ui-sref=main.favourite-transactions style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/fav.svg style=\"height: 16px\" alt=\"\">&nbsp;Favorites</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none\"><a ui-sref=main.saved-items style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/saveItem.svg style=\"height: 16px\" alt=\"\">&nbsp;Saved Items</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none;color:#347ABC\"><a ui-sref=main.feedback style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/feedback.svg style=\"height: 16px\" alt=\"\">&nbsp;Feedback</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none;color:#347ABC;padding-left: 5px !important\"><a ui-sref=main.dashboardEdit.widgits class=webProlieOptionList><img src=../../../assets/images/icons/customize-dashboard-icon.svg style=\"height: 16px;margin: 0px\" alt=\"\">&nbsp;Customize Dashboard</a></div></div><!-- More option list End--><!-- Logout --><div class=\"list-item dropDownButton\" style=color:#EB1C24><a ng-click=Header.logoutMe(); href=javascript:void(0) style=\"display: inline-flex;color:#EB1C24 !important\"><img src=../../../assets/images/icons/logout-red.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Logout</a></div></div></div></li></ul><div class=black-tint></div><!--  <div class=\"row low-head\">--><!--    &lt;!&ndash; Temporary changes done for HMF-9350 &ndash;&gt;--><!--    &lt;!&ndash;<a href=\"assets/documents/HDFC-Mutual-Fund-Scheme-Positioning-and-Categorization.pdf\" target=\"blank\" tabindex=\"0\">New Categorization and Rationalization of Schemes</a>&ndash;&gt;--><!--    <a href=\"https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf\" target=\"blank\" tabindex=\"0\">Temporary Change in Cut-Off timings for NAV applicability</a>--><!--  </div>--></header><!--    Mobile Sidebar\n------------------------------><div class=black-tint></div><aside class=mobile-menu><div class=\"affix stick-top\"><div class=head><img class=logo-mobile src=../../../assets/images/logo.png></div><div class=middle ui-sref=welcome.existingUserWelcome><span class=user-pic><i class=home-icon></i></span><div class=server-clock-mobile><span my-current-time=Header.format></span></div></div></div><nav><aside class=mobile-nav><ul class=list-group><li ui-sref=main.dashboard.widgits><span class=\"dashboard-sidebar-icon default-icon\"></span> <span class=\"dashboard-sidebar-active-icon active-icon\"></span> <span class=nav-link>Dashboard</span></li><li ui-sref=main.transactions.recent><span class=\"transaction-sidebar-icon default-icon\"></span> <span class=\"transaction-sidebar-active-icon active-icon\"></span> <span class=nav-link>Transactions</span></li><li ui-sref=main.portfolio.list><span class=\"investment-sidebar-icon default-icon\"></span> <span class=\"investment-sidebar-icon active-icon\"></span> <span class=nav-link>Portfolio</span></li><li ui-sref=main.systematicCorner><span class=\"corner-sidebar-icon default-icon\"></span> <span class=\"corner-sidebar-active-icon active-icon\"></span> <span class=nav-link>Systematic-Corner</span></li><li ui-sref=main.statements><span class=\"reports-sidebar-icon default-icon\"></span> <span class=\"reports-sidebar-active-icon active-icon\"></span> <span class=nav-link>Statements</span></li><li ui-sref=main.services><span class=\"service-requests-icon default-icon\"></span> <span class=\"service-requests-active-icon active-icon\"></span> <span class=nav-link>Services</span></li><li><span class=\"website-sidebar-icon default-icon\"></span> <span class=\"website-sidebar-active-icon active-icon\"></span> <span class=nav-link><a href={{Header.HDFC_API.WEBSITE_LINK}} target=_blank>HDFC Fund Website</a></span></li><li ui-sref=main.feedback><span class=\"feedback-sidebar-icon default-icon\"></span> <span class=\"feedback-sidebar-active-icon active-icon\"></span> <span class=nav-link>Feedback</span></li></ul></aside></nav></aside><style>#menuDropdown .dropdown-backdrop {\n  display: none !important;\n  } \n  .contentAlignCenter{\n    display: flex;\n    align-items: center;\n    margin-right: 8px;\n    justify-content: center;\n  }\n  .contentAlignCenter2{\n    display: flex;\n    align-items: center; \n    justify-content: left;\n    background: transparent;\n  }\n  .header-right-wrapper{ \n      display: flex;\n      justify-content: right;\n      align-items: center; \n  }\n  .new-bm-dropdown{\n    border-radius: 0px 0px 8px 8px; \n    inset: 15px 0px auto auto !important;\n    width: 218px;\n  }\n  .login-form-switch .slider{\n    background-color:linear-gradient(93.92deg, #21ADE9 -7.52%, #1162C7 99.94%);\n  }\n  .activeTab{\n    border-bottom: 2px solid blue;\n    width: 20px;\n  }  \n\n  #custom-select {\n      width: 32px;  \n      overflow: hidden; color: #2A699E; \n  }\n\n  .select-tab {\n      border: 1px solid #AECAE4;\n      border-radius: 50%;\n      min-width: 30px;\n      height: 30px;\n      display: flex  !important;\n      justify-content: center  !important;\n      align-items: center;\n      text-align: left;\n      padding: 10px;\n      cursor: pointer;\n  } \n  .select-list {\n      z-index: 1;\n      right: 10px !important;\n      margin-top: 4px; \n      position: absolute;\n      background: white; \n      display: none; /* Initially hidden */\n      border: 1px solid #ccc; \n      width: 200px;\n      text-align: left;  \n      border-bottom-left-radius: 10px;\n      border-bottom-right-radius: 10px; \n      \n    .list-item{ \n      border: none;\n      padding-left: 10px;\n      display: flex;\n      align-items: center;\n      height:35px;\n    }\n  } \n  .moreselect-list {\n    margin-top: 0px !important;\n    z-index: 1;\n      right: 198px !important;\n      margin-top: 4px; \n      position: absolute;\n      background: white; \n      display: none; /* Initially hidden */\n      border: 1px solid #ccc; \n      min-width: 164px;\n      text-align: left;  \n      border-radius: 10px; \n      \n    .list-item{ \n      padding-left: 10px;\n      display: flex;\n      align-items: center;\n      min-height:35px;\n    }\n  }  \n\n  .dropDownButton{\n    font-size: 12px;   \n    border-top: 1px solid #ccc; \n    color: #347ABC;   \n    font-weight: 550; \n  } \n  .linkPanList{\n    background: transparent !important;\n    color: black !important; \n    text-align: left !important;\n    border-radius: 4px !important;\n  }\n  .select-text{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  } \n  .currentActiveUser{\n    background: #EBF2F9 !important; \n  }\n  @media screen and (max-width: 480px) {\n    .moreselect-list {\n        margin: 5px;\n        right: 0px !important;\n        width: 170px;\n    }\n    .select-list {\n        width: 170px;\n    }\n}\n.webProlieOptionList{\n  display: inline-flex !important;\n  color: #347ABC !important;\n  background: transparent !important;\n  padding: 0px !important;\n  margin: 0px !important;\n  align-items: center !important;\n}\n.btn-nohover:hover{\n  background: transparent !important;\n}\n.header .right-nav > ul > li a:hover{\n  color:#347ABC !important;\n}</style><script>var openListId = null; \n\n  function toggleList(event, listData) {\n      event.stopPropagation(); // Prevent click from propagating to document\n      const listId = parseInt(listData.charAt(4)); // Extract list number from \'listXData\'\n      const list = document.getElementById(`selectList${listId}`); \n      // const moreOptionList1 = document.getElementById(\"moreselectList3\");  \n      // const moreOptionList2 = document.getElementById(\"moreselectList4\");    \n  \n        if (list.style.display === \'block\') {\n          list.style.display = \'none\';  \n          openListId = null;\n      } else { \n        // moreOptionList1.style.display = \'none\'; \n        // moreOptionList2.style.display = \'none\'; \n        list.style.display = \'block\';   \n          openListId = listId;\n      }\n  }\n\n  function toggleMoreList(event, listData) {\n      event.stopPropagation();  \n      const listId = parseInt(listData.charAt(4)); // Extract list number from \'listXData\'\n      const list = document.getElementById(`moreselectList${listId}`);  \n      const moreOptionButton = document.getElementById(`moreOptionButton${listId}`);  \n  \n      if (list.style.display === \'block\') {\n          list.style.display = \'none\';  \n          moreOptionButton.style.backgroundColor = \'white\';\n      } else {\n          list.style.display = \'block\'; \n          moreOptionButton.style.backgroundColor = \'#EBF2F9\';\n      }\n  }\n document.addEventListener(\'click\', () => {\n     // Close all lists if clicking outside\n     const lists = document.querySelectorAll(\'.select-list\');   \n     lists.forEach(list => {  \n      list.style.display = \'none\';\n     }); \n     openListId = null;\n });</script>");
$templateCache.put("app/components/header/login-header.html","<header class=\"post-login-header container-fluid\" ng-if=\"Header.isLoggedInStatus && !Header.faqVisible\"><div class=\"row main-head header-wrap-main\"><div class=\"col-xs-12 col-sm-6 col-md-5\"><div class=left-section><!--<div class=\"faq-seperator\"></div>\n        <span>\n           {{Header.constants.NAV_APPLICABILITY_MESSAGE}}\n        </span>--></div></div><div class=\"col-sm-6 col-md-7 hidden-xs height100\"><div class=right-section><div class=header-right-wrapper><div class=right-wrap-tb><div class=login-detail><span>Last login:</span> <span>{{Header.recentActivities}} | {{Header.time}}</span></div><div class=faq-seperator></div><a ui-sref=faq class=faq-button><img src=assets/images/faq-logged-in.svg class=\"faq-icon body-img-color\"> <img src=assets/images/faqBW.svg style=\"display: none\" class=\"faq-icon body-img-bw\">FAQs</a><div class=faq-seperator></div><div class=text-size-img-container><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'decrement\')\" ng-class=\"{\'active-font\': Header.active[2]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'original\')\" ng-class=\"{\'active-font\': Header.active[1]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'increment\')\" ng-class=\"{\'active-font\': Header.active[3]}\">A</div></div><div class=toggle-theme><label class=switch><input type=checkbox name=toggletheme ng-model=Header.contrastt ng-change=Header.contrast() class=box title=\"High Contrast\"><div class=knobs><span>Dark</span></div><div class=layer></div></label></div></div></div></div></div></div><div class=\"row main-head\"><div class=col-md-12><nav class=\"navbar navbar-inverse top-menu\"><div class=container-fluid><div class=navbar-header><div><button type=button class=navbar-toggle data-bs-toggle=collapse data-bs-target=#myNavbar ng-click=Header.handleNavBar(true)><span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand href={{Header.HDFC_API.WEBSITE_LINK}} target=_blank><img src=assets/images/HDFC-Bharosa-PNG.png alt=\"MF online investors\" class=\"logo-main-hdfcmf pull-left\"> </a><!-- <a class=\"navbar-brand second\" href=\"/welcome\">\n                <img src=\"assets/images/MF-Online-Investors.svg\" alt=\"MF online investors\" class=\"logo-main-mf\"/>\n              </a>   --></div><div><ul class=visible-xs><li class=contentAlignCenter><a ng-click=\"Header.goToState(\'cart\')\" class=cart-action><p class=cart-notification ng-if=\"Header.cartCount>0\">{{Header.cartCount}}</p><img src=assets/images/shopping-cart.svg alt=ecart></a></li><li class=\"dropdown notification-list contentAlignCenter\"><a class=dropdown-toggle data-bs-toggle=dropdown href=javaScript:void(0)><p class=notify-circle ng-if=\"Header.notificationCount>0\"></p><img src=assets/images/bell-icon.svg alt=notification></a><ul class=\"dropdown-menu notifies-dropdown\" ng-if=\"Header.notificationCount>0\"><li ng-repeat=\"notification in Header.latestNotificationList\">{{notification.title}}<p class=time-stamp ng-if=\"notification.diff===0\">{{notification.time}}</p><p class=time-stamp ng-if=\"notification.diff>0\">{{notification.date1}} at {{notification.time1}}</p></li><p class=\"view-all cursor-pointer ng-scope\" ng-if=\"Header.notificationCount>0\" ui-sref=main.notifications href=/notifications><a href=\"\" ng-click=Header.viewAllClicked()>View All <i class=arrow-blue-right-icon></i></a></p></ul><ul class=dropdown-menu ng-if=\"Header.notificationCount === 0\"><li class=no-notification>You currently do not have any notifications</li></ul></li><li class=\"dropdown sub-actions contentAlignCenter\"><div id=custom-select data-list=1><div class=select-tab data-bs-toggle=dropdown><div><div class=select-text><p class=text1 style=\"font-size: 14px;  font-weight: 600\">{{Header.selectedLinkPan.investorFirstName[0]}}</p></div></div></div><div class=\"dropdown-menu select-list\"><!-- display linked list --><div class=list-item ng-class=\"{\'currentActiveUser\': _option.panNumber == Header.selectedLinkPan.panNumber}\" ng-repeat=\"_option in Header.linkedPanList\" ng-click=\"!_option.selected?Header.changeLinkedPan(_option):\'\'\" style=\"color: #231F20;  display: flex;   justify-content: space-between;  text-align: left;   align-items: center\"><span style=\"display: flex; align-items: center\">{{_option.investorFirstName.split(\' \')[0]}} <span ng-if=_option.default style=\"color: #7B7979;font-size: 10px\">&nbsp;(Primary)</span> </span><img ng-if=\"_option.panNumber == Header.selectedLinkPan.panNumber\" src=../../../assets/images/icons/blue-check.svg style=\"height: 16px;padding-right: 12px\" alt=\"\"></div><!-- my profile --><div class=\"list-item dropDownButton\" style=\"border-top:1px solid #ccc\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><a ui-sref=main.profile.basicInfo style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/profile-blue.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;My Profile</a></div><!-- Add Account --><div class=\"list-item dropDownButton\" ng-click=\"Header.changeLinkedPan(\'Add\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber && !Header.corporateUserFlag\"><img src=../../../assets/images/icons/blue-add-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Add Account</div><!-- Managed Acconts --><div class=\"list-item dropDownButton\" ng-click=\"Header.changeLinkedPan(\'ManagedAccounts\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber && !Header.corporateUserFlag\"><img src=../../../assets/images/icons/blue-setting-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Manage Accounts</div><!-- More option --><div class=\"list-item dropDownButton\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\" id=moreOptionButton3 onclick=\"toggleMoreList(event, \'list3Data\')\" style=\"border-bottom:1px solid #ccc;\n                                        display: flex;\n                                        justify-content: space-between;\n                                        text-align: left;\n                                        align-items: center\"><span style=\"display: flex\"><img src=../../../assets/images/icons/more-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;More </span><img src=../../../assets/images/icons/arrow-blue-right.png style=\"width: 20px;padding-right: 12px\" alt=\"\"></div><!-- More option list start--><div ng- class=moreselect-list id=moreselectList3 ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><div class=\"list-item dropDownButton\"><a ui-sref=main.favourite-transactions style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/fav.svg style=\"height: 16px\" alt=\"\">&nbsp;Favorites</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none\"><a ui-sref=main.saved-items style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/saveItem.svg style=\"height: 16px\" alt=\"\">&nbsp;Saved Items</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none;color:#347ABC\"><a ui-sref=main.feedback style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/feedback.svg style=\"height: 16px\" alt=\"\">&nbsp;Feedback</a></div></div><!-- More option list End--><!-- Logout --><div class=\"list-item dropDownButton\" style=color:#EB1C24><a ng-click=Header.logoutMe(); href=javascript:void(0) style=\"display: inline-flex;color:#EB1C24 !important\"><img src=../../../assets/images/icons/logout-red.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Logout</a></div></div></div></li></ul></div></div><!-- only added for mobile --><div class=visible-xs><ul><li><span class=dropdown><button class=\"btn btn-primary-action navbar-btn navbar-btn-main\" ng-click=\"Header.slideSubMenu(\'mobile-transact-section\', true)\"><div class=mobile-button-text><img src=assets/images/rupee-icon.svg> <span>Transact Now</span></div><span class=\"arrow arrow-down\"></span></button></span></li></ul></div><!-- Mobile section ends here --><div class=\"collapse navbar-collapse nav-align\" id=myNavbar><div class=\"visible-xs mobile-specific\"><div><button type=button class=navbar-toggle data-bs-toggle=collapse data-bs-target=#myNavbar ng-click=Header.handleNavBar(false)><span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div><div class=text-size-img-container><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'decrement\')\" ng-class=\"{\'active-font\': Header.active[2]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'original\')\" ng-class=\"{\'active-font\': Header.active[1]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'increment\')\" ng-class=\"{\'active-font\': Header.active[3]}\">A</div></div><div class=toggle-theme><label class=switch><input type=checkbox name=toggletheme ng-model=Header.contrastt ng-change=Header.contrast() class=box title=\"High Contrast\"><div class=knobs><span>Dark</span></div><div class=layer></div></label></div></div></div><div class=visible-xs><div class=login-detail><span>Last login:</span> <span>{{Header.recentActivities}} | {{Header.time}}</span></div></div><ul class=\"nav navbar-nav navbar-left\"><!-- <li class=\"dropdown visible-xs\">\n                <a class=\"dropdown-toggle\" data-bs-toggle=\"dropdown\" href=\"#\" ng-click=\"Header.slideSubMenu(\'mobile-profile-section\', true)\">\n                  My Profile\n                  <span class=\"arrow arrow-down hidden-xs\"></span>\n                  <i class=\"arrow-right-blue-icon visible-xs\"></i>\n                </a>\n              </li> --><li><a ui-sref=main.dashboard.widgits>Dashboard</a></li><li><a ui-sref=main.portfolio.list>Portfolio</a></li><li><a ui-sref=main.transactions.recent>Transactions</a></li><li><a ui-sref=main.systematicCorner>Systematic Corner</a></li><li><a ui-sref=main.statements>Statements</a></li><li><a ui-sref=main.services>Services</a></li><li class=dropdown><a class=dropdown-toggle data-bs-toggle=dropdown href=# ng-click=\"Header.slideSubMenu(\'mobile-more-section\', true)\">More <span class=\"arrow arrow-down hidden-xs\"></span> <i class=\"arrow-right-blue-icon visible-xs\"></i></a><ul class=\"dropdown-menu hidden-xs\"><li><a href={{Header.HDFC_API.WEBSITE_LINK}}learn/calculators target=_blank>Calculators</a></li><li><a href={{Header.HDFC_API.WEBSITE_LINK}}learners-corner target=_blank>Learning Center</a></li></ul></li><li class=\"dropdown visible-xs\"><a ng-click=Header.logoutMe(); href=javascript:void(0)>Logout</a></li><li class=main-actions ng-click=\"Header.goToState(\'cart\')\"><a href=javaScript:void(0) class=cart-action><p class=cart-notification ng-if=\"Header.cartCount>0\">{{Header.cartCount}}</p><img src=assets/images/shopping-cart.svg alt=ecart></a></li><li class=\"main-actions dropdown\"><a class=dropdown-toggle data-bs-toggle=dropdown href=javaScript:void(0)><p class=notify-circle ng-if=\"Header.notificationCount>0\"></p><img src=assets/images/bell-icon.svg alt=notification></a><ul class=\"dropdown-menu notifies-dropdown\" ng-if=\"Header.notificationCount>0\"><li ng-repeat=\"notification in Header.latestNotificationList\">{{notification.title}}<p class=time-stamp ng-if=\"notification.diff===0\">{{notification.time}}</p><p class=time-stamp ng-if=\"notification.diff>0\">{{notification.date1}} at {{notification.time1}}</p></li><p class=\"view-all cursor-pointer ng-scope\" ng-if=\"Header.notificationCount>0\" ui-sref=main.notifications href=/notifications><a href=\"\" ng-click=Header.viewAllClicked()>View All <i class=arrow-blue-right-icon></i></a></p></ul><ul class=dropdown-menu ng-if=\"Header.notificationCount === 0\"><li class=no-notification>You currently do not have any notifications</li></ul></li><!-- <li class=\"main-actions\"><div class=\"faq-seperator\"></div></li> --><li class=\"dropdown main-actions\" style=\"padding-right: 10px\"><div style=\"margin-top: 8px\"><div id=custom-select data-list=1><div class=select-tab data-bs-toggle=dropdown><div><div class=select-text><p class=text1 style=\"font-size: 14px;  font-weight: 600\">{{Header.selectedLinkPan.investorFirstName[0]}}</p></div></div></div><div class=\"dropdown-menu select-list\"><!-- display linked list --><div class=list-item ng-class=\"{\'currentActiveUser\': _option.panNumber == Header.selectedLinkPan.panNumber}\" ng-repeat=\"_option in Header.linkedPanList\" ng-click=\"!_option.selected?Header.changeLinkedPan(_option):\'\'\" style=\"color: #231F20;  display: flex;   justify-content: space-between;  text-align: left;   align-items: center\"><span style=\"display: flex;align-items: center\">{{_option.investorFirstName.split(\' \')[0]}} <span ng-if=_option.default style=\"color: #7B7979;font-size: 10px\">&nbsp;(Primary)</span> </span><img ng-if=\"_option.panNumber == Header.selectedLinkPan.panNumber\" src=../../../assets/images/icons/blue-check.svg style=\"height: 16px;padding-right: 12px\" alt=\"\"></div><!-- my profile --><div class=\"list-item dropDownButton\" style=\"border-top:1px solid #ccc\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><a ui-sref=main.profile.basicInfo style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/profile-blue.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;My Profile</a></div><!-- Add Account --><div class=\"list-item dropDownButton\" ng-click=\"Header.changeLinkedPan(\'Add\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber && !Header.corporateUserFlag\"><img src=../../../assets/images/icons/blue-add-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Add Account</div><!-- Managed Acconts --><div class=\"list-item dropDownButton\" ng-click=\"Header.changeLinkedPan(\'ManagedAccounts\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber && !Header.corporateUserFlag\"><img src=../../../assets/images/icons/blue-setting-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Manage Accounts</div><!-- More option list start--><div ng- class=moreselect-list id=moreselectList6 ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><div class=\"list-item dropDownButton\"><a ui-sref=main.favourite-transactions style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/fav.svg style=\"height: 16px\" alt=\"\">&nbsp;Favorites</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none\"><a ui-sref=main.saved-items style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/saveItem.svg style=\"height: 16px\" alt=\"\">&nbsp;Saved Items</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none;color:#347ABC\"><a ui-sref=main.feedback style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/feedback.svg style=\"height: 16px\" alt=\"\">&nbsp;Feedback</a></div></div><!-- More option list End--><!-- More option --><div class=\"list-item dropDownButton\" id=moreOptionButton4 onclick=\"toggleMoreList(event, \'list6Data\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\" style=\"border-bottom:1px solid #ccc; display: flex;  justify-content: space-between;\n                                      text-align: left;     align-items: center\"><span style=\"display: flex\"><img src=../../../assets/images/icons/more-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;More </span><img src=../../../assets/images/icons/arrow-blue-right.png style=\"width: 20px;padding-right: 12px\" alt=\"\"></div><!-- Logout --><div class=\"list-item dropDownButton\" style=color:#EB1C24><a ng-click=Header.logoutMe(); href=javascript:void(0) style=\"display: inline-flex;color:#EB1C24 !important\"><img src=../../../assets/images/icons/logout-red.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Logout</a></div></div></div></div></li></ul><ul class=\"nav navbar-nav navbar-right visible-sm visible-md visible-lg\"><li><span class=\"dropdown pull-right\"><button class=\"btn btn-primary-action navbar-btn navbar-btn-main\" data-bs-toggle=dropdown aria-haspopup=true aria-expanded=false><img src=assets/images/rupee-icon.svg> <span>Transact Now</span> <span class=\"arrow arrow-down\"></span></button><div class=\"dropdown-menu transact-header-dropdown transact-header-dropdown-new\" ng-if=\"Header.landingPageType !== \'NEW_FIRST_TIME_PROSPECT_FOLIO\'\" style=\"border-radius: 14px\"><div class=container-fluid><!--                      <div class=\"row\">--><!--                        <div class=\"col-sm-4\">--><!--                          <label>Popular transactions</label>--><!--                        </div>--><!--                        <div class=\"col-sm-7\">--><!--                          <label>Other transactions</label>--><!--                        </div>--><!--                      </div>--><div class=\"row transact-now-item-container\"><div class=\"col-sm-3 header-popular-tab-container\"><ul><li ng-click=Header.goToState(popTrxn.transactionType.toLowerCase()) ng-repeat=\"popTrxn in Header.popularTransactions | orderBy: \'index\'\"><img ng-src=../assets/images/icons/transact-now-menu/{{popTrxn.transactionName.toLowerCase()}}.svg alt={{popTrxn.transactionName}}> <span class=tnc-name-link>{{popTrxn.transactionName}}</span></li><!--                            <li ng-click=\"Header.goToState(\'flexsip\')\"><a href=\"javaScript:void(0)\" tabindex=\"8\">Flex SIP</a></li>--><!--                            <li ng-click=\"Header.goToState(\'switch\')\">--><!--                               <img src=\"../assets/images/icons/transact-now-menu/switch.svg\" alt=\"switch\">--><!--                               <span class=\"tnc-name-link\" href=\"javaScript:void(0)\" tabindex=\"9\">Switch</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'purchase\')\">--><!--                               <img src=\"../assets/images/icons/transact-now-menu/purchase.svg\" alt=\"purchase\">--><!--                               <span class=\"tnc-name-link\">Purchase</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'redemption\')\">--><!--                               <img src=\"../assets/images/icons/transact-now-menu/redemption.svg\" alt=\"redemption\">--><!--                               <span class=\"tnc-name-link\">Redemption</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'stp\')\"><a href=\"javaScript:void(0)\" tabindex=\"11\">Systematic Transfer Plan (STP)</a></li>--></ul></div><div class=\"col-sm-8 header-other-tab-container\"><label>Others Options</label><ul class=transact-now-ul-list><li ng-click=Header.goToState(otherTransaction.transactionType.toLowerCase()) ng-repeat=\"otherTransaction in Header.otherTransactions | orderBy: \'index\'\"><img ng-src=\"{{ \'../assets/images/icons/transact-now-menu/\' + (otherTransaction.transactionName.toLowerCase().split(\' \').join(\'\')) + \'.svg\' }}\" alt=\"{{ otherTransaction.transactionName }}\"> <span class=tnc-name-link>{{otherTransaction.transactionName}}</span></li><!--                            <li ng-click=\"Header.goToState(\'changeDividendOption\')\" >--><!--                               <img src=\"../assets/images/icons/transact-now-menu/changeidcwoption.svg\" alt=\"idcw\">--><!--                               <span class=\"tnc-name-link\">Change IDCW Option</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'swp\')\">--><!--                               <img src=\"../assets/images/icons/transact-now-menu/changeidcwoption.svg\" alt=\"idcw\">--><!--                               <span class=\"tnc-name-link\">Systematic Withdrawal Advantage Plan</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'smartSwap\')\" >--><!--                               <img src=\"../assets/images/icons/transact-now-menu/smart-systematicwithdrawaladvantageplan.svg\" alt=\"smart-swap\">--><!--                               <span class=\"tnc-name-link\">SMART SWAP</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'dtp\')\" >--><!--                               <img src=\"../assets/images/icons/transact-now-menu/transferidcwplan(tip).svg\" alt=\"tip\">--><!--                               <span class=\"tnc-name-link\">Transfer IDCW Plan (TIP)</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'dreamSip\')\" >--><!--                               <img src=\"../assets/images/icons/transact-now-menu/rollover.svg\" alt=\"rollover\">--><!--                               <span class=\"tnc-name-link\">DREAM SIP</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'rolloverView\')\" >--><!--                               <img src=\"../assets/images/icons/transact-now-menu/changeidcwoption.svg\" alt=\"idcw\">--><!--                               <span class=\"tnc-name-link\">Roll Over</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'stp\')\">--><!--                               <img src=\"../assets/images/icons/transact-now-menu/systematictransferplan(stp).svg\" alt=\"stp\">--><!--                               <span class=\"tnc-name-link\">Systematic Transfer Plan (STP)</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'instantRedemption\')\" >--><!--                               <img src=\"../assets/images/icons/transact-now-menu/instantaccessfacility.svg\" alt=\"iaf\">--><!--                               <span class=\"tnc-name-link\">Instant Access Facility</span>--><!--                            </li>--><!--                            <li ng-click=\"Header.goToState(\'flexsip\')\">--><!--                               <img src=\"../assets/images/icons/transact-now-menu/flexsip.svg\" alt=\"flex-sip\">--><!--                               <span class=\"tnc-name-link\">Flex SIP</span>--><!--                            </li>--></ul></div></div></div></div><div class=\"dropdown-menu transact-header-dropdown prospect transact-header-dropdown-new end-0 adjust-width\" ng-if=\"Header.landingPageType === \'NEW_FIRST_TIME_PROSPECT_FOLIO\'\" style=\"border-radius: 14px\"><div class=container-fluid><div class=\"row transact-now-item-container\"><div class=\"col-md-5 col-sm-5 header-popular-tab-container\"><ul><li ng-click=\"Header.goToState(\'purchase\')\"><img src=assets/images/icons/transact-now-menu/purchase.svg alt=purchase> <span class=tnc-name-link>Purchase</span></li><li ng-click=\"Header.goToState(\'sip\')\"><img src=assets/images/icons/transact-now-menu/sip.svg alt=sip> <span class=tnc-name-link>SIP</span></li></ul></div><div class=\"col-md-7 col-sm-7 header-other-tab-container\"><label>Others Options</label><ul class=transact-now-ul-list><li ng-click=\"Header.goToState(\'flexsip\')\"><img src=assets/images/icons/transact-now-menu/flexsip.svg> <span class=tnc-name-link>Flex SIP</span></li></ul></div></div></div></div></span></li><li class=sub-actions ng-click=\"Header.goToState(\'cart\')\"><a href=javaScript:void(0) class=cart-action><p class=cart-notification ng-if=\"Header.cartCount>0\">{{Header.cartCount}}</p><img src=assets/images/shopping-cart.svg alt=ecart></a></li><li class=\"sub-actions dropdown\"><a class=dropdown-toggle data-bs-toggle=dropdown href=javaScript:void(0)><p class=notify-circle ng-if=\"Header.notificationCount>0\"></p><img src=assets/images/bell-icon.svg alt=notification></a><ul class=\"dropdown-menu notifies-dropdown\" ng-if=\"Header.notificationCount>0\"><li ng-repeat=\"notification in Header.latestNotificationList\">{{notification.title}}<p class=time-stamp ng-if=\"notification.diff===0\">{{notification.time}}</p><p class=time-stamp ng-if=\"notification.diff>0\">{{notification.date1}} at {{notification.time1}}</p></li><p class=\"view-all cursor-pointer ng-scope\" ng-if=\"Header.notificationCount>0\" ui-sref=main.notifications href=/notifications><a href=\"\" ng-click=Header.viewAllClicked()>View All <i class=arrow-blue-right-icon></i></a></p></ul><ul class=dropdown-menu ng-if=\"Header.notificationCount === 0\"><li class=no-notification>You currently do not have any notifications</li></ul></li><!-- <li class=\"sub-actions\"><div class=\"faq-seperator\"></div></li> --><li class=\"dropdown sub-actions\" style=\"padding-right: 10px\"><div style=\"margin-top: 8px\"><div id=custom-select data-list=1><div class=select-tab data-bs-toggle=dropdown><div><div class=select-text><p class=text1 style=\"font-size: 14px;  font-weight: 600\">{{Header.selectedLinkPan.investorFirstName[0]}}</p></div></div></div><div class=\"dropdown-menu select-list\"><!-- display linked list --><div class=list-item ng-class=\"{\'currentActiveUser\': _option.panNumber == Header.selectedLinkPan.panNumber}\" ng-repeat=\"_option in Header.linkedPanList\" ng-click=\"!_option.selected?Header.changeLinkedPan(_option):\'\'\" style=\"color: #231F20;  display: flex;   justify-content: space-between;  text-align: left;   align-items: center\"><span style=\"display: flex; align-items: center\">{{_option.investorFirstName.split(\' \')[0]}} <span ng-if=_option.default style=\"color: #7B7979;font-size: 10px\">&nbsp;(Primary)</span> </span><img ng-if=\"_option.panNumber == Header.selectedLinkPan.panNumber\" src=../../../assets/images/icons/blue-check.svg style=\"height: 16px;padding-right: 12px\" alt=\"\"></div><!-- my profile --><div class=\"list-item dropDownButton\" style=\"border-top:1px solid #ccc\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><a ui-sref=main.profile.basicInfo style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/profile-blue.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;My Profile</a></div><!-- Add Account --><div class=\"list-item dropDownButton\" ng-click=\"Header.changeLinkedPan(\'Add\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber && !Header.corporateUserFlag\"><img src=../../../assets/images/icons/blue-add-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Add Account</div><!-- Managed Acconts --><div class=\"list-item dropDownButton\" ng-click=\"Header.changeLinkedPan(\'ManagedAccounts\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber && !Header.corporateUserFlag\"><img src=../../../assets/images/icons/blue-setting-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Manage Accounts</div><!-- More option list start--><div ng- class=moreselect-list id=moreselectList4 ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><div class=\"list-item dropDownButton\"><a ui-sref=main.favourite-transactions style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/fav.svg style=\"height: 16px\" alt=\"\">&nbsp;Favorites</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none\"><a ui-sref=main.saved-items style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/saveItem.svg style=\"height: 16px\" alt=\"\">&nbsp;Saved Items</a></div><div class=\"list-item dropDownButton\" style=\"display: inline-flex;border: none;color:#347ABC\"><a ui-sref=main.feedback style=\"display: inline-flex;color:#347ABC\"><img src=../../../assets/images/icons/feedback.svg style=\"height: 16px\" alt=\"\">&nbsp;Feedback</a></div></div><!-- More option list End--><!-- More option --><div class=\"list-item dropDownButton\" id=moreOptionButton4 onclick=\"toggleMoreList(event, \'list4Data\')\" ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\" style=\"border-bottom:1px solid #ccc; display: flex;  justify-content: space-between;\n                                      text-align: left;     align-items: center\"><span style=\"display: flex\"><img src=../../../assets/images/icons/more-icon.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;More </span><img src=../../../assets/images/icons/arrow-blue-right.png style=\"width: 20px;padding-right: 12px\" alt=\"\"></div><!-- Logout --><div class=\"list-item dropDownButton\" style=color:#EB1C24><a ng-click=Header.logoutMe(); href=javascript:void(0) style=\"display: inline-flex;color:#EB1C24 !important\"><img src=../../../assets/images/icons/logout-red.svg style=\"height: 16px\" alt=\"\">&nbsp;&nbsp;Logout</a></div></div></div></div></li></ul></div></div></nav><!-- only added for mobile --><div class=\"mobile-profile-section visible-xs\"><div class=slidemenu-action><div><a href=javascript:void(0) ng-click=\"Header.slideSubMenu(\'mobile-profile-section\', false)\"><img src=assets/images/icons/back-arrow-icon-grey.svg> Back</a></div></div><ul ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\"><li><label>{{Header.userFirstName}}</label></li><li><a ui-sref=main.profile.basicInfo>My Profile</a></li><li><a ng-if=\"Header.selectedLinkPan.default && Header.selectedLinkPan.panNumber\" ui-sref=main.favourite-transactions>Favorites</a></li><li><a ui-sref=main.saved-items>Saved Items</a></li><li><a ui-sref=main.feedback>Feedback</a></li></ul></div><div class=\"mobile-more-section visible-xs\"><div class=slidemenu-action><div><a href=javascript:void(0) ng-click=\"Header.slideSubMenu(\'mobile-more-section\', false)\"><img src=assets/images/icons/back-arrow-icon-grey.svg> Back</a></div></div><ul><li><a href={{Header.HDFC_API.WEBSITE_LINK}}learn/calculators target=_blank>Calculators</a></li><li><a href={{Header.HDFC_API.WEBSITE_LINK}}learners-corner class=learning target=_blank>Learning Center</a></li></ul></div><div class=\"mobile-transact-section visible-xs\" ng-if=\"Header.landingPageType !== \'NEW_FIRST_TIME_PROSPECT_FOLIO\'\"><div class=container-fluid><div class=row><div class=col-xs-12><div class=slidemenu-action><div><a href=javascript:void(0) ng-click=\"Header.slideSubMenu(\'mobile-transact-section\', false)\"><img src=assets/images/icons/black-back-arrow.svg> Back</a></div></div></div></div><div class=\"row transact-now-item-container\"><div class=\"col-sm-12 col-xs-12 header-popular-tab-container\"><ul><li ng-click=Header.goToState(popTrxn.transactionType.toLowerCase()) ng-repeat=\"popTrxn in Header.popularTransactions | orderBy: \'index\'\"><img ng-src=../assets/images/icons/transact-now-menu/{{popTrxn.transactionName.toLowerCase()}}.svg alt={{popTrxn.transactionName}}> <span class=tnc-name-link>{{popTrxn.transactionName}}</span></li></ul></div><div class=\"col-sm-12 col-xs-12 header-other-tab-container\"><label>Others Options</label><ul class=transact-now-ul-list><li ng-click=Header.goToState(otherTransaction.transactionType.toLowerCase()) ng-repeat=\"otherTransaction in Header.otherTransactions | orderBy: \'index\'\"><img ng-src=\"{{ \'../assets/images/icons/transact-now-menu/\' + (otherTransaction.transactionName.toLowerCase().split(\' \').join(\'\')) + \'.svg\' }}\" alt=\"{{ otherTransaction.transactionName }}\"> <span class=tnc-name-link>{{otherTransaction.transactionName}}</span></li></ul></div></div></div></div><div class=\"mobile-transact-section visible-xs prospect\" ng-if=\"Header.landingPageType === \'NEW_FIRST_TIME_PROSPECT_FOLIO\'\"><div class=container-fluid><div class=row><div class=col-xs-12><div class=slidemenu-action><div><a href=javascript:void(0) ng-click=\"Header.slideSubMenu(\'mobile-transact-section\', false)\"><img src=assets/images/icons/black-back-arrow.svg> Back</a></div></div></div></div><div class=\"row transact-now-item-container\"><div class=\"col-sm-12 header-popular-tab-container\"><ul><li ng-click=\"Header.goToState(\'purchase\')\"><img src=assets/images/icons/transact-now-menu/purchase.svg alt=purchase> <span class=tnc-name-link>Purchase</span></li><li ng-click=\"Header.goToState(\'sip\')\"><img src=assets/images/icons/transact-now-menu/sip.svg alt=sip> <span class=tnc-name-link>SIP</span></li></ul></div><div class=\"col-sm-12 header-other-tab-container\"><label>Others Options</label><ul class=transact-now-ul-list><li ng-click=\"Header.goToState(\'flexsip\')\"><img src=assets/images/icons/transact-now-menu/flexsip.svg> <span class=tnc-name-link>Flex SIP</span></li></ul></div></div></div></div><!-- mobile section ends here--></div><!--<div class=\"col-md-12\">\n      <div class=\"left-section\">\n        <img src=\"assets/images/logo.png\" alt=\"MF online investors\" class=\"logo pull-left\" ui-sref=\"login\"/>\n        <div class=\"header-text-missed-call\" ng-if=\"Header.isLoggedInStatus\">Request for Account Statement, Folio or\n          Transactions! For any query, Give a Miss Call @ 9436194361\n        </div>\n      </div>\n      <div class=\"right-section\">\n        <nav class=\"right-nav pull-right\">\n          <ul>\n            <li class=\"server-clock\" ng-if=\"Header.isLoggedInStatus\">\n              <span my-current-time=\"Header.format\"></span>\n            </li>\n            <li ng-if=\"Header.isLoggedInStatus && Header.investorType != \'NEW\'\" ui-sref=\"welcome.existingUserWelcome\"\n                class=\"home-link\">\n              <a href=\"javascript:void(0)\" tabindex=\"7\"><i class=\"home-icon\"></i></a>\n            </li>\n            <li>\n              <a href=\"javaScript:void(0)\" ui-sref=\"faq\" tabindex=\"7\">FAQs</a>\n            </li>\n            <li ng-if=\"Header.isLoggedInStatus\">\n              <a ng-click=\"Header.logoutMe();\" href=\"javascript:void(0)\" tabindex=\"8\">Logout</a>\n            </li>\n          </ul>\n        </nav>\n      </div>\n      <div class=\"lower-head\">\n        <p>\n          <a style=\"left: 5px;\" ng-if=\"Header.isLoggedInStatus && Header.faqVisible\" href=\"javaScript:void(0)\"\n             class=\"mobile-link\" ui-sref=\"welcome.existingUserWelcome\" tabindex=\"6\">Home</a>\n          <a href=\"javaScript:void(0)\" class=\"mobile-link\" ui-sref=\"faq\" tabindex=\"7\"> <i class=\"faq-icon\"></i> FAQs</a>\n      </div>\n    </div>--></div></header><header class=\"header header1 container-fluid\" ng-if=\"Header.isLoggedInStatus && Header.faqVisible\"><div class=headStyle ng-if=Header.isLoggedInStatus><ul><li tabindex=1 ng-click=\"Header.changedFont(\'increment\')\" title=\"Increase font-size\">A+</li><li tabindex=2 ng-click=\"Header.changedFont(\'original\')\" title=\"Reset font size\">A</li><li tabindex=3 ng-click=\"Header.changedFont(\'decrement\')\" title=\"Decrease font size\">A-</li><li tabindex=4 ng-click=Header.contrasts() class=box title=\"High Contrast\"><span class=\"glyphicon glyphicon-adjust\"></span></li></ul></div><div class=\"row main-head\"><div class=left-section><img src=assets/images/logo.png alt=\"MF online investors\" class=\"logo pull-left\" ui-sref=login><!--<div class=\"header-text-missed-call\" ng-if=\"Header.isLoggedInStatus\">{{Header.constants.NAV_APPLICABILITY_MESSAGE}}--></div><div class=right-section><nav class=\"right-nav pull-right\"><ul><li class=server-clock ng-if=Header.isLoggedInStatus><span my-current-time=Header.format></span></li><li ng-if=\"Header.isLoggedInStatus && Header.investorType != \'NEW\'\" ui-sref=welcome.existingUserWelcome class=home-link><a href=javascript:void(0) tabindex=7><i class=home-icon></i></a></li><li class=dropdown ng-if=Header.isLoggedInStatus><a href=javaScript:void(0) ng-click=\"Header.goToState(\'cart\')\" data-bs-toggle=dropdown class=notification-dropdown aria-haspopup=true aria-expanded=false style=\"display: flex\"><span>Cart </span><i class=cart-icon></i> <span class=countEcart tabindex=-1 ng-if=!Header.iconClicked style=\"color: black\">{{Header.cartCount}}</span></a></li><li><a href=javaScript:void(0) ui-sref=faq tabindex=7>FAQs</a></li><li ng-if=Header.isLoggedInStatus><a ng-click=Header.logoutMe(); href=javascript:void(0) tabindex=8>Logout</a></li></ul></nav></div><div class=lower-head><p><a style=\"left: 5px\" ng-if=\"Header.isLoggedInStatus && Header.faqVisible\" href=javaScript:void(0) class=mobile-link ui-sref=welcome.existingUserWelcome tabindex=6>Home</a> <a href=javaScript:void(0) class=mobile-link ui-sref=faq tabindex=7><i class=faq-icon></i> FAQs</a></p></div></div></header><div class=\"headerPreLogin pre-login-header container-fluid\" ng-if=!Header.isLoggedInStatus><div class=\"row main-head header-wrap-main\"><div class=\"col-xs-4 col-sm-3 col-md-4\"><div class=left-section><!-- <img src=\"../../../assets/images/breadcrumb-mobile.svg\" class=\"header-breadcrumb\" ui-sref=\"breadcrumb\"/> --> <a href={{Header.HDFC_API.WEBSITE_LINK}} class=logo-main-web target=_blank><img src=assets/images/hdfcmf-Main.svg alt=\"MF online investors\" class=\"logo-main-hdfcmf pull-left\"></a><!-- <a href=\"{{Header.HDFC_API.WEBSITE_LINK}}\" class=\"logo-main-web\" target=\"_blank\"><img src=\"assets/images/mfonline-investor.png\" alt=\"MF online investors\" class=\"logo-main-mf\"/></a> --></div></div><div class=\"col-xs-8 col-sm-9 col-md-8\"><div class=right-section><div class=header-right-wrapper><div class=right-wrap-tb><button ui-sref=instantLogin class=faq-button style=\"color: #1B4B86;border: 1px solid #1B4B86\" ng-if=Header.HideQuickInveBtn>Quick Invest</button> <button ui-sref=faq class=faq-button><img src=assets/images/faq.svg class=\"faq-icon body-img-color\"> <img src=assets/images/faqBW.svg style=\"display: none\" class=\"faq-icon body-img-bw\">FAQs</button><div class=faq-seperator></div><div class=text-size-img-container><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'decrement\')\" ng-class=\"{\'active-font\': Header.active[2]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'original\')\" ng-class=\"{\'active-font\': Header.active[1]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'increment\')\" ng-class=\"{\'active-font\': Header.active[3]}\">A</div></div><div class=toggle-theme><label class=switch><input type=checkbox name=toggletheme ng-model=Header.contrastt ng-change=Header.contrast() class=box title=\"High Contrast\"><div class=knobs><span>Dark</span></div><div class=layer></div></label></div></div><div class=new-mobile-menu><div class=new-menu-btns><button ui-sref=instantLogin class=qui-button>Quick Invest</button><ul><li class=\"dropdown sub-actions\"><a class=\"dropdown-toggle profile-dropdown\" id=three-dot data-bs-toggle=dropdown href=#><img id=three-dot-icon src=../../../assets/images/v-dot-menu.svg class=dotmenuContrast></a><div class=testingdata><ul class=\"dropdown-menu new-bm-dropdown\"><li><a ui-sref=faq style=\"padding: 10px 0px 10px 24px;font-weight: 500;border-bottom: 1px solid gray;color: black\"><span style=\"padding: 0px 5px 0px 0px\"><svg width=20 height=20 viewBox=\"0 0 20 20\" fill=none xmlns=http://www.w3.org/2000/svg class=contrastFaqNonactive><path fill-rule=evenodd clip-rule=evenodd d=\"M10 18.3334C5.39752 18.3334 1.66669 14.6026 1.66669 10.0001C1.66669 5.39758 5.39752 1.66675 10 1.66675C14.6025 1.66675 18.3334 5.39758 18.3334 10.0001C18.3334 14.6026 14.6025 18.3334 10 18.3334ZM10 16.6667C11.7681 16.6667 13.4638 15.9644 14.7141 14.7141C15.9643 13.4639 16.6667 11.7682 16.6667 10.0001C16.6667 8.23197 15.9643 6.53628 14.7141 5.28604C13.4638 4.03579 11.7681 3.33341 10 3.33341C8.23191 3.33341 6.53622 4.03579 5.28597 5.28604C4.03573 6.53628 3.33335 8.23197 3.33335 10.0001C3.33335 11.7682 4.03573 13.4639 5.28597 14.7141C6.53622 15.9644 8.23191 16.6667 10 16.6667ZM9.16669 13.3334H10.8334V15.0001H9.16669V13.3334ZM9.16669 11.6734C9.16669 11.6734 10.8334 11.6667 10.8334 11.6734C10.8334 10.8384 13.3334 10.0001 13.3334 8.33341C13.3334 6.49175 11.8559 5.00008 10.0075 5.00008C9.56915 4.99909 9.13489 5.08459 8.7296 5.25166C8.32432 5.41873 7.95597 5.66411 7.64565 5.97374C7.33532 6.28336 7.08912 6.65116 6.92114 7.05607C6.75315 7.46098 6.66669 7.89504 6.66669 8.33341H8.33335C8.33335 7.41675 9.08335 6.66675 10 6.66675C10.9167 6.66675 11.6667 7.41675 11.6667 8.33341C11.6667 9.08341 9.16669 10.3059 9.16669 11.6734Z\" fill=black /></svg> <svg width=20 height=20 viewBox=\"0 0 20 20\" fill=none xmlns=http://www.w3.org/2000/svg class=contrastFaqactive><path fill-rule=evenodd clip-rule=evenodd d=\"M10 18.3334C5.39752 18.3334 1.66669 14.6026 1.66669 10.0001C1.66669 5.39758 5.39752 1.66675 10 1.66675C14.6025 1.66675 18.3334 5.39758 18.3334 10.0001C18.3334 14.6026 14.6025 18.3334 10 18.3334ZM10 16.6667C11.7681 16.6667 13.4638 15.9644 14.7141 14.7141C15.9643 13.4639 16.6667 11.7682 16.6667 10.0001C16.6667 8.23197 15.9643 6.53628 14.7141 5.28604C13.4638 4.03579 11.7681 3.33341 10 3.33341C8.23191 3.33341 6.53622 4.03579 5.28597 5.28604C4.03573 6.53628 3.33335 8.23197 3.33335 10.0001C3.33335 11.7682 4.03573 13.4639 5.28597 14.7141C6.53622 15.9644 8.23191 16.6667 10 16.6667ZM9.16669 13.3334H10.8334V15.0001H9.16669V13.3334ZM9.16669 11.6734C9.16669 11.6734 10.8334 11.6667 10.8334 11.6734C10.8334 10.8384 13.3334 10.0001 13.3334 8.33341C13.3334 6.49175 11.8559 5.00008 10.0075 5.00008C9.56915 4.99909 9.13489 5.08459 8.7296 5.25166C8.32432 5.41873 7.95597 5.66411 7.64565 5.97374C7.33532 6.28336 7.08912 6.65116 6.92114 7.05607C6.75315 7.46098 6.66669 7.89504 6.66669 8.33341H8.33335C8.33335 7.41675 9.08335 6.66675 10 6.66675C10.9167 6.66675 11.6667 7.41675 11.6667 8.33341C11.6667 9.08341 9.16669 10.3059 9.16669 11.6734Z\" fill=white /></svg> </span>FAQs</a></li><li><div><div><ul style=\"display: flex;justify-content: space-around;margin-top: 15px\"><li><!-- use app/login/login.directive.js --><p class=toggle-login-text style=\"color: black\">Light</p></li><li><div class=login-form-switch><label class=switch><input type=checkbox ng-model=Header.contrastt2 ng-change=Header.contrast2() class=box title=\"High Contrast\" value={{Header.contrastt2}}> <span class=\"slider round\" style=\"background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%)\"></span></label></div></li><li><p class=toggle-login-text style=\"color: black\">Dark</p></li></ul></div></div></li><li><div style=\"display: flex;justify-content: center\"><div style=\"margin:8px;display: flex;width: 170px;justify-content: space-around;align-items: center;text-align: center;height: 50px;background: rgba(236, 242, 244, 1);border-radius: 10px\"><p ng-click=\"Header.changedFont(\'decrement\')\" class=contrastFont ng-class=\"{\'activeTab\': Header.active[2]}\">-A</p><p ng-click=\"Header.changedFont(\'original\')\" class=contrastFont ng-class=\"{\'activeTab\': Header.active[1]}\">A</p><p ng-click=\"Header.changedFont(\'increment\')\" class=contrastFont ng-class=\"{\'activeTab\': Header.active[3]}\">A+</p></div></div></li></ul></div></li></ul></div></div></div></div></div></div></div><style>.contentAlignCenter{\n    display: flex;\n    align-items: center;\n    margin-right: 8px;\n    justify-content: center;\n  }\n  .header-right-wrapper{ \n      display: flex;\n      justify-content: right;\n      align-items: center; \n  }\n  .new-bm-dropdown{\n    border-radius: 0px 0px 8px 8px; \n    inset: 15px 0px auto auto !important;\n    width: 218px;\n  }\n  .login-form-switch .slider{\n    background-color:linear-gradient(93.92deg, #21ADE9 -7.52%, #1162C7 99.94%);\n  }\n  .activeTab{\n    border-bottom: 2px solid blue;\n    width: 20px;\n  }  \n\n  #custom-select {\n      width: 32px;  \n      overflow: hidden; color: #2A699E; \n  }\n\n  .select-tab {\n      border: 1px solid #AECAE4;\n      border-radius: 50%;\n      width: 30px;\n      height: 30px;\n      display: flex !important;\n      justify-content: center !important;\n      align-items: center;\n      text-align: left;\n      padding: 10px;\n      cursor: pointer;\n  } \n  .select-list {\n    left: unset !important ;\n      z-index: 1;\n      right: 10px !important;\n      margin-top: 4px; \n      position: absolute;\n      background: white; \n      display: none; /* Initially hidden */\n      border: 1px solid #ccc; \n      width: 200px;\n      text-align: left;  \n      border-bottom-left-radius: 10px;\n      border-bottom-right-radius: 10px; \n      \n    .list-item{ \n      border: none;\n      padding-left: 10px;\n      display: flex;\n      align-items: center;\n      height:35px;\n    }\n  } \n  .moreselect-list {\n    margin-top: 0px !important;\n    z-index: 1;\n      right: 198px !important;\n      margin-top: 4px; \n      position: absolute;\n      background: white; \n      display: none; /* Initially hidden */\n      border: 1px solid #ccc; \n      width: 150px;\n      text-align: left;  \n      border-radius: 10px; \n      \n    .list-item{ \n      padding-left: 10px;\n      display: flex;\n      align-items: center;\n      height:35px;\n    }\n  }  \n\n  .dropDownButton{\n    font-size: 12px;   \n    border-top: 1px solid #ccc; \n    color: #347ABC;   \n    font-weight: 550; \n  } \n  .linkPanList{\n    background: transparent !important;\n    color: black !important; \n    text-align: left !important;\n    border-radius: 4px !important;\n  }\n  .select-text{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  } \n  .currentActiveUser{\n    background: #EBF2F9 !important; \n  }\n  @media screen and (min-width: 480px) {\n    .qui-button{\n      width: 123px !important;\n    }\n  }\n  @media screen and (max-width: 480px) {\n    .moreselect-list {\n        margin: 5px;\n        right: 0px !important;\n        width: 170px;\n    }\n    .select-list {\n        width: 170px;\n    }\n    .qui-button{\n     padding: 0px !important;\n     padding-left:0px !important;\n     padding-right:0px !important;\n     font-size: 3.5vw !important;\n     width: 32vw !important;\n    }\n}</style><script>var openListId = null;\n  \n  function toggleList(event, listData) {\n      event.stopPropagation(); // Prevent click from propagating to document\n      const listId = parseInt(listData.charAt(4)); // Extract list number from \'listXData\'\n      const list = document.getElementById(`selectList${listId}`); \n      const moreOptionList1 = document.getElementById(\"moreselectList3\");  \n      const moreOptionList2 = document.getElementById(\"moreselectList4\");    \n      \n         if (list.style.display === \'block\') {\n          list.style.display = \'none\';  \n          openListId = null;\n      } else { \n        // moreOptionList1.style.display = \'none\'; \n        // moreOptionList2.style.display = \'none\'; \n        list.style.display = \'block\';  \n          openListId = listId;\n      }\n  }\n\n  function toggleMoreList(event, listData) {\n      event.stopPropagation();  \n      const listId = parseInt(listData.charAt(4)); // Extract list number from \'listXData\'\n      const list = document.getElementById(`moreselectList${listId}`);  \n      const moreOptionButton = document.getElementById(`moreOptionButton${listId}`);  \n  \n      if (list.style.display === \'block\') {\n          list.style.display = \'none\';  \n          moreOptionButton.style.backgroundColor = \'white\';\n      } else {\n          list.style.display = \'block\'; \n          moreOptionButton.style.backgroundColor = \'#EBF2F9\';\n      }\n  }\n document.addEventListener(\'click\', () => {\n     // Close all lists if clicking outside\n     const lists = document.querySelectorAll(\'.select-list\');   \n     lists.forEach(list => {  \n      list.style.display = \'none\';\n     }); \n     openListId = null;\n });</script>");
$templateCache.put("app/components/header/new-investor-header.html","<div class=\"new-investor-header container-fluid\"><div class=\"row main-head header-wrap-main\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=left-section><a class=header-brand href=https://investor-web.hdfcfund.com/ target=_blank><img src=assets/images/mfonline-investor.png alt=\"MF online investors\" class=logo-main-mf></a></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=right-section><div class=header-right-wrapper><div class=right-wrap-tb><a href=tel:180030106767 class=toll-free><img src=assets/images/toll.svg class=body-img-color> <img src=assets/images/phoneBW.svg style=\"display: none\" class=body-img-bw><div class=\"header-text-common hidden-xs\">1800 - 3010 - 6767 <span>(Toll-free)</span></div></a><button ui-sref=faq class=faq-button><img src=assets/images/faq.svg class=\"faq-icon body-img-color\"> <img src=assets/images/faqBW.svg style=\"display: none\" class=\"faq-icon body-img-bw\">FAQs</button></div></div></div></div></div></div>");
$templateCache.put("app/components/header/welcome-first-login-header.html","<div class=\"headerPreLogin pre-login-header container-fluid\"><div class=\"row main-head header-wrap-main\"><div class=\"col-sm-6 col-md-6\"><div class=left-section><a href=javascript:void(0) ng-click=Header.showMenu(true)><img src=../../../assets/images/breadcrumb-mobile.svg class=header-breadcrumb> </a><a class=header-brand href={{Header.HDFC_API.WEBSITE_LINK}} target=_blank><img src=assets/images/hdfcmf-Main.svg alt=\"MF online investors\" class=\"logo-main-hdfcmf pull-left\"><!-- <img src=\"assets/images/mfonline-investor.png\" alt=\"MF online investors\" class=\"logo-main-mf\"/> --></a></div></div><div class=\"col-sm-6 col-md-6\"><div class=right-section><div class=header-right-wrapper><div class=right-wrap-tb><button class=logout ng-click=Header.logoutMe();>LOGOUT</button> <button ui-sref=faq class=faq-button><img src=assets/images/faq.svg class=\"faq-icon body-img-color\"> <img src=assets/images/faqBW.svg style=\"display: none\" class=\"faq-icon body-img-bw\">FAQs</button><div class=faq-seperator></div><div class=text-size-img-container><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'decrement\')\" ng-class=\"{\'active-font\': Header.active[2]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'original\')\" ng-class=\"{\'active-font\': Header.active[1]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'increment\')\" ng-class=\"{\'active-font\': Header.active[3]}\">A</div></div><div class=toggle-theme><label class=switch><input type=checkbox name=toggletheme ng-model=Header.contrastt ng-change=Header.contrast() class=box title=\"High Contrast\"><div class=knobs><span>Dark</span></div><div class=layer></div></label></div></div></div></div></div><div class=\"mobile-welcome-section visible-xs\"><div class=slidemenu-action><div><a href=javascript:void(0) ng-click=Header.showMenu(false)><img src=../../../assets/images/breadcrumb-mobile.svg class=header-breadcrumb></a></div><div class=header-right-wrapper><div class=text-size-img-container><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'decrement\')\" ng-class=\"{\'active-font\': Header.active[2]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'original\')\" ng-class=\"{\'active-font\': Header.active[1]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Header.changedFont(\'increment\')\" ng-class=\"{\'active-font\': Header.active[3]}\">A</div></div><div class=toggle-theme><label class=switch><input type=checkbox name=toggletheme ng-model=Header.contrastt ng-change=Header.contrast() class=box title=\"High Contrast\"><div class=knobs><span>Dark</span></div><div class=layer></div></label></div></div></div><ul><li><a ui-sref=faq>FAQs</a></li><li><a ng-click=Header.logoutMe(); href=javascript:void(0)>logout</a></li></ul></div></div></div>");
$templateCache.put("app/components/header/welcome-header.html","<header class=\"header header3 container-fluid\"><div class=\"row main-head\"><div class=col-md-12><div class=left-section><img src=assets/images/logo.png alt=HDFC class=\"logo pull-left\"><!-- Temporary changes done for HMF-9350 --><!--<span class=\"scheme-pdf\"><a href=\"assets/documents/HDFC-Mutual-Fund-Scheme-Positioning-and-Categorization.pdf\" target=\"blank\">New Categorization and Rationalization of Schemes</a></span>--><!--            <span class=\"scheme-pdf\"><a href=\"https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf\" target=\"blank\">Temporary Change in Cut-Off timings for NAV applicability</a></span>--></div><div class=right-section><nav class=\"right-nav pull-right\"><ul><li><a href=javaScript:void(0) ui-sref=faq><i class=faq-icon tabindex=2></i>FAQs</a></li><li><a ng-click=Header.logoutMe() tabindex=3>Logout</a></li></ul></nav></div><div class=lower-head><p><a style=\"left: 5px\" ng-if=\"Header.isLoggedInStatus && Header.faqVisible\" href=javaScript:void(0) class=mobile-link ui-sref=welcome.existingUserWelcome tabindex=1>Home</a> <a href=javaScript:void(0) class=mobile-link ui-sref=faq><i class=faq-icon tabindex=2></i>FAQs</a> <a ng-click=Header.logoutMe() class=mobile-link tabindex=3>Logout</a></p></div></div></div></header>");
$templateCache.put("app/components/header-pre-login/header-pre-login.html","<header class=\"header affix instant-header container-fluid new-folio-creation-header\"><div class=\"left-item pull-left flex-style\"><a href={{Header.HDFC_API.WEBSITE_LINK}} target=_blank><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo></a></div><!--will be visible if we are passing logo url--><div ng-if=Header.logoUrl class=\"left-item pull-left flex-style ms-3\"><!--    <a href=\"{{Header.HDFC_API.WEBSITE_LINK}}\" target=\"_blank\">--> <img style=\"pointer-events: none\" src={{Header.logoUrl}} alt=HDFC class=logo><!--    </a>--></div><div class=timeLogout ng-class=\"{\'timeoutLogoUrl\' : Header.logoUrl}\"><span ng-class=\"{\'clockhide\' : Header.logoUrl}\" class=server-clock my-current-time=Header.format></span> <span class=sign-out ng-click=Header.logoutMe(); ng-if=Header.showLogoutBtn>Logout</span></div><div class=clock-header-logo ng-if=Header.logoUrl><span class=server-clock my-current-time=Header.format></span></div></header>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=https://github.com/Swiip/generator-gulp-angular><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/components/new-slide-image/slide-image.html","<style>.mySlides {\n        display: none\n    }\n\n    .slideshow-container {\n        position: relative;\n        margin: auto;\n    }\n\n    .dot {\n        cursor: pointer;\n        height: 15px;\n        width: 15px;\n        margin: 0 2px;\n        background-color: #f7f7f7;\n        border-radius: 50%;\n        display: inline-block;\n        transition: background-color 0.6s ease;\n    }\n\n    .dot:hover,.activeWeb {\n        background-color: #fff;\n        width: 45px;\n        border-radius: 15px;\n    }\n\n    .dot-area {\n        position: absolute;\n        top: 69%;\n        left: 21%;\n    }</style><div class=slideshow-container><!-- <div class=\"mySlides\">\n        <img src=\"../../../assets/images/LoginSlider1.svg\" style=\"width:100%\">\n    </div>\n    <div class=\"mySlides\">\n        <img src=\"../../../assets/images/LoginSlider2.svg\" style=\"width:100%\">\n    </div>\n    <div class=\"mySlides\">\n        <img src=\"../../../assets/images/LoginSlider3.svg\" style=\"width:100%\">\n    </div>\n    <div class=\"dot-area\">\n        <span class=\"dot\" id=\"dot1\" ng-click=\"slideImage.currentSlide(1)\"></span>\n        <span class=\"dot\" id=\"dot2\" ng-click=\"slideImage.currentSlide(2)\"></span>\n        <span class=\"dot\" id=\"dot3\" ng-click=\"slideImage.currentSlide(3)\"></span>\n    </div> --><div style=\"height: 99vh; width: 100%\"><img src=../../../assets/images/Login_banner_web.jpg alt=\"\" width=100% style=\"padding: 24px !important;height: 100%\"></div></div>");
$templateCache.put("app/components/new-slide-image-mb/slide-image-mb.html","<style>.mySlidesMb {\n        display: none\n    }\n\n    .slideshow-containerMb {\n        position: relative;\n        margin: auto;\n    }\n\n    .dotMb {\n        cursor: pointer;\n        height: 6px;\n        width: 6px;\n        margin: 0 2px;\n        background-color: #f7f7f7;\n        border-radius: 50%;\n        display: inline-block;\n        transition: background-color 0.6s ease;\n    }\n\n    .activeMb,\n    .dotMb:hover {\n        background-color: #fff;\n        width: 22px;\n        height: 6px;\n        border-radius: 16px;\n    }\n\n    .dotMb-area {\n        position: absolute;\n        top: 37%;\n        left: 6%;\n    }</style><div class=slideshow-containerMb><!-- <div class=\"mySlidesMb\">\n        <img src=\"../../../assets/images/mobileLoginBanner1.svg\" style=\"width:100%\">\n    </div>\n    <div class=\"mySlidesMb\">\n        <img src=\"../../../assets/images/mobileLoginBanner2.svg\" style=\"width:100%\">\n    </div>\n    <div class=\"mySlidesMb\">\n        <img src=\"../../../assets/images/mobileLoginBanner3.svg\" style=\"width:100%\">\n    </div>\n    <div class=\"dotMb-area\">\n        <span class=\"dotMb\" id=\"dotMb1\" ng-click=\"slideImageMb.currentSlide(1)\"></span>\n        <span class=\"dotMb\" id=\"dotMb2\" ng-click=\"slideImageMb.currentSlide(2)\"></span>\n        <span class=\"dotMb\" id=\"dotMb3\" ng-click=\"slideImageMb.currentSlide(3)\"></span>\n    </div> --><div><img src=../../../assets/images/newMobileSvg.svg alt=\"\" width=100%></div></div>");
$templateCache.put("app/components/sideImage/sideImage.html","<section class=\"col-xs-12 invest-with col-md-6 pull-left\" ng-class=\"{\'height-long\': $state.current.name == \'registration.newInvestor\',\'image2\' : switchImageFlag}\"><span class=link-at-image><a href=javascript:void(0) ui-sref=createUserId.verifyAccountDetails></a></span><!--<span class=\"link-at-image2\"><p>Below instructions are for the Old HDFC MF Investor Website users. </p></span>--><!--<span class=\"link-at-image3\"><p>*New users click on \"Register Now\" to create user ID. </p></span>--><footer class=\"bottom-bar clearfix\" ng-hide=switchImageFlag><!--<span class=\"pull-left\">Need help in log in!</span>\n    <span class=\"pull-right btn-change\" ng-click=\"switchImage()\">CLICK HERE</span>--><!--<div class=\"footer-top\">\n      <span class=\"pull-left\">Need help logging in?</span>\n      <span class=\"pull-right btn-change\" ng-click=\"switchImage()\" role=\"button\" tabindex=\"8\">CLICK HERE</span>\n    </div>--><div class=footer-bottom><span class=pull-left>How to transact online using HDFC MFOnline Investors?</span> <span class=\"pull-right btn-change\" ng-click=SideImage.openVideo() role=button tabindex=9>WATCH VIDEO</span></div></footer><style>span.link-at-image a{\n      /*position: absolute;*/\n      /*top: 169px;*/\n      /*display: block;*/\n      /*left: 44px;*/\n      /*height: 40px;*/\n      /*width: 14%;*/\n\n      position: absolute;\n      top: 29%;\n      display: block;\n      left: 6%;\n      height: 7%;\n      width: 15%;\n    }\n    span.link-at-image2 p{\n      position: absolute;\n      top: 75px;\n      display: block;\n      left: 49px;\n      height: 25px;\n      width: 90%;\n      line-height: 27px;\n      font-size: 18px;\n    }\n    span.link-at-image3 p{\n      position: absolute;\n      bottom: 43px;\n      display: block;\n      right: 0px;\n      height: 35px;\n      width: 72%;\n      line-height: 30px;\n      font-size: 18px;\n    }</style></section>");
$templateCache.put("app/components/sidebar/sidebar.html","<div class=\"common sidebar not-mobile\" ng-init=Sidebar.initTab()><aside class=\"affix side-nav\"><ul class=list-group><!--<li ng-class=\"{\'active-link\':Sidebar.active[0]}\" ng-click=\"Sidebar.activateTab(0)\">--><li ng-class=\"{\'active-link\':Sidebar.active[0]}\"><a ng-click=Sidebar.activateTab(0) ui-sref=main.dashboard.widgits><span class=\"dashboard-sidebar-icon default-icon\"></span> <span class=\"dashboard-sidebar-active-icon active-icon\"></span> <span class=nav-link>Dashboard</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[1]}\"><a ng-click=Sidebar.activateTab(1) ui-sref=main.transactions.recent><span class=\"transaction-sidebar-icon default-icon\"></span> <span class=\"transaction-sidebar-active-icon active-icon\"></span> <span class=nav-link>Transactions</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[2]}\"><a ng-click=Sidebar.activateTab(2) ui-sref=main.portfolio.list><span class=\"investment-sidebar-icon default-icon\"></span> <span class=\"investment-sidebar-active-icon active-icon\"></span> <span class=nav-link>Portfolio</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[3]}\"><a ng-click=Sidebar.activateTab(3) ui-sref=main.systematicCorner><span class=\"corner-sidebar-icon default-icon\"></span> <span class=\"corner-sidebar-active-icon active-icon\"></span> <span class=nav-link>Systematic-Corner</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[4]}\"><a ng-click=Sidebar.activateTab(4) ui-sref=main.statements><span class=\"reports-sidebar-icon default-icon\"></span> <span class=\"reports-sidebar-active-icon active-icon\"></span> <span class=nav-link>Statements</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[5]}\"><a ng-click=Sidebar.activateTab(5) ui-sref=main.services><span class=\"service-requests-icon default-icon\"></span> <span class=\"service-requests-active-icon active-icon\"></span> <span class=nav-link>Services</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[9]}\"><a href={{Sidebar.HDFC_API.WEBSITE_LINK}} target=_blank ng-click=Sidebar.activateTab(9)><span class=\"website-sidebar-icon default-icon\"></span> <span class=\"website-sidebar-active-icon active-icon\"></span> <span class=nav-link>HDFC Fund Website</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[10]}\"><a ng-click=Sidebar.activateTab(10) ui-sref=main.feedback><span class=\"feedback-sidebar-icon default-icon\"></span> <span class=\"feedback-sidebar-active-icon active-icon\"></span> <span class=nav-link>Feedback</span></a></li></ul></aside></div>");
$templateCache.put("app/createUserId/verifyDetails/userIdSuccessAcknowledgement.html","<div class=\"row row-no-gutters\"><div class=\"col-md-12 form-existing-wrap userid-success\" style=\"margin-top: 15px\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=\"forgot-password-forms formSuccessAcknowledgement\"><img src=../../../assets/images/successImage.svg><div class=successFormHeading>Created Successfully!</div><div class=successFormContent>Thank you for creating your User ID. Please use this User ID and password to log in to MFOnline.</div><button type=button class=\"loginBtn btn btn-bloc inputLoginBtn loginBtnNewThemeSuccess\" href=javascript:void(0) ui-sref=login ng-click=\"CreateUserId.handleSideBarClick(\'EXISTING_USER\')\">PROCEED TO LOGIN</button></div></div></div>");
$templateCache.put("app/createUserId/verifyDetails/verifyAccountDetails.html","<div class=\"row row-no-gutters\"><div class=\"col-md-12 form-existing-wrap res-form-exis\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=forgot-password-forms><div class=login-header><div style=\"display: flex;align-items: center\"><a href=javascript:void(0) ui-sref=login><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=nonconstrastImgarrow> <img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=constrastImgarrow></a><h4 style=\"padding-bottom: 0px;font-size: 17px\">Create User ID</h4></div><div class=provide-resp>Please provide the following information to verify your details.</div></div><div class=webContainer><form class=login-form autocomplete=off name=verifyAccountForm ng-submit=CreateUserId.verifyAccountDetails() novalidate ng-init=CreateUserId.Init()><div class=\"input-normal userID-input-container\" ng-class=\"{error:verifyAccountForm.folioNo.$dirty &&\n            verifyAccountForm.folioNo.$invalid && verifyAccountForm.folioNo.$touched}\"><input placeholder=\"e.g. 546321\" type=text class=new-input-control name=folioNo ng-model=CreateUserId.formData.folioNo ng-maxlength=12 is-number ng-change=\"CreateUserId.processFlag=false;CreateUserId.resetValues()\" autocomplete=off autofocus required><label>Folio Number<span class=req> *</span></label><span class=error-input ng-messages=verifyAccountForm.folioNo.$error ng-show=\"verifyAccountForm.folioNo.$dirty && verifyAccountForm.folioNo.$invalid && verifyAccountForm.folioNo.$touched\"><span ng-message=required ng-bind=CreateUserId.validateData.FOLIO_REQUIRED></span> <span ng-message=maxlength ng-bind=CreateUserId.validateData.FOLIO_FIELD_MAX></span></span></div><div style=\"display: flex;justify-content: end;min-height: 10px\"><a href=javascript:void(0) ui-sref=\"forgotfolio({from:\'createUserId.verifyAccountDetails\'})\" class=forgtId style=\"font-size: 13px;color: blue\">Forgot Folio</a></div><div class=\"input-normal userpan-input-container\" ng-class=\"{error:verifyAccountForm.pan.$dirty &&\n            verifyAccountForm.pan.$invalid && verifyAccountForm.pan.$touched}\"><input placeholder=\"e.g. ABCDE1234A\" type=text class=new-input-control name=pan maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=CreateUserId.formData.pan ng-change=\"CreateUserId.processFlag=false; CreateUserId.resetValues()\" capitalize required><label>PAN<span class=req> *</span></label><span class=error-input ng-messages=verifyAccountForm.pan.$error ng-show=\"verifyAccountForm.pan.$dirty && verifyAccountForm.pan.$invalid && verifyAccountForm.pan.$touched\"><span ng-message=required ng-bind=CreateUserId.validateData.PAN_REQUIRED></span> <span ng-message=minlength ng-bind=CreateUserId.validateData.PAN_FIELD_MIN></span> <span ng-message=maxlength ng-bind=CreateUserId.validateData.PAN_FIELD_MAX></span> <span ng-message=pattern ng-bind=CreateUserId.validateData.PAN_FIELD></span></span></div><!--Missing contact details message section--><p ng-if=CreateUserId.missingContactDetail class=missing-contact-message ng-bind=CreateUserId.validateData.MISSING_MOBILE_NUMBER></p><p ng-if=CreateUserId.missingEmail class=missing-contact-message ng-bind=CreateUserId.validateData.MISSING_EMAIL></p><!--Missing contact details message section--><!-- Missing email id input fields section--><div class=\"input-normal password-input-container\" ng-if=CreateUserId.missingEmail><input type=email name=email ng-pattern=CreateUserId.EMAIL_PATTERN ng-model=CreateUserId.formData.emailId placeholder=\"Email ID\" maxlength=150 required><label>Email ID<span class=req> *</span></label><span ng-show=\"verifyAccountForm.email.$dirty && verifyAccountForm.email.$invalid\"><span class=error-input ng-show=verifyAccountForm.email.$error.pattern class=help-block ng-bind=CreateUserId.validateData.EMAIL_FIELD></span></span></div><div class=\"input-normal password-input-container\" ng-if=CreateUserId.missingEmail><div class=selectfield ng-class=\"{error:verifyAccountForm.emailBelongsTo.$dirty && verifyAccountForm.emailBelongsTo.$invalid}\"><select name=emailBelongsTo ng-model=CreateUserId.formData.emailBelongsTo ng-options=\"data.familyCode as data.familyDescription for data in CreateUserId.belongToListEmail\" required><option value=\"\" selected>Select Value</option></select></div><label>Email ID Belongs To<span class=req> *</span></label></div><!-- Missing email id input fields section--><!-- Missing contact number input fields section--><div class=\"input-normal password-input-container\" ng-if=CreateUserId.missingContactDetail><input type=text is-number name=contactNumber ng-pattern=CreateUserId.MOBILE_PATTERN ng-model=CreateUserId.formData.contactNumber minlength=10 maxlength=13 placeholder=\"Mobile Number\" required><label>Mobile Number<span class=req> *</span></label><span ng-show=\"verifyAccountForm.contactNumber.$dirty && verifyAccountForm.contactNumber.$invalid\"><span class=error-input ng-show=verifyAccountForm.contactNumber.$error.pattern class=help-block ng-bind=CreateUserId.validateData.MOBILE_FIELD></span></span></div><div class=\"input-normal password-input-container\" ng-if=CreateUserId.missingContactDetail><div class=selectfield ng-class=\"{error:verifyAccountForm.mobileBelongsTo.$dirty && verifyAccountForm.mobileBelongsTo.$invalid}\"><select name=mobileBelongsTo ng-model=CreateUserId.formData.mobileBelongsTo ng-options=\"data.familyCode as data.familyDescription for data in CreateUserId.belongToListMobile\" required><option value=\"\" selected>Select Value</option></select></div><label>Mobile No. Belongs To<span class=req> *</span></label></div><!-- Missing contact number input fields section--><div class=\"checkbox form-check\" ng-if=CreateUserId.showTerms><input type=checkbox style=\"width: 33%\" id=termNcondition name=termNcondition ng-model=CreateUserId.formData.termNcondition required> <i class=icon-checkbox style=margin-right:10px></i> <span class=checkbox-text>I accepted the <a class=tnc-res ng-click=CreateUserId.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a></span></div><div class=\"btnContainer loginpwdBtn\"><button type=submit class=wBtn style=\"width: 100% !important\" ng-if=\"!CreateUserId.missingContactDetail && !CreateUserId.missingEmail\" ng-disabled=\"verifyAccountForm.$invalid ||\n                    CreateUserId.processFlag || !CreateUserId.formData.termNcondition\">VERIFY</button> <button type=button class=\"loginBtn btn btn-bloc loginBtnNewTheme\" ng-if=\"CreateUserId.missingContactDetail || CreateUserId.missingEmail\" ng-click=CreateUserId.submitCreateUserIdForm() ng-disabled=\"verifyAccountForm.$invalid ||\n                    CreateUserId.processFlag || !CreateUserId.formData.termNcondition\">SUBMIT</button></div></form></div></div></div></div><style>.new-input-control{\n    height: 48px !important;\n    padding: 5px 24px 4px 20px !important;\n    border-radius: 100px !important;\n  }\n  .userid-controls{\n    top: 30px !important;\n    right: 4% !important;\n    width: 95px;\n    border: none !important;\n  }\n  .loginBtn{\n    background: linear-gradient(93.92deg, #058DC8 -7.52%, #1B4B86 99.94%) !important;\n  }\n  .forgot-password-forms{\n    padding: 1% 10% 20px 10% !important;\n  }\n  .provide-resp{\n    padding-top: 0px !important;\n  }\n  @media only screen and (max-width: 767px) {\n    .login-header{\n      padding-top: 10px;\n    }\n  }\n  @media only screen and (min-width: 767px) and (max-width:1024px) {\n    .login-header{\n      padding-top: 30px;\n    }\n  }</style>");
$templateCache.put("app/createUserId/verifyDetails/verifyOTP.html","<div class=\"row row-no-gutters\"><div class=\"col-md-12 form-existing-wrap\" style=\"margin-top: 15px\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=forgot-password-forms><div class=login-header><div style=\"display: flex;align-items: center\"><a href=javascript:void(0) ui-sref=login><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=\"hide-lg nonconstrastImgarrow\"> <img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=\"hide-lg constrastImgarrow\"></a><h4 style=\"padding-bottom: 0px;font-size: 17px\">Create User ID</h4></div></div><div><form name=otpForm ng-submit=CreateUserId.confirmOtp() autocomplete=off novalidate ng-init=CreateUserId.Init() class=\"login-form resend-user-otp\"><span class=\"form-group otpSucessText\" ng-if=\"CreateUserId.otpSentMessage && CreateUserId.details.missingDetail\">We have sent two One-time Passwords(OTPs) for authentication purpose. Both OTPs are valid for 15 minutes only.</span><div class=\"input-normal otp-input-container otp-unlock-id\" ng-class=\"{error:otpForm.otpNumber.$dirty && otpForm.otpNumber.$invalid}\"><input type=text ng-model=CreateUserId.formData.otpNumber ng-if=!CreateUserId.inputReset is-number ng-click=CreateUserId.resetValues() minlength=6 maxlength=6 name=otpNumber autocomplete=off autofocus required><label>Enter OTP <span ng-if=CreateUserId.details.missingDetail>1</span></label><div class=input-controls style=\"top: 45%\" ng-if=!CreateUserId.details.missingDetail><timer countdown=CreateUserId.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a href=\"\" class=\"text-blue resend\" ng-click=CreateUserId.reGenerateOtp() ng-class={anchorDisable:CreateUserId.processOTPFlag} ng-show=\"countdown ==0\">Resend OTP</a></span></div></timer></div><span ng-messages=otpForm.otpNumber.$error ng-show=otpForm.otpNumber.$dirty><span class=mod-error-msg ng-message=required ng-bind=CreateUserId.validateData.OTP_REQUIRED></span> <span class=mod-error-msg ng-message=minlength ng-bind=CreateUserId.validateData.OTP_FIELD></span> <span class=mod-error-msg ng-message=maxlength ng-bind=CreateUserId.validateData.OTP_FIELD></span></span><p ng-if=CreateUserId.details.missingDetail>{{CreateUserId.otpSentMessage}}</p></div><div class=\"input-normal otp-input-container otp-unlock-id\" ng-class=\"{error:otpForm.otpNumber2.$dirty && otpForm.otpNumber2.$invalid}\" ng-if=CreateUserId.details.missingDetail><input type=text ng-model=CreateUserId.formData.otpNumber2 ng-if=!CreateUserId.inputReset is-number ng-click=CreateUserId.resetValues() minlength=6 maxlength=6 name=otpNumber2 autocomplete=off autofocus required><label>Enter OTP 2</label><span class=error-input ng-messages=otpForm.otpNumber2.$error ng-show=otpForm.otpNumber2.$dirty><span ng-message=required ng-bind=CreateUserId.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=CreateUserId.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=CreateUserId.validateData.OTP_FIELD></span></span><p ng-if=CreateUserId.details.missingDetail>{{CreateUserId.updatedContactOtpSentMessage}}</p></div><div class=resend-otp-container ng-if=CreateUserId.details.missingDetail><timer countdown=CreateUserId.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a href=\"\" class=\"text-blue resend\" ng-click=CreateUserId.reGenerateOtp() ng-class={anchorDisable:CreateUserId.processOTPFlag} ng-show=\"countdown ==0\">Resend OTP</a></span></div></timer></div><div class=resend-otp-message ng-if=!CreateUserId.details.missingDetail><div id=clickText class=\"form-group otpSucessText\" ng-if=Login.sentOtpRespMsg ng-bind-html=Login.sentOtpRespMsg></div><span class=\"form-group otpSucessText\" ng-if=CreateUserId.otpResendMessage>{{CreateUserId.otpResendMessage}}</span> <span class=\"form-group otpSucessText\" ng-if=CreateUserId.otpSentMessage>{{CreateUserId.otpSentMessage}}</span> <span class=error ng-if=CreateUserId.errorMessage><span class=mod-error-msg>{{ CreateUserId.errorMessage }}</span></span></div><div class=\"btnContainer loginpwdBtn button-placing d-flex justify-content-between align-items-baseline\"><button type=submit class=wBtn ng-disabled=\"otpForm.$invalid || CreateUserId.processFlag || CreateUserId.isOtpInValid\">Submit</button> <span class=inputTxt><a ng-click=CreateUserId.confirmCancel() href=javascript:void(0) tabindex=0 class=cursor-pointer>Cancel</a></span></div></form></div></div></div></div><style>.forgot-password-forms{\n    padding: 1% 10% 20px 10% !important;\n  }\n  .align-items-baseline{\n    align-items: baseline;\n  }</style>");
$templateCache.put("app/createUserId/verifyDetails/verifyUserIdDetails.html","<div class=\"row row-no-gutters\"><div class=\"col-md-12 form-existing-wrap\" style=\"margin-top: 0px\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=forgot-password-forms><div class=login-header><div style=\"display: flex;align-items: center\"><a href=javascript:void(0) ui-sref=login class=contrastDarkFont><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=\"hide-lg nonconstrastImgarrow\"> <img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=\"hide-lg constrastImgarrow\"></a><h4 style=\"padding-bottom: 0px;font-size: 17px\">Create User ID</h4></div><div><div>Please provide details for creating new user ID.</div></div></div><div><!--<div class=\"loader availability-loader\" style=\"position: absolute;\"><span class=\"loading\"></span></div>--><form autocomplete=off name=verifyUserForm ng-submit=CreateUserId.generateOtp() novalidate class=\"login-form verify-user-details\" ng-init=\"CreateUserId.Init(); CreateUserId.pw=\'\';pw=\'\';\"><div class=\"input-normal userID-input-container\" ng-class=\"{error:verifyUserForm.userId.$dirty &&\n            (verifyUserForm.userId.$invalid || CreateUserId.availableMessage|| CreateUserId.formData.userId.includes(\' \'))}\"><input type=text ng-model=CreateUserId.formData.userId name=userId required minlength=6 maxlength=38 autocomplete=off ng-change=CreateUserId.resetValues() ng-disabled=CreateUserId.isUserId ng-keyup=CreateUserId.checkText() ng-blur=CreateUserId.checkAvailability() ng-pattern=CreateUserId.appConstants.userId_regex class=edit-input-padding> <img src=../../assets/images/icons/pencil.png class=input-edit-icon ng-click=CreateUserId.resetCreateUserId()><label>User ID</label><span class=error-input ng-messages=verifyUserForm.userId.$error><span class=mod-error-msg ng-message=required ng-bind=CreateUserId.validateData.USER_ID_REQUIRED></span> <span class=mod-error-msg ng-message=minlength ng-bind=CreateUserId.validateData.USER_ID_MIN></span> <span class=mod-error-msg ng-message=pattern ng-bind=CreateUserId.validateData.USER_ID_FIELD_PATTERN></span> </span><span class=mod-error-msg ng-if=CreateUserId.invalidUserId ng-bind=CreateUserId.validateData.INVALID_USER_ID_ERROR></span> <span class=mod-error-msg ng-if=CreateUserId.availableMessage ng-bind=CreateUserId.availableMessage></span></div><div class=\"input-normal password-input-container\" ng-class=\"{error:verifyUserForm.password.$dirty && verifyUserForm.password.$invalid || CreateUserId.isRequired || !CreateUserId.isMatching}\" tooltips tooltip-template=\"Password should contain minimum 8 & maximum 15 characters, atleast one capital letter, one small letter, one number and one special character($@!_)\" tooltip-show-trigger=focusin tooltip-hide-trigger=focusout tooltip-side=right><input type=password ng-model=pw name=pwName id=pwId minlength=8 maxlength=15 ng-change=CreateUserId.checkPattern(pw) autocomplete=off autofocus required><label>Password</label><span class=error-input ng-messages=verifyUserForm.pwName.$error ng-show=verifyUserForm.pwName.$dirty><span class=mod-error-msg ng-message=required ng-if=CreateUserId.isRequired ng-bind=CreateUserId.validateData.PASSWORD_REQUIRED></span> <span class=mod-error-msg ng-if=!CreateUserId.isMatching ng-bind=CreateUserId.validateData.PASSWORD_FIELD></span> <span class=mod-error-msg ng-message=minlength style=\"top: 60px\" ng-bind=CreateUserId.validateData.PASSWORD_MIN></span></span><ul id=strength check-strength=pw></ul></div><div class=\"input-normal password-input-container\" ng-class=\"{error:verifyUserForm.confirmPassword.$dirty && verifyUserForm.confirmPassword.$invalid}\"><label>Confirm Password</label><input type=password ng-model=CreateUserId.formData.confirmPassword name=confirmPassword ng-pattern=CreateUserId.check4CofirmPW required autocomplete=off> <span ng-show=verifyUserForm.confirmPassword.$dirty><span class=mod-error-msg ng-show=verifyUserForm.confirmPassword.$error.required ng-bind=CreateUserId.validateData.CONFIRM_PASSWORD_REQUIRED></span> <span class=mod-error-msg ng-show=verifyUserForm.confirmPassword.$error.pattern>{{ CreateUserId.validateData.PASSWORD_MATCH }}</span></span></div><div class=\"input-normal password-input-container\" ng-if=!CreateUserId.formData.emailAddress><input type=email name=email ng-pattern=CreateUserId.EMAIL_PATTERN ng-model=CreateUserId.formData.emailId maxlength=150 required><label>Email ID</label><span ng-show=\"verifyUserForm.email.$dirty && verifyUserForm.email.$invalid\"><span class=mod-error-msg ng-show=verifyUserForm.email.$error.pattern class=help-block ng-bind=CreateUserId.validateData.EMAIL_FIELD></span></span></div><div class=\"get-otp register-info-container\"><p>OTP will be sent on the following:</p><div class=input-normal ng-if=CreateUserId.formData.maskedEmail><i class=mail-icon></i> <input no-focus type=text ng-model=CreateUserId.formData.maskedEmail name=emailAddress class=pd40 disabled style=\"border: 1px solid gray !important\"> <span class=highlight></span> <span class=bar></span></div><div class=input-normal ng-if=CreateUserId.formData.maskedMobile><i class=mobile-icon></i> <input type=text ng-model=CreateUserId.formData.maskedMobile name=contact class=pd40 disabled style=\"border: 1px solid gray !important\"> <span class=highlight></span> <span class=bar></span></div></div><span class=error ng-if=CreateUserId.errorMessage><span class=\"error-message help-block\">{{ CreateUserId.errorMessage }}</span></span><div class=\"btnContainer loginpwdBtn\" ng-class=\"{\'button-placing\' : Login.showSecStep}\" style=\"display: flex;justify-content: space-between;align-items: baseline\"><button type=submit ng-disabled=\"verifyUserForm.$invalid || !CreateUserId.isMatching || CreateUserId.emailEdit || CreateUserId.contactEdit || CreateUserId.availableMessage || CreateUserId.isRequired || !CreateUserId.isMatching || CreateUserId.invalidUserId\" class=\"wBtn loginBtnTheme\">Generate OTP</button> <input type=submit ng-if=\"Login.showSecStep || Login.showOtpField\" ng-disabled=\"loginFormPassword.$invalid || Login.loginProcessFlag || !Login.showSecStep\" ng-click=Login.login() tabindex=16 class=\"loginBtn btn btn-bloc loginBtnTheme\" value=LOGIN> <span class=inputTxt ng-if=!Login.showSecStep><a ng-click=CreateUserId.confirmCancel() href=javascript:void(0) tabindex=0 class=cursor-pointer>Cancel</a></span></div></form></div></div></div></div><style>.forgot-password-forms{\n    padding: 1% 10% 20px 10% !important;\n  }\n  .register-info-container div input {\n  width: 85%;\n  }</style>");
$templateCache.put("app/dashboard/widgits/dividentUpdateWidgit.html","<div class=\"dash-card updates\" ng-class={dragit:Dividend.checkLocation()} ng-init=Dividend.init()><div class=\"loader dividend-loader\" style=\"position: absolute\"><span class=loading></span></div><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left><!--Latest Scheme Evaluation--> Investment Performance Evaluation</p></div><div class=\"card-body table-responsive top-up tables-widget\"><table class=\"table table-striped table-responsive\"><thead ng-if=\"Dividend.navDividend.length>0\"><tr class=select-th-dash><th class=col-xs-6>Scheme Name</th><th class=col-xs-2>Cost Value<br>(<i class=rupee-small-icon></i>)</th><th class=col-xs-2>Market Value (<i class=rupee-small-icon></i>)</th><th class=col-xs-2>Nav</th><th></th><!--            <th class=\"col-xs-2\">XIRR (%)</th>--></tr></thead><tr class=select-td ng-repeat=\"data in Dividend.navDividend\"><td class=col-xs-6>{{data.schemeName}}</td><td class=col-xs-2 easyassist-key=mask-element>{{data.costValue | truncateDecimal : 2 | unit: data.costValueUnit}}</td><td class=col-xs-2 easyassist-key=mask-element>{{data.marketValue | truncateDecimal : 2 | unit:data.marketValueUnit}}</td><td class=col-xs-2>{{data.navValue | truncateDecimal : 4}}</td><td><span class=\"btn-more dropdown\"><button class=\"btn-primary-action dropdown-toggle\" data-bs-toggle=dropdown ng-if=\"data.folio && data.topUpAction !== undefined && data.schemeCode && data.topUpAction.length!==0\" style=\"width: 77px\">{{Dividend.topUpLabel || Dividend.top_Up_label}} <i class=arrow-white-down-icon></i></button><ul class=dropdown-menu><li>{{Dividend.topUpLabel || Dividend.top_Up_label}} <i class=arrow-blue-down-icon></i></li><li class=list-group-item ng-click=Dividend.selectTransaction(action,data) ng-repeat=\"action in data.topUpAction\">{{action}} <i class=\"arrow-right-icon pull-right\"></i></li></ul></span></td></tr><tr ng-if=\"Dividend.navDividend.length==0\"><td colspan=5 align=center>No Data Available</td></tr></table></div></div>");
$templateCache.put("app/dashboard/widgits/investmentWidgit.html","<div class=\"dash-card overview\" ng-class=\"{dragit: Investment.checkLocation()}\" ng-init=Investment.init()><div class=\"loader transsnap\" style=position:absolute><span class=loading></span></div><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>Investment Overview</p></div><div class=card-body><div class=\"purchase-current clearfix\"><div class=\"col-sm-12 col-md-4 text-center cost-value padding-removal\"><p class=total-cost-content easyassist-key=mask-element><i class=rupee-black-icon></i>{{Investment.constantDataDTO.totalPurchaseValue | truncateDecimal : 2 | unit:Investment.purchaseValueUnit}}</p><span>Total Cost Value</span></div><div class=line-seperator-dash><!--                <i class=\"arrow-blue-right-icon\"></i>--></div><div class=\"col-sm-12 col-md-4 text-center market-value padding-removal\"><p easyassist-key=mask-element><i class=rupee-black-icon></i>{{Investment.constantDataDTO.totalCurrentValue | truncateDecimal : 2 | unit:Investment.currentValueUnit}}<!--<span class=\"text-green\" ng-if=\"Investment.totalCurrentPercentageUnit>0\"><i class=\"arrow-green-up-icon\"></i>{{Investment.constantDataDTO.totalCurrentPercentage | unit: Investment.totalCurrentPercentageUnit}}%</span>--><!--<span class=\"text-red\" ng-if=\"Investment.totalCurrentPercentageUnit<0\"><i class=\"arrow-red-down-icon\"></i>{{Investment.constantDataDTO.totalCurrentPercentage | unit: Investment.totalCurrentPercentageUnit}}%</span>--></p><span>Total Market Value</span></div><div class=\"col-sm-12 col-md-4 text-center xirr padding-removal\"><!--            <p>{{Investment.constantDataDTO.xirrValue}}</p>--><p class=xirrContent style=\"padding-bottom: 2px\" ng-if=\"Investment.constantDataDTO.xirrValue<0\">({{Investment.constantDataDTO.xirrValue | truncateDecimal : 2 | unit:Investment.constantDataDTO.xirrValueUnit}}{{Investment.constantDataDTO.xirrValueUnit|unitValue}})</p><p class=xirrContent style=\"padding-bottom: 2px\" ng-if=\"Investment.constantDataDTO.xirrValue>=0\">{{Investment.constantDataDTO.xirrValue | truncateDecimal : 2 | unit:Investment.constantDataDTO.xirrValueUnit}}{{Investment.constantDataDTO.xirrValueUnit|unitValue}}</p><span class=leaf-label>XIRR%<div class=info-xirr-icon><i class=\"info-icon base-tooltip info-xirr-margin\" data-bs-html=true data-bs-toggle=tooltip tooltip data-bs-placement=top title={{Investment.xirrInfo}}></i></div></span></div></div><div class=\"total-investments text-center\"><span ng-if=Investment.schemeCount><a ui-sref=main.portfolio.list>Total No of Schemes: {{Investment.schemeCount}}</a></span> <span ng-if=!Investment.schemeCount><a ui-sref=main.portfolio.list>Total No of Schemes: 0</a></span></div><hr><div class=overview-graph ng-if=Investment.investmentData.length><div class=\"loader popup\"><span class=loading></span></div><div class=\"col-sm-12 col-md-5 text-center\" id=donutchart-asset></div><div class=\"col-sm-12 col-md-7 horizontal-chart-line\"><p>{{Investment.investmentData[Investment.investmentSelected].aumType}} Investments</p><p class=amount easyassist-key=mask-element><i class=rupee-black-icon></i>{{Investment.investmentData[Investment.investmentSelected].amount | unit:Investment.investmentData[Investment.investmentSelected].amount}}</p><div class=\"equity-overview clearfix\"><table><tr ng-repeat=\"data in Investment.investmentData[Investment.investmentSelected].topSchemesList\"><td>{{data.schemeName}}</td><td class=\"equity-amount text-right\" easyassist-key=mask-element><i class=rupee-blue-small-icon></i>{{data.totalAmount | truncateDecimal : 2 | unit:data.totalAmount}}</td></tr></table></div><i class=shadow-divider-icon></i></div></div><div ng-if=\"!Investment.investmentData.length \" style=\"text-align: center;margin-top: 90px\">No Data Available</div></div></div>");
$templateCache.put("app/dashboard/widgits/marketUpdateWidgit.html","<div class=\"dash-card market-updates\" ng-class={dragit:Market.checkLocation()} ng-init=Market.init()><i class=drag-icon></i><div class=card-body><div class=\"loader popup\"><span class=loading></span></div><div class=\"col-md-4 nse-bse-block\"><div class=nse-block><i class=nse-icon></i> <span class=amt>{{Market.nseRate.currentRate|unit:Market.nseRate.currentRate}}</span><p ng-class=\"Market.nseRate.rateChange<0?\'text-red\':\'text-green\'\"><i ng-class=\"Market.nseRate.rateChange<0?\'negative-down-icon\':\'positive-up-icon\'\"></i>{{Market.nseRate.rateChange}} ({{Market.nseRate.percentageRateChange | number:2 }}%)</p></div><div class=bse-block><i class=bse-icon></i> <span class=amt>{{Market.bseRate.currentRate|unit:Market.bseRate.currentRate}}</span><p ng-class=\"Market.bseRate.rateChange<0?\'text-red\':\'text-green\'\"><i ng-class=\"Market.bseRate.rateChange<0?\'negative-down-icon\':\'positive-up-icon\'\"></i>{{Market.bseRate.rateChange}} ({{Market.bseRate.percentageRateChange | number:2 }}%)</p></div></div><div class=\"col-md-8 updates-block\"><!--remove border none style--><div class=clearfix><p class=\"text-blue strong pull-left\">Market Updates</p><!--  <span class=\"text-blue cursor-pointe pull-right\">View All <i class=\"arrow-blue-icon\"></i></span>--></div><ul><li ng-repeat=\"data in Market.marketNewsList\"><a href={{data.link}} target=_blank>{{data.title}}</a></li></ul><p ng-if=\"Market.marketNewsList.length===0\" style=\"text-align: center; margin-top: 50px\">No Data Found</p></div></div></div>");
$templateCache.put("app/dashboard/widgits/quickLinkWidgit.html","<div class=\"dash-card quick-links\" ng-class={dragit:quickLinkWidgit.checkLocation()}><div class=\"loader assetmng-loader\" style=\"position: absolute\"><span class=loading></span></div><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>Quick Links</p></div><div class=card-body><div class=col-md-6><ul><li><a ng-click=\"quickLinkWidgit.checkKycStatus(\'purchase\')\">Purchase</a></li><li><a ng-click=\"quickLinkWidgit.checkKycStatus(\'sip\')\">SIP</a></li><li><a ui-sref=faq>FAQs</a></li></ul></div></div></div>");
$templateCache.put("app/dashboard/widgits/recentActivityWidgit.html","<div class=\"dash-card recent-activities\" ng-class={dragit:RecentActivity.checkLocation()} ng-init=RecentActivity.init()><div class=\"loader assetmng-loader\" style=\"position: absolute\"><span class=loading></span></div><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>Recent Activities</p></div><div class=card-body><table class=\"table table-striped\"><tr ng-repeat=\"activities in RecentActivity.recentActivity\"><td>{{activities.date}}</td><td>{{activities.message}}</td></tr><tr ng-if=\"RecentActivity.recentActivity.length==0\"><td>No Data Available</td></tr></table></div></div>");
$templateCache.put("app/dashboard/widgits/schemePerformanceEvaluation.html","<div class=\"dash-card contributors-block\" ng-class={dragit:Contributor.checkLocation()} ng-init=Contributor.init()><div class=\"loader contributor-loader\" style=\"position: absolute\"><span class=loading></span></div><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left><!--Contributors in Change--> Scheme Performance Evaluation</p><div class=pull-right><select ng-change=Contributor.frequencyChanged() ng-model=Contributor.selectedFrequency ng-options=\"_freq.value as _freq.key for _freq in Contributor.CONTRIBUTORS_FREQUENCY\"></select><select ng-change=Contributor.contributorsChanged() ng-model=Contributor.selectedContributors ng-options=\"_cont.value as _cont.key for _cont  in Contributor.NO_OF_CONTRIBUTORS\" ng-val></select></div></div><div class=card-body><div class=\"col-sm-12 col-md-8 text-center\" id=areachart style=padding-left:0;padding-right:0><!--Place graph here--></div><div class=\"col-sm-12 col-md-4 areachart-legends\"><div ng-repeat=\"data in Contributor.contributorData\"><div><p ng-click=Contributor.changeGraph($index) ng-class=\"{\'text-primary\':Contributor.currentIndex==$index}\"><span style=background-color:{{Contributor.AppConstants.AREA_CHART_COLOR[$index]}} class=graph-legend></span>{{data.schemeName}}</p><span class=text-center ng-if=\"data.percentChangeInNav>=0\"><i class=rupee-small-icon></i>{{data.changeInNav | number : 2}}<span class=\"percentage text-green\">({{data.percentChangeInNav | number : 2}}%)<i class=arrow-green-small-icon></i></span></span> <span class=text-center ng-if=\"data.percentChangeInNav<0\"><i class=rupee-small-icon></i>{{data.changeInNav | number : 2}}<span class=\"percentage text-red\">({{data.percentChangeInNav | number : 2}}%)<i class=arrow-red-small-icon></i></span></span></div></div><div ng-if=!Contributor.contributorData style=\"text-align: center;margin-top: 90px\">No Data Available</div></div></div></div>");
$templateCache.put("app/dashboard/widgits/transactionStatusWidgit.html","<div class=\"dash-card trans-status\" ng-class={dragit:Snapshot.checkLocation()} ng-init=Snapshot.init();><div class=\"loader assetmng-loader\" style=\"position: absolute\"><span class=loading></span></div><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>Transaction Status</p><div class=pull-right><span class=text-blue><strong>Last 15 Days </strong></span><span class=\"text-blue cursor-pointer\" ui-sref=main.transactions.all>View All <i class=arrow-blue-icon></i></span></div></div><div class=card-body><div class=\"row status-block flex-style\"><div ui-sref=\"main.transactions.all({trStatus:\'processed\',fromDate:Snapshot.fromDate,toDate:Snapshot.toDate})\" class=\"processed text-center text-uppercase\"><span ng-if=Snapshot.snapshotData.processedCount ng-bind=Snapshot.snapshotData.processedCount|unit:Snapshot.snapshotData.processedCount>0</span> <span ng-if=!Snapshot.snapshotData.processedCount>0</span> <span>Processed</span></div><div ui-sref=\"main.transactions.all({trStatus:\'reversed\',fromDate:Snapshot.fromDate,toDate:Snapshot.toDate})\" class=\"reversed text-center text-uppercase\"><span ng-if=Snapshot.snapshotData.reversedCount ng-bind=Snapshot.snapshotData.reversedCount|unit:Snapshot.snapshotData.reversedCount>150</span> <span ng-if=!Snapshot.snapshotData.reversedCount>0</span> <span>Reversed</span></div><div ui-sref=\"main.transactions.all({trStatus:\'rejected\',fromDate:Snapshot.fromDate,toDate:Snapshot.toDate})\" class=\"rejected text-center text-uppercase\"><span ng-if=Snapshot.snapshotData.rejectedCount ng-bind=Snapshot.snapshotData.rejectedCount|unit:Snapshot.snapshotData.rejectedCount>150</span> <span ng-if=!Snapshot.snapshotData.rejectedCount>0</span> <span>Rejected</span></div><div ui-sref=\"main.transactions.all({trStatus:\'pending\',fromDate:Snapshot.fromDate,toDate:Snapshot.toDate})\" class=\"pending-approval text-center text-uppercase\"><span ng-if=Snapshot.snapshotData.pendingCount ng-bind=Snapshot.snapshotData.pendingCount|unit:Snapshot.snapshotData.reversedCount>150</span> <span ng-if=!Snapshot.snapshotData.pendingCount>0</span> <span>Pending</span></div></div></div></div>");
$templateCache.put("app/e-cart/checkout/cart.html","<section class=\"main-section clearfix\"><div class=content-area><div class=row><div class=col-md-12><div class=\"post-login ecart-journey\"><section class=sub-header><h3 class=heading-web><i class=red>E-Cart Summary</i></h3><h3 class=heading-mobile><i class=red>E-Cart Summary</i></h3></section><div class=\"ecart-journey main-section-ecart\"><section class=container-fluid><div class=\"folio-invest-through row\"><div class=\"col-md-12 folio-selection-container\"><div class=\"row set-display-flex\"><div class=\"col-sm-6 col-md-5 folio-selection set-display-flex\"><label class=label-black>Folio No :</label><select class=custom-select name=folio id=_first tooltip-placement=top uib-tooltip={{Ecart.formData.taxStatusSelected}} ng-change=Ecart.folioChanged() ng-model=Ecart.formData.folioNumber class=select-folio-list ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Ecart.ecartFolioList\" ng-init=\"Ecart.formData.folioNumber=Ecart.formData.folioNumber?Ecart.formData.folioNumber: null\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Ecart.isRequired><option value=\"\">Select Folio</option></select></div><div class=\"col-sm-6 col-md-7 folio-selection set-display-flex\"><label class=label-black ng-if=Ecart.formData.folioNumber>Invest Through :</label><span ng-if=\"Ecart.formData.folioNumber && Ecart.investThrough === \'DIRECT\'\">Direct</span> <span ng-if=\"Ecart.formData.folioNumber && Ecart.investThrough === \'DISTRIBUTOR\'\">{{Ecart.brokerCode}}</span> <span ng-if=\"Ecart.formData.folioNumber && Ecart.investThrough === \'RIA\'\">{{Ecart.brokerCode}}</span> <span class=\"edit-btn blue\" ng-click=\"Ecart.showPopupScreen(\'INVEST_THROUGH\')\" ng-if=Ecart.formData.folioNumber>Edit</span></div></div><div class=row ng-if=Ecart.formData.folioError><div class=\"col-sm-6 col-md-5\"><span class=bank-error-msg style=\"margin-bottom: 0px;margin-top: 5px;font-size: 14px;margin-left: 22%\">{{Ecart.formData.folioError}}</span></div></div></div></div><hr><div class=row><div class=col-md-12><div class=review-section><div class=no-data ng-if=\"(Ecart.cartItem.totalLength==0)\"><p class=strong>No items added to your e-cart</p></div><div ng-if=\"Ecart.cartItem.cartItemList && Ecart.cartItem.totalLength > 0\"><!--review header--><div class=row><div class=col-md-12><div class=\"row background-header-content-main background-blue\"><div class=col-md-6><span class=header-content>Scheme Name</span></div><div class=col-md-4><span class=header-content>Investment Type</span></div><div class=col-md-2><span class=header-content>Amount</span></div></div></div></div><!--review cards--><div><div class=\"row item-row\" ng-repeat=\"item in Ecart.cartItem.cartItemList track by $index\"><div class=col-md-12><div class=\"row investement-type\"><div class=\"col-md-6 col-xs-7\"><span class=\"review-table-data blue\">{{Ecart.indexToNumberArray[$index]}} Investment</span></div><div class=\"col-md-4 hidden-xs\"></div><div class=\"col-md-2 col-xs-5 edit-responsive\"><span class=\"edit-btn red\" ng-click=\"Ecart.showPopupScreen(\'CART_DETAILS\', item)\">Edit</span> <span class=\"edit-btn red\" ng-click=Ecart.removeCartItem(item)>Remove</span></div></div></div><div class=\"col-md-12 card-container\"><div class=\"row card-ui\"><div class=\"col-md-6 col-sm-12 col-xs-12\"><span class=responsive-title>Scheme Name</span> <span class=\"review-table-data black\">{{item.schemeName}}</span></div><div class=\"col-md-6 col-xs-12 col-sm-12 visible-xs\"><hr></div><div class=\"col-md-4 col-sm-9 col-xs-8\"><span class=responsive-title>Investment Type</span> <span class=\"review-table-data d-block black\" ng-if=item.sipOpted>SIP</span> <span class=\"review-table-data d-block black\" ng-if=item.purchaseOpted>Purchase</span></div><div class=\"col-md-2 col-sm-3 col-xs-4\"><span class=\"responsive-title amount\">Amount</span> <span class=\"review-table-data d-block black amount\" tooltip-placement=top-left uib-tooltip=\"{{\'₹ \' + Ecart.utilService.getCommaSeperatedString(item.installmentAmount)}}\" ng-if=item.sipOpted>{{\'₹ \' + Ecart.utilService.getCommaSeperatedString(item.installmentAmount)}}</span> <span class=\"review-table-data d-block black amount\" tooltip-placement=top-left uib-tooltip=\"{{\'₹ \' + Ecart.utilService.getCommaSeperatedString(item.amount)}}\" ng-if=item.purchaseOpted>{{\'₹ \' + Ecart.utilService.getCommaSeperatedString(item.amount)}}</span></div><!--error message for particular item--><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=item.errorExists><span class=bank-error-msg>{{item.message}}</span></div></div></div></div></div><!--review footer summary --><div class=row style=\"margin-top: 40px\"><div class=col-md-12><div class=\"row background-header-content-secondary background-blue\"><div class=col-md-6><span class=header-content></span></div><div class=\"col-md-4 col-sm-9 col-xs-7\"><span class=header-content>Total Amount</span></div><div class=\"col-md-2 col-sm-3 col-xs-5\"><span class=\"header-content amount\" tooltip-placement=top-left uib-tooltip=\"{{\'₹ \' + Ecart.utilService.getCommaSeperatedString(Ecart.totalSum)}}\">{{\'₹ \' + Ecart.utilService.getCommaSeperatedString(Ecart.totalSum)}}</span></div></div></div></div></div><div class=row style=\"margin-top: 40px\"><div class=col-md-12 style=\"padding: 0px\"><div class=row><div class=col-md-6></div><div class=col-md-4></div><div class=\"col-md-2 col-xs-12\"><button ng-if=\"Ecart.cartItem.totalLength > 0 && Ecart.cartItem.totalLength !== Ecart.maximumItemAllowed\" ng-disabled=!Ecart.formData.folioNumber class=\"red add-more\" ng-click=\"Ecart.showPopupScreen(\'ALL_FUNDS\')\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add More</div></button> <button ng-if=\"Ecart.cartItem.totalLength === 0\" class=\"red add-more\" ng-disabled=!Ecart.formData.folioNumber ng-click=\"Ecart.showPopupScreen(\'ALL_FUNDS\')\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add Funds</div></button></div></div></div></div><!--notes--><ng-bind-html dynamic=Ecart.notesEcart.noteDTO.noteDTOMap.Note_Purchase_Review.content></ng-bind-html><ng-bind-html dynamic=Ecart.notesEcart.noteDTO.noteDTOMap.Note_Purchase_Summary.content></ng-bind-html><div class=row style=\"margin-top: 40px\"><div class=\"col-md-12 text-center\"><!--error message for cart --> <span ng-if=Ecart.cartDetails.errorExists class=bank-error-msg style=\"text-align: center\">{{Ecart.cartDetails.message}}</span> <button class=btn-primary ng-disabled=\"Ecart.cartItem.totalLength === 0 || Ecart.cartError || !Ecart.formData.folioNumber\" ng-click=Ecart.moveToPayment()>Proceed</button></div></div></div></div></div></section><div class=sidebar-container id=sidebarContainer ng-if=Ecart.showSideBarInvest hdfc-ecart-sidebar side-title=Ecart.sidebarTitle investor-data=Ecart.investorData invest-through=Ecart.investThrough cart-item=Ecart.cartDetails euin-declaration=Ecart.dynamicDataSipPurchaseReview update-info=\"Ecart.fetchCartItems(\'invest\', data)\"></div><div class=sidebar-container id=sidebarContainer ng-if=\"Ecart.showSideBarCart && Ecart.cartItem.cartItemList && Ecart.cartItem.totalLength > 0\" hdfc-ecart-sidebar side-title=Ecart.sidebarTitle investor-data=Ecart.investorData cart-item=Ecart.itemToBeEdited euin-declaration=Ecart.dynamicDataSipPurchaseReview show-add-cart=Ecart.showAddCart update-info=\"Ecart.fetchCartItems(\'add\')\"></div><div class=sidebar-container id=sidebarContainer ng-if=Ecart.showSideAllFunds hdfc-ecart-sidebar side-title=Ecart.sidebarTitle investor-data=Ecart.investorData euin-declaration=Ecart.dynamicDataSipPurchaseReview show-add-cart=Ecart.showAddCart update-info=\"Ecart.fetchCartItems(\'all\')\"></div><!--<div class=\"main-section-ecart-review\" ng-if=\"Ecart.showAddEcart\">\n              <div class=\"sidebar-container\" id=\"sidebarContainer\"\n                   hdfc-ecart-sidebar\n                   investor-data = \"Ecart.investorData\"\n                   title=\"Ecart.sidebarTitle\"\n                   update-info = \"Ecart.fetchCartItems()\">\n              </div>\n            </div>--></div></div></div></div></div></section><style>div i.dot {\n      display: inline-block;\n      position: relative;\n      top: -2px;\n      height: 6px;\n      margin-right: 10px;\n      width: 6px;\n      background: #d92018;\n    }\n\n\n    .info {\n      font-weight: normal;\n      font-size: 12px;\n      margin-top : 10px;\n    }\n\n    .info p {\n      margin-top : 0px !important;\n      margin-bottom: 0px !important;\n    }\n\n    .info span {\n      display: inline-block;\n      vertical-align: top;\n    }\n\n    @media only screen and (max-width: 768px) {\n      .btn-secondary-action-ecart, .btn-ecart {\n        margin-right: 50px;\n      }\n    }</style>");
$templateCache.put("app/e-cart/checkout/cartEdit.html","<div class=\"main-section clearfix\" ng-hide=EditEcart.formData.isSummaryViewEnabled><section class=\"initiate-transaction sipPurchase\" ng-init=EditEcart.init()><p class=page-title>PURCHASE</p><p></p><header><form name=fForm novalidate ng-keypress=EditEcart.handleEnter($event) autocomplete=off><div ng-class=\"{\'anything-disabled\': EditEcart.formData.dynamicData.readOnly }\" class=\"folio-check pull-left\">Existing Folio No :<select name=folio id=_first ng-disabled=true ng-required=EditEcart.isRequired><option value=\"\">{{EditEcart.formData.folioNumber}}</option></select><span class=error-input ng-show=\"EditEcart.tForm.folio.$dirty && EditEcart.tForm.folio.$invalid && EditEcart.tForm.folio.$error.required\" ng-bind=EditEcart.VALIDATE_DATA.FOLIO_REQUIRED></span></div><div class=\"pull-left or-part\">OR</div><div class=\"pull-left text-primary cursor-pointer\" ng-click=EditEcart.redirectToFolioCreation();>Proceed with a New Folio</div></form></header><fieldset ng-class=\"{\'anything-disabled\': !EditEcart.formData.folioNumber }\"><div class=content-area><form name=EditEcart.tForm novalidate autocomplete=off><div class=col-md-12><div class=\"row borderline\"><div class=\"col-md-12 row\"><table class=\"table borderless top-part\"><tr><td>Investor Name</td><td>:</td><td>{{EditEcart.folioInvestorName||EditEcart.formData.folioInvestorName}}</td></tr><tr><td>Invest through</td><td>:</td><td><div ng-class=\"{\'anything-disabled\': EditEcart.formData.dynamicData.readOnly }\" class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=EditEcart.formData.isDirect ng-disabled=!fForm.$valid ng-click=\"EditEcart.changeThroughDistributor(\'DIRECT\')\"> <span class=check></span> </span><span class=radio-label>Direct</span></div><div ng-class=\"{\'anything-disabled\': EditEcart.formData.dynamicData.readOnly }\" class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=EditEcart.formData.isThroughDistributor ng-disabled=!fForm.$valid ng-click=\"EditEcart.changeThroughDistributor(\'ARN\')\"> <span class=check></span> </span><span class=radio-label>Distributor</span></div><div ng-class=\"{\'anything-disabled\': EditEcart.formData.dynamicData.readOnly }\" class=radio-block><span class=radio><input type=radio name=investThrough ng-value=true ng-model=EditEcart.formData.isThroughRia ng-disabled=!fForm.$valid ng-change=\"EditEcart.changeThroughDistributor(\'RIA\')\"> <span class=check></span> </span><span class=radio-label>RIA</span></div></td></tr><tr ng-if=EditEcart.formData.isThroughDistributor><td></td><td></td><td><div class=col-md-3><div class=input-normal ng-class=\"{error:(EditEcart.tForm.brokerCode.$dirty&&EditEcart.tForm.brokerCode.$invalid)||(EditEcart.brokerCodeError != \'\')}\"><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=EditEcart.formData.brokerCode ng-change=EditEcart.changeDistributorCode() autocomplete=off ng-blur=\"EditEcart.searchDistributor();EditEcart.showArnLabel=false\" ng-required=!EditEcart.formData.distributorARN maxlength=10 ng-pattern=/^[0-9]{4,10}$/ ng-focus=\"EditEcart.showArnLabel=true\"> <span class=highlight></span> <span class=bar></span> <span class=arn ng-show=\"EditEcart.showArnLabel || EditEcart.formData.brokerCode\">ARN -</span><label>ARN</label><p ng-if=EditEcart.formData.brokerName class=info-primary>Distributor Name: {{EditEcart.formData.brokerName}}</p><span class=error-input ng-show=\"(EditEcart.tForm.brokerCode.$dirty && EditEcart.tForm.brokerCode.$invalid &&EditEcart.tForm.brokerCode.$error.required) && (!EditEcart.formData.distributorName)\" ng-bind=EditEcart.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(EditEcart.tForm.brokerCode.$dirty && EditEcart.tForm.brokerCode.$invalid &&EditEcart.tForm.brokerCode.$error.pattern) && (!EditEcart.formData.distributorName)\" ng-bind=EditEcart.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"EditEcart.brokerCodeError !== \'\' && !EditEcart.tForm.brokerCode.$invalid\" ng-bind=EditEcart.brokerCodeError></span></div></div><span class=\"col-md-1 or-part text-center\">OR</span><div class=col-md-3><div class=\"input-select input-normal\" ng-class=\"{error:EditEcart.tForm.distributorName.$dirty && EditEcart.tForm.distributorName.$invalid}\"><input type=text name=distributorName id=distributorName ng-change=\"EditEcart.searchDistributorByName();EditEcart.formData.isEuin=true\" ng-model=EditEcart.formData.distributorName autocomplete=off ng-required=!EditEcart.formData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><label>Search Distributor</label><drop-down list-data=EditEcart.distributorList display-key=name display-key-second=arnCode hdfc-click=EditEcart.distributorListChanged(data) model=EditEcart.formData.distributorARN for=distributorName></drop-down></div></div></td></tr><tr ng-if=EditEcart.formData.isThroughRia><td>RIA Code</td><td>:</td><td><div class=col-md-4><div class=input-normal ng-class=\"{error:(EditEcart.tForm.riaCode.$dirty && EditEcart.tForm.riaCode.$invalid)||(EditEcart.riaCodeError != \'\')}\"><input type=text name=riaCode id=riaCode ng-model=EditEcart.formData.riaBrokerCode ng-change=EditEcart.changeDistributorCode() autocomplete=off ng-blur=EditEcart.searchDistributor(); ng-required=!EditEcart.formData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span><!--<p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name: {{Transaction.formData.brokerName}}</p>--> <span class=error-input ng-show=\"(EditEcart.tForm.riaCode.$dirty && EditEcart.tForm.riaCode.$invalid &&EditEcart.tForm.riaCode.$error.required)\" ng-bind=EditEcart.VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(EditEcart.tForm.riaCode.$dirty && EditEcart.tForm.riaCode.$invalid &&EditEcart.tForm.riaCode.$error.pattern)\" ng-bind=EditEcart.VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"EditEcart.riaCodeError !== \'\' && !EditEcart.tForm.riaCode.$invalid\" ng-bind=EditEcart.riaCodeError></span></div></div></td></tr></table><fieldset ng-class=\"{\'anything-disabled\': EditEcart.isArnSuccess || EditEcart.brokerCodeError !==\'\'}\"><table class=\"table borderless top-part\"><tr ng-if=EditEcart.formData.isThroughDistributor><td></td><td></td><td><div class=col-md-3><div class=input-normal ng-class=\"{error:(EditEcart.tForm.subBrokerARN.$dirty&&EditEcart.tForm.subBrokerARN.$invalid)||(EditEcart.subBrokerCodeError !== \'\')}\"><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=EditEcart.formData.subBrokerARN ng-change=EditEcart.changeSubBrokerArn() ng-blur=EditEcart.fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>Sub Broker ARN</label><p ng-if=EditEcart.subBrokerName class=info-primary>Sub Broker Name: {{EditEcart.subBrokerName}}</p><span class=error-input ng-show=\"(EditEcart.tForm.subBrokerARN.$dirty && EditEcart.tForm.subBrokerARN.$invalid && EditEcart.tForm.subBrokerARN.$error.pattern)\" ng-bind=EditEcart.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"EditEcart.subBrokerCodeError != \'\'&& !EditEcart.tForm.subBrokerARN.$error.pattern\" ng-bind=EditEcart.subBrokerCodeError></span></div></div><span class=col-md-1></span><div class=col-md-3><div class=input-normal ng-class={error:EditEcart.tForm.subBrokerCode.$dirty&&EditEcart.tForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=EditEcart.formData.subBrokerCode autocomplete=off ng-disabled=\"!EditEcart.formData.subBrokerARN || EditEcart.subBrokerCodeError !=\'\'\" ng-required=EditEcart.formData.subBrokerARN restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<span ng-if=EditEcart.formData.subBrokerARN class=req>*</span></label><span class=error-input ng-show=EditEcart.tForm.subBrokerCode.$dirty&&EditEcart.tForm.subBrokerCode.$error.required ng-bind=EditEcart.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></td></tr><tr ng-if=EditEcart.formData.isThroughDistributor><td></td><td></td><td><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=true ng-model=EditEcart.formData.isEuin ng-click=\"EditEcart.changeThroughDistributor(EditEcart.formData.isThroughDistributor);EditEcart.isCheckedTandC=false\" required> <span class=check></span> </span><span class=radio-label>EUIN</span></div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=false ng-model=EditEcart.formData.isEuin ng-click=\"EditEcart.changeThroughDistributor(EditEcart.formData.isThroughDistributor);EditEcart.euinData.euinNameCode=\'\';\n                                         EditEcart.filterEuinList();EditEcart.isSelectedEuin = true\"> <span class=check></span> </span><span class=radio-label>EUIN Declaration</span></div></td></tr><tr ng-if=\"EditEcart.formData.isEuin != null && EditEcart.formData.isEuin === false && EditEcart.formData.isThroughDistributor\"><td></td><td></td><td><div class=checkbox><input ng-model=EditEcart.isCheckedTandC type=checkbox ng-disabled=EditEcart.formData.isEuin ng-required=\"(EditEcart.formData.brokerCode || !EditEcart.isArnSuccess) && !EditEcart.formData.isEuin\"> <i class=icon-checkbox></i> <span class=checkbox-text style=\"margin-top: -16px\">I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></div></td></tr><tr ng-if=\"EditEcart.formData.isEuin != null && EditEcart.formData.isEuin === true &&  EditEcart.formData.isThroughDistributor\"><td></td><td></td><td><div class=\"input-select input-normal selectfield\" ng-class={error:EditEcart.tForm.euin.$dirty&&EditEcart.tForm.euin.$invalid}><input type=text name=euin id=euin ng-model=EditEcart.euinData.euinNameCode ng-change=EditEcart.filterEuinList() ng-required=\"(EditEcart.formData.brokerCode || EditEcart.formData.distributorName) && !EditEcart.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Select Euin</label><!--ng-disabled=\"!Transaction.euinList.length || Transaction.isArnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\"--> <span class=error-input ng-show=\"(EditEcart.tForm.euin.$dirty&&EditEcart.tForm.euin.$error.required) || !EditEcart.isSelectedEuin\" ng-bind=EditEcart.VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=EditEcart.euinList display-key=euinName display-key-second=euinCode hdfc-click=EditEcart.selectEuin(data) model=EditEcart.formData.euin for=euin></list-drop-down></div></td></tr></table></fieldset><fieldset ng-class=\"{\'anything-disabled\': !EditEcart.formData.riaBrokerCode || EditEcart.riaCodeError !== \'\'}\"><table class=\"table borderless top-part\"><tr ng-if=EditEcart.formData.isThroughRia><td><div class=checkbox><input ng-model=EditEcart.isCheckedTandC type=checkbox ng-disabled=\"!EditEcart.formData.riaBrokerCode || EditEcart.riaCodeError !== \'\'\" ng-change=EditEcart.setTandCVariable(); ng-required=EditEcart.formData.riaBrokerCode> <i class=icon-checkbox></i> <span class=\"checkbox-text ria\" style=\"margin-top: -10px\">I/We hereby consent for providing transactions data feed, portfolio holdings, NAV etc. in respect of my/our transactions under Direct Plan to the Registered Investment Advisor (RIA) recorded against the transaction, if applicable.</span></div></td></tr></table></fieldset></div></div><div id=lumpsum-form><div class=row><label class=form-label>Add Scheme</label></div><div class=row><div class=\"col-md-3 row\"><div class=\"input-select input-normal\" ng-class=\"{error:EditEcart.tForm.pInScheme1.$dirty && EditEcart.tForm.pInScheme1.$invalid,\n      \'anything-disabled\':EditEcart.formData.dynamicData.readOnly}\"><input type=text name=pInScheme1 id=pInScheme1 ng-change=EditEcart.filterPurchaseInSchemeList() ng-model=EditEcart.formData.purchaseInSchemeName autocomplete=off ng-disabled=!fForm.$valid required> <span class=highlight></span> <span class=bar></span><label>select scheme</label><span class=error-input ng-show=\"EditEcart.tForm.pInScheme1.$dirty && EditEcart.tForm.pInScheme1.$invalid && EditEcart.tForm.pInScheme1.$error.required\" ng-bind=EditEcart.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=EditEcart.purchaseInSchemeList display-key=scheme hdfc-click=EditEcart.purchaseInSchemeChanged(data) model=EditEcart.formData.purchaseInSchemeCode for=pInScheme1></drop-down><p class=info-primary>{{EditEcart.formData.purchaseInSchemeName}}</p></div></div><div ng-if=!EditEcart.formData.dynamicData.readOnly class=\"col-md-offset-1 col-md-4 scheme-invoke\"><span>OR</span> <span class=\"text-primary cursor-pointer\" ng-click=fForm.$valid&&EditEcart.purchaseSchemeListModal()><i class=list-icon></i> Select from List</span></div></div><div class=row ng-if=\"EditEcart.formData.purchaseInvestmentOption===EditEcart.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=\"form-label less\">Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=row><div class=\"col-md-12 form-group\" ng-class=\"{\'radio-disabled\':(EditEcart.purchaseValidations.isEnabled==\'N\')}\" style=\"padding: 0\" ng-if=\"EditEcart.formData.purchaseInvestmentOption===EditEcart.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=radio-block ng-repeat=\"_option in EditEcart.devidendOptions\" ng-class=\"{\'anything-disabled\': ((_option == EditEcart.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && EditEcart.purchaseValidations.isGrowth === false && EditEcart.purchaseValidations.dividendReinvestmentApplicable === false)\n                 || (_option == EditEcart.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && EditEcart.purchaseValidations.isGrowth === false && EditEcart.purchaseValidations.dividendPayoutApplicable === false)\n                 )}\"><span class=radio><input type=radio id=pDividendOption{{_option}} ng-value=_option ng-disabled=\"!fForm.$valid\n                 || (_option == EditEcart.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && EditEcart.purchaseValidations.isGrowth === false && EditEcart.purchaseValidations.dividendReinvestmentApplicable === false)\n                 || (_option == EditEcart.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && EditEcart.purchaseValidations.isGrowth === false && EditEcart.purchaseValidations.dividendPayoutApplicable === false)\" name=pDividendOption ng-model=EditEcart.formData.purchaseDividendOption> <span class=check></span> </span><span class=radio-label>{{EditEcart.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div class=\"row form-group\" ng-if=\"EditEcart.isSchemeTypeELSS && EditEcart.formData.purchaseInvestmentOption===EditEcart.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=info-primary>IDCW Re-invest option is not applicable for ELSS</div></div><div class=row><div class=\"col-md-3 row\"><div class=\"input-normal icon-input\" ng-class=\"{error:(EditEcart.tForm.pAmount.$dirty && EditEcart.tForm.pAmount.$invalid)||(EditEcart.formData.purchaseAmount&&EditEcart.isPurchaseMin),\'has-data\':EditEcart.formData.purchaseAmount}\"><input type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=pAmount ng-model=EditEcart.formData.purchaseAmount ng-change=EditEcart.checkPurchaseValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ondrop=\"return false\" ng-disabled=!fForm.$valid required> <span class=highlight></span> <span class=bar></span><label>Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"EditEcart.tForm.pAmount.$dirty && EditEcart.tForm.pAmount.$error.required\" ng-bind=EditEcart.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"EditEcart.formData.purchaseAmount && EditEcart.isPurchaseMin\" class=error-input>{{\'Minimum amount should be \'+ EditEcart.purchaseMinAmount}}</span> <span ng-if=\"EditEcart.formData.purchaseAmount && !EditEcart.isPurchaseMin && (EditEcart.purchaseValidations.purchaseMultiple && !EditEcart.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{EditEcart.purchaseValidations.purchaseMultiple|unit}}</span></div><div class=form-group><label id=divDisplayWords>{{EditEcart.amountInWords}} (In Words)</label></div></div></div></div></div><div ng-class=\"{\'anything-disabled\': !EditEcart.formData.folioNumber }\" class=form-footer><button type=button ng-if=!EditEcart.formData.isThroughRia ng-disabled=\" !EditEcart.tForm.$valid || EditEcart.isInvalidForm || !EditEcart.formData.purchaseAmount||!EditEcart.formData.purchaseInSchemeCode || ((EditEcart.formData.brokerCode || EditEcart.formData.distributorARN) && EditEcart.isArnSuccess) || (EditEcart.formData.subBrokerARN && EditEcart.isSubarnSuccess) || !EditEcart.isSelectedEuin\" ng-click=EditEcart.updateEcartItem() class=\"btn btn-primary-action\">Update To E-cart</button> <button type=button ng-if=EditEcart.formData.isThroughRia ng-disabled=\" !EditEcart.tForm.$valid || EditEcart.isInvalidForm || !EditEcart.formData.purchaseAmount||!EditEcart.formData.purchaseInSchemeCode || !(EditEcart.formData.isThroughRia && EditEcart.formData.riaBrokerCode && EditEcart.isCheckedTandC)  \" ng-click=EditEcart.updateEcartItem() class=\"btn btn-primary-action\">Update To E-cart</button></div></form></div></fieldset></section></div>");
$templateCache.put("app/e-cart/directives/all.funds.html","<div class=\"container-fluid all-funds\"><div class=row><div class=\"col-md-12 mobile-padding\"><form><div class=row><div class=col-md-12><div class=header-container><div class=row><div class=col-md-12><div class=search><input ng-disabled=\"allFundForm.regularDirectError !== null\" type=text ng-model=allFormData.searchModel ng-change=searchRecords() class=form-control placeholder=Search aria-label=Search aria-describedby=basic-addon2> <button class=btn-sm><img src=/assets/images/icons/icon-search-white.png></button></div></div></div><div class=row><div class=\"col-xs-8 col-md-6\"><div class=radio ng-if=\"linkdata.flowName !== \'E_CART\'\"><ul><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': allFundForm.isRegular}\">Direct</span></li><li><div class=form-switch><label class=switch><input type=checkbox ng-model=allFundForm.isRegular ng-change=changeFundsListing() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': !allFundForm.isRegular}\">Regular</span></li></ul></div></div><div class=\"col-xs-4 col-md-6\"><div class=\"filter-action pull-right\"><button class=btn-sm ng-click=openFilter() ng-disabled=allFundForm.regularDirectError><img src=/assets/images/filter-red.svg> Filter</button></div></div><div class=\"col-xs-12 col-md-10\"><span class=bank-error-msg>{{allFundForm.regularDirectError}}</span></div></div></div></div></div><div class=row ng-repeat=\"fund in funds track by $index\"><div class=\"col-md-12 rel-recommend\"><p class=recommend ng-if=\"linkdata.isHdfcBank && fund.recommended\">Recommended</p><div class=cart-container><div class=row><div class=col-md-12><div class=card><div class=card-header><div class=row><div class=col-md-12><div class=investment-details>{{fund.fundName}}</div></div></div></div><div class=card-body><div class=row><div class=col-md-12><div class=fund-details><div class=blue ng-if=\"fund.fundCategory.length > 0 && fund.fundCategory[0] !=\'\'\">{{fund.fundCategory[0]}}</div><div class=riskmeter><img src=assets/images/icons/riskometer/low.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Low risk\'\"> <img src=assets/images/icons/riskometer/moderately-low.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Low to Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderate1.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderately-high.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Moderately High Risk\'\"> <img src=assets/images/icons/riskometer/very-high.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'High Risk\'\"> <img src=assets/images/icons/riskometer/high.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Very High Risk\'\"><div class=blue>{{fund.riskReturnProfile[0]}}</div></div><div class=\"blue-background white\" ng-if=fund.investorInvested>{{fund.investorInvested}}</div></div></div></div><div class=row><div class=\"col-xs-8 col-md-6\"><div class=investment-label ng-if=allFundForm.isRegular>NAV as on<span class=font-resize ng-if=fund.fundNavRegular.nav_date[11]> {{fund.fundNavRegular.nav_date[11]}}</span></div><div class=investment-label ng-if=!allFundForm.isRegular>NAV as on<span class=font-resize ng-if=fund.fundNavDirect.nav_date[11]> {{fund.fundNavDirect.nav_date[11]}}</span></div></div><div class=\"col-xs-4 col-md-6\"><div class=\"nav-amount pull-right\" ng-if=allFundForm.isRegular>&#8377{{fund.fundNavRegular.nav_amount[11] ? utilService.getCommaSeperatedWithFloatValue(fund.fundNavRegular.nav_amount[11],4): 0}}</div><div class=\"nav-amount pull-right\" ng-if=!allFundForm.isRegular>&#8377{{fund.fundNavDirect.nav_amount[11] ? utilService.getCommaSeperatedWithFloatValue(fund.fundNavDirect.nav_amount[11],4): 0}}</div></div></div><!--<hr>--><!--<div class=\"row\" ng-if=\"allFundForm.isRegular && fund.regularCagrReturns.length > 0\">\n                        <div class=\"col-xs-8 col-md-8\">\n                          <div class=\"row\">\n                            <div class=\"col-xs-3 col-md-3\">\n                              <div class=\"investment-label\">\n                                CAGR\n                              </div>\n                            </div>\n                            <div class=\"col-xs-9 col-md-8\">\n                              <div class=\"cagr-select\">\n                                <select\n                                  class=\"custom-select\"\n                                  id=\"regular-{{$index}}\"\n                                  tooltip-placement=\"top\" uib-tooltip=\"{{fund.selectedYear}}\"\n                                  ng-model = \"fund.selectedYear\"\n                                  ng-options=\"cagrReturn.key as cagrReturn.key for cagrReturn in fund.regularCagrReturns\"\n                                  ng-change=\"displayCagrValue(fund)\"\n                                ></select>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                        <div class=\"col-xs-4 col-md-4\">\n                          <div class=\"cagr-percent pull-right\">\n                            {{fund.regularCagr}}%\n                          </div>\n                        </div>\n                      </div>--><!--<div class=\"row\" ng-if=\"!allFundForm.isRegular && fund.directCagrReturns.length > 0\">\n                        <div class=\"col-xs-8 col-md-8\">\n                          <div class=\"row\">\n                            <div class=\"col-xs-3 col-md-3\">\n                              <div class=\"investment-label\">\n                                CAGR\n                              </div>\n                            </div>\n                            <div class=\"col-xs-9 col-md-8\">\n                              <div class=\"cagr-select\">\n                                <select\n                                  class=\"custom-select\"\n                                  id=\"direct-{{$index}}\"\n                                  tooltip-placement=\"top\" uib-tooltip=\"{{fund.selectedYear}}\"\n                                  ng-model = \"fund.selectedYear\"\n                                  ng-options=\"cagrReturn.key as cagrReturn.key for cagrReturn in fund.directCagrReturns\"\n                                  ng-change=\"displayCagrValue(fund)\"\n                                ></select>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                        <div class=\"col-xs-4 col-md-4\">\n                          <div class=\"cagr-percent pull-right\">\n                            {{fund.directCagr}}%\n                          </div>\n                        </div>\n                      </div>--></div><div class=card-footer><div class=row><div class=col-md-12><div class=card-action><!--<button class=\"btn btn-secondary\">Details</button>--> <button class=\"btn btn-primary\" ng-click=moveToCartDetails(fund)>Add to cart</button></div></div></div></div></div></div></div></div></div></div></form></div></div></div><div class=\"row filter-row\"><div class=col-md-12><div class=row><div class=\"col-xs-3 col-md-4 height100 backdrop\"></div><div class=\"col-xs-9 col-md-8 height100 content-col\"><section class=\"sidebar-content-section height100\"><div class=\"row height100\"><div class=col-md-12><div class=row><div class=col-md-12><div class=filter-header><h1>Filters</h1><a class=cancel-cta ng-click=openFilter()><i class=times-icon></i></a></div></div></div><div class=row><div class=col-md-12><div ng-repeat=\"filter in filterList\"><uib-accordion><div uib-accordion-group class=panel-default is-open=true><uib-accordion-heading>{{filter.filterName}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-up\': status.open, \'glyphicon-chevron-down\': !status.open}\"></i></uib-accordion-heading><div class=checkbox ng-repeat=\"option in filter.filterOptions\" ng-if=\"(linkdata && linkdata.flowName == \'E_CART\' && option.key !== \'Children Fund\') || !linkdata\"><input ng-model=option.checked type=checkbox ng-change=\"filterFunds(filter.filterKey, filter.filterOptions)\"> <i class=icon-checkbox></i><div class=option-name>{{option.key}}</div></div></div></uib-accordion></div></div></div></div></div></section></div></div></div></div>");
$templateCache.put("app/e-cart/directives/cart-details.html","<div class=\"container-fluid cart-details-container\"><div class=row><div class=col-md-12><label class=label-black>You’re investing in {{fundName}}</label></div></div><div class=row><div class=col-md-12><form name=tform><div class=row><div class=col-md-12><div class=input-field-card><div class=\"input-normal input-select\"><input type=text name=inScheme1 id=inScheme1 ng-change=filterInSchemeList() ng-model=formData.schemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off required><label>Select a Plan Option</label><span class=error-input ng-show=\"tForm.inScheme1.$dirty && tForm.inScheme1.$error.required\" ng-bind=VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=inSchemeList display-key=schemeName hdfc-click=inSchemeChanged(data) model=formData.schemeCode is-from-jan-nivesh=isFromJanNivesh is-new-user=isNewUser for=inScheme1></drop-down><!--<select class=\"custom-select select-scheme-list\" name=\"inScheme1\" id=\"inScheme1\"\n                <!--<select class=\"custom-select select-scheme-list\" name=\"inScheme1\" id=\"inScheme1\"\n                        ng-model=\"formData.schemeName\"\n                        ng-change=\"changeSelectedScheme()\"\n                        ng-options=\"scheme.schemeName as scheme.schemeName for scheme in inSchemeList\">\n                  <option value=\"\">Select a Plan Option</option>\n                </select>--></div></div></div></div><div class=row ng-if=\"formData.schemeCode && formData.isDividend\"><div class=col-md-12><div class=input-field-card><div class=\"input-normal input-select\"><input type=text id=investment name=investment ng-model=formData.investmentOptionName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off required><label>Select IDCW Option</label><span class=error-input ng-show=\"tForm.investment.$dirty && tForm.investment.$error.required\" ng-bind=VALIDATE_DATA.INVESTMENT_OPTIONS_REQUIRED></span><drop-down list-data=investmentOptions display-key=key hdfc-click=changeInvestmentOptions(data) model=formData.dividendOption for=investment></drop-down></div></div></div></div><div class=row ng-if=\"formData.schemeCode && formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\' && !(isFromJanNivesh && isNewUser)\"><div class=col-md-12><div class=\"cart-container transactions\"><div class=row><div class=\"col-xs-9 col-md-8\"><div class=\"section-title pull-left\">Purchase Transaction</div></div><div class=\"col-xs-3 col-md-4\"><div class=section-action><a class=\"red link-action\" ng-click=\"removeTransactionFromList(\'PURCHASE\')\" ng-if=\"(formData.schemeCode && formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\' ) && (formData.schemeCode && formData.sipOpted && sipValidation.sipEnabled === \'Y\')\">Remove</a></div></div></div><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=card><div class=card-body><label>Investment Amount</label><input type=text name=amount maxlength=16 ng-maxlength=16 ng-model=formData.displayAmount ng-change=\"changeInstallmentAmount(\'PURCHASE\', true)\" required><!--                          <span class=\"field-info\"> Minimum amount should be {{purchaseMinAmount}} </span>--><div><span ng-if=\"formData.amount && isPurchaseMin\" class=\"error-input purchase-amount-error\">Minimum amount should be {{purchaseMinAmount}} </span><span ng-if=\"formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)\" class=\"error-input purchase-amount-error\">Please provide amount in multiples of &#8377;{{purchaseValidation.purchaseMultiple|unit}}<span ng-if=\"formData.amount % 1 != 0\">,</span> </span><span ng-if=\"formData.amount % 1 != 0\" class=\"error-input purchase-amount-error\" ng-class=\"{errorDown: formData.amount && isPurchaseMin}\">{{\"Amount can\'t be decimal\"}}</span></div><div class=amount-button-container><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in purchaseValidation.amountArray\" ng-click=\"formData.displayAmount=amount; changeInstallmentAmount(\'PURCHASE\', true)\"><img src=../../assets/images/rupee-indian.svg>{{utilService.getCommaSeperatedString(amount)}}</button></div></div></div></div></div></div></div></div></div></div><div class=row ng-if=\"formData.schemeCode && formData.sipOpted && sipValidation.sipEnabled === \'Y\'\"><div class=col-md-12><div class=\"cart-container transactions\"><div class=row><div class=\"col-xs-9 col-md-8\"><div class=\"section-title pull-left\">SIP Transaction</div></div><div class=\"col-xs-3 col-md-4\"><div class=section-action><a class=\"red link-action\" ng-click=\"removeTransactionFromList(\'SIP\')\" ng-if=\"(formData.schemeCode && formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\' )&& (formData.schemeCode && formData.sipOpted && sipValidation.sipEnabled === \'Y\')\">Remove</a></div></div></div><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=card><div class=card-body><label>Investment Amount</label><input type=text name=amount ng-model=formData.installmentDisplayAmount ng-change=\"changeInstallmentAmount(\'SIP\',true)\" required><!--                          <span class=\"field-info\"> Minimum amount should be {{sipValidation.monMinAmt}} </span>--><div><span ng-if=\"formData.installmentAmount && isMin\" class=error-input>Minimum amount should be &#8377; {{validations.minAmount|unit}} </span><span ng-if=\"formData.installmentAmount && isMax\" class=error-input>Maximum amount should be &#8377; {{Transaction.validations.maxAmount|unit}}</span> <span ng-if=\"formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded\" class=error-input>Please Provide In multiples of &#8377; {{validations.amountMultiples|unit}} </span><span ng-show=\"formData.installmentAmount && amountExceeded\" class=error-input ng-bind=VALIDATE_DATA.AMOUNT_EXCEEDED></span></div><div class=fi-consent ng-if=sipWithFi><div class=checkbox><input ng-model=Summary.isCheckedTandC type=checkbox> <i class=checkmark></i> <span class=checkbox-text>Wish to pay First installment with your SIP Registration</span></div></div><div class=amount-button-container><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in sipValidation.amountArray\" ng-click=\"formData.installmentDisplayAmount=amount; changeInstallmentAmount(\'SIP\',true)\"><img src=../../assets/images/rupee-indian.svg>{{utilService.getCommaSeperatedString(amount)}}</button></div></div></div></div></div><div class=\"row increase-padding\"><div class=col-md-12><div class=input-field-card><div class=input-normal><label>SIP Start Date (SIP Frequency - Monthly)</label><div class=\"input-group date date-picker transaction-cal\" ng-class=\"{error:tForm.startDate.$dirty && tForm.startDate.$invalid}\" date-calendar data-viewmode={{viewMode}} data-date-default=formData.startDate data-enabled-dates=enabledStartDates data-min-date=startMinDateBiller data-max-date=startMaxDate data-on-date-change=changeStartDate data-view-date=enabledStartDates[0] data-enable=true style=\"position: relative\"><input id=startDateId type=text name=startDate ng-keyup=\"autoDate(\'startDate\')\" required> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span></span></div></div><div class=start-date-error><span class=\"error-input purchase-amount-error\" ng-if=\"formData.startDate && startDateError\">SIP Start Date is not valid. Please choose another date.</span></div></div></div></div><div class=row><div class=col-md-12><div class=input-field-card><div class=input-normal><label>SIP End Date</label><div class=\"input-group date date-picker transaction-cal\" ng-class=\"{error:tForm.endDate.$dirty && tForm.endDate.$invalid}\" date-calendar data-viewmode={{viewMode}} data-date-default=formData.endDate data-on-date-change=changeEndDate data-enabled-dates=enabledEndDates data-view-date=enabledEndDateView data-min-date=enabledEndDates[0] data-enable=true id=endDate showdefault=false><input id=endDateId type=text name=endDate placeholder=\"SIP End Date - DD-MMM-YYYY\" ng-keyup=\"autoDate(\'endDate\')\" ng-blur=checkEnableEndDate() required> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span></span></div></div><span class=error-input ng-if=\"!isEndDateFound && formData.endDate\">Invalid Date</span></div><div class=fi-consent><div class=\"checkbox checkbox-width\" ng-class=\"{\'anything-disabled\': !enabledDefaultYear}\"><input class=change-till-perpetuity ng-model=formData.isTillPerpetuity ng-change=\"changeTillPerpetuity(\'fromHtml\')\" type=checkbox ng-disabled=!enabledDefaultYear> <i class=checkmark></i> <span class=checkbox-text>Default to Year, 2099</span></div></div></div></div></div></div></div></div></div><div class=row ng-if=\"!formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\' && !(isFromJanNivesh && isNewUser)\"><div class=col-md-12><a class=\"available-transactions link-action\" ng-click=\"addTransactionFields(\'PURCHASE\'); addPurchaseClick();\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add Purchase Transaction</div></a></div></div><div class=row ng-if=\"!formData.sipOpted && sipValidation.sipEnabled === \'Y\'\"><div class=col-md-12><a class=\"available-transactions link-action\" ng-click=\"addTransactionFields(\'SIP\');\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add SIP Transaction</div></a></div></div><div class=row ng-if=\"isExceedingEmandateDate && formData.sipOpted\"><div class=\"col-xs-12 npciNote\"><!--dynamic note for emandate Ristriction--><ng-bind-html dynamic=NPCINote></ng-bind-html></div></div><div class=row><div class=\"col-md-12 text-center\"><button class=btn-primary ng-disabled=\"tform.$invalid || (isMin) || (isMax) || (formData.purchaseOpted && isPurchaseMin) || (formData.installmentAmount && amountExceeded) || (formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded) || (formData.installmentAmount && isMax) || (formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)) || (formData.amount && formData.amount % 1 != 0) || (!formData.purchaseOpted && !formData.sipOpted) || (formData.sipOpted && (!formData.endDate || !formData.startDate || startDateError)) || (formData.sipOpted && !isEndDateFound)\" ng-click=addToCart() ng-if=showAddCart>Add to Cart</button> <button class=btn-primary ng-disabled=\"tform.$invalid || (isMin) || (isMax) || (formData.purchaseOpted && isPurchaseMin) || (formData.installmentAmount && amountExceeded) || (formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded) || (formData.installmentAmount && isMax) || (formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)) || (formData.amount && formData.amount % 1 != 0) || (!formData.purchaseOpted && !formData.sipOpted) || (formData.sipOpted && (!formData.endDate || !formData.startDate || startDateError)) || (formData.sipOpted && !isEndDateFound)\" ng-click=saveCartEdited() ng-if=!showAddCart>Save</button></div></div></form></div></div></div>");
$templateCache.put("app/e-cart/directives/ecart.details.html","<div class=\"container-fluid ecart-details\"><div class=row><div class=\"col-md-12 mobile-padding\"><form><div class=row ng-repeat=\"investment in investmentList track by $index\"><div class=col-md-12><div class=cart-container><div class=row><div class=\"col-xs-7 col-md-8\"><div class=section-title>{{appConstants.ECART_CART_ITEM_NUMBER[$index]}} Investment</div></div><div class=\"col-xs-5 col-md-4\"><div class=section-action><a class=\"red link-action link-action-edit\" ng-click=removeTransactionFromList(availableTransaction.key)>Edit</a> <a class=\"red link-action\" ng-click=removeTransactionFromList(availableTransaction.key)>Remove</a></div></div></div><div class=row><div class=col-md-12><div class=card><div class=card-body><div class=row><div class=\"col-xs-8 col-md-6\"><div class=investment-label>Scheme Name</div><div class=investment-details>{{investment.schemeName}}</div></div><div class=\"col-xs-4 col-md-6\"><div class=investment-label>CAGR</div><div class=investment-details>{{investment.CAGR}}%</div></div></div><hr><div class=row><div class=\"col-xs-8 col-md-6\"><div class=investment-label>Investment Type</div><div class=investment-details ng-if=\"investment.sipOpted && !investment.purchaseOpted\">SIP</div><div class=investment-details ng-if=\"investment.purchaseOpted && !investment.sipOpted\">Purchase</div><div class=investment-details ng-if=\"investment.sipOpted && investment.purchaseOpted\">Purchase + SIP</div></div><div class=\"col-xs-4 col-md-6\"><div class=investment-label>Amount</div><div class=investment-details ng-if=\"investment.sipOpted && !investment.purchaseOpted\">{{\'₹\' + utilService.getCommaSeperatedString(investment.installmentAmount)}}</div><div class=investment-details ng-if=\"investment.purchaseOpted && !investment.sipOpted\">{{\'₹\' + utilService.getCommaSeperatedString(investment.amount)}}</div><div class=investment-details ng-if=\"investment.sipOpted && investment.purchaseOpted\">{{\'₹\' + utilService.getCommaSeperatedString((investment.amount + investment.installmentAmount))}}</div></div></div></div></div></div></div></div></div></div><div class=row ng-repeat=\"suggestion in suggestionList track by $index\" ng-if=\"investmentList.length < 3\"><div class=col-md-12><div class=cart-container><div class=row><div class=col-md-12><div class=card><div class=card-body><div class=row><div class=col-md-12><div class=suggestion-label>Would you like to add <i class=red>{{suggestion.fund}}</i> to your cart?</div></div></div><hr><div class=row><div class=\"col-xs-6 col-md-6\"><div class=\"row display-flex\"><div class=\"col-xs-6 col-md-6\"><div class=investment-label>CAGR</div><div class=investment-details>{{suggestion.cagrValue}}%</div></div><div class=\"col-xs-6 col-md-6\"><div class=cagr-select><select class=custom-select ng-model=formData.yearSelected ng-options=\"cagrReturn.key as cagrReturn.key for cagrReturn in suggestion.cagrReturns\" ng-change=showCagrValue($index)></select></div></div></div></div><div class=\"col-xs-6 col-md-6\"><div class=investment-label>Risk Rating</div><div class=investment-details><div class=riskmeter><img src=assets/images/icons/riskometer/very-high.svg alt={{suggestion.riskType}}><div>{{suggestion.riskType}}</div></div></div></div></div></div></div></div></div></div></div></div><div class=row ng-if=\"investmentList.length < 3\"><div class=col-md-12><div class=cart-container><div class=row><div class=\"col-xs-12 col-md-12\"><div class=card><div class=row><div class=col-md-12><div class=addmore-fund-section><a class=\"available-transactions link-action\" ng-click=addTransactionFields(transaction);><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label black\" ng-click=\"setSideBarState(\'ALL_FUNDS\')\">Add More Funds</div></a><div class=sub-heading>You can add maximum three items to the cart</div></div></div></div></div></div></div></div></div></div><div class=row><div class=\"col-md-12 text-center\"><div class=action-container><button class=btn-primary ng-click=redirectToSummary()>Continue to Pay</button></div></div></div></form></div></div></div>");
$templateCache.put("app/e-cart/directives/invest-through.html","<div class=\"container-fluid invest-through-container\"><div class=row><div class=\"col-md-12 mobile-padding\"><form name=tForm novalidate autocomplete=off><div class=row><div class=col-md-12><div class=radio-block-container><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isDirect ng-click=\"changeThroughDistributor(\'DIRECT\')\"> <span class=check></span> </span><span class=radio-label>Direct</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isThroughDistributor ng-click=\"changeThroughDistributor(\'DISTRIBUTOR\')\"> <span class=check></span> </span><span class=radio-label>Distributor</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isThroughRia ng-click=\"changeThroughDistributor(\'RIA\')\"> <span class=check></span> </span><span class=radio-label>RIA</span></div></div></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal><label>ARN <span class=\"req text-red\" ng-if=!investThroughFormData.distributorName>*</span></label><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=investThroughFormData.brokerCode ng-change=changeDistributorCode() autocomplete=off ng-blur=searchDistributor(); ng-required=!investThroughFormData.distributorARN maxlength=10 ng-pattern=/^[0-9]{4,10}$/ > <span class=highlight></span> <span class=bar></span><p ng-if=investThroughFormData.brokerName class=info-primary>Distributor Name: {{investThroughFormData.brokerName}}</p><span class=error-input ng-show=\"(tForm.brokerCode.$dirty && tForm.brokerCode.$invalid &&tForm.brokerCode.$error.required) && (!investThroughFormData.distributorName)\" ng-bind=VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(tForm.brokerCode.$dirty && tForm.brokerCode.$invalid && tForm.brokerCode.$error.pattern) && (!investThroughFormData.distributorName)\" ng-bind=VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"brokerCodeError !== \'\' && !tForm.brokerCode.$invalid\" ng-bind=brokerCodeError></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-md-12 text-center\"><label class=label-black>OR</label></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.distributorName.$dirty&&tForm.distributorName.$invalid)}><label>Search Distributor <span class=\"req text-red\" ng-if=!investThroughFormData.brokerCode>*</span></label><input type=text name=distributorName id=distributorName ng-model=investThroughFormData.distributorName ng-change=searchDistributorByName() autocomplete=off ng-required=!investThroughFormData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><drop-down list-data=distributorList display-key=name display-key-second=arnCode hdfc-click=distributorListChanged(data) model=investThroughFormData.distributorARN for=distributorName></drop-down></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.subBrokerARN.$dirty&&tForm.subBrokerARN.$invalid)}><label>Search Broker ARN</label><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=investThroughFormData.subBrokerARN ng-change=changeSubBrokerArn() ng-blur=fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><p ng-if=subBrokerName class=info-primary>Sub Broker Name: {{subBrokerName}}</p><span class=error-input ng-show=\"(tForm.subBrokerARN.$dirty && tForm.subBrokerARN.$invalid && tForm.subBrokerARN.$error.pattern)\" ng-bind=VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"subBrokerCodeError != \'\'&& !tForm.subBrokerARN.$error.pattern\" ng-bind=subBrokerCodeError></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.brokerCode.$dirty&&tForm.brokerCode.$invalid)}><label>Sub Broker Code</label><input type=text name=subBrokerCode id=subBrokerCode ng-model=investThroughFormData.subBrokerCode autocomplete=off ng-disabled=\"!investThroughFormData.subBrokerARN || subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=tForm.subBrokerCode.$dirty&&tForm.subBrokerCode.$error.required ng-bind=VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=col-md-12><div class=radio-block-container><div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=true ng-model=investThroughFormData.isEuin ng-click=\"investThroughFormData.isCheckedTandC=false\" ng-init=\"isSelectedEuin = false;\" required> <span class=check></span> </span><span class=radio-label>EUIN</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=false ng-model=investThroughFormData.isEuin ng-click=\"investThroughFormData.euinNameCode=\'\';filterEuinList();isSelectedEuin=true;\"> <span class=check></span> </span><span class=radio-label>EUIN Declaration</span></div></div></div></div></div><div class=row ng-if=\"investThroughFormData.isEuin != null && investThroughFormData.isEuin === true && investThroughFormData.isThroughDistributor\"><div class=\"col-sm-12 col-md-9\"><div class=\"input-select input-normal selectfield\" ng-class={error:tForm.euin.$dirty&&tForm.euin.$invalid}><label>Select Euin</label><input type=text name=euin id=euin ng-model=investThroughFormData.euinNameCode ng-change=filterEuinList() ng-required=\"(investThroughFormData.brokerCode || investThroughFormData.distributorName) && !investThroughFormData.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=(tForm.euin.$dirty&&tForm.euin.$error.required) ng-bind=VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=euinList display-key=euinName display-key-second=euinCode hdfc-click=selectEuin(data) model=investThroughFormData.euin for=euin></list-drop-down></div></div></div><div class=row ng-if=\"investThroughFormData.isEuin != null && investThroughFormData.isEuin === false && investThroughFormData.isThroughDistributor\" ng-hide=!distributorMessage><div class=col-md-12><div class=checkbox><input ng-model=investThroughFormData.isCheckedTandC type=checkbox ng-disabled=investThroughFormData.isEuin ng-required=\"(investThroughFormData.brokerCode || !isArnSuccess) && !investThroughFormData.isEuin\"> <i class=icon-checkbox></i><ng-bind-html class=bind-html ng-bind-html=distributorMessage.content></ng-bind-html></div></div></div><!------------------------- RIA section starts from here------------------><div class=row ng-if=investThroughFormData.isThroughRia><div class=\"col-sm-12 col-md-9\"><div class=input-normal><label>RIA Code <span class=\"req text-red\">*</span></label><input type=text name=riaCode id=riaCode ng-model=investThroughFormData.riaBrokerCode ng-change=changeDistributorCode() autocomplete=off ng-blur=searchDistributor(); ng-required=!investThroughFormData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span><p ng-if=\"investThroughFormData.riaBrokerCode && investThroughFormData.riaBrokerName\" class=info-primary>RIA Name: {{investThroughFormData.riaBrokerName}}</p><span class=error-input ng-show=\"(tForm.riaCode.$dirty && tForm.riaCode.$invalid &&tForm.riaCode.$error.required)\" ng-bind=VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(tForm.riaCode.$dirty && tForm.riaCode.$invalid &&tForm.riaCode.$error.pattern)\" ng-bind=VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"riaCodeError !== \'\' && !tForm.riaCode.$invalid\" ng-bind=riaCodeError></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughRia><div class=col-md-12><div class=checkbox><input ng-model=investThroughFormData.isCheckedTandC type=checkbox ng-disabled=\"!investThroughFormData.riaBrokerCode || riaCodeError !== \'\'\" ng-change=setTandCVariable(); ng-required=investThroughFormData.riaBrokerCode> <i class=icon-checkbox></i><ng-bind-html class=bind-html ng-bind-html=riaMessage.content></ng-bind-html></div></div></div><div class=row><div class=\"col-md-12 text-center\"><button class=btn-primary ng-if=!investThroughFormData.isThroughDistributor ng-disabled=\"investThroughFormData.isThroughRia && (!investThroughFormData.riaBrokerCode || !investThroughFormData.isCheckedTandC)\" ng-click=updateCartViaInvestThrough()>Save</button> <button class=btn-primary ng-if=investThroughFormData.isThroughDistributor ng-disabled=\"(!investThroughFormData.brokerCode && !investThroughFormData.distributorName) || (investThroughFormData.isEuin && !investThroughFormData.euinNameCode)\n              || (!investThroughFormData.isEuin && !investThroughFormData.isCheckedTandC) || (investThroughFormData.isEuin === true && !isSelectedEuin)\" ng-click=updateCartViaInvestThrough()>Save</button></div></div></form></div></div></div>");
$templateCache.put("app/e-cart/directives/sidebar.directive.html","<div class=\"col-sm-6 col-md-8 height100 backdrop\"></div><div class=\"col-sm-6 col-md-4 height100 content-col\" id=scrollTo ng-init=init()><section class=sidebar-content-section><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=header-section><a class=cancel-cta ng-click=collapse()><img src=assets/images/icons/cross-circle.svg alt=collapse></a><h3>{{sidebarTitle}}</h3></div><div class=body-section><div data-ng-switch=sidebarSection><div data-ng-switch-when=CART_DETAILS><div data-ng-include=\"\'app/e-cart/directives/cart-details.html\'\"></div></div><div data-ng-switch-when=INVEST_THROUGH><div data-ng-include=\"\'app/e-cart/directives/invest-through.html\'\"></div></div><div data-ng-switch-when=ECART><div data-ng-include=\"\'app/e-cart/directives/ecart.details.html\'\"></div></div><div data-ng-switch-when=ALL_FUNDS><div data-ng-include=\"\'app/e-cart/directives/all.funds.html\'\"></div></div></div></div></div></div></div></div></section></div>");
$templateCache.put("app/e-cart/ecart-payment/ecart-payment-screen.html","<section class=\"main-section clearfix payment-screen payment-screen-ecart\" ng-init=Payment.init()>{{vm.paymentOptions}}<h3 class=page-title>Please Select a Payment Method</h3><section class=content-area><header><!--      <div class=\"col-md-3\" ng-if=\"!Payment.formData.sipFirstInstallment\">--><!--        Scheme Name: <strong>{{Payment.formData.purchaseInSchemeName}}</strong>--><!--      </div>--><!--      <div class=\"col-md-3\" ng-if=\"Payment.formData.sipFirstInstallment\">--><!--        Scheme Name: <strong>{{Payment.formData.inSchemeName}}</strong>--><!--      </div>--><div class=col-md-4 ng-if=\"!Payment.formData.sipFirstInstallment && Payment.formData.investmentType === \'SIPPURCHASE\'\">Pay Now: <strong><i class=grey-rupee-icon></i> {{Payment.utilService.getCommaSeperatedString(Payment.formDataPayment.purchaseAmount)}}</strong><br><label style=\"padding-top: 5px\" class=payment-details-padding>{{Payment.formDataPayment.amountInWords}} (In Words)</label><label style=\"font-size: 15px;padding-top: 5px\" class=payment-details-padding><strong>Note: Pay now is the total amount of Purchase transactions only.</strong></label></div><div class=\"col-md-4 payment-details-padding\" ng-if=\"!Payment.formData.sipFirstInstallment && Payment.formData.investmentType != \'SIPPURCHASE\' && Payment.formData.investmentType != \'SIP\'\">Pay Now: <strong><i class=grey-rupee-icon></i> {{Payment.utilService.getCommaSeperatedString(Payment.formData.amount)}}</strong><br><label style=\"padding-top: 5px\">{{Payment.formData.amountInWords}} (In Words)</label></div><div class=\"col-md-2 payment-details-padding\" ng-if=Payment.formData.sipFirstInstallment>Pay Now: <strong><i class=grey-rupee-icon></i> {{Payment.utilService.getCommaSeperatedString(Payment.formData.amount)}}</strong></div><div class=\"col-md-3 payment-details-padding\">Folio Number: <strong>{{Payment.formData.folioNumber}}</strong></div><div class=\"col-md-3 payment-details-padding\" ng-if=!Payment.formData.sipFirstInstallment>Transaction Type: <strong>Cart ({{Payment.formData.investmentType === \'SIPPURCHASE\' ? \'SIP + PURCHASE\' : Payment.formData.investmentType}})</strong></div><div class=\"col-md-4 payment-details-padding\" ng-if=Payment.formData.sipFirstInstallment>Transaction Type: <strong>SIP with 1<sup style=\"font-size: small\">st</sup> installment</strong></div></header><!--<div class=\"debit-pay-unavailable\">\n      <p>\n        Debit Card Payment Option is Discontinued.\n      </p>\n    </div>--><div class=tabheads ng-if=\"Payment.formData.investmentType ===\'SIP\'\"><div class=tabhead ng-repeat=\"_option in Payment.paymentOptions\" ng-class=\"{\'active-DEBIT\': Payment.formData.purchasePaymentOption===_option}\"><div class=radio-block><span class=radio><input type=radio id=paymentOption1{{_option}} ng-value=_option name=paymentOption ng-change=\"Payment.changedPaymentOption(\'fromHtml\')\" ng-model=Payment.formData.purchasePaymentOption><!-- ng-disabled=\"_option===Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS\"--> <span class=check></span><!--<p class=\"bottom-line\"></p>--> </span><span class=radio-label>{{_option === \'UPI\' ? Payment.sipUpiText : Payment.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div class=tabheads ng-if=\"Payment.formData.investmentType ===\'PURCHASE\'\"><div class=tabhead ng-repeat=\"_option in Payment.paymentOptions\" ng-class=\"{\'active-DEBIT\': Payment.formData.purchasePaymentOption===_option}\"><div class=radio-block><span class=radio><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-change=\"Payment.changedPaymentOption(\'fromHtml\')\" ng-model=Payment.formData.purchasePaymentOption><!-- ng-disabled=\"_option===Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS\"--> <span class=check></span><!--<p class=\"bottom-line\"></p>--> </span><span class=radio-label>{{Payment.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div class=tabheads ng-if=\"Payment.formData.investmentType ===\'SIPPURCHASE\'\"><div class=tabhead ng-repeat=\"_option in Payment.paymentOptions\" ng-class=\"{\'active-DEBIT\': Payment.formData.purchasePaymentOption===_option}\"><div class=radio-block><span class=radio><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-change=\"Payment.changedPaymentOption(\'fromHtml\')\" ng-model=Payment.formData.purchasePaymentOption><!-- ng-disabled=\"_option===Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS\"--> <span class=check></span><!--<p class=\"bottom-line\"></p>--> </span><span class=radio-label>{{_option === \'UPI\' ? Payment.sipUpiText : Payment.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><style>.main-section.payment-screen .tabheads .tabhead:last-child{display:table-cell;}</style><form autocomplete=off novalidate name=tForm><div style=\"padding: 20px\" ng-if=\"Payment.paymentOptions.length === 0\"><div class=bank-error-msg>No valid payment mode available to proceed with SIP transaction</div></div><div class=tab-body ng-if=\"Payment.paymentOptions.length !== 0\" ng-switch=Payment.formData.purchasePaymentOption><div ng-switch-when=NETBANKING><ng-bind-html dynamic=Payment.noteNetBanking.content></ng-bind-html><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><input type=text name=bank id=bank ng-model=Payment.bankInfo.bankName ng-change=Payment.changeBank() ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\" autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly> <span class=highlight></span> <span class=bar></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=Payment.changeBank() model=Payment.bankInfo for=bank></bank-drop-down><!--<select class=\"\" name=\"bank\" ng-disabled=\"!Payment.bankList\"\n                        ng-model=\"Payment.bankInfo\"\n                        ng-options=\"bank.bankName for bank in Payment.bankList\"\n                        ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\"\n                        ng-change=\"Payment.changeBank()\"\n                        easyassist-key=\"mask-element\"\n                        required>\n                  <option value=\"\" selected>\n                    {{Payment.bankList&&!Payment.bankList.length ?\'No Bank Available\':\'Select Bank\'}}\n                  </option>\n                </select>\n\n                <label ng-if=\"Payment.bankInfo\">Select Bank</label>\n                <span class=\"error-input\" ng-show=\"tForm.bank.$dirty&&tForm.bank.$error.required\"\n                      ng-bind=\"Payment.VALIDATE_DATA.BANK_REQUIRED\"></span>--></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.bankAcType.$dirty && tForm.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-init=\"Payment.formData.paymentInfo.accType=Payment.formData.paymentInfo.accType?Payment.formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.formData.paymentInfo.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><ng-bind-html dynamic=Payment.notesPayment.noteDTO.noteDTOMap.Note_Purchase_TPV.content></ng-bind-html><div class=text-red ng-if=!Payment.bankList||!Payment.bankList.length><span>In case your registered bank is not displayed, please choose other payment mode or add another bank.</span></div><!--<div class=\"row\">\n            <div class=\"col-md-12\" style=\"margin-top: 40px;\">\n              <ng-bind-html dynamic=\"Payment.notesSIP.noteDTO.noteDTOMap.Note_SIP_Review_Registration.content\">\n              </ng-bind-html>\n            </div>\n          </div>--></div><div ng-if=\"Payment.formData.investmentType !== \'SIP\' && Payment.formData.investmentType !== \'SIPPURCHASE\'\" ng-switch-when=OTM><div class=col-md-12><ng-bind-html dynamic=Payment.notesPayment.noteDTO.noteDTOMap.Note_Mix_OTM_Review.content></ng-bind-html></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><input type=text name=bank id=otmBank ng-model=Payment.bankInfo.bankName ng-change=Payment.changeBank() ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\" autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly> <span class=highlight></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.bankList display-key=bankName display-key-second=bankAcNo hdfc-click=Payment.changeBank() model=Payment.bankInfo for=otmBank></bank-drop-down></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.bankAcType.$dirty && tForm.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.formData.paymentInfo.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=\"row col-md-12\"><ng-bind-html dynamic=Payment.notesPayment.noteDTO.noteDTOMap.Note_Purchase_OTM.content></ng-bind-html></div><div class=\"row col-md-10\"><div><table class=\"table borderless otm-bank-details\" ng-if=\"(Payment.bankInfo && Payment.bankList.length)\"><tr><td>Account No:</td><td easyassist-key=mask-element>{{Payment.bankInfo.bankAcNo}}</td></tr><tr><td>OTM UMRN No:</td><td>{{Payment.bankInfo.omUmrn}}</td></tr><tr><td>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{Payment.bankInfo.maxAmount}} <span class=error-input ng-show=\"Payment.isOTMAmount && Payment.formData.amount\" ng-bind=Payment.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ECART></span></td></tr><tr><td>OTM Start Date:</td><td>{{Payment.bankInfo.omStartDate}} <span class=error-input ng-show=\"Payment.isOTMStartDate && Payment.formData.amount\" ng-bind=\"Payment.VALIDATE_DATA.DATE_START_VALIDATION_ERROR + \' \' + Payment.bankInfo.omStartDate\"></span></td></tr><tr><td>OTM Expiry Date:</td><td>{{Payment.bankInfo.omExpiryDate}}</td></tr></table></div></div></div></div><!--SIP PAYMENT MODES--><!-- STANDING INSTRUCTION --><div ng-switch-when=EC><div class=row><div class=col-md-12><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_Sip_Ecart_Review.content></ng-bind-html></div><div class=col-md-4><div class=\"input-select input-normal selectfield marginBottom\" ng-class=\"{error: tForm.bank.$dirty && tForm.bank.$invalid}\"><input type=\"text inputPayment\" name=bank id=ecbank ng-model=Payment.bankInfo.bankName autocomplete=off placeholder=\"Select Bank\" ng-required=!Payment.formData.paymentInfo only-alphabets> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"tForm.bank.$dirty && tForm.bank.$error.required\" ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=Payment.changeBank() model=Payment.bankInfo for=ecbank></bank-drop-down></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.bankAcType.$dirty && tForm.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.formData.paymentInfo.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=col-md-12 style=\"margin-top: 40px\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.NOTE_SIP_SI.content></ng-bind-html></div><div class=col-md-12><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_SIP_Review_Registration.content></ng-bind-html></div></div></div><!-- OTM --><div ng-if=\"Payment.formData.investmentType === \'SIP\' || Payment.formData.investmentType === \'SIPPURCHASE\'\" ng-switch-when=OTM><div class=row><div class=col-md-12 ng-if=\"Payment.formData.investmentType === \'SIP\'\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_Sip_Ecart_Review.content></ng-bind-html></div><div class=col-md-12 ng-if=\"Payment.formData.investmentType === \'SIPPURCHASE\'\"><ng-bind-html dynamic=Payment.notesPayment.noteDTO.noteDTOMap.Note_Mix_OTM_Review.content></ng-bind-html></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" style=\"margin-bottom: 20px\" ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><input type=text name=bank id=otmBank ng-model=Payment.bankInfo.bankName ng-change=Payment.changeBank() ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\" autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly> <span class=highlight></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.OTMbankList display-key=bankName display-key-second=bankAcNo hdfc-click=Payment.changeBank() model=Payment.bankInfo for=otmBank></bank-drop-down></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.bankAcType.$dirty && tForm.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.formData.paymentInfo.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=\"row col-md-10\" ng-if=\"(Payment.bankInfo && Payment.OTMbankList.length)\"><div><table class=\"table borderless otm-bank-details\" ng-if=\"(Payment.bankInfo && Payment.OTMbankList.length)\"><tr><td>Account No:</td><td easyassist-key=mask-element>{{Payment.bankInfo.bankAcNo}}</td></tr><tr><td>OTM UMRN No:</td><td>{{Payment.bankInfo.omUmrn}}</td></tr><tr><td>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{Payment.bankInfo.maxAmount}} <span class=error-input ng-show=\"Payment.isOTMAmount && Payment.formData.amount\" ng-bind=Payment.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ECART></span></td></tr><tr><td>OTM Start Date:</td><td>{{Payment.bankInfo.omStartDate}} <span class=error-input ng-show=\"Payment.isOTMStartDate && Payment.formData.amount && Payment.formData.investmentType === \'SIPPURCHASE\'\" ng-bind=\"Payment.VALIDATE_DATA.DATE_START_VALIDATION_ERROR + \' \' + Payment.bankInfo.omStartDate\"></span> <span class=error-input ng-show=\"Payment.isOTMStartDate && Payment.formData.amount && Payment.formData.investmentType === \'SIP\'\" ng-bind=\"Payment.VALIDATE_DATA.DATE_SIP_VALIDATION_ERROR + \' \' + Payment.bankInfo.omStartDate\"></span> <span class=error-input ng-show=\"Payment.isOTMStartDate && Payment.formData.sipFirstAmount\" ng-bind=\"Payment.VALIDATE_DATA.DATE_START_FIRST_INSTALLMENT_VALIDATION_ERROR + \' \' + Payment.bankInfo.omStartDate\"></span></td></tr><tr><td>OTM Expiry Date:</td><td>{{Payment.bankInfo.omExpiryDate}}<!--<span class=\"error-input\" ng-show=\"Payment.isOTMDate && Payment.formData.amount\"\n                            ng-bind=\"Payment.VALIDATE_DATA.EXPIRY_DATE_VALID_ERROR + \' \' + Payment.bankInfo.omExpiryDate\"></span>--> <span class=error-input ng-show=\"Payment.isOTMDate && Payment.formData.sipFirstAmount\" ng-bind=\"Payment.VALIDATE_DATA.EXPIRY_DATE_FIRST_INSTALLMENT_VALID_ERROR + \' \' + Payment.bankInfo.omExpiryDate\"></span> <span class=error-input ng-show=Payment.isOTMEndDate ng-bind=Payment.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></td></tr></table></div></div><div class=col-md-12 ng-if=\"Payment.formData.investmentType === \'SIP\'\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_SIP_Review_OTM.content></ng-bind-html></div><div class=col-md-12 ng-if=\"Payment.formData.investmentType === \'SIP\'\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_SIP_Review_Registration.content></ng-bind-html></div></div></div><!-- EMANDATE --><div class=emandate-section ng-switch-when=E-mandate><div class=row><div class=col-md-12><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_Sip_Ecart_Review.content></ng-bind-html></div></div><div ng-hide=\"(Payment.formDataPayment.emandateValidate.isEmailinValid || Payment.formDataPayment.emandateValidate.isEmailMobileinValid || Payment.formDataPayment.emandateValidate.isMobileinValid)\" class=row><div class=\"col-md-3 label-emandate\" style=\"padding-left: 15px\">Select Bank</div><div class=col-md-4><div class=siPaymentOption><div class=\"input-select input-normal selectfield marginBottomField\"><input type=text name=bank id=emandateBank ng-model=Payment.bankInfo.bankName ng-change=Payment.changeBank() ng-init=\"Payment.bankInfo = Payment.bankInfo ? Payment.bankInfo : null\" placeholder=\"Select Bank\" ng-disabled=\"Payment.showEmandateError || Payment.minStartDateLimitError || Payment.maxEndDateLimitError\" autocomplete=off only-alphabets required readonly> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"tForm.bank.$dirty && tForm.bank.$error.required && !Payment.bankInfo.bankName\" ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.EMbankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=Payment.changeBank() model=Payment.bankInfo for=emandateBank></bank-drop-down></div></div></div></div><div ng-hide=\"(Payment.formDataPayment.emandateValidate.isEmailinValid || Payment.formDataPayment.emandateValidate.isEmailMobileinValid || Payment.formDataPayment.emandateValidate.isMobileinValid)\" class=row><div class=\"col-md-3 label-emandate\" style=\"padding-left: 15px\">Authentication Mode</div><div class=col-md-4><div class=\"selectfield marginBottomField\" ng-class=\"{error: tForm.authenticationMode.$dirty && tForm.authenticationMode.$invalid}\"><label id=authModeLabel style=\"padding-bottom: 12px\" class=\"form-label less\">Authentication Mode</label><div class=\"input-select input-normal selectfield marginBottom\"><select name=authenticationMode ng-disable=!Payment.authenticationMode class=form-control ng-model=Payment.formData.paymentInfo.authMode ng-options=\"auth.text for auth in Payment.authenticationMode\" ng-change=\"Payment.formData.paymentInfo.authenticationMode = Payment.formData.paymentInfo.authMode.value\" ng-init=\"Payment.formData.paymentInfo.authMode = Payment.formData.paymentInfo.authMode ? Payment.formData.paymentInfo.authMode: null\" required><option value=\"\" selected>{{Payment.authenticationMode && !Payment.authenticationMode.length ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}</option></select><span class=error-input ng-show=\"tForm.authenticationMode.$dirty && tForm.authenticationMode.$error.required && !Payment.formData.paymentInfo.authMode\" ng-bind=Payment.VALIDATE_DATA.AUTHENTICATION_MODE_REQUIRED></span></div></div></div></div><div ng-hide=\"(Payment.formDataPayment.emandateValidate.isEmailinValid || Payment.formDataPayment.emandateValidate.isEmailMobileinValid || Payment.formDataPayment.emandateValidate.isMobileinValid)\" class=row><div class=\"col-md-3 label-emandate\" style=\"padding-left: 15px\">Mandate Amount</div><div class=col-md-4><div class=\"input-normal icon-input\" ng-class=\"{error:(Payment.tForm.eAmount.$invalid && Payment.tForm.eAmount.$dirty),\'has-data\':Payment.formData.emandateAmount}\"><input type=number ignore-mouse-wheel onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" name=eAmount ng-model=Payment.formData.emandateAmount ng-change=Payment.checkAmountValidationEmandate() ng-maxlength=10 limit-to=10 required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><div class=amtWords ng-if=Payment.formData.emandateAmount><p id=amountInwordsEmandate>{{Payment.emandateWord.amountInWords}} (In Words)</p></div><!--                <span class=\"text-success\">--><!--                  Maximum allowed for e-mandate is ₹ {{Payment.mandateMaxString}}.--><!--          </span>--><div class=error-input ng-show=\"Payment.amountLess && Payment.formData.emandateAmount\">{{Payment.VALIDATE_DATA.EMANDATE_MIN_ERROR + Payment.emandateMinAmountLimit}}.</div><div class=error-input ng-show=Payment.amountMore>{{Payment.VALIDATE_DATA.EMANDATE_MAX_ERROR + Payment.mandateMaxString}}.</div><div class=error-input ng-show=\"!Payment.amountLess && Payment.isLessThanSipAmount\" ng-bind=Payment.VALIDATE_DATA.EMANDATE_SIP_AMOUNT_ERROR></div><div class=error-input ng-show=!Payment.formData.emandateAmount ng-bind=Payment.VALIDATE_DATA.MANDATE_AMOUNT_REQUIRED></div></div></div></div><div ng-hide=\"(Payment.formDataPayment.emandateValidate.isEmailinValid || Payment.formDataPayment.emandateValidate.isEmailMobileinValid || Payment.formDataPayment.emandateValidate.isMobileinValid)\" class=row><div class=\"col-md-3 label-emandate\" style=\"padding-left: 15px\">Mandate Start Date</div><div class=col-md-4 ng-if=!Payment.isReseting><div class=\"input-select input-normal input-group date date-picker transaction-cal anything-disabled\" date-calendar data-viewmode={{Payment.viewMode}} data-date-default=Payment.formData.emandateDate id=emandateStartDate data-enable=true style=\"position: relative\"><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div></div><div ng-hide=\"(Payment.formDataPayment.emandateValidate.isEmailinValid || Payment.formDataPayment.emandateValidate.isEmailMobileinValid || Payment.formDataPayment.emandateValidate.isMobileinValid)\" class=row><div class=\"col-md-3 label-emandate\" style=\"padding-left: 15px\">Mandate End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=right title={{Payment.mandateInfo}} tooltip-side=right></i></div><div class=\"sip-dates col-md-4\"><div ng-class=\"{\'anything-disabled\': !Payment.formData.emandateDate}\"><div class=form-group ng-if=!Payment.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal eEndDate\" ng-class=\"{error:Payment.tForm.endDateEmandate.$dirty && Payment.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=Payment.formData.endDateEmandate data-enabled-dates=Payment.enabledEmandateEndDatesList data-view-date=Payment.enabledEndDateView data-max-date=Payment.maxEndDateEmandate data-min-date=Payment.minEndDateEmandate data-on-date-change=Payment.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><!-- data-min-date=\"Payment.formData.minEndDate\"--> <input type=text name=endDateEmandate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span style=\"word-spacing: -1px\" class=error-input ng-show=\"Payment.formData.purchasePaymentOption === Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && Payment.sipDateLessEmandate\" ng-bind=Payment.VALIDATE_DATA.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div><div class=row><div class=col-md-12 ng-if=Payment.showEmandateError><span class=error-input>SIP Amount cannot be greater than Rs. {{Payment.emandateValidateData.maxAmountLimitInfo}} for Emandate payment mode</span></div><!--            <div class=\"col-md-12\" ng-if=\"Payment.minAmountLimitError\">--><!--              <span class=\"error-input\">SIP Amount cannot be less than Rs.{{Payment.emandateValidateData.minAmountLimit}} for Emandate payment mode</span>--><!--            </div>--><div class=col-md-12 ng-if=Payment.minStartDateLimitError><span class=error-input>start date cannot be earlier than Mandate start date</span></div><div class=col-md-12 ng-if=Payment.maxEndDateLimitError><span class=error-input>Mandate end date cannot be earlier than mandate start date</span></div><div class=col-md-12 ng-if=\"(Payment.formDataPayment.emandateValidate.isEmailinValid || Payment.formDataPayment.emandateValidate.isEmailMobileinValid || Payment.formDataPayment.emandateValidate.isMobileinValid)\" class=emandateError><span class=error-input ng-show=Payment.formDataPayment.emandateValidate.isMobileinValid ng-bind=Payment.VALIDATE_DATA.INVALID_MOBILE_EMANDATE></span> <span class=error-input ng-show=Payment.formDataPayment.emandateValidate.isEmailinValid ng-bind=Payment.VALIDATE_DATA.INVALID_EMAIL_EMANDATE></span> <span class=error-input ng-show=Payment.formDataPayment.emandateValidate.isEmailMobileinValid ng-bind=Payment.VALIDATE_DATA.INVALID_EMAIL_MOBILE_EMANDATE></span></div><div class=col-md-12 style=\"margin-top: 40px\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_SIP_Review_eOTM.content ng-if=\"Payment.formData.paymentInfo.authMode.value !== \'DEBIT_CARD\'\"></ng-bind-html><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_SIP_Review_eOTM_Debit_Card.content ng-if=\"Payment.formData.paymentInfo.authMode.value === \'DEBIT_CARD\'\"></ng-bind-html></div><div class=col-md-12 style=\"margin-top: 20px\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_SIP_Review_Registration.content></ng-bind-html></div></div></div><div ng-switch-when=UPI><div class=row><div class=col-md-3><div class=\"input-select input-normal selectfield\" ng-class=\"{error: tForm.bank.$dirty && tForm.bank.$invalid}\"><input type=\"text inputPayment\" name=bank id=upiBank ng-model=Payment.bankInfo.bankName autocomplete=off placeholder=\"Select Bank\" ng-required=!Payment.formData.paymentInfo only-alphabets> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"tForm.bank.$dirty && tForm.bank.$error.required\" ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=Payment.changeBank() model=Payment.bankInfo for=upiBank></bank-drop-down></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.bankAcType.$dirty && tForm.bankAcType.$invalid}\"><select class=select-box name=bankAcType ng-model=Payment.formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.formData.paymentInfo.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div ng-if=Payment.bankInfo style=\"padding: 0px\" class=\"col-md-9 ipad-view\" ng-class=\"!Payment.formData.paymentInfo.ifscCode || !Payment.formData.paymentInfo.accType ? \'col-md-12\' : \'\'\"><div class=col-md-5><div class=input-normal ng-class={error:Payment.tForm.virtualAddress.$invalid&&Payment.tForm.virtualAddress.$dirty}><input style=\"padding-top: 13px;text-transform: lowercase\" type=text ng-model=Payment.formData.virtualAddress name=virtualAddress ng-pattern=Payment.PATTERN.upi_virtual_addr_regex ng-change=Payment.handleVpa() required ng-readonly=\"Payment.formData.isUPIVerified && Payment.formData.verifyUPIResp.valid === true\" easyassist-key=mask-element><div class=bar></div><div class=highlight></div><label style=\"display: block;width: 100%\">Virtual Payment Address (UPI ID) <span class=req>*</span> <i class=edit-icon style=\"position: absolute;right: 0px; top:16px; pointer-events: all; box-sizing: content-box\" ng-if=\"Payment.formData.isUPIVerified && Payment.formData.verifyUPIResp.valid === true\" ng-click=\"Payment.formData.isUPIVerified = false\"></i></label><span class=error-input ng-show=tForm.virtualAddress.$dirty&&(tForm.virtualAddress.$error.required||tForm.virtualAddress.$error.pattern) ng-bind=Payment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!tForm.virtualAddress.$invalid\n                  &&  (!Payment.formData.isUPIVerified && Payment.formData.verifyUPIResp.valid === false)\" ng-bind=Payment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span></div></div><div class=\"col-sm-12 ipad-button\" ng-if=\"Payment.formData.purchasePaymentOption==\'UPI\' && !Payment.formData.isUPIVerified\" ng-class=\"!Payment.formData.paymentInfo.ifscCode || !Payment.formData.paymentInfo.accType ? \'col-md-2\' : \'col-md-3\'\"><button blur-on-click class=\"btn btn-primary-action\" ng-disabled=\"!Payment.formData.virtualAddress || (!Payment.formData.minorFlag && Payment.checkForMinorBankListCondition()) || (!Payment.formData.isUPIVerified && Payment.formData.verifyUPIResp.valid === false)\" ng-click=Payment.verifyVirtualUPI()>Verify</button></div><div class=\"col-sm-12 col-md-2 verify-vpa verify-ack-padding\" ng-if=\"Payment.formData.isUPIVerified && Payment.formData.verifyUPIResp.valid === true\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{Payment.formData.name}}</span></div><div class=\"col-sm-12 col-md-2 verify-vpa verify-ack-padding\" ng-if=\"!Payment.formData.isUPIVerified && Payment.formData.verifyUPIResp.valid === false\"><p><strong><span class=error-input style=\"display:inline;font-size:100%;margin-bottom: 20px\">Not Verified</span> <i class=\"cancel-icon error-input\"></i></strong></p></div></div><div class=col-md-12 ng-if=\"Payment.formData.investmentType === \'SIP\'\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_Sip_Ecart_Review.content></ng-bind-html></div><div class=col-md-12 ng-if=\"Payment.formData.investmentType === \'PURCHASE\'\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_PURCHASE_UPI.content></ng-bind-html></div><div class=col-md-12 ng-if=\"Payment.formData.investmentType === \'SIP\'\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_SIP_UPI.content></ng-bind-html></div><div class=col-md-12 ng-if=\"Payment.formData.investmentType === \'SIPPURCHASE\'\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_SIPPURCHASE_UPI.content></ng-bind-html></div><div class=col-md-12 style=\"margin-top: 40px\"><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.NOTE_SIP_SI.content></ng-bind-html></div><div class=col-md-12><ng-bind-html dynamic=Payment.notesSIP.noteDTO.noteDTOMap.Note_SIP_Review_Registration.content></ng-bind-html></div></div></div></div><div class=\"tc-block-d declaration-checkbox\" ng-if=\"Payment.paymentOptions.length !== 0\"><h6>Declaration :</h6><div class=checkbox><input id=declaration ng-model=Payment.isCheckedDeclaration type=checkbox required> <i class=icon-checkbox></i><label for=declaration>I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the bank account holders.</label></div></div><div ng-if=Payment.showTerms class=\"tc-block-d tc-block-with-link declaration-checkbox\" ng-if=\"Payment.paymentOptions.length !== 0\"><h6 class=ng-scope>Terms &amp; Conditions</h6><div><div class=checkbox><input id=isCheckedTandC ng-model=Payment.isCheckedTandC type=checkbox aria-invalid=false> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a style=\"position: relative;z-index: 9\" ng-click=Payment.showTermConditions() href=javaScript:void(0)>Terms &amp; Conditions</a> of Investment</label></div></div><br><div ng-if=\"Payment.formData.purchasePaymentOption === \'E-mandate\' && Payment.showTermsEmandate\"><div class=checkbox><input id=isCheckedTandCeMandate ng-model=Payment.isCheckedTandCeMandate type=checkbox class=\"ng-valid ng-touched ng-not-empty ng-dirty ng-valid-parse\" aria-invalid=false> <i class=icon-checkbox></i><label for=isCheckedTandCeMandate class=checkbox-text>I have read and understood <a style=\"position: relative;z-index: 9\" ng-click=Payment.showTermConditionsemandate() href=javaScript:void(0)>Terms &amp; Conditions</a> of e-mandate (eOTM)</label></div></div></div><div class=\"form-footer col-md-12 ecart-form-footer\"><span ng-click=Payment.goToBack() style=\"float: left; color: #103880;display: flex; align-items: center\" class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span> <button blur-on-click class=\"btn btn-primary-action\" ng-disabled=\"tForm.$invalid || Payment.isInvalidForm || Payment.isOTMStartDate || Payment.isOTMAmount || Payment.isOTMEndDate\n                || Payment.isOTMDate || (Payment.formData.purchasePaymentOption==Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING && Payment.bankInfo.tpvEnableFlag==\'N\'\n                || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition())) || !Payment.isCheckedTandC || (Payment.formData.purchasePaymentOption === \'E-mandate\' && (!Payment.isCheckedTandCeMandate || Payment.amountLess || Payment.amountMore || Payment.isLessThanSipAmount || Payment.sipDateLessEmandate)) || Payment.paymentOptions.length === 0 || Payment.showEmandateError || Payment.minStartDateLimitError || Payment.maxEndDateLimitError || Payment.formData.purchasePaymentOption === \'UPI\' && (!Payment.formData.isUPIVerified)\" ng-click=Payment.completePurchaseFirst($event)>{{Payment.formData.investmentType === \'SIP\' ? \'Complete Transaction\' : \'Continue to Pay\'}}</button><!--        <button blur-on-click ng-if=\"Payment.formData.purchasePaymentOption==\'UPI\'\"--><!--                class=\" btn btn-primary-action\" ng-disabled=\"tForm.$invalid || !Payment.formData.isUPIVerified || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition()) || !Payment.isCheckedTandC || Payment.paymentOptions.length === 0\"--><!--                ng-click=\"Payment.completePurchaseFirst($event)\">--><!--          {{Payment.formData.investmentType === \'SIP\' ? \'Complete Transaction\' : \'Continue to Pay\'}}--><!--        </button>--></div></form></section><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{Payment.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=Payment.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=Payment.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=Payment.billdeskPayload.msg></form><!-- Payment form commented: --><!-- with new implementation we are not using it, directly appending data from backend on billdesk url. --><!--<form autocomplete=\"off\" name=\'billdeskPayFormDebitOnly\' id=\"billdeskPayFormDebitOnly\" method=\'POST\'\n        action=\'https://www.billdesk.com/pgidsk/PGICommonGateway\'>\n    <input type=\"hidden\" name=\"msg\" ng-value=\"Payment.billDeskpayload\" id=\"msg\"/>\n    <input id=\"hidRequestId\" type=\'hidden\' name=\'hidRequestId\' value=\"PGIME1000\"/>\n    <input id=\"hidOperation\" type=\'hidden\' name=\'hidOperation\' value=\"ME100\"/>\n  </form>--><style>.checkbox{text-align: left;\n      width: 100%;\n      position: relative !important;\n    }\n    .checkbox label{\n      position: absolute;\n      top: 2px;\n      left: 3px;\n    }\n\n\n    div i.dot {\n      display: inline-block;\n      position: relative;\n      top: -2px;\n      height: 6px;\n      margin-right: 10px;\n      width: 6px;\n      background: #d92018;\n    }\n\n\n    .info {\n      font-weight: normal;\n      font-size: 12px;\n    }\n\n    .info p {\n      margin-top : 0px !important;\n      margin-bottom: 0px !important;\n    }\n\n    .info span {\n      display: inline-block;\n      vertical-align: top;\n    }\n    .toggle-select{\n      font-weight: bold;\n    }\n    .selected{\n      margin: 0px 7px 0px 7px;\n    }</style></section>");
$templateCache.put("app/e-cart/ecart-pre-login-folio/ecart-pre-login-folio.html","<div class=ecart-folio-main><div class=row><div class=\"col-sm-6 col-md-6\"><div class=left-section style=\"margin: 10px 0px 0px 30px\"><a href=\"\" class=logo-main-web><img src=assets/images/hdfcmf-Main.svg alt=\"MF online investors\" class=\"logo-main-hdfcmf pull-left\" style=\"width: 100px\"></a></div></div></div><div class=folio-dropdown-section><div class=header-section></div><div class=dropdown-section><div class=headings><div class=row><p class=\"col-xs-12 col-sm-1 col-md-1\"></p><p class=\"col-xs-12 col-sm-3 col-md-3\">Folio Number</p><p class=\"col-xs-12 col-sm-3 col-md-3\">Mobile Number</p><p class=\"col-xs-12 col-sm-5 col-md-5\">Email ID</p></div></div><div class=content><div ng-repeat=\"folios in Folio.maskedFolioList\" class=\"row folio-data\"><input class=\"col-xs-12 col-sm-1 col-md-1\" type=radio ng-model=Folio.folioNumber ng-change=Folio.chooseFolio(folios) name=folioNumber value={{folios.folioNumber}}><p class=\"col-xs-12 col-sm-3 col-md-3\">{{folios.id}}</p><p class=\"col-xs-12 col-sm-3 col-md-3\">{{folios.mobileNo}}</p><p class=\"col-xs-12 col-sm-5 col-md-5\">{{folios.email}}</p></div></div><div class=btn-section><button>Send Otp</button></div></div></div></div>");
$templateCache.put("app/e-cart/pre-login/pre-login.html","<div class=ecart-journey><header class=\"header affix instant-header container-fluid new-folio-creation-header\"><div class=\"left-item pull-left flex-style\"><a href={{Ecart.HDFC_API.WEBSITE_LINK}} target=_blank><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo></a></div><div class=timeLogout><span class=server-clock my-current-time=Ecart.format></span> <span class=sign-out ng-click=Ecart.logoutMe();>Logout</span></div></header><section class=main-section-ecart-review ng-if=!Ecart.isLoading><div class=modal-content id=loginLoader tabindex=-1><div class=\"modal-body main-loader\"><p class=blacktintLoad></p><div class=\"loader-box-content text-center\"><p><img src=../assets/images/logo-main.png alt=HDFC></p><p><img src=../assets/images/logo.png alt=\"Partner\'s Logo\"></p><h3 class=text-primary>Welcome {{Ecart.investorName || \'Investor\' | camelcase}}</h3><p>Please wait while we fetch your details.</p><img src=../assets/images/loader_web.gif alt=loader class=loader-gif><br><timer interval=1000>{{minutes}}:{{seconds}}</timer></div></div></div></section><section class=main-section-ecart-review ng-if=Ecart.isLoading><div ng-class=\"Ecart.stateTitle === \'Folio\' ? \'folio-creation-new\' : \'folio-created\'\"><div class=content-area><div ui-view></div></div></div></section><!--  <div ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div>--><footer-login></footer-login></div>");
$templateCache.put("app/e-cart/pre-login-token/pre-login-token.html","<div class=ecart-journey><header class=\"header affix instant-header container-fluid new-folio-creation-header\"><div class=\"left-item pull-left flex-style\"><a href={{Ecart.HDFC_API.WEBSITE_LINK}} target=_blank><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo></a></div></header><section class=main-section-ecart-review ng-if=!Ecart.isLoading><div class=modal-content id=loginLoader tabindex=-1><div class=\"modal-body main-loader\"><p class=blacktintLoad></p><div class=\"loader-box-content text-center\"><p><img src=../assets/images/logo-main.png alt=HDFC></p><p><img src=../assets/images/logo.png alt=\"Partner\'s Logo\"></p><h3 class=text-primary>Welcome {{EcartReview.investorName || \'Investor\' | camelcase}}</h3><p>Please wait while we fetch your details.</p><img src=../assets/images/loader_web.gif alt=loader class=loader-gif><br><timer interval=1000>{{minutes}}:{{seconds}}</timer></div></div></div></section><section class=main-section-ecart-review ng-if=Ecart.isLoading><div ng-class=\"Ecart.stateTitle === \'Folio\' ? \'folio-creation-new\' : \'folio-created\'\"><div class=content-area><div ui-view></div></div></div></section><div ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div><footer-login></footer-login></div>");
$templateCache.put("app/e-cart/review/ecart.review.html","<div class=ecart-journey><section class=sub-header><h2 class=heading-web><i class=red>E-Cart Summary</i></h2><h2 class=heading-mobile><i class=red>E-Cart Summary</i></h2></section><section class=main-container><div class=\"folio-invest-through row\"><div class=\"col-md-12 folio-selection-container\"><div class=\"row set-display-flex\"><div class=\"col-sm-6 col-md-5 folio-selection set-display-flex\"><label class=label-black>Folio No :</label><select class=\"custom-select bg-img\" name=folio id=_first ng-model=EcartReview.formData.folioNumber tooltip-placement=top uib-tooltip={{EcartReview.formData.taxStatusSelected}} class=select-folio-list ng-options=\"folio.folioNumber as folio.folioNumber for folio in EcartReview.ecartFolioList\" ng-init=\"EcartReview.formData.folioNumber=EcartReview.formData.folioNumber?EcartReview.formData.folioNumber: null\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=EcartReview.isRequired disabled><option value=\"\">Select Folio</option></select></div><div class=\"col-sm-6 col-md-7 folio-selection set-display-flex\"><label class=label-black ng-if=\"EcartReview.formData.folioNumber && EcartReview.linkdata.flowName !== \'E_CART\'\">Invest Through :</label><span ng-if=\"EcartReview.formData.folioNumber && EcartReview.investThrough === \'DIRECT\' && EcartReview.linkdata.flowName !== \'E_CART\'\">Direct</span> <span ng-if=\"EcartReview.formData.folioNumber && EcartReview.investThrough === \'DISTRIBUTOR\' && EcartReview.linkdata.flowName !== \'E_CART\'\">{{EcartReview.brokerCode}}</span> <span ng-if=\"EcartReview.formData.folioNumber && EcartReview.investThrough === \'RIA\' && EcartReview.linkdata.flowName !== \'E_CART\'\">{{EcartReview.brokerCode}}</span> <span class=\"edit-btn blue\" ng-click=\"EcartReview.showPopupScreen(\'INVEST_THROUGH\')\" ng-if=\"EcartReview.formData.folioNumber && EcartReview.investThrough && EcartReview.linkdata.flowName !== \'E_CART\'\">Edit</span> <span class=select-invest ng-click=\"EcartReview.showPopupScreen(\'INVEST_THROUGH\')\" ng-if=\"EcartReview.formData.folioNumber && !EcartReview.investThrough && EcartReview.linkdata.flowName !== \'E_CART\'\">Select Invest Through</span></div></div><div class=row ng-if=EcartReview.formData.folioError><div class=\"col-sm-6 col-md-5\"><span class=bank-error-msg style=\"margin-bottom: 0px;margin-top: 5px;font-size: 14px;margin-left: 22%\">{{EcartReview.formData.folioError}}</span></div></div></div></div><hr><div class=review-section><!--      Through MFD / RIA--><div class=row ng-if=\"EcartReview.cartItemList && EcartReview.cartItemList.length > 0 && EcartReview.linkdata.flowName == \'E_CART\'\"><div class=col-md-12><div class=\"row background-header-content-main background-blue\"><div class=col-md-6><span class=header-content>Distributor / RIA Details</span></div></div></div></div><!--      MFD / RIA Details--><div class=\"row item-row distributor-details distributor-ria\" ng-if=\"EcartReview.cartItemList && EcartReview.cartItemList.length > 0 && EcartReview.linkdata.flowName == \'E_CART\'\"><div class=col-md-12 ng-if=!EcartReview.brokerDetailsFromArn.investThroughRIA><div class=\"row investement-type\"><div class=\"col-md-8 col-xs-12 flex-items\"><span class=\"review-table-data blue\">ARN No.</span><div class=d-flex><input class=ria-pad type=text name=arn id=arn ng-model=EcartReview.brokerDetailsFromArn.brokerCode ng-disabled=true><label for=arn class=static-value>ARN-</label></div></div></div><div class=\"row investement-type\" ng-if=EcartReview.brokerDetailsFromArn.subBrokerARN><div class=\"col-md-8 col-xs-12 flex-items\"><span class=\"review-table-data blue\">Sub Broker ARN</span><div class=d-flex><input class=ria-pad type=text name=subBrokerARN id=subBrokerARN ng-model=EcartReview.brokerDetailsFromArn.subBrokerARN ng-disabled=true><label for=subBrokerARN class=static-value>ARN-</label></div></div><div class=\"col-md-4 col-xs-12 flex-items flex-ipad-view\"><span class=\"review-table-data blue hide-span\"></span><div class=\"d-flex flex-ipad-width\"><input class=ria-pad type=text name=subBrokerCode id=subBrokerCode ng-model=EcartReview.brokerDetailsFromArn.subBrokerCode ng-disabled=true><label for=subBrokerCode class=static-value>ARN-</label></div></div></div><div class=\"row investement-type\" ng-if=false><div class=\"col-md-8 col-xs-12 flex-items\"><span class=\"review-table-data blue\">EUIN</span><div class=d-flex><input class=ria-pad type=text name=arn id=arn ng-disabled=true><label for=arn class=static-value>ARN-</label></div></div></div><div class=\"row investement-type euin-investment-type\"><div class=col-md-12 style=\"margin-bottom: 15px\"><div class=radio-block-container ng-style=\"{\'align-items\' : !EcartReview.brokerDetailsFromArn.isEuin ? \'flex-start\' : \'center\'}\"><div class=dec-width><div class=radio-block><span class=radio><input type=radio name=euin ng-model=EcartReview.brokerDetailsFromArn.isEuin ng-value=true ng-disabled=EcartReview.linkdata.euin ng-change=EcartReview.resetEuinData()> <span class=check></span> </span><span class=\"radio-label blue\">EUIN</span></div></div><div class=dec-width><div class=radio-block><span class=radio><input type=radio name=euin ng-model=EcartReview.brokerDetailsFromArn.isEuin ng-value=false ng-disabled=EcartReview.linkdata.euin> <span class=check></span> </span><span class=\"radio-label blue\">EUIN Declaration</span></div></div><div class=dec-width ng-if=EcartReview.brokerDetailsFromArn.isEuin><div class=\"input-select input-normal selectfield\" style=\"width: 308px\"><input class=ria-pad type=text name=euin id=euin ng-model=EcartReview.brokerDetailsFromArn.euinNameCode ng-change=EcartReview.filterEuinList() ng-disabled=EcartReview.linkdata.euin ng-blur=EcartReview.checkEuinNameValid(EcartReview.brokerDetailsFromArn.euinNameCode) autocomplete=off style=\"padding: 5px 5px 5px 10px\"> <span class=highlight></span> <span class=bar></span><list-drop-down list-data=EcartReview.euinListARN display-key=euinName display-key-second=euinCode hdfc-click=EcartReview.selectEuin(data) model=EcartReview.brokerDetailsFromArn.euin for=euin></list-drop-down></div><span class=error-input ng-if=\"!EcartReview.valueExists && EcartReview.brokerDetailsFromArn.euinNameCode\">No EUIN Available</span></div><div class=\"checkbox dec-width\" ng-if=!EcartReview.brokerDetailsFromArn.isEuin><input ng-model=EcartReview.isCheckedTandC type=checkbox> <i class=icon-checkbox></i><ng-bind-html class=bind-html ng-bind-html=EcartReview.distributorMessage.content></ng-bind-html></div></div></div></div></div><div class=col-md-12 ng-if=EcartReview.brokerDetailsFromArn.investThroughRIA><div class=\"row investement-type\"><div class=\"col-md-8 col-xs-12 flex-items\"><span class=\"review-table-data blue\">RIA Code</span><div class=d-flex><input class=ria-pad type=text name=riaCode id=riaCode ng-model=EcartReview.brokerDetailsFromArn.riaCode ng-disabled=true></div></div></div></div><div class=\"col-md-12 ria-consent\" ng-if=EcartReview.brokerDetailsFromArn.investThroughRIA><div class=\"row investement-type\"><div class=\"col-md-12 col-xs-12 flex-items\" style=\"column-gap: 166px; padding-bottom: 16px\"><span class=\"review-table-data blue\"></span><div class=\"checkbox dec-width\"><input ng-model=EcartReview.isCheckedTandC type=checkbox> <i class=icon-checkbox></i><ng-bind-html class=bind-html ng-bind-html=EcartReview.riaMessage.content></ng-bind-html></div></div></div></div></div><div class=no-data ng-if=\"(EcartReview.cartItemList.length==0)\"><p class=strong style=\"text-align: center;font-size: 20px;padding: 2%\">No items added to your e-cart</p></div><!--review header--><div class=row ng-if=\"EcartReview.cartItemList && EcartReview.cartItemList.length > 0\"><div class=col-md-12><div class=\"row background-header-content-main background-blue\"><div class=col-md-6><span class=header-content>Scheme Name</span></div><div class=col-md-4><span class=header-content>Investment Type</span></div><div class=col-md-2><span class=header-content>Amount</span></div></div></div></div><!--review cards--><div class=\"row item-row\" ng-repeat=\"item in EcartReview.cartItemList track by $index\" ng-if=\"EcartReview.cartItemList && EcartReview.cartItemList.length > 0\"><div class=col-md-12><div class=\"row investement-type\"><div class=\"col-md-6 col-xs-7\"><span class=\"review-table-data blue\">{{EcartReview.investmentArray[$index]}} Investment</span></div><div class=\"col-md-4 hidden-xs\"></div><div class=\"col-md-2 col-xs-5 edit-responsive\"><span class=\"edit-btn red\" ng-click=\"EcartReview.showPopupScreen(\'CART_DETAILS\', item)\">Edit</span> <span class=\"edit-btn red\" ng-if=\"!(EcartReview.isFromJanNivesh && EcartReview.isNewUser)\" ng-click=EcartReview.removeCartItem(item)>Remove</span></div></div></div><div class=\"col-md-12 card-container\"><div class=\"row card-ui\"><div class=\"col-md-6 col-sm-10 col-xs-12\"><span class=responsive-title>Scheme Name</span> <span class=\"review-table-data black\">{{item.schemeName}}</span></div><div class=\"col-md-6 col-xs-12 col-sm-12 visible-xs\"><hr></div><div class=\"col-md-4 col-sm-9 col-xs-8\"><span class=responsive-title>Investment Type</span> <span class=\"review-table-data d-block black\" ng-if=item.sipOpted>SIP</span> <span class=\"review-table-data d-block black\" ng-if=item.purchaseOpted>Purchase</span></div><div class=\"col-md-2 col-sm-3 col-xs-4\"><span class=\"responsive-title amount\">Amount</span> <span class=\"review-table-data d-block black amount\" tooltip-placement=top-left uib-tooltip=\"{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(item.installmentAmount)}}\" ng-if=item.sipOpted>{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(item.installmentAmount)}}</span> <span class=\"review-table-data d-block black amount\" tooltip-placement=top-left uib-tooltip=\"{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(item.amount)}}\" ng-if=item.purchaseOpted>{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(item.amount)}}</span></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=item.errorExists><span class=bank-error-msg>{{item.message}}</span></div></div></div></div><!--review footer summary --><div class=row style=\"margin-top: 40px\" ng-if=\"EcartReview.cartItemList && EcartReview.cartItemList.length > 0\"><div class=col-md-12><div class=\"row background-header-content-secondary background-blue\"><div class=col-md-6><span class=header-content></span></div><div class=\"col-md-4 col-sm-9 col-xs-8\"><span class=header-content>Total Amount</span></div><div class=\"col-md-2 col-sm-3 col-xs-4\"><span class=\"header-content amount\" tooltip-placement=top-left uib-tooltip=\"{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(EcartReview.totalSum)}}\">{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(EcartReview.totalSum)}}</span></div></div></div></div><div class=row style=\"margin-top: 40px\"><div class=col-md-12 style=\"padding: 0px\"><div class=row><div class=col-md-6></div><div class=col-md-4></div><div class=\"col-md-2 col-xs-12\" ng-if=\"!(EcartReview.isFromJanNivesh && EcartReview.isNewUser)\"><button class=\"red add-more\" ng-click=\"EcartReview.showPopupScreen(\'ALL_FUNDS\')\" ng-class=\"{\'anything-disabled\': EcartReview.linkdata.flowName !== \'E_CART\' && (!EcartReview.formData.folioNumber || !EcartReview.investThrough)}\" ng-disabled=\"EcartReview.linkdata.flowName !== \'E_CART\' && (!EcartReview.formData.folioNumber || !EcartReview.investThrough)\" ng-if=\"EcartReview.formData.folioNumber\n                  && (EcartReview.cartItemList.length < EcartReview.cartDetails.maximumItemAllowed)\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add More</div></button> <button ng-if=\"EcartReview.cartItemList.length === 0\" class=\"red add-more\" ng-class=\"{\'anything-disabled\': EcartReview.linkdata.flowName !== \'E_CART\' && (!EcartReview.formData.folioNumber || !EcartReview.investThrough)}\" ng-disabled=\"EcartReview.linkdata.flowName !== \'E_CART\' && (!EcartReview.formData.folioNumber || !EcartReview.investThrough)\" ng-click=\"EcartReview.showPopupScreen(\'ALL_FUNDS\')\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add Funds</div></button></div></div></div></div><!--notes--><ng-bind-html dynamic=EcartReview.notesEcart.noteDTO.noteDTOMap.Note_Purchase_Review.content></ng-bind-html><ng-bind-html dynamic=EcartReview.notesEcart.noteDTO.noteDTOMap.Note_Purchase_Summary.content></ng-bind-html><div class=row style=\"margin-top: 40px\" ng-if=\"EcartReview.linkdata.flowName !== \'E_CART\'\"><div class=\"col-md-12 text-center\"><span ng-if=EcartReview.cartDetails.errorExists class=bank-error-msg style=\"text-align: center\">{{EcartReview.cartDetails.message}}</span> <button class=btn-primary ng-disabled=\"EcartReview.cartItemList.length == 0 || EcartReview.cartError || !EcartReview.investThrough\" ng-click=EcartReview.moveToPayment()><!--|| !EcartReview.kycVerifiedFlag--> Proceed</button></div></div><div class=row style=\"margin-top: 40px\" ng-if=\"EcartReview.linkdata.flowName == \'E_CART\'\"><div class=\"col-md-12 text-center\"><span ng-if=EcartReview.cartDetails.errorExists class=bank-error-msg style=\"text-align: center\">{{EcartReview.cartDetails.message}}</span> <button class=btn-primary ng-disabled=\"EcartReview.cartItemList.length == 0 || EcartReview.cartError || (EcartReview.brokerDetailsFromArn.isEuin == true && !EcartReview.brokerDetailsFromArn.euinNameCode) || (EcartReview.brokerDetailsFromArn.isEuin == false && !EcartReview.isCheckedTandC) || (EcartReview.brokerDetailsFromArn.investThroughRIA && !EcartReview.isCheckedTandC) || !EcartReview.valueExists\" ng-click=EcartReview.moveToPayment()><!--|| !EcartReview.kycVerifiedFlag--> Proceed</button></div></div></div></section><div class=sidebar-container id=sidebarContainer ng-if=EcartReview.showSideBarInvest hdfc-ecart-sidebar side-title=EcartReview.sidebarTitle invest-through=EcartReview.investThrough investor-data=EcartReview.investorData cart-item=EcartReview.cartDetails euin-declaration=EcartReview.dynamicDataSipPurchaseReview update-info=\"EcartReview.fetchCartItemList(\'invest\', data)\" is-from-jan-nivesh=EcartReview.isFromJanNivesh></div><div class=sidebar-container id=sidebarContainer ng-if=EcartReview.showSideBarCart hdfc-ecart-sidebar side-title=EcartReview.sidebarTitle investor-data=EcartReview.investorData cart-item=EcartReview.itemToBeEdited euin-declaration=EcartReview.dynamicDataSipPurchaseReview show-add-cart=EcartReview.showAddCart update-info=\"EcartReview.fetchCartItemList(\'add\')\" is-from-jan-nivesh=EcartReview.isFromJanNivesh></div><div class=sidebar-container id=sidebarContainer ng-if=EcartReview.showSideAllFunds hdfc-ecart-sidebar side-title=EcartReview.sidebarTitle investor-data=EcartReview.investorData euin-declaration=EcartReview.dynamicDataSipPurchaseReview show-add-cart=EcartReview.showAddCart update-info=\"EcartReview.fetchCartItemList(\'all\')\" is-from-jan-nivesh=EcartReview.isFromJanNivesh></div></div><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"EcartReview.expandSidebar()\">Toggle collapse Horizontally</button>\n<hr>-->");
$templateCache.put("app/firstLogin/folioDetails/folioDetails.html","<welcome-header></welcome-header><div class=investor-folio-creation ng-init=FolioDetails.init()><div class=folio-creation><div class=\"row content-header clearfix\"><div class=\"pull-left wel-name\">Welcome {{FolioDetailsParent.firstName}},<p>PAN : {{ FolioDetailsParent.panNumber }} <span>(KYC Verified)</span></p></div><div name=steps class=\"pull-right show-steps\">{{FolioDetailsParent.stepsAway}} steps away from creating a folio</div></div><div class=\"row folio-details\"><!-- Left Section Start--><section class=\"col-md-3 graphics-image\"><div ng-if=\"$state.current.name != \'folioDetails.folioCreation\'\" class=row><img src=../assets/images/graphic_bank.png alt=login class=img-responsive></div><div ng-if=\"$state.current.name == \'folioDetails.folioCreation\'\" class=row><img src=../assets/images/graphic_onboarding.png alt=login class=img-responsive></div></section><!-- Left Section End--><!-- Right Section Start--><section class=\"col-md-9 folio-details-steps\"><div ui-view></div><!--<button ng-if=\"uiState.current.name!=\'folioDetails.folioCreation\'\" type=\"button\" class=\"btn btn-primary-action\">Save</button>--></section><!-- Right Section End--></div></div></div>");
$templateCache.put("app/firstLogin/welcome/existingLogin.welcome.html","<login-header></login-header>{{FirstTimeLogin.text}}<div class=welcome-page ng-init=Welcome.init()><div class=investment-loader style=\"display: none\"><span class=loading></span></div><div class=container-fluid><div class=row><div class=\"col-md-12 welcome-header\"><div ui-view=headerWidget></div></div></div></div><div class=container><div class=row ng-repeat=\"widgets in Welcome.widgetAsPerUser track by $index\"><div class={{widget.classes}} ng-repeat=\"widget in widgets\"><div ui-view={{widget.widgetName}} class=\"height100 welcome-widgets\"></div></div></div></div></div><footer-login></footer-login><div class=visible-xs><footer class=\"container-fluid footer-logged-in\"><div class=row><div class=col-xs-12><div class=footer-data-container><span class=footer-text-common>For more info, visit <span class=footer-link><a href={{Welcome.HDFC_API.WEBSITE_LINK}} target=_blank>hdfcfund.com</a></span></span></div></div></div><div class=row><div class=col-xs-6><div class=footer-data-container><img src=assets/images/toll.svg class=\"toll-icon icon-align-footer body-img-color\"> <img src=assets/images/phoneBW.svg style=\"display: none\" class=\"toll-icon icon-align-footer body-img-bw\"> <span class=footer-text-common>1800 3010 6767 / 1800 419 7676 (Toll - Free)</span></div></div><div class=col-xs-6><div class=footer-data-container><img src=assets/images/mail.svg class=\"mail-icon-new icon-align-footer body-img-color\"> <img src=assets/images/mailBW.svg style=\"display: none\" class=\"mail-icon-new icon-align-footer body-img-bw\"> <span class=footer-text-common><a href=mailto:Hello@hdfcfund.com class=text-blue>Hello@hdfcfund.com</a></span></div></div></div><div class=row><div class=col-xs-12><div class=footer-data-container><div class=\"footer-text-common social-text-index\">FOLLOW US</div><div class=social-container-index><a href=https://www.linkedin.com/company/hdfc-mutual-fund/ target=_blank><img src=assets/images/linkedin.svg class=social-icon> </a><a href=https://twitter.com/hdfcmf target=_blank><img src=\"assets/images/Twitter Logo.svg\" class=social-icon width=26px> </a><a href=https://www.youtube.com/channel/UCiuV2NCrpHzhQogNvK1FZ_A target=_blank><img src=assets/images/youtube.svg class=social-icon></a></div></div></div></div><div class=row><div class=col-xs-12><div class=download-app-footer><div class=\"footer-text-common social-text-index\">DOWNLOAD THE APP</div><div class=social-container-index><a href=\"https://play.google.com/store/apps/details?id=com.hdfcfund.investor&hl=en_IN\" target=_blank><img src=assets/images/google-play.png class=gp-icon> </a><a href=\"https://itunes.apple.com/us/app/mfonline-investors/id1380088205?mt=8\" target=_blank><img src=assets/images/app-store.svg class=istore-icon></a></div></div></div></div><div class=row><div class=col-md-12><div class=footer-inner-wrap><div class=footer-data-container><div class=footer-copyright-text>Copyright © 2024. All rights reserved</div></div></div></div></div></footer></div><style>@media only screen and (min-width:990px){\n  .welcome-page .container > .row {\n    display: flex;\n    flex-grow:1;\n  }\n }</style>");
$templateCache.put("app/firstLogin/welcome/firstLogin.welcome.html","<div class=\"first-login height100\"><welcome-login-header></welcome-login-header><div class=\"row main-wrap first-login-height\" ng-init=Welcome.init();><div class=\"col-xs-12 new-investor-folio-background-mobile\"><div class=investor-mobile><h4>Welcome to</h4><h3><div>HDFC</div><div>Mutual Funds</div></h3></div></div><div class=\"start-folio col-xs-12 col-sm-7 col-md-7\"><div class=\"col-sm-12 col-md-6 new-investor-folio-background\"><div class=investor-content><h4>Welcome to</h4><h3><div>HDFC</div><div>Mutual</div><div>Funds</div></h3></div></div><div class=\"col-sm-12 col-md-6 new-investor-folio-right\"><div class=start-folio-right><p>Let us start by building your <span>Folio</span></p><button type=submit class=btn ng-disabled=\"Welcome.emailIdExist === false\" ng-click=Welcome.goToFirstFolioCreation();>Start Now</button></div></div></div></div><footer-login></footer-login></div><style>.more{\n\n    font-size: 20px;\n    display: block;\n    margin-bottom: -63px;\n  }</style>");
$templateCache.put("app/forgot/forgotFolio/forgotFolio.html","<div><!-- <div class=\"header-form-resp\">\n    <div class=\"back-to-login-header\"><a href=\"/\" style=\"color:#5290DB\"  ng-click=\"ForgotFolio.handleSideBarClick(\'EXISTING_USER\')\" class=\"contrastDarkFont\">\n      <img src=\"assets/images/back-arrow-icon.svg\" class=\"arrowBackIcon resp-head-icon loginBckImg\"/> Back to login</a>\n    </div>\n  </div> --><div class=\"row row-no-gutters\"><!-- <div class=\"side-nav-container col-md-3\">\n      <div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\">\n        <div class=\"col-md-12 height100\">\n          <div class=\"side-nav-wrap\">\n            <hdfc-login-sidebar sidebar-click=\"ForgotFolio.handleSideBarClick(message)\"></hdfc-login-sidebar>\n          </div>\n        </div>\n      </div>\n    </div> --><div class=\"col-sm-12 col-xs-12 widthContainer p-0\"><br><login-header></login-header><br><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=forms-container><div class=\"row row-no-gutters\"><div class=\"col-sm-12 col-md-12 form-existing-wrap res-form-exis\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=forgot-password-forms><div class=login-header><div><div style=\"display: flex;align-items: center\"><a href=javascript:void(0) ui-sref=login ng-click=\"ForgotFolio.handleSideBarClick(\'EXISTING_USER\')\" style=\"padding-bottom: 4px\"><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=\"hide-lg nonconstrastImgarrow\"> <img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=\"hide-lg constrastImgarrow\"></a><h4 ng-if=\"ForgotFolio.showOTPForm === false\" style=\"padding-bottom: 0px;font-size: 17px\">Forgot Folio</h4><h4 ng-if=\"ForgotFolio.showOTPForm === true\" style=\"padding-bottom: 0px;font-size: 17px\">Forgot Folio</h4></div><div ng-if=\"ForgotFolio.showOTPForm === true\">OTP has been sent to your registered {{ForgotFolio.selectedField === \'email\'? \"Email Id\" : \"Mobile Number\"}}.</div></div></div><div><form autocomplete=off name=forgotfolioForm ng-submit=ForgotFolio.submit() ng-if=\"ForgotFolio.showOTPForm === false\"><div class=\"input-normal pan-input-container input-web-width\" ng-class=\"{error:forgotfolioForm.pan.$dirty && forgotfolioForm.pan.$invalid}\"><input type=text name=pan maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=ForgotFolio.payload.panNumber placeholder=\"e.g. ABCDE1234A\" autofocus required capitalize style=\"border-radius: 100px;height: 48px\"><label>PAN<span class=req>*</span></label><span style=color:red ng-show=\"forgotfolioForm.pan.$dirty && forgotfolioForm.pan.$invalid\"><span class=mod-error-msg ng-show=forgotfolioForm.pan.$error.required ng-bind=ForgotFolio.validateData.PAN_REQUIRED></span><!-- <span class=\"error-input\" ng-show=\"forgotfolioForm.pan.$error.minlength\"\n                              ng-bind=\"ForgotFolio.validateData.PAN_FIELD\"></span>\n                      <span class=\"error-input\" ng-show=\"forgotfolioForm.pan.$error.maxlength\"\n                              ng-bind=\"ForgotFolio.validateData.PAN_FIELD\"></span> --> <span class=mod-error-msg ng-show=forgotfolioForm.pan.$error.pattern ng-bind=ForgotFolio.validateData.PAN_FIELD></span></span></div><p class=\"provide-details provide-resp\">Enter your registered Email ID or Mobile No to get OTP :</p><div class=\"login-form-switch switch-styling\"><span class=\"toggle-lable toggle-res-text\" style=\"padding-right: 2%\">Email ID</span><label class=switch><input type=checkbox ng-model=ForgotFolio.toggleunlock ng-change=ForgotFolio.changeFields() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label><span class=\"toggle-lable toggle-res-text\" style=\"padding-left: 2%\">Mobile No</span></div><div class=\"input-normal pan-input-container input-web-width\" ng-class=\"{error:forgotfolioForm.email.$dirty && forgotfolioForm.email.$invalid}\" ng-if=!ForgotFolio.toggleunlock><input type=email class=form-control no-focus name=email ng-pattern=ForgotFolio.pattern.email_regex ng-model=ForgotFolio.payload.email ng-disabled=\"ForgotFolio.selectedField !== \'email\'\" maxlength=150 placeholder=abc@domain.com ng-required=\"ForgotFolio.selectedField === \'email\'\" style=\"border-radius: 100px;height: 48px\"><label class=label-res>Email ID</label><span ng-show=\"forgotfolioForm.email.$dirty && forgotfolioForm.email.$invalid && forgotfolioForm.email.$touched\"><span style=\"display: block\" class=mod-error-msg ng-show=forgotfolioForm.email.$error.required ng-bind=ForgotFolio.validateData.KYC_VERIFIED_EMAIL></span> <span style=\"display: block\" class=mod-error-msg ng-show=forgotfolioForm.email.$error.pattern class=help-block ng-bind=ForgotFolio.validateData.EMAIL_FIELD></span></span></div><div class=\"input-normal pan-input-container input-web-width\" ng-if=ForgotFolio.toggleunlock ng-class=\"{error:forgotfolioForm.phone.$dirty && forgotfolioForm.phone.$invalid}\"><input type=tel class=form-control no-focus name=phone placeholder=+919876543210 ng-pattern=ForgotFolio.pattern.mobile_regex maxlength=13 ng-model=ForgotFolio.payload.mobileNumber ng-required=\"ForgotFolio.selectedField === \'mobile\'\" style=\"border-radius: 100px;height: 48px\"><label class=label-res>Mobile No.</label><span ng-show=\"forgotfolioForm.phone.$dirty && forgotfolioForm.phone.$invalid\"><span style=\"display: block\" class=mod-error-msg ng-show=forgotfolioForm.phone.$error.pattern class=help-block ng-bind=ForgotFolio.validateData.MOBILE_ISD></span></span></div><div class=\"btnContainer loginpwdBtn otp-button-placing input-web-width\"><input id=submitUserId ng-disabled=\"forgotfolioForm.$invalid || ForgotFolio.processFlag\" type=submit class=\"loginBtn btn btn-bloc res-submmit-forgot-folio loginBtnNewTheme\" value=\"Get OTP\"></div></form><form name=ForgotFolioOTPForm ng-if=\"ForgotFolio.showOTPForm === true\"><div class=\"input-normal otp-input-container otp-unlock-id\"><input type=text ng-model=ForgotFolio.otpNumber maxlength=6 autofocus required style=\"border-radius: 100px;height: 48px\"><label>Enter OTP</label><div class=input-controls ng-if=ForgotFolio.showOTPForm><timer countdown=ForgotFolio.pattern.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a href=\"\" class=\"text-blue resend\" ng-click=ForgotFolio.resendOTP() ng-class={anchorDisable:ForgotFolio.processFlagOtp} ng-show=\"countdown ==0\">Resend OTP</a></span></div></timer></div></div><div class=\"btnContainer loginpwdBtn otp-button-placing\"><input ng-disabled=\"!ForgotFolio.otpNumber || ForgotFolio.processFlagVerifyOtp\" value=Verify type=submit ng-click=ForgotFolio.verifyOTP() class=\"loginBtn btn btn-bloc loginBtnNewTheme loginBtnTheme\"> <span class=\"inputTxt forgot-folio-cancel\"><a ng-click=ForgotFolio.confirmCancel() href=javascript:void(0) tabindex=0 class=cursor-pointer>Cancel</a></span></div></form></div></div></div></div></div></div><div class=\"new-carosal-web widthContainer\"><slide-image></slide-image></div></div><!-- <footer-login></footer-login> --></div><style>.forgot-password-forms{\n    padding: 1% 10% 20px 10% !important;\n  }\n  .forms-container{\n    margin: auto;\n    margin-top: 0px;\n    width: 90%;\n  }\n  .loginBtn{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border-radius: 100px !important;\n  }\n  .form-existing-wrap{\n    border-radius: 16px;\n  }\n   @media screen and (max-width: 1024px) {\n    .forms-container{\n      margin-top: -30% !important;\n    }\n    .form-existing-wrap{\n      border-radius: 16px;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n  }\n  @media only screen and (max-width: 767px) {\n    .header-form-resp{\n    position: relative;\n    }\n    .login-header{\n      padding-top: 10px;\n    }\n  }\n  .contrastClass .forms-container{\n    background: transparent !important;\n  }</style>");
$templateCache.put("app/forgot/forgotId/forgotId.html","<!-- <login-header class=\"update-contact-header-none\"></login-header> --><!-- <div class=\"unlock-mobile-header\">\n  <div class=\"back-to-login-header\"><a href=\"/\" style=\"color:#5290DB\">\n    <img src=\"assets/images/back-arrow-icon.svg\" class=\"arrowBackIcon resp-head-icon loginBckImg\"/> Back to login</a>\n  </div>\n</div>  --><div class=\"row side-nav-main-height row-no-gutters\"><!-- <div class=\"side-nav-container col-md-3\">\n    <div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\">\n      <div class=\"col-md-12 height100\">\n        <div class=\"side-nav-wrap\">\n          <hdfc-login-sidebar sidebar-click=\"ForgotId.handleSideBarClick(message)\"></hdfc-login-sidebar>\n        </div>\n      </div>\n    </div>\n  </div> --><div class=\"col-sm-12 col-xs-12 widthContainer p-0\"><login-header></login-header><br><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=\"forms-container removeBackground\"><div class=\"row row-no-gutters removeBackground\"><div class=\"col-sm-12 col-md-12 form-existing-wrap res-form-exis removeBackground\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=forgot-password-forms><div class=login-header><div style=\"display: flex;align-items: center\"><a href=javascript:void(0) ui-sref=login style=\"padding-bottom: 4px\"><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=\"hide-lg nonconstrastImgarrow\"> <img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=\"hide-lg constrastImgarrow\"></a><h4 style=\"padding-bottom: 0px;font-size: 17px\">Forgot User ID</h4></div><div><div class=forger-subline-res style=\"padding-top: 0px\">Please provide following details to retrieve your User ID.</div></div></div><div><form autocomplete=off name=forgotId ng-submit=ForgotId.submit() class=login-form><div class=\"input-normal userID-input-container\" ng-class=\"{error:forgotId.email.$dirty && forgotId.email.$invalid}\"><input type=email no-focus name=email ng-pattern=ForgotId.pattern.email_regex ng-model=ForgotId.payload.email maxlength=150 class=\"folio-num-input input-folio-res\" placeholder=\"e.g. abc@hdfc.com\" autofocus required style=\"border-radius: 100px;height: 48px\"><label>Email ID<span class=req>*</span></label><span ng-show=\"forgotId.email.$dirty && forgotId.email.$invalid\"><span class=mod-error-msg ng-show=forgotId.email.$error.required ng-bind=ForgotId.validateData.KYC_VERIFIED_EMAIL style=\"display: block\"></span> <span class=mod-error-msg ng-show=forgotId.email.$error.pattern class=help-block ng-bind=ForgotId.validateData.EMAIL_FIELD style=\"display: block\"></span></span></div><div class=\"input-normal userpan-input-container\" ng-class=\"{error:forgotId.pan.$dirty && forgotId.pan.$invalid}\"><input type=text name=pan maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=ForgotId.payload.PAN class=\"folio-num-input input-folio-res\" placeholder=\"e.g. ABCDE1234A\" required capitalize style=\"border-radius: 100px;height: 48px\"><label>PAN<span class=req>*</span></label><span style=color:red ng-show=\"forgotId.pan.$dirty && forgotId.pan.$invalid\"><span class=mod-error-msg ng-show=forgotId.pan.$error.required ng-bind=ForgotId.validateData.PAN_REQUIRED style=\"display: block\"></span> <span class=mod-error-msg ng-show=forgotId.pan.$error.pattern ng-bind=ForgotId.validateData.PAN_FIELD style=\"display: block\"></span></span></div><div class=\"btnContainer loginpwdBtn\" ng-class=\"{\'button-placing\' : Login.showSecStep}\"><input id=submitUserId ng-disabled=forgotId.$invalid type=submit class=\"loginBtn btn btn-bloc loginBtnNewTheme\" value=SUBMIT></div></form></div></div></div></div></div></div><div class=\"col-sm-12 col-xs-12 existing-investor-carousel widthContainer p-0\"><slide-image></slide-image></div></div><!-- <footer-login></footer-login> --><style>.p-l-0{\n    padding-left: 0px !important;\n  }\n  .form-existing-wrap{\n    border-radius: 16px;\n  }\n  .forms-container .forgot-password-forms{\n    padding: 1% 10% 20px 10% !important;\n  }\n  .forms-container{\n    margin: auto !important;\n  }\n  .loginBtn{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border-radius: 100px !important;\n  }\n   @media screen and (max-width: 1024px) {\n    .existing-investor-carousel{\n      display: none;\n    }\n    .forms-container{\n      margin-top: -30% !important;\n      width: 90%;\n      margin: auto;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n    }\n    .forms-container .forgot-password-forms{\n      padding: 5% 5% 20px 5% !important;\n    }\n    .form-existing-wrap{\n      box-shadow: 0 0 5px 0 rgba(62, 76, 85, 0.4705882353);\n    }\n    .col-md-6{\n      width: 100% !important;\n    }\n  }\n  .contrastClass  .forgot-password-forms{\n    background: black;\n  }\n  .removeBackground{\n    background: none !important;\n  }\n  .forgot-password-forms{\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n    border-radius: 16px;\n  }\n  @media screen and (min-width:767px) and (max-width: 991px) {\n    .forms-container .forgot-password-forms{\n      padding: 5% 5% 20px 5% !important;\n    }\n  }\n  .contrastClass{\n    .forms-container{\n      background: transparent !important;\n    }\n  }</style>");
$templateCache.put("app/forgot/forgotPassword/forgotPassword.html","<!-- <login-header class=\"update-contact-header-none\"></login-header> --><!-- <div class=\"unlock-mobile-header\">\n  <div class=\"back-to-login-header\"><a href=\"/\" style=\"color:#5290DB\">\n    <img src=\"assets/images/back-arrow-icon.svg\" class=\"arrowBackIcon resp-head-icon loginBckImg\"/> Back to login</a>\n  </div>\n</div>  --><div class=\"side-nav-main-height row row-no-gutters\"><!-- <div class=\"side-nav-container col-md-3\">\n    <div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\">\n      <div class=\"col-md-12 height100\">\n        <div class=\"side-nav-wrap\">\n          <hdfc-login-sidebar sidebar-click=\"ForgotPassword.handleSideBarClick(message)\"></hdfc-login-sidebar>\n        </div>\n      </div>\n    </div>\n  </div> --><div class=\"col-md-6 col-sm-12 col-xs-12 p-l-0\"><!-- <login-header class=\"header-action-resp\"></login-header> --><br><login-header></login-header><br><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=forms-container><div class=\"row row-no-gutters\" style=\"background: none\"><div class=\"col-md-12 form-existing-wrap res-form-exis\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=forgot-password-forms><div class=login-header><div style=\"display: flex;align-items: center\"><a href=javascript:void(0) ui-sref=login class=contrastDarkFont style=\"padding-bottom: 4px\"><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=\"hide-lg nonconstrastImgarrow\"> <img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=\"hide-lg constrastImgarrow\"></a><h4 style=\"padding-bottom: 0px;font-size: 17px\">Forgot Password</h4></div><div class=forger-subline-res style=\"padding-top: 0px\">Please provide following details to reset your password</div></div><div><form class=forgot-password-form autocomplete=off name=forgotPwd ng-submit=ForgotPassword.submit()><div class=\"input-normal userID-input-container\" ng-class=\"{error:forgotPwd.userId.$dirty && forgotPwd.userId.$invalid}\"><input type=text no-focus name=userId ng-model=ForgotPassword.payload.userId ng-keyup=ForgotPassword.checkText() placeholder=\"Enter UserID\" autofocus required style=\"border-radius: 100px;height: 48px\"><label>User ID<span class=req>*</span></label><span ng-show=\"forgotPwd.userId.$dirty && forgotPwd.userId.$invalid\"><span class=mod-error-msg ng-show=forgotPwd.userId.$error.required ng-bind=ForgotPassword.validateData.USER_ID_REQUIRED style=\"display: block\"></span> </span><span class=mod-error-msg ng-if=ForgotPassword.invalidUserId ng-bind=ForgotPassword.validateData.INVALID_USER_ID_ERROR></span></div><div class=\"input-normal pan-input-container\" ng-class=\"{error:forgotPwd.pan.$dirty && forgotPwd.pan.$invalid}\"><input type=text name=pan maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=ForgotPassword.payload.PAN placeholder=\"Enter PAN\" required capitalize style=\"border-radius: 100px;height: 48px\"><label>User PAN<span class=req>*</span></label><span style=color:red ng-show=\"forgotPwd.pan.$dirty && forgotPwd.pan.$invalid\" style=\"display: block\"><span class=mod-error-msg ng-show=forgotPwd.pan.$error.required ng-bind=ForgotPassword.validateData.PAN_REQUIRED style=\"display: block\"></span> <span class=mod-error-msg ng-show=forgotPwd.pan.$error.pattern ng-bind=ForgotPassword.validateData.PAN_FIELD style=\"display: block\"></span></span></div><div class=\"btnContainer loginpwdBtn button-placing\"><input ng-disabled=\"forgotPwd.$invalid || ForgotPassword.processFlag || ForgotPassword.invalidUserId\" id=submitUserId type=submit class=\"btn-login btn-unlock-form loginBtn loginBtnNewTheme\" value=SUBMIT></div></form></div></div></div></div></div></div><div class=\"col-sm-12 col-md-6 existing-investor-carousel\"><slide-image></slide-image></div></div><!-- <footer-login></footer-login> --><style>.p-l-0{\n    padding-left: 0px !important;\n  }\n  .form-existing-wrap{\n    border-radius: 16px;\n    background: none;\n  }\n  .forms-container .forgot-password-forms{\n    padding: 1% 10% 20px 10% !important;\n  }\n  .loginBtn{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border-radius: 100px !important;\n  }\n  .contrastClass .row-no-gutters{\n    background: black !important;\n  }\n   @media screen and (max-width: 1024px) {\n    .existing-investor-carousel{\n      display: none;\n    }\n    .forms-container{\n      margin-top: -30% !important;\n      width: 90%;\n      margin: auto;\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n      background: none !important;\n    }\n    .forms-container .forgot-password-forms{\n      padding: 5% 5% 20px 5% !important;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      border-radius: 16px;\n    }\n    .contrastClass .forgot-password-forms{\n      padding: 5% 5% 20px 5% !important;\n      background: black;\n    }\n    .col-md-6{\n      width: 100% !important;\n    }\n  }\n  @media screen and (min-width:767px) and (max-width: 991px) {\n    .forms-container .forgot-password-forms{\n      padding: 5% 5% 20px 5% !important;\n    }\n  }</style>");
$templateCache.put("app/forgot/resetPassword/resetPassword.html","<login-header></login-header><div class=\"container-fluid global-login forgot-cred\"><div class=\"row flex-style\"><!--Left Section--><side-image-landing-page></side-image-landing-page><!--Right Section--><section class=\"col-xs-12 pull-right col-md-3 login-form\"><form autocomplete=off name=resetPwdForm ng-submit=ResetPassword.resetPassword() ng-init=\"ResetPassword.pw=\'\';pw=\'\';\"><h3>Reset Password</h3><div class=input-normal ng-class=\"{error:resetPwdForm.newPassword.$dirty && resetPwdForm.newPassword.$invalid || ResetPassword.isRequired || !ResetPassword.isMatching}\" tooltips tooltip-template=\"Password should contain minimum 8 & maximum 15 characters, atleast one capital letter, one small letter, one number and one special character($@!_)\" tooltip-show-trigger=focusin , tooltip-show-trigger=focusout tooltip-side=left><!--<input type=\"password\" ng-model=\"ResetPassword.formData.newPassword\" name=\"newPassword\" ng-pattern=\"ResetPassword.pattern.password_regex\" required maxlength=\"12\" minlength=\"8\" autocomplete=\"off\">\n          <span ng-show=\"resetPwdForm.newPassword.$dirty && resetPwdForm.newPassword.$invalid\">\n        <span class=\"error-input\" ng-show=\"resetPwdForm.newPassword.$error.required\" ng-bind=\"ResetPassword.validateData.PASSWORD_REQUIRED\"></span>\n        <span class=\"error-input\" ng-show=\"resetPwdForm.newPassword.$error.pattern\" ng-bind=\"ResetPassword.validateData.PASSWORD_FIELD\"></span>\n        <span class=\"error-input\" ng-show=\"resetPwdForm.newPassword.$error.maxlength\" ng-bind=\"ResetPassword.validateData.PASSWORD_FIELD\"></span>\n        </span>--> <input type=password ng-model=ResetPassword.formData.newPassword name=pwName id=pwId ng-change=ResetPassword.checkPattern() autocomplete=off minlength=8 maxlength=15 required> <span ng-show=\"resetPwdForm.pwName.$dirty && resetPwdForm.pwName.$invalid\"><span class=error-input ng-show=resetPwdForm.pwName.$error.required ng-bind=ResetPassword.validateData.PASSWORD_REQUIRED></span> <span class=error-input ng-show=resetPwdForm.pwName.$error.minlength ng-bind=ResetPassword.validateData.PASSWORD_MIN></span> </span><span class=error-input ng-if=!ResetPassword.isMatching ng-bind=ResetPassword.validateData.PASSWORD_FIELD></span> <span class=highlight></span> <span class=bar></span><label>Password</label><ul id=strength check-strength=pw></ul><!--  <div class=\"strength\">\n            <span class=\"common-strength strength1\"></span>\n            <span class=\"common-strength strength2\"></span>\n            <span class=\"common-strength strength3\"></span>\n            <span class=\"common-strength strength4\"></span>\n          </div>--><!-- <span class=\"conditioned-text\">8-character minimum; case sensitive</span>--></div><div class=input-normal ng-class=\"{error:resetPwdForm.confirmPassword.$dirty && resetPwdForm.confirmPassword.$invalid}\"><input type=password ng-model=ResetPassword.formData.confirmPassword ng-change=ResetPassword.checkConfirmpassword() name=confirmPassword maxlength=15 required autocomplete=off> <span ng-show=\"resetPwdForm.confirmPassword.$dirty && resetPwdForm.confirmPassword.$invalid\"><span class=error-input ng-show=resetPwdForm.confirmPassword.$error.required ng-bind=ResetPassword.validateData.CONFIRM_PASSWORD_REQUIRED></span> </span><span class=error-input ng-show=!ResetPassword.isConfirmMatched>{{ ResetPassword.validateData.PASSWORD_MATCH }}</span> <span class=highlight></span> <span class=bar></span><label>Confirm Password</label></div><button type=submit ng-disabled=\"resetPwdForm.$invalid || !ResetPassword.isMatching || !ResetPassword.isConfirmMatched\" class=\"btn btn-primary-action btn-block btn-login\">Reset Password</button></form></section></div></div><div ng-include=\"\'app/components/footer/footer-pre-login.html\'\"></div>");
$templateCache.put("app/instant-investment/login/login.html","<div class=\"height100 height-mobile-quick-invest\"><div class=\"row row-no-gutters\"><!-- <div class=\"side-nav-container col-md-3\">\n      <div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\">\n        <div class=\"col-md-12 height100\">\n          <div class=\"side-nav-wrap\">\n            <hdfc-login-sidebar sidebar-click=\"InstantLogin.handleSideBarClick(message)\"></hdfc-login-sidebar>\n          </div>\n        </div>\n      </div>\n    </div> --><div class=\"col-sm-12 widthContainer\" style=\"padding-right: 0px\"><login-header></login-header><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=\"forms-container main-form-view\"><div class=\"row row-no-gutters\"><!-- <div class=\"existing-investor-background-mobile quick-invest-mobile-margin\">\n            <img src=\"../../../assets/images/resp-quickinvest.svg\"/>\n            <div class=\"quick-invest-mobile\">\n              <h4>Now Initiate </h4>\n              <h3>SIP, Lumpsum <span class=\"changeFont\">or</span> Switch<span class=\"changeFont\"> Transaction with </span><span>Ease!</span></h3>\n            </div>\n          </div> --><div class=\"col-sm-12 col-md-12 form-existing-wrap form-existing-wrap-login d-flex justify-content-center\" ng-if=InstantLogin.panAndDobFrame><div class=\"quick-invest-forms reg-form-resp web-form-container webContainer\" style=\"padding: 0px\"><div class=login-header style=\"padding-bottom: 0%\"><span class=\"d-flex align-items-baseline\"><a ui-sref=login><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=nonconstrastImgarrow></a><a ui-sref=login><img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=constrastImgarrow></a><h4>Quick Investment</h4></span><div class=register-sub-headline>Invest quickly without logging in</div></div><div><form name=loginForm autocomplete=false novalidate class=login-form><div class=form-group ng-class=\"{error:loginForm.panNumber.$dirty && loginForm.panNumber.$invalid && loginForm.panNumber.$touched}\"><div class=password-input-container><input type=text name=panNumber maxlength=10 minlength=10 class=\"form-control input-web-width\" ng-pattern=/^[A-Z]{5}[0-9]{4}[A-Z]$/ ng-model=InstantLogin.loginPayload.panNumber capitalize ng-blur=InstantLogin.checkPanVerification() placeholder=\"e.g. ABCDE1234A\" required autocomplete=off style=\"border-radius: 100px\"><label>PAN</label><span ng-messages=loginForm.panNumber.$error ng-show=\"loginForm.panNumber.$dirty && loginForm.panNumber.$invalid\"><span class=error-input ng-message=required ng-bind=InstantLogin.validateData.PAN_REQUIRED></span> <span class=error-input ng-message=minlength ng-bind=InstantLogin.validateData.PAN_FIELD></span> <span class=error-input ng-message=maxlength ng-bind=InstantLogin.validateData.PAN_FIELD></span> <span class=error-input ng-message=pattern ng-bind=InstantLogin.validateData.PAN_FIELD></span> </span><span class=error-input ng-if=InstantLogin.invalidPanDob>{{panMessage.panMessage}}</span></div></div><div class=row><div class=\"col-xs-12 color-date\"><div class=\"password-input-container input-select input-normal input-group date date-picker dateInputReg input-web-width\" date-calendar data-enable=true data-viewmode={{InstantLogin.viewMode}} data-date-default=InstantLogin.dob data-on-date-change=InstantLogin.varifyDate maxdate=now format=DD-MM-YYYY style=\"height: 40px;\n                        border-radius: 5px\"><input class=newinvestor-dob ng-pattern=/^\\d{2}[./-]\\d{2}[./-]\\d{4}$/ ng-model=InstantLogin.typedDate id=dobId name=dob type=text autocomplete=off placeholder=DD-MM-YYYY ng-keyup=InstantLogin.autoDate() required style=\"border-radius: 100px\" easyassist-key=mask-element><label for=dobId>Date of Birth</label><span class=\"input-group-addon datepickericon\"><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png style=\"width: 18px;margin-top: 5px\"> </span><span class=error-input ng-if=InstantLogin.dateErrorMessage ng-bind=InstantLogin.dateErrorMessage></span></div></div></div><div class=\"btnContainer loginpwdBtn quick-login-button\" style=\"min-height: 50px\"><input id=submitLogin1 type=button ng-disabled=\"!InstantLogin.panVerifiedFlag || InstantLogin.loginProcessFlag || !InstantLogin.loginPayload.dob || !InstantLogin.dobtrue\" class=\"btn btn-block loginBtn loginBtnNewTheme input-web-width\" value=Proceed ng-click=InstantLogin.login()></div></form></div></div></div><div class=\"col-sm-12 col-md-12 form-existing-wrap form-existing-wrap-login\" ng-if=InstantLogin.folioFrame><div style=\"padding: 24px\"><div class=login-header style=\"font-size: 18px;padding-bottom: 0%\"><a href=javascript:void(0) ng-click=InstantLogin.backtoPanDobFrame() class=\"d-flex align-items-baseline\" style=\"align-items: center !important\"><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=nonconstrastImgarrow> <img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=constrastImgarrow> Back</a></div><div><div style=\"align-items: center;text-align: left;margin-top:20px\"><p class=folioCaption>Select any one folio to proceed with the transaction</p><div class=\"rdiv1 text-md-left text-center contrast-bg-black\" style=\"border: 1px solid gray;border-top-left-radius: 15px;border-top-right-radius: 15px;border-bottom-left-radius: 15px;border-bottom-right-radius: 15px;padding: 4px\"><div style=\"width: 100%; margin: auto;overflow: auto;scrollbar-width: thin;position: relative\"><div class=\"row setWidth\" style=\"padding: 5px;position: sticky;top: 0;left: 0;border-bottom: 1px solid gray;z-index: 1;background-color: #ffff\"><p class=\"col-xs-12 col-sm-1 col-md-1\"></p><p class=\"col-xs-12 col-sm-3 col-md-3\" style=\"font-weight: 600; font-size:13px\">Folio No.</p><p class=\"col-xs-12 col-sm-3 col-md-3 margin7\" style=\"font-weight: 600; font-size:13px\">Mobile No.</p><p class=\"col-xs-12 col-sm-5 col-md-5 margin7\" style=\"font-weight: 600; font-size:13px\">Email ID</p></div><div class=setWidth><div style=\"max-height: 200px; margin: 13px 0\"><div class=row style=\"padding: 5px\" ng-repeat=\"x in InstantLogin.loginPayload.maskedFolioList\"><div class=\"col-xs-12 col-sm-1 col-md-1\"><input type=radio ng-model=InstantLogin.folioNumber ng-change=InstantLogin.chooseFolio(x) name=folioNumber value={{x.folioNumber}}></div><p class=\"col-xs-12 col-sm-3 col-md-3\" style=font-size:13px><span ng-if=\"x.id && x.id != \'null\'\">{{x.id}}</span></p><p class=\"col-xs-12 col-sm-3 col-md-3\" style=font-size:13px><span ng-if=\"x.mobileNo && x.mobileNo != \'null\'\">{{x.mobileNo}}</span></p><p class=\"col-xs-12 col-sm-5 col-md-5\" style=font-size:13px><span ng-if=\"x.email && x.email != \'null\'\">{{x.email}}</span></p></div></div></div></div></div><!-- <p>{{SelectFolio.folioNumber}}</p> --><div style=\"margin-top: 50px;display: flex;justify-content: center\" class=col-md-12><div class=\"btnContainer quick-login-button input-web-width\" style=\"min-height: 10px;text-align: center;margin: 5px 0px 20px 0px; justify-content: center;display: flex\"><input id=submitLogin1 type=button ng-disabled=InstantLogin.isInvalid class=\"btn btn-block loginBtn loginBtnNewTheme\" style=\"background: #FD5C5E\" value=\"Send OTP\" ng-click=InstantLogin.sendOtp()></div></div></div></div></div></div><div class=\"col-sm-12 col-md-12 form-existing-wrap form-existing-wrap-login\" ng-if=InstantLogin.OTPFrame class=\"d-flex justify-content-center\"><form name=loginForm autocomplete=false novalidate class=\"login-form d-flex justify-content-center\"><div class=\"login-forms web-form-container\" style=\"min-height: 425px\"><div class=login-header><div ng-if=InstantLogin.showSecStep class=header-action><a href=javascript:void(0) ng-click=InstantLogin.showPreviousStep(); class=\"d-flex align-items-baseline\" style=\"align-items: center !important;color:black\"><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=nonconstrastImgarrow> <img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=constrastImgarrow><p>Back to Folios</p></a></div></div><div ng-if=InstantLogin.showOtpField ng-class=\"{error:loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid}\"><div class=otp-input-container><input class=\"form-control border-radius-100\" id=otpId type=text ng-model=InstantLogin.loginPayload.otp required minlength=6 maxlength=6 tabindex=13 name=otpNumber is-number autofocus autocomplete=off><label>Enter OTP</label><span class=highlight></span> <span class=bar></span><div class=input-controls ng-if=InstantLogin.showSecStep><span class=forgot><timer countdown=InstantLogin.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=InstantLogin.sendOtp();>Resend OTP</a></span></div></timer></span></div></div><span ng-show=\"loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid && loginForm.otpNumber.$pristine\"><span class=error-input ng-show=loginForm.otpNumber.$error.required ng-bind=InstantLogin.validateData.OTP_REQUIRED></span></span></div><div class=resend-otp-message ng-if=InstantLogin.showSecStep><div id=clickText class=\"form-group otpSucessText\" ng-if=InstantLogin.sentOtpRespMsg ng-bind-html=InstantLogin.sentOtpRespMsg style=\"margin-top: 16px\"></div></div><div class=\"btnContainer loginpwdBtn input-web-width\" style=\"min-height: 50px\" ng-class=\"{showOtp:InstantLogin.loginUsingOtpFlag && InstantLogin.showOtpField === false, \'button-placing\' : InstantLogin.showSecStep}\"><input id=submitLogin1 type=submit ng-hide=\"!InstantLogin.showOtpField || InstantLogin.showSecStep \" ng-disabled=\"loginForm.$invalid || InstantLogin.loginProcessFlag || !InstantLogin.showOtpField\" class=\"loginBtn btn btn-bloc inputLoginBtn loginBtnNewTheme\" ng-click=InstantLogin.loginWithOTP() tabindex=14 required value=LOGIN> <input id=submitLogin2 type=submit ng-show=InstantLogin.showSecStep ng-disabled=\"loginForm.otpNumber.$error.required || loginForm.otpNumber.$invalid || InstantLogin.loginProcessFlag || !InstantLogin.showOtpField\" ng-click=InstantLogin.loginWithOTP() tabindex=14 class=\"loginBtn btn btn-bloc inputLoginBtn loginBtnNewTheme\" value=LOGIN></div></div></form></div></div></div></div><div class=\"new-carosal-web widthContainer p-0\"><slide-image></slide-image></div></div><!-- <div class=\"mobile-footer-blue mobile-footer-blue-quick-invest\">\n    <div class=\"mobile-footer-blue-container\"\n         ng-click=\"InstantLogin.handleSideBarClick(InstantLogin.appConstants.INVESTOR_SELECTION.EXISTING_USER)\"\n         ui-sref=\"login\">\n      <img src=\"assets/images/newInvestor.svg\" class=\"investorIcon body-img-color\"/>\n      <img src=\"assets/images/existingInvestorBW.svg\" style=\"display: none;\" class=\"body-img-bw\"/>\n      <div class=\"mainmenu-text mobile-footer-blue-text\">Existing Investor</div>\n    </div>\n    <div class=\"mobile-footer-blue-container mobile-footer-seperator\"\n         ng-click=\"InstantLogin.handleSideBarClick(InstantLogin.appConstants.INVESTOR_SELECTION.NEW_INVESTOR)\"\n         ui-sref=\"newInvestor\">\n      <img src=\"assets/images/quickinvest.svg\" class=\"investorIcon mobile-footer-icon body-img-color\"/>\n      <img src=\"assets/images/ic_newinvestor2bw.svg\" style=\"display: none;\" class=\"body-img-bw\"/>\n      <div class=\"mainmenu-text mobile-footer-blue-text\">New Investor?</div>\n    </div>\n  </div> --><!-- <footer-login></footer-login> --></div><style>.datepickericon {\n      position: absolute;\n      top: 34px;\n      right: 16px;\n  }\n  .margin7{\n    margin-left:-7px\n  }\n  .changeFont{\n    font-weight: normal;\n    color: #4d5068 !important;\n  }\n  .folioCaption{\n    text-align: left;\n    margin-bottom: 20px;\n    font-size: 14px;\n    font-weight: bold;\n  }\n  .setWidth{\n    width: 120% !important;\n  }\n  .loginBtn{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border-radius: 100px !important;\n  }\n  @media (min-width: 992px) and (max-width: 1336px) {\n    .setWidth{\n      width: 180% !important;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    .forms-container .quick-invest-background .quick-invest-content h3{\n      font-size: 20px;\n    }\n    .form-existing-wrap{\n      background-color: transparent;\n    } \n  }\n  @media screen and (max-width: 1024px) {\n    .main-form-view{\n      position: absolute;\n      width: 90% !important;\n      top: 68%;\n      left: 50%;\n      padding: 25px;\n      transform: translate(-50%);\n      border-radius: 16px;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n    .forms-container .form-existing-wrap{\n      background: transparent;\n    }\n    .forms-container{\n      margin: 0px;\n    }\n    .form-existing-wrap-login{\n      margin-left: 0px;\n    }\n    .form-existing-wrap{\n      box-shadow: none;\n    }\n  }\n  @media screen and (max-width: 310px) {\n    .forms-container .quick-invest-background .quick-invest-content h3{\n      font-size: 19px;\n    }\n  }\n  @media screen and (max-width: 991px) {\n    .quick-invest-content{\n      display: block;\n    }\n  }\n  @media screen and (min-width:767px) and (max-width: 991px) {\n    .forms-container{\n      margin: 2% !important;\n    }\n    .form-existing-wrap{\n      margin-top: 10px !important;\n    }\n  }\n  @media screen and (max-width: 425px){\n    .forms-container .quick-invest-forms .login-header h4{\n      font-size: 1.5em;\n    }\n  }</style>");
$templateCache.put("app/instant-investment/purchase/chequeAcknowledgepage.html","<div><div class=main-success><div class=headersub><a class=gotohome href=javascript:void(0) ng-click=Payment.gotohome()><i class=\"home-blue-icon cursor-pointer\"></i> <strong class=\"text-blue cursor-pointer\">Go To Home</strong></a><div><img src=assets/images/thumbs-succes.png></div><div>Transaction Completed Successfully!</div></div><div class=body-section><div><strong>Payment Summary</strong></div><div><div>Folio Number: <strong>{{Payment.summaryData.folioNumber}}</strong></div><div>Payment Method: <strong>{{Payment.summaryData.paymentMethod}}</strong></div><div>Total Amount (INR): <strong>₹&nbsp;{{Payment.summaryData.amount}}</strong></div><div>Bank Name: <strong>{{Payment.summaryData.bankName}}</strong></div><!-- <div>Transaction Number: <strong>{{Payment.summaryData.transactionNo}}</strong></div> --><div>Cheque Number: <strong>{{Payment.summaryData.chequeNo}}</strong></div><div>Payment Date: <strong>{{Payment.summaryData.transactionDate}}</strong></div></div></div><div class=inner><div><table><thead><tr><th>DIRECT/Distributor/RIA</th><th>Scheme Name</th><th>Amount (INR)</th><th>CAMS Reference Number</th><!-- <th>Sub Transaction Number</th> --></tr></thead><tbody id=tableData><tr><td data-label=DIRECT/Distributor/RIA>{{Payment.summaryData.arn}}</td><td data-label=\"Scheme Name\">{{Payment.summaryData.schemeName}}</td><td data-label=\"Amount (INR)\">₹&nbsp;{{Payment.summaryData.amount}}</td><td data-label=\"CAMS Reference Number\">{{Payment.summaryData.camsreferenceNo}}</td><!-- <td data-label=\"Sub Transaction Number\">{{Payment.summaryData.subTransactionNumber}}</td> --></tr></tbody></table></div></div><div class=note-section><span><ins><strong>NOTE:</strong></ins> In case of any queries or concerns related to your transaction, please quote <strong>Transaction number</strong> in your communication. CAMS Reference Number with \'Awaiting\' status indicate that transaction is pending to be processed at CAMS. Kindly do not initiate payment again.</span></div></div></div><style type=text/css>body {\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.25;\n    }\n\n    .main-success {\n        width: 80%;\n        margin: auto;\n    }\n    .headersub {\n        text-align: center;\n        display: flex;\n        justify-content: start;\n        align-items: center;\n        background-color: white;\n    }\n    .headersub > div{\n        display: inline-block;\n        font-family: Poppins;\n        font-size: 22px;\n        font-weight: bold;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.36;\n        letter-spacing: normal;\n        text-align: left;\n        color: #4bc4a4;\n        padding: 1%;\n    }\n    .headersub > div:first-of-type {\n        padding-left: 16%;\n    }\n    .headersub img {\n        width: 100%;\n    }\n    .headersub > .gotohome {\n        text-decoration: none;\n        font-family: Poppins;\n    }\n    .headersub > .gotohome > .home-blue-icon{\n        background: url(\"https://investor-web.hdfcfund.com/assets/images/sprite.png\") -169px -387px;\n        width: 20px;\n        height: 18px;\n        display: inline-block;\n    }\n    .headersub > .gotohome > strong.text-blue{\n        font-size: 20px;\n        color: #083280;\n    }\n    .body-section {\n        padding: 3%;\n    }\n    .body-section > div:first-child{\n        font-family: Poppins;\n        font-size: 16px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 0.46;\n        letter-spacing: normal;\n        text-align: center;\n        color: #586065;\n        padding: 2%;\n    }\n    .body-section > div:last-child {\n        border-radius: 3px;\n        background-color: #e8faf4;\n        padding: 1%;\n    }\n    .body-section > div:last-child > div {\n        display: inline-block;\n        padding: 1%;\n        font-size: 12px;\n    }\n    table {\n        border: 1px solid #c6dceb;\n        margin: 0;\n        padding: 10px;\n        width: 100%;\n        table-layout: fixed;\n        border-radius: 5px;\n        border-collapse: separate;\n        border-spacing: 0px 10px;\n    }\n\n    table caption {\n        font-size: 1.5em;\n        margin: .5em 0 .75em;\n    }\n\n    table tr {\n        border: 1px solid #ddd;\n        padding: .35em;\n    }\n\n    table tbody tr {\n        background-color: #eaf5ff;\n    }\n\n    table thead tr th{\n        padding: 1% 1% 1% 1%;\n    }\n\n    table th,\n    table td {\n        padding: .625em;\n        text-align: left;\n        font-size: .85em;\n        line-height: 1.5;\n    }\n\n    table th {\n        font-size: .85em;\n        letter-spacing: normal;\n    }\n\n    .footer {\n        width: 100%;\n        text-align: center;\n        padding: 2%;\n    }\n\n    .footer a {\n        padding: 10px;\n        background-color: #083280;\n        text-decoration: none;\n        border-radius: 5px;\n        /*background-image: linear-gradient(180deg,#0d41a1,#083280),linear-gradient(#6d5cae,#6d5cae);*/\n        box-shadow: 0 1px 10px 0 rgba(17,17,19,.25);\n        border: 1px solid #1f3b71;\n        color: #fff;\n    }\n\n    .headersub1 {\n        background: #0d41a1;\n        z-index: 9;\n        text-align: center;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .note-section {\n        font-size: 14px;\n        background-color: #fef1f2;\n        color: black;\n        padding: 2%;\n        text-align: justify;\n        border-radius: 5px;\n        margin: 2% 0 2% 0;\n    }\n\n    .hiddenState {\n        display: none;\n    }\n\n    @media screen and (max-width: 600px) {\n        .headersub {\n            display: block;\n            padding-top: 5%;\n        }\n        .headersub > .gotohome {\n            display: block;\n        }\n        .headersub > div {\n            text-align: center;\n        }\n        .headersub > div:first-of-type {\n            padding-left: 0px;\n        }\n        .body-section > div:first-child {\n            padding: 10%;\n        }\n        .body-section > div:last-child > div {\n            display: block;\n        }\n        .body-section > div:last-child > div > strong {\n            float: right;\n        }\n        table {\n            border: 0;\n        }\n        table caption {\n            font-size: 1.3em;\n        }\n        table thead {\n            border: none;\n            clip: rect(0 0 0 0);\n            height: 1px;\n            margin: -1px;\n            overflow: hidden;\n            padding: 0;\n            position: absolute;\n            width: 1px;\n        }\n        table tr {\n            border-bottom: 3px solid #ddd;\n            display: block;\n            margin-bottom: .625em;\n        }\n        table td {\n            border-bottom: 1px solid #ddd;\n            display: block;\n            font-size: .8em;\n            text-align: right;\n        }\n        table td::before {\n            content: attr(data-label);\n            float: left;\n            font-weight: bold;\n        }\n        table td:last-child {\n            border-bottom: 0;\n        }\n        .footer a{\n            display: inline-block;\n            margin: 4%;\n        }\n        .note-section {\n            padding: 5%;\n            line-height: 1.5;\n            text-align: left;\n        }\n    }\n    .hidden {\n        display: none;\n    }\n    .show {\n        display: block;\n    }\n    .inner table th{\n        font-weight: 700;\n    }</style>");
$templateCache.put("app/instant-investment/purchase/payment-screen.html","<section ng-show=!Payment.showPaymentInfo class=\"clearfix payment-screen\" ng-init=Payment.init() ng-hide=Payment.chequeAcknowledgeSuccess><h3 class=page-title ng-if=!Payment.showUpiPaymentReview>Please Select a Payment Method</h3><h3 class=page-title ng-if=Payment.showUpiPaymentReview>Please Review Payment Method</h3><section class=\"content-area col-md-12\"><header><div class=col-md-3 ng-if=!Payment.formData.sipFirstInstallment>Scheme Name: <strong>{{Payment.formData.purchaseInSchemeName}}</strong></div><div class=col-md-3 ng-if=Payment.formData.sipFirstInstallment>Scheme Name: <strong>{{Payment.formData.inSchemeName}}</strong></div><div class=col-md-3 ng-if=!Payment.formData.sipFirstInstallment>Amount: <strong><i class=grey-rupee-icon></i> {{Payment.formData.purchaseAmount}}</strong></div><div class=col-md-2 ng-if=Payment.formData.sipFirstInstallment>Amount: <strong><i class=grey-rupee-icon></i> {{Payment.formData.sipFirstAmount}}</strong></div><div class=col-md-3 ng-if=!Payment.formData.sipFirstInstallment>Transaction Type: <strong>{{Payment.formData.investmentType}}</strong></div><div class=col-md-4 ng-if=Payment.formData.sipFirstInstallment>Transaction Type: <strong>SIP with 1<sup style=\"font-size: small\">st</sup> installment</strong></div><div class=col-md-3>Folio Number: <strong>{{Payment.formData.folioNumber}}</strong></div></header><div class=tabheads ng-if=\"Payment.formData.investmentType ===\'PURCHASE\' && !Payment.arnHardcodedData.isHdfcBank \"><div class=tabhead ng-repeat=\"_option in Payment.paymentOptions\"><div class=radio-block ng-class=\"{\'anything-disabled\':(Payment.arnHardcodedData.isHdfcBank && (_option == \'RTGS\' || _option == \'HDFC\' || _option == \'UPI\' || _option == \'OTM\'))}\"><span class=radio><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-disabled=\"_option===Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS\" ng-change=Payment.changedPaymentOption() ng-model=Payment.formData.purchasePaymentOption> <span class=check></span> </span><span class=radio-label>{{Payment.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div class=tabheads ng-if=\"Payment.arnHardcodedData && Payment.arnHardcodedData.isHdfcBank && Payment.formData.investmentType ===\'PURCHASE\'\"><div class=tabhead ng-repeat=\"_option in Payment.paymentOptions\"><div class=radio-block ng-hide=\"(Payment.arnHardcodedData.isHdfcBank && ( _option == \'RTGS\' || _option == \'HDFC\' || _option == \'UPI\' || _option == \'OTM\'))\"><span class=radio><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-disabled=\"_option===Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS\" ng-change=Payment.changedPaymentOption() ng-model=Payment.formData.purchasePaymentOption> <span class=check></span> </span><span class=radio-label>{{Payment.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div class=tabheads ng-if=\"Payment.formData.investmentType ===\'SIP\'\"><div class=tabhead ng-repeat=\"_option in Payment.paymentOptions\"><div class=radio-block ng-class=\"{\'anything-disabled\':(Payment.arnHardcodedData.isHdfcBank && (_option == \'OTM\' || _option == \'EM\'))}\"><span class=radio><input type=radio id=paymentOption1{{_option}} ng-value=_option name=paymentOption ng-disabled=\"_option===Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS\" ng-change=Payment.changedPaymentOption() ng-model=Payment.formData.purchasePaymentOption> <span class=check></span> </span><span class=radio-label>{{_option === \'UPI\' ? Payment.sipUpiText : Payment.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><form novalidate name=tForm><div class=tab-body ng-switch=Payment.formData.purchasePaymentOption ng-init=Payment.setForm(tForm)><div ng-switch-when=Q><div class=row><ng-bind-html dynamic=Payment.notesInstantPayment.noteDTO.noteDTOMap.Note_Quick_Investment_Cheque.content></ng-bind-html></div><input type=text style=\"visibility: hidden\"> <input type=password style=\"visibility: hidden\"><div class=row><div class=col-md-12><div style=\"display: flex; margin-left:2px\" class=neft-form-switch><span>Are you transferring funds from folio registered bank account? <span style=\"color: darkgrey\">(Only HDFC Bank allow)</span></span> <span style=\"margin-left: 10px; margin-right: 10px\" class=toggle-login-text ng-class=\"{\'login-active-tab\': Payment.notTransfurringFund}\">Yes</span><label class=switch><input type=checkbox ng-model=Payment.notTransfurringFund ng-click=Payment.changeBankRegisterOption() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label><span style=\"margin-left: 10px; margin-right: 10px\" class=toggle-login-text ng-class=\"{\'login-active-tab\': !Payment.notTransfurringFund}\">No</span></div></div></div><br><br><div class=row><div class=col-md-4 style=\"margin-bottom: 30px\" ng-if=Payment.notTransfurringFund><div class=\"selectfield marginBottom\" ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><select name=bank ng-disabled=!Payment.bankList ng-model=Payment.bankInfo ng-options=\"bank.bankName for bank in Payment.bankList\" ng-init=\"Payment.bankInfo = Payment.bankInfo ? Payment.bankInfo : null\" ng-change=Payment.changeBank() required><option value=\"\" selected>{{Payment.bankList&&!Payment.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=Payment.bankInfo>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><br><div ng-if=\"(Payment.notTransfurringFund && Payment.bankInfo) || (!Payment.notTransfurringFund && Payment.bankInfo == null)\"><div class=row ng-if=!Payment.notTransfurringFund><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankName.$invalid&&tForm.bankName.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.bankName name=bankName required ng-readonly=\"!Payment.notTransfurringFund && Payment.formData.paymentInfo.bankName\"><div class=bar></div><div class=highlight></div><label>Bank Name<span class=req>*</span></label><span class=error-input ng-show=tForm.bankName.$dirty&&tForm.bankName.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\" ng-readonly=\"Payment.notTransfurringFund && Payment.bankInfo.ifscCode\" ng-blur=Payment.manualIfscSearch();><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required && Payment.showInvalidIfscerror\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span><div style=\"width: 100px\" ng-class=\"{\'anything-disabled\': Payment.bankInfo.ifscCode}\"><div class=alignifsctext style=\"display: flex;justify-content: left;align-items: center\" ng-click=Payment.selectIFSC()><a style=\"height: 15px;width: 20px\"><svg class=\"svg-icon search-icon\" aria-labelledby=\"title desc\" role=img viewBox=\"0 0 19.9 19.7\"><title id=title>Search Icon</title><desc id=desc>A magnifying glass icon.</desc><g class=search-path fill=none stroke=#669ddf><path stroke-linecap=square stroke-width=3 d=\"M18.5 18.3l-5.4-5.4\"/><circle stroke-width=2 cx=8 cy=8 r=7 /></g></svg></a><p style=\"color: #669ddf;font-size: 12px\">SEARCH IFSC</p></div></div></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankBranch.$invalid&&tForm.bankBranch.$dirty} ng-if=\"Payment.notTransfurringFund && Payment.branchbankfield\"><input type=text ng-model=Payment.formData.paymentInfo.bankBranch maxlength=40 minlength=1 only-alphabets name=bankBranch required ng-readonly=\"Payment.notTransfurringFund && Payment.formData.paymentInfo.bankBranch\"><div class=bar></div><div class=highlight></div><label>Branch Address<span class=req>*</span></label><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div><div class=input-normal ng-class={error:tForm.bankBranch.$invalid&&tForm.bankBranch.$dirty} ng-if=\"!Payment.branchbankfield || !Payment.notTransfurringFund\"><input type=text ng-model=Payment.formData.paymentInfo.bankBranch maxlength=40 minlength=1 only-alphabets name=bankBranch required><div class=bar></div><div class=highlight></div><label>Branch Address<span class=req>*</span></label><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><div class=row><div class=col-md-12><div class=row ng-if=!Payment.notTransfurringFund><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankAcNo.$invalid&&tForm.bankAcNo.$dirty}><!-- <input type=\"text\" autocomplete=\"false\" ng-model=\"Payment.formData.paymentInfo.bankAcNo\" name=\"bankAcNo\"\n                      required ng-if=\"Payment.notTransfurringFund\" ng-minlength=\"9\" maxlength=\"20\" ng-readonly=\"Payment.notTransfurringFund\"\n                      onkeypress=\'return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\'\n                      ng-keydown=\"Payment.copyPasteHandler($event)\"> --> <input type=password autocomplete=false ng-model=Payment.formData.paymentInfo.bankAcNo name=bankAcNo required ng-if=!Payment.notTransfurringFund ng-minlength=9 maxlength=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event)><div class=bar></div><div class=highlight></div><label>Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.minlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div></div><div class=col-md-4 ng-if=!Payment.notTransfurringFund><div class=input-normal ng-class={error:tForm.verifyBankAcNo.$invalid&&tForm.verifyBankAcNo.$dirty}><input type=text ng-keydown=Payment.copyPasteHandler($event) name=verifyBankAcNo ng-minlength=9 required ng-model=Payment.formData.paymentInfo.verifyBankAcNo ng-pattern=Payment.formData.paymentInfo.bankAcNo onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=highlight></span> <span class=bar></span><label>Verify Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.verifyBankAcNo.$dirty&&tForm.verifyBankAcNo.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&tForm.verifyBankAcNo.$error.minlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&!tForm.verifyBankAcNo.$error.minlength&&tForm.verifyBankAcNo.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div></div></div></div><div class=row><div class=col-md-12><div class=row><div class=col-md-4><div class=selectfield ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select name=accountType ng-disabled=\"!Payment.accountTypeList || (Payment.notTransfurringFund && Payment.isAccTypeFieldDisabled)\" ng-model=Payment.accountType ng-options=\"account.accountType for account in Payment.accountTypeList\" ng-init=\"Payment.accountTypeList = Payment.accountTypeList ? Payment.accountTypeList : null\" ng-change=Payment.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=tForm.accountType.$dirty&&tForm.accountType.$error.required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div></div></div></div><div class=row><div class=col-md-12><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:tForm.chequeNumber.$invalid && tForm.chequeNumber.$dirty}\"><input type=password maxlength=15 minlength=1 ng-model=Payment.formData.paymentInfo.chequeNumber name=chequeNumber required capitalize=\"\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event)><div class=bar></div><div class=highlight></div><label>Cheque Number<span class=req>*</span></label><span class=error-input ng-show=tForm.chequeNumber.$dirty&&tForm.chequeNumber.$error.required ng-bind=Payment.VALIDATE_DATA.CHEQUE_NUMBER_REQUIRED></span></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:tForm.verifyChequeNumber.$invalid && tForm.verifyChequeNumber.$dirty}\"><input type=text maxlength=15 minlength=1 ng-model=Payment.formData.paymentInfo.verifyChequeNumber name=verifyChequeNumber required capitalize=\"\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=Payment.formData.paymentInfo.chequeNumber ng-keydown=Payment.copyPasteHandler($event)><div class=bar></div><div class=highlight></div><label>Verify Cheque Number<span class=req>*</span></label><span class=error-input ng-show=tForm.verifyChequeNumber.$dirty&&tForm.verifyChequeNumber.$error.required ng-bind=Payment.VALIDATE_DATA.CHEQUE_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyChequeNumber.$error.required&&!tForm.verifyChequeNumber.$error.minlength&&tForm.verifyChequeNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_CHEQUE_NUMBER_RANGE></span></div></div></div></div></div></div></div><div class=row ng-switch-when=DEBIT><div class=col-md-4><div class=form-group><div class=radio-block><span class=radio><input type=radio ng-click=Payment.cardTypeChanged() ng-model=Payment.debitCardType value=visa name=debitType> <span class=check></span> </span><span class=radio-label>Visa/Master</span></div><div class=radio-block><span class=radio><input type=radio ng-click=Payment.cardTypeChanged() ng-model=Payment.debitCardType value=maestro name=debitType> <span class=check></span> </span><span class=radio-label>Maestro</span></div></div><div class=selectfield ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><select name=bank ng-disabled=!Payment.bankList ng-model=Payment.bankInfo ng-options=\"bank.bankName for bank in Payment.bankList\" ng-init=\"Payment.bankInfo = Payment.bankInfo ? Payment.bankInfo : null\" ng-change=Payment.changeBank() required><option value=\"\" selected>{{Payment.bankList&&!Payment.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=Payment.bankInfo>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><div ng-switch-when=NETBANKING><div class=row><ng-bind-html dynamic=Payment.notesInstantPayment.noteDTO.noteDTOMap.Note_Quick_Investment_Net_Banking.content></ng-bind-html><div class=col-md-4><div class=\"selectfield marginBottom\" ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><select name=bank ng-disabled=!Payment.bankList ng-model=Payment.bankInfo ng-options=\"bank.bankName for bank in Payment.bankList\" ng-init=\"Payment.bankInfo = Payment.bankInfo ? Payment.bankInfo : null\" ng-change=Payment.changeBank() required><option value=\"\" selected>{{Payment.bankList&&!Payment.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=Payment.bankInfo>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><br><div class=row style=margin-top:2px><div class=col-md-4 ng-if=Payment.showIFSCField><div class=input-normal ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div class=col-md-4 ng-if=Payment.showAccountTypeField><div class=selectfield ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!Payment.accountTypeList ng-model=Payment.accountType ng-options=\"account.accountType for account in Payment.accountTypeList\" ng-init=\"Payment.accountTypeList = Payment.accountTypeList ? Payment.accountTypeList : null\" ng-change=Payment.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div></div></div><p class=\"text-red error-msg-tpv\" ng-if=\"Payment.formData.purchasePaymentOption==Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING && Payment.bankInfo.tpvEnableFlag==\'N\'\">Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br>Please select other payment mode or add a TPV enabled bank in your folio. <a ng-click=Payment.tpv() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</p><div ng-switch-when=RTGS><ng-bind-html dynamic=Payment.notesInstantPayment.noteDTO.noteDTOMap.Note_Quick_Investment_Neft.content></ng-bind-html><div class=\"col-md-12 row imp-info\"><h6>Bank Details</h6><p class=text-danger>The mode of payment is applicable only to those who have already transferred the subscription amount into our designated scheme and now wish to submit the transaction online. HDFC AMC will not be responsible for any transfer of money done into a wrong account by the investor. Allotment of NAV is subject to realization of subscription amount into the designated scheme collection Account number 00600350109922, Account Name: HDFC Mutual Fund RTGS A/c, RTGS Code HDFC0000060.</p></div><input type=text style=\"visibility: hidden\"> <input type=password style=\"visibility: hidden\"><div class=row><div class=col-md-12><div style=\"display: flex; margin-left:2px\" class=neft-form-switch><span>{{Payment.PATTERN.RTGS_MESSAGE}}</span> <span style=\"margin-left: 10px; margin-right: 10px\" class=toggle-login-text ng-class=\"{\'login-active-tab\': Payment.isNewPayment}\">Yes</span><label class=switch><input type=checkbox ng-model=Payment.isNewPayment ng-click=Payment.changeRtgsPaymentOption() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label><span style=\"margin-left: 10px; margin-right: 10px\" class=toggle-login-text ng-class=\"{\'login-active-tab\': !Payment.isNewPayment}\">No</span></div></div></div><br><div ng-if=Payment.isNewPayment><div class=row><div class=col-md-4><div class=\"selectfield marginBottom\" ng-class=\"{error:tForm.bank.$dirty && tForm.bank.$invalid}\"><select name=bank ng-disabled=!Payment.bankList ng-model=Payment.bankInfo ng-options=\"bank.bankName for bank in Payment.bankList\" ng-init=\"Payment.bankInfo = Payment.bankInfo ? Payment.bankInfo : null\" ng-change=Payment.changeBank() required disabled><option value=\"\" class=ng-binding selected>Select Bank</option></select><span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.bank.$dirty && tForm.bank.$error.required\" ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED aria-hidden=true>Bank is required.</span></div></div></div><!--<p class=\"text-red error-msg-tpv\" ng-if=\"Payment.formData.purchasePaymentOption == Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS && Payment.bankInfo.tpvEnableFlag==\'N\'\">\n              Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br/>\n              Please select other payment mode or add a TPV enabled bank in your folio. <a\n              ng-click=\"Payment.tpv()\" href=\"javaScript:void(0)\">Click here</a> to view the TPV enabled banks.\n            </p>--><br><br><!--            <div class=\"row\" style=\"margin-top: 3px\" ng-if=\"Payment.showIFSCField\">--><!--            <div class=\"col-md-4\">--><!--              <div class=\"input-normal\" ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\">--><!--                <input type=\"text\" maxlength=\"11\" minlength=\"11\" ng-model=\"Payment.formData.paymentInfo.ifscCode\" name=\"ifscCode\" required=\"\" ng-pattern=\"/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/\" capitalize=\"\" >--><!--                <div class=\"bar\"></div>--><!--                <div class=\"highlight\"></div>--><!--                <label>IFSC/NEFT Code<span class=\"req\">*</span></label>--><!--                <span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=\"Payment.VALIDATE_DATA.IFSC_CODE_FIELD\" aria-hidden=\"true\">Please enter valid IFSC code.</span>--><!--                <span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=\"Payment.VALIDATE_DATA.IFSC_CODE_REGEX\" aria-hidden=\"true\">Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span>--><!--              </div>--><!--            </div>--><!--              <div class=\"col-md-4\" ng-if=\"Payment.showAccountTypeField\">--><!--                <div class=\"selectfield\" ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\">--><!--                  <select class=\"\" name=\"accountType\" ng-disabled=\"!Payment.accountTypeList\"--><!--                          ng-model=\"Payment.accountType\"--><!--                          ng-options=\"account.accountType for account in Payment.accountTypeList\"--><!--                          ng-init=\"Payment.accountTypeList = Payment.accountTypeList ? Payment.accountTypeList : null\"--><!--                          ng-change=\"Payment.changeAccountype()\"--><!--                          required>--><!--                    <option value=\"\" selected>--><!--                      Account Type--><!--                    </option>--><!--                  </select>--><!--                  <label ng-if=\"Payment.accountType\">Account Type</label>--><!--                  <span class=\"req text-red\">*</span>--><!--                  <span class=\"error-input\" ng-show=\"tForm.accountType.$dirty && tForm.accountType.$error.required\"--><!--                        ng-bind=\"Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED\"></span>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            <div class=\"row\">--><!--              <div class=\"col-md-4\" style=\"margin-top: 3px;\">--><!--                <div class=\"input-normal\"--><!--                     ng-class=\"{error:tForm.utrNumber.$invalid&&tForm.utrNumber.$dirty}\">--><!--                  <input type=\"text\" name=\"utrNumber\"--><!--                         ng-model=\"Payment.formData.paymentInfo.utrNumber\"--><!--                         ng-pattern=\"Payment.PATTERN.UTR_REGEX\"--><!--                         required>--><!--                  <span class=\"highlight\"></span>--><!--                  <span class=\"bar\"></span>--><!--                  <label>UTR Number<span class=\"req\">*</span></label>--><!--                  <span class=\"error-input\" ng-show=\"tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required\"--><!--                        ng-bind=\"Payment.VALIDATE_DATA.UTR_REQUIRED\"></span>--><!--                  <span class=\"error-input\" ng-show=\"tForm.utrNumber.$dirty&&tForm.utrNumber.$error.pattern\"--><!--                        class=\"help-block\" ng-bind=\"Payment.VALIDATE_DATA.UTR_RANGE\"></span>--><!--                </div>--><!--              </div>--><!--              <div class=\"col-md-4\" style=\"margin-top:3px\">--><!--                <div class=\"input-normal\"--><!--                     ng-class=\"{error:tForm.verifyUtrNumber.$invalid&&tForm.verifyUtrNumber.$dirty}\">--><!--                  <input type=\"text\" name=\"verifyUtrNumber\"--><!--                         ng-model=\"Payment.formData.paymentInfo.verifyUtrNumber\"--><!--                         ng-pattern=\"Payment.formData.paymentInfo.utrNumber\"--><!--                         required>--><!--                  <span class=\"highlight\"></span>--><!--                  <span class=\"bar\"></span>--><!--                  <label>Verify UTR Number<span class=\"req\">*</span></label>--><!--                  <span class=\"error-input\" ng-show=\"tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required\"--><!--                        ng-bind=\"Payment.VALIDATE_DATA.UTR_REQUIRED\"></span>--><!--                  <span class=\"error-input\" ng-show=\"tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.pattern\"--><!--                        ng-bind=\"Payment.VALIDATE_DATA.SAME_UTR_REQUIRED\"></span>--><!--                </div>--><!--              </div>--><!--            </div>--></div><br><div ng-show=\"(Payment.bankInfo && Payment.isNewPayment) || (!Payment.isNewPayment && Payment.bankInfo == null)\"><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankName.$invalid&&tForm.bankName.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.bankName name=bankName required ng-readonly=Payment.isNewPayment><div class=bar></div><div class=highlight></div><label>Bank Name<span class=req>*</span></label><span class=error-input ng-show=tForm.bankName.$dirty&&tForm.bankName.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankBranch.$invalid&&tForm.bankBranch.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.bankBranch only-alphabets name=bankBranch required ng-readonly=Payment.isNewPayment><div class=bar></div><div class=highlight></div><label>Branch City<span class=req>*</span></label><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankAcNo.$invalid&&tForm.bankAcNo.$dirty}><input type=text autocomplete=false ng-model=Payment.formData.paymentInfo.bankAcNo name=bankAcNo required ng-if=Payment.isNewPayment ng-minlength=9 maxlength=20 ng-readonly=Payment.isNewPayment onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event)> <input type=password autocomplete=false ng-model=Payment.formData.paymentInfo.bankAcNo name=bankAcNo required ng-if=!Payment.isNewPayment ng-minlength=9 maxlength=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event)><div class=bar></div><div class=highlight></div><label>Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.minlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div></div><div class=col-md-4 ng-if=!Payment.isNewPayment><div class=input-normal ng-class={error:tForm.verifyBankAcNo.$invalid&&tForm.verifyBankAcNo.$dirty}><input type=text ng-keydown=Payment.copyPasteHandler($event) name=verifyBankAcNo ng-minlength=9 required ng-model=Payment.formData.paymentInfo.verifyBankAcNo ng-pattern=Payment.formData.paymentInfo.bankAcNo onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=highlight></span> <span class=bar></span><label>Verify Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.verifyBankAcNo.$dirty&&tForm.verifyBankAcNo.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&tForm.verifyBankAcNo.$error.minlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&!tForm.verifyBankAcNo.$error.minlength&&tForm.verifyBankAcNo.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text maxlength=11 minlength=11 ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=Payment.IFSC_REGEX capitalize ng-readonly=\"Payment.isNewPayment && Payment.formData.paymentInfo.ifscCode\"><div class=bar></div><div class=highlight></div><label>IFSC/NEFT Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4><div class=selectfield ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select name=accountType ng-disabled=\"!Payment.accountTypeList || (Payment.isNewPayment && Payment.isAccTypeFieldDisabled)\" ng-model=Payment.accountType ng-options=\"account.accountType for account in Payment.accountTypeList\" ng-init=\"Payment.accountTypeList = Payment.accountTypeList ? Payment.accountTypeList : null\" ng-change=Payment.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.accountType>Account Type</label><span class=\"req text-red\" style=\"right: 0px\">*</span> <span class=error-input ng-show=\"tForm.accountType.$dirty && tForm.accountType.$error.required\" ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.utrNumber.$invalid&&tForm.utrNumber.$dirty}><input type=text name=utrNumber ng-model=Payment.formData.paymentInfo.utrNumber ng-pattern=Payment.PATTERN.UTR_REGEX required> <span class=highlight></span> <span class=bar></span><label>UTR Number<span class=req>*</span></label><span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.pattern class=help-block ng-bind=Payment.VALIDATE_DATA.UTR_RANGE></span></div></div><div class=col-md-4><div class=input-normal ng-class={error:tForm.verifyUtrNumber.$invalid&&tForm.verifyUtrNumber.$dirty}><input type=text name=verifyUtrNumber ng-model=Payment.formData.paymentInfo.verifyUtrNumber ng-pattern=Payment.formData.paymentInfo.utrNumber required> <span class=highlight></span> <span class=bar></span><label>Verify UTR Number<span class=req>*</span></label><span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_UTR_REQUIRED></span></div></div></div><!--<div class=\"row\">\n              <div class=\"col-md-12\">\n                <div class=\"upload-some\">\n                  <span class=\"leaf-label\">Upload Bank Statement\n                    <i class=\"info-icon base-tooltip\" data-bs-html=\"true\" data-bs-toggle=\"tooltip\"  data-bs-placement=\"{{Main.tooltipClass}}\"\n                       title=\"{{Payment.PATTERN.BANK_STATEMENT_INFO}}\"></i>\n                    <span class=\"req text-red\">*</span>\n                  </span>\n                  <div class=\"upload-leaf\">\n                    <input id=\"uploadCheckLeaf\" type=\"file\" name=\"pic\" accept=\"image/*, application/*\" file-model-profile=\"chequeLeaf\"\n                           upload=\"Payment.bankUploadChequeLeafFile(file)\" ng-model=\"Payment.checkleaf\">\n                    <div class=\"file-upload\"><button>Choose File</button><span ng-if=\"Payment.chooseAFile || Payment.fileName == null\">No File Chosen</span>\n                      <span ng-if=\"Payment.fileType === \'tif\' || Payment.fileType === \'tiff\' || Payment.fileType === \'pdf\' \"><a href=\"javascript:void(0)\" ng-click=\"Payment.downloadPdfFile(Payment.bankchequeLeafUrl,Payment.fileType)\">Download</a></span>\n                      <span ng-if=\"Payment.fileType == \'jpg\' ||  Payment.fileType == \'jpeg\'\" ng-click=\"Payment.openUploadedDoc(Payment.bankPayload.bankDetails.chequeLeaf)\">{{Payment.bankChequeLeaf}}</span></div>\n                  </div>\n                </div>\n              </div>\n            </div>--></div></div><div class=row ng-switch-when=OTM><p class=\"col-md-12 otp-sent paymentOtpMessage\" ng-if=\"!Payment.isOtmOtpVerified && Payment.isOtmValid\">{{Payment.otpSentMessage}}</p><div class=\"col-md-4 instantInvestOtm\" ng-if=!Payment.isOtmOtpVerified><div class=input-normal ng-class=\"{\'anything-disabled\': !Payment.isOtmValid}\"><input type=text ng-model=Payment.otmOtp name=otmotp ng-maxlength=6 maxlength=6 is-number required><div class=bar></div><div class=highlight></div><label>OTP<span class=req>*</span></label><span class=error-input ng-show=tForm.otmotp.$dirty&&tForm.otmotp.$error.required ng-bind=Payment.VALIDATE_DATA.OTP_REQUIRED></span> <span class=error-input ng-show=tForm.otmotp.$dirty&&tForm.otmotp.$error.number ng-bind=Payment.VALIDATE_DATA.OTP_FIELD></span> <span class=error-input ng-show=tForm.otmotp.$dirty&&tForm.otmotp.$error.maxlength ng-bind=Payment.VALIDATE_DATA.OTP_FIELD></span></div><div class=otmResendOtp ng-if=Payment.isOtmValid><timer countdown=Payment.PATTERN.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Payment.resendOtp()>Resend OTP</a> <a ng-show=\"countdown > 0\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><div class=col-md-4 ng-if=Payment.isOtmOtpVerified><div class=selectfield ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><select name=bank ng-disabled=!Payment.otmList.bankList ng-model=Payment.bankInfo ng-options=\"bank.bankName for bank in Payment.otmList.bankList\" ng-init=\"Payment.bankInfo = Payment.bankInfo ? Payment.bankInfo : null\" ng-change=Payment.changeBank() required><option value=\"\" selected>{{Payment.bankList&&!Payment.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=Payment.bankInfo>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span></div><!--\n            <div>\n              <div class=\"input-normal\">\n                <input type=\"text\" name=\"bankName\" ng-model=\"Payment.bankInfo.bankName\" readonly>\n\n                <div class=\"bar\"></div>\n                <div class=\"highlight\"></div>\n                <label>Bank Name</label>\n              </div>\n\n              <div class=\"input-normal\">\n                <input type=\"text\" ng-model=\"Payment.bankInfo.bankBranch\" readonly name=\"bankBranch\">\n\n                <div class=\"bar\"></div>\n                <div class=\"highlight\"></div>\n                <label>Branch</label>\n              </div>\n\n              <div class=\"input-normal\">\n                <input type=\"password\" ng-model=\"Payment.bankInfo.bankAcNo\" readonly name=\"bankAcNo\">\n\n                <div class=\"bar\"></div>\n                <div class=\"highlight\"></div>\n                <label>Account Number</label>\n              </div>\n\n              <div class=\"input-normal\">\n                <input type=\"text\" ng-model=\"Payment.bankInfo.ifscCode\" name=\"ifscCode\" readonly>\n\n                <div class=\"bar\"></div>\n                <div class=\"highlight\"></div>\n                <label>IFSC/NEFT Code</label>\n              </div>\n            </div>--></div><div style=\"margin-top: 2px\" class=col-md-4 ng-if=\"Payment.isOtmOtpVerified && Payment.showIFSCField\"><div class=input-normal ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div class=col-md-4 ng-if=Payment.showAccountTypeField><div class=selectfield ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!Payment.accountTypeList ng-model=Payment.accountType ng-options=\"account.accountType for account in Payment.accountTypeList\" ng-init=\"Payment.accountTypeList = Payment.accountTypeList ? Payment.accountTypeList : null\" ng-change=Payment.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=\"tForm.accountType.$dirty && tForm.accountType.$error.required\" ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div><div class=\"row col-md-12\"><div><ng-bind-html dynamic=Payment.notesInstantPayment.noteDTO.noteDTOMap.Note_Quick_Investment_OTM.content></ng-bind-html></div></div><div class=col-md-8><div><table class=\"table borderless\" ng-if=\"Payment.bankInfo && Payment.otmList.bankList.length\"><tr><td class=otmTableWidth>Account No:</td><td>{{Payment.bankInfo.bankAcNo}}</td></tr><tr><td class=otmTableWidth>OTM UMRN No:</td><td>{{Payment.bankInfo.omUmrn}}</td></tr><tr><td class=otmTableWidth>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{Payment.bankInfo.maxAmount}} <span class=error-input ng-show=\"Payment.isOTMAmount && Payment.formData.purchaseAmount\" ng-bind=Payment.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_PURCHASE_ERROR></span> <span class=error-input ng-show=\"Payment.isOTMAmount && Payment.formData.sipFirstAmount\" ng-bind=Payment.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_SIP_ERROR></span></td></tr><tr><td class=otmTableWidth>OTM Start Date:</td><td>{{Payment.bankInfo.omStartDate}} <span class=error-input ng-show=Payment.isOTMStartDate ng-bind=\"Payment.VALIDATE_DATA.DATE_START_VALIDATION_ERROR + \' \' + Payment.bankInfo.omStartDate\"></span> <span class=error-input ng-show=\"Payment.isOTMStartDate && Payment.formData.sipFirstAmount\" ng-bind=\"Payment.VALIDATE_DATA.DATE_START_FIRST_INSTALLMENT_VALIDATION_ERROR + \' \' + Payment.bankInfo.omStartDate\"></span></td></tr><tr><td class=otmTableWidth>OTM Expiry Date:</td><td>{{Payment.bankInfo.omExpiryDate}} <span class=error-input ng-show=Payment.isOTMDate ng-bind=\"Payment.VALIDATE_DATA.EXPIRY_DATE_VALID_ERROR + \' \' + Payment.bankInfo.omExpiryDate\"></span> <span class=error-input ng-show=\"Payment.isOTMDate && Payment.formData.sipFirstAmount\" ng-bind=\"Payment.VALIDATE_DATA.EXPIRY_DATE_FIRST_INSTALLMENT_VALID_ERROR + \' \' + Payment.bankInfo.omExpiryDate\"></span></td></tr></table></div></div></div><div ng-switch-when=HDFC><div class=\"col-md-12 row hdfctab imp-info\"><h6>Bank Details</h6></div><ng-bind-html dynamic=Payment.notesInstantPayment.noteDTO.noteDTOMap.Note_Quick_Investment_HDFC.content></ng-bind-html><div class=\"col-md-12 row\"><div class=col-md-4><div class=input-normal ng-class={error:tForm.schemeAccountNumber.$invalid&&tForm.schemeAccountNumber.$dirty}><input type=number ignore-mouse-wheel ng-model=Payment.formData.paymentInfo.schemeAccountNumber name=schemeAccountNumber ng-minlength=9 required><div class=bar></div><div class=highlight></div><label>HDFC MF Scheme Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.required ng-bind=Payment.VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.number ng-bind=Payment.VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_FIELD></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.minlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div></div></div><div class=\"col-md-12 row\"><div class=col-md-4><div class=input-normal ng-class={error:tForm.accountNumber.$invalid&&tForm.accountNumber.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.accountNumber name=accountNumber ng-minlength=9 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event) required><div class=bar></div><div class=highlight></div><label>Investor Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.required ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.minlength ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span></div></div><div class=col-md-4><div class=input-normal ng-class={error:tForm.verifyAccountNumber.$invalid&&tForm.verifyAccountNumber.$dirty}><input type=text ng-keydown=Payment.copyPasteHandler($event) name=verifyAccountNumber ng-minlength=9 required ng-model=Payment.formData.paymentInfo.verifyAccountNumber ng-pattern=Payment.formData.paymentInfo.accountNumber onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=highlight></span> <span class=bar></span><label>Confirm Investor Account Number</label><span class=error-input ng-show=tForm.verifyAccountNumber.$dirty&&tForm.verifyAccountNumber.$error.required ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyAccountNumber.$error.required&&tForm.verifyAccountNumber.$error.minlength ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyAccountNumber.$error.required&&!tForm.verifyAccountNumber.$error.minlength&&tForm.verifyAccountNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_INVESTOR_ACCOUNT_NUMBER_RANGE></span></div></div></div><div class=\"col-md-12 row\"><div class=col-md-4 style=\"margin-top: 2px\"><div class=input-normal ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div class=col-md-4><div class=selectfield ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!Payment.accountTypeList ng-model=Payment.accountType ng-options=\"account.accountType for account in Payment.accountTypeList\" ng-init=\"Payment.accountTypeList = Payment.accountTypeList ? Payment.accountTypeList : null\" ng-change=Payment.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=\"tForm.accountType.$dirty && tForm.accountType.$error.required\" ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div></div><div class=\"col-md-12 row\"><div class=col-md-4><div class=input-normal ng-class={error:tForm.accountHolderName.$invalid&&tForm.accountHolderName.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.accountHolderName only-alphabets name=accountHolderName required><div class=bar></div><div class=highlight></div><label>Account Holder Name<span class=req>*</span></label><span class=error-input ng-show=tForm.accountHolderName.$dirty&&tForm.accountHolderName.$error.required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_HOLDER_REQUIRED></span></div></div></div><div class=\"col-md-12 row\"><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankBranch.$invalid&&tForm.bankBranch.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.bankBranch only-alphabets name=bankBranch required><div class=bar></div><div class=highlight></div><label>HDFC Bank Branch Name<span class=req>*</span></label><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><div class=\"col-md-12 row\"><div class=col-md-4><div class=input-normal ng-class={error:tForm.utrNumber.$invalid&&tForm.utrNumber.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.utrNumber name=utrNumber required ng-minlength=9 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event)><div class=bar></div><div class=highlight></div><label>Bank Reference Number<span class=req>*</span></label><span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.minlength ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE></span></div></div><div class=col-md-4><div class=input-normal ng-class={error:tForm.verifyUtrNumber.$invalid&&tForm.verifyUtrNumber.$dirty}><input type=text ng-keydown=Payment.copyPasteHandler($event) name=verifyUtrNumber ng-minlength=9 required ng-model=Payment.formData.paymentInfo.verifyUtrNumber ng-pattern=Payment.formData.paymentInfo.utrNumber onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=highlight></span> <span class=bar></span><label>Confirm Bank Reference Number</label><span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyUtrNumber.$error.required&&tForm.verifyUtrNumber.$error.minlength ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyUtrNumber.$error.required&&!tForm.verifyUtrNumber.$error.minlength&&tForm.verifyUtrNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_BANK_REFERENCE_NUMBER_RANGE></span></div></div></div><div class=\"col-md-12 row\" ng-if=Payment.isUPIVerified><div class=\"col-md-4 verify-vpa\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{Payment.name}}</span></div></div><div class=\"col-md-12 row\"><div class=col-md-12><div class=upload-some><span class=leaf-label>Upload Bank Statement <i class=\"info-icon base-tooltip\" data-bs-html=true data-bs-toggle=tooltip data-bs-placement={{Main.tooltipClass}} title={{Payment.PATTERN.BANK_STATEMENT_INFO}}></i> <span class=\"req text-red\">*</span></span><div class=upload-leaf><input id=uploadCheckLeaf type=file name=pic accept=\"image/*, application/*\" file-model-profile=chequeLeaf upload=Payment.bankUploadChequeLeafFile(file) ng-model=Payment.checkleaf><div class=file-upload><button>Choose File</button><span ng-if=\"Payment.chooseAFile || Payment.fileName == null\">No File Chosen</span> <span ng-if=\"Payment.fileType === \'tif\' || Payment.fileType === \'tiff\' || Payment.fileType === \'pdf\' \"><a href=javascript:void(0) ng-click=Payment.downloadPdfFile(Payment.bankchequeLeafUrl,Payment.fileType)>Download</a></span> <span ng-if=\"Payment.fileType == \'jpg\' ||  Payment.fileType == \'jpeg\'\" ng-click=Payment.openUploadedDoc(Payment.bankchequeLeafUrl)>{{Payment.bankChequeLeaf}}</span></div></div></div></div></div></div><div class=row ng-switch-when=UPI><div class=col-md-4><div class=selectfield ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><select name=bank ng-disabled=\"!Payment.bankList || Payment.isDisableUpi\" ng-model=Payment.bankInfo ng-options=\"bank as (bank.bankName) for bank in Payment.bankList\" ng-change=Payment.selectedUpiBank() required><option value=\"\" selected>{{Payment.bankList&&!Payment.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=Payment.bankInfo>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span></div></div><div class=col-md-4 ng-if=Payment.showIFSCField><div class=input-normal ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div class=col-md-4 ng-if=Payment.showAccountTypeField><div class=selectfield ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!Payment.accountTypeList ng-model=Payment.accountType ng-options=\"account.accountType for account in Payment.accountTypeList\" ng-init=\"Payment.accountTypeList = Payment.accountTypeList ? Payment.accountTypeList : null\" ng-change=Payment.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=\"tForm.accountType.$dirty && tForm.accountType.$error.required\" ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div><div ng-class=\"{\'col-md-12\' : Payment.showAccountTypeField || Payment.showIFSCField }\" ng-if=Payment.bankInfo class=col-md-6><div class=row><div class=\"col-md-5 vpa-input\"><div class=input-normal ng-class={error:tForm.virtualAddress.$invalid&&tForm.virtualAddress.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.virtualAddress name=virtualAddress ng-pattern=Payment.PATTERN.upi_virtual_addr_regex ng-change=\"Payment.verifyUPIResp={}\" required ng-readonly=\"Payment.isUPIVerified && Payment.verifyUPIResp.valid === true\" ng-change=\"Payment.verifyUPIResp={}\" ng-disabled=Payment.isDisableUpi><div class=bar></div><div class=highlight></div><label style=\"display: block;width: 100%\">Virtual Payment Address (UPI ID) <span class=req>*</span> <i class=edit-icon style=\"position: absolute;right: 0px; top:16px; pointer-events: all; box-sizing: content-box\" ng-if=\"Payment.isUPIVerified && Payment.verifyUPIResp.valid === true && !Payment.isDisableUpi\" ng-click=\"Payment.isUPIVerified = false\"></i></label><span class=error-input ng-show=tForm.virtualAddress.$dirty&&(tForm.virtualAddress.$error.required||tForm.virtualAddress.$error.pattern) ng-bind=Payment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!tForm.virtualAddress.$invalid\n                  &&  (!Payment.isUPIVerified && Payment.verifyUPIResp.valid === false)\" ng-bind=Payment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span></div></div><div class=col-md-3><button blur-on-click style=\"width: 100%;padding: 10px 0px\" ng-if=\"Payment.formData.purchasePaymentOption==\'UPI\' && !Payment.isUPIVerified\" class=\"btn btn-primary-action\" ng-disabled=\"!Payment.formData.paymentInfo.virtualAddress || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition())\" ng-click=Payment.verifyUPI()>Verify</button></div><div class=\"col-md-3 verify-vpa verify-ack-padding\" ng-if=\"Payment.isUPIVerified && Payment.verifyUPIResp.valid === true\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{Payment.name}}</span></div><div class=\"col-md-2 verify-vpa verify-ack-padding verify-ack-col\" ng-if=\"!Payment.isUPIVerified && Payment.verifyUPIResp.valid === false\"><p><strong><span class=error-input style=\"display:inline;font-size:100%;margin-bottom: 20px\">Not Verified</span> <i class=\"cancel-icon error-input\"></i></strong></p></div></div></div><div class=\"initiate-transaction col-md-12\"><ng-bind-html ng-if=\"Payment.formData.investmentType !==\'SIP\'\" dynamic=Payment.notesInstantPayment.noteDTO.noteDTOMap.Note_Quick_Investment_UPI.content></ng-bind-html><ng-bind-html ng-if=\"Payment.formData.investmentType === \'SIP\'\" dynamic=Payment.notesInstantPayment.noteDTO.noteDTOMap.Note_SIP_FI_UPI.content></ng-bind-html></div></div></div><div class=tc-block-d ng-class=\"{\'tc-block-when-bankInfo\' : Payment.formData.purchasePaymentOption ==\'RTGS\' && Payment.isNewPayment && Payment.bankInfo && Payment.bankInfo.tpvEnableFlag == \'N\'}\"><h6>Declaration :</h6><div class=checkbox><input id=declaration ng-model=Payment.isCheckedDeclaration type=checkbox required> <i class=icon-checkbox></i><label for=declaration>I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the bank account holders.</label></div></div><div class=\"form-footer col-md-12\"><span ng-click=Payment.goToBack() style=\"float: left; color: #103880\" class=cursor-pointer><i class=arrow-blue-back-icon></i>Back</span> <button blur-on-click ng-if=\"Payment.formData.purchasePaymentOption!=\'UPI\' && Payment.formData.purchasePaymentOption!=\'OTM\'\" class=\"btn btn-primary-action\" ng-disabled=\"tForm.$invalid || (Payment.formData.purchasePaymentOption==Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING\n                && Payment.bankInfo.tpvEnableFlag==\'N\' || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition())\n                 || (Payment.formData.purchasePaymentOption ==\'HDFC\' && Payment.fileName == null)) || Payment.rFileType\" ng-click=Payment.submitForm()>Continue to Pay</button><!--|| (Payment.formData.purchasePaymentOption ==\'RTGS\' && Payment.isNewPayment && ((Payment.fileName == null) || (Payment.bankInfo && Payment.bankInfo.tpvEnableFlag==\'N\')))\n                 || (Payment.formData.purchasePaymentOption ==\'RTGS\' && !Payment.isNewPayment && Payment.fileName == null)--> <button blur-on-click ng-if=\"Payment.formData.purchasePaymentOption==\'OTM\' && !Payment.isOtmOtpVerified\" class=\"btn btn-primary-action\" ng-disabled=\"tForm.$invalid || !Payment.isOtmValid\" ng-click=Payment.submitOtmOtp()>Verify OTP</button> <button blur-on-click ng-if=\"Payment.formData.purchasePaymentOption==\'OTM\' && Payment.isOtmOtpVerified\" class=\"btn btn-primary-action\" ng-disabled=\"tForm.$invalid || Payment.isInvalidForm || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition())\" ng-click=Payment.submitForm()>Continue to Pay</button> <button blur-on-click ng-if=\"Payment.formData.purchasePaymentOption==\'UPI\'\" class=\"btn btn-primary-action\" ng-disabled=\"tForm.$invalid || !Payment.isUPIVerified || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition())\" ng-click=Payment.submitForm()>Continue to Pay</button></div></form></section><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{Payment.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=Payment.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=Payment.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=Payment.billdeskPayload.msg></form><!-- Payment form commented: --><!-- with new implementation we are not using it, directly appending data from backend on billdesk url. --><!--\n  <form autocomplete=\"off\" name=\'billdeskPayFormDebitOnly\' id=\"billdeskPayFormDebitOnly\" method=\'POST\'\n        action=\'https://www.billdesk.com/pgidsk/PGICommonGateway\'>\n    <input type=\"hidden\" name=\"msg\" ng-value=\"Payment.billDeskpayload\" id=\"msg\"/>\n    <input id=\"hidRequestId\" type=\'hidden\' name=\'hidRequestId\' value=\"PGIME1000\"/>\n    <input id=\"hidOperation\" type=\'hidden\' name=\'hidOperation\' value=\"ME100\"/>\n  </form>--></section><div ng-show=Payment.showPaymentInfo class=\"content-area quick-payment-success\"><div class=imp-info><strong>Important:</strong><p><i class=dot></i> <span>You now have 10 min to complete the transaction and return to this page. If you exceed this time, you may not get a transaction confirmation number. In such a scenario, please contact your ISC immediately. (Please Click here to view list.) If a new window has not opened, please check again if your pop-up blockers are disabled by following the below steps. Go to Tools. Select popup blocker. Disable/ turn off pop-up blockers and try again.</span></p><p><i class=dot></i> <span>If a new window has not opened, please check again if your pop-up blockers are disabled by following the below steps. Go to Tools. Select popup blocker. Disable/ turn off pop-up blockers and try again.</span></p></div><div class=\"text-center align-buttons\"><button class=\"btn-primary-action btn-small\" ui-sref=instantLoginHome.instantInvest>Make New Investment</button></div></div><div ng-if=Payment.chequeAcknowledgeSuccess class=content-area><div data-ng-include=\"\'app/instant-investment/purchase/chequeAcknowledgepage.html\'\"></div></div><style>.checkbox{text-align: left;\n    width: 100%;}\n  .checkbox label{\n    position: absolute;\n    top: 2px;\n    left: 10px;\n  }\n  .content-area{\n    float: left;}\n\n    .instant-invest.main-section .content-area .imp-info div i.dot {\n      display: inline-block;\n      position: relative;\n      top: -2px;\n      height: 6px;\n      margin-right: 10px;\n      width: 6px;\n      background: #d92018;\n    }\n\n\n    .info {\n      font-weight: normal;\n      font-size: 12px;\n    }\n\n    .info p {\n      margin-top : 0px !important;\n      margin-bottom: 0px !important;\n    }\n\n    .info span {\n      display: inline-block;\n      vertical-align: top;\n    }\n\n    .switch {\n  position: relative;\n  display: inline-block;\n  width: 54px;\n  height: 24px;\n}\n\n.switch input { \n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider1 {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #84e084;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n.slider1:after {\n  content: \"\" !important;\n}\n.slider1:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 18px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n\ninput:focus + .slider1 {\n  box-shadow: 0 0 1px #CCC;\n}\n\ninput:checked + .slider1:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded slider1s */\n.slider1.round {\n  border-radius: 34px;\n}\n\n.slider1.round:before {\n  border-radius: 50%;\n}</style>");
$templateCache.put("app/instant-investment/purchase/purchase.html","<div id=lumpsum-form><div class=row><label class=form-label>Add Scheme</label></div><div class=row><div class=\"col-md-3 col-sm-6 row\"><div class=\"input-select input-normal\" ng-class={error:InstantInvest.tForm.pInScheme1.$invalid}><input type=text name=pInScheme1 id=pInScheme1 ng-change=InstantInvest.filterPurchaseInSchemeList() ng-model=InstantInvest.formData.purchaseInSchemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off ng-required=InstantInvest.isRequired capitalize><!--ng-disabled=\"!fForm.$valid\"--> <span class=highlight></span> <span class=bar></span><label>Select a Scheme</label><span class=error-input ng-show=InstantInvest.tForm.pInScheme1.$error.required ng-bind=InstantInvest.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=InstantInvest.purchaseInSchemeList display-key=scheme hdfc-click=InstantInvest.purchaseInSchemeChanged(data) model=InstantInvest.formData.purchaseInSchemeCode for=pInScheme1></drop-down><p class=info-primary>{{InstantInvest.formData.purchaseInSchemeName}}</p></div></div><div class=\"col-md-offset-1 col-sm-offset-1 col-md-4 col-sm-4 scheme-invoke\" ng-hide=\"InstantInvest.arnHardcodedData.schemeGroupCode || InstantInvest.arnHardcodedData.SCHEMEWISECAMP\"><span>OR</span> <span class=\"text-primary cursor-pointer\" ng-click=InstantInvest.purchaseSchemeListModal()><i class=list-icon></i> Select from List</span></div></div><div class=row ng-if=\"InstantInvest.formData.purchaseInvestmentOption===InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=\"form-label less\">Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=row><div class=\"col-md-12 form-group\" style=\"padding-left: 0\" ng-class=\"{\'radio-disabled\':(InstantInvest.purchaseValidations.isEnabled==\'N\')}\" ng-if=\"InstantInvest.formData.purchaseInvestmentOption===InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div ng-class=\"{\'anything-disabled\': (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.isSchemeTypeELSS) || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT && InstantInvest.purchaseValidations.dividendPayoutApplicable === false) || (_option == InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.purchaseValidations.dividendReinvestmentApplicable === false) }\" class=radio-block ng-repeat=\"_option in InstantInvest.devidendOptions\"><span class=radio><input type=radio id=pDividendOption{{_option}} ng-value=_option ng-disabled=\"\n                 ((_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST)\n                 && (InstantInvest.purchaseValidations.endingType === InstantInvest.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED))\n                  || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.isSchemeTypeELSS) || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT && InstantInvest.purchaseValidations.dividendPayoutApplicable === false) || (_option == InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.purchaseValidations.dividendReinvestmentApplicable === false)\" name=pDividendOption ng-model=InstantInvest.formData.purchaseDividendOption> <span class=check></span> </span><span class=radio-label>{{InstantInvest.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div class=\"row form-group\" ng-if=\"InstantInvest.isSchemeTypeELSS && InstantInvest.formData.purchaseInvestmentOption == InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[\'DIVIDEND\']\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div><div class=row><div class=\"col-md-3 col-sm-6 row\"><div class=\"input-normal icon-input\" ng-class=\"{error:(InstantInvest.tForm.pAmount.$invalid && InstantInvest.tForm.pAmount.$dirty)||(InstantInvest.formData.purchaseAmount&&InstantInvest.isPurchaseMin),\'has-data\':InstantInvest.formData.purchaseAmount}\"><input type=number ignore-mouse-wheel name=pAmount ng-model=InstantInvest.formData.purchaseAmount ng-change=InstantInvest.checkPurchaseValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ondrop=\"return false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" required><!--ng-disabled=\"!fForm.$valid\" InstantInvest.isRequired--> <span class=highlight></span> <span class=bar></span><label>Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"InstantInvest.tForm.pAmount.$invalid && InstantInvest.tForm.pAmount.$dirty\"><span class=error-input ng-show=InstantInvest.tForm.pAmount.$error.required ng-bind=InstantInvest.VALIDATE_DATA.AMOUNT_REQUIRED></span> </span><span ng-if=\"InstantInvest.formData.purchaseAmount && InstantInvest.isPurchaseMin\" class=error-input>{{\'Minimum amount should be \'+ InstantInvest.purchaseMinAmount}}<span ng-if=\"InstantInvest.formData.purchaseAmount%1 != 0\">, </span></span><span ng-if=\"InstantInvest.formData.purchaseAmount && InstantInvest.isPurchaseMax\" class=error-input>{{\'Maximum amount should be \'+ InstantInvest.maxAmount}}<span ng-if=\"InstantInvest.formData.purchaseAmount%1 != 0\">, </span></span><span ng-if=\"InstantInvest.formData.purchaseAmount && !InstantInvest.isPurchaseMin && (InstantInvest.purchaseValidations.purchaseMultiple && !InstantInvest.isMultiples)\" class=error-input>Please provide amount in multiples of &#8377;{{InstantInvest.purchaseValidations.purchaseMultiple|unit}}<span ng-if=\"Transaction.formData.purchaseAmount%1 != 0\">, </span></span><span ng-if=\"InstantInvest.formData.purchaseAmount && InstantInvest.formData.purchaseAmount%1 != 0\" class=error-input ng-class=\"{errorDown: InstantInvest.formData.purchaseAmount && InstantInvest.isPurchaseMin}\">{{\"Amount can\'t be decimal\"}}</span></div><div class=form-group><label id=divDisplayWords>{{InstantInvest.amountInWords}} (In Words)</label></div></div></div></div>");
$templateCache.put("app/instant-investment/redemption/redeem.success.html","<section><div class=content-area><div class=row><div class=\"col-md-5 col-sm-6\"><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{InstantInvest.formData.folioNumber}}</td></tr><tr><td>CAMS Reference No.</td><td>:</td><td>{{InstantInvest.camsReferenceNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{InstantInvest.transactionType | camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{InstantInvest.outSchemeName}}</td></tr><tr ng-if=\"InstantInvest.amountType === InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT\"><td>Redemption Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{InstantInvest.amount}}<br><label id=reedemstatusDisplayWords>{{InstantInvest.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"InstantInvest.amountType === InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td>Redemption Units</td><td>:</td><td>{{InstantInvest.units.toFixed(3)}}</td></tr><tr ng-if=\"InstantInvest.amountType === InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Units</td><td>:</td><td>All Free Units</td></tr><tr><td>Bank Name</td><td>:</td><td>{{InstantInvest.formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{InstantInvest.formData.bankInfo.bankAcNo}}</td></tr><!--<tr>\n          <td>Branch</td>\n          <td>:</td>\n          <td>{{InstantInvest.formData.bankInfo.bankBranch}}</td>\n        </tr>--><tr><td>IFSC</td><td>:</td><td easyassist-key=mask-element>{{InstantInvest.formData.bankInfo.ifscCode}}</td></tr><tr><td>Payout</td><td>:</td><td>{{InstantInvest.formData.bankInfo.payoutDescription |camelcase}}</td></tr></table></div><div class=\"col-md-7 col-sm-6 status-grid text-center centerAlign\"><div><div><p class=verify-sign><i class=verify-icon></i></p><p class=\"status-info green\">Transaction Initiated Successfully</p><div ng-if=\"!InstantInvest.isFavourite == \'false\'\" class=fav-block><div class=checkbox><input type=checkbox ng-disabled=InstantInvest.favrouitModel ng-model=InstantInvest.favrouitModel ng-change=InstantInvest.favrouiteApi(InstantInvest.transactionId)> <i class=icon-favorite></i></div><strong class=text-blue>Mark as a Favourite Transaction</strong></div></div><button type=button ng-click=InstantInvest.goToHome() class=\"btn btn-primary-action\" style=\"margin: 12px\">Go to Home</button></div></div></div></div></section><style>.centerAlign{\n    display:flex;\n    justify-content:center;\n    align-items: center;\n  }</style>");
$templateCache.put("app/instant-investment/redemption/redemption.html","<div class=redeem><div class=row><div class=\"col-sm-12 col-md-4 content-box\" style=\"padding-left: 0px\"><p class=col-head>Select Scheme</p><div class=\"input-select input-normal\" ng-class=\"{error:InstantInvest.tForm.$dirty && InstantInvest.tForm.$invalid, \'anything-disabled\': !InstantInvest.formData.folioNumber }\"><input type=text name=outScheme id=outScheme ng-change=InstantInvest.filterOutSchemeList() ng-model=InstantInvest.outSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><span class=error-input ng-show=\"InstantInvest.tForm.outScheme.$dirty && InstantInvest.tForm.outScheme.$invalid && InstantInvest.tForm.outScheme.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=InstantInvest.outSchemeList display-key=schemeName hdfc-click=InstantInvest.outSchemeChanged(data) model=InstantInvest.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{InstantInvest.outSchemeName}}</p></div><div ng-class=\"{\'anything-disabled\': !InstantInvest.formData.folioNumber }\" class=value-snippet ng-if=InstantInvest.unitsDetails><div><p class=text-uppercase>Total Market Value</p><span class=left-val easyassist-key=mask-element>{{InstantInvest.unitsDetails.totalCurrentValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{InstantInvest.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{InstantInvest.unitsDetails.lockedValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{InstantInvest.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value</p><span class=left-val easyassist-key=mask-element>{{InstantInvest.unitsDetails.freeValueUnits | number:3}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{InstantInvest.unitsDetails.freeValueAmount|unit}}</span></div><p class=text-primary>*as of last business day</p></div></div><div ng-class=\"{\'anything-disabled\': !InstantInvest.formData.folioNumber }\" class=\"col-sm-12 col-md-4 content-box\"><p class=col-head>Select Value</p><div class=form-group><div class=radio-block><span class=radio><input type=radio id=amount name=amountType ng-value=InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT ng-model=InstantInvest.amountType ng-disabled=!InstantInvest.unitsDetails.freeValueAmount ng-change=InstantInvest.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>Amount</span></div><div class=radio-block><span class=radio><input type=radio id=allUnits name=amountType ng-value=InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS ng-model=InstantInvest.amountType ng-disabled=!InstantInvest.unitsDetails.freeValueAmount ng-change=InstantInvest.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>All Free units</span></div><div class=radio-block><span class=radio><input type=radio id=noOfUnits name=amountType ng-value=InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS ng-model=InstantInvest.amountType ng-disabled=!InstantInvest.unitsDetails.freeValueAmount ng-change=InstantInvest.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>No. of units</span></div></div><div class=\"input-normal icon-input\" ng-if=\"InstantInvest.amountType==InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT\" ng-class=\"{error:(InstantInvest.tForm.amount.$dirty && InstantInvest.tForm.amount.$invalid),\'has-data\':InstantInvest.amount}\"><input type=number ignore-mouse-wheel ng-disabled=!InstantInvest.unitsDetails.freeValueAmount name=amount onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-change=InstantInvest.checkRedeemValidations() ng-model=InstantInvest.amount class=pd20 required> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"InstantInvest.tForm.amount.$dirty && InstantInvest.tForm.amount.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"InstantInvest.amount && InstantInvest.isMin\" class=error-input>Amount must be greater or equal to {{InstantInvest.validations.minAmount.toFixed(2)}}<!-- Amount cannot be less than the minimum required amount in the target scheme--> </span><span ng-if=\"InstantInvest.amount && InstantInvest.isMax\" class=error-input>Amount cannot exceed value of clear units available to redeem </span><span ng-if=\"InstantInvest.amount && !InstantInvest.isMax && !InstantInvest.isMin && (InstantInvest.validations.amountMultiples&&!InstantInvest.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{InstantInvest.validations.amountMultiples|unit}}</span><div style=\"padding-top: 20px\"><div id=divDisplayWords>{{InstantInvest.amountInWords}} <span>(In Words)</span></div></div></div><div class=input-normal ng-if=\"InstantInvest.amountType ==\'units\'\" ng-class=\"{error:(InstantInvest.tForm.units.$dirty && InstantInvest.tForm.units.$invalid)}\"><input type=number ignore-mouse-wheel ng-disabled=!InstantInvest.unitsDetails.freeValueUnits ng-change=InstantInvest.checkRedeemValidations() name=units ng-model=InstantInvest.units ng-required=InstantInvest.isRequired autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter Units</label><span class=error-input ng-show=InstantInvest.tForm.units.$error.required ng-bind=InstantInvest.VALIDATE_DATA.UNITS_REQUIRED></span> <span ng-if=\"InstantInvest.units !== \'\' && InstantInvest.isMin\" class=error-input>Unit must be greater or equal to {{InstantInvest.validations.minUnits.toFixed(3)}}<!--Value of units cannot be less than the minimum required amount in the target scheme--> </span><span ng-if=\"InstantInvest.units && InstantInvest.isMax\" class=error-input>Units cannot exceed clear units available to redeem</span></div><div class=input-normal><div class=estimate-block ng-if=InstantInvest.tForm.$valid><a href=\"\" ng-click=InstantInvest.downloadReport()><strong>Estimated Exit Load</strong></a><div>This InstantInvest may have exit load charges as per AMC guidelines for this scheme</div></div></div></div><div ng-class=\"{\'anything-disabled\': !InstantInvest.formData.folioNumber }\" class=\"col-sm-12 col-md-4 content-box\"><p class=col-head>Select Bank For Payout</p><div class=selectfield ng-class=\"{error:InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$invalid}\"><select name=bank ng-disable=!InstantInvest.bankList ng-model=InstantInvest.formData.bankInfo ng-options=\"bank.bankName for bank in InstantInvest.bankList track by bank.payoutId\" ng-change=InstantInvest.changedBank() ng-init=\"InstantInvest.formData.bankInfo=InstantInvest.formData.bankInfo?InstantInvest.formData.bankInfo: null\" required><option value=\"\" selected>{{InstantInvest.bankList&&!InstantInvest.bankList.length?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=InstantInvest.formData.bankInfo.bankName>Select Bank</label><span class=error-input ng-show=\"InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.BANK_REQUIRED></span></div><span class=text-green>Please click here to see your registered payout banks.</span><table class=\"table borderless\" ng-if=InstantInvest.formData.bankInfo&&InstantInvest.bankList.length><tr><td>Bank Name:</td><td>{{InstantInvest.formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{InstantInvest.formData.bankInfo.bankAcNo}}</td></tr><tr><td>IFSC:</td><td>{{InstantInvest.formData.bankInfo.ifscCode}}</td></tr><tr><td>Payout:</td><td>{{InstantInvest.formData.bankInfo.payoutDescription | uppercase}}</td></tr></table></div><div class=\"col-sm-12 col-md-12\"><ng-bind-html ng-bind-html=InstantInvest.noteRedemption.content></ng-bind-html></div></div></div><div ng-if=InstantInvest.formData.isSummaryViewEnabled><instantinvest-summary form-data=InstantInvest.summaryData is-summary-view-enabled=InstantInvest.formData.isSummaryViewEnabled instantinvest-type={{InstantInvest.InstantInvestType}} show-terms=InstantInvest.showTerms></instantinvest-summary></div><style>.content-box{\n        border-right: 1px solid #ddd !important;\n      }</style>");
$templateCache.put("app/instant-investment/redemption/summary.redeem.html","<div class=summary><p class=page-title>REVIEW TRANSACTION : Redemption</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=InstantInvest.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=InstantInvest.formData.isThroughDistributor>{{InstantInvest.formData.brokerCode?\'ARN-\'+InstantInvest.formData.brokerCode:(InstantInvest.formData.distributorARN?InstantInvest.formData.distributorARN:\'\')}}</td><td ng-if=!InstantInvest.formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=InstantInvest.formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=InstantInvest.formData.isThroughRia>{{InstantInvest.formData.brokerCode?InstantInvest.formData.brokerCode:(InstantInvest.formData.distributorARN?InstantInvest.formData.distributorARN:\'\')}}</td><td ng-if=!InstantInvest.formData.brokerCode>N/A</td></tr><tr ng-if=InstantInvest.formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=InstantInvest.formData.brokerName>{{InstantInvest.formData.brokerName}}</td><td ng-if=!InstantInvest.formData.brokerName>N/A</td></tr><!--Sub Broker columns--><tr ng-if=InstantInvest.formData.subBrokerARN><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+InstantInvest.formData.subBrokerARN}}</td></tr><tr ng-if=\"InstantInvest.formData.euin && InstantInvest.euinName\"><td>EUIN Name</td><td>:</td><td>{{InstantInvest.euinName}}</td></tr><tr><td>Folio No.</td><td>:</td><td>{{InstantInvest.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{InstantInvest.formData.investmentType| camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{InstantInvest.outSchemeName}}</td></tr><tr ng-if=InstantInvest.amount><td>Redemption Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{InstantInvest.amount}}<br><label id=amountInWords>{{InstantInvest.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"InstantInvest.units && InstantInvest.amountType === InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td>Redemption Units</td><td>:</td><td>{{InstantInvest.units}}</td></tr><tr ng-if=\"InstantInvest.amountType===InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>All Free Units</td><td>:</td><td>Yes</td></tr><tr><td>Bank Name</td><td>:</td><td>{{InstantInvest.formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{InstantInvest.formData.bankInfo.bankAcNo}}</td></tr><tr><td>IFSC</td><td>:</td><td>{{InstantInvest.formData.bankInfo.ifscCode}}</td></tr><tr><td>Payout</td><td>:</td><td>{{InstantInvest.formData.bankInfo.payoutDescription | uppercase}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{InstantInvest.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{InstantInvest.mobileNumber}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 0px; display: block\">Transaction acknowledgement email and SMS will be sent to above contact details registered in the folio.</label></div><div ng-if=\"InstantInvest.formData.liquidFlag===\'Y\' && !InstantInvest.formData.outSchemeName.toLowerCase().includes(\'hdfc overnight fund\')\"><label style=\"padding: 8px 0px 0px 20px; display: block\">Exit Load would be applicable as per SEBI Circular \"SEBI/HO/IMD/DF2/CIR/P/2019/101\" dated September 20, 2019. <a href=https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf target=_blank>Click here</a> to know more</label></div><div class=tc-block><h6 ng-click=redemptionConfirmModalShow()>Terms & Conditions</h6><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InstantInvest.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment.</span></div></div></div><div class=content-foot><div><a href=\"\" ng-click=InstantInvest.goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!InstantInvest.formData ng-click=InstantInvest.submitRedeemFirst($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div><style>.summary div.tc-block{\n    padding-left: 0px;\n  }</style>");
$templateCache.put("app/instant-investment/schedule_purchase/response_purchase.html","<div class=content-area><div style=\"padding: 15px\"><div class=success-content style=\"margin: 10px\"><div class=items-main><img ng-if=!InstantInvest.isModify class=success-content-img src=assets/images/scuccespage.svg width=70%> <img ng-if=InstantInvest.isModify class=success-content-img src=assets/images/modifyscuccespage.svg width=70%></div></div><div class=col-md-12><div style=\"padding: 10px;margin: auto;text-align: center;width: 100%;line-height: normal\"><h3>You shall receive reminder email to complete transaction on respective scheduled dates.</h3><br><br></div></div><div><h1 ng-if=!InstantInvest.isModify>Scheduled Transaction Details</h1><h1 ng-if=InstantInvest.isModify>Modified Scheduled Transaction Details</h1><hr></div><div style=\"margin: 30px\"><div class=row style=padding-bottom:30px><div class=\"col-md-3 pd10\"><p>Folio</p><p class=topTextSize>{{InstantInvest.schedulerResponseData.folioNumber}}</p></div><div class=\"col-md-3 pd10\"><p>Broker code</p><p class=topTextSize><span ng-if=!InstantInvest.schedulerResponseData.arn>DIRECT</span> <span ng-if=InstantInvest.schedulerResponseData.arn>{{InstantInvest.schedulerResponseData.arn}}</span></p></div><div class=\"col-md-3 pd10\" ng-if=\"InstantInvest.formData.euin &&  InstantInvest.formData.euin.euinCode\"><p>EUIN</p><p class=topTextSize>{{InstantInvest.formData.euin.euinCode}}</p></div><div class=\"col-md-3 pd10\"><p>Transaction Type</p><p class=topTextSize>Schedule Purchase</p></div><div class=\"col-md-3 pd10\" ng-if=InstantInvest.schedulerResponseData.scheduleId><p>Transaction Reference No</p><p class=topTextSize>{{InstantInvest.schedulerResponseData.scheduleId}}</p></div><div class=\"col-md-3 pd10\"><p>Scheme Name</p><p class=topTextSize>{{InstantInvest.schedulerResponseData.schemeName}}</p></div><div class=\"col-md-3 pd10\"><p>Payment Mode</p><p class=topTextSize ng-if=\"InstantInvest.schedulePurchasePayload.bankDetails.payMech == \'NETBANKING\'\">Net Banking</p><p class=topTextSize ng-if=\"InstantInvest.schedulePurchasePayload.bankDetails.payMech == \'OTM\'\">One Time Mandate</p><p class=topTextSize ng-if=\"InstantInvest.schedulePurchasePayload.bankDetails.payMech == \'UPI\'\">UPI</p></div><div class=\"col-md-3 pd10\"><p>Amount</p><p class=topTextSize><i class=rupee-black-icon></i>{{InstantInvest.schedulerResponseData.amount}}</p></div><div class=\"col-md-3 pd10\"><p>Frequency</p><p class=topTextSize ng-if=\"InstantInvest.schedulerResponseData.frequency == \'OM\'\">Monthly</p><p class=topTextSize ng-if=\"InstantInvest.schedulerResponseData.frequency == \'FN\'\">Fortnightly</p><p class=topTextSize ng-if=\"InstantInvest.schedulerResponseData.frequency == \'OW\'\">Weekly</p></div></div><div class=row><div class=\"col-md-3 pd10\"><p>Scheduled Start Date</p><p class=topTextSize>{{InstantInvest.schedulePurchasePayload.purchase_scheduler_start_date}}</p></div><div class=\"col-md-3 pd10\"><p>Scheduled End Date</p><p class=topTextSize>{{InstantInvest.schedulePurchasePayload.purchase_scheduler_end_date}}</p></div><div class=\"col-md-3 pd10\" ng-if=\"InstantInvest.formData.bankInfo && InstantInvest.formData.bankInfo.omUmrn\"><p>UMRN</p><p class=topTextSize>{{InstantInvest.formData.bankInfo.omUmrn}}</p></div></div></div><div style=\"margin: 30px\"><p>In case of any queries or concerns related to your transaction, please quote Transaction number in your communication. CAMS Reference Number with Awaiting status indicate that transaction is pending to be processed at CAMS. Kindly do not initiate payment again.</p></div><div style=\"margin: 30px\" ng-if=\"InstantInvest.noNomination == null || InstantInvest.noNomination == \'\' \"><p>You have not nominated OR opted-out of nomination in your folio {{InstantInvest.formData.folioNumber}}. We recommend you to add nominee details in your folio. Please <a href=https://digital.camsonline.com/changeofnomination target=_blank style=\"color: blue\">click here</a> for adding nominee details OR opting out of nomination.</p></div></div></div><!-- fail --><!-- <div class=\"content-area\">\n  <div class=\"success-content\" style=\"margin: 10px;\">\n    <div class=\"items-main\">\n      <img class=\"success-content-img\" src=\"assets/images/failpage.svg\" />\n      <h2 class=\"success-content-desc\">Transaction Scheduled successfully!\n      </h2>\n    </div>\n  </div>\n  <div>\n    <h1>Payment Summary</h1>\n    <hr>\n  </div>\n  <div style=\"margin: 30px;\">\n    <p>Your transaction is rejected due to : {{}}</p>\n    <p>If your account is debited and fund are transerred, please do not transact again. For clarification write to <a href=\"\">hello@hdfc.com</a> or call 1800 3010 6767(Toll Free)</p>\n  </div>\n  <div style=\"margin: 30px;\">\n    <p>You have not nominated OR opted-out of nomination in your folio {{InstantInvest.formData.folioNumber}}. We recommend you to add nominee details in your folio. Please <a href=\"\">click</a> here for adding nominee details OR opting out of nomination.</p>\n  </div>\n  <div style=\"margin: 30px;display: flex;justify-content: center;align-items: center;\">\n    <button ng-click=\"HomeInstant.logoutMe()\" class=\"btn-primary-action btn\">Go Home</button>\n  </div>\n</div> --><style>.topTextSize {\n    font-family: Proxima Nova;\n    font-size: 16px;\n    font-weight: bold;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: left;\n  }\n\n  .pd10 {\n    padding: 10px;\n  }\n\n  .items-main {\n    text-align: center;\n  }</style>");
$templateCache.put("app/instant-investment/schedule_purchase/schedule_purchase.html","<div id=lumpsum-form><div class=row><label class=form-label>Add Scheme</label></div><div class=row><div class=\"col-md-3 col-sm-6 row\"><div class=\"input-select input-normal\" ng-class={error:InstantInvest.tForm.pInScheme1.$invalid}><input type=text name=pInScheme1 id=pInScheme1 ng-change=InstantInvest.filterPurchaseInSchemeList() ng-model=InstantInvest.formData.purchaseInSchemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off ng-required=InstantInvest.isRequired capitalize><!--ng-disabled=\"!fForm.$valid\"--> <span class=highlight></span> <span class=bar></span><label>Select a Scheme</label><span class=error-input ng-show=InstantInvest.tForm.pInScheme1.$error.required ng-bind=InstantInvest.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=InstantInvest.purchaseInSchemeList display-key=scheme hdfc-click=InstantInvest.purchaseInSchemeChanged(data) model=InstantInvest.formData.purchaseInSchemeCode for=pInScheme1></drop-down><p class=info-primary>{{InstantInvest.formData.purchaseInSchemeName}}</p></div></div><div class=\"col-md-offset-1 col-sm-offset-1 col-md-4 col-sm-4 scheme-invoke\" ng-hide=InstantInvest.arnHardcodedData.schemeGroupCode><span>OR</span> <span class=\"text-primary cursor-pointer\" ng-click=InstantInvest.purchaseSchemeListModal()><i class=list-icon></i> View All Scheme</span></div></div><div class=row ng-if=\"InstantInvest.formData.purchaseInvestmentOption===InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=\"form-label less\">Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=row><div class=\"col-md-12 form-group\" style=\"padding-left: 0\" ng-class=\"{\'radio-disabled\':(InstantInvest.purchaseValidations.isEnabled==\'N\')}\" ng-if=\"InstantInvest.formData.purchaseInvestmentOption===InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div ng-class=\"{\'anything-disabled\': (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.isSchemeTypeELSS) || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT && InstantInvest.purchaseValidations.dividendPayoutApplicable === false) || (_option == InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.purchaseValidations.dividendReinvestmentApplicable === false) }\" class=radio-block ng-repeat=\"_option in InstantInvest.devidendOptions\"><span class=radio><input type=radio id=pDividendOption{{_option}} ng-value=_option ng-disabled=\"\n                 ((_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST)\n                 && (InstantInvest.purchaseValidations.endingType === InstantInvest.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED))\n                  || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.isSchemeTypeELSS) || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT && InstantInvest.purchaseValidations.dividendPayoutApplicable === false) || (_option == InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.purchaseValidations.dividendReinvestmentApplicable === false)\" name=pDividendOption ng-model=InstantInvest.formData.purchaseDividendOption> <span class=check></span> </span><span class=radio-label>{{InstantInvest.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div class=\"row form-group\" ng-if=\"InstantInvest.isSchemeTypeELSS && InstantInvest.formData.purchaseInvestmentOption == InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[\'DIVIDEND\']\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div><!-- Frequency Start --><div class=row ng-if=InstantInvest.formData.purchaseInSchemeName><label class=\"form-label less\">Installment Frequency</label></div><div class=row ng-if=InstantInvest.formData.purchaseInSchemeName><div class=\"col-md-6 col-sm-6 form-group\"><div class=radio-block ng-repeat=\"freq in InstantInvest.scheduleFrequencyList\"><span class=radio><input type=radio id=\"{{freq.key+\'1\'}}\" ng-change=InstantInvest.schedulePurchaseChangeFrequency() ng-model=InstantInvest.formData.frequency ng-value=freq.key name=installmentFrequency><!--ng-disabled=\"!fForm.$valid\"--> <span class=check></span> </span><span class=radio-label>{{freq.value}}</span></div></div></div><!-- Frequency End --><!-- Amount Start --><div class=row ng-if=InstantInvest.formData.purchaseInSchemeName><div class=\"col-md-3 col-sm-6 row\"><div class=\"input-normal icon-input\" ng-class=\"{error:(InstantInvest.tForm.pAmount.$invalid && InstantInvest.tForm.pAmount.$dirty)||(InstantInvest.formData.purchaseAmount&&InstantInvest.isPurchaseMin),\'has-data\':InstantInvest.formData.purchaseAmount}\"><input type=number ignore-mouse-wheel name=pAmount ng-model=InstantInvest.formData.purchaseAmount ng-change=InstantInvest.checkPurchaseValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ondrop=\"return false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" required><!--ng-disabled=\"!fForm.$valid\" InstantInvest.isRequired--> <span class=highlight></span> <span class=bar></span><label>Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"InstantInvest.tForm.pAmount.$invalid && InstantInvest.tForm.pAmount.$dirty\"><span class=error-input ng-show=InstantInvest.tForm.pAmount.$error.required ng-bind=InstantInvest.VALIDATE_DATA.AMOUNT_REQUIRED></span> </span><span ng-if=\"InstantInvest.formData.purchaseAmount && InstantInvest.isPurchaseMin\" class=error-input>{{\'Minimum amount should be \'+ InstantInvest.purchaseMinAmount}}<span ng-if=\"InstantInvest.formData.purchaseAmount%1 != 0\">, </span></span><span ng-if=\"InstantInvest.formData.purchaseAmount && InstantInvest.isPurchaseMax\" class=error-input>{{\'Maximum amount should be \'+ InstantInvest.maxAmount}}<span ng-if=\"InstantInvest.formData.purchaseAmount%1 != 0\">, </span></span><span ng-if=\"InstantInvest.OtmAmountMax && InstantInvest.formData.sipPaymentOption == \'OTM\'\" class=error-input>Amount cannot be greater than OTM Max Amount</span> <span ng-if=\"InstantInvest.formData.purchaseAmount && !InstantInvest.isPurchaseMin && (InstantInvest.purchaseValidations.purchaseMultiple && !InstantInvest.isMultiples)\" class=error-input>Please provide amount in multiples of &#8377;{{InstantInvest.purchaseValidations.purchaseMultiple|unit}}<span ng-if=\"Transaction.formData.purchaseAmount%1 != 0\">, </span></span><span ng-if=\"InstantInvest.formData.purchaseAmount%1 != 0\" class=error-input ng-class=\"{errorDown: InstantInvest.formData.purchaseAmount && InstantInvest.isPurchaseMin}\">{{\"Amount can\'t be decimal\"}}</span></div><div class=form-group><label id=divDisplayWords>{{InstantInvest.amountInWords}} (In Words)</label></div></div></div><div class=row ng-if=InstantInvest.formData.purchaseInSchemeName><button class=amountData ng-click=InstantInvest.updateAmount(5000)>₹5,000</button> <button class=amountData ng-click=InstantInvest.updateAmount(10000)>₹10,000</button> <button class=amountData ng-click=InstantInvest.updateAmount(15000)>₹15,000</button></div><!-- Amount End --><!-- Payment Option Start --><div class=row style=\"margin-top: 15px !important\" ng-if=InstantInvest.formData.purchaseInSchemeName><label class=\"form-label less\">Payment Options</label></div><div class=row ng-if=InstantInvest.formData.purchaseInSchemeName><div style=\"padding-left: 0px\" class=\"col-sm-12 col-md-12 form-group\"><div class=radio-block ng-repeat=\"_option in InstantInvest.paymentOptions \"><span class=radio ng-hide=\"(_option == \'E-mandate\' && InstantInvest.dateDiff > InstantInvest.emandateMaxYear) || (_option == \'E-mandate\' && InstantInvest.noEmandateBank) || ((_option == \'NETBANKING\' || _option == \'UPI\') && InstantInvest.noECBank) ||  ((_option == \'OTM\' && InstantInvest.noOTMBank) ||( _option == \'OTM\' && InstantInvest.purchaseValidations.schemeType == \'LIQUID\') ||( _option == \'E-mandate\' && InstantInvest.formData.minorFlag))\"><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-change=InstantInvest.changedSchedulePaymentOption() ng-model=InstantInvest.formData.sipPaymentOption> <span class=check></span> </span><span class=radio-label ng-hide=\"(_option == \'E-mandate\' && InstantInvest.dateDiff > InstantInvest.emandateMaxYear) || (_option == \'E-mandate\' && InstantInvest.noEmandateBank) || ((_option == \'NETBANKING\' || _option == \'UPI\') && InstantInvest.noECBank) ||  ((_option == \'OTM\' && InstantInvest.noOTMBank) ||( _option == \'OTM\' && InstantInvest.purchaseValidations.schemeType == \'LIQUID\'))\">{{InstantInvest.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div ng-if=\"InstantInvest.paymentOptions && !InstantInvest.paymentOptions.length && InstantInvest.formData.purchaseInSchemeName\" class=bank-error-msg>No payment method is found for this folio</div><!-- Emandate Payment option Start --><div class=borderline ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && InstantInvest.emandateDisplay && InstantInvest.formData.purchaseInSchemeName\"><div class=row><label id=authModeLabel style=top:5px class=\"form-label less col-md-2\">Select Bank</label><div class=\"col-sm-12 col-md-3\" style=\"margin-bottom: 8px !important; \n      margin-left: 0px !important;\n      padding-left: 0px !important\"><div class=selectfield ng-class=\"{error:InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$invalid}\"><select name=bank ng-disabled=false ng-model=InstantInvest.formData.bankInfo ng-options=\"bank.bankName for bank in InstantInvest.bankList track by bank.bankName\" ng-change=InstantInvest.changeBank() ng-init=\"InstantInvest.formData.bankInfo = InstantInvest.formData.bankInfo ? InstantInvest.formData.bankInfo : null\" required><option value=\"\" selected>{{InstantInvest.bankList&&!InstantInvest.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=InstantInvest.formData.bankInfo>Select Bank</label><span class=error-input ng-show=\"InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$error.required && !InstantInvest.formData.bankName\" ng-bind=InstantInvest.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><div class=row ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" ng-class=\"{error:InstantInvest.tForm.authenticationMode.$dirty && InstantInvest.tForm.authenticationMode.$invalid}\"><label id=authModeLabel style=top:5px class=\"form-label less col-md-2\">Authentication Mode</label><div class=\"selectfield col-md-3\" style=\"margin-bottom: 8px !important; \n      margin-left: 0px !important;\n      padding-left: 0px !important\"><div class=selectauthdrop><select name=authenticationMode ng-disable=!InstantInvest.authenticationMode class=authModeDropdown ng-model=InstantInvest.formData.authMode ng-options=\"auth.text for auth in InstantInvest.authenticationMode\" ng-init=\"InstantInvest.formData.authMode=InstantInvest.formData.authMode?InstantInvest.formData.authMode: null\" required><option value=\"\" selected>{{InstantInvest.authenticationMode&&!InstantInvest.authenticationMode.length ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}</option></select><span class=error-input ng-show=\"InstantInvest.tForm.authenticationMode.$dirty && InstantInvest.tForm.authenticationMode.$error.required && !InstantInvest.formData.authMode\" ng-bind=InstantInvest.VALIDATE_DATA.AUTHENTICATION_MODE_REQUIRED></span></div></div></div><div class=row ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\"><label id=authModeLabel style=top:5px class=\"form-label less col-md-2\">Mandate Amount</label><div class=\"input-normal icon-input col-md-3\" style=\"margin-bottom: 8px !important; \n      margin-left: 0px !important;\n      padding-left: 0px !important\"><i class=rupee-small-icon style=\"display: block\"></i> <input type=number ignore-mouse-wheel name=Amount ng-model=InstantInvest.formData.EmgAmount ng-change=InstantInvest.checkAmountValidationSchedule() style=width:100%><div class=text-success>Maximum allowed for e-mandate is Rs. {{InstantInvest.emandateDetail.maxAmountLimit}}.</div><div class=error-input ng-show=InstantInvest.amountLess>Amount of e-mandate cannot be less than Rs. {{InstantInvest.emandateDetail.minAmountLimit}}</div><div class=error-input ng-show=InstantInvest.amountMore>Amount of e-mandate cannot be greater than Rs. {{InstantInvest.emandateDetail.maxAmountLimit}}</div><div class=error-input ng-show=\"InstantInvest.amountEMgMore && !InstantInvest.amountLess && !InstantInvest.amountMore\">Mandate amount cannot be less than Purchase entered amount.</div></div></div><div class=row ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\"><label id=authModeLabel style=top:5px class=\"form-label less col-md-2\">Mandate Start Date</label><div class=\"col-md-3 anything-disabled\" ng-if=!InstantInvest.isReseting><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode={{InstantInvest.viewMode}} data-date-default=InstantInvest.formData.emandateDate id=emandateStartDate data-enable=true style=\"position: relative\"><input type=text name=emandateStartDate placeholder=DD-MMM-YYYY readonly></div></div></div><div class=row ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\"><label id=authModeLabel style=top:5px class=\"form-label less col-md-2\">Mandate End Date</label><div class=\"sip-dates col-md-3\"><div ng-class=\"{\'anything-disabled\': !InstantInvest.formData.emandateDate}\"><div class=form-group ng-if=!InstantInvest.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal eEndDate\" ng-class=\"{error:InstantInvest.tForm.endDateEmandate.$dirty && InstantInvest.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InstantInvest.formData.endDateEmandate data-enabled-dates=InstantInvest.enabledEmandateEndDatesList data-view-date=InstantInvest.enabledEndDateView data-max-date=InstantInvest.maxEndDateEmandate data-min-date=InstantInvest.minEndDateEmandate data-on-date-change=InstantInvest.changeScheduleEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><!-- data-min-date=\"InstantInvest.formData.minEndDate\"--> <input type=text name=endDateEmandate autocomplete=off placeholder=DD-MMM-YYYY readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><!-- <span class=\"highlight\">Mandate end date must be greater than schedule end date</span> --> <span class=bar ng-if=InstantInvest.errorEmandate style=color:red>Mandate end date must be greater than schedule end date</span></div></div></div></div></div><!-- <div class=\"point-to-note\">\n      Please Note: <br />\n      <ul>\n        <li>To register e-mandate you would be redirected to Net Banking login page. A debit of Rs 1/- may be carried out to your account for registration depending on the selected bank.</li>\n        <li>This e-Mandate would get registered as part of SIP transaction with relevant details fetched as entered on this screen and would be available under OTM\n          payment mode for registering fresh SIPs and lump sum purchase transactions.</li>\n        <li>E-mandate (eOTM) registration is not applicable for minor and NRI investors </li>\n        <li>As per NPCI Circular NPCI/2023-24/NACH/008, mandate can be registered for a maximum duration of 30 years from the date of issuance.</li>\n      </ul>\n    </div>  --></div><!-- Emandate Payment Option End --><!-- 1 NETBANKING  --><div ng-if=\"InstantInvest.formData.purchaseInSchemeName && (InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING || InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)\"><div class=row><div class=\"col-sm-12 col-md-3\"><div class=selectfield ng-class=\"{error:InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$invalid}\"><select name=bank ng-disabled=false ng-model=InstantInvest.formData.bankInfo ng-init=\"InstantInvest.formData.bankInfo=InstantInvest.formData.bankInfo ? InstantInvest.formData.bankInfo : null\" ng-options=\"bank.bankName for bank in InstantInvest.bankECList track by bank.bankName\" ng-change=InstantInvest.changeBank() required><option value=\"\" selected>{{InstantInvest.bankECList&&!InstantInvest.bankECList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=InstantInvest.formData.bankInfo>Select Bank</label><span class=error-input ng-show=\"InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$error.required && !InstantInvest.formData.bankName\" ng-bind=InstantInvest.VALIDATE_DATA.BANK_REQUIRED></span></div></div><div style=margin-top:2px class=\"col-sm-12 col-md-4\" ng-if=InstantInvest.showIFSCField><div class=input-normal ng-class=\"{error:InstantInvest.tForm.ifscCode.$invalid && InstantInvest.tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=InstantInvest.formData.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"InstantInvest.tForm.ifscCode.$dirty && InstantInvest.tForm.ifscCode.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"InstantInvest.tForm.ifscCode.$dirty && InstantInvest.tForm.ifscCode.$error.pattern\" ng-bind=InstantInvest.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div class=\"col-sm-12 col-md-4\" ng-if=InstantInvest.showAccountTypeField><div class=selectfield ng-class=\"{error:InstantInvest.tForm.accountType.$dirty && InstantInvest.tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!InstantInvest.accountTypeList ng-model=InstantInvest.formData.accountType ng-options=\"account.accountType for account in InstantInvest.accountTypeList\" ng-init=\"InstantInvest.accountTypeList = InstantInvest.accountTypeList ? InstantInvest.accountTypeList : null\" ng-change=InstantInvest.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=InstantInvest.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=\"InstantInvest.tForm.accountType.$dirty && InstantInvest.tForm.accountType.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div></div></div><!-- 2 OTM --><div class=borderline ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM\"><!-- otp verify for otm bank --><!-- <div class=\"row\" ng-if=\"!InstantInvest.isOtmOtpVerified\">\n      <div class=\"col-sm-12 col-md-12 instantInvestOtmSection\">\n        <p class=\"otp-sent\" ng-if=\"InstantInvest.isOtmVisible\">{{InstantInvest.otpSentMessage}}</p>\n      </div>\n      <div class=\"col-sm-12 col-md-4 instantInvestOtmSection\">\n        <div class=\"\">\n          <div class=\"input-normal\" ng-class=\"{\'anything-disabled\': !InstantInvest.isOtmVisible}\">\n            <input type=\"text\" ng-model=\"InstantInvest.otmOtp\" name=\"otmotp\"\n               ng-maxlength=\"6\"\n               maxlength=\"6\"\n               is-number\n               required>\n            <div class=\"bar\"></div>\n            <div class=\"highlight\"></div>\n            <label>OTP<span class=\"req\">*</span></label>\n            <span class=\"error-input\" ng-show=\"InstantInvest.tForm.otmotp.$dirty && InstantInvest.tForm.otmotp.$error.required\"\n                  ng-bind=\"InstantInvest.VALIDATE_DATA.OTP_REQUIRED\"></span>\n            <span class=\"error-input\"\n                  ng-show=\"InstantInvest.tForm.otmotp.$dirty && InstantInvest.tForm.otmotp.$error.number\"\n                  ng-bind=\"InstantInvest.VALIDATE_DATA.OTP_FIELD\"></span>\n            <span class=\"error-input\" ng-show=\"InstantInvest.tForm.otmotp.$dirty && InstantInvest.tForm.otmotp.$error.maxlength\"\n                  ng-bind=\"InstantInvest.VALIDATE_DATA.OTP_FIELD\"></span>\n          </div>\n          <div class=\"otmResendOtp\" ng-if=\"InstantInvest.isOtmVisible\">\n            <timer countdown=\"InstantInvest.resendOtpCounter\" interval=\"1000\">\n              <a ng-show=\"countdown === 0\" href=\"\" ng-click=\"InstantInvest.resendOtp()\">Resend OTP</a>\n              <a ng-show=\"countdown > 0\">Enable Resend OTP in {{countdown}}s</a>\n            </timer>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-sm-12 col-md-2 instantInvestOtmSection\">\n        <button type=\"button\" ng-if=\"InstantInvest.formData.sipPaymentOption ===\'OTM\' && InstantInvest.isOtmVisible\"\n          ng-disabled=\"!InstantInvest.otmOtp\"\n          ng-click=\"InstantInvest.submitOtmOtp()\" ng-disabled = \"!InstantInvest.isOtmVisible\" class=\"btn btn-primary-action\">Verify OTP\n        </button>\n      </div>\n    </div> --><!-- OTM Select bank --><div class=row><div class=\"col-sm-12 col-md-3\"><div class=selectfield ng-class=\"{error:(InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$invalid)\n            || (InstantInvest.formData.bankInfo && InstantInvest.formData.bankInfo.otmFrequency != \'AWP\'\n            && InstantInvest.formData.frequency == \'BZ\')}\"><select name=bank ng-disabled=!InstantInvest.OTMbankList ng-model=InstantInvest.formData.bankInfo ng-options=\"bank.bankName for bank in InstantInvest.OTMbankList track by bank.omUmrn\" ng-change=InstantInvest.changeBank() ng-init=\"InstantInvest.formData.bankInfo = InstantInvest.formData.bankInfo ? InstantInvest.formData.bankInfo : null\" required><option value=\"\" selected>{{InstantInvest.OTMbankList&&!InstantInvest.OTMbankList.length ?\'No Bank Available\':\'Select OTM Bank\'}}</option></select><label ng-if=InstantInvest.formData.bankInfo>Select Bank</label><span class=error-input ng-show=\"InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.BANK_REQUIRED></span> <span ng-if=\"InstantInvest.tForm.bank.$dirty && (InstantInvest.formData.otmBank\n            && InstantInvest.selectedFrequency.key === \'BZ\'\n            && InstantInvest.formData.bankInfo.otmFrequency != \'AWP\')\" class=error-input><!-- Otm end date should be on or before selected end date.--> Invalid OTM Bank, OTM Instruction Type not AWP(As & When Presented)</span></div></div><div class=row style=margin-top:2px><div class=\"col-sm-12 col-md-4\" ng-if=InstantInvest.showIFSCField><div class=input-normal ng-class=\"{error:InstantInvest.tForm.ifscCode.$invalid && InstantInvest.tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=InstantInvest.formData.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"InstantInvest.tForm.ifscCode.$dirty && InstantInvest.tForm.ifscCode.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"InstantInvest.tForm.ifscCode.$dirty && InstantInvest.tForm.ifscCode.$error.pattern\" ng-bind=InstantInvest.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div class=\"col-sm-12 col-md-4\"><div ng-if=InstantInvest.showAccountTypeField class=selectfield ng-class=\"{error:InstantInvest.tForm.accountType.$dirty && InstantInvest.tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!InstantInvest.accountTypeList ng-model=InstantInvest.formData.accountType ng-options=\"account.accountType for account in InstantInvest.accountTypeList\" ng-init=\"InstantInvest.accountTypeList = InstantInvest.accountTypeList ? InstantInvest.accountTypeList : null\" ng-change=InstantInvest.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=InstantInvest.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=\"InstantInvest.tForm.accountType.$dirty && InstantInvest.tForm.accountType.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div></div></div><div class=row><div class=\"col-sm-12 col-md-7\"><table class=\"table borderless\" ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM && InstantInvest.formData.bankInfo\"><tr><td class=otmTableWidth>Account No:</td><td>{{InstantInvest.formData.bankInfo.bankAcNo}}</td></tr><tr><td class=otmTableWidth>OTM UMRN No:</td><td>{{InstantInvest.formData.bankInfo.omUmrn}}</td></tr><tr><td class=otmTableWidth>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{InstantInvest.formData.bankInfo.maxAmount}} <span class=error-input ng-show=InstantInvest.isOTMAmount ng-bind=InstantInvest.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR></span></td></tr><tr><td class=otmTableWidth>OTM Instruction Type:</td><td>{{InstantInvest.formData.bankInfo.otmFrequencyName? InstantInvest.formData.bankInfo.otmFrequencyName : InstantInvest.formData.bankInfo.otmFrequency}}</td></tr><tr><td>OTM Start Date:</td><td>{{InstantInvest.formData.bankInfo.omStartDate}}</td></tr><tr><td>OTM Expiry Date:</td><td>{{InstantInvest.formData.bankInfo.omExpiryDate}} <span class=error-input ng-show=InstantInvest.isOTMDate ng-bind=InstantInvest.VALIDATE_DATA.DATE_VALIDATION_ERROR></span></td></tr></table></div></div></div><!-- Payment Option End --><!-- dynamic Node started --><ng-bind-html ng-if=\"InstantInvest.formData.sipPaymentOption == \'NETBANKING\' || InstantInvest.formData.sipPaymentOption == \'OTM\'\" dynamic=InstantInvest.setSchedulePurchaseDynamicDetails.noteDTO.noteDTOMap.Note_SP_NB_QI.content></ng-bind-html><ng-bind-html ng-if=\"InstantInvest.formData.sipPaymentOption == \'E-mandate\'\" dynamic=InstantInvest.setSchedulePurchaseDynamicDetails.noteDTO.noteDTOMap.Note_SP_OTM_QI.content></ng-bind-html><ng-bind-html ng-if=\"InstantInvest.formData.sipPaymentOption == \'UPI\'\" dynamic=InstantInvest.dynamicData.noteDTO.noteDTOMap.Note_Quick_Investment_UPI.content></ng-bind-html><!-- Dynamic Note Ended   --><!-- Date Selection Start  --><div class=col-md-12 style=\"margin-top: 20px\" ng-if=InstantInvest.formData.purchaseInSchemeName><div class=row><div class=col-md-2 style=\"padding: 0px\"><p class=form-label style=\"margin-bottom: 0px !important\">Scheduled Start Date</p><div class=\"input-group date date-picker transaction-cal date-input\" ng-class=\"{error:InstantInvest.startDate.$dirty && InstantInvest.startDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode={{InstantInvest.viewMode}} data-date-default=InstantInvest.formData.startDate data-enabled-dates=InstantInvest.enabledOTMStartDatesList data-min-date=InstantInvest.enabledMINStartDates data-max-date=InstantInvest.startMaxDate data-on-date-change=InstantInvest.changeScheduleStartDate data-enable=true id=StartDate style=\"position: relative\"><input class=calenderinputBox type=text name=startDate placeholder=DD-MMM-YYYY style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InstantInvest.startDate.$error.required ng-bind=InstantInvest.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div><div class=col-md-2 style=\"padding: 0px\"><p class=form-label style=\"margin-bottom: 0px !important\">Scheduled End Date</p><div class=\"input-group date date-picker transaction-cal date-input\" ng-class=\"{\'anything-disabled\':!InstantInvest.formData.startDate || InstantInvest.formData.isTillPerpetuity}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InstantInvest.formData.endDate data-on-date-change=InstantInvest.changeScheduleEndDate data-enabled-dates=InstantInvest.enabledEndDates data-min-date=InstantInvest.minEndDate data-max-date=\"InstantInvest.enabledEndDates[InstantInvest.enabledEndDates.length - 1]\" data-enable=true data-view-date=InstantInvest.enabledEndDateView showdefault=false id=endDate-EC><input class=calenderinputBox type=text name=endDate id=endDate ng-model=InstantInvest.formData.endDate autocomplete=off placeholder=DD-MMM-YYYY style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar ng-if=InstantInvest.amountErrorEmandate style=color:red>Scheduled end date cannot be greater than mandate end date</span> <span class=error-input ng-show=\"InstantInvest.formData.endDate.$dirty && InstantInvest.formData.endDate.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.END_DATE_REQUIRED></span> <span class=error-input ng-show=InstantInvest.isOTMEndDate ng-bind=InstantInvest.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div></div><div class=col-md-3 style=\"margin-top: 25px\"><div class=\"euinDecCheck row\" ng-if=\"InstantInvest.formData.sipPaymentOption != \'E-mandate\'\"><div><div><span class=checkbox><div class=\"checkDec mob-w\" style=\"margin-left: 18px\"><input ng-class=\"{\'anything-disabled\':!InstantInvest.formData.startDate}\" type=checkbox class=\"nomineeCheckbox col-xs-12 col-md-1\" name=defaultdate id=defaultdate ng-model=InstantInvest.formData.isTillPerpetuity ng-change=InstantInvest.setDec2099Date()> <span ng-class=\"{\'anything-disabled\':!InstantInvest.formData.startDate}\" class=icon-checkbox></span> <span ng-class=\"{\'anything-disabled\':!InstantInvest.formData.startDate}\" class=checkbox-text href=javaScript:void(0) for=defaultdate>Default End Date Dec-2099</span></div></span></div></div></div></div></div></div></div><style>.amountData {\n    width: 123px !important;\n    height: 35px !important;\n\n    border-color: #F3F9FF;\n    padding: 16px, 29px, 16px, 29px;\n    border-radius: 32px;\n    Background: #F3F9FF;\n    font-family: Proxima Nova;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 18px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #004B8B;\n    text-align: center;\n    height: 30px;\n    width: 120px;\n    margin-right: 16px;\n\n  }</style>");
$templateCache.put("app/instant-investment/schedule_purchase/summary.schedulepurchase.html","<div class=summary><p class=page-title>REVIEW TRANSACTION : SCHEDULE PURCHASE</p><div class=\"content-area clearfix instant-review\"><div class=col-md-6><table class=\"table borderless\"><tr ng-if=InstantInvest.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=InstantInvest.formData.isThroughDistributor>{{InstantInvest.formData.brokerCode?\'ARN-\'+InstantInvest.formData.brokerCode:(InstantInvest.formData.distributorARN?InstantInvest.formData.distributorARN:\'\')}}</td><td ng-if=!InstantInvest.formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=InstantInvest.formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=InstantInvest.formData.isThroughRia>{{InstantInvest.formData.brokerCode?InstantInvest.formData.brokerCode:(InstantInvest.formData.distributorARN?InstantInvest.formData.distributorARN:\'\')}}</td><td ng-if=!InstantInvest.formData.brokerCode>N/A</td></tr><tr ng-if=InstantInvest.formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=InstantInvest.formData.brokerName>{{InstantInvest.formData.brokerName}}</td><td ng-if=!InstantInvest.formData.brokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"InstantInvest.formData.isThroughDistributor && InstantInvest.formData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+InstantInvest.formData.subBrokerARN}}</td></tr><tr ng-if=\"InstantInvest.formData.isThroughDistributor && InstantInvest.formData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td>{{InstantInvest.formData.subBrokerCode}}</td></tr><tr ng-if=\"InstantInvest.formData.euin && InstantInvest.formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{InstantInvest.formData.euin.euinCode}}</td></tr><tr ng-if=\"InstantInvest.formData.euin && InstantInvest.formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{InstantInvest.formData.euin.euinName}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{InstantInvest.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>Schedule Purchase</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{InstantInvest.formData.purchaseInSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{InstantInvest.formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND ? InstantInvest.formData.investmentOption : (InstantInvest.formData.investmentOption | uppercase)}}</td></tr><tr ng-if=\"InstantInvest.formData.investmentOption.toUpperCase() == \'DIVIDEND\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td><span ng-if=\"InstantInvest.formData.purchaseDividendOption.toUpperCase() == \'Y\'\">Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option </span><span ng-if=\"InstantInvest.formData.purchaseDividendOption.toUpperCase() == \'N\'\">Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{InstantInvest.formData.purchaseAmount}}</td></tr><tr><td>Schedule Frequency</td><td>:</td><td><span ng-if=\"InstantInvest.formData.frequency == \'FN\'\">Fortnightly </span><span ng-if=\"InstantInvest.formData.frequency == \'OM\'\">Monthly </span><span ng-if=\"InstantInvest.formData.frequency == \'OW\'\">Weekly</span></td></tr><tr><td>Scheduled Start Date</td><td>:</td><td>{{InstantInvest.formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Scheduled End Date</td><td>:</td><td>{{InstantInvest.formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"InstantInvest.formData.sipPaymentOption ==\'NETBANKING\'\">Net Banking</td><td ng-if=\"InstantInvest.formData.sipPaymentOption ==\'OTM\'\">OTM (One Time Mandate)</td><td ng-if=\"InstantInvest.formData.sipPaymentOption == \'E-mandate\'\">E-Mandate</td><td ng-if=\"InstantInvest.formData.sipPaymentOption == \'UPI\'\">UPI</td></tr><tr ng-if=\"(InstantInvest.formData.bankInfo.bankName==\'HDFC BANK\' && InstantInvest.formData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{InstantInvest.formData.bankAcNo}}</td></tr><tr ng-if=\"InstantInvest.formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{InstantInvest.formData.bankInfo.omUmrn}}</td></tr></table></div><div class=col-md-6><table class=\"borderless table\" ng-if=\"InstantInvest.formData.sipPaymentOption == \'E-mandate\'\"><tr ng-if=\"InstantInvest.formData.sipPaymentOption == \'E-mandate\'\"><td style=\"color: black\"><u><strong>Emandate Registration Details</strong></u></td></tr><tr><td class=eMandateReview>Bank Name</td><td class=eMandateRow>:</td><td>{{InstantInvest.formData.bankInfo.bankName.substring(0,InstantInvest.formData.bankInfo.bankName.indexOf(\"-\"))}}</td></tr><tr><td class=eMandateReview>Account Number</td><td class=eMandateRow>:</td><td>{{InstantInvest.formData.bankInfo.accountNumber}}</td></tr><tr><td class=eMandateReview>Amount</td><td class=eMandateRow>:</td><td><i class=rupee-small-icon></i> {{InstantInvest.formData.EmgAmount}}</td></tr><tr><td class=eMandateReview>Frequency</td><td class=eMandateRow>:</td><td>As and when presented</td></tr><tr><td class=eMandateReview>Start Date</td><td class=eMandateRow>:</td><td>{{InstantInvest.formData.emandateDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td class=eMandateReview>End Date</td><td class=eMandateRow>:</td><td>{{InstantInvest.formData.endDateEmandate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td class=eMandateReview>Purpose of Mandate</td><td class=eMandateRow>:</td><td>Mutual Fund Payment</td></tr></table></div><div class=col-md-6><table class=\"borderless table\"><tr><td class=\"eMandateReview instant-summary\">Email ID</td><td class=eMandateRow>:</td><td>{{InstantInvest.arnHardcodedData.maskedEmail}}</td></tr><tr><td class=\"eMandateReview instant-summary\">Mobile Number</td><td class=eMandateRow>:</td><td>{{InstantInvest.arnHardcodedData.maskedMobileNumber}}</td></tr></table></div><div class=tc-block><div><h6>Terms & Conditions</h6><div class=checkbox style=\"display: unset !important\"><input ng-model=InstantInvest.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>&nbsp; I have read and understood <a ng-click=InstantInvest.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div><br><div ng-if=\"InstantInvest.formData.sipPaymentOption == \'E-mandate\'\"><div class=checkbox><input id=isCheckedTandCeMandate ng-model=InstantInvest.isCheckedTandCeMandate type=checkbox ng-change=InstantInvest.ischeckedem()> <i class=icon-checkbox></i><label for=isCheckedTandCeMandate style=\"padding-left: 0px !important\" class=checkbox-text>&nbsp; I have read and understood <a ng-click=InstantInvest.showTermConditionsEmandateForSchedulePurchase() href=javaScript:void(0)>Terms & Conditions</a> of e-mandate (eOTM)</label></div></div></div><!-- EC/OTM --><div class=\"col-md-12 form-footer\" ng-if=\"InstantInvest.formData.sipPaymentOption != \'E-mandate\'\"><div><a href=\"\" ng-click=InstantInvest.goToBack() class=\"cursor-pointer text-primary pull-left\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-click=InstantInvest.modifyTransaction($event) ng-disabled=\"!InstantInvest.isCheckedTandC || !InstantInvest.formData\" class=\"btn-primary-action btn pull-right\"><span ng-if=!InstantInvest.isModify>Schedule Transaction</span><span ng-if=InstantInvest.isModify>Modify Schedule Transaction</span></button></div></div><!-- E-mandate --><div class=\"col-md-12 form-footer\" ng-if=\"InstantInvest.formData.sipPaymentOption == \'E-mandate\'\"><div><a href=\"\" ng-click=InstantInvest.goToBack() class=\"cursor-pointer text-primary pull-left\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=\"!InstantInvest.isCheckedTandC || !InstantInvest.isCheckedTandCeMandate || !InstantInvest.formData\" ng-click=InstantInvest.modifyTransaction($event) class=\"btn-primary-action btn pull-right\"><span ng-if=!InstantInvest.isModify>Schedule Transaction</span><span ng-if=InstantInvest.isModify>Modify Schedule Transaction</span></button></div></div></div></div>");
$templateCache.put("app/instant-investment/sip/sip.html","<div id=SIP-form><div class=row><label class=form-label>Add Scheme</label></div><div class=row><div class=\"col-md-3 col-sm-6 row\"><div class=\"input-select input-normal\" ng-class={error:InstantInvest.tForm.sInScheme1.$invalid}><input type=text name=sInScheme1 id=sInScheme1 ng-change=InstantInvest.filterInSchemeList() ng-model=InstantInvest.formData.inSchemeName autocomplete=off onpaste=\"return false\" ondrop=\"return false\" ng-required=InstantInvest.isRequired capitalize><!--ng-disabled=\"!fForm.$valid\"--> <span class=highlight></span> <span class=bar></span><label>Select a Scheme</label><span class=error-input ng-show=InstantInvest.tForm.sInScheme1.$error.required ng-bind=InstantInvest.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=InstantInvest.inSchemeList display-key=scheme hdfc-click=\"InstantInvest.inSchemeChanged(data, \'sip\')\" model=InstantInvest.formData.inSchemeCode for=sInScheme1></drop-down><p class=info-primary>{{InstantInvest.formData.inSchemeName}}</p></div></div><div class=\"col-md-offset-1 col-sm-offset-1 col-md-4 col-sm-4 scheme-invoke\" ng-hide=\"InstantInvest.arnHardcodedData.schemeGroupCode || InstantInvest.arnHardcodedData.CAMP || InstantInvest.arnHardcodedData.SCHEMEWISECAMP\"><span>OR</span> <span class=\"text-primary cursor-pointer\" ng-click=InstantInvest.schemeListModal()><i class=list-icon></i> Select from List</span></div></div><div class=row><label class=\"form-label less\">Installment Frequency</label></div><div class=row><div class=\"col-md-6 col-sm-6 form-group\"><div class=radio-block ng-if=\"InstantInvest.formData.frequency && InstantInvest.formData.inSchemeName\" ng-repeat=\"freq in InstantInvest.frequencyList\" ng-class=\"{\'daily-anything-disabled\': (freq.code === \'BZ\' && !InstantInvest.isOTMEnabled) ||\n                 ((freq.code === \'OW\' || freq.code === \'BZ\') && (InstantInvest.formData.minorFlag && InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.isHdfcBank))}\"><span class=radio><input type=radio id=\"{{freq.code+\'1\'}}\" ng-change=InstantInvest.changeFrequency(freq.code) ng-model=InstantInvest.formData.frequency ng-value=freq.code name=installmentFrequency><!--ng-disabled=\"!fForm.$valid\"--> <span class=check></span> </span><span class=radio-label>{{freq.name}}</span> <i class=\"info-icon base-tooltip\" ng-if=\"freq.code === \'BZ\'\" tooltip data-bs-toggle=tooltip data-bs-placement=right style=\"Z-INDEX: 36\" data-bs-title=\"Mode of payment through Daily SIP shall be only through OTM of frequency - As and when presented.\n               SIP Top Up facility is not available for Daily SIP. For Daily SIP, OTM bank must have OTM Instruction Type as AWP. Daily SIP end date can be only on a business day. \" tooltip-side=right></i></div></div></div><div class=row><div class=\"col-md-3 col-sm-6 row\"><div class=\"input-normal icon-input\" ng-class=\"{error:(InstantInvest.tForm.sAmount.$invalid && InstantInvest.tForm.sAmount.$dirty)\n           ,\'has-data\':InstantInvest.formData.amount}\"><input type=number ignore-mouse-wheel name=sAmount ng-model=InstantInvest.formData.amount ng-change=InstantInvest.checkSipValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" required><!--ng-disabled=\"!fForm.$valid\" InstantInvest.isRequired--> <span class=highlight></span> <span class=bar></span><label>SIP Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"InstantInvest.tForm.sAmount.$invalid && InstantInvest.tForm.sAmount.$dirty\"><span class=error-input ng-show=\"InstantInvest.tForm.sAmount.$invalid && InstantInvest.tForm.sAmount.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.AMOUNT_REQUIRED></span> </span><span ng-if=\"InstantInvest.formData.amount && InstantInvest.isMin\" class=error-input>Minimum amount should be &#8377; {{InstantInvest.validations.minAmount|unit}}</span> <span ng-if=\"InstantInvest.formData.amount && InstantInvest.isMax && InstantInvest.formData.sipPaymentOption !== InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=error-input>Maximum amount should be &#8377; {{InstantInvest.validations.maxAmount|unit}}</span> <span ng-if=\"InstantInvest.formData.amount && !InstantInvest.isMax && !InstantInvest.isMin && (InstantInvest.validations.amountMultiples && !InstantInvest.isMultiples) && !InstantInvest.amountExceeded\" class=error-input>Please Provide In multiples of &#8377; {{InstantInvest.validations.amountMultiples|unit}}</span> <span ng-show=\"InstantInvest.tForm.sAmount.$dirty && InstantInvest.amountExceeded\" class=error-input ng-bind=InstantInvest.VALIDATE_DATA.AMOUNT_EXCEEDED></span><!--        <span ng-if=\"InstantInvest.formData.amount && InstantInvest.isMax && InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=\"error-input\">SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode</span>--></div><div class=form-group><label id=divDisplayWords>{{InstantInvest.amountInWords}} (In Words)</label></div></div><div class=\"col-sm-12 col-md-6 amount-button-container\" ng-if=InstantInvest.formData.inSchemeCode><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in InstantInvest.sipFirstInstallmentAmount\" ng-click=\"InstantInvest.formData.amount = amount; InstantInvest.checkSipValidations()\"><img src=../../assets/images/rupee-indian.svg>{{amount}}</button></div></div><div class=row ng-if=\"InstantInvest.formData.inSchemeCode && (InstantInvest.formData.frequency !== \'BZ\' && InstantInvest.formData.frequency !== \'OW\') \"><div class=\"col-sm-12 col-md-12 px-0\"><label class=form-label>Do you wish to pay First installment with your SIP Registration:</label><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-class=\"{\'anything-disabled\':(InstantInvest.formData.minorFlag && InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.isHdfcBank)}\" ng-model=InstantInvest.sipFirstInstallment ng-change=InstantInvest.changeFirstInstallment(true) ng-disabled=\"(InstantInvest.formData.minorFlag && InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.isHdfcBank) \" ng-value=true> <span class=check></span> </span><span class=radio-label>Yes</span></div><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=InstantInvest.sipFirstInstallment ng-change=InstantInvest.changeFirstInstallment(false) ng-value=false> <span class=check></span> </span><span class=radio-label>No</span></div></div></div><!--<div class=\"row\" ng-if=\"InstantInvest.sipFirstInstallment && InstantInvest.formData.frequency !== \'BZ\'\">\n    <div class=\"col-md-3 row\">\n      <div class=\"input-normal icon-input\"\n           ng-class=\"{error:(InstantInvest.tForm.sFirstAmount.$invalid && InstantInvest.tForm.sFirstAmount.$dirty),\'has-data\':InstantInvest.formData.sipFirstAmount}\">\n        <input type=\"number\" ignore-mouse-wheel name=\"sFirstAmount\"\n               ng-model=\"InstantInvest.formData.sipFirstAmount\"\n               ng-change=\"InstantInvest.checkSipFirstValidations()\"\n               onkeyup=\"NumToWord(this.value,\'divDisplayWordFirstInstallment\');\"\n               required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Amount</label>\n        <i class=\"rupee-grey-icon\"></i>\n        <span class=\"error-input\"\n              ng-show=\"InstantInvest.tForm.sFirstAmount.$dirty && InstantInvest.tForm.sFirstAmount.$error.required\"\n              ng-bind=\"InstantInvest.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>\n        <span ng-if=\"InstantInvest.formData.sipFirstAmount && InstantInvest.isFirstMin\" class=\"error-input\">Minimum amount should be &#8377; {{InstantInvest.validations.minAmount|unit}}</span>\n        <span ng-if=\"InstantInvest.formData.sipFirstAmount && InstantInvest.isFirstMax && InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=\"error-input\">SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode</span>\n        <span ng-if=\"InstantInvest.formData.sipFirstAmount && InstantInvest.isFirstMax && InstantInvest.formData.sipPaymentOption != InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=\"error-input\">Maximum amount should be &#8377; {{InstantInvest.validations.maxAmount|unit}}</span>\n        <span\n          ng-if=\"InstantInvest.formData.sipFirstAmount && !InstantInvest.isFirstMax && !InstantInvest.isFirstMin && (InstantInvest.validations.amountMultiples && !InstantInvest.isFirstMultiples)\"\n          class=\"error-input\">Please Provide In multiples of &#8377; {{InstantInvest.validations.amountMultiples|unit}}</span>\n      </div>\n      <div class=\"form-group\">\n        <label id=\"divDisplayWordFirstInstallment\">{{InstantInvest.amountInWords}} (In Words)</label>\n      </div>\n    </div>\n    <div class=\"col-md-offset-3 row amount-button-container\" ng-if=\"InstantInvest.formData.inSchemeCode\">\n      <button class=\"btn-sip-first-install-action\" type=\"button\"\n             ng-repeat=\"amount in InstantInvest.sipFirstInstallmentAmount\"\n              ng-click=\"InstantInvest.formData.sipFirstAmount = amount; InstantInvest.checkSipFirstValidations()\">\n        <img src=\"../../assets/images/rupee-indian.svg\">{{amount}}</button>\n    </div>\n  </div>--><div class=row ng-if=\"InstantInvest.validations.investmentOption===InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=\"form-label less\">Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=row><div style=\"padding-left: 0\" class=\"col-sm-12 col-md-12 form-group\" ng-class=\"{\'radio-disabled\':(InstantInvest.validations.isEnabled==\'N\')}\" ng-if=\"InstantInvest.validations.investmentOption===InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div ng-class=\"{\'anything-disabled\': (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.isSchemeTypeELSS) || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT && InstantInvest.inSchemeValidations.dividendPayoutApplicable === false) || (_option == InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.inSchemeValidations.dividendReinvestmentApplicable === false)}\" class=radio-block ng-repeat=\"_option in InstantInvest.devidendOptions\"><span class=radio><input type=radio id=sDividendOption{{_option}} ng-value=_option name=sDividendOption ng-model=InstantInvest.formData.sipDividendOption ng-disabled=\"((_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST)\n            && (InstantInvest.validations.endingType === InstantInvest.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED))\n            || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.isSchemeTypeELSS) || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT && InstantInvest.inSchemeValidations.dividendPayoutApplicable === false) || (_option == InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.inSchemeValidations.dividendReinvestmentApplicable === false) \"> <span class=check></span> </span><span class=radio-label>{{InstantInvest.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div class=\"row form-group\" ng-if=\"InstantInvest.isSchemeTypeELSS && InstantInvest.validations.investmentOption == InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[\'DIVIDEND\']\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div><!--Payment start here--><div class=row><label class=\"form-label less\">Payment Options</label></div><div class=row><div style=\"padding-left: 0px\" class=\"col-sm-12 col-md-12 form-group\" ng-if=\"InstantInvest.formData.frequency!=\'BZ\'\"><div class=radio-block ng-repeat=\"_option in InstantInvest.paymentOptions track by $index\"><span class=radio ng-if=\"!(!InstantInvest.isOTMEnabled && _option==\'OTM\') && !(InstantInvest.arnHardcodedData && _option==\'UPI\') && !(InstantInvest.PARTNER_DATA && _option==\'UPI\') || (InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.isHdfcBank && _option !== \'UPI\') \"><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-change=InstantInvest.changedPaymentOption() ng-model=InstantInvest.formData.sipPaymentOption> <span class=check></span> </span><span class=radio-label ng-if=\"!(!InstantInvest.isOTMEnabled && _option==\'OTM\') && !(InstantInvest.arnHardcodedData && _option==\'UPI\') && !(InstantInvest.PARTNER_DATA && _option==\'UPI\') || (InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.isHdfcBank && _option !== \'UPI\')\">{{InstantInvest.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div><div class=col-md-12><ng-bind-html dynamic=InstantInvest.Note_Quick_Investment_SIP_One_Click.content ng-if=\"InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.isHdfcBank\"></ng-bind-html></div><div class=\"col-sm-12 col-md-12 form-group\" ng-if=\"InstantInvest.formData.frequency==\'BZ\'\"><div class=radio-block><span class=radio style=\"margin-left: 10px\"><input type=radio id=paymentOptionE-upi value=UPI name=paymentOption ng-change=InstantInvest.changedPaymentOption() ng-model=InstantInvest.formData.sipPaymentOption> <span class=check></span> </span><span class=radio-label>UPI Autopay</span></div><div class=radio-block ng-if=!InstantInvest.arnHardcodedData.isHdfcBank><span class=radio ng-if=InstantInvest.isOTMEnabled><input type=radio id=paymentOptionOTM value=OTM name=paymentOption ng-change=InstantInvest.changedPaymentOption() ng-model=InstantInvest.formData.sipPaymentOption> <span class=check></span> </span><span class=radio-label ng-if=InstantInvest.isOTMEnabled>OTM (One Time Mandate)</span></div><div class=radio-block><span class=radio style=\"margin-left: 10px\" ng-if=InstantInvest.isEMandateEnabled><input type=radio id=paymentOptionE-mandate value=E-mandate name=paymentOption ng-change=InstantInvest.changedPaymentOption() ng-model=InstantInvest.formData.sipPaymentOption> <span class=check></span> </span><span class=radio-label ng-if=InstantInvest.isEMandateEnabled>Register E-mandate (eOTM)</span></div></div><div class=\"col-sm-12 col-md-12\"><ng-bind-html ng-if=\"InstantInvest.paymentOptions.length > 0 && !(InstantInvest.arnHardcodedData && InstantInvest.arnHardcodedData.isHdfcBank)\" dynamic=InstantInvest.notesInstantInvestement.content></ng-bind-html></div></div><div class=borderline ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC\"><div class=row><div class=\"col-sm-12 col-md-3\"><div class=selectfield ng-class=\"{error:InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$invalid}\"><select name=bank ng-disabled=false ng-model=InstantInvest.formData.bankInfo ng-init=\"InstantInvest.formData.bankInfo=InstantInvest.formData.bankInfo ? InstantInvest.formData.bankInfo : null\" ng-options=\"bank.bankName for bank in InstantInvest.bankList track by bank.bankName\" ng-change=InstantInvest.changeBank() required><option value=\"\" selected>{{InstantInvest.bankList&&!InstantInvest.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=InstantInvest.formData.bankInfo>Select Bank</label><span class=error-input ng-show=\"InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$error.required && !InstantInvest.formData.bankName\" ng-bind=InstantInvest.VALIDATE_DATA.BANK_REQUIRED></span></div></div><div style=margin-top:2px class=\"col-sm-12 col-md-4\" ng-if=InstantInvest.showIFSCField><div class=input-normal ng-class=\"{error:InstantInvest.tForm.ifscCode.$invalid && InstantInvest.tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=InstantInvest.formData.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"InstantInvest.tForm.ifscCode.$dirty && InstantInvest.tForm.ifscCode.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"InstantInvest.tForm.ifscCode.$dirty && InstantInvest.tForm.ifscCode.$error.pattern\" ng-bind=InstantInvest.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div class=\"col-sm-12 col-md-4\" ng-if=InstantInvest.showAccountTypeField><div class=selectfield ng-class=\"{error:InstantInvest.tForm.accountType.$dirty && InstantInvest.tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!InstantInvest.accountTypeList ng-model=InstantInvest.formData.accountType ng-options=\"account.accountType for account in InstantInvest.accountTypeList\" ng-init=\"InstantInvest.accountTypeList = InstantInvest.accountTypeList ? InstantInvest.accountTypeList : null\" ng-change=InstantInvest.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=InstantInvest.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=\"InstantInvest.tForm.accountType.$dirty && InstantInvest.tForm.accountType.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div><!--<div class=\"col-md-1 text-center\" style=\"top:15px;\">OR</div>--><div class=\"col-sm-12 col-md-3\" style=margin-top:2px><div class=input-normal ng-if=\"InstantInvest.formData.bankInfo.bankCode == \'OTHER\'\" ng-class=\"{error:InstantInvest.tForm.bankName.$dirty && InstantInvest.tForm.bankName.$invalid}\"><input type=text ng-click=InstantInvest.otherBankSelected() ng-disabled=\"InstantInvest.formData.bankInfo.bankCode != \'OTHER\'||!fForm.$valid\" ng-model=InstantInvest.formData.bankName name=bankName ng-required=\"InstantInvest.formData.bankInfo.bankCode == \'OTHER\'\"> <span class=highlight></span> <span class=bar></span><label>Bank Name</label><span class=error-input ng-show=\"InstantInvest.tForm.bankName.$dirty && InstantInvest.tForm.bankName.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div></div><div class=row><div class=\"col-sm-12 col-md-12\"><ng-bind-html dynamic=InstantInvest.dynamicData.noteDTO.noteDTOMap.NOTE_SIP_SI.content></ng-bind-html></div></div><div class=row ng-if=\"InstantInvest.formData.bankInfo.bankName ==\'HDFC BANK\'\"><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class={error:InstantInvest.tForm.bankAcNo.$dirty&&InstantInvest.tForm.bankAcNo.$invalid}><input type=text ng-model=InstantInvest.formData.bankAcNo name=bankAcNo ng-disabled=!fForm.$valid required minlength=9 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" directive.mask ng-keydown=InstantInvest.copyPasteHandler($event) ng-change=InstantInvest.accFocus();> <span class=highlight></span> <span class=bar></span><label>Account Number</label><span ng-show=InstantInvest.accModelDirty><span class=error-input ng-show=\"InstantInvest.formData.bankAcNo.split(\'\').length==0\" ng-bind=InstantInvest.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(InstantInvest.formData.bankAcNo.split(\'\').length == null || (InstantInvest.formData.bankAcNo.split(\'\').length<9 && InstantInvest.formData.bankAcNo.split(\'\').length>0)) \" ng-bind=InstantInvest.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class={error:InstantInvest.tForm.verifyBankAcNo.$dirty&&InstantInvest.tForm.verifyBankAcNo.$invalid}><input type=text ng-model=InstantInvest.formData.verifyBankAcNo name=verifyBankAcNo ng-disabled=!fForm.$valid required ng-keydown=InstantInvest.copyPasteHandler($event) ng-minlength=9 ng-pattern=InstantInvest.formData.bankAcNo onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=highlight></span> <span class=bar></span><label>Verify Account Number</label><span class=error-input ng-show=InstantInvest.tForm.verifyBankAcNo.$dirty&&InstantInvest.tForm.verifyBankAcNo.$error.required ng-bind=InstantInvest.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=!InstantInvest.tForm.verifyBankAcNo.$error.required&&InstantInvest.tForm.verifyBankAcNo.$error.minlength ng-bind=InstantInvest.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!InstantInvest.tForm.verifyBankAcNo.$error.required&&!InstantInvest.tForm.verifyBankAcNo.$error.minlength&&InstantInvest.tForm.verifyBankAcNo.$error.pattern ng-bind=InstantInvest.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div></div></div><div class=borderline ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM\"><div class=row ng-if=!InstantInvest.isOtmOtpVerified><div class=\"col-sm-12 col-md-12 instantInvestOtmSection\"><p class=otp-sent ng-if=InstantInvest.isOtmVisible>{{InstantInvest.otpSentMessage}}</p></div><div class=\"col-sm-12 col-md-4 instantInvestOtmSection\"><div><div class=input-normal ng-class=\"{\'anything-disabled\': !InstantInvest.isOtmVisible}\"><input type=text ng-model=InstantInvest.otmOtp name=otmotp ng-maxlength=6 maxlength=6 is-number required><div class=bar></div><div class=highlight></div><label>OTP<span class=req>*</span></label><span class=error-input ng-show=\"InstantInvest.tForm.otmotp.$dirty && InstantInvest.tForm.otmotp.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.OTP_REQUIRED></span> <span class=error-input ng-show=\"InstantInvest.tForm.otmotp.$dirty && InstantInvest.tForm.otmotp.$error.number\" ng-bind=InstantInvest.VALIDATE_DATA.OTP_FIELD></span> <span class=error-input ng-show=\"InstantInvest.tForm.otmotp.$dirty && InstantInvest.tForm.otmotp.$error.maxlength\" ng-bind=InstantInvest.VALIDATE_DATA.OTP_FIELD></span></div><div class=otmResendOtp ng-if=InstantInvest.isOtmVisible><timer countdown=InstantInvest.resendOtpCounter interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=InstantInvest.resendOtp()>Resend OTP</a> <a ng-show=\"countdown > 0\">Enable Resend OTP in {{countdown}}s</a></timer></div></div></div><div class=\"col-sm-12 col-md-2 instantInvestOtmSection\"><button type=button ng-if=\"InstantInvest.formData.investmentType==\'SIP\' && InstantInvest.formData.sipPaymentOption ===\'OTM\' && InstantInvest.isOtmVisible\" ng-disabled=!InstantInvest.otmOtp ng-click=InstantInvest.submitOtmOtp() ng-disabled=!InstantInvest.isOtmVisible class=\"btn btn-primary-action\">Verify OTP</button></div></div><div class=row ng-if=InstantInvest.isOtmOtpVerified><div class=\"col-sm-12 col-md-3\"><div class=selectfield ng-class=\"{error:(InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$invalid)\n            || (InstantInvest.formData.bankInfo && InstantInvest.formData.bankInfo.otmFrequency != \'AWP\'\n            && InstantInvest.formData.frequency == \'BZ\')}\"><select name=bank ng-disabled=!InstantInvest.bankList ng-model=InstantInvest.formData.bankInfo ng-options=\"bank.bankName for bank in InstantInvest.bankList track by bank.omUmrn\" ng-change=InstantInvest.changeBank() ng-init=\"InstantInvest.formData.bankInfo = InstantInvest.formData.bankInfo ? InstantInvest.formData.bankInfo : null\" required><option value=\"\" selected>{{InstantInvest.bankList&&!InstantInvest.bankList.length ?\'No Bank Available\':\'Select OTM Bank\'}}</option></select><label ng-if=InstantInvest.formData.bankInfo>Select Bank</label><span class=error-input ng-show=\"InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.BANK_REQUIRED></span> <span ng-if=\"InstantInvest.tForm.bank.$dirty && (InstantInvest.formData.otmBank\n            && InstantInvest.selectedFrequency.key === \'BZ\'\n            && InstantInvest.formData.bankInfo.otmFrequency != \'AWP\')\" class=error-input><!-- Otm end date should be on or before selected end date.--> Invalid OTM Bank, OTM Instruction Type not AWP(As & When Presented)</span></div></div><div class=row style=margin-top:2px><div class=\"col-sm-12 col-md-4\" ng-if=InstantInvest.showIFSCField><div class=input-normal ng-class=\"{error:InstantInvest.tForm.ifscCode.$invalid && InstantInvest.tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=InstantInvest.formData.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"InstantInvest.tForm.ifscCode.$dirty && InstantInvest.tForm.ifscCode.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"InstantInvest.tForm.ifscCode.$dirty && InstantInvest.tForm.ifscCode.$error.pattern\" ng-bind=InstantInvest.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div class=\"col-sm-12 col-md-4\"><div ng-if=InstantInvest.showAccountTypeField class=selectfield ng-class=\"{error:InstantInvest.tForm.accountType.$dirty && InstantInvest.tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!InstantInvest.accountTypeList ng-model=InstantInvest.formData.accountType ng-options=\"account.accountType for account in InstantInvest.accountTypeList\" ng-init=\"InstantInvest.accountTypeList = InstantInvest.accountTypeList ? InstantInvest.accountTypeList : null\" ng-change=InstantInvest.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=InstantInvest.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=\"InstantInvest.tForm.accountType.$dirty && InstantInvest.tForm.accountType.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div></div></div><div class=row><div class=\"col-sm-12 col-md-7\"><table class=\"table borderless\" ng-if=\"InstantInvest.formData.bankInfo && InstantInvest.isOtmOtpVerified\"><tr><td class=otmTableWidth>Account No:</td><td>{{InstantInvest.formData.bankInfo.bankAcNo}}</td></tr><tr><td class=otmTableWidth>OTM UMRN No:</td><td>{{InstantInvest.formData.bankInfo.omUmrn}}</td></tr><tr><td class=otmTableWidth>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{InstantInvest.formData.bankInfo.maxAmount}} <span class=error-input ng-show=InstantInvest.isOTMAmount ng-bind=InstantInvest.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR></span></td></tr><tr><td class=otmTableWidth>OTM Instruction Type:</td><td>{{InstantInvest.formData.bankInfo.otmFrequencyName? InstantInvest.formData.bankInfo.otmFrequencyName : InstantInvest.formData.bankInfo.otmFrequency}}</td></tr><tr><td>OTM Start Date:</td><td>{{InstantInvest.formData.bankInfo.omStartDate}}</td></tr><tr><td>OTM Expiry Date:</td><td>{{InstantInvest.formData.bankInfo.omExpiryDate}} <span class=error-input ng-show=InstantInvest.isOTMDate ng-bind=InstantInvest.VALIDATE_DATA.DATE_VALIDATION_ERROR></span></td></tr></table></div></div></div><div ng-if=\"InstantInvest.paymentOptions && !InstantInvest.paymentOptions.length\" class=bank-error-msg>No payment method is found for this folio</div><div class=\"borderline emandate-section\" ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && InstantInvest.emandateDisplay\"><div class=row><div class=\"col-sm-12 col-md-3 label-emandate\">Select Bank</div><div class=col-md-3><div class=selectfield><select name=bank ng-disabled=false ng-model=InstantInvest.formData.bankInfo ng-options=\"bank.bankName for bank in InstantInvest.bankList track by bank.uniqueId\" ng-change=InstantInvest.changeBank() ng-init=\"InstantInvest.formData.bankInfo = InstantInvest.formData.bankInfo ? InstantInvest.formData.bankInfo : null\" required><option value=\"\" selected>{{InstantInvest.bankList&&!InstantInvest.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><span class=error-input ng-show=\"InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$error.required && !InstantInvest.formData.bankName\" ng-bind=InstantInvest.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Authentication Mode</div><div class=col-md-3><div class=selectfield ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" ng-class=\"{error:InstantInvest.tForm.authenticationMode.$dirty && InstantInvest.tForm.authenticationMode.$invalid}\"><div class=selectauthdrop><select name=authenticationMode ng-disable=!InstantInvest.authenticationMode class=authModeDropdown ng-model=InstantInvest.formData.authMode ng-options=\"auth.text for auth in InstantInvest.authenticationMode\" ng-init=\"InstantInvest.formData.authMode=InstantInvest.formData.authMode?InstantInvest.formData.authMode: null\" required><option value=\"\" selected>{{InstantInvest.authenticationMode&&!InstantInvest.authenticationMode.length ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}</option></select><span class=error-input ng-show=\"InstantInvest.tForm.authenticationMode.$dirty && InstantInvest.tForm.authenticationMode.$error.required && !InstantInvest.formData.authMode\" ng-bind=InstantInvest.VALIDATE_DATA.AUTHENTICATION_MODE_REQUIRED></span></div></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Mandate Amount</div><div class=col-md-3><div class=\"input-normal icon-input\" ng-class=\"{error:(InstantInvest.tForm.eAmount.$invalid && InstantInvest.tForm.eAmount.$dirty),\'has-data\':InstantInvest.formData.emandateAmount}\"><input type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=eAmount ng-model=InstantInvest.formData.emandateAmount ng-change=InstantInvest.checkAmountValidationEmandate() ng-maxlength=10 limit-to=10 required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><div class=amtWords ng-if=InstantInvest.formData.emandateAmount><p id=amountInwordsEmandate>{{InstantInvest.emandateWord.amountInWords}} (In Words)</p></div><!--          <span class=\"text-success\">--><!--                  Maximum allowed for e-mandate is ₹ {{InstantInvest.mandateMaxString}}.--><!--          </span>--><div class=error-input ng-show=InstantInvest.amountLess>{{InstantInvest.VALIDATE_DATA.EMANDATE_MIN_ERROR + InstantInvest.emandateMinAmountLimit}}.</div><div class=error-input ng-show=InstantInvest.amountMore>{{InstantInvest.VALIDATE_DATA.EMANDATE_MAX_ERROR + InstantInvest.mandateMaxString}}.</div><div class=error-input ng-show=\"!InstantInvest.amountLess && InstantInvest.isLessThanSipAmount\" ng-bind=InstantInvest.VALIDATE_DATA.EMANDATE_SIP_AMOUNT_ERROR></div></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Mandate Start Date</div><div class=\"col-md-3 anything-disabled\" ng-if=!InstantInvest.isReseting><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode={{InstantInvest.viewMode}} data-date-default=InstantInvest.formData.emandateDate id=emandateStartDate data-enable=true style=\"position: relative\"><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Mandate End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-bs-placement=right title={{InstantInvest.mandateInfo}}></i></div><div class=\"sip-dates col-md-3\"><div ng-class=\"{\'anything-disabled\': !InstantInvest.formData.emandateDate}\"><div class=form-group ng-if=!InstantInvest.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal eEndDate\" ng-class=\"{error:InstantInvest.tForm.endDateEmandate.$dirty && InstantInvest.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InstantInvest.formData.endDateEmandate data-enabled-dates=InstantInvest.enabledEmandateEndDatesList data-view-date=InstantInvest.enabledEndDateView data-max-date=InstantInvest.maxEndDateEmandate data-min-date=InstantInvest.minEndDateEmandate data-on-date-change=InstantInvest.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><!-- data-min-date=\"InstantInvest.formData.minEndDate\"--> <input type=text name=endDateEmandate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div></div></div><!-- E-mandate note --><ng-bind-html dynamic=InstantInvest.notesInstantInvestementEmandate.content></ng-bind-html></div><!--  UPI Payment Mode--><div class=\"borderline upi-section\" ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\"><div class=row><div class=\"col-xs-10 col-sm-6 col-md-3\"><div class=selectfield ng-class=\"{error:InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$invalid}\"><select name=bank ng-disabled=false ng-model=InstantInvest.formData.bankInfo ng-init=\"InstantInvest.formData.bankInfo=InstantInvest.formData.bankInfo ? InstantInvest.formData.bankInfo : null\" ng-options=\"bank.bankName for bank in InstantInvest.bankList track by bank.bankName\" ng-change=InstantInvest.selectedUpiBank() required><option value=\"\" selected>{{InstantInvest.bankList&&!InstantInvest.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=InstantInvest.formData.bankInfo>Select Bank</label><span class=error-input ng-show=\"InstantInvest.tForm.bank.$dirty && InstantInvest.tForm.bank.$error.required && !InstantInvest.formData.bankName\" ng-bind=InstantInvest.VALIDATE_DATA.BANK_REQUIRED></span></div></div><div class=\"col-sm-4 col-md-4\" style=\"margin-top: 3px\" ng-if=InstantInvest.showIFSCField><div class=input-normal ng-class=\"{error:InstantInvest.tForm.ifscCode.$invalid && InstantInvest.tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=InstantInvest.formData.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"InstantInvest.tForm.ifscCode.$dirty && InstantInvest.tForm.ifscCode.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"InstantInvest.tForm.ifscCode.$dirty && InstantInvest.tForm.ifscCode.$error.pattern\" ng-bind=InstantInvest.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div class=\"col-sm-4 col-md-4\" ng-if=InstantInvest.showAccountTypeField><div class=selectfield ng-class=\"{error:InstantInvest.tForm.accountType.$dirty && InstantInvest.tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!InstantInvest.accountTypeList ng-model=InstantInvest.formData.accountType ng-options=\"account.accountType for account in InstantInvest.accountTypeList\" ng-init=\"InstantInvest.accountTypeList = InstantInvest.accountTypeList ? InstantInvest.accountTypeList : null\" ng-change=InstantInvest.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=InstantInvest.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=\"InstantInvest.tForm.accountType.$dirty && InstantInvest.tForm.accountType.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div><div class=\"col-sm-12 col-md-9 vpa-view\" ng-if=InstantInvest.formData.bankInfo><div class=\"col-xs-10 col-sm-6 col-md-4 p-0\"><div class=input-normal ng-class={error:InstantInvest.tForm.virtualAddress.$invalid&&InstantInvest.tForm.virtualAddress.$dirty}><input style=\"text-transform: lowercase\" type=text ng-model=InstantInvest.formData.virtualAddress name=virtualAddress ng-pattern=InstantInvest.PATTERN.upi_virtual_addr_regex ng-change=InstantInvest.handleVpa() required ng-readonly=\"InstantInvest.formData.isUPIVerified && InstantInvest.formData.verifyUPIResp.valid === true\"><div class=bar></div><div class=highlight></div><label style=\"display: block;width: 100%\">Virtual Payment Address (UPI ID) <span class=req>*</span> <i class=edit-icon style=\"position: absolute;right: 0px; top:16px; pointer-events: all; box-sizing: content-box\" ng-if=\"InstantInvest.formData.isUPIVerified && InstantInvest.formData.verifyUPIResp.valid === true\" ng-click=\"InstantInvest.formData.isUPIVerified = false\"></i></label><span class=error-input ng-show=InstantInvest.tForm.virtualAddress.$dirty&&(InstantInvest.tForm.virtualAddress.$error.required||InstantInvest.tForm.virtualAddress.$error.pattern) ng-bind=InstantInvest.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!InstantInvest.tForm.virtualAddress.$invalid\n                  &&  (!InstantInvest.formData.isUPIVerified && InstantInvest.formData.verifyUPIResp.valid === false)\" ng-bind=InstantInvest.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span></div></div><div class=\"col-xs-12 col-sm-3 col-md-3\" ng-if=\"InstantInvest.formData.sipPaymentOption==\'UPI\' && !InstantInvest.formData.isUPIVerified\" ng-class=\"!InstantInvest.showIFSCField || !InstantInvest.showAccountTypeField ? \'col-md-3\' : \'col-md-4\'\"><button blur-on-click class=\"btn btn-primary-action\" ng-disabled=\"!InstantInvest.formData.virtualAddress || (!InstantInvest.bankInfo.minorBankFlag && InstantInvest.checkForMinorBankListCondition()) || (!InstantInvest.formData.isUPIVerified && InstantInvest.formData.verifyUPIResp.valid === false)\" ng-click=InstantInvest.verifyUPI()>Verify</button></div><div class=\"col-sm-3 col-md-2 verify-vpa verify-ack-padding\" ng-if=\"InstantInvest.formData.isUPIVerified && InstantInvest.formData.verifyUPIResp.valid === true\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{InstantInvest.formData.name}}</span></div><div class=\"col-sm-2 col-md-2 verify-vpa verify-ack-padding verify-ack-col\" ng-if=\"!InstantInvest.formData.isUPIVerified && InstantInvest.formData.verifyUPIResp.valid === false\"><p><strong><span class=error-input style=\"display:inline;font-size:100%;margin-bottom: 20px\">Not Verified</span> <i class=\"cancel-icon error-input\"></i></strong></p></div></div></div><div class=row><div class=\"col-sm-12 col-md-12\"><ng-bind-html dynamic=InstantInvest.dynamicData.noteDTO.noteDTOMap.Note_SIP_UPI.content></ng-bind-html></div></div></div><!--Payment end here--><div class=row><label class=\"form-label less\">Installment Date Details</label></div><div ng-if=\"((InstantInvest.formData.sipPaymentOption === InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) || (InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) || (InstantInvest.formData.sipPaymentOption === InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) && InstantInvest.formData.frequency === \'OW\'\"><div class=\"row form-group\"><div class=\"col-sm-12 col-md-3 selectfield\" style=\"padding-left: 0\" ng-class=\"{error:InstantInvest.tForm.day.$dirty && InstantInvest.tForm.day.$invalid}\"><label ng-if=InstantInvest.formData.weeklyDay>Select Day</label><select name=day ng-model=InstantInvest.formData.weeklyDay ng-change=InstantInvest.changeDay() ng-options=\"day as day for day in InstantInvest.daysList\" ng-init=\"InstantInvest.formData.weeklyDay=InstantInvest.formData.weeklyDay?InstantInvest.formData.weeklyDay: null\" required><option value=\"\" selected>Select Day</option></select><span class=error-input ng-show=\"InstantInvest.tForm.day.$dirty && InstantInvest.tForm.day.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.DAY_REQUIRED></span></div></div></div><div ng-if=\"((InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) ||\n       (InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) || (InstantInvest.formData.sipPaymentOption === InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) && InstantInvest.formData.frequency === \'OW\'\"><div class=row><div class=\"col-sm-12 col-md-3 col-sm-5 row\" ng-if=!InstantInvest.isReseting ng-class=\"{\'anything-disabled\':!InstantInvest.formData.weeklyDay}\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:InstantInvest.tForm.startDate.$dirty && InstantInvest.tForm.startDate.$invalid}\" date-calendar data-viewmode=days data-date-default=InstantInvest.formData.startDate data-min-date=InstantInvest.startMinDateOTM data-max-date=InstantInvest.startMaxDate data-on-date-change=InstantInvest.changeStartDate data-enabled-dates=InstantInvest.enabledStartDates id=weeklyStartDate-EC data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=InstantInvest.formData.startDate>Start Date - DD-MMM-YYYY</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InstantInvest.tForm.startDate.$error.required ng-bind=InstantInvest.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div></div><div class=\"row borderline\"><div class=sip-dates><div class=\"col-sm-12 col-md-3 col-sm-5 row\" ng-class=\"{\'anything-disabled\': !InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName,\'disable-date\': InstantInvest.disableEndDateSelection }\"><div class=form-group ng-if=!InstantInvest.isReseting ng-class=\"{\'anything-disabled\': !InstantInvest.formData.startDate }\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:InstantInvest.tForm.endDate.$dirty && InstantInvest.tForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InstantInvest.formData.endDate data-on-date-change=InstantInvest.changeEndDate data-enabled-dates=InstantInvest.enabledEndDates data-view-date=InstantInvest.enabledEndDateView data-min-date=InstantInvest.enabledEndDates[0] data-enable=true id=weeklyEndDate-EC><input type=text name=endDate autocomplete=off id=endDateCalenderWeekly placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon ng-click=InstantInvest.handleMandateCalender()><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span><label ng-if=InstantInvest.formData.endDate>End Date - DD-MMM-YYYY</label><span class=bar></span> <span class=error-input ng-show=\"InstantInvest.formData.weeklyDay && InstantInvest.tForm.day.$dirty && InstantInvest.tForm.day.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.MONTH_REQUIRED></span> <span class=error-input ng-show=\"InstantInvest.formData.weeklyDay && InstantInvest.tForm.day.$dirty && InstantInvest.tForm.day.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.END_DATE_REQUIRED></span> <span class=error-input ng-show=\"InstantInvest.formData.weeklyDay && InstantInvest.isOTMEndDate\" ng-bind=InstantInvest.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span> <span style=\"word-spacing: -1px\" class=error-input ng-show=\"InstantInvest.formData.sipPaymentOption === InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && InstantInvest.sipDateLessEmandate\" ng-bind=InstantInvest.VALIDATE_DATA.EMANDATE_DATE_EXCEED_ERROR></span></div></div></div><div class=\"col-md-1 col-sm-1 text-center or-part\" ng-if=\"InstantInvest.formData.sipPaymentOption != \'E-mandate\' && InstantInvest.formData.sipPaymentOption !== InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\">OR</div><div class=\"col-md-4 col-sm-6 default-date\" ng-if=\"InstantInvest.formData.sipPaymentOption != \'E-mandate\' && InstantInvest.formData.sipPaymentOption !== InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\" ng-class=\"{\'anything-disabled\': !InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName }\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=weeklyDefaultDate-EC ng-class=\"{\'anything-disabled\': !InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName}\" ng-model=InstantInvest.formData.isTillPerpetuity ng-change=InstantInvest.changeTillPerpetuityFlag() ng-disabled=\"!InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName\"> <span class=icon-checkbox></span></span><label for=defaultDate>Choose Default End Date, which is 2099</label></div></div></div></div><div ng-if=\"((InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) ||\n       (InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) || (InstantInvest.formData.sipPaymentOption === InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) && InstantInvest.formData.frequency !== \'OW\'\"><div class=row ng-class=\"{\'anything-disabled\': !InstantInvest.formData.inSchemeName}\"><div class=\"col-md-3 col-sm-5 row\" ng-if=!InstantInvest.isReseting><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:InstantInvest.tForm.startDate.$dirty && InstantInvest.tForm.startDate.$invalid}\" date-calendar data-viewmode=months data-date-default=InstantInvest.formData.startDate data-min-date=InstantInvest.startMinDateBiller data-max-date=InstantInvest.startMaxDate data-on-date-change=InstantInvest.changeStartDate id=startDate-EC data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=InstantInvest.formData.startDate>Start Date - DD-MMM-YYYY</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InstantInvest.tForm.startDate.$error.required ng-bind=InstantInvest.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div></div><div class=\"row borderline\"><div class=sip-dates><div class=\"col-md-3 col-sm-5 row\" ng-class=\"{\'anything-disabled\': !InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName,\'disable-date\': InstantInvest.disableEndDateSelection }\"><div class=form-group ng-if=!InstantInvest.isReseting><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:InstantInvest.tForm.endDate.$dirty && InstantInvest.tForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InstantInvest.formData.endDate data-on-date-change=InstantInvest.changeEndDate data-enabled-dates=InstantInvest.enabledEndDates data-view-date=InstantInvest.enabledEndDateView data-min-date=InstantInvest.enabledEndDates[0] data-enable=true id=endDate-EC><input type=text name=endDate autocomplete=off id=endDateCalender placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon ng-click=InstantInvest.handleMandateCalender()><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span><label ng-if=InstantInvest.formData.endDate>End Date - DD-MMM-YYYY</label><span class=bar></span> <span class=error-input ng-show=\"InstantInvest.tForm.day.$dirty && InstantInvest.tForm.day.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.MONTH_REQUIRED></span> <span style=\"word-spacing: -1px\" class=error-input ng-show=\"InstantInvest.formData.sipPaymentOption === InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && InstantInvest.sipDateLessEmandate\" ng-bind=InstantInvest.VALIDATE_DATA.EMANDATE_DATE_EXCEED_ERROR></span></div></div></div><div class=\"col-md-1 col-sm-1 text-center or-part\" ng-if=\"InstantInvest.formData.sipPaymentOption != \'E-mandate\' && InstantInvest.formData.sipPaymentOption !== InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\">OR</div><div class=\"col-md-4 col-sm-6 default-date\" ng-if=\"InstantInvest.formData.sipPaymentOption != \'E-mandate\' && InstantInvest.formData.sipPaymentOption !== InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\" ng-class=\"{\'anything-disabled\': !InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName }\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=defaultDate-EC ng-class=\"{\'anything-disabled\': !InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName }\" ng-model=InstantInvest.formData.isTillPerpetuity ng-change=InstantInvest.changeTillPerpetuityFlag() ng-disabled=\"!InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName\"> <span class=icon-checkbox></span></span><label for=defaultDate>Choose Default End Date, which is 2099</label></div></div></div></div><div ng-if=\"InstantInvest.formData.sipPaymentOption===InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM && InstantInvest.formData.frequency !== \'OW\'\"><div class=row ng-class=\"{\'anything-disabled\': !InstantInvest.formData.inSchemeName}\"><div class=\"col-md-3 col-sm-5 row\" ng-if=!InstantInvest.isReseting><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:InstantInvest.tForm.startDate.$dirty && InstantInvest.tForm.startDate.$invalid}\" date-calendar data-viewmode=months data-date-default=InstantInvest.formData.startDate data-min-date=InstantInvest.startMinDateOTM data-max-date=InstantInvest.startMaxDate data-on-date-change=InstantInvest.changeStartDate id=startDate-OTM data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=InstantInvest.formData.startDate>Start Date - DD-MMM-YYYY</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InstantInvest.tForm.startDate.$error.required ng-bind=InstantInvest.VALIDATE_DATA.START_DATE_REQUIRED></span> <span class=error-input ng-show=\"InstantInvest.isOTMStartDate && (InstantInvest.formData.bankInfo && !InstantInvest.isOtmVisible)\" ng-bind=\"InstantInvest.VALIDATE_DATA.DATE_SIP_VALIDATION_ERROR + \' \' + InstantInvest.formData.bankInfo.omStartDate\"></span></div></div></div><div class=\"row borderline\"><div class=sip-dates><div class=\"col-md-3 col-sm-5 row\" ng-class=\"{\'anything-disabled\': !InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName,\'disable-date\': InstantInvest.disableEndDateSelection }\"><div class=form-group ng-if=!InstantInvest.isReseting><!-- data-min-date=\"InstantInvest.formData.minEndDate\"--><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:InstantInvest.tForm.endDate.$dirty && InstantInvest.tForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InstantInvest.formData.endDate data-on-date-change=InstantInvest.changeEndDate data-enabled-dates=InstantInvest.enabledEndDates data-view-date=InstantInvest.enabledEndDateView data-min-date=InstantInvest.enabledEndDates[0] data-max-date=InstantInvest.enabledEndDates[InstantInvest.enabledEndDates.length-1] data-enable=true id=endDate-OTM><!--data-days-of-week-disabled=\"[6,0]\"--> <input type=text name=endDate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span><label ng-if=InstantInvest.formData.endDate>End Date - DD-MMM-YYYY</label><span class=bar></span> <span class=error-input ng-show=\"InstantInvest.tForm.day.$dirty && InstantInvest.tForm.day.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.MONTH_REQUIRED></span> <span class=error-input ng-show=InstantInvest.isOTMEndDate ng-bind=InstantInvest.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span> <span style=\"word-spacing: -1px\" class=error-input ng-show=\"InstantInvest.formData.sipPaymentOption === InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && InstantInvest.sipDateLessEmandate\" ng-bind=InstantInvest.VALIDATE_DATA.EMANDATE_DATE_EXCEED_ERROR></span></div></div></div><div class=\"col-md-1 col-sm-1 text-center or-part\" ng-if=\"InstantInvest.formData.sipPaymentOption != \'E-mandate\' && InstantInvest.formData.sipPaymentOption !== InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\">OR</div><div class=\"col-md-4 col-sm-6 default-date\" ng-if=\"InstantInvest.formData.sipPaymentOption != \'E-mandate\' && InstantInvest.formData.sipPaymentOption !== InstantInvest.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\" ng-class=\"{\'anything-disabled\': !InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName }\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=defaultDate ng-class=\"{\'anything-disabled\': !InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName }\" ng-model=InstantInvest.formData.isTillPerpetuity ng-change=InstantInvest.changeTillPerpetuityFlag() ng-disabled=\"!InstantInvest.formData.startDate || !InstantInvest.formData.inSchemeName\"> <span class=icon-checkbox></span></span><label for=defaultDate>Choose Default End Date, which is 2099</label></div></div></div></div></div>");
$templateCache.put("app/instant-investment/summary-directive/sip-purchase-summary.html","<div class=\"content-area clearfix instant-review\" ng-init=init()><div class=col-md-6><table ng-if=\"transactionType == TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\" class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=formData.isThroughRia>{{formData.brokerCode?formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.brokerCode>N/A</td></tr><tr ng-if=formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=formData.brokerName>{{formData.brokerName}}</td><td ng-if=!formData.brokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{transactionType}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{formData.purchaseInSchemeName}}</td></tr><tr ng-if=\"formData.purchaseInvestmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td><span ng-if=\"formData.purchaseInvestmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.purchaseDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.purchaseAmount}}</td></tr></table><table ng-if=\"transactionType == TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\" class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=formData.isThroughRia>{{formData.brokerCode?formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.brokerCode>N/A</td></tr><tr ng-if=formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=formData.brokerName>{{formData.brokerName}}</td><td ng-if=!formData.brokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{transactionType}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND ? formData.investmentOption : (formData.investmentOption | camelcase)}}</td></tr><tr ng-if=\"formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td><span ng-if=\"formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND ? TRANSACTIONS_CONST.DESCRIPTIONS[formData.sipDividendOption] : (formData.sipDividendOption | camelcase)}}</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr><td>Installment Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr ng-if=\"formData.frequency===\'OW\'\"><td>SIP Day</td><td>:</td><td>{{formData.weeklyDay}}</td></tr><tr><td>Start Date</td><td>:</td><td>{{formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>End Date</td><td>:</td><td>{{formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"formData.sipPaymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"formData.sipPaymentOption ==\'OTM\'\">OTM (One Time Mandate)</td><td ng-if=\"formData.sipPaymentOption == \'E-mandate\'\">E-Mandate</td><td ng-if=\"formData.sipPaymentOption == \'UPI\'\">UPI Autopay</td></tr><tr ng-if=\"(formData.bankInfo.bankName==\'HDFC BANK\' && formData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{formData.bankAcNo}}</td></tr><tr ng-if=\"formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{formData.bankInfo.omUmrn}}</td></tr><tr ng-if=\"formData.sipPaymentOption==\'UPI\'\"><td>Virtual Payment Address (VPA)</td><td>:</td><td>{{formData.virtualAddress}}</td></tr><tr ng-if=formData.sipFirstInstallment><td>SIP First Installment</td><td>:</td><td ng-bind=\"formData.sipFirstInstallment?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.sipFirstAmount><td>SIP First Installment Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.sipFirstAmount}}</td></tr></table></div><div class=col-md-6><table class=\"borderless table\" ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><tr ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><td style=\"color: black\"><u><strong>Emandate Registration Details</strong></u></td></tr><tr><td class=eMandateReview>Bank Name</td><td class=eMandateRow>:</td><td>{{formData.bankInfo.bankName.substring(0,formData.bankInfo.bankName.indexOf(\"-\"))}}</td></tr><tr><td class=eMandateReview>Account Number</td><td class=eMandateRow>:</td><td>{{formData.bankInfo.accountNumber}}</td></tr><tr><td class=eMandateReview>Amount</td><td class=eMandateRow>:</td><td><i class=rupee-small-icon></i> {{formData.emandateAmount}}<br><label id=amountInwordsEmandateSummary>{{emandateAmountDetails.amountInWords}} (In Words)</label></td></tr><tr><td class=eMandateReview>Frequency</td><td class=eMandateRow>:</td><td>As and when presented</td></tr><tr><td class=eMandateReview>Authentication Mode</td><td class=eMandateRow>:</td><td>{{formData.authMode.text}}</td></tr><tr><td class=eMandateReview>Start Date</td><td class=eMandateRow>:</td><td>{{formData.emandateDate}}</td></tr><tr><td class=eMandateReview>End Date</td><td class=eMandateRow>:</td><td>{{formData.endDateEmandate}}</td></tr><tr><td class=eMandateReview>Purpose of Mandate</td><td class=eMandateRow>:</td><td>Mutual Fund Payment</td></tr></table></div><div class=col-md-6 ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"><table class=\"borderless table\" style=\"margin-top: 0px !important\"><tr><td class=\"eMandateReview instant-summary\">Email ID</td><td class=eMandateRow style=\"padding-left: 7px !important\">:</td><td ng-bind=\"investorEmail ? investorEmail : \'Not Updated\'\"></td></tr><tr><td class=\"eMandateReview instant-summary\">Mobile Number</td><td class=eMandateRow style=\"padding-left: 7px !important\">:</td><td ng-bind=\"investorNumber ? investorNumber : \'Not Updated\'\"></td></tr></table></div><div class=col-md-6 ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\"><table class=\"table borderless\" style=\"margin-top: 0px !important\"><tr><td class=\"eMandateReview instant-summary\">Email ID</td><td class=eMandateRow style=\"padding-left: 7px !important\">:</td><td ng-bind=\"investorEmail ? investorEmail : \'Not Updated\'\"></td></tr><tr><td class=\"eMandateReview instant-summary\">Mobile Number</td><td class=eMandateRow style=\"padding-left: 7px !important\">:</td><td ng-bind=\"investorNumber ? investorNumber : \'Not Updated\'\"></td></tr></table></div><div class=\"col-md-12 col-sm-12\"><label style=\"padding: 25px 0px 0px 0px; display: block\" ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\">Transaction acknowledgement email and SMS will be sent to above contact details registered in the folio.</label><label style=\"padding: 25px 0px 0px 0px; display: block\" ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\">Transaction acknowledgement email and SMS will be sent to above contact details registered in the folio.</label></div><div class=\"col-md-12 col-sm-12 tc-block\" ng-show=showTerms><div><h6>Terms & Conditions</h6><div class=checkbox style=\"display: unset !important\"><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>&nbsp; I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div><br><div ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><div class=checkbox><input id=isCheckedTandCeMandate ng-model=isCheckedTandCeMandate type=checkbox ng-change=ischeckedem()> <i class=icon-checkbox></i><label for=isCheckedTandCeMandate style=\"padding-left: 0px !important\" class=checkbox-text>&nbsp; I have read and understood <a ng-click=showTermConditionsemandate() href=javaScript:void(0)>Terms & Conditions</a> of e-mandate (eOTM)</label></div></div></div><div class=\"col-md-12 col-sm-12 instant-invest-note\"><ng-bind-html dynamic=notes.content></ng-bind-html></div><div class=\"col-md-12 form-footer\" ng-if=\"formData.sipPaymentOption != \'E-mandate\'\"><div><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary pull-left\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=\"!isCheckedTandC || !formData\" ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div><div class=\"col-md-12 form-footer\" ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><div><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary pull-left\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=\"!isCheckedTandC || !isCheckedTandCeMandate || !formData\" ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div>");
$templateCache.put("app/instant-investment/switch/summary.switch.html","<div class=summary ng-init=init()><p class=page-title>REVIEW TRANSACTION : SWITCH</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=InstantInvest.formData.isThroughDistributor><td style=\"width: 240px\">Distributor ARN</td><td>:</td><td ng-if=InstantInvest.formData.isThroughDistributor>{{InstantInvest.formData.brokerCode?\'ARN-\'+InstantInvest.formData.brokerCode:(InstantInvest.formData.distributorARN?InstantInvest.formData.distributorARN:\'\')}}</td><td ng-if=!InstantInvest.formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=InstantInvest.formData.isThroughRia><td style=\"width: 240px\">RIA Code</td><td>:</td><td ng-if=InstantInvest.formData.isThroughRia>{{InstantInvest.formData.brokerCode?InstantInvest.formData.brokerCode:(InstantInvest.formData.distributorARN?InstantInvest.formData.distributorARN:\'\')}}</td><td ng-if=!InstantInvest.formData.brokerCode>N/A</td></tr><tr ng-if=InstantInvest.formData.isThroughRia><td style=\"width: 240px\">RIA Name</td><td>:</td><td ng-if=InstantInvest.formData.brokerName>{{InstantInvest.formData.brokerName}}</td><td ng-if=!InstantInvest.formData.brokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=InstantInvest.formData.subBrokerARN><td style=\"width: 240px\">Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+InstantInvest.formData.subBrokerARN}}</td></tr><tr ng-if=\"InstantInvest.formData.euin && InstantInvest.euinName\"><td style=\"width: 240px\">EUIN Name</td><td>:</td><td>{{InstantInvest.euinName}}</td></tr><tr><td style=\"width: 240px\">Folio No.</td><td>:</td><td>{{InstantInvest.formData.folioNumber}}</td></tr><tr><td style=\"width: 240px\">Transaction Type</td><td>:</td><td>{{InstantInvest.formData.investmentType | camelcase}}</td></tr><tr><td style=\"width: 240px\">Switch Out Scheme</td><td>:</td><td>{{InstantInvest.outSchemeName}}</td></tr><tr><td style=\"width: 240px\">Switch In Scheme</td><td>:</td><td>{{InstantInvest.inSchemeName}}</td></tr><tr><td style=\"width: 240px\">Investment Option</td><td>:</td><td>{{InstantInvest.validations.investmentOption}}</td><!-- <td>{{formData.investmentOption.toUpperCase() == TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? (TRANSACTIONS_CONST.INVESTMENT_OPTIONS[formData.investmentOption] | camelcase) : TRANSACTIONS_CONST.INVESTMENT_OPTIONS[formData.investmentOption]}}</td> --></tr></table></div><h1>{{InstantInvest.autoSwitchSchemeDividendOption}}</h1><div class=col-md-6><table class=\"table borderless\"><tr ng-if=\"formData.investmentOption.toUpperCase() != InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td style=\"width: 240px\">Target Scheme IDCW Option</td><td>:</td><td>{{InstantInvest.TRANSACTIONS_CONST.DESCRIPTIONS[InstantInvest.formData.dividendOption]}}</td></tr><tr ng-if=InstantInvest.formData.subBrokerCode><td style=\"width: 240px\">Sub Broker Code</td><td>:</td><td>{{InstantInvest.formData.subBrokerCode}}</td></tr><tr ng-if=\"InstantInvest.formData.euin && InstantInvest.formData.euin.euinCode\"><td style=\"width: 240px\">EUIN Code</td><td>:</td><td>{{InstantInvest.formData.euin.euinCode}}</td></tr><tr ng-if=InstantInvest.amount><td style=\"width: 240px\">Amount</td><td style=\"width: 15px\">:</td><td><i class=rupee-small-icon ng-if=!InstantInvest.units></i> {{InstantInvest.units ? \'NA\' : InstantInvest.amount}}<br><label id=amountInwords>{{InstantInvest.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"InstantInvest.amountType === InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td style=\"width: 240px\">Units</td><td>:</td><td>{{InstantInvest.units?InstantInvest.units:\'NA\'}}</td></tr><tr ng-if=\"InstantInvest.amountType === InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td style=\"width: 240px\">Units</td><td>:</td><td>All Free Units</td></tr><tr><td style=\"width: 240px\">Email ID</td><td>:</td><td easyassist-key=mask-element>{{InstantInvest.email}}</td></tr><tr><td style=\"width: 240px\">Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{InstantInvest.mobileNumber}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\" ng-if=InstantInvest.checkedNfoAutoSwitch><tr><td style=\"width: 240px\">Auto Switch On Maturity:</td><td>:</td><td>{{InstantInvest.checkedNfoAutoSwitch?\'Yes\':\'No\'}}</td></tr><tr><td>Auto Switch scheme:</td><td>:</td><td>{{InstantInvest.switchInSchemeName}}</td></tr><tr ng-if=\"InstantInvest.switchInInvestmentOption.toUpperCase() != InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Auto Switch Scheme IDCW Option:</td><td>:</td><td>{{InstantInvest.autoSwitchSchemeDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email and SMS will be sent to above contact details registered in the folio.</label></div><div class=tc-block ng-show=InstantInvest.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input ng-model=InstantInvest.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InstantInvest.showTermConditions() href=javaScript:void(0)><u>Terms & Conditions</u></a> of Investment</span></div></div></div><ng-bind-html ng-bind-html=InstantInvest.notesReview.content></ng-bind-html><div class=content-foot><a href=\"\" ng-click=InstantInvest.goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!InstantInvest.isCheckedTandC ng-click=InstantInvest.submitFormSwitchFirst() class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div><style>div i.dot {\n        display: inline-block;\n        position: relative;\n        top: -2px;\n        height: 6px;\n        margin-right: 10px;\n        width: 6px;\n        background: #d92018;\n      }\n  \n  \n      .info {\n        font-weight: normal;\n        font-size: 12px;\n      }\n  \n      .info p {\n        margin-top : 0px !important;\n        margin-bottom: 0px !important;\n      }\n  \n      .info span {\n        display: inline-block;\n        vertical-align: top;\n      }</style>");
$templateCache.put("app/instant-investment/switch/switch.html","<style>.borderSwitch {\n        /* border-left: 1px solid lightgray; border-right: 1px solid lightgray; */\n    }\n     @media only screen and (min-width:350px) and (max-width:767px){\n        .borderSwitch{border:0;}\n    }</style><div><div class=col-md-4><p class=col-head>Select Switch Out Scheme</p><div class=\"input-select input-normal\" ng-class=\"{\'anything-disabled\': !InstantInvest.formData.folioNumber }\"><input type=text name=outScheme id=outScheme ng-change=InstantInvest.filterOutSchemeList() ng-model=InstantInvest.outSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Source Scheme</label><span class=error-input ng-show=\"InstantInvest.tForm.outScheme.$dirty && InstantInvest.tForm.outScheme.$invalid && InstantInvest.tForm.outScheme.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=InstantInvest.outSchemeList display-key=schemeName hdfc-click=InstantInvest.outSchemeChanged(data) model=InstantInvest.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{InstantInvest.outSchemeName}}</p></div><div ng-class=\"{\'anything-disabled\': !InstantInvest.formData.folioNumber }\" class=value-snippet ng-if=InstantInvest.unitsDetails><div><p class=text-uppercase>Total Market Value</p><span class=left-val easyassist-key=mask-element>{{InstantInvest.unitsDetails.totalCurrentValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{InstantInvest.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{InstantInvest.unitsDetails.lockedValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{InstantInvest.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value</p><span class=left-val easyassist-key=mask-element>{{InstantInvest.unitsDetails.freeValueUnits | number:3}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{InstantInvest.unitsDetails.freeValueAmount|unit}}</span></div><p class=text-primary>*as of last business day</p></div></div><div ng-class=\"{\'anything-disabled\': !InstantInvest.outSchemeName}\" class=\"col-md-4 borderSwitch\" style=\"border-left: 1px solid lightgray; border-right: 1px solid lightgray\"><p class=col-head>Switch In Scheme</p><div class=\"input-select input-normal\"><input type=text name=inScheme id=inScheme ng-change=InstantInvest.filterInSchemeListTwo() ng-model=InstantInvest.inSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><span class=error-input ng-show=\"InstantInvest.tForm.inScheme.$dirty && InstantInvest.tForm.inScheme.$invalid && InstantInvest.tForm.inScheme.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.TARGET_SCHEME_REQUIRED></span><drop-down list-data=InstantInvest.inSchemeList display-key=scheme hdfc-click=InstantInvest.inSchemeChangedSwitch(data) model=InstantInvest.inSchemeCode for=inScheme></drop-down><p class=info-primary>{{InstantInvest.inSchemeName}}</p></div><div class=\"form-group text-center\"><p>OR</p><br><p><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=InstantInvest.schemeFilterListModal()>Select from list</span></p></div><div class=form-group ng-class=\"{\'radio-disabled\':(InstantInvest.validations.isEnabled==\'N\')}\" ng-if=\"InstantInvest.validations.investmentOption===InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=form-label><strong>Select Income Distribution cum Capital Withdrawal (IDCW) Option.</strong></label><div class=radio-block ng-repeat=\"_option in InstantInvest.devidendOptions\" style=\"padding-bottom: 10px\" ng-class=\"{\'anything-disabled\': ((_option == InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && (InstantInvest.inSchemeValidations.isGrowth === false||InstantInvest.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && InstantInvest.inSchemeValidations.dividendReinvestmentApplicable === false)\n                        || (_option == InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT && (InstantInvest.inSchemeValidations.isGrowth === false||InstantInvest.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && InstantInvest.inSchemeValidations.dividendPayoutApplicable === false)) }\"><span class=radio><input type=radio id=dividendOption{{$index}} ng-value=_option ng-disabled=\"(_option == InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && (InstantInvest.inSchemeValidations.isGrowth === false||InstantInvest.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && InstantInvest.inSchemeValidations.dividendReinvestmentApplicable === false)\n                        || (_option == InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT   && (InstantInvest.inSchemeValidations.isGrowth === false||InstantInvest.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && InstantInvest.inSchemeValidations.dividendPayoutApplicable === false)\" name=dividendOption ng-model=InstantInvest.formData.dividendOption> <span class=check></span> </span><span class=radio-label>{{InstantInvest.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div><div class=\"row form-group\" ng-if=\"InstantInvest.isSchemeTypeELSS && InstantInvest.validations.investmentOption===InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div><div class=\"tc-block row form-group\" ng-if=InstantInvest.nfoEnabled><div class=checkbox><input name=isAutoSwitch ng-model=InstantInvest.isAutoSwitch type=checkbox ng-change=InstantInvest.fetchAutoSwitch()> <i class=icon-checkbox></i> <span class=checkbox-text>Auto Switch on Maturity</span></div></div><div class=row ng-if=InstantInvest.isAutoSwitch><div class=\"col-md-12 row\"><div class=\"input-select input-normal\" ng-class=\"{error:InstantInvest.tForm.switchInScheme.$dirty && InstantInvest.tForm.switchInScheme.$invalid}\"><input type=text name=switchInScheme id=switchInScheme ng-change=InstantInvest.filterAutoSwitchInSchemeList() ng-model=InstantInvest.switchInSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><span class=error-input ng-show=\"InstantInvest.tForm.switchInScheme.$dirty && InstantInvest.tForm.switchInScheme.$invalid && InstantInvest.tForm.switchInScheme.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.TARGET_SCHEME_REQUIRED></span><drop-down list-data=InstantInvest.autoSwitchInSchemeList display-key=scheme hdfc-click=InstantInvest.autoInSchemeChanged(data) model=InstantInvest.switchInSchemeCode for=switchInScheme></drop-down><p class=info-primary>{{InstantInvest.switchInSchemeName}}</p></div><div class=form-group ng-class=\"{\'radio-disabled\':(InstantInvest.switchInSchemeValidations.isEnabled==\'N\')}\" ng-if=\"InstantInvest.switchInSchemeValidations.switchInInvestmentOption===InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=form-label><strong>Select Income Distribution cum Capital Withdrawal (IDCW) Option</strong></label><div ng-class=\"{\'anything-disabled\': (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST\n                       && InstantInvest.switchInSchemeValidations.endingType === InstantInvest.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.isSwitchInSchemeTypeELSS) }\" class=radio-block ng-repeat=\"_option in InstantInvest.dividendOptions\"><span class=radio><input type=radio id=dividendsOption{{$index}} ng-value=_option ng-disabled=\"(_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST&& InstantInvest.switchInSchemeValidations.endingType === InstantInvest.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (_option==InstantInvest.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && InstantInvest.isSwitchInSchemeTypeELSS)\" name=switchDividendOption ng-model=InstantInvest.autoSwitchSchemeDividendOption> <span class=check></span> </span><span class=radio-label>{{InstantInvest.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div><div class=\"row form-group\" ng-if=\"InstantInvest.isSwitchInSchemeTypeELSS && InstantInvest.switchInSchemeValidations.switchInInvestmentOption===InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div></div><div class=\"form-group col-md-offset-1 col-md-12 scheme-invoke\"><span>OR</span> <span><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=InstantInvest.switchInSchemeListModal()>Select from list</span></span></div></div></div><div ng-class=\"{\'anything-disabled\': !InstantInvest.outSchemeName }\" class=col-md-4><p class=col-head>Select Value</p><div class=form-group ng-class=\"{\'radio-disabled\':(InstantInvest.validations.isEnabled==\'N\')}\"><div class=radio-block><span class=radio><input type=radio id=amount name=amountType ng-value=InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT ng-model=InstantInvest.amountType ng-disabled=\"(!InstantInvest.unitsDetails)||(InstantInvest.validations.isEnabled==\'N\')\" ng-change=InstantInvest.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>Amount</span></div><div class=radio-block><span class=radio><input type=radio id=allUnits name=amountType ng-value=InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS ng-model=InstantInvest.amountType ng-disabled=\"(!InstantInvest.unitsDetails)||(InstantInvest.validations.isEnabled==\'N\')\" ng-change=InstantInvest.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>All Free Units</span></div><div class=radio-block><span class=radio><input type=radio id=noOfUnits name=amountType ng-value=InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS ng-model=InstantInvest.amountType ng-disabled=\"(!InstantInvest.unitsDetails)||(InstantInvest.validations.isEnabled==\'N\')\" ng-change=InstantInvest.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>No. of Units</span></div></div><div class=\"input-normal icon-input\" ng-if=\"InstantInvest.amountType == InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT\" ng-class=\"{error:InstantInvest.tForm.amount.$invalid||(InstantInvest.tForm.amount.$dirty&&InstantInvest.isInvalidForm),\'has-data\':InstantInvest.amount}\"><input type=number name=amount ignore-mouse-wheel ng-disabled=\"(!InstantInvest.unitsDetails.freeValueAmount)||(InstantInvest.validations.isEnabled==\'N\')\" onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-change=InstantInvest.checkSwitchValidations();InstantInvest.checkSwitchValidationsForPreview() min={{InstantInvest.validationsApi.minAmount}} max={{InstantInvest.validationsApi.maxAmount}} ng-model=InstantInvest.amount class=pd20 required> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"InstantInvest.tForm.amount.$dirty && InstantInvest.tForm.amount.$invalid\"><span class=error-input ng-show=\"InstantInvest.tForm.amount.$dirty && InstantInvest.tForm.amount.$error.required\" ng-bind=InstantInvest.VALIDATE_DATA.AMOUNT_REQUIRED></span><!--<span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=\"error-input\">Amount cannot be less than the minimum required amount in the target scheme</span>--><!--<span ng-if=\"Transaction.formData.amount && Transaction.isMax && !Transaction.isMin\" class=\"error-input\">Amount cannot exceed value of clear units available to switch </span>--> <span ng-if=\"InstantInvest.amount && !InstantInvest.isMax && !InstantInvest.isMin && (InstantInvest.validations.amountMultiples&&!InstantInvest.isMultiples)\" class=error-input>Please provide In multiples of &#8377; {{InstantInvest.validations.amountMultiples|unit}}</span> <span class=error-input ng-show=InstantInvest.tForm.amount.$error.max>Amount cannot exceed to {{InstantInvest.validationsApi.maxAmount}}</span> <span class=error-input ng-show=\"InstantInvest.tForm.amount.$error.min && !InstantInvest.tForm.amount.$error.max\">Minimum amount should be {{InstantInvest.validationsApi.minAmount}}</span></span></div><div ng-if=\"InstantInvest.amountType== InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT\" class=form-group><label id=divDisplayWords>{{InstantInvest.amountInWords}} (In Words)</label></div><!--Unit input --><div class=input-normal ng-if=\"InstantInvest.amountType == InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\" ng-class={error:InstantInvest.tForm.units.$invalid||(InstantInvest.tForm.units.$dirty&&InstantInvest.isInvalidForm)}><input type=number ignore-mouse-wheel ng-disabled=!InstantInvest.unitsDetails.freeValueUnits ng-change=InstantInvest.checkSwitchValidations();InstantInvest.checkSwitchValidationsForPreview() name=units min={{InstantInvest.validationsApi.minUnits}} max={{InstantInvest.validationsApi.maxUnits}} ng-model=InstantInvest.units ng-required=InstantInvest.isRequired autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter Units</label><span ng-show=\"InstantInvest.tForm.units.$dirty && InstantInvest.tForm.units.$invalid\"><span class=error-input ng-show=InstantInvest.tForm.units.$error.required ng-bind=InstantInvest.VALIDATE_DATA.UNITS_REQUIRED></span><!--<span ng-if=\"InstantInvest.formData.units && InstantInvest.isMin && !InstantInvest.isMax\" class=\"error-input\">Value of units cannot be less than the minimum required amount in the target scheme </span>--><!--<span ng-if=\"InstantInvest.formData.units && InstantInvest.isMax\" class=\"error-input\">Units cannot exceed clear units available to switch</span>--> <span class=error-input ng-show=\"InstantInvest.tForm.units.$error.min && !InstantInvest.tForm.units.$error.max\">Minimum unit should be {{InstantInvest.validationsApi.minUnits}}</span><!--|unit--> <span class=error-input ng-show=InstantInvest.tForm.units.$error.max>Units cannot exceed to {{InstantInvest.validationsApi.maxUnits}}</span><!--|unit--></span></div><div class=form-group><div class=estimate-block ng-if=InstantInvest.tForm.$valid><a href=\"\" ng-click=InstantInvest.downloadReport()><strong>Estimated Exit Load</strong></a><div>This transaction may have exit load charges as per AMC guidelines for this scheme</div></div></div></div><ng-bind-html ng-bind-html=InstantInvest.notes.content></ng-bind-html></div>");
$templateCache.put("app/instant-investment/switch/switch.success.html","<div class=content-area><div class=row><div class=\"col-md-7 col-sm-6\"><table class=\"table borderless\"><tr ng-if=InstantInvest.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=InstantInvest.formData.brokerCode>{{InstantInvest.formData.brokerCode?\'ARN-\'+InstantInvest.formData.brokerCode:(InstantInvest.formData.distributorARN?InstantInvest.formData.distributorARN:\'\')}}</td><td ng-if=!InstantInvest.formData.brokerCode>N/A</td></tr><!--RIA code columns--><tr ng-if=InstantInvest.formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=InstantInvest.formData.brokerCode>{{InstantInvest.formData.brokerCode?InstantInvest.formData.brokerCode:(InstantInvest.formData.distributorARN?InstantInvest.formData.distributorARN:\'\')}}</td><td ng-if=!InstantInvest.formData.brokerCode>N/A</td></tr><tr ng-if=InstantInvest.formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=InstantInvest.formData.brokerName>{{InstantInvest.formData.brokerName}}</td><td ng-if=!InstantInvest.formData.brokerName>N/A</td></tr><!--RIA code columns--><tr><td class=col-md-5>Folio No.</td><td>:</td><td>{{InstantInvest.formData.folioNumber}}</td></tr><tr><td>CAMS Reference No.</td><td>:</td><td>{{InstantInvest.camsReferenceNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{InstantInvest.transactionType | camelcase}}</td></tr><tr><td>Switch Out Scheme</td><td>:</td><td>{{InstantInvest.outSchemeName}}</td></tr><tr><td>Switch In Scheme</td><td>:</td><td>{{InstantInvest.inSchemeName}}</td></tr><tr ng-if=\"InstantInvest.investmentOption == InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Investment Option</td><td>:</td><td>{{InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[InstantInvest.investmentOption] | camelcase}}</td></tr><tr ng-if=\"InstantInvest.investmentOption != InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Investment Option</td><td>:</td><td>{{InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[InstantInvest.investmentOption]}}</td></tr><tr ng-if=\"InstantInvest.investmentOption.toUpperCase() != InstantInvest.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH && InstantInvest.dividendOption\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td>{{InstantInvest.TRANSACTIONS_CONST.DESCRIPTIONS[InstantInvest.dividendOption]}}</td></tr><tr ng-if=\"InstantInvest.transactionValue === InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT\"><td style=\"width: 140px\">Amount</td><td style=\"width: 15px\">:</td><td><i class=rupee-small-icon></i> {{InstantInvest.amount}}<br><label id=switchstatusDisplayWords>{{InstantInvest.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"InstantInvest.transactionValue === InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td>Units</td><td>:</td><td>{{InstantInvest.units}}</td></tr><tr ng-if=\"InstantInvest.transactionValue === InstantInvest.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Units</td><td>:</td><td>All Free Units</td></tr></table></div><div class=\"col-md-3 col-sm-6\" style=\"margin: 80px\"><div class=container><div class=row style=\"margin : 0% 9% 1%\"><p class=verify-sign><i class=verify-icon></i></p></div><p class=\"status-info green\">Transaction Initiated Successfully</p><div ng-if=\"!InstantInvest.isFavourite == \'false\'\" class=fav-block><div class=checkbox><input type=checkbox ng-disabled=InstantInvest.favrouitModel ng-model=InstantInvest.favrouitModel ng-change=InstantInvest.favrouiteApi(InstantInvest.transactionId)> <i class=icon-favorite></i></div><strong class=text-blue>Mark as a Favourite Transaction</strong></div><button type=button ng-click=InstantInvest.goToHome() class=\"btn btn-primary-action\" style=\"margin: 12px\">Go to Home</button></div></div></div></div>");
$templateCache.put("app/investor/addFolio/add.html","<div class=\"main-section clearfix investors\" id=investors><div class=investors-new ng-init=MainFolioParent.init();><!-- InvestorsAdd.checkPanDetails(); --><div class=content-header><p class=small-text>New Folio Creation</p><h5><span ng-bind=\"MainFolioParent.firstName+\' \'+MainFolioParent.middleName+\' \'+MainFolioParent.lastName\">Aakash sharma</span> <span class=separator>&nbsp;| &nbsp;</span><span class=pan-details> PAN : <span easyassist-key=mask-element ng-bind=MainFolioParent.panNumber>ABCD1234</span></span></h5></div><div class=\"clearfix box-main\"><div class=ui-progress ng-class=\"{\'half-complete\':MainFolioParent.$state.current.name==\'main.folio.nominee\',\'full-complete\':MainFolioParent.$state.current.name==\'main.folio.bankdetails\',\'step1\':MainFolioParent.$state.current.name==\'main.investors.add.bankdetails\',\'step2\':MainFolioParent.$state.current.name==\'main.investors.add.scheme\'}\"><div class=fourElement ng-class=\"{fiveElement : (MainFolioParent.holdmode ==MainFolioParent.CONST.INVESTOR_HOLD_MODE.AOS) }\"><span id=holdmodeId ng-class=\"{\'active\':MainFolioParent.$state.current.name==\'main.folio.holdmode\',\n                      \'done\':MainFolioParent.$state.current.name==\'main.folio.soleApplicant\'||MainFolioParent.$state.current.name==\'main.folio.jointholders\'||MainFolioParent.$state.current.name==\'main.folio.nominee\'||MainFolioParent.$state.current.name==\'main.folio.bankdetails\' ||MainFolioParent.$state.current.name==\'main.folio.review\'}\" data-text=\"Mode of Holding\">&nbsp;</span></div><div class=fourElement ng-class=\"{fiveElement : (MainFolioParent.holdmode ==MainFolioParent.CONST.INVESTOR_HOLD_MODE.AOS) }\"><span id=folioId ng-class=\"{\'active\':MainFolioParent.$state.current.name==\'main.folio.soleApplicant\',\n          \'done\':MainFolioParent.$state.current.name==\'main.folio.jointholders\'||MainFolioParent.$state.current.name==\'main.folio.nominee\'||MainFolioParent.$state.current.name==\'main.folio.bankdetails\'||MainFolioParent.$state.current.name==\'main.folio.review\'}\" data-text=\"Sole Applicant\">&nbsp;</span></div><div class=fourElement ng-class=\"{fiveElement : (MainFolioParent.holdmode ==MainFolioParent.CONST.INVESTOR_HOLD_MODE.AOS) }\" ng-if=\"MainFolioParent.holdmode === MainFolioParent.CONST.INVESTOR_HOLD_MODE.AOS\"><span id=jointHolder ng-class=\"{\'active\':MainFolioParent.$state.current.name==\'main.folio.jointholders\',\n          \'done\':MainFolioParent.$state.current.name==\'main.folio.nominee\'||MainFolioParent.$state.current.name==\'main.folio.bankdetails\'||MainFolioParent.$state.current.name==\'main.folio.review\'}\" data-text=\"Joint Holders\">&nbsp;</span></div><div class=fourElement ng-class=\"{fiveElement : (MainFolioParent.holdmode ==MainFolioParent.CONST.INVESTOR_HOLD_MODE.AOS) }\"><span id=addNominee ng-class=\"{\'active\':MainFolioParent.$state.current.name==\'main.folio.nominee\',\'done\':MainFolioParent.$state.current.name==\'main.folio.bankdetails\'||MainFolioParent.$state.current.name==\'main.folio.review\'}\" data-text=\"Add Nominee\">&nbsp;</span></div><div class=fourElement ng-class=\"{fiveElement : (MainFolioParent.holdmode ==MainFolioParent.CONST.INVESTOR_HOLD_MODE.AOS) }\" id=schemeId class=folio-bank-details><span ng-class=\"{\'active\':MainFolioParent.$state.current.name==\'main.folio.bankdetails\',\'done\':MainFolioParent.bankDetailSuccess ||MainFolioParent.$state.current.name==\'main.folio.review\'}\" data-text=\"Bank Details\">&nbsp;</span></div></div><div ui-view></div></div></div></div>");
$templateCache.put("app/investor/holderApproval/holder-smartlink.html","<div class=clearfix><div class=email-view ng-if=Approval.isLoaded><div data-ng-include=\"\'app/investor/holderApproval/holder.html\'\"></div></div></div>");
$templateCache.put("app/investor/holderApproval/holder.html","<div class=\"main-section clearfix investors\" id=investors style=padding:0px><login-header ng-if=!Approval.isLoggedInStatus></login-header><div class=login-screen ng-class=\"{\'add-margin\': Approval.isLoggedInStatus}\"><section class=\"faq-wrapper main-section container\"><h1 style=margin-bottom:0px>Folio Approval</h1><form style=\"margin-top: 0px\" autocomplete=off class=nominee-section name=jointHolderForm novalidate><div style=\"margin-top: 0px;padding-top:0px\" class=form-content><div class=nominee-list><table><tbody><tr><td class=col-md-2>Unit Holder:</td><td class=col-md-4><input type=text name=jointHolderName value=\"{{Approval.folioDetails.soleApplicantDetail.personalDetail.firstName+\' \'+ Approval.folioDetails.soleApplicantDetail.personalDetail.middleName+ \' \' + Approval.folioDetails.soleApplicantDetail.personalDetail.lastName}}\" only-alphabets readonly></td><td class=col-md-4><div><input type=text name=panNumber ng-model=Approval.folioDetails.soleApplicantDetail.panNumber readonly> <span class=highlight></span> <span class=bar></span></div></td></tr><tr><td class=col-md-2>Holder:</td><td class=col-md-4><input type=text name=jointHolderName value=\"{{Approval.holder.firstName + \' \' + Approval.holder.middleName+\' \'+Approval.holder.lastName}}\" readonly></td><td class=col-md-4><div><input type=text name=panNumber value={{Approval.holder.pan}} readonly> <span class=highlight></span> <span class=bar></span></div></td></tr></tbody></table><!--<p><i class=\"info-icon\"></i></p>--></div><div id=tab-container1 class=\"tab-container clearfix\"><ul class=\"mobile-hide nav nav-tabs\"><li><strong>Holder Details</strong></li></ul></div><div class=tab-content><div><div id=add-joint-holder class=\"tab-pane fade joint-holder in active\"><div><div><div class=pdt0><div class=row style=\"margin-bottom: 10px\"><p style=\"margin-top: 0px !important\"><strong>Contact Details</strong></p><div class=col-md-5 style=\"margin-right: 40px\"><label><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{Approval.holder.email?Approval.holder.email:\"Not Available\"}}</label><div><div class=\"col-md-5 belongsToContainerWeb\" style=\"display: inline-flex;  margin-right: 40px\"><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block ; margin-left : 5px\" ng-class=\"{error:jointHolderForm.emailBelongsTo.$dirty && jointHolderForm.emailBelongsTo.$invalid}\"><select id=emailBelongsTo name=emailBelongsTo ng-model=Approval.holder.emailDeclaration style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray; margin-top: 8px;margin-left: 0px\" ng-required=Approval.holder.email ng-disabled=!Approval.holder.email><option value selected>Select Value</option><option ng-repeat=\"value in Approval.belongToListEmail\" ng-selected=\"Approval.holder.emailDeclaration == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"jointHolderForm.emailBelongsTo.$dirty \"><span class=error-input ng-show=jointHolderForm.emailBelongsTo.$error.required>Please select option</span></span></div></div></div></div><div class=col-md-5><label><strong>Mobile</strong> <span class=\"req text-red\">*</span> : {{Approval.holder.mobileNumber?Approval.holder.mobileNumber:\"Not Available\"}}</label><div><div class=\"col-md-5 belongsToContainerMobile\" style=\"display: inline-flex\"><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block\" ng-class=\"{error:jointHolderForm.mobileBelongsTo.$dirty && jointHolderForm.mobileBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" id=mobileBelongsTo name=mobileBelongsTo ng-model=Approval.holder.mobileDeclaration ng-init=\"Approval.holder.mobileDeclaration = Approval.holder.mobileDeclaration ? Approval.holder.mobileDeclaration : null\" ng-options=\"data.familyCode as data.familyDescription for data in Approval.belongToListMobile\" ng-selected=\"Approval.holders.mobileBelongsTo == data.familyCode\" style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray; margin-top: 8px;margin-left: 0px\" ng-required=Approval.holder.mobileNumber ng-disabled=!Approval.holder.mobileNumber><option value=\"\" selected>Select Value</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"jointHolderForm.mobileBelongsTo.$dirty &&  jointHolderForm.mobileBelongsTo.$invalid\"><span class=error-input ng-show=jointHolderForm.mobileBelongsTo.$error.required>Please select option</span></span></div></div></div></div></div><div class=row style=\"margin-top: 15px\"><!--                        &lt;!&ndash;empty placeholder when email doesnt exist to maintain ui&ndash;&gt;--><!--                        <div class=\"col-md-5\" style=\"margin-right: 40px;\" ng-if=\"!Approval.holder.email\"></div>--><!--                        &lt;!&ndash;empty placeholder when mobile doesnt exist to maintain ui&ndash;&gt;--><!--                        <div class=\"col-md-5\" style=\"margin-right: 40px;\" ng-if=\"!Approval.holder.mobileNumber\"></div>--></div><div class=row><div class=col-md-3><p class=pdt10><strong>Tax Status</strong></p><div class=selectfield ng-class=\"{error:jointHolderForm.taxStatusCode.$dirty && jointHolderForm.taxStatusCode.$invalid}\"><!--<label>Tax Status</label>--><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=Approval.holder.taxStatusCode ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in Approval.taxStatusList\" ng-init=\"Approval.holder.taxStatusCode = Approval.holder.taxStatusCode?Approval.holder.taxStatusCode: null\" required><option value=\"\" selected>Tax Status</option></select><!--<label ng-if=\"Approval.formData.taxStatusCode\">Tax Status</label>--> <span ng-show=\"jointHolderForm.taxStatusCode.$dirty && jointHolderForm.taxStatusCode.$invalid\"><span class=error-input ng-show=jointHolderForm.taxStatusCode.$error.required ng-bind=Approval.validations.TAX_STATUS></span> </span><span class=\"req text-red\">*</span></div></div></div><p class=pdt10><strong>Income Details</strong></p><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:jointHolderForm.occupation.$dirty && jointHolderForm.occupation.$invalid}\"><select class=\"browser-default custom-select\" name=occupation ng-model=Approval.holder.occupationCode ng-options=\"_type.occupationCode as _type.occupationDescription for _type in Approval.occupationList\" ng-init=\"Approval.holder.occupationCode = Approval.holder.occupationCode ? Approval.holder.occupationCode : null\" ng-change=Approval.setOccuValidation() required><option value=\"\" selected>Occupation</option></select><label ng-if=Approval.formData.occupation>Occupation</label><span ng-show=\"jointHolderForm.occupation.$dirty && jointHolderForm.occupation.$invalid\"><span class=error-input ng-show=jointHolderForm.occupation.$error.required ng-bind=Approval.validations.OCCUPATION></span> </span><span class=\"req text-red\">*</span></div></div></div><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:jointHolderForm.grossAnnualIncome.$dirty\n                 && jointHolderForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-click=\"Approval.setOptionalEmpty(\'GrossAnnualIncome\')\" ng-model=Approval.holder.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in Approval.incomeSlabList\" ng-required=\"!(Approval.holder.netWorth)\n                      &&!(Approval.holder.netWorthDate)\" ng-disabled=Approval.holder.netWorth ng-init=\"Approval.holder.grossAnnualIncome = Approval.holder.grossAnnualIncome ? Approval.holder.grossAnnualIncome : null\" ng-class=\"{\'selectfield-disabled\':Approval.holder.netWorth}\"><option value=\"\" selected>Gross Annual Income</option></select><label ng-if=Approval.holder.grossAnnualIncome>Gross Annual Income</label><span ng-show=\"jointHolderForm.grossAnnualIncome.$dirty && jointHolderForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=jointHolderForm.grossAnnualIncome.$error.required ng-bind=Approval.validations.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=jointHolderForm.grossAnnualIncome.$error.number ng-bind=Approval.validations.INVALID_AMOUNT></span> </span><span ng-if=\"!(Approval.holder.netWorth)\n                      &&!(Approval.holder.netWorthDate)\" class=\"req text-red\">*</span> <span class=highlight></span> <span class=bar></span></div></div><div class=\"or-part col-md-1\" style=\"position: relative;top: 30px;text-align: center\">OR<span style=color:#d82018> *</span></div><div class=col-md-3><div class=\"input-normal mgt13\" ng-class=\"{error:jointHolderForm.netWorth.$dirty\n                 && jointHolderForm.netWorth.$invalid}\"><input type=number ignore-mouse-wheel name=netWorth class=pd20 ng-model=Approval.holder.netWorth ng-required=!Approval.holder.grossAnnualIncome onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-disabled=Approval.holder.grossAnnualIncome> <span ng-show=\"jointHolderForm.netWorth.$dirty && jointHolderForm.netWorth.$invalid\"><span class=error-input ng-show=jointHolderForm.netWorth.$error.number ng-bind=Approval.validations.INVALID_AMOUNT></span> <span class=error-input ng-show=jointHolderForm.netWorth.$error.required ng-bind=Approval.validations.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span><!--<i class=\"rupee-input-icon\"></i>--><label>Net worth (in Rs.) <span ng-if=\"!(Approval.holder.grossAnnualIncome)\n                ||(Approval.holder.netWorthDate)\" class=\"req text-red\">*</span></label></div><div class=form-group><label id=divDisplayWords>(In Words)</label></div></div><div class=col-md-3><div class=\"input-select input-normal date date-picker mgt13\" ng-class=\"{error : Approval.holder.netWorth\n                   && !Approval.holder.netWorthDate\n                   }\"><input type=text name=netWorthDate date-calendar format=DD-MMM-YYYY viewmode=days data-view-date=Approval.holder.netWorthDate date-default=Approval.defaultDateNetWorthDate maxdate=now data-min-date=Approval.minDate data-on-date-change=Approval.changeStartDateJointHolder autocomplete=off ng-model=Approval.holder.netWorthDate ng-required=\"!Approval.holder.grossAnnualIncome && !Approval.holder.netWorthDate\" ng-disabled=Approval.holder.grossAnnualIncome> <span class=highlight></span> <span class=bar></span> <i class=calendar-input-icon></i><!--<i class=\"times-icon\" ng-click=\"Approval.resetNetWorthDate()\"></i>--><label>As on DD-MMM-YYYY <span ng-if=\"!(Approval.holder.grossAnnualIncome)\n                ||(Approval.holder.netWorth)\" class=\"req text-red\">*</span></label><span ng-show=\"jointHolderForm.netWorthDate.$dirty && jointHolderForm.netWorthDate.$invalid\"><span class=error-input ng-show=jointHolderForm.netWorthDate.$error.required>{{Approval.validations.NET_WORTH_DATE}}</span></span></div><span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span></div></div></div><hr><div><p><strong>Politically Exposed Person (PEP) Status</strong></p><span class=radio-block><span class=radio><input type=radio id=politicalStatus1 name=politicalStatus ng-model=Approval.holder.politicalStatus ng-value=Approval.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=politicalStatus1>Investor is politically exposed person.</label></span><span class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=Approval.holder.politicalStatus ng-value=Approval.CONST.INVESTOR_POLITICAL_STATUS.RELATED> <span class=check></span></span><label for=politicalStatus2>Investor is related to politically exposed person.</label></span><span class=radio-block><span class=radio><input type=radio id=politicalStatus3 name=politicalStatus ng-model=Approval.holder.politicalStatus ng-value=Approval.CONST.INVESTOR_POLITICAL_STATUS.NONE> <span class=check></span></span><label for=politicalStatus3>Not Applicable</label></span></div><hr><div><p class=nomargin><strong>FATCA and CRS information</strong></p><div class=\"row pdt10\"><div class=col-md-3><div class=selectfield ng-class=\"{error:jointHolderForm.birthCountry.$dirty && jointHolderForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=Approval.holder.fatcaDetail.birthCountry ng-options=\"country.countryCode as country.countryName for country in Approval.countryList\" ng-init=\"Approval.holder.fatcaDetail.birthCountry = Approval.holder.fatcaDetail.birthCountry ? Approval.holder.fatcaDetail.birthCountry : null\" required><option value=\"\" selected>Country of Birth</option></select><span class=\"req text-red\">*</span> <span ng-show=\"jointHolderForm.birthCountry.$dirty && jointHolderForm.birthCountry.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry.$error.required>{{Approval.validations.COUNTRY}}</span></span></div></div><div class=col-md-3><div class=\"input-normal cityBirth\" ng-class=\"{error:jointHolderForm.birthPlace.$dirty && jointHolderForm.birthPlace.$invalid}\"><input type=text name=birthPlace only-alphabets ng-model=Approval.holder.fatcaDetail.birthPlace required> <span class=highlight></span> <span class=bar></span><label>City of Birth <span class=\"req text-red\">*</span></label><span ng-show=\"jointHolderForm.birthPlace.$dirty && jointHolderForm.birthPlace.$invalid\"><span class=error-input ng-show=jointHolderForm.birthPlace.$error.required>{{Approval.validations.BIRTH_CITY}}</span></span></div></div></div><div class=\"row pdt10\"><div class=col-md-3><div class=selectfield ng-class=\"{error:jointHolderForm.addressType.$dirty && jointHolderForm.addressType.$invalid}\"><select class=\"browser-default custom-select\" name=addressType ng-model=Approval.holder.fatcaDetail.addressType ng-options=\"_type.value as _type.addressDescription for _type in Approval.addressTypeList\" ng-init=\"Approval.holder.fatcaDetail.addressType = Approval.holder.fatcaDetail.addressType ? Approval.holder.fatcaDetail.addressType : null\" required><option value=\"\" selected>Address Type</option></select><label ng-if=Approval.formData.fatcaDetail.addressType>Address Type</label><span ng-show=\"jointHolderForm.addressType.$dirty && jointHolderForm.addressType.$invalid\"><span class=error-input ng-show=jointHolderForm.addressType.$error.required ng-bind=Approval.validations.ADDRESS_TYPE></span> </span><span class=\"req text-red\">*</span></div></div></div></div><div class=inves-pay><p><strong>Does the investor pay or file tax other than India?</strong></p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-model=Approval.holder.fatcaDetail.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-model=Approval.holder.fatcaDetail.payTaxInIndia ng-value=true> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span><!--First taxdetails--><div ng-if=!Approval.holder.fatcaDetail.payTaxInIndia><div class=tax-res><p><strong>Tax Residency Country</strong></p><div class=row><div class=col-md-4><div class=selectfield ng-class=\"{error:jointHolderForm.birthCountry1.$dirty && jointHolderForm.birthCountry1.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry ng-options=\"country.countryName as country.countryName for country in Approval.countryList|removeCountry:\'india\'\" ng-init=\"Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry = Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry ? Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry : null\" required><option value=\"\" selected>Name Of Country</option></select><span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.birthCountry1.$dirty && jointHolderForm.birthCountry1.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry1.$error.required>{{Approval.validations.COUNTRY}}</span></span></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><div class=selectfield ng-class=\"{error:jointHolderForm.taxIdType1.$dirty && jointHolderForm.taxIdType1.$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType-$index ng-model=Approval.holder.fatcaDetail.fatcaTax1.taxIdType ng-options=\"taxid.description as taxid.description for taxid in Approval.taxIdTypeList\" ng-init=\"Approval.holder.fatcaDetail.fatcaTax1.taxIdType = Approval.holder.fatcaDetail.fatcaTax1.taxIdType ? Approval.holder.fatcaDetail.fatcaTax1.taxIdType : null\" ng-required=Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry><option value=\"\" selected>Select Tax ID type</option></select><label ng-if=Approval.holder.fatcaDetail.fatcaTax1.taxIdType>Select Tax ID type</label><span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.taxIdType1.$dirty && jointHolderForm.taxIdType1.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType1.$error.required>{{Approval.validations.TAX_ID_TYPE}}</span></span></div></div></div><div class=row><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxIdNumber1 ng-model=Approval.holder.fatcaDetail.fatcaTax1.taxPayingCity ng-required=Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry capitalize> <span class=highlight></span> <span class=bar></span><label>City <span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry>*</span></label></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxIdNumber1 ng-model=Approval.holder.fatcaDetail.fatcaTax1.taxId ng-maxlength=20 limit-to=20 maxlength=20 ng-required=Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number <span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry>*</span></label></div></div></div></div><div class=\"add-another-tax-res tax-res\" ng-if=!Approval.holder.fatcaDetail.secondTax><a href=\"\" class=text-blue ng-click=\"Approval.holder.fatcaDetail.secondTax = true\"><strong><i class=expand-icon></i> <span>Add another tax residency country</span></strong></a></div></div><!--Second taxdetails--><div ng-if=\"!Approval.holder.fatcaDetail.payTaxInIndia && Approval.holder.fatcaDetail.secondTax\"><div class=tax-res><p><strong>Tax Residency Country <span class=remove-item ng-click=Approval.deleteSecond(Approval.holder.fatcaDetail)><i class=delete-red-icon></i></span></strong></p><div class=row><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><div class=selectfield ng-class=\"{error:jointHolderForm.birthCountry2.$dirty && jointHolderForm.birthCountry2.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry2 ng-model=Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry ng-options=\"country.countryName as country.countryName for country in Approval.countryList|removeCountry:\'india\'\" ng-init=\"Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry = Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry ? Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry : null\" ng-required=Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry><option value=\"\" selected>Name Of Country</option></select><span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.birthCountry2.$dirty && jointHolderForm.birthCountry2.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry2.$error.required>{{JointHolders.validations.COUNTRY}}</span></span></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><div class=selectfield ng-class=\"{error:jointHolderForm.taxIdType2.$dirty && jointHolderForm.taxIdType2.$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType2 ng-model=Approval.holder.fatcaDetail.fatcaTax2.taxIdType ng-options=\"taxid.description as taxid.description for taxid in Approval.taxIdTypeList\" ng-init=\"Approval.holder.fatcaDetail.fatcaTax2.taxIdType = Approval.holder.fatcaDetail.fatcaTax2.taxIdType ? Approval.holder.fatcaDetail.fatcaTax2.taxIdType : null\" ng-required=Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry><option value=\"\" selected>Select Tax ID type</option></select><label ng-if=Approval.holder.fatcaDetail.fatcaTax2.taxIdType>Select Tax ID type <span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry>*</span></label><span ng-show=\"jointHolderForm.taxIdType2.$dirty && jointHolderForm.taxIdType2.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType2.$error.required>{{JointHolders.validations.TAX_ID_TYPE}}</span></span></div></div></div><div class=row><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxIdNumber2 ng-model=Approval.holder.fatcaDetail.fatcaTax2.taxPayingCity ng-required=Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry capitalize> <span class=highlight></span> <span class=bar></span><label>City<span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry>*</span></label></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxIdNumber2 ng-model=Approval.holder.fatcaDetail.fatcaTax2.taxId ng-maxlength=20 limit-to=20 maxlength=20 ng-required=Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry>*</span></label></div></div></div></div><div class=\"add-another-tax-res tax-res\" ng-if=!Approval.holder.fatcaDetail.thirdTax><a href=\"\" class=text-blue ng-click=\"Approval.holder.fatcaDetail.thirdTax = true;\"><strong><i class=expand-icon></i> <span>Add another tax residency country</span></strong></a></div></div><!--Third taxdetails--><div ng-if=\"!Approval.holder.fatcaDetail.payTaxInIndia && Approval.holder.fatcaDetail.thirdTax\"><div class=tax-res><p><strong>Tax Residency Country <span class=remove-item ng-click=Approval.deleteThird(Approval.holder.fatcaDetail)><i class=delete-red-icon></i></span></strong></p><div class=row><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><div class=selectfield ng-class=\"{error:jointHolderForm.birthCountry3.$dirty && jointHolderForm.birthCountry3.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry ng-options=\"country.countryName as country.countryName for country in Approval.countryList|removeCountry:\'india\'\" ng-init=\"Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry = Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry ? Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry : null\" ng-required=Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry><option value=\"\" selected>Name Of Country</option></select><span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.birthCountry3.$dirty && jointHolderForm.birthCountry3.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry3.$error.required>{{JointHolders.validations.COUNTRY}}</span></span></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry}\"><div class=selectfield ng-class=\"{error:jointHolderForm.taxIdType3.$dirty && jointHolderForm.taxIdType3.$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType-$index ng-model=Approval.holder.fatcaDetail.fatcaTax3.taxIdType ng-options=\"taxid.description as taxid.description for taxid in Approval.taxIdTypeList\" ng-init=\"Approval.holder.fatcaDetail.fatcaTax3.taxIdType = Approval.holder.fatcaDetail.fatcaTax3.taxIdType ? Approval.holder.fatcaDetail.fatcaTax3.taxIdType : null\" ng-required=Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry><option value=\"\" selected>Select Tax ID type</option></select><label ng-if=Approval.holder.fatcaDetail.fatcaTax3.taxIdType>Select Tax ID type</label><span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.taxIdType3.$dirty && jointHolderForm.taxIdType3.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType3.$error.required>{{JointHolders.validations.TAX_ID_TYPE}}</span></span></div></div></div><div class=row><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxPayingCity3 ng-model=Approval.holder.fatcaDetail.fatcaTax3.taxPayingCity ng-required=Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry capitalize> <span class=highlight></span> <span class=bar></span><label>City<span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry>*</span></label></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxIdNumber3 ng-model=Approval.holder.fatcaDetail.fatcaTax3.taxId ng-maxlength=20 limit-to=20 maxlength=20 ng-required=Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=\"req text-red\" ng-if=Approval.holder.fatcaDetail.fatcaTax3.taxPayingCountry>*</span></label></div></div></div></div></div></div><div id=tab-container class=\"tab-container clearfix\"><ul class=\"mobile-hide nav nav-tabs\"><li><strong>Nominee Details</strong></li></ul></div><section class=\"minor-details holder-nominees\"><div class=box-body><div class=\"box-details nominee-list-section clearfix\"><div class=\"row optOutContainer\" ng-if=\"Approval.nominees.length == 0\"><div class=\"checkbox declarationText\" style=\"margin-bottom: 20px !important\"><input type=checkbox ng-value=true ng-disabled=true ng-checked=true> <span class=icon-checkbox></span> <span class=checkbox-text>I hereby declare to opting out of nomination</span></div><div class=checkbox-text style=margin-left:5px!important><ng-bind-html dynamic=Approval.dynamicNote.content></ng-bind-html></div></div><div class=col-md-4 ng-repeat=\"nominee in Approval.nominees\"><p style=\"margin-top: 0px\" class=nomargin><strong>Nominee {{$index+1}} Detail</strong></p><table class=table><tr><td><span><strong>Nominee Name:</strong></span> &nbsp; <strong>{{nominee.nomineeName}}</strong></td></tr><tr><td><span><strong>Nominee Relation:</strong></span> &nbsp; <strong>{{nominee.nomineeRelation}}</strong></td></tr><tr><td><span><strong>Nominee Dob:</strong></span> &nbsp; <strong>{{nominee.dob}}</strong></td></tr><tr><td><span><strong>Nominee Percentage:</strong></span> &nbsp; <strong>{{nominee.percentage}}</strong></td></tr><tr ng-if=Approval.folioDetails.sebiNomineeRegulatory01650Active><td><span><strong>Nominee Email Id:</strong></span> &nbsp; <strong>{{nominee.emailId}}</strong></td></tr><tr ng-if=Approval.folioDetails.sebiNomineeRegulatory01650Active><td><span><strong>Nominee Mobile No.:</strong></span> &nbsp; <strong>{{nominee.mobileNumber}}</strong></td></tr><tr ng-if=Approval.folioDetails.sebiNomineeRegulatory01650Active><td><span><strong>Nominee Personal Identifier:</strong></span> &nbsp; <strong>{{nominee.identityProofDescription}}</strong></td></tr><tr ng-if=\"Approval.folioDetails.sebiNomineeRegulatory01650Active && nominee.identityProofNumber\"><td><span ng-if=\"nominee.identityProofType === \'AADHAR_CARD\'\"><strong>Nominee Aadhar Card:</strong></span> <span ng-if=\"nominee.identityProofType === \'DRIVING_LICENSE\'\"><strong>Nominee Driving License:</strong></span> <span ng-if=\"nominee.identityProofType === \'PASSPORT\'\"><strong>Nominee Passport:</strong></span> <span ng-if=\"nominee.identityProofType === \'PAN_CARD\'\"><strong>Nominee Pan:</strong></span> &nbsp; <strong><span easyassist-key=mask-element><span ng-if=\"nominee.identityProofType === \'AADHAR_CARD\'\">XXXX XXXX </span>{{nominee.identityProofNumber}}</span></strong></td></tr><!--<tr ng-if=\"nominee.soleAddressApplicable\">\n                                <td><span><strong>Address Details:</strong></span> &nbsp; <strong>Same As Investor</strong></td>\n                              </tr>--><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine1  && !nominee.minor\"><td><span><strong>Nominee AddressLine1:</strong></span> &nbsp; <strong>{{nominee.nomineeAddress.addressLine1}}</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine2 && !nominee.minor\"><td><span><strong>Nominee AddressLine2:</strong></span> &nbsp; <strong>{{nominee.nomineeAddress.addressLine2}}</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine3 && !nominee.minor\"><td><span><strong>Nominee AddressLine3:</strong></span> &nbsp; <strong>{{nominee.nomineeAddress.addressLine3}}</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.city && !nominee.minor\"><td><span><strong>Nominee\'s City:</strong></span> &nbsp; <strong>{{nominee.nomineeAddress.city}}</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.countryName && !nominee.minor\"><td><span><strong>Nominee\'s Country:</strong></span> &nbsp; <strong ng-bind=nominee.nomineeAddress.countryName>{{nominee.nomineeAddress.countryName}}</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.pinCode && !nominee.minor\"><td><span><strong>Nominee\'s PinCode:</strong></span> &nbsp; <strong>{{nominee.nomineeAddress.pinCode}}</strong></td></tr><tr><td ng-if=\"nominee.guardianName && nominee.minor\"><span><strong>Guardian Name:</strong></span> &nbsp; <strong>{{nominee.guardianName}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine1 && nominee.minor\"><td><span><strong>Guardian\'s AddressLine1:</strong></span> &nbsp; <strong>{{nominee.guardianAddress.addressLine1}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine2 && nominee.minor\"><td><span><strong>Guardian\'s AddressLine2:</strong></span> &nbsp; <strong>{{nominee.guardianAddress.addressLine2}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine3 && nominee.minor\"><td><span><strong>Guardian\'s AddressLine3:</strong></span> &nbsp; <strong>{{nominee.guardianAddress.addressLine3}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.city && nominee.minor\"><td><span><strong>Guardian\'s City:</strong></span> &nbsp; <strong>{{nominee.guardianAddress.city}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.countryName && nominee.minor\"><td><span><strong>Guardian\'s Country:</strong></span> &nbsp; <strong>{{nominee.guardianAddress.countryName}} </strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.pinCode && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s PinCode:</strong></span> &nbsp; <strong>{{nominee.guardianAddress.pinCode}}</strong></td></tr></table></div></div><div class=\"box-details clearfix\"><div class=col-md-4 ng-if=\"Approval.folioDetails.nomineeRegistrationCO && Approval.folioDetails.nomineeRegistrationCO.accountHoldingDeclaration\"><h6 class=text-blue>Statement of Holding:</h6><table class=table><tr><td><span><strong>{{Approval.folioDetails.nomineeRegistrationCO.accountHoldingDeclaration === \'NOMINATION_YES\' ? \'Nomination: Yes\': \'Nomination: No\'}}</strong></span></td></tr></table></div></div></div></section><div class=form-footer ng-if=!Approval.hideApproveReject><span ng-show=\"$state.current.name==\'main.investorApproval\'\" ui-sref=main.profile.pendingApprovals class=\"pull-left back\" role=button tabindex=0><i class=arrow-blue-back-icon></i>Back</span> <button class=\"btn btn-negative-action\" ng-click=Approval.confirmCancelModaltoReject()>Reject</button> <button type=submit class=\"btn btn-primary-action\" ng-disabled=\"jointHolderForm.$invalid||(Approval.holder.netWorth && !Approval.holder.netWorthDate) && (!Approval.holder.email && !Approval.holder.mobileNumber)\" ng-click=Approval.approveFolioSubmit()>Approve</button></div></div></div></div></div></div></div></form><!--<footer class=\"faq-foot\">2016 HDFC Asset Management Company Ltd. All Rights Reserved</footer>--><div class=scroll-top><i class=white-up-icon></i> Scroll To Top</div></section></div></div><style>div#investors span.radio-block label {\n    display: block;\n    margin-top: -19px;\n    margin-left: 30px;\n  }\n\n  div#add-joint-holder p.pdt10 {\n    margin-top: 12px;\n    margin-bottom: 1px;\n  }\n\n  div#tab-container.tab-container ul.mobile-hide.nav.nav-tabs {\n    margin-bottom: 20px;\n  }\n\n  div.input-normal.cityBirth {\n    margin-top: 13px;\n  }\n  .input-normal.date.date-picker{margin-bottom: 0px;}\n\n  table.table tbody tr td:first-child {\n    padding-left: 0px;\n  }\n  table.table {\n    border-bottom: none;\n  }\n  .table > tbody > tr > td{\n    border-top:none;\n  }\n  .input-normal input.ng-dirty.ng-not-empty ~ label, .input-normal input[ng-required].ng-not-empty ~ label {\n    top: -5px;\n    font-size: 12px;\n  }\n  .add-margin {\n    margin-top: 100px;\n  }\n  .belongsToContainerWeb , .belongsToContainerMobile {\n    padding-left: 0px !important;\n  }</style>");
$templateCache.put("app/investor/holderApprovalForNominee/holderApprovalForNominee.html","<div ng-if=ApprovalForNominee.isLoaded ng-class=\"{\'main-section\' : ApprovalForNominee.approvalType}\"><div class=\"investors updateNomineeDetailsSmartlink\" ng-if=!ApprovalForNominee.isOptout><form autocomplete=off class=nominee-section name=addNomineeForm novalidate style=\"margin: 0px; padding: 50px\" ng-class=\"{\'from-portal-for-nomination\' : ApprovalForNominee.approvalType}\"><!--<form autocomplete=\"off\" class=\"nominee-section\" name=\"addNomineeForm\" novalidate>--><div ng-if=!ApprovalForNominee.approvalType><h5 class=screen-title>Review Nominee Details</h5><div class=border-bottom-underline></div></div><div class=\"form-content nominee-details-container\" ng-class=\"{\'pd-incase-from-portal\' : ApprovalForNominee.approvalType}\"><div ng-if=ApprovalForNominee.approvalType style=\"padding-top: 30px\"><h5 class=screen-title>Review Nominee Details</h5><div class=border-bottom-underline></div></div><div class=form-content><label style=\"padding: 5px; font-size: 16px\"><strong>Contact Details</strong></label><div class=row style=\"padding: 5px\"><div class=col-md-3 style=\"margin-right: 40px\" ng-if=ApprovalForNominee.investorEmail><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{ApprovalForNominee.investorEmail}}</label></div><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!ApprovalForNominee.investorEmail><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : Not available</label></div><div class=\"col-md-3 mLabel\" ng-if=ApprovalForNominee.investorMobile><label class=mobile-belongs-to style=\"margin-top: 30px; margin-left:30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : {{ApprovalForNominee.investorMobile}}</label></div><div class=col-md-3 ng-if=!ApprovalForNominee.investorMobile><label class=mobile-belongs-to style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : Not available</label></div></div><div class=row style=\"padding: 5px\"><div class=\"col-md-3 belongsToContainerWeb\" style=\"display: inline-flex;  margin-right: 40px\" ng-if=ApprovalForNominee.investorEmail><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block ; margin-left : 5px\" ng-class=\"{error:addNomineeForm.emailBelongsTo.$dirty && addNomineeForm.emailBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=emailBelongsTo style=\"width: 150px\" ng-model=ApprovalForNominee.emailBelongsTo ng-init=\"ApprovalForNominee.emailBelongsTo = ApprovalForNominee.emailBelongsTo ? ApprovalForNominee.emailBelongsTo: null\" ng-options=\"data.familyCode as data.familyDescription for data in ApprovalForNominee.belongToListEmail\" required><option value=\"\" selected>Select Value</option></select><span ng-if=\"addNomineeForm.emailBelongsTo.$dirty && addNomineeForm.emailBelongsTo.$invalid\"><span class=error-input style=\"width: max-content\" ng-if=addNomineeForm.emailBelongsTo.$error.required>{{ApprovalForNominee.validateData.EMAIL_BELONGS_TO}}</span></span></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!ApprovalForNominee.investorEmail></div><div class=\"col-md-3 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=ApprovalForNominee.investorMobile><div class=mobile-belongs-to style=\"flex-shrink : 0; margin-left: 30px\"><label class=mobile-belongs-to style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block\" ng-class=\"{error:addNomineeForm.mobileBelongsTo.$dirty && addNomineeForm.mobileBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=mobileBelongsTo style=\"width: 150px\" ng-model=ApprovalForNominee.mobileBelongsTo ng-init=\"ApprovalForNominee.mobileBelongsTo = ApprovalForNominee.mobileBelongsTo ? ApprovalForNominee.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in ApprovalForNominee.belongToListMobile\" required><option value=\"\" selected>Select Value</option></select><span ng-if=\"addNomineeForm.mobileBelongsTo.$dirty && addNomineeForm.mobileBelongsTo.$invalid\"><span class=error-input style=\"width: max-content\" ng-if=addNomineeForm.mobileBelongsTo.$error.required>{{ApprovalForNominee.validateData.MOBILE_BELONGS_TO}}</span></span></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!ApprovalForNominee.investorMobile></div></div></div><!--      <div class=\"row\" ng-if=\"wantToAddNomineeLater\"></div>--><div><div class=\"nominee-list proportion-div\"><div>Proportion <span class=text-warn>(Should not be greater than 100%)</span></div></div><div class=tab-container><ul class=\"nav nav-tabs\" ng-class=\"{\'updated-width holder-smartlink\': ApprovalForNominee.isSebiRegActive}\"><li ng-repeat=\"data in ApprovalForNominee.nomineePayload track by $index\" ng-click=ApprovalForNominee.setActiveTab($index) ng-class=\"{\'active\':ApprovalForNominee.activeTab===$index}\">{{ApprovalForNominee.nomineeEnum[$index]}} Nominee Details</li></ul></div><div name=\"nominee-details tab-content\" ng-repeat=\"data in ApprovalForNominee.nomineePayload track by $index\" ng-show=\"ApprovalForNominee.activeTab===$index\"><div class=row><div class=col-md-2><div class=input-normal>{{data.firstName}}</div></div><div class=col-md-2><div class=input-normal>{{data.percentage}} %</div></div></div><div class=\"row nominee-section-details\"><div class=col-md-4><div class=input-normal><p>DDD-MMM-YYYY<span class=req></span></p><div>{{data.dateOfBirth}}</div></div></div><div class=col-md-4><div class=input-normal><p>Relationship with Applicant</p><div>{{data.relation}}</div></div></div><div class=col-md-4 ng-if=\"ApprovalForNominee.isSebiRegActive && data.emailId\"><div class=input-normal><p>Nominee Email Id</p><div>{{data.emailId}}</div></div></div><div class=col-md-4 ng-if=\"ApprovalForNominee.isSebiRegActive && data.mobileNumber\"><div class=input-normal><p>Nominee Mobile No.</p><div>{{data.mobileNumber}}</div></div></div><div class=col-md-4 ng-if=\"ApprovalForNominee.isSebiRegActive && data.identityProofType\"><div class=input-normal><p>Nominee Personal Identifier</p><div>{{data.identityProofDescription}}</div></div></div><div class=col-md-4 ng-if=\"ApprovalForNominee.isSebiRegActive && data.identityProofNumber\"><div class=input-normal><p ng-if=\"data.identityProofType === \'AADHAR_CARD\'\">Nominee Aadhar Card</p><p ng-if=\"data.identityProofType === \'DRIVING_LICENSE\'\">Nominee Driving License</p><p ng-if=\"data.identityProofType === \'PAN_CARD\'\">Nominee Pan</p><p ng-if=\"data.identityProofType === \'PASSPORT\'\">Nominee Passport</p><p ng-if=\"data.identityProofType === \'OTHERS\'\">Nominee Other Identity</p><div>{{data.identityProofNumber}}</div></div></div></div><div class=\"row nominee-section-details\" ng-if=!ApprovalForNominee.isSebiRegActive><div class=col-md-4><div class=input-normal><p>PAN</p><div>{{data.panNumber ? data.panNumber : \'Not Available\'}}</div></div></div></div><div ng-if=data.minor class=nominee-section-details><p style=\"margin-bottom: 0px\">Guardian Details</p><div class=row><div class=col-md-4><div class=input-normal style=\"margin-top: 12px\" ng-class=\"{error:addNomineeForm[\'guardianName-\'+$index].$dirty && addNomineeForm[\'guardianName-\'+$index].$invalid}\"><input type=text ng-model=data.guardianName name=guardianName-{{$index}} ng-maxlength=40 limit-to=40 maxlength=40 only-alphabets capitalize required readonly> <span class=highlight></span> <span class=bar></span><label>Guardian Name<span class=\"req text-red\">*</span></label></div></div><div class=col-md-4><div class=input-normal style=\"margin-top: 12px\" ng-class=\"{error:addNomineeForm[\'guardianRelationWithNominee-\'+$index].$dirty && addNomineeForm[\'guardianRelation-\'+$index].$invalid}\"><input type=text ng-model=data.guardianRelationWithNominee name=guardianRelationWithNominee-{{$index}} ng-init=\"data.guardianRelationWithNominee=data.guardianRelationWithNominee?data.guardianRelationWithNominee:null\" required readonly> <span class=highlight></span> <span class=bar></span><label>Guardian\'s Relationship with Nominee<span class=\"req text-red\">*</span></label></div></div></div><div class=row><div class=col-md-4><div class=\"input-normal input-pan\" ng-class=\"{error:addNomineeForm[\'guardianPanNumber-\'+$index].$dirty && addNomineeForm[\'guardianPanNumber-\'+$index].$invalid}\"><input type=text maxlength=10 minlength=10 ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-bind=data.guardianPanNumber ng-model=data.guardianPanNumber name=guardianPanNumber-{{$index}} ng-change=\"minorPanChanged($index , data.guardianPanNumber , true)\" autocomplete=off capitalize required readonly><label style=\"color: #9f9f9f; font-size: 13px; font-weight: normal; position: absolute; pointer-events: none; left: 5px; top: 15px; transition: 0.2s ease all\">PAN of Guardian <span class=\"req text-red\">*</span></label></div></div></div></div><p style=\"margin-left: 0px\">Address Details of <span ng-if=!ApprovalForNominee.nomineePayload[$index].guardianName>Nominee</span><span ng-if=ApprovalForNominee.nomineePayload[$index].guardianName>Nominee’s Guardian</span></p><div ng-if=!data.minor><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid}\"><input type=text ng-model=data.nomineeAddress1 name=addressLine1-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 easyassist-key=mask-element capitalize readonly> <span class=highlight></span> <span class=bar></span><label>Address Line 1</label></div></div><div class=col-md-4><div class=input-normal><input type=text ng-model=data.nomineeAddress2 name=addressLine2-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 easyassist-key=mask-element capitalize readonly> <span class=highlight></span> <span class=bar></span><label>Address Line 2</label></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'residencyCountry-\'+$index].$dirty && addNomineeForm[\'residencyCountry-\'+$index].$invalid}\"><input type=text ng-model=data.country name=residencyCountry-{{$index}} ng-change=changeCountry($index,data.country) ng-init=\"data.country=data.country?data.country:null\" easyassist-key=mask-element readonly> <span class=highlight></span> <span class=bar></span><label>Name of country</label></div></div><!--              <div class=\"col-md-4\">--><!--                <div class=\"selectfield\" ng-class=\"{error:addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid}\">--><!--                  <select name=\"state-{{$index}}\"--><!--                          ng-disabled=\"data.nomineeAddress.country != \'IN\'\"--><!--                          ng-model=\"data.nomineeAddress.state\"--><!--                          ng-init=\"data.nomineeAddress.state=data.nomineeAddress.state?data.nomineeAddress.state:null\"--><!--                          ng-options=\"_state.stateCode as _state.stateName for _state in stateList\"--><!--                          ng-change=\"changeState($index,data.nomineeAddress.state)\"--><!--                          required>--><!--                    <option value=\"\" selected>Select State</option>--><!--                  </select>--><!--                  <label ng-if=\"data.nomineeAddress.state\">STATE</label>--><!--                  <span class=\"req text-red\">*</span>--><!--&lt;!&ndash;                  <span ng-show=\"addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid\">&ndash;&gt;--><!--&lt;!&ndash;                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'state-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.STATE_REQUIRED}}</span>&ndash;&gt;--><!--&lt;!&ndash;                </span>&ndash;&gt;--><!--                </div>--><!--              </div>--><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid}\"><input type=text ng-model=data.state name=residencyCountry-{{$index}} ng-init=\"data.state=data.state?data.state:null\" easyassist-key=mask-element readonly> <span class=highlight></span> <span class=bar></span><label>STATE</label></div></div><!--<div class=\"col-md-4\">\n                  <div class=\"input-normal mgt8\"\n                       ng-class=\"{error:addNomineeForm[\'state\'+$index].$dirty && addNomineeForm[\'state\'+$index].$invalid}\">\n                    <input type=\"text\" ng-model=\"data.nomineeAddress.state\" name=\"state{{$index}}\" required>\n                    <span class=\"highlight\"></span>\n                    <span class=\"bar\"></span>\n                    <label>State <span class=\"req text-red\">*</span></label>\n                    <span\n                      ng-show=\"addNomineeForm[\'state\'+$index].$dirty && addNomineeForm[\'state\'+$index].$invalid\">\n                <span class=\"error-input\" ng-show=\"addNomineeForm[\'state\'+$index].$error.required\">{{Nominee.validateData.STATE_REQUIRED}}</span>\n                  </span>\n                  </div>\n                </div>--></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid}\"><input type=text ng-model=data.city name=city-{{$index}} ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element only-alphabets capitalize readonly> <span class=highlight></span> <span class=bar></span><label>City</label></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'pinCode-\'+$index].$dirty && addNomineeForm[\'pinCode-\'+$index].$invalid}\"><input type=text ng-model=data.postalCode name=pinCode-{{$index}} is-number ng-maxlength=6 limit-to=6 easyassist-key=mask-element maxlength=6 readonly> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code</label></div></div></div></div></div><div class=row ng-if=\"ApprovalForNominee.isSebiRegActive && ApprovalForNominee.summaryData.accountHoldingDeclaration\"><div class=col-md-12><p style=\"margin-left: 0px\">Statement of Holding</p><div class=mb-2><span>{{ApprovalForNominee.summaryData.accountHoldingDeclaration === \'NOMINATION_YES\' ? \'Nomination: Yes\': \'Nomination: No\'}}</span></div></div></div></div><!--<hr />--><div class=\"form-footer form-content\" ng-if=!ApprovalForNominee.hideApproveReject><div class=btn-div><button class=\"btn btn-secondary-action\" ng-click=ApprovalForNominee.confirmReject()>Reject</button> <button class=\"btn btn-primary-action\" ng-click=ApprovalForNominee.approveFolioSubmit() ng-disabled=\"addNomineeForm.$invalid || !ApprovalForNominee.investorEmail || !ApprovalForNominee.investorMobile\">Approve</button></div></div></div></form></div><div ng-if=ApprovalForNominee.isOptout class=updateNomineeDetailsSmartlink style=\"padding: 50px 50px 10px 50px\" ng-class=\"{\'from-portal-for-optout\' : ApprovalForNominee.approvalType}\"><section class=nominee-details><div class=form-content style=\"padding: 0px\" ng-class=\"{\'pd-for-portal-optout\' : ApprovalForNominee.approvalType}\"><h5 class=screen-title>Review Opt-out</h5><div style=\"height: 8px; background-color: #AEAEAE; margin-bottom: 50px\"></div><h4 class=screen-title>{{ApprovalForNominee.optOutMsg}}</h4><div><label style=\"padding: 5px; font-size: 16px\"><strong>Contact Details</strong></label><div class=row style=\"padding: 5px\"><div class=col-md-3 style=\"margin-right: 40px\" ng-if=ApprovalForNominee.investorEmail><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{ApprovalForNominee.investorEmail}}</label></div><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!ApprovalForNominee.investorEmail><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : Not available</label></div><div class=\"col-md-3 mLabel\" ng-if=ApprovalForNominee.investorMobile><label class=mobile-belongs-to style=\"margin-top: 30px; margin-left:30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : {{ApprovalForNominee.investorMobile}}</label></div><div class=col-md-3 ng-if=!ApprovalForNominee.investorMobile><label class=mobile-belongs-to style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : Not available</label></div></div><div class=row style=\"padding: 5px\"><div class=\"col-md-3 belongsToContainerWeb\" style=\"display: inline-flex;  margin-right: 40px\" ng-if=ApprovalForNominee.investorEmail><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block ; margin-left : 5px\" ng-class=\"{error:addNomineeForm.emailBelongsTo.$dirty && addNomineeForm.emailBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=emailBelongsTo style=\"width: 150px\" ng-model=ApprovalForNominee.emailBelongsTo ng-init=\"ApprovalForNominee.emailBelongsTo = ApprovalForNominee.emailBelongsTo ? ApprovalForNominee.emailBelongsTo: null\" ng-options=\"data.familyCode as data.familyDescription for data in ApprovalForNominee.belongToListEmail\" required><option value=\"\" selected>Select Value</option></select><span ng-if=\"addNomineeForm.emailBelongsTo.$dirty && addNomineeForm.emailBelongsTo.$invalid\"><span class=error-input style=\"width: max-content\" ng-if=OptoutNomineeForm.emailBelongsTo.$error.required>{{ApprovalForNominee.validateData.EMAIL_BELONGS_TO}}</span></span></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!ApprovalForNominee.investorEmail></div><div class=\"col-md-3 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=ApprovalForNominee.investorMobile><div class=mobile-belongs-to style=\"flex-shrink : 0; margin-left: 30px\"><label class=mobile-belongs-to style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block\" ng-class=\"{error:addNomineeForm.mobileBelongsTo.$dirty && addNomineeForm.mobileBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=mobileBelongsTo style=\"width: 150px\" ng-model=ApprovalForNominee.mobileBelongsTo ng-init=\"ApprovalForNominee.mobileBelongsTo = ApprovalForNominee.mobileBelongsTo ? ApprovalForNominee.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in ApprovalForNominee.belongToListMobile\" required><option value=\"\" selected>Select Value</option></select><span ng-if=\"addNomineeForm.mobileBelongsTo.$dirty && addNomineeForm.mobileBelongsTo.$invalid\"><span class=error-input style=\"width: max-content\" ng-if=addNomineeForm.mobileBelongsTo.$error.required>{{ApprovalForNominee.validateData.MOBILE_BELONGS_TO}}</span></span></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!ApprovalForNominee.investorMobile></div></div></div><div class=optOutalign><div class=\"checkbox optoutNomineeCheckbox\"><input type=checkbox name=TnC ng-model=ApprovalForNominee.TnC required> <i class=icon-checkbox style=\"padding-right: 25px\"></i> <span class=checkbox-text style=\"text-align: left\">I / We hereby confirm that I / We do not wish to appoint any nominee(s) for my mutual fund units held in my / our folio listed below and understand the issues involved in non appointment of nominee(s) and further am/are aware that in case of death of all the account holder(s), my / our legal heirs would need to submit all the requisite documents issued by Court or other such competent authority, based on the value of assets held in the mutual fund folio.</span></div></div><div class=\"form-footer form-content\" ng-if=!ApprovalForNominee.hideApproveReject><div class=btn-div><button type=button class=\"btn btn-secondary-action\" ng-click=ApprovalForNominee.confirmReject()>Reject</button> <button class=\"btn btn-primary-action\" ng-disabled=\"!ApprovalForNominee.TnC || addNomineeForm.$invalid || !ApprovalForNominee.investorEmail || !ApprovalForNominee.investorMobile\" ng-click=ApprovalForNominee.approveFolioSubmit()>Approve</button></div></div></div></section></div></div><style>.input-pan input:focus ~ label , .input-pan input.ng-not-empty ~ label{\n    top: -5px !important;\n    font-size: 12px !important;\n  }</style>");
$templateCache.put("app/investor/profile/fatcaUpdate.html","<div class=\"main-section fatcaUpdate\" ng-init=Profile.fatca_init()><h3 class=screen-title ng-bind=\"Profile.fullName |camelcase\">Aakash Kumar</h3><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.profile.basicInfo>Profile </span><i class=breadcrumb-icon></i><span> FATCA/CRS</span></p><div class=content-area><form name=fatcaUpdateForm><p class=\"col-md-12 form-title\"><strong>FATCA and CRS Information</strong></p><div class=col-md-12><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:fatcaUpdateForm.birthCountry.$dirty && fatcaUpdateForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=Profile.formData.birthCountry ng-options=\"country.countryCode as country.countryName for country in Profile.countryList\" ng-init=\"Profile.formData.birthCountry = Profile.formData.birthCountry ? Profile.formData.birthCountry : null\" required><option value=\"\" selected>Country of Birth</option></select><label ng-if=Profile.formData.birthCountry>Country of Birth</label><span class=\"req text-red\">*</span> <span ng-show=\"fatcaUpdateForm.birthCountry.$dirty && fatcaUpdateForm.birthCountry.$invalid\"><span class=error-input ng-show=fatcaUpdateForm.birthCountry.$error.required>{{Profile.validations.BIRTH_COUNTRY}}</span></span></div></div><div class=col-md-3><div class=\"input-normal cityBirth\" ng-class=\"{error:fatcaUpdateForm.birthCity.$dirty && fatcaUpdateForm.birthCity.$invalid}\"><input type=text name=birthCity ng-model=Profile.formData.birthCity required only-alphabets> <span class=highlight></span> <span class=bar></span><label>City of Birth <span class=\"req text-red\">*</span></label><span ng-show=\"fatcaUpdateForm.birthCity.$dirty && fatcaUpdateForm.birthCity.$invalid\"><span class=error-input ng-show=fatcaUpdateForm.birthCity.$error.required>{{Profile.validations.BIRTH_CITY}}</span></span></div></div><div class=col-md-3><div class=selectfield ng-class=\"{error:fatcaUpdateForm.fatcaAddressType.$dirty && fatcaUpdateForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-model=Profile.formData.fatcaAddressType ng-options=\"_type.value as _type.addressDescription for _type in Profile.addressTypeList\" ng-init=\"Profile.formData.fatcaAddressType = Profile.formData.fatcaAddressType ? Profile.formData.fatcaAddressType : null\" required><option value=\"\" selected>Address Type</option></select><label ng-if=Profile.formData.fatcaAddressType>Address Type</label><span ng-show=\"fatcaUpdateForm.fatcaAddressType.$dirty && fatcaUpdateForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=fatcaUpdateForm.fatcaAddressType.$error.required ng-bind=Profile.validations.FATCA_ADDRESS_TYPE_REQUIRED></span> </span><span class=\"req text-red\">*</span></div></div></div><div class=row><div class=col-md-3><div class=\"input-normal cityBirth\" ng-class=\"{error:fatcaUpdateForm.fatherName.$dirty && fatcaUpdateForm.fatherName.$invalid}\"><input type=text name=fatherName ng-model=Profile.formData.fatherName required> <span class=highlight></span> <span class=bar></span><label>Father\'s Name<span class=\"req text-red\">*</span></label><span ng-show=\"fatcaUpdateForm.fatherName.$dirty && fatcaUpdateForm.fatherName.$invalid\"><span class=error-input ng-show=fatcaUpdateForm.fatherName.$error.required>{{Profile.validations.FATHER_NAME}}</span></span></div></div><div class=col-md-3><div class=\"input-normal cityBirth\" ng-class=\"{error:fatcaUpdateForm.spouseName.$dirty && fatcaUpdateForm.spouseName.$invalid}\"><input type=text name=spouseName ng-model=Profile.formData.spouseName> <span class=highlight></span> <span class=bar></span><label>Spouse\'s Name<!--<span class=\"req text-red\">*</span>--></label><span ng-show=\"fatcaUpdateForm.spouseName.$dirty && fatcaUpdateForm.spouseName.$invalid\"><span class=error-input ng-show=fatcaUpdateForm.spouseName.$error.required>{{Profile.validations.SPOUSE_NAME}}</span></span></div></div></div><div class=form-group><p class=tax-payment><strong>Does the investor pay or file tax other than India?</strong></p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-change=Profile.changePayTaxOutsideIndiaStatus(true) ng-model=Profile.formData.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-model=Profile.formData.payTaxInIndia ng-value=true> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span></div><table class=\"table fatca-table\" ng-if=!Profile.formData.payTaxInIndia><thead><tr><th>S. No</th><th>Tax Country</th><th>Tax ID Type</th><th>Tax ID Number</th><th></th></tr></thead><tbody><tr ng-repeat=\"data in Profile.formData.payOutsideIndiaAddresses track by $index\"><td class=text-bold>{{$index+1}}</td><td class=text-bold ng-bind=Profile.fetchCountryNameFromCode(data.country)>Czech Republic</td><td class=text-bold ng-bind=Profile.fetchTaxIdTypeFromKey(data.taxIdType)>Passport</td><td class=text-bold ng-bind=data.taxIdNumber>100098</td><td ng-click=Profile.deleteFatcaTaxResidency($index)><i class=delete-red-icon></i></td></tr><tr ng-if=\"Profile.formData.payOutsideIndiaAddresses.length==0\"><td colspan=5 align=center class=text-bold>No Data</td></tr></tbody></table><div class=tax-res ng-if=\"!Profile.formData.payTaxInIndia && Profile.formData.payOutsideIndiaAddresses.length<4\"><p class=text-blue ng-click=Profile.addFatcaTaxResidency()><strong><i class=expand-icon></i><span class=add-another-tax-res>Add Country </span></strong></p><!--ng-show=\"((Profile.formData.payOutsideIndiaAddresses.length)*1<3)\"--></div></div><div class=tc-block><h6>Terms & Conditions</h6><div><div class=checkbox><input ng-model=Profile.isCheckedFatcaTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=Profile.showFatcaTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment.</span></div></div></div><div class=\"form-footer col-md-12\"><a href=\"\" class=\"pull-left back\" ng-click=Profile.goToBack()><i class=arrow-blue-back-icon></i>Back</a> <span class=pull-right><input ng-disabled=\"(fatcaUpdateForm.$invalid || ((!Profile.formData.payTaxInIndia && Profile.formData.payOutsideIndiaAddresses.length==0))) || !Profile.isCheckedFatcaTandC\" type=button value=Save class=\"btn btn-primary-action\" ng-click=Profile.saveFatcaUpdate()></span></div></form></div></div>");
$templateCache.put("app/investor/profile/kycUpdate.html","<div class=\"main-section kycUpdate\" ng-init=Profile.kyc_init()><h3 class=screen-title ng-bind=\"Profile.fullName |camelcase\">Aakash Kumar</h3><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.profile.basicInfo>Profile </span><i class=breadcrumb-icon></i><span> KYC Update</span></p><div class=content-area><form name=kycUpdateForm><p class=\"col-md-12 form-title\"><strong>Occupation Details</strong></p><div class=col-md-12><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:kycUpdateForm.occupation.$dirty && kycUpdateForm.occupation.$invalid}\"><select class=\"browser-default custom-select\" name=occupation ng-model=Profile.formData.occupation ng-options=\"_type.occupationCode as _type.occupationDescription for _type in Profile.occupationList\" ng-init=\"Profile.formData.occupation = Profile.formData.occupation ? Profile.formData.occupation : null\" required><option value=\"\" selected>Occupation</option></select><label ng-if=Profile.formData.occupation>Occupation</label><span ng-show=\"kycUpdateForm.occupation.$dirty && kycUpdateForm.occupation.$invalid\"><span class=error-input ng-show=kycUpdateForm.occupation.$error.required ng-bind=Profile.validations.OCCUPATION></span> </span><span class=\"req text-red\">*</span></div></div></div><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:kycUpdateForm.grossAnnualIncome.$dirty\n                 && kycUpdateForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-model=Profile.formData.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in Profile.incomeSlabList\" ng-init=\"Profile.formData.grossAnnualIncome = Profile.formData.grossAnnualIncome ? Profile.formData.grossAnnualIncome : null\" ng-required=\"!Profile.formData.netWorth && !Profile.formData.netWorthDate\" ng-class=\"{\'selectfield-disabled\':Profile.formData.netWorth}\"><!--ng-disabled=\"Profile.formData.netWorth\"--><option value=\"\" selected>Gross Annual Income</option></select><label ng-if=Profile.formData.grossAnnualIncome>Gross Annual Income</label><span ng-show=\"kycUpdateForm.grossAnnualIncome.$dirty && kycUpdateForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=kycUpdateForm.grossAnnualIncome.$error.required ng-bind=Profile.validations.GROSS_ANNUAL_INCOME></span> </span><span ng-if=\"!Profile.formData.netWorth && !Profile.formData.netWorthDate\" class=\"req text-red\">*</span> <span class=highlight></span> <span class=bar></span></div></div><div class=\"or-part col-md-1\" style=\"position: relative;top: 30px;text-align: center\">OR</div><div class=col-md-3><div class=\"input-normal icon-input mgt13\" ng-class=\"{error:kycUpdateForm.netWorth.$dirty && kycUpdateForm.netWorth.$invalid}\"><input type=number ignore-mouse-wheel name=netWorth class=pd20 ng-model=Profile.formData.netWorth ng-required=!Profile.formData.grossAnnualIncome ng-disabled=Profile.formData.grossAnnualIncome> <span ng-show=\"kycUpdateForm.netWorth.$dirty && kycUpdateForm.netWorth.$invalid\"><span class=error-input ng-show=kycUpdateForm.netWorth.$error.number>Enter a Valid net worth Amount</span> <span class=error-input ng-show=kycUpdateForm.netWorth.$error.required ng-bind=Profile.validations.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span> <i class=rupee-input-icon></i><label>Net worth (in Rs.) <span ng-if=!Profile.formData.grossAnnualIncome class=\"req text-red\">*</span></label></div></div><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:kycUpdateForm.netWorthDate.$dirty && kycUpdateForm.netWorthDate.$invalid}\"><input type=text name=netWorthDate date-calendar format=DD-MMM-YYYY viewmode=days showdefault=\"{{\'\'+!!Profile.formData.netWorthDate}}\" date-default=Profile.defaultdate maxdate=now data-min-date=Profile.minDate data-on-date-change=Profile.changeStartDate autocomplete=off ng-model=Profile.formData.netWorthDate ng-required=!Profile.formData.grossAnnualIncome ng-disabled=Profile.formData.grossAnnualIncome readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label>As on DD-MMM-YYYY <span ng-if=!Profile.formData.grossAnnualIncome class=\"req text-red\">*</span></label><span ng-show=\"kycUpdateForm.netWorthDate.$dirty && kycUpdateForm.netWorthDate.$invalid\"><span class=error-input ng-show=kycUpdateForm.netWorthDate.$error.required ng-bind=Profile.validations.NET_WORTH_DATE></span></span></div><span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span></div></div><div class=\"form-content political-exposed\"><p><strong>Politically Exposed Person (PEP) Status</strong></p><div class=radio-block><span class=radio><input type=radio id=politicalStatus1 name=politicalStatus ng-model=Profile.formData.politicalStatus ng-value=Profile.POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=politicalStatus1>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=Profile.formData.politicalStatus ng-value=Profile.POLITICAL_STATUS.RELATED> <span class=check></span></span><label for=politicalStatus2>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus3 name=politicalStatus ng-model=Profile.formData.politicalStatus ng-value=Profile.POLITICAL_STATUS.NONE> <span class=check></span></span><label for=politicalStatus3>Not Applicable</label></div></div></div><div class=tc-block><h6 ng-click=Profile.checkTnc()>Terms & Conditions</h6><div><div class=checkbox><input ng-model=Profile.isCheckedKycTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=Profile.showKycTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment.</span></div></div></div><div class=\"form-footer col-md-12\"><a href=\"\" class=\"pull-left back\" ng-click=Profile.goToBack()><i class=arrow-blue-back-icon></i>Back</a> <span class=pull-right><input ng-disabled=\"!kycUpdateForm.$valid || !Profile.isCheckedKycTandC\" type=button value=Save ng-click=Profile.saveKYCUpdate() class=\"btn btn-primary-action\"></span></div></form></div></div>");
$templateCache.put("app/investor/profile/profile.html","<section class=\"main-section clearfix investors-profile\"><div class=\"clearfix profile-header\"><div class=pull-left><p ng-bind=\"ProfileParentCtrl.nameFull |camelcase\">Sumit kumar</p></div><div class=pull-right><a href=javascript:void(0) ui-sref=main.subscriptionValuation.folio-valuation class=\"cursor-pointer subscribe-icon\"></a> <button class=\"btn btn-primary-action folio-new-btn\" ng-if=ProfileParentCtrl.folioCreationEnabled ng-click=ProfileParentCtrl.redirectToFolioCreation()>Create New Folio<!--<i class=\"arrow-white-down-icon\"></i>--></button><!--<button class=\"btn btn-primary-action folio-map-btn\" ui-sref=\"main.soleApplicant.soleApplicant\">Map Folio&lt;!&ndash;<i class=\"arrow-white-down-icon\"></i>&ndash;&gt;</button>--></div></div><ul class=\"nav nav-tabs\"><li ui-sref-active=active><a ui-sref=main.profile.basicInfo>Investor Details</a></li><li ui-sref-active=active><a ui-sref=main.profile.folioDetails>Folio Details</a></li><li ui-sref-active=active><a ui-sref=main.profile.pendingApprovals>Pending Approvals ({{ProfileParentCtrl.pendingApprovalCount||0}})</a></li><li ui-sref-active=active><a ui-sref=main.profile.declaration>15 - G/H Declaration</a></li></ul><div ui-view></div></section>");
$templateCache.put("app/investment-baskets/basket/basket.html","<div class=investment-sub-header><div class=title><label class=title-pre>Investment</label><label class=title-post>Basket</label></div></div><div class=\"basket-card-container row mb-4\"><div class=no-data-content ng-hide=\"BasketCtrl.basketList.length > 0\">No Data Found</div><div class=\"col-md-4 col-sm-6\" ng-repeat=\"basket in BasketCtrl.basketList\"><div class=basket-card><div class=basket-card-body><div class=basket-title-container><img class=basket-icon src=\"{{BasketCtrl.imageBaseUrl + (basket.basketName | formatImageUrl) + \'.png\'}}\"><div class=basket-title>{{basket.basketName}}</div></div><div class=basket-desc>{{basket.basketDescription}}</div></div><div class=basket-btn-container><button class=btn-basket-details ui-sref=main.investment.basketDetails({id:basket.basketId})>View Details</button> <button class=btn-basket-invest ng-click=BasketCtrl.investNow(basket)>Invest Now</button></div></div></div></div><div class=disclaimer-container><h3 class=disclaim-title ng-if=BasketCtrl.disclaimer>Disclaimers:</h3><div class=disclaim-desc><div ng-bind-html=BasketCtrl.disclaimer></div></div></div>");
$templateCache.put("app/investment-baskets/basket-invest-now/invest.now.html","<div class=\"investment-sub-header d-flex align-items-center justify-content-between\"><div class=title ng-if=\"InvestNowCtrl.journey === \'INVESTMENT_BASKET_JOURNEY\' \"><label class=title-post>Investment</label><label class=title-pre>Basket</label></div><div class=title ng-if=\"InvestNowCtrl.journey === \'PERSONALITY\' || InvestNowCtrl.journey === \'RISK_JOURNEY\' \"><label class=title-post>Know your</label><label class=title-pre>Investment Personality</label></div><div class=title ng-if=\"InvestNowCtrl.journey === \'GOAL_JOURNEY\' \"><label class=title-post>Goal</label><label class=title-pre>Planning</label></div><button type=button class=\"btn pull-right reset-btn\" ng-click=InvestNowCtrl.resetBasketDetails() ng-if=InvestNowCtrl.isResetVisible>Reset</button></div><transaction id=InvestNowCtrl.id from-pre-login=InvestNowCtrl.isFromPreLogin journey=InvestNowCtrl.journey retirement=InvestNowCtrl.containRetirementScheme show-reset=InvestNowCtrl.showReset(data)></transaction>");
$templateCache.put("app/investment-baskets/folio/folio.html","<div class=\"basket-folio-review investment-sub-header\"><div class=\"header-title title\" style=\"margin-bottom: 15px\"><div ng-if=\"Folio.journey ===\'GOAL_JOURNEY\'\"><label class=title-post>Goal</label><label class=title-pre>Planning</label></div><div ng-if=\"Folio.journey ===\'INVESTMENT_BASKET_JOURNEY\'\"><label class=title-post>Investment</label><label class=title-pre>Basket</label></div><div ng-if=\"Folio.journey ===\'PERSONALITY\'\"><label class=title-post>Know your</label><label class=title-pre>Investment Personality</label></div><!--    <h3 ng-if=\"Folio.journey ===\'INVESTMENT_BASKET_JOURNEY\'\"><span>Investment</span> Basket</h3>--><!--    <h3 ng-if=\"Folio.journey ===\'PERSONALITY\'\"><span>Know your</span> Investment Personality</h3>--></div><div class=basic-details><div class=view-btn><h6>Basic Details</h6><div><span class=btn-edit ng-if=\"Folio.stepper.FOLIO_CREATION_STEP.basic_details_completed && !Folio.isEditing\" ng-click=Folio.handleEditBasicDetails()>Edit</span> <span data-bs-toggle=collapse href=#basicDetails role=button aria-expanded=false aria-controls=nomineeDetails ng-if=\"Folio.showBasicDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.basic_details_completed\" ng-click=\"Folio.downIconClick(\'basicDetails\')\" class=\"glyphicon glyphicon-chevron-down\"></span> <span data-bs-toggle=collapse href=#basicDetails role=button aria-expanded=false aria-controls=nomineeDetails ng-if=\"!Folio.showBasicDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.basic_details_completed\" ng-click=\"Folio.upIconClick(\'basicDetails\')\" class=\"glyphicon glyphicon-chevron-up\"></span></div></div><div class=\"box-body collapse set-margin-top-20 set-padding-left-10\" id=basicDetails><basic-details ng-if=\" Folio.showBasic\" pan=\"Folio.journeyDetails.panNumber ? Folio.journeyDetails.panNumber  : Folio.panNumber\" first-flow=Folio.firstFlow stepper-updated-info=Folio.getStepperInfo() proceed-action=Folio.proceedToIncomeDetails() selected-folio-data=Folio.selecteFolioData journey=Folio.journey from-pre-login=Folio.fromPreLogin retirement=Folio.retirement></basic-details></div></div><div class=income-details ng-if=\"Folio.receivedData.folioForUser === \'Self\'\"><div class=view-btn><h6 class=pull-left ng-if=\"Folio.receivedData.folioForUser === \'Self\'\"><strong>Income Details</strong></h6><span class=btn-edit ng-if=\"Folio.stepper.FOLIO_CREATION_STEP.income_details_completed && Folio.receivedData.folioForUser === \'Self\' && !Folio.isEditing\" ng-click=Folio.handleEditIncomeDetails()>Edit</span> <span data-bs-toggle=collapse href=#incomeDetails role=button aria-expanded=false aria-controls=incomeDetails ng-if=\"Folio.showincomeDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.income_details_completed && Folio.receivedData.folioForUser === \'Self\'\" ng-click=\"!Folio.showIncomeGuardian || Folio.downIconClick(\'incomeDetails\')\" class=\"glyphicon glyphicon-chevron-down\"></span> <span data-bs-toggle=collapse href=#incomeDetails role=button aria-expanded=false aria-controls=incomeDetails ng-if=\"!Folio.showincomeDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.income_details_completed && Folio.receivedData.folioForUser === \'Self\'\" ng-click=\"Folio.upIconClick(\'incomeDetails\')\" class=\"glyphicon glyphicon-chevron-up\"></span></div><div class=\"box-body collapse set-margin-top-20 set-padding-left-10\" id=incomeDetails><income-details ng-if=Folio.showIncomeGuardian pan=Folio.journeyDetails.panNumber first-flow=Folio.firstFlow stepper-updated-info=Folio.getStepperInfo() proceed-action=Folio.performIncomeDetailsActions() selected-folio-data=Folio.selecteFolioData journey=Folio.journey></income-details></div></div><div class=income-details ng-if=\"Folio.receivedData.folioForUser === \'Minor\'\"><div class=view-btn><h6 class=pull-left ng-if=\"Folio.receivedData.folioForUser === \'Minor\'\"><strong>Guardian Details</strong></h6><span class=btn-edit ng-if=\"Folio.stepper.FOLIO_CREATION_STEP.guardian_details_completed && Folio.receivedData.folioForUser === \'Minor\' && !Folio.isEditing\" ng-click=Folio.handleEditGuardianIncomeDetails()>Edit</span> <span data-bs-toggle=collapse href=#incomeDetails role=button aria-expanded=false aria-controls=incomeDetails ng-if=\"Folio.showincomeDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.guardian_details_completed && Folio.receivedData.folioForUser === \'Minor\'\" ng-click=\"!Folio.showIncomeGuardian || Folio.downIconClick(\'guardianDetails\')\" class=\"glyphicon glyphicon-chevron-down\"></span> <span data-bs-toggle=collapse href=#incomeDetails role=button aria-expanded=false aria-controls=incomeDetails ng-if=\"!Folio.showincomeDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.guardian_details_completed && Folio.receivedData.folioForUser === \'Minor\'\" ng-click=\"Folio.upIconClick(\'guardianDetails\')\" class=\"glyphicon glyphicon-chevron-up\"></span></div><div class=\"box-body collapse set-margin-top-20 set-padding-left-10\" id=incomeDetails><!--      <p>income details directive here</p>--><guardian-details ng-if=Folio.showIncomeGuardian pan=Folio.journeyDetails.panNumber first-flow=Folio.firstFlow proceed-action=Folio.proceedGuardianDetailsActions() stepper-updated-info=Folio.getStepperInfo() selected-folio-data=Folio.selecteFolioData journey=Folio.journey></guardian-details></div></div><div class=holder-details ng-if=\"Folio.receivedData.folioHoldingMode === \'ANY_OR_SURVIVOR\' && Folio.receivedData.folioForUser !== \'Minor\'\"><div class=view-btn><h6 class=pull-left><strong>Holder Details</strong></h6><span class=btn-edit ng-if=\"Folio.stepper.FOLIO_CREATION_STEP.holder_details_completed && !Folio.isEditing\" ng-click=Folio.handleEditHolder()>Edit</span> <span data-bs-toggle=collapse href=#holderDetails role=button aria-expanded=false aria-controls=holderDetails ng-if=\"Folio.showholderDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.holder_details_completed\" ng-click=\"!Folio.showHolder || Folio.downIconClick(\'holderDetails\')\" class=\"glyphicon glyphicon-chevron-down\"></span> <span data-bs-toggle=collapse href=#holderDetails role=button aria-expanded=false aria-controls=holderDetails ng-if=\"!Folio.showholderDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.holder_details_completed\" ng-click=\"Folio.upIconClick(\'holderDetails\')\" class=\"glyphicon glyphicon-chevron-up\"></span></div><div class=\"box-body collapse set-margin-top-20 set-padding-left-10\" id=holderDetails><holder-directive ng-if=Folio.showHolder pan=Folio.journeyDetails.panNumber first-flow=Folio.firstFlow proceed-action=Folio.performHolderAction() stepper-updated-info=Folio.getStepperInfo() selected-folio-data=Folio.selecteFolioData journey=Folio.journey from-pre-login=Folio.fromPreLogin></holder-directive></div></div><div class=nominee-detail ng-if=\"Folio.receivedData.folioForUser !== \'Minor\'\"><div class=view-btn><h6>Nominee Details</h6><div><span class=btn-edit ng-if=\"Folio.stepper.FOLIO_CREATION_STEP.nominee_details_completed && !Folio.isEditing\" ng-click=Folio.handleEditNominee()>Edit</span> <span data-bs-toggle=collapse href=#nomineeDetails role=button aria-expanded=false aria-controls=nomineeDetails ng-if=\"Folio.shownomineeDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.nominee_details_completed\" ng-click=\"!Folio.showNominee || Folio.downIconClick(\'nomineeDetails\')\" class=\"glyphicon glyphicon-chevron-down\"></span> <span data-bs-toggle=collapse href=#nomineeDetails role=button aria-expanded=false aria-controls=nomineeDetails ng-if=\"!Folio.shownomineeDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.nominee_details_completed\" ng-click=\"Folio.upIconClick(\'nomineeDetails\')\" class=\"glyphicon glyphicon-chevron-up\"></span></div></div><div class=\"box-body collapse set-margin-top-20\" id=nomineeDetails><folio-nominee ng-if=Folio.showNominee pan=Folio.journeyDetails.panNumber first-flow=Folio.firstFlow proceed-action=Folio.performNomineeAction() stepper-updated-info=Folio.getStepperInfo() selected-folio-data=Folio.selecteFolioData journey=Folio.journey></folio-nominee></div></div><div class=bank-details><div class=view-btn><h6>Bank Details</h6><span class=btn-edit ng-if=\"Folio.stepper.FOLIO_CREATION_STEP.bank_details_completed && !Folio.isEditing\" ng-click=Folio.handleEditBank()>Edit</span> <span data-bs-toggle=collapse href=#bankDetails role=button aria-expanded=false aria-controls=bankDetails ng-if=\"Folio.showbankDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.bank_details_completed\" ng-click=\"!Folio.showBank || Folio.downIconClick(\'bankDetails\')\" class=\"glyphicon glyphicon-chevron-down\"></span> <span data-bs-toggle=collapse href=#bankDetails role=button aria-expanded=false aria-controls=bankDetails ng-if=\"!Folio.showbankDownIcon && !Folio.stepper.FOLIO_CREATION_STEP.bank_details_completed\" ng-click=\"Folio.upIconClick(\'bankDetails\')\" class=\"glyphicon glyphicon-chevron-up\"></span></div><div class=\"box-body collapse set-margin-top-20 set-padding-left-10\" id=bankDetails><bank-details-directive ng-if=Folio.showBank pan=Folio.journeyDetails.panNumber first-flow=Folio.firstFlow bank-payload=BankDetails.payload stepper-updated-info=Folio.getStepperInfo() selected-folio-data=Folio.selecteFolioData proceed-action=Folio.performBankAction() journey=Folio.journey></bank-details-directive></div></div><div class=proceed><!--    <button ng-if=\"Folio.showSaveButton\" ng-disabled=\"!Folio.enableBtn\" class=\"proceed-btn\" ng-click=\"Folio.saveData()\">--><!--      Save--><!--    </button>--> <button ng-disabled=Folio.showSaveButton class=\"proceed-btn folio-create-new\" ng-click=Folio.createNewFolio()>Proceed</button></div></div>");
$templateCache.put("app/investment-baskets/goals/goals.html","<div class=goals-container ng-if=GoalsCtrl.goalsList><div class=header-title><h3><span>Goal</span> Planning</h3></div><div class=main-div><div class=description><p>Goal-based investing is a relatively new approach to wealth management that emphasizes investing with the objective of attaining specific life goals. Goal-based investing (GBI) involves a wealth manager or investment firm’s clients measuring their progress towards specific life goals, such as saving for children’s.</p></div><div class=main-container><div class=\"container container-goal\"><div class=journey><ul class=steps><li ng-repeat=\"step in GoalsCtrl.allSteps track by $index\" class=step ng-class=\"{\'active\' : GoalsCtrl.allSteps[$index].completed, \'not-active\' : GoalsCtrl.checkDisable[$index]}\" ng-click=\"GoalsCtrl.changeStep(step.id , step.name, \'USER_ACTION\')\">{{step.name}}<span class=\"glyphicon glyphicon-chevron-right\"></span></li></ul><div class=select-goals ng-if=\"!GoalsCtrl.isShown && !GoalsCtrl.isReview\"><ul><li class=goal-name remove-space ng-repeat=\"data in GoalsCtrl.goalsList track by $index\" ng-click=GoalsCtrl.showQuestionaire(data)><p>{{data.goalCategory == \'MY_NEST\' ? \'My Home\' : data.goalName}}</p></li></ul></div></div></div><div ng-if=\"GoalsCtrl.isShown && !GoalsCtrl.isReview\" class=questionaire-content ng-class=\"{\'section-change\' : GoalsCtrl.isShown}\"><div class=questionaire-main-container><form><div class=question-listing-div><div class=goal-head-div><label ng-if=\"GoalsCtrl.formData.goalCategory !== \'CHILD_EDUCATION\' && GoalsCtrl.formData.goalCategory !== \'MY_NEST\'\">{{GoalsCtrl.formData.goalName}}</label><label ng-if=\"GoalsCtrl.formData.goalCategory === \'CHILD_EDUCATION\'\">Child Education Costs</label><label ng-if=\"GoalsCtrl.formData.goalCategory === \'MY_NEST\'\">My Future Home</label><p ng-if=GoalsCtrl.showInfoGoal>Lorem ipsum</p></div><div class=question-and-btn-wrap ng-class=\"{\'age-ques\':(step.measurement == \'YEARS\' || step.measurement == \'MONTHS\')}\" ng-repeat=\"step in GoalsCtrl.questionModelData track by $index\"><div class=label-wrapper><div><span>{{step.questionName}}</span></div><span class=input-wrapper ng-class=\"{\n                     \'not-rupee\': !GoalsCtrl.symbolCheck[$index].rupeeSymbol && !GoalsCtrl.symbolCheck[$index].percentSymbol,\n                      \'percentage\': GoalsCtrl.symbolCheck[$index].percentSymbol && !GoalsCtrl.symbolCheck[$index].rupeeSymbol}\"><span class=rupee-span ng-if=\"GoalsCtrl.questionModelData[$index].measurement === \'INR\'\"><img src=assets/images/icons/investor-basket/rupee-blue.svg> </span><span class=month-year-span ng-if=\"step.measurement == \'MONTHS\'\"><input ng-if=\"step.measurement === \'MONTHS\'\" type=text class=input-model ng-model=GoalsCtrl.questionModelData[$index].displayValue maxlength=2 ng-change=\"GoalsCtrl.changeInput(GoalsCtrl.questionModelData[$index].displayValue, step.id)\"> <span ng-if=\"GoalsCtrl.formData.goalCategory !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalCategory && step.questionType !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType && GoalsCtrl.symbolCheck[$index].yearSymbol\"><span ng-if=\"GoalsCtrl.questionModelData[$index].inputRange > 11\">year</span> <span ng-if=\"GoalsCtrl.questionModelData[$index].inputRange <= 11\">month</span> <small style=\"color: #1B4B86; margin-left: -4px\" ng-if=\"GoalsCtrl.questionModelData[$index].inputRange !== 1 && GoalsCtrl.questionModelData[$index].inputRange !== 12\">s</small> </span><span ng-if=\"GoalsCtrl.formData.goalCategory === GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalCategory && step.questionType !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType && GoalsCtrl.symbolCheck[$index].yearSymbol\"><span ng-if=\"GoalsCtrl.questionModelData[$index].inputRange > 11\">year</span> <span ng-if=\"GoalsCtrl.questionModelData[$index].inputRange <= 11\">month</span> <small style=\"color: #1B4B86; margin-left: -4px\" ng-if=\"GoalsCtrl.questionModelData[$index].inputRange !== 1 && GoalsCtrl.questionModelData[$index].inputRange !== 12\">s</small> </span><span ng-if=\"GoalsCtrl.formData.goalCategory === GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalCategory && step.questionType === GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType &&GoalsCtrl.symbolCheck[$index].yearSymbol\"><span>months</span> </span></span><!--                    <input ng-if=\"step.measurement !== \'MONTHS\' && $index == 0\" class=\"input-model\" type=\"text\" ng-model=\"GoalsCtrl.questionModelData[$index].inputRange\"--><!--                       ng-attr-maxLength=\"{{GoalsCtrl.symbolCheck[$index].rupeeSymbol == true ? \'15\' : \'\' }}\"--><!--                       ng-change=\"GoalsCtrl.changeInput(GoalsCtrl.questionModelData[$index].inputRange, step.id, GoalsCtrl.questionModelData[$index].questionType)\"--><!--                       ng-class=\"{\'incase-rupee-symbol\': step.questionType && (step.questionType !== \'TIME\' && step.questionType !== \'INFLATION\' && step.questionType !== \'WITHDRAWAL_RATE\' && step.questionType !== \'AGE\' && step.questionType !== \'LIFE_EXPECTANCY\' && step.questionType !== \'RETIREMENT_AGE\' && step.questionType !== \'EXPENSE_MONTHS\') , \'inflation\' : step.questionType === \'INFLATION\' || step.questionType === \'WITHDRAWAL_RATE\'}\" autofocus/>--> <input ng-if=\"step.measurement !== \'MONTHS\'\" class=input-model type=text ng-model=GoalsCtrl.questionModelData[$index].inputRange ng-attr-maxlength=\"{{GoalsCtrl.symbolCheck[$index].rupeeSymbol == true ? \'\' : GoalsCtrl.symbolCheck[$index].percentSymbol == true ? \'2\' : \'\'  }}\" ng-change=\"GoalsCtrl.changeInput(GoalsCtrl.questionModelData[$index].inputRange, step.id, GoalsCtrl.questionModelData[$index].questionType)\" ng-class=\"{\'incase-rupee-symbol\': step.questionType && (step.questionType !== \'TIME\' && step.questionType !== \'INFLATION\' && step.questionType !== \'WITHDRAWAL_RATE\' && step.questionType !== \'AGE\' && step.questionType !== \'LIFE_EXPECTANCY\' && step.questionType !== \'RETIREMENT_AGE\' && step.questionType !== \'EXPENSE_MONTHS\') , \'inflation\' : step.questionType === \'INFLATION\' || step.questionType === \'WITHDRAWAL_RATE\'}\"> <span ng-if=\"GoalsCtrl.symbolCheck[$index].yearSymbol && step.measurement !== \'MONTHS\'\"><span>year</span> <small style=\"color: #1B4B86; margin-left: -4px\" ng-if=\"GoalsCtrl.questionModelData[$index].inputRange !== 1 && GoalsCtrl.questionModelData[$index].inputRange !== 12\">s</small> </span><span style=\"padding-top: 2px\" class=mob-pad ng-if=GoalsCtrl.symbolCheck[$index].percentSymbol>%</span></span></div><input ng-if=\"(step.measurement == \'YEARS\' || step.measurement == \'MONTHS\') && step.questionType !== \'AGE\' && step.questionType !== \'LIFE_EXPECTANCY\' && step.questionType !== \'RETIREMENT_AGE\' \" type=range class=calculate-slider min={{step.minValue}} max={{step.maxValue}} id=range-selector data-elemid={{step.id}} ng-model=GoalsCtrl.questionModelData[$index].rangeValue> <input ng-if=\"step.measurement == \'PERCENTAGE\'\" type=range class=calculate-slider min={{step.minValue}} max={{step.maxValue}} id=range-selector data-elemid={{step.id}} ng-model=GoalsCtrl.questionModelData[$index].rangeValue><div class=values-wrapper ng-if=\"step.minValue && step.maxValue && step.measurement == \'MONTHS\'\"><span>{{step.minValue > 11 ? GoalsCtrl.Math.floor(step.minValue/12) + \' year\' : step.minValue + \' month\'}} <small style=\"margin-left: -4px; font-size: 17px; font-weight: 600; color: #505050\" ng-if=\"step.minValue !== 1 && step.minValue !== 12\">s</small> </span><span ng-if=\"GoalsCtrl.formData.goalCategory !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalCategory && step.questionType !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType\">{{step.maxValue > 11 ? GoalsCtrl.Math.floor(step.maxValue/12) + \' year\' : step.maxValue + \' month\'}} <small style=\"margin-left: -4px; font-size: 17px; font-weight: 600; color: #505050\" ng-if=\"step.maxValue !== 1 && step.maxValue!== 12\">s</small> </span><span ng-if=\"GoalsCtrl.formData.goalCategory === GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalCategory && step.questionType !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType\">{{step.maxValue > 11 ? GoalsCtrl.Math.floor(step.maxValue/12) + \' year\' : step.maxValue + \' month\'}} <small style=\"margin-left: -4px; font-size: 17px; font-weight: 600; color: #505050\" ng-if=\"step.maxValue !== 1 && step.maxValue!== 12\">s</small> </span><span ng-if=\"GoalsCtrl.formData.goalCategory === GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalCategory && step.questionType === GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType\">{{step.maxValue + \' months\'}}</span></div><div class=values-wrapper ng-if=\"step.minValue && step.maxValue && step.measurement == \'PERCENTAGE\'\"><span>{{step.minValue + \' %\'}} </span><span>{{step.maxValue + \' %\'}}</span></div><div class=\"label-wrapper error-wrapper\"><div ng-if=\"step.measurement === \'INR\' && GoalsCtrl.parseInt(GoalsCtrl.questionModelData[$index].inputRange.toString().replaceAll(\',\',\'\')) && GoalsCtrl.parseInt(GoalsCtrl.questionModelData[$index].inputRange.toString().replaceAll(\',\',\'\')) < GoalsCtrl.questionModelData[$index].minValue\" class=error-input>Minimum amount should be <span id=displayInWordsForGoalsForMinValue>{{GoalsCtrl.questionModelData[$index].minValueInWords.amountInWords}}</span></div><div ng-if=\"step.measurement === \'INR\' && GoalsCtrl.parseInt(GoalsCtrl.questionModelData[$index].inputRange.toString().replaceAll(\',\',\'\')) && GoalsCtrl.parseInt(GoalsCtrl.questionModelData[$index].inputRange.toString().replaceAll(\',\',\'\')) > GoalsCtrl.questionModelData[$index].maxValue\" class=error-input>Maximum amount should be <span id=displayInWordsForGoalsForMaxValue>{{GoalsCtrl.questionModelData[$index].maxValueInWords.amountInWords}}</span></div><div ng-if=\"GoalsCtrl.formData.goalCategory == \'MY_NEST\' && step.questionType == \'PV\' && (GoalsCtrl.parseInt(GoalsCtrl.questionModelData[0].inputRange.toString().replaceAll(\',\',\'\')) < GoalsCtrl.parseInt(GoalsCtrl.questionModelData[1].inputRange.toString().replaceAll(\',\',\'\'))) && (GoalsCtrl.parseInt(GoalsCtrl.questionModelData[$index].inputRange.toString().replaceAll(\',\',\'\')) <= GoalsCtrl.questionModelData[$index].maxValue)\" class=error-input><span>Down payment cannot be more than current cost of home</span></div></div><div class=\"label-wrapper error-wrapper\" ng-class=\"{\'age-ques-label\':(step.measurement == \'YEARS\' || step.measurement == \'MONTHS\')}\"><div><div ng-if=\"step.measurement === \'MONTHS\' &&\n                     (GoalsCtrl.questionModelData[$index].inputRange > GoalsCtrl.questionModelData[$index].maxValue)\" class=error-input ng-class=\"{\'age-slider\' :step.measurement !== \'YEARS\'}\">Value should be less than<!--<span>\n                        <span ng-if=\"GoalsCtrl.questionModelData[$index].minValue === 12\"> {{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].minValue/12)}} year</span>\n                        <span ng-if=\"GoalsCtrl.questionModelData[$index].minValue > 12\"> {{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].minValue/12)}} years</span>\n                        <span ng-if=\"GoalsCtrl.questionModelData[$index].minValue < 12\"> {{GoalsCtrl.questionModelData[$index].minValue}} months</span>\n                      </span>--><!-- - --> <span ng-if=\"GoalsCtrl.formData.goalCategory !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalCategory && step.questionType !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType\"><span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue === 12\">{{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].maxValue/12)}} year</span> <span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue > 12\">{{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].maxValue/12)}} years</span> <span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue < 12\">{{GoalsCtrl.questionModelData[$index].maxValue}} months</span> </span><span ng-if=\"GoalsCtrl.formData.goalCategory === GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalCategory && step.questionType !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType\"><span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue === 12\">{{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].maxValue/12)}} year</span> <span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue > 12\">{{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].maxValue/12)}} years</span> <span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue < 12\">{{GoalsCtrl.questionModelData[$index].maxValue}} months</span> </span><span ng-if=\"GoalsCtrl.formData.goalCategory === GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalCategory && step.questionType === GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType\"><span>{{GoalsCtrl.questionModelData[$index].maxValue}} months</span></span></div><div ng-if=\"step.measurement === \'MONTHS\' &&\n                     (GoalsCtrl.questionModelData[$index].inputRange < GoalsCtrl.questionModelData[$index].minValue)\" class=error-input ng-class=\"{\'age-slider\' :step.measurement !== \'YEARS\'}\">Value should be greater than <span><span ng-if=\"GoalsCtrl.questionModelData[$index].minValue === 12\">{{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].minValue/12)}} year</span> <span ng-if=\"GoalsCtrl.questionModelData[$index].minValue > 12\">{{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].minValue/12)}} years</span> <span ng-if=\"GoalsCtrl.questionModelData[$index].minValue < 12\">{{GoalsCtrl.questionModelData[$index].minValue}} months</span> </span><!-- -\n                      <span ng-if=\"GoalsCtrl.formData.goalName !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalName && step.questionType !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType\">\n                        <span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue === 12\"> {{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].maxValue/12)}} year</span>\n                        <span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue > 12\"> {{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].maxValue/12)}} years</span>\n                        <span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue < 12\"> {{GoalsCtrl.questionModelData[$index].maxValue}} months</span>\n                      </span>\n                      <span ng-if=\"GoalsCtrl.formData.goalName === GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalName && step.questionType !== GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType\">\n                        <span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue === 12\"> {{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].maxValue/12)}} year</span>\n                        <span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue > 12\"> {{GoalsCtrl.Math.floor(GoalsCtrl.questionModelData[$index].maxValue/12)}} years</span>\n                        <span ng-if=\"GoalsCtrl.questionModelData[$index].maxValue < 12\"> {{GoalsCtrl.questionModelData[$index].maxValue}} months</span>\n                      </span>\n                      <span ng-if=\"GoalsCtrl.formData.goalName === GoalsCtrl.GOALS_WITH_MONTH_VALUE.goalName && step.questionType === GoalsCtrl.GOALS_WITH_MONTH_VALUE.questionType\">\n                        <span> {{GoalsCtrl.questionModelData[$index].maxValue}} months</span>\n                      </span>--></div><div ng-if=\"step.measurement === \'YEARS\'\" class=\"error-input age-input\"><span ng-if=\"step.questionType === \'AGE\' && (GoalsCtrl.questionModelData[$index].inputRange && GoalsCtrl.questionModelData[$index].inputRange < GoalsCtrl.questionModelData[$index].minValue)\">Age should be greater or equal to {{GoalsCtrl.questionModelData[$index].minValue}} years.</span> <span ng-if=\"step.questionType === \'AGE\' && (GoalsCtrl.questionModelData[$index].inputRange && GoalsCtrl.questionModelData[$index].inputRange > GoalsCtrl.questionModelData[$index].maxValue)\">Age should be less or equal to {{GoalsCtrl.questionModelData[$index].maxValue}} years.</span> <span ng-if=\"step.questionType === \'RETIREMENT_AGE\' && (GoalsCtrl.questionModelData[$index].inputRange && GoalsCtrl.questionModelData[$index].inputRange < GoalsCtrl.questionModelData[$index].minValue)\" class=resp-retirement>Retirement Age should be greater or equal to {{GoalsCtrl.questionModelData[$index].minValue}} years.</span> <span ng-if=\"step.questionType === \'RETIREMENT_AGE\' && (GoalsCtrl.questionModelData[$index].inputRange && GoalsCtrl.questionModelData[$index].inputRange > GoalsCtrl.questionModelData[$index].maxValue)\" class=resp-retirement>Retirement Age should be less or equal to {{GoalsCtrl.questionModelData[$index].maxValue}} years.</span><!--<span ng-if=\"((GoalsCtrl.questionModelData[1].inputRange && GoalsCtrl.questionModelData[3].inputRange && step.questionType !== \'LIFE_EXPECTANCY\' && step.questionType !== \'RETIREMENT_AGE\')\n                                      && GoalsCtrl.questionModelData[1].inputRange >= GoalsCtrl.questionModelData[3].inputRange)\">Age\n                        should be less than retirement age.</span>--> <span ng-if=\"((GoalsCtrl.questionModelData[1].inputRange && GoalsCtrl.questionModelData[3].inputRange && step.questionType !== \'LIFE_EXPECTANCY\' && step.questionType !== \'AGE\')\n                                      && GoalsCtrl.questionModelData[3].inputRange <= GoalsCtrl.questionModelData[1].inputRange) && !(GoalsCtrl.questionModelData[$index].inputRange < GoalsCtrl.questionModelData[$index].minValue)\" class=resp-retirement>Retirement age should be greater than current age.</span> <span ng-if=\"step.questionType === \'LIFE_EXPECTANCY\' && (GoalsCtrl.questionModelData[$index].inputRange && GoalsCtrl.questionModelData[$index].inputRange > GoalsCtrl.questionModelData[$index].maxValue)\" class=resp-retirement>Life expectancy should be less or equal to {{GoalsCtrl.questionModelData[$index].maxValue}} years. </span><span ng-if=\"step.questionType === \'LIFE_EXPECTANCY\' && (GoalsCtrl.questionModelData[$index].inputRange && GoalsCtrl.questionModelData[$index].inputRange < GoalsCtrl.questionModelData[$index].minValue)\" class=resp-retirement>Life expectancy should be greater or equal to {{GoalsCtrl.questionModelData[$index].minValue}} years. </span><span ng-if=\"step.questionType === \'LIFE_EXPECTANCY\' && step.questionType !== \'RETIREMENT_AGE\'  &&\n                         (GoalsCtrl.questionModelData[4].inputRange && GoalsCtrl.questionModelData[4].inputRange < GoalsCtrl.questionModelData[3].inputRange) &&\n                        !(GoalsCtrl.questionModelData[$index].inputRange < GoalsCtrl.questionModelData[$index].minValue)\" class=resp-retirement>Life expectancy needs to be greater than planning to retire age.</span></div></div></div><div class=\"label-wrapper error-wrapper\" ng-class=\"{\'percentage-error-label\': step.measurement == \'PERCENTAGE\'}\"><div><div ng-if=\"(step.questionType === \'INFLATION\' || step.questionType === \'WITHDRAWAL_RATE\') &&\n                      GoalsCtrl.questionModelData[$index].inputRange < GoalsCtrl.questionModelData[$index].minValue\" class=error-input><span>Minimum <span ng-if=\"step.questionType === \'INFLATION\'\">inflation</span> <span ng-if=\"step.questionType === \'WITHDRAWAL_RATE\'\">withdrawal</span> rate should be {{GoalsCtrl.questionModelData[$index].minValue}}%.</span></div><div ng-if=\"(step.questionType === \'INFLATION\' || step.questionType === \'WITHDRAWAL_RATE\') &&\n                      GoalsCtrl.questionModelData[$index].inputRange > GoalsCtrl.questionModelData[$index].maxValue\" class=error-input><span>Maximum <span ng-if=\"step.questionType === \'INFLATION\'\">inflation</span> <span ng-if=\"step.questionType === \'WITHDRAWAL_RATE\'\">withdrawal</span> rate should be {{GoalsCtrl.questionModelData[$index].maxValue}}%.</span></div></div></div></div><div class=risk-content-area ng-if=GoalsCtrl.showRiskProfileSection><div class=row><div class=\"selectfield-for-risk col-sm-12 col-md-6\"><div class=risk-head-and-goalname><p>Your Investment Personality</p></div><select name=risk id=risk ng-disabled=GoalsCtrl.investorRiskProfile ng-model=GoalsCtrl.formData.riskProfiler ng-options=\"riskProfile.name as riskProfile.value for riskProfile in GoalsCtrl.riskProfileOptions\" ng-init=\"GoalsCtrl.formData.riskProfiler = GoalsCtrl.formData.riskProfiler ? GoalsCtrl.formData.riskProfiler : null\" required><!-- <option value=\"\" selected disabled>Select</option> --></select><p ng-click=GoalsCtrl.evaluatePersonality()>Take a questionnaire to find out your risk appetite.</p></div><div class=\"col-sm-12 col-md-6\"><div class=risk-image-container><img ng-src=\"{{\'assets/images/icons/riskometer/\' + GoalsCtrl.formData.riskProfiler.toLowerCase() + \'.svg\'}}\" alt=\'Personality.calculatedRiskAppetite.riskAppetite.split(\"_\").join(\" \")\'></div></div></div></div></div><div class=btn-div><button class=\"btn btn-secondary-action\" ng-click=GoalsCtrl.goToBack()>Back</button> <button ng-if=!GoalsCtrl.showRiskProfileSection class=\"btn btn-primary-action\" ng-click=GoalsCtrl.goToRecommendation() ng-disabled=GoalsCtrl.isBtnDisable>Submit</button> <button ng-if=GoalsCtrl.showRiskProfileSection class=\"btn btn-primary-action\" ng-click=GoalsCtrl.goToRecommendation() ng-disabled=\"GoalsCtrl.isBtnDisable || !GoalsCtrl.formData.riskProfiler\">Submit</button></div></form></div></div><div ng-if=GoalsCtrl.isReview class=review-main-container><div class=review-container-wrapper ng-if=GoalsCtrl.basketData><div class=review-content-area><div class=scheme-content-area><button type=button class=\"btn pull-right reset-btn\" ng-click=GoalsCtrl.resetBasketDetails() ng-if=GoalsCtrl.showReset>Reset</button><p>{{GoalsCtrl.suggestionData.transactionType === \'PURCHASE\' ? \'Lumpsum\' : GoalsCtrl.suggestionData.transactionType}} Amount: &#8377; {{GoalsCtrl.convertToLocalString(GoalsCtrl.editAllSchemeSumAmount ? GoalsCtrl.editAllSchemeSumAmount : GoalsCtrl.editAllSchemeSumAmount === 0 ? 0 : GoalsCtrl.suggestionData.amount)}}</p><p ng-if=GoalsCtrl.basketData>Basket Recommendation:</p><!-- <h1 ng-if=\"GoalsCtrl.basketData\">{{GoalsCtrl.basketData.basketName}}</h1> --></div><div class=basket-details><div class=basket-title><div class=basket-name><span ng-if=!GoalsCtrl.isEditBasketName tooltip-placement=top uib-tooltip={{GoalsCtrl.basketData.basketName}}>{{GoalsCtrl.basketData.basketName}}</span><form name=GoalsCtrl.basketForm ng-if=GoalsCtrl.isEditBasketName ng-class=\"{\'anything-disabled\' : !GoalsCtrl.isEdit}\" tooltip-placement=top uib-tooltip={{GoalsCtrl.customBasketName}}><input name=customName ng-pattern=/^[\\w\\S\\s.-]{2,50}$/ ng-model=GoalsCtrl.customBasketName ng-change=GoalsCtrl.changeBasketName(GoalsCtrl.customBasketName) required maxlength=50><div ng-show=\"GoalsCtrl.basketForm.customName.$dirty && GoalsCtrl.basketForm.customName.$error.required\" class=invalid-error-msg>Basket name is required</div><div ng-show=\"GoalsCtrl.basketForm.customName.$dirty && GoalsCtrl.basketForm.customName.$error.pattern\" class=invalid-error-msg>Invalid basket name</div></form></div><div ng-if=!GoalsCtrl.isEdit class=edit-icon-wrapper><i class=\"pull-right edit-icon\" ng-click=GoalsCtrl.editBasket(GoalsCtrl.isEdit)></i></div><div ng-if=GoalsCtrl.isEdit class=\"pull-right edit-icon-wrapper hide-on-mob\"><button type=button ng-disabled=\"GoalsCtrl.schemeAmountError || GoalsCtrl.basketForm.$invalid\" ng-click=GoalsCtrl.editBasket(GoalsCtrl.isEdit)>Save</button></div></div><div class=basket-info-container><div class=no-data-content ng-hide=\"GoalsCtrl.basketData.schemesInBasket && GoalsCtrl.basketData.schemesInBasket.length > 0\">No Data Found</div><div class=scheme-container ng-repeat=\"scheme in GoalsCtrl.basketData.schemesInBasket\"><div class=\"basket-info-row edit-scheme-wrapper\"><div class=basket-info-header><a class=fund-link href={{scheme.fundUrl}} target=_blank>{{scheme.schemeName}}</a><div ng-show=\"scheme.errorMsg && GoalsCtrl.isEdit\" class=\"invalid-error-msg hide-on-mob\">{{scheme.errorMsg}}</div></div><div class=basket-info-data ng-if=!GoalsCtrl.isEdit><span class=rupee-span>₹</span>{{GoalsCtrl.convertToLocalString(scheme.amount) || \'0\'}}</div><div ng-if=GoalsCtrl.isEdit class=basket-info-data><span class=\"rupee-scheme-span rupee-basket\"><img src=assets/images/icons/investor-basket/rupee-blue.svg> </span><input type=text class=custom-scheme-amount name=schemeAmount ignore-mouse-wheel maxlength=\"{{journey == \'GOAL_JOURNEY\' && formData.transactionType == \'SIP\' ? 14 : 20}}\" ng-maxlength=\"{{journey == \'GOAL_JOURNEY\' && formData.transactionType == \'SIP\' ? 14 : 20}}\" ng-model=scheme.customSchemeAmountDisplay ng-change=GoalsCtrl.editSchemeAmount(scheme) stopcopypaste><div ng-show=\"scheme.errorMsg && GoalsCtrl.isEdit\" class=\"invalid-error-msg d-none error-show-on-mob\">{{scheme.errorMsg}}</div></div></div><!--          <div ng-show=\"formData.amount && scheme.errorMsg\" class=\"invalid-error-msg\">{{scheme.errorMsg}}</div>--></div></div><div ng-if=GoalsCtrl.isEdit class=\"edit-icon-wrapper d-none show-on-mob\"><button type=button ng-disabled=\"GoalsCtrl.schemeAmountError || GoalsCtrl.basketForm.$invalid\" ng-click=GoalsCtrl.editBasket(GoalsCtrl.isEdit)>Save</button></div></div><div class=optional-container ng-if=\"GoalsCtrl.formData.goalCategory === \'RETIREMENT\' || GoalsCtrl.formData.goalCategory === \'TAX_PLANNING\'\"><div><p>OR</p></div><div ng-if=\"GoalsCtrl.formData.goalCategory === \'RETIREMENT\'\"><a href={{GoalsCtrl.HDFC_API.WEBSITE_LINK}}our-products/retirement-planning target=_blank>Choose from our Retirement Funds</a></div><div ng-if=\"GoalsCtrl.formData.goalCategory === \'TAX_PLANNING\'\"><a href={{GoalsCtrl.HDFC_API.WEBSITE_LINK}}our-products/tax-savings target=_blank>Choose from our Tax Saving Funds</a></div></div><div class=review-btn-container><button class=\"btn btn-primary-action\" ng-click=GoalsCtrl.startInvesting(true) ng-disabled=\"GoalsCtrl.schemeAmountError || GoalsCtrl.isEdit\">Start Investing</button></div></div></div><div ng-if=GoalsCtrl.schemesList class=schemes-main-container><div class=scheme-list-container ng-class=\"{\'scheme-center\' : GoalsCtrl.schemesList.length == 1}\"><div ng-repeat=\"schemeData in GoalsCtrl.schemesList\" class=scheme ng-style=\"{\'width\' : GoalsCtrl.schemesList.length == 1 ? \'400px\' : \'30%\'}\"><div class=scheme-wrapper><p>{{GoalsCtrl.suggestionData.transactionType === \'PURCHASE\' ? \'Lumpsum\' : GoalsCtrl.suggestionData.transactionType}} Amount: &#8377; {{GoalsCtrl.convertToLocalString(schemeData.amount)}}</p><p>Scheme Recommendation:</p><label><a class=fund-link href={{schemeData.fundUrl}} target=_blank>{{schemeData.schemeName}}</a></label><div class=optional-container ng-if=\"(GoalsCtrl.formData.goalCategory === \'RETIREMENT\' || GoalsCtrl.formData.goalCategory === \'TAX_PLANNING\') && schemeData.schemeType === \'ELSS\'\"><div><p>OR</p></div><div ng-if=\"GoalsCtrl.formData.goalCategory === \'RETIREMENT\'\"><a href={{GoalsCtrl.HDFC_API.WEBSITE_LINK}}our-products/retirement-planning target=_blank>Choose from our Retirement Funds</a></div><div ng-if=\"GoalsCtrl.formData.goalCategory === \'TAX_PLANNING\'\"><a href={{GoalsCtrl.HDFC_API.WEBSITE_LINK}}our-products/tax-savings target=_blank>Choose from our Tax Saving Funds</a></div></div><div class=btn-wrapper><button class=\"btn btn-primary-action\" ng-click=GoalsCtrl.startInvestingInScheme(schemeData)>Start Investing</button></div></div></div></div></div><div ng-if=\"!GoalsCtrl.basketData && !GoalsCtrl.schemesList\" style=\"height: 300px; display: flex; justify-content: center; align-items: center\"><h1>No Data Available</h1></div></div></div><div class=disclaimer-container ng-if=\"!GoalsCtrl.isShown || GoalsCtrl.isReview\"><h3 class=disclaim-title ng-if=GoalsCtrl.disclaimer>Disclaimers:</h3><div class=disclaim-desc><div ng-bind-html=GoalsCtrl.disclaimer></div></div></div></div></div><div ng-if=!GoalsCtrl.goalsList style=\"height: 300px; display: flex; justify-content: center; align-items: center\"><h1>No Data Available</h1></div><style>.goal-name, li:focus{\n    border: none !important;\n  }\n\n  .input-model:focus{\n    border-bottom: none !important;\n  }</style>");
$templateCache.put("app/investment-baskets/invest-now/invest-now.html","<header class=\"header affix instant-header container-fluid new-folio-creation-header\"><div class=\"left-item pull-left flex-style\"><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo></div><div class=\"pull-right right-part\"><span class=server-clock my-current-time=InvestNow.format></span><!--    <span class=\"faq cursor-pointer\" ng-if=\"!InvestNow.arnHardcodedData\">--><!--      <a href=\"javaScript:void(0)\" ui-sref=\"faq\"> FAQ</a>--><!--    </span>--><!--<span class=\"sign-out\" ng-click=\"InvestNow.logoutMe();\">\n      Logout\n    </span>--></div></header><section class=\"main-section pre-login invest-now\" ng-if=!InvestNow.isLoading><div class=modal-content id=loginLoader tabindex=-1><div class=\"modal-body main-loader\"><p class=blacktintLoad></p><div class=\"loader-box-content text-center\"><p><img src=../assets/images/logo-main.png alt=HDFC></p><p><img src=../assets/images/logo.png alt=\"Partner\'s Logo\"></p><h3 class=text-primary>Welcome {{InvestNow.investorName || \'Investor\' | camelcase}}</h3><p>Please wait while we fetch your details.</p><img src=../assets/images/loader_web.gif alt=loader class=loader-gif><br><timer interval=1000>{{minutes}}:{{seconds}}</timer></div></div></div></section><section class=\"main-section pre-login invest-now\" ng-if=InvestNow.isLoading><div><div class=content-area><div ui-view></div></div></div></section><div ng-if=!InvestNow.isLoading ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div><footer-login></footer-login>");
$templateCache.put("app/investment-baskets/investment-transaction/investmentSipPurchase.html","<div data-ng-switch=Investment.formData.investmentType><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/investment-baskets/investment-transaction/investment-purchase/investment-purchase.html\'\"></div></div><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/investment-baskets/investment-transaction/investment-sip/investment-sip.html\'\"></div></div></div>");
$templateCache.put("app/investment-baskets/personality/personality.html","<div class=personality-main-container><h3><span>Know your</span> Investment Personality</h3><div class=intro-section ng-if=Personality.isIntroShown><div class=description-section><p>Your investing personality determines the type of investor you are. The investment personality profiler calculation considers many factors, including age, financial background, conditions and your investment aspirations.</p><button class=\"btn btn-primary-action\" ng-click=Personality.evaluatePersonality()>Evaluate</button></div></div><div class=personality-section-start ng-if=!Personality.isIntroShown><div class=desc><p>Your investing personality determines the type of investor you are. The investment personality profiler calculation considers many factors, including age, financial background, conditions and your investment aspirations.</p></div><div class=\"journey personality-stepper\"><ul class=steps><li ng-repeat=\"step in Personality.allSteps track by $index\" class=step ng-class=\"{\'active\' : Personality.allSteps[$index].completed, \'not-active\' : Personality.checkDisable[$index]}\" ng-click=Personality.changeStep(step.id)>{{step.name}}<span class=\"glyphicon glyphicon-chevron-right\"></span></li></ul></div><div class=questionaire-section ng-if=\"!Personality.showScoreSection && !Personality.showRecommendScreen && !Personality.isIntroShown\"><div id=investmentPersonality><div class=question-ans-container style=\"padding: 50px 45px 40px 45px; width: 70%; margin: auto\"><div class=progress-bar-container><div class=progress-div></div><span class=progress-count>{{Personality.currentTab + 1}} of {{Personality.investmentPersonalityQuestion.questionAndAnswers.length}}</span></div><div class=tab style=\"padding: 0 15px\" ng-repeat=\"ques in Personality.investmentPersonalityQuestion.questionAndAnswers\"><div class=row><div class=col-md-12 style=\"padding: 0px !important\"><div class=question-section>{{ques.question}}</div><div class=answer-section ng-repeat=\"ansDetails in ques.riskQuestionsDTO\"><div class=radio-block><span class=radio><input type=radio name={{ansDetails.questionId}} value={{ansDetails.optionId}} ng-change=\"Personality.isValueSelected(ansDetails.questionId, ansDetails.optionId)\" ng-model=Personality.formData[ansDetails.questionId] ng-checked=\"ansDetails.optionId == Personality.formData[ansDetails.questionId]\"> <span class=check></span></span></div><span class=radio-label>{{ansDetails.answer}}</span></div></div></div></div></div><div class=btn-wrapper-container><button class=\"btn btn-secondary-action\" ng-if=\"Personality.currentTab != 0\" ng-click=Personality.nextAndPreviousAction(-1)>Previous</button> <button class=\"btn btn-primary-action\" ng-if=\"Personality.currentTab < Personality.investmentPersonalityQuestion.questionAndAnswers.length -1 \" ng-disabled=!Personality.validateObject[Personality.currentTab] ng-click=Personality.nextAndPreviousAction(1);>Next</button> <button class=\"btn btn-primary-action\" ng-disabled=!Personality.validateObject[Personality.currentTab] ng-if=\"Personality.currentTab === Personality.investmentPersonalityQuestion.questionAndAnswers.length -1 \" ng-click=Personality.submitForm();>Submit</button></div></div></div><div class=score-section-container ng-if=Personality.showScoreSection><p>score section</p><div class=score-btn-wrapper><button class=\"btn btn-secondary-action\" ng-click=Personality.goToQuestionaire()>Previous</button> <button class=\"btn btn-primary-action\" ng-click=Personality.goToRecomendation()>Submit</button></div></div><div class=recommend-section ng-if=Personality.showRecommendScreen><div class=review-content-area><div class=row><div class=\"col-xs-12 col-md-5\"><div class=risk-content-area><div class=risk-head><p>Your Investment Personality</p></div><!--<div class=\"selectfield-for-risk\">\n                {{Personality.calculatedRiskAppetite.riskAppetite.split(\"_\").join(\" \") |camelcase}}\n              </div>--><div class=risk-image-container><img ng-src={{Personality.icon}} alt=\'Personality.calculatedRiskAppetite.riskAppetite.split(\"_\").join(\" \")\'></div></div></div><div class=\"col-xs-12 col-md-7\"><div class=scheme-content-area><div class=risk-head><p>Basket Recommendation</p></div><!-- <h1>{{Personality.suggestedBasket.basketName}}</h1> --><div class=basket-details><div class=basket-title><div class=basket-name>{{Personality.suggestedBasket.basketName}}</div><!--<label class=\"link-view-details\" ng-click=\"Personality.viewDetails()\">View Details</label>--></div><div class=basket-info-container><div class=no-data-content ng-hide=\"Personality.suggestedBasket.schemesInBasket && Personality.suggestedBasket.schemesInBasket.length > 0\">No Data Found</div><div class=scheme-container ng-repeat=\"scheme in Personality.suggestedBasket.schemesInBasket\"><div class=basket-info-row><div class=basket-info-header><a class=fund-link href={{scheme.fundUrl}} target=_blank>{{scheme.schemeName}}</a></div></div></div></div></div></div></div></div><div class=review-btn-container><button class=\"btn btn-primary-action\" ng-click=Personality.startInvesting()>Start Investing</button></div></div></div></div><div class=disclaimer-container ng-if=Personality.showRecommendScreen><h3 class=disclaim-title ng-if=Personality.disclaimer>Disclaimers:</h3><div class=disclaim-desc><div ng-bind-html=Personality.disclaimer></div></div></div></div><style>li:focus{\n    border: none !important;\n  }</style>");
$templateCache.put("app/investment-baskets/pre-login/pre-login.html","<header class=\"header affix instant-header container-fluid new-folio-creation-header\"><div class=\"left-item pull-left flex-style\"><a href={{InvestNow.HDFC_API.WEBSITE_LINK}} target=_blank><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo></a></div><div class=timeLogout><span class=server-clock my-current-time=InvestNow.format></span><!--    <span class=\"faq cursor-pointer\" ng-if=\"!InvestNow.arnHardcodedData\">--><!--      <a href=\"javaScript:void(0)\" ui-sref=\"faq\"> FAQ</a>--><!--    </span>--> <span class=sign-out ng-click=InvestNow.logoutMe();>Logout</span></div></header><section class=\"main-section pre-login invest-now\"><div><div class=content-area><div ui-view></div></div></div></section><!--<div ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div>--><footer-login></footer-login>");
$templateCache.put("app/investment-baskets/review/review.controller.html","<div class=\"investment-basket-review initiate-transaction\"><form name=dateForm autocomplete=off><section ng-if=\"Review.journey === Review.constants.JOURNEY.GOAL_JOURNEY\"><div class=container><div class=\"row goal-review\"><div class=\"col-xs-12 col-md-6\"><div class=row><div class=col-xs-12><div class=title><h4>Review</h4><!-- <div class=\"sub-header\">\n                    <p>Please review your following details</p>\n                  </div> --><div class=transaction-type><p><span>Folio Number : </span>{{Review.journeyDetails.folioNumber}}</p></div><div class=transaction-type ng-if=\"Review.transactionType == \'SIP\'\"><p>Transaction Type : Systematic Investment Plan Registration</p></div><div class=transaction-type ng-if=\"Review.transactionType == \'PURCHASE\'\"><p>Transaction Type : Lumpsum</p></div></div></div></div><div class=row><div class=col-xs-12><div class=goal-details><div class=basket-title ng-if=Review.basketTitle><p>{{Review.basketTitle}}</p></div><div class=basket-title ng-if=Review.schemesDetails><p>{{Review.schemesDetails.schemeName}}</p></div><div class=goal>Goal: {{Review.goal}}</div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=col-md-12><div class=amount-review><label class=header-title ng-if=\"Review.transactionType == \'SIP\' && Review.schemesDetails\">Total Sip Amount :</label><label class=header-title ng-if=\"Review.transactionType == \'PURCHASE\' && Review.schemesDetails\">Total Amount :</label><label class=header-title ng-if=\"Review.basketSchemesDetails && Review.journeySavedDetails.basket\">Total Basket Amount :</label><div class=\"input-select input-normal input-group amount-container-review\"><div class=goal-amount-review><span class=\"rupee-span rupee-basket\">₹</span> <input ng-class=\"{\'schemeAmount\' : Review.schemesDetails}\" class=input-field ignore-mouse-wheel type=text ng-change=Review.amountChanged();Review.checkDateValidation() ng-disabled=Review.isBasketCustomized placeholder=\"Enter amount\" maxlength=20 ng-maxlength=20 ng-model=Review.formData.displayAmount required></div><span ng-if=\"Review.formData.amount && Review.disabledBtn && !Review.amountMultiples\" class=error-input>{{Review.VALIDATE_DATA.MIN_AMOUNT_BASKET}} &#8377; {{Review.minBasketAmount|unit}}</span><!--sip error messages scheme--> <span ng-if=\"Review.formData.amount && Review.isMin\" class=error-input>Minimum amount should be &#8377; {{Review.convertToLocalString(Review.validations.minAmount)|unit}}</span> <span ng-if=\"Review.formData.amount && !Review.isMax && !Review.isMin && (Review.validations.amountMultiples&&!Review.isMultiples)\" class=error-input>Please provide amount in multiples of &#8377; {{Review.validations.amountMultiples|unit}}</span><!-- purchase error message schemes--> <span ng-if=\"Review.formData.purchaseAmount && Review.isPurchaseMin\" class=\"error-input purchase-amount-error\">{{\'Minimum amount should be \'+ Review.purchaseMinAmount}}<span ng-if=\"Review.formData.purchaseAmount%1 != 0\">, </span></span><span ng-if=\"Review.formData.purchaseAmount && !Review.isPurchaseMin && (Review.purchaseValidations.purchaseMultiple && !Review.isMultiples)\" class=\"error-input purchase-amount-error\">Please provide amount in multiples of &#8377;{{Review.purchaseValidations.purchaseMultiple|unit}}<span ng-if=\"Review.formData.purchaseAmount%1 != 0\">,</span></span><div class=pd-amount-in-words><div id=divDisplayWords>{{Review.formData.amountInWord}}</div></div><!--                        <span ng-if=\"!Review.tForm.pAmount.$error.required && Review.formData.purchaseAmount%1 != 0\" class=\"error-input purchase-amount-error\" ng-class=\"{errorDown: Review.formData.purchaseAmount && Review.isPurchaseMin}\">{{\"Amount can\'t be decimal\"}}</span>--><!--                        <div class=\"scheme-option-container\">--><!--                          <button class=\"btn-scheme-option\" ng-repeat=\"amountOption in Review.amountOptions\"--><!--                                  ng-class=\"amountOption.value == Review.formData.amount ? \'active\': \'\'\"--><!--                                  ng-click=\"Review.onAmountChange(amountOption.value)\">--><!--                            <span class=\"rupee-span\">₹ </span> {{Review.convertToLocalString(amountOption.text)}}--><!--                          </button>--><!--                        </div>--></div></div></div></div><div class=row ng-if=\"Review.transactionType === \'SIP\'\"><div class=col-md-12><div class=start-date><label class=header-title>SIP Start Date :</label><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:Modal.tForm.startDate.$dirty && Modal.tForm.startDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode={{Review.viewMode}} data-date-default=Review.formData.startDate data-enabled-dates=Review.enabledStartDatesList data-min-date=Review.startMinDateBiller data-max-date=Review.startMaxDate data-on-date-change=Review.changeStartDate id=startDate-EC data-enable=true style=\"position: relative\"><input type=text name=startDate readonly required ng-model=Review.formData.startDate> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span> </span><span class=highlight></span> <span class=bar></span><!--                        <span class=\"error-input\" ng-show=\"dateForm.startDate.$error.required\"--><!--                              ng-bind=\"Review.VALIDATE_DATA.START_DATE_REQUIRED\"></span>--></div></div></div></div><!--<div class=\"row\" ng-if=\"Review.journey === \'INVESTMENT_BASKET_JOURNEY\' && Review.transactionType === \'SIP\'\">\n                  <div class=\"col-md-12\">\n                    <div class=\"start-date\">\n                      <label class=\"header-title\">SIP End Date :</label>\n                      <div class=\"input-select input-normal input-group date date-picker transaction-cal\"\n                           ng-class=\"{error:Modal.tForm.endDate.$dirty && Modal.tForm.endDate.$invalid}\"\n                           date-calendar\n                           format=\"DD-MMM-YYYY\"\n                           data-viewmode=\"{{Review.viewMode}}\"\n                           data-date-default=\"Review.formData.endDate\"\n                           data-on-date-change=\"Review.changeEndDate\"\n                           data-enabled-dates=\"Review.enabledEndDates\"\n                           data-view-date=\"Review.enabledEndDateView\"\n                           data-min-date=\"Review.enabledEndDates[0]\"\n                           data-enable=\"true\"\n                           id=\"endDate-OTM\"\n                           showdefault=\"false\">\n                        <input type=\'text\' name=\"endDate\" autocomplete=\"off\" readonly/>\n                        <span class=\"input-group-addon calender-container\">\n                          <span class=\"glyphicon-calendar-blue\"></span>\n                        </span>\n                        <span class=\"highlight\"></span>\n                        <span class=\"bar\"></span>\n                        <span class=\"error-input\" ng-show=\"dateForm.endDate.$error.required\"\n                              ng-bind=\"Review.VALIDATE_DATA.END_DATE_REQUIRED\"></span>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>--><div class=row ng-if=\"Review.transactionType === \'SIP\' && !Review.isBasketCustomized\"><div class=col-md-12><div class=end-date><label class=header-title>SIP End Date :</label><div class=end-date-input><input class=input-field date-calendar data-date-default=Review.formData.endDate data-on-date-change=Review.changeEndDate format=DD-MMM-YYYY type=text ng-model=Review.formData.endDate name=endDate ng-disabled=!Review.isBasketCustomized required> <span class=highlight></span> <span class=bar></span> <i style=\"position:absolute;left: 100%;top: 15%;margin-left: 10px\" class=\"info-icon base-tooltip\" tooltip=\"\" data-toggle=tooltip data-bs-placement=right tooltip-side=right data-bs-title={{Review.mandateInfo}}></i></div></div></div></div><div class=row ng-if=\"Review.transactionType === \'SIP\' && Review.isBasketCustomized\"><div class=col-md-12><div class=start-date style=\"padding-bottom: 10px\"><label class=header-title>SIP End Date :</label><div class=\"input-select input-normal input-group date date-picker transaction-cal\" style=position:relative ng-class=\"{error:dateForm.endDate.$dirty && dateForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode={{Review.viewMode}} data-date-default=Review.formData.endDate data-on-date-change=Review.changeEndDate data-enabled-dates=Review.enabledEndDates data-view-date=Review.enabledEndDateView data-min-date=Review.enabledEndDates[0] data-enable=true id=endDate-OTM showdefault=false><input type=text name=endDate autocomplete=off readonly ng-model=Review.formData.endDate required> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span> </span><span class=highlight></span> <span class=bar></span> <i style=\"position:absolute;left: 100%;top: 25%;margin-left: 10px\" class=\"info-icon base-tooltip\" tooltip=\"\" data-toggle=tooltip data-bs-placement=right tooltip-side=right data-bs-title={{Review.mandateInfo}}></i><!--                        <span class=\"error-input\" ng-show=\"dateForm.endDate.$error.required\"--><!--                              ng-bind=\"Review.VALIDATE_DATA.END_DATE_REQUIRED\"></span>--></div></div></div></div><div class=row ng-if=\"Review.transactionType === \'SIP\' && Review.isBasketCustomized\"><div class=col-md-12><div class=start-date><div></div><div style=\"width: 50%\" class=end-date-default><div class=\"col-md-4 default-date\" ng-class=\"{\'anything-disabled\': !Review.formData.startDate }\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=defaultDate ng-class=\"{\'anything-disabled\': !Review.formData.startDate }\" ng-model=Review.formData.isTillPerpetuity ng-change=Review.changeTillPerpetuityFlag() ng-disabled=!Review.formData.startDate> <span class=icon-checkbox></span> </span><!--                <label style=\"margin-left: 10px\" for=\"defaultDate\">Default date shall be December 2099</label>--><label style=\"margin-left: 10px; line-height: 18px\" for=defaultDate>Choose Default End Date, which is 2099</label></div></div></div></div></div></div></div><div class=row ng-if=false><div class=col-xs-12><div class=imp-info><div><img src=assets/images/info-icon-blue.png alt=info></div><div>{{Review.constants.BASKET_NOTE}}</div></div></div></div></div><div ng-class=\"{\'schemeReview\' : Review.schemesDetails}\" class=\"col-xs-12 col-md-6\"><div class=basket-details><div class=title ng-if=Review.basketName>{{Review.basketName}}</div><div class=title ng-if=Review.schemesDetails>{{Review.schemesDetails.schemeName}}</div><table><tbody ng-if=Review.basketSchemesDetails><tr ng-repeat=\"detail in Review.basketSchemesDetails\"><td><a class=fund-link href={{detail.fundUrl}} target=_blank>{{detail.schemeName}}</a><!--                    <p ng-if=\"detail.amount && detail.isMin\" class=\"error-input\">Minimum amount should be &#8377; {{detail.minAmount|unit}}</p>--><!--                    <p--><!--                      ng-if=\"detail.amount && !detail.isMax && !detail.isMin && (detail.amountMultiples && !detail.isMultiples)\"--><!--                      class=\"error-input\">Please Provide In multiples of &#8377; {{detail.amountMultiples|unit}}--><!--                    </p>--><!--                    <p ng-if=\"detail.amount && detail.isPurchaseMin\" class=\"error-input purchase-amount-error\">--><!--                      {{\'Minimum amount should be \'+ detail.purchaseMinAmount}}<span ng-if=\"detail.amount %1 != 0\">, </span>--><!--                    </p>--><!--                    <p ng-if=\"detail.amount && !detail.isPurchaseMin && (detail.purchaseMultiple && !detail.isMultiples)\" class=\"error-input purchase-amount-error\">--><!--                      Please provide amount in multiples of &#8377;{{detail.purchaseMultiple|unit}}<span ng-if=\"detail.amount %1 != 0\">, </span>--><!--                    </p>--></td><td><span class=rupee-span>₹ </span>{{Review.convertToLocalString(detail.amount)}}</td></tr><tr ng-if=Review.isBasket class=total-basket-amount><td>Total Basket Amount</td><td><span class=rupee-span>₹ </span>{{Review.formData.amount ? Review.convertToLocalString(Review.formData.amount) : 0}}</td></tr></tbody><tbody ng-if=Review.schemesDetails><tr><td><a class=fund-link href={{Review.fundUrl}} target=_blank>{{Review.schemesDetails.schemeName}}</a></td><td><span class=rupee-span>₹ </span>{{Review.formData.amount ? Review.convertToLocalString(Review.formData.amount) : 0}}</td></tr></tbody></table></div></div></div><div class=\"col-xs-12 col-md-12 trans-ackn\"><span class=icon-info-sign></span><p>Transaction acknowledgement email and SMS will be sent to the email and mobile number registered in the folio shown above.</p></div><div class=\"col-xs-12 col-md-12\"><div class=review-tnc-action><div class=checkbox><input id=isCheckedTandC ng-model=Review.isCheckedTandC type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=Review.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div><div class=action-container><!--          <button class=\"btn btn-secondary-action\" ng-click=\"Review.backToFolioCreation()\">Back</button>--> <button class=\"btn btn-primary-action\" ng-click=Review.proceedToTransact() ng-disabled=\"dateForm.$invalid || !Review.isCheckedTandC ||  (!Review.isBasket && (!Review.isMultiples || Review.isMin)) || (Review.isBasket &&  Review.disabledBtn)\">Proceed</button></div></div></div></div></section><section ng-if=\"Review.journey !== Review.constants.JOURNEY.GOAL_JOURNEY\"><div class=container><div class=\"row goal-review\"><div class=\"col-xs-12 col-md-6\"><div class=row><div class=col-xs-12><div class=title><h4>Review</h4><!-- <div class=\"sub-header\">\n                    <p>Please review your following details</p>\n                  </div> --><div class=transaction-type><p><span>Folio Number : </span>{{Review.journeyDetails.folioNumber}}</p></div><div class=transaction-type ng-if=\"Review.transactionType == \'SIP\'\"><p>Transaction Type : Systematic Investment Plan Registration</p></div><div class=transaction-type ng-if=\"Review.transactionType == \'PURCHASE\'\"><p>Transaction Type : Lumpsum</p></div></div></div></div><div class=row><div class=col-xs-12><div class=goal-details><div class=basket-title ng-if=Review.basketName><p>{{Review.basketName}}</p></div><div class=basket-title ng-if=Review.schemesDetails><p>{{Review.schemesDetails.schemeName}}</p></div></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=col-md-12><div class=\"amount-review row\"><div class=\"header-container col-md-12 col-sm-12\"><label class=header-title ng-if=Review.journeySavedDetails.basket>Total Basket Amount :</label></div><div class=\"col-md-12 col-sm-12 amount-container-review\"><div class=\"input-select input-normal\"><span class=\"rupee-span rupee-basket\">₹ </span><input class=input-field ignore-mouse-wheel type=text ng-disabled=Review.isBasketCustomized name=amount ng-change=\"Review.amountChanged(); Review.checkDateValidation()\" maxlength=20 ng-maxlength=20 placeholder=\"Enter amount\" ng-model=Review.formData.displayAmount required></div><!--sip error messages scheme--> <span ng-if=\"Review.formData.amount && Review.disabledBtn && !Review.amountMultiples\" class=error-input>{{Review.VALIDATE_DATA.MIN_AMOUNT_BASKET}} &#8377; {{Review.minBasketAmount|unit}}</span> <span ng-if=\"Review.formData.amount && Review.isMin\" class=error-input>Minimum amount should be &#8377; {{Review.convertToLocalString(Review.validations.minAmount)|unit}}</span> <span ng-if=\"Review.formData.amount && !Review.isMax && !Review.isMin && (Review.validations.amountMultiples&&!Review.isMultiples)\" class=error-input>Please provide amount in multiples of &#8377; {{Review.validations.amountMultiples|unit}}</span> <span ng-if=\"Review.formData.amount && Review.disabledBtn && !Review.minBasketAmount\" class=error-input>Please provide amount in multiples of &#8377; {{Review.amountMultiples|unit}}</span><!-- purchase error message schemes--> <span ng-if=\"Review.formData.purchaseAmount && Review.isPurchaseMin\" class=\"error-input purchase-amount-error\">{{\'Minimum amount should be \'+ Review.purchaseMinAmount}}<span ng-if=\"Review.formData.purchaseAmount%1 != 0\">, </span></span><span ng-if=\"Review.formData.purchaseAmount && !Review.isPurchaseMin && (Review.purchaseValidations.purchaseMultiple && !Review.isMultiples)\" class=\"error-input purchase-amount-error\">Please provide amount in multiples of &#8377;{{Review.purchaseValidations.purchaseMultiple|unit}}<span ng-if=\"Review.formData.purchaseAmount%1 != 0\">, </span></span><!--                        <span ng-if=\"!Review.tForm.pAmount.$error.required && Review.formData.purchaseAmount%1 != 0\" class=\"error-input purchase-amount-error\" ng-class=\"{errorDown: Review.formData.purchaseAmount && Review.isPurchaseMin}\">{{\"Amount can\'t be decimal\"}}</span>--><br><div class=amount-words><div>{{Review.formData.amountInWord}}</div></div><div class=scheme-option-container><button class=btn-scheme-option ng-repeat=\"amountOption in Review.amountOptions\" ng-style=\"{\'cursor\': Review.isBasketCustomized ? \'not-allowed\' : \'default\'}\" ng-class=\"amountOption.value == Review.formData.amount ? \'active\': \'\'\" ng-click=Review.onAmountChange(amountOption.value) ng-disabled=Review.isBasketCustomized><span class=rupee-span>₹</span> {{Review.convertToLocalString(amountOption.text)}}</button></div></div></div></div></div><div class=row ng-if=\"Review.transactionType === \'SIP\'\"><div class=col-md-12><div class=start-date><label class=header-title>SIP Start Date :</label><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:dateForm.startDate.$dirty && dateForm.startDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode={{Review.viewMode}} data-date-default=Review.formData.startDate data-enabled-dates=Review.enabledStartDatesList data-min-date=Review.startMinDateBiller data-max-date=Review.startMaxDate data-on-date-change=Review.changeStartDate id=startDate-EC data-enable=true style=\"position: relative\"><input type=text name=startDate readonly required ng-model=Review.formData.startDate> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span> </span><span class=highlight></span> <span class=bar></span><!--                        <span class=\"error-input\" ng-show=\"dateForm.startDate.$error.required\"--><!--                              ng-bind=\"Review.VALIDATE_DATA.START_DATE_REQUIRED\"></span>--></div></div></div></div><div class=row ng-if=\"Review.transactionType === \'SIP\'\"><div class=col-md-12><div class=start-date style=\"padding-bottom: 10px\"><label class=header-title>SIP End Date :</label><div class=\"input-select input-normal input-group date date-picker transaction-cal\" style=position:relative ng-class=\"{error:dateForm.endDate.$dirty && dateForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode={{Review.viewMode}} data-date-default=Review.formData.endDate data-on-date-change=Review.changeEndDate data-enabled-dates=Review.enabledEndDates data-view-date=Review.enabledEndDateView data-min-date=Review.enabledEndDates[0] data-enable=true id=endDate-OTM showdefault=false><input type=text name=endDate autocomplete=off readonly required ng-model=Review.formData.endDate> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span> </span><span class=highlight></span> <span class=bar></span> <i style=\"position:absolute;left: 100%;top: 25%;margin-left: 10px\" class=\"info-icon base-tooltip\" tooltip=\"\" data-toggle=tooltip data-bs-placement=right tooltip-side=right data-bs-title={{Review.mandateInfo}}></i><!--                        <span class=\"error-input\" ng-show=\"dateForm.endDate.$error.required\"--><!--                              ng-bind=\"Review.VALIDATE_DATA.END_DATE_REQUIRED\"></span>--></div></div></div></div><div class=row ng-if=\"Review.transactionType === \'SIP\'\"><div class=col-md-12><div class=start-date><div></div><div style=\"width: 50%\" class=end-date-default><div class=\"col-md-4 default-date\" ng-class=\"{\'anything-disabled\': !Review.formData.startDate }\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=defaultDate ng-class=\"{\'anything-disabled\': !Review.formData.startDate }\" name=checkbox ng-model=Review.formData.isTillPerpetuity ng-change=Review.changeTillPerpetuityFlag() ng-disabled=!Review.formData.startDate> <span class=icon-checkbox></span> </span><!--                <label style=\"margin-left: 10px\" for=\"defaultDate\">Default date shall be December 2099</label>--><label style=\"margin-left: 10px; line-height: 18px\" for=defaultDate>Choose Default End Date, which is 2099</label></div></div></div></div></div><!--<div class=\"row\" ng-if=\"Review.journey === \'GOAL_JOURNEY\' && Review.transactionType === \'SIP\'\">\n                  <div class=\"col-md-12\">\n                    <div class=\"end-date\">\n                      <label class=\"header-title\">SIP End Date :</label>\n                      <div class=\"end-date-input\">\n                        <input class=\"input-field\" date-calendar\n                               format=\"DD-MMM-YYYY\" type=\"text\" ng-model=\"Review.formData.endDate\" name=\"endDate\" disabled required>\n                        <span class=\"highlight\"></span>\n                        <span class=\"bar\"></span>\n                      </div>\n                    </div>\n                  </div>\n                </div>--></div></div><div class=row ng-if=false><div class=col-xs-12><div class=imp-info><div><img src=assets/images/info-icon-blue.png alt=info></div><div>{{Review.constants.BASKET_NOTE}}</div></div></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=basket-details><div class=title ng-if=Review.basketName>{{Review.basketName}}</div><div class=title ng-if=Review.schemesDetails>{{Review.schemesDetails.schemeName}}</div><table><tbody ng-if=Review.basketSchemesDetails><tr ng-repeat=\"detail in Review.basketSchemesDetails\"><td><a class=fund-link href={{detail.fundUrl}} target=_blank>{{detail.schemeName}}</a><!--                  <p ng-if=\"detail.amount && detail.isMin\" class=\"error-input\">Minimum amount should be &#8377; {{detail.minAmount|unit}}</p>--><!--                  <p--><!--                    ng-if=\"detail.amount && !detail.isMax && !detail.isMin && (detail.amountMultiples && !detail.isMultiples)\"--><!--                    class=\"error-input\">Please Provide In multiples of &#8377; {{detail.amountMultiples|unit}}--><!--                  </p>--><!--                  <p ng-if=\"detail.amount && detail.isPurchaseMin\" class=\"error-input purchase-amount-error\">--><!--                    {{\'Minimum amount should be \'+ detail.purchaseMinAmount}}<span ng-if=\"detail.amount %1 != 0\">, </span>--><!--                  </p>--><!--                  <p ng-if=\"detail.amount && !detail.isPurchaseMin && (detail.purchaseMultiple && !detail.isMultiples)\" class=\"error-input purchase-amount-error\">--><!--                    Please provide amount in multiples of &#8377;{{detail.purchaseMultiple|unit}}<span ng-if=\"detail.amount %1 != 0\">, </span>--><!--                  </p>--></td><td><span class=rupee-span>₹ </span>{{Review.convertToLocalString(detail.amount)}}</td></tr><tr class=total-basket-amount><td>Total Basket Amount</td><td><span class=rupee-span>₹</span>{{Review.formData.amount ? Review.convertToLocalString(Review.formData.amount) : 0}}</td></tr></tbody><tbody ng-if=Review.schemesDetails><tr><td>{{Review.schemesDetails.schemeName}}</td><td><span class=rupee-span>₹ </span>{{Review.convertToLocalString(Review.totalAmount)}}</td></tr></tbody></table></div></div></div><div class=\"col-xs-12 col-md-12 trans-ackn\"><span class=icon-info-sign></span><p>Transaction acknowledgement email and SMS will be sent to the email and mobile number registered in the folio shown above.</p></div><div class=\"col-xs-12 col-md-12\"><div class=review-tnc-action><div class=checkbox><input id=isCheckedTandC ng-model=Review.isCheckedTandC type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=Review.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div><div class=action-container><button ng-if=Review.showBackButton class=\"btn btn-secondary-action\" ng-click=Review.backToReview()>Back</button> <button class=\"btn btn-primary-action\" ng-click=Review.proceedToTransact() ng-disabled=\"dateForm.$invalid || !Review.isCheckedTandC ||  (!Review.isBasket && (!Review.isMultiples || Review.isMin)) || (Review.isBasket &&  Review.disabledBtn)\">Proceed</button></div></div></div></div></section><div class=disclaimer-container><h3 class=disclaim-title ng-if=Review.disclaimer>Disclaimers:</h3><div class=disclaim-desc><div ng-bind-html=Review.disclaimer></div></div></div></form></div>");
$templateCache.put("app/investment-baskets/scheme-invest/scheme-invest.html","<div class=investment-sub-header><div class=title ng-if=\"InvestNowCtrl.journey === \'INVESTMENT_BASKET_JOURNEY\' \"><label class=title-post>Investment</label><label class=title-pre>Basket</label></div><div class=title ng-if=\"InvestNowCtrl.journey === \'PERSONALITY\' \"><label class=title-post>Know your</label><label class=title-pre>Investment Personality</label></div><div class=title ng-if=\"InvestNowCtrl.journey === \'GOAL_JOURNEY\' \"><label class=title-post>Goal</label><label class=title-pre>Planning</label></div></div><transaction-scheme journey=InvestNowCtrl.journey retirement=InvestNowCtrl.containRetirementScheme></transaction-scheme>");
$templateCache.put("app/investment-baskets/suggestions/suggestion.html","<div class=\"row suggestion-container\"><div class=col-md-12><suggestions-directive></suggestions-directive></div></div>");
$templateCache.put("app/investment-baskets/transaction-failure/transaction.failure.html","<div class=investment-sub-header><div class=title><label class=title-post>Know your</label><label class=title-pre>Investment Personality</label></div></div><div class=transaction-error-container><div class=error-content><div class=items-main><img class=error-content-img src=assets/images/icons/investor-basket/failure.png><div class=error-content-desc>{{TransFailureCtrl.transType == TransFailureCtrl.TRANSACTION_TYPE.SIP ? \'SIP Registration failed\' : \'Transaction is not successful\'}}</div></div></div><div class=transaction-card-container><div class=transaction-error-title>Your transaction is rejected due to</div><div class=transaction-error-desc><span ng-if=\"TransFailureCtrl.transType ==  TransFailureCtrl.TRANSACTION_TYPE.SIP\">Your SIP Registration is rejected due to : {{TransFailureCtrl.errorMessage}} </span><span ng-if=\"TransFailureCtrl.transType ==  TransFailureCtrl.TRANSACTION_TYPE.LUMPSUM\">If your account is debited and fund are transferred, please do not transact again. </span><span ng-bind-html=TransFailureCtrl.contactMessage></span></div></div><div class=transaction-note-container ng-if=\"TransFailureCtrl.transType ==  TransFailureCtrl.TRANSACTION_TYPE.SIP\"><div class=transaction-note-title>Note</div><div class=transaction-note-desc>{{TransFailureCtrl.note}}</div></div></div><div class=proceed-btn-container><button class=proceed-btn ui-sref=createUserId.verifyAccountDetails>Proceed with Registration</button></div>");
$templateCache.put("app/investment-baskets/transaction-success/purchase.transaction.success.html","<!--<div class=\"investment-sub-header\">\n  <div class=\"title\">\n    <label class=\"title-post\">\n      Know your\n    </label>\n    <label class=\"title-pre\">Investment Personality</label>\n  </div>\n</div>--><div class=transaction-success-container><div class=success-content><div class=items-main><img class=success-content-img src=assets/images/icons/investor-basket/success.png><div class=success-content-desc>Transaction completed successfully</div></div></div><div class=transaction-success-card-container><div class=transaction-success-title>Payment summary</div><div class=\"transaction-summary-details-container row\"><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\"><div class=factor-title>Folio number</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.transData.folioNumber}}</div></div><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\"><div class=factor-title>Total amount</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.convertToLocalString(PurchaseSuccessCtrl.transData.totalAmount)}}</div></div><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\" ng-if=PurchaseSuccessCtrl.transData.tranNumber><div class=factor-title>Transaction number</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.transData.tranNumber}}</div></div><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\"><div class=factor-title>Payment method</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.transData.paymentMethod}}</div></div><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\" ng-if=PurchaseSuccessCtrl.transData.bankName><div class=factor-title>Bank name</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.transData.bankName}}</div></div><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\"><div class=factor-title>Payment date</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.transData.paymentDate}}</div></div></div></div><div class=\"transaction-success-card-container more-details\"><div class=\"transaction-summary-details-container row\"><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\"><div class=factor-title>DIRECT/ Distributor RIA</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.transData.distributorRIA}}</div></div><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\"><div class=factor-title>Amount</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.convertToLocalString(PurchaseSuccessCtrl.transData.totalAmount)}}</div></div><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\" ng-if=PurchaseSuccessCtrl.transData.subTranNumber><div class=factor-title>Sub Transaction number</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.transData.subTranNumber}}</div></div><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\"><div class=factor-title>Scheme name</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.transData.schemeName}}</div></div><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\"><div class=factor-title>CAMS Reference number</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.transData.CAMSRefNumber}}</div></div><div class=\"summary-factor-container col-12 col-sm-6 col-md-4\"><div class=factor-title>Payment date</div><div class=details-separator>:</div><div class=factor-data>{{PurchaseSuccessCtrl.transData.paymentDate}}</div></div></div></div><div class=transaction-note-container><div class=transaction-note-desc>NOTE : {{PurchaseSuccessCtrl.note}}</div></div></div><div class=proceed-btn-container ng-if=\"!PurchaseSuccessCtrl.isExistingInvestor && PurchaseSuccessCtrl.loggedIn\"><button class=proceed-btn ui-sref=createUserId.verifyAccountDetails>Proceed with Registration</button></div>");
$templateCache.put("app/investment-baskets/transaction-success/sip.transaction.success.html","<!--<div class=\"investment-sub-header\">\n  <div class=\"title\">\n    <label class=\"title-post\">\n      Know your\n    </label>\n    <label class=\"title-pre\">Investment Personality</label>\n  </div>\n</div>--><div class=transaction-success-container><div class=success-content><div class=items-main><img class=success-content-img src=assets/images/icons/investor-basket/success.png><div class=success-content-desc>Transaction completed successfully!</div></div></div><div class=\"row row-margin-s\"><!-- <div class=\"col-sm-12 col-md-4 col-pad-s\">\n        <div class=\" sip-installment-summary-container\">\n          <div class=\"summary-title\">SIP payment summary</div>\n          <div class=\"summary-details-container\">\n            <div class=\"summary-factor-container\">\n              <div class=\"factor-data\">\n                Payment mode\n              </div>\n              <div class=\"details-separator\">:</div>\n              <div class=\"factor-title\">\n                {{SipTranSuccessCtrl.transData.paymentMode}}\n              </div>\n            </div>\n            <div class=\"summary-factor-container\">\n              <div class=\"factor-data\">\n                Amount\n              </div>\n              <div class=\"details-separator\">:</div>\n              <div class=\"factor-title\">\n                <span class=\"rupee-span\">₹ </span>\n                {{SipTranSuccessCtrl.convertToLocalString(SipTranSuccessCtrl.transData.amount)}}\n              </div>\n            </div>\n            <div class=\"summary-factor-container\">\n              <div class=\"factor-data\">\n                Payment date\n              </div>\n              <div class=\"details-separator\">:</div>\n              <div class=\"factor-title\">\n                {{SipTranSuccessCtrl.transData.startDate}}\n              </div>\n            </div>\n            <div class=\"summary-factor-container\">\n              <div class=\"factor-data\">\n                Folio number\n              </div>\n              <div class=\"details-separator\">:</div>\n              <div class=\"factor-title\">\n                {{SipTranSuccessCtrl.transData.folioNumber}}\n              </div>\n            </div>\n            <div class=\"summary-factor-container\">\n              <div class=\"factor-data\">\n                Transaction number\n              </div>\n              <div class=\"details-separator\">:</div>\n              <div class=\"factor-title\">\n                {{SipTranSuccessCtrl.transData.tranNumber}}\n              </div>\n            </div>\n            <div class=\"summary-factor-container\">\n              <div class=\"factor-data\">\n                Bank name\n              </div>\n              <div class=\"details-separator\">:</div>\n              <div class=\"factor-title\">\n                {{SipTranSuccessCtrl.transData.bankName}}\n              </div>\n            </div>\n            <div class=\"summary-factor-container\">\n              <div class=\"factor-data\">\n                Transaction type\n              </div>\n              <div class=\"details-separator\">:</div>\n              <div class=\"factor-title\">\n                {{SipTranSuccessCtrl.transData.transactionType}}\n              </div>\n            </div>\n          </div>\n        </div>\n      </div> --><div class=\"col-sm-12 col-pad-s\"><div class=sip-installment-summary-container><div class=summary-header>SIP Registration summary</div><!-- <div class=\"summary-title\">Your SIP registration details</div> --><div class=\"summary-details-container row\"><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>Folio Number</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.folioNumber}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>Payment mode</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.paymentMode}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\" ng-if=SipTranSuccessCtrl.transData.IDCWOption><div class=factor-data>IDCW option</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.IDCWOption || \'-\'}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>SIP installment amount</div><div class=details-separator>:</div><div class=factor-title><span class=rupee-span>₹ </span>{{SipTranSuccessCtrl.convertToLocalString(SipTranSuccessCtrl.transData.amount)}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>SIP registration number</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.srnNo}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>SIP frequency</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.frequency}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>CAMS Reference Number</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.tranNumber}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>Bank name</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.bankName}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>No of installments</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.noOfInstallments}}</div></div><!--          <div class=\"summary-factor-container col-12 col-sm-6\">--><!--            <div class=\"factor-data\">--><!--              CAMS Reference number--><!--            </div>--><!--            <div class=\"details-separator\">:</div>--><!--            <div class=\"factor-title\">--><!--              {{SipTranSuccessCtrl.transData.CAMSRefNumber}}--><!--            </div>--><!--          </div>--><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>SIP term</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.noOfInstallments}} {{SipTranSuccessCtrl.transData.noOfInstallments > 1 ? \'Months\' : \'Month\'}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data ng-if=!SipTranSuccessCtrl.transData.basketTrue>Source scheme name</div><div class=factor-data ng-if=SipTranSuccessCtrl.transData.basketTrue>Source basket name</div><div class=details-separator>:</div><div class=\"factor-title basket-name-div\">{{SipTranSuccessCtrl.transData.schemeName}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>Transaction initiated date & time</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.transactionInitiatedDate}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\"><div class=factor-data>Investment option</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.investmentOption}}</div></div><div class=\"summary-factor-container col-12 col-sm-6\" ng-if=SipTranSuccessCtrl.transData.UMRNNo><div class=factor-data>UMRN no</div><div class=details-separator>:</div><div class=factor-title>{{SipTranSuccessCtrl.transData.UMRNNo || \'-\'}}</div></div></div></div></div></div><!--<div class=\"transaction-note-container c-mb-1\">\n    <div class=\"transaction-note-title-small\">SIP Top up details</div>\n    <div class=\"transaction-note-desc\">\n      SIP Top up frequency : Half yearly | SIP Top up amount/SIP Top up cap Month & year : SIP Top up amount/SIP Top up\n      percentage : 100\n    </div>\n  </div>--><div ng-if=!SipTranSuccessCtrl.isExistingInvestor class=\"proceed-btn-container c-mb-3\" ng-if=SipTranSuccessCtrl.loggedIn><button class=proceed-btn ui-sref=createUserId.verifyAccountDetails>Proceed with Registration</button></div><div class=transaction-note-container><!-- <div class=\"transaction-note-title\">\n      Note\n    </div> --><div class=\"transaction-note-desc red-text\">{{SipTranSuccessCtrl.note}}</div></div><div class=transaction-note-container><div class=transaction-note-title>For payment of SIP Installments, follow these steps :</div></div><div class=\"sip-installment-steps-container row row-margin-s\"><div class=\"installment-card-container col-pad-s col-12 col-sm-6 col-md-3\" ng-repeat=\"step in SipTranSuccessCtrl.installmentSteps\"><div class=installment-card-body><div class=installment-card-title>{{step.stepNo}}</div><div class=items-main><img class=success-content-img ng-src={{step.imgUrl}}></div><div class=installment-card-desc>{{step.description}}</div></div></div></div><div class=\"transaction-note-container c-mb-1\"><div class=transaction-note-title-small>Important</div><div class=transaction-note-desc><ol type=1><li ng-repeat=\"point in SipTranSuccessCtrl.importantNote\">{{point}}</li></ol></div></div></div>");
$templateCache.put("app/kyc/kyc-update/kyc-update.html","<div class=new-investors><!-- <new-investor-header ng-If=\"!cUrl && NewInvestor.showHeaderFooter\"></new-investor-header > --><div class=\"row row-no-gutters\"><!-- <div class=\"progressBar col-xs-12 col-sm-4 col-md-3 newInvestorSideBarCss\">\n      <hdfc-login-sidebar sidebar-click=\"KycUpdate.handleSideBarClick(message)\"></hdfc-login-sidebar>\n    </div> --><div class=\"col-sm-6 col-xs-12 widthContainer p-0\"><br><login-header></login-header><br><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=container-fluid><div class=\"kyc-form-container row\"><div class=\"col-xs-12 mainBox\"><div class=\"form-page-header row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><h4 class=mainStep2>Update KYC</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><p class=mainTitile style=\"font-size: 13px;padding: 15px 0 0 0\">Verify KYC Status to update or modify your KYC details.</p></div></div><div class=\"form-page-container row\"><div class=col-xs-12><form class=verification-form autocomplete=off name=signupForm ng-submit=KycUpdate.verifyDetails() novalidate><div class=row><div class=\"col-xs-12 col-md-12\"><div><p for=pan class=s-label>PAN <span class=required-field-icon>*</span></p><br><input class=c-form-control id=pan tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=KycUpdate.formData.pan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-change=KycUpdate.resetValues() ng-blur=KycUpdate.checkPanVerification() placeholder=\"e.g. ABCDE1234A\" capitalize required easyassist-key=mask-element style=\"height: 48px;border-radius: 100px;border: 1px solid gray;padding-left: 10px\"><br><span ng-show=\"signupForm.pan.$dirty && signupForm.pan.$invalid\"><span class=mod-error-msg ng-show=signupForm.pan.$error.required ng-bind=KycUpdate.validateData.PAN_REQUIRED></span> <span class=mod-error-msg ng-show=signupForm.pan.$error.maxlength ng-bind=KycUpdate.validateData.PAN_FIELD></span> <span class=mod-error-msg ng-show=signupForm.pan.$error.pattern ng-bind=KycUpdate.validateData.PAN_FIELD></span> </span><span class=mod-error-msg ng-if=KycUpdate.panMessage ng-bind=KycUpdate.panMessage></span></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><div class=dob-input-container><label for=dobId class=s-label>Date of Birth <span class=required-field-icon>*</span></label><div class=\"input-select input-normal input-group date date-picker dateInputReg resp-input tablet-input-responsive\" date-calendar data-enable=true data-viewmode={{KycUpdate.viewMode}} data-date-default=KycUpdate.formData.dob data-max-date=KycUpdate.maxDate data-on-date-change=KycUpdate.changeStartDate maxdate=now format=DD-MM-YYYY id=endDate><input class=newinvestor-dob tabindex=2 id=dobId name=dob type=text autocomplete=off onkeypress=\"return event.charCode >= 45 && event.charCode <= 57\" maxlength=10 placeholder=dd-mm-yyyy ng-keyup=KycUpdate.autoDate() required style=\"border: none;border-radius: 100px\" easyassist-key=mask-element> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png></span></div><span class=mod-error-msg ng-if=KycUpdate.dateErrorMessage ng-bind=KycUpdate.dateErrorMessage></span></div></div></div><div class=kyc-verify><button tabindex=3 type=submit class=wBtn ng-disabled=\"signupForm.pan.$invalid || !KycUpdate.formData.dob || KycUpdate.panMessage\n                        || KycUpdate.processFlag\">VERIFY</button></div></form></div></div></div></div></div></div><div class=\"new-carosal-web widthContainer p-0\"><slide-image></slide-image></div></div></div><!-- <footer-login></footer-login> --><form autocomplete=off name=ekycForm id=ekycForm method=POST enctype=multipart/form-data action={{KycUpdate.actionUrl}}><input id=url type=hidden name=url ng-value=KycUpdate.ekycRequestCO.url> <input id=sess_id type=hidden name=sess_id ng-value=KycUpdate.ekycRequestCO.sess_id> <input id=ekyctype type=hidden name=ekyctype ng-value=KycUpdate.ekycRequestCO.ekyctype> <input id=Plkyc_type type=hidden name=Plkyc_type ng-value=KycUpdate.ekycRequestCO.plkyc_type> <input id=kyc_data type=hidden name=kyc_data ng-value=KycUpdate.ekycRequestCO.kyc_data></form><style>.mainStep2{\n    padding: 10px 0px 0px 0px;\n  }\n  .mod-error-msg{\n    color: red !important;\n  }\n  .required-field-icon{\n    color: red !important;\n  }\n  .wBtn:disabled {\n    opacity: 60% !important;\n  }\n  .c-form-control {\n    width: 336px;\n    border: 1px solid rgba(111, 111, 111, 0.4) !important;\n    height: 54px;\n    color: #1B4B86;\n    &::placeholder {\n      color: gray;\n      opacity: 1;\n    }\n  }\n  .newInvestorSideBarCss{\n    padding-top: 40px;\n  }\n  .hdfc-blue-cta-small{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border-radius: 100px !important;\n  }\n  input:focus {\n    border: 1px solid #B8C6D1 !important;\n  }\n  .container-fluid{\n      background-color: white;\n  } \n  .contrastClass .mainBox { \n    background: black;\n    color: white !important;\n  }\n  /* .mainStep2 .mainTitile .s-label */\n  @media only screen and (max-width: 767px) {\n    .newInvestorSideBarCss{\n      padding-top: 0px;\n      display: none;\n    }\n    .existing-investor-carousel{\n      display: none !important;\n    }\n    .container-fluid{\n      width: 90%;\n      margin: auto;\n    }\n    .kyc-form-container{\n      padding: 0px !important;\n    }\n  }\n  @media only screen and (max-width: 425px) {\n    .resp-input{\n      width: 100% !important;\n    }\n    .new-investors .kyc-form-container .form-page-container .col-xs-12 .verification-form .dob-input-container .newinvestor-dob{\n      width: 100% !important;\n    }\n    .wBtn{\n      width: 100% !important;\n    }\n  }\n  @media only screen\n  and (min-device-width : 768px)\n  and (max-device-width : 768px) {\n    .kyc-verify{\n      width: 163px !important;\n    }\n    .hidden-xs{\n      width: 78%;\n    }\n  }\n  .tablet-input-responsive{\n    width: 336px !important;\n      height: 48px;\n      border-radius: 100px;\n      margin-bottom: 5px;\n      border: 1px solid #B8C6D1;\n      padding: 1px;\n  }\n  @media only screen and (max-width: 1024px) {\n    .mainBox{\n      margin-top: -30% !important;\n      border-radius: 16px;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n      padding: 5% 9%;\n    }\n    .tablet-input-responsive,.wBtn{\n      width: 100% !important;\n    }\n    .c-form-control {\n      width: 100% !important;\n    }\n  }</style>");
$templateCache.put("app/login/login-components/breadcrumb.html","<div class=breadcrumb-body><div class=headerPreLogin ng-if=!Header.isLoggedInStatus><div class=\"row main-head footer-wrap-main breadcrumb-row\"><div class=mobile-breadcrumb-header><div><img src=../../../assets/images/breadcrumb-mobile-open.svg class=\"header-breadcrumb header-breadcrumb-mobile\" ui-sref=login> <a href={{Login.HDFC_API.WEBSITE_LINK}} class=logo-main-web target=_blank><img src=assets/images/hdfcmf-Main.png alt=\"MF online investors\" class=\"logo-main-hdfcmf pull-left breadcrumb-hdfc-logo\"></a></div><div class=header-right-wrapper><div class=right-wrap-breadcrum><div class=\"text-size-img-container breadcrumb-text-size-container text-size-res\"><img src=assets/images/text-small.svg class=text-size-img ng-click=\"Login.changedFont(\'decrement\')\" title=\"Decrease font size\"> <img src=assets/images/text-med.svg class=text-size-img ng-click=\"Login.changedFont(\'original\')\" title=\"Reset font size\"> <img src=assets/images/text-large.svg class=text-size-img ng-click=\"Login.changedFont(\'increment\')\" title=\"Increase font-size\"></div><div class=\"toggle-theme breadcrumb-toggle-theme res-theme-toogle\"><label class=switch><input type=checkbox ng-click=Login.contrast() ng-model=Login.contrastt class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></div></div></div><div class=breadcrumb-link ng-click=Login.handleSideBarClick(Login.appConstants.INVESTOR_SELECTION.EXISTING_USER) ui-sref=login>EXISTING INVESTOR</div><div class=breadcrumb-link ng-click=Login.handleSideBarClick(Login.appConstants.INVESTOR_SELECTION.NEW_INVESTOR) ui-sref=newInvestor>NEW INVESTOR</div><div class=breadcrumb-link ng-click=Login.handleSideBarClick(Login.appConstants.INVESTOR_SELECTION.QUICK_INVEST) ui-sref=instantLogin>QUICK INVEST</div><div class=breadcrumb-link ui-sref=updateContactLogin>UPDATE CONTACT DETAILS</div><div class=breadcrumb-link ui-sref=kycUpdate>UPDATE KYC</div><div class=\"breadcrumb-link breadcrumb-link-bottom breadcrumb-faq-padding\" ui-sref=faq>FAQs</div></div><div class=\"row breadcrumb-footer breadcrumb-row breadcrumb-footer-row-position\"><div class=\"breadcrumb-footer-info-text breadcrumb-link-row\" style=\"display: block\">For more info, visit <span><a href={{Login.HDFC_API.WEBSITE_LINK}} target=_blank>hdfcfund.com</a></span></div><div class=\"footer-data-box breadcrumb-link-bottom breadcrumb-link-row breadcrumb-align-call\"><img src=assets/images/toll.svg width=14px class=\"toll-icon icon-align-footer body-img-color breadcrumb-footer-phone-icon\"> <img src=assets/images/phoneBW.svg width=14px style=\"display: none\" class=\"toll-icon icon-align-footer body-img-bw\"> <span class=\"footer-text-common footer-breadcrumb-text\">1800 3010 6767 / 1800 419 7676 (Toll - Free)</span> <img src=assets/images/mail.svg width=15px class=\"mail-icon-new icon-align-footer body-img-color\"> <img src=assets/images/mailBW.svg width=15px style=\"display: none\" class=\"mail-icon-new icon-align-footer body-img-bw\"> <span class=\"footer-text-common footer-breadcrumb-text\"><a href=mailto:Hello@hdfcfund.com class=text-blue>Hello@hdfcfund.com</a></span></div><div class=\"breadcrumb-link-bottom breadcrumb-footer-social\"><div class=\"footer-text-common social-text-index breadcrumb-footer-info-text breadcrumb-follow-us vertical-align-text\">FOLLOW US</div><div class=\"social-container-index breadcrumb-footer-info-text\"><a href=https://www.linkedin.com/company/hdfc-mutual-fund/ target=_blank><img src=assets/images/linkedin.svg class=social-icon> </a><a href=https://twitter.com/hdfcmf target=_blank><img src=\"assets/images/Twitter Logo.svg\" class=social-icon width=26px> </a><a href=https://www.youtube.com/channel/UCiuV2NCrpHzhQogNvK1FZ_A target=_blank><img src=assets/images/youtube.svg class=social-icon></a></div></div><div class=\"breadcrumb-link-bottom breadcrumb-footer-social\"><div class=\"footer-text-common social-text-index breadcrumb-footer-info-text vertical-align-text\">DOWNLOAD THE APP</div><div class=\"social-container-index breadcrumb-footer-info-text\"><a href=\"https://play.google.com/store/apps/details?id=com.hdfcfund.investor&hl=en_IN\" target=_blank><img src=assets/images/gplay.jpg class=gp-icon> </a><a href=\"https://itunes.apple.com/us/app/mfonline-investors/id1380088205?mt=8\" target=_blank><img src=assets/images/istore.svg class=istore-icon></a></div></div><div class=\"breadcrumb-link-bottom breadcrumb-footer-social\"><div class=\"footer-copyright-text breadcrumb-footer-info-text\">Copyright © 2024. All rights reserved</div></div></div></div></div>");
$templateCache.put("app/login/login-components/existing-investor-login-new-mobile.html","<div class=\"main-login-screen row row-no-gutters\"><div class=\"widthContainer form-existing-wrap-login\"><br><login-header></login-header><div class=\"new-mobile-carousel pt-1\"><slide-image-mb></slide-image-mb></div><div class=\"main-form-view d-flex justify-content-center\"><div class=\"login-forms web-form-container\"><div class=login-header><div><h4 class=\"new-login-title p-0 lineHeight35\">Get Started With Your</h4><h4 class=new-login-title><span style=color:#347ABC>Investment </span><span style=color:#EB1C24>Journey</span></h4><div><p class=mobtxtDesc style=\"font-size:14px;line-height: 16px;color: #4F4C4D;font-weight: 400\">Invest in tomorrow, start today!</p></div></div><!-- Back button from OTP Page --><!-- <div ng-if=\"Login.showSecStep\" class=\"header-action\">\n            <a href=\"javascript:void(0)\" ng-click=\"Login.showPreviousStep();\">\n              <img src=\"assets/images/back-button.svg\">\n              Back to Login\n            </a>\n          </div> --></div><div class=\"d-tablet-flex justify-content-table mb-2\"><div class=box><label class=subBox ng-click=\"Login.chooseLogin(\'MOBILE_NUMBER\')\" ng-attr-class=\"{{Login.loginWith == \'MOBILE_NUMBER\' ? \'subBox activeBtn\' : \'subBox\' }}\">Mobile No.</label><label class=subBox ng-click=\"Login.chooseLogin(\'USER_ID\')\" ng-attr-class=\"{{Login.loginWith == \'USER_ID\' ? \'subBox activeBtn\' : \'subBox\' }}\">User ID</label></div></div><!-- Mobile Number --><div ng-if=\"Login.loginWith == \'MOBILE_NUMBER\' && !Login.showOtpField\"><br><form autocomplete=off name=mobileLoginForm><p style=\"color: black\">Mobile Number</p><br><div class=mobileInputGroup ng-class=\"{\'error-border\':mobileLoginForm.mobileNumber.$dirty && mobileLoginForm.mobileNumber.$invalid}\"><label style=\"padding: 0px 10px 0px 10px;color: black\">+91</label><div class=verticalLine></div><input type=text autocomplete=off class=mobileInput name=mobileNumber id=mobile_number ng-model=Login.loginPayload.mobileNumber pattern=[6789][0-9]{9} onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" placeholder=\"10-digit mobile number\" maxlength=10 minlength=10 required></div><div><p class=mod-error-msg ng-show=\"mobileLoginForm.mobileNumber.$dirty && mobileLoginForm.mobileNumber.$invalid && !mobileLoginForm.mobileNumber.$error.required\">{{Login.validateData.MOBILE_FIELD}}</p><p class=mod-error-msg ng-show=\"mobileLoginForm.mobileNumber.$dirty && mobileLoginForm.mobileNumber.$error.required\">{{Login.validateData.MOBILE_REQUIRED}}</p></div><br><!-- tmc --><div class=\"checkbox form-check\" style=\"display: flex !important;justify-content: start;padding: 0px\"><input type=checkbox style=\"width: 33%\" name=hdfcTnc1 id=hdfcTnc2 style=\"top: 0\" ng-model=Login.tnc required class=\"ng-dirty ng-valid-parse ng-touched ng-not-empty ng-valid ng-valid-required\" aria-invalid=false data-gtm-form-interact-field-id=0> <i class=icon-checkbox style=margin-right:10px></i> <span class=checkbox-text style=\"bottom: 0\">I accept the <a class=tnc-res ng-click=Login.getTnc() href=javascript:void(0) style=\"color: #032AF9 !important\">Terms &amp; Conditions</a></span></div><br><button class=wBtn ng-disabled=\"!Login.loginPayload.mobileNumber || !Login.tnc\" ng-click=Login.generateOtp()>Proceed &nbsp;</button></form></div><!-- old User id password --><div ng-if=\"Login.loginWith == \'USER_ID\' && !Login.showOtpField\"><div ng-class=\"{\'form-placing\': Login.showSecStep}\"><form class=login-form name=loginFormPassword ng-if=Login.isResetLoginForm novalidate ng-class=\"{alignMargin:Login.showSecStep && !Login.sentOtpRespMsg}\" autocomplete=off><!-- USER ID --><div ng-hide=Login.showSecStep style=\"width: 300px\" class=sm-w-100><span class=prefilled ng-if=Login.tracked ng-bind=Login.loginPayload.username></span><br><div class=userId-container><p for=userId class=input-title-note style=\"padding: 10px 0px 10px 0px\">User ID</p><input class=\"userIDControl form-control sm-w-100\" ng-keyup=Login.checkText() ng-class=\"{\'error-border\' : (loginFormPassword.userId.$dirty && loginFormPassword.userId.$invalid) ||Login.showUnlockID }\" autofocus tabindex=12 name=userId ng-model=Login.loginPayload.username type=text id=userId placeholder=\"Enter User ID\" ng-trim=false ng-pattern=Login.appConstants.userId_regex required stopcopypaste ng-if=!Login.tracked style=\"height: 48px;width: 300px;border-radius: 100px\"></div><p class=mod-error-msg ng-if=Login.invalidUserId>{{Login.validateData.INVALID_USER_ID_ERROR}}</p><div><div ng-show=\"loginFormPassword.userId.$dirty && loginFormPassword.userId.$invalid\" style=\"float: left\"><p class=mod-error-msg ng-show=\"loginFormPassword.userId.$dirty && loginFormPassword.userId.$error.required\">{{Login.validateData.USER_ID_REQUIRED}}</p><p class=mod-error-msg ng-show=\"loginFormPassword.userId.$dirty && loginFormPassword.userId.$error.pattern\">{{Login.appConstants.USERNAME_PATTERN}}</p></div><div style=\"float: left;margin-top: 5px\"><p class=mod-error-msg ng-show=Login.showUnlockID>User ID has been locked.</p></div><div class=\"input-controls input-controls-logint sm-padding\" style=\"float: right;margin-top: 5px\"><span class=\"inputTxt inputTxtLogin\" ng-if=!Login.showUnlockID><a ui-sref=createUserId.verifyAccountDetails class=createId style=\"color: #032AF9;font-weight: 500\">Create ID</a> <span class=seperator-id>|</span> </span><span class=\"inputTxt inputTxtLogin\"><a ui-sref=forgotUserId class=forgtId tabindex=16 style=\"color: #032AF9;font-weight: 500\">Forgot ID</a> <span class=seperator-id ng-if=Login.showUnlockID>|</span> </span><span class=\"inputTxt inputTxtLogin\" ng-if=Login.showUnlockID><a ui-sref=\"unlockfolioid({type:\'userid\',from:\'login\'})\" class=unlckId style=\"color: #032AF9;font-weight: 500\">Unlock ID</a><!-- <span class=\"seperator-id\">|</span> --></span></div></div></div><br><br><!-- PASSWORD --><div ng-if=!Login.loginUsingOtpFlag style=\"width: 300px\" class=sm-w-100><div class=\"password-container sm-padding\"><p for=password class=input-title-note><span ng-class=\"{\'activeTab\' : !Login.loginUsingOtpFlag}\" ng-click=\"Login.loginViaUpdate(\'Password\')\">Password</span> | <span ng-class=\"{\'activeTab\':Login.loginUsingOtpFlag}\" ng-click=\"Login.loginViaUpdate(\'PAN\')\">PAN</span></p><br><input class=\"passworsControl form-control sm-w-100\" no-focus tabindex=13 id=password name=password ng-class=\"{\'error-border\' : loginFormPassword.password.$dirty && loginFormPassword.password.$invalid}\" placeholder=\"Enter Password\" type={{Login.passwordType}} ng-model=Login.loginPayload.password required stopcopypaste autocomplete=one-time-code style=\"height: 48px;width: 300px;border-radius: 100px\"><div class=\"input-controls eye-sm\" style=\"position: absolute;top: 54px;right: 17px\"><span class=inputTxt><span class=password-toggle><img src=../../../assets/images/showpassword.svg ng-if=\"Login.passwordType === \'password\'\" ng-click=Login.showPassword()> <img src=../../../assets/images/blind-1.svg ng-if=\"Login.passwordType !== \'password\'\" ng-click=Login.showPassword()></span></span></div></div><div><div ng-show=\"loginFormPassword.password.$dirty && loginFormPassword.password.$invalid\" style=\"float: left\"><p class=mod-error-msg ng-show=loginFormPassword.password.$error.required>{{Login.validateData.PASSWORD_REQUIRED}}</p></div><div style=\"float: right;margin-top: 5px\"><span class=\"inputTxt inputTxtLogin\"><a href=javascript:void(0) ui-sref=forgotPassword tabindex=16 style=\"color: blue;font-size: 11px !important;font-weight: 500\">Forgot Password?</a></span></div></div></div><!-- PAN --><div ng-if=Login.loginUsingOtpFlag><div style=\"margin-top: 0px;padding-top: 0px\"><p for=password class=input-title-note><span ng-class=\"{\'activeTab\' : !Login.loginUsingOtpFlag}\" ng-click=\"Login.loginViaUpdate(\'Password\')\">Password</span> | <span ng-class=\"{\'activeTab\':Login.loginUsingOtpFlag}\" ng-click=\"Login.loginViaUpdate(\'PAN\')\">PAN</span></p><br><input class=\"panNumberControl form-control sm-w-100\" type=text name=panNumber maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=Login.loginPayload.panNumber ng-class=\"{\'error-border\' : loginFormPassword.panNumber.$dirty && loginFormPassword.panNumber.$invalid}\" capitalize placeholder=\"e.g. ABCDE1234A\" required autocomplete=off style=\"height: 48px;width: 300px;border-radius: 100px\"><div ng-show=\"loginFormPassword.panNumber.$dirty && loginFormPassword.panNumber.$invalid\"><p class=mod-error-msg ng-show=loginFormPassword.panNumber.$error.required>{{Login.validateData.PAN_REQUIRED}}</p><p class=mod-error-msg ng-show=loginFormPassword.panNumber.$error.pattern>{{Login.validateData.PAN_FIELD}}</p></div></div></div><!-- buttons --><div class=\"btnContainer loginpwdBtn btn-proced\"><button type=submit class=wBtn ng-if=!Login.loginUsingOtpFlag ng-disabled=\"loginFormPassword.$invalid || Login.loginProcessFlag || Login.invalidUserId\" ng-hide=Login.showOtpField ng-click=Login.firstStepLogin()>Proceed</button> <button type=submit class=wBtn ng-if=Login.loginUsingOtpFlag ng-disabled=\"loginFormPassword.$invalid || Login.loginProcessFlag || Login.invalidUserId\" ng-click=Login.generateOtp()>Proceed</button></div></form></div></div><!-- OTP Verify --><div ng-if=Login.showOtpField class=\"d-tablet-flex justify-content-table\"><div><div ng-if=\"Login.loginWith == \'MOBILE_NUMBER\'\"><br><p class=\"otp-txt pt-1\">Please enter OTP sent to your mobile number <span style=\"font-weight: bold\">({{Login.maskedMobileNo}}).<span style=\"color: #032AF9;font-weight: 600\" ng-click=Login.changeMobileNo()>Change Mobile Number</span></span></p></div><div ng-if=\"Login.loginWith == \'USER_ID\'\"><p ng-if=Login.sentOtpRespMsg ng-bind-html=Login.sentOtpRespMsg class=\"otp-txt pt-2\"></p></div><div class=\"d-tablet-flex justify-content-table\"><div class=otp-input-container><!-- OTP fields --><!-- OTP code Start--><div class=input-code><div class=input-otp-box><input type=tel id=otp-number-input-1 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Login.otpValChanged(this) pattern=[0-9]{1} ng-model=Login.loginPayload.otp1 is-number autofocus easyassist-key=mask-element style=\"border: none !important;\n    border-bottom: 1px solid gray !important\"> <input type=tel id=otp-number-input-2 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Login.otpValChanged(this) pattern=[0-9]{1} ng-model=Login.loginPayload.otp2 is-number easyassist-key=mask-element style=\"border: none !important;\n    border-bottom: 1px solid gray !important\"> <input type=tel id=otp-number-input-3 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Login.otpValChanged(this) pattern=[0-9]{1} ng-model=Login.loginPayload.otp3 is-number easyassist-key=mask-element style=\"border: none !important;\n    border-bottom: 1px solid gray !important\"> <input type=tel id=otp-number-input-4 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Login.otpValChanged(this) pattern=[0-9]{1} ng-model=Login.loginPayload.otp4 is-number easyassist-key=mask-element style=\"border: none !important;\n    border-bottom: 1px solid gray !important\"> <input type=tel id=otp-number-input-5 class=otp-number-box minlength=1 tabindex=5 onpaste=handlePaste(event) maxlength=1 autocomplete=off ng-change=Login.otpValChanged(this) pattern=[0-9]{1} ng-model=Login.loginPayload.otp5 is-number easyassist-key=mask-element style=\"border: none !important;\n    border-bottom: 1px solid gray !important\"> <input type=tel id=otp-number-input-6 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Login.otpValChanged(this) pattern=[0-9]{1} ng-model=Login.loginPayload.otp6 is-number easyassist-key=mask-element style=\"border: none !important;\n    border-bottom: 1px solid gray !important\"></div></div><!-- OTP code End --><br><!-- re-send otp --><div style=\"float: right;margin-right: 8px\"><span class=forgot><timer countdown=Login.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd style=\"font-size: 11px\">Resend OTP in 00:{{countdown}}s</span><div><span class=inputTxt style=\"font-size: 11px\"><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Login.reGenerateOtp();>Resend OTP</a></span></div></timer></span></div><div><form autocomplete=off name=authform><!-- Pan Input --><div class=pan-input-container ng-if=\"Login.loginWith == \'USER_ID\' && !Login.loginUsingOtpFlag && Login.showSecStep && Login.isAdditionalFactorRequired\" ng-class=\"{error:authform.authPanNumber.$dirty && authform.authPanNumber.$invalid}\"><input class=\"panNumberControl form-control sm-w-100 authinput\" type=text name=authPanNumber maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=Login.loginPayload.authPanNumber capitalize placeholder=\"e.g. PGHJD4532M\" required autocomplete=off><label for=authPanNumber>PAN</label><div ng-show=\"authform.authPanNumber.$dirty && authform.authPanNumber.$invalid\"><p class=mod-error-msg ng-show=authform.authPanNumber.$error.required>{{Login.validateData.PAN_REQUIRED}}</p><p class=mod-error-msg ng-show=authform.authPanNumber.$error.pattern>{{Login.validateData.PAN_FIELD}}</p></div></div><!-- DOB Input --><div class=row ng-if=\"Login.loginWith == \'USER_ID\' && Login.loginUsingOtpFlag && Login.showSecStep && Login.isAdditionalFactorRequired\"><div class=\"col-xs-12 col-md-12\"><div class=dob-input-container><label for=dobId class=s-label>Date of Birth</label><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{Login.viewMode}} data-date-default=Login.loginPayload.authdob data-on-date-change=Login.checkDobDate maxdate=now format=DD-MM-YYYY id=endDate style=\"width: 100%;height: 40px;border-radius: 5px\"><input class=\"newinvestor-dob authinput\" tabindex=2 id=dobId name=dob type=text autocomplete=off placeholder=dd-mm-yyyy ng-keyup=Login.autoDate() required style=\"border: none\" easyassist-key=mask-element> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span class=mod-error-msg ng-if=Login.dateErrorMessage ng-bind=Login.dateErrorMessage></span></div></div></div></div></form></div></div></div><div ng-if=Login.showGCaptcha><div vc-recaptcha key=Login.publicKey ng-model=Login.myRecaptchaResponse></div></div><br><br><div class=\"d-tablet-flex justify-content-table\"><button class=wBtnTwo ng-if=\"Login.loginWith == \'USER_ID\' && Login.showOtpField\" ng-disabled=\"!Login.loginPayload.otp1 || !Login.loginPayload.otp2 || !Login.loginPayload.otp3 || !Login.loginPayload.otp4 || !Login.loginPayload.otp5 || !Login.loginPayload.otp6 ||(!Login.loginUsingOtpFlag  && Login.isAdditionalFactorRequired && !Login.loginPayload.authPanNumber) || (Login.loginUsingOtpFlag && Login.isAdditionalFactorRequired && !Login.loginPayload.authdob)\" ng-click=Login.login()>Verify OTP &nbsp;</button> <button class=wBtnTwo ng-if=\"Login.loginWith == \'MOBILE_NUMBER\' && Login.showOtpField\" ng-disabled=\"(Login.otpWrongAttempts>=3 && !Login.myRecaptchaResponse) || !Login.loginPayload.otp1 || !Login.loginPayload.otp2 || !Login.loginPayload.otp3 || !Login.loginPayload.otp4 || !Login.loginPayload.otp5 || !Login.loginPayload.otp6\" ng-click=Login.login()>Verify OTP&nbsp;</button></div></div></div></div></div></div><div class=\"widthContainer investor-carousel-new\"><slide-image></slide-image></div></div><style>.wBtn:disabled {\n    opacity: 60% !important;\n    cursor: not-allowed;\n  }\n    input::-ms-reveal,\n      input::-ms-clear {\n        display: none;\n      }\n  .password-container {\n    position: relative;\n  }\n  .error-border{\n    border: 1px solid #EB1C24 !important;\n  }\n.otp-input-container{\n width: 300px;\n}\n.otp-txt{\n  font-size: 13px;\nline-height: 28px;\n}\n  .box {\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-evenly;\n    width: 300px;\n    height: 40px;\n    background: rgba(242, 243, 251, 0.99);\n    border: 1px solid #E0E1EB;\n    border-radius: 100px;\n  }\n\n  .subBox {\n    margin: auto;\n    font-size: 11px;\n    color: #1D1A1B;\n    text-align: center;\n    width: 137px;\n    height: 28px;\n    padding: 6px;\n    cursor: pointer;\n  }\n\n  .activeBtn {\n    background: #FFFFFF;\n    box-shadow: 3px 4px 11px rgba(0, 0, 0, 0.08);\n    border-radius: 100px;\n  }\n\n  .mobileInputGroup {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    box-sizing: border-box;\n    background: white;\n    width: 300px;\n    height: 48px;\n    border: 1px solid #BDBCBD;\n    border-radius: 100px;\n  }\n\n  .mobileInput {\n    padding: 0px 0px 0px 10px;\n    height: 45px;\n    width: 84%;\n    border: none;\n    border-radius: 30px;\n  }\n  .mobileInput:focus{\n    border: none !important;\n  }\n\n  .verticalLine {\n    border-right: 1px solid gray;\n    height: 34px;\n  }\n\n  .cta {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    width: 300px;\n    height: 48px;\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%);\n    border: none;\n    border-radius: 100px;\n    color: white;\n  }\n\n  .wBtn:after{\n    content: url(\'../../../assets/images/arrow-white-small.svg\');\n  }\n  .wBtn:disabled {\n    opacity: 60% !important;\n    background: linear-gradient(94deg, #cdd7e3 -21.18%, #c3cfde 95.94%);\n  }\n  .wBtnTwo {\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border: none;\n    color: white;\n    width: 300px;\n    height: 48px;\n    text-align: center;\n    text-transform: none !important;\n    padding: 0px !important;\n    align-items: center;\n    font-size: 16px !important;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 100px;\n    transition: background-color 0.3s;\n  }\n  .wBtnTwo:disabled {\n    cursor: not-allowed;\n    opacity: 60%;\n  }\n  .existing-investor-background {\n    background-image: url(\"../../../assets/images/new-bg.svg\") !important;\n    background-size: cover;\n  }\n\n  .form-control {\n    height: 48px;\n    border-radius: 100px;\n  }\n\n  .otp-number-box {\n    width: 15.1%;\n    border: none !important;\n    border-bottom: 1px solid gray !important;\n    border-radius: 0px !important; \n  } \n  .login-forms {\n    margin: auto;\n  }\n  .activeTab {\n    color: #032AF9;\n    font-weight: 500;\n  }\n  .new-login-title {\n    font-size: 1.75rem !important;\n    line-height: 42px;\n    font-weight: 700 !important;\n    color: black;\n  }\n  .lineHeight35{\n    line-height: 35px !important;\n  }\n  .otp-number-input-data{\n    width: 45px;\n  }\n  input:focus{\n    border: 1px solid gray;\n  }\n  .btn-proced{\n    min-height: 50px;\n     width: 300px;\n  }\n  @media only screen and (max-width: 450px) {\n    .otp-number-box{\n      padding: 8px 10px !important;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    .main-login-screen {\n      /* margin-top: 5% !important; */\n    }\n    .login-forms {\n      border-radius: 16px;\n    }\n    .sm-input-width{\n      width: 95% !important;\n    }\n    .otp-input-container{\n      width: 100%;\n    }\n  }\n\n  @media screen and (max-width: 575px) {\n    .login-forms {\n      border-radius: 16px;\n      width: 328px !important;\n    }\n    /* .main-form-view{ \n      top: 62% !important;\n      position: absolute;\n      width: 90%;\n      top: 58% !important;\n      left: 50%;\n      padding: 20px;\n      transform: translate(-50%);\n      border-radius: 16px;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    } */\n  }\n  .userIDControl:focus {\n    border: 1px solid gray !important;\n  }\n  .panNumberControl:focus {\n    border: 1px solid gray !important;\n  }\n  .passworsControl:focus {\n    border: 1px solid gray !important;\n  }\n  .re_cap{\n    margin: 0px;\n    display: block;\n    min-height: 100px;\n  }\n  .input-title-note{\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    color: #000000;\n  }\n  .widthContainer{\n    width: 50%;\n  } \n  @media screen and (min-width: 376px) and (max-width: 574px) {\n    /* .main-form-view{ \n      top: 60% !important;\n    } */\n  }\n  @media screen and (min-width: 576px) and (max-width: 864px ) {\n    /* .main-form-view{ \n      top: 45% !important;\n    } */\n  }\n  @media screen and (max-width: 1024px) {\n    .investor-carousel-new{\n      display: none !important;\n    }\n    .widthContainer{\n      width: 100% !important;\n    }\n    .main-form-view{\n      position: absolute;\n      width: 90%;\n      top: 25%;\n      left: 50%;\n      padding: 20px;\n      transform: translate(-50%);\n      border-radius: 16px;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    } \n    .form-existing-wrap-login {\n      margin-left: 0px !important;\n      position: relative;\n    }\n    .login-forms{\n      padding: 1% !important;\n    }\n    .d-tablet-flex{\n      display: flex !important;\n    }\n    .justify-content-table{\n      justify-content: center !important;\n    }\n  }\n  @media screen and (max-width: 425px) {\n    .login-forms{\n      width: 255px !important;\n    }\n    .box{\n      width: 220px;\n    }\n    .subBox{\n      width: 96px;\n    }\n    .mobileInputGroup{\n      width: 220px;\n    }\n    .mobileInputGroup {\n      font-size: 12px;\n    }\n    .wBtn{\n      width: 220px !important;\n    }\n    .new-login-title{\n      font-size: 1.1rem !important;\n    }\n    .sm-w-100{\n      width: 90% !important;\n      height: 41px !important;\n    }\n    .eye-sm{\n      right: 33px !important;\n    }\n    .sm-padding{\n      padding-top: 5px;\n    }\n    .input-title-note{\n      font-size: 12px !important;\n    }\n    .forms-container .login-form:not(.userId) > div{\n      min-height: 93px;\n    }\n    .btn-proced{\n      width: 100% !important;\n    }\n  }\n  @media screen and (max-width: 375px) {\n    /* .main-form-view{\n      top: 70% !important;\n      width: 90%;\n      padding: 10px;\n    } */\n    .login-forms {\n      width: 240px !important;\n    }\n    .otp-txt{\n      font-size: 11px;\n    }\n  }\n  @media screen and (max-width: 310px) {\n    .pre-login-header .header-wrap-main .left-section .logo-main-hdfcmf{\n      margin-left: 0px;\n    }\n    .login-forms{\n      width: 210px !important;\n    }\n    .box, .mobileInputGroup{\n      width: 202px;\n    }\n    .subBox{\n      width: 86px;\n    }\n    .mobileInputGroup {\n      font-size: 12px;\n    }\n    .wBtn{\n      width: 202px !important;\n      height: 43px;\n    }\n    .new-login-title{\n      font-size: 0.9rem !important;\n    }\n    .mobtxtDesc{\n      font-size: 12px !important;\n      line-height: 13px !important;\n    }\n    .main-form-view {\n      padding: 20px 11px !important;\n    }\n  }\n  .forms-container .login-forms{\n    padding-top: 3% !important;\n    padding-left: 3% !important;\n  } \n.authinput{\n  height: 48px !important;\n  width: 300px;\n  border-radius: 100px !important;\n}</style><script>// const $inp = $(\".otp-number-box\");\n$(\".otp-number-box\").on({\n    paste(ev) { // Handle Pasting \n      const clip = ev.originalEvent.clipboardData.getData(\'text\').trim();\n      // Allow numbers only\n      if (!/\\d{6}/.test(clip)) return ev.preventDefault(); // Invalid. Exit here\n      // Split string to Array or characters\n      const s = [...clip];\n      // Populate inputs. Focus last input.\n      $(\".otp-number-box\").val(i => s[i]).eq(5).focus();\n    } \n  });  \n  function handlePaste(event){ \n     const clipboardData = event.clipboardData || window.clipboardData; \n     const pastedData = clipboardData.getData(\'Text\');\n    //  only proceed if pasted data is exacly 6 digits \n    otpData = parseInt(pastedData); \n    const otpPattern = new RegExp(\"^[0-9]\");  \n    validOTP =  otpPattern.test(otpData); \n    if (!validOTP || pastedData && pastedData.length >6) return; \n    if(pastedData && pastedData.length && pastedData != \"\" ){ \n        var scope = angular.element(document.body).injector().get(\'$rootScope\');\n        scope.otpPasteInVariable(pastedData); \n        if(/^\\d{6}$/.test(pastedData)) {\n          const inputs = document.querySelectorAll(\'.input-otp-box input\');\n          inputs.forEach((input, index) => {\n             input.value = pastedData[index] || \'\';\n          });  \n          //  Focus the last input field after pasting\n          event.preventDefault(); \n        }\n    } \n  }</script>");
$templateCache.put("app/login/login-components/existing-investor-login.html","<div class=\"row row-no-gutters\"><div class=existing-investor-background-mobile><img src=../../../assets/images/icons/existing-investor-mobile.svg><div class=existing-investor-mobile><!--<h4>Hey! Pro Investor</h4>\n      <h3>#KyaPlanHai</h3>--></div></div><!--  rendering static images--><div class=\"col-sm-12 col-md-6 existing-investor-background\" ng-if=\"Login.imageUrls.length <= 1 \" style=display:block><div class=existing-investor-content><!--<h4>Hey! Pro Investor</h4>\n      <h3>#KyaPlanHai</h3>--></div><!--rendered if we have redirect url--><div style=\"background:url(\'{{Login.imageUrls[0]}}\')\" ng-if=\"Login.redirectUrl && Login.imageUrls.length == 1\" ng-click=Login.redirectTo(Login.redirectUrl) class=dynamicContentStatic></div><!--rendered if we dont have redirect url--><div style=\"background:url(\'{{Login.imageUrls[0]}}\')\" ng-if=!Login.redirectUrl class=dynamicContentStatic></div></div><!--rendering carousel--><div class=\"col-md-6 existing-investor-carousel\" ng-if=\"Login.imageUrls.length > 1\"><div id=bannerCarousel class=\"carousel slide height100\" data-bs-ride=carousel><!--<ol class=\"carousel-indicators\">\n        <li data-target=\"#bannerCarousel\" data-bs-target=\"#bannerCarousel\" ng-repeat=\"image in Login.imageUrls\" data-bs-slide-to=\"{{$index}}\"\n            ng-class=\"{\'active\': $index === 0}\"></li>\n      </ol>--><!-- Wrapper for slides --><div class=\"carousel-inner height100\"><div class=\"carousel-item height100\" ng-repeat=\"image in Login.imageUrls track by $index\" ng-class=\"{\'active\': $index === 0}\"><a href={{Login.redirectUrl}} ng-if=Login.redirectUrl><img src={{image}} alt=banner-image> </a><img src={{image}} ng-if=!Login.redirectUrl></div></div><!-- Left and right controls --> <a class=\"left carousel-control\" data-bs-target=#bannerCarousel data-bs-slide=prev><span class=\"glyphicon glyphicon-chevron-left\"></span> <span class=sr-only>Previous</span> </a><a class=\"right carousel-control\" data-bs-target=#bannerCarousel data-bs-slide=next><span class=\"glyphicon glyphicon-chevron-right\"></span> <span class=sr-only>Next</span></a></div></div><div class=\"col-sm-12 col-md-6 form-existing-wrap form-existing-wrap-login\"><div class=login-forms style=\"min-height: 425px\"><div class=login-header><div ng-if=!Login.showSecStep><h4 class=existing-login-title>Investor Login</h4><div class=Investor-sub-headline>Manage your portfolio, transactions and more!</div></div><div ng-if=Login.showSecStep class=header-action><a href=javascript:void(0) ng-click=Login.showPreviousStep();><img src=assets/images/back-button.svg> Back to Login</a></div></div><div class=otpNavlist ng-if=!Login.showSecStep><ul><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': !Login.isChecked}\">Login via Password</span></li><li><div class=login-form-switch><label class=switch><input type=checkbox ng-model=Login.isChecked ng-click=Login.loginViaUpdate() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': Login.isChecked}\">Login via OTP</span></li></ul></div><div ng-show=!Login.loginUsingOtpFlag ng-class=\"{\'form-placing\': Login.showSecStep}\"><form class=login-form name=loginFormPassword ng-if=Login.isResetLoginForm novalidate ng-class=\"{alignMargin:Login.showSecStep && !Login.sentOtpRespMsg}\" autocomplete=off><div ng-hide=Login.showSecStep ng-class=\"{error:loginFormPassword.userId.$dirty && loginFormPassword.userId.$invalid}\"><span class=prefilled ng-if=Login.tracked ng-bind=Login.loginPayload.username></span><div class=userID-input-container><input class=form-control autofocus tabindex=12 name=userId ng-model=Login.loginPayload.username type=text id=userId placeholder=\"Enter User ID\" ng-trim=false ng-pattern=Login.appConstants.userId_regex required stopcopypaste ng-if=!Login.tracked><label for=userId>User ID</label></div><div class=\"input-controls input-controls-login input-option-float\"><span class=\"inputTxt inputTxtLogin\"><a href=javascript:void(0) ui-sref=\"unlockfolioid({type:\'userid\',from:\'login\'})\" class=unlckId tabindex=15>Unlock ID &nbsp;</a><span class=seperator-id>|</span> <span class=border-right></span> </span><span class=\"inputTxt inputTxtLogin\"><a href=javascript:void(0) ui-sref=forgotUserId class=forgtId tabindex=16>Forgot ID</a></span></div><span ng-show=\"loginFormPassword.userId.$dirty && loginFormPassword.userId.$invalid\"><span class=\"error-input mobile-error\" ng-show=loginFormPassword.userId.$error.required ng-bind=Login.validateData.USER_ID_REQUIRED></span> <span class=\"error-input mobile-error\" ng-show=loginFormPassword.userId.$error.pattern class=help-block>{{ Login.appConstants.USERNAME_PATTERN }}</span></span></div><div ng-hide=Login.showSecStep ng-class=\"{error:loginFormPassword.password.$dirty && loginFormPassword.password.$invalid}\"><div class=password-input-container><input class=form-control no-focus tabindex=13 id=password name=password placeholder=\"Enter Password\" type={{Login.passwordType}} ng-model=Login.loginPayload.password required stopcopypaste autocomplete=one-time-code><label for=password>Password</label><div class=input-controls><span class=inputTxt><span class=password-toggle><img src=../../../assets/images/showpassword.svg ng-if=\"Login.passwordType === \'password\'\" ng-click=Login.showPassword()> <img src=../../../assets/images/blind-1.svg ng-if=\"Login.passwordType !== \'password\'\" ng-click=Login.showPassword()></span></span></div><span ng-show=\"loginFormPassword.password.$dirty && loginFormPassword.password.$invalid\"><span class=error-input ng-show=loginFormPassword.password.$error.required ng-bind=Login.validateData.PASSWORD_REQUIRED></span></span></div><div><span class=\"inputTxt inputTxtLogin forgot-password\" ng-if=!Login.showSecStep><a href=javascript:void(0) ui-sref=forgotPassword class=forgtId id=forgotcontrast tabindex=16>Forgot Password?</a></span></div></div><div ng-if=Login.showSecStep class=form-bottom-margin ng-class=\"{error:loginFormPassword.otpNumber.$dirty && loginFormPassword.otpNumber.$invalid}\"><div class=otp-input-container><input class=form-control type=text ng-model=Login.loginPayload.otp required minlength=6 maxlength=6 tabindex=50 autofocus name=otpNumber id=otp-input is-number autofocus autocomplete=off><label for=otp-input>Enter OTP</label><span class=highlight></span> <span class=bar></span><div class=input-controls ng-if=Login.showSecStep><span class=forgot><timer countdown=Login.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Login.reGenerateOtp();>Resend OTP</a></span></div></timer></span></div></div></div><span ng-show=\"loginFormPassword.otpNumber.$dirty && loginFormPassword.otpNumber.$invalid && loginFormPassword.otpNumber.$pristine\"><span class=error-input ng-show=loginFormPassword.otpNumber.$error.required ng-bind=Login.validateData.OTP_REQUIRED></span></span><div class=resend-otp-message ng-if=Login.showSecStep><div class=\"form-group otpSucessText\" ng-if=Login.sentOtpRespMsg ng-bind-html=Login.sentOtpRespMsg></div></div><!-- Pan Input --><div class=pan-input-container ng-if=\"Login.showSecStep && Login.isAdditionalFactorRequired\" ng-class=\"{error:loginFormPassword.authPanNumber.$dirty && loginFormPassword.authPanNumber.$invalid}\"><input class=form-control type=text name=authPanNumber maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=Login.loginPayload.authPanNumber capitalize placeholder=\"e.g. PGHJD4532M\" required autocomplete=off><label for=authPanNumber>PAN</label><span ng-messages=loginFormPassword.authPanNumber.$error ng-show=\"loginFormPassword.authPanNumber.$dirty && loginFormPassword.authPanNumber.$invalid\"><span class=error-input ng-message=required ng-bind=Login.validateData.PAN_REQUIRED></span> <span class=error-input ng-message=minlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=error-input ng-message=maxlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=error-input ng-message=pattern ng-bind=Login.validateData.PAN_FIELD></span></span></div><div class=\"btnContainer loginpwdBtn\" style=\"min-height: 50px\" ng-class=\"{\'button-placing\' : Login.showSecStep}\"><input type=submit ng-if=!Login.showSecStep ng-disabled=\"loginFormPassword.$invalid || Login.loginProcessFlag\" ng-hide=Login.showOtpField class=\"loginBtn btn btn-bloc inputLoginBtn loginBtnNewTheme\" ng-click=Login.firstStepLogin() tabindex=14 value=LOGIN> <input type=submit ng-if=\"Login.showSecStep || Login.showOtpField\" ng-disabled=\"!Login.loginPayload.otp || Login.loginProcessFlag || !Login.showSecStep || (Login.isAdditionalFactorRequired && !Login.loginPayload.authPanNumber)\" ng-click=Login.login() tabindex=51 class=\"loginBtn btn btn-bloc inputLoginBtn loginBtnNewTheme\" value=LOGIN></div></form></div><div ng-show=Login.loginUsingOtpFlag ng-class=\"{\'form-placing\': Login.showSecStep}\"><form class=login-form name=loginForm ng-if=Login.isResetLoginForm ng-class=\"{alignMargin:Login.showOtpField && !Login.sentOtpRespMsg}\" novalidate><div ng-hide=Login.showOtpField ng-class=\"{error:loginForm.userId.$dirty && loginForm.userId.$invalid}\"><span class=prefilled ng-if=Login.tracked ng-bind=Login.loginPayload.username></span><div class=userID-input-container><input class=form-control autofocus name=userId ng-model=Login.loginPayload.username type=text ng-change=Login.reset() placeholder=\"Enter User ID\" required stopcopypaste ng-if=!Login.tracked><label for=userId>User ID</label></div><div class=\"input-controls input-controls-login input-option-float\"><span class=\"inputTxt inputTxtLogin\"><a href=javascript:void(0) ui-sref=\"unlockfolioid({type:\'userid\',from:\'login\'})\" class=unlckId tabindex=14>Unlock ID &nbsp;</a><span class=seperator-id>|</span> <span class=border-right></span> </span><span class=\"inputTxt inputTxtLogin\"><a href=javascript:void(0) ui-sref=forgotUserId class=forgtId tabindex=15>Forgot ID</a></span></div><div class=form-group><span ng-show=\"loginForm.userId.$dirty && loginForm.userId.$invalid\"><span class=\"error-input mobile-error\" ng-show=loginForm.userId.$error.required ng-bind=Login.validateData.USER_ID_REQUIRED></span> <span class=\"error-input mobile-error\" ng-show=\"loginForm.userId.$error.pattern && loginForm.userId.$invalid\" class=help-block>{{ Login.validateData.USERNAME_PATTERN }}</span></span></div></div><div ng-hide=Login.showOtpField ng-class=\"{error:loginForm.userId.$dirty && loginForm.userId.$invalid}\"><div class=pan-input-container><input class=form-control type=text name=panNumber maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=Login.loginPayload.panNumber capitalize placeholder=\"e.g. ABCDE1234A\" required autocomplete=off><label for=password>User PAN</label><span ng-messages=loginForm.panNumber.$error ng-show=\"loginForm.panNumber.$dirty && loginForm.panNumber.$invalid\"><span class=error-input ng-message=required ng-bind=Login.validateData.PAN_REQUIRED></span> <span class=error-input ng-message=minlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=error-input ng-message=maxlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=error-input ng-message=pattern ng-bind=Login.validateData.PAN_FIELD></span></span></div></div><div class=\"btnContainer loginpwdBtn\" style=\"min-height: 50px\" ng-hide=Login.showOtpField><input type=submit ng-disabled=\"!Login.loginPayload.username || !Login.loginPayload.panNumber\" ng-if=\"Login.showOtpField === false\" class=\"loginBtn btn btn-bloc inputLoginBtn loginBtnNewTheme\" ng-click=Login.generateOtp() value=\"Send OTP\"></div><div ng-if=Login.showOtpField ng-class=\"{error:loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid}\"><div class=otp-input-container><input class=form-control id=otpId type=text ng-model=Login.loginPayload.otp required minlength=6 maxlength=6 tabindex=13 name=otpNumber is-number autofocus autocomplete=off><label>Enter OTP</label><span class=highlight></span> <span class=bar></span><div class=input-controls ng-if=Login.showSecStep><span class=forgot><timer countdown=Login.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Login.reGenerateOtp();>Resend OTP</a></span></div></timer></span></div></div><span ng-show=\"loginForm.otpNumber.$dirty && loginForm.otpNumber.$invalid && loginForm.otpNumber.$pristine\"><span class=error-input ng-show=loginForm.otpNumber.$error.required ng-bind=Login.validateData.OTP_REQUIRED></span></span></div><div class=resend-otp-message ng-if=Login.showSecStep><div id=clickText class=\"form-group otpSucessText\" ng-if=Login.sentOtpRespMsg ng-bind-html=Login.sentOtpRespMsg></div></div><!-- DOB Input --><div class=row ng-if=\"Login.showOtpField && Login.isAdditionalFactorRequired\"><div class=\"col-xs-12 col-md-12\"><div class=dob-input-container><label for=dobId class=s-label>Date of Birth</label><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{Login.viewMode}} data-date-default=Login.loginPayload.authdob data-on-date-change=Login.checkDobDate maxdate=now format=DD-MM-YYYY id=endDate style=\"width: 100%;height: 40px;border-radius: 5px\"><input class=newinvestor-dob tabindex=2 id=dobId name=dob type=text autocomplete=off placeholder=dd-mm-yyyy ng-keyup=Login.autoDate() required style=\"border: none\" easyassist-key=mask-element> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span class=error-input ng-if=Login.dateErrorMessage ng-bind=Login.dateErrorMessage></span></div></div></div></div><div class=\"btnContainer loginpwdBtn\" style=\"min-height: 50px\" ng-class=\"{showOtp:Login.loginUsingOtpFlag && Login.showOtpField === false, \'button-placing\' : Login.showSecStep}\"><input id=submitLogin1 type=submit ng-hide=\"Login.loginUsingOtpFlag && !Login.showOtpField || Login.showSecStep \" ng-disabled=\"loginForm.$invalid || Login.loginProcessFlag || !Login.showOtpField\" class=\"loginBtn btn btn-bloc inputLoginBtn loginBtnNewTheme\" ng-click=Login.login() tabindex=14 value=LOGIN> <input id=submitLogin2 type=submit ng-show=Login.showSecStep ng-disabled=\"loginForm.otpNumber.$error.required || loginForm.otpNumber.$invalid || Login.loginProcessFlag || !Login.showOtpField || (Login.isAdditionalFactorRequired && !Login.loginPayload.authdob)\" ng-click=Login.login() tabindex=14 class=\"loginBtn btn btn-bloc inputLoginBtn loginBtnNewTheme\" value=LOGIN></div></form></div></div><div class=login-footer ng-if=!Login.showSecStep><div class=login-footer-create><div class=login-footer-inner-cover><img src=assets/images/registered-user.svg class=body-img-color> <img src=assets/images/createidBW.svg style=\"display: none\" class=body-img-bw></div><div><div>Already a HDFC MF Investor? <a href=javascript:void(0) ui-sref=createUserId.verifyAccountDetails class=\"forgtId createUserId\" tabindex=16>Create User ID </a>to login on online portal or app.</div></div></div></div></div></div><div class=mobile-footer-blue><div class=mobile-footer-blue-container ng-click=Login.handleSideBarClick(Login.appConstants.INVESTOR_SELECTION.NEW_INVESTOR) ui-sref=newInvestor><img src=assets/images/newInvestor.svg class=\"investorIcon investor-mobile-icon body-img-color\"> <img src=assets/images/ic_newinvestor2bw.svg style=\"display: none\" class=body-img-bw><div class=\"mainmenu-text mobile-footer-blue-text\">New Investor?</div></div><div class=\"mobile-footer-blue-container mobile-footer-seperator\" ng-click=Login.handleSideBarClick(Login.appConstants.INVESTOR_SELECTION.QUICK_INVEST) ui-sref=instantLogin><img src=assets/images/quickinvest.svg class=\"investorIcon mobile-footer-icon investor-mobile-icon body-img-color\"> <img src=assets/images/ic_quickinvest2bw.svg style=\"display: none\" class=body-img-bw><div class=\"mainmenu-text mobile-footer-blue-text\">Quick Invest</div></div></div>");
$templateCache.put("app/login/login-components/new-investor-registration.html","<div class=height-mobile-quick-invest><login-header></login-header><div class=\"side-nav-main-wrap row\"><div class=\"side-nav-container col-md-3\"><div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap\"><div class=\"col-md-12 height100\"><div class=side-nav-wrap><hdfc-login-sidebar sidebar-click=Login.handleSideBarClick(message)></hdfc-login-sidebar></div></div></div></div><div class=\"col-md-9 col-sm-12\"><div class=forms-container><div class=\"row row-no-gutters\"><div class=existing-investor-background-mobile><img src=../../../assets/images/resp-newinvestor.svg><div class=new-investor-mobile><h4>Welcome to</h4><h3><div>HDFC</div><div>Mutual Funds</div></h3></div></div><div class=\"col-sm-12 col-md-6 new-investor-background\"><div class=new-investor-content><h4>Welcome to</h4><h3><div>HDFC</div><div>Mutual</div><div>Funds</div></h3></div></div><div class=\"col-sm-12 col-md-6 form-existing-wrap form-existing-wrap-login\"><div class=\"registration-forms reg-form-resp\"><div class=login-header><h4 class=reg-form-heading>New Investor Registration</h4><div class=register-sub-headline>Register and Start your journey of investment today!</div></div><div><form class=login-form autocomplete=off name=signupForm ng-init=Login.Init() ng-submit=Login.verifyDetails() novalidate><div ng-class=\"{error:signupForm.pan.$dirty && signupForm.pan.$invalid || Login.panMessage}\"><div class=pan-input-container><input class=form-control tabindex=10 id=pan1 type=text name=pan maxlength=10 minlength=10 ng-model=Login.formData.pan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-change=Login.resetValues() ng-blur=Login.checkPanVerification() placeholder=\"e.g. ABCDE1234A\" autofocus capitalize required><label for=pan1>PAN</label><span ng-show=\"signupForm.pan.$dirty && signupForm.pan.$invalid\"><span class=error-input ng-show=signupForm.pan.$error.required ng-bind=Login.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=signupForm.pan.$error.maxlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=error-input ng-show=signupForm.pan.$error.pattern ng-bind=Login.validateData.PAN_FIELD></span> </span><span class=error-input ng-if=Login.panMessage ng-bind=Login.panMessage></span></div></div><div><div class=dob-input-container><label for=dobId>Date of Birth</label><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{Login.viewMode}} data-date-default=Login.formData.dob data-on-date-change=Login.changeStartDate maxdate=now format=DD-MMM-YYYY id=endDate><input class=newinvestor-dob tabindex=11 id=dobId name=dob type=text autocomplete=off placeholder=DD-MMM-YYYY required> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-if=Login.dateErrorMessage ng-bind=Login.dateErrorMessage></span></div></div></div><div class=\"checkbox form-check new-investor\" style=\"z-index: 0\" ng-if=Login.showTerms><input tabindex=12 type=checkbox style=\"width: 33%;z-index: 1\" id=termNcondition name=termNcondition href=javascript:void(0) ng-click=Login.confirmRegister() ng-model=Login.formData.termNcondition required> <i class=icon-checkbox></i> <span class=\"checkbox-text checkbox-text-resp\">I have read and accepted the <a tabindex=13 ng-click=Login.showTermConditions() href=javaScript:void(0) class=tnc-res>Terms & Conditions</a></span></div><div class=\"btnContainer loginpwdBtn registration-login-button\" style=\"min-height: 50px\"><button tabindex=14 type=submit class=\"loginBtn btn btn-bloc loginBtnNewTheme\" ng-disabled=\"signupForm.pan.$invalid || !Login.formData.dob || Login.panMessage || Login.processFlag || !Login.formData.termNcondition \">REGISTER NOW</button></div></form></div></div></div></div></div></div></div></div><div class=mobile-footer-blue><div class=mobile-footer-blue-container ng-click=Login.handleSideBarClick(Login.appConstants.INVESTOR_SELECTION.EXISTING_USER) ui-sref=login><img src=assets/images/newInvestor.svg class=\"investorIcon body-img-color\"> <img src=assets/images/existingInvestorBW.svg style=\"display: none\" class=body-img-bw><div class=\"mainmenu-text mobile-footer-blue-text\">Existing Investor</div></div><div class=\"mobile-footer-blue-container mobile-footer-seperator\" ng-click=Login.handleSideBarClick(Login.appConstants.INVESTOR_SELECTION.QUICK_INVEST) ui-sref=instantLogin><img src=assets/images/quickinvest.svg class=\"investorIcon mobile-footer-icon body-img-color\"> <img src=assets/images/ic_quickinvest2bw.svg style=\"display: none\" class=body-img-bw><div class=\"mainmenu-text mobile-footer-blue-text\">Quick Invest</div></div></div><footer-login></footer-login>");
$templateCache.put("app/login/login-components/quick-invest-login.html","<div class=\"row row-no-gutters\"><div class=\"existing-investor-background-mobile quick-invest-mobile-margin\"><img src=../../../assets/images/resp-quickinvest.svg></div><div class=\"col-md-6 quick-invest-background\"></div><div class=\"col-md-6 form-existing-wrap\"><div class=\"quick-invest-forms reg-form-resp\"><div class=login-header style=\"padding-bottom: 0%\"><h4>Quick Investment</h4><div>Invest quickly without logging in</div></div><div><form name=loginForm autocomplete=false novalidate><div class=form-group><div class=userpan-input-container ng-class=\"{error:loginForm.folioNumber.$dirty && loginForm.folioNumber.$invalid && loginForm.folioNumber.$touched}\"><input name=folioNumber ng-model=InstantLogin.loginPayload.folioNumber type=text id=folioNumber class=form-control ng-maxlength=12 is-number required placeholder=\"e.g. 546321\" autocomplete=off><label for=folioNumber>Folio Number</label><div class=input-controls><span class=inputTxt><a href=javascript:void(0) ui-sref=\"unlockfolioid({type:\'userid\',from:\'login\'})\" class=unlckId tabindex=14>Unlock ID &nbsp;</a><span class=seperator-id>|</span> <span class=border-right></span> </span><span class=inputTxt><a href=javascript:void(0) ui-sref=forgotUserId class=forgtId tabindex=15>Forgot ID</a></span></div><span class=error-input ng-messages=loginForm.folioNumber.$error ng-show=\"loginForm.folioNumber.$dirty && loginForm.folioNumber.$invalid && loginForm.folioNumber.$touched\"><span ng-message=required ng-bind=InstantLogin.validateData.FOLIO_REQUIRED></span> <span ng-message=maxlength ng-bind=InstantLogin.validateData.FOLIO_FIELD_MAX></span></span></div></div><div class=form-group><div class=password-input-container ng-class=\"{error:loginForm.panNumber.$dirty && loginForm.panNumber.$invalid && loginForm.panNumber.$touched}\"><input type=text name=panNumber maxlength=10 minlength=10 class=form-control ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=InstantLogin.loginPayload.panNumber capitalize placeholder=\"e.g. ABCDE1234A\" required autocomplete=off><label>PAN</label><span ng-messages=loginForm.panNumber.$error ng-show=\"loginForm.panNumber.$dirty && loginForm.panNumber.$invalid\"><span class=error-input ng-message=required ng-bind=InstantLogin.validateData.PAN_REQUIRED></span> <span class=error-input ng-message=minlength ng-bind=InstantLogin.validateData.PAN_FIELD></span> <span class=error-input ng-message=maxlength ng-bind=InstantLogin.validateData.PAN_FIELD></span> <span class=error-input ng-message=pattern ng-bind=InstantLogin.validateData.PAN_FIELD></span></span></div></div><div class=form-group><div class=password-input-container ng-class=\"{error:loginForm.bankAccountNumber.$dirty && loginForm.bankAccountNumber.$invalid && loginForm.bankAccountNumber.$touched}\"><input name=bankAccountNumber class=form-control type=text ng-minlength=9 ng-maxlength=20 is-number ng-model=InstantLogin.loginPayload.bankAccountNumber placeholder=\"Enter your 14 or 16 digit bank account number\" required autocomplete=off><label>Bank Account Number</label><span ng-messages=loginForm.bankAccountNumber.$error ng-show=\"loginForm.bankAccountNumber.$dirty && loginForm.bankAccountNumber.$invalid\"><span class=error-input ng-message=required ng-bind=InstantLogin.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-message=minlength ng-bind=InstantLogin.validateData.ACCOUNT_NUMBER_RANGE_MIN></span> <span class=error-input ng-message=maxlength ng-bind=InstantLogin.validateData.ACCOUNT_NUMBER_RANGE_MAX></span></span></div></div><div class=\"btnContainer loginpwdBtn\"><input id=submitLogin1 type=submit ng-disabled=\"loginForm.$invalid || InstantLogin.loginProcessFlag\" class=\"btn btn-block loginBtn\" value=Continue ng-click=InstantLogin.login()></div></form></div></div></div></div>");
$templateCache.put("app/mobile/faq/faq.html","<div class=login-screen><div dynamic=Faq.faqData></div></div><style>.mb10{padding-bottom: 5px;display: inline-block;margin-top: 10px;}\n  @media only screen and (max-width: 767px) {\n    .faq-wrapper {\n      padding: 20px 5px !important;\n    }\n\n    .faq-wrapper.main-section .faq-wrap > li div:first-child span:first-child {\n      margin-right: 10px;\n    }\n\n    .faq-wrapper.main-section .faq-list li span:first-child {\n      margin-right: 10px;\n    }\n\n    .faq-wrapper.main-section .faq-wrap > li div {\n      padding-left: 32px;\n    }\n\n    .faq-wrapper.main-section .faq-wrap > li ul {\n      padding-left: 48px;\n    }\n\n    .visit-link {\n      display : block;\n    }\n\n    .btn {\n      display: none ;\n    }\n\n    .v-link {\n      text-align: left !important;\n      word-spacing: 4px;\n    }\n\n    .two-factor th {\n      padding: 6px !important;\n    }\n\n    .set-padding {\n      padding-left: 18px !important;\n    }\n  }\n  section h1{margin-bottom: 10px !important;}\n  .headerPreLogin {\n    display:none;\n  }</style>");
$templateCache.put("app/mobile/tnc/transactionalTermcondition.html","<div class=modal-content id=tnc ng-init=MobileTnc.init()><div data-ng-switch=MobileTnc.transactionType><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncPurchase.html\'\"></div></div><div data-ng-switch-when=Schedule_Transaction><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncPurchase.html\'\"></div></div><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSip.html\'\"></div></div><div data-ng-switch-when=SWITCH><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSwitch.html\'\"></div></div><div data-ng-switch-when=REDEMPTION><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncRedemption.html\'\"></div></div><div data-ng-switch-when=INSTANT_REDEMPTION><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncInstantRedemption.html\'\"></div></div><div data-ng-switch-when=STP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncStp.html\'\"></div></div><div data-ng-switch-when=SIP_E_MANDATE><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSipEMandate.html\'\"></div></div><div data-ng-switch-when=Flex_STP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncFlexStp.html\'\"></div></div><div data-ng-switch-when=Swing_STP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSwingStp.html\'\"></div></div><div data-ng-switch-when=FLEX_INDEX><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncFlexIndex.html\'\"></div></div><div data-ng-switch-when=SWP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSwp.html\'\"></div></div><div data-ng-switch-when=DTP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncDtp.html\'\"></div></div><div data-ng-switch-when=KYC><div data-ng-include=\"\'app/components/modal/nonTransactionalTnc/tncKycUpdate.html\'\"></div></div><div data-ng-switch-when=FATCA><div data-ng-include=\"\'app/components/modal/nonTransactionalTnc/tncFatcaUpdate.html\'\"></div></div><div data-ng-switch-when=COBM><div data-ng-include=\"\'app/components/modal/nonTransactionalTnc/tncCobm.html\'\" ng-init=\"cobmTerms = MobileTnc.dynamicDataCOBM\"></div></div><div data-ng-switch-when=GENERAL><div data-ng-include=\"\'app/components/modal/termcondition/directive/generalTnc.html\'\" ng-init=\"generalTerms = MobileTnc.dynamicDataGeneral\"></div></div><div data-ng-switch-when=SMART_SWAP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSmartSwp.html\'\"></div></div><div data-ng-switch-when=BIOMETRIC><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncBiometric.html\'\"></div></div><div data-ng-switch-when=ECART><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncEcart.html\'\"></div></div><div data-ng-switch-when=FLEXSIP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncFlexSip.html\'\"></div></div></div></div>");
$templateCache.put("app/mobile/tpv/tpv.html","<!DOCTYPE html><html><head><meta http-equiv=content-type content=\"text/html; charset=UTF-8\"><style>table,th,td{\n      border:1px solid black;\n      border-collapse: collapse;\n      text-align: center;\n      padding: 3px;\n    }\n    table tr th{\n      font-weight: 700;\n      padding: 15px;\n    }</style></head><body><div style=\"padding: 6px\"><table style=\"width: 100%\"><tbody><tr bgcolor=103880 style=color:#fff><th width=25%>S.No</th><th width=75%>Bank Name</th></tr><tr><td>1.</td><td>Andhra Bank</td></tr><tr><td>2.</td><td>AXIS Bank LTD</td></tr><tr><td>3.</td><td>BANK OF INDIA</td></tr><tr><td>4.</td><td>Bank of Baroda</td></tr><tr></tr><tr><td>5.</td><td>Bank of Maharashtra</td></tr><tr><td>6.</td><td>Canara Bank</td></tr><tr><td>7.</td><td>Central Bank of India</td></tr><tr><td>8.</td><td>City Union Bank</td></tr><tr><td>9.</td><td>Corporation Bank</td></tr><tr><td>10.</td><td>DENA Bank</td></tr><tr><td>11.</td><td>HDFC Bank Ltd</td></tr><tr><td>12.</td><td>ICICI Bank</td></tr><tr><td>13.</td><td>IDBI Bank</td></tr><tr><td>14.</td><td>IndusInd Bank</td></tr><tr><td>15.</td><td>Indian Overseas Bank</td></tr><tr><td>16.</td><td>Karur Vysya Bank</td></tr><tr><td>17.</td><td>Karnataka Bank</td></tr><tr><td>18.</td><td>Kotak Mahindra Bank</td></tr><tr><td>19.</td><td>Lakshmi Vilas Bank</td></tr><tr><td>20.</td><td>Punjab National Bank</td></tr><tr><td>21.</td><td>State Bank of India</td></tr><tr><td>22.</td><td>Syndicate Bank</td></tr><tr><td>23.</td><td>South Indian Bank</td></tr><tr><td>24.</td><td>Standard Chartered Bank</td></tr><td>25.</td><td>Union Bank of India</td><tr><td>26.</td><td>YES Bank Ltd</td></tr></tbody></table></div></body></html>");
$templateCache.put("app/new-investors/folio-details/folio-details.html","<div class=container-fluid ng-if=!NewInvestor.testObj.steps[2].stepCompleted ng-init=FolioDetails.init()><div class=\"kyc-form-container row\"><div class=col-xs-12><div class=\"form-page-header row\" style=\"margin: 0px 0px 0px -50px\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><!-- ng-click=\"backButton()\" --><div style=\"display: flex;justify-content: flex-start;padding-right: 5px\"><img ng-click=backbtn() src=../../../assets/images/back-button.svg alt=\"\" srcset=\"\" style=\"width: 19px;height: 13px;margin: 0px 10px 0px 0px\"><h4 class=mainStep2 style=\"white-space: nowrap\">Step 3</h4></div><div><p ng-if=showSaveTag class=savebutton>Saved</p></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between;align-items: center\"><!-- <p>{{myState}}</p> --><!-- ng-If=\"FolioDetails.stepperForMinor.steps[0].stepActive == true && FolioDetails.stepperThird.steps[0].stepActive == true && FolioDetails.stepperForAnyoneSurvivor.steps[0].stepActive == true \" --><p class=mainTitile ng-if=\"myState ==\'/folio-basic-details\' || myState == \'/folio-basic-minor-details\' \">Please provide basic details to help us build your folio!</p><!-- ng-If=\"FolioDetails.stepperThird.steps[1].stepActive == true\" --><p class=mainTitile ng-if=\"myState ==\'/folio-income-details\'\">Great Going!Help us with income details</p><p class=mainTitile ng-if=\"myState ==\'/folio-guardian-minor-details\'\">Great Going!Help us with guardian details</p><!-- ng-If=\"FolioDetails.stepperForAnyoneSurvivor.steps[1].stepActive == true\"   --><p class=mainTitile ng-if=\"myState ==\'/folio-joint-holder-details\' && !FolioDetails.showholderdetails\">Great Going!Help us with Unit/First Holder details!</p><p class=mainTitile ng-if=\"myState ==\'/folio-joint-holder-details\' && FolioDetails.showholderdetails && !FolioDetails.addholder.steps[2].isactive\">Add Holder</p><p class=mainTitile ng-if=\"myState ==\'/folio-joint-holder-details\' && FolioDetails.showholderdetails && FolioDetails.addholder.steps[2].isactive\">Please provide holder\'s details</p><!-- ng-If=\"FolioDetails.shownomineedetails\" --><p class=mainTitile ng-if=\"myState == \'/folio-nominee-details\' \">You are almost there!</p><p class=mainTitile ng-if=\"myState == \'/bankdetails\' \">Add bank Details!</p></div></div><div class=\"form-page-container row\"><div class=col-xs-12 style=\"align-items: flex-start\"><div ng-if=\"folioBasicDetail.folioHoldingMode == \'SINGLE\'\"><horizontal-progress-sidebar ng-if=\"folioBasicDetail.folioForUser == \'Self\' && folioBasicDetail.folioHoldingMode == \'SINGLE\'\" steps=FolioDetails.stepperThird></horizontal-progress-sidebar><horizontal-progress-sidebar ng-if=\"folioBasicDetail.folioForUser == \'Minor\'\" steps=FolioDetails.stepperForMinor></horizontal-progress-sidebar></div><horizontal-progress-sidebar ng-if=\"folioBasicDetail.folioForUser == \'Self\' && folioBasicDetail.folioHoldingMode == \'ANY_OR_SURVIVOR\'\" steps=FolioDetails.stepperForAnyoneSurvivor></horizontal-progress-sidebar><div ui-view></div></div></div></div></div></div><style>@media only screen and (min-device-width : 768px) and (max-device-width : 768px) {\n    .hdfc-blue-cta-small{\n      width: 163px !important;\n    }\n  .stepper-horizontal-responsive .step li {\n       z-index: 5;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(2){\n    z-index: 4;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(3){\n    z-index: 3;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(4){\n    z-index: 2;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(5){\n    z-index: 1;\n  }\n}</style>");
$templateCache.put("app/new-investors/investment-details/investment-detail.html","<div class=container-fluid><div class=\"kyc-form-container row\"><div class=col-xs-12><div class=\"form-page-header row\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: flex-start;background-color: transparent;padding-right: 0px\"><img ng-click=logoutBtn() ng-if=\"currentstate == \'/selectscheme\' || currentstate == \'/investmentGoal\'\" src=../../../assets/images/back-button.svg alt=\"\" srcset=\"\" style=\"width: 19px;height: 13px;margin: 0px 10px 0px 0px\"> <img ng-click=backbtn() ng-if=\"currentstate != \'/selectscheme\' && currentstate != \'/investmentGoal\'\" src=../../../assets/images/back-button.svg alt=\"\" srcset=\"\" style=\"width: 19px;height: 13px;margin: 0px 10px 0px 0px\"><h4 class=mainStep2 style=\"white-space: nowrap\">Step 2</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between;align-items: center;padding-left: 5px\"><!-- <p>{{currentstate}}</p> --><!-- <p ng-if=\"stepperSecondary.steps[0].stepCompleted == false\" >Select a scheme based on your requirements and start investing!</p> --><p class=mainTitile ng-if=\"currentstate == \'/selectscheme\' || currentstate == \'/investmentGoal\' \">Select a scheme based on your requirements and start investing!</p><!-- <p ng-if=\"stepperSecondary.steps[1].stepActive == true && stepperSecondary.steps[1].stepCompleted == false \">Help us with your investment details!</p> --><p class=mainTitile ng-if=\"currentstate == \'/investmentmode\'\">Help us with your investment details!</p><!-- <p ng-if=\"stepperSecondary.steps[2].stepActive == true || stepperSecondary.steps[3].stepActive == true \">Last few questions on investment details!</p> --><p class=mainTitile ng-if=\"currentstate == \'/amountdetails\' \">Last few questions on investment details!</p><!-- <button type=\"button\" \n          ng-if=\" stepperSecondary.steps[1].stepActive == true && stepperSecondary.steps[1].stepCompleted == false \"\n          style=\"background-color: white;border-radius: 10px;width: 100px;border: 1px solid blue;\">Saved1</button>\n          <button type=\"button\" \n          ng-if=\" stepperSecondary.steps[2].stepActive == true && stepperSecondary.steps[2].stepCompleted == false \"\n          style=\"background-color: white;border-radius: 10px;width: 100px;border: 1px solid blue;\">Saved2</button>\n          <button type=\"button\" \n          ng-if=\" stepperSecondary.steps[3].stepActive == true && stepperSecondary.steps[3].stepCompleted == false \"\n          style=\"background-color: white;border-radius: 10px;width: 100px;border: 1px solid blue;\">Saved3</button> --></div></div><div class=\"form-page-container row\"><div class=col-xs-12 style=\"margin-top: 10px\"><horizontal-progress-sidebar steps=stepperSecondary></horizontal-progress-sidebar><div ui-view></div></div></div></div></div></div><style>@media only screen and (min-device-width : 768px) and (max-device-width : 768px) {\n    .hdfc-blue-cta-small{\n      width: 163px !important;\n    }\n  .stepper-horizontal-responsive .step li {\n       z-index: 5;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(2){\n    z-index: 4;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(3){\n    z-index: 3;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(4){\n    z-index: 2;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(5){\n    z-index: 1;\n  }\n}</style>");
$templateCache.put("app/new-investors/investo-profile/investo-profile.html","<div class=payment style=\"margin-left: 20px\" ng-init=InvestorProfile.init()><br><br><div class=main style=\"width: 85vw;box-shadow: -1px 1px 5px 1px lightgrey\"><div class=row><!-- ng-If=\"InvestorProfile.ModeOfHold == \'SINGLE\' || InvestorProfile.ModeOfHold == \'\' || InvestorProfile.holdmode == \'SINGLE\'\" --><div class=\"note col-sm-12 col-md-12\" style=\"margin: auto;margin-bottom: 50px;margin-left: 25px\"><img src=../../../assets/images/congratulation.png alt=\"\" style=\"height: 50px; margin-top: 5px\"><p style=\"font-weight: 600;\n                color: #000000;\n                text-align: center;\n                line-height: 20px;\n                letter-spacing: 0px;\n                padding: 5px\"><!-- You have successfully made your investments with HDFC MF</p> --><!-- <p class=\"headnotes\"> --> Take a step further towards consolidated Dashboard, Multiple Statements/Reports, Online Bank<br>Mandate Registration & more such online services by creating a User ID.</p></div><!-- <div ng-If=\"InvestorProfile.ModeOfHold == \'ANY_OR_SURVIVOR\' || InvestorProfile.holdmode == \'ANY_OR_SURVIVOR\'\" \n            class=\"note col-sm-12 col-md-12\" style=\"margin: auto;margin-bottom: 50px;margin-left: 25px;\">\n                <img src=\"../../../assets/images/congratulation.png\" alt=\"\" style=\"height: 50px; margin-top: 5px;\">\n                <br>\n                <p style=\"font-weight: bold;\">Your Request has been successfully sent for Approval.</p>\n            </div> --><div class=\"col-xs-12 col-md-12\" style=\"margin-bottom: 35px\"><div class=row><div class=\"col-sm-12 col-md-6\" style=\"display: flex;justify-content: center;align-items: center\"><img src=../../../assets/images/BannerProfileImage.jpg alt=\"\"></div><div class=\"col-sm-12 col-md-6\"><form class=profileform name=userForm id=userForm style=\"width: 70%;margin-top: 10px;margin-left: 10%\" ng-submit=InvestorProfile.registerNewUser()><div class=row><div class=\"col-xs-12 col-md-12\"><p class=profileTitle>User ID</p></div><div class=\"col-xs-12 col-md-12\"><input class=\"form-control profileInput\" type=text name=userName id=userName minlength=6 maxlength=38 ng-change=InvestorProfile.resetData() ng-model=InvestorProfile.userName autofocus required autocomplete=off ng-pattern=InvestorProfile.appConstants.userId_regex ng-blur=InvestorProfile.checkAvailability() easyassist-key=mask-element> <span class=showPassword style=\"position: absolute;top:10px;right: 35px\"><img src=../../../assets/images/new-investor/pencil.png alt=\"\" srcset=\"\"> </span><span ng-if=InvestorProfile.availableMessage>{{InvestorProfile.availableMessage}}</span> <span class=error-input ng-show=\"userForm.userName.$dirty && userForm.userName.$invalid\"><span ng-show=userForm.userName.$error.required ng-bind=InvestorProfile.validateData.USER_ID_REQUIRED></span> <span ng-show=userForm.userName.$error.minlength>{{ InvestorProfile.validateData.USER_ID_FIELD}}</span> <span ng-show=userForm.userName.$error.pattern>{{ InvestorProfile.validateData.USER_ID_FIELD_PATTERN}}</span> <span ng-show=InvestorProfile.availableMessage>{{ InvestorProfile.availableMessage}}</span></span></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><p class=profileTitle>Password</p></div><div class=\"col-xs-12 col-md-12\"><input class=\"form-control profileInput\" ng-attr-type=\"{{ InvestorProfile.showPassword ? \'text\' : \'password\' }}\" id=newuserPassword name=newuserPassword ng-model=InvestorProfile.mainPassword ng-minlength=8 ng-maxlength=15 ng-pattern=\"/^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[$_!@])[A-Za-z\\d$@!_]{8,15}$/\" required> <span class=showPassword ng-click=InvestorProfile.togglePassword() style=\"position: absolute;top:10px;right: 35px\"><img ng-src=\"{{ InvestorProfile.showPassword ? \'../../../assets/images/showpassword.svg\' : \'../../../assets/images/blind-1.svg\'}}\" alt=\"\" srcset=\"\"></span><br><div class=row ng-if=userForm.newuserPassword.$dirty style=\"margin-left: 2px\"><div class=col><span ng-if=userForm.newuserPassword.$error.required style=\"color: red;margin-left: 0px\">Password required!</span></div><!-- check pattern --><div class=row ng-if=!userForm.newuserPassword.$error.required><div class=\"col-xs-12 col-md-6 flex-start\"><img class=passicon ng-src=\"{{userForm.newuserPassword.$error.minlength || userForm.newuserPassword.$error.maxlength ? \'../../../assets/images/nav-tick2.png\' : \'../../../assets/images/icons/nav-tick.png\'}}\"><p class=fs-13>Between 8 and 15 characters</p></div><div class=\"col-xs-12 col-md-6 flex-start\"><img class=passicon ng-src=\"{{userForm.newuserPassword.$error.pattern ? \'../../../assets/images/nav-tick2.png\' : \'../../../assets/images/icons/nav-tick.png\'}}\"><p class=fs-13>A number</p></div><div class=\"col-xs-12 col-md-6 flex-start\"><img class=passicon ng-src=\"{{userForm.newuserPassword.$error.pattern ? \'../../../assets/images/nav-tick2.png\' : \'../../../assets/images/icons/nav-tick.png\'}}\"><p class=fs-13>An uppercase character</p></div><div class=\"col-xs-12 col-md-6 flex-start\"><img class=passicon ng-src=\"{{userForm.newuserPassword.$error.pattern ? \'../../../assets/images/nav-tick2.png\' : \'../../../assets/images/icons/nav-tick.png\'}}\"><p class=fs-13>An lowercase character</p></div><div class=\"col-xs-12 col-md-6 flex-start\"><img class=passicon ng-src=\"{{userForm.newuserPassword.$error.pattern ? \'../../../assets/images/nav-tick2.png\' : \'../../../assets/images/icons/nav-tick.png\'}}\"><p class=fs-13>Special characters($@!_)</p></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><p class=profileTitle>Confirm Password</p></div><div class=\"col-xs-12 col-md-12\"><input class=\"form-control profileInput\" ng-attr-type=\"{{ InvestorProfile.showConfirmPassword ? \'text\' : \'password\' }}\" name=confirmPassword id=confirmPassword ng-model=InvestorProfile.Cpassword ng-pattern=InvestorProfile.mainPassword ng-change=InvestorProfile.matchPassword() required> <span class=showPassword ng-click=InvestorProfile.toggleConfirmPassword() style=\"position: absolute;top:10px;right: 35px\"><img ng-src=\"{{ InvestorProfile.showConfirmPassword ? \'../../../assets/images/showpassword.svg\' : \'../../../assets/images/blind-1.svg\'}}\" alt=\"\" srcset=\"\"> </span><!-- <span class=\"error-input\" ng-show=\"userForm.confirmPassword.$error.pattern\">Password does not match above</span> --> <span></span></div></div><br><span ng-if=\"!InvestorProfile.passwordMatchSuccess && userForm.confirmPassword.$dirty\" style=\"color: red\">Password does not match above</span><br><div class=row ng-if=!InvestorProfile.showOtPWindow><div class=\"col-xs-12 col-md-12\"><button type=submit class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-disabled=\"!InvestorProfile.passwordMatchSuccess ||\n                                    !InvestorProfile.Cpassword ||\n                                    !InvestorProfile.mainPassword ||\n                                    !InvestorProfile.userName\">CREATE USER ID</button></div></div></form></div></div></div></div></div></div><style>.profileInput{\n        height: 40px;\n        background: #FFFFFF 0% 0% no-repeat padding-box;\n        border: 1px solid #B8C6D1;\n        border-radius: 5px;\n        opacity: 1;\n    }\n    .headnotes{\n        text-align: center;\n        font-size: 14px;\n        padding: 5px 5px 10px 5px;\n    }</style>");
$templateCache.put("app/new-investors/kyc-verification/kyc-verification.html","<div class=\"container-fluid p-0\"><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=\"kyc-form-container row main-form-view\"><div class=col-xs-12><div class=\"form-page-header row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><h4 class=\"mainStep2 contrastWhiteFont\">Step 1</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><p class=\"mainTitile contrastWhiteFont\" style=\"padding: 15px 0 0 0\">Verify KYC status to start your investment journey with us!</p></div></div><div class=\"form-page-container row\"><div class=col-xs-12><form class=verification-form autocomplete=off name=signupForm ng-submit=KycVerification.verifyDetails() novalidate><div class=row><div class=\"col-xs-12 col-md-12\"><div class=tax-input-container><label class=\"s-label contrastWhiteFont\">Tax Status</label><span class=\"req text-red\">*</span><div class=\"selectfield newJourneyTaxstatus\"><select name=taxStatusResident ng-model=KycVerification.formData.selectTaxStatusResident ng-init=\"KycVerification.formData.selectTaxStatusResident = KycVerification.formData.selectTaxStatusResident ? KycVerification.formData.selectTaxStatusResident : KycVerification.taxStatusList.RESIDENT_INDIVIDUAL\" ng-options=\"_taxStatus as _taxStatus for _taxStatus in KycVerification.taxStatusList\" ng-change=KycVerification.changesTaxStatus(KycVerification.formData.selectTaxStatusResident) required></select></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-5\"><div class=pan-input-container><label id=panevent ng-click=KycVerification.getModal() style=\"display: none\">Click</label><label for=pan class=\"s-label contrastWhiteFont\">PAN</label><span class=\"req text-red\">*</span> <input class=\"form-control borderRadius-100 respinputContainer\" id=pan tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=KycVerification.formData.pan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-change=KycVerification.resetValues() ng-blur=KycVerification.checkPanVerification() placeholder=\"e.g. ABCDE1234A\" autofocus capitalize required easyassist-key=mask-element ng-disabled=KycVerification.prefillPan> <span ng-show=\"signupForm.pan.$dirty && signupForm.pan.$invalid\"><span class=error-input ng-show=signupForm.pan.$error.required ng-bind=KycVerification.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=signupForm.pan.$error.maxlength ng-bind=KycVerification.validateData.PAN_FIELD></span> <span class=error-input ng-show=signupForm.pan.$error.pattern ng-bind=KycVerification.validateData.PAN_FIELD></span> </span><span class=error-input ng-if=KycVerification.panMessage ng-bind=KycVerification.panMessage></span></div></div><div class=col-md-3></div><div class=\"col-xs-12 col-md-4 hidden-xs\"><!--<div class=\"warning1\">\n                  <img src=\"../../../assets/images/icons/light-bulb.png\" style=\"width: 25px;height: 25px;\">\n                  <div class=\"wardiv\">Applicant\'s age should be 18 years or above</div>\n                </div>--></div></div><div class=row><div class=\"col-xs-12 col-md-5\"><div class=dob-input-container><label for=dobId class=\"s-label contrastWhiteFont\">Date of Birth</label><span class=\"req text-red\">*</span><div class=\"input-select input-normal input-group date date-picker dateInputReg resp-input\" date-calendar data-enable=true data-viewmode={{KycVerification.viewMode}} data-date-default=KycVerification.formData.dob data-on-date-change=KycVerification.changeStartDate maxdate=now format=DD-MM-YYYY id=endDate style=\"width: 336px;\n                    height: 40px;\n                    border-radius: 100px;\n                    border: 1px solid #B8C6D1\"><input class=\"newinvestor-dob borderRadius-100 respinputContainer\" tabindex=2 id=dobId name=dob type=text autocomplete=off placeholder=dd-mm-yyyy ng-keyup=KycVerification.autoDate() required style=\"border: none\" easyassist-key=mask-element> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span class=error-input ng-if=KycVerification.dateErrorMessage ng-bind=KycVerification.dateErrorMessage></span></div></div></div></div><!-- Start us/canada yes not --><!--<div style=\"display: flex;justify-content: flex-start;\">\n  <input class=\"nomineeCheckbox\"\n    type=\"checkbox\"\n    id=\"confirmfoliocreate\"\n    name=\"confirmfoliocreate\"\n    ng-click=\"KycVerification.getconformation()\"\n    ng-checked=\"KycVerification.conformation == \'US_CANADA\'\">\n  <label for=\"confirmfoliocreate\" class=\"confirmationnote\" style=\"font-size: 12px;\">\n    &nbsp;</label><label style=\"margin-top: 5px;\">I am a US Person/Resident of Canada.</label>\n</div>--><div class=confirmation-checkbox><input class=nomineeCheckbox type=checkbox id=confirmfoliocreate1 name=confirmfoliocreate1 ng-click=KycVerification.getconformation1() ng-checked=\"KycVerification.conformation == \'NOT_US_CANADA\'\"><label for=confirmfoliocreate1 class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\" class=contrastWhiteFont>I am not a US Person/Resident of Canada.</label></div><!-- End us/canada yes not --><!-- <div style=\"display: flex;justify-content: flex-start;\">\n              <input class=\"nomineeCheckbox\" type=\"checkbox\" id=\"confirmfoliocreate\" name=\"confirmfoliocreate\"\n                ng-click=\"KycVerification.getconformation()\" ng-checked=\"KycVerification.conformation\">\n              <label for=\"confirmfoliocreate\" class=\"confirmationnote\" style=\"font-size: 13px;\">\n                &nbsp;</label><label style=\"margin-top: 5px;\"> I have read and accepted the\n              <span ng-click=\"KycVerification.termandCondition()\"\n              style=\"font-size: 13px;color: blue;margin-top: 6px;\">\n                Terms & Conditions</span></label>\n            </div> --><div class=kyc-verify><button tabindex=3 type=submit class=\"btn-new-journey-color hdfc-blue-cta-small newJourneyBtn\" ng-disabled=\"signupForm.pan.$invalid || !KycVerification.formData.dob || KycVerification.panMessage\n                || KycVerification.processFlag || KycVerification.btnClose\">VERIFY</button></div></form></div></div></div></div></div><style>@media only screen\nand (min-device-width : 768px)\nand (max-device-width : 768px) {\n  .kyc-verify{\n    width: 163px !important;\n  }\n  .hidden-xs{\n    width: 78%;\n  }\n}\n@media only screen and (max-width: 425px) {\n  .sm-font{\n    font-size: 10px;\n  }\n}\n@media screen and (max-width: 1024px) {\n    .main-form-view{\n      position: absolute;\n      width: 90%;\n      top: 33%;\n      left: 50%;\n      padding: 20px;\n      transform: translate(-50%);\n      border-radius: 16px;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n    .newJourneyTaxstatus,.new-investors .kyc-form-container .verification-form .pan-input-container .form-control,\n    .new-investors .kyc-form-container .verification-form .newinvestor-dob,.resp-input,.new-investors .btn-new-journey-color{\n    width: 100% !important;\n    }\n  }\n \n  @media screen and (max-width: 375px) {\n    .main-form-view{\n      padding: 10px;\n      width: 90%;\n      top: 15% !important;\n      left: 53% !important;\n    }\n  }\n  @media screen and (max-width: 310px) {\n  .main-form-view {\n      padding: 20px 11px !important;\n    }\n  }\n  @media screen and (max-width:768px) {\n    .kyc-form-container{\n      padding: 5% 2% !important;\n    }\n    .main-form-view{ \n      top: 25%;\n    }\n  }\n  @media screen and (max-width: 567px){\n    .main-form-view{ \n      position: absolute;\n      width: 90%;\n      top: 22%;\n      left: 53%;\n      padding: 20px;\n      transform: translate(-50%);\n      border-radius: 16px;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n    \n  }\n  .contrastClass .contrastWhiteFont{\n    color: #fff !important;\n  }\n  .contrastClass .new-investors .kyc-form-container .form-page-container .nomineeCheckbox + .confirmationnote:before{\n    border: 0.1em solid #fff;\n  }\n  .newJourneyBtn{\n    background-image: linear-gradient(to right, #3368ab, #1d4e8a), linear-gradient(#2a5e9d, #275a99) !important;\n  }\n  .newJourneyBtn:disabled{\n    background: linear-gradient(94deg, #cdd7e3 -21.18%, #c3cfde 95.94%) !important;\n  }\n  .borderRadius-100{\n    border-radius: 100px !important;\n  }\n  .new-investors .kyc-form-container .form-page-container .req{\n    top: -2px;\n    margin-left: 0px;\n  }\n  .newJourneyTaxstatus{\n    border: 1px solid #B8C6D1;\n    width: 336px;\n    border-radius: 100px;\n  }\n  .newJourneyTaxstatus select{\n    border-bottom: none !important;\n    border-radius: 100px;\n    padding:6px 12px;\n  }\n  .new-investors .btn-new-journey-color{\n      height: 40px;\n    }\n    .new-investors .kyc-form-container .form-page-container .col-xs-12 .verification-form .pan-input-container .form-control:focus{\n      border: 1px solid #B8C6D1 !important;\n    }</style>");
$templateCache.put("app/new-investors/otp-verification/otp-verification.html","<div class=container-fluid><div class=\"otp-verification row\"><div class=col-xs-12><form class=otp-verification-form ng-submit=OtpVerification.verifyOTP()><div class=\"form-page-header row\"><h4>Step 1</h4></div><div class=\"form-page-container row\"><div class=\"col-xs-12 p-0\"><div class=welcome-message><p><span style=\"font-size: 14px;font-weight: 500\">Hi</span>, {{OtpVerification.userName}}!</p><p>Please verify your contact details</p></div><div class=verification-info><p style=\"font-size: 14px;font-weight: 500\">Verification link & OTP will be sent on the following:</p><div class=verification-info-content><div class=masked_info><img src=assets/images/new-investor/phone_icon.png><h6>{{OtpVerification.mobile}}</h6></div><div class=masked_info><img src=assets/images/new-investor/mail_icon.png><h6>{{OtpVerification.email}}</h6></div></div></div><div class=input-code><label>Enter OTP</label><div class=input-code-container><input type=tel id=otp-number-input-1 class=otp-number-input minlength=1 maxlength=1 autocomplete=off ng-change=OtpVerification.otpValChanged(this) ng-model=OtpVerification.otpVal1 is-number autofocus easyassist-key=mask-element> <input type=tel id=otp-number-input-2 class=otp-number-input minlength=1 maxlength=1 autocomplete=off ng-change=OtpVerification.otpValChanged(this) ng-model=OtpVerification.otpVal2 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-3 class=otp-number-input minlength=1 maxlength=1 autocomplete=off ng-change=OtpVerification.otpValChanged(this) ng-model=OtpVerification.otpVal3 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-4 class=otp-number-input minlength=1 maxlength=1 autocomplete=off ng-change=OtpVerification.otpValChanged(this) ng-model=OtpVerification.otpVal4 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-5 class=otp-number-input minlength=1 tabindex=5 maxlength=1 autocomplete=off ng-change=OtpVerification.otpValChanged(this) ng-model=OtpVerification.otpVal5 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-6 class=otp-number-input minlength=1 maxlength=1 autocomplete=off ng-change=OtpVerification.otpValChanged(this) ng-model=OtpVerification.otpVal6 is-number easyassist-key=mask-element></div><div class=input-controls style=\"align-self: end\"><timer countdown=OtpVerification.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a style=\"color: #337ab7\" href=\"\" ng-click=OtpVerification.reGenerateOtp() ng-class={anchorDisable:Registration.processOTPFlag} ng-show=\"countdown ==0\">Resend OTP</a></span></div></timer></div></div><div><button type=submit class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-disabled=\"OtpVerification.otpCodeLength !== 6\">SUBMIT</button></div></div></div></form></div></div></div><script>// const $inp = $(\".otp-number-input\");\n$(\".otp-number-input\").on({\n  paste(ev) { // Handle Pasting\n\n    const clip = ev.originalEvent.clipboardData.getData(\'text\').trim();\n    // Allow numbers only\n    if (!/\\d{6}/.test(clip)) return ev.preventDefault(); // Invalid. Exit here\n    // Split string to Array or characters\n    const s = [...clip];\n    // Populate inputs. Focus last input.\n    $(\".otp-number-input\").val(i => s[i]).eq(5).focus();\n  },\n  // input(ev) { // Handle typing\n\n  //   const i = $inp.index(this);\n  //   if (this.value) $inp.eq(i + 1).focus();\n  // },\n  // keydown(ev) { // Handle Deleting\n\n  //   const i = $inp.index(this);\n  //   if (!this.value && ev.key === \"Backspace\" && i) $inp.eq(i - 1).focus();\n  // }\n});</script>");
$templateCache.put("app/new-investors/payment/chequeAcknowledge.html","<div><div class=main-success><div class=headersub><!-- <a class=\"gotohome\" href=\"\">\n                <i class=\"home-blue-icon cursor-pointer\"></i>\n                <strong class=\"text-blue cursor-pointer\"> Go To Home</strong>\n            </a> --><div><img src=assets/images/thumbs-succes.png></div><div>Transaction Completed Successfully!</div></div><div class=body-section><div><strong>Payment Summary</strong></div><div><div>Folio Number: <strong>{{NewInvestorPayment.transactionDetails.folioNumber}}</strong></div><div>Payment Method: <strong>{{NewInvestorPayment.transactionDetails.paymentMode}}</strong></div><div>Total Amount (INR): <strong>₹&nbsp;{{NewInvestorPayment.transactionDetails.amount}}</strong></div><div>Bank Name: <strong>{{NewInvestorPayment.transactionDetails.folioBankDetails.bankName}}</strong></div><!-- <div>Transaction Number: <strong>{{NewInvestorPayment.transactionDetails.transactionNo}}</strong></div> --><div>Cheque Number: <strong>{{NewInvestorPayment.transactionDetails.chequeNo}}</strong></div><div>Payment Date: <strong>{{NewInvestorPayment.transactionDetails.transactionDate}}</strong></div></div></div><div class=inner><div><table><thead><tr><th>DIRECT/Distributor/RIA</th><th>Scheme Name</th><th>Amount (INR)</th><th>CAMS Reference Number</th><!-- <th>Sub Transaction Number</th> --></tr></thead><tbody id=tableData><tr><td data-label=DIRECT/Distributor/RIA>{{NewInvestorPayment.transactionDetails.distributorDetails.arnNo}}</td><td data-label=\"Scheme Name\">{{NewInvestorPayment.transactionDetails.schemeName}}</td><td data-label=\"Amount (INR)\">₹&nbsp;{{NewInvestorPayment.transactionDetails.amount}}</td><td data-label=\"CAMS Reference Number\">{{NewInvestorPayment.transactionDetails.camsReferenceNumber}}</td><!-- <td data-label=\"Sub Transaction Number\">{{NewInvestorPayment.transactionDetails.subTransactionNumber}}</td> --></tr></tbody></table></div></div><div class=note-section><span><ins><strong>NOTE:</strong></ins> In case of any queries or concerns related to your transaction, please quote <strong>Transaction number</strong> in your communication. CAMS Reference Number with \'Awaiting\' status indicate that transaction is pending to be processed at CAMS. Kindly do not initiate payment again.</span></div><!-- <div style=\"display: flex;justify-content: center;\">\n            <button class=\"btn\" style=\"padding: 8px;background-color: #244b8c;font-weight: bold;color:#ffff;\" ng-click=\"NewInvestorPayment.gotoprofile()\">Register user ID</p>\n        </div> --></div></div><style type=text/css>body {\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.25;\n    }\n\n    .main-success {\n        width: 80%;\n        margin: auto;\n    }\n    .headersub {\n        text-align: center;\n        display: flex;\n        justify-content: start;\n        align-items: center;\n        background-color: white;\n    }\n    .headersub > div{\n        display: inline-block;\n        font-family: Poppins;\n        font-size: 22px;\n        font-weight: bold;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.36;\n        letter-spacing: normal;\n        text-align: left;\n        color: #4bc4a4;\n        padding: 1%;\n    }\n    .headersub > div:first-of-type {\n        padding-left: 16%;\n    }\n    .headersub img {\n        width: 100%;\n    }\n    .headersub > .gotohome {\n        text-decoration: none;\n        font-family: Poppins;\n    }\n    .headersub > .gotohome > .home-blue-icon{\n        background: url(\"https://investor-web.hdfcfund.com/assets/images/sprite.png\") -169px -387px;\n        width: 20px;\n        height: 18px;\n        display: inline-block;\n    }\n    .headersub > .gotohome > strong.text-blue{\n        font-size: 20px;\n        color: #083280;\n    }\n    .body-section {\n        padding: 3%;\n    }\n    .body-section > div:first-child{\n        font-family: Poppins;\n        font-size: 16px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 0.46;\n        letter-spacing: normal;\n        text-align: center;\n        color: #586065;\n        padding: 2%;\n    }\n    .body-section > div:last-child {\n        border-radius: 3px;\n        background-color: #e8faf4;\n        padding: 1%;\n    }\n    .body-section > div:last-child > div {\n        display: inline-block;\n        padding: 1%;\n        font-size: 12px;\n    }\n    table {\n        border: 1px solid #c6dceb;\n        margin: 0;\n        padding: 10px;\n        width: 100%;\n        table-layout: fixed;\n        border-radius: 5px;\n        border-collapse: separate;\n        border-spacing: 0px 10px;\n    }\n\n    table caption {\n        font-size: 1.5em;\n        margin: .5em 0 .75em;\n    }\n\n    table tr {\n        border: 1px solid #ddd;\n        padding: .35em;\n    }\n\n    table tbody tr {\n        background-color: #eaf5ff;\n    }\n\n    table thead tr th{\n        padding: 1% 1% 1% 1%;\n    }\n\n    table th,\n    table td {\n        padding: .625em;\n        text-align: left;\n        font-size: .85em;\n        line-height: 1.5;\n    }\n\n    table th {\n        font-size: .85em;\n        letter-spacing: normal;\n    }\n\n    .footer {\n        width: 100%;\n        text-align: center;\n        padding: 2%;\n    }\n\n    .footer a {\n        padding: 10px;\n        background-color: #083280;\n        text-decoration: none;\n        border-radius: 5px;\n        /*background-image: linear-gradient(180deg,#0d41a1,#083280),linear-gradient(#6d5cae,#6d5cae);*/\n        box-shadow: 0 1px 10px 0 rgba(17,17,19,.25);\n        border: 1px solid #1f3b71;\n        color: #fff;\n    }\n\n    .headersub1 {\n        background: #0d41a1;\n        z-index: 9;\n        text-align: center;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .note-section {\n        font-size: 14px;\n        background-color: #fef1f2;\n        color: black;\n        padding: 2%;\n        text-align: justify;\n        border-radius: 5px;\n        margin: 2% 0 2% 0;\n    }\n\n    .hiddenState {\n        display: none;\n    }\n\n    @media screen and (max-width: 600px) {\n        .headersub {\n            display: block;\n            padding-top: 5%;\n        }\n        .headersub > .gotohome {\n            display: block;\n        }\n        .headersub > div {\n            text-align: center;\n        }\n        .headersub > div:first-of-type {\n            padding-left: 0px;\n        }\n        .body-section > div:first-child {\n            padding: 10%;\n        }\n        .body-section > div:last-child > div {\n            display: block;\n        }\n        .body-section > div:last-child > div > strong {\n            float: right;\n        }\n        table {\n            border: 0;\n        }\n        table caption {\n            font-size: 1.3em;\n        }\n        table thead {\n            border: none;\n            clip: rect(0 0 0 0);\n            height: 1px;\n            margin: -1px;\n            overflow: hidden;\n            padding: 0;\n            position: absolute;\n            width: 1px;\n        }\n        table tr {\n            border-bottom: 3px solid #ddd;\n            display: block;\n            margin-bottom: .625em;\n        }\n        table td {\n            border-bottom: 1px solid #ddd;\n            display: block;\n            font-size: .8em;\n            text-align: right;\n        }\n        table td::before {\n            content: attr(data-label);\n            float: left;\n            font-weight: bold;\n        }\n        table td:last-child {\n            border-bottom: 0;\n        }\n        .footer a{\n            display: inline-block;\n            margin: 4%;\n        }\n        .note-section {\n            padding: 5%;\n            line-height: 1.5;\n            text-align: left;\n        }\n    }\n    .hidden {\n        display: none;\n    }\n    .show {\n        display: block;\n    }\n    .inner table th{\n        font-weight: 700;\n    }</style>");
$templateCache.put("app/new-investors/payment/new-investor-payment.html","<div class=payment style=\"display: inline\" ng-init=NewInvestorPayment.init() ng-show=!NewInvestorPayment.chequeAcknowledgeSuccess><br><br><!-- FOR SIP WITH NO 1st INSTALLMENT --><div class=main ng-if=\"NewInvestorPayment.onlySipInvestment && !NewInvestorPayment.showSummary\" style=\"box-shadow: -1px 1px 5px 1px lightgrey\"><div style=\"padding: 50px;margin: inherit\"><div style=\"padding: 10px\"><p style=\"font-weight: bold;margin-left: 10px\">Investment Summary</p><br></div><div class=\"seocndrow row\" style=\"padding: 10px\"><div class=\"col-xs-12 col-md-6 informationData\"><!-- folio number --><div class=row><div class=\"col-xs-5 col-md-5\"><p>Folio Number</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.folioNumber}}</p></div></div><br><!-- Transaction --><div class=row><div class=\"col-xs-5 col-md-5\"><p>Transaction Type</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.investmentType}}</p></div></div><br><!-- Scheme Name --><div class=row><div class=\"col-xs-5 col-md-5\"><p>Scheme Name</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.fundName}}</p></div></div><br><!-- Investment Option --><div class=row><div class=\"col-xs-5 col-md-5\"><p>Investment Option</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'GROWTH\' \"><p class=font-weight-bold>{{NewInvestorPayment.formData.investmentOption}}</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\' \"><!-- <p class=\"font-weight-bold\">{{NewInvestorPayment.formData.investmentOption}}</p> --><p class=font-weight-bold>Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><!-- <div class=\"col-xs-5 col-md-6\" ng-If=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'Y\' \">\n                            <p class=\"font-weight-bold\">Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</p>\n                        </div>\n                        <div class=\"col-xs-5 col-md-6\" ng-If=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'N\' \">\n                            <p class=\"font-weight-bold\">Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</p>\n                        </div> --></div><br><!-- IDWC --><div class=row ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\'\"><div class=\"col-xs-5 col-md-5\"><p>Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.dividendOption == \'Y\' \"><p class=font-weight-bold>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.dividendOption == \'N\' \"><p class=font-weight-bold>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><br><!-- Amount --><div class=row><div class=\"col-xs-5 col-md-5\"><p>Amount</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold><img src=../../../../assets/images/rupee.svg alt=\"\" srcset=\"\"> {{NewInvestorPayment.formData.amount}}</p></div></div><br><div class=row><div class=\"col-xs-5 col-md-5\"><p>Investment Start Date</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.installmentStartDate}}</p></div></div><br><div class=row><div class=\"col-xs-5 col-md-5\"><p>Investment End Date</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.installmentEndDate}}</p></div></div><br><div class=row ng-if=\"NewInvestorPayment.formData.paymentOption === \'UAP\'\"><div class=\"col-xs-5 col-md-5\"><p>Payment Option</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>UPI Autopay</p></div></div><br><div class=row ng-if=\"NewInvestorPayment.formData.paymentOption === \'UAP\'\"><div class=\"col-xs-5 col-md-5\"><p>Virtual Payment Address (UPI ID)</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.payerVpa}}</p></div></div><br><div class=row ng-if=\"NewInvestorPayment.formData.paymentOption === \'UAP\'\"><div class=\"col-xs-5 col-md-5\"><p>Bank Name</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.bankName}}</p></div></div><br></div><div class=\"col-xs-12 col-md-6\"><div class=row><div class=\"col-xs-5 col-md-5\"><p>Frequency</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p style=\"font-size: 14px;color: #000000;font-weight: 600\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'OM\'\">Monthly</p><p style=\"font-size: 14px;color: #000000;font-weight: 600\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'Q\'\">Quaterly</p><p style=\"font-size: 14px;color: #000000;font-weight: 600\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'H\'\">Half Yearly</p><p style=\"font-size: 14px;color: #000000;font-weight: 600\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'Y\'\">Yearly</p></div></div><br><div class=row><div class=\"col-xs-5 col-md-5\"><p>Bank Name</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p style=\"font-weight: 600;color: #000000;font-size: 14px;word-break: break-all\">{{NewInvestorPayment.formData.bankInfo.bankNameOnly}}</p></div></div><br><div class=row><div class=\"col-xs-5 col-md-5\"><p>Email</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p style=\"font-weight: 600;color: #000000;font-size: 14px;word-break: break-all\">{{NewInvestorPayment.formData.maskedEmail}}</p></div></div><br><div class=row><div class=\"col-xs-5 col-md-5\"><p>mobile Number</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p style=\"font-size: 14px;font-weight: 600;color: #000000\">{{NewInvestorPayment.formData.maskedMobile}}</p></div></div><br></div></div><p style=\"font-weight: bold;margin-left: 10px;padding: 10px\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</p><br><div class=lessPadding><div class=tc-block><h6>Terms & Conditions</h6><div style=\"margin: 20px 0px 0px 0px\"><div class=checkbox><input id=isCheckedTandC ng-model=NewInvestorPayment.onlySipSummary type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=NewInvestorPayment.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div></div></div><div class=\"col-xs-12 col-md-12\"><input type=hidden id=hfReq><div><!-- <span ng-click=\"NewInvestorPayment.goToBack()\" class=\"cursor-pointer text-primary\"><i\n                          class=\"arrow-blue-back-icon\"></i>Back</span> --> <button ng-disabled=!NewInvestorPayment.onlySipSummary||!NewInvestorPayment.formData ng-click=NewInvestorPayment.transactionOtpConfirmation() class=\"btn-primary-action-pay btn pull-right\" style=\"border-radius: 40PX\">COMPLETE TRANSACTION</button></div></div></div></div></div><!-- Manual instuction --><div class=main ng-if=\"NewInvestorPayment.onlySipInvestment && NewInvestorPayment.showSummary\" style=\"background-color: white;box-shadow: -1px 1px 5px 1px lightgrey\"><!-- <div class=\"modal-body1\">\n            <h6 class=\"text-uppercase d-padding\"><span>Dear</span> {{NewInvestorPayment.userFllName}}</h6>\n            <br>\n            <p class=\"d-padding\">Thankyou for providing bank details. Please add HDFC Mutual Fund as a biller to your bank account </p>\n            <br>\n            <p>SRN No. for your SIP: <span>{{NewInvestorPayment.srnNo}}</span>\n                <a ng-if=\"NewInvestorPayment.sipBankData[0].netBankingUrl\"  ng-href=\"https://{{NewInvestorPayment.sipBankData[0].netBankingUrl}}\" target=\"_blank\" style=\"color: #2485bd\">\n                    Please click here for SRN registration</a>\n            </p>\n            <br>\n            <p class=\"d-padding\"><strong>Here is how you can quickly register HDFC Mutual Fund as a biller to your net banking\n                    account</strong></p>\n            <br>\n            <p class=\"d-padding\">In order to complete SIP registration, investor should either click on the \"Register SIP with bank\"\n                button\n                or log on to his/her registered banking net banking facility and register for auto debit instruction for\n                SIP\n                installment. We recommend investors to select the auto payment option.</p>\n                <br>\n            <ol style=\"line-height: 20px;list-style-type: none;\" class=\"d-padding\">\n                <li>a.Please select HDFC Mutual Fund as biller.</li>\n                <li>b.Please input the SIP Registration Number (SRN) in the field requesting the Biller Reference Number.\n                </li>\n                <li>c.Please complete your SIP registration with your bank within 1 day from today. The SRN will be\n                    invalid\n                    if the registration on your bank\'s website is not completed within the specified period.\n                </li>\n                <li>d.If the SIP registration with your bank is not completed by you, units created in your folio for the\n                    aforesaid SIP, if any, will be reversed.\n                </li>\n                <li>e.Investors will not hold HDFC Mutual Fund / HDFC Asset Management Company Limited, its registrars and\n                    other service providers responsible if the transaction is delayed or not effected or the Investor\'s\n                    bank\n                    account is debited in advance or after the spoecific SIP date due to local holidays or any other\n                    reason.\n                </li>\n            </ol>\n            <div class=\"text-center\">\n                <button  style=\"padding: 10px 25px 10px 25px;\n                border: none;\n                height: 40px;\n                box-shadow: 0px 1px 10px 0 rgb(17 17 19 / 25%);\n                color: #fff;\n                background-color: #FF8486;\n                border-radius: 40px;\"\n                ng-click=\"NewInvestorPayment.gotoprofile()\"> Proceed with Registration</button>\n            </div>\n        </div> --><div class=\"note col-sm-12 col-md-12\" style=\"margin: auto;padding: 15px 0px 30px 0px\"><img src=../../../assets/images/congratulation.png alt=\"\" style=\"height: 50px; margin-top: 5px\"><p style=\"font-size: large; font-weight: bold;color: #0d41a1;margin: 15px 0px 0px 0px\">Transaction Completed Successfully!</p></div><div class=row style=\"margin-top: 50px;width: 98%\"><!-- <div class=\"col-md-4\">\n                <div  style=\"padding: 30px 0px 10px 30px;\">\n                    <p style=\"font-weight: 600;\">SIP First Installment Payment Summary</p>\n                <div class=\"row p-short\">\n                    <div class=\"col-md-6\">Payment Mode</div>\n                    <div class=\"col-md-1\">:</div>\n                    <div class=\"col-md-5\"><p style=\"font-size: 12px;font-weight: bold;\"> Net Banking</p></div>\n                </div>\n                <div class=\"row p-short\">\n                    <div class=\"col-md-6\">Amount</div>\n                    <div class=\"col-md-1\">:</div>\n                    <div class=\"col-md-5\"><p style=\"font-size: 12px;font-weight: bold;\"> 5,00,000</p></div>\n                </div>\n                <div class=\"row p-short\">\n                    <div class=\"col-md-6\">Payment Date</div>\n                    <div class=\"col-md-1\">:</div>\n                    <div class=\"col-md-5\"><p style=\"font-size: 12px;font-weight: bold;\">03-03-2022</p> </div>\n                </div>\n                <div class=\"row p-short\">\n                    <div class=\"col-md-6\">folio Number</div>\n                    <div class=\"col-md-1\">:</div>\n                    <div class=\"col-md-5\"><p style=\"font-size: 12px;font-weight: bold;\">123456</p> </div>\n                </div>\n                <div class=\"row p-short\">\n                    <div class=\"col-md-6\">Transaction Number</div>\n                    <div class=\"col-md-1\">:</div>\n                    <div class=\"col-md-5\"><p style=\"font-size: 12px;font-weight: bold;\">9875678</p> </div>\n                </div>\n                <div class=\"row p-short\">\n                    <div class=\"col-md-6\">Bank Name</div>\n                    <div class=\"col-md-1\">:</div>\n                    <div class=\"col-md-5\"><p style=\"font-size: 12px;font-weight: bold;\">HDFC</p> </div>\n                </div>\n                <div class=\"row p-short\">\n                    <div class=\"col-md-6\">Transaction Type</div>\n                    <div class=\"col-md-1\">:</div>\n                    <div class=\"col-md-5\"><p style=\"font-size: 12px;font-weight: bold;\"> Transaction Type</p></div>\n                </div>\n                </div>\n            </div>  --><div class=\"boxdiv col-md-12\" style=\"border: 1px solid gray;border-radius: 8px;padding: 10px;margin-left: 5%;width: 96%\"><div class=sipseconddiv><p style=\"font-weight: 600\">SIP Registration Summary</p><br><br><div class=row><div class=col-md-6><!-- <div class=\"row p-short\">\n                                <div class=\"col-md-7\">Payment Mode</div>\n                                <div class=\"col-md-1\">:</div>\n                                <div class=\"col-md-4\"><p style=\"font-weight: 500;\">Net Banking</p> </div>\n                            </div> --><div class=\"row p-short\"><div class=col-md-7>SIP Registration Number</div><div class=col-md-1>:</div><div class=col-md-4><p style=\"font-weight: 500\">{{NewInvestorPayment.srnNo}}</p></div></div><div class=\"row p-short\"><div class=col-md-7>Bank Name</div><div class=col-md-1>:</div><div class=col-md-4><p style=\"font-weight: 500\">{{NewInvestorPayment.formData.bankInfo.bankNameOnly}}</p></div></div><!-- <div class=\"row p-short\">\n                                <div class=\"col-md-7\">CAMS Reference Number</div>\n                                <div class=\"col-md-1\">:</div>\n                                <div class=\"col-md-4\"><p style=\"font-weight: 500;\">{{}}</p> </div>\n                            </div> --><div class=\"row p-short\"><div class=col-md-7>Source Scheme Name</div><div class=col-md-1>:</div><div class=col-md-4><p style=\"font-weight: 500\">{{NewInvestorPayment.formData.schemeName}}</p></div></div><div class=\"row p-short\"><div class=col-md-7>Investment Option</div><div class=col-md-1>:</div><div class=col-md-4 ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'GROWTH\' \"><p style=\"font-weight: 500\">{{NewInvestorPayment.formData.investmentOption}}</p></div><div class=col-md-4 ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\' \"><p style=\"font-weight: 500\">Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><!-- IDWC --><div class=\"row p-short\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\'\"><div class=col-md-7>Income Distribution cum Capital Withdrawal (IDCW) Option</div><div class=col-md-1>:</div><div class=col-md-4 ng-if=\"NewInvestorPayment.formData.dividendOption == \'Y\' \"><p style=\"font-weight: 500\">Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><div class=col-md-4 ng-if=\"NewInvestorPayment.formData.dividendOption == \'N\' \"><p style=\"font-weight: 500\">Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><br><!-- <div class=\"row p-short\">\n                                <div class=\"col-md-7\">UMRN No</div>\n                                <div class=\"col-md-1\">:</div>\n                                <div class=\"col-md-4\"><p style=\"font-weight: 500;\">5665653</p> </div>\n                            </div>             --></div><div class=col-md-6><!-- <div class=\"row p-short\">\n                                <div class=\"col-md-7\">IDCW Option</div>\n                                <div class=\"col-md-1\">:</div>\n                                <div class=\"col-md-4\"><p style=\"font-weight: 500;\">Option</p> </div>\n                            </div> --><div class=\"row p-short\"><div class=col-md-7>SIP Installment Amount</div><div class=col-md-1>:</div><div class=col-md-4><p style=\"font-weight: 500\">{{NewInvestorPayment.formData.amount}}</p></div></div><div class=\"row p-short\"><div class=col-md-7>SIP Frequency</div><div class=col-md-1>:</div><div class=col-md-4><p style=\"font-weight: 500\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'OM\'\">Monthly</p><p style=\"font-weight: 500\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'Q\'\">Quarterly</p><p style=\"font-weight: 500\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'H\'\">Half Yearly</p><p style=\"font-weight: 500\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'Y\'\">Yearly</p></div></div><!-- <div class=\"row p-short\">\n                                <div class=\"col-md-7\">No of installments</div>\n                                <div class=\"col-md-1\">:</div>\n                                <div class=\"col-md-4\"><p style=\"font-weight: 500;\">10</p> </div>\n                            </div> --><!-- <div class=\"row p-short\">\n                                <div class=\"col-md-7\">SIP term</div>\n                                <div class=\"col-md-1\">:</div>\n                                <div class=\"col-md-4\"><p style=\"font-weight: 500;\">Term</p> </div>\n                            </div> --><div class=\"row p-short\"><div class=col-md-7>Transaction Initiate Date</div><div class=col-md-1>:</div><div class=col-md-4><p style=\"font-weight: 500\">{{NewInvestorPayment.SIPtransactionInitiateDate}}</p></div></div></div></div></div></div></div><br><div style=\"padding: 30px 0px 10px 40px\" ng-if=\"NewInvestorPayment.formData && !NewInvestorPayment.formData.sipFI && NewInvestorPayment.formData.topUpEnable\"><p style=\"padding: 10px 0px 10px 0px;font-weight: 600;font-size: 12px\">SIP Top up Details</p><div class=row><div class=col-md-2><p style=\"font-size: 11px\" ng-if=\"NewInvestorPayment.formData.topUpDetails.frequency == \'OM\'\">SIP Top up Frequency : Monthly</p><p style=\"font-size: 11px\" ng-if=\"NewInvestorPayment.formData.topUpDetails.frequency == \'Y\'\">SIP Top up Frequency : Yearly</p><p style=\"font-size: 11px\" ng-if=\"NewInvestorPayment.formData.topUpDetails.frequency == \'H\'\">SIP Top up Frequency : Half Yearly</p></div><div class=col-md-5><p style=\"font-size: 11px\">SIP Top up Cap Amount/SIP Top up Cap Month & Year : {{NewInvestorPayment.formData.topUpDetails.capAmount ? NewInvestorPayment.formData.topUpDetails.capAmount: NewInvestorPayment.formData.topUpDetails.capMonthYear}}</p></div><div class=col-md-5><!--                    <p style=\"font-size: 11px;\">SIP Top up Cap Amount/SIP Top up Percentage : {{NewInvestorPayment.formData.topUpDetails.amount ? NewInvestorPayment.formData.topUpDetails.amount : NewInvestorPayment.formData.topUpDetails.percentage}}.00</p>--><p style=\"font-size: 11px\">SIP Top up Cap Amount : {{NewInvestorPayment.formData.topUpDetails.amount}}.00</p></div></div></div><br><div class=text-center><button style=\"padding: 10px 25px 10px 25px;\n            border: none;\n            height: 40px;\n            box-shadow: 0px 1px 10px 0 rgb(17 17 19 / 25%);\n            color: #fff;\n            background-color: #FF8486;\n            border-radius: 40px\" ng-click=NewInvestorPayment.gotoprofile() ng-hide=NewInvestorPayment.disableUserButton>Proceed with Registration</button> <button style=\"padding: 10px 25px 10px 25px;\n            border: none;\n            height: 40px;\n            box-shadow: 0px 1px 10px 0 rgb(17 17 19 / 25%);\n            color: #fff;\n            background-color: #FF8486;\n            border-radius: 40px; margin-top: 20px\" ng-click=NewInvestorPayment.gotoLogin() ng-show=NewInvestorPayment.disableUserButton>Proceed to Login</button></div><!-- SIP top up details --><br><br></div><!-- summary for RTGS / HDFC --><div class=main ng-if=NewInvestorPayment.showTransactionSummaryForRTGSorHDFC style=\"box-shadow: -1px 1px 5px 1px lightgrey\"><div class=row><div class=col-md-6 style=\"padding: 30px;border-right: 1px solid #B8C6D1\"><div class=row style=\"padding: 10px\"><div class=col-md-5><p>Folio Number</p></div><div class=col-md-1><p>:</p></div><div class=col-md-6><p>{{NewInvestorPayment.formData.folioNumber}}</p></div></div><div class=row style=\"padding: 10px\"><div class=col-md-5><p>CAMS Reference No.</p></div><div class=col-md-1><p>:</p></div><div class=col-md-6><p>{{NewInvestorPayment.transactionDetails.camsReferenceNumber}}</p></div></div><div class=row style=\"padding: 10px\"><div class=col-md-5><p>Transaction Type</p></div><div class=col-md-1><p>:</p></div><div class=col-md-6><p>{{NewInvestorPayment.formData.investmentType}}</p></div></div><div class=row style=\"padding: 10px\"><div class=col-md-5><p>Scheme Name</p></div><div class=col-md-1><p>:</p></div><div class=col-md-6><p>{{NewInvestorPayment.formData.fundName}}</p></div></div><div class=row style=\"padding: 10px\"><div class=col-md-5><p>Amount</p></div><div class=col-md-1><p>:</p></div><div class=col-md-6><p><img class=ricon src=../../../../assets/images/rupee.svg alt=\"\" srcset=\"\"> {{NewInvestorPayment.formData.amount}}</p></div></div></div><div class=col-md-6 style=\"padding: 30px\"><div style=\"display: flex;\n                justify-content: center;\n                flex-direction: column;\n                align-items: center;\n                margin: 50px 0px 0px 0px\"><img src=../../../assets/images/icons/verified.png alt=\"\" srcset=\"\"><p style=\"padding: 10px;color: darkgreen\">Transaction Successfully</p><p style=\"padding: 10px;color: #244b8c;font-weight: bold\" ng-click=NewInvestorPayment.gotoprofile() ng-hide=NewInvestorPayment.disableUserButton>Register user ID</p><button style=\"padding: 10px 25px 10px 25px;\n                        border: none;\n                        height: 40px;\n                        box-shadow: 0px 1px 10px 0 rgb(17 17 19 / 25%);\n                        color: #fff;\n                        background-color: #FF8486;\n                        border-radius: 40px; margin-top: 20px\" ng-click=NewInvestorPayment.gotoLogin() ng-show=NewInvestorPayment.disableUserButton>Proceed to Login</button></div></div></div></div><!-- SIP 1st Installment or Purchase --><div class=main ng-if=\"!NewInvestorPayment.onlySipInvestment  && !NewInvestorPayment.showTransactionSummaryForRTGSorHDFC\" style=\"box-shadow: -1px 1px 5px 1px lightgrey\"><div class=row><div class=\"note col-sm-12 col-md-12\" style=\"margin: auto\"><img src=../../../assets/images/congratulation.png alt=\"\" style=\"height: 50px; margin-top: 5px\"><p style=\"font: normal normal 600 18px/30px Poppins;\n                letter-spacing: 0px;\n                color: #000000\">Congratulations {{NewInvestorPayment.userName}}!</p><br><p style=\"font: normal normal normal 16px/30px Poppins;\n                letter-spacing: 0px;\n                color: #000000\">Complete your first payment to start investing!</p></div></div><br><br><!--  --><div class=\"seocndrow row\"><div class=\"col-xs-12 col-md-5 informationData\"><p style=\"font-weight: bold\">Investment Summary</p><br><!-- folio number --><div class=row><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Folio Number</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.folioNumber}}</p></div></div><br><!-- Transaction --><div class=row><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Transaction Type</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.investmentType}}</p></div></div><br><!-- Scheme Name --><div class=row><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Scheme Name</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.fundName}}</p></div></div><br><!-- Investment Option --><div class=row><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Investment Option</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'GROWTH\' \"><p class=font-weight-bold>{{NewInvestorPayment.formData.investmentOption}}</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\' \"><!-- <p class=\"font-weight-bold\">{{NewInvestorPayment.formData.investmentOption}}</p> --><p class=font-weight-bold>Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><!-- <div class=\"col-xs-5 col-md-6\" ng-If=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'Y\' \">\n                                <p class=\"font-weight-bold\">Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</p>\n                            </div>\n                            <div class=\"col-xs-5 col-md-6\" ng-If=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'N\' \">\n                                <p class=\"font-weight-bold\">Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</p>\n                            </div>  --></div><br><!-- IDWC --><div class=row ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\'\"><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.dividendOption == \'Y\' \"><p class=font-weight-bold>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.dividendOption == \'N\' \"><p class=font-weight-bold>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><br><!-- Amount --><div class=row><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Amount</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold><img src=../../../../assets/images/rupee.svg alt=\"\" srcset=\"\"> {{NewInvestorPayment.formData.amount}}</p></div></div><br><div class=row ng-if=\"NewInvestorPayment.formData.paymentOption === \'UAP\'\"><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Payment Option</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>UPI Autopay</p></div></div><br><div class=row ng-if=\"NewInvestorPayment.formData.paymentOption === \'UAP\'\"><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Virtual Payment Address (UPI ID)</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.payerVpa}}</p></div></div><br><div class=row ng-if=\"NewInvestorPayment.formData.paymentOption === \'UAP\'\"><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Bank Name</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.bankName}}</p></div></div><br></div><div class=\"col-xs-12 col-md-7 paymentmodeData\"><p class=paymentmodetitle>Payment Mode</p><br><div class=\"bankCard row\"><div class=\"desktopMode col-xs-12 col-md-4\"><div ng-if=\"NewInvestorPayment.formData.paymentOption !== \'UAP\'\" ng-attr-class=\"{{NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\' ? \'menu2 row\' : \'menu row\'}}\" style=\"border-top-left-radius: 10px\"><div class=\"col-sm-12 col-md-12\"><p ng-click=\"NewInvestorPayment.getPaymenMode(\'NETBANKING\')\" ng-attr-class=\"{{ NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\' ? \'c-pink\' : \'c-blue\'}}\">Net Banking</p></div></div><div ng-if=\"!NewInvestorPayment.sipFirstInstallmentVisible && !NewInvestorPayment.distributorDetails.isHdfcBank\" ng-attr-class=\"{{NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' ? \'menu2 row\' : \'menu row\'}}\"><div class=\"col-sm-12 col-md-12\"><p ng-click=\"NewInvestorPayment.getPaymenMode(\'RTGS\')\" ng-attr-class=\"{{ NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' ? \'c-pink\' : \'c-blue\'}}\">NEFT/RTGS</p></div></div><!-- <div ng-if=\"!NewInvestorPayment.sipFirstInstallmentVisible\"\n                            ng-attr-class=\"{{NewInvestorPayment.formData.purchasePaymentOption == \'HDFC\' ? \'menu2 row\' : \'menu row\'}}\">\n                            <div class=\"col-sm-12 col-md-12\">\n                                <p ng-click=\"NewInvestorPayment.getPaymenMode(\'HDFC\')\"\n                                ng-attr-class=\"{{ NewInvestorPayment.formData.purchasePaymentOption == \'HDFC\' ? \'c-pink\' : \'c-blue\'}}\">\n                                HDFC Fund Transfer\n                                </p>\n                            </div>\n                        </div> --><div ng-if=\"!NewInvestorPayment.sipFirstInstallmentVisible && !NewInvestorPayment.distributorDetails.isHdfcBank\" ng-attr-class=\"{{NewInvestorPayment.formData.purchasePaymentOption == \'UPI\' ? \'menu2 row\' : \'menu row\'}}\" style=\"border-bottom-left-radius: 10px;border-bottom: none\"><div class=\"col-sm-12 col-md-12\"><p ng-click=\"NewInvestorPayment.getPaymenMode(\'UPI\')\" ng-attr-class=\"{{ NewInvestorPayment.formData.purchasePaymentOption == \'UPI\' ? \'c-pink\' : \'c-blue\'}}\">UPI</p></div></div><div ng-if=\"NewInvestorPayment.formData.investmentType == \'Purchase\' && NewInvestorPayment.distributorDetails && NewInvestorPayment.distributorDetails.isHdfcBank\" ng-attr-class=\"{{NewInvestorPayment.formData.purchasePaymentOption == \'Q\' ? \'menu2 row\' : \'menu row\'}}\"><div class=\"col-sm-12 col-md-12\"><p ng-click=\"NewInvestorPayment.getPaymenMode(\'Q\')\" ng-attr-class=\"{{ NewInvestorPayment.formData.purchasePaymentOption == \'Q\' ? \'c-pink\' : \'c-blue\'}}\">Cheque</p></div></div><div ng-if=\"NewInvestorPayment.sipFirstInstallmentVisible && NewInvestorPayment.formData.paymentOption == \'UAP\'\" ng-attr-class=\"{{NewInvestorPayment.formData.purchasePaymentOption == \'UPI\' ? \'menu2 row\' : \'menu row\'}}\" style=\"border-bottom-left-radius: 10px;border-bottom: none\"><div class=\"col-sm-12 col-md-12\"><p ng-click=\"NewInvestorPayment.getPaymenMode(\'UPI\')\" ng-attr-class=\"{{ NewInvestorPayment.formData.purchasePaymentOption == \'UPI\' ? \'c-pink\' : \'c-blue\'}}\">UPI Autopay</p></div></div></div><!-- for mobile --><div class=\"mobileMode col-xs-12 col-md-8\"><p style=\"font-size: 18px;font-weight: bold;line-height: 26px;margin-bottom: 14px\">Select payment option to make your first investment</p><p style=\"font-size: 18px;font-weight: bold;line-height: 26px;margin-bottom: 14px\">Payment Mode</p><form name=getGetPaymentMode><select class=\"form-control selectNormal\" name=paymentMode id=paymentMode ng-model=NewInvestorPayment.formData.purchasePaymentOption style=\"margin-top: 10px;margin-bottom: 10px\"><option ng-selected=\"NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\'\" ng-if=\"NewInvestorPayment.formData.paymentOption !== \'UAP\'\" value=NETBANKING>Net Banking</option><option ng-if=!NewInvestorPayment.sipFirstInstallmentVisible ng-selected=\"NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' \" value=RTGS>NEFT/RTGS</option><!-- <option ng-if=\"!NewInvestorPayment.sipFirstInstallmentVisible\"\n                                    ng-selected=\"NewInvestorPayment.formData.purchasePaymentOption == \'HDFC\' \"\n                                    value=\"HDFC\">HDFC Fund Transfer</option> --><option ng-if=\"!NewInvestorPayment.sipFirstInstallmentVisible && !NewInvestorPayment.distributorDetails.isHdfcBank\" ng-selected=\"NewInvestorPayment.formData.purchasePaymentOption == \'UPI\' \" value=UPI>UPI</option><option ng-if=\"NewInvestorPayment.formData.investmentType == \'Purchase\' && NewInvestorPayment.distributorDetails && NewInvestorPayment.distributorDetails.isHdfcBank\" ng-selected=\"NewInvestorPayment.formData.purchasePaymentOption == \'Q\' \" value=Cheque>Cheque</option><!--for sip upi--><option ng-if=\"NewInvestorPayment.sipFirstInstallmentVisible && NewInvestorPayment.formData.paymentOption == \'UAP\'\" ng-selected=\"NewInvestorPayment.formData.purchasePaymentOption == \'UPI\' \" value=UPI>UPI Autopay</option></select></form></div><div class=\"col-xs-12 col-md-8\"><!-- Net Banking --><div ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\'\" style=\"margin-bottom: 20px\"><p style=\"margin: 20px 0px 5px -8px;font: normal normal bold 11px/14px Poppins;\n                            letter-spacing: 0px;\n                            color: #000000;\n                            opacity: 1\">Select Bank</p><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:rtgsFormData.bank.$dirty&&tForm.bank.$invalid}><input type=\"text inputPayment\" class=form-control name=bank id=bank ng-model=NewInvestorPayment.formData.paymentInfo.bankName autocomplete=off ng-required=!NewInvestorPayment.formData.paymentInfo only-alphabets style=\"border: none;border: 1px solid gray;height: 40px;border-radius: 5px\" easyassist-key=mask-element> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=rtgsFormData.bank.$dirty&&rtgsFormData.bank.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=NewInvestorPayment.netBankingAndUPIList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=NewInvestorPayment.changeBank() model=NewInvestorPayment.formData.paymentInfo for=bank easyassist-key=mask-element></bank-drop-down></div></div><!-- NEFT/RTGS --><div ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\'\"><div><br><p>{{NewInvestorPayment.PATTERN.RTGS_MESSAGE}}</p><br><div style=\"display: flex\" class=neft-form-switch><!--                                    <p ng-attr-class=\"{{NewInvestorPayment.rtgsBankTogg ? \'\':\'f-bold\'}}\">No</p>--><!--                                    <input type=\"checkbox\" id=\"switch\" style=\"margin-right: 10px;\"--><!--                                        ng-click=\"NewInvestorPayment.selectRtgsBank()\"--><!--                                        ng-checked=\"NewInvestorPayment.rtgsBankTogg\" />--><!--                                    <label class=\"switchlablePay\" for=\"switch\" ng-checked=\"NewInvestorPayment.rtgsBankTogg\"--><!--                                        style=\"margin-right: 10px;\"></label>--><!--                                        <p ng-attr-class=\"{{NewInvestorPayment.rtgsBankTogg ? \'f-bold\':\'\'}}\">Yes</p>--> <span style=\"margin-left: 10px; margin-right: 10px\" class=toggle-login-text ng-class=\"{\'login-active-tab\': NewInvestorPayment.rtgsBankTogg}\">Yes</span><label class=switch><input type=checkbox ng-model=NewInvestorPayment.rtgsBankTogg ng-click=NewInvestorPayment.selectRtgsBank() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label><span style=\"margin-left: 10px; margin-right: 10px\" class=toggle-login-text ng-class=\"{\'login-active-tab\': !NewInvestorPayment.rtgsBankTogg}\">No</span></div></div><form name=rtgsFormData1><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:rtgsFormData.bank.$dirty&&tForm.bank.$invalid} ng-if=NewInvestorPayment.rtgsBankTogg><p style=\"font-weight: bold;margin: 10px\">Select Bank</p><input type=text class=\"form-control inputPayment\" name=bank id=bank ng-model=NewInvestorPayment.formData.paymentInfo.bankNameWithAccountNumber autocomplete=off ng-required=!NewInvestorPayment.formData.paymentInfo only-alphabets easyassist-key=mask-element> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=rtgsFormData.bank.$dirty&&rtgsFormData.bank.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=NewInvestorPayment.netBankingAndUPIList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=NewInvestorPayment.changeBank() model=NewInvestorPayment.bankInfo for=bank easyassist-key=mask-element></bank-drop-down></div><!-- Account Type --><!--                                <div class=\"row\" ng-If=\"!NewInvestorPayment.formData.paymentInfo.bankAcType\">--><!--                                    <div class=\"col-xs-12 col-md-12\">--><!--                                        <p class=\"investmentTitle\">Account Type</p>--><!--                                    </div>--><!--                                    <div class=\"col-xs-12 col-md-12\">--><!--                                        <select id=\"accountType\" name=\"accountType\" class=\"form-control selectNormal\"--><!--                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.accType\" required>--><!--                                            <option value selected=\"selected\">Select</option>--><!--                                            <option ng-repeat=\"value in NewInvestorPayment.bankAccountType\"--><!--                                                ng-selected=\"NewInvestorPayment.bankAccountDetailsForm.accountType == value.accountTypeCode\"--><!--                                                value=\"{{value.accountTypeCode}}\">{{value.accountType}}</option>--><!--                                        </select>--><!--                                    </div>--><!--                                </div>--><!-- IFSC/NEFT Code --><!--                                 <div class=\"row\" ng-If=\"!NewInvestorPayment.formData.paymentInfo.ifscCode\">--><!--                                    <div class=\"col-md-12\">--><!--                                        <p class=\"paymentTitle\">IFSC/NEFT Code</p>--><!--                                    </div>--><!--                                    <div class=\"col-md-12\">--><!--                                        <input type=\"text\" class=\"form-control inputPayment\"--><!--                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.ifscCode\"--><!--                                            name=\"ifscCode\" required ng-pattern=\"NewInvestorPayment.IFSC_REGEX\"--><!--                                            capitalize>--><!--                                        <span class=\"error-input\"--><!--                                            ng-show=\"rtgsFormData.ifscCode.$dirty&&rtgsFormData.ifscCode.$error.required\"--><!--                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.IFSC_CODE_FIELD\"></span>--><!--                                        <span class=\"error-input\"--><!--                                            ng-show=\"rtgsFormData.ifscCode.$dirty&&rtgsFormData.ifscCode.$error.pattern\"--><!--                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.IFSC_CODE_REGEX\"></span>--><!--                                    </div>--><!--                                </div>--><!--                                <div class=\"row\">--><!--                                    <div class=\"col-md-6\">--><!--                                        <p class=\"paymentTitle\">UTR Number</p>--><!--                                        <input type=\"text\" class=\"form-control inputPayment\" name=\"utrNumber\"--><!--                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.utrNumber\"--><!--                                            ng-pattern=\"NewInvestorPayment.PATTERN.UTR_REGEX\" ng-maxlength=\"255\"--><!--                                            required>--><!--                                        <span class=\"error-input\"--><!--                                            ng-show=\"rtgsFormData1.utrNumber.$dirty&&rtgsFormData1.utrNumber.$error.required\"--><!--                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.UTR_REQUIRED\"></span>--><!--                                        <span class=\"error-input\"--><!--                                            ng-show=\"rtgsFormData1.utrNumber.$dirty&&rtgsFormData1.utrNumber.$error.pattern\"--><!--                                            class=\"help-block\"--><!--                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.UTR_RANGE\"></span>--><!--                                        <span class=\"error-input\"--><!--                                            ng-show=\"rtgsForm.utrNumber.$dirty&&rtgsForm.utrNumber.$error.maxlength\"--><!--                                            class=\"help-block\"--><!--                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.UTR_INVALID\"></span>--><!--                                    </div>--><!--                                    <div class=\"col-md-6\">--><!--                                        <p class=\"paymentTitle\">Vefity UTR Number</p>--><!--                                        <input type=\"text\" class=\"form-control inputPayment\" name=\"verifyUtrNumber\"--><!--                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.verifyUtrNumber\"--><!--                                            ng-pattern=\"NewInvestorPayment.formData.paymentInfo.utrNumber\" required>--><!--                                        <span class=\"error-input\"--><!--                                            ng-show=\"rtgsFormData1.verifyUtrNumber.$dirty&&rtgsFormData1.verifyUtrNumber.$error.required\"--><!--                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.UTR_REQUIRED\"></span>--><!--                                        <span class=\"error-input\"--><!--                                            ng-show=\"rtgsFormData1.verifyUtrNumber.$dirty&&rtgsFormData1.verifyUtrNumber.$error.pattern\"--><!--                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.SAME_UTR_REQUIRED\"></span>--><!--                                    </div>--><!--                                </div>--><br><br></form><form name=rtgsFormData><div ng-init=NewInvestorPayment.setFormDataForNeft(rtgsFormData) ng-hide=\"(NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' && NewInvestorPayment.rtgsBankTogg && !NewInvestorPayment.bankInfo)\"><!--(NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' && NewInvestorPayment.rtgsBankTogg && NewInvestorPayment.formData.paymentInfo && NewInvestorPayment.formData.paymentInfo.tpvEnableFlag == \'N\') || --><!-- bank name --><div class=row><div class=col-md-12><p class=paymentTitle>Bank name</p></div><div class=col-md-12><input type=text class=\"form-control inputPayment\" ng-model=NewInvestorPayment.formData.paymentInfo.bankName name=bankName only-alphabets required ng-readonly=NewInvestorPayment.rtgsBankTogg> <span class=error-input ng-show=\"rtgsFormData.bankName.$dirty && rtgsFormData.bankName.$error.required\" ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div><!-- Branch name --><div class=row><div class=col-md-12><p class=paymentTitle>Branch City</p></div><div class=col-md-12><input type=text class=\"form-control inputPayment\" ng-model=NewInvestorPayment.formData.paymentInfo.branchName only-alphabets name=bankBranch required ng-readonly=NewInvestorPayment.rtgsBankTogg> <span class=error-input ng-show=rtgsFormData.bankBranch.$dirty&&rtgsFormData.bankBranch.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div><!-- Account Number/ Verify Account Number --><div class=row><div ng-class=\"{\'col-md-12\' : NewInvestorPayment.rtgsBankTogg, \'col-md-6\' : !NewInvestorPayment.rtgsBankTogg}\"><p class=paymentTitle>Account Number</p><input type=text autocomplete=false class=\"form-control inputPayment\" ng-if=NewInvestorPayment.rtgsBankTogg ng-model=NewInvestorPayment.formData.paymentInfo.accNo name=bankAcNo required maxlength=20 minlength=\"\" onkeypress=\"(event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=NewInvestorPayment.copyPasteHandler($event) ng-readonly=NewInvestorPayment.rtgsBankTogg> <input type=password autocomplete=false class=\"form-control inputPayment\" ng-if=!NewInvestorPayment.rtgsBankTogg ng-model=NewInvestorPayment.formData.paymentInfo.accNo name=bankAcNo required maxlength=20 minlength=\"\" onkeypress=\"(event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=NewInvestorPayment.copyPasteHandler($event)> <span class=error-input ng-show=rtgsFormData.bankAcNo.$dirty&&rtgsFormData.bankAcNo.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=rtgsFormData.bankAcNo.$dirty&&rtgsFormData.bankAcNo.$error.maxlength ng-bind=NewInvestorPayment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div><div class=col-md-6 ng-if=!NewInvestorPayment.rtgsBankTogg><p class=paymentTitle>Verify Account Number</p><input type=text class=\"form-control inputPayment\" ng-keydown=Payment.copyPasteHandler($event) name=verifyBankAcNo maxlength=20 required ng-model=NewInvestorPayment.formData.paymentInfo.verifyBankAcNo ng-pattern=NewInvestorPayment.formData.paymentInfo.accNo onkeypress=\"(event.charCode >= 48 && event.charCode <= 57)\" easyassist-key=mask-element> <span class=error-input ng-show=rtgsFormData.verifyBankAcNo.$dirty&&rtgsFormData.verifyBankAcNo.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=!rtgsFormData.verifyBankAcNo.$error.required&&rtgsFormData.verifyBankAcNo.$error.maxlength ng-bind=NewInvestorPayment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!rtgsFormData.verifyBankAcNo.$error.required&&!rtgsFormData.verifyBankAcNo.$error.maxlength&&rtgsFormData.verifyBankAcNo.$error.pattern ng-bind=NewInvestorPayment.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div><!-- Account Type --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=paymentTitle>Account Type</p></div><div class=\"col-xs-12 col-md-12\"><select id=accountType name=accountType class=\"form-control selectNormal\" ng-model=NewInvestorPayment.formData.paymentInfo.accType required ng-disabled=\"NewInvestorPayment.rtgsBankTogg && NewInvestorPayment.isAccTypeFieldDisabled\"><option value selected>Select</option><option ng-repeat=\"value in NewInvestorPayment.bankAccountType\" ng-selected=\"NewInvestorPayment.bankAccountDetailsForm.accountType == value.accountTypeCode\" value={{value.accountTypeCode}}>{{value.accountType}}</option></select></div></div><br><!-- IFSC/NEFT Code --><div class=row><div class=col-md-12><p class=paymentTitle>IFSC/NEFT Code</p></div><div class=col-md-12><input type=text class=\"form-control inputPayment\" ng-model=NewInvestorPayment.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=NewInvestorPayment.IFSC_REGEX capitalize ng-readonly=\"NewInvestorPayment.rtgsBankTogg && NewInvestorPayment.formData.paymentInfo.ifscCode\"> <span class=error-input ng-show=rtgsFormData.ifscCode.$dirty&&rtgsFormData.ifscCode.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=rtgsFormData.ifscCode.$dirty&&rtgsFormData.ifscCode.$error.pattern ng-bind=NewInvestorPayment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><!-- UTR Number/ Verify UTR Number --><div class=row><div class=col-md-6><p class=paymentTitle>UTR Number</p><input type=text class=\"form-control inputPayment\" name=utrNumber ng-model=NewInvestorPayment.formData.paymentInfo.utrNumber ng-pattern=NewInvestorPayment.PATTERN.UTR_REGEX ng-maxlength=255 required> <span class=error-input ng-show=rtgsFormData.utrNumber.$dirty&&rtgsFormData.utrNumber.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=rtgsFormData.utrNumber.$dirty&&rtgsFormData.utrNumber.$error.pattern class=help-block ng-bind=NewInvestorPayment.VALIDATE_DATA.UTR_RANGE></span> <span class=error-input ng-show=rtgsForm.utrNumber.$dirty&&rtgsForm.utrNumber.$error.maxlength class=help-block ng-bind=NewInvestorPayment.VALIDATE_DATA.UTR_INVALID></span></div><div class=col-md-6><p class=paymentTitle>Verify UTR Number</p><input type=text class=\"form-control inputPayment\" name=verifyUtrNumber ng-model=NewInvestorPayment.formData.paymentInfo.verifyUtrNumber ng-pattern=NewInvestorPayment.formData.paymentInfo.utrNumber required> <span class=error-input ng-show=rtgsFormData.verifyUtrNumber.$dirty&&rtgsFormData.verifyUtrNumber.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=rtgsFormData.verifyUtrNumber.$dirty&&rtgsFormData.verifyUtrNumber.$error.pattern ng-bind=NewInvestorPayment.VALIDATE_DATA.SAME_UTR_REQUIRED></span></div></div><!-- chequesleaf --><!--<div class=\"row\">\n    <div class=\"col-xs-12 col-sm-6 col-md-6\">\n        <label for=\"chequesleafImage\" class=\"new-investor-chequeleaf-label\" style=\"text-align: right;\n    padding: 10px;\n    padding-left: 35px;\n    margin-top: 15px;\n    background-color: lightgray;\n    border-radius: 25px;\n    cursor: pointer;\n    background-size: 28px;\n    background-position-x: 5px;\n    background-position-y: 3px;\n    background-repeat: no-repeat;\n    font-size: 13px;\n    width: 100%;\n    background-image: url(../../../../assets/images/new-investor/uploadIcon.png);\">\n            Upload Bank Statement\n        </label>\n        </label>\n        <input type=\"file\" name=\"chequesleafImage\" id=\"chequesleafImage\"\n            accept=\"image/tiff,image/tif,image/jpeg,image/jpg,application/pdf\" file-model-profile=\"Preview Uploaded Doc\"\n            ng-model=\"NewInvestorPayment.formData.paymentInfo.chequeLeaf\"\n            upload=\"NewInvestorPayment.bankUploadChequeLeafFile(file)\" style=\"display: none;visibility: none;\"\n            required>\n\n    </div>\n    <div class=\"col-xs-12  col-sm-6 col-md-6\">\n        <p\n        ng-if=\"NewInvestorPayment.bankchequeLeafUrl && NewInvestorPayment.fileType!=\'pdf\'  && NewInvestorPayment.fileType != \'tiff\'\"\n        ng-click=\"NewInvestorPayment.openUploadedDoc()\"\n        style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 15px; font-size: 13px\">\n        Show Image</p>\n      <p\n        ng-if=\"NewInvestorPayment.bankchequeLeafUrl && (NewInvestorPayment.fileType ==\'pdf\' || NewInvestorPayment.fileType == \'tiff\')\"\n        ng-click=\"NewInvestorPayment.downloadPdfFile(NewInvestorPayment.bankchequeLeafUrl,NewInvestorPayment.fileType)\"\n        style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 15px; font-size: 13px\">\n        Download <span style=\"text-transform: capitalize\">{{NewInvestorPayment.fileType}}</span></p>\n    </div>\n</div>--><br></div></form></div><!--HDFC Fund Transfer  --><!-- <div ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'HDFC\'\">\n                            <form name=\"hdfcFundTransferForm\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-12\">\n                                        <p class=\"paymentTitle\">HDFC MF Scheme Account Number</p>\n                                    </div>\n                                    <div class=\"col-md-12\">\n                                        <input type=\"number\" class=\"form-control inputPayment\" ignore-mouse-wheel\n                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.schemeAccountNumber\"\n                                            name=\"schemeAccountNumber\" ng-maxlength=\"25\" required>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.schemeAccountNumber.$dirty&&hdfcFundTransferForm.schemeAccountNumber.$error.required\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_REQUIRED\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.schemeAccountNumber.$dirty&&hdfcFundTransferForm.schemeAccountNumber.$error.number\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_FIELD\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.schemeAccountNumber.$dirty&&hdfcFundTransferForm.schemeAccountNumber.$error.maxlength\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE\"></span>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-md-6\">\n                                        <p class=\"paymentTitle\">Investor Account Number</p>\n                                        <input type=\"password\" class=\"form-control inputPayment\"\n                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.accountNumber\"\n                                            name=\"accountNumber\" ng-maxlength=\"20\" easyassist-key=\"mask-element\"\n                                            onkeypress=\'(event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\'\n                                            ng-keydown=\"NewInvestorPayment.copyPasteHandler($event)\" required>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.accountNumber.$dirty&&hdfcFundTransferForm.accountNumber.$error.required\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.accountNumber.$dirty&&hdfcFundTransferForm.accountNumber.$error.maxlength\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE\"></span>\n\n                                    </div>\n                                    <div class=\"col-md-6\">\n                                        <p class=\"paymentTitle\">Verify Investor Account Number</p>\n                                        <input type=\"text\" class=\"form-control inputPayment\"\n                                            ng-keydown=\"NewInvestorPayment.copyPasteHandler($event)\"\n                                            name=\"verifyAccountNumber\" ng-maxlength=\"20\" easyassist-key=\"mask-element\"\n                                            required\n                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.verifyAccountNumber\"\n                                            ng-pattern=\"NewInvestorPayment.formData.paymentInfo.accountNumber\"\n                                            onkeypress=\'(event.charCode >= 48 && event.charCode <= 57)\'>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.verifyAccountNumber.$dirty&&hdfcFundTransferForm.verifyAccountNumber.$error.required\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"!hdfcFundTransferForm.verifyAccountNumber.$error.required&&hdfcFundTransferForm.verifyAccountNumber.$error.maxlength\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"!hdfcFundTransferForm.verifyAccountNumber.$error.required&&!hdfcFundTransferForm.verifyAccountNumber.$error.maxlength&&tForm.verifyAccountNumber.$error.pattern\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.SAME_INVESTOR_ACCOUNT_NUMBER_RANGE\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.verifyAccountNumber.$dirty&&hdfcFundTransferForm.verifyAccountNumber.$error.pattern\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE\"></span>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-xs-12 col-md-12\">\n                                        <p class=\"investmentTitle\">Account Type</p>\n                                    </div>\n                                    <div class=\"col-xs-12 col-md-12\">\n                                        <select id=\"accountType\" name=\"accountType\" class=\"form-control selectNormal\"\n                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.accType\" required>\n                                            <option value selected=\"selected\">Select</option>\n                                            <option ng-repeat=\"value in NewInvestorPayment.bankAccountType\"\n                                                ng-selected=\"NewInvestorPayment.bankAccountDetailsForm.accountType == value.accountTypeCode\"\n                                                value=\"{{value.accountTypeCode}}\">{{value.accountType}}</option>\n                                        </select>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-md-12\">\n                                        <p class=\"paymentTitle\">Account Holder Name</p>\n                                    </div>\n                                    <div class=\"col-md-12\">\n                                        <input type=\"text\" class=\"form-control inputPayment\"\n                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.accountHolderName\"\n                                            only-alphabets name=\"accountHolderName\" required>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.accountHolderName.$dirty&&hdfcFundTransferForm.accountHolderName.$error.required\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.ACCOUNT_HOLDER_REQUIRED\"></span>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-md-12\">\n                                        <p class=\"paymentTitle\">IFSC/NEFT Code</p>\n                                    </div>\n                                    <div class=\"col-md-12\">\n                                        <input type=\"text\" class=\"form-control inputPayment\"\n                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.ifscCode\" name=\"ifscCode\"\n                                            required ng-pattern=\"NewInvestorPayment.IFSC_REGEX\" capitalize>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.ifscCode.$dirty&&hdfcFundTransferForm.ifscCode.$error.required\"\n                                            ng-bind=\"Payment.VALIDATE_DATA.IFSC_CODE_FIELD\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.ifscCode.$dirty&&hdfcFundTransferForm.ifscCode.$error.pattern\"\n                                            ng-bind=\"Payment.VALIDATE_DATA.IFSC_CODE_REGEX\"></span>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-md-6\">\n                                        <p class=\"paymentTitle\">Bank Reference Number</p>\n                                        <input type=\"text\" class=\"form-control inputPayment\"\n                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.utrNumber\"\n                                            name=\"utrNumber\" required ng-maxlength=\"255\" ng-pattern=\"/^[a-zA-Z0-9]*$/\">\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.utrNumber.$dirty&&hdfcFundTransferForm.utrNumber.$error.required\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.utrNumber.$dirty&&hdfcFundTransferForm.utrNumber.$error.maxlength\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.utrNumber.$dirty&&hdfcFundTransferForm.utrNumber.$error.pattern\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.UTR_INVALID\"></span>\n                                    </div>\n                                    <div class=\"col-md-6\">\n                                        <p class=\"paymentTitle\">Verify Bank Reference Number</p>\n                                        <input type=\"text\" class=\"form-control inputPayment\" name=\"verifyUtrNumber\"\n                                            ng-maxlength=\"255\" required\n                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.verifyUtrNumber\"\n                                            ng-pattern=\"NewInvestorPayment.formData.paymentInfo.utrNumber\">\n                                        <span class=\"error-input\"\n                                            ng-show=\"hdfcFundTransferForm.verifyUtrNumber.$dirty&&hdfcFundTransferForm.verifyUtrNumber.$error.required\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"!hdfcFundTransferForm.verifyUtrNumber.$error.required&&hdfcFundTransferForm.verifyUtrNumber.$error.maxlength\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE\"></span>\n                                        <span class=\"error-input\"\n                                            ng-show=\"!hdfcFundTransferForm.verifyUtrNumber.$error.required&&!hdfcFundTransferForm.verifyUtrNumber.$error.maxlength&& hdfcFundTransferForm.verifyUtrNumber.$error.pattern\"\n                                            ng-bind=\"NewInvestorPayment.VALIDATE_DATA.SAME_BANK_REFERENCE_NUMBER_RANGE\"></span>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-xs-12 col-sm-6 col-md-6\">\n                                        <label for=\"chequesleafImage\" style=\"text-align: right;\n                                            padding: 10px;\n                                            padding-left: 35px;\n                                            margin-top: 15px;\n                                            background-color: lightgray;\n                                            border-radius: 25px;\n                                            cursor: pointer;\n                                            background-size: 28px;\n                                            background-position-x: 5px;\n                                            background-position-y: 3px;\n                                            background-repeat: no-repeat;\n                                            background-image: url(../../../../assets/images/new-investor/uploadIcon.png);\">\n                                            Upload Cheque leaf\n                                        </label>\n                                        </label>\n                                        <input type=\"file\" name=\"chequesleafImage\" id=\"chequesleafImage\"\n                                            accept=\"image/tiff,image/tif,image/jpeg,image/jpg\"\n                                            file-model-profile=\"Preview Uploaded Doc\"\n                                            ng-model=\"NewInvestorPayment.formData.paymentInfo.chequeLeaf\"\n                                            upload=\"NewInvestorPayment.bankUploadChequeLeafFile(file)\"\n                                            style=\"display: none;visibility: none;\" required>\n\n                                    </div>\n                                    <div class=\"col-xs-12  col-sm-6 col-md-6\">\n                                        <p ng-if=\"NewInvestorPayment.bankchequeLeafUrl\"\n                                            ng-click=\"NewInvestorPayment.openUploadedDoc()\"\n                                            style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 5px;\">\n                                            Show Image</p>\n                                    </div>\n                                </div>\n                                <br>\n                                <br>\n                            </form>\n                        </div> --><!-- UPI --><div ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'UPI\'\"><form name=upiPaymentForm ng-submit=NewInvestorPayment.verifyUPI()><p class=paymentTitle>Select UPI bank</p><!-- <input type=\"text\" name=\"upiBank\" id=\"upiBank\" class=\"form-control\"\n                                    ng-model=\"NewInvestorPayment.formData.paymentInfo.bank\"\n                                    ng-change=\"NewInvestorPayment.selectedUpiBank()\"\n                                    ng-init=\"NewInvestorPayment.upiPaymet ? NewInvestorPayment.upiPaymet: null\"\n                                    autocomplete=\"off\" only-alphabets>\n                                <span class=\"error-input\"\n                                    ng-show=\"upiPaymentForm.bank.$dirty&&upiPaymentForm.bank.$error.required\"\n                                    ng-bind=\"NewInvestorPayment.VALIDATE_DATA.BANK_REQUIRED\"></span>\n                                <bank-drop-down list-data=\"NewInvestorPayment.netBankingAndUPIList\"\n                                    display-key=\"bankNameOnly\" display-key-second=\"accountNumber\"\n                                    ng-click=\"NewInvestorPayment.selectedUpiBank()\" model=\"NewInvestorPayment.upiPaymet\"\n                                    for=\"upiBank\">\n                                </bank-drop-down> --><select class=\"form-control selectNormal\" name=bank ng-disabled=\"!NewInvestorPayment.upiPaymet || NewInvestorPayment.disableUpiBank\" ng-model=NewInvestorPayment.bankInfo ng-options=\"bank as bank.bankName for bank in NewInvestorPayment.netBankingAndUPIList\" ng-change=NewInvestorPayment.selectedUpiBank() easyassist-key=mask-element required><option value=\"\" easyassist-key=mask-element selected></option></select><p class=paymentTitle>Virtual Payment Address(UPI ID)</p><input type=text ng-model=NewInvestorPayment.formData.paymentInfo.virtualAddress ng-disabled=NewInvestorPayment.disableUpiBank name=virtualAddress class=\"form-control inputPayment\" ng-pattern=NewInvestorPayment.PATTERN.upi_virtual_addr_regex ng-change=\"NewInvestorPayment.verifyUPIResp={}\" required ng-readonly=\"NewInvestorPayment.isUPIVerified && NewInvestorPayment.verifyUPIResp.valid === true\" easyassist-key=mask-element> <span class=error-input ng-show=\"upiPaymentForm.virtualAddress.$dirty &&\n                                    (upiPaymentForm.virtualAddress.$error.required ||upiPaymentForm.virtualAddress.$error.pattern)\" ng-bind=NewInvestorPayment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!upiPaymentForm.virtualAddress.$invalid\n                             &&  (!NewInvestorPayment.isUPIVerified && NewInvestorPayment.verifyUPIResp.valid === false)\" ng-bind=NewInvestorPayment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span><br><button blur-on-click class=btn-new-journey-color style=\"border-radius: 30px\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption==\'UPI\' && !NewInvestorPayment.isUPIVerified\" class=btn ng-disabled=\"!NewInvestorPayment.formData.paymentInfo.virtualAddress ||\n                                    (!NewInvestorPayment.bankInfo.minorBankFlag && NewInvestorPayment.checkForMinorBankListCondition())\" ng-click=NewInvestorPayment.verifyUPI()>Verify</button><div ng-if=NewInvestorPayment.showUPIStatus><div class=\"verify-vpa verify-ack-padding\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption==\'UPI\' && NewInvestorPayment.isUPIVerified == true\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{NewInvestorPayment.name}}</span></div></div></form></div><!-- Cheque --><div ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'Q\'\"><div><br><p>Are you transferring funds from folio registered bank account?<span style=\"color: darkgrey\">(Only HDFC Bank allow)</span></p><br><div style=\"display: flex\" class=neft-form-switch><span style=\"margin-left: 10px; margin-right: 10px\" class=toggle-login-text ng-class=\"{\'login-active-tab\': NewInvestorPayment.chequeBankTogg}\">Yes</span><label class=switch><input type=checkbox ng-model=NewInvestorPayment.chequeBankTogg ng-click=NewInvestorPayment.selectChequeBank() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label><span style=\"margin-left: 10px; margin-right: 10px\" class=toggle-login-text ng-class=\"{\'login-active-tab\': !NewInvestorPayment.chequeBankTogg}\">No</span></div></div><form name=chequeFormData1><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:chequeFormData.bank.$dirty&&tForm.bank.$invalid} ng-if=NewInvestorPayment.chequeBankTogg><p style=\"font-weight: bold;margin: 10px\">Select Bank<span class=\"req text-red\">*</span></p><input type=text class=\"form-control inputPayment\" name=bank id=bank ng-model=NewInvestorPayment.formData.paymentInfo.bankNameWithAccountNumber autocomplete=off ng-required=!NewInvestorPayment.formData.paymentInfo only-alphabets easyassist-key=mask-element> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=chequeFormData.bank.$dirty&&chequeFormData.bank.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=NewInvestorPayment.netBankingAndUPIList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=NewInvestorPayment.changeBank() model=NewInvestorPayment.bankInfo for=bank easyassist-key=mask-element></bank-drop-down></div><br><br></form><form name=chequeFormData><div ng-init=NewInvestorPayment.setFormDataForNeft(chequeFormData) ng-hide=\"(NewInvestorPayment.formData.purchasePaymentOption == \'Q\' && NewInvestorPayment.chequeBankTogg && NewInvestorPayment.formData.paymentInfo && NewInvestorPayment.formData.paymentInfo.tpvEnableFlag == \'N\') || (NewInvestorPayment.formData.purchasePaymentOption == \'Q\' && NewInvestorPayment.chequeBankTogg && !NewInvestorPayment.bankInfo)\"><!-- bank name --><div class=row><div class=col-md-12><p class=paymentTitle>Bank name<span class=\"req text-red\">*</span></p></div><div class=col-md-12><input type=text class=\"form-control inputPayment\" ng-model=NewInvestorPayment.formData.paymentInfo.bankName name=bankName only-alphabets required ng-readonly=\"NewInvestorPayment.chequeBankTogg || !NewInvestorPayment.chequeBankTogg\"> <span class=error-input ng-show=\"chequeFormData.bankName.$dirty && chequeFormData.bankName.$error.required\" ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div><!-- IFSC/NEFT Code --><div class=row><div class=col-md-12><p class=paymentTitle>IFSC/NEFT Code<span class=\"req text-red\">*</span></p></div><div class=col-md-6 ng-if=!NewInvestorPayment.chequeBankTogg style=\"display: flex;justify-content: right;align-items: center\"><div style=\"width: 100px\"><div class=alignifsctext style=\"display: flex;justify-content: right;align-items: center\" ng-click=NewInvestorPayment.selectIFSC()><a style=\"height: 15px;width: 20px\"><svg class=\"svg-icon search-icon\" aria-labelledby=\"title desc\" role=img viewBox=\"0 0 19.9 19.7\"><title id=title>Search Icon</title><desc id=desc>A magnifying glass icon.</desc><g class=search-path fill=none stroke=#669ddf><path stroke-linecap=square stroke-width=3 d=\"M18.5 18.3l-5.4-5.4\"/><circle stroke-width=2 cx=8 cy=8 r=7 /></g></svg></a><p style=\"color: #669ddf;font-size: 12px\">SEARCH IFSC</p></div></div></div><div class=col-md-12><input type=text class=\"form-control inputPayment\" ng-model=NewInvestorPayment.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=NewInvestorPayment.IFSC_REGEX capitalize ng-readonly=\"NewInvestorPayment.chequeBankTogg && NewInvestorPayment.formData.paymentInfo.ifscCode\" ng-if=NewInvestorPayment.chequeBankTogg> <input type=text class=\"form-control inputPayment\" ng-model=NewInvestorPayment.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=NewInvestorPayment.IFSC_REGEX capitalize ng-if=!NewInvestorPayment.chequeBankTogg ng-blur=NewInvestorPayment.manualIfscSearch()> <span class=error-input ng-show=chequeFormData.ifscCode.$dirty&&chequeFormData.ifscCode.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=chequeFormData.ifscCode.$dirty&&chequeFormData.ifscCode.$error.pattern ng-bind=NewInvestorPayment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><!-- Account Number/ Verify Account Number --><div class=row><div ng-class=\"{\'col-md-12\' : NewInvestorPayment.chequeBankTogg, \'col-md-6\' : !NewInvestorPayment.chequeBankTogg}\"><p class=paymentTitle>Account Number<span class=\"req text-red\">*</span></p><input type=text autocomplete=false class=\"form-control inputPayment\" ng-if=NewInvestorPayment.chequeBankTogg ng-model=NewInvestorPayment.formData.paymentInfo.accNo name=bankAcNo required maxlength=20 minlength=\"\" onkeypress=\"(event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=NewInvestorPayment.copyPasteHandler($event) ng-readonly=NewInvestorPayment.chequeBankTogg> <input type=password autocomplete=false class=\"form-control inputPayment\" ng-if=!NewInvestorPayment.chequeBankTogg ng-model=NewInvestorPayment.formData.paymentInfo.accNo name=bankAcNo required maxlength=20 minlength=\"\" onkeypress=\"(event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=NewInvestorPayment.copyPasteHandler($event)> <span class=error-input ng-show=chequeFormData.bankAcNo.$dirty&&chequeFormData.bankAcNo.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=chequeFormData.bankAcNo.$dirty&&chequeFormData.bankAcNo.$error.maxlength ng-bind=NewInvestorPayment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div><div class=col-md-6 ng-if=!NewInvestorPayment.chequeBankTogg><p class=paymentTitle>Verify Account Number<span class=\"req text-red\">*</span></p><input type=text class=\"form-control inputPayment\" ng-keydown=NewInvestorPayment.copyPasteHandler($event) name=verifyBankAcNo maxlength=20 required ng-model=NewInvestorPayment.formData.paymentInfo.verifyBankAcNo ng-pattern=NewInvestorPayment.formData.paymentInfo.accNo onkeypress=\"(event.charCode >= 48 && event.charCode <= 57)\" easyassist-key=mask-element> <span class=error-input ng-show=chequeFormData.verifyBankAcNo.$dirty&&chequeFormData.verifyBankAcNo.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=!chequeFormData.verifyBankAcNo.$error.required&&chequeFormData.verifyBankAcNo.$error.maxlength ng-bind=NewInvestorPayment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!chequeFormData.verifyBankAcNo.$error.required&&!chequeFormData.verifyBankAcNo.$error.maxlength&&chequeFormData.verifyBankAcNo.$error.pattern ng-bind=NewInvestorPayment.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div><!-- Account Type --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=paymentTitle>Account Type<span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-12\"><select id=accountType name=accountType class=\"form-control selectNormal\" ng-model=NewInvestorPayment.formData.paymentInfo.accType required ng-disabled=\"NewInvestorPayment.chequeBankTogg && NewInvestorPayment.isAccTypeFieldDisabled\"><option value selected>Select</option><option ng-repeat=\"value in NewInvestorPayment.bankAccountType\" ng-selected=\"NewInvestorPayment.bankAccountDetailsForm.accountType == value.accountTypeCode\" value={{value.accountTypeCode}}>{{value.accountType}}</option></select></div></div><br><!-- Branch name --><div class=row><div class=col-md-6><p class=paymentTitle>Branch Address<span class=\"req text-red\">*</span></p></div><div class=col-md-12><input type=text class=\"form-control inputPayment\" ng-model=NewInvestorPayment.formData.paymentInfo.branchName only-alphabets name=bankBranch required ng-readonly=NewInvestorPayment.chequeBankTogg> <span class=error-input ng-show=chequeFormData.bankBranch.$dirty&&chequeFormData.bankBranch.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div><!-- Cheque number/ Verify Cheque number --><div class=row><div class=col-md-6><p class=paymentTitle>Cheque Number<span class=\"req text-red\">*</span></p><input type=password class=\"form-control inputPayment\" name=chequeNumber ng-model=NewInvestorPayment.formData.paymentInfo.chequeNumber maxlength=15 minlength=1 required onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=error-input ng-show=chequeFormData.chequeNumber.$dirty&&chequeFormData.chequeNumber.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.CHEQUE_NUMBER_REQUIRED></span></div><div class=col-md-6><p class=paymentTitle>Verify Cheque Number<span class=\"req text-red\">*</span></p><input type=text class=\"form-control inputPayment\" name=verifyChequeNumber maxlength=15 minlength=1 ng-model=NewInvestorPayment.formData.paymentInfo.verifyChequeNumber ng-pattern=NewInvestorPayment.formData.paymentInfo.chequeNumber required onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=error-input ng-show=chequeFormData.verifyChequeNumber.$dirty&&chequeFormData.verifyChequeNumber.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.CHEQUE_NUMBER_REQUIRED></span> <span class=error-input ng-show=chequeFormData.verifyChequeNumber.$dirty&&chequeFormData.verifyChequeNumber.$error.pattern ng-bind=NewInvestorPayment.VALIDATE_DATA.SAME_CHEQUE_NUMBER_RANGE></span></div></div><br></div></form></div></div></div></div></div><div class=\"row noteForTpv\" ng-if=\"(NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\' && NewInvestorPayment.formData.paymentInfo.tpvEnableFlag == \'N\')\"><!--|| NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\'--><div class=\"col-sm-1 col-md-3\"></div><div class=\"col-sm-11 col-md-9\" style=\"display: flex;justify-content: flex-start;flex-direction: row;align-items: center\"><p class=\"text-red error-msg-tpv\" style=\"font-size: 13px\">Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br>Please select other payment mode or add a TPV enabled bank in your folio. <a ng-click=NewInvestorPayment.tpv() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</p></div></div><br><!-- Declaration --><br><div class=row><div class=\"col-sm-1 col-md-2\"></div><div class=\"col-sm-11 col-md-10\" style=\"display: flex;justify-content: flex-start;flex-direction: row;align-items: center\"><input class=nomineeCheckbox type=checkbox name=paymentDeclairation id=paymentDeclairation ng-click=NewInvestorPayment.getconfirmation() ng-checked=NewInvestorPayment.confirmation style=\"margin-bottom: 5px;margin-right: 5px\"><label for=paymentDeclairation class=confirmationnote style=\"margin-left: 30px\">I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the account holders.</label></div></div><br><div class=paymentBtn><!-- <p class=\"savebtn\">SAVE</p> --> <button class=\"btn btn-primary-action-pay hdfc-blue-cta-small payment-btn-hover\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\'\" ng-click=NewInvestorPayment.transactionOtpConfirmation() ng-disabled=\"!NewInvestorPayment.confirmation ||\n                !NewInvestorPayment.formData.paymentInfo.bankName ||\n                !NewInvestorPayment.formData.paymentInfo.accountNumber ||\n                NewInvestorPayment.formData.paymentInfo.tpvEnableFlag == \'N\'\" style=\"margin-left: 40px;width: 180px !important;margin-bottom: 15px\">CONTINUE TO PAY</button> <button class=\"btn btn-primary-action-pay hdfc-blue-cta-small\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\'\" ng-click=NewInvestorPayment.transactionOtpConfirmation() ng-disabled=\"!NewInvestorPayment.confirmation ||\n                !NewInvestorPayment.formData.paymentInfo.bankName ||\n                !NewInvestorPayment.formData.paymentInfo.branchName ||\n                !NewInvestorPayment.formData.paymentInfo.accNo ||\n                !NewInvestorPayment.formData.paymentInfo.accType ||\n                (!NewInvestorPayment.rtgsBankTogg && !NewInvestorPayment.formData.paymentInfo.verifyBankAcNo) ||\n                !NewInvestorPayment.formData.paymentInfo.ifscCode ||\n                !NewInvestorPayment.formData.paymentInfo.utrNumber ||\n                !NewInvestorPayment.formData.paymentInfo.verifyUtrNumber\" style=\"width: 180px;margin-bottom: 15px\">CONTINUE TO PAY</button><!--!NewInvestorPayment.formData.paymentInfo.chequeLeaf || (NewInvestorPayment.rtgsBankTogg && NewInvestorPayment.formData.paymentInfo.tpvEnableFlag == \'N\') ||--><!--                <button class=\"btn btn-primary-action-pay hdfc-blue-cta-small\" ng-If=\"NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' && !NewInvestorPayment.rtgsBankTogg\"--><!--                ng-click=\"NewInvestorPayment.transactionOtpConfirmation()\"--><!--                ng-disabled=\"!NewInvestorPayment.confirmation ||--><!--                !NewInvestorPayment.formData.paymentInfo.bankName ||--><!--                !NewInvestorPayment.formData.paymentInfo.utrNumber ||--><!--                !NewInvestorPayment.formData.paymentInfo.verifyUtrNumber\" style=\"width: 180px;margin-bottom: 15px;\">--><!--                CONTINUE TO PAY</button>--><!-- <button class=\"btn btn-primary-action-pay hdfc-blue-cta-small\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'HDFC\'\"\n                ng-click=\"NewInvestorPayment.transactionOtpConfirmation()\" ng-disabled=\"!NewInvestorPayment.confirmation ||\n                !NewInvestorPayment.formData.paymentInfo.schemeAccountNumber ||\n                !NewInvestorPayment.formData.paymentInfo.accountNumber ||\n                !NewInvestorPayment.formData.paymentInfo.verifyAccountNumber ||\n                !NewInvestorPayment.formData.paymentInfo.accountHolderName ||\n                !NewInvestorPayment.formData.paymentInfo.chequeLeaf ||\n                !NewInvestorPayment.formData.paymentInfo.ifscCode ||\n                !NewInvestorPayment.formData.paymentInfo.utrNumber ||\n                !NewInvestorPayment.formData.paymentInfo.verifyUtrNumber\" style=\"width: 180px;margin-bottom: 15px;\">\n                CONTINUE TO PAY</button> --> <button class=\"btn btn-primary-action-pay hdfc-blue-cta-small\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'UPI\'\" ng-click=NewInvestorPayment.transactionOtpConfirmation() ng-disabled=\"!NewInvestorPayment.confirmation ||\n                !NewInvestorPayment.formData.paymentInfo.virtualAddress ||\n                !NewInvestorPayment.verifyUPIResp.valid ||\n                !NewInvestorPayment.bankInfo\" style=\"width: 180px;margin-bottom: 15px\">CONTINUE TO PAY</button> <button class=\"btn btn-primary-action-pay hdfc-blue-cta-small payment-btn-hover\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'Q\'\" ng-click=NewInvestorPayment.transactionOtpConfirmation() ng-disabled=\"!NewInvestorPayment.confirmation ||\n                !NewInvestorPayment.formData.paymentInfo.bankName ||\n                !NewInvestorPayment.formData.paymentInfo.branchName ||\n                !NewInvestorPayment.formData.paymentInfo.accNo ||\n                !NewInvestorPayment.formData.paymentInfo.accType ||\n                (!NewInvestorPayment.chequeBankTogg && !NewInvestorPayment.formData.paymentInfo.verifyBankAcNo) ||\n                (NewInvestorPayment.chequeBankTogg && NewInvestorPayment.formData.paymentInfo.tpvEnableFlag == \'N\') ||\n                !NewInvestorPayment.formData.paymentInfo.ifscCode ||\n                !NewInvestorPayment.formData.paymentInfo.chequeNumber ||\n                !NewInvestorPayment.formData.paymentInfo.verifyChequeNumber\" style=\"width: 180px;margin-bottom: 15px\">CONTINUE TO PAY</button></div></div><br><br></div><div style=\"display: flex;justify-content: center\"><div ng-if=NewInvestorPayment.chequeAcknowledgeSuccess><div data-ng-include=\"\'app/new-investors/payment/chequeAcknowledge.html\'\" class=content-area style=\"position: relative;left: 20%;top: 2%\"></div></div></div><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{NewInvestorPayment.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=NewInvestorPayment.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=NewInvestorPayment.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=NewInvestorPayment.billdeskPayload.msg></form><style>.sipseconddiv{\n        padding: 30px 0px 10px 30px;\n    }\n    .p-short{\n        padding: 5px 0px 5px 0px;\n    }\n    .inputPayment{\n        height: 34px;\n        background: #FFFFFF 0% 0% no-repeat padding-box;\n        border: 1px solid #B8C6D1;\n        border-radius: 5px;\n    }\n    #switch {\n    height: 0;\n    width: 0;\n    visibility: hidden;\n  }\n    .switchlablePay {\n    cursor: pointer;\n    text-indent: -9999px;\n    width: 29px;\n    height: 16px;\n    background: #5ceb57;\n    display: block;\n    border-radius: 50px;\n    position: relative;\n  }\n\n  .switchlablePay:after {\n    content: \"\";\n    position: absolute;\n    top: 3px;\n    left: 5px;\n    width: 10px;\n    height: 10px;\n    background: #fff;\n    border-radius: 50px;\n  }\n\n  input:checked + .switchlablePay {\n    background: #5ceb57;\n  }\n  input:checked + .switchlablePay:after {\n    left: calc(100% - 5px);\n    transform: translateX(-100%);\n  }\n  .switchlablePay:active:after {\n    width: 10px;\n  }\n  .f-bold{\n      font-weight: 600;\n      color: #000000;\n  }\n    .c-pink{\n        font: normal normal 600 12px/19px Poppins;\n        letter-spacing: 0px;\n        color: #FF8486;\n        opacity: 1;\n    }\n    .c-blue{\n        font: normal normal medium 12px/19px Poppins;\n        letter-spacing: 0px;\n        color: #7E8F95;\n        opacity: 1;\n    }\n    .summaryKey{\n        font: normal normal medium 12px/19px Poppins;\n        letter-spacing: 0px;\n        color: #7E8F95;\n        opacity: 1;\n    }\n    .modal-body1{\n        margin: auto;\n    padding: 50px;\n    width: 60%;\n    border-radius: 10px;\n    background: white;\n    box-shadow: -1px 1px 5px 1px lightgrey;\n    }\n    p{\n        color: #000000;\n    }\n    li{\n        padding: 5px;\n    }\n    .d-padding{\n        padding: 10px 0px 10px 0px;\n    }\n    .lessPadding{\n            padding: 10px 10px 10px 20px;\n    }\n    @media screen and (max-width: 600px) {\n        .sipseconddiv{\n            padding: 10px 0px 10px 15px;\n        }\n        .boxdiv{\n            margin-left: 15px;\n        }\n        .modal-body1{\n            width: 100%;\n        }\n\n        .lessPadding{\n            padding: 0px;\n        }\n        .btn-primary-action-pay {\n        padding: 10px 10px 10px 10px;\n        border-color: transparent;\n        background-color: #FF8486;\n        color: white;\n\n     }\n    }\n    .hdfc-blue-cta-small{\n        background-color: #FF8486;\n        color: white;\n    }\n    .btn-primary-action-pay {    color: white;\n        border-color: transparent;\n        background-color: #FF8486;\n\n     }\n     .hdfc-blue-cta-small:disabled{\n        background-color: #FF8486;\n        color: white;\n    }\n  .btn-primary-action-pay:disabled {\n    border-color: transparent;\n    background-color: #fdbdbe;\n  }\n    .payment-btn-hover:hover{\n    color: #000000 !important;\n    background-color: #FF8486;\n    border-color: transparent;\n    }</style>");
$templateCache.put("app/payment/landing-token/landing-token.html","<!--showing initial loader until setting token --><div ng-if=Payment.showLoader><div data-ng-include=\"\'app/payment/templates/common/loader/loader.html\'\"></div></div>");
$templateCache.put("app/payment/link-expired/link-expired.html","<div class=expired-link><!-- link expired  --><div><div class=\"row payment-header-container\"><div class=col-md-12 data-ng-include=\"\'app/payment/templates/header/header.html\'\"></div></div><div class=\"centerDiv mT20\"><div style=\"text-align: center\"><img src=../../../assets/images/icons/payment-journey/warning.svg alt=\"\" style=\"width: 70px;margin-top: 25%\"><br><h2 class=mT20>Transaction link has been expired.</h2></div></div><div class=\"footerDiv set-position-fixed\"><div data-ng-include=\"\'app/payment/templates/footer/footer.html\'\"></div></div></div></div>");
$templateCache.put("app/payment/pre-login-landing/pre-login-landing.html","<div class=payment-journey><section ng-if=!Payment.isLoading><div data-ng-include=\"\'app/payment/templates/loader/loader.html\'\"></div></section><section ng-if=Payment.isLoading><div><div><div ui-view></div></div></div></section><div class=footerDiv><div data-ng-include=\"\'app/payment/templates/footer/footer.html\'\"></div></div></div>");
$templateCache.put("app/portfolio/dematFoliosDetail/dematFoliosDetail.html","<div id=folios ng-init=DematFoliosDetail.init()><div class=folio-tabs><span class=slide-left ng-if=\"DematFoliosDetail.folioList.length>11 && !DematFoliosDetail.slideLeftDisabled\" ng-click=DematFoliosDetail.slideLeft()><i class=slide-left-icon></i></span><div class=capsule-box><span ng-repeat=\"folioValue in DematFoliosDetail.folioList track by $index\"><span ng-if=DematFoliosDetail.isDisplayed($index+1) class=\"capsule slide\" data={{$index+1}} ng-class=\"{\'active\': DematFoliosDetail.selectedFolio == folioValue}\" ng-click=\"(DematFoliosDetail.selectedFolio == folioValue) || DematFoliosDetail.getFolioData(folioValue)\">{{folioValue}}</span></span></div><span class=slide-right ng-if=\"DematFoliosDetail.folioList.length>11 && !DematFoliosDetail.slideRightDisabled\" ng-click=DematFoliosDetail.slideRight()><i class=slide-right-icon></i></span></div><div class=top-flow><div class=flow-card style=\"border-right: 0\"><span class=\"value text-uppercase\">Market Value</span> <span class=lead easyassist-key=mask-element><i class=rupee-black-icon></i>{{DematFoliosDetail.totalMarketvalue|unit:DematFoliosDetail.currentValueCountUnit}} {{DematFoliosDetail.currentValueCountUnit|unitValue}}</span></div></div><div class=\"search-data row\"><div class=\"col-md-12 col-xs-12\"><div class=\"pull-left d-note\"><span style=\"text-decoration: underline\">Note:</span> Since below scheme(s) are under demat folio, no transactions are allowed.</div><div class=\"sort-data pull-right\"><select ng-change=DematFoliosDetail.statusSchemeType() ng-model=DematFoliosDetail.selectedSchemeType ng-options=\"_schemetype.value as _schemetype.key for _schemetype in DematFoliosDetail.SCHEMETYPES\" ng-value=_schemetype.value></select></div></div></div><div class=\"list data-grid\"><table class=\"table table-responsive rwd-table\"><thead><tr><th colspan=2>Scheme Name</th><th>Closing Units</th><th>NAV</th><th>NAV AS ON</th><!--<th>Average NAV</th>--><th>Market Value (<i class=rupee-small-icon></i>)<br></th></tr></thead><tbody><tr ng-repeat=\"val in DematFoliosDetail.portfolioData track by $index \"><td colspan=2 data-th=Scheme><span class=text-blue ng-bind-html=val.scheme|linebreak:8></span></td><td data-th=\"Closing Units\" easyassist-key=mask-element>{{val.totalUnit | truncateDecimal : 3}}</td><td data-th=NAV>{{val.nav | truncateDecimal : 4}}</td><td data-th=\"Nav as on\">{{val.navDate}}</td><!--<td data-th=\"NAV Average\">{{val.navAverage}}</td>--><td data-th=\"Market Value\" class=text-left><span>{{val.currentValue | truncateDecimal : 2 |unit:val.currentValueUnit}}{{val.currentValueUnit|unitValue}}</span></td></tr><tr class=total-strip ng-if=\"DematFoliosDetail.portfolioData && DematFoliosDetail.portfolioData.length\"><td><strong>TOTAL</strong></td><td colspan=4></td><td><strong>{{DematFoliosDetail.totalMarketvalue | truncateDecimal : 2 | unit:DematFoliosDetail.totalMarketvalueCountUnit}}{{DematFoliosDetail.totalMarketvalueCountUnit|unitValue}}</strong></td></tr></tbody><tbody><tr ng-if=(!DematFoliosDetail.portfolioData||!DematFoliosDetail.portfolioData.length)&&!DematFoliosDetail.isLoading><td colspan=9>No Record found</td></tr></tbody></table><div class=end-pagination ng-if=\"DematFoliosDetail.isPagination && DematFoliosDetail.totalFolioData > DematFoliosDetail.pageLimitPortfolio\"><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"DematFoliosDetail.totalFolioData <= DematFoliosDetail.PAGE_LIMITS[0]\" ng-bind=DematFoliosDetail.totalFolioData></span><select ng-if=\"DematFoliosDetail.totalFolioData > DematFoliosDetail.PAGE_LIMITS[0]\" ng-change=DematFoliosDetail.pageLimitListChange() ng-model=DematFoliosDetail.pageLimitPortfolio ng-options=\"_limit as _limit for _limit in FoliosDetail.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black ng-bind=DematFoliosDetail.totalFolioData>205</span></div><ul uib-pagination total-items=DematFoliosDetail.totalFolioData ng-model=DematFoliosDetail.currentPagePortfolio max-size=5 items-per-page=DematFoliosDetail.pageLimitPortfolio class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=DematFoliosDetail.initFolioList() rotate=false></ul></div></div></div><style>.d-note{\n    color: red;\n    margin-top:20px;\n  }</style>");
$templateCache.put("app/portfolio/foliosDetail/foliosDetail.html","<div id=folios ng-init=FoliosDetail.init()><div class=folio-tab-container><span class=slide-left ng-if=\"FoliosDetail.folioList.length>11 && !FoliosDetail.slideLeftDisabled\" ng-click=FoliosDetail.slideLeft()><i class=slide-left-icon></i></span><div class=folio-tabs><div class=capsule-box><span ng-repeat=\"folioValue in FoliosDetail.folioList track by $index\"><span ng-if=FoliosDetail.isDisplayed($index+1) class=\"capsule slide\" data={{$index+1}} ng-class=\"{\'active\': FoliosDetail.selectedFolio == folioValue.folioNumber, \'invalidFolio\': !folioValue.validFolio}\" ng-click=\"(FoliosDetail.selectedFolio == folioValue.folioNumber) || FoliosDetail.getFolioData(folioValue.folioNumber)\">{{folioValue.folioNumber}}</span></span></div></div><span class=slide-right ng-if=\"FoliosDetail.folioList.length>11 && !FoliosDetail.slideRightDisabled\" ng-click=FoliosDetail.slideRight()><i class=slide-right-icon></i></span></div><p class=point-to-note>NOTE: Transactions cannot be initiated in folios highlighted in <span style=\"color: red\">red.</span></p><div class=top-flow><div class=flow-card><span class=\"value text-uppercase\">Cost Value</span> <span class=lead easyassist-key=mask-element><i class=rupee-black-icon></i>{{FoliosDetail.totalPurchaseValue | truncateDecimal : 2 | unit:FoliosDetail.purchaseValueCountUnit}} {{FoliosDetail.purchaseValueCountUnit|unitValue}}</span></div><div class=\"flow-card flow-card-marketValue\"><span class=\"value text-uppercase\">Market Value</span> <span class=lead easyassist-key=mask-element><i class=rupee-black-icon></i>{{FoliosDetail.totalCurrentValue | truncateDecimal : 2 | unit:FoliosDetail.currentValueCountUnit}} {{FoliosDetail.currentValueCountUnit|unitValue}}</span></div><div class=flow-card><span class=\"value text-uppercase xirrIcon\">Xirr%</span> <i class=\"info-icon base-tooltip\" data-bs-html=true data-bs-toggle=tooltip tooltip data-bs-placement=right title={{FoliosDetail.xirrInfo}}></i> <span class=lead><span class=xirrContent ng-if=\"FoliosDetail.constantDataDTO.xirrValue<0\">({{FoliosDetail.constantDataDTO.xirrValue | truncateDecimal : 2 |unit:FoliosDetail.constantDataDTO.xirrValueUnit}}{{FoliosDetail.constantDataDTO.xirrValueUnit|unitValue}})</span> <span class=xirrContent ng-if=\"FoliosDetail.constantDataDTO.xirrValue>=0\">{{FoliosDetail.constantDataDTO.xirrValue | truncateDecimal : 2 |unit:FoliosDetail.constantDataDTO.xirrValueUnit}}{{FoliosDetail.constantDataDTO.xirrValueUnit|unitValue}}</span></span></div></div><div class=\"search-data row\"><div class=\"col-md-12 col-xs-12\"><div class=\"sort-data pull-right\"><select ng-change=FoliosDetail.statusSchemeType() ng-model=FoliosDetail.selectedSchemeType ng-options=\"_schemetype.value as _schemetype.key for _schemetype in FoliosDetail.SCHEMETYPES\" ng-value=_schemetype.value></select></div></div></div><div class=\"list data-grid\"><table class=\"table table-responsive rwd-table\"><thead><tr><th colspan=2>Scheme Name</th><th>Closing Units</th><th>NAV</th><th>NAV AS ON</th><!--<th>Average NAV</th>--><th>Cost Value (<i class=rupee-small-icon></i>)<br></th><th>Market Value (<i class=rupee-small-icon></i>)<br></th><th>XIRR (%)</th><th class=text-center>Action</th></tr></thead><tbody><tr ng-repeat=\"val in FoliosDetail.portfolioData track by $index \"><td colspan=2 data-th=Scheme><!--ng-click=\"FoliosDetail.transactionOverview(val.scheme, val.schemeCode)\"--> <span class=text-blue ng-bind-html=val.scheme|linebreak:8></span></td><td data-th=\"Closing Units\" easyassist-key=mask-element>{{val.totalUnit | truncateDecimal : 3 }}</td><td data-th=NAV>{{val.nav | truncateDecimal : 4}}</td><td data-th=\"Nav as on\">{{val.navDate}}</td><!--<td data-th=\"NAV Average\">{{val.navAverage}}</td>--><td data-th=\"Cost Value\" class=text-left><span easyassist-key=mask-element>{{val.purchaseValue | truncateDecimal : 2 | unit:val.purchaseValueUnit}}{{val.purchaseValueUnit|unitValue}}</span></td><td data-th=\"Market Value\" class=text-left><span easyassist-key=mask-element>{{val.currentValue | truncateDecimal : 2 | unit:val.currentValueUnit}}{{val.currentValueUnit|unitValue}}</span></td><td data-th=Xirr class=text-left><span ng-if=\"val.irr<0\">({{val.irr | truncateDecimal : 2 | unit:val.irrUnit}}{{val.irrUnit|unitValue}})</span> <span ng-if=\"val.irr>=0\">{{val.irr| truncateDecimal : 2 | unit:val.irrUnit}}{{val.irrUnit|unitValue}}</span></td><td data-th=Action class=text-center><span class=\"btn-more dropdown\"><button ng-class={disabled:!FoliosDetail.validFolio} class=\"btn-secondary-action dropdown-toggle\" data-bs-toggle=dropdown>Transact <i class=arrow-blue-down-icon></i></button><ul class=\"folio-list dropdown-menu\"><li>Transact <i class=arrow-blue-down-icon></i></li><li class=list-group-item ng-click=FoliosDetail.selectTransaction(action,val) ng-repeat=\"action in val.action\">{{action == \'DTP\' ? \'TIP\' : action == \'Change Dividend Option\' ? \'Change IDCW Option\' : action == \'FLEXSIP\' ? \'Flex SIP\' : action }} <i class=\"arrow-right-icon pull-right\"></i></li></ul></span></td></tr><tr class=total-strip ng-if=\"FoliosDetail.portfolioData && FoliosDetail.portfolioData.length\"><td><strong>TOTAL</strong></td><td colspan=4></td><td easyassist-key=mask-element><strong>{{FoliosDetail.totalMarketValueCount | truncateDecimal : 2 |unit:FoliosDetail.totalMarketValueCountUnit}}{{FoliosDetail.totalMarketValueCountUnit|unitValue}}</strong></td><td easyassist-key=mask-element><strong>{{FoliosDetail.totalCostValueCount | truncateDecimal : 2 | unit:FoliosDetail.totalMarketValueCountUnit}}{{FoliosDetail.totalCostValueCountUnit|unitValue}}</strong></td><td></td><td></td></tr></tbody><tbody><tr ng-if=(!FoliosDetail.portfolioData||!FoliosDetail.portfolioData.length)&&!FoliosDetail.isLoading><td colspan=10>No Record found</td></tr></tbody></table><div class=end-pagination ng-if=\"FoliosDetail.isPagination && FoliosDetail.totalFolioData > FoliosDetail.pageLimitPortfolio\"><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"FoliosDetail.totalFolioData <= FoliosDetail.PAGE_LIMITS[0]\" ng-bind=FoliosDetail.totalFolioData></span><select ng-if=\"FoliosDetail.totalFolioData > FoliosDetail.PAGE_LIMITS[0]\" ng-change=FoliosDetail.pageLimitListChange() ng-model=FoliosDetail.pageLimitPortfolio ng-options=\"_limit as _limit for _limit in FoliosDetail.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black ng-bind=FoliosDetail.totalFolioData>205</span></div><ul uib-pagination total-items=FoliosDetail.totalFolioData ng-model=FoliosDetail.currentPagePortfolio max-size=5 items-per-page=FoliosDetail.pageLimitPortfolio class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=FoliosDetail.initFolioList() rotate=false></ul></div></div></div><style>.folio-list.dropdown-menu{\n    min-width:177px;\n  }\n  .flow-card-marketValue{\n    border-right: 1px solid #cccccc\n  }\n  #folios .top-flow .flow-card span.xirrContent{\n    margin-bottom: 0px;\n    color: #000;\n    text-align: left;\n    font-size: 24px;\n    line-height: 24px;\n    display: inline;\n  }\n  #folios .top-flow .flow-card:last-child span.value{\n    display: inline-block;\n  }\n  #folios .top-flow .flow-card:last-child i.info-icon{\n    vertical-align: top;\n    margin-top: -2px;\n  }</style>");
$templateCache.put("app/portfolio/portfolioDetail/portfolioDetail.html","<div id=portfolio ng-init=PortfolioDetail.init()><div class=\"loader portfolio-loader\" style=\"width:calc(100% - 0px) !important;\n  position: absolute;top:0px;left:0px\"><span class=loading></span> <span class=loading-text>Please wait while we are updating your details...</span></div><div class=top-flow><div class=flow-card><span class=\"value text-uppercase\">Cost Value</span> <span class=lead easyassist-key=mask-element><i class=rupee-black-icon></i>{{PortfolioDetail.totalPurchaseValue | truncateDecimal : 2 | unit:PortfolioDetail.purchaseValueCountUnit}} {{PortfolioDetail.purchaseValueCountUnit|unitValue}}</span></div><div class=\"flow-card flow-card-marketValue\"><span class=\"value text-uppercase\">Market Value</span> <span class=lead easyassist-key=mask-element><i class=rupee-black-icon></i>{{PortfolioDetail.totalCurrentValue | truncateDecimal : 2 | unit:PortfolioDetail.currentValueCountUnit}} {{PortfolioDetail.currentValueCountUnit|unitValue}}</span></div><div class=\"flow-card xirr-section\"><span class=\"value text-uppercase\">Xirr%</span> <i class=\"info-icon base-tooltip\" data-bs-html=true data-bs-toggle=tooltip tooltip data-bs-placement=right title={{PortfolioDetail.xirrInfo}}></i> <span class=lead><span class=xirrContent ng-if=\"PortfolioDetail.constantDataDTO.xirrValue<0\">({{PortfolioDetail.constantDataDTO.xirrValue | truncateDecimal : 2 | unit:PortfolioDetail.constantDataDTO.xirrValueUnit}}{{PortfolioDetail.constantDataDTO.xirrValueUnit|unitValue}})</span> <span class=xirrContent ng-if=\"PortfolioDetail.constantDataDTO.xirrValue>=0\">{{PortfolioDetail.constantDataDTO.xirrValue | truncateDecimal : 2 | unit:PortfolioDetail.constantDataDTO.xirrValueUnit}}{{PortfolioDetail.constantDataDTO.xirrValueUnit|unitValue}}</span></span></div></div><div class=\"search-data row\"><div class=\"col-md-12 col-xs-12\"><div class=\"sort-data pull-right\"><select ng-change=PortfolioDetail.statusSchemeType() ng-model=PortfolioDetail.selectedSchemeType ng-options=\"_schemetype.value as _schemetype.key for _schemetype in PortfolioDetail.SCHEMETYPES\" ng-value=_schemetype.value></select></div></div></div><div class=\"list data-grid\"><table class=\"table table-responsive rwd-table\"><thead><tr><th colspan=2>Scheme Name</th><th>Closing Units</th><th>NAV</th><th>NAV AS ON</th><!--<th>Average NAV</th>--><th>Cost Value (<i class=rupee-small-icon></i>)<br></th><th>Market Value (<i class=rupee-small-icon></i>)<br></th><th></th><!--<th class=\"text-center\">Action</th>--><!--        <th>XIRR (%)</th>--></tr></thead><tbody><tr ng-repeat=\"val in PortfolioDetail.portfolioData track by $index \"><td colspan=2 data-th=Scheme><!-- ng-click=\"PortfolioDetail.transactionOverview(val.scheme, val.schemeCode)\"--> <span class=text-blue ng-bind-html=val.scheme|linebreak:8></span><!--<p class=\"small-grey-text\"> {{val.type}} {{val.investmentOption!=\'null\' ?\' - \'+val.investmentOption:\'\'}}</p>--></td><td data-th=\"Closing Units\" easyassist-key=mask-element>{{val.totalUnit | truncateDecimal : 3}}</td><td data-th=NAV>{{val.nav | truncateDecimal : 4}}</td><td data-th=\"Nav as on\">{{val.navDate}}</td><!--<td data-th=\"NAV Average\">{{val.navAverage }}</td>--><!--<td data-th=\"IRR\" ng-if=\"(val.currentValue!=0 || val.purchaseValue!=0) && $index%2==0\">6.0 %</td>\n        <td data-th=\"IRR\" ng-if=\"(val.currentValue!=0 || val.purchaseValue!=0) && $index%2!=0\">7.8 %</td>\n        <td data-th=\"IRR\" ng-if=\"(val.currentValue==0 && val.purchaseValue==0)\">0</td>--><td data-th=\"Cost Value\" class=text-left><span easyassist-key=mask-element>{{val.purchaseValue| truncateDecimal : 3 | unit : val.purchaseValueUnit}}{{val.purchaseValueUnit|unitValue}}</span></td><td data-th=\"Market Value\" class=text-left><span easyassist-key=mask-element>{{val.currentValue | truncateDecimal : 2 | unit : val.purchaseValueUnit}}{{val.currentValueUnit|unitValue}}</span></td><td data-th=Action><span class=\"btn-more dropdown\" ng-if=\"val.topUpAction.length > 0\"><button class=\"btn-primary-action dropdown-toggle\" data-bs-toggle=dropdown ng-if=\"val.folioNumber && val.topUpAction !== undefined && val.schemeCode && val.topUpAction.length!==0\">{{PortfolioDetail.topUpLabel || PortfolioDetail.top_Up_label}} <i class=arrow-white-down-icon></i></button><ul class=dropdown-menu><li>{{PortfolioDetail.topUpLabel || PortfolioDetail.top_Up_label}} <i class=arrow-blue-down-icon></i></li><li class=list-group-item ng-click=PortfolioDetail.selectPortfolioTransaction(action,val) ng-repeat=\"action in val.topUpAction\">{{action}} <i class=\"arrow-right-icon pull-right\"></i></li></ul></span></td><!--        <td data-th=\"IRR\"><span>({{val.irr | number:2}})</span></td>--><!--<td data-th=\"Action\">\n\n            <span class=\"btn-more dropdown\">\n              <button class=\"btn-secondary-action dropdown-toggle\" data-toggle=\"dropdown\"> Transact  <i class=\"arrow-blue-down-icon\"></i> </button>\n              <ul class=\"dropdown-menu\">\n                <li>Transact  <i class=\"arrow-blue-down-icon\"></i></li>\n                <li class=\"list-group-item\" ng-click=\"PortfolioDetail.selectTransaction(action,val)\" ng-repeat=\"action in val.action\">\n                  {{action}}  <i class=\"arrow-right-icon pull-right\"></i>\n                </li>\n              </ul>\n            </span>\n          </span>\n        </td>--></tr><tr class=total-strip ng-if=\"PortfolioDetail.portfolioData && PortfolioDetail.portfolioData.length\"><td><strong>TOTAL</strong></td><td colspan=4></td><td easyassist-key=mask-element><strong>{{PortfolioDetail.totalMarketValueCount| truncateDecimal : 2 |unit:PortfolioDetail.totalMarketValueCountUnit}}{{PortfolioDetail.totalMarketValueCountUnit|unitValue}}</strong></td><td easyassist-key=mask-element><strong>{{PortfolioDetail.totalCostValueCount | truncateDecimal : 2 | unit:PortfolioDetail.totalMarketValueCountUnit}}{{PortfolioDetail.totalCostValueCountUnit|unitValue}}</strong></td><td></td></tr></tbody><tbody><tr ng-if=(!PortfolioDetail.portfolioData||!PortfolioDetail.portfolioData.length)&&!PortfolioDetail.isLoading><td colspan=9>No Record found</td></tr></tbody></table><div class=end-pagination ng-if=\"PortfolioDetail.isPagination && PortfolioDetail.totalPortfolioData > PortfolioDetail.pageLimitPortfolio\"><div class=\"total-data pagination\"><span>Showing &nbsp</span> <span ng-if=\"PortfolioDetail.totalPortfolioData <= PortfolioDetail.PAGE_LIMITS[0]\" ng-bind=PortfolioDetail.totalPortfolioData></span><select ng-if=\"PortfolioDetail.totalPortfolioData > PortfolioDetail.PAGE_LIMITS[0]\" ng-change=PortfolioDetail.pageLimitListChange() ng-model=PortfolioDetail.pageLimitPortfolio ng-options=\"_limit as _limit for _limit in PortfolioDetail.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black ng-bind=PortfolioDetail.totalPortfolioData>205</span></div><ul uib-pagination total-items=PortfolioDetail.totalPortfolioData ng-model=PortfolioDetail.currentPagePortfolio max-size=5 items-per-page=PortfolioDetail.pageLimitPortfolio class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=PortfolioDetail.initPortfolioList() rotate=false></ul></div></div></div><style>.loading-text{\n    width: 298px;\n    height: 50px;\n    left: 0;\n    right: 0;\n    margin: auto;\n    top: 113px;\n    bottom: 0;\n    position: absolute;\n    z-index: 2;\n    background-repeat: no-repeat;\n    background-size: 48px;\n    font-weight:bold;\n  }\n  .flow-card-marketValue{\n    border-right: 1px solid #cccccc\n  }\n\n  #portfolio .top-flow .flow-card span.xirrContent{\n    margin-bottom: 0px;\n    color: #000;\n    text-align: left;\n    font-size: 24px;\n    line-height: 24px;\n    display: inline;\n  }\n  #portfolio .top-flow .flow-card:last-child span.value{\n    display: inline-block;\n  }\n  #portfolio .top-flow .flow-card:last-child i.info-icon{\n    vertical-align: top;\n    margin-top: -2px;\n  }</style>");
$templateCache.put("app/savedItems/components/savedItemsTupple.html","<ul><li ng-repeat=\"item in list  | limitTo: limit  track by $index \"><span ng-if=\"type!=\'transaction\'\">{{item.holdingStatus}}</span> <span>{{type===\'transaction\'?item.type.toUpperCase():item.investorName}} {{item.taxStatusDescription?\'(\' +item.taxStatusDescription + \')\':\'\'}}</span><!--+($index +1)--> <span ng-if=\"type===\'transaction\'\" class=date>{{item.schemeName}}</span> <span class=date>{{type===\'transaction\'?item.initiateDate:item.lastModified}}</span> <span class=icons-block><span><i class=delete-icon ng-click=delete(item)></i></span> <span><i class=view-icon ng-click=\"type===\'transaction\'? view({tID:item.transactionId,ctID:item.compositeTransactionId,tType:item.transactionType}) : view({uuid:item.folioId})\"></i></span></span></li></ul><span ng-show=showViewMoreFlag ng-click=showMore() class=\"pull-right view-more\"><i class=expand-block-icon></i> View More</span>");
$templateCache.put("app/services/modal/modal-popup.html","<div data-ng-switch=Modal.view><div data-ng-switch-when=REGISTER_SUCCESS><div data-ng-include=\"\'app/components/modal/register/registration.modal.html\'\"></div></div><div data-ng-switch-when=REGISTER_USER><div data-ng-include=\"\'app/components/modal/existingUser/existinguser.modal.html\'\"></div></div><div data-ng-switch-when=NON_KYC><div data-ng-include=\"\'app/components/modal/register/nonKyc.modal.html\'\"></div></div><div data-ng-switch-when=INITIATE_SUCCESS><div data-ng-include=\"\'app/components/modal/initiateTransaction/success.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_SCHEME_LIST><div data-ng-include=\"\'app/components/modal/schemeList/schemeList.model.html\'\"></div></div><div data-ng-switch-when=Add_Link_Pan><div data-ng-include=\"\'app/components/modal/addLinkPan/addLinkPan.modal.html\'\"></div></div><div data-ng-switch-when=SUCCESS_MESSAGE><div data-ng-include=\"\'app/components/modal/successMessage/success.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_CANCEL><div data-ng-include=\"\'app/components/modal/confirmCancel/confirm-cancel.modal.html\'\"></div></div><div data-ng-switch-when=REJECTION_REASON><div data-ng-include=\"\'app/components/modal/confirmCancel/rejectionReason.modal.html\'\"></div></div><div data-ng-switch-when=FOLIO_SUCCESS_MESSAGE><div data-ng-include=\"\'app/components/modal/folioCreation/folio-success.modal.html\'\"></div></div><div data-ng-switch-when=IFSC_SELECTION><div data-ng-include=\"\'app/components/modal/IFSCSelection/ifsc-selection.modal.html\'\"></div></div><div data-ng-switch-when=IFSC_SELECTION_NEW_JOURNEY><div data-ng-include=\"\'app/components/modal/IFSCSelectionNewJourney/ifsc-selection-new-journey.modal.html\'\"></div></div><div data-ng-switch-when=MAP_FOLIO><div data-ng-include=\"\'app/components/modal/dashboard/mapfolio.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_OTP><div data-ng-include=\"\'app/components/modal/confirmOtpReg/confirmOtp.modal.html\'\"></div></div><div data-ng-switch-when=ADD_JOINT_HOLDER><div data-ng-include=\"\'app/components/modal/addJointHolder/addJointHolder.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_OTP_SUCCESS><div data-ng-include=\"\'app/components/modal/confirmOtpReg/confirmOtpSuccess.modal.html\'\"></div></div><div data-ng-switch-when=RESET_PASSWORD_SUCCESS><div data-ng-include=\"\'app/components/modal/resetPassword/resetPasswordSuccess.modal.html\'\"></div></div><div data-ng-switch-when=FORGOT_PASSWORD><div data-ng-include=\"\'app/components/modal/forgotPassword/forgotPassword.modal.html\'\"></div></div><div data-ng-switch-when=CREATE_USER_SUCCESS><div data-ng-include=\"\'app/components/modal/createUser/createUserId.modal.html\'\"></div></div><div data-ng-switch-when=CREATE_USER_EMAIL_ERROR><div data-ng-include=\"\'app/components/modal/createUser/createUserIdEmailError.modal.html\'\"></div></div><div data-ng-switch-when=CHANGE_PASSWORD><div data-ng-include=\"\'app/components/modal/resetPassword/changePassword.modal.html\'\"></div></div><div data-ng-switch-when=CHANGE_PASSWORD_SUCCESS><div data-ng-include=\"\'app/components/modal/resetPassword/changePasswordSuccess.modal.html\'\"></div></div><div data-ng-switch-when=TERM_CONDITION><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTIONAL_TERM_CONDITION><div data-ng-include=\"\'app/components/modal/transactionalTnc/transactionalTermcondition.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTIONAL_TERM_CONDITION_E_MANDATE><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSipEMandate.html\'\"></div></div><div data-ng-switch-when=NON_TRANSACTIONAL_TERM_CONDITION><div data-ng-include=\"\'app/components/modal/nonTransactionalTnc/nonTransactionalTnc.modal.html\'\"></div></div><div data-ng-switch-when=MANUAL_INSTRUCTIONS><div data-ng-include=\"\'app/components/modal/transactions/manualInstructions.modal.html\'\"></div></div><div data-ng-switch-when=DREAM_SIP_CHANGE_OPTION><div data-ng-include=\"\'app/components/modal/dreamSip/changeOption.modal.html\'\"></div></div><div data-ng-switch-when=CHANGE_TARGET_SCHEME><div data-ng-include=\"\'app/components/modal/dreamSip/changeTargetScheme.modal.html\'\"></div></div><div data-ng-switch-when=DREAM_SIP_POINT_TO_NOTE><div data-ng-include=\"\'app/components/modal/dreamSip/pointToNote.modal.html\'\"></div></div><div data-ng-switch-when=SUCCESS_TRANSACTION><div data-ng-include=\"\'app/components/modal/transactions/transaction.success.html\'\"></div></div><div data-ng-switch-when=CHANGE_DIVIDEND><div data-ng-include=\"\'app/components/modal/changeDividend/changeDividend.modal.html\'\"></div></div><div data-ng-switch-when=CHANGE_DIVIDEND_SUCCESS><div data-ng-include=\"\'app/components/modal/changeDividend/changeDividendSuccess.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_REGISTER><div data-ng-include=\"\'app/components/modal/register/confirmRegister.modal.html\'\"></div></div><div data-ng-switch-when=REDIRECT_TO_OLD_FOLIO><div data-ng-include=\"\'app/components/modal/register/redirectToOldFolio.modal.html\'\"></div></div><div data-ng-switch-when=ARN_POPUP><div data-ng-include=\"\'app/components/modal/arnPopup/arnPopup.modal.html\'\"></div></div><div data-ng-switch-when=OTP_CONFIRM><div data-ng-include=\"\'app/components/modal/otp/otp.modal.html\'\"></div></div><div data-ng-switch-when=OTP_CONFIRM_SUCCESS><div data-ng-include=\"\'app/components/modal/otp/otpSuccess.modal.html\'\"></div></div><div data-ng-switch-when=OTP_NOMINEE_UPDATE><div data-ng-include=\"\'app/components/modal/otp/nomineeUpdate.modal.html\'\"></div></div><div data-ng-switch-when=WIDGET_SELECTION><div data-ng-include=\"\'app/components/modal/widgetStore/widgetSelection.modal.html\'\"></div></div><div data-ng-switch-when=SAVED_TRANSACTION><div data-ng-include=\"\'app/components/modal/initiateTransaction/saved.modal.html\'\"></div></div><div data-ng-switch-when=ADD_TAX_RESIDENCY><div data-ng-include=\"\'app/components/modal/profile/addTaxResidency.modal.html\'\"></div></div><div data-ng-switch-when=DASHBOARD_EDIT_SUCCESS><div data-ng-include=\"\'app/components/modal/editDashboard/success.edit.html\'\"></div></div><div data-ng-switch-when=DELETE_TAX_RESIDENCY><div data-ng-include=\"\'app/components/modal/profile/deleteTaxResidency.modal.html\'\"></div></div><div data-ng-switch-when=NOTIFICATION_DETAILS><div data-ng-include=\"\'app/components/modal/notification/notification.modal.html\'\"></div></div><div data-ng-switch-when=CANCEL_SIP><div data-ng-include=\"\'app/components/modal/cancelSIP/cancelSIP.modal.html\'\"></div></div><div data-ng-switch-when=CANCEL_SIP_SUCCESS><div data-ng-include=\"\'app/components/modal/cancelSIP/cancelSipSuccess.modal.html\'\"></div></div><div data-ng-switch-when=UNCLAIMED_DIVIDEND><div data-ng-include=\"\'app/components/modal/profile/unclaimedDetails.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_SUMMARY><div data-ng-include=\"\'app/components/modal/transactionSummary/transaction-summary.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_SCHEME_LIST_INSTANT><div data-ng-include=\"\'app/components/modal/schemeListInstant/schemeListInstant.model.html\'\"></div></div><div data-ng-switch-when=FEEDBACK_SUCCESS><div data-ng-include=\"\'app/components/modal/feedback/feedback.modal.html\'\"></div></div><div data-ng-switch-when=STATEMENT_PDF><div data-ng-include=\"\'app/components/modal/statements/statementpdf.modal.html\'\"></div></div><div data-ng-switch-when=ROLL_OVER_OVERVIEW><div data-ng-include=\"\'app/components/modal/rollOver/rollOverOverview.modal.html\'\"></div></div><div data-ng-switch-when=ROLL_OVER_CONFIRM><div data-ng-include=\"\'app/components/modal/rollOver/rollOverConfirm.modal.html\'\"></div></div><div data-ng-switch-when=ROLL_OVER_SUCCESS><div data-ng-include=\"\'app/components/modal/rollOver/rollOverSuccess.modal.html\'\"></div></div><div data-ng-switch-when=ENTER_EMAIL_VERIFICATION><div data-ng-include=\"\'app/components/modal/email-verification/enter-email.modal.html\'\"></div></div><div data-ng-switch-when=OTP_VERIFICATION><div data-ng-include=\"\'app/components/modal/email-verification/enter-otp.modal.html\'\"></div></div><div data-ng-switch-when=EMAIL_VERIFICATION_SUCCESS><div data-ng-include=\"\'app/components/modal/email-verification/email-verified.modal.html\'\"></div></div><div data-ng-switch-when=SELF_DECLARE><div data-ng-include=\"\'app/components/modal/folioCreation/self-declaration.modal.html\'\"></div></div><div data-ng-switch-when=CUT_OFF><div data-ng-include=\"\'app/components/modal/popups/cutoff.modal.html\'\"></div></div><div data-ng-switch-when=CHILDREN_FUND_MSG><div data-ng-include=\"\'app/components/modal/cancelSIP/childrenFundMessage.modal.html\'\"></div></div><div data-ng-switch-when=PURCHASE_NETBANKING><div data-ng-include=\"\'app/components/modal/popups/purchaseNetBanking.modal.html\'\"></div></div><div data-ng-switch-when=PURCHASE_LIQUID><div data-ng-include=\"\'app/components/modal/popups/purchaseLiquid.modal.html\'\"></div></div><div data-ng-switch-when=REDEMPTION_CONFIRM><div data-ng-include=\"\'app/components/modal/redemptionConfirm/redemptionConfirm.modal.html\'\"></div></div><div data-ng-switch-when=EDIT_SUBSCRIPTION><div data-ng-include=\"\'app/components/modal/subscriptions/editSubscription.modal.html\'\"></div></div><div data-ng-switch-when=EDIT_SUBSCRIPTION_SUCCESS><div data-ng-include=\"\'app/components/modal/subscriptions/editSuccess.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_UNSUBSCRIBE><div data-ng-include=\"\'app/components/modal/subscriptions/confirmUnsubscribe.modal.html\'\"></div></div><div data-ng-switch-when=ADD_BANK><div data-ng-include=\"\'app/components/modal/modifyBank/addSuccess.modal.html\'\"></div></div><div data-ng-switch-when=DELETE_BANK><div data-ng-include=\"\'app/components/modal/modifyBank/deleteBank.modal.html\'\"></div></div><div data-ng-switch-when=DELETE_BANK_SUCCESS><div data-ng-include=\"\'app/components/modal/modifyBank/deleteSuccess.modal.html\'\"></div></div><div data-ng-switch-when=CHANGE_BANK_SUCCESS><div data-ng-include=\"\'app/components/modal/modifyBank/changeSuccess.modal.html\'\"></div></div><div data-ng-switch-when=CHANGE_DEFAULT_BANK><div data-ng-include=\"\'app/components/modal/modifyBank/changeDefaultBank.modal.html\'\"></div></div><div data-ng-switch-when=UPI_SUCCESS><div data-ng-include=\"\'app/components/modal/initiateTransaction/upisuccess.modal.html\'\"></div></div><div data-ng-switch-when=STAY_INVESTED><div data-ng-include=\"\'app/components/modal/redemptionConfirm/stayInvested.modal.html\'\"></div></div><div data-ng-switch-when=LOGIN_LOADER><div data-ng-include=\"\'app/components/modal/login-loader/login-loader.modal.html\'\"></div></div><div data-ng-switch-when=LOGIN_VIDEO><div data-ng-include=\"\'app/components/modal/login-video/login-video.modal.html\'\"></div></div><div data-ng-switch-when=ADD_FATCA_TAX_RESIDENCY><div data-ng-include=\"\'app/components/modal/profile/addFatcaTaxResidency.modal.html\'\"></div></div><div data-ng-switch-when=SELECT_ACCOUNT_NO><div data-ng-include=\"\'app/components/modal/selectAccount/selectAccount.modal.html\'\"></div></div><div data-ng-switch-when=CHECK_PAN><div data-ng-include=\"\'app/components/modal/createUser/pan-verification.modal.html\'\"></div></div><div data-ng-switch-when=SHOW_IMAGE><div data-ng-include=\"\'app/components/modal/showImage/showImage.modal.html\'\"></div></div><div data-ng-switch-when=FOLIO_SUCCESS><div data-ng-include=\"\'app/components/modal/folioSuccess/folioSuccess.modal.html\'\"></div></div><div data-ng-switch-when=HOLD_HOLDER><div data-ng-include=\"\'app/components/modal/holdHolderNewJourney/hold.modal.html\'\"></div></div><div data-ng-switch-when=SHOW_IMAGE1><div data-ng-include=\"\'app/components/modal/showImage/showImage1.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_LOGIN><div data-ng-include=\"\'app/components/modal/confirmLoginReg/confirmLogin.modal.html\'\"></div></div><div data-ng-switch-when=OFF_LINE_USER_MSG><div data-ng-include=\"\'app/components/modal/changeDividend/offlineUserMsg.modal.html\'\"></div></div><div data-ng-switch-when=REGISTER_EMANDATE><div data-ng-include=\"\'app/components/modal/transactions/registerEMandate.modal.html\'\"></div></div><div data-ng-switch-when=TPV_MODAL><div data-ng-include=\"\'app/components/modal/tpv/tpv.modal.html\'\"></div></div><div data-ng-switch-when=MINOR_BANK_MODAL><div data-ng-include=\"\'app/components/modal/popups/minor.bank.html\'\"></div></div><div data-ng-switch-when=MINOR_SIP_MODAL><div data-ng-include=\"\'app/components/modal/popups/minor.sip.modal.html\'\"></div></div><div data-ng-switch-when=MINOR_PURCHASE_MODAL><div data-ng-include=\"\'app/components/modal/popups/minor.purchase.modal.html\'\"></div></div><div data-ng-switch-when=ADD_BANK_MSG><div data-ng-include=\"\'app/components/modal/popups/add.bank.msg.html\'\"></div></div><div data-ng-switch-when=ADD_BANK_COBM_DISABLED><div data-ng-include=\"\'app/components/modal/popups/addBank.cobm.disabled.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_WARNING><div data-ng-include=\"\'app/components/modal/transactionWarning/transaction-warning.modal.html\'\"></div></div><div data-ng-switch-when=SCHEDULE_TRANSACTION><div data-ng-include=\"\'app/components/modal/scheduleTransaction/schedule-transaction.modal.html\'\"></div></div><div data-ng-switch-when=OTP_FOR_APPROVAL><div data-ng-include=\"\'app/components/modal/otp/otp-verification.modal.html\'\"></div></div><div data-ng-switch-when=KYC_REJECT><div data-ng-include=\"\'app/components/modal/register/kycReject.modal.html\'\"></div></div><div data-ng-switch-when=CANCEL_MANDATE><div data-ng-include=\"\'app/components/modal/cancelMandate/cancelMandate.modal.html\'\"></div></div><div data-ng-switch-when=NFO_ENABLED><div data-ng-include=\"\'app/components/modal/nfoEnabled/nfoEnabled.modal.html\'\"></div></div><div data-ng-switch-when=GENERIC_MODAL><div data-ng-include=\"\'app/components/modal/genericModal/generic.modal.html\'\"></div></div><div data-ng-switch-when=ECART_SUCCESS_MODAL><div data-ng-include=\"\'app/components/modal/popups/eCart.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_CANCEL_ECART><div data-ng-include=\"\'app/components/modal/confirmCancel/confirm-cancel-ecart.modal.html\'\"></div></div><div data-ng-switch-when=VIDEO_MODAL><div data-ng-include=\"\'app/components/modal/video-modal/video.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_CANCEL_PRELOGIN><div data-ng-include=\"\'app/components/modal/confirmCancel/confirm-cancel-prelogin.html\'\"></div></div><div data-ng-switch-when=DECLARATION><div data-ng-include=\"\'app/components/modal/declaration/declaration.modal.html\'\"></div></div><div data-ng-switch-when=SUBSCRIBE_TOGGLE_MODAL><div data-ng-include=\"\'app/components/modal/subscribeToggle/subscribeToggle.modal.html\'\"></div></div><div data-ng-switch-when=NUDGE_REASONS><div data-ng-include=\"\'app/components/modal/nudgeReasons/nudgeReasons.modal.html\'\"></div></div><div data-ng-switch-when=STOP_SCHEDULE_REDEEM><div data-ng-include=\"\'app/components/modal/redemptionConfirm/nudgeScheduleRedemption.html\'\"></div></div><div data-ng-switch-when=CHOOSE_PAUSE><div data-ng-include=\"\'app/components/modal/confirmCancel/sip-corner-pause.modal.html\'\"></div></div><div data-ng-switch-when=TERM_CONDITION_SIP><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\"></div></div><div data-ng-switch-when=SUBSCRIBE_WHATSAPP><div data-ng-include=\"\'app/components/modal/subscribeWhatsapp/subscribeWhatsapp.modal.html\'\"></div></div><div data-ng-switch-when=SUBSCRIBE_WHATSAPP_SECOND_STEP><div data-ng-include=\"\'app/components/modal/subscribeWhatsapp/subscribeWhatsappSecondStep.modal.html\'\"></div></div><div data-ng-switch-when=SUBSCRIBE_WHATSAPP_TnC><div data-ng-include=\"\'app/components/modal/subscribeWhatsapp/subscribeWhatsappTnC.modal.html\'\"></div></div><div data-ng-switch-when=SESSION_EXPIRE><div data-ng-include=\"\'app/components/modal/session/session.modal.html\'\"></div></div><div data-ng-switch-when=SESSION_ACTIVE><div data-ng-include=\"\'app/components/modal/session/active-session.modal.html\'\"></div></div><div data-ng-switch-when=NFO_POINT_NOTES><div data-ng-include=\"\'app/components/modal/nfoTransactionNotes/nfoTransactionNotes.modal.html\'\"></div></div><div data-ng-switch-when=CANCEL_NOMINEE><div data-ng-include=\"\'app/components/modal/cancelNominee/cancelNominee.modal.html\'\"></div></div><div data-ng-switch-when=OFFLINE_NOMINEE_FORM><div data-ng-include=\"\'app/components/modal/offlineNomineeForm/offLineNominee.modal.html\'\"></div></div><div data-ng-switch-when=UPDATE_NOMINEE_SUCCESS><div data-ng-include=\"\'app/components/modal/updateNominee/updateNomineeSuccess.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_OTP_MODAL><div data-ng-include=\"\'app/components/modal/transactionOtp/transaction.otp.modal.html\'\"></div></div><div data-ng-switch-when=HDFC_BANK_MODAL><div data-ng-include=\"\'app/components/modal/hdfcBankModal/hdfcbank.modal.html\'\"></div></div><div data-ng-switch-when=ARN_ADD_BANK_MODAL><div data-ng-include=\"\'app/components/modal/arnAddBank/arnaddbank.modal.html\'\"></div></div><div data-ng-switch-when=REGISTER_EMANDATE_NEW_INVESTOR_JOURNEY><div data-ng-include=\"\'app/components/modal/registerEmandateNewJourney/registerEmandateNewJourney.modal.html\'\"></div></div><div data-ng-switch-when=NEW_JOURNEY_REGISTERED><div data-ng-include=\"\'app/components/modal/newJourneyRegistered/newJourneyRegistered.modal.html\'\"></div></div><div data-ng-switch-when=Dream_Sip_Tenure><div data-ng-include=\"\'app/components/modal/dreamSipTenure/dream.sip.tenure.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_DREAM_SCHEME_LIST><div data-ng-include=\"\'app/components/modal/dreamSchemeList/dreamSchemeList.model.html\'\"></div></div><div data-ng-switch-when=INVESTMENT_PERSONALITY_MODAL><div data-ng-include=\"\'app/components/modal/investmentPersonality/investment.personality.modal.html\'\"></div></div><div data-ng-switch-when=INVESTMENT_INSTALLMENT_DETAIL_MODAL><div data-ng-include=\"\'app/components/modal/basketSipInstallmentDetails/basketSipInstallmentDetails.modal.html\'\"></div></div><div data-ng-switch-when=SIP_OR_PURCHASE_BASKET><div data-ng-include=\"\'app/components/modal/sipOrPurchaseBasket/sipOrPurchaseBasket.modal.html\'\"></div></div><div data-ng-switch-when=FILL_FOLIO_DETAIL_MODAL><div data-ng-include=\"\'app/components/modal/fill-folio-detail/fillFolioDetail.modal.html\'\"></div></div><div data-ng-switch-when=SELECT_FOLIO><div data-ng-include=\"\'app/components/modal/select-folio/select.folio.modal.html\'\"></div></div><div data-ng-switch-when=UNSAVED_CHANGES><div data-ng-include=\"\'app/components/modal/unsaved-changes/unsaved-changes.modal.html\'\"></div></div><div data-ng-switch-when=FOLIO_CHOICE_MODAL><div data-ng-include=\"\'app/components/modal/folio-choice/folio-choice.modal.html\'\"></div></div><div data-ng-switch-when=DECISION_FOLIO_MODAL><div data-ng-include=\"\'app/components/modal/decisionModal/decision.modal.html\'\"></div></div><div data-ng-switch-when=ONE_CLICK_PANAADHAR_STATUS_MODAL><div data-ng-include=\"\'app/components/modal/oneclickpanaadharstatus/oneclickpanaadharstatus.modal.html\'\"></div></div><div data-ng-switch-when=PREFILL_FOLIO><div data-ng-include=\"\'app/components/modal/prefill-folio/prefill.folio.modal.html\'\"></div></div><div data-ng-switch-when=CONTACT_SAVE_MODAL><div data-ng-include=\"\'app/components/modal/contactSave/contactSave.modal.html\'\"></div></div><div data-ng-switch-when=OPT_OUT_NOMINEE_MODAL><div data-ng-include=\"\'app/components/modal/optOutNominee/optOutNominee.modal.html\'\"></div></div><div data-ng-switch-when=NOMINEE_UPDATE_VERIFICATION_ON_SMARTLINK><div data-ng-include=\"\'app/components/modal/otpForApproval/nomineeUpdateVerification.modal.html\'\"></div></div><div data-ng-switch-when=NOTIFICATION_OF_NOMINEE_ON_LOGIN><div data-ng-include=\"\'app/components/modal/notificationModal/nomineeUpdateNotification.modal.html\'\"></div></div><div data-ng-switch-when=CONTACT_OTP_MODAL><div data-ng-include=\"\'app/components/modal/otp/contact-otp-modal/contact-otp.modal.html\'\"></div></div><div data-ng-switch-when=PURCHASE_SCHEDULE_CANCEL><div data-ng-include=\"\'app/components/modal/purchaseScheduleCancel/purchaseScheduleCancel.html\'\"></div></div><div data-ng-switch-when=PURCHASE_SCHEDULE_SCHEMES><div data-ng-include=\"\'app/components/modal/purchaseScheduleSchemes/purchaseScheduleSchemes.html\'\"></div></div><div data-ng-switch-when=SIP_TOP_UP_DETAILS_MODAL><div data-ng-include=\"\'app/components/modal/sipTopupDetailsModal/sipTopupDetails.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_SCHEME_LIST_NEW_MODAL><div data-ng-include=\"\'app/components/modal/schemeListNewModal/schemeListNew.modal.html\'\"></div></div><div data-ng-switch-when=SIP_DETAILS_MODAL><div data-ng-include=\"\'app/components/modal/sipDetailsModal/sipDetails.modal.html\'\"></div></div><div data-ng-switch-when=OTP_AUTO_MOVE_TO_NEXT_FIELD><div data-ng-include=\"\'app/components/modal/otpVerificationNew/otpAutoMoveToNextField.modal.html\'\"></div></div><div data-ng-switch-when=LOGIN_WITH_MOBILE><div data-ng-include=\"\'app/components/modal/loginWithMobile/login_with_mobile.modal.html\'\"></div></div><div data-ng-switch-when=OTP_VERIFY_CONFIRM><div data-ng-include=\"\'app/components/modal/otpForPanLinkDelink/otpVerificationConfirm.modal.html\'\"></div></div><div data-ng-switch-when=NJ_NOTE_LOGIN_WITH_MOBILE><div data-ng-include=\"\'app/components/modal/loginWithMobileNoteNJ/loginWithMobileNoteNJ.modal.html\'\"></div></div><div data-ng-switch-when=MOBILE_TERM_AND_CONDITION><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\"></div></div><div data-ng-switch-when=NJ_CONTACT_UPDATE_LOGIN_WITH_MOBILE><div data-ng-include=\"\'app/components/modal/loginWithMobileContactUpdateNJ/loginWithMobileContactUpdateNJ.modal.html\'\"></div></div></div>");
$templateCache.put("app/subscription-valuation/subscriptions/NAVs.html","<section class=nav-subscription ng-init=SubscriptionValuation.init()><div class=content-area><div class=\"form-group col-md-12\"><p class=title>Get Updates on</p><div><div class=radio-block><span class=radio><input id=email type=radio name=modes value=EMAIL ng-model=SubscriptionValuation.mode ng-change=\"SubscriptionValuation.modeChanged(\'scheme\')\"> <span class=check></span></span><label class=radio-label for=email>Email</label></div><div class=radio-block><span class=radio><input id=sms type=radio name=modes value=SMS ng-model=SubscriptionValuation.mode ng-change=\"SubscriptionValuation.modeChanged(\'scheme\')\"> <span class=check></span></span><label class=radio-label for=sms>SMS</label></div><div class=radio-block><span class=radio><input id=both type=radio name=modes value=BOTH ng-model=SubscriptionValuation.mode ng-change=\"SubscriptionValuation.modeChanged(\'scheme\')\"> <span class=check></span></span><label class=radio-label for=both>Both</label></div></div></div><div class=\"form-group col-md-12 select-schemes\" ng-if=SubscriptionValuation.schemeList.length><p class=\"title clearfix\"><span class=pull-left>Select Schemes for Subscriptions</span> <span class=pull-right><button type=button class=\"btn-small btn-secondary-action\" ng-class=\"{\'disabled\':(SubscriptionValuation.checkedScheme==0)}\" ng-disabled=\"SubscriptionValuation.checkedScheme==0\" ng-click=SubscriptionValuation.subscribeSchemes()>Subscribe</button></span></p><div><div class=checkbox ng-if=SubscriptionValuation.schemeList.length><input type=checkbox ng-model=SubscriptionValuation.checkall ng-click=\"SubscriptionValuation.checkAll(\'scheme\')\"> <i class=icon-checkbox></i> <span class=checkbox-text>All Schemes</span></div><div class=checkbox ng-if=SubscriptionValuation.schemeList.length ng-repeat=\"scheme in SubscriptionValuation.schemeList\"><input type=checkbox ng-model=scheme.selected ng-click=\"SubscriptionValuation.calculateChecked(\'scheme\')\"> <i class=icon-checkbox></i> <span class=checkbox-text>{{scheme.schemeName}}</span></div></div></div><div class=\"form-group col-md-12\" ng-if=SubscriptionValuation.subscriptions.length><p class=title>Ongoing Subscriptions</p><table class=\"table table-striped\"><thead><tr><th>Schemes</th><th>Medium</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"data in SubscriptionValuation.subscriptions\"><td>{{data.schemeName}}</td><td>{{data.mode}}</td><td><button type=button class=\"btn-small btn-secondary-action\" ng-click=\"SubscriptionValuation.unsubscribeSubscription(\'scheme\',data)\">Unsubscribe</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"SubscriptionValuation.editSubscription(\'scheme\', data)\">Edit</button></td></tr></tbody></table></div></div></section>");
$templateCache.put("app/subscription-valuation/subscriptions/folio-valuation.html","<section class=folio-valuation ng-init=SubscriptionValuation.init()><div class=content-area><div class=\"form-group col-md-12\"><p class=title>Get Updates on</p><div><div class=radio-block><span class=radio><input id=email type=radio name=modes value=EMAIL ng-model=SubscriptionValuation.mode ng-change=\"SubscriptionValuation.modeChanged(\'folio\')\"> <span class=check></span></span><label class=radio-label for=email>Email</label></div><div class=radio-block><span class=radio><input id=sms type=radio name=modes value=SMS ng-model=SubscriptionValuation.mode ng-change=\"SubscriptionValuation.modeChanged(\'folio\')\"> <span class=check></span></span><label class=radio-label for=sms>SMS</label></div><div class=radio-block><span class=radio><input id=both type=radio name=modes value=BOTH ng-model=SubscriptionValuation.mode ng-change=\"SubscriptionValuation.modeChanged(\'folio\')\"> <span class=check></span></span><label class=radio-label for=both>Both</label></div></div></div><div class=\"form-group col-md-12\"><p class=title>Select Frequency <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip style=top:4px data-bs-placement=right title=\"<strong style=\'font-size:14px;margin-bottom:10px;\'>Subscription Frequency</strong>\n            </br>Weekly: You will get updates on fridays\n            </br>Monthly: You will get updates on 1st day of the month.\"></i></p><div><div class=radio-block><span class=radio><input type=radio id=daily type=radio name=frequency value=DAILY ng-model=SubscriptionValuation.frequency> <span class=check></span> </span><span class=radio-label>Daily</span></div><div class=radio-block><span class=radio><input type=radio type=radio id=weekly type=radio name=frequency value=WEEKLY ng-model=SubscriptionValuation.frequency> <span class=check></span> </span><span class=radio-label>Weekly</span></div><div class=radio-block><span class=radio><input type=radio type=radio id=monthly type=radio name=frequency value=MONTHLY ng-model=SubscriptionValuation.frequency> <span class=check></span> </span><span class=radio-label>Monthly</span></div></div></div><div class=\"form-group col-md-12 select-folios\" ng-if=SubscriptionValuation.folioList.length><p class=\"title clearfix\"><span class=pull-left>Select Folio(s) for Subscriptions</span> <span class=pull-right><button type=button class=\"btn-small btn-secondary-action\" ng-class=\"{\'disabled\':(SubscriptionValuation.checkedFolio==0)}\" ng-disabled=\"SubscriptionValuation.checkedFolio==0\" ng-click=SubscriptionValuation.subscribeFolios()>Subscribe</button> </span><!--editSubscriptionSuccess()--></p><div><div class=checkbox ng-if=SubscriptionValuation.folioList.length><input type=checkbox ng-model=SubscriptionValuation.checkall ng-click=\"SubscriptionValuation.checkAll(\'folio\')\"> <i class=icon-checkbox></i> <span class=checkbox-text>All Folios</span></div><div class=checkbox ng-if=SubscriptionValuation.folioList.length ng-repeat=\"folio in SubscriptionValuation.folioList\"><input type=checkbox ng-model=folio.selected ng-checked=folio.selected ng-click=\"SubscriptionValuation.calculateChecked(\'folio\')\"> <i class=icon-checkbox></i> <span class=checkbox-text>{{folio.folio}}</span></div></div></div><div class=\"form-group col-md-12\" ng-if=SubscriptionValuation.subscriptions.length><p class=title>Ongoing Subscriptions</p><div class=col-md-12><table class=\"table table-striped\"><thead><tr><th>Folio No</th><th>Medium</th><th>Frequency</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"data in SubscriptionValuation.subscriptions\"><td>{{data.folioNumber}}</td><td>{{data.mode}}</td><td>{{data.frequency}}</td><td><button type=button class=\"btn-small btn-secondary-action\" ng-click=\"SubscriptionValuation.unsubscribeSubscription(\'folio\',data)\">Unsubscribe</button> <button type=button ng-click=\"SubscriptionValuation.editSubscription(\'folio\', data)\" class=\"btn-small btn-secondary-action\">Edit</button></td></tr></tbody></table></div></div></div></section>");
$templateCache.put("app/transactions/changeDividend/change-dividend.html","<div class=main-section><section class=initiate-transaction><p class=page-title>Change IDCW Option</p><div class=\"content-area redeem\"><form class=row novalidate><div class=\"col-md-4 nobrdr-rgt\"><p class=col-head>Select Scheme for IDCW Change</p><div class=selectfield ng-class={error:Transaction.tForm.folio.$invalid}><select name=folio ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=Transaction.tForm.folio.$error.required ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><div class=selectfield ng-class={error:Transaction.tForm.outScheme.$invalid}><label ng-if=Transaction.formData.outSchemeCode>Select a Scheme</label><select class=\"browser-default custom-select\" name=outScheme ng-change=Transaction.outSchemeChanged() ng-model=Transaction.formData.outSchemeCode ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Transaction.outSchemeList\" ng-init=\"Transaction.formData.outSchemeCode=Transaction.formData.outSchemeCode?Transaction.formData.outSchemeCode: null\" ng-required=Transaction.isRequired><option value=\"\" selected>Select a Scheme</option></select><span class=error-input ng-show=Transaction.tForm.outScheme.$error.required ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span> <span class=info-primary>(Currently Chosen IDCW option: Payout)</span></div><div class=form-group><label class=form-label>Choose IDCW Option:</label><div class=radio-block><span class=radio><input type=radio> <span class=check></span> </span><span class=radio-label>Reinvest</span></div><div class=radio-block><span class=radio><input type=radio> <span class=check></span> </span><span class=radio-label>Payout</span></div></div></div><div class=\"form-footer col-md-12\"><button type=button class=\"btn btn-primary-action\" ng-click=ChangeDividend.submit()>Submit</button></div></form></div></section></div>");
$templateCache.put("app/transactions/favourite/favourite-transactions.html","<div class=\"main-section favourite-transactions\" style=padding-top:90px ng-init=FavTrans.init()><div class=\"container-fluid page-head\"><h3 class=\"screen-title pull-left\">Favourite Transactions</h3><div class=pull-right><span>Filters: &nbsp;</span><div class=filters-group><select id=typeSelect ng-change=FavTrans.fav.typeChangeDropdown(FavTrans.fav.selectedTransactionType) ng-model=FavTrans.fav.selectedTransactionType><option ng-repeat=\"data in FavTrans.fav.transactionTypeListDropdown\" value={{data.value}}>{{data.key}}</option></select><button class=apply-btn ng-click=FavTrans.fav.applyFilter()>Apply</button> <button class=reset-btn ng-click=FavTrans.fav.resetFilter()>Reset</button></div></div></div><div class=content-area><favourite-transactions-tupple data-list=FavTrans.fav.favTransList data-edit=FavTrans.fav.edit data-delete=FavTrans.fav.delete data-cart=FavTrans.fav.cart data-limit=FavTrans.fav.limit data-show-more=FavTrans.fav.showMore data-show-view-more-flag=FavTrans.fav.showViewMoreFlag></favourite-transactions-tupple></div></div>");
$templateCache.put("app/transactions/list/allList.html","<section class=\"main-section clearfix transaction-list\" ng-init=List.allInit()><h6 class=page-title>Transactions</h6><ul class=\"nav nav-tabs\"><li><a href=javascript:void(0); ui-sref=main.transactions.recent>Recent </a></li><li class=active><a href=javascript:void(0); ui-sref=main.transactions.all>All </a></li></ul><div class=\"content-area clearfix\" ng-init=List.init()><div class=middle-flow><div class=\"status-filter clearfix\"><div class=\"col-md-2 col-sm-4 col-xs-6\" ng-repeat=\"(key,value) in List.snapshotList\"><div class=\"filter alltransacTabs cursor-pointer {{key.split(\'Count\')[0].toLowerCase()}}\" id=_first ng-click=List.changeTransationStatus(key) ng-class=\"{\'active-filter\':List.selectedStatus===key}\"><p ng-if=\"key!=\'allCount\'\" class=base-tooltip data-bs-html=true data-bs-toggle=tooltip ng-class=\"{\'tooltip-placement\' : List.transactionSnapShotList[key].label === \'Expired\' || List.transactionSnapShotList[key].label === \'Cancelled\'}\" tooltip data-bs-placement=\"{{ List.transactionSnapShotList[key].label === \'Expired\' || List.transactionSnapShotList[key].label === \'Cancelled\' ? \'top\' : \'right\'}}\" data-bs-title={{List.tooTipLabel[key]}}>{{List.transactionSnapShotList[key].label}}</p><p ng-if=\"key==\'allCount\'\">{{List.transactionSnapShotList[key].label}}</p><p>{{value|unit:value}}</p><span class=bar></span></div></div></div></div><div class=\"bottom-flow clearfix\"><span class=search-box><i class=search-grey-icon></i> <input placeholder=\"Search Folio No. or Scheme\" class=search-input type=text ng-model=List.searchText select-on-click ng-change=List.localSearch(List.searchText)></span><div class=filters-group><input date-range on-date-change=List.filterByDate placeholder=\"From Date -> To Date\" date-default=List.dateFilter class=date-picker type=text> <span class=\"dropdown date-select\"><span data-bs-toggle=dropdown ng-click=\"List.showAmountBox=true\">{{List.title}} <i class=black-down-icon></i></span><div class=dropdown-menu><form autocomplete=off name=myForm><p>Amount Range</p><div class=range-input><span><i class=rupee-black-icon></i><input ng-focus=\"List.singleAmount=\'\'\" ng-disabled=List.singleAmount ng-model=List.fromAmount type=number ignore-mouse-wheel ng-required=List.toAmount?true:false></span><span>To</span> <span><i class=rupee-black-icon></i><input ng-focus=\"List.singleAmount=\'\'\" ng-disabled=List.singleAmount ng-model=List.toAmount type=number ignore-mouse-wheel ng-required=List.fromAmount?true:false ng-valid=\"List.toAmount>List.fromAmount\"></span></div><div class=\"text-center orpart\">Or</div><div class=amount-input><i class=rupee-black-icon></i> <input placeholder=\"Enter Amount\" ng-focus=\"List.toAmount=\'\'; List.fromAmount=\'\'\" ng-disabled=List.fromAmount;List.toAmount ng-model=List.singleAmount type=number ignore-mouse-wheel></div><div class=text-center><button ng-disabled=\"myForm.$invalid ||List.toAmount<List.fromAmount\" class=\"btn btn-primary-action\" ng-click=\"List.setAmount();List.showAmountBox=false;\">OK</button></div></form></div></span><select id=typeSelect ng-change=List.typeChangeDropdown(List.selectedTransactionType) ng-model=List.selectedTransactionType><option ng-repeat=\"data in List.transactionTypeListDropdown\" value={{data.value}}>{{data.key}}</option></select><button class=apply-btn ng-click=List.applyFilter()>Apply</button> <button class=apply-btn ng-click=List.resetFilter()>Reset</button></div></div><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th ng-click=\"List.sortOrder.sortKey=\'folioNumber\';List.filterByHeader()\">Folio<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"List.sortOrder.sortKey=\'transactionDateTime\';List.filterByHeader()\"><span ng-if=\"!List.transactionStatus.includes(\'SCHEDULE\')\">Date</span> <span ng-if=\"List.transactionStatus.includes(\'SCHEDULE\')\">Scheduled Date</span><div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Investment type</th><th ng-click=\"List.sortOrder.sortKey=\'transactionType\';List.filterByHeader()\">Transaction type<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"List.sortOrder.sortKey=\'schemeName\';List.filterByHeader()\">Scheme<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"List.sortOrder.sortKey=\'amount\';List.filterByHeader()\">Amount(<i class=rupee-small-icon></i>)<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Units</th><th ng-if=\"List.status === \'REJECTED\'\">Remarks</th><!--<th ng-click=\"List.sortOrder.sortKey=\'status\';List.filterByHeader()\">--><!--Status--><!--<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div>--><!--</th>--><!--<th class=\"text-center\">Action</th>--></tr></thead><tbody><tr ng-if=List.transactionList ng-repeat=\"data in List.transactionList\"><td data-th=\"Folio No\">{{data.folioNumber}}</td><td data-th=Date>{{data.date}}</td><td data-th=\"Investment type\">{{data.investmentType}}</td><td data-th=\"Transaction type\">{{data.transactionType === \'FLEXSIP\' ? \'Flex SIP\' : data.transactionType}}</td><!--<td class=\"text-primary text-bold\" data-th=\"Scheme\">{{data.scheme}}</td>--><td class=\"text-primary text-bold\" data-th=Scheme><div ng-if=\"(data.transactionStatus === List.transactionSnapShotList.scheduledCount.key ||\n            data.transactionStatus === List.transactionSnapShotList.canceledScheduleCount.key ||\n            data.transactionStatus === List.transactionSnapShotList.expiredScheduleCount.key) && data.transactionType === \'SWITCH\' && data.targetScheme\"><div><span class=normal-grey-text>Source Scheme: </span><span ng-bind-html=data.scheme|linebreak:8></span><p class=small-grey-text>{{data.schemeType}}</p></div><div><span class=normal-grey-text>Target Scheme: </span><span ng-bind-html=data.targetScheme|linebreak:8></span><p class=small-grey-text>{{data.targetSchemeType}}</p></div></div><div ng-if=\"data.transactionType !== \'SWITCH\'\"><span ng-bind-html=data.scheme|linebreak:8></span><p class=small-grey-text>{{data.schemeType}}</p></div></td><td data-th=Amount class=text-left><span ng-if=\"!data.amount && data.amount === 0\">--</span> <span ng-if=\"data.amount!=0 && data.amount>=0\">{{data.amount.toFixed(2)|unit:data.amount}}</span></td><td data-th=Unit><span ng-if=\"data.transactionMode  !== \'ALL_UNITS\' && data.unit && data.unit > 0\">{{data.unit.toFixed(3)}}</span> <span ng-if=\"data.transactionMode  !== \'ALL_UNITS\' && !data.unit && data.unit === 0\">-- </span><span ng-if=\"data.transactionMode  === \'ALL_UNITS\'\">All Free Units</span></td><td data-th=Remark ng-if=\"List.status === \'REJECTED\'\"><a href=javascript:void(0); ng-if=data.remarks tooltip data-bs-toggle=tooltip data-bs-placement=left data-bs-title={{data.remarks}}><i class=info-icon></i></a></td><!--<td data-th=\"Status\"><span ng-class=\"data.transactionStatus.toLowerCase()+\'-text\'\">{{List.transactionSnapShotList[data.transactionStatus.toLowerCase()+\"Count\"].label}}</span>--><!--</td>--><!--<td data-th=\"Action\" class=\"text-center\">--><!--<button--><!--ng-if=\"data.transactionStatus && data.transactionStatus!=\'PENDING\' && data.transactionStatus!=\'DELETED\'\"--><!--class=\"btn-small btn-secondary-action\" ng-click=\"List.viewSummary(data)\">View Details--><!--</button>--><!--&lt;!&ndash;<button ng-if=\"data.transactionStatus && data.transactionStatus==\'PENDING\' && data.transactionStatus!=\'DELETED\'\" class=\"btn-small btn-secondary-action\">Approve</button>&ndash;&gt;--><!--<p class=\"text-center\"--><!--ng-if=\"data.transactionStatus && data.transactionStatus==\'PENDING\' && data.transactionStatus!=\'DELETED\'\">--><!--&#45;&#45;</p>--><!--</td>--></tr><tr ng-if=\"List.totalTransactionList==0\"><td>{{List.response}}</td></tr></tbody></table><div class=col-md-12 ng-if=List.isPagination><div class=total-data><span>Showing &nbsp</span><select ng-if=\"List.totalTransactionList>=25\" ng-change=List.pageLimitListChange(List.pageLimitTransactionList) ng-model=List.pageLimitTransactionList><option ng-repeat=\"value in List.pageLimitDropDownList\" value={{value}}>{{value}}</option></select><span ng-if=\"List.totalTransactionList<25\">{{List.totalTransactionList}}</span> <span>of</span> <span class=t-black>{{List.totalTransactionList}}</span></div><ul uib-pagination total-items=List.totalTransactionList ng-model=List.currentPageTransactionList max-size=5 items-per-page=List.pageLimitTransactionList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=List.initTransactionList() rotate=false></ul></div></div></section>");
$templateCache.put("app/transactions/list/recentList.html","<section class=\"main-section clearfix transaction-list\" ng-init=List.recentInit()><h6 class=page-title>Transactions</h6><ul class=\"nav nav-tabs\"><li class=active><a href=javascript:void(0); ui-sref=main.transactions.recent>Recent </a></li><li><a href=javascript:void(0); ui-sref=main.transactions.all>All </a></li></ul><div class=\"content-area clearfix\" ng-init=List.init()><div class=row><div class=col-md-12><div class=\"bottom-flow recent-list\"><div class=filters-group><select id=folioSelect ng-change=List.getFolioData(List.selectedFolio) ng-model=List.selectedFolio ng-options=\"folioValue as folioValue for folioValue in List.folioList\"><option value=\"\">Folio Number</option></select></div><!--<form name=\"tForm\">\n            <div class=\"selectfield\"\n                 ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\">\n              <select name=\"folio\"\n                      ng-change=\"List.getFolioData(List.selectedFolio)\"\n                      ng-model=\"List.selectedFolio\"\n                      ng-options=\"folioValue as folioValue for folioValue in List.folioList\"\n                      required>\n                <option value=\"\">Folio Number</option>\n              </select>\n              <label ng-if=\"List.selectedFolio\">Folio Number</label>\n              <span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\">\n              <span class=\"error-input\" ng-show=\"tForm.folio.$error.required\"\n                    ng-bind=\"Statements.VALIDATE_DATA.FOLIO_REQUIRED\"></span>\n            </span>\n            </div>\n          </form>--></div></div></div><!--<div class=\"folio-tabs\">\n      <span class=\"slide-left\" ng-if=\"List.folioList.length>11 && !List.slideLeftDisabled\" ng-click=\"List.slideLeft()\">\n        <i class=\"slide-left-icon\"></i>\n      </span>\n\n      <div class=\"capsule-box\">\n        <span ng-repeat=\"folioValue in List.folioList track by $index\" class=\"capsule-cover\">\n          <span ng-if=\"List.isDisplayed($index+1)\" class=\"capsule slide\" data=\"{{$index+1}}\"\n                ng-class=\"{\'active\': List.selectedFolio == folioValue}\"\n                ng-click=\"(List.selectedFolio == folioValue) || List.getFolioData(folioValue)\">\n              {{folioValue}}\n            <span ng-if=\"List.selectedFolio == folioValue\" ng-click=\"List.refresh(List.selectedFolio)\" class=\"refreshFolioButton\"><strong>&#x27F3;</strong></span>\n          </span>\n        </span>\n      </div>\n\n      <span class=\"slide-right\" ng-if=\"List.folioList.length>11 && !List.slideRightDisabled\" ng-click=\"List.slideRight()\">\n        <i class=\"slide-right-icon\"></i>\n      </span>\n    </div>--><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Date</th><th>Investment type</th><th>Transaction type</th><th>Scheme</th><th>Amount(<i class=rupee-small-icon></i>)</th><th>Units</th><th>Status</th></tr></thead><tbody><tr ng-if=List.transactionList ng-repeat=\"data in List.transactionList\"><td data-th=Date>{{data.date}}</td><td data-th=\"Investment type\">{{data.investmentType}}</td><td data-th=\"Transaction type\">{{data.transactionType === \'FLEXSIP\' ? \'Flex SIP\' : data.transactionType}}</td><!--<td class=\"text-primary text-bold\" data-th=\"Scheme\">{{data.scheme}}</td>--><td class=\"text-primary text-bold\" data-th=Scheme><span ng-bind-html=data.scheme|linebreak:8></span><p class=small-grey-text>{{data.schemeType}}</p></td><td data-th=Amount class=text-left>{{data.amount.toFixed(2)|unit:data.amount }}</td><td data-th=Unit>{{data.unit.toFixed(2) ? data.unit.toFixed(2) : \'--\' }}</td><td data-th=Status><span ng-class=\"data.transactionStatus.toLowerCase()+\'-text\'\">{{data.transactionStatus}}</span></td></tr><tr ng-if=!List.transactionList.length><td colspan=8 style=\"text-align: center\">No record found.</td></tr></tbody></table></div></section>");
$templateCache.put("app/transactions/payments/payment-screen.html","<section class=\"main-section clearfix payment-screen\" ng-init=Payment.init()><h3 class=page-title ng-if=!Payment.showUpiPaymentReview>Please Select a Payment Method</h3><h3 class=page-title ng-if=Payment.showUpiPaymentReview>Please Review Payment Method</h3><section class=content-area><header><div class=\"col-sm-3 col-md-3\" ng-if=!Payment.formData.sipFirstInstallment>Scheme Name: <strong>{{Payment.formData.purchaseInSchemeName}}</strong></div><div class=\"col-sm-3 col-md-3\" ng-if=Payment.formData.sipFirstInstallment>Scheme Name: <strong>{{Payment.formData.inSchemeName}}</strong></div><div class=\"col-sm-3 col-md-3\" ng-if=!Payment.formData.sipFirstInstallment>Amount: <strong><i class=grey-rupee-icon></i> {{Payment.formData.purchaseAmount}}</strong><br><label>{{Payment.formData.amountInWords}} (In Words)</label></div><div class=\"col-sm-2 col-md-2\" ng-if=Payment.formData.sipFirstInstallment>Amount: <strong ng-if=\"Payment.formData.investmentType != \'DREAMSIP\'  \"><i class=grey-rupee-icon></i> {{Payment.formData.sipFirstAmount}}</strong> <strong ng-if=\"Payment.formData.investmentType == \'DREAMSIP\'  \"><i class=grey-rupee-icon></i> {{Payment.formData.amount}}</strong></div><div class=\"col-sm-3 col-md-3\" ng-if=!Payment.formData.sipFirstInstallment>Transaction Type: <strong>{{Payment.formData.investmentType}}</strong></div><div class=\"col-sm-4 col-md-4\" ng-if=Payment.formData.sipFirstInstallment>Transaction Type: <strong ng-if=\"Payment.formData.investmentType != \'DREAMSIP\'\">{{Payment.formData.investmentType === \'FLEXSIP\' ? \'Flex SIP\' : \'SIP\'}} with 1 <sup style=\"font-size: small\">st</sup> installment</strong> <strong ng-if=\"Payment.formData.investmentType == \'DREAMSIP\'\">DREAM SIP with 1 <sup style=\"font-size: small\">st</sup> installment</strong></div><div class=\"col-sm-3 col-md-3\">Folio Number: <strong>{{Payment.formData.folioNumber}}</strong></div></header><!--<div class=\"debit-pay-unavailable\">\n      <p>\n        Debit Card Payment Option is Discontinued.\n      </p>\n    </div>--><div class=tabheads ng-if=\"Payment.formData.investmentType ===\'SIP\' || Payment.formData.investmentType ===\'FLEXSIP\' || Payment.formData.investmentType ===\'DREAMSIP\'\"><div class=tabhead ng-repeat=\"_option in Payment.paymentOptions\" ng-class=\"{\'active-DEBIT\': Payment.formData.purchasePaymentOption===_option}\"><div class=radio-block><span class=radio><input type=radio id=paymentOption1{{_option}} ng-value=_option name=paymentOption ng-change=Payment.changedPaymentOption() ng-model=Payment.formData.purchasePaymentOption><!-- ng-disabled=\"_option===Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS\"--> <span class=check></span><!--<p class=\"bottom-line\"></p>--> </span><span class=radio-label>{{_option === \'UPI\' && Payment.formData.investmentType ===\'SIP\' ? Payment.sipUpiText : Payment.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div class=tabheads ng-if=\"Payment.formData.investmentType ===\'PURCHASE\'\"><div class=tabhead ng-repeat=\"_option in Payment.paymentOptions\" ng-class=\"{\'active-DEBIT\': Payment.formData.purchasePaymentOption===_option}\"><div class=radio-block><span class=radio><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-change=Payment.changedPaymentOption() ng-model=Payment.formData.purchasePaymentOption><!-- ng-disabled=\"_option===Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.IMPS\"--> <span class=check></span><!--<p class=\"bottom-line\"></p>--> </span><span class=radio-label>{{Payment.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><style>.main-section.payment-screen .tabheads .tabhead:last-child{display:table-cell;}</style><form autocomplete=off novalidate name=tForm><div class=tab-body ng-switch=Payment.formData.purchasePaymentOption ng-init=Payment.getFormData(tForm)><div class=row ng-switch-when=DEBIT><div class=col-md-4><div class=form-group><div class=radio-block><span class=radio><input type=radio ng-click=Payment.cardTypeChanged() ng-model=Payment.debitCardType value=visa name=debitType> <span class=check></span> </span><span class=radio-label>Visa/Master</span></div><div class=radio-block><span class=radio><input type=radio ng-click=Payment.cardTypeChanged() ng-model=Payment.debitCardType value=master name=debitType> <span class=check></span> </span><span class=radio-label>Maestro</span></div></div><div class=selectfield ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><select name=bank ng-disabled=!Payment.bankList ng-model=Payment.bankInfo ng-options=\"bank.bankName for bank in Payment.bankList\" ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\" ng-change=Payment.changeBank() required><option value=\"\" selected>{{Payment.bankList&&!Payment.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=Payment.bankInfo>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><div ng-switch-when=NETBANKING><ng-bind-html dynamic=Payment.noteNetBanking.content></ng-bind-html><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><input type=text name=bank id=bank ng-model=Payment.bankInfo.bankName ng-change=Payment.changeBank() ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\" autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly> <span class=highlight></span> <span class=bar></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=Payment.changeBank() model=Payment.bankInfo for=bank></bank-drop-down><!--<select class=\"\" name=\"bank\" ng-disabled=\"!Payment.bankList\"\n                      ng-model=\"Payment.bankInfo\"\n                      ng-options=\"bank.bankName for bank in Payment.bankList\"\n                      ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\"\n                      ng-change=\"Payment.changeBank()\"\n                      easyassist-key=\"mask-element\"\n                      required>\n                <option value=\"\" selected>\n                  {{Payment.bankList&&!Payment.bankList.length ?\'No Bank Available\':\'Select Bank\'}}\n                </option>\n              </select>\n\n              <label ng-if=\"Payment.bankInfo\">Select Bank</label>\n              <span class=\"error-input\" ng-show=\"tForm.bank.$dirty&&tForm.bank.$error.required\"\n                    ng-bind=\"Payment.VALIDATE_DATA.BANK_REQUIRED\"></span>--></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.bankAcType.$dirty && tForm.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-init=\"Payment.formData.paymentInfo.accType=Payment.formData.paymentInfo.accType?Payment.formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.formData.paymentInfo.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><ng-bind-html dynamic=Payment.notesPayment.noteDTO.noteDTOMap.Note_Purchase_TPV.content></ng-bind-html><div class=text-red ng-if=!Payment.bankList||!Payment.bankList.length><span>In case your registered bank is not displayed, please choose other payment mode or add another bank.</span></div></div><div ng-switch-when=RTGS><div class=\"bank-details-heading col-md-12\"><h6>Bank Details</h6></div><ng-bind-html dynamic=Payment.notesPayment.noteDTO.noteDTOMap.Note_Purchase_NEFT_RTGS.content></ng-bind-html><input type=text style=\"visibility: hidden\"> <input type=password style=\"visibility: hidden\"><div class=row style=\"margin-bottom: 7px\"><div class=col-md-7><div class=neft-form-switch><span>{{Payment.PATTERN.RTGS_MESSAGE}}</span> <span ng-class=\"{\'toggle-select\':Payment.isNewPayment}\">Yes</span><label class=switch><input ng-model=Payment.isNewPayment type=checkbox ng-change=Payment.changeRtgsPaymentOption()> <span class=\"slider round\"></span></label><span ng-class=\"{\'toggle-select\':!Payment.isNewPayment}\">No</span></div></div></div><div class=row><div class=col-md-4 ng-if=Payment.isNewPayment><div class=\"input-select input-normal selectfield\" ng-class={error:tForm.rtgsBank.$dirty&&tForm.rtgsBank.$invalid}><input type=text name=rtgsBank id=rtgsBank ng-model=Payment.bankInfo.bankName ng-change=Payment.changeBank() autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly> <span class=highlight></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=tForm.rtgsBank.$dirty&&tForm.rtgsBank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=Payment.changeBank() model=Payment.bankInfo for=rtgsBank></bank-drop-down><!--<ng-bind-html\n                  dynamic=\"Payment.notesPayment.noteDTO.noteDTOMap.Note_Purchase_TPV.content\"\n                ></ng-bind-html>--></div></div></div><div class=bank-detail-section ng-if=\"(Payment.bankInfo && Payment.isNewPayment) || (!Payment.isNewPayment && Payment.bankInfo == null)\"><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankName.$invalid&&tForm.bankName.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.bankName name=bankName only-alphabets required ng-readonly=Payment.isNewPayment><div class=bar></div><div class=highlight></div><label>Bank Name<span class=req>*</span></label><span class=error-input ng-show=tForm.bankName.$dirty&&tForm.bankName.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankBranch.$invalid&&tForm.bankBranch.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.bankBranch only-alphabets name=bankBranch required ng-readonly=Payment.isNewPayment><div class=bar></div><div class=highlight></div><label>Branch City<span class=req>*</span></label><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankAcNo.$invalid&&tForm.bankAcNo.$dirty}><input type=text autocomplete=false ng-model=Payment.formData.paymentInfo.accNo ng-if=Payment.isNewPayment name=bankAcNo required maxlength=20 ng-readonly=Payment.isNewPayment onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event)> <input type=password autocomplete=false ng-model=Payment.formData.paymentInfo.accNo ng-if=!Payment.isNewPayment name=bankAcNo required maxlength=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event)><div class=bar></div><div class=highlight></div><label>Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.maxlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div></div><div class=col-md-4 ng-if=!Payment.isNewPayment><div class=input-normal ng-class={error:tForm.verifyBankAcNo.$invalid&&tForm.verifyBankAcNo.$dirty}><input type=text ng-keydown=Payment.copyPasteHandler($event) name=verifyBankAcNo maxlength=20 required ng-model=Payment.formData.paymentInfo.verifyBankAcNo ng-pattern=Payment.formData.paymentInfo.accNo onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=highlight></span> <span class=bar></span><label>Verify Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.verifyBankAcNo.$dirty&&tForm.verifyBankAcNo.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&tForm.verifyBankAcNo.$error.maxlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&!tForm.verifyBankAcNo.$error.maxlength&&tForm.verifyBankAcNo.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize ng-readonly=\"Payment.isNewPayment && Payment.formData.paymentInfo.ifscCode\"><div class=bar></div><div class=highlight></div><label>IFSC/NEFT Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.bankAcType.$dirty && tForm.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.bankAcType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required ng-disabled=\"Payment.isNewPayment && Payment.isAccTypeFieldDisabled\"><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.formData.paymentInfo.bankAcType>Account Type</label><span class=\"req text-red\">*</span><!--                  <span class=\"error-input\" ng-messages=\"tForm.bankAcType.$error\" ng-show=\"tForm.bankAcType.$dirty\">--><!--                  <span ng-message=\"required\" ng-bind=\"Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED\"></span>--><!--                </span>--> <span class=error-input ng-show=\"tForm.accountType.$dirty && tForm.accountType.$error.required\" ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.utrNumber.$invalid&&tForm.utrNumber.$dirty}><input type=text name=utrNumber ng-model=Payment.formData.paymentInfo.utrNumber ng-pattern=Payment.PATTERN.UTR_REGEX ng-maxlength=255 required> <span class=highlight></span> <span class=bar></span><label>UTR Number<span class=req>*</span></label><span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.pattern class=help-block ng-bind=Payment.VALIDATE_DATA.UTR_RANGE></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.maxlength class=help-block ng-bind=Payment.VALIDATE_DATA.UTR_INVALID></span></div></div><div class=col-md-4><div class=input-normal ng-class={error:tForm.verifyUtrNumber.$invalid&&tForm.verifyUtrNumber.$dirty}><input type=text name=verifyUtrNumber ng-model=Payment.formData.paymentInfo.verifyUtrNumber ng-pattern=Payment.formData.paymentInfo.utrNumber required> <span class=highlight></span> <span class=bar></span><label>Verify UTR Number<span class=req>*</span></label><span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_UTR_REQUIRED></span></div></div></div><!--<div class=\"row\">\n              <div class=\"col-md-12\">\n                <div class=\"upload-some\">\n                  <span class=\"leaf-label\">Upload Bank Statement\n                    <i class=\"info-icon base-tooltip\" data-bs-html=\"true\" data-bs-toggle=\"tooltip\"  data-bs-placement=\"{{Main.tooltipClass}}\"\n                       title=\"{{Payment.PATTERN.BANK_STATEMENT_INFO}}\"></i>\n                    <span class=\"req text-red\">*</span>\n                  </span>\n                  <div class=\"upload-leaf\">\n                    <input id=\"uploadCheckLeaf\" type=\"file\" name=\"pic\" accept=\"image/*, application/*\" file-model-profile=\"chequeLeaf\"\n                           upload=\"Payment.bankUploadChequeLeafFile(file)\" ng-model=\"Payment.formData.paymentInfo.chequeLeaf\" required>\n                    <div class=\"file-upload\"><button>Choose File</button><span ng-if=\"Payment.chooseAFile\">No File Chosen</span>\n                      <span ng-if=\"Payment.fileType === \'tif\' || Payment.fileType === \'tiff\' || Payment.fileType == \'pdf\'\"><a href=\"javascript:void(0)\" ng-click=\"Payment.downloadPdfFile(Payment.bankchequeLeafUrl,Payment.fileType)\">Download</a></span>\n                      <span ng-if=\"Payment.fileType == \'jpg\' ||  Payment.fileType == \'jpeg\' \" ng-click=\"Payment.openUploadedDoc(Payment.formData.paymentInfo.chequeLeaf)\">{{Payment.bankChequeLeaf}}</span></div>\n                  </div>\n                </div>\n              </div>\n            </div>--></div></div><div class=row ng-switch-when=OTM><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><input type=text name=bank id=otmBank ng-model=Payment.bankInfo.bankName ng-change=Payment.changeBank() ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\" autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly> <span class=highlight></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.bankList display-key=bankName display-key-second=bankAcNo hdfc-click=Payment.changeBank() model=Payment.bankInfo for=otmBank></bank-drop-down><!--<select class=\"\" name=\"bank\" ng-disabled=\"!Payment.bankList\"\n                      ng-model=\"Payment.bankInfo\"\n                      ng-options=\"bank as (bank.bankName+\' - \'+bank.bankAcNo) for bank in Payment.bankList\"\n                      ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\"\n                      ng-change=\"Payment.changeBank()\"\n                      easyassist-key=\"mask-element\"\n                      required>\n                <option value=\"\" easyassist-key=\"mask-element\" selected>\n                  {{Payment.bankList&&!Payment.bankList.length ?\'No Bank Available\':\'Select Bank\'}}\n                </option>\n              </select>\n\n              <label ng-if=\"Payment.bankInfo\">Select Bank</label>\n              <span class=\"error-input\" ng-show=\"tForm.bank.$dirty&&tForm.bank.$error.required\"\n                    ng-bind=\"Payment.VALIDATE_DATA.BANK_REQUIRED\"></span>--></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.bankAcType.$dirty && tForm.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.formData.paymentInfo.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=\"row col-md-12\"><ng-bind-html dynamic=Payment.notesPayment.noteDTO.noteDTOMap.Note_Purchase_OTM.content></ng-bind-html></div><div class=\"row col-md-10\"><div><table class=\"table borderless otm-bank-details\" ng-if=\"(Payment.bankInfo && Payment.bankList.length)\"><tr><td>Account No:</td><td easyassist-key=mask-element>{{Payment.bankInfo.bankAcNo}}</td></tr><tr><td>OTM UMRN No:</td><td>{{Payment.bankInfo.omUmrn}}</td></tr><tr><td>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{Payment.bankInfo.maxAmount}} <span class=error-input ng-show=\"Payment.isOTMAmount && Payment.formData.purchaseAmount\" ng-bind=Payment.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_PURCHASE_ERROR></span> <span class=error-input ng-show=\"Payment.isOTMAmount && Payment.formData.sipFirstAmount\" ng-bind=Payment.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_SIP_ERROR></span></td></tr><tr><td>OTM Start Date:</td><td>{{Payment.bankInfo.omStartDate}} <span class=error-input ng-show=\"Payment.isOTMStartDate && Payment.formData.purchaseAmount\" ng-bind=\"Payment.VALIDATE_DATA.DATE_START_VALIDATION_ERROR + \' \' + Payment.bankInfo.omStartDate\"></span> <span class=error-input ng-show=\"Payment.isOTMStartDate && Payment.formData.sipFirstAmount\" ng-bind=\"Payment.VALIDATE_DATA.DATE_START_FIRST_INSTALLMENT_VALIDATION_ERROR + \' \' + Payment.bankInfo.omStartDate\"></span></td></tr><tr><td>OTM Expiry Date:</td><td>{{Payment.bankInfo.omExpiryDate}} <span class=error-input ng-show=\"Payment.isOTMDate && Payment.formData.purchaseAmount\" ng-bind=\"Payment.VALIDATE_DATA.EXPIRY_DATE_VALID_ERROR + \' \' + Payment.bankInfo.omExpiryDate\"></span> <span class=error-input ng-show=\"Payment.isOTMDate && Payment.formData.sipFirstAmount\" ng-bind=\"Payment.VALIDATE_DATA.EXPIRY_DATE_FIRST_INSTALLMENT_VALID_ERROR + \' \' + Payment.bankInfo.omExpiryDate\"></span></td></tr></table></div></div></div><div ng-switch-when=HDFC><div class=\"col-md-12 bank-details-heading\"><h6>Bank Details</h6></div><div class=row><div class=col-md-12><ng-bind-html dynamic=Payment.notesPayment.noteDTO.noteDTOMap.Note_Purchase_HDFC_Fund_Transfer.content></ng-bind-html></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.schemeAccountNumber.$invalid&&tForm.schemeAccountNumber.$dirty}><input type=number ignore-mouse-wheel ng-model=Payment.formData.paymentInfo.schemeAccountNumber name=schemeAccountNumber ng-maxlength=25 required><div class=bar></div><div class=highlight></div><label>HDFC MF Scheme Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.required ng-bind=Payment.VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.number ng-bind=Payment.VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_FIELD></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.maxlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.accountNumber.$invalid&&tForm.accountNumber.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.accountNumber name=accountNumber ng-maxlength=20 easyassist-key=mask-element onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event) required><div class=bar></div><div class=highlight></div><label>Investor Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.required ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.maxlength ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span></div></div><div class=col-md-4><div class=input-normal ng-class={error:tForm.verifyAccountNumber.$invalid&&tForm.verifyAccountNumber.$dirty}><input type=text ng-keydown=Payment.copyPasteHandler($event) name=verifyAccountNumber ng-maxlength=20 easyassist-key=mask-element required ng-model=Payment.formData.paymentInfo.verifyAccountNumber ng-pattern=Payment.formData.paymentInfo.accountNumber onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=highlight></span> <span class=bar></span><label>Confirm Investor Account Number</label><span class=error-input ng-show=tForm.verifyAccountNumber.$dirty&&tForm.verifyAccountNumber.$error.required ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyAccountNumber.$error.required&&tForm.verifyAccountNumber.$error.maxlength ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyAccountNumber.$error.required&&!tForm.verifyAccountNumber.$error.maxlength&&tForm.verifyAccountNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_INVESTOR_ACCOUNT_NUMBER_RANGE></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.bankAcType.$dirty && tForm.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.formData.paymentInfo.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.accountHolderName.$invalid&&tForm.accountHolderName.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.accountHolderName only-alphabets name=accountHolderName required><div class=bar></div><div class=highlight></div><label>Account Holder Name<span class=req>*</span></label><span class=error-input ng-show=tForm.accountHolderName.$dirty&&tForm.accountHolderName.$error.required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_HOLDER_REQUIRED></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.bankBranch.$invalid&&tForm.bankBranch.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.bankBranch only-alphabets name=bankBranch required><div class=bar></div><div class=highlight></div><label>HDFC Bank Branch Name<span class=req>*</span></label><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class={error:tForm.utrNumber.$invalid&&tForm.utrNumber.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.utrNumber name=utrNumber required ng-maxlength=255 ng-pattern=/^[a-zA-Z0-9]*$/ ><div class=bar></div><div class=highlight></div><label>Bank Reference Number<span class=req>*</span></label><span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.maxlength ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.UTR_INVALID></span></div></div><div class=col-md-4><div class=input-normal ng-class={error:tForm.verifyUtrNumber.$invalid&&tForm.verifyUtrNumber.$dirty}><input type=text name=verifyUtrNumber ng-maxlength=255 required ng-model=Payment.formData.paymentInfo.verifyUtrNumber ng-pattern=Payment.formData.paymentInfo.utrNumber> <span class=highlight></span> <span class=bar></span><label>Confirm Bank Reference Number</label><span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyUtrNumber.$error.required&&tForm.verifyUtrNumber.$error.maxlength ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyUtrNumber.$error.required&&!tForm.verifyUtrNumber.$error.maxlength&&tForm.verifyUtrNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_BANK_REFERENCE_NUMBER_RANGE></span></div></div></div><div class=row><div class=col-md-12><div class=upload-some><span class=leaf-label>Upload Bank Statement <i class=\"info-icon base-tooltip\" data-bs-html=true data-bs-toggle=tooltip data-bs-placement={{Main.tooltipClass}} title={{Payment.PATTERN.BANK_STATEMENT_INFO}}></i> <span class=\"req text-red\">*</span></span><div class=upload-leaf><input id=uploadCheckLeaf type=file name=pic accept=\"image/*, application/*\" file-model-profile=chequeLeaf upload=Payment.bankUploadChequeLeafFile(file) ng-model=Payment.formData.paymentInfo.chequeLeaf required><div class=file-upload><button>Choose File</button><span ng-if=Payment.chooseAFile>No File Chosen</span> <span ng-if=\"Payment.fileType === \'tif\' || Payment.fileType === \'tiff\'|| Payment.fileType == \'pdf\'\"><a href=javascript:void(0) ng-click=Payment.downloadPdfFile(Payment.bankchequeLeafUrl,Payment.fileType)>Download</a></span> <span ng-if=\"Payment.fileType == \'jpg\' ||  Payment.fileType == \'jpeg\' \" ng-click=Payment.openUploadedDoc(Payment.formData.paymentInfo.chequeLeaf)>{{Payment.bankChequeLeaf}}</span></div></div></div></div></div></div><div ng-switch-when=UPI><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><input type=text name=bank id=upiBank ng-model=Payment.bankInfo.bankName ng-change=Payment.selectedUpiBank() ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\" autocomplete=off ng-required=!Payment.bankInfo ng-disabled=Payment.isDisableUpi only-alphabets readonly> <span class=highlight></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=Payment.selectedUpiBank() model=Payment.bankInfo for=upiBank></bank-drop-down><!--<select class=\"\" name=\"bank\" ng-disabled=\"!Payment.bankList\"\n                      ng-model=\"Payment.bankInfo\"\n                      ng-options=\"bank as bank.bankName for bank in Payment.bankList\"\n                      ng-init=\"Payment.bankInfo=Payment.bankInfo?Payment.bankInfo: null\"\n                      ng-change=\"Payment.selectedUpiBank()\"\n                      easyassist-key=\"mask-element\"\n                      required>\n                <option value=\"\" easyassist-key=\"mask-element\" selected>\n                  {{Payment.bankList&&!Payment.bankList.length ?\'No Bank Available\':\'Select Bank\'}}\n                </option>\n              </select>\n\n              <label ng-if=\"Payment.bankInfo\">Select Bank</label>\n              <span class=\"error-input\" ng-show=\"tForm.bank.$dirty&&tForm.bank.$error.required\"\n                    ng-bind=\"Payment.VALIDATE_DATA.BANK_REQUIRED\"></span>--></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode && !Payment.isDisableUpi\"><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=col-md-4 ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType && !Payment.isDisableUpi\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.bankAcType.$dirty && tForm.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=Payment.formData.paymentInfo.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div ng-if=Payment.bankInfo><div class=row ng-class=\"{\'col-md-12\': (!Payment.bankInfo.ifscCode && !Payment.isDisableUpi) || (!Payment.bankInfo.bankAcType && !Payment.isDisableUpi)}\"><div class=\"col-md-4 vpa-input\"><div class=input-normal ng-class={error:tForm.virtualAddress.$invalid&&tForm.virtualAddress.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.virtualAddress name=virtualAddress ng-pattern=Payment.PATTERN.upi_virtual_addr_regex ng-change=\"Payment.verifyUPIResp={}\" required ng-readonly=\"Payment.isUPIVerified && Payment.verifyUPIResp.valid === true\" easyassist-key=mask-element ng-disabled=Payment.isDisableUpi><div class=bar></div><div class=highlight></div><label style=\"display: block;width: 100%\">Virtual Payment Address (UPI ID) <span class=req>*</span> <i class=edit-icon style=\"position: absolute;right: 0px; top:16px; pointer-events: all; box-sizing: content-box\" ng-if=\"Payment.isUPIVerified && Payment.verifyUPIResp.valid === true && !Payment.isDisableUpi\" ng-click=\"Payment.isUPIVerified = false\"></i></label><span class=error-input ng-show=tForm.virtualAddress.$dirty&&(tForm.virtualAddress.$error.required||tForm.virtualAddress.$error.pattern) ng-bind=Payment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!tForm.virtualAddress.$invalid\n                  &&  (!Payment.isUPIVerified && Payment.verifyUPIResp.valid === false)\" ng-bind=Payment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span></div></div><div class=col-md-4 ng-if=!Payment.isDisableUpi><button blur-on-click ng-if=\"Payment.formData.purchasePaymentOption==\'UPI\' && !Payment.isUPIVerified\" class=\"btn btn-primary-action\" ng-disabled=\"!Payment.formData.paymentInfo.virtualAddress || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition())\" ng-click=Payment.verifyUPI()>Verify</button></div><div class=\"col-md-2 verify-vpa verify-ack-padding\" ng-if=\"Payment.isUPIVerified && Payment.verifyUPIResp.valid === true\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{Payment.name}}</span></div><div class=\"col-md-2 verify-vpa verify-ack-padding verify-ack-col\" ng-if=\"!Payment.isUPIVerified && Payment.verifyUPIResp.valid === false\"><p><strong><span class=error-input style=\"display:inline;font-size:100%;margin-bottom: 20px\">Not Verified</span> <i class=\"cancel-icon error-input\"></i></strong></p></div></div></div><div class=initiate-transaction><div class=text-red ng-if=!Payment.bankList||!Payment.bankList.length><span>In case your registered bank is not displayed, please choose other payment mode or add another bank.</span></div><ng-bind-html ng-if=\"Payment.formData.investmentType !==\'SIP\'\" dynamic=Payment.notesPayment.noteDTO.noteDTOMap.Note_Purchase_UPI.content></ng-bind-html><ng-bind-html ng-if=\"Payment.formData.investmentType ===\'SIP\'\" dynamic=Payment.notesPayment.noteDTO.noteDTOMap.Note_SIP_FI_UPI.content></ng-bind-html></div></div></div><div class=tc-block-d ng-class=\"{\'tc-block-when-bankInfo\' : Payment.formData.purchasePaymentOption == \'RTGS\' && Payment.isNewPayment && Payment.bankInfo && Payment.bankInfo.tpvEnableFlag == \'N\'}\"><h6>Declaration :</h6><div class=checkbox><input id=declaration ng-model=Payment.isCheckedDeclaration type=checkbox required> <i class=icon-checkbox></i><label for=declaration>I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the bank account holders.</label></div></div><div class=\"form-footer col-md-12\"><span ng-click=Payment.goToBack() style=\"float: left; color: #103880\" class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span> <button blur-on-click ng-if=\"Payment.formData.purchasePaymentOption!=\'UPI\'\" class=\"btn btn-primary-action pull-right\" ng-disabled=\"tForm.$invalid || Payment.isInvalidForm || Payment.isOTMStartDate || Payment.isOTMAmount\n                || Payment.isOTMDate || (Payment.formData.purchasePaymentOption==Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING && Payment.bankInfo.tpvEnableFlag==\'N\'\n                || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition()))\" ng-click=Payment.completePurchaseFirst($event)>Continue to Pay</button><!--|| (Payment.formData.purchasePaymentOption==Payment.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS && Payment.bankInfo.tpvEnableFlag==\'N\')--> <button blur-on-click ng-if=\"Payment.formData.purchasePaymentOption==\'UPI\'\" class=\"btn btn-primary-action pull-right\" ng-disabled=\"tForm.$invalid || !Payment.isUPIVerified || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition())\" ng-click=Payment.completePurchaseFirst($event)>Continue to Pay</button></div></form></section><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{Payment.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=Payment.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=Payment.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=Payment.billdeskPayload.msg></form><!-- Payment form commented: --><!-- with new implementation we are not using it, directly appending data from backend on billdesk url. --><!--<form autocomplete=\"off\" name=\'billdeskPayFormDebitOnly\' id=\"billdeskPayFormDebitOnly\" method=\'POST\'\n        action=\'https://www.billdesk.com/pgidsk/PGICommonGateway\'>\n    <input type=\"hidden\" name=\"msg\" ng-value=\"Payment.billDeskpayload\" id=\"msg\"/>\n    <input id=\"hidRequestId\" type=\'hidden\' name=\'hidRequestId\' value=\"PGIME1000\"/>\n    <input id=\"hidOperation\" type=\'hidden\' name=\'hidOperation\' value=\"ME100\"/>\n  </form>--><style>.checkbox{text-align: left;\n    width: 100%;}\n  .checkbox label{\n    position: absolute;\n    top: 2px;\n    left: 10px;\n  }\n\n\n  div i.dot {\n    display: inline-block;\n    position: relative;\n    top: -2px;\n    height: 6px;\n    margin-right: 10px;\n    width: 6px;\n    background: #d92018;\n  }\n\n\n  .info {\n    font-weight: normal;\n    font-size: 12px;\n  }\n\n  .info p {\n    margin-top : 0px !important;\n    margin-bottom: 0px !important;\n  }\n\n  .info span {\n    display: inline-block;\n    vertical-align: top;\n  }\n  .toggle-select{\n    font-weight: bold;\n  }\n  .selected{\n    margin: 0px 7px 0px 7px;\n  }</style></section>");
$templateCache.put("app/transactions/roll-over/rollOverReview.html","<div class=\"main-section rollover-review clearfix\"><div class=summary ng-init=Rollover.summaryInit()><p class=page-title>REVIEW ROLL-OVER</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{Rollover.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>ROLL OVER</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Rollover.formData.schemeName}}</td></tr><tr><td>Roll over mode</td><td>:</td><td>{{Rollover.ROLLOVER_MODE[Rollover.formData.amountType]}}</td></tr><tr ng-if=Rollover.formData.amount><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{(Rollover.formData.amount)?Rollover.formData.amount:\'N/A\'}}</td></tr><tr ng-if=\"Rollover.formData.amountType == \'NoOfUnits\'\"><td>No of units</td><td>:</td><td>{{(Rollover.formData.units)?Rollover.formData.units:\'N/A\'}}</td></tr><tr ng-if=\"Rollover.formData.amountType == \'AllUnits\'\"><td>All Free Units</td><td>:</td><td>Yes</td></tr></table></div></div><div class=row><div class=\"col-md-12 content-foot\"><div class=tc-block><div><div class=checkbox><input ng-model=Rollover.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=Summary.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div><a href=\"\" ng-click=Rollover.goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button ng-disabled=!Rollover.isCheckedTandC||!Rollover.formData ng-click=Rollover.rolloverConfirm(Rollover.saveRolloverRequest) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div></div></div>");
$templateCache.put("app/transactions/roll-over/rollover-view.html","<div class=\"main-section initiate-transaction\" ng-init=Rollover.init()><section class=rollover-view><p class=\"page-title text-uppercase\">Roll over</p><div class=\"content-area roll-availaible\"><ul ng-if=\"(!Rollover.schemeList || !Rollover.schemeList.length)\"><li style=padding-bottom:15px>No new schemes is currently open for Roll Over request</li></ul><ul ng-if=\"Rollover.schemeList && Rollover.schemeList.length\"><li class=clearfix ng-repeat=\"scheme in Rollover.schemeList track by $index\"><span class=\"pull-left text-primary\">{{scheme.schemeName}} </span><span class=pull-right><span class=select-folio><div class=selectfield ng-class={error:Rollover.tForm.folio.$invalid}><select name=folio ng-change=Rollover.selectFolio($index) ng-model=Rollover.formData.folioNumber ng-options=\"folio.folioNumber as folio.taxStatus for folio in scheme.folioDetails\" ng-init=\"Rollover.formData.folioNumber=Rollover.formData.folioNumber?Rollover.formData.folioNumber: null\" required><option value=\"\">Select Folio</option></select></div></span><button id=registered_{{$index}} ng-disabled=true class=\"btn-small btn-primary-action regBtn\" ng-click=\"Rollover.rolloverForm(scheme, Rollover.formData.folioNumber)\">Register</button></span></li></ul></div><div class=\"content-area clearfix rolled-list\"><header class=clearfix><p>Roll Over Details</p><div class=folio-tabs><span class=slide-left ng-if=\"Rollover.folioList.length>11 && !Rollover.slideLeftDisabled\" ng-click=Rollover.slideLeft($index)><i class=slide-left-icon></i></span><div class=capsule-box><span id=_first ng-repeat=\"folioValue in Rollover.folioList track by $index\"><span ng-if=Rollover.isDisplayed($index+1) class=\"capsule slide\" data={{$index+1}} ng-class=\"{\'active\': Rollover.selectedFolio == folioValue}\" ng-click=\"(Rollover.selectedFolio == folioValue) || Rollover.getFolioData(folioValue)\">{{folioValue}}</span></span></div><span class=slide-right ng-if=\"Rollover.folioList.length>11 && !Rollover.slideRightDisabled\" ng-click=Rollover.slideRight($index)><i class=slide-right-icon></i></span></div></header><table class=\"table table-striped rwd-table\"><thead><tr><th>TRANSACTION NO</th><th>TRANSACTION TIME</th><!--msg_created_time--><th>SOURCE scheme</th><th>ROLL OVER MODE</th><th>AMOUNT/ UNITS</th><th>STATUS</th><th>ACTION</th></tr></thead><tbody><tr ng-repeat=\"val in Rollover.rolloverData track by $index \"><td>{{val.cams_ref_no}}</td><td>{{val.msg_created_time}}</td><td>{{val.schemeName}}</td><td>{{val.rolloverMode}}</td><td ng-if=\"val.mode == \'unit\'\">{{val.amountOrUnits|unit:val.unitValue}} {{val.unitValue|unitValue}}<span ng-if=\"val.amountOrUnits !=\'NA\'\"> Units</span></td><td ng-if=\"val.mode == \'amount\'\"><i ng-if=\"val.amountOrUnits !=\'NA\'\" class=rupee-black-icon></i>{{val.amountOrUnits|unit:val.unitValue}} {{val.unitValue|unitValue}}</td><td>{{val.type == \"cancelled\" ? \"Cancelled\" :val.msg_current_status}}</td><td data-th=Action><span class=\"btn-more dropdown\"><button class=\"btn-secondary-action dropdown-toggle\" data-bs-toggle=dropdown>Actions <i class=arrow-blue-down-icon></i></button><ul class=dropdown-menu><li>Actions <i class=arrow-blue-down-icon></i></li><li class=list-group-item ng-click=Rollover.rolloverDetail(val)>Details <i class=\"arrow-right-icon pull-right\"></i></li></ul></span></td></tr></tbody><tbody><tr ng-if=\"(!Rollover.rolloverData || !Rollover.rolloverData.length) && !Rollover.isLoading\"><td class=text-center colspan=7>There are no schemes currently open for Roll Over under this folio</td></tr></tbody></table><!--      <div class=\"imp-info\">--><!--        <strong>Important:</strong>--><!--&lt;!&ndash;        <p>&ndash;&gt;--><!--&lt;!&ndash;          <i class=\"dot\"></i> <strong>Pending:</strong> <span>Investor has registered for roll over.</span>&ndash;&gt;--><!--&lt;!&ndash;        </p>&ndash;&gt;--><!--&lt;!&ndash;        <p>&ndash;&gt;--><!--&lt;!&ndash;          <i class=\"dot\"></i> <strong>Cancelled:</strong> <span>Online roll-over registered earlier has been cancelled by investor.</span>&ndash;&gt;--><!--&lt;!&ndash;        </p>&ndash;&gt;--><!--      </div>--><ng-bind-html ng-bind-html=Rollover.notes.noteDTO.noteDTOMap.Note_Roll_Over.content ng-if=Rollover.showNote></ng-bind-html></div></section></div>");
$templateCache.put("app/transactions/roll-over/rollover.html","<div class=\"main-section initiate-Rollover\" ng-init=Rollover.initAdd()><section class=rollover-form><p class=\"screen-title text-uppercase\">roll over</p><div class=content-area><form autocomplete=off class=row name=Rollover.tForm ng-keypress=Rollover.handleEnter($event) novalidate><p>Select Scheme for Roll Over</p><div class=row><div class=\"col-md-4 border-btm\"><table class=\"borderless table\"><tr><td>Selected Folio</td><td>:</td><td>{{Rollover.schemeData && Rollover.schemeData.folioNumber}}</td></tr><tr><td>Selected Scheme</td><td>:</td><td class=relative>{{Rollover.schemeData && Rollover.schemeData.schemeName}}<div class=rollover-scheme><div class=total-scheme><p class=text-uppercase>Total</p><p><span>Amount : </span><span easyassist-key=mask-element>&#8377 {{Rollover.schemeData.currentValue.totalCurrentValueAmount}}</span></p><p><span>Units : </span><span easyassist-key=mask-element>{{Rollover.schemeData.currentValue.totalCurrentValueUnits}}</span></p></div><div class=avail-rollover-unit><p class=text-uppercase>Available</p><p><span>Amount : </span><span easyassist-key=mask-element>&#8377 {{Rollover.schemeData.currentValue.freeValueAmount}}</span></p><p><span>Units : </span><span easyassist-key=mask-element>{{Rollover.schemeData.currentValue.freeValueUnits}}</span></p></div></div></td></tr></table></div></div><p>Select Roll Over Mode</p><div><span class=radio-block><span class=radio><input type=radio id=allUnits name=amountType value=AllUnits ng-model=Rollover.formData.amountType ng-change=Rollover.amountTypeChanged()> <span class=check></span></span><label>All Free units</label></span></div><div class=\"row amount col-md-12\"><div class=col-md-4><div class=input-normal ng-if=\"Rollover.formData.amountType==\'Amount\'\" ng-class=\"{error:(Rollover.tForm.amount.$invalid && Rollover.tForm.amount.$dirty) ||(Rollover.tForm.amount.$dirty && Rollover.isInvalidForm),\'has-data\':Rollover.formData.amount}\"><input type=number ignore-mouse-wheel name=amount ng-change=Rollover.checkSwitchValidations() ng-model=Rollover.formData.amount required> <span class=highlight></span> <span class=bar></span><label>Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"Rollover.tForm.amount.$error.required && Rollover.tForm.amount.$dirty\" ng-bind=Rollover.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Rollover.formData.amount && Rollover.isMin\" class=error-input>Minimum amount should be greater than &#8377; {{Rollover.validations.minAmount}}</span> <span ng-if=\"Rollover.formData.amount && Rollover.isMax\" class=error-input>Maximum amount should be less than or equal to &#8377; {{Rollover.validations.maxAmount}}</span></div><div class=input-normal ng-if=\"Rollover.formData.amountType==\'NoOfUnits\'\" ng-class=\"{error:(Rollover.tForm.units.$invalid && Rollover.tForm.units.$dirty)||(Rollover.tForm.units.$dirty && Rollover.isInvalidForm)}\"><input type=number ignore-mouse-wheel ng-change=Rollover.checkSwitchValidations() name=units ng-model=Rollover.formData.units required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter Units</label><span class=error-input ng-show=\"Rollover.tForm.units.$error.required && Rollover.tForm.units.$dirty\" ng-bind=Rollover.VALIDATE_DATA.UNITS_REQUIRED></span> <span ng-if=\"Rollover.formData.units && Rollover.isMin\" class=error-input>Minimum unit should be greater than {{Rollover.validations.minUnits}}</span> <span ng-if=\"Rollover.formData.units && Rollover.isMax\" class=error-input>Maximum unit should be less than or equal to {{Rollover.validations.maxUnits}}</span></div></div></div><div class=important-change><p class=imp-head>Important:</p><p class=imp-des>Actual unit balance available to switch/redeem maybe lower than total balance because of lien (s) marked against your unit, any recently purchased/switch in units where credit status is not established, investment in investments in ELSS (open ended scheme with 3 years locking), or any other valid reason.</p></div><div class=\"row form-footer\"><div class=\"col-md-8 text-left\"></div><div class=col-md-4><button ng-disabled=\"!Rollover.tForm.$valid || Rollover.isInvalidForm\" class=\"btn btn-primary-action pull-right common-btn-padding\" ng-click=Rollover.goToSummary()>Proceed to Transact</button></div></div></form></div></section></div>");
$templateCache.put("app/transactions/schedule-transaction-status/schedule-transaction-status.html","<section class=\"main-section transaction-status\" ng-init=ScheduleSummary.init()><!-- --><div class=content-area><div class=\"col-md-5 col-sm-6 review-grid\"><table class=\"table borderless\"><tr ng-if=\"ScheduleSummary.formData.transactionType !== \'REDEMPTION\' && !ScheduleSummary.formData.riaConsent\"><td>Distributor ARN</td><td>:</td><td ng-if=ScheduleSummary.formData.brokerCode>{{ScheduleSummary.formData.brokerCode}}</td><td ng-if=!ScheduleSummary.formData.brokerCode>DIRECT</td></tr><!--RIA code columns--><tr ng-if=\"ScheduleSummary.formData.transactionType !== \'REDEMPTION\' && ScheduleSummary.formData.riaConsent\"><td>RIA Code</td><td>:</td><td ng-if=ScheduleSummary.formData.brokerCode>{{ScheduleSummary.formData.brokerCode}}</td><td ng-if=!ScheduleSummary.formData.brokerCode>N/A</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType !== \'REDEMPTION\' && ScheduleSummary.formData.riaConsent\"><td>RIA Name</td><td>:</td><td ng-if=ScheduleSummary.formData.brokerCode>{{ScheduleSummary.riaName ? ScheduleSummary.riaName : \'NA\'}}</td><td ng-if=!ScheduleSummary.formData.brokerCode>N/A</td></tr><!--RIA code columns--><!-- <tr ng-if=\"ScheduleSummary.formData.transactionType === \'PURCHASE\' && ScheduleSummary.formData.euin.euinCode\">\n                    <td>EUIN Code</td>\n                    <td>:</td>\n                    <td>{{ScheduleSummary.formData.euin.euinCode}}</td>\n                </tr>\n                <tr ng-if=\"ScheduleSummary.formData.transactionType === \'PURCHASE\' && ScheduleSummary.formData.euin.euinName\">\n                    <td>EUIN Name</td>\n                    <td>:</td>\n                    <td>{{ScheduleSummary.formData.euin.euinName}}</td>\n                </tr> --><tr><td>Folio No.</td><td>:</td><td>{{ScheduleSummary.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{ScheduleSummary.formData.transactionType | camelcase}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType !== \'SWITCH\'\"><td>Scheme Name</td><td>:</td><td>{{ScheduleSummary.formData.sourceSchemeName}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\'\"><td>Switch Out Scheme</td><td>:</td><td>{{ScheduleSummary.formData.sourceSchemeName}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\'\"><td>Switch In Scheme</td><td>:</td><td>{{ScheduleSummary.formData.targetScheme}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\'\"><td>Investment Option</td><td>:</td><td>{{ScheduleSummary.formData.investmentOption === ScheduleSummary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? (ScheduleSummary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[ScheduleSummary.formData.investmentOption] | camelcase) : ScheduleSummary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[ScheduleSummary.formData.investmentOption]}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td>{{ScheduleSummary.formData.investmentOption === ScheduleSummary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? \'NA\' : ScheduleSummary.TRANSACTIONS_CONST.DESCRIPTIONS[ScheduleSummary.formData.dividendOption]}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\' && ScheduleSummary.formData.amount > 0\"><td>Redemption Amount</td><td>:</td><td>{{ScheduleSummary.formData.amount}}<br><label id=divDisplayWords>{{ScheduleSummary.formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\' && ScheduleSummary.formData.units > 0 && ScheduleSummary.formData.transactionMode.toLowerCase() !== ScheduleSummary.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Redemption Units</td><td>:</td><td>{{ScheduleSummary.formData.units}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\' && ScheduleSummary.formData.units > 0 && ScheduleSummary.formData.transactionMode.toLowerCase() === ScheduleSummary.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Redemption Units</td><td>:</td><td>All Free Units</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\'\"><td>Bank Name</td><td>:</td><td>{{ScheduleSummary.formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\'\"><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{ScheduleSummary.formData.bankInfo.bankAcNo}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\'\"><td>IFSC</td><td>:</td><td>{{ScheduleSummary.formData.bankInfo.ifscCode}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\'\"><td>Payout</td><td>:</td><td>{{ScheduleSummary.formData.bankInfo.payoutDescription |camelcase}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'PURCHASE\'\"><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{ScheduleSummary.formData.amount}}<br><label id=divDisplayWords>{{ScheduleSummary.formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\' && ScheduleSummary.formData.transactionMode.toLowerCase() !== ScheduleSummary.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td><span ng-if=!ScheduleSummary.formData.units>Amount</span><spann ng-if=ScheduleSummary.formData.units>Units</spann></td><td>:</td><td><i class=rupee-small-icon ng-if=!ScheduleSummary.formData.units></i>{{ScheduleSummary.formData.units ? ScheduleSummary.formData.units : ScheduleSummary.formData.amount}}<br><label ng-if=(!ScheduleSummary.formData.units) id=divDisplayWords>{{ScheduleSummary.formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\' && ScheduleSummary.formData.transactionMode.toLowerCase() === ScheduleSummary.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Units</td><td>:</td><td>All Free Units</td></tr><tr><td>Scheduled Date(s)*</td><td>:</td><td><span ng-if=ScheduleSummary.formData.scheduleDetails.scheduleDate>{{ScheduleSummary.formData.scheduleDetails.scheduleDate | dateformatter: \'DD-MMM-YYYY\'}}</span> <span ng-if=ScheduleSummary.formData.scheduleDetails.scheduleDates>, {{ScheduleSummary.formData.scheduleDetails.scheduleDates}}</span></td></tr><tr ng-if=ScheduleSummary.formData.scheduleDetails.frequency><td>Frequency</td><td>:</td><td>{{ScheduleSummary.formData.scheduleDetails.frequency}}</td></tr><tr ng-if=ScheduleSummary.formData.scheduleDetails.endDate><td>End Date</td><td>:</td><td>{{ScheduleSummary.formData.scheduleDetails.endDate | dateformatter: \'DD-MMM-YYYY\'}}</td></tr></table><div class=label-section><label>*If a scheduled date falls on a non-business day, then reminder SMS and Email will be sent on the immediately succeeding business day.</label></div></div><div class=\"col-md-7 col-sm-6 status-grid text-center\"><p class=verify-sign><i class=verify-icon></i></p><p class=\"status-info green success\">Transaction Scheduled Successfully</p><div class=status-message><span ng-if=\"ScheduleSummary.formData.transactionType === \'PURCHASE\'\">Your {{ScheduleSummary.formData.transactionType.toLowerCase()}} transaction with reference no {{ScheduleSummary.formData.transactionId}} has been successfully scheduled for the selected dates(s) with {{ScheduleSummary.formData.scheduleDetails.frequency}} frequency. The transaction(s) shall be deemed to be received only when confirmed on the Scheduled date(s) and payment is initiated before the cut-off timing as applicable. Further, applicability of NAV shall be as per SEBI guidelines. Alert notification will be sent on scheduled date(s) via SMS and Email on your mobile number and email ID registered in the folio. </span><span ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\' || ScheduleSummary.formData.transactionType === \'SWITCH\'\">Your {{ScheduleSummary.formData.transactionType.toLowerCase()}} transaction with reference no {{ScheduleSummary.formData.transactionId}} has been successfully scheduled for the selected dates(s) with {{ScheduleSummary.formData.scheduleDetails.frequency}} frequency. The transaction(s) shall be deemed to be received only when confirmed on the Scheduled date(s). Further, applicability of NAV shall be as per SEBI guidelines. Alert notification will be sent on scheduled date(s) via SMS and Email on your mobile number and email ID registered in the folio. </span><span><strong>You can view scheduled transactions under \'Saved Items\' page.</strong></span></div><div class=gottohome ui-sref=welcome ng-click=ScheduleSummary.clearSessionStorage()><i class=\"home-blue-icon cursor-pointer\"></i> <strong class=\"text-blue cursor-pointer\">Go To Home</strong></div></div></div></section>");
$templateCache.put("app/transactions/sip-cancellation/cancellation-details.html","<div class=\"main-section summary\" ng-init=Summary.init()><p class=page-title>SIP Cancellation Summary</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr class=\"cancellation-info text-center\"><td colspan=3 class=text>You have cancelled the following SIP</td></tr><!--          <tr>--><!--            <td>Status</td>--><!--            <td>:</td>--><!--            <td>Cancelled</td>--><!--          </tr>--><tr><td>Status date</td><td>:</td><td>21-March-2019</td></tr><tr><td>SIP Registration Number</td><td>:</td><td>HDDirect-1232</td></tr><tr><td>Folio Number</td><td>:</td><td>9881232</td></tr><tr><td>SIP Mode</td><td>:</td><td>Online</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>1256</td></tr><tr><td>Scheme Name</td><td>:</td><td>Some Scheme name</td></tr><tr><td>SIP From Date</td><td>:</td><td>09-Jan-1999</td></tr><tr><td>SIP To Date</td><td>:</td><td>09-Jan-2099</td></tr><tr><td>Number of Installments</td><td>:</td><td>7</td></tr><tr><td>SIP Frequency</td><td>:</td><td>Monthly</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td>1000</td></tr><tr><td>Distributor Code/Name</td><td>:</td><td>DIRECT/Direct</td></tr></table></div></div></div></div>");
$templateCache.put("app/transactions/sip-cancellation/cancellation-review.html","<div class=\"main-section summary\" ng-init=Summary.init()><p class=page-title>SIP Cancellation Details</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr><td>SIP Registration Number</td><td>:</td><td>HDDirect-1232</td></tr><tr><td>Folio Number</td><td>:</td><td>9881232</td></tr><tr><td>SIP Mode</td><td>:</td><td>Online</td></tr><tr><td>CAMS Transaction Number</td><td>:</td><td>1256</td></tr><tr><td>Scheme Name</td><td>:</td><td>Some Scheme name</td></tr><tr><td>SIP From Date</td><td>:</td><td>09-Jan-1999</td></tr><tr><td>SIP To Date</td><td>:</td><td>09-Jan-2099</td></tr><tr><td>Number of Installments</td><td>:</td><td>7</td></tr><tr><td>SIP Frequency</td><td>:</td><td>Monthly</td></tr><tr><td>Installment Amount(INR)</td><td>:</td><td>1000</td></tr><tr><td>Distributor Code/Name</td><td>:</td><td>DIRECT/Direct</td></tr></table></div><div class=\"imp-info col-md-12\"><strong>Important:</strong><p><i class=dot></i> <span>It takes 10 working days for the cancellation to be effective. Thus, if a SIP Investment is due within 10 working days from the date of cancellation, that installment will be processed and your bank amount will be debited for that SIP installment.</span></p></div></div><div class=content-foot><div><a href=\"\" ng-click=Summary.goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button class=\"btn-primary-action btn pull-right\">Confirm</button></div></div></div></div>");
$templateCache.put("app/transactions/status/transaction-status.html","<section class=\"main-section transaction-status\" ng-init=Summary.init()><!-- --><div class=content-area><div class=\"col-md-5 col-sm-6 review-grid\" ng-if=\"Summary.transactionType.toUpperCase() == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.FLEX_INDEX\"><!--  If Flex Index   --><table class=\"table borderless\"><tr ng-if=Summary.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=Summary.formData.isThroughDistributor>{{Summary.formData.distributorDetails.arnNo?\'ARN-\'+Summary.formData.distributorDetails.arnNo:\'\'}}</td><td ng-if=!Summary.formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=Summary.formData.distributorDetails.riaOpted><td>RIA Code</td><td>:</td><td ng-if=Summary.formData.distributorDetails.arnNo>{{Summary.formData.distributorDetails.arnNo}}</td><td ng-if=!Summary.formData.distributorDetails.arnNo>N/A</td></tr><tr ng-if=Summary.formData.distributorDetails.riaOpted><td>RIA Name</td><td>:</td><td ng-if=Summary.formData.distributorDetails.arnNo>{{Summary.riaName}}</td><td ng-if=!Summary.formData.distributorDetails.arnNo>N/A</td></tr><!--RIA code columns--><tr><td>Folio No.</td><td>:</td><td>{{Summary.formData.sourceScheme.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>Flex Index</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Summary.formData.sourceScheme.schemeName}}</td></tr><tr><td>Target Scheme</td><td>:</td><td>{{Summary.formData.targetScheme.schemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.targetScheme.dividendOption]}}</td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{Summary.formData.amount}}<br><label id=divDisplayWords>{{Summary.formData.amountInWords}} (In Words)</label></td></tr></table><table class=\"flex-table table\" style=\"margin-left: 10px\" ng-if=Summary.switchExecutionDetails><thead><tr><th>{{Summary.TRANSACTIONS_CONST.INVESTMENT_MODE[Summary.formData.investmentMode]}} Installments</th><th>Stages of Switch Execution<br><span style=color:#737373>S&P BSE SENSEX Levels</span></th></tr></thead><tbody><tr><td>{{Summary.switchExecutionDetails.firstSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(I) </span>{{Summary.switchExecutionDetails.firstSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{Summary.switchExecutionDetails.secondSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(I) </span>{{Summary.switchExecutionDetails.secondSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{Summary.switchExecutionDetails.thirdSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(I) </span>{{Summary.switchExecutionDetails.thirdSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{Summary.switchExecutionDetails.fourthSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(I) </span>{{Summary.switchExecutionDetails.fourthSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr></tbody></table></div><div class=\"col-md-5 col-sm-6 review-grid\" ng-if=\"Summary.transactionType.toUpperCase() == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.DTP\"><!--  If DTP   --><table class=\"table borderless\"><tr ng-if=Summary.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=Summary.formData.isThroughDistributor>{{Summary.formData.distributorDetails.arnNo?\'ARN-\'+Summary.formData.distributorDetails.arnNo:\'\'}}</td><td ng-if=!Summary.formData.isThroughDistributor>N/A</td></tr><tr><td>Folio No.</td><td>:</td><td>{{Summary.formData.sourceScheme.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.summaryType == \'DTP\'? \'TIP\': Summary.formData.summaryType}}</td></tr><tr><td>Transfer from Scheme</td><td>:</td><td ng-bind=Summary.formData.sourceScheme.schemeName></td></tr><tr><td>Transfer to Scheme</td><td>:</td><td ng-bind=Summary.formData.targetScheme.schemeName></td></tr><tr><td>Investment Option</td><td>:</td><td>{{Summary.formData.targetScheme.investmentOption.toUpperCase() != Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[Summary.formData.targetScheme.investmentOption] : (Summary.formData.targetScheme.investmentOption | camelcase)}}</td></tr><tr ng-if=\"Summary.formData.targetScheme.investmentOption.toUpperCase() != Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.targetScheme.dividendOption]}}</td></tr></table></div><div class=\"col-md-5 col-sm-6 review-grid\" style=\"display: none\"><!--  If Flex Stp   --><table class=\"table borderless\"><!--<tr>--><!--<td>Distributor ARN</td>--><!--<td>:</td>--><!--<td>9788778</td>--><!--</tr>--><!--RIA code columns--><tr ng-if=Summary.formData.distributorDetails.riaOpted><td>RIA Code</td><td>:</td><td ng-if=Summary.formData.distributorDetails.arnNo>{{Summary.formData.distributorDetails.arnNo}}</td><td ng-if=!Summary.formData.distributorDetails.arnNo>N/A</td></tr><tr ng-if=Summary.formData.distributorDetails.riaOpted><td>RIA Name</td><td>:</td><td ng-if=Summary.formData.distributorDetails.arnNo>{{Summary.riaName}}</td><td ng-if=!Summary.formData.distributorDetails.arnNo>N/A</td></tr><!--RIA code columns--><tr><td>Folio No.</td><td>:</td><td>{{Summary.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.formType}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Summary.formData.outSchemeName}}</td></tr><tr><td>Target Scheme</td><td>:</td><td>{{Summary.formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{Summary.formData.investmentOption.toUpperCase() != Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[Summary.formData.investmentOption] : ( Summary.formData.investmentOption | camelcase)}}</td></tr><tr ng-if=\"Summary.formData.investmentOption.toUpperCase() != Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.dividendOption]}}</td></tr><tr><td>STP Type</td><td>:</td><td>Flex</td></tr><tr><td>STP Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{Summary.formData.amount}}</td></tr><tr><td>Frequency</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Summary.formData.frequency]}}</td></tr><tr ng-if=\"Summary.formData.frequency === \'OW\'\"><td>Day of Transfer</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS.WEEK_DAYS[Summary.formData.day]}}</td></tr><tr><td>No. of Installments</td><td>:</td><td>{{Summary.formData.noOfInstallments}}</td></tr><tr><td>Start Date</td><td>:</td><td>{{Summary.formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>End Date</td><td>:</td><td>{{Summary.formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr></table></div><!--  If Flex STP   --><div class=\"col-md-5 col-sm-6 review-grid\" style=\"display: none\"><!--  If Instant Redeem   --><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{Summary.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.formType | camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Summary.formData.outSchemeName}}</td></tr><tr ng-if=Summary.formData.amount><td>Redemption Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.amount}}</td></tr><tr ng-if=Summary.formData.units><td>Redemption Units</td><td>:</td><td>{{Summary.formData.units}}</td></tr><tr><td>Bank Name</td><td>:</td><td>{{Summary.formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{Summary.formData.bankInfo.accountNo}}</td></tr><tr><td>Branch</td><td>:</td><td>{{Summary.formData.bankInfo.branchName}}</td></tr><tr><td>IFSC</td><td>:</td><td>{{Summary.formData.bankInfo.ifscCode}}</td></tr></table></div><div class=\"col-md-5 col-sm-6 review-grid\" ng-if=\"Summary.transactionType.toUpperCase() == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\"><!--  If Purchase   --><table class=\"table borderless\"><tr ng-if=!Summary.formData.distributorDetails.riaOpted><td>Distributor ARN</td><td>:</td><td ng-if=Summary.formData.distributorDetails>{{Summary.formData.distributorDetails.arnNo}}</td><td ng-if=!Summary.formData.distributorDetails>N/A</td></tr><!--RIA code columns--><tr ng-if=Summary.formData.distributorDetails.riaOpted><td>RIA Code</td><td>:</td><td ng-if=Summary.formData.distributorDetails.arnNo>{{Summary.formData.distributorDetails.arnNo}}</td><td ng-if=!Summary.formData.distributorDetails.arnNo>N/A</td></tr><tr ng-if=Summary.formData.distributorDetails.riaOpted><td>RIA Name</td><td>:</td><td ng-if=Summary.formData.distributorDetails.arnNo>{{Summary.riaName}}</td><td ng-if=!Summary.formData.distributorDetails.arnNo>N/A</td></tr><!--RIA code columns--><tr ng-if=Summary.formData.euinCode><td>EUIN Code</td><td>:</td><td>{{Summary.formData.euinCode}}</td></tr><tr ng-if=Summary.formData.euinName><td>EUIN Name</td><td>:</td><td>{{Summary.formData.euinName}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Summary.formData.folioNumber}}</td></tr><tr><td>CAMS Reference No.</td><td>:</td><td>{{Summary.formData.camsReferenceNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.summaryType |camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Summary.formData.schemeName}}</td></tr><tr ng-if=Summary.formData.purchaseInvestmentOption><td>Investment Option</td><td>:</td><td>{{Summary.formData.purchaseInvestmentOption}}</td></tr><tr ng-if=\"Summary.formData.purchaseInvestmentOption===Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td><span ng-if=\"Summary.formData.purchaseInvestmentOption===Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.purchaseDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon ng-if=Summary.formData.amount></i> {{Summary.formData.amount}}<br><label id=purchasestatusDisplayWords>{{Summary.formData.amountInWords}} (In Words)</label></td></tr></table></div><div class=\"col-md-5 col-sm-6 review-grid\" ng-if=\"Summary.transactionType.toUpperCase() == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.REDEMPTION\"><!--  If Redeem   --><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{Summary.formData.sourceScheme.folioNumber}}</td></tr><tr><td>CAMS Reference No.</td><td>:</td><td>{{Summary.formData.camsReferenceNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.summaryType | camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Summary.formData.sourceScheme.schemeName}}</td></tr><tr ng-if=\"Summary.transactionValue === Summary.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && Summary.formData.sourceScheme.withDrawalAmount\"><td>Redemption Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.sourceScheme.withDrawalAmount}}<br><label id=reedemstatusDisplayWords>{{Summary.formData.sourceScheme.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"Summary.transactionValue === Summary.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS && Summary.formData.sourceScheme.withDrawalUnits\"><td>Redemption Units</td><td>:</td><td>{{Summary.formData.sourceScheme.withDrawalUnits.toFixed(3)}}</td></tr><tr ng-if=\"Summary.transactionValue === Summary.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Units</td><td>:</td><td>All Free Units</td></tr><tr><td>Bank Name</td><td>:</td><td>{{Summary.formData.accountList[0].bankName | uppercase}}</td></tr><tr><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{Summary.formData.accountList[0].bankAcNo}}</td></tr><!--<tr>\n          <td>Branch</td>\n          <td>:</td>\n          <td>{{Summary.formData.bankInfo.bankBranch}}</td>\n        </tr>--><tr><td>IFSC</td><td>:</td><td easyassist-key=mask-element>{{Summary.formData.accountList[0].ifscCode}}</td></tr><tr><td>Payout</td><td>:</td><td>{{Summary.formData.accountList[0].payoutDescription|camelcase}}</td></tr></table></div><div class=\"col-md-5 col-sm-6 review-grid\" ng-if=\"Summary.transactionType.toUpperCase() == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.INSTANT_REDEMPTION\"><!--  If instant Redeem   --><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{Summary.formData.sourceScheme.folioNumber}}</td></tr><tr><td>CAMS Reference No.</td><td>:</td><td>{{Summary.formData.camsReferenceNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.summaryType | camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Summary.formData.sourceScheme.schemeName}}</td></tr><tr ng-if=Summary.formData.sourceScheme.withDrawalAmount><td>Redemption Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.sourceScheme.withDrawalAmount}}<br><label id=instantRedeemstatusDisplayWords>{{Summary.formData.sourceScheme.amountInWords}} (In Words)</label></td></tr><tr ng-if=Summary.formData.sourceScheme.withDrawalUnits><td>Redemption Units</td><td>:</td><td>{{Summary.formData.sourceScheme.withDrawalUnits.toFixed(3)}}</td></tr><tr><td>Bank Name</td><td>:</td><td>{{Summary.formData.accountList[0].bankName | uppercase}}</td></tr><tr><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{Summary.formData.accountList[0].bankAcNo}}</td></tr><!--<tr>\n          <td>Branch</td>\n          <td>:</td>\n          <td>{{Summary.formData.bankInfo.bankBranch}}</td>\n        </tr>--><tr><td>IFSC</td><td>:</td><td>{{Summary.formData.accountList[0].ifscCode}}</td></tr><!--<tr>\n          <td>Payout</td>\n          <td>:</td>\n          <td>{{Summary.formData.accountList[0].payoutDescription|camelcase}}</td>\n        </tr>--></table></div><div class=\"col-md-5 col-sm-6 review-grid\" ng-if=\"Summary.transactionType.toUpperCase() == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.STP\"><!--  If STP   --><table class=\"table borderless\"><tr ng-if=Summary.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=Summary.formData.isThroughDistributor>{{Summary.formData.distributorDetails.arnNo?\'ARN-\'+Summary.formData.distributorDetails.arnNo:\'\'}}</td><td ng-if=!Summary.formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=Summary.formData.distributorDetails.riaOpted><td>RIA Code</td><td>:</td><td ng-if=Summary.formData.distributorDetails.arnNo>{{Summary.formData.distributorDetails.arnNo}}</td><td ng-if=!Summary.formData.distributorDetails.arnNo>N/A</td></tr><tr ng-if=Summary.formData.distributorDetails.riaOpted><td>RIA Name</td><td>:</td><td ng-if=Summary.formData.distributorDetails.arnNo>{{Summary.riaName}}</td><td ng-if=!Summary.formData.distributorDetails.arnNo>N/A</td></tr><!--RIA code columns--><tr><td>Folio No.</td><td>:</td><td>{{Summary.formData.sourceScheme.folioNumber}}</td></tr><tr><td>CAMS Reference No.</td><td>:</td><td>{{Summary.formData.camsReferenceNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.summaryType | uppercase}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Summary.formData.sourceScheme.schemeName}}</td></tr><tr><td>Target Scheme</td><td>:</td><td>{{Summary.formData.stpTargetScheme.schemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{Summary.formData.stpTargetScheme.investmentOption.toUpperCase() != Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[Summary.formData.stpTargetScheme.investmentOption] : (Summary.formData.stpTargetScheme.investmentOption | camelcase)}}</td></tr><tr ng-if=\"Summary.formData.stpTargetScheme.investmentOption.toUpperCase() != Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.stpTargetScheme.dividendOption]}}</td></tr><tr><td>STP Type</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.STP_TYPE[Summary.formData.stpTargetScheme.stpType]}}</td></tr><tr ng-if=\"Summary.formData.transferOption === \'F\'\"><td>STP Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{Summary.formData.stpTargetScheme.amount}}<br><label id=STPstatusDisplayWords>{{Summary.formData.stpTargetScheme.amountInWords}} (In Words)</label></td></tr><tr><td>Frequency</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Summary.formData.stpTargetScheme.paymentFrequency]}}</td></tr><tr><td>STP Start Date</td><td>:</td><td>{{Summary.formData.stpTargetScheme.startDate | date : \'dd-MMM-yyyy\'}}</td></tr><tr ng-if=\"Summary.formData.stpTargetScheme.paymentFrequency !== \'DZ\'\"><td>STP End Date</td><td>:</td><td>{{Summary.formData.stpTargetScheme.endDate | date : \'dd-MMM-yyyy\'}}</td></tr><tr ng-if=\"Summary.formData.stpTargetScheme.paymentFrequency === \'DZ\'\"><td>No of Installments</td><td>:</td><td>{{Summary.formData.stpTargetScheme.installments}}</td></tr></table></div><!--  If STP   --><div class=\"col-md-5 col-sm-6 review-grid\" ng-if=\"Summary.transactionType.toUpperCase() == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWITCH\"><table class=\"table borderless\"><tr ng-if=Summary.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=Summary.formData.isThroughDistributor>{{Summary.formData.distributorDetails.arnNo?\'ARN-\'+Summary.formData.distributorDetails.arnNo:\'\'}}</td><td ng-if=!Summary.formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=Summary.formData.distributorDetails.riaOpted><td>RIA Code</td><td>:</td><td ng-if=Summary.formData.distributorDetails.riaOpted>{{Summary.formData.distributorDetails.arnNo}}</td><td ng-if=!Summary.formData.distributorDetails.riaOpted>N/A</td></tr><tr ng-if=Summary.formData.distributorDetails.riaOpted><td>RIA Name</td><td>:</td><td ng-if=Summary.formData.distributorDetails.riaOpted>{{Summary.riaName}}</td><td ng-if=!Summary.formData.distributorDetails.riaOpted>N/A</td></tr><!--RIA code columns--><tr><td class=col-md-5>Folio No.</td><td>:</td><td>{{Summary.formData.sourceScheme.folioNumber}}</td></tr><tr><td>CAMS Reference No.</td><td>:</td><td>{{Summary.formData.camsReferenceNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.summaryType | camelcase}}</td></tr><tr><td>Switch Out Scheme</td><td>:</td><td>{{Summary.formData.sourceScheme.schemeName}}</td></tr><tr><td>Switch In Scheme</td><td>:</td><td>{{Summary.formData.targetScheme.schemeName}}</td></tr><tr ng-if=\"Summary.formData.targetScheme.investmentOption == Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Investment Option</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[Summary.formData.targetScheme.investmentOption] | camelcase}}</td></tr><tr ng-if=\"Summary.formData.targetScheme.investmentOption != Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Investment Option</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[Summary.formData.targetScheme.investmentOption]}}</td></tr><tr ng-if=\"Summary.formData.targetScheme.investmentOption.toUpperCase() != Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.targetScheme.dividendOption]}}</td></tr><tr ng-if=\"Summary.transactionValue === Summary.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT\"><td style=\"width: 140px\">Amount</td><td style=\"width: 15px\">:</td><td><i class=rupee-small-icon></i> {{Summary.formData.targetScheme.amount}}<br><label id=switchstatusDisplayWords>{{Summary.formData.targetScheme.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"Summary.transactionValue === Summary.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td>Units</td><td>:</td><td>{{Summary.formData.targetScheme.units}}</td></tr><tr ng-if=\"Summary.transactionValue === Summary.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Units</td><td>:</td><td>All Free Units</td></tr></table></div><!--  If Switch   --><div class=\"col-md-5 col-sm-6 review-grid\" ng-if=\"Summary.transactionType.toUpperCase() == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP\"><!--  If SWP   --><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{Summary.formData.sourceScheme.folioNumber}}</td></tr><tr><td>CAMS Reference No.</td><td>:</td><td>{{Summary.formData.camsReferenceNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.summaryType}}</td></tr><tr><td>Withdrawal Scheme</td><td>:</td><td>{{Summary.formData.sourceScheme.schemeName}}</td></tr><tr><td>Withdrawal Type</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.swpWithdrawalOptions.swpType]}}</td></tr><tr ng-if=\"Summary.formData.swpWithdrawalOptions.swpType === \'F\'\"><td>Withdrawal Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.sourceScheme.withDrawalAmount}}<br><label id=SWPstatusDisplayWords>{{Summary.formData.sourceScheme.amountInWords}} (In Words)</label></td></tr><tr><td>Frequency</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Summary.formData.swpWithdrawalOptions.frequency]}}</td></tr><tr><td>Start Date</td><td>:</td><td>{{Summary.formData.swpWithdrawalOptions.startDate | date : \'dd-MMM-yyyy\'}}</td></tr><tr><td>End Date</td><td>:</td><td>{{Summary.formData.swpWithdrawalOptions.endDate | date : \'dd-MMM-yyyy\'}}</td></tr><tr><td>Bank Name</td><td>:</td><td ng-bind=\"Summary.formData.accountList[0].bankName | uppercase\" easyassist-key=mask-element></td></tr><tr><td>Account Number</td><td>:</td><td ng-bind=Summary.formData.accountList[0].bankAcNo easyassist-key=mask-element></td></tr></table></div><div class=\"col-md-5 col-sm-6 review-grid\" ng-if=\"Summary.transactionType.toUpperCase() == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.SMART_SWAP\"><!--  If SWP   --><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{Summary.formData.sourceScheme.folioNumber}}</td></tr><tr><td>CAMS Reference No.</td><td>:</td><td>{{Summary.formData.camsReferenceNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>SMART SWAP</td></tr><tr><td>Withdrawal Scheme</td><td>:</td><td>{{Summary.formData.sourceScheme.schemeName}}</td></tr><!--        <tr>--><!--          <td>Withdrawal Type</td>--><!--          <td>:</td>--><!--          <td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.swpWithdrawalOptions.swpType]}}</td>--><!--        </tr>--><tr><td>SMART SWAP Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.sourceScheme.withDrawalAmount}}<br><label id=smartSwapstatusDisplayWords>{{Summary.formData.sourceScheme.amountInWords}} (In Words)</label></td></tr><tr><td>Frequency</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Summary.formData.swpWithdrawalOptions.frequency]}}</td></tr><tr><td>% Percentage (per annum)</td><td>:</td><td>{{Summary.formData.swpWithdrawalOptions.percentage}}</td></tr><tr><td>SMART SWAP Start Date</td><td>:</td><td>{{Summary.formData.swpWithdrawalOptions.startDate | date : \'dd-MMM-yyyy\'}}</td></tr><tr><td>Bank Name</td><td>:</td><td ng-bind=\"Summary.formData.accountList[0].bankName | uppercase\" easyassist-key=mask-element></td></tr><tr><td>Account Number</td><td>:</td><td ng-bind=Summary.formData.accountList[0].bankAcNo easyassist-key=mask-element></td></tr></table></div><div class=\"col-md-5 col-sm-6 review-grid\" ng-if=\"Summary.transactionType.toUpperCase() == Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.ROLLOVER\"><!--  If rollover   --><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{Summary.formData.folioNumber}}</td></tr><tr><td>CAMS Reference No.</td><td>:</td><td>{{Summary.formData.camsReferenceNumber}}</td></tr><tr><td>Scheme</td><td>:</td><td ng-bind=Summary.formData.schemeName></td></tr><tr><td>Roll over mode</td><td>:</td><td>{{Summary.ROLLOVER_MODE[Summary.formData.rolloverMode]}}</td></tr><tr ng-if=Summary.formData.amount><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{(Summary.formData.amount)?Summary.formData.amount:\'N.A\'}}<br><label id=RolloverstatusDisplayWords>{{Summary.formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"Summary.formData.rolloverMode == \'NoOfUnits\'\"><td>No of units</td><td>:</td><td>{{(Summary.formData.units)?Summary.formData.units:\'N.A\'}}</td></tr><tr ng-if=\"Summary.formData.rolloverMode == \'AllUnits\'\"><td>All Free Units</td><td>:</td><td>Yes</td></tr></table></div><div class=\"col-md-7 col-sm-6 status-grid text-center\"><p class=verify-sign><i class=verify-icon></i></p><p class=\"status-info green\">Transaction Initiated Successfully</p><div ng-if=\"Summary.isFavourite == \'false\'\" class=fav-block><div class=checkbox><input type=checkbox ng-disabled=Summary.favrouitModel ng-model=Summary.favrouitModel ng-change=Summary.favrouiteApi(Summary.transactionId)> <i class=icon-favorite></i></div><strong class=text-blue>Mark as a Favourite Transaction</strong></div><div class=gottohome ui-sref=welcome><i class=\"home-blue-icon cursor-pointer\"></i> <strong class=\"text-blue cursor-pointer\">Go To Home</strong></div></div></div></section>");
$templateCache.put("app/transactions/summary/summary.html","<div class=\"main-section clearfix initiate\"><div class=email-view><div data-ng-switch=Summary.summaryToOpen><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/transactions/summary/summary.purchase.sip.html\'\"></div></div></div></div></div>");
$templateCache.put("app/transactions/summary/summary.purchase.sip.html","<div class=summary ng-init=Summary.init()><p class=page-title ng-if=\"Summary.formData.investmentType === Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || Summary.formData.optionalInvestmentType === Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\">REVIEW TRANSACTION : PURCHASE INVESTMENT</p><p class=page-title ng-if=\"Summary.formData.investmentType === Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || Summary.formData.optionalInvestmentType === Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\">REVIEW TRANSACTION : SYSTEMATIC INVESTMENT PLAN REGISTRATION</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"Summary.formData.investmentType === Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || Summary.formData.optionalInvestmentType === Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\"><!--<p class=\"sec-head\">Purchase Investment</p>--><table class=\"table borderless\"><tr ng-if=Summary.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=Summary.formData.isThroughDistributor>{{Summary.formData.brokerCode?\'ARN-\'+Summary.formData.brokerCode:(Summary.formData.distributorARN?Summary.formData.distributorARN:\'\')}}</td><td ng-if=!Summary.formData.isThroughDistributor>N/A</td></tr><tr ng-if=\"Summary.formData.euin && Summary.formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{Summary.formData.euin.euinCode?Summary.formData.euin.euinCode:\'N/A\'}}</td></tr><tr ng-if=\"Summary.formData.euin && Summary.formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{Summary.formData.euin.euinName?Summary.formData.euin.euinName:\'N/A\'}}</td></tr><tr ng-if=Summary.formData.subBrokerARN><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+Summary.formData.subBrokerARN}}</td></tr><tr ng-if=Summary.formData.subBrokerCode><td>Sub Broker Code</td><td>:</td><td>{{Summary.formData.subBrokerCode}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Summary.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.investmentType|camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Summary.formData.purchaseInSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{Summary.formData.purchaseInvestmentOption | camelcase}}</td></tr><tr ng-if=\"Summary.formData.purchaseInvestmentOption===Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>IDCW Option</td><td>:</td><td><span ng-if=\"Summary.formData.purchaseInvestmentOption===Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.purchaseDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.purchaseAmount}}</td></tr><tr ng-if=Summary.formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td>:</td><td ng-bind=\"Summary.formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=Summary.formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td>:</td><td ng-bind=Summary.formData.inSchemeName></td></tr><tr ng-if=\"Summary.formData.checkedNfoAutoSwitch && Summary.formData.switchSchemeInvestmentOption==\'DIVIDEND\'\"><td>Auto Switch Scheme IDCW Option:</td><td>:</td><td ng-bind=\"Summary.formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table></div><div class=col-md-6 ng-if=\"Summary.formData.investmentType === Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || Summary.formData.optionalInvestmentType === Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"><!--<p class=\"sec-head\">SIP Investment</p>--><table class=\"table borderless\"><tr ng-if=Summary.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=Summary.formData.isThroughDistributor>{{Summary.formData.brokerCode?\'ARN-\'+Summary.formData.brokerCode:(Summary.formData.distributorARN?Summary.formData.distributorARN:\'\')}}</td><td ng-if=!Summary.formData.isThroughDistributor>N/A</td></tr><tr ng-if=\"Summary.formData.euin && Summary.formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{Summary.formData.euin.euinCode}}</td></tr><tr ng-if=\"Summary.formData.euin && Summary.formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{Summary.formData.euin.euinName}}</td></tr><tr ng-if=Summary.formData.subBrokerARN><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+Summary.formData.subBrokerARN}}</td></tr><tr ng-if=Summary.formData.subBrokerCode><td>Sub Broker Code</td><td>:</td><td>{{Summary.formData.subBrokerCode}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Summary.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.formData.investmentType}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Summary.formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{Summary.formData.investmentOption | camelcase}}</td></tr><tr ng-if=\"Summary.formData.investmentOption===Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>IDCW Option</td><td>:</td><td><span ng-if=\"Summary.formData.investmentOption===Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS[Summary.formData.sipDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.amount}}</td></tr><tr><td>Installment Frequency</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Summary.formData.frequency]}}</td></tr><tr><td>Start Date</td><td>:</td><td>{{Summary.formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>End Date</td><td>:</td><td>{{Summary.formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"Summary.formData.sipPaymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"Summary.formData.sipPaymentOption ==\'OTM\'\">OTM (One Time Mandate)</td></tr><tr><td>Bank Name</td><td>:</td><td>{{Summary.formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"(Summary.formData.bankInfo.bankName==\'HDFC BANK\' && Summary.formData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{Summary.formData.bankAcNo}}</td></tr><tr ng-if=\"Summary.formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{Summary.formData.bankInfo.omUmrn}}</td></tr><tr ng-if=Summary.formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"Summary.formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=Summary.formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=Summary.formData.inSchemeName></td></tr><tr ng-if=Summary.formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"Summary.formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table></div><div class=col-md-6 ng-if=\"Summary.formData.investmentType === Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || Summary.formData.optionalInvestmentType === Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"><table class=\"borderless table\"><tr ng-if=Summary.formData.sipTopupEnabled><td>SIP Topup Enabled</td><td>:</td><td>Yes</td></tr><tr ng-if=\"Summary.formData.sipTopupEnabled && Summary.formData.topupDetails.amount\"><td>SIP Topup Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.topupDetails.amount}}</td></tr><tr ng-if=\"Summary.formData.sipTopupEnabled && Summary.formData.topupDetails.percentage\"><td>SIP Topup Percentage</td><td>:</td><td>{{Summary.formData.topupDetails.percentage}}%</td></tr><tr ng-if=\"Summary.formData.sipTopupEnabled && Summary.formData.topupDetails.frequency\"><td>SIP Topup Frequency</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Summary.formData.topupDetails.frequency]}}</td></tr><tr ng-if=\"Summary.formData.sipTopupEnabled && Summary.formData.topupDetails.capAmount\"><td>SIP Topup Cap Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.topupDetails.capAmount}}</td></tr><tr ng-if=\"Summary.formData.sipTopupEnabled && Summary.formData.topupDetails.capMonthYear\"><td style=\"width: 200px\">SIP Topup Cap Month/Year</td><td>:</td><td>{{Summary.capMonthYear}}</td></tr></table></div><div class=col-md-6 ng-if=\"Summary.formData.summaryType === \'SIP_TOPUP\'\"><table class=\"table borderless\"><tr><td>Folio Number</td><td>:</td><td>{{Summary.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.TRANSACTION_TYPE[Summary.formData.summaryType]}}</td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.amount}}</td></tr><tr><td>Installment Frequency</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Summary.formData.frequency]}}</td></tr><tr><td>Sip End Date</td><td>:</td><td>{{Summary.formData.toDate}}</td></tr><tr ng-if=Summary.formData.topupAmount><td>Topup Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.topupAmount}}</td></tr><tr ng-if=Summary.formData.topupPercentage><td>Topup Percentage</td><td>:</td><td>{{Summary.formData.topupPercentage}}%</td></tr><tr><td>Topup Frequency</td><td>:</td><td>{{Summary.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Summary.formData.topupFrequency]}}</td></tr><tr ng-if=Summary.formData.topupCapAmount><td>Topup Cap-Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Summary.formData.topupCapAmount}}</td></tr><tr ng-if=Summary.formData.topupCapMonthYear><td>Topup Cap-Date</td><td>:</td><td>{{Summary.sipTopupCapMonthYear}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"Summary.formData.bankDetailsForECS.paymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"Summary.formData.bankDetailsForECS.paymentOption ==\'OTM\'\">OTM (One Time Mandate)</td></tr><tr><td>Bank Name</td><td>:</td><td>{{Summary.formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"(Summary.formData.bankInfo.bankName==\'HDFC BANK\' && Summary.formData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{Summary.formData.bankAcNo}}</td></tr><tr ng-if=\"Summary.formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{Summary.formData.bankInfo.omUmrn}}</td></tr><tr ng-if=Summary.formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"Summary.formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=Summary.formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=Summary.formData.inSchemeName></td></tr><tr ng-if=Summary.formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"Summary.formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table></div></div><div class=tc-block><h6>Terms & Conditions</h6><div><div class=checkbox><input id=isCheckedTandC ng-model=Summary.isCheckedTandC type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=Summary.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div></div></div><div class=content-foot><input type=hidden id=hfReq><div><span ng-click=Summary.goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span> <button ng-disabled=!Summary.isCheckedTandC||!Summary.formData ng-click=Summary.submitForm() class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div><style>.checkbox label{padding-left: 0}</style>");
$templateCache.put("app/transactions/summary/summary.schedule-payment-audit.html","<div class=\"container-fluid payment-audit\"><div class=row><div class=col-xs-12><header><div class=logo><img src=../../../assets/images/logo.png></div></header></div></div><div class=row><div class=col-xs-12><section class=initiate-transaction><div class=summary><p class=page-title>COMPLETE TRANSACTION : <span>Scheduled</span> {{SummarySchedule.transactionType|camelcase}}</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\" ng-if=\"SummarySchedule.transactionType === \'PURCHASE\' \"><tr><td>Folio No.</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.folioNumber}}</td></tr><tr><td>Distributor ARN</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.brokerCode}}</td></tr><tr ng-if=SummarySchedule.scheduleTransactionDetails.euin><td>EUIN Code</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.euin}}</td></tr><tr ng-if=SummarySchedule.scheduleTransactionDetails.euin><td>EUIN Name</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.euinName}}</td></tr><tr ng-if=SummarySchedule.scheduleTransactionDetails.subBrokerCode><td>Sub Broker Code</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.subBrokerCode}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{SummarySchedule.transactionType | camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.defaultSourceSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.purchaseInvestmentOption | camelcase}}</td></tr><tr ng-if=\"SummarySchedule.scheduleTransactionDetails.oneClickSchedulePurchase && SummarySchedule.scheduleTransactionDetails.purchaseInvestmentOption == \'DIVIDEND\' \"><td>Dividend Option</td><td>:</td><td ng-if=\"SummarySchedule.scheduleTransactionDetails.dividendOption == \'Y\' \">Dividend Reinvest</td><td ng-if=\"SummarySchedule.scheduleTransactionDetails.dividendOption == \'N\' \">Dividend Payout</td></tr><tr ng-if=\"SummarySchedule.scheduleTransactionDetails.purchaseInvestmentOption === SummarySchedule.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>IDCW Option</td><td>:</td><td><span ng-if=\"SummarySchedule.scheduleTransactionDetails.purchaseInvestmentOption === SummarySchedule.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{SummarySchedule.TRANSACTIONS_CONST.DESCRIPTIONS[SummarySchedule.scheduleTransactionDetails.purchaseDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td ng-if=!SummarySchedule.scheduleTransactionDetails.oneClickSchedulePurchase><i class=rupee-small-icon></i> {{SummarySchedule.scheduleTransactionDetails.amount}}</td><td ng-if=SummarySchedule.scheduleTransactionDetails.oneClickSchedulePurchase><input type=number ng-model=SummarySchedule.scheduleTransactionDetails.amount ng-change=SummarySchedule.changeAmount() style=\"width: 75%;height: 35px;border-bottom: 1px solid gray;padding: 0px 0px 0px 15px\" required><br><span style=\"color: red\" ng-if=!SummarySchedule.scheduleTransactionDetails.amount>Amount required!</span> <span style=\"color: red\" ng-if=SummarySchedule.isPurchaseMin>Amount cannot be less than the minimum required amount {{SummarySchedule.purchaseValidations.minAddlPurchaseAmt}}</span></td></tr><tr><td>Scheduled Date</td><td>:</td><td ng-if=!SummarySchedule.scheduleTransactionDetails.oneClickSchedulePurchase>{{SummarySchedule.scheduleTransactionDetails.scheduleDate | dateformatter: \'DD-MMM-YYYY\'}}</td><td ng-if=SummarySchedule.scheduleTransactionDetails.oneClickSchedulePurchase>{{SummarySchedule.scheduleTransactionDetails.purchaseDay}}</td></tr></table><table class=\"table borderless\" ng-if=\"SummarySchedule.transactionType === \'SWITCH\' \"><tr><td>Folio No.</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{SummarySchedule.transactionType | camelcase}}</td></tr><tr><td>Switch Out Scheme</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.defaultSourceSchemeName}}</td></tr><tr><td>Switch In Scheme</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.targetSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.investmentOption | camelcase}}</td></tr><tr ng-if=\"SummarySchedule.scheduleTransactionDetails.investmentOption.toUpperCase() != SummarySchedule.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td style=\"width: 240px\">Target Scheme IDCW Option</td><td>:</td><td>{{SummarySchedule.TRANSACTIONS_CONST.DESCRIPTIONS[SummarySchedule.scheduleTransactionDetails.dividendOption]}}</td></tr><tr><td>Scheduled Date</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.scheduleDate | dateformatter: \'DD-MMM-YYYY\'}}</td></tr></table><table class=\"table borderless\" ng-if=\"SummarySchedule.transactionType === \'REDEMPTION\' \"><tr><td>Folio No.</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{SummarySchedule.transactionType| camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.defaultSourceSchemeName}}</td></tr><tr ng-if=SummarySchedule.scheduleTransactionDetails.amount><td>Redemption Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{SummarySchedule.scheduleTransactionDetails.amount}}</td></tr><tr ng-if=\"SummarySchedule.scheduleTransactionDetails.units && SummarySchedule.scheduleTransactionDetails.amountType == SummarySchedule.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td>Redemption Units</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.units}}</td></tr><tr ng-if=\"SummarySchedule.scheduleTransactionDetails.transactionMode.toLowerCase() === SummarySchedule.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Units</td><td>:</td><td>All Free Units</td></tr><tr><td>Bank Name</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.bankName | uppercase}}</td></tr><tr><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{SummarySchedule.scheduleTransactionDetails.accountNumber}}</td></tr><tr><td>IFSC</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.ifsc}}</td></tr><tr><td>Payout</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.payoutDesc | uppercase}}</td></tr><tr><td>Scheduled Date</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.scheduleDate | dateformatter: \'DD-MMM-YYYY\'}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\" ng-if=\"SummarySchedule.transactionType === \'SWITCH\' \"><tr ng-if=SummarySchedule.scheduleTransactionDetails.amount><td>Amount</td><td style=\"width: 15px\">:</td><td><i class=rupee-small-icon ng-if=!SummarySchedule.scheduleTransactionDetails.units></i> {{SummarySchedule.scheduleTransactionDetails.units ? \'NA\' : SummarySchedule.scheduleTransactionDetails.amount}}</td></tr><tr ng-if=\"SummarySchedule.scheduleTransactionDetails.transactionMode.toLowerCase() === SummarySchedule.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td>Units</td><td>:</td><td>{{SummarySchedule.scheduleTransactionDetails.units?SummarySchedule.scheduleTransactionDetails.units:\'NA\'}}</td></tr><tr ng-if=\"SummarySchedule.scheduleTransactionDetails.transactionMode.toLowerCase() === SummarySchedule.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Units</td><td>:</td><td>All Free Units</td></tr><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{SummarySchedule.scheduleTransactionDetails.emailID}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{SummarySchedule.scheduleTransactionDetails.mobileNumber}}</td></tr></table><table class=\"table borderless\" ng-if=\"SummarySchedule.transactionType !== \'SWITCH\'\"><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{SummarySchedule.scheduleTransactionDetails.emailID}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{SummarySchedule.scheduleTransactionDetails.mobileNumber}}</td></tr></table></div></div><div class=row ng-if=\"SummarySchedule.transactionType === \'PURCHASE\'\"><div class=col-md-12><section class=payment-screen><h3 class=page-title>Please Select a Payment Methods</h3><div class=tabheads><div class=tabhead ng-repeat=\"_option in SummarySchedule.paymentOptions\" ng-class=\"{\'active-DEBIT\': SummarySchedule.formData.purchasePaymentOption===_option}\"><div class=radio-block><span class=radio><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-change=SummarySchedule.changedPaymentOption() ng-model=SummarySchedule.formData.purchasePaymentOption> <span class=check></span> </span><span class=radio-label>{{SummarySchedule.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><form autocomplete=off novalidate name=tForm><div class=tab-body ng-switch=SummarySchedule.formData.purchasePaymentOption><div class=row ng-switch-when=NETBANKING><div class=\"point-to-note imp-info\" ng-if=!SummarySchedule.oneClickHDFCFLow>Please Note:<br><p><i class=dot></i> <span>Lumpsum purchase is allowed only through bank accounts registered in your folio</span></p><p><i class=dot></i> <span>Payment through Net Banking is allowed only from banks which provide Third Party Verification(TPV) facility. <a ng-click=SummarySchedule.tpv() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</span></p><p><i class=dot></i> <span>The transaction shall be deemed to be received only when confirmed on the Scheduled date and payment is initiated before the cut-off timing as applicable. Further, applicability of NAV shall be as per SEBI guidelines.</span></p><p><i class=dot></i><span>IFSC update may take time to reflect in your bank details</span></p><p><i class=dot></i><span> Your transaction shall be validated at RTA, whereby, if your name in bank account used for payment and name in folio does not match and RTA is unable to verify due to lack of proof submission, allotment of units will be delayed/withheld/transaction will be considered as NIGO. Units allotted if any, will be refunded in case if AMC / RTA could not verify the source of funds proof for the said transaction, as mandated by SEBI vide its circular no. SEBI/HO/IMD/IMD-I DOF5/P/CIR/2021/634 dated 04-Oct-2021.</span></p></div><div ng-if=SummarySchedule.oneClickHDFCFLow><ng-bind-html dynamic=SummarySchedule.NOTESECTIONDATA.noteDTO.noteDTOMap.Note_SP_NB.content></ng-bind-html></div><div class=row><div style=\"border: none\" class=col-md-4><div class=\"selectfield marginBottom\" ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><select name=bank ng-disabled=!SummarySchedule.bankList ng-model=SummarySchedule.bankInfo ng-options=\"bank.bankName for bank in SummarySchedule.bankList\" ng-init=\"SummarySchedule.bankInfo=SummarySchedule.bankInfo?SummarySchedule.bankInfo: null\" ng-change=SummarySchedule.changeBank() required><option value=\"\" selected>{{SummarySchedule.bankList&&!SummarySchedule.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=SummarySchedule.bankInfo>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=SummarySchedule.VALIDATE_DATA.BANK_REQUIRED></span></div></div><div style=\"border: none; margin-top : 2px\" ng-if=SummarySchedule.showIFSCField class=col-md-4><div class=input-normal ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=SummarySchedule.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=SummarySchedule.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=SummarySchedule.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div style=\"border: none\" ng-if=SummarySchedule.showAccountTypeField class=col-md-4><div class=selectfield ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!SummarySchedule.accountTypeList ng-model=SummarySchedule.accountType ng-options=\"account.accountType for account in SummarySchedule.accountTypeList\" ng-init=\"SummarySchedule.accountTypeList = SummarySchedule.accountTypeList ? SummarySchedule.accountTypeList : null\" ng-change=SummarySchedule.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=SummarySchedule.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=\"tForm.accountType.$dirty && tForm.accountType.$error.required\" ng-bind=SummarySchedule.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div></div><p class=\"text-red error-msg-tpv\" ng-if=\"SummarySchedule.bankInfo.tpvEnableFlag==\'N\'\">Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br>Please select other payment mode or add a TPV enabled bank in your folio. <a ng-click=SummarySchedule.tpv() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</p><div class=text-red ng-if=!SummarySchedule.bankList||!SummarySchedule.bankList.length><span>In case your registered bank is not displayed, please choose other payment mode or add another bank.</span></div></div><div class=row ng-switch-when=OTM><div class=initiate-transaction style=\"padding-top: 0px\"><div class=\"imp-info col-md-12\" ng-if=!SummarySchedule.oneClickHDFCFLow><strong>Please note :</strong><p><i class=dot></i> <span>The transaction shall be deemed to be received only when confirmed on the Scheduled date and payment is initiated before the cut-off timing as applicable. Further, applicability of NAV shall be as per SEBI guidelines.</span></p><p><i class=dot></i><span>IFSC update may take time to reflect in your bank details</span></p><p><i class=dot></i><span> Your transaction shall be validated at RTA, whereby, if your name in bank account used for payment and name in folio does not match and RTA is unable to verify due to lack of proof submission, allotment of units will be delayed/withheld/transaction will be considered as NIGO. Units allotted if any, will be refunded in case if AMC / RTA could not verify the source of funds proof for the said transaction, as mandated by SEBI vide its circular no. SEBI/HO/IMD/IMD-I DOF5/P/CIR/2021/634 dated 04-Oct-2021.</span></p></div><div ng-if=SummarySchedule.oneClickHDFCFLow><ng-bind-html dynamic=SummarySchedule.NOTESECTIONDATA.noteDTO.noteDTOMap.Note_SP_OTM.content></ng-bind-html></div></div><div style=\"border: none\" class=col-md-4><div class=selectfield ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><select name=bank ng-disabled=!SummarySchedule.bankList ng-model=SummarySchedule.bankInfo ng-options=\"bank as (bank.bankName+\' - \'+bank.bankAcNo) for bank in SummarySchedule.bankList\" ng-init=\"SummarySchedule.bankInfo=SummarySchedule.bankInfo?SummarySchedule.bankInfo: null\" ng-change=SummarySchedule.changeBank() required><option value=\"\" selected>{{SummarySchedule.bankList&&!SummarySchedule.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=SummarySchedule.bankInfo>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=SummarySchedule.VALIDATE_DATA.BANK_REQUIRED></span></div></div><div style=\"border: none; margin-top : 2px\" ng-if=SummarySchedule.showIFSCField class=col-md-4><div class=input-normal ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=SummarySchedule.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=SummarySchedule.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=SummarySchedule.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div style=\"border: none\" ng-if=SummarySchedule.showAccountTypeField class=col-md-4><div class=selectfield ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!SummarySchedule.accountTypeList ng-model=SummarySchedule.accountType ng-options=\"account.accountType for account in SummarySchedule.accountTypeList\" ng-init=\"SummarySchedule.accountTypeList = SummarySchedule.accountTypeList ? SummarySchedule.accountTypeList : null\" ng-change=SummarySchedule.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=SummarySchedule.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=tForm.accountType.$dirty&&tForm.accountType.$error.required ng-bind=SummarySchedule.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div><div class=row><div class=col-md-11><table class=\"table borderless\" ng-if=\"SummarySchedule.bankInfo && SummarySchedule.bankList.length\"><tr><td>Account No:</td><td>{{SummarySchedule.bankInfo.bankAcNo}}</td></tr><tr><td>OTM UMRN No:</td><td>{{SummarySchedule.bankInfo.omUmrn}}</td></tr><tr><td>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{SummarySchedule.bankInfo.maxAmount}} <span class=error-input ng-show=SummarySchedule.isOTMAmount ng-bind=SummarySchedule.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_PURCHASE_ERROR></span></td></tr><tr><td>OTM Expiry Date:</td><td>{{SummarySchedule.bankInfo.omExpiryDate}} <span class=error-input ng-show=SummarySchedule.isOTMDate ng-bind=SummarySchedule.VALIDATE_DATA.DATE_VALIDATION_ERROR></span></td></tr></table></div></div></div><div class=row ng-switch-when=UPI><div class=initiate-transaction style=\"padding-top: 0px\"><div class=\"imp-info col-md-12\"><strong>Please note :</strong><p><i class=dot></i> <span>Unified Payments Interface (UPI) is an instant payment system developed by the National Payments Corporation of India (NPCI), an RBI regulated entity.</span></p><p><i class=dot></i> <span>At present, the transaction limit as per NPCI is Rs. 100000 per transaction per day; however this limit may vary from bank to bank.</span></p><p><i class=dot></i> <span>BHIM application of NPCI allows a maximum of Rs 20000 per transaction and a maximum of Rs 40000 per day per linked bank account.</span></p><p><i class=dot></i> <span>Once you click ‘Continue to Pay’ on our website, you would get a notification on your UPI app and have to authorize the payment from selected bank account to complete the transaction.</span></p><p><i class=dot></i> <span>The transaction shall be deemed to be received only when confirmed on the Scheduled date and payment is initiated before the cut-off timing as applicable. Further, applicability of NAV shall be as per SEBI guidelines.</span></p><p id=tpv_note_ifsc><i class=dot></i><span>IFSC update may take time to reflect in your bank details</span></p><p id=tpv_note_message><i class=dot></i><span> Your transaction shall be validated at RTA, whereby, if your name in bank account used for payment and name in folio does not match and RTA is unable to verify due to lack of proof submission, allotment of units will be delayed/withheld/transaction will be considered as NIGO. Units allotted if any, will be refunded in case if AMC / RTA could not verify the source of funds proof for the said transaction, as mandated by SEBI vide its circular no. SEBI/HO/IMD/IMD-I DOF5/P/CIR/2021/634 dated 04-Oct-2021.</span></p></div></div><div style=\"border: none\" class=col-md-4><div class=selectfield ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><select name=bank ng-disabled=!SummarySchedule.bankList ng-model=SummarySchedule.bankInfo ng-options=\"bank as bank.bankName for bank in SummarySchedule.bankList\" ng-init=\"SummarySchedule.bankInfo=SummarySchedule.bankInfo?SummarySchedule.bankInfo: null\" ng-change=SummarySchedule.selectedUpiBank() required><option value=\"\" selected>{{SummarySchedule.bankList&&!SummarySchedule.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=SummarySchedule.bankInfo>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=SummarySchedule.VALIDATE_DATA.BANK_REQUIRED></span></div></div><div ng-if=SummarySchedule.showIFSCField style=\"border: none; margin-top : 2px\" class=col-md-4><div class=input-normal ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\"><input type=text maxlength=11 minlength=11 ng-model=SummarySchedule.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=/^[a-zA-Z]{4}[0][a-zA-Z0-9]{6}$/ capitalize=\"\"><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=SummarySchedule.VALIDATE_DATA.IFSC_CODE_FIELD aria-hidden=true>Please enter valid IFSC code.</span> <span class=\"error-input ng-binding ng-hide\" ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=SummarySchedule.VALIDATE_DATA.IFSC_CODE_REGEX aria-hidden=true>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><div ng-if=SummarySchedule.showAccountTypeField style=\"border: none\" class=col-md-4><div class=selectfield ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select name=accountType ng-disabled=!SummarySchedule.accountTypeList ng-model=SummarySchedule.accountType ng-options=\"account.accountType for account in SummarySchedule.accountTypeList\" ng-init=\"SummarySchedule.accountTypeList = SummarySchedule.accountTypeList ? SummarySchedule.accountTypeList : null\" ng-change=SummarySchedule.changeAccountype() required><option value=\"\" selected>Account Type</option></select><label ng-if=SummarySchedule.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-show=\"tForm.accountType.$dirty && tForm.accountType.$error.required\" ng-bind=SummarySchedule.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div><div ng-class=\"{\'col-md-12\' : SummarySchedule.showAccountTypeField || SummarySchedule.showIFSCField }\" ng-if=SummarySchedule.bankInfo><div class=row><div class=\"col-md-4 vpa-input\" style=\"border: none\"><div class=input-normal ng-class={error:tForm.virtualAddress.$invalid&&tForm.virtualAddress.$dirty}><input type=text ng-model=SummarySchedule.formData.paymentInfo.virtualAddress name=virtualAddress ng-pattern=SummarySchedule.PATTERN.upi_virtual_addr_regex ng-change=\"SummarySchedule.verifyUPIResp={}\" required ng-readonly=\"SummarySchedule.isUPIVerified && SummarySchedule.verifyUPIResp.valid === true\"><div class=bar></div><div class=highlight></div><label style=\"display: block;width: 100%\">Virtual Payment Address (UPI ID) <span class=req>*</span> <i class=edit-icon style=\"position: absolute;right: 0px; top:16px; pointer-events: all; box-sizing: content-box\" ng-if=\"SummarySchedule.isUPIVerified && SummarySchedule.verifyUPIResp.valid === true\" ng-click=\"SummarySchedule.isUPIVerified = false\"></i></label><span class=error-input ng-show=tForm.virtualAddress.$dirty&&(tForm.virtualAddress.$error.required||tForm.virtualAddress.$error.pattern) ng-bind=SummarySchedule.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!tForm.virtualAddress.$invalid\n                                                          &&  (!SummarySchedule.isUPIVerified && SummarySchedule.verifyUPIResp.valid === false)\" ng-bind=SummarySchedule.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span></div></div><div class=col-md-2><button blur-on-click ng-if=\"SummarySchedule.transactionType === \'PURCHASE\' && SummarySchedule.formData.purchasePaymentOption==\'UPI\' && !SummarySchedule.isUPIVerified\" class=\"btn btn-primary-action pull-right\" ng-disabled=!SummarySchedule.formData.paymentInfo.virtualAddress ng-click=SummarySchedule.verifyUPI()>Verify</button></div><div class=\"col-md-2 verify-vpa\" ng-if=\"SummarySchedule.isUPIVerified && SummarySchedule.verifyUPIResp.valid === true\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{SummarySchedule.name}}</span></div><div class=\"col-md-2 verify-vpa verify-ack-padding verify-ack-col\" ng-if=\"!SummarySchedule.isUPIVerified && SummarySchedule.verifyUPIResp.valid === false\"><p><strong><span class=error-input style=\"display:inline;font-size:100%;margin-bottom: 20px\">Not Verified</span> <i class=\"cancel-icon error-input\"></i></strong></p></div></div></div></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block; font-weight:bold\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label></div><div class=tc-block><h6>Terms & Conditions</h6><div><div class=checkbox><input id=isCheckedTandC ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=SummarySchedule.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div></div></div><div class=content-foot><input type=hidden id=hfReq><div style=text-align:right><button class=\"btn btn-primary-action\" ng-hide=SummarySchedule.hideCancel ng-click=SummarySchedule.confirmCancelModaltoReject()>Cancel</button> <button blur-on-click ng-if=\"SummarySchedule.transactionType === \'PURCHASE\' && SummarySchedule.formData.purchasePaymentOption ===\'NETBANKING\'\" class=\"btn btn-primary-action pull-right\" ng-disabled=\"!SummarySchedule.scheduleTransactionDetails.amount ||  !isCheckedTandC || (tForm.$invalid || SummarySchedule.isInvalidForm) || (!SummarySchedule.bankInfo.minorBankFlag && SummarySchedule.checkForMinorBankListCondition()) || SummarySchedule.bankInfo.tpvEnableFlag==\'N\'\" ng-click=SummarySchedule.submitForm()>Continue to Pay</button> <button blur-on-click ng-if=\"SummarySchedule.transactionType === \'PURCHASE\' && SummarySchedule.formData.purchasePaymentOption ===\'OTM\'\" class=\"btn btn-primary-action pull-right\" ng-disabled=\"!SummarySchedule.scheduleTransactionDetails.amount || !isCheckedTandC || (tForm.$invalid || SummarySchedule.isInvalidForm) || (!SummarySchedule.bankInfo.minorBankFlag && SummarySchedule.checkForMinorBankListCondition())\" ng-click=SummarySchedule.submitForm()>Continue to Pay</button> <button blur-on-click ng-if=\"SummarySchedule.transactionType === \'PURCHASE\' && SummarySchedule.formData.purchasePaymentOption==\'UPI\'\" class=\"btn btn-primary-action pull-right\" ng-disabled=\"!isCheckedTandC || (tForm.$invalid || !SummarySchedule.isUPIVerified)\" ng-click=SummarySchedule.submitForm()>Continue to Pay</button></div></div></form></section></div></div><div ng-if=\"SummarySchedule.transactionType !== \'PURCHASE\'\"><label style=\"padding: 25px 0px 0px 20px; display: block; font-weight:bold\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label><label style=\"padding: 15px 0px 0px 20px; display: block; font-weight:bold\" ng-if=\"SummarySchedule.transactionType === \'REDEMPTION\' \">Exit Load would be applicable as per SEBI Circular \"SEBI/HO/IMD/DF2/CIR/P/2019/101\" dated September 20, 2019. <a class=note-link href=https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf target=_blank>Click here</a> to know more</label></div><div class=tc-block ng-if=\"SummarySchedule.transactionType !== \'PURCHASE\'\"><h6>Terms & Conditions</h6><div><div class=checkbox><input id=isCheckedTandC ng-model=SummarySchedule.isCheckedTandC type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=SummarySchedule.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div></div></div><div class=content-foot ng-if=\"SummarySchedule.transactionType !== \'PURCHASE\'\"><input type=hidden id=hfReq><div style=text-align:right><button class=\"btn btn-primary-action\" ng-click=SummarySchedule.confirmCancelModaltoReject()>Cancel</button> <button blur-on-click ng-disabled=!SummarySchedule.isCheckedTandC ng-if=\"SummarySchedule.transactionType !== \'PURCHASE\'\" ng-click=SummarySchedule.submitSchedule($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div><style>.checkbox label{padding-left: 0}</style></section><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{SummarySchedule.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=SummarySchedule.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=SummarySchedule.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=SummarySchedule.billdeskPayload.msg></form><!-- Payment form commented: --><!-- with new implementation we are not using it, directly appending data from backend on billdesk url. --><!--\n            <form autocomplete=\"off\" name=\'billdeskPayFormDebitOnly\' id=\"billdeskPayFormDebitOnly\" method=\'POST\'\n                  action=\'https://www.billdesk.com/pgidsk/PGICommonGateway\'>\n              <input type=\"hidden\" name=\"msg\" ng-value=\"SummarySchedule.billDeskpayload\" id=\"msg\"/>\n              <input id=\"hidRequestId\" type=\'hidden\' name=\'hidRequestId\' value=\"PGIME1000\"/>\n              <input id=\"hidOperation\" type=\'hidden\' name=\'hidOperation\' value=\"ME100\"/>\n            </form> --></div></div></div>");
$templateCache.put("app/transactions/summary/summary.schedule.transaction.html","<div class=clearfix><div class=email-view ng-if=SummarySchedule.isLoaded><div data-ng-switch=SummarySchedule.transactionType><div data-ng-include=\"\'app/transactions/summary/summary.schedule-payment-audit.html\'\"></div></div></div></div>");
$templateCache.put("app/transactions/view/transaction-view.html","<div class=\"main-section clearfix transaction-view\"><h5 class=screen-title ng-bind=TransactionViewParentCtrl.schemeName>HDFC Artbitrage Fund Summary</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.portfolio.list>Portfolio </span><i class=breadcrumb-icon></i><span> Scheme Overview</span></p><div class=\"col-md-12 view-box\"><ul class=\"nav nav-tabs\"><li ui-sref-active=active><a ui-sref=main.transactions-view.details>Details</a></li><li ui-sref-active=active><a ui-sref=main.transactions-view.transactions>Systematic Registration</a></li></ul><div ui-view></div></div></div>");
$templateCache.put("app/unlock/unlockFolioId/unlockFolioId.html","<!-- <login-header class=\"update-contact-header-none\"></login-header> --><!-- <div class=\"unlock-mobile-header\">\n  <div class=\"back-to-login-header\"><a href=\"/\" style=\"color:#5290DB\" ng-click=\"UnlockFolioId.handleSideBarClick(\'EXISTING_USER\')\" class=\"contrastDarkFont\">\n    <img src=\"assets/images/back-arrow-icon.svg\" class=\"arrowBackIcon resp-head-icon loginBckImg\"/> Back to login</a>\n  </div>\n</div> --><div class=\"row row-no-gutters\"><!-- <div class=\"side-nav-container col-md-3\">\n    <div class=\"row height100\" style=\"display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;\">\n      <div class=\"col-md-12 height100\">\n        <div class=\"side-nav-wrap\">\n          <hdfc-login-sidebar sidebar-click=\"UnlockFolioId.handleSideBarClick(message)\"></hdfc-login-sidebar>\n        </div>\n      </div>\n    </div>\n  </div> --><div class=\"col-sm-12 col-xs-12 widthContainer\"><br><login-header></login-header><br><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=forms-container><div class=\"row row-no-gutters\"><div class=\"col-md-12 form-existing-wrap res-form-exis col-xs-12\"><div class=\"loader availability-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=forgot-password-forms><div class=login-header><!-- <div class=\"header-action header-action-resp\">\n                <a href=\"javascript:void(0)\" ui-sref=\"login\" ng-click=\"UnlockFolioId.handleSideBarClick(\'EXISTING_USER\')\">\n                  <img src=\"assets/images/back-button.svg\" class=\"loginBckImg\">\n                  Back to Login\n                </a>\n              </div> --><div style=\"padding-bottom: 0px\"><div style=\"display: flex;align-items: center\"><a href=javascript:void(0) ui-sref=login ng-click=\"UnlockFolioId.handleSideBarClick(\'EXISTING_USER\')\"><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=\"hide-lg nonconstrastImgarrow\"> <img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=\"hide-lg constrastImgarrow\"></a><h3 style=\"padding-bottom: 0px\">Unlock {{UnlockFolioId.type.toLowerCase() == \'userid\'? \'User ID\' : UnlockFolioId.type }}</h3></div><br><div ng-if=\"UnlockFolioId.showOTPForm === true\"><br>OTP has been sent to your registered {{UnlockFolioId.selectedField == \'email\'?\'Email ID\':\'Mobile Number\'}}.</div></div></div><div><form class=\"login-form userId\" autocomplete=off name=unlockFolioIdForm ng-submit=UnlockFolioId.submit() ng-if=\"UnlockFolioId.showOTPForm === false\"><div class=\"input-normal userID-input-container\" ng-if=\"UnlockFolioId.type === \'folio\'\"><input type=text ng-model=UnlockFolioId.payload.folioNumber class=folio-num-input placeholder=\"Enter Folio Number\" autofocus required style=\"border-radius: 100px;height: 48px\"><label>Folio Number</label></div><div class=\"input-normal userID-input-container\" ng-if=\"UnlockFolioId.type === \'UserId\'\"><input type=text ng-model=UnlockFolioId.payload.userId placeholder=\"Enter User ID\" ng-keyup=UnlockFolioId.checkText() autofocus required style=\"border-radius: 100px;height: 48px\"><label>User ID</label></div><span class=mod-error-msg ng-if=UnlockFolioId.invalidUserId ng-bind=UnlockFolioId.validateData.INVALID_USER_ID_ERROR></span><p class=\"provide-details provide-resp\">Enter your registered Email ID or Mobile No to get OTP:</p><div class=\"login-form-switch switch-styling\"><span class=toggle-lable style=\"padding-right: 2%\">Email ID</span><label class=switch><input type=checkbox ng-model=UnlockFolioId.toggleunlock ng-change=UnlockFolioId.changeFields() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label><span class=toggle-lable style=\"padding-left: 2%\">Mobile No</span></div><div class=\"input-normal pan-input-container\" ng-if=!UnlockFolioId.toggleunlock ng-class=\"{error:unlockFolioIdForm.email.$dirty && unlockFolioIdForm.email.$invalid}\"><input type=email no-focus name=email ng-pattern=UnlockFolioId.pattern.email_regex ng-model=UnlockFolioId.payload.email ng-disabled=\"UnlockFolioId.selectedField !== \'email\'\" maxlength=150 placeholder=abc@domain.com ng-required=\"UnlockFolioId.selectedField === \'email\'\" style=\"height: 48px;border-radius: 100px\"><label>Email ID</label><span ng-show=\"unlockFolioIdForm.email.$dirty && unlockFolioIdForm.email.$invalid && unlockFolioIdForm.email.$touched\"><span style=\"display: block\" class=mod-error-msg ng-show=unlockFolioIdForm.email.$error.required ng-bind=UnlockFolioId.validateData.KYC_VERIFIED_EMAIL></span> <span style=\"display: block\" class=mod-error-msg ng-show=unlockFolioIdForm.email.$error.pattern class=help-block ng-bind=UnlockFolioId.validateData.EMAIL_FIELD></span></span></div><div class=\"input-normal pan-input-container\" ng-if=UnlockFolioId.toggleunlock ng-class=\"{error:unlockFolioIdForm.phone.$dirty && unlockFolioIdForm.phone.$invalid}\"><input type=tel no-focus name=phone ng-pattern=UnlockFolioId.pattern.mobile_regex maxlength=13 ng-model=UnlockFolioId.payload.mobileNumber placeholder=\"e.g. +919876543210\" ng-required=\"UnlockFolioId.selectedField === \'mobile\'\" style=\"border-radius: 100px;height: 48px\"><label>Mobile No.</label><span ng-show=\"unlockFolioIdForm.phone.$dirty && unlockFolioIdForm.phone.$invalid\"><span style=\"display: block\" class=mod-error-msg ng-show=unlockFolioIdForm.phone.$error.pattern class=help-block ng-bind=UnlockFolioId.validateData.MOBILE_ISD></span></span></div><div class=\"btnContainer loginpwdBtn otp-button-placing\"><input id=submitUserId ng-disabled=\"unlockFolioIdForm.$invalid || UnlockFolioId.processFlag || UnlockFolioId.invalidUserId\" type=submit class=\"loginBtn btn btn-bloc loginBtnNewTheme\" value=\"GET OTP\"></div></form><form name=ForgotFolioOTPForm ng-if=\"UnlockFolioId.showOTPForm === true\"><div class=\"input-normal otp-input-container otp-unlock-id\"><input type=text ng-model=UnlockFolioId.otp maxlength=6 autofocus required style=\"border-radius: 100px;height: 48px\"><label>Enter OTP</label><div class=input-controls><span><timer countdown=UnlockFolioId.pattern.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span><div><span class=inputTxt><a href=\"\" class=\"text-blue resend\" ng-click=UnlockFolioId.resendOTP() ng-class={anchorDisable:UnlockFolioId.processFlagOtp} ng-show=\"countdown ==0\">Resend OTP</a></span></div></timer></span></div></div><div class=\"btnContainer loginpwdBtn otp-button-placing\"><input ng-disabled=\"!UnlockFolioId.otp || UnlockFolioId.processFlag\" value=Verify type=submit ng-click=UnlockFolioId.verifyOTP() class=\"loginBtn btn btn-bloc loginBtnNewTheme loginBtnTheme\"> <span class=inputTxt><a href=\"\" ng-click=UnlockFolioId.confirmCancel() tabindex=0 class=cursor-pointer>Cancel</a></span></div></form></div></div></div></div></div></div><div class=\"widthContainer new-carosal-web\"><slide-image></slide-image></div></div><style>.login-form form {\n    padding-top: 40px;\n  }\n\n  .cancel-btn {\n    padding-bottom: 46px;\n  }\n  .loginBtn{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border-radius: 100px !important;\n  }\n  .forgot-password-forms{\n    padding: 1% 10% 20px 10% !important;\n  }\n  .forms-container{\n    margin-top: 0% !important;\n  }\n  .form-existing-wrap{ \n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n    border-radius: 16px;\n  }\n  .contrastClass .form-existing-wrap{ \n    background: black;\n  }\n  .login-header{\n    padding-bottom: 0px !important;\n  }\n  @media only screen and (max-width: 767px) {\n    .login-header{\n      padding-top: 10px !important;\n    }\n    .inputTxt {\n      margin-top: 14px !important;\n    }\n  }\n   @media screen and (max-width: 1024px) {\n    .login-header{\n      padding-top: 10px !important;\n    }\n    .forms-container{\n      margin-top: -30% !important;\n      width: 90%;\n      margin: auto;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n    }\n  }\n  @media screen and (min-width:767px) and (max-width: 991px) {\n    .forms-container .forgot-password-forms{\n      padding: 4%;\n    }\n  }\n  .contrastClass .forms-container{\n   background: transparent !important;\n  }</style><!-- <footer-login></footer-login> -->");
$templateCache.put("app/whatsapp-payment/acknowledgement/paymentacknowledgement.html","<!-- header section start --><div class=headerDiv><div class=subHeaderDiv1><img ng-click=WhatsAppPaymentAck.openWLink() class=displayForMobile style=\"flex-shrink: 0; width: 3vh\" src=../../../assets/images/icons/white-back-arrow.svg><div style=\"margin-left: auto;     text-align: center;margin-right: auto; height: 6vh\"><img src=../../../assets/images/logo.jpg style=\"height: 5vh\"><p class=ptext style=\"color: white;padding-top: 5vh; font-size: 4vh; margin: 2px\">Acknowledgement</p></div></div></div><div style=\"position: relative;\n    padding-bottom: 50px\"><!-- <div class=\"centerDiv\" style=\"border-bottom: solid 4px #009E36;\">\n    <h2 style=\"margin:0 auto;    margin-bottom: 14px;\">Acknowledgement</h2> \n</div> --><div ng-class=\"WhatsAppPaymentAck.Data && WhatsAppPaymentAck.Data.status ? \'ackBackgroundImage\' : \'ackNoBackgroundImage\' \"><div style=\"text-align: center\"><br><img ng-if=WhatsAppPaymentAck.Data.status style=\"height: 18vh\" src=../../../assets/images/correctIcon.svg alt=\"\"> <img ng-if=\"!WhatsAppPaymentAck.Data || !WhatsAppPaymentAck.Data.status\" style=\"height: 18vh\" src=../../../assets/images/FailedTransaction.svg alt=\"\"><br></div></div><div class=centerDiv><div style=\"text-align: center;margin-top:14px\"><h2 style=\"margin-top: 8px;line-height: normal;    font-size: 3vh\">Transaction <span ng-if=WhatsAppPaymentAck.Data.status>Successful</span><span ng-if=\"!WhatsAppPaymentAck.Data || !WhatsAppPaymentAck.Data.status\">Failed</span></h2><p class=p1text class=subHeading style=\"margin-top: 10px\" ng-if=WhatsAppPaymentAck.Data.status>Thank you for investing with us.</p><div class=subDivStyle><!-- SRN No: {{WhatsAppPaymentAck.Data.srnNo}}<br>  --> {{WhatsAppPaymentAck.Data.schemeName}}<br>₹ {{WhatsAppPaymentAck.Data.amount}}</div><p class=p1text style=\"margin-top: 20px;padding-bottom:60px\">Kindly check WhatsApp to view detailed acknowledgement</p></div></div><div class=footerDiv><img src=../../../assets/images/hdfcmf-Main.png alt=\"\" style=\"height: 20px\"><p class=footerSubHeading>Managed by HDFC MF Limited.<a href={{WhatsAppPaymentAck.CORPORATE_URL}} target=_blank style=\"color: blue;font-weight: 500\">Learn More</a>.</p></div></div><style>.footerSubHeading{\n        margin-left: 6px; \n    }\n    .footerDiv{\n        position: fixed;\n        bottom: 0px;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;  \n        padding-right: 6px;\n        padding-bottom: 10px;\n        background-color: white;\n    }\n    h2{\n        font-size: 4vh;\n    } \n    .ackBackgroundImage{\n        background-image: url(../../../assets/images/ackBg.svg);\n        display: flow;\n        align-items: end;\n        justify-content: center;\n        height: 22vh;\n        background-repeat: repeat;\n    }\n    .ackNoBackgroundImage{\n        background-color: white;\n        display: flow;\n        align-items: end;\n        justify-content: center;\n        height: 22vh;\n        background-repeat: repeat;\n    }\n    .centerDiv{\n        display: flex;\n        align-items: center;\n        justify-content: center; \n    }\n    .subHeading{\n        font-family: Inter;\n        font-size: 3vh;\n        font-weight: 400;\n        line-height: 24px;\n    }\n    .p1text{\n        font-size: 2.5vh;\n        line-height: normal;\n    }\n    .div{\n        line-height: normal;\n    }\n    .subDivStyle{\n        margin: 12px;\n        padding: 22px;\n        background: linear-gradient(110.94deg, #F0F6FF 0%, #FFE6E6 213.86%);\n        font-family: Proxima Nova;\n        font-size: 3vh;\n        font-weight: 600;\n        line-height: 4vh;\n    }\n    @media (max-width: 362px) { \n        .footerSubHeading{\n            white-space: nowrap !important; \n            font-size: 4vw !important; \n        }\n        .footerDiv{\n            left:2px !important;\n        }\n    }\n    .headerDiv{ \n    height: 23vh;min-height: 110px; \n    background: linear-gradient(334.14deg, #124480 16.32%, #02245F 83.68%); \n  }\n  .subHeaderDiv1{\n    display: flex;  \n    justify-content: flex-start;  \n    align-items: flex-start;  \n    width: 100%;  \n    padding: 12px;\n    padding-top: 4vh;  \n  }\n  .subHeaderDiv2{\n    display: flex; justify-content: center; \n    width: 100%;  text-align: center;   padding: 2vh;   \n    padding-bottom: 4vh; padding-top: 4vh;     \n  }\n  .subHeaderDiv3{\n    display: flex;  \n    justify-content: center;  \n    align-items: center;  \n    width: 100%;  \n  }\n  .content-area{\n    padding: 0px;\n  }\n    .displayForMobile{\n      display: none;\n    }\n    @media (max-width: 768px) {\n      .displayForMobile{\n        display: block !important;\n      }\n    }</style>");
$templateCache.put("app/whatsapp-payment/landing-token/whatsapp-landing-token.html","<div class=ecart-journey ng-if=!WhatsappApiGateWay.linkHasbeenExpired><hdfc-header-pre-login show-logout-btn=WhatsappApiGateWay.showLogoutBtn></hdfc-header-pre-login><section class=main-section-ecart-review ng-if=!WhatsappApiGateWay.isLoading><div class=modal-content id=loginLoader tabindex=-1><div class=\"modal-body main-loader\"><p class=blacktintLoad></p><div class=\"loader-box-content text-center\"><p><img src=../assets/images/logo-main.png alt=HDFC></p><p><img src=../assets/images/logo.png alt=\"Partner\'s Logo\"></p><h3 class=text-primary>Welcome {{WhatsappApiGateWay.investorName || \'Investor\' | camelcase}}</h3><p>Please wait while we fetch your details.</p><img src=../assets/images/loader_web.gif alt=loader class=loader-gif><br><timer interval=1000>{{minutes}}:{{seconds}}</timer></div></div></div></section><section class=main-section-ecart-review ng-if=WhatsappApiGateWay.isLoading><div><div class=content-area><div ui-view></div></div></div></section><!--  <div ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div>--><footer-login></footer-login></div><div style=\"position: relative; padding-bottom: 50px\" ng-if=WhatsappApiGateWay.linkHasbeenExpired><!-- header section start --><div class=headerDiv><div class=subHeaderDiv1><img ng-click=WhatsappApiGateWay.openWLink() class=displayForMobile style=\"flex-shrink: 0; width: 3vh\" src=../../../assets/images/icons/white-back-arrow.svg><div style=\"margin-left: auto;     text-align: center;margin-right: auto; height: 6vh\"><img src=../../../assets/images/logo.jpg style=\"height: 5vh\"><p class=ptext style=\"color: white;padding-top: 5vh; font-size: 4vh; margin: 2px\">Expired</p></div></div></div><!-- link expired  --><div><div class=\"centerDiv mT20\"><div style=\"text-align: center\"><img src=../../../assets/images/FailedTransaction.svg alt=\"\" style=\"margin-top: 10%\"><br><p class=\"ptext cblack\" style=\"text-align: center;  font-size: 4vh; margin: 10px;  font-weight: 700;color: black\">Transaction link has expired</p></div></div><div class=footerDiv><div class=footerSubDiv><img src=../../../assets/images/hdfcmf-Main.png alt=\"\" style=\"height: 20px\"><p class=footerSubHeading>Managed by HDFC MF Limited.<a href={{WhatsappApiGateWay.CORPORATE_URL}} target=_blank style=\"color: blue;font-weight: 500\">Learn More</a>.</p></div></div></div></div><style>h2{\n        font-size: 3vh;\n    }  \n  .mT20{\n     margin-top: 20px;\n     line-height: initial;\n  }\n  .footerDiv{\n     position: fixed;\n     bottom: 0px;\n     width: 100%; \n     background-color: white;\n  }\n  .footerSubDiv{\n     display: flex;justify-content: center;align-items: center;margin-top: 15px;\n  }\n  .footerSubHeading{\n    margin-left: 6px; \n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    text-align: left;\n  }\n  .centerDiv{\n      display: flex;\n      align-items: center;\n      justify-content: center; \n  }\n  @media (max-width: 500px) { \n    .ptest2{\n      margin: 7%;\n    }\n  } \n  @media (max-width: 362px) { \n        .footerSubHeading{\n        white-space: nowrap !important; \n        font-size: 4vw !important; \n        }\n        .footerDiv{\n        left:2px !important;\n        }\n    }\n    .headerDiv{ \n    height: 25vh;min-height: 110px; \n    background: linear-gradient(334.14deg, #124480 16.32%, #02245F 83.68%); \n    }\n    .subHeaderDiv1{\n      display: flex;  \n      justify-content: flex-start;  \n      align-items: flex-start;  \n      width: 100%;  \n      padding: 12px;\n      padding-top: 4vh;  \n    }\n    .subHeaderDiv2{\n      display: flex; justify-content: center; \n      width: 100%;  text-align: center;   padding: 2vh;   \n      padding-bottom: 4vh; padding-top: 4vh;     \n    }\n    .subHeaderDiv3{\n      display: flex;  \n      justify-content: center;  \n      align-items: center;  \n      width: 100%;  \n    } \n    .ptest2{ \n      font-size: 2.5vh; \n      margin-top: 12px; \n    } \n    .displayForMobile{\n      display: none;\n      }\n      @media (max-width: 768px) {\n      .displayForMobile{\n      display: block !important;\n      }\n    }</style>");
$templateCache.put("app/whatsapp-payment/payment/whatsappPayment.html","<section ng-if=\"Payment.linkID && !Payment.formData.sipFirstInstallment && !Payment.isTransactionDone && !Payment.linkHasbeenExpired\" class=section-pd-bottom><!-- header section start --><div class=headerDiv><div class=subHeaderDiv1><img ng-click=Payment.openWLink() class=displayForMobile style=\"flex-shrink: 0; width: 3vh\" src=../../../assets/images/icons/white-back-arrow.svg> <img style=\"margin-left: auto; margin-right: auto; height: 6vh\" src=../../../assets/images/logo.jpg></div><div class=\"subHeaderDiv2 col-md-12\"><p class=ptext style=\"color: white; font-size: 2.5vh; margin: 2px\">Choose Your Payment Option</p></div><div class=subHeaderDiv3><p class=\"ptext amountText\">₹<span ng-if=\"Payment.formData.investmentType === \'SIP\'\"> {{Payment.formData.amount}} </span><span ng-if=\"Payment.formData.investmentType !== \'SIP\'\">{{Payment.formData.purchaseAmount}}</span></p></div></div><!-- header section end --><!-- UPI Start --><section class=\"main-section-whatsup clearfix payment-screen\" style=\"padding: 0px\"><section class=content-area style=\"width: 413px;margin: 10px 0px 5px 0px;    padding: 0px;border-radius: 11px;box-shadow: 4px 5px 32px -12px\"><!-- desktop view form--><form class=desktop-gateway-view autocomplete=off novalidate name=tForm><div class=tab-body ng-switch=Payment.formData.selectedPaymentOption ng-init=Payment.getFormData(tForm)><div class=mainDiv><div style=\"display: flex;justify-content: space-between\"><div style=\"display: flex;justify-content: center;align-items: center\"><img src=../../../assets/images/upi_icon.svg alt=\"\"><div><p class=subHeadingStyle>UPI <span ng-if=\"Payment.formData.investmentType === \'SIP\'\">Autopay</span></p></div></div><img src=../../../assets/images/icons/black-down-arrow.svg ng-if=!Payment.UPITabExpanded ng-click=\"Payment.changeToggleIcon(\'collapseExampleUPI\')\" style=\"width: 25px\"></div></div><div ng-class=\"Payment.UPITabExpanded ? \'expandBlock\' : \'closeexpandBlock\' \"><div class=w100><p class=stright-line></p><p class=\"ptext cblack\" style=\"margin: 16px 0px 8px 0px\">Select Bank for UPI Payment</p></div><div class=\"upi w100\" style=\"width: 364px\"><!-- UPI Bank --><!--UPI BANK selection  START --><div class=custom-select data-list=1><div class=select-tab onclick=\"toggleList(event, \'list1Data\')\"><div style=\"display: flex\"><div class=select-text><p class=text1>{{Payment.UPIbankInfo.bankNameOnly}}</p><p class=text2>{{Payment.UPIbankInfo.maskedAccountNumber}}</p></div></div><div class=arrow><img src=../../../assets/images/down-arrow.svg alt=\"\" class=downArrow></div></div><div ng- class=select-list id=selectList1><div class=list-item ng-repeat=\"_option in Payment.UPIBankList\" ng-click=\"Payment.changeBank(_option,\'UPI\')\">{{_option.bankNameOnly}} - {{_option.maskedAccountNumber}}</div></div></div><!--UPI BANK selection  END --><div><div ng-if=\"Payment.formData.selectedPaymentOption == \'UPI\'\"><div ng-if=\"Payment.UPIbankInfo && !Payment.UPIbankInfo.ifscCode\"><div style=\"width: 100%;height: 20px\"></div><div class=input-normal ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required class=inputborder maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize placeholder=\"IFSC Code\"><div class=bar></div><div class=highlight></div><span class=error-input ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div ng-if=\"Payment.UPIbankInfo && !Payment.UPIbankInfo.bankAcType\"><div class=\"selectfield selectionIcon w100\" ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\" style=\"width: 364px;height: 60px\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-init=\"Payment.formData.paymentInfo.accType=Payment.formData.paymentInfo.accType?Payment.formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required style=\"border: 1px solid gray;border-radius: 10px\"><option value=\"\" selected>Account Type</option></select><span class=error-input ng-messages=tForm.accountType.$error ng-show=tForm.accountType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><!-- Extra fields end--></div><!-- UPI Input --><div ng-if=Payment.UPIbankInfo.bankName class=row><div class=\"input-normal col-md-12\" style=\"margin-bottom: 2px;text-align: left\"><input type=text class=inputborder ng-model=Payment.formData.paymentInfo.virtualAddress name=virtualAddress ng-readonly=Payment.isUPIVerified ng-change=Payment.getUPIId() ng-pattern=Payment.PATTERN.upi_virtual_addr_regex placeholder=\"Enter UPI ID of selected bank\"> <span class=error-input ng-show=\"tForm.virtualAddress.$dirty && (tForm.virtualAddress.$error.required||tForm.virtualAddress.$error.pattern)\" ng-bind=Payment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!tForm.virtualAddress.$invalid\n                                  &&  (!Payment.isUPIVerified && Payment.verifyUPIResp.valid === false)\" ng-bind=\"Payment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED+\'. Please try again.\'\"></span></div><div class=\"col-md-12 verifyButtonDiv\" ng-if=!Payment.isUPIVerified><button class=verifyButton style=\"margin-bottom: 12px\" ng-disabled=!Payment.formData.paymentInfo.virtualAddress ng-click=Payment.verifyUPI()>Verify</button></div><div class=\"col-md-12 verifyButtonDiv\" ng-if=\"Payment.isUPIVerified && Payment.verifyUPIResp.valid === true && !Payment.isDisableUpi\"><button class=verifyButton style=\"margin-bottom: 12px\" ng-click=\"Payment.isUPIVerified = false\">Edit</button></div></div><div class=\"col-md-12 verify-vpa verify-ack-padding\" style=\"margin-bottom: 12px\" ng-if=Payment.isUPIVerified><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{Payment.name}}</span></div></div><!-- <hr> --></div></div></form></section><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{Payment.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden class=inputborder name=hidRequestId ng-value=Payment.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden class=inputborder name=hidOperation ng-value=Payment.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg class=inputborder ng-value=Payment.billdeskPayload.msg></form></section><!-- UPI End --><!-- OTM Start --><section class=\"main-section-whatsup clearfix payment-screen\" style=\"padding: 0px\" ng-if=\"Payment.otmBankList && Payment.otmBankList.length > 0 \"><section class=content-area style=\"width: 413px;margin: 5px 0px 5px 0px;    padding: 0px;border-radius: 11px;box-shadow: 4px 5px 32px -12px\"><!-- desktop view form--><form class=desktop-gateway-view autocomplete=off novalidate name=tForm1><div class=tab-body ng-switch=Payment.formData.selectedPaymentOption ng-init=Payment.getFormData(tForm1)><div class=mainDiv><div style=\"display: flex;justify-content: space-between\"><div style=\"display: flex;justify-content: center;align-items: center\"><img src=../../../assets/images/mandate-icon.svg alt=\"\"><div><p class=subHeadingStyle>Existing Bank Mandate</p></div></div><img src=../../../assets/images/icons/black-down-arrow.svg ng-if=!Payment.OTMTabExpanded ng-click=\"Payment.changeToggleIcon(\'collapseExampleOTM\')\" style=\"width: 25px\"></div></div><div ng-class=\"Payment.OTMTabExpanded ? \'expandBlock\' : \'closeexpandBlock\' \"><p class=stright-line></p><br><div class=custom-select data-list=2><div class=select-tab onclick=\"toggleList(event, \'list2Data\')\"><div style=\"display: flex\"><div class=select-text><p class=text1>{{Payment.OTMbankInfo.bankName}}</p><p class=text2>{{Payment.OTMbankInfo.maskedBankAcNo}}</p></div></div><div class=arrow><img src=../../../assets/images/down-arrow.svg alt=\"\" class=downArrow></div></div><div class=select-list id=selectList2><div class=list-item ng-repeat=\"_option in Payment.otmBankList\" ng-click=\"Payment.changeBank(_option,\'OTM\')\">{{_option.bankName}} - {{_option.maskedBankAcNo}}<p></p></div></div></div><div ng-if=\"Payment.OTMbankInfo && !Payment.OTMbankInfo.ifscCode\"><div class=input-normal ng-class={error:tForm1.ifscCode.$invalid&&tForm1.ifscCode.$dirty}><input type=text class=inputborder ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize placeholder=\"IFSC Code\"><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm1.ifscCode.$dirty&&tForm1.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm1.ifscCode.$dirty&&tForm1.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div ng-if=\"Payment.OTMbankInfo && !Payment.OTMbankInfo.bankAcType\"><div class=\"selectfield selectionIcon w100\" ng-class=\"{error:tForm1.accountType.$dirty && tForm1.accountType.$invalid}\" style=\"width: 364px;height: 60px\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required style=\"border: 1px solid gray;border-radius: 10px\"><option value=\"\" selected>Account Type</option></select></div><span class=error-input ng-messages=tForm1.accountType.$error ng-show=tForm1.accountType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div><div ng-if=Payment.OTMbankInfo><div class=\"otm-bank-details text-left\" ng-if=\"(Payment.otmBankList && Payment.otmBankList.length)\"><div class=\"row otmDetails\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>Account No:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>{{Payment.OTMbankInfo.bankAcNo}}</p></div></div><div class=\"row otmDetails\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>OTM UMRN No:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>{{Payment.OTMbankInfo.omUmrn}}</p></div></div><div class=\"row otmDetails\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>OTM Instruction Type:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>{{Payment.OTMbankInfo.otmFrequencyName}}</p></div></div><div class=\"row otmDetails\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>OTM Max Amount:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left><i class=rupee-small-icon></i>{{Payment.OTMbankInfo.maxAmount}}</p></div></div><div class=\"row otmDetails\" ng-if=\"Payment.isOTMAmount && Payment.formData.purchaseAmount\"><div><span class=error-input style=\"float: left;text-align: left;padding-left: 15px\" ng-bind=Payment.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_PURCHASE_ERROR></span></div></div><div class=\"row otmDetails\" ng-if=\"Payment.isOTMAmount && Payment.formData.sipFirstAmount\"><div><span class=error-input style=\"float: left;text-align: left;padding-left: 15px\" ng-bind=Payment.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_SIP_ERROR></span></div></div><div class=\"row otmDetails\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>OTM Start Date:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>{{Payment.OTMbankInfo.omStartDate}}</p></div></div><div class=\"row otmDetails\" ng-if=Payment.isOTMStartDate><div><span class=error-input style=\"float: left;text-align: left;padding-left: 15px\" ng-bind=\"Payment.VALIDATE_DATA.DATE_START_VALIDATION_ERROR + \' \' + Payment.OTMbankInfo.omStartDate\"></span></div></div><div class=\"row otmDetails\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>OTM Expiry Date:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><p class=f-left>{{Payment.OTMbankInfo.omExpiryDate}}</p></div></div><div class=\"row otmDetails\" ng-if=Payment.isOTMDate><div><span class=error-input style=\"float: left;text-align: left; padding-left: 15px\" ng-bind=\"Payment.VALIDATE_DATA.EXPIRY_DATE_VALID_ERROR + \' \' + Payment.OTMbankInfo.omExpiryDate\"></span></div></div></div></div></div></div></form></section><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{Payment.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden class=inputborder name=hidRequestId ng-value=Payment.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden class=inputborder name=hidOperation ng-value=Payment.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg class=inputborder ng-value=Payment.billdeskPayload.msg></form></section><!-- OTM END --><!-- Purchase NETBANKING Start --><section class=\"main-section-whatsup clearfix payment-screen\" ng-if=\"Payment.formData.investmentType === \'PURCHASE\' \" style=\"padding: 0px\"><section class=content-area style=\"width: 413px;margin: 5px 0px 5px 0px;    padding: 0px;border-radius: 11px;box-shadow: 4px 5px 32px -12px\"><!-- desktop view form--><form class=desktop-gateway-view autocomplete=off novalidate name=tForm2><div class=tab-body ng-switch=Payment.formData.selectedPaymentOption ng-init=Payment.getFormData(tForm2)><div class=mainDiv><div style=\"display: flex;justify-content: space-between\"><div style=\"display: flex;justify-content: center;align-items: center\"><img src=../../../assets/images/net.svg alt=\"\"><p class=subHeadingStyle>Net Banking</p></div><img src=../../../assets/images/icons/black-down-arrow.svg ng-if=!Payment.PNetBankingTabExpanded ng-click=\"Payment.changeToggleIcon(\'collapseExamplePurchaseNetbanking\')\" style=\"width: 25px\"></div></div><div ng-class=\"Payment.PNetBankingTabExpanded ? \'expandBlock\' : \'closeexpandBlock\' \"><p class=stright-line></p><div><!-- NETBANKING --><!--NETBANKING BANK selection  START --><p class=ptext>Registered bank</p><div class=custom-select data-list=3><div class=select-tab onclick=\"toggleList(event, \'list3Data\')\"><div style=\"display: flex\"><div class=select-text><p class=text1>{{Payment.bankInfo.bankNameOnly}}</p><p class=text2>{{Payment.bankInfo.maskedAccountNumber}}</p></div></div><div class=arrow><img src=../../../assets/images/down-arrow.svg alt=\"\" class=downArrow></div></div><div class=select-list id=selectList3><div class=list-item ng-repeat=\"_option in Payment.netBankingBankList\" ng-click=\"Payment.changeBank(_option,\'NETBANKING\')\">{{_option.bankNameOnly}} - {{_option.maskedAccountNumber}}</div></div></div><!--NETBANKING BANK selection  END --><div ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><br><div class=input-normal ng-class={error:tForm2.ifscCode.$invalid&&tForm2.ifscCode.$dirty} style=\"width: 364px\"><input type=text class=\"inputborder w100\" ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize placeholder=\"IFSC Code\"><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm2.ifscCode.$dirty&&tForm2.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm2.ifscCode.$dirty&&tForm2.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon w100\" ng-class=\"{error:tForm2.accountType.$dirty && tForm2.accountType.$invalid}\" style=\"width: 364px;height: 60px\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-init=\"Payment.formData.paymentInfo.accType=Payment.formData.paymentInfo.accType?Payment.formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required style=\"border: 1px solid gray;border-radius: 10px\"><option value=\"\" selected>Account Type</option></select><span class=error-input ng-messages=tForm2.accountType.$error ng-show=tForm2.accountType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=text-red ng-if=\"!Payment.netBankingBankList || !Payment.netBankingBankList.length\"><span>In case your registered bank is not displayed, please choose other payment mode or add another bank.</span></div></div></div></div></form></section><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{Payment.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden class=inputborder name=hidRequestId ng-value=Payment.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden class=inputborder name=hidOperation ng-value=Payment.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg class=inputborder ng-value=Payment.billdeskPayload.msg></form></section><!-- Purchase NETBANKING END --><!-- SIP NETBANKING/Biller Start --><section class=\"main-section-whatsup clearfix payment-screen\" ng-if=\"Payment.formData.investmentType === \'SIP\' && Payment.viewBillerPaymentMode \" style=\"padding: 0px\"><section class=content-area style=\"width: 413px;margin: 5px 0px 5px 0px;    padding: 0px;border-radius: 11px;box-shadow: 4px 5px 32px -12px\"><!-- desktop view form--><form class=desktop-gateway-view autocomplete=off novalidate name=tForm3><div class=tab-body ng-switch=Payment.formData.selectedPaymentOption ng-init=Payment.getFormData(tForm3)><div class=mainDiv><div style=\"display: flex;justify-content: space-between\"><div style=\"display: flex;justify-content: center;align-items: center\"><img src=../../../assets/images/net.svg alt=\"\"><p class=subHeadingStyle>Net Banking</p></div><img src=../../../assets/images/icons/black-down-arrow.svg ng-if=!Payment.SNetBankingTabExpanded ng-click=\"Payment.changeToggleIcon(\'collapseExampleSIPNetbanking\')\" style=\"width: 25px\"></div></div><div ng-class=\"Payment.SNetBankingTabExpanded ? \'expandBlock\' : \'closeexpandBlock\' \"><p class=stright-line></p><div><!-- NETBANKING --><!--NETBANKING BANK selection  START --><p class=ptext>Registered bank</p><div class=custom-select data-list=4><div class=select-tab onclick=\"toggleList(event, \'list4Data\')\"><div style=\"display: flex\"><div class=select-text><p class=text1>{{Payment.bankInfo.bankNameOnly}}</p><p class=text2>{{Payment.bankInfo.maskedAccountNumber}}</p></div></div><div class=arrow><img src=../../../assets/images/down-arrow.svg alt=\"\" class=downArrow></div></div><div class=select-list id=selectList4><div class=list-item ng-repeat=\"_option in Payment.billerBankList\" ng-click=\"Payment.changeBank(_option,\'EC\')\">{{_option.bankNameOnly}} - {{_option.maskedAccountNumber}}</div></div></div><!--NETBANKING BANK selection  END --><div ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><br><div class=input-normal ng-class={error:tForm3.ifscCode.$invalid&&tForm3.ifscCode.$dirty} style=\"width: 364px\"><input type=text class=\"inputborder w100\" ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize placeholder=\"IFSC Code\"><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm3.ifscCode.$dirty&&tForm3.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm3.ifscCode.$dirty&&tForm3.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon w100\" ng-class=\"{error:tForm3.accountType.$dirty && tForm3.accountType.$invalid}\" style=\"width: 364px;height: 60px\"><select class=select-box name=accountType ng-model=Payment.formData.paymentInfo.accType ng-init=\"Payment.formData.paymentInfo.accType=Payment.formData.paymentInfo.accType?Payment.formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required style=\"border: 1px solid gray;border-radius: 10px\"><option value=\"\" selected>Account Type</option></select><span class=error-input ng-messages=tForm3.accountType.$error ng-show=tForm3.accountType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div></div></form></section><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{Payment.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden class=inputborder name=hidRequestId ng-value=Payment.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden class=inputborder name=hidOperation ng-value=Payment.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg class=inputborder ng-value=Payment.billdeskPayload.msg></form></section><!-- SIP NETBANKING/Biller END --><!-- paynow Buttons section start --><section class=\"main-section-whatsup clearfix payment-screen\"><div style=\"width: 413px; margin: 20px 0px 20px 0px; padding: 0px\"><button class=wBtn ng-if=\"Payment.formData.investmentType === \'PURCHASE\' && Payment.formData.selectedPaymentOption == \'UPI\'\" ng-disabled=\"(Payment.formData.paymentInfo && (!Payment.formData.paymentInfo.bankName ||  Payment.amountOverUPILimit || !Payment.formData.paymentInfo.ifscCode || !Payment.formData.paymentInfo.accType)) || !Payment.isUPIVerified\" ng-click=Payment.checkDuplicate($event)>Pay Now <img class=icon src=../../../assets/images/arrow-white-small.svg alt=\"\" srcset=\"\"></button> <button class=wBtn ng-if=\"Payment.formData.investmentType === \'PURCHASE\' && Payment.formData.selectedPaymentOption == \'NETBANKING\'\" ng-disabled=\"!Payment.bankInfo || !Payment.formData.paymentInfo.ifscCode || !Payment.formData.paymentInfo.accType\" ng-click=Payment.checkDuplicate($event)>Pay Now <img class=icon src=../../../assets/images/arrow-white-small.svg alt=\"\" srcset=\"\"></button> <button class=wBtn ng-if=\"Payment.formData.investmentType === \'PURCHASE\' && Payment.formData.selectedPaymentOption == \'OTM\'\" ng-disabled=\"!Payment.OTMbankInfo || !Payment.formData.paymentInfo.ifscCode || !Payment.formData.paymentInfo.accType || Payment.isInvalidForm || Payment.isOTMStartDate || Payment.isOTMDate\" ng-click=Payment.checkDuplicate($event)>Pay Now <img class=icon src=../../../assets/images/arrow-white-small.svg alt=\"\" srcset=\"\"></button> <button class=wBtn ng-if=\"Payment.formData.investmentType === \'SIP\' && Payment.formData.selectedPaymentOption == \'EC\'\" ng-disabled=\"!Payment.bankInfo || \n      (Payment.bankInfo && !Payment.bankInfo.ifscCode && !Payment.formData.paymentInfo.ifscCode) || \n      (Payment.bankInfo && !Payment.bankInfo.bankAcType && !Payment.formData.paymentInfo.accType) ||\n      (Payment.bankInfo.bankCode == \'OTHER\' && !Payment.formData.bankName)\" ng-click=Payment.checkDuplicate($event)>Pay Now <img class=icon src=../../../assets/images/arrow-white-small.svg alt=\"\" srcset=\"\"></button> <button class=wBtn ng-if=\"Payment.formData.investmentType === \'SIP\' && Payment.formData.selectedPaymentOption == \'OTM\'\" ng-disabled=\"(Payment.formData.paymentInfo &&  (!Payment.formData.paymentInfo.bankName || !Payment.formData.paymentInfo.ifscCode || !Payment.formData.paymentInfo.accType)) || Payment.isOTMDate || Payment.isOTMAmount \" ng-click=Payment.checkDuplicate($event)>Pay Now <img class=icon src=../../../assets/images/arrow-white-small.svg alt=\"\" srcset=\"\"></button> <button class=wBtn ng-if=\"Payment.formData.investmentType === \'SIP\' && Payment.formData.selectedPaymentOption == \'UPI\'\" ng-disabled=\"(Payment.formData.paymentInfo && (!Payment.formData.paymentInfo.bankName || !Payment.formData.paymentInfo.ifscCode || !Payment.formData.paymentInfo.accType)) || !Payment.isUPIVerified || Payment.amountOverUPILimit\" ng-click=Payment.checkDuplicate($event)>Pay Now <img class=icon src=../../../assets/images/arrow-white-small.svg alt=\"\" srcset=\"\"></button></div></section><div class=footerDiv><img src=../../../assets/images/hdfcmf-Main.png alt=\"\" style=\"height: 20px\"><p class=footerSubHeading>Managed by HDFC MF Limited.<a href={{Payment.CORPORATE_URL}} target=_blank style=\"color: blue;font-weight: 500\">Learn More</a>.</p></div></section><section ng-if=\"(!Payment.linkID || Payment.formData.sipFirstInstallment || Payment.isTransactionDone) && !Payment.linkHasbeenExpired\" class=section-pd-bottom><section class=main-section-whatsup><div class=modal-content id=loginLoader tabindex=-1><div class=\"modal-body main-loader\"><p class=blacktintLoad></p><div class=\"loader-box-content text-center\"><p><img src=../../../assets/images/logo-main.png alt=HDFC></p><p><img src=../../../assetsassets/images/logo.png alt=\"Partner\'s Logo\"></p><h3 class=text-primary>Welcome {{WhatsappApiGateWay.investorName || \'Investor\' | camelcase}}</h3><p>Please wait while we fetch your details.</p><img src=../../../assets/images/loader_web.gif alt=loader class=loader-gif><br><timer interval=1000>{{minutes}}:{{seconds}}</timer></div></div></div></section></section><!-- link expired  --><div ng-if=Payment.linkHasbeenExpired><!-- header section start --><div class=headerDiv style=\"height: 22vh\"><div class=subHeaderDiv1><img ng-click=Payment.openWLink() class=displayForMobile style=\"flex-shrink: 0; width: 3vh\" src=../../../assets/images/icons/white-back-arrow.svg><div style=\"margin-left: auto;     text-align: center;margin-right: auto; height: 6vh\"><img src=../../../assets/images/logo.jpg style=\"height: 5vh\"><p class=ptext style=\"color: white;padding-top: 5vh; font-size: 4vh; margin: 2px\">Expired</p></div></div></div><!-- link expired  --><div class=\"centerDiv mT20\"><div style=\"text-align: center\"><img src=../../../assets/images/FailedTransaction.svg alt=\"\" style=\"margin-top: 10%\"><br><p class=\"ptext cblack\" style=\"text-align: center;font-size: 4vh; margin: 10px;  font-weight: 700;color: black\">Transaction link has expired</p></div></div><div class=footerDiv><div class=footerSubDiv><img src=../../../assets/images/hdfcmf-Main.png alt=\"\" style=\"height: 20px\"><p class=footerSubHeading>Managed by HDFC MF Limited.<a href={{Payment.CORPORATE_URL}} target=_blank style=\"color: blue;font-weight: 500\">Learn More</a>.</p></div></div></div><style>.cblack{\n    color: #000000 !important;\n  }\n  h2{\n    font-size: 4vh;\n  }\n  .mT20{\n     margin-top: 20px;\n     line-height: initial;\n  }\n  .footerDiv{\n     position: fixed;\n     bottom: 0px;\n     width: 100%;\n     background: white;\n  }\n  .footerDiv{\n        position: fixed;\n        bottom: 0px;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;  \n        padding-right: 6px;\n        padding-top: 10px;\n        padding-bottom: 10px;\n        background-color: white;\n    }\n  .section-pd-bottom{\n    padding-bottom: 60px;\n  }\n  .footerSubDiv{\n     display: flex;justify-content: center;align-items: center;margin-top: 15px;\n  }\n  body,span,div,input,select,p,option{\n    font-family: Inter !important;\n  }\n  .mainDiv{\n    width: 364px;\n    margin: 10px 0px 10px 0px;\n  }\n  .subHeadingStyle{ \n    font-size: 14px;\n    font-weight: 500;\n    line-height: 26px;\n    text-align: left;\n    margin-left: 5px;\n  }\n  .wBtn {  \n    font-weight: 700;  \n    background: #1B4B86; \n    border: none;\n    color: white;\n    width: 318px;\n    height: 48px;\n    text-align: center;\n    text-decoration: none;\n    align-items: center;\n    font-size: 18px;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 6px;\n    transition: background-color 0.3s;\n  }\n  .wBtn:disabled {\n    opacity: 0.5;\n  }\n  .icon {\n    width: 16px;\n    height: 16px;\n    margin-right: 8px;\n    fill: white;\n  }\n  .f-left{\n    float: left;\n    font-size: 12px;\n  }\n  .otmDetails{\n    margin: 10px 0px 10px 0px !important;\n  }\n  .input-normal{\n    margin-bottom: 20px !important;\n  } \n  .centerDiv{\n      display: flex;\n      align-items: center;\n      justify-content: center; \n  }\n  .radioButtonStyle{\n    width: 20px;\n    height: 20px;\n    top: 42px;\n    left: 344px;\n    gap: 0px;\n    border-radius: 100px 0px 0px 0px;\n    border: 1px 0px 0px 0px;\n    opacity: 0px;\n\n  }\n  .footerSubHeading{\n    margin-left: 6px; \n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    text-align: left;\n  }\n  @media (max-width: 330px) { \n    .footerSubHeading{\n      white-space: nowrap !important; \n      font-size: 4vw !important; \n    }\n    .footerDiv{\n      left:2px !important;\n    }\n  }\n  button{\n    width: 100% !important;\n  }\n  .custom-select {\n      border: 1px solid #D3D2D2;\n      width: 364px;\n      border-radius: 10px;\n      overflow: hidden;\n      margin-bottom: 10px; /* Space between lists */\n  }\n\n  .select-tab {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      text-align: left;\n      padding: 10px;\n      cursor: pointer;\n  }\n\n  .select-image {\n      width: 40px;\n      height: 40px;\n      margin-right: 10px;\n  }\n\n  .select-text {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .arrow {\n      font-size: 20px;\n  }\n\n  .select-list {\n      display: none; /* Initially hidden */\n      border-top: 1px solid #ccc;\n      max-height: 150px;\n      text-align: left;\n      overflow-y: scroll;\n  }\n  select{\n    font-family: Inter !important;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px; \n    border: 1px solid #BDBCBD !important;\n    padding-left: 14px !important;\n  } \n  .inputborder{ \n    border: 1px solid #BDBCBD !important; \n  }\n  input{ \n    font-family: Inter !important; \n    border-radius: 6px;\n    width: 365px;\n    height: 40px; \n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;  \n    padding-left: 14px !important;\n  }\n  .list-item {\n      padding: 10px;\n      border-bottom: 1px solid #ccc;\n  }\n  .list-item:hover {\n      background-color: #f1f1f1;\n  }\n  .text1{ \n    font-size: 12px;\n    font-weight: 600;\n    line-height: 14px;\n  }\n  .text2{ \n    font-size: 10px;\n    font-weight: 300;\n    line-height: 12px\n  }\n  .main-section-whatsup{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    background:#F9F9F9 !important;\n  }\n  .headingDiv{  margin-top: 12px;\n    padding-bottom: 14px;\n  }\n  .headingTitle{ \n    font-size: 16px;\n    font-weight: 700;\n    line-height: 23px;\n    text-align: left;\n  }\n  .content-area{\n    padding: 0px;\n  }\n  @include viewport(mobile) {\n    .main-section-whatsup, .w100, .mainDiv,  .custom-select{\n      width: 100% !important;\n    }\n    input,select{\n      width: 95%;\n    } \n  }\n  @media only screen and (max-width: 650px) {\n    .main-section-whatsup, .w100, .mainDiv,  .custom-select{\n      width: 100%  !important;\n    }\n    input,select{\n      width: 95%;\n    }\n  }\n  @media only screen and (max-width: 460px) {\n    .wBtn{\n      width: 85% !important;\n    }\n\n  }\n  @media only screen and (max-width: 767px) {\n     .verifyButton{\n      width: 100% !important;\n     }\n     .verifyButtonDiv{\n      padding-left: 15px !important;\n      padding-right: 15px !important;\n     }\n  }\n  progress{ \n    border: solid 1px #F4F4F4; \n    height: 6px !important; \n    padding: 0px 60px 0px 0px;\n    gap: 0px;\n    opacity: 0px; \n    width: 100%;\n    height: 12px;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n  }\n  progress::-webkit-progress-bar{background-color: transparent;}\n  progress::-webkit-progress-value{\n    background-color: #009E36;\n  }\n  progress::-moz-progress-bar{\n    background-color: #009E36;\n  }\n  .verifyButton{\n    height: 40px;\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 16px;\n    text-align: center;\n    background: #FFFFFF;\n    border: 1px solid #2A699E;\n    color: #2A699E; \n    background-color:#FFFFFF; \n    padding: 10px 9px 9px 9px; \n    border-radius: 6px;\n    border: 1px 0px 0px 0px;\n    opacity: 0px;\n  }\n  .stright-line{\n    border-bottom: 1px solid #A7A5A6; \n  } \n  .downArrow{\n    width: 14px;\n    height: 7px;\n    top: 7.5px;\n    left: 5px;\n    gap: 0px;\n    border: 1px 0px 0px 0px;\n    opacity: 0px; \n  }\n  .ptext{\n    text-align: left;\n    font-size: 14px;\n    color: #908E8F;\n    margin: 15px 0px 15px 0px;\n  }\n  .startDate{\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    color: #000000;\n  }\n  .expandBlock {\n    display: block !important; \n  }\n  .closeexpandBlock {\n    display: none !important; \n  } \n  .headerDiv{ \n    height: 30vh;min-height: 110px; \n    background: linear-gradient(334.14deg, #124480 16.32%, #02245F 83.68%); \n  }\n  .subHeaderDiv1{\n    display: flex;  \n    justify-content: flex-start;  \n    align-items: flex-start;  \n    width: 100%;  \n    padding: 12px;\n    padding-top: 4vh;  \n  }\n  .subHeaderDiv2{\n    display: flex; justify-content: center; \n    width: 100%;  text-align: center;   padding: 2vh;   \n    padding-bottom: 4vh; padding-top: 4vh;     \n  }\n  .subHeaderDiv3{\n    display: flex;  \n    justify-content: center;  \n    align-items: center;  \n    width: 100%;  \n  }\n  .amountText{\n    color: white; font-size: 5vh; font-weight: 700; margin: 0;\n  }\n  .displayForMobile{\n    display: none;\n  }\n  @media (max-width: 768px) {\n    .displayForMobile{\n    display: block !important;\n    }\n  }</style><script>$(document).ready(function() {\n    window.history.pushState(null, \"\", window.location.href);\n    window.onpopstate = function() {\n        window.history.pushState(null, \"\", window.location.href);\n    };\n  });\n \n  var openListId = null;\n \n  function toggleList(event, listData) {\n      event.stopPropagation(); // Prevent click from propagating to document\n  \n      const listId = parseInt(listData.charAt(4)); // Extract list number from \'listXData\'\n      const list = document.getElementById(`selectList${listId}`);\n  \n      if (openListId && openListId !== listId) {\n          // Close the previously opened list\n          document.getElementById(`selectList${openListId}`).style.display = \'none\';\n      }\n  \n      if (list.style.display === \'block\') {\n          list.style.display = \'none\';\n          openListId = null;\n      } else {\n          list.style.display = \'block\';\n          openListId = listId;\n      }\n  }\n \n  document.addEventListener(\'click\', () => {\n      // Close all lists if clicking outside\n      const lists = document.querySelectorAll(\'.select-list\');\n      lists.forEach(list => {\n          list.style.display = \'none\';\n      });\n      openListId = null;\n  });</script>");
$templateCache.put("app/whatsapp-payment/pre-login-landing/whatsapp-pre-login-landing.html","<div class=gateway-payment><hdfc-header-pre-login show-logout-btn=WhatsappApiGateWay.showLogoutBtn logo-url=WhatsappApiGateWay.logoUrl></hdfc-header-pre-login><section ng-if=!WhatsappApiGateWay.isLoading><div class=modal-content id=loginLoader tabindex=-1><div class=\"modal-body main-loader\"><p class=blacktintLoad></p><div class=\"loader-box-content text-center\"><p><img src=../../../assets/images/logo-main.png alt=HDFC></p><p><img src=../../../assets/images/logo.png alt=\"Partner\'s Logo\"></p><h3 class=text-primary>Welcome {{WhatsappApiGateWay.investorName || \'Investor\' | camelcase}}</h3><p>Please wait while we fetch your details.</p><img src=../../../assets/images/loader_web.gif alt=loader class=loader-gif><br><timer interval=1000>{{minutes}}:{{seconds}}</timer></div></div></div></section><section ng-if=WhatsappApiGateWay.isLoading><div><div class=content-area><div ui-view></div></div></div></section></div>");
$templateCache.put("app/arn-review/scheduleTransaction/purchaseScheduleTransaction/scheduleTransactionList.html","<div class=sMainDiv ng-repeat=\"data in scheduleTransactionList.data track by $index\" ng-if=scheduleTransactionList.beforotp><div style=\"width: 85%\" id={{data.scheduler_id}}><div class=\"topDetails1 sSubDiv\" id=mainDiv{{$index}}><div class=container style=\"width: 100%\"><div class=\"row sMT25\" style=\"width: 100%;margin-left: 0px;margin-right: 0px\"><div class=\"col-sm-5 text-left\">Scheme Name<p class=topTextSize>{{data.schemeName}}</p></div><div class=\"col-sm-2 text-left\"><p>Folio Number</p><p class=topTextSize>{{data.maskedFolio}}</p></div><div class=\"col-sm-2 text-left\"><p>Mobile Number</p><p class=topTextSize>{{data.maskedMobileNumber}}</p></div><div class=\"col-sm-2 text-left\"><p>Email ID</p><p class=topTextSize>{{data.maskedEmail}}</p></div><div class=col-sm-1><img src=assets/images/arrow-down.svg data-bs-toggle=collapse id=collapseImage{{$index}} data-bs-target=#collapseExample{{$index}} aria-expanded=false aria-controls=collapseExample{{$index}} alt=\"\" ng-click=scheduleTransactionList.changeToggleIcon($index) style=\"width: 25px\"></div></div></div></div><div class=collapse ng-class=\"{\'expandBlock\':data.scheduler_id == scheduleTransactionList.schedulerIdDetails }\" id=collapseExample{{$index}}><div class=secondDiv><div class=container><div class=row style=\"margin-top: 25px\"><div class=\"col-sm-2 text-left\">Broker code<p class=valueText2Size><span ng-if=!data.brokerCode>DIRECT</span> <span ng-if=data.brokerCode>{{data.brokerCode}}</span></p></div><div class=\"col-sm-3 text-left\"><p>EUIN</p><p class=valueText2Size><span ng-if=data.euin>{{data.euin}}</span> <span ng-if=!data.euin>NA</span></p></div><div class=\"col-sm-3 text-left\"><p>Transaction Type</p><p class=valueText2Size>{{data.transactionType}}</p></div><div class=\"col-sm-4 text-left\"><p ng-if=\"data.investmentOption == \'Growth\'\">Investment Option</p><p ng-if=\"data.investmentOption != \'Growth\'\">Income Distribution cum Capital Withdrawal (IDCW) Option</p><p class=valueText2Size ng-if=\"data.dividendOption == \'Z\'\">Growth</p><p class=valueText2Size ng-if=\"data.dividendOption != \'Z\'\"><span ng-if=\"data.dividendOption == \'Y\'\">Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</span> <span ng-if=\"data.dividendOption == \'N\'\">Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</span></p></div></div></div><div class=container><div class=row style=\"margin-top: 25px;\n                margin-bottom: 25px\"><div class=\"col-sm-2 text-left\">Amount(INR)<p class=valueText2Size><i class=rupee-black-icon></i>{{data.installmentAmount}}</p></div><div class=\"col-sm-3 text-left\"><p>Scheduled Start Date</p><p class=valueText2Size>{{data.scheduleStartDate }}</p></div><div class=\"col-sm-3 text-left\"><p>Scheduled End Date</p><p class=valueText2Size>{{data.scheduleEndDate}}</p></div><div class=\"col-sm-4 text-left\"><p>Payment Option :</p><p class=valueText2Size ng-if=\"data.payMech == \'OTM\'\">OTM (One Time Mandate)</p><p class=valueText2Size ng-if=\"data.payMech == \'HEM\'\">Register E-mandate (eOTM)</p><p class=valueText2Size ng-if=\"data.payMech == \'NETBANKING\'\">Net Banking</p><p class=valueText2Size ng-if=\"data.payMech == \'UPI\'\">UPI</p><p class=valueText2Size ng-if=!data.payMech>NA</p></div></div></div><div class=container style=\"width: 100%\"><div class=row style=\"margin-top: 5px;float: right;\n                margin-bottom: 5px\"><button class=sCancelButton ng-click=scheduleTransactionList.cancel(data)>Cancel</button> <button class=smodifyButton ng-click=scheduleTransactionList.modify(data)>Modify</button></div></div></div></div></div></div><div style=\"display: flex;justify-content: center;align-items: center;width: 99%\" ng-if=\"scheduleTransactionList.data.length == 0\"><h1 style=\"color: red\">No scheduled transaction is available</h1></div><div style=\"display: flex;justify-content: center;align-items: center;width: 99%\" ng-if=!scheduleTransactionList.beforotp><div style=\"width: 80%\"><div class=topDetails><div><img src={{ArnReview.formData.distributorImage}} alt=\"\" srcset=\"\" style=\"width: 180px; margin: 15px 0px 15px 10px\"></div><div style=font-size:18px><p class=\"note p-10\" ng-if=ArnReview.formData.distributorName>{{ArnReview.formData.distributorName}}</p></div><div style=\"text-align: left;margin: 5px 50px 5px 5px; font-size:18px\"><p class=fs-10 ng-if=ArnReview.formData.arn>ARN-{{ArnReview.formData.arn}}</p></div></div><div class=secondDiv><div><div class=otpDiv><div class=\"group otpInput input-normal\" ng-class=\"{error:ModalOtpForm.otpNumber.$dirty && ModalOtpForm.otpNumber.$invalid}\"><!-- <P style=\"text-align: left;font-size: 12px;font-weight: bold;padding: 5px 5px 5px 0px; color: blue;\">Enter OTP</p> --> <input type=text ng-model=scheduleTransactionList.otpNumber name=otpNumber is-number style=\"cursor: auto; font-size: 18px\" ng-change=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off placeholder=\"ENTER OTP\" autofocus> <span class=forgot><timer countdown=60 interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>Resend OTP in &nbsp;<br class=break>{{countdown}}s</span> <a href=javascript:void(0); ng-show=\"countdown == 0\" ng-click=scheduleTransactionList.reSendOtp(); class=forgot-pwd>Resend&nbsp;&nbsp;OTP</a></timer></span></div><div><span class=error-input ng-messages=ModalOtpForm.otpNumber.$error ng-show=ModalOtpForm.otpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span></div><div><p style=\"font-size: 14px;text-align: justify;padding: 0px 0px 30px 0px\">Please enter OTP sent on your folio registered email ID ({{scheduleTransactionList.currentForlio.maskedEmail}}) and mobile number({{scheduleTransactionList.currentForlio.maskedMobileNumber}}).OTP is valid for 15 minutes only.</p></div><div class=flex><button type=button class=btn-pro ng-click=scheduleTransactionList.back()>Back</button> <button type=button class=btn-pro ng-disabled=!scheduleTransactionList.otpNumber ng-click=scheduleTransactionList.makeTransaction()>Submit</button></div></div></div></div></div></div><p ng-click=scheduleTransactionList.browserBackButtonClick() id=callBackButton></p><style>.sMainDiv {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 99%;\n    margin-top: 40px;\n  }\n\n  .sSubDiv {\n    background-color: #F3F9FF !important;\n    border-bottom-left-radius: 12px;\n    border-bottom-right-radius: 12px;\n  }\n\n  .sMT25 {\n    margin-top: 25px;\n    margin-bottom: 25px;\n  }\n\n  .sCancelButton {\n    width: 195px;\n    height: 48px;\n    padding: 12px, 24px, 12px, 24px;\n    border-radius: 8px;\n    background: transparent;\n    margin: 15px;\n    color: #004B8B;\n    font-weight: 600;\n    border: 1px solid #004B8B;\n\n  }\n\n  .smodifyButton {\n    width: 195px;\n    height: 48px;\n    padding: 12px, 24px, 12px, 24px;\n    border-radius: 8px;\n    background: #1B4B86;\n    margin: 15px;\n    color: white;\n    border: 1px solid #004B8B\n  }\n\n  .topDetails1 {\n    background-color: #0c4c87;\n    display: flex;\n    justify-content: space-between;\n    text-align: center;\n    align-items: center;\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    box-shadow: 0px 1px 6px 0px grey;\n  }\n\n  .topTextSize {\n    font-family: Proxima Nova;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: left;\n\n  }\n\n  .valueText2Size {\n    font-family: Proxima Nova;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: left;\n\n  }\n  .break{\n    display: none;\n  }\n   .rdiv1{ \n    border: none; \n    margin: auto;\n   }\n   @media only screen and (max-width: 1150px) {\n    .rdiv1{ \n    width: 100%;\n    margin: 15px;\n   }\n  }   \n  @media only screen and (max-width: 450px) {\n    .break{\n    display: initial;\n  }\n  .forgot-pwd {\n    top: 7%;\n  }\n  .input-normal input {\n    width: 65% !important;\n  }\n  } \n      .col {\n        text-align: center;\n      }\n  \n      .btn {\n        margin-right: 30px;\n      }\n  \n      .otpInput {\n        border: 1px solid gray;\n        border-radius: 30px;\n      }\n  \n      .input-normal input {\n        border-bottom: none !important;\n        border-right: 1px solid gray;\n        background: transparent;\n        text-align: center;\n        width: 70%;\n      }\n  \n      .input-normal input:focus {\n        border-right: 1px solid gray !important;\n        border-bottom: none !important;\n        text-align: center;\n        width: 70% !important;\n      }\n  \n      .otpDiv {\n        align-items: center;\n        text-align: center;\n        width: 50%;\n        margin-left: 25%;\n        margin-top: 10%;\n      }\n  \n  .btn-pro {\n      width: 163px;\n      height:  45px;\n      border: none;\n      letter-spacing: 0px;\n      color: #FFFFFF;    \n      background: #FD5C5E 0% 0% no-repeat padding-box;\n      border-radius: 18px;\n      font-size: 18px;\n    }\n  \n  \n    button:disabled,\n    button[disabled] {\n      opacity: 0.43;\n    }\n  \n  \n    .forgot-pwd {\n      position: absolute;\n      top: 20%;\n      right: 2%;\n      font-size: 12px;\n      padding: 5px 5px 5px 0px;\n      color: blue;\n    }\n    .input-normal .forgot a{\n      position: absolute;\n      top: 20%;\n      right: 2%;\n      font-size: 12px;\n      padding: 5px 5px 5px 0px;\n      color: blue;\n    }\n  \n    @media (max-width: 900px) {\n      .otpDiv {\n        align-items: center;\n        text-align: center;\n        width: 100%;\n        margin-left: 0px;\n        margin-top: 10%;\n      }\n      .forgot-pwd {\n        top: 15%;\n        right: 2%;\n      }\n      .input-normal .forgot a{\n      top: 15%;\n      right: 2%;\n    }\n    }\n\n    .expandBlock {\n      display: block !important; \n    }</style><script>window.addEventListener(\'popstate\',function(event){\n    var s = document.getElementById(\"callBackButton\");\n    s.click();\n  })</script>");
$templateCache.put("app/arn-review/scheduleTransaction/successfulCancelTransaction/successfulCancelTransaction.html","<div class=transaction-success-container><div class=success-content style=\"margin: 75px\"><div class=items-main><img class=success-content-img src=assets/images/icons/investor-basket/success.png><h2 class=success-content-desc>Transaction Cancelled successfully!</h2></div></div><div style=\"margin: 35px;\n  border-bottom: #e8e6e6;\n  border-style: groove\"><h1>Scheduled Transaction Details</h1></div><div style=\"margin: 35px\"><div class=row style=padding-bottom:30px><div class=col-md-3><p>Folio</p><p class=topTextSize>{{successfulCancelTransaction.data.folioNumber}}</p></div><div class=col-md-3><p>Broker code</p><p class=topTextSize><span ng-if=!successfulCancelTransaction.data.brokerCode>DIRECT</span> <span ng-if=successfulCancelTransaction.data.brokerCode>{{successfulCancelTransaction.data.brokerCode}}</span></p></div><div class=col-md-3><p>EUIN</p><p class=topTextSize><span ng-if=successfulCancelTransaction.data.euin>{{successfulCancelTransaction.data.euin}} </span><span ng-if=!successfulCancelTransaction.data.euin>NA</span></p></div><div class=col-md-3><p>Transaction Type</p><p class=topTextSize>Scheduled Purchase</p></div></div><div class=row style=padding-bottom:30px><div class=col-md-3><p>Scheme Name</p><p class=topTextSize>{{successfulCancelTransaction.data.schemeName}}</p></div><div class=col-md-3><p>Payment Mode</p><p class=topTextSize ng-if=\"successfulCancelTransaction.data.payMech == \'NETBANKING\'\">Net Banking</p><p class=topTextSize ng-if=\"successfulCancelTransaction.data.payMech == \'OTM\'\">OTM (One Time Mandate)</p><p class=topTextSize ng-if=\"successfulCancelTransaction.data.payMech == \'HEM\'\">E-Mandate</p><p class=topTextSize ng-if=\"successfulCancelTransaction.data.payMech == \'UPI\'\">UPI</p></div><div class=col-md-3><p>Amount</p><p class=topTextSize><i class=rupee-black-icon></i>{{successfulCancelTransaction.data.installmentAmount}}</p></div><div class=col-md-3><p ng-if=\"successfulCancelTransaction.data.investmentOption.toUpperCase() == \'GROWTH\'\">Investment Option</p><p ng-if=\"successfulCancelTransaction.data.investmentOption.toUpperCase() != \'GROWTH\'\">Income Distribution cum Capital Withdrawal (IDCW) Option</p><p class=topTextSize ng-if=\"successfulCancelTransaction.data.dividendOption.toUpperCase() == \'Z\'\">Growth</p><p class=topTextSize ng-if=\"successfulCancelTransaction.data.dividendOption.toUpperCase() == \'Y\'\">Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</p><p class=topTextSize ng-if=\"successfulCancelTransaction.data.dividendOption.toUpperCase() == \'N\'\">Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><div class=row style=padding-bottom:30px><div class=col-md-3><p>Scheduled Start Date</p><p class=topTextSize>{{successfulCancelTransaction.data.scheduleStartDate}}</p></div><div class=col-md-3><p>Scheduled End Date</p><p class=topTextSize>{{successfulCancelTransaction.data.scheduleEndDate}}</p></div><div class=col-md-3><p>Mobile Number</p><p class=topTextSize>{{successfulCancelTransaction.data.maskedMobileNumber}}</p></div><div class=col-md-3><p>Email ID</p><p class=topTextSize>{{successfulCancelTransaction.data.maskedEmail}}</p></div></div></div><div style=\"margin: 35px\" ng-if=\"!InstantInvest.optOutNominee && InstantInvest.optedOutNominee\"><p>You have not nominated OR opted-out of nomination in your folio {{successfulCancelTransaction.data.folioNumber}}. We recommend you to add nominee details in your folio. Please <a href=https://digital.camsonline.com/changeofnomination target=_blank>Click here</a> for adding nominee details OR opting out of nomination. (NOTE: System shall redirect you to external CAMS website for updating nominee details in folio).</p></div></div><style>.topTextSize {\n    font-family: Proxima Nova;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: left;\n\n  }</style>");
$templateCache.put("app/components/directives/customDualDatePicker/dualDatePicker.html","<div class=\"form-input sip-tenure-container\" id=sip-tenure-input><label class=form-label>SIP Tenure</label><div class=\"input-normal icon-input\"><input type=text ignore-mouse-wheel name=tenure ng-model=tenureDisplay class=form-control required readonly> <span class=highlight></span> <span class=bar></span> <span class=input-group-addon ng-click=showCalender()><span class=\"glyphicon glyphicon-calendar-revamp\"></span></span></div></div><div class=\"d-flex justify-content-between calendar-container-wrapper\" ng-if=showCalendarView id=calender-view-wrapper ng-click=$event.stopPropagation()><div class=calendar-container id=calendar-1><div class=calendar-header id=header-1><button class=calendar-nav id=prev-month-1><span class=\"glyphicon glyphicon-chevron-left\"></span></button><div class=calendar-title id=calendar-title-1 data-view=date><span id=calendar-month-year-1>Feb 2024</span></div><button class=calendar-nav id=next-month-1><span class=\"glyphicon glyphicon-chevron-right\"></span></button></div><div class=separator></div><div class=calendar-weekdays id=weekday-calendar-1><span>Sun</span> <span>Mon</span> <span>Tue</span> <span>Wed</span> <span>Thu</span> <span>Fri</span> <span>Sat</span></div><div class=calendar-days id=calendar-days-1><!-- Days will be generated here --></div></div><div class=calendar-container id=calendar-2><div class=calendar-header id=header-2><button class=calendar-nav id=prev-month-2><span class=\"glyphicon glyphicon-chevron-left\"></span></button><div class=calendar-title id=calendar-title-2 data-view=date><span id=calendar-month-year-2>Feb 2024</span></div><button class=calendar-nav id=next-month-2><span class=\"glyphicon glyphicon-chevron-right\"></span></button></div><div class=separator></div><div class=calendar-weekdays id=weekday-calendar-2><span>Sun</span> <span>Mon</span> <span>Tue</span> <span>Wed</span> <span>Thu</span> <span>Fri</span> <span>Sat</span></div><div class=calendar-days id=calendar-days-2><!-- Days will be generated here --></div></div></div>");
$templateCache.put("app/components/header/Preliminary-Header/preliminary-header.html","<div class=\"preliminary-dashboard hidden-xs\"><div class=\"headerPreLogin pre-login-header container-fluid\"><div class=\"row main-head header-wrap-main\"><div class=\"col-sm-6 col-md-6\"></div><div class=\"col-sm-6 col-md-6 p-0\"><div class=right-section><div class=header-right-wrapper><div class=right-wrap-tb><div class=logindetailstext ng-if=Prelimaryheader.lastDateTime><span class=\"pr-2 logintxt d-flex flex-wrap tablogintxt\">Last Login&nbsp; <span class=\"logindetailstext tablogintxt\">{{Prelimaryheader.lastDateTime}}</span></span></div><button ui-sref=faq class=faq-button><img src=assets/images/faq.svg class=\"faq-icon body-img-color\"> <img src=assets/images/faqBW.svg style=\"display: none\" class=\"faq-icon body-img-bw\">FAQs</button><div class=faq-seperator></div><div class=text-size-img-container><div class=\"text-size-img body-img-color\" ng-click=\"Prelimaryheader.changedFont(\'decrement\')\" ng-class=\"{\'active-font\': Prelimaryheader.active[2]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Prelimaryheader.changedFont(\'original\')\" ng-class=\"{\'active-font\': Prelimaryheader.active[1]}\">A</div><div class=\"text-size-img body-img-color\" ng-click=\"Prelimaryheader.changedFont(\'increment\')\" ng-class=\"{\'active-font\': Prelimaryheader.active[3]}\">A</div></div><div class=toggle-theme><label class=switch><input type=checkbox name=toggletheme ng-model=Prelimaryheader.contrastt ng-change=Prelimaryheader.contrast() class=box title=\"High Contrast\"><div class=knobs><span>Dark</span></div><div class=layer></div></label></div></div></div></div></div><hr class=m-0><div class=\"col-sm-6 col-md-6\"><div class=left-section><a class=logo-main-web><img src=assets/images/hdfcmf-Main.svg alt=\"MF online investors\" class=\"logo-main-hdfcmf pull-left\"></a></div></div><div class=\"col-sm-6 col-md-6\"><div class=dropdown><a class=\"dropdown-toggle PrelimaryheaderProfile\" data-bs-toggle=dropdown href=# data-bs-auto-close=outside><img src=assets/images/preliminary-dashboard/profile.png class=\"pull-right pt-3 contrastImg-profile\"></a><ul class=\"dropdown-menu PrelimaryheaderProfileDropdownMenu\" style=\"min-width: 100px\"><li class=\"no-border logouttxt\"><button class=logoutBtn ng-click=Prelimaryheader.logout() class=nofocus>Logout</button></li></ul></div></div></div></div></div><!-- only for mobile --><div class=\"visible-xs mobileHeaderDashaboard\"><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-6 p-0\"><div class=left-section><div class=d-flex><div class=p-3><img src=../../../assets/images/breadcrumb-mobile.svg ui-sref=preliminarySidebar></div><div class=p-2><a class=logo-main-web><img src=assets/images/hdfcmf-Main.svg alt=\"MF online investors\" class=\"logo-main-hdfcmf pull-left\"></a></div></div></div></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-6 p-0\"><div class=right-section><div class=\"d-flex justify-content-end align-items-center\"><div class=dropdown><a class=\"dropdown-toggle PrelimaryheaderProfile\" data-bs-toggle=dropdown data-bs-auto-close=outside href=#><img src=assets/images/preliminary-dashboard/profile.png class=\"pull-right pt-2 pb-2 pr-2 contrastImg-profile\"></a><ul class=\"dropdown-menu PrelimaryheaderProfileDropdownMenu\" style=\"min-width: 100px\"><li class=\"no-border logouttxt\"><button class=logoutBtn ng-click=Prelimaryheader.logout() class=nofocus>Logout</button></li></ul></div><div class=\"dropdown verticalmenu-nofocus\"><a class=\"dropdown-toggle Prelimaryheadermore verticalmenu-nofocus\" data-bs-toggle=dropdown href=# data-bs-auto-close=outside><img src=assets/images/preliminary-dashboard/fi_more-vertical.svg class=\"pull-right pt-3 pb-3 pl-2 pr-2 constrastImg contrastImg-profile\"> <img src=assets/images/preliminary-dashboard/fi_more_verticalBlack.svg class=\"pull-right pt-3 pb-3 pl-2 pr-2 nonconstrastImg\"></a><ul class=\"dropdown-menu PrelimaryheaderMoreDropdownMenu\"><li class=\"borderSeparator pt-2 pb-2\"><a ui-sref=faq class=nofocus><img src=assets/images/preliminary-dashboard/faqQuestionmark.svg alt=\"\"> <span class=mobilefaqtxt>FAQs</span></a></li><li class=\"pt-2 pb-2\"><ul class=d-flex><li><span class=toggle-contrast-text>Dark</span></li><li><div class=preliminary-form-switch><label class=switch><input type=checkbox ng-model=Prelimaryheader.contrastt ng-change=Prelimaryheader.contrast() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-contrast-text>Light</span></li></ul></li><li class=\"borderSeparator pt-2 pb-2\"><div class=\"text-size-img-container mobileFontChangeContainer d-flex\"><div class=\"text-size-img mobFontChangeTxt\" ng-click=\"Prelimaryheader.changedFont(\'decrement\')\" ng-class=\"{\'active-font\': Prelimaryheader.active[2]}\">-A</div><div class=\"text-size-img mobFontChangeTxt\" ng-click=\"Prelimaryheader.changedFont(\'original\')\" ng-class=\"{\'active-font\': Prelimaryheader.active[1]}\">A</div><div class=\"text-size-img mobFontChangeTxt\" ng-click=\"Prelimaryheader.changedFont(\'increment\')\" ng-class=\"{\'active-font\': Prelimaryheader.active[3]}\">A+</div></div></li><li class=\"pt-2 pb-2\"><a href=\"\" class=nofocus><div class=logindetailstext ng-if=Prelimaryheader.lastDateTime><span class=\"pr-2 logintxt moblogintxt d-flex flex-wrap\">Last Login&nbsp; <span class=\"logindetailstext moblogintxt\">{{Prelimaryheader.lastDateTime}}</span></span></div></a></li></ul></div></div></div></div></div><style>.logoutBtn{\n    padding: 6px;\n    background: transparent;\n    border: none;\n    font-family: Inter;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.01em;\n    text-align: center;\n    margin: 0px !important;\n} \n.contrastClass .contrastImg-profile{\n  background:transparent !important;\n}\n.contrastClass .PrelimaryheaderMoreDropdownMenu{\n    background: #000;\n}\n.contrastClass .mobilefaqtxt{\n  color: #fff !important;\n}\n.contrastClass .mobilefaqtxt,.contrastClass .contrastImgMode,.contrastClass .logindetailstext,.contrastClass .moblogintxt {\n  color: #fff !important;\n} \n.verticalmenu-nofocus:focus{\n  border:none !important;\n}</style>");
$templateCache.put("app/components/modal/IFSCSelection/ifsc-selection.modal.html","<div class=modal-content id=ifsc-modal ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><!--<i class=\"times-icon\" ></i>--><div class=\"modal-head modal-before-none\"><h3>IFSC Search</h3><i class=times-icon ng-click=Modal.error();></i></div><div class=modal-body><form name=IFSCForm novalidate><div class=row><div class=col-md-5><div class=\"input-select input-normal\" ng-if=Modal.showFieldifsc ng-class=\"{error:IFSCForm.ifsccode.$dirty && IFSCForm.ifsccode.$invalid}\"><input class=form-control type=text ng-model=Modal.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-maxlength=11 limit-to=11 ng-pattern=Modal.IFSC_REGEX capitalize required ng-change=Modal.clearBankField()> <span class=highlight></span> <span class=bar></span><label>IFSC<span class=\"req text-red\">*</span></label><span ng-show=\"IFSCForm.ifsccode.$dirty && IFSCForm.ifsccode.$invalid\"><span class=error-input ng-show=IFSCForm.ifsccode.$error.pattern ng-bind=Modal.APP_CONSTANT.IFSC_CODE_REGEX></span></span></div></div></div><p class=form-raw-content>OR</p><br><div class=row><div class=col-md-5><div class=selectfield ng-class=\"{error:IFSCForm.bankName.$dirty && IFSCForm.bankName.$invalid}\" ng-if=Modal.showFieldbank><select class=select-box name=bankName ng-model=Modal.bankName ng-init=null ng-change=Modal.bankChange() ng-options=\"bank.bankName as bank.bankName for bank in Modal.bankList\" required><option value=\"\" selected>Bank Name</option></select><span class=\"req IfscReqModal text-red\">*</span></div></div><div class=col-md-5><div class=selectfield><select class=select-box name=city ng-model=Modal.cityName ng-options=\"city as city for city in Modal.cityList\" required ng-disabled=!Modal.bankName ng-class={enable:Modal.bankName}><option value=\"\" selected>Select City</option></select><span class=\"req IfscReqModal text-red\">*</span> <span class=error-input ng-if=\"Modal.cityList && !Modal.cityList.length\" ng-bind=Modal.APP_CONSTANT.IFSC_MODAL_CITY_BLANK></span></div></div></div><div class=\"row margin-section modal-multiple-action\"><button class=\"btn btn-secondary-action common-btn-padding clear-button-content\" ng-click=Modal.clearForm() value=Search>Clear</button> <button class=\"btn btn-primary-action common-btn-padding\" ng-click=Modal.searchIFSC() value=Search ng-disabled=\"!(Modal.ifsccode || (Modal.bankName && Modal.cityName))\">Search</button></div></form><div class=ifscModalDataDiv ng-if=\"Modal.IFSCsearchResult.length && (Modal.ifsccode || (Modal.bankName && Modal.cityName))\"><table class=\"table table-striped table-responsive rwd-table\" style=\"overflow-x: auto\"><thead><tr><th>Bank Name</th><th>Branch City</th><th>IFSC Code</th><th>Branch Location</th><th>State</th></tr></thead><tbody><tr ng-repeat=\"item in Modal.IFSCsearchResult\"><td data-th=\"Bank Name\" class=alignBankNameIfsc><input type=radio name=switch-radio1 ng-change=Modal.selectBank(item) ng-model=Modal.selectdIFSC checked value=0 ng-value=item> {{item.bankName}}</td><td data-th=\"Branch City\">{{item.branchCity}}</td><td data-th=\"IFSC Code\">{{item.ifscCode}}</td><td data-th=\"Branch Location\">{{item.branchLocation}}</td><td data-th=State>{{item.state}}</td></tr></tbody></table><div class=\"form-footer form-content margin-ifsc-modal-footer\"><button class=\"btn btn-primary-action common-btn-padding\" ng-click=Modal.submitIFSC() value=Select ng-disabled=\"!Modal.selectdIFSC || Modal.pennyDropValidationError\">Select</button></div></div><div ng-if=\"Modal.searchIFSCCLicked && !Modal.IFSCsearchResult.length && (Modal.ifsccode || (Modal.bankName && Modal.cityName))\"><p class=no-result-ifsc>No Result Found</p></div></div></div>");
$templateCache.put("app/components/modal/IFSCSelectionNewJourney/ifsc-selection-new-journey.modal.html","<div class=modal-content id=ifsc-modal ng-init=Modal.init() style=\"width: 107%\" ng-class=\"{\'fromFolioCreationForJourneys\' : Modal.fromFolioCreationForJourneys}\"><div class=\"loader popup\"><span class=loading></span></div><!--<i class=\"times-icon\" ></i>--><div class=\"modal-head modal-before-none\"><h3>Search IFSC</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form name=IFSCForm novalidate><div class=row><div class=\"col-xs-12 col-sm-6 col-md-2\"><input type=radio name=forIfsc id=ifsc ng-checked=\"Modal.modeofifscsearch == \'IFSC\'\" ng-click=\"Modal.getIfscSerchMode(\'IFSC\')\"><label class=bankOptions for=ifsc style=\"margin-bottom: 15px\">IFSC</label></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><input type=radio name=forIfsc id=bankcityname ng-checked=\"Modal.modeofifscsearch == \'BANKNAME\'\" ng-click=\"Modal.getIfscSerchMode(\'BANKNAME\')\"><label class=bankOptions for=bankcityname>Bank Name & City</label></div></div><div class=\"form-content credentialNote\" ng-if=\"Modal.distributorDetails && Modal.distributorDetails.isHdfcBank\"><p>For new user folio creation restricted only to HDFC Bank..</p></div><div class=\"form-content credentialNote\" ng-if=\"Modal.modalData.bankName  && Modal.modalData.paymentMode != \'UAP\'\"><p>Select only {{Modal.modalData.bankName}} bank for E-mandate transaction.</p></div><div class=\"form-content credentialNote\" ng-if=\"Modal.modalData.bankName && Modal.modalData.paymentMode === \'UAP\'\"><p>Select only {{Modal.modalData.bankName}} bank for UPI Autopay transaction.</p></div><br><!-- IFSC --><div class=row ng-if=\"Modal.modeofifscsearch == \'IFSC\'\"><div class=col-md-5><p style=\"font-size: 10px;font-weight: bold\">Enter IFSC Code</p></div><div class=col-md-8><div class=\"input-select input-normal\" ng-if=Modal.showFieldifsc ng-class=\"{error:IFSCForm.ifsccode.$dirty && IFSCForm.ifsccode.$invalid}\"><input type=text class=form-control ng-model=Modal.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-maxlength=11 limit-to=11 ng-pattern=Modal.IFSC_REGEX capitalize required autofocus ng-change=Modal.clearBankField() style=\"border: 1px solid gray;\n              border-radius: 8px;\n              height: 40px\"> <span ng-show=\"IFSCForm.ifsccode.$dirty && IFSCForm.ifsccode.$invalid\"><span class=error-input style=\"position: relative\" ng-show=IFSCForm.ifsccode.$error.pattern ng-bind=Modal.APP_CONSTANT.IFSC_CODE_REGEX></span></span></div></div><div class=\"col-md-2 ifsc-search-action\"><button class=\"btn btn-primary-action\" ng-click=Modal.searchIFSC() value=Search ng-disabled=!Modal.ifsccode style=\"width: 130px;background-color: #244b8c;color: white\">Search</button></div></div><!-- BANK NAME --><div class=row ng-if=\"Modal.modeofifscsearch == \'BANKNAME\'\"><div class=col-md-4><p style=\"font-weight: bold;margin-bottom: 2px\">Bank Name</p><div class=selectfield ng-class=\"{error:IFSCForm.bankName.$dirty && IFSCForm.bankName.$invalid}\" ng-if=Modal.showFieldbank><select class=\"select-box selectNormal\" name=bankName ng-model=Modal.bankName ng-init=null ng-change=Modal.bankChange() ng-options=\"bank.bankName as bank.bankName for bank in Modal.bankList\" required style=\"border: 1px solid #9f9f9f;border-radius: 5px\"><option value selected>Bank Name</option></select></div></div><div class=col-md-4><p style=\"font-weight: bold;margin-bottom: 2px\">City Name</p><div class=selectfield><select class=\"select-box selectNormal\" name=city ng-model=Modal.cityName ng-options=\"city as city for city in Modal.cityList\" required ng-disabled=!Modal.bankName ng-class={enable:Modal.bankName} style=\"border: 1px solid #9f9f9f;border-radius: 5px\"><option value selected>Select City</option></select><span class=error-input ng-if=\"Modal.cityList && !Modal.cityList.length\" ng-bind=Modal.APP_CONSTANT.IFSC_MODAL_CITY_BLANK></span></div></div><div class=col-md-2><br><button class=\"btn btn-primary-action\" ng-click=Modal.searchIFSC() value=Search ng-disabled=\"!Modal.bankName || !Modal.cityName\" style=\"width: 130px;background-color: #244b8c;color: white; margin-top: 10px\">Search</button></div></div></form><!-- Show data --><div class=ifscModalDataDiv ng-if=\"Modal.IFSCsearchResult.length && (Modal.ifsccode || (Modal.bankName && Modal.cityName))\"><table class=\"table table-responsive rwd-table\" style=\"overflow-x: auto\"><thead><tr><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\">Bank Name</th><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\">IFSC Code</th><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\">State</th><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\">City</th><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\">Branch Location</th><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\"></th></tr></thead><tbody><tr ng-repeat=\"item in Modal.IFSCsearchResult\"><td data-th=\"Bank Name\" class=alignBankNameIfsc><!-- <input type=\"radio\" name=\"switch-radio1\" ng-model=\"Modal.selectdIFSC\" checked=\"\" value=\"0\" ng-value=\"item\" > --> {{item.bankName}}</td><td data-th=\"IFSC Code\">{{item.ifscCode}}</td><td data-th=State>{{item.state}}</td><td data-th=\"Branch City\">{{item.branchCity}}</td><td data-th=\"Branch Location\">{{item.branchLocation}}</td><td><p ng-click=Modal.submitIFSC(item) value=Select style=\"width: 100px;color: #244b8c;background-color: white;border: 1px solid #244b8c;height: 30px;border-radius: 15px;padding: 2px;text-align: center\">SELECT</p></td></tr></tbody></table><div class=\"form-footer form-content margin-ifsc-modal-footer\"></div></div><div ng-if=\"Modal.modalData.bankName && Modal.emandateBank\" class=\"form-content credentialNote\"><p>Select only {{Modal.modalData.bankName}} bank.</p></div><div ng-if=\"Modal.searchIFSCCLicked && !Modal.IFSCsearchResult.length && (Modal.ifsccode || (Modal.bankName && Modal.cityName))\"><p class=no-result-ifsc>No Result Found</p></div></div></div><style>input[type=\"radio\"] {\n            display: none;\n        }\n\n        label {\n            position: relative;\n        }\n\n\n        label.bankOptions::before {\n            content: \"\";\n            border: 1px solid #222;\n            display: inline-block;\n            width: 25px;\n            height: 25px;\n            margin: -8px 10px;\n            margin-left: 0;\n            border-radius: 50%;\n        }\n        label.bankOptions::after {\n            content: \"\";\n            display: inline-block;\n            position: absolute;\n            width: 15px;\n            height: 15px;\n            left: 5px;\n            top: 8px;\n            margin: -8px 20px;\n            margin-left: 0;\n            border-radius: 50%;\n            transition: all 0.4s;\n        }\n        input[type=\"radio\"]:checked+label::after {\n            background: #ff8486;\n        }\n        input[type=\"radio\"]:checked+label::before {\n            border: 1px solid #ff8486;\n        }\n        .credentialNote{\n          padding: 15px;\n          background:linen;\n          border-radius: 8px;\n          margin-top: 12px;\n          font-weight: 500;\n          text-align: center;\n        }</style>");
$templateCache.put("app/components/modal/addJointHolder/addJointHolder.modal.html","<div class=\"thirdholderPopup nriHolderPopup\"><div class=head><p><b>Add Third Holder</b></p><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=body><form class=verification-form autocomplete=off name=holderPanVerificationForm style=margin:30px ng-submit=Modal.submit() novalidate><!-- PAN input --><div class=row><div class=\"col-xs-12 col-md-12\"><div class=tax-status-container><label class=s-label>Tax Status</label><div class=tax-field-container><div class=flex-check><input class=nomineeCheckbox type=radio id=resident-tax-status name=tax-status ng-value=true ng-model=Modal.formData.taxStatusResident ng-change=Modal.changedRiNriTaxStatus()><label for=resident-tax-status class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\">{{Modal.appConstants.TAX_STATUS_INDIVIDUAL.RESIDENT_INDIVIDUAL}}</label></div><div class=flex-check><input class=nomineeCheckbox type=radio id=tax-status name=tax-status ng-value=false ng-model=Modal.formData.taxStatusResident ng-change=Modal.changedRiNriTaxStatus()><label for=tax-status class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\" class=show-on-desktop>{{Modal.appConstants.TAX_STATUS_INDIVIDUAL.NON_RESIDENT_INDIVIDUAL}}</label><label style=\"margin-top: 5px\" class=show-on-mobile>{{Modal.appConstants.TAX_STATUS_INDIVIDUAL.NRI_ON_MOBILE}}</label></div></div></div></div><div class=col-md-3></div></div><div class=row style=\"margin-top: 20px;\n          text-align: left\"><div class=\"col-xs-12 col-md-12\"><div class=pan-input-container><label for=pan><b>PAN</b></label><input class=form-control id=pan style=\"height: 40px;width:100%; margin-top: 12px\" tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=Modal.holderData.pan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-change=Modal.resetValues() ng-blur=Modal.checkPanEmailExist() capitalize required easyassist-key=mask-element> <span ng-show=\"holderPanVerificationForm.pan.$dirty && holderPanVerificationForm.pan.$invalid\"><span class=error-input ng-show=holderPanVerificationForm.pan.$error.required ng-bind=Modal.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=holderPanVerificationForm.pan.$error.maxlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=holderPanVerificationForm.pan.$error.pattern ng-bind=Modal.validateData.PAN_FIELD></span> </span><span style=\"display: inline-block; margin-top: 20px\" class=error-input ng-if=Modal.panMessage ng-bind-html=Modal.panMessage></span></div></div></div><br><!-- Eamil Add --><div ng-if=Modal.showEmail class=\"input-select input-normal\"><div class=row style=\"margin-top: 20px;\n        text-align: left\"><div class=\"col-xs-12 col-md-8\"><p><b>Email</b></p></div><div class=\"col-xs-12 col-md-12\" style=\"margin-top: 12px\"><div style=\"display: flex;align-items: center\"><input type=email name=email ng-model=Modal.holderData.email required style=\"border-radius: 4px;\n              border: 1px solid #242424\"></div><span ng-if=!Modal.holderData.email style=\"color: red\">Email filed required!</span></div><div class=\"col-xs-12 col-md-12 kyc-verify\"><button type=button class=btn-holder ng-disabled=!Modal.holderData.email style=\"margin: 12px;width: 275px\" ng-click=Modal.AddEmailToHolderPan()>Add Email</button></div></div></div><!-- OTP --><div ng-if=Modal.showOtp><div><div class=row style=\"margin-top: 20px;\n          text-align: left\"><div class=\"col-xs-12 col-md-8\"><p><b>Verify OTP</b></p></div><div class=\"col-xs-12 col-md-12\" style=\"margin-top: 12px\"><input class=form-control type=text minlength=6 maxlength=6 name=otp ng-model=Modal.Otp required></div><div class=\"col-xs-12 col-md-12 kyc-verify\"><button type=button class=\"btn-holder btn-primary-action-pay\" ng-click=Modal.verifyOtp() style=\"margin: 12px;width: 275px\" ng-disabled=!Modal.Otp>Verify</button></div><div class=\"col-xs-12 col-md-12 kyc-verify\"><button type=button class=btn-holder ng-click=Modal.reGenerateOtp() style=\"margin: 12px;width: 275px\">Resend OTP</button></div></div></div></div><br><!-- Verify Button --><div class=kyc-verify style=\"padding-bottom: 40px\"><button tabindex=3 style=\"width: 60%;height: 42px\" type=submit class=\"btn hdfc-blue-cta-small btn-primary-action-pay\" ng-disabled=\"holderPanVerificationForm.pan.$invalid ||\n    !Modal.processFlag ||\n    !Modal.AllowedJointHolder\" ng-click=Modal.verifyOrAddHolder3()>VERIFY</button><br></div></form></div></div><style>.modal-content {\n    width: 460px;\n  }\n\n  b {\n    font-weight: bold;\n  }\n\n  @media screen and (max-width: 750px) {\n    .modal-content {\n      width: 90%;\n      margin-left: 5%;\n      margin-right: 5%;\n    }\n  }\n  @media only screen and (max-width: 1000px ){\n  .btn-primary-action-pay {\n    width: 150px !important;\n  }\n}\n  .hdfc-blue-cta-small:disabled{\n    background-color: #FF8486;\n        color: white;\n}\n  .btn-primary-action-pay {\n         width: 163px;\n         height: 35px;\n         border-color: transparent;\n         background-color: #FF8486;\n        border-radius: 50px !important;\n          line-height: 1.4 !important;\n           color: #ffffff;\n        padding: 6px 25px !important;\n        padding: 10px 10px 10px 10px;\n    border-radius: 45px;\n    margin-left: 5px;\n     }\n\n  a {\n    text-decoration: underline !important;\n    color: #103880;\n  }</style>");
$templateCache.put("app/components/modal/addLinkPan/addLinkPan.modal.html","<!-- Enter Pan Popup --><div class=modal-content ng-if=\"Modal.STEPS ==\'GET_PAN_MOBILE\'\" id=enter-pan><div class=modal-header><h4 class=modal-title>Add Account</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content><form autocomplete=off class=addPan-form name=addPanForm novalidate ng-submit=Modal.checkPanVerification()><div class=\"normal-wrap clearfix\"><div class=sip-form-box><div class=row><div><!-- Pan --><div class=form-group><label><b>Enter PAN</b></label><div class=input-select><input class=form-control id=addPan tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=Modal.newLinkedPanPayload.pan ng-pattern=/^[A-Z]{3}[P,H][A-Z][0-9]{4}[A-Z]$/ ng-change=Modal.resetValues() placeholder=Eg.ABCDE1234A autofocus capitalize required easyassist-key=mask-element> <span ng-show=\"addPanForm.pan.$dirty && addPanForm.pan.$invalid\"><span class=mod-error-msg ng-show=addPanForm.pan.$error.required ng-bind=Modal.validateData.PAN_REQUIRED></span> <span class=mod-error-msg ng-show=addPanForm.pan.$error.maxlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=mod-error-msg ng-show=addPanForm.pan.$error.pattern ng-bind=Modal.validateData.PAN_FIELD></span></span></div></div><!-- Mobile --><div class=form-group><label><b>Enter Mobile Number</b></label><div class=input-select><input class=form-control id=mobile tabindex=2 type=text name=mobileNumber ng-model=Modal.newLinkedPanPayload.mobile ng-change=Modal.resetErrorms() placeholder=\"10-digit mobile number\" required easyassist-key=mask-element onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" maxlength=10 minlength=10> <span ng-show=\"addPanForm.mobileNumber.$dirty && addPanForm.mobileNumber.$invalid\"><span class=mod-error-msg ng-show=addPanForm.mobileNumber.$error.required ng-bind=Modal.validateData.MOBILE_FIELD></span></span></div></div><div class=form-group><span class=mod-error-msg ng-if=Modal.panMessage ng-bind=Modal.panMessage></span></div><!-- Button --><div><button class=wBtn type=submit style=\"padding: 0px !important;text-transform: none;font-size: 16px !important;width: 100%\" ng-disabled=\"!Modal.newLinkedPanPayload.pan || !Modal.newLinkedPanPayload.mobile || Modal.panMessage\">Proceed</button></div><br><br></div></div></div></div></form></div></div></div><!-- List of Folio --><div class=modal-content ng-if=\"Modal.STEPS ==\'SELCT_FOLIO\'\"><div class=modal-header><h4 class=modal-title>Select Folio</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content><div><p>OTP will be sent on selected folio registered email ID & mobile number for linking external PAN</p></div><br><div style=\"max-height: 302px; overflow: auto\"><div class=folioBox ng-repeat=\"x in Modal.FolioList track by $index\"><div style=\"margin: 0px 10px 0px 15px\"><input type=radio name=folioNumber ng-model=Modal.folioNumber value={{x.folioNumber}}></div><div><p style=\"font-size: 14px;font-weight: 500;line-height: 26px;text-align: left\">{{x.maskedFolioNumber}}</p><p style=\"font-size: 9px;font-weight: 300;line-height: 12px;text-align: left\">{{x.maskedMobile}} | {{x.maskedEmail}}</p></div></div></div><br><!-- Button --><div><button class=wBtn ng-click=Modal.sendOtp() style=\"padding: 0px !important;text-transform: none;font-size: 16px !important;width: 100%\" ng-disabled=!Modal.folioNumber>Proceed</button></div><br></div></div></div><!-- OTP verify Popup --><div class=modal-content ng-if=\"Modal.STEPS ==\'VERIFY_OTP\'\" id=enter-pan><div class=modal-header><h4 class=modal-title>Verify OTP</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content><form autocomplete=off class=addPan-form name=panOtpVerifyForm novalidate><div class=\"normal-wrap clearfix\"><div class=sip-form-box><div class=row><div><div class=form-group style=\"margin: 5px\"><label>{{Modal.otpMessage}}</label><div class=\"input-select input-normal\" style=\"margin-bottom: 0px\"><!-- OTP code Start--><div class=otp-input-container><div class=input-code><div class=input-otp-box style=\"display: flex\"><input type=tel id=otp-number-input-1 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp1 is-number autofocus easyassist-key=mask-element style=\"border: none !important;\n                                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"> <input type=tel id=otp-number-input-2 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp2 is-number easyassist-key=mask-element style=\"border: none !important;\n                                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"> <input type=tel id=otp-number-input-3 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp3 is-number easyassist-key=mask-element style=\"border: none !important;\n                                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"> <input type=tel id=otp-number-input-4 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp4 is-number easyassist-key=mask-element style=\"border: none !important;\n                                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"> <input type=tel id=otp-number-input-5 class=otp-number-box minlength=1 tabindex=5 onpaste=handlePaste(event) maxlength=1 autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp5 is-number easyassist-key=mask-element style=\"border: none !important;\n                                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"> <input type=tel id=otp-number-input-6 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp6 is-number easyassist-key=mask-element style=\"border: none !important;\n                                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"></div></div></div></div><!-- OTP code End --><!-- Resend OTP --><div style=\"float: right;margin: 10px 0px 10px 0px\"><span class=forgot><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd style=\"font-size: 11px\">Resend OTP in 00:{{countdown}}s</span><div><span class=inputTxt style=\"font-size: 11px\"><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Modal.resendOTP()>Resend OTP</a></span></div></timer></span></div><br><div class=btnDiv><button class=wBtnTwo ng-click=Modal.verifyotp() type=button ng-disabled=\"!Modal.otp1 || !Modal.otp2 || !Modal.otp3 || !Modal.otp4 || !Modal.otp5 || !Modal.otp6\" style=\"padding: 0px !important;text-transform: none;font-size: 16px !important;width: 100%\">Verify OTP</button></div><br></div></div></div></div></div></form></div></div></div><style>.modal-dialog{ \n      width: 500px; \n    }\n    .modal-content .modal-body{\n      border-radius: 24px;\n      padding-bottom: 0px !important;\n      padding-top: 25px !important;\n    }\n    .proceedButton{\n      color: white !important;\n      margin-top: 20px !important;\n        margin-right: 0.5rem; \n        padding: 15px 25px !important;\n        border-radius: 50px;\n        font-size: 11px !important;\n        font-weight: 500;\n        font-family: Poppins;\n        font-style: normal;\n        line-height: 0.82;\n        letter-spacing: normal; \n        text-transform: uppercase;\n        box-shadow: none;\n        background: linear-gradient(93.92deg, #058DC8 -7.52%, #1B4B86 99.94%) !important;   \n        width: 100% !important;\n    }\n\n    .wBtn:after {\n      content: url(\'../../../assets/images/arrow-white-small.svg\');\n    }\n    .wBtn:disabled {\n      opacity: 60% !important;\n      background: linear-gradient(94deg, #cdd7e3 -21.18%, #c3cfde 95.94%);\n      cursor: not-allowed;\n    }\n    .wBtnTwo {\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border: none;\n    color: white;\n    width: 300px;\n    height: 48px;\n    text-align: center;\n    text-transform: none !important;\n    padding: 0px !important;\n    align-items: center;\n    font-size: 16px !important;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 100px;\n    transition: background-color 0.3s;\n  }\n  .wBtnTwo:disabled {\n    cursor: not-allowed;\n    opacity: 60%;\n  }\n\n    .modal-content .modal-header:before {\n      background: white;\n    }\n    .form-control{    \n      border-bottom: none;\n      border: 1px solid gray;\n      border-radius: 100px;\n      height: 48px;\n      margin: 10px 0px 0px 0px;\n      padding: 0px 0px 0px 15px;\n    }\n    input:focus{\n      border: 1px solid gray !important;\n    }\n    .folioBox {\n    display: flex;\n    /* width: 349px; */\n    min-height: 50px;\n    border: 1px solid #d3d2d2;\n    border-radius: 10px;\n    margin: 10px 0px 10px 0px;\n    padding-top: 3px;\n  }\n  .modal-content{\n    border-radius: 26px;\n  }</style><script>// const $inp = $(\".otp-number-box\");\n$(\".otp-number-box\").on({\n    paste(ev) { // Handle Pasting \n      const clip = ev.originalEvent.clipboardData.getData(\'text\').trim();\n      // Allow numbers only\n      if (!/\\d{6}/.test(clip)) return ev.preventDefault(); // Invalid. Exit here\n      // Split string to Array or characters\n      const s = [...clip];\n      // Populate inputs. Focus last input.\n      $(\".otp-number-box\").val(i => s[i]).eq(5).focus();\n    } \n  }); \n  function handlePaste(event){ \n     const clipboardData = event.clipboardData || window.clipboardData; \n     const pastedData = clipboardData.getData(\'Text\');\n     otpData = parseInt(pastedData); \n    const otpPattern = new RegExp(\"^[0-9]\");  \n    validOTP =  otpPattern.test(otpData); \n    if (!validOTP || pastedData && pastedData.length >6) return; \n    //  only proceed if pasted data is exacly 6 digits \n    if(pastedData && pastedData.length && pastedData != \"\" ){ \n        var scope = angular.element(document.body).injector().get(\'$rootScope\');\n        scope.otpPasteInVariable(pastedData); \n        if(/^\\d{6}$/.test(pastedData)) {\n          const inputs = document.querySelectorAll(\'.input-otp-box input\');\n          inputs.forEach((input, index) => {\n            input.value = pastedData[index] || \'\';\n          }); \n          //  Focus the last input field after pasting\n          event.preventDefault(); \n        }\n    } \n  }</script>");
$templateCache.put("app/components/modal/arnAddBank/arnaddbank.modal.html","<div class=modal-content id=folio-success><i class=times-icon ng-click=Modal.dismissModal();></i><div><form class=\"main-section modal-padding clearfix modifyBank\" name=AddBankForm id=AddBankForm><h5 class=screen-title>Add New Bank</h5><!--\n        <p class=\"breadcrumbs\">\n          <span class=\"text-primary cursor-pointer\" ui-sref=\"main.profile.folioDetails\">Folio Details </span><i\n          class=\"breadcrumb-icon\"></i><span> Add Bank</span>\n        </p> --><div class=folio-addbank><strong>Folio : </strong><span>{{Modal.modalData.folioNumber}}</span></div><div class=content-area><p class=\"col-md-12 form-title\"><strong>Provide New Bank Details</strong></p><div class=col-md-12><div class=row><div class=col-md-4><div class=input-normal><input type=text ng-model=Modal.payload.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-disabled=Modal.disableAccntDetails ng-pattern=Modal.IFSC_REGEX capitalize required readonly> <span class=highlight></span> <span class=bar></span> <span class=\"glyphicon glyphicon-search\" ng-click=Modal.selectIFSC()></span><label ng-class={ifscBlank:!Modal.payload.ifsccode}>IFSC Code <span class=\"req text-red\">*</span></label><span ng-show=\"Modal.ifsccode.$dirty && Modal.ifsccode.$invalid\"><span class=error-input ng-show=Modal.ifsccode.$error.required ng-bind=Modal.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=Modal.ifsccode.$error.pattern ng-bind=Modal.validateData.IFSC_CODE_REGEX></span></span></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:AddBankForm.bankName.$dirty && AddBankForm.bankName.$invalid}\"><input type=text ng-model=Modal.payload.bankName name=bankName required ng-disabled=!Modal.selectedBank ng-class={enable:Modal.selectedBank} ng-readonly=Modal.selectedBank> <span class=highlight></span> <span class=bar></span><label>Bank Name<span class=\"req text-red\">*</span></label></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=selectfield ng-class=\"{error:AddBankForm.accountType.$dirty && AddBankForm.accountType.$invalid}\"><select class=select-box name=accountType ng-model=Modal.payload.accountType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Modal.bankTypeList\" required ng-disabled=!Modal.payload.ifsccode ng-class={disablefield:!Modal.payload.ifsccode}><option value=\"\" selected>Account Type</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=AddBankForm.accountType.$error ng-show=AddBankForm.accountType.$dirty><span ng-message=required ng-bind=Modal.validateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row><div class=\"col-md-4 col-md-offset-1\"><div class=input-normal ng-class=\"{error:AddBankForm.branchLocation.$dirty && AddBankForm.branchLocation.$invalid}\"><input type=text ng-model=Modal.payload.bankBranch maxlength=40 name=branchLocation required autocomplete=off capitalize ng-disabled=!Modal.payload.ifsccode ng-class={enable:Modal.payload.bankBranch}> <span class=highlight></span> <span class=bar></span><label>Branch Location <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.branchLocation.$dirty && AddBankForm.branchLocation.$invalid\"><span class=error-input ng-show=AddBankForm.branchLocation.$error.required ng-bind=Modal.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=input-normal ng-class=\"{error:AddBankForm.branchCity.$dirty && AddBankForm.branchCity.$invalid}\"><input type=text ng-model=Modal.payload.bankCity name=branchCity only-alphabets autocomplete=off capitalize required ng-disabled=!Modal.payload.ifsccode ng-class={enable:Modal.payload.bankCity}> <span class=highlight></span> <span class=bar></span><label>Branch City <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.branchCity.$dirty && AddBankForm.branchCity.$invalid\"><span class=error-input ng-show=AddBankForm.branchCity.$error.required ng-bind=Modal.validateData.CITY_REQUIRED></span></span></div></div><div class=col-md-4><div class=selectfield ng-class=\"{error:AddBankForm.payoutMechanism.$dirty && AddBankForm.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select\" name=payoutMechanism ng-model=Modal.payload.payoutMechanism ng-options=\"_type.payoutCode as _type.payoutDescription for _type in Modal.payoutMechanismList\" required ng-disabled=!Modal.payload.ifsccode ng-class={disablefield:!Modal.payload.ifsccode} ng-readonly=\"\"><option value=\"\" selected>Payout Mechanism</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=AddBankForm.payoutMechanism.$error ng-show=AddBankForm.payoutMechanism.$dirty><span ng-message=required ng-bind=Modal.validateData.PAYOUT_MECH_REQUIRED></span></span></div></div></div><div class=row><div class=\"col-md-4 col-md-offset-1\"><div class=input-normal><input type=text ng-model=Modal.payload.accountNumber easyassist-key=mask-element onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-maxlength=20 maxlength=20 name=accountNumber limit-to=20 ng-disabled=!Modal.payload.ifsccode ng-class={enable:Modal.payload.ifsccode} required autocomplete=off directive.mask ng-change=Modal.accFocus(); capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number <span class=\"req text-red\">*</span></label><span ng-show=Modal.accModelDirty><span class=error-input ng-show=AddBankForm.accountNumber.$error.required ng-bind=Modal.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(Modal.payload.accountNumber.split(\'\').length !=0 && Modal.payload.accountNumber.split(\'\').length<1)\" ng-bind=Modal.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=input-normal ng-class=\"{error:AddBankForm.verifyAccountNumber.$dirty && AddBankForm.verifyAccountNumber.$invalid}\"><input type=text ng-model=Modal.verifyAccountNumber easyassist-key=mask-element ng-maxlength=20 maxlength=20 name=verifyAccountNumber limit-to=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=Modal.payload.accountNumber required autocomplete=off ng-keydown=Modal.copyPasteHandler($event) capitalize ng-disabled=!Modal.payload.ifsccode ng-class={enable:Modal.payload.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Verify Account Number <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.verifyAccountNumber.$dirty && AddBankForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=AddBankForm.verifyAccountNumber.$error.required ng-bind=Modal.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"AddBankForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\" ng-bind=Modal.validateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"AddBankForm.verifyAccountNumber.$error.pattern\n                  && !AddBankForm.verifyAccountNumber.$error.maxlength && !AddBankForm.verifyAccountNumber.$error.required\">{{Modal.validateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div><div class=row><div class=\"col-md-12 mark-default\"><div class=checkbox><input type=checkbox ng-model=Modal.payload.makeDefaultBank> <i class=icon-checkbox></i> <span class=checkbox-text>Make it a default bank for this folio</span></div></div></div><ng-bind-html dynamic=Modal.note></ng-bind-html><ng-bind-html dynamic=Modal.noteBankRestrict></ng-bind-html><div class=\"row upload-some\"><span class=leaf-label>Upload Old Bank Proof <span class=\"req text-red\">*</span> <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Upload cheque leaf of old bank to validate bank details. \"></i></span><p class=upload-data><span class=grey-text>Bank Name : </span><span>{{Modal.defaultBank[0].bankName}}</span></p><div><input type=file name=pic accept=image/* file-model-profile=Modal.chequeLeafOld enctype=multipart/form-data upload=Modal.uploadChequeLeafFileOld(file) ng-model=Modal.bankDetails.chequeLeafOld><div class=file-upload><!-- <button>Choose File</button>\n                  <span ng-if=\"Modal.chooseAFileOld\">No File Chosen</span> --> <span ng-click=Modal.openUploadedDocOld()>{{Modal.bankDetails.chequeLeafOld}}</span></div></div></div><div class=\"row upload-some\" ng-if=!Modal.payload.pennyDropValid><span class=leaf-label>Upload New Bank Proof <span class=\"req text-red\">*</span> <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Upload cheque leaf of new bank to validate bank details. \"></i></span><div><input id=uploadCheckLeafNew type=file name=pic accept=image/* file-model-profile=Modal.chequeLeafNew upload=\"Modal.uploadChequeLeafFile(file,\'add\')\" ng-model=Modal.bankDetails.chequeLeaf><div class=file-upload><!-- <button>Choose File</button> --><!-- <span ng-if=\"Modal.chooseAFileNew\">No File Chosen</span> --> <span ng-click=Modal.openUploadedDoc()>{{Modal.bankDetails.chequeLeaf}}</span></div></div></div></div><div class=tc-block ng-if=Modal.showTerms><div><div class=checkbox><input ng-model=Modal.isCheckedCobmTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=Modal.showCobmTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment.</span></div></div></div><div class=\"form-footer col-md-12\"><span class=pull-right><input type=button value=Cancel ng-click=Modal.dismissModal() class=\"btn btn-primary-action common-btn-padding nomargin\"> <input type=submit value=Submit ng-if=!Modal.payload.pennyDropValid class=\"btn btn-primary-action common-btn-padding nomargin\" ng-disabled=\"AddBankForm.$invalid || !Modal.bankDetails.chequeLeaf || !Modal.bankDetails.chequeLeafOld || !Modal.isCheckedCobmTandC\" ng-click=Modal.addBankSubmit()> <input type=submit value=Validate ng-if=Modal.payload.pennyDropValid class=\"btn btn-primary-action common-btn-padding nomargin\" ng-disabled=\"AddBankForm.$invalid || !Modal.bankDetails.chequeLeafOld || !Modal.isCheckedCobmTandC\" ng-click=Modal.validatePennyDropDetails()></span></div></div><style>.ifscBlank {\n            top:15px !important;\n          }</style></form></div></div><style>.modal-padding{\npadding: 30px;\n  }\n  .nomargin{\n    margin: 0px !important;\n  }\n  .input-normal input{\n    border-right: none !important;\n  }</style>");
$templateCache.put("app/components/modal/arnPopup/arnPopup.modal.html","<div class=modal-content ng-if=\"Modal.modalData.status == \'NOT_VERIFIEDNEW\' \"><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div><p>Your KYC is not completed. Click on Proceed button to complete E-KYC.</p></div><br><br><div class=text-center><!-- <p class=\"btn\" ng-click=\"Modal.closeModal()\">Cancel</p> --><p class=btn ng-click=Modal.ekyc()>Proceed</p></div></div></div><div class=modal-content ng-if=\"Modal.modalData.status == \'VERIFIEDNEW\' \"><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div><p>Dear Investor,</p><p>You have not started your investment journey with HDFC Mutual Fund. Please click on Proceed to begin your journey with us.</p></div><br><br><div class=text-center><p class=btn ng-click=Modal.closeModal()>Cancel</p><p class=btn ng-click=Modal.process()>Proceed</p></div></div></div><div class=modal-content ng-if=\"Modal.modalData.status == \'EMPTYBANKLIST\' || Modal.modalData.status ==\'HDFCBANKLIST\' \"><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div><p>Dear Investor,</p><p ng-if=\"Modal.modalData.status == \'EMPTYBANKLIST\'\">You do not have a folio with HDFC Bank registered in it. Please click on proceed to create new folio and register HDFC Bank.</p><p ng-if=\"Modal.modalData.status == \'HDFCBANKLIST\'\">Please create new folio to complete transaction.</p></div><br><br><div class=text-center><p class=btn ng-if=\"Modal.modalData.status == \'EMPTYBANKLIST\'\" ng-click=Modal.dismissModal()>Cancel</p><p class=btn ng-click=Modal.closeModal()><span ng-if=\"Modal.modalData.status == \'HDFCBANKLIST\'\">Create New Folio </span><span ng-if=\"Modal.modalData.status == \'EMPTYBANKLIST\'\">Proceed</span></p></div></div></div><div class=modal-content ng-if=\"Modal.modalData.status == \'EXISTINGUSER\'\"><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div><p>Dear Investor,</p><p>You have already created folio with HDFC bank.You want to create new addition folio with HDFC bank?</p></div><br><br><div class=text-center><p class=btn ng-click=Modal.addNewFolio()>New folio</p><p class=btn ng-click=Modal.home()>Home</p></div></div></div><style>.btn{\n    margin-right: 0.5rem;\n    background: rgb(253 92 94);\n    padding: 5px 25px !important;\n    border-radius: 50px;\n    font-size: 11px !important;\n    font-weight: 500;\n    font-family: Poppins;\n    font-style: normal;\n    line-height: 0.82;\n    letter-spacing: normal;\n    border: none;\n    color: #FFFFFF;\n    width: 150px;  \n    box-shadow: none;\n  }\n  @media only screen and (max-width: 450px)  and (min-width: 346px) {\n    .btn{\n      width: 45%;\n    }\n    }\n    @media only screen and (max-width: 345px) {\n    .btn{\n      width: 80%;\n      margin:5px;\n    }\n    }</style>");
$templateCache.put("app/components/modal/basketSipInstallmentDetails/basketSipInstallmentDetails.modal.html","<div class=\"modal-content SipInstallmentBasketModal\" id=SipInstallment-popUp><div class=modal-head><h3>Installment Detail</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body ng-scope\"><div class=set-margin-bottom-30><label class=header-title>Installment Frequency</label><input class=\"anything-disabled frequency\" type=text name=frequency id=frequency ng-model=Modal.installmentFrequency disabled></div><div class=dates-container><div class=start-data><label class=header-title>SIP Start Date</label><div ng-if=!Modal.isReseting class=set-margin-10><div class=\"input-select input-normal input-group date date-picker Modal.cal\" ng-class=\"{error:Modal.tForm.startDate.$dirty && Modal.tForm.startDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode={{Modal.viewMode}} data-date-default=Modal.formData.startDate data-enabled-dates=Modal.enabledStartDatesList data-min-date=Modal.startMinDateBiller data-max-date=Modal.startMaxDate data-on-date-change=Modal.changeStartDate id=startDate-EC data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"Select Date\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Modal.tForm.startDate.$error.required ng-bind=Modal.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div></div><div class=end-date><label class=header-title>SIP End Date</label><input class=\"anything-disabled set-margin-10\" type=text name=endDate id=endDate ng-model=Modal.endDate disabled></div></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.proceedToFolioCreation()>Proceed</button></div></div></div><style></style>");
$templateCache.put("app/components/modal/cancelMandate/cancelMandate.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><ng-bind-html dynamic=Modal.modalData.dynamicData.content></ng-bind-html><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/cancelNominee/cancelNominee.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope\"><div class=cancel-nominee-modal><div class=cancel-msg>{{Modal.modalData.message}}</div><div class=tc-block><h6>Terms & Conditions</h6><div class=checkbox><input type=checkbox name=TnC ng-model=Modal.tandcCheck ng-click=Modal.tncCheck() required style=\"width: 6%\"> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> cancellation of nomination</span></div></div><br><br><div class=\"text-center modal-multiple-action\"><button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>Cancel</button> <button class=\"btn btn-primary-action\" ng-disabled=!Modal.tandcCheck ng-click=Modal.closeModal()>OK</button></div></div></div></div>");
$templateCache.put("app/components/modal/cancelSIP/cancelSIP.modal.html","<div class=modal-content id=changeDividend-popUp><div class=loader style=\"position: absolute\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body ng-scope\"><div class=\"text-center want-dividend\"><p>Do you want to cancel the SIP Investment?</p></div><div class=important-change><p class=imp-head>Important:</p><p class=imp-des>It takes 10 working days for the cancellation to be effective. Thus, If a SIP installment is due within 10 working days from the date of cancelletion, that installment will be processed and your bank account will be debited for the SIP installment.</p></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.cancelTransaction(Modal.id,Modal.type);>Confirm</button></div></div></div>");
$templateCache.put("app/components/modal/cancelSIP/cancelSipSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=initiateTransactionMsg><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div><i class=verify-icon></i></div><p>Your Request for Cancellation of SIP Investment has been successfully sent. The status for the same will be updated within few hours.</p><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.dismissModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/cancelSIP/childrenFundMessage.modal.html","<div class=modal-content id=forgot-success><div class=\"loader popup\"><span class=loading></span></div><div><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p class=text-center>{{Modal.modalData.message}}</p><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>Cancel</button> <button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>Confirm</button></div></div></div>");
$templateCache.put("app/components/modal/changeDividend/changeDividend.modal.html","<div class=modal-content id=changeDividend-popUp><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body ng-scope\"><div class=\"text-center want-dividend\"><p>{{Modal.modalData.text}}</p></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal();>Confirm</button></div></div></div>");
$templateCache.put("app/components/modal/changeDividend/changeDividendSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=changeDividend-success><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><p class=text-center><i class=verify-icon></i></p><p class=\"text-center changeDividend-message\"><!--Your Dividend change request for <span class=\"strong\"> \"{{Modal.schemeName}}\" </span> <br />has been successfully sent--> Your request for change in IDCW options has been received successfully.</p><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/changeDividend/offlineUserMsg.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope\"><div class=text-center><div class=Bot-Modal-Text>You have not yet registered for HDFC MFOnline services. Kindly use \'Transaction Bot\' on our HDFC FUND website to update your contact details for respective folio.<br>To register for HDFC MFOnline services, create \'User ID\' with same folio.</div></div><br><br><div class=text-center><button class=\"btn btn-primary-action\" id=modal_close ng-click=Modal.closeModal()><a style=\"color: #fff\" href={{Modal.HDFC_API.WEBSITE_LINK}} target=_blank>Update via Transaction Bot</a></button><div class=bot-container><img id=bot_img src=assets/images/chat.gif alt=chat-bot></div></div></div></div><style>#modal_close{padding: 10px 35px;position: relative;}\n  #bot_img{position: absolute;height: 100px;top: 85px;right:78px;}</style>");
$templateCache.put("app/components/modal/confirmCancel/confirm-cancel-ecart.modal.html","<div class=modal-content><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation ecart-remove-modal\"><div class=text-center><p ng-bind-html=Modal.modalData.message style=\"font-size: 14px !important\"></p></div><br><br><div class=text-center><button class=\"btn-ecart btn-primary-action\" ng-click=Modal.closeModal()>Yes</button> <button class=\"btn-ecart btn-secondary-action\" autofocus ng-click=Modal.dismissModal()>No</button></div></div></div>");
$templateCache.put("app/components/modal/confirmCancel/confirm-cancel-prelogin.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div class=text-center>{{ Modal.modalData.Text }}</div><br><br><div class=\"modal-multiple-action text-center\"><button class=btn-secondary-action autofocus ng-click=Modal.dismissModal() ng-if=!Modal.buttonCancel>No</button> <button class=btn-primary-action ng-click=Modal.closeModal() ng-if=!Modal.buttonProceed>Yes</button></div></div></div><style>.btn-primary-action{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    /* border-radius: 100px !important; */\n  }\n  .btn-secondary-action{\n    border: 1px solid #1B4B8666 !important;\n  }</style>");
$templateCache.put("app/components/modal/confirmCancel/confirm-cancel.modal.html","<div class=modal-content ng-if=!Modal.modalData.isModifySipEnabled><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div style=\"line-height: 1.5\"><p ng-bind-html=Modal.modalData.message></p></div><br><br><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" ng-class=\"{\'basket-btn-secondary\': Modal.modalData.isBasketJourney}\" autofocus ng-click=Modal.dismissModal() ng-if=!Modal.buttonCancel>No</button> <button class=\"btn btn-primary-action\" ng-class=\"{\'basket-btn-primary\': Modal.modalData.isBasketJourney}\" ng-click=Modal.closeModal() ng-if=!Modal.buttonProceed>Yes</button> <button class=\"btn btn-secondary-action\" autofocus ng-click=\"Modal.closeSipModal(\'cancel\')\" ng-if=\"Modal.buttonCancel && Modal.modalData.transactionType === \'SIP\'\">Cancel SIP</button> <button class=\"btn btn-secondary-action\" autofocus ng-click=\"Modal.closeSipModal(\'cancel\')\" ng-if=\"Modal.buttonCancel && Modal.modalData.transactionType === \'FLEXSIP\'\">Cancel Flex SIP</button> <button class=\"btn btn-secondary-action\" autofocus ng-click=\"Modal.closeSipModal(\'cancel\')\" ng-if=\"Modal.buttonCancel && Modal.modalData.transactionType === \'DREAMSIP\'\">Cancel DREAM SIP</button> <button class=\"btn btn-primary-action\" ng-click=Modal.closeSipModal() ng-if=Modal.buttonProceed>Stay Invested</button></div></div></div><div class=modal-content ng-if=Modal.modalData.isModifySipEnabled><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div><p>Hi {{Modal.modalData.investorName}},</p><p>{{Modal.modalData.heardAbout}}</p></div><br><div style=\"line-height: 1.5\"><p>{{Modal.modalData.modifySipText}}</p></div><br><br><div class=\"modal-multiple-action text-center modifyCTA\"><button class=\"btn btn-primary-action\" ng-click=\"Modal.modifySip(\'modify\')\" ng-if=Modal.buttonProceed>Modify SIP</button> <button class=\"btn btn-secondary-action\" autofocus ng-click=\"Modal.closeSipModal(\'cancel\')\" ng-if=Modal.buttonCancel>Proceed with Cancellation</button></div></div></div><style>.modifyCTA{\n    justify-content: space-around !important;\n  }\n  .modifyCTA > .btn{\n    width: 210px;\n  }\n\n  @media only screen and (max-width: 767px) {\n    .modifyCTA{\n      flex-direction: column;\n    }\n    .modifyCTA > .btn{\n      margin: 0px !important;\n    }\n  }</style>");
$templateCache.put("app/components/modal/confirmCancel/rejectionReason.modal.html","<div class=modal-content><div class=modal-head><h3 class=align-left>Reason for rejection</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body form-wrapper rejection-reason\"><div class=input-normal><input autocomplete=off type=text name=reason ng-model=Modal.reason required> <span class=highlight></span> <span class=bar></span><label ng-if=\"Modal.modalData.type!=\'folioRejection\' && Modal.modalData.type !==\'NominationRejection\'\">Please write the reason for rejecting investment..</label><label ng-if=\"Modal.modalData.type==\'folioRejection\'\">Please write the reason for rejecting folio..</label><label ng-if=\"Modal.modalData.type==\'bankRejection\' || Modal.modalData.type==\'NominationRejection\'\">Please write the reason for rejecting..</label><!-- Folio Approval--TODO: DO NOT DELETE--><!--<label>Please write the reason for rejectiong folio...</label>--> <span class=support-text ng-if=\"Modal.modalData.type !==\'NominationRejection\'\">This will be shared with your holder(s) to help you better.</span></div><div class=text-center><button type=button class=\"btn btn-primary-action\" ng-disabled=!Modal.reason ng-click=Modal.closeModal();>Ok</button></div></div></div>");
$templateCache.put("app/components/modal/confirmCancel/sip-corner-pause.modal.html","<div class=modal-content ng-if=!Modal.modalData.isModifySipEnabled><i class=times-icon ng-click=Modal.dismissModal(); ng-if=Modal.modalData.ButtonPause></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div ng-if=Modal.modalData.ButtonPause><p>Hi {{Modal.modalData.investorName}},</p><p>{{Modal.modalData.heardAbout}}</p><br></div><div style=\"line-height: 1.5\" ng-if=!Modal.modalData.ButtonPause><p ng-bind-html=Modal.modalData.message></p></div><div ng-if=Modal.modalData.ButtonPause><div class=modify-sip><p>{{Modal.modalData.pauseSipText}}</p><br><div class=\"text-center space-between d-flex sip-pause-cancel-other-container\"><button class=\"btn btn-primary-action\" ng-click=\"Modal.dismissSipModal(\'pause\')\" ng-if=\"Modal.buttonProceed && Modal.modalData.transactionType === \'DREAMSIP\'\">Pause DREAM SIP</button> <button class=\"btn btn-secondary-action\" autofocus ng-click=\"Modal.closeSipModal(\'cancel\')\" ng-if=Modal.buttonCancel>Proceed with Cancellation</button></div></div></div><br><br><div class=\"modal-multiple-action text-center\" ng-if=!Modal.modalData.ButtonPause><button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissModal() ng-if=!Modal.buttonCancel>No</button> <button class=\"btn btn-primary-action\" ng-click=Modal.closeModal() ng-if=!Modal.buttonProceed>Yes</button> <button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissSipModal() ng-if=Modal.buttonCancel>Cancel SIP</button> <button class=\"btn btn-primary-action\" ng-click=\"Modal.dismissSipModal(\'pause\')\" ng-if=Modal.buttonProceed>Pause SIP</button></div></div></div><div class=modal-content ng-if=Modal.modalData.isModifySipEnabled><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><p>Hi {{Modal.modalData.investorName}},</p><p>{{Modal.modalData.heardAbout}}</p><br><div class=pause-main-div><div class=modify-sip><p>{{Modal.modalData.modifySipText}}</p><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-primary-action\" ng-click=\"Modal.modifySip(\'modify\')\" ng-if=Modal.buttonProceed>Modify SIP</button></div></div><div class=line-separator-modify></div><div class=modify-sip><p>{{Modal.modalData.pauseSipText}}</p><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-primary-action\" ng-click=\"Modal.dismissSipModal(\'pause\')\" ng-if=Modal.buttonProceed>Pause SIP</button></div></div></div><div class=pause-main-div><div class=modify-sip><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissSipModal() ng-if=Modal.buttonCancel>Proceed with Cancellation</button></div></div></div><!--    <div class=\"modal-multiple-action text-center\">--><!--      <button class=\"btn btn-secondary-action\" autofocus ng-click=\"Modal.dismissModal()\" ng-if=\"!Modal.buttonCancel\">No</button>--><!--      <button class=\"btn btn-primary-action\" ng-click=\"Modal.closeModal()\"  ng-if=\"!Modal.buttonProceed\">Yes</button>--><!--      <button class=\"btn btn-secondary-action\" autofocus ng-click=\"Modal.dismissSipModal()\" ng-if=\"Modal.buttonCancel\">Cancel SIP</button>--><!--      <button class=\"btn btn-primary-action\" ng-click=\"Modal.dismissSipModal(\'pause\')\" ng-if=\"Modal.buttonProceed\">Pause SIP</button>--><!--    </div>--></div></div>");
$templateCache.put("app/components/modal/confirmLoginReg/confirmLogin.modal.html","<!-- Otp verification--><div class=modal-content id=confirm-login ng-init=Modal.init()><div class=\"loader called-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Two Factor Authentication</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body clearfix\"><form autocomplete=off name=ModalOtpForm ng-submit=Modal.verify() novalidate><!--<p style=\"margin-bottom:15px;\">--><!--As per reuirements of SEBI Cyber Security and Cyber Resilience Frameword circular CIR/MRD/DP/13/2015 dated 06 July 2015, two factor authentication is required by all users who connect using online--><!--internet facility.<br/>--><!--</p>--><p ng-bind=Modal.modalContent class=confirm-modal-text></p><div class=row style=\"margin:30px 0px\"><div class=col-md-12 ng-if=\"Modal.modalData.detail.loginType === \'OTP\'\"><div class=\"group input-normal\" ng-class=\"{error:ModalOtpForm.pan.$dirty && ModalOtpForm.pan.$invalid}\"><input type=text name=pan maxlength=10 minlength=10 style=\"cursor: auto\" ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=Modal.formData.pan autofocus required capitalize> <span style=color:red ng-show=\"ModalOtpForm.pan.$dirty && ModalOtpForm.pan.$invalid\"><span class=error-input ng-show=ModalOtpForm.pan.$error.required ng-bind=Modal.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=ModalOtpForm.pan.$error.minlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=ModalOtpForm.pan.$error.maxlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=ModalOtpForm.pan.$error.pattern ng-bind=Modal.validateData.PAN_FIELD></span> </span><span class=highlight></span> <span class=bar></span><label>PAN</label></div></div><div class=col-md-12 ng-if=\"Modal.modalData.detail.loginType === \'ThroughPassword\'\"><div class=\"group input-normal\" ng-class=\"{error:ModalOtpForm.otpNumber.$dirty && ModalOtpForm.otpNumber.$invalid}\"><input type=text ng-model=Modal.formData.otpNumber name=otpNumber is-number style=\"cursor: auto\" ng-change=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off autofocus> <span class=highlight></span> <span class=bar></span> <span class=forgot><timer countdown=30 interval=1000><span ng-show=\"countdown > 0\" style=\"position: absolute;top: 45px;right: 0px\" class=forgot-pwd>Enable Resend OTP in {{countdown}}s</span> <a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Modal.reSendOtp(); class=forgot-pwd>Resend OTP</a></timer></span><label>Enter OTP</label><span class=error-input ng-messages=ModalOtpForm.otpNumber.$error ng-show=ModalOtpForm.otpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span></div></div></div><button type=submit ng-disabled=\"ModalOtpForm.$invalid || Modal.processFlag\" class=\"btn btn-primary-action\">Verify</button> <span class=error ng-if=Modal.errorMessage><span class=error-all-message>{{ Modal.errorMessage }}</span></span></form></div></div>");
$templateCache.put("app/components/modal/confirmLoginReg/confirmLoginSuccess.modal.html","<!-- Otp verification--><div class=modal-content id=confirm-otp-success><!--<div class=\"modal-header\">--><!--<h4 class=\"modal-title\">OTP Verified</h4>--><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--><!--</div>--><div class=modal-body><form autocomplete=off><p class=\"text-center success-text\"><i class=verify-icon></i>Created Successfully</p><div class=text-center><button type=button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></div></form></div></div>");
$templateCache.put("app/components/modal/confirmOtpReg/confirmOtp.modal.html","<!-- Otp verification--><div class=modal-content id=confirm-otp><!--<div class=\"modal-header\">--><!--<h4 class=\"modal-title\">Create User ID</h4>--> <i class=times-icon ng-click=Modal.dismissModal();></i><!--</div>--><div class=\"modal-body clearfix\"><form autocomplete=off name=modalOtpForm ng-submit=Modal.verifyOtp() novalidate><h3>Create User ID</h3><p>We have sent an OTP on your registered {{Modal.modalData.text}}.<br></p><div class=row><div class=col-md-6><div class=\"group input-normal\" ng-class=\"{error:modalOtpForm.otpNumber.$dirty && modalOtpForm.otpNumber.$invalid}\"><input type=text ng-model=Modal.formData.otpNumber name=otpNumber is-number ng-change=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter OTP</label><span class=error-input ng-messages=modalOtpForm.otpNumber.$error ng-show=modalOtpForm.otpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span></div></div></div><button type=submit ng-disabled=\"otpForm.$invalid || Modal.processFlag\" class=\"btn btn-primary-action pull-right\">Submit</button> <span class=error ng-if=Modal.errorMessage><span class=error-all-message>{{ Modal.errorMessage }}</span></span></form></div></div>");
$templateCache.put("app/components/modal/confirmOtpReg/confirmOtpSuccess.modal.html","<!-- Otp verification--><div class=modal-content id=confirm-otp-success><!--<div class=\"modal-header\">--><!--<h4 class=\"modal-title\">OTP Verified</h4>--> <i class=times-icon ng-click=Modal.dismissModal();></i><!--</div>--><div class=modal-body><form autocomplete=off><p class=\"text-center success-text\"><i class=verify-icon></i>Created Successfully</p><br><div class=text-center><button type=button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></div></form></div></div>");
$templateCache.put("app/components/modal/contactSave/contactSave.modal.html","<div class=modal-content id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body style=\"background: #F3F9FF\"><p class=title>To proceed with Folio creation both contact details of investors are mandatory. Kindly get in touch with our ISC or CAMS to update CKYC.</p><button type=submit ng-click=Modal.closeModal() class=\"btn btn-primary-action\" style=\"border-radius: 30px\">Ok</button></div></div><style>label{\n    font-size: 18px;\n    font-weight: bold;\n  }\n  .title{\n    font-size: 18px !important;\n    color: #333333;\n  }\n  ::-webkit-input-placeholder {\n    text-align: center;\n  }\n  :-moz-placeholder {\n    text-align: center;\n  }</style>");
$templateCache.put("app/components/modal/createUser/createUserId.modal.html","<!-- Sign up Completed--><div class=modal-content id=user-otp-done><div class=modal-body><form autocomplete=off><p class=\"text-center success-text\"><i class=verify-icon></i>User ID Created Successfully</p><!-- Create User Id Text --><p class=text-center>You have successfully registered for HDFC MFONLINE</p><!--<p class=\"text-center strong verify-email\">Verify your email to start investing</p>--><!--Reset Password Success Text--><!--<p class=\"text-center\">--><!--You have successfully reset your password. Please continue to login to your account.--><!--</p>--><div class=text-center><button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></div></form></div></div>");
$templateCache.put("app/components/modal/createUser/createUserIdEmailError.modal.html","<!-- Sign up Completed--><div class=modal-content id=user-otp-done><div class=modal-body><form autocomplete=off><!-- Create User Id Text --><p class=text-center>Either Email ID or Mobile number is mandatory for creating user ID. Kindly <a href={{Modal.HDFC_API.WEBSITE_LINK}}CMT/UPLOAD/ARTICLEATTACHMENTS/CTR_Non_Financial_Transaction_15062016.pdf target=_blank>click here</a> to download the form to update your contact details and submit the same to your <a href={{Modal.HDFC_API.WEBSITE_LINK}}contactus/our-offices/4DFE03E1-B11C-4C5F-86DC-A18EC154C65A target=_blank>nearest Investor Service Centre (ISC).</a></p><div class=text-center><button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></div></form></div></div>");
$templateCache.put("app/components/modal/createUser/pan-verification.modal.html","<!-- Otp verification--><div class=\"modal-content nriHolderPopup holderPopupForJH\" id=addInvestor ng-init=Modal.defaultSetDate();><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title ng-bind=Modal.modalData.label.header>Add Joint Holder</h3><i class=times-icon ng-click=\"Modal.dismissModal(\'viaCrossButton\');\"></i></div><div class=modal-body><form autocomplete=off name=Modal.verificationForm novalidate class=verification-form><div class=row><div class=\"col-xs-12 col-md-12\"><div class=tax-status-container style=\"margin-bottom: 20px\"><label class=s-label>Tax Status</label><div class=tax-field-container><div class=flex-check><input class=nomineeCheckbox type=radio id=resident-tax-status name=tax-status ng-value=false ng-model=Modal.modalData.nriFlag><label for=resident-tax-status class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\">{{Modal.appConstants.TAX_STATUS_INDIVIDUAL.RESIDENT_INDIVIDUAL}}</label></div><div class=flex-check><input class=nomineeCheckbox type=radio id=tax-status name=tax-status ng-value=true ng-model=Modal.modalData.nriFlag><label for=tax-status class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\" class=show-on-desktop>{{Modal.appConstants.TAX_STATUS_INDIVIDUAL.NON_RESIDENT_INDIVIDUAL}}</label><label style=\"margin-top: 5px\" class=show-on-mobile>{{Modal.appConstants.TAX_STATUS_INDIVIDUAL.NRI_ON_MOBILE}}</label></div></div></div></div><div class=col-md-3></div></div><div class=\"input-select input-normal\" ng-class=\"{error:Modal.verificationForm.pan.$dirty && Modal.verificationForm.pan.$invalid}\"><input type=text name=pan maxlength=10 minlength=10 ng-model=Modal.formData.pan ng-change=Modal.panChanged() ng-readonly=\"Modal.emailVerify===true||Modal.otpVerify === true\" ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ easyassist-key=mask-element capitalize required> <span ng-show=\"Modal.verificationForm.pan.$dirty && Modal.verificationForm.pan.$invalid\"><span class=error-input ng-show=Modal.verificationForm.pan.$error.minlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=Modal.verificationForm.pan.$error.maxlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=Modal.verificationForm.pan.$error.pattern ng-bind=Modal.validateData.PAN_FIELD></span> </span><span class=\"error-input panAdharJoint\" ng-if=Modal.panAdhaarNotLinked ng-bind-html=Modal.panAdhaarNotLinked></span><!--PAN OF JOIN HOLDER ERROR MESSAGE FOR BANNED COUNTRY--> <span class=pAdharError ng-show=Modal.isPanBannedCountryInvalid><span class=error-input ng-show=Modal.isPanBannedCountryInvalid ng-bind-html=Modal.bannedCountryMessage></span> </span><span class=highlight></span> <span class=bar></span><label>{{Modal.modalData.label.pan}}<span class=req>*</span></label></div><div ng-if=\"Modal.emailVerify===true||Modal.otpVerify === true\" class=\"input-select input-normal\" ng-class=\"{error:Modal.verificationForm.email.$dirty && Modal.verificationForm.email.$invalid}\"><input type=email name=email ng-model=Modal.formData.email ng-readonly=\"Modal.otpVerify === true\" ng-pattern=Modal.EMAIL_PATTERN required> <span ng-show=\"Modal.verificationForm.email.$dirty && Modal.verificationForm.email.$invalid\"><span class=error-input ng-show=Modal.verificationForm.email.$error.minlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=Modal.verificationForm.email.$error.maxlength ng-bind=Modal.validateData.PAN_FIELD></span> </span><span style=color:#46a040 class=\"common-error submit-success ng-binding\" ng-bind=Modal.emailMsg></span> <span class=highlight></span> <span class=bar></span><label>Email<span class=req>*</span></label></div><div ng-if=\"Modal.otpVerify === true\" class=\"input-select input-normal\" ng-class=\"{error:Modal.verificationForm.otp.$dirty && Modal.verificationForm.otp.$invalid}\"><input type=text minlength=6 maxlength=6 name=otp ng-change=\"Modal.OTPResendMsg=\'\';Modal.wrongMsg=\'\'\" ng-model=Modal.formData.otp required> <a style=float:right ng-click=Modal.reGenerateOtp() ng-disabled=Modal.processFlag class=\"resend-otp cursor-pointer\">Resend OTP</a> <span ng-show=\"Modal.verificationForm.otp.$dirty && Modal.verificationForm.otp.$invalid\"><span class=error-input ng-show=Modal.verificationForm.otp.$error.minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span class=error-input ng-show=Modal.verificationForm.otp.$error.maxlength ng-bind=Modal.validateData.OTP_FIELD></span> </span><span style=color:#46a040 class=\"common-error submit-success\" ng-bind=Modal.OTPResendMsg></span> <span class=highlight></span> <span class=bar></span><label>OTP<span class=req>*</span></label></div><div class=text-center><button type=button ng-if=Modal.panVerify class=\"btn btn-primary-action\" ng-click=Modal.verifyPAN() ng-class=\"{\'basket-btn-primary\': Modal.modalData.isBasketJourney}\" ng-disabled=\"Modal.verificationForm.$invalid || Modal.wrongMsg != \'\' || Modal.panAdhaarNotLinked\">Verify PAN</button> <button type=button ng-if=Modal.emailVerify class=\"btn btn-primary-action\" ng-click=Modal.verifyEmail() ng-disabled=\"Modal.verificationForm.$invalid || Modal.wrongMsg != \'\'\">Verify Email</button> <button type=button ng-if=Modal.otpVerify class=\"btn btn-primary-action\" ng-click=Modal.verifyOTP() ng-disabled=\"Modal.verificationForm.$invalid || Modal.wrongMsg != \'\'\">Verify OTP</button><div ng-class=\"{\'common-error\':Modal.wrongMsg != \'\'}\"><span ng-show=\"Modal.wrongMsg != \'\'\" ng-bind=Modal.wrongMsg></span></div></div></form></div></div><style>.panAdharJoint {\n    margin-top: 10px;\n    display: inline-block;\n  }\n\n  .panAdharJoint a {\n    text-decoration: underline !important;\n    color: #103880;\n    margin-top: 20px;\n  }</style>");
$templateCache.put("app/components/modal/dashboard/mapfolio.modal.html","<div class=modal-content id=map-folio ng-init=Modal.init()><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body ng-scope\"><form autocomplete=off><div class=text-center><i class=user-grey-icon></i><h6 class=text-blue>Hi {{Modal.modalData.name}}!</h6><p ng-if=\"Modal.folioMapL > 1\">The below folio numbers associated with your PAN will be mapped to this account.</p><p ng-if=\"Modal.folioMapL == 1\">The below folio number associated with your PAN will be mapped to this account.</p></div><br><br><div class=folio-checkbox><span class=checkbox ng-repeat=\"(key,value) in Modal.folioMap\"><input type=checkbox checked disabled> <span class=icon-checkbox></span> <span class=checkbox-text>{{value}}</span></span></div><div class=text-center><button class=\"btn btn-primary-action text-uppercase\" autofocus ng-click=Modal.mapFolio()>OK</button></div></form></div></div>");
$templateCache.put("app/components/modal/decisionModal/decision.modal.html","<div class=modal-content id=user-otp-done><div class=modal-body><form autocomplete=off><p class=text-center>You have selected E-mandate payment option you can\'t create folio with minor.</p><div class=text-center><button ng-click=Modal.changePaymentoption() class=\"btn btn-primary-action pad\">Change Payment option</button> <button ng-click=Modal.continuewithSelf() class=\"btn btn-primary-action pad\">Continue with Self</button></div></form></div></div><style>.pad{\n        margin: 15px;\n    }</style>");
$templateCache.put("app/components/modal/declaration/declaration.modal.html","<div class=modal-content id=disclaimerPopups><div class=modal-head><h3>Declaration</h3></div><div class=modal-body id=declarationModal style=\"height: 300px;overflow: auto\"><div id=agreement style=height:850px>*I/We {{Modal.modalData.InvestorName}} do hearby declare that i am resident in India within the meaning of the section 6 of the income-tax Act, 1961.<br>*I/We also hereby declare that to the best of *my/our knowledge and belief what is stated above is correct, complete and is truly stated. *I/We declare that the incomes referred to in this form are not includible in the total income of any other person under sections 60 to 64 of the Incometax Act, 1961.<br>*I/We further declare that the tax *on my/our estimated total income including income/incomes referred to in estimated income and aggregate amount of *income/incomes referred to in computed in accordance with the provisions of the Income-tax Act, 1961, for the previous year ending on {{Modal.modalData.lastDateFY}} relevant to the assessment year {{Modal.modalData.FY}} will be nil.<br><br>*I/We also declare that *my/our *income/incomes referred to in column and the aggregate amount of *income/incomes referred to in estimated total income for the previous year ending on {{Modal.modalData.lastDateFY}} relevant to the assessment year {{Modal.modalData.FY}} will not exceed the maximum amount which is not chargeable to income-tax.<br><br><span style=\"font-weight: bold\">Instruction</span><br><br>As per provisions of section 206AA(2), the declaration under section 197A(1) or 197A(1A) shall be invalid if the declaration fails to furnish his valid [Permanent Account Number or Aadhaar Number].<br><br>15 G - Declaration can be furnished by an residential individual under section 197A(1) or 197A(1A) and for form 15H - Declaration can be furnished by an resident individual who is of the age of 60 years or more at any time during the previous year.<br><br>Please mention “Yes” if assessed to tax under the provisions of Income-tax Act, 1961 for any of the assessment year out of six assessment years preceding the year in which the declaration is filed.<br><br>Please mention the amount of estimated total income of the previous year for which the declaration is filed including the amount of income for which this declaration is made.<br><br>In case any declaration(s) in Form No. 15G is filed before filing this declaration during the previous year, mention the aggregate amount of income for which said declaration(s) have been filed.<br><br>Before signing the declaration/verification, the declarant should satisfy himself that the information furnished in this form is true, correct and complete in all respects. Any person making a false statement in the declaration shall be liable to prosecution under section 277 of the Income-tax Act, 1961 and on conviction be punishable -<br><br>(i) in a case where tax sought to be evaded exceeds twenty-five lakh rupees, with rigorous imprisonment which shall not be less than six months but which may extend to seven years and with fine;<br><br>(ii) in any other case, with rigorous imprisonment which shall not be less than three months but which may extend to two years and with fine.</div></div><div class=text-center><button style=\"margin: 5px\" class=\"btn btn-primary-action\" ng-click=Modal.closeModal() id=closeBtn disabled>OK</button></div></div><script>$(document).ready(function () {\n    jQuery(\n      function ($) {\n        $(\'#declarationModal\').bind(\'scroll\', function () {\n          if (($(this).scrollTop() + $(this).innerHeight() < $(this)[0].scrollHeight)) {\n            if ($(\'#closeBtn\').prop(\'disabled\')) {\n              $(\'#closeBtn\').prop(\'disabled\', true);\n            }\n          } else {\n            $(\'#closeBtn\').prop(\'disabled\', false);\n          }\n        })\n      }\n    );\n  });</script>");
$templateCache.put("app/components/modal/dreamSchemeList/dreamSchemeList.model.html","<!-- Scheme List--><div class=modal-content id=schemeList ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Scheme List</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><ul class=\"nav nav-tabs tab-type-2\"><li ng-class=\"{active:$index==0}\" ng-repeat=\"schemeType in Modal.schemeTypeList\" ng-click=Modal.filterSchemes(schemeType)><a data-bs-toggle=tab>{{schemeType}}</a></li></ul><input ng-if=\"Modal.schemeList.length !=0\" type=search id=searchbox ng-model=Modal.searchString autocomplete=off placeholder=\"Search Scheme\" class=\"blank-input scheme-search\"> <span class=no-scheme ng-if=\"Modal.schemeList.length===0\">No Scheme Found For The Category</span><div class=\"tab-content tab-type-2-content\" ng-if=Modal.schemeList.length><div id=All class=\"tab-pane fade in active\"><ul><li ng-repeat=\"scheme in Modal.schemeList|searchFor:Modal.searchString\" ng-click=Modal.selectScheme(scheme)>{{scheme.scheme}}</li></ul></div></div></div></div>");
$templateCache.put("app/components/modal/dreamSip/changeOption.modal.html","<div class=modal-content id=forgot-success ng-init=Modal.fetchTargetScheme()><div class=modal-header><h4 class=modal-title>Change Option</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content ng-if=\"Modal.modalData.optionType == \'Option A\'\"><h6 class=text-center style=\"line-height: 1.5\">Please select Target scheme if you wish to change Dream SIP Option from A to B</h6><br><form autocomplete=off class=sipPurchase-form name=sipPurchaseForm novalidate><div class=\"normal-wrap clearfix\"><div class=sip-form-box><div class=row><!-- <div class=\"col-md-3 form-grid\">\n                    <div class=\"install-freq frequency\">\n                      <p><strong>Select Option</strong></p>\n                      <div class=\"radio-block\" ng-repeat=\"option in Modal.optionList\">\n                        <span class=\"radio\">\n                          <input type=\"radio\" id=\"{{option.key+\'1\'}}\" \n                            ng-model=\"Modal.formData.optionType\"  ng-value=\"option.value\"\n                            name=\"option\" ng-change=\"Modal.changeOptionType()\"/>\n                          <span class=\"check\"></span>\n                        </span>\n                        <label>{{option.value}}</label> </div>\n                    </div>\n                  </div>   --><div><div class=form-group><div class=\"input-select input-normal\"><input type=text name=targetScheme id=targetScheme ng-change=Modal.filterSipSchemeList() ng-model=Modal.formData.targetSchemeName autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><drop-down list-data=Modal.targetSchemeList display-key=scheme hdfc-click=Modal.targetSchemeChanged(data) model=Modal.formData.targetSchemeCode for=targetScheme></drop-down></div></div></div></div></div></div></form><div class=row><div class=col-md-12><div class=point-to-note-tpv style=margin-top:10px>Note:<br><ul><li>Option A – Source and Target scheme of SIP and SWAP shall remain same.</li><li>Option B – Source and Target scheme of SIP and SWAP shall be different.</li><li>Your request to change Dream SIP Option may take up to 5 business days.</li></ul></div></div></div></div><div class=content ng-if=\"Modal.modalData.optionType == \'Option B\'\"><h4 class=text-center style=\"line-height: normal\">{{Modal.modalData.sourceScheme}}</h4><br><br><h6 class=text-center>Do you wish to change Dream SIP Option from B to A?</h6><br><div class=row><div class=col-md-12><div class=point-to-note-tpv style=margin-top:10px>Note:<br><ul><li>Option A – Source and Target scheme of SIP and SWAP shall remain same.</li><li>Option B – Source and Target scheme of SIP and SWAP shall be different.</li><li>Your request to change Dream SIP Option may take up to 5 business days.</li></ul></div></div></div></div><br><div class=row><div class=col-md-6><button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissModal()>Cancel</button></div><div class=col-md-6 ng-if=\"Modal.modalData.optionType == \'Option B\'\"><button class=\"btn btn-primary-action\" ng-click=Modal.continue()>Confirm</button></div><div class=col-md-6 ng-if=\"Modal.modalData.optionType == \'Option A\'\"><button class=\"btn btn-primary-action\" ng-disabled=!Modal.formData.targetSchemeCode ng-click=Modal.continue()>Confirm</button></div></div></div></div>");
$templateCache.put("app/components/modal/dreamSip/changeTargetScheme.modal.html","<div class=modal-content id=forgot-success ng-init=Modal.fetchTargetScheme()><div class=modal-header><h4 class=modal-title>Change Target Scheme</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content ng-if=\"Modal.modalData.optionType == \'Option B\'\"><form autocomplete=off class=sipPurchase-form name=sipPurchaseForm novalidate><div class=\"normal-wrap clearfix\"><div class=sip-form-box><div class=row><div><div class=form-group><div class=\"input-select input-normal\"><input type=text name=targetScheme id=targetScheme ng-change=Modal.filterSipSchemeList() ng-model=Modal.targetSchemeData.targetSchemeName autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><drop-down list-data=Modal.targetSchemeList display-key=scheme hdfc-click=Modal.targetSchemeChanged(data) model=Modal.targetSchemeData.targetSchemeCode for=targetScheme></drop-down></div></div></div></div></div></div></form></div><div class=row><div class=point-to-note-tpv style=\"padding-bottom: 7px !important\">Note:</div><div class=point-to-note-tpv style=\"padding: 20px;padding-top: 7px !important;\n        text-align: center\"><ul><li>Your request to change Dream SIP Target Scheme may take up to 5 business days.</li></ul></div></div><br><div class=row><div class=col-md-6><button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissModal()>Cancel</button></div><div class=col-md-6 ng-if=\"Modal.modalData.optionType == \'Option B\'\"><button class=\"btn btn-primary-action\" ng-disabled=!Modal.targetSchemeData.targetSchemeCode ng-click=Modal.continue()>Confirm</button></div></div></div></div>");
$templateCache.put("app/components/modal/dreamSip/pointToNote.modal.html","<div class=modal-content id=disclaimerPopups><div class=modal-header style=\"background: aliceblue\"><h4 class=modal-title>Dream SIP - Points To Note</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div style=\"margin: 20px\"><div><ol style=\"line-height: normal\"><li>1. Dream SIP for your investor shall be registered in a new folio.</li><li>2. New Dream SIP folio for your investor shall be created using details of existing folio {{}}.</li><li>3. You may review and update details of new folio to be created for your investor on next screen before registering Dream SIP.</li><li>4. New folio created for Dream SIP shall not be available for lumpsum purchase, SIP and Switch transactions. you may continue to place redemption transaction in Dream SIP folio including SWAP on behalf of your investor. However, subsequent SWAP after completion of SIP tenure shall not get triggered and Dream SIP shall get converted into normal SIP and Continue until it\'s tenure.</li></ol></div><br><div><button class=\"btn btn-primary-action btn-center\" style=\"margin-right: auto\" ng-click=Modal.continue()>Continue</button></div></div><br></div>");
$templateCache.put("app/components/modal/dreamSipTenure/dream.sip.tenure.modal.html","<!-- Scheme List--><div class=modal-content id=schemeList><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title><b>SIP Tenure</b></h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>SIP Tenure</th><th>Monthly SWAP Installments</th></tr></thead><tbody><tr ng-repeat=\"data in Modal.modalData\"><td>{{data.value}} Years</td><td>{{data.multiple}}<span ng-if=\"(data.multiple % 1) === 0\">.0</span> times monthly SIP installments</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/modal/editDashboard/success.edit.html","<div class=modal-content id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><i class=success-icon></i><p>Changes have been saved successfully.</p><button type=submit ui-sref=main.dashboard.widgits ng-click=Modal.dismissModal(); class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/email-verification/email-verified.modal.html","<!-- Scheme List--><div class=\"modal-content email-verify\" id=initiateTransactionMsg><div class=loader style=\"position: absolute\"><span class=loading></span></div><div class=modal-body><div><i class=verify-icon></i> <span>Added Successfully</span></div><p ng-bind=Modal.modalData></p><!--<p>You have successfully added <strong>shivi00987@hotmail.com</strong>\n      </br>as your email ID.</p>--><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/email-verification/enter-email.modal.html","<div class=modal-content id=emailVerify><div class=loader style=\"position: absolute\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><p class=\"blueHead text-center\">Email Verification</p><p class=info>You have not mapped any email ID yet, add one to be associated with your HDFC MF online account.</p><form name=emailForm ng-submit=Modal.verifyEmail()><div class=input-normal ng-class=\"{error:emailForm.emailId.$dirty && emailForm.emailId.$invalid}\"><input type=text ng-model=Modal.formData.emailId autofocus name=emailId ng-pattern=Modal.appConstants.email_regex maxlength=150 autocomplete=off required><label>Enter Email ID</label><span class=error-input ng-messages=emailForm.emailId.$error ng-show=emailForm.emailId.$dirty><span ng-message=required ng-bind=Modal.validateData.EMAIL_REQUIRED></span> <span ng-message=pattern ng-bind=Modal.validateData.EMAIL_FIELD></span></span></div><div class=text-center><button type=submit class=\"btn btn-primary-action\" ng-disabled=\"emailForm.$invalid || Modal.processFlag\">Send OTP</button></div></form></div></div>");
$templateCache.put("app/components/modal/email-verification/enter-otp.modal.html","<div class=modal-content id=emailVerify><div class=loader style=\"position: absolute\"><span class=loading></span></div><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><form autocomplete=off name=modalOtpForm ng-submit=Modal.verifyOtp() novalidate><p class=info ng-bing=Modal.modalData.Text>-</p><div class=\"input-group input-normal\" ng-class=\"{error:modalOtpForm.otpNumber.$dirty && modalOtpForm.otpNumber.$invalid}\"><input type=text ng-model=Modal.formData.otpNumber ng-if=!Modal.inputReset name=otpNumber is-number ng-click=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter OTP</label><span class=error-input ng-messages=modalOtpForm.otpNumber.$error ng-show=modalOtpForm.otpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span> </span><span class=forgot><span ng-if=Modal.otpResendMessage style=\"color: #1bb898\">{{Modal.otpResendMessage}}</span> </span><span class=resend-btn ng-click=Modal.resendOtp()>Resend OTP</span></div><div class=text-center><button type=submit ng-disabled=\"modalOtpForm.$invalid || Modal.processFlag\" class=\"btn btn-primary-action\">Submit OTP</button></div><span class=error ng-if=Modal.errorMessage><span class=error-all-message>{{ Modal.errorMessage }}</span></span></form></div></div>");
$templateCache.put("app/components/modal/existingUser/existinguser.modal.html","<!-- Sign up Completed--><div class=modal-content id=register-done><!-- <div><i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i></div> --><div class=modal-body><form autocomplete=off><div style=\"display: flex;justify-content: center;align-items: center;flex-direction: column\"><img src=\"../../../../assets/images/Group 5626.svg\" alt=\"\"><h1 style=\"margin-top: 10px;margin-bottom: 0px\">Welcome {{Modal.modalData.name}}</h1><p style=\"font-weight: 400\" ng-if=!Modal.modalData.name>You already have investments with us.</p><p style=\"font-weight: 400\" ng-if=Modal.modalData.name>You are already registered with us.</p></div><p class=text-center><span ng-if=Modal.modalData.name>We have sent your user ID to your registered. Email ID <span style=\"color: blue\">({{Modal.modalData.email}})</span>and Mobile no.<span style=\"color: blue\">({{Modal.modalData.mobile}})</span>.</span> {{Modal.modalData.text}}</p><div class=\"modal-multiple-action text-center\"><button ng-click=Modal.closeModal() class=\"btn hdfc-blue-cta-small\" style=\"background: #244b8c;\n          width: 200px\">{{Modal.modalData.buttonText}}</button></div></form></div></div>");
$templateCache.put("app/components/modal/feedback/feedback.modal.html","<div class=modal-content id=feedbackModal><div class=modal-body><i class=times-icon ng-click=Modal.dismissModal();></i><form><div class=text-center><i class=success-icon></i></div><p class=text-center>Thank you for filling the details, we will get back to you shortly.</p><div class=text-center><button class=\"btn-primary-action btn\" ng-click=Modal.closeModal();>OK</button></div></form></div></div>");
$templateCache.put("app/components/modal/fill-folio-detail/fillFolioDetail.modal.html","<div class=\"modal-content folio-detail-modal\" id=initiateTransactionMsg><div class=modal-head><h3>Create New Folio</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p>{{Modal.modalData.text}}</p><div class=\"modal-multiple-actions text-center\"><button ng-disabled=\"\" class=\"btn btn-primary-action\" ng-click=\"Modal.closeModal(\'SELECT_NEW\')\"><i>Yes, Select Folio</i></button> <button class=\"btn btn-secondary-action\" ng-click=\"Modal.closeModal(\'no\')\">No, Create New</button></div></div></div>");
$templateCache.put("app/components/modal/folio-choice/folio-choice.modal.html","<div class=\"modal-content folio-detail-modal\" id=initiateTransactionMsg><div class=modal-head><h3>Select from below options</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=\"modal-multiple-actions text-center\"><button ng-disabled=\"\" class=\"btn btn-primary-action\" ng-click=\"Modal.closeModal(\'SELECT_NEW\')\"><i>Select Existing Folio</i></button> <button class=\"btn btn-secondary-action\" ng-click=\"Modal.closeModal(\'no\')\">No, Create New</button></div></div></div>");
$templateCache.put("app/components/modal/folioCreation/folio-success.modal.html","<!-- Scheme List--><div class=modal-content id=folio-success><i class=times-icon ng-click=\"Modal.dismissModal(\'close\');\"></i><div class=modal-body><p ng-show=\"Modal.modalData.holdmode !==\'ANY_OR_SURVIVOR\'\" class=text-center><i class=verify-icon></i> <span>Successfully Created</span> <span class=text-small>Folio No. {{Modal.modalData.folioNumber}}</span></p><div ng-show=\"Modal.modalData.holdmode !==\'ANY_OR_SURVIVOR\'\" class=\"clearfix folio-num\"><p>A new folio has been successfully created & saved</p><p>You can now proceed to {{Modal.modalData.fromOtherJoruney ? \'payment\' : \'invest\'}}</p><br><p class=nomineeRegistrationError ng-if=Modal.modalData.nomineeRegistrationFailureMessage ng-bind-html=Modal.modalData.nomineeRegistrationFailureMessage></p><div class=text-center><!--<div class=\"radio-block\">\n        <span class=\"radio\">\n          <input type=\"radio\" value=\"sip\" ng-model=\"Modal.stateToGo\" name=\"siporpurchase\">\n          <span class=\"check\"></span>\n        </span>\n        <span class=\"radio-label\">SIP</span>\n      </div>\n\n      <div class=\"radio-block\">\n        <span class=\"radio\">\n          <input type=\"radio\" value=\"purchase\" ng-model=\"Modal.stateToGo\" name=\"siporpurchase\">\n          <span class=\"check\"></span>\n        </span>\n        <span class=\"radio-label\">Purchase</span>\n      </div>--> <button ng-if=!Modal.modalData.fromOtherJoruney class=\"btn-primary-action btn\" ng-click=Modal.goToTransactionSip()>Start a SIP</button> <button ng-if=!Modal.modalData.fromOtherJoruney class=\"btn-primary-action btn\" ng-click=Modal.goToTransactionPurcahse()>Start a Purchase</button> <button style=\"background: #1b4b86\" ng-if=Modal.modalData.fromOtherJoruney class=\"btn-primary-action btn\" ng-click=Modal.closeModal()>Proceed to Transact</button></div></div><div ng-show=\"Modal.modalData.holdmode == \'ANY_OR_SURVIVOR\' && Modal.modalData.firstFlow == \'NO\'\" class=\"clearfix folio-num\"><div class=text-center><p>Your Request has been successfully sent for Approval.</p></div></div><!--<button class=\"btn btn-primary-action btn-center\" ng-click=\"Modal.goToTransaction()\">Transact Now</button>--><div ng-if=!Modal.modalData.fromOtherJoruney class=\"go-dash text-center\" ng-click=Modal.closeModal();>Go to Home <i class=arrow-blue-icon></i></div><div ng-if=\"Modal.modalData.fromOtherJoruney &&  Modal.modalData.holdmode ==\'ANY_OR_SURVIVOR\'\" class=\"go-dash text-center\" ng-click=Modal.closeModal();>Go to Home <i class=arrow-blue-icon></i></div><!--on click--><!--<button class=\"btn btn-primary-action btn-center\" ng-click=\"Modal.dismissModal()\">Transact Now<i class=\"welcome-arrow-white-icon\"></i> </button>--><!--<div class=\"go-dash text-center\" ng-click=\"Modal.goDashboard();\">Go to Dashboard <i class=\"arrow-blue-icon\"></i></div>--><div ng-show=\"Modal.modalData.holdmode == \'ANY_OR_SURVIVOR\' && Modal.modalData.firstFlow == \'YES\'\" class=\"clearfix folio-num\"><div class=text-center><p>Your Request for approval has been submitted successfully. Please ask your holders to approve the folio.</p><div style=margin-top:20px><p>Want to create a new Foilo?</p><p><button class=\"btn btn-primary-action\" ng-click=Modal.redirectToFolioCreation()>Proceed</button></p><p style=margin-top:15px><a ng-click=Modal.logoutMe()>Logout</a></p></div></div></div><!--<button class=\"btn btn-primary-action btn-center\" ng-click=\"Modal.goToTransaction()\">Transact Now</button>--></div></div>");
$templateCache.put("app/components/modal/folioCreation/self-declaration.modal.html","<div class=modal-content id=selfDeclare><div class=modal-body><h6 class=head>Self Declaration</h6><p class=small-grey-text>I, Aakash Kumar (parent/legal guardian) am, The information and data contained in this Website do not constitute distribution, an offer to buy or sell or solicitation of an offer to buy or sell any Schemes/Units of HDFC Mutual Fund in any jurisdiction in which such distribution, sale or offer is not authorised. The material/information provided in this Website is for the limited purposes of information only for the investors. In particular, the information herein is not for distribution and does not constitute an offer to buy or sell or solicitation of an offer to buy or sell any Schemes/Units of HDFC Mutual Fund to any person in the United States of America (\'USA\')/Canada.</p><p class=small-grey-text>By entering this Website or accessing any data contained in the name of Rakesh (minor investor) this Website, I/We hereby confirm that</p><p class=small-grey-text>I) I/We am/are not a U.S. person, within the definition of the term \'US Person\' under the US Securities laws/resident of Canada.</p><p class=\"small-grey-text dark\">II). Neither the Fund, AMC not any person connected with it will be liable and / or responsible for any liability that may arise to the minor Unit holder on account of any rejection/ non-acceptance/ delay in realization of such redemption proceeds/ IDCW payouts as the hereinabove mentioned.</p><div class=text-center><button type=button class=\"btn-primary-action btn\">I Agree</button></div></div></div>");
$templateCache.put("app/components/modal/folioSuccess/folioSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=folio-success><!-- <i class=\"times-icon\" ng-click=\"Modal.dismissModal(\'close\');\"></i> --><div class=modal-body><div ng-show=\"Modal.modalData.holdmode !=\'ANY_OR_SURVIVOR\'\" class=\"clearfix folio-num text-center\"><i class=verify-icon></i><br><span>Successfully Created</span><br><span class=text-small>Folio No. {{Modal.modalData.folioNumber}}</span><br><p ng-if=\"!Modal.distributorDetails || (Modal.distributorDetails && Modal.distributorDetails.transactionType != \'Purchase_Scheduler\')\">A new folio has been successfully created & saved</p><p ng-if=\"Modal.distributorDetails && Modal.distributorDetails.transactionType == \'Purchase_Scheduler\'\">New folio successfully created</p><p ng-if=\"!Modal.distributorDetails || (Modal.distributorDetails && Modal.distributorDetails.transactionType != \'Purchase_Scheduler\')\">You can now proceed to payment</p><p ng-if=\"Modal.distributorDetails && Modal.distributorDetails.transactionType == \'Purchase_Scheduler\'\">You can now proceed to schedule purchase transaction</p><div ng-if=\"Modal.distributorDetails && Modal.distributorDetails.transactionType == \'Purchase_Scheduler\'\"><div class=otpDiv ng-if=Modal.otpSended><div class=\"group otpInput input-normal\" style=\"display: flex;justify-content: center;flex-direction: row;align-items: center\"><input type=text ng-model=Modal.otpNumber name=otpNumber is-number style=\"cursor: auto; font-size: 14px;width: 50%\" required minlength=6 maxlength=6 autocomplete=off placeholder=\"ENTER OTP\" autofocus> <span class=forgot><timer countdown=60 interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd>&nbsp;Resend OTP in &nbsp;<br class=break>&nbsp;{{countdown}}s</span> <span href=javascript:void(0); ng-show=\"countdown == 0\" ng-click=Modal.resendOtp(); class=forgot-pwd>&nbsp;Resend&nbsp;&nbsp;OTP</span></timer></span></div></div></div><button class=\"btn btn-primary-action\" ng-if=\"Modal.distributorDetails && Modal.distributorDetails.transactionType == \'Purchase_Scheduler\'\" ng-disabled=!Modal.otpNumber ng-click=Modal.verifyOtp();>Verify OTP</button> <button class=\"btn btn-primary-action\" ng-if=\"!Modal.distributorDetails || (Modal.distributorDetails && Modal.distributorDetails.transactionType != \'Purchase_Scheduler\')\" ng-click=Modal.pay();>Go to payment</button></div></div><div ng-show=\"Modal.modalData.holdmode == \'ANY_OR_SURVIVOR\'\" class=\"clearfix folio-num\"><div class=text-center><i class=verify-icon></i><p>Your request for approval has been submitted successfully. Please ask your holders to approve the folio.</p><div style=margin-top:20px><!-- <p><button class=\"btn btn-primary-action\" ng-click=\"Modal.redirectToFolioCreation()\">Proceed</button></p> --><p style=\"margin-bottom: 20px\"><button class=\"btn btn-primary-action\" ng-click=Modal.logoutMe()>OK</button></p></div></div></div></div>");
$templateCache.put("app/components/modal/forgotPassword/forgotPassword.modal.html","<!-- Scheme List--><div class=modal-content id=forgot-password><div class=\"loader popup\"><span class=loading></span></div><div><i class=times-icon ng-click=Modal.dismissModal();></i></div><!--<i class=\"times-icon\" ></i>--><div class=modal-body><p ng-bind-html=Modal.modalData.message></p><!--Forgot pwd--><!--<p class=\"text-center\">A link to reset your password has been sent to your registered email ID xyz@xyz.com</p>--><div class=text-center><button class=\"btn btn-primary-action btn-new-theam\" ng-click=Modal.closeModal()>OK</button></div></div></div><style>.btn-new-theam{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n  }</style>");
$templateCache.put("app/components/modal/genericModal/generic.modal.html","<div class=modal-content id=initiateTransactionMsg><i ng-if=!Modal.modalData.isUpi class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><p ng-if=\"!Modal.modalData.isAadhar && !Modal.modalData.fundName\" ng-bind-html=Modal.modalData.text></p><p ng-if=Modal.modalData.isAadhar class=panAdhar ng-bind-html=Modal.modalData.text></p><div class=\"d-flex justify-content-center mb-1\" ng-if=Modal.modalData.fundName><img src=../../../../assets/images/cart-big-img.svg alt=trasaction-cart></div><p ng-if=Modal.modalData.fundName class=fund-style-text style=\"font-size: 16px !important\">Do you want to add <span class=fw-bold>{{Modal.modalData.fundName}}</span> to cart?</p><ng-bind-html dynamic=Modal.modalData.hdfcNomineePopupMessage></ng-bind-html><button type=submit ng-class=\"{\'set-btn-blue\': Modal.modalData.showBlueBtn}\" ng-click=Modal.closeModal() ng-if=\"!Modal.modalData.modifySipAction && !Modal.modalData.redirectAction && !Modal.modalData.fundName\" class=\"btn btn-primary-action\">OK</button> <button type=submit ng-click=Modal.closeModal() ng-if=Modal.modalData.fundName class=\"btn btn-primary-action btn-style-update\" style=\"font-size: 14px !important\">Add to Cart</button><div class=\"modal-multiple-action text-center modifyCTA\" ng-if=\"Modal.modalData.modifySipAction || Modal.modalData.redirectAction\"><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>Yes</button> <button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissModal()>No</button></div></div></div><style>.panAdhar a{\n    text-decoration: underline !important;\n    font-size: 12px !important;\n    color:#103880;\n  }\n\n  .modifyCTA{\n    justify-content: space-around !important;\n  }\n  .modifyCTA > .btn{\n    width: 210px;\n  }\n\n  @media only screen and (max-width: 767px) {\n    .modifyCTA{\n      column-gap: 5px;\n    }\n  }\n\n  b {\n    font-weight: bold;\n  }\n\n  .fund-style-text {\n    text-align: center;\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 400 !important;\n  }\n  .btn-style-update {\n    background: #1B4B86 !important;\n    color: #FFF;\n    text-align: center;\n    font-family: \"Proxima Nova\" !important;\n    font-style: normal;\n    font-weight: 600 !important;\n    text-transform: none !important;\n  }</style>");
$templateCache.put("app/components/modal/hdfcBankModal/hdfcbank.modal.html","<!-- Scheme List--><div class=modal-content id=folio-success><!-- <i class=\"times-icon\" ng-click=\"Modal.dismissModal(\'close\');\"></i> --><div class=modal-body><div><div class=\"clearfix folio-num text-center\"><p>You do not have a folio with HDFC Bank registered in it.</p><p>Please click on proceed to add new HDFC Bank.</p></div><div style=\"display: flex;justify-content: center\"><p style=\"margin-bottom: 20px\"><button class=\"btn btn-primary-action\" ng-click=Modal.logoutMe()>Cancel</button></p><p style=\"margin-bottom: 20px\"><button class=\"btn btn-primary-action\" ng-click=Modal.proceed()>Proceed</button></p></div></div></div></div>");
$templateCache.put("app/components/modal/holdHolderNewJourney/hold.modal.html","<!-- Scheme List--><div class=modal-content id=folio-success><!-- <i class=\"times-icon\" ng-click=\"Modal.dismissModal(\'close\');\"></i> --><div class=modal-body><div ng-if=!Modal.expiredDate class=\"clearfix folio-num text-center\"><p>Your folio request is pending for approval.</p><p>Do you want to create new folio or go with existing folio?</p></div><div ng-if=Modal.expiredDate class=\"clearfix folio-num text-center\"><p>Your folio request has been expired.</p><p>Please create new folio.</p></div><div style=\"display: flex;justify-content: center\"><p style=\"margin-bottom: 20px\"><button class=\"btn btn-primary-action\" ng-click=Modal.logoutMe()>Logout</button></p><p style=\"margin-bottom: 20px\"><button class=\"btn btn-primary-action\" ng-click=Modal.craeteNewFolio()>New Folio</button></p></div></div></div>");
$templateCache.put("app/components/modal/initiateTransaction/saved.modal.html","<!-- Scheme List--><div class=modal-content id=initiateTransactionMsg ng-class=\"{\'new-save-form\' : Modal.modalData.newFlow}\"><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal(); ng-if=!Modal.modalData.newFlow;></i><div class=modal-head ng-if=Modal.modalData.newFlow;><h3>SUCCESS</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div ng-if=!Modal.modalData.newFlow;><i class=verify-icon></i></div><p ng-if=!Modal.modalData.newFlow;>Transaction has been saved successfully.<br>You can now view it in your “Saved Items” section.</p><div class=modal-content-container ng-if=Modal.modalData.newFlow;><div><i class=verify-icon></i></div><div><p>Transaction has been saved successfully. You can now view it in your “Saved Items” section.</p></div></div><div ng-class=\"{\'new-save-btn-container\' : Modal.modalData.newFlow}\"><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/initiateTransaction/success.modal.html","<!-- Scheme List--><div class=modal-content id=initiateTransactionMsg><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div><i class=verify-icon></i> <span>Transaction Complete</span></div><p>You have successfully completed a {{Modal.modalData.transactionType.toUpperCase()}} Transaction.</p><div ng-if=!Modal.modalData.isFavourite class=fav-block ng-class=\"{\'anything-disabled\':Modal.modalData.transactionType==\'FLEX INDEX\'}\"><div class=checkbox><input ng-model=Modal.isChecked type=checkbox> <i class=icon-favorite></i></div><span>Mark as a Favourite Transaction</span></div><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/initiateTransaction/upisuccess.modal.html","<!-- Scheme List--><div class=modal-content id=initiateTransactionMsg><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div><i class=verify-icon></i> <span>Transaction Initiated</span></div><p>Transaction has been initiated successfully through UPI. You will get a request for approval on your UPI App. Please approve the same using bank account selected here to complete the transaction.</p><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/investmentPersonality/investment.personality.modal.html","<div class=modal-content id=investmentPersonality><div class=modal-head><h3 class=modal-title>Know Your Investment Personality</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body question-ans-container\"><div class=tab ng-repeat=\"ques in Modal.investmentPersonalityQuestion.questionAndAnswers\"><div class=row><div class=col-md-12><div class=question-section>{{ques.question}}</div><div class=answer-section ng-repeat=\"ansDetails in ques.answerDetail\"><div class=radio-block><span class=radio><input type=radio name={{ansDetails.questionId}} value={{ansDetails.optionId}} ng-model=Modal.formData[ansDetails.questionId] ng-checked=\"ansDetails.optionId == Modal.formData[ansDetails.questionId]\"> <span class=check></span></span></div><span class=radio-label>{{ansDetails.answer}}</span></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-small btn-secondary-action\" ng-if=\"Modal.currentTab !== 0\" ng-click=Modal.nextAndPreviousAction(-1)>Previous</button> <button class=\"btn btn-small btn-primary-action\" ng-disabled=\"!Modal.formData[Modal.currentTab + 1]\" ng-if=\"Modal.currentTab < Modal.investmentPersonalityQuestion.questionAndAnswers.length -1 \" ng-click=Modal.nextAndPreviousAction(1);>Next</button> <button class=\"btn btn-small btn-primary-action\" ng-disabled=\"!Modal.formData[Modal.currentTab + 1]\" ng-if=\"Modal.currentTab >= Modal.investmentPersonalityQuestion.questionAndAnswers.length -1 \" ng-click=Modal.submitForm();>Submit</button></div></div>");
$templateCache.put("app/components/modal/login-loader/login-loader.modal.html","<!-- Scheme List--><div class=modal-content id=loginLoader tabindex=-1><div class=\"modal-body main-loader\"><p class=blacktintLoad></p><div class=\"loader-box-content text-center\"><p><img src=../assets/images/logo-main.png alt=HDFC></p><p><img src=../assets/images/logo.png alt=\"Partner\'s Logo\"></p><h3 class=text-primary>Welcome {{Modal.investorName || \'Investor\' | camelcase}}</h3><p>Please wait while we fetch your details.</p><img src=../assets/images/loader_web.gif alt=loader class=loader-gif><br><timer interval=1000>{{minutes}}:{{seconds}}</timer></div></div></div>");
$templateCache.put("app/components/modal/login-video/login-video.modal.html","<div class=modal-content id=loginLoader><div class=\"modal-body main-loader\" style=\"padding: 45px 15px 15px 20px\"><i class=times-icon ng-click=Modal.dismissModal();></i><iframe src=\"https://www.youtube-nocookie.com/embed/5ZxbJ38SHe0?rel=0\" frameborder=0 allow=\"autoplay; encrypted-media\" allowfullscreen></iframe></div></div>");
$templateCache.put("app/components/modal/loginWithMobile/confirmation_prompt.html","<div class=modal-header style=\"height: 44px\"><h4 class=modal-title>Welcome</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content><div class=row><div class=col-md-12><p>Dear Investor,<br>Get started with your investment journey with HDFC Mutual Fund. Please click on Proceed to begin your journey with us.</p></div></div><br><div class=row><div class=col-md-12><button class=wBtn ng-click=Modal.closeModal() style=\"padding: 0px !important;\n                text-transform: none;\n                font-size: 16px !important;\n                width: 100% !important\">Proceed</button></div></div><br></div></div>");
$templateCache.put("app/components/modal/loginWithMobile/folio-list.html","<div class=modal-header ng-class=\"{\'removeStyle\': !Modal.showMobileBelongsTo}\" style=\"height: 44px\"><h4 class=modal-title ng-if=Modal.showMobileBelongsTo>Verified Your Identity</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body style=\"width: 100%; padding: 15px !important\"><div class=content ng-if=!Modal.showMobileBelongsTo><p style=\"font-weight: 500; font-size: 14px !important; line-height: 24px;text-align: center\">Select User ID to proceed further.</p></div><div class=content ng-if=Modal.showMobileBelongsTo><p style=\"font-weight: 400; font-size: 12px !important; line-height: 12px\">Select folio in which you want to update new mobile number</p><br></div><div class=content><form><!-- mobile NO belongs to --><p ng-if=Modal.showMobileBelongsTo style=\"font-weight: bold\">Mobile number belongs to <span style=\"color: red\">*</span></p><div ng-if=Modal.showMobileBelongsTo><select id=mobileBelongsTo name=mobileBelongsTo ng-model=Modal.mobileBelongsTo required style=\"height: 40px;border-radius: 100px;width: 100%;border: 1px solid gray;margin-left: 0px;padding: 0px 0px 0px 15px\"><option value=\"\" selected>Select Value</option><option ng-repeat=\"value in Modal.belongToListMobile\" ng-selected=\"Modal.mobileBelongsTo == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><br><span ng-show=\"dobMobileForm.mobileBelongsTo.$dirty \"><span class=error-input ng-show=dobMobileForm.mobileBelongsTo.$error.required>Please select option</span></span></div><br><p style=\"font-weight: bold\" ng-if=Modal.showMobileBelongsTo>Select Folio <span style=\"color: red\">*</span></p><div style=\"max-height: 302px; overflow: auto\"><div class=folioBox ng-repeat=\"x in Modal.folioList track by $index\"><div style=\"margin: 0px 10px 0px 15px\"><input type=radio name=folioNumber ng-model=Modal.folioNumber value={{x.folioNumber}}></div><div><p style=\"font-size: 14px;font-weight: 500;line-height: 26px;text-align: left\"><span ng-if=Modal.showMobileBelongsTo>{{x.maskedFolioNumber}}</span> <span ng-if=!Modal.showMobileBelongsTo>{{x.maskedUserId}}</span></p><p style=\"font-size: 9px;font-weight: 300;line-height: 12px;text-align: left\"><span ng-if=!Modal.showMobileBelongsTo>Folio:{{x.maskedFolioNumber}} | </span>{{x.maskedMobile}} | {{x.maskedEmail}}</p></div></div></div><br><br><div class=btnDiv ng-if=Modal.showMobileBelongsTo><button class=wBtnTwo ng-click=Modal.updateContact() ng-disabled=\"!Modal.folioNumber || !Modal.mobileBelongsTo\" style=\"padding: 0px !important;text-transform: none;font-size: 16px !important;width: 100%\">Proceed &nbsp;</button></div><div class=btnDiv ng-if=!Modal.showMobileBelongsTo><button class=wBtnTwo ng-click=Modal.updateContact() ng-disabled=!Modal.folioNumber style=\"padding: 0px !important;text-transform: none;font-size: 16px !important;width: 100%\">Proceed &nbsp;</button></div><!-- <br /><br /> --></form></div></div><style>.removeStyle{\n    padding-top: 0px !important;\n    border-color: transparent !important;\n    height: unset !important;\n  }\n  @media only screen and (max-width: 768px) {\n    button {\n        width: 100% !important;\n    }\n}</style>");
$templateCache.put("app/components/modal/loginWithMobile/login_with_mobile.modal.html","<div class=modal-content><div data-ng-switch=Modal.STEPS><div data-ng-switch-when=VERIFY_PAN><div data-ng-include=\"\'app/components/modal/loginWithMobile/verify-pan-dob.html\'\"></div></div><div data-ng-switch-when=VERIFY_DOB_AND_MOBILE><div data-ng-include=\"\'app/components/modal/loginWithMobile/verify-mobile.html\'\"></div></div><div data-ng-switch-when=OTP_VERIFY><div data-ng-include=\"\'app/components/modal/loginWithMobile/otp-verify.html\'\"></div></div><div data-ng-switch-when=FOLIO_LIST><div data-ng-include=\"\'app/components/modal/loginWithMobile/folio-list.html\'\"></div></div><!-- Note message modals start --><div data-ng-switch-when=CONFIRMATION_PROMPT><div data-ng-include=\"\'app/components/modal/loginWithMobile/confirmation_prompt.html\'\"></div></div><div data-ng-switch-when=NON_INDIVIDUAL_NOTE><div data-ng-include=\"\'app/components/modal/loginWithMobile/non-individual-note.html\'\"></div></div><div data-ng-switch-when=NON_EKYC><div data-ng-include=\"\'app/components/modal/loginWithMobile/non-ekyc-note.html\'\"></div></div><div data-ng-switch-when=NON_INDIVIDUAL_NON_UPDATE><div data-ng-include=\"\'app/components/modal/loginWithMobile/non-individual-and-not-assosiate-pan-note.html\'\"></div></div><!-- Note message modals end --></div></div><style>.modal-content{\n    border-radius: 24px !important;\n  }\n  .modal-dialog {\n    width: 400px;\n    border-radius: 24px;\n  }\n  .modal-content .modal-body {\n    padding-bottom: 0px !important;\n    padding-top: 25px !important;\n  }\n  .modal-content button{\n    line-height: 2;\n  }\n  .modal-content .modal-header:before {\n    background: white;\n  }\n  .folioBox {\n    display: flex;\n    /* width: 349px; */\n    min-height: 50px;\n    border: 1px solid #d3d2d2;\n    border-radius: 10px;\n    margin: 10px 0px 10px 0px;\n    padding-top: 3px;\n  }\n  .wBtn:after {\n    content: url(\'../../../assets/images/arrow-white-small.svg\');\n  }\n  .wBtn:disabled {\n    opacity: 60% !important;\n    cursor: not-allowed;\n  }\n  .wBtnTwo {\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border: none;\n    color: white;\n    width: 300px;\n    height: 48px;\n    text-align: center;\n    text-transform: none !important;\n    padding: 0px !important;\n    align-items: center;\n    font-size: 16px !important;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 100px;\n    transition: background-color 0.3s;\n  }\n  .wBtnTwo:disabled {\n    cursor: not-allowed;\n    opacity: 60%;\n  }\n  .panControl:focus {\n    border: 1px solid gray !important;\n  }\n  .dobControl:focus {\n    border: 1px solid gray !important;\n  }\n  .mobileInput {\n    padding: 0px 0px 0px 10px;\n    height: 45px;\n    width: 84%;\n    border: none;\n    border-radius: 30px;\n  }\n  .mobileInput:focus{\n    border: none !important;\n  }\n  .newinvestor-dob:f{\n    border: none !important;\n  }\n  .verticalLine {\n    border-right: 1px solid gray;\n    height: 34px;\n  }\n  .otp-number-box {\n    width: 15.1%;\n    border: none !important;\n    border-bottom: 1px solid gray !important;\n    border-radius: 0px !important; \n  }\n  @media only screen and (max-width: 767px) {\n    .modal:before {\n        display: inline-block;\n    }\n  }</style>");
$templateCache.put("app/components/modal/loginWithMobile/non-ekyc-note.html","<div class=modal-header><h4 class=modal-title>Note:</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body style=\"width: 100%; padding: 15px !important\"><div class=content><img src=assets/images/icons/saved.png alt=\"\"><p style=\"font-weight: 500; font-size: 14px; line-height: 24px\">It seems like your KYC is not verified. Complete KYC with quick easy steps.</p><button class=wBtn ng-click=Modal.startKyc() style=\"padding: 0px !important;\n        text-transform: none;\n        font-size: 16px !important;\n        width: 100%\">Start KYC&nbsp;</button></div></div>");
$templateCache.put("app/components/modal/loginWithMobile/non-individual-and-not-assosiate-pan-note.html","<div class=modal-header><h4 class=modal-title>Note:</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body style=\"width: 100%;padding: 0px\"><div class=content style=\"text-align: center\"><p style=\"font-weight: 500; font-size: 12px !important; line-height: 24px\">Currently we do not support folio creation for your PAN. Please create folio through physical mode and submit request for enabling transactions online in your folio</p><button ng-click=\"Modal.dismissModal(\'logout\');\" style=\"height: 48px;\n    color: white;\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%);margin: 15px 0px 15px 0px\">Okay</button></div><br></div><style>p{\n        margin-bottom: 12px;\n    }</style>");
$templateCache.put("app/components/modal/loginWithMobile/non-individual-note.html","<div class=modal-header><h4 class=modal-title>Note:</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body style=\"width: 100%; padding: 15px !important\"><div class=content><p style=\"font-weight: 500; font-size: 14px; line-height: 24px\">Entered mobile number not found for your PAN. <span style=\"color: blue;cursor: pointer\" ng-click=\"Modal.dismissModal(\'logout\')\">Click here</span> to login using User ID.</p></div></div>");
$templateCache.put("app/components/modal/loginWithMobile/otp-verify.html","<div class=modal-header><h4 class=modal-title>Enter OTP</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content><form autocomplete=off name=\"\" novalidate><div class=\"normal-wrap clearfix\"><div class=sip-form-box><div class=row><div><div class=form-group style=\"margin: 5px\"><label>{{Modal.otpMessage}}</label><div class=\"input-select input-normal\"><!-- OTP code Start--><div class=otp-input-container><div class=input-code><div class=input-otp-box style=\"display: flex\"><input type=tel id=otp-number-input-1 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp1 is-number autofocus easyassist-key=mask-element style=\"border: none !important;\n                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"> <input type=tel id=otp-number-input-2 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp2 is-number easyassist-key=mask-element style=\"border: none !important;\n                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"> <input type=tel id=otp-number-input-3 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp3 is-number easyassist-key=mask-element style=\"border: none !important;\n                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"> <input type=tel id=otp-number-input-4 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp4 is-number easyassist-key=mask-element style=\"border: none !important;\n                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"> <input type=tel id=otp-number-input-5 class=otp-number-box minlength=1 tabindex=5 onpaste=handlePaste(event) maxlength=1 autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp5 is-number easyassist-key=mask-element style=\"border: none !important;\n                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"> <input type=tel id=otp-number-input-6 class=otp-number-box minlength=1 maxlength=1 onpaste=handlePaste(event) autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otp6 is-number easyassist-key=mask-element style=\"border: none !important;\n                          border-bottom: 1px solid gray !important;width: 12%;margin: 8px\"></div></div></div><br><!-- OTP code End --><div style=\"float: right;margin-right: 8px\"><span class=forgot><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=inputTxt style=\"font-size: 13px;top:60px;right: 20px\">Resend OTP in 00:{{countdown}}s</span><div><span class=inputTxt><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Modal.resendotp() style=\"font-size: 13px;top:55px;right: 20px\">Resend OTP</a></span></div></timer></span></div><br><br><span class=highlight></span> <span class=bar></span><div class=btnDiv><button class=wBtnTwo ng-click=Modal.verifyotp() ng-disabled=\"!Modal.otp1 || !Modal.otp2 || !Modal.otp3 || !Modal.otp4 || !Modal.otp5 || !Modal.otp6\" style=\"padding: 0px !important;text-transform: none;font-size: 16px !important;width: 100%\">Verify OTP</button></div></div></div></div></div></div></div></form></div></div><script>// const $inp = $(\".otp-number-box\");\n  $(\".otp-number-box\").on({\n    paste(ev) { // Handle Pasting \n      const clip = ev.originalEvent.clipboardData.getData(\'text\').trim();\n      // Allow numbers only\n      if (!/\\d{6}/.test(clip)) return ev.preventDefault(); // Invalid. Exit here\n      // Split string to Array or characters\n      const s = [...clip];\n      // Populate inputs. Focus last input.\n      $(\".otp-number-box\").val(i => s[i]).eq(5).focus();\n    }\n  });\n  function handlePaste(event) {\n    const clipboardData = event.clipboardData || window.clipboardData;\n    const pastedData = clipboardData.getData(\'Text\');\n    //  only proceed if pasted data is exacly 6 digits \n    otpData = parseInt(pastedData); \n    const otpPattern = new RegExp(\"^[0-9]\");  \n    validOTP =  otpPattern.test(otpData); \n    if (!validOTP || pastedData && pastedData.length >6) return; \n    if (pastedData && pastedData.length && pastedData != \"\") {\n      var scope = angular.element(document.body).injector().get(\'$rootScope\');\n      scope.otpPasteInVariable(pastedData);\n      if (/^\\d{6}$/.test(pastedData)) {\n        const inputs = document.querySelectorAll(\'.input-otp-box input\');\n        inputs.forEach((input, index) => {\n          input.value = pastedData[index] || \'\';\n        });\n        //  Focus the last input field after pasting\n        event.preventDefault();\n      }\n    }\n  }</script>");
$templateCache.put("app/components/modal/loginWithMobile/verify-mobile.html","<div class=modal-header><h4 class=modal-title>Enter Details</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content><form name=dobMobileForm autocomplete=off><div class=\"normal-wrap clearfix\"><div class=sip-form-box><div class=form-group><p style=\"font-size: 13px !important;font-weight: 400;line-height: 28px !important\">Mobile no. <span>({{Modal.logedInMaskMobile}})</span> is not registered against entered PAN. To continue, we need your registered mobile no. to update new mobile no. or you can login with registered no.</p><br><!-- mobile no --><div class=mobileNumberInputGroup><label style=\"padding: 0px 10px 0px 10px; color: black\">+91</label><div class=verticalLine></div><input type=text autocomplete=off class=mobileInput name=mobileNumber id=mobile_number ng-model=Modal.mobileNumber pattern=[6789][0-9]{9} ng-change=Modal.getMobileNumber() onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" placeholder=\"10-digit mobile number\" maxlength=10 minlength=10 required></div><div><p class=mod-error-msg ng-show=\"dobMobileForm.mobileNumber.$dirty && dobMobileForm.mobileNumber.$invalid && !dobMobileForm.mobileNumber.$error.required\">{{Modal.VALIDATE_CONST.MOBILE_FIELD}}</p><p class=mod-error-msg ng-show=\"dobMobileForm.mobileNumber.$dirty && dobMobileForm.mobileNumber.$error.required\">{{Modal.VALIDATE_CONST.MOBILE_REQUIRED}}</p></div><br><div style=\"display: flex;justify-content: center;align-items: center\"><p style=\"border: 1px dashed gray;width: 45%\"></p><p>&nbsp;OR&nbsp;</p><p style=\"border: 1px dashed gray;width: 45%\"></p></div><div style=\"display: flex;justify-content: center;align-items: center\"><p ng-click=\"Modal.dismissModal(\'HOME_STATE\');\" style=\"color: #032AF9;font-size: 14px !important\">Login with Registered No.</p></div><br><button class=wBtn ng-click=Modal.verifyDOBMobile() ng-disabled=dobMobileForm.$invalid style=\"padding: 0px !important;text-transform: none;font-size: 16px !important;width: 100%\">Proceed &nbsp;</button></div></div></div></form></div></div><style>.mobileNumberInputGroup {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    box-sizing: border-box;\n    background: white;\n    width: 100%;\n    height: 48px;\n    border: 1px solid #BDBCBD;\n    border-radius: 100px;\n  }\n  .wBtn:after{\n    position: static !important;\n  }\n  @media screen and (max-width: 768px) {\n    .wBtn {\n      width: 100% !important;\n    }\n  }</style>");
$templateCache.put("app/components/modal/loginWithMobile/verify-pan-dob.html","<div class=modal-content><div class=modal-header><h4 class=modal-title>Enter PAN</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content><form name=panForm autocomplete=off><div class=\"normal-wrap clearfix\"><div class=sip-form-box><div class=row><div><div class=form-group><label><b>PAN</b></label><div class=\"input-select input-normal\" ng-class=\"{\'anything-disabled\':Modal.modalData.data.pan}\"><input type=text id=pan name=pan class=panControl maxlength=10 minlength=10 placeholder=Eg.ABCDE1234A ng-pattern=/^[A-Z]{3}[A-Z][A-Z][0-9]{4}[A-Z]$/ ng-class=\"{\'errorBorder\':panForm.pan.$dirty && panForm.pan.$invalid}\" style=\"border-radius: 24px;\n                      margin-top: 12px;\n                      height: 48px;\n                      padding: 0px 0px 0px 15px\" ng-model=Modal.panNumber autocomplete=off capitalize required><div ng-show=\"panForm.pan.$dirty && panForm.pan.$invalid\"><p class=mod-error-msg ng-show=panForm.pan.$error.required ng-bind=Modal.VALIDATE_CONST.PAN_REQUIRED></p><p class=mod-error-msg ng-show=panForm.pan.$error.maxlength ng-bind=Modal.VALIDATE_CONST.PAN_FIELD></p><p class=mod-error-msg ng-show=panForm.pan.$error.pattern ng-bind=Modal.VALIDATE_CONST.PAN_FIELD></p></div><p class=mod-error-msg ng-if=Modal.panMessage ng-bind=Modal.panMessage></p></div><!-- DOB --><div class=dob-input-container><label for=dobId style=\"margin: 5px 0px 10px 0px\">Date of Birth</label><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode=days data-date-default=Modal.dob data-on-date-change=Modal.changeStartDate maxdate=now format=DD-MM-YYYY id=endDate style=\"margin-bottom: 0px\"><input class=dobControl id=dobId name=dob type=text autocomplete=off placeholder=DD-MM-YYYY ng-keyup=Modal.autoDate() easyassist-key=mask-element ng-pattern=/^\\d{2}[./-]\\d{2}[./-]\\d{4}$/ style=\"height: 48px;\n                        border-radius: 100px;\n                        border: 1px solid #b8c6d1;\n                        padding: 0px 0px 0px 15px\" required> <span class=input-group-addon style=\"right: 20px; top: 20px\"><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png width=18px></span><p class=mod-error-msg ng-if=Modal.dateErrorMessage ng-bind=Modal.dateErrorMessage></p><p class=mod-error-msg ng-if=Modal.doberrormsg ng-bind=Modal.doberrormsg></p></div></div><br><button class=wBtn ng-click=Modal.verifypan() ng-disabled=\"!Modal.panNumber || !Modal.dob\" style=\"padding: 0px !important;\n                    text-transform: none;\n                    font-size: 16px !important;\n                    width: 100% !important\">Proceed</button></div></div></div></div></div></form></div></div></div><style>.wBtn:after{\n    position: static !important;\n  }\n  .panControl{\n    border: 1px solid #b5b1b1 !important;\n  }\n  .errorBorder{\n    border: 1px solid red !important;\n  }</style>");
$templateCache.put("app/components/modal/loginWithMobileContactUpdateNJ/loginWithMobileContactUpdateNJ.modal.html","<div class=modal-header style=\"height: 44px\"><h4 class=modal-title>Note</h4><i class=times-icon ng-click=Modal.closeModal();></i></div><div class=modal-content><div class=modal-body><form autocomplete=off><p style=\"text-align: center\"></p><p>Your mobile number (+91{{Modal.maskedMobileNo}}) shall get updated in new folio</p><p></p><div class=\"d-flex justify-content-center mt-4\"><button class=wBtn style=\"width: 157px;height: 27px\" ng-click=Modal.closeModal()>OK</button></div></form></div></div>");
$templateCache.put("app/components/modal/loginWithMobileNoteNJ/loginWithMobileNoteNJ.modal.html","<div class=modal-content><div class=modal-body><form autocomplete=off><p style=\"text-align: center\">{{Modal.modalData.text}}</p><div class=\"modal-multiple-action text-center\"><button ng-click=Modal.closeModal() class=\"btn btn-primary-action\" style=\"width: 200px;margin: 20px\">{{Modal.modalData.buttonText}}</button></div></form></div></div>");
$templateCache.put("app/components/modal/mobiletnc/mobiletnc.modal.html","<div class=modal-content id=tnc><div class=modal-head><h3 class=modal-title>TERMS AND CONDITIONS</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><ng-bind-html dynamic=Modal.dynamicDataTncGeneral></ng-bind-html></div>");
$templateCache.put("app/components/modal/modifyBank/addSuccess.modal.html","<div class=\"modal-content modifyBank\" id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div class=text-center><i class=verify-icon></i></div><p>Your request to <strong class=blackIt>‘Add New bank’</strong> to Folio No.<br>{{Modal.folioId}} is sent successfully.<br><br>It would take upto 7 working days to verify and<br>update new bank with your folio.</p><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/modifyBank/changeDefaultBank.modal.html","<div class=\"modal-content deleteBank\" id=initiateTransactionMsg><div class=modal-head><h3>Change Default Bank</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p>Folio No: <span class=blackIt>{{Modal.folioId}}</span></p><div ng-repeat=\"banks in Modal.bankDetails\"><div class=radio-block ng-if=!banks.defaultBank><span class=radio><input name=changeDefaultCheck ng-model=Modal.selectedModifyBank ng-value=banks ng-change=Modal.changeModifyDefaultBank(banks) type=radio> <span class=check></span> </span><span class=radio-label>{{banks.bankName}}<label class=info-primary easyassist-key=mask-element>({{banks.accountNumber}})</label><!--<span ng-if=\"Modal.selectedDefault === $index\" class=\"info-primary\">(Default)</span> --></span></div></div><!--<div class=\"col-md-12\">\n      <div class=\"radio-block\">\n          <span class=\"radio\">\n            <input type=\"radio\"/>\n            <span class=\"check\"></span>\n          </span>\n        <span class=\"radio-label\">Bank 2</span>\n      </div>\n    </div>\n    <div class=\"col-md-12\">\n      <div class=\"radio-block\">\n          <span class=\"radio\">\n            <input type=\"radio\"/>\n            <span class=\"check\"></span>\n          </span>\n        <span class=\"radio-label\">Bank 3</span>\n      </div>\n    </div>--><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" ng-click=Modal.closeModal()>Cancel</button> <button ng-disabled=!Modal.selectedModifyBank class=\"btn btn-primary-action\" ng-click=Modal.submitModifyDefaultBank()>Submit</button></div></div></div>");
$templateCache.put("app/components/modal/modifyBank/changeSuccess.modal.html","<div class=\"modal-content modifyBank\" id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div class=text-center><i class=verify-icon></i></div><p>Your request to <strong class=blackIt>\'Change Of bank’</strong> to Folio No.<br>{{Modal.folioId}} is sent successfully.<br><br>It would take upto 7 working days to verify and<br>update new bank with your folio.</p><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/modifyBank/deleteBank.modal.html","<div class=\"modal-content deleteBank\" id=initiateTransactionMsg><div class=\"loader deleteBank-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-head><h3>Delete Bank</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body deleteBankModal\"><p>Folio No: <span class=blackIt>{{Modal.folioId}}</span></p><div ng-repeat=\"banks in Modal.bankDetails\"><!--<div class=\"radio-block\" ng-if=\"!banks.defaultBank\"> &lt;!&ndash; ng-class=\"{\'anything-disabled\':$index === 0}\" &ndash;&gt;\n        <span class=\"radio\">\n          <input name=\"deleteBankCheck\" ng-value=\"banks\" type=\"radio\" ng-model=\"Modal.selectedDeleteBank\" ng-change=\"Modal.changeDeleteBank(banks)\"/>\n          <span class=\"check\"></span>\n        </span>\n        <span class=\"radio-label\">{{banks.bankName}} <label easyassist-key=\"mask-element\">({{banks.accountNumber}})</label></span> &lt;!&ndash;<span ng-if=\"$index === 0\" class=\"info-primary\"> (Default) </span>&ndash;&gt;\n      </div>--><label>Please confirm if the below bank should be removed from the Folio:</label><div class=table-responsive><table class=table><tbody><tr><td class=col-2>Bank Name</td><td class=col-2>:</td><td class=col-2>{{banks.bankName}}</td></tr><tr><td class=col-2>Account Type</td><td class=col-2>:</td><td class=col-2>{{banks.accountType}}</td></tr><tr><td class=col-2>Account Number</td><td class=col-2>:</td><td class=col-2>{{banks.accountNumber}}</td></tr></tbody></table></div></div><!--<div class=\"upload-some\">\n        <span class=\"leaf-label\">Upload Bank Proof\n        <i class=\"info-icon base-tooltip\" data-bs-html=\"true\" tooltip data-bs-toggle=\"tooltip\"  data-bs-placement=\"right\" data-bs-title=\"Max file size should be less than or equal to 2 MB. File format should be tiff, tif, jpg and jpeg extension.\"></i>\n        </span>\n      <div class=\"upload-leaf\">\n        <div class=\"file-upload\">\n        <input type=\"file\" name=\"pic\" accept=\"image/tiff,image/tif,image/jpeg,image/jpg\" file-model-profile=\"Modal.chequeLeaf\"\n               upload=\"Modal.uploadChequeLeafFile(file)\" ng-model=\"Modal.deleteBank.payload.chequeLeaf\" class=\"delete-bank-file-upload\">\n          <button>Choose File</button>\n          <span ng-if=\"Modal.chooseAFile\">No File Chosen</span>\n          <span ng-if=\"Modal.deleteBank.payload.chequeLeaf\" ng-click=\"Modal.openUploadedDoc()\">{{Modal.deleteBank.payload.chequeLeaf}}</span></div>\n      </div>\n    </div>--><p class=error-msg>You can delete default bank only by making another bank as default for this folio.</p><div class=\"modal-multiple-action text-center\"><button type=button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>Cancel</button> <button ng-disabled=\"!Modal.selectedDeleteBank || Modal.chooseAFile\" class=\"btn btn-primary-action\" ng-click=Modal.submitDeleteBank()>Proceed</button></div></div></div>");
$templateCache.put("app/components/modal/modifyBank/deleteSuccess.modal.html","<div class=\"modal-content modifyBank\" id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div class=text-center><i class=verify-icon></i></div><p>Your request to <strong class=blackIt>‘Delete bank’</strong> to Folio No.<br>{{Modal.folioId}} is sent successfully.<br><br>It would take upto 7 working days to verify and<br>update new bank with your folio.</p><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/newJourneyRegistered/newJourneyRegistered.modal.html","<div class=modal-content id=register-done><div><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off><p ng-if=Modal.modalData.from class=\"text-center success-text\"><i class=verify-icon></i>Created Successfully</p><p style=\"text-align: center\">{{Modal.modalData.text}}</p><div class=\"modal-multiple-action text-center\"><button ng-click=Modal.closeModal() class=\"btn btn-primary-action\" style=\"width: 200px\">{{Modal.modalData.buttonText}}</button></div></form></div></div>");
$templateCache.put("app/components/modal/nfoEnabled/nfoEnabled.modal.html","<div class=modal-content ng-class=\"{\'sipTopup-details-modal\': Modal.modalData.showBlueBtn}\" id=disclaimerPopups><div class=modal-head><h3 ng-class=\"{\'modal-title\': Modal.modalData.showBlueBtn}\">Important Information</h3></div><div class=modal-body><div ng-class=\"{\'mb-4\': Modal.modalData.showBlueBtn,\'imp-info\' : !Modal.modalData.showBlueBtn}\"><p>{{Modal.modalData.message}}</p></div><div class=text-center><button ng-class=\"{\'set-btn-blue\': Modal.modalData.showBlueBtn}\" class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/nfoTransactionNotes/nfoTransactionNotes.modal.html","<div class=modal-content id=disclaimerPopups><div class=modal-head><h3>Important Information</h3></div><div class=modal-body><div class=transaction-notes><div class=tab-body><div class=\"point-to-note imp-info\"><p><i class=dot></i> <span>STP during NFO would be available only under FSTP option. The first installment for STP application received for monthly / quarterly frequency would be processed on the allotment date irrespective of the transfer date opted by the investor. However, subsequent transfers would be processed on the date opted by the investor.<br>In respect of STP instalments for daily and weekly frequencies falling upto the NFO allotment date, STP-out will be processed as per the Applicable NAV of Transferor Scheme on the relevant instalment dates. However, STP-into the new scheme will be processed on the NFO allotment date.<br>The STP installments under Daily and Weekly frequencies falling between the NFO allotment date and scheme re-opening date, will be processed on the scheme re-opening date at applicable NAVs of Transferor and Transferee Scheme.</span></p><p><i class=dot></i> <span>Applications received under FSTP during NFO would be accepted only upto 1 day prior to NFO closure date. For applications submitted on the last day of the NFO, the STP would commence post reopening of scheme, on the installment date chosen by the investor.</span></p><p><i class=dot></i> <span>HDFC Mutual Fund/ AMC may from time to time add/ alter/ amend the rules for processing STP applications during NFO. HDFC Mutual Fund/ AMC has the right to process applications received during the NFO in a manner it may deem fit and has the right to reject any application.</span></p></div></div></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/nonTransactionalTnc/nonTransactionalTnc.modal.html","<div class=modal-content id=tnc><div data-ng-switch=Modal.modalData.type><div data-ng-switch-when=KYC><div data-ng-include=\"\'app/components/modal/nonTransactionalTnc/tncKycUpdate.html\'\"></div></div><div data-ng-switch-when=FATCA><div data-ng-include=\"\'app/components/modal/nonTransactionalTnc/tncFatcaUpdate.html\'\"></div></div><div data-ng-switch-when=COBM><div data-ng-include=\"\'app/components/modal/nonTransactionalTnc/tncCobm.html\'\"></div></div></div></div>");
$templateCache.put("app/components/modal/nonTransactionalTnc/tncCobm.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – Change of Bank Mandate</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><!--handling for mobile--><ng-bind-html dynamic=cobmTerms></ng-bind-html><nonterms-condition transaction-type=COBM terms-condition-dynamic=Modal.modalData.dynamicTransactionData></nonterms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to\n      the respective Scheme(s) under the Scheme Information Document(s), Statement of Additional Information, and the\n      Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer\n      Documents</strong>”) (Please visit the “Download” section on our website <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n       {{Modal.HDFC_API.WEBSITE_LINK}} </a> to read) and the terms\n      and conditions for change of bank mandate (please <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}CMT/UPLOAD/ARTICLEATTACHMENTS/CTR_Non_Financial_Transaction_15062016.pdf\" class=\"text-primary\"\n      target=\"_blank\"> <strong>click\n      here</strong></a> to read), and hereby apply to the Trustee of HDFC\n      Mutual Fund for change of bank mandate registered in my folios with HDFC MF. I hereby also confirm to have read,\n      understood, and agree to abide by the Terms applicable to this Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong> to read).\n    </li>\n    <li>\n      I/We shall be solely responsible for ensuring that all information relating to bank account provided to HDFC\n      AMC/HDFC MF, including the bank account number, is accurate, and HDFC AMC/HDFC MF shall not be responsible to\n      verify the accuracy of the information/details provided. The requirement to upload my/our cheque leaf of my bank\n      account on the Platform does not impose any obligation on HDFC AMC/HDFC MF to verify the details of the bank\n      account provided by me/us on the Platform. I/We shall also be liable to inform HDFC AMC/HDFC MF/Registrar and\n      Transfer Agent of any change in any details or information provided initially. If any incorrect bank account\n      number is provided by me, the redemption proceeds could be credited to the said wrong bank account so provided by\n      me/us and there is no guarantee of recovery of the same. HDFC AMC/HDFC MF shall not be held liable for any loss or\n      damage that may be sustained by me/us on account of such error on my/our part.\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/nonTransactionalTnc/tncFatcaUpdate.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – FATCA & CRS Update</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><nonterms-condition transaction-type=FATCA></nonterms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to\n      the respective Scheme(s) under the Scheme Information Document(s), Statement of Additional Information, and the\n      Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer\n      Documents</strong>”) inter alia provisions on \'Foreign Account Tax Compliance Act (FATCA) and Common Reporting\n      Standards\n      (CRS) on Automatic Exchange of Information (AEOI) (Please visit the “Download” section on our website\n      <a\n        href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  class=\"text-primary\" target=\"_blank\">\n        {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and the terms and conditions for FATCA and CRS certification (please <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}CMT/UPLOAD/ARTICLEATTACHMENTS/FATCA_INDIVIDUAL_AADHAR_FORM.pdf\" class=\"text-primary\"\n      target=\"_blank\"> <strong>click\n      here</strong></a>\n      to read), and hereby apply to the Trustee to update the information provided by me on the Platform. I hereby also\n      confirm to have read, understood, and agree to abide by the Terms applicable to this Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong>\n      to read).\n    </li>\n    <li>\n      I/We hereby confirm that the information provided by me/us is true, correct, and complete.\n    </li>\n    <li>\n      I/We hereby agree and confirm to inform HDFC AMC/HDFC MF/ Trustees promptly of any modification to the\n      information provided initially. I further agree to abide by the provisions of the Scheme related documents.\n    </li>\n    <li>\n      I/We hereby authorize you to disclose, share, remit in any form/manner/mode the above information and/or any\n      part of it including the changes/updates that may be provided by me/us to HDFC AMC/HDFC MF/ its Sponsor(s)/\n      Trustees, its employees, agents and third party service providers, SEBI registered intermediaries for single\n      updation/ submission, any Indian or foreign statutory, regulatory, judicial, quasi- judicial authorities/agencies\n      including but not limited to Financial Intelligence Unit-India (FIU-IND) etc without any intimation/advice to\n      me/us.\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/nonTransactionalTnc/tncKycUpdate.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – Supplementary KYC Update</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><nonterms-condition transaction-type=KYC></nonterms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to\n      the respective Scheme(s) under the Scheme Information Document(s), Statement of Additional Information, and the\n      Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer\n      Documents</strong>”) (Please visit the “Download” section on our website <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\" target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and the terms\n      and conditions for supplementary KYC update (please <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}CMT/UPLOAD/ARTICLEATTACHMENTS/Supplementary_CKYC_Application_Form_20-01-2017_(Editable PDF)31012017.pdf\"\n      class=\"text-primary\"\n      target=\"_blank\"> <strong>click\n      here</strong></a> to read), and hereby apply to the Trustee to update\n      the information provided by me on the Platform. I hereby also confirm to have read, understood, and agree to abide\n      by the Terms applicable to this Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong> to read).\n    </li>\n    <li>\n      I/We hereby declare that the details furnished by me are true and correct to the best of my/our knowledge and\n      belief and I/we undertake to inform you of any changes therein, immediately. In case any of the above information\n      is found to be false or untrue or misleading or misrepresenting, I/we am/are aware that I/we may be held liable\n      for it. I/we hereby declare that I/we am/are not making this application for the purpose of contravention of any\n      Act, Rules, Regulations or any statute of legislation or any notifications/directions issued by any governmental\n      or statutory authority from time to time.\n    </li>\n    <li>\n      I/We hereby authorize you to disclose, share, remit in any form/manner/mode the above information and/or any\n      part of it including the changes/updates that may be provided by me/us in such manner and to such authorities as\n      may be required under the provisions of applicable laws.\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/notification/notification.modal.html","<div class=modal-content ng-init=Modal.init()><div class=modal-head><h3 class=modal-title>Notification Details</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><table class=\"table borderless\"><tr><td>Created Date :</td><td>{{Modal.notificationDetails.createdDate}}</td></tr><tr><td>Title :</td><td>{{Modal.notificationDetails.title}}</td></tr><tr><td>Description :</td><td>{{Modal.notificationDetails.description}}</td></tr></table></div></div>");
$templateCache.put("app/components/modal/notificationModal/nomineeUpdateNotification.modal.html","<div class=\"modal-content imp-notification-on-login\" ng-init=Modal.init()><div class=modal-head><h3 class=modal-title>Important Notification</h3></div><div class=modal-body><p ng-bind-html=Modal.modalData.text></p><!--    <p class=\"mt-3 mb-3\">Please nominate or opt-out of nomination for following folios.</p>--><div class=table-container ng-class=\"{\'overflow-height\': Modal.modalData.folioList.length > 3}\"><table class=table><thead><tr><th>SRN</th><th style=\"text-transform: none\">Folio</th></tr></thead><tbody><tr ng-repeat=\"data in Modal.modalData.folioList track by $index\"><td>{{$index + 1}}</td><td>{{data}}</td></tr></tbody></table></div><div class=text-center style=\"padding-top: 20px\"><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/nudgeReasons/nudgeReasons.modal.html","<div class=modal-content ng-if=\"Modal.reasonsList.length > 0\"><div class=\"modal-body form-wrapper ng-scope\"><div><span>{{Modal.modalData.Text}}</span> <i class=times-icon ng-click=Modal.dismissModal();></i></div><br><div class=\"form-group nudge-popup\" ng-if=!Modal.showSipNudge><div class=radio-block style=\"display: block; margin-bottom: 0.5rem\" ng-repeat=\"reasons in Modal.reasonsList\"><span class=radio><input type=radio name=nudgeReason ng-value=reasons ng-model=Modal.nudgeReason ng-change=Modal.nudgeReasonChange(reasons)> <span class=check></span> </span><span class=radio-label>{{reasons}}</span></div></div><div class=\"form-group nudge-popup\" ng-if=Modal.showSipNudge><div class=radio-block style=\"display: block; margin-bottom: 0.5rem\" ng-repeat=\"reasons in Modal.reasonsList\"><span class=radio><input type=radio name=nudgeReason ng-value=reasons.reasonCode ng-model=Modal.reasonCode ng-change=Modal.nudgeReasonChange(reasons)> <span class=check></span> </span><span class=radio-label>{{reasons.reasonDetail}}</span></div></div><div ng-if=\"Modal.nudgeReason === \'Other\' || Modal.nudgeReason === \'Others\'\"><textarea name=nudgeOtherReason style=\"width: 100%;resize: none\" rows=4 placeholder={{Modal.placeHolderText}} ng-model=Modal.nudgeOtherReason ng-attr-maxlength={{Modal.maxLength}}></textarea></div><br><br><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-primary-action\" ng-disabled=\"!Modal.nudgeReason || (Modal.nudgeReason ===\'Other\' && !Modal.nudgeOtherReason)\" ng-click=Modal.approveRedemption() ng-if=\"!Modal.buttonProceed && !Modal.modalData.buttonProceed\">Submit</button> <button class=\"btn btn-primary-action\" ng-disabled=\"!Modal.nudgeReason || (Modal.nudgeReason ===\'Other\' && !Modal.nudgeOtherReason) || (Modal.nudgeReason ===\'Others\' && !Modal.nudgeOtherReason)\" ng-click=Modal.approveSipCancel($event) ng-if=Modal.modalData.buttonProceed>Submit</button></div></div></div>");
$templateCache.put("app/components/modal/offlineNomineeForm/offLineNominee.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope\"><div class=offline-nominee-modal><div class=offline-form-msg>{{Modal.modalData.message}} <a href=https://files.hdfcfund.com/s3fs-public/2020-07/MF-Nomination%20Form.pdf target=_blank style=\"color: blue\">Click here</a></div><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.dismissModal()>OK</button></div></div></div></div>");
$templateCache.put("app/components/modal/oneclickpanaadharstatus/oneclickpanaadharstatus.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope\"><div><p ng-bind-html=Modal.modalData.text></p></div><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.dismissModal()>OK</button></div></div></div><style>a{\n      color: #2485bd !important;\n    }</style>");
$templateCache.put("app/components/modal/optOutNominee/optOutNominee.modal.html","<div class=modal-content id=initiateTransactionMsg ng-if=!Modal.oneClickNomineeoptout><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><p ng-bind-html=Modal.modalData.text></p><button type=submit ng-click=Modal.closeModal() class=\"btn btn-primary-action\" style=\"background: #1b4b86; text-transform: none\">{{Modal.modalData.ctaText}}</button></div></div><div class=modal-content ng-if=Modal.oneClickNomineeoptout><i class=times-icon ng-click=Modal.closeModal();></i><div class=modal-body><p>You have not nominated OR opted-out of nomination in your folio {{Modal.foliNumber}}. We recommend you to add nominee details in your folio. Please <span><a href=https://digital.camsonline.com/changeofnomination target=_blank style=\"color: #1b4b86\">Click Here</a> </span>for adding nominee details OR opting out of nomination.</p></div></div>");
$templateCache.put("app/components/modal/otp/nomineeUpdate.modal.html","<!-- Otp verification--><div class=modal-content id=nominee-otp><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Investor Verification</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=Modal.otpForm autocomplete=off ng-submit=Modal.confirmOtpUpdateNominee() class=otp-modal-form novalidate><p class=otp-info ng-bind=Modal.modalData.message></p><div class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text ng-pattern=Modal.appConstants.otp_regex ng-model=Modal.otpNumber name=otpNumber required minlength=6 maxlength=6 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Enter OTP</label><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=error-input ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.maxlength>{{ Modal.validateData.OTP_FIELD }}</span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.pattern>{{ Modal.validateData.OTP_FIELD }}</span></span><div style=\"padding-top: 10px\"><span ng-bind=Modal.otpResendMessage style=\"color: #1bb898\">OTP sent</span><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.resendOtpNomineeUpdate() class=pull-right ng-disabled=Modal.isProcessing>Resend OTP</a> <a ng-show=\"countdown > 0\" style=\"float:right;font-size: 12px !important\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><div class=text-center><button style=\"margin: 0 auto\" type=submit ng-disabled=\"Modal.otpForm.$invalid || Modal.isProcessing\" class=\"btn btn-primary-action btn-block\">Submit</button></div></form></div></div>");
$templateCache.put("app/components/modal/otp/otp-verification.modal.html","<!-- Otp verification--><div class=modal-content id=signUp-otp><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Investor Verification</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=Modal.otpForm autocomplete=off ng-submit=Modal.confirmTransaction() class=otp-modal-form novalidate><p class=otp-info>An OTP has been sent to your Registered Email Id/Mobile Number.<br>Please enter the OTP to verify.</p><div ng-if=\"Modal.modalData.summaryType == \'one-click-schedule-purchase\'\"><div><p>PAN</p></div><div class=\"group input-normal\"><input type=text name=panNumber maxlength=10 minlength=10 class=form-control ng-pattern=/^[A-Z]{5}[0-9]{4}[A-Z]$/ ng-model=Modal.panNumber capitalize placeholder=\"e.g. ABCDE1234A\" required autocomplete=off ng-blur=Modal.checkPanVerification()> <span ng-messages=Modal.otpForm.panNumber.$error ng-show=\"Modal.otpForm.panNumber.$dirty && Modal.otpForm.panNumber.$invalid\"><span class=error-input ng-message=required ng-bind=Modal.validateData.PAN_REQUIRED></span> <span class=error-input ng-message=minlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-message=maxlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-message=pattern ng-bind=Modal.validateData.PAN_FIELD></span></span></div><div><p>Date of Birth</p></div><div class=\"group input-normal\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{Modal.viewMode}} data-date-default=Modal.dob data-max-date=Modal.maxDate data-on-date-change=Modal.changeStartDate maxdate=now format=DD-MM-YYYY id=endDate style=\"height: 40px;border-radius: 5px;margin-bottom: 5px;border-bottom: 1px solid #B8C6D1\"><input class=newinvestor-dob tabindex=2 id=dobId name=dob type=text autocomplete=off onkeypress=\"return event.charCode >= 45 && event.charCode <= 57\" maxlength=10 ng-pattern=/^\\d{2}[./-]\\d{2}[./-]\\d{4}$/ placeholder=dd-mm-yyyy ng-keyup=Modal.autoDate() style=\"border: none\" easyassist-key=mask-element required> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png></span></div><span class=error-input ng-if=Modal.dateErrorMessage ng-bind=Modal.dateErrorMessage></span></div></div><div class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text ng-pattern=Modal.appConstants.otp_regex ng-model=Modal.otpNumber name=otpNumber required minlength=6 maxlength=6 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Enter OTP</label><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=error-input ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.maxlength>{{ Modal.validateData.OTP_FIELD }}</span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.pattern>{{ Modal.validateData.OTP_FIELD }}</span></span><div style=\"padding-top: 10px\" ng-if=Modal.otpValid><span ng-bind=Modal.otpResendMessage style=\"color: #1bb898\">OTP sent</span><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.resendOtp() class=pull-right ng-disabled=Modal.isProcessing>Resend OTP</a> <a ng-show=\"countdown > 0\" style=\"float:right;font-size: 12px !important\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><div class=text-center ng-if=\"Modal.modalData.summaryType != \'one-click-schedule-purchase\'\"><button type=submit ng-disabled=\"Modal.otpForm.$invalid || Modal.isProcessing || !Modal.otpValid\" class=\"btn btn-primary-action btn-block\">Submit</button></div><div class=text-center ng-if=\"Modal.modalData.summaryType == \'one-click-schedule-purchase\'\"><button type=button ng-disabled=\"Modal.otpForm.$invalid || !Modal.dob || !Modal.otpValid\" ng-click=Modal.confirmTransactionONE() class=\"btn btn-primary-action btn-block\">Submit</button></div></form></div></div>");
$templateCache.put("app/components/modal/otp/otp.modal.html","<!-- Otp verification--><div class=modal-content id=confirm-otp><div class=\"modal-body clearfix\"><i class=times-icon ng-click=Modal.dismissModal();></i><form autocomplete=off name=Modal.modalOtpForm ng-submit=Modal.verifyOtp() novalidate><p class=text-center>{{Modal.modalData.message || \'We have sent two One-time Passwords(OTPs) for authentication purpose. Both OTPs are valid for 15 minutes only.\'}}<br></p><div ng-if=\"Modal.modalData.previousContact || Modal.modalData.mail || !Modal.modalData.mail || !Modal.modalData.previousContact\" class=\"input-group input-normal\" ng-class=\"{error:Modal.modalOtpForm.otpNumber.$dirty && Modal.modalOtpForm.otpNumber.$invalid}\"><input type=text ng-model=Modal.formData.otpNumber name=otpNumber is-number ng-change=Modal.resetValues() easyassist-key=mask-element required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label ng-if=Modal.modalData.email>Enter OTP 1</label><label ng-if=Modal.modalData.contact>Enter OTP 1</label><span class=error-input style=\"position: initial !important\" ng-messages=Modal.modalOtpForm.otpNumber.$error ng-show=Modal.modalOtpForm.otpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span><p ng-if=\"Modal.modalData.text === \'Email Address\'\" style=\"padding: 12px 0\">OTP 1 sent to email ID ({{ Modal.modalData.mail || \'Not Available\' }}) and mobile number ({{Modal.modalData.previousContact || \'Not Available\'}}) registered in your profile.</p><p ng-if=\"Modal.modalData.text === \'Mobile Number\'\" style=\"padding: 12px 0\">OTP 1 sent to email ID ({{ Modal.modalData.mail || \'Not Available\' }}) and mobile number ({{Modal.modalData.previousContact || \'Not Available\'}}) registered in your profile.</p><p ng-if=\"Modal.modalData.text === \'Folio Update Details\'\" style=\"padding: 12px 0\">OTP 1 sent to <span ng-if=Modal.modalData.mail>email ID ({{ Modal.modalData.mail || \'Not Available\' }})</span> <span ng-if=\"Modal.modalData.mail && Modal.modalData.previousContact\">and</span> <span ng-if=Modal.modalData.previousContact>mobile number ({{Modal.modalData.previousContact || \'Not Available\'}})</span> registered in your folio.</p></div><div class=\"input-group input-normal\" ng-class=\"{error:Modal.modalOtpForm.newOtpNumber.$dirty && Modal.modalOtpForm.newOtpNumber.$invalid}\"><input type=text ng-model=Modal.formData.newOtpNumber name=newOtpNumber is-number ng-change=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label ng-if=Modal.modalData.email>Enter OTP 2</label><label ng-if=Modal.modalData.contact>Enter OTP 2</label><span class=error-input style=\"position: initial !important\" ng-messages=Modal.modalOtpForm.newOtpNumber.$error ng-show=Modal.modalOtpForm.newOtpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span><p ng-if=Modal.modalData.email style=\"padding: 13px 0\">OTP 2 sent to new email ID ({{Modal.modalData.email}}) entered.</p><p ng-if=Modal.modalData.contact style=\"padding: 13px 0\">OTP 2 sent to new mobile number ({{Modal.modalData.contact}}) entered.</p><span class=forgot style=\"position: relative;width: 100%;display: inline-block;text-align: right\"><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.resendOtp() class=forgot-pwd style=\"position: relative;top: 0;right: 0\">Resend OTP</a> <a ng-show=\"countdown > 0\" ng-class=\"{\'forgot-pwd-disabled\': countdown > 0}\" style=\"position: relative;top: 0;right: 0\">Enable Resend OTP in {{countdown}}s</a></timer></span></div><div class=text-center><button type=submit ng-disabled=\"Modal.modalOtpForm.$invalid || Modal.processFlag || Modal.errorMessage\" class=\"btn btn-primary-action\">Submit</button></div><!--<div ng-if=\"Modal.otpResendMessage\" class=\"form-group text-center text-blue\" style=\" margin-top:20px;\">{{Modal.otpResendMessage}}</div>--> <span class=error ng-if=Modal.errorMessage><span class=error-all-message>{{ Modal.errorMessage }}</span></span></form></div></div>");
$templateCache.put("app/components/modal/otp/otpSuccess.modal.html","<!-- Otp verification--><div class=modal-content id=confirm-otp-success><!--<div class=\"modal-header\">--><!--<h4 class=\"modal-title\">OTP Verified</h4>--> <i class=times-icon ng-click=Modal.closeModal();></i><!--</div>--><div class=modal-body><form autocomplete=off><p class=\"text-center success-text\"><i class=verify-icon></i>{{Modal.modalData.message}}</p></form><div class=text-center><button type=button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></div></div></div>");
$templateCache.put("app/components/modal/otpForApproval/nomineeUpdateVerification.modal.html","<!-- Otp verification--><div class=\"modal-content dob-otp-modal\" id=nominee-otp><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Investor Verification</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=Modal.otpForm autocomplete=off ng-submit=Modal.confirmOtpUpdateNominee() class=otp-modal-form novalidate><p class=otp-info>An OTP has been sent to your Registered Email Id/Mobile Number.<br>Please enter the OTP to verify.</p><div class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.dob.$dirty && Modal.otpForm.dob.$invalid}\"><input type=text ng-model=Modal.dob name=dob ng-change=Modal.checkValidateDOB(Modal.dob) required> <span class=highlight></span> <span class=bar></span><label>Enter Date of Birth<span class=req>*</span></label><span ng-show=Modal.otpForm.dob.$dirty><span class=error-input ng-show=Modal.otpForm.dob.$error.required ng-bind=Modal.validateData.DOB_REQUIRED_MSG></span> <span class=error-input ng-show=\"Modal.dateValidationErrorMsg && Modal.otpForm.dob\">{{Modal.dateValidationErrorMsg}}</span></span></div><div class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text ng-pattern=Modal.appConstants.otp_regex ng-model=Modal.otpNumber name=otpNumber required minlength=6 maxlength=6 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Enter OTP<span class=req>*</span></label><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=error-input ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.maxlength>{{ Modal.validateData.OTP_FIELD }}</span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.pattern>{{ Modal.validateData.OTP_FIELD }}</span></span><div style=\"padding-top: 10px\"><span ng-bind=Modal.otpResendMessage style=\"color: #1bb898\">OTP sent</span><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.resendOtpNomineeUpdate() class=pull-right ng-disabled=Modal.isProcessing>Resend OTP</a> <a ng-show=\"countdown > 0\" style=\"float:right;font-size: 12px !important\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><div class=text-center><button style=\"margin: 0 auto\" type=submit ng-disabled=\"Modal.otpForm.$invalid || Modal.isProcessing || Modal.dateValidationErrorMsg\" class=\"btn btn-primary-action btn-block\">Submit</button></div></form></div></div>");
$templateCache.put("app/components/modal/otpForPanLinkDelink/otpVerificationConfirm.modal.html","<div class=modal-content ng-if=\"Modal.STEPS ==\'CONFIRMATION_PROMPT\'\"><div class=modal-header><h4 class=modal-title>Confirm</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content><div ng-if=\"Modal.modalData.data.type == \'LINKED_PAN\'\"><p>Are you sure you want to remove PAN: {{Modal.modalData.data.maskedPan}}?</p><p>You shall not be able to view portfolio or make transactions for the specified PAN.</p></div><div ng-if=\"Modal.modalData.data.type == \'MY_PAN\'\"><p>Are you sure you want to remove linkage of your account from external PAN {{Modal.modalData.data.maskedPan}}?</p><p>NOTE: External PAN shall not longer be able to view your portfolio or transact in your PAN</p></div><br><!-- Button --><div><button class=wBtn ng-click=Modal.removePan() style=\"padding: 0px !important;text-transform: none;font-size: 16px !important;width: 100%\">&nbsp;Yes, Remove</button></div><br></div></div></div><style>.modal-dialog {\n    width: 500px;\n  }\n\n  .modal-content .modal-body {\n    border-radius: 24px;\n    padding-bottom: 0px !important;\n    padding-top: 25px !important;\n  }\n\n\n  .wBtn:before {\n    content: url(\'../../../assets/images/icons/correct-icon.svg\');\n  }\n\n  .wBtn:disabled {\n    opacity: 60% !important;\n    background: linear-gradient(94deg, #cdd7e3 -21.18%, #c3cfde 95.94%);\n    cursor: not-allowed;\n  }\n\n  .modal-content .modal-header:before {\n    background: white;\n  }</style>");
$templateCache.put("app/components/modal/otpVerificationNew/otpAutoMoveToNextField.modal.html","<!-- Otp verification--><div class=\"modal-content automoveto-next-fieldOtp-modal\"><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>OTP Verification</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body style=\"padding: 22px 20px !important\"><form autocomplete=off name=Modal.otpForm autocomplete=off ng-submit=Modal.otpVerification() class=otp-modal-form novalidate><p class=otp-info-contact>An OTP has been sent to your registered Email ID/Mobile No.</p><p class=otp-info-consent>Please enter the OTP to verify</p><div class=\"input-normal input-code\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\" ng-init=Modal.init()><div class=input-code-container><input type=tel id=otp-number-input-1 class=otp-number-input minlength=1 maxlength=1 tabindex=1 autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otpValIndex1 is-number custom-auto-focus easyassist-key=mask-element> <input type=tel id=otp-number-input-2 class=otp-number-input minlength=1 maxlength=1 tabindex=2 autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otpValIndex2 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-3 class=otp-number-input minlength=1 maxlength=1 tabindex=3 autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otpValIndex3 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-4 class=otp-number-input minlength=1 maxlength=1 tabindex=4 autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otpValIndex4 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-5 class=otp-number-input minlength=1 tabindex=5 maxlength=1 autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otpValIndex5 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-6 class=otp-number-input minlength=1 maxlength=1 tabindex=6 autocomplete=off ng-change=Modal.otpValChanged(this) ng-model=Modal.otpValIndex6 is-number easyassist-key=mask-element></div><div class=resend-otp-container><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=resend-otp-label><span class=link-text>Resend OTP</span> in <span class=counter-text>{{countdown}} sec</span> </span><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Modal.reGenerateOtp(); class=\"forgot-pwd resend-otp-txt\">Resend OTP</a></timer></div><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=\"error-input text-left\" ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=info-primary style=left:13% ng-bind=Modal.otpResendMessage></span> </span><span style=color:#46a040 class=\"common-error submit-success\" ng-bind=Modal.OTPResendMsg></span></div><div class=\"row otp-btn-container\"><button class=\"btn btn-secondary-action\" type=button ng-click=Modal.dismissModal()>Cancel</button> <button class=\"btn btn-primary-action\" type=submit ng-disabled=\"Modal.otpForm.$invalid || Modal.otpCodeLength !== 6 || !Modal.isOtpValid\">Confirm</button></div></form></div></div>");
$templateCache.put("app/components/modal/popups/add.bank.msg.html","<div class=modal-content id=disclaimerPopups><div class=modal-head><h3 class=text-center>Important Information</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=imp-info><p>Only five bank accounts can be registered in the folio, please delete existing bank account to add new one.</p></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/popups/addBank.cobm.disabled.html","<div class=modal-content id=disclaimerPopups><div class=modal-head><h3 class=text-center>Important Information</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=imp-info><p>{{Modal.modalData.isAddBank ? \'You can not add a new bank in this folio\' : \'Add New Bank is not available online for prospect folio\'}}</p></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/popups/cutoff.modal.html","<ng-bind-html dynamic=Modal.modalData.message.cutoffData.content style=\"padding-bottom:0px !important\"></ng-bind-html><div class=text-center style=\"padding:0px 45px 45px\"><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div><style>.modal-content .modal-body {\n      padding-bottom: 0px !important;\n  }</style>");
$templateCache.put("app/components/modal/popups/eCart.modal.html","<div class=modal-content><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div class=text-center>{{Modal.modalData.message}}</div><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/popups/minor.bank.html","<div class=modal-content id=disclaimerPopups><div class=modal-head><h3 class=text-center>Important Information</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=imp-info><p>Transactions are restricted with the selected bank account as per the provisions of SEBI Circular SEBI/HO/IMD/DF3/CIR/P/2019/166 dated December 24, 2019. Registered bank account(s) in the folio of a minor should be of the minor or joint account of the minor with the guardian as per the provisions of the circular. <span ng-if=\"!Modal.modalData.instantInvestment && !Modal.modalData.isFromSmartLink\">Kindly <a ng-click=Modal.redirectToAddBank() href=javaScript:void(0) style=\"text-decoration: underline !important\">Click here</a> to add minor\'s bank account and upload proof. </span><span ng-if=Modal.modalData.instantInvestment>add minor\'s bank account for the folio.</span></p></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/popups/minor.purchase.modal.html","<div class=modal-content id=disclaimerPopups><div class=modal-head><h3 class=text-center>Important Information</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=imp-info><p>As per provisions of SEBI circular SEBI/HO/IMD/DF3/CIR/P/2019/166 dated December 24, 2019, registered bank account(s) in the folio of a minor should be of the minor or joint account of the minor with the guardian as per provisions of the circular. In order to comply with this SEBI requirement, <strong>\'NEFT/RTGS\'</strong> and <strong>\'HDFC Fund Transfer\'</strong> payment modes would not be available. Kindly proceed with <strong>Net Banking, OTM</strong> or <strong>UPI</strong> payment mode as applicable.</p></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/popups/minor.sip.modal.html","<div class=modal-content id=disclaimerPopups><div class=modal-head><h3>Important Information</h3><div><i class=times-icon ng-click=Modal.dismissModal();></i></div></div><div class=modal-body><div class=imp-info><p>As per provisions of SEBI circular SEBI/HO/IMD/DF3/CIR/P/2019/166 dated December 24, 2019, registered bank account(s) in the folio of a minor should be of the minor or joint account of the minor with the guardian as per provisions of the circular. In order to comply with this SEBI requirement, Standing instruction payment mode would NOT be available for SIP transaction. Kindly proceed with OTM payment mode if you have registered or, register fresh OTM for minor folio.</p></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/popups/purchaseLiquid.modal.html","<!-- Scheme List--><div class=modal-content id=disclaimerPopups><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=text-center>Important Information</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--><div class=modal-body><div>Change in uniform cut-off timing for applicability of NAV for Liquid Schemes / Plans. Please <u class=\"cursor-pointer text-blue\" ng-click=Modal.openLink()>Click here </u>to view Addendum.</div><div class=imp-info><p><i class=dot></i> <span>Please note that the Net Asset Value (NAV) applicability depends on <strong><u>the entire amount of subscription / purchase as per the application is credited to the bank account of the respective Liquid Schemes / Plans before the cutoff time i.e. available for utilization before the cut-off time.</u></strong></span></p><p><i class=dot></i> <span>There could be a time lag between the amount of subscription being debited to your bank account and the subsequent credit into the respective schemes bank account. HDFC Asset Management Company Limited or its bankers or its service providers will not be liable for the delay and consequent pricing of units.</span></p></div><!--Forgot pwd--><!--<p class=\"text-center\">A link to reset your password has been sent to your registered email ID xyz@xyz.com</p>--><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/popups/purchaseNetBanking.modal.html","<!-- Scheme List--><div class=modal-content id=disclaimerPopups><div class=modal-head><h3 class=text-center>Important Information</h3><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--></div><div class=modal-body><p>Since your subscription request is for an amount greater than or equal to Rs. 2 lac, the applicable NAV shall be based on receipt of credit into our account. We receive credit relatively faster if you use net banking as a payment option using the following banks:</p><div class=\"imp-info clearfix\"><div class=col-md-4 style=\"padding: 0px\"><p><i class=dot></i> <span>HDFC Bank</span></p><p><i class=dot></i> <span>State Bank of India&nbsp;(SBI)</span></p><p><i class=dot></i> <span>Kotak Mahindra Bank</span></p></div><div class=col-md-4><p><i class=dot></i> <span>ICICI Bank</span></p><p><i class=dot></i> <span>Yes Bank</span></p></div><div class=col-md-4><p><i class=dot></i> <span>Axis Bank</span></p><p><i class=dot></i> <span>IDBI Bank</span></p></div></div><p>In case you wish to subscribe through a bank other than those mentioned above, there could be a time lag in receipt of credit from the time of your account being debited to the time of receiving the funds into our scheme collection account.</p><p>Alternatively, you could use Real Time Gross Settlement (RTGS) as a payment option for faster transfer of funds. Please <u class=\"cursor-pointer text-blue\" ng-click=Modal.openLink()>Click here </u>to know more on how to use RTGS for your investment?</p><!--Forgot pwd--><!--<p class=\"text-center\">A link to reset your password has been sent to your registered email ID xyz@xyz.com</p>--><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/prefill-folio/prefill.folio.modal.html","<div class=\"modal-content select-folio-modal\" id=initiateTransactionMsg><div class=modal-head><h3>Investment Details</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form name=folioForm><div class=select-folio-container><div class=row><div class=col-md-12><p class=title>Select Folio</p><div ng-class=\"{error:folioForm.folio.$dirty && folioForm.folio.$invalid}\"><select name=folio id=_first ng-change=Modal.folioChanged() ng-model=Modal.formData.folioNumber class=\"selectNormal select-folio-list\" ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Modal.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio Number</option></select><span class=error-input ng-show=\"folioForm.folio.$dirty && folioForm.folio.$invalid && folioForm.folio.$error.required\" ng-bind=Modal.VALIDATE_DATA.FOLIO_REQUIRED></span> <span class=error-input ng-show=Modal.kycVerifiedFlag ng-bind=Modal.kycMessage></span> <span class=error-input ng-show=!Modal.folioList ng-bind=Modal.VALIDATE_DATA.BASKET_NO_FOLIO></span></div></div></div></div><div class=folio-submit><button type=submit ng-disabled=folioForm.$invalid ng-click=Modal.closeModal() class=\"btn btn-primary-action\">Submit</button></div></form></div></div>");
$templateCache.put("app/components/modal/profile/addFatcaTaxResidency.modal.html","<!-- Sign up Completed--><div class=modal-content id=add-tax-residency-modal ng-init=Modal.init()><div class=\"loader taxpopup\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Add Tax Residency</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=taxResidencyModalForm ng-submit=Modal.addFatca()><div class=selectfield ng-class=\"{error:taxResidencyModalForm.birthCountry.$dirty && taxResidencyModalForm.birthCountry.$invalid}\"><select class=select-box name=birthCountry ng-model=Modal.payload.birthCountry ng-options=\"country.countryCode as country.countryName for country in Modal.countryList\" required ng-init=\"Modal.payload.birthCountry = Modal.payload.birthCountry ? Modal.payload.birthCountry :null\"><option value=\"\" selected>Name of Country</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyModalForm.birthCountry.$dirty && taxResidencyModalForm.birthCountry.$invalid\"><span class=error-input ng-show=taxResidencyModalForm.birthCountry.$error.required>{{Modal.validateData.SELECT_COUNTRY}}</span></span></div><div class=selectfield ng-class=\"{error:taxResidencyModalForm.taxIdType.$dirty && taxResidencyModalForm.taxIdType.$invalid}\"><select class=select-box name=taxIdType ng-model=Modal.payload.taxIdType ng-options=\"taxid.value as taxid.description for taxid in Modal.taxIdTypeList\" required ng-init=\"Modal.payload.taxIdType = Modal.payload.taxIdType ? Modal.payload.taxIdType : null\"><option value=\"\" selected>Select Tax Id Type</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyModalForm.taxIdType.$dirty && taxResidencyModalForm.taxIdType.$invalid\"><span class=error-input ng-show=taxResidencyModalForm.taxIdType.$error.required>{{Modal.validateData.TAX_ID_TYPE}}</span></span></div><div class=input-normal ng-class=\"{error:taxResidencyModalForm.taxIdNumber.$dirty && taxResidencyModalForm.taxIdNumber.$invalid}\"><input type=text name=taxIdNumber ng-model=Modal.payload.taxIdNumber required> <span class=highlight></span> <span class=bar></span><label>Tax ID Number<span class=\"req text-red\">*</span></label><span ng-show=\"taxResidencyModalForm.taxIdNumber.$dirty && taxResidencyModalForm.taxIdNumber.$invalid\"><span class=error-input ng-show=taxResidencyModalForm.taxIdNumber.$error.required>{{Modal.validateData.TAX_ID_NUMBER}}</span></span></div><div class=\"text-center form-footer form-content\"><!--<input type=\"button\" ng-click= \"Modal.confirmCancel()\" class=\"btn btn-secondary-action common-btn-padding\" value=\"Cancel\" />--> <input type=submit ng-disabled=\"taxResidencyModalForm.$invalid || Modal.processFlag\" class=\"btn btn-primary-action common-btn-padding\" value=Save></div></form></div></div>");
$templateCache.put("app/components/modal/profile/addTaxResidency.modal.html","<!-- Sign up Completed--><div class=modal-content id=add-tax-residency-modal ng-init=Modal.init()><div class=\"loader taxpopup\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Add Tax Residency</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=taxResidencyModalForm ng-submit=Modal.addFatca()><div class=selectfield ng-class=\"{error:taxResidencyModalForm.birthCountry.$dirty && taxResidencyModalForm.birthCountry.$invalid}\"><select class=select-box name=birthCountry ng-model=Modal.payload.birthCountry ng-options=\"country.countryCode as country.countryName for country in Modal.countryList\" required ng-init=\"Modal.payload.birthCountry = Modal.payload.birthCountry ? Modal.payload.birthCountry : null\"><option value=\"\" selected>Name of Country</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyModalForm.birthCountry.$dirty && taxResidencyModalForm.birthCountry.$invalid\"><span class=error-input ng-show=taxResidencyModalForm.birthCountry.$error.required>{{Modal.validateData.SELECT_COUNTRY}}</span></span></div><div class=selectfield ng-class=\"{error:taxResidencyModalForm.taxIdType.$dirty && taxResidencyModalForm.taxIdType.$invalid}\"><select class=select-box name=taxIdType ng-model=Modal.payload.taxIdType ng-options=\"taxid.value as taxid.description for taxid in Modal.taxIdTypeList\" required ng-init=\"Modal.payload.taxIdType = Modal.payload.taxIdType ? Modal.payload.taxIdType : null\"><option value=\"\" selected>Select Tax Id Type</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyModalForm.taxIdType.$dirty && taxResidencyModalForm.taxIdType.$invalid\"><span class=error-input ng-show=taxResidencyModalForm.taxIdType.$error.required>{{Modal.validateData.TAX_ID_TYPE}}</span></span></div><div class=input-normal ng-class=\"{error:taxResidencyModalForm.taxIdNumber.$dirty && taxResidencyModalForm.taxIdNumber.$invalid}\"><input type=text name=taxIdNumber ng-model=Modal.payload.taxIdNumber required> <span class=highlight></span> <span class=bar></span><label>Tax ID Number<span class=\"req text-red\">*</span></label><span ng-show=\"taxResidencyModalForm.taxIdNumber.$dirty && taxResidencyModalForm.taxIdNumber.$invalid\"><span class=error-input ng-show=taxResidencyModalForm.taxIdNumber.$error.required>{{Modal.validateData.TAX_ID_NUMBER}}</span></span></div><div class=\"text-center form-footer form-content\"><!--<input type=\"button\" ng-click= \"Modal.confirmCancel()\" class=\"btn btn-secondary-action common-btn-padding\" value=\"Cancel\" />--> <input type=submit ng-disabled=\"taxResidencyModalForm.$invalid || Modal.processFlag\" class=\"btn btn-primary-action common-btn-padding\" value=Save></div></form></div></div>");
$templateCache.put("app/components/modal/profile/deleteTaxResidency.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div class=text-center>Are you sure you want to delete this tax residency?</div><br><br><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>No</button> <button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>Yes</button></div></div></div>");
$templateCache.put("app/components/modal/profile/unclaimedDetails.modal.html","<div class=modal-content id=unclaimedDividend><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Unclaimed Amount</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><table class=\"table table-striped\"><thead><tr><th>Folio Number</th><th>RUD Number</th><th>Date</th><th>Type</th><th class=text-center>Amount<br>(<i class=rupee-small-icon></i>)</th><th>Remarks</th></tr></thead><tbody><tr ng-repeat=\"dividends in Modal.unclaimedDividend\"><td ng-bind=dividends.folioNumber>23532</td><td ng-bind=dividends.rudNumber>23532</td><td ng-bind=dividends.rudDate>24 Oct 2017</td><td ng-bind=\"dividends.warrantType==\'D\' ? \'Dividend\':\'Redemption\'\">IDCW</td><td class=text-center ng-bind=dividends.amount|unit>890.45</td><td ng-bind=dividends.remarks>Taken for Revalidation</td></tr><tr ng-repeat=\"dividends in Modal.unClaimedRedemptions\"><td ng-bind=dividends.folioNumber>23532</td><td ng-bind=dividends.rudNumber>23532</td><td ng-bind=dividends.rudDate>24 Oct 2017</td><td ng-bind=\"dividends.warrantType==\'D\' ? \'Dividend\':\'Redemption\'\">Redemption</td><td class=text-center ng-bind=dividends.amount|unit>890.45</td><td ng-bind=dividends.remarks>Taken for Revalidation</td></tr></tbody></table></div><div class=modal-footer><button class=\"btn-small btn-primary-action\" ng-click=Modal.dismissModal();>Ok</button></div></div>");
$templateCache.put("app/components/modal/purchaseScheduleCancel/purchaseScheduleCancel.html","<div style=\"margin: 15px\"><div style=\"margin: 30px\"><p class=sp1>Heard about modify transaction?</p><p class=sp2>You can modify scheduled purchase transaction instead of cancelling.</p></div><div class=\"row sSubDiv\" style=\"background-color: transparent  !important\"><button class=sCancelButton style=\"font-size: 14px !important;\n          border: 1px solid #004B8B !important\" ng-click=\"Modal.proceed(\'Cancel\')\">No, i want to cancel transaction</button> <button class=smodifyButton style=\"font-size: 16px !important\" ng-click=\"Modal.proceed(\'Modify\')\">Modify</button></div></div><style>.modal-content{\n    border-radius: 18px;\n  }\n  .sp1 {\n    font-family: Inter;\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 42px;\n    letter-spacing: 0em;\n    text-align: center;\n    margin: 20px;\n  }\n\n  .sp2 {\n    font-family: Proxima Nova;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 28px;\n    letter-spacing: 0em;\n    text-align: center;\n  }\n\n  .sCancelButton {\n    font-weight: 700;\n    width: 195px;\n    height: 48px;\n    padding: 12px, 24px, 12px, 24px;\n    border-radius: 10px !important;\n    background: transparent !important;\n    margin: 15px;\n    color: #004B8B !important;\n  }\n\n  .smodifyButton {\n    width: 195px;\n    height: 48px;\n    padding: 12px, 24px, 12px, 24px;\n    border-radius: 10px !important;\n    background: #1B4B86 !important;\n    margin: 15px;\n    color: white;\n    border: 1px solid #004B8B\n  }\n\n  .sSubDiv {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n  }</style>");
$templateCache.put("app/components/modal/purchaseScheduleSchemes/purchaseScheduleSchemes.html","<div class=modal-content><div style=\"background-color: #F3F9FF;padding: 12px; border-radius: 15px\"><div style=\"display: flex;justify-content: space-between\"><p class=mt7><b>All Schemes</b></p><div style=\"display: flex;justify-content: space-between\"><p class=mt7>Scheme Category</p><select class=select-cnt ng-model=Modal.schemeCategory ng-change=Modal.changeSchemeCategory()><option value=\"\" selected>Category</option><option ng-repeat=\"list in Modal.CategoryList\" ng-if=\"list && list !=null && list !=\'\' && list != \'undefined\'\" value={{list}}>{{list}}</option></select><img src=../../../../assets/images/icons/times.png ng-click=Modal.dismissModal(); alt=\"\" srcset=\"\" style=\"height: 15px;margin-top: 7px\"></div></div></div><br><div><div class=row style=\"margin-left: 0px\"><div class=\"col-md-8 col-sm-10\" style=\"padding: 0px 0px\"><input class=\"form-control search-fund\" type=text name=searchscheam id=searchscheam placeholder=&nbsp;&nbsp;&nbsp;Search... ng-model=Modal.filterwithname ng-change=Modal.changewithFilterName() style=\"height: 40px\"></div></div></div><br><div><div class=row ng-repeat=\"fundData in Modal.recFund\" ng-hide=\"(fundData.retirementFlag == true && Modal.folioData.corporateInvestor) ||\n      (fundData.retirementFlag == true && Modal.folioData.minorFlag) ||\n      (fundData.minorFlag == true && !Modal.folioData.minorFlag)\" style=\"border-bottom: 1px solid gray;margin: 0px 0px 15px 0px;padding: 10px 0px 15px 0px\"><div class=col-md-3><div><p class=rec>Recommended</p><p><b>{{fundData.fundName}}</b></p></div></div><div class=col-md-3><p>Select scheme</p><!-- <select class=\"selectController\" ng-model=\"Modal.schemeData\" ng-change=\"Modal.changeScheme(fundData.fundCode)\"> --><!-- <option value=\"\">Select scheme</option>\n                  <option ng-repeat=\"scheme in fundData.schemes\" value=\"{{scheme}}\">{{scheme.scheme}}</option> --><select class=selectController name=schemeCategory ng-model=fundData.schemeData ng-options=\"scheme.schemeName for scheme in fundData.schemes\" ng-change=Modal.changeScheme(fundData.fundCode,fundData.schemeData)><option value=\"\" selected>Select Scheme</option></select></div><div class=\"col-md-2 navtab\"><p>NAV ({{fundData.navDateTimestamp}})</p><p style=\"margin-top: 10px\"><b>{{fundData.navValue}}</b></p></div><div class=col-md-2 style=\"padding-right: 0px\"><p>Riskometer <img class=base-tooltip src=../../../../assets/images/info-icon.svg style=\"height: 15px\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"<img src=\'{{fundData.riskmeter}}\'>\"></p><div style=\"display: flex\"><img src={{fundData.riskicon}} style=\"width: 25px\"><p style=\"margin-top: 5px\"><b>{{fundData.risk}}</b></p></div></div><div class=col-md-2><input type=button class=investButton ng-disabled=!fundData.selected value=\"Invest Now\" ng-click=Modal.investnow(fundData.schemeData)></div><!-- <hr> --></div><div class=row ng-repeat=\"fundData in Modal.otherFund\" ng-hide=\"(fundData.retirementFlag == true && Modal.folioData.corporateInvestor) ||\n      (fundData.retirementFlag == true && Modal.folioData.minorFlag) ||\n      (fundData.minorFlag == true && !Modal.folioData.minorFlag)\" style=\"border-bottom: 1px solid gray;margin: 0px 0px 15px 0px;padding: 10px 0px 15px 0px\"><div class=col-md-3><div><p><b>{{fundData.fundName}}</b></p></div></div><div class=col-md-3><p>Select scheme</p><!-- <select class=\"selectController\" ng-model=\"Modal.schemeData\" ng-change=\"Modal.changeScheme(fundData.fundCode)\"> --><!-- <option value=\"\">Select scheme</option>\n                  <option ng-repeat=\"scheme in fundData.schemes\" value=\"{{scheme}}\">{{scheme.scheme}}</option> --><select class=selectController name=schemeCategory ng-model=fundData.schemeData ng-options=\"scheme.schemeName for scheme in fundData.schemes\" ng-change=Modal.changeScheme(fundData.fundCode,fundData.schemeData)><option value=\"\" selected>Select Scheme</option></select></div><div class=\"col-md-2 navtab\"><p>NAV ({{fundData.navDateTimestamp}})</p><p style=\"margin-top: 10px\"><b>{{fundData.navValue}}</b></p></div><div class=col-md-2 style=\"padding-right: 0px\"><p>Riskometer <img class=base-tooltip src=../../../../assets/images/info-icon.svg style=\"height: 15px\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"<img src=\'{{fundData.riskmeter}}\'>\"></p><div style=\"display: flex\"><img src={{fundData.riskicon}} style=\"width: 25px\"><p style=\"margin-top: 5px\"><b>{{fundData.risk}}</b></p></div></div><div class=col-md-2><input type=button class=investButton ng-disabled=!fundData.selected value=\"Invest Now\" ng-click=Modal.investnow(fundData.schemeData)></div><!-- <hr> --></div><h5 ng-if=\"Modal.recFund.length == 0 && Modal.otherFund.length == 0\" style=\"color: red;margin-left: 30%;padding: 10px 0px 15px 0px\">Records Not Found!</h5></div></div><style>p{\n    font-size: 12px !important;\n    font-weight: 600;\n  }\n  .modal-content {\n      border-radius: 15px;\n      width: 108% !important;\n  }\n\n  .search-fund {\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      background-image: url(\"/assets/images/icons/search.png\");\n      background-size: 5px;\n      background-repeat: no-repeat;\n      background-position-x: 2%;\n      background-position-y: 13px;\n      background-size: 13px;\n  }\n\n  .form-control {\n      padding: 6px 30px;\n      margin-left: 15px;\n  }\n  .selectController{\n      width: 100% !important;\n      height: 35px;\n      margin: 0px 15px 0px 0px;\n      border-radius: 7px;\n  }\n  .select-cnt {\n      width: 125px !important;\n      height: 30px;\n      margin: 0px 15px 0px 15px;\n      border-radius: 15px;\n      text-align: center;\n      background: linear-gradient(0deg, #F7F9FA, #F7F9FA),\n      linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));\n      border: 1px solid #e6e6e6;\n      text-align: left;\n  }\n\n  .mt7 {\n      margin-top: 7px;\n  }\n  .investButton{\n      padding: 6px 15px 6px 15px;\n      border-radius: 8px;\n      background: #1B4B86;\n      color: white;\n      border: none;\n  }\n  button[disabled], html input[disabled] {\n      background: #8c8dc45c;\n      cursor: default;\n  }\n  .rec{\n      width: 140px;\n      text-align: center;\n      padding: 5px;\n      margin-bottom: 10px;\n      border-radius: 5px;\n      background: #4EAE8033;\n      color: #088b4ccf;\n;\n  }\n  .navtab{\n      padding: 0px;\n  }\n  @media screen and (max-width:550px) {\n      .navtab{\n          padding: 15px;\n      }\n      .modal-content {\n        border-radius: 15px;\n        width: 100% !important;\n      }\n      .search-fund{\n        width: 88% !important;\n      }\n  }</style>");
$templateCache.put("app/components/modal/redemptionConfirm/nudgeScheduleRedemption.html","<div class=modal-content><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div style=\"line-height: 1.5\"><p ng-bind-html=Modal.modalData.message></p></div><br><div><input ng-model=Modal.isChecked type=checkbox> <span>Do not display this message again</span></div><br><br><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.gotoRedeem() ng-if=!Modal.buttonCancel>Yes</button> <button class=\"btn btn-primary-action\" ng-click=Modal.stayInvested() ng-if=!Modal.buttonProceed>No</button></div></div></div>");
$templateCache.put("app/components/modal/redemptionConfirm/redemptionConfirm.modal.html","<div class=modal-content><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div style=\"line-height: 1.5\"><p ng-bind-html=Modal.modalData.message></p></div><br><div><input ng-model=Modal.isChecked type=checkbox> <span>Do not display this message again</span></div><br><br><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.gotoRedeem() ng-if=!Modal.buttonCancel>Yes, Redeem</button> <button class=\"btn btn-primary-action\" ng-click=Modal.stayInvested() ng-if=!Modal.buttonProceed>No, Stay Invested</button></div></div></div>");
$templateCache.put("app/components/modal/redemptionConfirm/stayInvested.modal.html","<!-- Scheme List--><div class=modal-content id=initiateTransactionMsg><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div><i class=verify-icon></i> <span ng-bind-html=Modal.modalData.message></span></div><!--<h5 class=\"text-primary\">{{Modal.modalData.message?Modal.modalData.message:\'Thank You. Your process to initiate redemption has been terminated. \'}}</h5>--></div></div>");
$templateCache.put("app/components/modal/register/confirmRegister.modal.html","<!-- Sign up Completed--><div class=modal-content id=confirm-registration><div class=modal-head><h3>Declaration for US/Canada Residents</h3><div><i class=times-icon ng-click=Modal.dismissModal();></i></div></div><div class=modal-body><p>The information and data contained in this Website do not constitute distribution, an offer to buy or sell or solicitation of an offer to buy or sell any Schemes/Units of HDFC Mutual Fund in any jurisdiction in which such distribution, sale or offer is not authorised. The material/information provided in this Website is for the limited purposes of information only for the investors. In particular, the information herein is not for distribution and does not constitute an offer to buy or sell or solicitation of an offer to buy or sell any Schemes/Units of HDFC Mutual Fund to any person in the United States of America (\'USA\')/Canada.</p><p>By entering this Website or accessing any data contained in this Website, I/We hereby confirm that I/We am/are not a U.S. person, within the definition of the term \'US Person\' under the US Securities laws/resident of Canada. I/We hereby confirm that I/We am/are not giving a false confirmation and/or disguising my/our country of residence. I/We agree and acknowledge that HDFC Mutual Fund/HDFC Asset Management Company Limited (HDFC AMC) is relying upon my/our confirmation and in no event shall the directors, officers, employees, trustees, agents of HDFC AMC associate/group companies be liable for any direct, indirect, incidental or consequential damages arising out of false confirmation provided herein.</p></div><div class=modal-footer><button ng-click=Modal.dismissModal() class=\"btn btn-secondary-action\">I am a US Person/Resident of Canada</button> <button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">I am not a US Person/Resident of CANADA</button></div></div>");
$templateCache.put("app/components/modal/register/kycReject.modal.html","<div class=modal-content id=register-done><div class=modal-body><form autocomplete=off><p class=text-center>Cannot proceed with {{Modal.modalData.screen}} since your KYC status is rejected. <span ng-click=Modal.redirectToEkyc(); class=\"cursor-pointer text-primary\">Click here</span> to reinitiate eKYC process to proceed.</p><div class=text-center><button ng-click=\"Modal.closeModal(\'login\')\" class=\"btn btn-primary-action btn-small buttonStylingModal\">{{Modal.modalData.buttonText}}</button></div></form></div></div>");
$templateCache.put("app/components/modal/register/nonKyc.modal.html","<!-- Sign up Completed--><div class=modal-content id=register-done><i class=times-icon ng-click=\"Modal.dismissModal(\'close\');\"></i><div class=modal-body><form autocomplete=off><p class=text-center ng-if=!Modal.modalData.showHtml>{{Modal.modalData.text}}</p><ng-bind-html ng-if=Modal.modalData.showHtml dynamic=Modal.modalData.text></ng-bind-html><div class=text-center><button ng-click=\"Modal.closeModal(\'login\')\" class=\"btn btn-primary-action btn-small buttonStylingModal\">{{Modal.modalData.buttonText}}</button></div></form></div></div><form autocomplete=off name=ekycForm id=ekycForm method=POST enctype=multipart/form-data action={{Modal.modalData.actionUrl}}><input id=url type=hidden name=url ng-value=Modal.modalData.ekycRequestCO.url> <input id=sess_id type=hidden name=sess_id ng-value=Modal.modalData.ekycRequestCO.sess_id> <input id=ekyctype type=hidden name=ekyctype ng-value=Modal.modalData.ekycRequestCO.ekyctype> <input id=Plkyc_type type=hidden name=Plkyc_type ng-value=Modal.modalData.ekycRequestCO.plkyc_type> <input id=kyc_data type=hidden name=kyc_data ng-value=Modal.modalData.ekycRequestCO.kyc_data></form>");
$templateCache.put("app/components/modal/register/redirectToOldFolio.modal.html","<!-- Sign up Completed--><div class=modal-content><div class=modal-body><h5 class=text-center>It seems your registration process is still incomplete.</h5><br><br><h6 class=text-center>Please complete the process by clicking on the link. <a href=https://investor.hdfcfund.com/mfonline/Login.aspx target=_blank>Click Here</a></h6><br><br></div></div>");
$templateCache.put("app/components/modal/register/registration.modal.html","<!-- Sign up Completed--><div class=modal-content id=register-done><div><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off><p ng-if=Modal.modalData.from class=\"text-center success-text\"><i class=verify-icon></i>Created Successfully</p><!-- Create User Id Text --><p>{{Modal.modalData.text}}</p><div class=\"modal-multiple-action text-center\"><button ng-if=Modal.modalData.buttonTextCancel ng-click=\"Modal.closeModal(\'login\')\" class=\"btn btn-secondary-action\">{{Modal.modalData.buttonTextCancel}}</button> <button ng-click=\"Modal.closeModal(\'createUserId\')\" class=\"btn btn-primary-action\" style=\"background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%)\">{{Modal.modalData.buttonText}}</button></div></form></div></div>");
$templateCache.put("app/components/modal/registerEmandateNewJourney/registerEmandateNewJourney.modal.html","<div class=modal-content id=initiateTransactionMsg><div class=\"loader popup\"><span class=loading></span></div><div><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p style=\"text-align: left\">To register your eMandate you would be redirected to the {{Modal.modalData.bankName}} internet banking login page. A debit of Rs. 1/- may be carried out to your account for registration depending on the selected bank.<br></p><p style=\"text-align: left\">Do you wish to proceed?</p><p></p><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>Cancel</button> <button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/resetPassword/changePassword.modal.html","<!--   Reset Password ----><div class=modal-content id=changePasswrdModal><div class=modal-head><h3 class=modal-title>Change Password</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=changeForm ng-submit=Modal.changePassword() novalidate><p class=\"text-center text-danger\" ng-if=\"Modal.passwordExpireMsg && Modal.passwordExpireMsg === \'Password Expired\'\">Your Password has been expired. Please change your password in the form below.</p><br><ul class=info-card><li>1) Password should be between 8 to 15 character.</li><li>2) Atleast one special character @, $, _, !</li><li>3) Atleast one Upper case letter.</li><li>4) Atleast one lower case letter.</li><li>5) Atleast one number.</li></ul><div class=input-normal ng-class=\"{error:changeForm.oldPassword.$dirty && changeForm.oldPassword.$invalid}\"><input name=oldPassword ng-model=Modal.changePasswordPayload.oldPassword ng-change=Modal.resetDefaults() maxlength=15 type=password required autocomplete=off ng-keydown=Modal.copyPasteHandler($event)> <span class=highlight></span> <span class=bar></span><label>Existing Password</label><span ng-show=\"changeForm.oldPassword.$dirty && changeForm.oldPassword.$invalid\"><span class=error-input ng-show=changeForm.oldPassword.$error.required ng-bind=Modal.validateData.PASSWORD_REQUIRED></span><!--<span class=\"error-input\" ng-show=\"changeForm.oldPassword.$error.pattern\">{{ Modal.validateData.PASSWORD_FIELD }}</span>--></span></div><div class=input-normal ng-class=\"{error:changeForm.newPassword.$dirty && changeForm.newPassword.$invalid}\"><input name=newPassword ng-model=Modal.changePasswordPayload.newPassword ng-pattern=\"/^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[$_!@])[A-Za-z\\d$@!_]{8,15}$/\" maxlength=15 type=password ng-change=Modal.resetDefaults() required autocomplete=off ng-keydown=Modal.copyPasteHandler($event)> <span class=highlight></span> <span class=bar></span><label>New Password</label><span ng-show=\"changeForm.newPassword.$dirty && changeForm.newPassword.$invalid\"><span class=error-input ng-show=changeForm.newPassword.$error.required ng-bind=Modal.validateData.PASSWORD_REQUIRED></span> <span class=error-input ng-show=changeForm.newPassword.$error.pattern>{{ Modal.validateData.PASSWORD_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:changeForm.confirmPassword.$dirty && changeForm.confirmPassword.$invalid}\"><input name=confirmPassword ng-model=Modal.changePasswordPayload.confirmPassword type=password ng-pattern=\"/^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[$_!@])[A-Za-z\\d$@!_]{8,15}$/\" maxlength=15 ng-change=Modal.resetDefaults() required autocomplete=off ng-keydown=Modal.copyPasteHandler($event)> <span class=highlight></span> <span class=bar></span><label>Confirm New Password</label><span ng-show=\"changeForm.confirmPassword.$dirty && changeForm.confirmPassword.$invalid\"><span class=error-input ng-show=changeForm.confirmPassword.$error.required ng-bind=Modal.validateData.CONFIRM_PASSWORD_REQUIRED></span> <span class=error-input ng-show=changeForm.confirmPassword.$error.maxlength>{{ Modal.validateData.PASSWORD_FIELD }}</span> <span class=error-input ng-show=changeForm.confirmPassword.$error.pattern>{{ Modal.validateData.PASSWORD_FIELD }}</span> </span><span class=\"error-input confirm-error\" ng-show=Modal.confirmErr>{{ Modal.confirmErr }}</span></div><div class=\"form-footer form-content\" style=\"text-align: center !important\"><!--<input type=\"button\" ng-click=\"Modal.confirmCancel()\" class=\"btn btn-secondary-action common-btn-padding\" value=\"Cancel\" />--> <input type=submit ng-disabled=\"changeForm.$invalid || Modal.processFlag\" class=\"btn btn-primary-action\" value=Save></div><!--<button ng-disabled=\"changeForm.$invalid || Modal.processFlag\" class=\"btn btn-block btn-primary-action\">Submit</button>--></form></div></div><!--   Reset Password ---->");
$templateCache.put("app/components/modal/resetPassword/changePasswordSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=reset-password><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><p class=\"text-center success-text\" ng-show=!Modal.modalData.hideSuccessIcon><i class=verify-icon></i></p><p class=text-center>{{Modal.modalData.message}}</p><!--Forgot pwd--><!--<p class=\"text-center\">A link to reset your password has been sent to your registered email ID xyz@xyz.com</p>--><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/resetPassword/resetPasswordSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=reset-password><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon></i><div class=modal-body><p class=\"text-center success-text\"><i class=verify-icon></i>Successfully Changed</p><p class=text-center>You have successfully reset your password.<br>Please continue to login to your account.</p><!--Forgot pwd--><!--<p class=\"text-center\">A link to reset your password has been sent to your registered email ID xyz@xyz.com</p>--><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>Continue to Login</button></div></div></div>");
$templateCache.put("app/components/modal/rollOver/changeDividendSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=changeDividend-success><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><p class=text-center><i class=verify-icon></i></p><p class=\"text-center changeDividend-message\">Your IDCW change request for <span class=strong>\"HDFC Banking & PSU Debt\"</span><br>has been successfully sent</p><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/rollOver/rollOverConfirm.modal.html","<div class=modal-content id=changeDividend-popUp><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body ng-scope\"><div class=\"text-center want-dividend\"><p>Do you want to make the Roll Over Request?</p></div><div class=important-change><p class=imp-head>Important:</p><p class=imp-des>Thank you for being an eco-friendly investor.A copy of the roll over request has ben emailed to you. Please do not print this page unless absolutely necessary.<br><br>Actual unit balance avaiable to switch/redeem/roll over may be lower than total balance because of any lien(s) marked against your units, any recently purchased / Switch in units where the credit status is not established, investments in ELSS(Open ended schemes with 3 year lock-in), or any other reason.</p></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.submitForm()>Confirm</button></div></div></div>");
$templateCache.put("app/components/modal/rollOver/rollOverOverview.modal.html","<div class=modal-content id=rollOverview><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body ng-scope\"><strong ng-if=\"item.type == \'cancelled\'\">Roll Over Cancellation Summary </strong><strong ng-if=\"item.type != \'cancelled\'\">Roll Over Summary</strong><table class=\"table borderless\"><tbody><tr><td>Transaction Number</td><td>:</td><td>{{Modal.modalData && Modal.modalData.cams_ref_no}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Modal.modalData && Modal.modalData.folio_no}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Modal.modalData && Modal.modalData.schemeName}}</td></tr><tr><td>Status</td><td>:</td><td>{{(Modal.modalData && Modal.modalData.type == \"cancelled\") ? \"Cancelled\" : Modal.modalData.msg_current_status}}</td></tr><tr><td>Transaction Date</td><!--msg_created_time--><td>:</td><td>{{Modal.modalData && Modal.modalData.msg_created_time}}</td></tr><tr ng-if=\"(Modal.modalData && Modal.modalData.mode == \'unit\')\"><td>Units</td><td>:</td><td>{{Modal.modalData && Modal.modalData.amountOrUnits|unit:Modal.modalData && Modal.modalData.unitValue}} {{Modal.modalData && Modal.modalData.unitValue|unitValue}}<span ng-if=\"(Modal.modalData && Modal.modalData.amountOrUnits !=\'NA\')\"> Units</span></td></tr><tr ng-if=\"(Modal.modalData && Modal.modalData.mode == \'amount\')\"><td>Amount</td><td>:</td><td><i ng-if=\"(Modal.modalData && Modal.modalData.amountOrUnits !=\'NA\')\" class=rupee-black-icon></i>{{Modal.modalData && Modal.modalData.amountOrUnits|unit:Modal.modalData && Modal.modalData.unitValue}} {{Modal.modalData && Modal.modalData.unitValue|unitValue}}<br><label id=divDisplayWords>{{Modal.modalData.amountInWords}} (In Words)</label></td></tr><!--<tr>\n        <td>Client IP Address</td>\n        <td>:</td>\n        <td>171.28.5.172</td>\n      </tr>--></tbody></table></div></div>");
$templateCache.put("app/components/modal/rollOver/rollOverSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=initiateTransactionMsg><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div><i class=verify-icon></i></div><p>Your Roll Over request for <strong>“{{Modal.modalData}}”</strong><br>has been successfully sent</p><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/scheduleTransaction/schedule-transaction.modal.html","<div class=modal-content id=scheduleTransactionModal><div class=modal-head><h3 class=modal-title>{{Modal.modalData.title}}</h3><i class=times-icon ng-click=\"Modal.dismissModal(\'close\');\"></i></div><div class=\"modal-body form-wrapper ng-scope\"><div class=\"content-area redeem\"><form autocomplete=off name=Modal.scheduleTransactionForm novalidate><div class=row><div class=col-md-4><div><strong>Schedule Date</strong></div></div><div class=col-md-8><div class=form-group><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode=days data-date-default=Modal.formData.scheduleDate data-enabled-dates=Modal.enabledDates data-view-date=Modal.minStartDate data-min-date=Modal.enabledDates[0] data-max-date=Modal.startMaxDate id=startDate data-enable=true data-on-date-change=Modal.changeStartDate style=\"position: relative\" ng-class={error:Modal.scheduleTransactionForm.startDate.$invalid} showdefault=false><input type=text name=startDate placeholder=\"Schedule Date - DD-MMM-YYYY\" readonly required> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=Modal.scheduleTransactionForm.startDate>Schedule Date</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Modal.scheduleTransactionForm.scheduleDate.$error.required ng-bind=Modal.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div></div></div><div class=row><div class=col-md-4><div><strong>Frequency</strong></div></div><div class=col-md-8><div class=form-group><div class=\"radio-block input-normal\"><span class=radio><input type=radio name=frequency value=One-time ng-model=Modal.formData.frequency ng-click=\"Modal.changeFrequencies(\'one-time\')\"> <span class=check></span> </span><span class=radio-label>One-time</span></div><div class=\"radio-block input-normal\"><span class=radio><input type=radio name=frequency value=Weekly ng-model=Modal.formData.frequency ng-class=\"{\'frequency-disable\': Modal.modalData.amountType === \'all_units\'}\" ng-disabled=\"Modal.modalData.amountType === \'all_units\'\" ng-click=\"Modal.changeFrequencies(\'weekly\')\"> <span class=check></span> </span><span class=radio-label>Weekly</span></div><div class=\"radio-block input-normal\"><span class=radio><input type=radio name=frequency value=Monthly ng-model=Modal.formData.frequency ng-class=\"{\'frequency-disable\': Modal.modalData.amountType === \'all_units\'}\" ng-disabled=\"Modal.modalData.amountType === \'all_units\'\" ng-click=\"Modal.changeFrequencies(\'monthly\')\"> <span class=check></span> </span><span class=radio-label>Monthly</span></div></div></div></div><div class=row ng-if=Modal.isVisibleEndDate><div class=col-md-4><div><strong>End Date</strong></div></div><div class=col-md-8><div class=form-group><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode=days data-enabled-dates=Modal.enabledEndDates data-date-default=Modal.formData.endDate data-view-date=Modal.enabledEndDateView id=endDate data-enable=Modal.isEnableEndDate data-on-date-change=Modal.changeEndDate data-min-date=Modal.endMinDate data-max-date=Modal.endMaxDate style=\"position: relative\" ng-class={error:Modal.scheduleTransactionForm.endDate.$invalid}><input type=text name=endDate placeholder=\"End Date - DD-MMM-YYYY\" readonly required> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=Modal.scheduleTransactionForm.endDate>End Date</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Modal.scheduleTransactionForm.endDate.$error.required ng-bind=Modal.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div></div></div><div class=row ng-show=Modal.modalData.notesDynamic><div class=col-md-12><div class=\"point-to-note imp-info\" ng-if=Modal.modalData.notesDynamic.content><!--                <strong>Important Points To Note:</strong>--><div><ng-bind-html ng-bind-html=Modal.modalData.notesDynamic.content></ng-bind-html></div><!--                <ul>--><!--                  <li>Schedule Transaction allows you to schedule the transaction on a future date. You can schedule multiple transactions by selecting weekly or monthly frequency. On the scheduled date, you will receive reminder Email and SMS on your registered Email ID and Mobile number in the folio with instructions to complete the transaction.</li>--><!--                  <li>The transaction shall be deemed to be received only when confirmed on the Scheduled date before cut-off timing as applicable. Further, applicability of NAV shall be as per SEBI guidelines. If a scheduled date falls on a non-business day, then reminder SMS and Email will be sent on the immediately succeeding business day.</li>--><!--                  <li>When scheduling multiple transactions with weekly or monthly frequency, they should not be considered as systematic transactions (SIP, STP or SWP) and would require you to explicitly complete each transaction on the scheduled date before cut-off timing as applicable.</li>--><!--                  <li>In case of multiple scheduled transactions, each transaction shall be considered as independent transaction and cancellation or expiry of one transaction will not result into other scheduled transaction being cancelled or expired.</li>--><!--                  <li>For weekly frequency, the interval of subsequent scheduled transactions would be (T+7) calendar days, while for monthly frequency it would be (T+30) calendar days starting from the day first transaction is scheduled.</li>--><!--                </ul>--></div></div></div><div class=row><div class=col-md-12><div class=\"form-group text-center\"><button ng-click=Modal.performSubmission() ng-disabled=\"!Modal.formData.scheduleDate || (Modal.isVisibleEndDate ? !Modal.formData.endDate : Modal.formData.endDate)\" class=\"btn btn-primary-action\">Continue</button></div></div></div></form></div></div></div>");
$templateCache.put("app/components/modal/schemeList/schemeList.model.html","<!-- Scheme List--><div class=modal-content id=schemeList ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Scheme List</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><ul class=\"nav nav-tabs tab-type-2\"><li ng-class=\"{active:$index === Modal.selected}\" ng-repeat=\"schemeType in Modal.schemeTypeList\" ng-click=\"Modal.fetchSchemes(schemeType, $index)\"><a data-bs-toggle=tab>{{schemeType}}</a></li></ul><input ng-if=\"Modal.schemeList.length !=0\" type=search id=searchbox ng-model=Modal.searchString autocomplete=off placeholder=\"Search Scheme\" class=\"blank-input scheme-search\"> <span class=no-scheme ng-if=\"Modal.schemeList.length===0\">No Scheme Found For The Category</span><div class=\"tab-content tab-type-2-content\" ng-if=Modal.schemeList.length><div id=All class=\"tab-pane fade in active\"><ul><li ng-repeat=\"scheme in Modal.schemeList|searchFor:Modal.searchString\" ng-click=Modal.selectScheme(scheme)>{{scheme.scheme}}</li></ul></div></div></div></div>");
$templateCache.put("app/components/modal/schemeListInstant/schemeListInstant.model.html","<!-- Scheme List--><div class=modal-content id=schemeList ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Scheme List</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><ul class=\"nav nav-tabs tab-type-2\"><li ng-class=\"{active:$index==0}\" ng-repeat=\"schemeType in Modal.schemeTypeList\" ng-click=Modal.fetchSchemes(schemeType)><a data-bs-toggle=tab>{{schemeType}}</a></li></ul><input ng-if=\"Modal.schemeList.length !=0\" type=search id=searchbox ng-model=Modal.searchString autocomplete=off placeholder=\"Search Scheme\" class=\"blank-input scheme-search\"> <span class=no-scheme ng-if=\"Modal.schemeList.length===0\">No Scheme Found For The Category</span><div class=\"tab-content tab-type-2-content\" ng-if=Modal.schemeList.length><div id=All class=\"tab-pane fade in active\"><ul><li ng-repeat=\"scheme in Modal.schemeList|searchFor:Modal.searchString\" ng-click=Modal.selectScheme(scheme)>{{scheme.scheme}}</li></ul></div></div></div></div>");
$templateCache.put("app/components/modal/schemeListNewModal/schemeListNew.modal.html","<!-- Scheme List--><div class=\"modal-content schemeListNewModal\" id=schemeList ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><div class=scheme-modal-toggle-container><div class=\"label-black f-family-inter f-weight-400\">Direct</div><label class=switch><input type=checkbox ng-model=Modal.modalData.isThroughDistributor ng-change=\"Modal.fetchSchemes(\'ALL\', 0)\"> <span class=slider></span></label><div class=\"label-black f-family-inter f-weight-400\">Regular</div></div><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><ul class=\"nav nav-tabs tab-type-2\"><li ng-class=\"{active:$index === Modal.selected}\" ng-repeat=\"schemeType in Modal.schemeTypeList\" ng-click=\"Modal.fetchSchemes(schemeType, $index)\"><a data-bs-toggle=tab>{{schemeType}}</a></li></ul><input ng-if=\"Modal.schemeList.length !=0\" type=search id=searchbox ng-model=Modal.searchString autocomplete=off placeholder=\"Search Scheme\" class=\"blank-input scheme-search\"> <span class=no-scheme ng-if=\"Modal.schemeList.length===0\">No Scheme Found For The Category</span><div class=\"tab-content tab-type-2-content\" ng-if=Modal.schemeList.length><div id=All class=\"tab-pane fade in active\"><ul><li ng-repeat=\"scheme in Modal.schemeList|searchFor:Modal.searchString\" ng-click=Modal.selectScheme(scheme)>{{scheme.scheme}}</li></ul></div></div></div></div>");
$templateCache.put("app/components/modal/select-folio/select.folio.modal.html","<div class=\"modal-content select-folio-modal\" id=initiateTransactionMsg><div class=modal-head><h3>Investment Details</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form name=folioForm><div class=select-folio-container><div class=row><div class=col-md-12><p class=title>Select Folio</p><div ng-class=\"{error:folioForm.folio.$dirty && folioForm.folio.$invalid}\"><select name=folio id=_first ng-change=Modal.folioChanged() ng-model=Modal.formData.folioNumber class=\"selectNormal select-folio-list\" ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Modal.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio Number</option></select><span class=error-input ng-show=\"folioForm.folio.$dirty && folioForm.folio.$invalid && folioForm.folio.$error.required\" ng-bind=Modal.VALIDATE_DATA.FOLIO_REQUIRED></span> <span class=error-input ng-show=Modal.kycVerifiedFlag ng-bind=Modal.kycMessage></span> <span class=error-input ng-show=!Modal.folioList ng-bind=Modal.VALIDATE_DATA.BASKET_NO_FOLIO></span></div></div></div></div><div class=folio-submit><button type=submit ng-disabled=folioForm.$invalid ng-click=Modal.closeModal() class=\"btn btn-primary-action\">Submit</button></div></form></div></div>");
$templateCache.put("app/components/modal/selectAccount/selectAccount.modal.html","<div class=modal-content id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><form name=accountNoForm><div class=selectfield><label style=\"top: -17px\">Select Account No</label><select class=\"browser-default custom-select\" name=accountNo ng-init=\"Modal.formData.accountNo = Modal.bankAccounts[0]\" ng-options=\"_account for _account in Modal.bankAccounts\" ng-model=Modal.formData.accountNo required></select></div><br><button ng-click=Modal.closeModal() ng-disabled=!Modal.formData.accountNo class=\"btn btn-primary-action\">Submit</button></form></div></div>");
$templateCache.put("app/components/modal/session/active-session.modal.html","<div class=\"modal-content active-session-modal\" id=forgot-success><div class=\"loader popup\"><span class=loading></span></div><div><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p style=\"padding: 30px 0\">Your previous session is <span style=\"color: #337ab7\">still active.</span><br>Do you want to cancel the previous session and login again?</p><div class=row><div class=col-sm-6><button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal() style=\"width: 100%\">No</button></div><div class=col-sm-6><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal() style=\"width: 100%\">Yes</button></div></div></div></div><style>.btn-primary-action{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n  }\n  .btn-secondary-action{\n    border: 1px solid blue !important;\n    color: blue !important;\n  }</style>");
$templateCache.put("app/components/modal/session/session.modal.html","<div class=\"modal-content session-modal\" id=disclaimerPopups><div class=modal-head><h3 class=text-center>You have logged out successfully.</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=row><div class=\"col-sm-12 col-md-12\"><p>Thanks for using HDFC MFOnline Investors. We hope to see you again soon.</p></div></div><div class=row><div class=col-sm-6><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal() style=\"width: 100%;background:linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%)\">Login again</button></div><div class=col-sm-6 style=\"word-wrap: break-word\"><a id=funds class=\"btn btn-secondary-action\" style=\"width: 100%; border-radius: 50px;\n               color: #3C75BA;\n               border-color: #3C75BA\" target=_blank href={{Modal.HDFC_API.WEBSITE_LINK}}our-products>Explore HDFC MF Website</a></div></div><div class=row><div class=col-sm-12 style=\"margin-top: 25px\"><p style=\"font-weight: bolder;text-decoration: underline\">For any queries / assistance:</p><br><p>Email @ <span style=\"color: #337ab7\"><a style=\"color: #337ab7\" href=mailto:Hello@hdfcfund.com>Hello@hdfcfund.com</a> </span>| Call @ <a style=color:#000000 href=tel:180030106767>180030106767</a> / <a style=color:#000000 href=tel:18004197676>18004197676</a> (Toll Free Number) <span><!-- <img style=\"vertical-align: middle;height: 20px;margin-left: 5px;\" id=\"bot_img\" src=\"assets/images/chat.gif\" alt=\"chat-bot\"/> --> </span></p></div></div></div></div>");
$templateCache.put("app/components/modal/showImage/showImage.modal.html","<!-- Widget Selection\n--------------------------><!--\n<div class=\"modal-content\" id=\"widgetSore\" ng-init=\"Modal.init();\">\n  &lt;!&ndash;<div class=\"loader widget\" style=\"position: absolute;\"><span class=\"loading\"></span></div>&ndash;&gt;\n  &lt;!&ndash;<div class=\"modal-header\">\n    <h4 class=\"modal-title text-uppercase\">WIDGET STORE</h4>\n    <div class=\"selected-count\"><span>{{Modal.selectedCounter}}</span> Widgets Selected Out of <span ng-bind=\"Modal.widgetList.length\">6</span></div>\n  </div>&ndash;&gt;\n  <div class=\"tagline\">List of all the widgets that will appear on your dashboard screen. You can De-Select any widget you want to Remove.</div>\n  <div class=\"modal-body\">\n    <div class=\"col-md-6 col-sm-6\">\n      <div class=\"widget-box\">\n        <div class=\"text-center\">\n          <img http-src=\"{{Modal.modalData.docUrl}}\"/>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-primary-action\" ng-click=\"Modal.submitWidgetList();\">OK</button>\n  </div>\n</div>--><!-- Scheme List--><div class=modal-content id=imagePreview ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--><div class=modal-body style=\"padding:15px 15px\"><div class=\"image-preview text-center\"><img http-src={{Modal.docUrl}} class=img-responsive ng-if=\"Modal.supportedFileType && Modal.docUrl && Modal.uploaded\"> <img ng-if=Modal.supportedFileType ng-src={{Modal.docUrl}} class=img-responsive ng-show=\"Modal.docUrl && !Modal.uploaded\"><div ng-if=!Modal.supportedFileType>Preview not Supported for {{Modal.fileType}} files.</div></div></div><div class=modal-footer style=text-align:center><!--<button class=\"btn btn-secondary-action\" ng-click=\"Modal.dismissModal()\">Cancel</button>--> <button ng-class=\"{\'set-btn-blue\': Modal.modalData.showBlueBtn}\" ng-click=Modal.dismissModal() class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/showImage/showImage1.modal.html","<!-- Widget Selection\n--------------------------><!--\n<div class=\"modal-content\" id=\"widgetSore\" ng-init=\"Modal.init();\">\n  &lt;!&ndash;<div class=\"loader widget\" style=\"position: absolute;\"><span class=\"loading\"></span></div>&ndash;&gt;\n  &lt;!&ndash;<div class=\"modal-header\">\n    <h4 class=\"modal-title text-uppercase\">WIDGET STORE</h4>\n    <div class=\"selected-count\"><span>{{Modal.selectedCounter}}</span> Widgets Selected Out of <span ng-bind=\"Modal.widgetList.length\">6</span></div>\n  </div>&ndash;&gt;\n  <div class=\"tagline\">List of all the widgets that will appear on your dashboard screen. You can De-Select any widget you want to Remove.</div>\n  <div class=\"modal-body\">\n    <div class=\"col-md-6 col-sm-6\">\n      <div class=\"widget-box\">\n        <div class=\"text-center\">\n          <img http-src=\"{{Modal.modalData.docUrl}}\"/>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-primary-action\" ng-click=\"Modal.submitWidgetList();\">OK</button>\n  </div>\n</div>--><!-- Scheme List--><div class=modal-content id=imagePreview ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--><div class=modal-body style=\"padding:15px 15px\"><div class=\"image-preview text-center\"><img style=\"margin: 0 auto\" http-src={{Modal.docUrl}} class=img-responsive ng-if=\"Modal.supportedFileType && Modal.docUrl && Modal.uploaded\"> <img ng-if=Modal.supportedFileType ng-src={{Modal.docUrl}} class=img-responsive ng-show=\"Modal.docUrl && !Modal.uploaded\"><div ng-if=!Modal.supportedFileType>Preview not Supported for {{Modal.fileType}} files.</div></div></div><div class=\"modal-footer justify-content-center\" style=text-align:center><!--<button class=\"btn btn-secondary-action\" ng-click=\"Modal.dismissModal()\">Cancel</button>--> <button ng-click=Modal.dismissModal() style=\"background: #244b8c;\n      color: white;border-radius: 25px\">OK</button></div></div>");
$templateCache.put("app/components/modal/sipDetailsModal/sipDetails.modal.html","<div class=\"modal-content sipviaPurchase-details-modal\"><div class=modal-head><h3 class=modal-title>SIP Details</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body sipviaPurchase-modal-body\"><form name=sipDetailsForm autocomplete=off><!-- SIP Amount row --><div class=row><div class=\"col-sm-12 col-md-12 d-flex justify-content-center flex-column\"><div class=\"form-input sip-amt-container\"><label class=\"form-label form-label-bold d-flex justify-content-center\">Enter SIP Amount</label><div class=\"input-normal icon-input\" ng-class=\"{error:(Modal.sipDetailsForm.pAmount.$dirty && Modal.sipDetailsForm.pAmount.$invalid)||(Modal.formData.sipViaPurchaseAmount && Modal.isPurchaseMin),\'has-data\':Modal.formData.sipViaPurchaseAmount}\"><!--<span class=\"rupee-symbol-entity\">&#8377;</span>--> <input type=text onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=pAmount ng-model=Modal.formData.sipDetailsViaPurchase.sipDisplayAmount ng-change=Modal.changeAmount() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ondrop=\"return false\" ng-disabled=\"\" class=input-style aria-describedby=rupee-addon required> <span class=rupee-span-new ng-if=!Modal.formData.sipDetailsViaPurchase.sipDisplayAmount>₹</span> <span class=highlight></span> <span class=bar></span></div></div><div class=\"text-center mb-2\"><span class=error-input ng-show=\"sipDetailsForm.pAmount.$dirty && sipDetailsForm.pAmount.$error.required\" ng-bind=Modal.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Modal.formData.sipDetailsViaPurchase.sipAmount && Modal.isMin\" class=error-input>Minimum amount should be &#8377; {{Modal.validations.minAmount|unit}}</span> <span ng-if=\"Modal.formData.sipDetailsViaPurchase.sipAmount && !Modal.isMax && !Modal.isMin && (Modal.validations.amountMultiples&&!Modal.isMultiples) && !Modal.amountExceeded\" class=error-input>Please Provide In multiples of &#8377; {{Modal.validations.amountMultiples|unit}}</span> <span ng-show=\"sipDetailsForm.pAmount.$dirty && Modal.formData.sipDetailsViaPurchase.sipAmount && Modal.amountExceeded\" class=error-input ng-bind=Modal.VALIDATE_DATA.AMOUNT_EXCEEDED></span><div class=form-group ng-if=\"Modal.formData.sipDetailsViaPurchase && Modal.formData.sipDetailsViaPurchase.sipAmount\"><label>{{Modal.amountInWords}}</label></div></div></div></div><!-- SIP tenure and Frequency --><div class=\"row mb-3\"><div class=\"col-sm-12 col-md-6\"><dual-date-picker enabled-start-dates=Modal.enabledStartDates enabled-end-dates=Modal.enabledEndDates current-view-start=Modal.startDateView current-view-end=Modal.endDateView start-date=Modal.formData.startDate end-date=Modal.formData.endDate on-change-start-date=Modal.changeStartDate on-change-end-date=Modal.changeEndDate input-placeholder=Modal.sipTenurePlaceHolder></dual-date-picker></div><div class=\"col-sm-12 col-md-6\"><div class=scheme-fields><div class=row><div class=col-md-12><div class=form-input><label for=freq class=form-label>Frequency</label><div class=dropdown><div class=\"value-wrapper f-weight-500\" data-bs-toggle=dropdown id=freq ng-class=\"{\'anything-disabled\': true}\">{{Modal.modalData.defaultFreq.name}}<!--                      <img src=\"../../../../../assets/images/icons/drop-arrow-red.svg\" alt=\"down\">--></div></div></div></div></div></div></div></div><div class=\"row sipviaPurchase-details-btn-container\"><button class=\"btn btn-primary-action\" ng-disabled=\"!sipDetailsForm.$valid || !Modal.formData.frequency || Modal.isMin || Modal.amountExceeded || !Modal.formData.startDate || !Modal.formData.endDate || (!Modal.isMin && (Modal.validations.amountMultiples&&!Modal.isMultiples))\" ng-click=Modal.closeModal()>Confirm</button></div></form></div></div>");
$templateCache.put("app/components/modal/sipOrPurchaseBasket/sipOrPurchaseBasket.modal.html","<div class=modal-content><div class=modal-head><h3 class=modal-title>How Would you like to proceed with investment in?</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=text-center><button class=\"btn-ecart btn-primary-action\" ng-click=Modal.redirectToTransaction()>SIP</button> <button class=\"btn-ecart btn-secondary-action ecart-button-alignment\" autofocus ng-click=Modal.redirectToTransaction()>LUMPSUM</button></div></div></div>");
$templateCache.put("app/components/modal/sipTopupDetailsModal/sipTopupDetails.modal.html","<div class=\"modal-content sipTopup-details-modal\"><div class=modal-head><h3 class=modal-title>SIP Top-Up</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body siptopup-modal-body\"><form name=sipTopupForm autocomplete=off><div class=\"row mb-3\"><div class=\"col-sm-12 col-md-6\"><div class=form-input ng-class=\"{error:(sipTopupForm.topupAmount.$invalid && sipTopupForm.topupAmount.$dirty),\'has-data\':Modal.formData.topupDetails.amount}\"><label class=form-label>Amount</label><div class=input-group><!--            <span class=\"input-group-text\" id=\"rupee-addon\">--><!--              <div class=\"ruppee-img\"></div>--><!--            </span>--> <input type=text ignore-mouse-wheel name=topupAmount style=\"border-left: 1px solid rgba(111, 111, 111, 0.4) !important\" ng-model=Modal.formData.topupDetails.displayAmount ng-disabled=\"\" ng-change=Modal.checkSipValidationsForTopupAmount(true) onkeyup=\"NumToWord(this.value,\'divDisplayInWords\')\" class=form-control ng-required=Modal.formData.showTopUpBlock ng-class=\"{\'empty-padding\' : !Modal.formData.topupDetails.displayAmount}\"> <span class=rupee-span-new-top-up ng-if=!Modal.formData.topupDetails.displayAmount>₹</span></div><span class=error-input ng-show=\"sipTopupForm.topupAmount.$dirty && sipTopupForm.topupAmount.$error.required\" ng-bind=Modal.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Modal.formData.topupDetails.amount && Modal.modalData.isTopupMinAmt\" class=error-input>Minimum amount should be &#8377; {{Modal.modalData.validations.topupMinAmt|unit}}</span> <span ng-if=\"Modal.formData.topupDetails.amount  && !Modal.modalData.isTopupMinAmt && (Modal.modalData.validations.topupAmtMultples && !Modal.modalData.isTopUpMultiples)\" class=error-input>Please provide In multiples of &#8377; {{Modal.modalData.validations.topupAmtMultples|unit}}</span> <span ng-show=\"sipTopupForm.topupAmount.$dirty && Modal.formData.topupDetails.amount && Modal.amountExceeded\" class=error-input ng-bind=Modal.VALIDATE_DATA.AMOUNT_EXCEEDED></span></div><div class=form-group><label ng-if=Modal.formData.topupDetails.amount>{{Modal.topupAmount.amountInWords}} (In Words)</label></div></div><div class=\"col-sm-12 col-md-6\"><div class=duration-content-wrapper><div class=\"head-title f-family-inter f-weight-600\">Frequency</div><div class=\"d-flex gap-2 mt-3\"><!-- Loop through the topupFrequencyList from API --> <button type=button class=\"btn duration-btn f-weight-500\" ng-repeat=\"topUpFreq in Modal.topupFrequencyList\" ng-class=\"{\'active-btn\': Modal.formData.topupDetails.frequency === topUpFreq.key}\" ng-click=Modal.changeTopUpFreq(topUpFreq)>{{topUpFreq.value}}</button></div></div></div></div><div class=\"sip-topupcap-title mb-2 f-family-inter f-weight-700\">SIP Top-Up Cap</div><div class=\"row topup-amt-and-capyear-container\"><div class=col-md-6><div class=form-input ng-class=\"{error:(sipTopupForm.capAmount.$invalid && sipTopupForm.capAmount.$dirty && Modal.modalData.isminCapAmount),\'has-data\':Modal.formData.capAmount}\"><label class=form-label>Amount</label><div class=input-group><!--                              <span class=\"input-group-text\" id=\"rupee-addon\">--><!--                                <div class=\"ruppee-img\"></div>--><!--                              </span>--> <input type=text ignore-mouse-wheel name=capAmount style=\"border-left: 1px solid rgba(111, 111, 111, 0.4) !important\" ng-model=Modal.formData.topupDetails.displayCapAmount onkeyup=\"NumToWord(this.value,\'capAmntDisplayInWords\')\" ng-change=Modal.capAmountChanged(); class=form-control ng-required=\"Modal.formData.showTopUpBlock && ((!Modal.formData.topupDetails.capAmount && !Modal.formData.topupDetails.capMonthYearSelect))\" ng-class=\"{\'empty-padding\' : !Modal.formData.topupDetails.displayCapAmount}\"> <span class=rupee-span-new-top-up ng-if=!Modal.formData.topupDetails.displayCapAmount>₹</span></div><span class=error-input ng-show=\"sipTopupForm.capAmount.$dirty && sipTopupForm.capAmount.$error.required\" ng-bind=Modal.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Modal.formData.topupDetails.capAmount && Modal.isminCapAmount\" class=error-input>Minimum amount should be &#8377; {{Modal.minCapAmount}}</span></div><div class=form-group ng-if=\"Modal.formData.modifyAction !== \'modifySip\'\"><label><span ng-if=Modal.formData.topupDetails.capAmount>{{Modal.topupCapAmount.amountInWords}} (In Words)</span></label></div><div class=form-group ng-if=\"Modal.formData.modifyAction == \'modifySip\'\"><label ng-if=Modal.formData.topupDetails.capAmount>{{Modal.topupCapAmount.amountInWords}} (In Words)</label></div></div><!-- OR Divider --><div class=\"col-lg-1 col-md-1 col-sm-12 text-center separator-wrapper\"><div class=or-divider><span class=divider-text>OR</span></div></div><div class=\"col-md-5 cap-month-year-container\"><div class=form-input><label class=form-label>Cap Month Year</label><div class=\"field-type-2 capMonthYear-calender-wrapper\" ng-if=\"Modal.formData.topupDetails.frequency === \'Y\'\"><div class=\"input-normal verify-acc input-group date date-picker transaction-cal form-control\" ng-class=\"{error:sipTopupForm.endDate.$dirty && sipTopupForm.endDate.$invalid}\" date-calendar data-viewmode=years data-date-default=Modal.formData.topupDetails.capMonthYearSelect data-on-date-change=Modal.changeCapMonthYear data-enabled-dates=Modal.capDatesView data-view-date=Modal.enableCapDateView data-min-date=Modal.minCapDate data-max-date=Modal.capYearMaxYear format=MMM-YYYY data-enable=true id=capMonthYearY date-mode=year-month showdefault=false><input type=text name=capMonthYear autocomplete=off placeholder=MMM-YYYY readonly ng-required=\"Modal.formData.showTopUpBlock && !Modal.formData.topupDetails.capAmount\"> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar-revamp\"></span></span></div></div><div class=\"field-type-2 capMonthYear-calender-wrapper\" ng-if=\"Modal.formData.topupDetails.frequency === \'H\'\"><div class=\"input-normal verify-acc input-group date date-picker transaction-cal form-control\" ng-class=\"{error:sipTopupForm.endDate.$dirty && sipTopupForm.endDate.$invalid}\" date-calendar data-viewmode=years data-date-default=Modal.formData.topupDetails.capMonthYearSelect data-on-date-change=Modal.changeCapMonthYear data-enabled-dates=Modal.capDatesView data-view-date=Modal.enableCapDateView data-min-date=Modal.minCapDate data-max-date=Modal.capYearMaxYear format=MMM-YYYY data-enable=true id=capMonthYearH date-mode=year-month showdefault=false><input type=text name=capMonthYear autocomplete=off placeholder=MMM-YYYY readonly ng-required=\"Modal.formData.showTopUpBlock && !Modal.formData.topupDetails.capAmount\"> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar-revamp\"></span></span></div></div></div></div></div><div class=\"row sip-topup-details-btn-container\"><button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal(Modal.isminCapAmount)>Cancel</button> <button class=\"btn btn-primary-action\" ng-disabled=\"!sipTopupForm.$valid || Modal.isminCapAmount || Modal.modalData.isTopupMinAmt || !Modal.modalData.isTopUpMultiples || Modal.amountExceeded\" ng-click=Modal.closeModal()>Save</button></div></form></div></div>");
$templateCache.put("app/components/modal/statements/statementpdf.modal.html","<!-- Scheme List--><div class=modal-content id=statementPdf><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"loader popup\"><span class=loading></span></div><div class=modal-body><p class=report-type>IDCW Statement</p><iframe src=http://indiabudget.gov.in/ub2017-18/memo/memo.pdf></iframe></div></div>");
$templateCache.put("app/components/modal/subscribeToggle/subscribeToggle.modal.html","<div class=\"modal-content subscribe-modal\"><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"loader popup\"><span class=loading></span></div><div class=modal-body><div class=\"textarea-subscribe strong\" style=\"line-height: 1.5\">Could you please provide your reason for opting out of HDFC MFOnline Investors promotional notifications</div><textarea ng-model=Modal.reasonForOptingOut placeholder=\"Enter reason...\" cols=40 rows=10 style=\"margin-top: 30px;margin-bottom: 30px;padding: 5px;width: 100%;resize: none\"></textarea><div class=text-center><button type=submit class=\"btn btn-primary-action\" ng-click=Modal.confirmUnsubscribe()>Submit</button></div></div></div>");
$templateCache.put("app/components/modal/subscribeWhatsapp/subscribeWhatsapp.modal.html","<div class=modal-content id=tnc><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body id=subscribe-modal><div class=subscribe-body><div class=subscribe-image></div><div class=subscribe-text><div class=\"text-center subscribe-para\">Hey there!<br>HDFC MF is now on WhatsApp.</div><div class=\"text-center modal-text-margin-top\">You can now make purchase or SIP transaction or request for Account Statements or Status Checks with HDFC MF on WhatsApp.</div><div class=\"text-center modal-text-margin-top\">Just say ‘Hi’ in the message window and get started!</div><div class=\"text-center modal-text-margin-top\"><div class=text-center><label for=tnc class=tnc-text-color><input type=checkbox class=subscribe-check name=tnc ng-model=Modal.isTnCchecked> <span ng-click=Modal.tnC()>I have read the WhatsApp Service Terms & Conditions</span></label></div></div><div class=\"text-center modal-text-margin-top\"><button type=submit ng-click=Modal.movetosecondstep() class=\"btn btn-primary-action subscribe-button\" ng-disabled=!Modal.isTnCchecked>Register Now</button></div></div></div></div></div>");
$templateCache.put("app/components/modal/subscribeWhatsapp/subscribeWhatsappSecondStep.modal.html","<div class=modal-content id=tnc ng-init=Modal.subsSecondStepModalInit()><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body second-step-subscribe-body\"><div class=\"subscribe-para text-center\">Thank You!</div><div class=\"text-center modal-text-margin-top\">You have successfully subscribe for HDFC MF WhatsApp service.</div><div class=\"text-center modal-text-margin-top\">You can initiate transaction with HDFC MF through WhatsApp from any/all of your registered mobile numbers as listed below.</div><div class=\"text-center modal-text-margin-top\"><div class=text-center><div ng-repeat=\"number in Modal.mobileNumberList track by $index\">{{number}}</div></div></div><div class=\"text-center modal-text-margin-top\"><button type=submit ng-click=Modal.closeModal() class=\"btn btn-primary-action\">Submit</button></div><div class=\"text-center market-risk-text modal-text-margin-top\">Mutual Fund Investments are subject to market risks, read all scheme related documents carefully.</div></div></div>");
$templateCache.put("app/components/modal/subscribeWhatsapp/subscribeWhatsappTnC.modal.html","<div class=modal-head><h3 class=modal-title>WhatsApp Terms and Conditions</h3><i class=times-icon ng-click=Modal.closeModal();></i></div><div class=\"modal-body whatsappSubscribeTnCModal\"><h6 class=\"margin-none modal-text-line-height\">‘Chatbot’ via HDFC MF ‘website’ and ‘WhatsApp’ for Investors – Terms of Use</h6><div class=\"modal-text-margin-top modal-text-line-height\">Thank you for visiting the HDFC MF website. These terms and conditions (hereinafter referred to as \"<strong>Terms</strong>\") are for Investors who wish to use the ‘chatbot’ feature via ‘website’ and / or ‘WhatsApp’ (hereinafter collectively referred to as \"<strong>the Platform</strong>\"); to undertake transactions in the schemes of HDFC Mutual Fund (\"<strong>HDFC MF</strong>\") that are managed by HDFC Asset Management Company Limited (\"<strong>HDFC AMC</strong>\") (jointly hereinafter referred to as \"<strong>we</strong>\", \"<strong>us</strong>\", or \"<strong>our</strong>\").<div class=modal-text-margin-top></div>This page sets forth the Terms applicable for the access and use of the Platform for every person who visits the Platform (hereinafter referred to as \"<strong>User</strong>\" or \"<strong>they</strong>\" or \"<strong>their</strong>\" or \"<strong>you</strong>\" or \"<strong>your</strong>\"), and shall be applicable to all folios, which are existing or may be created at any time in future. You are requested to read these Terms carefully before you start using the Platform. By using the Platform you indicate that you have read, understood and accepted these Terms and have agreed to abide by the same without any limitation or qualification.<div class=modal-text-margin-top></div>We reserve the right to modify these Terms at any time. Your continuing to use the Platform and availing of the facilities provided therein subsequent to modifications shall be construed as you having read, understood, and agreed to be bound by the revised Terms and shall constitute an agreement between you and HDFC AMC. These Terms shall always be read in conjunction with our Privacy Policy and the Terms of Use of our website available on <a href={{Modal.HDFC_API.WEBSITE_LINK}} target=_blank>{{Modal.HDFC_API.WEBSITE_LINK}}</a> and the terms and conditions of the Scheme Information Document (\"<strong>SID</strong>\"), the Key Information Memorandum (\"<strong>KIM</strong>\"), and the Statement of Additional Information (\"<strong>SAI</strong>\") (hereinafter collectively referred to as <strong>Scheme Related Documents</strong>). If you do not intend to be legally bound by these Terms, including amendments thereto, please refrain from using the Platform.<div class=modal-text-margin-top></div>This Platform for HDFC MF investors is powered by Computer Age Management Services (“<strong>CAMS</strong>”) and hence the terms and conditions of CAMS for access and use will also apply. Kindly refer to the same on myCAMS website:<div class=modal-text-margin-top></div><a href=\"https://mycams.camsonline.com/ policiestc/disclaimerandtermsofuse\" target=_blank>https://mycams.camsonline.com/ policiestc/disclaimerandtermsofuse</a><div class=modal-text-margin-top></div>Further, kindly note that the terms and conditions of WhatsApp for access and use will also apply. Kindly refer to the same on WhatsApp website: <a href=\"https://www.whatsapp.com/legal/?lg=en&lc=US&eea=0\" target=_blank>https://www.whatsapp.com/legal/?lg=en&lc=US&eea=0</a></div><h6 class=\"modal-text-margin-top modal-text-line-height\">Eligibility</h6><div class=\"modal-text-margin-top modal-text-line-height\"><ul><li>Only for ‘Resident Indian’ adults having the mode of holding/operation as ’Single’ or ’Anyone or Survivor’; who are eligible to invest in schemes of HDFC MF as per the terms of the Scheme Related Documents and are not restricted by any legal/regulatory/judicial/quasi judicial/other authority to invest in schemes of HDFC MF and have already registered their mobile number and e-mail id with HDFC AMC/HDFC MF - are entitled to use the Platform after registration through <a href={{Modal.HDFC_API.WEBSITE_LINK}}whatsapp-service target=_blank>{{Modal.HDFC_API.WEBSITE_LINK}}whatsapp-service</a></li><div class=modal-text-margin-top></div><li>Access to Platform shall not be available to US Persons (i. e., a U.S. person within the meaning of Regulation S under the Securities Act of 1933 of U.S. or as defined by the U.S. Commodity Futures Trading Commission as amended from time to time) or to residents of Canada.</li><div class=modal-text-margin-top></div><li>If you choose to access the Platform from locations other than India, you shall do so at your own risk and you would be solely responsible for compliance with applicable local laws and regulations of such location/territory. We accept no liability whatsoever, direct or indirect, for non-compliance with the laws of any country other than the Republic of India. The mere fact that the Platform can be accessed through internet by you in a country other than India shall not be interpreted to imply that the laws of the said country govern these Terms and/or the use of the Platform. Existing eligible unit holders /investors of HDFC MF may, at any time, subject to these Terms, register through website [insert link] and use the facilities available on the Platform.</li><div class=modal-text-margin-top></div><li>User hereby agrees to abide by these Terms and all applicable Indian and Foreign laws/rules/regulations in force and the changes thereto from time to time relating to the access to the Platform and/or the facilities made available thereon, including those relating to execution of transactions in Schemes of HDFC MF. The User further confirms that he is authorised, and is not restricted by any legal/regulatory/judicial/quasi judicial/other authority, to access the Platform and avail of the facilities offered thereon, including to execute transactions in schemes of HDFC MF.</li><div class=modal-text-margin-top></div><div class=modal-text-margin-top></div><li>For Users who are existing investors of HDFC MF, the contact details shall be as per the details available with HDFC AMC/HDFC MF.</li><div class=modal-text-margin-top></div><li>You hereby confirm that you shall not use the Platform for any unlawful or improper purposes. HDFC AMC/HDFC MF shall be authorized to immediately discontinue/suspend/terminate your access to the Platform upon being made aware of any such unlawful or improper use of the Platform.</li></ul></div><h6 class=\"modal-text-margin-top modal-text-line-height\">Minor investors:</h6><div class=\"modal-text-margin-top modal-text-line-height\">The Platform may be accessed on behalf of a minor unit holder/investor by the natural and/or legal guardian. The guardian shall represent the minor in all transactions of any description executed on the Platform or otherwise on behalf of the minor until the said minor attains majority. The minor unit holder’s bank account details are required to be registered for the purpose of receiving redemption proceeds/ dividend payouts, and in the absence of the same, the bank account of the guardian representing the minor may be registered till such time a bank account is opened in the name of the minor and details of the same is registered in the folio of the minor investor. However, HDFC AMC/HDFC MF shall pay proceeds of redemption / dividend payouts only in the name of minor investor/ minor unit holder. HDFC AMC/HDFC MF shall not be liable for any loss or damage sustained by the minor unit holder on account of any non-receipt of or delays in receiving the redemption proceeds / dividend payouts on account of the above.<div class=modal-text-margin-top></div>Nomination shall not be allowed till such time the minor attains the age of majority.<div class=modal-text-margin-top></div>The guardian shall be eligible to access the Platform on behalf of the minor till such time the minor attains the age of majority. The guardian agrees to indemnify HDFC AMC/HDFC MF against any claim of the minor for any transactions made in the minor\'s account. Upon the minor attaining the age of majority, the right of the guardian to represent the minor and to access the Platform on behalf of the minor shall stand terminated. The minor shall be required to fulfil such formalities, through submission of physical request forms and documents, updation of bank and contact details, etc., as may be stipulated by HDFC AMC/HDFC MF for change of status from minor to major from time to time. Access to the Platform with respect to the investments of the minor unitholder shall remain suspended till such time the formalities of change of status are completed.<div class=modal-text-margin-top></div>To continue accessing the Platform the minor (now turned major) User shall also be required to update the bank account details, contact details, nomination, etc., on the Platform, before online facilities available on the Platform can be availed of.<div class=modal-text-margin-top></div><ul><li>HDFC AMC/HDFC MF reserves the right to decide the type of services/facilities that may be offered on the Platform from time to time. There is no assurance by HDFC AMC/HDFC MF that all facilities that are available under the offline/physical mode shall also become available to the User on the Platform. HDFC AMC/HDFC MF may also, at its sole discretion, make additions modifications and/or deletions to the services and/or facilities that are presently offered on the Platform.</li></ul><h6 class=\"modal-text-margin-top modal-text-line-height\">Access</h6><div class=\"modal-text-margin-top modal-text-line-height\"><ul><li>You hereby acknowledge and agree that it shall be your responsibility to upgrade the software, hardware and the operating system of your computer and/or mobile phone handset, as the case may be at your sole cost and consequences from time to time so as to remain compatible with that of the Platform; and you also would require a proper uninterrupted internet connection.</li><div class=modal-text-margin-top></div><li>We shall be at liberty to change, vary or upgrade the software, hardware, operating systems, etc. of the Platform from time to time and shall be under no obligation to provide support to all versions of the software, hardware, or operating systems used by you. We shall not be liable for your failure to access the Platform, partially or fully, whether due to your systems, the internet network or any other cause or reason whatsoever.</li><div class=modal-text-margin-top></div><li>The Platform and its features and facilities offered may be expanded, limited or modified at any time to meet the needs of the Users, or for regulatory, technical or any other reasons whatsoever, without providing any advance notice or reason to Users. We reserve the right to change, modify, suspend, add, remove, or restrict the User’s access to the Platform or a part of it at our sole discretion, without prior notice. We may also in our sole discretion, and at any time, discontinue, temporarily or permanently, any or the entire facilities under the Platform without notice. This could result in delays or failure in the processing of instructions or requests of the Users. We disclaim all and any liability, whether direct or indirect, whether arising out of loss of profit or otherwise, sustained by any User on account of such delays or failure and each User hereby acknowledges and agrees to the same.</li><div class=modal-text-margin-top></div><li>While we will make all reasonable efforts to ensure that industry standard, accessible formats are used for the materials posted on the Platform. However, we cannot guarantee the compatibility of such materials with your computer or mobile software.</li><div class=modal-text-margin-top></div><li>As this is an electronic service, access cannot always be guaranteed due to external factors beyond our control. Whilst we endeavour to ensure that the facilities offered under the Platform are available without any interruptions, we do not guarantee that the access to or use of Platform or any part thereof will be uninterrupted or error free or that the Platform or the server that makes it available will be free of viruses or other harmful, malicious, or disruptive components. You agree not to hold us liable or responsible for any loss/damage that may be suffered by you while downloading or using the software for accessing the Platform or while availing of any facilities under the Platform.</li><div class=modal-text-margin-top></div><li>The internet per se is susceptible to a number of frauds, misuse, hacking and other actions, which could affect the electronic instructions to us through the Platform. Whilst we aim to provide security to prevent the same, we cannot provide any guarantee from such internet frauds, hacking and other risks associated with the internet.</li></ul></div><h6 class=\"modal-text-margin-top modal-text-line-height\">Security</h6><div class=\"modal-text-margin-top modal-text-line-height\"><ul><li>With a view to enhance security for transacting on the Platform, all Users will be asked certain authentication questions and an OTP will be sent on their registered mobile number for verification.</li><div class=modal-text-margin-top></div><li>At the end of every transaction request that is successfully processed/ executed; a transaction completion receipt shall be sent on your registered e-mail id and your registered mobile number. You shall notify us immediately of any unauthorized use of the Platform or any other breach of security whatsoever that you may be aware of.</li></ul></div><h6 class=\"modal-text-margin-top modal-text-line-height\">Execution of Transactions</h6><div class=\"modal-text-margin-top modal-text-line-height\"><ul><li>The online facilities made available to the Users on the Platform shall be in addition to and not in substitution of the existing procedures or facilities for transacting in the Schemes of HDFC MF, including through offline/physical mode and there is no assurity regarding uninterrupted availability of the Platform to its Users or timely receipt of the OTP on the registered mobile number.</li><div class=modal-text-margin-top></div><li>Users requesting for any transaction shall be liable to pay all charges, fees, interests, and costs, as applicable, which HDFC AMC/HDFC MF in its absolute discretion may levy with respect to such services/facilities offered on the Platform.</li><div class=modal-text-margin-top></div><li>Transaction request(s) made on the Platform may not be processed by HDFC AMC/HDFC MF till clear funds sufficient to cover the subscription price have been received by HDFC AMC/HDFC MF in its bank account; and not upon the debit of funds from the bank account of the User.</li><div class=modal-text-margin-top></div><li>The payment for any transaction on the Platform shall be made by the User using any of the payment gateways including, but not limited to, Net Banking Facility, National Electronics Funds Transfer System (<strong>NEFT</strong>), Real Time Gross Settlement (“<strong>RTGS</strong>”), HDFC Bank Fund Transfer Facility, etc., and HDFC AMC/HDFC MF will not be liable for any failures in the link or for any fraud (either at the payment gateway\'s end and/or the bank\'s end or failure of telecommunication network) that could take place at the time of making payment. If HDFC AMC/HDFC MF does not receive the subscription amount within five working days from the date of subscription transaction, such transaction will be treated as cancelled. A transaction shall be construed to be completed only upon receipt of a written confirmation in that regard from HDFC AMC/HDFC MF and not otherwise.</li><div class=modal-text-margin-top></div><li>The User hereby confirms that any amount utilised for transacting in the Scheme(s) of HDFC MF is/shall be through legitimate sources only and transaction executed by the User are not for the purpose of contravention and/or evasion of any act, rules, regulations, notifications or directions issued by any regulatory authority in India or in any other jurisdiction applicable to the User.</li><div class=modal-text-margin-top></div><li>User understands and acknowledges that the responsibility of providing the correct information/details, including the contact information, amount, the bank account details, etc., lies solely with the User and HDFC AMC/HDFC MF shall not be responsible to verify the accuracy of the information/details provided by the User. The User shall also be liable to inform HDFC AMC/HDFC MF/Registrar and Transfer Agent of any change in any details or information provided initially. If any incorrect bank account number is provided by the User, any amount payable to the User could be credited to the wrong bank account so provided by the User and there is no guarantee of recovery of the same. The User shall take all care and caution to ensure that there are no mistakes and errors and that the information given to HDFC AMC/HDFC MF is error free, accurate, proper, and complete at all points of time. The User confirms that HDFC AMC/HDFC MF shall not be held liable for any loss or damage that may be sustained by the User on account of such error on the part of the User.</li><div class=modal-text-margin-top></div><li>The User also confirms that, if the User receives any wrong credit of funds in his bank account from HDFC AMC/HDFC MF, which does not belong to the User, on account of any reason whatsoever, the same shall immediately be returned to HDFC AMC/HDFC MF.</li><div class=modal-text-margin-top></div><li>Any request for transaction on the Platform shall be time stamped consistent with the terms of the Scheme Related Documents. The Net Asset Value (NAV) applicable for purchase or redemption or switching of units shall be based on the time of the business day on which the application is received / completed on the Platform, and subject to the provisions of realisation of funds and cut off timings as described in the Scheme Related Documents of HDFC MF. Any transactions received/completed on the Platform after the cut off time as mentioned in the Scheme Related Documents shall be deemed to be received on the succeeding business day and shall be processed accordingly. The decision of HDFC AMC in this regard shall be final and binding on the User.</li><div class=modal-text-margin-top></div><li>Transactions once placed on the Platform cannot be cancelled by the User other than as specifically allowed on the Platform.</li></ul></div></div><h6 class=\"modal-text-margin-top modal-text-line-height\">General Terms</h6><div class=\"modal-text-margin-top modal-text-line-height\"><ul><li>Amendments: These Terms may be amended or modified at any time and for such reason as HDFC AMC deems fit and proper including but not limited to comply with changes in laws and/or regulations, to correct inaccuracies, omissions, errors or ambiguities, reflect changes in the scope and nature of the services or based on User requirements.</li><div class=modal-text-margin-top></div><li>Suspension or Termination of facilities: HDFC AMC may, at its sole discretion, suspend/ disallow/ modify/ restrict all or any of the facilities offered under the Platform or deny access to the Platform to any specific User at any time and for such time period and for such reasons as it deems fit; including on account of inactive/dormant User ID, non compliance of the Terms, death, insolvency, or bankruptcy of the User, any restriction imposed by any legal/ judicial /regulatory authority, or for any other cause arising out of the law/regulation or for such other reasons as we may deem fit.</li><div class=modal-text-margin-top></div><li>HDFC AMC shall be entitled to withdraw or terminate all or any facilities offered under the Platform without assigning any reason whatsoever, without any prior notice to the User.</li><div class=modal-text-margin-top></div><li>HDFC AMC shall not be liable for any loss or damage that may be sustained by any User on account of such suspension/withdrawal/termination by HDFC AMC.</li><div class=modal-text-margin-top></div><li>Accuracy of information: You shall solely be responsible for the correctness of information supplied to us for use of the Platform or while availing of any facility on the Platform or through any other means such as electronic mail or written communication. We accept no responsibility or liability for the consequences arising out of any erroneous information supplied to us. If you notice an error in the information supplied to us, you shall immediately notify the same to us in order to enable us to endeavor to correct the error wherever possible on a \"reasonable efforts\" basis.</li><div class=modal-text-margin-top></div><li>All outputs of statements are duplicate Statements of Account and are prepared by electronic means and the information contained therein will be extracted from a computerized back-up system maintained by HDFC AMC. In case you notice any error in the account information supplied through the Platform or transaction confirmation received by you, you shall promptly, but not later than 30 (Thirty) days from the date of receipt of the information, intimate us of the same. Upon receipt of such intimation, we shall endeavor to correct the error.</li><div class=modal-text-margin-top></div><li>You hereby agree and acknowledge that, while we will take all reasonable steps to ensure the accuracy of the statement and information generated, we shall not be held liable for any errors therein. You further agree to hold us harmless against any loss, damages, etc., that may be incurred /suffered on account of any inaccurate/incorrect information contained in the outputs from the Platform.</li></ul></div><h6 class=\"modal-text-margin-top modal-text-line-height\">Disclaimers</h6><div class=\"modal-text-margin-top modal-text-line-height\"><ul class=list-align-tnc><li>Your use of the Platform shall be at your sole risk. The Platform has been provided on an “as is” and “as available” basis. Except as explicitly warranted in these Terms, we make no express or implied warranty with respect to the services/facilities provided on the Platform, including, without limitations, any warranties of uninterrupted/error free performance of the Platform, that any identified defects will be corrected, that the Platform is free from viruses or other malicious, destructive or corrupting code, non-infringement of third party rights, title, merchantability, data accuracy and completeness, satisfactory quality and/or fitness for a particular purpose.</li><div class=modal-text-margin-top></div><li>The facilities offered on the Platform shall not constitute an offer to buy or sell or a solicitation to any person in any jurisdiction where it is unlawful to make such offer or solicitation.</li><div class=modal-text-margin-top></div><li>Whilst every reasonable precaution has been taken to ensure the accuracy, security and confidentiality of data and information on the Platform, there cannot be any guarantee from internet frauds, hacking and other similar actions.</li><div class=modal-text-margin-top></div><li>We make no representation that the Platform or the facilities offered on the Platform are appropriate or available for use in other locations or territories where their contents are unlawful and is prohibited. If you choose to access the Platform from locations other than India, you shall do so on your own initiative and you would be responsible for compliance with applicable local laws and regulations of such location/territory.</li><div class=modal-text-margin-top></div><li>We do not have any direct agreement or tie-up with WhatsApp and we shall not be responsible for any of the communication sent or received by the User over WhatsApp or the services provided by WhatsApp to the Users particularly in relation with data privacy or data integrity.</li></ul></div><h6 class=\"modal-text-margin-top modal-text-line-height\">Liability</h6><div class=\"modal-text-margin-top modal-text-line-height\"><ul class=list-align-tnc><li>HDFC AMC/HDFC MF shall not be liable for any damages or losses sustained by the User (direct and/or indirect) whatsoever, due to disruption or non-availability of the services/facility(s) under the Platform due to technical fault/error or any failure or failure in telecommunication network or any error in any software or hardware systems.</li><div class=modal-text-margin-top></div><li>HDFC AMC/HDFC MF shall also not be liable for any unauthorised transactions occurring through the Platform and the User hereby fully indemnifies and holds HDFC AMC/ HDFC MF harmless against any action, suit, proceeding initiated against it or any loss, cost or damage incurred by it as a result thereof.</li><div class=modal-text-margin-top></div><li>HDFC AMC/HDFC MF shall under no circumstance be held liable to the User if the Platform or all or any part of the facilities on the Platform is not available in the desired manner for reasons including but not limited to legal restraints, faults in the telecommunication network or network failure, faults in computer systems, or any other force majeure events (such as flood, extraordinary weather condition, earthquake or other act of God, fire, war, insurrection, riot, labour dispute, accident, action of government, communications, power failure, equipment or software malfunction) or any other reason beyond the control of HDFC AMC/HDFC MF.</li><div class=modal-text-margin-top></div><li>Under no circumstances shall HDFC AMC/HDFC MF be liable for any damages whatsoever whether such damages are direct, indirect, incidental or consequential and irrespective of whether any claim is based on loss of revenue, interruption of business or any loss of any character or nature whatsoever and whether sustained by the User or by any other person.</li><div class=modal-text-margin-top></div><li>Illegal or improper use of the Platform shall render the User liable for payment of financial charges as decided by HDFC AMC/HDFC MF or will result in suspension / termination of the access to the Platform extended to the User. The aforesaid does not limit rights of HDFC AMC/HDFC MF to initiate appropriate legal proceedings against the User.</li></ul></div><h6 class=\"modal-text-margin-top modal-text-line-height\">Disclosure of personal information</h6><div class=\"modal-text-margin-top modal-text-line-height\">We may use your personal information for following purposes:<div class=modal-text-margin-top></div><ul class=list-align-tnc><li>To process your requests for any of the services on the Platform.</li><div class=modal-text-margin-top></div><li>To deliver any administrative notices, alerts, advice, notifications and communications relevant to your use of any facilities on the Platform.</li><div class=modal-text-margin-top></div><li>To analyze usage of the Platform and improve the services /facilities offered</li><div class=modal-text-margin-top></div><li>For market research, project planning, troubleshooting problems, detecting and protecting against error, fraud or other criminal activity.</li><div class=modal-text-margin-top></div><li>To disclose as required by applicable laws/regulations or to any Indian or foreign statutory, regulatory, judicial, quasi-judicial authorities/agencies including, but not limited to Financial Intelligence Unit-India (FIU-IND)</li><div class=modal-text-margin-top></div><li>To disclose to our Sponsor(s), Trustees, its employees, and agents, and to other Institutions and/or Third Party Service Providers that provide services to us and which are bound by confidentiality arrangements with us.</li><div class=modal-text-margin-top></div><li>For participation in any telecommunication or electronic clearing network.</li><div class=modal-text-margin-top></div><li>In compliance with a legal directive.</li><div class=modal-text-margin-top></div><li>For fraud prevention purposes.</li></ul><div class=modal-text-margin-top></div>We, either directly or through call centres, may call or send promotional information/ material or other alters to the mobile number/(s) or email IDs provided by you during the course of registration on the Platform and you shall be deemed to have provided your consent for receipt of such promotional information/material. If you do not wish to receive such promotional information/ materials, please call on toll free no. 1800 3010 6767/ 1800 419 7676 or register for the Do Not Call Register (“DNCR”) of HDFC AMC/HDFC MF.<div class=modal-text-margin-top></div>We reserve the right to record telephonic conversations with Users for quality control purposes.<div class=modal-text-margin-top></div>The confidentiality obligations of HDFC AMC/HDFC MF shall be subject to the Privacy Policy displayed on the website <a href={{Modal.HDFC_API.WEBSITE_LINK}} target=_blank>{{Modal.HDFC_API.WEBSITE_LINK}}</a> and these Terms shall be read in conjunction with the said Privacy Policy. The User, by agreeing to these Terms shall be deemed to have consented to the terms of the Privacy Policy of HDFC AMC/HDFC MF.</div><h6 class=\"modal-text-margin-top modal-text-line-height\">Indemnity</h6><div class=\"modal-text-margin-top modal-text-line-height\">User shall indemnify and keep indemnified and hold harmless, HDFC AMC/HDFC MF for all claims, liabilities, losses, damages and expenses which HDFC AMC/HDFC MF may sustain or incur either directly or indirectly as a result of:<div class=modal-text-margin-top></div><ul class=list-align-tnc><li>Providing to the User an access to the Platform and the facilities offered on the Platform.</li><li>Unauthorised use of the Platform or by any third party through the User’s personal and financial information</li><li>HDFC AMC/HDFC MF in good faith taking or refusing to take any action on the electronic instructions received from the User.</li><li>Fraud, negligence/ mistake or misconduct by the User.</li><li>Any illegal or improper use of the Platform by the User.</li><li>Negligence or mistake or misconduct of the User.</li><li>Any delay or failure to process the transactions carried out by the User due to error, defect, failure or interruption or for any reason whatsoever; or</li><li>Breach or non-compliance of any of the Terms by the User.</li></ul></div><h6 class=\"modal-text-margin-top modal-text-line-height\">Governing Law and Jurisdiction</h6><div class=\"modal-text-margin-top modal-text-line-height\">These Terms and the use of the Platform shall be governed by the laws of the Republic of India.<div class=modal-text-margin-top></div>The User and the HDFC AMC/HDFC MF agree to submit to the exclusive jurisdiction of the courts in Mumbai as regards any disputes, claims or matters arising under these Terms. HDFC AMC/HDFC MF accepts no liability whatsoever, direct or indirect, for non-compliance with the laws of any country other than the Republic of India. The mere fact that the Platform can be accessed through internet by the User in a country other than Republic of India shall not be interpreted to imply that the laws of such country govern these Terms and/or the use of Platform.<div class=modal-text-margin-top></div>In case of a dispute, the matter will be settled by arbitration as per the rules of Arbitration and Conciliation Act, 1996. HDFC AMC shall nominate the sole arbitrator and that the place of arbitration shall be Mumbai and the language of arbitration shall be English.</div><h6 class=\"modal-text-margin-top modal-text-line-height\">Waiver</h6><div class=\"modal-text-margin-top modal-text-line-height\">Failure on the part of HDFC AMC/HDFC MF to enforce any rights conferred by these Terms or any law / regulation shall not be deemed to be a waiver of any such rights.</div><h6 class=\"modal-text-margin-top modal-text-line-height\">User Communication and Grievance Redressal</h6><div class=\"modal-text-margin-top modal-text-line-height\">In case you wish to offer your comments or feedback regarding this Platform or the online services offered on this Platform or if you wish to air any complaints or grievances, you may contact us on 1800 3010 6767 / 1800 419 7676 or write to us to <a href=mailto:cliser@hdfcfund.com>cliser@hdfcfund.com</a>.</div><h6 class=\"modal-text-margin-top modal-text-line-height\">Interpretation</h6><div class=\"modal-text-margin-top modal-text-line-height\"><ul class=list-align-tnc><li>The headings are used for convenience and ease of reference only and shall not affect the construction or interpretation of any provisions of these Terms.</li><div class=modal-text-margin-top></div><li>The words, you, your, and User refer to the person(s) who access the Platform and shall include both singular and plural. Reference to masculine shall include the feminine and neuter gender.</li><div class=modal-text-margin-top></div><li>Words and expressions used but not defined herein shall have the same meanings assigned to them in such Scheme Related Documents.</li><div class=modal-text-margin-top></div><li>In case of any conflict between the provisions of these Terms and the provisions of the Scheme Related Documents, the provisions of the Scheme Related Documents shall prevail.</li></ul></div></div>");
$templateCache.put("app/components/modal/subscriptions/confirmUnsubscribe.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div class=text-center>Are you sure you want to unsubscribe?</div><br><br><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissModal()>No</button> <button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>Yes</button></div></div></div>");
$templateCache.put("app/components/modal/subscriptions/editSubscription.modal.html","<!-- Scheme List--><div class=modal-content id=subscriptions><div class=\"loader subscription\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-head><h3>Edit Subscription</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body clearfix\"><div class=form-group><p class=title>Get Updates on</p><div><div class=checkbox ng-repeat=\"mode in Modal.MODE\" style=\"margin-right: 15px\"><input type=checkbox ng-model=mode.selected value={{mode.value}} ng-change=Modal.modeChanged(mode)> <i class=icon-checkbox></i> <span class=checkbox-text>{{mode.value}}</span></div></div></div><div class=form-group ng-if=Modal.oldFrequency><p class=title>Select Frequency</p><div><div class=radio-block><span class=radio><input type=radio type=radio name=folioFrequency value=DAILY ng-model=Modal.folioFrequency ng-change=Modal.frequencyChange()> <span class=check></span> </span><span class=radio-label>Daily</span></div><div class=radio-block><span class=radio><input type=radio type=radio type=radio name=folioFrequency value=WEEKLY ng-model=Modal.folioFrequency ng-change=Modal.frequencyChange()> <span class=check></span> </span><span class=radio-label>Weekly</span></div><div class=radio-block><span class=radio><input type=radio type=radio type=radio name=folioFrequency value=MONTHLY ng-model=Modal.folioFrequency ng-change=Modal.frequencyChange()> <span class=check></span> </span><span class=radio-label>Monthly</span></div></div></div><div class=\"modal-multiple-action text-center\"><button type=button class=\"btn-secondary-action btn-small\" ng-click=Modal.closeModal()>Cancel</button> <button ng-if=Modal.oldFrequency type=button class=\"btn-primary-action btn-small\" ng-disabled=\"(Modal.oldModeToCalculate === Modal.newModeToCalculate) && (Modal.oldFrequency===Modal.folioFrequency)\" ng-click=\"Modal.editSubscriptionSubmit(\'folio\')\">Submit</button> <button ng-if=!Modal.oldFrequency type=button class=\"btn-primary-action btn-small\" ng-disabled=\"(Modal.oldModeToCalculate === Modal.newModeToCalculate)\" ng-click=\"Modal.editSubscriptionSubmit(\'scheme\')\">Submit</button></div></div></div>");
$templateCache.put("app/components/modal/subscriptions/editSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div><i class=verify-icon></i></div><p>Your have successfully subscribed for<br>folio valuation updates.</p><br><p ng-if=Modal.successList>Folio(s): <strong ng-repeat=\"folio in Modal.successList\">{{folio}}{{$last ? \'\' : \', \'}}</strong></p><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/successMessage/success.modal.html","<ng-bind-html ng-if=Modal.modalData.firstLogin dynamic=Modal.DynamicDataFirstLogin.content></ng-bind-html><ng-bind-html ng-if=!Modal.modalData.firstLogin dynamic=Modal.DynamicData.content></ng-bind-html><style>.updateNomineeErrorField a {\n    font-weight: 600;\n    text-decoration: underline !important;\n  }\n  .btn{\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%) !important;\n    border-radius: 100px !important;\n  }</style>");
$templateCache.put("app/components/modal/termcondition/termcondition.modal.html","<div class=modal-content id=tnc><div class=modal-head><h3 class=modal-title>TERMS AND CONDITIONS</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><general-terms-condition transaction-type=GENERAL transaction-terms-data=Modal.dynamicDataTncGeneral ng-if=\"Modal.modalData.type !== \'SIP\'\"></general-terms-condition><general-terms-condition transaction-type=SIP transaction-terms-data=Modal.dynamicDataTncSip ng-if=\"Modal.modalData.type === \'SIP\'\"></general-terms-condition><!--<div class=\"modal-body\">\n\n    <h6 class=\"text-center\">HDFC MF Online for Investors – Terms of Use</h6>\n    <br/>\n\n    <p>\n      Thank you for visiting HDFC MF Online for Investors, a facility offered by HDFC Mutual Fund\n      (\"<strong>HDFC MF</strong>\")/HDFC Asset Management Company Limited (\"<strong>HDFC AMC</strong>\") (jointly\n      hereinafter\n      referred to as \"<strong>we</strong>\", \"<strong>us</strong>\", or \"<strong>our</strong>\") to enable online\n      transactions in schemes of HDFC MF\n      through our web portal, (\"<a target=\"_blank\" href=\"https://investor-web.hdfcfund.com\"><strong>Web Portal</strong></a>\")\n      and our mobile application,\n      HDFCMF Mobile (\"<strong>Mobile App</strong>\") (hereinafter collectively referred to as \"<strong>the\n      Platform</strong>\").\n    </p>\n    <br/>\n\n    <p>\n      This page sets forth the terms and conditions (\"<strong>Terms</strong>\") applicable to the access and use of the\n      Platform, including the Web Portal and the Mobile App, for every person who visits the Platform (hereinafter\n      referred to as \"<strong>User</strong>\" or \"<strong>they</strong>\" or \"<strong>their</strong>\"\n      or \"<strong>you</strong>\" or \"<strong>your</strong>\"), and shall be applicable to all folios, which are existing\n      or may be created at any time in future. You are requested to read these Terms carefully before you start using\n      the Platform. By using the Platform you indicate that you have read, understood and accepted these Terms and have\n      agreed to abide by the same without any limitation or qualification.\n    </p>\n    <br/>\n\n    <p>\n      We reserve the right to modify these Terms at any time. Your continuing to use the Platform and availing of the\n      facilities provided therein subsequent to modifications shall be construed as you having read, understood, and\n      agreed to be bound by the revised Terms and shall constitute an agreement between you and HDFC AMC. These Terms\n      shall always be read in conjunction with our Privacy Policy and the Terms of Use of our website available on -\n      <a target=\"_blank\" href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\" >{{Modal.HDFC_API.WEBSITE_LINK}}</a> and the terms and conditions of\n      the Scheme Information\n      Document (\"<strong>SID</strong>\"), the Key Information Memorandum (\"<strong>KIM</strong>\"), and the Statement of\n      Additional Information (\"<strong>SAI</strong>\") (hereinafter collectively referred to as <strong>Scheme Related\n      Documents</strong>). If you do not intend to be legally bound by these Terms, including amendments thereto, please\n      refrain from using the Platform.\n    </p>\n    <br/>\n\n    <h6 class=\"margin-none\">\n      Registration on the Platform:\n    </h6>\n    <ul>\n      <li>\n        Resident adult individuals (with intended mode of holding/operation as single or “Anyone or Survivor” or\n        “Joint”) and minor (acting through Guardian) investors, who are eligible to invest in schemes of HDFC MF as per\n        the terms of the Scheme Related Documents and are not restricted by any legal/regulatory/judicial/quasi\n        judicial/other authority to invest in schemes of HDFC MF, shall be authorised to directly register on the\n        Platform and avail of the online services available thereon.\n      </li>\n      <li>\n        Access to Platform shall not be available to US Persons (<i>i. e., a U.S. person within the meaning of\n        Regulation\n        S under the Securities Act of 1933 of U.S. or as defined by the U.S. Commodity Futures Trading Commission as\n        amended from time to time</i>) or to residents of Canada.\n      </li>\n      <li>\n        Non-Resident Indian (NRI)/Persons of Indian Origin (PIO)/Overseas Citizen of India (OCI) Users may access the\n        Platform provided: (i) the applicable local laws/regulations of their country of residence does not prohibit\n        such access or does not impose any registration or other requirement on HDFC AMC/HDFC MF as a consequence of\n        such access; or (ii) their country or territory is not a non compliant country or territory declared under\n        Financial Action Task Force (FATF).\n      </li>\n      <li>\n        If you choose to access the Platform from locations other than India, you shall do so at your own risk and you\n        would be solely responsible for compliance with applicable local laws and regulations of such\n        location/territory. We accept no liability whatsoever, direct or indirect, for non-compliance with the laws of\n        any country other than the Republic of India. The mere fact that the Platform can be accessed through internet\n        by you in a country other than India shall not be interpreted to imply that the laws of the said country govern\n        these Terms and/or the use of the Platform.\n      </li>\n      <li>\n        Non individuals and Power of Attorney Holders shall be required to submit a physical HDFCMF Online Access\n        Request Form, together with such documents as may be stipulated by HDFC AMC/HDFC MF, prior to obtaining access\n        to the Platform.\n      </li>\n      <li>\n        Existing unitholder /investors of HDFC MF may, at any time, subject to these Terms, register on the Platform\n        and avail of online facilities available thereon.\n      </li>\n      <li>\n        User hereby agrees to abide by these Terms and all applicable Indian and Foreign laws/rules/regulations in\n        force and the changes thereto from time to time relating to the access to the Platform and/or the facilities\n        made available thereon, including those relating to execution of transactions in Schemes of HDFC MF. The User\n        further confirms that he is authorised, and is not restricted by any legal/regulatory/judicial/quasi\n        judicial/other authority, to access the Platform and avail of the facilities offered thereon, including to\n        execute transactions in schemes of HDFC MF.\n      </li>\n      <li>\n        User shall be required to comply with KYC (know your client/customer) and KYC Registration Agency\n        (“<strong>KRA</strong>”)\n        requirements under SEBI (KYC Registration Agency) Regulation, 2011, as may be amended from time to time, and\n        requirements under Prevention of Money Laundering Act, 2002 and such other applicable laws/rules/regulations as\n        the case may be. Registration on the Platform shall be permitted for KYC Registration Agency (KRA) verified\n        Users only. Accordingly while enrolling for the Platform registration, the User shall be required to provide\n        their PAN, Aadhaar Number, and such other information as may be prescribed from time to time under the SEBI (KYC\n        Registration Agency Regulation, 2011, Prevention of Money Laundering Act, 2002 and rules made there under as may\n        be amended from time to time, and such other applicable laws/regulations as the case may be. Based on the\n        information provided, once it is ascertained that the User is KRA verified and the other information provided by\n        the User is in order as required by the applicable laws, the User will be allowed to register on the Platform.\n        Subsequent to registration on the Platform, for the purpose of compliance with applicable laws/regulations, User\n        may be required to submit such other documents as may be stipulated by HDFC AMC/HDFC MF from time to time and\n        the User hereby undertakes to submit such details/documents as and when required by HDFC AMC/HDFC MF. The User\n        further acknowledges that any failure to submit such documents/details may result in the User’s access to the\n        Platform being suspended/ terminated.\n      </li>\n      <li>\n        The subsequent access to the Platform and execution of transaction(s) on the Platform, the User hereby\n        provides consent in accordance with Aadhaar Act, 2016 and regulations made thereunder, for (i) collecting,\n        storing and usage (ii) validating/authenticating and (ii) updating my/our Aadhaar number(s) in accordance with\n        the Aadhaar Act, 2016 (and regulations made thereunder) and PMLA. User hereby provides consent for sharing/\n        disclosing of the Aadhaar number(s) including demographic information with the asset management companies of\n        SEBI registered mutual fund and their Registrar and Transfer Agent (RTA) for the purpose of updating the same in\n        User’s folios with their PAN.\n      </li>\n      <li>\n        User’s address as per KRA will be the registered address of the User in the records of\n        HDFC AMC/HDFC MF.\n      </li>\n      <li>\n        User’s signature for the records of the HDFC AMC/HDFC MF in connection with availing of facilities on the\n        Platform shall be retrieved / obtained from the KRA. In case HDFC AMC in unable to obtain a clear image of the\n        signature, User shall be required to submit a physical signature updation request to HDFC AMC to transact in\n        schemes of HDFC MF through the physical mode.\n      </li>\n      <li>\n        With respect to the Users who are first time investors of HDFC MF, the contact details, including email\n        address and mobile number, shall be obtained from the KRA at the time of registration on the Platform. The User\n        shall be responsible to ensure that the contact details, including the email address and the mobile number\n        available with the KRA are accurate, and to update the same in case of any inaccuracies prior to proceeding with\n        the registration on the Platform. HDFC AMC/HDFC MF shall not be responsible to verify the correctness of the\n        information obtained from the KRA. For Users who are existing investors of HDFC MF, the contact details shall be\n        as per the details available with HDFC AMC/HDFC MF.\n      </li>\n      <li>\n        All correspondence and/or delivery by HDFC AMC shall be made only at the address and/or email address\n        available with HDFC AMC/HDFC MF. HDFC AMC shall send communications/letters etc. to the User through\n        courier/messenger/email/SMS or through any other valid mode at its own discretion and the User shall not hold\n        HDFC AMC/HDFC MF liable for any loss and/or delay arising there from.\n      </li>\n      <li>\n        You hereby confirm that you shall not use the Platform for any illegal or improper purposes. HDFC AMC/HDFC MF\n        shall be authorized to immediately discontinue/suspend/terminate your access to the Platform upon being made\n        aware of any such illegal or improper use of the Platform.\n      </li>\n      <li>\n        • In order for you to be eligible for registration on the Platform and to transact on the Platform, you may need\n        to have access to net banking facility/other online payment facility with the select banks having arrangements\n        with us as per the list displayed on the Platform. You shall be required to register the account details and\n        upload an image of the cheque <i>(in .pdf /.jpeg format)</i> on the Platform. It shall be your responsibility to\n        ensure\n        that the account details registered by you and the image of the cheque uploaded pertains to your bank account.\n        In case of joint holding, the account details registered shall be the bank account of the first-named unit\n        holder or, in case of joint bank account, the first-named unit holder in the folio should be one of the joint\n        holders of the bank account. In case it is found that the bank account details registered do not fulfil the\n        above criteria, HDFC AMC/HDFC MF shall reject the transaction requests and refund the amounts to the account\n        registered on the Platform without any interest thereon, and HDFC AMC/HDFC MF shall not be liable for any\n        losses/damage sustained by the User on account of the above.\n      </li>\n      <br/>\n\n      <li>\n        <strong>Minor investors:</strong> The Platform may be accessed on behalf of a minor unitholder/investor by the\n        natural and/or legal guardian. The guardian shall represent the minor in all transactions of any description\n        executed on the Platform or otherwise on behalf of the minor until the said minor attains majority.\n        <br/> <br/>\n        The minor unitholder’s bank account details are required to be registered for the purpose of receiving\n        redemption proceeds/ dividend payouts, and in the absence of the same, the bank account of the guardian\n        representing the minor may be registered till such time a bank account is opened in the name of the minor and\n        details of the same is registered in the folio of the minor investor. However, HDFC AMC/HDFC MF shall pay\n        proceeds of redemption / dividend payouts only in the name of minor investor/ minor unit holder. HDFC AMC/HDFC\n        MF shall not be liable for any loss or damage sustained by the minor unit holder on account of any non-receipt\n        of or delays in receiving the redemption proceeds / dividend payouts on account of the above.\n        <br/> <br/>\n        Nomination shall not be allowed till such time the minor attains the age of majority.\n        <br/> <br/>\n        The guardian shall be eligible to access the Platform on behalf of the minor till such time the minor attains\n        the age of majority. The guardian agrees to indemnify HDFC AMC/HDFC MF against any claim of the minor for any\n        transactions made in the minor\'s account. Upon the minor attaining the age of majority, the right of the\n        guardian to represent the minor and to access the Platform on behalf of the minor shall stand terminated. The\n        minor shall be required to fulfil such formalities, through submission of physical request forms and documents,\n        updation of bank and contact details, etc., as may be stipulated by HDFC AMC/HDFC MF for change of status from\n        minor to major from time to time. Access to the Platform with respect to the investments of the minor unitholder\n        shall remain suspended till such time the formalities of change of status are completed.\n        <br/> <br/>\n        To continue accessing the Platform the minor (now turned major) User shall also be required to update the bank\n        account details, contact details, nomination, etc., on the Platform, before online facilities available on the\n        Platform can be availed of.\n      </li>\n      <br/>\n\n      <li>\n        <strong>Joint Holding:</strong> Joint holders (irrespective of the mode of operation) shall be allowed to access\n        the Platform through creation of User ID and password only upon completion of an authentication by all the joint\n        holders independently. Completion of the authentication process by all the joint holders in the manner\n        stipulated by HDFC AMC/HDFC MF shall be construed as a confirmation provided by all the joint holders that they\n        have read, understood, and having agreed to be bound by these Terms. The subsequent access to the Platform and\n        execution of transaction(s) on the Platform using the User ID and password created by the joint holders shall be\n        deemed as access/execution of transactions for and on behalf of and with the consent of all the joint holders.\n        <br/><br/>\n        For registration of nomination in case of joint holders, a scanned copy of a duly filled nomination form in the\n        format stipulated by HDFC AMC/HDFC MF, signed by all the joint holders, shall be uploaded on the Platform. In\n        case the nomination form is not signed by all the joint holders, the same shall be liable to be rejected and the\n        nomination shall not be registered in the folio of the joint holders, HDFC AMC/HDFC MF shall not be liable for\n        any loss/damage sustained by the Users on account of the same.\n      </li>\n      <br/>\n      <li>\n        <strong>Nomination:</strong> Subject to the terms contained herein, the Scheme Related Documents, and the\n        applicable SEBI Regulations, nomination shall be mandatory for individual Users having a single mode of holding.\n        Users who do not wish to nominate are required to confirm their non-intention to nominate.\n        <br/><br/>\n        Through nomination facility, we are not in any way attempting to grant nominee any rights other than those\n        granted to him by law to which he is subject. A nomination does not create any interest in the units / property\n        after the death of the unitholder and the nominee shall hold the units in his capacity as a trustee for legal\n        heirs or legatees of the unitholder.\n        <br/><br/>\n        Nomination can also be made in favour of the Central Government, State Government, local authority, any person\n        designated by virtue of these offices or a religious or charitable trust. The nominee shall not be a trust\n        (other than a religious or charitable trust), society, body corporate, partnership firm, karta of Hindu\n        Undivided Family or a power of attorney holder.\n        <br/><br/>\n        A minor can be nominated and in that event the name, address and signature of the natural/ legal guardian of the\n        minor nominee shall be provided by the User. The guardian to a minor nominee should be a person other than the\n        User.\n      </li>\n      <br/>\n      <li>\n        HDFC AMC/HDFC MF reserves the right to decide the type of services/facilities that may be offered on the\n        Platform from time to time. There is no assurance by HDFC AMC/HDFC MF that all facilities available under the\n        offline/physical mode shall be available to the User on the Platform. HDFC AMC/HDFC MF may also make additions\n        and/or deletions to the services and/or facilities that are currently offered on the Platform at its sole\n        discretion.\n      </li>\n    </ul>\n    <br/>\n\n    <h6 class=\"margin-none\">\n      Access\n    </h6>\n    <ul>\n      <li>\n        You hereby acknowledge and agree that it shall be your responsibility to upgrade the software, hardware and\n        the operating system of your computer and/or mobile phone handset as the case may be at your sole cost from time\n        to time so as to be compatible with that of the Platform, and you also would need to be a current internet user\n        or have access to the internet.\n      </li>\n      <li>\n        We shall be at liberty to change, vary or upgrade the software, hardware, operating systems, etc., of the\n        Platform from time to time and shall be under no obligation to provide support to all versions of the software,\n        hardware, or operating systems used by you. We shall not be liable for your failure to access the Platform,\n        partially or fully, whether due to your systems, the internet network or any other cause whatsoever.\n      </li>\n      <li>\n        The Platform and its features and facilities offered may be expanded, limited or modified at any time to meet\n        the needs of the Users, or for regulatory, technical or any other reasons whatsoever, without advance notice or\n        reason. We reserve the right to change, modify, suspend, add, remove, or restrict the User’s access to the\n        Platform or a part of it at our sole discretion, without prior notice. We may also in our sole discretion, and\n        at any time, discontinue, temporarily or permanently, any or the entire facilities under the Platform without\n        notice. This could result in delays or failure in the processing of instructions or requests of the Users. We\n        disclaim all and any liability, whether direct or indirect, whether arising out of loss of profit or otherwise,\n        sustained by any User on account of such delays or failure and each User hereby acknowledges and agrees to the\n        same.\n      </li>\n      <li>\n        While we will make all reasonable efforts to ensure that industry standard, accessible formats are used for\n        the materials posted on the Platform, we cannot guarantee the compatibility of such materials with your computer\n        or mobile software\n      </li>\n      <li>\n        As this is an electronic service, access cannot always be guaranteed due to external factors beyond our\n        control. Whilst we endeavour to ensure that the facilities offered under the Platform are available without any\n        interruptions, we do not guarantee that the access to or use of Platform or any part thereof will be\n        uninterrupted or error free or that the Platform or the server that makes it available will be free of viruses\n        or other harmful, malicious, or disruptive components. You agree not to hold us liable or responsible for any\n        loss/damage that may be suffered by you while downloading software for accessing the Platform or while availing\n        of any facilities under the Platform.\n      </li>\n      <li>\n        The internet per se is susceptible to a number of frauds, misuse, hacking and other actions, which could\n        affect the electronic instructions to us through the Platform. Whilst we aim to provide security to prevent the\n        same, there cannot be any guarantee from such internet frauds, hacking and other actions.\n      </li>\n    </ul>\n    <br/>\n\n    <h6 class=\"margin-none\">\n      Security\n    </h6>\n    <ul>\n      <li>\n        The facilities under the Platform can be availed of only by those Users who are in possession of valid login\n        credentials to access the same.\n      </li>\n      <li>\n        At the time of registration on the Platform, you shall be required to create your own User ID and Password.\n        You shall treat the User ID and Password as confidential and shall be solely responsible for the use,\n        confidentiality, and protection of the same against disclosure to third parties. You acknowledge that if any\n        third person obtains access to the User ID and/or Password, such third party would be able to transact/provide\n        electronic instructions to us on the Platform, and any instruction/request for transaction received through your\n        User ID shall be processed as a valid and bonafide instruction received from you. We shall not be liable for any\n        loss that may be suffered by you as a result of an unauthorized third party using the User ID and passwords,\n        either with or without your knowledge.\n      </li>\n      <li>\n        You shall notify us immediately of any unauthorized use of the Platform or any other breach of security\n        whatsoever that you may be aware of.\n      </li>\n      <li>\n        Any transactions through the Platform can be effected only by valid login credentials entered by you. You\n        agree not to request/ demand any evidence or proof for transactions undertaken on the Platform and the audit\n        trail of the log-in using your login credentials would be conclusive proof to establish that the transactions\n        are bonafide.\n      </li>\n      <li>\n        Every usage of the Platform using your login credentials shall be deemed to be usage by the User personally\n        and in physically and mentally stable state, notwithstanding any loss, theft, hacking etc. of the User ID and/or\n        the password. HDFC AMC/HDFC MF shall not be required to check the identity of the person accessing the Platform\n        at any point of time or his mental or physical stability.\n      </li>\n      <li>\n        Your password shall expire within 90 days creation/ updation thereof. If your password expires, for continued\n        access to the Platform, you shall be required to regain access to the Platform by following the validation\n        process as stipulated by HDFC AMC/HDFC MF.\n      </li>\n      <li>\n        As a safety measure you are advised to change the password as frequently as may be required.\n      </li>\n    </ul>\n    <br/>\n\n    <h6 class=\"margin-none\">\n      Execution of Transactions:\n    </h6>\n    <ul>\n      <li>\n        The online facilities made available to the Users on the Platform shall be in addition to and not in\n        substitution of the existing procedures or facilities for transacting in the Schemes of HDFC MF, including\n        through offline/physical mode.\n      </li>\n      <li>\n        An application for any transaction on the Platform by the User does not automatically imply that HDFC AMC/HDFC\n        MF shall accept or process the same. HDFC AMC/HDFC MF shall have the sole discretion of rejecting any request\n        for any transaction on the Platform with insufficient/incorrect information and/or documents or for any other\n        reason as HDFC AMC/HDFC MF may deem fit, and the decision of HDFC AMC/HDFC MF in this regard shall be final.\n        HDFC AMC/HDFC MF shall not be liable for any loss sustained by any User on account of such rejection. Further,\n        HDFC AMC/HDFC MF also reserves a right to seek additional information from Users for processing requests for\n        transactions or otherwise on case to case basis.\n      </li>\n      <li>\n        Users requesting for any transaction shall be liable to pay all charges, fees, interests, and costs, as\n        applicable, which HDFC AMC/HDFC MF in its absolute discretion may levy with respect to such services/facilities\n        offered on the Platform.\n      </li>\n      <li>\n        Transaction request(s) made on the Platform may not be processed by HDFC AMC till clear funds sufficient to\n        cover the subscription price have been received by HDFC AMC in the designated bank account and not upon the\n        debit of funds from the account of the User.\n      </li>\n      <li>\n        The payment for any transaction on the Platform shall be made by the User using any of the payment gateways\n        including, but not limited to, Net Banking Facility, National Electronics Funds Transfer System\n        (<strong>NEFT</strong>), Real\n        Time Gross Settlement (“<strong>RTGS</strong>”), VISA/Master Maestro Debit Cards, HDFC Bank Fund Transfer\n        Facility, etc., and HDFC AMC/HDFC MF will not be liable for any failures in the link or for any fraud (either at\n        the payment gateway\'s end and/or the bank\'s end or failure of telecommunication network) that could take place\n        at the time of making payment. If HDFC AMC/HDFC MF does not receive the subscription amount, the transaction\n        will be treated as cancelled. A transaction shall be construed to be completed only upon receipt of a written\n        confirmation in that regard from HDFC AMC/HDFC MF and not otherwise.\n      </li>\n      <li>\n        The User hereby confirms that any amount utilised for transacting in the Scheme(s) of HDFC MF is/shall be\n        through legitimate sources only and transaction executed by the User are not for the purpose of contravention\n        and/or evasion of any act, rules, regulations, notifications or directions issued by any regulatory authority in\n        India or in any other jurisdiction applicable to the User.\n      </li>\n      <li>\n        User understands and acknowledges that the responsibility of providing the correct information/details,\n        including the contact information, amount, the bank account details, etc., lies solely with the User and HDFC\n        AMC/HDFC MF shall not be responsible to verify the accuracy of the information/details provided by the User. The\n        User shall also be liable to inform HDFC AMC/HDFC MF/Registrar and Transfer Agent of any change in any details\n        or information provided initially. If any incorrect bank account number is provided by the User, any amount\n        payable to the User could be credited to the wrong bank account so provided by the User and there is no\n        guarantee of recovery of the same. The User shall take all care and caution to ensure that there are no mistakes\n        and errors and that the information given to HDFC AMC/HDFC MF is error free, accurate, proper, and complete at\n        all points of time. The User confirms that HDFC AMC/HDFC MF shall not be held liable for any loss or damage that\n        may be sustained by the User on account of such error on the part of the User.\n      </li>\n      <li>\n        The User also confirms that, if the User receives any wrong credit of funds in his bank account from HDFC\n        AMC/HDFC MF, which does not belong to the User, on account of any reason whatsoever, the same shall immediately\n        be returned to HDFC AMC/HDFC MF.\n      </li>\n      <li>\n        Any request for transaction on the Platform shall be time stamped consistent with the terms of the Scheme\n        Related Documents. The Net Asset Value (NAV) applicable for purchase or redemption or switching of units shall\n        be based on the time of the business day on which the application is received / completed on the Platform, and\n        subject to the provisions of realisation of funds and cut off timings as described in the Scheme Related\n        Documents of HDFC MF. Any transactions received/completed on the Platform after the cut off time as mentioned in\n        the Scheme Related Documents shall be deemed to be received on the succeeding business day and shall be\n        processed accordingly. The decision of HDFC AMC in this regard shall be final and binding on the User.\n      </li>\n      <li>\n        Transactions once placed on the Platform cannot be cancelled by the User other than as specifically allowed on\n        the Platform.\n      </li>\n    </ul>\n    <br/>\n\n    <h6 class=\"margin-none\">\n      General Terms:\n    </h6>\n    <ul>\n      <li>\n        <strong>Amendments:</strong><br/>\n        These Terms may be amended or modified at any time and for such reason as HDFC AMC deems fit and proper\n        including but not limited to comply with changes in laws and/or regulations, to correct inaccuracies, omissions,\n        errors or ambiguities, reflect changes in the scope and nature of the services or based on User requirements\n      </li>\n      <li>\n        <strong>Suspension or Termination of facilities:</strong>\n        HDFC AMC may, at its sole discretion, suspend/disallow/modify/restrict all or any of the facilities offered\n        under the Platform or deny access to the Platform to any specific User at any time and for such time period and\n        for such reasons as it deems fit, including on account of inactive/dormant User ID, non compliance of the Terms,\n        death, insolvency, or bankruptcy of the User, any restriction imposed by any legal/judicial/regulatory\n        authority, or for any other cause arising out of the law/regulation or for such other reasons as we may deem\n        fit.\n        <br/><br/>\n        HDFC AMC shall be entitled to withdraw or terminate all or any facilities offered under the Platform without\n        assigning any reason whatsoever, without any prior notice to the User.\n        <br/><br/>\n        HDFC AMC shall not be liable for any loss or damage that may be sustained by any User on account of such\n        suspension/withdrawal/termination by HDFC AMC.\n      </li>\n      <br/>\n      <li>\n        <strong>Accuracy of information</strong>\n        You shall solely be responsible for the correctness of information supplied to us for use of the Platform or\n        while availing of any facility on the Platform or through any other means such as electronic mail or written\n        communication. We accept no liability for the consequences arising out of any erroneous information supplied by\n        you. If you notice an error in the information supplied to us, you shall immediately notify the same to us in\n        order to enable us to endeavour to correct the error wherever possible on a \"reasonable efforts\" basis.\n        <br/><br/>\n        All outputs of statements are duplicate Statements of Account and are prepared by electronic means and the\n        information contained therein will be extracted from a computerized back-up system maintained by HDFC AMC. In\n        case you notice any error in the account information supplied through the Platform or transaction confirmation\n        received by you, you shall promptly, but not later than 30 (Thirty) days from the date of receipt of the\n        information, intimate us of the same. Upon receipt of such intimation, we shall endeavour to correct the error.\n        <br/><br/>\n        You hereby agree and acknowledge that, while we will take all reasonable steps to ensure the accuracy of the\n        statement and information generated, we shall not be held liable for any errors therein. You further agree to\n        hold us harmless against any loss, damages, etc., that may be incurred /suffered on account of any\n        inaccurate/incorrect information contained in the outputs from the Platform.\n      </li>\n      <br/>\n      <li>\n        <strong>Disclaimer</strong>\n        <ul class=\"type-circle\">\n          <li>\n            Your use of the Platform shall be at your sole risk. The Platform has been provided on an “as is” and “as\n            available” basis. Except as explicitly warranted in these Terms, we make no express or implied warranty with\n            respect to the services/facilities provided on the Platform, including, without limitations, any warranties\n            of uninterrupted/error free performance of the Platform, that any identified defects will be corrected, that\n            the Platform is free from viruses or other malicious, destructive or corrupting code, non-infringement of\n            third party rights, title, merchantability, data accuracy and completeness, satisfactory quality and/or\n            fitness for a particular purpose.\n          </li>\n          <li>\n            The facilities offered on the Platform shall not constitute an offer to buy or sell or a solicitation to\n            any person in any jurisdiction where it is unlawful to make such offer or solicitation.\n          </li>\n          <li>\n            Whilst every reasonable precaution has been taken to ensure the accuracy, security and confidentiality of\n            data and information on the Platform, there cannot be any guarantee from internet frauds, hacking and other\n            similar actions.\n          </li>\n          <li>\n            The Platform is controlled and operated by us from our offices in India. We make no representation that\n            the Platform or the facilities offered on the Platform are appropriate or available for use in other\n            locations or territories where their contents are unlawful and is prohibited. If you choose to access the\n            Platform from locations other than India, you shall do so on your own initiative and you would be\n            responsible for compliance with applicable local laws and regulations of such location/territory.\n          </li>\n        </ul>\n      </li>\n      <br/>\n      <li>\n        <strong>Liability:</strong>\n        HDFC AMC/HDFC MF shall not be liable for any damages or losses sustained by the User (direct and/or indirect)\n        whatsoever, due to disruption or non-availability of the services/facility(s) under the Platform due to\n        technical fault/error or any failure or failure in telecommunication network or any error in any software or\n        hardware systems.\n        <br/><br/>\n        HDFC AMC/HDFC MF shall not be liable for any unauthorised transactions occurring through the Platform and the\n        User hereby fully indemnifies and holds HDFC AMC/ HDFC MF harmless against any action, suit, proceeding\n        initiated against it or any loss, cost or damage incurred by it as a result thereof. HDFC AMC/HDFC MF shall\n        under no circumstance be held liable to the User if the Platform or all or any part of the facilities on the\n        Platform is not available in the desired manner for reasons including but not limited to legal restraints,\n        faults in the telecommunication network or network failure, or any other force majeure events (such as flood,\n        extraordinary weather condition, earthquake or other act of God, fire, war, insurrection, riot, labour dispute,\n        accident, action of government, communications, power failure, equipment or software malfunction)or any other\n        reason beyond the control of HDFC AMC/HDFC MF. Under no circumstances shall HDFC AMC/HDFC MF be liable for any\n        damages whatsoever whether such damages are direct, indirect, incidental consequential and irrespective of\n        whether any claim is based on loss of revenue, interruption of business or any loss of any character or nature\n        whatsoever and whether sustained by the User or by any other person. Illegal or improper use of the Platform\n        shall render the User liable for payment of financial charges as decided by HDFC AMC/HDFC MF or will result in\n        suspension / termination of the access to the Platform extended to the User. The aforesaid does not limit rights\n        of HDFC AMC/HDFC MF to initiate appropriate legal proceedings against the User.\n      </li>\n      <br/>\n      <li>\n        <strong>Disclosure of personal information:</strong>\n        We may use your personal information for following purposes:\n        <ul class=\"type-circle\">\n          <li>\n            To process your requests for any of the services on the Platform;\n          </li>\n          <li>\n            To deliver any administrative notices, alerts, advice, notifications and communications relevant to your\n            use of any facilities on the Platform.\n          </li>\n          <li>\n            To analyze usage of the Platform and improve the services /facilities offered;\n          </li>\n          <li>\n            For market research, project planning, troubleshooting problems,\n            detecting and protecting against error, fraud or other criminal activity;\n          </li>\n          <li>\n            To disclose as required by applicable laws/regulations or to any Indian or foreign statutory, regulatory,\n            judicial, quasi-judicial authorities/agencies including, but not limited to Financial Intelligence\n            Unit-India (FIU-IND)\n          </li>\n          <li>\n            To disclose to our Sponsor(s), Trustees, its employees, and agents, and to other Institutions and/or Third\n            Party Service Providers that provide services to us and which are bound by confidentiality arrangements with\n            us.\n          </li>\n          <li>\n            For participation in any telecommunication or electronic clearing network.\n          </li>\n          <li>\n            In compliance with a legal directive.\n          </li>\n          <li>\n            For fraud prevention purposes.\n          </li>\n        </ul>\n        <br/>\n        We, either directly or through call centres, may call or send promotional information/ material or other alters\n        to the mobile number/(s) or email IDs provided by you during the course of registration on the Platform and you\n        shall be deemed to have provided your consent for receipt of such promotional information/material. If you do\n        not wish to receive such promotional information/ materials, please call on toll free no. 1800 3010 6767/ 1800\n        419 7676 or register for the Do Not Call Register (“<strong>DNCR</strong>”) of HDFC AMC.\n        <br/><br/>\n        We reserve the right to record telephonic conversations with Users for quality control purposes.\n        <br/><br/>\n        The confidentiality obligations of HDFC AMC/HDFC MF shall be subject to the Privacy Policy displayed on the\n        website <i class=\"text-underline\"><a target=\"_blank\" href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\" >{{Modal.HDFC_API.WEBSITE_LINK}}</a></i>\n        and these Terms shall be read in conjunction with the said Privacy Policy. The User, by agreeing to these Terms\n        shall be deemed to have consented to the terms of the Privacy Policy of HDFC AMC.\n      </li>\n      <br/>\n      <li>\n        <strong>Proprietary Rights:</strong><br/>\n        The Platform and the contents thereof are for the sole use of the Users registered with us. The User accessing\n        the Platform should not bring our name, our reputation or our products into disrepute.\n        <br/><br/>\n        All copyrights and other intellectual property rights in the materials on the Platform belong to us. While\n        accessing the Platform, you shall be deemed to have acknowledged our copyright and other proprietary rights\n        where they exist in any material provided. Permission given to access the Platform will not entitle you to any\n        ownership or proprietary interest in the Platform or software underlying the Platform as well as other internet\n        related software which are required for accessing the Platform. You further acknowledge and agree that all title\n        and rights in and to any third party content that is incorporated into the Platform is the property of the\n        respective content owners and may be protected by applicable patent, copyright, trademark or other intellectual\n        property laws.\n        <br/><br/>\n        We own and hold all rights, license, title, and interest, to the Platform and all the information and data\n        available on the Platform and we grant to you a limited license to access, view, download, print and share\n        certain materials posted on the Platform solely in connection with providing the facilities offered on the\n        Platform. You agree not to reproduce, duplicate, copy, alter, modify, transmit, create derivative works of,\n        publish, sublicense, distribute, circulate, disassemble, decompile, reverse engineer or re-sell the Platform or\n        any part thereof. You further agree that it shall not take any actions, whether intentional or unintentional,\n        that may circumvent, disable, damage or impair the ability of the Platform to function, or allow or assist any\n        third party to do so. You shall not to access, without authority, or interfere with, damage or disrupt: a) any\n        part of the Platform; b) any equipment or network on which the Platform is stored; c) any software used in the\n        provision of the Platform; or d) any equipment or network or software owned or used by any third party.\n      </li>\n      <br/>\n      <li>\n        <strong>Non Transferability:</strong><br/>\n        The grant of access to the Platform to the User is not transferable under any circumstances and shall be used\n        only by the User.\n        <br/><br/>\n        HDFC AMC, however, is at liberty to subcontract and employ agents to carry out its obligations in relation to\n        provision of services and/or maintaining the Platform.\n      </li>\n      <br/>\n      <li>\n        <strong>Indemnity:</strong><br/>\n        User shall indemnify HDFC AMC/HDFC MF for all claims, liabilities, losses, damages and expenses which HDFC\n        AMC/HDFC MF may sustain or incur either directly or indirectly as a result of:\n        <ul class=\"type-circle\">\n          <li>\n            Providing to the User an access to the Platform and the facilities offered on the Platform\n          </li>\n          <li>\n            Unauthorised use of the Platform or by any third party through the User ID/password of the User;\n          </li>\n          <li>\n            HDFC AMC/HDFC MF in good faith taking or refusing to take any action on the electronic instructions received\n            from the User;\n          </li>\n          <li>\n            Fraud, negligence/ mistake or misconduct by the User;\n          </li>\n          <li>\n            Any illegal or improper use of the Platform by the User;\n          </li>\n          <li>\n            Negligence or mistake or misconduct of the User;\n          </li>\n          <li>\n            Any delay or failure to process the transactions carried out by the User due to error, defect, failure or\n            interruption or for any reason whatsoever; or\n          </li>\n          <li>\n            Breach or non-compliance of any of the Terms by the User.\n          </li>\n        </ul>\n      </li>\n      <br/>\n      <li>\n        <strong>Governing Law and Jurisdiction:</strong><br/>\n        These Terms and the use of the Platform shall be governed by the laws of the Republic of India.\n        <br/><br/>\n        The User and the HDFC AMC/HDFC MF agree to submit to the exclusive jurisdiction of the courts in Mumbai\n        as regards any claims or matters arising under these Terms. HDFC AMC/HDFC MF accepts no liability whatsoever,\n        direct or indirect, for non-compliance with the laws of any country other than the Republic of India. The mere\n        fact that the Platform can be accessed through internet by the User in a country other than Republic of India\n        shall not be interpreted to imply that the laws of such country govern these Terms and/or the use of Platform.\n        <br/><br/>\n        In case of a dispute, the matter will be settled by arbitration as per the rules of Arbitration and Conciliation\n        Act, 1996. HDFC AMC shall nominate the sole arbitrator and that the place of arbitration shall be Mumbai and the\n        language of arbitration shall be English.\n      </li>\n      <br/>\n      <li>\n        <strong>Waiver:</strong><br/>\n        Failure on the part of HDFC AMC/HDFC MF to enforce any rights conferred by these Terms or any law / regulation\n        shall not be deemed to be a waiver of any such rights.\n      </li>\n      <br/>\n      <li>\n        <strong>User Communication and Grievance Redressal:</strong><br/>\n        In case you wish to offer your comments or feedback regarding this Platform or the online services offered on\n        this Platform or if you wish to air any complaints or grievances, you may contact us on 1800 3010 6767 / 1800\n        419 7676 or write to us to cliser@hdfcfund.com.\n      </li>\n      <br/>\n      <li>\n        <strong>Interpretation:</strong>\n        <ul class=\"type-circle\">\n          <li>\n            The headings are used for convenience and ease of reference only and shall not affect the construction or\n            interpretation of any provisions of these Terms;\n          </li>\n          <li>\n            The words, you, your, and User refer to the person(s) who access the Platform and shall include both\n            singular and plural. Reference to masculine shall include the feminine and neuter gender.\n          </li>\n          <li>\n            Words and expressions used but not defined herein shall have the same meanings assigned to them in such\n            Scheme Related Documents\n          </li>\n          <li>\n            In case of any conflict between the provisions of these Terms and the provisions of the Scheme Related\n            Documents, the provisions of the Scheme Related Documents shall prevail;\n          </li>\n        </ul>\n      </li>\n    </ul>\n  </div>--></div>");
$templateCache.put("app/components/modal/tpv/tpv.modal.html","<div class=modal-content id=tpv-modal><div class=modal-head><h3 class=modal-title>TPV Enabled Bank</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><tpv></tpv></div></div>");
$templateCache.put("app/components/modal/transactionOtp/transaction.otp.modal.html","<!-- Otp verification--><div class=modal-content id=signUp-otp><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Investor Verfication</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=Modal.otpForm autocomplete=off ng-submit=Modal.confirmTransaction() class=otp-modal-form novalidate><ng-bind-html ng-if=Modal.modalData.upiModalOtp style=\"text-align: center\" dynamic=Modal.modalData.upiModalOtp.content></ng-bind-html><p class=otp-info>An OTP has been sent to your Registered Email Id/Mobile Number.<br>Please enter the OTP to verify.</p><div class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text ng-pattern=Modal.appConstants.otp_regex ng-model=Modal.otpNumber name=otpNumber required minlength=6 maxlength=6 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Enter OTP</label><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=\"error-input displayContaint\" ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=\"error-input displayContaint\" ng-show=Modal.otpForm.otpNumber.$error.maxlength>{{ Modal.validateData.OTP_FIELD }}</span> <span class=\"error-input displayContaint\" ng-show=Modal.otpForm.otpNumber.$error.pattern>{{ Modal.validateData.OTP_FIELD }}</span></span><div style=\"padding-top: 10px\"><span ng-bind=Modal.otpResendMessage style=\"color: #1bb898\">OTP sent</span><timer ng-if=Modal.isOtmValid countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.resendOtp() class=pull-right ng-disabled=Modal.isProcessing>Resend OTP</a> <a ng-show=\"countdown > 0\" style=\"float:right;font-size: 12px !important\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><div class=text-center><button ng-class=\"{\'set-btn-blue\': Modal.modalData.showBlueBtn}\" type=submit ng-disabled=\"Modal.otpForm.$invalid || Modal.isProcessing || !Modal.isOtmValid\" class=\"btn btn-primary-action\">Submit</button></div></form></div></div><style>.displayContaint{\n    display: contents;\n  }</style>");
$templateCache.put("app/components/modal/transactionSummary/transaction-summary.html","<div class=modal-content id=transSum ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title>Transaction Details</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><table class=\"table borderless\"><tr><td>Folio Number</td><td>{{Modal.transactionSummary.folioNumber||\'--\'}}</td></tr><tr><td>Transaction Type</td><td>{{Modal.transactionSummary.type||\'--\'}}</td></tr><tr><td>Status</td><td>{{Modal.transactionSummary.status||\'--\'}}</td></tr><tr><td>Scheme</td><td>{{Modal.transactionSummary.schemeName||\'--\'}}</td></tr><!--<tr>--><!--<td>Plan</td>--><!--<td>{{Modal.transactionSummary.plan||\'&#45;&#45;\'}}</td>--><!--</tr>--><!--<tr>\n        <td>Investment Option</td>\n        <td>{{(Modal.transactionSummary.investmentOption | camelcase) ||\'--\' }}</td>\n      </tr>\n      <tr ng-if=\"Modal.transactionSummary.investmentOption.toUpperCase() != Summary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\">--><!--<tr ng-if=\"Modal.transactionSummary.option\">--><!--<td>Investment Option</td>--><!--<td>{{Modal.transactionSummary.option||\'&#45;&#45;\'}}</td>--><!--</tr>--><tr ng-if=Modal.transactionSummary.dividendReinvestOption><td>IDCW Option</td><td>{{Modal.transactionSummary.dividendReinvestOption}}</td></tr><tr><td>Amount</td><td><i class=rupee-small-icon></i>{{(Modal.transactionSummary.amount|unit)||\'--\'}}</td></tr><tr><td align=center colspan=2><!--action could be REMIND or REINITIATE --><!--<button type=\"submit\" ng-if=\"Modal.transactionSummary.action\" ng-click=\"Modal.initiateTransaction()\" class=\"btn btn-primary-action\">\n            {{Modal.transactionSummary.action}}\n          </button>--></td></tr></table></div></div>");
$templateCache.put("app/components/modal/transactionWarning/transaction-warning.modal.html","<div class=modal-content><div class=modal-head><h3 class=modal-title>Warning!!</h3><i class=times-icon ng-click=\"Modal.dismissModal(\'close\');\"></i></div><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><p class=text-center>{{ Modal.modalData }}</p><br><br><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" ng-class=\"{\'set-btn-blue-border\': Modal.showBlueBtn}\" ng-click=Modal.dismissModal()>No</button> <button class=\"btn btn-primary-action\" ng-class=\"{\'set-btn-blue\': Modal.showBlueBtn}\" ng-click=Modal.closeModal()>Yes</button></div></div></div>");
$templateCache.put("app/components/modal/transactionalTnc/tncBiometric.html","<div class=modal-head><h3 class=modal-title>Terms and Conditions for Biometric Authentication to access & use of the Application</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=BIOMETRIC></terms-condition>");
$templateCache.put("app/components/modal/transactionalTnc/tncDtp.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – TIP</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=DTP></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to\n      the respective Scheme(s) under the Scheme Information Document(s), Statement of Additional Information, and the\n      Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer\n      Documents</strong>”) (Please visit the “Download” section on our website <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and the terms\n      and conditions for enrolment for DTP (please click here to read), and hereby apply to the Trustee of HDFC Mutual\n      Fund for enrolment under the DTP and to allot the Units of the said Scheme(s) of HDFC Mutual Fund, as indicated\n      above. I hereby also confirm to have read, understood, and agree to abide by the Terms applicable to this\n      Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong> to read).\n    </li>\n    <li>\n      Irrespective of my/our enrolment for DTP, if the dividend in the Source Scheme is less than Rs. 500/-, the\n      dividend will be automatically reinvested in the Source Scheme and shall not be invested in the Target Scheme.\n    </li>\n    <li>\n      I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this\n      investment.\n    </li>\n    <li>\n      The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other\n      mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the\n      Scheme is being recommended to me/us;\n    </li>\n    <li>\n      I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC\n      AMC/HDFC MF/ Distributor for this investment;\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/tncEcart.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=ECART></terms-condition>");
$templateCache.put("app/components/modal/transactionalTnc/tncFlexIndex.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – Flex Index</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=FLEX_INDEX></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to\n      the respective Schemes under the Scheme Information Document(s), Statement of Additional Information, and the\n      Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer\n      Documents</strong>”) (Please visit the “Download” section on our website <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and the terms\n      and conditions for enrolment for Flex Index Plan (please click here to read), and hereby apply to the Trustee of\n      HDFC Mutual Fund for enrolment under the Flex Index Plan and to allot the Units of the said Scheme(s) of HDFC\n      Mutual Fund, as indicated above. I hereby also confirm to have read, understood, and agree to abide by the Terms\n      applicable to this Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong> to read).\n    </li>\n    <li>\n      I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this\n      investment.\n    </li>\n    <li>\n      The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other\n      mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the\n      Scheme is being recommended to me/us;\n    </li>\n    <li>\n      I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC\n      AMC/HDFC MF/ Distributor for this investment;\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/tncFlexSip.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – Flex Systematic Investment Plan (Flex SIP)</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=FLEX_SIP></terms-condition>");
$templateCache.put("app/components/modal/transactionalTnc/tncFlexStp.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – Flex STP</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=Flex_STP></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to\n      the respective Schemes under the Scheme Information Document(s), Statement of Additional Information, and the\n      Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer\n      Documents</strong>”) (Please visit the “Download” section on our website <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and the terms\n      and conditions for enrolment for Flex STP (please click here to read), and hereby apply to the Trustee of HDFC\n      Mutual Fund for enrolment under the Flex STP and to allot the Units of the said Scheme(s) of HDFC Mutual Fund,\n      as indicated above. I hereby also confirm to have read, understood, and agree to abide by the Terms applicable\n      to this Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong> to read).\n    </li>\n    <li>\n      I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this\n      investment.\n    </li>\n    <li>\n      The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other\n      mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the\n      Scheme is being recommended to me/us;\n    </li>\n    <li>\n      I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC\n      AMC/HDFC MF/ Distributor for this investment;\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/tncInstantRedemption.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – Instant Access Facility</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=INSTANT_REDEMPTION></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood and agree to abide by all the terms, conditions, rules, and regulations of the\n      respective Scheme(s) under the Scheme Information Document(s) and Statement of Additional Information of\n      HDFC Mutual Fund <span style=\"text-decoration:underline;\">including Addenda thereto issued from time to time</span>\n      (hereinafter referred to as \"<B>Offer Documents</B>\")\n      (Please visit the \"Download\" section on our website <a href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read).I hereby also confirm to have read, understood, and agree to abide\n      by the Terms applicable to this Platform (Please <strong class=\"text-primary\" ng-click=\"Modal.showGeneralTnc()\">\n      click here </strong> to read).\n    </li>\n    <li>\n      Any request for transaction on the Platform shall be time stamped consistent with the terms of the Offer Documents.\n      The Net Asset Value (NAV) for purchase /redemption /switch shall be based on the time of the business day on\n      which the application is received on the Platform, and subject to the provisions of realisation of funds and\n      cut off timings as described in the Offer Documents of HDFC MF. Any transactions entered on the Platform after\n      the cut off time shall be deemed to be received on the succeeding business day and shall be processed accordingly.\n      The decision of HDFC AMC in this regard shall be final and binding on me/us.\n    </li>\n    <br/>\n    <h6 class=\"margin-none\">\n      Instant Access Facility (IAF)\n    </h6>\n    <li>\n      Any valid request for redemption received through IAF on the Platform, in respect of HDFC Liquid Fund Scheme under\n      the Growth Option of Regular Plan and Direct Plan, the credit of redemption proceeds into the registered bank\n      account shall be instantly processed through Immediate Payment Service (IMPS) at any time or day of the\n      week subject to the provisions of realisation of funds and cut off timings as described in the Offer Documents\n      of HDFC MF as amended from time to time.\n    </li>\n    <li>\n     For the purpose of IAF, NAV applicable shall be as under:\n      <ul class=\"type-circle\">\n        <li>\n          In respect of valid IAF request received up to 3.00 pm on a calendar day, the applicable NAV shall be the lower of\n          <br/>\n          (i) NAV of previous calendar day and\n          <br/>\n          (ii) NAV of calendar day on which the request is received;\n        </li>\n\n      <li>\n      In respect of valid IAF request received after 3.00 pm on a calendar day, the applicable NAV shall be lower of\n      <br/>\n      (i) NAV of calendar day on which such request is received and\n      <br/>\n      (ii) NAV of the next calendar day\n        <p style=\"text-decoration:underline;margin-left: -20px;\">It may be noted that exit load, if applicable, shall be levied by adjusting units to be redeemed.</p>\n      </li>\n      </ul>\n    <li>\n    I/We shall be solely responsible for ensuring that all information provided to HDFC AMC/HDFC MF, including the bank\n    account details, is accurate, and HDFC AMC/HDFC MF shall not be responsible to verify the accuracy of the\n    information/details provided. I/We shall also be liable to inform HDFC AMC/HDFC MF/Registrar and Transfer\n    Agent of any change in any details or information provided initially. If any incorrect bank account number is\n    provided by me, the redemption proceeds could be credited to the said wrong bank account so provided by me/us\n    and there is no guarantee of recovery of the same. HDFC AMC/HDFC MF shall not be held liable for any loss or damage\n    that may be sustained by me/us on account of such error on my/our part.\n    </li>\n    <li>\n      IAF shall be available only to the resident individual investors whose complete CBS (Core Banking System) account\n      number is registered in the folio along with IFSC code and wherein Investor’s bank is immediate payment service\n      (IMPS) enabled.\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/tncPurchase.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – {{Modal.modalData.fromBasket ? \'Lumpsum\' : \'Purchase\' }}</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=PURCHASE></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood and agree to abide by all the terms, conditions, rules and regulations of the\n      respective Scheme(s) under the Scheme Information Document(s) and Statement of Additional Information of HDFC\n      Mutual Fund (hereinafter referred as “<strong>Offer Documents</strong>”) (Please visit the “Download” section on\n      our website<a href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and hereby apply to the Trustee of HDFC Mutual Fund for allotment of Units\n      of\n      the said Scheme(s) of HDFC Mutual Fund, as indicated above. I hereby also confirm to have read, understood, and\n      agree to abide by the Terms applicable to this Platform (Please <strong class=\"text-primary\"\n                                                                              ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong>to read).\n    </li>\n    <li>\n      I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this\n      investment.\n    </li>\n    <li>\n      In accordance with SEBI Circular Cir/IMD/DF/13/2011 dated August 22, 2011, as amended from time to time, for\n      purchases/subscriptions of Rs. 10,000/- and above through a Distributor, Transaction Charges shall be deducted\n      from the subscription amount as follows:\n\n      <ul class=\"type-circle\">\n        <li>\n          Rs. 150/- for a first time investor across mutual funds; or\n        </li>\n        <li>\n          Rs. 100/- for investor other than first time investor.\n        </li>\n        <li>\n          No Transaction Charges shall be deducted: (a) if the Distributor has not opted to receive any Transaction\n          Charges; or (b) for purchases/subscriptions under Direct Plan (i. e., not through a Distributor).\n        </li>\n      </ul>\n    </li>\n    <li>\n      The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other\n      mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the\n      Scheme is being recommended to me/us;\n    </li>\n    <li>\n      I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC\n      AMC/HDFC MF/ Distributor for this investment;\n    </li>\n    <li>\n      Any request for transaction on the Platform shall be time stamped consistent with the terms of the Offer\n      Documents. The Net Asset Value (NAV) for purchase /redemption/switch shall be based on the time of the business\n      day on which the application is received on the Platform, and subject to the provisions of realisation of funds\n      and cut off timings as described in the Offer Documents of HDFC MF. Any transactions entered on the Platform after\n      the cut off time shall be deemed to be received on the succeeding business day and shall be processed accordingly.\n      The decision of HDFC AMC in this regard shall be final and binding on me/us.\n    </li>\n    <li>\n      As per the provisions of SEBI circular CIR/IMD/DF/21/2012 dated 13 September 2012, for subscription / switch-in\n      in all schemes / plans (other than liquid schemes) for an amount of Rs. 2 (Two) lakhs and above, the Applicable\n      NAV will be of the day on which the funds are available for utilization, if the application is received before the\n      applicable cut-off time and the funds for the entire amount of subscription/purchase/switch-in as per the\n      application are credited to the bank account of the respective Scheme(s) before the cut-off time;\n    </li>\n    <li>\n      There could be a time lag between the amount of subscription being debited from your bank account and the\n      subsequent credit into the respective schemes’ bank account. HDFC AMC or its bankers or its service providers will\n      not be liable for the delay and consequent pricing of units;\n    </li>\n    <li>\n      All multiple applications for investment (at the first holder’s PAN level) in a particular scheme (irrespective\n      of the plan / option / sub-option) received on the same Business Day, will be aggregated to ascertain whether the\n      total amount equals to Rs. 2 lakhs or more and to determine the applicable NAV.\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/tncRedemption.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – Redemption</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=REDEMPTION></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood and agree to abide by all the terms, conditions, rules, and regulations of the\n      respective Scheme(s) under the Scheme Information Document(s) and Statement of Additional Information of HDFC\n      Mutual Fund (hereinafter referred to as “<strong>Offer Documents</strong>”) (Please visit the “Download” section\n      on our website\n      <a\n        href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n        {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read). I hereby also confirm to have read, understood, and agree to abide by\n      the\n      Terms applicable to this Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong> to read).\n    </li>\n    <li>\n      Any request for transaction on the Platform shall be time stamped consistent with the terms of the Offer\n      Documents. The Net Asset Value (NAV) for purchase /redemption /switch shall be based on the time of the business\n      day on which the application is received on the Platform, and subject to the provisions of realisation of funds\n      and cut off timings as described in the Offer Documents of HDFC MF. Any transactions entered on the Platform\n      after the cut off time shall be deemed to be received on the succeeding business day and shall be processed\n      accordingly. The decision of HDFC AMC in this regard shall be final and binding on me/us.\n    </li>\n    <li>\n      I/We shall be solely responsible for ensuring that all information provided to HDFC AMC/HDFC MF, including the\n      bank account details, is accurate, and HDFC AMC/HDFC MF shall not be responsible to verify the accuracy of the\n      information/details provided. I/We shall also be liable to inform HDFC AMC/HDFC MF/Registrar and Transfer Agent\n      of any change in any details or information provided initially. If any incorrect bank account number is provided\n      by me, the redemption proceeds could be credited to the said wrong bank account so provided by me/us and there\n      is no guarantee of recovery of the same. HDFC AMC/HDFC MF shall not be held liable for any loss or damage that\n      may be sustained by me/us on account of such error on my/our part.\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/tncRollover.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – Rollover</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><h6 class=margin-none>I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:</h6><br><ul><li>I/We have read, understood, and agree to the features, terms, conditions, rules, and regulations relating to the Roll over of the Scheme as stated in the Addendum published by HDFC AMC/HDFC MF in this regard and hereby provide my/our consent thereto.</li><li>I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to the respective Schemes under the Scheme Information Document(s), Statement of Additional Information, and the Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer Documents</strong>”) (Please visit the “Download” section on our website <a href={{Modal.HDFC_API.WEBSITE_LINK}} target=_blank>{{Modal.HDFC_API.WEBSITE_LINK}}</a> to read). I hereby also confirm to have read, understood, and agree to abide by the Terms applicable to this Platform (Please <strong class=text-primary ng-click=Modal.showGeneralTnc()>click here </strong>to read).</li><li>All declarations/confirmation provided by me/us during the initial subscription to the Scheme(s) shall continue to be applicable with respect to this consent for Roll over and shall continue to be binding on me/us.</li><li>Even after my/our consent to the roll over as conveyed herein, the Roll over may not materialize depending on restrictions under extant provisions of applicable laws/regulations or any other reason whatsoever. HDFC AMC/HDFC MF shall not be held liable for any loss or damage whatsoever that may be sustained by me/us as a result non-occurrence of the Roll over</li><li>I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this investment or in providing this consent.</li><li>The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the Scheme is being recommended to me/us;</li><li>I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC AMC/HDFC MF/ Distributor for this investment or in relation to this consent;</li></ul><br><p style=\"font-style: italic\">The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general Terms and Conditions.</p></div>");
$templateCache.put("app/components/modal/transactionalTnc/tncSip.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – <span ng-if=\"Modal.modalData.transactionType == \'DREAM_SIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.transactionType != \'DREAM_SIP\'\">Systematic Investment Plan (SIP)</span></h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=SIP></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood and agree to abide by all the terms, conditions, rules and regulations relating to\n      the respective Scheme(s), enrolment for SIP, and Direct Debit / Standing Instruction facilities or the One Time\n      Mandate (OTM) facility as the case may be, under the Scheme Information Document(s), Statement of Additional\n      Information, and the Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter\n      referred as “Offer Documents”) (Please visit the “Download” section on our website “<strong>Offer\n      Documents</strong>”)(Please visit the “Download” section on our website <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read), and hereby apply to the Trustee of HDFC Mutual Fund to register my/our SIP\n      and to allot the Units of the said Scheme(s) of HDFC Mutual Fund, as indicated above. I hereby also confirm to\n      have read, understood, and agree to abide by the Terms applicable to this Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong> to read).\n    </li>\n    <li>\n      I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this\n      investment.\n    </li>\n    <li>\n      In accordance with SEBI Circular Cir/IMD/DF/13/2011 dated August 22, 2011, as amended from time to time, for\n      purchases/subscriptions of Rs. 10,000/- and above through a Distributor, Transaction Charges shall be deducted\n      from the subscription amount as follows:\n\n      <ul class=\"type-circle\">\n        <li>\n          Rs. 150/- for a first time investor across mutual funds; or\n        </li>\n        <li>\n          Rs. 100/- for investor other than first time investor.\n        </li>\n        <li>\n          No Transaction Charges shall be deducted: (a) if the Distributor has not opted to receive any Transaction\n          Charges; or (b) for purchases/subscriptions under Direct Plan (i. e., not through a Distributor).\n        </li>\n      </ul>\n    </li>\n    <li>\n      In case of investments through SIP, the transaction Charges are deductible, only if the total commitment of\n      investment* is more than or equal to Rs. 10,000. In all such cases, the Transaction Charges shall be deducted in 3\n      to 4 installments.\n      * Amount per SIP installment x No. of installments\n\n    </li>\n    <li>\n      The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other mode),\n      payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the Scheme is\n      being recommended to me/us;\n    </li>\n    <li>\n      I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC\n      AMC/HDFC MF/ Distributor for this investment;\n    </li>\n    <li>\n      Units will be allotted on the applicable dates subject to realization of funds where total SIP investments on a\n      date amount to Rs. 2 lakh or more. In case the date falls on a Non Business Day or falls during a book closure\n      period, the immediate next Business Day will be considered for the purpose of determining the applicability of NAV\n      subject to the realization of proceeds;\n    </li>\n    <li>\n      In case my/our OTM is not already registered, SIP Registration shall be completed only upon successful\n      registration of auto debit instructions in favour of HDFC MF with my/our bank account for payment of SIP\n      instalments. In case of my/our failure to complete the registration of auto debit instructions within 1 day\n      from the date of registration for SIP on this Platform, HDFC AMC/HDFC MF shall reject my/our SIP registration\n      and HDFC AMC/HDFC MF shall not liable for any loss or damage sustained by me/us on account of such rejection.\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/tncSipEMandate.html","<div class=modal-head><h3 class=\"modal-title transforText\">Terms and Conditions for using ‘electronic - One Time Mandate’ (e-OTM) facility</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=SIP-E-MANDATE></terms-condition><style>.transforText{\n    text-transform: unset !important;\n  }</style>");
$templateCache.put("app/components/modal/transactionalTnc/tncSmartSwp.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – SMART SWAP</h3><i class=\"times-icon mobile-swap-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=SMART_SWAP></terms-condition>");
$templateCache.put("app/components/modal/transactionalTnc/tncStp.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – STP</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=STP></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to\n      the respective Scheme(s) under the Scheme Information Document(s), Statement of Additional Information, and the\n      Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer\n      Documents</strong>”) (Please visit the “Download” section on our website <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and\n      the terms\n      and conditions for enrolment for STP (please click here to read), and hereby apply to the Trustee of HDFC Mutual\n      Fund for enrolment under the STP and to allot the Units of the said Scheme(s) of HDFC Mutual Fund, as indicated\n      above. I hereby also confirm to have read, understood, and agree to abide by the Terms applicable to this\n      Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong> to read).\n    </li>\n    <li>\n      I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this\n      investment.\n    </li>\n    <li>\n      The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other\n      mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the\n      Scheme is being recommended to me/us;\n    </li>\n    <li>\n      I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC\n      AMC/HDFC MF/ Distributor for this investment;\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/tncSwingStp.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – Swing STP</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=Swing_STP></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to\n      the respective Schemes under the Scheme Information Document(s), Statement of Additional Information, and the\n      Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer\n      Documents</strong>”) (Please visit the “Download” section on our website <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and the terms\n      and conditions for enrolment for Swing STP (please click here to read), and hereby apply to the Trustee of HDFC\n      Mutual Fund for enrolment under the Swing STP and to allot the Units of the said Scheme(s) of HDFC Mutual Fund,\n      as indicated above. I hereby also confirm to have read, understood, and agree to abide by the Terms applicable\n      to this Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong> to read).\n    </li>\n    <li>\n      I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this\n      investment.\n    </li>\n    <li>\n      The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other\n      mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the\n      Scheme is being recommended to me/us;\n    </li>\n    <li>\n      I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC\n      AMC/HDFC MF/ Distributor for this investment;\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/tncSwitch.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – Switch</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=SWITCH></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood and agree to abide by all the terms, conditions, rules and regulations of the\n      respective Scheme(s) under the Scheme Information Document(s) of the respective Scheme(s) and Statement of\n      Additional Information of HDFC Mutual Fund (hereinafter referred as “<strong>Offer Documents</strong>”) (Please\n      visit the\n      “Download” section on our website <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and hereby apply to the Trustee of HDFC\n      Mutual Fund for allotment of Units of the said Scheme(s) of HDFC Mutual Fund, as indicated above. I hereby also\n      confirm to have read, understood, and agree to abide by the Terms applicable to this Platform (Please <strong\n      class=\"text-primary\"\n      ng-click=\"Modal.showGeneralTnc()\"> click\n      here </strong>\n      to read).\n    </li>\n    <li>\n      I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this\n      investment.\n    </li>\n    <li>\n      The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other\n      mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the\n      Scheme is being recommended to me/us;\n    </li>\n    <li>\n      I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC\n      AMC/HDFC MF/ Distributor for this investment;\n    </li>\n    <li>\n      Any request for transaction on the Platform shall be time stamped consistent with the terms of the Offer\n      Documents. The Net Asset Value (NAV) for purchase /redemption /switch shall be based on the time of the business\n      day on which the application is received on the Platform, and subject to the provisions of cut off timings as\n      described in the Offer Documents of HDFC MF. Any transactions entered on the Platform after the cut off time\n      shall be deemed to be received on the succeeding business day and shall be processed accordingly. The decision\n      of HDFC AMC in this regard shall be final and binding on me/us.\n    </li>\n    <li>\n      As per the provisions of SEBI circular CIR/IMD/DF/21/2012 dated 13 September 2012, for subscription /\n      switch-in in all schemes / plans (other than liquid schemes) for an amount of Rs. 2 (Two) lakh and above, the\n      Applicable NAV will be of the day on which the funds are available for utilization, if the application is\n      received before the applicable cut-off time and the funds for the entire amount of\n      subscription/purchase/switch-in as per the application are credited to the bank account of the respective\n      Schemes(s) before the cut-off time;\n    </li>\n    <li>\n      All multiple applications for investment (at the first holder’s PAN level) in a particular scheme\n      (irrespective of the plan / option / sub-option) received on the same Business Day, will be aggregated to\n      ascertain whether the total amount equals to Rs. 2 lakh or more and to determine the applicable NAV.\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/tncSwp.html","<div class=modal-head><h3 class=modal-title>HDFC MF Online for Investors – SWAP</h3><i class=\"times-icon mobile-tnc\" ng-click=Modal.dismissModal();></i></div><terms-condition transaction-type=SWP></terms-condition><!--<div class=\"modal-body\">\n  <h6 class=\"margin-none\">\n    I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:\n  </h6>\n  <br/>\n  <ul>\n    <li>\n      I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to\n      the respective Scheme(s) under the Scheme Information Document(s), Statement of Additional Information, and the\n      Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer\n      Documents</strong>”) (Please visit the “Download” section on our website <a\n      href=\"{{Modal.HDFC_API.WEBSITE_LINK}}\"  target=\"_blank\">\n      {{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and the terms\n      and conditions for enrolment for SWAP (please click here to read), and hereby apply to the Trustee of HDFC\n      Mutual Fund for enrolment under the SWAP of the said Scheme(s) of HDFC Mutual Fund, as indicated above. I hereby\n      also confirm to have read, understood, and agree to abide by the Terms applicable to this Platform (Please\n      <strong\n        class=\"text-primary\"\n        ng-click=\"Modal.showGeneralTnc()\"> click\n        here </strong> to read).\n    </li>\n    <li>\n      I/We shall be solely responsible for ensuring that all information provided to HDFC AMC/HDFC MF, including the\n      bank account details, is accurate, and HDFC AMC/HDFC MF shall not be responsible to verify the accuracy of the\n      information/details provided. I/We shall also be liable to inform HDFC AMC/HDFC MF/Registrar and Transfer Agent\n      of any change in any details or information provided initially. If any incorrect bank account number is provided\n      by me, the redemption proceeds could be credited to the said wrong bank account so provided by me/us and there\n      is no guarantee of recovery of the same. HDFC AMC/HDFC MF shall not be held liable for any loss or damage that\n      may be sustained by me/us on account of such error on my/our part.\n    </li>\n  </ul>\n  <br/>\n  <p style=\"font-style: italic\">\n    The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general\n    Terms and Conditions.\n  </p>\n</div>-->");
$templateCache.put("app/components/modal/transactionalTnc/transactionalTermcondition.modal.html","<div class=modal-content id=tnc><div data-ng-switch=Modal.modalData.transactionType><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncPurchase.html\'\"></div></div><div data-ng-switch-when=Schedule_Transaction><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncPurchase.html\'\"></div></div><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSip.html\'\"></div></div><div data-ng-switch-when=DREAM_SIP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSip.html\'\"></div></div><div data-ng-switch-when=SIP-E-MANDATE><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSipEMandate.html\'\"></div></div><div data-ng-switch-when=SWITCH><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSwitch.html\'\"></div></div><div data-ng-switch-when=REDEMPTION><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncRedemption.html\'\"></div></div><div data-ng-switch-when=INSTANT_REDEMPTION><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncInstantRedemption.html\'\"></div></div><div data-ng-switch-when=STP><div ng-if=\"Modal.modalData.subTransactionType === \'STP\'\" data-ng-include=\"\'app/components/modal/transactionalTnc/tncStp.html\'\"></div><div ng-if=\"Modal.modalData.subTransactionType === \'Flex STP\'\" data-ng-include=\"\'app/components/modal/transactionalTnc/tncFlexStp.html\'\"></div><div ng-if=\"Modal.modalData.subTransactionType === \'Swing STP\'\" data-ng-include=\"\'app/components/modal/transactionalTnc/tncSwingStp.html\'\"></div></div><div data-ng-switch-when=Flex_STP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncFlexStp.html\'\"></div></div><div data-ng-switch-when=Swing_STP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSwingStp.html\'\"></div></div><div data-ng-switch-when=FLEX_INDEX><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncFlexIndex.html\'\"></div></div><div data-ng-switch-when=SWP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSwp.html\'\"></div></div><div data-ng-switch-when=DTP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncDtp.html\'\"></div></div><div data-ng-switch-when=SMART_SWAP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncSmartSwp.html\'\"></div></div><div data-ng-switch-when=ECART><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncEcart.html\'\"></div></div><div data-ng-switch-when=FLEXSIP><div data-ng-include=\"\'app/components/modal/transactionalTnc/tncFlexSip.html\'\"></div></div></div></div>");
$templateCache.put("app/components/modal/transactions/manualInstructions.modal.html","<div class=modal-content id=termsCondition><div class=modal-head><h3>MANUAL INSTRUCTIONS</h3><div><i class=times-icon ng-click=Modal.dismissModal();></i></div></div><div ng-switch=Modal.modalData.paymentOption><div ng-switch-when=OTM ng-if=\"Modal.modalData.summaryType != \'SIP_TOPUP\'\" class=modal-body><h6 class=text-uppercase><span>Dear</span> {{Modal.modalData.investorName}}</h6><p>Thank you for transacting online using HDFCMF Online Investors.</p><p>We have successfully received your request for {{Modal.modalData.transactionType}} via OTM. {{Modal.modalData.transactionType}} will be debited from your bank account on the selected date, kindly maintain sufficient balance to stay invested with us.</p><div class=row style=padding-bottom:30px><div class=col-md-12><p>Transaction Details:</p><table class=table><tr><td>Folio Number</td><td>: {{Modal.modalData.folioNumber}}</td></tr><tr><td>Investor Name</td><td>: {{Modal.modalData.investorName}}</td></tr><tr><td>Transaction Type</td><td>: {{Modal.modalData.transactionType}} Registration</td></tr><tr><td>Payment mode</td><td>: OTM</td></tr><tr><td>{{Modal.modalData.transactionType}} Registration Number</td><td>: {{Modal.modalData.srnNo}}</td></tr><tr><td>CAMS Transaction Number</td><td>: {{Modal.modalData.transactionId}}</td></tr><tr><td>Scheme Name</td><td>: {{Modal.modalData.schemeName}}</td></tr><tr><td>Investment Option</td><td>: {{Modal.modalData.investmentOption}}</td></tr><tr ng-if=\"Modal.modalData.investmentOption === Modal.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>: <span ng-if=\"Modal.modalData.investmentOption===Modal.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{Modal.TRANSACTIONS_CONST.DESCRIPTIONS[Modal.modalData.sipDividendOption]}}</span></td></tr><tr ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\"><td>Installment Amount(INR)</td><td>: {{Modal.modalData.amount}}</td></tr><tr ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\"><td>SIP Amount(INR)</td><td>: {{Modal.modalData.amount}}</td></tr><tr ng-if=Modal.modalData.frequency><td>{{Modal.modalData.transactionType}} Frequency</td><td>: {{Modal.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Modal.modalData.frequency]}}</td></tr><tr ng-if=\"Modal.modalData.frequency === \'OW\'\"><td>{{Modal.modalData.transactionType}} Day</td><td>: {{Modal.modalData.weeklyDay}}</td></tr><tr ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\"><td>SWAP Amount (INR)</td><td>: {{Modal.modalData.swapAmount}}</td></tr><tr ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\"><td>Dream SIP Option</td><td>: {{Modal.modalData.option}} (SIP - SWAP)</td></tr><tr><td>Transaction Initiated Date & Time</td><td>: {{Modal.modalData.transactionInitiateDate}}</td></tr><tr><td>{{Modal.modalData.transactionType}} From Date</td><td>: {{Modal.modalData.startDate}}</td></tr><tr ng-if=\"Modal.modalData.transactionType === \'Flex SIP\'\"><td>Flex SIP Tenure</td><td>: {{Modal.tenureDiff}} years</td></tr><tr><td>{{Modal.modalData.transactionType}} To Date</td><td>: {{Modal.modalData.endDate}}</td></tr><tr ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\"><td>SIP Tenure</td><td>: {{Modal.modalData.sipPeriod}} years</td></tr><tr><td>Bank Name</td><td>: {{Modal.modalData.bankName | uppercase}}</td></tr><tr><td>Bank Account number</td><td>: <span easyassist-key=mask-element>{{Modal.modalData.bankAcNo}}</span></td></tr><tr ng-if=Modal.modalData.mobileNumber><td>Mobile Number</td><td>: {{Modal.modalData.mobileNumber}}</td></tr><tr ng-if=Modal.modalData.sipFirstInstallment><td>{{Modal.modalData.transactionType}} With First Installment</td><td>: <span ng-bind=\"Modal.modalData.sipFirstInstallment?\'Yes\':\'No\'\"></span></td></tr><tr ng-if=Modal.modalData.sipFirstAmount><td>{{Modal.modalData.transactionType}} First Installment Amount</td><td>: {{Modal.modalData.sipFirstAmount}}</td></tr></table></div></div></div><div ng-switch-when=OTM ng-if=\"Modal.modalData.summaryType === \'SIP_TOPUP\'\" class=modal-body><h6 class=text-uppercase><span>Dear</span> {{Modal.modalData.investorName}}</h6><p>Thank you for transacting online using HDFCMF Online Investors.</p><p>We have successfully received your request for SIP via OTM. SIP will be debited from your bank account on the selected date, kindly maintain sufficient balance to stay invested with us.</p><div class=row style=padding-bottom:30px><div class=col-md-12><p>Transaction Details:</p><table class=table><tr><td>Folio Number</td><td>: {{Modal.modalData.folioNumber}}</td></tr><tr><td>Investor Name</td><td>: {{Modal.modalData.folioInvestorName}}</td></tr><tr><td>Transaction Type</td><td>: {{Modal.modalData.transactionType}}</td></tr><tr><td>Payment mode</td><td>: OTM</td></tr><tr><td>Topup Registration Number</td><td>: {{Modal.modalData.srnNo}}</td></tr><tr><td>Scheme Name</td><td>: {{Modal.modalData.schemeName}}</td></tr><tr><td>SIP Topup Amount</td><td>: {{Modal.modalData.sipTopupAmount}}</td></tr><tr><td>SIP Topup Cap Amount</td><td>: {{Modal.modalData.sipTopupCapAmount}}</td></tr><tr><td>SIP Topup Frequency</td><td>: {{Modal.modalData.sipTopupFrequency}}</td></tr><tr><td>Transaction Initiated Date & Time</td><td>: {{Modal.modalData.transactionInitiateDate}}</td></tr><tr><td>Bank Name</td><td>: {{Modal.modalData.bankName | uppercase}}</td></tr><tr><td>Bank Account number</td><td>: <span easyassist-key=mask-element>{{Modal.modalData.bankAcNo}}</span></td></tr><tr ng-if=Modal.modalData.mobileNumber><td>Mobile Number</td><td>: {{Modal.modalData.mobileNumber}}</td></tr></table></div></div></div><div ng-switch-default class=modal-body><h6 class=text-uppercase><span>Dear</span> {{Modal.modalData.investorName}}</h6><p>Thank you for providing bank details. Please add HDFC Mutual Fund as a biller to your bank account</p><p>SRN No. for your <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span>: <span style=\"font-weight: bold;font-size: 14px\">{{Modal.modalData.srnNo}}</span> <a ng-if=Modal.modalData.netBankingUrl target=_blank ng-href={{Modal.modalData.netBankingUrl}} style=\"color: #2485bd\">Please click here for SRN registration</a></p><p ng-if=Modal.modalData.sipFirstInstallment><strong>First Installment Details:</strong><ul><li style=\"padding-bottom: 5px\" ng-if=Modal.modalData.sipFirstInstallment>Bank Name: {{Modal.modalData.sipFirstBankName}}</li><li style=\"padding-bottom: 5px\" ng-if=Modal.modalData.sipFirstAmount>Amount: {{Modal.modalData.sipFirstAmount}}</li><li style=\"padding-bottom: 5px\" ng-if=Modal.modalData.installmentPaymentOption>Payment Mode: {{Modal.modalData.installmentPaymentOption}}</li></ul></p><p><strong>Here is how you can quickly register HDFC Mutual Fund as a biller to your net banking account</strong></p><p>In order to complete <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span> registration, investor should either click on the \"Register <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span> with bank\" button or log on to his/her registered banking net banking facility and register for auto debit instruction for <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span> installment. We recommend investors to select the auto payment option.</p><ol><li>Please select HDFC Mutual Fund as biller.</li><li>Please input the <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span> Registration Number (SRN) in the field requesting the Biller Reference Number.</li><li>Please complete your <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span> registration with your bank within 70 days from today. The SRN will be invalid if the registration on your bank\'s website is not completed within the specified period.</li><li>If the <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span> registration with your bank is not completed by you, units created in your folio for the aforesaid <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span>, if any, will be reversed.</li><li>Investors will not hold HDFC Mutual Fund / HDFC Asset Management Company Limited, its registrars and other service providers responsible if the transaction is delayed or not effected or the Investor\'s bank account is debited in advance or after the spoecific <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span> date due to local holidays or any other reason.</li><li>Please register SRN for your <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span> with Autopay option to avoid <span ng-if=\"Modal.modalData.investmentType == \'DREAMSIP\'\">Dream SIP</span> <span ng-if=\"Modal.modalData.investmentType != \'DREAMSIP\'\">SIP</span> getting cancelled due to non-availability of debit bank account from your bank.</li></ol></div><div class=\"modal-footer center-aligned\"><button class=\"btn btn-primary-action font-14\" ng-click=Modal.closeModal() style=\"font-size: 13px !important\">OK</button></div></div></div>");
$templateCache.put("app/components/modal/transactions/registerEMandate.modal.html","<div class=modal-content id=signUp-otp ng-if=!Modal.modalData.noOtpConfirmModal><div class=\"loader popup\"><span class=loading></span></div><div><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=Modal.otpForm autocomplete=off class=otp-modal-form style=\"width: 500px\" novalidate><p style=\"text-align: left\" ng-if=\"Modal.modalData.authMode !== \'DEBIT_CARD\'\">To register your eMandate you would be redirected to the {{Modal.modalData.bankName}} internet banking login page. A debit of Rs. 1/- may be carried out to your account for registration depending on the selected bank.<br><br></p><p style=\"text-align: left\">An OTP has been sent to your Registered Email Id/Mobile Number.<br>Please enter the OTP to verify.</p><br><div class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text ng-pattern=Modal.appConstants.otp_regex ng-model=Modal.otpNumber name=otpNumber required minlength=6 maxlength=6 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Enter OTP</label><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=error-input ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.maxlength>{{ Modal.validateData.OTP_FIELD }}</span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.pattern>{{ Modal.validateData.OTP_FIELD }}</span></span><div style=\"padding-top: 10px\"><span ng-bind=Modal.otpResendMessage style=\"color: #1bb898\">OTP sent</span><timer ng-if=Modal.isOtmValid countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.resendOtp() class=pull-right ng-disabled=Modal.isProcessing>Resend OTP</a> <a ng-show=\"countdown > 0\" style=\"float:right;font-size: 12px !important\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><div class=\"modal-multiple-action text-center\"><button ng-class=\"{\'set-btn-blue-border\': Modal.modalData.showBlueBtn}\" class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>Cancel</button> <button ng-class=\"{\'set-btn-blue\': Modal.modalData.showBlueBtn}\" class=\"btn btn-primary-action\" ng-disabled=\"Modal.otpForm.$invalid || Modal.isProcessing || !Modal.isOtmValid\" ng-click=Modal.confirmTransaction()>OK</button></div></form></div></div><div class=modal-content id=initiateTransactionMsg ng-if=Modal.modalData.noOtpConfirmModal><div class=\"loader popup\"><span class=loading></span></div><div><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p style=\"text-align: left\" ng-if=\"Modal.modalData.authMode !== \'DEBIT_CARD\'\">To register your eMandate you would be redirected to the {{Modal.modalData.bankName}} internet banking login page. A debit of Rs. 1/- may be carried out to your account for registration depending on the selected bank.<br></p><p style=\"text-align: left\">Do you wish to proceed?</p><p></p><div ng-if=\"Modal.modalData.type == \'DREAMSIP\'\"><form autocomplete=off name=Modal.otpForm autocomplete=off ng-submit=Modal.closeModal() class=otp-modal-form novalidate><div class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text ng-pattern=Modal.appConstants.otp_regex ng-model=Modal.otpNumber name=otpNumber required minlength=6 maxlength=6 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Enter OTP</label><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=error-validation ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=error-validation ng-show=Modal.otpForm.otpNumber.$error.maxlength>{{ Modal.validateData.OTP_FIELD }}</span> <span class=error-validation ng-show=Modal.otpForm.otpNumber.$error.pattern>{{ Modal.validateData.OTP_FIELD }}</span></span><div style=\"padding-top: 10px\"><span ng-bind=Modal.otpResendMessage style=\"color: #1bb898\">OTP sent</span><timer ng-if=Modal.isOtmValid countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.resendOtp() class=pull-right ng-disabled=Modal.isProcessing>Resend OTP</a> <a ng-show=\"countdown > 0\" style=\"float:right;font-size: 12px !important\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>Cancel</button> <button type=submit class=\"btn btn-primary-action\" ng-disabled=Modal.otpForm.$invalid>Ok</button></div></form></div><div class=\"modal-multiple-action text-center\" ng-if=\"Modal.modalData.type != \'DREAMSIP\'\"><button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>Cancel</button> <button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div><style>.error-validation{\n    color: red !important;\n    font-size: 12px !important;\n  }</style>");
$templateCache.put("app/components/modal/transactions/transaction.success.html","<div class=modal-content id=forgot-success><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><p class=text-center>Your transaction is successful</p><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div></div>");
$templateCache.put("app/components/modal/unsaved-changes/unsaved-changes.modal.html","<div class=popup><div class=popupIcon><img src=../../../../assets/images/note-icon.svg></div><div class=popupNote ng-if=\"!Modal.modalData.misMatchNriData && !Modal.modalData.misMatchNriDataAtPayment\"><p style=\"font-weight: bold\">Please note:</p><p class=f-w-100>You have unsaved changes which will lead to</p><p class=f-w-100>loss of information provided.</p><p class=f-w-100>Are you sure you want to proceed?</p></div><div class=btnDiv ng-if=\"!Modal.modalData.misMatchNriData && !Modal.modalData.misMatchNriDataAtPayment\"><button class=popupBtn type=button ng-click=Modal.stayWithMinor()>No</button> <button class=popupBtn type=button ng-click=Modal.gotoSelf()>Yes</button></div><div class=\"popupNote misMatchNriData-note\" ng-if=Modal.modalData.misMatchNriData><p style=\"font-weight: bold\">Please note:</p><p class=f-w-100>You already have a saved request to create a folio with {{Modal.modalData.misMatchNriData && Modal.modalData.misMatchNriData.nriFlag ? \'NRI\' : \'RI\'}} tax status.</p><p class=f-w-100>Click \"Yes\" to proceed further or click \"No\" to be</p><p class=f-w-100>redirected to the drop journey.</p></div><div class=btnDiv ng-if=Modal.modalData.misMatchNriData><button class=\"popupBtn btn-lowercase\" type=button ng-click=Modal.deleteFolio()>Yes</button> <button class=\"popupBtn btn-lowercase\" type=button ng-click=Modal.dropJourneyContinue()>No</button></div><div class=\"popupNote misMatchNriDataAtPayment-note\" ng-if=Modal.modalData.misMatchNriDataAtPayment><p style=\"font-weight: bold\">Please note:</p><p class=f-w-100>You already have a saved request with Folio tax status as {{Modal.modalData.misMatchNriData && Modal.modalData.misMatchNriDataAtPayment.nriFlag ? \'NRI\' : \'RI\'}}.</p><p class=f-w-100>Click \"Yes\" to proceed further or click \"No\" to cancel</p><p class=f-w-100>the journey.</p></div><div class=btnDiv ng-if=Modal.modalData.misMatchNriDataAtPayment><button class=\"popupBtn btn-lowercase\" type=button ng-click=Modal.goToPayment()>Yes</button> <button class=\"popupBtn btn-lowercase\" type=button ng-click=Modal.updateStep()>No</button></div></div><style>.titleFatca{\n    margin: 5px 0px 5px 0px;\n  }\n  .popup{\n    border-radius: 20px;\n    background: rgb(255 255 255);\n    box-shadow: 0px 2px 14px rgb(18 66 101 / 30%);\n    color: black;\n    /*width: 60vw;*/\n    border-radius: 13px;\n    z-index: 999;\n    position: relative;\n    /*top: -80px;*/\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;flex-direction: column;\n  }\n  .btnDiv{\n    width: 50%;\n    padding: 30px;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n  }\n  .popupBtn{\n    width: 100px !important;\n    border-radius: 15px;\n    /*height: 30px;*/\n    color: white;\n    border: none;\n    background: #244b8c;\n  }\n  .popupIcon{\n    height: 100px;\n    width: 100px;\n    margin-top: 50px;\n    /* margin-bottom: 20px; */\n  }\n  .f-w-100{\n    font-weight: 100;\n  }\n  .popupNote{\n    margin: 20px;\n    width: 390px;\n    line-height: 26px;\n    font-size: 16px;\n    display: flex;\n    justify-content: center;\n    font-family: \"Open Sans\", sans-serif;\n    color: rgb(68 68 68);\n    align-items: center;\n    text-align: center;\n    flex-direction: column;\n  }\n\n  .misMatchNriData-note {\n    width: 450px;\n    margin: 20px 20px 0px 20px;\n  }\n\n  .misMatchNriDataAtPayment-note {\n    width: 500px;\n    margin: 20px 0px 20px 0px;\n  }\n  .btn-lowercase {\n    text-transform: none !important;\n  }\n\n  @media screen and (max-width: 860px) {\n    .minorageproofdiv{\n      margin-left: -15px;\n    }\n    .btnDiv{\n      width: 80%;\n    }\n    .popup{\n      /*width: 90vw;*/\n      /*margin-top: -10px;*/\n      /*left: -15px;*/\n    }\n    .popupNote{\n      width: 100%;\n    }\n\n    .misMatchNriDataAtPayment-note {\n      padding: 20px;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    /*.popup{*/\n    /*  width: 90vw;*/\n    /*  margin-top: -70px;*/\n    /*}*/\n  }</style>");
$templateCache.put("app/components/modal/updateNominee/updateNomineeSuccess.modal.html","<div class=\"modal-content update-nominee-sucess\"><div class=\"modal-body form-wrapper ng-scope\"><div class=offline-nominee-modal><div class=offline-form-msg>{{Modal.modalData.message}}</div><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.dismissModal()>OK</button></div></div></div></div>");
$templateCache.put("app/components/modal/video-modal/video.modal.html","<div class=modal-content id=videoModal><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><iframe class=youtube-video frameborder=0 allowfullscreen allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" title=\"YouTube video player\" width=100% ng-src={{Modal.modalData.url}} id=widget2></iframe></div></div>");
$templateCache.put("app/components/modal/widgetStore/widgetSelection.modal.html","<!-- Widget Selection\n--------------------------><div class=modal-content id=widgetSore ng-init=Modal.init();><div class=\"loader widget\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-header><h4 class=\"modal-title text-uppercase\">WIDGET STORE</h4><div class=selected-count><span>{{Modal.selectedCounter}}</span> Widgets Selected Out of <span ng-bind=Modal.widgetList.length>6</span></div></div><div class=tagline>List of all the widgets that will appear on your dashboard screen. You can De-Select any widget you want to Remove.</div><div class=modal-body><div class=\"col-md-4 col-sm-6\" ng-repeat=\"widgetData in Modal.widgetList\"><div class=widget-box ng-class=\"{\'active-widget\':widgetData.selected}\"><div class=widget-type><img ng-src={{widgetData.imageUrl}}><!--<img src=\"../../../../assets/images/widget-store/aum.png\"/>--></div><input type=checkbox ng-model=widgetData.selected ng-change=Modal.selectedCount();> <span class=\"select-bar text-center\"><div class=active-border></div><span class=circ></span> <i class=green-tick-icon></i> <span class=text ng-if=!widgetData.selected>Select</span> <span class=text ng-if=widgetData.selected>Selected</span></span></div><div class=\"text-center widget-label\">{{widgetData.widgetName}}</div></div></div><div class=modal-footer><button class=\"btn btn-primary-action\" ng-click=Modal.submitWidgetList();>Apply</button></div></div>");
$templateCache.put("app/components/sidebar/investor-progress-sidebar/investor-horizontal-progress-sidebar.directive.html","<div class=stepper-horizontal-container><div class=stepper-horizontal><div class=step ng-repeat=\"step in forms.steps track by $index\"><div class=step-heading ng-class=\"{\'active\': step.stepActive, \'step-completed\': step.stepCompleted}\" style=\"display: flex;justify-content: flex-start;align-items: center\"><!-- ng-click=\"toggleListItems($index)\" --><div ng-if=!step.stepCompleted class=circle></div><div ng-if=step.stepCompleted class=circle><strong>&#10003;</strong></div><div class=step-title>{{step.name}}</div><!-- <hr ng-if=\"!$last\" /> --><div class=hr ng-if=!$last></div></div></div></div><div class=stepper-horizontal-responsive><ul class=\"step steps-5\"><li ng-repeat=\"step in forms.steps track by $index\" style=\"background: #5bd\"><div class=innerDiv><div ng-if=!step.stepCompleted class=circle></div><div ng-if=step.stepCompleted class=circle><strong>&#10003;</strong></div><div class=nameofstep><label>{{step.name}}</label></div></div></li></ul></div></div>");
$templateCache.put("app/components/sidebar/investor-progress-sidebar/investor-vertical-progress-sidebar.directive.html","<div class=\"stepper progress-sidebar-container\" ng-if=!responsive><h6>New to HDFC<br>Mutual Fund</h6><div class=step1 ng-repeat=\"step in forms.steps\"><div class=step-heading ng-class=\"{\'active\': step.stepActive && !step.stepCompleted, \'step-completed\': step.stepCompleted && !step.stepActive}\"><!-- ng-click=\"toggleListItems($index);redirectToState(step);\" --><div class=steps-details><div ng-if=!step.stepCompleted class=circle>{{step.step}}</div><div ng-if=step.stepCompleted class=circle style=color:white><strong>&#10003;</strong></div><div class=title>{{step.name}}</div></div><div uib-collapse=!step.expanded><div class=body><div ng-if=step.stepCompleted class=details><div ng-if=step.investorName>{{step.investorName.toUpperCase()}}</div><div ng-if=step.panNumber easyassist-key=mask-element>{{step.panNumber.toUpperCase()}}</div><div ng-if=step.schemeName>{{step.schemeName}}</div><div ng-if=\"step.schemeInfo.amount || step.frequency || step.schemeInfo.investmentType\">&#8377;{{step.schemeInfo.amount}} {{step.frequency}} ({{step.schemeInfo.investmentType}})</div></div></div></div></div><div class=line ng-class=\"{\'active-line\':step.stepActive,\'step-completed-line\': step.stepCompleted}\" ng-hide=\"step.step >=forms.steps.length\"></div></div></div><div class=progress-vertical-responsive ng-if=responsive><div class=step-responsive ng-repeat=\"step in forms.steps track by $index\"><div><!-- ng-click=\"toggleListItems($index)\" --><div class=stepper-responsive ng-class=\"{\'stepper-responsive-active\':step.stepActive,\'stepper-responsive-step-completed\':step.stepCompleted}\" style=\"margin: 5px\"><div ng-if=!step.stepCompleted class=circle-responsive ng-class=\"{\'stepper-line\': !$last}\">{{step.step}}</div><div ng-if=step.stepCompleted class=circle-responsive ng-class=\"{\'stepper-line\': !$last}\" style=color:white><strong>&#10003;</strong></div><div>{{step.name}}</div></div></div></div></div>");
$templateCache.put("app/components/sidebar/login-sidebar/login-sidebar.directive.html","<ul class=\"col-md-12 side-menu-list-container\"><li class=\"row side-menu-list\" ng-class=\"{\'active-tab-sidemenu\': LoginSidebar.active[0]}\"><a ng-click=\"LoginSidebar.activateTab(LoginSidebar.constants.EXISTING_USER);\n      LoginSidebar.sideBarClick({message: LoginSidebar.constants.EXISTING_USER});\" ui-sref=login class=\"row sidebar-link\"><div class=col-md-2><img src=assets/images/existingInvestorBW.svg style=\"display: none\" class=body-img-bw> <img src=assets/images/investorIcon.svg ng-if=LoginSidebar.active[0] class=\"investorIcon body-img-color\"> <img src=assets/images/newInvestor.svg ng-if=!LoginSidebar.active[0] class=\"investorIcon body-img-bw body-contrast-img\"></div><div class=col-md-9><div class=mainmenu-text>Existing Investor</div><div class=submenu-text>Login to view your transactions, portfolio and more</div></div><div class=col-md-1><img src=assets/images/sideMenuArrowSelected.svg ng-if=LoginSidebar.active[0] class=side-menu-arrow> <img src=assets/images/sideMenuArrow.svg ng-if=!LoginSidebar.active[0] class=side-menu-arrow></div></a></li><li class=\"row side-menu-list\" ng-class=\"{\'active-tab-sidemenu\': LoginSidebar.active[1]}\"><a ng-click=\"LoginSidebar.activateTab(LoginSidebar.constants.NEW_INVESTOR);\n      LoginSidebar.sideBarClick({message: LoginSidebar.constants.NEW_INVESTOR});\" ui-sref=newInvestor.kycVerification class=\"row sidebar-link\"><div class=col-md-2><img src=assets/images/ic_newinvestor2bw.svg style=\"display: none\" ng-if=LoginSidebar.active[1] class=body-img-bw> <img src=assets/images/newInvestorBW.svg style=\"display: none\" ng-if=!LoginSidebar.active[1] class=body-img-bw> <img src=assets/images/newInvestorSelected.svg ng-if=LoginSidebar.active[1] class=\"investorIcon body-img-color\"> <img src=assets/images/new-investor-normal.svg ng-if=!LoginSidebar.active[1] class=\"investorIcon body-img-bw body-contrast-img\"></div><div class=col-md-9><div class=mainmenu-text>New Investor</div><div class=submenu-text>Take your first step now</div></div><div class=col-md-1><img src=assets/images/sideMenuArrowSelected.svg ng-if=LoginSidebar.active[1] class=side-menu-arrow> <img src=assets/images/sideMenuArrow.svg ng-if=!LoginSidebar.active[1] class=side-menu-arrow></div></a></li><li class=\"row side-menu-list\" ng-class=\"{\'active-tab-sidemenu\': LoginSidebar.active[2]}\"><a ng-click=\"LoginSidebar.activateTab(LoginSidebar.constants.QUICK_INVEST);\n     LoginSidebar.sideBarClick({message: LoginSidebar.constants.QUICK_INVEST});\" ui-sref=instantLogin class=\"row sidebar-link\"><div class=col-md-2><img src=assets/images/ic_quickinvest2bw.svg style=\"display: none\" class=body-img-bw> <img src=assets/images/quickInvestSelected.svg ng-if=LoginSidebar.active[2] class=\"investorIcon body-img-color\"> <img src=assets/images/quickinvest.svg ng-if=!LoginSidebar.active[2] class=\"investorIcon body-img-bw body-contrast-img\"></div><div class=col-md-9><div class=mainmenu-text>Quick Invest</div><div class=submenu-text>Invest without login</div></div><div class=col-md-1><img src=assets/images/sideMenuArrowSelected.svg ng-if=LoginSidebar.active[2] class=side-menu-arrow> <img src=assets/images/sideMenuArrow.svg ng-if=!LoginSidebar.active[2] class=side-menu-arrow></div></a></li><li class=\"row side-menu-list\" ng-class=\"{\'active-tab-sidemenu\': LoginSidebar.active[3]}\"><a ng-click=\"LoginSidebar.activateTab(LoginSidebar.constants.UPDATE_CONTACT_DETAILS);\n     LoginSidebar.sideBarClick({message: LoginSidebar.constants.UPDATE_CONTACT_DETAILS});\" ui-sref=updateContactLogin class=\"row sidebar-link\"><div class=col-md-2><img src=assets/images/ic_update_contact_white.svg style=\"display: none\" class=body-img-bw> <img src=assets/images/ic_update_contact_white.svg ng-if=LoginSidebar.active[3] class=\"investorIcon body-img-color\"> <img src=assets/images/update-contact.svg ng-if=!LoginSidebar.active[3] class=\"investorIcon body-img-bw body-contrast-img\"></div><div class=col-md-9><div class=mainmenu-text>Update Contact Details</div><div class=submenu-text></div></div><div class=col-md-1><img src=assets/images/sideMenuArrowSelected.svg ng-if=LoginSidebar.active[3] class=side-menu-arrow> <img src=assets/images/sideMenuArrow.svg ng-if=!LoginSidebar.active[3] class=side-menu-arrow></div></a></li><li class=\"row side-menu-list\" ng-class=\"{\'active-tab-sidemenu\': LoginSidebar.active[4]}\"><a ng-click=\"LoginSidebar.activateTab(LoginSidebar.constants.UPDATE_KYC);\n     LoginSidebar.sideBarClick({message: LoginSidebar.constants.UPDATE_KYC});\" ui-sref=kycUpdate class=\"row sidebar-link\"><div class=\"col-md-2 update-kyc-section\"><img src=assets/images/icons/update_kyc.png style=\"display: none\" class=\"investorIcon body-img-bw\"> <img src=assets/images/icons/update_kyc.png ng-if=LoginSidebar.active[4] class=\"investorIcon body-img-color\"> <img src=assets/images/icons/update_kyc.png ng-if=!LoginSidebar.active[4] class=\"investorIcon body-img-bw body-contrast-img\"></div><div class=col-md-9><div class=mainmenu-text>Update KYC</div><div class=submenu-text>Update or Modify KYC details online</div></div><div class=col-md-1><img src=assets/images/sideMenuArrowSelected.svg ng-if=LoginSidebar.active[4] class=side-menu-arrow> <img src=assets/images/sideMenuArrow.svg ng-if=!LoginSidebar.active[4] class=side-menu-arrow></div></a></li></ul>");
$templateCache.put("app/components/sidebar/preliminary-sidebar/preliminary-sidebar.html","<hdfc-dashboard-headers></hdfc-dashboard-headers><div class=\"common sidebar not-mobile\" ng-init=PreliminaryDashboardSidebar.initTab()><psidebar class=\"affix side-nav hidden-xs\" id=side-nav><ul class=\"list-group mt-4\"><li ng-class=\"{\'active-link\':PreliminaryDashboardSidebar.active[0]}\" class=nav-option><a ng-click=PreliminaryDashboardSidebar.activateTab(0) ui-sref=preliminaryDashboard><span ng-show=!PreliminaryDashboardSidebar.active[0] class=dashboardmenuicon></span> <span ng-show=PreliminaryDashboardSidebar.active[0] class=dashboardmenuicon-active></span> <span class=nav-link>Dashboard</span></a></li><li ng-class=\"{\'active-link\':PreliminaryDashboardSidebar.active[1]}\" class=nav-option><a ng-click=\"PreliminaryDashboardSidebar.transactSubMenu = !PreliminaryDashboardSidebar.transactSubMenu; PreliminaryDashboardSidebar.activateTab(1)\" aria-expanded={{!PreliminaryDashboardSidebar.transactSubMenu}}><div class=\"d-flex align-self-center justify-content-between\"><div class=d-flex><span ng-show=!PreliminaryDashboardSidebar.active[1] class=transactNowmenuicon></span> <span ng-show=PreliminaryDashboardSidebar.active[1] class=transactNowmenuicon-active></span> <span class=\"nav-link submenuPosition\" style=\"display: flex\">Transact Now</span></div><div class=subMenuArrow><span ng-show=!PreliminaryDashboardSidebar.transactSubMenu class=\"arrow arrow-down\"></span> <span ng-show=PreliminaryDashboardSidebar.transactSubMenu class=\"arrow arrow-right\"></span></div></div></a></li><ul class=\"collapse list-unstyled\" id=transactSubMenu uib-collapse=PreliminaryDashboardSidebar.transactSubMenu><li ng-class=\"{\'active-link\':PreliminaryDashboardSidebar.active[2]}\" class=nav-option ng-click=\"PreliminaryDashboardSidebar.addpan(\'SIP\')\"><a ng-click=PreliminaryDashboardSidebar.activateTab(2) ng-model=PreliminaryDashboardSidebar.transactionType><span class=nav-link>SIP</span></a></li><li ng-class=\"{\'active-link\':PreliminaryDashboardSidebar.active[3]}\" class=nav-option ng-click=\"PreliminaryDashboardSidebar.addpan(\'PURCHASE\')\"><a ng-click=PreliminaryDashboardSidebar.activateTab(3) ng-model=PreliminaryDashboardSidebar.transactionType><span class=nav-link>Purchase</span></a></li></ul><li ng-class=\"{\'active-link\':PreliminaryDashboardSidebar.active[4]}\" class=nav-option><a ng-click=PreliminaryDashboardSidebar.activateTab(4) href={{PreliminaryDashboardSidebar.allInvestmentBasketLink}} target=_blank><span ng-show=!PreliminaryDashboardSidebar.active[4] class=investmentbasketicon></span> <span ng-show=PreliminaryDashboardSidebar.active[4] class=investmentbasketicon-active></span> <span class=nav-link>Investment Basket</span></a></li><li ng-class=\"{\'active-link\':PreliminaryDashboardSidebar.active[5]}\" class=nav-option><a ng-click=\"PreliminaryDashboardSidebar.toolsSubMenu = !PreliminaryDashboardSidebar.toolsSubMenu; PreliminaryDashboardSidebar.activateTab(5)\" aria-expanded={{!PreliminaryDashboardSidebar.toolsSubMenu}}><div class=\"d-flex align-self-center justify-content-between\"><div class=d-flex><span ng-show=!PreliminaryDashboardSidebar.active[5] class=toolsicon></span> <span ng-show=PreliminaryDashboardSidebar.active[5] class=toolsicon-active></span> <span class=\"nav-link submenuPosition\" style=\"display: flex\">Tools</span></div><div class=subMenuArrow><span ng-show=!PreliminaryDashboardSidebar.toolsSubMenu class=\"arrow arrow-down\"></span> <span ng-show=PreliminaryDashboardSidebar.toolsSubMenu class=\"arrow arrow-right\"></span></div></div></a></li><ul class=\"collapse list-unstyled\" id=toolsSubMenu uib-collapse=PreliminaryDashboardSidebar.toolsSubMenu><li ng-class=\"{\'active-link\':PreliminaryDashboardSidebar.active[6]}\" class=nav-option><a ng-click=PreliminaryDashboardSidebar.activateTab(6) href={{PreliminaryDashboardSidebar.knowYourInvestmentPersonality}} target=_blank><span class=nav-link>Know your investment personality</span></a></li><li ng-class=\"{\'active-link\':PreliminaryDashboardSidebar.active[7]}\" class=nav-option><a ng-click=PreliminaryDashboardSidebar.activateTab(7) href={{PreliminaryDashboardSidebar.allCalculatorLink}} target=_blank><span class=nav-link>Calculators</span></a></li></ul><li ng-class=\"{\'active-link\':PreliminaryDashboardSidebar.active[8]}\" class=nav-option><a ng-click=PreliminaryDashboardSidebar.activateTab(8) href={{PreliminaryDashboardSidebar.learnerCorner}} target=_blank><span ng-show=!PreliminaryDashboardSidebar.active[8] class=learningicon></span> <span ng-show=PreliminaryDashboardSidebar.active[8] class=learningicon-active></span> <span class=nav-link>Learning Corner</span></a></li></ul></psidebar></div><style>.breadcrumb-link:focus{\n    border-top: 1px solid #D6D6D6 !important;\n    border-left: none !important;\n    border-right: none !important;\n    border-bottom: none !important;\n  }\n  .nav-link:hover{\n    color: white;\n  }</style>");
$templateCache.put("app/components/sidebar/preliminary-sidebar/preliminarySidebarBreadcum.html","<div class=breadcrumb-body><div class=\"headerPreLogin contrastpreliminarydashboard\"><div class=\"row main-head footer-wrap-main breadcrumb-row preliminaryfooter\"><div class=\"mobile-breadcrumb-header preliminaryheaderpadding\"><div><img src=../../../assets/images/breadcrumb-mobile-open.svg class=\"header-breadcrumb header-breadcrumb-mobile\" ui-sref=preliminaryDashboard> <a class=logo-main-web ui-sref=preliminaryDashboard><img src=assets/images/hdfcmf-Main.png alt=\"MF online investors\" class=\"logo-main-hdfcmf pull-left breadcrumb-hdfc-logo\"></a></div><div class=header-right-wrapper><div class=right-wrap-breadcrum><div class=\"d-flex justify-content-end align-items-center\"><div class=dropdown><a class=\"dropdown-toggle PrelimaryheaderProfile\" data-bs-toggle=dropdown data-bs-auto-close=outside href=#><img src=assets/images/preliminary-dashboard/profile.png class=\"pull-right pt-2 pb-2 pr-2 contrastImg-profile\"></a><ul class=\"dropdown-menu PrelimaryheaderProfileDropdownMenu\"><li class=\"no-border logouttxt\" ng-click=PreliminaryDashboard.logout(true)><a href=\"\">Logout</a></li></ul></div><div class=\"dropdown verticalmenu-nofocus\"><a class=\"dropdown-toggle Prelimaryheadermore verticalmenu-nofocus\" data-bs-toggle=dropdown href=# data-bs-auto-close=outside><img src=assets/images/preliminary-dashboard/verticalmenu.png class=\"pull-right pt-3 pb-3 pl-2 pr-2 contrastImg-profile verticalmenu-nofocus\"></a><ul class=\"dropdown-menu PrelimaryheaderMoreDropdownMenu\"><li class=\"borderSeparator pt-2 pb-2\"><a ui-sref=faq class=nofocus><img src=assets/images/preliminary-dashboard/faqQuestionmark.svg alt=\"\"> <span class=mobilefaqtxt>FAQs</span></a></li><li class=\"pt-2 pb-2\"><ul class=d-flex><li><span class=\"toggle-contrast-text contrastImgMode\">Dark</span></li><li><div class=preliminary-form-switch><label class=switch><input type=checkbox ng-model=PreliminaryDashboard.contrastt ng-click=PreliminaryDashboard.contrast() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=\"toggle-contrast-text contrastImgMode\">Light</span></li></ul></li><li class=\"borderSeparator pt-2 pb-2\"><div class=\"text-size-img-container mobileFontChangeContainer d-flex\"><div class=\"text-size-img mobFontChangeTxt\" ng-click=\"PreliminaryDashboard.changedFont(\'decrement\')\" ng-class=\"{\'active-font\': PreliminaryDashboard.active[2]}\">-A</div><div class=\"text-size-img mobFontChangeTxt\" ng-click=\"PreliminaryDashboard.changedFont(\'original\')\" ng-class=\"{\'active-font\': PreliminaryDashboard.active[1]}\">A</div><div class=\"text-size-img mobFontChangeTxt\" ng-click=\"PreliminaryDashboard.changedFont(\'increment\')\" ng-class=\"{\'active-font\': PreliminaryDashboard.active[3]}\">A+</div></div></li><li class=\"pt-2 pb-2\"><a href=\"\" class=nofocus><div class=logindetailstext ng-if=PreliminaryDashboard.lastDateTime><span class=\"pr-2 logintxt moblogintxt d-flex flex-wrap\">Last Login&nbsp; <span class=\"logindetailstext moblogintxt\">{{PreliminaryDashboard.lastDateTime}}</span></span></div></a></li></ul></div></div></div></div></div><div class=breadcrumb-link ui-sref=preliminaryDashboard>Dashboard</div><div class=\"breadcrumb-link d-flex justify-content-between\" ng-click=\"PreliminaryDashboard.transactSubMenu = !PreliminaryDashboard.transactSubMenu;\" data-bs-toggle=collapse data-bs-target=#transactnow>Transact Now <i ng-show=!PreliminaryDashboard.transactSubMenu class=\"arrow-down-icon visible-xs\"></i> <i ng-show=PreliminaryDashboard.transactSubMenu class=\"arrow-right-blue-icon visible-xs\"></i></div><div id=transactnow class=collapse><div class=breadcrumb-link ng-click=PreliminaryDashboard.addpan()>SIP</div><div class=breadcrumb-link ng-click=PreliminaryDashboard.addpan()>Purchase</div></div><a class=breadcrumb-link href={{PreliminaryDashboard.allInvestmentBasketLink}} target=_blank>Investment Basket</a><div class=\"breadcrumb-link d-flex justify-content-between\" ng-click=\"PreliminaryDashboard.toolsSubMenu = !PreliminaryDashboard.toolsSubMenu;\" data-bs-toggle=collapse data-bs-target=#tools>Tools <i ng-show=!PreliminaryDashboard.toolsSubMenu class=\"arrow-down-icon visible-xs\"></i> <i ng-show=PreliminaryDashboard.toolsSubMenu class=\"arrow-right-blue-icon visible-xs\"></i></div><div id=tools class=collapse><a class=\"breadcrumb-link d-block\" ui-sref=preliminaryDashboard href={{PreliminaryDashboard.knowYourInvestmentPersonality}} target=_blank>Know your investment personality</a> <a class=\"breadcrumb-link d-block\" href={{PreliminaryDashboard.allCalculatorLink}} target=_blank>Calculators</a></div><a class=breadcrumb-link href={{PreliminaryDashboard.learnerCorner}} target=_blank>Learning Corner</a></div></div></div><style>.breadcrumb-link:focus{\n      border-top: 1px solid #D6D6D6 !important;\n      border-left: none !important;\n      border-right: none !important;\n      border-bottom: none !important;\n    }\n    .contrastClass .contrastImg-profile{\n      background:transparent !important;\n    }\n    .contrastClass .contrastpreliminarydashboard .breadcrumb-link{\n      color: white !important;\n    }\n    .preliminaryfooter{\n      padding-bottom:30px ;\n    }\n    .contrastClass .PrelimaryheaderMoreDropdownMenu{\n      background: #000;\n    }\n    .contrastClass .mobilefaqtxt{\n      color: #fff !important;\n    }\n    .contrastClass .mobilefaqtxt,.contrastClass .contrastImgMode,.contrastClass .logindetailstext,.contrastClass .moblogintxt {\n      color: #fff !important;\n    }\n    .verticalmenu-nofocus:focus{\n      border:none !important;\n    }</style>");
$templateCache.put("app/firstLogin/folioDetails/addNominee/addNominee.html","<div ng-init=FolioDetails.init() name=addNomineeForm><folio-nominee-details nominee-payload=FolioDetails.payload main-folio-parent=FolioDetailsParent first-flow=YES pan=FolioDetails.userPan dynamic-bank-details-note=FolioDetails.dynamicData></folio-nominee-details></div>");
$templateCache.put("app/firstLogin/folioDetails/bankDetails/bankDetails.html","<div ng-init=FolioDetails.init() class=investors><folio-bank-details bank-payload=FolioDetails.payload first-flow=YES bank-type-list=FolioDetails.bankTypeList dynamic-bank-details-note=FolioDetails.dynamicData></folio-bank-details></div>");
$templateCache.put("app/firstLogin/folioDetails/folioCreation/folioCreation.html","<div ng-init=FolioDetails.init() name=folioCreation novalidate><div class=\"col-md-12 folio-create\"><folio-form-data holders=FolioDetails.formData main-folio-parent=FolioDetailsParent first-flow=YES ekyc-email=FolioDetails.ekycEmail ekyc-email-belongs-to=FolioDetails.emailBelongsTo ekyc-mobile=FolioDetails.ekycMobile ekyc-mobile-belongs-to=FolioDetails.mobileBelongsTo></folio-form-data></div></div>");
$templateCache.put("app/firstLogin/folioDetails/holdMode/holdMode.html","<div class=tab-content name=folioCreation ng-init=HoldMode.init();><div class=\"col-md-12 folio-create\"><folio-hold-mode holders=HoldMode.formData main-folio-parent=FolioDetailsParent first-flow=YES></folio-hold-mode></div></div>");
$templateCache.put("app/firstLogin/folioDetails/incomeDetails/incomeDetails.html","<form autocomplete=off ng-init=FolioDetails.init() name=folioDetailsForm novalidate><div class=\"col-md-5 income\"><h6>Tax Status</h6><div class=\"input-select input-normal selectfield\" ng-class=\"{error:folioDetailsForm.taxStatus.$dirty && folioDetailsForm.taxStatus.$invalid}\"><select class=\"browser-default custom-select\" name=taxStatus ng-model=FolioDetails.payload.soleApplicantDetail.taxStatusCode ng-options=\"status.taxStatusCode as status.taxStatusDescription for status in FolioDetails.taxStatusList\" ng-change=FolioDetails.changeTaxStatus() required ng-init=\"FolioDetails.payload.soleApplicantDetail.taxStatusCode = FolioDetails.payload.soleApplicantDetail.taxStatusCode ? FolioDetails.payload.soleApplicantDetail.taxStatusCode : null\"><option value=\"\" selected>Tax Status</option></select><span class=\"req text-red\">*</span> <span ng-show=\"folioDetailsForm.taxStatus.$dirty && folioDetailsForm.taxStatus.$invalid\"><span class=error-input ng-show=folioDetailsForm.taxStatus.$error.required>{{FolioDetails.validations.TAX_STATUS}}</span></span></div><h6>Income Details</h6><div class=\"input-select input-normal selectfield\" ng-class=\"{error:folioDetailsForm.occupationDescription.$dirty && folioDetailsForm.occupationDescription.$invalid}\"><select class=\"browser-default custom-select\" name=occupationDescription ng-model=FolioDetails.payload.soleApplicantDetail.occupation ng-options=\"occupation.occupationCode as occupation.occupationDescription for occupation in FolioDetails.occupationList\" ng-init=\"FolioDetails.payload.soleApplicantDetail.occupation = FolioDetails.payload.soleApplicantDetail.occupation ? FolioDetails.payload.soleApplicantDetail.occupation : null\" required><option value=\"\" selected>Occupation</option></select><span class=\"req text-red\">*</span> <span ng-show=\"folioDetailsForm.occupationDescription.$dirty && folioDetailsForm.occupationDescription.$invalid\"><span class=error-input ng-show=folioDetailsForm.occupationDescription.$error.required>{{FolioDetails.validations.OCCUPATION}}</span></span></div><div class=\"input-select input-normal selectfield\" ng-class=\"{error:folioDetailsForm.grossAnnualIncome.$dirty && folioDetailsForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-model=FolioDetails.payload.soleApplicantDetail.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in FolioDetails.incomeSlabList\" ng-init=\"FolioDetails.payload.soleApplicantDetail.grossAnnualIncome = FolioDetails.payload.soleApplicantDetail.grossAnnualIncome ? FolioDetails.payload.soleApplicantDetail.grossAnnualIncome : null\" ng-required=!FolioDetails.payload.soleApplicantDetail.netWorth ng-disabled=FolioDetails.payload.soleApplicantDetail.netWorth ng-change=FolioDetails.resetNetWorthDetails() ng-class=\"{\'selectfield-disabled\':FolioDetails.payload.soleApplicantDetail.netWorth}\"><option value=\"\" selected>Gross Annual Income</option></select><span class=\"req text-red\" ng-if=!FolioDetails.payload.soleApplicantDetail.netWorth>*</span> <span ng-show=\"folioDetailsForm.grossAnnualIncome.$dirty && folioDetailsForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=folioDetailsForm.grossAnnualIncome.$error.required>{{FolioDetails.validations.GROSS_ANNUAL_INCOME}}</span></span></div><div class=form-group><strong style=color:#000>OR</strong></div><div class=input-normal ng-class=\"{error:folioDetailsForm.netWorth.$dirty && folioDetailsForm.netWorth.$invalid}\"><input type=text name=netWorth is-number ng-model=FolioDetails.payload.soleApplicantDetail.netWorth ng-required=!FolioDetails.payload.soleApplicantDetail.grossAnnualIncome ng-disabled=FolioDetails.payload.soleApplicantDetail.grossAnnualIncome> <span class=highlight></span> <span class=bar></span> <i class=rupee-input-icon></i><label>Net Worth <span class=\"req text-red\" ng-if=!FolioDetails.payload.soleApplicantDetail.grossAnnualIncome>*</span></label><span ng-show=\"folioDetailsForm.netWorth.$dirty && folioDetailsForm.netWorth.$invalid\"><span class=error-input ng-show=folioDetailsForm.netWorth.$error.required>{{FolioDetails.validations.NET_WORTH}}</span></span></div><div class=\"input-normal mgt13\" ng-class=\"{error:folioDetailsForm.networthDate.$dirty && folioDetailsForm.networthDate.$invalid}\"><input type=text id=networthDate name=networthDate date-calendar format=DD-MMM-YYYY viewmode=days showdefault=\"{{\'\'+!!FolioDetails.payload.soleApplicantDetail.netWorthDate}}\" date-default=FolioDetails.defaultsoleApplicantNWDate maxdate=now data-min-date=FolioDetails.minDate data-on-date-change=FolioDetails.changeNetWorthDateForSoleApplicant autocomplete=off ng-model=FolioDetails.payload.soleApplicantDetail.netWorthDate ng-required=!FolioDetails.payload.soleApplicantDetail.grossAnnualIncome ng-disabled=FolioDetails.payload.soleApplicantDetail.grossAnnualIncome> <span class=highlight></span> <span class=bar></span> <i class=calendar-input-icon></i><!--<i class=\"times-icon\" ng-click=\"FolioDetails.resetNetWorthDate()\"></i>--><label>As on DD-MMM-YYYY <span ng-if=\"!(FolioDetails.payload.soleApplicantDetail.grossAnnualIncome)\n                ||(FolioDetails.payload.soleApplicantDetail.netWorth)\" class=\"req text-red\" ng-if=!FolioDetails.payload.soleApplicantDetail.grossAnnualIncome>*</span></label><span ng-show=\"folioDetailsForm.networthDate.$dirty && folioDetailsForm.networthDate.$invalid\"><span class=error-input ng-show=folioDetailsForm.networthDate.$error.required>{{FolioDetails.validations.NET_WORTH_DATE}}</span> </span><span class=\"text-support text-warn text-purple\">(Not older than 1year)</span></div></div><div class=\"col-md-12 review cursor-pointer\"><span class=\"pull-left previous\" ng-click=FolioDetails.back()><i class=back-icon></i>Previous</span> <span class=\"pull-right next\" ng-hide=folioDetailsForm.$invalid ng-click=FolioDetails.next()>Next<i class=next-icon></i></span></div></form>");
$templateCache.put("app/firstLogin/folioDetails/incomeDetails/incomeDetails.minor.html","<form autocomplete=off ng-init=FolioDetails.init() name=folioDetailsForm novalidate><h6>Guardian\'s Income Details</h6><div class=\"col-md-8 income\"><div class=\"input-select input-normal selectfield\" ng-class=\"{error:folioDetailsForm.occupationDescription.$dirty && folioDetailsForm.occupationDescription.$invalid}\"><select class=\"browser-default custom-select\" name=occupationDescription ng-model=FolioDetails.payload.guardianDetail.occupationCode ng-options=\"occupation.occupationCode as occupation.occupationDescription for occupation in FolioDetails.occupationList\" required><option value=\"\" selected>Occupation</option></select><span class=\"req text-red\">*</span> <span ng-show=\"folioDetailsForm.occupationDescription.$dirty && folioDetailsForm.occupationDescription.$invalid\"><span class=error-input ng-show=folioDetailsForm.occupationDescription.$error.required>{{FolioDetails.validations.OCCUPATION}}</span></span></div><div class=\"input-select input-normal selectfield\" ng-class=\"{error:folioDetailsForm.grossAnnualIncome.$dirty && folioDetailsForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-model=FolioDetails.payload.guardianDetail.income ng-options=\"_type.incomeCode as _type.incomeDescription for _type in FolioDetails.incomeSlabList\" ng-required=!FolioDetails.payload.guardianDetail.netWorth ng-disabled=FolioDetails.payload.guardianDetail.netWorth ng-change=FolioDetails.resetNetWorthDetails() ng-class=\"{\'selectfield-disabled\':FolioDetails.payload.guardianDetail.netWorth}\"><option value=\"\" selected>Gross Annual Income</option></select><span class=\"req text-red\" ng-if=!FolioDetails.payload.guardianDetail.netWorth>*</span> <span ng-show=\"folioDetailsForm.grossAnnualIncome.$dirty && folioDetailsForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=folioDetailsForm.grossAnnualIncome.$error.required>{{FolioDetails.validations.GROSS_ANNUAL_INCOME}}</span></span></div><div class=form-group><strong style=color:#000>OR</strong></div><div class=input-normal ng-class=\"{error:folioDetailsForm.netWorth.$dirty && folioDetailsForm.netWorth.$invalid}\"><input type=text name=netWorth ng-model=FolioDetails.payload.guardianDetail.netWorth ng-required=!FolioDetails.payload.guardianDetail.income ng-disabled=FolioDetails.payload.guardianDetail.income> <span class=highlight></span> <span class=bar></span> <i class=rupee-input-icon></i><label>Net Worth <span class=\"req text-red\" ng-if=!FolioDetails.payload.guardianDetail.income>*</span></label><span ng-show=\"folioDetailsForm.netWorth.$dirty && folioDetailsForm.netWorth.$invalid\"><span class=error-input ng-show=folioDetailsForm.netWorth.$error.required>{{FolioDetails.validations.NET_WORTH}}</span></span></div><div class=\"input-normal mgt13\" ng-class=\"{error:folioDetailsForm.networthDate.$dirty && folioDetailsForm.networthDate.$invalid}\"><input type=text id=networthDate name=networthDate date-calendar format=DD-MMM-YYYY viewmode=days showdefault=\"{{\'\'+!!FolioDetails.payload.guardianDetail.netWorthDate}}\" date-default=FolioDetails.defaultsoleApplicantNWDate maxdate=now data-min-date=FolioDetails.minDate data-on-date-change=FolioDetails.changeNetWorthDateForSoleApplicant autocomplete=off ng-model=FolioDetails.payload.guardianDetail.netWorthDate ng-required=!FolioDetails.payload.guardianDetail.income ng-disabled=FolioDetails.payload.guardianDetail.income> <span class=highlight></span> <span class=bar></span> <i class=calendar-input-icon></i><label>As on DD-MMM-YYYY <span ng-if=\"!(FolioDetails.payload.guardianDetail.income)\n                && (FolioDetails.payload.guardianDetail.netWorth)\" class=\"req text-red\">*</span></label><span ng-show=\"folioDetailsForm.networthDate.$dirty && folioDetailsForm.networthDate.$invalid\"><span class=error-input ng-show=folioDetailsForm.networthDate.$error.required>{{FolioDetails.validations.NET_WORTH_DATE}}</span> </span><span class=\"text-support text-warn text-purple\">(Not older than 1year)</span></div></div><div class=\"col-md-12 review cursor-pointer\"><span class=\"pull-left previous\" ng-click=FolioDetails.back()><i class=back-icon></i>Previous</span> <span class=\"pull-right next\" ng-hide=folioDetailsForm.$invalid ng-click=FolioDetails.next()>Next<i class=next-icon></i></span></div></form>");
$templateCache.put("app/firstLogin/folioDetails/jointHolders/jointHolders.html","<div ng-init=FolioDetails.init() name=folioCreation novalidate><div class=\"col-md-12 folio-create\"><folio-joint-holders joint-holders-payload=FolioDetails.payload main-folio-parent=FolioDetailsParent first-flow=YES></folio-joint-holders></div></div>");
$templateCache.put("app/firstLogin/folioDetails/politicalExposed/politicalExposed.html","<form autocomplete=off ng-init=FolioDetails.init() novalidate><h6>{{FolioDetails.headingText}}</h6><div class=\"col-md-8 political-exposed\"><div class=radio-block><span class=radio><input ng-if=!FolioDetails.payload.soleApplicantDetail.minor type=radio name=politicallyExposed ng-model=FolioDetails.payload.soleApplicantDetail.politicalStatus ng-value=FolioDetails.POLITICAL_STATUS.POLITICAL> <input type=radio ng-if=FolioDetails.payload.soleApplicantDetail.minor name=politicallyExposed ng-model=FolioDetails.payload.guardianDetail.pepStatus ng-value=FolioDetails.POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio ng-if=!FolioDetails.payload.soleApplicantDetail.minor name=politicallyExposed ng-model=FolioDetails.payload.soleApplicantDetail.politicalStatus ng-value=FolioDetails.POLITICAL_STATUS.RELATED> <input type=radio ng-if=FolioDetails.payload.soleApplicantDetail.minor name=politicallyExposed ng-model=FolioDetails.payload.guardianDetail.pepStatus ng-value=FolioDetails.POLITICAL_STATUS.RELATED> <span class=check></span></span><label>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio ng-if=!FolioDetails.payload.soleApplicantDetail.minor name=politicallyExposed ng-model=FolioDetails.payload.soleApplicantDetail.politicalStatus ng-value=FolioDetails.POLITICAL_STATUS.NONE> <input type=radio ng-if=FolioDetails.payload.soleApplicantDetail.minor name=politicallyExposed ng-model=FolioDetails.payload.guardianDetail.pepStatus ng-value=FolioDetails.POLITICAL_STATUS.NONE> <span class=check></span></span><label>Not applicable</label></div></div><div class=\"col-md-12 review cursor-pointer\"><span class=\"pull-left previous\" ng-click=FolioDetails.back()><i class=back-icon></i>Previous</span> <span class=\"pull-right next\" ng-click=FolioDetails.next()>Next<i class=next-icon></i></span></div></form>");
$templateCache.put("app/firstLogin/folioDetails/review/review.html","<div class=investors><folio-review first-flow=YES></folio-review></div>");
$templateCache.put("app/firstLogin/folioDetails/taxResidency/taxResidency.html","<form autocomplete=off ng-init=FolioDetails.init() name=taxResidencyForm novalidate><h6>FATCA and CRS information</h6><div class=fatca-info><div class=row><div class=col-md-6><div class=\"input-select input-normal selectfield\" ng-class=\"{error:taxResidencyForm.birthCountry.$dirty && taxResidencyForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=FolioDetails.payload.soleApplicantDetail.birthCountry ng-options=\"country.countryCode as country.countryName for country in FolioDetails.countryList\" ng-init=\"FolioDetails.payload.soleApplicantDetail.birthCountry = FolioDetails.payload.soleApplicantDetail.birthCountry ? FolioDetails.payload.soleApplicantDetail.birthCountry : null\" required><option value=\"\" selected>Country of Birth</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyForm.birthCountry.$dirty && taxResidencyForm.birthCountry.$invalid\"><span class=error-input ng-show=taxResidencyForm.birthCountry.$error.required>{{FolioDetails.validateData.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-6><div class=input-normal ng-class=\"{error:taxResidencyForm.birthCity.$dirty && taxResidencyForm.birthCity.$invalid}\"><input type=text name=birthCity ng-model=FolioDetails.payload.soleApplicantDetail.birthCity only-alphabets required> <span class=highlight></span> <span class=bar></span><label>City of Birth <span class=\"req text-red\">*</span></label><span ng-show=\"taxResidencyForm.birthCity.$dirty && taxResidencyForm.birthCity.$invalid\"><span class=error-input ng-show=taxResidencyForm.birthCity.$error.required>{{FolioDetails.validateData.BIRTH_CITY}}</span></span></div></div></div><div class=row><div class=col-md-6><div class=\"input-select input-normal selectfield\" ng-class=\"{error:taxResidencyForm.addressType.$dirty && taxResidencyForm.addressType.$invalid}\"><select class=\"browser-default custom-select\" name=addressType ng-model=FolioDetails.payload.soleApplicantDetail.fatcaAddressType ng-options=\"address.value as address.addressDescription for address in FolioDetails.addressTypeList\" ng-init=\"FolioDetails.payload.soleApplicantDetail.fatcaAddressType = FolioDetails.payload.soleApplicantDetail.fatcaAddressType ? FolioDetails.payload.soleApplicantDetail.fatcaAddressType : null\" required><option value=\"\" selected>Address Type</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyForm.addressType.$dirty && taxResidencyForm.addressType.$invalid\"><span class=error-input ng-show=taxResidencyForm.addressType.$error.required>{{FolioDetails.validateData.FATCA_ADDRESS_TYPE_REQUIRED}}</span></span></div></div></div></div><h6>Do you pay or file tax other than India?</h6><div class=\"col-md-6 tax-res\"><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-model=FolioDetails.payload.soleApplicantDetail.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-model=FolioDetails.payload.soleApplicantDetail.payTaxInIndia ng-value=true> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span><div ng-if=!FolioDetails.payload.soleApplicantDetail.payTaxInIndia ng-repeat=\"data in FolioDetails.payload.soleApplicantDetail.payOutsideIndiaAddresses\"><div class=tax-res><p><strong>Tax Residency Country</strong> <span ng-show=\"$index > 0\" class=remove-item ng-click=FolioDetails.deleteTaxResidency($index)><i class=delete-red-icon></i></span></p><div class=\"input-select input-normal selectfield\" ng-class=\"{error:taxResidencyForm[\'birthCountry\'+$index].$dirty && taxResidencyForm[\'birthCountry\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry{{$index}} ng-model=data.countryName ng-options=\"country.countryCode as country.countryName for country in FolioDetails.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" ng-init=\"data.countryName = data.countryName ? data.countryName : null\" required><option value=\"\" selected>Name Of Country</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyForm[\'birthCountry\'+$index].$dirty && taxResidencyForm[\'birthCountry\'+$index].$invalid\"><span class=error-input ng-show=\"taxResidencyForm[\'birthCountry\'+$index].$error.required\">{{FolioDetails.validateData.SELECT_COUNTRY}}</span></span></div><div class=input-normal ng-class=\"{error:taxResidencyForm[\'birthCity\'+$index].$dirty && taxResidencyForm[\'birthCity\'+$index].$invalid}\"><input type=text name=birthCity{{$index}} ng-model=data.birthCity only-alphabets required> <span class=highlight></span> <span class=bar></span><label>City<span class=\"req text-red\">*</span></label><span ng-show=\"taxResidencyForm[\'birthCity\'+$index].$dirty && taxResidencyForm[\'birthCity\'+$index].$invalid\"><span class=error-input ng-show=\"taxResidencyForm[\'birthCity\'+$index].$error.required\">{{FolioDetails.validateData.BIRTH_CITY}}</span></span></div><div class=\"input-select input-normal selectfield\" ng-class=\"{error:taxResidencyForm[\'taxIdType\'+$index].$dirty && taxResidencyForm[\'taxIdType\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType{{$index}} ng-model=data.taxIdType ng-options=\"taxid.value as taxid.description for taxid in FolioDetails.taxIdTypeList\" ng-init=\"data.taxIdType = data.taxIdType ? data.taxIdType : null\" required><option value=\"\" selected>Select Tax ID Type</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyForm[\'taxIdType\'+$index].$dirty && taxResidencyForm[\'taxIdType\'+$index].$invalid\"><span class=error-input ng-show=\"taxResidencyForm[\'taxIdType\'+$index].$error.required\">{{FolioDetails.validateData.TAX_ID_TYPE}}</span></span></div><div class=input-normal ng-class=\"{error:taxResidencyForm[\'taxIdNumber\'+$index].$dirty && taxResidencyForm[\'taxIdNumber\'+$index].$invalid}\"><input type=text name=taxIdNumber{{$index}} ng-model=data.taxIdNumber required> <span class=highlight></span> <span class=bar></span><label>Tax ID Number <span class=\"req text-red\">*</span></label><span ng-show=\"taxResidencyForm[\'taxIdNumber\'+$index].$dirty && taxResidencyForm[\'taxIdNumber\'+$index].$invalid\"><span class=error-input ng-show=\"taxResidencyForm[\'taxIdNumber\'+$index].$error.required\">{{FolioDetails.validateData.TAX_ID_NUMBER}}</span></span></div></div></div><div class=add-another-tax-res ng-show=\"!FolioDetails.payload.soleApplicantDetail.payTaxInIndia &&\nFolioDetails.payload.soleApplicantDetail.payOutsideIndiaAddresses.length < 3\" ng-click=FolioDetails.addNewResidencyFields()><a href=\"\" class=text-blue><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div><div class=\"col-md-12 review pd30 cursor-pointer\"><span class=\"pull-left previous\" ng-click=FolioDetails.back()><i class=back-icon></i>Previous</span> <span class=\"pull-right next\" ng-hide=taxResidencyForm.$invalid ng-click=FolioDetails.next()>Next<i class=next-icon></i></span></div></form>");
$templateCache.put("app/firstLogin/folioDetails/taxResidency/taxResidency.minor.html","<form autocomplete=off ng-init=FolioDetails.init() name=taxResidencyForm novalidate><h6>Guardian\'s FATCA and CRS information</h6><div class=fatca-info><div class=row><div class=col-md-6><div class=\"input-select input-normal selectfield\" ng-class=\"{error:taxResidencyForm.birthCountry.$dirty && taxResidencyForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=FolioDetails.payload.guardianDetail.fatca.birthCountry ng-options=\"country.countryCode as country.countryName for country in FolioDetails.countryList\" required ng-init=\"FolioDetails.payload.guardianDetail.fatca.birthCountry = FolioDetails.payload.guardianDetail.fatca.birthCountry ? FolioDetails.payload.guardianDetail.fatca.birthCountry :null\"><option value=\"\" selected>Country of Birth</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyForm.birthCountry.$dirty && taxResidencyForm.birthCountry.$invalid\"><span class=error-input ng-show=taxResidencyForm.birthCountry.$error.required>{{FolioDetails.validateData.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-6><div class=input-normal ng-class=\"{error:taxResidencyForm.birthCity.$dirty && taxResidencyForm.birthCity.$invalid}\"><input type=text name=birthCity ng-model=FolioDetails.payload.guardianDetail.fatca.birthPlace required> <span class=highlight></span> <span class=bar></span><label>City of Birth <span class=\"req text-red\">*</span></label><span ng-show=\"taxResidencyForm.birthCity.$dirty && taxResidencyForm.birthCity.$invalid\"><span class=error-input ng-show=taxResidencyForm.birthCity.$error.required>{{FolioDetails.validateData.BIRTH_CITY}}</span></span></div></div></div><div class=row><div class=col-md-6><div class=\"input-select input-normal selectfield\" ng-class=\"{error:taxResidencyForm.addressType.$dirty && taxResidencyForm.addressType.$invalid}\"><select class=\"browser-default custom-select\" name=addressType ng-model=FolioDetails.payload.guardianDetail.fatca.addressType ng-options=\"address.value as address.addressDescription for address in FolioDetails.addressTypeList\" required ng-init=\"FolioDetails.payload.guardianDetail.fatca.addressType = FolioDetails.payload.guardianDetail.fatca.addressType ? FolioDetails.payload.guardianDetail.fatca.addressType : null\"><option value=\"\" selected>Address Type</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyForm.addressType.$dirty && taxResidencyForm.addressType.$invalid\"><span class=error-input ng-show=taxResidencyForm.addressType.$error.required>{{FolioDetails.validateData.FATCA_ADDRESS_TYPE_REQUIRED}}</span></span></div></div></div></div><h6>Does the guardian pay or file tax other than India?</h6><div class=\"col-md-8 tax-res\"><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-model=FolioDetails.payload.guardianDetail.fatca.payTaxInIndia ng-value=false ng-click=FolioDetails.changePayTaxOutsideIndiaStatus(true)> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-model=FolioDetails.payload.guardianDetail.fatca.payTaxInIndia ng-value=true> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span><div ng-if=!FolioDetails.payload.guardianDetail.fatca.payTaxInIndia ng-repeat=\"data in FolioDetails.fatcaArray\"><div class=tax-res><p><strong>Tax Residency Country</strong> <span ng-show=\"$index > 0\" class=remove-item ng-click=FolioDetails.deleteTaxResidency($index)><i class=delete-red-icon></i></span></p><div class=\"input-select input-normal selectfield\" ng-class=\"{error:taxResidencyForm[\'birthCountry\'+$index].$dirty && taxResidencyForm[\'birthCountry\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry{{$index}} ng-model=data.taxPayingCountry ng-options=\"country.countryCode as country.countryName for country in FolioDetails.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" required ng-init=\"data.taxPayingCountry = data.taxPayingCountry ? data.taxPayingCountry :null\"><option value=\"\" selected>Name Of Country</option></select><span class=\"req text-red\">*</span> <span ng-show=\"taxResidencyForm[\'birthCountry\'+$index].$dirty && taxResidencyForm[\'birthCountry\'+$index].$invalid\"><span class=error-input ng-show=\"taxResidencyForm[\'birthCountry\'+$index].$error.required\">{{FolioDetails.validateData.SELECT_COUNTRY}}</span></span></div><div class=input-normal ng-class=\"{error:taxResidencyForm[\'birthCity\'+$index].$dirty && taxResidencyForm[\'birthCity\'+$index].$invalid}\"><input type=text name=birthCity{{$index}} ng-model=data.taxPayingCity only-alphabets required> <span class=highlight></span> <span class=bar></span><label>City of Birth <span class=\"req text-red\">*</span></label><span ng-show=\"taxResidencyForm[\'birthCity\'+$index].$dirty && taxResidencyForm[\'birthCity\'+$index].$invalid\"><span class=error-input ng-show=\"taxResidencyForm[\'birthCity\'+$index].$error.required\">{{FolioDetails.validateData.BIRTH_CITY}}</span></span></div><div class=\"input-select input-normal selectfield\" ng-class=\"{error:taxResidencyForm[\'taxIdType\'+$index].$dirty && taxResidencyForm[\'taxIdType\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType{{$index}} ng-model=data.taxId ng-options=\"taxid.value as taxid.description for taxid in FolioDetails.taxIdTypeList\" ng-init=\"data.taxId = data.taxId ? data.taxId :null\" required><option value=\"\" selected>Select Tax ID Type</option></select><span ng-show=\"taxResidencyForm[\'taxIdType\'+$index].$dirty && taxResidencyForm[\'taxIdType\'+$index].$invalid\"><span class=error-input ng-show=\"taxResidencyForm[\'taxIdType\'+$index].$error.required\">{{FolioDetails.validateData.TAX_ID_TYPE}}</span></span></div><div class=input-normal ng-class=\"{error:taxResidencyForm[\'taxIdNumber\'+$index].$dirty && taxResidencyForm[\'taxIdNumber\'+$index].$invalid}\"><input type=text name=taxIdNumber{{$index}} ng-model=data.taxIdNumber required> <span class=highlight></span> <span class=bar></span><label>Tax ID Number <span class=\"req text-red\">*</span></label><span ng-show=\"taxResidencyForm[\'taxIdNumber\'+$index].$dirty && taxResidencyForm[\'taxIdNumber\'+$index].$invalid\"><span class=error-input ng-show=\"taxResidencyForm[\'taxIdNumber\'+$index].$error.required\">{{FolioDetails.validateData.TAX_ID_NUMBER}}</span></span></div></div></div><div class=add-another-tax-res ng-show=\"!FolioDetails.payload.guardianDetail.fatca.payTaxInIndia &&\nFolioDetails.fatcaArray.length < 3\" ng-click=FolioDetails.addNewResidencyFields()><a href=\"\" class=text-blue><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div><div class=\"col-md-12 review pd30 cursor-pointer\"><span class=\"pull-left previous\" ng-click=FolioDetails.back()><i class=back-icon></i>Previous</span> <span ng-if=FolioDetails.payload.guardianDetail.fatca.payTaxInIndia class=\"pull-right next\" ng-hide=taxResidencyForm.$invalid ng-click=FolioDetails.next()>Next<i class=next-icon></i></span> <span ng-if=!FolioDetails.payload.guardianDetail.fatca.payTaxInIndia class=\"pull-right next\" ng-hide=taxResidencyForm.$invalid ng-click=FolioDetails.next()>Next<i class=next-icon></i></span></div></form>");
$templateCache.put("app/firstLogin/welcome/all-videos/all-videos.html","<login-header></login-header>{{FirstTimeLogin.text}}<div class=video-page ng-init=Welcome.init()><div class=container-fluid><div class=row><div class=\"col-md-12 video-header-action\"><div class=header-action><a href=/welcome><img src=assets/images/back-button.svg> Back to Welcome</a></div></div></div><div class=row><div class=\"col-md-12 video-header\"><div class=header-background><div class=background-title><label>Watch Videos</label></div></div></div></div><div class=container><div class=row><div ng-repeat=\"video in VideosController.videosList\" class={{video.class}}><div class=video-container ng-click=VideosController.playVideo(video.url)><div class=video-thumbnail><img src={{video.thumbnail}} alt=Videos></div><div class=video-meta><div class=video-play><img src=assets/images/play-button.svg></div><div class=video-title><div><img src=assets/images/play-icon.png alt=play> {{video.name}}</div></div></div></div></div></div></div></div></div><footer-login></footer-login>");
$templateCache.put("app/investor/addFolio/addNominee/nominee.html","<!--\n<form autocomplete=\"off\" class=\"nominee-section\" name=\"addNomineeForm\" ng-init=\"Nominee.init()\" novalidate>\n  <div class=\"form-content\">\n    <div class=\"nominee-title clearfix\">\n      <span class=\"pull-left details\"><strong>Nominee Details</strong></span>\n      <span class=\"pull-right checkbox\">\n            <input type=\"checkbox\" ng-model=\"Nominee.wantToAddNomineeLater\" ng-value=\"true\" ng-click=\"Nominee.checkAddNominee()\">\n            <span class=\"icon-checkbox\"></span>\n            <span class=\"checkbox-text\">Add Nominee Later</span>\n          </span>\n    </div>\n    &lt;!&ndash;<p><strong>Nominee Details</strong></p>&ndash;&gt;\n    <div ng-if=\"!Nominee.wantToAddNomineeLater\">\n      <div class=\"nominee-list\">\n        <table>\n          <thead>\n          <tr>\n            <th class=\"col-md-2\">&nbsp;</th>\n            <th class=\"col-md-4\">Name</th>\n            <th class=\"col-md-4\">Proportion <span class=\"text-warn\">(Should not be greater than 100%)</span></th>\n            <th class=\"col-md-4\">&nbsp;</th>\n          </tr>\n          </thead>\n          <tbody>\n          <tr ng-repeat=\"data in Nominee.payload.nominees\">\n            <td class=\"col-md-2\">{{Nominee.enum[$index]}} Nominee</td>\n            <td class=\"col-md-4\">\n              <input\n                type=\"text\"\n                name=\"nomineeName-{{$index}}\"\n                ng-model=\"data.nomineeName\"\n                only-alphabets\n                ng-maxlength=\"40\"\n                limit-to=\"40\"\n                required/>\n              <span class=\"req text-red\">*</span>\n              <span\n                ng-show=\"addNomineeForm[\'nomineeName-\'+$index].$dirty && addNomineeForm[\'nomineeName-\'+$index].$invalid\">\n                                                  <span class=\"error-input\"\n                                                        ng-show=\"addNomineeForm[\'nomineeName-\'+$index].$error.required\">\n                                                    {{Nominee.validateData.NOMINEE_NAME_REQUIRED}}</span>\n                                                        </span>\n            </td>\n            <td class=\"col-md-4\">\n              <div\n                ng-class=\"{error:addNomineeForm[\'proportion\'+$index].$dirty && addNomineeForm[\'proportion-\'+$index].$invalid}\">\n                <input type=\"text\" name=\"proportion-{{$index}}\" ng-model=\"data.percentage\" ng-blur=\"Nominee.calculatePercentage()\" maxlength=\"3\" is-number required>%\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <span class=\"req text-red\">*</span>\n                <span\n                  ng-show=\"addNomineeForm[\'proportion-\'+$index].$dirty && addNomineeForm[\'proportion-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'proportion-\'+$index].$error.required\">{{Nominee.validateData.NOMINEE_PROPORTION_REQUIRED}}</span>\n              </span>\n              </div>\n\n            </td>\n            <td class=\"col-md-4\" ng-if=\"Nominee.payload.nominees.length > 1\">\n              <i class=\"delete-red-icon\" ng-click=\"Nominee.deleteNominee($index)\"></i></td>\n          </tr>\n          </tbody>\n        </table>\n        &lt;!&ndash;<p><i class=\"info-icon\"></i></p>&ndash;&gt;\n      </div>\n      <div class=\"tab-container\">\n        <ul class=\"mobile-hide nav nav-tabs\">\n          <li ng-repeat=\"data in Nominee.payload.nominees\"\n              ng-click=\"Nominee.setActiveTab($index)\" ng-class=\"{\'active\':Nominee.activeTab===$index}\">\n            {{Nominee.enum[$index]}} Nominee Details\n          </li>\n        </ul>\n        <div class=\"pull-right add-another-nominee\"\n             ng-if=\"Nominee.showAddNominee\"\n             ng-click=\"Nominee.addNominee()\">\n          <a href=\"\" class=\"text-blue\"><strong><i class=\"plus-icon\"></i>Add Another Nominee</strong></a>\n        </div>\n      </div>\n      <div name=\"nominee-details tab-content\" ng-repeat=\"data in Nominee.payload.nominees\"\n           ng-show=\"Nominee.activeTab===$index\">\n        <div class=\"row\">\n          <div class=\"col-md-4\">\n            &lt;!&ndash;<div class=\"input-normal\">&ndash;&gt;\n            &lt;!&ndash;<input type=\"text\" required>&ndash;&gt;\n            &lt;!&ndash;<span class=\"highlight\"></span>&ndash;&gt;\n            &lt;!&ndash;<span class=\"bar\"></span>&ndash;&gt;\n            &lt;!&ndash;<label>Name</label>&ndash;&gt;\n            &lt;!&ndash;</div>&ndash;&gt;\n            <div class=\"nominee-name\">\n              &lt;!&ndash;<span>Name</span>&ndash;&gt;\n              <span ng-class=\"{\'empty\':data.nomineeName===\'\'}\" class=\"name\" ng-bind=\"data.nomineeName\"></span>\n              &lt;!&ndash; <span ng-if=\"!data.nomineeName\" style=\"margin-bottom: 39px;\"></span>&ndash;&gt;\n            </div>\n            <div class=\"input-normal\"\n                 ng-class=\"{error:folioCreation[\'dob-\'+$index].$dirty && folioCreation[\'dob-\'+$index].$invalid}\">\n              <input type=\"text\"\n                     name=\"dob-{{$index}}\"\n                     id=\"dob-{{$index}}\"\n                     date-calendar\n                     format=\"DD-MMM-YYYY\"\n                     viewmode=\'days\'\n                     showdefault=\"false\"\n                     date-default=\"data.dob\"\n                     maxdate=\"now\"\n                     data-min-date=\"Nominee.minDate\"\n                     data-on-date-change=\"Nominee.changeDob\"\n                     autocomplete=\"off\"\n                     data-enable=\"true\"\n                     required>\n              <span class=\"highlight\"></span>\n              <span class=\"bar\"></span>\n              <i class=\"calendar-input-icon\"></i>\n              &lt;!&ndash;<i class=\"times-icon\" ng-click=\"Nominee.resetNetWorthDate()\"></i>&ndash;&gt;\n              <label>DD-MMM-YYYY\n                <span class=\" req text-red\">*</span></label>\n              <span ng-show=\"folioCreation[\'dob-\'+$index].$dirty && folioCreation[\'dob-\'+$index].$invalid\">\n              <span class=\"error-input\" ng-show=\"folioCreation[\'dob-\'+$index].$error.required\">{{Nominee.validations.NET_WORTH_DATE}}</span>\n            </span>\n            </div>\n          </div>\n          <div class=\"col-md-4\">\n            <div class=\"nominee-name\" ng-class=\"{error:addNomineeForm.proportion.$invalid}\">\n              &lt;!&ndash;<span>Proportion in %</span>&ndash;&gt;\n              <span name=\"proportion\" ng-bind=\"data.percentage\"></span>\n            </div>\n            <div class=\"input-normal\" ng-class=\"{error:addNomineeForm[\'nomineeRelation-\'+$index].$dirty && addNomineeForm[\'nomineeRelation-\'+$index].$invalid}\">\n              <input type=\"text\"\n                     ng-model=\"data.nomineeRelation\"\n                     only-alphabets\n                     name=\"nomineeRelation-{{$index}}\"\n                     ng-maxlength=\"20\"\n                     limit-to=\"20\"\n                     capitalize required>\n              <span class=\"highlight\"></span>\n              <span class=\"bar\"></span>\n              <label>Relationship with Applicant <span class=\"req text-red\">*</span> </label>\n              <span\n                ng-show=\"addNomineeForm[\'nomineeRelation-\'+$index].$dirty && addNomineeForm[\'nomineeRelation-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'nomineeRelation-\'+$index].$error.required\">{{Nominee.validateData.NOMINEE_RELATIONSHIP}}</span>\n              </span>\n            </div>\n\n          </div>\n        </div>\n\n        <p>Address Details of <span ng-if=\"!Nominee.payload.nominees[$index].minor\">Nominee</span><span\n          ng-if=\"Nominee.payload.nominees[$index].minor\">Nominee’s Guardian</span></p>\n\n        <div ng-if=\"!data.minor\">\n          <div class=\"row\">\n            <div class=\"col-md-4\">\n              <div class=\"input-normal\"\n                   ng-class=\"{error:addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid}\">\n                <input type=\"text\"\n                       ng-model=\"data.nomineeAddress.addressLine1\"\n                       name=\"addressLine1-{{$index}}\"\n                       ng-maxlength=\"60\"\n                       limit-to=\"60\"\n                       capitalize required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>Address Line 1<span class=\"req text-red\">*</span></label>\n                <span\n                  ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$error.required\">{{Nominee.validateData.ADDRESS1_REQUIRED}}</span>\n              </span>\n              </div>\n            </div>\n            <div class=\"col-md-4\">\n              <div class=\"input-normal\">\n                <input type=\"text\"\n                       ng-model=\"data.nomineeAddress.addressLine2\"\n                       name=\"addressLine2-{{$index}}\"\n                       ng-maxlength=\"60\"\n                       limit-to=\"60\"\n                       capitalize>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>Address Line 2</label>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-4\">\n              <div class=\"selectfield\"\n                   ng-class=\"{error:addNomineeForm[\'residencyCountry-\'+$index].$dirty && addNomineeForm[\'residencyCountry-\'+$index].$invalid}\">\n                <select name=\"residencyCountry-{{$index}}\"\n                        ng-model=\"data.nomineeAddress.country\"\n                        ng-options=\"_country.countryCode as _country.countryName for _country in Nominee.countryList\"\n                        ng-init=\"data.nomineeAddress.country = data.nomineeAddress.country ? data.nomineeAddress.country : null\"\n                        required>\n                  <option value=\"\" selected>Name of country</option>\n                </select>\n                <label ng-if=\"data.nomineeAddress.country\">Name of country</label>\n                <span class=\"req text-red\">*</span>\n                <span\n                  ng-show=\"addNomineeForm[\'residencyCountry-\'+$index].$dirty && addNomineeForm[\'residencyCountry-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'residencyCountry-\'+$index].$error.required\">{{Nominee.validateData.SELECT_COUNTRY}}</span>\n              </span>\n              </div>\n            </div>\n\n            <div class=\"col-md-4\">\n              <div class=\"input-normal\"\n                   ng-class=\"{error:addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid}\">\n                <input type=\"text\"\n                       ng-model=\"data.nomineeAddress.city\"\n                       name=\"city-{{$index}}\"\n                       only-alphabets\n                       capitalize required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>City <span class=\"req text-red\">*</span></label>\n                <span\n                  ng-show=\"addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'city-\'+$index].$error.required\">{{Nominee.validateData.CITY}}</span>\n              </span>\n              </div>\n            </div>\n            &lt;!&ndash;<div class=\"col-md-4\">\n              <div class=\"input-normal mgt8\"\n                   ng-class=\"{error:addNomineeForm[\'state\'+$index].$dirty && addNomineeForm[\'state\'+$index].$invalid}\">\n                <input type=\"text\" ng-model=\"data.nomineeAddress.state\" name=\"state{{$index}}\" required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>State <span class=\"req text-red\">*</span></label>\n                <span\n                  ng-show=\"addNomineeForm[\'state\'+$index].$dirty && addNomineeForm[\'state\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'state\'+$index].$error.required\">{{Nominee.validateData.STATE_REQUIRED}}</span>\n              </span>\n              </div>\n            </div>&ndash;&gt;\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-4\">\n              <div class=\"input-normal\"\n                   ng-class=\"{error:addNomineeForm[\'pinCode-\'+$index].$dirty && addNomineeForm[\'pinCode-\'+$index].$invalid}\">\n                <input type=\"text\" ng-model=\"data.nomineeAddress.pinCode\"\n                       name=\"pinCode-{{$index}}\" is-number maxlength=\"6\" required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>Zip / Postal Code <span class=\"req text-red\">*</span></label>\n                <span\n                  ng-show=\"addNomineeForm[\'pinCode-\'+$index].$dirty && addNomineeForm[\'pinCode-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'pinCode-\'+$index].$error.required\">{{Nominee.validateData.PINCODE_REQUIRED}}</span>\n              </span>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"data.minor\">\n          <div class=\"row\">\n            <div class=\"col-md-4\">\n              <div class=\"input-normal\"\n                   ng-class=\"{error:addNomineeForm[\'guardianName-\'+$index].$dirty && addNomineeForm[\'guardianName-\'+$index].$invalid}\">\n                <input type=\"text\"\n                       ng-model=\"data.guardianName\"\n                       name=\"guardianName-{{$index}}\"\n                       ng-maxlength=\"40\"\n                       limit-to=\"40\"\n                       only-alphabets capitalize required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>Guardian Name<span class=\"req text-red\">*</span></label>\n                <span\n                  ng-show=\"addNomineeForm[\'guardianName-\'+$index].$dirty && addNomineeForm[\'guardianName-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'guardianName-\'+$index].$error.required\">{{Nominee.validateData.GUARDIAN_NAME}}</span>\n              </span>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-4\">\n              <div class=\"input-normal\"\n                   ng-class=\"{error:addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid}\">\n                <input type=\"text\" ng-model=\"data.guardianAddress.addressLine1\" name=\"addressLine1-{{$index}}\" capitalize required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>Address Line 1<span class=\"req text-red\">*</span></label>\n                <span\n                  ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$error.required\">{{Nominee.validateData.ADDRESS1_REQUIRED}}</span>\n              </span>\n              </span>\n              </div>\n            </div>\n            <div class=\"col-md-4\">\n              <div class=\"input-normal\">\n                <input type=\"text\" ng-model=\"data.guardianAddress.addressLine2\" name=\"addressLine2-{{$index}}\" capitalize>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>Address Line 2</label>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-4\">\n              <div class=\"selectfield\"\n                   ng-class=\"{error:addNomineeForm[\'residencyCountry-\'+$index].$dirty && addNomineeForm[\'residencyCountry-\'+$index].$invalid}\">\n                <select name=\"residencyCountry-{{$index}}\"\n                        ng-model=\"data.guardianAddress.country\"\n                        ng-options=\"_country.countryCode as _country.countryName for _country in Nominee.countryList\"\n                        ng-init=\"data.guardianAddress.country = data.guardianAddress.country ? data.guardianAddress.country : null\"\n                        required>\n                  <option value=\"\" selected>Name of country</option>\n                </select>\n                <label ng-if=\"data.guardianAddress.country\">Name of country</label>\n                <span class=\"req text-red\">*</span>\n                <span\n                  ng-show=\"addNomineeForm[\'residencyCountry-\'+$index].$dirty && addNomineeForm[\'residencyCountry-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'residencyCountry-\'+$index].$error.required\">{{Nominee.validateData.SELECT_COUNTRY}}</span>\n              </span>\n              </div>\n            </div>\n\n            <div class=\"col-md-4\">\n              <div class=\"input-normal\"\n                   ng-class=\"{error:addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid}\">\n                <input type=\"text\" ng-model=\"data.guardianAddress.city\" name=\"city-{{$index}}\" capitalize required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>City <span class=\"req text-red\">*</span></label>\n                <span\n                  ng-show=\"addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'city-\'+$index].$error.required\">{{Nominee.validateData.CITY}}</span>\n              </span>\n              </div>\n            </div>\n            &lt;!&ndash;<div class=\"col-md-4\">\n              <div class=\"input-normal\"\n                   ng-class=\"{error:addNomineeForm[\'state\'+$index].$dirty && addNomineeForm[\'state\'+$index].$invalid}\">\n                <input type=\"text\" ng-model=\"data.guardianAddress.state\" name=\"state{{$index}}\" required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>State <span class=\"req text-red\">*</span></label>\n                <span\n                  ng-show=\"addNomineeForm[\'state\'+$index].$dirty && addNomineeForm[\'state\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'state\'+$index].$error.required\">{{Nominee.validateData.STATE_REQUIRED}}</span>\n              </span>\n              </div>\n            </div>&ndash;&gt;\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-4\">\n              <div class=\"input-normal\"\n                   ng-class=\"{error:addNomineeForm[\'gpinCode-\'+$index].$dirty && addNomineeForm[\'gpinCode-\'+$index].$invalid}\">\n                <input type=\"text\" ng-model=\"data.guardianAddress.pinCode\" name=\"gpinCode-{{$index}}\" is-number maxlength=\"6\" required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>Zip / Postal Code <span class=\"req text-red\">*</span></label>\n                <span\n                  ng-show=\"addNomineeForm[\'gpinCode-\'+$index].$dirty && addNomineeForm[\'gpinCode-\'+$index].$invalid\">\n            <span class=\"error-input\" ng-show=\"addNomineeForm[\'gpinCode-\'+$index].$error.required\">{{Nominee.validateData.PINCODE_REQUIRED}}</span>\n              </span>\n              </div>\n            </div>\n          </div>\n        </div>\n        <hr/>\n      </div>\n    </div>\n    &lt;!&ndash;<hr />&ndash;&gt;\n    <div class=\"form-footer form-content\">&lt;!&ndash;{{addNomineeForm.$error |json  }}&ndash;&gt;\n      <div class=\"text-danger\" ng-bind=\"Nominee.validationMsg\"></div>\n      <a href=\"\" class=\"pull-left back\" ng-click=\"Nominee.back(\'fromBack\')\"><i class=\"arrow-blue-back-icon\"></i>Back</a>\n      <input type=\"button\" value=\"Save\" class=\"btn btn-secondary-action common-btn-padding\"\n             ng-click=\"Nominee.saveFolio()\">\n      <input type=\"submit\" class=\"btn btn-primary-action common-btn-padding\" ng-click=\"Nominee.continue()\"\n             value=\"Continue\" ng-disabled=\"addNomineeForm.$invalid\"/>\n    </div>\n  </div>\n</form>\n\n--><div ng-init=Nominee.init();><folio-nominee-details nominee-payload=Nominee.payload main-folio-parent=MainFolioParent first-flow=NO pan=Nominee.userPan dynamic-bank-details-note=Nominee.dynamicData></folio-nominee-details></div>");
$templateCache.put("app/investor/addFolio/bankDetails/bankDetails.html","<div ng-init=BankDetails.init()><folio-bank-details main-folio-parent=BankDetails.MainFolioParent is-sole-applicant-minor=BankDetails.isSoleApplicantMinor bank-payload=BankDetails.payload first-flow=NO bank-type-list=BankDetails.bankTypeList dynamic-bank-details-note=BankDetails.dynamicData></folio-bank-details></div>");
$templateCache.put("app/investor/addFolio/holdmode/holdmode.html","<!--\n\n&lt;!&ndash; Self Section Start&ndash;&gt;\n<div class=\"tab-content\" ng-init=\"HoldMode.init();\">\n\n  <button class=\"mobile-show mobile-accordion clearfix\">\n    <a data-toggle=\"tab\" href=\"#applicant-details\"><strong>Hold Mode Details</strong><i\n      class=\"accordian-arrow-down-icon pull-right\"></i></a>\n  </button>\n\n  <div id=\"applicant-details\" class=\"tab-pane fade in active\">\n\n\n    <form name=\"holdmodeForm\" novalidate>\n      <div class=\"form-content\">\n        <p><strong>Select mode of holding</strong></p>\n        <div class=\"radio-block \">\n              <div class=\"radio mg20\">\n                <input type=\"radio\"\n                       id=\"single\"\n                       name=\"holdmode\"\n                       ng-model=\"HoldMode.formData.holdmode\"\n                       ng-value=\"HoldMode.CONST.INVESTOR_HOLD_MODE.SINGLE\"\n                       ng-change=\"HoldMode.setHoldmode()\"\n                       required\n                />\n                <span class=\"check\"></span>\n              </div>\n          <label for=\"single\">Single</label>\n        </div>\n        <div class=\"radio-block\" style=\"display:  block;margin-top: 18px;\">\n              <div class=\"radio\">\n                <input type=\"radio\"\n                       id=\"aos\"\n                       name=\"holdmode\"\n                       ng-model=\"HoldMode.formData.holdmode\"\n                       ng-value=\"HoldMode.CONST.INVESTOR_HOLD_MODE.AOS\"\n                       ng-change=\"HoldMode.setHoldmode()\"\n                       required\n                />\n                <span class=\"check\"></span>\n              </div>\n          <label for=\"aos\">Anyone or Survivor</label>\n        </div>\n      </div>\n      <hr/>\n      <div class=\"form-footer form-content\">\n        <input type=\"button\" ng-disabled=\"holdmodeForm.$invalid\" class=\"btn btn-secondary-action common-btn-padding\" ng-click=\"HoldMode.saveFolio()\"\n               value=\"Save\"/>\n        <input type=\"submit\" class=\"btn btn-primary-action common-btn-padding\"\n               ng-disabled=\"holdmodeForm.$invalid\"\n               value=\"Continue\" ng-click=\"HoldMode.saveFolio()\"/>\n      </div>\n    </form>\n  </div>\n</div>\n\n\n--><div class=tab-content ng-init=HoldMode.init();><folio-hold-mode holders=HoldMode.formData main-folio-parent=MainFolioParent first-flow=NO></folio-hold-mode></div>");
$templateCache.put("app/investor/addFolio/jointHolders/jointHolders.html","<div ng-init=JointHolders.init()><folio-joint-holders joint-holders-payload=JointHolders.formData , main-folio-parent=MainFolioParent first-flow=NO></folio-joint-holders></div>");
$templateCache.put("app/investor/addFolio/review/review.html","<div><folio-review first-flow=NO></folio-review></div>");
$templateCache.put("app/investor/addFolio/soleApplicant/guardianDetails.html","<!--<investor-soleApplicant-tab control=\"GuardianDetails\"></investor-soleApplicant-tab>--><ul class=\"mobile-hide nav nav-tabs\"><li ui-sref-active=active><a ui-sref=main.folio.soleApplicant>Sole Applicant Details</a></li><li ui-sref-active=active ng-if=GuardianDetails.tabEnable.tabGuardianDetailShow><a ng-if=!GuardianDetails.tabEnable.tab4>Guardian Details</a> <a ui-sref=main.investors.add.guardianDetails ng-if=GuardianDetails.tabEnable.tab4><strong>Guardian Details</strong></a></li><li ui-sref-active=active><a ng-if=Nominee.tabEnable.tab2 ui-sref=main.folio.nominee href=javaScript:void(0);><i class=expand-icon></i>Add Nominee Information</a></li><!--<li ui-sref-active=\"active\">\n    <a ui-sref=\"main.investors.add.jointholders\" ng-if=\"GuardianDetails.tabEnable.tab3\">Add Joint Holder</a>\n  </li>--></ul><div class=tab-content ng-init=GuardianDetails.init();><!--<span class=\"add-joint-holder pull-right\" ng-if=\"!GuardianDetails.tabEnable.tab3\"\n        ng-click=\"GuardianDetails.addJointHolderTab()\">+ Add Joint Holder </span>--> <button class=\"mobile-show mobile-accordion clearfix\"><a data-bs-toggle=tab href=#applicant-details>Guardian\'s Details<i class=\"accordian-arrow-down-icon pull-right\"></i></a></button><div id=applicant-details class=\"tab-pane fade in active\"><form autocomplete=off name=GuardianDetails.gaurdianDetailsForm ng-submit=GuardianDetails.submitGuardianDetails() novalidate><div class=form-content><p><strong>Guardian\'s Details</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails.gaurdianDetailsForm.taxStatusCode.$dirty && GuardianDetails.gaurdianDetailsForm.taxStatusCode.$invalid}\"><!--<label>Tax Status</label>--><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.taxStatusCode ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in GuardianDetails.taxStatusList\" ng-init=\"GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.taxStatusCode = GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.taxStatusCode ? GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.taxStatusCode : null\" required><option value=\"\" selected>Tax Status</option></select><span ng-show=\"GuardianDetails.gaurdianDetailsForm.taxStatusCode.$dirty && GuardianDetails.gaurdianDetailsForm.taxStatusCode.$invalid\"><span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.taxStatusCode.$error.required ng-bind=GuardianDetails.validateData.TAX_STATUS></span> </span><span class=req>*</span></div><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$dirty\n                 && GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in GuardianDetails.incomeSlabList\" ng-init=\"GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome = GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome ? GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome : null\" ng-required=\"!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth)\n                      && !(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate)\"><option value=\"\" selected>Gross Annual Income</option></select><span ng-if=\"!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth)\n                      &&!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate)\" class=req>*</span> <span ng-show=\"GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$dirty\n                && GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$error.required ng-bind=GuardianDetails.validateData.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$error.number ng-bind=GuardianDetails.validateData.INVALID_AMOUNT></span> </span><span class=highlight></span> <span class=bar></span><label>Gross Annual Income</label></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails.gaurdianDetailsForm.occupation.$dirty && GuardianDetails.gaurdianDetailsForm.occupation.$invalid}\"><select class=\"browser-default custom-select\" name=occupation ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.occupation ng-options=\"_type.occupationCode as _type.occupationDescription for _type in GuardianDetails.occupationList\" ng-init=\"GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.occupation = GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.occupation ? GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.occupation : null\" required><option value=\"\" selected>Occupation</option></select><span ng-show=\"GuardianDetails.gaurdianDetailsForm.occupation.$dirty && GuardianDetails.gaurdianDetailsForm.occupation.$invalid\"><span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.occupation.$error.required ng-bind=GuardianDetails.validateData.OCCUPATION></span> </span><span class=req>*</span></div><div class=\"row net-worth-main\"><div class=\"col-md-6 net-worth-inner\"><div class=input-normal ng-class=\"{error:GuardianDetails.gaurdianDetailsForm.netWorth.$dirty\n                 && GuardianDetails.gaurdianDetailsForm.netWorth.$invalid}\"><input type=number ignore-mouse-wheel name=netWorth class=pd20 ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth ng-required=!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome)> <span ng-show=\"GuardianDetails.gaurdianDetailsForm.netWorth.$dirty && GuardianDetails.gaurdianDetailsForm.netWorth.$invalid\"><span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.netWorth.$error.number ng-bind=GuardianDetails.validateData.INVALID_AMOUNT></span> <span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.netWorth.$error.required ng-bind=GuardianDetails.validateData.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span><label>Net worth (in Rs.) <span ng-if=\"!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome)\n                ||(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate)\" class=req>*</span></label></div></div><div class=\"col-md-6 net-worth-inner\" ng-if=GuardianDetails.resetNetWorthDateFlag><div class=input-normal ng-class=\"{error : GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth\n                   && !GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate\n                   }\"><input type=text name=netWorthDate id=guardianDetailsNetWorthDate date-calendar date-default=GuardianDetails.defaultDateNetWorthDate showdefault=\"{{\'\'+!!GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate}}\" format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=GuardianDetails.minDate data-on-date-change=GuardianDetails.changeNetWorthDate required readonly> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i> <i class=times-icon ng-click=GuardianDetails.resetNetWorthDateG();></i><label>As on DD-MMM-YYYY <span ng-if=\"!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome)\n                ||(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth)\" class=req>*</span></label></div></div></div></div></div></div><hr><div class=form-content><p><strong>Politically Exposed Person (PEP) Status</strong></p><div class=radio-block><span class=radio><input type=radio id=politicalStatus1 name=politicalStatus ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.politicalStatus ng-value=GuardianDetails.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=politicalStatus1>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.politicalStatus ng-value=GuardianDetails.CONST.INVESTOR_POLITICAL_STATUS.RELATED> <span class=check></span></span><label for=politicalStatus2>Investor is related to politically exposed person.<span class=req>*</span></label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus3 name=politicalStatus ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.politicalStatus ng-value=GuardianDetails.CONST.INVESTOR_POLITICAL_STATUS.NONE> <span class=check></span></span><label for=politicalStatus3>Not applicable<span class=req>*</span></label></div></div><hr><div class=form-content><p><strong>FATCA and CRS information</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails.gaurdianDetailsForm.fatcaAddressType.$dirty && GuardianDetails.gaurdianDetailsForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.fatcaAddressType ng-options=\"_type.value as _type.addressDescription for _type in GuardianDetails.addressDescriptions\" ng-init=\"GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.fatcaAddressType = GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.fatcaAddressType ? GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.fatcaAddressType : null\" required><option value=\"\" selected>Address Type</option></select><span ng-show=\"GuardianDetails.gaurdianDetailsForm.fatcaAddressType.$dirty && GuardianDetails.gaurdianDetailsForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.fatcaAddressType.$error.required ng-bind=GuardianDetails.validateData.ADDRESS_TYPE></span> </span><span class=req>*</span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails.birthCountry.$dirty && GuardianDetails.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.birthCountry ng-options=\"country.countryName as country.countryName for country in GuardianDetails.countryList\" ng-init=\"GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.birthCountry = GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.birthCountry ? GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.birthCountry : null\" required><option value=\"\" selected>Country of Birth</option></select><span class=req>*</span> <span ng-show=\"GuardianDetails.birthCountry.$dirty && GuardianDetails.birthCountry.$invalid\"><span class=error-input ng-show=GuardianDetails.birthCountry.$error.required>{{GuardianDetails.validations.COUNTRY}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less\" ng-class=\"{error:GuardianDetails.birthCity.$dirty && GuardianDetails.birthCity.$invalid}\"><input type=text name=birthCity ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.birthCity required capitalize> <span class=highlight></span> <span class=bar></span><label>City of Birth<span class=req>*</span></label></div></div></div></div><div class=\"row tax-res\"></div><div class=\"form-content inves-pay\"><p><strong>Does the investor pay or file tax other than India?</strong></p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-change=GuardianDetails.fileTaxActionGuardianDetails() ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payTaxInIndia ng-value=true> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-change=GuardianDetails.fileTaxActionGuardianDetails() ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span><div ng-show=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payTaxInIndia><div class=\"row tax-res\" ng-repeat=\"data in GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\"><p><strong>Tax Residency Country</strong> <span ng-show=\"$index>0\" class=remove-item ng-click=GuardianDetails.deleteTaxResidencyGD($index)><i class=delete-icon></i></span></p><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails[\'birthCountry-\'+$index].$dirty && GuardianDetailsGuardianDetails[\'birthCountry-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName ng-options=\"country.countryName as country.countryName for country in GuardianDetails.countryList|removeCountry:\'india\'\" ng-init=\"GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName = GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName ? GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName : null\" required><option value=\"\" selected>Name of Country</option></select><span class=req>*</span> <span ng-show=\"GuardianDetails[\'birthCountry-\'+$index].$dirty && GuardianDetails[\'birthCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"GuardianDetails[\'birthCountry-\'+$index].$error.required\">{{GuardianDetails.validations.COUNTRY}}</span></span></div><!--\n              <div class=\"input-select input-normal\"\n              >\n                <input type=\"text\" name=\"countryName-{{$index}}\"\n                       ng-model=\"GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName\"\n                >\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>Name of country<span class=\"req\">*</span></label>\n              </div>--><div class=\"input-select input-normal\"><input type=text name=taxIdType-{{$index}} ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdType capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID Type<span class=req>*</span></label></div></div><div class=col-md-4><div class=\"input-select input-normal\"><input type=text name=taxIdNumber-{{$index}} ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdNumber capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=req>*</span></label></div></div><div ng-show=\"GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName &&\nGuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdNumber &&\nGuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdType\"><a ng-show=\"(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses.length)*1<4 &&\n(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses.length)*1 == ($index*1+1)\" href=\"\" class=text-blue ng-click=GuardianDetails.addMoreTaxResidencyGD()><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div></div></div><hr><div class=\"form-footer form-content\"><button class=\"btn btn-negative-action\" ng-click=GuardianDetails.cancelTransaction()>Cancel</button> <button class=\"btn btn-primary-action\" ng-disabled=\"GuardianDetails.gaurdianDetailsForm.$invalid\n              ||(!GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate && !GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome)\n              ||(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth && !GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate)\n            \">Continue</button></div></form></div></div>");
$templateCache.put("app/investor/addFolio/soleApplicant/sole.applicant.html","<div class=tab-content ng-init=SoleDetails.init();><!--\n  <button class=\"mobile-show mobile-accordion clearfix\">\n    <a data-toggle=\"tab\" href=\"#applicant-details\"><strong>Sole Applicant Details</strong><i\n      class=\"accordian-arrow-down-icon pull-right\"></i></a>\n  </button>\n  <div id=\"applicant-details\" class=\"tab-pane fade in active\">\n    <form name=\"soleApplicantForm\" novalidate>\n      <div class=\"form-content pdt0\">\n        <div class=\"form-group\">\n          <span><strong>Folio Creation:</strong></span>\n          <span class=\"radio-block\">\n          <span class=\"radio\">\n            <input type=\"radio\" id=\"selefId\" name=\"isMinor\" ng-model=\"SoleDetails.formData.minor\"\n                   ng-change=\"SoleDetails.setMinorFlag()\"\n                   ng-value=\"false\"/>\n            <span class=\"check\"></span>\n          </span>\n          <label for=\"selefId\">Self</label>\n        </span>\n          <span class=\"radio-block\" ng-class=\"{\'anything-disabled\':(SoleDetails.formData.holdmode!==SoleDetails.pattern.INVESTOR_HOLD_MODE.SINGLE)}\">\n          <span class=\"radio\">\n            <input type=\"radio\" id=\"monorId\" name=\"isMinor\" ng-model=\"SoleDetails.formData.minor\"\n                   ng-change=\"SoleDetails.setMinorFlag()\"\n                   ng-value=\"true\"\n                   ng-disabled=\"SoleDetails.formData.holdmode !==SoleDetails.pattern.INVESTOR_HOLD_MODE.SINGLE\"/>\n            <span class=\"check\"></span>\n          </span>\n          <label for=\"monorId\">Minor</label>\n        </span>\n        </div>\n        <div name=\"minor-fields\" ng-if=\"SoleDetails.formData.minor\" class=\"folio-create\">\n          <div class=\"row\">\n            <div class=\"form-label mr20 mrb20 col-md-12\">Minor’s Details</div>\n            <div class=\"col-md-2\">\n              <div class=\"selectfield\"\n                   ng-class=\"{error:soleApplicantForm.gender.$dirty && soleApplicantForm.gender.$invalid}\">\n                <select class=\"browser-default custom-select\" name=\"gender\"\n                        ng-model=\"SoleDetails.formData.gender\"\n                        ng-options=\"data.value as data.name for data in SoleDetails.genderList\"\n                        ng-init=\"SoleDetails.formData.gender = SoleDetails.formData.gender ? SoleDetails.formData.gender : null\"\n                        required>\n                  <option value=\"\" selected>Gender</option>\n                </select>\n                <label ng-if=\"SoleDetails.formData.gender\">Gender</label>\n                <span\n                  ng-show=\"soleApplicantForm.gender.$dirty && soleApplicantForm.gender.$invalid\">\n                    <span class=\"error-input\" ng-show=\"soleApplicantForm.gender.$error.required\"\n                          ng-bind=\"SoleDetails.validations.GENDER\"></span>\n                </span>\n                <span class=\"req text-red\">*</span>\n              </div>\n            </div>\n            <div class=\"col-md-3 col-md-offset-1\">\n              <div class=\"input-normal\"\n                   ng-class=\"{error:soleApplicantForm.minorName.$dirty && soleApplicantForm.minorName.$invalid}\">\n                <input type=\"text\" name=\"minorName\" ng-model=\"SoleDetails.formData.firstName\"\n                       maxlength=\"60\" ng-pattern=\"SoleDetails.pattern.name_regex\" required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>Minor\'s Name<span class=\"req text-red\">*</span></label>\n              </div>\n              <span ng-show=\"soleApplicantForm.minorName.$dirty && soleApplicantForm.minorName.$invalid\">\n              <span class=\"error-input error\" ng-show=\"soleApplicantForm.minorName.$error.required\"\n                    ng-bind=\"SoleDetails.validations.MINOR_NAME\"></span>\n              <span class=\"error-input error\" ng-show=\"soleApplicantForm.minorName.$error.pattern && !soleApplicantForm.minorName.$error.required\"\n                    ng-bind=\"SoleDetails.validations.MINOR_VALID_NAME\"></span>\n            </span>\n            </div>\n            <div class=\"col-md-3\">\n\n              <div class=\"input-normal\" style=\"position: relative;\"\n                   ng-class=\"{error:soleApplicantForm.dob.$dirty && soleApplicantForm.dob.$invalid}\">\n                <input type=\"text\"\n                       name=\"dob\"\n                       date-calendar\n                       format=\"DD-MMM-YYYY\"\n                       viewmode=\'days\'\n                       showdefault=\"{{\'\'+!!SoleDetails.formData.dateOfBirth}}\"\n                       date-default=\"SoleDetails.defaultMinorDob\"\n                       maxdate=\"now\"\n                       data-min-date=\"SoleDetails.minDateMinor\"\n                       data-on-date-change=\"SoleDetails.changeMinorDob\"\n                       autocomplete=\"off\"\n                       ng-model=\"SoleDetails.formData.dateOfBirth\"\n                       data-enable=\"true\"\n                       required>\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <i class=\"calendar-input-icon\"></i>\n                &lt;!&ndash;<i class=\"times-icon\" ng-click=\"Nominee.resetNetWorthDate()\"></i>&ndash;&gt;\n                <label>DD-MMM-YYYY\n                  <span class=\" req text-red\">*</span></label>\n                <span ng-show=\"soleApplicantForm.dob.$dirty && soleApplicantForm.dob.$invalid\">\n              <span class=\"error-input\" ng-show=\"soleApplicantForm.dob.$error.required\">{{SoleDetails.validations.MINOR_DOB}}</span>\n            </span>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-4\">\n              <span class=\"form-label\">Upload Minor\'s Age Proof\n              <i class=\"info-icon base-tooltip\" tooltip data-html=\"true\" data-toggle=\"tooltip\"\n                 data-placement=\"{{Main.tooltipClass}}\"\n                 title=\"<u style=\'font-size:14px;font-weight:bold\'>View List of Valid DOB Proof</u></br>\nMax file size should be less than or equal to 2 MB.</br>File format should be Png, pdf, jpg and jpeg extension.\"></i>\n              </span>\n              <div class=\"upload-proof\">\n                &lt;!&ndash;<input type=\"file\" name=\"pic\" accept=\"image/*\">&ndash;&gt;\n                <input type=\"file\" name=\"pic\" id=\"ageProof\" accept=\"image/*\"\n                       file-model-profile=\"SoleDetails.minorAgeProof\" style=\"width:45%;\"\n                       upload=\"SoleDetails.uploadMinorDobFile(file)\" ng-model=\"SoleDetails.minorAgeProof\">\n                <div class=\"file-upload\">\n                  <button>Choose File</button>\n                  <span ng-if=\"SoleDetails.chooseAFile\">No File Chosen</span>\n                  <span ng-click=\"SoleDetails.openUploadedDoc(SoleDetails.formData.minorAgeProof)\">{{SoleDetails.ageProofDocUrl}}</span></div>\n                <span class=\"req\">*</span>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\" ng-if=\"SoleDetails.formData.minor\">\n            <div class=\"col-md-3\">\n              <p class=\"pdt10\"><strong>Tax Status</strong></p>\n              <div class=\"selectfield\"\n                   ng-class=\"{error:soleApplicantForm.taxStatusCode.$dirty && soleApplicantForm.taxStatusCode.$invalid}\">\n                &lt;!&ndash;<label>Tax Status</label>&ndash;&gt;\n                <select class=\"browser-default custom-select\" name=\"taxStatusCode\"\n                        ng-model=\"SoleDetails.formData.taxStatusCode\"\n                        ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in SoleDetails.taxStatusList\"\n                        ng-init=\"SoleDetails.formData.taxStatusCode = SoleDetails.formData.taxStatusCode ? SoleDetails.formData.taxStatusCode : null\"\n                        required>\n                  <option value=\"\" selected>Tax Status</option>\n                </select>\n                <label ng-if=\"SoleDetails.formData.taxStatusCode\">Tax Status</label>\n                <span\n                  ng-show=\"soleApplicantForm.taxStatusCode.$dirty && soleApplicantForm.taxStatusCode.$invalid\">\n                    <span class=\"error-input\" ng-show=\"soleApplicantForm.taxStatusCode.$error.required\"\n                          ng-bind=\"SoleDetails.validations.TAX_STATUS\"></span>\n                </span>\n                <span class=\"req text-red\">*</span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <hr ng-if=\"SoleDetails.formData.minor\"/>\n      <div class=\"form-content\">\n        <div ng-if=\"SoleDetails.formData.minor\">\n          <div class=\"form-label mrb20\">Guardian: {{SoleDetails.guardianName}}</div>\n          <div class=\"row\">\n            <div class=\"col-md-3\">\n              <div class=\" selectfield\"\n                   ng-class=\"{error:soleApplicantForm.relationship.$dirty && soleApplicantForm.relationship.$invalid}\">\n                <select class=\"browser-default custom-select\" name=\"relationship\"\n                        ng-model=\"SoleDetails.formData.relationship\"\n                        ng-options=\"_type.value as _type.name for _type in SoleDetails.relationshipList\"\n                        ng-init=\"SoleDetails.formData.relationship = SoleDetails.formData.relationship ? SoleDetails.formData.relationship : null\"\n                        required>\n                  <option value=\"\" selected>Relationship With Minor</option>\n                </select>\n                <span class=\"req text-red\">*</span>\n                <label ng-if=\"SoleDetails.formData.relationship\">Relationship With Minor</label>\n                <span\n                  ng-show=\"soleApplicantForm.relationship.$dirty && soleApplicantForm.relationship.$invalid\">\n              <span class=\"error-input\" ng-show=\"soleApplicantForm.relationship.$error.required\">{{SoleDetails.validations.NOMINEE_RELATIONSHIP}}</span>\n            </span>\n              </div>\n            </div>\n            <div class=\"col-md-4\">\n            <span class=\"form-label\">Upload Relationship Proof\n\n               <i class=\"info-icon base-tooltip\" tooltip data-html=\"true\" data-toggle=\"tooltip\"\n                  data-placement=\"{{Main.tooltipClass}}\"\n                  title=\"<u style=\'font-size:14px;font-weight:bold\'>View List of Relationship Proof</u></br>\nMax file size should be less than or equal to 2 MB. </br>File format should be Png, pdf, jpg and jpeg extension.\"></i>\n\n            </span>\n              <div class=\"upload-proof\">\n                &lt;!&ndash;<input type=\"file\" name=\"pic\" accept=\"image/*\">&ndash;&gt;\n                <input type=\"file\" name=\"minorRelationshipFile\" id=\"minorRelationshipFile\" accept=\"image/*\"\n                       file-model-profile=\"SoleDetails.minorRelationshipFile\" style=\"width:45%;\"\n                       upload=\"SoleDetails.uploadMinorRelationshipFile(file)\"\n                       ng-model=\"SoleDetails.minorRelationshipFile\">\n                <div class=\"file-upload\">\n                  <button>Choose File</button>\n                  <span ng-if=\"SoleDetails.chooseARelationshipFile\">No File Chosen</span>\n                  <span ng-click=\"SoleDetails.openUploadedDoc(SoleDetails.formData.minorRelationshipProof)\">{{SoleDetails.relationshipDocUrl}}</span></div>\n                <span class=\"req\">*</span>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\" ng-if=\"!SoleDetails.formData.minor\">\n        <div class=\"col-md-3\">\n          <p class=\"pdt10\"><strong>Tax Status</strong></p>\n          <div class=\"selectfield\"\n               ng-class=\"{error:soleApplicantForm.taxStatusCode.$dirty && soleApplicantForm.taxStatusCode.$invalid}\">\n            &lt;!&ndash;<label>Tax Status</label>&ndash;&gt;\n            <select class=\"browser-default custom-select\" name=\"taxStatusCode\"\n                    ng-model=\"SoleDetails.formData.taxStatusCode\"\n                    ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in SoleDetails.taxStatusList\"\n                    ng-change=\"SoleDetails.changedTaxStatus()\"\n                    ng-init=\"SoleDetails.formData.taxStatusCode = SoleDetails.formData.taxStatusCode ? SoleDetails.formData.taxStatusCode : null\"\n                    required>\n              <option value=\"\" selected>Tax Status</option>\n            </select>\n            <label ng-if=\"SoleDetails.formData.taxStatusCode\">Tax Status</label>\n            <span\n              ng-show=\"soleApplicantForm.taxStatusCode.$dirty && soleApplicantForm.taxStatusCode.$invalid\">\n                    <span class=\"error-input\" ng-show=\"soleApplicantForm.taxStatusCode.$error.required\"\n                          ng-bind=\"SoleDetails.validations.TAX_STATUS\"></span>\n                </span>\n            <span class=\"req text-red\">*</span>\n          </div>\n        </div>\n        </div>\n        <p class=\"pdt10\"><strong><span ng-if=\"SoleDetails.formData.minor\">Guardian\'s </span>Income Details</strong></p>\n        <div class=\"row\">\n          <div class=\"col-md-3\">\n            <div class=\"selectfield\"\n                 ng-class=\"{error:soleApplicantForm.occupation.$dirty && soleApplicantForm.occupation.$invalid}\">\n              <select class=\"browser-default custom-select\" name=\"occupation\"\n                      ng-model=\"SoleDetails.formData.occupation\"\n                      ng-options=\"_type.occupationCode as _type.occupationDescription for _type in SoleDetails.occupationList\"\n                      ng-change=\"SoleDetails.setOccuValidation()\"\n                      ng-init=\"SoleDetails.formData.occupation = SoleDetails.formData.occupation ? SoleDetails.formData.occupation : null\"\n                      required>\n                <option value=\"\" selected>Occupation</option>\n              </select>\n              <label ng-if=\"SoleDetails.formData.occupation\">Occupation</label>\n              <span\n                ng-show=\"soleApplicantForm.occupation.$dirty && soleApplicantForm.occupation.$invalid\">\n                <span class=\"error-input\" ng-show=\"soleApplicantForm.occupation.$error.required\"\n                      ng-bind=\"SoleDetails.validations.OCCUPATION\"></span>\n              </span>\n              <span class=\"req text-red\">*</span>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-3\">\n            <div class=\"selectfield\"\n                 ng-class=\"{error:soleApplicantForm.grossAnnualIncome.$dirty\n                 && soleApplicantForm.grossAnnualIncome.$invalid}\">\n\n              <select class=\"browser-default custom-select\" name=\"grossAnnualIncome\"\n                      ng-click=\"SoleDetails.setOptionalEmpty(\'GrossAnnualIncome\')\"\n                      ng-model=\"SoleDetails.formData.grossAnnualIncome\"\n                      ng-options=\"_type.incomeCode as _type.incomeDescription for _type in SoleDetails.incomeSlabList\"\n                      ng-required=\"!(SoleDetails.formData.netWorth)\n                      &&!(SoleDetails.formData.netWorthDate)\"\n                      ng-init=\"SoleDetails.formData.grossAnnualIncome = SoleDetails.formData.grossAnnualIncome ? SoleDetails.formData.grossAnnualIncome : null\"\n                      ng-disabled=\"SoleDetails.formData.netWorth\"\n                      ng-class=\"{\'selectfield-disabled\':SoleDetails.formData.netWorth}\">\n                <option value=\"\" selected>Gross Annual Income</option>\n              </select>\n              <label ng-if=\"SoleDetails.formData.grossAnnualIncome\">Gross Annual Income</label>\n              <span\n                ng-show=\"soleApplicantForm.grossAnnualIncome.$dirty && soleApplicantForm.grossAnnualIncome.$invalid\">\n                    <span class=\"error-input\" ng-show=\"soleApplicantForm.grossAnnualIncome.$error.required\"\n                          ng-bind=\"SoleDetails.validations.GROSS_ANNUAL_INCOME\"></span>\n                <span class=\"error-input\" ng-show=\"soleApplicantForm.grossAnnualIncome.$error.number\"\n                      ng-bind=\"SoleDetails.validations.INVALID_AMOUNT\"></span>\n                </span>\n              <span ng-if=\"!(SoleDetails.formData.netWorth)\n                      &&!(SoleDetails.formData.netWorthDate)\"\n                    class=\"req text-red\">*</span>\n              <span class=\"highlight\"></span>\n              <span class=\"bar\"></span>\n            </div>\n          </div>\n          <div class=\"or-part col-md-1\" style=\"position: relative;top: 30px;text-align: center;\">OR<span\n            style=\"color:#d82018\"> *</span></div>\n          <div class=\"col-md-3\">\n            <div class=\"input-normal mgt13\"\n                 ng-class=\"{error:soleApplicantForm.netWorth.$dirty\n                 && soleApplicantForm.netWorth.$invalid}\">\n              <input type=\"number\" ignore-mouse-wheel name=\"netWorth\" class=\"pd20\"\n                     ng-model=\"SoleDetails.formData.netWorth\"\n                     ng-required=\"!SoleDetails.formData.grossAnnualIncome\"\n                     ng-disabled=\"SoleDetails.formData.grossAnnualIncome\"\n                     ng-maxlength=\"15\" limit-to=\"15\"\n                     onkeyup=\"NumToWord(this.value,\'DisplayWordsTaxAmt\');\">\n              <span\n                ng-show=\"soleApplicantForm.netWorth.$dirty && soleApplicantForm.netWorth.$invalid\">\n                <span class=\"error-input\"\n                      ng-show=\"soleApplicantForm.netWorth.$error.number\"\n                      ng-bind=\"SoleDetails.validations.INVALID_AMOUNT\"></span>\n                  <span class=\"error-input\"\n                        ng-show=\"soleApplicantForm.netWorth.$error.required\"\n                        ng-bind=\"SoleDetails.validations.NET_WORTH\"></span>\n              </span>\n              <span class=\"highlight\"></span>\n              <span class=\"bar\"></span>\n              <i class=\"rupee-input-icon\"></i>\n              <label>Net worth (in Rs.)\n                <span ng-if=\"!(SoleDetails.formData.grossAnnualIncome)\n                ||(SoleDetails.formData.netWorthDate)\"\n                      class=\"req text-red\">*</span>\n              </label>\n            </div>\n            <div class=\"form-group\">\n              <label id=\"DisplayWordsTaxAmt\">{{SoleDetails.amountInWords}} (In Words)</label>\n            </div>\n\n          </div>\n          <div class=\"col-md-3\">\n            <div class=\"input-select input-normal date date-picker mgt13\"\n                 ng-class=\"{error : SoleDetails.formData.netWorth\n                   && !SoleDetails.formData.netWorthDate\n                   }\">\n\n              <input type=\"text\"\n                     name=\"netWorthDate\"\n                     date-calendar\n                     format=\"DD-MMM-YYYY\"\n                     viewmode=\'days\'\n                     showdefault=\"{{\'\'+!!SoleDetails.formData.netWorthDate}}\"\n                     date-default=\"SoleDetails.defaultDob\"\n                     maxdate=\"now\"\n                     data-min-date=\"SoleDetails.minDate\"\n                     data-on-date-change=\"SoleDetails.changeStartDate\"\n                     autocomplete=\"off\"\n                     ng-model=\"SoleDetails.formData.netWorthDate\"\n                     ng-required=\"!SoleDetails.formData.grossAnnualIncome\"\n                     ng-disabled=\"SoleDetails.formData.grossAnnualIncome\">\n\n              <span class=\"highlight\"></span>\n              <span class=\"bar\"></span>\n              <i class=\"calendar-input-icon\"></i>\n              &lt;!&ndash;<i class=\"times-icon\" ng-click=\"SoleDetails.resetNetWorthDate()\"></i>&ndash;&gt;\n              <label>As on DD-MMM-YYYY\n                <span ng-if=\"!(SoleDetails.formData.grossAnnualIncome)\n                ||(SoleDetails.formData.netWorth)\"\n                      class=\"req text-red\">*</span>\n              </label>\n              <span ng-show=\"soleApplicantForm.netWorthDate.$dirty && soleApplicantForm.netWorthDate.$invalid\">\n              <span class=\"error-input\" ng-show=\"soleApplicantForm.netWorthDate.$error.required\">{{SoleDetails.validations.NET_WORTH_DATE}}</span>\n            </span>\n            </div>\n            <span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span>\n\n          </div>\n\n        </div>\n      </div>\n      <div class=\"form-content less-pad political-exposed\">\n        <p><strong><span ng-if=\"SoleDetails.formData.minor\">Guardian\'s </span>Politically Exposed Person (PEP)\n          Status</strong></p>\n        <div class=\"radio-block\">\n              <span class=\"radio\">\n                <input type=\"radio\" id=\"politicalStatus1\" name=\"politicalStatus\"\n                       ng-model=\"SoleDetails.formData.politicalStatus\"\n                       ng-value=\"SoleDetails.POLITICAL_STATUS.POLITICAL\"/>\n                <span class=\"check\"></span>\n              </span>\n          <label for=\"politicalStatus1\">Investor is politically exposed person.</label>\n        </div>\n        <div class=\"radio-block\">\n              <span class=\"radio\">\n                <input type=\"radio\" id=\"politicalStatus2\" name=\"politicalStatus\"\n                       ng-model=\"SoleDetails.formData.politicalStatus\"\n                       ng-value=\"SoleDetails.POLITICAL_STATUS.RELATED\"/>\n                <span class=\"check\"></span>\n              </span>\n          <label for=\"politicalStatus2\">Investor is related to politically exposed person.</label>\n        </div>\n        <div class=\"radio-block\">\n              <span class=\"radio\">\n                <input type=\"radio\" id=\"politicalStatus3\" name=\"politicalStatus\"\n                       ng-model=\"SoleDetails.formData.politicalStatus\"\n                       ng-value=\"SoleDetails.POLITICAL_STATUS.NONE\"/>\n                <span class=\"check\"></span>\n              </span>\n          <label for=\"politicalStatus3\">Not Applicable</label>\n        </div>\n      </div>\n      <div class=\"form-content less-pad\">\n        <p class=\"nomargin\"><strong><span ng-if=\"SoleDetails.formData.minor\">Guardian\'s </span>FATCA and CRS information</strong>\n\n          <i ng-if=\"SoleDetails.formData.minor\" class=\"info-icon base-tooltip\" tooltip data-html=\"true\"\n             data-toggle=\"tooltip\"\n             data-placement=\"{{Main.tooltipClass}}\"\n             title=\"The below information is required for all applicants(s) / guardians. Is also applicant(s) / guardian’s country of birth / citizenship / Nationality / TAX residency other than India?\"></i>\n\n        </p>\n        <div class=\"row pdt10\">\n          <div class=\"col-md-3\">\n            <div class=\" selectfield\"\n                 ng-class=\"{error:soleApplicantForm.birthCountry.$dirty && soleApplicantForm.birthCountry.$invalid}\">\n              <select class=\"browser-default custom-select\" name=\"birthCountry\"\n                      ng-model=\"SoleDetails.formData.birthCountry\"\n                      ng-options=\"country.countryCode as country.countryName for country in SoleDetails.countryList\"\n                      ng-init=\"SoleDetails.formData.birthCountry = SoleDetails.formData.birthCountry ? SoleDetails.formData.birthCountry : null\"\n                      required>\n                <option value=\"\" selected>Country of Birth</option>\n              </select>\n              <span class=\"req text-red\">*</span>\n              <span\n                ng-show=\"soleApplicantForm.birthCountry.$dirty && soleApplicantForm.birthCountry.$invalid\">\n              <span class=\"error-input\" ng-show=\"soleApplicantForm.birthCountry.$error.required\">{{SoleDetails.validations.COUNTRY}}</span>\n            </span>\n            </div>\n          </div>\n\n\n          <div class=\"col-md-3\">\n            <div class=\"input-normal cityBirth\"\n                 ng-class=\"{error:soleApplicantForm.birthCity.$dirty && soleApplicantForm.birthCity.$invalid}\">\n              <input type=\"text\" name=\"birthCity\" only-alphabets\n                     ng-model=\"SoleDetails.formData.birthCity\" required>\n              <span class=\"highlight\"></span>\n              <span class=\"bar\"></span>\n              <label>City of Birth <span class=\"req text-red\">*</span></label>\n              <span ng-show=\"soleApplicantForm.birthCity.$dirty && soleApplicantForm.birthCity.$invalid\">\n                <span class=\"error-input\" ng-show=\"soleApplicantForm.birthCity.$error.required\">{{SoleDetails.validations.BIRTH_CITY}}</span>\n              </span>\n            </div>\n          </div>\n\n        </div>\n        <div class=\"row pdt10\">\n          <div class=\"col-md-3\">\n            <div class=\"selectfield\"\n                 ng-class=\"{error:soleApplicantForm.fatcaAddressType.$dirty && soleApplicantForm.fatcaAddressType.$invalid}\">\n\n              <select class=\"browser-default custom-select\" name=\"fatcaAddressType\"\n                      ng-model=\"SoleDetails.formData.fatcaAddressType\"\n                      ng-options=\"_type.value as _type.addressDescription for _type in SoleDetails.addressTypeList\"\n                      ng-init=\"SoleDetails.formData.fatcaAddressType = SoleDetails.formData.fatcaAddressType ? SoleDetails.formData.fatcaAddressType : null\"\n                      required>\n                <option value=\"\" selected>Address Type</option>\n              </select>\n              <label ng-if=\"SoleDetails.formData.fatcaAddressType\">Address Type</label>\n              <span\n                ng-show=\"soleApplicantForm.fatcaAddressType.$dirty && soleApplicantForm.fatcaAddressType.$invalid\">\n                    <span class=\"error-input\" ng-show=\"soleApplicantForm.fatcaAddressType.$error.required\"\n                          ng-bind=\"SoleDetails.validations.ADDRESS_TYPE\"></span>\n                </span>\n              <span class=\"req text-red\">*</span>\n            </div>\n          </div>\n\n        </div>\n      </div>\n      <div class=\"form-content less-pad inves-pay\">\n        <p><strong>Does the investor pay or file tax other than India?</strong></p>\n        <span class=\"radio-block\">\n          <span class=\"radio\">\n            <input type=\"radio\" id=\"payTaxInIndiaYes\" name=\"payTaxInIndia\"\n                   ng-change=\"SoleDetails.changePayTaxOutsideIndiaStatus(true)\"\n                   ng-model=\"SoleDetails.formData.payTaxInIndia\"\n                   ng-value=\"false\"/>\n            <span class=\"check\"></span>\n          </span>\n          <label for=\"payTaxInIndiaYes\">Yes</label>\n        </span>\n        <span class=\"radio-block\">\n            <span class=\"radio\">\n              <input type=\"radio\" id=\"payTaxInIndiaNo\" name=\"payTaxInIndia\"\n                     ng-model=\"SoleDetails.formData.payTaxInIndia\"\n                     ng-value=\"true\"/>\n              <span class=\"check\"></span>\n            </span>\n                  <label for=\"payTaxInIndiaNo\">No</label>\n            </span>\n        <div ng-if=\"!SoleDetails.formData.minor && !SoleDetails.formData.payTaxInIndia\">\n          <div class=\"tax-res\"\n               ng-repeat=\"data in SoleDetails.formData.payOutsideIndiaAddresses\">\n            <p>\n              <strong>Tax Residency Country</strong>\n              <span ng-show=\"$index > 0\" class=\"remove-item\" ng-click=\"SoleDetails.deleteTaxResidency($index)\">\n                <i class=\"delete-red-icon\"></i>\n              </span>\n            </p>\n\n            <div class=\"row\">\n              <div class=\"col-md-3\">\n                <div class=\"selectfield\"\n                     ng-class=\"{error:soleApplicantForm[\'birthCountry-\'+$index].$dirty && soleApplicantForm[\'birthCountry-\'+$index].$invalid}\">\n                  <select class=\"browser-default custom-select\" name=\"birthCountry-$index\"\n                          ng-model=\"SoleDetails.formData.payOutsideIndiaAddresses[$index].countryName\"\n                          ng-options=\"country.countryCode as country.countryName for country in SoleDetails.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\"\n                          ng-init=\"SoleDetails.formData.payOutsideIndiaAddresses[$index].countryName = SoleDetails.formData.payOutsideIndiaAddresses[$index].countryName ? SoleDetails.formData.payOutsideIndiaAddresses[$index].countryName : null\"\n                          required>\n                    <option value=\"\" selected>Name Of Country</option>\n                  </select>\n                  <label ng-if=\"SoleDetails.formData.payOutsideIndiaAddresses[$index].countryName\">Name Of\n                    Country</label>\n                  <span class=\" req text-red\">*</span>\n                  <span\n                    ng-show=\"soleApplicantForm[\'birthCountry-\'+$index].$dirty && soleApplicantForm[\'birthCountry-\'+$index].$invalid\">\n                    <span class=\"error-input\" ng-show=\"soleApplicantForm[\'birthCountry-\'+$index].$error.required\">{{SoleDetails.validations.COUNTRY}}</span>\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"col-md-3\">\n                <div class=\"input-normal cityBirth\"\n                     ng-class=\"{error:soleApplicantForm[\'birthCity-\'+$index].$dirty && soleApplicantForm[\'birthCity-\'+$index].$invalid}\">\n                  <input type=\"text\" name=\"birthCity{{$index}}\"\n                         ng-model=\"SoleDetails.formData.payOutsideIndiaAddresses[$index].birthCity\"\n                         ng-maxlength=\"35\" limit-to=\"35\"\n                         required>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>City<span class=\"req text-red\">*</span></label>\n                  <span\n                    ng-show=\"soleApplicantForm[\'birthCity-\'+$index].$dirty && soleApplicantForm[\'birthCity-\'+$index].$invalid\">\n<span class=\"error-input\" ng-show=\"soleApplicantForm[\'birthCity-\'+$index].$error.required\">{{SoleDetails.validations.BIRTH_CITY}}</span>\n</span>\n                </div>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-md-3\">\n                <div class=\"selectfield\"\n                     ng-class=\"{error:soleApplicantForm[\'taxIdType-\'+$index].$dirty && soleApplicantForm[\'taxIdType-\'+$index].$invalid}\">\n                  <select class=\"browser-default custom-select\" name=\"taxIdType-$index\"\n                          ng-model=\"SoleDetails.formData.payOutsideIndiaAddresses[$index].taxIdType\"\n                          ng-options=\"taxid.description as taxid.description for taxid in SoleDetails.taxIdTypeList\"\n                          ng-init=\"SoleDetails.formData.payOutsideIndiaAddresses[$index].taxIdType = SoleDetails.formData.payOutsideIndiaAddresses[$index].taxIdType ? SoleDetails.formData.payOutsideIndiaAddresses[$index].taxIdType : null\"\n                          required>\n                    <option value=\"\" selected>Select Tax ID type</option>\n                  </select>\n                  <label ng-if=\"SoleDetails.formData.payOutsideIndiaAddresses[$index].taxIdType\">Select Tax ID\n                    type</label>\n                  <span class=\" req text-red\">*</span>\n                  <span\n                    ng-show=\"soleApplicantForm[\'taxIdType-\'+$index].$dirty && soleApplicantForm[\'taxIdType-\'+$index].$invalid\">\n                    <span class=\"error-input\" ng-show=\"soleApplicantForm[\'taxIdType-\'+$index].$error.required\">{{SoleDetails.validations.TAX_ID_TYPE}}</span>\n                  </span>\n                </div>\n              </div>\n              <div class=\"col-md-3\">\n                <div class=\"input-select input-normal\">\n                  <input type=\"text\" name=\"taxIdNumber-{{$index}}\"\n                         ng-model=\"SoleDetails.formData.payOutsideIndiaAddresses[$index].taxIdNumber\"\n                         ng-maxlength=\"20\" limit-to=\"20\"\n                         required capitalize>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>Tax ID number<span class=\"req text-red\">*</span></label>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"add-another-tax-res tax-res\">\n            <a ng-show=\"((SoleDetails.formData.payOutsideIndiaAddresses.length)*1<3)\"\n               href=\"\" class=\"text-blue\" ng-click=\"SoleDetails.addMoreTaxResidency()\"><strong><i\n              class=\"expand-icon\"></i>Add\n              another tax residency country</strong></a>\n          </div>\n        </div>\n        <div ng-if=\"SoleDetails.formData.minor && !SoleDetails.formData.payTaxInIndia\">\n          <div class=\"tax-res\"\n               ng-repeat=\"data in SoleDetails.fatcaArray\">\n            <p>\n              <strong>Tax Residency Country</strong>\n              <span ng-show=\"$index > 0\" class=\"remove-item\" ng-click=\"SoleDetails.deleteTaxResidencyFromFatca($index)\">\n                <i class=\"delete-red-icon\"></i>\n              </span>\n            </p>\n\n            <div class=\"row\">\n              <div class=\"col-md-3\">\n                <div class=\"selectfield\"\n                     ng-class=\"{error:soleApplicantForm[\'birthCountry\'+$index].$dirty && soleApplicantForm[\'birthCountry\'+$index].$invalid}\">\n                  <select class=\"browser-default custom-select\" name=\"birthCountry{{$index}}\"\n                          ng-model=\"data.taxPayingCountry\"\n                          ng-options=\"country.countryCode as country.countryName for country in SoleDetails.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\"\n                          ng-init=\"data.taxPayingCountry = data.taxPayingCountry ? data.taxPayingCountry : null\"\n                          required>\n                    <option value=\"\" selected>Name Of Country</option>\n                  </select>\n                  <label ng-if=\"data.taxPayingCountry\">Name Of Country</label>\n                  <span class=\" req text-red\">*</span>\n                  <span\n                    ng-show=\"soleApplicantForm[\'birthCountry\'+$index].$dirty && soleApplicantForm[\'birthCountry\'+$index].$invalid\">\n                    <span class=\"error-input\" ng-show=\"soleApplicantForm[\'birthCountry\'+$index].$error.required\">{{SoleDetails.validations.COUNTRY}}</span>\n                  </span>\n                </div>\n              </div>\n\n              <div class=\"col-md-3\">\n                <div class=\"input-normal\"\n                     ng-class=\"{error:soleApplicantForm[\'birthCity\'+$index].$dirty && soleApplicantForm[\'birthCity\'+$index].$invalid}\">\n                  <input type=\"text\" name=\"birthCity{{$index}}\"\n                         ng-model=\"data.taxPayingCity\"\n                         required capitalize>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>City<span class=\"req text-red\">*</span></label>\n                  <span\n                    ng-show=\"soleApplicantForm[\'birthCity\'+$index].$dirty && soleApplicantForm[\'birthCity\'+$index].$invalid\">\n                <span class=\"error-input\" ng-show=\"soleApplicantForm[\'birthCity\'+$index].$error.required\">{{SoleDetails.validations.BIRTH_CITY}}</span>\n              </span>\n                </div>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-md-3\">\n                <div class=\"selectfield\"\n                     ng-class=\"{error:soleApplicantForm[\'taxIdType\'+$index].$dirty && soleApplicantForm[\'taxIdType\'+$index].$invalid}\">\n                  <select class=\"browser-default custom-select\" name=\"taxIdType{{$index}}\"\n                          ng-model=\"data.taxId\"\n                          ng-options=\"taxid.description as taxid.description for taxid in SoleDetails.taxIdTypeList\"\n                          ng-init=\"data.taxId = data.taxId ? data.taxId : null\"\n                          required>\n                    <option value=\"\" selected>Select Tax ID type</option>\n                  </select>\n                  <label ng-if=\"data.taxId\">Select Tax ID type</label>\n                  <span class=\" req text-red\">*</span>\n                  <span\n                    ng-show=\"soleApplicantForm[\'taxIdType\'+$index].$dirty && soleApplicantForm[\'taxIdType\'+$index].$invalid\">\n                    <span class=\"error-input\" ng-show=\"soleApplicantForm[\'taxIdType\'+$index].$error.required\">{{SoleDetails.validations.TAX_ID_TYPE}}</span>\n                  </span>\n                </div>\n              </div>\n              <div class=\"col-md-3\">\n                <div class=\"input-normal\"\n                     ng-class=\"{error:soleApplicantForm[\'taxIdNumber\'+$index].$dirty && soleApplicantForm[\'taxIdNumber\'+$index].$invalid}\">\n                  <input type=\"text\" name=\"taxIdNumber{{$index}}\"\n                         ng-model=\"data.taxIdNumber\"\n                         required capitalize>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>Tax ID number<span class=\"req text-red\">*</span></label>\n                  <span\n                    ng-show=\"soleApplicantForm[\'taxIdNumber\'+$index].$dirty && soleApplicantForm[\'taxIdNumber\'+$index].$invalid\">\n                <span class=\"error-input\" ng-show=\"soleApplicantForm[\'taxIdNumber\'+$index].$error.required\">{{SoleDetails.validations.TAX_ID_NUMBER}}</span>\n              </span>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"add-another-tax-res tax-res\" ng-if=\"SoleDetails.formData.minor\">\n            <a ng-show=\"!SoleDetails.formData.guardianDetail.fatca.payTaxInIndia &&\n                        SoleDetails.fatcaArray.length < 3\"\n               href=\"\" class=\"text-blue\" ng-click=\"SoleDetails.addNewResidencyFields()\"><strong><i\n              class=\"expand-icon\"></i>Add\n              another tax residency country</strong></a>\n          </div>\n        </div>\n      </div>\n      <hr/>\n      <div class=\"form-footer form-content\">\n        &lt;!&ndash;<button class=\"btn btn-negative-action\" ng-click=\"SoleDetails.cancelTransaction()\">Cancel</button>&ndash;&gt;\n        <span class=\"pull-left back\" ng-click=\"SoleDetails.back(\'fromBack\')\"><i class=\"arrow-blue-back-icon\"></i>Back</span>\n        <input type=\"button\" class=\"btn btn-secondary-action common-btn-padding\" ng-click=\"SoleDetails.saveFolio()\"\n               value=\"Save\"/>\n        <input ng-if=\"!SoleDetails.formData.minor\" type=\"submit\" class=\"btn btn-primary-action common-btn-padding\"\n               ng-disabled=\"(soleApplicantForm.$invalid) || (!SoleDetails.formData.netWorthDate  && !SoleDetails.formData.grossAnnualIncome)\"\n               value=\"Continue\" ng-click=\"SoleDetails.continue()\"/>\n        <input ng-if=\"SoleDetails.formData.minor\" type=\"submit\" class=\"btn btn-primary-action common-btn-padding\"\n               ng-disabled=\"(soleApplicantForm.$invalid) || (!SoleDetails.formData.dateOfBirth)||(SoleDetails.formData.holdmode !== SoleDetails.pattern.INVESTOR_HOLD_MODE.SINGLE)\"\n               value=\"Continue\" ng-click=\"SoleDetails.continue()\"/>\n      </div>\n    </form>\n  </div>--><folio-form-data holders=SoleDetails.formData nominees-resp=SoleDetails.nomineesResp main-folio-parent=MainFolioParent first-flow=NO ekyc-email=SoleDetails.ekycEmail ekyc-email-belongs-to=SoleDetails.emailBelongsTo ekyc-mobile=SoleDetails.ekycMobile ekyc-mobile-belongs-to=SoleDetails.mobileBelongsTo></folio-form-data></div>");
$templateCache.put("app/investor/profile/declaration/declaration.html","<div class=\"folio-info declaration-info\" ng-init=Declaration.init();><ul class=\"nav nav-tabs\"><li class=active><a data-bs-toggle=tab href=#declaration ng-click=Declaration.resetDeclaration()>Declaration</a></li><li><a data-bs-toggle=tab href=#viewCancel ng-click=Declaration.getFolio()>View / Cancel</a></li></ul><div class=\"tab-content declaration-tab\"><!--  Declaration TAB --><div id=declaration class=\"tab-pane fade in active\"><form name=form novalidate><!--        FOLIO NUMBER--><div class=col-sm-12><div class=\"col-sm-4 col-spacing-div\">Folio No.<span class=\"req text-red\">*</span> :</div><div class=\"col-sm-8 col-spacing-div\"><select name=folioNumber ng-model=Declaration.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in Declaration.folioList\" ng-init=\"Declaration.folioNumber=Declaration.folioNumber?Declaration.folioNumber: null\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-change=Declaration.resetFolio() required><option value=\"\">Select Folio</option></select><span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-show=\"form.folioNumber.$error.required && form.folioNumber.$touched\" ng-bind=Declaration.VALIDATE_DATA.FOLIO_REQUIRED aria-hidden=true>Folio Number is required.</span></div></div><!--        DECLARATION CATEGORY--><div class=col-sm-12><div class=\"col-sm-4 col-spacing-div\">Declaration Category<span class=\"req text-red\">*</span> :</div><div class=\"col-sm-8 col-spacing-div\"><select name=category id=_second ng-model=Declaration.category ng-options=\"category as category for category in Declaration.declarationCategory\" ng-init=\"Declaration.category=Declaration.category?Declaration.category: null\" ng-change=Declaration.verifyFormDeclaration() required><option value=\"\">Select Declaration Category</option></select><span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-show=\"form.category.$dirty && form.category.$error.required\" ng-bind=Declaration.VALIDATE_DATA.DECLARATION_CATEGORY_REQUIRED aria-hidden=true>Declaration Category is required.</span> <span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-show=Declaration.formValidationError ng-bind=Declaration.formValidationMessage aria-hidden=true>{{Declaration.formValidationMessage}}</span></div></div><!--        YEAR OF DECLARATION--><div class=col-sm-12><div class=\"col-sm-4 col-spacing-div\">Year For Declaration<span class=\"req text-red\">*</span> :</div><div class=\"col-sm-8 col-spacing-div\"><select name=declarationYear id=_third ng-model=Declaration.declarationYear ng-options=\"declarationYear as declarationYear for declarationYear in Declaration.yearForDeclarationList\" ng-init=\"Declaration.declarationYear=Declaration.declarationYear?Declaration.declarationYear: null\" required><option value=\"\">Select Year of Declaration</option></select><span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-show=\"form.declarationYear.$dirty && form.declarationYear.$error.required\" ng-bind=Declaration.VALIDATE_DATA.DECLARATION_YEAR_REQUIRED aria-hidden=true>Year of Declaration is required.</span></div></div><!--        ESTIMATED TOTAL INCOME--><div class=col-md-12><div class=\"col-md-4 income-dividend-margin col-spacing-div\">Estimated Total Income<span class=\"req text-red\">*</span> :</div><div class=\"input-normal icon-input col-md-8 col-spacing-div\"><input type=number ng-model=Declaration.totalIncome name=totalIncome required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01 class=\"ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched input-width\" aria-invalid=true> <span class=highlight></span> <span class=bar></span><label class=label-text>Estimated Total Income</label><i class=rupee-grey-icon></i> <span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-show=\"form.totalIncome.$dirty && form.totalIncome.$error.required\" ng-bind=Declaration.VALIDATE_DATA.ESTIMATED_TOTAL_INCOME_REQUIRED aria-hidden=true>Amount is required</span> <span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-if=\"form.totalIncome.$viewValue ? true : false\" ng-show=\"form.totalIncome.$dirty && form.totalIncome.$invalid\" ng-bind=Declaration.VALIDATE_DATA.TWO_DECIMAL_ALLOWED aria-hidden=true>Only two decimal input allowed.</span></div></div><!--        ESTIMATED INCOME--><div class=col-sm-12><div class=\"col-md-4 income-dividend-margin col-spacing-div\">Estimated Income(From IDCW)<span class=\"req text-red\">*</span> :</div><div class=\"input-normal icon-input col-md-8 col-spacing-div\"><input type=number ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01 ng-model=Declaration.estimatedIncome name=estimatedIncome required class=\"ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched input-width\" aria-invalid=true> <span class=highlight></span> <span class=bar></span><label class=label-text>Estimated Income(From IDCW)</label><i class=rupee-grey-icon></i> <span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-show=\"form.estimatedIncome.$dirty && form.estimatedIncome.$error.required\" ng-bind=Declaration.VALIDATE_DATA.ESTIMATED_INCOME_REQUIRED aria-hidden=true>Amount is required</span> <span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-if=\"form.estimatedIncome.$viewValue ? true : false\" ng-show=\"form.estimatedIncome.$dirty && form.estimatedIncome.$invalid\" ng-bind=Declaration.VALIDATE_DATA.TWO_DECIMAL_ALLOWED aria-hidden=true>Only two decimal input allowed.</span> <span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-show=\"form.estimatedIncome.$dirty && form.totalIncome.$dirty && Declaration.estimatedIncome > Declaration.totalIncome\" ng-bind=Declaration.VALIDATE_DATA.ESTIMATED_INCOME_GREATER_THAN_TOTAL_INCOME aria-hidden=true>Estimated income should not be greater than Total Estimated Income.</span></div></div><!--        INVESTMENT DECLARATION TAX--><div class=col-sm-12><div class=\"col-sm-4 col-spacing-div\">Investment Declaration Assessed To Tax<span class=\"req text-red\">*</span> :</div><div class=col-sm-8><div class=\"col-md-1 radio-block declaration-amount\"><span class=radio><input type=radio name=taxable ng-value=true ng-model=Declaration.taxable ng-click=Declaration.changeTax(true) class=\"ng-pristine ng-untouched ng-valid ng-not-empty\" value=true aria-invalid=false selected> <span class=check></span> </span><span class=radio-label>Yes</span></div><div class=\"col-md-8 radio-block declaration-amount\"><span class=radio><input type=radio name=nontaxable ng-value=true ng-model=Declaration.nonTaxable ng-click=Declaration.changeTax(false) class=\"ng-pristine ng-untouched ng-valid ng-not-empty\" value=true aria-invalid=false> <span class=check></span> </span><span class=radio-label>No</span></div></div></div><!--        PLEASE NOTE--><div class=col-md-12><ng-bind-html ng-bind-html=Declaration.dynamicDataNote></ng-bind-html></div><!--        CHECKBOX DECLARATION--><div class=\"col-sm-12 footer-margin\"><div class=\"col-md-9 checkbox-spacing\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=defaultDate ng-model=Declaration.declaration ng-change=Declaration.changeDeclarationPopUp() class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false ng-disabled=\"Declaration.folioNumber ? false : true\"> <span class=icon-checkbox></span></span><label for=defaultDate class=declaration-label>I agree to <a href=javaScript:void(0) ng-click=Declaration.showDeclarationSuccessPopup() class=declaration-color ng-class=\"{\'declaration-terms-disabled\' : !Declaration.folioNumber}\">Declaration</a></label></div><div class=col-md-3><button type=button ng-click=Declaration.submitDeclaration() ng-disabled=\"!Declaration.declaration || form.$invalid || Declaration.estimatedIncome > Declaration.totalIncome || Declaration.dobError || Declaration.formValidationError\" id=submitButton class=\"declaration-button btn btn-primary-action ng-scope\">Submit</button></div></div></form></div><!--    VIEW CANCEL TAB--><div id=viewCancel class=\"tab-pane fade\"><!--      NO RECORD FOUND--><form name=cancelForm><div ng-if=!Declaration.folioSubmit class=col-sm-12><p class=no-record>No record found.</p></div><div ng-if=Declaration.folioSubmit><!--        FOLIO NUMBER--><div class=col-sm-12><div class=\"col-sm-2 col-spacing-div\">Folio No.<span class=\"req text-red\">*</span> :</div><div class=\"col-sm-10 col-spacing-div\"><select name=cancelFolio ng-model=Declaration.cancelFolio required ng-change=Declaration.folioChanged() ng-options=\"folio as folio for folio in Declaration.cancelFolioList\" ng-init=\"Declaration.cancelFolio=Declaration.cancelFolio?Declaration.cancelFolio: null\"><option value=\"\">Select Folio</option></select><span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-show=\"cancelForm.cancelFolio.$dirty && cancelForm.cancelFolio.$error.required\" ng-bind=Declaration.VALIDATE_DATA.FOLIO_REQUIRED aria-hidden=true>Folio Number is required.</span></div></div><!--      FOLIO SUBMIT--><div class=col-md-12 ng-if=!Declaration.declarationSubmit><button type=button ng-click=Declaration.submitFolio() ng-disabled=cancelForm.cancelFolio.$invalid class=\"submit-button btn btn-primary-action ng-scope\" ng-if=Declaration.folioSubmit>Submit</button></div><div ng-if=Declaration.declarationSubmit><!--REGISTRATION NUMBER--><div class=col-sm-12><div class=\"col-sm-2 col-spacing-div\">Registration No.<span class=\"req text-red\">*</span> :</div><div class=\"col-sm-10 col-spacing-div\"><select name=registrationNo id=second required ng-model=Declaration.registrationNo ng-change=Declaration.RegistrationChanged() ng-options=\"registrationNo as registrationNo for registrationNo in Declaration.registerNoList\" ng-init=\"Declaration.registrationNo=Declaration.registrationNo?Declaration.registrationNo: null\"><option value=\"\">Select Registration No.</option></select><span class=\"row error-input ng-binding ng-hide error-msg-div\" ng-show=\"cancelForm.registrationNo.$dirty && cancelForm.registrationNo.$error.required\" ng-bind=Declaration.VALIDATE_DATA.REGISTRATION_NO_REQUIRED aria-hidden=true>Registration Number is required.</span></div></div><!--REGISTRATION SUBMIT--><div class=col-md-12><button type=button ng-click=Declaration.submitRegistration() ng-disabled=\"cancelForm.$invalid || Declaration.details\" class=\"submit-button btn btn-primary-action ng-scope\" ng-if=Declaration.declarationSubmit>Submit</button></div></div><div ng-if=Declaration.details><div class=col-sm-12><div class=col-sm-12><p class=text-style>Details</p></div><div class=col-sm-12><table class=col-sm-8><tr ng-if=Declaration.detailDeclarationCategory><td class=\"col-sm-5 table-padding declaration-amount\">Declaration Category</td><td class=\"col-sm-1 declaration-amount text-center-colon\">:</td><td class=\"col-sm-6 declaration-amount\">{{Declaration.detailDeclarationCategory}}</td></tr><tr ng-if=Declaration.detailRegistrationNo><td class=\"col-sm-5 declaration-amount row-padding\">Registration No</td><td class=\"col-sm-1 declaration-amount text-center-colon\">:</td><td class=\"col-sm-6 declaration-amount\">{{Declaration.detailRegistrationNo}}</td></tr><tr ng-if=Declaration.detailRegistrationDate><td class=\"col-sm-5 declaration-amount row-padding\">Registration Date</td><td class=\"col-sm-1 declaration-amount text-center-colon\">:</td><td class=\"col-sm-6 declaration-amount\">{{Declaration.detailRegistrationDate}}</td></tr><tr ng-if=Declaration.detailInvestorName><td class=\"col-sm-5 declaration-amount row-padding\">Investor Name</td><td class=\"col-sm-1 declaration-amount text-center-colon\">:</td><td class=\"col-sm-6 declaration-amount\">{{Declaration.detailInvestorName}}</td></tr><tr ng-if=Declaration.detailTax><td class=\"col-sm-5 declaration-amount row-padding\">Investment Declaration Assessed To Tax</td><td class=\"col-sm-1 declaration-amount text-center-colon\">:</td><td class=\"col-sm-6 declaration-amount\">{{Declaration.detailTax}}</td></tr><tr ng-if=Declaration.detailIncome><td class=\"col-sm-5 declaration-amount row-padding\">Estimated Income</td><td class=\"col-sm-1 declaration-amount text-center-colon\">:</td><td class=\"col-sm-6 declaration-amount\"><i class=rupee-small-icon></i>{{Declaration.detailIncome}}</td></tr><tr ng-if=Declaration.detailTotalIncome><td class=\"col-sm-5 declaration-amount row-padding\">Estimated Total Income</td><td class=\"col-sm-1 declaration-amount text-center-colon\">:</td><td class=\"col-sm-6 declaration-amount\"><i class=rupee-small-icon></i>{{Declaration.detailTotalIncome}}</td></tr><tr ng-if=Declaration.detailFYFromDate><td class=\"col-sm-5 declaration-amount row-padding\">FY From Date</td><td class=\"col-sm-1 declaration-amount text-center-colon\">:</td><td class=\"col-sm-6 declaration-amount\">{{Declaration.detailFYFromDate}}</td></tr><tr ng-if=Declaration.detailFYToDate><td class=\"col-sm-5 declaration-amount row-padding\">FY To Date</td><td class=\"col-sm-1 declaration-amount text-center-colon\">:</td><td class=\"col-sm-6 declaration-amount\">{{Declaration.detailFYToDate}}</td></tr></table></div></div><div class=\"col-sm-12 footer-margin\"><div class=\"col-sm-2 cancel-button\"><button type=button ng-click=Declaration.close() class=\"btn btn-primary-action ng-scope\">Close</button></div><div class=\"col-sm-10 cancel-button\"><button type=button ng-click=Declaration.cancelRegistration() class=\"btn btn-primary-action ng-scope cancel-registration-button\">Cancel Registration</button></div></div></div></div></form></div></div></div>");
$templateCache.put("app/investor/profile/modifyNominee/updateNominee.html","<form class=\"main-section clearfix modifyNominee\" name=updateNomineeForm id=updateNomineeForm ng-init=UpdateNominee.folioDetailsData><h5 class=screen-title>Add / Update Nominee</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.profile.folioDetails>Folio Details </span><i class=breadcrumb-icon></i><span> Add/Update Nominee</span></p><div class=folio-updatenominee><strong>Folio : </strong><span>{{UpdateNominee.folioNo}}</span></div><section class=nominee-details><div class=form-content><div style=\"padding: 20px 0px\"><label style=\"padding: 5px; font-size: 16px\"><strong>Contact Details</strong></label><div class=row style=\"padding: 5px\"><div class=col-md-3 style=\"margin-right: 40px\" ng-if=UpdateNominee.investorEmail><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{UpdateNominee.investorEmail}}</label></div><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!UpdateNominee.investorEmail><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : Not available</label></div><!--            <div class=\"col-md-3 belongsToContainerMobile emailBelongsMobile\" style=\"display: inline-flex;  margin-right: 40px;\" ng-if=\"UpdateNominee.investorEmail\">--><!--              <div style=\"flex-shrink : 0;\">--><!--                <label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> : </label>--><!--              </div>--><!--              <div class=\"selectfield\" style=\"display: inline-block ; margin-left : 5px;\"--><!--                   ng-class=\"{error:soleApplicantForm.emailBelongsTo.$dirty && soleApplicantForm.emailBelongsTo.$invalid}\">--><!--                <select class=\"browser-default custom-select\" name=\"emailBelongsTo\" style=\"width: 150px\"--><!--                        ng-model=\"holders.emailBelongsTo\"--><!--                        ng-init=\"holders.emailBelongsTo = holders.emailBelongsTo ? holders.emailBelongsTo: null\"--><!--                        ng-options=\"data.familyCode as data.familyDescription for data in UpdateNominee.belongToListEmail\"--><!--                        required>--><!--                  <option value=\"\" selected>Select Value</option>--><!--                </select>--><!--                <span class=\"req text-red\">*</span>--><!--              </div>--><!--            </div>--><div class=\"col-md-3 mLabel\" ng-if=UpdateNominee.investorMobile><label class=mobile-belongs-to style=\"margin-top: 30px; margin-left:30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : {{UpdateNominee.investorMobile}}</label></div><div class=col-md-3 ng-if=!UpdateNominee.investorMobile><label class=mobile-belongs-to style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : Not available</label></div></div><div class=row style=\"padding: 5px\"><div class=\"col-md-3 belongsToContainerWeb\" style=\"display: inline-flex;  margin-right: 40px\" ng-if=UpdateNominee.investorEmail><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block ; margin-left : 5px\" ng-class=\"{error:updateNomineeForm.emailBelongsTo.$dirty && updateNomineeForm.emailBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=emailBelongsTo style=\"width: 150px\" ng-model=UpdateNominee.emailBelongsTo ng-init=\"UpdateNominee.emailBelongsTo = UpdateNominee.emailBelongsTo ? UpdateNominee.emailBelongsTo: null\" ng-options=\"data.familyCode as data.familyDescription for data in UpdateNominee.belongToListEmail\" required><option value=\"\" selected>Select Value</option></select><span ng-if=\"updateNomineeForm.emailBelongsTo.$dirty && updateNomineeForm.emailBelongsTo.$invalid\"><span class=error-input style=\"width: max-content\" ng-if=updateNomineeForm.emailBelongsTo.$error.required>{{UpdateNominee.nomineeValidateData.EMAIL_BELONGS_TO}}</span></span></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!UpdateNominee.investorEmail></div><div class=\"col-md-3 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=UpdateNominee.investorMobile><div class=mobile-belongs-to style=\"flex-shrink : 0; margin-left: 30px\"><label class=mobile-belongs-to style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block\" ng-class=\"{error:updateNomineeForm.mobileBelongsTo.$dirty && updateNomineeForm.mobileBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=mobileBelongsTo style=\"width: 150px\" ng-model=UpdateNominee.mobileBelongsTo ng-init=\"UpdateNominee.mobileBelongsTo = UpdateNominee.mobileBelongsTo ? UpdateNominee.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in UpdateNominee.belongToListMobile\" required><option value=\"\" selected>Select Value</option></select><span ng-if=\"updateNomineeForm.mobileBelongsTo.$dirty && updateNomineeForm.mobileBelongsTo.$invalid\"><span class=error-input style=\"width: max-content\" ng-if=updateNomineeForm.mobileBelongsTo.$error.required>{{UpdateNominee.nomineeValidateData.MOBILE_BELONGS_TO}}</span></span></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!UpdateNominee.investorMobile></div></div></div><div class=\"nominee-title clearfix\"><span class=\"pull-left details\"><strong>Nominee Details</strong> <i class=\"info-icon base-tooltip\" tooltip data-bs-html=true data-bs-toggle=tooltip data-placement={{Main.tooltipClass}} ng-if=UpdateNominee.showNomineeUpdate title=\"SEBI Circular No. SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650, dated January 10, 2025\n            states that, in case of Joint Account/Folio: <br>\n            1. In case of “Demise of one or more joint holder(s)” event: Transmission of\n              Account/Folio to: Surviving holder(s) through name deletion, The surviving holder(s) shall\n              inherit the assets as owners.<br>\n            2. In case of “Demise of all joint holders simultaneously – having nominee” event: Transmission of Account/Folio to: Nominee.<br>\n            3. In case of “Demise of all joint holders simultaneously – not having nominee event: Transmission of Account /Folio to: Legal heir(s) of the youngest holder\"></i></span><p class=consent-text ng-if=UpdateNominee.showNomineeUpdate>I/We hereby nominate the following person(s) who shall receive all the assets held in my / our account / folio in the event of my / our demise, as trustee and on behalf of my/our legal heir(s).</p></div><div class=list-head><div class=\"col-md-2 blank-table-space\">&nbsp;</div><div class=col-md-4>Name</div><div class=col-md-4>Proportion <span class=text-warn>(Should not be greater than 100%)</span></div><div class=col-md-2>&nbsp;</div></div><div class=\"updated-scroll full-width\"><div class=\"list-data d-flex\" style=\"width: 100%\" ng-if=\"UpdateNominee.folioData.folioDetailsData.nominees.length>0\" ng-repeat=\"nominee in UpdateNominee.folioData.folioDetailsData.nominees\"><div class=col-md-2 ng-if=UpdateNominee.folioData.folioDetailsData.nominees>{{UpdateNominee.nomineeEnum[$index]}} Nominee</div><div class=col-md-4 ng-class=\"{error:updateNomineeForm[\'firstName\'+$index].$dirty && updateNomineeForm[\'firstName-\'+$index].$invalid}\"><input type=text name=firstName-{{$index}} ng-bind=nominee.firstName ng-model=nominee.firstName ng-maxlength=40 limit-to=40 maxlength=40 autocomplete=off ng-change=UpdateNominee.setincapcitationList($index) only-alphabets required> <span class=\"req text-red\">*</span> <span ng-show=\"updateNomineeForm[\'firstName-\'+$index].$dirty && updateNomineeForm[\'firstName-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'firstName-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.NOMINEE_NAME_REQUIRED}}</span></span></div><div class=col-md-4 ng-class=\"{error:updateNomineeForm[\'proportion\'+$index].$dirty && updateNomineeForm[\'proportion-\'+$index].$invalid}\"><input type=text name=proportion-{{$index}} ng-bind=nominee.percentage ng-model=nominee.percentage ng-blur=UpdateNominee.calculatePercentage() maxlength=3 is-number required>% <span class=\"req text-red\">*</span> <span ng-show=\"updateNomineeForm[\'proportion-\'+$index].$dirty && updateNomineeForm[\'proportion-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'proportion-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.NOMINEE_PROPORTION_REQUIRED}}</span> </span><span ng-if=\"nominee.percentage == 0\"><span class=error-input>{{UpdateNominee.proportion_msg}}</span></span></div><div class=col-md-2 ng-if=\"UpdateNominee.folioData.folioDetailsData.nominees.length > 1 || UpdateNominee.isPrefillNomineeDataExist\"><i class=delete-red-icon ng-click=UpdateNominee.deleteNominee($index)></i></div></div></div><div class=\"col-md-12 proportion-warn\">{{UpdateNominee.percentage_msg}}</div><div class=tab-container><ul class=\"mobile-hide nav nav-tabs d-block\" ng-class=\"UpdateNominee.showAddNominee && (UpdateNominee.folioData.folioDetailsData.nominees.length< UpdateNominee.maxNominee) ? \'updated-width\': \'full-width\'\"><li ng-repeat=\"nominee in UpdateNominee.folioData.folioDetailsData.nominees\" ng-click=UpdateNominee.setActiveTab($index) ng-class=\"{\'active\':UpdateNominee.activeTab===$index}\">{{UpdateNominee.nomineeEnum[$index]}} Nominee Details</li></ul><div class=\"pull-right add-another-nominee\" ng-if=\"UpdateNominee.showAddNominee && (UpdateNominee.folioData.folioDetailsData.nominees.length< UpdateNominee.maxNominee)\" ng-click=UpdateNominee.addNominee()><a href=\"\" class=text-blue><strong><i class=plus-icon></i>Add Another Nominee</strong></a></div></div><div name=nominee-details ng-repeat=\"nominee in UpdateNominee.folioData.folioDetailsData.nominees\" ng-show=\"UpdateNominee.activeTab===$index\"><div class=row><div class=col-md-10><div class=\"nominee-title clearfix\"><span class=checkbox><input type=checkbox ng-model=nominee.minor ng-value=true ng-click=UpdateNominee.changeNomineeIsMinor($index)> <span class=icon-checkbox></span> <span class=checkbox-text>The Nominee is Minor</span></span></div></div></div><div class=row><div class=col-md-4><div class=nominee-name><span ng-class=\"{\'empty\':nominee.firstName===\'\'}\" class=name ng-bind=nominee.firstName></span></div><div class=input-normal ng-class=\"{error:updateNomineeForm[\'dob-\'+$index].$dirty && updateNomineeForm[\'dob-\'+$index].$invalid}\"><input type=text ng-if=nominee.minor name=dob-{{$index}} id=dob-{{$index}} date-calendar format=DD-MMM-YYYY viewmode=days showdefault=true date-default=nominee.dateOfBirth maxdate=now data-min-date=UpdateNominee.isMinorMinDate data-max-date=UpdateNominee.isMinorMaxDate data-on-date-change=UpdateNominee.nomineeChangeDob autocomplete=off data-enable=true ng-bind=nominee.dateOfBirth ng-model=nominee.dateOfBirth> <input type=text ng-if=!nominee.minor name=dob-{{$index}} id=dob-{{$index}} date-calendar format=DD-MMM-YYYY viewmode=days showdefault=true date-default=nominee.dateOfBirth maxdate=now data-min-date=UpdateNominee.dataMinDate data-max-date=UpdateNominee.dataMaxDate data-on-date-change=UpdateNominee.nomineeChangeDob autocomplete=off data-enable=true ng-bind=nominee.dateOfBirth ng-model=nominee.dateOfBirth> <i class=calendar-input-icon></i><label>DD-MMM-YYYY<span class=\"req text-red\" ng-if=nominee.minor>*</span></label><span ng-show=\"updateNomineeForm[\'dob-\'+$index].$dirty && updateNomineeForm[\'dob-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'dob-\'+$index].$error.required\">{{nomineeValidations.NET_WORTH_DATE}}</span></span></div></div><div class=col-md-4><div class=nominee-name ng-class={error:updateNomineeForm.proportion.$invalid}><span ng-bind=nominee.percentage></span></div><div class=selectfield ng-class=\"{error:updateNomineeForm[\'relation-\'+$index].$dirty && updateNomineeForm[\'nomineeRelation-\'+$index].$invalid}\"><select name=relation-{{$index}} ng-model=nominee.relation ng-init=\"nominee.relation=nominee.relation?nominee.relation:null\" ng-options=\"_type.value as _type.name for _type in UpdateNominee.applicantRelationShip\" ng-change=UpdateNominee.changeNomineeRelationsShip($index,nominee.relation) required><option value=\"\" selected>Relationship with Applicant</option></select><label ng-if=nominee.relation>Relationship with Applicant</label><span class=\"req text-red\">*</span> <span ng-show=\"updateNomineeForm[\'relation-\'+$index].$dirty && updateNomineeForm[\'relation-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'relation-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.NOMINEE_RELATIONSHIP}}</span></span></div></div><!--NOMINEE RELATION OTHER RELATION INPUT FIELD STARTS HERE--><!--<div class=\"col-md-4\" ng-if=\"UpdateNominee.showNomineeUpdate  && nominee.relation === \'OTHERS\'\">\n            <div class=\"nominee-name\" ng-class=\"{error:updateNomineeForm.proportion.$invalid}\">\n              <span style=\"margin-bottom: 8px\" name=\"proportion\"></span>\n            </div>\n            <div class=\"input-normal input-other\" ng-class=\"{error: updateNomineeForm[\'others-\'+$index].$dirty && updateNomineeForm[\'others-\'+$index].$invalid}\">\n              <input type=\"text\"\n                     ng-pattern=\"/^[a-zA-Z\\s]*$/\"\n                     ng-bind=\"nominee.others\"\n                     ng-model=\"nominee.others\"\n                     name=\"others-{{$index}}\"\n                     maxlength=\"50\"\n                     autocomplete=\"off\" capitalize required>\n              <label>Others (Please specify) <span class=\"req text-red\">*</span></label>\n              <span ng-show=\"updateNomineeForm[\'others-\'+$index].$dirty && updateNomineeForm[\'others-\'+$index].$invalid\">\n                  <span class=\"error-input\" ng-show=\"updateNomineeForm[\'others-\'+$index].$error.pattern\">\n                    Please enter valid PAN\n                  </span>\n                    <span class=\"error-input\" ng-show=\"updateNomineeForm[\'others-\'+$index].$error.required\">\n                    {{UpdateNominee.nomineeValidateData.RELATIONSHIP_WITH_APPLICANT_OTHER}}\n                  </span>\n                </span>\n            </div>\n          </div>--><!--NOMINEE RELATION OTHER RELATION INPUT FIELD ENDS HERE--></div><div class=row><!--NOMINEE EMAIL INPUT FIELD STARTS HERE--><div class=col-md-4 ng-if=UpdateNominee.showNomineeUpdate><div class=\"input-normal input-other\" ng-class=\"{error: updateNomineeForm[\'emailId-\'+$index].$dirty && updateNomineeForm[\'emailId-\'+$index].$invalid}\"><input type=text ng-pattern=UpdateNominee.emailPattern ng-model=nominee.emailId name=emailId-{{$index}} maxlength=254 ng-change=UpdateNominee.nomineeEmailChanged($index,nominee.emailId) autocomplete=off required><label>Nominee Email ID<span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeForm[\'emailId-\'+$index].$dirty && updateNomineeForm[\'emailId-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'emailId-\'+$index].$error.pattern\">{{UpdateNominee.nomineeValidateData.EMAIL_FIELD}} </span><span class=error-input ng-show=\"updateNomineeForm[\'emailId-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.EMAIL_REQUIRED}} </span></span><span><span class=error-input ng-show=\"!updateNomineeForm[\'emailId-\'+$index].$invalid && nominee.emailIdInvalid\">{{UpdateNominee.errorMessageEmail}}</span></span></div></div><!--NOMINEE EMAIL INPUT FIELD ENDS HERE--><!--NOMINEE MOBILE INPUT FIELD STARTS HERE--><div class=col-md-4 ng-if=UpdateNominee.showNomineeUpdate><div class=\"input-normal input-other\" ng-class=\"{error: updateNomineeForm[\'mobile-\'+$index].$dirty && updateNomineeForm[\'mobile-\'+$index].$invalid}\"><input type=text ng-model=nominee.mobile ng-pattern=UpdateNominee.mobilePattern name=mobile-{{$index}} minlength=1 maxlength=15 autocomplete=off required><label>Nominee Mobile No.<span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeForm[\'mobile-\'+$index].$dirty && updateNomineeForm[\'mobile-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'mobile-\'+$index].$error.pattern || updateNomineeForm[\'mobile-\'+$index].$error.minlength\">{{UpdateNominee.nomineeValidateData.MOBILE_FIELD}} </span><span class=error-input ng-show=\"updateNomineeForm[\'mobile-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.MOBILE_REQUIRED}} </span></span><span ng-show=\"!updateNomineeForm[\'mobile-\'+$index].$invalid && nominee.mobileInvalid\"><span class=error-input>{{UpdateNominee.errorMessageMobile}}</span></span></div></div><!--NOMINEE MOBILE INPUT FIELD ENDS HERE--><!--NOMINEE IDENTIFIER FIELD STARTS HERE--><div class=col-md-4 ng-if=UpdateNominee.showNomineeUpdate><div class=\"selectfield select-field-other\" ng-class=\"{error:updateNomineeForm[\'personalIdentifier-\'+$index].$dirty && updateNomineeForm[\'personalIdentifier-\'+$index].$invalid}\"><select name=personalIdentifier-{{$index}} ng-model=nominee.identityProofType ng-init=\"nominee.identityProofType = nominee.identityProofType ? nominee.identityProofType : null\" ng-options=\"_type.identityProofType as _type.identityProof for _type in nominee.applicantPersonalIdentifiers\" ng-change=UpdateNominee.changePersonalIdentifier($index,nominee.identityProofType) easyassist-key=mask-element required><option value=\"\" selected>Select Personal Identifier of Nominee</option></select><label ng-if=nominee.identityProofType>Select Personal Identifier of Nominee</label><span class=\"req text-red\">*</span> <span ng-show=\"updateNomineeForm[\'personalIdentifier-\'+$index].$dirty && updateNomineeForm[\'personalIdentifier-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'personalIdentifier-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.PERSONAL_IDENTIFIER_REQUIRED}}</span></span></div></div><!--NOMINEE IDENTIFIER FIELD ENDS HERE--><!--NOMINEE PAN FIELD STARTS HERE--><div class=col-md-4 ng-if=\"!UpdateNominee.showNomineeUpdate || (UpdateNominee.showNomineeUpdate && nominee.identityProofType === \'PAN_CARD\')\"><div class=\"input-normal input-pan input-other\" ng-class=\"{error:updateNomineeForm[\'panNumber-\'+$index].$dirty && updateNomineeForm[\'panNumber-\'+$index].$invalid}\"><input type=text maxlength=10 minlength=10 ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-bind=nominee.panNumber ng-model=nominee.panNumber ng-change=\"UpdateNominee.nomineePanChanged($index , nominee.panNumber)\" name=panNumber-{{$index}} ng-required=UpdateNominee.showNomineeUpdate autocomplete=off capitalize><label ng-if=!UpdateNominee.showNomineeUpdate style=\"color: #9f9f9f; font-size: 13px; font-weight: normal; position: absolute; pointer-events: none; left: 5px; top: 15px; transition: 0.2s ease all\">PAN of Nominee</label><label ng-if=UpdateNominee.showNomineeUpdate style=\"color: #9f9f9f; font-size: 13px; font-weight: normal; position: absolute; pointer-events: none; left: 5px; top: 15px; transition: 0.2s ease all\">Nominee PAN <span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeForm[\'panNumber-\'+$index].$dirty && updateNomineeForm[\'panNumber-\'+$index].$invalid\"><span class=error-input>Please enter valid PAN </span></span><span class=error-input ng-show=\"!updateNomineeForm[\'panNumber-\'+$index].$invalid && UpdateNominee.folioData.folioDetailsData.nominees[$index].nomineePanInvalid\">{{UpdateNominee.errorMessageNominee}}</span></div></div><!--NOMINEE PAN FIELD ENDS HERE--><!--NOMINEE DL FIELD STARTS HERE--><div class=col-md-4 ng-if=\"UpdateNominee.showNomineeUpdate && nominee.identityProofType === \'DRIVING_LICENSE\'\"><div class=\"input-normal input-other\" ng-class=\"{error: updateNomineeForm[\'drivingLicense-\'+$index].$dirty && updateNomineeForm[\'drivingLicense-\'+$index].$invalid}\"><input type=text ng-bind=nominee.drivingLicense ng-model=nominee.drivingLicense name=drivingLicense-{{$index}} maxlength=35 ng-change=\"UpdateNominee.nomineeLicenseChanged($index, nominee.drivingLicense)\" autocomplete=off required capitalize><label>Nominee Driving License No. <span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeForm[\'drivingLicense-\'+$index].$dirty && updateNomineeForm[\'drivingLicense-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'drivingLicense-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.DRIVING_LICENSE_REQUIRED}} </span></span><span ng-show=nominee.nomineeLicenseInvalid><span class=error-input>{{UpdateNominee.errorMessageNomineeLicense}}</span></span></div></div><!--NOMINEE DL FIELD STARTS HERE--><!--NOMINEE AADHAAR FIELD STARTS HERE--><div class=col-md-4 ng-if=\"UpdateNominee.showNomineeUpdate && nominee.identityProofType === \'AADHAR_CARD\'\"><div class=\"input-normal input-other\" ng-class=\"{error: updateNomineeForm[\'aadharCard-\'+$index].$dirty && updateNomineeForm[\'aadharCard-\'+$index].$invalid}\"><input type=text class=aadhar-field ng-bind=nominee.aadharCard ng-pattern=/^\\+?\\d+$/ ng-model=nominee.aadharCard name=aadharCard-{{$index}} maxlength=4 minlength=4 ng-change=\"UpdateNominee.nomineeAadhaarChanged($index, nominee.aadharCard)\" autocomplete=off required capitalize><label>Nominee Aadhaar No.<span class=\"req text-red\">*</span></label><span class=arn style=\"top: 11px\">XXXX XXXX </span><span ng-show=\"updateNomineeForm[\'aadharCard-\'+$index].$dirty && updateNomineeForm[\'aadharCard-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'aadharCard-\'+$index].$error.minlength || updateNomineeForm[\'aadharCard-\'+$index].$error.pattern\">{{UpdateNominee.nomineeValidateData.AADHAAR_INVALID}} </span><span class=error-input ng-show=\"updateNomineeForm[\'aadharCard-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.AADHAAR_REQUIRED}} </span></span><span ng-show=nominee.nomineeAadhaarInvalid><span class=error-input>{{UpdateNominee.errorMessageNomineeAadhaar}}</span></span></div></div><!--NOMINEE AADHAAR FIELD STARTS HERE--><!--NOMINEE PASSPORT FIELD STARTS HERE--><div class=col-md-4 ng-if=\"UpdateNominee.showNomineeUpdate && nominee.identityProofType === \'PASSPORT\'\"><div class=\"input-normal input-other\" ng-class=\"{error: updateNomineeForm[\'passport-\'+$index].$dirty && updateNomineeForm[\'passport-\'+$index].$invalid}\"><input type=text ng-bind=nominee.passport ng-model=nominee.passport name=passport-{{$index}} maxlength=35 ng-change=\"UpdateNominee.passportChanged($index, nominee.passport)\" autocomplete=off required capitalize><label>Nominee Passport<span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeForm[\'passport-\'+$index].$dirty && updateNomineeForm[\'passport-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'passport-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.PASSPORT_REQUIRED}} </span></span><span ng-show=nominee.nomineePassportInvalid><span class=error-input>{{UpdateNominee.errorMessagePassportNumber}}</span></span></div></div><!--NOMINEE PASSPORT FIELD STARTS HERE--></div><div ng-if=nominee.minor><p>Guardian Details</p><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:updateNomineeForm[\'guardianName-\'+$index].$dirty && updateNomineeForm[\'guardianName-\'+$index].$invalid}\"><input type=text ng-model=nominee.guardianName ng-bind=nominee.guardianName name=guardianName-{{$index}} ng-maxlength=40 limit-to=40 maxlength=40 only-alphabets capitalize required> <span class=highlight></span> <span class=bar></span><label>Guardian Name<span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeForm[\'guardianName-\'+$index].$dirty && updateNomineeForm[\'guardianName-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'guardianName-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.GUARDIAN_NAME}}</span></span></div></div><div class=col-md-4><div class=selectfield ng-class=\"{error:updateNomineeForm[\'guardianRelationWithNominee-\'+$index].$dirty && updateNomineeForm[\'guardianRelation-\'+$index].$invalid}\"><select name=guardianRelationWithNominee-{{$index}} ng-model=nominee.guardianRelationWithNominee ng-init=\"nominee.guardianRelationWithNominee=nominee.guardianRelationWithNominee?nominee.guardianRelationWithNominee:null\" ng-options=\"_type.value as _type.name for _type in UpdateNominee.minorRelationShip\" ng-change=UpdateNominee.changeMinorRelationsShip($index,nominee.guardianRelationWithNominee) required><option value=\"\" selected>Guardian\'s Relationship with Nominee</option></select><label ng-if=nominee.guardianRelationWithNominee>Guardian\'s Relationship with Nominee</label><span class=\"req text-red\">*</span> <span ng-show=\"updateNomineeForm[\'guardianRelationWithNominee-\'+$index].$dirty && updateNomineeForm[\'guardianRelationWithNominee-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'guardianRelationWithNominee-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.NOMINEE_RELATIONSHIP}}</span></span></div></div></div><div class=row><div class=col-md-4><div class=\"input-normal input-pan\" ng-class=\"{error:updateNomineeForm[\'guardianPanNumber-\'+$index].$dirty && updateNomineeForm[\'guardianPanNumber-\'+$index].$invalid}\"><input type=text maxlength=10 minlength=10 ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-bind=nominee.guardianPanNumber ng-model=nominee.guardianPanNumber name=guardianPanNumber-{{$index}} ng-change=\"UpdateNominee.minorPanChanged($index , nominee.guardianPanNumber , true)\" autocomplete=off capitalize><label style=\"color: #9f9f9f; font-size: 13px; font-weight: normal; position: absolute; pointer-events: none; left: 5px; top: 15px; transition: 0.2s ease all\">PAN of Guardian</label><span ng-show=\"!nominee.guardianPanNumber && updateNomineeForm[\'guardianPanNumber-\'+$index].$dirty && updateNomineeForm[\'guardianPanNumber-\'+$index].$invalid && !updateNomineeForm[\'guardianPanNumber-\'+$index].$error.required\"><span class=error-input>{{UpdateNominee.nomineeValidateData.PAN_FIELD}} </span></span><span class=error-input ng-show=\"!updateNomineeForm[\'guardianPanNumber-\'+$index].$invalid && UpdateNominee.folioData.folioDetailsData.nominees[$index].minorPanInvalid && updateNomineeForm[\'guardianPanNumber-\'+$index]\">{{UpdateNominee.errorMessage}} </span><span class=error-input ng-show=\"updateNomineeForm[\'guardianPanNumber-\'+$index].$error.required && updateNomineeForm[\'guardianPanNumber-\'+$index].$dirty\">Pan is required {{UpdateNominee.nomineeValidateData.PAN_REQUIRED}}</span></div></div></div></div><p>Address Details of <span ng-if=!UpdateNominee.folioData.folioDetailsData.nominees[$index].minor>Nominee</span> <span ng-if=UpdateNominee.folioData.folioDetailsData.nominees[$index].minor>Nominee\'s Guardian</span></p><div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:updateNomineeForm[\'addressLine1-\'+$index].$dirty && updateNomineeForm[\'addressLine1-\'+$index].$invalid}\"><input type=text ng-model=nominee.nomineeAddress1 ng-bind=nominee.nomineeAddress1 name=addressLine1-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 ng-required=UpdateNominee.showNomineeUpdate capitalize><label>Address Line 1 <span class=\"req text-red\" ng-if=UpdateNominee.showNomineeUpdate>*</span></label><span ng-show=\"updateNomineeForm[\'addressLine1-\'+$index].$dirty && updateNomineeForm[\'addressLine1-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'addressLine1-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.ADDRESS1_REQUIRED}}</span></span></div></div><div class=col-md-4><div class=input-normal><input type=text class=address2-input ng-bind=nominee.nomineeAddress2 ng-model=nominee.nomineeAddress2 name=addressLine2-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 capitalize><label class=address2>Address Line 2</label></div></div></div><div class=row><div class=col-md-4 style=\"margin-top: 2px\"><div class=input-normal ng-class=\"{error:updateNomineeForm[\'city\'].$dirty && updateNomineeForm[\'city\'].$invalid}\"><input type=text name=city-{{$index}} ng-bind=nominee.city ng-model=nominee.city ng-maxlength=35 limit-to=35 maxlength=35 ng-required=UpdateNominee.showNomineeUpdate only-alphabets capitalize><label>City <span class=\"req text-red\" ng-if=UpdateNominee.showNomineeUpdate>*</span></label><span ng-show=\"updateNomineeForm[\'city-\'+$index].$dirty && updateNomineeForm[\'city-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'city\'].$error.required\">{{UpdateNominee.nomineeValidateData.CITY}}</span></span></div></div><div class=col-md-4><div class=selectfield ng-class=\"{error:updateNomineeForm[\'state-\'+$index].$dirty && updateNomineeForm[\'state-\'+$index].$invalid}\"><select name=state-{{$index}} ng-disabled=\"nominee.countryCode != \'IN\'\" ng-model=nominee.stateCode ng-init=\"nominee.stateCode=nominee.stateCode?nominee.stateCode:null\" ng-options=\"_state.stateCode as _state.stateName for _state in UpdateNominee.stateList\" ng-change=UpdateNominee.changeState($index,nominee.stateCode) ng-required=UpdateNominee.showNomineeUpdate><option value=\"\" selected>Select State</option></select><label ng-if=nominee.stateCode>STATE</label><span ng-if=UpdateNominee.showNomineeUpdate class=\"req text-red\">*</span> <span ng-show=\"updateNomineeForm[\'state-\'+$index].$dirty && updateNomineeForm[\'state-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'state-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.STATE_REQUIRED}}</span></span></div></div></div><div class=row><div class=col-md-4><div class=selectfield ng-class=\"{error:updateNomineeForm[\'country-\'+$index].$dirty && updateNomineeForm[\'country-\'+$index].$invalid}\"><select name=country-{{$index}} ng-init=\"nominee.countryCode = nominee.countryCode ? nominee.countryCode : null\" ng-model=nominee.countryCode ng-options=\"_country.countryCode as _country.countryName for _country in UpdateNominee.countryList\" ng-change=UpdateNominee.changeCountry($index,nominee.countryCode) ng-required=UpdateNominee.showNomineeUpdate><option value=\"\" selected>Select Country</option></select><label ng-if=nominee.countryCode>Name of country</label><span ng-if=UpdateNominee.showNomineeUpdate class=\"req text-red\">*</span> <span ng-show=\"updateNomineeForm[\'country-\'+$index].$dirty && updateNomineeForm[\'country-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'country-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:updateNomineeForm[\'pinCode-\'+$index].$dirty && updateNomineeForm[\'pinCode-\'+$index].$invalid}\"><input type=text ng-model=nominee.postalCode name=pinCode-{{$index}} is-number ng-minlength=6 minlength=6 ng-maxlength=6 limit-to=6 maxlength=6 ng-required=UpdateNominee.showNomineeUpdate> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code <span class=\"req text-red\" ng-if=UpdateNominee.showNomineeUpdate>*</span></label><span ng-show=\"updateNomineeForm[\'pinCode-\'+$index].$dirty && updateNomineeForm[\'pinCode-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'pinCode-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.PINCODE_REQUIRED}}</span></span></div></div></div></div></div><div class=statement-declaration ng-if=UpdateNominee.showNomineeUpdate><p class=section-title>Statement of Holding(Account Statement) Declaration <span class=\"req text-red\">*</span></p><div class=declaration-content><div class=row><div class=col-md-12><span>I/ We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/ us by the AMC as follows; (please tick, as appropriate)</span></div></div><div class=row><div class=col-md-12><div class=radio-block><span class=radio><input type=radio name=statmentNomination ng-value=true ng-model=UpdateNominee.nomination ng-change=UpdateNominee.setStatement() required> <span class=check></span> </span><span class=radio-label>Nomination: Yes</span></div><div class=radio-block><span class=radio><input type=radio name=statmentNomination ng-value=false ng-model=UpdateNominee.nomination ng-change=UpdateNominee.setStatement() required> <span class=check></span> </span><span class=radio-label>Nomination: No</span></div></div><!--<div class=\"col-md-12 mb-3\">\n              <div class=\"checkbox\">\n                <input ng-model=\"UpdateNominee.nomination\" type=\"checkbox\"\n                       ng-change=\"UpdateNominee.setStatement();\"\n                       ng-required=\"!UpdateNominee.nomineeName\"/>\n                <i class=\"icon-checkbox\"></i>\n                <span class=\"checkbox-text ria\" style=\"margin-top: -10px;\">Nomination: Yes/No</span>\n              </div>\n            </div>\n\n            <div class=\"col-md-12\">\n              <div class=\"checkbox\">\n                <input ng-model=\"UpdateNominee.nomineeName\" type=\"checkbox\"\n                       ng-change=\"UpdateNominee.setStatement();\"\n                       ng-required=\"!UpdateNominee.nomination\" />\n                <i class=\"icon-checkbox\"></i>\n                <span class=\"checkbox-text ria\" style=\"margin-top: -10px;\">Name of Nominee(s)</span>\n              </div>\n            </div>--><!--<div class=\"col-md-12 mt-2\">\n              <span ng-show=\"!UpdateNominee.nomineeName && !UpdateNominee.nomination\">\n                <span class=\"error-input\">{{UpdateNominee.nomineeValidateData.STATEMENT_HOLDING_DECLARATION_REQUIRED}}</span>\n              </span>\n            </div>--></div></div></div><!--<div class=\"statement-declaration\"  ng-if=\"UpdateNominee.showNomineeUpdate && UpdateNominee.folioData.folioDetailsData.folioHoldingMode !== \'Any or survivor\'\">\n        <p class=\"section-title\">Incapacitation Declaration (Optional)\n          <i class=\"info-icon base-tooltip\" data-bs-html=\"true\" tooltip data-bs-toggle=\"tooltip\"\n             data-bs-placement=\"right\"\n             data-bs-title=\'<div>\n                SEBI Circular: SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650 dated January 10, 2025, 3.5 paragraph states, Nominee to act on behalf of incapacitated investors 3.5.1. The regulated entity shall provide the investors having single holding / account / folio, the option to: <br/>\n                a) empower, any one of the nominees (excluding minor nominee) to operate the investor’s account / folio, if the investor is physical incapacitated, but still has the capacity to contract. <br/>\n                b) specify either the percentage or absolute value of assets in the account/ folio that can be encashed by such nominee. <br/>\n                c) change such mandate any number of times without any restriction. <br/>\n              </div>\'>\n          </i>\n        </p>\n        <div class=\"declaration-content\">\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n                <span>I hereby authorize\n                  <select name=\"incapcitationNominee\"\n                          ng-model=\"UpdateNominee.incapcitationNomineeIndex\"\n                          ng-change=\"UpdateNominee.selectedNominee()\"\n                          ng-init=\"UpdateNominee.incapcitationNomine ? UpdateNominee.incapcitationNominee : null\"\n                          ng-options=\"data.value as data.key disable when (data.isMinor) for data in UpdateNominee.incapcitationList\"\n                          >\n                    <option value=\"\" selected>Select Nominee Name</option>\n                  </select>\n                (nominee number <input readonly type=\"text\" ng-model=\"UpdateNominee.folioData.folioDetailsData.incapacitationDeclaration.nomineeNumber\" name=\"nomineeNumber\" is-number maxlength=\"6\">) to operate my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up to\n                  <input type=\"text\" ng-pattern=\"/^(100|[1-9]?[0-9])$/\" ng-model-options=\"{ allowInvalid: true}\" ng-required=\"UpdateNominee.incapcitationNomineeIndex !== null && !UpdateNominee.folioData.folioDetailsData.incapacitationDeclaration.amount\" ng-model=\"UpdateNominee.folioData.folioDetailsData.incapacitationDeclaration.percentage\" ng-change=\"UpdateNominee.folioData.folioDetailsData.incapacitationDeclaration.amount = null\" name=\"percentage\" is-number maxlength=\"3\">% of assets in the account / folio or Rs.\n                  <input type=\"text\" ng-model=\"UpdateNominee.folioData.folioDetailsData.incapacitationDeclaration.amount\" ng-required=\"UpdateNominee.incapcitationNomineeIndex !== null && !UpdateNominee.folioData.folioDetailsData.incapacitationDeclaration.percentage\" name=\"claimAmount\" ng-change=\"UpdateNominee.folioData.folioDetailsData.incapacitationDeclaration.percentage = null\" is-number maxlength=\"20\">.\n                </span>\n\n                <span ng-show=\"UpdateNominee.incapcitationNomineeIndex && updateNomineeForm[\'percentage\'].$dirty && updateNomineeForm[\'percentage\'].$invalid\">\n                  <span class=\"error-input\" ng-show=\"updateNomineeForm[\'percentage\'].$error.pattern && UpdateNominee.folioData.folioDetailsData.incapacitationDeclaration.percentage < 1\">\n                    Amount/percentage cannot be less than 1.\n                  </span>\n                  <span class=\"error-input\" ng-show=\"updateNomineeForm[\'percentage\'].$error.pattern && UpdateNominee.folioData.folioDetailsData.incapacitationDeclaration.percentage > 100\">\n                    Percentage cannot be more than 100%.\n                  </span>\n                </span>\n\n                <span ng-show=\"UpdateNominee.incapcitationNomineeIndex && ((updateNomineeForm[\'percentage\'].$dirty && updateNomineeForm[\'percentage\'].$invalid) || (updateNomineeForm[\'claimAmount\'].$dirty && updateNomineeForm[\'claimAmount\'].$invalid))\">\n                  <span class=\"error-input\" ng-show=\"updateNomineeForm[\'percentage\'].$error.required || updateNomineeForm[\'claimAmount\'].$error.required\">\n                    Please enter the percentage or Rs. that can be encashed by the nominee.\n                  </span>\n                </span>\n            </div>\n          </div>\n        </div>\n      </div>--><div class=tc-block><h6>Terms & Conditions</h6><div class=checkbox><input type=checkbox name=TnC ng-model=UpdateNominee.TnC ng-click=UpdateNominee.tncCheck() required> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=UpdateNominee.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div><div class=\"form-footer form-content\"><div class=text-danger ng-bind=validationMsg ng-show=updateNomineeForm.$invalid></div><a href=\"\" class=\"pull-left back\" ng-click=UpdateNominee.goToBack()><i class=arrow-blue-back-icon></i>Back</a> <span class=pull-right><button type=button class=\"btn btn-secondary-action\" ng-click=UpdateNominee.goToBack()>Cancel</button> <button class=\"btn btn-primary-action\" ng-disabled=\"updateNomineeForm.$invalid || UpdateNominee.totalPercentage != \'100\' || UpdateNominee.proportion_msg != \'\' || !UpdateNominee.minorPanValid || !UpdateNominee.nomineePanValid || !UpdateNominee.investorEmail || !UpdateNominee.investorMobile || UpdateNominee.dobRequired || !UpdateNominee.emailIdValid || (UpdateNominee.incapcitationNominee && ((updateNomineeForm[\'percentage\'].$dirty && updateNomineeForm[\'percentage\'].$invalid) || (updateNomineeForm[\'claimAmount\'].$dirty && updateNomineeForm[\'claimAmount\'].$invalid)) || !UpdateNominee.nomineeLicenseValid || !UpdateNominee.nomineeAadhaarValid || !UpdateNominee.nomineePassportValid)\" ng-click=UpdateNominee.nomineeUpdate()>Submit</button></span></div></div></section></form><style>.input-pan input:focus ~ label , .input-pan input.ng-not-empty ~ label{\n    top: -5px !important;\n    font-size: 12px !important;\n  }</style>");
$templateCache.put("app/investor/profile/optoutNominee/optoutNominee.html","<form class=\"main-section clearfix modifyNominee\" name=OptoutNomineeForm id=OptoutNomineeForm ng-init=OptoutNominee.folioDetailsData><h5 class=screen-title>Opt-out of Nomination</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.profile.folioDetails>Folio Details </span><i class=breadcrumb-icon></i><span> Opt-out of Nomination</span></p><div class=folio-OptoutNominee><strong>Folio : </strong><span>{{OptoutNominee.folioNo}}</span></div><section class=nominee-details><div class=form-content><div style=\"padding: 20px 0px\"><label style=\"padding: 5px; font-size: 16px\"><strong>Contact Details</strong></label><div class=row style=\"padding: 5px\"><div class=col-md-3 style=\"margin-right: 40px\" ng-if=OptoutNominee.investorEmail><label style=\"margin-top: 30px; display: inline-flex\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{OptoutNominee.investorEmail}}</label></div><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!OptoutNominee.investorEmail><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : Not available</label></div><!--            <div class=\"col-md-3 belongsToContainerMobile emailBelongsMobile\" style=\"display: inline-flex;  margin-right: 40px;\" ng-if=\"UpdateNominee.investorEmail\">--><!--              <div style=\"flex-shrink : 0;\">--><!--                <label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> : </label>--><!--              </div>--><!--              <div class=\"selectfield\" style=\"display: inline-block ; margin-left : 5px;\"--><!--                   ng-class=\"{error:soleApplicantForm.emailBelongsTo.$dirty && soleApplicantForm.emailBelongsTo.$invalid}\">--><!--                <select class=\"browser-default custom-select\" name=\"emailBelongsTo\" style=\"width: 150px\"--><!--                        ng-model=\"holders.emailBelongsTo\"--><!--                        ng-init=\"holders.emailBelongsTo = holders.emailBelongsTo ? holders.emailBelongsTo: null\"--><!--                        ng-options=\"data.familyCode as data.familyDescription for data in UpdateNominee.belongToListEmail\"--><!--                        required>--><!--                  <option value=\"\" selected>Select Value</option>--><!--                </select>--><!--                <span class=\"req text-red\">*</span>--><!--              </div>--><!--            </div>--><div class=\"col-md-3 mLabel\" ng-if=OptoutNominee.investorMobile><label class=mobile-belongs-to style=\"margin-top: 30px; margin-left:30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : {{OptoutNominee.investorMobile}}</label></div><div class=col-md-3 ng-if=!OptoutNominee.investorMobile><label class=mobile-belongs-to style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : Not available</label></div></div><div class=row style=\"padding: 5px\"><div class=\"col-md-3 belongsToContainerWeb\" style=\"display: inline-flex;  margin-right: 40px\" ng-if=OptoutNominee.investorEmail><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block ; margin-left : 5px\" ng-class=\"{error:OptoutNomineeForm.emailBelongsTo.$dirty && OptoutNomineeForm.emailBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=emailBelongsTo style=\"width: 150px\" ng-model=OptoutNominee.emailBelongsTo ng-init=\"OptoutNominee.emailBelongsTo = OptoutNominee.emailBelongsTo ? OptoutNominee.emailBelongsTo: null\" ng-options=\"data.familyCode as data.familyDescription for data in OptoutNominee.belongToListEmail\" required><option value=\"\" selected>Select Value</option></select><span ng-if=\"OptoutNomineeForm.emailBelongsTo.$dirty && OptoutNomineeForm.emailBelongsTo.$invalid\"><span class=error-input style=\"width: max-content\" ng-if=OptoutNomineeForm.emailBelongsTo.$error.required>{{UpdateNominee.validateData.EMAIL_BELONGS_TO}}</span></span></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!OptoutNominee.investorEmail></div><div class=\"col-md-3 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=OptoutNominee.investorMobile><div class=mobile-belongs-to style=\"flex-shrink : 0; margin-left: 30px\"><label class=mobile-belongs-to style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block\" ng-class=\"{error:OptoutNomineeForm.mobileBelongsTo.$dirty && OptoutNomineeForm.mobileBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=mobileBelongsTo style=\"width: 150px\" ng-model=OptoutNominee.mobileBelongsTo ng-init=\"OptoutNominee.mobileBelongsTo = OptoutNominee.mobileBelongsTo ? OptoutNominee.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in OptoutNominee.belongToListMobile\" required><option value=\"\" selected>Select Value</option></select><span ng-if=\"OptoutNomineeForm.mobileBelongsTo.$dirty && OptoutNomineeForm.mobileBelongsTo.$invalid\"><span class=error-input style=\"width: max-content\" ng-if=OptoutNomineeForm.mobileBelongsTo.$error.required>{{UpdateNominee.validateData.MOBILE_BELONGS_TO}}</span></span></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=col-md-3 style=\"margin-right: 40px\" ng-if=!OptoutNominee.investorMobile></div></div></div><div class=optOutalign><div class=\"checkbox optoutNomineeCheckbox\"><input type=checkbox name=TnC ng-model=OptoutNominee.TnC required> <i class=icon-checkbox style=\"padding-right: 25px\"></i><ng-bind-html class=text-justify dynamic=OptoutNominee.dynamicNote.content></ng-bind-html></div></div><div class=\"form-footer form-content optOutFooter\"><div class=text-danger ng-bind=validationMsg ng-show=updateNomineeForm.$invalid></div><a href=\"\" class=\"pull-left back\" ng-click=OptoutNominee.goToBack()><i class=arrow-blue-back-icon></i>Previous</a> <span class=pull-right><button type=button class=\"btn btn-secondary-action\" ng-click=OptoutNominee.goToBack()>Cancel</button> <button class=\"btn btn-primary-action\" ng-disabled=\"!OptoutNominee.TnC || OptoutNomineeForm.$invalid || !OptoutNominee.investorMobile || !OptoutNominee.investorEmail\" ng-click=OptoutNominee.goToContinueOptOutNomination()>Continue</button></span></div></div></section></form><style>.input-pan input:focus ~ label , .input-pan input.ng-not-empty ~ label{\n    top: -5px !important;\n    font-size: 12px !important;\n  }</style>");
$templateCache.put("app/investor/profile/profileDetails/basicInfo.html","<section class=basic-info ng-init=Profile.basicDetails();><div class=content-area><form autocomplete=off name=profileForm><div class=row><div class=col-md-12><div class=\"col-md-3 col-sm-12 profile-section\"><div class=investor-img><img http-src={{Profile.basic.profileImageUrl}} ng-if=Profile.basic.profileImageUrl alt=\"profile pic\"> <img src=assets/images/bg_profile.png ng-if=!Profile.basic.profileImageUrl alt=\"profile pic\" style=\"width: 100%\"> <span class=welcome-edit><input type=file id=changeImg accept=.jpeg,.jpg,.png file-model-profile=Profile.profileImage upload=Profile.uploadProfileImage(file)><label for=changeImg></label><i class=welcome-edit-icon></i></span></div><div class=caption><p class=text-center>{{Profile.nameFull | camelcase}}</p></div></div><div class=col-md-6><table class=\"table info-data\"><tbody><tr><td>PAN</td><td>:</td><td class=text-bold ng-bind=Profile.basic.basicInfo.panNumber easyassist-key=mask-element></td></tr><tr><td>KYC Status</td><td>:</td><!-- TODO: Uncomment update in line below--><td class=text-bold><span>{{Profile.basic.basicInfo.kycStatus}}</span>&nbsp;&nbsp;&nbsp;&nbsp; <strong class=\"text-blue cursor-pointer\" role=button ng-click=Profile.updateKYC() ng-class=\"{\'anything-disabled\': !Profile.basic.basicInfo.dob || !Profile.basic.basicInfo.panNumber}\"><u>(Update KYC)</u></strong> <span class=\"verify pull-right\"><i ng-if=Profile.basic.basicInfo.kycVerified class=verify-small-icon></i></span></td></tr><tr><td>DOB / DOI</td><td>:</td><td class=text-bold ng-bind=Profile.basic.basicInfo.dob easyassist-key=mask-element>06/9/1986</td></tr><tr><td>Permanent Address</td><td>:</td><!-- TODO: Uncomment edit icon in line below--><td class=text-bold><span ng-bind=Profile.basic.basicInfo.permanentAddress easyassist-key=mask-element></span><!--<i class=\"edit-icon pull-right\"></i>--></td></tr><tr><td style=\"width : 130px\">Mobile</td><td>:</td><td class=text-bold ng-if=!Profile.contactEdit><!-- <span ng-bind=\"Profile.basic.basicInfo.mobileNo\"></span>--> <input type=text value=\"{{Profile.formData.contact?Profile.formData.contact:\'Not Available\'}}\" name=contact class=\"pd40 contactProfile\" easyassist-key=mask-element disabled> <i class=\"edit-icon pull-right\" ng-click=Profile.updateContact()></i></td><td ng-if=Profile.contactEdit ng-class=\"{error:profileForm.contactEdited.$dirty && profileForm.contactEdited.$invalid}\"><select name=contactEdited ng-init=Profile.formData.contact ng-model=Profile.formData.contactEdited ng-options=\"contact.mobileNumber as (contact.mobileNumber) for contact in Profile.mobileListData\" easyassist-key=mask-element required></select><span class=error-input ng-messages=profileForm.contactEdited.$error ng-show=profileForm.contactEdited.$dirty><span ng-message=required ng-bind=Profile.validateData.MOBILE_REQUIRED></span></span></td></tr><tr ng-if=Profile.contactEdit class=BelongsTo><td>Mobile No. Belongs To</td><td>:</td><td><select name=mobileBelongsToProfile ng-init=\"Profile.mobileBelongsToProfile = Profile.mobileBelongsToProfile ? Profile.mobileBelongsToProfile : null\" ng-model=Profile.mobileBelongsToProfile ng-options=\"_type.familyCode as _type.familyDescription for _type in Profile.belongToListMobile\" easyassist-key=mask-element required><option value=\"\" selected>Select Value</option></select><div class=actionButton><button type=button ng-click=Profile.saveNewContact() ng-disabled=\"!Profile.mobileBelongsToProfile || profileForm.contactEdited.$invalid || !Profile.saveContactBtn\" class=save>Save</button> <button type=button ng-click=\"Profile.contactEdit = false; Profile.mobileBelongsToProfile = null;\" class=save>Cancel</button></div></td></tr></tbody></table><div ng-if=Profile.mobileActive class=trai-notification><span ng-bind-html=Profile.appConstants.TRAI.NOTIFICATION></span></div></div><div class=\"col-md-3 account-details-container acc-details\"><p>Account Details</p><table class=\"table account-details\"><tbody><tr><td class=set-width-td-label>User ID</td><td>:</td><td class=text-bold easyassist-key=mask-element ng-if=\"Profile.basic.accountDetails.userId && Profile.idCreated\">{{Profile.basic.accountDetails.userId}}</td><td class=text-bold easyassist-key=mask-element ng-if=\"Profile.basic.accountDetails.userId && !Profile.idCreated\" style=\"display: flex\"><p style=\"font-size: 13px\">Not Created</p><i class=\"info-icon base-tooltip\" tooltip data-bs-toggle=tooltip data-bs-placement=right style=\"Z-INDEX: 36;margin-left: 10px\" data-bs-title=\"You have logged in using your mobile number. You may choose to create user ID or continue to use mobile number to login.\" tooltip-side=right></i></td></tr><tr><td class=set-width-td-label>Password</td><td>:</td><td class=text-bold easyassist-key=mask-element ng-if=\"Profile.basic.accountDetails.userId && Profile.idCreated\">******* <i class=\"edit-icon pull-right\" ng-click=Profile.changePassword()></i></td><td class=text-bold easyassist-key=mask-element ng-if=\"Profile.basic.accountDetails.userId && !Profile.idCreated\">Not Created</td></tr><tr><td class=set-width-td-label>Email ID</td><td>:</td><!--<td>{{Profile.basic.accountDetails.emailId}} <i class=\"edit-icon pull-right\"></i></td>--><td ng-if=!Profile.emailEdit class=\"emailprofile text-bold basicProfileEmailContainer\" easyassist-key=mask-element><input type=text value=\"{{Profile.formData.emailAddress?Profile.formData.emailAddress:\'Not Available\'}}\" name=emailAddress class=\"pd40 contactProfile\" easyassist-key=mask-element disabled style=\"width: 170px; padding: 0px\"> <i class=\"edit-icon pull-right\" ng-click=Profile.updateEmail()></i></td><td ng-if=Profile.emailEdit ng-class=\"{error:profileForm.emailAddressEdited.$dirty && profileForm.emailAddressEdited.$invalid}\"><select name=emailAddressEdited class=email-profile-width ng-init=Profile.formData.emailAddress ng-model=Profile.formData.emailAddressEdited ng-options=\"contact.emailId as (contact.emailId) for contact in Profile.emailListData\" easyassist-key=mask-element required></select><span class=error-input ng-messages=profileForm.emailAddressEdited.$error ng-show=profileForm.emailAddressEdited.$dirty><span ng-message=required ng-bind=Profile.validateData.EMAIL_REQUIRED></span> <span ng-message=pattern ng-bind=Profile.validateData.EMAIL_FIELD></span></span></td></tr><tr ng-if=Profile.emailEdit class=BelongsTo><td class=set-width-td-label>Email ID Belongs To</td><td>:</td><td><select name=emailBelongsToProfile class=email-profile-width ng-init=\"Profile.emailBelongsToProfile = Profile.emailBelongsToProfile ? Profile.emailBelongsToProfile : null\" ng-model=Profile.emailBelongsToProfile ng-options=\"_type.familyCode as _type.familyDescription for _type in Profile.belongToListEmail\" easyassist-key=mask-element required><option value=\"\" selected>Select Value</option></select><div class=actionButton><button type=button ng-click=Profile.saveNewEmail() ng-disabled=\"!Profile.emailBelongsToProfile || profileForm.emailAddressEdited.$invalid || !Profile.saveEmailBtn\" class=save>Save</button> <button type=button ng-click=\"Profile.emailEdit = false; Profile.emailBelongsToProfile = null\" class=save>Cancel</button></div></td></tr></tbody></table><div class=register-for-whatsapp ng-click=Profile.registerForWhatsapp() ng-class=\"{disablelink:(!Profile.mobileNoExists || Profile.whatsappTransactionSubscribed || Profile.disableLinkNow)}\">Register to transact on WhatsApp</div><div class=\"error-input error-subscribe\" ng-show=\"Profile.whatsappTransactionSubscribed || Profile.disableLinkNow\">*Mobile Number already registered for WhatsApp Service</div><div class=\"error-input error-subscribe\" ng-show=!Profile.mobileNoExists>*Please register your Mobile Number to enable this service.</div><div class=acc-details><table class=\"table bd-top\"><tbody><tr><td class=\"set-width-td-label whatsapp-label\">WhatsApp Transaction Notification</td><td>:</td><td class=td-flex easyassist-key=mask-element><span class=span-flex ng-class=\"{\'anything-disabled\': Profile.isDisabled}\"><span class=\"toggle-login-text td-item\">Unsubscribe</span><div class=\"login-form-switch td-item\"><label class=switch><input type=checkbox ng-model=Profile.subscribedToggleFlagForWhatsapp ng-click=Profile.toggleWhatsapp() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div><span class=\"toggle-login-text td-item\">Subscribe</span> </span><span class=td-item ng-if=Profile.isDisabled><i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=auto data-bs-title=\"Kindly update your mobile number to avail  Whats App Transaction Notification service\"></i></span></td></tr></tbody></table></div></div></div></div><ng-bind-html ng-bind-html=Profile.dynamicDataNote></ng-bind-html></form></div></section><form autocomplete=off name=ekycForm id=ekycForm method=POST enctype=multipart/form-data action={{Profile.actionUrl}}><input id=url type=hidden name=url ng-value=Profile.ekycRequestCO.url> <input id=sess_id type=hidden name=sess_id ng-value=Profile.ekycRequestCO.sess_id> <input id=ekyctype type=hidden name=ekyctype ng-value=Profile.ekycRequestCO.ekyctype> <input id=Plkyc_type type=hidden name=Plkyc_type ng-value=Profile.ekycRequestCO.plkyc_type> <input id=kyc_data type=hidden name=kyc_data ng-value=Profile.ekycRequestCO.kyc_data></form>");
$templateCache.put("app/investor/profile/profileDetails/folioDetails.html","<form autocomplete=off name=profileForm><div class=folio-info ng-init=Profile.folioDetails();Profile.basicDetails();><div class=folio-numbers ng-if=Profile.folioListData.length ng-init=Profile.getFolioDetailsInit();><!--<span class=\"active\">678945</span>--><ol class=list-inline><!-- TODO:Angular first li should have \"btn-secondary-action\" class --><!--<li ng-repeat=\"data in Profile.soleApplicant.folioList\" ng-bind=\"data.folioId\">678945</li>--><!--<li>678945</li>\n        <li>678945</li>\n        <li>678945</li>--><li ng-repeat=\"folio in Profile.folioListData track by $index\" ng-class=\"{active:Profile.currentFolioIndx==$index}\" ng-click=Profile.getDetails(folio,$index)><!--        ng-class=\"{active : ($index == Profile.currentFolioIndx)}\"--> <span ng-bind=folio.folioNo></span></li></ol></div><div class=mrg4><table class=table-data><tbody><tr><td>Holding Mode:</td><td ng-bind=\"Profile.folioDetailsData.folioHoldingMode||\'Not Available\'\"></td></tr><tr><td>Tax Status:</td><td ng-bind=\"Profile.folioDetailsData.folioTaxStatus||\'Not Available\'\"></td></tr><tr><td><span class=grey-text>Supplementary KYC:</span></td><td ng-if=\"Profile.kycStatus!=\'\'\"><span class=text-green ng-if=\"Profile.kycStatus==\'Y\'\">Completed </span><span ng-if=\"Profile.kycStatus!=\'Y\'\">Incomplete </span><strong class=\"text-blue cursor-pointer\" ng-click=Profile.redirecToKycUpdate(Profile.selectedFolio)>Update</strong></td><td ng-if=\"Profile.kycStatus ===\'\'\"></td></tr><tr><td><span class=grey-text>FATCA and CRS:</span></td><td ng-if=\"Profile.fatcaStatus!=\'\' && Profile.fatcaStatus==\'NA\'\"><span>NA <i class=\"info-icon base-tooltip\" tooltip data-bs-toggle=tooltip data-bs-placement={{Main.tooltipClass}} data-bs-title=\"FATCA compliance is applicable for folios created\n          between 01-Jul-2014 and 31-Aug-2015. FATCA compliance is not applicable for folios created out of this date range.\"></i> </span><!--<strong class=\"text-blue cursor-pointer\" ng-click=\"Profile.redirecToFatcaUpdate(Profile.selectedFolio)\">Update</strong>--></td><td ng-if=\"Profile.fatcaStatus!=\'\' &&  Profile.fatcaStatus!=\'NA\'\"><span ng-if=\"Profile.fatcaStatus==\'Completed\'\">Completed </span><span ng-if=\"Profile.fatcaStatus!=\'Completed\'\">Not Submitted/Incomplete </span><strong class=\"text-blue cursor-pointer\" ng-click=Profile.redirecToFatcaUpdate(Profile.selectedFolio)>Update</strong></td></tr><!-- <tr>\n           <td>Aadhar Status:</td>\n           &lt;!&ndash;<td ng-if=\"Profile.folioDetailsData.aadharStatus\" class=\"text-green\">Linked</td>&ndash;&gt;\n           <td ng-bind=\"Profile.folioDetailsData.aadharStatus||\'Not Available\'\">\n             &lt;!&ndash;<a style=\"cursor: pointer;\" ng-href=\"{{Profile.folioDetailsData.aadharLinkURL}}\" target=\"_blank\"\n                title=\"Click here to link AADHAAR\">Not Linked (Click to link)</a>&ndash;&gt;\n           </td>\n         </tr>--></tbody></table></div><div class=\"clearfix bg-grey nobrd folio-header\" ng-if=!Profile.isObjectEmpty(Profile.folioDetailsData.guardianDetails)><p class=\"strong pull-left\">Guardian Details</p></div><div class=\"mrg4 mrg40\" ng-if=!Profile.isObjectEmpty(Profile.folioDetailsData.guardianDetails)><table class=table-data><tr ng-if=Profile.folioDetailsData.guardianDetails.name><td>Name</td><td>:</td><td>{{Profile.folioDetailsData.guardianDetails.name}}</td></tr><tr ng-if=Profile.folioDetailsData.guardianDetails.pan><td>PAN</td><td>:</td><td>{{Profile.folioDetailsData.guardianDetails.pan}}</td></tr><tr ng-if=Profile.folioDetailsData.guardianDetails.relation><td>Relationship</td><td>:</td><td>{{Profile.folioDetailsData.guardianDetails.relation}}</td></tr><tr ng-if=Profile.folioDetailsData.guardianDetails.dob><td>Date of birth</td><td>:</td><td>{{Profile.folioDetailsData.guardianDetails.dob}}</td></tr><tr ng-if=Profile.folioDetailsData.guardianDetails.kyc><td>KYC Status</td><td>:</td><td>{{Profile.folioDetailsData.guardianDetails.kyc}}</td></tr><tr ng-if=Profile.folioDetailsData.guardianDetails.aadharStatus><td>Aadhar Status</td><td>:</td><td>{{Profile.folioDetailsData.guardianDetails.aadharStatus}}</td></tr><tr ng-if=Profile.folioDetailsData.guardianDetails.aadharLinked><td>Aadhar Linked</td><td>:</td><td>{{Profile.folioDetailsData.guardianDetails.aadharLinked}}</td></tr></table></div><div class=\"clearfix bg-grey nobrd folio-header\"><p class=\"strong pull-left\">Contact Details</p></div><div class=mrg23 ng-if=!Profile.folioDetailsData.contactDetails>No Data Available.</div><div class=\"mrg4 mrg40\" ng-if=Profile.folioDetailsData.contactDetails><table class=table-data><tbody><tr><td>Email:</td><td ng-if=!Profile.folioEmailEdit class=\"emailprofile text-bold\"><!--<input type=\"text\" value=\"{{Profile.formData.folioEmailAddress?Profile.formData.folioEmailAddress:\'Not Available\'}}\"  name=\"folioEmailAddress\"--><!--class=\"pd40 contactProfile\" disabled>--> <span ng-bind=\"Profile.formData.folioEmailAddress?Profile.formData.folioEmailAddress:\'Not Available\'\" easyassist-key=mask-element></span> <strong ng-if=\"!Profile.formData.folioEmailAddress && !Profile.folioMobileEdit\" class=\"text-blue cursor-pointer\" ng-click=Profile.updateFolioEmail()>Add</strong> <strong ng-if=\"Profile.formData.folioEmailAddress && Profile.formData.folioMobileContact && !Profile.folioMobileEdit\" class=\"text-blue cursor-pointer\" ng-click=Profile.updateFolioEmail()>Update</strong></td><td ng-if=Profile.folioEmailEdit ng-class=\"{error:profileForm.folioEmailAddressEdited.$dirty && profileForm.folioEmailAddressEdited.$invalid}\"><input type=text ng-class=\"{\'activeborder\': Profile.folioEmailEdit}\" maxlength=150 ng-model=Profile.formData.folioEmailAddressEdited autofocus name=folioEmailAddressEdited class=\"pd40 email-edit\" ng-pattern=Profile.appConstants.email_regex autocomplete=off easyassist-key=mask-element required> <span class=error-input ng-messages=profileForm.folioEmailAddressEdited.$error ng-show=profileForm.folioEmailAddressEdited.$dirty><span ng-message=required ng-bind=Profile.validateData.EMAIL_REQUIRED></span> <span ng-message=pattern ng-bind=Profile.validateData.EMAIL_FIELD></span></span></td></tr><tr ng-if=Profile.folioEmailEdit><td>Email ID Belongs To:</td><td style=\"display: flex; flex-direction: column; align-items: baseline\"><select ng-model=Profile.emailBelongsTo style=\"height: 25px\" ng-options=\"_type.familyCode as _type.familyDescription for _type in Profile.belongToListEmail\" ng-init=\"Profile.emailBelongsTo = Profile.emailBelongsTo ? Profile.emailBelongsTo : null\"><option value=\"\" selected>Select Value</option></select><div style=\"margin-top: 10px; display: flex; flex-direction: row-reverse\"><button type=button ng-click=\"Profile.folioEmailEdit = false; Profile.emailBelongsTo = null;\" class=\"save pull-right\">Cancel</button> <button type=button ng-click=Profile.saveNewFolioEmail() ng-disabled=\"!Profile.emailBelongsTo || profileForm.folioEmailAddressEdited.$invalid || !Profile.saveFolioEmailBtn\" class=\"save pull-right\">Save</button></div></td></tr><tr><td>Mobile:</td><td class=text-bold ng-if=!Profile.folioMobileEdit><span easyassist-key=mask-element ng-bind=\"Profile.folioDetailsData.contactDetails.mobileNumber ?Profile.folioDetailsData.contactDetails.mobileNumber :\'Not Available\'\"></span> <strong class=\"text-blue cursor-pointer\" ng-if=\"!Profile.formData.folioMobileContact && !Profile.folioEmailEdit\" ng-click=Profile.updateFolioContact()>Add</strong> <strong class=\"text-blue cursor-pointer\" ng-if=\"Profile.formData.folioMobileContact && Profile.formData.folioEmailAddress && !Profile.folioEmailEdit\" ng-click=Profile.updateFolioContact()>Update</strong></td><td ng-if=Profile.folioMobileEdit ng-class=\"{error:profileForm.folioMobileEdited.$dirty && profileForm.folioMobileEdited.$invalid}\"><input type=text ng-class=\"{\'activeborder\': Profile.folioMobileEdit}\" ng-model=Profile.formData.folioMobileEdited autofocus name=folioMobileEdited class=pd40 minlength=10 maxlength=13 autocomplete=off ng-change=Profile.updateMobileChange() easyassist-key=mask-element required><div><span class=error-input ng-messages=profileForm.folioMobileEdited.$error ng-show=profileForm.folioMobileEdited.$dirty><span ng-message=required ng-bind=Profile.validateData.MOBILE_REQUIRED></span> <span ng-if=\"(!Profile.isValid || Profile.isMobileNotValid) && !profileForm.folioMobileEdited.$invalid\" ng-bind=Profile.validateData.MOBILE_ISD></span> <span ng-message=minlength ng-bind=Profile.validateData.MOBILE_FIELD></span> <span ng-message=maxlength ng-bind=Profile.validateData.MOBILE_FIELD></span></span></div></td></tr><tr ng-if=Profile.folioMobileEdit><td>Mobile No. Belongs To:</td><td style=\"display: flex; flex-direction: column; align-items: baseline\"><select ng-model=Profile.mobileBelongsTo style=\"height: 25px\" ng-options=\"_type.familyCode as _type.familyDescription for _type in Profile.belongToListMobile\" ng-init=\"Profile.mobileBelongsTo = Profile.mobileBelongsTo ? Profile.mobileBelongsTo : null\"><option value=\"\" selected>Select Value</option></select><div style=\"margin-top: 10px; display: flex; flex-direction: row-reverse\"><button type=button ng-click=\"Profile.folioMobileEdit = false; Profile.mobileBelongsTo = null;\" class=\"save pull-right\">Cancel</button> <button type=button ng-click=Profile.saveNewFolioContact() ng-disabled=\"!Profile.isValid || Profile.isMobileNotValid || !Profile.mobileBelongsTo || profileForm.folioMobileEdited.$invalid || !Profile.saveFolioContactBtn\" class=\"save pull-right\">Save</button></div></td></tr></tbody></table></div><div class=subscribe-toggle ng-if=Profile.folioDetailsData.contactDetails.mobileNumber><p class=\"strong pull-left marketing-heading\">Marketing SMS Communication:</p><ul class=subscribe-toggle-panel><li><span class=toggle-login-text>Unsubscribe</span></li><li><div class=login-form-switch><label class=switch><input type=checkbox ng-model=Profile.subscribedToggleFlag ng-click=Profile.toggleMarketing() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text>Subscribe</span></li></ul><p class=\"marketing-heading strong\">(Note: Change in subscription may take up to 5 working days to take effect)</p></div><div ng-if=\"Profile.folioDetailsData.jointHolders.length>0\"><div class=\"clearfix bg-grey folio-header\"><p class=\"pull-left strong\">Joint Holders</p></div><div class=\"mrg40 joint-holder\"><div class=scroll-horz><ol class=\"pd20 list-inline tab-type2\"><li ng-repeat=\"data in Profile.folioDetailsData.jointHolders\" ng-class=\"{active : ($index == Profile.currentJdHolderIndx),\'cursor-pointer\':($index != Profile.currentJdHolderIndx)}\" ng-click=\"Profile.showJointHolderDetails(data, $index); Profile.currentJdHolderIndx = $index;\"><span ng-bind=data.firstName></span></li></ol></div><table class=table-data><tbody><tr><td>PAN</td><td>:</td><td ng-bind=Profile.jointHoldersDetails.panNumber></td></tr><tr><td>Date of Birth</td><td>:</td><!--<td ng-bind=\"Profile.soleApplicant.jointHolders[Profile.currentJdHolderIndx].dob\"></td>--><td ng-bind=\"Profile.jointHoldersDetails.dateOfBirth || \'NA\'\"></td></tr><tr><td>KYC Status</td><td>:</td><td ng-bind=Profile.jointHoldersDetails.kycstatus></td></tr><tr><td><span>Aadhar Status</span></td><td>:</td><!--<td ng-if=\"Profile.jointHoldersDetails.aadharStatus\" class=\"text-green\">Linked</td>--><td ng-bind=\"Profile.jointHoldersDetails.aadharStatus||\'Not Available\'\"><!--<a style=\"cursor: pointer;\" ng-href=\"{{Profile.jointHoldersDetails.aadharLinkURL}}\" target=\"_blank\"\n                 title=\"Click here to link AADHAAR\">Not Linked (Click to link)</a>--></td></tr></tbody></table></div></div><div class=\"clearfix bg-grey folio-header\"><p class=\"strong pull-left\">Nominee Details</p><span class=optedOut-txt ng-if=Profile.folioDetailsData.optedOutNominee ng-class=\"{\'anything-disabled\' : Profile.folioDetailsData.optedOutNominee}\">(Opted-out of Nomination)</span> <span class=pull-right style=\"display: flex\"><ul class=modify-nominee><li ng-click=Profile.redirectToUpdateNominee() ng-if=Profile.folioDetailsData.addUpdateNominee>Add/Update Nominee</li></ul><!--        <ul class=\"modify-nominee\" ng-if=\"Profile.folioDetailsData.folioHoldingMode.toLowerCase().split(\' \').join(\'\') == \'anyorsurvivor\'--><!--            || Profile.folioDetailsData.folioHoldingMode.toLowerCase().split(\' \').join(\'\') == \'jointholder\'\">--><!--            <li ng-if=\"Profile.folioDetailsData.folioTaxStatusCode == 01 || Profile.folioDetailsData.folioTaxStatusCode == 11 || Profile.folioDetailsData.folioTaxStatusCode == 21 || Profile.folioDetailsData.folioTaxStatusCode == 24\" ng-click=\"Profile.offlineNomineeForm()\">Add/Update Nominee</li>--><!--       </ul>--><ul class=modify-nominee ng-if=Profile.folioDetailsData.optOutNominee><li ng-click=Profile.goToNomineeOptOut()>Opt-out of Nomination</li></ul><!--      <ul class=\"modify-nominee\"--><!--          ng-if=\"Profile.folioDetailsData.cancelNomination && Profile.folioDetailsData.nominees.length!=0\">--><!--       <li ng-click=\"Profile.cancelNominee()\">Cancel Nomination</li>--><!--    </ul>--> </span><!-- TODO: Uncomment it --><!--<p class=\"pull-right\"><i class=\"edit-icon\"></i><span>Edit</span></p>--></div><div class=mrg23 ng-if=\"Profile.folioDetailsData.nominees.length == 0\">No Nominee Registered.</div><div class=mrg40 ng-if=\"Profile.folioDetailsData.nominees.length>0\"><div class=scroll-horz><ol class=\"pd20 list-inline tab-type2\"><li ng-repeat=\"nominee in Profile.folioDetailsData.nominees track by $index\" ng-class=\"{active :Profile.currentNomineeIndx==$index}\" ng-click=Profile.showNomineeDetails(nominee,$index)><span ng-if=Profile.folioDetailsData.nominees>{{$index+1}}.</span> <span easyassist-key=mask-element ng-bind=nominee.firstName></span></li></ol></div><table class=table-data><tbody><tr><td>Relationship with Applicant</td><td>:</td><td easyassist-key=mask-element ng-bind=\"Profile.nomineeDetails.relation || \'NA\'\">Son</td></tr><tr><td>Proportion in %</td><td>:</td><td easyassist-key=mask-element ng-if=Profile.nomineeDetails.percentage>{{Profile.nomineeDetails.percentage}}%</td><td ng-if=!Profile.nomineeDetails.percentage>NA</td></tr><tr><td>Date of Birth</td><td>:</td><td easyassist-key=mask-element ng-bind=\"Profile.nomineeDetails.dateOfBirth || \'NA\'\">1 Dec1987</td></tr><tr><td>The nominee is minor</td><td>:</td><td easyassist-key=mask-element ng-if=Profile.nomineeDetails.minor>Yes</td><td easyassist-key=mask-element ng-if=!Profile.nomineeDetails.minor>No</td></tr><tr><td>Address</td><td>:</td><td ng-if=\"Profile.nomineeDetails.address1 || Profile.nomineeDetails.address2 || Profile.nomineeDetails.address3\"><span easyassist-key=mask-element>{{Profile.nomineeDetails.nomineeAddress1}}</span> <span ng-if=Profile.nomineeDetails.nomineeAddress2>, </span><span easyassist-key=mask-element>{{Profile.nomineeDetails.nomineeAddress2}} </span><span ng-if=Profile.nomineeDetails.nomineeAddress3>, </span><span easyassist-key=mask-element>{{Profile.nomineeDetails.address3}} </span><span>, {{Profile.nomineeDetails.city}} , {{Profile.nomineeDetails.state}} , {{Profile.nomineeDetails.country}} , {{Profile.nomineeDetails.postalCode}}</span></td><td ng-if=\"!Profile.nomineeDetails.address1 && !Profile.nomineeDetails.address2 && !Profile.nomineeDetails.address3\">NA</td></tr><tr ng-if=\"Profile.folioDetailsData.sebiNomineeRegulatory01650Active && Profile.nomineeDetails.emailId\"><td>Nominee Email Id</td><td>:</td><td easyassist-key=mask-element ng-bind=\"Profile.nomineeDetails.emailId || \'NA\'\"></td></tr><tr ng-if=\"Profile.folioDetailsData.sebiNomineeRegulatory01650Active && Profile.nomineeDetails.mobileNumber\"><td>Nominee Mobile No.</td><td>:</td><td easyassist-key=mask-element ng-bind=\"Profile.nomineeDetails.mobileNumber || \'NA\'\"></td></tr><tr ng-if=\"Profile.folioDetailsData.sebiNomineeRegulatory01650Active && Profile.nomineeDetails.identityProofType\"><td>Nominee Personal Identifier</td><td>:</td><td easyassist-key=mask-element ng-bind=\"Profile.nomineeDetails.identityProofDescription || \'NA\'\"></td></tr><tr ng-if=\"Profile.folioDetailsData.sebiNomineeRegulatory01650Active && Profile.nomineeDetails.identityProofNumber\"><td ng-if=\"Profile.nomineeDetails.identityProofType === \'AADHAR_CARD\'\">Nominee Aadhar Card</td><td ng-if=\"Profile.nomineeDetails.identityProofType === \'DRIVING_LICENSE\'\">Nominee Driving License</td><td ng-if=\"Profile.nomineeDetails.identityProofType === \'PAN_CARD\'\">Nominee Pan</td><td ng-if=\"Profile.nomineeDetails.identityProofType === \'PASSPORT\'\">Nominee Passport</td><td ng-if=\"Profile.nomineeDetails.identityProofType === \'OTHERS\'\">Nominee Others Identity</td><td>:</td><td ng-if=Profile.nomineeDetails.identityProofNumber><span easyassist-key=mask-element><span ng-if=\"Profile.nomineeDetails.identityProofType === \'AADHAR_CARD\'\">XXXX XXXX </span>{{Profile.nomineeDetails.identityProofNumber}}</span></td><td ng-if=!Profile.nomineeDetails.identityProofNumber>Not Available</td></tr><tr ng-if=!Profile.folioDetailsData.sebiNomineeRegulatory01650Active><td>PAN of Nominee</td><td>:</td><td ng-if=Profile.nomineeDetails.panNumber><span easyassist-key=mask-element>{{Profile.nomineeDetails.panNumber}}</span></td><td ng-if=!Profile.nomineeDetails.panNumber>Not Available</td></tr><!-- guardian details shown here if availaible--><tr ng-if=Profile.nomineeDetails.minor><td>Guardian Name</td><td>:</td><td ng-if=Profile.nomineeDetails.guardianName><span easyassist-key=mask-element>{{Profile.nomineeDetails.guardianName}}</span></td><td ng-if=!Profile.nomineeDetails.guardianName>Not Available</td></tr><tr ng-if=Profile.nomineeDetails.minor><td>PAN of Guardian</td><td>:</td><td ng-if=Profile.nomineeDetails.guardianPanNumber><span easyassist-key=mask-element>{{Profile.nomineeDetails.guardianPanNumber}}</span></td><td ng-if=!Profile.nomineeDetails.guardianPanNumber>Not Available</td></tr><tr ng-if=Profile.nomineeDetails.minor><td>Guardian’s Relationship with Nominee</td><td>:</td><td ng-if=Profile.nomineeDetails.guardianRelationWithNominee><span easyassist-key=mask-element>{{Profile.nomineeDetails.guardianRelationWithNominee}}</span></td><td ng-if=!Profile.nomineeDetails.guardianRelationWithNominee>Not Available</td></tr></tbody></table><table class=table-data ng-if=\"Profile.folioDetailsData.sebiNomineeRegulatory01650Active && Profile.folioDetailsData.accountHoldingDeclaration\"><tbody><tr><td><strong>Statement of Holding</strong></td></tr><tr><td>{{Profile.folioDetailsData.nomineeRegistrationCO.accountHoldingDeclaration === \'NOMINATION_YES\' ? \'Nomination: Yes\': \'Nomination: No\'}}</td></tr></tbody></table></div><div class=\"clearfix bg-grey folio-header\"><p class=\"strong pull-left\">Payout Bank Details</p><span class=pull-right><ul class=modify-bank ng-if=Profile.folioDetailsData.cobmEnabled><li ng-click=Profile.redirectToAddBank() ng-if=\"Profile.folioDetailsData.bankDetails.length<5\">Add New Bank</li><li ng-click=Profile.redirectToCobmStatus()>Request Status</li></ul></span></div><div class=mrg23 ng-if=!Profile.folioDetailsData.bankDetails>No Data Available.</div><div class=mrg40 ng-if=Profile.folioDetailsData.bankDetails><div class=scroll-horz><ol class=\"pd20 list-inline tab-type2\"><li ng-repeat=\"bank in Profile.folioDetailsData.bankDetails\" ng-class=\"{active :Profile.currentBankIndx==$index}\" ng-click=Profile.showBankDetails(bank,$index)><span ng-if=Profile.folioDetailsData.bankDetails>{{$index+1}}.</span> <span>{{bank.bankName}} - <span easyassist-key=mask-element>{{bank.accountNumber}}</span> <span ng-if=bank.defaultBank class=info-primary>(Default)</span></span></li></ol></div><table class=table-data><tbody><tr><td>Account Type</td><td>:</td><td easyassist-key=mask-element>{{Profile.bankDetails.accountType || \'NA\'}}</td></tr><tr><td>Account Number</td><td>:</td><!--<td ng-bind=\"Profile.soleApplicant.folioList[Profile.currentFolioIndx].bankAcc\">0001298768RTGS/NEFT</td>--><td ng-bind=\"Profile.bankDetails.accountNumber || \'NA\'\" easyassist-key=mask-element>Saving</td></tr><tr><td>Branch Name</td><td>:</td><td ng-bind=\"Profile.bankDetails.branchName || \'NA\'\" easyassist-key=mask-element></td></tr><tr><td>Branch Location</td><td>:</td><td ng-bind=\"Profile.bankDetails.branchCity || \'NA\'\" easyassist-key=mask-element>Saket, New Delhi</td></tr><tr><td>IFSC</td><td>:</td><td easyassist-key=mask-element>{{Profile.bankDetails.ifscCode}} <span ng-disabled=\"Profile.bankDetails.updateIfscValid == false\" ng-class=\"{disableUpdate:Profile.bankDetails.updateIfscValid==false}\" ng-click=Profile.redirectIFSCUpdate() class=\"btn btn-secondary-action\">Update</span> <i ng-if=\"Profile.bankDetails.updateIfscValid==false\" tooltip class=\"info-icon base-tooltip\" data-bs-html=true data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Dear Investor, We have observed that your Bank information is incomplete. Kindly update your Bank details by visiting our nearest ISC/branch.\"></i></td></tr><tr><td>Payout Mechanism</td><td>:</td><td>{{Profile.bankDetails.payoutMethod}}<div ng-if=Profile.hideChangePayoutOpt><select ng-if=Profile.changePayoutSwitch ng-model=Profile.newPayoutMethod ng-options=\"_type.payoutCode as _type.payoutDescription for _type in Profile.payoutMechanismList\" ng-init=\"Profile.newPayoutMethod = Profile.newPayoutMethod ? Profile.newPayoutMethod : null\"><option value=\"\" selected>Payout Mechanism</option><!--<option ng-repeat=\"payout in Profile.payoutMechanismList\" value=\"{{payout.payoutCode}}\">{{payout.payoutDescription}}</option>--></select><button ng-disabled=!Profile.newPayoutMethod ng-if=Profile.changePayoutSwitch ng-click=Profile.UpdatePayoutMethod() class=\"btn btn-secondary-action\">Change</button> <span ng-if=Profile.changePayoutSwitch ng-click=Profile.payoutSwitch() class=\"btn btn-secondary-action\">Cancel</span> <span ng-if=!Profile.changePayoutSwitch ng-click=Profile.payoutSwitch() class=\"btn btn-secondary-action\">Change</span></div></td></tr><tr><td>MICR Number</td><td>:</td><td ng-bind=\"Profile.bankDetails.micrnumber || \'NA\'\"></td></tr><tr ng-if=\"!Profile.bankDetails.defaultBank && Profile.folioDetailsData.cobmEnabled && Profile.folioDetailsData.bankDetails.length>1\"><td ng-show=\"!Profile.bankDetails.defaultBank && Profile.folioDetailsData.cobmEnabled && Profile.folioDetailsData.bankDetails.length>1\"><button ng-click=Profile.deleteBank() class=\"btn btn-secondary-action\" style=margin:0px>Click to Delete Bank</button></td><td></td><td ng-show=\"!Profile.bankDetails.defaultBank && Profile.folioDetailsData.bankDetails.length>1\"><button ng-click=Profile.changeDefaultBank() class=\"btn btn-secondary-action\" style=margin:0px>Click to Make Default Bank</button></td></tr><tr ng-if=\"Profile.folioDetailsData.cobmEnabled && Profile.bankDetails.defaultBank && Profile.folioDetailsData.bankDetails.length>1\"><td>Can be deleted?</td><td>:</td><td ng-show=\"!Profile.bankDetails.defaultBank && Profile.folioDetailsData.cobmEnabled && Profile.folioDetailsData.bankDetails.length>1\"><span>Yes</span> <button ng-click=Profile.deleteBank() class=\"btn btn-secondary-action\">Click to Delete Bank</button></td><td ng-show=\"(Profile.bankDetails.defaultBank  && Profile.folioDetailsData.cobmEnabled) || (Profile.folioDetailsData.bankDetails.length===1)\"><span>NA</span> <i ng-show=Profile.bankDetails.defaultBank class=\"info-icon base-tooltip\" tooltip=\"\" data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Default Bank can not be deleted.\" data-original-title=\"Default Bank can not be deleted.\"></i></td></tr><tr ng-if=\"Profile.folioDetailsData.cobmEnabled && Profile.bankDetails.defaultBank && Profile.folioDetailsData.bankDetails.length>1\"><td>Can be a default bank?</td><td>:</td><td ng-show=\"!Profile.bankDetails.defaultBank && Profile.folioDetailsData.bankDetails.length>1\"><span>Yes</span> <button ng-click=Profile.changeDefaultBank() class=\"btn btn-secondary-action\">Click to Make Default Bank</button></td><td ng-show=\"Profile.bankDetails.defaultBank || (Profile.folioDetailsData.bankDetails.length===1)\"><span>NA</span> <i ng-show=Profile.bankDetails.defaultBank class=\"info-icon base-tooltip\" tooltip=\"\" data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Already is a default bank.\" data-original-title=\"Already is a default bank.\"></i></td></tr></tbody></table><!--<p class=\"add-bank\"><i class=\"plus-icon\"></i><span>Add Another Bank</span></p>--></div><div class=\"clearfix bg-grey folio-header\"><p class=\"strong pull-left strong\">OTM Details</p><span class=\"pull-right text-register\" ng-click=Profile.registerMandate() ng-if=\"Profile.folioDetailsData.emandateEnabled && Profile.folioDetailsData.otm.length == 0\">Register E-mandate (eOTM)</span> <span ng-if=\"Profile.folioDetailsData.emandateEnabled && Profile.folioDetailsData.otm.length>0\"><span class=\"pull-right text-register\" ng-click=Profile.cancelMandate()>Cancel Mandate</span> <span class=\"pull-right text-register\" style=\"padding: 0 20px\">|</span> <span class=\"pull-right text-register\" ng-click=Profile.registerMandate()>Register New E-mandate (eOTM)</span></span></div><div class=mrg23 ng-if=\"Profile.folioDetailsData.otm.length == 0\">No Data Available.</div><div class=mrg40 ng-if=\"Profile.folioDetailsData.otm.length>0\"><div class=scroll-horz><ol class=\"pd20 list-inline tab-type2\"><li ng-repeat=\"otm in Profile.folioDetailsData.otm\" ng-class=\"{active :Profile.currentOtpIndx==$index}\" ng-click=Profile.showOtmDetails(otm,$index)><span ng-if=Profile.folioDetailsData.otm>{{$index+1}}.</span> <span>{{otm.bankName}}</span></li></ol></div><table class=table-data><tbody><tr><td>Bank Name</td><td>:</td><td ng-bind=\"Profile.otpDetails.bankName || \'NA\'\" easyassist-key=mask-element></td></tr><tr><td>Account Type</td><td>:</td><td ng-bind=\"Profile.otpDetails.accountType || \'NA\'\" easyassist-key=mask-element></td></tr><tr><td>Bank Account Number</td><td>:</td><td ng-bind=\"Profile.otpDetails.accountNumber || \'NA\'\" easyassist-key=mask-element></td></tr><tr><td>Registration Date</td><td>:</td><td ng-bind=\"Profile.otpDetails.registrationDate.split(\' \')[0]  || \'NA\'\"></td></tr><tr><td>OTM Start Date</td><td>:</td><td ng-bind=\"Profile.otpDetails.startDate.split(\' \')[0]  || \'NA\'\"></td></tr><tr><td>OTM Expiry Date</td><td>:</td><td ng-bind=\"Profile.otpDetails.expiredDate.split(\' \')[0]  || \'NA\'\"></td></tr><tr><td>OTM Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Profile.otpDetails.maxAmount || \'NA\'}}</td></tr><tr><td>UMR number</td><td>:</td><td ng-bind=\"Profile.otpDetails.umrNumber || \'NA\'\"></td></tr></tbody></table></div><div class=\"clearfix bg-grey folio-header\"><p class=\"strong pull-left strong\">CAMS OTM Details</p></div><div class=mrg23 ng-if=\"Profile.folioDetailsData.camsOTM.length == 0\">No Data Available.</div><div class=mrg40 ng-if=\"Profile.folioDetailsData.camsOTM.length>0\"><div class=scroll-horz><ol class=\"pd20 list-inline tab-type2\"><li ng-repeat=\"camsOTM in Profile.folioDetailsData.camsOTM\" ng-class=\"{active :Profile.currentOtpIndx==$index}\" ng-click=Profile.showCamsOtmDetails(camsOTM,$index)><span ng-if=Profile.folioDetailsData.camsOTM>{{$index+1}}.</span> <span>{{camsOTM.bankName}}</span></li></ol></div><table class=table-data><tbody><tr><td>Bank Name</td><td>:</td><td ng-bind=\"Profile.cotmDetail.bankName || \'NA\'\" easyassist-key=mask-element></td></tr><tr></tr><tr><td>Bank Branch City</td><td>:</td><td ng-bind=\"Profile.cotmDetail.branchCity || \'NA\'\" easyassist-key=mask-element></td></tr><tr></tr><tr><td>IFSC Code</td><td>:</td><td ng-bind=\"Profile.cotmDetail.ifscCode || \'NA\'\" easyassist-key=mask-element></td></tr><tr><td>Account Type</td><td>:</td><td ng-bind=\"Profile.cotmDetail.accountType || \'NA\'\" easyassist-key=mask-element></td></tr><tr><td>Bank Account Number</td><td>:</td><td ng-bind=\"Profile.cotmDetail.accountNumber || \'NA\'\" easyassist-key=mask-element></td></tr><tr><td>OTM Start Date</td><td>:</td><td ng-bind=\"Profile.cotmDetail.startDate || Profile.cotmDetail.fromDate || \'NA\'\"></td></tr><tr><td>OTM Expiry Date</td><td>:</td><td ng-bind=\"Profile.cotmDetail.expiredDate || Profile.cotmDetail.toDate  || \'NA\'\"></td></tr><tr><td>OTM Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Profile.cotmDetail.maxAmount || \'NA\'}}</td><!--<td><i class=\"rupee-icon\"></i> <span ng-bind=\"Profile.cotmDetail.maxAmount || \'NA\'\"></span></td>--></tr><tr><td>UMR number</td><td>:</td><td ng-bind=\"Profile.cotmDetail.omUmrn || \'NA\'\"></td></tr></tbody></table></div><div class=\"clearfix bg-grey nobrd folio-header\"><p class=\"strong pull-left\">RUD</p></div><div class=mrg23 ng-if=!Profile.folioDetailsData.investments>No Data Available.</div><div class=\"mrg4 mrg40\" ng-if=Profile.folioDetailsData.investments><table class=table-data><thead><tr><th>Scheme Name</th><th>Unclaimed Amount/ RUD</th></tr></thead><tbody><tr ng-repeat=\"data in Profile.folioDetailsData.investments\"><td ng-bind=data.schemeName>HDFC Balanced Fund</td><td class=text-center><span class=text-primary ng-if=\"data.schemeType==\'Dividend\'\">NA</span> <span ng-if=\"data.schemeType !=\'Dividend\'\"><span class=\"text-primary cursor-pointer\" ng-if=!data.dividendSum ng-click=\"Profile.getInfo(data,$index, \'dividend\')\">View</span> <span class=text-primary ng-if=data.dividendSum>{{data.dividendSum}}</span></span></td></tr></tbody></table></div></div></form>");
$templateCache.put("app/investor/profile/registerMandate/registerMandate.html","<div class=main-section ng-init=RegisterMandate.init()><div class=\"mandate-heading paddng-bottom-mandate\">E-Mandate Registration</div><div class=mandate-section><div class=row><div class=col-md-8><table class=\"table borderless mandateTable\"><tr><td>Folio Number</td><td>:</td><td>{{RegisterMandate.folioNumber}}</td></tr></table><div class=\"mandate-heading mandate-heading-underline\">Investor Details</div><table class=\"table borderless mandateTable\"><tr><td>Investor Name</td><td>:</td><td>{{RegisterMandate.InvestorName}}</td></tr><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{RegisterMandate.InvestorEmail}}</td></tr><tr style=\"padding:12px 5px\"><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{RegisterMandate.InvestorMobile}}</td></tr></table><div class=\"mandate-heading mandate-heading-underline\">E-Mandate Details</div><table class=\"table borderless mandateTable\"><tr><td>Bank Name & Account Number</td><td>:</td><td><div class=row><div class=col-md-8><div class=\"input-select input-normal selectfield transaction-cal\" style=\"margin-bottom: 0px\"><input type=text name=bank id=bank ng-model=RegisterMandate.formData.bankInfo.bankName ng-change=RegisterMandate.changeBank() autocomplete=off ng-required=!RegisterMandate.bankInfo only-alphabets> <span class=highlight></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required && !Transaction.formData.bankName\" ng-bind=Transaction.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=RegisterMandate.bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=RegisterMandate.changeBank() model=RegisterMandate.formData.bankInfo for=bank></bank-drop-down></div><!--<div class=\"selectfield\" style=\"margin-bottom: 0px;\" >\n                    <select class=\"\" name=\"bank\" ng-disabled=\"false\"\n                            easyassist-key=\"mask-element\"\n                            ng-model=\"RegisterMandate.formData.bankInfo\"\n                            ng-options=\"bank.bankName for bank in RegisterMandate.bankList track by bank.accountNumber \"\n                            ng-change=\"RegisterMandate.changeBank()\"\n                            required>\n                      <option value=\"\" selected>\n                        {{RegisterMandate.bankList && !RegisterMandate.bankList.length ?\'No Bank Available\':\'Select Bank\'}}\n                      </option>\n                    </select>\n\n                    <label ng-if=\"Transaction.formData.bankInfo\">Select Bank</label>\n                    <span class=\"error-input\"\n                          ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required && !Transaction.formData.bankName\"\n                          ng-bind=\"Transaction.VALIDATE_DATA.BANK_REQUIRED\"></span>\n                  </div>--></div></div></td></tr><tr><td>Account Type</td><td>:</td><td><div class=row><div class=col-md-8>{{RegisterMandate.formData.bankInfo.accTypeDesc}}</div></div></td></tr><tr><td>Amount</td><td>:</td><td class=mandateAmount><div class=row><div class=col-md-8><input type=number ignore-mouse-wheel name=Amount onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=RegisterMandate.formData.amount ng-maxlength=10 limit-to=10 ng-change=RegisterMandate.checkAmountValidation() style=width:100%><div class=amtWords ng-if=RegisterMandate.formData.amount><p style=\"font-size: 12px\" id=amountInwordsEmandate>{{RegisterMandate.emandateWord.amountInWords}} (In Words)</p></div><div class=text-success>Maximum allowed for e-mandate is ₹ {{RegisterMandate.mandateMaxString}}.</div><div class=error-input ng-show=RegisterMandate.amountLess>{{RegisterMandate.VALIDATE_DATA.EMANDATE_MIN_ERROR + RegisterMandate.emandateDetail.minAmountLimit}}.</div><div class=error-input ng-show=RegisterMandate.amountMore>{{RegisterMandate.VALIDATE_DATA.EMANDATE_MAX_ERROR + RegisterMandate.mandateMaxString}}.</div></div></div></td></tr><tr><td>Start Date</td><td>:</td><td><div class=row><div class=\"col-md-8 set-index\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode={{RegisterMandate.viewMode}} data-date-default=RegisterMandate.formData.startDate data-enabled-dates=RegisterMandate.enabledBillerStartDatesList data-view-date=RegisterMandate.viewDate data-min-date=RegisterMandate.startMinDateBiller data-max-date=RegisterMandate.startMaxDate data-on-date-change=RegisterMandate.changeStartDate data-enable=true id=mandateStartDate showdefault=false><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></td></tr><tr><td>End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-bs-placement=right title={{RegisterMandate.mandateInfo}}></i></td><td>:</td><td><div class=row><div class=col-md-8 ng-class=\"{\'anything-disabled\': !RegisterMandate.formData.startDate }\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode={{RegisterMandate.viewMode}} data-date-default=RegisterMandate.formData.endDate data-enabled-dates=RegisterMandate.enabledBillerEndDatesList data-min-date=RegisterMandate.minEndDate data-max-date=RegisterMandate.maxEndDate data-on-date-change=RegisterMandate.changeEndDate data-view-date=RegisterMandate.endDateView data-enable=true><input type=text name=endDate placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><!--                <div class=\"col-md-4 default-date MandateDefaultDate\" ng-class=\"{\'anything-disabled\': !RegisterMandate.formData.startDate }\">--><!--                    <span class=\"checkbox\" style=\"bottom: -3px;\">--><!--                      <input type=\"checkbox\" id=\"defaultDate\" ng-change=\"RegisterMandate.defaultEndDate()\" ng-model=\"RegisterMandate.isDefaultDateSelected\">--><!--                      <span class=\"icon-checkbox\"></span>--><!--                    </span>--><!--                  <label for=\"defaultDate\" style=\"margin-left: 5px;\">Until Cancelled</label>--><!--                </div>--></div></td></tr><tr><td>Frequency</td><td>:</td><td><div class=row><div class=col-md-8>{{RegisterMandate.emandateDetail.frequency}}</div></div></td></tr><tr><td>Authentication Mode</td><td>:</td><td><div class=row><div class=col-md-8><div class=selectfield style=\"margin-bottom: 0px\"><select name=authenticationMode class=authModeDropdown ng-model=RegisterMandate.formData.authModeSelect ng-options=\"authMode.text for authMode in RegisterMandate.formData.bankInfo.authenticationModes\" ng-init=\"RegisterMandate.formData.authModeSelect=RegisterMandate.formData.authModeSelect?RegisterMandate.formData.authModeSelect: null\" ng-change=\"RegisterMandate.authMode = RegisterMandate.formData.authModeSelect\" required><option value=\"\" selected>{{(RegisterMandate.authenticationModes && !RegisterMandate.authenticationModes.length) ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}</option></select></div></div></div></td></tr><tr><td>Purpose of E-mandate</td><td>:</td><td><div class=row><div class=col-md-8>{{RegisterMandate.emandateDetail.purpose}}</div></div></td></tr></table></div></div><div class=row><div class=col-md-12><ng-bind-html ng-bind-html=RegisterMandate.dynamicDataNote></ng-bind-html><div ng-if=RegisterMandate.showTerms><div class=\"mandate-heading padding-top-term\">Terms & Conditions</div><div class=\"checkbox padding-top-term\"><input ng-model=RegisterMandate.isCheckedFatcaTandC type=checkbox style=\"width: 30%\"> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=RegisterMandate.showTermConditionsemandate() href=javaScript:void(0)>Terms & Conditions</a> of e-mandate registration.</span></div></div><hr><div class=\"button-section-mandate align-right-mandate\"><button ng-click=RegisterMandate.reset() class=\"btn btn-primary-action\" style=\"padding: 6px 50px\">Reset</button> <button ng-disabled=\"!RegisterMandate.formData.bankInfo || !RegisterMandate.formData.startDate || !RegisterMandate.formData.endDate ||\n         !RegisterMandate.formData.amount || RegisterMandate.amountLess || RegisterMandate.amountMore || !RegisterMandate.isCheckedFatcaTandC || !RegisterMandate.formData.authModeSelect\" ng-click=RegisterMandate.goToSummary() class=\"btn btn-primary-action\" style=\"padding: 6px 50px\">Proceed</button></div></div></div></div></div>");
$templateCache.put("app/investor/profile/registerMandate/summary.registerMandate.html","<div class=main-section ng-init=RegisterMandateReview.init()><div class=\"mandate-heading paddng-bottom-mandate\">Review E-mandate Registration Details</div><div class=mandate-section><div class=internal-section-mandate><table class=\"table borderless\"><tr><td style=\"padding:12px 5px\">Folio Number</td><td>:</td><td>{{RegisterMandateReview.folioNo}}</td></tr><tr><td style=\"padding:12px 5px\">Bank Name</td><td>:</td><td>{{RegisterMandateReview.bankNameOnly}}</td></tr><tr><td style=\"padding:12px 5px\">Account Number</td><td>:</td><td easyassist-key=mask-element>{{RegisterMandateReview.accountNumber}}</td></tr><tr><td style=\"padding:12px 5px\">Account Type</td><td>:</td><td>{{RegisterMandateReview.accountType}}</td></tr><tr><td style=\"padding:12px 5px\">Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{RegisterMandateReview.amount}}</td></tr><tr><td style=\"padding:12px 5px\">Frequency</td><td>:</td><td>{{RegisterMandateReview.frequency}}</td></tr><tr><td style=\"padding:12px 5px\">Mandate Start Date</td><td>:</td><td>{{RegisterMandateReview.startDate}}</td></tr><tr><td style=\"padding:12px 5px\">Mandate End Date</td><td>:</td><td>{{RegisterMandateReview.endDate}}</td></tr><tr><td style=\"padding:12px 5px\">Purpose of Mandate</td><td>:</td><td>{{RegisterMandateReview.purpose}}</td></tr><tr><td style=\"padding:12px 5px\">Authentication Mode</td><td>:</td><td>{{RegisterMandateReview.authMode}}</td></tr></table></div><div class=\"mandate-heading padding-top-term\">Declaration</div><div class=\"checkbox padding-top-term\"><input ng-model=RegisterMandateReview.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have checked the mandate details and I found it correct. I wish to proceed for authentication.</span></div><hr><div ng-click=RegisterMandateReview.goToBack() class=\"cursor-pointer text-primary padding-top-term\" style=width:6%><i class=arrow-blue-back-icon></i>Back</div><div class=\"button-section-mandate align-right-mandate\"><button ng-disabled=!RegisterMandateReview.isCheckedTandC ng-click=RegisterMandateReview.submitMandate() class=\"btn btn-primary-action\" style=\"padding: 6px 48px\">Authenticate</button></div></div></div>");
$templateCache.put("app/investment-baskets/basket/basket-details/basket.details.html","<div class=investment-sub-header><div class=title><label class=title-post>{{ BasketDetailsCtrl.basketDetails.basketName.substring(0, BasketDetailsCtrl.basketDetails.basketName.length - 7) }}</label><label class=title-pre>Basket</label></div></div><div class=investment-sub-desc><div class=basket-desc>{{BasketDetailsCtrl.basketDetails.basketDescription}}</div><div class=share-invest-container><span class=\"media-share dropdown\"><button class=\"share-media dropdown-toggle\" data-bs-toggle=dropdown aria-expanded=false><img src=assets/images/icons/investor-basket/ShareIcon.svg alt=share></button><div class=dropdown-menu><button class=\"btn btn-default social_share\" data-type=fb data-url={{BasketDetailsCtrl.basketUrl}} ng-click=BasketDetailsCtrl.facebookShare($event)><img src=assets/images/icons/investor-basket/facebook-share.svg alt=fb></button> <button class=\"btn btn-default social_share\" data-type=twitter data-url={{BasketDetailsCtrl.basketUrl}} ng-click=BasketDetailsCtrl.twitterShare($event)><img src=assets/images/icons/investor-basket/twitter-share.svg alt=twitter></button> <button class=\"btn btn-default social_share\" data-type=whatsapp data-url={{BasketDetailsCtrl.basketUrl}} ng-click=BasketDetailsCtrl.whatsappShare($event)><img src=assets/images/icons/investor-basket/whatsapp-share.svg alt=whatsapp></button> <button class=\"btn btn-default social_share\" data-type=email data-url={{BasketDetailsCtrl.basketUrl}} ng-click=BasketDetailsCtrl.emailShare($event)><img src=assets/images/icons/investor-basket/email-share.svg alt=email></button> <button class=\"btn btn-default social_share\" data-type=linkedin data-url={{BasketDetailsCtrl.basketUrl}} ng-click=BasketDetailsCtrl.emailShare($event)><img src=assets/images/icons/investor-basket/linkedin.svg alt=email></button></div></span><button class=btn-invest ng-click=BasketDetailsCtrl.investNow(BasketDetailsCtrl.basketDetails,1)>Invest Now</button></div></div><div class=\"basket-details-container row\"><div class=no-data-content ng-hide=\"BasketDetailsCtrl.basketDetails.schemesInBasket && BasketDetailsCtrl.basketDetails.schemesInBasket.length > 0\">No Data Found</div><div class=\"col-md-4 col-sm-6\" ng-repeat=\"scheme in BasketDetailsCtrl.basketDetails.schemesInBasket\"><div class=basket-details-card><div class=basket-details-card-body><div class=scroll-container><div class=basket-details-title-container><div class=basket-details-title><a class=fund-link href={{scheme.fundUrl}} target=_blank>{{scheme.schemeName}}</a></div></div><div class=basket-details-desc ng-if=scheme.investorsCount>{{scheme.investorsCount}} investors have invested in this fund.</div><div class=basket-details-desc ng-if=scheme.allocation>{{scheme.allocation}}% Basket Allocation.</div><!--<div class=\"scheme-option-container\">\n            <button class=\"btn-scheme-option {{scheme.selectedOption.id == returns.key ? \'active\' : \'\'}}\"\n                    ng-repeat=\"returns in scheme.updAnnualisedReturns\"\n                    ng-click=\"BasketDetailsCtrl.onOptionChange(scheme, returns.key, returns.value)\">\n              {{returns.key }}\n              <span ng-if=\"returns.key !== \'Since Inception\'\">{{ returns.key == 1 ? \'year\' : \' years\'}}</span>\n            </button>\n          </div>--><!--<div class=\"scheme-option-details-body\">\n            <div class=\"option-detail\">\n              <div class=\"option-title\">\n                CAGR\n              </div>\n              <div class=\"option-data\" ng-if=\"scheme.selectedOption.annualisedReturns || scheme.selectedOption.annualisedReturns == 0\">\n                {{scheme.selectedOption.annualisedReturns}}%\n              </div>\n            </div>\n            <div class=\"option-detail\">\n              <div class=\"option-title\">\n                Benchmark Return\n              </div>\n              <div class=\"option-data\" ng-if=\"scheme.selectedOption.benchmarkReturn || scheme.selectedOption.benchmarkReturn == 0\">\n                {{scheme.selectedOption.benchmarkReturn}}%\n              </div>\n            </div>\n          </div>--><div class=\"basket-details-desc desc-more\">{{scheme.schemeDescription}}</div></div></div></div></div></div><div class=investment-sub-desc-lower>Potential Equity Exposure : {{BasketDetailsCtrl.basketDetails.potentialEquityExposure || 0}}%</div><div class=other-basket-container><h3 class=other-basket-title>Other Investment Baskets</h3></div><div class=\"basket-card-container row\"><div class=no-data-content ng-hide=\"BasketDetailsCtrl.basketList.length > 0\">No Data Found</div><div class=\"col-md-4 col-sm-6\" ng-repeat=\"basket in BasketDetailsCtrl.basketList\" ng-hide=\"basket.basketId == BasketDetailsCtrl.id\"><div class=basket-card><div class=basket-card-body><div class=basket-title-container><img class=basket-icon src=\"{{BasketDetailsCtrl.imageBaseUrl + (basket.basketName | formatImageUrl) + \'.png\'}}\"><div class=basket-title>{{basket.basketName}}</div></div><div class=basket-desc>{{basket.basketDescription}}</div></div><div class=basket-btn-container><button class=btn-basket-details ui-sref=main.investment.basketDetails({id:basket.basketId})>View Details</button> <button class=btn-basket-invest ng-click=BasketDetailsCtrl.investNow(basket.basketId,basket.basketName,2)>Invest Now</button></div></div></div></div>");
$templateCache.put("app/investment-baskets/basket/basketView/basket.view.html","<div class=basket-information><h2 class=basket-information-header>HDFC BALANCED BASKET</h2><p class=basket-information-sub-header>balanced basket with an equal equity and debt funds</p><div class=row><div class=col-md-4><div id=chart></div></div><div class=col-md-8><div class=row><div class=col-md-6><div class=basket-scheme-info><div class=basket-header><h6>HDFC TOP 100 FUND</h6><div class=fund-allocation><p>Fund Allocation</p><p class=fund-info-perc>30%</p></div></div><div class=fund-info><div><p>Nav as on 22.04.22</p><p class=fund-info-perc>23</p></div><div><p>5 years Returns</p><p class=fund-info-perc>24</p></div></div></div></div><div class=col-md-6><div class=basket-scheme-info><div class=basket-header><h6>HDFC TOP 100 FUND</h6><div class=fund-allocation><p>Fund Allocation</p><p class=fund-info-perc>30%</p></div></div><div class=fund-info><div><p>Nav as on 22.04.22</p><p class=fund-info-perc>23</p></div><div><p>5 years Returns</p><p class=fund-info-perc>24</p></div></div></div></div><div class=col-md-6><div class=basket-scheme-info><div class=basket-header><h6>HDFC TOP 100 FUND</h6><div class=fund-allocation><p>Fund Allocation</p><p class=fund-info-perc>30%</p></div></div><div class=fund-info><div><p>Nav as on 22.04.22</p><p class=fund-info-perc>23</p></div><div><p>5 years Returns</p><p class=fund-info-perc>24</p></div></div></div></div><div class=col-md-6><div class=basket-scheme-info><div class=basket-header><h6>HDFC TOP 100 FUND</h6><div class=fund-allocation><p>Fund Allocation</p><p class=fund-info-perc>30%</p></div></div><div class=fund-info><div><p>Nav as on 22.04.22</p><p class=fund-info-perc>23</p></div><div><p>5 years Returns</p><p class=fund-info-perc>24</p></div></div></div></div></div><div class=\"col-md-12 invest-now-btn\"><button>Invest Now</button></div></div></div></div>");
$templateCache.put("app/investment-baskets/invest-now/add-folio/add-folio.html","<div class=content-area></div><div><button type=button ng-click=InvestNowAddFolio.moveToPayment()>Move To Payment</button></div>");
$templateCache.put("app/investment-baskets/invest-now/payment/payment.html","<div class=\"invest-now payment-mob-view\" style=\"padding: 0px !important\"><payment-data dynamic-data-sip=InvestNowPayment.dynamicDataSipPurchaseReview dynamic-data-purchase=InvestNowPayment.noteNetBanking></payment-data></div>");
$templateCache.put("app/investment-baskets/investment-basket-directives/basket-list-directive/basket-list.directive.html","<div class=\"row basket-list\"><div class=\"col-md-4 basket-container\" ng-repeat=\"basket in basketList.baskets\"><div class=basket><div class=basket-header><div class=basket-title>{{basket.basketName}}</div><div class=basket-action><a href=javascript:void(0)>View Details</a></div></div><div class=basket-body><div ng-repeat=\"basketScheme in basket.basketSchemes\"><div class=left-section><div><strong>{{basketScheme.schemeName}}</strong></div><div><strong ng-if=basketScheme.type>{{basketScheme.type}} |&nbsp;</strong> <span>{{basketScheme.riskProfile}}</span> <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Information needs to be added here\"></i></div></div><div class=right-section><div>SIP Amount</div><div><i class=rupee-small-icon></i> {{basketScheme.sipAmount}}</div></div></div></div><div class=basket-actions><button class=transact-action ng-click=\"proceedToInvestment(goal.goalName, goal.goalId)\">Start Investing</button></div></div></div></div>");
$templateCache.put("app/investment-baskets/investment-basket-directives/folio/folio.directive.html","<div class=basket-folio-review><h6>Review</h6><section class=basket-info><p>Systematic Investment Plan Registrations</p><h2>HDFC Balance Matters Basket</h2><span style=\"font-weight: bold\">Goal : My Home</span></section><section class=folio-infos><p>Folio Number : <strong>15195349</strong></p><div><table class=\"table borderless\"><tr><td>Email ID</td><td>:</td><td><strong>test@gmail.com</strong></td></tr><tr><td>Mobile Number</td><td>:</td><td><strong>+9121212121221</strong></td></tr><tr><td>Mode of holding</td><td>:</td><td><strong>+9121212121221</strong></td></tr></table></div><span class=info>This information belongs to arjun</span></section><section class=scheme-selection><button class=scheme-selection-btn>HDFC Top 100 Fund</button> <button class=scheme-selection-btn>HDFC Mid Cap opportunity Fund</button> <button class=scheme-selection-btn>HDFC High Cap opportunity Fund</button> <button class=scheme-selection-btn>HDFC High Cap opportunity Fund</button> <button class=scheme-selection-btn>HDFC High Cap opportunity Fund</button> <button class=scheme-selection-btn>HDFC High Cap opportunity Fund</button> <button class=scheme-selection-btn>HDFC High Cap opportunity Fund</button> <button class=scheme-selection-btn>HDFC High Cap opportunity Fund</button></section><section class=scheme-data><table class=\"table borderless\"><tr><td>Transaction Type</td><td>:</td><td><strong>SIP</strong></td></tr><tr><td>Amount</td><td>:</td><td><strong>7581.7</strong></td></tr><tr><td>Installment Frequency</td><td>:</td><td><strong>Monthly</strong></td></tr><tr><td>Start Date</td><td>:</td><td><strong>31-Dec-2022</strong></td></tr><tr><td>End Date</td><td>:</td><td><strong>Until Cancelled</strong></td></tr></table></section><section class=investment-detail><div class=view-btn><h6>Investment detail</h6></div><table class=\"table borderless set-margin-top-20\"><tr><td>Investment Option</td><td>:</td><td><strong>Growth</strong></td></tr><tr><td>Bank Name</td><td>:</td><td><strong>HDFC-BANK-LTD-22121</strong></td></tr></table></section><section class=nominee-detail><div class=view-btn><h6>Nominee detail</h6><a data-bs-toggle=collapse href=#nomineeDetails role=button aria-expanded=false aria-controls=nomineeDetails>View</a></div><div class=\"box-body collapse set-margin-top-20\" id=nomineeDetails><div class=\"box-details clearfix\"><div class=col-md-4 style=\"padding-left: 0\" ng-repeat=\"nominee in dummyNomineeData\"><h6 style=\"margin-bottom: 10px; margin-top: 10px; padding-left: 10px\">Nominee {{$index+1}} Detail</h6><table class=\"table borderless\"><tr><td><span><strong>Nominee Name:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeName}}</span></strong></td></tr><tr><td><span><strong>Nominee Relation:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{applicantRelationShip[nominee.nomineeRelation]}}</span></strong></td></tr><tr ng-if=nominee.panNumber><td><span><strong>Nominee Pan:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.panNumber}}</span></strong></td></tr><tr><td><span><strong>Nominee Dob:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.dob}}</span></strong></td></tr><tr><td><span><strong>Nominee Percentage:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.percentage}}</span></strong></td></tr><tr ng-if=nominee.soleAddressApplicable><td><span><strong>Address Details:</strong></span> &nbsp; <strong>Same As Investor</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine1 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee Address Line 1:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine1}}</span></strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine2 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee Address Line 2:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine2}}</span></strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine3 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee Address Line 3:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine3}}</span></strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.city && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee\'s City:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeAddress.city}}</span></strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.countryName && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee\'s Country:</strong></span> &nbsp; <strong ng-bind=nominee.nomineeAddress.countryName><span easyassist-key=mask-element>{{nominee.nomineeAddress.countryName}}</span></strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.pinCode && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee\'s PinCode:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeAddress.pinCode}}</span></strong></td></tr><tr><td ng-if=\"nominee.guardianName && !nominee.soleAddressApplicable && nominee.minor\"><span><strong>Guardian Name:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianName}}</span></strong></td></tr><tr><td ng-if=\"nominee.guardianRelationWithNominee && !nominee.soleAddressApplicable && nominee.minor\"><span><strong>Guardian Relation:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{minorRelationShip[nominee.guardianRelationWithNominee]}}</span></strong></td></tr><tr><td ng-if=\"nominee.guardianPanNumber && !nominee.soleAddressApplicable && nominee.minor\"><span><strong>Guardian Pan:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianPanNumber}}</span></strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine1 && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s Address Line 1:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.addressLine1}}</span></strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine2 && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s Address Line 2:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.addressLine2}}</span></strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine3 && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s Address Line 3:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.addressLine3}}</span></strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.city && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s City:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.city}}</span></strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.countryName && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s Country:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.countryName}}</span> </strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.pinCode && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s PinCode:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.pinCode}}</span></strong></td></tr></table></div></div></div></section><section class=bank-details><div class=view-btn><h6>Bank detail Self</h6><a data-bs-toggle=collapse href=#bankDetails role=button aria-expanded=false aria-controls=bankDetails>View</a></div><div class=\"box-body collapse set-margin-top-20\" id=bankDetails><div class=\"box-details clearfix\"><div class=col-md-4 style=\"padding-left: 0\"><table class=\"table borderless\"><tr><td><span><strong>Bank Name:</strong></span> &nbsp; <strong>{{reviewFormData.bankDetails.bankName}}</strong></td></tr><tr><td><span><strong>Account Type:</strong></span> <strong>{{reviewModalData.accountType}}</strong></td></tr><tr ng-hide=!reviewFormData.bankDetails.pennyDropValid><td><span><strong>MICR No:</strong></span> &nbsp;<strong>{{reviewFormData.bankDetails.micrnumber}}</strong></td></tr><tr><td><span><strong>Payout Mechanism:</strong></span> &nbsp;<strong>{{reviewModalData.payoutDescription}}</strong></td></tr><tr><td><span><strong>Account Number:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{reviewFormData.bankDetails.accountNumber}}</span></strong></td></tr><tr><td><span><strong>IFSC No:</strong></span> &nbsp;<strong>{{reviewFormData.bankDetails.ifsccode}}</strong></td></tr><tr><td><span><strong>Branch Location:</strong></span> &nbsp;<strong>{{reviewFormData.bankDetails.bankBranch}}</strong></td></tr><tr><td><span><strong>Branch City:</strong></span> &nbsp;<strong>{{reviewFormData.bankDetails.bankCity}}</strong></td></tr></table></div><div class=col-md-4 ng-if=reviewFormData.bankDetails.chequeLeaf><table class=\"table borderless\"><td class=attachment><span class=proof><strong>Cheque Leaf Image:</strong></span> &nbsp;<div class=\"form-group cheque-leaf\"><span class=upload-button><label><i class=ic-img-icon></i></label></span><span class=\"file-name text-blue\">Cheque Leaf Image</span><!--<span class=\"file-name text-blue\">Cheque Leaf Image{{chequeLeafFilename}}</span>--></div></td></table></div></div></div></section><section class=minor-detail ng-if=reviewFormData.minor><div class=view-btn><h6 class=pull-left ng-if=reviewFormData.minor><strong>Minor Details</strong></h6><!--      <i ng-if=\"firstFlow ==\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'folioDetails.folioCreation\')\"></i>--><!--      <i ng-if=\"firstFlow !=\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'main.folio.soleApplicant\')\"></i>--> <a data-bs-toggle=collapse href=#minorDetails role=button aria-expanded=false aria-controls=minorDetails>View</a></div><div class=\"box-body collapse\" id=minorDetails><div class=\"box-details clearfix\"><div class=col-md-12><table class=\"table borderless\"><tr><td><span><strong>Name:</strong></span> <strong>{{reviewFormData.soleApplicantDetail.personalDetail.firstName}}</strong></td></tr><tr><td><span><strong>DOB:</strong></span> <strong>{{reviewFormData.soleApplicantDetail.personalDetail.dateOfBirth}}</strong></td></tr><tr><td class=attachment><span class=proof><strong>DOB Proof:</strong></span> &nbsp;<div class=form-group><span class=upload-button><label><i class=ic-img-icon></i></label></span><span class=\"file-name text-blue\">DOB Proof </span><!--<span class=\"file-name text-blue\">DOB Proof {{minorAgeProofFilename}}</span>--></div></td></tr></table></div></div></div></section><section class=income-details><div class=view-btn><h6 class=pull-left ng-if=reviewFormData.minor><strong>Guardian Details</strong></h6><h6 class=pull-left ng-if=!reviewFormData.minor><strong>Sole Applicant Details</strong></h6><!--      <i ng-if=\"firstFlow ==\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'folioDetails.folioCreation\')\"></i>--><!--      <i ng-if=\"firstFlow !=\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'main.folio.soleApplicant\')\"></i>--> <a data-bs-toggle=collapse href=#incomeDetails role=button aria-expanded=false aria-controls=incomeDetails>View</a></div><div class=\"box-body collapse\" id=incomeDetails><div class=\"box-details clearfix\"><div class=\"col-md-12 bordered\" style=\"margin-bottom: 20px\"><h5 style=\"padding: 0px; margin-top: 20px\" class=text-blue>Contact Details</h5><div class=row><div class=col-md-4><label ng-if=soleApplicantEmail style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{soleApplicantEmail}}</label><label ng-if=!soleApplicantEmail style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : Not available</label><div class=mobileView ng-if=soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>{{soleApplicantEmailBelongsTo}}</strong></label></div><div class=mobileView class=col-md-3 ng-if=!soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>Not Applicable</strong></label></div></div><div class=col-md-3><label ng-if=soleApplicantMobile style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : {{soleApplicantMobile}}</label><label ng-if=!soleApplicantMobile style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : Not available</label></div></div><div class=row><div class=\"col-md-4 webView\" ng-if=soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>{{soleApplicantEmailBelongsTo}}</strong></label></div><div class=\"col-md-3 webView\" ng-if=!soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>Not Applicable</strong></label></div><div class=col-md-4 ng-if=soleApplicantMobile><label style=\"margin-top: 30px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>{{soleApplicantMobileBelongsTo}}</strong></label></div><div class=col-md-4 ng-if=!soleApplicantMobile><label style=\"margin-top: 30px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>Not Applicable</strong></label></div></div></div><div class=\"col-md-4 bordered\"><h5 class=\"text-blue set-header-margin-top-bottom\" ng-if=reviewFormData.minor>Guardian’s Income Details</h5><h5 class=\"text-blue set-header-margin-top-bottom\" ng-if=!reviewFormData.minor>Income Details</h5><table class=\"table borderless\"><tr><td><span><strong>Tax Status:</strong></span> <strong>{{reviewFormData.soleApplicantDetail.personalDetail.taxStatusDescription}}</strong></td></tr><tr><td><span><strong>Occupation:</strong></span> <strong><span easyassist-key=mask-element>{{reviewModalData.occupationDescription}}</span></strong></td></tr><tr ng-if=reviewFormData.soleApplicantDetail.selfDetail.grossAnnualIncome><td><span><strong>Gross Annual Income:</strong></span> <strong><span easyassist-key=mask-element>{{reviewModalData.incomeDescription}}</span></strong></td></tr><tr ng-if=reviewFormData.soleApplicantDetail.selfDetail.netWorth><td><span><strong>Net Worth:</strong></span> <strong><i class=rupee-small-icon></i> <span easyassist-key=mask-element>{{reviewFormData.soleApplicantDetail.selfDetail.netWorth}}</span></strong></td></tr><tr></tr><tr ng-if=reviewFormData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome><td><span><strong>Gross Annual Income:</strong></span> <strong><span easyassist-key=mask-element>{{reviewModalData.incomeDescription}}</span></strong></td></tr><tr ng-if=reviewFormData.soleApplicantDetail.minorDetail.guardian.netWorth><td><span><strong>Net Worth:</strong></span> <strong><i class=rupee-small-icon></i> <span easyassist-key=mask-element>{{reviewFormData.soleApplicantDetail.minorDetail.guardian.netWorth}}</span></strong></td></tr><tr><td><span><strong>Political Exposed Person Status:</strong></span> <strong ng-if=\"\n                  reviewFormData.soleApplicantDetail.selfDetail.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.POLITICAL||\n                  reviewFormData.soleApplicantDetail.minorDetail.guardian.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.POLITICAL\n                  \">Investor is politically exposed person </strong><strong ng-if=\"\n                  reviewFormData.soleApplicantDetail.selfDetail.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.RELATED||\n                  reviewFormData.soleApplicantDetail.minorDetail.guardian.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.RELATED\n                  \">Investor is related to politically exposed person </strong><strong ng-if=\"\n                  reviewFormData.soleApplicantDetail.selfDetail.politicalStatus==pattern.INVESTOR_POLITICAL_STATUS.NONE||\n                  reviewFormData.soleApplicantDetail.minorDetail.guardian.politicalStatus==pattern.INVESTOR_POLITICAL_STATUS.NONE\n                  \">Not Applicable</strong></td></tr><tr ng-if=reviewFormData.minor><td class=pdb20><span><strong>Relationship with Minor:</strong></span> &nbsp;<strong>{{reviewFormData.soleApplicantDetail.minorDetail.guardian.relation}}</strong></td></tr><tr ng-if=reviewFormData.minor><td class=attachment><span class=proof><strong>Relationship Proof:</strong></span> &nbsp;<div class=form-group><span class=upload-button><label><i class=ic-img-icon></i></label></span><span class=\"file-name text-blue\">Relationship Proof</span><!--<span class=\"file-name text-blue\">{{relationshipProofFilename}}</span>--></div></td></tr></table></div><div class=col-md-4><h5 class=\"text-blue set-header-margin-top-bottom\" ng-if=reviewFormData.minor>Guardian’s FATCA &amp; CSR information</h5><h5 class=\"text-blue set-header-margin-top-bottom\" ng-if=!reviewFormData.minor>FATCA &amp; CSR information</h5><table class=\"table borderless\"><tr><td><span><strong>Country of Birth: </strong></span><strong><span easyassist-key=mask-element>{{reviewModalData.birthCountry}}</span></strong></td></tr><tr><td ng-if=reviewFormData.minor><span><strong>City of Birth:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace}}</span></strong></td><td ng-if=!reviewFormData.minor><span><strong>City of Birth:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{reviewFormData.soleApplicantDetail.selfDetail.fatca.birthPlace}}</span></strong></td></tr><tr><td ng-if=reviewFormData.minor><span><strong>Address Type:</strong></span> &nbsp; <strong>{{reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.addressTypeDescription}}</strong></td><td ng-if=!reviewFormData.minor><span><strong>Address Type:</strong></span> &nbsp; <strong>{{reviewFormData.soleApplicantDetail.selfDetail.fatca.addressTypeDescription}}</strong></td></tr></table></div><div class=\"col-md-4 bordered-left\"><!--            <h5 class=\"text-blue\" ng-if=\"reviewFormData.minor && !reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia\">Guardian’s Tax Details</h5>--><h5 class=\"text-blue set-header-margin-top-bottom\" ng-if=reviewFormData.minor>Guardian’s Tax Details</h5><h5 class=\"text-blue set-header-margin-top-bottom\" ng-if=!reviewFormData.minor>Tax Details</h5><table class=\"table borderless\" ng-repeat=\"data in fatcaArray\" ng-if=\"fatcaArray.length>0 && !reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia\"><tr><td><span><strong>Name of Country{{$index+1}}:</strong></span> <strong><span easyassist-key=mask-element>{{data.taxPayingCountryDescription}}</span></strong></td></tr><tr><td><span><strong>Name of City{{$index+1}}:</strong></span> <strong><span easyassist-key=mask-element>{{data.taxPayingCity}}</span></strong></td></tr><tr><td><span><strong>Tax ID Type{{$index+1}}:</strong></span> <strong><span easyassist-key=mask-element>{{data.taxIdType}}</span></strong></td></tr><tr><td><span><strong>Tax ID Number{{$index+1}}:</strong></span> <strong><span easyassist-key=mask-element>{{data.taxId}}</span></strong></td></tr></table><table ng-if=\"fatcaArray.length==0\"><tr><td><span><strong>Tax Details Not Available</strong></span></td></tr></table></div></div></div></section><section class=holder-details ng-if=\"!reviewFormData.minor && reviewFormData.jointHolders.length>0\"><div class=view-btn><h6 class=pull-left><strong>Holders Details</strong></h6><!--      <i ng-if=\"firstFlow ==\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'folioDetails.jointholders\')\"></i>--><!--      <i ng-if=\"firstFlow !=\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'main.folio.jointholders\')\"></i>--> <a data-bs-toggle=collapse href=#holderDetails role=button aria-expanded=false aria-controls=holderDetails>View</a></div><div class=\"box-body collapse\" id=holderDetails ng-repeat=\"holder in reviewFormData.jointHolders\"><div class=\"box-details clearfix set-margin-top-20\"><!--{{holder|json}}--><div class=col-md-4><strong>Holders Name:</strong> {{holder.firstName+\" \"+holder.middleName+\" \"+holder.lastName}}</div></div><div class=\"box-details clearfix\"><div class=\"col-md-4 bordered\"><h5 class=\"text-blue set-header-margin-top-bottom\">Income Details</h5><table class=\"table borderless\"><tr><td><span><strong>Tax Status:</strong></span> &nbsp;<!--<strong>{{// reviewModalData.holders[$index].taxStatusDescription}}</strong>--> <strong>{{holder.taxStatusDescription}}</strong></td></tr><tr><td><span><strong>Occupation:</strong></span> &nbsp; <strong>{{reviewModalData.holders[$index].occupationDescription}}</strong> <strong><span easyassist-key=mask-element>{{holder.occupationDescription }}</span></strong></td></tr><tr ng-if=holder.grossAnnualIncome><td><span><strong>Gross Annual Income:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{holder.incomeDescription}}</span></strong></td></tr><tr ng-if=holder.netWorth><td><span><strong>Net Worth:</strong></span> &nbsp;<strong> <i class=rupee-small-icon></i> <span easyassist-key=mask-element>{{holder.netWorth}}</span></strong></td></tr><tr><td class=pdt20><span><strong>Political Exposed Person Status:</strong></span> &nbsp; <strong ng-if=\"holder.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.POLITICAL\">Investor is politically exposed person </strong><strong ng-if=\"holder.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.RELATED\">Investor is related to politically exposed person </strong><strong ng-if=\"holder.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.NONE\">Not Applicable</strong></td></tr></table></div><div class=\"col-md-4 bordered\"><h5 class=\"text-blue set-header-margin-top-bottom\">FATCA &amp; CSR information</h5><table class=\"table borderless\"><tr><td><span><strong>Country of Birth: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.birthCountryDescription}}</span></strong></td></tr><tr><td><span><strong>City of Birth:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.birthPlace}}</span></strong></td></tr><tr><td><span><strong>Address Type:</strong></span> &nbsp; <strong>{{holder.fatcaDetail.addressType}}</strong></td></tr></table></div><div class=col-md-4><h5 class=\"text-blue set-header-margin-top-bottom\">Tax Details</h5><table class=\"table borderless\" ng-if=\"\n            holder.fatcaDetail.fatcaTax1 && !holder.fatcaDetail.payTaxInIndia\"><tr><td><span><strong>Name of Country1: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxPayingCountry}}</span></strong></td></tr><tr><td><span><strong>Name of City1: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxPayingCity}}</span></strong></td></tr><tr><td><span><strong>Tax ID Type1:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxIdType}}</span></strong></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax1.taxId><td><span><strong>Tax ID Number1:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxId}}</span></strong></td></tr></table><table class=table ng-if=\"holder.fatcaDetail.fatcaTax2 && !holder.fatcaDetail.payTaxInIndia\"><tr><td><span><strong>Name of Country2: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxPayingCountry}}</span></strong></td></tr><tr><td><span><strong>Name of City2: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxPayingCity}}</span></strong></td></tr><tr><td><span><strong>Tax ID Type2:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxIdType}}</span></strong></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax2.taxId><td><span><strong>Tax ID Number2:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxId}}</span></strong></td></tr></table><table class=table ng-if=\"holder.fatcaDetail.fatcaTax3 && !holder.fatcaDetail.payTaxInIndia\"><tr><td><span><strong>Name of Country3: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxPayingCountry}}</span></strong></td></tr><tr><td><span><strong>Name of City3: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxPayingCity}}</span></strong></td></tr><tr><td><span><strong>Tax ID Type3:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxIdType}}</span></strong></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax3.taxId><td><span><strong>Tax ID Number3:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxId}}</span></strong></td></tr></table><table ng-if=\"\n            holder.fatcaDetail.payTaxInIndia ||\n            (holder.fatcaDetail.fatcaTax1==undefined)\n            &&(holder.fatcaDetail.fatcaTax2==undefined)\n            &&(holder.fatcaDetail.fatcaTax3==undefined)\"><tr><td><span><strong>Tax Details Not Available</strong></span></td></tr></table></div></div></div></section><section class=set-margin-top-20><p>Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above</p></section><section class=\"TnCBasket set-margin-top-20\"><div class=tc-block><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment.</span></div></div></div></section></div>");
$templateCache.put("app/investment-baskets/investment-basket-directives/payment-directive/payment.directive.html","<form name=tForm novalidate autocomplete=off><div class=payment ng-init=init()><div class=\"main container-fluid container-payment\"><div class=row><div class=\"note col-sm-12 col-md-12\"><!--<img src=\"../../../assets/images/payment-success.png\" alt=\"\">\n          <p>Congratulations {{userName | camelcase}}!</p>--><p ng-if=existingInvestor>Complete your payment to start investing!</p><p ng-if=!existingInvestor>Complete your first payment to start investing!</p></div></div><br><br><div class=\"container row\" style=\"margin: auto\"><div class=\"col-xs-12 col-md-12 pad-mob\"><div class=row><div class=col-xs-12><p class=paymentModeTitle>Select Payment Mode</p><br><div class=\"col-xs-12 col-md-4\"></div><div class=\"col-xs-12 col-md-8\"><div class=payment-mode-lbl></div></div></div></div><div class=\"row paymentModeData\" ng-if=\"transactionType == \'PURCHASE\'\"><div class=\"col-xs-12 col-md-4\"><div class=bankCard><div class=desktopMode><div ng-attr-class=\"{{active[$index] ? \'menu2 row\' : \'menu row\'}}\" style=\"border-top-left-radius: 10px\" ng-repeat=\"_option in purchasePaymentOptions\"><div class=\"col-sm-12 col-md-12\"><p ng-click=getPaymentMode(_option)>{{TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</p></div></div></div></div></div><div class=\"col-xs-12 col-md-8 bankCard selection\"><!--            <div class=\"select-bank-lbl\">Select Bank: </div>--><!-- Net Banking --><div class=netBankingPaymentOption ng-if=\"formData.purchasePaymentOption == \'NETBANKING\'\" style=\"margin-bottom: 20px\"><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:rtgsFormData.bank.$dirty&&tForm.bank.$invalid}><input type=\"text inputPayment\" class=form-control name=bank id=bank ng-model=formData.bankInfo.bankName autocomplete=off placeholder=\"Select Bank\" ng-required=!bankInfo only-alphabets> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=rtgsFormData.bank.$dirty&&rtgsFormData.bank.$error.required ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=netBankingAndUPIList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=changePurchaseBank() model=formData.bankInfo for=bank></bank-drop-down></div><div class=\"col-md-5 additional-details purchase-pad\" style=\"padding-left: 0px\" ng-if=\"formData.bankInfo && !formData.bankInfo.ifscCode\"><div><label class=titleFatca>IFSC Code<span class=req>*</span></label></div><div ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=formData.paymentInfo.ifscCode name=ifscCode required class=input-field maxlength=11 minlength=11 ng-pattern=IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-7 additional-details purchase-pad\" ng-if=\"formData.bankInfo.bankName && !formData.bankInfo.bankAcType\" style=\"padding-left: 0px\"><div><label class=titleFatca>Account Type <span class=\"req text-red\">*</span></label></div><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select class=select-box name=accountType ng-model=formData.paymentInfo.accType ng-init=\"formData.paymentInfo.accType = formData.paymentInfo.accType ? formData.paymentInfo.accType : null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=error-input ng-messages=tForm.accountType.$error ng-show=tForm.accountType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><!--------------- Netbank payment option end here----------------------><!--------------- RTGS payment options---------------------------------><div class=netBankingPaymentOption ng-if=\"formData.purchasePaymentOption == \'RTGS\'\" style=\"margin-bottom: 20px\"><div class=row><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px; padding-bottom: 0px\"><div><label class=titleFatca>Bank Name<span class=req>*</span></label></div><div ng-class={error:tForm.bankName.$invalid&&tForm.bankName.$dirty}><input type=text ng-model=formData.paymentInfo.bankName name=bankName only-alphabets class=input-field required><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.bankName.$dirty&&tForm.bankName.$error.required ng-bind=VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Branch<span class=req>*</span></label></div><div ng-class={error:tForm.bankBranch.$invalid&&tForm.bankBranch.$dirty}><input type=text ng-model=formData.paymentInfo.bankBranch name=bankBranch only-alphabets class=input-field required><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><div class=row><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Account Number<span class=req>*</span></label></div><div ng-class={error:tForm.bankAcNo.$invalid&&tForm.bankAcNo.$dirty}><input type=password autocomplete=false ng-model=formData.paymentInfo.accountNumber name=bankAcNo required class=input-field maxlength=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=copyPasteHandler($event)><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.required ng-bind=VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.maxlength ng-bind=VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Verify Account Number<span class=req>*</span></label></div><div ng-class={error:tForm.verifyBankAcNo.$invalid&&tForm.verifyBankAcNo.$dirty}><input type=text ng-keydown=copyPasteHandler($event) name=verifyBankAcNo maxlength=20 required ng-model=formData.paymentInfo.verifyBankAcNo ng-pattern=formData.paymentInfo.accountNumber class=input-field onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.verifyBankAcNo.$dirty&&tForm.verifyBankAcNo.$error.required ng-bind=VALIDATE_DATA.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&tForm.verifyBankAcNo.$error.maxlength ng-bind=VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&!tForm.verifyBankAcNo.$error.maxlength&&tForm.verifyBankAcNo.$error.pattern ng-bind=VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div></div><div class=row><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>IFSC/NEFT Code<span class=req>*</span></label></div><div ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=formData.paymentInfo.ifscCode name=ifscCode required class=input-field maxlength=11 minlength=11 ng-pattern=IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Account Type<span class=req>*</span></label></div><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:rtgsFormData.bank.$dirty&&tForm.bank.$invalid}><select class=select-box name=accountType ng-model=formData.paymentInfo.bankAcType ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>UTR Number<span class=req>*</span></label></div><div ng-class={error:tForm.utrNumber.$invalid&&tForm.utrNumber.$dirty}><input type=text name=utrNumber class=input-field ng-model=formData.paymentInfo.utrNumber ng-pattern=PATTERN.UTR_REGEX ng-maxlength=255 required> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required ng-bind=VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.pattern class=help-block ng-bind=VALIDATE_DATA.UTR_RANGE></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.maxlength class=help-block ng-bind=VALIDATE_DATA.UTR_INVALID></span></div></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Verify UTR Number<span class=req>*</span></label></div><div ng-class={error:tForm.utrNumber.$invalid&&tForm.utrNumber.$dirty}><input type=text name=verifyUtrNumber class=input-field ng-model=formData.paymentInfo.verifyUtrNumber ng-pattern=formData.paymentInfo.utrNumber required> <span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required ng-bind=VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.pattern ng-bind=VALIDATE_DATA.SAME_UTR_REQUIRED></span></div></div></div><!--<div class=\"row\">\n                <div class=\"col-xs-12 col-sm-6 col-md-6\" style=\"padding-left: 0px;\">\n                  <label for=\"chequesleafImage\" style=\"text-align: right;\n                    padding: 10px;\n                    padding-left: 35px;\n                    margin-top: 15px;\n                    background-color: lightgray;\n                    border-radius: 25px;\n                    cursor: pointer;\n                    background-size: 28px;\n                    background-position-x: 5px;\n                    background-position-y: 3px;\n                    background-repeat: no-repeat;\n                    background-image: url(../../../../assets/images/new-investor/uploadIcon.png);\">\n                    Upload Bank Statement\n                  </label>\n                  </label>\n                  <input type=\"file\" name=\"chequesleafImage\" id=\"chequesleafImage\"\n                     accept=\"image/tiff,image/tif,image/jpeg,image/jpg,application/pdf\" file-model-profile=\"Preview Uploaded Doc\"\n                     ng-model=\"formData.paymentInfo.chequeLeaf\"\n                     upload=\"bankUploadChequeLeafFile(file)\" style=\"display: none;visibility: none;\"\n                     required>\n\n                </div>\n                <div class=\"col-xs-12  col-sm-6 col-md-6\" style=\"padding-left: 0px;\">\n                  <p\n                    ng-if=\"bankchequeLeafUrl && fileType!=\'pdf\'\"\n                    ng-click=\"openUploadedDoc()\"\n                    style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 15px;\">\n                    Show Image</p>\n                  <p\n                    ng-if=\"bankchequeLeafUrl && fileType ==\'pdf\' \"\n                    ng-click=\"downloadPdfFile(bankchequeLeafUrl, fileType)\"\n                    style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 15px;\">\n                    Download Pdf</p>\n                </div>\n              </div>--></div><!----------------HDFC payment options--><div class=netBankingPaymentOption ng-if=\"formData.purchasePaymentOption == \'HDFC\'\" style=\"margin-bottom: 20px\"><div class=row><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px; padding-bottom: 0px\"><div><label class=titleFatca>HDFC MF Scheme Account Number<span class=req>*</span></label></div><div ng-class={error:tForm.schemeAccountNumber.$invalid&&tForm.schemeAccountNumber.$dirty}><input ng-model=formData.paymentInfo.schemeAccountNumber name=schemeAccountNumber type=number ignore-mouse-wheel ng-maxlength=25 class=input-field required><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.required ng-bind=VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.number ng-bind=VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_FIELD></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.maxlength ng-bind=VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div></div></div><div class=row><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Investor Account Number<span class=req>*</span></label></div><div ng-class={error:tForm.accountNumber.$invalid&&tForm.accountNumber.$dirty}><input type=text ng-model=formData.paymentInfo.accountNumber name=accountNumber ng-maxlength=20 class=input-field easyassist-key=mask-element onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=copyPasteHandler($event) required><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.required ng-bind=VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.maxlength ng-bind=VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span></div></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Confirm Investor Account Number<span class=req>*</span></label></div><div ng-class={error:tForm.verifyAccountNumber.$invalid&&tForm.verifyAccountNumber.$dirty}><input type=text ng-keydown=copyPasteHandler($event) name=verifyAccountNumber ng-maxlength=20 class=input-field easyassist-key=mask-element required ng-model=formData.paymentInfo.verifyAccountNumber ng-pattern=formData.paymentInfo.accountNumber onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.verifyAccountNumber.$dirty&&tForm.verifyAccountNumber.$error.required ng-bind=VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyAccountNumber.$error.required&&tForm.verifyAccountNumber.$error.maxlength ng-bind=VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyAccountNumber.$error.required&&!tForm.verifyAccountNumber.$error.maxlength&&tForm.verifyAccountNumber.$error.pattern ng-bind=VALIDATE_DATA.SAME_INVESTOR_ACCOUNT_NUMBER_RANGE></span></div></div></div><div class=row><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>IFSC Code<span class=req>*</span></label></div><div ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=formData.paymentInfo.ifscCode name=ifscCode required class=input-field maxlength=11 minlength=11 ng-pattern=IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Account Type<span class=req>*</span></label></div><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:tForm.accountType.$dirty&&tForm.accountType.$invalid}><select class=select-box name=accountType ng-model=formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Account Holder Name<span class=req>*</span></label></div><div ng-class={error:tForm.accountHolderName.$invalid&&tForm.accountHolderName.$dirty}><input type=text ng-model=formData.paymentInfo.accountHolderName only-alphabets class=input-field name=accountHolderName required><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.accountHolderName.$dirty&&tForm.accountHolderName.$error.required ng-bind=VALIDATE_DATA.ACCOUNT_HOLDER_REQUIRED></span></div></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>HDFC Bank Branch Name<span class=req>*</span></label></div><div ng-class={error:tForm.bankBranch.$invalid&&tForm.bankBranch.$dirty}><input type=text ng-model=formData.paymentInfo.bankBranch only-alphabets name=bankBranch class=input-field required><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><div class=row><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Bank Reference Number<span class=req>*</span></label></div><div ng-class={error:tForm.utrNumber.$invalid&&tForm.utrNumber.$dirty}><input type=text ng-model=formData.paymentInfo.utrNumber name=utrNumber required class=input-field ng-maxlength=255 ng-pattern=/^[a-zA-Z0-9]*$/ > <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required ng-bind=VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.maxlength ng-bind=VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.pattern ng-bind=VALIDATE_DATA.UTR_INVALID></span></div></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\"><div><label class=titleFatca>Confirm Bank Reference Number<span class=req>*</span></label></div><div ng-class={error:tForm.verifyUtrNumber.$invalid&&tForm.verifyUtrNumber.$dirty}><input type=text name=verifyUtrNumber ng-maxlength=255 class=input-field required ng-model=formData.paymentInfo.verifyUtrNumber ng-pattern=formData.paymentInfo.utrNumber> <span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required ng-bind=VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyUtrNumber.$error.required&&tForm.verifyUtrNumber.$error.maxlength ng-bind=VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyUtrNumber.$error.required&&!tForm.verifyUtrNumber.$error.maxlength&&tForm.verifyUtrNumber.$error.pattern ng-bind=VALIDATE_DATA.SAME_BANK_REFERENCE_NUMBER_RANGE></span></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6\" style=\"padding-left: 0px\"><label for=chequesleafImage style=\"text-align: right;\n                    padding: 10px;\n                    padding-left: 35px;\n                    margin-top: 15px;\n                    background-color: lightgray;\n                    border-radius: 25px;\n                    cursor: pointer;\n                    background-size: 28px;\n                    background-position-x: 5px;\n                    background-position-y: 3px;\n                    background-repeat: no-repeat;\n                    background-image: url(../../../../assets/images/new-investor/uploadIcon.png)\">Upload Bank Statement</label><input type=file name=chequesleafImage id=chequesleafImage accept=image/tiff,image/tif,image/jpeg,image/jpg,application/pdf file-model-profile=\"Preview Uploaded Doc\" ng-model=formData.paymentInfo.chequeLeaf upload=bankUploadChequeLeafFile(file) style=\"display: none;visibility: none\" required></div><div class=\"col-xs-12 col-sm-6 col-md-6\" style=\"padding-left: 0px\"><p ng-if=\"bankchequeLeafUrl && fileType!=\'pdf\'\" ng-click=openUploadedDoc() style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 15px\">Show Image</p><p ng-if=\"bankchequeLeafUrl && fileType ==\'pdf\' \" ng-click=\"downloadPdfFile(bankchequeLeafUrl, fileType)\" style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 15px\">Download Pdf</p></div></div></div><!---------------- UPI payment options--><div class=netBankingPaymentOption ng-if=\"formData.purchasePaymentOption == \'UPI\'\" style=\"margin-bottom: 20px\"><div class=row><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:rtgsFormData.bank.$dirty&&tForm.bank.$invalid}><input type=text name=bank id=upiBank class=form-control ng-model=formData.bankInfo.bankName ng-change=selectedUpiBank() ng-init=\"formData.bankInfo = formData.bankInfo ? formData.bankInfo: null\" autocomplete=off ng-required=!formData.bankInfo only-alphabets> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=netBankingAndUPIList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=selectedUpiBank() model=formData.bankInfo for=upiBank></bank-drop-down></div><div class=\"col-md-5 additional-details purchase-pad\" style=\"padding-left: 0px\" ng-if=\"formData.bankInfo && !formData.bankInfo.ifscCode\"><div><label class=titleFatca>IFSC Code<span class=req>*</span></label></div><div ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=formData.paymentInfo.ifscCode name=ifscCode required class=input-field maxlength=11 minlength=11 ng-pattern=IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-7 additional-details purchase-pad\" ng-if=\"formData.bankInfo.bankName && !formData.bankInfo.bankAcType\" style=\"padding-left: 0px\"><div><label class=titleFatca>Account Type <span class=\"req text-red\">*</span></label></div><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select class=select-box name=accountType ng-model=formData.paymentInfo.accType ng-init=\"formData.paymentInfo.accType = formData.paymentInfo.accType ? formData.paymentInfo.accType : null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=error-input ng-messages=tForm.accountType.$error ng-show=tForm.accountType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row ng-if=formData.bankInfo><div class=\"col-md-5 vpa-input\" style=\"padding-left: 0px\"><div><label style=\"display: block;width: 100%\">Virtual Payment Address(UPI ID) <span class=req>*</span></label></div><div class=input-normal ng-class={error:tForm.virtualAddress.$invalid&&tForm.virtualAddress.$dirty}><input type=text ng-model=formData.paymentInfo.virtualAddress name=virtualAddress class=input-field ng-pattern=PATTERN.upi_virtual_addr_regex ng-change=\"formData.verifyUPIResp={}\" required ng-readonly=\"isUPIVerified && formData.verifyUPIResp.valid === true\" easyassist-key=mask-element> <i class=edit-icon style=\"position: absolute;right: 5px; top:16px; pointer-events: all; box-sizing: content-box\" ng-if=\"isUPIVerified && formData.verifyUPIResp.valid === true\" ng-click=changeUpiVerified()></i><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.virtualAddress.$dirty&&(tForm.virtualAddress.$error.required||tForm.virtualAddress.$error.pattern) ng-bind=VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!tForm.virtualAddress.$invalid\n                  &&  (!isUPIVerified && formData.verifyUPIResp.valid === false)\" ng-bind=VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span></div></div><div class=\"col-md-4 upi-verify\" ng-if=\"formData.purchasePaymentOption==\'UPI\' && !isUPIVerified\"><button blur-on-click class=\"btn btn-primary-action\" ng-disabled=\"!formData.paymentInfo.virtualAddress || (!formData.bankInfo.minorBankFlag && checkForMinorBankListCondition())\" ng-click=verifyUPI()>Verify</button></div><div class=\"col-md-3 upi-verified\" ng-if=\"isUPIVerified && formData.verifyUPIResp.valid === true\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{name}}</span></div><div class=\"col-md-3 upi-notverified\" ng-if=\"!isUPIVerified && formData.verifyUPIResp.valid === false\"><p><strong><span class=error-input style=display:inline>Not Verified</span> <i class=cancel-icon></i></strong></p></div></div></div><!---------------- OTM payment options--><div class=netBankingPaymentOption ng-if=\"formData.purchasePaymentOption == \'OTM\'\" style=\"margin-bottom: 20px\"><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:rtgsFormData.bank.$dirty&&tForm.bank.$invalid}><input type=\"text inputPayment\" class=form-control name=bank id=otmBank ng-model=formData.bankInfo.bankName autocomplete=off placeholder=\"Select Bank\" ng-required=!formData.bankInfo only-alphabets> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=rtgsFormData.bank.$dirty&&rtgsFormData.bank.$error.required ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=bankList display-key=bankName display-key-second=bankAcNo hdfc-click=changePurchaseBank() model=formData.bankInfo for=otmBank></bank-drop-down></div><div class=\"col-md-5 additional-details purchase-pad\" style=\"padding-left: 0px\" ng-if=\"formData.bankInfo && !formData.bankInfo.ifscCode\"><div><label class=titleFatca>IFSC Code<span class=req>*</span></label></div><div ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text ng-model=formData.paymentInfo.ifscCode name=ifscCode required class=input-field maxlength=11 minlength=11 ng-pattern=IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-7 additional-details purchase-pad\" ng-if=\"formData.bankInfo.bankName && !formData.bankInfo.bankAcType\" style=\"padding-left: 0px\"><div><label class=titleFatca>Account Type <span class=\"req text-red\">*</span></label></div><div class=\"selectfield selectionIcon\" ng-class=\"{error:tForm.accountType.$dirty && tForm.accountType.$invalid}\"><select class=select-box name=accountType ng-model=formData.paymentInfo.accType ng-init=\"formData.paymentInfo.accType = formData.paymentInfo.accType ? formData.paymentInfo.accType : null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=error-input ng-messages=tForm.accountType.$error ng-show=tForm.accountType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=row><div class=\"col-md-12 resp-padd\"><table class=\"table table-bordered\" ng-if=(formData.bankInfo)><tr><td>Account No:</td><td easyassist-key=mask-element>{{formData.bankInfo.bankAcNo}}</td></tr><tr><td>OTM UMRN No:</td><td>{{formData.bankInfo.omUmrn}}</td></tr><tr><td>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{formData.bankInfo.maxAmount}}<div class=error-input ng-show=\"formData.purchaseAmount > formData.bankInfo.maxAmount\" ng-bind=VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR></div></td></tr><tr><td>OTM Start Date:</td><td>{{formData.bankInfo.omStartDate}}<div class=error-input ng-show=\"isOTMStartDate && formData.purchaseAmount\" ng-bind=\"VALIDATE_DATA.DATE_START_VALIDATION_ERROR + \' \' + bankInfo.omStartDate\"></div><div class=error-input ng-show=\"isOTMStartDate && formData.sipFirstAmount\" ng-bind=\"VALIDATE_DATA.DATE_START_FIRST_INSTALLMENT_VALIDATION_ERROR + \' \' + bankInfo.omStartDate\"></div></td></tr><tr><td>OTM Expiry Date:</td><td>{{formData.bankInfo.omExpiryDate}}<div class=error-input ng-show=\"isOTMDate && formData.purchaseAmount\" ng-bind=\"VALIDATE_DATA.EXPIRY_DATE_VALID_ERROR + \' \' + bankInfo.omExpiryDate\"></div><div class=error-input ng-show=\"isOTMDate && formData.sipFirstAmount\" ng-bind=\"VALIDATE_DATA.EXPIRY_DATE_FIRST_INSTALLMENT_VALID_ERROR + \' \' + bankInfo.omExpiryDate\"></div></td></tr></table></div></div></div><div class=\"row noteForTpv\" ng-if=\"formData.purchasePaymentOption == \'NETBANKING\' && formData.paymentInfo.tpvEnableFlag == \'N\' \"><div class=\"col-sm-12 col-md-12\" style=\"display: flex;justify-content: center;flex-direction: row;align-items: center\"><p class=\"text-red error-msg-tpv text-center\" style=\"font-size: 13px\">Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br>Please select other payment mode or add a TPV enabled bank in your folio. <a ng-click=tpv() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</p></div></div></div></div><div class=\"row paymentModeData\" ng-if=\"transactionType == \'SIP\'\"><div class=\"col-xs-12 col-md-4\"><div class=bankCard><div class=desktopMode><div ng-attr-class=\"{{active[$index] ? \'menu2 row\' : \'menu row\'}}\" ng-if=\"sipPaymentOptions.length > 0\" style=\"border-top-left-radius: 10px\" ng-repeat=\"_option in sipPaymentOptions\"><div class=\"col-sm-12 col-md-12\"><p ng-click=getPaymentMode(_option)>{{TRANSACTIONS_CONST.DESCRIPTIONS[_option] === \'UPI\' ? \'UPI Autopay\' : TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</p></div></div></div></div></div><div ng-if=\"sipPaymentOptions.length === 0\"><div class=bank-error-msg>No valid payment mode available to proceed with SIP transaction</div></div><!-- OTM --><div class=\"col-xs-12 col-md-8 bankCard selection\" ng-if=\"formData.sipPaymentOption == \'OTM\' && sipPaymentOptions.length > 0\"><!-- OTM --><!--            <div class=\"select-bank-lbl\">Select Bank: </div>--><div class=netBankingPaymentOption style=\"margin-bottom: 20px\"><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:rtgsFormData.bank.$dirty&&tForm.bank.$invalid}><input type=\"text inputPayment\" class=form-control name=bank id=bank ng-model=formData.paymentInfo.bankName autocomplete=off placeholder=\"Select Bank\" ng-required=!formData.paymentInfo only-alphabets> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=rtgsFormData.bank.$dirty&&rtgsFormData.bank.$error.required ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=OTMbankList display-key=bankName display-key-second=bankAcNo hdfc-click=changeBank() model=formData.paymentInfo for=bank></bank-drop-down></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\" ng-if=\"formData.paymentInfo && !formData.paymentInfo.ifscCode\"><div><label class=titleFatca>IFSC Code<span class=req>*</span></label></div><div ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\"><input type=text ng-model=formData.ifscCode name=ifscCode required maxlength=11 minlength=11 class=input-field ng-pattern=IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><span class=error-input ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-6 additional-details\" style=\"padding-left: 0px; padding-right: 0px\" ng-if=\"formData.paymentInfo && !formData.paymentInfo.bankAcType\"><div><label class=titleFatca>Account Type</label><span class=\"req text-red\">*</span></div><div class=\"input-select input-normal selectfield marginBottom\" ng-class=\"{error:formData.paymentInfo.bankAcType.$dirty && formData.paymentInfo.bankAcType.$invalid}\"><select class=form-control name=accountType ng-model=formData.bankAcType ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\" selected>Account Type</option></select><div class=bar></div><span class=error-input ng-messages=formData.paymentInfo.bankAcType.$error ng-show=formData.paymentInfo.bankAcType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=row><div class=\"col-md-12 resp-padd\"><table class=\"table table-bordered\" ng-if=formData.paymentInfo><tr><td>Account No:</td><td easyassist-key=mask-element>{{formData.paymentInfo.bankAcNo}}</td></tr><tr><td>OTM UMRN No:</td><td>{{formData.paymentInfo.omUmrn}}</td></tr><tr><td>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{formData.paymentInfo.maxAmount}}<div class=error-input ng-show=\"formData.purchaseAmount > formData.paymentInfo.maxAmount\" ng-bind=VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR></div></td></tr><tr><td>OTM Instruction Type:</td><td>{{formData.paymentInfo.otmFrequencyName ? formData.paymentInfo.otmFrequencyName : formData.paymentInfo.otmFrequency}}</td></tr><tr><td>OTM Start Date:</td><td>{{formData.paymentInfo.omStartDate}}<div class=error-input ng-show=startDateValidation ng-bind=\"VALIDATE_DATA.DATE_SIP_VALIDATION_ERROR + \' \' + formData.paymentInfo.omStartDate\"></div></td></tr><tr><td>OTM Expiry Date:</td><td>{{formData.paymentInfo.omExpiryDate}}<div class=error-input ng-show=isInvalidDate ng-bind=VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></div></td></tr></table></div></div></div></div><!--  EC--><div class=\"col-xs-12 col-md-8 bankCard selection\" ng-if=\"formData.sipPaymentOption == \'EC\' && sipPaymentOptions.length > 0\"><!--            <div class=\"select-bank-lbl\">Select Bank: </div>--><div class=netBankingPaymentOption style=\"margin-bottom: 20px\"><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:rtgsFormData.bank.$dirty&&tForm.bank.$invalid}><input type=\"text inputPayment\" class=form-control name=bank id=bank ng-model=formData.paymentInfo.bankName autocomplete=off placeholder=\"Select Bank\" ng-required=!formData.paymentInfo only-alphabets> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=rtgsFormData.bank.$dirty&&rtgsFormData.bank.$error.required ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=changeBank() model=formData.paymentInfo for=bank></bank-drop-down></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\" ng-if=\"formData.paymentInfo && !formData.paymentInfo.ifscCode\"><div><label class=titleFatca>IFSC Code<span class=req>*</span></label></div><div ng-class=\"{error:tForm.ifscCode.$invalid && tForm.ifscCode.$dirty}\"><input type=text ng-model=formData.ifscCode name=ifscCode required maxlength=11 minlength=11 class=input-field ng-pattern=IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><span class=error-input ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.required\" ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=\"tForm.ifscCode.$dirty && tForm.ifscCode.$error.pattern\" ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-6 additional-details\" style=\"padding-left: 0px; padding-right: 0px\" ng-if=\"formData.paymentInfo && !formData.paymentInfo.bankAcType\"><div><label class=titleFatca>Account Type</label><span class=\"req text-red\">*</span></div><div class=\"input-select input-normal selectfield marginBottom\" ng-class=\"{error:formData.paymentInfo.bankAcType.$dirty && formData.paymentInfo.bankAcType.$invalid}\"><select class=form-control name=accountType ng-model=formData.bankAcType ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=error-input ng-messages=formData.paymentInfo.bankAcType.$error ng-show=formData.paymentInfo.bankAcType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=siPaymentOption ng-if=\"formData.paymentInfo.bankCode == \'OTHER\'\"><div class=\"input-field input-normal marginBottom\" ng-if=\"formData.paymentInfo.bankCode == \'OTHER\'\" ng-class=\"{error:tForm.bankName.$dirty && Transaction.tForm.bankName.$invalid}\"><input type=text ng-click=otherBankSelected() ng-disabled=\"formData.paymentInfo.bankCode != \'OTHER\'||!fForm.$valid\" ng-model=formData.paymentInfo.bankName name=bankName ng-required=\"Transaction.formData.paymentInfo.bankCode == \'OTHER\'\"> <span class=highlight></span> <span class=bar></span><label>Bank Name</label><span class=error-input ng-show=\"tForm.bankName.$dirty && Transaction.tForm.bankName.$error.required\" ng-bind=VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div></div><!--  E-Mandate --><div class=\"col-xs-12 col-md-8 bankCard selection\" ng-if=\"formData.sipPaymentOption == TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && sipPaymentOptions.length > 0\"><!--            <div class=\"select-bank-lbl\">Select Bank: </div>--><div class=siPaymentOption><label id=bankLabelEmandate style=\"padding-bottom: 12px\" class=\"form-label less\">Select Bank</label><div class=\"input-select input-normal selectfield\"><input type=text name=bank id=bank class=form-control ng-model=formData.paymentInfo.bankName ng-change=changeBank() ng-init=\"formData.paymentInfo = formData.paymentInfo ? formData.paymentInfo : null\" placeholder=\"Select Bank\" autocomplete=off only-alphabets required readonly> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"tForm.bank.$dirty && tForm.bank.$error.required && !formData.bankName\" ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=EMbankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=changeBank() model=formData.paymentInfo for=bank></bank-drop-down></div></div><div class=siPaymentOption ng-class=\"{error:tForm.authenticationMode.$dirty && tForm.authenticationMode.$invalid}\"><label id=authModeLabel style=\"padding-bottom: 12px\" class=\"form-label less\">Authentication Mode</label><div class=\"input-select input-normal selectfield marginBottom\"><select name=authenticationMode ng-disable=!authenticationMode class=form-control ng-model=formData.authMode ng-options=\"auth.text for auth in authenticationMode\" ng-init=\"formData.authMode = formData.authMode ? formData.authMode: null\" ng-change=setDynamicNotes() required><option value=\"\" selected>{{authenticationMode&&!authenticationMode.length ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}</option></select><span class=error-input ng-show=\"tForm.authenticationMode.$dirty && tForm.authenticationMode.$error.required && !formData.authMode\" ng-bind=VALIDATE_DATA.AUTHENTICATION_MODE_REQUIRED></span></div></div><div class=siPaymentOption><label id=mandateAmount style=\"padding-bottom: 12px\" class=\"form-label less\">Mandate Amount</label><div class=\"input-normal icon-input\" ng-class=\"{error:(tForm.eAmount.$invalid && tForm.eAmount.$dirty),\'has-data\':formData.emandateAmount}\"><input class=form-control type=text ignore-mouse-wheel name=eAmount ng-model=formData.displayAmountMandate ng-change=checkAmountValidationEmandate() maxlength=13 required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon style=\"top: 20px\"></i><div class=amtWords style=\"margin-top: 10px\" ng-if=formData.displayAmountMandate><p id=amountInwordsEmandate>{{formData.emandateWord.amountInWords}} (In Words)</p></div><!--                <span class=\"text-success\">--><!--                  Maximum allowed for e-mandate is ₹ {{mandateMaxString}}.--><!--                </span>--><div class=error-input ng-show=amountLess>{{VALIDATE_DATA.EMANDATE_MIN_ERROR + emandateMinAmountLimit}}</div><div class=error-input ng-show=amountMore>{{VALIDATE_DATA.EMANDATE_MAX_ERROR + mandateMaxString}}</div><div class=error-input ng-show=\"!amountLess && isLessThanSipAmount\" ng-bind=VALIDATE_DATA.EMANDATE_SIP_AMOUNT_ERROR></div></div></div><div class=siPaymentOption><label id=mandateStartDate style=\"padding-bottom: 12px\" class=\"form-label less\">Mandate Start Date</label><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode={{viewMode}} data-date-default=formData.emandateDate id=emandateStartDate data-enable=true style=\"position: relative\"><input class=form-control type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div><div class=siPaymentOption><label id=mandateEndDate style=\"padding-bottom: 12px\" class=\"form-label less\">Mandate End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-bs-placement=right title={{mandateInfo}}></i></label><div class=sip-dates><div ng-class=\"{\'anything-disabled\': !formData.emandateDate}\"><div class=form-group ng-if=!isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal eEndDate\" ng-class=\"{error:tForm.endDateEmandate.$dirty && tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode={{viewMode}} data-date-default=formData.endDateEmandate data-enabled-dates=enabledEmandateEndDatesList data-min-date=minEndDateEmandate data-max-date=maxEndDateEmandate data-on-date-change=changeEndDateEmandate data-enable=true><input class=input-basket type=text name=endDateEmandate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=\"input-group-addon calender-container\" style=\"top: 20px\"><span class=glyphicon-calendar-blue></span> </span><span class=highlight></span> <span class=bar></span> <span style=\"word-spacing: -1px\" class=error-input ng-show=\"formData.sipPaymentOption === TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && sipDateLessEmandate\" ng-bind=VALIDATE_DATA.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div><!--            <div class=\"bank-error-msg\" ng-if=\"formData.purchaseAmount > 100000\">--><!--              SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode--><!--            </div>--></div><!-- UPI Changes  --><div class=\"col-xs-12 col-md-8 bankCard selection\" ng-if=\"formData.sipPaymentOption == TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI && sipPaymentOptions.length > 0\"><div class=netBankingPaymentOption style=\"margin-bottom: 20px\"><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><input type=\"text inputPayment\" name=bank id=upiBank class=form-control ng-model=formData.paymentInfo.bankName placeholder=\"Select Bank\" ng-init=\"formData.paymentInfo=formData.paymentInfo?formData.paymentInfo: null\" autocomplete=off ng-required=!formData.paymentInfo only-alphabets> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=UPIbankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=changeBank() model=formData.paymentInfo for=upiBank></bank-drop-down></div><div class=\"col-md-6 additional-details purchase-pad\" style=\"padding-left: 0px\" ng-if=\"formData.paymentInfo && !formData.paymentInfo.ifscCode\"><div><label class=titleFatca>IFSC Code<span class=req>*</span></label></div><div ng-class={error:tForm.ifscCode.$invalid&&tForm.ifscCode.$dirty}><input type=text class=input-field ng-model=formData.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-6 additional-details\" style=\"padding-left: 0px; padding-right: 0px\" ng-if=\"formData.paymentInfo && !formData.paymentInfo.bankAcType\"><div><label class=titleFatca>Account Type</label><span class=\"req text-red\">*</span></div><div class=\"input-select input-normal selectfield marginBottom\" ng-class=\"{error:formData.paymentInfo.bankAcType.$dirty && formData.paymentInfo.bankAcType.$invalid}\"><select class=form-control name=accountType ng-model=formData.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=netBankingPaymentOption style=\"margin-bottom: 20px\"><div class=\"col-md-12 additional-details\" style=\"padding-left: 0px; padding-right: 0px\" ng-if=formData.paymentInfo><div><label class=titleFatca>Virtual Payment Address (UPI ID)<span class=req>*</span></label></div><div ng-class={error:tForm.virtualAddress.$invalid&&tForm.virtualAddress.$dirty}><input style=\"text-transform: lowercase\" type=text class=input-field ng-model=formData.paymentInfo.virtualAddress name=virtualAddress ng-pattern=PATTERN.upi_virtual_addr_regex ng-change=handleVpa() required ng-readonly=\"isUPIVerified && formData.verifyUPIResp.valid === true\" easyassist-key=mask-element><div class=bar></div><div class=highlight></div><i class=edit-icon style=\"position: absolute;right: 0px; top:42px; pointer-events: all; box-sizing: content-box\" ng-if=\"isUPIVerified && formData.verifyUPIResp.valid === true\" ng-click=changeUpiVerified()></i> <span class=error-input ng-show=tForm.virtualAddress.$dirty&&(tForm.virtualAddress.$error.required||tForm.virtualAddress.$error.pattern) ng-bind=VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!tForm.virtualAddress.$invalid\n                  &&  (!isUPIVerified && formData.verifyUPIResp.valid === false)\" ng-bind=VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span></div><div class=row><div class=col-md-8><button style=\"margin-top: 20px\" blur-on-click ng-if=\"formData.sipPaymentOption==\'UPI\' && !isUPIVerified\" class=\"btn btn-primary-action\" ng-disabled=\"!formData.paymentInfo.virtualAddress || (!bankInfo.minorBankFlag && checkForMinorBankListCondition()) || (!isUPIVerified && formData.verifyUPIResp.valid === false)\" ng-click=verifyUPI()>Verify</button></div><div class=\"col-md-12 verify-vpa verify-ack-padding verify-ack-col\" ng-if=\"!isUPIVerified && formData.verifyUPIResp.valid === false\"><p style=\"width: 100px\"><strong><span class=error-input style=\"display:inline;font-size:100%;margin-bottom: 20px\">Not Verified</span> <i class=\"cancel-icon error-input\"></i></strong></p></div></div><div class=\"verify-vpa verify-ack-padding\" ng-if=\"isUPIVerified && formData.verifyUPIResp.valid === true\"><p style=\"width: 100px\"><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{name}}</span></div></div></div><div class=initiate-transaction><div class=text-red ng-if=!bankList||!bankList.length><span>In case your registered bank is not displayed, please choose other payment mode or add another bank.</span></div><!--              <ng-bind-html--><!--                dynamic=\"Payment.notesPayment.noteDTO.noteDTOMap.Note_Purchase_UPI.content\">--><!--              </ng-bind-html>--></div></div></div></div></div><!-- Declaration --><br><div class=row><!--      <div class=\"col-sm-1 col-md-2\"></div>--><div class=\"col-sm-12 col-md-12\"><div class=\"checkbox payment-tnc\"><input id=isCheckedTandC ng-model=confirmation type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the account holders.</label></div></div></div><br><div class=row><div class=col-xs-12><div class=paymentBtn><button class=back-btn ng-click=backToReview()>Back</button> <button class=\"btn btn-primary-action-pay proceed-btn\" ng-if=\"transactionType == \'PURCHASE\' && formData.purchasePaymentOption !== \'UPI\'\" ng-click=transactionOtmConfirmation() ng-disabled=\"tForm.$invalid || !confirmation || isOTMStartDate || isOTMAmount || isOTMDate ||\n                (formData.purchasePaymentOption === \'NETBANKING\' && (!formData.paymentInfo.bankName || !formData.paymentInfo.accountNumber)) ||\n                formData.paymentInfo.tpvEnableFlag == \'N\'\">Continue to pay</button> <button class=\"btn btn-primary-action-pay proceed-btn\" ng-if=\"transactionType == \'PURCHASE\' && formData.purchasePaymentOption === \'UPI\'\" ng-click=transactionOtmConfirmation() ng-disabled=\"tForm.$invalid || !confirmation\n                || !isUPIVerified || (!formData.bankInfo.minorBankFlag && checkForMinorBankListCondition())\">Continue to pay</button> <button class=\"btn btn-primary-action-pay proceed-btn\" ng-if=\"transactionType == \'SIP\' && formData.sipPaymentOption !== \'E-mandate\'\" ng-disabled=\"tForm.$invalid || !confirmation || sipPaymentOptions.length ===0 || (formData.sipPaymentOption == \'OTM\' && (formData.purchaseAmount > formData.paymentInfo.maxAmount || isInvalidDate || startDateValidation)) || (formData.sipPaymentOption==\'UPI\' && !isUPIVerified)\" ng-click=transactionOtmConfirmation() ng-disabled=tForm.$invalid>Continue to pay</button> <button class=\"btn btn-primary-action-pay proceed-btn\" ng-if=\"transactionType == \'SIP\' && formData.sipPaymentOption == \'E-mandate\'\" ng-disabled=\"tForm.$invalid || !confirmation || amountLess || amountMore || isLessThanSipAmount || sipDateLessEmandate\" ng-click=sipSubmitRegisterForm() ng-disabled=tForm.$invalid>Continue to pay</button></div></div></div></div><div class=\"initiate-transaction transaction-note-container c-mb-1\"><div class=transaction-note-desc ng-if=\"transactionType === \'PURCHASE\'\"><ng-bind-html dynamic=notes.content></ng-bind-html></div><div class=transaction-note-desc ng-if=\"transactionType === \'SIP\'\"><ng-bind-html dynamic=commonNote.content></ng-bind-html><ng-bind-html dynamic=notes.content></ng-bind-html></div></div></div></form><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=billdeskPayload.msg></form><style>.sipseconddiv{\n    padding: 30px 0px 10px 30px;\n  }\n  .p-short{\n    padding: 5px 0px 5px 0px;\n  }\n  .inputPayment{\n    height: 34px;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border: 1px solid #B8C6D1;\n    border-radius: 5px;\n  }\n  #switch {\n    height: 0;\n    width: 0;\n    visibility: hidden;\n  }\n  .switchlablePay {\n    cursor: pointer;\n    text-indent: -9999px;\n    width: 29px;\n    height: 16px;\n    background: #5ceb57;\n    display: block;\n    border-radius: 50px;\n    position: relative;\n  }\n\n  .switchlablePay:after {\n    content: \"\";\n    position: absolute;\n    top: 3px;\n    left: 5px;\n    width: 10px;\n    height: 10px;\n    background: #fff;\n    border-radius: 50px;\n  }\n\n  input:checked + .switchlablePay {\n    background: #5ceb57;\n  }\n  input:checked + .switchlablePay:after {\n    left: calc(100% - 5px);\n    transform: translateX(-100%);\n  }\n  .switchlablePay:active:after {\n    width: 10px;\n  }\n  .f-bold{\n    font-weight: 600;\n    color: #000000;\n  }\n  .c-pink{\n    font: normal normal 600 1.143em Poppins;\n    letter-spacing: 0px;\n    color: #FF8486;\n    opacity: 1;\n  }\n  .c-blue{\n    font: normal normal medium 12px/19px Poppins;\n    letter-spacing: 0px;\n    color: #7E8F95;\n    opacity: 1;\n  }\n  .summaryKey{\n    font: normal normal medium 12px/19px Poppins;\n    letter-spacing: 0px;\n    color: #7E8F95;\n    opacity: 1;\n  }\n  .modal-body1{\n    margin: auto;\n    padding: 50px;\n    width: 60%;\n    border-radius: 10px;\n    background: white;\n    box-shadow: -1px 1px 5px 1px lightgrey;\n  }\n  p{\n    color: #000000;\n  }\n  .d-padding{\n    padding: 10px 0px 10px 0px;\n  }\n  .lessPadding{\n    padding: 10px 10px 10px 20px;\n  }\n  @media screen and (max-width: 600px) {\n    .sipseconddiv{\n      padding: 10px 0px 10px 15px;\n    }\n    .boxdiv{\n      margin-left: 15px;\n    }\n    .modal-body1{\n      width: 100%;\n    }\n\n    .lessPadding{\n      padding: 0px;\n    }\n    .btn-primary-action-pay {\n      padding: 10px 10px 10px 10px;\n      border-color: transparent;\n      background-color: #FF8486;\n      color: white;\n\n    }\n  }\n  .hdfc-blue-cta-small{\n    background-color: #FF8486;\n    color: white;\n  }\n  .btn-primary-action-pay {    color: white;\n    border-color: transparent;\n    background-color: #FF8486;\n\n  }\n  .hdfc-blue-cta-small:disabled{\n    background-color: #FF8486;\n    color: white;\n  }\n  .btn-primary-action-pay:disabled {\n    border-color: transparent;\n    background-color: #fdbdbe;\n  }</style>");
$templateCache.put("app/investment-baskets/investment-basket-directives/suggestions-directive/suggestions.directive.html","<div class=row><div class=\"col-md-12 investment-details\"><div><label>Goal Amount:</label><span><i class=rupee-black-icon></i> {{suggestionList.goalAmount}}</span></div><div><hr></div><div class=top-flow><div class=flow-card><div class=value>Sip Amount</div><div class=lead><i class=rupee-black-icon></i>33,322</div></div><div class=flow-card><div class=value>Duration</div><div class=lead><i class=rupee-black-icon></i>{{suggestionList.duration}}</div></div></div></div></div><div class=row ng-if=\"suggestionList.baskets.length > 0\"><div class=col-md-12><hr></div></div><div class=row ng-if=\"suggestionList.schemes.length > 0\"><div class=col-md-12><div class=section-head><div class=section-title>Suggested Scheme:</div></div><div class=section-body><div class=row><div class=\"col-md-4 scheme-suggested-list\" ng-repeat=\"scheme in suggestionList.schemes\"><div>{{100 | unit}}%</div><div><div class=scheme-title>{{scheme.schemeName}}</div><div class=sub-details><div ng-repeat=\"detail in scheme.details\">{{detail}}</div></div><div class=scheme-details><div><label>Sip Amount:</label><i class=rupee-small-icon></i> <strong>{{scheme.sipAmount}}</strong></div><div><label>Scheme Type:</label><strong>{{scheme.schemeType}}</strong></div><div><label>Number of Investor:</label><strong>{{scheme.numberOfInvestor}}</strong></div></div><div class=scheme-action><button class=transact-action ng-click=\"proceedToInvestment(goal.goalName, goal.goalId)\">Start Investing</button></div></div></div></div></div></div></div><div class=row ng-if=\"suggestionList.baskets.length > 0\"><div class=col-md-12><hr></div></div><div class=\"row basket-suggestion-container\" ng-if=\"suggestionList.baskets.length > 0\"><div class=col-md-12><div class=section-head><div class=section-title>Suggested Baskets</div></div><div class=section-body><div class=row><div class=\"col-md-4 basket-container\" ng-repeat=\"basket in suggestionList.baskets\"><div class=basket><div class=basket-header><div class=basket-title>{{basket.basketName}}</div><div class=basket-action><a href=javascript:void(0)>View Details</a></div></div><div class=basket-body><div ng-repeat=\"basketScheme in basket.basketSchemes\"><div class=left-section><div><strong>{{basketScheme.schemeName}}</strong></div><div><strong ng-if=basketScheme.type>{{basketScheme.type}} |&nbsp;</strong> <span>{{basketScheme.riskProfile}}</span> <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Information needs to be added here\"></i></div></div><div class=right-section><div>SIP Amount</div><div><i class=rupee-small-icon></i> {{basketScheme.sipAmount}}</div></div></div></div><div class=basket-actions><button class=transact-action ng-click=\"proceedToInvestment(goal.goalName, goal.goalId)\">Start Investing</button></div></div></div></div></div></div></div><!--<folio-directive></folio-directive>-->");
$templateCache.put("app/investment-baskets/investment-basket-directives/transaction-directive/transaction.directive.html","<div class=invest-now-container><div class=\"invest-now-body row\"><div class=\"col-12 transaction-details col-sm-6\"><form name=tForm novalidate><div class=trans-row><div><label class=trans-title>Transaction Type</label><label class=trans-title ng-if=\"!showRadio && formData.transactionType == TRANSACTION_TYPE.LUMPSUM\" class=trans-radio-label>: Lumpsum</label><label class=trans-title ng-if=\"!showRadio && formData.transactionType == TRANSACTION_TYPE.SIP\" class=trans-radio-label>: SIP</label></div><div ng-if=showRadio class=radio-row><input class=trans-radio-btn ng-checked=\"formData.transactionType == TRANSACTION_TYPE.LUMPSUM\" name=trans-type type=radio value={{TRANSACTION_TYPE.LUMPSUM}} ng-model=formData.transactionType ng-change=onTransTypeChange(true)><label class=trans-radio-label>Lumpsum</label><input class=trans-radio-btn ng-checked=\"formData.transactionType == TRANSACTION_TYPE.SIP\" name=trans-type type=radio value={{TRANSACTION_TYPE.SIP}} ng-model=formData.transactionType ng-change=onTransTypeChange(true)><label class=trans-radio-label>SIP</label></div></div><br>Enter Amount<br><div class=amount-field-container><span class=\"rupee-span rupee-basket\"><img src=assets/images/icons/investor-basket/rupee-blue.svg> </span><input class=trans-input-amount ignore-mouse-wheel type=text placeholder=\"Enter amount\" ng-model=formData.displayAmount ng-change=onAmountChange(formData.displayAmount) ng-required=true name=amount maxlength=\"{{journey == \'GOAL_JOURNEY\' && formData.transactionType == \'SIP\' ? 14 : 20}}\" ng-maxlength=\"{{journey == \'GOAL_JOURNEY\' && formData.transactionType == \'SIP\' ? 14 : 20}}\" min={{basketDetails.minBasketAmount}} onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-class=\"{error:(tForm.amount.$dirty && tForm.amount.$invalid)||(formData.amount == \'\')}\" ng-disabled=\"isEdit || disableFields || isBasketCustomized\"><div class=\"error-input invalid-error-msg\" ng-show=\"(tForm.amount.$dirty && tForm.amount.$invalid &&tForm.amount.$error.required)\" ng-bind=VALIDATE_DATA.AMOUNT_REQUIRED></div><div class=\"error-input invalid-error-msg\" ng-show=\"(formData.amount) && formData.amount < minAmount\" ng-bind=\"VALIDATE_DATA.MIN_AMOUNT_BASKET + \' ₹\' +  convertToLocalString(minAmount)\"></div><!--<div ng-show=\"formData.amount && tForm.amount.$error.schemeAmountError && tForm.amount.$invalid && !(formData.amount < minAmount)\" class=\"error-input invalid-error-msg\"\n               ng-bind=\"VALIDATE_DATA.INVALID_AMOUNT_BASKET\"></div>--></div><div style=\"color: #6F6F6F\"><label style=\"padding-top: 12px\">{{formData.amountInWords}}</label></div><div ng-if=\"journey !== \'GOAL_JOURNEY\'\" class=scheme-option-container><button class=btn-scheme-option ng-repeat=\"amountOption in amountOptions\" ng-class=\"amountOption == formData.amount ? \'active\': \'\'\" ng-click=onAmountChange(amountOption) ng-disabled=\"isEdit || disableFields || isBasketCustomized\"><span class=rupee-span>₹</span> {{convertToLocalString(amountOption)}}</button></div><div class=sip-details ng-show=\"formData.transactionType == TRANSACTION_TYPE.SIP\"><br><div class=\"date-section initiate-transaction\"><div><label class=sip-date-label>SIP Start Date:</label></div><!--          <input class=\"trans-datepicker\" type=\"date\" ng-model=\"formData.sipStartDate\">--><!-- SIP Start Datepicker --><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:tForm.sipStartDate.$dirty && tForm.sipStartDate.$invalid}\" date-calendar data-viewmode={{viewMode}} data-date-default=formData.sipStartDate data-on-date-change=changeStartDate data-min-date=calendarRange.minSipStartDate data-max-date=calendarRange.maxSipStartDate data-view-date=enabledEndDateView id=sipStartDate data-enable=true style=\"position: relative\"><input type=text ng-model=formData.sipStartDate name=sipStartDate ng-required=\"formData.transactionType == TRANSACTION_TYPE.SIP\" placeholder=\"Select Start Date\" readonly> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span> </span><!--              <label ng-if=\"formData.sipStartDate\">Select Start Date</label>--> <span class=highlight></span> <span class=bar></span><!--              <span class=\"error-input\" ng-show=\"tForm.sipEndDate.$dirty && tForm.sipStartDate.$error.required\"--><!--                    ng-bind=\"VALIDATE_DATA.START_DATE_REQUIRED\"></span>--></div></div><!--for other journeys--><div ng-if=showRadio class=\"date-section initiate-transaction\"><div><label class=sip-date-label>SIP End Date:</label></div><!--          <input class=\"trans-datepicker\" type=\"date\" ng-model=\"formData.sipEndDate\">--><!-- SIP End Datepicker --><div class=\"input-select input-normal input-group date date-picker transaction-cal\" style=\"position: relative\" ng-class=\"{error:tForm.sipEndDate.$dirty && tForm.sipEndDate.$invalid}\" date-calendar data-viewmode={{viewMode}} data-date-default=formData.sipEndDate data-on-date-change=changeEndDate data-enabled-dates=enabledEndDates data-min-date=enabledEndDateView[0] data-view-date=enabledEndDateView id=sipEndDate data-enable=true style=\"position: relative\"><input type=text ng-model=formData.sipEndDate name=sipEndDate ng-required=\"formData.transactionType == TRANSACTION_TYPE.SIP\" placeholder=\"Select End Date\" readonly> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span> </span><!--              <label ng-if=\"formData.sipEndDate\">Select End Date</label>--> <span class=highlight></span> <span class=bar></span> <i style=\"position:absolute;left: 100%;top: 25%;margin-left: 10px\" class=\"info-icon base-tooltip\" tooltip=\"\" data-toggle=tooltip data-bs-placement=right tooltip-side=right data-bs-title={{mandateInfo}}></i><!--              <span class=\"error-input\" ng-show=\"tForm.sipEndDate.$dirty && tForm.sipEndDate.$error.required\"--><!--                    ng-bind=\"VALIDATE_DATA.END_DATE_REQUIRED\"></span>--></div></div><!--for goal journey--><div ng-if=!showRadio class=\"date-section initiate-transaction\"><div><label class=sip-date-label>SIP End Date:</label></div><!--          <input class=\"trans-datepicker\" type=\"date\" ng-model=\"formData.sipEndDate\">--><!-- SIP End Datepicker --><div class=\"input-select input-normal input-group date date-picker transaction-cal\" style=\"position: relative\" ng-class=\"{error:tForm.sipEndDate.$dirty && tForm.sipEndDate.$invalid, \'anything-disabled\': !disableFields && !isBasketCustomized}\" date-calendar data-viewmode={{viewMode}} data-date-default=formData.sipEndDate data-on-date-change=changeEndDate data-enabled-dates=enabledEndDates data-min-date=enabledEndDateView[0] data-view-date=enabledEndDateView id=sipEndDate data-enable=true style=\"position: relative\"><input type=text ng-model=formData.sipEndDate name=sipEndDate ng-required=\"formData.transactionType == TRANSACTION_TYPE.SIP\" placeholder=\"Select End Date\" readonly> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span> </span><!--              <label ng-if=\"formData.sipEndDate\">Select End Date</label>--> <span class=highlight></span> <span class=bar></span> <i style=\"position:absolute;left: 100%;top: 25%;margin-left: 10px\" class=\"info-icon base-tooltip\" tooltip=\"\" data-toggle=tooltip data-bs-placement=right tooltip-side=right data-bs-title={{mandateInfo}}></i><!--              <span class=\"error-input\" ng-show=\"tForm.sipEndDate.$dirty && tForm.sipEndDate.$error.required\"--><!--                    ng-bind=\"VALIDATE_DATA.END_DATE_REQUIRED\"></span>--></div></div><div ng-if=\"showRadio || (!(!disableFields && !isBasketCustomized) && journey == \'GOAL_JOURNEY\')\" class=date-section><div></div><div style=\"max-width: 200px\" class=end-date-default><div class=\"col-md-4 default-date\" ng-class=\"{\'anything-disabled\': !formData.sipStartDate }\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=defaultDate ng-class=\"{\'anything-disabled\': !formData.sipStartDate }\" ng-model=formData.isTillPerpetuity ng-change=changeTillPerpetuityFlag() ng-disabled=!formData.sipStartDate> <span class=icon-checkbox></span> </span><!--                <label style=\"margin-left: 10px\" for=\"defaultDate\">Default date shall be December 2099</label>--><label style=\"margin-left: 10px\" for=defaultDate>Choose Default End Date, which is 2099</label></div></div></div></div></form></div><div class=\"col-12 basket-details col-sm-6\"><div class=basket-title><div class=basket-name><span ng-if=!isEditBasketName tooltip-placement=top uib-tooltip={{basketDetails.basketName}}>{{basketDetails.basketName}}</span><form name=form.basketForm ng-if=isEditBasketName ng-class=\"{\'anything-disabled\': !isEdit}\" tooltip-placement=top uib-tooltip={{customBasketName}}><input name=customName ng-pattern=/^[\\w\\S\\s.-]{2,50}$/ ng-model=customBasketName ng-change=changeBasketName(customBasketName) required maxlength=50><div ng-show=\"form.basketForm.customName.$dirty && form.basketForm.customName.$error.required\" class=invalid-error-msg>Basket name is required</div><div ng-show=\"form.basketForm.customName.$dirty && form.basketForm.customName.$error.pattern\" class=invalid-error-msg>Invalid basket name</div></form></div><label ng-if=\"showRadio && !fromPreLogin\" class=link-view-details ng-click=viewDetails()>View Details</label><div ng-if=!isEdit class=edit-icon-wrapper><i class=\"pull-right edit-icon\" ng-click=editBasket(isEdit)></i></div><div ng-if=isEdit class=\"pull-right edit-icon-wrapper hide-on-mob\"><button type=button ng-disabled=\"schemeAmountError || form.basketForm.$invalid\" ng-click=editBasket(isEdit)>Save</button></div></div><div class=basket-info-container><div class=no-data-content ng-hide=\"basketDetails.schemesInBasket && basketDetails.schemesInBasket.length > 0\">No Data Found</div><div class=scheme-container ng-repeat=\"scheme in basketDetails.schemesInBasket\"><div class=\"basket-info-row edit-scheme-wrapper\"><div class=basket-info-header><a class=fund-link href={{scheme.fundUrl}} target=_blank>{{scheme.schemeName}}</a><div ng-show=\"scheme.errorMsg && isEdit\" class=\"invalid-error-msg hide-on-mob\">{{scheme.errorMsg}}</div></div><div ng-if=!isEdit class=basket-info-data><span class=rupee-span>₹</span>{{convertToLocalString(scheme.amount) || \'0\'}}</div><div ng-if=isEdit class=basket-info-data><span class=\"rupee-scheme-span rupee-basket\"><img src=assets/images/icons/investor-basket/rupee-blue.svg> </span><input type=text class=custom-scheme-amount name=schemeAmount ignore-mouse-wheel maxlength=\"{{journey == \'GOAL_JOURNEY\' && formData.transactionType == \'SIP\' ? 14 : 20}}\" ng-maxlength=\"{{journey == \'GOAL_JOURNEY\' && formData.transactionType == \'SIP\' ? 14 : 20}}\" ng-model=scheme.customSchemeAmountDisplay ng-change=editSchemeAmount(scheme) stopcopypaste></div><div ng-show=\"scheme.errorMsg && isEdit\" class=\"invalid-error-msg d-none error-show-on-mob\">{{scheme.errorMsg}}</div></div><!--          <div ng-show=\"formData.amount && scheme.errorMsg\" class=\"invalid-error-msg\">{{scheme.errorMsg}}</div>--></div></div><div ng-if=isEdit class=\"edit-icon-wrapper d-none show-on-mob\"><button type=button ng-disabled=\"schemeAmountError || form.basketForm.$invalid\" ng-click=editBasket(isEdit)>Save</button></div></div></div></div><div class=invest-now-btn-container><div class=invest-now-btn-main><button ng-if=\"invType !== \'NEW\'\" class=back-btn ng-click=back();>Back</button> <button ng-disabled=\"tForm.$invalid || (formData.amount < minAmount && !disableFields) || isEdit || schemeAmountError\" class=process-btn ng-click=\"onProceed(false, editBasketDetailsSaved, false);\">{{getProceedBtnLbl()}}</button></div></div><div class=disclaimer-container><h3 class=disclaim-title ng-if=disclaimer>Disclaimers:</h3><div class=disclaim-desc><div ng-bind-html=disclaimer></div></div></div>");
$templateCache.put("app/investment-baskets/investment-basket-directives/transaction-directive-scheme/transaction.scheme.directive.html","<div class=invest-now-container><div class=\"invest-now-body row\" ng-class=\"formData.transactionType == TRANSACTION_TYPE.LUMPSUM ? \'lumpsum-active\': \'\'\"><div class=\"col-12 transaction-details\" ng-class=\"formData.transactionType == TRANSACTION_TYPE.LUMPSUM ? \'col-sm-12\': \'col-sm-6\'\"><form name=tForm novalidate><div class=trans-row><div><label class=trans-title>Transaction Type</label><label class=trans-title ng-if=\"formData.transactionType == TRANSACTION_TYPE.LUMPSUM\" class=trans-radio-label>: Lump sum</label><label class=trans-title ng-if=\"formData.transactionType == TRANSACTION_TYPE.SIP\" class=trans-radio-label>: SIP</label></div><!--          <div>--><!--            <input class=\"trans-radio-btn\" ng-checked=\"formData.transactionType == TRANSACTION_TYPE.LUMPSUM\"--><!--                   name=\"trans-type\" type=\"radio\"--><!--                   value=\"{{TRANSACTION_TYPE.LUMPSUM}}\"--><!--                   ng-model=\"formData.transactionType\" ng-change=\"onTransTypeChange()\"> <label--><!--            class=\"trans-radio-label\"> Lump--><!--            sum </label>--><!--            <input class=\"trans-radio-btn\" ng-checked=\"formData.transactionType == TRANSACTION_TYPE.SIP\"--><!--                   name=\"trans-type\"--><!--                   type=\"radio\"--><!--                   value=\"{{TRANSACTION_TYPE.SIP}}\"--><!--                   ng-model=\"formData.transactionType\" ng-change=\"onTransTypeChange()\"> <label--><!--            class=\"trans-radio-label\"> SIP </label>--><!--          </div>--></div><br>Enter Amount<br><div class=amount-field-container><span class=\"rupee-span rupee-basket\"><img src=assets/images/icons/investor-basket/rupee-blue.svg> </span><input class=trans-input-amount ignore-mouse-wheel type=text placeholder=\"Enter amount\" ng-model=formData.displayAmount ng-change=onAmountChange(formData.displayAmount) ng-required=true name=amount min={{basketDetails.minBasketAmount}} onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" maxlength=\"{{journey == \'GOAL_JOURNEY\' && formData.transactionType == \'SIP\' ? 14 : 20}}\" ng-maxlength=\"{{journey == \'GOAL_JOURNEY\' && formData.transactionType == \'SIP\' ? 14 : 20}}\" ng-class=\"{error:(tForm.amount.$dirty && tForm.amount.$invalid)||(formData.amount == \'\')}\"><div class=\"error-input invalid-error-msg\" ng-show=\"(tForm.amount.$dirty && tForm.amount.$invalid &&tForm.amount.$error.required)\" ng-bind=VALIDATE_DATA.AMOUNT_REQUIRED></div><!--sip error messages scheme--><div ng-if=\"formData.amount && isMin\" class=error-input>Minimum amount should be &#8377; {{convertToLocalString(validations.minAmount)|unit}}</div><div ng-if=\"formData.amount && !isMax && !isMin && (validations.amountMultiples && !isMultiples)\" class=error-input>Please provide amount in multiples of &#8377; {{validations.amountMultiples|unit}}</div><!-- purchase error message schemes--><div ng-if=\"formData.amount && isPurchaseMin\" class=\"error-input purchase-amount-error\">{{\'Minimum amount should be ₹\'+ purchaseMinAmount}}<span ng-if=\"formData.amount % 1 != 0\">,</span></div><div ng-if=\"formData.amount && !isPurchaseMin && (purchaseValidations.purchaseMultiple && !isMultiples)\" class=\"error-input purchase-amount-error\">Please provide amount in multiples of &#8377;{{purchaseValidations.purchaseMultiple|unit}}<span ng-if=\"formData.amount % 1 != 0\">,</span></div></div><div style=\"color: #6F6F6F\"><label style=\"padding-top: 12px\">{{amountInWords}}</label></div><!--        <div class=\"scheme-option-container\">--><!--          <button class=\"btn-scheme-option\" ng-repeat=\"amountOption in amountOptions\"--><!--                  ng-class=\"amountOption == formData.amount ? \'active\': \'\'\"--><!--                  ng-click=\"onAmountChange(amountOption)\">--><!--            <span class=\"rupee-span\">₹ </span> {{convertToLocalString(amountOption)}}--><!--          </button>--><!--        </div>--><div class=sip-details ng-show=\"formData.transactionType == TRANSACTION_TYPE.SIP\"><br><div class=\"date-section initiate-transaction\"><div><label class=sip-date-label>SIP Start Date:</label></div><!--          <input class=\"trans-datepicker\" type=\"date\" ng-model=\"formData.sipStartDate\">--><!-- SIP Start Datepicker --><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:tForm.sipStartDate.$dirty && tForm.sipStartDate.$invalid}\" date-calendar data-viewmode={{viewMode}} data-date-default=formData.sipStartDate data-on-date-change=changeStartDate data-min-date=calendarRange.minSipStartDate data-max-date=calendarRange.maxSipStartDate id=sipStartDate data-enable=true style=\"position: relative\"><input type=text ng-model=formData.sipStartDate name=sipStartDate ng-required=\"formData.transactionType == TRANSACTION_TYPE.SIP\" placeholder=\"Select Start Date\" readonly> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span> </span><!--              <label ng-if=\"formData.sipStartDate\">Select Start Date</label>--> <span class=highlight></span> <span class=bar></span><!--              <span class=\"error-input\" ng-show=\"tForm.sipEndDate.$dirty && tForm.sipStartDate.$error.required\"--><!--                    ng-bind=\"VALIDATE_DATA.START_DATE_REQUIRED\"></span>--></div></div><!--for goal journey--><div class=\"date-section initiate-transaction\"><div><label class=sip-date-label>SIP End Date:</label></div><!--          <input class=\"trans-datepicker\" type=\"date\" ng-model=\"formData.sipEndDate\">--><!-- SIP End Datepicker --><div class=\"input-select input-normal input-group date date-picker transaction-cal anything-disabled\" style=\"position: relative\" ng-class=\"{error:tForm.sipEndDate.$dirty && tForm.sipEndDate.$invalid}\" date-calendar data-viewmode={{viewMode}} data-date-default=formData.sipEndDate data-on-date-change=changeEndDate data-enabled-dates=enabledEndDates data-min-date=calendarRange.minSipEndDate id=sipEndDate data-enable=true style=\"position: relative\"><input type=text ng-model=formData.sipEndDate name=sipEndDate ng-required=\"formData.transactionType == TRANSACTION_TYPE.SIP\" placeholder=\"Select End Date\" readonly> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span> </span><!--              <label ng-if=\"formData.sipEndDate\">Select End Date</label>--> <span class=highlight></span> <span class=bar></span> <i style=\"position:absolute;left: 100%;top: 25%;margin-left: 10px\" class=\"info-icon base-tooltip\" tooltip=\"\" data-toggle=tooltip data-bs-placement=right tooltip-side=right data-bs-title={{mandateInfo}}></i><!--              <span class=\"error-input\" ng-show=\"tForm.sipEndDate.$dirty && tForm.sipEndDate.$error.required\"--><!--                    ng-bind=\"VALIDATE_DATA.END_DATE_REQUIRED\"></span>--></div></div></div></form></div><div class=\"col-12 basket-details\" ng-class=\"formData.transactionType == TRANSACTION_TYPE.LUMPSUM ? \'col-sm-12\': \'col-sm-6\'\"><div class=basket-title><div class=basket-name>{{basketDetails.basketName}}</div></div><div class=basket-info-container><div class=no-data-content ng-show=\"journeyDetails.schemes[0].length === 0\">No Data Found</div><div class=scheme-container><div class=basket-info-row><!--            <div class=\"basket-info-header\"> {{journeyDetails.schemes[0].schemeName}}</div>--><div class=basket-info-header><a class=fund-link href={{fundUrl}} target=_blank>{{journeyDetails.schemes[0].schemeName}}</a></div><div class=basket-info-data><span class=rupee-span>₹ </span>{{convertToLocalString(formData.amount) || \'0\'}}</div></div><!--          <div ng-show=\"formData.amount && scheme.errorMsg\" class=\"invalid-error-msg\">{{scheme.errorMsg}}</div>--></div></div></div></div></div><div class=invest-now-btn-container><div class=invest-now-btn-main><button ng-if=\"invType !== \'NEW\'\" class=back-btn ng-click=back();>Back</button> <button ng-disabled=\"tForm.$invalid || !isMultiples || isMin\" class=process-btn ng-click=onProceed();>Proceed to Folio Creation</button></div></div><div class=disclaimer-container><h3 class=disclaim-title ng-if=disclaimer>Disclaimers:</h3><div class=disclaim-desc><div ng-bind-html=disclaimer></div></div></div>");
$templateCache.put("app/investment-baskets/investment-transaction/investment-purchase/investment-purchase.html","<div class=basket-purchase><h2 class=basket-information-header>Lumpsum Investment</h2><div class=\"row goal-amount\"><div class=col-md-8><div class=\"row pad-top\"><div class=col-md-6><div class=basket-scheme-info><div class=basket-header><div class=fund-allocation><p>Enter Amount</p><p class=fund-info-perc></p></div></div><div class=fund-info><i class=rupee-grey-icon></i> <input type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=pAmount ng-model=Transaction.formData.purchaseAmount ng-change=Transaction.checkPurchaseValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ondrop=\"return false\" placeholder=\"Lumpsum Amount is 5000\" required></div><div class=form-group><label id=divDisplayWords>{{Transaction.amountInWords}}</label></div></div></div><div class=col-md-2><div class=\"basket-scheme-info mg-goal\"><div class=fund-info><i class=rupee-grey-icon></i><h2>5000</h2></div></div></div><div class=col-md-2><div class=\"basket-scheme-info mg-goal\"><div class=fund-info><i class=rupee-grey-icon></i><h2>7000</h2></div></div></div><div class=col-md-2><div class=\"basket-scheme-info mg-goal\"><div class=fund-info><i class=rupee-grey-icon></i><h2>10000</h2></div></div></div></div></div></div></div><div class=\"row suggestion-container\"><div class=col-md-12><div class=\"row basket-suggestion-container\" ng-if=\"Investment.suggestionList.baskets.length > 0\"><div class=col-md-12><div class=section-head><div class=section-title></div></div><div class=section-body><div class=row><div class=\"col-md-4 basket-container\" ng-repeat=\"basket in Investment.suggestionList.baskets\"><div class=basket><div class=basket-header><div class=basket-title>{{basket.basketName}}</div><div class=basket-action><a href=javascript:void(0)>View Details</a></div></div><div class=basket-body><div ng-repeat=\"basketScheme in basket.basketSchemes\"><div class=left-section><div><strong>{{basketScheme.schemeName}}</strong></div><div><strong ng-if=basketScheme.type>{{basketScheme.type}} |&nbsp;</strong> <span>{{basketScheme.riskProfile}}</span> <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right title=\"Information needs to be added here\"></i></div></div><div class=right-section><div>SIP Amount</div><div><i class=rupee-small-icon></i> {{basketScheme.sipAmount}}</div></div></div></div><div class=basket-actions><button class=transact-action ng-click=\"Investment.proceedToInvestment(goal.goalName, goal.goalId)\">Start Investing</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/investment-baskets/investment-transaction/investment-sip/investment-sip.html","SIP");
$templateCache.put("app/new-investors/folio-details/bank-details/bank-details.html","<div class=bankdetails ng-init=BankDetails.gettaxStatus()><div class=row><div class=\"col-xs-12 col-md-6\"><form name=bankDetailsForm id=bankDetailsForm ng-submit=BankDetails.submitBankAccountDetails()><!-- IFSC code --><div class=row><div class=\"col-xs-12 col-md-12\" style=\"display: flex;align-items: center;\n                    justify-content: space-between\"><p class=investmentTitle>IFSC Code</p><div class=alignifsctext style=\"display: flex;justify-content: space-between;align-items: center\" ng-click=BankDetails.selectIFSC()><a style=\"height: 15px;width: 20px\"><svg class=\"svg-icon search-icon\" aria-labelledby=\"title desc\" role=img viewBox=\"0 0 19.9 19.7\"><title id=title>Search Icon</title><desc id=desc>A magnifying glass icon.</desc><g class=search-path fill=none stroke=#669ddf><path stroke-linecap=square stroke-width=3 d=\"M18.5 18.3l-5.4-5.4\"/><circle stroke-width=2 cx=8 cy=8 r=7 /></g></svg></a><p style=\"color: #669ddf;font-size: 12px\">SEARCH IFSC</p></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><input type=text class=\"form-control inputNormal\" name=ifsccode id=ifsccode autocomplete=off maxlength=11 minlength=11 ng-maxlength=11 limit-to=11 ng-model=BankDetails.bankAccountDetailsForm.ifscCode ng-pattern=BankDetails.IFSC_REGEX capitalize required readonly style=\"background-color: #ffffff;width: 336px\"></div><div ng-show=\"bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid\" style=\"margin-left: 15px\"><span class=error-input ng-show=bankDetailsForm.ifsccode.$error.pattern>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><br><!-- Account Type --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Account Type</p></div><div class=\"col-xs-12 col-md-12\"><select class=selectNormal id=accountType name=accountType ng-model=BankDetails.bankAccountDetailsForm.accountType required style=\"height: 40px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"value in BankDetails.bankAccountType\" ng-selected=\"BankDetails.bankAccountDetailsForm.accountType == value.accountTypeCode\" value={{value.accountTypeCode}}>{{value.accountType}}</option></select></div></div><br><!-- payout Mechanism --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Payout Mechanism</p></div><div class=\"col-xs-12 col-md-12\"><select class=selectNormal id=accountType name=accountType ng-model=BankDetails.bankAccountDetailsForm.bankDetails.payoutMechanism required style=\"height: 40px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"value in BankDetails.payoutMechanismList\" ng-selected=\"BankDetails.bankAccountDetailsForm.bankDetails.payoutMechanism == value.payoutCode\" value={{value.payoutCode}}>{{value.payoutDescription}}</option></select></div></div><br><!-- Account Number --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Account Number</p></div><div class=\"col-xs-12 col-md-12\"><input type=password class=\"form-control inputNormal\" name=bankaccountnumber id=bankaccountnumber ng-maxlength=20 autocomplete=off ng-model=BankDetails.bankAccountDetailsForm.accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required style=\"width: 336px\"> <span ng-show=\"bankDetailsForm.bankaccountnumber.$dirty && bankDetailsForm.bankaccountnumber.$invalid\"><span class=error-input ng-show=bankDetailsForm.bankaccountnumber.$error.required>Bank Account Number required!</span> <span class=error-input ng-show=\"bankDetailsForm.bankaccountnumber.$error.maxlength || bankDetailsForm.bankaccountnumber.$error.minlength\">Bank account number should be in range 1 to 20.</span></span></div></div><br><!-- verify Account Number --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Verify Account Number</p></div><div class=\"col-xs-12 col-md-12\"><input type=number class=\"form-control inputNormal\" name=verifybankaccountnumber id=verifybankaccountnumber ng-maxlength=20 ng-model=BankDetails.bankAccountDetailsForm.accountNumberverify onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-change=BankDetails.matchAccountNumber() autocomplete=off ng-pattern=BankDetails.bankAccountDetailsForm.accountNumber required style=\"width: 336px\" easyassist-key=mask-element> <span ng-show=\"bankDetailsForm.verifybankaccountnumber.$dirty && bankDetailsForm.verifybankaccountnumber.$invalid\"><span class=error-input ng-show=bankDetailsForm.verifybankaccountnumber.$error.required>Bank Account Number required!</span> <span class=error-input ng-show=\"bankDetailsForm.verifybankaccountnumber.$error.maxlength || bankDetailsForm.verifybankaccountnumber.$error.minlength\">Bank account number should be in range 1 to 20.</span> <span class=error-input ng-show=bankDetailsForm.verifybankaccountnumber.$error.pattern>Bank account number should be same.</span></span></div></div><br><!-- chequesleaf --><div class=row ng-if=BankDetails.showcheckLeaf><!-- <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                        <a style=\"color: blue;\">{{BankDetails.bankAccountDetailsForm.chequesleafImageUrl}}</a>\n                    </div> --><div class=\"col-xs-12 col-sm-6 col-md-8\" style=\"padding: 10px 0px 15px 12px\"><label for=chequesleafImage style=\"text-align: right;\n                    padding: 10px;\n                    padding-left: 35px;\n                    background-color: lightgray;\n                    border-radius: 25px;\n                    cursor: pointer;\n                    background-size: 28px;\n                    background-position-x: 5px;\n                    background-position-y: 3px;\n                    background-repeat: no-repeat;\n                    background-image: url(../../../../assets/images/new-investor/uploadIcon.png)\">Upload Cheque leaf</label><input type=file name=chequesleafImage id=chequesleafImage accept=image/tiff,image/tif,image/jpeg,image/jpg file-model-profile=\"Preview Uploaded Doc\" ng-model=BankDetails.bankAccountDetailsForm.chequesleafImageUrl upload=BankDetails.bankUploadChequeLeafFile(file) style=\"display: none;visibility: none\" required></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><p ng-if=\"BankDetails.fileType == \'jpg\' ||  BankDetails.fileType == \'jpeg\'\" ng-click=BankDetails.openUploadedDoc() style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 5px\">Show Image</p><a href=javascript:void(0) ng-click=BankDetails.downloadFile() ng-if=\"BankDetails.fileType == \'tif\' || BankDetails.fileType == \'tiff\' \" style=\"color: blue;cursor: pointer\" download>Download</a></div></div><!-- Submit button --><div style=\"display: flex;justify-content: space-between\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-if=BankDetails.showcheckLeaf ng-click=BankDetails.submitWithCheckLeaf() ng-disabled=\"!BankDetails.bankAccountDetailsForm.chequesleafImageUrl ||\n                            !BankDetails.bankAccountDetailsForm.ifscCode ||\n                            !BankDetails.bankAccountDetailsForm.accountType ||\n                            !BankDetails.bankAccountDetailsForm.bankDetails.payoutMechanism ||\n                            !BankDetails.bankAccountDetailsForm.accountNumber ||\n                            !BankDetails.bankAccountDetailsForm.accountNumberverify\">CONTINUE</button> <button type=submit class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-if=!BankDetails.showcheckLeaf ng-disabled=\"\n                            !BankDetails.bankAccountDetailsForm.ifscCode ||\n                            !BankDetails.bankAccountDetailsForm.accountType ||\n                            !BankDetails.bankAccountDetailsForm.bankDetails.payoutMechanism ||\n                            !BankDetails.bankAccountDetailsForm.accountNumber ||\n                            !BankDetails.bankAccountDetailsForm.accountNumberverify\">CONTINUE</button></div></form></div><div class=\"col-xs-12 col-md-6\"><div class=warning style=\"width: 250px;margin-top: 28px\" ng-if=!BankDetails.bankAccountDetailsForm.ifscCode><img src=../../../assets/images/icons/light-bulb.png style=\"width: 50px;height: 30px;margin: 10px 10px 0px 10px\"><div style=\"padding: 5px\"><br><p style=\"line-height: 20px;\n                    font-size: 12px;\n                    font-weight: 500\">Your bank account details will be used to credit or debit funds, credit dividends, among other things.</p><br><p style=\"line-height: 20px;\n                font-size: 12px;\n                font-weight: 500;margin-right: 6px\">Your details are absolutely safe with us and payment will only be done if you authorise us to make a payment.</p><br><br></div></div><div class=bankinfo ng-if=BankDetails.bankAccountDetailsForm.ifscCode style=\"background-color: white;border-radius: 8px;padding: 18px;width: 80%;margin-top: 28px\"><p style=\"font-size:12px;letter-spacing: 0px;color: #7E8F95\">Bank Name: <span style=\"font-weight: 600;font-size: 12px;color: #000000\">&nbsp;{{BankDetails.bankAccountDetailsForm.bankName}}</span></p><br><p style=\"font-size:12px;letter-spacing: 0px;color: #7E8F95\">Branch City: <span style=\"font-weight: 600;font-size: 12px;color: #000000\">&nbsp;{{BankDetails.bankAccountDetailsForm.bankCity}}</span></p><br><p style=\"font-size:12px;letter-spacing: 0px;color: #7E8F95\">Branch Location: <span style=\"font-weight: 600;font-size: 12px;color: #000000\">&nbsp;{{BankDetails.bankAccountDetailsForm.branchLocation}}</span></p></div></div></div></div><style>.inputNormal{\n        width: 336px;\n        background-color: #ffffff;\n    }\n    .selectNormal{\n        width: 336px;\n    }\n    .alignifsctext {\n        margin-left: 243px; \n        position: absolute;\n    }\n    @media only screen and (max-width: 508px) { \n       .alignifsctext {   \n            margin-left: 210px;\n      } \n    }</style>");
$templateCache.put("app/new-investors/folio-details/folio-basic-details/folio-basic-details.html","<div class=basicdetailsform><br><!-- Selfmode --><div class=selffolio ng-if=\"folioBasicDetail.folioForUser == \'Self\'\"><form autocomplete=off name=folioSelfSingleBasicForm ng-submit=FolioBasicDetails.submitFolioSelfSingleBsicForm()><div class=row><div class=\"col-xs-12 col-md-6\"><p class=titleFatca>Create Folio For</p><div class=\"row btn-ss\" style=\"margin-left: 2px\"><p ng-click=\"FolioBasicDetails.chooseFolioFor(\'Self\')\" ng-attr-class=\"{{folioBasicDetail.folioForUser == \'Self\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">Self</span></p><p ng-click=\"FolioBasicDetails.chooseFolioFor(\'Minor\')\" ng-attr-class=\"{{folioBasicDetail.folioForUser == \'Minor\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">Minor</span></p></div></div></div><br><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1>Mode Of Holding</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=btn-l><p ng-attr-class=\"{{folioBasicDetail.folioHoldingMode == \'SINGLE\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getholdingmode(\'SINGLE\')\"><span style=\"margin: auto\">Single</span></p><p ng-attr-class=\"{{folioBasicDetail.folioHoldingMode == \'ANY_OR_SURVIVOR\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getholdingmode(\'ANY_OR_SURVIVOR\')\"><span style=\"margin: auto\">Anyone or Survivor</span></p></div></div></div><br><!-- OTHER THAN INDIA --><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1 style=\"margin: 15px 0px 10px -10px\">Do you pay or file tax in a country other than India?</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=btn-l><p ng-attr-class=\"{{folioBasicDetail.fileTaxOtherIndian == \'Yes\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getTaxFileStatus(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{folioBasicDetail.fileTaxOtherIndian == \'No\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getTaxFileStatus(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div><br><!-- FATCA QUESTIONS --><div ng-if=!folioBasicDetail.Fatca.taxPayIndia><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxPaycountry name=taxPaycountry ng-model=folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry style=\"width: 336px;height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.countries\" ng-selected=\"folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select><span ng-show=\"folioSelfSingleBasicForm.taxPaycountry.$dirty && !folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry\"><span class=error-input ng-show=folioSelfSingleBasicForm.taxPaycountry.$error.required ng-bind=FolioBasicDetails.validateData.SELECT_COUNTRY></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID Type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxIdType name=taxIdType ng-model=folioBasicDetail.Fatca.fatcaTax1.taxIdType easyassist-key=mask-element style=\"width: 336px;height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.taxIdType\" ng-selected=\"folioBasicDetail.Fatca.fatcaTax1.taxIdType == value.value\" value={{value.value}}>{{value.description}}</option></select><span ng-show=\"folioSelfSingleBasicForm.taxIdType.$dirty && !folioBasicDetail.Fatca.fatcaTax1.taxIdType\"><span class=error-input ng-show=folioSelfSingleBasicForm.taxIdType.$error.required ng-bind=FolioBasicDetails.validateData.TAX_ID_TYPE></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxpayingCity type=text name=taxpayingCity ng-model=folioBasicDetail.Fatca.fatcaTax1.taxPayingCity ng-pattern=\"/^[a-zA-Z ]+$/\" required easyassist-key=mask-element> <span ng-show=\"folioSelfSingleBasicForm.taxpayingCity.$dirty && folioSelfSingleBasicForm.taxpayingCity.$invalid\"><span class=error-input ng-show=folioSelfSingleBasicForm.taxpayingCity.$error.required ng-bind=FolioBasicDetails.validateData.CITY></span> <span class=error-input ng-show=folioSelfSingleBasicForm.taxpayingCity.$error.pattern>Number not allowed in minor name!</span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxId type=text name=taxId ng-model=folioBasicDetail.Fatca.fatcaTax1.taxId ng-maxlength=20 limit-to=20 maxlength=20 required easyassist-key=mask-element> <span ng-show=\"folioSelfSingleBasicForm.taxId.$dirty && folioSelfSingleBasicForm.taxId.$invalid\"><span class=error-input ng-show=folioSelfSingleBasicForm.taxId.$error.required ng-bind=FolioBasicDetails.validateData.TAX_ID_NUMBER></span></span></div></div></div><br><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1 style=\"margin-top: 0px\">Politicaly Exposed Person(PEP) status</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=btn-l><p ng-attr-class=\"{{folioBasicDetail.userPEPStatus == \'Yes\' ? \'btn-active1 col-xs-6 first-btn  col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getPEPStatus(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{folioBasicDetail.userPEPStatus == \'No\' ? \'btn-active1 col-xs-6 last-btn  col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getPEPStatus(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div><br><div class=row style=\"margin: 15px 0px 0px 0px\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit>CONTINUE</button></div></form></div><div class=popup ng-if=showPopUpWindow><div class=popupIcon><img src=../../../../assets/images/note-icon.svg></div><div class=popupNote><p style=\"font-weight: bold\">Please note:</p><p class=f-w-100>You have unsaved changes which will lead to</p><p class=f-w-100>loss of information provided.</p><p class=f-w-100>Are you sure you want to proceed?</p></div><div class=btnDiv><button class=popupBtn type=button ng-click=FolioBasicDetails.stayWithMajor()>No</button> <button class=popupBtn type=button ng-click=FolioBasicDetails.gotoMinor()>Yes</button></div></div></div><style>.popup{\n    border-radius: 20px;\n    background: rgb(255 255 255);\n    box-shadow: 0px 2px 14px rgb(18 66 101 / 30%);\n    color: black;\n    width: 100%;\n    border-radius: 13px;\n    z-index: 999;\n    position: relative;\n    top: -90px;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;flex-direction: column;\n  }\n  .btnDiv{\n    width: 50%;\n    padding: 30px;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n  }\n  .popupBtn{\n      width: 100px !important;\n      border-radius: 15px;\n      height: 30px;\n      color: white;\n      border: none;\n      background: #244b8c;\n  }\n  .popupIcon{\n    height: 100px;\n    width: 100px;\n    margin-top: 50px;\n    /* margin-bottom: 20px; */\n  }\n  .f-w-100{\n    font-weight: 100;\n  }\n  .popupNote{\n    margin: 20px;\n    width: 390px;\n    line-height: 26px;\n    font-size: 16px;\n    display: flex;\n    justify-content: center;\n    font-family: \"Open Sans\", sans-serif;\n    color: rgb(68 68 68);\n    align-items: center;\n    text-align: center;\n    flex-direction: column;\n  }</style>");
$templateCache.put("app/new-investors/folio-details/folio-basic-minor/folio-basic-minor.html","<div class=minorFormdata><div><form autocomplete=off ng-if=!FolioBasicMinorDetails.showPopUp name=minorBasicForm ng-submit=FolioBasicMinorDetails.submitMinorBsicDetails() novalidate><div class=row><div class=\"col-xs-12 col-md-6\"><p class=titleFatca>Create Folio For</p><div class=\"row btn-ss\" style=\"margin-left: 2px\"><p ng-click=\"FolioBasicMinorDetails.chooseFolioFor(\'Self\')\" ng-attr-class=\"{{folioBasicMinorDetail.folioForUser == \'Self\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">Self</span></p><p ng-click=\"FolioBasicMinorDetails.chooseFolioFor(\'Minor\')\" ng-attr-class=\"{{folioBasicMinorDetail.folioForUser == \'Minor\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">Minor</span></p></div></div></div><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Minor\'s Name</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=minorsname type=text n name=minorsname ng-model=FolioBasicMinorDetails.minorFormData.minorsFullName ng-pattern=\"/^[a-zA-Z ]+$/\" style=\"width: 336px\" autofocus required> <span ng-show=\"minorBasicForm.minorsname.$dirty && minorBasicForm.minorsname.$invalid\"><span class=error-input ng-show=minorBasicForm.minorsname.$error.required ng-bind=FolioBasicMinorDetails.validateData.MINOR_NAME></span> <span class=error-input ng-show=minorBasicForm.minorsname.$error.pattern>Number not allowed in minor name!</span></span></div></div><div class=\"dobrow row\"><div class=\"minordob col-xs-12 col-md-5\"><div class=dob-input-container><label class=titleFatca for=dobId style=\"margin-bottom: -10px\">Date of Birth</label><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{FolioBasicMinorDetails.viewMode}} data-date-default=FolioBasicMinorDetails.minorFormData.dob data-on-date-change=FolioBasicMinorDetails.getMinordob maxdate=now format=DD-MMM-YYYY id=endDate style=\"margin-bottom: -5px;z-index: 999;width: 336px\"><input class=newinvestor-dob id=dobId name=dob type=text autocomplete=off placeholder=dd-mm-yyyy ng-keyup=FolioBasicMinorDetails.autoDate() required easyassist-key=mask-element> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png style=\"top: -8px\"> </span><span class=error-input ng-if=FolioBasicMinorDetails.dateErrorMessage ng-bind=FolioBasicMinorDetails.dateErrorMessage></span> <span class=error-input ng-if=FolioBasicMinorDetails.MINOR_DOB_ERROR>Applicant\'s age should be leass than 18 years</span></div></div></div><!-- <div class=\"col-xs-12 col-md-5 hidden-xs\">\n          <div class=\"warning\">\n            <img src=\"../../../assets/images/icons/light-bulb.png\">\n            <div>Applicant\'s age should be 18 years or above</div>\n          </div>\n        </div> --></div><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Minor\'s Gender</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=gender name=gender ng-model=FolioBasicMinorDetails.minorFormData.gender required style=\"height: 40px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"gData in FolioBasicMinorDetails.genderObj\" ng-selected=\"FolioBasicMinorDetails.minorFormData.gender == gData.value\" value={{gData.value}}>{{gData.name}}</option></select><span ng-show=\"minorBasicForm.gender.$dirty && !FolioBasicMinorDetails.minorFormData.gender\"><span class=error-input ng-show=minorBasicForm.gender.$error.required ng-bind=FolioBasicMinorDetails.validateData.GENDER_REQUIRED></span></span></div></div><div class=row><div class=\"col-xs-12 col-md-8\" style=\"display: flex;justify-content: flex-start;flex-direction: row;margin-bottom: 2px;align-items: center\"><p class=titleFatca>Minor\'s Age Proof</p><i class=\"blue-info-icon base-tooltip\" data-bs-html=true data-bs-toggle=tooltip tooltip=\"\" data-bs-placement=right style=\"display: inline-flex\" data-bs-original-title=\"<u style=\'font-size:14px;font-weight:bold\'>View List of Valid DOB Proof</u></br>Below is the list of Valid DOB Proof</br>\n            <ul style=\'color:black\'><li>Birth certificate</li><li>School leaving certificate/ Mark sheet issued by Higher Secondary Board of respective states, ICSE, CBSE etc.</li>\n            <li>Passport</li><li>Any other suitable proof evidencing the date of birth of the minor</li></ul>Max File size should be less than or equal to 2 MB.\n              File format should be tif, tiff, jpg and jpeg extension.\"></i></div></div><div class=row style=\"width: 100%\"><!-- <div class=\"col-xs-12 col-sm-12 col-md-12\"> --><!-- <div class=\" row\" style=\"width: 100%;\"> --><div class=\"col-xs-12 col-sm-12 col-md-7\"><select class=selectNormal id=minorsageproof name=minorsageproof ng-model=FolioBasicMinorDetails.minorFormData.ageproofType required style=\"height: 40px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"value in FolioBasicMinorDetails.minorAgeProofType\" ng-selected=\"FolioBasicMinorDetails.minorFormData.ageproofType == value.proofTypeDesc\" value={{value.proofTypeDesc}}>{{value.proofTypeDesc}}</option></select><span ng-show=\"minorBasicForm.minorsageproof.$dirty && !FolioBasicMinorDetails.minorFormData.ageproofType\"><span class=error-input ng-show=minorBasicForm.minorsageproof.$error.required>Minors ageproof required!</span></span></div><div class=\"col-xs-12 col-sm-12 col-md-5\" ng-if=FolioBasicMinorDetails.minorFormData.ageproofimageName><p style=\"color: blue;font-size: 9px\">{{FolioBasicMinorDetails.minorFormData.ageproofimageName}}</p></div><div class=\"col-xs-12 col-sm-12 col-md-5\"><label for=minorageproofimage style=\"text-align: right;\n              padding: 10px;\n              padding-left: 41px;\n              background-color: lightgray;\n              border-radius: 25px;\n              background-size: 30px;\n              cursor: pointer;\n              background-position-x: 5px;\n              background-position-y: 3px;\n              background-repeat: no-repeat;\n              background-image: url(../../../../assets/images/new-investor/uploadIcon.png)\">upload proof</label><input type=file name=minorageproofimage id=minorageproofimage accept=image/tiff,image/tif,image/jpeg,image/jpg file-model-profile=\"Preview Uploaded Doc\" ng-model=FolioBasicMinorDetails.minorFormData.ageproofimageurl upload=FolioBasicMinorDetails.getMinorAgeProofImage(file) style=\"display: none;visibility: none\" required></div><!-- </div> --><!-- </div> --></div><div class=row><div class=\"col-xs-12 col-md-5\"><p class=titleFatca>Tax Status</p><select class=selectNormal id=taxstatus name=taxstatus ng-model=FolioBasicMinorDetails.minorFormData.taxstatus required style=\"height: 40px;width: 336px\" ng-disabled=FolioBasicMinorDetails.taxStatusResident><option value selected>Select</option><option ng-repeat=\"value in FolioBasicMinorDetails.taxStatus\" ng-selected=\"FolioBasicMinorDetails.minorFormData.taxstatus == value.taxStatusCode\" value={{value.taxStatusCode}} selected>{{value.taxStatusDescription}}</option></select><span ng-show=\"minorBasicForm.taxstatus.$dirty && !FolioBasicMinorDetails.minorFormData.taxstatus\"><span class=error-input ng-show=minorBasicForm.taxstatus.$error.required ng-bind=FolioBasicMinorDetails.validateData.TAX_STATUS></span></span></div></div><br><div><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit ng-disabled=\"minorBasicForm.minorsname.$error.required ||\n           minorBasicForm.minorsname.$error.pattern ||\n           FolioBasicMinorDetails.MINOR_DOB_ERROR ||\n          !FolioBasicMinorDetails.minorFormData.dob ||\n          !FolioBasicMinorDetails.minorFormData.gender ||\n          !FolioBasicMinorDetails.minorFormData.ageproofType ||\n          !FolioBasicMinorDetails.minorFormData.taxstatus ||\n          !FolioBasicMinorDetails.minorFormData.ageproofimageName\">CONTINUE</button></div></form></div><div class=popup ng-if=FolioBasicMinorDetails.showPopUp><div class=popupIcon><img src=../../../../assets/images/note-icon.svg></div><div class=popupNote><p style=\"font-weight: bold\">Please note:</p><p class=f-w-100>You have unsaved changes which will lead to</p><p class=f-w-100>loss of information provided.</p><p class=f-w-100>Are you sure you want to proceed?</p></div><div class=btnDiv><button class=popupBtn type=button ng-click=FolioBasicMinorDetails.stayWithMinor()>No</button> <button class=popupBtn type=button ng-click=FolioBasicMinorDetails.gotoSelf()>Yes</button></div></div></div><style>.titleFatca{\n    margin: 5px 0px 5px 0px;\n  }\n  .popup{\n      border-radius: 20px;\n      background: rgb(255 255 255);\n      box-shadow: 0px 2px 14px rgb(18 66 101 / 30%);\n      color: black;\n      width: 60vw;\n      border-radius: 13px;\n      z-index: 999;\n      position: relative;\n      top: -80px;\n      left: 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;flex-direction: column;\n    }\n    .btnDiv{\n      width: 50%;\n      padding: 30px;\n      display: flex;\n      justify-content: space-evenly;\n      align-items: center;\n    }\n    .popupBtn{\n      width: 100px !important;\n        border-radius: 15px;\n        height: 30px;\n        color: white;\n        border: none;\n        background: #244b8c;\n    }\n    .popupIcon{\n      height: 100px;\n      width: 100px;\n      margin-top: 50px;\n      /* margin-bottom: 20px; */\n    }\n    .f-w-100{\n      font-weight: 100;\n    }\n    .popupNote{\n      margin: 20px;\n      width: 390px;\n      line-height: 26px;\n      font-size: 16px;\n      display: flex;\n      justify-content: center;\n      font-family: \"Open Sans\", sans-serif;\n      color: rgb(68 68 68);\n      align-items: center;\n      text-align: center;\n      flex-direction: column;\n    }\n\n  @media screen and (max-width: 860px) {\n    .minorageproofdiv{\n    margin-left: -15px;\n  }\n  .btnDiv{\n    width: 80%;\n  }\n  .popup{\n    width: 90vw;\n    margin-top: -10px;\n    left: -15px;\n  }\n  .popupNote{\n    width: 100%;\n  }\n  }\n  @media screen and (max-width: 767px) {\n    .popup{\n      width: 90vw;\n      margin-top: -70px;\n    }\n  }</style>");
$templateCache.put("app/new-investors/folio-details/folio-basic-minor-guardian/folio-basic-minor-guardian.html","<div><form autocomplete=off name=minorFormGuardian ng-submit=FolioMinorGuardianDetails.submitMinorGuardianDetails() novalidate><!-- Relation --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Guardian\'s Relationship</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=minorGuardianRelationship name=minorGuardianRelationship ng-model=FolioMinorGuardianDetails.minorFormGuardianData.relation required style=\"width: 336px;height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"x in FolioMinorGuardianDetails.relationshipList\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.relation == x.value\" value={{x.value}}>{{x.name}}</option></select><span ng-show=\"minorFormGuardian.minorGuardianRelationship.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.relation\"><span class=error-input ng-show=minorFormGuardian.minorGuardianRelationship.$error.required>Relationship is required</span></span></div></div><br><!-- Relation proof --><div class=row><div class=\"col-xs-12 col-md-8\" style=\"display: flex;justify-content: flex-start;flex-direction: row;margin-bottom: 2px;text-align: center;align-items: center\"><p class=titleFatca>Guardian Relationship Proof</p><i class=\"blue-info-icon base-tooltip\" tooltip data-bs-html=true data-bs-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"<u style=\'font-size:14px;font-weight:bold\'>View List of Relationship Proof</u></br>\n                        In case of a natural parent, documents evidencing the relationship of the natural parent with the minor,\n                        if the same is not available as part of the documents mentioned above, should be submitted. In case of court appointed legal guardian, supporting documentary evidence (notarized court order) should be provided.\n                        </br>Max file size should be less than or equal to 2 MB. </br>File format should be tif, tiff, jpg and jpeg extension.\"></i></div><!-- <div class=\"col-xs-12 col-md-12\" style=\"display: flex;justify-content: flex-start;flex-direction: row;\"> --><!-- <div class=\"minorageproofdiv row\" style=\"width: 100%;\"> --><div class=\"col-xs-12 col-sm-12 col-md-7\"><select class=selectNormal id=minorRelationshipType name=minorRelationshipType ng-model=FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofType required style=\"width: 336px;height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"value in FolioMinorGuardianDetails.relationProofType\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofType == value.proofTypeDesc\" value={{value.proofTypeDesc}}>{{value.proofTypeDesc}}</option></select><span ng-show=\"minorFormGuardian.minorRelationshipType.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofType\"><span class=error-input ng-show=minorFormGuardian.minorRelationshipType.$error.required>Minors Relationship proof required!</span></span></div><div class=\"col-xs-12 col-sm-12 col-md-5\" ng-if=FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofimagename><p style=\"color: blue;font-size: 9px\">{{FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofimagename}}</p></div><div class=\"col-xs-12 col-sm-12 col-md-5\"><label for=guardianrelationproofimage style=\"text-align: right;\n            padding: 10px;\n            padding-left: 41px;\n            background-color: lightgray;\n            border-radius: 25px;\n            background-size: 30px;\n            cursor: pointer;\n            background-position-x: 5px;\n            background-position-y: 3px;\n            background-repeat: no-repeat;\n            background-image: url(../../../../assets/images/new-investor/uploadIcon.png)\">upload proof</label><input type=file name=guardianrelationproofimage id=guardianrelationproofimage accept=\"image/jpeg, image/jpg, image/tif, image/tiff\" file-model-profile=\"Preview Uploaded Doc\" ng-model=FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofimageurl upload=FolioMinorGuardianDetails.getGuardianRelationProofImage(file) style=\"display: none;visibility: none\" required><!-- onchange=\"angular.element(this).scope().FolioMinorGuardianDetails.getGuardianRelationProofImage(this.files)\" --></div><!-- </div> --><!-- </div> --></div><br><!--  Occupation--><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Occupation</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=occupation name=occupation ng-model=FolioMinorGuardianDetails.minorFormGuardianData.occupation required style=\"width: 336px;height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.investorOccupations\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.occupation == value.occupationCode\" value={{value.occupationCode}}>{{value.occupationDescription}}</option></select><span ng-show=\"minorFormGuardian.occupation.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.occupation\"><span class=error-input ng-show=minorFormGuardian.occupation.$error.required ng-bind=FolioMinorGuardianDetails.validateData.OCCUPATION></span></span></div></div><br><!-- Income --><div class=row><div class=\"col-xs-12 col-md-5\" style=\"margin-bottom: 5px\"><div style=\"display: flex;justify-content: flex-start;flex-direction: row\"><p class=grossanualincome>Gross Annual Income</p><input type=checkbox id=switch style=\"margin-right: 10px\" ng-click=FolioMinorGuardianDetails.networthcall() ng-checked=FolioMinorGuardianDetails.networth><label class=switchlableG for=switch ng-checked=FolioMinorGuardianDetails.networth style=\"margin-right: 10px\">Toggle</label><span style=\"font-weight: 600\">Net Worth</span></div></div></div><div class=row><div class=\"col-xs-12 col-md-5\" ng-if=!FolioMinorGuardianDetails.networth><select class=selectNormal id=guardianAnnualincome name=guardianAnnualincome ng-model=FolioMinorGuardianDetails.minorFormGuardianData.grossAnnualIncome style=\"margin-left: 0px;width: 336px;height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.incomeSlabList\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.grossAnnualIncome == value.incomeCode\" value={{value.incomeCode}}>{{value.incomeDescription}}</option></select><span ng-show=\"minorFormGuardian.guardianAnnualincome.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.grossAnnualIncome\"><span class=error-input ng-show=minorFormGuardian.guardianAnnualincome.$error.required ng-bind=FolioMinorGuardianDetails.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-5\" ng-if=FolioMinorGuardianDetails.networth><input type=number class=\"form-control inputNormal\" id=annualincome1 name=annualincome1 ng-model=FolioMinorGuardianDetails.minorFormGuardianData.networth required easyassist-key=mask-element> <span ng-show=\"minorFormGuardian.annualincome1.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.networth\"><span class=error-input ng-show=minorFormGuardian.annualincome1.$error.required ng-bind=FolioMinorGuardianDetails.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-4\" ng-if=FolioMinorGuardianDetails.networth style=\"margin-top: -11px\"><div style=\"position: relative\"><div class=dob-input-container style=\"height: 50px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{FolioMinorGuardianDetails.viewMode}} data-date-default=FolioMinorGuardianDetails.minorFormGuardianData.grossAnnualIncomeDate data-on-date-change=FolioMinorGuardianDetails.grossAnnualIncomeDate maxdate=now format=DD-MM-YYYY id=endDate style=\"width: 336px\"><input class=newinvestor-dob tabindex=2 id=grossAnnualIncomeDateId name=grossAnnualIncomeDate type=text autocomplete=off placeholder=dd-mm-yyyy ng-keyup=FolioMinorGuardianDetails.autoDate() required easyassist-key=mask-element> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png style=\"top: -8px\"> </span><span>(Not older than 1 year)</span><br><span class=error-input ng-if=FolioMinorGuardianDetails.dateErrorMessage ng-bind=FolioMinorGuardianDetails.dateErrorMessage></span></div></div></div></div></div><br><!-- FATAC --><div class=row style=\"margin-left: 2px;\n    display: flex;justify-content: flex-start;flex-direction: row;align-items: center;text-align: center\"><p class=titleFatca>FATCA & CRS related question.</p><i class=\"blue-info-icon base-tooltip\" tooltip data-bs-html=true data-bs-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"The below information is required for all applicants(s) / guardians. Is also applicant(s) / guardian’s country of birth / citizenship / Nationality / TAX residency other than India?\"></i></div><!-- Countri --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=fatcacountry name=fatcacountry ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.Countrie required style=\"width: 336px;height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.countries\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.Fatca.Countrie == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select><span ng-show=\"minorFormGuardian.fatcacountry.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.Countrie\"><span class=error-input ng-show=minorFormGuardian.fatcacountry.$error.required ng-bind=FolioMinorGuardianDetails.validateData.SELECT_COUNTRY></span></span></div></div><br><!-- address type --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Address type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=addressType name=addressType ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.addressType required style=\"width: 336px;height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"x in FolioDetails.addressType\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.Fatca.addressType == x.value\" value={{x.value}}>{{x.addressDescription}}</option></select><span ng-show=\"minorFormGuardian.addressType.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.addressType\"><span class=error-input ng-show=minorFormGuardian.addressType.$error.required ng-bind=FolioMinorGuardianDetails.validateData.FATCA_ADDRESS_TYPE_REQUIRED></span></span></div></div><br><!-- city --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=fatcaTaxpayingCity type=text name=fatcaTaxpayingCity ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.City ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 336px\" easyassist-key=mask-element> <span ng-show=\"minorFormGuardian.fatcaTaxpayingCity.$dirty && minorFormGuardian.fatcaTaxpayingCity.$invalid\"><span class=error-input ng-show=minorFormGuardian.fatcaTaxpayingCity.$error.required ng-bind=FolioMinorGuardianDetails.validateData.CITY></span> <span class=error-input ng-show=minorFormGuardian.fatcaTaxpayingCity.$error.pattern>Number not allowed in minor name!</span></span></div></div><br><!-- do you pay or file tax. --><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1>Do you pay or file tax in a country other than India?</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=\"row btn-l\"><div class=\"col-xs-12 col-md-5 btn-l\" style=\"padding: 0px 0px 0px 0px;margin-left: 2px\"><p ng-attr-class=\"{{FolioMinorGuardianDetails.minorFormGuardianData.fileTaxOtherIndian == \'Yes\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioMinorGuardianDetails.getTaxFileStatusForGuardian(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{FolioMinorGuardianDetails.minorFormGuardianData.fileTaxOtherIndian == \'No\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioMinorGuardianDetails.getTaxFileStatusForGuardian(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div></div><br><!-- FATCA1 --><div ng-if=!FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPayIndian><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=country name=country ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry required style=\"width: 336px;height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.countries\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select><span ng-show=\"minorFormGuardian.country.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry\"><span class=error-input ng-show=minorFormGuardian.country.$error.required ng-bind=FolioMinorGuardianDetails.validateData.SELECT_COUNTRY></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID Type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxIdType name=taxIdType ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxIdType required style=\"width: 336px;height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.taxIdType\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxIdType == value.value\" value={{value.value}}>{{value.description}}</option></select><span ng-show=\"minorFormGuardian.taxIdType.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxIdType\"><span class=error-input ng-show=minorFormGuardian.taxIdType.$error.required ng-bind=FolioMinorGuardianDetails.validateData.TAX_ID_TYPE></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxpayingCity type=text name=taxpayingCity ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxPayingCity ng-pattern=\"/^[a-zA-Z ]+$/\" autofocus required style=\"width: 336px\" easyassist-key=mask-element> <span ng-show=\"minorFormGuardian.taxpayingCity.$dirty && minorFormGuardian.taxpayingCity.$invalid\"><span class=error-input ng-show=minorFormGuardian.taxpayingCity.$error.required ng-bind=FolioMinorGuardianDetails.validateData.CITY></span> <span class=error-input ng-show=minorFormGuardian.taxpayingCity.$error.pattern>Number not allowed in minor name!</span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxId type=text name=taxId ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxId ng-maxlength=20 limit-to=20 maxlength=20 required style=\"width: 336px\" easyassist-key=mask-element> <span ng-show=\"minorFormGuardian.taxId.$dirty && minorFormGuardian.taxId.$invalid\"><span class=error-input ng-show=minorFormGuardian.taxId.$error.required ng-bind=FolioMinorGuardianDetails.validateData.TAX_ID_NUMBER></span></span></div></div></div><!-- Political status --><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1>Politicaly Exposed Person(PEP) status</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=\"row btn-l\"><div class=\"col-xs-12 col-md-5 btn-l\" style=\"padding: 0px 0px 0px 0px;margin-left: 2px\"><p ng-attr-class=\"{{FolioMinorGuardianDetails.minorFormGuardianData.userPEPStatusForGuardian == \'Yes\' ? \'btn-active1 col-xs-6 first-btn  col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioMinorGuardianDetails.getPEPStatusForGuardian(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{FolioMinorGuardianDetails.minorFormGuardianData.userPEPStatusForGuardian == \'No\' ? \'btn-active1 col-xs-6 last-btn  col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioMinorGuardianDetails.getPEPStatusForGuardian(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div></div><br><br><p class=error>{{FolioMinorGuardianDetails.errorMsg}}</p><!-- SUBMIT --><div><button ng-if=\"FolioMinorGuardianDetails.minorFormGuardianData.fileTaxOtherIndian == \'No\'\" class=\"btn btn-primary-action-pay\" type=submit ng-disabled=\"minorFormGuardian.$error.required || FolioMinorGuardianDetails.notolderthan1year\">CONTINUE</button><!-- ng-disabled=\"minorFormGuardian.minorGuardianRelationship.$error.required ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.relation ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofType ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofimagename ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.occupation ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.Countrie ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.addressType ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.City\n        \" --> <button ng-if=\"FolioMinorGuardianDetails.minorFormGuardianData.fileTaxOtherIndian == \'Yes\'\" class=\"btn btn-primary-action-pay\" type=submit ng-disabled=\"minorFormGuardian.$error.required || FolioMinorGuardianDetails.notolderthan1year\">CONTINUE</button><!-- ng-disabled=\"minorFormGuardian.minorGuardianRelationship.$error.required ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.relation ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofType ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofimagename ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.occupation ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.Countrie ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.addressType ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.City  ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxIdType ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxPayingCity ||\n        !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxId\n        \" --></div></form></div><style>.switchlableG{\n      margin-right: 10px;\n      width: 29px;\n      height: 16px;\n      background: #5CEB57 0% 0% no-repeat padding-box;\n      border-radius: 37px;\n      opacity: 1;\n      cursor: pointer;\n      text-indent: -9999px;\n      display: block;\n      position: relative;\n  }\n  @media only screen and (max-width: 1000px ){\n  .btn-primary-action-pay {\n    width: 150px !important;\n  }\n}\n  .btn-primary-action-pay {\n         width: 163px;\n         height: 35px;\n         border-color: transparent;\n         background-color: #FF8486;\n        border-radius: 50px !important;\n          line-height: 1.4 !important;\n           color: #ffffff;\n        padding: 6px 25px !important;\n        padding: 10px 10px 10px 10px;\n    border-radius: 45px;\n    margin-left: 5px;\n     }\n  .switchlableG:after {\n    content: \"\";\n    position: absolute;\n    top: 3px;\n    left: 5px;\n    width: 10px;\n    height: 10px;\n    background: #fff;\n    border-radius: 50px;\n  }\n\n  input:checked+.switchlableG {\n    background: #5ceb57;\n  }\n\n  input:checked+.switchlableG:after {\n    left: calc(100% - 5px);\n    transform: translateX(-100%);\n  }\n\n  .switchlableG:active:after {\n    width: 15px;\n  }\n\n\n  @media only screen and (max-width: 375px) {\n    .minorageproofdiv {\n      margin-left: -15px;\n    }\n\n}</style>");
$templateCache.put("app/new-investors/folio-details/folio-holder-details/folio-holder-details.html","<div class=holderdetails style=\"position: relative\"><!-- step 1 --><div class=panverify ng-if=addholder.steps[0].isactive><form class=verification-form autocomplete=off name=holderPanVerificationForm ng-submit=FolioJointHolderDetails.verifyOrAddHolder2() novalidate><!-- PAN input --><div class=row><div class=\"col-xs-12 col-md-12\"><div class=tax-input-container><label>Tax Status</label><div class=tax-field-container><div style=\"display: flex;justify-content: flex-start\"><input class=nomineeCheckbox type=radio id=resident-tax-status name=tax-status ng-value=true ng-model=FolioJointHolderDetails.holderData.taxStatusResident ng-change=FolioJointHolderDetails.changedRiNriTaxStatus()><label for=resident-tax-status class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\">{{FolioJointHolderDetails.appConstants.TAX_STATUS_INDIVIDUAL.RESIDENT_INDIVIDUAL}}</label></div><div style=\"display: flex;justify-content: flex-start\"><input class=nomineeCheckbox type=radio id=tax-status name=tax-status ng-value=false ng-model=FolioJointHolderDetails.holderData.taxStatusResident ng-change=FolioJointHolderDetails.changedRiNriTaxStatus()><label for=tax-status class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\">{{FolioJointHolderDetails.appConstants.TAX_STATUS_INDIVIDUAL.NON_RESIDENT_INDIVIDUAL}}</label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-5\"><div class=pan-input-container><label for=pan>PAN</label><input class=form-control id=pan tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=FolioJointHolderDetails.holderData.pan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-change=FolioJointHolderDetails.resetValues() ng-blur=FolioJointHolderDetails.checkPanEmailExist() capitalize required easyassist-key=mask-element style=\"background: #FFFFFF 0% 0% no-repeat padding-box;\n            border: 1px solid #B8C6D1;\n            border-radius: 5px;\n            height: 40px;\n            opacity: 1\"><br><span ng-show=\"holderPanVerificationForm.pan.$dirty && holderPanVerificationForm.pan.$invalid\"><span class=error-input ng-show=holderPanVerificationForm.pan.$error.required ng-bind=FolioJointHolderDetails.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=holderPanVerificationForm.pan.$error.maxlength ng-bind=FolioJointHolderDetails.validateData.PAN_FIELD></span> <span class=error-input ng-show=holderPanVerificationForm.pan.$error.pattern ng-bind=FolioJointHolderDetails.validateData.PAN_FIELD></span> </span><span class=error-input ng-if=FolioJointHolderDetails.panMessage ng-bind-html=FolioJointHolderDetails.panMessage></span></div></div><div class=\"col-xs-12 col-md-5\"><!-- <p style=\"color: red;font-weight: bold;\">{{FolioJointHolderDetails.wrongMsg}}</p> --></div></div><br><!-- Eamil Add --><div ng-if=FolioJointHolderDetails.showEmail class=\"input-select input-normal\"><div class=row><div class=\"col-xs-12 col-md-8\"><p>Email</p></div><div class=\"col-xs-12 col-md-5\"><div style=\"display: flex;align-items: center\"><input class=\"form-control inputNormal\" type=email name=email ng-model=FolioJointHolderDetails.holderData.email required></div><span ng-if=!FolioJointHolderDetails.holderData.email style=\"color: red\">Email filed required!</span></div><div class=\"col-xs-12 col-md-5\"><button type=button class=btn-holder ng-disabled=!FolioJointHolderDetails.holderData.email ng-click=FolioJointHolderDetails.AddEmailToHolderPan()>Add Email</button></div></div></div><!-- OTP --><div ng-if=FolioJointHolderDetails.showOtp><div><div class=row><div class=\"col-xs-12 col-md-8\"><p>Verify OTP</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" type=text minlength=6 maxlength=6 name=otp ng-model=FolioJointHolderDetails.Otp required></div><div class=\"col-xs-12 col-md-2\"><button type=button class=btn-holder ng-click=FolioJointHolderDetails.verifyOtp() ng-disabled=!FolioJointHolderDetails.Otp>Verify</button></div><div class=\"col-xs-12 col-md-3\"><button type=button class=btn-holder ng-click=FolioJointHolderDetails.reGenerateOtp()>Resend OTP</button></div></div></div></div><br><!-- Verify Button --><div class=kyc-verify><button tabindex=3 type=submit class=\"btn hdfc-blue-cta-small btn-primary-action-pay\" ng-disabled=\"holderPanVerificationForm.pan.$invalid ||\n            !FolioJointHolderDetails.processFlag ||\n            !FolioJointHolderDetails.AllowedJointHolder\">VERIFY</button></div></form></div><!-- Step 2 --><div ng-if=addholder.steps[1].isactive><div ng-if=FolioJointHolderDetails.holders[0].pan><div ng-repeat=\"x in FolioJointHolderDetails.holders track by $index\"><p ng-if=\"vm.holderLength == 1\" style=\"font-weight: bold;margin-top: 15px;margin-bottom: 15px;border-left: 3px;border-left:3px solid darkblue\">&nbsp; Second Holder</p><p ng-if=\"vm.holderLength == 2\" style=\"font-weight: bold;margin-top: 15px;margin-bottom: 15px;border-left: 3px;border-left:3px solid darkblue\">&nbsp; Third Holder</p><div style=\"display: flex;justify-content: flex-start;flex-direction: row;width: 60%;margin-bottom: 30px\"><div><p style=\"margin-top: 10px;margin-bottom: 10px;font-weight: bold\">Name</p><input class=\"form-control inputNormal\" type=text value=\"{{x.jointHolderName ? x.jointHolderName :(x.firstName+\' \'+x.middleName +\' \'+x.lastName)}}\" readonly style=\"background-color: white;width: 95%\"></div><div><p style=\"margin-top: 10px;margin-bottom: 10px;font-weight: bold\">PAN</p><input class=\"form-control inputNormal\" type=text value={{x.pan}} readonly style=\"background-color: white;width: 95%\" easyassist-key=mask-element></div><div><p style=\"margin-top: 10px;margin-bottom: 10px;font-weight: bold\">Email</p><input class=\"form-control inputNormal\" type=text value={{x.email}} readonly style=\"background-color: white;width: 95%\" easyassist-key=mask-element></div><div><p style=\"margin-top: 10px;margin-bottom: 10px;font-weight: bold\">Mobile</p><input class=\"form-control inputNormal\" type=text value={{x.mobileNumber}} readonly style=\"background-color: white;width: 95%\" easyassist-key=mask-element></div><div style=\"display: flex;justify-content: flex-start;align-items: center;cursor: pointer;\n            margin-top: 30px;\n            margin-left: 10px\" ng-click=FolioJointHolderDetails.deleteHolder($index)><img src=../../../../../assets/images/icons/delete-red.png alt=\"\" srcset=\"\"></div></div><div ng-if=\"!x.mobileNumber && !x.email\" style=\"margin-bottom: 10px\"><p class=update-contact-warning style=color:red>To proceed with Folio creation contact details of investor are mandatory. Kindly get in touch with our ISC or CAMS to update CKYC.</p></div></div><div><button ng-if=FolioJointHolderDetails.stopaddholder class=\"btn addAnotherButton\" ng-click=FolioJointHolderDetails.addthirdholderinfolio()>ADD ANOTHER HOLDER</button> <button class=\"btn hdfc-blue-cta-small btn-primary-action-pay\" ng-click=FolioJointHolderDetails.holdernext() ng-disabled=FolioJointHolderDetails.notValid2ndHolder>CONTINUE</button></div></div></div><!-- Step 3 --><div class=holderform3 ng-if=addholder.steps[2].isactive><div class=row><div class=\"nomineetab col-sm-4 col-md-4\"><p ng-attr-class=\"{{ FolioJointHolderDetails.holderTab == 0 ? \'nomineecount border-b-3\' : \'nomineecount\'}}\" ng-click=FolioJointHolderDetails.getholdersdata(0)>Second Holder</p><span style=\"cursor: pointer; margin-right: 15px\" ng-click=FolioJointHolderDetails.deleteHolder(0)><img src=../../../../../assets/images/icons/delete-red.png alt=\"\" srcset=\"\"></span><p ng-if=\"FolioJointHolderDetails.holderCount == 2\" ng-attr-class=\"{{ FolioJointHolderDetails.holderTab == 1 ? \'nomineecount border-b-3\' : \'nomineecount\'}}\" ng-click=FolioJointHolderDetails.getholdersdata(1)>Third holder</p><span style=\"cursor: pointer; margin-right: 15px\" ng-click=FolioJointHolderDetails.deleteHolder(1) ng-if=\"FolioJointHolderDetails.holderCount == 2\"><img src=../../../../../assets/images/icons/delete-red.png alt=\"\" srcset=\"\"></span></div></div><div style=\"width: 400px;background-color: white;border-radius: 5px;padding: 11px;margin-top: 25px\"><p>Name :&nbsp;<span style=\"font-weight: bold\">{{FolioJointHolderDetails.jointHolderDetails.jointHolderName}}</span></p><br><p>PAN :&nbsp; <span style=\"font-weight: bold\" easyassist-key=mask-element>{{FolioJointHolderDetails.jointHolderDetails.pan}}</span></p><br><p>Email :&nbsp; <span style=\"font-weight: bold\" easyassist-key=mask-element>{{FolioJointHolderDetails.jointHolderDetails.email?FolioJointHolderDetails.jointHolderDetails.email:\"Not Available\"}}</span></p><br><p>Mobile :&nbsp; <span style=\"font-weight: bold\" easyassist-key=mask-element>{{FolioJointHolderDetails.jointHolderDetails.mobileNumber?FolioJointHolderDetails.jointHolderDetails.mobileNumber:\"Not Available\"}}</span></p></div><br><!-- address --><form id=jointHolderForm name=jointHolderForm ng-submit=FolioJointHolderDetails.submithHolderIncomeDetails(FolioJointHolderDetails.holderTab)><div ng-if=FolioJointHolderDetails.showSameHOlderDetail style=\"width: 50%;padding: 5px; display: flex;justify-content: flex-start;flex-direction: row;align-items: center\"><p class=\"inputquestion titleFatca\">Applicant Details</p>&nbsp; <input class=nomineeCheckbox type=checkbox name=address id=address><!-- ng-model=\"FolioJointHolderDetails.sameFirstHoderDetails\" --><label class=confirmationnote ng-click=FolioJointHolderDetails.addFirstHolderData() for=address style=\"margin-left: 10px;font-size: 14px\">Same as first holder</label></div><!-- tax status --><div class=\"row tax-status-row\"><div class=\"col-xs-12 col-sm-8 col-md-8\"><p class=titleFatca>Tax Status<span class=\"req text-red\">*</span></p></div><br><div class=\"col-xs-12 col-md-5\"><div><select class=selectNormal id=taxstatus name=taxstatus ng-model=FolioJointHolderDetails.jointHolderDetails.taxStatusCode ng-disabled=!FolioJointHolderDetails.jointHolderDetails.nriFlag ng-change=\"FolioJointHolderDetails.taxStatusChanged(FolioJointHolderDetails.jointHolderDetails.taxStatusCode, FolioJointHolderDetails.holderTab)\" style=\"height: 40px\" required><option value selected>Select</option><option ng-repeat=\"value in FolioJointHolderDetails.taxStatusData\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.taxStatusCode == value.taxStatusCode\" value={{value.taxStatusCode}}>{{value.taxStatusDescription}}</option></select></div><span ng-show=\"jointHolderForm.taxstatus.$dirty && !FolioJointHolderDetails.jointHolderDetails.taxstatus\"><span class=error-input ng-show=jointHolderForm.taxstatus.$error.required ng-bind=FolioJointHolderDetails.validateData.TAX_STATUS></span></span></div><div class=\"note-banner col-xs-12 col-md-7 noterelativepostion tax-status-ackn\" ng-if=FolioJointHolderDetails.taxStatusInfoMsg><div class=warning><span class=icon-info-sign></span><div class=wardiv>{{FolioJointHolderDetails.taxStatusInfoMsg}}</div></div></div></div><br><!-- Occupation --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Occupation<span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5 d-flex flex-column\"><select class=selectNormal id=occupation name=occupation ng-model=FolioJointHolderDetails.jointHolderDetails.occupationCode style=\"height: 40px\" required><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.investorOccupations\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.occupationCode == value.occupationCode\" value={{value.occupationCode}}>{{value.occupationDescription}}</option></select><span ng-show=\"jointHolderForm.occupation.$dirty && !FolioJointHolderDetails.jointHolderDetails.occupationCode\"><span class=error-input ng-show=jointHolderForm.occupation.$error.required ng-bind=FolioJointHolderDetails.validateData.OCCUPATION></span></span></div></div><br><!-- TOGGLE BUTTON --><div class=row><div class=\"col-xs-12 col-md-5\" style=\"margin-bottom: 5px\"><div style=\"display: flex;justify-content: flex-start;flex-direction: row\"><p class=grossanualincome>Gross Annual Income<span class=\"req text-red\">*</span></p><input type=checkbox id=switch style=\"margin-right: 10px\" ng-click=FolioJointHolderDetails.networthcall() ng-checked=FolioJointHolderDetails.networth><label class=switchlableHolder for=switch ng-checked=FolioJointHolderDetails.networth style=\"margin-right: 10px\"></label><span style=\"font-weight: 600\">Net Worth</span></div></div></div><br><!-- Annual Income --><div class=row><div class=\"col-xs-12 col-md-5 d-flex flex-column\" ng-if=!FolioJointHolderDetails.networth><select class=selectNormal id=annualincome1 name=annualincome1 ng-model=FolioJointHolderDetails.jointHolderDetails.grossAnnualIncome style=\"height: 40px\" easyassist-key=mask-element required><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.incomeSlabList\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.grossAnnualIncome == value.incomeCode\" value={{value.incomeCode}}>{{value.incomeDescription}}</option></select><span ng-show=\"jointHolderForm.annualincome1.$dirty && !FolioJointHolderDetails.jointHolderDetails.gross1\"><span class=error-input ng-show=jointHolderForm.annualincome1.$error.required ng-bind=FolioJointHolderDetails.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-5\" ng-if=FolioJointHolderDetails.networth><input type=\"number inputNormal\" class=form-control id=annualincome1 name=annualincome1 ng-model=FolioJointHolderDetails.jointHolderDetails.netWorth required style=\"height: 40px\" easyassist-key=mask-element> <span ng-show=\"jointHolderForm.annualincome1.$dirty && !FolioJointHolderDetails.jointHolderDetails.netWorth\"><span class=error-input ng-show=jointHolderForm.annualincome1.$error.required ng-bind=FolioJointHolderDetails.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-4\" ng-if=FolioJointHolderDetails.networth style=\"margin-top: -11px\"><div style=\"position: relative\"><div class=dob-input-container style=\"height: 45px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{FolioJointHolderDetails.viewMode}} data-date-default=FolioJointHolderDetails.jointHolderDetails.netWorthDate data-on-date-change=FolioJointHolderDetails.getGrossAnnualIncomeDateOfHolder maxdate=now format=DD-MMM-YYYY id=endDate><input class=newinvestor-dob tabindex=2 id=grossAnnualIncomeDateId name=grossAnnualIncomeDate type=text autocomplete=off ng-keyup=FolioJointHolderDetails.autoDate() placeholder=\"As on dd-mm-yyyy\" required easyassist-key=mask-element> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span>(Not older than 1 year)</span><br><span class=error-input ng-if=FolioJointHolderDetails.dateErrorMessage ng-bind=FolioJointHolderDetails.dateErrorMessage></span></div></div></div></div></div><p class=titleFatca style=\"padding-top: 25px\">FATCA & CRS related question.</p><!-- Country --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Country<span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=country name=country ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.birthCountry style=\"height: 40px\" easyassist-key=mask-element required><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.countries\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.fatcaDetail.birthCountry == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select></div><!-- <div class=\"col-sm-7 col-md-7\">\n            <div class=\"warning\">\n              <img src=\"../../../assets/images/icons/light-bulb.png\" style=\"height: 20%;width: 20%;\">\n              <div class=\"wardiv\">FATCA (Foreign Account tax Compliance Act) & CRS (Common Reporting Standard)\n                declaration was prepared by finacial institutions company with the Central Board of Direct taxes\n                (CBDT) rules.</div>\n            </div>\n          </div> --></div><!-- address type --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Address type<span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=addressType name=addressType ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.addressType style=\"height: 40px\" easyassist-key=mask-element required><option value selected>Select</option><option ng-repeat=\"x in FolioDetails.addressType\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.fatcaDetail.addressType == x.value\" value={{x.value}}>{{x.addressDescription}}</option></select><span ng-show=\"jointHolderDetails.addressType.$dirty && !FolioJointHolderDetails.jointHolderDetails.fatcaDetail.addressType\"><span class=error-input ng-show=jointHolderDetails.addressType.$error.required ng-bind=FolioJointHolderDetails.validateData.FATCA_ADDRESS_TYPE_REQUIRED></span></span></div></div><!-- city --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>City<span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" type=text id=City name=City ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.birthPlace ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 322px\" easyassist-key=mask-element> <span ng-show=\"jointHolderForm.City.$dirty && jointHolderForm.City.$invalid\"><span class=error-input ng-show=jointHolderForm.City.$error.required ng-bind=FolioJointHolderDetails.validateData.CITY></span> <span class=error-input ng-show=jointHolderForm.City.$error.pattern>Number not allowed in minor name!</span></span></div></div><!-- do you pay or file tax. --><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1>Do you pay or file tax in a country other than India?</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=\"row btn-l\"><div class=\"col-xs-12 col-md-5 btn-l\"><p ng-attr-class=\"{{FolioJointHolderDetails.jointHolderTaxDetails_fileTaxOtherIndian == \'Yes\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioJointHolderDetails.getTaxFileStatusForJointHolder(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{FolioJointHolderDetails.jointHolderTaxDetails_fileTaxOtherIndian == \'No\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioJointHolderDetails.getTaxFileStatusForJointHolder(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div></div><br><br><!-- FATCA1 --><div ng-if=!FolioJointHolderDetails.jointHolderDetails.fatcaDetail.payTaxInIndia><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=country name=country ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCountry style=\"height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.countries\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCountry == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select><span ng-show=\"jointHolderForm.country.$dirty && !FolioJointHolderDetails.jointHolderFormData.fatcaDetail.fatcaTax1.taxPayingCountry\"><span class=error-input ng-show=jointHolderForm.country.$error.required ng-bind=FolioJointHolderDetails.validateData.SELECT_COUNTRY></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID Type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxIdType name=taxIdType ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType style=\"height: 40px\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.taxIdType\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType == value.value\" value={{value.value}}>{{value.description}}</option></select><span ng-show=\"jointHolderForm.taxIdType.$dirty && !FolioJointHolderDetails.jointHolderFormData.fatcaDetail.fatcaTax1.taxIdType\"><span class=error-input ng-show=jointHolderForm.taxIdType.$error.required ng-bind=FolioJointHolderDetails.validateData.TAX_ID_TYPE></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxpayCity type=text name=taxpayCity ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCity ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 332px\" easyassist-key=mask-element> <span ng-show=\"jointHolderForm.taxpayCity.$dirty && jointHolderForm.taxpayCity.$invalid\"><span class=error-input ng-show=jointHolderForm.taxpayCity.$error.required ng-bind=FolioJointHolderDetails.validateData.CITY></span> <span class=error-input ng-show=jointHolderForm.taxpayCity.$error.pattern>Number not allowed in name!</span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxId type=text name=taxId ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxId ng-maxlength=20 limit-to=20 maxlength=20 required style=\"width: 332px\" easyassist-key=mask-element> <span ng-show=\"jointHolderForm.taxId.$dirty && jointHolderForm.taxId.$invalid\"><span class=error-input ng-show=jointHolderForm.taxId.$error.required ng-bind=FolioJointHolderDetails.validateData.TAX_ID_NUMBER></span></span></div></div></div><!-- Political status --><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1>Politicaly Exposed Person(PEP) status</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=\"row btn-l\"><div class=\"col-xs-12 col-md-5 btn-l\"><p ng-attr-class=\"{{FolioJointHolderDetails.jointHolderTaxDetails_politicalStatus == \'Yes\' ? \'btn-active1 col-xs-6 first-btn  col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioJointHolderDetails.getPEPStatusForJointHolder(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{FolioJointHolderDetails.jointHolderTaxDetails_politicalStatus == \'No\' ? \'btn-active1 col-xs-6 last-btn  col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioJointHolderDetails.getPEPStatusForJointHolder(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div></div><br><div style=\"display: flex;flex-direction: row\"><button class=\"btn-new-journey-color btn-primary-action-pay hdfc-blue-cta-small\" type=submit ng-if=!FolioJointHolderDetails.nextFlag ng-disabled=\"jointHolderForm.$error.required || FolioJointHolderDetails.notolderthan1year || FolioJointHolderDetails.notValid2ndHolder\">CONTINUE</button> &nbsp;&nbsp;&nbsp;&nbsp;<!-- <button class=\"btn hdfc-blue-cta-small\" ng-If=\"FolioJointHolderDetails.nextFlag\"\n          ng-click=\"FolioJointHolderDetails.submitHolder()\" type=\"button\">NEXT</button> --></div></form></div></div><style>#switch {\n              height: 0;\n              width: 0;\n              visibility: hidden;\n            }\n\n            .switchlableHolder {\n              margin-right: 10px;\n              width: 29px;\n              height: 16px;\n              background: #5CEB57 0% 0% no-repeat padding-box;\n              border-radius: 37px;\n              opacity: 1;\n              cursor: pointer;\n              text-indent: -9999px;\n              display: block;\n              position: relative;\n            }\n\n            .switchlableHolder:after {\n              content: \"\";\n              position: absolute;\n              top: 3px;\n              left: 5px;\n              width: 10px;\n              height: 10px;\n              background: #fff;\n              border-radius: 50px;\n            }\n\n            input:checked+.switchlableHolder {\n              background: #5ceb57;\n            }\n\n            input:checked+.switchlableHolder:after {\n              left: calc(100% - 5px);\n              transform: translateX(-100%);\n            }\n\n            .switchlableHolder:active:after {\n              width: 10px;\n              height: 10px;\n            }\n\n    .thirdholderPopup {\n    /* position: absolute; */\n    top: 25%;\n    left: auto;\n    border-radius: 15px;\n    z-index: 1000;\n    /* width: 500px; */\n    height: auto;\n    background-color: white;\n\n\n  }\n  .thirdholderPopup .body\n      form {\n        text-align: center;\n        align-items: center;\n\n      }\n      .thirdholderPopup .body\n      form  .form-control {\n          border: 1px solid gray;\n        }\n  .thirdholderPopup .head {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      background-color: #eaf5ff;\n      border-top-left-radius: 15px;\n      border-top-right-radius: 15px;\n      height: 42px;\n\n    }\n    .thirdholderPopup .head p {\n        padding: 20px;\n      }\n    .addAnotherButton{\n      background-color: white;\n          border: 1px solid #ff8486;\n          color: #ff8486;\n          width: 300px;\n          border-radius: 25px;\n          margin-right: 20px;\n    }\n    @media screen and (max-width: 850px) {\n\n      .addAnotherButton{\n        width: 300px !important;\n      }\n    }\n    .btn-primary-action-pay {    color: white;\n        border-color: transparent;\n        background-color: #FF8486;\n\n     }\n     .hdfc-blue-cta-small:disabled{\n        background-color: #FF8486;\n        color: white;\n    }\n    @media only screen and (max-width: 1000px ){\n  .btn-primary-action-pay {\n    width: 150px !important;\n  }\n}\n  .hdfc-blue-cta-small:disabled{\n    background-color: #FF8486;\n        color: white;\n}\n  .btn-primary-action-pay {\n         width: 163px;\n         height: 35px;\n         border-color: transparent;\n         background-color: #FF8486;\n        border-radius: 50px !important;\n          line-height: 1.4 !important;\n           color: #ffffff;\n        padding: 6px 25px !important;\n        padding: 10px 10px 10px 10px;\n    border-radius: 45px;\n    margin-left: 5px;\n     }\n\n    a {\n      text-decoration: underline !important;\n      color: #103880;\n    }</style>");
$templateCache.put("app/new-investors/folio-details/folio-income-details/folio-income-details.html","<div class=incomedetails><br><form id=folioIncomeFormData name=folioIncomeFormData ng-submit=FolioIncomeDetails.submitFolioIncomeForm()><div class=form-content style=\"margin-bottom: 20px\"><!--<label><strong>Contact Details (Please submit physical request to update contact details in your\n              KYC)</strong></label>--><div class=\"form-content credentialNote\" ng-if=\"!FolioIncomeDetails.soleApplicantEmail && !FolioIncomeDetails.soleApplicantMobile\"><label>To proceed with Folio creation both contact details of investor are mandatory. Kindly update missing contact detail by getting in touch with our ISC or CAMS to update CKYC.</label></div><div class=\"form-content credentialNote\" ng-if=\"(!FolioIncomeDetails.soleApplicantEmail && FolioIncomeDetails.soleApplicantMobile) || (FolioIncomeDetails.soleApplicantEmail && !FolioIncomeDetails.soleApplicantMobile)\"><label>Kindly add missing contact detail to proceed with folio creation.</label></div><div class=row><div class=col-md-6 ng-if=FolioIncomeDetails.soleApplicantEmail><label class=folio-contact-label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : <span easyassist-key=mask-element ng-if=!FolioIncomeDetails.showEmailEditField>{{FolioIncomeDetails.soleApplicantEmail}} </span><span class=edit-icon style=\"vertical-align: middle\" ng-if=\"(FolioIncomeDetails.soleApplicantEmail && FolioIncomeDetails.soleApplicantMobile) && !FolioIncomeDetails.showEmailEditField && !FolioIncomeDetails.showMobileEditField\" ng-click=\"FolioIncomeDetails.editContactDetails(\'email\')\"></span><div><input class=\"form-control inputNormal edit-fields\" type=text name=email ng-model=FolioIncomeDetails.soleApplicantEditedEmail ng-change=\"FolioIncomeDetails.changeValue(\'email\', FolioIncomeDetails.soleApplicantEditedEmail)\" ng-if=FolioIncomeDetails.showEmailEditField ng-pattern=FolioIncomeDetails.pattern.email_regex required><div ng-show=\"folioIncomeFormData.email.$dirty && folioIncomeFormData.email.$invalid\"><span class=error-input ng-bind=FolioIncomeDetails.pattern.ToastrMessage.VALIDATE_DATA.EMAIL_FIELD></span></div></div><span ng-if=FolioIncomeDetails.showEmailEditField class=edit-actions><button type=button class=\"btn-small btn-primary-action\" ng-disabled=\"folioIncomeFormData.email.$pristine || folioIncomeFormData.email.$error.pattern || folioIncomeFormData.email.$error.required\" ng-click=\"FolioIncomeDetails.generateContactUpdateOtp(\'email\')\">Send OTP</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"FolioIncomeDetails.cancelEditAction(\'email\');\">Cancel</button></span></label></div><div class=col-md-6 ng-if=!FolioIncomeDetails.soleApplicantEmail><label class=folio-contact-label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : <span ng-if=!FolioIncomeDetails.showEmailEditField>Not Updated</span> <span class=edit-icon style=\"vertical-align: middle\" ng-if=\"(!FolioIncomeDetails.soleApplicantEmail && FolioIncomeDetails.soleApplicantMobile) && !FolioIncomeDetails.showEmailEditField && !FolioIncomeDetails.showMobileEditField\" ng-click=\"FolioIncomeDetails.editContactDetails(\'email\')\"></span><div><input class=\"form-control inputNormal edit-fields\" type=text name=email ng-model=FolioIncomeDetails.soleApplicantEditedEmail ng-change=\"FolioIncomeDetails.changeValue(\'email\', FolioIncomeDetails.soleApplicantEditedEmail)\" ng-if=FolioIncomeDetails.showEmailEditField ng-pattern=FolioIncomeDetails.pattern.email_regex required><div ng-show=\"folioIncomeFormData.email.$dirty && folioIncomeFormData.email.$invalid\"><span class=error-input ng-bind=FolioIncomeDetails.pattern.ToastrMessage.VALIDATE_DATA.EMAIL_FIELD></span></div></div><span ng-if=FolioIncomeDetails.showEmailEditField class=edit-actions><button type=button class=\"btn-small btn-primary-action\" ng-disabled=\"folioIncomeFormData.email.$error.pattern || folioIncomeFormData.email.$error.required\" ng-click=\"FolioIncomeDetails.generateContactUpdateOtp(\'email\')\">Send OTP</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"FolioIncomeDetails.cancelEditAction(\'email\');\">Cancel</button></span></label></div><!-- <div class=\"col-md-3 belongsToContainerMobile emailBelongsMobile\"\n              style=\"display: inline-flex;  margin-right: 40px;\" ng-if=\"FolioIncomeDetails.soleApplicantEmail\">\n              <div style=\"flex-shrink : 0;\">\n                  <label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span>\n                      : </label>\n              </div>\n              <div class=\"selectfield\" style=\"display: inline-block ; margin-left : 5px;\"\n                  ng-class=\"{error:soleApplicantForm.emailBelongsTo.$dirty && soleApplicantForm.emailBelongsTo.$invalid}\">\n                  <select class=\"browser-default custom-select\" name=\"emailBelongsTo\" style=\"width: 150px\"\n                      ng-model=\"holders.emailBelongsTo\"\n                      ng-init=\"holders.emailBelongsTo = holders.emailBelongsTo ? holders.emailBelongsTo: null\"\n                      ng-options=\"data.familyCode as data.familyDescription for data in belongToListEmail\" required>\n                      <option value=\"\" selected>Select Value</option>\n                  </select>\n                  <span class=\"req text-red\">*</span>\n              </div>\n          </div>\n   --><div class=\"col-md-6 mLabel\" ng-if=FolioIncomeDetails.soleApplicantMobile><label class=folio-contact-label style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : <span easyassist-key=mask-element ng-if=!FolioIncomeDetails.showMobileEditField>{{FolioIncomeDetails.soleApplicantMobile}}</span> <span class=edit-icon style=\"vertical-align: middle\" ng-if=\"(FolioIncomeDetails.soleApplicantEmail && FolioIncomeDetails.soleApplicantMobile) && !FolioIncomeDetails.showMobileEditField && !FolioIncomeDetails.showEmailEditField\" ng-click=\"FolioIncomeDetails.editContactDetails(\'mobile\');\" ng-hide=FolioIncomeDetails.throughMobileLogin></span><div><input class=\"form-control inputNormal edit-fields\" type=text name=mobile ng-model=FolioIncomeDetails.soleApplicantEditedMobile ng-change=\"FolioIncomeDetails.changeValue(\'mobile\', FolioIncomeDetails.soleApplicantEditedMobile)\" ng-if=FolioIncomeDetails.showMobileEditField ng-pattern=FolioIncomeDetails.pattern.mobile_regex maxlength=13 required></div><span ng-if=FolioIncomeDetails.showMobileEditField class=edit-actions><button type=button class=\"btn-small btn-primary-action\" ng-disabled=\"folioIncomeFormData.mobile.$error.pattern || folioIncomeFormData.mobile.$error.required\" ng-click=\"FolioIncomeDetails.generateContactUpdateOtp(\'mobile\')\">Send OTP</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"FolioIncomeDetails.cancelEditAction(\'mobile\');\">Cancel</button></span></label><div ng-show=\"folioIncomeFormData.mobile.$dirty && folioIncomeFormData.mobile.$invalid && folioIncomeFormData.mobile.$error.pattern\" class=contact-error><span class=error-input ng-bind=FolioIncomeDetails.pattern.ToastrMessage.VALIDATE_DATA.MOBILE_ISD></span></div></div><div class=col-md-6 ng-if=!FolioIncomeDetails.soleApplicantMobile><label class=folio-contact-label style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : <span ng-if=!FolioIncomeDetails.showMobileEditField>Not Updated</span> <span class=edit-icon style=\"vertical-align: middle\" ng-if=\"(FolioIncomeDetails.soleApplicantEmail && !FolioIncomeDetails.soleApplicantMobile) && !FolioIncomeDetails.showMobileEditField && !FolioIncomeDetails.showEmailEditField\" ng-click=\"FolioIncomeDetails.editContactDetails(\'mobile\')\" ng-hide=FolioIncomeDetails.throughMobileLogin></span><div><input class=\"form-control inputNormal edit-fields\" type=text name=mobile ng-model=FolioIncomeDetails.soleApplicantEditedMobile ng-change=\"FolioIncomeDetails.changeValue(\'mobile\', FolioIncomeDetails.soleApplicantEditedMobile)\" ng-if=FolioIncomeDetails.showMobileEditField ng-pattern=FolioIncomeDetails.pattern.mobile_regex maxlength=13 required><div ng-show=\"folioIncomeFormData.mobile.$dirty && folioIncomeFormData.mobile.$invalid\"><span class=error-input ng-bind=FolioIncomeDetails.pattern.ToastrMessage.VALIDATE_DATA.MOBILE_FIELD></span></div></div><span ng-if=FolioIncomeDetails.showMobileEditField class=edit-actions><button type=button class=\"btn-small btn-primary-action\" ng-disabled=\"folioIncomeFormData.mobile.$pristine || folioIncomeFormData.mobile.$error.pattern || folioIncomeFormData.mobile.$error.required\" ng-click=\"FolioIncomeDetails.generateContactUpdateOtp(\'mobile\')\">Send OTP</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"FolioIncomeDetails.cancelEditAction(\'mobile\');\">Cancel</button></span></label></div></div><div class=row style=\"margin-top: 15px\"><div class=\"col-md-6 belongsToContainerWeb\" style=\"display: inline-flex\" ng-if=FolioIncomeDetails.soleApplicantEmail><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block ; margin-left : 5px\" ng-class=\"{error:folioIncomeFormData.emailBelongsTo.$dirty && folioIncomeFormData.emailBelongsTo.$invalid}\"><!-- <select class=\"browser-default custom-select\" name=\"emailBelongsTo\" style=\"width: 130px;    margin-top: 8px;\"\n                      ng-model=\"FolioIncomeDetails.holders.emailBelongsTo\"\n                      ng-init=\"FolioIncomeDetails.holders.emailBelongsTo = FolioIncomeDetails.holders.emailBelongsTo ? FolioIncomeDetails.holders.emailBelongsTo: null\"\n                      ng-options=\"data.familyCode as data.familyDescription for data in FolioIncomeDetails.belongToListEmail\" required>\n                      <option value=\"\" selected>Select Value</option>\n                  </select> --><select id=emailBelongsTo name=emailBelongsTo ng-model=FolioIncomeDetails.holders.emailBelongsTo style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray; margin-top: 8px;margin-left: 0px\" required><option value selected>Select Value</option><option ng-repeat=\"value in FolioIncomeDetails.belongToListEmail\" ng-selected=\"FolioIncomeDetails.holders.emailBelongsTo == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"folioIncomeFormData.emailBelongsTo.$dirty \"><span class=error-input ng-show=folioIncomeFormData.emailBelongsTo.$error.required>Please select option</span></span></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=col-md-6 ng-if=!FolioIncomeDetails.soleApplicantEmail></div><div class=\"col-md-6 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=FolioIncomeDetails.soleApplicantMobile><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block\" ng-class=\"{error:folioIncomeFormData.mobileBelongsTo.$dirty && folioIncomeFormData.mobileBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" id=mobileBelongsTo name=mobileBelongsTo ng-model=FolioIncomeDetails.holders.mobileBelongsTo ng-init=\"FolioIncomeDetails.holders.mobileBelongsTo = FolioIncomeDetails.holders.mobileBelongsTo ? FolioIncomeDetails.holders.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in FolioIncomeDetails.belongToListMobile\" ng-selected=\"FolioIncomeDetails.holders.mobileBelongsTo == data.familyCode\" style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray; margin-top: 8px;margin-left: 0px\" required><option value=\"\" selected>Select Value</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"folioIncomeFormData.mobileBelongsTo.$dirty &&  folioIncomeFormData.mobileBelongsTo.$invalid\"><span class=error-input ng-show=folioIncomeFormData.mobileBelongsTo.$error.required>Please select option</span></span></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=col-md-6 ng-if=!FolioIncomeDetails.soleApplicantMobile></div></div></div><!-- tax status --><div class=\"row tax-status-row\"><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Status<span class=\"req text-red\">*</span></p></div><br><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxstatus name=taxstatus ng-model=FolioIncomeDetails.folioIncomeForm.taxstatus ng-disabled=\"FolioIncomeDetails.taxStatusResident == true\" style=\"height: 40px;border-radius: 5px;width: 336px\" required><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.taxStatusData\" ng-selected=\"FolioIncomeDetails.folioIncomeForm.taxstatus == value.taxStatusCode\" value={{value.taxStatusCode}}>{{value.taxStatusDescription}}</option></select></div><span ng-show=\"folioIncomeFormData.taxstatus.$dirty && !FolioIncomeDetails.folioIncomeForm.taxstatus\" class=col-md-12><span class=error-input ng-show=folioIncomeFormData.taxstatus.$error.required ng-bind=FolioIncomeDetails.validateData.TAX_STATUS></span></span></div><br><!-- Occupation --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Occupation<span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5 d-flex flex-column\"><select class=selectNormal id=occupation name=occupation ng-model=FolioIncomeDetails.folioIncomeForm.occupation style=\"height: 40px;border-radius: 5px;width: 336px\" required><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.investorOccupations\" ng-selected=\"FolioIncomeDetails.folioIncomeForm.occupation == value.occupationCode\" value={{value.occupationCode}}>{{value.occupationDescription}}</option></select><span ng-show=\"folioIncomeFormData.occupation.$dirty && !FolioIncomeDetails.folioIncomeForm.occupation\"><span class=error-input ng-show=folioIncomeFormData.occupation.$error.required ng-bind=FolioIncomeDetails.validateData.OCCUPATION></span></span></div></div><br><!-- TOGGLE BUTTON --><div class=row><div class=\"col-xs-12 col-md-5\" style=\"margin-bottom: 3px\"><div style=\"display: flex;justify-content: flex-start;flex-direction: row;align-items: center\"><p class=grossanualincome>Gross Annual Income<span class=\"req text-red\">*</span></p><input type=checkbox id=switch style=\"margin-right: 10px\" ng-click=FolioIncomeDetails.networthcall() ng-checked=FolioIncomeDetails.networth><label class=switchlableINcome for=switch ng-checked=FolioIncomeDetails.networth style=\"margin-right: 10px\"></label><span class=titleFatca>Net Worth</span></div></div></div><br><!-- Annual Income --><div class=row><div class=\"col-xs-12 col-md-5 d-flex flex-column\" ng-if=!FolioIncomeDetails.networth><select class=selectNormal id=annualincome name=annualincome ng-model=FolioIncomeDetails.folioIncomeForm.annualincome style=\"height: 40px;border-radius: 5px;width: 336px;margin-left: 0px\" required easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.incomeSlabList\" ng-selected=\"FolioIncomeDetails.folioIncomeForm.annualincome == value.incomeCode\" value={{value.incomeCode}}>{{value.incomeDescription}}</option></select><span ng-show=\"folioIncomeFormData.annualincome.$dirty && !FolioIncomeDetails.folioIncomeForm.grossAnnualIncome\"><span class=error-input ng-show=folioIncomeFormData.annualincome.$error.required ng-bind=FolioIncomeDetails.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-sm-12 col-md-6\" ng-if=FolioIncomeDetails.networth><input type=number class=\"form-control inputNormal\" id=annualincome1 name=annualincome1 ng-model=FolioIncomeDetails.folioIncomeForm.networth required easyassist-key=mask-element> <span ng-show=\"folioIncomeFormData.annualincome1.$dirty && !FolioIncomeDetails.folioIncomeForm.networth\"><span class=error-input ng-show=folioIncomeFormData.annualincome1.$error.required ng-bind=FolioIncomeDetails.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-sm-12 col-md-6\" ng-if=FolioIncomeDetails.networth style=\"margin-top: -11px\"><div style=\"position: relative\"><div class=dob-input-container style=\"height: 45px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{FolioIncomeDetails.viewMode}} data-date-default=FolioIncomeDetails.folioIncomeForm.grossAnnualIncomeDate data-on-date-change=FolioIncomeDetails.getGrossAnnualIncomeDate maxdate=now format=DD-MM-YYYY id=endDate><input class=newinvestor-dob tabindex=2 id=grossAnnualIncomeDateId ng-keyup=FolioIncomeDetails.autoDate() name=grossAnnualIncomeDate type=text autocomplete=off placeholder=\"As on dd-mm-yyyy\" easyassist-key=mask-element required> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span>(Not older than 1 year)</span><br><span class=error-input ng-if=FolioIncomeDetails.dateErrorMessage ng-bind=FolioIncomeDetails.dateErrorMessage></span></div></div></div></div></div><br><br><div class=row><div class=col-md-12><p class=titleFatca>FATCA & CRS related question.</p></div></div><!-- Country --><div class=\"row absulatepostion\"><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Country<span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=country name=country ng-model=FolioIncomeDetails.folioIncomeForm.Fatca.countrie easyassist-key=mask-element style=\"height: 40px;border-radius: 5px;width: 336px;margin-left: 0px\" required><!-- <option value selected=\"selected\">Select</option> --><option ng-repeat=\"value in FolioDetails.countries\" ng-selected=\"FolioIncomeDetails.folioIncomeForm.Fatca.countrie == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select></div><div class=\"note-banner col-xs-12 col-md-7 noterelativepostion\"><div class=warning><img src=../../../assets/images/icons/light-bulb.png style=\"height: 50px;width: 50px;margin-top: 25px;padding: 10px\"><div class=wardiv>FATCA (Foreign Account tax Compliance Act) & CRS (Common Reporting Standard) declaration was prepared by finacial institutions company with the Central Board of Direct taxes (CBDT) rules.</div></div></div></div><!-- address type --><div class=\"row relativepostion\"><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Address type<span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=addressType name=addressType ng-model=FolioIncomeDetails.folioIncomeForm.Fatca.addressType easyassist-key=mask-element style=\"height: 40px;border-radius: 5px;width: 336px;margin-left: 0px\" required><!-- <option value selected=\"selected\">Select</option> --><option ng-repeat=\"x in FolioDetails.addressType\" ng-selected=\"FolioIncomeDetails.folioIncomeForm.Fatca.addressType == x.value\" value={{x.value}}>{{x.addressDescription}}</option></select><span ng-show=\"folioIncomeForm.addressType.$dirty && !FolioIncomeDetails.folioIncomeForm.Fatca.addressType\"><span class=error-input ng-show=folioIncomeForm.addressType.$error.required ng-bind=FolioIncomeDetails.validateData.FATCA_ADDRESS_TYPE_REQUIRED></span></span></div></div><br><!-- city --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>City<span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" type=text id=City name=City ng-model=FolioIncomeDetails.folioIncomeForm.Fatca.city easyassist-key=mask-element ng-pattern=\"/^[a-zA-Z ]+$/\" required> <span ng-show=\"folioIncomeFormData.City.$dirty && folioIncomeFormData.City.$invalid\"><span class=error-input ng-show=folioIncomeFormData.City.$error.required ng-bind=FolioIncomeDetails.validateData.CITY></span> <span class=error-input ng-show=folioIncomeFormData.City.$error.pattern>Numbers, Special characters not allowed in city name!</span></span></div></div><br><br><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit ng-disabled=\"folioIncomeFormData.$error.required  || !FolioIncomeDetails.holders.emailBelongsTo || !FolioIncomeDetails.holders.mobileBelongsTo || !FolioIncomeDetails.soleApplicantEmail || !FolioIncomeDetails.soleApplicantMobile\n      \">CONTINUE</button><!-- <button\n      class=\"btn hdfc-blue-cta-small\"\n      type=\"submit\">CONTINUE</button> --></form></div><style>.inputNormal{\n    width: 336px !important;\n  }\n  .dateInputReg{\n    width: 336px !important;\n  }\n    @media screen and (min-width: 1285px) {\n    .relativepostion{\n        position: relative;\n        margin-top: 90px;\n    }\n    .absulatepostion{\n         position: absolute;\n    }\n  }\n  @media screen and (max-width: 1285px) {\n    .noterelativepostion{\n\n       width: 100%;\n         }\n  }\n\n  .credentialNote{\n    padding:15px;\n    background: linen;\n    border-radius: 8px;\n    margin-top: 12px;\n    font-weight: 500;\n    text-align: center;\n  }</style>");
$templateCache.put("app/new-investors/folio-details/folio-nominee-details/folio-nominee-details.html","<div class=nomineedetails ng-init=FolioNomineeDetails.init()><form id=nomineeForm name=nomineeForm ng-submit=FolioNomineeDetails.submitNomineeData() novalidate autocomplete=off><br><p class=title1 style=\"margin: 0px 0px 0px -10px\">Do you wish to opt out of nomination?</p><br><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"row btn-yesno\" style=\"width: 336px\"><p ng-click=FolioNomineeDetails.addnomineedata(0) ng-attr-class=\"{{FolioNomineeDetails.addnominee && \' btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' || \' btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span ng-click=FolioNomineeDetails.addnomineedata(0) style=\"margin: auto\">Yes</span></p><p ng-click=FolioNomineeDetails.addnomineedata(1) ng-attr-class=\"{{FolioNomineeDetails.addnominee && \' btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' || \' btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\'  }}\"><span ng-click=FolioNomineeDetails.addnomineedata(1) style=\"margin: auto\">No</span></p></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div ng-if=FolioNomineeDetails.addnominee style=\"width: 269px;\n        height: 64px;\n        /* UI Properties */\n        background: #FFFBE3 0% 0% no-repeat padding-box;\n        border: 1px solid #EAE7D5;\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        border-radius: 6px;\n        opacity: 1\"><img src=../../../assets/images/icons/light-bulb.png style=\"width: 22px;\n          height: 22px;margin: 10px\"><p style=\"width: 219px;\n          height: 39px;\n          /* UI Properties */\n          text-align: left;\n          font: normal normal normal 12px/20px Poppins;\n          letter-spacing: 0px;\n          color: #000000\">you can add upto {{FolioNomineeDetails.maxNominee}} nominees. The total proportion should be 100%.</p></div></div></div><div ng-if=FolioNomineeDetails.addnominee><div class=row ng-if=FolioNomineeDetails.showNomineeUpdate><div class=\"col-sm-6 col-md-12\"><p style=\"font-size: 14px\"><strong>Nominee Details</strong> <i class=\"info-icon base-tooltip\" ng-if=FolioNomineeDetails.showNomineeUpdate data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"<div>\n                  SEBI Circular No. SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650, dated January 10, 2025\n                  states that, in case of Joint Account/Folio: <br>\n                  1. In case of “Demise of one or more joint holder(s)” event: Transmission of\n                    Account/Folio to: Surviving holder(s) through name deletion, The surviving holder(s) shall\n                    inherit the assets as owners.<br>\n                  2. In case of “Demise of all joint holders simultaneously – having nominee” event: Transmission of Account/Folio to: Nominee.<br>\n                  3. In case of “Demise of all joint holders simultaneously – not having nominee event: Transmission of Account /Folio to: Legal heir(s) of the youngest holder.\n                </div>\" style=\"top: 3px\"></i></p></div><div class=\"col-sm-6 col-md-12\"><span style=\"line-height: 1.5\">I/We hereby nominate the following person(s) who shall receive all the assets held in my / our account / folio in the event of my / our demise, as trustee and on behalf of my/our legal heir(s).</span></div></div><div class=row><div class=\"nomineetab col-sm-6 col-md-12\" style=\"overflow-x: auto\"><br><p ng-if=\"FolioNomineeDetails.nominees.length === 0\" ng-attr-class=\"{{FolioNomineeDetails.currentNomineeValue == 0 ? \'nomineecount b-b2\' : \'nomineecount\'}}\" ng-click=\"FolioNomineeDetails.currentNominee(FolioNomineeDetails.currentNomineeValue , true)\">{{FolioNomineeDetails.nomineeEnum[FolioNomineeDetails.currentNomineeValue]}} Nominee</p><p style=\"flex: 0 0 auto\" ng-repeat=\"nominee in FolioNomineeDetails.nominees track by $index\" ng-if=\"FolioNomineeDetails.nominees.length > 0\" ng-attr-class=\"{{FolioNomineeDetails.currentNomineeValue == $index ? \'nomineecount b-b2\' : \'nomineecount\'}}\" ng-click=\"FolioNomineeDetails.currentNominee($index , true)\">{{FolioNomineeDetails.nomineeEnum[$index]}} Nominee</p></div></div><div class=row><div class=\"col-sm-6 col-md-6\"><div class=row><div class=\"col-sm-6 col-md-6\"><p class=titleFatca>Name</p><input class=\"form-control inputNormal\" type=text name=nomineename id=nomineename ng-maxlength=40 limit-to=40 maxlength=40 ng-model=FolioNomineeDetails.nomineeDetails.nomineeName ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 95%\" ng-change=FolioNomineeDetails.setincapcitationList() autocomplete=off> <span ng-show=\"nomineeForm.nomineename.$dirty && nomineeForm.nomineename.$invalid\"><span class=error-input ng-show=nomineeForm.nomineename.$error.required ng-bind=FolioNomineeDetails.validateData.NOMINEE_NAME_REQUIRED></span> <span class=error-input ng-show=nomineeForm.nomineename.$error.pattern>Numbers,special characters are not allowed in name!</span></span></div><div class=\"col-sm-6 col-md-6\"><p class=titleFatca>Share Percent</p><input class=\"form-control percentage\" type=text name=sharepercent id=sharepercent ng-model=FolioNomineeDetails.nomineeDetails.percentage ng-pattern=/^[0-9]+$/ minlength=1 maxlength=3 style=\"width: 95%\" autocomplete=off ng-change=FolioNomineeDetails.updatePercentage()> <span ng-show=\"nomineeForm.sharepercent.$dirty && nomineeForm.sharepercent.$invalid\"><span class=error-input ng-show=nomineeForm.sharepercent.$error.required ng-bind=FolioNomineeDetails.validateData.PERCENT_REQUIRED></span> <span class=error-input ng-show=nomineeForm.sharepercent.$error.pattern>Text not allowed in percentage!</span></span></div></div></div><div class=\"col-sm-6 col-md-6\" ng-if=FolioNomineeDetails.showDeleteBtn><div style=\"display: flex;justify-content: flex-start;align-items: center;cursor: pointer\" ng-click=FolioNomineeDetails.deleteNominee(FolioNomineeDetails.currentNomineeValue)><img src=../../../../../assets/images/icons/delete-red.png alt=\"\" srcset=\"\" style=\"margin: 10px\"><p style=\"color: red\">Delete nominee</p></div></div></div><br><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><div class=checkbox><input type=checkbox ng-change=FolioNomineeDetails.changeFolioMinor() ng-model=FolioNomineeDetails.nomineeDetails.minor> <i class=icon-checkbox></i> <span class=checkbox-text>The Nominee is Minor</span></div></div></div><!-- DOB --><div class=\"form-control-group row\" ng-if=FolioNomineeDetails.nomineeDetails.minor><div class=\"col-sm-12 col-md-12\"><p class=titleFatca style=\"padding: 0px\">Date of Birth <span class=\"req text-red\" ng-if=FolioNomineeDetails.nomineeDetails.minor style=\"color: red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><div class=dob-input-container style=\"height: 45px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{FolioNomineeDetails.viewMode}} data-date-default=FolioNomineeDetails.nomineeDetails.dob data-on-date-change=FolioNomineeDetails.getNomineeDob data-min-date=FolioNomineeDetails.minorMinDate data-max-date=FolioNomineeDetails.minorMaxDate format=DD-MMM-YYYY><input class=newinvestor-dob tabindex=2 id=nomineedob name=nomineedob type=text autocomplete=off ng-keyup=FolioNomineeDetails.autoDate() placeholder=dd-mm-yyyy required style=\"border-radius: 5px\" easyassist-key=mask-element> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png style=\"width: 20px;top: -7px !important\"> </span><span ng-show=\"nomineeForm.nomineedob.$dirty && nomineeForm.nomineedob.$invalid\"><span class=error-input ng-if=FolioNomineeDetails.dateErrorMessage ng-bind=FolioNomineeDetails.dateErrorMessage></span></span></div><br></div></div></div><div class=\"form-control-group row\" ng-if=!FolioNomineeDetails.nomineeDetails.minor><div class=\"col-sm-12 col-md-12\"><p class=titleFatca style=\"padding: 0px\">Date of Birth <span class=\"req text-red\" ng-if=FolioNomineeDetails.nomineeDetails.minor style=\"color: red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><div class=dob-input-container style=\"height: 45px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{FolioNomineeDetails.viewMode}} data-date-default=FolioNomineeDetails.nomineeDetails.dob data-on-date-change=FolioNomineeDetails.getNomineeDob data-min-date=FolioNomineeDetails.majorMinDate data-max-date=FolioNomineeDetails.majorMaxDate format=DD-MMM-YYYY><input class=newinvestor-dob tabindex=2 id=nomineedob name=nomineedob type=text autocomplete=off ng-keyup=FolioNomineeDetails.autoDate() placeholder=dd-mm-yyyy required style=\"border-radius: 5px\" easyassist-key=mask-element> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png style=\"width: 20px;top: -7px !important\"> </span><span ng-show=\"nomineeForm.nomineedob.$dirty && nomineeForm.nomineedob.$invalid\"><span class=error-input ng-if=FolioNomineeDetails.dateErrorMessage ng-bind=FolioNomineeDetails.dateErrorMessage></span></span></div><br></div></div></div><br><br><!-- Relation --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Relationship <span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=nomineeRelationship name=nomineeRelationship ng-model=FolioNomineeDetails.nomineeDetails.nomineeRelation required style=\"height: 40px;width: 100%\" easyassist-key=mask-element><option value selected>Select</option><option ng-repeat=\"x in FolioNomineeDetails.applicantRelationShip\" ng-selected=\"FolioNomineeDetails.nomineeDetails.nomineeRelation == x.value\" value={{x.value}}>{{x.relationDesc}}</option></select></div></div><br><!--NOMINEE RELATION OTHER RELATION INPUT FIELD STARTS HERE--><!--<div class=\" form-control-group row\" ng-if=\"FolioNomineeDetails.showNomineeUpdate  && FolioNomineeDetails.nomineeDetails.nomineeRelation === \'OTHERS\'\">\n        <div class=\"col-sm-12 col-md-12\">\n          <p class=\"titleFatca\">Others (Please specify)</p>\n        </div>\n        <div class=\"col-sm-6 col-md-6\">\n          <input class=\"form-control\" type=\"text\"\n                 ng-pattern=\"/^[a-zA-Z\\s]*$/\"\n                 ng-bind=\"FolioNomineeDetails.others\"\n                 ng-model=\"FolioNomineeDetails.others\"\n                 name=\"others\"\n                 maxlength=\"50\"\n                 autocomplete=\"off\" capitalize required>\n          <span ng-show=\"nomineeForm[\'others\'].$dirty && nomineeForm[\'others\'].$invalid\">\n            <span class=\"error-input\" ng-show=\"nomineeForm[\'others\'].$error.required\">\n              {{FolioNomineeDetails.nomineeValidateData.RELATIONSHIP_WITH_APPLICANT_OTHER}}\n            </span>\n          </span>\n        </div>\n      </div><br>--><!--NOMINEE RELATION OTHER RELATION INPUT FIELD ENDS HERE--><!--NOMINEE EMAIL INPUT FIELD STARTS HERE--><div class=\"form-control-group row\" ng-if=FolioNomineeDetails.showNomineeUpdate><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee Email ID<span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=form-control type=text ng-pattern=FolioNomineeDetails.emailPattern ng-model=FolioNomineeDetails.nomineeDetails.emailId name=emailId maxlength=254 ng-change=FolioNomineeDetails.nomineeEmailChanged(FolioNomineeDetails.nomineeDetails.emailId) autocomplete=off required> <span ng-show=\"nomineeForm[\'emailId\'].$dirty && nomineeForm[\'emailId\'].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'emailId\'].$error.pattern\">{{FolioNomineeDetails.nomineeValidateData.EMAIL_FIELD}} </span><span class=error-input ng-show=\"nomineeForm[\'emailId\'].$error.required\">{{FolioNomineeDetails.nomineeValidateData.EMAIL_REQUIRED}} </span></span><span><span class=error-input ng-show=FolioNomineeDetails.emailIdInvalid>{{FolioNomineeDetails.errorMessageEmail}}</span></span></div></div><br><!--NOMINEE EMAIL INPUT FIELD ENDS HERE--><!--NOMINEE MOBILE INPUT FIELD STARTS HERE--><div class=\"form-control-group row\" ng-if=FolioNomineeDetails.showNomineeUpdate><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee Mobile No.<span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=form-control type=text ng-model=FolioNomineeDetails.nomineeDetails.mobileNumber name=mobile minlength=1 maxlength=15 ng-pattern=FolioNomineeDetails.mobilePattern autocomplete=off required> <span ng-show=\"nomineeForm[\'mobile\'].$dirty && nomineeForm[\'mobile\'].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'mobile\'].$error.pattern || nomineeForm[\'mobile\'].$error.minlength\">{{FolioNomineeDetails.nomineeValidateData.MOBILE_FIELD}} </span><span class=error-input ng-show=\"nomineeForm[\'mobile\'].$error.required\">{{FolioNomineeDetails.nomineeValidateData.MOBILE_REQUIRED}} </span></span><span ng-show=\"!nomineeForm[\'mobile\'].$invalid && FolioNomineeDetails.nomineeDetails.mobileInvalid\"><span class=error-input>{{FolioNomineeDetails.errorMessageMobile}}</span></span></div></div><br><!--NOMINEE MOBILE INPUT FIELD ENDS HERE--><!--NOMINEE IDENTIFIER FIELD STARTS HERE--><div class=\"form-control-group row mb-3\" ng-if=FolioNomineeDetails.showNomineeUpdate><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Select Personal Identifier of Nominee <span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=personalIdentifier name=personalIdentifier ng-model=FolioNomineeDetails.nomineeDetails.identityProofType ng-init=\"FolioNomineeDetails.nomineeDetails.identityProofType = FolioNomineeDetails.nomineeDetails.identityProofType ? FolioNomineeDetails.nomineeDetails.identityProofType : null\" ng-options=\"_type.value as _type.name for _type in FolioNomineeDetails.nomineeDetails.applicantPersonalIdentifiers\" ng-change=FolioNomineeDetails.changePersonalIdentifier(FolioNomineeDetails.nomineeDetails.identityProofType) easyassist-key=mask-element required style=\"height: 40px;width: 100%\"><option value=\"\" selected>Select Personal Identifier of Nominee</option></select><span ng-show=\"nomineeForm[\'personalIdentifier\'].$dirty && nomineeForm[\'personalIdentifier\'].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'personalIdentifier\'].$error.required\">{{FolioNomineeDetails.nomineeValidateData.PERSONAL_IDENTIFIER_REQUIRED}}</span></span></div></div><!--NOMINEE IDENTIFIER FIELD ENDS HERE--><!-- PAN --><div class=\"form-control-group row mb-3\" ng-if=\"!FolioNomineeDetails.showNomineeUpdate || (FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.nomineeDetails.identityProofType === \'PAN_CARD\')\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee PAN <span ng-if=FolioNomineeDetails.showNomineeUpdate class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><div class=pan-input-container><label for=pan></label><input class=form-control id=nomineepan tabindex=1 type=text name=nomineepan maxlength=10 minlength=10 autocomplete=off ng-model=FolioNomineeDetails.nomineePan ng-change=FolioNomineeDetails.checkPanValid() ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ capitalize style=\"background: #FFFFFF 0% 0% no-repeat padding-box;\n        border: 1px solid #B8C6D1;\n        border-radius: 5px;\n        height: 40px;\n        opacity: 1\" easyassist-key=mask-element ng-required=FolioNomineeDetails.showNomineeUpdate><br><span ng-show=\"nomineeForm.nomineepan.$dirty && nomineeForm.nomineepan.$invalid\"><span class=error-input ng-show=nomineeForm.nomineepan.$error.required ng-bind=FolioNomineeDetails.validateData.PAN_REQUIRED style=\"color: red\"></span> <span class=error-input ng-show=nomineeForm.nomineepan.$error.maxlength ng-bind=FolioNomineeDetails.validateData.PAN_FIELD style=\"color: red\"></span> <span class=error-input ng-show=nomineeForm.nomineepan.$error.pattern ng-bind=FolioNomineeDetails.validateData.PAN_FIELD style=\"color: red\"></span> </span><span ng-show=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineePANInvalid><span class=error-input>{{FolioNomineeDetails.errorMessageNominee}}</span></span></div></div></div><!-- PAN Ends here --><!--NOMINEE License FIELD STARTS HERE--><div class=\"form-control-group row mb-3\" ng-if=\"FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.nomineeDetails.identityProofType === \'DRIVING_LICENSE\'\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee Driving License No.<span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=form-control type=text ng-bind=FolioNomineeDetails.nomineeDetails.drivingLicense ng-model=FolioNomineeDetails.nomineeDetails.drivingLicense name=drivingLicense maxlength=35 ng-change=FolioNomineeDetails.nomineeLicenseChanged(FolioNomineeDetails.nomineeDetails.drivingLicense) autocomplete=off required capitalize> <span ng-show=\"nomineeForm[\'drivingLicense\'].$dirty && nomineeForm[\'drivingLicense\'].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'drivingLicense\'].$error.required\">{{FolioNomineeDetails.nomineeValidateData.DRIVING_LICENSE_INVALID}} </span></span><span ng-show=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeLicenseInvalid><span class=error-input>{{FolioNomineeDetails.errorMessageNomineeLicense}}</span></span></div></div><!--NOMINEE License INPUT FIELD ENDS HERE--><!--NOMINEE AADHAAR FIELD STARTS HERE--><div class=\"form-control-group row mb-3\" ng-if=\"FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.nomineeDetails.identityProofType === \'AADHAR_CARD\'\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee Aadhaar No.<span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control input-aadhar-investor\" type=text class=aadhar-field ng-bind=FolioNomineeDetails.nomineeDetails.aadharCard ng-model=FolioNomineeDetails.nomineeDetails.aadharCard name=aadharCard ng-pattern=/^\\+?\\d+$/ minlength=4 maxlength=4 ng-change=FolioNomineeDetails.nomineeAadhaarChanged(FolioNomineeDetails.nomineeDetails.aadharCard) autocomplete=off required capitalize> <span class=\"arn aadhar-investor\">XXXX XXXX </span><span ng-show=\"nomineeForm[\'aadharCard\'].$dirty && nomineeForm[\'aadharCard\'].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'aadharCard\'].$error.minlength || nomineeForm[\'aadharCard\'].$error.pattern\">{{FolioNomineeDetails.nomineeValidateData.AADHAAR_INVALID}} </span><span class=error-input ng-show=\"nomineeForm[\'aadharCard\'].$error.required\">{{FolioNomineeDetails.nomineeValidateData.AADHAAR_INVALID}} </span></span><span ng-show=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeAadhaarInvalid><span class=error-input>{{FolioNomineeDetails.errorMessageNomineeAadhaar}}</span></span></div></div><!--NOMINEE AADHAAR INPUT FIELD ENDS HERE--><!--NOMINEE License FIELD STARTS HERE--><div class=\"form-control-group row mb-3\" ng-if=\"FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.nomineeDetails.identityProofType === \'PASSPORT\'\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee Passport<span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=form-control type=text ng-bind=FolioNomineeDetails.nomineeDetails.passport ng-model=FolioNomineeDetails.nomineeDetails.passport name=passport maxlength=35 ng-change=FolioNomineeDetails.passportChanged(FolioNomineeDetails.nomineeDetails.passport) autocomplete=off required capitalize> <span ng-show=\"nomineeForm[\'passport\'].$dirty && nomineeForm[\'passport\'].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'passport\'].$error.required\">{{FolioNomineeDetails.nomineeValidateData.PASSPORT_REQUIRED}} </span></span><span ng-show=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineePassportInvalid><span class=error-input>{{FolioNomineeDetails.errorMessagePassportNumber}}</span></span></div></div><!--NOMINEE License INPUT FIELD ENDS HERE--><div ng-if=FolioNomineeDetails.nomineeDetails.minor><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Guardian Name <span class=\"req text-red\" style=\"color: red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control inputNormal\" type=text name=guardianName id=guardianName autocomplete=off ng-model=FolioNomineeDetails.guardianName ng-blur=FolioNomineeDetails.checkgNmae() style=\"width: 100%\"></div></div><!-- Relation --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Guardian Relationship <span class=\"req text-red\" style=\"color: red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=guardianRelation name=guardianRelation ng-model=FolioNomineeDetails.guardianRelation ng-change=FolioNomineeDetails.checkGRelation() required style=\"height: 40px;width: 100%\"><option value selected>Select</option><option ng-repeat=\"x in FolioNomineeDetails.guardianRelationshipList\" ng-selected=\"FolioNomineeDetails.guardianRelation == x.value\" value={{x.value}}>{{x.relationDesc}}</option></select></div></div><br><!-- PAN --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Guardian PAN</p></div><div class=\"col-sm-6 col-md-6\"><div class=pan-input-container><label for=pan></label><input class=form-control id=pan tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=FolioNomineeDetails.guardianPan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-blur=FolioNomineeDetails.checkpan() easyassist-key=mask-element capitalize autocomplete=off style=\"background: #FFFFFF 0% 0% no-repeat padding-box;\n          border: 1px solid #B8C6D1;\n          border-radius: 5px;\n          height: 40px;\n          width: 100%;\n          opacity: 1\"><br><span ng-show=\"nomineeForm.pan.$dirty && nomineeForm.pan.$invalid\"><span class=error-input ng-show=nomineeForm.pan.$error.required ng-bind=FolioNomineeDetails.validateData.PAN_REQUIRED style=\"color: red\"></span> <span class=error-input ng-show=nomineeForm.pan.$error.maxlength ng-bind=FolioNomineeDetails.validateData.PAN_FIELD style=\"color: red\"></span> <span class=error-input ng-show=nomineeForm.pan.$error.pattern ng-bind=FolioNomineeDetails.validateData.PAN_FIELD style=\"color: red\"></span></span></div></div></div></div><!-- address --><!--<div class=\"row\">\n        <p class=\"inputquestion titleFatca col-xs-12 col-md-2\">Address Details</p>&nbsp;\n          <div class=\"col-xs-12 col-md-7 col-md-4\">\n            <input type=\"checkbox\" class=\"nomineeCheckbox col-xs-12 col-md-1\" name=\"address\" id=\"address\"\n            ng-model=\"FolioNomineeDetails.addAddress\" ng-click=\"FolioNomineeDetails.addNomineeNewAddress()\"\n            ng-checked=\"FolioNomineeDetails.addAddress\" autocomplete=\"off\"/>\n            <label class=\"confirmationnote \" for=\"address\"\n          style=\"font-size: 13px;font-weight: bold; width: fit-content ;\">Same as applicant address</label>\n          </div>\n      </div><br>--><!-- Address Line 1 --><div class=address ng-if=!FolioNomineeDetails.addAddress><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Address Line 1 <span ng-if=FolioNomineeDetails.showNomineeUpdate class=\"req text-red\" style=\"color: red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control inputNormal\" type=text name=addressLine1 id=addressLine1 ng-maxlength=60 limit-to=60 maxlength=60 ng-model=FolioNomineeDetails.addressLine1 style=\"width: 100%\" easyassist-key=mask-element autocomplete=off ng-required=FolioNomineeDetails.showNomineeUpdate></div></div><br><!-- Address Line 2 --><div class=address><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Address Line 2</p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control inputNormal\" type=text name=addressLine2 id=addressLine2 ng-maxlength=60 limit-to=60 maxlength=60 autocomplete=off ng-model=FolioNomineeDetails.addressLine2 style=\"width: 100%\" easyassist-key=mask-element></div></div><br><!-- country --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Country <span ng-if=FolioNomineeDetails.showNomineeUpdate class=\"req text-red\" style=\"color: red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=country name=country ng-model=FolioNomineeDetails.country style=\"height: 40px;width: 100%\" ng-change=FolioNomineeDetails.setState() easyassist-key=mask-element ng-required=FolioNomineeDetails.showNomineeUpdate><option value selected>Select</option><option ng-repeat=\"value in FolioDetails.countries\" ng-selected=\"FolioNomineeDetails.country == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select></div></div><br><!-- state --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>State <span ng-if=FolioNomineeDetails.showNomineeUpdate class=\"req text-red\" style=\"color: red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=state name=state ng-model=FolioNomineeDetails.state ng-disabled=\"FolioNomineeDetails.country != \'IN\' \" style=\"height: 40px;width: 100%\" easyassist-key=mask-element ng-required=FolioNomineeDetails.showNomineeUpdate>><option value selected>Select</option><option ng-repeat=\"value in FolioNomineeDetails.stateList\" ng-selected=\"FolioNomineeDetails.state == value.stateCode\" value={{value.stateCode}}>{{value.stateName}}</option></select></div></div><br><!-- city/zipcode --><div class=row><div class=\"col-sm-6 col-md-6\"><div class=row style=\"margin-left: 2px\"><div class=\"col-sm-12 col-md-6\"><div class=row><p class=\"titleFatca col-sm-12 col-md-12\" style=\"margin-left: -15px\">City <span ng-if=FolioNomineeDetails.showNomineeUpdate class=\"req text-red\" style=\"color: red\">*</span></p><input class=\"form-control inputNormal col-sm-12 col-md-12\" type=text ng-model=FolioNomineeDetails.city name=city id=city ng-maxlength=35 limit-to=35 maxlength=35 ng-pattern=\"/^[a-zA-Z ]+$/\" style=\"width: 95%\" required easyassist-key=mask-element autocomplete=off><br><span class=\"col-sm-12 col-md-12\" ng-show=\"nomineeForm.city.$dirty && nomineeForm.city.$invalid\"><span class=error-input ng-show=nomineeForm.city.$error.required ng-bind=FolioNomineeDetails.validateData.CITY></span> <span class=error-input ng-show=nomineeForm.city.$error.pattern>Number not allowed in name!</span></span></div></div><div class=\"col-sm-12 col-md-6\"><div class=row><p class=\"titleFatca col-sm-12 col-md-12\" style=\"margin-left: -15px\">Zip Code <span ng-if=FolioNomineeDetails.showNomineeUpdate class=\"req text-red\" style=\"color: red\">*</span></p><input class=\"form-control inputNormal col-sm-12 col-md-12\" type=text is-number autocomplete=off ng-model=FolioNomineeDetails.pinCode name=zipcode id=zipcode ng-pattern=/^[0-9]+$/ ng-maxlength=6 limit-to=6 maxlength=6 style=\"width: 95%\" easyassist-key=mask-element required><br><div ng-show=\"nomineeForm.zipcode.$dirty && nomineeForm.zipcode.$invalid\"><span class=error-input ng-show=nomineeForm.zipcode.$error.required>Zipcode is required!</span></div><span class=error-input ng-show=nomineeForm.zipcode.$error.minlength>zipcode length is less!</span> <span class=error-input ng-show=nomineeForm.zipcode.$error.maxlength>zipcode length is high!</span> <span class=\"col-sm-12 col-md-12\" ng-show=\"nomineeForm.zipcode.$dirty && nomineeForm.zipcode.$invalid\"><span class=error-input ng-show=nomineeForm.zipcode.$error.pattern>Text not allowed in zipcode!</span></span></div></div></div></div></div><br></div></div><!--NOMINEE STATEMENT DECLARATION FIELD STARTS HERE--><div class=\"statement-declaration row mb-4\" ng-if=FolioNomineeDetails.showNomineeUpdate><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Statement of Holding(Account Statement) Declaration <span class=\"req text-red\">*</span></p></div><div class=\"col-sm-12 col-md-12\"><div class=declaration-content><div class=row><div class=\"col-md-12 mb-4\"><span>I/ We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/ us by the AMC as follows; (please tick, as appropriate)</span></div></div><div class=row><div class=\"col-md-12 mb-3\"><div class=radio-block><span class=radio><input type=radio name=statmentNomination ng-value=true ng-change=FolioNomineeDetails.setStatement() ng-model=FolioNomineeDetails.nomination required> <span class=check></span> </span><span class=radio-label>Nomination: Yes</span></div><div class=radio-block><span class=radio><input type=radio name=statmentNomination ng-value=false ng-change=FolioNomineeDetails.setStatement() ng-model=FolioNomineeDetails.nomination required> <span class=check></span> </span><span class=radio-label>Nomination: No</span></div><!--<div class=\"checkbox\">\n                  <input ng-model=\"FolioNomineeDetails.nomination\" type=\"checkbox\"\n                         ng-change=\"FolioNomineeDetails.setStatement();\"\n                         ng-required=\"!FolioNomineeDetails.nomineeName\"/>\n                  <i class=\"icon-checkbox\"></i>\n                  <span class=\"checkbox-text ria\" style=\"margin-top: -10px;\">Nomination: Yes/No</span>\n                </div>--></div><!--<div class=\"col-md-12\">\n                <div class=\"checkbox\">\n                  <input ng-model=\"FolioNomineeDetails.nomineeName\" type=\"checkbox\"\n                         ng-change=\"FolioNomineeDetails.setStatement();\"\n                         ng-required=\"!FolioNomineeDetails.nomination\" />\n                  <i class=\"icon-checkbox\"></i>\n                  <span class=\"checkbox-text ria\" style=\"margin-top: -10px;\">Name of Nominee(s)</span>\n                </div>\n              </div>--><!--<div class=\"col-md-12 mt-2\">\n                <span ng-show=\"!FolioNomineeDetails.nomineeName && !FolioNomineeDetails.nomination\">\n                  <span class=\"error-input\">{{FolioNomineeDetails.nomineeValidateData.STATEMENT_HOLDING_DECLARATION_REQUIRED}}</span>\n                </span>\n              </div>--></div></div></div></div><!--NOMINEE STATEMENT DECLARATION FIELD ENDS HERE--><!--NOMINEE Incapacitation DECLARATION FIELD STARTS HERE--><!--<div class=\"statement-declaration row mb-4\" ng-if=\"FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.payload.holdmode !== \'ANY_OR_SURVIVOR\'\">\n\n        <div class=\"col-sm-12 col-md-12\">\n          <p class=\"titleFatca\">Incapacitation Declaration (Optional) <i class=\"info-icon base-tooltip\" data-bs-html=\"true\" tooltip data-bs-toggle=\"tooltip\"\n                                                                                   data-bs-placement=\"right\"\n                                                                                   data-bs-title=\'<div>\n                SEBI Circular: SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650 dated January 10, 2025, 3.5 paragraph states, Nominee to act on behalf of incapacitated investors 3.5.1. The regulated entity shall provide the investors having single holding / account / folio, the option to: <br/>\n                a) empower, any one of the nominees (excluding minor nominee) to operate the investor’s account / folio, if the investor is physical incapacitated, but still has the capacity to contract. <br/>\n                b) specify either the percentage or absolute value of assets in the account/ folio that can be encashed by such nominee. <br/>\n                c) change such mandate any number of times without any restriction. <br/>\n              </div>\'>\n          </i></p>\n        </div>\n\n        <div class=\"col-sm-12 col-md-12\">\n          <div class=\"declaration-content\">\n            <div class=\"row\">\n              <div class=\"col-md-12\">\n                <span style=\"line-height: 3\">I hereby authorize\n                  <select name=\"incapcitationNominee\" class=\"set-only-border-bottom\"\n                          ng-model=\"FolioNomineeDetails.incapcitationNomineeIndex\"\n                          ng-change=\"FolioNomineeDetails.selectedNominee()\"\n                          ng-options=\"data.value as data.key disable when (data.isMinor) for data  in FolioNomineeDetails.incapcitationList\"\n                  >\n                    <option value=\"\" selected>Select Nominee Name</option>\n                  </select>\n                (nominee number <input class=\"set-only-border-bottom\" readonly type=\"text\" ng-model=\"FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber\" name=\"nomineeNumber\" is-number maxlength=\"6\">) to operate my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up to\n                  <input class=\"set-only-border-bottom\" type=\"text\" ng-disabled=\"!FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber\" ng-pattern=\"/^(100|[1-9][0-9]?)$/\" ng-model-options=\"{ allowInvalid: true}\" ng-required=\"FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber && !FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.amount\" ng-model=\"FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.percentage\" ng-change=\"FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.amount = null\" name=\"percentage\" is-number maxlength=\"3\">% of assets in the account / folio or Rs.\n                  <input class=\"set-only-border-bottom\" type=\"text\" ng-disabled=\"!FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber\" ng-pattern=\"/^[1-9]\\d*$/\" ng-model=\"FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.amount\" ng-required=\"FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber && !FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.percentage\" name=\"claimAmount\" ng-change=\"FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.percentage = null\" is-number maxlength=\"20\">.\n                </span>\n\n            </div>\n\n            <div class=\"col-md-12\">\n              <span ng-show=\"(FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber && nomineeForm[\'percentage\'].$dirty && nomineeForm[\'percentage\'].$invalid) || (nomineeForm[\'claimAmount\'].$dirty && nomineeForm[\'claimAmount\'].$invalid)\">\n\n                  <span class=\"error-input\" ng-show=\"nomineeForm[\'claimAmount\'].$error.pattern\">\n                    Amount/percentage cannot be less than 1.\n                  </span>\n                  <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.pattern && FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.percentage < 1\">\n                    Amount/percentage cannot be less than 1.\n                  </span>\n                  <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.pattern && FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.percentage > 100\">\n                    Percentage cannot be more than 100%.\n                  </span>\n                </span>\n\n              <span ng-show=\"FolioNomineeDetails.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber && ((nomineeForm[\'percentage\'].$dirty && nomineeForm[\'percentage\'].$invalid) || (nomineeForm[\'claimAmount\'].$dirty && nomineeForm[\'claimAmount\'].$invalid))\">\n                  <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.required || nomineeForm[\'claimAmount\'].$error.required\">\n                    Please enter the percentage or Rs. that can be encashed by the nominee.\n                  </span>\n                </span>\n            </div>\n\n            </div>\n          </div>\n        </div>\n\n      </div>--><!--NOMINEE Incapacitation DECLARATION FIELD ENDS HERE--><div style=\"display: flex\"><div ng-if=FolioNomineeDetails.extraNomineeVar><button ng-disabled=\"FolioNomineeDetails.showNomineeUpdate && (!FolioNomineeDetails.nomineeLicenseValid || !FolioNomineeDetails.nomineeAadhaarValid || !FolioNomineeDetails.nomineePANValid || FolioNomineeDetails.emailIdInvalid)\" type=button ng-click=FolioNomineeDetails.addExtraNomineeFun() style=\"border-radius: 18px;background-color: white;width: 233px;text-align: center;padding: 10px;border: 1px solid #ff8486;color: #ff8486\">ADD ANOTHER NOMINEE</button> <button ng-disabled=\"FolioNomineeDetails.showNomineeUpdate && (!FolioNomineeDetails.nomineeLicenseValid || !FolioNomineeDetails.nomineeAadhaarValid || !FolioNomineeDetails.nomineePANValid || FolioNomineeDetails.emailIdInvalid)\" class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-click=FolioNomineeDetails.addnewnominee(nomineeForm)>CONTINUE</button></div><div ng-if=!FolioNomineeDetails.extraNomineeVar><div ng-if=!FolioNomineeDetails.addAddress><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-disabled=\"!FolioNomineeDetails.nomineeDetails.nomineeName ||\n        !FolioNomineeDetails.nomineeDetails.percentage || (FolioNomineeDetails.nomineeDetails.minor && !FolioNomineeDetails.nomineeDetails.dob) ||\n        !FolioNomineeDetails.nomineeDetails.nomineeRelation ||\n        !FolioNomineeDetails.proceed || nomineeForm.$invalid || FolioNomineeDetails.showNomineeUpdate && (!FolioNomineeDetails.nomineeLicenseValid || !FolioNomineeDetails.nomineeAadhaarValid || !FolioNomineeDetails.nomineePANValid || FolioNomineeDetails.emailIdInvalid || !FolioNomineeDetails.nomineePassportValid)\" ng-click=FolioNomineeDetails.addnewnominee(nomineeForm)>CONTINUE</button></div><div ng-if=FolioNomineeDetails.addAddress><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-disabled=\"!FolioNomineeDetails.nomineeDetails.nomineeName ||\n        !FolioNomineeDetails.nomineeDetails.percentage ||(FolioNomineeDetails.nomineeDetails.minor && !FolioNomineeDetails.nomineeDetails.dob) ||\n        !FolioNomineeDetails.nomineeDetails.nomineeRelation ||\n        !FolioNomineeDetails.proceed || nomineeForm.$invalid || FolioNomineeDetails.showNomineeUpdate && (!FolioNomineeDetails.nomineeLicenseValid || !FolioNomineeDetails.nomineeAadhaarValid || !FolioNomineeDetails.nomineePANValid || FolioNomineeDetails.emailIdInvalid || !FolioNomineeDetails.nomineePassportValid)\" ng-click=FolioNomineeDetails.addnewnominee(nomineeForm)>CONTINUE</button></div></div></div><br><!-- <div\n      ng-If=\"FolioNomineeDetails.numberofnominees > 0 && FolioNomineeDetails.addAddress\" style=\"display: flex;\">\n        <button type=\"button\"\n        ng-If=\"(FolioNomineeDetails.shownextSteps1 || FolioNomineeDetails.shownextSteps2) && FolioNomineeDetails.addanotherNominee\"\n        ng-click=\"FolioNomineeDetails.addnewnominee(nomineeForm)\"\n        ng-disabled=\"!FolioNomineeDetails.nomineeDetails.nomineeName ||\n        !FolioNomineeDetails.nomineeDetails.percentage ||\n        !FolioNomineeDetails.nomineeDetails.nomineeRelation\"\n          style=\"border-radius: 18px;background-color: white;width: 233px;text-align: center;padding: 10px;border: 1px solid #ff8486;color: #ff8486;\">\n          ADD ANOTHER NOMINEE\n        </button>\n        &nbsp;&nbsp;\n        <button class=\"btn hdfc-blue-cta-small\"\n          type=\"submit\">CONTINUE</button>\n      </div> --><!-- <div ng-If=\"FolioNomineeDetails.numberofnominees > 0 && !FolioNomineeDetails.addAddress\" style=\"display: flex;\">\n        <button type=\"button\"\n        ng-If=\"(FolioNomineeDetails.shownextSteps1 || FolioNomineeDetails.shownextSteps2) && FolioNomineeDetails.addanotherNominee\"\n        ng-click=\"FolioNomineeDetails.addnewnominee(nomineeForm)\"\n        ng-disabled=\"!FolioNomineeDetails.nomineeDetails.nomineeName ||\n        !FolioNomineeDetails.nomineeDetails.percentage ||\n        !FolioNomineeDetails.nomineeDetails.nomineeRelation ||\n        !FolioNomineeDetails.addressLine1 ||\n        !FolioNomineeDetails.addressLine2 ||\n        !FolioNomineeDetails.city ||\n        !FolioNomineeDetails.pinCode\"\n          style=\"border-radius: 18px;background-color: white;width: 233px;text-align: center;padding: 10px;border: 1px solid #ff8486;color: #ff8486;\">\n          ADD ANOTHER NOMINEE\n        </button>\n        &nbsp;&nbsp;\n        <button class=\"btn hdfc-blue-cta-small\"\n          type=\"submit\">CONTINUE</button>\n      </div> --><!-- end address --><!-- end nominee yes --></div><div ng-if=!FolioNomineeDetails.addnominee style=\"margin-left: -15px\"><!-- Confirmation note --><div class=row><div class=\"col-sm-10 col-md-9\" style=\"display: flex;justify-content: flex-start;flex-direction: row\"><input class=nomineeCheckbox type=checkbox id=confirmfoliocreate name=confirmfoliocreate ng-click=FolioNomineeDetails.getconformation() ng-checked=FolioNomineeDetails.conformation><label for=confirmfoliocreate class=confirmationnote ng-checked=FolioNomineeDetails.conformation style=\"font-size: 13px\"><ng-bind-html class=label-val-container dynamic=FolioNomineeDetails.DynamicDataNominee.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT.content></ng-bind-html></label></div></div><!-- Confirmation note --><br><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit ng-disabled=!FolioNomineeDetails.conformation>CONTINUE</button></div></form></div><style>.percentage {\n    height: 40px;\n    border: 1px solid gray;\n    background-repeat: no-repeat;\n    background-position-y: 14px;\n    background-position-x: 36px;\n    background-size: 11px;\n    background-image: url(\"assets//images/percent.svg\");\n  }\n  .error-input{\n    color: red;\n    padding-bottom: 10px;\n  }\n\n  @media screen and (max-width: 750px) {\n    .minorageproofdiv {\n      margin-left: -15px;\n    }\n  }\n\n  .Red{\n    color: red !important;\n  }</style>");
$templateCache.put("app/new-investors/folio-details/summary/summary-page.html","<div class=row ng-init=SummaryPage.init() style=\"margin-top: 15px\"><div class=col-xs-12><div class=\"form-page-header row\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: flex-start;flex-direction: row;align-items: baseline\"><img ng-click=SummaryPage.gotoBankPage() src=../../../assets/images/icons8-left-arrow-96.png alt=\"\" srcset=\"\" style=\"width: 20px;padding-top: 3px\"><div style=\"display: flex;justify-content: flex-start;flex-direction: column\"><p class=reviewFolioPage style=\"color: #244c8a;font-weight: 600;font-size: 22px\">Review Folio Details</p><p class=userName>{{SummaryPage.userData.panHolderName}}</p></div><p id=callModal ng-click=SummaryPage.getModal() style=\"display: none\"></p></div></div></div></div><div style=\"margin-left: 15px\"><!-- single self --><horizontal-progress-sidebar ng-if=\"!SummaryPage.folioDetails.minor && SummaryPage.folioDetails.holdmode == \'SINGLE\' \" steps=SummaryPage.stepperThird></horizontal-progress-sidebar><!-- any or survior self --><horizontal-progress-sidebar ng-if=\"!SummaryPage.folioDetails.minor && SummaryPage.folioDetails.holdmode == \'ANY_OR_SURVIVOR\' \" steps=SummaryPage.stepperForAnyoneSurvivor></horizontal-progress-sidebar><!-- minor --><horizontal-progress-sidebar ng-if=\"SummaryPage.folioDetails.minor && SummaryPage.folioDetails.holdmode == \'SINGLE\' \" steps=SummaryPage.stepperForMinor></horizontal-progress-sidebar></div><div><div class=modal-body style=\"margin-left: 15px\"><div class=row ng-if=!SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=form-content><!--<label><strong>Contact Details (Please submit physical request to update contact details in your\n                    KYC)</strong></label>--><div class=row><div class=col-md-5 style=\"margin-right: 40px\" ng-if=SummaryPage.soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : <span easyassist-key=mask-element>{{SummaryPage.soleApplicantEmail}}</span></label></div><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!SummaryPage.soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : Not available</label></div><!-- <div class=\"col-md-3 belongsToContainerMobile emailBelongsMobile\"\n                    style=\"display: inline-flex;  margin-right: 40px;\" ng-if=\"SummaryPage.soleApplicantEmail\">\n                    <div style=\"flex-shrink : 0;\">\n                        <label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span>\n                            : </label>\n                    </div>\n                    <div class=\"selectfield\" style=\"display: inline-block ; margin-left : 5px;\"\n                        ng-class=\"{error:soleApplicantForm.emailBelongsTo.$dirty && soleApplicantForm.emailBelongsTo.$invalid}\">\n                        <select class=\"browser-default custom-select\" name=\"emailBelongsTo\" style=\"width: 150px\"\n                            ng-model=\"holders.emailBelongsTo\"\n                            ng-init=\"holders.emailBelongsTo = holders.emailBelongsTo ? holders.emailBelongsTo: null\"\n                            ng-options=\"data.familyCode as data.familyDescription for data in belongToListEmail\" required>\n                            <option value=\"\" selected>Select Value</option>\n                        </select>\n                        <span class=\"req text-red\">*</span>\n                    </div>\n                </div>\n         --><div class=\"col-md-5 mLabel\" ng-if=SummaryPage.soleApplicantMobile><label style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : <span easyassist-key=mask-element>{{SummaryPage.soleApplicantMobile}}</span></label></div><div class=col-md-5 ng-if=!SummaryPage.soleApplicantMobile><label style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : Not available</label></div></div><div class=row style=\"margin-top: 15px\"><div class=\"col-md-5 belongsToContainerWeb\" style=\"display: inline-flex;  margin-right: 40px\" ng-if=SummaryPage.soleApplicantEmail><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> : {{SummaryPage.belongToListEmail}}</label></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!SummaryPage.soleApplicantEmail></div><div class=\"col-md-5 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=SummaryPage.soleApplicantMobile><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> :{{SummaryPage.belongToListMobile}}</label></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!SummaryPage.soleApplicantMobile></div></div></div></div><!-- sole details --><div class=row ng-if=!SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Sole Applicant Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotofolioBasic() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=row><p class=col-md-12 style=\"color: #497eac\">Income Details</p></div><div class=\"row m-top\"><div class=col-md-6><p>Tax Status</p></div><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription readonly><!-- <div class=\"col-md-6 bg-white\">\n                        <p style=\"font-weight: 100;\">{{SummaryPage.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription}}</p>\n                    </div> --></div><div class=\"row m-top\"><div class=col-md-6><p>Occupation</p></div><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.occupationData.occupationDescription readonly><!-- <div class=\"col-md-6 bg-white\">\n                        <p style=\"font-weight: 100;\">{{SummaryPage.occupationData.occupationDescription}}</p>\n                    </div> --></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorth><p class=col-md-6>Gross Annual Income</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.grossIncomeData.incomeDescription readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.grossIncomeData.incomeDescription}}</p> --></div><div class=\"row m-top\" ng-if=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorth><p class=col-md-6>Net Worth</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorth readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorth}} --><p></p></div><div class=\"row m-top\" ng-if=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorth><p class=col-md-6>Net Worth date</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorthDate readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorthDate}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=row><p class=col-md-12 style=\"color: #497eac\">FATCA and CRS Details</p></div><div class=\"row m-top\"><div class=col-md-6><p>Country of Birth</p></div><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.countryData.countryName readonly easyassist-key=mask-element><!-- <div class=\"col-md-6 bg-white\">\n                        <p style=\"font-weight: 100;\">{{SummaryPage.countryData.countryName}}</p>\n                    </div> --></div><div class=\"row m-top\"><p class=col-md-6>City of Birth</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.birthPlace readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.birthPlace}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Address of type</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.addressType readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.addressType}}</p> --></div></div><div class=\"col-xs-12 col-sm-7 col-md-4\"><div class=row><p class=col-md-12 style=\"color: #497eac\">Tax Details</p></div><div class=row ng-if=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.payTaxInIndia><p class=ml-15 style=\"font-weight: bold;color: #244b8c\">Tax Details not available</p></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.payTaxInIndia><p class=col-md-6>Tax Paying Country</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCountryDescription readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCountryDescription}}\n                    </p> --></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.payTaxInIndia><p class=col-md-6>Tax Paying City</p><p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCity readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCity}}</p> --></p></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.payTaxInIndia><p class=col-md-6>Tax Id</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxId readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxId}}</p> --></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.payTaxInIndia><p class=col-md-6>Tax ID type</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.taxIdDetails.description readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.taxIdDetails.description}}</p> --></div></div></div><!-- minor data --><div class=row ng-if=SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"color: #244b8c; font-weight: bold;font-size: 15px\">Minor Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoMinorBasic() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.personalDetail.firstName readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.personalDetail.firstName}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"row m-top\"><p class=col-md-6>DOB</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.personalDetail.dateOfBirth readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.personalDetail.dateOfBirth}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>DOB Proof</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.minorProofType readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.minorProofType}}</p> --></div></div></div><!-- Minor income details --><div class=row ng-if=SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Guardian\'s Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoMinorGuardian() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><p style=\"color: #244b8c\">Guardian\'s Income Details</p></div><div class=\"col-xs-12 col-sm-6 col-md-5\"><div class=\"row m-top\"><p class=col-md-6>Tax Status</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Occupation</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.occupationData.occupationDescription readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.occupationData.occupationDescription}}</p> --></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth><p class=col-md-6>Gross Annual Income</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.grossIncomeData.incomeDescription readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.grossIncomeData.incomeDescription}}</p> --></div><div class=\"row m-top\" ng-if=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth><p class=col-md-6>Net Worth</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth}}</p> --></div><div class=\"row m-top\" ng-if=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth><p class=col-md-6>Net Worth Date</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorthDate readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorthDate}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-5\"><div class=\"row m-top\"><p class=col-md-6>Political Exposed Person Status</p><input class=\"col-md-6 bg-white\" type=text ng-model=\"SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.politicalStatus == \'NONE\' ? \'Not Applicable\' : SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.politicalStatus\" readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.politicalStatus == \'NONE\' ? \'Not Applicable\' : SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.politicalStatus}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Relationship with Minor</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.relation readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.relation}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Relationship Proof</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.minorRelationshipProofType readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.minorRelationshipProofType}}</p> --></div></div></div><!-- Guardian\'s FATCA and CRS details --><div class=row ng-if=SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Guardian\'s FATCA and CRS information</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoMinorGuardian() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-12 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Country of Birth</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.countryData.countryName readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.countryData.countryName}}</p> --></div></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><div class=\"row m-top\"><p class=col-md-6>City of Birth</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace}}</p> --></div></div><div class=\"col-xs-12 col-sm-12 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Address of type</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.addressType readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.addressType}}</p> --></div></div></div><!-- Guardian\'s tax details --><div class=row ng-if=SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Guardian\'s Tax Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoMinorGuardian() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-if=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia><p class=ml-15 style=\"font-weight: bold;color: #244b8c\">Tax Details not available</p></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia><div class=\"row m-top\"><p class=col-md-3>Tax Paying Country</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCountryDescription readonly easyassist-key=mask-element><!-- <p class=\"col-md-3 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCountryDescription}} --><p></p></div><div class=\"row m-top\"><p class=col-md-3>Tax Paying City</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCity readonly easyassist-key=mask-element><!-- <p class=\"col-md-3 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCity}}\n                    </p> --></div><div class=\"row m-top\"><p class=col-md-3>Tax Id</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxId readonly easyassist-key=mask-element><!-- <p class=\"col-md-3 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxId}}</p> --></div><div class=\"row m-top\"><p class=col-md-3>Tax ID type</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.taxIdDetails.description readonly easyassist-key=mask-element><!-- <p class=\"col-md-3 bg-white\">{{SummaryPage.taxIdDetails.description}}</p> --></div></div></div><br><!-- Holder details --><div class=row ng-if=\"!SummaryPage.folioDetails.minor && SummaryPage.jointHoldersData.length > 0\" style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Holder Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoHolderPage() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-repeat=\"x in SummaryPage.jointHoldersData track by $index\"><!-- <p class=\"col-xs-12 col-sm-12 col-md-12\" style=\"font-weight: bold;\">Joint Holder {{$index + 1}} </p> --><div class=\"row m-top\"><p class=col-md-2>Holder\'s Name</p><p class=\"col-md-2 bg-white\">{{x.firstName}} {{x.lastName}}</p></div></div></div><!-- holder other details --><!-- <div class=\"row\" ng-If=\"!SummaryPage.folioDetails.minor && SummaryPage.jointHoldersData.length > 0\"\n            style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;\">\n            <div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between;\">\n                <p style=\"font-weight: bold;font-size: 15px;\">Holder Other Details</p>\n                <img src=\"../../../assets/images/icons/edit.png\" ng-click=\"SummaryPage.gotoHolderPage()\"\n                    style=\"height: 15px;cursor: pointer;\">\n            </div>\n            <div class=\"row\" ng-repeat=\"x in SummaryPage.jointHoldersData track by $index\">\n                <div class=\"row m-top\" style=\"margin-left: 15px;\">\n                    <p class=\"col-md-2\" style=\"color:#497eac;\n                    \">Holder\'s Name {{$index + 1}}</p>\n                    <p class=\"col-md-2 bg-white\">{{x.firstName}} {{x.lastName}}</p>\n                </div>\n                <div class=\"col-xs-12 col-sm-6 col-md-4\">\n                    <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                        <p style=\"color: #497eac;\">Income Details</p>\n                    </div>\n\n                    <div class=\"row m-top m-left-0\">\n                        <p class=\"col-md-6\">Tax Status</p>\n                        <p class=\"col-md-6 bg-white\">{{x.taxStatusDescription}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\">\n                        <p class=\"col-md-6\">Occupation</p>\n                        <p class=\"col-md-6 bg-white\">{{x.occupationDescription}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\" ng-If=\"!x.netWorth\">\n                        <p class=\"col-md-6\">Gross Annual Income</p>\n                        <p class=\"col-md-6 bg-white\">{{SummaryPage.holderIncomdeslab[$index].incomeDescription}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\" ng-If=\"x.netWorth\">\n                        <p class=\"col-md-6\">Net Worth</p>\n                        <p class=\"col-md-6 bg-white\">{{x.netWorth}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\" ng-If=\"x.netWorth\">\n                        <p class=\"col-md-6\">Net Worth Date</p>\n                        <p class=\"col-md-6 bg-white\">{{x.netWorthDate}}</p>\n                    </div>\n                </div>\n\n                <div class=\"col-xs-12 col-sm-12 col-md-4\">\n                <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                    <p style=\"color: #497eac;\">FATCA and CRS Details</p>\n                </div>\n                <div class=\"row m-top m-left-0\">\n                    <p class=\"col-md-6\">Country of Birth</p>\n                    <p class=\"col-md-6 bg-white\">{{SummaryPage.countryList[$index].countryName}}</p>\n                </div>\n                <div class=\"row m-top m-left-0\">\n                    <p class=\"col-md-6\">City of Birth</p>\n                    <p class=\"col-md-6 bg-white\">{{x.fatcaDetail.birthPlace}}</p>\n                </div>\n                <div class=\"row m-top m-left-0\">\n                    <p class=\"col-md-6\">Address of type</p>\n                    <p class=\"col-md-6 bg-white\">{{x.fatcaDetail.addressType}}</p>\n                </div>\n                </div>\n\n                <div class=\"col-xs-12 col-sm-6 col-md-4\">\n                    <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                        <p style=\"color: #497eac;\">Tax Details</p>\n                    </div>\n                    <div ng-If=\"SummaryPage.jointHoldersData[$index].fatcaDetail.payTaxInIndia\">\n                        <p>Tax Details not available</p>\n                    </div>\n\n                    <div ng-If=\"!SummaryPage.jointHoldersData[$index].fatcaDetail.payTaxInIndia\">\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax Paying Country</p>\n                            <p class=\"col-md-6 bg-white\">{{SummaryPage.jointHoldersData[$index].fatcaDetail.fatcaTax1.taxPayingCountryDescription}}</p>\n                        </div>\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax Paying City</p>\n                            <p class=\"col-md-6 bg-white\">{{SummaryPage.jointHoldersData[$index].fatcaDetail.fatcaTax1.taxPayingCity}}</p>\n                        </div>\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax Id</p>\n                            <p class=\"col-md-6 bg-white\">{{SummaryPage.jointHoldersData[$index].fatcaDetail.fatcaTax1.taxId}}</p>\n                        </div>\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax ID type</p>\n                            <p class=\"col-md-6 bg-white\">{{SummaryPage.taxIdTypeList[$index].description}}</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div> --><!-- Nominee details --><div class=row ng-if=\"SummaryPage.nomineeData.length > 0\" style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Nominee Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoNomineePage() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-12, col-md-12\"><div class=\"row new-investor-nominee-section\"><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-repeat=\"x in SummaryPage.nomineeData track by $index\"><div class=\"row m-top\"><p class=col-md-12 style=\"font-size: 14px; color: #497eac\">Nominee {{$index + 1}} Details</p></div><div class=\"row m-top\"><p class=col-md-6>Nominee Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.nomineeName readonly><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeName}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Nominee Relation</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.nomineeRelation readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeRelation}}</p> --></div><div class=\"row m-top\" ng-if=x.emailId><p class=col-md-6>Nominee Email Id</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.emailId readonly easyassist-key=mask-element></div><div class=\"row m-top\" ng-if=x.mobileNumber><p class=col-md-6>Nominee Mobile No.</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.mobileNumber readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeRelation}}</p> --></div><div class=\"row m-top\" ng-if=x.dob><p class=col-md-6>Nominee DOB</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.dob readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{x.dob}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>The Nominee is Minor</p><div class=col-md-6><input type=checkbox type=checkbox ng-model=x.minor disabled></div></div><div class=\"row m-top\"><p class=col-md-6>Nominee Percentage</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.percentage readonly><!-- <p class=\"col-md-6 bg-white\">{{x.percentage}}</p> --></div><div class=\"row m-top\" ng-if=x.identityProofType><p class=col-md-6>Nominee Personal Identifier</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.identityProofDescription readonly easyassist-key=mask-element></div><div class=\"row m-top\" ng-if=\"x.identityProofNumber && SummaryPage.folioDetails.sebiNomineeRegulatory01650Active\"><p class=col-md-6 ng-if=\"x.identityProofType === \'AADHAR_CARD\'\">Nominee Aadhar Card</p><p class=col-md-6 ng-if=\"x.identityProofType === \'DRIVING_LICENSE\'\">Nominee Driving License</p><p class=col-md-6 ng-if=\"x.identityProofType === \'PAN_CARD\'\">Nominee Pan</p><p class=col-md-6 ng-if=\"x.identityProofType === \'PASSPORT\'\">Nominee Passport</p><div class=\"col-md-6 p-0\"><span class=\"arn aadhar-investor\" ng-if=\"x.identityProofType === \'AADHAR_CARD\'\">XXXX XXXX </span><input class=\"col-md-12 bg-white\" type=text ng-class=\"{\'aadhar-field\': x.identityProofType === \'AADHAR_CARD\'}\" ng-model=x.identityProofNumber readonly easyassist-key=mask-element></div></div><div class=\"row m-top\" ng-if=\"x.panNumber && !SummaryPage.folioDetails.sebiNomineeRegulatory01650Active\"><p class=col-md-6>Nominee Pan</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.panNumber readonly easyassist-key=mask-element></div><div class=\"row m-top\" ng-if=x.guardianPanNumber><p class=col-md-6>Guardian Pan</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.guardianPanNumber readonly easyassist-key=mask-element></div><div class=\"row m-top\" ng-if=SummaryPage.gAddress[$index]><p class=col-md-6>Guardian\'s Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.guardianName readonly><!-- <p class=\"col-md-6 bg-white\">{{x.guardianName}}</p> --></div><div class=\"row m-top\" ng-if=SummaryPage.addressLine1[$index]><p class=col-md-6 ng-if=SummaryPage.gAddress[$index]>Guardian\'s Address Line1</p><p class=col-md-6 ng-if=!SummaryPage.gAddress[$index]>Nominee\'s Address Line1</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.addressLine1[$index] readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.addressLine1[$index]}}</p> --></div><div class=\"row m-top\" ng-if=SummaryPage.addressLine2[$index]><p class=col-md-6 ng-if=SummaryPage.gAddress[$index]>Guardian\'s Address Line2</p><p class=col-md-6 ng-if=!SummaryPage.gAddress[$index]>Nominee\'s Address Line2</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.addressLine2[$index] readonly easyassist-key=mask-element></div><div class=\"row m-top\" ng-if=\"SummaryPage.nomineeCountry[$index] && SummaryPage.nomineeCountry[$index].countryName\"><p class=col-md-6 ng-if=SummaryPage.gAddress[$index]>Guardian\'s Country</p><p class=col-md-6 ng-if=!SummaryPage.gAddress[$index]>Nominee\'s Country</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.nomineeCountry[$index].countryName readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.nomineeCountry[$index].countryName}}</p> --></div><div class=\"row m-top\" ng-if=\"(x.nomineeAddress && x.nomineeAddress.city) || (x.guardianAddress && x.guardianAddress.city)\"><p class=col-md-6 ng-if=SummaryPage.gAddress[$index]>Guardian\'s City</p><p class=col-md-6 ng-if=!SummaryPage.gAddress[$index]>Nominee\'s City</p><input class=\"col-md-6 bg-white\" type=text ng-if=\"x.nomineeAddress && x.nomineeAddress.city\" ng-model=x.nomineeAddress.city readonly easyassist-key=mask-element> <input class=\"col-md-6 bg-white\" type=text ng-if=\"x.guardianAddress && x.guardianAddress.city\" ng-model=x.guardianAddress.city readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeAddress.city ? x.nomineeAddress.city : x.guardianAddress.city }}</p> --></div><div class=\"row m-top\" ng-if=x.nomineeAddress.pinCode><p class=col-md-6>Nominee PinCode</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.nomineeAddress.pinCode readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeAddress.pinCode}}</p> --></div><div class=\"row m-top\" ng-if=x.guardianAddress.pinCode><p class=col-md-6>Nominee PinCode</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.guardianAddress.pinCode readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{x.guardianAddress.pinCode}}</p> --></div></div></div></div><div class=\"col-xs-12 col-sm-12, col-md-12\" ng-if=SummaryPage.folioDetails.sebiNomineeRegulatory01650Active><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-if=SummaryPage.folioDetails.nomineeRegistrationCO.incapacitationDeclaration><div class=\"row m-top\"><p class=col-md-12 style=\"font-size: 14px; color: #497eac\">Incapacitation Details</p></div><div class=\"row m-top\"><p class=col-md-6>Nominee Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.nomineeRegistrationCO.incapacitationDeclaration.nomineeName readonly></div><div class=\"row m-top\"><p class=col-md-6>Encash Assets Upto</p><input class=\"col-md-6 bg-white\" type=text ng-if=SummaryPage.folioDetails.nomineeRegistrationCO.incapacitationDeclaration.percentage ng-model=SummaryPage.folioDetails.nomineeRegistrationCO.incapacitationDeclaration.percentage readonly easyassist-key=mask-element> <input class=\"col-md-6 bg-white\" type=text ng-if=SummaryPage.folioDetails.nomineeRegistrationCO.incapacitationDeclaration.amount ng-model=SummaryPage.folioDetails.nomineeRegistrationCO.incapacitationDeclaration.amount readonly easyassist-key=mask-element></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-if=SummaryPage.folioDetails.nomineeRegistrationCO.accountHoldingDeclaration><div class=\"row m-top\"><p class=col-md-12 style=\"font-size: 14px; color: #497eac\">Statement of Holding</p></div><div class=\"row m-top\"><p class=col-md-6>{{SummaryPage.folioDetails.nomineeRegistrationCO.accountHoldingDeclaration === \'NOMINATION_YES\' ? \'Nomination: Yes\': \'Nomination: No\'}}</p></div></div></div></div></div><!-- bank details  --><div class=row style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Bank Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoBankPage() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Bank Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.bankDetails.bankName readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.bankDetails.bankName}}</p> --></div><div class=\"row m-top\"><p class=\"col-md-6 m-top\">Account Type</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.bank.accountType readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.bank.accountType}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Payout Mechanism</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.payoutDescriptionData.payoutDescription readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.payoutDescriptionData.payoutDescription}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Account Number</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.bankDetails.accountNumber readonly easyassist-key=mask-element><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.bankDetails.accountNumber}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>IFSC Code</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.bankDetails.ifsccode readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.bankDetails.ifsccode}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Branch Location</p><textarea class=\"col-md-6 bg-white textAreaSize\" rows=4 type=text style=\"height: 72PX\" ng-model=SummaryPage.folioDetails.bankDetails.bankBranch readonly> </textarea><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.bankDetails.bankBranch}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Branch City</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.bankDetails.bankCity readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.bankDetails.bankCity}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Cheque leaf Image</p><div class=\"col-md-6 bg-white minbg\" style=\"display: flex;justify-content: space-between;align-items: center\"><p class=ml-15 style=\"font-weight: 100;line-height: 12px\">Cheque leaf Image</p><img src=../../../../assets/images/icons/ic-img.png ng-click=SummaryPage.openUploadedDoc(SummaryPage.folioDetails.bankDetails.chequeLeaf) alt=\"\" style=\"height: 15px\"></div></div></div></div></div><div class=\"modal-footer center-aligned\"><!-- <button class=\"btn btn-primary-action\" style=\"border-radius: 40px;\" ng-click=\"SummaryPage.backpage()\"> Back\n        </button> --> <button class=btn style=\"border-radius: 40px; padding: 0px;border: none; padding-left: 25px;padding-right: 25px;height: 35px; background-color: #ff5153;color:white\" ng-click=SummaryPage.createNewFolio()>Submit</button></div></div><style>@import url( ../../../../assets/fonts/proximanova-bold.otf);\n@import url( ../../../../assets/fonts/proximanova-regular.otf);\n    p {\n        line-height: 30px;\n        font-size: 12px;\n        font-weight: 600;\n        font-family: \"proximanova-bold\", sans-serif !important;\n    }\n\n    .m-left-0 {\n        margin-left: 0px;\n    }\n\n    .m-top {\n        margin-top: 5px;\n    }\n    input{\n        font-size: 14px;\n        font-weight: 400;\n        font-family: \"proximanova-bold\", sans-serif !important;\n        color: #444444;\n        border-radius: 0.25rem;\n        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    }\n    .bg-white {\n        font-family: \"proximanova-bold\", sans-serif !important;\n        color: #444444;\n        background-color: white;\n        font-size: 13px;\n        text-align: start;\n        border-radius: 6px;\n        padding: 0px;\n        margin: 0px;\n        font-weight: 100;\n        border-radius: 0.25rem;\n        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n        height: 30px;\n        border: 1px solid lightgray;\n        padding-left: 5px;\n    }\n    .userName{\n        font-family: \"proximanova-regular\",sans-serif;\n  font-weight: 400;\n  opacity: 0.7;\n  font-size: 15px;\n    }\n    @media screen and (max-width: 990px) {\n    .minbg{\n        width: 177px;\n    }\n    p{\n        margin-left: -15px;\n    }\n    .ml-15{\n        margin-left: 0px;\n    }\n  }\n\n\n  @media only screen and (max-device-width : 1008px) {\n    .reviewFolioPage{\n    margin-left: 5px;\n    }\n  }\n  @media only screen and (min-device-width : 768px) and (max-device-width : 768px) {\n    .hdfc-blue-cta-small{\n      width: 163px !important;\n    }\n    .btn{\n        width: 163px;\n    }\n  .stepper-horizontal-responsive .step li {\n       z-index: 5;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(2){\n    z-index: 4;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(3){\n    z-index: 3;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(4){\n    z-index: 2;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(5){\n    z-index: 1;\n  }\n}</style>");
$templateCache.put("app/new-investors/investment-details/amount-details/amount-details.html","<div class=container-fluid ng-init=AmountDetails.init()><form class=verification-form autocomplete=off id=amountDetailsForm name=amountDetailsForm ng-if=!AmountDetails.PaymentModePurchse><!-- amount --><div class=row><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>Amount</p></div><div class=\"form-group col-xs-12 col-md-6 input-normal\" ng-class=\"{error:amountDetailsForm.anAmount.$dirty && amountDetailsForm.anAmount.$invalid}\" style=\"margin-bottom: 5px\"><div class=\"input-icons w-336\"><img class=ricon src=../../../../assets/images/rupee.svg alt=\"\" srcset=\"\" style=\"padding: 0 0 0 0\"> <input class=\"form-control input-border-line\" type=number onkeyup=\"NumToWord(this.value,\'newJournyDivDisplayWords\')\" id=amt ignore-mouse-wheel name=anAmount ng-model=AmountDetails.formData.amount ng-change=AmountDetails.checkSipValidations(); autofocus required style=\"height: 40px;width: 336px;padding: 0px 0px 0px 28px\"></div><span class=error-input ng-show=\"(amountDetailsForm.anAmount.$dirty && amountDetailsForm.anAmount.$error.required)\">&nbsp;&nbsp; Amount is required</span> <span ng-if=\"AmountDetails.formData.amount && AmountDetails.isMin\" class=error-input>Minimum amount should be &#8377; {{AmountDetails.validations.minAmount|unit}}</span> <span ng-if=\"AmountDetails.formData.amount && AmountDetails.isMax\" class=error-input>Maximum amount should be &#8377; {{AmountDetails.validations.maxAmount|unit}}</span> <span ng-if=\"AmountDetails.formData.amount && !AmountDetails.isMax && !AmountDetails.isMin && (AmountDetails.validations.amountMultiples && !AmountDetails.isMultiples) && !AmountDetails.amountExceeded\" class=error-input>Please Provide In multiples of &#8377; {{AmountDetails.validations.amountMultiples|unit}}</span><div class=error-input ng-if=\"amountDetailsForm.anAmount.$dirty && AmountDetails.formData.sipPaymentOption !== \'E-mandate\' && AmountDetails.amountExceeded\">{{AmountDetails.VALIDATE_DATA.AMOUNT_EXCEEDED}}</div><span><div class=row><div class=\"maxDiv col-xs-4 col-md-4 mt-2\" ng-repeat=\"arrayAmount in AmountDetails.formData.amountArray\"><button class=amountBtn style=\"border:1px solid #b7b7b7\" type=button ng-click=AmountDetails.getAmount(false,arrayAmount)>&#8377;{{arrayAmount}}</button></div></div></span></div><!-- <div class=\"col-xs-12 col-md-4\" >\n        <div class=\"warning\">\n          <img src=\"../../../assets/images/icons/light-bulb.png\">\n          <div><br>Minimum investment amount is 5000</div>\n        </div>\n      </div> --></div><div class=row><div class=\"col-xs-12 col-md-4 mt-2\"><label id=newJournyDivDisplayWords>{{AmountDetails.amountInWords}} (In Words)</label></div></div><!-- <div class=\"row\">\n      <div class=\"col-xs-4 col-md-1\" ng-repeat=\"arrayAmount in AmountDetails.formData.amountArray\">\n        <button class=\"amountBtn\" style=\"border:1px solid #b7b7b7\" type=\"button\"\n          ng-click=\"AmountDetails.getAmount(arrayAmount)\">&#8377;{{arrayAmount}}</button>\n      </div>\n    </div> --><br><br><!-- installment --><div><div class=row><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>Installment Frequency</p></div><div class=\"col-xs-12 col-md-10\"><div class=\"row extrawidth\" style=\"margin-left: 2px\"><p ng-click=AmountDetails.changeFrequency(AmountDetails.frequencyData[0]) ng-attr-class=\"{{AmountDetails.SelectedFrequency.name == \'Monthly\' ? \'btn-active1 first-btn m-btn1 col-xs-3 col-md-2\' : \'btn-deactive1 m-btn1 first-btn col-xs-3 col-md-2\' }}\"><span style=\"margin: auto;font-weight: 500\" role=button>Monthly</span></p><p ng-click=AmountDetails.changeFrequency(AmountDetails.frequencyData[1]) ng-attr-class=\"{{AmountDetails.SelectedFrequency.name == \'Quarterly\' ? \'btn-active1 m-btn2 col-xs-3 col-md-2\' : \'btn-deactive1 m-btn2 col-xs-3 col-md-2\' }}\"><span style=\"margin: auto;font-weight: 500\" role=button>Quarterly</span></p><p ng-click=AmountDetails.changeFrequency(AmountDetails.frequencyData[2]) ng-attr-class=\"{{AmountDetails.SelectedFrequency.name == \'Half Yearly\' ? \'btn-active1 m-btn3 col-xs-3 col-md-2\' : \'btn-deactive1  m-btn3 col-xs-3 col-md-2\' }}\"><span style=\"margin: auto;font-weight: 500\" role=button>Half Yearly</span></p><p ng-click=AmountDetails.changeFrequency(AmountDetails.frequencyData[3]) ng-attr-class=\"{{AmountDetails.SelectedFrequency.name == \'Yearly\' ? \'btn-active1 last-btn m-btn4 col-xs-3 col-md-2\' : \'btn-deactive1 last-btn m-btn4 col-xs-3 col-md-2\' }}\"><span style=\"margin: auto;font-weight: 500\" role=button>Yearly</span></p></div></div></div><br><!-- IDCW --><div class=radio-block ng-if=\"AmountDetails.formData.investmentOption.toUpperCase() != \'GROWTH\' \" style=\"margin-bottom: 20px\"><p class=investmentTitle>Investment option</p><div class=radio-block><span class=radio><input type=radio id=reInvest name=idcw ng-change=\"\" ng-model=AmountDetails.dividenInevstmentOption value=Y> <span class=check></span> </span>&nbsp; Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option<br><span class=radio><input type=radio id=Payout name=idcw ng-change=\"\" ng-model=AmountDetails.dividenInevstmentOption value=N> <span class=check></span> </span>&nbsp; Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</div></div><!-- IDCW END --><div class=row><ng-bind-html dynamic=AmountDetails.dynamicNoteSip.noteDTO.noteDTOMap.Note_SIP.content class=col-md-12></ng-bind-html></div><!-- Payment Options --><div><div class=\"col-md-12 p-0\" style=\"margin-bottom: 12px\"><label class=form-label style=\"font-weight: bold\">Do you wish to pay First installment with your SIP Registration:</label><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=AmountDetails.sipFirstInstallment ng-change=AmountDetails.changeFirstInstallment(true) ng-value=true ng-disabled=AmountDetails.distributorDetails.isHdfcBank> <span class=check></span> </span><span class=radio-label>Yes</span></div><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=AmountDetails.sipFirstInstallment ng-change=AmountDetails.changeFirstInstallment(false) ng-value=false> <span class=check></span> </span><span class=radio-label>No</span></div></div><br></div><!-- Payment Options --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=\"investmentTitle form-label\">Payment Options</p><div class=\"col-md-12 form-group\" ng-if=\"AmountDetails.formData.frequency!=\'BZ\'\"><div class=radio-block ng-repeat=\"_option in AmountDetails.paymentOptions \"><span class=radio ng-hide=\"(AmountDetails.sipFirstInstallment && _option == \'E-mandate\') || (AmountDetails.nriFlag && _option == \'E-mandate\')\"><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-change=AmountDetails.changedPaymentOption() ng-model=AmountDetails.formData.sipPaymentOption> <span class=check></span> </span><span class=radio-label ng-hide=\"(AmountDetails.sipFirstInstallment && _option == \'E-mandate\') || (AmountDetails.nriFlag && _option == \'E-mandate\') \">{{AmountDetails.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div class=col-md-6 ng-if=\"AmountDetails.formData.sipPaymentOption == \'E-mandate\' \"><div><p class=investmentTitle>Select Bank</p></div><div class=selectfield ng-class=\"{error:amountDetailsForm.bank.$dirty && amountDetailsForm.bank.$invalid}\"><!-- <select class=\"\" name=\"bank\" ng-disabled=\"false\" class=\"getbank\" id=\"selectbank\"\n              ng-model=\"AmountDetails.formData.bankInfo\"\n              ng-options=\"bank.bankName for bank in AmountDetails.bankList track by bank.bankCode\"\n              ng-change=\"AmountDetails.changeBank()\"\n              ng-init=\"AmountDetails.formData.bankInfo = AmountDetails.formData.bankInfo ? AmountDetails.formData.bankInfo : null\"\n              required> --><select name=bank ng-disabled=false class=getbank id=selectbank ng-model=AmountDetails.formData.bankInfo ng-change=AmountDetails.changeBank() required><option value selected>Select Bank</option><option ng-repeat=\"value in AmountDetails.bankList\" ng-selected=\"AmountDetails.formData.bankInfo == value\" value={{value}}>{{value.bankName}}</option></select><span class=error-input ng-show=\"amountDetailsForm.bank.$dirty && amountDetailsForm.bank.$error.required && !AmountDetails.formData.bankName\" ng-bind=AmountDetails.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><div class=row><div style=\"padding-top: 15px\" class=col-md-6 ng-if=\"AmountDetails.formData.sipPaymentOption == \'UPI\' \"><div><p class=investmentTitle>Select Bank</p></div><div class=selectfield ng-class=\"{error:amountDetailsForm.bank.$dirty && amountDetailsForm.bank.$invalid}\"><select name=bank ng-disabled=false ng-model=AmountDetails.formData.bankInfo ng-init=\"AmountDetails.formData.bankInfo=AmountDetails.formData.bankInfo ? AmountDetails.formData.bankInfo : null\" ng-options=\"bank.bankName for bank in AmountDetails.bankList track by bank.bankName\" ng-change=AmountDetails.selectedUpiBank() required><option value=\"\" selected>{{AmountDetails.bankList&&!AmountDetails.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><span class=error-input ng-show=\"amountDetailsForm.bank.$dirty && amountDetailsForm.bank.$error.required && !AmountDetails.formData.bankName\" ng-bind=AmountDetails.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><!--      UPI Payment start--><div class=row ng-if=\"AmountDetails.formData.bankInfo && AmountDetails.formData.sipPaymentOption == \'UPI\'\" style=\"padding-top: 15px;padding-bottom: 15px\"><div class=col-md-6><div><p class=investmentTitle>Virtual Payment Address (UPI ID)</p></div><div ng-class=\"{error:amountDetailsForm.ifscCode.$dirty && amountDetailsForm.ifscCode.$invalid}\" style=\"margin-bottom: 5px\"><div style=\"position: relative\"><input style=\"text-transform: lowercase\" class=\"form-control inputNormal\" type=text ng-model=AmountDetails.formData.bankInfo.virtualAddress name=virtualAddress ng-pattern=AmountDetails.PATTERN.upi_virtual_addr_regex ng-change=AmountDetails.handleVpa() required ng-readonly=\"AmountDetails.isUPIVerified && AmountDetails.verifyUPIResp.valid === true\"><label style=\"display: block;width: 100%\"><i class=edit-icon ng-if=\"AmountDetails.isUPIVerified && AmountDetails.verifyUPIResp.valid === true\" style=\"position: absolute;left: 304px; top:13px; pointer-events: all; box-sizing: content-box\" ng-click=\"AmountDetails.isUPIVerified = false\"></i></label><span class=error-input ng-show=amountDetailsForm.virtualAddress.$dirty&&(amountDetailsForm.virtualAddress.$error.required||amountDetailsForm.virtualAddress.$error.pattern) ng-bind=AmountDetails.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!amountDetailsForm.virtualAddress.$invalid\n                  &&  (!AmountDetails.isUPIVerified && AmountDetails.verifyUPIResp.valid === false)\" ng-bind=AmountDetails.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span></div></div></div><div class=col-md-6 ng-if=\"AmountDetails.formData.sipPaymentOption==\'UPI\'\"><div class=\"col-xs-12 col-md-6\" style=\"padding-top: 24px\" ng-if=!AmountDetails.isUPIVerified><button class=\"btn-new-journey-color hdfc-blue-cta-small\" blur-on-click class=\"btn btn-primary-action\" ng-disabled=\"!AmountDetails.formData.bankInfo.virtualAddress || (!AmountDetails.bankInfo.minorBankFlag && AmountDetails.checkForMinorBankListCondition())\" ng-click=AmountDetails.verifyUPI()>Verify</button></div><div class=\"col-md-6 verify-vpa verify-ack-padding\" style=\"padding-top: 14px\" ng-if=\"AmountDetails.isUPIVerified && AmountDetails.verifyUPIResp.valid === true\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{AmountDetails.name}}</span></div><div class=\"col-md-6 verify-vpa verify-ack-padding\" style=\"padding-top: 24px\" ng-if=\"!AmountDetails.isUPIVerified && AmountDetails.verifyUPIResp.valid === false\"><p><strong><span class=error-input style=\"display:inline;font-size:100%;margin-bottom: 20px\">Not Verified</span> <i class=\"cancel-icon error-input\"></i></strong></p></div></div></div><!--      <ng-bind-html ng-if=\"AmountDetails.formData.sipPaymentOption == \'EC\'\"--><!--                    dynamic=\"AmountDetails.dynamicNoteSip.noteDTO.noteDTOMap.Note_SIP_SI.content\"--><!--      >--><!--      </ng-bind-html>--><ng-bind-html ng-if=\"AmountDetails.formData.sipPaymentOption == \'E-mandate\'\" dynamic=AmountDetails.dynamicNoteSip.noteDTO.noteDTOMap.Note_SIP_eOTM.content class=col-md-12></ng-bind-html><ng-bind-html ng-if=\"AmountDetails.formData.sipPaymentOption == \'UPI\' && !AmountDetails.sipFirstInstallment\" dynamic=AmountDetails.dynamicNoteSip.noteDTO.noteDTOMap.Note_SIP_UPI.content class=col-md-12></ng-bind-html><ng-bind-html ng-if=\"AmountDetails.formData.sipPaymentOption == \'UPI\' && AmountDetails.sipFirstInstallment\" dynamic=AmountDetails.dynamicNoteSip.noteDTO.noteDTOMap.Note_SIP_FI_UPI.content></ng-bind-html><!--      UPI Payment ends--><!-- Select Bank End--><!-- Start Dates --><div><div class=\"col-md-12 p-0\"><p class=\"investmentTitle form-label\" style=\"font-weight: bold\">Start Date :</p><div class=\"w-336 verify-acc input-group date date date-picker transaction-cal\" ng-class=\"{error:amountDetailsForm.startDate.$dirty && amountDetailsForm.startDate.$invalid}\" date-calendar data-viewmode={{AmountDetails.viewMode}} data-date-default=AmountDetails.formData.startDate data-enabled-dates=AmountDetails.enabledStartDates data-min-date=AmountDetails.startMinDateOTM data-max-date=AmountDetails.startMaxDate data-on-date-change=AmountDetails.changeStartDate format=DD-MMM-YYYY id=weeklyStartDate data-enable=true style=\"position: relative\"><input type=text name=startDate id=startDate placeholder=\"Start Date - DD-MMM-YYYY\" style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #B8C6D1;border-radius: 5px\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=AmountDetails.amountDetailsForm.startDate>Start Date - DD-MMM-YYYY</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=amountDetailsForm.startDate.$error.required ng-bind=AmountDetails.VALIDATE_DATA.START_DATE_REQUIRED></span> <span class=error-input ng-show=amountDetailsForm.isOTMStartDate ng-bind=\"AmountDetails.VALIDATE_DATA.DATE_SIP_VALIDATION_ERROR + \' \' + AmountDetails.bankInfo.omStartDate\"></span></div></div></div><div><div class=\"col-md-12 p-0\"><p class=investmentTitle>End Date :</p><div class=\"w-336 verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:amountDetailsForm.endDate.$dirty && amountDetailsForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=AmountDetails.formData.endDate data-on-date-change=AmountDetails.changeEndDate data-enabled-dates=AmountDetails.enabledEndDates data-view-date=AmountDetails.enabledEndDateView data-min-date=AmountDetails.enabledEndDates[0] data-max-date=\"AmountDetails.enabledEndDates[AmountDetails.enabledEndDates.length - 1]\" ng-disabled=AmountDetails.formData.startDate data-enable=true id=weeklyEndDate showdefault=false><input type=text name=endDate id=endDate ng-keyup=AmountDetails.autoDate2() autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" required style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #B8C6D1;border-radius: 5px\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span><!-- <label ng-if=\"AmountDetails.formData.endDate\">End Date - DD-MMM-YYYY</label> --> <span class=bar></span> <span class=error-input ng-show=\"amountDetailsForm.endDate.$dirty && amountDetailsForm.endDate.$error.required\" ng-bind=AmountDetails.VALIDATE_DATA.END_DATE_REQUIRED></span> <span class=error-input ng-show=AmountDetails.isOTMEndDate ng-bind=AmountDetails.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div><div ng-if=\"AmountDetails.formData.sipPaymentOption != \'E-mandate\' && AmountDetails.formData.sipPaymentOption != \'UPI\'\"><input type=checkbox class=\"nomineeCheckbox col-xs-12 col-md-1\" name=defaultdate id=defaultdate ng-model=AmountDetails.formData.isTillPerpetuity ng-change=AmountDetails.changeTillPerpetuityFlag()><label class=\"confirmationnote col-xs-12 col-md-7\" for=defaultdate style=\"font-size: 13px;font-weight: bold;width: auto\">Default date shall be Dec-2099</label></div><br></div></div><!-- End Dates --><div ng-if=\"AmountDetails.formData.showTopUpBlock && !AmountDetails.sipFirstInstallment\" style=\"margin:15px 0px 0px -10px\"><div class=col-md-12><label class=\"form-label less\" style=\"font-weight: bold;font-size: 12px\">SIP Top-up Details</label></div><div class=\"col-md-12 form-group\" ng-if=!AmountDetails.isReseting><span class=checkbox style=\"bottom: -3px\"></span> <input type=checkbox class=nomineeCheckbox id=sipToptup ng-model=AmountDetails.formData.sipTopupEnabled ng-change=AmountDetails.changeSipTopupSelected(AmountDetails.formData.sipTopupEnabled)><label class=confirmationnote for=sipToptup style=\"margin-left: 2px;font-size: 12px; font-weight: 600\">SIP Top-up</label></div><!-- <div ng-if=\"AmountDetails.formData.sipTopupSelected\"> --><div class=col-md-12 ng-if=AmountDetails.formData.sipTopupEnabled style=\"padding: 0px\"><div ng-class=\"{\'anything-disabled\': !AmountDetails.formData.sipTopupSelected }\" class=col-md-12><div><div class=row><div class=\"col-xs-12 col-sm-5 col-md-4 topUpdiv30\"><p class=investmentTitle>Amount :</p><div class=\"input-normal icon-input\" ng-class=\"{error:(AmountDetails.tForm.topupAmount.$invalid && AmountDetails.tForm.topupAmount.$dirty),\'has-data\':AmountDetails.formData.topupDetails.amount}\"><input class=\"form-control input-border-line\" type=number ignore-mouse-wheel name=topupAmount ng-model=AmountDetails.formData.topupDetails.amount ng-disabled=AmountDetails.formData.topupDetails.percentage ng-change=AmountDetails.checkSipValidations(true);AmountDetails.getTopupFrequencyList(); onkeyup=\"NumToWord(this.value,\'divDisplayInWords\')\" ng-required=\"AmountDetails.formData.sipTopupEnabled && ((!AmountDetails.formData.topupDetails.percentage && !AmountDetails.formData.topupDetails.amount) || !AmountDetails.formData.topupDetails.percentage)\" style=\"border: none;border: 1px solid gray;border-radius: 5px;height: 40px;width: 100%\"> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i> <span class=error-input ng-show=\"AmountDetails.tForm.topupAmount.$dirty && AmountDetails.tForm.topupAmount.$error.required\" ng-bind=AmountDetails.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"AmountDetails.formData.topupDetails.amount && AmountDetails.isTopupMinAmt\" class=error-input>Minimum amount should be &#8377; {{AmountDetails.validations.topupMinAmt|unit}}</span> <span ng-if=\"AmountDetails.formData.topupDetails.amount  && !AmountDetails.isTopupMinAmt && (AmountDetails.validations.topupAmtMultples&&!AmountDetails.isTopUpMultiples)\" class=error-input>Please provide In multiples of &#8377; {{AmountDetails.validations.topupAmtMultples|unit}}</span></div></div><div class=\"col-sm-2 col-md-1 or-part text-center topUpdiv10\" ng-if=AmountDetails.showTopUpPercentage>OR</div><div class=\"col-xs-12 col-sm-5 col-md-4 topUpdiv30\" ng-if=AmountDetails.showTopUpPercentage><p class=investmentTitle>Percentage (%) :</p><div class=input-normal ng-class=\"{error:(AmountDetails.tForm.topupPercentage.$invalid && AmountDetails.tForm.topupPercentage.$dirty),\'has-data\':AmountDetails.formData.topupPercentage}\"><input class=\"form-control input-border-line\" type=number ignore-mouse-wheel name=topupPercentage ng-model=AmountDetails.formData.topupDetails.percentage ng-disabled=AmountDetails.formData.topupDetails.amount ng-change=AmountDetails.checkSipValidations();AmountDetails.getTopupFrequencyList();AmountDetails.changeTopUpFreq() ng-required=\"AmountDetails.formData.sipTopupEnabled && ((!AmountDetails.formData.topupDetails.percentage && !AmountDetails.formData.topupDetails.amount) || !AmountDetails.formData.topupDetails.amount)\" style=\"width: 100%;\n                      height: 40px;\n                  border: none;border-radius: 5px;border: 1px solid gray\"> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"AmountDetails.tForm.topupPercentage.$dirty && AmountDetails.tForm.topupPercentage.$error.required\" ng-bind=AmountDetails.VALIDATE_DATA.PERCENT_REQUIRED></span> <span ng-if=\"AmountDetails.formData.topupDetails.percentage && AmountDetails.isTopupMinPerc\" class=error-input>Minimum percentage should be {{AmountDetails.validations.topupMinPercentage|unit}}%</span> <span ng-if=\"AmountDetails.formData.topupDetails.percentage && !AmountDetails.isTopupMinPerc && (AmountDetails.validations.topupPercentageMultples&&!AmountDetails.isTopupPercMultiples)\" class=error-input>Please provide in multiple of {{AmountDetails.validations.topupPercentageMultples|unit}}%</span></div></div></div><div class=row><div class=col-md-12><label class=\"form-label less\" style=\"font-weight: bold;margin-bottom: 5px\">Frequency</label></div></div><div class=row><div class=\"col-md-5 form-group\"><div class=radio-block ng-repeat=\"freq in AmountDetails.topupFrequencyList\"><span class=radio><input type=radio ng-model=AmountDetails.formData.topupDetails.frequency ng-value=freq.key name=topupFrequency ng-change=AmountDetails.changeTopUpFreq()> <span class=check></span> </span><span class=radio-label>{{freq.value}}</span></div></div></div><div class=row><div class=col-md-12><label class=\"form-label less\" style=\"font-weight: bold;margin: 5px 0px 5px 0px\">SIP Top-up CAP</label></div></div><div class=row><div class=\"col-xs-12 col-sm-5 col-md-4 topUpdiv30\"><p class=investmentTitle>Amount :</p><div class=\"input-normal icon-input\" ng-class=\"{error:(AmountDetails.tForm.capAmount.$invalid && AmountDetails.tForm.capAmount.$dirty && AmountDetails.isminCapAmount),\'has-data\':AmountDetails.formData.capAmount}\"><input class=\"form-control input-border-line\" type=number ignore-mouse-wheel name=capAmount ng-model=AmountDetails.formData.topupDetails.capAmount ng-disabled=AmountDetails.formData.topupDetails.capMonthYear onkeyup=\"NumToWord(this.value,\'capAmntDisplayInWords\')\" ng-change=AmountDetails.capAmountChanged(); ng-required=\"AmountDetails.formData.sipTopupEnabled && ((!AmountDetails.formData.topupDetails.capAmount && !AmountDetails.formData.topupDetails.capMonthYear) || !AmountDetails.formData.topupDetails.capMonthYear)\" style=\"border: none;border: 1px solid gray;border-radius: 5px;height: 40px;width: 100%\"> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i> <span class=error-input ng-show=\"AmountDetails.tForm.capAmount.$dirty && AmountDetails.tForm.capAmount.$error.required\" ng-bind=AmountDetails.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"AmountDetails.formData.topupDetails.capAmount && AmountDetails.isminCapAmount\" class=error-input>Minimum amount should be &#8377; {{AmountDetails.minCapAmount}}</span></div></div><div class=\"col-sm-2 col-md-1 or-part text-center topUpdiv10\">OR</div><div class=\"col-xs-12 col-sm-5 col-md-4 topUpdiv30\"><p class=investmentTitle>Cap Month Year - MM/YYYY :</p><div><div class=selectfield><select class=\"browser-default custom-select\" name=capDates ng-disabled=AmountDetails.formData.topupDetails.capAmount ng-options=\"_dates for _dates in AmountDetails.capDates\" ng-model=AmountDetails.formData.topupDetails.capMonthYear ng-init=\"AmountDetails.formData.topupDetails.capMonthYear=AmountDetails.formData.topupDetails.capMonthYear?AmountDetails.formData.topupDetails.capMonthYear: null\" ng-required=\"AmountDetails.formData.sipTopupEnabled && ((!AmountDetails.formData.topupDetails.capAmount && !AmountDetails.formData.topupDetails.capMonthYear) || !AmountDetails.formData.topupDetails.capAmount)\" style=\"border: none;border: 1px solid;border-radius: 5px;height: 40px; width: 100%\"><option value=\"\">Cap Month Year - MM/YYYY</option></select></div></div></div></div></div></div></div></div></div><div class=\"col-md-12 p-0\" style=\"margin: 0\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-if=AmountDetails.formData.sipTopupEnabled ng-disabled=\"amountDetailsForm.anAmount.$invalid ||\n       !AmountDetails.formData.startDate ||\n       !AmountDetails.formData.endDate  ||\n       !AmountDetails.formData.sipTopupEnabled ||\n       AmountDetails.isminCapAmount||\n       (!AmountDetails.formData.topupDetails.capAmount && !AmountDetails.formData.topupDetails.capMonthYear) ||\n       (!AmountDetails.formData.topupDetails.amount &&  !AmountDetails.formData.topupDetails.percentage) || !AmountDetails.paymentvalidBank || AmountDetails.amountExceeded || AmountDetails.formData.sipPaymentOption == \'UPI\' && (!AmountDetails.upiPaymentvalidBank || !AmountDetails.isUPIVerified)\" ng-click=AmountDetails.next1()>CONTINUE</button></div><div class=\"col-md-12 p-0\" style=\"margin: 0\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-if=!AmountDetails.formData.sipTopupEnabled ng-disabled=\"amountDetailsForm.anAmount.$invalid ||\n       !AmountDetails.formData.startDate ||\n       !AmountDetails.formData.endDate || AmountDetails.formData.sipTopupEnabled || AmountDetails.amountExceeded  || !AmountDetails.paymentvalidBank || AmountDetails.formData.sipPaymentOption == \'UPI\' && (!AmountDetails.upiPaymentvalidBank || !AmountDetails.isUPIVerified)\" ng-click=AmountDetails.next1()>CONTINUE</button></div></form><form class=verification-form autocomplete=off id=purchseamountDetailsForm name=purchseamountDetailsForm ng-if=AmountDetails.PaymentModePurchse><div class=row><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>Amount</p></div><div class=\"col-xs-12 col-md-6 input-normal\" ng-class=\"{error:purchseamountDetailsForm.anAmount.$dirty && purchseamountDetailsForm.anAmount.$invalid}\" style=\"margin-bottom: 5px\"><div class=\"input-icons w-336\"><img class=ricon src=../../../../assets/images/rupee.svg alt=\"\" srcset=\"\" style=\"padding: 0 0 0 0\"> <input class=\"form-control input-border-line w-336\" onkeyup=\"NumToWord(this.value,\'newJournyPurchaseDivDisplayWords\')\" type=number id=amt ignore-mouse-wheel name=anAmount ng-model=AmountDetails.formData.amount ng-change=AmountDetails.checkPurchseAmountValidations(); autofocus required style=\"height: 40px;padding: 0px 0px 0px 30px\"></div><span class=error-input ng-show=\"(amountDetailsForm.anAmount.$dirty && amountDetailsForm.anAmount.$error.required)\">&nbsp;&nbsp; Amount is required</span> <span ng-if=\"AmountDetails.formData.amount && AmountDetails.ispurchseMinAmount\" class=error-input>Minimum amount should be &#8377; {{AmountDetails.purchseSchemeValidationData.minFirstPurchaseAmt}}</span> <span><div class=row><div class=\"maxDiv col-xs-4 col-md-4 mt-2\" ng-repeat=\"arrayAmount in AmountDetails.formData.amountArray\"><button class=amountBtn style=\"border:1px solid #b7b7b7\" type=button ng-click=AmountDetails.getAmount(false,arrayAmount)>&#8377;{{arrayAmount}}</button></div></div></span></div></div><div class=row><div class=\"col-xs-12 col-md-4 mt-2\"><label id=newJournyPurchaseDivDisplayWords>{{AmountDetails.amountInWords}} (In Words)</label></div></div><br><!-- IDCW --><div class=radio-block ng-if=\"AmountDetails.formData.investmentOption.toUpperCase() != \'GROWTH\' \" style=\"margin-bottom: 20px\"><p class=investmentTitle>Investment option</p><div class=radio-block><span class=radio><input type=radio id=reInvest name=idcw ng-change=\"\" ng-model=AmountDetails.dividenInevstmentOption value=Y> <span class=check></span> </span>&nbsp; Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option<br><span class=radio><input type=radio id=Payout name=idcw ng-change=\"\" ng-model=AmountDetails.dividenInevstmentOption value=N> <span class=check></span> </span>&nbsp; Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</div></div><br><!-- IDCW END --><div class=row><div class=\"col-md-8 point-to-note imp-info\" style=\"margin: 10px 0 9px;padding: 15px;\n      border-radius: 6px\">Please Note:<br><br><p><ul style=\"color: black\"><li><ng-bind-html dynamic=AmountDetails.dynamicNoteSip.noteDTO.noteDTOMap.Note_SEBI_CIRCULAR_NOMINEE.content></ng-bind-html></li></ul></p></div></div><div class=row style=\"margin: 0\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-disabled=\"purchseamountDetailsForm.anAmount.$invalid ||\n       AmountDetails.ispurchseMinAmount || !AmountDetails.purchseSchemeValidationData.minFirstPurchaseAmt\" ng-click=AmountDetails.next1()>INVEST</button></div></form></div><style>.w-336{\n    width: 336px;\n  }\n  .input-icons{\n    position: relative;\n  }\n  .input-icons > img {\n            position: absolute;\n            top: 35%;\n            left: 15px;\n        }\n        .maxDiv{\n    width: 70px;\n  }\n  .investmentTitle{\n    font-weight: bold;\n  }\n@media only screen and (max-width: 768px) {\n  .selectfield{\n    width: 100%;\n  }\n  .maxDiv{\n    width: 100px;\n  }\n  .topUpdiv30{\n    width: 80%;\n    }\n    .topUpdiv10{\n      margin-bottom: 18px;\n    width: 80%;\n    }\n}\n@media only screen and (min-width: 768px) {\n  .topUpdiv30{\n    width: 40%;\n    }\n    .topUpdiv10{\n      margin-top: 35px;\n    width: 5%;\n    }\n}</style>");
$templateCache.put("app/new-investors/investment-details/investment-mode/investment-mode.html","<div class=container-fluid ng-init=InvestmentMode.setGetDraftData()><form id=investmentModeform class=investmentModeform name=investmentModeform ng-submit=InvestmentMode.next()><div class=row><br><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>Investment Type</p></div><div class=\"col-xs-12 col-md-6\"><div class=\"row btn-m\" style=\"margin-left: 2px;width: 344px\"><p ng-click=\"InvestmentMode.investmentValidation.sipEnabled ? InvestmentMode.chooseInvestmentType(\'SIP\') : InvestmentMode.disableAlertSIPLumbsum(\'SIP\')\" ng-attr-class=\"{{InvestmentMode.SelectedInvestmentType == \'SIP\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">SIP</span></p><p ng-click=\"InvestmentMode.investmentValidation.purchaseEnabled ? InvestmentMode.chooseInvestmentType(\'Purchase\') : InvestmentMode.disableAlertSIPLumbsum(\'Purchase\')\" ng-attr-class=\"{{InvestmentMode.SelectedInvestmentType == \'Purchase\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">Lumpsum</span></p></div></div><div class=\"col-xs-12 col-md-4 hidden-xs\"><div class=warning1><img src=../../../assets/images/icons/light-bulb.png style=\"height: 25px;width: 25px\"><div><br>Under SIPs,you invest a small amount regularly</div></div></div></div><br><div class=row><div class=\"col xs-12 col-md-7\"><p class=investmentTitle>Investing Through</p></div><div class=\"col-xs-12 col-md-6\" ng-class=\"{\'anything-disabled\':InvestmentMode.distributorDetails}\"><div class=\"row btn-m\" style=\"margin-left: 2px;width: 344px\"><p ng-click=\"!InvestmentMode.investmentValidation.directSchemes ? InvestmentMode.disabledDistributtonAlert(\'Self\') : InvestmentMode.chooseInvestmentThrough(\'Self\')\" ng-attr-class=\"{{InvestmentMode.SelectedInvestingThrough == \'Self\' ? \'btn-active1 first-btn col-xs-4 col-md-4 col-sm-4\' : \'btn-deactive1 first-btn col-xs-4 col-md-4 col-sm-4\' }}\"><span style=\"margin: auto;font-weight: 500\">Self</span></p><p ng-click=\"!InvestmentMode.investmentValidation.directSchemes ? InvestmentMode.chooseInvestmentThrough(\'Distributor\') : InvestmentMode.disabledDistributtonAlert(\'Distributor\')\" ng-attr-class=\"{{InvestmentMode.SelectedInvestingThrough == \'Distributor\' ? \'btn-active1 col-xs-4 col-md-4 col-sm-4\' : \'btn-deactive1 col-xs-4 col-md-4 col-sm-4\' }}\"><span style=\"margin: auto;font-weight: 500\">Distributor</span></p><p ng-click=\"!InvestmentMode.investmentValidation.directSchemes ? InvestmentMode.disabledDistributtonAlert(\'Ria\') : InvestmentMode.chooseInvestmentThrough(\'RIA\')\" ng-attr-class=\"{{InvestmentMode.SelectedInvestingThrough == \'RIA\' ? \'btn-active1 last-btn col-xs-4 col-md-4 col-sm-4\' : \'btn-deactive1 last-btn col-xs-4 col-md-4 col-sm-4\' }}\"><span style=\"margin: auto;font-weight: 500\">RIA</span></p></div></div></div><br><div ng-if=\"InvestmentMode.SelectedInvestingThrough == \'Distributor\'\"><div class=row><div class=\"col-xs-12 col-md-6\" style=\"margin-bottom: 5px\"><p ng-if=InvestmentMode.distributorDetails class=investmentTitle>ARN</p><div style=\"display: flex;justify-content: flex-start;flex-direction: row\" ng-if=!InvestmentMode.distributorDetails><p class=investmentTitle>ARN</p><input type=checkbox id=switch style=\"margin-right: 10px\" ng-model=InvestmentMode.searchARN><label class=switchlable1 for=switch style=\"margin-right: 10px\"></label><span>Search Distributor</span></div><div class=input-normal ng-if=!InvestmentMode.searchARN ng-class=\"{\'anything-disabled\':InvestmentMode.distributorDetails}\"><input type=text minlength=4 class=arn-no name=brokerCode id=brokerCode onkeypress=\"event.charCode >= 48 && event.charCode <= 57\" ng-model=InvestmentMode.investmentARN ng-change=InvestmentMode.changeinvestmentARN() ng-disabled=\"InvestmentMode.distributorDetails.key == \'MFD\' || (InvestmentMode.distributorDetails.key == \'E_CODE\' && InvestmentMode.distributorDetails.arn) || InvestmentMode.distributorDetails.key == \'CONNECT_PARTNER\'\" autocomplete=off ng-blur=InvestmentMode.fetchEuinList() required style=\"height: 40px;border-radius: 5px; border: 1px solid gray\"> <span class=highlight></span> <span class=bar></span> <span class=arn1>ARN -</span><p class=info-primary ng-if=InvestmentMode.brokerName>Distributor Name : {{InvestmentMode.brokerName}}</p><span class=error-input style=\"color: red\" ng-show=investmentModeform.brokerCode.$dirty&&investmentModeform.brokerCode.$error.required ng-bind=InvestmentMode.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input style=\"color: red\" ng-show=\"investmentModeform.brokerCode.$dirty && investmentModeform.brokerCode.$invalid && investmentModeform.brokerCode.$error.minlength\" ng-bind=InvestmentMode.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input style=\"color: red\" ng-show=\"InvestmentMode.brokerCodeError != \'\'&& !investmentModeform.brokerCode.$error.pattern\" ng-bind=InvestmentMode.brokerCodeError></span></div><!--Temp Seach arn  --><div class=\"input-select input-normal\" ng-if=InvestmentMode.searchARN ng-class=\"{error:investmentModeform.distributorName.$dirty && investmentModeform.distributorName.$invalid}\"><input type=text name=distributorName id=distributorName ng-change=InvestmentMode.searchDistributorByName(); ng-model=InvestmentMode.distributorName ng-disabled=\"InvestmentMode.distributorDetails.key == \'MFD\' || (InvestmentMode.distributorDetails.key == \'E_CODE\' && InvestmentMode.distributorDetails.arn) || InvestmentMode.distributorDetails.key == \'CONNECT_PARTNER\'\" autocomplete=off only-alphabets required style=\"height: 40px;border-radius: 5px; border: 1px solid gray\"> <span class=highlight></span> <span class=bar></span><label>Search Distributor</label><drop-down list-data=InvestmentMode.distributorList display-key=name display-key-second=arnCode hdfc-click=InvestmentMode.distributorListChanged(data) model=InvestmentMode.formData.distributorARN for=distributorName></drop-down><span class=error-input style=\"color: red\" ng-show=investmentModeform.distributorName.$dirty&&investmentModeform.distributorName.$error.required ng-bind=InvestmentMode.VALIDATE_DATA.BROKER_REQUIRED></span></div></div></div><!-- Sub Broker Details Start --><p class=investmentTitle>Sub Broker ARN</p><div class=row><div class=\"input-normal col-xs-12 col-md-6\" ng-class=\"{\'anything-disabled\':InvestmentMode.distributorDetails}\"><!-- <p class=\"investmentTitle\">Sub Broker Code</p> --> <input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=InvestmentMode.subBrokerARN ng-change=InvestmentMode.changeSubBrokerArn() ng-disabled=\"InvestmentMode.distributorDetails.key == \'MFD\' || (InvestmentMode.distributorDetails.key == \'E_CODE\' && InvestmentMode.distributorDetails.arn) || InvestmentMode.distributorDetails.key == \'CONNECT_PARTNER\'\" ng-blur=InvestmentMode.fetchEuinListSubBroker() ng-required=\"InvestmentMode.investmentARN || InvestmentMode.distributorName \" maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false style=\"height: 40px;border-radius: 5px; border: 1px solid gray\"> <span class=highlight></span> <span class=bar></span> <span class=arn1 style=\"margin-left: 15px\">ARN -</span><p class=info-primary ng-if=InvestmentMode.subBrokerName>Sub Broker Name: {{InvestmentMode.subBrokerName}}</p><span class=error-input style=\"color: red\" ng-show=\"(investmentModeform.subBrokerARN.$dirty && investmentModeform.subBrokerARN.$invalid && investmentModeform.subBrokerARN.$error.pattern)\" ng-bind=InvestmentMode.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input style=\"color: red\" ng-show=\"InvestmentMode.subBrokerCodeError != \'\'&& !investmentModeform.subBrokerARN.$error.pattern\" ng-bind=InvestmentMode.subBrokerCodeError></span></div></div><div class=row><div class=\"input-normal col-xs-12 col-md-6\" ng-class=\"{\'anything-disabled\':InvestmentMode.distributorDetails}\"><p class=investmentTitle>Sub Broker Code</p><input type=text name=subBrokerCode id=subBrokerCode ng-model=InvestmentMode.subBrokerCode autocomplete=off ng-disabled=\"!InvestmentMode.subBrokerARN || InvestmentMode.subBrokerCodeError !=\'\' || InvestmentMode.distributorDetails.key == \'MFD\' || (InvestmentMode.distributorDetails.key == \'E_CODE\' && InvestmentMode.distributorDetails.arn) || InvestmentMode.distributorDetails.key == \'CONNECT_PARTNER\'\" ng-blur=InvestmentMode.checksubbrokercode() restrict-special-charcter ng-trim=false style=\"height: 40px;border-radius: 5px; border: 1px solid gray\"> <span class=highlight></span> <span class=bar></span> <span class=error-input style=\"color: red\" ng-show=investmentModeform.subBrokerCode.$dirty&&investmentModeform.subBrokerCode.$error.required ng-bind=investmentModeform.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div><!-- Sub Broket Details End --><div class=row ng-class=\"{\'anything-disabled\':InvestmentMode.distributorDetails.euin && InvestmentMode.isCorrectEuin}\"><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>EUIN</p></div><div class=\"col-xs-12 col-md-6\"><div class=\"row btn-ss\" style=\"margin-left: 2px;width: 344px\"><p ng-click=\"InvestmentMode.chooseEnui(\'EUIN\')\" ng-attr-class=\"{{InvestmentMode.SelectedEnui == \'EUIN\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\" role=button>EUIN</span></p><p ng-click=\"InvestmentMode.chooseEnui(\'EUIN Declaration\')\" ng-attr-class=\"{{InvestmentMode.SelectedEnui == \'EUIN Declaration\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\" role=button>EUIN Declaration</span></p></div></div></div><br><!-- EUIN Declaration start --><!-- <div class=\"checkbox\" ng-if=\"InvestmentMode.SelectedEnui == \'EUIN Declaration\'\">\n            <input ng-model=\"InvestmentMode.isCheckedTandC\" type=\"checkbox\" />\n            <i class=\"icon-checkbox\"></i>\n            <span class=\"checkbox-text\" style=\"margin-top: -16px;\">I/We hereby confirm that the EUIN box\n              has been\n              intentionally\n              left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span>\n          </div>  --><div class=row ng-if=\"InvestmentMode.SelectedEnui == \'EUIN Declaration\'\"><div class=\"col-sm-10 col-md-9\" style=\"display: flex;justify-content: flex-start;flex-direction: row\"><input class=nomineeCheckbox type=checkbox id=confirmfoliocreate name=confirmfoliocreate ng-model=InvestmentMode.isCheckedTandC><label for=confirmfoliocreate class=confirmationnote ng-checked=InvestmentMode.isCheckedTandC style=\"font-size: 13px\">&nbsp;I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</label></div><br><div class=\"col-sm-12 col-md-12\" ng-if=\"InvestmentMode.distributorDetails && InvestmentMode.distributorDetails.isHdfcBank\" style=\"display: flex;justify-content: flex-start;flex-direction: row\"><input class=nomineeCheckbox type=checkbox id=confirmfoliocreate1 name=confirmfoliocreate1 ng-model=InvestmentMode.isCheckedTandC2 required><label for=confirmfoliocreate1 class=confirmationnote ng-checked=InvestmentMode.isCheckedTandC2 style=\"font-size: 13px\"><ng-bind-html ng-bind-html=InvestmentMode.hdfcOneClickDisclaimerNote></ng-bind-html></label></div><br></div><div class=row ng-if=\"InvestmentMode.SelectedEnui == \'EUIN\'\"><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>Select Euin</p></div><div class=\"col-sm-10 col-md-9\"><div class=\"input-select input-normal selectfield\" ng-class=\"{error:investmentModeform.euin.$dirty&& investmentModeform.euin.$invalid}\" style=\"width: 336px !important\"><input type=text name=euin id=euin ng-model=InvestmentMode.euinData.euinNameCode ng-disabled=InvestmentMode.isCorrectEuin ng-change=InvestmentMode.filterEuinList() ng-init=\"InvestmentMode.euinData = InvestmentMode.euinData ? InvestmentMode.euinData : null\" require autocomplete=off style=\"height: 40px;border-radius: 5px; border: 1px solid gray\"> <span class=highlight></span> <span class=bar></span><!-- <label>Select Euin</label> --> <span class=error-input ng-show=\"investmentModeform.euin.$dirty && investmentModeform.euin.$error.required || ( !InvestmentMode.euinData.euinNameCode && InvestmentMode.SelectedEnui == \'EUIN\')\" ng-bind=InvestmentMode.VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down class=error-input list-data=InvestmentMode.euinList display-key=euinName display-key-second=euinCode hdfc-click=InvestmentMode.selectEuin(data) model=InvestmentMode.euin for=euin></list-drop-down></div></div></div></div><div class=row ng-if=\"InvestmentMode.SelectedInvestingThrough == \'RIA\'\"><div class=\"col xs-12 col-md-7\"><p class=investmentTitle>RIA Code</p></div><div class=col-md-6><div class=input-normal><input type=text name=riaCode id=riaCode ng-model=InvestmentMode.RiaCode autocomplete=off required minlength=12 ng-disabled=InvestmentMode.distributorDetails ng-blur=InvestmentMode.getEuinRIA() maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ autofocus required capitalize ng-blur=InvestmentMode.getEuinRIA() style=\"height: 40px;border-radius: 5px; border: 1px solid gray\"> <span ng-show=\"investmentModeform.riaCode.$dirty && investmentModeform.riaCode.$invalid\"><span class=error-input style=\"color: red\" ng-show=investmentModeform.riaCode.$error.required ng-bind=InvestmentMode.validateData.RIA_REQUIRED></span> <span class=error-input style=\"color: red\" ng-show=investmentModeform.riaCode.$error.maxlength ng-bind=InvestmentMode.validateData.RIA_INVALID></span> <span class=error-input style=\"color: red\" ng-show=investmentModeform.riaCode.$error.minlength ng-bind=InvestmentMode.validateData.RIA_INVALID></span></span></div></div></div><div class=row style=\"margin: 0\" ng-if=\"InvestmentMode.SelectedInvestingThrough == \'Self\'\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-click=InvestmentMode.next()>CONTINUE</button></div><div class=row style=\"margin: 0\" ng-if=\"InvestmentMode.SelectedInvestingThrough == \'Distributor\'\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-disabled=\"!InvestmentMode.isCheckedTandC || !InvestmentMode.investmentARN || (InvestmentMode.distributorDetails && InvestmentMode.distributorDetails.isHdfcBank && !InvestmentMode.isCheckedTandC2)\" ng-if=\"InvestmentMode.SelectedEnui == \'EUIN Declaration\'\" ng-click=InvestmentMode.next() ng-disabled=investmentModeform.riaCode.$invalid>CONTINUE</button> <button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-disabled=\"!InvestmentMode.euinData.euinNameCode || !InvestmentMode.investmentARN || InvestmentMode.brokerProcess\" ng-if=\"InvestmentMode.SelectedEnui == \'EUIN\'\" ng-click=InvestmentMode.next()>CONTINUE</button></div><div class=row style=\"margin: 0\" ng-if=\"InvestmentMode.SelectedInvestingThrough == \'RIA\'\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit ng-click=InvestmentMode.next() ng-disabled=\"investmentModeform.riaCode.$invalid || !InvestmentMode.riaProcced\">CONTINUE</button></div></form></div><style>.input-normal input, .input-normal input[ng-required] {\n  width: 336px;\n}\n.new-investors .kyc-form-container .form-page-container .col-xs-12 select{\n  width: 336px;\n}\n  .arn1 {\n    position: absolute;\n    top: 12px;\n    left: 6px;\n    font-size: 14px !important;\n    color: #242424 !important;\n    display: block;\n  }\n  .switchlable1 {\n    cursor: pointer;\n    text-indent: -9999px;\n    width: 29px;\n    height: 16px;\n    background: #5ceb57;\n    display: block;\n    border-radius: 50px;\n    position: relative;\n  }\n\n\n  .switchlable1 {\n    margin-right: 10px;\n    width: 29px;\n    height: 16px;\n    background: #5CEB57 0% 0% no-repeat padding-box;\n    border-radius: 37px;\n    opacity: 1;\n    cursor: pointer;\n    text-indent: -9999px;\n    display: block;\n    position: relative;\n  }\n\n  .switchlable1:after {\n    content: \"\";\n    position: absolute;\n    top: 3px;\n    left: 5px;\n    width: 10px;\n    height: 10px;\n    background: #fff;\n    border-radius: 50px;\n  }\n\n  input:checked+.switchlable1 {\n    background: #5ceb57;\n  }\n\n  input:checked+.switchlable1:after {\n    left: calc(100% - 5px);\n    transform: translateX(-100%);\n  }\n\n  .switchlable1:active:after {\n    width: 10px;\n  }\n  \n  @media only screen and (max-width: 400px) {\n    .container-fluid{\n      padding: 0px;\n      margin: 0px;\n    }\n  }</style>");
$templateCache.put("app/new-investors/investment-details/scheme-details/scheme-investment-goal.html","<div class=\"portfolio clearfix\" ng-init=SchemeInvestment.init()><ul style=\"display: flex;justify-content: start;flex-direction: row;padding: 3px;border-bottom: 1px solid gray\"><li ui-sref-active=activeMode class=mobile-f-size style=\"background-color: transparent;margin-bottom: -3px;height: inherit;margin-left: -3px;padding: 5px;\n      width: 180px;display: flex;justify-content: center\"><a ui-sref=newInvestor.investmentDetails.schemedetails.investmentGoal>Investment Goal</a></li><li ui-sref-active=activeMode class=mobile-f-size style=\"background-color: transparent;margin-left: 50px;margin-bottom: -3px;height: inherit;padding: 5px;\n      width: 200px;display: flex;justify-content: center\"><a ui-sref=newInvestor.investmentDetails.schemedetails.selectscheme>Select your scheme</a></li></ul><div ui-view></div></div>");
$templateCache.put("app/payment/templates/common/payment-common.html","<div><div><div class=row><div class=col-md-12><div class=payment-options-container><div class=row><!-- payment selection field starts here--><div class=\"col-md-12 p-0\"><div class=form-input><div class=other-payment-options><div class=other-payment-option-container ng-repeat=\"_option in Payment.paymentOptions track by $index\"><div class=card><div class=card-body><!-- payment options dropdown starts here--><div class=radio-button><input type=radio id=paymentOption-{{_option.key}} name=paymentOption ng-value=_option.key ng-model=Payment.formData.selectedPaymentOption><label class=\"btn btn-default\" id={{_option.key}} for=paymentOption-{{_option.key}} ng-click=Payment.selectPaymentOption(_option,$index)><span>{{_option.value}}</span> <span ng-if=\"Payment.activeIndex === $index\" class=\"up-accordian ms-auto\"></span> <span ng-if=\"Payment.activeIndex !== $index\" class=\"down-accordian ms-auto\"></span></label></div><!-- payment options dropdown ends here--><!--other payment options responsive section starts here--><div ng-if=\"Payment.activeIndex === $index\"><hr><!--upi section starts here--><form ng-if=\"Payment.formData.selectedPaymentOption == Payment.PAYMENT_OPTIONS.UPI || Payment.formData.selectedPaymentOption == Payment.PAYMENT_OPTIONS.UPISIP\" autocomplete=off novalidate name=tFormUPI class=upiForm><div ng-init=Payment.getFormDataUpi(tFormUPI)><div class=\"col-md-12 px-0\"><label class=upi-label>Select Bank for UPI Payment</label><!--bank selection starts here--><div class=row><div class=col-md-12><div class=form-input><div class=search-input ng-class=\"{error:tFormUPI.bank.$dirty && tFormUPI.bank.$invalid}\"><input type=text name=bank id=upiBank ng-model=Payment.bankInfoUPI.maskedBankName ng-change=Payment.selectedUpiBank() class=\"select-folio-list form-select\" ng-init=\"Payment.bankInfoUPI = Payment.bankInfoUPI ? Payment.bankInfoUPI: null\" autocomplete=off ng-required=!Payment.bankInfoUPI ng-disabled=isDisableUpi only-alphabets readonly> <span class=error-input ng-show=\"tFormUPI.bank.$dirty && tFormUPI.bank.$error.required\" ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.UPIBankList display-key=bankNameOnly display-key-second=maskedAccountNumber hdfc-click=Payment.selectedUpiBank() model=Payment.bankInfoUPI for=upiBank></bank-drop-down></div></div></div><!--IFSC AND ACCOUNT TYPE FIELDS --><div class=col-md-12 ng-if=\"Payment.bankInfoUPI && !Payment.bankInfoUPI.ifscCode || Payment.bankInfoUPI && !Payment.bankInfoUPI.bankAcType\"><div class=\"row align-items-center\"><!-- UPI ifsc code selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-top-12\" ng-if=\"Payment.bankInfoUPI && !Payment.bankInfoUPI.ifscCode\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX class=form-control capitalize><label>IFSC Code</label><span class=error-input ng-show=\"tFormUPI.ifscCode.$dirty && tFormUPI.ifscCode.$error.required\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=\"tFormUPI.ifscCode.$dirty && tFormUPI.ifscCode.$error.pattern\" ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div></div><!-- UPI Account type selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-top-12\" ng-if=\"Payment.bankInfoUPI && !Payment.bankInfoUPI.bankAcType\"><div class=form-input><div class=field-type-2><select name=accountType ng-model=Payment.formData.paymentInfo.accType class=form-select ng-init=\"Payment.formData.paymentInfo.accType = Payment.formData.paymentInfo.accType ? Payment.formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option class=set-select-label-color-grey value=\"\">Select Account Type</option></select><label ng-if=Payment.bankInfo.bankAcType>Account Type<span class=\"req text-red\">*</span></label><span class=error-input ng-messages=tFormUPI.accountType.$error ng-show=tFormUPI.accountType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div></div></div><!--bank selection ends here--><!--upi intent section starts here--><div class=\"row set-margin-top-16\" ng-if=\"Payment.isIntent && Payment.formData.investmentType === \'SIP\' && Payment.bankInfoUPI\"><div class=col-md-12><div class=\"d-flex justify-content-between mb-3 mt-2\"><div ng-repeat=\"intentList in Payment.intentList\" class=\"upi-button-intent text-center\"><button class=col-md-12 ng-class=\"{\'button-active\' : intentList.key === Payment.selectedUpiOption}\" ng-click=Payment.selectedUpiBlock(intentList.key)><img src={{intentList.iconUrl}} alt={{intentList.key}}></button> <span>{{intentList.name}}</span></div></div></div></div><!--upi intent section ends here--><!--vpa starts here--><div class=\"row align-items-center\" ng-if=\"Payment.selectedUpiOption && Payment.selectedUpiOption === \'OTHERS\' && Payment.bankInfoUPI\"><!--virtual address field--><div class=\"col-md-12 vpa-input\"><div class=input-normal ng-class=\"{error:tFormUPI.virtualAddress.$invalid && tFormUPI.virtualAddress.$dirty}\"><input style=\"text-transform: lowercase\" type=text ng-model=Payment.formData.paymentInfo.virtualAddress name=virtualAddress ng-pattern=Payment.PATTERN.upi_virtual_addr_regex ng-change=\"Payment.verifyUPIResp={}; Payment.selectedUpiOption = \'OTHERS\'; Payment.isUPIVerified = false;\" required easyassist-key=mask-element ng-disabled=Payment.isDisableUpi><div class=bar></div><div class=highlight></div><label style=\"display: block\">Enter UPI ID of selected bank<!--                                        <i class=\"edit-icon\"--><!--                                           ng-if=\"Payment.isUPIVerified && Payment.verifyUPIResp.valid === true && !Payment.isDisableUpi\"--><!--                                           ng-click=\"Payment.isUPIVerified = false\"></i>--></label><span class=error-input ng-show=\"tFormUPI.virtualAddress.$dirty && (tFormUPI.virtualAddress.$error.required || tFormUPI.virtualAddress.$error.pattern)\" ng-bind=Payment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!tFormUPI.virtualAddress.$invalid\n                                            &&  (!Payment.isUPIVerified && Payment.verifyUPIResp.valid === false)\" ng-bind=Payment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span></div></div><!--vpa button field--><div class=\"col-md-12 text-center set-margin-top-16\" ng-if=!Payment.isUPIVerified ng-class=\"{\'anything-disabled\': !Payment.formData.paymentInfo.virtualAddress || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition())}\"><button blur-on-click class=\"btn btn-primary-payment\" ng-disabled=\"!Payment.formData.paymentInfo.virtualAddress || (!Payment.bankInfo.minorBankFlag && Payment.checkForMinorBankListCondition())\" ng-click=Payment.verifyUPI()>Verify</button></div><div class=\"col-md-12 text-center verify-vpa verify-ack-padding set-margin-top-16 ps-0\" ng-if=\"Payment.isUPIVerified && Payment.verifyUPIResp.valid === true\"><p class=verified><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{Payment.name}}</span></div><div class=\"col-md-12 text-center verify-vpa set-margin-top-16 ps-0\" ng-if=\"!Payment.isUPIVerified && Payment.verifyUPIResp.valid === false\"><p><strong><span class=\"error-input error-upi\" style=\"display:inline;font-size:100%;margin-bottom: 20px;color: red\">Not Verified</span> <i class=\"cancel-icon error-input\"></i></strong></p></div></div><!--vpa ends here--><!-- tnc selection column--><!--                                <div class=\"row set-margin-top-32 set-margin-bottom-24\" ng-if=\"Payment.formData.investmentType === \'PURCHASE\'\">--><!--                                  <div class=\"col-md-12\">--><!--                                    <div class=\"checkbox checkbox-neft\">--><!--                                      <input id=\"declaration3\" ng-model=\"isCheckedDeclarationUPI\" type=\"checkbox\" required/>--><!--                                      <i class=\"icon-checkbox\"></i>--><!--                                      <label for=\"declaration3\" class=\"label-black f-family-inter f-weight-400\">--><!--                                        I hereby declare that the funds transferred are from bank account where the first/sole unit holder is one of the bank account holders.--><!--                                      </label>--><!--                                    </div>--><!--                                  </div>--><!--                                </div>--><!-- tnc selection column ends here --></div></div></form><!--upi section ends here--><!--other payment options section starts here--><form ng-if=\"Payment.formData.selectedPaymentOption !== Payment.PAYMENT_OPTIONS.UPI && Payment.formData.selectedPaymentOption !== Payment.PAYMENT_OPTIONS.UPISIP\" autocomplete=off novalidate name=tForm><div class=\"col-md-12 other-payment-modes-container px-0\" ng-init=Payment.getFormData(tForm)><div class=row><div class=col-md-12><div ng-switch=Payment.formData.selectedPaymentOption><div ng-switch-when=Net_Banking><!--                                      <div class=\"row set-margin-bottom-20 fw-normal\" ng-if=\"Payment.showDatesManupilateError\">--><!--                                        <div class=\"col-md-12\">--><!--                                          If you choose this payment option, your SIP start date will be {{Payment.displayDate}}--><!--                                        </div>--><!--                                      </div>--><div class=row><!-- Netbanking bank selection column--><div class=col-md-12><div class=form-input><div class=search-input><input type=text name=bank id=bank ng-model=Payment.bankInfo.maskedBankName ng-change=Payment.changeBank() class=form-select ng-init=\"Payment.bankInfo = Payment.bankInfo ? Payment.bankInfo: null\" autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly><label>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.netBankingBankList display-key=bankNameOnly display-key-second=maskedAccountNumber hdfc-click=Payment.changeBank() model=Payment.bankInfo for=bank></bank-drop-down></div></div></div><!-- Netbanking ifsc code selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-top-18\" ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX class=form-control capitalize><label>IFSC Code</label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div></div><!-- Netbanking Account type selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-top-18\" ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=form-input><div class=field-type-2><select name=accountType ng-model=Payment.formData.paymentInfo.accType class=form-select ng-init=\"Payment.formData.paymentInfo.accType = Payment.formData.paymentInfo.accType ? Payment.formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option class=set-select-label-color-grey value=\"\">Select Account Type</option></select><label ng-if=Payment.bankInfo.bankAcType>Account Type<span class=\"req text-red\">*</span></label><span class=error-input ng-messages=tForm.accountType.$error ng-show=tForm.accountType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=col-md-12 ng-if=\"Payment.bankInfo.tpvEnableFlag==\'N\'\"><p class=\"text-red error-msg-tpv\">Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br>Please select other payment mode or add a TPV enabled bank in your folio. <a ng-click=Payment.tpv($event) href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</p></div></div><!-- tnc selection column--><!--                                      <div class=\"row set-margin-top-32 set-margin-bottom-24\" ng-if=\"Payment.formData.investmentType == \'PURCHASE\'\">--><!--                                        <div class=\"col-md-12\">--><!--                                          <div class=\"checkbox checkbox-neft\">--><!--                                            <input id=\"declaration4\" ng-model=\"isCheckedDeclarationNetBanking\" type=\"checkbox\" required/>--><!--                                            <i class=\"icon-checkbox\"></i>--><!--                                            <label for=\"declaration3\" class=\"label-black f-family-inter f-weight-400\">--><!--                                              I hereby declare that the funds transferred are from bank account where the first/sole unit holder is one of the bank account holders.--><!--                                            </label>--><!--                                          </div>--><!--                                        </div>--><!--                                      </div>--><!-- tnc selection column ends here --></div><div ng-switch-when=NEFT_RTGS><div class=\"row set-margin-bottom-20\"><div class=col-md-12><div class=toggle-container><label class=switch><input type=checkbox ng-model=Payment.isNewPayment ng-change=Payment.changeRtgsPaymentOption()> <span class=slider></span></label><span class=\"label-black f-family-inter f-weight-400 label-medium\">Have you transferred funds from registered bank account?</span></div></div></div><div class=\"row set-margin-top-12\"><!-- RTGS bank selection column--><div class=col-md-12 ng-if=Payment.isNewPayment><div class=form-input><div class=search-input><input type=text name=rtgsBank id=rtgsBank ng-model=Payment.bankInfo.maskedBankName ng-change=Payment.changeBank() class=form-select autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly><label>Select Bank</label><span class=error-input ng-show=tForm.rtgsBank.$dirty&&tForm.rtgsBank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.NEFTRTGSBankList display-key=bankNameOnly display-key-second=maskedAccountNumber hdfc-click=Payment.changeBank() model=Payment.bankInfo for=rtgsBank></bank-drop-down></div></div></div><!-- RTGS bank name column--><div class=\"col-md-12 set-margin-bottom-18 set-margin-top-18\" ng-if=\"(Payment.isNewPayment && Payment.bankInfo.bankName) || (!Payment.isNewPayment && !Payment.bankInfo.bankName)\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.bankName name=bankName only-alphabets required class=form-control ng-readonly=Payment.isNewPayment><label>Bank Name</label><span class=error-input ng-show=tForm.bankName.$dirty&&tForm.bankName.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div></div><!-- RTGS branch city column--><div class=\"col-md-12 set-margin-bottom-18\" ng-if=\"(Payment.isNewPayment && Payment.bankInfo.bankName) || (!Payment.isNewPayment && !Payment.bankInfo.bankName)\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.bankBranch only-alphabets name=bankBranch required ng-readonly=Payment.isNewPayment class=form-control><label>Branch City</label><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><!-- RTGS account number column--><div class=\"col-md-12 set-margin-bottom-18\" ng-if=\"(Payment.isNewPayment && Payment.bankInfo.bankName) || (!Payment.isNewPayment && !Payment.bankInfo.bankName)\"><div class=form-input><div class=field-type-2><input type=text autocomplete=false ng-model=Payment.formData.paymentInfo.accNo ng-if=Payment.isNewPayment name=bankAcNo required maxlength=20 ng-readonly=Payment.isNewPayment onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=copyPasteHandler($event) class=form-control> <input type=password autocomplete=false ng-model=Payment.formData.paymentInfo.accNo ng-if=!Payment.isNewPayment name=bankAcNo required maxlength=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event) class=form-control><label>Account Number</label><span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.maxlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div></div></div><!-- RTGS verify account number column--><div class=\"col-md-12 set-margin-bottom-18\" ng-if=!Payment.isNewPayment><div class=form-input><div class=field-type-2><input type=text ng-keydown=Payment.copyPasteHandler($event) name=verifyBankAcNo maxlength=20 required ng-model=Payment.formData.paymentInfo.verifyBankAcNo ng-pattern=Payment.formData.paymentInfo.accNo onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\" class=form-control><label>Verify Account Number</label><span class=error-input ng-show=tForm.verifyBankAcNo.$dirty&&tForm.verifyBankAcNo.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&tForm.verifyBankAcNo.$error.maxlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&!tForm.verifyBankAcNo.$error.maxlength&&tForm.verifyBankAcNo.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div></div><!-- RTGS ifsc code selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-bottom-18\" ng-if=\"(Payment.isNewPayment && Payment.bankInfo.bankName) || (!Payment.isNewPayment && !Payment.bankInfo.bankName)\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required ng-readonly=\"Payment.isNewPayment && Payment.bankInfo.ifscCode\" maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX class=form-control capitalize><label>IFSC Code</label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div></div><!-- RTGS Account type selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-bottom-18\" ng-if=\"(Payment.isNewPayment && Payment.bankInfo.bankName) || (!Payment.isNewPayment && !Payment.bankInfo.bankName)\"><div class=form-input><div class=field-type-2><select name=accountType ng-model=Payment.formData.paymentInfo.bankAcType class=form-select ng-disabled=\"Payment.isNewPayment && Payment.isAccTypeFieldDisabled\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option class=set-select-label-color-grey value=\"\">Account Type</option></select><label ng-if=Payment.bankInfo.bankAcType>Account Type</label><span class=error-input ng-show=\"tForm.accountType.$dirty && tForm.accountType.$error.required\" ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></div></div></div><!-- RTGS UTR number column--><div class=\"col-md-12 set-margin-bottom-18\" ng-if=\"(Payment.isNewPayment && Payment.bankInfo.bankName) || (!Payment.isNewPayment && !Payment.bankInfo.bankName)\"><div class=form-input><div class=field-type-2><input type=text name=utrNumber ng-model=Payment.formData.paymentInfo.utrNumber ng-pattern=Payment.PATTERN.UTR_REGEX ng-maxlength=255 required class=form-control><label>UTR Number</label><span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.pattern class=help-block ng-bind=Payment.VALIDATE_DATA.UTR_RANGE></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.maxlength class=help-block ng-bind=Payment.VALIDATE_DATA.UTR_INVALID></span></div></div></div><!-- RTGS verify utr column--><div class=col-md-12 ng-if=\"(Payment.isNewPayment && Payment.bankInfo.bankName) || (!Payment.isNewPayment && !Payment.bankInfo.bankName)\"><div class=form-input><div class=field-type-2><input type=text name=verifyUtrNumber ng-model=Payment.formData.paymentInfo.verifyUtrNumber ng-pattern=Payment.formData.paymentInfo.utrNumber required class=form-control><label>Verify UTR Number</label><span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_UTR_REQUIRED></span></div></div></div></div><!--                                      <div class=\"row set-margin-top-32 set-margin-bottom-24\">--><!--                                        <div class=\"col-md-12\">--><!--                                          <div class=\"checkbox checkbox-neft\">--><!--                                            <input id=\"declaration1\" ng-model=\"isCheckedDeclarationNEFT\" type=\"checkbox\" required/>--><!--                                            <i class=\"icon-checkbox\"></i>--><!--                                            <label for=\"declaration1\" class=\"label-black f-family-inter f-weight-400\">--><!--                                              I hereby declare that the funds transferred are from bank account where the first/sole unit holder is one of the bank account holders.--><!--                                            </label>--><!--                                          </div>--><!--                                        </div>--><!--                                      </div>--></div><div ng-switch-when=OTM><div class=row><!-- OTM bank selection column--><div class=col-md-12><div class=form-input><div class=search-input><input type=text name=bank id=otmBank ng-model=Payment.bankInfo.maskedBankName ng-change=Payment.changeBank() class=form-select ng-init=\"Payment.bankInfo = Payment.bankInfo ? Payment.bankInfo: null\" autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly><label>Select Mandate</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.otmBankList display-key=bankName display-key-second=maskedBankAcNo hdfc-click=Payment.changeBank() model=Payment.bankInfo for=otmBank></bank-drop-down></div></div></div><!-- OTM ifsc code selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-top-18\" ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX class=form-control capitalize><label>IFSC Code</label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div></div><!-- OTM Account type selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-top-18\" ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=form-input><div class=field-type-2><select name=accountType ng-model=Payment.formData.paymentInfo.accType class=form-select ng-init=\"Payment.formData.paymentInfo.accType = Payment.formData.paymentInfo.accType ? Payment.formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option class=set-select-label-color-grey value=\"\">Select Account Type</option></select><label ng-if=Payment.bankInfo.bankAcType>Account Type<span class=\"req text-red\">*</span></label><span class=error-input ng-messages=tForm.accountType.$error ng-show=tForm.accountType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div><!-- OTM details selection column--><div class=\"row set-margin-top-18\" ng-if=Payment.bankInfo.bankName><table class=\"table borderless otm-bank-details\" ng-if=\"(Payment.otmBankList && Payment.otmBankList.length)\"><tr><td>Account No:</td><td easyassist-key=mask-element>{{Payment.bankInfo.bankAcNo}}</td></tr><tr><td>OTM UMRN No:</td><td>{{Payment.bankInfo.omUmrn}}</td></tr><tr><td>OTM UMRN No:</td><td>{{Payment.bankInfo.otmFrequencyName}}</td></tr><tr><td>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{Payment.bankInfo.maxAmount}} <span class=error-input ng-show=\"Payment.isOTMAmount && Payment.formData.purchaseAmount\" ng-bind=Payment.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_PURCHASE_ERROR></span> <span class=error-input ng-show=\"Payment.isOTMAmount && Payment.formData.sipFirstAmount\" ng-bind=Payment.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_SIP_ERROR></span></td></tr><tr><td>OTM Start Date:</td><td>{{Payment.bankInfo.omStartDate}} <span class=error-input ng-show=\"Payment.isOTMStartDate && Payment.formData.purchaseAmount\" ng-bind=\"Payment.VALIDATE_DATA.DATE_START_VALIDATION_ERROR + \' \' + Payment.bankInfo.omStartDate\"></span> <span class=error-input ng-show=\"Payment.isOTMStartDate && Payment.formData.sipFirstAmount\" ng-bind=\"Payment.VALIDATE_DATA.DATE_START_FIRST_INSTALLMENT_VALIDATION_ERROR + \' \' + Payment.bankInfo.omStartDate\"></span></td></tr><tr><td>OTM Expiry Date:</td><td>{{Payment.bankInfo.omExpiryDate}} <span class=error-input ng-show=\"Payment.isOTMDate && Payment.formData.purchaseAmount\" ng-bind=\"Payment.VALIDATE_DATA.EXPIRY_DATE_VALID_ERROR + \' \' + Payment.bankInfo.omExpiryDate\"></span> <span class=error-input ng-show=\"Payment.isOTMDate && Payment.formData.sipFirstAmount\" ng-bind=\"Payment.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR  + \' \' + Payment.bankInfo.omExpiryDate\"></span></td></tr></table></div><!-- OTM details selection column ends here--><!-- tnc selection column--><!--                                      <div class=\"row set-margin-top-32 set-margin-bottom-24 \" ng-if=\"Payment.formData.investmentType === \'PURCHASE\'\">--><!--                                        <div class=\"col-md-12\">--><!--                                          <div class=\"checkbox checkbox-neft\">--><!--                                            <input id=\"declaration5\" ng-model=\"isCheckedDeclarationOTM\" type=\"checkbox\" required/>--><!--                                            <i class=\"icon-checkbox\"></i>--><!--                                            <label for=\"declaration3\" class=\"label-black f-family-inter f-weight-400\">--><!--                                              I hereby declare that the funds transferred are from bank account where the first/sole unit holder is one of the bank account holders.--><!--                                            </label>--><!--                                          </div>--><!--                                        </div>--><!--                                      </div>--><!-- tnc selection column ends here --></div><div ng-switch-when=HDFC_Fund_Transfer><div class=row><!-- HDFC Scheme Account Number column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=field-type-2><input type=number ignore-mouse-wheel ng-model=Payment.formData.paymentInfo.schemeAccountNumber name=schemeAccountNumber ng-maxlength=20 ng-minlength=4 limit-to=20 required class=form-control><label>HDFC MF Scheme Account Number</label><span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.required ng-bind=Payment.VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.number ng-bind=Payment.VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_FIELD></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.minlength ng-bind=Payment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE_NEW></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.maxlength ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span></div></div></div><!-- HDFC Investor Account Number column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.accountNumber name=accountNumber ng-maxlength=20 ng-minlength=4 limit-to=20 easyassist-key=mask-element onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=Payment.copyPasteHandler($event) required class=form-control><label>Investor Account Number</label><span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.required ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.maxlength ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.minlength ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE_NEW></span></div></div></div><!-- HDFC Confirm Investor Account Number column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=field-type-2><input type=text ng-keydown=Payment.copyPasteHandler($event) name=verifyAccountNumber ng-maxlength=20 ng-minlength=4 limit-to=20 easyassist-key=mask-element required ng-model=Payment.formData.paymentInfo.verifyAccountNumber ng-pattern=Payment.formData.paymentInfo.accountNumber onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\" class=form-control><label>Confirm Investor Account Number</label><span class=error-input ng-show=tForm.verifyAccountNumber.$dirty&&tForm.verifyAccountNumber.$error.required ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyAccountNumber.$error.required&&tForm.verifyAccountNumber.$error.maxlength ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyAccountNumber.$error.required&&!tForm.verifyAccountNumber.$error.maxlength&&tForm.verifyAccountNumber.$error.pattern&&!tForm.verifyAccountNumber.$error.minlength ng-bind=Payment.VALIDATE_DATA.SAME_INVESTOR_ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=tForm.verifyAccountNumber.$dirty&&tForm.verifyAccountNumber.$error.minlength ng-bind=Payment.VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE_NEW></span></div></div></div><!-- HDFC Account holder name column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.accountHolderName only-alphabets name=accountHolderName required class=form-control><label>Account Holder Name</label><span class=error-input ng-show=tForm.accountHolderName.$dirty&&tForm.accountHolderName.$error.required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_HOLDER_REQUIRED></span></div></div></div><!-- HDFC Bank Branch name column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.bankBranch only-alphabets name=bankBranch required class=form-control><label>HDFC Bank Branch Name</label><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><!-- HDFC Bank Reference Number column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.utrNumber name=utrNumber required ng-maxlength=255 ng-pattern=/^[a-zA-Z0-9]*$/ class=form-control><label>Bank Reference Number</label><span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.maxlength ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.UTR_INVALID></span></div></div></div><!-- HDFC Bank Reference Number column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=field-type-2><input type=text name=verifyUtrNumber ng-maxlength=255 required ng-model=Payment.formData.paymentInfo.verifyUtrNumber ng-pattern=Payment.formData.paymentInfo.utrNumber class=form-control><label>Confirm Bank Reference Number</label><span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyUtrNumber.$error.required&&tForm.verifyUtrNumber.$error.maxlength ng-bind=Payment.VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyUtrNumber.$error.required&&!tForm.verifyUtrNumber.$error.maxlength&&tForm.verifyUtrNumber.$error.pattern ng-bind=Payment.VALIDATE_DATA.SAME_BANK_REFERENCE_NUMBER_RANGE></span></div></div></div><!-- HDFC ifsc code selection column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX class=form-control capitalize><label>IFSC Code</label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div></div><!-- HDFC Account type selection column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=field-type-2><select name=accountType ng-model=Payment.formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required class=form-select><option value=\"\">Account Type</option></select><label ng-if=Payment.formData.paymentInfo.accType>Account Type</label><span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div><!-- HDFC upload column--><div class=row><div class=col-md-12><div ng-class=\"{\'upload-box-container\' : !Payment.fileType, \'file-upload\' : Payment.fileType}\"><div class=upload-box><div class=upload-box-items><div ng-if=!Payment.fileType class=upload-block><img src=assets/images/icons/payment-journey/upload-solid.svg alt=upload></div><label ng-if=!Payment.fileType class=\"label-black f-family-inter f-weight-400\">Upload bank statement</label><div class=file-info-container ng-if=Payment.fileType><img ng-if=\"Payment.fileType == \'pdf\'\" src=../../../../assets/images/icons/payment-journey/pdf-uploaded.svg alt=pdf-logo> <img ng-if=\"Payment.fileType == \'tif\'\" src=../../../../assets/images/icons/payment-journey/tif-uploaded.svg alt=tif-logo> <img ng-if=\"Payment.fileType == \'tiff\'\" src=../../../../assets/images/icons/payment-journey/tiff-uploaded.svg alt=tiff-logo> <img ng-if=\"Payment.fileType == \'jpg\'\" src=../../../../assets/images/icons/payment-journey/jpg-uploaded.svg alt=jpg-logo> <img ng-if=\"Payment.fileType == \'jpeg\'\" src=../../../../assets/images/icons/payment-journey/jpeg-uploaded.svg alt=jpeg-logo><div class=file-info><p>{{Payment.fileName}}</p><span>{{Payment.displaySize}}</span> <span>{{Payment.dateUploaded}}</span></div></div><input class=file-select id=uploadCheckLeaf type=file name=pic accept=\"image/*, application/*\" file-model-profile=chequeLeaf upload=\"Payment.bankUploadChequeLeafFile(file,\'web\')\" ng-model=Payment.formData.paymentInfo.chequeLeaf required></div></div><div class=info-upload><!--                                              <p ng-if=\"!Payment.fileType\">Supported file formats are .jpeg, .jpg, .tiff, .tif, .pdf</p>--> <button ng-click=Payment.chequeLeafReadMore() ng-if=!Payment.fileType>Read instructions</button> <img ng-if=\"Payment.fileType && (Payment.fileType == \'pdf\' || Payment.fileType == \'tif\' ||  Payment.fileType == \'tiff\')\" ng-click=Payment.downloadPdfFile(Payment.bankchequeLeafUrl,Payment.fileType) class=download-btn-new src=../../../../assets/images/icons/payment-journey/download-icon.svg alt=download> <span ng-if=\"Payment.fileType && Payment.fileType !== \'pdf\' && Payment.fileType !== \'tif\' && Payment.fileType !== \'tiff\'\" ng-click=Payment.openUploadedDoc(Payment.formData.paymentInfo.chequeLeaf)>Preview</span></div></div></div></div><!-- HDFC TNC column--><!--                                      <div class=\"row set-margin-top-32 set-margin-bottom-24\">--><!--                                        <div class=\"col-md-12\">--><!--                                          <div class=\"checkbox checkbox-rtgs\">--><!--                                            <input id=\"declaration0\" ng-model=\"isCheckedDeclaration\" type=\"checkbox\" required/>--><!--                                            <i class=\"icon-checkbox\"></i>--><!--                                            <label for=\"declaration0\" class=\"label-black f-family-inter f-weight-400\">--><!--                                              I hereby declare that the funds transferred are from bank account where the first/sole unit holder is one of the bank account holders.--><!--                                            </label>--><!--                                          </div>--><!--                                        </div>--><!--                                      </div>--><!-- HDFC TNC column--></div><div ng-switch-when=Biller><div class=row><!-- Biller bank selection column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=search-input><input type=text name=ECbank id=ECbank ng-model=Payment.bankInfo.maskedBankName ng-change=Payment.changeBank() class=form-select ng-init=\"Payment.bankInfo = Payment.bankInfo ? Payment.bankInfo: null\" autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly><label>Select Bank</label><span class=error-input ng-show=\"tForm.ECbank.$dirty && tForm.ECbank.$error.required\" ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.billerBankList display-key=bankNameOnly display-key-second=maskedAccountNumber hdfc-click=Payment.changeBank() model=Payment.bankInfo for=ECbank></bank-drop-down></div></div></div><!-- Biller bank code selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-bottom-18\" ng-if=\"Payment.bankInfo.bankCode == \'OTHER\'\"><div class=form-input><div class=field-type-2><input type=text ng-disabled=\"Payment.bankInfo.bankCode != \'OTHER\'||!fForm.$valid\" ng-model=Payment.formData.bankName name=bankName ng-required=\"Payment.bankInfo.bankCode == \'OTHER\'\" class=form-control><label>Bank Name</label><span class=error-input ng-show=\"tForm.bankName.$dirty && tForm.bankName.$error.required\" ng-bind=Payment.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div></div><!-- Biller ifsc code selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-bottom-18\" ng-if=\"Payment.bankInfo && !Payment.bankInfo.ifscCode\"><div class=form-input><div class=field-type-2><input type=text ng-model=Payment.formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX class=form-control capitalize><label>IFSC Code</label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=Payment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div></div><!-- Biller Account type selection column (if not available in selected bank)--><div class=\"col-md-12 set-margin-bottom-18\" ng-if=\"Payment.bankInfo && !Payment.bankInfo.bankAcType\"><div class=form-input><div class=field-type-2><select name=accountType ng-model=Payment.formData.paymentInfo.accType class=form-select ng-init=\"Payment.formData.paymentInfo.accType = Payment.formData.paymentInfo.accType ? Payment.formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required><option class=set-select-label-color-grey value=\"\">Select Account Type</option></select><label ng-if=Payment.bankInfo.bankAcType>Account Type<span class=\"req text-red\">*</span></label><span class=error-input ng-messages=tForm.accountType.$error ng-show=tForm.accountType.$dirty><span ng-message=required ng-bind=Payment.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div></div><div ng-switch-when=E_Mandate><div class=row ng-if=\"(!Payment.emailExist || !Payment.mobileExist || Payment.isEmailMobileinValid)\"><!-- mandate error message column--><div class=col-md-12><span class=error-input ng-show=\"!Payment.mobileExist && !Payment.isEmailMobileinValid\" ng-bind=Payment.VALIDATE_DATA.INVALID_MOBILE_EMANDATE></span> <span class=error-input ng-show=\"!Payment.emailExist && !Payment.isEmailMobileinValid\" ng-bind=Payment.VALIDATE_DATA.INVALID_EMAIL_EMANDATE></span> <span class=error-input ng-show=Payment.isEmailMobileinValid ng-bind=Payment.VALIDATE_DATA.INVALID_EMAIL_MOBILE_EMANDATE></span></div><!-- mandate error message column ends here --></div><div class=row ng-if=\"(Payment.emailExist && Payment.mobileExist)\"><!-- mandate bank selection column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=search-input><input type=text name=bankMandate id=bankMandate ng-model=Payment.bankInfo.maskedBankName ng-change=Payment.changeBank() class=form-select autocomplete=off ng-required=!Payment.bankInfo only-alphabets readonly><label>Select Bank</label><span class=error-input ng-show=\"tForm.bankMandate.$dirty && tForm.bankMandate.$error.required\" ng-bind=Payment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Payment.mandateBankList display-key=bankNameOnly display-key-second=maskedBankAcNo hdfc-click=Payment.changeBank() model=Payment.bankInfo for=bankMandate></bank-drop-down></div></div></div><!-- mandate auth mode selection column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=field-type-2><select name=authenticationMode ng-disable=!Payment.authenticationMode ng-model=Payment.formData.authMode ng-options=\"auth.text for auth in Payment.authenticationMode\" required class=form-select><option value=\"\" selected>{{Payment.authenticationMode&&!Payment.authenticationMode.length ?\'No Authentication Mode Available\':\'Authentication Mode\'}}</option></select><label ng-if=Payment.formData.authMode>Authentication Mode</label><span class=error-input ng-show=\"tForm.authenticationMode.$dirty && tForm.authenticationMode.$error.required && !Payment.formData.authMode\" ng-bind=Payment.VALIDATE_DATA.AUTHENTICATION_MODE_REQUIRED></span></div></div></div><!-- mandate amount selection column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=\"field-type-2 mandate-amount-payment\"><input type=text name=eAmount ng-model=Payment.formData.displayAmountMandate ng-change=Payment.checkAmountValidationEmandate(true) maxlength=16 ng-maxlength=16 class=form-control><label>Mandate Amount</label><i class=rupee-black-icon></i><div class=amtWords ng-if=Payment.formData.emandateAmount><p id=amountInwordsEmandate>{{Payment.formData.emandateWord.amountInWords}} (In Words)</p></div><div class=error-input ng-show=Payment.amountLess>{{Payment.VALIDATE_DATA.EMANDATE_MIN_ERROR + Payment.emandateMinAmountLimit}}.</div><div class=error-input ng-show=Payment.amountMore>{{Payment.VALIDATE_DATA.EMANDATE_MAX_ERROR + Payment.mandateMaxString}}.</div><div class=error-input ng-show=\"!Payment.amountLess && Payment.isLessThanSipAmount\" ng-bind=Payment.VALIDATE_DATA.EMANDATE_SIP_AMOUNT_ERROR></div><div class=error-input ng-show=!Payment.formData.emandateAmount ng-bind=Payment.VALIDATE_DATA.MANDATE_AMOUNT_REQUIRED></div></div></div></div><!-- mandate start date column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=\"field-type-2 mandate-start-date-payment\"><div><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" class=form-control ng-model=Payment.displayMandateDate readonly><label>Mandate Start Date</label></div></div></div></div><!-- mandate end date column--><div class=\"col-md-12 set-margin-bottom-18\"><div class=form-input><div class=\"field-type-2 mandate-end-date-payment\"><div class=\"input-normal verify-acc input-group date date-picker transaction-cal eEndDate form-control\" ng-class=\"{error:tForm.endDateEmandate.$dirty && tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=Payment.formData.endDateEmandate data-enabled-dates=Payment.enabledEmandateEndDatesList data-view-date=Payment.enabledEndDateView data-max-date=Payment.maxEndDateEmandate data-min-date=Payment.minEndDateEmandate data-on-date-change=Payment.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><input type=text name=endDateEmandate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly><label>Mandate End Date</label><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><span style=\"word-spacing: -1px\" class=error-input ng-show=Payment.sipDateLessEmandate ng-bind=Payment.VALIDATE_DATA.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div></div></div></div></form><!--other payment options section ends here--></div><!--other payment options responsive section ends here--></div></div></div></div><div class=\"row error-input text-center mt-2\" ng-if=\"!Payment.formData.selectedPaymentOption && Payment.paymentOptions.length === 0\"><p class=error>No valid payment mode available to proceed with transaction.</p></div></div></div><!-- payment selection field ends here--></div></div></div><!--bill desk form section starts here--><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{Payment.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=Payment.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=Payment.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=Payment.billdeskPayload.msg></form><!--bill desk form section ends here--></div></div></div>");
$templateCache.put("app/payment/templates/footer/footer.html","<div><div class=footerSubDiv><img src=../../../assets/images/hdfcmf-Main.png alt=\"\" style=\"height: 20px\"><p class=footerSubHeading>Managed by HDFC MF Limited.<a href={{Payment.CORPORATE_URL}} target=_blank style=\"color: blue;font-weight: 500\">Learn More</a>.</p></div></div>");
$templateCache.put("app/payment/templates/header/header.html","<div class=\"payment-header text-center\"><div class=logo-btn-container><img ng-if=Payment.successBackUrl ng-click=Payment.handleBackRedirection() class=back-btn src=assets/images/icons/payment-journey/back-arrow.svg alt=HDFC class=logo> <img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo> <span></span></div><p class=expired-text ng-if=!Payment.formData>Expired</p><p ng-if=Payment.formData class=mb-2>Choose Your Payment Option</p><p ng-if=Payment.formData class=amount-info>₹ {{Payment.utilService.getCommaSeperatedString(Payment.formData.purchaseAmount ? Payment.formData.purchaseAmount : Payment.formData.amount)}}</p></div>");
$templateCache.put("app/payment/templates/investor-details/investor-details.html","<div class=\"row investor-details-section\"><div class=\"col-md-12 info-name-details\"><div class=\"col-md-12 p-0 info-name-container\"><div class=image-section><img http-src={{Payment.profileImageUrl}} alt=user></div><div><span class=info-name>Hi {{Payment.formData.investorName}}</span><p class=info-description>Embark on a journey towards achieving your goal.</p></div></div></div><div class=\"col-md-12 investor-detail\"><div class=\"col-md-12 p-0\"><hr><p>Folio: <span>{{Payment.formData.folioNumber}}</span></p><p>Investing Through: <span>{{Payment.investThrough}}</span></p><!--ria details starts here --><p ng-if=Payment.formData.isThroughRia>RIA Code: <span>{{Payment.formData.riaBrokerCode}}</span></p><p ng-if=Payment.formData.isThroughRia>RIA Name: <span>{{Payment.formData.riaBrokerName}}</span></p><!--distributor details starts here --><p ng-if=\"Payment.formData.isThroughDistributor && Payment.formData.brokerCode\">Distributor ARN: <span>{{Payment.formData.brokerCode}}</span></p><p ng-if=\"Payment.formData.isThroughDistributor && Payment.formData.euin.euinCode\">EUIN Code: <span>{{Payment.formData.euin.euinCode}}</span></p><p ng-if=\"Payment.formData.isThroughDistributor && Payment.formData.euin.euinName\">EUIN Name: <span>{{Payment.formData.euin.euinName}}</span></p><p ng-if=\"Payment.formData.isThroughDistributor && Payment.formData.subBrokerARN\">Sub Broker ARN: <span>{{Payment.formData.subBrokerARN}}</span></p><p ng-if=\"Payment.formData.isThroughDistributor && Payment.formData.subBrokerCode\">Sub Broker Code: <span>{{Payment.formData.subBrokerCode}}</span></p></div></div></div>");
$templateCache.put("app/payment/templates/loader/loader.html","<div ng-class=\"{\'gateway-payment\': Payment.sourcePortal !== \'INVESTOR\'}\"><section><div class=modal-content id=loginLoader tabindex=-1><div ng-class=\"{\'loader-payment\': Payment.sourcePortal === \'INVESTOR\'}\" class=\"modal-body main-loader\"><p class=blacktintLoad></p><div class=\"loader-box-content text-center\"><p><img src=../assets/images/logo-main.png alt=HDFC></p><p><img src=../assets/images/logo.png alt=\"Partner\'s Logo\"></p><h3 class=text-primary>Welcome {{ApiGateWay.investorName || \'Investor\' | camelcase}}</h3><p>Please wait while we fetch your details.</p><img src=../assets/images/loader_web.gif alt=loader class=loader-gif><br><timer ng-if=\"Payment.sourcePortal !== \'INVESTOR\'\" interval=1000>{{minutes}}:{{seconds}}</timer></div></div></div></section></div>");
$templateCache.put("app/transactions/favourite/components/favouriteTransactionsTupple.html","<div class=\"col-md-3 col-sm-6\" ng-repeat=\" item in list | limitTo: limit  track by $index\"><div class=favourite-block><div class=\"fav-head container-fluid\"><span class=pull-left>Folio No: {{item.folioNumber}}</span> <span class=pull-right>{{item.initiatedDate}}</span></div><div class=fav-body><ul><li class=text-primary>{{item.transactionType == \'DTP\' ? \'TIP\' : item.transactionType}}</li><li>{{item.schemeName}}</li></ul></div><div class=fav-foot><div class=fav-btn><i class=edit-icon ng-click=\"edit({tID:item.transactionId,ctID:item.compositeTransactionId,tType:item.transactionType, tFolio:item.folioNumber,validFolio:item.validFlag,folioMsg:item.invalidFolioMessage})\"></i></div><div class=fav-btn ng-if=\"item.transactionType==\'LUMPSUM\'\"><i class=cart-blue-icon ng-click=cart()></i></div><div class=fav-btn><i class=delete-red-icon ng-click=delete(item)></i></div></div></div></div><h5 class=\"text-center alternate-text\" ng-if=\"list.length<=0\">You have not set any favourite transaction(s).</h5><div ng-if=\"list.length>0\" class=\"col-md-12 text-right\" ng-show=showViewMoreFlag><span ng-click=showMore() class=text-primary>View More</span></div>");
$templateCache.put("app/transactions/initiate/dream-sip/dream-sip.html","<div class=\"main-section clearfix\" ng-hide=DreamSip.formData.isSummaryViewEnabled><section class=\"initiate-transaction sipPurchase\" ng-init=DreamSip.init()><p class=page-title>Dream SIP</p><header><form name=fForm novalidate ng-keypress=DreamSip.handleEnter($event) autocomplete=off><div ng-class=\"{\'anything-disabled\': DreamSip.formData.dynamicData.readOnly }\" class=\"folio-check pull-left\">Existing Folio No :<select name=folio id=_first ng-change=DreamSip.folioChanged() ng-model=DreamSip.formData.folioNumber ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in DreamSip.folioList\" ng-init=\"DreamSip.formData.folioNumber=DreamSip.formData.folioNumber?DreamSip.formData.folioNumber: null\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=DreamSip.isRequired><option value=\"\">Select Folio</option></select><span class=error-input ng-show=\"DreamSip.tForm.folio.$dirty && DreamSip.tForm.folio.$invalid && DreamSip.tForm.folio.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.FOLIO_REQUIRED></span></div></form></header><fieldset ng-class=\"{\'anything-disabled\': !DreamSip.formData.folioNumber }\"><div class=content-area><form name=DreamSip.tForm novalidate autocomplete=off><div class=col-md-12><div class=\"row borderline\"><div class=\"col-md-12 row\"><table class=\"table borderless top-part\"><tr><td>Investor Name</td><td>:</td><td>{{DreamSip.folioInvestorName||DreamSip.formData.folioInvestorName}}</td></tr><tr><td>Invest through</td><td>:</td><td><div ng-class=\"{\'anything-disabled\': DreamSip.formData.dynamicData.readOnly }\" class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=DreamSip.formData.isDirect ng-disabled=!fForm.$valid ng-click=\"DreamSip.changeThroughDistributor(\'DIRECT\')\"> <span class=check></span> </span><span class=radio-label>Direct</span></div><div ng-class=\"{\'anything-disabled\': DreamSip.formData.dynamicData.readOnly }\" class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=DreamSip.formData.isThroughDistributor ng-disabled=!fForm.$valid ng-click=\"DreamSip.changeThroughDistributor(\'ARN\')\"> <span class=check></span> </span><span class=radio-label>Distributor</span></div><div ng-class=\"{\'anything-disabled\': DreamSip.formData.dynamicData.readOnly }\" class=radio-block><span class=radio><input type=radio name=investThrough ng-value=true ng-model=DreamSip.formData.isThroughRia ng-disabled=!fForm.$valid ng-change=\"DreamSip.changeThroughDistributor(\'RIA\')\"> <span class=check></span> </span><span class=radio-label>RIA</span></div></td></tr><tr ng-if=DreamSip.formData.isThroughDistributor><td></td><td></td><td><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class=\"{error:(DreamSip.tForm.brokerCode.$dirty&&DreamSip.tForm.brokerCode.$invalid)||(DreamSip.brokerCodeError != \'\')}\"><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=DreamSip.formData.brokerCode ng-change=DreamSip.changeDistributorCode() autocomplete=off ng-blur=\"DreamSip.searchDistributor();DreamSip.showArnLabel=false\" ng-required=!DreamSip.formData.distributorARN maxlength=10 ng-pattern=/^[0-9]{4,10}$/ ng-focus=\"DreamSip.showArnLabel=true\"> <span class=highlight></span> <span class=bar></span> <span class=arn ng-show=\"DreamSip.showArnLabel || DreamSip.formData.brokerCode\">ARN -</span><label>ARN</label><p ng-if=DreamSip.formData.brokerName class=info-primary>Distributor Name: {{DreamSip.formData.brokerName}}</p><span class=error-input ng-show=\"(DreamSip.tForm.brokerCode.$dirty && DreamSip.tForm.brokerCode.$invalid &&DreamSip.tForm.brokerCode.$error.required) && (!DreamSip.formData.distributorName)\" ng-bind=DreamSip.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(DreamSip.tForm.brokerCode.$dirty && DreamSip.tForm.brokerCode.$invalid &&DreamSip.tForm.brokerCode.$error.pattern) && (!DreamSip.formData.distributorName)\" ng-bind=DreamSip.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"DreamSip.brokerCodeError !== \'\' && !DreamSip.tForm.brokerCode.$invalid\" ng-bind=DreamSip.brokerCodeError></span></div></div><span class=\"col-sm-12 col-md-1 or-part text-center\">OR</span><div class=\"col-sm-12 col-md-3\"><div class=\"input-select input-normal\" ng-class=\"{error:DreamSip.tForm.distributorName.$dirty && DreamSip.tForm.distributorName.$invalid}\"><input type=text name=distributorName id=distributorName ng-change=\"DreamSip.searchDistributorByName();DreamSip.formData.isEuin=true\" ng-model=DreamSip.formData.distributorName autocomplete=off ng-required=!DreamSip.formData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><label>Search Distributor</label><drop-down list-data=DreamSip.distributorList display-key=name display-key-second=arnCode hdfc-click=DreamSip.distributorListChanged(data) model=DreamSip.formData.distributorARN for=distributorName></drop-down></div></div></td></tr><!--RIA sections--><tr ng-if=DreamSip.formData.isThroughRia><td>RIA Code</td><td>:</td><td><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class=\"{error:(DreamSip.tForm.riaCode.$dirty && DreamSip.tForm.riaCode.$invalid)||(DreamSip.riaCodeError != \'\')}\"><input type=text name=riaCode id=riaCode ng-model=DreamSip.formData.riaBrokerCode ng-change=DreamSip.changeDistributorCode() autocomplete=off ng-blur=DreamSip.searchDistributor(); ng-required=!DreamSip.formData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span><!--<p ng-if=\"DreamSip.formData.brokerName\" class=\"info-primary\">Distributor Name: {{DreamSip.formData.brokerName}}</p>--> <span class=error-input ng-show=\"(DreamSip.tForm.riaCode.$dirty && DreamSip.tForm.riaCode.$invalid &&DreamSip.tForm.riaCode.$error.required)\" ng-bind=DreamSip.VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(DreamSip.tForm.riaCode.$dirty && DreamSip.tForm.riaCode.$invalid &&DreamSip.tForm.riaCode.$error.pattern)\" ng-bind=DreamSip.VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"DreamSip.riaCodeError !== \'\' && !DreamSip.tForm.riaCode.$invalid\" ng-bind=DreamSip.riaCodeError></span></div></div></td></tr><!--RIA sections ends here--></table><fieldset ng-class=\"{\'anything-disabled\': DreamSip.isArnSuccess || DreamSip.brokerCodeError !==\'\'}\"><table class=\"table borderless top-part\"><tr ng-if=DreamSip.formData.isThroughDistributor><td></td><td></td><td><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class=\"{error:(DreamSip.tForm.subBrokerARN.$dirty&&DreamSip.tForm.subBrokerARN.$invalid)||(DreamSip.subBrokerCodeError !== \'\')}\"><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=DreamSip.formData.subBrokerARN ng-change=DreamSip.changeSubBrokerArn() ng-blur=DreamSip.fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>Sub Broker ARN</label><p ng-if=DreamSip.subBrokerName class=info-primary>Sub Broker Name: {{DreamSip.subBrokerName}}</p><span class=error-input ng-show=\"(DreamSip.tForm.subBrokerARN.$dirty && DreamSip.tForm.subBrokerARN.$invalid && DreamSip.tForm.subBrokerARN.$error.pattern)\" ng-bind=DreamSip.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"DreamSip.subBrokerCodeError != \'\'&& !DreamSip.tForm.subBrokerARN.$error.pattern\" ng-bind=DreamSip.subBrokerCodeError></span></div></div><span class=\"col-sm-12 col-md-1\"></span><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class={error:DreamSip.tForm.subBrokerCode.$dirty&&DreamSip.tForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=DreamSip.formData.subBrokerCode autocomplete=off ng-disabled=\"!DreamSip.formData.subBrokerARN || DreamSip.subBrokerCodeError !=\'\'\" ng-required=DreamSip.formData.subBrokerARN restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<span ng-if=DreamSip.formData.subBrokerARN class=req>*</span></label><span class=error-input ng-show=DreamSip.tForm.subBrokerCode.$dirty&&DreamSip.tForm.subBrokerCode.$error.required ng-bind=DreamSip.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></td></tr><tr ng-if=DreamSip.formData.isThroughDistributor><td></td><td></td><td><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=true ng-model=DreamSip.formData.isEuin ng-click=\"DreamSip.isCheckedTandC=false\" required> <span class=check></span> </span><span class=radio-label>EUIN</span></div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=false ng-model=DreamSip.formData.isEuin ng-click=\"DreamSip.euinData.euinNameCode=\'\';DreamSip.filterEuinList();DreamSip.isSelectedEuin=true;\"> <span class=check></span> </span><span class=radio-label>EUIN Declaration</span></div></td></tr><tr ng-if=\"DreamSip.formData.isEuin != null && DreamSip.formData.isEuin === false && DreamSip.formData.isThroughDistributor\" ng-hide=!DreamSip.distributorMessage><td></td><td></td><td><div class=checkbox><input ng-model=DreamSip.isCheckedTandC type=checkbox ng-disabled=DreamSip.formData.isEuin ng-required=\"(DreamSip.formData.brokerCode || !DreamSip.isArnSuccess) && !DreamSip.formData.isEuin\"> <i class=icon-checkbox></i><ng-bind-html ng-bind-html=DreamSip.distributorMessage.content></ng-bind-html></div></td></tr><tr ng-if=\"DreamSip.formData.isEuin != null && DreamSip.formData.isEuin === true &&  DreamSip.formData.isThroughDistributor\"><td></td><td></td><td><div class=\"input-select input-normal selectfield\" ng-class={error:DreamSip.tForm.euin.$dirty&&DreamSip.tForm.euin.$invalid}><input type=text name=euin id=euin ng-model=DreamSip.euinData.euinNameCode ng-change=DreamSip.filterEuinList() ng-required=\"(DreamSip.formData.brokerCode || DreamSip.formData.distributorName) && !DreamSip.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Select Euin</label><!--ng-disabled=\"!DreamSip.euinList.length || DreamSip.isArnSuccess || (DreamSip.formData.subBrokerARN && DreamSip.isSubarnSuccess)\"--> <span class=error-input ng-show=\"(DreamSip.tForm.euin.$dirty&&DreamSip.tForm.euin.$error.required) || !DreamSip.isSelectedEuin\" ng-bind=DreamSip.VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=DreamSip.euinList display-key=euinName display-key-second=euinCode hdfc-click=DreamSip.selectEuin(data) model=DreamSip.formData.euin for=euin></list-drop-down></div></td></tr></table></fieldset><fieldset ng-class=\"{\'anything-disabled\': !DreamSip.formData.riaBrokerCode || DreamSip.riaCodeError !== \'\'}\" ng-hide=!DreamSip.riaMessage><table class=\"table borderless top-part\"><tr ng-if=DreamSip.formData.isThroughRia><td><div class=checkbox><input ng-model=DreamSip.isCheckedTandC type=checkbox ng-disabled=\"!DreamSip.formData.riaBrokerCode || DreamSip.riaCodeError !== \'\'\" ng-change=DreamSip.setTandCVariable(); ng-required=DreamSip.formData.riaBrokerCode> <i class=icon-checkbox></i><ng-bind-html ng-bind-html=DreamSip.riaMessage.content></ng-bind-html></div></td></tr></table></fieldset></div></div><!-- start choose folio --><!-- <div class=\"row\">\n            <label class=\"form-label less\">Do you want to create New folio for Dream SIP?</label>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-3 form-group\">\n              <div class=\"radio-block\" ng-repeat=\"option in DreamSip.folioOption\">\n                <span class=\"radio\">\n                  <input type=\"radio\" id=\"{{option.title+\'1\'}}\"\n                    ng-model=\"DreamSip.formData.CREATE_NEW_FOLIO\" ng-disabled=\"!fForm.$valid\" ng-value=\"option.value\"\n                    name=\"folioOption\" />\n                  <span class=\"check\"></span>\n                </span>\n                <span class=\"radio-label\">{{option.title}}</span>\n              </div>\n            </div>\n          </div> --><!-- end choose folio --><div class=row><label class=\"form-label less\">Select Option</label></div><div class=row><div class=\"col-sm-12 col-md-3 form-group\"><div class=radio-block ng-repeat=\"option in DreamSip.optionList\"><span class=radio><input type=radio id=\"{{option.key+\'1\'}}\" ng-change=DreamSip.changeOption() ng-model=DreamSip.formData.option ng-disabled=!fForm.$valid ng-value=option.value name=option> <span class=check></span> </span><span class=radio-label>{{option.value}}</span></div></div><div class=\"col-sm-12 col-md-9\"><div class=\"point-to-note imp-info ng-scope\" style=\"margin: 0px 0 10px\">Please Note:<br><br><p><i class=dot></i> <span>Click to download <a ng-click=\"DreamSip.openDreamDocumentFile(\'https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/HDFC+Dream+SIP+-+Presentation.pdf\')\" href=javascript:void(0) class=nav-faq-link><b>Dream SIP Presentation</b></a> and <a ng-click=\"DreamSip.openDreamDocumentFile(\'https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/HDFC+Dream+SIP+-+FAQs.pdf\')\" href=javascript:void(0) class=nav-faq-link><b>Dream SIP FAQs</b></a>.</span></p><p><i class=dot></i> <span>Under Option A - SIP and SWAP shall trigger in the same scheme.</span></p><p><i class=dot></i> <span>Under Option B - SIP shall be registered in source sheme, while SWAP shall get triggered in Target scheme after switching entire units from source to Target scheme. </span></p></div></div></div><div class=row><label class=\"form-label less\">Add Scheme</label></div><div class=row><div class=\"col-sm-12 col-md-3 row\"><div class=\"input-select input-normal\" ng-class=\"{error:DreamSip.tForm.sInScheme1.$dirty && DreamSip.tForm.sInScheme1.$invalid,\n                     \'anything-disabled\': DreamSip.formData.dynamicData.readOnly }\"><input type=text name=sInScheme1 id=sInScheme1 ng-change=DreamSip.filterInSchemeList() ng-model=DreamSip.formData.inSchemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off ng-disabled=!fForm.$valid required> <span class=highlight></span> <span class=bar></span><label ng-if=\"DreamSip.formData.option == \'Option A\'\">Select a Scheme</label><label ng-if=\"DreamSip.formData.option == \'Option B\'\">Select Source Scheme</label><span class=error-input ng-show=\"DreamSip.tForm.sInScheme1.$dirty && DreamSip.tForm.sInScheme1.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=DreamSip.inSchemeList display-key=scheme hdfc-click=\"DreamSip.inSchemeChanged(data, \'sip\')\" model=DreamSip.formData.inSchemeCode for=sInScheme1></drop-down><p class=info-primary>{{DreamSip.formData.inSchemeName}}</p></div></div><div ng-if=!DreamSip.formData.dynamicData.readOnly class=\"col-sm-12 col-md-offset-1 col-md-4 scheme-invoke\"><span>OR</span> <span class=\"text-primary cursor-pointer\" ng-click=fForm.$valid&&DreamSip.schemeListModal()><i class=list-icon></i> Select from List</span></div></div><div class=row ng-if=\"DreamSip.formData.option == \'Option B\'\"><div class=\"col-sm-12 col-md-3 row\"><div class=\"input-select input-normal\" ng-class=\"{error:DreamSip.tForm.tagetScheme.$dirty && DreamSip.tForm.tagetScheme.$invalid,\n                     \'anything-disabled\': DreamSip.formData.dynamicData.readOnly }\"><input type=text name=tagetScheme id=tagetScheme ng-change=DreamSip.filterInTargetSchemeList() ng-model=DreamSip.formData.targetSchemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off ng-disabled=!fForm.$valid required> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><span class=error-input ng-show=\"DreamSip.tForm.tagetScheme.$dirty && DreamSip.tForm.tagetScheme.$error.required\">Target scheme is required</span><drop-down list-data=DreamSip.targetSchemeList display-key=scheme hdfc-click=\"DreamSip.targetSchemeChanged(data, \'sip\')\" model=DreamSip.formData.targetSchemecode for=tagetScheme></drop-down><p class=info-primary>{{DreamSip.formData.targetSchemeName}}</p></div></div><!-- <div ng-if=\"!DreamSip.formData.dynamicData.readOnly\" class=\"col-md-offset-1 col-md-4 scheme-invoke\">\n                <span>OR</span>\n                <span class=\"text-primary cursor-pointer\" ng-click=\"fForm.$valid&&DreamSip.schemeListModal()\"><i\n                    class=\"list-icon\"></i> Select from List </span>\n              </div> --></div><div class=row><label class=\"form-label less\">Installment Frequency</label></div><div class=row><div class=\"col-sm-12 col-md-6 form-group\"><div class=radio-block><span class=radio><input type=radio id=frq1 ng-model=DreamSip.formData.frequency ng-disabled=!fForm.$valid value=OM name=installmentFrequency> <span class=check></span> </span><span class=radio-label>Monthly</span></div></div></div><div class=row><label class=\"form-label less\">Select SIP Period (in years)</label></div><div class=row><div class=\"col-sm-12 col-md-3 row\"><div class=selectfield><select class=select-box name=sipPeriod ng-model=DreamSip.formData.sipPeriod ng-init=\"DreamSip.formData.sipPeriod = 20 \" ng-change=DreamSip.changeSipPeriod() ng-options=\"sipPeriod.value as (sipPeriod.value + \' years\')  for sipPeriod in DreamSip.sipPeriodArray\" required></select></div></div></div><!-- ng-selected = \"DreamSip.formData.sipPeriod = sipPeriod.value\" --><div class=row ng-class=\"{\'anything-disabled\': !DreamSip.formData.inSchemeName }\"><div class=\"col-sm-12 col-md-3 row\"><div class=\"input-normal icon-input\" ng-class=\"{error:(DreamSip.tForm.sAmount.$invalid && DreamSip.tForm.sAmount.$dirty),\'has-data\':DreamSip.formData.amount}\"><input type=number ignore-mouse-wheel name=sAmount ng-model=DreamSip.formData.amount ng-disabled=!fForm.$valid ng-change=DreamSip.checkSipValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" required> <span class=highlight></span> <span class=bar></span><label>SIP Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"DreamSip.tForm.sAmount.$dirty && DreamSip.tForm.sAmount.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"DreamSip.formData.amount && DreamSip.isMin\" class=error-input>Minimum amount should be &#8377; {{DreamSip.validations.minAmount|unit}}</span> <span ng-if=\"DreamSip.formData.amount && DreamSip.isMax && DreamSip.formData.sipPaymentOption != DreamSip.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=error-input>Maximum amount should be &#8377; {{DreamSip.validations.maxAmount|unit}}</span> <span ng-if=\"DreamSip.formData.amount && !DreamSip.isMax && !DreamSip.isMin && (DreamSip.validations.amountMultiples&&!DreamSip.isMultiples)\" class=error-input>Please Provide in multiples of &#8377; {{DreamSip.validations.amountMultiples|unit}}</span></div><div class=form-group><label id=divDisplayWords>{{DreamSip.amountInWords}} (In Words)</label></div></div></div><div class=row ng-class=\"{\'anything-disabled\': !DreamSip.formData.amount }\"><div class=\"col-sm-12 col-md-3 row\"><div class=\"input-normal icon-input\" ng-class=\"{error:(DreamSip.tForm.swapAmount.$invalid && DreamSip.tForm.swapAmount.$dirty),\'has-data\':DreamSip.formData.swapAmount}\"><input type=number ignore-mouse-wheel name=swapAmount ng-model=DreamSip.formData.swapAmount ng-disabled=!fForm.$valid ng-change=DreamSip.checkSwapValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords1\')\" required> <span class=highlight></span> <span class=bar></span><label>SWAP Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"DreamSip.tForm.swapAmount.$dirty && DreamSip.tForm.swapAmount.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"DreamSip.formData.swapAmount && DreamSip.isSwapMin\" class=error-input>Minimum amount cannot be less than &#8377; {{DreamSip.validations.swpValidationDTO.monMinAmt|unit}}</span> <span ng-if=\"DreamSip.formData.swapAmount && DreamSip.isSwapMax \" class=error-input>Maximum amount cannot be greater than &#8377; {{DreamSip.maxSwapAmount|unit}}</span> <span ng-if=\"DreamSip.formData.amount && DreamSip.formData.swapAmount && !DreamSip.isSwapMax && !DreamSip.isSwapMin && (DreamSip.validations.amountMultiples&&!DreamSip.isSwapMultiples)\" class=error-input>Please Provide in multiples of &#8377; {{DreamSip.validations.swpValidationDTO.monAmtMultiples|unit}}</span></div><div class=form-group ng-if=DreamSip.formData.swapAmount><label id=divDisplayWords1>{{DreamSip.amountInWords}} (In Words)</label></div></div><div class=\"col-sm-12 col-md-9\"><div class=\"point-to-note imp-info ng-scope\" style=\"margin: 0px 0 10px\">Please Note:<br><br><p><i class=dot></i> <span>SWAP amount cannot be greater than pre-defined amount set for each SIP period.<a ng-click=DreamSip.DreamSipTenure() href=javaScript:void(0)>Click here</a> to know maximum SWAP amount allowed for each SIP period.</span></p></div></div></div><!-- <div class=\"row\">\n              <div class=\"col-md-12 row\">\n                <label class=\"form-label\">Do you wish to pay First installment with your SIP Registration:</label>\n\n                <div class=\"radio-block first-installment-radio  anything-disabled\">\n                                <span class=\"radio\">\n                                  <input type=\"radio\" name=\"sipFirstInstallment\"\n                                         ng-model=\"DreamSip.formData.sipFirstInstallment\"\n                                         ng-change=\"DreamSip.changeFirstInstallment(true)\"\n                                         ng-value=\"true\"/>\n                                  <span class=\"check\"></span>\n                                </span>\n                  <span class=\"radio-label\">Yes</span>\n                </div>\n\n                <div class=\"radio-block first-installment-radio  anything-disabled\">\n                                 <span class=\"radio\">\n                                  <input type=\"radio\" name=\"sipFirstInstallment\"\n                                         ng-model=\"DreamSip.formData.sipFirstInstallment\"\n                                         ng-change=\"DreamSip.changeFirstInstallment(false)\"\n                                         ng-value=\"false\"/>\n                                  <span class=\"check\"></span>\n                                </span>\n                  <span class=\"radio-label\">No</span>\n                </div>\n              </div>\n            </div> --><div class=row ng-if=DreamSip.inSchemeValidations.dividendPayoutApplicable><label class=\"form-label less\">Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=row><div class=\"col-md-12 form-group\" ng-class=\"{\'radio-disabled\':(DreamSip.validations.isEnabled==\'N\')}\" style=\"padding: 0\" ng-if=DreamSip.inSchemeValidations.dividendPayoutApplicable><div class=radio-block ng-repeat=\"_option in DreamSip.devidendOptions\" ng-class=\"{\'anything-disabled\': ((_option == DreamSip.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && DreamSip.inSchemeValidations.isGrowth === false && DreamSip.inSchemeValidations.dividendReinvestmentApplicable === false)\n          || (_option == DreamSip.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && DreamSip.inSchemeValidations.isGrowth === false && DreamSip.inSchemeValidations.dividendPayoutApplicable === false)) }\"><span class=radio><input type=radio id=sDividendOption{{_option}} ng-value=_option ng-disabled=\"!fForm.$valid\n          || (_option == DreamSip.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && DreamSip.inSchemeValidations.isGrowth === false && DreamSip.inSchemeValidations.dividendReinvestmentApplicable === false)\n          || (_option == DreamSip.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && DreamSip.inSchemeValidations.isGrowth === false && DreamSip.inSchemeValidations.dividendPayoutApplicable === false)\" name=sDividendOption ng-model=DreamSip.formData.sipDividendOption> <span class=check></span> </span><span class=radio-label>{{DreamSip.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div>{{DreamSip.formData.purchaseInvestmentOption}}<div class=\"row form-group\" ng-if=\"DreamSip.isSchemeTypeELSS && DreamSip.validations.investmentOption===DreamSip.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div><!--Payment Start here--><div class=row><label class=\"form-label less\">Payment Options</label></div><div class=row><div ng-if=\"DreamSip.paymentOptions && DreamSip.paymentOptions.length\"><div class=\"col-md-12 p-0 form-group\"><div class=radio-block ng-repeat=\"_option in DreamSip.paymentOptions\"><span class=radio ng-if=\"_option == \'EMANDATE\' && DreamSip.formData.sipFirstInstallment ? false : true\"><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-change=DreamSip.changedPaymentOption() ng-disabled=!fForm.$valid ng-model=DreamSip.formData.sipPaymentOption> <span class=check></span> </span><span class=radio-label>{{DreamSip.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><ng-bind-html dynamic=DreamSip.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_DreamSIP.content ng-if=DreamSip.showNote></ng-bind-html><div class=borderline ng-if=\"DreamSip.formData.sipPaymentOption===DreamSip.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC\"><div class=row><div class=\"col-sm-12 col-md-3\"><div class=selectfield ng-class=\"{error:DreamSip.tForm.bank.$dirty && DreamSip.tForm.bank.$invalid}\"><select class=select-noborder name=bank ng-disabled=false ng-model=DreamSip.ECBankData ng-change=DreamSip.changeBank() required><option value=\"\" selected>Select Bank</option><option ng-repeat=\"bank in DreamSip.bankList\" value={{bank}}>{{bank.bankName}}</option></select><label ng-if=DreamSip.formData.bankInfo>Select Bank</label><span class=error-input ng-show=\"DreamSip.tForm.bank.$dirty && DreamSip.tForm.bank.$error.required && !DreamSip.formData.bankName\" ng-bind=DreamSip.VALIDATE_DATA.BANK_REQUIRED></span></div></div><div class=col-md-12><ng-bind-html dynamic=DreamSip.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.NOTE_SIP_SI.content></ng-bind-html></div><!--<div class=\"col-md-1 text-center\" style=\"top:15px;\">OR</div>--><div class=\"col-sm-12 col-md-3\" ng-if=\"DreamSip.formData.bankInfo.bankCode == \'OTHER\'\"><div class=input-normal ng-if=\"DreamSip.formData.bankInfo.bankCode == \'OTHER\'\" ng-class=\"{error:DreamSip.tForm.bankName.$dirty && DreamSip.tForm.bankName.$invalid}\"><input type=text ng-click=DreamSip.otherBankSelected() ng-disabled=\"DreamSip.formData.bankInfo.bankCode != \'OTHER\'||!fForm.$valid\" ng-model=DreamSip.formData.bankName name=bankName ng-required=\"DreamSip.formData.bankInfo.bankCode == \'OTHER\'\"> <span class=highlight></span> <span class=bar></span><label>Bank Name</label><span class=error-input ng-show=\"DreamSip.tForm.bankName.$dirty && DreamSip.tForm.bankName.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div><div class=\"col-sm-12 col-md-3\" ng-if=\"DreamSip.formData.bankInfo && !DreamSip.formData.bankInfo.ifscCode\"><div class=input-normal ng-class=\"{error:DreamSip.tForm.ifscCode.$invalid && DreamSip.tForm.ifscCode.$dirty}\"><input type=text ng-model=DreamSip.formData.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=DreamSip.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=\"DreamSip.tForm.ifscCode.$dirty && DreamSip.tForm.ifscCode.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=\"DreamSip.tForm.ifscCode.$dirty && DreamSip.tForm.ifscCode.$error.pattern\" ng-bind=DreamSip.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-sm-12 col-md-3\" ng-if=\"DreamSip.formData.bankInfo && !DreamSip.formData.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:DreamSip.formData.bankInfo.bankAcType.$dirty && DreamSip.formData.bankInfo.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=DreamSip.formData.bankAcType ng-options=\"_type.accountTypeCode as _type.accountType for _type in DreamSip.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=DreamSip.formData.bankInfo.bankAcType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=DreamSip.formData.bankInfo.bankAcType.$error ng-show=DreamSip.formData.bankInfo.bankAcType.$dirty><span ng-message=required ng-bind=DreamSip.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row ng-if=\"DreamSip.formData.bankInfo.bankName ==\'HDFC BANK\'\"><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class={error:DreamSip.tForm.bankAcNo.$dirty&&DreamSip.tForm.bankAcNo.$invalid}><input type=text ng-model=DreamSip.formData.bankAcNo name=bankAcNo ng-disabled=!fForm.$valid required minlength=9 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" directive.mask ng-keydown=DreamSip.copyPasteHandler($event) ng-change=DreamSip.accFocus();> <span class=highlight></span> <span class=bar></span><label>Account Number</label><span ng-show=DreamSip.accModelDirty><span class=error-input ng-show=\"DreamSip.formData.bankAcNo.split(\'\').length==0\" ng-bind=DreamSip.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(DreamSip.formData.bankAcNo.split(\'\').length == null || (DreamSip.formData.bankAcNo.split(\'\').length<9 && DreamSip.formData.bankAcNo.split(\'\').length>0)) \" ng-bind=DreamSip.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class={error:DreamSip.tForm.verifyBankAcNo.$dirty&&DreamSip.tForm.verifyBankAcNo.$invalid}><input type=text ng-model=DreamSip.formData.verifyBankAcNo name=verifyBankAcNo ng-disabled=!fForm.$valid required ng-keydown=DreamSip.copyPasteHandler($event) ng-minlength=9 ng-pattern=DreamSip.formData.bankAcNo onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=highlight></span> <span class=bar></span><label>Verify Account Number</label><span class=error-input ng-show=DreamSip.tForm.verifyBankAcNo.$dirty&&DreamSip.tForm.verifyBankAcNo.$error.required ng-bind=DreamSip.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=!DreamSip.tForm.verifyBankAcNo.$error.required&&DreamSip.tForm.verifyBankAcNo.$error.minlength ng-bind=DreamSip.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!DreamSip.tForm.verifyBankAcNo.$error.required&&!DreamSip.tForm.verifyBankAcNo.$error.minlength&&DreamSip.tForm.verifyBankAcNo.$error.pattern ng-bind=DreamSip.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div></div></div><div class=borderline ng-if=\"DreamSip.formData.sipPaymentOption===DreamSip.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM\"><div class=row><div class=\"col-sm-12 col-md-3\" style=\"padding-left: 15px;padding-right: 15px\"><div class=\"input-select input-normal selectfield\" ng-class=\"{error:(DreamSip.tForm.bank.$dirty && DreamSip.tForm.bank.$invalid)\n      || (DreamSip.formData.bankInfo\n                            && DreamSip.formData.bankInfo.otmFrequency != \'AWP\'\n                            )}\"><input type=text name=bank id=otmBank ng-model=DreamSip.formData.bankInfo.bankName ng-change=DreamSip.changeBank() ng-init=\"DreamSip.formData.bankInfo = DreamSip.formData.bankInfo ? DreamSip.formData.bankInfo : null\" autocomplete=off only-alphabets required> <span class=highlight></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=\"DreamSip.tForm.bank.$dirty && DreamSip.tForm.bank.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.BANK_REQUIRED></span> <span ng-if=\"DreamSip.tForm.bank.$dirty && (DreamSip.formData.otmBank\n                            && DreamSip.formData.bankInfo.otmFrequency != \'AWP\')\" class=error-input><!-- Otm end date should be on or before selected end date.--> Invalid OTM Bank, OTM Instruction Type not AWP(As & When Presented)</span><bank-drop-down list-data=DreamSip.OTMbankList display-key=bankName display-key-second=bankAcNo hdfc-click=DreamSip.changeBank() model=DreamSip.formData.bankInfo for=otmBank></bank-drop-down></div></div><div class=\"col-sm-12 col-md-3\" ng-if=\"DreamSip.formData.bankInfo && !DreamSip.formData.bankInfo.ifscCode\"><div class=input-normal ng-class=\"{error:DreamSip.tForm.ifscCode.$invalid && DreamSip.tForm.ifscCode.$dirty}\"><input type=text ng-model=DreamSip.formData.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=DreamSip.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=\"DreamSip.tForm.ifscCode.$dirty && DreamSip.tForm.ifscCode.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=\"DreamSip.tForm.ifscCode.$dirty && DreamSip.tForm.ifscCode.$error.pattern\" ng-bind=DreamSip.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-sm-12 col-md-3\" ng-if=\"DreamSip.formData.bankInfo && !DreamSip.formData.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:DreamSip.formData.bankInfo.bankAcType.$dirty && DreamSip.formData.bankInfo.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=DreamSip.formData.bankAcType ng-options=\"_type.accountTypeCode as _type.accountType for _type in DreamSip.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=DreamSip.formData.bankAcType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=DreamSip.formData.bankInfo.bankAcType.$error ng-show=DreamSip.formData.bankInfo.bankAcType.$dirty><span ng-message=required ng-bind=DreamSip.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row ng-if=\"DreamSip.formData.sipPaymentOption===DreamSip.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM\"><ng-bind-html ng-bind-html=DreamSip.notesOtm.content ng-if=DreamSip.showOtmNote></ng-bind-html></div><div class=row><div class=\"col-sm-12 col-md-9\"><table class=\"table otm-bank-details borderless\" ng-if=DreamSip.formData.bankInfo><tr><td>Account No:</td><td easyassist-key=mask-element>{{DreamSip.formData.bankInfo.bankAcNo}}</td></tr><tr><td>OTM UMRN No:</td><td>{{DreamSip.formData.bankInfo.omUmrn}}</td></tr><tr><td>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{DreamSip.formData.bankInfo.maxAmount}} <span class=error-input ng-show=DreamSip.isOTMAmount ng-bind=DreamSip.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR></span></td></tr><tr><td>OTM Instruction Type:</td><td>{{DreamSip.formData.bankInfo.otmFrequencyName ? DreamSip.formData.bankInfo.otmFrequencyName : DreamSip.formData.bankInfo.otmFrequency}}</td></tr><tr><td>OTM Start Date:</td><td>{{DreamSip.formData.bankInfo.omStartDate}}</td></tr><tr><td>OTM Expiry Date:</td><td>{{DreamSip.formData.bankInfo.omExpiryDate}} <span class=error-input ng-show=DreamSip.isOTMDate ng-bind=DreamSip.VALIDATE_DATA.DATE_VALIDATION_ERROR></span></td></tr></table></div></div></div><div class=\"borderline emandate-section\" ng-if=\"DreamSip.formData.sipPaymentOption===DreamSip.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\"><div class=row><div class=\"col-sm-12 col-md-3 set-font-weight-bold label-emandate-dream-sip\">Select Bank</div><div class=col-md-3><div class=selectfield><select class=select-noborder name=bank ng-disabled=false ng-model=DreamSip.EmandateBank ng-change=DreamSip.changeBank() required><option value=\"\" selected>Select Bank</option><option ng-repeat=\"bank in DreamSip.EMbankList\" value={{bank}}>{{bank.bankName}}</option></select><span class=error-input ng-show=\"DreamSip.tForm.bank.$dirty && DreamSip.tForm.bank.$error.required && !DreamSip.formData.bankName\" ng-bind=DreamSip.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><div class=row><div class=\"col-md-3 set-font-weight-bold label-emandate-dream-sip\">Authentication Mode</div><div class=col-md-3><div class=selectfield ng-if=\"DreamSip.formData.sipPaymentOption===DreamSip.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" ng-class=\"{error:DreamSip.tForm.authenticationMode.$dirty && DreamSip.tForm.authenticationMode.$invalid}\"><div class=selectauthdrop><select name=authenticationMode ng-disable=!DreamSip.authenticationMode class=authModeDropdown ng-model=DreamSip.formData.authMode ng-options=\"auth.text for auth in DreamSip.authenticationMode\" ng-init=\"DreamSip.formData.authMode=DreamSip.formData.authMode?DreamSip.formData.authMode: null\" required><option value=\"\" selected>{{DreamSip.authenticationMode&&!DreamSip.authenticationMode.length ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}</option></select><span class=error-input ng-show=\"DreamSip.tForm.authenticationMode.$dirty && DreamSip.tForm.authenticationMode.$error.required && !DreamSip.formData.authMode\" ng-bind=DreamSip.VALIDATE_DATA.AUTHENTICATION_MODE_REQUIRED></span></div></div></div></div><div class=row><div class=\"col-md-3 set-font-weight-bold label-emandate-dream-sip\">Mandate Amount</div><div class=col-md-3><div class=\"input-normal icon-input\" ng-class=\"{error:(DreamSip.tForm.eAmount.$invalid && DreamSip.tForm.eAmount.$dirty),\'has-data\':DreamSip.formData.emandateAmount}\"><input type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=eAmount ng-model=DreamSip.formData.emandateAmount ng-change=DreamSip.checkAmountValidationEmandate() ng-disabled=!fForm.$valid ng-maxlength=10 limit-to=10 required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><div class=amtWords><p id=amountInwordsEmandate>{{DreamSip.formData.emandateWord.amountInWords}} (In Words)</p></div><!--                      <span class=\"text-success\">--><!--                        Maximum allowed for e-mandate is ₹ {{DreamSip.mandateMaxString}}.--><!--                      </span>--><div class=error-input ng-show=DreamSip.amountLess>{{DreamSip.VALIDATE_DATA.EMANDATE_MIN_ERROR + DreamSip.emandateMinAmountLimit}}.</div><div class=error-input ng-show=DreamSip.amountMore>{{DreamSip.VALIDATE_DATA.EMANDATE_MAX_ERROR + DreamSip.mandateMaxString}}.</div><div class=error-input ng-show=\"!DreamSip.amountLess && DreamSip.isLessThanSipAmount\" ng-bind=DreamSip.VALIDATE_DATA.EMANDATE_SIP_AMOUNT_ERROR></div></div></div></div><div class=row><div class=\"col-md-3 set-font-weight-bold label-emandate-dream-sip\">Mandate Start Date</div><div class=\"col-md-3 anything-disabled\" ng-if=!DreamSip.isReseting><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode={{DreamSip.viewMode}} data-date-default=DreamSip.formData.emandateDate id=emandateStartDate data-enable=true style=\"position: relative\"><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div></div><div class=row><div class=\"col-md-3 set-font-weight-bold label-emandate-dream-sip\">Mandate End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-bs-placement=right title={{DreamSip.mandateInfo}}></i></div><div class=\"sip-dates col-md-3\"><div ng-class=\"{\'anything-disabled\': !DreamSip.formData.emandateDate}\"><div class=form-group ng-if=!DreamSip.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal eEndDate\" ng-class=\"{error:DreamSip.tForm.endDateEmandate.$dirty && DreamSip.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=DreamSip.formData.endDateEmandate data-enabled-dates=DreamSip.enabledEmandateEndDatesList data-view-date=DreamSip.enabledEndDateView data-min-date=DreamSip.enabledEmandateEndDatesList[0] data-on-date-change=DreamSip.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><!-- data-min-date=\"DreamSip.formData.minEndDate\"--> <input type=text name=endDateEmandate autocomplete=off id=endDateCalender placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=DreamSip.sipDateLessEmandate ng-bind=DreamSip.VALIDATE_DATA.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div><ng-bind-html ng-bind-html=DreamSip.notesEOtm.content ng-if=\"DreamSip.showEotmNote && DreamSip.formData.authMode.value !== \'DEBIT_CARD\'\"></ng-bind-html><ng-bind-html ng-bind-html=DreamSip.notesEOtmDebitCard.content ng-if=\"DreamSip.showEotmNote && DreamSip.formData.authMode.value === \'DEBIT_CARD\'\"></ng-bind-html></div><div class=borderline ng-if=\"DreamSip.formData.sipPaymentOption===DreamSip.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\"><div class=row><div class=\"col-sm-12 col-md-3\"><div class=\"input-select input-normal selectfield\" ng-class={error:DreamSip.tForm.bank.$dirty&&DreamSip.tForm.bank.$invalid}><input style=\"padding-top: 13px\" type=text name=bank id=upiBank ng-model=DreamSip.formData.bankInfo.bankName ng-change=DreamSip.changeBank() ng-init=\"DreamSip.formData.bankInfo=DreamSip.formData.bankInfo?DreamSip.formData.bankInfo: null\" autocomplete=off ng-required=!DreamSip.bankInfo only-alphabets readonly> <span class=highlight></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=DreamSip.tForm.bank.$dirty&&DreamSip.tForm.bank.$error.required ng-bind=DreamSip.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=DreamSip.UPIbankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=DreamSip.changeBank() model=DreamSip.formData.bankInfo for=upiBank></bank-drop-down></div></div><div class=\"col-sm-12 col-md-3\" ng-if=\"DreamSip.formData.bankInfo && !DreamSip.formData.bankInfo.ifscCode\"><div class=input-normal ng-class={error:DreamSip.tForm.ifscCode.$invalid&&DreamSip.tForm.ifscCode.$dirty}><input style=\"padding-top: 13px\" type=text ng-model=DreamSip.formData.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=DreamSip.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=DreamSip.tForm.ifscCode.$dirty&&DreamSip.tForm.ifscCode.$error.required ng-bind=DreamSip.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=DreamSip.tForm.ifscCode.$dirty&&DreamSip.tForm.ifscCode.$error.pattern ng-bind=DreamSip.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-sm-12 col-md-3\" ng-if=\"DreamSip.formData.bankInfo && !DreamSip.formData.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:DreamSip.tForm.bankAcType.$dirty && DreamSip.tForm.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=DreamSip.formData.bankAcType ng-options=\"_type.accountTypeCode as _type.accountType for _type in DreamSip.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=DreamSip.formData.bankAcType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=DreamSip.tForm.bankAcType.$error ng-show=DreamSip.tForm.bankAcType.$dirty><span ng-message=required ng-bind=DreamSip.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div ng-if=DreamSip.formData.bankInfo style=\"padding: 0px\" ng-style=\"{\'margin-top\' : !DreamSip.formData.bankInfo.ifscCode || !DreamSip.formData.bankInfo.bankAcType ? \'20px\' : \'0px\'}\" ng-class=\"!DreamSip.formData.bankInfo.ifscCode || !DreamSip.formData.bankInfo.bankAcType ? \'col-md-12\' : \'col-md-9\'\"><div class=col-sm-12 style=\"margin-bottom: 20px\" ng-class=\"!DreamSip.formData.bankInfo.ifscCode || !DreamSip.formData.bankInfo.bankAcType ? \'col-md-3\' : \'col-md-4\'\"><div class=input-normal ng-class={error:DreamSip.tForm.virtualAddress.$invalid&&DreamSip.tForm.virtualAddress.$dirty}><input style=\"padding-top: 13px;text-transform: lowercase\" type=text ng-model=DreamSip.formData.virtualAddress name=virtualAddress ng-pattern=DreamSip.PATTERN.upi_virtual_addr_regex ng-change=DreamSip.handleVpa() required ng-readonly=\"DreamSip.formData.isUPIVerified && DreamSip.formData.verifyUPIResp.valid === true\" easyassist-key=mask-element><div class=bar></div><div class=highlight></div><label style=\"display: block;width: 100%\">Virtual Payment Address (UPI ID) <span class=req>*</span> <i class=edit-icon style=\"position: absolute;right: 0px; top:16px; pointer-events: all; box-sizing: content-box\" ng-if=\"DreamSip.formData.isUPIVerified && DreamSip.formData.verifyUPIResp.valid === true\" ng-click=\"DreamSip.formData.isUPIVerified = false\"></i></label><span class=error-input ng-show=DreamSip.tForm.virtualAddress.$dirty&&(DreamSip.tForm.virtualAddress.$error.required||DreamSip.tForm.virtualAddress.$error.pattern) ng-bind=DreamSip.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!DreamSip.tForm.virtualAddress.$invalid\n                  &&  (!DreamSip.formData.isUPIVerified && DreamSip.formData.verifyUPIResp.valid === false)\" ng-bind=DreamSip.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span></div></div><div class=col-sm-12 ng-if=\"DreamSip.formData.sipPaymentOption==\'UPI\' && !DreamSip.formData.isUPIVerified\" ng-class=\"!DreamSip.formData.bankInfo.ifscCode || !DreamSip.formData.bankInfo.bankAcType ? \'col-md-2\' : \'col-md-3\'\"><button blur-on-click class=\"btn btn-primary-action\" ng-disabled=\"!DreamSip.formData.virtualAddress || (!DreamSip.formData.minorFlag && DreamSip.checkForMinorBankListCondition()) || (!DreamSip.formData.isUPIVerified && DreamSip.formData.verifyUPIResp.valid === false)\" ng-click=DreamSip.verifyUPI()>Verify</button></div><div class=\"col-sm-12 col-md-2 verify-vpa verify-ack-padding\" ng-if=\"DreamSip.formData.isUPIVerified && DreamSip.formData.verifyUPIResp.valid === true\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{DreamSip.formData.name}}</span></div><div class=\"col-sm-12 col-md-2 verify-vpa verify-ack-padding\" ng-if=\"!DreamSip.formData.isUPIVerified && DreamSip.formData.verifyUPIResp.valid === false\"><p><strong><span class=error-input style=\"display:inline;font-size:100%;margin-bottom: 20px\">Not Verified</span> <i class=\"cancel-icon error-input\"></i></strong></p></div></div><div class=initiate-transaction><div class=text-red ng-if=!DreamSip.bankList||!DreamSip.bankList.length><span>In case your registered bank is not displayed, please choose other payment mode or add another bank.</span></div></div></div><ng-bind-html dynamic=DreamSip.notesUPI.content></ng-bind-html></div></div><div ng-if=\"DreamSip.paymentOptions.length == 0\" class=\"bank-error-msg marginBotNovalid\">No valid payment mode available to proceed with SIP DreamSip</div><div ng-if=\"(DreamSip.isEmailinValid || DreamSip.isEmailMobileinValid || DreamSip.isMobileinValid) && (DreamSip.formData.sipPaymentOption===DreamSip.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)\" class=emandateError><span class=error-input ng-show=DreamSip.isMobileinValid ng-bind=DreamSip.VALIDATE_DATA.INVALID_MOBILE_EMANDATE></span> <span class=error-input ng-show=DreamSip.isEmailinValid ng-bind=DreamSip.VALIDATE_DATA.INVALID_EMAIL_EMANDATE></span> <span class=error-input ng-show=DreamSip.isEmailMobileinValid ng-bind=DreamSip.VALIDATE_DATA.INVALID_EMAIL_MOBILE_EMANDATE></span></div><!--Payment End here--><!-- date --><div class=row><label class=\"form-label less\">Installment Date Details</label></div><div class=row ng-class=\"{\'anything-disabled\': !DreamSip.formData.inSchemeName }\"><div class=\"col-sm-12 col-md-3 row\"><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:DreamSip.tForm.startDate.$dirty && DreamSip.tForm.startDate.$invalid}\" date-calendar data-viewmode={{DreamSip.viewMode}} data-date-default=DreamSip.formData.startDate data-enabled-dates=DreamSip.enabledStartDates data-min-date=DreamSip.startMinDateBiller data-max-date=DreamSip.startMaxDate data-on-date-change=DreamSip.changeStartDate id=StartDate data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=DreamSip.formData.startDate>Start Date - DD-MMM-YYYY</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=DreamSip.tForm.startDate.$error.required ng-bind=DreamSip.VALIDATE_DATA.START_DATE_REQUIRED></span> <span class=error-input ng-show=DreamSip.isOTMStartDate ng-bind=\"DreamSip.VALIDATE_DATA.DATE_SIP_VALIDATION_ERROR + \' \' + DreamSip.formData.bankInfo.omStartDate\"></span></div></div></div><div class=\"row borderline\"><div class=sip-dates><div class=\"col-sm-12 col-md-3 row\" ng-class=\"{\'anything-disabled\':true}\"><div class=form-group><div class=\"input-normal verify-acc input-group date date-picker Transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=DreamSip.formData.endDate data-on-date-change=DreamSip.changeEndDate data-enabled-dates=DreamSip.enabledEndDates data-view-date=DreamSip.enabledEndDateView data-min-date=DreamSip.enabledEndDates[0] data-enable=true id=EndDate showdefault=false readonly><!-- data-min-date=\"DreamSip.formData.minEndDate\"--> <input type=text name=endDate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span><label ng-if=DreamSip.formData.endDate>End Date - DD-MMM-YYYY</label><span class=bar></span> <span class=error-input ng-show=\"DreamSip.tForm.day.$dirty && DreamSip.tForm.day.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.END_DATE_REQUIRED></span> <span class=error-input ng-show=DreamSip.isOTMEndDate ng-bind=DreamSip.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div></div></div></div></div><!-- Sip Topup --><!-- <div ng-if=\"DreamSip.formData.showTopUpBlock\">\n              <div class=\"row\">\n                <label class=\"form-label less\">SIP Top-up Details</label>\n              </div>\n\n              <div class=\"row\">\n\n                <div class=\"col-md-3 row form-group\" ng-if=\"!DreamSip.isReseting\">\n                  <span class=\"checkbox\" style=\"bottom: -3px;\">\n                    <input type=\"checkbox\" id=\"sipToptup\" ng-model=\"DreamSip.formData.sipTopupEnabled\"\n                      ng-change=\"DreamSip.changeSipTopupSelected(DreamSip.formData.sipTopupEnabled)\">\n                    <span class=\"icon-checkbox\"></span>\n                  </span>&nbsp;\n                  <label style=\"margin-left: 2px;\" for=\"defaultDate\">SIP Top-up</label>\n                </div>\n\n              </div>\n              <div class=\"row\" ng-if=\"DreamSip.formData.sipTopupSelected\">\n                <div ng-class=\"{\'anything-disabled\': !DreamSip.formData.sipTopupSelected }\" class=\"col-md-12\">\n                  <div class=\"col-md-12 row\">\n                    <div class=\"row\">\n                      <div class=\"col-md-3\">\n                        <div class=\"input-normal icon-input\"\n                          ng-class=\"{error:(DreamSip.tForm.topupAmount.$invalid && DreamSip.tForm.topupAmount.$dirty),\'has-data\':DreamSip.formData.topupDetails.amount}\">\n                          <input type=\"number\" ignore-mouse-wheel name=\"topupAmount\"\n                            ng-model=\"DreamSip.formData.topupDetails.amount\"\n                            ng-disabled=\"!fForm.$valid || DreamSip.formData.topupDetails.percentage\"\n                            ng-change=\"DreamSip.checkSipValidations();DreamSip.getTopupFrequencyList();\"\n                            onkeyup=\"NumToWord(this.value,\'divDisplayInWords\');\"\n                            ng-required=\"DreamSip.formData.sipTopupEnabled && ((!DreamSip.formData.topupDetails.percentage && !DreamSip.formData.topupDetails.amount) || !DreamSip.formData.topupDetails.percentage)\">\n                          <span class=\"highlight\"></span>\n                          <span class=\"bar\"></span>\n                          <label>Amount</label>\n                          <i class=\"rupee-grey-icon\"></i>\n                          <span class=\"error-input\"\n                            ng-show=\"DreamSip.tForm.topupAmount.$dirty && DreamSip.tForm.topupAmount.$error.required\"\n                            ng-bind=\"DreamSip.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>\n                          <span ng-if=\"DreamSip.formData.topupDetails.amount && DreamSip.isTopupMinAmt\"\n                            class=\"error-input\">Minimum amount should be &#8377;\n                            {{DreamSip.validations.topupMinAmt|unit}}</span>\n                          <span\n                            ng-if=\"DreamSip.formData.topupDetails.amount  && !DreamSip.isTopupMinAmt && (DreamSip.validations.topupAmtMultples&&!DreamSip.isTopUpMultiples)\"\n                            class=\"error-input\">Please provide In multiples of &#8377;\n                            {{DreamSip.validations.topupAmtMultples|unit}}</span>\n                        </div>\n                        <div class=\"form-group\">\n                          <label id=\"divDisplayInWords\">{{DreamSip.amountInWords}} (In Words)</label>\n                        </div>\n                      </div>\n                      <div class=\"col-md-1 or-part text-center\">OR</div>\n\n                      <div class=\"col-md-3\">\n\n                        <div class=\"input-normal\"\n                          ng-class=\"{error:(DreamSip.tForm.topupPercentage.$invalid && DreamSip.tForm.topupPercentage.$dirty),\'has-data\':DreamSip.formData.topupPercentage}\">\n                          <input type=\"number\" ignore-mouse-wheel name=\"topupPercentage\"\n                            ng-model=\"DreamSip.formData.topupDetails.percentage\"\n                            ng-disabled=\"!fForm.$valid ||  DreamSip.formData.topupDetails.amount\"\n                            ng-change=\"DreamSip.checkSipValidations();DreamSip.getTopupFrequencyList();DreamSip.changeTopUpFreq()\"\n                            ng-required=\"DreamSip.formData.sipTopupEnabled && ((!DreamSip.formData.topupDetails.percentage && !DreamSip.formData.topupDetails.amount) || !DreamSip.formData.topupDetails.amount)\">\n                          <span class=\"highlight\"></span>\n                          <span class=\"bar\"></span>\n                          <label>Percentage (%)</label>\n                          <span class=\"error-input\"\n                            ng-show=\"DreamSip.tForm.topupPercentage.$dirty && DreamSip.tForm.topupPercentage.$error.required\"\n                            ng-bind=\"DreamSip.VALIDATE_DATA.PERCENT_REQUIRED\"></span>\n                          <span ng-if=\"DreamSip.formData.topupDetails.percentage && DreamSip.isTopupMinPerc\"\n                            class=\"error-input\">Minimum percentage should be\n                            {{DreamSip.validations.topupMinPercentage|unit}}%</span>\n                          <span\n                            ng-if=\"DreamSip.formData.topupDetails.percentage && !DreamSip.isTopupMinPerc && (DreamSip.validations.topupPercentageMultples&&!DreamSip.isTopupPercMultiples)\"\n                            class=\"error-input\">Please provide in multiple of\n                            {{DreamSip.validations.topupPercentageMultples|unit}}%</span>\n                        </div>\n\n                      </div>\n\n                    </div>\n\n                    <div class=\"row\">\n                      <div class=\"col-md-12\">\n                        <label class=\"form-label less\">Frequency</label>\n                      </div>\n                    </div>\n\n                    <div class=\"row\">\n                      <div class=\"col-md-5 form-group\">\n                        <div class=\"radio-block\" ng-repeat=\"freq in DreamSip.topupFrequencyList\">\n                          <span class=\"radio\">\n                            <input type=\"radio\" ng-model=\"DreamSip.formData.topupDetails.frequency\"\n                              ng-disabled=\"!fForm.$valid\" ng-value=\"freq.key\" name=\"topupFrequency\"\n                              ng-change=\"DreamSip.changeTopUpFreq()\" />\n                            <span class=\"check\"></span>\n                          </span>\n                          <span class=\"radio-label\">{{freq.value}}</span>\n                        </div>\n                      </div>\n                    </div>\n\n                    <div class=\"row\">\n                      <div class=\"col-md-12\">\n                        <label class=\"form-label less\">SIP Top-up CAP</label>\n                      </div>\n                    </div>\n\n                    <div class=\"row\">\n\n                      <div class=\"col-md-3\">\n                        <div class=\"input-normal icon-input\"\n                          ng-class=\"{error:(DreamSip.tForm.capAmount.$invalid && DreamSip.tForm.capAmount.$dirty && DreamSip.isminCapAmount),\'has-data\':DreamSip.formData.capAmount}\">\n                          <input type=\"number\" ignore-mouse-wheel name=\"capAmount\"\n                            ng-model=\"DreamSip.formData.topupDetails.capAmount\"\n                            ng-disabled=\"!fForm.$valid || DreamSip.formData.topupDetails.capMonthYear\"\n                            onkeyup=\"NumToWord(this.value,\'capAmntDisplayInWords\');\"\n                            ng-change=\"DreamSip.capAmountChanged();\"\n                            ng-required=\"DreamSip.formData.sipTopupEnabled && ((!DreamSip.formData.topupDetails.capAmount && !DreamSip.formData.topupDetails.capMonthYear) || !DreamSip.formData.topupDetails.capMonthYear)\">\n                          <span class=\"highlight\"></span>\n                          <span class=\"bar\"></span>\n                          <label>Amount</label>\n                          <i class=\"rupee-grey-icon\"></i>\n                          <span class=\"error-input\"\n                            ng-show=\"DreamSip.tForm.capAmount.$dirty && DreamSip.tForm.capAmount.$error.required\"\n                            ng-bind=\"DreamSip.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>\n                          <span ng-if=\"DreamSip.formData.topupDetails.capAmount && DreamSip.isminCapAmount\"\n                            class=\"error-input\">Minimum amount should be &#8377; {{DreamSip.minCapAmount}}</span>\n                        </div>\n                        <div class=\"form-group\">\n                          <label id=\"capAmntDisplayInWords\"><span\n                              ng-if=\"DreamSip.formData.topupDetails.capAmount\">{{DreamSip.amountInWords}} (In\n                              Words)</span></label>\n                        </div>\n                      </div>\n                      <div class=\"col-md-1 or-part text-center\">OR</div>\n                      <div class=\"row\">\n                        <div class=\"col-md-3\">\n                          <div class=\"selectfield\"\n                            ng-class=\"{\'anything-disabled\': !fForm.$valid || DreamSip.formData.topupDetails.capAmount }\">\n                            <select class=\"browser-default custom-select\" name=\"capDates\"\n                              ng-disabled=\"!fForm.$valid || DreamSip.topupDetails.formData.capAmount\"\n                              ng-options=\"_dates for _dates in DreamSip.capDates\"\n                              ng-model=\"DreamSip.formData.topupDetails.capMonthYear\"\n                              ng-init=\"DreamSip.formData.topupDetails.capMonthYear=DreamSip.formData.topupDetails.capMonthYear?DreamSip.formData.topupDetails.capMonthYear: null\"\n                              ng-required=\"DreamSip.formData.sipTopupEnabled && ((!DreamSip.formData.topupDetails.capAmount && !DreamSip.formData.topupDetails.capMonthYear) || !DreamSip.formData.topupDetails.capAmount)\">\n                              <option value=\"\">Cap Month Year - MM/YYYY</option>\n                            </select>\n\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div> --></div><div ng-class=\"{\'anything-disabled\': !DreamSip.formData.folioNumber }\" class=\"form-footer row\"><div class=col-md-12><button ng-disabled=!DreamSip.formData.inSchemeName class=\"btn btn-secondary-action\" type=button ng-click=DreamSip.saveForm()>Save</button> <button type=button ng-if=!DreamSip.formData.sipTopupSelected ng-disabled=\"!DreamSip.tForm.$valid || DreamSip.isInvalidForm\n          || !DreamSip.formData.inSchemeCode || DreamSip.isminCapAmount ||  DreamSip.isSwapMin || DreamSip.isSwapMax ||  !DreamSip.isSwapMultiples || !DreamSip.isMultiples || !DreamSip.formData.startDate || !DreamSip.formData.endDate || DreamSip.isMax || DreamSip.isMin ||  !DreamSip.isSelectedEuin || DreamSip.amountLess || DreamSip.amountMore || DreamSip.isLessThanSipAmount || DreamSip.sipDateLessEmandate\" ng-click=DreamSip.goToSipSummary() class=\"btn btn-primary-action\">Proceed to Transact</button> <button type=button ng-if=DreamSip.formData.sipTopupSelected ng-disabled=\"!DreamSip.tForm.$valid || DreamSip.isInvalidForm\n        || !DreamSip.formData.inSchemeCode ||  DreamSip.isSwapMin || DreamSip.isSwapMax ||  DreamSip.isminCapAmount || !DreamSip.formData.startDate || !DreamSip.isMultiples || !DreamSip.isSwapMultiples || !DreamSip.formData.endDate || DreamSip.isMax || DreamSip.isMin ||  !DreamSip.isSelectedEuin\n        || (!DreamSip.formData.topupDetails.amount && !DreamSip.formData.topupDetails.percentage) ||\n      (!DreamSip.formData.topupDetails.capAmount &&  !DreamSip.formData.topupDetails.capMonthYear)\" ng-click=DreamSip.goToSipSummary() class=\"btn btn-primary-action\">Proceed to Transact</button></div></div></form></div></fieldset></section></div><div ng-if=DreamSip.formData.isSummaryViewEnabled><transaction-summary form-data=DreamSip.summaryData is-summary-view-enabled=DreamSip.formData.isSummaryViewEnabled transaction-type={{DreamSip.transactionType}} notes=DreamSip.notesReview.content show-terms=DreamSip.showTerms></transaction-summary></div>");
$templateCache.put("app/transactions/initiate/dtp/dtp.html","<div class=\"main-section clearfix\" ng-hide=Transaction.formData.isSummaryViewEnabled><div class=\"loader dtp-loader\" style=\"position: absolute\"><span class=loading></span></div><section class=initiate-transaction ng-init=Transaction.init()><p class=page-title>TRANSFER IDCW PLAN (TIP)</p><div class=\"content-area redeem\"><form autocomplete=off class=row name=Transaction.tForm ng-keypress=Transaction.handleEnter($event) novalidate><div class=top-wrap><label>Invest through Distributor</label><div class=form-group><div class=radio-block><span class=radio><input type=radio id=_first name=throughDistributor ng-value=true ng-model=Transaction.formData.isThroughDistributor ng-click=\"Transaction.changeThroughDistributor(\'ARN\')\"> <span class=check></span> </span><span class=radio-label>Yes</span></div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=false ng-model=Transaction.formData.isThroughDistributor ng-click=\"Transaction.changeThroughDistributor(\'DIRECT\')\"> <span class=check></span> </span><span class=radio-label>No</span></div></div><div class=\"row euin-part drop-pos\" ng-if=Transaction.formData.isThroughDistributor><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\"><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=\"Transaction.searchDistributor();Transaction.showArnLabel=false\" maxlength=10 ng-pattern=/^[0-9]{4,10}$/ ng-required=!Transaction.formData.distributerName ng-focus=\"Transaction.showArnLabel=true\"> <span class=highlight></span> <span class=bar></span> <span class=arn ng-show=\"Transaction.showArnLabel || Transaction.formData.brokerCode\">ARN -</span><label>ARN</label><p ng-if=Transaction.formData.brokerName class=info-primary>Distributor Name: {{Transaction.formData.brokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.required) && (!Transaction.formData.distributerName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.pattern) && (!Transaction.formData.distributorName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.brokerCodeError !== \'\' && !Transaction.tForm.brokerCode.$invalid\" ng-bind=Transaction.brokerCodeError></span></div></div><span class=or-part>OR</span><div class=\"col-sm-12 col-md-4\"><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.distributerName.$dirty && Transaction.tForm.distributerName.$invalid}\"><input type=text name=distributerName id=distributerName ng-change=Transaction.searchDistributorByName() ng-model=Transaction.formData.distributerName autocomplete=off ng-required=!Transaction.formData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><label>Search Distributor</label><!--<p ng-if=\"Transaction.formData.distributorARN\" class=\"info-primary\">{{Transaction.formData.distributorARN}}</p>--><!--<span class=\"error-input\" ng-show=\"Transaction.tForm.distributerName.$dirty && Transaction.tForm.distributerName.$invalid && Transaction.tForm.distributerName.$error.required\"\n                      ng-bind=\"Transaction.VALIDATE_DATA.DISTRIBUTOR_REQUIRED\"></span>--><drop-down list-data=Transaction.distributorList display-key=name display-key-second=arnCode hdfc-click=Transaction.distributorListChanged(data) model=Transaction.formData.distributorARN for=distributerName></drop-down><!--<p ng-if=\"Transaction.formData.distributorARN\" class=\"info-primary\">{{Transaction.formData.distributorARN}}</p>--></div></div></div><div class=row ng-if=Transaction.formData.isThroughDistributor><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class={error:Transaction.tForm.subBrokerARN.$dirty&&Transaction.tForm.subBrokerARN.$invalid}><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=Transaction.formData.subBrokerARN ng-change=Transaction.changeSubBrokerArn(); ng-blur=Transaction.fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>Sub Broker ARN</label><p ng-if=Transaction.subBrokerName class=info-primary>Sub Broker Name: {{Transaction.subBrokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.subBrokerARN.$dirty && Transaction.tForm.subBrokerARN.$invalid && Transaction.tForm.subBrokerARN.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.subBrokerCodeError != \'\'&& !Transaction.tForm.subBrokerARN.$error.pattern\" ng-bind=Transaction.subBrokerCodeError></span></div></div><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class={error:Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=Transaction.formData.subBrokerCode autocomplete=off ng-disabled=\"!Transaction.formData.subBrokerARN || Transaction.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code</label><span class=error-input ng-show=Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$error.required ng-bind=Transaction.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div><!--<div class=\"col-md-4\">\n              <div class=\"selectfield\" ng-class=\"{error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}\">\n                <label ng-if=\"Transaction.formData.euin\">Select EUIN {{!Transaction.formData.brokerCode ? \"(Optional)\" : \"\" }}</label>\n                <select name=\"euin\" id=\"euin\"\n                        ng-model=\"Transaction.formData.euin\"\n                        ng-disabled=\"!Transaction.euinList.length\"\n                        ng-options=\"_euin as (_euin.euinName+\' - \'+_euin.euinCode) for _euin in Transaction.euinList track by _euin.euinCode\"\n                        ng-required=\"Transaction.formData.brokerCode\" autocomplete=\"off\">\n                  <option value=\"\" selected >Select EUIN {{!Transaction.formData.brokerCode ? \"(Optional)\" : \"\"\n                      }}</option>\n                </select>\n                <span class=\"error-input\" ng-show=\"Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required\"\n                      ng-bind=\"Transaction.VALIDATE_DATA.EUIN_REQUIRED\"></span>\n              </div>\n            </div>--></div><div class=\"row euin-part drop-pos\" ng-if=Transaction.formData.isThroughDistributor><div class=\"col-sm-12 col-md-4\"><div class=\"input-select input-normal selectfield\" ng-class={error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}><input type=text name=euin id=euin ng-model=Transaction.euinData.euinNameCode ng-disabled=\"!Transaction.euinMasterList.length || Transaction.isArnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\" ng-change=Transaction.filterEuinList() ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributerName) && !Transaction.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Select Euin</label><span class=error-input ng-show=\"Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required || !Transaction.isSelectedEuin\" ng-bind=Transaction.VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=Transaction.euinList display-key=euinName display-key-second=euinCode hdfc-click=Transaction.selectEuin(data) model=Transaction.formData.euin for=euin></list-drop-down></div><!--<div class=\"input-select input-normal\"\n                   ng-class=\"{error:Transaction.tForm.euin.$dirty && Transaction.tForm.euin.$invalid}\">\n                  <input type=\"text\" name=\"euin\" id=\"euin\"\n                         ng-model=\"Transaction.formData.euinInput\"\n                         ng-change=\"Transaction.setEuinData()\"\n                         ng-disabled=\"Transaction.isArnSuccess\"\n                         autocomplete=\"off\"\n                         ng-required=\"(Transaction.formData.brokerCode || !Transaction.isArnSuccess) && !Transaction.isCheckedTandC\">\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>Select EUIN</label>\n                  &lt;!&ndash;<p ng-if=\"Transaction.formData.distributorARN\" class=\"info-primary\">{{Transaction.formData.distributorARN}}</p>&ndash;&gt;\n          <span class=\"error-input\" ng-show=\"Transaction.tForm.euinInput.$dirty && Transaction.tForm.euinInput.$invalid && Transaction.tForm.euinInput.$error.required\"\n                ng-bind=\"Transaction.VALIDATE_DATA.EUIN_REQUIRED\"></span>\n                  <drop-down list-data=\"Transaction.euinList\"\n                             display-key=\"euinName\"\n                             display-key-second=\"euinCode\"\n                             hdfc-click=\"Transaction.EuinChanged(data)\"\n                             model=\"Transaction.formData.euin\"\n                             for=\"euin\">\n                  </drop-down>\n\n              </div>--></div><div ng-show=Transaction.euinBoxMessage><span class=or-part>OR</span><div class=\"col-sm-12 col-md-7\"><div class=checkbox><input ng-model=Transaction.isCheckedTandC type=checkbox ng-change=Transaction.isCheckedEuin() ng-disabled=\"Transaction.isArnSuccess || Transaction.isSubarnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\" ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributerName) && !Transaction.formData.euin\"> <i class=icon-checkbox></i><ng-bind-html class=checkbox-text ng-bind-html=Transaction.euinBoxMessage.content></ng-bind-html></div></div></div></div><!--<div ng-if=\"Transaction.formData.brokerName\" class=\"row\">\n            <div class=\"col-md-4\">\n              <span>Distributor Name: {{Transaction.formData.brokerName}}</span>\n            </div>\n          </div>--></div><div><div class=\"col-sm-12 col-md-4\"><p class=col-head>Select Scheme for IDCW Transfer</p><div class=selectfield ng-class=\"{error:Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid}\"><select name=folio ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$invalid , \'anything-disabled\': !Transaction.formData.folioNumber }\"><input type=text name=outScheme id=outScheme ng-change=Transaction.filterOutSchemeList() ng-model=Transaction.formData.outSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Source Scheme</label><span class=error-input ng-show=\"Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.outSchemeList display-key=schemeName hdfc-click=Transaction.outSchemeChanged(data) model=Transaction.formData.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{Transaction.formData.outSchemeName}}</p></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"col-sm-12 col-md-4 nobrdr-rgt\"><p class=col-head>Scheme to Transfer In</p><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid}\"><input type=text name=inScheme id=inScheme ng-change=Transaction.filterInSchemeList() ng-model=Transaction.formData.inSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><span class=error-input ng-show=\"Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.TARGET_SCHEME_REQUIRED></span><drop-down list-data=Transaction.inSchemeList display-key=scheme hdfc-click=Transaction.inSchemeChanged(data) model=Transaction.formData.inSchemeCode for=inScheme></drop-down><p class=info-primary>{{Transaction.formData.inSchemeName}}</p></div><div class=\"form-group text-center\"><p>OR</p><br><p><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=Transaction.schemeListModal()>Select from list</span></p></div><div class=form-group ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\" ng-if=\"Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=form-label>Select Income Distribution cum Capital Withdrawal (IDCW) Option</label><div style=\"padding-bottom: 10px\" ng-class=\"{\'anything-disabled\': ((_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)\n                 || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT && Transaction.inSchemeValidations.dividendPayoutApplicable === false)) }\" class=radio-block ng-repeat=\"_option in Transaction.devidendOptions\"><span class=radio><input type=radio id=dividendOption{{$index}} ng-value=_option ng-disabled=\"(_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)\n                                    || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT && Transaction.inSchemeValidations.dividendPayoutApplicable === false)\" name=dividendOption ng-model=Transaction.formData.dividendOption> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div><div class=\"row form-group\" ng-if=\"Transaction.isSchemeTypeELSS && Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"form-footer col-md-12\"><button class=\"btn btn-secondary-action\" ng-disabled=\"!Transaction.formData.inSchemeName || !Transaction.formData.outSchemeCode\" ng-click=Transaction.saveForm()>Save</button> <button ng-disabled=\"!Transaction.tForm.$valid || !Transaction.formData.inSchemeCode ||Transaction.isInvalidForm || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)  || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || !Transaction.formData.outSchemeCode\" ng-click=Transaction.goToSummary() class=\"btn btn-primary-action\">Proceed to Transact</button></div></form></div></section></div><div ng-if=Transaction.formData.isSummaryViewEnabled><transaction-summary form-data=Transaction.summaryData is-summary-view-enabled=Transaction.formData.isSummaryViewEnabled transaction-type={{Transaction.transactionType}} show-terms=Transaction.showTerms notes=Transaction.notesReview.content></transaction-summary></div>");
$templateCache.put("app/transactions/initiate/flexindex/flexindex.html","<div class=\"main-section clearfix\" ng-hide=Transaction.formData.isSummaryViewEnabled><section class=initiate-transaction ng-init=Transaction.init()><p class=page-title>FLEX INDEX <i class=\"info-icon base-tooltip\" tooltip data-bs-toggle=tooltip data-bs-placement={{Main.tooltipClass}} title=\"HDFC FLEXINDEX PLAN empowers you to automatically transfer your\ninvestments from selected Debt/Liquid schemes to selected Equity schemes of\nHDFC Mutual Fund at closing BSE SENSEX levels of your choice.\"></i></p><div class=\"content-area redeem\"><form autocomplete=off class=row name=Transaction.tForm ng-keypress=Transaction.handleEnter($event) novalidate><div class=top-wrap><label>Invest through</label><div class=form-group><div class=radio-block><span class=radio><input type=radio id=_first name=throughDistributor ng-value=true ng-model=Transaction.formData.isDirect ng-change=\"Transaction.changeThroughDistributor(\'DIRECT\')\"> <span class=check></span> </span><span class=radio-label>Direct</span></div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isThroughDistributor ng-change=\"Transaction.changeThroughDistributor(\'ARN\')\"> <span class=check></span> </span><span class=radio-label>Distributor</span></div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isThroughRia ng-change=\"Transaction.changeThroughDistributor(\'RIA\')\"> <span class=check></span> </span><span class=radio-label>RIA</span></div></div><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughDistributor><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\"><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=\"Transaction.searchDistributor();Transaction.showArnLabel=false\" maxlength=10 ng-pattern=/^[0-9]{4,10}$/ ng-required=!Transaction.formData.distributerName ng-focus=\"Transaction.showArnLabel=true\"> <span class=highlight></span> <span class=bar></span> <span class=arn ng-show=\"Transaction.showArnLabel || Transaction.formData.brokerCode\">ARN -</span><label>ARN</label><p ng-if=Transaction.formData.brokerName class=info-primary>Distributor Name: {{Transaction.formData.brokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.required) && (!Transaction.formData.distributerName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.pattern) && (!Transaction.formData.distributorName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.brokerCodeError !== \'\' && !Transaction.tForm.brokerCode.$invalid\" ng-bind=Transaction.brokerCodeError></span></div></div><span class=or-part>OR</span><div class=\"col-sm-12 col-md-4\"><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.distributerName.$dirty && Transaction.tForm.distributerName.$invalid}\"><input type=text name=distributerName id=distributerName ng-change=Transaction.searchDistributorByName() ng-model=Transaction.formData.distributerName autocomplete=off ng-required=!Transaction.formData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><label>Search Distributor</label><!--<p ng-if=\"Transaction.formData.distributorARN\" class=\"info-primary\">{{Transaction.formData.distributorARN}}</p>--><!--<span class=\"error-input\" ng-show=\"Transaction.tForm.distributerName.$dirty && Transaction.tForm.distributerName.$invalid && Transaction.tForm.distributerName.$error.required\"\n                      ng-bind=\"Transaction.VALIDATE_DATA.DISTRIBUTOR_REQUIRED\"></span>--><drop-down list-data=Transaction.distributorList display-key=name display-key-second=arnCode hdfc-click=Transaction.distributorListChanged(data) model=Transaction.formData.distributorARN for=distributerName></drop-down><!--<p ng-if=\"Transaction.formData.distributorARN\" class=\"info-primary\">{{Transaction.formData.distributorARN}}</p>--></div></div></div><!-- RIA code section--><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughRia><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class=\"{error:(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid)||(Transaction.riaCodeError != \'\')}\"><input type=text name=riaCode id=riaCode ng-model=Transaction.formData.brokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=\"Transaction.searchDistributor(); Transaction.showRiaLabel=false\" ng-required=!Transaction.formData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span><label>RIA Code</label><!--<p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name: {{Transaction.formData.brokerName}}</p>--> <span class=error-input ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.required)\" ng-bind=Transaction.VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"Transaction.riaCodeError !== \'\' && !Transaction.tForm.riaCode.$invalid\" ng-bind=Transaction.riaCodeError></span></div></div></div><div ng-show=Transaction.riaMessage><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughRia><div class=col-md-12><div class=checkbox><input ng-model=Transaction.isCheckedTandC type=checkbox ng-change=Transaction.isCheckedEuin() ng-disabled=\"!Transaction.formData.brokerCode || Transaction.riaCodeError\" ng-required=Transaction.formData.brokerCode> <i class=icon-checkbox></i><ng-bind-html class=checkbox-text ng-bind-html=Transaction.riaMessage.content></ng-bind-html></div></div></div></div><!--RIA code section ends here--><div class=row ng-if=Transaction.formData.isThroughDistributor><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class={error:Transaction.tForm.subBrokerARN.$dirty&&Transaction.tForm.subBrokerARN.$invalid}><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=Transaction.formData.subBrokerARN ng-change=Transaction.changeSubBrokerArn(); ng-blur=Transaction.fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>Sub Broker ARN</label><p ng-if=Transaction.subBrokerName class=info-primary>Sub Broker Name: {{Transaction.subBrokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.subBrokerARN.$dirty && Transaction.tForm.subBrokerARN.$invalid && Transaction.tForm.subBrokerARN.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.subBrokerCodeError != \'\'&& !Transaction.tForm.subBrokerARN.$error.pattern\" ng-bind=Transaction.subBrokerCodeError></span></div></div><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class={error:Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=Transaction.formData.subBrokerCode autocomplete=off ng-disabled=\"!Transaction.formData.subBrokerARN || Transaction.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code</label><span class=error-input ng-show=Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$error.required ng-bind=Transaction.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div><!--<div class=\"col-md-4\">\n              <div class=\"selectfield\" ng-class=\"{error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}\">\n                <label ng-if=\"Transaction.formData.euin\">Select EUIN {{!Transaction.formData.brokerCode ? \"(Optional)\" : \"\" }}</label>\n                <select name=\"euin\" id=\"euin\"\n                        ng-model=\"Transaction.formData.euin\"\n                        ng-disabled=\"!Transaction.euinList.length\"\n                        ng-options=\"_euin as (_euin.euinName+\' - \'+_euin.euinCode) for _euin in Transaction.euinList track by _euin.euinCode\"\n                        ng-required=\"Transaction.formData.brokerCode\" autocomplete=\"off\">\n                  <option value=\"\" selected >Select EUIN {{!Transaction.formData.brokerCode ? \"(Optional)\" : \"\"\n                      }}</option>\n                </select>\n                <span class=\"error-input\" ng-show=\"Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required\"\n                      ng-bind=\"Transaction.VALIDATE_DATA.EUIN_REQUIRED\"></span>\n              </div>\n            </div>--></div><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughDistributor><div class=\"col-sm-12 col-md-4\"><div class=\"input-select input-normal selectfield\" ng-class={error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}><input type=text name=euin id=euin ng-model=Transaction.euinData.euinNameCode ng-disabled=\"!Transaction.euinMasterList.length || Transaction.isArnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\" ng-change=\"Transaction.filterEuinList() || Transaction.isSelectEuin()\" ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributerName) && !Transaction.isCheckedTandC\" autocomplete=off> <span class=error-input ng-show=\"Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required || !Transaction.isSelectedEuin\" ng-bind=Transaction.VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=Transaction.euinList display-key=euinName display-key-second=euinCode hdfc-click=Transaction.selectEuin(data) model=Transaction.formData.euin for=euin></list-drop-down></div><!--<div class=\"input-select input-normal\"\n                   ng-class=\"{error:Transaction.tForm.euin.$dirty && Transaction.tForm.euin.$invalid}\">\n                  <input type=\"text\" name=\"euin\" id=\"euin\"\n                         ng-model=\"Transaction.formData.euinInput\"\n                         ng-change=\"Transaction.setEuinData()\"\n                         ng-disabled=\"Transaction.isArnSuccess\"\n                         autocomplete=\"off\"\n                         ng-required=\"(Transaction.formData.brokerCode || !Transaction.isArnSuccess) && !Transaction.isCheckedTandC\">\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>Select EUIN </label>\n                  &lt;!&ndash;<p ng-if=\"Transaction.formData.distributorARN\" class=\"info-primary\">{{Transaction.formData.distributorARN}}</p>&ndash;&gt;\n          <span class=\"error-input\" ng-show=\"Transaction.tForm.euinInput.$dirty && Transaction.tForm.euinInput.$invalid && Transaction.tForm.euinInput.$error.required\"\n                ng-bind=\"Transaction.VALIDATE_DATA.EUIN_REQUIRED\"></span>\n                  <drop-down list-data=\"Transaction.euinList\"\n                             display-key=\"euinName\"\n                             display-key-second=\"euinCode\"\n                             hdfc-click=\"Transaction.EuinChanged(data)\"\n                             model=\"Transaction.formData.euin\"\n                             for=\"euin\">\n                  </drop-down>\n\n              </div>--></div><div ng-show=Transaction.euinBoxMessage><span class=or-part>OR</span><div class=\"col-sm-12 col-md-7\"><div class=checkbox><input ng-model=Transaction.isCheckedTandC type=checkbox ng-change=Transaction.isCheckedEuin() ng-disabled=\"Transaction.isArnSuccess || Transaction.isSubarnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\" ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributerName) && !Transaction.formData.euin\"> <i class=icon-checkbox></i><ng-bind-html class=checkbox-text ng-bind-html=Transaction.euinBoxMessage.content></ng-bind-html></div></div></div></div><!--<div ng-if=\"Transaction.formData.brokerName\" class=\"row\">\n            <div class=\"col-md-4\">\n              <span>Distributor Name: {{Transaction.formData.brokerName}}</span>\n            </div>\n          </div>--></div><div><div class=\"col-sm-12 col-md-4\"><p class=col-head>Select Source Scheme</p><div class=selectfield ng-class={error:Transaction.tForm.folio.$invalid}><select name=folio ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=Transaction.tForm.folio.$error.required ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><!--            <div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"selectfield\"--><!--                 ng-class=\"{error:Transaction.tForm.outScheme.$invalid}\">--><!--              <label ng-if=\"Transaction.formData.outSchemeCode\">Select Source Scheme</label>--><!--              <select class=\"browser-default custom-select\" name=\"outScheme\"--><!--                      ng-change=\"Transaction.outSchemeChanged()\"--><!--                      ng-model=\"Transaction.formData.outSchemeCode\"--><!--                      ng-init=\"Transaction.formData.outSchemeCode=Transaction.formData.outSchemeCode?Transaction.formData.outSchemeCode: null\"--><!--                      ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Transaction.outSchemeList\"--><!--                      ng-required=\"Transaction.isRequired\">--><!--                <option value=\"\" selected>Select Source Scheme</option>--><!--              </select>--><!--              <span class=\"error-input\" ng-show=\"Transaction.tForm.outScheme.$error.required\"--><!--                    ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--            </div>--><div class=\"input-select input-normal\" ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" ng-class={error:Transaction.tForm.outScheme.$invalid}><input type=text name=outScheme id=outScheme ng-change=Transaction.filterOutSchemeList() ng-model=Transaction.formData.outSchemeName autocomplete=off ng-required=Transaction.isRequired> <span class=highlight></span> <span class=bar></span><label>Select Source Scheme</label><span class=error-input ng-show=Transaction.tForm.outScheme.$error.required ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.outSchemeList display-key=schemeName hdfc-click=Transaction.outSchemeChanged(data) model=Transaction.formData.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{Transaction.formData.outSchemeName}}</p></div><div class=value-snippet ng-if=Transaction.unitsDetails><div><p class=text-uppercase>Total Market Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.totalCurrentValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{Transaction.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.lockedValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{Transaction.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.freeValueUnits | number:3}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{Transaction.unitsDetails.freeValueAmount|unit}}</span></div><p class=text-primary>*as of last business day</p><p class=\"error-message text-danger\">{{Transaction.unitsDetails.message}}</p></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.outSchemeCode || Transaction.unitsDetails.message !== \'\'}\" class=\"col-sm-12 col-md-4\"><p class=col-head>Select Target Scheme</p><div class=\"input-select input-normal\" ng-class={error:Transaction.tForm.inScheme.$invalid}><input type=text name=inScheme id=inScheme ng-change=Transaction.filterInSchemeList() ng-model=Transaction.formData.inSchemeName autocomplete=off ng-required=Transaction.isRequired> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><span class=error-input ng-show=Transaction.tForm.inScheme.$error.required ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.inSchemeList display-key=scheme hdfc-click=Transaction.inSchemeChanged(data) model=Transaction.formData.inSchemeCode for=inScheme></drop-down><p class=info-primary>{{Transaction.formData.inSchemeName}}</p><div class=info-primary>(Only Growth Schemes)</div></div><div class=\"form-group text-center\"><p>OR</p><br><p><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=Transaction.flexIndexschemeListModal()>Select from list</span></p></div><div class=form-group ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\" ng-if=\"Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=form-label>Select IDCW option</label><div class=radio-block ng-repeat=\"_option in Transaction.devidendOptions\"><span class=radio><input type=radio id=dividendOption{{$index}} ng-value=_option ng-disabled=\"_option==Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST&& Transaction.validations.endingType === Transaction.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED\" name=dividendOption ng-model=Transaction.formData.dividendOption> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div><div class=\"input-normal icon-input\" ng-class=\"{error:Transaction.tForm.amount.$invalid,\'has-data\':Transaction.formData.amount}\"><input type=number ignore-mouse-wheel min={{Transaction.validations.minAmount}} max={{Transaction.unitsDetails.freeValueAmount}} name=amount onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-change=Transaction.checkValidations() ng-model=Transaction.formData.amount class=pd20 ng-required=Transaction.isRequired> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=Transaction.tForm.amount.$error.required ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span class=error-input ng-show=Transaction.tForm.amount.$error.min>{{ Transaction.VALIDATE_DATA.MINIMUM_AMOUNT }} &#8377; {{Transaction.validations.minAmount}}</span> <span class=error-input ng-show=Transaction.tForm.amount.$error.max>{{ Transaction.VALIDATE_DATA.MAX_AMOUNT }}</span> <span class=error-input ng-show=Transaction.tForm.amount.$dirty&&!vm.isMin&&!Transaction.isMultiples>Please Provide In Multiples Of &#8377; {{Transaction.validations.amountMultiples}}</span><div class=info-primary>(&#8377; 20000 Min Amount & in multiples of 1,000 thereafter)</div></div><div ng-if=\"Transaction.formData.amountType==\'amount\'\" class=form-group><label id=divDisplayWords>{{Transaction.amountInWords}} (In Words)</label></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.outSchemeCode || Transaction.unitsDetails.message !== \'\'}\" class=\"col-sm-12 col-md-4\"><p class=col-head>Select Investment Mode</p><div class=form-group ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\"><div class=radio-block><span class=radio><input type=radio id=amount name=amountType value=Fixed ng-model=Transaction.specificProperties.investmentMode ng-change=\"Transaction.helper.investModeChanged(\'Fixed\')\"> <span class=check></span> </span><span class=radio-label>Fixed</span></div><div class=radio-block><span class=radio><input type=radio id=allUnits name=amountType value=Flexible ng-model=Transaction.specificProperties.investmentMode ng-change=\"Transaction.helper.investModeChanged(\'Flexible\')\"> <span class=check></span> </span><span class=radio-label>Flexible</span></div></div><div class=flex-table style=\"display: none\"><table class=borderless><tr><td>{{Transaction.specificProperties.investmentMode}}<br>Installments</td><td>Stages of Switch Execution <span class=grey-text>S&P BSE SENSEX Levels</span></td></tr><tr><td>25%</td><td><div class=input-normal><input type=text> <i>(I)</i></div></td></tr><tr><td>25%</td><td><div class=\"input-normal icon-input\"><input type=text> <i>(II)</i></div></td></tr><tr><td>25%</td><td><div class=input-normal><input type=text> <i>(III)</i></div></td></tr><tr><td>25%</td><td><div class=input-normal><input type=text> <i>(IV)</i></div></td></tr><tr><td>100%</td></tr></table></div><div class=flex-table><table class=borderless><tr><td>{{Transaction.specificProperties.investmentMode}}<br>Installments</td><td>Stages of Switch Execution <span class=grey-text>S&P BSE SENSEX Levels</span></td></tr><tr><td><div class=\"input-normal left-input\"><input ng-if=\"Transaction.specificProperties.investmentMode!=\'Fixed\'\" type=text placeholder=\"Minimum 10%\" ng-change=\"Transaction.helper.installmentValueChanged(\'installment1\')\" ng-model=Transaction.specificProperties.investmentModeData.installment1> <span ng-if=\"Transaction.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=input-normal><input type=text ng-change=\"Transaction.helper.stageValueChanged(\'stage1\')\" ng-model=Transaction.specificProperties.investmentModeData.stage1> <i>(I)</i></div></td></tr><tr><td><div class=\"input-normal left-input\"><input type=text ng-if=\"Transaction.specificProperties.investmentMode!=\'Fixed\'\" placeholder=\"Minimum 10%\" ng-change=\"Transaction.helper.installmentValueChanged(\'installment2\')\" ng-model=Transaction.specificProperties.investmentModeData.installment2> <span ng-if=\"Transaction.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=\"input-normal icon-input\"><input type=text ng-change=\"Transaction.helper.stageValueChanged(\'stage2\')\" ng-model=Transaction.specificProperties.investmentModeData.stage2> <i>(II)</i></div></td></tr><tr><td><div class=\"input-normal left-input\"><input type=text ng-if=\"Transaction.specificProperties.investmentMode!=\'Fixed\'\" placeholder=\"Minimum 10%\" ng-change=\"Transaction.helper.installmentValueChanged(\'installment3\')\" ng-model=Transaction.specificProperties.investmentModeData.installment3> <span ng-if=\"Transaction.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=input-normal><input type=text ng-change=\"Transaction.helper.stageValueChanged(\'stage3\')\" ng-model=Transaction.specificProperties.investmentModeData.stage3> <i>(III)</i></div></td></tr><tr><td><div class=\"input-normal left-input\"><input type=text ng-if=\"Transaction.specificProperties.investmentMode!=\'Fixed\'\" placeholder=\"Minimum 10%\" ng-change=\"Transaction.helper.installmentValueChanged(\'installment4\')\" ng-model=Transaction.specificProperties.investmentModeData.installment4> <span ng-if=\"Transaction.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=input-normal><input type=text ng-change=\"Transaction.helper.stageValueChanged(\'stage4\')\" ng-model=Transaction.specificProperties.investmentModeData.stage4> <i>(IV)</i></div></td></tr><tr ng-if=\"Transaction.specificProperties.investmentMode!=\'Fixed\'\"><td class=info-primary>(Percentages should be equal to 100)</td></tr></table></div><p class=error-input style=\"margin:10px 0px\" ng-show=\"!Transaction.specificProperties.validations.stage1 ||\n!Transaction.specificProperties.validations.stage2 || !Transaction.specificProperties.validations.stage3\n|| !Transaction.specificProperties.validations.stage4\">Stage amount should be multiples of hundred</p><p class=error-input style=\"margin:10px 0px\" ng-show=\"!Transaction.specificProperties.validations.installment1 ||\n!Transaction.specificProperties.validations.installment2 || !Transaction.specificProperties.validations.installment3\n|| !Transaction.specificProperties.validations.installment4\">Installment % should be of two digit</p><p class=error-input style=\"margin:10px 0px 20px 0px\" ng-show=\"Transaction.specificProperties.investmentMode!=\'Fixed\' && !Transaction.specificProperties.validations.installmentsSumHundred\">Sum of all installments should be 100</p><div class=input-normal><div class=estimate-block ng-if=Transaction.tForm.$valid><a href=\"\" ng-click=Transaction.downloadReport()><strong>Estimated Exit Load</strong></a><div>This transaction may have exit load charges as per AMC guidelines for this scheme</div></div></div></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"form-footer col-md-12\"><button class=\"btn btn-secondary-action\" ng-disabled=\"!Transaction.formData.inSchemeName || !Transaction.formData.outSchemeCode\" ng-click=Transaction.saveForm()>Save</button> <button ng-click=Transaction.goToSummary() ng-disabled=\"!Transaction.tForm.$valid || !Transaction.formData.amount || !Transaction.formData.outSchemeCode || !Transaction.formData.inSchemeCode || !Transaction.specificProperties.validations.stagesValid || !Transaction.isMultiples\n|| !Transaction.specificProperties.validations.installmentsValid || (Transaction.specificProperties.investmentMode!=\'Fixed\' && !Transaction.specificProperties.validations.installmentsSumHundred) || !Transaction.formData.inSchemeCode\n|| (!Transaction.specificProperties.investmentModeData.stage1 ||!Transaction.specificProperties.investmentModeData.stage2|| !Transaction.specificProperties.investmentModeData.stage3||!Transaction.specificProperties.investmentModeData.stage4)|| ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)  || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || !Transaction.formData.outSchemeCode\" class=\"btn btn-primary-action\">Proceed to Transact</button></div></form></div></section></div><div ng-if=Transaction.formData.isSummaryViewEnabled><transaction-summary form-data=Transaction.summaryData is-summary-view-enabled=Transaction.formData.isSummaryViewEnabled transaction-type={{Transaction.transactionType}} show-terms=Transaction.showTerms></transaction-summary></div>");
$templateCache.put("app/transactions/initiate/flexsip/flexsip.html","<div class=\"main-section clearfix\" ng-hide=Transaction.formData.isSummaryViewEnabled><section class=\"initiate-transaction sipPurchase\" ng-init=Transaction.init()><p class=page-title>FLEX SYSTEMATIC INVESTMENT PLAN REGISTRATION <i class=\"info-icon base-tooltip\" tooltip data-bs-toggle=tooltip data-bs-placement={{Main.tooltipClass}} title=\"Flex SIP is a facility whereby investors can invest at predetermined intervals in the\n                 eligible schemes of the Fund, higher amount(s) determined by a formula linked to\n                 value of investments, to take advantage of market movements.\"></i></p><header><form name=fForm novalidate ng-keypress=Transaction.handleEnter($event) autocomplete=off><div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\" class=\"folio-check pull-left\">Existing Folio No :<select name=folio id=_first ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber class=select-folio-list ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Folio</option></select><span class=error-input ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid && Transaction.tForm.folio.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><div class=\"pull-left or-part\" ng-if=\"Transaction.profile.folioCreationEnabled && !Transaction.formData.dynamicData.readOnly\">OR</div><div ng-if=\"Transaction.profile.folioCreationEnabled && !Transaction.formData.dynamicData.readOnly\" class=\"pull-left text-primary cursor-pointer\" ng-click=Transaction.redirectToFolioCreation();>Proceed with a New Folio</div></form></header><fieldset ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\"><div class=content-area><form name=Transaction.tForm novalidate autocomplete=off><div class=col-md-12><div class=\"row borderline\"><div class=\"col-md-12 row\"><table class=\"table borderless top-part\"><tr><td>Investor Name</td><td>:</td><td>{{Transaction.folioInvestorName||Transaction.formData.folioInvestorName}}</td></tr><tr><td>Invest through</td><td>:</td><td><div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\" class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isDirect ng-disabled=!fForm.$valid ng-click=\"Transaction.changeThroughDistributor(\'DIRECT\')\"> <span class=check></span> </span><span class=radio-label>Direct</span></div><div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\" class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isThroughDistributor ng-disabled=!fForm.$valid ng-click=\"Transaction.changeThroughDistributor(\'ARN\')\"> <span class=check></span> </span><span class=radio-label>Distributor</span></div><div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\" class=radio-block><span class=radio><input type=radio name=investThrough ng-value=true ng-model=Transaction.formData.isThroughRia ng-disabled=!fForm.$valid ng-change=\"Transaction.changeThroughDistributor(\'RIA\')\"> <span class=check></span> </span><span class=radio-label>RIA</span></div></td></tr><tr ng-if=Transaction.formData.isThroughDistributor><td></td><td></td><td><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\"><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=\"Transaction.searchDistributor();Transaction.showArnLabel=false\" ng-required=!Transaction.formData.distributorARN maxlength=10 ng-pattern=/^[0-9]{4,10}$/ ng-focus=\"Transaction.showArnLabel=true\"> <span class=highlight></span> <span class=bar></span> <span class=arn ng-show=\"Transaction.showArnLabel || Transaction.formData.brokerCode\">ARN -</span><label>ARN</label><p ng-if=Transaction.formData.brokerName class=info-primary>Distributor Name: {{Transaction.formData.brokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.required) && (!Transaction.formData.distributorName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.pattern) && (!Transaction.formData.distributorName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.brokerCodeError !== \'\' && !Transaction.tForm.brokerCode.$invalid\" ng-bind=Transaction.brokerCodeError></span></div></div><span class=\"col-sm-12 col-md-1 or-part text-center\">OR</span><div class=\"col-sm-12 col-md-3\"><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.distributorName.$dirty && Transaction.tForm.distributorName.$invalid}\"><input type=text name=distributorName id=distributorName ng-change=\"Transaction.searchDistributorByName();Transaction.formData.isEuin=true\" ng-model=Transaction.formData.distributorName autocomplete=off ng-required=!Transaction.formData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><label>Search Distributor</label><drop-down list-data=Transaction.distributorList display-key=name display-key-second=arnCode hdfc-click=Transaction.distributorListChanged(data) model=Transaction.formData.distributorARN for=distributorName></drop-down></div></div></td></tr><!--RIA sections--><tr ng-if=Transaction.formData.isThroughRia><td>RIA Code</td><td>:</td><td><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class=\"{error:(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid)||(Transaction.riaCodeError != \'\')}\"><input type=text name=riaCode id=riaCode ng-model=Transaction.formData.riaBrokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=Transaction.searchDistributor(); ng-required=!Transaction.formData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span><!--<p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name: {{Transaction.formData.brokerName}}</p>--> <span class=error-input ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.required)\" ng-bind=Transaction.VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"Transaction.riaCodeError !== \'\' && !Transaction.tForm.riaCode.$invalid\" ng-bind=Transaction.riaCodeError></span></div></div></td></tr><!--RIA sections ends here--></table><fieldset ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\"><table class=\"table borderless top-part\"><tr ng-if=Transaction.formData.isThroughDistributor><td></td><td></td><td><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class=\"{error:(Transaction.tForm.subBrokerARN.$dirty&&Transaction.tForm.subBrokerARN.$invalid)||(Transaction.subBrokerCodeError !== \'\')}\"><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=Transaction.formData.subBrokerARN ng-change=Transaction.changeSubBrokerArn() ng-blur=Transaction.fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>Sub Broker ARN</label><p ng-if=Transaction.subBrokerName class=info-primary>Sub Broker Name: {{Transaction.subBrokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.subBrokerARN.$dirty && Transaction.tForm.subBrokerARN.$invalid && Transaction.tForm.subBrokerARN.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.subBrokerCodeError != \'\'&& !Transaction.tForm.subBrokerARN.$error.pattern\" ng-bind=Transaction.subBrokerCodeError></span></div></div><span class=\"col-sm-12 col-md-1\"></span><div class=\"col-sm-12 col-md-3\"><div class=input-normal ng-class={error:Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=Transaction.formData.subBrokerCode autocomplete=off ng-disabled=\"!Transaction.formData.subBrokerARN || Transaction.subBrokerCodeError !=\'\'\" ng-required=Transaction.formData.subBrokerARN restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<span ng-if=Transaction.formData.subBrokerARN class=req>*</span></label><span class=error-input ng-show=Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$error.required ng-bind=Transaction.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></td></tr><tr ng-if=Transaction.formData.isThroughDistributor><td></td><td></td><td><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=true ng-model=Transaction.formData.isEuin ng-click=\"Transaction.isCheckedTandC=false\" required> <span class=check></span> </span><span class=radio-label>EUIN</span></div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=false ng-model=Transaction.formData.isEuin ng-click=\"Transaction.euinData.euinNameCode=\'\';Transaction.filterEuinList();Transaction.isSelectedEuin=true;\"> <span class=check></span> </span><span class=radio-label>EUIN Declaration</span></div></td></tr><tr ng-if=\"Transaction.formData.isEuin != null && Transaction.formData.isEuin === false && Transaction.formData.isThroughDistributor\" ng-hide=!Transaction.distributorMessage><td></td><td></td><td><div class=checkbox><input ng-model=Transaction.isCheckedTandC type=checkbox ng-disabled=Transaction.formData.isEuin ng-required=\"(Transaction.formData.brokerCode || !Transaction.isArnSuccess) && !Transaction.formData.isEuin\"> <i class=icon-checkbox></i><ng-bind-html ng-bind-html=Transaction.distributorMessage.content></ng-bind-html></div></td></tr><tr ng-if=\"Transaction.formData.isEuin != null && Transaction.formData.isEuin === true &&  Transaction.formData.isThroughDistributor\"><td></td><td></td><td><div class=\"input-select input-normal selectfield\" ng-class={error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}><input type=text name=euin id=euin ng-model=Transaction.euinData.euinNameCode ng-change=Transaction.filterEuinList() ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributorName) && !Transaction.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Select Euin</label><!--ng-disabled=\"!Transaction.euinList.length || Transaction.isArnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\"--> <span class=error-input ng-show=\"(Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required) || !Transaction.isSelectedEuin\" ng-bind=Transaction.VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=Transaction.euinList display-key=euinName display-key-second=euinCode hdfc-click=Transaction.selectEuin(data) model=Transaction.formData.euin for=euin></list-drop-down></div></td></tr></table></fieldset><fieldset ng-class=\"{\'anything-disabled\': !Transaction.formData.riaBrokerCode || Transaction.riaCodeError !== \'\'}\" ng-hide=!Transaction.riaMessage><table class=\"table borderless top-part\"><tr ng-if=Transaction.formData.isThroughRia><td><div class=checkbox><input ng-model=Transaction.isCheckedTandC type=checkbox ng-disabled=\"!Transaction.formData.riaBrokerCode || Transaction.riaCodeError !== \'\'\" ng-change=Transaction.setTandCVariable(); ng-required=Transaction.formData.riaBrokerCode> <i class=icon-checkbox></i><ng-bind-html ng-bind-html=Transaction.riaMessage.content></ng-bind-html></div></td></tr></table></fieldset></div></div><div><div id=SIP-form><div class=row><label class=form-label>Add Scheme</label></div><div class=row><div class=\"col-sm-12 col-md-3 row\"><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.sInScheme1.$dirty && Transaction.tForm.sInScheme1.$invalid,\n                        \'anything-disabled\': Transaction.formData.dynamicData.readOnly }\"><input type=text name=sInScheme1 id=sInScheme1 ng-change=Transaction.filterInSchemeList() ng-model=Transaction.formData.inSchemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off ng-disabled=!fForm.$valid required> <span class=highlight></span> <span class=bar></span><label>Select a Scheme</label><span class=error-input ng-show=\"Transaction.tForm.sInScheme1.$dirty && Transaction.tForm.sInScheme1.$error.required\" ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.inSchemeList display-key=scheme hdfc-click=\"Transaction.inSchemeChanged(data, \'sip\')\" model=Transaction.formData.inSchemeCode for=sInScheme1></drop-down><p class=info-primary>{{Transaction.formData.inSchemeName}}</p></div></div><div ng-if=!Transaction.formData.dynamicData.readOnly class=\"col-sm-12 col-md-offset-1 col-md-4 scheme-invoke\"><span>OR</span> <span class=\"text-primary cursor-pointer\" ng-click=fForm.$valid&&Transaction.schemeListModal()><i class=list-icon></i> Select from List</span></div></div><div class=row><label class=\"form-label less\">Installment Frequency</label></div><div class=row><div class=\"col-sm-12 col-md-6 form-group\" style=padding:0px><div class=radio-block ng-if=\"Transaction.formData.frequency && Transaction.frequencyList.length > 1\" ng-repeat=\"freq in Transaction.frequencyList\"><span class=radio><input type=radio id=\"{{freq.code+\'1\'}}\" ng-change=Transaction.changeFrequency() ng-model=Transaction.formData.frequency ng-disabled=!fForm.$valid ng-value=freq.code name=installmentFrequency> <span class=check></span> </span><span class=radio-label>{{freq.name}}</span></div></div></div><div class=row><div class=\"col-sm-12 col-md-3 row\"><div class=\"input-normal icon-input\" ng-class=\"{error:(Transaction.tForm.sAmount.$invalid && Transaction.tForm.sAmount.$dirty),\'has-data\':Transaction.formData.amount}\"><input type=number ignore-mouse-wheel name=sAmount ng-model=Transaction.formData.amount ng-disabled=!fForm.$valid ng-change=Transaction.checkFlexSipValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" required> <span class=highlight></span> <span class=bar></span><label>SIP Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"Transaction.tForm.sAmount.$dirty && Transaction.tForm.sAmount.$error.required\" ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=error-input>Minimum amount should be &#8377; {{Transaction.validations.minAmount|unit}}</span> <span ng-if=\"Transaction.formData.amount === 0 && Transaction.isMin\" class=error-input>Minimum amount should be &#8377; {{Transaction.validations.minAmount|unit}}</span> <span ng-if=\"Transaction.formData.amount && Transaction.isMax\" class=error-input>Flex SIP installment amount cannot exceed Rs. 1 Lakh </span><span ng-if=\"Transaction.formData.amount && !Transaction.isMax && !Transaction.isMin && (Transaction.validations.amountMultiples&&!Transaction.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{Transaction.validations.amountMultiples|unit}}</span></div><div class=form-group><label id=divDisplayWords>{{Transaction.amountInWords}} (In Words)</label></div></div><div class=\"col-sm-12 col-md-6 amount-button-container\" ng-if=Transaction.formData.inSchemeCode><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in Transaction.sipFirstInstallmentAmount\" ng-click=\"Transaction.formData.amount=amount;Transaction.checkFlexSipValidations()\"><img src=../../assets/images/rupee-indian.svg>{{amount}}</button></div></div><div class=row ng-if=Transaction.formData.inSchemeCode><div class=\"col-sm-12 col-md-12 p-0\"><label class=form-label>Do you wish to pay First installment with your SIP Registration:</label><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=Transaction.sipFirstInstallment ng-disabled=!fForm.$valid ng-change=Transaction.changeFirstInstallment(true) ng-value=true> <span class=check></span> </span><span class=radio-label>Yes</span></div><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=investmentType ng-model=Transaction.sipFirstInstallment ng-disabled=!fForm.$valid ng-change=Transaction.changeFirstInstallment(false) ng-value=false> <span class=check></span> </span><span class=radio-label>No</span></div></div></div><!--                  <div class=\"row\"--><!--                       ng-if=\"Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">--><!--                    <label class=\"form-label less\">Income Distribution cum Capital Withdrawal (IDCW) Option</label>--><!--                  </div>--><!--                  <div class=\"row\">--><!--                    <div class=\"col-md-12 form-group\" ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\" style=\"padding: 0\"--><!--                         ng-if=\"Transaction.validations.investmentOption === Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">--><!--                      <div--><!--                        class=\"radio-block\" ng-repeat=\"_option in Transaction.devidendOptions\"--><!--                        ng-class=\"{\'anything-disabled\': ((_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)--><!--                        || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendPayoutApplicable === false)) }\">--><!--                      <span class=\"radio\">--><!--                        <input type=\"radio\" id=\"sDividendOption{{_option}}\" ng-value=\"_option\"--><!--                       ng-disabled=\"!fForm.$valid--><!--                       || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)--><!--                       || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendPayoutApplicable === false)\"--><!--                       name=\"sDividendOption\"--><!--                       ng-model=\"Transaction.formData.sipDividendOption\"/>--><!--                      <span class=\"check\"></span>--><!--                    </span>--><!--                        <span class=\"radio-label\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span>--><!--                      </div>--><!--                    </div>--><!--                  </div>--> {{Transaction.formData.purchaseInvestmentOption}}<div class=\"row form-group\" ng-if=\"Transaction.isSchemeTypeELSS && Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div><!--Payment Start here--><div class=row><label class=\"form-label less\">Payment Options</label></div><div class=row><div ng-if=Transaction.formData.flexSipPaymentOption><div class=\"col-md-12 p-0\"><div class=radio-block ng-style=\"(!Transaction.isOTMEnabled || !Transaction.isEMandateEnabled) && {\'margin-right\': 0}\" ng-repeat=\"_option in Transaction.paymentOptions \"><span class=radio ng-if=\"(!(!Transaction.isOTMEnabled && _option==\'OTM\')) && !((!Transaction.isEMandateEnabled && _option==\'E-mandate\'))\"><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-change=Transaction.changedPaymentOption() ng-disabled=!fForm.$valid ng-model=Transaction.formData.flexSipPaymentOption> <span class=check></span> </span><span class=radio-label ng-if=\"(!(!Transaction.isOTMEnabled && _option==\'OTM\')) && !((!Transaction.isEMandateEnabled && _option==\'E-mandate\'))\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><ng-bind-html dynamic=Transaction.DynamicDataFlexSipReview.noteDTO.noteDTOMap.Note_FLEX_SIP_Review.content style=\"margin:-20px 0 0\" ng-if=\"(Transaction.isEMandateEnabled && Transaction.formData.flexSipPaymentOption === Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) || (Transaction.isOTMEnabled && Transaction.formData.flexSipPaymentOption === Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM)\"></ng-bind-html><div class=borderline ng-if=\"Transaction.isOTMEnabled && Transaction.formData.flexSipPaymentOption === Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM\"><div class=row><div class=\"col-sm-12 col-md-4\" style=\"padding-left: 15px;padding-right: 15px\"><div class=\"input-select input-normal selectfield\" ng-class=\"{error:(Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$invalid)\n                            || (Transaction.formData.bankInfo && Transaction.formData.bankInfo.otmFrequency != \'AWP\')}\"><input type=text name=bank id=otmBank ng-model=Transaction.formData.bankInfo.bankName ng-change=Transaction.changeBank() ng-init=\"Transaction.formData.bankInfo = Transaction.formData.bankInfo ? Transaction.formData.bankInfo : null\" autocomplete=off only-alphabets required> <span class=highlight></span> <span class=bar></span><label>Select Bank</label><span class=error-input ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required\" ng-bind=Transaction.VALIDATE_DATA.BANK_REQUIRED></span> <span ng-if=\"Transaction.tForm.bank.$dirty && (Transaction.formData.otmBank\n                              && Transaction.formData.bankInfo.otmFrequency != \'AWP\')\" class=error-input><!-- Otm end date should be on or before selected end date.--> Invalid OTM Bank, OTM Instruction Type not AWP(As & When Presented)</span><bank-drop-down list-data=Transaction.OTMbankList display-key=bankName display-key-second=bankAcNo hdfc-click=Transaction.changeBank() model=Transaction.formData.bankInfo for=otmBank></bank-drop-down></div></div><div class=\"col-sm-12 col-md-3\" ng-if=\"Transaction.formData.bankInfo && !Transaction.formData.bankInfo.ifscCode\"><div class=input-normal ng-class=\"{error:Transaction.tForm.ifscCode.$invalid && Transaction.tForm.ifscCode.$dirty}\"><input type=text ng-model=Transaction.formData.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=Transaction.IFSC_REGEX capitalize><div class=bar></div><div class=highlight></div><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=\"Transaction.tForm.ifscCode.$dirty && Transaction.tForm.ifscCode.$error.required\" ng-bind=Transaction.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=\"Transaction.tForm.ifscCode.$dirty && Transaction.tForm.ifscCode.$error.pattern\" ng-bind=Transaction.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><div class=\"col-sm-12 col-md-3\" ng-if=\"Transaction.formData.bankInfo && !Transaction.formData.bankInfo.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:Transaction.formData.bankInfo.bankAcType.$dirty && Transaction.formData.bankInfo.bankAcType.$invalid}\"><select class=select-box name=accountType ng-model=Transaction.formData.bankAcType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Transaction.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=Transaction.formData.bankAcType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=Transaction.formData.bankInfo.bankAcType.$error ng-show=Transaction.formData.bankInfo.bankAcType.$dirty><span ng-message=required ng-bind=Transaction.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row ng-if=\"Transaction.isOTMEnabled && Transaction.formData.flexSipPaymentOption === Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM\"><ng-bind-html ng-bind-html=Transaction.notesOtm.content ng-if=Transaction.showOtmNote></ng-bind-html></div><div class=row><div class=\"col-sm-12 col-md-9\"><table class=\"table otm-bank-details borderless\" ng-if=Transaction.formData.bankInfo><tr><td>Account No:</td><td easyassist-key=mask-element>{{Transaction.formData.bankInfo.bankAcNo}}</td></tr><tr><td>OTM UMRN No:</td><td>{{Transaction.formData.bankInfo.omUmrn}}</td></tr><tr><td>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{Transaction.formData.bankInfo.maxAmount}} <span class=error-input ng-show=Transaction.isOTMAmount ng-bind=Transaction.validationMessage></span></td></tr><tr><td>OTM Instruction Type:</td><td>{{Transaction.formData.bankInfo.otmFrequencyName ? Transaction.formData.bankInfo.otmFrequencyName : Transaction.formData.bankInfo.otmFrequency}}</td></tr><tr><td>OTM Start Date:</td><td>{{Transaction.formData.bankInfo.omStartDate}}</td></tr><tr><td>OTM Expiry Date:</td><td>{{Transaction.formData.bankInfo.omExpiryDate}} <span class=error-input ng-show=Transaction.isOTMDate ng-bind=Transaction.VALIDATE_DATA.DATE_VALIDATION_ERROR></span></td></tr></table></div></div></div></div><div ng-if=\"Transaction.paymentOptions.length == 0 || (!Transaction.isEMandateEnabled && !Transaction.isOTMEnabled)\" class=\"bank-error-msg marginBotNovalid\">{{Transaction.validationMessageNoPayment}}</div><div class=\"borderline emandate-section\" ng-if=\"Transaction.formData.flexSipPaymentOption === Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && Transaction.emandateDisplay && Transaction.isEMandateEnabled\"><div class=row><div class=\"col-sm-12 col-md-3 label-emandate\">Select Bank</div><div class=\"col-sm-12 col-md-3\"><div class=\"input-select input-normal selectfield\"><input type=text name=bank id=bank ng-model=Transaction.formData.bankInfo.bankName ng-change=Transaction.changeBank() ng-init=\"Transaction.formData.bankInfo = Transaction.formData.bankInfo ? Transaction.formData.bankInfo : null\" autocomplete=off only-alphabets required readonly> <span class=highlight></span> <span class=bar></span><label ng-if=!Transaction.formData.bankInfo>Select Bank</label><span class=error-input ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required && !Transaction.formData.bankName\" ng-bind=Transaction.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=Transaction.bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=Transaction.changeBank() model=Transaction.formData.bankInfo for=bank></bank-drop-down></div><!--<div class=\"selectfield\">\n                          <select class=\"\" name=\"bank\" ng-disabled=\"false\"\n                                  ng-model=\"Transaction.formData.bankInfo\"\n                                  ng-options=\"bank.bankName for bank in Transaction.bankList track by bank.accountNumber\"\n                                  ng-change=\"Transaction.changeBank()\"\n                                  ng-init=\"Transaction.formData.bankInfo = Transaction.formData.bankInfo ? Transaction.formData.bankInfo : null\"\n                                  easyassist-key=\"mask-element\"\n                                  required>\n                            <option value=\"\" selected>\n                              {{Transaction.bankList&&!Transaction.bankList.length ?\'No Bank Available\':\'Select Bank\'}}\n                            </option>\n                          </select>\n\n                          <label ng-if=\"Transaction.formData.bankInfo\">Select Bank</label>\n                          <span class=\"error-input\"\n                                ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required && !Transaction.formData.bankName\"\n                                ng-bind=\"Transaction.VALIDATE_DATA.BANK_REQUIRED\"></span>\n                        </div>--></div></div><div class=row><div class=\"col-sm-12 col-md-3 label-emandate\">Authentication Mode</div><div class=\"col-sm-12 col-md-3\"><div class=selectfield ng-if=\"Transaction.formData.flexSipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && Transaction.isEMandateEnabled\" ng-class=\"{error:Transaction.tForm.authenticationMode.$dirty && Transaction.tForm.authenticationMode.$invalid}\"><div class=selectauthdrop><select name=authenticationMode ng-disable=!Transaction.authenticationMode class=authModeDropdown ng-model=Transaction.formData.authMode ng-options=\"auth.text for auth in Transaction.authenticationMode\" ng-init=\"Transaction.formData.authMode=Transaction.formData.authMode?Transaction.formData.authMode: null\" required><option value=\"\" selected>{{Transaction.authenticationMode&&!Transaction.authenticationMode.length ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}</option></select><span class=error-input ng-show=\"Transaction.tForm.authenticationMode.$dirty && Transaction.tForm.authenticationMode.$error.required && !Transaction.formData.authMode\" ng-bind=Transaction.VALIDATE_DATA.AUTHENTICATION_MODE_REQUIRED></span></div></div></div></div><div class=row><div class=\"col-sm-12 col-md-3 label-emandate\">Mandate Amount</div><div class=\"col-sm-12 col-md-3\"><div class=\"input-normal icon-input\" ng-class=\"{error:(Transaction.tForm.eAmount.$invalid && Transaction.tForm.eAmount.$dirty),\'has-data\':Transaction.formData.emandateAmount}\"><input type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=eAmount ng-model=Transaction.formData.emandateAmount ng-change=Transaction.checkAmountValidationEmandate() ng-disabled=!fForm.$valid ng-maxlength=10 limit-to=10 required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><div class=amtWords ng-if=Transaction.formData.emandateAmount><p id=amountInwordsEmandate>{{Transaction.formData.emandateWord.amountInWords}} (In Words)</p></div><!--                          <span class=\"text-success\">--><!--                            Maximum allowed for e-mandate is ₹ {{Transaction.mandateMaxString}}.--><!--                          </span>--><div class=error-input ng-show=\"Transaction.amountLess && !Transaction.amountLessMin\">{{Transaction.VALIDATE_DATA.EMANDATE_MIN_ERROR_FLEX_SIP}}</div><div class=error-input ng-show=Transaction.amountLessMin>{{Transaction.VALIDATE_DATA.EMANDATE_MIN_ERROR + Transaction.emandateMinimumAmountLimit}}.</div><div class=error-input ng-show=Transaction.amountMore>{{Transaction.VALIDATE_DATA.EMANDATE_MAX_ERROR + Transaction.mandateMaxString}}.</div><div class=error-input ng-show=\"!Transaction.amountLess && !Transaction.amountLessMin &&  Transaction.isLessThanSipAmount\" ng-bind=Transaction.VALIDATE_DATA.EMANDATE_SIP_AMOUNT_ERROR></div><div class=error-input ng-show=!Transaction.formData.emandateAmount ng-bind=Transaction.VALIDATE_DATA.MANDATE_AMOUNT_REQUIRED></div></div></div></div><div class=row><div class=\"col-sm-12 col-md-3 label-emandate\">Mandate Start Date</div><div class=\"col-sm-12 col-md-3 anything-disabled\" ng-if=!Transaction.isReseting><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode={{Transaction.viewMode}} data-date-default=Transaction.formData.emandateDate id=emandateStartDate data-enable=true style=\"position: relative\"><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div></div><div class=row><div class=\"col-sm-12 col-md-3 label-emandate\">Mandate End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-bs-placement=right title={{Transaction.mandateInfo}} tooltip-side=right></i></div><div class=\"sip-dates col-sm-12 col-md-3\"><div ng-class=\"{\'anything-disabled\': !Transaction.formData.emandateDate}\"><div class=form-group ng-if=!Transaction.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal eEndDate\" ng-class=\"{error:Transaction.tForm.endDateEmandate.$dirty && Transaction.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=Transaction.formData.endDateEmandate data-enabled-dates=Transaction.enabledEmandateEndDatesList data-view-date=Transaction.enabledEndDateView data-max-date=Transaction.maxEndDateEmandate data-min-date=Transaction.minEndDateEmandate data-on-date-change=Transaction.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><!-- data-min-date=\"Transaction.formData.minEndDate\"--> <input type=text name=endDateEmandate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Transaction.sipDateLessEmandate ng-bind=Transaction.VALIDATE_DATA.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div><div class=row><ng-bind-html dynamic=Transaction.notesEOtm.content ng-if=\"Transaction.showEotmNote && Transaction.formData.authMode.value !== \'DEBIT_CARD\'\"></ng-bind-html><ng-bind-html dynamic=Transaction.notesEOtmDebitCard.content ng-if=\"Transaction.showEotmNote && Transaction.formData.authMode.value === \'DEBIT_CARD\'\"></ng-bind-html></div></div><div ng-if=\"(Transaction.isEmailinValid || Transaction.isEmailMobileinValid || Transaction.isMobileinValid) && (Transaction.formData.flexSipPaymentOption === Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && Transaction.isEMandateEnabled)\" class=emandateError><span class=error-input ng-show=Transaction.isMobileinValid ng-bind=Transaction.VALIDATE_DATA.INVALID_MOBILE_EMANDATE></span> <span class=error-input ng-show=Transaction.isEmailinValid ng-bind=Transaction.VALIDATE_DATA.INVALID_EMAIL_EMANDATE></span> <span class=error-input ng-show=Transaction.isEmailMobileinValid ng-bind=Transaction.VALIDATE_DATA.INVALID_EMAIL_MOBILE_EMANDATE></span></div><!--Payment End here--><div class=row><label class=\"form-label less\">Installment Date Details</label></div><div ng-if=\"(Transaction.formData.flexSipPaymentOption !== Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) || !Transaction.formData.flexSipPaymentOption\"><div class=row><div class=\"col-sm-12 col-md-3 row\" ng-if=!Transaction.isReseting ng-class=\"{\'anything-disabled\': !Transaction.formData.inSchemeName}\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode={{Transaction.viewMode}} data-date-default=Transaction.formData.startDate data-enabled-dates=Transaction.enabledBillerStartDatesList data-min-date=Transaction.startMinDateBiller data-max-date=Transaction.startMaxDate data-on-date-change=Transaction.changeStartDate id=startDate-EC data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"Flex SIP Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=Transaction.formData.startDate>Flex SIP Start Date - DD-MMM-YYYY</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Transaction.tForm.startDate.$error.required ng-bind=Transaction.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div></div><div class=row><div class=\"col-sm-12 col-md-3 row\" ng-class=\"{\'anything-disabled\': !Transaction.formData.inSchemeName}\"><div class=\"input-select input-normal selectfield\" style=\"margin-bottom: 30px\" ng-class=\"{error: Transaction.tForm.tenure.$invalid && Transaction.tForm.tenure.$dirty}\"><select class=\"browser-default custom-select\" name=tenure ng-model=Transaction.formData.tenure ng-change=Transaction.changeTenure() ng-options=\"duration.tenureValue as duration.tenureKey for duration in Transaction.tenureDuration\" required><option value=\"\" selected>Select Tenure</option></select><label style=\"background: white\" ng-if=Transaction.formData.tenure>Tenure</label><span ng-show=\"Transaction.tForm.tenure.$dirty && Transaction.tForm.tenure.$invalid\"><span class=error-input ng-show=Transaction.tForm.tenure.$error.required ng-bind=Transaction.TRANSACTIONS_CONST.validations.TENURE_EMPTY></span></span></div></div></div><div class=\"row borderline\"><div class=\"sip-dates flex-sip-end-date\"><div class=\"col-sm-12 col-md-3 row anything-disabled\"><div class=form-group ng-if=!Transaction.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:Transaction.tForm.endDate.$dirty && Transaction.tForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=Transaction.formData.endDate data-on-date-change=Transaction.changeEndDate data-enabled-dates=Transaction.enabledEndDates data-view-date=Transaction.enabledEndDateView data-min-date=Transaction.enabledEndDates[0] data-enable=true id=endDate-EC showdefault=false><input type=text name=endDate autocomplete=off placeholder=\"Flex SIP End Date - DD-MMM-YYYY\" readonly disabled style=\"cursor: not-allowed\"> <span class=highlight></span><label ng-if=Transaction.formData.endDate>Flex SIP End Date - DD-MMM-YYYY</label><span class=bar></span> <span class=error-input ng-show=\"Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\" ng-bind=Transaction.VALIDATE_DATA.MONTH_REQUIRED></span></div></div></div></div></div></div><div ng-if=\"Transaction.isOTMEnabled && Transaction.formData.flexSipPaymentOption === Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM\"><div class=row><div class=\"col-sm-12 col-md-3 row\" ng-if=!Transaction.isReseting ng-class=\"{\'anything-disabled\': !Transaction.formData.inSchemeName}\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\" date-calendar data-viewmode={{Transaction.viewMode}} data-date-default=Transaction.formData.startDate data-enabled-dates=Transaction.enabledOTMStartDatesList data-min-date=Transaction.startMinDateOTM data-max-date=Transaction.startMaxDate data-on-date-change=Transaction.changeStartDate id=startDate-OTM data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"Flex SIP Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=Transaction.formData.startDate>Flex SIP Start Date - DD-MMM-YYYY</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Transaction.tForm.startDate.$error.required ng-bind=Transaction.VALIDATE_DATA.START_DATE_REQUIRED></span> <span class=error-input ng-show=Transaction.isOTMStartDate ng-bind=\"Transaction.VALIDATE_DATA.DATE_SIP_VALIDATION_ERROR + \' \' + Transaction.formData.bankInfo.omStartDate\"></span></div></div></div><div class=row><div class=\"col-sm-12 col-md-3 row\" ng-class=\"{\'anything-disabled\': !Transaction.formData.inSchemeName}\"><div class=\"input-select input-normal selectfield\" style=\"margin-bottom: 30px\" ng-class=\"{error: Transaction.tForm.tenure.$invalid && Transaction.tForm.tenure.$dirty}\"><select class=\"browser-default custom-select\" name=tenure ng-model=Transaction.formData.tenure ng-change=Transaction.changeTenure() ng-options=\"duration.tenureValue as duration.tenureKey for duration in Transaction.tenureDuration\" required><option value=\"\" selected>Select Tenure</option></select><label style=\"background: white\" ng-if=Transaction.formData.tenure>Tenure</label><span ng-show=\"Transaction.tForm.tenure.$dirty && Transaction.tForm.tenure.$invalid\"><span class=error-input ng-show=Transaction.tForm.tenure.$error.required ng-bind=Transaction.VALIDATE_DATA.TENURE_EMPTY></span></span></div></div></div><div class=\"row borderline\"><div class=\"sip-dates flex-sip-end-date\"><div class=\"col-sm-12 col-md-3 row anything-disabled\"><div class=form-group ng-if=!Transaction.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:Transaction.tForm.endDate.$dirty && Transaction.tForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=Transaction.formData.endDate data-on-date-change=Transaction.changeEndDate data-enabled-dates=Transaction.enabledEndDates data-view-date=Transaction.enabledEndDateView data-min-date=Transaction.enabledEndDates[0] data-enable=true id=endDate-OTM showdefault=false><!-- data-min-date=\"Transaction.formData.minEndDate\"--> <input type=text name=endDate autocomplete=off placeholder=\"Flex SIP End Date - DD-MMM-YYYY\" ng-model=Transaction.formData.minEndDate readonly disabled style=\"cursor: not-allowed\"> <span class=highlight></span><label ng-if=Transaction.formData.endDate>Flex SIP End Date - DD-MMM-YYYY</label><span class=bar></span> <span class=error-input ng-show=\"Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\" ng-bind=Transaction.VALIDATE_DATA.MONTH_REQUIRED></span> <span class=error-input ng-show=Transaction.isOTMEndDate ng-bind=Transaction.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span> <span class=error-input ng-show=Transaction.sipDateLessEmandate ng-bind=Transaction.VALIDATE_DATA.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div></div></div></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=form-footer><button ng-disabled=!Transaction.formData.inSchemeName class=\"btn btn-secondary-action\" type=button ng-click=Transaction.saveForm()>Save</button> <button ng-if=\"Transaction.formData.flexSipPaymentOption!==\'E-mandate\'\" type=button ng-disabled=\"!Transaction.tForm.$valid||Transaction.isInvalidForm || Transaction.isOTMStartDate || Transaction.isOTMEndDate\n                    || !Transaction.formData.inSchemeCode  || !Transaction.formData.startDate || !Transaction.formData.endDate || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (Transaction.formData.bankInfo.otmFrequency != null && Transaction.formData.bankInfo.otmFrequency != \'AWP\')\n                    || Transaction.isMax || Transaction.isMin || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || !Transaction.isMultiples || !Transaction.isOTMEnabled\" ng-click=Transaction.goToFlexSipSummary() class=\"btn btn-primary-action\">Proceed to Transact</button> <button ng-if=\"Transaction.formData.flexSipPaymentOption===\'E-mandate\'\" type=button ng-disabled=\"!Transaction.tForm.$valid || Transaction.isInvalidForm\n                    || !Transaction.formData.inSchemeCode || !Transaction.formData.startDate || !Transaction.formData.endDate || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (Transaction.formData.bankInfo.otmFrequency != null && Transaction.formData.bankInfo.otmFrequency != \'AWP\') || Transaction.isMax || Transaction.isMin || Transaction.isEmailinValid || Transaction.isEmailMobileinValid || Transaction.isMobileinValid || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || !Transaction.isMultiples || Transaction.amountLess || Transaction.amountMore || Transaction.isLessThanSipAmount || Transaction.sipDateLessEmandate || Transaction.amountLessMin\" ng-click=Transaction.goToFlexSipSummary() class=\"btn btn-primary-action\">Proceed to Transact</button></div></form></div></fieldset></section></div><div ng-if=Transaction.formData.isSummaryViewEnabled><transaction-summary form-data=Transaction.summaryData is-summary-view-enabled=Transaction.formData.isSummaryViewEnabled transaction-type={{Transaction.transactionType}} notes=Transaction.notesReview.content show-terms=Transaction.showTerms show-terms-emandate=Transaction.showTermsEmandate></transaction-summary></div><style>.selectfield select.ng-not-empty {\n    border-bottom: 1px solid #aeaeae;\n  }\n\n  .initiate-transaction .content-area .sip-dates .anything-disabled:before {\n    top: -15px !important;\n  }\n\n  .initiate-transaction .content-area .flex-sip-end-date .anything-disabled:before {\n    background: rgba(255, 255, 255, 0.4);\n  }</style>");
$templateCache.put("app/transactions/initiate/instant-redemption/instant-redemption.html","<div class=main-section ng-hide=Transaction.formData.isSummaryViewEnabled><section class=initiate-transaction ng-init=Transaction.init()><p class=page-title>INSTANT ACCESS FACILITY <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement={{Main.tooltipClass}} title=\"The Instant Access facility allows you to place an immediate withdrawal request from any of your investments made in our Liquid schemes subject to a maximum limit of Rs 50,000 or 90% of the curent valuation of the investment in the liquid scheme per day\"></i></p><div class=\"content-area redeem\"><form class=row name=Transaction.tForm ng-keypress=Transaction.handleEnter($event) novalidate><div><div class=\"col-sm-12 col-md-4\"><p class=col-head>Select Scheme</p><div class=selectfield ng-class={error:Transaction.tForm.folio.$invalid}><select name=folio id=_first ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=Transaction.tForm.folio.$error.required ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><p ng-if=Transaction.errorMessage ng-bind=Transaction.errorMessage></p><!--            <div class=\"selectfield\"--><!--                 ng-class=\"{error:Transaction.tForm.outScheme.$invalid && Transaction.tForm.outScheme.$dirty, \'anything-disabled\': !Transaction.formData.folioNumber}\">--><!--              <label ng-if=\"Transaction.formData.outSchemeCode\">Select a Scheme</label>--><!--              <select class=\"\" name=\"outScheme\"--><!--                      ng-change=\"Transaction.outSchemeChanged()\"--><!--                      ng-model=\"Transaction.formData.outSchemeCode\"--><!--                      ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Transaction.outSchemeList\"--><!--                      ng-init=\"Transaction.formData.outSchemeCode=Transaction.formData.outSchemeCode?Transaction.formData.outSchemeCode: null\"--><!--                      required=\"required\">--><!--                <option value=\"\" selected>Select a Scheme</option>--><!--              </select>--><!--            <span class=\"error-input\" ng-show=\"Transaction.tForm.outScheme.$invalid && Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$error.required\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--            </div>--><div class=\"input-select input-normal\" ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" ng-class={error:Transaction.tForm.outScheme.$invalid}><input type=text name=outScheme id=outScheme ng-change=Transaction.filterOutSchemeList() ng-model=Transaction.formData.outSchemeName autocomplete=off ng-required=Transaction.isRequired> <span class=highlight></span> <span class=bar></span><label>Select a Scheme</label><span class=error-input ng-show=Transaction.tForm.outScheme.$error.required ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.outSchemeList display-key=schemeName hdfc-click=Transaction.outSchemeChanged(data) model=Transaction.formData.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{Transaction.formData.outSchemeName}}</p></div><div class=value-snippet ng-if=\"Transaction.validations.maxAmount !==\'\' && Transaction.formData.outSchemeCode\"><div><p class=text-uppercase>Available for Instant Access Facility</p><span class=left-val>Amount </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{Transaction.validations.maxAmount | number :2}}</span></div></div></div><div class=\"col-sm-12 col-md-4\"><p class=col-head>Enter Amount Value</p><div class=\"input-normal icon-input\" ng-if=\"Transaction.formData.amountType==\'amount\'\" ng-class=\"{error:Transaction.tForm.amount.$invalid && Transaction.tForm.amount.$dirty || (Transaction.tForm.amount.$dirty && Transaction.isMax),\'has-data\':Transaction.formData.amount,\n               \'anything-disabled\': !Transaction.formData.folioNumber}\"><input type=number ignore-mouse-wheel name=amount onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-change=Transaction.checkInstantRedeemValidations() ng-model=Transaction.formData.amount class=pd20 required> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"Transaction.tForm.amount.$invalid && Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$error.required\" ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Transaction.formData.amount && Transaction.isMin && !Transaction.isMax\" class=error-input>Minimum amount should be &#8377; {{Transaction.validations.minAmount|unit}}</span> <span ng-if=\"Transaction.formData.amount && Transaction.isMax  && !Transaction.isMin\" class=error-input>You don\'t have sufficient balance to perform Instant access facility OR Your daily limit for Instant access facility is already utilized.</span> <span ng-if=\"Transaction.formData.amount && !Transaction.isMax && !Transaction.isMin && (Transaction.validations.amountMultiples&&!Transaction.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{Transaction.validations.amountMultiples|unit}}</span></div><div style=\"padding-top: 19px\"><label id=divDisplayWords>{{Transaction.amountInWords}} (In Words)</label></div><div class=input-normal ng-if=\"Transaction.formData.amountType==\'units\'\" ng-class={error:Transaction.tForm.units.$invalid||(Transaction.tForm.units.$dirty&&Transaction.isInvalidForm)}><input type=number ignore-mouse-wheel ng-disabled=!Transaction.unitsDetails.freeValueUnits ng-change=Transaction.checkRedeemValidations() name=units ng-model=Transaction.formData.units required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter Units</label><span class=error-input ng-show=\"Transaction.tForm.units.$invalid && Transaction.tForm.units.$dirty && Transaction.tForm.units.$error.required\" ng-bind=Transaction.VALIDATE_DATA.UNITS_REQUIRED></span> <span ng-if=\"Transaction.formData.units && Transaction.isMin\" class=error-input>{{Transaction.VALIDATE_DATA.MINIMUM_UNIT}}{{Transaction.validations.minUnits|unit}}</span> <span ng-if=\"Transaction.formData.units && Transaction.isMax\" class=error-input>{{Transaction.VALIDATE_DATA.MAX_UNIT}}</span></div><div class=input-normal><div class=estimate-block ng-if=Transaction.tForm.$valid><a href=\"\" ng-click=Transaction.downloadReport()><strong>Estimated Exit Load</strong></a><div>This transaction may have exit load charges as per AMC guidelines for this scheme</div></div></div></div><div class=\"col-sm-12 col-md-4\"><p class=col-head>Select Bank For Payout</p><div class=selectfield ng-class=\"{error:Transaction.tForm.bank.$invalid && Transaction.tForm.bank.$dirty, \'anything-disabled\': !Transaction.formData.folioNumber}\"><select name=bank ng-disable=!Transaction.bankList ng-model=Transaction.formData.bankInfo ng-options=\"bank as bank.bankName for bank in Transaction.bankList track by bank.accountNo\" ng-init=\"Transaction.formData.bankInfo=Transaction.formData.bankInfo?Transaction.formData.bankInfo: null\" required ng-change=Transaction.instantRedeemBankValidation(Transaction.formData.bankInfo)><option value=\"\" selected>{{Transaction.bankList&&!Transaction.bankList.length?\'No Bank Available for Instant Access\':\'Select Bank for Instant Access Facility\'}}</option></select><label ng-if=Transaction.formData.bankInfo.bankName>Select Bank for Instant Access Facility</label><span class=error-input ng-show=\"Transaction.tForm.bank.$invalid && Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required\" ng-bind=Transaction.VALIDATE_DATA.BANK_REQUIRED></span> <span class=error-input ng-show=Transaction.showBankInfo>{{Transaction.formData.bankInfo.bankInfo}}</span></div><p ng-if=Transaction.bankErrorMsg ng-bind=Transaction.bankErrorMsg></p><table class=\"table borderless\" ng-if=Transaction.formData.bankInfo&&Transaction.bankList.length><tr><td>Bank Name:</td><td>{{Transaction.formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{Transaction.formData.bankInfo.accountNo}}</td></tr><tr><td>IFSC:</td><td>{{Transaction.formData.bankInfo.ifscCode}}</td></tr><tr ng-if=Transaction.formData.bankInfo.payoutDescription><td>Payout:</td><td>{{Transaction.formData.bankInfo.payoutDescription | uppercase}}</td></tr></table></div><div class=col-sm-12><ng-bind-html ng-bind-html=Transaction.notes.content></ng-bind-html></div></div><div class=\"form-footer col-md-12\"><button class=\"btn btn-secondary-action\" ng-disabled=\"!Transaction.formData.outSchemeCode || !Transaction.formData.folioNumber\" ng-click=Transaction.saveInstaForm()>Save</button> <button ng-click=Transaction.goToSummary() ng-disabled=\"Transaction.tForm.$invalid||Transaction.isInvalidForm || Transaction.showBankInfo  || (!Transaction.kycVerifiedFlag) || !Transaction.formData.outSchemeCode\" class=\"btn btn-primary-action\">Proceed to Transact</button></div></form></div></section></div><div ng-if=Transaction.formData.isSummaryViewEnabled><transaction-summary form-data=Transaction.summaryData is-summary-view-enabled=Transaction.formData.isSummaryViewEnabled transaction-type={{Transaction.transactionType}}></transaction-summary></div>");
$templateCache.put("app/transactions/initiate/nfoSwitchOut/nfoswitchout.html","<p>nfo-switch-out place holder</p>");
$templateCache.put("app/transactions/initiate/redemption/redemption.html","<div class=\"main-section clearfix\" ng-hide=Transaction.formData.isSummaryViewEnabled><section class=\"initiate-transaction redemption\" ng-init=Transaction.init()><p class=page-title>REDEEM</p><div class=\"content-area redeem\"><form autocomplete=off class=row name=Transaction.tForm ng-keypress=Transaction.handleEnter($event) novalidate><div class=\"col-sm-12 col-md-4\"><p class=col-head>Select Scheme</p><div class=selectfield ng-class=\"{error:(Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid)}\"><select name=folio id=_first ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid && Transaction.tForm.folio.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><!--          <div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"selectfield\"--><!--               ng-class=\"{error:Transaction.tForm.outScheme.$invalid}\">--><!--            <label ng-if=\"Transaction.formData.outSchemeCode\">Select Scheme</label>--><!--            <select class=\"\" name=\"outScheme\"--><!--                    ng-change=\"Transaction.outSchemeChanged()\"--><!--                    ng-model=\"Transaction.formData.outSchemeCode\"--><!--                    ng-init=\"Transaction.formData.outSchemeCode=Transaction.formData.outSchemeCode?Transaction.formData.outSchemeCode: null\"--><!--                    ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Transaction.outSchemeList\"--><!--                    required>--><!--              <option value=\"\" selected>Select Scheme</option>--><!--            </select>--><!--            <span class=\"error-input\"--><!--                  ng-show=\"Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$error.required\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--          </div>--><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid, \'anything-disabled\': !Transaction.formData.folioNumber }\"><input type=text name=outScheme id=outScheme ng-change=Transaction.filterOutSchemeList() ng-model=Transaction.formData.outSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><span class=error-input ng-show=\"Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$invalid && Transaction.tForm.outScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.outSchemeList display-key=schemeName hdfc-click=Transaction.outSchemeChanged(data) model=Transaction.formData.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{Transaction.formData.outSchemeName}}</p></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=value-snippet ng-if=Transaction.unitsDetails><div><p class=text-uppercase>Total Market Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.totalCurrentValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{Transaction.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.lockedValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{Transaction.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.freeValueUnits | number:3}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{Transaction.unitsDetails.freeValueAmount|unit}}</span></div><p class=text-primary>*as of last business day</p></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"col-sm-12 col-md-4 brdrhgt\"><p class=col-head>Select Value</p><div class=form-group><div class=radio-block><span class=radio><input type=radio id=amount name=amountType ng-value=Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT ng-model=Transaction.formData.amountType ng-disabled=!Transaction.unitsDetails.freeValueAmount ng-change=Transaction.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>Amount</span></div><div class=radio-block><span class=radio><input type=radio id=allUnits name=amountType ng-value=Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS ng-model=Transaction.formData.amountType ng-disabled=!Transaction.unitsDetails.freeValueAmount ng-change=Transaction.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>All Free units</span></div><div class=radio-block><span class=radio><input type=radio id=noOfUnits name=amountType ng-value=Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS ng-model=Transaction.formData.amountType ng-disabled=!Transaction.unitsDetails.freeValueAmount ng-change=Transaction.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>No. of units</span></div></div><div class=\"input-normal icon-input\" ng-if=\"Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT\" ng-class=\"{error:(Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$invalid),\'has-data\':Transaction.formData.amount}\"><input type=number ignore-mouse-wheel ng-disabled=!Transaction.unitsDetails.freeValueAmount name=amount onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-change=Transaction.checkRedeemValidations() ng-model=Transaction.formData.amount class=pd20 required> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$error.required\" ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=error-input>Amount must be greater or equal to {{Transaction.validations.minAmount.toFixed(2)}}<!-- Amount cannot be less than the minimum required amount in the target scheme--> </span><span ng-if=\"Transaction.formData.amount && Transaction.isMax\" class=error-input>Amount cannot exceed value of clear units available to redeem </span><span ng-if=\"Transaction.formData.amount && !Transaction.isMax && !Transaction.isMin && (Transaction.validations.amountMultiples&&!Transaction.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{Transaction.validations.amountMultiples|unit}}</span><div style=\"padding-top: 20px\"><div id=divDisplayWords>{{Transaction.amountInWords}} (In Words)</div></div></div><div class=input-normal ng-if=\"Transaction.formData.amountType==\'units\'\" ng-class=\"{error:(Transaction.tForm.units.$dirty && Transaction.tForm.units.$invalid)}\"><input type=number ignore-mouse-wheel ng-disabled=!Transaction.unitsDetails.freeValueUnits ng-change=Transaction.checkRedeemValidations() name=units ng-model=Transaction.formData.units ng-required=Transaction.isRequired autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter Units</label><span class=error-input ng-show=\"Transaction.tForm.units.$dirty && Transaction.tForm.units.$error.required\" ng-bind=Transaction.VALIDATE_DATA.UNITS_REQUIRED></span> <span ng-if=\"Transaction.formData.units !== \'\' && Transaction.isMin\" class=error-input>Unit must be greater or equal to {{Transaction.validations.minUnits.toFixed(3)}}<!--Value of units cannot be less than the minimum required amount in the target scheme--> </span><span ng-if=\"Transaction.formData.units && Transaction.isMax\" class=error-input>Units cannot exceed clear units available to redeem</span></div><div class=input-normal><div class=estimate-block ng-if=Transaction.tForm.$valid><a href=\"\" ng-click=Transaction.downloadReport()><strong>Estimated Exit Load</strong></a><div>This transaction may have exit load charges as per AMC guidelines for this scheme</div></div></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"col-sm-12 col-md-4\"><p class=col-head>Select Bank For Payout</p><div class=selectfield ng-class=\"{error:Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$invalid}\"><select name=bank ng-disable=!Transaction.bankList ng-model=Transaction.formData.bankInfo ng-options=\"bank.bankName for bank in Transaction.bankList track by bank.id\" ng-change=Transaction.changeBank() ng-init=\"Transaction.formData.bankInfo=Transaction.formData.bankInfo?Transaction.formData.bankInfo: null\" required><option value=\"\" selected>{{Transaction.bankList&&!Transaction.bankList.length?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=Transaction.formData.bankInfo.bankName>Select Bank</label><span class=error-input ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required\" ng-bind=Transaction.VALIDATE_DATA.BANK_REQUIRED></span></div><span class=text-green>Please click here to see your registered payout banks.</span><table class=\"table borderless\" ng-if=Transaction.formData.bankInfo&&Transaction.bankList.length><tr><td>Bank Name:</td><td>{{Transaction.formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{Transaction.formData.bankInfo.bankAcNo}}</td></tr><tr><td>IFSC:</td><td>{{Transaction.formData.bankInfo.ifscCode}}</td></tr><tr><td>Payout:</td><td>{{Transaction.formData.bankInfo.payoutDescription | uppercase}}</td></tr></table></div><div class=\"col-sm-12 col-md-12\"><ng-bind-html ng-bind-html=Transaction.noteRedemption.content></ng-bind-html></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"form-footer col-md-12\"><button class=\"btn btn-secondary-action\" ng-disabled=\"!Transaction.formData.outSchemeCode || !Transaction.unitsDetails.freeValueUnits\" ng-click=Transaction.saveForm()>Save</button> <button ng-disabled=\"(!Transaction.tForm.$valid||Transaction.isInvalidForm)\n              || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS && Transaction.isMin)\n              || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS && Transaction.isMax)\n              || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && Transaction.isMin)\n              || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && Transaction.isMax)\n              || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && !Transaction.isMultiples)\n              || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && (Transaction.unitsDetails.freeValueAmount < Transaction.outSchemeValidations.minRedemptionAmt))\n              || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS && (Transaction.unitsDetails.freeValueUnits < Transaction.outSchemeValidations.minRedemptionUnit))\n              || (Transaction.selectedFolioObj.minorFlag && !Transaction.formData.bankInfo.minorBankFlag) || !Transaction.formData.outSchemeCode\" class=\"btn btn-secondary-action\" type=button ng-click=Transaction.goToScheduleTransaction()>Schedule Transaction</button><!--<button ng-disabled=\"Transaction.tForm.$invalid\" class=\" btn btn-secondary-action\" disabled ng-click=\"Transaction.saveForm()\">Save</button>--> <button ng-click=Transaction.goToSummary() ng-disabled=\"(!Transaction.tForm.$valid||Transaction.isInvalidForm)\n                  || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS && Transaction.isMin)\n                  || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS && Transaction.isMax)\n                  || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && Transaction.isMin)\n                  || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && Transaction.isMax)\n                  || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && !Transaction.isMultiples)\n                  || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT && (Transaction.unitsDetails.freeValueAmount < Transaction.outSchemeValidations.minRedemptionAmt))\n                  || (Transaction.formData.amountType==Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS && (Transaction.unitsDetails.freeValueUnits < Transaction.outSchemeValidations.minRedemptionUnit))\n                  || (Transaction.selectedFolioObj.minorFlag && !Transaction.formData.bankInfo.minorBankFlag)  || (!Transaction.kycVerifiedFlag) || !Transaction.formData.outSchemeCode\" class=\"btn btn-primary-action\">Proceed to Transact</button></div></form></div></section></div><div ng-if=Transaction.formData.isSummaryViewEnabled><transaction-summary form-data=Transaction.summaryData is-summary-view-enabled=Transaction.formData.isSummaryViewEnabled transaction-type={{Transaction.transactionType}} show-terms=Transaction.showTerms></transaction-summary></div>");
$templateCache.put("app/transactions/initiate/sip-purchase/sip-purchase.html","<!--\n<div class=\"container-fluid sip-purchase main-section clearfix\" ng-hide=\"Transaction.formData.isSummaryViewEnabled\">\n  <div ng-init=\"Transaction.init()\" class=\"transaction-header\">\n    <h3 ng-if=\"Transaction.formData.investmentType === \'PURCHASE\'\" class=\"page-title\">Purchase</h3>\n    <h3 ng-if=\"Transaction.formData.investmentType === \'SIP\'\" class=\"page-title\">SIP</h3>\n  </div>\n  <div class=\"transaction-body\">\n    <section class=\"initiate-transaction\">\n      <form name=\"Transaction.tForm\" ng-keypress=\"Transaction.handleEnter($event)\" novalidate autocomplete=\"off\">\n        &lt;!&ndash;folio card section&ndash;&gt;\n        <div class=\"card\">\n          <div class=\"card-body folio-card\">\n            <div class=\"row\">\n              <div class=\"col-md-3\">\n                <div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly || Transaction.formData.modifyAction == \'modifySip\' }\" class=\"form-input folio-input\">\n                  <label for=\"folioInput\" class=\"form-label\">Existing Folio Number</label>\n                  <select name=\"folio\" id=\"folioInput\"\n                          ng-change=\"Transaction.folioChanged(); Transaction.checkTransactionID = false;\"\n                          ng-model=\"Transaction.formData.folioNumber\"\n                          class=\"select-folio-list form-select\"\n                          ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\"\n                          ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\"\n                          options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=\"Transaction.isRequired\">\n                    <option value=\"\">Select Folio</option>\n                  </select>\n                  <span class=\"error-input\"\n                        ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid && Transaction.tForm.folio.$error.required\"\n                        ng-bind=\"Transaction.VALIDATE_DATA.FOLIO_REQUIRED\"></span>\n                </div>\n              </div>\n              <div class=\"col-md-9 d-flex\">\n                <div class=\"investor-intro\">\n                  <div>\n                    Hi, <span>Pranali</span>\n                  </div>\n                  <div>\n                    Embark on a journey towards achieving your goal.\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        &lt;!&ndash;folio card section ends here&ndash;&gt;\n        &lt;!&ndash;Scheme Details section start from here&ndash;&gt;\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <div class=\"row\">\n              <div class=\"col-md-12\">\n                <h5>Scheme Details</h5>\n              </div>\n            </div>\n          </div>\n          <div class=\"card-body\">\n            <div class=\"row\">\n              <div class=\"col-md-7\">\n                <div class=\"form-input\">\n                  <label class=\"form-label\">Invest Through</label>\n                  <div class=\"invest-through-options\" ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\">\n                    <div class=\"radio-button\">\n                      <input type=\"radio\" id=\"direct\" name=\"throughDistributor\" ng-value=\"true\"\n                             ng-model=\"Transaction.formData.isDirect\"\n                             ng-disabled=\"!Transaction.tForm.$valid\"/>\n                      <label class=\"btn btn-default\" for=\"direct\" ng-click=\"Transaction.changeThroughDistributor(\'DIRECT\')\">Direct</label>\n                    </div>\n                    <div class=\"radio-button\">\n                      <input type=\"radio\" id=\"distributor\" name=\"throughDistributor\" ng-value=\"true\"\n                             ng-model=\"Transaction.formData.isThroughDistributor\"\n                             ng-disabled=\"!Transaction.tForm.$valid\"/>\n                      <label class=\"btn btn-default\" for=\"distributor\" ng-click=\"Transaction.changeThroughDistributor(\'ARN\')\">Distributor</label>\n                    </div>\n                    <div class=\"radio-button\">\n                      <input type=\"radio\" name=\"throughDistributor\" id=\"ria\"\n                             ng-value=\"true\"\n                             ng-model=\"Transaction.formData.isThroughRia\"\n                             ng-disabled=\"!Transaction.tForm.$valid\"/>\n                      <label class=\"btn btn-default\" for=\"ria\" ng-click=\"Transaction.changeThroughDistributor(\'RIA\')\">RIA</label>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        &lt;!&ndash;scheme details section ends here&ndash;&gt;\n      </form>\n      &lt;!&ndash;<header>\n        <form name=\"fForm\" novalidate  autocomplete=\"off\">\n\n          <div class=\"pull-left or-part\" ng-if=\"Transaction.profile.folioCreationEnabled && !Transaction.formData.dynamicData.readOnly && Transaction.formData.modifyAction !== \'modifySip\'\"> OR</div>\n          <div ng-if=\"Transaction.profile.folioCreationEnabled && !Transaction.formData.dynamicData.readOnly && Transaction.formData.modifyAction !== \'modifySip\'\" class=\"pull-left text-primary cursor-pointer\"\n               ng-click=\"Transaction.redirectToFolioCreation();\">Proceed with a New Folio\n          </div>\n        </form>\n      </header>&ndash;&gt;\n\n      <fieldset ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\">\n        <div class=\"content-area\">\n          <form name=\"Transaction.tForm\" novalidate autocomplete=\"off\">\n            <div class=\"col-md-12\">\n              <div class=\"row borderline\">\n                <div class=\"col-md-12 row\">\n                  <table class=\"table borderless top-part\">\n                    <tr ng-if=\"false\">\n                      <td>\n                        Investment Type\n                      </td>\n                      <td> :</td>\n                      <td>\n                        <div class=\"radio-block\">\n                      <span class=\"radio\">\n                        <input type=\"radio\" id=\"purchase\" name=\"investmentType\"\n                               ng-model=\"Transaction.formData.investmentType\"\n                               ng-disabled=\"!fForm.$valid\"\n                               ng-value=\"Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\"/>\n                        <span class=\"check\"></span>\n                      </span>\n                          <span class=\"radio-label\">Purchase</span>\n                        </div>\n\n                        <div class=\"radio-block\">\n                       <span class=\"radio\">\n                        <input type=\"radio\" id=\"sip\" name=\"investmentType\"\n                               ng-model=\"Transaction.formData.investmentType\"\n                               ng-disabled=\"!fForm.$valid\"\n                               ng-value=\"Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"/>\n                        <span class=\"check\"></span>\n                      </span>\n                          <span class=\"radio-label\">SIP</span>\n                        </div>\n                      </td>\n                    </tr>\n                    <tr>\n                      <td>\n                        Investor Name\n                      </td>\n                      <td> :</td>\n                      <td>\n                        {{Transaction.folioInvestorName||Transaction.formData.folioInvestorName}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <td>\n                        Invest through\n                      </td>\n                      <td> :</td>\n                      <td>\n                        <div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\"\n                             class=\"radio-block\">\n                       <span class=\"radio\">\n                        <input type=\"radio\" name=\"throughDistributor\" ng-value=\"true\"\n                               ng-model=\"Transaction.formData.isDirect\"\n                               ng-disabled=\"!fForm.$valid\"\n                               ng-click=\"Transaction.changeThroughDistributor(\'DIRECT\'); Transaction.checkTransactionID = false\"/>\n                        <span class=\"check\"></span>\n                      </span>\n                          <span class=\"radio-label\">Direct</span>\n                        </div>\n\n                        <div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\"\n                             class=\"radio-block\">\n                    <span class=\"radio\">\n                      <input type=\"radio\" name=\"throughDistributor\" ng-value=\"true\"\n                             ng-model=\"Transaction.formData.isThroughDistributor\"\n                             ng-disabled=\"!fForm.$valid\"\n                             ng-click=\"Transaction.changeThroughDistributor(\'ARN\'); Transaction.checkTransactionID = false\"/>\n                      <span class=\"check\"></span>\n                    </span>\n                          <span class=\"radio-label\">Distributor</span>\n                        </div>\n\n                        <div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\"\n                             class=\"radio-block\">\n                        <span class=\"radio\">\n                          <input type=\"radio\" name=\"investThrough\"\n                                 ng-value=\"true\"\n                                 ng-model=\"Transaction.formData.isThroughRia\"\n                                 ng-disabled=\"!fForm.$valid\"\n                                 ng-change=\"Transaction.changeThroughDistributor(\'RIA\') ; Transaction.checkTransactionID = false\"/>\n                          <span class=\"check\"></span>\n                        </span>\n                          <span class=\"radio-label\">RIA</span>\n                        </div>\n                      </td>\n                    </tr>\n                    <tr ng-if=\"Transaction.formData.isThroughDistributor\">\n                      <td></td>\n                      <td></td>\n                      <td>\n                        <div class=\"col-sm-12 col-md-3\">\n                          <div class=\"input-normal\"\n                               ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\">\n                            <input type=\"text\" class=\"arn-no\" name=\"brokerCode\" id=\"brokerCode\"\n                                   ng-model=\"Transaction.formData.brokerCode\"\n                                   ng-change=\"Transaction.changeDistributorCode()\"\n                                   autocomplete=\"off\"\n                                   ng-blur=\"Transaction.searchDistributor();Transaction.showArnLabel=false\"\n                                   ng-required=\"!Transaction.formData.distributorARN\"\n                                   maxlength=\"10\" ng-pattern=\"/^[0-9]{4,10}$/\"\n                                   ng-focus=\"Transaction.showArnLabel=true\">\n                            <span class=\"highlight\"></span>\n                            <span class=\"bar\"></span>\n                            <span class=\"arn\" ng-show=\"Transaction.showArnLabel || Transaction.formData.brokerCode\">ARN -</span>\n                            <label>ARN</label>\n                            <p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name:\n                              {{Transaction.formData.brokerName}}</p>\n                            <span class=\"error-input\"\n                                  ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.required) && (!Transaction.formData.distributorName)\"\n                                  ng-bind=\"Transaction.VALIDATE_DATA.BROKER_REQUIRED\"></span>\n                            <span class=\"error-input\"\n                                  ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.pattern) && (!Transaction.formData.distributorName)\"\n                                  ng-bind=\"Transaction.VALIDATE_DATA.BROKER_VALID\"></span>\n                            <span class=\"error-input\"\n                                  ng-show=\"Transaction.brokerCodeError !== \'\' && !Transaction.tForm.brokerCode.$invalid\"\n                                  ng-bind=\"Transaction.brokerCodeError\"></span>\n                          </div>\n                        </div>\n                        <span class=\"col-sm-12 col-md-1 or-part text-center\">OR</span>\n                        <div class=\"col-sm-12 col-md-3\">\n                          <div class=\"input-select input-normal\"\n                               ng-class=\"{error:Transaction.tForm.distributorName.$dirty && Transaction.tForm.distributorName.$invalid}\">\n                            <input type=\"text\" name=\"distributorName\" id=\"distributorName\"\n                                   ng-change=\"Transaction.searchDistributorByName();Transaction.formData.isEuin=true\"\n                                   ng-model=\"Transaction.formData.distributorName\"\n                                   autocomplete=\"off\" ng-required=\"!Transaction.formData.brokerCode\" only-alphabets>\n                            <span class=\"highlight\"></span>\n                            <span class=\"bar\"></span>\n                            <label>Search Distributor</label>\n                            <drop-down list-data=\"Transaction.distributorList\"\n                                       display-key=\"name\"\n                                       display-key-second=\"arnCode\"\n                                       hdfc-click=\"Transaction.distributorListChanged(data)\"\n                                       model=\"Transaction.formData.distributorARN\"\n                                       for=\"distributorName\">\n                            </drop-down>\n                          </div>\n                        </div>\n                      </td>\n                    </tr>\n                    &lt;!&ndash;RIA sections&ndash;&gt;\n                    <tr ng-if=\"Transaction.formData.isThroughRia\">\n                      <td>RIA Code</td>\n                      <td> :</td>\n                      <td>\n                        <div class=\"col-sm-12 col-md-4\">\n                          <div class=\"input-normal\"\n                               ng-class=\"{error:(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid)||(Transaction.riaCodeError != \'\')}\">\n                            <input type=\"text\" name=\"riaCode\" id=\"riaCode\"\n                                   ng-model=\"Transaction.formData.riaBrokerCode\"\n                                   ng-change=\"Transaction.changeDistributorCode()\"\n                                   autocomplete=\"off\"\n                                   ng-blur=\"Transaction.searchDistributor();\"\n                                   ng-required=\"!Transaction.formData.distributorARN\"\n                                   maxlength=\"12\" ng-pattern=\"/^[A-Z0-9]{12}/\"\n                                   capitalize\n                            >\n                            <span class=\"highlight\"></span>\n                            <span class=\"bar\"></span>\n                            &lt;!&ndash;<p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name: {{Transaction.formData.brokerName}}</p>&ndash;&gt;\n                            <span class=\"error-input\"\n                                  ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.required)\"\n                                  ng-bind=\"Transaction.VALIDATE_DATA.RIA_REQUIRED\"></span>\n                            <span class=\"error-input\"\n                                  ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.pattern)\"\n                                  ng-bind=\"Transaction.VALIDATE_DATA.RIA_INVALID\"></span>\n                            <span class=\"error-input\"\n                                  ng-show=\"Transaction.riaCodeError !== \'\' && !Transaction.tForm.riaCode.$invalid\"\n                                  ng-bind=\"Transaction.riaCodeError\"></span>\n                          </div>\n                        </div>\n                      </td>\n                    </tr>\n                    &lt;!&ndash;RIA sections ends here&ndash;&gt;\n                  </table>\n                  <fieldset ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\">\n                    <table class=\"table borderless top-part\">\n\n                      <tr ng-if=\"Transaction.formData.isThroughDistributor\">\n                        <td></td>\n                        <td></td>\n                        <td>\n                          <div class=\"col-sm-12 col-md-3\">\n                            <div class=\"input-normal\"\n                                 ng-class=\"{error:(Transaction.tForm.subBrokerARN.$dirty&&Transaction.tForm.subBrokerARN.$invalid)||(Transaction.subBrokerCodeError !== \'\')}\">\n                              <input type=\"text\" class=\"arn-no\" name=\"subBrokerARN\" id=\"subBrokerARN\"\n                                     ng-model=\"Transaction.formData.subBrokerARN\"\n                                     ng-change=\"Transaction.changeSubBrokerArn()\"\n                                     ng-blur=\"Transaction.fetchEuinListSubBroker()\"\n                                     maxlength=\"10\" ng-pattern=\"/^[0-9]{4,10}$/\"\n                                     autocomplete=\"off\" restrict-special-charcter ng-trim=\"false\">\n                              <span class=\"highlight\"></span>\n                              <span class=\"bar\"></span>\n                              <span class=\"arn\">ARN -</span>\n                              <label>Sub Broker ARN</label>\n                              <p ng-if=\"Transaction.subBrokerName\" class=\"info-primary\">Sub Broker Name:\n                                {{Transaction.subBrokerName}}</p>\n                              <span class=\"error-input\"\n                                    ng-show=\"(Transaction.tForm.subBrokerARN.$dirty && Transaction.tForm.subBrokerARN.$invalid && Transaction.tForm.subBrokerARN.$error.pattern)\"\n                                    ng-bind=\"Transaction.VALIDATE_DATA.BROKER_VALID\"></span>\n                              <span class=\"error-input\"\n                                    ng-show=\"Transaction.subBrokerCodeError != \'\'&& !Transaction.tForm.subBrokerARN.$error.pattern\"\n                                    ng-bind=\"Transaction.subBrokerCodeError\"></span>\n                            </div>\n                          </div>\n                          <span class=\"col-sm-12 col-md-1\"></span>\n                          <div class=\"col-sm-12 col-md-3\">\n                            <div class=\"input-normal\"\n                                 ng-class=\"{error:Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$invalid}\">\n                              <input type=\"text\" name=\"subBrokerCode\" id=\"subBrokerCode\"\n                                     ng-model=\"Transaction.formData.subBrokerCode\"\n                                     autocomplete=\"off\"\n                                     ng-disabled=\"!Transaction.formData.subBrokerARN || Transaction.subBrokerCodeError !=\'\'\"\n                                     ng-change=\"Transaction.changeSubBrokerCode()\"\n                                     restrict-special-charcter\n                                     ng-trim=\"false\">\n                              <span class=\"highlight\"></span>\n                              <span class=\"bar\"></span>\n                              <label>Sub Broker Code</label>\n                              <span class=\"error-input\"\n                                    ng-show=\"Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$error.required\"\n                                    ng-bind=\"Transaction.VALIDATE_DATA.SUB_BROKER_REQUIRED\"></span>\n                            </div>\n                          </div>\n                        </td>\n                      </tr>\n                      <tr ng-if=\"Transaction.formData.isThroughDistributor\">\n                        <td></td>\n                        <td></td>\n                        <td>\n                          <div class=\"radio-block\">\n                    <span class=\"radio\">\n                      <input type=\"radio\" name=\"euinCheck\" ng-value=\"true\"\n                             ng-model=\"Transaction.formData.isEuin\"\n                             ng-click=\"Transaction.isCheckedTandC=false\"\n                             required/>\n                      <span class=\"check\"></span>\n                    </span>\n                            <span class=\"radio-label\">EUIN</span>\n                          </div>\n                          <div class=\"radio-block\">\n                       <span class=\"radio\">\n                        <input type=\"radio\" name=\"euinCheck\" ng-value=\"false\"\n                               ng-model=\"Transaction.formData.isEuin\"\n                               ng-click=\"Transaction.euinData.euinNameCode=\'\';Transaction.filterEuinList();Transaction.isSelectedEuin=true;\"/>\n                        <span class=\"check\"></span>\n                      </span>\n                            <span class=\"radio-label\">EUIN Declaration</span>\n                          </div>\n                        </td>\n                      </tr>\n                      <tr\n                        ng-if=\"Transaction.formData.isEuin != null && Transaction.formData.isEuin === false && Transaction.formData.isThroughDistributor\"\n                        ng-hide=\"!Transaction.distributorMessage\"\n                      >\n                        <td></td>\n                        <td></td>\n                        <td >\n                          <div class=\"checkbox\">\n                            <input ng-model=\"Transaction.isCheckedTandC\" type=\"checkbox\"\n                                   ng-disabled=\"Transaction.formData.isEuin\"\n                                   ng-required=\"(Transaction.formData.brokerCode || !Transaction.isArnSuccess) && !Transaction.formData.isEuin\"/>\n                            <i class=\"icon-checkbox\"></i>\n\n                            <ng-bind-html\n                              ng-bind-html = \"Transaction.distributorMessage.content\"\n                            ></ng-bind-html>\n\n                          </div>\n                        </td>\n                      </tr>\n\n                      <tr\n                        ng-if=\"Transaction.formData.isEuin != null && Transaction.formData.isEuin === true &&  Transaction.formData.isThroughDistributor\">\n                        <td></td>\n                        <td></td>\n                        <td>\n                          <div class=\"input-select input-normal selectfield\" ng-class=\"{error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}\">\n                            <input type=\"text\" name=\"euin\" id=\"euin\"\n                                   ng-model=\"Transaction.euinData.euinNameCode\"\n                                   ng-change=\"Transaction.filterEuinList()\"\n                                   ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributorName) && !Transaction.isCheckedTandC\"\n                                   autocomplete=\"off\">\n                            <span class=\"highlight\"></span>\n                            <span class=\"bar\"></span>\n                            <label>Select Euin</label>\n                            &lt;!&ndash;ng-disabled=\"!Transaction.euinList.length || Transaction.isArnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\"&ndash;&gt;\n                            <span class=\"error-input\" ng-show=\"(Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required) || !Transaction.isSelectedEuin\"\n                                  ng-bind=\"Transaction.VALIDATE_DATA.EUIN_REQUIRED\"></span>\n                            <list-drop-down list-data=\"Transaction.euinList\"\n                                            display-key=\"euinName\"\n                                            display-key-second=\"euinCode\"\n                                            hdfc-click=\"Transaction.selectEuin(data)\"\n                                            model=\"Transaction.formData.euin\"\n                                            for=\"euin\">\n                            </list-drop-down>\n                          </div>\n                        </td>\n                      </tr>\n                    </table>\n                  </fieldset>\n                  <fieldset ng-class=\"{\'anything-disabled\': !Transaction.formData.riaBrokerCode || Transaction.riaCodeError !== \'\'}\" ng-hide=\"!Transaction.riaMessage\">\n                    <table class=\"table borderless top-part\">\n                      <tr ng-if=\"Transaction.formData.isThroughRia\">\n                        <td>\n                          <div class=\"checkbox\">\n                            <input ng-model=\"Transaction.isCheckedTandC\" type=\"checkbox\"\n                                   ng-disabled=\"!Transaction.formData.riaBrokerCode || Transaction.riaCodeError !== \'\'\"\n                                   ng-change=\"Transaction.setTandCVariable();\"\n                                   ng-required=\"Transaction.formData.riaBrokerCode\"/>\n                            <i class=\"icon-checkbox\"></i>\n\n                            <ng-bind-html\n                              ng-bind-html = \"Transaction.riaMessage.content\"\n                            ></ng-bind-html>\n\n                          </div>\n                        </td>\n                      </tr>\n                    </table>\n                  </fieldset>\n                </div>\n              </div>\n\n              <div data-ng-switch=\"Transaction.formData.investmentType\">\n                <div data-ng-switch-when=\"PURCHASE\">\n                  <div data-ng-include=\"\'app/transactions/initiate/sip-purchase/purchase/purchase.html\'\"></div>\n                </div>\n                <div data-ng-switch-when=\"SIP\">\n                  <div data-ng-include=\"\'app/transactions/initiate/sip-purchase/sip/sip.html\'\"></div>\n                </div>\n              </div>\n\n              <div class=\"row\" ng-if=\"false\">\n                <div class=\"add-button\" ng-if=\"!Transaction.formData.optionalInvestmentType\"\n                     ng-click=\"fForm.$valid&&Transaction.addOptionalTransaction()\">\n                  <i class=\"expand-block-icon\"></i> Add\n                  {{Transaction.formData.investmentType===Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE?\'Sip\':\'Lumpsum\'}}\n                  Transaction (Optional)\n                </div>\n                <div class=\"add-button\" ng-if=\"Transaction.formData.optionalInvestmentType\"\n                     ng-click=\"Transaction.removeOptionalScheme()\">\n                  <i class=\"collapse-block-icon\"></i> Remove\n                  {{Transaction.formData.investmentType===Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE?\'Sip\':\'Lumpsum\'}}\n                  Transaction (Optional)\n                </div>\n\n              </div>\n\n              <div data-ng-switch=\"Transaction.formData.optionalInvestmentType\">\n                <div data-ng-switch-when=\"PURCHASE\">\n                  <div data-ng-include=\"\'app/transactions/initiate/sip-purchase/purchase/purchase.html\'\"></div>\n                </div>\n                <div data-ng-switch-when=\"SIP\">\n                  <div data-ng-include=\"\'app/transactions/initiate/sip-purchase/sip/sip.html\'\"></div>\n                </div>\n              </div>\n            </div>\n            <div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"form-footer\">\n              <button ng-if=\"Transaction.transactionType==\'SIP\' && Transaction.formData.modifyAction !== \'modifySip\'\"\n                      ng-disabled=\"!Transaction.formData.inSchemeName\" class=\" btn btn-secondary-action\" type=\"button\"\n                      ng-click=\"Transaction.saveForm()\">Save\n              </button>\n              <button ng-if=\"Transaction.transactionType==\'PURCHASE\' || Transaction.transactionType==\'SCHEDULE_TRANSACTION_PURCHASE\'\"\n                      ng-disabled=\"!Transaction.formData.purchaseInSchemeName\" class=\" btn btn-secondary-action\"\n                      type=\"button\" ng-click=\"Transaction.saveForm()\">Save\n              </button>\n              &lt;!&ndash; Schedule Transaction button  &ndash;&gt;\n              <button ng-if=\"Transaction.transactionType==\'PURCHASE\' || Transaction.transactionType==\'SCHEDULE_TRANSACTION_PURCHASE\'\"\n                      ng-disabled=\"!Transaction.tForm.$valid||\n                Transaction.isInvalidForm || !Transaction.helper.isFormValid() || !Transaction.formData.purchaseInSchemeCode || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || !Transaction.isSelectedEuin || Transaction.purchaseValidations.purchaseMultiple && !Transaction.isMultiples\"\n                      class=\" btn btn-secondary-action\" type=\"button\"\n                      ng-click=\"Transaction.goToScheduleTransaction()\">\n                Schedule Transaction\n              </button>\n\n              <button ng-hide=\"Transaction.transactionType==\'SIP\' && (Transaction.formData.frequency !== \'OM\' || Transaction.sipFirstInstallment || Transaction.formData.sipTopupEnabled)\"\n                      ng-disabled=\"!Transaction.tForm.$valid||\n                Transaction.isInvalidForm || !Transaction.helper.isFormValid() || (Transaction.transactionType==\'PURCHASE\' && !Transaction.formData.purchaseInSchemeCode) || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || !Transaction.isSelectedEuin || (Transaction.transactionType==\'PURCHASE\' && Transaction.purchaseValidations.purchaseMultiple && !Transaction.isMultiples) ||\n                (Transaction.transactionType==\'SIP\' && (!Transaction.formData.startDate || !Transaction.formData.endDate || !Transaction.isMultiples || Transaction.amountExceeded || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (Transaction.formData.bankInfo.otmFrequency != null && Transaction.formData.bankInfo.otmFrequency != \'AWP\'\n                              && Transaction.formData.frequency === \' BZ\') || Transaction.isMax || Transaction.isMin || (!Transaction.kycVerifiedFlag) || !Transaction.formData.inSchemeCode || Transaction.isminCapAmount || Transaction.isOTMStartDate || Transaction.isOTMEndDate || (Transaction.formData.sipPaymentOption===\'E-mandate\' && (Transaction.isEmailinValid || Transaction.isEmailMobileinValid || Transaction.isMobileinValid))))\"\n                      class=\" btn btn-secondary-action\" type=\"button\"\n                      ng-click=\"Transaction.showNavApplicabilityModal()\">\n                Add to E-cart\n              </button>\n\n              &lt;!&ndash; Schedule Transaction button section ends here &ndash;&gt;\n              <button ng-if=\"Transaction.transactionType==\'SIP\' && Transaction.formData.sipPaymentOption!==\'E-mandate\'\" type=\"button\" ng-disabled=\"!Transaction.tForm.$valid||Transaction.isInvalidForm || !Transaction.helper.isFormValid() || Transaction.isOTMStartDate || Transaction.isOTMEndDate\n          || !Transaction.formData.inSchemeCode || Transaction.isminCapAmount || !Transaction.formData.startDate || !Transaction.formData.endDate || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (Transaction.formData.bankInfo.otmFrequency != null && Transaction.formData.bankInfo.otmFrequency != \'AWP\'\n                              && Transaction.formData.frequency === \' BZ\') || Transaction.isMax || Transaction.isMin || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || !Transaction.isMultiples || Transaction.amountExceeded || Transaction.formData.modifyAction == \'modifySip\' && Transaction.disableBtnForModify || (Transaction.formData.sipPaymentOption == \'UPI\' && !Transaction.formData.isUPIVerified)\"\n                      ng-click=\"Transaction.goToSipSummary()\" class=\" btn btn-primary-action\">Proceed to Transact\n              </button>\n              <button ng-if=\"Transaction.transactionType==\'SIP\' && Transaction.formData.sipPaymentOption===\'E-mandate\'\" type=\"button\" ng-disabled=\"!Transaction.tForm.$valid||Transaction.isInvalidForm || !Transaction.helper.isFormValid()\n          || !Transaction.formData.inSchemeCode || Transaction.isminCapAmount || !Transaction.formData.startDate || !Transaction.formData.endDate || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (Transaction.formData.bankInfo.otmFrequency != null && Transaction.formData.bankInfo.otmFrequency != \'AWP\'\n                              && Transaction.formData.frequency === \' BZ\') || Transaction.isMin || Transaction.isEmailinValid || Transaction.isEmailMobileinValid || Transaction.isMobileinValid || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || !Transaction.isMultiples || Transaction.amountExceeded || Transaction.formData.modifyAction == \'modifySip\' && Transaction.disableBtnForModify || Transaction.amountLess || Transaction.amountMore || Transaction.isLessThanSipAmount || Transaction.sipDateLessEmandate\"\n                      ng-click=\"Transaction.goToSipSummary()\" class=\" btn btn-primary-action\">Proceed to Transact\n              </button>\n              <button ng-if=\"Transaction.transactionType==\'PURCHASE\' || Transaction.transactionType==\'SCHEDULE_TRANSACTION_PURCHASE\'\" type=\"button\" ng-disabled=\"!Transaction.tForm.$valid||\n          Transaction.isInvalidForm || !Transaction.helper.isFormValid() || !Transaction.formData.purchaseInSchemeCode || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (!Transaction.kycVerifiedFlag) || (Transaction.isPurchaseAmountDecimal) || !Transaction.isSelectedEuin || Transaction.purchaseValidations.purchaseMultiple && !Transaction.isMultiples\"\n                      ng-click=\"Transaction.goToPurchaseSummary()\" class=\" btn btn-primary-action\">Proceed to Transact\n              </button>\n\n              &lt;!&ndash;{{!Transaction.tForm.$valid}}=1=={{Transaction.isInvalidForm }}=2=={{ Transaction.isOTMInvalidForm }}=3=={{\n              Transaction.isBankInvalidForm }}=4=={{ !Transaction.helper.isFormValid() }}=5=={{\n              !Transaction.formData.inSchemeCode }}=6=={{ransaction.formData.startDate }}=7=={{\n              !Transaction.formData.endDate }}=8=={{ Transaction.formData.brokerCode }}=9=={{\n              Transaction.formData.distributorARN }}=10=={{ Transaction.isArnSuccess\n              }}=11=={{ Transaction.formData.subBrokerARN }}\"=111==\"{{ Transaction.isSubarnSuccess\n              }}=12=={{ (Transaction.formData.bankInfo.otmFrequency != \'AWP\' )}}=13=={{ Transaction.formData.frequency === \'BZ\' }}=14=={{\n              Transaction.formData.sipPaymentOption === \'OTM\'\n              }}=15=={{ (Transaction.formData.sipTopupEnabled && (Transaction.formData.topupDetails.amount ?\n              Transaction.tForm.topupAmount.$invalid : Transaction.tForm.topupPercentage.$invalid))\n              }}=16=={{ransaction.formData.sipTopupEnabled && Transaction.isCapInvalidForm}}&ndash;&gt;\n            </div>\n          </form>\n        </div>\n      </fieldset>\n\n      <div class=\"ecart-journey main-section-ecart\" ng-if=\"Transaction.showEcartModel\">\n        <div class=\"sidebar-container\" id=\"sidebarContainer\"\n             hdfc-ecart-sidebar\n             side-title=\"Transaction.sidebarTitle\"\n             investor-data = \"Transaction.investorData\"\n             cart-item = \"Transaction.ecartData\"\n             show-add-cart=\"Transaction.showAddCart\"\n             close-action=\"Transaction.closeAction(action)\">\n        </div>\n      </div>\n\n    </section>\n  </div>\n  <div class=\"transaction-footer\">\n\n  </div>\n</div>\n\n<div ng-if=\"Transaction.formData.isSummaryViewEnabled\">\n  <transaction-summary\n    form-data=\"Transaction.summaryData\"\n    is-summary-view-enabled=\"Transaction.formData.isSummaryViewEnabled\"\n    transaction-type=\"{{Transaction.transactionType}}\"\n    notes=\"Transaction.notesReview.content\"\n    show-terms = \"Transaction.showTerms\"\n    show-terms-emandate = \"Transaction.showTermsEmandate\"\n    note-upi-otp=\"Transaction.upiModalNote\"\n  ></transaction-summary>\n</div>\n\n-->");
$templateCache.put("app/transactions/initiate/sip-topup/sip-topup.html","<div class=\"main-section clearfix\"><section class=\"initiate-transaction redemption sip-topup\" ng-init=SipTopup.init()><p class=page-title>SIP TOPUP</p><div class=\"content-area redeem\"><form autocomplete=off class=row name=sipTopupForm ng-keypress=Transaction.handleEnter($event) novalidate><div class=col-md-12><div class=\"row form-group\"><div class=col-md-3><div class=\"input-normal icon-input\" ng-class=\"{error:(SipTopup.formData.topupDetails.amount && (SipTopup.isMinTopupAmount || !SipTopup.isMultipleTopupAmount))}\"><input type=number ignore-mouse-wheel ng-change=SipTopup.changeTopupAmount(sipTopupForm) name=topupAmount onkeyup=\"NumToWord(this.value,\'topupAmntInWords\')\" ng-disabled=SipTopup.formData.topupDetails.percentage ng-model=SipTopup.formData.topupDetails.amount autocomplete=off ng-required=\"(!SipTopup.formData.topupDetails.percentage && !SipTopup.formData.topupDetails.amount) || !SipTopup.formData.topupDetails.percentage\"> <i class=rupee-grey-icon></i><label>Amount</label><div class=error-input ng-if=\"(SipTopup.formData.topupDetails.amount && (SipTopup.isMinTopupAmount || !SipTopup.isMultipleTopupAmount))\"><!--ng-show=\"(!SipTopup.formData.topupDetails.percentage && !SipTopup.formData.topupDetails.amount) || !SipTopup.formData.topupDetails.percentage\"--> <span ng-if=\"SipTopup.isMinTopupAmount && sipTopupForm.topupAmount.$valid\">{{\'Minimum amount should be &#8377;\'+ SipTopup.schemeValidationsData.topupMinAmt+\'.\'}} </span><span ng-if=\"!SipTopup.isMultipleTopupAmount && sipTopupForm.topupAmount.$valid && !SipTopup.isMinTopupAmount && !SipTopup.amountExceeded\">{{\'Please provide In multiples of &#8377;\'+ SipTopup.schemeValidationsData.topupAmtMultples+\'.\'}} </span><span ng-if=\"sipTopupForm.topupDetails.amount.$invalid && sipTopupForm.topupDetails.amount.$error.number\">{{SipTopup.VALIDATE_DATA.INVALID_AMOUNT+\'.\'}}</span></div><span class=error-input ng-if=\"SipTopup.formData.topupDetails.amount && SipTopup.amountExceeded\">{{SipTopup.VALIDATE_DATA.AMOUNT_EXCEEDED}}</span></div><div ng-if=SipTopup.formData.topupDetails.amount class=amount-in-words style=\"margin-top: 50px\"><span>(In Words)&nbsp;</span><div id=topupAmntInWords></div></div></div><div class=\"col-md-1 or-part text-center\" ng-if=SipTopup.showTopUpPercentage>OR</div><div class=col-md-3 ng-if=SipTopup.showTopUpPercentage><div class=input-normal ng-class=\"{error:(SipTopup.formData.topupDetails.percentage && (SipTopup.isMinTopupPercentage || !SipTopup.isMultipleTopupPercentage))}\"><input type=number ignore-mouse-wheel ng-change=\"SipTopup.changeTopupPercentage(sipTopupForm); SipTopup.getTopupFrequencyList();SipTopup.changeTopUpFreq()\" name=topupPercentage ng-disabled=SipTopup.formData.topupDetails.amount ng-model=SipTopup.formData.topupDetails.percentage autocomplete=off ng-required=\"(!SipTopup.formData.topupDetails.amount && !SipTopup.formData.topupDetails.percentage) || !SipTopup.formData.topupDetails.amount\"><label>Percentage (%)</label><span class=error-input ng-if=\"(SipTopup.formData.topupDetails.percentage && (SipTopup.isMinTopupPercentage || !SipTopup.isMultipleTopupPercentage))\"><!-- ng-show=\"(!SipTopup.formData.topupDetails.amount && !SipTopup.formData.topupDetails.percentage) || !SipTopup.formData.topupDetails.amount\"--> <span ng-if=\"SipTopup.isMinTopupPercentage && sipTopupForm.topupPercentage.$valid\">{{\'Minimum percentage should be \'+ SipTopup.schemeValidationsData.topupMinPercentage+\'%.\'}} </span><span ng-if=\"!SipTopup.isMultipleTopupPercentage && sipTopupForm.topupPercentage.$valid\">{{\'Please provide in multiples of \'+ SipTopup.schemeValidationsData.topupPercentageMultples+\'%.\'}} </span><span ng-if=\"sipTopupForm.topupPercentage.$invalid && sipTopupForm.topupPercentage.$error.number\">{{SipTopup.VALIDATE_DATA.INVALID_AMOUNT+\'.\'}}</span></span></div></div></div><div class=row><div class=col-md-6><div class=install-freq><p><strong>Topup Frequency</strong></p><span class=radio-block ng-repeat=\"freq in SipTopup.topupFrequencyList\"><span class=radio><input type=radio ng-model=SipTopup.formData.topupDetails.frequency ng-value=freq.key ng-change=SipTopup.changeTopUpFreq() name=topupFrequency> <span class=check></span></span><label class=radio-label>{{freq.value}}</label></span></div></div></div><div class=row><div class=col-md-3><div class=\"input-normal icon-input\" ng-class={error:(SipTopup.isminCapAmount)}><input type=number ignore-mouse-wheel name=capAmount onkeyup=\"NumToWord(this.value,\'capAmntInWords\')\" ng-model=SipTopup.formData.topupDetails.capAmount ng-disabled=SipTopup.formData.topupDetails.capMonthYear autocomplete=off ng-change=SipTopup.capAmountChanged(sipTopupForm) ng-required=\"(!SipTopup.formData.topupDetails.capAmount && !SipTopup.formData.topupDetails.capMonthYear) || !SipTopup.formData.topupDetails.capMonthYear\"> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Cap Amount</label><span class=error-input ng-if=SipTopup.isminCapAmount><span ng-if=\"SipTopup.isminCapAmount && sipTopupForm.capAmount.$valid\">{{\'Minimum amount should be &#8377; \'+ SipTopup.minCapAmount}}</span></span></div><div ng-if=SipTopup.formData.topupDetails.capAmount class=amount-in-words><span>(In Words)&nbsp;</span><div id=capAmntInWords></div></div></div><div class=\"col-md-1 or-part text-center\">OR</div><div class=col-md-3><div><div class=selectfield ng-class=\"{\'anything-disabled\': SipTopup.formData.topupDetails.capAmount }\"><select class=\"browser-default custom-select\" name=capDates ng-disabled=SipTopup.formData.topupDetails.capAmount ng-options=\"_dates for _dates in SipTopup.capDates\" ng-model=SipTopup.formData.topupDetails.capMonthYear ng-init=\"SipTopup.formData.topupDetails.capAmount=SipTopup.formData.topupDetails.capAmount?SipTopup.formData.topupDetails.capAmount: null\" ng-required=\"(!SipTopup.formData.topupDetails.capAmount && !SipTopup.formData.topupDetails.capMonthYear) || !SipTopup.formData.topupDetails.capAmount\"><option value=\"\">Cap Month Year - MM/YYYY</option></select></div></div></div><hr><div><p class=\"col-md-6 form-group\"><strong>Payment Options</strong></p></div><div><div class=\"col-md-12 form-group\"><div class=radio-block ng-repeat=\"_option in SipTopup.paymentOptions \"><span class=radio><input type=radio id=paymentOption{{_option}} ng-value=_option name=paymentOption ng-change=SipTopup.changedPaymentOption() ng-model=SipTopup.formData.sipPaymentOption> <span class=check></span> </span><span class=radio-label>{{SipTopup.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div></div><div ng-if=\"SipTopup.formData.sipPaymentOption===SipTopup.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC\"><div><div class=col-md-3><div class=selectfield ng-class=\"{error:SipTopup.tForm.bank.$dirty && SipTopup.tForm.bank.$invalid}\"><select name=bank ng-disabled=false ng-model=SipTopup.formData.bankInfo ng-options=\"bank.bankName for bank in SipTopup.bankList track by bank.bankCode\" ng-change=SipTopup.changeBank() ng-init=\"SipTopup.formData.bankInfo=SipTopup.formData.bankInfo?SipTopup.formData.bankInfo: null\" required><option value=\"\" selected>{{SipTopup.bankList&&!SipTopup.bankList.length ?\'No Bank Available\':\'Select Bank\'}}</option></select><label ng-if=SipTopup.formData.bankInfo>Select Bank</label><span class=error-input ng-show=\"SipTopup.tForm.bank.$dirty && SipTopup.tForm.bank.$error.required && !SipTopup.formData.bankName\" ng-bind=SipTopup.VALIDATE_DATA.BANK_REQUIRED></span></div></div><div class=col-md-3><div class=input-normal ng-if=\"SipTopup.formData.bankInfo.bankCode == \'OTHER\'\" ng-class=\"{error:SipTopup.tForm.bankName.$dirty && SipTopup.tForm.bankName.$invalid}\"><input type=text ng-click=SipTopup.otherBankSelected() ng-disabled=\"SipTopup.formData.bankInfo.bankCode != \'OTHER\'||!fForm.$valid\" ng-model=SipTopup.formData.bankName name=bankName ng-required=\"SipTopup.formData.bankInfo.bankCode == \'OTHER\'\"> <span class=highlight></span> <span class=bar></span><label>Bank Name</label><span class=error-input ng-show=\"SipTopup.tForm.bankName.$dirty && SipTopup.tForm.bankName.$error.required\" ng-bind=SipTopup.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div></div><!--<div class=\"row\">--><!--<div class=\"col-md-3\">--><!--<div class=\"input-normal\"--><!--ng-class=\"{error:SipTopup.tForm.bankBranch.$dirty && Transaction.tForm.bankBranch.$invalid}\">--><!--<input type=\"text\" name=\"bankBranch\" only-alphabets ng-model=\"Transaction.formData.bankBranch\" ng-disabled=\"!fForm.$valid\"--><!--maxlength=\"255\" required>--><!--<span class=\"highlight\"></span>--><!--<span class=\"bar\"></span>--><!--<label>Branch Name</label>--><!--<span class=\"error-input\" ng-show=\"Transaction.tForm.bankBranch.$dirty && Transaction.tForm.bankBranch.$error.required\"--><!--ng-bind=\"Transaction.VALIDATE_DATA.BANK_BRANCH_REQUIRED\"></span>--><!--</div>--><!--</div>--><!--<div class=\"col-md-3 \">--><!--<div class=\"input-normal\"--><!--ng-class=\"{error:Transaction.tForm.bankCity.$dirty && Transaction.tForm.bankCity.$invalid}\">--><!--<input type=\"text\" ng-model=\"Transaction.formData.bankCity\" only-alphabets name=\"bankCity\" ng-disabled=\"!fForm.$valid\"--><!--maxlength=\"255\" required>--><!--<span class=\"highlight\"></span>--><!--<span class=\"bar\"></span>--><!--<label>Branch City</label>--><!--<span class=\"error-input\"--><!--ng-show=\"Transaction.tForm.bankCity.$dirty && Transaction.tForm.bankCity.$error.required\"--><!--ng-bind=\"Transaction.VALIDATE_DATA.BANK_CITY_REQUIRED\"></span>--><!--</div>--><!--</div>--><!--</div>--><div class=row ng-if=\"SipTopup.formData.bankInfo.bankName ==\'HDFC BANK\'\"><div class=col-md-3><div class=input-normal ng-class={error:SipTopup.tForm.bankAcNo.$dirty&&SipTopup.tForm.bankAcNo.$invalid}><input type=text ng-model=SipTopup.formData.bankAcNo name=bankAcNo ng-disabled=!fForm.$valid required minlength=9 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" directive.mask ng-keydown=SipTopup.copyPasteHandler($event) ng-change=SipTopup.accFocus();> <span class=highlight></span> <span class=bar></span><label>Account Number</label><span ng-show=SipTopup.accModelDirty><span class=error-input ng-show=\"SipTopup.formData.bankAcNo.split(\'\').length==0\" ng-bind=SipTopup.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(SipTopup.formData.bankAcNo.split(\'\').length == null || (SipTopup.formData.bankAcNo.split(\'\').length<9 && SipTopup.formData.bankAcNo.split(\'\').length>0)) \" ng-bind=SipTopup.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=col-md-3><div class=input-normal ng-class={error:SipTopup.tForm.verifyBankAcNo.$dirty&&SipTopup.tForm.verifyBankAcNo.$invalid}><input type=text ng-model=SipTopup.formData.verifyBankAcNo name=verifyBankAcNo ng-disabled=!fForm.$valid required ng-keydown=SipTopup.copyPasteHandler($event) ng-minlength=9 ng-pattern=SipTopup.formData.bankAcNo onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=highlight></span> <span class=bar></span><label>Verify Account Number</label><span class=error-input ng-show=SipTopup.tForm.verifyBankAcNo.$dirty&&SipTopup.tForm.verifyBankAcNo.$error.required ng-bind=SipTopup.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=!SipTopup.tForm.verifyBankAcNo.$error.required&&SipTopup.tForm.verifyBankAcNo.$error.minlength ng-bind=SipTopup.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!SipTopup.tForm.verifyBankAcNo.$error.required&&!SipTopup.tForm.verifyBankAcNo.$error.minlength&&SipTopup.tForm.verifyBankAcNo.$error.pattern ng-bind=SipTopup.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div></div></div><div ng-if=\"SipTopup.formData.sipPaymentOption===SipTopup.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM\"><div class=clearfix><div class=col-md-3><div class=selectfield ng-class=\"{error:SipTopup.tForm.bank.$dirty && SipTopup.tForm.bank.$invalid}\"><select name=bank ng-disabled=!SipTopup.bankList ng-model=SipTopup.formData.bankInfo ng-options=\"bank.bankName for bank in SipTopup.bankList\" ng-init=\"SipTopup.formData.bankInfo=SipTopup.formData.bankInfo?SipTopup.formData.bankInfo: null\" ng-change=SipTopup.changeBank() required><option value=\"\" selected>{{SipTopup.bankList&&!SipTopup.bankList.length ?\'No Bank Available\':\'Select OTM Bank\'}}</option></select><label ng-if=SipTopup.formData.bankInfo>Select Bank</label><span class=error-input ng-show=\"SipTopup.tForm.bank.$dirty && SipTopup.tForm.bank.$error.required\" ng-bind=SipTopup.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><div class=row><div class=col-md-7><table class=\"table borderless\" ng-if=\"SipTopup.formData.bankInfo && SipTopup.bankList.length\"><tr><td>OTM UMRN No:</td><td>{{SipTopup.formData.bankInfo.omUmrn}}</td></tr><tr><td>OTM Max Amount:</td><td><i class=rupee-small-icon></i>{{SipTopup.formData.bankInfo.maxAmount}} <span class=error-input ng-show=SipTopup.isOTMAmount ng-bind=SipTopup.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR></span></td></tr><tr><td>OTM Expiry Date:</td><td>{{SipTopup.formData.bankInfo.omExpiryDate}} <span class=error-input ng-show=SipTopup.isOTMDate ng-bind=SipTopup.VALIDATE_DATA.DATE_VALIDATION_ERROR></span></td></tr></table></div></div></div></div><div class=\"col-md-12 form-footer form-content\"><button type=button ng-click=SipTopup.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"sipTopupForm.$invalid || SipTopup.isminCapAmount || SipTopup.amountExceeded\" class=\"btn btn-primary-action\" ng-click=SipTopup.goToSummary(sipTopupForm)>Review</button></div></div></form></div></section></div>");
$templateCache.put("app/transactions/initiate/smart-swap/smartSwp.html","<div class=scheme-loader style=\"display: none\"><span class=loading></span></div><div class=\"main-section clearfix\" ng-hide=Transaction.formData.isSummaryViewEnabled><section class=initiate-transaction ng-init=Transaction.init()><p class=page-title>SMART SWAP</p><div class=\"content-area clearfix redeem\"><form autocomplete=off class=row name=Transaction.tForm ng-keypress=Transaction.handleEnter($event) novalidate><div class=\"col-sm-12 col-md-4\"><p class=col-head>Select Scheme for Withdrawal</p><div class=selectfield ng-class=\"{error:(Transaction.tForm.folio.$invalid && Transaction.tForm.folio.$dirty)}\"><select name=folio id=_first ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><div class=\"input-select input-normal\" ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" ng-class={error:Transaction.tForm.outScheme.$invalid}><input type=text name=outScheme id=outScheme ng-change=Transaction.filterOutSchemeList() ng-model=Transaction.formData.outSchemeName autocomplete=off ng-required=Transaction.isRequired> <span class=highlight></span> <span class=bar></span><label>Select Source Scheme</label><span class=error-input ng-show=Transaction.tForm.outScheme.$error.required ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span> <span class=error-input style=\"position:relative; top: 10px\" ng-if=\"Transaction.outSchemeList.length===0\">The fund / Scheme part of your portfolio are not applicable for SMART SWAP. Kindly <span ng-click=Transaction.openTermsAndCondition(); class=\"cursor-pointer text-primary\">Click here</span> for details</span><drop-down list-data=Transaction.outSchemeList display-key=schemeName hdfc-click=Transaction.outSchemeChanged(data) model=Transaction.formData.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{Transaction.formData.outSchemeName}}</p></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=value-snippet ng-if=Transaction.unitsDetails><div><p class=text-uppercase>Total Market Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.totalCurrentValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{Transaction.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.lockedValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{Transaction.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.freeValueUnits | number:3}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{Transaction.unitsDetails.freeValueAmount|unit}}</span></div><p class=text-primary>*as of last business day</p></div></div><div class=\"col-sm-12 col-md-4\" ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber || !Transaction.formData.outSchemeName}\"><p class=col-head>Select Withdrawal Options</p><div class=\"input-normal icon-input\" ng-class=\"{error:(Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$invalid),\n               \'has-data\':Transaction.formData.amount}\"><input type=number ignore-mouse-wheel name=amount ng-disabled=!Transaction.formData.folioNumber ng-model=Transaction.formData.amount ng-maxlength=12 limit-to=12 onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ondrop=\"return false\" ng-change=Transaction.checkValidations() required><!--            ng-change=\"Transaction.checkSwpStpValidations()\"--> <span class=highlight></span> <span class=bar></span><label>SMART SWAP Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$error.required\" ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=error-input>Minimum amount should be greater than &#8377; {{Transaction.outSchemeValidations.smartSwapMinAmount}}</span></div><div class=form-group ng-if=\"Transaction.formData.transferOption !== Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION\"><label id=divDisplayWords>{{Transaction.amountInWords}} (In Words)</label></div><div class=selectfield ng-class=\"{error:Transaction.tForm.frequency.$dirty && Transaction.tForm.frequency.$invalid}\"><label ng-if=Transaction.formData.frequency>Select Frequency</label><select name=frequency ng-disabled=\"(Transaction.validations.isEnabled == false)||(!Transaction.formData.folioNumber)\" ng-model=Transaction.formData.frequency ng-options=\"key for (key,value) in Transaction.frequencyList\" ng-init=\"Transaction.formData.frequency=Transaction.formData.frequency?Transaction.formData.frequency: null\" required><option value=\"\" selected>Select Frequency</option></select><span class=error-input ng-show=\"Transaction.tForm.frequency.$dirty && Transaction.tForm.frequency.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FREQUENCY_REQUIRED></span></div><div class=selectfield ng-class=\"{error:Transaction.tForm.percentage.$dirty && Transaction.tForm.percentage.$invalid}\"><label ng-if=Transaction.formData.percentage>Select Percentage(per annum)</label><select name=percentage ng-disabled=!Transaction.formData.folioNumber ng-model=Transaction.formData.percentage ng-options=\"percentage as percentage for percentage in Transaction.percentageList\" ng-init=\"Transaction.formData.percentage=Transaction.formData.percentage?Transaction.formData.percentage: null\" required><option value=\"\" selected>Select Percentage(per annum)</option></select><span class=error-input ng-show=\"Transaction.tForm.percentage.$dirty && Transaction.tForm.percentage.$error.required\" ng-bind=Transaction.VALIDATE_DATA.PERCENT_REQUIRED></span></div><div class=selectfield ng-if=!Transaction.isReseting ng-class=\"{\'anything-disabled\':!Transaction.formData.folioNumber}\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\" date-calendar data-viewmode={{Transaction.viewMode}} data-date-default=Transaction.formData.startDate data-min-date=Transaction.startMinDate data-max-date=Transaction.startMaxDate data-on-date-change=Transaction.changeStartDate id=startDate data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"SMART SWAP Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=Transaction.formData.startDate>SMART SWAP Start Date - DD-MMM-YYYY</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Transaction.tForm.startDate.$error.required ng-bind=Transaction.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber || !Transaction.formData.outSchemeName}\" class=\"col-sm-12 col-md-4\"><p class=col-head>Select Bank For Payout</p><div class=selectfield ng-class=\"{error:Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$invalid}\"><select name=bank ng-disabled=!Transaction.bankList ng-model=Transaction.formData.bankInfo ng-options=\"bank.bankName for bank in Transaction.bankList track by bank.payoutId\" ng-change=Transaction.changeBank() ng-init=\"Transaction.formData.bankInfo=Transaction.formData.bankInfo?Transaction.formData.bankInfo: null\" required><option value=\"\" selected>{{Transaction.bankList&&!Transaction.bankList.length ?\'No Bank Available for Redemption\':\'Select Bank for Withdrawal\'}}</option></select><label ng-if=Transaction.formData.bankInfo.bankName>Select Bank for Withdrawal</label><span class=error-input ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required\" ng-bind=Transaction.VALIDATE_DATA.BANK_REQUIRED></span></div><table class=\"table borderless\" ng-if=Transaction.formData.bankInfo&&Transaction.bankList.length><tr><td>Bank Name:</td><td>{{Transaction.formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{Transaction.formData.bankInfo.bankAcNo}}</td></tr><tr><td>IFSC:</td><td>{{Transaction.formData.bankInfo.ifscCode}}</td></tr><tr><td>Payout:</td><td>{{Transaction.formData.bankInfo.payoutDescription | uppercase}}</td></tr></table></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"form-footer col-md-12\"><button class=\"btn btn-secondary-action\" ng-disabled=!Transaction.formData.outSchemeCode ng-click=Transaction.saveForm()>Save</button> <button ng-disabled=\"!Transaction.tForm.$valid||Transaction.isInvalidForm || !Transaction.formData.startDate || (Transaction.selectedFolioObj && Transaction.selectedFolioObj.minorFlag && !Transaction.formData.bankInfo.minorBankFlag)  || (!Transaction.kycVerifiedFlag) || Transaction.formData.amount < Transaction.outSchemeValidations.smartSwapMinAmount || !Transaction.formData.outSchemeCode\" ng-click=Transaction.goToSummary() class=\"btn btn-primary-action\">Proceed to Transact</button></div></form></div></section></div><div ng-if=Transaction.formData.isSummaryViewEnabled><transaction-summary form-data=Transaction.summaryData is-summary-view-enabled=Transaction.formData.isSummaryViewEnabled transaction-type={{Transaction.transactionType}} show-terms=Transaction.showTerms></transaction-summary></div>");
$templateCache.put("app/transactions/initiate/stp/stp.html","<div class=\"main-section clearfix\" ng-hide=Transaction.formData.isSummaryViewEnabled><section class=initiate-transaction ng-init=Transaction.init()><p class=page-title>SYSTEMATIC TRANSFER PLAN (STP) <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement={{Main.tooltipClass}} data-bs-title=\"STP refers to Systematic Transfer Plan where in an investor invests a lump sum\namount in one scheme and regularly transfers (i.e. switches) a predefined amount into another scheme. Every month on a specified date an amount you choose is transferred from one mutual fund scheme to another of your choice.</br></br> Currently, Fixed Systematic Transfer Plan (FSTP) - Monthly Interval and Capital\nAppreciation Systematic Transfer Plan (CASTP) - Monthly Interval facility is available to you on 1st, 5th, 10th, 15th, 20th and 25th of a month and FSTP -\nQuarterly interval and CASTP - Quarterly Interval facility is available to you on\n1st, 5th, 10th 15th, 20th and the 25th of the first month of each quarter. You\nmay also opt for FSTP - Daily and FSTP Weekly (where the STP transfer is\neffective every Friday).\"></i></p><div class=\"content-area redeem\"><form autocomplete=off class=row name=Transaction.tForm ng-keypress=Transaction.handleEnter($event) novalidate><div class=top-wrap><label>Invest through</label><div class=form-group><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isDirect ng-click=\"Transaction.changeThroughDistributor(\'DIRECT\')\"> <span class=check></span> </span><span class=radio-label>Direct</span></div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isThroughDistributor ng-click=\"Transaction.changeThroughDistributor(\'ARN\')\"> <span class=check></span> </span><span class=radio-label>Distributor</span></div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isThroughRia ng-click=\"Transaction.changeThroughDistributor(\'RIA\')\"> <span class=check></span> </span><span class=radio-label>RIA</span></div></div><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughDistributor><div class=col-md-4><div class=input-normal ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\"><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=\"Transaction.searchDistributor();Transaction.showArnLabel=false\" maxlength=10 ng-pattern=/^[0-9]{4,10}$/ ng-required=!Transaction.formData.distributerName ng-focus=\"Transaction.showArnLabel=true\"> <span class=highlight></span> <span class=bar></span> <span class=arn ng-show=\"Transaction.showArnLabel || Transaction.formData.brokerCode\">ARN -</span><label>ARN</label><p ng-if=Transaction.formData.brokerName class=info-primary>Distributor Name: {{Transaction.formData.brokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.required) && (!Transaction.formData.distributerName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.pattern) && (!Transaction.formData.distributorName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.brokerCodeError !== \'\' && !Transaction.tForm.brokerCode.$invalid\" ng-bind=Transaction.brokerCodeError></span></div></div><span class=or-part>OR</span><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.distributerName.$dirty && Transaction.tForm.distributerName.$invalid}\"><input type=text name=distributerName id=distributerName ng-change=Transaction.searchDistributorByName() ng-model=Transaction.formData.distributerName autocomplete=off ng-required=!Transaction.formData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><label>Search Distributor</label><!--<p ng-if=\"Transaction.formData.distributorARN\" class=\"info-primary\">{{Transaction.formData.distributorARN}}</p>--><!--<span class=\"error-input\" ng-show=\"Transaction.tForm.distributerName.$dirty && Transaction.tForm.distributerName.$invalid && Transaction.tForm.distributerName.$error.required\"\n                      ng-bind=\"Transaction.VALIDATE_DATA.DISTRIBUTOR_REQUIRED\"></span>--><drop-down list-data=Transaction.distributorList display-key=name display-key-second=arnCode hdfc-click=Transaction.distributorListChanged(data) model=Transaction.formData.distributorARN for=distributerName></drop-down><!--<p ng-if=\"Transaction.formData.distributorARN\" class=\"info-primary\">{{Transaction.formData.distributorARN}}</p>--></div></div></div><div class=row ng-if=Transaction.formData.isThroughDistributor><div class=col-md-4><div class=input-normal ng-class={error:Transaction.tForm.subBrokerARN.$dirty&&Transaction.tForm.subBrokerARN.$invalid}><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=Transaction.formData.subBrokerARN ng-change=Transaction.changeSubBrokerArn(); ng-blur=Transaction.fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>Sub Broker ARN</label><p ng-if=Transaction.subBrokerName class=info-primary>Sub Broker Name: {{Transaction.subBrokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.subBrokerARN.$dirty && Transaction.tForm.subBrokerARN.$invalid && Transaction.tForm.subBrokerARN.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.subBrokerCodeError != \'\'&& !Transaction.tForm.subBrokerARN.$error.pattern\" ng-bind=Transaction.subBrokerCodeError></span></div></div><div class=col-md-4><div class=input-normal ng-class={error:Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=Transaction.formData.subBrokerCode autocomplete=off ng-disabled=\"!Transaction.formData.subBrokerARN || Transaction.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code</label><span class=error-input ng-show=Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$error.required ng-bind=Transaction.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div><!--<div class=\"col-md-4\">\n              <div class=\"selectfield\" ng-class=\"{error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}\">\n                <label ng-if=\"Transaction.formData.euin\">Select EUIN {{!Transaction.formData.brokerCode ? \"(Optional)\" : \"\" }}</label>\n                <select name=\"euin\" id=\"euin\"\n                        ng-model=\"Transaction.formData.euin\"\n                        ng-disabled=\"!Transaction.euinList.length\"\n                        ng-options=\"_euin as (_euin.euinName+\' - \'+_euin.euinCode) for _euin in Transaction.euinList track by _euin.euinCode\"\n                        ng-required=\"Transaction.formData.brokerCode\" autocomplete=\"off\">\n                  <option value=\"\" selected >Select EUIN {{!Transaction.formData.brokerCode ? \"(Optional)\" : \"\"\n                      }}</option>\n                </select>\n                <span class=\"error-input\" ng-show=\"Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required\"\n                      ng-bind=\"Transaction.VALIDATE_DATA.EUIN_REQUIRED\"></span>\n              </div>\n            </div>--></div><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughDistributor><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class={error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}><input type=text name=euin id=euin ng-model=Transaction.euinData.euinNameCode ng-disabled=\"!Transaction.euinMasterList.length || Transaction.isArnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\" ng-change=Transaction.filterEuinList() ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributerName) && !Transaction.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Select Euin</label><span class=error-input ng-show=\"Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required || !Transaction.isSelectedEuin\" ng-bind=Transaction.VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=Transaction.euinList display-key=euinName display-key-second=euinCode hdfc-click=Transaction.selectEuin(data) model=Transaction.formData.euin for=euin></list-drop-down></div></div><div ng-show=Transaction.euinBoxMessage><span class=or-part>OR</span><div class=col-md-7><div class=checkbox><input ng-model=Transaction.isCheckedTandC type=checkbox ng-change=Transaction.isCheckedEuin() ng-disabled=\"Transaction.isArnSuccess || Transaction.isSubarnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\" ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributerName) && !Transaction.formData.euin\"> <i class=icon-checkbox></i><ng-bind-html class=checkbox-text ng-bind-html=Transaction.euinBoxMessage.content></ng-bind-html></div></div></div></div><!--RIA section--><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughRia><div class=col-md-4><div class=input-normal ng-class=\"{error:(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid)||(Transaction.brokerCodeError != \'\')}\"><input type=text name=riaCode id=riaCode ng-model=Transaction.formData.brokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=\"Transaction.searchDistributor(); Transaction.showRiaLabel=false\" ng-required=!Transaction.formData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span><label>RIA Code</label><!--<p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name: {{Transaction.formData.brokerName}}</p>--> <span class=error-input ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.required)\" ng-bind=Transaction.VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"Transaction.riaCodeError !== \'\' && !Transaction.tForm.riaCode.$invalid\" ng-bind=Transaction.riaCodeError></span></div></div></div><div ng-show=Transaction.riaMessage><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughRia><div class=col-md-12><div class=checkbox><input ng-model=Transaction.isCheckedTandC type=checkbox ng-change=Transaction.isCheckedEuin() ng-disabled=\"!Transaction.formData.brokerCode || Transaction.riaCodeError !== \'\'\" ng-required=Transaction.formData.brokerCode> <i class=icon-checkbox></i><ng-bind-html class=checkbox-text ng-bind-html=Transaction.riaMessage.content></ng-bind-html></div></div></div></div><!--RIA section ends here--><label>Select STP Type</label><div class=form-group><div class=radio-block><span class=radio><input type=radio name=stptype ng-model=Transaction.specificProperties.stpType ng-click=\"Transaction.helper.changeStpType(\'F\');Transaction.fill_end_date = null;\" value=normalStp> <span class=check></span> </span><span class=radio-label>Normal STP</span></div><!--<div class=\"radio-block\">\n              <span class=\"radio\">\n                <input type=\"radio\" name=\'stptype\' ng-model=\"Transaction.specificProperties.stpType\"\n                       ng-click=\"Transaction.helper.changeStpType(\'Q\')\"\n                       value=\"swingStp\"/>\n                <span class=\"check\"></span>\n              </span>\n              <span class=\"radio-label\">Swing STP</span>\n            </div>--><div class=radio-block><span class=radio><input type=radio name=stptype ng-model=Transaction.specificProperties.stpType ng-click=\"Transaction.helper.changeStpType(\'T\');Transaction.fill_end_date = null;Transaction.transferOptionChanged(Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT);\" value=flexStp> <span class=check></span> </span><span class=radio-label>Flex STP </span><i class=\"info-icon base-tooltip\" tooltip data-bs-toggle=tooltip data-bs-placement={{Main.tooltipClass}} data-bs-title=\"HDFC Flex Systematic Transfer Plan is a facility wherein unit holder(s) of\ndesignated open-ended Scheme(s) of HDFC Mutual Fund can opt to transfer\nvariable amount(s) linked to value of investments under HDFC Flex Systematic\nTransfer Plan on the date of transfer at pre-determined intervals from\ndesignated open-ended Scheme(s) of HDFC Fund referred to as Transferee\nScheme.\"></i></div></div></div><div id=normal-stp ng-if=\"Transaction.specificProperties.stpType === \'normalStp\'\" class=clearfix><div class=\"col-sm-12 col-md-4\"><p class=col-head>Select Scheme for Transfer</p><div class=selectfield ng-class=\"{error:Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid}\"><select name=folio ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><!--            <div class=\"selectfield\"--><!--                 ng-class=\"{error:Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$invalid, \'anything-disabled\': !Transaction.formData.folioNumber}\">--><!--              <label ng-if=\"Transaction.formData.outSchemeCode\">Select Source Scheme</label>--><!--              <select name=\"outScheme\"--><!--                      ng-change=\"Transaction.outSchemeChanged()\"--><!--                      ng-model=\"Transaction.formData.outSchemeCode\"--><!--                      ng-init=\"Transaction.formData.outSchemeCode=Transaction.formData.outSchemeCode?Transaction.formData.outSchemeCode: null\"--><!--                      ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Transaction.outSchemeList\"--><!--                      required>--><!--                <option value=\"\" selected>Select Source Scheme</option>--><!--              </select>--><!--              <span class=\"error-input\"--><!--                    ng-show=\"Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$error.required\"--><!--                    ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--            </div>--><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$invalid, \'anything-disabled\': !Transaction.formData.folioNumber}\"><input type=text name=outScheme id=outScheme ng-change=Transaction.filterOutSchemeList() ng-model=Transaction.formData.outSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Source Scheme</label><span class=error-input ng-show=\"Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.outSchemeList display-key=schemeName hdfc-click=Transaction.outSchemeChanged(data) model=Transaction.formData.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{Transaction.formData.outSchemeName}}</p></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=value-snippet ng-if=Transaction.unitsDetails><div><p class=text-uppercase>Total Market Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.totalCurrentValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{Transaction.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.lockedValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{Transaction.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.freeValueUnits | number:3}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{Transaction.unitsDetails.freeValueAmount|unit}}</span></div><p class=text-primary>*as of last business day</p><p class=\"error-message text-danger\">{{Transaction.unitsDetails.message}}</p></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber || Transaction.unitsDetails.message !== \'\' }\" class=\"col-sm-12 col-md-4 brdrhgt\"><p class=col-head>Scheme to Transfer in</p><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid}\"><input type=text name=inScheme id=inScheme ng-change=Transaction.filterInSchemeList() ng-model=Transaction.formData.inSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><span class=error-input ng-show=\"Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.TARGET_SCHEME_REQUIRED></span><drop-down list-data=Transaction.inSchemeList display-key=scheme hdfc-click=Transaction.inSchemeChanged(data) model=Transaction.formData.inSchemeCode for=inScheme></drop-down><p class=info-primary>{{Transaction.formData.inSchemeName}}</p></div><div class=\"form-group text-center\"><p>OR</p><br><p><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=Transaction.schemeListModal()>Select from list</span></p></div><div class=form-group ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\" ng-if=\"Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=form-label><strong>Select Income Distribution cum Capital Withdrawal (IDCW) Option</strong></label><div class=radio-block ng-repeat=\"_option in Transaction.devidendOptions\" style=\"padding-bottom: 10px\" ng-class=\"{\'anything-disabled\':((_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && (Transaction.inSchemeValidations.isGrowth === false||Transaction.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)\n                        || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT   && (Transaction.inSchemeValidations.isGrowth === false||Transaction.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && Transaction.inSchemeValidations.dividendPayoutApplicable === false))}\"><span class=radio><input type=radio id=dividendOption{{$index}} ng-value=_option ng-disabled=\"(_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && (Transaction.inSchemeValidations.isGrowth === false||Transaction.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)\n                        || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT   && (Transaction.inSchemeValidations.isGrowth === false||Transaction.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && Transaction.inSchemeValidations.dividendPayoutApplicable === false)\" name=dividendOption ng-model=Transaction.formData.dividendOption> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div><div class=\"row form-group\" ng-if=\"Transaction.isSchemeTypeELSS && Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div><label class=form-label><strong>Select STP Type</strong></label><div class=form-group ng-class=\"{\'radio-disabled\': (Transaction.validations.isEnabled == \'N\')||(!Transaction.unitsDetails.freeValueUnits)}\" ng-if=!Transaction.isReseting><div class=radio-block><span class=radio><input type=radio id=fixedAmount name=transferOption ng-model=Transaction.formData.transferOption ng-disabled=\"(Transaction.validations.isEnabled == \'N\')||(Transaction.unitsDetails.freeValueUnits == 0)\" ng-value=Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT ng-click=Transaction.transferOptionChanged(Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT);> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT]}}</span></div><div class=radio-block ng-hide=\"Transaction.formData.inSchemeType == \'NFO\'\" ng-class=\"{\'anything-disabled\': (Transaction.validations.isEnabled == \'N\')||(Transaction.unitsDetails.freeValueUnits == 0) || (!Transaction.isSourceSchemeGrowth) || Transaction.formData.inSchemeType == \'NFO\'}\"><span class=radio><input type=radio id=capitalAppreciation name=transferOption ng-model=Transaction.formData.transferOption ng-disabled=\"(Transaction.validations.isEnabled == \'N\')||(Transaction.unitsDetails.freeValueUnits == 0) || (!Transaction.isSourceSchemeGrowth) || Transaction.formData.inSchemeType == \'NFO\'\" ng-value=Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION ng-click=Transaction.transferOptionChanged(Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION);> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION]}}</span></div></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber || Transaction.unitsDetails.message !== \'\'}\" class=\"col-sm-12 col-md-4\"><p class=col-head>Systematic Transfer Option</p><div class=selectfield ng-class=\"{error:Transaction.tForm.frequency.$dirty && Transaction.tForm.frequency.$invalid}\"><label ng-if=Transaction.formData.frequency>Select Frequency</label><select name=frequency ng-disabled=\"(Transaction.validations.isEnabled == \'N\')||(!Transaction.unitsDetails.freeValueUnits)\" ng-change=Transaction.changeFrequency() ng-model=Transaction.formData.frequency ng-options=\"_frequency.key as _frequency.value for _frequency in Transaction.frequencyList\" ng-init=\"Transaction.formData.frequency=Transaction.formData.frequency?Transaction.formData.frequency: null\" required><option value=\"\" selected>Select Frequency</option></select><span class=error-input ng-show=\"Transaction.tForm.frequency.$dirty && Transaction.tForm.frequency.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FREQUENCY_REQUIRED></span></div><div class=form-group ng-if=Transaction.daysList><div class=selectfield ng-class=\"{error:Transaction.tForm.day.$dirty && Transaction.tForm.day.$invalid}\"><label ng-if=Transaction.formData.day>Select Day</label><select name=day ng-model=Transaction.formData.day ng-disabled=\"(Transaction.validations.isEnabled == \'N\')||(!Transaction.unitsDetails.freeValueUnits)\" ng-change=Transaction.changeDay() ng-options=\"day.value as day.name for day in Transaction.daysList\" ng-init=\"Transaction.formData.day=Transaction.formData.day?Transaction.formData.day: null\" required><option value=\"\" selected>Select Day</option></select><span class=error-input ng-show=\"Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\" ng-bind=Transaction.VALIDATE_DATA.DAY_REQUIRED></span></div></div><!--Normal STP--><div ng-if=\"!Transaction.isReseting && Transaction.showCalender\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode={{Transaction.viewMode}} data-enabled-dates=Transaction.enabledStartDates data-date-default=Transaction.formData.startDate data-min-date=Transaction.minStartDate data-max-date=Transaction.maxStartDate data-on-date-change=Transaction.changeStartDate id=startDate data-enable=true style=\"position: relative\" ng-class={error:Transaction.tForm.startDate.$invalid}><input type=text name=startDate placeholder=DD-MMM-YYYY readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=Transaction.formData.startDate>Start Date</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Transaction.tForm.startDate.$error.required ng-bind=Transaction.VALIDATE_DATA.START_DATE_REQUIRED></span></div><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode=days data-enabled-dates=Transaction.enabledEndDates data-view-date=Transaction.enabledEndDateView data-min-date=Transaction.enabledEndDates[0] data-max-date=Transaction.maxEndDate data-date-default=Transaction.formData.endDate data-on-date-change=Transaction.changeEndDate id=endDate data-enable=true focus-on=amount-field ng-class=\"{error:Transaction.tForm.endDate.$invalid || Transaction.formData.noOfInstallments && (Transaction.formData.noOfInstallments < Transaction.validations.minInstallments)}\"><input type=text name=endDate required placeholder=DD-MMM-YYYY readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span><label ng-if=Transaction.formData.endDate>End Date</label><span class=error-input ng-show=Transaction.tForm.endDate.$error.required ng-bind=Transaction.VALIDATE_DATA.END_DATE_REQUIRED></span> <span ng-if=\"Transaction.formData.noOfInstallments && (Transaction.formData.noOfInstallments < Transaction.validations.minInstallments)\" class=error-input>Minimum number of installments should be {{Transaction.validations.minInstallments}}</span></div><span style=\"display: block; margin-top: 10px; margin-bottom: 10px\" class=alert-warning ng-if=Transaction.fill_end_date>{{Transaction.fill_end_date}}</span> <i ng-if=\"Transaction.validations.minAmount > 500 && Transaction.fill_end_date\" class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=top data-bs-title=\"If you are going to put your installment amount in between 500 to 999, please increase the no. of installment ( In this case, minimum no. of installment has to be 12).\"></i></div><!--<div class=\"text-center form-group\">OR</div>--><div class=input-normal ng-if=\"!Transaction.showCalender && Transaction.formData.frequency == \'DZ\'\"><input name=installments type=number ignore-mouse-wheel ng-model=Transaction.formData.noOfInstallments ng-change=Transaction.onChangeSTPInstallment() required><label>No. of Installments</label><span ng-if=\"Transaction.formData.noOfInstallments && (Transaction.formData.noOfInstallments < Transaction.inSchemeValidations.dailyMinInstallmentNumber)\" class=error-input>Minimum number of installments should be {{Transaction.inSchemeValidations.dailyMinInstallmentNumber}}</span> <span ng-if=\"Transaction.formData.noOfInstallments === 0\" class=error-input>Minimum number of installments should be {{Transaction.inSchemeValidations.dailyMinInstallmentNumber}}</span> <span ng-if=\"(Transaction.inSchemeValidations.dailyMaxInstallmentNumber > 0) && (Transaction.formData.noOfInstallments > Transaction.inSchemeValidations.dailyMaxInstallmentNumber)\" class=error-input>No of Installment should not be greater than {{Transaction.inSchemeValidations.dailyMaxInstallmentNumber}}</span></div><div class=input-normal ng-if=\"!Transaction.showCalender && Transaction.formData.frequency == \'OW\'\"><input name=installments type=number ignore-mouse-wheel ng-model=Transaction.formData.noOfInstallments ng-change=Transaction.onChangeSTPInstallment() required><label>No. of Installments</label><span ng-if=\"Transaction.formData.noOfInstallments && (Transaction.formData.noOfInstallments < Transaction.inSchemeValidations.weeklyMinInstallmentNumber)\" class=error-input>Minimum number of installments should be {{Transaction.inSchemeValidations.weeklyMinInstallmentNumber}}</span> <span ng-if=\"Transaction.formData.noOfInstallments === 0\" class=error-input>Minimum number of installments should be {{Transaction.inSchemeValidations.weeklyMinInstallmentNumber}}</span> <span ng-if=\"(Transaction.inSchemeValidations.weeklyMaxInstallmentNumber > 0) && (Transaction.formData.noOfInstallments > Transaction.inSchemeValidations.weeklyMaxInstallmentNumber)\" class=error-input>No of Installment should not be greater than {{Transaction.inSchemeValidations.weeklyMaxInstallmentNumber}}</span> <span style=\"display: block; margin-top: 10px; margin-bottom: 10px\" class=alert-warning ng-if=Transaction.fill_end_date>{{Transaction.fill_end_date}}</span> <i ng-if=\"Transaction.validations.minAmount > 500 && Transaction.fill_end_date\" class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=top data-bs-title=\"If you are going to put your installment amount in between 500 to 999, please increase the no. of installment ( In this case, minimum no. of installment has to be 12).\"></i></div><div class=\"input-normal icon-input\" ng-if=\"Transaction.formData.transferOption !== Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION && !Transaction.isReseting\" ng-class=\"{error:(Transaction.tForm.amount.$invalid && Transaction.tForm.amount.$dirty),\'has-data\':Transaction.formData.amount}\"><input type=number ignore-mouse-wheel name=amount class=amount-field ng-disabled=\"!Transaction.unitsDetails||!Transaction.unitsDetails.freeValueAmount||(Transaction.unitsDetails.freeValueAmount<Transaction.validations.minAmount)\" ng-model=Transaction.formData.amount ng-change=\"Transaction.amountChanged(\'amount-field\')\" onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-blur=Transaction.blured() required> <span class=highlight></span> <span class=bar></span><label>STP Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$error.required\" ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=error-input>Minimum amount should be &#x20B9; {{Transaction.validations.minAmount|unit}}</span> <span ng-if=\"Transaction.formData.amount && Transaction.isMax && !Transaction.isMin\" class=error-input>Maximum amount should be &#x20B9; {{Transaction.validations.maxAmount|unit}}</span> <span ng-if=\"Transaction.formData.amount && !Transaction.isMax && !Transaction.isMin && (Transaction.validations.amountMultiples&&!Transaction.isMultiples)\" class=error-input>Please Provide In multiples of &#x20B9; {{Transaction.validations.amountMultiples|unit}}</span></div><div class=form-group ng-if=\"Transaction.formData.transferOption !== Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION\"><label id=divDisplayWords>{{Transaction.amountInWords}} (In Words)</label></div></div></div><div id=flex-stp ng-if=\"Transaction.specificProperties.stpType === \'flexStp\'\" class=clearfix><div class=\"col-sm-12 col-md-4\"><p class=col-head>Select Scheme for Transfer</p><div class=selectfield ng-class=\"{error:Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid}\"><select name=folio ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><!--            <div class=\"selectfield\"--><!--                 ng-class=\"{error:Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$invalid, \'anything-disabled\': !Transaction.formData.folioNumber}\">--><!--              <label ng-if=\"Transaction.formData.outSchemeCode\">Select Source Scheme</label>--><!--              <select name=\"outScheme\"--><!--                      ng-change=\"Transaction.outSchemeChanged()\"--><!--                      ng-model=\"Transaction.formData.outSchemeCode\"--><!--                      ng-init=\"Transaction.formData.outSchemeCode=Transaction.formData.outSchemeCode?Transaction.formData.outSchemeCode: null\"--><!--                      ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Transaction.outSchemeList\"--><!--                      required>--><!--                <option value=\"\" selected>Select Source Scheme</option>--><!--              </select>--><!--              <span class=\"error-input\"--><!--                    ng-show=\"Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$error.required\"--><!--                    ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--            </div>--><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$invalid, \'anything-disabled\': !Transaction.formData.folioNumber}\"><input type=text name=outScheme id=outScheme ng-change=Transaction.filterOutSchemeList() ng-model=Transaction.formData.outSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Source Scheme</label><span class=error-input ng-show=\"Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.outSchemeList display-key=schemeName hdfc-click=Transaction.outSchemeChanged(data) model=Transaction.formData.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{Transaction.formData.outSchemeName}}</p></div><div class=value-snippet ng-if=Transaction.unitsDetails><div><p class=text-uppercase>Total Market Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.totalCurrentValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{Transaction.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.lockedValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{Transaction.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.freeValueUnits | number:3}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{Transaction.unitsDetails.freeValueAmount|unit}}</span></div><p class=text-primary>*as of last business day</p><p class=\"error-message text-danger\">{{Transaction.unitsDetails.message}}</p></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber || Transaction.unitsDetails.message !== \'\' }\" class=\"col-sm-12 col-md-4 brdrhgt\"><p class=col-head>Scheme to Transfer in</p><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid}\"><input type=text name=inScheme id=inScheme ng-change=Transaction.filterInSchemeList() ng-model=Transaction.formData.inSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><span class=error-input ng-show=\"Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.TARGET_SCHEME_REQUIRED></span><drop-down list-data=Transaction.inSchemeList display-key=scheme hdfc-click=Transaction.inSchemeChanged(data) model=Transaction.formData.inSchemeCode for=inScheme></drop-down><p class=info-primary>{{Transaction.formData.inSchemeName}}</p></div><div class=\"form-group text-center\"><p>OR</p><br><p><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=Transaction.schemeListModal()>Select from list</span></p></div><div class=\"row form-group\" ng-if=\"Transaction.isSchemeTypeELSS && Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div><div class=selectfield ng-class=\"{error:Transaction.tForm.frequency.$dirty && Transaction.tForm.frequency.$invalid}\"><label ng-if=Transaction.formData.frequency>Select Frequency of Flex STP</label><select name=frequency ng-disabled=\"(Transaction.validations.isEnabled == \'N\')||(!Transaction.unitsDetails.freeValueUnits)\" ng-change=Transaction.changeFrequency() ng-model=Transaction.formData.frequency ng-options=\"_frequency.key as _frequency.value for _frequency in Transaction.frequencyList\" ng-init=\"Transaction.formData.frequency=Transaction.formData.frequency?Transaction.formData.frequency: null\" required><option value=\"\" selected>Select Frequency of Flex STP</option></select><span class=error-input ng-show=\"Transaction.tForm.frequency.$dirty && Transaction.tForm.frequency.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FREQUENCY_REQUIRED></span></div><div class=form-group ng-if=\"Transaction.daysList && Transaction.specificProperties.showDateOfTransfer\"><div class=selectfield ng-class=\"{error:Transaction.tForm.day.$dirty && Transaction.tForm.day.$invalid}\"><label ng-if=Transaction.formData.day>Date of Transfer</label><select name=day ng-model=Transaction.formData.day ng-disabled=\"(Transaction.validations.isEnabled == \'N\')||(!Transaction.unitsDetails.freeValueUnits)\" ng-change=Transaction.changeDay() ng-options=\"day.value as day.name for day in Transaction.daysList\" ng-init=\"Transaction.formData.day=Transaction.formData.day?Transaction.formData.day: null\" required><option value=\"\" selected>Date of Transfer</option></select><span class=error-input ng-show=\"Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\" ng-bind=Transaction.VALIDATE_DATA.DAY_REQUIRED></span></div></div><div class=form-group ng-if=\"Transaction.daysList && Transaction.specificProperties.showDayOfTransfer\"><div class=selectfield ng-class={error:Transaction.tForm.day.$invalid}><label ng-if=Transaction.formData.day>Day of Transfer</label><select name=day ng-model=Transaction.formData.day ng-disabled=\"(Transaction.validations.isEnabled == \'N\')||(!Transaction.unitsDetails.freeValueUnits)\" ng-change=Transaction.changeDay() ng-options=\"day.value as day.name for day in Transaction.weekList\" ng-init=\"Transaction.formData.day=Transaction.formData.day?Transaction.formData.day: null\" ng-required=Transaction.isRequired><option value=\"\" selected>Day of Transfer</option></select><span class=error-input ng-show=Transaction.tForm.day.$error.required ng-bind=Transaction.VALIDATE_DATA.DAY_REQUIRED></span></div></div><!--Flex STP--><div ng-if=\"!Transaction.isReseting && Transaction.showCalender\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode={{Transaction.viewMode}} data-enabled-dates=Transaction.enabledStartDates data-date-default=Transaction.formData.startDate data-on-date-change=Transaction.changeStartDate data-min-date=Transaction.minStartDate data-max-date=Transaction.maxStartDate id=startDate11 data-enable=true ng-class={error:Transaction.tForm.startDate.$invalid}><input type=text name=startDate placeholder=DD-MMM-YYYY readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=Transaction.formData.startDate>Start Date</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Transaction.tForm.startDate.$error.required ng-bind=Transaction.VALIDATE_DATA.START_DATE_REQUIRED></span></div><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-viewmode=days data-enabled-dates=Transaction.enabledEndDates data-view-date=Transaction.enabledEndDateView data-min-date=Transaction.enabledEndDates[0] data-date-default=Transaction.formData.endDate data-on-date-change=Transaction.changeEndDate id=endDate-flex data-enable=true focus-on=amount-field ng-class=\"{error:Transaction.tForm.endDate.$invalid || Transaction.formData.noOfInstallments && (Transaction.formData.noOfInstallments < Transaction.validations.minInstallments)}\"><input type=text name=endDate placeholder=DD-MMM-YYYY readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=Transaction.formData.endDate>End Date</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Transaction.tForm.endDate.$error.required ng-bind=Transaction.VALIDATE_DATA.END_DATE_REQUIRED></span><!--<span class=\"error-input\" ng-if=\"!Transaction.formData.endDate\">{{Transaction.fill_end_date}}</span>--> <span ng-if=\"Transaction.formData.noOfInstallments && (Transaction.formData.noOfInstallments < Transaction.validations.minInstallments)\" class=error-input>Minimum number of installments should be {{Transaction.validations.minInstallments}}</span> <span style=\"display: block; margin-top: 10px; margin-bottom: 10px\" class=alert-warning ng-if=Transaction.fill_end_date>{{Transaction.fill_end_date}}</span></div></div><div ng-if=\"!Transaction.showCalender && Transaction.formData.frequency\"><!--<div ng-if=\"!Transaction.specificProperties.showInstallment\" class=\"text-center form-group\">OR</div>--><div class=input-normal><input name=installments type=number ignore-mouse-wheel ng-model=Transaction.formData.noOfInstallments ng-change=Transaction.onChangeSTPInstallment() required><label>No. of Installments</label><span ng-if=\"Transaction.formData.noOfInstallments && (Transaction.formData.noOfInstallments < Transaction.validations.minInstallments)\" class=error-input>Minimum number of installments should be {{Transaction.validations.minInstallments}}</span> <span ng-if=\"Transaction.formData.noOfInstallments === 0\" class=error-input>Minimum number of installments should be {{Transaction.validations.minInstallments}}</span> <span ng-if=\"(Transaction.inSchemeValidations.dailyMaxInstallmentNumber > 0) && (Transaction.formData.noOfInstallments > Transaction.inSchemeValidations.dailyMaxInstallmentNumber)\" class=error-input>No of Installment should not be greater than {{Transaction.inSchemeValidations.dailyMaxInstallmentNumber}}</span></div></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber || Transaction.unitsDetails.message !== \'\' }\" class=\"col-sm-12 col-md-4\"><p class=col-head>Systematic Transfer Amount</p><div class=\"input-normal icon-input\" ng-if=\"Transaction.formData.transferOption !== Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION && !Transaction.isReseting\" ng-class=\"{error:(Transaction.tForm.amount.$dirty&&Transaction.tForm.amount.$invalid),\'has-data\':Transaction.formData.amount}\"><input type=number ignore-mouse-wheel name=amount class=amount-field ng-disabled=\"!Transaction.unitsDetails||!Transaction.unitsDetails.freeValueAmount||(Transaction.unitsDetails.freeValueAmount<Transaction.validations.minAmount)\" ng-model=Transaction.formData.amount ng-change=\"Transaction.amountChanged(\'amount-field\')\" onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-blur=Transaction.blured() required> <span class=highlight></span> <span class=bar></span><label>Amount of Transfer per Installment</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$error.required\" ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=error-input>Minimum amount should be &#x20B9; {{Transaction.validations.minAmount|unit}}</span> <span ng-if=\"Transaction.formData.amount && Transaction.isMax\" class=error-input>Maximum amount should be &#x20B9; {{Transaction.validations.maxAmount|unit}}</span> <span ng-if=\"Transaction.formData.amount && !Transaction.isMax && !Transaction.isMin && (Transaction.validations.amountMultiples&&!Transaction.isMultiples)\" class=error-input>Please Provide In multiples of &#x20B9; {{Transaction.validations.amountMultiples|unit}}</span></div><div class=form-group ng-if=\"Transaction.formData.transferOption !== Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION\"><label id=divDisplayWords>{{Transaction.amountInWords}}(In Words)</label></div></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"form-footer col-md-12\"><button class=\"btn btn-secondary-action\" ng-disabled=\"!Transaction.formData.inSchemeName || !Transaction.formData.outSchemeCode\" ng-click=Transaction.saveForm()>Save</button> <button ng-if=\"Transaction.formData.frequency==\'DZ\'\" ng-disabled=\"!Transaction.tForm.$valid||Transaction.isInvalidForm || !Transaction.formData.inSchemeCode ||\n                  !Transaction.formData.startDate || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) ||\n                  (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) ||\n                  ((Transaction.formData.noOfInstallments) && (Transaction.formData.noOfInstallments > Transaction.inSchemeValidations.dailyMaxInstallmentNumber))  || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || Transaction.formData.noOfInstallments === 0 || Transaction.formData.noOfInstallments && (Transaction.formData.noOfInstallments < Transaction.validations.minInstallments) || !Transaction.formData.outSchemeCode\" ng-click=Transaction.goToSummary() class=\"btn btn-primary-action\">Proceed to Transact</button> <button ng-if=\"Transaction.formData.frequency==\'OW\'\" ng-disabled=\"!Transaction.tForm.$valid||Transaction.isInvalidForm || !Transaction.formData.inSchemeCode ||\n                  !Transaction.formData.startDate || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) ||\n                  (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) ||\n                  ((Transaction.formData.noOfInstallments) && (Transaction.formData.noOfInstallments > Transaction.inSchemeValidations.weeklyMaxInstallmentNumber))  || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || Transaction.formData.noOfInstallments === 0 || Transaction.formData.noOfInstallments && (Transaction.formData.noOfInstallments < Transaction.validations.minInstallments)\" ng-click=Transaction.goToSummary() class=\"btn btn-primary-action\">Proceed to Transact</button> <button ng-if=\"Transaction.formData.frequency!=\'DZ\' && Transaction.formData.frequency!=\'OW\'\" ng-disabled=\"!Transaction.tForm.$valid||Transaction.isInvalidForm || !Transaction.formData.inSchemeCode || !Transaction.formData.startDate || !Transaction.formData.endDate || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || Transaction.formData.noOfInstallments === 0 || Transaction.formData.noOfInstallments && (Transaction.formData.noOfInstallments < Transaction.validations.minInstallments) || !Transaction.formData.outSchemeCode\" ng-click=Transaction.goToSummary() class=\"btn btn-primary-action\">Proceed to Transact</button></div></form></div></section></div><!--TODO working for HMF-7667 --><div ng-if=Transaction.formData.isSummaryViewEnabled><transaction-summary form-data=Transaction.summaryData is-summary-view-enabled=Transaction.formData.isSummaryViewEnabled transaction-type={{Transaction.transactionType}} transaction-sub-type={{Transaction.specificProperties.stpType}} notes=Transaction.notesReview.content show-terms=Transaction.showTerms show-terms-flex=Transaction.showTermsFlex></transaction-summary></div>");
$templateCache.put("app/transactions/initiate/switch/switch.html","<div class=\"main-section clearfix\" ng-hide=Transaction.formData.isSummaryViewEnabled><section class=initiate-transaction ng-init=Transaction.init()><p class=page-title>SWITCH</p><div class=\"content-area redeem\"><form autocomplete=off class=row name=Transaction.tForm ng-keypress=Transaction.handleEnter($event) novalidate><div class=top-wrap><label>Invest through</label><div class=form-group><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isDirect ng-click=\"Transaction.changeThroughDistributor(\'DIRECT\')\"> <span class=check></span> </span><span class=radio-label>Direct</span></div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isThroughDistributor ng-click=\"Transaction.changeThroughDistributor(\'ARN\')\"> <span class=check></span> </span><span class=radio-label>Distributor</span></div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=Transaction.formData.isThroughRia ng-click=\"Transaction.changeThroughDistributor(\'RIA\')\"> <span class=check></span> </span><span class=radio-label>RIA</span></div></div><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughDistributor><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\"><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=\"Transaction.searchDistributor();Transaction.showArnLabel=false;\" maxlength=10 ng-pattern=/^[0-9]{4,10}$/ ng-required=!Transaction.formData.distributerName ng-focus=\"Transaction.showArnLabel=true\"> <span class=highlight></span> <span class=bar></span> <span class=arn ng-show=\"Transaction.showArnLabel || Transaction.formData.brokerCode\">ARN -</span><label>ARN</label><p ng-if=Transaction.formData.brokerName class=info-primary>Distributor Name: {{Transaction.formData.brokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.required) && (!Transaction.formData.distributerName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.pattern) && (!Transaction.formData.distributorName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.brokerCodeError !== \'\' && !Transaction.tForm.brokerCode.$invalid\" ng-bind=Transaction.brokerCodeError></span></div></div><span class=\"col-sm-12 col-md-1 or-part\">OR</span><div class=\"col-sm-12 col-md-4\"><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.distributerName.$dirty && Transaction.tForm.distributerName.$invalid}\"><input type=text name=distributerName id=distributerName ng-change=Transaction.searchDistributorByName() ng-model=Transaction.formData.distributerName autocomplete=off ng-required=!Transaction.formData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><label>Search Distributor</label><drop-down list-data=Transaction.distributorList display-key=name display-key-second=arnCode hdfc-click=Transaction.distributorListChanged(data) model=Transaction.formData.distributorARN for=distributerName></drop-down></div></div></div><div class=row ng-if=Transaction.formData.isThroughDistributor><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class={error:Transaction.tForm.subBrokerARN.$dirty&&Transaction.tForm.subBrokerARN.$invalid}><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=Transaction.formData.subBrokerARN ng-change=Transaction.changeSubBrokerArn(); ng-blur=Transaction.fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>Sub Broker ARN</label><p ng-if=Transaction.subBrokerName class=info-primary>Sub Broker Name: {{Transaction.subBrokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.subBrokerARN.$dirty && Transaction.tForm.subBrokerARN.$invalid && Transaction.tForm.subBrokerARN.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.subBrokerCodeError != \'\'&& !Transaction.tForm.subBrokerARN.$error.pattern\" ng-bind=Transaction.subBrokerCodeError></span></div></div><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class={error:Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=Transaction.formData.subBrokerCode autocomplete=off ng-disabled=\"!Transaction.formData.subBrokerARN || Transaction.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code</label><span class=error-input ng-show=Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$error.required ng-bind=Transaction.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></div><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughDistributor><div class=\"col-sm-12 col-md-4\"><div class=\"input-select input-normal selectfield\" ng-class={error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}><input type=text name=euin id=euin ng-model=Transaction.euinData.euinNameCode ng-disabled=\"!Transaction.euinMasterList.length || Transaction.isArnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\" ng-change=\"Transaction.filterEuinList() || Transaction.isSelectEuin()\" ng-init=\"Transaction.formData.euin=Transaction.formData.euin?Transaction.formData.euin: null\" ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributerName) && !Transaction.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Select Euin</label><span class=error-input ng-show=\"Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required || !Transaction.isSelectedEuin\" ng-bind=Transaction.VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=Transaction.euinList display-key=euinName display-key-second=euinCode hdfc-click=Transaction.selectEuin(data) model=Transaction.formData.euin for=euin></list-drop-down></div></div><div ng-show=Transaction.euinBoxMessage><span class=or-part>OR</span><div class=\"col-sm-12 col-md-7\"><div class=checkbox><input ng-model=Transaction.isCheckedTandC type=checkbox ng-change=Transaction.isCheckedEuin() ng-disabled=\"Transaction.isArnSuccess || Transaction.isSubarnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\" ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributerName) && !Transaction.formData.euin\"> <i class=icon-checkbox></i><ng-bind-html ng-bind-html=Transaction.euinBoxMessage.content></ng-bind-html></div></div></div></div><!--RIA code section starts from here--><div class=row ng-if=Transaction.formData.isThroughRia><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\"><input type=text name=riaCode id=riaCode ng-model=Transaction.formData.brokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=Transaction.searchDistributor(); ng-required=!Transaction.formData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span><label>RIA Code</label><!--<p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name: {{Transaction.formData.brokerName}}</p>--> <span class=error-input ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.required)\" ng-bind=Transaction.VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"Transaction.riaCodeError !== \'\' && !Transaction.tForm.riaCode.$invalid\" ng-bind=Transaction.riaCodeError></span></div></div></div><div ng-show=Transaction.riaMessage><div class=\"row euin-part\" ng-if=Transaction.formData.isThroughRia><div class=\"col-sm-12 col-md-12\"><div class=checkbox><input ng-model=Transaction.isCheckedTandC type=checkbox ng-change=Transaction.isCheckedEuin() ng-disabled=\"!Transaction.formData.brokerCode || Transaction.riaCodeError !== \'\'\" ng-required=Transaction.formData.brokerCode> <i class=icon-checkbox></i><ng-bind-html ng-bind-html=Transaction.riaMessage.content></ng-bind-html></div></div></div></div><!--RIA code section ends here--></div><div><div class=\"col-sm-12 col-md-4\"><p class=col-head>Select Switch Out Scheme</p><div class=selectfield ng-class=\"{error:(Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid)}\"><select name=folio ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid && Transaction.tForm.folio.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><!--            <div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"selectfield\"--><!--                 ng-class=\"{error:Transaction.tForm.outScheme.$invalid}\">--><!--              <label ng-if=\"Transaction.formData.outSchemeCode\">Select Source Scheme</label>--><!--              <select class=\"browser-default custom-select\" name=\"outScheme\"--><!--                      ng-change=\"Transaction.outSchemeChanged()\"--><!--                      ng-model=\"Transaction.formData.outSchemeCode\"--><!--                      ng-init=\"Transaction.formData.outSchemeCode=Transaction.formData.outSchemeCode?Transaction.formData.outSchemeCode: null\"--><!--                      ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Transaction.outSchemeList\"--><!--                      required>--><!--                <option value=\"\" selected>Select Source Scheme</option>--><!--              </select>--><!--            <span class=\"error-input\" ng-show=\"Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$invalid && Transaction.tForm.outScheme.$error.required\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--            </div>--><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid, \'anything-disabled\': !Transaction.formData.folioNumber }\"><input type=text name=outScheme id=outScheme ng-change=Transaction.filterOutSchemeList() ng-model=Transaction.formData.outSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Source Scheme</label><span class=error-input ng-show=\"Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$invalid && Transaction.tForm.outScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.outSchemeList display-key=schemeName hdfc-click=Transaction.outSchemeChanged(data) model=Transaction.formData.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{Transaction.formData.outSchemeName}}</p></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=value-snippet ng-if=Transaction.unitsDetails><div><p class=text-uppercase>Total Market Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.totalCurrentValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{Transaction.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.lockedValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{Transaction.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.freeValueUnits | number:3}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{Transaction.unitsDetails.freeValueAmount|unit}}</span></div><p class=text-primary>*as of last business day</p></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"col-sm-12 col-md-4\"><p class=col-head>Switch In Scheme</p><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid}\"><input type=text name=inScheme id=inScheme ng-change=Transaction.filterInSchemeList() ng-model=Transaction.formData.inSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><span class=error-input ng-show=\"Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid && Transaction.tForm.inScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.TARGET_SCHEME_REQUIRED></span><drop-down list-data=Transaction.inSchemeList display-key=scheme hdfc-click=Transaction.inSchemeChanged(data) model=Transaction.formData.inSchemeCode for=inScheme></drop-down><p class=info-primary>{{Transaction.formData.inSchemeName}}</p></div><div class=\"form-group text-center\"><p>OR</p><br><p><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=Transaction.schemeListModal()>Select from list</span></p></div><div class=form-group ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\" ng-if=\"Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=form-label><strong>Select Income Distribution cum Capital Withdrawal (IDCW) Option</strong></label><div class=radio-block ng-repeat=\"_option in Transaction.devidendOptions\" style=\"padding-bottom: 10px\" ng-class=\"{\'anything-disabled\': ((_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && (Transaction.inSchemeValidations.isGrowth === false||Transaction.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)\n                        || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT   && (Transaction.inSchemeValidations.isGrowth === false||Transaction.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && Transaction.inSchemeValidations.dividendPayoutApplicable === false)) }\"><span class=radio><input type=radio id=dividendOption{{$index}} ng-value=_option ng-disabled=\"(_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && (Transaction.inSchemeValidations.isGrowth === false||Transaction.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)\n                        || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT   && (Transaction.inSchemeValidations.isGrowth === false||Transaction.inSchemeValidations.investmentOption !== vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH) && Transaction.inSchemeValidations.dividendPayoutApplicable === false)\" name=dividendOption ng-model=Transaction.formData.dividendOption> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div><div class=\"row form-group\" ng-if=\"Transaction.isSchemeTypeELSS && Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div><div class=\"tc-block row form-group\" ng-if=Transaction.nfoEnabled><div class=checkbox><input name=isAutoSwitch ng-model=Transaction.formData.isAutoSwitch type=checkbox ng-change=Transaction.fetchSwitchInSchemes()> <i class=icon-checkbox></i> <span class=checkbox-text>Auto Switch on Maturity</span></div></div><div class=row ng-if=Transaction.formData.isAutoSwitch><div class=\"col-md-12 row\"><div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.switchInScheme.$dirty && Transaction.tForm.switchInScheme.$invalid}\"><input type=text name=switchInScheme id=switchInScheme ng-change=Transaction.filterSwitchInSchemeList() ng-model=Transaction.formData.switchInSchemeName autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><span class=error-input ng-show=\"Transaction.tForm.switchInScheme.$dirty && Transaction.tForm.switchInScheme.$invalid && Transaction.tForm.switchInScheme.$error.required\" ng-bind=Transaction.VALIDATE_DATA.TARGET_SCHEME_REQUIRED></span><drop-down list-data=Transaction.autoSwitchInSchemeList display-key=scheme hdfc-click=Transaction.switchInSchemeChanged(data) model=Transaction.formData.switchInSchemeCode for=switchInScheme></drop-down><p class=info-primary>{{Transaction.formData.switchInSchemeName}}</p></div><div class=form-group ng-class=\"{\'radio-disabled\':(Transaction.switchInSchemeValidations.isEnabled==\'N\')}\" ng-if=\"Transaction.switchInSchemeValidations.switchInInvestmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label class=form-label><strong>Select Income Distribution cum Capital Withdrawal (IDCW) Option</strong></label><div ng-class=\"{\'anything-disabled\': (_option==Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST\n                       && Transaction.switchInSchemeValidations.endingType === Transaction.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (_option==Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.isSwitchInSchemeTypeELSS) }\" class=radio-block ng-repeat=\"_option in Transaction.dividendOptions\"><span class=radio><input type=radio id=dividendsOption{{$index}} ng-value=_option ng-disabled=\"(_option==Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST&& Transaction.switchInSchemeValidations.endingType === Transaction.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (_option==Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.isSwitchInSchemeTypeELSS)\" name=switchDividendOption ng-model=Transaction.formData.autoSwitchSchemeDividendOption> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div><div class=\"row form-group\" ng-if=\"Transaction.isSwitchInSchemeTypeELSS && Transaction.switchInSchemeValidations.switchInInvestmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div></div><div class=\"form-group col-md-offset-1 col-md-12 scheme-invoke\"><span>OR</span> <span><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=Transaction.switchInSchemeListModal()>Select from list</span></span></div></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"col-sm-12 col-md-4\"><p class=col-head>Select Value</p><div class=form-group ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\"><div class=radio-block><span class=radio><input type=radio id=amount name=amountType ng-value=Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT ng-model=Transaction.formData.amountType ng-disabled=\"(!Transaction.unitsDetails)||(Transaction.validations.isEnabled==\'N\')\" ng-change=Transaction.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>Amount</span></div><div class=radio-block><span class=radio><input type=radio id=allUnits name=amountType ng-value=Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS ng-model=Transaction.formData.amountType ng-disabled=\"(!Transaction.unitsDetails)||(Transaction.validations.isEnabled==\'N\')\" ng-change=Transaction.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>All Free Units</span></div><div class=radio-block><span class=radio><input type=radio id=noOfUnits name=amountType ng-value=Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS ng-model=Transaction.formData.amountType ng-disabled=\"(!Transaction.unitsDetails)||(Transaction.validations.isEnabled==\'N\')\" ng-change=Transaction.amountTypeChanged()> <span class=check></span> </span><span class=radio-label>No. of Units</span></div></div><div class=\"input-normal icon-input\" ng-if=\"Transaction.formData.amountType == Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT\" ng-class=\"{error:Transaction.tForm.amount.$invalid||(Transaction.tForm.amount.$dirty&&Transaction.isInvalidForm),\'has-data\':Transaction.formData.amount}\"><input type=number name=amount ignore-mouse-wheel ng-disabled=\"(!Transaction.unitsDetails.freeValueAmount)||(Transaction.validations.isEnabled==\'N\')\" onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-change=Transaction.checkSwitchValidations() min={{Transaction.validationsApi.minAmount}} max={{Transaction.validationsApi.maxAmount}} ng-model=Transaction.formData.amount class=pd20 required> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$invalid\"><span class=error-input ng-show=\"Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$error.required\" ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span><!--<span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=\"error-input\">Amount cannot be less than the minimum required amount in the target scheme</span>--><!--<span ng-if=\"Transaction.formData.amount && Transaction.isMax && !Transaction.isMin\" class=\"error-input\">Amount cannot exceed value of clear units available to switch </span>--> <span ng-if=\"Transaction.formData.amount && !Transaction.isMax && !Transaction.isMin && (Transaction.validations.amountMultiples&&!Transaction.isMultiples)\" class=error-input>Please provide In multiples of &#8377; {{Transaction.validations.amountMultiples|unit}}</span> <span class=error-input ng-show=Transaction.tForm.amount.$error.max>Amount cannot exceed value of clear units available to switch</span> <span class=error-input ng-show=\"Transaction.tForm.amount.$error.min && !Transaction.tForm.amount.$error.max\">{{Transaction.VALIDATE_DATA.MINIMUM_AMOUNT}} {{Transaction.validationsApi.minAmount|unit}}</span></span></div><div ng-if=\"Transaction.formData.amountType== Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.AMOUNT\" class=form-group><label id=divDisplayWords>{{Transaction.amountInWords}} (In Words)</label></div><!--Unit input --><div class=input-normal ng-if=\"Transaction.formData.amountType == Transaction.TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\" ng-class={error:Transaction.tForm.units.$invalid||(Transaction.tForm.units.$dirty&&Transaction.isInvalidForm)}><input type=number ignore-mouse-wheel ng-disabled=!Transaction.unitsDetails.freeValueUnits ng-change=Transaction.checkSwitchValidations() name=units min={{Transaction.validationsApi.minUnits}} max={{Transaction.validationsApi.maxUnits}} ng-model=Transaction.formData.units ng-required=Transaction.isRequired autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter Units</label><span ng-show=\"Transaction.tForm.units.$dirty && Transaction.tForm.units.$invalid\"><span class=error-input ng-show=Transaction.tForm.units.$error.required ng-bind=Transaction.VALIDATE_DATA.UNITS_REQUIRED></span><!--<span ng-if=\"Transaction.formData.units && Transaction.isMin && !Transaction.isMax\" class=\"error-input\">Value of units cannot be less than the minimum required amount in the target scheme </span>--><!--<span ng-if=\"Transaction.formData.units && Transaction.isMax\" class=\"error-input\">Units cannot exceed clear units available to switch</span>--> <span class=error-input ng-show=\"Transaction.tForm.units.$error.min && !Transaction.tForm.units.$error.max\">Value of units cannot be less than the minimum required amount in the target scheme</span><!--|unit--> <span class=error-input ng-show=Transaction.tForm.units.$error.max>Units cannot exceed clear units available to switch</span><!--|unit--></span></div><div class=form-group><div class=estimate-block ng-if=Transaction.tForm.$valid><a href=\"\" ng-click=Transaction.downloadReport()><strong>Estimated Exit Load</strong></a><div>This transaction may have exit load charges as per AMC guidelines for this scheme</div></div></div></div><div class=col-sm-12><ng-bind-html ng-bind-html=Transaction.notes.content></ng-bind-html></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"form-footer col-md-12\"><button class=\"btn btn-secondary-action\" ng-disabled=\"!Transaction.formData.inSchemeName || !Transaction.formData.outSchemeCode\" ng-click=Transaction.saveForm()>Save</button> <button ng-disabled=\"!Transaction.tForm.$valid ||Transaction.isInvalidForm || !Transaction.formData.inSchemeCode || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || !Transaction.isSelectedEuin || !Transaction.formData.outSchemeCode\" class=\"btn btn-secondary-action\" type=button ng-click=Transaction.goToScheduleTransaction()>Schedule Transaction</button> <button ng-disabled=\"!Transaction.tForm.$valid ||Transaction.isInvalidForm || !Transaction.formData.inSchemeCode || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || !Transaction.formData.outSchemeCode\" ng-click=Transaction.checkSwitchSummary() class=\"btn btn-primary-action\">Proceed to Transact</button></div></form></div></section></div><script>$(document).ready(function(){\n    $(\'[data-bs-toggle=\"tooltip\"]\').tooltip();\n  });</script><div ng-if=Transaction.formData.isSummaryViewEnabled><transaction-summary form-data=Transaction.summaryData is-summary-view-enabled=Transaction.formData.isSummaryViewEnabled transaction-type={{Transaction.transactionType}} notes=Transaction.notesReview.content show-terms=Transaction.showTerms></transaction-summary></div>");
$templateCache.put("app/transactions/initiate/swp/swp.html","<div class=\"main-section clearfix\" ng-hide=Transaction.formData.isSummaryViewEnabled><section class=initiate-transaction ng-init=Transaction.init()><p class=page-title>SYSTEMATIC WITHDRAWAL ADVANTAGE PLAN (SWAP) <i class=\"info-icon base-tooltip\" tooltip data-bs-toggle=tooltip data-bs-placement={{Main.tooltipClass}} title=\"Systematic Withdrawal Advantage Plan (SWAP) enables investors to redeem a\npre-defined amount from there investments at regular intervals. Every month\non a specified date an amount you choose is withdrawn from the scheme of\nyour choice.\"></i></p><div class=\"content-area clearfix redeem\"><form autocomplete=off class=row name=Transaction.tForm ng-keypress=Transaction.handleEnter($event) novalidate><div class=\"col-sm-12 col-md-4\"><p class=col-head>Select Scheme for Withdrawal</p><div class=selectfield ng-class=\"{error:(Transaction.tForm.folio.$invalid && Transaction.tForm.folio.$dirty)}\"><select name=folio id=_first ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><label class=form-label>Select SWP Type</label><div class=form-group ng-class=\"{\'radio-disabled\': (Transaction.validations.isEnabled == \'N\')||(!Transaction.unitsDetails.freeValueUnits),\'anything-disabled\': !Transaction.formData.folioNumber }\" ng-if=!Transaction.isReseting><div class=radio-block><span class=radio><input type=radio id=fixedAmount name=transferOption ng-model=Transaction.formData.transferOption ng-disabled=\"(Transaction.validations.isEnabled == \'N\')||(Transaction.unitsDetails.freeValueUnits == 0)\" ng-value=Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT ng-click=Transaction.transferOptionChanged(Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT);> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT]}}</span></div><div class=radio-block><span class=radio ng-if=\"Transaction.validations.investmentOption !== Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><input type=radio id=capitalAppreciation name=transferOption ng-disabled=\"(Transaction.validations.isEnabled == \'N\')||(Transaction.unitsDetails.freeValueUnits == 0)\" ng-model=Transaction.formData.transferOption ng-value=Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION ng-click=Transaction.transferOptionChanged(Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION);> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION]}}</span></div></div><!--          <div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"selectfield\"--><!--               ng-class=\"{error:(Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$invalid)}\">--><!--            <label ng-if=\"Transaction.formData.outSchemeCode\">Select Scheme</label>--><!--            <select name=\"outScheme\"--><!--                    ng-change=\"Transaction.outSchemeChanged()\"--><!--                    ng-model=\"Transaction.formData.outSchemeCode\"--><!--                    ng-init=\"Transaction.formData.outSchemeCode=Transaction.formData.outSchemeCode?Transaction.formData.outSchemeCode: null\"--><!--                    ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Transaction.outSchemeList\"--><!--                    required>--><!--              <option value=\"\" selected>Select Scheme</option>--><!--            </select>--><!--            <span class=\"error-input\"--><!--                  ng-show=\"Transaction.tForm.outScheme.$dirty && Transaction.tForm.outScheme.$error.required\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--          </div>--><div class=\"input-select input-normal\" ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" ng-class={error:Transaction.tForm.outScheme.$invalid}><input type=text name=outScheme id=outScheme ng-change=Transaction.filterOutSchemeList() ng-model=Transaction.formData.outSchemeName autocomplete=off ng-required=Transaction.isRequired> <span class=highlight></span> <span class=bar></span><label>Select Source Scheme</label><span class=error-input ng-show=Transaction.tForm.outScheme.$error.required ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.outSchemeList display-key=schemeName hdfc-click=Transaction.outSchemeChanged(data) model=Transaction.formData.outSchemeCode for=outScheme></drop-down><p class=info-primary>{{Transaction.formData.outSchemeName}}</p></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=value-snippet ng-if=Transaction.unitsDetails><div><p class=text-uppercase>Total Market Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.totalCurrentValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{Transaction.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.lockedValueUnits}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{Transaction.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value</p><span class=left-val easyassist-key=mask-element>{{Transaction.unitsDetails.freeValueUnits | number:3}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{Transaction.unitsDetails.freeValueAmount|unit}}</span></div><p class=text-primary>*as of last business day</p></div></div><div class=\"col-sm-12 col-md-4\" ng-class=\"{\'anything-disabled\': (Transaction.unitsDetails.freeValueUnits==\'0\' || Transaction.unitsDetails.freeValueAmount==\'0\') }\"><p class=col-head>Select Withdrawal Options</p><div class=selectfield ng-class=\"{error:Transaction.tForm.frequency.$dirty && Transaction.tForm.frequency.$invalid}\"><label ng-if=Transaction.formData.frequency>Select Frequency</label><select name=frequency ng-disabled=\"(Transaction.validations.isEnabled == \'N\')||(!Transaction.unitsDetails.freeValueUnits)\" ng-change=Transaction.changeFrequency() ng-model=Transaction.formData.frequency ng-options=\"_frequency.key as _frequency.value for _frequency in Transaction.frequencyList\" required><option value=\"\" selected>Select Frequency</option></select><span class=error-input ng-show=\"Transaction.tForm.frequency.$dirty && Transaction.tForm.frequency.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FREQUENCY_REQUIRED></span></div><div class=\"input-normal icon-input\" ng-if=\"Transaction.formData.transferOption !== Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION\" ng-class=\"{error:(Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$invalid),\n               \'has-data\':Transaction.formData.amount}\"><input type=number ignore-mouse-wheel name=amount ng-disabled=!Transaction.unitsDetails||!Transaction.unitsDetails.freeValueAmount ng-model=Transaction.formData.amount ng-change=Transaction.checkSwpStpValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" required> <span class=highlight></span> <span class=bar></span><label>SWP Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"Transaction.tForm.amount.$dirty && Transaction.tForm.amount.$error.required\" ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=error-input>Minimum amount should be &#8377; {{Transaction.validations.minAmount|unit}}</span> <span ng-if=\"Transaction.formData.amount && Transaction.isMax && !Transaction.isMin\" class=error-input>Maximum amount should be &#8377; {{Transaction.validations.maxAmount|unit}}</span> <span ng-if=\"Transaction.formData.amount && !Transaction.isMax && !Transaction.isMin && (Transaction.validations.amountMultiples&&!Transaction.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{Transaction.validations.amountMultiples|unit}}</span></div><div class=form-group ng-if=\"Transaction.formData.transferOption !== Transaction.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION\"><label id=divDisplayWords>{{Transaction.amountInWords}} (In Words)</label></div><div class=selectfield ng-if=!Transaction.isReseting ng-class=\"{\'anything-disabled\':!Transaction.formData.frequency}\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\" date-calendar data-viewmode={{Transaction.viewMode}} data-date-default=Transaction.formData.startDate data-min-date=Transaction.startMinDate data-max-date=Transaction.startMaxDate data-on-date-change=Transaction.changeStartDate id=startDate data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"SWP Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=Transaction.formData.startDate>SWP Start Date - DD-MMM-YYYY</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Transaction.tForm.startDate.$error.required ng-bind=Transaction.VALIDATE_DATA.START_DATE_REQUIRED></span></div><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:Transaction.tForm.endDate.$dirty && Transaction.tForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=Transaction.formData.endDate data-on-date-change=Transaction.changeEndDate data-enabled-dates=Transaction.enabledEndDates data-view-date=Transaction.enabledEndDateView data-min-date=Transaction.enabledEndDates[0] data-max-date=Transaction.maxEndDate data-enable=true id=endDate showdefault=false><!-- data-min-date=\"Transaction.formData.minEndDate\"--> <input type=text name=endDate autocomplete=off placeholder=\"SWP End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span><label ng-if=Transaction.formData.endDate>SWP End Date - DD-MMM-YYYY</label><span class=bar></span> <span class=error-input ng-show=\"Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\" ng-bind=Transaction.VALIDATE_DATA.MONTH_REQUIRED></span></div></div></div><div ng-class=\"{\'anything-disabled\': (!Transaction.formData.folioNumber || Transaction.unitsDetails.freeValueUnits==\'0\') }\" class=\"col-sm-12 col-md-4\"><p class=col-head>Select Bank For Payout</p><div class=selectfield ng-class=\"{error:Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$invalid}\"><select name=bank ng-disabled=!Transaction.bankList ng-model=Transaction.formData.bankInfo ng-options=\"bank.bankName for bank in Transaction.bankList track by bank.payoutId\" ng-change=Transaction.changeBank() ng-init=\"Transaction.formData.bankInfo=Transaction.formData.bankInfo?Transaction.formData.bankInfo: null\" required><option value=\"\" selected>{{Transaction.bankList&&!Transaction.bankList.length ?\'No Bank Available for Redemption\':\'Select Bank for Withdrawal\'}}</option></select><label ng-if=Transaction.formData.bankInfo.bankName>Select Bank for Withdrawal</label><span class=error-input ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required\" ng-bind=Transaction.VALIDATE_DATA.BANK_REQUIRED></span></div><table class=\"table borderless\" ng-if=Transaction.formData.bankInfo&&Transaction.bankList.length><tr><td>Bank Name:</td><td>{{Transaction.formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{Transaction.formData.bankInfo.bankAcNo}}</td></tr><tr><td>IFSC:</td><td>{{Transaction.formData.bankInfo.ifscCode}}</td></tr><tr><td>Payout:</td><td>{{Transaction.formData.bankInfo.payoutDescription | uppercase}}</td></tr></table></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"form-footer col-md-12\"><button class=\"btn btn-secondary-action\" ng-disabled=!Transaction.formData.outSchemeCode ng-click=Transaction.saveForm()>Save</button> <button ng-disabled=\"!Transaction.tForm.$valid||Transaction.isInvalidForm || !Transaction.formData.startDate || !Transaction.formData.endDate || (Transaction.selectedFolioObj && Transaction.selectedFolioObj.minorFlag && !Transaction.formData.bankInfo.minorBankFlag)  || (!Transaction.kycVerifiedFlag) || !Transaction.formData.outSchemeCode\" ng-click=Transaction.goToSummary() class=\"btn btn-primary-action\">Proceed to Transact</button></div></form></div></section></div><div ng-if=Transaction.formData.isSummaryViewEnabled><transaction-summary form-data=Transaction.summaryData is-summary-view-enabled=Transaction.formData.isSummaryViewEnabled transaction-type={{Transaction.transactionType}} modal-data-terms-condition=Transaction.TermsCondition.content show-terms=Transaction.showTerms></transaction-summary></div>");
$templateCache.put("app/transactions/status/payment-status/payment.status.html","<div class=header-section><hdfc-header ng-if=\"!PaymentStatus.showWhatsApp && !PaymentStatus.isMobile\"></hdfc-header><hdfc-sidebar ng-if=\"!PaymentStatus.showWhatsApp && !PaymentStatus.isMobile\"></hdfc-sidebar><div class=\"payment-header-container payment-header text-center\" ng-if=PaymentStatus.showWhatsApp><div class=logo-btn-container><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo> <span></span></div><p>Acknowledgement</p></div></div><section ng-if=!PaymentStatus.isPending class=\"content-section payment-status\" ng-class=\"{\'p-0\' : PaymentStatus.isMobile}\"><div class=\"container-fluid height100\" ng-class=\"{\'header-spacing\': !PaymentStatus.showWhatsApp && !PaymentStatus.isMobile}\"><section class=height100 ng-class=\"{\'box-shadow\': !PaymentStatus.showWhatsApp && !PaymentStatus.isMobile}\"><div class=row><div class=col-md-12><div class=header ng-class=\"{\'header-background\': PaymentStatus.transactionDetails.paymentStatus && PaymentStatus.transactionDetails.transactionType !== \'SIPPURCHASE\' || PaymentStatus.transactionDetails.transactionType === \'SIPPURCHASE\' && PaymentStatus.isSuccess}\"><div ng-if=\"PaymentStatus.transactionDetails.paymentStatus && PaymentStatus.transactionDetails.transactionType !== \'SIPPURCHASE\'\"><div class=header-img><div class=success><i class=header-success></i></div></div><div class=text><h3>Transaction Successful</h3></div></div><div ng-if=\"PaymentStatus.transactionDetails.hasOwnProperty(\'paymentStatus\') && !PaymentStatus.transactionDetails.paymentStatus && PaymentStatus.transactionDetails.transactionType !== \'SIPPURCHASE\'\"><div class=header-img><div class=failed><i class=header-failed></i></div></div><div class=\"text text-center\"><h3>Transaction Failed</h3><p style=\"margin-top: 20px; margin-bottom: 10px\">{{PaymentStatus.errorMessage}}</p></div></div><div ng-if=\"PaymentStatus.transactionDetails.transactionType === \'SIPPURCHASE\'\"><div class=header-img ng-if=PaymentStatus.isSuccess><div class=success><i class=header-success></i></div></div><div class=header-img ng-if=!PaymentStatus.isSuccess><div class=failed style=\"margin-top: 25px\"><i class=header-failed></i></div></div></div></div><div class=\"text text-center\" ng-if=\"PaymentStatus.transactionDetails.transactionType === \'SIPPURCHASE\'\"><div ng-if=PaymentStatus.isSuccess><h3>Thank you for investing with us</h3></div><div ng-if=!PaymentStatus.isSuccess class=mt-8><h3>Transaction Failed</h3></div><p ng-if=!PaymentStatus.isSuccess style=\"margin-top: 20px; margin-bottom: 10px\">{{PaymentStatus.errorMessage}}</p></div></div></div><div class=row><div class=col-md-12><div class=body><div class=row ng-if=\"PaymentStatus.transactionDetails.paymentStatus && PaymentStatus.transactionDetails.transactionType !== \'SIPPURCHASE\'\"><div class=col-md-12><p>Thank you for investing with us.</p></div></div><div class=row><div class=col-md-12><div class=fund-details ng-class=\"{\'fund-details-error\' : PaymentStatus.transactionDetails.hasOwnProperty(\'paymentStatus\') && !PaymentStatus.transactionDetails.paymentStatus && PaymentStatus.transactionDetails.transactionType !== \'SIPPURCHASE\' && PaymentStatus.errorMessage, \'fund-detail-spacing\' : PaymentStatus.transactionDetails.hasOwnProperty(\'paymentStatus\') && !PaymentStatus.transactionDetails.paymentStatus && PaymentStatus.transactionDetails.transactionType !== \'SIPPURCHASE\' && !PaymentStatus.errorMessage}\"><div ng-repeat=\"items in PaymentStatus.transactionDetails.cartItems\"><div class=\"main-text black-200\">{{items.schemeName}}</div><div class=\"sub-text black-200 font-weight-600\" ng-if=\"PaymentStatus.transactionDetails.transactionType !== \'SIPPURCHASE\'\">₹{{PaymentStatus.utilService.getCommaSeperatedString(items.amount)}}</div><div class=\"sub-text black-200 font-weight-600\" ng-if=\"PaymentStatus.transactionDetails.transactionType === \'SIPPURCHASE\'\">{{PaymentStatus.PAYMENT_OPTIONS[PaymentStatus.transactionDetails.paymentOption]}} | {{PaymentStatus.transactionDetails.investThrough}}</div></div></div></div></div><div class=row><div class=\"mx-auto col-md-5\"><div class=transaction-details ng-repeat=\"items in PaymentStatus.transactionDetails.cartItems\"><div class=row ng-if=\"PaymentStatus.transactionDetails.transactionType === \'SIP\' && PaymentStatus.transactionDetails.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Type: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">SIP</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">SIP</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Tenure: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{PaymentStatus.transactionDetails.sipDuration}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{PaymentStatus.transactionDetails.sipDuration}}</span></p></div><div class=\"col-md-6 col-xs-6\" ng-if=items.sipWithFirstInstallment><p class=\"sub-text black-80 font-weight-400\">First Installment Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{PaymentStatus.utilService.getCommaSeperatedString(items.amount)}}</span></p></div><div class=\"col-xs-6 visible-xs\" ng-if=items.sipWithFirstInstallment><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{PaymentStatus.utilService.getCommaSeperatedString(items.amount)}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Investing Through: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{PaymentStatus.transactionDetails.arn}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{PaymentStatus.transactionDetails.arn}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Method: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{PaymentStatus.transactionDetails.paymentMethod}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{PaymentStatus.transactionDetails.paymentMethod}}</span></p></div><div class=\"col-md-6 col-xs-6\" ng-if=items.camsReferenceNo><p class=\"sub-text black-80 font-weight-400\">CAMS Reference Number: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{items.camsReferenceNo}}</span></p></div><div class=\"col-xs-6 visible-xs\" ng-if=items.camsReferenceNo><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{items.camsReferenceNo}}</span></p></div><div class=\"col-md-6 col-xs-6\" ng-if=PaymentStatus.transactionDetails.sipTopUpAmount><p class=\"sub-text black-80 font-weight-400\">SIP Top-Up Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{PaymentStatus.utilService.getCommaSeperatedString(PaymentStatus.transactionDetails.sipTopUpAmount)}}/{{PaymentStatus.constants.TRANSACTIONS.DESCRIPTIONS.FREQ[PaymentStatus.transactionDetails.sipTopupFrequency]}}</span></p></div><div class=\"col-xs-6 visible-xs\" ng-if=PaymentStatus.transactionDetails.sipTopUpAmount><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{PaymentStatus.utilService.getCommaSeperatedString(PaymentStatus.transactionDetails.sipTopUpAmount)}}/{{PaymentStatus.constants.TRANSACTIONS.DESCRIPTIONS.FREQ[PaymentStatus.transactionDetails.sipTopupFrequency]}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Registration Number: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{PaymentStatus.transactionDetails.srn}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{PaymentStatus.transactionDetails.srn}}</span></p></div></div><div class=row ng-if=\"PaymentStatus.transactionDetails.transactionType === \'PURCHASE\' && PaymentStatus.transactionDetails.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Type: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">Purchase</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">Purchase</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Date: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{PaymentStatus.transactionDetails.transactionInitiatedAt}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{PaymentStatus.transactionDetails.transactionInitiatedAt}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Investing Through: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{items.brokerCode}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{items.brokerCode}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Method: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{PaymentStatus.PAYMENT_OPTIONS[PaymentStatus.transactionDetails.paymentOption]}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{PaymentStatus.PAYMENT_OPTIONS[PaymentStatus.transactionDetails.paymentOption]}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">CAMS Reference No.: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{items.camsReferenceNo}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{items.camsReferenceNo}}</span></p></div></div><div class=row ng-if=\"PaymentStatus.transactionDetails.transactionType === \'SIPPURCHASE\' && PaymentStatus.transactionDetails.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-12\"><div class=\"col-md-12 col-xs-12\"><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600 hidden-xs\">Purchase Summary</span></p></div><div class=\"col-xs-12 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">Purchase Summary</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{PaymentStatus.utilService.getCommaSeperatedString(items.amount)}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{PaymentStatus.utilService.getCommaSeperatedString(items.amount)}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Date: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{PaymentStatus.transactionDetails.transactionInitiatedAt}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{PaymentStatus.transactionDetails.transactionInitiatedAt}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Status: <span ng-style=\"{\'color\' : items.purchasePaymentStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600 hidden-xs\">{{items.purchasePaymentStatus}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span ng-style=\"{\'color\' : items.purchasePaymentStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600\">{{items.purchasePaymentStatus}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Number: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{PaymentStatus.cartId}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{PaymentStatus.cartId}}</span></p></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"col-md-12 col-xs-12\"><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600 hidden-xs\">SIP Summary</span></p></div><div class=\"col-xs-12 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">SIP Summary</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{PaymentStatus.utilService.getCommaSeperatedString(items.installmentAmount)}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{PaymentStatus.utilService.getCommaSeperatedString(items.installmentAmount)}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Tenure: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{PaymentStatus.transactionDetails.sipDuration}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{PaymentStatus.transactionDetails.sipDuration}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Status: <span ng-style=\"{\'color\' : items.sipPaymentStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600 hidden-xs\">{{items.sipPaymentStatus}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span ng-style=\"{\'color\' : items.sipPaymentStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600\">{{items.sipPaymentStatus}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Registration Number (SRN): <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{items.srnNo}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{items.srnNo}}</span></p></div></div></div><div class=row ng-if=\"PaymentStatus.transactionDetails.sourcePortal === \'WHATSAPP\'\"><div class=\"col-md-12 col-xs-12 whatsapp-message\"><p>Kindly check WhatsApp to view detailed acknowledgement</p></div></div><div class=row ng-if=\"(PaymentStatus.transactionDetails.transactionType === \'SIP\' && PaymentStatus.transactionDetails.paymentStatus) || (PaymentStatus.transactionDetails.transactionType === \'SIPPURCHASE\' && PaymentStatus.isSuccess && PaymentStatus.isSipSuccess)\"><div class=\"col-md-12 col-xs-12\"><div class=sip-message><i class=info-fill></i><p>Your next SIP installment shall be debited on {{PaymentStatus.installmentDate}}. <span ng-if=PaymentStatus.showInstallments>Subsequent SIP installments shall be debited every {{PaymentStatus.installmentText}}.</span></p></div></div></div></div></div></div><div class=row ng-class=\"{\'set-responsive-width-max\' : PaymentStatus.transactionDetails.transactionType === \'SIPPURCHASE\' || PaymentStatus.transactionDetails.transactionType === \'PURCHASE\' && !PaymentStatus.transactionDetails.paymentStatus || PaymentStatus.transactionDetails.transactionType === \'SIP\' && PaymentStatus.transactionDetails.transactionType === \'PURCHASE\' && !PaymentStatus.transactionDetails.paymentStatus || PaymentStatus.transactionDetails.transactionType === \'SIP\' && !PaymentStatus.transactionDetails.paymentStatus}\" ng-if=\"PaymentStatus.transactionDetails.sourcePortal !== \'WHATSAPP\'\"><div class=\"mx-auto col-md-5\"><div class=action-container><button class=\"btn btn-secondary\" ng-if=PaymentStatus.transactionDetails.cartItems ng-click=PaymentStatus.redirectToHome();>Go To Home</button> <button class=\"btn btn-primary\" ng-if=\"PaymentStatus.transactionDetails.transactionType === \'SIP\' && PaymentStatus.transactionDetails.paymentStatus\" ng-click=\"PaymentStatus.performRedirect(\'SIP\');\">Invest More</button> <button class=\"btn btn-primary\" ng-click=\"PaymentStatus.performRedirect(\'PURCHASE\');\" ng-if=\"PaymentStatus.transactionDetails.transactionType === \'PURCHASE\' && PaymentStatus.transactionDetails.paymentStatus\">Invest More</button> <button class=\"btn btn-primary\" ng-click=\"PaymentStatus.performRedirect(\'SIP\');\" ng-if=\"PaymentStatus.transactionDetails.transactionType === \'SIP\' && PaymentStatus.transactionDetails.transactionType === \'PURCHASE\' && PaymentStatus.transactionDetails.paymentStatus\">Invest More</button> <button class=\"btn btn-primary\" ng-click=PaymentStatus.performRedirect(PaymentStatus.transactionDetails.transactionType); ng-if=\"PaymentStatus.transactionDetails.cartItems && ((!PaymentStatus.isSipPurchase && !PaymentStatus.transactionDetails.paymentStatus) || (PaymentStatus.isSipPurchase && (!PaymentStatus.isSipSuccess || !PaymentStatus.isPurchaseSuccess)))\">Re-Try</button> <button class=\"btn btn-primary\" ng-click=\"PaymentStatus.performRedirect(\'PURCHASE\');\" ng-if=\"PaymentStatus.isSipPurchase && (PaymentStatus.isSipSuccess && PaymentStatus.isPurchaseSuccess)\">Invest More</button></div></div></div></div></div></div><div class=\"row footer-row\" ng-if=!PaymentStatus.showWhatsApp><div class=col-md-12><footer><div class=footer-text>For any clarification, please reach our customer service at <a href=mailto:Hello@hdfcfund.com>Hello@hdfcfund.com</a> or call us at <a href=\"tel:1800 3010 6767\">1800 3010 6767</a> or <a href=\"tel:1800 419 7676\">1800 419 7676</a>.</div></footer></div></div><div class=\"row footer-row\" ng-if=PaymentStatus.showWhatsApp><div class=col-md-12><div><div class=footerSubDiv><img src=../../../assets/images/hdfcmf-Main.png alt=\"\" style=\"height: 20px\"><p class=footerSubHeading>Managed by HDFC MF Limited.<a href={{PaymentStatus.CORPORATE_URL}} target=_blank style=\"color: blue;font-weight: 500\">Learn More</a>.</p></div></div></div></div></section></div></section><section ng-if=PaymentStatus.isPending class=\"content-section payment-status\" ng-class=\"{\'p-0\' : PaymentStatus.isMobile}\"><div class=\"container-fluid height100\" ng-class=\"{\'header-spacing\': !PaymentStatus.showWhatsApp && !PaymentStatus.isMobile}\"><section class=height100 ng-class=\"{\'box-shadow\': !PaymentStatus.showWhatsApp && !PaymentStatus.isMobile}\"><div class=row><div class=col-md-12><div class=header><div><div class=header-img><div class=success><i class=header-success></i></div></div></div></div><div class=\"text text-center\"><div ng-if=PaymentStatus.isSuccess><h3>Thank you. Your transaction has been received</h3></div></div></div></div><div class=row><div class=col-md-12><div class=body><div class=row><div class=col-md-12><div class=\"fund-details fund-detail-spacing\" ng-class=\"{\'set-padding-left-right-15\': !PaymentStatus.isMobile}\"><div><div class=\"main-text black-200\">Please wait for 24 hours for payment to get processed by your bank. If your account is debited and fund are transferred, please do not transact again.</div><div class=\"sub-text black-200 font-weight-600 mt-4\">For clarification please write to Hello@hdfcfund.com or call 1800 3010 6767 (Toll Free)</div></div></div></div></div><div class=\"row set-responsive-width-max\"><div class=\"mx-auto col-md-5\"><div class=action-container><button class=\"btn btn-primary\" ng-click=\"PaymentStatus.performRedirect(\'PURCHASE\');\">Start Lump sum purchase</button> <button class=\"btn btn-primary\" ng-click=\"PaymentStatus.performRedirect(\'SIP\');\">Start an SIP</button></div></div></div></div></div></div></section></div></section><div class=footer-section ng-if=\"!PaymentStatus.showWhatsApp && !PaymentStatus.isMobile\"><div ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div></div>");
$templateCache.put("app/transactions/status/schedule-transaction-success/schedule-transaction-success.html","<div class=\"container-fluid payment-audit\"><div class=row><div class=col-xs-12><header><div class=logo><img src=../../../assets/images/logo.png></div></header></div></div><div class=row><div class=\"col-xs-12 summary\"><section class=transaction-status ng-init=ScheduleSummary.init()><!-- --><div class=content-area><div class=\"col-md-5 col-sm-6 review-grid\"><table class=\"table borderless\"><tr ng-if=\"ScheduleSummary.formData.transactionType !== \'REDEMPTION\' && !ScheduleSummary.formData.riaConsent\"><td>Distributor ARN</td><td>:</td><td ng-if=ScheduleSummary.formData.brokerCode>{{ScheduleSummary.formData.brokerCode}}</td><td ng-if=!ScheduleSummary.formData.brokerCode>DIRECT</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType !== \'REDEMPTION\' && ScheduleSummary.formData.riaConsent\"><td>RIA Code</td><td>:</td><td ng-if=ScheduleSummary.formData.brokerCode>{{ScheduleSummary.formData.brokerCode}}</td><td ng-if=!ScheduleSummary.formData.brokerCode>N/A</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType !== \'REDEMPTION\' && ScheduleSummary.formData.riaConsent\"><td>RIA Name</td><td>:</td><td ng-if=ScheduleSummary.formData.riaName>{{ScheduleSummary.formData.riaName}}</td><td ng-if=!ScheduleSummary.formData.riaName>N/A</td></tr><tr><td>Folio No.</td><td>:</td><td>{{ScheduleSummary.formData.folioNumber}}</td></tr><tr ng-if=\"ScheduleSummary.formData.isFromSmartLink && !ScheduleSummary.ONEClickHDFCBankFlow\"><td>CAMS Reference No.</td><td>:</td><td>{{ScheduleSummary.formData.cams | camelcase}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{ScheduleSummary.formData.transactionType | camelcase}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType !== \'SWITCH\'\"><td>Scheme Name</td><td>:</td><td>{{ScheduleSummary.formData.sourceSchemeName}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\'\"><td>Switch Out Scheme</td><td>:</td><td>{{ScheduleSummary.formData.sourceSchemeName}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\'\"><td>Switch In Scheme</td><td>:</td><td>{{ScheduleSummary.formData.targetScheme}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\'\"><td>Investment Option</td><td>:</td><td>{{ScheduleSummary.formData.investmentOption | camelcase}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\'\"><td>Dividend Option</td><td>:</td><td>{{ScheduleSummary.formData.investmentOption === ScheduleSummary.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? \'NA\' : ScheduleSummary.TRANSACTIONS_CONST.DESCRIPTIONS[ScheduleSummary.formData.dividendOption]}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\' && ScheduleSummary.formData.amount > 0\"><td>Redemption Amount</td><td>:</td><td>{{ScheduleSummary.formData.amount}}<br><label id=scheduleStatusDisplayWords>{{ScheduleSummary.formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\' && ScheduleSummary.formData.units > 0\"><td>Redemption Units</td><td>:</td><td>{{ScheduleSummary.formData.units}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\'\"><td>Bank Name</td><td>:</td><td>{{ScheduleSummary.formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\'\"><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{ScheduleSummary.formData.bankInfo.bankAcNo}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\'\"><td>IFSC</td><td>:</td><td>{{ScheduleSummary.formData.bankInfo.ifscCode}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'REDEMPTION\'\"><td>Payout</td><td>:</td><td>{{ScheduleSummary.formData.bankInfo.payoutDescription |camelcase}}</td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'PURCHASE\'\"><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{ScheduleSummary.formData.amount}}<br><label id=scheduleStatusDisplayWords>{{ScheduleSummary.formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType === \'SWITCH\' && ScheduleSummary.formData.transactionMode.toLowerCase() !== ScheduleSummary.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td><span ng-if=!ScheduleSummary.formData.units>Amount</span><spann ng-if=ScheduleSummary.formData.units>Units</spann></td><td>:</td><td><i class=rupee-small-icon ng-if=!ScheduleSummary.formData.units></i>{{ScheduleSummary.formData.units ? ScheduleSummary.formData.units : ScheduleSummary.formData.amount}}<br><label id=scheduleStatusDisplayWords ng-if=!ScheduleSummary.formData.units>{{ScheduleSummary.formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"ScheduleSummary.formData.transactionType !== \'PURCHASE\' && ScheduleSummary.formData.transactionMode.toLowerCase() === ScheduleSummary.TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Units</td><td>:</td><td>All Free Units</td></tr><tr ng-if=\"ScheduleSummary.formData.initiated && !ScheduleSummary.ONEClickHDFCBankFlow\"><td>Scheduled On</td><td>:</td><td>{{ScheduleSummary.formData.initiated}}</td></tr><tr><td>Scheduled Date<span ng-if=!ScheduleSummary.formData.isFromSmartLink>(s)</span></td><td>:</td><td><span ng-if=ScheduleSummary.formData.scheduleDetails.scheduleDate>{{ScheduleSummary.formData.scheduleDetails.scheduleDate | dateformatter: \'DD-MMM-YYYY\'}}</span> <span ng-if=ScheduleSummary.formData.scheduleDetails.scheduleDates>, {{ScheduleSummary.formData.scheduleDetails.scheduleDates}}</span></td></tr><tr ng-if=ScheduleSummary.formData.scheduleDetails.frequency><td>Frequency</td><td>:</td><td>{{ScheduleSummary.formData.scheduleDetails.frequency}}</td></tr><tr ng-if=ScheduleSummary.formData.scheduleDetails.endDate><td>End Date</td><td>:</td><td>{{ScheduleSummary.formData.scheduleDetails.endDate | dateformatter: \'DD-MMM-YYYY\'}}</td></tr><tr ng-if=\"ScheduleSummary.formData.isFromSmartLink && ScheduleSummary.formData.transactionType === \'PURCHASE\'\"><td>Payment Method</td><td>:</td><td>{{ScheduleSummary.TRANSACTIONS_CONST.DESCRIPTIONS[ScheduleSummary.formData.formData.purchasePaymentOption]}}</td></tr><tr ng-if=\"ScheduleSummary.formData.isFromSmartLink && ScheduleSummary.formData.transactionType === \'PURCHASE\'\"><td>Bank and Account Number</td><td>:</td><td>{{ScheduleSummary.formData.bankInfo.bankName}} <span ng-if=ScheduleSummary.formData.bankInfo.bankAcNo>-</span> <span easyassist-key=mask-element>{{ScheduleSummary.formData.bankInfo.bankAcNo}}</span></td></tr></table></div><div class=\"col-md-7 col-sm-6 status-grid text-center\"><p class=verify-sign><i class=verify-icon></i></p><p class=\"status-info green success\" ng-if=ScheduleSummary.formData.isFromSmartLink>Transaction Completed Successfully</p><div class=gottohome ui-sref=welcome ng-click=ScheduleSummary.clearSessionStorage() ng-if=!ScheduleSummary.formData.isFromSmartLink><i class=\"home-blue-icon cursor-pointer\"></i> <strong class=\"text-blue cursor-pointer\">Go To Home</strong></div><div class=gottohome ui-sref=welcome ng-click=ScheduleSummary.clearSessionStorage() ng-if=\"ScheduleSummary.formData.isFromSmartLink && !ScheduleSummary.formData.gigWorkersFlow\"><i class=\"home-blue-icon cursor-pointer\"></i> <strong class=\"text-blue cursor-pointer\">Login to MFOnline Investors</strong></div></div></div></section></div></div></div>");
$templateCache.put("app/transactions/summary/directive/summary.dream-sip.html","<section class=\"initiate-transaction redemption sip-topup\"><div class=summary><p class=page-title>REVIEW TRANSACTION : Dream SIP Registration (SIP to SWAP)</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"formData.investmentType == \'DREAMSIP\'\"><table class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=formData.isThroughRia>{{formData.riaBrokerCode}}</td><td ng-if=!formData.riaBrokerCode>N/A</td></tr><tr ng-if=formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=formData.riaBrokerName>{{formData.riaBrokerName}}</td><td ng-if=!formData.riaBrokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"formData.isThroughDistributor && formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>DREAMSIP</td></tr><tr><td ng-if=\"formData.option===\'Option A\'\">Scheme Name</td><td ng-if=\"formData.option===\'Option B\'\">Source Scheme Name</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr ng-if=\"formData.option===\'Option B\'\"><td>Target Scheme Name</td><td>:</td><td>{{formData.targetSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption}}</td></tr><!-- <tr ng-if=\"formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">\n                <td>Income Distribution cum Capital Withdrawal (IDCW) Option</td>\n                <td>:</td>\n                <td><span\n                  ng-if=\"formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">\n                    {{TRANSACTIONS_CONST.DESCRIPTIONS[formData.sipDividendOption]}}\n                  </span>\n                </td>\n              </tr> --><tr><td>SIP Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.amount}}</td></tr><tr><td>SWAP Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.swapAmount}}</td></tr><tr><td>Installment Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr ng-if=\"formData.frequency == \'OW\'\"><td>SIP Day</td><td>:</td><td>{{formData.weeklyDay}}</td></tr><tr><td>Start Date</td><td>:</td><td>{{formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>End Date</td><td>:</td><td>{{formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>SIP Tenure</td><td>:</td><td>{{formData.sipPeriod}}</td></tr><tr><td>Dream SIP Option</td><td>:</td><td ng-if=\"formData.option===\'Option A\'\">{{formData.option}} (SIP - SWAP)</td><td ng-if=\"formData.option===\'Option B\'\">{{formData.option}} (SIP - SWITCH - SWAP)</td></tr><!-- <tr>\n                <td>Type Of Folio</td>\n                <td>:</td>\n                <td ng-if=\"formData.CREATE_NEW_FOLIO\">NEW</td>\n                <td ng-if=\"!formData.CREATE_NEW_FOLIO\">EXISTING</td>\n              </tr> --><tr><td>Payment Option</td><td>:</td><td ng-if=\"formData.sipPaymentOption ==\'E-mandate\'\">Register E-mandate (eOTM)</td><td ng-if=\"formData.sipPaymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"formData.sipPaymentOption ==\'OTM\'\">OTM (One Time Mandate)</td><td ng-if=\"formData.sipPaymentOption ==\'UPI\'\">UPI Autopay</td></tr><tr ng-if=\"formData.sipPaymentOption == \'UPI\'\"><td>Virtual Payment Address (UPI ID)</td><td>:</td><td>{{formData.virtualAddress}}</td></tr><tr ng-if=\"formData.sipPaymentOption != \'E-mandate\'\"><td>Bank Name</td><td>:</td><td>{{formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"(formData.bankInfo.bankName==\'HDFC BANK\' && formData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{formData.bankAcNo}}</td></tr><tr ng-if=\"formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{formData.bankInfo.omUmrn}}</td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=formData.inSchemeName></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table></div><div class=col-md-6 ng-if=\"formData.investmentType == \'DREAMSIP\'\"><table class=\"borderless table\"><tr ng-if=formData.sipTopupEnabled><td>SIP Topup Enabled</td><td>:</td><td>Yes</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.amount\"><td>SIP Topup Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.topupDetails.amount}}</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.percentage\"><td>SIP Topup Percentage</td><td>:</td><td>{{formData.topupDetails.percentage}}%</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.frequency\"><td>SIP Topup Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.topupDetails.frequency]}}</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.capAmount\"><td>SIP Topup Cap Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.topupDetails.capAmount}}</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.capMonthYear\"><td style=\"width: 200px\">SIP Topup Cap Month/Year</td><td>:</td><td>{{formData.topupDetails.capMonthYear}}</td></tr><tr><td class=eMandateReview>Email ID</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td class=eMandateReview>Mobile Number</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table><table class=\"borderless table\" ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><tr ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><td style=\"color: black\"><u><strong>Emandate Registration Details</strong></u></td></tr><tr><td class=eMandateReview>Bank Name</td><td class=eMandateRow>:</td><td>{{formData.bankInfo.bankName.substring(0,formData.bankInfo.bankName.indexOf(\"-\"))}}</td></tr><tr><td class=eMandateReview>Account Number</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.bankInfo.accountNumber}}</td></tr><tr><td class=eMandateReview>Amount</td><td class=eMandateRow>:</td><td><i class=rupee-small-icon></i> {{formData.emandateAmount}}<br><label id=amountInwordsEmandateSummary>{{emandateAmountDetails.amountInWords}} (In Words)</label></td></tr><tr><td class=eMandateReview>Frequency</td><td class=eMandateRow>:</td><td>As and when presented</td></tr><tr><td class=eMandateReview>Authentication Mode</td><td class=eMandateRow>:</td><td>{{formData.authMode.text}}</td></tr><tr><td class=eMandateReview>Start Date</td><td class=eMandateRow>:</td><td>{{formData.emandateDate}}</td></tr><tr><td class=eMandateReview>End Date</td><td class=eMandateRow>:</td><td>{{formData.endDateEmandate}}</td></tr><tr><td class=eMandateReview>Purpose of Mandate</td><td class=eMandateRow>:</td><td>Mutual Fund Payment</td></tr></table></div><div class=col-md-6 ng-if=\"formData.summaryType === \'SIP_TOPUP\'\"><table class=\"table borderless\"><tr><td>Folio Number</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{TRANSACTIONS_CONST.TRANSACTION_TYPE[formData.summaryType]}}</td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.amount}}</td></tr><tr><td>Installment Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr><td>Sip End Date</td><td>:</td><td>{{formData.toDate}}</td></tr><tr ng-if=formData.topupAmount><td>Topup Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.topupAmount}}</td></tr><tr ng-if=formData.topupPercentage><td>Topup Percentage</td><td>:</td><td>{{formData.topupPercentage}}%</td></tr><tr><td>Topup Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.topupFrequency]}}</td></tr><tr ng-if=formData.topupCapAmount><td>Topup Cap-Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.topupCapAmount}}</td></tr><tr ng-if=formData.topupCapMonthYear><td>Topup Cap-Date</td><td>:</td><td>{{Summary.sipTopupCapMonthYear}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"formData.bankDetailsForECS.paymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"formData.bankDetailsForECS.paymentOption ==\'OTM\'\">OTM (One Time Mandate)</td><td ng-if=\"formData.sipPaymentOption.paymentOption ==\'E-mandate\' || formData.bankDetailsForECS.paymentOption ==\'HEM\'\">eOTM(eOTM E-mandate )</td></tr><tr><td>Bank Name</td><td>:</td><td>{{formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"(formData.bankInfo.bankName==\'HDFC BANK\' && formData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{formData.bankAcNo}}</td></tr><tr ng-if=\"formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{formData.bankInfo.omUmrn}}</td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=formData.inSchemeName></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\" ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label><label style=\"padding: 25px 0px 0px 20px; display: block\" ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\">Transaction acknowledgement email and SMS will be sent to above contact details registered in the folio.</label></div><div class=tc-block><h6 ng-if=showTerms>Terms & Conditions</h6><div ng-show=showTerms><div class=checkbox><input id=isCheckedTandC ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div></div><div ng-if=\"formData.sipPaymentOption == \'E-mandate\'\" ng-show=showTermsEmandate><br><div class=checkbox><input id=isCheckedTandCeMandate ng-model=isCheckedTandCeMandate type=checkbox ng-change=ischeckedem()> <i class=icon-checkbox></i><label for=isCheckedTandCeMandate class=checkbox-text>I have read and understood <a ng-click=showTermConditionsemandate() href=javaScript:void(0)>Terms & Conditions</a> of e-mandate (eOTM)</label></div></div></div><ng-bind-html ng-bind-html=notes></ng-bind-html><div class=content-foot><input type=hidden id=hfReq><div><span ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span><!-- <button blur-on-click ng-disabled=\"!isCheckedTandC|| !formData\"\n                    ng-click=\"goToNewFolioCreation()\"\n                    class=\"btn-primary-action btn pull-right\">Create New Folio\n            </button> --> <button blur-on-click ng-disabled=\"!isCheckedTandC|| !formData\" ng-click=makeTransaction($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div><style>.checkbox label{padding-left: 0}</style></section>");
$templateCache.put("app/transactions/summary/directive/summary.dtp.html","<div class=summary ng-init=init()><p class=page-title>REVIEW TRANSACTION : TRANSFER IDCW PLAN (TIP)</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><tr ng-if=\"formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr ng-if=formData.subBrokerARN><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=formData.subBrokerCode><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>TIP</td></tr><tr><td>Transfer from Scheme</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr><td>Transfer to Scheme</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption.toUpperCase() != TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? formData.investmentOption :( formData.investmentOption | camelcase)}}</td></tr><tr ng-if=\"formData.investmentOption.toUpperCase() != TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.dividendOption]}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr><td>Email ID</td><td>:</td><td>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td>{{formData.mobileNumber}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label></div><div class=tc-block ng-show=showTerms><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><ng-bind-html ng-bind-html=notes></ng-bind-html><div class=content-foot><div><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!formData ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div>");
$templateCache.put("app/transactions/summary/directive/summary.flexindex.html","<div class=\"summary flex-index\" ng-init=init()><p class=page-title>REVIEW TRANSACTION : FLEX INDEX</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=formData.isThroughRia>{{formData.brokerCode?formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.brokerCode>N/A</td></tr><tr ng-if=formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=formData.brokerName>{{formData.brokerName}}</td><td ng-if=!formData.brokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=formData.subBrokerARN><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>Flex Index</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr><td>Target Scheme</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption}} Growth</td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr><td class=width-small>Investment Mode</td><td style=width:20px>:</td><td>{{formData.investmentMode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr ng-if=formData.subBrokerCode><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr></table><table class=\"flex-table table\"><thead><tr><th>{{formData.investmentMode}} Installments</th><th>Stages of Switch Execution<br><span style=color:#737373>S&P BSE SENSEX Levels</span></th></tr></thead><tbody><tr><td>{{formData.investmentModeData.installment1}}%</td><td><span class=grey-text>(I) </span>{{formData.investmentModeData.stage1}}</td></tr><tr><td>{{formData.investmentModeData.installment2}}%</td><td><span class=grey-text>(II) </span>{{formData.investmentModeData.stage2}}</td></tr><tr><td>{{formData.investmentModeData.installment3}}%</td><td><span class=grey-text>(III) </span>{{formData.investmentModeData.stage3}}</td></tr><tr><td>{{formData.investmentModeData.installment4}}%</td><td><span class=grey-text>(IV) </span>{{formData.investmentModeData.stage4}}</td></tr></tbody></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label></div><div class=tc-block ng-show=showTerms><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=content-foot><div><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!formData ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div>");
$templateCache.put("app/transactions/summary/directive/summary.flexsip.html","<section class=\"initiate-transaction redemption sip-topup\"><div class=summary><p class=page-title>REVIEW TRANSACTION : Flex SIP</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=formData.isThroughRia>{{formData.riaBrokerCode}}</td><td ng-if=!formData.riaBrokerCode>N/A</td></tr><tr ng-if=formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=formData.riaBrokerName>{{formData.riaBrokerName}}</td><td ng-if=!formData.riaBrokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"formData.isThroughDistributor && formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>Flex SIP</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption}}</td></tr><tr ng-if=\"formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td><span ng-if=\"formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.sipDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td><span><i class=rupee-small-icon></i> {{formData.amount}}</span><br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr><td>Installment Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr><td>Start Date</td><td>:</td><td>{{formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Flex SIP Tenure</td><td>:</td><td>{{formData.tenure}} years</td></tr><tr><td>End Date</td><td>:</td><td>{{formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"formData.flexSipPaymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"formData.flexSipPaymentOption ==\'OTM\'\">OTM (One Time Mandate)</td><td ng-if=\"formData.flexSipPaymentOption == \'E-mandate\'\">E-mandate</td></tr><tr ng-if=\"formData.flexSipPaymentOption != \'E-mandate\'\"><td>Bank Name</td><td>:</td><td>{{formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"(formData.bankInfo.bankName==\'HDFC BANK\' && formData.flexSipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{formData.bankAcNo}}</td></tr><tr ng-if=\"formData.flexSipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{formData.bankInfo.omUmrn}}</td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=formData.inSchemeName></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr><tr ng-if=formData.sipFirstInstallment><td>Flex SIP First Installment</td><td>:</td><td ng-bind=\"formData.sipFirstInstallment?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.sipFirstAmount><td>Flex SIP First Installment Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.sipFirstAmount}}</td></tr></table></div><div class=col-md-6><table class=\"borderless table\"><tr><td class=eMandateReview>Email ID</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td class=eMandateReview>Mobile Number</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table><table class=\"borderless table\" ng-if=\"formData.flexSipPaymentOption == \'E-mandate\'\"><tr ng-if=\"formData.flexSipPaymentOption == \'E-mandate\'\"><td style=\"color: black\"><u><strong>Emandate Registration Details</strong></u></td></tr><tr><td class=eMandateReview>Bank Name</td><td class=eMandateRow>:</td><td>{{formData.bankInfo.bankName.substring(0,formData.bankInfo.bankName.indexOf(\"-\"))}}</td></tr><tr><td class=eMandateReview>Account Number</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.bankInfo.accountNumber}}</td></tr><tr><td class=eMandateReview>Amount</td><td class=eMandateRow>:</td><td><i class=rupee-small-icon></i> {{formData.emandateAmount}}<br><label id=amountInwordsEmandateSummary>{{emandateAmountDetails.amountInWords}} (In Words)</label></td></tr><tr><td class=eMandateReview>Frequency</td><td class=eMandateRow>:</td><td>As and when presented</td></tr><tr><td class=eMandateReview>Authentication Mode</td><td class=eMandateRow>:</td><td>{{formData.authMode.text}}</td></tr><tr><td class=eMandateReview>Start Date</td><td class=eMandateRow>:</td><td>{{formData.emandateDate}}</td></tr><tr><td class=eMandateReview>End Date</td><td class=eMandateRow>:</td><td>{{formData.endDateEmandate}}</td></tr><tr><td class=eMandateReview>Purpose of Mandate</td><td class=eMandateRow>:</td><td>Mutual Fund Payment</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label></div><div class=tc-block><h6 ng-if=showTerms>Terms & Conditions</h6><div ng-show=showTerms><div class=checkbox><input id=isCheckedTandC ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div></div><div ng-if=\"formData.flexSipPaymentOption == \'E-mandate\'\" ng-show=showTermsEmandate><br><div class=checkbox><input id=isCheckedTandCeMandate ng-model=isCheckedTandCeMandate type=checkbox ng-change=ischeckedem()> <i class=icon-checkbox></i><label for=isCheckedTandCeMandate class=checkbox-text>I have read and understood <a ng-click=showTermConditionsemandate() href=javaScript:void(0)>Terms & Conditions</a> of e-mandate (eOTM)</label></div></div></div><ng-bind-html dynamic=notes></ng-bind-html><div class=content-foot ng-if=\"formData.flexSipPaymentOption !== \'E-mandate\'\"><input type=hidden id=hfReq><div><span ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span> <button blur-on-click ng-disabled=\"!isCheckedTandC|| !formData\" ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div><div class=content-foot ng-if=\"formData.flexSipPaymentOption == \'E-mandate\'\"><input type=hidden id=hfReq><div><span ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span> <button blur-on-click ng-disabled=\"!isCheckedTandC || !isCheckedTandCeMandate || !formData\" ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div><style>.checkbox label{padding-left: 0}\n\n    div i.dot {\n      display: inline-block;\n      position: relative;\n      top: -2px;\n      height: 6px;\n      margin-right: 10px;\n      width: 6px;\n      background: #d92018;\n    }\n\n\n    .info {\n      font-weight: normal;\n      font-size: 12px;\n    }\n\n    .info p {\n      margin-top : 0px !important;\n      margin-bottom: 0px !important;\n    }\n\n    .info span {\n      display: inline-block;\n      vertical-align: top;\n    }</style></section>");
$templateCache.put("app/transactions/summary/directive/summary.flexstp.html","<div class=summary ng-init=init()><p class=page-title>REVIEW TRANSACTION : FLEX STP</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.formType}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr><td>Target Scheme</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption | camelcase}}</td></tr><tr ng-if=\"formData.investmentOption.toUpperCase() != TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>IDCW Option</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.dividendOption]}}</td></tr><tr><td>STP Type</td><td>:</td><td>Flex</td></tr><tr><td>STP Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{formData.amount}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr ng-if=formData.subBrokerARN><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=formData.subBrokerCode><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr><td>Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr ng-if=\"formData.frequency === \'DZ\'\"><td>No of Installments</td><td>:</td><td>{{formData.noOfInstallments}}</td></tr><tr ng-if=\"formData.frequency === \'OW\'\"><td>Day of Transfer</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.WEEK_DAYS[formData.day]}}</td></tr><tr ng-if=formData.startDate><td>Start Date</td><td>:</td><td>{{formData.startDate && formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr ng-if=formData.endDate><td>End Date</td><td>:</td><td>{{formData.endDate && formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label></div><div class=tc-block ng-show=showTermsFlex><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=content-foot><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!formData ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div><!--TODO for HMF-7667-->");
$templateCache.put("app/transactions/summary/directive/summary.html","<div class=\"main-section clearfix initiate\"><div class=email-view><div data-ng-switch=transactionType><div data-ng-switch-when=DTP><div data-ng-include=\"\'app/transactions/summary/directive/summary.dtp.html\'\"></div></div><div data-ng-switch-when=STP><div data-ng-include=\"\'app/transactions/summary/directive/summary.stp.html\'\"></div></div><div data-ng-switch-when=FlexSTP><div data-ng-include=\"\'app/transactions/summary/directive/summary.flexstp.html\'\"></div></div><div data-ng-switch-when=SwingSTP><div data-ng-include=\"\'app/transactions/summary/directive/summary.swingstp.html\'\"></div></div><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/transactions/summary/directive/summary.purchase.sip.html\'\"></div></div><div data-ng-switch-when=SWP><div data-ng-include=\"\'app/transactions/summary/directive/summary.swp.html\'\"></div></div><div data-ng-switch-when=REDEMPTION><div data-ng-include=\"\'app/transactions/summary/directive/summary.redeem.html\'\"></div></div><div data-ng-switch-when=SWITCH><div data-ng-include=\"\'app/transactions/summary/directive/summary.switch.html\'\"></div></div><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/transactions/summary/directive/summary.purchase.sip.html\'\"></div></div><div data-ng-switch-when=FLEX_INDEX><div data-ng-include=\"\'app/transactions/summary/directive/summary.flexindex.html\'\"></div></div><div data-ng-switch-when=INSTANT_REDEMPTION><div data-ng-include=\"\'app/transactions/summary/directive/summary.instant-redeem.html\'\"></div></div><div data-ng-switch-when=SCHEDULE_TRANSACTION_PURCHASE><div data-ng-include=\"\'app/transactions/summary/directive/summary.schedule-transaction.html\'\"></div></div><div data-ng-switch-when=SCHEDULE_TRANSACTION_SWITCH><div data-ng-include=\"\'app/transactions/summary/directive/summary.schedule-transaction.html\'\"></div></div><div data-ng-switch-when=SCHEDULE_TRANSACTION_REDEMPTION><div data-ng-include=\"\'app/transactions/summary/directive/summary.schedule-transaction.html\'\"></div></div><div data-ng-switch-when=SMART_SWAP><div data-ng-include=\"\'app/transactions/summary/directive/summary.smart.swp.html\'\"></div></div><div data-ng-switch-when=DREAM_SIP><div data-ng-include=\"\'app/transactions/summary/directive/summary.dream-sip.html\'\"></div></div><div data-ng-switch-when=FLEXSIP><div data-ng-include=\"\'app/transactions/summary/directive/summary.flexsip.html\'\"></div></div></div></div></div>");
$templateCache.put("app/transactions/summary/directive/summary.instant-redeem.html","<div class=summary ng-init=init()><p class=page-title>REVIEW TRANSACTION : INSTANT ACCESS FACILITY</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>Instant Access Facility</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr ng-if=formData.amount><td>Redemption Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=formData.units><td>Redemption Units</td><td>:</td><td>{{formData.units}}</td></tr><tr><td>Bank Name</td><td>:</td><td>{{formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{formData.bankInfo.accountNo}}</td></tr><tr><td>Branch</td><td>:</td><td>{{formData.bankInfo.branchName}}</td></tr><tr><td>IFSC</td><td>:</td><td>{{formData.bankInfo.ifscCode}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr><td>Email ID</td><td>:</td><td>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td>{{formData.mobileNumber}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email and SMS will be sent to above contact details registered in the folio.</label></div><div ng-show=\"formData.outSchemeName.toLowerCase().includes(\'hdfc liquid fund\')\"><label style=\"padding: 8px 0px 0px 20px; display: block\">Exit Load would be applicable as per SEBI Circular \"SEBI/HO/IMD/DF2/CIR/P/2019/101\" dated September 20, 2019. <a href=https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf target=_blank>Click here</a> to know more</label></div><div class=tc-block><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=content-foot><div><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!formData ng-click=submitInstantRedeemFirst($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div>");
$templateCache.put("app/transactions/summary/directive/summary.purchase.sip.html","<section class=\"initiate-transaction redemption sip-topup\" ng-if=\"formData.modifyAction !== \'modifySip\'\"><div class=summary><p class=page-title ng-if=\"transactionType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\">REVIEW TRANSACTION : PURCHASE INVESTMENT</p><p class=page-title ng-if=\"transactionType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\">REVIEW TRANSACTION : SYSTEMATIC INVESTMENT PLAN REGISTRATION</p><div class=content-area><div class=row><div class=col-md-6 ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\"><table class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=formData.isThroughRia>{{formData.riaBrokerCode}}</td><td ng-if=!formData.riaBrokerCode>N/A</td></tr><tr ng-if=formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=formData.riaBrokerName>{{formData.riaBrokerName}}</td><td ng-if=!formData.riaBrokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"formData.isThroughDistributor && formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode?formData.euin.euinCode:\'N/A\'}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName?formData.euin.euinName:\'N/A\'}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.investmentType|camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{formData.purchaseInSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.purchaseInvestmentOption}}</td></tr><tr ng-if=\"formData.purchaseInvestmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td><span ng-if=\"formData.purchaseInvestmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.purchaseDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.purchaseAmount}}<br><label id=purchaseAmountInWord>{{formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td>:</td><td ng-bind=\"formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td>:</td><td ng-bind=formData.inSchemeName></td></tr><tr ng-if=\"formData.checkedNfoAutoSwitch && formData.switchSchemeInvestmentOption==\'DIVIDEND\'\"><td>Auto Switch Scheme IDCW Option:</td><td>:</td><td ng-bind=\"formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table></div><div class=col-md-6 ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"><table class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=formData.isThroughRia>{{formData.riaBrokerCode}}</td><td ng-if=!formData.riaBrokerCode>N/A</td></tr><tr ng-if=formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=formData.riaBrokerName>{{formData.riaBrokerName}}</td><td ng-if=!formData.riaBrokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"formData.isThroughDistributor && formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.investmentType}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption}}</td></tr><tr ng-if=\"formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td><span ng-if=\"formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.sipDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr><td>Installment Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr ng-if=\"formData.frequency == \'OW\'\"><td>SIP Day</td><td>:</td><td>{{formData.weeklyDay}}</td></tr><tr><td>Start Date</td><td>:</td><td>{{formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>End Date</td><td>:</td><td>{{formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"formData.sipPaymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"formData.sipPaymentOption ==\'OTM\'\">OTM (One Time Mandate)</td><td ng-if=\"formData.sipPaymentOption == \'E-mandate\'\">E-mandate</td><td ng-if=\"formData.sipPaymentOption == \'UPI\'\">UPI Autopay</td></tr><tr ng-if=\"formData.sipPaymentOption == \'UPI\'\"><td>Virtual Payment Address (UPI ID)</td><td>:</td><td>{{formData.virtualAddress}}</td></tr><tr ng-if=\"formData.sipPaymentOption != \'E-mandate\'\"><td>Bank Name</td><td>:</td><td>{{formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"(formData.bankInfo.bankName==\'HDFC BANK\' && formData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{formData.bankAcNo}}</td></tr><tr ng-if=\"formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{formData.bankInfo.omUmrn}}</td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=formData.inSchemeName></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr><tr ng-if=formData.sipFirstInstallment><td>SIP First Installment</td><td>:</td><td ng-bind=\"formData.sipFirstInstallment?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.sipFirstAmount><td>SIP First Installment Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.sipFirstAmount}}</td></tr></table></div><div class=col-md-6 ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"><table class=\"borderless table\"><tr ng-if=formData.sipTopupEnabled><td>SIP Topup Enabled</td><td>:</td><td>Yes</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.amount\"><td>SIP Topup Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.topupDetails.amount}}<br><label>{{formData.topupDetails.topUpamountInwords}} (In Words)</label></td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.percentage\"><td>SIP Topup Percentage</td><td>:</td><td>{{formData.topupDetails.percentage}}%</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.frequency\"><td>SIP Topup Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.topupDetails.frequency]}}</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.capAmount\"><td>SIP Topup Cap Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.topupDetails.capAmount}}<br><label>{{formData.topupDetails.topUpCapamountInwords}} (In Words)</label></td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.capMonthYear\"><td style=\"width: 200px\">SIP Topup Cap Month/Year</td><td>:</td><td>{{capMonthYear}}</td></tr><tr><td class=eMandateReview>Email ID</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td class=eMandateReview>Mobile Number</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table><table class=\"borderless table\" ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><tr ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><td style=\"color: black\"><u><strong>Emandate Registration Details</strong></u></td></tr><tr><td class=eMandateReview>Bank Name</td><td class=eMandateRow>:</td><td>{{formData.bankInfo.bankName.substring(0,formData.bankInfo.bankName.indexOf(\"-\"))}}</td></tr><tr><td class=eMandateReview>Account Number</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.bankInfo.accountNumber}}</td></tr><tr><td class=eMandateReview>Amount</td><td class=eMandateRow>:</td><td><i class=rupee-small-icon></i> {{formData.emandateAmount}}<br><label id=amountInwordsEmandateSummary>{{emandateAmountDetails.amountInWords}} (In Words)</label></td></tr><tr><td class=eMandateReview>Frequency</td><td class=eMandateRow>:</td><td>As and when presented</td></tr><tr><td class=eMandateReview>Authentication Mode</td><td class=eMandateRow>:</td><td>{{formData.authMode.text}}</td></tr><tr><td class=eMandateReview>Start Date</td><td class=eMandateRow>:</td><td>{{formData.emandateDate}}</td></tr><tr><td class=eMandateReview>End Date</td><td class=eMandateRow>:</td><td>{{formData.endDateEmandate}}</td></tr><tr><td class=eMandateReview>Purpose of Mandate</td><td class=eMandateRow>:</td><td>Mutual Fund Payment</td></tr></table></div><div class=col-md-6 ng-if=\"formData.summaryType === \'SIP_TOPUP\'\"><table class=\"table borderless\"><tr><td>Folio Number</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{TRANSACTIONS_CONST.TRANSACTION_TYPE[formData.summaryType]}}</td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr><td>Installment Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr><td>Sip End Date</td><td>:</td><td>{{formData.toDate}}</td></tr><tr ng-if=formData.topupAmount><td>Topup Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.topupAmount}}</td></tr><tr ng-if=formData.topupPercentage><td>Topup Percentage</td><td>:</td><td>{{formData.topupPercentage}}%</td></tr><tr><td>Topup Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.topupFrequency]}}</td></tr><tr ng-if=formData.topupCapAmount><td>Topup Cap-Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.topupCapAmount}}</td></tr><tr ng-if=formData.topupCapMonthYear><td>Topup Cap-Date</td><td>:</td><td>{{Summary.sipTopupCapMonthYear}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"formData.bankDetailsForECS.paymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"formData.bankDetailsForECS.paymentOption ==\'OTM\'\">OTM (One Time Mandate)</td></tr><tr><td>Bank Name</td><td>:</td><td>{{formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"(formData.bankInfo.bankName==\'HDFC BANK\' && formData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{formData.bankAcNo}}</td></tr><tr ng-if=\"formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{formData.bankInfo.omUmrn}}</td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=formData.inSchemeName></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table></div><div class=col-md-6 ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\"><table class=\"table borderless\"><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\" ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label><label style=\"padding: 25px 0px 0px 20px; display: block\" ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\">Transaction acknowledgement email and SMS will be sent to above contact details registered in the folio.</label></div><div class=tc-block><h6 ng-if=showTerms>Terms & Conditions</h6><div ng-show=showTerms><div class=checkbox><input id=isCheckedTandC ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div></div><div ng-if=\"formData.sipPaymentOption == \'E-mandate\'\" ng-show=showTermsEmandate><br><div class=checkbox><input id=isCheckedTandCeMandate ng-model=isCheckedTandCeMandate type=checkbox ng-change=ischeckedem()> <i class=icon-checkbox></i><label for=isCheckedTandCeMandate class=checkbox-text>I have read and understood <a ng-click=showTermConditionsemandate() href=javaScript:void(0)>Terms & Conditions</a> of e-mandate (eOTM)</label></div></div></div><ng-bind-html dynamic=notes></ng-bind-html><div class=content-foot ng-if=\"formData.sipPaymentOption !== \'E-mandate\'\"><input type=hidden id=hfReq><div><span ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span> <button blur-on-click ng-disabled=\"!isCheckedTandC|| !formData\" ng-click=submitForm($event) ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\" class=\"btn-primary-action btn pull-right\">Complete Transaction</button> <button blur-on-click ng-disabled=\"!isCheckedTandC|| !formData\" ng-click=finishPurchaseFirst($event) ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\" class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div><div class=content-foot ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><input type=hidden id=hfReq><div><span ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span> <button blur-on-click ng-disabled=\"!isCheckedTandC || !isCheckedTandCeMandate || !formData\" ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div><style>.checkbox label{padding-left: 0}\n\n     div i.dot {\n      display: inline-block;\n      position: relative;\n      top: -2px;\n      height: 6px;\n      margin-right: 10px;\n      width: 6px;\n      background: #d92018;\n    }\n\n\n    .info {\n      font-weight: normal;\n      font-size: 12px;\n    }\n\n    .info p {\n      margin-top : 0px !important;\n      margin-bottom: 0px !important;\n    }\n\n    .info span {\n      display: inline-block;\n      vertical-align: top;\n    }</style></section><section class=\"initiate-transaction redemption sip-topup modified-section\" ng-if=\"formData.modifyAction == \'modifySip\'\"><div class=summary><p class=page-title ng-if=\"transactionType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\">REVIEW TRANSACTION : SYSTEMATIC INVESTMENT PLAN REGISTRATION</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr><td>Folio Number</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td class=eMandateReview>Email ID</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td class=eMandateReview>Mobile Number</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.investmentType}}</td></tr></table></div></div><div class=row style=\"padding-top: 10px\"><div class=bd-top-modified></div><div class=col-md-6><p class=modified-details>Cancelled Details:</p><table class=\"table borderless\" ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"><tr ng-if=oldSipSystematicData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=oldSipSystematicData.isThroughDistributor>{{oldSipSystematicData.brokerCode?\'ARN-\'+oldSipSystematicData.brokerCode:(oldSipSystematicData.distributorARN?oldSipSystematicData.distributorARN:\'\')}}</td><td ng-if=!oldSipSystematicData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=oldSipSystematicData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=oldSipSystematicData.isThroughRia>{{oldSipSystematicData.riaBrokerCode}}</td><td ng-if=!oldSipSystematicData.riaBrokerCode>N/A</td></tr><tr ng-if=oldSipSystematicData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=oldSipSystematicData.riaBrokerName>{{oldSipSystematicData.riaBrokerName}}</td><td ng-if=!oldSipSystematicData.riaBrokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"oldSipSystematicData.isThroughDistributor && oldSipSystematicData.isEuin && oldSipSystematicData.euinCode\"><td>EUIN Code</td><td>:</td><td>{{oldSipSystematicData.euinCode}}</td></tr><tr ng-if=\"oldSipSystematicData.isThroughDistributor && oldSipSystematicData.isEuin && oldSipSystematicData.euinName\"><td>EUIN Name</td><td>:</td><td>{{oldSipSystematicData.euinName}}</td></tr><tr ng-if=\"formData.isThroughDistributor && oldSipSystematicData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+oldSipSystematicData.subBrokerARN}}</td></tr><tr ng-if=\"formData.isThroughDistributor && oldSipSystematicData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td>{{oldSipSystematicData.subBrokerCode}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{oldSipSystematicData.inSchemeName}}</td></tr><tr ng-if=oldSipSystematicData.investmentOption><td>Investment Option</td><td>:</td><td>{{oldSipSystematicData.investmentOption}}</td></tr><tr ng-if=\"oldSipSystematicData.dividendOption && oldSipSystematicData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td><span ng-if=\"oldSipSystematicData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{TRANSACTIONS_CONST.DESCRIPTIONS[oldSipSystematicData.sipDividendOption]}}</span></td></tr><tr ng-if=oldSipSystematicData.amount><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{oldSipSystematicData.amount}}<br><label id=amountInwords>{{oldSipSystematicData.amountInWords}} (In Words)</label></td></tr><tr ng-if=oldSipSystematicData.frequency><td>Installment Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[oldSipSystematicData.frequency]}}</td></tr><tr ng-if=\"oldSipSystematicData.frequency == \'OW\' && oldSipSystematicData.weeklyDay\"><td>SIP Day</td><td>:</td><td>{{oldSipSystematicData.weeklyDay}}</td></tr><tr ng-if=oldSipSystematicData.startDate><td>Start Date</td><td>:</td><td>{{oldSipSystematicData.startDate}}</td></tr><tr ng-if=oldSipSystematicData.endDate><td>End Date</td><td>:</td><td>{{oldSipSystematicData.endDate}}</td></tr><tr ng-if=oldSipSystematicData.sipPaymentOption><td>Payment Option</td><td>:</td><td ng-if=\"oldSipSystematicData.sipPaymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"oldSipSystematicData.sipPaymentOption ==\'OTM\'\">OTM (One Time Mandate)</td><td ng-if=\"oldSipSystematicData.sipPaymentOption == \'E-mandate\'\">E-mandate</td></tr><tr ng-if=oldSipSystematicData.bankInfo.bankName><td>Bank Name</td><td>:</td><td ng-if=oldSipSystematicData.bankInfo.bankName>{{oldSipSystematicData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=oldSipSystematicData.bankInfo.bankAcNo><td>Account Number</td><td>:</td><td>{{oldSipSystematicData.bankInfo.bankAcNo}}</td></tr><tr ng-if=\"oldSipSystematicData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{oldSipSystematicData.bankInfo.omUmrn}}</td></tr><tr ng-if=oldSipSystematicData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"oldSipSystematicData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=oldSipSystematicData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=oldSipSystematicData.inSchemeName></td></tr><tr ng-if=oldSipSystematicData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"oldSipSystematicData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr><tr ng-if=oldSipSystematicData.sipFirstInstallment><td>SIP First Installment</td><td>:</td><td ng-bind=\"oldSipSystematicData.sipFirstInstallment?\'Yes\':\'No\'\"></td></tr><tr ng-if=oldSipSystematicData.sipFirstAmount><td>SIP First Installment Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{oldSipSystematicData.sipFirstAmount}}</td></tr></table><table class=\"borderless table\"><tr ng-if=!oldSipSystematicData.sipTopupEnabled><td>SIP Topup Enabled</td><td>:</td><td>No</td></tr><tr ng-if=oldSipSystematicData.sipTopupEnabled><td>SIP Topup Enabled</td><td>:</td><td>Yes</td></tr><tr ng-if=\"oldSipSystematicData.sipTopupEnabled && oldSipSystematicData.topupDetails.amount\"><td>SIP Topup Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{oldSipSystematicData.topupDetails.amount}}<br><label id=topUpamountInwords>{{formData.topupDetails.oldTopUpamountInwords}} (In Words)</label></td></tr><tr ng-if=\"oldSipSystematicData.sipTopupEnabled && oldSipSystematicData.topupDetails.percentage\"><td>SIP Topup Percentage</td><td>:</td><td>{{oldSipSystematicData.topupDetails.percentage}}%</td></tr><tr ng-if=\"oldSipSystematicData.sipTopupEnabled && oldSipSystematicData.topupDetails.frequency\"><td>SIP Topup Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[oldSipSystematicData.topupDetails.frequency]}}</td></tr><tr ng-if=\"oldSipSystematicData.sipTopupEnabled && oldSipSystematicData.topupDetails.capAmount\"><td>SIP Topup Cap Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{oldSipSystematicData.topupDetails.capAmount}}<br><label id=topUpCapamountInwords>{{formData.topupDetails.oldtopUpCapamountInwords}} (In Words)</label></td></tr><tr ng-if=\"oldSipSystematicData.sipTopupEnabled && oldSipSystematicData.topupDetails.capMonthYear\"><td style=\"width: 200px\">SIP Topup Cap Month/Year</td><td>:</td><td>{{capMonthYear}}</td></tr><tr><td class=eMandateReview></td><td class=eMandateRow></td><td easyassist-key=mask-element></td></tr><tr><td class=eMandateReview></td><td class=eMandateRow></td><td easyassist-key=mask-element></td></tr></table><table class=\"table borderless\" ng-if=\"oldSipSystematicData.summaryType === \'SIP_TOPUP\'\"><tr><td>Folio Number</td><td>:</td><td>{{oldSipSystematicData.folioNumber}}</td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{oldSipSystematicData.amount}}<br><label id=amountInwords>{{oldSipSystematicData.amountInWords}} (In Words)</label></td></tr><tr><td>Installment Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[oldSipSystematicData.frequency]}}</td></tr><tr><td>Sip End Date</td><td>:</td><td>{{oldSipSystematicData.toDate}}</td></tr><tr ng-if=oldSipSystematicData.topupAmount><td>Topup Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{oldSipSystematicData.topupAmount}}</td></tr><tr ng-if=formData.topupPercentage><td>Topup Percentage</td><td>:</td><td>{{oldSipSystematicData.topupPercentage}}%</td></tr><tr><td>Topup Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.topupFrequency]}}</td></tr><tr ng-if=oldSipSystematicData.topupCapAmount><td>Topup Cap-Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{oldSipSystematicData.topupCapAmount}}</td></tr><tr ng-if=oldSipSystematicData.topupCapMonthYear><td>Topup Cap-Date</td><td>:</td><td>{{oldSipSystematicData.sipTopupCapMonthYear}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"oldSipSystematicData.bankDetailsForECS.paymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"oldSipSystematicData.bankDetailsForECS.paymentOption ==\'OTM\'\">OTM (One Time Mandate)</td></tr><tr><td>Bank Name</td><td>:</td><td>{{oldSipSystematicData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"(oldSipSystematicData.bankInfo.bankName==\'HDFC BANK\' && oldSipSystematicData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td>{{oldSipSystematicData.bankAcNo}}</td></tr><tr ng-if=\"oldSipSystematicData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{oldSipSystematicData.bankInfo.omUmrn}}</td></tr><tr ng-if=oldSipSystematicData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"oldSipSystematicData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=oldSipSystematicData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=oldSipSystematicData.inSchemeName></td></tr><tr ng-if=oldSipSystematicData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"oldSipSystematicData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table></div><div class=\"col-md-6 modified-border-left\"><p class=modified-details>Modified Details:</p><table class=\"table borderless\" ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor ng-class=\"{modifedValue : formData.distributorARN!== oldSipSystematicData.distributorARN}\">{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=formData.isThroughRia ng-class=\"{modifedValue :formData.isThroughRia !==oldSipSystematicData.isThroughRia}\">{{formData.riaBrokerCode}}</td><td ng-if=!formData.riaBrokerCode>N/A</td></tr><tr ng-if=formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=formData.riaBrokerName ng-class=\"{modifedValue :formData.riaBrokerName !==oldSipSystematicData.riaBrokerName}\">{{formData.riaBrokerName}}</td><td ng-if=!formData.riaBrokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"formData.isThroughDistributor && formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td ng-class=\"{modifedValue :formData.euin.euinCode !==oldSipSystematicData.euinCode}\">{{formData.euin.euinCode}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td ng-class=\"{modifedValue :formData.euin.euinName !==oldSipSystematicData.euinName}\">{{formData.euin.euinName}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td ng-class=\"{modifedValue :formData.subBrokerARN !==oldSipSystematicData.subBrokerARN}\">{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=\"formData.isThroughDistributor && formData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td ng-class=\"{modifedValue :formData.subBrokerCode !==oldSipSystematicData.subBrokerCode}\">{{formData.subBrokerCode}}</td></tr><tr><td>Scheme Name</td><td>:</td><td ng-class=\"{modifedValue :formData.inSchemeName !==oldSipSystematicData.inSchemeName}\">{{formData.inSchemeName}}</td></tr><tr ng-if=oldSipSystematicData.investmentOption><td>Investment Option</td><td>:</td><td ng-class=\"{modifedValue :formData.investmentOption !==oldSipSystematicData.investmentOption}\">{{formData.investmentOption}}</td></tr><tr ng-if=\"formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td ng-class=\"{modifedValue:formData.sipDividendOption !== oldSipSystematicData.dividendOption}\"><span ng-if=\"formData.investmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.sipDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td ng-class=\"{modifedValue :formData.amount !==oldSipSystematicData.amount}\"><i class=rupee-small-icon></i> {{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr><td>Installment Frequency</td><td>:</td><td ng-class=\"{modifedValue :formData.frequency !==oldSipSystematicData.frequency}\">{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr ng-if=\"formData.frequency == \'OW\'\"><td>SIP Day</td><td>:</td><td ng-class=\"{modifedValue :formData.weeklyDay !==oldSipSystematicData.weeklyDay}\">{{formData.weeklyDay}}</td></tr><tr><td>Start Date</td><td>:</td><td ng-class=\"{modifedValue :formData.startDate.format(\'DD-MMM-YYYY\') !==oldSipSystematicData.startDate}\">{{formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>End Date</td><td>:</td><td ng-class=\"{modifedValue :formData.endDate.format(\'DD-MMM-YYYY\') !==oldSipSystematicData.endDate}\">{{formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-if=\"formData.sipPaymentOption ==\'EC\'\" ng-class=\"{modifedValue :formData.sipPaymentOption !==oldSipSystematicData.sipPaymentOption}\">Standing Instruction/Biller</td><td ng-if=\"formData.sipPaymentOption ==\'OTM\'\" ng-class=\"{modifedValue :formData.sipPaymentOption !==oldSipSystematicData.sipPaymentOption}\">OTM (One Time Mandate)</td><td ng-if=\"formData.sipPaymentOption == \'E-mandate\'\" ng-class=\"{modifedValue :formData.sipPaymentOption !==oldSipSystematicData.sipPaymentOption}\">E-mandate</td></tr><tr><td>Bank Name</td><td>:</td><td ng-class=\"{modifedValue :formData.bankInfo.bankName !==oldSipSystematicData.bankInfo.bankName}\">{{formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=formData.bankInfo.accountNumber><td>Account Number</td><td>:</td><td ng-class=\"{modifedValue :formData.bankInfo.accountNumber !==oldSipSystematicData.bankInfo.bankAcNo}\">{{formData.bankInfo.accountNumber}}</td></tr><tr ng-if=formData.bankInfo.bankAcNo><td>Account Number</td><td>:</td><td ng-class=\"{modifedValue :formData.bankInfo.bankAcNo !==oldSipSystematicData.bankInfo.bankAcNo}\">{{formData.bankInfo.bankAcNo}}</td></tr><tr ng-if=\"formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td ng-class=\"{modifedValue :formData.bankInfo.omUmrn !==oldSipSystematicData.bankInfo.omUmrn}\">{{formData.bankInfo.omUmrn}}</td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-class=\"{modifedValue :formData.checkedNfoAutoSwitch !==oldSipSystematicData.checkedNfoAutoSwitch}\" ng-bind=\"formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-class=\"{modifedValue :formData.inSchemeName !==oldSipSystematicData.inSchemeName}\" ng-bind=formData.inSchemeName></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-class=\"{modifedValue :formData.switchDividendOption !==oldSipSystematicData.switchDividendOption}\" ng-bind=\"formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr><tr ng-if=formData.sipFirstInstallment><td>SIP First Installment</td><td>:</td><td ng-class=\"{modifedValue :formData.sipFirstInstallment !==oldSipSystematicData.sipFirstInstallment}\" ng-bind=\"formData.sipFirstInstallment?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.sipFirstAmount><td>SIP First Installment Amount</td><td>:</td><td ng-class=\"{modifedValue :formData.sipFirstAmount !==oldSipSystematicData.sipFirstAmount}\"><i class=rupee-small-icon></i> {{formData.sipFirstAmount}}</td></tr></table><table class=\"borderless table\"><tr ng-if=!formData.sipTopupEnabled><td>SIP Topup Enabled</td><td>:</td><td ng-class=\"{modifedValue :formData.sipTopupEnabled !==oldSipSystematicData.sipTopupEnabled}\">No</td></tr><tr ng-if=formData.sipTopupEnabled><td>SIP Topup Enabled</td><td>:</td><td ng-class=\"{modifedValue :formData.sipTopupEnabled !==oldSipSystematicData.sipTopupEnabled}\">Yes</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.amount\"><td>SIP Topup Amount</td><td>:</td><td ng-class=\"{modifedValue :formData.topupDetails.amount !==oldSipSystematicData.topupDetails.amount}\"><i class=rupee-small-icon></i> {{formData.topupDetails.amount}}<br><label>{{formData.topupDetails.topUpamountInwords}} (In Words)</label></td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.percentage\"><td>SIP Topup Percentage</td><td>:</td><td ng-class=\"{modifedValue :formData.topupDetails.percentage !==oldSipSystematicData.topupDetails.percentage}\">{{formData.topupDetails.percentage}}%</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.frequency\"><td>SIP Topup Frequency</td><td>:</td><td ng-class=\"{modifedValue :formData.topupDetails.frequency !== oldSipSystematicData.topupDetails.frequency}\">{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.topupDetails.frequency]}}</td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.capAmount\"><td>SIP Topup Cap Amount</td><td>:</td><td ng-class=\"{modifedValue :formData.topupDetails.capAmount !== oldSipSystematicData.topupDetails.capAmount}\"><i class=rupee-small-icon></i> {{formData.topupDetails.capAmount}}<br><label>{{formData.topupDetails.topUpCapamountInwords}} (In Words)</label></td></tr><tr ng-if=\"formData.sipTopupEnabled && formData.topupDetails.capMonthYear\"><td style=\"width: 200px\">SIP Topup Cap Month/Year</td><td>:</td><td ng-class=\"{modifedValue :formData.topupDetails.capMonthYear !== oldSipSystematicData.topupDetails.capMonthYear}\">{{capMonthYear}}</td></tr><tr><td class=eMandateReview></td><td class=eMandateRow></td><td easyassist-key=mask-element></td></tr><tr><td class=eMandateReview></td><td class=eMandateRow></td><td easyassist-key=mask-element></td></tr></table><table class=\"borderless table\" ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><tr ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><td style=\"color: black\"><u><strong>New Emandate Registration Details</strong></u></td></tr><tr><td class=eMandateReview>Bank Name</td><td class=eMandateRow>:</td><td>{{formData.bankInfo.bankName.substring(0,formData.bankInfo.bankName.indexOf(\"-\"))}}</td></tr><tr><td class=eMandateReview>Account Number</td><td class=eMandateRow>:</td><td easyassist-key=mask-element>{{formData.bankInfo.accountNumber}}</td></tr><tr><td class=eMandateReview>Amount</td><td class=eMandateRow>:</td><td><i class=rupee-small-icon></i> {{formData.emandateAmount}}<br><label id=amountInwordsEmandateSummary>{{emandateAmountDetails.amountInWords}} (In Words)</label></td></tr><tr><td class=eMandateReview>Frequency</td><td class=eMandateRow>:</td><td>As and when presented</td></tr><tr><td class=eMandateReview>Authentication Mode</td><td class=eMandateRow>:</td><td>{{formData.authMode.text}}</td></tr><tr><td class=eMandateReview>Start Date</td><td class=eMandateRow>:</td><td>{{formData.emandateDate}}</td></tr><tr><td class=eMandateReview>End Date</td><td class=eMandateRow>:</td><td>{{formData.endDateEmandate}}</td></tr><tr><td class=eMandateReview>Purpose of Mandate</td><td class=eMandateRow>:</td><td>Mutual Fund Payment</td></tr></table><table class=\"table borderless\" ng-if=\"formData.summaryType === \'SIP_TOPUP\'\"><tr><td>Folio Number</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{TRANSACTIONS_CONST.TRANSACTION_TYPE[formData.summaryType]}}</td></tr><tr><td>Amount</td><td>:</td><td ng-class=\"{modifedValue :formData.amount !== oldSipSystematicData.amount}\"><i class=rupee-small-icon></i> {{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr><td>Installment Frequency</td><td>:</td><td ng-class=\"{modifedValue :formData.frequency !== oldSipSystematicData.frequency}\">{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr><td>Sip End Date</td><td>:</td><td ng-class=\"{modifedValue :formData.toDate !== oldSipSystematicData.toDate}\">{{formData.toDate}}</td></tr><tr ng-if=formData.topupAmount><td>Topup Amount</td><td>:</td><td ng-class=\"{modifedValue :formData.topupAmount !== oldSipSystematicData.topupAmount}\"><i class=rupee-small-icon></i> {{formData.topupAmount}}</td></tr><tr ng-if=formData.topupPercentage><td>Topup Percentage</td><td>:</td><td ng-class=\"{modifedValue :formData.topupPercentage !== oldSipSystematicData.topupPercentage}\">{{formData.topupPercentage}}%</td></tr><tr><td>Topup Frequency</td><td>:</td><td ng-class=\"{modifedValue :formData.topupFrequency !== oldSipSystematicData.topupFrequency}\">{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.topupFrequency]}}</td></tr><tr ng-if=formData.topupCapAmount><td>Topup Cap-Amount</td><td>:</td><td ng-class=\"{modifedValue :formData.topupCapAmount !== oldSipSystematicData.topupCapAmount}\"><i class=rupee-small-icon></i> {{formData.topupCapAmount}}</td></tr><tr ng-if=formData.topupCapMonthYear><td>Topup Cap-Date</td><td>:</td><td ng-class=\"{modifedValue :formData.sipTopupCapMonthYear !== oldSipSystematicData.sipTopupCapMonthYear}\">{{Summary.sipTopupCapMonthYear}}</td></tr><tr><td>Payment Option</td><td>:</td><td ng-class=\"{modifedValue :formData.bankDetailsForECS.paymentOption !== oldSipSystematicData.bankDetailsForECS.paymentOption}\" ng-if=\"formData.bankDetailsForECS.paymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-class=\"{modifedValue :formData.bankDetailsForECS.paymentOption !== oldSipSystematicData.bankDetailsForECS.paymentOption}\" ng-if=\"formData.bankDetailsForECS.paymentOption ==\'OTM\'\">OTM (One Time Mandate)</td></tr><tr><td>Bank Name</td><td>:</td><td ng-class=\"{modifedValue :formData.bankInfo.bankName !== oldSipSystematicData.bankInfo.bankName}\">{{formData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=\"(formData.bankInfo.bankName==\'HDFC BANK\' && formData.sipPaymentOption ==\'EC\')\"><td>Account Number</td><td>:</td><td ng-class=\"{modifedValue :formData.bankAcNo !== oldSipSystematicData.bankAcNo}\">{{formData.bankAcNo}}</td></tr><tr ng-if=\"formData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td ng-class=\"{modifedValue :formData.bankInfo.omUmrn !== oldSipSystematicData.bankInfo.omUmrn}\">{{formData.bankInfo.omUmrn}}</td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-class=\"{modifedValue :formData.checkedNfoAutoSwitch !== oldSipSystematicData.checkedNfoAutoSwitch}\" ng-bind=\"formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-class=\"{modifedValue :formData.inSchemeName !== oldSipSystematicData.inSchemeName}\" ng-bind=formData.inSchemeName></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-class=\"{modifedValue :formData.switchDividendOption !== oldSipSystematicData.switchDividendOption}\" ng-bind=\"formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\" ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label></div><div class=tc-block><h6 ng-if=showTerms>Terms & Conditions</h6><div ng-show=showTerms><div class=checkbox><input id=isCheckedTandC ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div></div><div ng-if=\"formData.sipPaymentOption == \'E-mandate\'\" ng-show=showTermsEmandate><br><div class=checkbox><input id=isCheckedTandCeMandate ng-model=isCheckedTandCeMandate type=checkbox ng-change=ischeckedem()> <i class=icon-checkbox></i><label for=isCheckedTandCeMandate class=checkbox-text>I have read and understood <a ng-click=showTermConditionsemandate() href=javaScript:void(0)>Terms & Conditions</a> of e-mandate (eOTM)</label></div></div></div><ng-bind-html dynamic=notes></ng-bind-html><div class=content-foot ng-if=\"formData.sipPaymentOption !== \'E-mandate\'\"><input type=hidden id=hfReq><div><span ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span> <button blur-on-click ng-disabled=\"!isCheckedTandC|| !formData\" ng-click=submitForm($event) ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\" class=\"btn-primary-action btn pull-right\">Complete Transaction</button> <button blur-on-click ng-disabled=\"!isCheckedTandC|| !formData\" ng-click=finishPurchaseFirst($event) ng-if=\"formData.investmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE || formData.optionalInvestmentType === TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\" class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div><div class=content-foot ng-if=\"formData.sipPaymentOption == \'E-mandate\'\"><input type=hidden id=hfReq><div><span ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span> <button blur-on-click ng-disabled=\"!isCheckedTandC || !isCheckedTandCeMandate || !formData\" ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div><style>.checkbox label{padding-left: 0}\n\n    div i.dot {\n      display: inline-block;\n      position: relative;\n      top: -2px;\n      height: 6px;\n      margin-right: 10px;\n      width: 6px;\n      background: #d92018;\n    }\n\n\n    .info {\n      font-weight: normal;\n      font-size: 12px;\n    }\n\n    .info p {\n      margin-top : 0px !important;\n      margin-bottom: 0px !important;\n    }\n\n    .info span {\n      display: inline-block;\n      vertical-align: top;\n    }\n\n    .modified-border-right{\n      border-right: 1px solid #B4BDC4;\n    }\n    .modified-border-left{\n      border-left: 1px solid #B4BDC4;\n    }\n    .bd-top-modified{\n      border-top: 1px solid #B4BDC4;\n      width: 94%;\n      margin: auto;\n    }\n\n    .modified-details{\n      padding: 17px;\n      text-align: center;\n      text-decoration: underline;\n      font-weight: bold;\n    }\n\n    .modifedValue{\n      color: #47bc95 !important;\n      font-weight: 900;\n    }\n    .modified-section td {\n      width: 172px !important;\n    }</style></section>");
$templateCache.put("app/transactions/summary/directive/summary.redeem.html","<div class=summary ng-init=init()><p class=page-title>REVIEW TRANSACTION : REDEEM</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.formType| camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr ng-if=formData.amount><td>Redemption Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"formData.units && formData.amountType===TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td>Redemption Units</td><td>:</td><td>{{formData.units}}</td></tr><tr ng-if=\"formData.amountType===TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>All Free Units</td><td>:</td><td>Yes</td></tr><tr><td>Bank Name</td><td>:</td><td>{{formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{formData.bankInfo.bankAcNo}}</td></tr><tr><td>IFSC</td><td>:</td><td>{{formData.bankInfo.ifscCode}}</td></tr><tr><td>Payout</td><td>:</td><td>{{formData.bankInfo.payoutDescription | uppercase}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email and SMS will be sent to above contact details registered in the folio.</label></div><div ng-if=\"formData.liquidFlag===\'Y\' && !formData.outSchemeName.toLowerCase().includes(\'hdfc overnight fund\')\"><label style=\"padding: 8px 0px 0px 20px; display: block\">Exit Load would be applicable as per SEBI Circular \"SEBI/HO/IMD/DF2/CIR/P/2019/101\" dated September 20, 2019. <a href=https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf target=_blank>Click here</a> to know more</label></div><div class=tc-block ng-show=showTerms><h6 ng-click=redemptionConfirmModalShow()>Terms & Conditions</h6><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment.</span></div></div></div><div class=content-foot><div><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!formData ng-click=submitRedeemFirst($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div>");
$templateCache.put("app/transactions/summary/directive/summary.schedule-transaction.html","<section class=\"schedule initiate-transaction redemption sip-topup\"><div class=summary><p class=page-title>{{formData.scheduleDetails.transactionAction}} TRANSACTION : <span ng-if=\"formData.scheduleDetails.transactionAction == \'VIEW\' || formData.scheduleDetails.transactionAction == \'CANCEL\'\">Scheduled</span> <span ng-if=\"formData.scheduleDetails.transactionAction == \'REVIEW\'\">Schedule</span> {{formData.scheduleDetails.state|camelcase}}</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\" ng-if=\"formData.scheduleDetails.state === \'PURCHASE\' \"><!-- <tr ng-if=\"formData.isThroughDistributor\">\n                          <td>Distributor ARN</td>\n                          <td>:</td>\n                          <td ng-if=\"formData.isThroughDistributor\">\n                            {{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}\n                          </td>\n                          <td ng-if=\"!formData.isThroughDistributor\">N/A</td>\n                        </tr>\n                        <tr ng-if=\"formData.euin && formData.euin.euinCode\">\n                          <td>EUIN Code</td>\n                          <td>:</td>\n                          <td>{{formData.euin.euinCode?formData.euin.euinCode:\'N/A\'}}</td>\n                        </tr>\n                        <tr ng-if=\"formData.euin && formData.euin.euinName\">\n                          <td>EUIN Name</td>\n                          <td>:</td>\n                          <td>{{formData.euin.euinName?formData.euin.euinName:\'N/A\'}}</td>\n                        </tr>\n                        <tr ng-if=\"formData.subBrokerARN\">\n                          <td>Sub Broker ARN</td>\n                          <td>:</td>\n                          <td>{{\'ARN-\'+formData.subBrokerARN}}</td>\n                        </tr>\n                        <tr ng-if=\"formData.subBrokerCode\">\n                          <td>Sub Broker Code</td>\n                          <td>:</td>\n                          <td>{{formData.subBrokerCode}}</td>\n                        </tr> --><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.investmentType| camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{formData.purchaseInSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.purchaseInvestmentOption}}</td></tr><tr ng-if=\"formData.purchaseInvestmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td><span ng-if=\"formData.purchaseInvestmentOption===TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.purchaseDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.purchaseAmount}}<br><label id=purchaseAmountInWord>{{formData.amountInWords}} (In Words)</label></td></tr><tr><td>Scheduled Date <span ng-if=\"formData.scheduleDetails.transactionAction !== \'REVIEW\'\">*</span> <span ng-if=\"formData.scheduleDetails.transactionAction == \'REVIEW\'\">(s)*</span></td><td>:</td><td><span ng-if=formData.scheduleDetails.scheduleDate>{{formData.scheduleDetails.scheduleDate | dateformatter: \'DD-MMM-YYYY\'}}</span><!--\n                              --><span ng-if=formData.scheduleDetails.scheduleDates>, {{formData.scheduleDetails.scheduleDates}}</span></td></tr><tr ng-if=\"formData.scheduleDetails.transactionAction == \'REVIEW\'\"><td>Frequency</td><td>:</td><td>{{formData.scheduleDetails.frequency}}</td></tr><tr ng-if=formData.scheduleDetails.endDate><td>End Date</td><td>:</td><td>{{formData.scheduleDetails.endDate | dateformatter: \'DD-MMM-YYYY\'}}</td></tr></table><table class=\"table borderless\" ng-if=\"formData.scheduleDetails.state === \'SWITCH\' \"><!-- <tr ng-if=\"formData.isThroughDistributor\">\n                          <td>Distributor ARN</td>\n                          <td>:</td>\n                          <td ng-if=\"formData.isThroughDistributor\">{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td>\n                          <td ng-if=\"!formData.isThroughDistributor\">N/A</td>\n                        </tr>\n                        <tr ng-if=\"formData.subBrokerARN\">\n                          <td>Sub Broker ARN</td>\n                          <td>:</td>\n                          <td>{{\'ARN-\'+formData.subBrokerARN}}</td>\n                        </tr>\n                        <tr ng-if=\"formData.euin && formData.euin.euinName\">\n                          <td>EUIN Name</td>\n                          <td>:</td>\n                          <td>{{formData.euin.euinName}}</td>\n                        </tr> --><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.formType | camelcase}}</td></tr><tr><td>Switch Out Scheme</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr><td>Switch In Scheme</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption.toUpperCase() != TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? TRANSACTIONS_CONST.INVESTMENT_OPTIONS[formData.investmentOption]: (TRANSACTIONS_CONST.INVESTMENT_OPTIONS[formData.investmentOption] | camelcase)}}</td></tr><tr ng-if=\"formData.investmentOption.toUpperCase() != TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td style=\"width: 240px\">Target Scheme IDCW Option</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.dividendOption]}}</td></tr><tr><td>Scheduled Date <span ng-if=\"formData.scheduleDetails.transactionAction !== \'REVIEW\'\">*</span> <span ng-if=\"formData.scheduleDetails.transactionAction == \'REVIEW\'\">(s)*</span></td><td>:</td><td><span ng-if=formData.scheduleDetails.scheduleDate>{{formData.scheduleDetails.scheduleDate | dateformatter: \'DD-MMM-YYYY\'}}</span> <span ng-if=formData.scheduleDetails.scheduleDates>, {{formData.scheduleDetails.scheduleDates}}</span></td></tr><tr ng-if=\"formData.scheduleDetails.transactionAction == \'REVIEW\'\"><td>Frequency</td><td>:</td><td>{{formData.scheduleDetails.frequency}}</td></tr><tr ng-if=\"formData.scheduleDetails.transactionAction == \'REVIEW\' &&  formData.scheduleDetails.endDate\"><td>End Date</td><td>:</td><td>{{formData.scheduleDetails.endDate | dateformatter: \'DD-MMM-YYYY\'}}</td></tr></table><table class=\"table borderless\" ng-if=\"formData.scheduleDetails.state === \'REDEMPTION\' \"><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.formType| camelcase}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr ng-if=formData.amount><td>Redemption Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"formData.units && formData.amountType===TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td>Redemption Units</td><td>:</td><td>{{formData.units}}</td></tr><tr ng-if=\"formData.amountType===TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>All Free Units</td><td>:</td><td>Yes</td></tr><tr><td>Bank Name</td><td>:</td><td>{{formData.bankInfo.bankName | uppercase}}</td></tr><tr><td>Account Number</td><td>:</td><td easyassist-key=mask-element>{{formData.bankInfo.bankAcNo}}</td></tr><tr><td>IFSC</td><td>:</td><td>{{formData.bankInfo.ifscCode}}</td></tr><tr><td>Payout</td><td>:</td><td>{{formData.bankInfo.payoutDescription | uppercase}}</td></tr><tr><td>Scheduled Date <span ng-if=\"formData.scheduleDetails.transactionAction !== \'REVIEW\'\">*</span> <span ng-if=\"formData.scheduleDetails.transactionAction == \'REVIEW\'\">(s)*</span></td><td>:</td><td><span ng-if=formData.scheduleDetails.scheduleDate>{{formData.scheduleDetails.scheduleDate | dateformatter: \'DD-MMM-YYYY\'}}</span> <span ng-if=formData.scheduleDetails.scheduleDates>, {{formData.scheduleDetails.scheduleDates}}</span></td></tr><tr ng-if=\"formData.scheduleDetails.transactionAction == \'REVIEW\'\"><td>Frequency</td><td>:</td><td>{{formData.scheduleDetails.frequency}}</td></tr><tr ng-if=\"formData.scheduleDetails.transactionAction == \'REVIEW\' && formData.scheduleDetails.endDate\"><td>End Date</td><td>:</td><td>{{formData.scheduleDetails.endDate | dateformatter: \'DD-MMM-YYYY\'}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\" ng-if=\"formData.scheduleDetails.state === \'SWITCH\' \"><!--  <tr ng-if=\"formData.subBrokerCode\">\n                          <td>Sub Broker Code</td>\n                          <td>:</td>\n                          <td>{{formData.subBrokerCode}}</td>\n                        </tr>\n                        <tr ng-if=\"formData.euin && formData.euin.euinCode\">\n                          <td>EUIN Code</td>\n                          <td>:</td>\n                          <td>{{formData.euin.euinCode}}</td>\n                        </tr> --><tr ng-if=formData.amount><td>Amount</td><td style=\"width: 15px\">:</td><td><i class=rupee-small-icon ng-if=!formData.units></i> {{formData.units ? \'NA\' : formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"formData.amountType === TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td>Units</td><td>:</td><td>{{formData.units?formData.units:\'NA\'}}</td></tr><tr ng-if=\"formData.amountType === TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Units</td><td>:</td><td>All Free Units</td></tr><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table><table class=\"table borderless\" ng-if=\"formData.scheduleDetails.state !== \'SWITCH\'\"><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table></div></div><div class=label-section><label>*If a scheduled date falls on a non-business day, then reminder SMS and Email will be sent on the immediately succeeding business day.</label><label ng-if=\"formData.scheduleDetails.transactionAction === \'REVIEW\'\" ng-class=\"{\'space-between\': formData.scheduleDetails.transactionAction !== \'REVIEW\' && formData.scheduleDetails.state !== \'REDEMPTION\'}\">Transaction alert notification and acknowledgement email and SMS will be sent to above contact details registered in the folio.</label><label ng-if=\"formData.scheduleDetails.transactionAction !== \'REVIEW\'\" ng-class=\"{\'space-between\': formData.scheduleDetails.transactionAction !== \'REVIEW\' && formData.scheduleDetails.state !== \'REDEMPTION\'}\">Transaction <span ng-if=\"formData.scheduleDetails.transactionAction === \'VIEW\'\">alert notification and </span>acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label><label ng-if=\"formData.scheduleDetails.state === \'REDEMPTION\' \">Exit Load would be applicable as per SEBI Circular \"SEBI/HO/IMD/DF2/CIR/P/2019/101\" dated September 20, 2019. <a class=note-link href=https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf target=_blank>Click here</a> to know more</label></div><div ng-show=showTerms><div class=tc-block ng-show=\"formData.scheduleDetails.transactionAction === \'REVIEW\'\"><h6>Terms & Conditions</h6><div><div class=checkbox><input id=isCheckedTandC ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i><label for=isCheckedTandC class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</label></div></div></div></div><div class=imp-info style=\"padding: 0px\" ng-if=\"formData.scheduleDetails.DynamicNotesScheduleReview.content && formData.scheduleDetails.state !== \'REDEMPTION\'\"><ng-bind-html dynamic=formData.scheduleDetails.DynamicNotesScheduleReview.content></ng-bind-html></div><div class=content-foot><input type=hidden id=hfReq><div><span ng-click=goToBack() class=\"cursor-pointer text-primary\" ng-if=\"formData.scheduleDetails.transactionAction === \'REVIEW\'\"><i class=arrow-blue-back-icon></i>Back</span> <button blur-on-click ng-if=\"formData.scheduleDetails.transactionAction === \'VIEW\'\" ng-click=redirectToSavedItems() class=\"btn-primary-action btn pull-right\">View Scheduled Transactions</button> <button blur-on-click ng-if=\"formData.scheduleDetails.transactionAction === \'CANCEL\'\" ng-click=handleCancelAction() class=\"btn-primary-action btn pull-right\">Cancel Scheduled Transaction</button> <button blur-on-click ng-disabled=\"!isCheckedTandC || !formData\" ng-if=\"formData.scheduleDetails.transactionAction === \'REVIEW\'\" ng-click=handleScheduleTransactionAction($event) class=\"btn-primary-action btn pull-right\">Schedule Transaction</button></div></div></div></div><style>.checkbox label{padding-left: 0}\n\n      div i.dot {\n      display: inline-block;\n      position: relative;\n      top: -2px;\n      height: 6px;\n      margin-right: 10px;\n      width: 6px;\n      background: #d92018;\n    }\n\n\n    .info {\n      font-weight: normal;\n      font-size: 12px;\n    }\n\n    .info p {\n      margin-top : 0px !important;\n      margin-bottom: 0px !important;\n    }\n\n    .info span {\n      display: inline-block;\n      vertical-align: top;\n    }</style></section>");
$templateCache.put("app/transactions/summary/directive/summary.smart.swp.html","<div class=summary ng-init=init()><p class=page-title>REVIEW TRANSACTION : SMART SYSTEMATIC WITHDRAWAL ADVANTAGE PLAN (SMART SWAP)</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr><td class=col-md-4>Folio</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr><td>Market Value</td><td>:</td><td><i class=rupee-small-icon></i>{{formData.marketValue|unit}}</td></tr><tr><td>SMART SWAP Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.amount}}</td></tr><tr><td>SMART SWAP Amount in words</td><td>:</td><td>{{formData.amountInWords}}</td></tr><tr><td class=width-small>Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr><td>% Percentage (per annum)</td><td>:</td><td>{{formData.percentage}}</td></tr><tr><td class=col-md-4>SMART SWAP Start Date</td><td>:</td><td>{{formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr><td style=\"text-decoration: underline\">BANK</td></tr><tr><td class=width-small>Bank Name</td><td>:</td><td>{{formData.bankInfo.bankName | uppercase}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email will be sent to above contact details registered in the folio.</label></div><div class=tc-block ng-show=showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a></span></div></div></div><div class=content-foot><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!formData ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div>");
$templateCache.put("app/transactions/summary/directive/summary.stp.html","<div class=summary ng-init=init()><p class=page-title>REVIEW TRANSACTION : {{formData.formType===\'Flex STP\' ? \'FLEX STP\' : \'SYSTEMATIC TRANSFER PLAN (STP)\'}}</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=formData.isThroughRia>{{formData.brokerCode?formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.brokerCode>N/A</td></tr><tr ng-if=formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=formData.brokerName>{{formData.brokerName}}</td><td ng-if=!formData.brokerName>N/A</td></tr><!--RIA code columns--><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.formType}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr><td>Target Scheme</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption.toUpperCase() != TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? formData.investmentOption : (formData.investmentOption | camelcase)}}</td></tr><tr ng-if=\"formData.investmentOption.toUpperCase() != TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Target Scheme IDCW Option</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.dividendOption]}}</td></tr><tr><td>STP Type</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.transferOption]}}</td></tr><tr ng-if=\"formData.transferOption === \'F\'\"><td>STP Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr ng-if=formData.subBrokerARN><td class=width-small>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=formData.subBrokerCode><td class=width-small>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinCode\"><td class=width-small>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinName\"><td class=width-small>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr><td class=width-small>Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr ng-if=\"formData.frequency === \'DZ\' || formData.frequency === \'OW\'\"><td class=width-small>No of Installments</td><td>:</td><td>{{formData.noOfInstallments}}</td></tr><tr ng-if=formData.startDate><td class=width-small>STP Start Date</td><td>:</td><td>{{formData.startDate && formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr ng-if=formData.endDate><td class=width-small>STP End Date</td><td>:</td><td>{{formData.endDate && formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label></div><div class=tc-block ng-show=\"formData.formType===\'Flex STP\' && showTermsFlex || formData.formType===\'STP\' && showTerms\"><h6>Terms & Conditions</h6><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><ng-bind-html ng-bind-html=notes></ng-bind-html><div class=content-foot><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!formData ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div>");
$templateCache.put("app/transactions/summary/directive/summary.swingstp.html","<div class=summary ng-init=init()><p class=page-title>REVIEW TRANSACTION : SWING STP</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.formType}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr><td>Target Scheme</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption | camelcase}}</td></tr><tr ng-if=\"formData.investmentOption.toUpperCase() != TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>IDCW Option</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.dividendOption]}}</td></tr><tr><td>STP Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{formData.amount}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr ng-if=formData.subBrokerARN><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=formData.subBrokerCode><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr><td>Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr><tr ng-if=\"formData.frequency === \'OW\'\"><td>Day of Transfer</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.WEEK_DAYS[formData.day]}}</td></tr><tr ng-if=formData.noOfInstallments><td>No. of Installments</td><td>:</td><td>{{formData.noOfInstallments}}</td></tr><tr ng-if=formData.startDate><td>Start Date</td><td>:</td><td>{{formData.startDate && formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr ng-if=formData.endDate><td>End Date</td><td>:</td><td>{{formData.endDate && formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr></table></div></div><!--    <div><label style=\"padding: 25px 0px 0px 20px; display: block;\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label></div>--><div class=tc-block><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=content-foot><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!formData ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div>");
$templateCache.put("app/transactions/summary/directive/summary.switch.html","<div class=summary ng-init=init()><p class=page-title>REVIEW TRANSACTION : SWITCH</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=formData.isThroughDistributor>{{formData.brokerCode?\'ARN-\'+formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=formData.isThroughRia>{{formData.brokerCode?formData.brokerCode:(formData.distributorARN?formData.distributorARN:\'\')}}</td><td ng-if=!formData.brokerCode>N/A</td></tr><tr ng-if=formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=formData.brokerName>{{formData.brokerName}}</td><td ng-if=!formData.brokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=formData.subBrokerARN><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+formData.subBrokerARN}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td>{{formData.euin.euinName}}</td></tr><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.formType | camelcase}}</td></tr><tr><td>Switch Out Scheme</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr><td>Switch In Scheme</td><td>:</td><td>{{formData.inSchemeName}}</td></tr><tr><td>Investment Option</td><td>:</td><td>{{formData.investmentOption.toUpperCase() == TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? (TRANSACTIONS_CONST.INVESTMENT_OPTIONS[formData.investmentOption] | camelcase) : TRANSACTIONS_CONST.INVESTMENT_OPTIONS[formData.investmentOption]}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr ng-if=\"formData.investmentOption.toUpperCase() != TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td style=\"width: 240px\">Target Scheme IDCW Option</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.dividendOption]}}</td></tr><tr ng-if=formData.subBrokerCode><td>Sub Broker Code</td><td>:</td><td>{{formData.subBrokerCode}}</td></tr><tr ng-if=\"formData.euin && formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td>{{formData.euin.euinCode}}</td></tr><tr ng-if=formData.amount><td>Amount</td><td style=\"width: 15px\">:</td><td><i class=rupee-small-icon ng-if=!formData.units></i> {{formData.units ? \'NA\' : formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"formData.amountType === TRANSACTIONS_CONST.AMOUNT_TYPE.UNITS\"><td>Units</td><td>:</td><td>{{formData.units?formData.units:\'NA\'}}</td></tr><tr ng-if=\"formData.amountType === TRANSACTIONS_CONST.AMOUNT_TYPE.ALL_UNITS\"><td>Units</td><td>:</td><td>All Free Units</td></tr><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\" ng-if=formData.checkedNfoAutoSwitch><tr><td style=\"width: 240px\">Auto Switch On Maturity:</td><td>:</td><td>{{formData.checkedNfoAutoSwitch?\'Yes\':\'No\'}}</td></tr><tr><td>Auto Switch scheme:</td><td>:</td><td>{{formData.switchInSchemeName}}</td></tr><tr ng-if=\"formData.switchInInvestmentOption.toUpperCase() != TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH\"><td>Auto Switch Scheme IDCW Option:</td><td>:</td><td>{{formData.autoSwitchSchemeDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email and SMS will be sent to above contact details registered in the folio.</label></div><div class=tc-block ng-show=showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><ng-bind-html ng-bind-html=notes></ng-bind-html><div class=content-foot><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!formData ng-click=submitFormSwitchFirst($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div><style>div i.dot {\n      display: inline-block;\n      position: relative;\n      top: -2px;\n      height: 6px;\n      margin-right: 10px;\n      width: 6px;\n      background: #d92018;\n    }\n\n\n    .info {\n      font-weight: normal;\n      font-size: 12px;\n    }\n\n    .info p {\n      margin-top : 0px !important;\n      margin-bottom: 0px !important;\n    }\n\n    .info span {\n      display: inline-block;\n      vertical-align: top;\n    }</style>");
$templateCache.put("app/transactions/summary/directive/summary.swp.html","<div class=summary ng-init=init()><p class=page-title>REVIEW TRANSACTION : SYSTEMATIC WITHDRAWAL ADVANTAGE PLAN (SWAP)</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{formData.formType}}</td></tr><tr><td>Withdrawal Scheme</td><td>:</td><td>{{formData.outSchemeName}}</td></tr><tr><td>Withdrawal Type</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS[formData.transferOption]}}</td></tr><tr ng-if=\"formData.transferOption === \'F\'\"><td>Withdrawal Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{formData.amount}}<br><label id=amountInwords>{{formData.amountInWords}} (In Words)</label></td></tr><tr><td class=width-small>Frequency</td><td>:</td><td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.frequency]}}</td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr><td class=width-small>Start Date</td><td>:</td><td>{{formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td class=width-small>End Date</td><td>:</td><td>{{formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td class=width-small>Bank Name</td><td>:</td><td>{{formData.bankInfo.bankName | uppercase}}</td></tr><tr><td class=width-small>Account Number</td><td>:</td><td easyassist-key=mask-element>{{formData.bankInfo.bankAcNo}}</td></tr><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element>{{formData.email}}</td></tr><tr><td>Mobile Number</td><td>:</td><td easyassist-key=mask-element>{{formData.mobileNumber}}</td></tr></table></div></div><div><label style=\"padding: 25px 0px 0px 20px; display: block\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</label></div><div class=tc-block ng-show=showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input ng-model=isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=showTermConditions() href=javaScript:void(0)>Terms & Conditions</a></span></div></div></div><div class=content-foot><a href=\"\" ng-click=goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</a> <button blur-on-click ng-disabled=!isCheckedTandC||!formData ng-click=submitForm($event) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div>");
$templateCache.put("app/transactions/view/schemeOverview/details.html","<div class=\"view-body clearfix\" ng-init=TransactionView.init()><div class=value-area><div class=value-slot><p class=text-uppercase>Cost value</p><p><i class=rupee-black-icon></i>{{TransactionView.constantData.costValue|unit:TransactionView.purchaseValueCountUnit}} {{TransactionView.purchaseValueCountUnit|unitValue}}</p></div><div class=value-slot><p class=text-uppercase>Market value</p><p><i class=rupee-black-icon></i>{{TransactionView.constantData.marketValue|unit:TransactionView.currentValueCountUnit}} {{TransactionView.currentValueCountUnit|unitValue}}</p></div></div><h6 class=col-md-12>Systematic Registrations</h6><table class=\"table table-striped\"><thead><tr><th>Folio</th><th>Type</th><th>Scheme To</th><th>Start Date</th><th>End Date</th><th>Amount</th><th>Units</th><th>Status</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"overview in TransactionView.overviewData\"><td ng-bind=overview.folioNumber>1029248</td><td>{{overview.type}}</td><td><p ng-bind=\"overview.toScheme || \'N/A\'\">HDFC Artbitrage Fund</p><!--<p ng-bind=\"overview.investmentOption\" class=\"small-grey\">Direct - Growth</p>--></td><!--ng-bind=\"overview.toScheme\"--><td ng-bind=overview.startDate>10/07/2016</td><td ng-bind=overview.endDate>10/07/2019</td><td><p ng-bind=overview.amount>&#x20B9; 300</p><p class=small-grey ng-bind=overview.frequency>Monthly</p></td><!--ng-bind=\"overview.amount\"--><td ng-bind=overview.units>0</td><td ng-bind=overview.status>Completed</td><td><span class=\"dropdown action-dropper\" ng-if=\"overview.actions.length>0\"><span data-bs-toggle=dropdown>Transact <i class=black-down-icon></i></span><ul class=dropdown-menu><!--<li>Transact  <i class=\"arrow-blue-down-icon\"></i></li>--><li ng-repeat=\"action in overview.actions\" ng-click=TransactionView.selectTransaction(action,overview)>{{action}} <i class=\"arrow-right-icon pull-right\"></i></li></ul></span></td></tr><tr class=text-center ng-if=!TransactionView.overviewData.length><td colspan=8>No records found</td></tr></tbody></table></div>");
$templateCache.put("app/transactions/view/schemeOverview/transactions.html","<div class=\"view-body clearfix\" ng-init=TransactionView.init()><h5>Last Transactions</h5><table class=\"table table-striped\"><thead><tr><th>Folio</th><th>Type</th><th>Transaction Date</th><th>Amount</th><th>Units</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"trans in TransactionView.transactionsOverview\"><td ng-bind=trans.folioNumber>111111</td><td ng-bind=trans.type>Systematic Transfer</td><td ng-bind=trans.date>10/07/2016</td><td ng-bind=trans.amount>300 (Monthly)</td><td ng-bind=\"trans.units || \'-\'\">1400</td><td ng-bind=trans.status>Completed</td></tr><tr class=text-center ng-if=!TransactionView.transactionsOverview.length><td colspan=8>No records found</td></tr></tbody></table></div>");
$templateCache.put("app/components/directives/payment/templates/transaction.template.html","<div class=row><div class=col-md-12><div class=payment-options-container><div class=row><div class=col-md-3><div class=form-input><label class=form-label>Registration Through UPI</label><div class=search-input ng-class={error:tForm.bank.$dirty&&tForm.bank.$invalid}><input type=text name=bank id=upiBank ng-model=bankInfo.bankName ng-change=selectedUpiBank() class=\"select-folio-list form-select\" ng-init=\"bankInfo = bankInfo ? bankInfo: null\" autocomplete=off ng-required=!bankInfo ng-disabled=isDisableUpi only-alphabets readonly> <span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=selectedUpiBank() model=bankInfo for=upiBank></bank-drop-down></div></div></div></div><div class=row><div class=col-md-8><div class=seperators><span>OR</span></div></div></div><div class=row><div class=col-md-10><div class=form-input><label class=form-label>Other Payment Options</label><div class=other-payment-options><div class=radio-button ng-repeat=\"_option in purchasePaymentOptions| limitTo: (1 - purchasePaymentOptions.length)\"><input type=radio id=paymentOption-{{_option}} name=paymentOption ng-value=_option ng-model=formData.selectedPaymentOption><label class=\"btn btn-default\" id={{_option.toLowerCase()}} for=paymentOption-{{_option}} ng-click=changedPaymentOptionPurchase(_option)>{{TRANSACTIONS_CONST.PAYMENT_CONSTANTS[_option]}}</label></div></div></div></div></div></div></div></div><div class=row><div class=col-md-10><div ng-switch=formData.selectedPaymentOption><div ng-switch-when=NETBANKING class=payment-details-sections><div class=row><!-- Netbanking bank selection column--><div class=col-md-4><div class=form-input><div class=search-input><input type=text name=bank id=bank ng-model=bankInfo.bankName ng-change=changeBank() class=form-select ng-init=\"bankInfo=bankInfo?bankInfo: null\" autocomplete=off ng-required=!bankInfo only-alphabets readonly><label>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=changeBank() model=bankInfo for=bank></bank-drop-down></div></div></div><!-- Netbanking ifsc code selection column (if not available in selected bank)--><div class=col-md-4 ng-if=\"bankInfo && !bankInfo.ifscCode\"><div class=form-input><div class=field-type-2><input type=text ng-model=formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=IFSC_REGEX class=form-control capitalize><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div></div><!-- Netbanking Account type selection column (if not available in selected bank)--><div class=col-md-4 ng-if=\"bankInfo && !bankInfo.bankAcType\"><div class=form-input><div class=field-type-2><select name=accountType ng-model=formData.paymentInfo.accType class=form-select ng-init=\"formData.paymentInfo.accType=formData.paymentInfo.accType?formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\">Select Account Type</option></select><label>Account Type<span class=\"req text-red\">*</span></label><span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div></div><div ng-switch-when=RTGS class=payment-details-sections><div class=row><div class=col-md-12><div class=toggle-container><label class=switch><input type=checkbox ng-model=isNewPayment ng-change=changeRtgsPaymentOption()> <span class=slider></span></label><div class=\"label-black f-family-inter f-weight-400\">Have you transfered funds from registered bank account?</div></div></div></div><div class=row><!-- RTGS bank selection column--><div class=col-md-4 ng-if=isNewPayment><div class=form-input><div class=search-input><input type=text name=rtgsBank id=rtgsBank ng-model=bankInfo.bankName ng-change=changeBank() class=form-select autocomplete=off ng-required=!bankInfo only-alphabets readonly><label>Select Bank</label><span class=error-input ng-show=tForm.rtgsBank.$dirty&&tForm.rtgsBank.$error.required ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=changeBank() model=bankInfo for=rtgsBank></bank-drop-down></div></div></div><!-- RTGS bank name column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text ng-model=formData.paymentInfo.bankName name=bankName only-alphabets required class=form-control ng-readonly=isNewPayment><label>Bank Name<span class=req>*</span></label><span class=error-input ng-show=tForm.bankName.$dirty&&tForm.bankName.$error.required ng-bind=VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div></div><!-- RTGS branch city column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text ng-model=formData.paymentInfo.bankBranch only-alphabets name=bankBranch required ng-readonly=isNewPayment class=form-control><label>Branch City<span class=req>*</span></label><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><!-- RTGS account number column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text autocomplete=false ng-model=formData.paymentInfo.accNo ng-if=isNewPayment name=bankAcNo required maxlength=20 ng-readonly=isNewPayment onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=copyPasteHandler($event) class=form-control> <input type=password autocomplete=false ng-model=formData.paymentInfo.accNo ng-if=!isNewPayment name=bankAcNo required maxlength=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=copyPasteHandler($event) class=form-control><label>Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.required ng-bind=VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.bankAcNo.$dirty&&tForm.bankAcNo.$error.maxlength ng-bind=VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div></div></div><!-- RTGS verify account number column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text ng-keydown=copyPasteHandler($event) name=verifyBankAcNo maxlength=20 required ng-model=formData.paymentInfo.verifyBankAcNo ng-pattern=formData.paymentInfo.accNo onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\" class=form-control><label>Verify Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.verifyBankAcNo.$dirty&&tForm.verifyBankAcNo.$error.required ng-bind=VALIDATE_DATA.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&tForm.verifyBankAcNo.$error.maxlength ng-bind=VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyBankAcNo.$error.required&&!tForm.verifyBankAcNo.$error.maxlength&&tForm.verifyBankAcNo.$error.pattern ng-bind=VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div></div><!-- RTGS ifsc code selection column (if not available in selected bank)--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text ng-model=formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=IFSC_REGEX class=form-control capitalize><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div></div><!-- Netbanking Account type selection column (if not available in selected bank)--><div class=col-md-4><div class=form-input><div class=field-type-2><select name=accountType ng-model=formData.paymentInfo.accType class=form-select ng-init=\"formData.paymentInfo.accType=formData.paymentInfo.accType?formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\">Select Account Type</option></select><label>Account Type<span class=\"req text-red\">*</span></label><span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><!-- RTGS UTR number column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text name=utrNumber ng-model=formData.paymentInfo.utrNumber ng-pattern=PATTERN.UTR_REGEX ng-maxlength=255 required class=form-control><label>UTR Number<span class=req>*</span></label><span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required ng-bind=VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.pattern class=help-block ng-bind=VALIDATE_DATA.UTR_RANGE></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.maxlength class=help-block ng-bind=VALIDATE_DATA.UTR_INVALID></span></div></div></div><!-- RTGS verify utr column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text name=verifyUtrNumber ng-model=formData.paymentInfo.verifyUtrNumber ng-pattern=formData.paymentInfo.utrNumber required class=form-control><label>Verify UTR Number<span class=req>*</span></label><span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required ng-bind=VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.pattern ng-bind=VALIDATE_DATA.SAME_UTR_REQUIRED></span></div></div></div></div><div class=row><div class=col-md-12><div class=checkbox><input id=declaration ng-model=isCheckedDeclaration type=checkbox required> <i class=icon-checkbox></i><label for=declaration class=\"label-black f-family-inter f-weight-400\">I hereby declare that the funds transferred are from bank account where the first/sole unit holder is one of the bank account holders.</label></div></div></div></div><div ng-switch-when=OTM class=payment-details-sections><div class=row><!-- OTM bank selection column--><div class=col-md-4><div class=form-input><div class=search-input><input type=text name=bank id=otmBank ng-model=bankInfo.bankName ng-change=changeBank() class=form-select ng-init=\"bankInfo=bankInfo?bankInfo: null\" autocomplete=off ng-required=!bankInfo only-alphabets readonly><label>Select Bank</label><span class=error-input ng-show=tForm.bank.$dirty&&tForm.bank.$error.required ng-bind=VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=bankList display-key=bankName display-key-second=bankAcNo hdfc-click=changeBank() model=bankInfo for=otmBank></bank-drop-down></div></div></div><!-- OTM ifsc code selection column (if not available in selected bank)--><div class=col-md-4 ng-if=\"bankInfo && !bankInfo.ifscCode\"><div class=form-input><div class=field-type-2><input type=text ng-model=formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=IFSC_REGEX class=form-control capitalize><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div></div><!-- OTM Account type selection column (if not available in selected bank)--><div class=col-md-4 ng-if=\"bankInfo && !bankInfo.bankAcType\"><div class=form-input><div class=field-type-2><select name=accountType ng-model=formData.paymentInfo.accType class=form-select ng-init=\"formData.paymentInfo.accType=formData.paymentInfo.accType?formData.paymentInfo.accType:null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required><option value=\"\">Select Account Type</option></select><label>Account Type<span class=\"req text-red\">*</span></label><span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div></div><div ng-switch-when=HDFC class=payment-details-sections><div class=row><!-- HDFC Scheme Account Number column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=number ignore-mouse-wheel ng-model=formData.paymentInfo.schemeAccountNumber name=schemeAccountNumber ng-maxlength=25 required class=form-control><label>HDFC MF Scheme Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.required ng-bind=VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.number ng-bind=VALIDATE_DATA.SCHEME_ACCOUNT_NUMBER_FIELD></span> <span class=error-input ng-show=tForm.schemeAccountNumber.$dirty&&tForm.schemeAccountNumber.$error.maxlength ng-bind=VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div></div></div><!-- HDFC Investor Account Number column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text ng-model=formData.paymentInfo.accountNumber name=accountNumber ng-maxlength=20 easyassist-key=mask-element onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=copyPasteHandler($event) required class=form-control><label>Investor Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.required ng-bind=VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.accountNumber.$dirty&&tForm.accountNumber.$error.maxlength ng-bind=VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span></div></div></div><!-- HDFC Confirm Investor Account Number column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text ng-keydown=copyPasteHandler($event) name=verifyAccountNumber ng-maxlength=20 easyassist-key=mask-element required ng-model=formData.paymentInfo.verifyAccountNumber ng-pattern=formData.paymentInfo.accountNumber onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\" class=form-control><label>Confirm Investor Account Number<span class=req>*</span></label><span class=error-input ng-show=tForm.verifyAccountNumber.$dirty&&tForm.verifyAccountNumber.$error.required ng-bind=VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyAccountNumber.$error.required&&tForm.verifyAccountNumber.$error.maxlength ng-bind=VALIDATE_DATA.INVESTOR_ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyAccountNumber.$error.required&&!tForm.verifyAccountNumber.$error.maxlength&&tForm.verifyAccountNumber.$error.pattern ng-bind=VALIDATE_DATA.SAME_INVESTOR_ACCOUNT_NUMBER_RANGE></span></div></div></div><!-- HDFC Account holder name column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text ng-model=formData.paymentInfo.accountHolderName only-alphabets name=accountHolderName required class=form-control><label>Account Holder Name<span class=req>*</span></label><span class=error-input ng-show=tForm.accountHolderName.$dirty&&tForm.accountHolderName.$error.required ng-bind=VALIDATE_DATA.ACCOUNT_HOLDER_REQUIRED></span></div></div></div><!-- HDFC Bank Branch name column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text ng-model=formData.paymentInfo.bankBranch only-alphabets name=bankBranch required class=form-control><label>HDFC Bank Branch Name<span class=req>*</span></label><span class=error-input ng-show=tForm.bankBranch.$dirty&&tForm.bankBranch.$error.required ng-bind=VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div></div><!-- HDFC Bank Reference Number column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text ng-model=formData.paymentInfo.utrNumber name=utrNumber required ng-maxlength=255 ng-pattern=/^[a-zA-Z0-9]*$/ class=form-control><label>Bank Reference Number<span class=req>*</span></label><span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.required ng-bind=VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.maxlength ng-bind=VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE></span> <span class=error-input ng-show=tForm.utrNumber.$dirty&&tForm.utrNumber.$error.pattern ng-bind=VALIDATE_DATA.UTR_INVALID></span></div></div></div><!-- HDFC Bank Reference Number column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text name=verifyUtrNumber ng-maxlength=255 required ng-model=formData.paymentInfo.verifyUtrNumber ng-pattern=formData.paymentInfo.utrNumber class=form-control><label>Confirm Bank Reference Number<span class=req>*</span></label><span class=error-input ng-show=tForm.verifyUtrNumber.$dirty&&tForm.verifyUtrNumber.$error.required ng-bind=VALIDATE_DATA.BANK_REFERENCE_NUMBER_REQUIRED></span> <span class=error-input ng-show=!tForm.verifyUtrNumber.$error.required&&tForm.verifyUtrNumber.$error.maxlength ng-bind=VALIDATE_DATA.BANK_REFERENCE_NUMBER_RANGE></span> <span class=error-input ng-show=!tForm.verifyUtrNumber.$error.required&&!tForm.verifyUtrNumber.$error.maxlength&&tForm.verifyUtrNumber.$error.pattern ng-bind=VALIDATE_DATA.SAME_BANK_REFERENCE_NUMBER_RANGE></span></div></div></div><!-- HDFC ifsc code selection column--><div class=col-md-4><div class=form-input><div class=field-type-2><input type=text ng-model=formData.paymentInfo.ifscCode name=ifscCode required maxlength=11 minlength=11 ng-pattern=IFSC_REGEX class=form-control capitalize><label>IFSC Code<span class=req>*</span></label><span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.required ng-bind=VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=tForm.ifscCode.$dirty&&tForm.ifscCode.$error.pattern ng-bind=VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div></div><!-- HDFC Account type selection column--><div class=col-md-4><div class=form-input><div class=field-type-2><select name=accountType ng-model=formData.paymentInfo.accType ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required class=form-select><option value=\"\">Select Account Type</option></select><label>Account Type<span class=\"req text-red\">*</span></label><span class=error-input ng-messages=tForm.bankAcType.$error ng-show=tForm.bankAcType.$dirty><span ng-message=required ng-bind=VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div><div class=row><div class=col-md-12><div class=upload-box><div><div class=upload-block><img src=assets/images/icons/flowbite_upload-solid.svg alt=upload></div><label class=\"label-black f-family-inter f-weight-400\">Tap here to upload bank statement</label><p>Supported file formats are .jpeg, .jpg, .tiff, .tif, .pdf</p><button class=\"btn btn-link disclaimer-link f-family-inter f-weight-500\" type=button>Read instructions</button> <input class=file-select id=uploadCheckLeaf type=file name=pic accept=\"image/*, application/*\" file-model-profile=chequeLeaf upload=bankUploadChequeLeafFile(file) ng-model=formData.paymentInfo.chequeLeaf required></div><!--<span class=\"leaf-label\">Upload Bank Statement\n                <i class=\"info-icon base-tooltip\" data-bs-html=\"true\" data-bs-toggle=\"tooltip\"  data-bs-placement=\"{{Main.tooltipClass}}\"\n                   title=\"{{PATTERN.BANK_STATEMENT_INFO}}\"></i>\n                <span class=\"req text-red\">*</span>\n              </span>\n              <div class=\"upload-leaf\">\n                <input id=\"uploadCheckLeaf\" type=\"file\" name=\"pic\" accept=\"image/*, application/*\" file-model-profile=\"chequeLeaf\"\n                       upload=\"bankUploadChequeLeafFile(file)\" ng-model=\"formData.paymentInfo.chequeLeaf\" required>\n                <div class=\"file-upload\"><button>Choose File</button><span ng-if=\"chooseAFile\">No File Chosen</span>\n                  <span ng-if=\"fileType === \'tif\' || fileType === \'tiff\'|| fileType == \'pdf\'\"><a href=\"javascript:void(0)\" ng-click=\"downloadPdfFile(bankchequeLeafUrl,fileType)\">Download</a></span>\n                  <span ng-if=\"fileType == \'jpg\' ||  fileType == \'jpeg\' \" ng-click=\"openUploadedDoc(formData.paymentInfo.chequeLeaf)\">{{bankChequeLeaf}}</span></div>\n              </div>--></div></div></div><div class=row><div class=col-md-12><div class=checkbox><input id=declaration ng-model=isCheckedDeclaration type=checkbox required> <i class=icon-checkbox></i><label for=declaration class=\"label-black f-family-inter f-weight-400\">I hereby declare that the funds transferred are from bank account where the first/sole unit holder is one of the bank account holders.</label></div></div></div></div></div></div></div>");
$templateCache.put("app/components/modal/loginWithMobile/existingUser/verify-pan-dob.html","<div class=height100><div class=side-nav-main-wrap><div class=\"col-md-12 col-sm-12 backgroundBgLoginSlider\" style=\"width: 100%;padding: 0px;margin: 0px\"><div class=forms-container><div class=\"main-login-screen row row-no-gutters\"><div class=\"widthContainer form-existing-wrap-login\"><br><login-header></login-header><br><div class=new-mobile-carousel><slide-image-mb></slide-image-mb></div><div class=main-form-view style=\"margin-top: 20px\"><div class=login-forms style=\"min-height: 425px;width: 344px;padding: 0px\"><div class=login-header><div ng-if=!Login.showSecStep><h4 class=new-login-title>Get Started With Your</h4><h4 class=new-login-title><span style=color:#347ABC>Investment </span><span style=color:#EB1C24>Journey</span></h4></div></div><div><div><form name=panForm autocomplete=off><div class=\"normal-wrap clearfix\"><div class=sip-form-box><div class=row><div><div class=form-group><div style=\"display: flex;align-items: center\"><div ng-click=Checkuser.mobileTknLogout(true) style=\"cursor: pointer\"><img src=../../../assets/images/icons/black-back-arrow.svg alt=\"\" class=\"hide-lg nonconstrastImgarrow\"> <img src=../../../assets/images/icons/white-back-arrow.svg alt=\"\" class=\"hide-lg constrastImgarrow\"></div><p style=\"font-size: 17px;font-weight: 600;margin-left: 8px\">Enter Details</p></div><br><!-- PAN --><label><b>PAN</b></label><div class=\"input-select input-normal\"><input type=text id=pan name=pan class=panControl maxlength=10 minlength=10 placeholder=Eg.ABCDE1234A ng-pattern=/^[A-Z]{3}[A-Z][A-Z][0-9]{4}[A-Z]$/ ng-class=\"{\'errorBorder\':panForm.pan.$dirty && panForm.pan.$invalid}\" style=\"border-radius: 24px;\n                                          margin-top: 12px;\n                                          height: 48px;\n                                          padding: 0px 0px 0px 15px\" ng-model=Checkuser.panNumber autocomplete=off capitalize required><div ng-show=\"panForm.pan.$dirty && panForm.pan.$invalid\"><p class=mod-error-msg ng-show=panForm.pan.$error.required ng-bind=Checkuser.VALIDATE_CONST.PAN_REQUIRED></p><p class=mod-error-msg ng-show=panForm.pan.$error.maxlength ng-bind=Checkuser.VALIDATE_CONST.PAN_FIELD></p><p class=mod-error-msg ng-show=panForm.pan.$error.pattern ng-bind=Checkuser.VALIDATE_CONST.PAN_FIELD></p></div><p class=mod-error-msg ng-if=Checkuser.panMessage ng-bind=Checkuser.panMessage></p></div><!-- DOB --><div class=dob-input-container><label for=dobId style=\"margin: 5px 0px 10px 0px;font-weight: 400\">Date of Birth</label><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode=days data-date-default=Checkuser.dob data-on-date-change=Checkuser.changeStartDate maxdate=now format=DD-MM-YYYY id=endDate style=\"margin-bottom: 0px\"><input class=dobControl id=dobId name=dob type=text autocomplete=off placeholder=DD-MM-YYYY ng-keyup=Checkuser.autoDate() easyassist-key=mask-element ng-pattern=/^\\d{2}[./-]\\d{2}[./-]\\d{4}$/ style=\"height: 48px;border-radius: 100px;border: 1px solid #b8c6d1;padding: 0px 0px 0px 15px\" required> <span class=input-group-addon style=\"right: 20px; top: 20px\"><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png style=\"width: 22px;top: -8px\"></span><p class=mod-error-msg ng-if=Checkuser.dateErrorMessage ng-bind=Checkuser.dateErrorMessage></p><p class=mod-error-msg ng-if=Checkuser.doberrormsg ng-bind=Checkuser.doberrormsg></p></div></div><br><button class=wBtn ng-click=Checkuser.verifypan() ng-disabled=\"!Checkuser.panNumber || !Checkuser.dob\" style=\"padding: 0px !important;\n                                        text-transform: none;\n                                        font-size: 16px !important;\n                                        width: 100% !important\">Proceed</button></div></div></div></div></div></form></div></div></div></div></div><div class=\"widthContainer investor-carousel-new\"><slide-image></slide-image></div></div></div></div></div></div><style>.panControl{\n    border: 1px solid #b5b1b1 !important;\n  }\n  .errorBorder{\n    border: 1px solid red !important;\n  }\n  .forms-container {\n    margin: 0px !important;\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n\n  .backgroundBgLoginSlider {\n    background-color: white;\n  }\n\n  input::-ms-reveal,\n  input::-ms-clear {\n    display: none;\n  }\n\n  .password-container {\n    position: relative;\n  }\n\n  .error-border {\n    border: 1px solid #EB1C24 !important;\n  }\n\n  .otp-input-container {\n    width: 300px;\n  }\n\n  .otp-txt {\n    font-size: 14px;\n    line-height: 28px;\n  }\n\n  .box {\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-evenly;\n    width: 300px;\n    height: 40px;\n    background: rgba(242, 243, 251, 0.99);\n    border: 1px solid #E0E1EB;\n    border-radius: 100px;\n  }\n\n  .subBox {\n    margin: auto;\n    font-size: 11px;\n    color: #1D1A1B;\n    text-align: center;\n    width: 137px;\n    height: 28px;\n    padding: 6px;\n    cursor: pointer;\n  }\n\n  .activeBtn {\n    background: #FFFFFF;\n    box-shadow: 3px 4px 11px rgba(0, 0, 0, 0.08);\n    border-radius: 100px;\n  }\n\n  .mobileInputGroup {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    box-sizing: border-box;\n    background: white;\n    width: 300px;\n    height: 48px;\n    border: 1px solid #BDBCBD;\n    border-radius: 100px;\n  }\n\n  .mobileInput {\n    padding: 0px 0px 0px 10px;\n    height: 45px;\n    width: 84%;\n    border: none;\n    border-radius: 30px;\n  }\n\n  .mobileInput:focus {\n    border: none !important;\n  }\n  .panControl:focus{\n    border: 1px solid #b5b1b1 !important;\n  }\n  .verticalLine {\n    border-right: 1px solid gray;\n    height: 34px;\n  }\n\n  .cta {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    width: 300px;\n    height: 48px;\n    background: linear-gradient(94deg, #3C75BA -21.18%, #1B4B86 95.94%);\n    border: none;\n    border-radius: 100px;\n    color: white;\n  }\n\n\n  .wBtn:after {\n    content: url(\'../../../assets/images/arrow-white-small.svg\');\n  }\n\n  .wBtn:disabled {\n    opacity: 60% !important;\n  }\n\n  .existing-investor-background {\n    background-image: url(\"../../../assets/images/new-bg.svg\") !important;\n    background-size: cover;\n  }\n\n  .form-control {\n    height: 48px;\n    border-radius: 100px;\n  }\n\n  .otp-number-box {\n    width: 15.1%;\n    border: none !important;\n    border-bottom: 1px solid gray !important;\n    border-radius: 0px !important;\n  }\n\n  .login-forms {\n    margin: auto;\n  }\n\n  .activeTab {\n    color: #032AF9;\n    font-weight: 500;\n  }\n\n  .new-login-title {\n    font-size: 1.75rem;\n    line-height: 42px !important;\n    font-weight: 700 !important;\n    color: black;\n  }\n\n  .otp-number-input-data {\n    width: 45px;\n  }\n\n  input:focus {\n    border: 1px solid gray;\n  }\n\n  @media only screen and (max-width: 767px) {}\n\n  @media screen and (max-width: 767px) {\n    .main-login-screen {\n      /* margin-top: 5% !important; */\n    }\n\n    .login-forms {\n      border-radius: 16px;\n    }\n\n    .sm-input-width {\n      width: 95% !important;\n    }\n\n    .otp-input-container {\n      width: 100%;\n    }\n  }\n\n  @media screen and (max-width: 575px) {\n    .login-forms {\n      border-radius: 16px;\n      width: 328px !important;\n    }\n\n    .main-form-view {\n      position: absolute;\n      width: 90%;\n      top: 63%;\n      left: 50%;\n      padding: 20px;\n      transform: translate(-50%);\n      border-radius: 16px;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n  }\n\n  .userIDControl:focus {\n    border: 1px solid gray !important;\n  }\n\n  .panNumberControl:focus {\n    border: 1px solid gray !important;\n  }\n\n  .passworsControl:focus {\n    border: 1px solid gray !important;\n  }\n\n  .re_cap {\n    margin: 0px;\n    display: block;\n    min-height: 100px;\n  }\n\n  .input-title-note {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    color: #000000;\n  }\n\n  .widthContainer {\n    width: 50%;\n  }\n\n  @media screen and (max-width: 1024px) {\n    .investor-carousel-new {\n      display: none !important;\n    }\n\n\n    .widthContainer {\n      width: 100% !important;\n    }\n\n    .main-form-view {\n      position: absolute;\n      width: 90%;\n      top: 63%;\n      left: 50%;\n      padding: 20px;\n      transform: translate(-50%);\n      border-radius: 16px;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #FFFFFF 100%);\n      box-shadow: 4px 14px 38px -10px rgba(95, 100, 103, 0.31);\n    }\n\n    .form-existing-wrap-login {\n      margin-left: 0px !important;\n      position: relative;\n    }\n  }\n\n  @media screen and (max-width: 425px) {\n    .login-forms {\n      width: 255px !important;\n    }\n\n    .box {\n      width: 220px;\n    }\n\n    .mobileInputGroup {\n      width: 220px;\n    }\n\n    .mobileInputGroup {\n      font-size: 12px;\n    }\n    .new-login-title {\n      font-size: 1.3rem !important;\n    }\n\n    .sm-w-100 {\n      width: 90% !important;\n      height: 41px !important;\n    }\n\n    .eye-sm {\n      right: 33px !important;\n    }\n\n    .sm-padding {\n      padding-top: 5px;\n    }\n\n    .input-title-note {\n      font-size: 12px !important;\n    }\n\n    .forms-container .login-form:not(.userId)>div {\n      min-height: 93px;\n    }\n  }\n\n  @media screen and (max-width: 375px) {\n    .main-form-view {\n      width: 90%;\n      padding: 10px;\n    }\n\n    .login-forms {\n      width: 240px !important;\n    }\n\n    .otp-txt {\n      font-size: 11px;\n    }\n  }\n\n  @media screen and (max-width: 310px) {\n    .pre-login-header .header-wrap-main .left-section .logo-main-hdfcmf {\n      margin-left: 0px;\n    }\n\n    .login-forms {\n      width: 210px !important;\n    }\n\n    .box,\n    .mobileInputGroup {\n      width: 202px;\n    }\n\n    .mobileInputGroup {\n      font-size: 12px;\n    }\n\n    .new-login-title {\n      font-size: 1rem !important;\n    }\n\n    .mobtxtDesc {\n      font-size: 12px !important;\n      line-height: 13px !important;\n    }\n\n    .main-form-view {\n      padding: 20px 11px !important;\n    }\n  }</style>");
$templateCache.put("app/components/modal/nonTransactionalTnc/directive/nonTransactionalTnc.html","<div class=modal-content id=tnc ng-init=init()><div data-ng-switch=transactionType><div data-ng-switch-when=KYC><div data-ng-include=\"\'app/components/modal/nonTransactionalTnc/directive/tncKycUpdate.html\'\"></div></div><div data-ng-switch-when=FATCA><div data-ng-include=\"\'app/components/modal/nonTransactionalTnc/directive/tncFatcaUpdate.html\'\"></div></div><div data-ng-switch-when=COBM><div data-ng-include=\"\'app/components/modal/nonTransactionalTnc/directive/tncCobm.html\'\"></div></div></div></div>");
$templateCache.put("app/components/modal/nonTransactionalTnc/directive/tncCobm.html","<ng-bind-html ng-if=termsConditionDynamic dynamic=termsConditionDynamic.content></ng-bind-html>");
$templateCache.put("app/components/modal/nonTransactionalTnc/directive/tncFatcaUpdate.html","<div class=modal-body><h6 class=margin-none>I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:</h6><br><ul><li>I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to the respective Scheme(s) under the Scheme Information Document(s), Statement of Additional Information, and the Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer Documents</strong>”) inter alia provisions on \'Foreign Account Tax Compliance Act (FATCA) and Common Reporting Standards (CRS) on Automatic Exchange of Information (AEOI) (Please visit the “Download” section on our website <a href={{HDFC_API.WEBSITE_LINK}} class=text-primary target=_blank>{{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and the terms and conditions for FATCA and CRS certification (please <a href={{HDFC_API.WEBSITE_LINK}}CMT/UPLOAD/ARTICLEATTACHMENTS/FATCA_INDIVIDUAL_AADHAR_FORM.pdf class=text-primary target=_blank><strong>click here</strong></a> to read), and hereby apply to the Trustee to update the information provided by me on the Platform. I hereby also confirm to have read, understood, and agree to abide by the Terms applicable to this Platform (Please <strong class=text-primary ng-click=showGeneralTnc()>click here </strong>to read).</li><li>I/We hereby confirm that the information provided by me/us is true, correct, and complete.</li><li>I/We hereby agree and confirm to inform HDFC AMC/HDFC MF/ Trustees promptly of any modification to the information provided initially. I further agree to abide by the provisions of the Scheme related documents.</li><li>I/We hereby authorize you to disclose, share, remit in any form/manner/mode the above information and/or any part of it including the changes/updates that may be provided by me/us to HDFC AMC/HDFC MF/ its Sponsor(s)/ Trustees, its employees, agents and third party service providers, SEBI registered intermediaries for single updation/ submission, any Indian or foreign statutory, regulatory, judicial, quasi- judicial authorities/agencies including but not limited to Financial Intelligence Unit-India (FIU-IND) etc without any intimation/advice to me/us.</li></ul><br><p style=\"font-style: italic\">The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general Terms and Conditions.</p></div>");
$templateCache.put("app/components/modal/nonTransactionalTnc/directive/tncKycUpdate.html","<div class=modal-body><h6 class=margin-none>I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:</h6><br><ul><li>I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to the respective Scheme(s) under the Scheme Information Document(s), Statement of Additional Information, and the Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer Documents</strong>”) (Please visit the “Download” section on our website <a href={{HDFC_API.WEBSITE_LINK}} target=_blank>{{HDFC_API.WEBSITE_LINK}}</a> to read) and the terms and conditions for supplementary KYC update (please <a href=\"{{HDFC_API.WEBSITE_LINK}}CMT/UPLOAD/ARTICLEATTACHMENTS/Supplementary_CKYC_Application_Form_20-01-2017_(Editable PDF)31012017.pdf\" class=text-primary target=_blank><strong>click here</strong></a> to read), and hereby apply to the Trustee to update the information provided by me on the Platform. I hereby also confirm to have read, understood, and agree to abide by the Terms applicable to this Platform (Please <strong class=text-primary ng-click=showGeneralTnc()>click here </strong>to read).</li><li>I/We hereby declare that the details furnished by me are true and correct to the best of my/our knowledge and belief and I/we undertake to inform you of any changes therein, immediately. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I/we am/are aware that I/we may be held liable for it. I/we hereby declare that I/we am/are not making this application for the purpose of contravention of any Act, Rules, Regulations or any statute of legislation or any notifications/directions issued by any governmental or statutory authority from time to time.</li><li>I/We hereby authorize you to disclose, share, remit in any form/manner/mode the above information and/or any part of it including the changes/updates that may be provided by me/us in such manner and to such authorities as may be required under the provisions of applicable laws.</li></ul><br><p style=\"font-style: italic\">The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general Terms and Conditions.</p></div>");
$templateCache.put("app/components/modal/otp/contact-otp-modal/contact-otp.modal.html","<!-- Otp verification--><div class=\"modal-content contact-update-modal\" id=confirm-otp><div class=\"modal-body clearfix\"><i class=times-icon ng-click=Modal.dismissModal();></i><form autocomplete=off name=Modal.modalOtpForm ng-submit=Modal.verifyOtp() novalidate><p class=text-center>We have sent two One-time Passwords(OTPs) for authentication purpose. Both OTPs are valid for 15 minutes only.<br></p><div class=\"input-group input-normal\" ng-class=\"{error:Modal.modalOtpForm.otpNumber.$dirty && Modal.modalOtpForm.otpNumber.$invalid}\"><input type=text ng-model=Modal.formData.otpNumber name=otpNumber is-number ng-change=Modal.resetValues() easyassist-key=mask-element required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter OTP 1</label><span class=error-input style=\"position: initial !important\" ng-messages=Modal.modalOtpForm.otpNumber.$error ng-show=Modal.modalOtpForm.otpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span><p>{{Modal.modalData.message}}</p></div><div class=\"input-group input-normal\" ng-class=\"{error:Modal.modalOtpForm.newOtpNumber.$dirty && Modal.modalOtpForm.newOtpNumber.$invalid}\"><input type=text ng-model=Modal.formData.newOtpNumber name=newOtpNumber is-number ng-change=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter OTP 2</label><span class=error-input style=\"position: initial !important\" ng-messages=Modal.modalOtpForm.newOtpNumber.$error ng-show=Modal.modalOtpForm.newOtpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span><p>{{Modal.modalData.message2}}</p></div><div class=reset-password-container><span class=forgot><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.resendOtp() class=forgot-pwd>Resend OTP</a> <a ng-show=\"countdown > 0\" ng-class=\"{\'forgot-pwd-disabled\': countdown > 0}\">Enable Resend OTP in {{countdown}}s</a></timer></span></div><div class=text-center><button type=submit ng-disabled=\"Modal.modalOtpForm.$invalid || Modal.processFlag || Modal.errorMessage\" class=\"btn btn-primary-action\">Submit</button></div><span class=error ng-if=Modal.errorMessage><span class=error-all-message>{{ Modal.errorMessage }}</span></span></form></div></div>");
$templateCache.put("app/components/modal/termcondition/directive/generalTnc.html","<!--rendered for web--><ng-bind-html ng-bind-html=transactionTermsData ng-if=showData></ng-bind-html><!--rendered for mobile view--><ng-bind-html dynamic=generalTerms></ng-bind-html>");
$templateCache.put("app/components/modal/termcondition/directive/generalTncSip.html","<ng-bind-html ng-bind-html=transactionTermsData ng-if=showData></ng-bind-html>");
$templateCache.put("app/components/modal/termcondition/directive/transactionalTermcondition.html","<div class=modal-content id=tnc ng-init=init()><div data-ng-switch=transactionType><div data-ng-switch-when=GENERAL><div data-ng-include=\"\'app/components/modal/termcondition/directive/generalTnc.html\'\"></div></div><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/components/modal/termcondition/directive/generalTncSip.html\'\"></div></div></div></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncBiometric.html","<div dynamic=biometricTnC.content></div><style>p,li {\n    margin-top:20px;\n    margin-bottom: 20px;\n  }\n  table {\n    margin:0 auto;\n    border:1px solid black;\n  }\n\n  table td {\n    padding: 10px;\n    border:1px solid black;\n  }\n\n  sup {\n    font-size: xx-small;\n  }\n  @media only screen and (max-width: 767px) {\n    h6 {\n      font-size: 16px;\n    }\n  }</style>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncDtp.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncEcart.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncFlexIndex.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncFlexSip.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncFlexStp.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncInstantRedemption.html","<div class=modal-body><h6 class=margin-none>I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:</h6><br><ul><li>I/We have read, understood and agree to abide by all the terms, conditions, rules, and regulations of the respective Scheme(s) under the Scheme Information Document(s) and Statement of Additional Information of HDFC Mutual Fund (hereinafter referred to as “<strong>Offer Documents</strong>”) (Please visit the “Download” section on our website <a href={{HDFC_API.WEBSITE_LINK}} target=_blank>{{Modal.HDFC_API.WEBSITE_LINK}}</a> to read). I hereby also confirm to have read, understood, and agree to abide by the Terms applicable to this Platform (Please <strong class=text-primary ng-click=showGeneralTnc()>click here </strong>to read).</li><li>Any request for transaction on the Platform shall be time stamped consistent with the terms of the Offer Documents. The Net Asset Value (NAV) for purchase /redemption /switch shall be based on the time of the business day on which the application is received on the Platform, and subject to the provisions of realisation of funds and cut off timings as described in the Offer Documents of HDFC MF. Any transactions entered on the Platform after the cut off time shall be deemed to be received on the succeeding business day and shall be processed accordingly. The decision of HDFC AMC in this regard shall be final and binding on me/us.</li><br><h6 class=margin-none>Instant Access Facility (IAF)</h6><li>Any valid request for redemption received through IAF on the Platform, in respect of HDFC Liquid Fund Scheme under the Growth Option of Regular Plan and Direct Plan, the credit of redemption proceeds into the registered bank account shall be instantly processed through Immediate Payment Service (IMPS) at any time or day of the week subject to the provisions of realisation of funds and cut off timings as described in the Offer Documents of HDFC MF as amended from time to time.</li><li>For the purpose of IAF, NAV applicable shall be as under:<ul class=type-circle><li>In respect of valid IAF request received up to 3.00 pm on a calendar day, the applicable NAV shall be the lower of<br>(i) NAV of previous calendar day and<br>(ii) NAV of calendar day on which the request is received;</li><li>In respect of valid IAF request received after 3.00 pm on a calendar day, the applicable NAV shall be lower of<br>(i) NAV of calendar day on which such request is received and<br>(ii) NAV of the next calendar day</li></ul></li><li>I/We shall be solely responsible for ensuring that all information provided to HDFC AMC/HDFC MF, including the bank account details, is accurate, and HDFC AMC/HDFC MF shall not be responsible to verify the accuracy of the information/details provided. I/We shall also be liable to inform HDFC AMC/HDFC MF/Registrar and Transfer Agent of any change in any details or information provided initially. If any incorrect bank account number is provided by me, the redemption proceeds could be credited to the said wrong bank account so provided by me/us and there is no guarantee of recovery of the same. HDFC AMC/HDFC MF shall not be held liable for any loss or damage that may be sustained by me/us on account of such error on my/our part. IAF shall be available only to the resident individual investors whose complete CBS (Core Banking System) account number is registered in the folio along with IFSC code and wherein Investor’s bank is immediate payment service (IMPS) enabled.</li></ul><br><p style=\"font-style: italic\">The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general Terms and Conditions.</p></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncPurchase.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncRedemption.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncRollover.html","<div class=modal-body><h6 class=margin-none>I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:</h6><br><ul><li>I/We have read, understood, and agree to the features, terms, conditions, rules, and regulations relating to the Roll over of the Scheme as stated in the Addendum published by HDFC AMC/HDFC MF in this regard and hereby provide my/our consent thereto.</li><li>I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to the respective Schemes under the Scheme Information Document(s), Statement of Additional Information, and the Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer Documents</strong>”) (Please visit the “Download” section on our website <a href={{HDFC_API.WEBSITE_LINK}} target=_blank>{{Modal.HDFC_API.WEBSITE_LINK}}</a> to read). I hereby also confirm to have read, understood, and agree to abide by the Terms applicable to this Platform (Please <strong class=text-primary ng-click=showGeneralTnc()>click here </strong>to read).</li><li>All declarations/confirmation provided by me/us during the initial subscription to the Scheme(s) shall continue to be applicable with respect to this consent for Roll over and shall continue to be binding on me/us.</li><li>Even after my/our consent to the roll over as conveyed herein, the Roll over may not materialize depending on restrictions under extant provisions of applicable laws/regulations or any other reason whatsoever. HDFC AMC/HDFC MF shall not be held liable for any loss or damage whatsoever that may be sustained by me/us as a result non-occurrence of the Roll over</li><li>I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this investment or in providing this consent.</li><li>The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the Scheme is being recommended to me/us;</li><li>I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC AMC/HDFC MF/ Distributor for this investment or in relation to this consent;</li></ul><br><p style=\"font-style: italic\">The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general Terms and Conditions.</p></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncSip.html","<!--<div dynamic=\"transactionModalData\" ng-if=\"showTerms\"></div>--><div class=modal-body><h6 class=margin-none>I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:</h6><br><ul><li>I/We have read, understood and agree to abide by all the terms, conditions, rules and regulations relating to the respective Scheme(s), enrolment for SIP, and Direct Debit / Standing Instruction facilities or the One Time Mandate (OTM) facility as the case may be, under the Scheme Information Document(s), Statement of Additional Information, and the Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “Offer Documents”) (Please visit the “Download” section on our website “<strong>Offer Documents</strong>”)(Please visit the “Download” section on our website <a href={{HDFC_API.WEBSITE_LINK}} target=_blank>{{Modal.HDFC_API.WEBSITE_LINK}}</a> to read), and hereby apply to the Trustee of HDFC Mutual Fund to register my/our SIP and to allot the Units of the said Scheme(s) of HDFC Mutual Fund, as indicated above. I hereby also confirm to have read, understood, and agree to abide by the Terms applicable to this Platform (Please <strong class=text-primary ng-click=showGeneralTnc()>click here </strong>to read).</li><li>I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this investment.</li><li>In accordance with SEBI Circular Cir/IMD/DF/13/2011 dated August 22, 2011, as amended from time to time, for purchases/subscriptions of Rs. 10,000/- and above through a Distributor, Transaction Charges shall be deducted from the subscription amount as follows:<ul class=type-circle><li>Rs. 150/- for a first time investor across mutual funds; or</li><li>Rs. 100/- for investor other than first time investor.</li><li>No Transaction Charges shall be deducted: (a) if the Distributor has not opted to receive any Transaction Charges; or (b) for purchases/subscriptions under Direct Plan (i. e., not through a Distributor).</li></ul></li><li>In case of investments through SIP, the transaction Charges are deductible, only if the total commitment of investment* is more than or equal to Rs. 10,000. In all such cases, the Transaction Charges shall be deducted in 3 to 4 installments. * Amount per SIP installment x No. of installments</li><li>The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the Scheme is being recommended to me/us;</li><li>I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC AMC/HDFC MF/ Distributor for this investment;</li><li>Units will be allotted on the applicable dates subject to realization of funds where total SIP investments on a date amount to Rs. 2 lakh or more. In case the date falls on a Non Business Day or falls during a book closure period, the immediate next Business Day will be considered for the purpose of determining the applicability of NAV subject to the realization of proceeds;</li><li>In case my/our OTM is not already registered, SIP Registration shall be completed only upon successful registration of auto debit instructions in favour of HDFC MF with my/our bank account for payment of SIP instalments. In case of my/our failure to complete the registration of auto debit instructions within 1 day from the date of registration for SIP on this Platform, HDFC AMC/HDFC MF shall reject my/our SIP registration and HDFC AMC/HDFC MF shall not liable for any loss or damage sustained by me/us on account of such rejection.</li></ul><br><p style=\"font-style: italic\">The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general Terms and Conditions.</p></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncSipEMandate.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncSipNurture.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncSmartSwp.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncStp.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncSwingStp.html","<div class=modal-body><h6 class=margin-none>I/WE HEREBY AGREE TO THE TERMS GIVEN BELOW:</h6><br><ul><li>I/We have read, understood, and agree to abide by all the terms, conditions, rules and regulations relating to the respective Schemes under the Scheme Information Document(s), Statement of Additional Information, and the Key Information Memorandum of HDFC Mutual Fund as amended from time to time (hereinafter referred as “<strong>Offer Documents</strong>”) (Please visit the “Download” section on our website <a href={{HDFC_API.WEBSITE_LINK}} target=_blank>{{Modal.HDFC_API.WEBSITE_LINK}}</a> to read) and the terms and conditions for enrolment for Swing STP (please click here to read), and hereby apply to the Trustee of HDFC Mutual Fund for enrolment under the Swing STP and to allot the Units of the said Scheme(s) of HDFC Mutual Fund, as indicated above. I hereby also confirm to have read, understood, and agree to abide by the Terms applicable to this Platform (Please <strong class=text-primary ng-click=showGeneralTnc()>click here </strong>to read).</li><li>I / We have neither received nor been induced by any rebate or gifts, directly or indirectly, in making this investment.</li><li>The Distributor has disclosed to me/us all the commissions (in the form of trail commission or any other mode), payable to him/them for the different competing Schemes of various Mutual Funds from amongst which the Scheme is being recommended to me/us;</li><li>I/We have not been offered/ communicated any indicative portfolio and/ or any indicative yield by the HDFC AMC/HDFC MF/ Distributor for this investment;</li></ul><br><p style=\"font-style: italic\">The capitalised terms used but not defined herein shall have the same meaning ascribed to it under the general Terms and Conditions.</p></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncSwitch.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/tncSwp.html","<div dynamic=dynamicTransactionalTerms></div>");
$templateCache.put("app/components/modal/transactionalTnc/directive/transactionalTermcondition.html","<div class=modal-content id=tnc ng-init=init()><div data-ng-switch=transactionType><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncPurchase.html\'\"></div></div><div data-ng-switch-when=SIP><!--<div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncSip.html\'\"></div>--><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncSipNurture.html\'\"></div></div><div data-ng-switch-when=SIP-E-MANDATE><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncSipEMandate.html\'\"></div></div><div data-ng-switch-when=SWITCH><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncSwitch.html\'\"></div></div><div data-ng-switch-when=REDEMPTION><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncRedemption.html\'\"></div></div><div data-ng-switch-when=INSTANT_REDEMPTION><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncInstantRedemption.html\'\"></div></div><div data-ng-switch-when=STP><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncStp.html\'\"></div><div ng-if=\"Modal.modalData.subTransactionType === \'Flex STP\'\" data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncFlexStp.html\'\"></div><div ng-if=\"Modal.modalData.subTransactionType === \'Swing STP\'\" data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncSwingStp.html\'\"></div></div><div data-ng-switch-when=Flex_STP><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncFlexStp.html\'\"></div></div><div data-ng-switch-when=Swing_STP><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncSwingStp.html\'\"></div></div><div data-ng-switch-when=FLEX_INDEX><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncFlexIndex.html\'\"></div></div><div data-ng-switch-when=SWP><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncSwp.html\'\"></div></div><div data-ng-switch-when=DTP><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncDtp.html\'\"></div></div><div data-ng-switch-when=SMART_SWAP><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncSmartSwp.html\'\"></div></div><div data-ng-switch-when=BIOMETRIC><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncBiometric.html\'\"></div></div><div data-ng-switch-when=ECART><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncEcart.html\'\"></div></div><div data-ng-switch-when=FLEX_SIP><div data-ng-include=\"\'app/components/modal/transactionalTnc/directive/tncFlexSip.html\'\"></div></div></div></div>");
$templateCache.put("app/firstLogin/welcome/widgets/basket-widget/basket-widget.html","<div class=\"bg-color col-md-12\"><div class=\"loader panAadhar-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=container><div class=row style=\"padding-bottom: 2.5%\"><div class=column><div class=card ng-repeat=\"basket in Basket.basket_widget\"><div class=content><div class=front><img class=profile width=100% src={{basket.image}} alt=basket_image><h2 class=pd-label>{{basket.label}}</h2></div><div class=\"back from-bottom\"><h2>{{basket.label}}</h2><p class=des>{{basket.description}}</p><button class=\"btn btn-primary-action navbar-btn navbar-btn-main basket-btn\" ng-click=Basket.redirectTo(basket.type)><span>{{basket.buttonText}}</span></button></div></div></div></div></div></div></div>");
$templateCache.put("app/firstLogin/welcome/widgets/banner-widget/banner-widget.html","<div class=\"row height100\"><div class=\"col-md-12 height100 banner-col\"><div id=bannerCarousel class=\"carousel slide height100\" data-bs-ride=carousel><ol class=carousel-indicators><li data-bs-target=#bannerCarousel ng-repeat=\"image in Banner.imageUrls\" data-bs-slide-to={{$index}} ng-class=\"{\'active\': $first}\"></li></ol><!-- Wrapper for slides --><div class=\"carousel-inner height100\"><div class=\"carousel-item height100\" ng-repeat=\"image in Banner.imageUrls track by $index\" ng-class=\"{\'active\': $first}\"><!--          <a href=\"{{image.url}}\" ng-if=\"image.url\">--><!--          <img src=\"{{image}}\">--><!--          </a>--> <img src={{image}} ng-if=!image.url></div></div><!-- Left and right controls --> <a class=\"left carousel-control\" data-bs-target=#bannerCarousel data-bs-slide=prev><span class=\"glyphicon glyphicon-chevron-left\"></span> <span class=sr-only>Previous</span> </a><a class=\"right carousel-control\" data-bs-target=#bannerCarousel data-bs-slide=next><span class=\"glyphicon glyphicon-chevron-right\"></span> <span class=sr-only>Next</span></a></div></div></div>");
$templateCache.put("app/firstLogin/welcome/widgets/calculator-widget/calculator-widget.html","<div class=row><div class=col-md-12><div class=section-header><div class=left-section><h4 class=section-title>Use our Calculators</h4><h5>Plan your Investments with our calculators</h5></div><div class=\"right-section hidden-xs\"><a href={{WEBSITE_LINK}}learn/calculators target=_blank>More Calculators</a></div></div></div></div><div class=\"row height100\"><div class=\"col-md-12 height100\"><div class=\"calculator-widget height100\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6\"><div><a href={{WEBSITE_LINK}}learn/sip target=_blank><div>Determine the monthly SIP investments you need to make to reach a particular goal.</div><div><i class=arrow-active-icon></i></div></a></div></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><div><a href={{WEBSITE_LINK}}learn/cost-of-child-education target=_blank><div>Estimate how much money you need to save every month to fund your child’s education in future.</div><div><i class=arrow-active-icon></i></div></a></div></div></div></div></div></div><div class=\"row visible-xs\"><div class=col-xs-12><div class=\"section-header section-align\"><div class=right-section><a href={{WEBSITE_LINK}}learn/calculators target=_blank>More Calculators</a></div></div></div></div>");
$templateCache.put("app/firstLogin/welcome/widgets/investment-widget/investment-widget.html","<div class=row><div class=col-md-12><div class=\"section-header portfolio-align\"><div class=left-section><h4 class=section-title>Portfolio</h4></div><div class=\"right-section hidden-xs\"><a ui-sref=main.portfolio.list>View Details</a></div></div></div></div><div class=\"row portfolio-transact-table\"><div class=col-md-12><div class=portfolio-section><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=section-details><div easyassist-key=mask-element><i class=rupee-blue-icon></i>{{Investment.constantDataDTO.totalPurchaseValue | truncateDecimal : 2 |unit:Investment.purchaseValueUnit}}</div><span>Total Cost Value</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=section-details><div easyassist-key=mask-element><i class=rupee-blue-icon></i>{{Investment.constantDataDTO.totalCurrentValue | truncateDecimal : 2 | unit:Investment.currentValueUnit}}</div><span>Total Market Value</span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=section-details><div><p class=xirrContent style=\"padding-bottom: 2px\" ng-if=\"Investment.constantDataDTO.xirrValue<0\">({{Investment.constantDataDTO.xirrValue | truncateDecimal : 2 | unit:Investment.constantDataDTO.xirrValueUnit}}{{Investment.constantDataDTO.xirrValueUnit|unitValue}})</p><p class=xirrContent style=\"padding-bottom: 2px\" ng-if=\"Investment.constantDataDTO.xirrValue>=0\">{{Investment.constantDataDTO.xirrValue | truncateDecimal : 2 | unit:Investment.constantDataDTO.xirrValueUnit}}{{Investment.constantDataDTO.xirrValueUnit|unitValue}}</p></div><span>XIRR% <span class=info-xirr-icon><a href=# tabindex=0 role=button class=\"base-tooltip info-xirr-margin xirr\" data-bs-toggle=tooltip data-bs-placement=top data-bs-title={{Investment.xirrInfo}}><img src=assets/images/info-icon.svg alt=info> </a><!--<i class=\"info-icon base-tooltip info-xirr-margin\" ></i>--></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=section-details><div>{{Investment.schemeCount}}</div><span>Total Number of Schemes</span></div></div></div></div></div></div><div class=\"row visible-xs\"><div class=col-xs-12><div class=\"section-header section-align\"><div class=right-section><a ui-sref=main.portfolio.list>View Details</a></div></div></div></div>");
$templateCache.put("app/firstLogin/welcome/widgets/quick-link-widget/quick-link-widget.html","<div class=\"row height100\"><div class=\"col-md-12 height100\"><div class=quick-link-widget><div class=\"row height100\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=calculate-section><div><h4>Calculate your<br>Goal</h4></div><div>Are you planning to<br>invest for retirement or<br>your children’s future?</div><div><a class=link-action href={{QuickLink.HDFC_API.WEBSITE_LINK}}learn/goal-sip target=_blank>Calculate now</a></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=quick-link-section><div><h4>Quick Links</h4></div><div><ul><li ng-repeat=\"(key, value) in QuickLink.quickLinks\"><a ng-model=value href={{value}}><img src=assets/images/right-arrow-blue.svg class=quick-link-icon>{{key}}</a></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/firstLogin/welcome/widgets/statement-widget/statement-widget.html","<div class=row><div class=col-md-12><div class=section-header><div class=left-section><h4 class=section-title>Statements</h4></div><div class=right-section><div id=myNavbar class=statement-dropdown><ul class=\"nav navbar-nav navbar-right\"><li class=dropdown><a class=dropdown-toggle data-bs-toggle=dropdown href=#>Other Statements <span class=\"arrow arrow-down\"></span></a><ul class=dropdown-menu><li><a ui-sref=\"main.statements({type:\'balance\'})\">Balance Confirmation Report</a></li><li><a ui-sref=\"main.statements({type:\'dividend\'})\">IDCW</a></li><li><a ui-sref=\"main.statements({type:\'exitLoad\'})\">Exit Load</a></li></ul></li></ul></div><!--<a href=\"#\">Other Statements</a>--></div></div></div></div><div class=\"row height100\"><div class=\"col-md-12 height100\"><div class=\"statement-widget height100\"><form name=tForm><div class=row><div class=col-md-12><div class=section-header><div class=left-header><div class=tabs><div ng-class=\"{\'active-tab\': Statements.isCheckedAccount}\" ng-click=\"Statements.changeStatementType(\'account\')\">Account Statement</div><div ng-class=\"{\'active-tab\': Statements.isCheckedCapital}\" ng-click=\"Statements.changeStatementType(\'capital\')\">Capital gain</div></div></div><div class=\"right-header hidden-xs\"><button ng-if=Statements.enableDownloadCTA ng-disabled=\"tForm.$invalid || (Statements.formData.statementOption==\'P\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=Statements.downloadStatement() ng-class=\"{\'hidebutton\': (Statements.selectedTab === \'capital\' && Statements.formData.statementOption === Statements.STATEMENT_OPTIONS.FULL)}\"><i class=download-icon></i>Download</button> <button ng-disabled=\"tForm.$invalid || (Statements.formData.statementOption==\'P\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=Statements.generateStatement()><i class=email-icon></i>Email</button></div></div></div></div><div class=row><div class=col-md-12><form><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=\"selectfield folio\" ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\"><select name=folio ng-change=Statements.folioChanged(Statements.formData.folioNumber) ng-model=Statements.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber  for folio in Statements.folioList\" ng-init=\"Statements.formData.folioNumber = Statements.formData.folioNumber? Statements.formData.folioNumber: null\" required><option value=\"\">Folio Number</option></select><span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\"><span class=error-input ng-show=tForm.folio.$error.required ng-bind=Statements.VALIDATE_DATA.FOLIO_REQUIRED></span></span><label>Folio Number</label></div></div><!--Commented for HMF-24569--><!--<div class=\"col-xs-12 col-sm-6 col-md-6\" ng-if=\"Statements.selectedTab === \'account\'\"\n                     ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber, \'anything-disabled schemeDisabled\': Statements.formData.folioNumber && Statements.schemeList.length === 0}\">\n                  <div class=\"selectfield scheme\"\n                       ng-class=\"{error:tForm.scheme.$dirty && tForm.scheme.$invalid}\">\n                    <select name=\"scheme\" ng-if=\"!Statements.formData.folioNumber\">\n                      <option value=\"\">Select Scheme</option>\n                    </select>\n                    <select name=\"scheme\" ng-if=\"Statements.formData.folioNumber\"\n                            ng-change=\"Statements.schemeChanged(Statements.formData.scheme)\"\n                            ng-model=\"Statements.formData.scheme\"\n                            ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Statements.schemeList\"\n                            ng-init=\"Statements.formData.scheme = Statements.formData.scheme? Statements.formData.scheme: null\"\n                            ng-disabled=\"Statements.schemeList.length === 0\" ng-required=\"Statements.schemeList.length > 0\">\n                      <option value=\"\">Select Scheme</option>\n                    </select>\n                    <p class=\"info-primary\" ng-if=\"Statements.formData.folioNumber && Statements.schemeList.length === 0\"><i class=\"info-icon\"></i><span>{{Statements.schemeNotAvailable}}</span></p>\n                    <span ng-show=\"tForm.scheme.$dirty && tForm.scheme.$invalid\">\n                          <span class=\"error-input\" ng-show=\"tForm.scheme.$error.required\"\n                                ng-bind=\"Statements.VALIDATE_DATA.SCHEME_REQUIRED\"></span>\n                        </span>\n                    <label>Scheme</label>\n                  </div>\n                </div>--></div></form></div></div><div class=row><div class=col-md-12><div class=row><p class=\"form-group col-md-12\"><strong>Select Period</strong></p><div class=\"col-sm-3 col-md-3\" ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.FULL ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Full Statement</span></div></div><div class=\"col-sm-3 col-md-3\" ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.PREVIOUS ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Previous F.Y</span></div></div><div class=\"col-sm-3 col-md-3\" ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.CURRENT ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Current F.Y</span></div></div><div class=\"col-sm-3 col-md-3\" ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.PERIOD ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Period</span></div></div></div></div></div><div class=row ng-if=\"Statements.isCheckedAccount && Statements.formData.statementOption==\'P\'\"><div class=\"col-sm-5 col-md-5\"><div class=\"input-select input-normal input-group date date-picker Statements-cal start-date\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.startDate data-on-date-change=Statements.changeStartDate maxdate=now format=DD-MMM-YYYY id=startDateDividend ng-class={error:Statements.tForm.startDate.$invalid}><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.startDate.$error.required ng-bind=Statements.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div><div class=\"col-sm-1 col-md-1 text-center mid-text\">To</div><div class=\"col-sm-5 col-md-5\"><div class=\"input-select input-normal input-group date date-picker Statements-cal end-date\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.endDate data-enabled-dates=Statements.enabledEndDates data-on-date-change=Statements.changeEndDate min=Statements.formData.minEndDate data-format=DD-MMM-YYYY max=now data-showdefault=false id=endDateDividend ng-class={error:Statements.tForm.endDate.$invalid}><input type=text name=endDate placeholder=\"End Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.endDate.$error.required ng-bind=Statements.VALIDATE_DATA.END_DATE_REQUIRED></span></div></div></div><div class=row ng-if=\"Statements.isCheckedCapital && Statements.formData.statementOption==\'P\'\"><div class=\"col-sm-5 col-md-5\"><div class=\"input-select input-normal input-group date date-picker Statements-cal start-date\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.startDate data-on-date-change=Statements.changeCaptailGainStartDate data-max-date=Statements.startMaxDate format=DD-MMM-YYYY id=startDate ng-class={error:Statements.tForm.startDate.$invalid}><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.startDate.$error.required ng-bind=Statements.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div><div class=\"col-sm-1 col-md-1 text-center mid-text\">To</div><div class=\"col-sm-5 col-md-5\"><div class=\"input-select input-normal input-group date date-picker Statements-cal end-date\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.endDate data-enabled-dates=Statements.capitalGainEnabledEndDates data-on-date-change=Statements.changeEndDate data-min-date=Statements.capitalGainEnabledEndDates[0] data-format=DD-MMM-YYYY data-max-date=Statements.endMaxDate data-showdefault=false id=endDate ng-class={error:Statements.tForm.endDate.$invalid}><input type=text name=endDate placeholder=\"End Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.endDate.$error.required ng-bind=Statements.VALIDATE_DATA.END_DATE_REQUIRED></span></div></div></div><div class=\"row visible-xs\"><div class=col-xs-12><div class=\"section-header header-align\"><div class=right-header><button ng-if=Statements.enableDownloadCTA ng-disabled=\"tForm.$invalid || (Statements.formData.statementOption==\'P\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=Statements.downloadStatement() ng-class=\"{\'hidebutton\': (Statements.selectedTab === \'capital\' && Statements.formData.statementOption === Statements.STATEMENT_OPTIONS.FULL)}\"><i class=download-icon></i>Download</button> <button ng-disabled=\"tForm.$invalid || (Statements.formData.statementOption==\'P\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=Statements.generateStatement()><i class=email-icon></i>Email</button></div></div></div></div></form></div></div></div>");
$templateCache.put("app/firstLogin/welcome/widgets/header/header-banner.html","<div class=welcome-background ng-class=\"{\'welcome-existing-background\': Welcome.isExistingInvestor, \'welcome-offline-background\': !Welcome.isExistingInvestor}\"><div class=background-title><label>{{Welcome.greetings}}, <span>{{Welcome.userFirstName}}</span></label></div></div>");
$templateCache.put("app/firstLogin/welcome/widgets/systematic-widget/systematic-widget.html","<div class=row><div class=col-md-12><div class=section-header><div class=left-section><h4 class=section-title>Systematic Corner</h4></div><div class=\"right-section hidden-xs\"><a ui-sref=main.systematicCorner ng-if=\"Systematic.systematicList.length > 0\">View all Systematic Transactions</a></div></div></div></div><div class=\"row height100\"><div class=\"col-md-12 height100\"><div class=\"table-widget table-responsive\" ng-if=\"Systematic.systematicList.length > 0\"><table class=\"table table-responsive\"><thead><tr class=select-th><th>Scheme name</th><th>Transaction type</th><th>Amount</th><th>Status</th><th></th></tr></thead><tbody><tr ng-if=Systematic.systematicList ng-repeat=\"data in Systematic.systematicList.slice(0,3)\"><td class=table-align style=\"width: 45%\">{{data.sourceScheme}}</td><td class=table-align>{{data.type}}</td><td class=\"date-width table-align\" ng-if=\"data.type!=\'DTP\'\"><div ng-if=\"data.amount != \'0\'\"><i class=rupee-small-icon></i>{{data.amount|unit:data.amount}}</div><div ng-if=\"data.amount == \'0\' || data.amount == \'0.0\'\">NA</div><div class=small-grey style=\"font-size: 10px\">({{data.frequency}})</div></td><td class=table-align ng-if=\"data.type==\'DTP\'\"><div>{{\'NA\'}}</div></td><td class=\"table-align status\"><span>{{data.status}}</span></td><td><span class=\"btn-more dropdown drop-selects\"><button class=\"btn-primary-action dropdown-toggle button-width\" data-bs-toggle=dropdown ng-if=\"data.topUpAction!==undefined && data.folioNumber && data.schemeCode && data.topUpAction.length!==0\">{{Systematic.topUpLabel || Systematic.top_Up_label}}<i class=arrow-white-down-icon></i></button><ul class=dropdown-menu><li>{{Systematic.topUpLabel || Systematic.top_Up_label}} <i class=arrow-blue-down-icon></i></li><li class=list-group-item ng-click=Systematic.selectTransaction(action,data) ng-repeat=\"action in data.topUpAction\">{{action}} <i class=\"arrow-right-icon pull-right\"></i></li></ul></span></td></tr></tbody></table></div><div class=\"systematic-widget height100\" ng-if=\"Systematic.systematicList.length==0\"><div><div>There are no Systematic Transactions!</div><div><a ui-sref=main.transactions.sip class=transact-action>SIP</a></div></div></div></div></div><div class=\"row visible-xs\"><div class=col-xs-12><div class=\"section-header section-align\"><div class=right-section><a ui-sref=main.systematicCorner>View all Systematic Transactions</a></div></div></div></div>");
$templateCache.put("app/firstLogin/welcome/widgets/transact-now-widget/transact-now.html","<div class=row><div class=col-md-12><div class=section-header><div class=left-section><h4 class=section-title>Transact Now</h4><h5>Initiate a transaction to get started</h5></div></div></div></div><div class=row><div class=col-md-12><div class=transactWidget><div class=\"row height100\"><div class=\"col-xs-12 col-sm-6 col-md-6 height100\"><div class=transact-section><div><img src=assets/images/transact-sip.svg alt=sip></div><div>Initiate Systematic<br>Investment Plan (SIP)</div><div><a ui-sref=main.transactions.sip class=transact-action>SIP</a></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 height100\"><div class=transact-section><div><img src=assets/images/transact-purchase.svg alt=purchase></div><div>Initiate Lumpsum<br>Purchase</div><div><a ui-sref=main.transactions.purchase class=transact-action>PURCHASE</a></div></div></div></div></div></div></div>");
$templateCache.put("app/firstLogin/welcome/widgets/transaction-widget/transaction-widget.html","<div class=row><div class=col-md-12><div class=section-header><div class=left-section><h4 class=section-title>Recent Transactions</h4></div><div class=\"right-section hidden-xs\"><a ui-sref=main.transactions.all>View All Transactions</a></div></div></div></div><div class=\"row recent-transact-table\"><div class=col-md-12><div class=\"table-widget table-responsive overflow-hide\" ng-if=\"Transaction.transactionList.length > 0\"><table class=\"table table-responsive\"><thead><tr class=select-th><th>Folio no.</th><th>Scheme name</th><th>Transaction type</th><th>Amount</th><th></th></tr></thead><tbody><tr ng-repeat=\"data in Transaction.transactionList\"><td style=\"width: 25%\">{{data.folioNumber}}</td><td>{{data.scheme}}</td><td>{{Transaction.transactionTypeValues[$index]}}</td><td data-th=Amount class=text-left><span ng-if=\"!data.amount && data.amount === 0\">--</span> <span ng-if=\"data.amount!=0 && data.amount>=0\"><i class=rupee-small-icon></i>{{data.amount.toFixed(2)|unit:data.amount}}</span></td><td><span class=\"btn-more dropdown drop-select-trans\"><button ng-if=\"data.topUpAction!==undefined && data.folioNumber && data.schemeCode && data.topUpAction.length!==0\" class=\"btn-primary-action dropdown-toggle\" data-bs-toggle=dropdown style=\"width: 77px\">{{Transaction.topUpLabel || Transaction.top_Up_label}} <i class=arrow-white-down-icon></i></button><ul class=dropdown-menu><li>{{Transaction.topUpLabel || Transaction.top_Up_label}} <i class=arrow-blue-down-icon></i></li><li class=list-group-item ng-click=Transaction.selectTransaction(data,action) ng-repeat=\"action in data.topUpAction\">{{action}} <i class=\"arrow-right-icon pull-right\"></i></li></ul></span></td></tr></tbody></table></div><div class=\"table-widget height100\" ng-if=\"Transaction.transactionList.length==0\"><div><span>There are no Recent Transactions!</span></div></div></div></div><div class=\"row visible-xs\"><div class=col-xs-12><div class=\"section-header section-align\"><div class=right-section><a ui-sref=main.transactions.all>View All Transactions</a></div></div></div></div><style>.overflow-hide{\n  overflow-x: visible !important;\n}\n.dropdown-backdrop {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n}\n@media screen and (max-width: 767px){\n  .overflow-hide{\n    overflow-y: auto !important;\n  }\n}\n.select-th th:nth-child(3){\n  padding-right: 12px !important;\n  padding-left: 2px !important;\n}</style>");
$templateCache.put("app/firstLogin/welcome/widgets/video-widget/video-widget.html","<div class=row><div class=col-md-12><div class=\"section-header video-widget-title\"><div class=left-section><h4 class=section-title>Watch Videos</h4><h5>Take guidance from step-by-step videos for initiating Transactions</h5></div><div class=\"right-section hidden-xs\" ng-if=\"Video.videoUrls.length > 0\"><a ui-sref=videos>View all Videos</a></div></div></div></div><div class=row><div class=col-md-12><div class=video-widget><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6\" ng-repeat=\"section in Video.videoUrls.slice(0,2)\"><div class=video-container ng-click=Video.playVideo(section.url)><div class=video-thumbnail><img src={{section.thumbnail}} alt=Videos style=\"width: 100%\" ng-class=\"{\'video-thumbnail\': section.thumbnail.includes(\'assets\')}\"></div><div class=video-meta><div class=video-play><img src=assets/images/play-button.svg></div><div class=video-title><div>{{section.name}}</div></div></div></div></div></div></div></div></div><div class=\"row visible-xs\"><div class=col-xs-12><div class=\"section-header section-align\"><div class=right-section><a ui-sref=videos>View all Videos</a></div></div></div></div>");
$templateCache.put("app/investor/addFolio/folio-directive/bankDetails/folio-bank-details-directive.html","<div><form autocomplete=off name=bankDetailsForm novalidate><div class=\"col-md-12 form-content bank-details\"><h6 ng-if=\"firstFlow == \'YES\'\">Bank Details <span>(These bank details would be used for payout purposes)</span></h6><p ng-if=\"firstFlow == \'NO\'\">Account Details <span>(This bank is for IDCW Payout and Redemption purposes.)</span></p><div class=row><div class=\"col-md-12 form-group accnt-optns\" ng-if=isSoleApplicantMinor><span class=radio-block><span class=radio><input type=radio name=bankOptions value=MINOR ng-model=bankPayload.bankDetails.bankHolderType> <span class=check></span></span><label>Account held by Minor</label></span><span class=radio-block><span class=radio><input type=radio name=bankOptions value=INVESTOR ng-model=bankPayload.bankDetails.bankHolderType> <span class=check></span></span><label>Account held by Investor <span class=small-grey-text>(in the capacity of the guardian)</span></label></span></div></div><div class=\"row foliobank-enableclass\"><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid}\"><input type=text ng-model=bankPayload.bankDetails.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-maxlength=11 limit-to=11 ng-pattern=IFSC_REGEX capitalize required readonly> <span class=highlight></span> <span class=bar></span> <span class=\"glyphicon glyphicon-search\" ng-click=selectIFSC()></span><label ng-class={ifscBlank:!bankPayload.bankDetails.ifsccode}>IFSC<span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid\"><span class=error-input ng-show=bankDetailsForm.ifsccode.$error.required ng-bind=bkValidateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=bankDetailsForm.ifsccode.$error.pattern ng-bind=bkValidateData.IFSC_CODE_REGEX></span></span></div></div><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:bankDetailsForm.bankName.$dirty && bankDetailsForm.bankName.$invalid}\"><input type=text ng-model=bankPayload.bankDetails.bankName name=bankName ng-disabled=!bankPayload.bankDetails.bankName ng-class={enable:bankPayload.bankDetails.bankName} ng-readonly=bankPayload.bankDetails.bankName> <span class=highlight></span> <span class=bar></span><label>Bank Name<span class=\"req text-red\">*</span></label></div></div><div class=col-md-4><div class=\"selectfield selectionIcon\" ng-class=\"{error:bankDetailsForm.accountType.$dirty && bankDetailsForm.accountType.$invalid}\"><select class=\"select-box select-box-border-folioDetails height-align\" name=accountType ng-model=bankPayload.bankDetails.accountType ng-init=\"bankPayload.bankDetails.accountType= bankPayload.bankDetails.accountType ? bankPayload.bankDetails.accountType: null\" ng-options=\"_type.accountTypeCode as _type.accountType for _type in bankTypeList\" required ng-disabled=!bankPayload.bankDetails.ifsccode ng-class={disablefield:!bankPayload.bankDetails.ifsccode}><option value=\"\" selected>Account Type</option></select><label ng-if=bankPayload.bankDetails.accountType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=bankDetailsForm.accountType.$error ng-show=bankDetailsForm.accountType.$dirty><span ng-message=required ng-bind=bankValidateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=\"row foliobank-enableclass\"><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:bankDetailsForm.branchLocation.$dirty && bankDetailsForm.branchLocation.$invalid}\"><input type=text ng-model=bankPayload.bankDetails.bankBranch maxlength=40 name=branchLocation required autocomplete=off capitalize ng-disabled=!bankPayload.bankDetails.ifsccode ng-class={enable:bankPayload.bankDetails.bankBranch}> <span class=highlight></span> <span class=bar></span><label>Branch Location <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.branchLocation.$dirty && bankDetailsForm.branchLocation.$invalid\"><span class=error-input ng-show=bankDetailsForm.branchLocation.$error.required ng-bind=bkValidateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:bankDetailsForm.branchCity.$dirty && bankDetailsForm.branchCity.$invalid}\"><input type=text ng-model=bankPayload.bankDetails.bankCity name=branchCity ng-maxlength=35 limit-to=35 maxlength=35 only-alphabets autocomplete=off capitalize required ng-disabled=!bankPayload.bankDetails.ifsccode ng-class={enable:bankPayload.bankDetails.bankCity}> <span class=highlight></span> <span class=bar></span><label>Branch City <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.branchCity.$dirty && bankDetailsForm.branchCity  .$invalid\"><span class=error-input ng-show=bankDetailsForm.branchCity.$error.required ng-bind=bkValidateData.CITY_REQUIRED></span></span></div></div><div class=col-md-4><div class=\"selectfield selectionIcon\" ng-class=\"{error:bankDetailsForm.payoutMechanism.$dirty && bankDetailsForm.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select height-align select-box-border-folioDetails\" name=payoutMechanism ng-model=bankPayload.bankDetails.payoutMechanism ng-init=\"bankPayload.bankDetails.payoutMechanism= bankPayload.bankDetails.payoutMechanism ? bankPayload.bankDetails.payoutMechanism: null\" ng-options=\"_type.payoutCode as _type.payoutDescription for _type in payoutMechanismList\" required ng-disabled=!bankPayload.bankDetails.ifsccode ng-class={disablefield:!bankPayload.bankDetails.ifsccode}><option value=\"\" selected>Payout Mechanism</option></select><label ng-if=bankPayload.bankDetails.payoutMechanism>Payout Mechanism</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=bankDetailsForm.payoutMechanism.$error ng-show=bankDetailsForm.payoutMechanism.$dirty><span ng-message=required ng-bind=bkValidateData.PAYOUT_MECH_REQUIRED></span></span></div></div></div><div class=\"row foliobank-enableclass\"><div class=col-md-4><div class=\"input-normal mgt8\" ng-class=\"{error:  (BankDetails.accModelDirty &&\n                 (!bankPayload.bankDetails.accountNumber.split(\'\').length || bankPayload.bankDetails.accountNumber.split(\'\').length>25))}\"><input type=text ng-model=bankPayload.bankDetails.accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-maxlength=20 maxlength=20 name=accountNumber limit-to=20 easyassist-key=mask-element required autocomplete=off directive.mask ng-change=accFocus(); capitalize ng-disabled=!bankPayload.bankDetails.ifsccode ng-class={enable:bankPayload.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Account Number <span class=\"req text-red\">*</span></label><span ng-show=accModelDirty><span class=error-input ng-show=\"bankPayload.bankDetails.accountNumber.split(\'\').length==0\" ng-bind=bkValidateData.ACCOUNT_NUMBER_REQUIRED></span><!--<span class=\"error-input\"\n                    ng-show=\"(!bankPayload.bankDetails.accountNumber.split(\'\').length || bankPayload.bankDetails.accountNumber.split(\'\').length>25)\"\n                    ng-bind=\"bkValidateData.ACCOUNT_NUMBER_RANGE\"></span>--> <span class=error-input ng-show=bankDetailsForm.accountNumber.$error.required ng-bind=bkValidateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(bankPayload.bankDetails.accountNumber.split(\'\').length !=0 && bankPayload.bankDetails.accountNumber.split(\'\').length<1)\" ng-bind=bkValidateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=col-md-4><div class=\"input-normal labelInvalid mgt8\" ng-class=\"{error:bankDetailsForm.verifyAccountNumber.$dirty && bankDetailsForm.verifyAccountNumber.$invalid}\"><input type=text ng-model=bankPayload.bankDetails.verifyAccountNumber maxlength=20 name=verifyAccountNumber limit-to=20 ng-maxlength=20 onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-pattern=bankPayload.bankDetails.accountNumber easyassist-key=mask-element required autocomplete=off ng-keydown=copyPasteHandler($event) capitalize ng-disabled=!bankPayload.bankDetails.ifsccode ng-class={enable:bankPayload.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Verify Account Number <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.verifyAccountNumber.$dirty && bankDetailsForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=bankDetailsForm.verifyAccountNumber.$error.required ng-bind=bkValidateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"bankDetailsForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\" ng-bind=bkValidateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"bankDetailsForm.verifyAccountNumber.$error.pattern\n            && !bankDetailsForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\">{{bkValidateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div><div class=\"row form-grid\" ng-show=\"bankPayload.bankDetails.chequeLeaf || bankPayload.bankDetails.pennyDropValid === false\"><span class=leaf-label>Upload Cheque Leaf <i class=\"info-icon base-tooltip\" data-bs-html=true data-bs-toggle=tooltip data-bs-placement={{Main.tooltipClass}} title=\"Account Number and Name should be printed the face of cheque.\nMax file size should be less than or equal to 2 MB.File format should be tiff, tif, jpg and jpeg extension.\"></i> <span class=\"req text-red\">*</span></span><div class=upload-leaf><input id=uploadCheckLeaf type=file name=pic accept=\"image/*, application/*\" file-model-profile=chequeLeaf upload=bankUploadChequeLeafFile(file) ng-model=bankPayload.bankDetails.chequeLeaf ng-required=!bankPayload.bankDetails.pennyDropValid><div class=file-upload><button>Choose File</button><span ng-if=chooseAFile>No File Chosen</span> <span ng-if=\"fileType === \'tif\' || fileType === \'tiff\'\"><a href=javascript:void(0) ng-click=downloadPdfFile(bankchequeLeafUrl,fileType)>Download</a></span> <span ng-if=\"fileType == \'jpg\' ||  fileType == \'jpeg\'\" ng-click=openUploadedDoc(bankPayload.bankDetails.chequeLeaf)>{{bankChequeLeaf}}</span></div></div></div><ng-bind-html dynamic=dynamicNote.content></ng-bind-html><ng-bind-html dynamic=dynamicNoteList.content></ng-bind-html><div class=\"form-footer form-content\"><span class=\"pull-left back\" ng-click=bankBack() ng-if=!isDreamSip><i class=arrow-blue-back-icon></i><span ng-if=\"firstFlow == \'YES\'\"> Previous</span><span ng-if=\"firstFlow == \'NO\'\"> Previous</span></span> <input ng-if=\"firstFlow == \'NO\'&& !isDreamSip\" type=button value=Save class=\"btn btn-secondary-action common-btn-padding\" ng-click=saveDetails()> <button type=button class=\"btn btn-primary-action common-btn-padding pull-right\" ng-if=\"!bankPayload.bankDetails.chequeLeaf && bankPayload.bankDetails.pennyDropValid\" ng-disabled=bankDetailsForm.$invalid ng-click=validatePennyDropDetails()>Validate</button> <input ng-if=\"(firstFlow == \'NO\' && bankPayload.bankDetails.chequeLeaf) || (firstFlow == \'NO\' && !bankPayload.bankDetails.pennyDropValid)\" type=button value=Continue class=\"btn btn-primary-action common-btn-padding\" ng-disabled=bankDetailsForm.$invalid ng-click=done()><!--|| !bankChequeLeaf--> <button ng-if=\"(firstFlow == \'YES\' && bankPayload.bankDetails.chequeLeaf) || (firstFlow == \'YES\' && !bankPayload.bankDetails.pennyDropValid)\" class=\"btn btn-primary-action common-btn-padding pull-right\" ng-disabled=\"bankDetailsForm.$invalid  || isBuzy || !bankChequeLeaf\" ng-click=done()>Continue</button></div></div></form><script>$(document).ready(function(){\n      $(\'[data-bs-toggle=\"tooltip\"]\').tooltip();\n    });</script><style>.ifscBlank {\n      top:15px !important;\n    }</style></div>");
$templateCache.put("app/investor/addFolio/folio-directive/holdMode/folio-holdMode-directive.html","<!-- Self Section Start--><div class=tab-content><button class=\"mobile-show mobile-accordion clearfix\"><a data-bs-toggle=tab href=#applicant-details><strong>Hold Mode Details</strong><i class=\"accordian-arrow-down-icon pull-right\"></i></a></button><div id=applicant-details class=\"tab-pane fade in active\"><form name=holdmodeForm novalidate><div class=form-content><div class=form-group><p class=folio-title ng-if=\"firstFlow == \'YES\'\">Folio Creation</p><span ng-if=\"firstFlow == \'NO\'\"><strong>Folio Creation:</strong></span><div class=folio-minor><span class=\"holdMode-label radio-block\"><span class=radio><input type=radio id=selefId name=isMinor ng-model=holders.minor ng-change=setMinorFlag() ng-value=false required> <span class=check></span></span><label for=selefId>Self</label></span><span class=\"holdMode-label radio-block minorlabel\"><span class=radio><input type=radio id=monorId name=isMinor ng-model=holders.minor ng-change=setMinorFlag() ng-value=true required> <span class=check></span></span><label for=monorId>Minor</label></span></div></div></div><div class=form-content style=\"margin-top: -30px\"><p><strong>Select mode of holding</strong></p><div class=\"holdMode-label radio-block\"><div class=\"radio mg20\"><input type=radio id=single name=holdmode ng-model=holders.holdmode ng-value=CONST.INVESTOR_HOLD_MODE.SINGLE ng-change=setHoldmode() required> <span class=check></span></div><label for=single>Single</label></div><div class=\"holdMode-label radio-block\" style=\"display:  block;margin-top: 16px\" ng-class=\"{\'anything-disabled\':(holders.minor)}\"><div class=radio><input type=radio id=aos name=holdmode ng-model=holders.holdmode ng-value=CONST.INVESTOR_HOLD_MODE.AOS ng-change=setHoldmode() ng-disabled=holders.minor required> <span class=check></span></div><label for=aos>Anyone or Survivor</label></div></div><hr><div class=\"form-footer form-content\"><input ng-if=\"firstFlow == \'NO\'\" type=button ng-disabled=holdmodeForm.$invalid class=\"btn btn-secondary-action common-btn-padding\" ng-click=saveFolio() value=Save> <input type=submit class=\"btn btn-primary-action common-btn-padding pull-right\" ng-disabled=holdmodeForm.$invalid value=Continue ng-click=continueFolio()></div></form></div></div>");
$templateCache.put("app/investor/addFolio/folio-directive/jointHolders/folio-joint-holders-directive.html","<div class=investors><form autocomplete=off class=nominee-section name=jointHolderForm ng-submit=continue() novalidate><div class=form-content><div class=\"nominee-title clearfix\"><span class=\"pull-left details\"><strong>Holder Details</strong></span></div><div class=nominee-list><table><thead><tr><th class=col-md-2>&nbsp;</th><th class=col-md-4>Name</th><th class=col-md-4>Pan</th><th class=col-md-4>&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"data in jointHoldersPayload.jointHolders\"><td class=col-md-2>{{enum[$index+1]}} Holder</td><td class=col-md-4><input type=text name=jointHolderName-{{$index}} value=\"{{data.firstName?data.firstName+\' \'+data.lastName : data.jointHolderName}}\" readonly></td><td class=col-md-4><div><input type=text name=panNumber-{{$index}} ng-model=data.pan easyassist-key=mask-element readonly> <span class=highlight></span> <span class=bar></span></div></td><!--          <td class=\"col-md-4\" ng-if=\"jointHoldersPayload.jointHolders.length > 1\">--><td class=col-md-4><i class=delete-red-icon ng-click=deleteCurrentJointHolder($index)></i></td></tr></tbody></table></div><div class=tab-container><ul class=\"mobile-hide nav nav-tabs\"><li ng-repeat=\"data in jointHoldersPayload.jointHolders\" ng-click=\"currentJointHolder.index = $index\" ng-class=\"{\'active\':currentJointHolder.index===$index}\">{{enum[$index+1]}} Holder Details</li></ul><div class=\"pull-right add-another-nominee\" ng-click=addMoreJointHolder() ng-if=\"jointHoldersPayload.jointHolders.length<2\"><a href=\"\" class=text-blue><strong><i class=plus-icon></i>Add Another Holder</strong></a></div></div><div class=tab-content><div><button class=\"mobile-show mobile-accordion clearfix\"><a data-bs-toggle=tab href=#add-joint-holder>Add Joint Holder<i class=\"accordian-arrow-up-icon pull-right\"></i></a></button><div id=add-joint-holder class=\"tab-pane fade joint-holder in active\"><div ng-repeat=\"holder in jointHoldersPayload.jointHolders\"><div ng-show=\"currentJointHolder.index === $index\"><div class=row style=\"margin-bottom: 20px\"><div class=col-md-3><p class=pdt10 style=\"margin-top: 0px !important; margin-bottom: 10px\"><strong>Contact Details</strong></p></div></div><div class=row style=\"margin-bottom: 10px; margin-left: -5px\"><div class=col-md-4><label><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{holder.email?holder.email:\"Not Available\"}}</label></div><div class=col-md-4><label><strong>Mobile</strong> <span class=\"req text-red\">*</span> : {{holder.mobileNumber? holder.mobileNumber:\"Not Available\"}}</label></div><div class=row ng-if=\"!holder.mobileNumber && !holder.email\"><div class=col-md-8><p class=update-contact-warning style=\"color: red\">To proceed with Folio creation contact details of investor are mandatory. Kindly get in touch with our ISC or CAMS to update CKYC.</p></div></div></div><div class=pdt0><div class=row><div class=col-md-3><p class=pdt10><strong>Tax Status</strong></p><div class=selectfield ng-class=\"{error:jointHolderForm.taxStatusCode.$dirty && jointHolderForm.taxStatusCode.$invalid, \'anything-disabled\': holder.nriFlag == false}\"><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=holder.taxStatusCode ng-init=\"holder.taxStatusCode = holder.taxStatusCode ? holder.taxStatusCode: null\" ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in taxStatusList[$index]\" ng-change=\"changedTaxStatus($index, holder.taxStatusCode)\" required><option value=\"\" selected>Tax Status</option></select><span ng-show=\"jointHolderForm.taxStatusCode.$dirty && jointHolderForm.taxStatusCode.$invalid\"><span class=error-input ng-show=jointHolderForm.taxStatusCode.$error.required ng-bind=validations.TAX_STATUS></span> </span><span class=\"req text-red\">*</span></div></div></div><div class=row ng-if=taxStatusNote><div class=\"col-xs-12 col-md-10 trans-ackn\"><span class=icon-info-sign></span><p>{{taxStatusNote}}</p></div></div><p class=pdt10><strong>Income Details</strong></p><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:jointHolderForm.occupation.$dirty && jointHolderForm.occupation.$invalid}\"><select class=\"browser-default custom-select\" name=occupation ng-model=holder.occupationCode ng-init=\"holder.occupationCode = holder.occupationCode ? holder.occupationCode: null\" ng-options=\"_type.occupationCode as _type.occupationDescription for _type in occupationList\" ng-change=setOccuValidation() easyassist-key=mask-element required><option value=\"\" selected>Occupation</option></select><label ng-if=jointHoldersPayload.occupation>Occupation</label><span ng-show=\"jointHolderForm.occupation.$dirty && jointHolderForm.occupation.$invalid\"><span class=error-input ng-show=jointHolderForm.occupation.$error.required ng-bind=validations.OCCUPATION></span> </span><span class=\"req text-red\">*</span></div></div></div><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:jointHolderForm.grossAnnualIncome.$dirty\n                 && jointHolderForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-click=\"setOptionalEmpty(\'GrossAnnualIncome\')\" ng-model=holder.grossAnnualIncome ng-init=\"holder.grossAnnualIncome = holder.grossAnnualIncome ? holder.grossAnnualIncome: null\" ng-options=\"_type.incomeCode as _type.incomeDescription for _type in incomeSlabList\" ng-required=\"!(holder.netWorth)\n                      &&!(holder.netWorthDate)\" ng-disabled=holder.netWorth ng-class=\"{\'selectfield-disabled\':holder.netWorth}\" easyassist-key=mask-element><option value=\"\" selected>Gross Annual Income</option></select><label ng-if=holder.grossAnnualIncome>Gross Annual Income</label><span ng-show=\"jointHolderForm.grossAnnualIncome.$dirty && jointHolderForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=jointHolderForm.grossAnnualIncome.$error.required ng-bind=validations.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=jointHolderForm.grossAnnualIncome.$error.number ng-bind=validations.INVALID_AMOUNT></span> </span><span ng-if=\"!(holder.netWorth)\n                      &&!(holder.netWorthDate)\" class=\"req text-red\">*</span> <span class=highlight></span> <span class=bar></span></div></div><div class=\"or-part col-md-1\" style=\"position: relative;top: 30px;text-align: center\">OR<span style=color:#d82018> *</span></div><div class=col-md-3><div class=input-normal style=margin-top:13px ng-class=\"{error:jointHolderForm.netWorth.$dirty\n                 && jointHolderForm.netWorth.$invalid}\"><input type=number name=netWorth class=pd20 ng-model=holder.netWorth ng-required=!holder.grossAnnualIncome ng-maxlength=15 limit-to=15 maxlength=15 ng-disabled=holder.grossAnnualIncome ng-keyup=\"NumToWord(holder.netWorth, \'DisplayWordsTaxAmt-\'+$index);\" easyassist-key=mask-element> <span ng-show=\"jointHolderForm.netWorth.$dirty && jointHolderForm.netWorth.$invalid\"><span class=error-input ng-show=jointHolderForm.netWorth.$error.number ng-bind=JointHolders.validations.INVALID_AMOUNT></span> <span class=error-input ng-show=jointHolderForm.netWorth.$error.required ng-bind=JointHolders.validations.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span> <i class=rupee-input-icon></i><label>Net worth (in Rs.) <span ng-if=!(holder.grossAnnualIncome)||(holder.netWorthDate) class=\"req text-red\">*</span></label></div><div class=form-group ng-if=holder.netWorth><span id=DisplayWordsTaxAmt-{{$index}}>{{holder.amountInWords}} (In Words)</span></div></div><div class=col-md-3><div class=\"input-select input-normal date date-picker\" style=margin-top:13px ng-class=\"{error : holder.netWorth\n                   && !holder.netWorthDate\n                   }\"><input type=text name=netWorthDate date-calendar format=DD-MMM-YYYY viewmode=days showdefault=\"{{\'\'+!!holder.netWorthDate}}\" date-default=defaultDob maxdate=now data-min-date=minDate data-on-date-change=changeStartDate autocomplete=off ng-model=holder.netWorthDate ng-required=!holder.grossAnnualIncome ng-disabled=holder.grossAnnualIncome> <span class=highlight></span> <span class=bar></span> <i class=calendar-input-icon></i><!--<i class=\"times-icon\" ng-click=\"JointHolders.resetNetWorthDate()\"></i>--><label>As on DD-MMM-YYYY <span ng-if=\"!(holder.grossAnnualIncome)\n                ||(holder.netWorth)\" class=\"req text-red\">*</span></label><span ng-show=\"jointHolderForm.netWorthDate.$dirty && jointHolderForm.netWorthDate.$invalid\"><span class=error-input ng-show=jointHolderForm.netWorthDate.$error.required>{{validations.NET_WORTH_DATE}}</span></span></div><span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span></div></div></div><hr><div><p><strong>Politically Exposed Person (PEP) Status</strong></p><span class=radio-block><span class=radio><input type=radio id=politicalStatus1-{{$index}} name=politicalStatus-{{$index}} ng-model=holder.politicalStatus ng-value=POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=politicalStatus1-{{$index}}>Investor is politically exposed person.</label></span><span class=radio-block><span class=radio><input type=radio id=politicalStatus2-{{$index}} name=politicalStatus-{{$index}} ng-model=holder.politicalStatus ng-value=POLITICAL_STATUS.RELATED> <span class=check></span></span><label for=politicalStatus2-{{$index}}>Investor is related to politically exposed person.</label></span><span class=radio-block><span class=radio><input type=radio id=politicalStatus3-{{$index}} name=politicalStatus-{{$index}} ng-model=holder.politicalStatus ng-value=POLITICAL_STATUS.NONE> <span class=check></span></span><label for=politicalStatus3-{{$index}}>Not Applicable</label></span></div><hr><div><p class=nomargin><strong>FATCA and CRS information</strong></p><div class=\"row pdt10\"><div class=col-md-3><div class=selectfield ng-class=\"{error:jointHolderForm.birthCountry.$dirty && jointHolderForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=holder.fatcaDetail.birthCountry ng-init=\"holder.fatcaDetail.birthCountry = holder.fatcaDetail.birthCountry ? holder.fatcaDetail.birthCountry: null\" ng-options=\"country.countryCode as country.countryName for country in countryList\" easyassist-key=mask-element required><option value=\"\" selected>Country of Birth</option></select><span class=\"req text-red\">*</span> <span ng-show=\"jointHolderForm.birthCountry.$dirty && jointHolderForm.birthCountry.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry.$error.required>{{validations.COUNTRY}}</span></span></div></div><div class=col-md-3><div class=\"input-normal cityBirth\" ng-class=\"{error:jointHolderForm.birthPlace.$dirty && jointHolderForm.birthPlace.$invalid}\"><input type=text name=birthPlace only-alphabets limit-to=35 maxlength=35 ng-maxlength=35 ng-pattern=/[A-Za-z]+(\\s[A-Za-z]+)?/ ng-model=holder.fatcaDetail.birthPlace easyassist-key=mask-element required> <span class=highlight></span> <span class=bar></span><label>City of Birth <span class=\"req text-red\">*</span></label><span ng-show=\"jointHolderForm.birthPlace.$dirty && jointHolderForm.birthPlace.$invalid\"><span class=error-input ng-show=jointHolderForm.birthPlace.$error.required>{{JointHolders.validations.BIRTH_CITY}}</span></span></div></div></div><div class=\"row pdt10\"><div class=col-md-3><div class=selectfield ng-class=\"{error:jointHolderForm.addressType.$dirty && jointHolderForm.addressType.$invalid}\"><select class=\"browser-default custom-select\" name=addressType ng-model=holder.fatcaDetail.addressType ng-init=\"holder.fatcaDetail.addressType = holder.fatcaDetail.addressType ? holder.fatcaDetail.addressType: null\" ng-options=\"_type.value as _type.addressDescription for _type in addressTypeList\" required><option value=\"\" selected>Address Type</option></select><label ng-if=holder.fatcaDetail.addressType>Address Type</label><span ng-show=\"jointHolderForm.addressType.$dirty && jointHolderForm.addressType.$invalid\"><span class=error-input ng-show=jointHolderForm.addressType.$error.required ng-bind=validations.ADDRESS_TYPE></span> </span><span class=\"req text-red\">*</span></div></div></div></div><div class=inves-pay><p><strong>Does the investor pay or file tax other than India?</strong></p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia-{{$index}} ng-change=fileTaxActionJointHolder($index) ng-model=holder.fatcaDetail.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo-{{$index}} name=payTaxInIndia-{{$index}} ng-model=holder.fatcaDetail.payTaxInIndia ng-value=true ng-change=\"holder.fatcaDetail.secondTax = holder.fatcaDetail.thirdTax = false;\"><!--ng-change=\"fileTaxActionJointHolder($index)\"--> <span class=check></span></span><label for=payTaxInIndiaNo-{{$index}}>No</label></span><!--First tax--><div ng-if=\"holder.fatcaDetail.payTaxInIndia === false && !isObjectEmpty(holder.fatcaDetail.fatcaTax1)\"><div class=tax-res><p><strong>Tax Residency Country</strong></p><div class=row><div class=col-md-4><div class=selectfield ng-class=\"{error:jointHolderForm.birthCountry1.$dirty && jointHolderForm.birthCountry1.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry1 ng-model=holder.fatcaDetail.fatcaTax1.taxPayingCountry ng-init=\"holder.fatcaDetail.fatcaTax1.taxPayingCountry = holder.fatcaDetail.fatcaTax1.taxPayingCountry ? holder.fatcaDetail.fatcaTax1.taxPayingCountry: null\" ng-options=\"country.countryName as country.countryName for country in countryList|removeCountry:\'india\'\" ng-required=\"holder.fatcaDetail.fatcaTax1.taxPayingCountry|| holder.fatcaDetail.payTaxInIndia==false\" ng-change=\"holder.fatcaDetail.fatcaTax1.taxPayingCountry?\'\':holder.fatcaDetail.fatcaTax1=\'\'\" easyassist-key=mask-element required><option value=\"\" selected>Name Of Country</option></select><span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax1.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.birthCountry1.$dirty && jointHolderForm.birthCountry1.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry1.$error.required>{{validations.COUNTRY}}</span></span></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><div class=selectfield ng-class=\"{error:jointHolderForm.taxIdType1.$dirty && jointHolderForm.taxIdType1.$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType-$index ng-model=holder.fatcaDetail.fatcaTax1.taxIdType ng-init=\"holder.fatcaDetail.fatcaTax1.taxIdType = holder.fatcaDetail.fatcaTax1.taxIdType ? holder.fatcaDetail.fatcaTax1.taxIdType: null\" ng-options=\"taxid.description as taxid.description for taxid in taxIdTypeList\" ng-required=holder.fatcaDetail.fatcaTax1.taxPayingCountry easyassist-key=mask-element required><option value=\"\" selected>Select Tax ID type</option></select><label ng-if=payoutdata.taxIdType>Select Tax ID type</label><span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax1.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.taxIdType1.$dirty && jointHolderForm.taxIdType1.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType1.$error.required>{{validations.TAX_ID_TYPE}}</span></span></div></div></div><div class=row><div class=col-md-4 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxIdNumber1 ng-model=holder.fatcaDetail.fatcaTax1.taxPayingCity ng-required=holder.fatcaDetail.fatcaTax1.taxPayingCountry ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element ng-pattern=/[A-Za-z]+(\\s[A-Za-z]+)?/ capitalize> <span class=highlight></span> <span class=bar></span><label>City <span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax1.taxPayingCountry>*</span></label></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxIdNumber3 ng-model=holder.fatcaDetail.fatcaTax1.taxId ng-required=holder.fatcaDetail.fatcaTax1.taxPayingCountry ng-maxlength=20 limit-to=20 maxlength=20 easyassist-key=mask-element capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number <span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax1.taxPayingCountry>*</span></label></div></div></div></div><div class=\"add-another-tax-res tax-res\" ng-if=!holder.fatcaDetail.secondTax><a href=\"\" class=text-blue ng-click=\"holder.fatcaDetail.secondTax = true\"><strong><i class=expand-icon></i> <span>Add another tax residency country</span></strong></a></div></div><!--Second tax--><div ng-if=\"holder.fatcaDetail.payTaxInIndia === false && !isObjectEmpty(holder.fatcaDetail.fatcaTax2) && holder.fatcaDetail.secondTax\"><div class=tax-res><p><strong>Tax Residency Country <span class=remove-item ng-click=deleteSecond(holder.fatcaDetail)><i class=delete-red-icon></i></span></strong></p><div class=row><div class=col-md-4 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><div class=selectfield ng-class=\"{error:jointHolderForm.birthCountry2.$dirty && jointHolderForm.birthCountry2.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry2 ng-model=holder.fatcaDetail.fatcaTax2.taxPayingCountry ng-init=\"holder.fatcaDetail.fatcaTax2.taxPayingCountry = holder.fatcaDetail.fatcaTax2.taxPayingCountry ? holder.fatcaDetail.fatcaTax2.taxPayingCountry: null\" ng-options=\"country.countryName as country.countryName for country in countryList|removeCountry:\'india\'\" ng-required=holder.fatcaDetail.fatcaTax2.taxPayingCountry ng-change=\"holder.fatcaDetail.fatcaTax2.taxPayingCountry?\'\':holder.fatcaDetail.fatcaTax2=\'\'\" easyassist-key=mask-element><option value=\"\" selected>Name Of Country</option></select><span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax2.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.birthCountry2.$dirty && jointHolderForm.birthCountry2.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry2.$error.required>{{validations.COUNTRY}}</span></span></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><div class=selectfield ng-class=\"{error:jointHolderForm.taxIdType2.$dirty && jointHolderForm.taxIdType2.$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType-$index ng-model=holder.fatcaDetail.fatcaTax2.taxIdType ng-init=\"holder.fatcaDetail.fatcaTax2.taxIdType = holder.fatcaDetail.fatcaTax2.taxIdType ? holder.fatcaDetail.fatcaTax2.taxIdType: null\" ng-options=\"taxid.description as taxid.description for taxid in taxIdTypeList\" ng-required=holder.fatcaDetail.fatcaTax2.taxPayingCountry easyassist-key=mask-element><option value=\"\" selected>Select Tax ID type</option></select><label ng-if=holder.fatcaDetail.fatcaTax2.taxIdType>Select Tax ID type</label><span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax2.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.taxIdType2.$dirty && jointHolderForm.taxIdType2.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType2.$error.required>{{validations.TAX_ID_TYPE}}</span></span></div></div></div><div class=row><div class=col-md-4 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxIdNumber2 ng-model=holder.fatcaDetail.fatcaTax2.taxPayingCity ng-required=holder.fatcaDetail.fatcaTax2.taxPayingCountry ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element ng-pattern=/[A-Za-z]+(\\s[A-Za-z]+)?/ capitalize> <span class=highlight></span> <span class=bar></span><label>City<span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax2.taxPayingCountry>*</span></label></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxIdNumber3 ng-model=holder.fatcaDetail.fatcaTax2.taxId ng-required=holder.fatcaDetail.fatcaTax2.taxPayingCountry ng-maxlength=20 limit-to=20 maxlength=20 easyassist-key=mask-element capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax2.taxPayingCountry>*</span></label></div></div></div></div><div class=\"add-another-tax-res tax-res\" ng-if=!holder.fatcaDetail.thirdTax><a href=\"\" class=text-blue ng-click=\"holder.fatcaDetail.thirdTax = true;\"><strong><i class=expand-icon></i> <span>Add another tax residency country</span></strong></a></div></div><!--Third tax--><div ng-if=\"holder.fatcaDetail.payTaxInIndia === false && !isObjectEmpty(holder.fatcaDetail.fatcaTax3) && holder.fatcaDetail.thirdTax\"><div class=tax-res><p><strong>Tax Residency Country <span class=remove-item ng-click=deleteThird(holder.fatcaDetail)><i class=delete-red-icon></i></span></strong></p><div class=row><div class=col-md-4><div class=selectfield ng-class=\"{error:jointHolderForm.birthCountry3.$dirty && jointHolderForm.birthCountry3.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry3 ng-model=holder.fatcaDetail.fatcaTax3.taxPayingCountry ng-init=\"holder.fatcaDetail.fatcaTax3.taxPayingCountry = holder.fatcaDetail.fatcaTax3.taxPayingCountry ? holder.fatcaDetail.fatcaTax3.taxPayingCountry: null\" ng-options=\"country.countryName as country.countryName for country in countryList|removeCountry:\'india\'\" ng-required=holder.fatcaDetail.fatcaTax3.taxPayingCountry ng-change=\"holder.fatcaDetail.fatcaTax3.taxPayingCountry?\'\':holder.fatcaDetail.fatcaTax3=\'\'\" easyassist-key=mask-element><option value=\"\" selected>Name Of Country</option></select><span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax3.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.birthCountry3.$dirty && jointHolderForm.birthCountry3.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry3.$error.required>{{validations.COUNTRY}}</span></span></div></div><div class=col-md-4><!----><div class=selectfield ng-class=\"{error:jointHolderForm.taxIdType3.$dirty && jointHolderForm.taxIdType3.$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType3 ng-model=holder.fatcaDetail.fatcaTax3.taxIdType ng-init=\"holder.fatcaDetail.fatcaTax3.taxIdType = holder.fatcaDetail.fatcaTax3.taxIdType ? holder.fatcaDetail.fatcaTax3.taxIdType: null\" ng-options=\"taxid.description as taxid.description for taxid in taxIdTypeList\" ng-required=holder.fatcaDetail.fatcaTax3.taxPayingCountry easyassist-key=mask-element><option value=\"\" selected>Select Tax ID type</option></select><label ng-if=holder.fatcaDetail.fatcaTax3.taxIdType>Select Tax ID type</label><span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax3.taxPayingCountry>*</span> <span ng-show=\"jointHolderForm.taxIdType3.$dirty && jointHolderForm.taxIdType3.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType3.$error.required>{{validations.TAX_ID_TYPE}}</span></span></div></div></div><div class=row><div class=col-md-4 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax3.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxPayingCity3 ng-model=holder.fatcaDetail.fatcaTax3.taxPayingCity ng-required=holder.fatcaDetail.fatcaTax3.taxPayingCountry ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element ng-pattern=/[A-Za-z]+(\\s[A-Za-z]+)?/ capitalize> <span class=highlight></span> <span class=bar></span><label>City<span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax3.taxPayingCountry>*</span></label></div></div><div class=col-md-4 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax3.taxPayingCountry}\"><div class=\"input-select input-normal\"><input type=text name=taxIdNumber3 ng-model=holder.fatcaDetail.fatcaTax3.taxId ng-required=holder.fatcaDetail.fatcaTax3.taxPayingCountry ng-maxlength=20 limit-to=20 maxlength=20 easyassist-key=mask-element capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=\"req text-red\" ng-if=holder.fatcaDetail.fatcaTax3.taxPayingCountry>*</span></label></div></div></div></div></div></div><div class=form-footer ng-if=\"jointHoldersPayload.jointHolders.length > 0\"><span class=\"pull-left back\" ng-click=back() style=\"cursor: pointer\"><i class=arrow-blue-back-icon></i> Previous</span> <button ng-if=\"firstFlow == \'NO\'\" type=button class=\"btn btn-secondary-action common-btn-padding\" ng-disabled=jointHolderForm.$invalid ng-click=saveFolio()>Save</button> <button type=button class=\"btn btn-primary-action common-btn-padding pull-right\" ng-disabled=\"jointHolderForm.$invalid || notValid2ndHolder\" ng-click=continue()>Continue</button></div></div></div></div></div></div></div></form></div><style>div#investors span.radio-block label {\n    display: block;\n    margin-top: -19px;\n    margin-left: 30px;\n  }\n\n  div#add-joint-holder p.pdt10 {\n    margin-top: 12px;\n    margin-bottom: 1px;\n  }\n\n  div#tab-container.tab-container ul.mobile-hide.nav.nav-tabs {\n    margin-bottom: 20px;\n  }\n\n  div.input-normal.cityBirth {\n    margin-top: 13px;\n  }</style>");
$templateCache.put("app/investor/addFolio/folio-directive/nominee/folio-nominee-directive.html","<div class=investors><form autocomplete=off class=nominee-section name=addNomineeForm ng-init=nomineeInit() novalidate><!--<form autocomplete=\"off\" class=\"nominee-section\" name=\"addNomineeForm\" novalidate>--><div class=form-content><div class=\"nominee-title clearfix\"><span class=\"pull-left details headerResp\" ng-if=!wantToAddNomineeLater><strong>Nominee Details</strong> <i class=\"info-icon base-tooltip\" ng-if=showNomineeUpdate data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"<div>\n                SEBI Circular No. SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650, dated January 10, 2025\n                states that, in case of Joint Account/Folio: <br>\n                1. In case of “Demise of one or more joint holder(s)” event: Transmission of\n                  Account/Folio to: Surviving holder(s) through name deletion, The surviving holder(s) shall\n                  inherit the assets as owners.<br>\n                2. In case of “Demise of all joint holders simultaneously – having nominee” event: Transmission of Account/Folio to: Nominee.<br>\n                3. In case of “Demise of all joint holders simultaneously – not having nominee event: Transmission of Account /Folio to: Legal heir(s) of the youngest holder.\n              </div>\"></i> </span><span class=\"pull-right checkbox\"><input type=checkbox ng-model=wantToAddNomineeLater ng-value=true ng-click=checkAddNominee()> <span class=icon-checkbox></span> <span class=checkbox-text>I hereby declare to opting out of nomination</span></span><p class=consent-text ng-if=\"showNomineeUpdate && !wantToAddNomineeLater\">I/We hereby nominate the following person(s) who shall receive all the assets held in my / our account / folio in the event of my / our demise, as trustee and on behalf of my/our legal heir(s).</p></div><div class=\"col-md-12 optOutalign\" ng-if=wantToAddNomineeLater><div class=checkbox style=\"text-align: left!important\"><input type=checkbox ng-model=optOutNominee ng-value=true ng-click=checkOptOutNominee()> <span class=icon-checkbox></span></div><div class=checkbox-text style=margin-left:5px!important><ng-bind-html dynamic=dynamicNote.content></ng-bind-html></div></div><div class=row ng-if=wantToAddNomineeLater></div><div ng-if=!wantToAddNomineeLater><div class=nominee-list><table><thead><tr><th class=\"col-md-2 blank-table-space\">&nbsp;</th><th class=col-md-4>Name</th><th class=col-md-4>Proportion <span class=text-warn>(Should not be greater than 100%)</span></th><th class=col-md-4>&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"data in nomineePayload.nominees\"><td class=col-md-2>{{nomineeEnum[$index]}} Nominee</td><td class=col-md-4><input type=text name=nomineeName-{{$index}} ng-model=data.nomineeName ng-maxlength=40 limit-to=40 maxlength=40 easyassist-key=mask-element autocomplete=off only-alphabets required> <span class=\"req text-red\">*</span> <span ng-show=\"addNomineeForm[\'nomineeName-\'+$index].$dirty && addNomineeForm[\'nomineeName-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'nomineeName-\'+$index].$error.required\">{{nomineeValidateData.NOMINEE_NAME_REQUIRED}}</span></span></td><td class=col-md-4><div ng-class=\"{error:addNomineeForm[\'proportion\'+$index].$dirty && addNomineeForm[\'proportion-\'+$index].$invalid}\"><input type=text name=proportion-{{$index}} ng-model=data.percentage ng-blur=calculatePercentage() maxlength=3 is-number easyassist-key=mask-element required>% <span class=highlight></span> <span class=bar></span> <span class=\"req text-red\">*</span> <span ng-show=\"addNomineeForm[\'proportion-\'+$index].$dirty && addNomineeForm[\'proportion-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'proportion-\'+$index].$error.required\">{{nomineeValidateData.NOMINEE_PROPORTION_REQUIRED}}</span></span></div></td><td class=col-md-4 ng-if=\"nomineePayload.nominees.length > 1\"><i class=delete-red-icon ng-click=deleteNominee($index)></i></td></tr></tbody></table><!--<p><i class=\"info-icon\"></i></p>--></div><div class=\"col-md-12 proportion-warn\" ng-if=showNomineeUpdate>{{percentage_msg}}</div><div class=tab-container><ul class=\"mobile-hide nav nav-tabs\" ng-class=\"showAddNominee && (nomineePayload.nominees.length < allowedNomineeLength) ? \'updated-width\': \'full-width\'\"><li ng-repeat=\"data in nomineePayload.nominees\" ng-click=setActiveTab($index) ng-class=\"{\'active\':activeTab===$index}\">{{nomineeEnum[$index]}} Nominee Details</li></ul><div class=\"pull-right add-another-nominee\" ng-if=\"showAddNominee && (nomineePayload.nominees.length < allowedNomineeLength)\" ng-click=addNominee()><a href=\"\" class=text-blue><strong><i class=plus-icon></i>Add Another Nominee</strong></a></div></div><div name=\"nominee-details tab-content\" ng-repeat=\"data in nomineePayload.nominees\" ng-show=\"activeTab===$index\"><div class=row><div class=col-md-10><div class=\"nominee-title clearfix\"><span class=checkbox><input type=checkbox ng-model=data.minor ng-value=true ng-click=changeNomineeIsMinor($index)> <span class=icon-checkbox></span> <span class=checkbox-text>The Nominee is Minor</span></span></div></div></div><div class=row><div class=col-md-4><div class=nominee-name><!--<span>Name</span>--> <span ng-class=\"{\'empty\':data.nomineeName===\'\'}\" class=name easyassist-key=mask-element ng-bind=data.nomineeName></span><!-- <span ng-if=\"!data.nomineeName\" style=\"margin-bottom: 39px;\"></span>--></div></div><div class=col-md-4><div class=nominee-name ng-class={error:addNomineeForm.proportion.$invalid}><!--<span>Proportion in %</span>--> <span style=\"margin-bottom: 8px\" name=proportion ng-bind=data.percentage></span></div></div></div><div class=row><div class=col-md-4><!--<div class=\"input-normal\">--><!--<input type=\"text\" required>--><!--<span class=\"highlight\"></span>--><!--<span class=\"bar\"></span>--><!--<label>Name</label>--><!--</div>--><div class=\"input-normal input-other\" ng-class=\"{error:addNomineeForm[\'dob-\'+$index].$dirty && addNomineeForm[\'dob-\'+$index].$invalid}\"><input type=text ng-if=data.minor name=dob-{{$index}} id=dob-{{$index}} date-calendar format=DD-MMM-YYYY viewmode=days showdefault=false date-default=data.dob maxdate=now data-min-date=isMinorMinDate data-max-date=isMinorMaxDate data-on-date-change=nomineeChangeDob autocomplete=off data-enable=true easyassist-key=mask-element ng-bind=data.dob ng-model=data.dob ng-required=\"showNomineeUpdate && data.minor\"> <input type=text ng-if=!data.minor name=dob-{{$index}} id=dob-{{$index}} date-calendar format=DD-MMM-YYYY viewmode=days showdefault=false date-default=data.dob maxdate=now data-min-date=dataMinDate data-max-date=dataMaxDate data-on-date-change=nomineeChangeDob autocomplete=off data-enable=true easyassist-key=mask-element ng-bind=data.dob ng-model=data.dob> <span class=highlight></span> <span class=bar></span> <i class=calendar-input-icon></i><!--<i class=\"times-icon\" ng-click=\"Nominee.resetNetWorthDate()\"></i>--><label>DD-MMM-YYYY <span class=\"req text-red\" ng-if=data.minor>*</span></label><span ng-show=\"addNomineeForm[\'dob-\'+$index].$dirty && addNomineeForm[\'dob-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'dob-\'+$index].$error.required\">{{nomineeValidations.NET_WORTH_DATE}}</span></span></div></div><div class=col-md-4><div class=selectfield ng-class=\"{error:addNomineeForm[\'nomineeRelation-\'+$index].$dirty && addNomineeForm[\'nomineeRelation-\'+$index].$invalid}\"><select name=nomineeRelation-{{$index}} ng-model=data.nomineeRelation ng-init=\"data.nomineeRelation=data.nomineeRelation?data.nomineeRelation:null\" ng-options=\"_type.value as _type.name for _type in applicantRelationShip\" ng-change=changeNomineeRelationsShip($index,data.nomineeRelation) easyassist-key=mask-element required><option value=\"\" selected>Relationship with Applicant</option></select><label ng-if=data.nomineeRelation>Relationship with Applicant</label><span class=\"req text-red\">*</span> <span ng-show=\"addNomineeForm[\'nomineeRelation-\'+$index].$dirty && addNomineeForm[\'nomineeRelation-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'nomineeRelation-\'+$index].$error.required\">{{nomineeValidateData.NOMINEE_RELATIONSHIP}}</span></span></div></div><div class=col-md-4 ng-if=showNomineeUpdate><div class=\"input-normal input-other\" ng-class=\"{error: addNomineeForm[\'emailId-\'+$index].$dirty && addNomineeForm[\'emailId-\'+$index].$invalid}\"><input type=text ng-pattern=emailPattern ng-model=data.emailId name=emailId-{{$index}} maxlength=254 ng-change=\"changeEmailId($index ,data.emailId)\" autocomplete=off required><label>Nominee Email ID<span class=\"req text-red\">*</span></label><span ng-show=\"addNomineeForm[\'emailId-\'+$index].$dirty && addNomineeForm[\'emailId-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'emailId-\'+$index].$error.pattern\">{{nomineeValidateData.EMAIL_FIELD}} </span><span class=error-input ng-show=\"addNomineeForm[\'emailId-\'+$index].$error.required\">{{nomineeValidateData.EMAIL_REQUIRED}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'emailId-\'+$index].$invalid && nomineePayload.nominees[$index].emailIdInvalid\">{{errorMessageEmail}}</span></div></div><div class=col-md-4 ng-if=showNomineeUpdate><div class=\"input-normal input-other\" ng-class=\"{error: addNomineeForm[\'mobile-\'+$index].$dirty && addNomineeForm[\'mobile-\'+$index].$invalid}\"><input type=text ng-pattern=mobilePattern ng-model=data.mobileNumber name=mobile-{{$index}} minlength=1 maxlength=15 autocomplete=off required><!--ng-change=\"changeMobileNumber($index, data.mobile)\"--><label>Nominee Mobile No.<span class=\"req text-red\">*</span></label><span ng-show=\"addNomineeForm[\'mobile-\'+$index].$dirty && addNomineeForm[\'mobile-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'mobile-\'+$index].$error.pattern || addNomineeForm[\'mobile-\'+$index].$error.minlength\">{{nomineeValidateData.MOBILE_FIELD}} </span><span class=error-input ng-show=\"addNomineeForm[\'mobile-\'+$index].$error.required\">{{nomineeValidateData.MOBILE_REQUIRED}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'mobile-\'+$index].$invalid && nomineePayload.nominees[$index].mobileInvalid\">{{errorMessageMobile}}</span></div></div><div class=col-md-4 ng-if=showNomineeUpdate><div class=selectfield ng-class=\"{error:addNomineeForm[\'personalIdentifier-\'+$index].$dirty && addNomineeForm[\'personalIdentifier-\'+$index].$invalid}\"><select name=personalIdentifier-{{$index}} ng-model=data.identityProofType ng-init=\"data.identityProofType = data.identityProofType ? data.identityProofType:null\" ng-options=\"_type.identityProofType as _type.identityProof for _type in data.applicantPersonalIdentifiers\" ng-change=\"changePersonalIdentifier($index, data.identityProofType)\" easyassist-key=mask-element required><option value=\"\" selected>Select Personal Identifier of Nominee</option></select><label ng-if=data.identityProofType>Select Personal Identifier of Nominee</label><span class=\"req text-red\">*</span> <span ng-show=\"addNomineeForm[\'personalIdentifier-\'+$index].$dirty && addNomineeForm[\'personalIdentifier-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'personalIdentifier-\'+$index].$error.required\">{{nomineeValidateData.PERSONAL_IDENTIFIER_REQUIRED}}</span></span></div></div><div class=col-md-4 ng-if=\"!showNomineeUpdate || (showNomineeUpdate && data.identityProofType === \'PAN_CARD\')\"><div class=\"input-normal input-other input-pan\" ng-class=\"{error: addNomineeForm[\'panNumber-\'+$index].$dirty && addNomineeForm[\'panNumber-\'+$index].$invalid}\"><input type=text maxlength=10 minlength=10 ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-bind=data.panNumber ng-model=data.panNumber ng-change=\"nomineePanChanged($index ,data.panNumber)\" name=panNumber-{{$index}} ng-required=showNomineeUpdate autocomplete=off capitalize><label style=\"color: #9f9f9f; font-size: 13px; font-weight: normal; position: absolute; pointer-events: none; left: 5px; top: 15px; transition: 0.2s ease all\" ng-if=!showNomineeUpdate>PAN of Nominee</label><label style=\"color: #9f9f9f; font-size: 13px; font-weight: normal; position: absolute; pointer-events: none; left: 5px; top: 15px; transition: 0.2s ease all\" ng-if=showNomineeUpdate>Nominee PAN <span class=\"req text-red\">*</span></label><span ng-show=\"addNomineeForm[\'panNumber-\'+$index].$dirty && addNomineeForm[\'panNumber-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'panNumber-\'+$index].$error.pattern\">Please enter valid PAN </span><span class=error-input ng-show=\"addNomineeForm[\'panNumber-\'+$index].$error.required\">{{nomineeValidateData.PAN_REQUIRED}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'panNumber-\'+$index].$invalid && nomineePayload.nominees[$index].nomineePanInvalid\">{{errorMessageNominee}}</span></div></div><div class=col-md-4 ng-if=\"showNomineeUpdate && data.identityProofType === \'DRIVING_LICENSE\'\"><div class=\"input-normal input-other\" ng-class=\"{error: addNomineeForm[\'drivingLicense-\'+$index].$dirty && addNomineeForm[\'drivingLicense-\'+$index].$invalid}\"><input type=text ng-bind=data.drivingLicense ng-model=data.drivingLicense name=drivingLicense-{{$index}} ng-change=\"drivingLicenseChanged($index ,data.drivingLicense)\" maxlength=35 autocomplete=off required capitalize><label>Nominee Driving License No. <span class=\"req text-red\">*</span></label><span ng-show=\"addNomineeForm[\'drivingLicense-\'+$index].$dirty && addNomineeForm[\'drivingLicense-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'drivingLicense-\'+$index].$error.pattern || addNomineeForm[\'drivingLicense-\'+$index].$error.required\">{{nomineeValidateData.DRIVING_LICENSE_INVALID}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'drivingLicense-\'+$index].$invalid && nomineePayload.nominees[$index].nomineeLicenseInvalid\">{{errorMessageDrivingLicense}}</span></div></div><div class=col-md-4 ng-if=\"showNomineeUpdate && data.identityProofType === \'AADHAR_CARD\'\"><div class=\"input-normal input-other\" ng-class=\"{error: addNomineeForm[\'aadharCard-\'+$index].$dirty && addNomineeForm[\'aadharCard-\'+$index].$invalid}\"><input type=text class=aadhar-field ng-bind=data.aadharCard ng-pattern=/^\\+?\\d+$/ ng-model=data.aadharCard name=aadharCard-{{$index}} minlength=4 maxlength=4 ng-change=\"aadharCardChanged($index ,data.aadharCard)\" autocomplete=off required capitalize><label>Nominee Aadhaar No. (Last 4 digits)<span class=\"req text-red\">*</span></label><span class=arn style=\"top: 11px\">XXXX XXXX </span><span ng-show=\"addNomineeForm[\'aadharCard-\'+$index].$dirty && addNomineeForm[\'aadharCard-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'aadharCard-\'+$index].$error.minlength || addNomineeForm[\'aadharCard-\'+$index].$error.pattern\">{{nomineeValidateData.AADHAAR_INVALID}} </span><span class=error-input ng-show=\"addNomineeForm[\'aadharCard-\'+$index].$error.required\">{{nomineeValidateData.AADHAAR_INVALID}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'aadharCard-\'+$index].$invalid && nomineePayload.nominees[$index].nomineeAadhaarInvalid\">{{errorMessageNomineeAadhaar}}</span></div></div><div class=col-md-4 ng-if=\"showNomineeUpdate && data.identityProofType === \'PASSPORT\'\"><div class=\"input-normal input-other\" ng-class=\"{error: addNomineeForm[\'passport-\'+$index].$dirty && addNomineeForm[\'passport-\'+$index].$invalid}\"><input type=text ng-bind=data.passport ng-model=data.passport name=passport-{{$index}} ng-change=\"passportChanged($index ,data.passport)\" maxlength=35 autocomplete=off required capitalize><label>Nominee Passport <span class=\"req text-red\">*</span></label><span ng-show=\"addNomineeForm[\'passport-\'+$index].$dirty && addNomineeForm[\'passport-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'passport-\'+$index].$error.required\">{{nomineeValidateData.PASSPORT_REQUIRED}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'passport-\'+$index].$invalid && nomineePayload.nominees[$index].nomineePassportInvalid\">{{errorMessagePassportNumber}}</span></div></div><div class=col-md-4 ng-if=\"showNomineeUpdate && data.identityProofType && data.identityProofType !== \'AADHAR_CARD\' && data.identityProofType !== \'DRIVING_LICENSE\' && data.identityProofType !== \'PAN_CARD\' && data.identityProofType !== \'PASSPORT\'\"><div class=\"input-normal input-other\" ng-class=\"{error: addNomineeForm[\'others-\'+$index].$dirty && addNomineeForm[\'others-\'+$index].$invalid}\"><input type=text ng-bind=data.somethingElse ng-model=data.somethingElse name=others-{{$index}} autocomplete=off required capitalize><label>Others<span class=\"req text-red\">*</span></label></div></div></div><div ng-if=data.minor><p>Guardian Details</p><div class=row><div class=col-md-4><div class=input-normal style=\"margin-top: 12px\" ng-class=\"{error:addNomineeForm[\'guardianName-\'+$index].$dirty && addNomineeForm[\'guardianName-\'+$index].$invalid}\"><input type=text ng-model=data.guardianName name=guardianName-{{$index}} ng-maxlength=40 limit-to=40 maxlength=40 only-alphabets capitalize required> <span class=highlight></span> <span class=bar></span><label>Guardian Name<span class=\"req text-red\">*</span></label><span ng-show=\"addNomineeForm[\'guardianName-\'+$index].$dirty && addNomineeForm[\'guardianName-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'guardianName-\'+$index].$error.required\">{{nomineeValidateData.GUARDIAN_NAME}}</span></span></div></div><div class=col-md-4><div class=selectfield ng-class=\"{error:addNomineeForm[\'guardianRelationWithNominee-\'+$index].$dirty && addNomineeForm[\'guardianRelation-\'+$index].$invalid}\"><select name=guardianRelationWithNominee-{{$index}} ng-model=data.guardianRelationWithNominee ng-init=\"data.guardianRelationWithNominee=data.guardianRelationWithNominee?data.guardianRelationWithNominee:null\" ng-options=\"_type.value as _type.name for _type in minorRelationShip\" ng-change=changeMinorRelationsShip($index,data.guardianRelationWithNominee) required><option value=\"\" selected>Guardian\'s Relationship with Nominee</option></select><label ng-if=data.guardianRelationWithNominee>Guardian\'s Relationship with Nominee</label><span class=\"req text-red\">*</span> <span ng-show=\"addNomineeForm[\'guardianRelationWithNominee-\'+$index].$dirty && addNomineeForm[\'guardianRelationWithNominee-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'guardianRelationWithNominee-\'+$index].$error.required\">{{nomineeValidateData.NOMINEE_RELATIONSHIP}}</span></span></div></div></div><div class=row><div class=col-md-4><div class=\"input-normal input-pan\" ng-class=\"{error:addNomineeForm[\'guardianPanNumber-\'+$index].$dirty && addNomineeForm[\'guardianPanNumber-\'+$index].$invalid}\"><input type=text maxlength=10 minlength=10 ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-bind=data.guardianPanNumber ng-model=data.guardianPanNumber name=guardianPanNumber-{{$index}} ng-change=\"minorPanChanged($index , data.guardianPanNumber , true)\" autocomplete=off capitalize><label style=\"color: #9f9f9f; font-size: 13px; font-weight: normal; position: absolute; pointer-events: none; left: 5px; top: 15px; transition: 0.2s ease all\">PAN of Guardian</label><span ng-show=\"!data.guardianPanNumber && addNomineeForm[\'guardianPanNumber-\'+$index].$dirty && addNomineeForm[\'guardianPanNumber-\'+$index].$invalid && !addNomineeForm[\'guardianPanNumber-\'+$index].$error.required\"><span class=error-input>Please enter valid PAN </span></span><span class=error-input ng-show=\"addNomineeForm[\'guardianPanNumber-\'+$index].$dirty && addNomineeForm[\'guardianPanNumber-\'+$index].$invalid && addNomineeForm[\'guardianPanNumber-\'+$index].$error.required \">{{nomineeValidateData.PAN_REQUIRED}}</span> <span class=error-input ng-show=\"!addNomineeForm[\'guardianPanNumber-\'+$index].$invalid && nomineePayload.nominees[$index].minorPanInvalid && addNomineeForm[\'guardianPanNumber-\'+$index]\">{{errorMessage}} </span><!--                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'guardianPanNumber-\'+$index].$error.required && addNomineeForm[\'guardianPanNumber-\'+$index].$dirty\">--><!--                  Pan is required--><!--                </span>--></div></div></div></div><p>Address Details of <span ng-if=!nomineePayload.nominees[$index].minor>Nominee</span><span ng-if=nomineePayload.nominees[$index].minor>Nominee’s Guardian</span></p><div ng-if=!data.minor><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid}\"><input type=text ng-model=data.nomineeAddress.addressLine1 name=addressLine1-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 easyassist-key=mask-element ng-required=showNomineeUpdate capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 1 <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></label><span ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$error.required\">{{nomineeValidateData.ADDRESS1_REQUIRED}}</span></span></div></div><div class=col-md-4><div class=input-normal><input type=text ng-model=data.nomineeAddress.addressLine2 name=addressLine2-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 easyassist-key=mask-element capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 2</label></div></div></div><div class=row><div class=col-md-4><div class=selectfield ng-class=\"{error:addNomineeForm[\'residencyCountry-\'+$index].$dirty && addNomineeForm[\'residencyCountry-\'+$index].$invalid}\"><select name=residencyCountry-{{$index}} ng-model=data.nomineeAddress.country ng-change=changeCountry($index,data.nomineeAddress.country) ng-options=\"_country.countryCode as _country.countryName for _country in nomineeCountryList\" ng-init=\"data.nomineeAddress.country=data.nomineeAddress.country?data.nomineeAddress.country:null\" easyassist-key=mask-element ng-required=showNomineeUpdate><option value=\"\" selected>{{showNomineeUpdate ? \'Select country\' : \'Name of country\'}}</option></select><label ng-if=data.guardianAddress.country>{{ showNomineeUpdate ? \'Select country\' : \'Name of country\'}}</label><span class=\"req text-red\" ng-if=showNomineeUpdate>*</span> <span ng-show=\"addNomineeForm[\'residencyCountry-\'+$index].$dirty && addNomineeForm[\'residencyCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'residencyCountry-\'+$index].$error.required\">{{nomineeValidateData.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-4><div class=selectfield ng-class=\"{error:addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid}\"><select name=state-{{$index}} ng-disabled=\"data.nomineeAddress.country != \'IN\'\" ng-model=data.nomineeAddress.state ng-init=\"data.nomineeAddress.state=data.nomineeAddress.state?data.nomineeAddress.state:null\" ng-options=\"_state.stateCode as _state.stateName for _state in stateList\" ng-change=changeState($index,data.nomineeAddress.state) ng-required=showNomineeUpdate><option value=\"\" selected>Select State</option></select><label ng-if=\"data.nomineeAddress.state && !showNomineeUpdate\">STATE</label><label ng-if=\"data.nomineeAddress.state && showNomineeUpdate\">Select State</label><span class=\"req text-red\" ng-if=showNomineeUpdate>*</span> <span ng-show=\"addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'state-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.STATE_REQUIRED}}</span></span></div></div><!--<div class=\"col-md-4\">\n                <div class=\"input-normal mgt8\"\n                     ng-class=\"{error:addNomineeForm[\'state\'+$index].$dirty && addNomineeForm[\'state\'+$index].$invalid}\">\n                  <input type=\"text\" ng-model=\"data.nomineeAddress.state\" name=\"state{{$index}}\" required>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>State <span class=\"req text-red\">*</span></label>\n                  <span\n                    ng-show=\"addNomineeForm[\'state\'+$index].$dirty && addNomineeForm[\'state\'+$index].$invalid\">\n              <span class=\"error-input\" ng-show=\"addNomineeForm[\'state\'+$index].$error.required\">{{Nominee.validateData.STATE_REQUIRED}}</span>\n                </span>\n                </div>\n              </div>--></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid}\"><input type=text ng-model=data.nomineeAddress.city name=city-{{$index}} ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element ng-required=showNomineeUpdate only-alphabets capitalize> <span class=highlight></span> <span class=bar></span><label>City <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></label><span ng-show=\"addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'city-\'+$index].$error.required\">{{nomineeValidateData.CITY}}</span></span></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'pinCode-\'+$index].$dirty && addNomineeForm[\'pinCode-\'+$index].$invalid}\"><input type=text ng-model=data.nomineeAddress.pinCode name=pinCode-{{$index}} is-number ng-maxlength=6 limit-to=6 easyassist-key=mask-element ng-required=showNomineeUpdate maxlength=6> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></label><span ng-show=\"addNomineeForm[\'pinCode-\'+$index].$dirty && addNomineeForm[\'pinCode-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'pinCode-\'+$index].$error.required\">{{nomineeValidateData.PINCODE_REQUIRED}}</span></span></div></div></div></div><div ng-if=data.minor><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid}\"><input type=text ng-model=data.guardianAddress.addressLine1 name=addressLine1-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 ng-required=showNomineeUpdate capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 1 <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></label><span ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$error.required\">{{nomineeValidateData.ADDRESS1_REQUIRED}}</span></span></div></div><div class=col-md-4><div class=input-normal><input type=text ng-model=data.guardianAddress.addressLine2 name=addressLine2-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 2</label></div></div></div><div class=row><div class=col-md-4><div class=selectfield ng-class=\"{error:addNomineeForm[\'gResidencyCountry-\'+$index].$dirty && addNomineeForm[\'gResidencyCountry-\'+$index].$invalid}\"><select name=gResidencyCountry-{{$index}} ng-model=data.guardianAddress.country ng-change=changeCountryGuardian($index,data.guardianAddress.country) ng-options=\"_country.countryCode as _country.countryName for _country in nomineeCountryList\" ng-init=\"data.guardianAddress.country=data.guardianAddress.country?data.guardianAddress.country:null\" ng-required=showNomineeUpdate><option value=\"\" selected>{{showNomineeUpdate ? \'Select country\' : \'Name of country\'}}</option></select><label ng-if=data.guardianAddress.country>{{ showNomineeUpdate ? \'Select country\' : \'Name of country\'}}</label><span class=\"req text-red\" ng-if=showNomineeUpdate>*</span> <span ng-show=\"addNomineeForm[\'gResidencyCountry-\'+$index].$dirty && addNomineeForm[\'gResidencyCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'gResidencyCountry-\'+$index].$error.required\">{{nomineeValidateData.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-4><div class=selectfield ng-class=\"{error:addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid}\"><select name=state-{{$index}} ng-disabled=\"data.guardianAddress.country != \'IN\'\" ng-model=data.guardianAddress.state ng-init=\"data.guardianAddress.state=data.nomineeAddress.state?data.nomineeAddress.state:null\" ng-options=\"_state.stateCode as _state.stateName for _state in stateList\" ng-change=changeState($index,data.nomineeAddress.state) ng-required=showNomineeUpdate><option value=\"\" selected>Select State</option></select><label ng-if=\"data.nomineeAddress.state && !showNomineeUpdate\">STATE</label><label ng-if=\"data.nomineeAddress.state && showNomineeUpdate\">Select State</label><span class=\"req text-red\" ng-if=showNomineeUpdate>*</span> <span ng-show=\"addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'state-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.STATE_REQUIRED}}</span></span></div></div><!--<div class=\"col-md-4\">\n                <div class=\"input-normal\"\n                     ng-class=\"{error:addNomineeForm[\'state\'+$index].$dirty && addNomineeForm[\'state\'+$index].$invalid}\">\n                  <input type=\"text\" ng-model=\"data.guardianAddress.state\" name=\"state{{$index}}\" required>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>State <span class=\"req text-red\">*</span></label>\n                  <span\n                    ng-show=\"addNomineeForm[\'state\'+$index].$dirty && addNomineeForm[\'state\'+$index].$invalid\">\n              <span class=\"error-input\" ng-show=\"addNomineeForm[\'state\'+$index].$error.required\">{{Nominee.validateData.STATE_REQUIRED}}</span>\n                </span>\n                </div>\n              </div>--></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid}\"><input type=text ng-model=data.guardianAddress.city name=city-{{$index}} ng-maxlength=35 limit-to=35 maxlength=35 ng-required=showNomineeUpdate only-alphabets capitalize> <span class=highlight></span> <span class=bar></span><label>City <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></label><span ng-show=\"addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'city-\'+$index].$error.required\">{{nomineeValidateData.CITY}}</span></span></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:addNomineeForm[\'gpinCode-\'+$index].$dirty && addNomineeForm[\'gpinCode-\'+$index].$invalid}\"><input type=text ng-model=data.guardianAddress.pinCode name=gpinCode-{{$index}} is-number maxlength=6 ng-required=showNomineeUpdate> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></label><span ng-show=\"addNomineeForm[\'gpinCode-\'+$index].$dirty && addNomineeForm[\'gpinCode-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'gpinCode-\'+$index].$error.required\">{{nomineeValidateData.PINCODE_REQUIRED}}</span></span></div></div></div></div><!--<hr/>--></div><!--\n        Statement Declaration sections\n        --><div class=statement-declaration ng-if=showNomineeUpdate><p class=section-title>Statement of Holding(Account Statement) Declaration <span class=\"req text-red\">*</span></p><div class=declaration-content><div class=row><div class=col-md-12><span>I/ We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/ us by the AMC as follows; (please tick, as appropriate)</span></div></div><div class=row><!--<div class=\"col-md-12 mb-3\">\n                <div class=\"checkbox\">\n                  <input ng-model=\"nomineePayload.accountHoldingDeclaration.nomination\" name=\"statementNomination\" type=\"checkbox\"\n                         ng-change=\"setStatement();\"\n                         ng-required=\"!nomineePayload.accountHoldingDeclaration.nomineeName\"/>\n                  <i class=\"icon-checkbox\"></i>\n                  <span class=\"checkbox-text ria\" style=\"margin-top: -10px;\">Nomination: Yes/No</span>\n                </div>\n              </div>\n\n              <div class=\"col-md-12\">\n                <div class=\"checkbox\">\n                  <input ng-model=\"nomineePayload.accountHoldingDeclaration.nomineeName\" name=\"statementNomineeName\" type=\"checkbox\"\n                         ng-change=\"setStatement();\"\n                         ng-required=\"!nomineePayload.accountHoldingDeclaration.nomination\"/>\n                  <i class=\"icon-checkbox\"></i>\n                  <span class=\"checkbox-text ria\" style=\"margin-top: -10px;\">Name of Nominee(s)</span>\n                </div>\n              </div>\n              <div class=\"col-md-12 mt-2\">\n                <span ng-show=\"(addNomineeForm[\'statementNomineeName\'].$dirty && addNomineeForm[\'statementNomineeName\'].$invalid) || (addNomineeForm[\'statementNomination\'].$dirty && addNomineeForm[\'statementNomination\'].$invalid)\">\n                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'statementNomineeName\'].$error.required\">{{nomineeValidateData.STATEMENT_HOLDING_DECLARATION_REQUIRED}}</span>\n                </span>\n              </div>--><div class=col-md-12><div class=radio-block><span class=radio><input type=radio name=statmentNomination ng-value=true ng-change=setStatement(); ng-model=nomineePayload.accountHoldingDeclaration.nomination required> <span class=check></span> </span><span class=radio-label>Nomination: Yes</span></div><div class=radio-block><span class=radio><input type=radio name=statmentNomination ng-value=false ng-change=setStatement(); ng-model=nomineePayload.accountHoldingDeclaration.nomination required> <span class=check></span> </span><span class=radio-label>Nomination: No</span></div></div></div></div></div><!--<div class=\"statement-declaration\"  ng-if=\"showNomineeUpdate && nomineePayload.holdmode !== \'ANY_OR_SURVIVOR\'\">\n          <p class=\"section-title\">Incapacitation Declaration (Optional)\n            <i class=\"info-icon base-tooltip\" data-bs-html=\"true\" tooltip data-bs-toggle=\"tooltip\"\n               data-bs-placement=\"right\"\n               data-bs-title=\'<div>\n                SEBI Circular: SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650 dated January 10, 2025, 3.5 paragraph states, Nominee to act on behalf of incapacitated investors 3.5.1. The regulated entity shall provide the investors having single holding / account / folio, the option to: <br/>\n                a) empower, any one of the nominees (excluding minor nominee) to operate the investor’s account / folio, if the investor is physical incapacitated, but still has the capacity to contract. <br/>\n                b) specify either the percentage or absolute value of assets in the account/ folio that can be encashed by such nominee. <br/>\n                c) change such mandate any number of times without any restriction. <br/>\n              </div>\'>\n            </i>\n          </p>\n          <div class=\"declaration-content\">\n            <div class=\"row\">\n              <div class=\"col-md-12\">\n                <span>I hereby authorize\n                  <select name=\"nomineeNames\"\n                      ng-model=\"nomineePayload.incapcitationNomineeIndex\"\n                      ng-options=\"data.value as data.key disable when (data.isMinor) for data in incapcitationList\"\n                      ng-change=\"selectedNominee(incapcitationNomineeIndex)\">\n                    <option value=\"\" selected>Select Nominee</option>\n                  </select>\n                  (nominee number\n                  <input type=\"text\"\n                   ng-model=\"nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber\"\n                   name=\"nomineeNumber\" is-number />\n                  ) to operate my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up to\n                  <input type=\"text\"\n                    ng-model=\"nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage\"\n                    name=\"percentage\" is-number maxlength=\"3\"\n                    ng-required=\"nomineePayload.incapcitationNomineeIndex !== null && !nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount\"\n                    ng-pattern=\"/^(100|[1-9]?[0-9])$/\"\n                    ng-model-options=\"{ allowInvalid: true}\"\n                    ng-disabled=\"nomineePayload.incapcitationNomineeIndex === null || nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount\">\n                  % of assets in the account / folio or Rs.\n                  <input type=\"text\"\n                    ng-model=\"nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount\"\n                    name=\"allowedAmount\"\n                    ng-pattern=\"/^[1-9]\\d*$/\"\n                    is-number maxlength=\"20\"\n                    ng-disabled=\"nomineePayload.incapcitationNomineeIndex === null || nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage\"\n                    ng-required=\"nomineePayload.incapcitationNomineeIndex !==null && !nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage\">.\n                </span>\n                <span ng-show=\"(addNomineeForm[\'percentage\'].$dirty && addNomineeForm[\'percentage\'].$invalid) || (addNomineeForm[\'allowedAmount\'].$dirty && addNomineeForm[\'allowedAmount\'].$invalid)\">\n                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'allowedAmount\'].$error.pattern\">\n                    Amount/percentage cannot be less than 1.\n                  </span>\n                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'percentage\'].$error.pattern && nomineePayload.incapacitationDeclaration.percentage < 1\">\n                    Amount/percentage cannot be less than 1.\n                  </span>\n                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'percentage\'].$error.pattern && nomineePayload.incapacitationDeclaration.percentage > 100\">\n                    Percentage cannot be more than 100%.\n                  </span>\n                </span>\n                <span ng-show=\"(addNomineeForm[\'percentage\'].$dirty && addNomineeForm[\'percentage\'].$invalid) || (addNomineeForm[\'allowedAmount\'].$dirty && addNomineeForm[\'allowedAmount\'].$invalid)\">\n                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'percentage\'].$error.required && addNomineeForm[\'allowedAmount\'].$error.required\">\n                    Please enter the percentage or Rs. that can be encashed by the nominee.\n                  </span>\n                </span>\n              </div>\n            </div>\n          </div>\n        </div>--></div><!--<hr />--><div class=\"form-footer form-content\"><!--{{addNomineeForm.$error |json  }}--><div class=text-danger ng-bind=validationMsg ng-show=addNomineeForm.$invalid></div><span class=\"pull-left back\" ng-click=goToBack() ng-if=!isDreamSip><i class=arrow-blue-back-icon></i> Previous</span> <input ng-if=\"firstFlow == \'NO\' && !isDreamSip\" type=button value=Save class=\"btn btn-secondary-action common-btn-padding\" ng-click=nomineeSaveFolio()> <input type=submit ng-if=!showNomineeUpdate class=\"btn btn-primary-action common-btn-padding\" ng-click=nomineeContinue() value=Continue ng-disabled=\"addNomineeForm.$invalid || !nomineePanValid || !minorPanValid  || (!optOutNominee && wantToAddNomineeLater ) || dobRequired\"> <input type=submit ng-if=showNomineeUpdate class=\"btn btn-primary-action common-btn-padding\" ng-click=nomineeContinue() value=Continue ng-disabled=\"addNomineeForm.$invalid || (!wantToAddNomineeLater && totalPercentage != \'100\') || !nomineePanValid || !minorPanValid  || (!optOutNominee && wantToAddNomineeLater ) || dobRequired || !emailIdValid || !nomineeLicenseValid || !nomineeAadhaarValid || !nomineePassportValid\"></div></div></form></div><style>.input-pan input:focus ~ label , .input-pan input.ng-not-empty ~ label {\n    top: -5px !important;\n    font-size: 12px !important\n  }</style>");
$templateCache.put("app/investor/addFolio/folio-directive/review/folio-review-directive.html","<div class=box-body id=review-folio-minor ng-init=Review.init()><form autocomplete=off class=review-minor-form><div class=form-content><h3 class=page-title>Review Folio Creation</h3><!--<h4>{{reviewFormData.soleApplicantDetail.name}}| </span> <span class=\"pan\">PAN :</span>{{reviewFormData.soleApplicantDetail.panNumber}}</h4>--><section class=minor-details ng-if=reviewFormData.minor><div class=\"box-head clearfix\"><p class=pull-left><strong>Minor Details</strong></p><i ng-if=\"firstFlow ==\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'folioDetails.folioCreation\')\"></i> <i ng-if=\"firstFlow !=\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'main.folio.soleApplicant\')\"></i></div><div class=box-body><div class=\"box-details clearfix\"><div class=col-md-4><table class=table><tr><td><span><strong>Name:</strong></span> <strong>{{reviewFormData.soleApplicantDetail.personalDetail.firstName}}</strong></td></tr><tr><td><span><strong>DOB:</strong></span> <strong>{{reviewFormData.soleApplicantDetail.personalDetail.dateOfBirth}}</strong></td></tr><tr><td class=attachment><span class=proof><strong>DOB Proof:</strong></span> &nbsp;<div class=form-group><span class=upload-button><label><i class=ic-img-icon></i></label></span><span class=\"file-name text-blue\">DOB Proof </span><!--<span class=\"file-name text-blue\">DOB Proof {{minorAgeProofFilename}}</span>--></div></td></tr></table></div></div></div></section><section class=guardian-details><div class=\"box-head clearfix\"><p class=pull-left ng-if=reviewFormData.minor><strong>Guardian Details</strong></p><p class=pull-left ng-if=!reviewFormData.minor><strong>Sole Applicant Details</strong></p><i ng-if=\"firstFlow ==\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'folioDetails.folioCreation\')\"></i> <i ng-if=\"firstFlow !=\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'main.folio.soleApplicant\')\"></i></div><div class=box-body><div class=\"box-details clearfix\"><div class=\"col-md-12 bordered\" style=\"margin-bottom: 20px\"><h5 style=\"padding: 0px\" class=text-blue>Contact Details</h5><div class=row><div class=col-md-4><label ng-if=soleApplicantEmail style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{soleApplicantEmail}}</label><label ng-if=!soleApplicantEmail style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : Not available</label><div class=mobileView ng-if=soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>{{soleApplicantEmailBelongsTo}}</strong></label></div><div class=mobileView class=col-md-3 ng-if=!soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>Not Applicable</strong></label></div></div><div class=col-md-3><label ng-if=soleApplicantMobile style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : {{soleApplicantMobile}}</label><label ng-if=!soleApplicantMobile style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : Not available</label></div></div><div class=row><div class=\"col-md-4 webView\" ng-if=soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>{{soleApplicantEmailBelongsTo}}</strong></label></div><div class=\"col-md-3 webView\" ng-if=!soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>Not Applicable</strong></label></div><div class=col-md-4 ng-if=soleApplicantMobile><label style=\"margin-top: 30px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>{{soleApplicantMobileBelongsTo}}</strong></label></div><div class=col-md-4 ng-if=!soleApplicantMobile><label style=\"margin-top: 30px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> : <strong>Not Applicable</strong></label></div></div></div><div class=\"col-md-4 bordered\"><h5 class=text-blue ng-if=reviewFormData.minor>Guardian’s Income Details</h5><h5 class=text-blue ng-if=!reviewFormData.minor>Income Details</h5><table class=table><tr><td><span><strong>Tax Status:</strong></span> <strong>{{reviewFormData.soleApplicantDetail.personalDetail.taxStatusDescription}}</strong></td></tr><tr><td><span><strong>Occupation:</strong></span> <strong><span easyassist-key=mask-element>{{reviewModalData.occupationDescription}}</span></strong></td></tr><tr ng-if=reviewFormData.soleApplicantDetail.selfDetail.grossAnnualIncome><td><span><strong>Gross Annual Income:</strong></span> <strong><span easyassist-key=mask-element>{{reviewModalData.incomeDescription}}</span></strong></td></tr><tr ng-if=reviewFormData.soleApplicantDetail.selfDetail.netWorth><td><span><strong>Net Worth:</strong></span> <strong><i class=rupee-small-icon></i> <span easyassist-key=mask-element>{{reviewFormData.soleApplicantDetail.selfDetail.netWorth}}</span></strong></td></tr><tr></tr><tr ng-if=reviewFormData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome><td><span><strong>Gross Annual Income:</strong></span> <strong><span easyassist-key=mask-element>{{reviewModalData.incomeDescription}}</span></strong></td></tr><tr ng-if=reviewFormData.soleApplicantDetail.minorDetail.guardian.netWorth><td><span><strong>Net Worth:</strong></span> <strong><i class=rupee-small-icon></i> <span easyassist-key=mask-element>{{reviewFormData.soleApplicantDetail.minorDetail.guardian.netWorth}}</span></strong></td></tr><tr><td><span><strong>Political Exposed Person Status:</strong></span> <strong ng-if=\"\n                  reviewFormData.soleApplicantDetail.selfDetail.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.POLITICAL||\n                  reviewFormData.soleApplicantDetail.minorDetail.guardian.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.POLITICAL\n                  \">Investor is politically exposed person </strong><strong ng-if=\"\n                  reviewFormData.soleApplicantDetail.selfDetail.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.RELATED||\n                  reviewFormData.soleApplicantDetail.minorDetail.guardian.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.RELATED\n                  \">Investor is related to politically exposed person </strong><strong ng-if=\"\n                  reviewFormData.soleApplicantDetail.selfDetail.politicalStatus==pattern.INVESTOR_POLITICAL_STATUS.NONE||\n                  reviewFormData.soleApplicantDetail.minorDetail.guardian.politicalStatus==pattern.INVESTOR_POLITICAL_STATUS.NONE\n                  \">Not Applicable</strong></td></tr><tr ng-if=reviewFormData.minor><td class=pdb20><span><strong>Relationship with Minor:</strong></span> &nbsp;<strong>{{reviewFormData.soleApplicantDetail.minorDetail.guardian.relation}}</strong></td></tr><tr ng-if=reviewFormData.minor><td class=attachment><span class=proof><strong>Relationship Proof:</strong></span> &nbsp;<div class=form-group><span class=upload-button><label><i class=ic-img-icon></i></label></span><span class=\"file-name text-blue\">Relationship Proof</span><!--<span class=\"file-name text-blue\">{{relationshipProofFilename}}</span>--></div></td></tr></table></div><div class=col-md-4><h5 class=text-blue ng-if=reviewFormData.minor>Guardian’s FATCA &amp; CSR information</h5><h5 class=text-blue ng-if=!reviewFormData.minor>FATCA &amp; CSR information</h5><table class=table><tr><td><span><strong>Country of Birth: </strong></span><strong><span easyassist-key=mask-element>{{reviewModalData.birthCountry}}</span></strong></td></tr><tr><td ng-if=reviewFormData.minor><span><strong>City of Birth:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace}}</span></strong></td><td ng-if=!reviewFormData.minor><span><strong>City of Birth:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{reviewFormData.soleApplicantDetail.selfDetail.fatca.birthPlace}}</span></strong></td></tr><tr><td ng-if=reviewFormData.minor><span><strong>Address Type:</strong></span> &nbsp; <strong>{{reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.addressTypeDescription}}</strong></td><td ng-if=!reviewFormData.minor><span><strong>Address Type:</strong></span> &nbsp; <strong>{{reviewFormData.soleApplicantDetail.selfDetail.fatca.addressTypeDescription}}</strong></td></tr></table></div><div class=\"col-md-4 bordered-left\"><!--            <h5 class=\"text-blue\" ng-if=\"reviewFormData.minor && !reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia\">Guardian’s Tax Details</h5>--><h5 class=text-blue ng-if=reviewFormData.minor>Guardian’s Tax Details</h5><h5 class=text-blue ng-if=!reviewFormData.minor>Tax Details</h5><table class=table ng-repeat=\"data in fatcaArray\" ng-if=\"fatcaArray.length>0 && !reviewFormData.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia\"><tr><td><span><strong>Name of Country{{$index+1}}:</strong></span> <strong><span easyassist-key=mask-element>{{data.taxPayingCountryDescription}}</span></strong></td></tr><tr><td><span><strong>Name of City{{$index+1}}:</strong></span> <strong><span easyassist-key=mask-element>{{data.taxPayingCity}}</span></strong></td></tr><tr><td><span><strong>Tax ID Type{{$index+1}}:</strong></span> <strong><span easyassist-key=mask-element>{{data.taxIdType}}</span></strong></td></tr><tr><td><span><strong>Tax ID Number{{$index+1}}:</strong></span> <strong><span easyassist-key=mask-element>{{data.taxId}}</span></strong></td></tr></table><table ng-if=\"fatcaArray.length==0\"><tr><td><span><strong>Tax Details Not Available</strong></span></td></tr></table></div></div></div></section><section class=guardian-details ng-if=\"!reviewFormData.minor && reviewFormData.jointHolders.length>0\"><div class=\"box-head clearfix\"><p class=pull-left><strong>Holders Details</strong></p><i ng-if=\"firstFlow ==\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'folioDetails.jointholders\')\"></i> <i ng-if=\"firstFlow !=\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'main.folio.jointholders\')\"></i></div><div class=box-body ng-repeat=\"holder in reviewFormData.jointHolders\"><div class=\"box-details clearfix\"><!--{{holder|json}}--><div class=col-md-4><strong>Holders Name:</strong> {{holder.firstName+\" \"+holder.middleName+\" \"+holder.lastName}}</div></div><div class=\"box-details clearfix\"><div class=\"col-md-4 bordered\"><h5 class=text-blue>Income Details</h5><table class=table><tr><td><span><strong>Tax Status:</strong></span> &nbsp;<!--<strong>{{// reviewModalData.holders[$index].taxStatusDescription}}</strong>--> <strong>{{holder.taxStatusDescription}}</strong></td></tr><tr><td><span><strong>Occupation:</strong></span> &nbsp; <strong>{{reviewModalData.holders[$index].occupationDescription}}</strong> <strong><span easyassist-key=mask-element>{{holder.occupationDescription }}</span></strong></td></tr><tr ng-if=holder.grossAnnualIncome><td><span><strong>Gross Annual Income:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{holder.incomeDescription}}</span></strong></td></tr><tr ng-if=holder.netWorth><td><span><strong>Net Worth:</strong></span> &nbsp;<strong> <i class=rupee-small-icon></i> <span easyassist-key=mask-element>{{holder.netWorth}}</span></strong></td></tr><tr><td class=pdt20><span><strong>Political Exposed Person Status:</strong></span> &nbsp; <strong ng-if=\"holder.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.POLITICAL\">Investor is politically exposed person </strong><strong ng-if=\"holder.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.RELATED\">Investor is related to politically exposed person </strong><strong ng-if=\"holder.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.NONE\">Not Applicable</strong></td></tr></table></div><div class=\"col-md-4 bordered\"><h5 class=text-blue>FATCA &amp; CSR information</h5><table class=table><tr><td><span><strong>Country of Birth: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.birthCountryDescription}}</span></strong></td></tr><tr><td><span><strong>City of Birth:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.birthPlace}}</span></strong></td></tr><tr><td><span><strong>Address Type:</strong></span> &nbsp; <strong>{{holder.fatcaDetail.addressType}}</strong></td></tr></table></div><div class=col-md-4><h5 class=text-blue>Tax Details</h5><table class=table ng-if=\"\n            holder.fatcaDetail.fatcaTax1 && !holder.fatcaDetail.payTaxInIndia\"><tr><td><span><strong>Name of Country1: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxPayingCountry}}</span></strong></td></tr><tr><td><span><strong>Name of City1: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxPayingCity}}</span></strong></td></tr><tr><td><span><strong>Tax ID Type1:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxIdType}}</span></strong></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax1.taxId><td><span><strong>Tax ID Number1:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxId}}</span></strong></td></tr></table><table class=table ng-if=\"holder.fatcaDetail.fatcaTax2 && !holder.fatcaDetail.payTaxInIndia\"><tr><td><span><strong>Name of Country2: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxPayingCountry}}</span></strong></td></tr><tr><td><span><strong>Name of City2: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxPayingCity}}</span></strong></td></tr><tr><td><span><strong>Tax ID Type2:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxIdType}}</span></strong></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax2.taxId><td><span><strong>Tax ID Number2:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxId}}</span></strong></td></tr></table><table class=table ng-if=\"holder.fatcaDetail.fatcaTax3 && !holder.fatcaDetail.payTaxInIndia\"><tr><td><span><strong>Name of Country3: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxPayingCountry}}</span></strong></td></tr><tr><td><span><strong>Name of City3: </strong></span>&nbsp; <strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxPayingCity}}</span></strong></td></tr><tr><td><span><strong>Tax ID Type3:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxIdType}}</span></strong></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax3.taxId><td><span><strong>Tax ID Number3:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxId}}</span></strong></td></tr></table><table ng-if=\"\n            holder.fatcaDetail.payTaxInIndia ||\n            (holder.fatcaDetail.fatcaTax1==undefined)\n            &&(holder.fatcaDetail.fatcaTax2==undefined)\n            &&(holder.fatcaDetail.fatcaTax3==undefined)\"><tr><td><span><strong>Tax Details Not Available</strong></span></td></tr></table></div></div></div></section><section class=minor-details ng-if=\"!reviewFormData.minor && reviewFormData.nominees.length>0\"><div class=\"box-head clearfix\"><p class=pull-left><strong>Nominee Details</strong></p><i ng-if=\"firstFlow ==\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'folioDetails.addNominee\')\"></i> <i ng-if=\"firstFlow !=\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'main.folio.nominee\')\"></i></div><div class=box-body><div class=\"box-details nominee-section clearfix\"><div class=col-md-4 ng-repeat=\"nominee in reviewFormData.nominees track by $index\"><h6 class=text-blue>Nominee {{$index+1}} Detail</h6><table class=table><tr><td><span><strong>Nominee Name:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeName}}</span></strong></td></tr><tr><td><span><strong>Nominee Relation:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{applicantRelationShip[nominee.nomineeRelation]}}</span></strong></td></tr><tr ng-if=\"showNomineeUpdate && nominee.emailId\"><td><span><strong>Nominee Email Id:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.emailId}}</span></strong></td></tr><tr ng-if=\"showNomineeUpdate && nominee.mobileNumber\"><td><span><strong>Nominee Mobile No.:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.mobileNumber}}</span></strong></td></tr><tr ng-if=\"showNomineeUpdate && nominee.identityProofType\"><td><span><strong>Nominee Personal Identifier:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.identityProofDescription}}</span></strong></td></tr><tr ng-if=\"showNomineeUpdate && nominee.identityProofNumber\"><td><span ng-if=\"nominee.identityProofType === \'AADHAR_CARD\'\"><strong>Nominee Aadhar Card:</strong></span> <span ng-if=\"nominee.identityProofType === \'DRIVING_LICENSE\'\"><strong>Nominee Driving License:</strong></span> <span ng-if=\"nominee.identityProofType === \'PASSPORT\'\"><strong>Nominee Passport:</strong></span> <span ng-if=\"nominee.identityProofType === \'OTHERS\'\"><strong>Nominee Other Identity:</strong></span> <span ng-if=\"nominee.identityProofType === \'PAN_CARD\'\"><strong>Nominee Pan:</strong></span> &nbsp; <strong><span easyassist-key=mask-element><span ng-if=\"nominee.identityProofType === \'AADHAR_CARD\'\">XXXX XXXX </span>{{nominee.identityProofNumber}}</span></strong></td></tr><tr ng-if=\"nominee.panNumber && !reviewFormData.sebiNomineeRegulatory01650Active\"><td><span><strong>Nominee Pan:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.panNumber}}</span></strong></td></tr><tr><td><span><strong>Nominee Dob:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.dob}}</span></strong></td></tr><tr><td><span><strong>Nominee Percentage:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.percentage}}</span></strong></td></tr><tr ng-if=nominee.soleAddressApplicable><td><span><strong>Address Details:</strong></span> &nbsp; <strong>Same As Investor</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine1 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee AddressLine1:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine1}}</span></strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine2 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee AddressLine2:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine2}}</span></strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine3 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee AddressLine3:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine3}}</span></strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.city && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee\'s City:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeAddress.city}}</span></strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.countryName && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee\'s Country:</strong></span> &nbsp; <strong ng-bind=nominee.nomineeAddress.countryName><span easyassist-key=mask-element>{{nominee.nomineeAddress.countryName}}</span></strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.pinCode && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee\'s PinCode:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.nomineeAddress.pinCode}}</span></strong></td></tr><tr><td ng-if=\"nominee.guardianName && !nominee.soleAddressApplicable && nominee.minor\"><span><strong>Guardian Name:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianName}}</span></strong></td></tr><tr><td ng-if=\"nominee.guardianRelationWithNominee && !nominee.soleAddressApplicable && nominee.minor\"><span><strong>Guardian Relation:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{minorRelationShip[nominee.guardianRelationWithNominee]}}</span></strong></td></tr><tr><td ng-if=\"nominee.guardianPanNumber && !nominee.soleAddressApplicable && nominee.minor\"><span><strong>Guardian Pan:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianPanNumber}}</span></strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine1 && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s AddressLine1:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.addressLine1}}</span></strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine2 && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s AddressLine2:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.addressLine2}}</span></strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine3 && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s AddressLine3:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.addressLine3}}</span></strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.city && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s City:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.city}}</span></strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.countryName && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s Country:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.countryName}}</span> </strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.pinCode && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s PinCode:</strong></span> &nbsp; <strong><span easyassist-key=mask-element>{{nominee.guardianAddress.pinCode}}</span></strong></td></tr></table></div></div><div class=\"box-details clearfix\" ng-if=reviewFormData.sebiNomineeRegulatory01650Active><!--<div class=\"col-md-4\" ng-if=\"reviewFormData.nomineeRegistrationCO.incapacitationDeclaration\">\n            <h6 class=\"text-blue\">Incapacitation Details</h6>\n            <table class=\"table\">\n              <tr>\n                <td><span><strong>Nominee Name:</strong></span>&nbsp;\n                  <strong><span easyassist-key=\"mask-element\">{{reviewFormData.nomineeRegistrationCO.incapacitationDeclaration.nomineeName}}</span></strong>\n                </td>\n              </tr>\n              <tr>\n                <td><span><strong>Encash Assets Upto:</strong></span> &nbsp;\n                  <strong>\n                    <span easyassist-key=\"mask-element\" ng-if=\"reviewFormData.nomineeRegistrationCO.incapacitationDeclaration.percentage\">\n                      {{reviewFormData.nomineeRegistrationCO.incapacitationDeclaration.percentage}}%\n                    </span>\n                    <span easyassist-key=\"mask-element\" ng-if=\"reviewFormData.nomineeRegistrationCO.incapacitationDeclaration.amount\">\n                      {{reviewFormData.nomineeRegistrationCO.incapacitationDeclaration.amount}}\n                    </span>\n                  </strong>\n                </td>\n              </tr>\n            </table>\n          </div>--><div class=col-md-4 ng-if=reviewFormData.nomineeRegistrationCO.accountHoldingDeclaration><h6 class=text-blue>Statement of Holding:</h6><table class=table><tr><td><span><strong>{{reviewFormData.nomineeRegistrationCO.accountHoldingDeclaration === \'NOMINATION_YES\' ? \'Nomination: Yes\': \'Nomination: No\'}}</strong></span></td></tr></table></div></div></div></section><section class=bank-details-self><div class=\"box-head clearfix\"><p class=pull-left><strong>Bank Details Self</strong></p><i ng-if=\"firstFlow ==\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'folioDetails.bankDetails\')\"></i> <i ng-if=\"firstFlow !=\'YES\'\" class=\"pull-right edit-icon\" ng-click=\"goToBack(\'main.folio.bankdetails\')\"></i></div><div class=box-body><div class=\"box-details clearfix\"><div class=col-md-4><table class=table><tr><td><span><strong>Bank Name:</strong></span> &nbsp; <strong>{{reviewFormData.bankDetails.bankName}}</strong></td></tr><tr><td><span><strong>Account Type:</strong></span> <strong>{{reviewModalData.accountType}}</strong></td></tr><tr ng-hide=!reviewFormData.bankDetails.pennyDropValid><td><span><strong>MICR No:</strong></span> &nbsp;<strong>{{reviewFormData.bankDetails.micrnumber}}</strong></td></tr><tr><td><span><strong>Payout Mechanism:</strong></span> &nbsp;<strong>{{reviewModalData.payoutDescription}}</strong></td></tr><tr><td><span><strong>Account Number:</strong></span> &nbsp;<strong><span easyassist-key=mask-element>{{reviewFormData.bankDetails.accountNumber}}</span></strong></td></tr><tr><td><span><strong>IFSC No:</strong></span> &nbsp;<strong>{{reviewFormData.bankDetails.ifsccode}}</strong></td></tr><tr><td><span><strong>Branch Location:</strong></span> &nbsp;<strong>{{reviewFormData.bankDetails.bankBranch}}</strong></td></tr><tr><td><span><strong>Branch City:</strong></span> &nbsp;<strong>{{reviewFormData.bankDetails.bankCity}}</strong></td></tr></table></div><div class=col-md-4 ng-if=reviewFormData.bankDetails.chequeLeaf><table class=table><td class=attachment><span class=proof><strong>Cheque Leaf Image:</strong></span> &nbsp;<div class=form-group><span class=upload-button><label><i class=ic-img-icon></i></label></span><span class=\"file-name text-blue\">Cheque Leaf Image</span><!--<span class=\"file-name text-blue\">Cheque Leaf Image{{chequeLeafFilename}}</span>--></div></td></table></div></div></div></section><div class=\"form-footer form-content\"><div class=text-danger ng-bind=\"\"></div><span class=\"pull-left back\" ng-click=goToBack()><i class=arrow-blue-back-icon></i> Previous</span> <input type=submit class=\"btn btn-primary-action common-btn-padding\" ng-click=savePayload(); value=Submit ng-disabled=\"\"></div></div></form></div><style>@media only screen and (max-width: 912px) {\n      .webView {\n        display : none !important;\n      }\n    }\n\n    @media only screen and (min-width: 913px) {\n      .mobileView {\n        display : none !important;\n      }\n    }</style>");
$templateCache.put("app/investor/addFolio/folio-directive/soleApplicant/folio-soleApplicant-directive.html","<div class=tab-content><div id=applicant-details class=\"tab-pane fade in active\"><form name=soleApplicantForm novalidate><div class=form-content><!--<label><strong>Contact Details (Please submit physical request to update contact details in your KYC)</strong></label>--><div ng-if=\"!soleApplicantEmail && !soleApplicantMobile\"><p class=update-contact-warning>{{pattern.UPDATE_CONTANCT_BOTH_MISSING}}</p></div><div ng-if=\"(!soleApplicantEmail && soleApplicantMobile) || (soleApplicantEmail && !soleApplicantMobile)\"><p class=update-contact-warning>{{pattern.UPDATE_CONTACT_SINGLE_MISSING}}</p></div><div class=row><div class=\"col-sm-12 col-md-6\"><table><tbody><tr><td><strong>Email Id</strong> <span class=\"req text-red\">*</span> :</td><td ng-if=!showEmailEditField><span ng-if=soleApplicantEmail>{{soleApplicantEmail}}</span> <span ng-if=!soleApplicantEmail>Not Updated</span> <span class=edit-icon style=\"vertical-align: middle\" ng-if=\"soleApplicantMobile && !showEmailEditField && !showMobileEditField\" ng-click=\"editContactDetails(\'email\')\"></span></td><td ng-if=showEmailEditField><div class=edit-fields><div class=input-normal ng-class=\"{error:soleApplicantForm.email.$dirty && soleApplicantForm.email.$invalid}\"><input type=text name=email ng-model=soleApplicantEditedEmail ng-change=\"changeValue(\'email\', soleApplicantEditedEmail)\" ng-if=showEmailEditField ng-pattern=pattern.email_regex required></div><span ng-if=showEmailEditField class=edit-actions><button type=button class=\"btn-small btn-primary-action\" ng-disabled=\"soleApplicantForm.email.$pristine || soleApplicantForm.email.$error.pattern || soleApplicantForm.email.$error.required\" ng-click=\"generateContactUpdateOtp(\'email\')\">Send OTP</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"cancelEditAction(\'email\');\">Cancel</button></span></div><div ng-show=\"soleApplicantForm.email.$dirty && soleApplicantForm.email.$invalid\"><span class=error-input ng-bind=validations.EMAIL_FIELD></span></div></td></tr></tbody></table></div><div class=\"col-sm-12 col-md-6 belongsToContainerMobile emailBelongsMobile\" style=\"display: inline-flex\" ng-if=soleApplicantEmail><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"margin-left : 5px\" ng-class=\"{error:soleApplicantForm.emailBelongsTo.$dirty && soleApplicantForm.emailBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=emailBelongsTo style=\"width: 150px\" ng-model=holders.emailBelongsTo ng-init=\"holders.emailBelongsTo = holders.emailBelongsTo ? holders.emailBelongsTo: null\" ng-options=\"data.familyCode as data.familyDescription for data in belongToListEmail\" required><option value=\"\" selected>Select Value</option></select><span class=\"req text-red\">*</span></div></div><div class=\"col-sm-12 col-md-6 mLabel\"><table><tbody><tr><td><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> :</td><td ng-if=!showMobileEditField><span ng-if=soleApplicantMobile>{{soleApplicantMobile}}</span> <span ng-if=!soleApplicantMobile>Not Updated</span> <span class=edit-icon style=\"vertical-align: middle\" ng-if=\"soleApplicantEmail && !showMobileEditField && !showEmailEditField\" ng-click=\"editContactDetails(\'mobile\');\"></span></td><td ng-if=showMobileEditField><div class=edit-fields><div class=input-normal style=\"width: 200px\" ng-class=\"{error:soleApplicantForm.mobile.$dirty && soleApplicantForm.mobile.$invalid}\"><input type=text name=mobile ng-model=soleApplicantEditedMobile ng-change=\"changeValue(\'mobile\', soleApplicantEditedMobile)\" ng-pattern=pattern.mobile_regex maxlength=13 required></div><span class=edit-actions><button type=button class=\"btn-small btn-primary-action\" ng-disabled=\"soleApplicantForm.mobile.$pristine || soleApplicantForm.mobile.$error.pattern || soleApplicantForm.mobile.$error.required\" ng-click=\"generateContactUpdateOtp(\'mobile\')\">Send OTP</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"cancelEditAction(\'mobile\');\">Cancel</button></span></div><div ng-show=\"soleApplicantForm.mobile.$dirty && soleApplicantForm.mobile.$invalid && soleApplicantForm.mobile.$error.pattern\"><span class=error-input ng-bind=validations.MOBILE_ISD></span></div></td></tr></tbody></table></div></div><div class=row><div class=\"col-sm-12 col-md-6 belongsToContainerWeb\" style=\"display: inline-flex\" ng-if=soleApplicantEmail><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block ; margin-left : 5px\" ng-class=\"{error:soleApplicantForm.emailBelongsTo.$dirty && soleApplicantForm.emailBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=emailBelongsTo style=\"width: 150px\" ng-model=holders.emailBelongsTo ng-init=\"holders.emailBelongsTo = holders.emailBelongsTo ? holders.emailBelongsTo: null\" ng-options=\"data.familyCode as data.familyDescription for data in belongToListEmail\" required><option value=\"\" selected>Select Value</option></select><span class=\"req text-red\">*</span></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=\"col-sm-12 col-md-6\" ng-if=!soleApplicantEmail></div><div class=\"col-sm-12 col-md-6 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=soleApplicantMobile><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield ng-class=\"{error:soleApplicantForm.mobileBelongsTo.$dirty && soleApplicantForm.mobileBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" name=mobileBelongsTo style=\"width: 150px\" ng-model=holders.mobileBelongsTo ng-init=\"holders.mobileBelongsTo = holders.mobileBelongsTo ? holders.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in belongToListMobile\" required><option value=\"\" selected>Select Value</option></select><span class=\"req text-red\">*</span></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=\"col-sm-12 col-md-6\" ng-if=!soleApplicantMobile></div></div></div><div class=\"form-content pdt0\" ng-if=holders.minor><!--<div class=\"form-group\">\n          &lt;!&ndash;<p  class=\"folio-title\" ng-if=\"firstFlow == \'YES\'\"><strong>Folio Creation</strong></p>&ndash;&gt;\n          <span class=\"folio-title\"><strong>Folio Creation</strong></span>\n          &lt;!&ndash;<span class=\"radio-block\" style=\"display: none\">\n            <span class=\"radio\">\n              <input type=\"radio\" id=\"selefId\" name=\"isMinor\" ng-model=\"holders.minor\"\n                     ng-change=\"setMinorFlag()\"\n                     ng-value=\"false\"/>\n              <span class=\"check\"></span>\n            </span>\n            <label for=\"selefId\">Self</label>\n          </span>\n          <span class=\"radio-block\" style=\"display: none\" ng-class=\"{\'anything-disabled\':(holders.holdmode!==pattern.INVESTOR_HOLD_MODE.SINGLE) && firstFlow == \'YES\'}\">\n            <span class=\"radio\">\n              <input type=\"radio\" id=\"monorId\" name=\"isMinor\" ng-model=\"holders.minor\"\n                     ng-change=\"setMinorFlag()\"\n                     ng-value=\"true\"\n                     ng-disabled=\"holders.formData.holdmode !==pattern.INVESTOR_HOLD_MODE.SINGLE\"/>\n              <span class=\"check\"></span>\n            </span>\n            <label for=\"monorId\">Minor</label>\n          </span>&ndash;&gt;\n        </div>--><div name=minor-fields ng-if=holders.minor class=folio-create><div class=row><div class=\"form-label mr20 mrb20 col-md-12\"><strong>Minor’s Details</strong></div><div><div class=\"col-md-3 select-pdt10\"><div class=selectfield ng-class=\"{error:soleApplicantForm.gender.$dirty && soleApplicantForm.gender.$invalid}\"><select class=\"browser-default custom-select\" name=gender ng-model=holders.gender ng-init=\"holders.gender= holders.gender ? holders.gender: null\" ng-options=\"data.value as data.name for data in genderList\" required><option value=\"\" selected>Gender</option></select><label ng-if=holders.gender>Gender</label><span ng-show=\"soleApplicantForm.gender.$dirty && soleApplicantForm.gender.$invalid\"><span class=error-input ng-show=soleApplicantForm.gender.$error.required ng-bind=validations.GENDER_REQUIRED></span> </span><span class=\"req text-red\">*</span></div></div><div class=col-md-3><div class=input-normal ng-class=\"{error:soleApplicantForm.minorName.$dirty && soleApplicantForm.minorName.$invalid}\"><input type=text name=minorName ng-maxlength=40 limit-to=40 maxlength=40 ng-model=holders.firstName ng-pattern=pattern.name_regex required> <span class=highlight></span> <span class=bar></span><label>Minor\'s Name<span class=\"req text-red\">*</span></label></div><span ng-show=\"soleApplicantForm.minorName.$dirty && soleApplicantForm.minorName.$invalid\"><span class=\"error-input error\" ng-show=soleApplicantForm.minorName.$error.required ng-bind=validations.MINOR_NAME></span> <span class=\"error-input error\" ng-show=\"soleApplicantForm.minorName.$error.pattern && !soleApplicantForm.minorName.$error.required\" ng-bind=validations.MINOR_VALID_NAME></span></span></div><div class=col-md-3><div class=input-normal style=\"position: relative\" ng-class=\"{error:soleApplicantForm.dob.$dirty && soleApplicantForm.dob.$invalid}\"><input type=text name=dob date-calendar format=DD-MMM-YYYY viewmode=days showdefault=\"{{\'\'+!!holders.dateOfBirth}}\" date-default=defaultDob maxdate=now data-min-date=holders.minDateMinor data-on-date-change=changeMinorDob autocomplete=off ng-model=holders.dateOfBirth data-enable=true required> <span class=highlight></span> <span class=bar></span> <i class=calendar-input-icon></i><!--<i class=\"times-icon\" ng-click=\"Nominee.resetNetWorthDate()\"></i>--><label>DD-MMM-YYYY <span class=\"req text-red\">*</span></label><span ng-show=\"soleApplicantForm.dob.$dirty && soleApplicantForm.dob.$invalid\"><span class=error-input ng-show=soleApplicantForm.dob.$error.required>{{validations.MINOR_DOB}}</span></span></div></div></div></div><div class=row><div class=\"col-md-4 age-proof\"><span class=form-label><strong>Upload Minor\'s Age Proof </strong><i class=\"info-icon base-tooltip\" tooltip data-bs-html=true data-bs-toggle=tooltip data-placement={{Main.tooltipClass}} data-bs-title=\"<u style=\'font-size:14px;font-weight:bold\'>View List of Valid DOB Proof</u></br>Below is the list of Valid DOB Proof</br>\n                          <ul style=\'color:black\'><li>Birth certificate</li><li>School leaving certificate/ Mark sheet issued by Higher Secondary Board of respective states, ICSE, CBSE etc.</li>\n                          <li>Passport</li><li>Any other suitable proof evidencing the date of birth of the minor</li></ul>Max File size should be less than or equal to 2 MB.\n                            File format should be tif, tiff, jpg and jpeg extension.\"></i></span><div class=row><div class=\"col-md-8 selectfield\" ng-class=\"{error:soleApplicantForm.minorAgeDoc.$dirty && soleApplicantForm.minorAgeDoc.$invalid}\"><select class=\"browser-default custom-select\" name=minorAgeDoc ng-model=holders.minorProofType ng-change=\"changeFile(\'minorproof\')\" ng-init=\"holders.minorProofType= holders.minorProofType ? holders.minorProofType: null\" ng-options=\"_type.proofTypeDesc as _type.proofTypeDesc for _type in dirData.proofList | filter:filterProofList(\'ageproof\')\" required><option value=\"\" selected>Select Options</option></select><span class=\"req text-red\">*</span> <span ng-show=\"soleApplicantForm.relationship.$dirty && soleApplicantForm.relationship.$invalid\"><span class=error-input ng-show=soleApplicantForm.relationship.$error.required>{{validations.NOMINEE_RELATIONSHIP}}</span></span></div><div class=col-md-4><div class=\"upload-proof upload-margin\"><!--<input type=\"file\" name=\"pic\" accept=\"image/*\">--> <input type=file name=pic id=ageProof accept=image/* file-model-profile=holders.minorAgeProof upload=uploadMinorDobFile(file) ng-disabled=!holders.minorProofType ng-model=holders.minorAgeProof><div class=file-upload><button ng-disabled=!holders.minorProofType>Choose File</button> <span ng-if=chooseAFile>No File Chosen</span></div></div><div class=upload-proof><div class=file-upload><span ng-if=\"holders.minorProofFileType === \'tif\' || holders.minorProofFileType === \'tiff\'\"><a href=javascript:void(0) ng-click=\"downloadFile(holders.minorAgeProofUrl,holders.minorProofFileType,\'minorAgeProof\')\">Download</a></span> <span class=file-name ng-if=\" holders.minorAgeProofUrl && (holders.minorProofFileType == \'jpg\' ||  holders.minorProofFileType == \'jpeg\')\" ng-click=openUploadedDoc(holders.minorAgeProofUrl) ng-show=holders.minorAgeProofUrl>Preview Uploaded Doc</span></div></div></div></div></div></div><div class=row ng-if=holders.minor><div class=col-md-3><p class=pdt10><strong>Tax Status</strong></p><div class=selectfield ng-class=\"{error:soleApplicantForm.taxStatusCode.$dirty && soleApplicantForm.taxStatusCode.$invalid}\"><!--<label>Tax Status</label>--><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=holders.taxStatusCode ng-init=\"holders.taxStatusCode= holders.taxStatusCode ? holders.taxStatusCode: null\" ng-change=changedMinorTaxStatus() ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in dirData.taxStatusList\" required><option value=\"\" selected>Tax Status</option></select><label ng-if=holders.taxStatusCode>Tax Status</label><span ng-show=\"soleApplicantForm.taxStatusCode.$dirty && soleApplicantForm.taxStatusCode.$invalid\"><span class=error-input ng-show=soleApplicantForm.taxStatusCode.$error.required ng-bind=validations.TAX_STATUS></span> </span><span class=\"req text-red\">*</span></div></div></div></div></div><hr ng-if=holders.minor><div class=form-content><div ng-if=holders.minor><div class=\"form-label mrb20\"><strong>Guardian:{{holders.guardianName}}</strong></div><div class=row><div class=\"col-md-4 select-pdt10\"><div class=selectfield ng-class=\"{error:soleApplicantForm.relationship.$dirty && soleApplicantForm.relationship.$invalid}\"><select class=\"browser-default custom-select\" name=relationship ng-model=holders.relationship ng-init=\"holders.relationship= holders.relationship ? holders.relationship: null\" ng-options=\"_type.value as _type.name for _type in relationshipList\" required><option value=\"\" selected>Relationship With Minor</option></select><span class=\"req text-red\">*</span><label ng-if=holders.relationship>Relationship With Minor</label><span ng-show=\"soleApplicantForm.relationship.$dirty && soleApplicantForm.relationship.$invalid\"><span class=error-input ng-show=soleApplicantForm.relationship.$error.required>{{validations.NOMINEE_RELATIONSHIP}}</span></span></div></div></div><div class=row><div class=col-md-4><span class=form-label><strong>Upload Relationship Proof</strong> <i class=\"info-icon base-tooltip\" tooltip data-bs-html=true data-bs-toggle=tooltip data-placement={{Main.tooltipClass}} data-bs-title=\"<u style=\'font-size:14px;font-weight:bold\'>View List of Relationship Proof</u></br>\n                          In case of a natural parent, documents evidencing the relationship of the natural parent with the minor,\n                          if the same is not available as part of the documents mentioned above, should be submitted. In case of court appointed legal guardian, supporting documentary evidence (notarized court order) should be provided.\n                          </br>Max file size should be less than or equal to 2 MB. </br>File format should be tif, tiff, jpg and jpeg extension.\"></i></span><div class=row><div class=\"col-md-8 selectfield\" ng-class=\"{error:soleApplicantForm.relationshipDoc.$dirty && soleApplicantForm.relationshipDoc.$invalid}\"><select class=\"browser-default custom-select\" name=relationshipDoc ng-model=holders.minorRelationshipProofType ng-change=\"changeFile(\'relation\')\" ng-init=\"holders.minorRelationshipProofType= holders.minorRelationshipProofType ? holders.minorRelationshipProofType: null\" ng-options=\"_type.proofTypeDesc as _type.proofTypeDesc for _type in dirData.proofList | filter:filterProofList(\'relationship\')\" required><option value=\"\" selected>Select Options</option></select><span class=\"req text-red\">*</span> <span ng-show=\"soleApplicantForm.relationship.$dirty && soleApplicantForm.relationship.$invalid\"><span class=error-input ng-show=soleApplicantForm.relationship.$error.required>{{validations.NOMINEE_RELATIONSHIP}}</span></span></div><div class=col-md-4><div class=\"upload-proof upload-margin\"><input type=file name=minorRelationshipFile id=minorRelationshipFile accept=image/* file-model-profile=holders.minorRelationshipFile upload=uploadMinorRelationshipFile(file); ng-model=holders.minorRelationshipFile ng-disabled=!holders.minorRelationshipProofType><div class=file-upload><button ng-disabled=!holders.minorRelationshipProofType>Choose File</button> <span ng-if=chooseARelationshipFile>No File Chosen</span></div></div><div class=upload-proof><div class=file-upload><span ng-if=\"holders.relationShipProofFileType === \'tif\' || holders.relationShipProofFileType === \'tiff\'\"><a href=javascript:void(0) ng-click=\"downloadFile(holders.minorRelationshipProofUrl,holders.relationShipProofFileType,\'minorRelationshipProof\')\">Download</a></span> <span class=file-name ng-if=\"holders.minorRelationshipProofUrl && (holders.relationShipProofFileType == \'jpg\' ||  holders.relationShipProofFileType == \'jpeg\')\" ng-click=openUploadedDoc(holders.minorRelationshipProofUrl) ng-show=holders.minorRelationshipProofUrl>Preview Uploaded Doc</span></div></div></div></div></div></div></div><div class=row ng-if=!holders.minor><div class=col-md-3><p class=pdt10><strong>Tax Status</strong></p><div class=selectfield ng-class=\"{error:soleApplicantForm.taxStatusCode.$dirty && soleApplicantForm.taxStatusCode.$invalid}\"><!--<label>Tax Status</label>--><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=holders.taxStatusCode ng-init=\"holders.taxStatusCode= holders.taxStatusCode ? holders.taxStatusCode: null\" ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in dirData.taxStatusList\" ng-change=changedTaxStatus() required><option value=\"\" selected>Tax Status</option></select><label ng-if=holders.taxStatusCode>Tax Status</label><span ng-show=\"soleApplicantForm.taxStatusCode.$dirty && soleApplicantForm.taxStatusCode.$invalid\"><span class=error-input ng-show=soleApplicantForm.taxStatusCode.$error.required ng-bind=validations.TAX_STATUS></span> </span><span class=\"req text-red\">*</span></div></div></div><p class=pdt10><strong><span ng-if=holders.minor>Guardian\'s </span>Income Details</strong></p><div class=row><div class=\"col-md-3 select-pdt10\"><div class=selectfield ng-class=\"{error:soleApplicantForm.occupation.$dirty && soleApplicantForm.occupation.$invalid}\"><select class=\"browser-default custom-select\" name=occupation ng-model=holders.occupation ng-init=\"holders.occupation= holders.occupation ? holders.occupation: null\" ng-disabled=!hufToContinue ng-options=\"_type.occupationCode as _type.occupationDescription for _type in dirData.occupationList\" ng-change=setOccuValidation() easyassist-key=mask-element required><option value=\"\" selected>Occupation</option></select><label ng-if=holders.occupation>Occupation</label><span ng-show=\"soleApplicantForm.occupation.$dirty && soleApplicantForm.occupation.$invalid\"><span class=error-input ng-show=soleApplicantForm.occupation.$error.required ng-bind=validations.OCCUPATION></span> </span><span class=\"req text-red\">*</span></div></div></div><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:soleApplicantForm.grossAnnualIncome.$dirty\n                 && soleApplicantForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-click=\"setOptionalEmpty(\'GrossAnnualIncome\')\" ng-model=holders.grossAnnualIncome ng-init=\"holders.grossAnnualIncome= holders.grossAnnualIncome ? holders.grossAnnualIncome: null\" ng-options=\"_type.incomeCode as _type.incomeDescription for _type in dirData.incomeSlabList\" ng-required=\"!(holders.netWorth)\n                      &&!(holders.netWorthDate)\" ng-disabled=\"holders.netWorth || !hufToContinue\" easyassist-key=mask-element ng-class=\"{\'selectfield-disabled\':holders.netWorth}\"><option value=\"\" selected>Gross Annual Income</option></select><label ng-if=holders.grossAnnualIncome>Gross Annual Income</label><span ng-show=\"soleApplicantForm.grossAnnualIncome.$dirty && soleApplicantForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=soleApplicantForm.grossAnnualIncome.$error.required ng-bind=validations.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=soleApplicantForm.grossAnnualIncome.$error.number ng-bind=validations.INVALID_AMOUNT></span> </span><span ng-if=\"!(holders.netWorth)\n                      &&!(holders.netWorthDate)\" class=\"req text-red\">*</span> <span class=highlight></span> <span class=bar></span></div></div><div class=\"or-part col-md-1\" style=\"position: relative;top: 30px;text-align: center\">OR<span style=color:#d82018> *</span></div><div class=col-md-3><div class=\"input-normal mgt13\" ng-class=\"{error:soleApplicantForm.netWorth.$dirty\n                 && soleApplicantForm.netWorth.$invalid}\"><input type=number name=netWorth class=pd20 ng-model=holders.netWorth ng-required=!holders.grossAnnualIncome ng-disabled=\"holders.grossAnnualIncome || !hufToContinue\" ng-maxlength=15 limit-to=15 maxlength=15 easyassist-key=mask-element onkeyup=\"NumToWord(this.value,\'DisplayWordsTaxAmt\')\"> <span ng-show=\"soleApplicantForm.netWorth.$dirty && soleApplicantForm.netWorth.$invalid\"><span class=error-input ng-show=soleApplicantForm.netWorth.$error.number ng-bind=validations.INVALID_AMOUNT></span> <span class=error-input ng-show=soleApplicantForm.netWorth.$error.required ng-bind=validations.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span> <i class=rupee-input-icon></i><label>Net worth (in Rs.) <span ng-if=\"!(holders.grossAnnualIncome)\n                ||(holders.netWorthDate)\" class=\"req text-red\">*</span></label></div><div class=form-group><span id=DisplayWordsTaxAmt>{{holders.amountInWords}} (In Words)</span></div></div><div class=col-md-3><div class=\"input-select input-normal date date-picker mgt13 soleApplicantDOB\" ng-class=\"{error : holders.netWorth\n                   && !holders.netWorthDate\n                   }\"><input type=text name=netWorthDate date-calendar format=DD-MMM-YYYY viewmode=days showdefault=\"{{\'\'+!!holders.netWorthDate}}\" date-default=defaultDob maxdate=now data-min-date=minDate data-on-date-change=changeStartDate autocomplete=off ng-model=holders.netWorthDate ng-required=!holders.grossAnnualIncome ng-disabled=\"holders.grossAnnualIncome || !hufToContinue\"> <span class=highlight></span> <span class=bar></span> <i class=calendar-input-icon></i><!--<i class=\"times-icon\" ng-click=\"holders.resetNetWorthDate()\"></i>--><label>As on DD-MMM-YYYY <span ng-if=\"!(holders.grossAnnualIncome)\n                ||(holders.netWorth)\" class=\"req text-red\">*</span></label><span ng-show=\"soleApplicantForm.netWorthDate.$dirty && soleApplicantForm.netWorthDate.$invalid\"><span class=error-input ng-show=soleApplicantForm.netWorthDate.$error.required>{{validations.NET_WORTH_DATE}}</span></span></div><span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span></div></div></div><div class=\"form-content less-pad political-exposed\"><p><strong><span ng-if=holders.minor>Guardian\'s </span>Politically Exposed Person (PEP) Status</strong></p><div class=radio-block><span class=radio><input type=radio id=politicalStatus1 name=politicalStatus ng-model=holders.politicalStatus ng-disabled=!hufToContinue ng-value=CONST.POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=politicalStatus1>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=holders.politicalStatus ng-disabled=!hufToContinue ng-value=CONST.POLITICAL_STATUS.RELATED> <span class=check></span></span><label for=politicalStatus2>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus3 name=politicalStatus ng-model=holders.politicalStatus ng-disabled=!hufToContinue ng-value=CONST.POLITICAL_STATUS.NONE> <span class=check></span></span><label for=politicalStatus3>Not Applicable</label></div></div><div class=\"form-content less-pad\"><p class=nomargin><strong><span ng-if=holders.minor>Guardian\'s </span>FATCA and CRS information</strong> <i ng-if=holders.minor class=\"info-icon base-tooltip\" tooltip data-bs-html=true data-bs-toggle=tooltip data-placement={{Main.tooltipClass}} data-bs-title=\"The below information is required for all applicants(s) / guardians. Is also applicant(s) / guardian’s country of birth / citizenship / Nationality / TAX residency other than India?\"></i></p><div class=\"row pdt10\"><div class=\"col-md-3 select-pdt10\"><div class=selectfield ng-class=\"{error:soleApplicantForm.birthCountry.$dirty && soleApplicantForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=holders.birthCountry ng-init=\"holders.birthCountry= holders.birthCountry ? holders.birthCountry: null\" ng-disabled=!hufToContinue ng-options=\"country.countryCode as country.countryName for country in dirData.countryList\" easyassist-key=mask-element required><option value=\"\" selected>Country of Birth</option></select><span class=\"req text-red\">*</span> <span ng-show=\"soleApplicantForm.birthCountry.$dirty && soleApplicantForm.birthCountry.$invalid\"><span class=error-input ng-show=soleApplicantForm.birthCountry.$error.required>{{validations.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-3><div class=\"input-normal cityBirth\" ng-class=\"{error:soleApplicantForm.birthCity.$dirty && soleApplicantForm.birthCity.$invalid}\"><input type=text name=birthCity only-alphabets ng-model=holders.birthCity ng-disabled=!hufToContinue ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element ng-pattern=/[A-Za-z]+(\\s[A-Za-z]+)?/ required> <span class=highlight></span> <span class=bar></span><label>City of Birth <span class=\"req text-red\">*</span></label><span ng-show=\"soleApplicantForm.birthCity.$dirty && soleApplicantForm.birthCity.$invalid\"><span class=error-input ng-show=soleApplicantForm.birthCity.$error.required>{{validations.BIRTH_CITY}}</span></span></div></div></div><div class=\"row pdt10\"><div class=\"col-md-3 select-pdt10\"><div class=selectfield ng-class=\"{error:soleApplicantForm.fatcaAddressType.$dirty && soleApplicantForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-model=holders.fatcaAddressType ng-init=\"holders.fatcaAddressType= holders.fatcaAddressType ? holders.fatcaAddressType: null\" ng-disabled=!hufToContinue ng-options=\"_type.value as _type.addressDescription for _type in dirData.addressTypeList\" required><option value=\"\" selected>Address Type</option></select><label ng-if=holders.fatcaAddressType>Address Type</label><span ng-show=\"soleApplicantForm.fatcaAddressType.$dirty && soleApplicantForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=soleApplicantForm.fatcaAddressType.$error.required ng-bind=validations.FATCA_ADDRESS_TYPE_REQUIRED></span> </span><span class=\"req text-red\">*</span></div></div></div></div><div class=\"form-content less-pad inves-pay\"><p><strong>Does the investor pay or file tax other than India?</strong></p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-change=changePayTaxOutsideIndiaStatus(true) ng-model=holders.payTaxInIndia ng-disabled=!hufToContinue ng-value=false> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-model=holders.payTaxInIndia ng-disabled=!hufToContinue ng-value=true> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span><div ng-if=\"!holders.minor && !holders.payTaxInIndia\"><div class=tax-res ng-repeat=\"data in holders.fatcaArray\"><p><strong>Tax Residency Country</strong> <span ng-show=\"$index > 0\" class=remove-item ng-click=deleteTaxResidency($index)><i class=delete-red-icon></i></span></p><div class=row><div class=\"col-md-3 select-pdt10\"><div class=selectfield ng-class=\"{error:soleApplicantForm[\'birthCountry-\'+$index].$dirty && soleApplicantForm[\'birthCountry-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=data.taxPayingCountry ng-init=\"data.taxPayingCountry=data.taxPayingCountry?data.taxPayingCountry:null\" ng-options=\"country.countryCode as country.countryName for country in dirData.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" easyassist-key=mask-element required><option value=\"\" selected>Name Of Country</option></select><label ng-if=holders.payOutsideIndiaAddresses[$index].countryName>Name Of Country</label><span class=\"req text-red\">*</span> <span ng-show=\"soleApplicantForm[\'birthCountry-\'+$index].$dirty && soleApplicantForm[\'birthCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"soleApplicantForm[\'birthCountry-\'+$index].$error.required\">{{validations.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-3><div class=\"input-normal cityBirth\" ng-class=\"{error:soleApplicantForm[\'birthCity-\'+$index].$dirty && soleApplicantForm[\'birthCity-\'+$index].$invalid}\"><input type=text name=birthCity{{$index}} ng-model=data.taxPayingCity ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element required> <span class=highlight></span> <span class=bar></span><label>City<span class=\"req text-red\">*</span></label><span ng-show=\"soleApplicantForm[\'birthCity-\'+$index].$dirty && soleApplicantForm[\'birthCity-\'+$index].$invalid\"><span class=error-input ng-show=\"soleApplicantForm[\'birthCity-\'+$index].$error.required\">{{validations.BIRTH_CITY}}</span></span></div></div></div><div class=row><div class=\"col-md-3 select-pdt10\"><div class=selectfield ng-class=\"{error:soleApplicantForm[\'taxIdType-\'+$index].$dirty && soleApplicantForm[\'taxIdType-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType-$index ng-model=data.taxIdType ng-init=\"data.taxIdType= data.taxIdType ? data.taxIdType: null\" ng-options=\"taxid.description as taxid.description for taxid in dirData.taxIdTypeList\" easyassist-key=mask-element required><option value=\"\" selected>Select Tax ID type</option></select><label ng-if=holders.payOutsideIndiaAddresses[$index].taxIdType>Select Tax ID type</label><span class=\"req text-red\">*</span> <span ng-show=\"soleApplicantForm[\'taxIdType-\'+$index].$dirty && soleApplicantForm[\'taxIdType-\'+$index].$invalid\"><span class=error-input ng-show=\"soleApplicantForm[\'taxIdType-\'+$index].$error.required\">{{validations.TAX_ID_TYPE}}</span></span></div></div><div class=col-md-3><div class=\"input-select input-normal\"><input type=text name=taxId-{{$index}} ng-model=data.taxId ng-maxlength=20 limit-to=20 maxlength=20 easyassist-key=mask-element required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=\"req text-red\">*</span></label></div></div></div></div><div class=\"add-another-tax-res tax-res\"><a ng-show=\"((holders.fatcaArray.length)*1<3)\" href=\"\" class=text-blue ng-click=addMoreTaxResidency()><strong><i class=expand-icon></i> <span>Add another tax residency country</span></strong></a></div></div><div ng-if=\"holders.minor && !holders.payTaxInIndia\"><div class=tax-res ng-repeat=\"data in holders.fatcaArray\"><p><strong>Tax Residency Country</strong> <span ng-show=\"$index > 0\" class=remove-item ng-click=deleteTaxResidencyFromFatca($index)><i class=delete-red-icon></i></span></p><div class=row><div class=\"col-md-3 select-pdt10\"><div class=selectfield ng-class=\"{error:soleApplicantForm[\'birthCountry\'+$index].$dirty && soleApplicantForm[\'birthCountry\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry{{$index}} ng-model=data.taxPayingCountry ng-init=\"data.taxPayingCountry= data.taxPayingCountry ? data.taxPayingCountry: null\" ng-options=\"country.countryCode as country.countryName for country in dirData.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" easyassist-key=mask-element required><option value=\"\" selected>Name Of Country</option></select><label ng-if=data.taxPayingCountry>Name Of Country</label><span class=\"req text-red\">*</span> <span ng-show=\"soleApplicantForm[\'birthCountry\'+$index].$dirty && soleApplicantForm[\'birthCountry\'+$index].$invalid\"><span class=error-input ng-show=\"soleApplicantForm[\'birthCountry\'+$index].$error.required\">{{validations.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-3><div class=input-normal ng-class=\"{error:soleApplicantForm[\'birthCity\'+$index].$dirty && soleApplicantForm[\'birthCity\'+$index].$invalid}\"><input type=text name=birthCity{{$index}} ng-model=data.taxPayingCity ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element required capitalize> <span class=highlight></span> <span class=bar></span><label>City<span class=\"req text-red\">*</span></label><span ng-show=\"soleApplicantForm[\'birthCity\'+$index].$dirty && soleApplicantForm[\'birthCity\'+$index].$invalid\"><span class=error-input ng-show=\"soleApplicantForm[\'birthCity\'+$index].$error.required\">{{validations.BIRTH_CITY}}</span></span></div></div></div><div class=row><div class=\"col-md-3 select-pdt10\"><div class=selectfield ng-class=\"{error:soleApplicantForm[\'taxIdType\'+$index].$dirty && soleApplicantForm[\'taxIdType\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType{{$index}} ng-model=data.taxIdType ng-init=\"data.taxIdType= data.taxIdType ? data.taxIdType: null\" ng-options=\"taxid.description as taxid.description for taxid in dirData.taxIdTypeList\" easyassist-key=mask-element required><option value=\"\" selected>Select Tax ID type</option></select><label ng-if=data.taxIdType>Select Tax ID type</label><span class=\"req text-red\">*</span> <span ng-show=\"soleApplicantForm[\'taxIdType\'+$index].$dirty && soleApplicantForm[\'taxIdType\'+$index].$invalid\"><span class=error-input ng-show=\"soleApplicantForm[\'taxIdType\'+$index].$error.required\">{{validations.TAX_ID_TYPE}}</span></span></div></div><div class=col-md-3><div class=input-normal ng-class=\"{error:soleApplicantForm[\'taxId\'+$index].$dirty && soleApplicantForm[\'taxId\'+$index].$invalid}\"><input type=text name=taxId{{$index}} ng-model=data.taxId ng-maxlength=20 limit-to=20 maxlength=20 easyassist-key=mask-element required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=\"req text-red\">*</span></label><span ng-show=\"soleApplicantForm[\'taxId\'+$index].$dirty && soleApplicantForm[\'taxId\'+$index].$invalid\"><span class=error-input ng-show=\"soleApplicantForm[\'taxId\'+$index].$error.required\">{{validations.TAX_ID_NUMBER}}</span></span></div></div></div></div><div class=\"add-another-tax-res tax-res\" ng-if=holders.minor><a ng-show=\"(!holders.payTaxInIndia) &&\n      ((holders.fatcaArray.length)*1<3)\" href=\"\" class=text-blue ng-click=addNewResidencyFields()><strong><i class=expand-icon></i> <span>Add another tax residency country</span></strong></a></div></div></div><hr><div class=\"form-footer form-content\"><!--<button class=\"btn btn-negative-action\" ng-click=\"holders.cancelTransaction()\">Cancel</button>--> <span class=\"pull-left back\" ng-click=\"back(\'fromBack\')\" ng-if=!isDreamSip><i class=arrow-blue-back-icon></i> Previous</span> <input ng-if=\"firstFlow === \'NO\' && !isDreamSip\" type=button class=\"btn btn-secondary-action common-btn-padding\" ng-click=saveFolio() ng-disabled=!hufToContinue value=Save> <input ng-if=!holders.minor type=submit class=\"pull-right btn btn-primary-action common-btn-padding\" ng-disabled=\"(soleApplicantForm.$invalid) || (!holders.netWorthDate  && !holders.grossAnnualIncome) || !hufToContinue || !soleApplicantEmail || !soleApplicantMobile\" value=Continue ng-click=continue()> <input ng-if=holders.minor type=submit class=\"pull-right btn btn-primary-action common-btn-padding\" ng-disabled=\"(soleApplicantForm.$invalid) || (!holders.dateOfBirth)||(holders.holdmode !== pattern.INVESTOR_HOLD_MODE.SINGLE) || !soleApplicantEmail || !soleApplicantMobile\" value=Continue ng-click=continue()></div></form></div></div><style>.update-contact-warning{\n    width: 100%;\n    display: inline-block;\n    background-color: #fef1f2;\n    border-top: 1px solid #e0e0e0;\n    border-bottom: 1px solid #e0e0e0;\n    text-align: center;\n    font-size: 12px;\n    padding: 2px;\n    position: relative;\n    top: 0px;\n    margin-right: 12px;\n  }\n    @media only screen and (max-width: 912px) {\n      .belongsToContainerMobile {\n        flex-direction: column;\n        width: 100%;\n      }\n\n      .belongsToContainerWeb {\n        display : none !important;\n      }\n\n      .belongsToContainerMobile select {\n        width : 100% !important;\n      }\n\n      .mLabel label {\n        margin-left : 0px !important;\n      }\n\n      .belongsToContainerMobile div {\n        margin-left : 0px !important;\n      }\n    }\n\n    @media only screen and (min-width: 913px) {\n      .emailBelongsMobile {\n        display : none !important;\n      }\n    }</style>");
$templateCache.put("app/investor/profile/modifyBank/addBank/addBank.html","<form class=\"main-section clearfix modifyBank\" name=AddBankForm id=AddBankForm ng-init=AddBank.init()><h5 class=screen-title>Add New Bank</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.profile.folioDetails>Folio Details </span><i class=breadcrumb-icon></i><span> Add Bank</span></p><div class=folio-addbank><strong>Folio : </strong><span>{{AddBank.folioNumberToDisplay}}</span></div><div class=content-area><p class=\"col-md-12 form-title\"><strong>Provide New Bank Details</strong></p><div class=col-md-12><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:AddBankForm.ifsccode.$dirty && AddBankForm.ifsccode.$invalid}\"><input type=text ng-model=AddBank.payload.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-disabled=AddBank.disableAccntDetails ng-pattern=AddBank.IFSC_REGEX capitalize required readonly> <span class=highlight></span> <span class=bar></span> <span class=\"glyphicon glyphicon-search\" ng-click=AddBank.selectIFSC()></span><label ng-class={ifscBlank:!AddBank.payload.ifsccode}>IFSC Code <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.ifsccode.$dirty && AddBankForm.ifsccode.$invalid\"><span class=error-input ng-show=AddBankForm.ifsccode.$error.required ng-bind=AddBank.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=AddBankForm.ifsccode.$error.pattern ng-bind=AddBank.validateData.IFSC_CODE_REGEX></span></span></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:AddBankForm.bankName.$dirty && AddBankForm.bankName.$invalid}\"><input type=text ng-model=AddBank.selectedBank name=bankName required ng-disabled=!AddBank.selectedBank ng-class={enable:AddBank.selectedBank} ng-readonly=AddBank.selectedBank> <span class=highlight></span> <span class=bar></span><label>Bank Name<span class=\"req text-red\">*</span></label></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=selectfield ng-class=\"{error:AddBankForm.accountType.$dirty && AddBankForm.accountType.$invalid}\"><select class=select-box name=accountType ng-model=AddBank.payload.accountType ng-options=\"_type.accountTypeCode as _type.accountType for _type in AddBank.bankTypeList\" ng-init=\"AddBank.payload.accountType = AddBank.payload.accountType ? AddBank.payload.accountType : null\" required ng-disabled=!AddBank.payload.ifsccode ng-class={disablefield:!AddBank.payload.ifsccode}><option value=\"\" selected>Account Type</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=AddBankForm.accountType.$error ng-show=AddBankForm.accountType.$dirty><span ng-message=required ng-bind=AddBank.validateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row><div class=\"col-md-4 col-md-offset-1\"><div class=input-normal ng-class=\"{error:AddBankForm.branchLocation.$dirty && AddBankForm.branchLocation.$invalid}\"><input type=text ng-model=AddBank.payload.bankBranch maxlength=40 name=branchLocation required autocomplete=off capitalize ng-disabled=!AddBank.payload.ifsccode ng-class={enable:AddBank.payload.bankBranch}> <span class=highlight></span> <span class=bar></span><label>Branch Location <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.branchLocation.$dirty && AddBankForm.branchLocation.$invalid\"><span class=error-input ng-show=AddBankForm.branchLocation.$error.required ng-bind=AddBank.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=input-normal ng-class=\"{error:AddBankForm.branchCity.$dirty && AddBankForm.branchCity.$invalid}\"><input type=text ng-model=AddBank.payload.bankCity name=branchCity only-alphabets autocomplete=off capitalize required ng-disabled=!AddBank.payload.ifsccode ng-class={enable:AddBank.payload.bankCity}> <span class=highlight></span> <span class=bar></span><label>Branch City <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.branchCity.$dirty && AddBank.branchCity.$invalid\"><span class=error-input ng-show=AddBankForm.branchCity.$error.required ng-bind=AddBank.validateData.CITY_REQUIRED></span></span></div></div><div class=col-md-4><div class=selectfield ng-class=\"{error:AddBankForm.payoutMechanism.$dirty && AddBankForm.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select\" name=payoutMechanism ng-model=AddBank.payload.payoutMechanism ng-options=\"_type.payoutCode as _type.payoutDescription for _type in AddBank.payoutMechanismList\" ng-init=\"AddBank.payload.payoutMechanism = AddBank.payload.payoutMechanism ? AddBank.payload.payoutMechanism : null\" required ng-disabled=!AddBank.payload.ifsccode ng-class={disablefield:!AddBank.payload.ifsccode} ng-readonly=\"\"><option value=\"\" selected>Payout Mechanism</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=AddBankForm.payoutMechanism.$error ng-show=AddBankForm.payoutMechanism.$dirty><span ng-message=required ng-bind=AddBank.validateData.PAYOUT_MECH_REQUIRED></span></span></div></div></div><div class=row><div class=\"col-md-4 col-md-offset-1\"><div class=input-normal ng-class=\"{error:(AddBank.accModelDirty &&\n                 (!AddBank.payload.accountNumber.split(\'\').length || AddBank.payload.accountNumber.split(\'\').length>25))}\"><input type=text ng-model=AddBank.payload.accountNumber easyassist-key=mask-element onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-maxlength=20 maxlength=20 name=accountNumber limit-to=20 ng-disabled=!AddBank.payload.ifsccode ng-class={enable:AddBank.payload.ifsccode} required autocomplete=off directive.mask ng-change=AddBank.accFocus(); capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number <span class=\"req text-red\">*</span></label><span ng-show=AddBank.accModelDirty><span class=error-input ng-show=AddBankForm.accountNumber.$error.required ng-bind=AddBank.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(AddBank.payload.accountNumber.split(\'\').length !=0 && AddBank.payload.accountNumber.split(\'\').length<1)\" ng-bind=AddBank.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=input-normal ng-class=\"{error:AddBankForm.verifyAccountNumber.$dirty && AddBankForm.verifyAccountNumber.$invalid}\"><input type=text ng-model=AddBank.verifyAccountNumber easyassist-key=mask-element ng-maxlength=20 maxlength=20 name=verifyAccountNumber limit-to=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=AddBank.payload.accountNumber required autocomplete=off ng-keydown=AddBank.copyPasteHandler($event) capitalize ng-disabled=!AddBank.payload.ifsccode ng-class={enable:AddBank.payload.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Verify Account Number <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.verifyAccountNumber.$dirty && AddBankForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=AddBankForm.verifyAccountNumber.$error.required ng-bind=AddBank.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"AddBankForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\" ng-bind=AddBank.validateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"AddBankForm.verifyAccountNumber.$error.pattern\n            && !AddBankForm.verifyAccountNumber.$error.maxlength && !AddBankForm.verifyAccountNumber.$error.required\">{{AddBank.validateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div><div class=row><div class=\"col-md-12 mark-default\"><div class=checkbox><input type=checkbox ng-model=AddBank.payload.makeDefaultBank> <i class=icon-checkbox></i> <span class=checkbox-text>Make it a default bank for this folio</span></div></div></div><ng-bind-html dynamic=AddBank.note></ng-bind-html><ng-bind-html dynamic=AddBank.noteBankRestrict></ng-bind-html><div class=\"row upload-some\"><span class=leaf-label>Upload Old Bank Proof <span class=\"req text-red\">*</span> <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right title=\"Upload cheque leaf of old bank to validate bank details. \"></i></span><p class=upload-data><span class=grey-text>Bank Name : </span><span>{{AddBank.oldBankName}}</span></p><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=AddBank.chequeLeafOld enctype=multipart/form-data upload=AddBank.uploadChequeLeafFileOld(file) ng-model=AddBank.bankDetails.chequeLeafOld><div class=file-upload><button>Choose File</button> <span ng-if=AddBank.chooseAFileOld>No File Chosen</span> <span ng-click=AddBank.openUploadedDocOld()>{{AddBank.bankDetails.chequeLeafOld}}</span></div></div></div><div class=\"row upload-some\" ng-if=!AddBank.payload.pennyDropValid><span class=leaf-label>Upload New Bank Proof <span class=\"req text-red\">*</span> <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right title=\"Upload cheque leaf of new bank to validate bank details. \"></i></span><div class=upload-leaf><input id=uploadCheckLeafNew type=file name=pic accept=image/* file-model-profile=AddBank.chequeLeafNew upload=\"AddBank.uploadChequeLeafFile(file,\'add\')\" ng-model=AddBank.bankDetails.chequeLeaf><div class=file-upload><button>Choose File</button> <span ng-if=AddBank.chooseAFileNew>No File Chosen</span> <span ng-click=AddBank.openUploadedDoc()>{{AddBank.bankDetails.chequeLeaf}}</span></div></div></div></div><div class=tc-block ng-if=AddBank.showTerms><h6 ng-click=Profile.checkTnc()>Terms & Conditions</h6><div><div class=checkbox><input ng-model=AddBank.isCheckedCobmTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=AddBank.showCobmTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment.</span></div></div></div><div class=\"form-footer col-md-12\"><a href=\"\" class=\"pull-left back\" ng-click=AddBank.back()><i class=arrow-blue-back-icon></i>Back</a> <span class=pull-right><input type=button value=Cancel ng-click=AddBank.back() class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=Submit ng-if=!AddBank.payload.pennyDropValid class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"AddBankForm.$invalid || !AddBank.bankDetails.chequeLeaf || !AddBank.bankDetails.chequeLeafOld || !AddBank.isCheckedCobmTandC\" ng-click=AddBank.addBankSubmit()> <input type=submit value=Validate ng-if=AddBank.payload.pennyDropValid class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"AddBankForm.$invalid || !AddBank.bankDetails.chequeLeafOld || !AddBank.isCheckedCobmTandC\" ng-click=AddBank.validatePennyDropDetails()></span></div></div><style>.ifscBlank {\n      top:15px !important;\n    }</style></form>");
$templateCache.put("app/investor/profile/modifyBank/changeBank/changeBank.html","<form class=\"main-section clearfix modifyBank\" name=modifyBank ng-init=ChangeBank.init()><h5 class=screen-title>Change Bank</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.portfolio.list>Folio Details </span><i class=breadcrumb-icon></i><span> Modify Bank</span></p><div class=folio-addbank><strong>Folio : </strong><span>{{ChangeBank.folioNumberToDisplay}}</span></div><div class=content-area><p class=\"col-md-12 form-title\"><strong>Provide New Bank Details</strong></p><div class=col-md-12><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:modifyBank.bankName.$dirty && modifyBank.bankName.$invalid}\"><select class=select-box name=bankName ng-model=ChangeBank.selectedBank ng-change=ChangeBank.changeBank() required><option value=\"\" selected>Bank Name</option><option ng-repeat=\"banks in ChangeBank.bankList\" value={{banks}}>{{banks.bankName}}</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=modifyBank.bankName.$error ng-show=modifyBank.bankName.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.BANK_NAME_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=selectfield ng-class=\"{error:modifyBank.accountType.$dirty && modifyBank.accountType.$invalid}\"><select class=select-box name=accountType ng-model=ChangeBank.payload.accountType ng-options=\"_type.accountTypeCode as _type.accountType for _type in ChangeBank.bankTypeList\" ng-init=\"ChangeBank.payload.accountType = ChangeBank.payload.accountType ? ChangeBank.payload.accountType : null\" required><option value=\"\" selected>Account Type</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=modifyBank.accountType.$error ng-show=modifyBank.accountType.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-normal mgt8\" ng-class=\"{error:modifyBank.micrnumber.$dirty && modifyBank.micrnumber.$invalid}\"><input type=text ng-model=ChangeBank.payload.micrnumber ng-maxlength=9 limit-to=9 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-minlength=9 ng-pattern=\"\'^[0-9]+$\'\" name=micrnumber autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>MICR Number <span class=\"req text-red\">*</span></label><span class=error-input ng-messages=modifyBank.micrnumber.$error ng-show=modifyBank.micrnumber.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.MICR_NUMBER_REQUIRED></span> <span ng-message=minlength ng-bind=ChangeBank.validateData.MICR_NUMBER_RANGE></span> <span ng-message=maxlength ng-bind=ChangeBank.validateData.MICR_NUMBER_RANGE></span> <span ng-message=pattern ng-bind=ChangeBank.validateData.DIGITS_ONLY></span></span></div></div></div><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:modifyBank.payoutMechanism.$dirty && modifyBank.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select\" name=payoutMechanism ng-model=ChangeBank.payload.payoutMechanism ng-disabled=\"ChangeBank.payload.RGTSCode==\'HDF\'\" ng-options=\"_type.payoutCode as _type.payoutDescription for _type in ChangeBank.payoutMechanismList\" ng-init=\"ChangeBank.payload.payoutMechanism = ChangeBank.payload.payoutMechanism ? ChangeBank.payload.payoutMechanism : null\" required><option value=\"\" selected>Payout Mechanism</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=modifyBank.payoutMechanism.$error ng-show=modifyBank.payoutMechanism.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.PAYOUT_MECH_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:(ChangeBank.accModelDirty &&\n                 (!ChangeBank.payload.accountNumber.split(\'\').length || ChangeBank.payload.accountNumber.split(\'\').length>25))}\"><input type=text ng-model=ChangeBank.payload.accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" maxlength=20 name=accountNumber limit-to=25 required autocomplete=off directive.mask ng-change=BankDetails.accFocus() capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number <span class=\"req text-red\">*</span></label><span ng-show=ChangeBank.accModelDirty><span class=error-input ng-show=\"ChangeBank.payload.accountNumber.split(\'\').length==0\" ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(!ChangeBank.payload.bankDetails.accountNumber.split(\'\').length || ChangeBank.payload.bankDetails.accountNumber.split(\'\').length>25)\" ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:modifyBank.verifyAccountNumber.$dirty && modifyBank.verifyAccountNumber.$invalid}\"><input type=text ng-model=ChangeBank.verifyAccountNumber maxlength=20 name=verifyAccountNumber limit-to=25 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=ChangeBank.payload.accountNumber required autocomplete=off ng-keydown=ChangeBank.copyPasteHandler($event) capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Account Number <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.verifyAccountNumber.$dirty && modifyBank.verifyAccountNumber.$invalid\"><span class=error-input ng-show=modifyBank.verifyAccountNumber.$error.required ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"modifyBank.verifyAccountNumber.$error.maxlength && !modifyBank.verifyAccountNumber.$error.required\" ng-bind=ChangeBank.validateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"modifyBank.verifyAccountNumber.$error.pattern\n            && !modifyBank.verifyAccountNumber.$error.maxlength && !modifyBank.verifyAccountNumber.$error.required\">{{ChangeBank.validateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div><div class=row><div class=col-md-3><div class=input-normal ng-class=\"{error:modifyBank.ifsccode.$dirty && modifyBank.ifsccode.$invalid}\"><input type=text ng-model=ChangeBank.payload.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=ChangeBank.IFSC_REGEX capitalize required> <span class=highlight></span> <span class=bar></span><label>IFSC Code <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.ifsccode.$dirty && modifyBank.ifsccode.$invalid\"><span class=error-input ng-show=modifyBank.ifsccode.$error.required ng-bind=ChangeBank.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=modifyBank.ifsccode.$error.pattern ng-bind=ChangeBank.validateData.IFSC_CODE_REGEX></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:modifyBank.branchLocation.$dirty && modifyBank.branchLocation.$invalid}\"><input type=text ng-model=ChangeBank.payload.bankBranch name=branchLocation required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Location <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.branchLocation.$dirty && modifyBank.branchLocation.$invalid\"><span class=error-input ng-show=modifyBank.branchLocation.$error.required ng-bind=ChangeBank.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:modifyBank.branchCity.$dirty && modifyBank.branchCity.$invalid}\"><input type=text ng-model=ChangeBank.payload.bankCity name=branchCity only-alphabets autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span><label>Branch City <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.branchCity.$dirty && modifyBank.branchCity  .$invalid\"><span class=error-input ng-show=modifyBank.branchCity.$error.required ng-bind=ChangeBank.validateData.CITY_REQUIRED></span></span></div></div></div><div class=\"row upload-some\"><span class=leaf-label>Upload New Bank Proof <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Upload cheque leaf of new bank to validate bank details. \"></i></span><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=ChangeBank.chequeLeafNew upload=ChangeBank.uploadChequeLeafFile(file) ng-model=ChangeBank.bankDetails.chequeLeaf><div class=file-upload><button>Choose File</button> <span ng-if=ChangeBank.chooseAFileNew>No File Chosen</span> <span ng-click=ChangeBank.openUploadedDoc()>{{ChangeBank.bankDetails.chequeLeaf}}</span></div></div></div><div class=\"row upload-some\"><span class=leaf-label>Upload Old Bank Proof <i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Upload cheque leaf of old bank to validate bank details. \"></i></span><p class=upload-data><span class=grey-text>Bank Name : </span><span>{{ChangeBank.oldBankName}}</span></p><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=ChangeBank.chequeLeafOld upload=ChangeBank.uploadChequeLeafFileOld(file) ng-model=ChangeBank.bankDetails.chequeLeafOld><div class=file-upload><button>Choose File</button> <span ng-if=ChangeBank.chooseAFileOld>No File Chosen</span> <span ng-click=ChangeBank.openUploadedDocOld()>{{ChangeBank.bankDetails.chequeLeafOld}}</span></div></div></div></div><div class=\"form-footer col-md-12\"><a href=\"\" class=\"pull-left back\" ng-click=ChangeBank.back()><i class=arrow-blue-back-icon></i>Back</a> <span class=pull-right><input type=button value=Cancel class=\"btn btn-secondary-action common-btn-padding\" ng-click=ChangeBank.back()> <input type=submit value=Sumbit class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"modifyBank.$invalid || !ChangeBank.bankDetails.chequeLeaf || !ChangeBank.bankDetails.chequeLeafOld\" ng-click=ChangeBank.changeBankSubmit()></span></div></div></form>");
$templateCache.put("app/investor/profile/modifyBank/changeMultipleBank/changeMultipleBank.html","<section class=\"main-section clearfix modifyBank\"><h5 class=screen-title>Change1 Bank</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.portfolio.list>Folio Details </span><i class=breadcrumb-icon></i><span> Modify Bank</span></p><div class=content-area><p class=\"col-md-12 form-title\"><strong>Provide New Bank Details</strong></p><div class=col-md-12><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:bankDetailsForm.bankName.$dirty && bankDetailsForm.bankName.$invalid}\"><select class=select-box name=bankName ng-model=BankDetails.payload.bankDetails.bankName ng-options=\"_type.bankName as _type.bankName for _type in BankDetails.bankList\" ng-init=\"BankDetails.payload.bankDetails.bankName = BankDetails.payload.bankDetails.bankName ? BankDetails.payload.bankDetails.bankName : null\" required><option value=\"\" selected>Bank Name</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=bankDetailsForm.bankName.$error ng-show=bankDetailsForm.bankName.$dirty><span ng-message=required ng-bind=BankDetails.validateData.BANK_NAME_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=selectfield ng-class=\"{error:bankDetailsForm.accountType.$dirty && bankDetailsForm.accountType.$invalid}\"><select class=select-box name=accountType ng-model=BankDetails.payload.bankDetails.accountType ng-options=\"_type.accountTypeCode as _type.accountType for _type in BankDetails.bankTypeList\" ng-init=\"BankDetails.payload.bankDetails.accountType = BankDetails.payload.bankDetails.accountType ? BankDetails.payload.bankDetails.accountType : null\" required><option value=\"\" selected>Account Type</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=bankDetailsForm.accountType.$error ng-show=bankDetailsForm.accountType.$dirty><span ng-message=required ng-bind=BankDetails.validateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-normal mgt8\" ng-class=\"{error:bankDetailsForm.micrnumber.$dirty && bankDetailsForm.micrnumber.$invalid}\"><input type=text ng-model=BankDetails.payload.bankDetails.micrnumber ng-maxlength=9 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-minlength=9 ng-pattern=\"\'^[0-9]+$\'\" name=micrnumber autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>MICR Number <span class=\"req text-red\">*</span></label><span class=error-input ng-messages=bankDetailsForm.micrnumber.$error ng-show=bankDetailsForm.micrnumber.$dirty><span ng-message=required ng-bind=BankDetails.validateData.MICR_NUMBER_REQUIRED></span> <span ng-message=minlength ng-bind=BankDetails.validateData.MICR_NUMBER_RANGE></span> <span ng-message=maxlength ng-bind=BankDetails.validateData.MICR_NUMBER_RANGE></span> <span ng-message=pattern ng-bind=BankDetails.validateData.DIGITS_ONLY></span></span></div></div></div><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:bankDetailsForm.payoutMechanism.$dirty && bankDetailsForm.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select\" name=payoutMechanism ng-model=BankDetails.payload.bankDetails.payoutMechanism ng-options=\"_type.payoutCode as _type.payoutDescription for _type in BankDetails.payoutMechanismList\" ng-init=\"BankDetails.payload.bankDetails.payoutMechanism = BankDetails.payload.bankDetails.payoutMechanism ? BankDetails.payload.bankDetails.payoutMechanism : null\" required><option value=\"\" selected>Payout Mechanism</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=bankDetailsForm.payoutMechanism.$error ng-show=bankDetailsForm.payoutMechanism.$dirty><span ng-message=required ng-bind=BankDetails.validateData.PAYOUT_MECH_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:(BankDetails.accModelDirty &&\n                 (!BankDetails.payload.bankDetails.accountNumber.split(\'\').length || BankDetails.payload.bankDetails.accountNumber.split(\'\').length>25))}\"><input type=text ng-model=BankDetails.payload.bankDetails.accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" maxlength=20 name=accountNumber required autocomplete=off directive.mask ng-change=BankDetails.accFocus(); capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number <span class=\"req text-red\">*</span></label><span ng-show=BankDetails.accModelDirty><span class=error-input ng-show=\"BankDetails.payload.bankDetails.accountNumber.split(\'\').length==0\" ng-bind=BankDetails.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(!BankDetails.payload.bankDetails.accountNumber.split(\'\').length || BankDetails.payload.bankDetails.accountNumber.split(\'\').length>25)\" ng-bind=BankDetails.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:bankDetailsForm.verifyAccountNumber.$dirty && bankDetailsForm.verifyAccountNumber.$invalid}\"><input type=text ng-model=BankDetails.payload.bankDetails.verifyAccountNumber maxlength=20 name=verifyAccountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=BankDetails.payload.bankDetails.accountNumber required autocomplete=off ng-keydown=BankDetails.copyPasteHandler($event) capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Account Number <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.verifyAccountNumber.$dirty && bankDetailsForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=bankDetailsForm.verifyAccountNumber.$error.required ng-bind=BankDetails.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"bankDetailsForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\" ng-bind=BankDetails.validateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"bankDetailsForm.verifyAccountNumber.$error.pattern\n            && !bankDetailsForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\">{{BankDetails.validateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div><div class=row><div class=col-md-3><div class=input-normal ng-class=\"{error:bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid}\"><input type=text ng-model=BankDetails.payload.bankDetails.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=BankDetails.IFSC_REGEX capitalize required> <span class=highlight></span> <span class=bar></span><label>IFSC Code <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid\"><span class=error-input ng-show=bankDetailsForm.ifsccode.$error.required ng-bind=BankDetails.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=bankDetailsForm.ifsccode.$error.pattern ng-bind=BankDetails.validateData.IFSC_CODE_REGEX></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:bankDetailsForm.branchLocation.$dirty && bankDetailsForm.branchLocation.$invalid}\"><input type=text ng-model=BankDetails.payload.bankDetails.bankBranch name=branchLocation required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Location <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.branchLocation.$dirty && bankDetailsForm.branchLocation.$invalid\"><span class=error-input ng-show=bankDetailsForm.branchLocation.$error.required ng-bind=BankDetails.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:bankDetailsForm.branchCity.$dirty && bankDetailsForm.branchCity.$invalid}\"><input type=text ng-model=BankDetails.payload.bankDetails.bankCity name=branchCity only-alphabets autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span><label>Branch City <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.branchCity.$dirty && bankDetailsForm.branchCity  .$invalid\"><span class=error-input ng-show=bankDetailsForm.branchCity.$error.required ng-bind=BankDetails.validateData.CITY_REQUIRED></span></span></div></div></div><div class=\"row upload-some\"><span class=leaf-label>Upload Cheque Leaf <i class=info-icon></i></span><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=BankDetails.chequeLeaf upload=BankDetails.uploadChequeLeafFile(file) ng-model=BankDetails.bankDetails.chequeLeaf><div class=file-upload><button>Choose File</button> <span ng-if=BankDetails.chooseAFile>No File Chosen</span> <span ng-click=BankDetails.openUploadedDoc()>{{BankDetails.chequeLeafUrl}}</span></div></div></div><div class=\"row border-bottom\"><div class=\"col-md-12 mark-default\"><div class=checkbox><input type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>Make it a default bank for this folio</span></div></div></div><div class=\"row upload-some\"><span class=leaf-label>Upload Any of Existing Bank\'s Proof <i class=info-icon></i></span><div class=col-md-3><div class=row><div class=selectfield ng-class=\"{error:bankDetailsForm.payoutMechanism.$dirty && bankDetailsForm.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select\" name=payoutMechanism ng-model=BankDetails.payload.bankDetails.payoutMechanism ng-options=\"_type.payoutCode as _type.payoutDescription for _type in BankDetails.payoutMechanismList\" ng-init=\"BankDetails.payload.bankDetails.payoutMechanism = BankDetails.payload.bankDetails.payoutMechanism ? BankDetails.payload.bankDetails.payoutMechanism : null\" required><option value=\"\" selected>Payout Mechanism</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=bankDetailsForm.payoutMechanism.$error ng-show=bankDetailsForm.payoutMechanism.$dirty><span ng-message=required ng-bind=BankDetails.validateData.PAYOUT_MECH_REQUIRED></span></span><label>Select Existing Bank</label></div></div></div><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=BankDetails.chequeLeaf upload=BankDetails.uploadChequeLeafFile(file) ng-model=BankDetails.bankDetails.chequeLeaf><div class=file-upload><button>Choose File</button> <span ng-if=BankDetails.chooseAFile>No File Chosen</span> <span ng-click=BankDetails.openUploadedDoc()>{{BankDetails.chequeLeafUrl}}</span></div></div></div></div><div class=\"form-footer col-md-12\"><a href=\"\" class=\"pull-left back\" ng-click=BankDetails.back()><i class=arrow-blue-back-icon></i>Back</a> <span class=pull-right><input type=button value=Cancel class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=Sumbit class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"bankDetailsForm.$invalid || !BankDetails.chequeLeafUrl\" ng-click=BankDetails.done()></span></div></div></section>");
$templateCache.put("app/investor/profile/modifyBank/cobmStatus/cobmStatus.html","<section class=\"main-section clearfix transaction-list\" ng-init=CobmStatus.init()><h6 class=page-title>Request Status</h6><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.profile.folioDetails>Folio Details </span><i class=breadcrumb-icon></i><span> Request Status</span></p><div class=\"content-area clearfix\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Bank Name</th><th>Bank Account Number</th><th>Transaction Type</th><th>Transaction Date</th><th>Status</th><th>Rejected Reason</th></tr></thead><tbody><tr ng-if=CobmStatus.cobmDetailList ng-repeat=\"status in CobmStatus.cobmDetailList\"><td data-th=\"Bank Name\" ng-bind-html=status.bankName></td><td data-th=\"Bank Account Number\" easyassist-key=mask-element>{{status.bankAccNo}}</td><td data-th=\"Transaction Type\">{{status.transactionType}}</td><td data-th=\"Transaction Date\">{{status.transactionDate}}</td><td data-th=Status>{{status.status}}</td><td data-th=\"Rejected Reason\">{{status.rejectedReason||\'-\'}}</td></tr><tr ng-if=!CobmStatus.cobmDetailList><td colspan=8>No Record found</td></tr></tbody></table><div class=col-md-12 ng-if=List.isPagination><div class=total-data><span>Showing &nbsp</span><select ng-if=\"List.totalTransactionList>=25\" ng-change=List.pageLimitListChange(List.pageLimitTransactionList) ng-model=List.pageLimitTransactionList><option ng-repeat=\"value in List.pageLimitDropDownList\" value={{value}}>{{value}}</option></select><span ng-if=\"List.totalTransactionList<25\">{{List.totalTransactionList}}</span> <span>of</span> <span class=t-black>{{List.totalTransactionList}}</span></div><ul uib-pagination total-items=List.totalTransactionList ng-model=List.currentPageTransactionList max-size=5 items-per-page=List.pageLimitTransactionList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=List.initTransactionList() rotate=false></ul></div></div></section>");
$templateCache.put("app/investor/profile/modifyBank/updateIFSC/updateIFSC.html","<form class=\"main-section clearfix modifyBank\" name=UpdateIFSCForm ng-init=UpdateIFSC.init()><h5 class=screen-title>Update IFSC</h5><div class=content-area><div class=\"col-md-12 form-group\"><div class=row><div class=col-md-3><div class=input-normal ng-class=\"{error:UpdateIFSCForm.ifsccode.$dirty && UpdateIFSCForm.ifsccode.$invalid}\"><input type=text ng-model=UpdateIFSC.payload.ifscCode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=UpdateIFSC.IFSC_REGEX capitalize required> <span class=highlight></span> <span class=bar></span><label>New IFSC Code <span class=\"req text-red\">*</span></label><span ng-show=\"UpdateIFSCForm.ifsccode.$dirty && UpdateIFSCForm.ifsccode.$invalid\"><span class=error-input ng-show=UpdateIFSCForm.ifsccode.$error.required ng-bind=UpdateIFSC.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=UpdateIFSCForm.ifsccode.$error.pattern ng-bind=UpdateIFSC.validateData.IFSC_CODE_REGEX></span></span></div></div></div><!--<div class=\"row upload-some\">\n        <span class=\"leaf-label\">Upload New Bank Proof\n        <i class=\"info-icon base-tooltip\" data-html=\"true\" tooltip data-toggle=\"tooltip\"  data-placement=\"right\" title=\"Upload cheque leaf of new bank to update its IFSC code. \"></i>\n        </span>\n        <div class=\"upload-leaf\">\n          <input type=\"file\" name=\"pic\" accept=\"image/*\" file-model-profile=\"UpdateIFSC.chequeLeafNew\"\n                 upload=\"AddBank.uploadChequeLeafFile(file,\'add\')\" ng-model=\"UpdateIFSC.bankDetails.chequeLeaf\">\n          <div class=\"file-upload\">\n            <button>Choose File</button>\n            <span ng-if=\"AddBank.chooseAFileNew\">No File Chosen</span>\n            <span ng-click=\"AddBank.openUploadedDoc()\">{{AddBank.chequeLeafUrlNew}}</span></div>\n        </div>\n      </div>\n      <div class=\"row upload-some\">\n        <span class=\"leaf-label\">Upload Old Bank Proof\n        <i class=\"info-icon base-tooltip\" data-html=\"true\" tooltip data-toggle=\"tooltip\"  data-placement=\"right\" title=\"Upload cheque leaf of old/existing bank to update its IFSC code. \"></i>\n        </span>\n        <p class=\"upload-data\">\n          <span class=\"grey-text\">Bank Name : </span><span>{{UpdateIFSC.oldBank.bankName}}</span>\n        </p>\n        <div class=\"upload-leaf\">\n          <input type=\"file\" name=\"pic\" accept=\"image/*\" file-model-profile=\"UpdateIFSC.chequeLeafOld\"\n                 upload=\"UpdateIFSC.uploadOldBankProof(file,\'modify\')\" ng-model=\"BankDetails.bankDetails.chequeLeaf\">\n          <div class=\"file-upload\">\n            <button>Choose File</button>\n            <span ng-if=\"UpdateIFSC.chooseAFileOld\">No File Chosen</span>\n            <span ng-click=\"UpdateIFSC.uploadChequeLeafFile()\">{{UpdateIFSC.chequeLeafUrlOld}}</span></div>\n        </div>\n      </div>--></div><div class=\"form-footer col-md-12\"><a href=\"\" class=\"pull-left back\" ng-click=UpdateIFSC.back()><i class=arrow-blue-back-icon></i>Back</a> <span class=pull-right><input type=button ng-click=UpdateIFSC.back() value=Cancel class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=Submit class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"UpdateIFSCForm.$invalid \" ng-click=UpdateIFSC.updateIFSCSuccessful()></span></div></div></form><!--\n|| !AddBank.chequeLeafUrl-->");
$templateCache.put("app/investor/profile/profileDetails/pendingApprovals/pendingApprovals.html","<div class=folio-info ng-init=Profile.init();><div class=folio-numbers><div class=unfinished-folios><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Approval Type</th><th>Initiated By</th><th>Initiated Date</th><th>Expiry Date</th><th>Current Status</th><th>Action</th></tr></thead><tbody><tr ng-if=\"Profile.approvalList.length==0\"><td data-th=\"Approval Type\" colspan=6>No Data Available</td></tr><tr ng-repeat=\"item in Profile.approvalList\"><td data-th=\"Approval Type\" ng-bind=item.approvalTypeDescription>FOLIO CREATION</td><td data-th=\"Initiated By\" ng-bind=item.initiatedBy>Individual</td><td data-th=\"Initiated Date\" ng-bind=item.initiatedDate>29-Jun-2018</td><td data-th=\"Expiry Date\" ng-bind=item.expiryDate>29-Jun-2018</td><td data-th=\"Current Status\" ng-bind=item.currentStatus>Pending</td><td data-th=Action><span ng-show=item.action><span class=view ng-click=Profile.approvFolio(item) role=button tabindex=0>Approve</span> / <span class=delete ng-click=Profile.rejectFolio(item) role=button tabindex=0>Reject</span></span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/investment-baskets/investment-basket-directives/folio/bank-details/bank-details.directive.html","<div ng-if=editBank class=\"row bank-detail\"><div class=col-xs-12><form style=\"padding-left: 15px\" autocomplete=off name=bankDetailsForm class=bankForm novalidate><div class=\"row foliobank-enableclass\"><div class=col-md-6><div class=col-md-6><div class=\"col-xs-12 col-md-12 ifsc-input\"><p class=titleFatca>IFSC Code <span class=\"req text-red\">*</span></p><div class=\"alignifsctext titleFatca\" style=\"display: flex;justify-content: space-between;align-items: center; margin-bottom: 20px\" ng-click=selectIFSC()><a style=\"height: 15px;width: 20px\"><svg class=ifsc-search aria-labelledby=\"title desc\" role=img viewBox=\"0 0 19.9 19.7\"><title id=title>Search Icon</title><desc id=desc>A magnifying glass icon.</desc><g class=search-path fill=none stroke=#669ddf><path stroke-linecap=square stroke-width=3 d=\"M18.5 18.3l-5.4-5.4\"/><circle stroke-width=2 cx=8 cy=8 r=7 /></g></svg> </a><span style=\"color: #669ddf;font-size: 12px\">SEARCH IFSC</span></div></div><div ng-class=\"{error:bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid}\"><input class=input-field type=text ng-model=bankPayload.bankDetails.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-maxlength=11 limit-to=11 ng-pattern=IFSC_REGEX capitalize required readonly placeholder=\"IFSC Code\"> <span class=highlight></span> <span class=bar></span> <span ng-show=\"bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid\"><span class=error-input ng-show=bankDetailsForm.ifsccode.$error.required ng-bind=bkValidateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=bankDetailsForm.ifsccode.$error.pattern ng-bind=bkValidateData.IFSC_CODE_REGEX></span></span></div></div><div class=\"col-md-6 responsive-margin-top\"><p class=titleFatca>Bank Name <span class=\"req text-red\">*</span></p><div ng-class=\"{error:bankDetailsForm.bankName.$dirty && bankDetailsForm.bankName.$invalid}\"><input class=input-field type=text ng-model=bankPayload.bankDetails.bankName name=bankName ng-disabled=!bankPayload.bankDetails.bankName ng-readonly=bankPayload.bankDetails.bankName placeholder=\"Bank Name\"> <span class=highlight></span> <span class=bar></span></div></div></div></div><div class=\"row foliobank-enableclass set-margin-top-20\"><div class=col-md-6><div class=col-md-6><p class=titleFatca>Branch Location <span class=\"req text-red\">*</span></p><div ng-class=\"{error:bankDetailsForm.branchLocation.$dirty && bankDetailsForm.branchLocation.$invalid}\"><input class=input-field type=text ng-model=bankPayload.bankDetails.bankBranch maxlength=40 name=branchLocation required autocomplete=off capitalize ng-disabled=!bankPayload.bankDetails.ifsccode placeholder=\"Branch Location\"> <span class=highlight></span> <span class=bar></span> <span ng-show=\"bankDetailsForm.branchLocation.$dirty && bankDetailsForm.branchLocation.$invalid\"><span class=error-input ng-show=bankDetailsForm.branchLocation.$error.required ng-bind=bkValidateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-6 responsive-margin-top\"><p class=titleFatca>Branch City <span class=\"req text-red\">*</span></p><div ng-class=\"{error:bankDetailsForm.branchCity.$dirty && bankDetailsForm.branchCity.$invalid}\"><input class=input-field type=text ng-model=bankPayload.bankDetails.bankCity name=branchCity ng-maxlength=35 limit-to=35 maxlength=35 only-alphabets autocomplete=off capitalize required ng-disabled=!bankPayload.bankDetails.ifsccode placeholder=\"Branch City\"> <span class=highlight></span> <span class=bar></span> <span ng-show=\"bankDetailsForm.branchCity.$dirty && bankDetailsForm.branchCity  .$invalid\"><span class=error-input ng-show=bankDetailsForm.branchCity.$error.required ng-bind=bkValidateData.CITY_REQUIRED></span></span></div></div></div></div><div class=\"row foliobank-enableclass set-margin-top-20\"><div class=col-md-6><div class=col-md-6><p class=titleFatca>Account Number <span class=\"req text-red\">*</span></p><div ng-class=\"{error:  (BankDetails.accModelDirty &&\n                 (!bankPayload.bankDetails.accountNumber.split(\'\').length || bankPayload.bankDetails.accountNumber.split(\'\').length>25))}\"><input class=input-field type=text ng-model=bankPayload.bankDetails.accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-maxlength=20 maxlength=20 name=accountNumber limit-to=20 easyassist-key=mask-element required autocomplete=off directive.mask ng-change=accFocus(); capitalize ng-disabled=!bankPayload.bankDetails.ifsccode placeholder=\"Account Number\"> <span class=highlight></span> <span class=bar></span> <span ng-show=accModelDirty><span class=error-input ng-show=\"bankPayload.bankDetails.accountNumber.split(\'\').length==0\" ng-bind=bkValidateData.ACCOUNT_NUMBER_REQUIRED></span><!--<span class=\"error-input\"\n                      ng-show=\"(!bankPayload.bankDetails.accountNumber.split(\'\').length || bankPayload.bankDetails.accountNumber.split(\'\').length>25)\"\n                      ng-bind=\"bkValidateData.ACCOUNT_NUMBER_RANGE\"></span>--> <span class=error-input ng-show=bankDetailsForm.accountNumber.$error.required ng-bind=bkValidateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(bankPayload.bankDetails.accountNumber.split(\'\').length !=0 && bankPayload.bankDetails.accountNumber.split(\'\').length<1)\" ng-bind=bkValidateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-6 responsive-margin-top\"><p class=titleFatca>Confirm Account Number <span class=\"req text-red\">*</span></p><div ng-class=\"{error:bankDetailsForm.verifyAccountNumber.$dirty && bankDetailsForm.verifyAccountNumber.$invalid}\"><input class=input-field type=text ng-model=bankPayload.bankDetails.verifyAccountNumber maxlength=20 name=verifyAccountNumber limit-to=20 ng-maxlength=20 onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-pattern=bankPayload.bankDetails.accountNumber easyassist-key=mask-element required autocomplete=off ng-keydown=copyPasteHandler($event) capitalize ng-disabled=!bankPayload.bankDetails.ifsccode placeholder=\"Confirm Account Number\"> <span class=highlight></span> <span class=bar></span> <span ng-show=\"bankDetailsForm.verifyAccountNumber.$dirty && bankDetailsForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=bankDetailsForm.verifyAccountNumber.$error.required ng-bind=bkValidateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"bankDetailsForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\" ng-bind=bkValidateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"bankDetailsForm.verifyAccountNumber.$error.pattern\n            && !bankDetailsForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\">{{bkValidateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div></div><div class=\"row set-margin-top-20\"><div class=col-md-12><div class=col-md-3><p class=\"titleFatca set-margin-bottom-20\">Payout Mechanism <span class=\"req text-red\">*</span></p><div ng-class=\"{error:bankDetailsForm.payoutMechanism.$dirty && bankDetailsForm.payoutMechanism.$invalid}\"><div style=\"display: inline-block\" ng-repeat=\"data in payoutMechanismList\"><button ng-disabled=!bankPayload.bankDetails.ifsccode ng-click=setPayoutMechanism(data.payoutCode) class=btn-small-shadow ng-class=\"{\'btn-small-shadow-background-blue\' : data.payoutCode === bankPayload.bankDetails.payoutMechanism}\">{{data.payoutDescription}}</button></div><span class=error-input ng-messages=bankDetailsForm.payoutMechanism.$error ng-show=bankDetailsForm.payoutMechanism.$dirty><span ng-message=required ng-bind=bkValidateData.PAYOUT_MECH_REQUIRED></span></span></div></div><div class=\"col-md-9 responsive-margin-top\"><p class=\"titleFatca set-margin-bottom-20\">Account Type <span class=\"req text-red\">*</span></p><div ng-class=\"{error:bankDetailsForm.accountType.$dirty && bankDetailsForm.accountType.$invalid}\"><div style=\"display: inline-block\" ng-repeat=\"data in bankTypeList\"><button type=button ng-disabled=!bankPayload.bankDetails.ifsccode ng-click=\"setAccountTypeValue(bankDetailsForm, data.accountTypeCode)\" class=btn-small-shadow ng-class=\"{\'btn-small-shadow-background-blue\' : data.accountTypeCode === bankPayload.bankDetails.accountType}\">{{data.accountType}}</button></div><span class=error-input ng-messages=bankDetailsForm.accountType.$error ng-show=bankDetailsForm.accountType.$dirty><span ng-message=required ng-bind=bankValidateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div><div class=\"row set-margin-top-20\" ng-if=\"bankPayload.bankDetails.chequeLeaf || bankPayload.bankDetails.pennyDropValid === false\"><div class=col-md-6><div class=\"col-xs-12 col-sm-6 col-md-6\" style=\"padding: 10px 0px 15px 12px;display: flex;align-items: center\"><label for=uploadCheckLeaf style=\"text-align: right;\n                    padding: 10px;\n                    padding-left: 35px;\n                    background-color: lightgray;\n                    border-radius: 25px;\n                    cursor: pointer;\n                    background-size: 28px;\n                    background-position-x: 5px;\n                    background-position-y: 3px;\n                    background-repeat: no-repeat;\n                    background-image: url(../../../../assets/images/new-investor/uploadIcon.png)\">Upload Cheque leaf</label><input type=file name=uploadCheckLeaf accept=image/tiff,image/tif,image/jpeg,image/jpg file-model-profile=chequeLeaf ng-model=bankPayload.bankDetails.chequeLeaf id=uploadCheckLeaf upload=bankUploadChequeLeafFile(file) style=\"visibility: hidden;position: absolute\" required> <i class=green-tick-icon ng-if=bankPayload.bankDetails.chequeLeaf></i></div><div ng-if=\"bankPayload.bankDetails.chequeLeaf !=\'\'\" class=\"col-xs-12 col-sm-6 col-md-6 responsive-margin-top\" style=\"padding: 5px 0px 15px 12px\"><p ng-if=\"fileType == \'jpg\' ||  fileType == \'jpeg\'\" ng-click=openUploadedDoc(bankPayload.bankDetails.chequeLeaf) style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 5px\">Show Image</p><p ng-if=\"fileType === \'tif\' || fileType === \'tiff\'\" ng-click=\"downloadPdfFile(bankchequeLeafUrl, fileType)\" style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 5px\">Download</p></div></div></div><!--      <div class=\"proceed set-margin-top-20\" ng-if=\"!bankPayload.bankDetails.chequeLeaf && bankPayload.bankDetails.pennyDropValid\">--><!--        <button class=\"proceed-btn\" type=\"button\" class=\"btn btn-primary-action common-btn-padding pull-right\" ng-if=\"!bankPayload.bankDetails.chequeLeaf && bankPayload.bankDetails.pennyDropValid\"--><!--                ng-disabled=\"bankDetailsForm.$invalid && !bankPayload.bankDetails.accountType\"--><!--                ng-click=\"validatePennyDropDetails()\">--><!--          Validate--><!--        </button>--><!--      </div>--><div class=\"proceed pd-right7\" style=\"margin-top: 20px\"><button class=proceed-btn ng-disabled=\"bankDetailsForm.$invalid || !bankPayload.bankDetails.accountType\" ng-if=!pennyDropCalled ng-click=continueBank()>Validate</button> <button class=proceed-btn type=submit ng-disabled=\"bankDetailsForm.$invalid || !bankPayload.bankDetails.accountType\" ng-click=continueBank() ng-if=pennyDropCalled ng-class=\"\">Next</button></div><!--      <div ng-if=\"bankDetailsForm.$valid\" ng-init=\"formIsvalid()\"></div>--><!--      <div ng-if=\"bankDetailsForm.$invalid\" ng-init=\"formIsinvalid()\"></div>--></form></div></div><div ng-if=!editBank><div class=\"box-body set-margin-top-20 set-padding-left-10\"><div class=\"box-details clearfix\"><div class=row><div class=\"col-sm-12 col-md-6\"><table class=\"table borderless\"><tbody><tr><td><span class=span-review-width><strong>Bank Name:</strong></span></td><td><span>{{bankPayload.bankDetails.bankName}}</span></td></tr><tr ng-if=\"!bankPayload.bankDetails.pennyDropValid && !bankPayload.bankDetails.micrnumber\"><td><span class=span-review-width><strong>MICR No:</strong></span></td><td><span>{{bankPayload.bankDetails.micrnumber}}</span></td></tr><tr ng-hide=!bankPayload.bankDetails.pennyDropValid><td><span class=span-review-width><strong>Payout Mechanism:</strong></span></td><td><span>{{reviewModalData.payoutDescription}}</span></td></tr><tr><td><span class=span-review-width><strong>IFSC No:</strong></span></td><td><span>{{bankPayload.bankDetails.ifsccode}}</span></td></tr><tr><td><span class=span-review-width><strong>Branch City:</strong></span></td><td><span>{{bankPayload.bankDetails.bankCity}}</span></td></tr><tr ng-if=bankPayload.bankDetails.chequeLeaf><td col-span=2><div class=attachment><span class=\"proof span-review-width\"><strong>Cheque Leaf Image:</strong></span><div class=\"form-group cheque-leaf\" ng-click=openUploadedDoc(bankPayload.bankDetails.chequeLeaf)><span class=upload-button><label style=\"vertical-align: middle\"><i class=ic-img-icon></i></label></span><span class=\"file-name text-blue\">Cheque Leaf Image</span></div></div></td></tr></tbody></table></div><div class=\"col-sm-12 col-md-6\"><table class=\"table borderless\"><tbody><tr><td><span class=span-review-width><strong>Account Type:</strong></span></td><td><span>{{reviewModalData.accountType}}</span></td></tr><tr><td><span class=span-review-width><strong>Account Number:</strong></span></td><td><span easyassist-key=mask-element>{{bankPayload.bankDetails.accountNumber}}</span></td></tr><tr><td><span class=span-review-width><strong>Branch Location:</strong></span></td><td><span>{{bankPayload.bankDetails.bankBranch}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/investment-baskets/investment-basket-directives/folio/basic-details/basic-details.directive.html","<div class=basket-folio-creation ng-show=editBasicDetail><div class=folio-creation><div class=\"row folio-details\"><section class=\"col-md-12 folio-details-steps\"><div class=tab-content name=folioCreation><div class=\"col-md-12 folio-create\"><div class=tab-content><div id=applicant-details class=\"tab-pane fade in active\"><form name=folioSelfSingleBasicForm novalidate ng-submit=submitFolioBasicDetails()><div class=\"row removePadding\"><div class=col-md-6><table class=\"table borderless top-part\"><tr class=mode-of-holding><td><strong>Create Folio For</strong></td><td></td><td class=td-style><div class=radio-block style=\"margin-right: 30px\" ng-class=\"{\'anything-disabled\': cgfFlag == \'true\' }\"><span class=radio><input type=radio id=selefId name=isMinor ng-model=folioBasicDetail.folioForUser ng-change=\"chooseFolioFor(\'Self\')\" value=Self ng-disabled=\"cgfFlag == \'true\'\" required> <span class=check></span> </span><span class=radio-label>Self</span></div><div class=radio-block ng-class=\"{\'anything-disabled\': onlyIndividualSelection == \'true\' }\"><span class=radio><input type=radio id=monorId name=isMinor ng-model=folioBasicDetail.folioForUser ng-change=\"chooseFolioFor(\'Minor\')\" value=Minor ng-disabled=\"onlyIndividualSelection == \'true\'\" required> <span class=check></span> </span><span class=radio-label>Minor</span></div></td></tr><tr class=mode-of-holding ng-if=\"folioBasicDetail.folioForUser !== \'Minor\'\"><td><strong>Mode of holding</strong></td><td class=extra-space></td><td class=\"td-style holder-options\"><div class=radio-block><span class=radio><input type=radio id=single name=holdmode ng-model=folioBasicDetail.folioHoldingMode value=SINGLE ng-change=\"getholdingmode(\'SINGLE\')\" required> <span class=check></span> </span><span class=radio-label>Single</span></div><div class=radio-block><span class=radio><input type=radio id=aos name=holdmode ng-model=folioBasicDetail.folioHoldingMode value=ANY_OR_SURVIVOR ng-change=\"getholdingmode(\'ANY_OR_SURVIVOR\')\" ng-disabled=\"folioBasicDetail.folioForUser == \'Minor\'\" required> <span class=check></span> </span><span class=radio-label>Anyone or survivor</span></div></td></tr></table></div><div class=col-md-6 ng-if=\"folioBasicDetail.folioForUser !== \'Minor\'\"><table class=\"table borderless top-part\"><tr><td><strong>Are you politically exposed person</strong></td><td></td></tr><tr><td class=politically style=\"padding-top: 22px\"><div class=radio-block><span class=radio><input type=radio id=politicalStatus1 name=politicalStatus ng-model=folioBasicDetail.politicalStatus ng-change=\"getPEPStatus(\'Yes\')\" ng-value=CONST_DATA.INVESTOR_POLITICAL_STATUS.POLITICAL> <span class=check></span> </span><span class=radio-label>Yes</span></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus3 name=politicalStatus ng-model=folioBasicDetail.politicalStatus ng-change=\"getPEPStatus(\'No\')\" ng-value=CONST_DATA.INVESTOR_POLITICAL_STATUS.NONE> <span class=check></span> </span><span class=radio-label>No</span></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=folioBasicDetail.politicalStatus ng-change=\"getPEPStatus(\'Related\')\" ng-value=CONST_DATA.INVESTOR_POLITICAL_STATUS.RELATED> <span class=check></span> </span><span class=radio-label>Related to PEP</span></div></td></tr></table></div></div><!--                  <div class=\"form-content less-pad inves-pay tax-residency\" ng-if=\"folioBasicDetail.folioForUser !== \'Minor\'\">--><!--                    <p>Are you a tax resident (i.e Are you assessed for tax in any other country outside India?)</p>--><!--                    <div class=\"tax-radio\">--><!--                    <span class=\"radio-block\">--><!--                      <span class=\"radio\">--><!--                        <input type=\"radio\" id=\"payTaxInIndiaYes\" name=\"payTaxInIndia\"--><!--                               ng-change=\"getTaxFileStatus(\'Yes\')\"--><!--                               ng-model=\"folioBasicDetail.fileTaxOtherIndian\"--><!--                               value=\"Yes\"/>--><!--                        <span class=\"check\"></span>--><!--                      </span>--><!--                      <label  for=\"payTaxInIndiaYes\">Yes</label>--><!--                    </span>--><!--                    <span class=\"radio-block\">--><!--            <span class=\"radio\">--><!--              <input type=\"radio\" id=\"payTaxInIndiaNo\" name=\"payTaxInIndia\"--><!--                     ng-model=\"folioBasicDetail.fileTaxOtherIndian\"--><!--                     ng-change=\"getTaxFileStatus(\'No\')\"--><!--                     value=\"No\"/>--><!--              <span class=\"check\"></span>--><!--            </span>--><!--                      <label for=\"payTaxInIndiaNo\">No</label>--><!--            </span>--><!--                    </div>--><!--                    <div ng-if=\"!folioBasicDetail.Fatca.taxPayIndia\" class=\"labelUI\">--><!--                      <div class=\"tax-res\">--><!--                        <div class=\"row\">--><!--                          <div class=\"col-md-3\">--><!--                            <label>Name Of Country</label>--><!--                            <div--><!--                                 ng-class=\"{error:folioSelfSingleBasicForm[\'birthCountry-\'+$index].$dirty && folioSelfSingleBasicForm[\'birthCountry-\'+$index].$invalid}\">--><!--                              <select class=\"form-control selectNormal\" id=\"taxPaycountry\" name=\"taxPaycountry\"--><!--                                      ng-model=\"folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry\"--><!--                              >--><!--                                <option value selected=\"selected\">Select</option>--><!--                                <option ng-repeat=\"value in countries\"--><!--                                        ng-selected=\"folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry == value.countryCode\"--><!--                                        value=\"{{value.countryCode}}\">{{value.countryName}}</option>--><!--                              </select>--><!--                              <span ng-show=\"folioSelfSingleBasicForm.taxPaycountry.$dirty && !folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry\">--><!--                                <span class=\"error-input\" ng-show=\"folioSelfSingleBasicForm.taxPaycountry.$error.required\"--><!--                                      ng-bind=\"CONST.SELECT_COUNTRY\"></span>--><!--                              </span>--><!--                            </div>--><!--                          </div>--><!--                          <div class=\"col-md-3\">--><!--                            <label>Tax Paying City</label>--><!--                            <div--><!--                                 ng-class=\"{error:folioSelfSingleBasicForm[\'birthCity-\'+$index].$dirty && folioSelfSingleBasicForm[\'birthCity-\'+$index].$invalid}\">--><!--                              <input id=\"taxpayingCity\" type=\"text\" name=\"taxpayingCity\" placeholder=\"City\" class=\"input-field\"--><!--                                     ng-model=\"folioBasicDetail.Fatca.fatcaTax1.taxPayingCity\" ng-pattern=\"/^[a-zA-Z ]+$/\"  required>--><!--                              <span class=\"highlight\"></span>--><!--                              <span class=\"bar\"></span>--><!--&lt;!&ndash;                              <label><span class=\"req text-red\">*</span></label>&ndash;&gt;--><!--                              <span--><!--                                ng-show=\"folioSelfSingleBasicForm.taxpayingCity.$dirty && folioSelfSingleBasicForm.taxpayingCity.$invalid\">--><!--              <span class=\"error-input\" ng-show=\"folioSelfSingleBasicForm.taxpayingCity.$error.required\"--><!--                    ng-bind=\"CONST.CITY\"></span>--><!--              <span class=\"error-input\" ng-show=\"folioSelfSingleBasicForm.taxpayingCity.$error.pattern\">Number not--><!--                allowed in minor--><!--                name!</span>--><!--            </span>--><!--                            </div>--><!--                          </div>--><!--                        </div>--><!--                        <div class=\"row\">--><!--                          <div class=\"col-md-3\">--><!--                            <label>Tax ID Type</label>--><!--                            <div--><!--                                 ng-class=\"{error:folioSelfSingleBasicForm[\'taxIdType-\'+$index].$dirty && folioSelfSingleBasicForm[\'taxIdType-\'+$index].$invalid}\">--><!--                              <select class=\" selectNormal browser-default custom-select\" id=\"taxIdType\" name=\"taxIdType\"--><!--                                      ng-model=\"folioBasicDetail.Fatca.fatcaTax1.taxIdType\"--><!--                                      >--><!--                                <option value selected=\"selected\">Select</option>--><!--                                <option ng-repeat=\"value in taxIdType\"--><!--                                        ng-selected=\"folioBasicDetail.Fatca.fatcaTax1.taxIdType == value.value\" value=\"{{value.value}}\">--><!--                                  {{value.description}}</option>--><!--                              </select>--><!--                              <label ng-if=\"holders.payOutsideIndiaAddresses[$index].taxIdType\">Select Tax ID--><!--                                type</label>--><!--                              <span ng-show=\"folioSelfSingleBasicForm.taxIdType.$dirty && folioSelfSingleBasicForm.taxIdType.$invalid\">--><!--              <span class=\"error-input\" ng-show=\"folioSelfSingleBasicForm.taxIdType.$error.required\"--><!--                    ng-bind=\"CONST.TAX_ID_TYPE\"></span>--><!--            </span>--><!--                            </div>--><!--                          </div>--><!--                          <div class=\"col-md-3\">--><!--                            <label for=\"\">Tax ID</label>--><!--                            <div >--><!--                              <input id=\"taxId\" type=\"text\" name=\"taxId\" ng-maxlength=\"20\" limit-to=\"20\" placeholder=\"Tax ID number\" class=\"input-field\"--><!--                                     ng-model=\"folioBasicDetail.Fatca.fatcaTax1.taxId\" capitalize required>--><!--                              <span class=\"highlight\"></span>--><!--                              <span class=\"bar\"></span>--><!--&lt;!&ndash;                              <label><span class=\"req text-red\">*</span></label>&ndash;&gt;--><!--                              <span ng-show=\"folioSelfSingleBasicForm.taxId.$dirty && folioSelfSingleBasicForm.taxId.$invalid\">--><!--                                <span class=\"error-input\" ng-show=\"folioSelfSingleBasicForm.taxId.$error.required\" ng-bind=\"CONST.TAX_ID_NUMBER\"></span></span>--><!--                            </div>--><!--                          </div>--><!--                        </div>--><!--                      </div>--><!--                    </div>--><!--                  </div>--><!--                  <div class=\"add-another-tax-res tax-res\">--><!--                    <a ng-show=\"((holders.fatcaArray.length)*1<3)\"--><!--                       href=\"\" class=\"text-blue\" ng-click=\"addMoreTaxResidency()\"><strong><i--><!--                      class=\"expand-icon\"></i>--><!--                      <span>Add another tax residency country</span></strong></a>--><!--                  </div>--><div class=form-content ng-if=\"folioBasicDetail.folioForUser !== \'Minor\'\"><p><strong>Are you a tax resident (i.e Are you assessed for tax in any other country outside India?)</strong></p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-change=changePayTaxOutsideIndiaStatus(true) ng-model=holders.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-model=holders.payTaxInIndia ng-value=true> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span><div ng-if=\"folioBasicDetail.folioForUser !== \'Minor\' && !holders.payTaxInIndia\"><div ng-repeat=\"data in holders.fatcaArray\"><p><strong>Tax Residency Country</strong> <span ng-show=\"$index > 0\" class=remove-item ng-click=deleteTaxResidency($index)><i class=delete-red-icon></i></span></p><div class=row><div class=col-md-3><label class=titleFatca>Select Country<span class=\"req text-red\">*</span></label><div ng-class=\"{error:folioSelfSingleBasicForm[\'birthCountry\'+$index].$dirty && folioSelfSingleBasicForm[\'birthCountry\'+$index].$invalid}\"><select class=selectNormal name=birthCountry{{$index}} ng-model=data.taxPayingCountry ng-init=\"data.taxPayingCountry=data.taxPayingCountry?data.taxPayingCountry:null\" ng-options=\"country.countryCode as country.countryName for country in countries|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" easyassist-key=mask-element required><option value=\"\" selected>Select Country</option></select><span ng-show=\"folioSelfSingleBasicForm[\'birthCountry\'+$index].$dirty && folioSelfSingleBasicForm[\'birthCountry\'+$index].$invalid\"><span class=error-input ng-show=\"folioSelfSingleBasicForm[\'birthCountry\'+$index].$error.required\">{{CONST.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-3><label class=titleFatca>City<span class=\"req text-red\">*</span></label><div ng-class=\"{error:folioSelfSingleBasicForm[\'birthCity\'+$index].$dirty && folioSelfSingleBasicForm[\'birthCity\'+$index].$invalid}\"><input type=text name=birthCity{{$index}} class=input-field ng-model=data.taxPayingCity ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element ng-pattern=/^[a-zA-Z\\s]*$/ required placeholder=City> <span class=highlight></span> <span class=bar></span> <span ng-show=\"folioSelfSingleBasicForm[\'birthCity\'+$index].$dirty && folioSelfSingleBasicForm[\'birthCity\'+$index].$invalid\"><span class=error-input ng-show=\"folioSelfSingleBasicForm[\'birthCity\'+$index].$error.required\">{{CONST.CITY}}</span> </span><span class=error-input ng-show=\"folioSelfSingleBasicForm[\'birthCity\'+$index].$error.pattern\">Invalid City</span></div></div></div><div class=row><div class=col-md-3><label class=titleFatca>Select Tax ID type<span class=\"req text-red\">*</span></label><div ng-class=\"{error:folioSelfSingleBasicForm[\'taxIdType\'+$index].$dirty && folioSelfSingleBasicForm[\'taxIdType\'+$index].$invalid}\"><select class=selectNormal name=taxIdType{{$index}} ng-model=data.taxIdType ng-init=\"data.taxIdType= data.taxIdType ? data.taxIdType: null\" ng-options=\"taxid.description as taxid.description for taxid in taxIdType\" easyassist-key=mask-element required><option value=\"\" selected>Select Tax ID type</option></select><span ng-show=\"folioSelfSingleBasicForm[\'taxIdType\'+$index].$dirty && folioSelfSingleBasicForm[\'taxIdType\'+$index].$invalid\"><div class=error-input ng-show=\"folioSelfSingleBasicForm[\'taxIdType\'+$index].$error.required\">{{CONST.TAX_ID_TYPE}}</div></span></div></div><div class=col-md-3><label class=titleFatca>Tax ID number<span class=\"req text-red\">*</span></label><div class=input-select><input type=text class=input-field name=taxId{{$index}} ng-model=data.taxId ng-maxlength=20 limit-to=20 maxlength=20 easyassist-key=mask-element required capitalize placeholder=\"Tax ID number\"> <span class=highlight></span> <span class=bar></span> <span ng-show=\"folioSelfSingleBasicForm[\'taxId\'+$index].$dirty && folioSelfSingleBasicForm[\'taxId\'+$index].$invalid\"><div class=error-input ng-show=\"folioSelfSingleBasicForm[\'taxId\'+$index].$error.required\">{{CONST.TAX_ID_NUMBER}}</div></span></div></div></div></div><div class=addMoreTax><a ng-show=\"((holders.fatcaArray.length)*1<3)\" href=\"\" class=text-blue ng-click=addMoreTaxResidency()><strong><i class=plus-icon></i> <span>Add another tax residency country</span></strong></a></div></div></div><div class=\"row minorForm\" ng-if=\"folioBasicDetail.folioForUser === \'Minor\'\"><div class=col-md-6><div class=row><div class=col-md-6><label class=titleFatca>Minor\'s Name<span class=\"req text-red\">*</span></label><div ng-class=\"{error:folioSelfSingleBasicForm.minorName.$dirty && folioSelfSingleBasicForm.minorName.$invalid}\"><input type=text class=input-field name=minorName placeholder=\"Minor\'s Name\" ng-maxlength=40 limit-to=40 maxlength=40 ng-model=minorFormData.minorsFullName ng-pattern=\"/^[a-zA-Z ]{1,40}$/\" required> <span class=highlight></span> <span class=bar></span> <span ng-show=\"folioSelfSingleBasicForm.minorName.$dirty && folioSelfSingleBasicForm.minorName.$invalid\"><span class=\"error-input error\" ng-show=folioSelfSingleBasicForm.minorName.$error.required ng-bind=CONST.MINOR_NAME></span> <span class=\"error-input error\" ng-show=\"folioSelfSingleBasicForm.minorName.$error.pattern && !folioSelfSingleBasicForm.minorName.$error.required\" ng-bind=CONST.MINOR_VALID_NAME></span></span></div></div></div><div class=row><div class=col-md-6><label class=titleFatca for=dobId>Date of Birth <span class=\"req text-red\">*</span></label><div class=\"input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{viewMode}} ng-class=\"{error:folioSelfSingleBasicForm.dob.$dirty && folioSelfSingleBasicForm.dob.$invalid}\" data-date-default=minorFormData.dob data-on-date-change=getMinordob maxdate=now format=DD-MMM-YYYY id=endDate style=\"margin-bottom: 0px\"><input class=input-field id=dobId name=dob type=text autocomplete=off placeholder=DD-MMM-YYYY ng-keyup=autoDate() ng-model=minorFormData.minorDob required> <span class=input-group-addon><span class=glyphicon-calendar-blue></span> </span><span class=error-input ng-if=\"dateErrorMessage && minorFormData.minorDob && folioSelfSingleBasicForm.dob.$dirty && folioSelfSingleBasicForm.dob.$invalid\" ng-bind=dateErrorMessage></span> <span class=error-input ng-if=\"MINOR_DOB_ERROR && minorFormData.minorDob\">Applicant\'s age should be less than 18 years</span></div><span ng-show=\"folioSelfSingleBasicForm.dob.$dirty && folioSelfSingleBasicForm.dob.$invalid\"><span class=error-input ng-show=folioSelfSingleBasicForm.dob.$error.required>{{CONST.MINOR_DOB}}</span></span></div></div><div class=row><div class=col-md-6><label class=titleFatca>Gender<span class=\"req text-red\">*</span></label><div ng-class=\"{error:folioSelfSingleBasicForm.gender.$dirty && folioSelfSingleBasicForm.gender.$invalid}\"><select class=\"selectNormal browser-default custom-select\" name=gender ng-model=minorFormData.gender ng-init=\"minorFormData.gender= minorFormData.gender ? minorFormData.gender: null\" ng-options=\"data.value as data.name for data in genderObj\" required><option value=\"\" selected>Gender</option></select><span ng-show=\"folioSelfSingleBasicForm.gender.$dirty && folioSelfSingleBasicForm.gender.$invalid\"><span class=error-input ng-show=folioSelfSingleBasicForm.gender.$error.required ng-bind=CONST.GENDER_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-6><label class=titleFatca>Upload Minor\'s Age Proof <span class=\"req text-red\">*</span> <i class=\"info-icon base-tooltip\" tooltip data-bs-html=true data-bs-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"<u style=\'font-size:14px;font-weight:bold\'>View List of Valid DOB Proof</u></br>Below is the list of Valid DOB Proof</br>\n                          <ul style=\'color:black\'><li>Birth certificate</li><li>School leaving certificate/ Mark sheet issued by Higher Secondary Board of respective states, ICSE, CBSE etc.</li>\n                          <li>Passport</li><li>Any other suitable proof evidencing the date of birth of the minor</li></ul>Max File size should be less than or equal to 2 MB.\n                            File format should be tif, tiff, jpg and jpeg extension.\"></i></label><div ng-class=\"{error:folioSelfSingleBasicForm.minorAgeDoc.$dirty && folioSelfSingleBasicForm.minorAgeDoc.$invalid}\"><select id=minorsageproof name=minorsageproof class=selectNormal ng-model=minorFormData.ageproofType ng-change=\"minorFormData.ageproofimageurl = null; minorFormData.ageproofimageName = \'\'; resetAgeProof()\" required><option value selected>Select</option><option ng-repeat=\"value in minorAgeProofType\" ng-selected=\"minorFormData.ageproofType == value.proofTypeDesc\" value={{value.proofTypeDesc}}>{{value.proofTypeDesc}}</option></select><span ng-show=\"folioSelfSingleBasicForm.minorsageproof.$dirty && !FolioBasicMinorDetails.minorFormData.ageproofType\"><span class=error-input ng-show=folioSelfSingleBasicForm.minorsageproof.$error.required>Minor\'s age proof required!</span></span></div></div><div class=col-md-6><div ng-if=minorFormData.ageproofimageName><p style=\"color: blue;font-size: 9px\">{{minorFormData.ageproofimageName}}</p></div><div class=upload-proof-image><label class=\"titleFatca upload-icon\" for=minorageproofimage class=uploadProofBasket>upload proof</label><input type=file name=minorageproofimage id=minorageproofimage accept=image/tiff,image/tif,image/jpeg,image/jpg file-model-profile=\"Preview Uploaded Doc\" ng-model=minorFormData.ageproofimageurl upload=getMinorAgeProofImage(file) style=\"display: none;visibility: none\" required> <i class=green-tick-icon ng-if=minorFormData.ageproofimageurl></i></div></div></div><div class=row><div class=col-md-6><label class=titleFatca>Tax Status <span class=\"req text-red\">*</span></label><div ng-class=\"{error:folioSelfSingleBasicForm.taxStatusCode.$dirty && folioSelfSingleBasicForm.taxStatusCode.$invalid}\"><select class=selectNormal id=taxstatus name=taxstatus ng-model=minorFormData.taxstatus required><option value selected>Select</option><option ng-repeat=\"value in taxStatus\" ng-selected=\"minorFormData.taxstatus == value.taxStatusCode\" value={{value.taxStatusCode}} selected>{{value.taxStatusDescription}}</option></select><span ng-show=\"folioSelfSingleBasicForm.taxstatus.$dirty && !minorFormData.taxstatus\"><span class=error-input ng-show=folioSelfSingleBasicForm.taxstatus.$error.required ng-bind=CONST.TAX_STATUS></span></span></div></div></div></div></div><!--                  <hr/>--><!--                  <div class=\"form-footer form-content\">--><!--                    <input type=\"submit\" ng-disabled=\"folioSelfSingleBasicForm.$invalid\" class=\"btn btn-primary-action common-btn-padding pull-right\"--><!--                           value=\"Continue\"/>--><!--                  </div>--><div class=proceed><button type=submit class=proceed-btn ng-disabled=\"folioSelfSingleBasicForm.$invalid || MINOR_DOB_ERROR\">Next</button></div><!--                  <div ng-if=\"!folioSelfSingleBasicForm.$invalid && editBasicDetail\" ng-init=\"formIsvalid()\"></div>--><!--                  <div ng-if=\"folioSelfSingleBasicForm.$invalid && editBasicDetail\" ng-init=\"formIsinvalid()\"></div>--></form></div></div></div></div></section></div></div></div><!--Self Review--><div class=\"container-fluid reviewTable set-padding-left-10\" ng-show=\"!editBasicDetail && folioBasicDetail.folioForUser === \'Self\'\"><div class=row><div class=col-xs-12><section class=initiate-transaction><div class=summary><div><div class=row><div class=\"col-md-6 pd0\"><table class=\"table borderless\"><tr><td><strong>Create Folio For: </strong></td><td>{{folioBasicDetail.folioForUser}}</td></tr><tr><td><strong>Mode Of Holding: </strong></td><td>{{folioBasicDetail.folioHoldingMode == \'ANY_OR_SURVIVOR\' ? \'Anyone or survivor\' : \'Single\'}}</td></tr><tr><td><strong>Politically Exposed Person(PEP) status: </strong></td><td>{{folioBasicDetail.userPEPStatus}}</td></tr></table></div><div class=\"col-md-6 pd-left-right\"><table class=\"table borderless\"><tr><td><strong>Are you a tax resident (i.e Are you assessed for tax in any other country outside India?):</strong></td><td>{{holders.payTaxInIndia == true?\'No\':\'Yes\'}}</td></tr></table><div class=row ng-if=\"holders.payTaxInIndia == false\"><div class=col-md-12><table class=\"table borderless\" ng-repeat=\"taxResidence in reviewData track by $index\"><tr><td><strong>Tax Residency Country {{$index+1}}</strong></td></tr><tr><td><strong>Name Of Country:</strong></td><td>{{taxResidence.taxPayingCountry}}</td></tr><tr><td><strong>City:</strong></td><td class=content-wrap>{{taxResidence.taxPayingCity}}</td></tr><tr><td><strong>Tax Id Type:</strong></td><td>{{taxResidence.taxIdType}}</td></tr><tr><td><strong>Tax Id:</strong></td><td class=content-wrap>{{taxResidence.taxId}}</td></tr></table></div></div></div></div></div></div></section></div></div></div><!--Minor Review--><div class=\"container-fluid reviewTable minor-review\" ng-show=\"!editBasicDetail && folioBasicDetail.folioForUser === \'Minor\'\"><div class=row><div class=col-xs-12><section class=initiate-transaction><div class=summary><div><div class=row><div class=\"col-md-6 pd0\"><table class=\"table borderless\"><tr><td><strong>Create Folio For: </strong></td><td>{{folioBasicDetail.folioForUser}}</td></tr><tr><td><strong>Minor\'s Name:</strong></td><td>{{minorFormData.minorsFullName}}</td></tr><tr><td><strong>Date Of Birth:</strong></td><td>{{minorFormData.dob}}</td></tr><tr></tr><tr><td><strong>Gender:</strong></td><td>{{minorFormData.gender | camelcase}}</td></tr></table></div><div class=\"col-md-6 pd0\"><table class=\"table borderless\"><tr><td><strong>Minor Age Poof:</strong></td><td>{{minorFormData.ageproofType}}</td></tr><tr><td><strong>Tax Status:</strong></td><td>{{taxStatusName | camelcase}}</td></tr></table></div></div></div></div></section></div></div></div>");
$templateCache.put("app/investment-baskets/investment-basket-directives/folio/guardian-details/guardian-details.directive.html","<!--Guardian Details--><div class=incomeDetailsForSelfAnyone ng-if=editGuardianDetail><form autocomplete=off name=minorFormGuardian ng-submit=submitMinorGuardianDetails() novalidate><!--<p style=\"padding-left: 15px;\" class=\"contactDetails\">Contact Details(Please submit physical request to update contact details in your KYC)</p>--><div class=contactDetails ng-if=\"!soleApplicantEmail && !soleApplicantMobile\"><span class=warning style=\"justify-content: center;padding: 10px\">{{CONST_DATA.UPDATE_CONTANCT_BOTH_MISSING}}</span></div><div class=contactDetails ng-if=\"(!soleApplicantEmail && soleApplicantMobile) || (soleApplicantEmail && !soleApplicantMobile)\"><span class=warning style=\"justify-content: center;padding: 10px\">{{CONST_DATA.UPDATE_CONTACT_SINGLE_MISSING}}</span></div><div style=\"padding-left: 15px\" class=row><div class=col-md-6><div class=\"emailAndMobile contact-label\"><table><tbody><tr><td style=\"padding: 0px !important\"><span><strong>Email Id <span class=\"req text-red\">*</span></strong></span> :</td><td ng-if=!showEmailEditField><span ng-if=\"soleApplicantEmail && !showEmailEditField\">{{soleApplicantEmail}}</span> <span ng-if=\"!soleApplicantEmail && !showEmailEditField\">Not Updated</span> <span class=edit-icon ng-if=\"soleApplicantMobile && !showEmailEditField && !showMobileEditField\" ng-click=\"editContactDetails(\'email\')\"></span></td><td><div class=edit-fields><div ng-class=\"{error:minorFormGuardian.email.$dirty && minorFormGuardian.email.$invalid}\"><input class=input-field type=text name=email ng-model=soleApplicantEditedEmail placeholder=\"Email Id\" ng-change=\"changeValue(\'email\', soleApplicantEditedEmail)\" ng-if=showEmailEditField ng-pattern=CONST_DATA.email_regex required></div><span ng-if=showEmailEditField class=edit-actions><button type=button class=\"btn-small btn-primary-action\" ng-disabled=\"minorFormGuardian.email.$pristine || minorFormGuardian.email.$error.pattern || minorFormGuardian.email.$error.required\" ng-click=\"generateContactUpdateOtp(\'email\')\">Send OTP</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"cancelEditAction(\'email\');\">Cancel</button></span></div><span ng-show=\"minorFormGuardian.email.$dirty && minorFormGuardian.email.$invalid\"><span class=error-input ng-bind=validateData.EMAIL_FIELD></span></span></td></tr></tbody></table></div></div><div class=col-md-6><div class=\"emailAndMobile contact-label\"><table><tbody><tr><td style=\"padding: 0px !important\"><span><strong>Mobile Number <span class=\"req text-red\">*</span></strong></span></td><td ng-if=!showMobileEditField><span ng-if=\"soleApplicantMobile && !showMobileEditField\">{{soleApplicantMobile}}</span> <span ng-if=\"!soleApplicantMobile && !showMobileEditField\">Not Updated</span> <span class=edit-icon ng-if=\"soleApplicantEmail && !showMobileEditField && !showEmailEditField\" ng-click=\"editContactDetails(\'mobile\');\"></span></td><td><div class=edit-fields><div><input class=input-field type=text name=mobileNumber ng-model=soleApplicantEditedMobile ng-change=\"changeValue(\'mobile\', soleApplicantEditedMobile)\" placeholder=\"Mobile Number\" maxlength=13 ng-if=showMobileEditField ng-pattern=CONST_DATA.mobile_regex required></div><span ng-if=showMobileEditField class=edit-actions><button type=button class=\"btn-small btn-primary-action\" ng-disabled=\"minorFormGuardian.mobileNumber.$pristine || minorFormGuardian.mobileNumber.$error.pattern || minorFormGuardian.mobileNumber.$error.required\" ng-click=\"generateContactUpdateOtp(\'mobile\')\">Send OTP</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"cancelEditAction(\'mobile\');\">Cancel</button></span></div><span ng-show=\"minorFormGuardian.mobileNumber.$dirty && minorFormGuardian.mobileNumber.$invalid && minorFormGuardian.mobileNumber.$error.pattern\"><span class=error-input ng-bind=validateData.MOBILE_ISD></span></span></td></tr></tbody></table></div></div></div><div style=\"padding-left: 15px\" class=row ng-if=\"soleApplicantEmail || soleApplicantMobile\"><div class=col-md-6><div class=\"emailAndMobile belongsTo\" ng-if=soleApplicantEmail><p><strong>Email Id Belongs To <span class=\"req text-red\">*</span></strong></p><p>:</p><div ng-class=\"{error:minorFormGuardian.emailBelongsTo.$dirty && minorFormGuardian.emailBelongsTo.$invalid}\" style=\"width: 235px\"><select id=emailBelongsTo class=selectNormal name=emailBelongsTo ng-model=holders.emailBelongsTo required><option value selected>Select Value</option><option ng-repeat=\"value in belongToListEmail\" ng-selected=\"holders.emailBelongsTo == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"minorFormGuardian.emailBelongsTo.$dirty \"><span class=error-input ng-show=minorFormGuardian.emailBelongsTo.$error.required>Please select option</span></span></div></div></div><div class=col-md-6><div class=\"emailAndMobile belongsTo\" ng-if=soleApplicantMobile><p><strong>Mobile No. Belongs To <span class=\"req text-red\">*</span></strong></p><p>:</p><div ng-class=\"{error:minorFormGuardian.mobileBelongsTo.$dirty && minorFormGuardian.mobileBelongsTo.$invalid}\" style=\"width: 235px\"><select class=selectNormal id=mobileBelongsTo name=mobileBelongsTo ng-model=holders.mobileBelongsTo ng-init=\"holders.mobileBelongsTo = holders.mobileBelongsTo ? holders.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in belongToListMobile\" ng-selected=\"holders.mobileBelongsTo == data.familyCode\" required><option value=\"\" selected>Select Value</option></select><span ng-show=\"minorFormGuardian.mobileBelongsTo.$dirty &&  minorFormGuardian.mobileBelongsTo.$invalid\"><span class=error-input ng-show=minorFormGuardian.mobileBelongsTo.$error.required>Please select option</span></span></div></div></div></div><div style=\"padding-left: 15px\" class=row><div class=\"col-md-6 removePad\"><div class=row><div class=col-md-6><label class=titleFatca>Guardian\'s Relationship<span class=\"req text-red\">*</span></label><div><select class=selectNormal id=minorGuardianRelationship name=minorGuardianRelationship ng-model=minorFormGuardianData.relation required><option value selected>Select</option><option ng-repeat=\"x in relationshipList\" ng-selected=\"minorFormGuardianData.relation == x.value\" value={{x.value}}>{{x.name}}</option></select><span ng-show=\"minorFormGuardian.minorGuardianRelationship.$dirty && !minorFormGuardianData.relation\"><span class=error-input ng-show=minorFormGuardian.minorGuardianRelationship.$error.required>Relationship is required</span></span></div></div></div><div class=row><div class=col-md-6><label class=titleFatca>Guardian Relationship Proof <span class=\"req text-red\">*</span></label><i class=\"info-icon base-tooltip\" tooltip data-bs-html=true data-bs-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"<u style=\'font-size:14px;font-weight:bold\'>View List of Relationship Proof</u></br>\n                        In case of a natural parent, documents evidencing the relationship of the natural parent with the minor,\n                        if the same is not available as part of the documents mentioned above, should be submitted. In case of court appointed legal guardian, supporting documentary evidence (notarized court order) should be provided.\n                        </br>Max file size should be less than or equal to 2 MB. </br>File format should be tif, tiff, jpg and jpeg extension.\"></i><div><select class=selectNormal id=minorRelationshipType name=minorRelationshipType ng-model=minorFormGuardianData.guardianrelationproofType ng-change=\"minorFormGuardianData.guardianrelationproofimagename = null;minorFormGuardianData.guardianrelationproofimageurl = \'\'; resetGuardianImage()\" required><option value selected>Select</option><option ng-repeat=\"value in relationProofType\" ng-selected=\"minorFormGuardianData.guardianrelationproofType == value.proofTypeDesc\" value={{value.proofTypeDesc}}>{{value.proofTypeDesc}}</option></select><span ng-show=\"minorFormGuardian.minorRelationshipType.$dirty && !minorFormGuardianData.guardianrelationproofType\"><span class=error-input ng-show=minorFormGuardian.minorRelationshipType.$error.required>Minors Relationship proof required!</span></span></div></div><div class=\"col-xs-12 col-md-6\"><div ng-if=minorFormGuardianData.guardianrelationproofimagename><p style=\"color: blue;font-size: 9px\" class=mg15>{{minorFormGuardianData.guardianrelationproofimagename}}</p></div><div class=upload-proof-image><label for=guardianrelationproofimage class=\"titleFatca upload-icon\">upload proof</label><input type=file name=guardianrelationproofimage id=guardianrelationproofimage accept=\"image/jpeg, image/jpg, image/tif, image/tiff\" file-model-profile=\"Preview Uploaded Doc\" ng-model=minorFormGuardianData.guardianrelationproofimageurl upload=getGuardianRelationProofImage(file) style=\"display: none;visibility: none\" required> <i class=green-tick-icon ng-if=minorFormGuardianData.guardianrelationproofimageurl></i></div><!-- onchange=\"angular.element(this).scope().getGuardianRelationProofImage(this.files)\" --></div></div><div class=row><div class=col-md-6><label class=titleFatca>Occupation <span class=\"req text-red\">*</span></label><div><select id=occupation class=selectNormal name=occupation ng-model=minorFormGuardianData.occupation required><option value selected>Select</option><option ng-repeat=\"value in investorOccupations\" ng-selected=\"minorFormGuardianData.occupation == value.occupationCode\" value={{value.occupationCode}}>{{value.occupationDescription}}</option></select><span ng-show=\"minorFormGuardian.occupation.$dirty && !minorFormGuardianData.occupation\"><span class=error-input ng-show=minorFormGuardian.occupation.$error.required ng-bind=validateData.OCCUPATION></span></span></div></div></div><div class=row><div class=col-md-12><label>FATCA & CRS related question.</label><i class=\"info-icon base-tooltip\" tooltip data-bs-html=true data-bs-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"The below information is required for all applicants(s) / guardians. Is also applicant(s) / guardian’s country of birth / citizenship / Nationality / TAX residency other than India?\"></i></div></div><div class=row><div class=col-md-6><label class=titleFatca>Select Country<span class=\"req text-red\">*</span></label><div><select class=selectNormal id=fatcacountry name=fatcacountry ng-model=minorFormGuardianData.Fatca.Countrie required><option value selected>Select Country</option><option ng-repeat=\"value in countries\" ng-selected=\"minorFormGuardianData.Fatca.Countrie == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select><span ng-show=\"minorFormGuardian.fatcacountry.$dirty && !minorFormGuardianData.Fatca.Countrie\"><span class=error-input ng-show=minorFormGuardian.fatcacountry.$error.required ng-bind=validateData.SELECT_COUNTRY></span></span></div></div></div><div class=row><div class=col-md-6><label class=titleFatca>Address type<span class=\"req text-red\">*</span></label><div><select class=selectNormal id=addressType name=addressType ng-model=minorFormGuardianData.Fatca.addressType required><option value selected>Select</option><option ng-repeat=\"x in addressType\" ng-selected=\"minorFormGuardianData.Fatca.addressType == x.value\" value={{x.value}}>{{x.addressDescription}}</option></select><span ng-show=\"minorFormGuardian.addressType.$dirty && !minorFormGuardianData.Fatca.addressType\"><span class=error-input ng-show=minorFormGuardian.addressType.$error.required ng-bind=validateData.FATCA_ADDRESS_TYPE_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-6><label class=titleFatca>City<span class=\"req text-red\">*</span></label><div><input class=input-field id=fatcaTaxpayingCity type=text name=fatcaTaxpayingCity ng-model=minorFormGuardianData.Fatca.City ng-maxlength=35 limit-to=35 maxlength=35 ng-pattern=/^[a-zA-Z\\s]*$/ required placeholder=City> <span ng-show=\"minorFormGuardian.fatcaTaxpayingCity.$dirty && minorFormGuardian.fatcaTaxpayingCity.$invalid\"><span class=error-input ng-show=minorFormGuardian.fatcaTaxpayingCity.$error.required ng-bind=validateData.CITY></span> <span class=error-input ng-show=minorFormGuardian.fatcaTaxpayingCity.$error.pattern>Invalid City</span></span></div></div></div></div><div class=col-md-6><!--      pollitical person--><div class=row><div class=col-md-12><table class=\"table borderless top-part\"><tr><td>Are you politically Exposed person</td><td></td></tr><tr><td class=politically><div class=radio-block><span class=radio><input type=radio id=politicalStatus1 name=politicalStatus ng-model=minorFormGuardianData.politicalStatus ng-change=\"getPEPStatusForGuardian(\'Yes\')\" ng-value=CONST_DATA.INVESTOR_POLITICAL_STATUS.POLITICAL> <span class=check></span> </span><span class=radio-label>Yes</span></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus3 name=politicalStatus ng-model=minorFormGuardianData.politicalStatus ng-change=\"getPEPStatusForGuardian(\'No\')\" ng-value=CONST_DATA.INVESTOR_POLITICAL_STATUS.NONE> <span class=check></span> </span><span class=radio-label>No</span></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=minorFormGuardianData.politicalStatus ng-change=\"getPEPStatusForGuardian(\'Related\')\" ng-value=CONST_DATA.INVESTOR_POLITICAL_STATUS.RELATED> <span class=check></span> </span><span class=radio-label>Related to PEP</span></div></td></tr></table></div></div><!--      income details--><div class=income-tab style=\"padding-bottom: 15px\"><div class=income-tab1><p>Income</p></div><div class=income-tab2 ng-click=incomeActiveTabForGuardian(incomeTab[0]) ng-class=\"{\'income-active-tab\':annualTabForGuardian}\"><div>Annual Gross Income</div></div><div class=income-tab3 ng-click=incomeActiveTabForGuardian(incomeTab[1]) ng-class=\"{\'income-active-tab\':netWorthTabForGurdian}\"><div>Net Worth</div></div></div><div class=row ng-if=annualTabForGuardian><div class=col-md-6><div><select id=guardianAnnualincome name=guardianAnnualincome class=selectNormal ng-model=minorFormGuardianData.grossAnnualIncome required><option value selected>Select</option><option ng-repeat=\"value in incomeSlabList\" ng-selected=\"minorFormGuardianData.grossAnnualIncome == value.incomeCode\" value={{value.incomeCode}}>{{value.incomeDescription}}</option></select><span ng-show=\"minorFormGuardian.guardianAnnualincome.$dirty && !minorFormGuardianData.grossAnnualIncome\"><span class=error-input ng-show=minorFormGuardian.guardianAnnualincome.$error.required ng-bind=validateData.GROSS_ANNUAL_INCOME></span></span></div></div></div><div class=row ng-if=netWorthTabForGurdian><div class=\"col-xs-12 col-md-6\"><div><input type=text class=\"form-control input-field\" id=annualincome1 style=\"padding-left: 20px\" name=annualincome1 placeholder=\"Net worth\" ng-change=netWorthChanges(minorFormGuardianData.networthComma) ng-model=minorFormGuardianData.networthComma onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" autofocus required> <span ng-show=\"minorFormGuardian.annualincome1.$dirty && !minorFormGuardianData.networth\"><div class=error-input ng-show=minorFormGuardian.annualincome1.$error.required ng-bind=validateData.NET_WORTH></div></span><i class=\"rupee-input-icon rupee-icon-genric\"></i></div><div class=set-margin-top-20><span id=divDisplayWords>{{amountInWords}}</span></div></div></div><div class=row ng-if=netWorthTabForGurdian><div class=col-md-6><div class=\"input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{viewMode}} data-date-default=minorFormGuardianData.grossAnnualIncomeDate data-on-date-change=grossAnnualIncomeDate maxdate=now format=DD-MM-YYYY id=endDate><input class=input-field tabindex=2 id=grossAnnualIncomeDateId name=grossAnnualIncomeDate type=text autocomplete=off placeholder=DD-MMM-YYYY ng-keyup=autoDate() required> <span class=input-group-addon><!--                <img class=\"calender-icon-register\" src=\"../../assets/images/icons/dateIcon.png\" />--> <span class=glyphicon-calendar-blue></span></span><div class=set-margin-top-20><span>(Not older than 1 year)</span></div><br><span class=error-input ng-if=dateErrorMessage ng-bind=dateErrorMessage></span></div></div></div></div></div><!--    <div class=\"row\">--><!--      <div class=\"col-md-12 pad30\">--><!--        <div class=\"row\">--><!--          <div class=\"col-md-8\">--><!--            <table class=\"table borderless top-part\">--><!--              <tr>--><!--                <td>--><!--                  Are you a tax resident (i.e Are you assessed for tax in any other country outside India?)--><!--                </td>--><!--                <td></td>--><!--              <tr>--><!--                <td class=\"politically\">--><!--                  <div class=\"radio-block\">--><!--                       <span class=\"radio\">--><!--                        <input type=\"radio\" id=\"payTaxInIndiaYes\" name=\"payTaxInIndiaYes\"--><!--                               ng-model=\"minorFormGuardianData.fileTaxOtherIndian\"--><!--                               ng-change=\"getTaxFileStatusForGuardian(\'Yes\')\"--><!--                               value=\"Yes\"/>--><!--                        <span class=\"check\"></span>--><!--                      </span>--><!--                    <span class=\"radio-label\">Yes</span>--><!--                  </div>--><!--                  <div--><!--                    class=\"radio-block\">--><!--                    <span class=\"radio\">--><!--                     <input type=\"radio\" id=\"payTaxInIndiaNo\" name=\"payTaxInIndiaNo\"--><!--                            ng-model=\"minorFormGuardianData.fileTaxOtherIndian\"--><!--                            ng-change=\"getTaxFileStatusForGuardian(\'No\')\"--><!--                            value=\"No\"/>--><!--                      <span class=\"check\"></span>--><!--                    </span>--><!--                    <span class=\"radio-label\">No</span>--><!--                  </div>--><!--                </td>--><!--              </tr>--><!--              </tr>--><!--            </table>--><!--          </div>--><!--        </div>--><!--        <div class=\"row\" ng-if=\"!minorFormGuardianData.Fatca.taxPayIndian\">--><!--          <div class=\"col-md-12\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-3\">--><!--                <label for=\"\">Name of Country</label>--><!--                <div>--><!--                  <select class=\"selectNormal\"--><!--                          id=\"country\"--><!--                          name=\"country\"--><!--                          ng-model=\"minorFormGuardianData.Fatca.taxPay1.taxPayingCountry\" required>--><!--                    <option value selected=\"selected\">Select</option>--><!--                    <option ng-repeat=\"value in countries\"--><!--                            ng-selected=\"minorFormGuardianData.Fatca.taxPay1.taxPayingCountry == value.countryCode\"--><!--                            value=\"{{value.countryCode}}\">{{value.countryName}}</option>--><!--                  </select>--><!--                  <span ng-show=\"minorFormGuardian.country.$dirty && !minorFormGuardianData.Fatca.taxPay1.taxPayingCountry\">--><!--          <span class=\"error-input\" ng-show=\"minorFormGuardian.country.$error.required\"--><!--                ng-bind=\"validateData.SELECT_COUNTRY\"></span>--><!--        </span>--><!--                </div>--><!--              </div>--><!--              <div class=\"col-md-3\">--><!--                <label for=\"\">Tax Paying City</label>--><!--                <div>--><!--                  <input class=\"input-field\"--><!--                         class=\"form-control inputNormal\"--><!--                         id=\"taxpayingCity\" placeholder=\"City\"--><!--                         type=\"text\"--><!--                         name=\"taxpayingCity\"--><!--                         ng-model=\"minorFormGuardianData.Fatca.taxPay1.taxPayingCity\"--><!--                         ng-pattern=\"/^[a-zA-Z ]+$/\"--><!--                         autofocus required>--><!--                  <span ng-show=\"minorFormGuardian.taxpayingCity.$dirty && minorFormGuardian.taxpayingCity.$invalid\">--><!--                    <span class=\"error-input\" ng-show=\"minorFormGuardian.taxpayingCity.$error.required\"--><!--                          ng-bind=\"validateData.CITY\"></span>--><!--                    <span class=\"error-input\" ng-show=\"minorFormGuardian.taxpayingCity.$error.pattern\">Number not allowed in minor--><!--                      name!</span>--><!--                  </span>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            <div class=\"row\">--><!--              <div class=\"col-md-3\">--><!--                <label for=\"\">Tax ID Type</label>--><!--                <div>--><!--                  <select class=\"selectNormal\"--><!--                          id=\"taxIdType\"--><!--                          name=\"taxIdType\"--><!--                          ng-model=\"minorFormGuardianData.Fatca.taxPay1.taxIdType\" required>--><!--                    <option value selected=\"selected\">Select</option>--><!--                    <option ng-repeat=\"value in taxIdType\"--><!--                            ng-selected=\"minorFormGuardianData.Fatca.taxPay1.taxIdType == value.value\"--><!--                            value=\"{{value.value}}\">{{value.description}}</option>--><!--                  </select>--><!--                  <span ng-show=\"minorFormGuardian.taxIdType.$dirty && !minorFormGuardianData.Fatca.taxPay1.taxIdType\">--><!--                    <span class=\"error-input\" ng-show=\"minorFormGuardian.taxIdType.$error.required\"--><!--                          ng-bind=\"validateData.TAX_ID_TYPE\"></span>--><!--                  </span>--><!--                </div>--><!--              </div>--><!--              <div class=\"col-md-3\">--><!--                <label for=\"\">Tax ID</label>--><!--                <div>--><!--                  <input class=\"input-field\"--><!--                         id=\"taxId\" placeholder=\"Tax ID number\"--><!--                         type=\"text\"--><!--                         name=\"taxId\"--><!--                         ng-model=\"minorFormGuardianData.Fatca.taxPay1.taxId\"--><!--                         required>--><!--                  <span ng-show=\"minorFormGuardian.taxId.$dirty && minorFormGuardian.taxId.$invalid\">--><!--                    <span class=\"error-input\" ng-show=\"minorFormGuardian.taxId.$error.required\"--><!--                          ng-bind=\"validateData.TAX_ID_NUMBER\"></span>--><!--                  </span>--><!--                </div>--><!--              </div>--><!--            </div>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--><div class=row style=\"padding-left: 26px\"><div class=col-md-12><div class=row><div class=col-md-8><table class=\"table borderless top-part\"><tr><td>Are you a tax resident (i.e Are you assessed for tax in any other country outside India?)</td><td></td></tr><tr><td class=politically><div class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-change=changePayTaxOutsideIndiaStatus(true) ng-model=holders.payTaxInIndia ng-value=false> <span class=check></span> </span><span class=radio-label>Yes</span></div><div class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-model=holders.payTaxInIndia ng-value=true> <span class=check></span> </span><span class=radio-label>No</span></div></td></tr></table></div></div><div ng-if=!holders.payTaxInIndia class=tax-status-adding style=\"padding-left: 15px\"><div ng-repeat=\"data in holders.fatcaArray\"><p><strong>Tax Residency Country</strong> <span ng-show=\"$index > 0\" class=remove-item ng-click=deleteTaxResidency($index)><i class=delete-red-icon></i></span></p><div class=row><div class=col-md-3><label class=titleFatca>Select Country<span class=\"req text-red\">*</span></label><div ng-class=\"{error:minorFormGuardian[\'birthCountry\'+$index].$dirty && minorFormGuardian[\'birthCountry\'+$index].$invalid}\"><select class=selectNormal name=birthCountry{{$index}} ng-model=data.taxPayingCountry ng-init=\"data.taxPayingCountry=data.taxPayingCountry?data.taxPayingCountry:null\" ng-options=\"country.countryCode as country.countryName for country in countries|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" easyassist-key=mask-element required><option value=\"\" selected>Select Country</option></select><span ng-show=\"minorFormGuardian[\'birthCountry\'+$index].$dirty && minorFormGuardian[\'birthCountry\'+$index].$invalid\"><span class=error-input ng-show=\"minorFormGuardian[\'birthCountry\'+$index].$error.required\">{{CONST.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-3><label class=titleFatca>City<span class=\"req text-red\">*</span></label><div ng-class=\"{error:minorFormGuardian[\'birthCity\'+$index].$dirty && minorFormGuardian[\'birthCity\'+$index].$invalid}\"><input type=text name=birthCity{{$index}} class=input-field ng-model=data.taxPayingCity ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element ng-pattern=/^[a-zA-Z\\s]*$/ required placeholder=City> <span class=highlight></span> <span class=bar></span> <span ng-show=\"minorFormGuardian[\'birthCity\'+$index].$dirty && minorFormGuardian[\'birthCity\'+$index].$invalid\"><span class=error-input ng-show=\"minorFormGuardian[\'birthCity\'+$index].$error.required\">{{CONST.BIRTH_CITY}}</span> </span><span class=error-input ng-show=\"minorFormGuardian[\'birthCity\'+$index].$error.pattern\">Invalid City</span></div></div></div><div class=row><div class=col-md-3><label class=titleFatca>Select Tax ID type<span class=\"req text-red\">*</span></label><div ng-class=\"{error:minorFormGuardian[\'taxIdType\'+$index].$dirty && minorFormGuardian[\'taxIdType\'+$index].$invalid}\"><select class=selectNormal name=taxIdType{{$index}} ng-model=data.taxIdType ng-init=\"data.taxIdType= data.taxIdType ? data.taxIdType: null\" ng-options=\"taxid.description as taxid.description for taxid in taxIdType\" easyassist-key=mask-element required><option value=\"\" selected>Select Tax ID type</option></select><span ng-show=\"minorFormGuardian[\'taxIdType\'+$index].$dirty && minorFormGuardian[\'taxIdType\'+$index].$invalid\"><span class=error-input ng-show=\"minorFormGuardian[\'taxIdType\'+$index].$error.required\">{{CONST.TAX_ID_TYPE}}</span></span></div></div><div class=col-md-3><label class=titleFatca>Tax ID number<span class=\"req text-red\">*</span></label><div><input type=text class=input-field name=taxId{{$index}} ng-model=data.taxId ng-maxlength=20 limit-to=20 maxlength=20 easyassist-key=mask-element required capitalize placeholder=\"Tax ID number\"> <span class=highlight></span> <span class=bar></span> <span ng-show=\"minorFormGuardian[\'taxId\'+$index].$dirty && minorFormGuardian[\'taxId\'+$index].$invalid\"><div class=error-input ng-show=\"minorFormGuardian[\'taxId\'+$index].$error.required\">{{CONST.TAX_ID_NUMBER}}</div></span></div></div></div></div><div class=addMoreTax><a ng-show=\"((holders.fatcaArray.length)*1<3)\" href=\"\" class=text-blue ng-click=addMoreTaxResidency()><strong><i class=plus-icon></i> <span>Add another tax residency country</span></strong></a></div></div></div></div><div class=proceed style=\"padding-left: 15px\"><button class=proceed-btn type=submit ng-disabled=\"minorFormGuardian.$invalid || !soleApplicantEmail || !soleApplicantMobile\">Next</button></div><!--    <div ng-if=\"!minorFormGuardian.$invalid\" ng-init=\"formIsvalid()\"></div>--><!--    <div ng-if=\"minorFormGuardian.$invalid\" ng-init=\"formIsinvalid()\"></div>--></form></div><!--Review of Guardian--><div class=\"container-fluid reviewTable minor-review\" ng-if=!editGuardianDetail><div class=row><div class=col-xs-12><section class=initiate-transaction><div class=summary><div><div class=row><div class=\"col-md-6 pd0\"><table class=\"table borderless\"><tr ng-if=soleApplicantEmail><td>Email Id:</td><td class=emailBreak>{{soleApplicantEmail || \'Not Updated\'}}</td></tr><tr ng-if=\"soleApplicantEmail && holders.emailBelongsTo\"><td>Email Belongs To:</td><td>{{filterBelongToEmail(holders.emailBelongsTo)}}</td></tr><tr ng-if=soleApplicantMobile><td>Mobile Number:</td><td>{{soleApplicantMobile || \'Not Updated\'}}</td></tr><tr ng-if=\"soleApplicantMobile && holders.mobileBelongsTo\"><td>Mobile Belongs To:</td><td>{{filterBelongToMobile(holders.mobileBelongsTo)}}</td></tr><tr><td>Guardian\'s Relationship:</td><td>{{minorFormGuardianData.relation}}</td></tr><tr><td>Guardian Relationship Proof :</td><td>{{minorFormGuardianData.guardianrelationproofType}}</td></tr><tr><td>Occupation:</td><td>{{occupation | camelcase}}</td></tr><tr></tr><tr><td>Country:</td><td>{{countryName.countryName | camelcase}}</td></tr><tr><td>politicalStatus:</td><td>{{minorFormGuardianData.userPEPStatusForGuardian}}</td></tr></table></div><div class=\"col-md-6 pd0\"><table class=\"table borderless\"><tr><td>Address type:</td><td>{{minorFormGuardianData.Fatca.addressType | camelcase}}</td></tr><tr><td>City:</td><td>{{minorFormGuardianData.Fatca.City}}</td></tr><tr ng-if=minorFormGuardianData.annualincome><td>Annual Gross Income:</td><td>{{grossAnnualincomeGuardian | camelcase}}</td></tr><tr ng-if=minorFormGuardianData.networth><td>Net Worth:</td><td>{{minorFormGuardianData.networth}}</td></tr><tr ng-if=folioBasicDetail.fileTaxOtherIndian><td>Gross Annual Income Date:</td><td>{{minorFormGuardianData.grossAnnualIncomeDate}}</td></tr></table></div><div class=\"col-md-6 pd0\"><table class=\"table borderless\"><tr><td>Are you a tax resident (i.e Are you assessed for tax in any other country outside India?):</td><td>{{holders.payTaxInIndia == true?\'No\':\'Yes\'}}</td></tr></table><table class=\"table borderless\" ng-repeat=\"taxResidence in reviewData track by $index\"><tr ng-if=\"reviewData.length > 0\"><td>Tax Residency Country {{$index+1}}</td></tr><tr ng-if=taxResidence.taxPayingCountry><td>Name Of Country:</td><td>{{taxResidence.taxPayingCountry}}</td></tr><tr ng-if=taxResidence.taxPayingCity><td>City:</td><td>{{taxResidence.taxPayingCity}}</td></tr><tr ng-if=taxResidence.taxIdType><td>Tax Id Type:</td><td>{{taxResidence.taxIdType}}</td></tr><tr ng-if=taxResidence.taxId><td>Tax Id:</td><td>{{taxResidence.taxId}}</td></tr></table></div></div></div></div></section></div></div></div>");
$templateCache.put("app/investment-baskets/investment-basket-directives/folio/holders/holders.html","<div class=joint-holder><!-- Pan Verification --><div class=set-padding-left-10 ng-if=\"!hideVerifyPanField && editHolder\" class=content id=addInvestor><div class=\"loader popup\"><span class=loading></span></div><div class=head><h3 class=title ng-bind=label.header>Add Joint Holder</h3></div><div class=body><form autocomplete=off name=verificationForm novalidate><div class=row><div class=\"col-xs-5 col-md-5\"><div class=tax-input-container-folio><label class=fw-bold>Tax Status</label><div class=\"tax-field-container mt-2 mb-3 d-flex\" style=\"column-gap: 40px\"><div class=\"d-flex justify-content-start;\"><input class=nomineeCheckbox type=radio id=resident-tax-status name=tax-status ng-value=false ng-model=formData.taxStatusResident><label for=resident-tax-status class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\">{{appConstants.TAX_STATUS_INDIVIDUAL.RESIDENT_INDIVIDUAL}}</label></div><div class=\"d-flex justify-content-start;\"><input class=nomineeCheckbox type=radio id=tax-status name=tax-status ng-value=true ng-model=formData.taxStatusResident><label for=tax-status class=confirmationnote style=\"font-size: 12px\"></label><label style=\"margin-top: 5px\">{{appConstants.TAX_STATUS_INDIVIDUAL.NON_RESIDENT_INDIVIDUAL}}</label></div></div></div></div></div><div class=row><div class=col-md-4 ng-class=\"{error:verificationForm.pan.$dirty && verificationForm.pan.$invalid}\"><input class=input-field type=text name=pan maxlength=10 minlength=10 ng-model=formData.pan ng-change=changePan(); ng-readonly=\"emailVerify===true||otpVerify === true\" ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ easyassist-key=mask-element capitalize required placeholder=\"e.g. ABCDE1234A\"> <span ng-show=\"verificationForm.pan.$dirty && verificationForm.pan.$invalid\"><span class=error-input ng-show=verificationForm.pan.$error.minlength ng-bind=validateData.PAN_FIELD></span> <span class=error-input ng-show=verificationForm.pan.$error.maxlength ng-bind=validateData.PAN_FIELD></span> <span class=error-input ng-show=\"verificationForm.pan.$error.pattern && !verificationForm.pan.$error.maxlength && !verificationForm.pan.$error.minlength\" ng-bind=validateData.PAN_FIELD></span> </span><span class=highlight></span> <span class=bar></span><div style=\"margin-left: 5px\" ng-class=\"{\'common-error\':wrongMsg != \'\'}\"><span ng-show=\"wrongMsg != \'\'\" ng-bind-html=wrongMsg></span></div></div></div><div ng-if=showEmail class=\"row verify-email\"><div class=\"col-xs-12 col-md-5\"><div class=row><div class=col-xs-12><label class=titleFatca>Email <span class=\"req text-red\">*</span></label></div></div><div class=row><div class=\"col-md-6 col-xs-12\"><input class=\"input-field form-control inputNormal\" type=email ng-change=changeEnteredEmail() ng-pattern=pattern.email_regex name=email ng-model=formData.email style=\"width: 100%\" required placeholder=Email> <span ng-show=\"verificationForm.email.$dirty && verificationForm.email.$invalid\"><span ng-if=\"!formData.email && verificationForm.email.$error.required\" class=error-input>Email field required!</span> <span ng-if=verificationForm.email.$error.pattern class=error-input>{{validateData.EMAIL_FIELD}}</span></span></div><div class=\"col-xs-12 col-md-6\"><button type=button style=\"margin-top: 0px\" class=\"btn hdfc-blue-cta-small btn-primary-action-pay\" ng-disabled=!formData.email ng-click=addEmailToHolderPan()>Add Email</button></div></div></div></div><div ng-if=showOtp class=\"row verify-email\"><div class=\"col-xs-12 col-md-5\"><div class=row><div class=col-xs-12><label class=titleFatca>Verify OTP <span class=\"req text-red\">*</span></label></div></div><div class=row><div class=\"col-md-6 col-xs-12\"><input class=\"input-field form-control inputNormal\" type=text minlength=6 maxlength=6 name=otp ng-model=formData.Otp style=\"width: 100%\" required placeholder=OTP><div style=\"padding-top: 10px\"><span ng-bind=OTPResendMsg style=\"color: #1bb898; display: block; font-size: 12px; padding-bottom: 15px\">OTP sent</span><timer countdown=pattern.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=reGenerateOtp() class=pull-right ng-disabled=isProcessing>Resend OTP</a> <a ng-show=\"countdown > 0\" style=\"float:right;font-size: 12px !important\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><div class=\"col-xs-12 col-md-6\"><button type=button style=\"margin-top: 0px\" class=\"btn hdfc-blue-cta-small btn-primary-action-pay\" ng-click=verifyOtp() ng-disabled=!formData.Otp>Verify</button></div></div></div></div><div class=row><div class=col-md-4><button ng-if=\"!showEmail && !showOtp \" type=button class=\"btn hdfc-blue-cta-small btn-primary-action-pay\" ng-click=verifyPAN() ng-disabled=\"verificationForm.$invalid || wrongMsg != \'\' || !allowJointHolder\">VERIFY</button></div></div></form></div></div><!--showing form data--><div class=set-padding-left-10 ng-if=\"hideVerifyPanField && editHolder\"><div class=investors><form autocomplete=off class=nominee-section name=jointHolderForm novalidate style=\"margin-left: 0\"><div class=form-content><div class=\"nominee-title clearfix\"><span class=\"pull-left details\"><strong>Holder Details</strong></span></div><div class=tab-container><ul class=\"nav nav-tabs\"><li ng-repeat=\"data in jointHoldersPayload.jointHolders\" ng-class=\"{\'active\':currentJointHolder.index===$index}\"><span ng-click=\"currentJointHolder.index = $index\">{{enum[$index+1]}} Holder Details</span> <i class=delete-red-icon ng-click=deleteCurrentJointHolder($index)></i></li></ul></div><div class=tab-content><div><div id=add-joint-holder class=\"tab-pane fade joint-holder in active\"><div ng-repeat=\"holder in jointHoldersPayload.jointHolders\"><div ng-show=\"currentJointHolder.index === $index\"><!--contact details--><div class=row style=\"margin-bottom: 10px; margin-left: -5px\"><div class=\"col-md-6 set-padding-left-0 contact-detail\"><div class=col-md-12><p>Name : <strong>{{holder.firstName ? holder.firstName +\' \'+holder.lastName : holder.jointHolderName}}</strong></p></div><div class=col-md-12><p>Pan : <strong>{{holder.pan}}</strong></p></div><div class=col-md-12><p>Email Id : <strong>{{holder.email?holder.email:\"Not Available\"}}</strong></p></div><div class=col-md-12><p>Mobile : <strong>{{holder.mobileNumber? holder.mobileNumber:\"Not Available\"}}</strong></p></div></div><div class=row ng-if=\"!holder.mobileNumber && !holder.email\"><div class=col-md-8><p class=update-contact-warning style=\"color: red\">To proceed with Folio creation contact details of investor are mandatory. Kindly get in touch with our ISC or CAMS to update CKYC.</p></div></div></div><div class=pdt0><div class=row style=\"margin-left: 0px\"><div class=\"col-md-3 holder-detail-copy-checkbox\" ng-show=\"currentJointHolder.index === 1\" class=ng-scope><p class=inputquestion style=\"margin: 5px 0px\">Applicant Details</p>&nbsp; <input style=\"height: 30px; width: 190px; left: 144px\" ng-click=addFirstHolderData() class=\"nomineeCheckbox sameasinvestor\" type=checkbox name=dataNominee id=dataNominee><label class=confirmationnote for=dataNominee style=\"margin-left: 10px;font-size: 14px\" tabindex=0>Same as second holder</label></div></div><div class=\"row tax-status-container\"><div class=\"col-md-12 set-padding-left-0\"><div class=col-md-4><p class=titleFatca>Tax Status <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.taxStatusCode.$dirty && jointHolderForm.taxStatusCode.$invalid }\"><div ng-class=\"{\'anything-disabled\' : holder.nriFlag === false}\"><select class=selectNormal name=taxStatusCode ng-model=holder.taxStatusCode ng-init=\"holder.taxStatusCode = holder.taxStatusCode ? holder.taxStatusCode: null\" ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in taxStatusList[$index]\" ng-change=\"changedTaxStatus($index, holder.taxStatusCode)\" required><option value=\"\" selected>Tax Status</option></select></div><div class=\"col-xs-12 col-md-12\" ng-show=\"jointHolderForm.taxStatusCode.$dirty && jointHolderForm.taxStatusCode.$invalid\"><span class=error-input ng-show=jointHolderForm.taxStatusCode.$error.required ng-bind=validations.TAX_STATUS></span></div><div class=\"col-xs-12 col-md-12 trans-ackn mt-4\" ng-if=taxStatusNote><span class=icon-info-sign style=\"width: 50px\"></span><p>{{taxStatusNote}}</p></div></div></div><div class=col-md-4><p class=titleFatca>Occupation <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.occupation.$dirty && jointHolderForm.occupation.$invalid}\"><select class=selectNormal name=occupation ng-model=holder.occupationCode ng-init=\"holder.occupationCode = holder.occupationCode ? holder.occupationCode: null\" ng-options=\"_type.occupationCode as _type.occupationDescription for _type in occupationList\" ng-change=setOccuValidation() easyassist-key=mask-element required><option value=\"\" selected>Occupation</option></select><span ng-show=\"jointHolderForm.occupation.$dirty && jointHolderForm.occupation.$invalid\"><span class=error-input ng-show=jointHolderForm.occupation.$error.required ng-bind=validations.OCCUPATION></span></span></div></div></div></div><div class=row><div class=\"col-md-6 set-padding-left-0\"><p class=titleFatca style=\"margin-left: 15px\">Income</p><div style=\"width: 260px\" class=slider-parent><div style=\"display: inline-block\"><span ng-click=changeAnnualIncome($index) class=btn-small-shadow ng-class=\"{\'btn-small-shadow-background-blue\' : !holder.showAnnualIncome}\">Annual Gross Income</span></div><div style=\"display: inline-block\"><span ng-click=changeAnnualIncome($index) class=btn-small-shadow ng-class=\"{\'btn-small-shadow-background-blue\' : holder.showAnnualIncome}\">Net Worth</span></div></div></div></div><div class=row><div ng-if=!holder.showAnnualIncome class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Annual Gross Income <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.grossAnnualIncome.$dirty\n                 && jointHolderForm.grossAnnualIncome.$invalid}\"><select class=selectNormal name=grossAnnualIncome ng-click=\"setOptionalEmpty(\'GrossAnnualIncome\')\" ng-model=holder.grossAnnualIncome ng-init=\"holder.grossAnnualIncome = holder.grossAnnualIncome ? holder.grossAnnualIncome: null\" ng-options=\"_type.incomeCode as _type.incomeDescription for _type in incomeSlabList\" ng-required=\"!(holder.netWorth)\n                      &&!(holder.netWorthDate)\" ng-class=\"{\'selectfield-disabled\':holder.netWorth}\" easyassist-key=mask-element><option value=\"\" selected>Select</option></select><span ng-show=\"jointHolderForm.grossAnnualIncome.$dirty && jointHolderForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=jointHolderForm.grossAnnualIncome.$error.required ng-bind=validations.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=jointHolderForm.grossAnnualIncome.$error.number ng-bind=validations.INVALID_AMOUNT></span> </span><span class=highlight></span> <span class=bar></span></div></div></div><div ng-if=holder.showAnnualIncome class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Net worth (in Rs.) <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.netWorth.$dirty\n                 && jointHolderForm.netWorth.$invalid}\"><input style=\"padding-left: 20px\" class=input-field type=text name=netWorth class=pd20 ng-model=holder.netWorthComma ng-required=!holder.grossAnnualIncome ng-maxlength=15 limit-to=15 maxlength=15 ng-disabled=holder.grossAnnualIncome ng-change=netWorthChanges(holder.netWorthComma,$index) ng-keyup=\"NumToWord(holder.netWorth, \'DisplayWordsTaxAmt-\'+$index);\" ng-change=netWorthChanges(holder.netWorthComma) easyassist-key=mask-element placeholder=\"Net worth\"> <span ng-show=\"jointHolderForm.netWorth.$dirty && jointHolderForm.netWorth.$invalid\"><span class=error-input ng-show=jointHolderForm.netWorth.$error.number ng-bind=JointHolders.validations.INVALID_AMOUNT></span> <span class=error-input ng-show=jointHolderForm.netWorth.$error.required ng-bind=JointHolders.validations.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span> <i class=rupee-input-icon></i></div><div class=form-group style=\"margin-top: 25px\"><span id=DisplayWordsTaxAmt-{{$index}}>{{holder.amountInWords}}</span></div></div><div class=col-md-6><p class=titleFatca>As on DD-MMM-YYYY <span class=\"req text-red\">*</span></p><div class=holders-networth-date ng-class=\"{error : holder.netWorth\n                   && !holder.netWorthDate\n                   }\"><input class=input-field type=text name=netWorthDate date-calendar format=DD-MMM-YYYY viewmode=days showdefault=\"{{\'\'+!!holder.netWorthDate}}\" date-default=defaultDob maxdate=now data-min-date=minDate data-on-date-change=changeStartDate autocomplete=off ng-model=holder.netWorthDate ng-required=!holder.grossAnnualIncome ng-disabled=holder.grossAnnualIncome placeholder=\"As on DD-MMM-YYYY\"> <span class=highlight></span> <span class=bar></span> <i class=calendar-input-icon></i> <span ng-show=\"jointHolderForm.netWorthDate.$dirty && jointHolderForm.netWorthDate.$invalid\"><span class=error-input ng-show=jointHolderForm.netWorthDate.$error.required>{{validations.NET_WORTH_DATE}}</span></span></div><span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span></div></div></div></div><div><p style=\"margin-bottom: 0\" class=nomargin><strong>FATCA and CRS information</strong></p><div class=\"row pdt10\"><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Country of Birth <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.birthCountry.$dirty && jointHolderForm.birthCountry.$invalid}\"><select class=selectNormal name=birthCountry ng-model=holder.fatcaDetail.birthCountry ng-init=\"holder.fatcaDetail.birthCountry = holder.fatcaDetail.birthCountry ? holder.fatcaDetail.birthCountry: null\" ng-options=\"country.countryCode as country.countryName for country in countryList\" easyassist-key=mask-element required><option value=\"\" selected>Country of Birth</option></select><span ng-show=\"jointHolderForm.birthCountry.$dirty && jointHolderForm.birthCountry.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry.$error.required>{{validations.COUNTRY}}</span></span></div></div><div class=col-md-6><p class=titleFatca>City of Birth <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.birthPlace.$dirty && jointHolderForm.birthPlace.$invalid}\"><input class=input-field type=text name=birthPlace limit-to=35 maxlength=35 ng-maxlength=35 ng-pattern=/[A-Za-z]+(\\s[A-Za-z]+)?/ ng-model=holder.fatcaDetail.birthPlace easyassist-key=mask-element required placeholder=\"City of Birth\"> <span class=highlight></span> <span class=bar></span> <span ng-show=\"jointHolderForm.birthPlace.$dirty && jointHolderForm.birthPlace.$invalid\"><span class=error-input ng-show=jointHolderForm.birthPlace.$error.required>{{validations.BIRTH_CITY}}</span> </span><span class=error-input ng-show=jointHolderForm.birthPlace.$error.pattern>Invalid City</span></div></div></div></div><div class=\"row pdt10\"><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Address Type <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.addressType.$dirty && jointHolderForm.addressType.$invalid}\"><select class=selectNormal class=\"browser-default custom-select\" name=addressType ng-model=holder.fatcaDetail.addressType ng-init=\"holder.fatcaDetail.addressType = holder.fatcaDetail.addressType ? holder.fatcaDetail.addressType: null\" ng-options=\"_type.value as _type.addressDescription for _type in addressTypeList\" required><option value=\"\" selected>Address Type</option></select><span ng-show=\"jointHolderForm.addressType.$dirty && jointHolderForm.addressType.$invalid\"><span class=error-input ng-show=jointHolderForm.addressType.$error.required ng-bind=validations.ADDRESS_TYPE></span></span></div></div></div></div></div><div><p><strong>Politically Exposed Person (PEP) Status</strong></p><div class=political-exposed-for-holder><span class=radio-block><span class=radio><input type=radio id=politicalStatus1-{{$index}} name=politicalStatus-{{$index}} ng-model=holder.politicalStatus ng-value=POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=politicalStatus1-{{$index}}>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=politicalStatus3-{{$index}} name=politicalStatus-{{$index}} ng-model=holder.politicalStatus ng-value=POLITICAL_STATUS.NONE> <span class=check></span></span><label for=politicalStatus3-{{$index}}>No</label></span><span class=radio-block><span class=radio><input type=radio id=politicalStatus2-{{$index}} name=politicalStatus-{{$index}} ng-model=holder.politicalStatus ng-value=POLITICAL_STATUS.RELATED> <span class=check></span></span><label for=politicalStatus2-{{$index}}>Related to PEP</label></span></div></div><div class=inves-pay><p><strong>Does the investor pay or file tax other than India?</strong></p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia-{{$index}} ng-change=fileTaxActionJointHolder($index) ng-model=holder.fatcaDetail.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo-{{$index}} name=payTaxInIndia-{{$index}} ng-model=holder.fatcaDetail.payTaxInIndia ng-value=true ng-change=\"holder.fatcaDetail.secondTax = holder.fatcaDetail.thirdTax = false;\"><!--ng-change=\"fileTaxActionJointHolder($index)\"--> <span class=check></span></span><label for=payTaxInIndiaNo-{{$index}}>No</label></span><!--First tax--><div ng-if=\"holder.fatcaDetail.payTaxInIndia === false && !isObjectEmpty(holder.fatcaDetail.fatcaTax1)\"><div class=tax-res><p><strong>Tax Residency Country</strong></p><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Selct Country <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.birthCountry1.$dirty && jointHolderForm.birthCountry1.$invalid}\"><select class=selectNormal name=birthCountry1 ng-model=holder.fatcaDetail.fatcaTax1.taxPayingCountry ng-init=\"holder.fatcaDetail.fatcaTax1.taxPayingCountry = holder.fatcaDetail.fatcaTax1.taxPayingCountry ? holder.fatcaDetail.fatcaTax1.taxPayingCountry: null\" ng-options=\"country.countryName as country.countryName for country in countryList|removeCountry:\'india\'\" ng-required=\"holder.fatcaDetail.fatcaTax1.taxPayingCountry|| holder.fatcaDetail.payTaxInIndia==false\" ng-change=\"holder.fatcaDetail.fatcaTax1.taxPayingCountry?\'\':holder.fatcaDetail.fatcaTax1=\'\'\" easyassist-key=mask-element required><option value=\"\" selected>Select Country</option></select><span ng-show=\"jointHolderForm.birthCountry1.$dirty && jointHolderForm.birthCountry1.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry1.$error.required>{{validations.COUNTRY}}</span></span></div></div><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><p class=titleFatca>Select Tax ID type <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.taxIdType1.$dirty && jointHolderForm.taxIdType1.$invalid}\"><select class=selectNormal name=taxIdType-$index ng-model=holder.fatcaDetail.fatcaTax1.taxIdType ng-init=\"holder.fatcaDetail.fatcaTax1.taxIdType = holder.fatcaDetail.fatcaTax1.taxIdType ? holder.fatcaDetail.fatcaTax1.taxIdType: null\" ng-options=\"taxid.description as taxid.description for taxid in taxIdTypeList\" ng-required=holder.fatcaDetail.fatcaTax1.taxPayingCountry easyassist-key=mask-element required><option value=\"\" selected>Select Tax ID type</option></select><!--                                 <span class=\" req text-red\" ng-if=\"holder.fatcaDetail.fatcaTax1.taxPayingCountry\">*</span>--> <span ng-show=\"jointHolderForm.taxIdType1.$dirty && jointHolderForm.taxIdType1.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType1.$error.required>{{validations.TAX_ID_TYPE}}</span></span></div></div></div></div><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><p class=titleFatca>City <span class=\"req text-red\">*</span></p><div><input class=input-field type=text name=taxIdNumber1 ng-model=holder.fatcaDetail.fatcaTax1.taxPayingCity ng-required=holder.fatcaDetail.fatcaTax1.taxPayingCountry ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element ng-pattern=/^[a-zA-Z\\s]*$/ capitalize placeholder=City> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"jointHolderForm.taxIdNumber1.$error.required && jointHolderForm.taxIdNumber1.$dirty\">{{validations.CITY}}</span> <span class=error-input ng-show=jointHolderForm.taxIdNumber1.$error.pattern>Invalid City</span></div></div><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><p class=titleFatca>Tax ID number <span class=\"req text-red\">*</span></p><div><input class=input-field type=text name=taxIdNumber3 ng-model=holder.fatcaDetail.fatcaTax1.taxId ng-required=holder.fatcaDetail.fatcaTax1.taxPayingCountry ng-maxlength=20 limit-to=20 maxlength=20 easyassist-key=mask-element capitalize placeholder=\"Tax ID number\"> <span class=highlight></span> <span class=bar></span></div></div></div></div></div><div class=\"add-another-tax-res tax-res\" ng-if=!holder.fatcaDetail.secondTax><a href=\"\" class=text-blue ng-click=\"holder.fatcaDetail.secondTax = true\"><strong class=\"btn-add-nominee btn-residency\"><i class=expand-icon></i> <span>Add another tax residency country</span></strong></a></div></div><!--Second tax--><div ng-if=\"holder.fatcaDetail.payTaxInIndia === false && !isObjectEmpty(holder.fatcaDetail.fatcaTax2) && holder.fatcaDetail.secondTax\"><div class=tax-res><p><strong>Tax Residency Country <span class=remove-item ng-click=deleteSecond(holder.fatcaDetail)><i class=delete-red-icon></i></span></strong></p><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax1.taxPayingCountry}\"><p class=titleFatca>Select Country <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.birthCountry2.$dirty && jointHolderForm.birthCountry2.$invalid}\"><select class=selectNormal name=birthCountry2 ng-model=holder.fatcaDetail.fatcaTax2.taxPayingCountry ng-init=\"holder.fatcaDetail.fatcaTax2.taxPayingCountry = holder.fatcaDetail.fatcaTax2.taxPayingCountry ? holder.fatcaDetail.fatcaTax2.taxPayingCountry: null\" ng-options=\"country.countryName as country.countryName for country in countryList|removeCountry:\'india\'\" ng-required=holder.fatcaDetail.fatcaTax2.taxPayingCountry ng-change=\"holder.fatcaDetail.fatcaTax2.taxPayingCountry?\'\':holder.fatcaDetail.fatcaTax2=\'\'\" easyassist-key=mask-element><option value=\"\" selected>Select Country</option></select><!--                                 <span class=\" req text-red\" ng-if=\"holder.fatcaDetail.fatcaTax2.taxPayingCountry\">*</span>--> <span ng-show=\"jointHolderForm.birthCountry2.$dirty && jointHolderForm.birthCountry2.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry2.$error.required>{{validations.COUNTRY}}</span></span></div></div><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><p class=titleFatca>Select Tax ID type <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.taxIdType2.$dirty && jointHolderForm.taxIdType2.$invalid}\"><select class=selectNormal name=taxIdType-$index ng-model=holder.fatcaDetail.fatcaTax2.taxIdType ng-init=\"holder.fatcaDetail.fatcaTax2.taxIdType = holder.fatcaDetail.fatcaTax2.taxIdType ? holder.fatcaDetail.fatcaTax2.taxIdType: null\" ng-options=\"taxid.description as taxid.description for taxid in taxIdTypeList\" ng-required=holder.fatcaDetail.fatcaTax2.taxPayingCountry easyassist-key=mask-element><option value=\"\" selected>Select Tax ID type</option></select><!--                                 <span class=\" req text-red\" ng-if=\"holder.fatcaDetail.fatcaTax2.taxPayingCountry\">*</span>--> <span ng-show=\"jointHolderForm.taxIdType2.$dirty && jointHolderForm.taxIdType2.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType2.$error.required>{{validations.TAX_ID_TYPE}}</span></span></div></div></div></div><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><p class=titleFatca>City <span class=\"req text-red\">*</span></p><div><input class=input-field type=text name=taxIdNumber2 ng-model=holder.fatcaDetail.fatcaTax2.taxPayingCity ng-required=holder.fatcaDetail.fatcaTax2.taxPayingCountry ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element ng-pattern=/^[a-zA-Z\\s]*$/ capitalize placeholder=City> <span class=highlight></span> <span class=bar></span><!--                                 <label>City<span class=\"req text-red\" ng-if=\"holder.fatcaDetail.fatcaTax2.taxPayingCountry\">*</span></label>--> <span class=error-input ng-show=\"jointHolderForm.taxIdNumber2.$error.required && jointHolderForm.taxIdNumber2.$dirty\">{{validations.CITY}}</span> <span class=error-input ng-show=jointHolderForm.taxIdNumber2.$error.pattern>Invalid City</span></div></div><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><p class=titleFatca>Tax ID number <span class=\"req text-red\">*</span></p><div><input class=input-field type=text name=taxIdNumber3 ng-model=holder.fatcaDetail.fatcaTax2.taxId ng-required=holder.fatcaDetail.fatcaTax2.taxPayingCountry ng-maxlength=20 limit-to=20 maxlength=20 easyassist-key=mask-element capitalize placeholder=\"Tax ID number\"> <span class=highlight></span> <span class=bar></span><!--                                 <label>Tax ID number<span class=\"req text-red\" ng-if=\"holder.fatcaDetail.fatcaTax2.taxPayingCountry\">*</span></label>--></div></div></div></div></div><div class=\"add-another-tax-res tax-res\" ng-if=!holder.fatcaDetail.thirdTax><a href=\"\" class=text-blue ng-click=\"holder.fatcaDetail.thirdTax = true;\"><strong class=\"btn-add-nominee btn-residency\"><i class=expand-icon></i> <span>Add another tax residency country</span></strong></a></div></div><!--Third tax--><div ng-if=\"holder.fatcaDetail.payTaxInIndia === false && !isObjectEmpty(holder.fatcaDetail.fatcaTax3) && holder.fatcaDetail.thirdTax\"><div class=tax-res><p><strong>Tax Residency Country <span class=remove-item ng-click=deleteThird(holder.fatcaDetail)><i class=delete-red-icon></i></span></strong></p><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><p class=titleFatca>Select Country <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.birthCountry3.$dirty && jointHolderForm.birthCountry3.$invalid}\"><select class=selectNormal name=birthCountry3 ng-model=holder.fatcaDetail.fatcaTax3.taxPayingCountry ng-init=\"holder.fatcaDetail.fatcaTax3.taxPayingCountry = holder.fatcaDetail.fatcaTax3.taxPayingCountry ? holder.fatcaDetail.fatcaTax3.taxPayingCountry: null\" ng-options=\"country.countryName as country.countryName for country in countryList|removeCountry:\'india\'\" ng-required=holder.fatcaDetail.fatcaTax3.taxPayingCountry ng-change=\"holder.fatcaDetail.fatcaTax3.taxPayingCountry?\'\':holder.fatcaDetail.fatcaTax3=\'\'\" easyassist-key=mask-element><option value=\"\" selected>Select Country</option></select><!--                                 <span class=\" req text-red\" ng-if=\"holder.fatcaDetail.fatcaTax3.taxPayingCountry\">*</span>--> <span ng-show=\"jointHolderForm.birthCountry3.$dirty && jointHolderForm.birthCountry3.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry3.$error.required>{{validations.COUNTRY}}</span></span></div></div><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax2.taxPayingCountry}\"><!----><p class=titleFatca>Select Tax ID type <span class=\"req text-red\">*</span></p><div ng-class=\"{error:jointHolderForm.taxIdType3.$dirty && jointHolderForm.taxIdType3.$invalid}\"><select class=selectNormal name=taxIdType3 ng-model=holder.fatcaDetail.fatcaTax3.taxIdType ng-init=\"holder.fatcaDetail.fatcaTax3.taxIdType = holder.fatcaDetail.fatcaTax3.taxIdType ? holder.fatcaDetail.fatcaTax3.taxIdType: null\" ng-options=\"taxid.description as taxid.description for taxid in taxIdTypeList\" ng-required=holder.fatcaDetail.fatcaTax3.taxPayingCountry easyassist-key=mask-element><option value=\"\" selected>Select Tax ID type</option></select><!--                                 <span class=\" req text-red\" ng-if=\"holder.fatcaDetail.fatcaTax3.taxPayingCountry\">*</span>--> <span ng-show=\"jointHolderForm.taxIdType3.$dirty && jointHolderForm.taxIdType3.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType3.$error.required>{{validations.TAX_ID_TYPE}}</span></span></div></div></div></div><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax3.taxPayingCountry}\"><p class=titleFatca>City <span class=\"req text-red\">*</span></p><div><input class=input-field type=text name=taxPayingCity3 ng-model=holder.fatcaDetail.fatcaTax3.taxPayingCity ng-required=holder.fatcaDetail.fatcaTax3.taxPayingCountry ng-maxlength=35 limit-to=35 maxlength=35 easyassist-key=mask-element ng-pattern=/^[a-zA-Z\\s]*$/ capitalize placeholder=City> <span class=highlight></span> <span class=bar></span><!--                               <label>City<span class=\"req text-red\" ng-if=\"holder.fatcaDetail.fatcaTax3.taxPayingCountry\">*</span></label></label>--> <span class=error-input ng-show=\"jointHolderForm.taxPayingCity3.$error.required && jointHolderForm.taxPayingCity3.$dirty\">{{validations.CITY}}</span> <span class=error-input ng-show=jointHolderForm.taxPayingCity3.$error.pattern>Invalid City</span></div></div><div class=col-md-6 ng-class=\"{\'anything-disabled\':!holder.fatcaDetail.fatcaTax3.taxPayingCountry}\"><p class=titleFatca>Tax ID number <span class=\"req text-red\">*</span></p><div><input class=input-field type=text name=taxIdNumber3 ng-model=holder.fatcaDetail.fatcaTax3.taxId ng-required=holder.fatcaDetail.fatcaTax3.taxPayingCountry ng-maxlength=20 limit-to=20 maxlength=20 easyassist-key=mask-element capitalize placeholder=\"Tax ID number\"> <span class=highlight></span> <span class=bar></span><!--                               <label>Tax ID number<span class=\"req text-red\" ng-if=\"holder.fatcaDetail.fatcaTax3.taxPayingCountry\">*</span></label></label>--></div></div></div></div></div></div></div></div></div></div></div></div><div class=add-another-nominee style=\"margin-top: 40px; width: fit-content\" ng-click=addMoreJointHolder() ng-if=\"jointHoldersPayload.jointHolders.length<2\"><a href=\"\" class=\"text-blue btn-add-nominee\"><strong><i class=plus-icon></i>Add Another Holder</strong></a></div></div><div class=proceed><button ng-disabled=\"jointHolderForm.$invalid || notValid2ndHolder\" class=proceed-btn ng-click=continue()>Next</button></div><!--       <div ng-if=\"jointHolderForm.$valid && !notValid2ndHolder\" ng-init=\"formIsvalid()\"></div>--><!--       <div ng-if=\"jointHolderForm.$invalid || notValid2ndHolder\" ng-init=\"formIsinvalid()\"></div>--></form></div><style>div#investors span.radio-block label {\n       display: block;\n       margin-top: -19px;\n       margin-left: 30px;\n     }\n\n     div#add-joint-holder p.pdt10 {\n       margin-top: 12px;\n       margin-bottom: 1px;\n     }\n\n     div#tab-container.tab-container ul.mobile-hide.nav.nav-tabs {\n       margin-bottom: 20px;\n     }\n\n     div.input-normal.cityBirth {\n       margin-top: 13px;\n     }</style></div><!--  showing review screen--><div ng-if=\"hideVerifyPanField && !editHolder\"><div class=box-body ng-repeat=\"holder in reviewData\"><div class=\"box-details clearfix set-margin-top-20\"><!--{{holder|json}}--><div style=\"padding-left: 8px\" class=col-md-12><strong>Holders Name:</strong> {{holder.jointHolderName}}</div></div><div class=\"box-details clearfix\"><div style=\"padding-left: 8px\" class=\"col-md-4 bordered\"><h5 class=\"text-blue set-header-margin-top-bottom\">Income Details</h5><table class=\"table borderless\"><tr><td class=t-status><span class=span-review-width><strong>Tax Status:</strong></span> &nbsp;<!--<strong>{{// reviewModalData.holders[$index].taxStatusDescription}}</strong>--></td><td><span class=tax-status-holder>{{holder.taxStatusDescription}}</span></td></tr><tr><td><span class=span-review-width><strong>Occupation:</strong></span> &nbsp;<!--              <strong>{{reviewModalData.holders[$index].occupationDescription}}</strong>--></td><td><span easyassist-key=mask-element>{{holder.occupationDescription }}</span></td></tr><tr ng-if=holder.grossAnnualIncome><td><span class=span-review-width><strong>Annual Gross Income:</strong></span> &nbsp;</td><td><span easyassist-key=mask-element>{{holder.incomeDescription}}</span></td></tr><tr ng-if=holder.netWorth><td><span class=span-review-width><strong>Net Worth:</strong></span></td><td><i class=rupee-small-icon></i> <span easyassist-key=mask-element>{{holder.netWorth}}</span></td></tr><tr><td class=pdt20><span class=span-review-width><strong>Political Exposed Person Status:</strong></span> &nbsp;</td><td><span ng-if=\"holder.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.POLITICAL\">Investor is politically exposed person </span><span ng-if=\"holder.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.RELATED\">Investor is related to politically exposed person </span><span ng-if=\"holder.politicalStatus===pattern.INVESTOR_POLITICAL_STATUS.NONE\">No</span></td></tr></table></div><div style=\"padding-left: 8px\" class=\"col-md-4 bordered\"><h5 class=\"text-blue set-header-margin-top-bottom\">FATCA &amp; CSR information</h5><table class=\"table borderless\"><tr><td><span class=span-review-width><strong>Country of Birth: </strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.birthCountryDescription}}</span></td></tr><tr><td><span class=span-review-width><strong>City of Birth:</strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.birthPlace}}</span></td></tr><tr><td><span class=span-review-width><strong>Address Type:</strong></span></td><td><span>{{holder.fatcaDetail.addressTypeDescription}}</span></td></tr></table></div><div style=\"padding-left: 8px\" class=\"col-md-4 holderReviewTable\"><h5 class=\"text-blue set-header-margin-top-bottom\">Tax Details</h5><table class=table ng-if=\"\n            holder.fatcaDetail.fatcaTax1 && !holder.fatcaDetail.payTaxInIndia\"><tr><td><span class=span-review-width><strong>Name of Country1: </strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxPayingCountry}}</span></td></tr><tr><td><span class=span-review-width><strong>Name of City1: </strong></span><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxPayingCity}}</span></td></tr><tr><td><span class=span-review-width><strong>Tax ID Type1:</strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxIdType}}</span></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax1.taxId><td><span class=span-review-width><strong>Tax ID Number1:</strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax1.taxId}}</span></td></tr></table><table class=table ng-if=\"holder.fatcaDetail.fatcaTax2 && !holder.fatcaDetail.payTaxInIndia\"><tr ng-if=\"holder.fatcaDetail.fatcaTax2.taxPayingCountry !== \'\'\"><td><span class=span-review-width><strong>Name of Country2: </strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxPayingCountry}}</span></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax2.taxPayingCity><td><span class=span-review-width><strong>Name of City2: </strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxPayingCity}}</span></td></tr><tr ng-if=\"holder.fatcaDetail.fatcaTax2.taxIdType !== \'\'\"><td><span class=span-review-width><strong>Tax ID Type2:</strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxIdType}}</span></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax2.taxId><td><span class=span-review-width><strong>Tax ID Number2:</strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax2.taxId}}</span></td></tr></table><table class=table ng-if=\"holder.fatcaDetail.fatcaTax3 && !holder.fatcaDetail.payTaxInIndia\"><tr ng-if=\"holder.fatcaDetail.fatcaTax3.taxPayingCountry !== \'\'\"><td><span class=span-review-width><strong>Name of Country3: </strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxPayingCountry}}</span></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax3.taxPayingCity><td><span class=span-review-width><strong>Name of City3: </strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxPayingCity}}</span></td></tr><tr ng-if=\"holder.fatcaDetail.fatcaTax3.taxIdType !== \'\'\"><td><span class=span-review-width><strong>Tax ID Type3:</strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxIdType}}</span></td></tr><tr ng-if=holder.fatcaDetail.fatcaTax3.taxId><td><span class=span-review-width><strong>Tax ID Number3:</strong></span></td><td><span easyassist-key=mask-element>{{holder.fatcaDetail.fatcaTax3.taxId}}</span></td></tr></table><table ng-if=\"\n            holder.fatcaDetail.payTaxInIndia ||\n            (holder.fatcaDetail.fatcaTax1==undefined)\n            &&(holder.fatcaDetail.fatcaTax2==undefined)\n            &&(holder.fatcaDetail.fatcaTax3==undefined)\"><tr><td><span class=span-review-width><strong>Tax Details Not Available</strong></span></td></tr></table></div></div></div></div></div><style>a {\n    text-decoration: underline !important;\n    color: #103880;\n  }</style>");
$templateCache.put("app/investment-baskets/investment-basket-directives/folio/income-details/income-details.directive.html","<div class=incomeDetailsForSelfAnyone ng-if=\"editIncomeDetail && receivedData.folioForUser === \'Self\'\"><div class=\"row pd20 incomeDetails\"><form id=folioIncomeFormData name=folioIncomeFormData ng-submit=submitFolioIncomeForm()><!--<p class=\"contactDetails\">Contact Details(Please submit physical request to update contact details in your KYC)</p>--><div class=contactDetails ng-if=\"!soleApplicantEmail && !soleApplicantMobile\"><span class=warning style=\"justify-content: center;padding: 10px\">{{CONST_DATA.UPDATE_CONTANCT_BOTH_MISSING}}</span></div><div class=contactDetails ng-if=\"(!soleApplicantEmail && soleApplicantMobile) || (soleApplicantEmail && !soleApplicantMobile)\"><span class=warning style=\"justify-content: center;padding: 10px\">{{CONST_DATA.UPDATE_CONTACT_SINGLE_MISSING}}</span></div><div class=row><div class=col-md-6><div class=\"emailAndMobile contact-label\"><table><tbody><tr><td style=\"padding: 0px !important\"><span><strong>Email Id <span class=\"req text-red\">*</span></strong></span> :</td><td ng-if=!showEmailEditField><span ng-if=\"soleApplicantEmail && !showEmailEditField\">{{soleApplicantEmail}}</span> <span ng-if=\"!soleApplicantEmail && !showEmailEditField\">Not Updated</span> <span class=edit-icon ng-if=\"soleApplicantMobile && !showEmailEditField && !showMobileEditField\" ng-click=\"editContactDetails(\'email\')\"></span></td><td><div class=edit-fields><input class=input-field type=text name=email ng-model=soleApplicantEditedEmail placeholder=\"Email Id\" ng-change=\"changeValue(\'email\', soleApplicantEditedEmail)\" ng-if=showEmailEditField ng-pattern=CONST_DATA.email_regex required> <span ng-if=showEmailEditField class=edit-actions><button type=button class=\"btn-small btn-primary-action\" ng-disabled=\"folioIncomeFormData.email.$pristine || folioIncomeFormData.email.$error.pattern || folioIncomeFormData.email.$error.required\" ng-click=\"generateContactUpdateOtp(\'email\')\">Send OTP</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"cancelEditAction(\'email\');\">Cancel</button></span></div><span ng-show=\"folioIncomeFormData.email.$dirty && folioIncomeFormData.email.$invalid\"><span class=error-input ng-bind=validateData.EMAIL_FIELD></span></span></td></tr></tbody></table></div></div><div class=\"col-md-6 visible-xs visible-sm\"><div class=\"emailAndMobile belongsTo\" ng-if=soleApplicantEmail><p><strong>Email Id Belongs To <span class=\"req text-red\">*</span></strong></p><p>:</p><div ng-class=\"{error:folioIncomeFormData.emailBelongsTo.$dirty && folioIncomeFormData.emailBelongsTo.$invalid}\" style=\"width: 235px\"><select id=emailBelongsTo class=selectNormal name=emailBelongsTo ng-model=holders.emailBelongsTo required><option value selected>Select Value</option><option ng-repeat=\"value in belongToListEmail\" ng-selected=\"holders.emailBelongsTo == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"folioIncomeFormData.emailBelongsTo.$dirty \"><span class=error-input ng-show=folioIncomeFormData.emailBelongsTo.$error.required>Please select option</span></span></div></div></div><div class=col-md-6><div class=\"emailAndMobile contact-label\"><table><tbody><tr><td style=\"padding: 0px !important\"><span><strong>Mobile No. <span class=\"req text-red\">*</span></strong></span> :</td><td ng-if=!showMobileEditField><span ng-if=\"soleApplicantMobile && !showMobileEditField\">{{soleApplicantMobile}}</span> <span ng-if=\"!soleApplicantMobile && !showMobileEditField\">Not Updated</span> <span class=edit-icon ng-if=\"soleApplicantEmail && !showMobileEditField && !showEmailEditField\" ng-click=\"editContactDetails(\'mobile\');\"></span></td><td><div class=edit-fields><div ng-class=\"{error:folioIncomeFormData.mobileNumber.$dirty && folioIncomeFormData.mobileNumber.$invalid}\"><input class=input-field type=text name=mobileNumber ng-model=soleApplicantEditedMobile ng-change=\"changeValue(\'mobile\', soleApplicantEditedMobile)\" placeholder=\"Mobile Number\" maxlength=13 ng-if=showMobileEditField ng-pattern=CONST_DATA.mobile_regex required></div><span ng-if=showMobileEditField class=edit-actions><button type=button class=\"btn-small btn-primary-action\" ng-disabled=\"folioIncomeFormData.mobileNumber.$pristine || folioIncomeFormData.mobileNumber.$error.pattern || folioIncomeFormData.mobileNumber.$error.required\" ng-click=\"generateContactUpdateOtp(\'mobile\')\">Send OTP</button> <button type=button class=\"btn-small btn-secondary-action\" ng-click=\"cancelEditAction(\'mobile\');\">Cancel</button></span></div><span ng-show=\"folioIncomeFormData.mobileNumber.$dirty && folioIncomeFormData.mobileNumber.$invalid && folioIncomeFormData.mobileNumber.$error.pattern\"><span class=error-input ng-bind=validateData.MOBILE_ISD></span></span></td></tr></tbody></table></div></div><div class=\"col-md-6 visible-xs visible-sm\"><div class=\"emailAndMobile belongsTo\" ng-if=soleApplicantMobile><p><strong>Mobile No. Belongs To <span class=\"req text-red\">*</span></strong></p><p>:</p><div ng-class=\"{error:folioIncomeFormData.mobileBelongsTo.$dirty && folioIncomeFormData.mobileBelongsTo.$invalid}\" style=\"width: 235px\"><select class=selectNormal id=mobileBelongsTo name=mobileBelongsTo ng-model=holders.mobileBelongsTo ng-init=\"holders.mobileBelongsTo = holders.mobileBelongsTo ? holders.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in belongToListMobile\" ng-selected=\"holders.mobileBelongsTo == data.familyCode\" required><option value=\"\" selected>Select Value</option></select><span ng-show=\"folioIncomeFormData.mobileBelongsTo.$dirty &&  folioIncomeFormData.mobileBelongsTo.$invalid\"><span class=error-input ng-show=folioIncomeFormData.mobileBelongsTo.$error.required>Please select option</span></span></div></div></div></div><div class=row ng-if=\"soleApplicantEmail || soleApplicantMobile\"><div class=\"col-md-6 hidden-xs hidden-sm\"><div class=\"emailAndMobile belongsTo\" ng-if=soleApplicantEmail><p><strong>Email Id Belongs To <span class=\"req text-red\">*</span></strong></p><p>:</p><div ng-class=\"{error:folioIncomeFormData.emailBelongsTo.$dirty && folioIncomeFormData.emailBelongsTo.$invalid}\" style=\"width: 235px\"><select id=emailBelongsTo class=selectNormal name=emailBelongsTo ng-model=holders.emailBelongsTo required><option value selected>Select Value</option><option ng-repeat=\"value in belongToListEmail\" ng-selected=\"holders.emailBelongsTo == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"folioIncomeFormData.emailBelongsTo.$dirty \"><span class=error-input ng-show=folioIncomeFormData.emailBelongsTo.$error.required>Please select option</span></span></div></div></div><div class=\"col-md-6 hidden-xs hidden-sm\"><div class=\"emailAndMobile belongsTo\" ng-if=soleApplicantMobile><p><strong>Mobile No. Belongs To <span class=\"req text-red\">*</span></strong></p><p>:</p><div ng-class=\"{error:folioIncomeFormData.mobileBelongsTo.$dirty && folioIncomeFormData.mobileBelongsTo.$invalid}\" style=\"width: 235px\"><select class=selectNormal id=mobileBelongsTo name=mobileBelongsTo ng-model=holders.mobileBelongsTo ng-init=\"holders.mobileBelongsTo = holders.mobileBelongsTo ? holders.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in belongToListMobile\" ng-selected=\"holders.mobileBelongsTo == data.familyCode\" required><option value=\"\" selected>Select Value</option></select><span ng-show=\"folioIncomeFormData.mobileBelongsTo.$dirty &&  folioIncomeFormData.mobileBelongsTo.$invalid\"><span class=error-input ng-show=folioIncomeFormData.mobileBelongsTo.$error.required>Please select option</span></span></div></div></div></div><div class=\"row removePad\"><div class=col-md-6><div class=row><div class=col-md-6><label class=titleFatca for=\"\">Tax Status <span class=\"req text-red\">*</span></label><div><div ng-class=\"{\'anything-disabled\' : folioIncomeForm.nriFlag === false}\"><select class=selectNormal id=taxstatus name=taxstatus ng-model=folioIncomeForm.taxstatus ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in taxStatusData\" ng-change=taxStatusChanged() required><option value=\"\" selected>Tax Status</option></select></div><span ng-show=\"folioIncomeFormData.taxstatus.$dirty && !folioIncomeForm.taxstatus\"><span class=error-input ng-show=folioIncomeFormData.taxstatus.$error.required ng-bind=validateData.TAX_STATUS></span></span></div></div></div><div class=row><div class=col-md-6><label class=titleFatca for=\"\">Occupation <span class=\"req text-red\">*</span></label><div><select class=selectNormal id=occupation name=occupation ng-model=folioIncomeForm.occupation required><option value selected>Select</option><option ng-repeat=\"value in investorOccupations\" ng-selected=\"folioIncomeForm.occupation == value.occupationCode\" value={{value.occupationCode}}>{{value.occupationDescription}}</option></select><span ng-show=\"folioIncomeFormData.occupation.$dirty && !folioIncomeForm.occupation\"><span class=error-input ng-show=folioIncomeFormData.occupation.$error.required ng-bind=validateData.OCCUPATION></span></span></div></div></div></div><div class=col-md-6><div class=income-tab style=\"padding-bottom: 15px\"><div class=income-tab1><p class=titleFatca>Income <span class=\"req text-red\">*</span></p></div><div class=income-tab2 ng-click=incomeActiveTab(incomeTab[0]) ng-class=\"{\'income-active-tab\':annualTab}\"><div>Annual Gross Income</div></div><div class=income-tab3 ng-click=incomeActiveTab(incomeTab[1]) ng-class=\"{\'income-active-tab\':netWorthTab}\"><div>Net Worth</div></div></div><div class=row ng-if=annualTab><div class=col-md-6><div><select class=selectNormal class=selectNormal id=annualincome name=annualincome ng-model=folioIncomeForm.annualincome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in incomeSlabList\" ng-init=\"folioIncomeForm.annualincome = folioIncomeForm.annualincome ? folioIncomeForm.annualincome : null\" required><option value selected>Select</option></select><span ng-show=\"folioIncomeFormData.annualincome.$dirty && !folioIncomeForm.grossAnnualIncome\"><span class=error-input ng-show=folioIncomeFormData.annualincome.$error.required ng-bind=validateData.GROSS_ANNUAL_INCOME></span></span></div></div></div><div class=row ng-if=netWorthTab><div class=col-md-6><div><input type=text class=input-field id=annualincome1 style=\"padding-left: 20px\" name=annualincome1 placeholder=\"Net worth\" ng-model=folioIncomeForm.networthComma onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-change=netWorthChanges(folioIncomeForm.networthComma) ng-maxlength=15 limit-to=15 maxlength=15 autofocus required> <span ng-show=\"folioIncomeFormData.annualincome1.$dirty && !folioIncomeForm.networth\"><div class=error-input ng-show=folioIncomeFormData.annualincome1.$error.required ng-bind=validateData.NET_WORTH></div></span><i class=\"rupee-input-icon rupee-icon-genric\"></i></div><div class=set-margin-top-20><span id=divDisplayWords>{{amountInWords}}</span></div></div></div><div class=\"row removePad\" ng-if=netWorthTab><div class=col-md-6><div class=\"input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{viewMode}} data-date-default=folioIncomeForm.grossAnnualIncomeDate data-on-date-change=getGrossAnnualIncomeDate maxdate=now format=DD-MMM-YYYY id=endDate><input class=input-field tabindex=2 id=grossAnnualIncomeDateId ng-keyup=autoDate() name=grossAnnualIncomeDate type=text autocomplete=off placeholder=\"As on DD-MMM-YYYY\" required> <span class=input-group-addon><span class=glyphicon-calendar-blue></span></span><div class=set-margin-top-20><span>(Not older than 1 year)</span></div><br><span class=error-input ng-if=dateErrorMessage ng-bind=dateErrorMessage></span></div></div></div></div></div><div class=row><div class=col-md-3><div style=\"margin-bottom: 15px\"><p style=\"font-size: 14px\"><strong>FATCA & CRS related question.</strong></p></div><label class=titleFatca for=\"\">Select Country <span class=\"req text-red\">*</span></label><div><select class=selectNormal id=country name=country ng-model=folioIncomeForm.Fatca.countrie><!-- <option value selected=\"selected\">Select</option> --><option ng-repeat=\"value in countries\" ng-selected=\"folioIncomeForm.Fatca.countrie == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select></div></div><div class=\"col-md-6 hide-in-mobile\"><div class=\"note-banner col-xs-12 noterelativepostion\"><div class=warning><img src=../../../assets/images/icons/light-bulb.png><div class=wardiv>FATCA (Foreign Account tax Compliance Act) & CRS (Common Reporting Standard) declaration was prepared by finacial institutions company with the Central Board of Direct taxes (CBDT) rules.</div></div></div></div></div><div class=row><div class=col-md-3><label class=titleFatca for=\"\">Address type <span class=\"req text-red\">*</span></label><div><select class=selectNormal class=selectNormal id=addressType name=addressType ng-model=folioIncomeForm.Fatca.addressType><!-- <option value selected=\"selected\">Select</option> --><option ng-repeat=\"x in addressType\" ng-selected=\"folioIncomeForm.Fatca.addressType == x.value\" value={{x.value}}>{{x.addressDescription}}</option></select><span ng-show=\"folioIncomeForm.addressType.$dirty && !folioIncomeForm.Fatca.addressType\"><span class=error-input ng-show=folioIncomeForm.addressType.$error.required ng-bind=validateData.FATCA_ADDRESS_TYPE_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-3><label class=titleFatca for=\"\">City <span class=\"req text-red\">*</span></label><div><input class=input-field type=text id=City name=City ng-maxlength=35 limit-to=35 maxlength=35 ng-model=folioIncomeForm.Fatca.city ng-pattern=/[A-Za-z]+(\\s[A-Za-z]+)?/ required placeholder=City> <span ng-show=\"folioIncomeFormData.City.$dirty && folioIncomeFormData.City.$invalid\"><span class=error-input ng-show=folioIncomeFormData.City.$error.required ng-bind=validateData.CITY></span> <span class=error-input ng-show=folioIncomeFormData.City.$error.pattern>Invalid City</span></span></div></div></div><!--    <div class=\"btn-div-wrapper\">--><!--      <button--><!--        class=\"btn btn-primary-action\"--><!--        type=\"submit\"--><!--        ng-disabled=\"folioIncomeFormData.$error.required\">CONTINUE</button>--><!--    </div>--><div class=\"proceed pd-right12\"><button class=proceed-btn type=submit ng-disabled=\"folioIncomeFormData.$invalid || !soleApplicantEmail || !soleApplicantMobile\">Next</button></div><!--    <div ng-if=\"!folioIncomeFormData.$invalid\" ng-init=\"formIsvalid()\"></div>--><!--    <div ng-if=\"folioIncomeFormData.$invalid\" ng-init=\"formIsinvalid()\"></div>--></form></div></div><!--Review of self or AnyOrSurvivor--><div ng-if=\"!editIncomeDetail && receivedData.folioForUser === \'Self\'\"><div class=\"box-body set-margin-top-20\"><div class=\"box-details clearfix\"><div class=row><div class=\"col-sm-12 col-md-6\"><table class=\"table borderless\"><tbody><tr ng-if=soleApplicantEmail><td><span class=span-review-width><strong>Email Id:</strong></span></td><td><span easyassist-key=mask-element>{{soleApplicantEmail || \'Not Updated\'}}</span></td></tr><tr ng-if=soleApplicantMobile><td><span class=span-review-width><strong>Mobile Number:</strong></span></td><td><span easyassist-key=mask-element>{{soleApplicantMobile || \'Not Updated\'}}</span></td></tr><tr ng-if=taxStatusName><td><span class=span-review-width><strong>Tax Status:</strong></span></td><td><span easyassist-key=mask-element>{{taxStatusName}}</span></td></tr><tr ng-if=folioIncomeForm.annualincome><td><span class=span-review-width><strong>Annual Gross Income:</strong></span></td><td><span easyassist-key=mask-element>{{grossAnnualincome }}</span></td></tr><tr ng-if=folioIncomeForm.networth><td><span class=span-review-width><strong>Net Worth:</strong></span></td><td><span easyassist-key=mask-element>{{folioIncomeForm.networth}}</span></td></tr><tr ng-if=folioIncomeForm.grossAnnualIncomeDate><td><span class=span-review-width><strong>Gross Annual Income Date:</strong></span></td><td><span easyassist-key=mask-element>{{folioIncomeForm.grossAnnualIncomeDate}}</span></td></tr><tr ng-if=folioIncomeForm.Fatca.addressType><td><span class=span-review-width><strong>Address type:</strong></span></td><td><span easyassist-key=mask-element>{{folioIncomeForm.Fatca.addressType | camelcase}}</span></td></tr></tbody></table></div><div class=\"col-sm-12 col-md-6\"><table class=\"table borderless\"><tbody><tr ng-if=\"soleApplicantEmail && holders.emailBelongsTo\"><td><span class=span-review-width><strong>Email Belongs To:</strong></span></td><td><span easyassist-key=mask-element>{{belongToEmail}}</span></td></tr><tr ng-if=\"soleApplicantMobile && holders.mobileBelongsTo\"><td><span class=span-review-width><strong>Mobile Belongs To:</strong></span></td><td><span easyassist-key=mask-element>{{belongToMobile}}</span></td></tr><tr ng-if=occupation><td><span class=span-review-width><strong>Occupation:</strong></span></td><td><span easyassist-key=mask-element>{{occupation | camelcase}}</span></td></tr><tr ng-if=folioIncomeForm.networth><td><span class=span-review-width><strong>Net Worth:</strong></span></td><td><span easyassist-key=mask-element>{{folioIncomeForm.networth}}</span></td></tr><tr ng-if=countryName.countryName><td><span class=span-review-width><strong>Country:</strong></span></td><td><span easyassist-key=mask-element>{{countryName.countryName | camelcase }}</span></td></tr><tr ng-if=folioIncomeForm.Fatca.city><td><span class=span-review-width><strong>City:</strong></span></td><td><span easyassist-key=mask-element>{{folioIncomeForm.Fatca.city}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/investment-baskets/investment-basket-directives/folio/nominee/nominee.directive.html","<div ng-show=editNominee class=\"investors nominee-data\"><form autocomplete=off class=nominee-section name=addNomineeForm ng-init=nomineeInit() novalidate ng-submit=nomineeContinue()><!--<form autocomplete=\"off\" class=\"nominee-section\" name=\"addNomineeForm\" novalidate>--><div class=form-content><div class=nominee-selection-choice><p class=title1>Do you want to add a nominee?</p><div class=\"radio-block input-normal\"><span class=radio><input type=radio name=wantToAddNomineeLater ng-value=false ng-model=wantToAddNomineeLater ng-click=checkAddNominee(false)> <span class=check></span> </span><span class=radio-label>Yes</span></div><div class=\"radio-block input-normal\"><span class=radio><input type=radio name=wantToAddNomineeLater ng-value=true ng-model=wantToAddNomineeLater ng-click=checkAddNominee(true)> <span class=check></span> </span><span class=radio-label>No</span></div></div><div class=\"nominee-title nominee-title-resp clearfix\"><span class=\"pull-left details headerResp\" ng-if=!wantToAddNomineeLater><strong>Nominee Details</strong> <i class=\"info-icon base-tooltip\" ng-if=showNomineeUpdate data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"<div>\n                SEBI Circular No. SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650, dated January 10, 2025\n                states that, in case of Joint Account/Folio: <br>\n                1. In case of “Demise of one or more joint holder(s)” event: Transmission of\n                  Account/Folio to: Surviving holder(s) through name deletion, The surviving holder(s) shall\n                  inherit the assets as owners.<br>\n                2. In case of “Demise of all joint holders simultaneously – having nominee” event: Transmission of Account/Folio to: Nominee.<br>\n                3. In case of “Demise of all joint holders simultaneously – not having nominee event: Transmission of Account /Folio to: Legal heir(s) of the youngest holder.\n              </div>\"></i></span></div><div class=\"nominee-title nominee-title-resp clearfix\" ng-if=\"showNomineeUpdate && !wantToAddNomineeLater\"><p class=\"consent-text nominee-declaration\">I/We hereby nominate the following person(s) who shall receive all the assets held in my / our account / folio in the event of my / our demise, as trustee and on behalf of my/our legal heir(s).</p></div><div class=\"col-md-12 optOutalign\" ng-if=wantToAddNomineeLater><div class=checkbox style=\"text-align: left!important\"><input type=checkbox ng-model=optOutNominee ng-value=true ng-click=checkOptOutNominee()> <span class=icon-checkbox></span></div><div class=checkbox-text style=margin-left:5px!important><ng-bind-html dynamic=dynamicNote.content></ng-bind-html></div></div><div class=row ng-if=wantToAddNomineeLater></div><div ng-if=!wantToAddNomineeLater ng-class=\"{\'nomineeList\': showNomineeUpdate}\"><div class=tab-container><ul class=\"nav nav-tabs folio-tabs\" ng-class=\"showAddNominee && (nomineePayload.nominees.length < allowedNomineeLength) ? \'updated-width\': \'full-width\'\"><li class=tabNominee ng-repeat=\"data in nomineePayload.nominees\" ng-class=\"{\'active\':activeTab===$index}\"><div ng-click=setActiveTab($index)>{{nomineeEnum[$index]}} Nominee Details</div><div ng-if=\"nomineePayload.nominees.length > 1\"><i class=delete-red-icon ng-click=deleteNominee($index)></i></div></li></ul></div><div name=\"nominee-details tab-content\" ng-repeat=\"data in nomineePayload.nominees\" ng-show=\"activeTab===$index\"><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Name <span class=\"req text-red\">*</span></p><input class=input-field type=text name=nomineeName-{{$index}} ng-model=data.nomineeName ng-maxlength=40 limit-to=40 maxlength=40 easyassist-key=mask-element placeholder=Name autocomplete=off only-alphabets required> <span ng-show=\"addNomineeForm[\'nomineeName-\'+$index].$dirty && addNomineeForm[\'nomineeName-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'nomineeName-\'+$index].$error.required\">{{nomineeValidateData.NOMINEE_NAME_REQUIRED}}</span></span></div><div class=col-md-6><p class=titleFatca>Allocation <span class=\"req text-red\">*</span></p><div ng-class=\"{error:addNomineeForm[\'proportion\'+$index].$dirty && addNomineeForm[\'proportion-\'+$index].$invalid}\"><input class=percentage type=text name=proportion-{{$index}} ng-model=data.percentage ng-blur=calculatePercentage() maxlength=3 is-number easyassist-key=mask-element required placeholder=Allocation> <span class=highlight></span> <span class=bar></span> <span ng-show=\"addNomineeForm[\'proportion-\'+$index].$dirty && addNomineeForm[\'proportion-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'proportion-\'+$index].$error.required\">{{nomineeValidateData.NOMINEE_PROPORTION_REQUIRED}}</span></span></div></div></div></div><!-- nominee is minor --><br><br><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><div class=checkbox style=\"text-align: left!important\"><input type=checkbox ng-model=data.minor ng-change=changeFolioMinor()> <span class=icon-checkbox></span> <span class=checkbox-text>The Nominee is Minor</span></div></div></div></div><div class=row><div class=\"col-md-12 set-padding-left-0\"><div class=\"col-md-3 nominee-dob\"><p class=titleFatca>Date of Birth <span class=\"req text-red\" ng-if=data.minor>*</span></p><div class=birth-cal ng-if=data.minor ng-class=\"{error:addNomineeForm[\'dob-\'+$index].$dirty && addNomineeForm[\'dob-\'+$index].$invalid}\"><input class=input-field type=text name=dob-{{$index}} id=dob-{{$index}} date-calendar format=DD-MMM-YYYY viewmode=days showdefault=false date-default=data.dob data-min-date=isMinorMinDate data-max-date=isMinorMaxDate data-on-date-change=nomineeChangeDob autocomplete=off data-enable=true easyassist-key=mask-element ng-bind=data.dob ng-model=data.dob placeholder=dd-mm-yyyy> <span class=highlight></span> <span class=bar></span> <i class=calendar-input-icon></i><!--<i class=\"times-icon\" ng-click=\"Nominee.resetNetWorthDate()\"></i>--> <span ng-show=\"addNomineeForm[\'dob-\'+$index].$dirty && addNomineeForm[\'dob-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'dob-\'+$index].$error.required\">{{nomineeValidations.NET_WORTH_DATE}}</span></span></div><div class=birth-cal ng-if=!data.minor ng-class=\"{error:addNomineeForm[\'dob-\'+$index].$dirty && addNomineeForm[\'dob-\'+$index].$invalid}\"><input class=input-field type=text name=dob-{{$index}} id=dob-{{$index}} date-calendar format=DD-MMM-YYYY viewmode=days showdefault=false date-default=data.dob data-min-date=dataMinDate data-max-date=dataMaxDate data-on-date-change=nomineeChangeDob autocomplete=off data-enable=true easyassist-key=mask-element ng-bind=data.dob ng-model=data.dob placeholder=dd-mm-yyyy> <span class=highlight></span> <span class=bar></span> <i class=calendar-input-icon></i><!--<i class=\"times-icon\" ng-click=\"Nominee.resetNetWorthDate()\"></i>--> <span ng-show=\"addNomineeForm[\'dob-\'+$index].$dirty && addNomineeForm[\'dob-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'dob-\'+$index].$error.required\">{{nomineeValidations.NET_WORTH_DATE}}</span></span></div></div><div class=col-md-3><p class=titleFatca>Relationship <span class=\"req text-red\">*</span></p><div ng-class=\"{error:addNomineeForm[\'nomineeRelation-\'+$index].$dirty && addNomineeForm[\'nomineeRelation-\'+$index].$invalid}\"><select class=selectNormal name=nomineeRelation-{{$index}} ng-model=data.nomineeRelation ng-init=\"data.nomineeRelation=data.nomineeRelation?data.nomineeRelation:null\" ng-options=\"_type.value as _type.name for _type in applicantRelationShip\" ng-change=changeNomineeRelationsShip($index,data.nomineeRelation) easyassist-key=mask-element required><option value=\"\" selected>Relationship with Applicant</option></select><span ng-show=\"addNomineeForm[\'nomineeRelation-\'+$index].$dirty && addNomineeForm[\'nomineeRelation-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'nomineeRelation-\'+$index].$error.required\">{{nomineeValidateData.NOMINEE_RELATIONSHIP}}</span></span></div></div></div></div><div class=row ng-if=showNomineeUpdate><div class=\"col-md-12 set-padding-left-0\"><div class=col-md-3><!--Nominee Email Id input fiels columns--><p class=titleFatca>Nominee Email ID <span class=\"req text-red\">*</span></p><div ng-class=\"{error: addNomineeForm[\'others-\'+$index].$dirty && addNomineeForm[\'others-\'+$index].$invalid}\"><input type=text class=input-field ng-pattern=emailPattern ng-model=data.emailId name=emailId-{{$index}} maxlength=254 placeholder=\"Nominee Email ID\" ng-change=\"changeEmailId($index ,data.emailId)\" autocomplete=off required> <span ng-show=\"addNomineeForm[\'emailId-\'+$index].$dirty && addNomineeForm[\'emailId-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'emailId-\'+$index].$error.pattern\">{{nomineeValidateData.EMAIL_FIELD}} </span><span class=error-input ng-show=\"addNomineeForm[\'emailId-\'+$index].$error.required\">{{nomineeValidateData.EMAIL_REQUIRED}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'emailId-\'+$index].$invalid && nomineePayload.nominees[$index].emailIdInvalid\">{{errorMessageEmail}}</span></div></div><div class=col-md-3 ng-if=showNomineeUpdate><!--Nominee mobile number columns--><p class=titleFatca>Nominee Mobile No.<span class=\"req text-red\">*</span></p><div ng-class=\"{error: addNomineeForm[\'others-\'+$index].$dirty && addNomineeForm[\'others-\'+$index].$invalid}\"><input type=text class=input-field ng-pattern=mobilePattern ng-model=data.mobileNumber name=mobile-{{$index}} placeholder=\"Nominee Mobile No.\" minlength=1 maxlength=15 autocomplete=off required><!--ng-change=\"changeMobileNumber($index, data.mobile)\"--> <span ng-show=\"addNomineeForm[\'mobile-\'+$index].$dirty && addNomineeForm[\'mobile-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'mobile-\'+$index].$error.pattern || addNomineeForm[\'mobile-\'+$index].$error.minlength\">{{nomineeValidateData.MOBILE_FIELD}} </span><span class=error-input ng-show=\"addNomineeForm[\'mobile-\'+$index].$error.required\">{{nomineeValidateData.MOBILE_REQUIRED}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'mobile-\'+$index].$invalid && nomineePayload.nominees[$index].mobileInvalid\">{{errorMessageMobile}}</span></div></div><div class=col-md-3><p class=titleFatca>Select Personal Identifier of Nominee <span class=\"req text-red\">*</span></p><div ng-class=\"{error:addNomineeForm[\'personalIdentifier-\'+$index].$dirty && addNomineeForm[\'personalIdentifier-\'+$index].$invalid}\"><select class=selectNormal name=personalIdentifier-{{$index}} ng-model=data.identityProofType ng-init=\"data.identityProofType=data.identityProofType?data.identityProofType:null\" ng-options=\"_type.identityProofType as _type.identityProof for _type in data.applicantPersonalIdentifiers\" ng-change=\"changePersonalIdentifier($index, data.identityProofType)\" easyassist-key=mask-element required><option value=\"\" selected>Select Personal Identifier of Nominee</option></select><span ng-show=\"addNomineeForm[\'personalIdentifier-\'+$index].$dirty && addNomineeForm[\'personalIdentifier-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'personalIdentifier-\'+$index].$error.required\">{{nomineeValidateData.PERSONAL_IDENTIFIER_REQUIRED}}</span></span></div></div></div></div><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6 ng-if=\"!showNomineeUpdate || (showNomineeUpdate && data.identityProofType === \'PAN_CARD\')\"><p class=titleFatca>Nominee PAN <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error: addNomineeForm[\'panNumber-\'+$index].$dirty && addNomineeForm[\'panNumber-\'+$index].$invalid}\"><input class=input-field type=text maxlength=10 minlength=10 ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-bind=data.panNumber ng-model=data.panNumber ng-change=\"nomineePanChanged($index ,data.panNumber)\" name=panNumber-{{$index}} placeholder=\"Nominee PAN\" ng-required=showNomineeUpdate autocomplete=off capitalize> <span ng-show=\"addNomineeForm[\'panNumber-\'+$index].$dirty && addNomineeForm[\'panNumber-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'panNumber-\'+$index].$error.pattern\">Please enter valid PAN </span><span class=error-input ng-show=\"addNomineeForm[\'panNumber-\'+$index].$error.required\">{{nomineeValidateData.PAN_REQUIRED}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'panNumber-\'+$index].$invalid && nomineePayload.nominees[$index].nomineePanInvalid\">{{errorMessageNominee}}</span></div></div><div class=col-md-6 ng-if=\"showNomineeUpdate && data.identityProofType === \'DRIVING_LICENSE\'\"><p class=titleFatca>Nominee Driving License No. <span class=\"req text-red\">*</span></p><div ng-class=\"{error: addNomineeForm[\'drivingLicense-\'+$index].$dirty && addNomineeForm[\'drivingLicense-\'+$index].$invalid}\"><input class=input-field type=text ng-bind=data.drivingLicense ng-model=data.drivingLicense name=drivingLicense-{{$index}} ng-change=\"drivingLicenseChanged($index ,data.drivingLicense)\" maxlength=35 placeholder=\"Nominee Driving License No.\" autocomplete=off required capitalize> <span ng-show=\"addNomineeForm[\'drivingLicense-\'+$index].$dirty && addNomineeForm[\'drivingLicense-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'drivingLicense-\'+$index].$error.pattern || addNomineeForm[\'drivingLicense-\'+$index].$error.required\">{{nomineeValidateData.DRIVING_LICENSE_INVALID}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'drivingLicense-\'+$index].$invalid && nomineePayload.nominees[$index].nomineeLicenseInvalid\">{{errorMessageDrivingLicense}}</span></div></div><div class=col-md-6 ng-if=\"showNomineeUpdate && data.identityProofType === \'AADHAR_CARD\'\"><p class=titleFatca>Nominee Aadhaar No. (Last 4 digits)<span class=\"req text-red\">*</span></p><div class=aadhar-field ng-class=\"{error: addNomineeForm[\'aadharCard-\'+$index].$dirty && addNomineeForm[\'aadharCard-\'+$index].$invalid}\"><input class=input-field type=text ng-bind=data.aadharCard ng-model=data.aadharCard ng-pattern=/^\\+?\\d+$/ name=aadharCard-{{$index}} maxlength=4 minlength=4 placeholder=\"Nominee Aadhaar No.\" ng-change=\"aadharCardChanged($index ,data.aadharCard)\" autocomplete=off required capitalize> <span class=arn>XXXX XXXX </span><span ng-show=\"addNomineeForm[\'aadharCard-\'+$index].$dirty && addNomineeForm[\'aadharCard-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'aadharCard-\'+$index].$error.minlength || addNomineeForm[\'aadharCard-\'+$index].$error.pattern\">{{nomineeValidateData.AADHAAR_INVALID}} </span><span class=error-input ng-show=\"addNomineeForm[\'aadharCard-\'+$index].$error.required\">{{nomineeValidateData.AADHAAR_INVALID}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'aadharCard-\'+$index].$invalid && nomineePayload.nominees[$index].nomineeAadhaarInvalid\">{{errorMessageNomineeAadhaar}}</span></div></div><div class=col-md-6 ng-if=\"showNomineeUpdate && data.identityProofType === \'PASSPORT\'\"><p class=titleFatca>Nominee Passport <span class=\"req text-red\">*</span></p><div ng-class=\"{error: addNomineeForm[\'passport-\'+$index].$dirty && addNomineeForm[\'passport-\'+$index].$invalid}\"><input class=input-field type=text ng-bind=data.passport ng-model=data.passport name=passport-{{$index}} ng-change=\"passportChanged($index ,data.passport)\" maxlength=35 placeholder=\"Nominee Passport\" autocomplete=off required capitalize> <span ng-show=\"addNomineeForm[\'passport-\'+$index].$dirty && addNomineeForm[\'passport-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'passport-\'+$index].$error.required\">{{nomineeValidateData.PASSPORT_REQUIRED}} </span></span><span class=error-input ng-show=\"!addNomineeForm[\'passport-\'+$index].$invalid && nomineePayload.nominees[$index].nomineePassportInvalid\">{{errorMessagePassportNumber}}</span></div></div><div class=col-md-6 ng-if=\"showNomineeUpdate && data.identityProofType && data.identityProofType !== \'AADHAR_CARD\' && data.identityProofType !== \'DRIVING_LICENSE\' && data.identityProofType !== \'PAN_CARD\' && data.identityProofType !== \'PASSPORT\'\"><p class=titleFatca>Others<span class=\"req text-red\">*</span></p><div class=aadhar-field ng-class=\"{error: addNomineeForm[\'panNumber-\'+$index].$dirty && addNomineeForm[\'panNumber-\'+$index].$invalid}\"><input class=input-field type=text ng-bind=data.somethingElse ng-model=data.somethingElse name=others-{{$index}} autocomplete=off required capitalize></div></div></div></div><div ng-if=data.minor><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Guardian Name <span class=\"req text-red\">*</span></p><div ng-class=\"{error:addNomineeForm[\'guardianName-\'+$index].$dirty && addNomineeForm[\'guardianName-\'+$index].$invalid}\"><input class=input-field type=text ng-model=data.guardianName name=guardianName-{{$index}} ng-maxlength=40 limit-to=40 maxlength=40 placeholder=\"Guardian Name\" only-alphabets capitalize required> <span class=highlight></span> <span class=bar></span> <span ng-show=\"addNomineeForm[\'guardianName-\'+$index].$dirty && addNomineeForm[\'guardianName-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'guardianName-\'+$index].$error.required\">{{nomineeValidateData.GUARDIAN_NAME}}</span></span></div></div><div class=col-md-6><p class=titleFatca>Guardian PAN</p><div ng-class=\"{error:addNomineeForm[\'guardianPanNumber-\'+$index].$dirty && addNomineeForm[\'guardianPanNumber-\'+$index].$invalid}\"><input class=input-field type=text maxlength=10 minlength=10 ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-bind=data.guardianPanNumber ng-model=data.guardianPanNumber name=guardianPanNumber-{{$index}} placeholder=\"Guardian PAN\" ng-change=\"minorPanChanged($index , data.guardianPanNumber , true)\" autocomplete=off capitalize> <span ng-show=\"!data.guardianPanNumber && addNomineeForm[\'guardianPanNumber-\'+$index].$dirty && addNomineeForm[\'guardianPanNumber-\'+$index].$invalid && !addNomineeForm[\'guardianPanNumber-\'+$index].$error.required\"><span class=error-input>Please enter valid PAN </span></span><span class=error-input ng-show=\"addNomineeForm[\'guardianPanNumber-\'+$index].$dirty && addNomineeForm[\'guardianPanNumber-\'+$index].$invalid && addNomineeForm[\'guardianPanNumber-\'+$index].$error.required \">{{nomineeValidateData.PAN_REQUIRED}}</span> <span class=error-input ng-show=\"!addNomineeForm[\'guardianPanNumber-\'+$index].$invalid && nomineePayload.nominees[$index].minorPanInvalid && addNomineeForm[\'guardianPanNumber-\'+$index]\">{{errorMessage}} </span><!--                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'guardianPanNumber-\'+$index].$error.required && addNomineeForm[\'guardianPanNumber-\'+$index].$dirty\">--><!--                  Pan is required--><!--                </span>--></div></div></div></div><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Guardian Relationship <span class=\"req text-red\">*</span></p><div ng-class=\"{error:addNomineeForm[\'guardianRelationWithNominee-\'+$index].$dirty && addNomineeForm[\'guardianRelation-\'+$index].$invalid}\"><select class=selectNormal name=guardianRelationWithNominee-{{$index}} ng-model=data.guardianRelationWithNominee ng-init=\"data.guardianRelationWithNominee=data.guardianRelationWithNominee?data.guardianRelationWithNominee:null\" ng-options=\"_type.value as _type.name for _type in minorRelationShip\" ng-change=changeMinorRelationsShip($index,data.guardianRelationWithNominee) required><option value=\"\" selected>Guardian\'s Relationship with Nominee</option></select><!--                  <span class=\"req text-red\">*</span>--> <span ng-show=\"addNomineeForm[\'guardianRelationWithNominee-\'+$index].$dirty && addNomineeForm[\'guardianRelationWithNominee-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'guardianRelationWithNominee-\'+$index].$error.required\">{{nomineeValidateData.NOMINEE_RELATIONSHIP}}</span></span></div></div></div></div></div><p class=address-label style=\"margin-bottom: 0\"><strong>Address Details :</strong></p><div ng-if=!data.minor><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Address Line 1 <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error:addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid}\"><input class=input-field type=text ng-model=data.nomineeAddress.addressLine1 name=addressLine1-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 easyassist-key=mask-element placeholder=\"Address Line 1\" ng-required=showNomineeUpdate capitalize> <span class=highlight></span> <span class=bar></span> <span ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$error.required\">{{nomineeValidateData.ADDRESS1_REQUIRED}}</span></span></div></div><div class=col-md-6><p class=titleFatca>Address Line 2</p><div><input class=input-field type=text ng-model=data.nomineeAddress.addressLine2 name=addressLine2-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 easyassist-key=mask-element placeholder=\"Address Line 2\" capitalize> <span class=highlight></span> <span class=bar></span></div></div></div></div><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Select Country <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error:addNomineeForm[\'residencyCountry-\'+$index].$dirty && addNomineeForm[\'residencyCountry-\'+$index].$invalid}\"><select class=selectNormal name=residencyCountry-{{$index}} ng-model=data.nomineeAddress.country ng-change=changeCountry($index,data.nomineeAddress.country) ng-options=\"_country.countryCode as _country.countryName for _country in nomineeCountryList\" ng-init=\"data.nomineeAddress.country=data.nomineeAddress.country?data.nomineeAddress.country:null\" easyassist-key=mask-element ng-required=showNomineeUpdate><option value=\"\" selected>Select country</option></select><span ng-show=\"addNomineeForm[\'residencyCountry-\'+$index].$dirty && addNomineeForm[\'residencyCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'residencyCountry-\'+$index].$error.required\">{{nomineeValidateData.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-6><p class=titleFatca>State <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error:addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid}\"><select class=selectNormal name=state-{{$index}} ng-disabled=\"data.nomineeAddress.country != \'IN\'\" ng-model=data.nomineeAddress.state ng-init=\"data.nomineeAddress.state=data.nomineeAddress.state?data.nomineeAddress.state:null\" ng-options=\"_state.stateCode as _state.stateName for _state in stateList\" ng-change=changeState($index,data.nomineeAddress.state) ng-required=showNomineeUpdate><option value=\"\" selected>Select State</option></select><span ng-show=\"addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'state-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.STATE_REQUIRED}}</span></span></div></div></div></div><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>City <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error:addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid}\"><input class=input-field type=text ng-model=data.nomineeAddress.city name=city-{{$index}} ng-maxlength=35 limit-to=35 maxlength=35 ng-pattern=/^[a-zA-Z\\s]*$/ easyassist-key=mask-element ng-required=showNomineeUpdate placeholder=City capitalize> <span class=highlight></span> <span class=bar></span> <span ng-show=\"addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'city-\'+$index].$error.required\">{{nomineeValidateData.CITY}}</span> </span><span class=error-input ng-show=\"addNomineeForm[\'city-\'+$index].$error.pattern\">Invalid City</span></div></div><div class=col-md-6><p class=titleFatca>Zip Code <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error:addNomineeForm[\'pinCode-\'+$index].$dirty && addNomineeForm[\'pinCode-\'+$index].$invalid}\"><input class=input-field type=text ng-model=data.nomineeAddress.pinCode name=pinCode-{{$index}} is-number ng-maxlength=6 limit-to=6 easyassist-key=mask-element placeholder=\"Zip Code\" ng-required=showNomineeUpdate maxlength=6> <span class=highlight></span> <span class=bar></span> <span ng-show=\"addNomineeForm[\'pinCode-\'+$index].$dirty && addNomineeForm[\'pinCode-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'pinCode-\'+$index].$error.required\">{{nomineeValidateData.PINCODE_REQUIRED}}</span></span></div></div></div></div></div><div ng-if=data.minor><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Address Line 1 <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error:addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid}\"><input class=input-field type=text ng-model=data.guardianAddress.addressLine1 name=addressLine1-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 placeholder=\"Address Line 1\" ng-required=showNomineeUpdate capitalize> <span class=highlight></span> <span class=bar></span> <span ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$dirty && addNomineeForm[\'addressLine1-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'addressLine1-\'+$index].$error.required\">{{nomineeValidateData.ADDRESS1_REQUIRED}}</span></span></div></div><div class=col-md-6><p class=titleFatca>Address Line 2</p><div><input class=input-field type=text ng-model=data.guardianAddress.addressLine2 name=addressLine2-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 placeholder=\"Address Line 2\" capitalize> <span class=highlight></span> <span class=bar></span></div></div></div></div><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>Select Country <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error:addNomineeForm[\'gResidencyCountry-\'+$index].$dirty && addNomineeForm[\'gResidencyCountry-\'+$index].$invalid}\"><select class=selectNormal name=gResidencyCountry-{{$index}} ng-model=data.guardianAddress.country ng-change=changeCountryGuardian($index,data.guardianAddress.country) ng-options=\"_country.countryCode as _country.countryName for _country in nomineeCountryList\" ng-init=\"data.guardianAddress.country=data.guardianAddress.country?data.guardianAddress.country:null\" ng-required=showNomineeUpdate><option value=\"\" selected>Select country</option></select><!--                  <span class=\"req text-red\">*</span>--> <span ng-show=\"addNomineeForm[\'gResidencyCountry-\'+$index].$dirty && addNomineeForm[\'gResidencyCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'gResidencyCountry-\'+$index].$error.required\">{{nomineeValidateData.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-6><p class=titleFatca>State <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error:addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid}\"><select class=selectNormal name=state-{{$index}} ng-disabled=\"data.guardianAddress.country != \'IN\'\" ng-model=data.guardianAddress.state ng-init=\"data.guardianAddress.state=data.guardianAddress.state?data.guardianAddress.state:null\" ng-options=\"_state.stateCode as _state.stateName for _state in stateList\" ng-change=changeState($index,data.nomineeAddress.state) ng-required=showNomineeUpdate><option value=\"\" selected>Select State</option></select><!--                  <span class=\"req text-red\">*</span>--> <span ng-show=\"addNomineeForm[\'state-\'+$index].$dirty && addNomineeForm[\'state-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'state-\'+$index].$error.required\">{{UpdateNominee.nomineeValidateData.STATE_REQUIRED}}</span></span></div></div></div></div><div class=row><div class=\"col-md-6 set-padding-left-0\"><div class=col-md-6><p class=titleFatca>City <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error:addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid}\"><input class=input-field type=text ng-model=data.guardianAddress.city name=city-{{$index}} ng-maxlength=35 limit-to=35 maxlength=35 ng-pattern=/^[a-zA-Z\\s]*$/ placeholder=City ng-required=showNomineeUpdate capitalize> <span class=highlight></span> <span class=bar></span> <span ng-show=\"addNomineeForm[\'city-\'+$index].$dirty && addNomineeForm[\'city-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'city-\'+$index].$error.required\">{{nomineeValidateData.CITY}}</span> </span><span class=error-input ng-show=\"addNomineeForm[\'city-\'+$index].$error.pattern\">Invalid City</span></div></div><div class=col-md-6><p class=titleFatca>Zip Code <span class=\"req text-red\" ng-if=showNomineeUpdate>*</span></p><div ng-class=\"{error:addNomineeForm[\'gpinCode-\'+$index].$dirty && addNomineeForm[\'gpinCode-\'+$index].$invalid}\"><input class=input-field type=text ng-model=data.guardianAddress.pinCode name=gpinCode-{{$index}} is-number maxlength=6 placeholder=\"Zip Code\" ng-required=showNomineeUpdate> <span class=highlight></span> <span class=bar></span><div ng-show=\"addNomineeForm[\'gpinCode-\'+$index].$dirty && addNomineeForm[\'gpinCode-\'+$index].$invalid\"><span class=error-input ng-show=\"addNomineeForm[\'gpinCode-\'+$index].$error.required\">{{nomineeValidateData.PINCODE_REQUIRED}}</span></div></div></div></div></div></div><!--<hr/>--></div></div><!--<hr />--><div class=row ng-if=\"showNomineeUpdate && !wantToAddNomineeLater\"><div class=col-md-12><div class=statement-declaration ng-if=showNomineeUpdate><p class=section-title>Statement of Holding(Account Statement) Declaration <span class=\"req text-red\">*</span></p><div class=declaration-content><div class=row><div class=col-md-12><span>I/ We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/ us by the AMC as follows; (please tick, as appropriate)</span></div></div><div class=row><!--<div class=\"col-md-12 mb-3\">\n                  <div class=\"checkbox\">\n                    <input ng-model=\"nomineePayload.accountHoldingDeclaration.nomination\" name=\"statementNomination\" type=\"checkbox\"\n                           ng-change=\"setStatement();\"\n                           ng-required=\"!nomineePayload.accountHoldingDeclaration.nomineeName\"/>\n                    <i class=\"icon-checkbox\"></i>\n                    <span class=\"checkbox-text ria\" style=\"margin-top: -10px;\">Nomination: Yes/No</span>\n                  </div>\n                </div>\n                <div class=\"col-md-12\">\n                  <div class=\"checkbox\">\n                    <input ng-model=\"nomineePayload.accountHoldingDeclaration.nomineeName\" name=\"statementNomineeName\" type=\"checkbox\"\n                           ng-change=\"setStatement();\"\n                           ng-required=\"!nomineePayload.accountHoldingDeclaration.nomination\"/>\n                    <i class=\"icon-checkbox\"></i>\n                    <span class=\"checkbox-text ria\" style=\"margin-top: -10px;\">Name of Nominee(s)</span>\n                  </div>\n                </div>\n                <div class=\"col-md-12 mt-2\">\n                  <span ng-show=\"(addNomineeForm[\'statementNomineeName\'].$dirty && addNomineeForm[\'statementNomineeName\'].$invalid) || (addNomineeForm[\'statementNomination\'].$dirty && addNomineeForm[\'statementNomination\'].$invalid)\">\n                    <span class=\"error-input\" ng-show=\"addNomineeForm[\'statementNomineeName\'].$error.required\">{{nomineeValidateData.STATEMENT_HOLDING_DECLARATION_REQUIRED}}</span>\n                  </span>\n                </div>--><div class=col-md-12><div class=radio-block><span class=radio><input type=radio name=statmentNomination ng-value=true ng-change=setStatement(); ng-model=nomineePayload.accountHoldingDeclaration.nomination required> <span class=check></span> </span><span class=radio-label>Nomination: Yes</span></div><div class=radio-block><span class=radio><input type=radio name=statmentNomination ng-value=false ng-change=setStatement(); ng-model=nomineePayload.accountHoldingDeclaration.nomination required> <span class=check></span> </span><span class=radio-label>Nomination: No</span></div></div></div></div></div></div></div><!--<div class=\"row\" ng-if=\"showNomineeUpdate && !wantToAddNomineeLater && nomineePayload.holdmode !== \'ANY_OR_SURVIVOR\'\">\n        <div class=\"col-md-12\">\n          <div class=\"statement-declaration\"  ng-if=\"showNomineeUpdate && nomineePayload.holdmode !== \'ANY_OR_SURVIVOR\'\">\n            <p class=\"section-title\">Incapacitation Declaration (Optional)\n              <i class=\"info-icon base-tooltip\" data-bs-html=\"true\" tooltip data-bs-toggle=\"tooltip\"\n                 data-bs-placement=\"right\"\n                 data-bs-title=\'<div>\n                SEBI Circular: SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650 dated January 10, 2025, 3.5 paragraph states, Nominee to act on behalf of incapacitated investors 3.5.1. The regulated entity shall provide the investors having single holding / account / folio, the option to: <br/>\n                a) empower, any one of the nominees (excluding minor nominee) to operate the investor’s account / folio, if the investor is physical incapacitated, but still has the capacity to contract. <br/>\n                b) specify either the percentage or absolute value of assets in the account/ folio that can be encashed by such nominee. <br/>\n                c) change such mandate any number of times without any restriction. <br/>\n              </div>\'>\n              </i>\n            </p>\n            <div class=\"declaration-content\">\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                <span>I hereby authorize\n                  <select name=\"nomineePayload.nomineeName \"\n                          ng-model=\"nomineePayload.incapcitationNomineeIndex\"\n                          ng-options=\"data.value as data.key disable when (data.isMinor) for data in incapcitationList\"\n                          ng-change=\"selectedNominee(incapcitationNomineeIndex)\">\n                    <option value=\"\" selected>Select Nominee</option>\n                  </select>\n                  (nominee number\n                  <input type=\"text\"\n                     ng-model=\"nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber\"\n                     name=\"nomineeNumber\" is-number />)\n                  to operate my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up to\n                  <input type=\"text\"\n                         ng-model=\"nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage\"\n                         name=\"percentage\" is-number maxlength=\"3\"\n                         ng-required=\"nomineePayload.incapcitationNomineeIndex !== null && !nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount\"\n                         ng-pattern=\"/^(100|[1-9]?[0-9])$/\"\n                         ng-model-options=\"{ allowInvalid: true}\"\n                         ng-disabled=\"nomineePayload.incapcitationNomineeIndex === null || nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount\">\n                  % of assets in the account / folio or Rs.\n                  <input type=\"text\"\n                         ng-model=\"nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.amount\"\n                         name=\"allowedAmount\"\n                         ng-pattern=\"/^[1-9]\\d*$/\"\n                         is-number maxlength=\"20\"\n                         ng-disabled=\"nomineePayload.incapcitationNomineeIndex === null || nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage\"\n                         ng-required=\"nomineePayload.incapcitationNomineeIndex !==null && !nomineePayload.nomineeRegistrationCO.incapacitationDeclaration.percentage\">.\n                </span>\n                  <span ng-show=\"(addNomineeForm[\'percentage\'].$dirty && addNomineeForm[\'percentage\'].$invalid) || (addNomineeForm[\'allowedAmount\'].$dirty && addNomineeForm[\'allowedAmount\'].$invalid)\">\n                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'allowedAmount\'].$error.pattern\">\n                    Amount/percentage cannot be less than 1.\n                  </span>\n                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'percentage\'].$error.pattern && nomineePayload.incapacitationDeclaration.percentage < 1\">\n                    Amount/percentage cannot be less than 1.\n                  </span>\n                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'percentage\'].$error.pattern && nomineePayload.incapacitationDeclaration.percentage > 100\">\n                    Percentage cannot be more than 100%.\n                  </span>\n                </span>\n                  <span ng-show=\"(addNomineeForm[\'percentage\'].$dirty && addNomineeForm[\'percentage\'].$invalid) || (addNomineeForm[\'allowedAmount\'].$dirty && addNomineeForm[\'allowedAmount\'].$invalid)\">\n                  <span class=\"error-input\" ng-show=\"addNomineeForm[\'percentage\'].$error.required && addNomineeForm[\'allowedAmount\'].$error.required\">\n                    Please enter the percentage or Rs. that can be encashed by the nominee.\n                  </span>\n                </span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>--><div class=row ng-if=!wantToAddNomineeLater><div class=col-md-6 style=\"margin-top: 40px\"><div ng-if=\"showAddNominee && (nomineePayload.nominees.length< allowedNomineeLength)\" ng-click=addNominee() style=\"width: fit-content\"><a href=\"\" class=\"text-blue btn-add-nominee\"><strong>Add Another Nominee</strong></a></div><div class=error-nominee-form ng-style=\"showAddNominee && {\'margin-top\': \'40px\'}\" style=\"color: #d92018\" ng-bind=validationMsg ng-show=\"addNomineeForm.$dirty && addNomineeForm.$invalid\"></div></div></div></div><!--      <div class=\"form-footer form-content\" style=\"text-align: center\">--><!--        <div class=\"text-danger\" ng-bind=\"validationMsg\" ng-show=\"addNomineeForm.$invalid\"></div>--><!--        <input type=\"submit\" class=\"btn btn-primary-action common-btn-padding\" ng-click=\"nomineeContinue()\"--><!--               value=\"Continue\" ng-disabled=\"addNomineeForm.$invalid || !nomineePanValid || !minorPanValid  || (!optOutNominee && wantToAddNomineeLater ) \"/>--><!--      </div>--><!--    {{addNomineeForm.$valid && (optOutNominee && wantToAddNomineeLater)}}--><div class=proceed><button class=proceed-btn type=submit ng-disabled=\"addNomineeForm.$invalid || !nomineePanValid || !minorPanValid  || (!optOutNominee && wantToAddNomineeLater ) || dobRequired || !nomineeLicenseValid || !nomineeAadhaarValid || !nomineePassportValid \">Next</button></div><!--    <div ng-if=\"editNominee && wantToAddNomineeLater && (addNomineeForm.$valid && (optOutNominee && wantToAddNomineeLater))\" ng-init=\"formIsvalid()\"></div>--><!--    <div ng-if=\"editNominee && !wantToAddNomineeLater && addNomineeForm.$valid && nomineePanValid && minorPanValid\" ng-init=\"formIsvalid()\"></div>--><!--    <div ng-if=\"addNomineeForm.$invalid || !nomineePanValid || !minorPanValid  || (!optOutNominee && wantToAddNomineeLater )\" ng-init=\"formIsinvalid()\"></div>--></form></div><!--Review of Nominee Details--><div ng-show=\"!editNominee && !wantToAddNomineeLater\" class=nominee-review-details-container><div class=\"box-body set-margin-top-20 nominee-details-wrapper\"><div class=\"box-details clearfix repeat-container\" ng-repeat=\"nominee in nomineePayload.nominees\"><div class=\"box-details clearfix set-margin-top-20\"><div style=\"padding-left: 8px\" class=col-md-12><h6 style=\"margin-bottom: 20px\">Nominee {{$index+1}} Detail</h6></div></div><div class=\"bordered nominee-table-container col-md-10 col-sm-12\" ng-class=\"{\'col-md-4\': nomineePayload.nominees.length > 2}\"><table class=\"table borderless\"><tbody><tr><td><span class=span-review-width><strong>Nominee Name:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.nomineeName}}</span></td></tr><tr><td><span class=span-review-width><strong>Nominee Relation:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.nomineeRelation.toUpperCase()}}</span></td></tr><tr ng-if=showNomineeUpdate><td><span class=span-review-width><strong>Nominee Email Id:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.emailId}}</span></td></tr><tr ng-if=showNomineeUpdate><td><span class=span-review-width><strong>Nominee Mobile No:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.mobileNumber}}</span></td></tr><tr ng-if=showNomineeUpdate><td><span class=span-review-width><strong>Nominee Personal Identifier:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.identityProofDescription}}</span></td></tr><tr ng-if=showNomineeUpdate><td><span class=span-review-width ng-if=\"nominee.identityProofType === \'AADHAR_CARD\'\"><strong>Nominee Aadhar Card:</strong></span> <span class=span-review-width ng-if=\"nominee.identityProofType === \'DRIVING_LICENSE\'\"><strong>Nominee Driving License:</strong></span> <span class=span-review-width ng-if=\"nominee.identityProofType === \'PAN_CARD\'\"><strong>Nominee Pan:</strong></span> <span class=span-review-width ng-if=\"nominee.identityProofType === \'PASSPORT\'\"><strong>Nominee Passport:</strong></span> <span class=span-review-width ng-if=\"nominee.identityProofType === \'OTHERS\'\"><strong>Nominee Other Identity:</strong></span></td><td><span easyassist-key=mask-element><span ng-if=\"nominee.identityProofType === \'AADHAR_CARD\'\">XXXX XXXX </span>{{nominee.identityProofNumber}}</span></td></tr><tr ng-if=\"nominee.panNumber && !showNomineeUpdate\"><td><span class=span-review-width><strong>Nominee Pan Number:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.panNumber}}</span></td></tr><tr><td><span class=span-review-width><strong>Nominee DOB:</strong></span></td><td><span easyassist-key=mask-element ng-if=nominee.dob>{{nominee.dob}}</span> <span easyassist-key=mask-element ng-if=!nominee.dob>NA</span></td></tr><tr><td><span class=span-review-width><strong>Nominee Percentage:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.percentage}}</span></td></tr><tr><td><span class=span-review-width><strong>The Nominee is Minor:</strong></span></td><td><span easyassist-key=mask-element ng-if=nominee.minor>Yes</span> <span easyassist-key=mask-element ng-if=!nominee.minor>No</span></td></tr><tr ng-if=nominee.soleAddressApplicable><td><span class=span-review-width><strong>Address Details:</strong></span></td><td><span easyassist-key=mask-element>Same as investor</span></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine1 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span class=span-review-width><strong>Nominee Address Line 1:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine1}}</span></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine2 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span class=span-review-width><strong>Nominee Address Line 2:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine2}}</span></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine3 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span class=span-review-width><strong>Nominee Address Line 3:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine3}}</span></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.city && !nominee.soleAddressApplicable && !nominee.minor\"><td><span class=span-review-width><strong>Nominee\'s City:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.nomineeAddress.city}}</span></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.countryName && !nominee.soleAddressApplicable && !nominee.minor\"><td><span class=span-review-width><strong>Nominee\'s Country:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.nomineeAddress.countryName}}</span></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.pinCode && !nominee.soleAddressApplicable && !nominee.minor\"><td><span class=span-review-width><strong>Nominee\'s PinCode:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.nomineeAddress.pinCode}}</span></td></tr><tr ng-if=\"nominee.guardianName && !nominee.soleAddressApplicable && nominee.minor\"><td><span class=span-review-width><strong>Guardian Name:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.guardianName}}</span></td></tr><tr ng-if=\"nominee.guardianRelationWithNominee && !nominee.soleAddressApplicable && nominee.minor\"><td><span class=span-review-width><strong>Guardian Relation:</strong></span></td><td><span easyassist-key=mask-element>{{minorRelation[nominee.guardianRelationWithNominee]}}</span></td></tr><tr ng-if=\"nominee.guardianPanNumber && !nominee.soleAddressApplicable && nominee.minor\"><td><span class=span-review-width><strong>Guardian PAN:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.guardianPanNumber}}</span></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine1 && !nominee.soleAddressApplicable && nominee.minor\"><td><span class=span-review-width><strong>Guardian\'s Address Line 1:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.guardianAddress.addressLine1}}</span></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine2 && !nominee.soleAddressApplicable && nominee.minor\"><td><span class=span-review-width><strong>Guardian\'s Address Line 2:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.guardianAddress.addressLine2}}</span></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine3 && !nominee.soleAddressApplicable && nominee.minor\"><td><span class=span-review-width><strong>Guardian\'s Address Line 3:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.guardianAddress.addressLine3}}</span></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.city && !nominee.soleAddressApplicable && nominee.minor\"><td><span class=span-review-width><strong>Guardian\'s City:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.guardianAddress.city}}</span></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.countryName && !nominee.soleAddressApplicable && nominee.minor\"><td><span class=span-review-width><strong>Guardian\'s Country:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.guardianAddress.countryName}}</span></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.pinCode && !nominee.soleAddressApplicable && nominee.minor\"><td><span class=span-review-width><strong>Guardian\'s PinCode:</strong></span></td><td><span easyassist-key=mask-element>{{nominee.guardianAddress.pinCode}}</span></td></tr></tbody></table></div></div></div><div class=col-md-12 style=\"padding-left: 8px\" ng-if=\"showNomineeUpdate && nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration\"><h6 style=\"margin-bottom: 20px; margin-top: 20px\">Statement of Holding</h6><div class=row><div class=\"col-md-6 set-margin-bottom-15\"><span class=span-review-width><strong>{{nomineePayload.nomineeRegistrationCO.accountHoldingDeclaration === \'NOMINATION_YES\' ? \'Nomination: Yes\': \'Nomination: No\'}}</strong></span></div></div></div></div><div class=\"col-md-12 optOutalign\" ng-show=\"!editNominee && wantToAddNomineeLater\"><div class=checkbox style=\"text-align: left!important\"><input disabled type=checkbox ng-model=optOutNominee ng-value=true ng-click=checkOptOutNominee()> <span class=icon-checkbox></span></div><div class=checkbox-text style=margin-left:5px!important><ng-bind-html dynamic=dynamicNote.content></ng-bind-html></div></div><style>.input-pan input:focus ~ label , .input-pan input.ng-not-empty ~ label{\n    top: -5px !important;\n    font-size: 12px !important;\n  }</style>");
$templateCache.put("app/investment-baskets/investment-basket-directives/goals/goals-list/goals-list.directive.html","<div class=\"row goals\"><div class=col-md-3 ng-repeat=\"goal in goalsList\"><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{goal.goalName}}</h3></div><div class=panel-body><table class=\"table borderless\"><tr><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{goal.defaultAmount}}</td></tr><tr><td>Timeline</td><td>:</td><td>{{goal.defaultTimeInMonth}} months</td></tr><tr><td>Inflation</td><td>:</td><td>{{goal.defaultInflation}}%</td></tr></table></div><div class=panel-footer><div><button class=transact-action ng-click=\"proceedToGoalSetting(goal.goalName, goal.goalId)\">Calculate</button></div></div></div></div></div>");
$templateCache.put("app/investment-baskets/investment-basket-directives/goals/goals-questionnaires/goals-questionnaires.directive.html","<!--<div class=\"row question-container\">--><!--  <div class=\"col-md-12\">--><!--    <div class=\"row\">--><!--      <div class=\"col-md-12\">--><!--        <p>Lets Get started!</p>--><!--        <p class=\"sub-heading\">Answer few of our questions to get the best suggestions from us.</p>--><!--      </div>--><!--    </div>--><!--    <div class=\"row\">--><!--      <div class=\"col-xs-12 col-md-6\">--><!--        <div class=\"left-section\">--><!--          <form name=\"tform\">--><!--            <div class=\"stepper\">--><!--              <div class=\"step\" ng-repeat=\"step in questionsList.steps\">--><!--                <div class=\"step-heading\" ng-class=\"{\'active\':step.expanded}\" ng-click=\"toggleListItems($index)\">--><!--                  <div class=\"question-index\">{{step.step}}</div>--><!--                  <div class=\"title\">{{step.questions}}</div>--><!--                </div>--><!--                <div class=\"line\" ng-hide=\"step.step >=questionsList.steps.length\"></div>--><!--                <div uib-collapse=\"!step.expanded\">--><!--                  <div class=\"body\">--><!--                    <div class=\"selectfield\" ng-if=\"step.isSelectField\">--><!--                      <select name=\"{{step.name}}\"--><!--                          id=\"ans-{{$index}}\"--><!--                          ng-change=\"{{step.method}}\"--><!--                          ng-model=\"formData[step.model]\"--><!--                          ng-options=\"{{step.ngRepeatOption}}\"--><!--                          required>--><!--                        <option value=\"\">{{step.name}}</option>--><!--                      </select>--><!--                    </div>--><!--                    <div class=\"input-field\" ng-if=\"!step.isSelectField\">--><!--                      <input type=\"text\" name=\"{{step.name}}\"--><!--                        placeholder=\"{{step.name}}\"--><!--                        ng-model=\"formData[step.model]\"--><!--                        capitalize required>--><!--                    </div>--><!--                    <button ng-hide=\"step.step >= questionsList.steps.length\" ng-click=\"toggleListItems($index + 1)\" class=\"btn btn-sm btn-bg ripple\" name=\"next\" type=\"button\"> Next </button>--><!--                    <button ng-hide=\"step.step <= 1\" ng-class=\"{\'btn-bg\': step.step==questionsList.steps.length}\" ng-click=\"toggleListItems($index - 1)\" class=\"btn btn-sm ripple\" name=\"previous\" type=\"button\"> Previous </button>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--          </form>--><!--        </div>--><!--      </div>--><!--      <div class=\"col-xs-12 col-md-6\">--><!--        <div class=\"risk-profiler\">--><!--          <div class=\"head-section\">--><!--            <p>Know Your Investment Personality</p>--><!--            <div class=\"action\">--><!--              <a href=\"\" ng-click=\"evaluateInvestmentPersonality()\" ng-if=\"!isEvaluated\" class=\"cursor-pointer text-primary\">Evaluate</a>--><!--              <a href=\"\" ng-click=\"evaluateInvestmentPersonality()\" ng-if=\"isEvaluated\" class=\"cursor-pointer text-primary\">Change/Update</a>--><!--            </div>--><!--          </div>--><!--          <div class=\"body-section\">--><!--            <div class=\"selectfield\">--><!--              <select name=\"risk\"--><!--                      id=\"risk\"--><!--                      ng-model=\"formData.riskProfiler\"--><!--                      ng-options=\"riskProfile as riskProfile for riskProfile in riskProfileOptions\"--><!--                      required>--><!--                <option value=\"\">Investment Personality</option>--><!--              </select>--><!--            </div>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <div class=\"row\">--><!--      <div class=\"col-md-12\">--><!--        <a href=\"\" ng-click=\"goToBack()\" class=\"cursor-pointer text-primary\"><i class=\"arrow-blue-back-icon\"></i>Back</a>--><!--        <button blur-on-click ng-disabled=\"tform.$invalid\" ng-click=\"submitForm($event)\"--><!--                class=\"btn-primary-action btn pull-right\">See our suggestion--><!--        </button>--><!--      </div>--><!--    </div>--><!--  </div>--> <!--</div>-->");
$templateCache.put("app/new-investors/investment-details/scheme-details/investment-goal/investment-goal.html","<div id=investmentgoal ng-init=InvestmentGoal.init()><div class=row style=\"--bs-gutter-x: 1.5rem\" ng-if=InvestmentGoal.hideArnTogg><div class=\"d-flex justify-content-end flex-row mb-2\" style=\"float: right;margin-top:5px\"><p ng-class=\"InvestmentGoal.DirectScheme? \'\' : \'investmentTitle1\' \" style=\"font-size: 12px\">Regular</p><input type=checkbox id=switch1 ng-model=InvestmentGoal.DirectScheme style=\"margin-right: 10px\"><label class=switchlable for=switch1 style=\"margin-right: 10px\">Toggle</label><span ng-class=\"InvestmentGoal.DirectScheme? \'investmentTitle1\' : \'\' \">Direct</span></div></div><br><div class=investment-tabs><span ng-repeat=\"folioValue in InvestmentGoal.InvestmentGoalList track by $index\"><span class=investment-capsule data={{$index+1}} style=\"font-size: 12px\" ng-class=\"{\'active\': InvestmentGoal.selectedInvestmentGoalName == folioValue.goalName}\" ng-click=InvestmentGoal.changeInvestmentGoal(folioValue.goalName)><img class=goalicons ng-src=\"{{InvestmentGoal.selectedInvestmentGoalName == folioValue.goalName ? folioValue.iconAcitve : folioValue.icon}}\" alt=\"\" srcset=\"\"> {{folioValue.goalName}}</span></span></div><div><h5 ng-if=\"InvestmentGoal.SelectedInvestmentGoalDetailsList.length == 0\" style=\"color: red\">Records not found!</h5><div class=row style=\"margin: 0\"><div class=\"investment-goal-details col-xs-11 col-sm-6 col-md-4\" ng-repeat=\"details in InvestmentGoal.SelectedInvestmentGoalDetailsArray\" style=\"min-height: 240px\"><div class=innerDiv><label class=title1 style=\"height: 70px\">{{details.fundName}}</label><br><label class=description style=\"font-size: 10px;height: 48px;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden;\n          text-overflow: ellipsis;margin-bottom:0px;line-height: 17px\">{{details.description}}</label><br><div class=investment-sub-details><div class=left-box><label style=\"font-size: 10px;color: #689ec7\">Inception Date</label><label>{{details.inceptionDate}}</label></div><div class=right-box><p style=\"font-size: 10px;color: #689ec7\">AUM Value</p><p>{{details.aumValue}}</p></div></div><div class=investment-risk-meter><p style=\"font-size: 11px; color: #689ec7\">Risk Return Profile:</p><p style=\"font-weight: bold\">High Risk</p><img ng-if=details.riskReturnProfile src={{details.riskReturnProfile}} alt=Unavailable srcset=\"\" style=\"width: 95px;height: 71px;margin-left: -14px\"></div><div class=investment-goal-select-scheme ng-if=!InvestmentGoal.DirectScheme><p style=\"font-size: 14px;font-weight: bold; width: 100%; text-align: center\">Select Scheme</p><!-- <select class=\"browser-default custom-select\" name=\"schemeCategory\" style=\"margin: 10px;\"\n                  ng-model=\"InvestmentGoal.selectedscheme\"\n                  ng-selected = \"InvestmentGoal.selectedscheme.schemeCode == schemes\"\n                  ng-change=\"InvestmentGoal.changeScheme(details)\"\n                  ng-options=\"schemes.schemeName for schemes in details.regularSchemes\"\n                  required>\n                  <option value=\"\" selected>Select Scheme</option>\n            </select>  --><!-- <select ng-model=\"schemes.selectedInvestmentGoalcard\"\n              ng-options=\" schemes.schemeName for schemes in details.regularSchemes\"\n              ng-selected=\"InvestmentGoal.selectedscheme.schemeCode == schemes\"  >\n              <option value=\"\" selected>Select Scheme</option>\n            </select> --><select ng-model=details.selectedInvestmentGoalcard ng-disabled=\"InvestmentGoal.distributorDetails && InvestmentGoal.distributorDetails.schemeCode\" ng-change=InvestmentGoal.changeInvestmentGoalcard(details) ng-options=\"item.schemeName for item in details.regularSchemes\" ng-selected=\"details.selectedInvestmentGoalcard.schemeCode == value.schemeCode\" style=\"height: 35px;width: 100%;border-radius: 5px\"><option value=\"\" selected>Select Scheme</option></select></div><div class=investment-goal-select-scheme ng-if=InvestmentGoal.DirectScheme><p style=\"font-size: 14px;font-weight: bold; width: 100%; text-align: center\">Select Scheme</p><!-- <select class=\"browser-default custom-select\" name=\"schemeCategory\" style=\"margin: 10px;\"\n                ng-model=\"InvestmentGoal.selectedscheme\"\n                ng-options=\"schemes.schemeName for schemes in details.directSchemes\"\n                ng-selected = \"InvestmentGoal.selectedscheme.schemeCode == schemes\"\n                ng-change=\"InvestmentGoal.changeScheme(details)\"\n                required>\n                <option value=\"\" selected>Select Scheme</option>\n          </select>  --><!-- <select ng-model=\"schemes.selectedInvestmentGoalcard\"\n              ng-options=\" schemes.schemeName for schemes in details.directSchemes\"\n              ng-selected=\"InvestmentGoal.selectedscheme.schemeCode == schemes\" >\n              <option value=\"\" selected>Select Scheme</option>\n            </select>  --><select ng-model=details.selectedInvestmentGoalcard ng-disabled=\"InvestmentGoal.distributorDetails && InvestmentGoal.distributorDetails.schemeCode\" ng-change=InvestmentGoal.changeInvestmentGoalcard(details) ng-options=\"item.schemeName for item in details.directSchemes\" ng-selected=\"details.selectedInvestmentGoalcard.schemeCode == value.schemeCode\" style=\"height: 35px;width: 100%;border-radius: 5px\"><option value=\"\" selected>Select Scheme</option></select></div></div></div></div><br><div style=\"display: flex;justify-content: flex-end;background: white;padding: 12px\"><p>Pages :</p><p ng-repeat=\"x in InvestmentGoal.pageArray\" ng-click=InvestmentGoal.getPageData(x) ng-class=\"x == InvestmentGoal.CurrentPage ? \'text-primary\' : \'text-dark\' \">{{x}},</p>&nbsp; <button ng-click=InvestmentGoal.prev() ng-disabled=\"InvestmentGoal.CurrentPage == 1\">&#60;</button> &nbsp; <button ng-click=InvestmentGoal.nextPage() ng-disabled=\"InvestmentGoal.CurrentPage == InvestmentGoal.pageArray[InvestmentGoal.pageArray.length - 1 ]\">&#62;</button></div></div><button class=\"continue-btn btn-new-journey-color hdfc-blue-cta-small\" ng-disabled=\"!InvestmentGoal.selectedscheme && !InvestmentGoal.selectedCard\" ng-click=InvestmentGoal.next()>INVEST</button></div><style>.investmentTitle1{\n    font-weight: bold;\n  }</style>");
$templateCache.put("app/new-investors/investment-details/scheme-details/select-scheme/select-scheme.html","<div class=choosescheam ng-init=SelectScheme.init()><div class=row style=\"--bs-gutter-x: 1.5rem\" ng-if=SelectScheme.hideArnTogg><div class=\"d-flex justify-content-end flex-row mb-2\" style=\"float: right;margin-top:5px\"><p ng-class=\"SelectScheme.DirectScheme? \'\' : \'investmentTitle1\' \" style=\"font-size: 12px\">Regular</p><input type=checkbox id=switch1 ng-click=SelectScheme.togScheme() ng-checked=SelectScheme.DirectScheme style=\"margin-right: 10px\"><label class=switchlable ng-checked=SelectScheme.DirectScheme for=switch1 style=\"margin-right: 10px\">Toggle</label><span ng-class=\"SelectScheme.DirectScheme? \'investmentTitle1\' : \'\' \">Direct</span></div></div><br><div class=row><div class=col-md-4><select class=\"browser-default custom-select\" name=schemeCategory ng-model=SelectScheme.selectedschemeCategory ng-options=\"schemeCategoryList for schemeCategoryList in SelectScheme.schemeCategoryList\" ng-change=SelectScheme.changeSchemeCategory() required style=\"width: 100%;height: 40px;border-radius: 6px\"><option value=\"\" selected>select your scheme</option></select></div><div class=col-md-8><input class=\"form-control search-fund\" type=text name=searchscheam id=searchscheam placeholder=\"&nbsp;&nbsp;&nbsp;Search by fund name\" ng-model=SelectScheme.filterwithname ng-change=SelectScheme.changewithFilterName() style=\"height: 40px\"></div></div><br><div><div style=\"margin-left: 15px\"><h5 ng-if=\"SelectScheme.selectedschemeCategoryDetails.length == 0\" style=\"color: red\">Records not found!</h5><div class=\"row schemeRow\" ng-repeat=\"x in SelectScheme.selectedschemeCategoryDetails track by $index\"><div class=\"col-xs-12 col-md-4 m-b5\"><p class=schemeTitle>{{x.fundName}}</p><!-- <p class=\"schemeTitileHead\">Hybrid Equity Plan</p> --></div><div class=\"col-xs-4 col-md-2 m-b5\"><p class=schemeTitileHeadBold>{{x.aumValue}} (CR)</p><p class=schemeTitileHead>Aum Value</p></div><!--<div class=\"col-xs-4 col-md-1 m-b5\">\n            <p class=\"schemeTitle\" ng-if=\"!SelectScheme.DirectScheme\"> {{x.regularOneYearReturn}} %</p>\n            <p class=\"schemeTitle\" ng-if=\"SelectScheme.DirectScheme\"> {{x.directOneYearReturn}} %</p>\n            <p class=\"schemeTitileHead\">1 Year return</p>\n          </div>--><div class=\"col-xs-4 col-md-2 m-b5\"><p style=\"font-size: 12px;color: #ff8486;cursor: pointer\" ng-click=SelectScheme.toggleDetails($index) ng-if=!x.Expand>+ SHOW DETAILS</p><p style=\"font-size: 12px;color: #ff8486;cursor: pointer\" ng-click=SelectScheme.toggleDetails($index) ng-if=x.Expand>- HIDE DETAILS</p></div><div class=\"col-xs-12 col-md-2 m-b5\" ng-if=SelectScheme.DirectScheme><!-- <select\n                ng-model=\"x.selectedScheme\"\n                required>\n                <option value=\"\" selected>Select Scheme</option>\n\n              <option ng-repeat=\"value in x.directSchemes\"\n                  ng-selected=\"(x.selectedScheme.schemeCode == value.schemeCode ) ? value.schemeCode: \'\'\"\n              value=\"{{value}}\"> {{value.schemeName}}</option>\n            </select>   --><select ng-model=x.selectedScheme ng-options=\" item.schemeName for item in x.directSchemes\" ng-selected=\"x.selectedScheme.schemeCode == value.schemeCode\" ng-disabled=SelectScheme.distributorDetails.schemeCode style=\"width: 100%;height: 40px;border-radius: 6px\"><option value=\"\" selected>Select Scheme</option></select></div><div class=\"col-xs-12 col-md-2 m-b5\" ng-if=!SelectScheme.DirectScheme><!-- <select\n                ng-model=\"x.selectedScheme\"\n                required>\n              <option value=\"\" selected>Select Scheme</option>\n              <option ng-repeat=\"value in x.regularSchemes\"\n                  ng-selected=\"(x.selectedScheme.schemeCode == value.schemeCode ) ? value.schemeCode: \'\'\"\n                  value=\"{{value}}\"> {{value.schemeName}}</option>\n            </select>  --><select ng-model=x.selectedScheme ng-options=\" item.schemeName for item in x.regularSchemes\" ng-selected=\"x.selectedScheme.schemeCode == value.schemeCode\" ng-disabled=SelectScheme.distributorDetails.schemeCode style=\"width: 100%;height: 40px;border-radius: 6px\"><option value=\"\" selected>Select Scheme</option></select></div><div class=\"col-xs-6 col-md-1 m-b5\"><button class=btn-new-journey-color type=button ng-disabled=!x.selectedScheme style=\"color: white; height: 30px;width: 100px;border: none;border-radius: 15px;color: white;font-size: 12px\" ng-click=SelectScheme.getScheme(x)>INVEST</button></div><div class=col-md-12 ng-if=x.Expand><hr></div><div class=\"col-xs-12 col-md-12\" ng-if=x.Expand style=\"padding-bottom: 10px\"><div class=row><div class=\"col-xs-12 col-md-4\"><div ng-repeat=\"fundmanager in x.fundManagers\"><p class=\"schemeTitle m-m-top\">{{fundmanager}}</p></div><p class=schemeTitileHead>Fund Manager</p></div><div class=\"col-xs-12 col-md-4\"><p class=schemeTitle>{{x.suggestedInvestmentPeriod}}</p><p class=schemeTitileHead>Suggested Investment Period</p></div></div></div></div></div></div></div><style>.investmentTitle1{\n    font-weight: bold;\n  }</style>");
$templateCache.put("app/transactions/initiate/sip-purchase/invest-through/invest-through-with-folio-section.html","<section class=folio-and-invest-through-section><div class=investor-card><!-- Investor Image and Name --><div class=\"investor-info d-flex\"><div class=inv-img-wrapper ng-class=\"{\'default-img-shown\' : !Transaction.defaultData.profileImageUrl}\"><img http-src={{Transaction.defaultData.profileImageUrl}} alt=\"Investor Image\" class=investor-image ng-if=\"Transaction.defaultData && Transaction.defaultData.profileImageUrl\"> <img src=assets/images/icons/default-user-icon.svg alt=default-investor-image class=\"investor-image default\" ng-if=!Transaction.defaultData.profileImageUrl></div><div class=inv-name-wrapper><h6 class=\"investor-name f-family-inter f-weight-600\">Hi {{Transaction.folioInvestorName ? Transaction.folioInvestorName : Transaction.investorName | camelcase}}</h6><div class=\"tagline f-family-inter\">Embark on a journey towards achieving your goal.</div></div><!--      <i class=\"toggle-arrow\" ng-click=\"Transaction.toggleExpand()\">--><!--        <span ng-if=\"!Transaction.isExpanded\">&#9660;</span> &lt;!&ndash; Down arrow &ndash;&gt;--><!--        <span ng-if=\"Transaction.isExpanded\">&#9650;</span> &lt;!&ndash; Up arrow &ndash;&gt;--><!--      </i>--></div><!-- Additional Details (Initially Hidden on Mobile) --><div class=additional-details ng-show=\"Transaction.isExpanded || !Transaction.isMobileView\"><div class=folio-field-wrapper><div class=form-input><label for=folioInput class=form-label>Folio</label><select name=folio id=folioInput ng-change=Transaction.folioChanged(true) ng-model=Transaction.formData.folioNumber class=\"select-folio-list form-select\" ng-options=\"folio.folioNumber as folio.taxStatusForNewJourney disable when (!folio.activeFlag) for folio in Transaction.folioList\" ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Folio</option></select><span class=error-input ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid && Transaction.tForm.folio.$error.required\" ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div></div><fieldset ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber}\"><div class=slider-section><!-- Direct, Distributor, RIA Slider --><div class=form-input><div class=invest-through-options ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\"><div class=radio-button><input type=radio id=direct name=throughDistributor ng-value=true ng-model=Transaction.formData.isDirect ng-disabled=!Transaction.tForm.$valid><label class=\"btn btn-default\" for=direct ng-click=\"Transaction.changeThroughDistributor(\'DIRECT\')\">Direct</label></div><div class=radio-button><input type=radio id=distributor name=throughDistributor ng-value=true ng-model=Transaction.formData.isThroughDistributor ng-disabled=!Transaction.tForm.$valid><label class=\"btn btn-default\" for=distributor ng-click=\"Transaction.changeThroughDistributor(\'ARN\')\">Distributor</label></div><div class=radio-button><input type=radio name=throughDistributor id=ria ng-value=true ng-model=Transaction.formData.isThroughRia ng-disabled=!Transaction.tForm.$valid><label class=\"btn btn-default\" for=ria ng-click=\"Transaction.changeThroughDistributor(\'RIA\')\">RIA</label></div></div></div><!--Invest through distributor row--><div class=\"row distributor-sub-content\" ng-if=Transaction.formData.isThroughDistributor><div class=\"sub-broker-content mt-4\"><div class=\"col-sm-12 col-md-5 mb-3 pe-0\"><div class=form-input ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\"><input type=text class=form-control name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=\";Transaction.formData.subBrokerARN=\'\';Transaction.subBrokerName=\'\';Transaction.formData.subBrokerCode=\'\';Transaction.formData.euin = {};Transaction.euinData = {};Transaction.searchDistributor();Transaction.showArnLabel=false;\" ng-required=!Transaction.formData.distributorARN maxlength=10 ng-pattern=/^[0-9]{4,10}$/ placeholder=\"Broker ARN\" ng-focus=\"Transaction.showArnLabel=true\" ng-class=\"{\'pad-arn\': Transaction.showArnLabel || Transaction.formData.brokerCode}\"> <span class=highlight></span> <span class=bar></span> <span class=invest-arn ng-class=\"{\'visible\': Transaction.showArnLabel || Transaction.formData.brokerCode}\">ARN -</span><!--                    <span class=\"arn\" ng-show=\"Transaction.showArnLabel || Transaction.formData.brokerCode\">ARN -</span>--><!--                    <label>ARN</label>--><p ng-if=\"Transaction.formData.brokerName && Transaction.formData.brokerCode\" class=info-primary>Distributor Name: {{Transaction.formData.brokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.required) && (!Transaction.formData.distributorName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.pattern) && (!Transaction.formData.distributorName)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.brokerCodeError !== \'\' && !Transaction.tForm.brokerCode.$invalid\" ng-bind=Transaction.brokerCodeError></span></div></div><!-- OR Divider --><div class=\"col-lg-2 col-md-2 col-sm-12 text-center separator-wrapper\"><div class=or-divider><span class=divider-text>OR</span></div></div><div class=\"col-sm-12 col-md-5 ps-0 search-dis\"><div class=form-input ng-class=\"{error:Transaction.tForm.distributorName.$dirty && Transaction.tForm.distributorName.$invalid}\"><input type=text name=distributorName id=distributorName ng-change=\"Transaction.formData.subBrokerARN=\'\';Transaction.subBrokerName=\'\';Transaction.formData.subBrokerCode=\'\';Transaction.formData.euin = {};Transaction.euinData = {};Transaction.helper.searchDistributorByName();Transaction.formData.isEuin=true;\" ng-model=Transaction.formData.distributorName class=form-control placeholder=\"Search Distributor\" autocomplete=off ng-required=!Transaction.formData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><p ng-if=\"Transaction.formData.distributorName && Transaction.formData.brokerName\" class=info-primary>Distributor Name: {{Transaction.formData.brokerName}}</p><!--                <label>Search Distributor</label>--><drop-down list-data=Transaction.distributorList display-key=name display-key-second=arnCode hdfc-click=Transaction.helper.distributorListChanged(data) model=Transaction.formData.distributorARN for=distributorName></drop-down></div></div><!--            <div class=\"col-md-5 mb-3\"></div>--><div class=\"col-sm-12 col-md-12 mb-3\" ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\"><div class=form-input ng-class=\"{error:(Transaction.tForm.subBrokerARN.$dirty&&Transaction.tForm.subBrokerARN.$invalid)||(Transaction.subBrokerCodeError !== \'\')}\"><input type=text class=form-control name=subBrokerARN id=subBrokerARN ng-model=Transaction.formData.subBrokerARN ng-change=Transaction.changeSubBrokerArn() ng-blur=\"Transaction.fetchEuinListSubBroker(); Transaction.showSubArnLabel = false\" maxlength=10 ng-pattern=/^[0-9]{4,10}$/ placeholder=\"Sub Broker ARN\" autocomplete=off restrict-special-charcter ng-trim=false ng-focus=\"Transaction.showSubArnLabel = true\" ng-class=\"{\'pad-arn\': Transaction.showSubArnLabel || Transaction.formData.subBrokerARN}\"> <span class=invest-arn ng-class=\"{\'visible\': Transaction.showSubArnLabel || Transaction.formData.subBrokerARN}\">ARN -</span><p ng-if=Transaction.subBrokerName class=info-primary>Sub Broker Name: {{Transaction.subBrokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.subBrokerARN.$dirty && Transaction.tForm.subBrokerARN.$invalid && Transaction.tForm.subBrokerARN.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"Transaction.subBrokerCodeError != \'\'&& !Transaction.tForm.subBrokerARN.$error.pattern\" ng-bind=Transaction.subBrokerCodeError></span></div></div><div class=\"col-sm-12 col-md-12\" ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\"><div class=form-input ng-class={error:Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode class=form-control ng-model=Transaction.formData.subBrokerCode autocomplete=off ng-disabled=\"!Transaction.formData.subBrokerARN || Transaction.subBrokerCodeError !=\'\'\" ng-change=Transaction.changeSubBrokerCode() restrict-special-charcter placeholder=\"Sub Broker Code\" ng-trim=false> <span class=error-input ng-show=Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$error.required ng-bind=Transaction.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></div><div class=radio-block-content ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\"><div class=col-md-12><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=true ng-model=Transaction.formData.isEuin ng-click=\"Transaction.isCheckedTandC=false\" required> <span class=check></span> </span><span class=radio-label>EUIN</span></div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=false ng-model=Transaction.formData.isEuin ng-click=\"Transaction.euinData.euinNameCode=\'\';Transaction.filterEuinList();Transaction.isSelectedEuin=true;\"> <span class=check></span> </span><span class=radio-label>EUIN Declaration</span></div></div></div><div class=euin-block-content ng-if=\"!Transaction.isArnSuccess && Transaction.formData.isEuin != null && Transaction.formData.isEuin === true &&  Transaction.formData.isThroughDistributor\"><div class=\"col-md-12 form-input\"><div ng-class={error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}><input type=text name=euin id=euin class=form-select ng-model=Transaction.euinData.euinNameCode ng-change=Transaction.filterEuinList() placeholder=\"Select EUIN\" ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributorName) && !Transaction.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span><!--                    <label>Select Euin</label>--> <span class=error-input ng-show=\"(Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required) || (Transaction.tForm.euin.$touched && !Transaction.isSelectedEuin)\" ng-bind=Transaction.VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=Transaction.euinList display-key=euinName display-key-second=euinCode hdfc-click=Transaction.selectEuin(data) model=Transaction.formData.euin for=euin></list-drop-down></div></div></div><div class=euin-dec-block-content ng-if=\"!Transaction.isArnSuccess && Transaction.formData.isEuin != null && Transaction.formData.isEuin === false && Transaction.formData.isThroughDistributor\"><div class=\"checkbox col-md-12\"><input ng-model=Transaction.isCheckedTandC type=checkbox ng-disabled=Transaction.formData.isEuin ng-required=\"(Transaction.formData.brokerCode || !Transaction.isArnSuccess) && !Transaction.formData.isEuin\"> <i class=icon-checkbox></i><ng-bind-html ng-bind-html=Transaction.distributorMessage.content></ng-bind-html></div></div></div><!--Invest through RIA row--><div class=\"row ria-sub-content\" ng-if=Transaction.formData.isThroughRia><div class=\"col-sm-12 col-md-12 mt-4\"><div class=form-input ng-class=\"{error:(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid)||(Transaction.riaCodeError != \'\')}\"><input type=text name=riaCode id=riaCode ng-model=Transaction.formData.riaBrokerCode ng-change=Transaction.changeDistributorCode() autocomplete=off ng-blur=Transaction.searchDistributor(); ng-required=!Transaction.formData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ class=form-control placeholder=\"RIA Code\" capitalize> <span class=highlight></span> <span class=bar></span><p ng-if=\"Transaction.formData.riaBrokerCode && Transaction.formData.riaBrokerName\" class=info-primary>RIA Name: {{Transaction.formData.riaBrokerName}}</p><span class=error-input ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.required)\" ng-bind=Transaction.VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.pattern)\" ng-bind=Transaction.VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"Transaction.riaCodeError !== \'\' && !Transaction.tForm.riaCode.$invalid\" ng-bind=Transaction.riaCodeError></span></div></div><div class=\"checkbox col-md-12 col-sm-12\"><input ng-model=Transaction.isCheckedTandC type=checkbox ng-disabled=\"!Transaction.formData.riaBrokerCode || Transaction.riaCodeError !== \'\'\" ng-change=Transaction.setTandCVariable() ng-required=Transaction.formData.riaBrokerCode> <i class=icon-checkbox></i><ng-bind-html ng-bind-html=Transaction.riaMessage.content></ng-bind-html></div></div></div></fieldset></div></div></section>");
$templateCache.put("app/transactions/initiate/sip-purchase/purchase/purchase.html","<!--<div class=\"container-fluid sip-purchase main-section clearfix\" ng-hide=\"Transaction.formData.isSummaryViewEnabled\">--><!--  <div ng-init=\"Transaction.init()\" class=\"transaction-header\">--><!--    <h3 ng-if=\"Transaction.formData.investmentType === \'PURCHASE\'\" class=\"page-title\">Purchase</h3>--><!--    <h3 ng-if=\"Transaction.formData.investmentType === \'SIP\'\" class=\"page-title\">SIP</h3>--><!--    <button class=\"btn btn-light\" ng-disabled=\"!Transaction.formData.purchaseInSchemeName\"--><!--      ng-click=\"Transaction.saveForm()\">Save <i class=\"save-icon\"></i>--><!--    </button>--><!--  </div>--><!--  <div class=\"transaction-body\">--><!--    <section class=\"initiate-transaction\">--><!--      <form name=\"Transaction.tForm\" ng-keypress=\"Transaction.handleEnter($event)\" novalidate autocomplete=\"off\">--><!--        &lt;!&ndash;folio card section&ndash;&gt;--><!--        <div class=\"card\">--><!--          <div class=\"card-body folio-card\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-3\">--><!--                <div class=\"form-input folio-input\">--><!--                  <label for=\"folioInput\" class=\"form-label\">Existing Folio Number</label>--><!--                  <select name=\"folio\" id=\"folioInput\"--><!--                          ng-change=\"Transaction.folioChanged()\"--><!--                          ng-model=\"Transaction.formData.folioNumber\"--><!--                          class=\"select-folio-list form-select\"--><!--                          ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\"--><!--                          ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\"--><!--                          options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=\"Transaction.isRequired\">--><!--                    <option value=\"\">Select Folio</option>--><!--                  </select>--><!--                  <span class=\"error-input\"--><!--                        ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid && Transaction.tForm.folio.$error.required\"--><!--                        ng-bind=\"Transaction.VALIDATE_DATA.FOLIO_REQUIRED\"></span>--><!--                </div>--><!--              </div>--><!--              <div class=\"col-md-9 d-flex\">--><!--                <div class=\"investor-intro\">--><!--                  <div>--><!--                    Hi, <span>Pranali</span>--><!--                  </div>--><!--                  <div>--><!--                    Embark on a journey towards achieving your goal.--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--          </div>--><!--        </div>--><!--        &lt;!&ndash;folio card section ends here&ndash;&gt;--><!--        &lt;!&ndash;Scheme Details section start from here&ndash;&gt;--><!--        <div class=\"card\" ng-class=\"{\'disabled-block\': !Transaction.formData.folioNumber, \'anything-disabled\': !Transaction.formData.folioNumber}\">--><!--          <div class=\"card-header\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-12\">--><!--                <h5>Scheme Details</h5>--><!--              </div>--><!--            </div>--><!--          </div>--><!--          <div class=\"card-body\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-7\">--><!--                <div class=\"form-input\">--><!--                  <label class=\"form-label\">Invest Through</label>--><!--                  <div class=\"invest-through-options\" ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\">--><!--                    <div class=\"radio-button\">--><!--                      <input type=\"radio\" id=\"direct\" name=\"throughDistributor\" ng-value=\"true\"--><!--                             ng-model=\"Transaction.formData.isDirect\"--><!--                             ng-disabled=\"!Transaction.tForm.$valid\"/>--><!--                      <label class=\"btn btn-default\" for=\"direct\" ng-click=\"Transaction.changeThroughDistributor(\'DIRECT\')\">Direct</label>--><!--                    </div>--><!--                    <div class=\"radio-button\">--><!--                      <input type=\"radio\" id=\"distributor\" name=\"throughDistributor\" ng-value=\"true\"--><!--                             ng-model=\"Transaction.formData.isThroughDistributor\"--><!--                             ng-disabled=\"!Transaction.tForm.$valid\"/>--><!--                      <label class=\"btn btn-default\" for=\"distributor\" ng-click=\"Transaction.changeThroughDistributor(\'ARN\')\">Distributor</label>--><!--                    </div>--><!--                    <div class=\"radio-button\">--><!--                      <input type=\"radio\" name=\"throughDistributor\" id=\"ria\"--><!--                             ng-value=\"true\"--><!--                             ng-model=\"Transaction.formData.isThroughRia\"--><!--                             ng-disabled=\"!Transaction.tForm.$valid\"/>--><!--                      <label class=\"btn btn-default\" for=\"ria\" ng-click=\"Transaction.changeThroughDistributor(\'RIA\')\">RIA</label>--><!--                    </div>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            &lt;!&ndash;Invest through distributor row&ndash;&gt;--><!--            <div class=\"row distributor-sub-content\" ng-if=\"Transaction.formData.isThroughDistributor\">--><!--              <div class=\"sub-broker-content\">--><!--                <div class=\"col-sm-12 col-md-2\">--><!--                  <div class=\"form-input\"--><!--                       ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\">--><!--                    <input type=\"text\" class=\"form-control\" name=\"brokerCode\" id=\"brokerCode\"--><!--                           ng-model=\"Transaction.formData.brokerCode\"--><!--                           ng-change=\"Transaction.changeDistributorCode()\"--><!--                           autocomplete=\"off\"--><!--                           ng-blur=\"Transaction.searchDistributor();Transaction.showArnLabel=false\"--><!--                           ng-required=\"!Transaction.formData.distributorARN\"--><!--                           maxlength=\"10\" ng-pattern=\"/^[0-9]{4,10}$/\"--><!--                           placeholder=\"Broker ARN\"--><!--                           ng-focus=\"Transaction.showArnLabel=true\">--><!--                    <span class=\"highlight\"></span>--><!--                    <span class=\"bar\"></span>--><!--                    &lt;!&ndash;                    <span class=\"arn\" ng-show=\"Transaction.showArnLabel || Transaction.formData.brokerCode\">ARN -</span>&ndash;&gt;--><!--                    &lt;!&ndash;                    <label>ARN</label>&ndash;&gt;--><!--                    <p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name:--><!--                      {{Transaction.formData.brokerName}}</p>--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.required) && (!Transaction.formData.distributorName)\"--><!--                          ng-bind=\"Transaction.VALIDATE_DATA.BROKER_REQUIRED\"></span>--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.pattern) && (!Transaction.formData.distributorName)\"--><!--                          ng-bind=\"Transaction.VALIDATE_DATA.BROKER_VALID\"></span>--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"Transaction.brokerCodeError !== \'\' && !Transaction.tForm.brokerCode.$invalid\"--><!--                          ng-bind=\"Transaction.brokerCodeError\"></span>--><!--                  </div>--><!--                </div>--><!--                <div class=\"col-sm-12 col-md-2\" ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\">--><!--                  <div class=\"form-input\"--><!--                       ng-class=\"{error:(Transaction.tForm.subBrokerARN.$dirty&&Transaction.tForm.subBrokerARN.$invalid)||(Transaction.subBrokerCodeError !== \'\')}\">--><!--                    <input type=\"text\" class=\"form-control\" name=\"subBrokerARN\" id=\"subBrokerARN\"--><!--                           ng-model=\"Transaction.formData.subBrokerARN\"--><!--                           ng-change=\"Transaction.changeSubBrokerArn()\"--><!--                           ng-blur=\"Transaction.fetchEuinListSubBroker()\"--><!--                           maxlength=\"10\" ng-pattern=\"/^[0-9]{4,10}$/\"--><!--                           placeholder=\"Sub Broker ARN\"--><!--                           autocomplete=\"off\" restrict-special-charcter ng-trim=\"false\">--><!--                    <p ng-if=\"Transaction.subBrokerName\" class=\"info-primary\">Sub Broker Name:--><!--                      {{Transaction.subBrokerName}}</p>--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"(Transaction.tForm.subBrokerARN.$dirty && Transaction.tForm.subBrokerARN.$invalid && Transaction.tForm.subBrokerARN.$error.pattern)\"--><!--                          ng-bind=\"Transaction.VALIDATE_DATA.BROKER_VALID\"></span>--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"Transaction.subBrokerCodeError != \'\'&& !Transaction.tForm.subBrokerARN.$error.pattern\"--><!--                          ng-bind=\"Transaction.subBrokerCodeError\"></span>--><!--                  </div>--><!--                </div>--><!--                <div class=\"col-sm-12 col-md-2\" ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\">--><!--                  <div class=\"form-input\"--><!--                       ng-class=\"{error:Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$invalid}\">--><!--                    <input type=\"text\" name=\"subBrokerCode\" id=\"subBrokerCode\" class=\"form-control\"--><!--                           ng-model=\"Transaction.formData.subBrokerCode\"--><!--                           autocomplete=\"off\"--><!--                           ng-disabled=\"!Transaction.formData.subBrokerARN || Transaction.subBrokerCodeError !=\'\'\"--><!--                           ng-change=\"Transaction.changeSubBrokerCode()\"--><!--                           restrict-special-charcter--><!--                           placeholder=\"Sub Broker Code\"--><!--                           ng-trim=\"false\">--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$error.required\"--><!--                          ng-bind=\"Transaction.VALIDATE_DATA.SUB_BROKER_REQUIRED\"></span>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--              <div class=\"radio-block-content\" ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\">--><!--                <div class=\"col-md-6\">--><!--                  <div class=\"radio-block\">--><!--                    <span class=\"radio\">--><!--                      <input type=\"radio\"--><!--                             name=\"euinCheck\"--><!--                             ng-value=\"true\"--><!--                             ng-model=\"Transaction.formData.isEuin\"--><!--                             ng-click=\"Transaction.isCheckedTandC=false\"--><!--                             required=\"\"--><!--                             class=\"\" value=\"true\"--><!--                      >--><!--                      <span class=\"check\"></span>--><!--                    </span>--><!--                    <span class=\"radio-label\">EUIN</span>--><!--                  </div>--><!--                  <div class=\"radio-block\">--><!--                    <span class=\"radio\">--><!--                      <input type=\"radio\"--><!--                             name=\"euinCheck\"--><!--                             ng-value=\"false\"--><!--                             ng-model=\"Transaction.formData.isEuin\"--><!--                             ng-click=\"Transaction.euinData.euinNameCode=\'\';Transaction.filterEuinList();Transaction.isSelectedEuin=true;\"--><!--                             class=\"\"--><!--                             value=\"false\"--><!--                      >--><!--                      <span class=\"check\"></span>--><!--                    </span>--><!--                    <span class=\"radio-label\">EUIN Declaration</span>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--              <div class=\"euin-block-content\" ng-if=\"!Transaction.isArnSuccess && Transaction.formData.isEuin != null && Transaction.formData.isEuin === true &&  Transaction.formData.isThroughDistributor\">--><!--                <div class=\"col-md-4 form-input\">--><!--                  <div class=\"\" ng-class=\"{error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}\">--><!--                    <input type=\"text\" name=\"euin\" id=\"euin\" class=\"form-select\"--><!--                           ng-model=\"Transaction.euinData.euinNameCode\"--><!--                           ng-change=\"Transaction.filterEuinList()\"--><!--                           placeholder=\"Select EUIN\"--><!--                           ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributorName) && !Transaction.isCheckedTandC\"--><!--                           autocomplete=\"off\">--><!--                    <span class=\"highlight\"></span>--><!--                    <span class=\"bar\"></span>--><!--                    &lt;!&ndash;                    <label>Select Euin</label>&ndash;&gt;--><!--                    <span class=\"error-input\" ng-show=\"(Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required) || !Transaction.isSelectedEuin\"--><!--                          ng-bind=\"Transaction.VALIDATE_DATA.EUIN_REQUIRED\"></span>--><!--                    <list-drop-down list-data=\"Transaction.euinList\"--><!--                                    display-key=\"euinName\"--><!--                                    display-key-second=\"euinCode\"--><!--                                    hdfc-click=\"Transaction.selectEuin(data)\"--><!--                                    model=\"Transaction.formData.euin\"--><!--                                    for=\"euin\">--><!--                    </list-drop-down>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--              <div class=\"euin-dec-block-content\" ng-if=\"!Transaction.isArnSuccess && Transaction.formData.isEuin != null && Transaction.formData.isEuin === false && Transaction.formData.isThroughDistributor\">--><!--                <div class=\"checkbox col-md-6\">--><!--                  <input--><!--                    ng-model=\"Transaction.isCheckedTandC\"--><!--                    type=\"checkbox\"--><!--                    ng-disabled=\"Transaction.formData.isEuin\"--><!--                    ng-required=\"(Transaction.formData.brokerCode || !Transaction.isArnSuccess) && !Transaction.formData.isEuin\">--><!--                  <i class=\"icon-checkbox\"></i>--><!--                  <ng-bind-html--><!--                    ng-bind-html = \"Transaction.riaMessage.content\"--><!--                  ></ng-bind-html>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            &lt;!&ndash;Invest through RIA row&ndash;&gt;--><!--            <div class=\"row ria-sub-content\" ng-if=\"Transaction.formData.isThroughRia\">--><!--              <div class=\"col-sm-12 col-md-4\">--><!--                <div class=\"form-input\"--><!--                     ng-class=\"{error:(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid)||(Transaction.riaCodeError != \'\')}\">--><!--                  <input type=\"text\" name=\"riaCode\" id=\"riaCode\"--><!--                         ng-model=\"Transaction.formData.riaBrokerCode\"--><!--                         ng-change=\"Transaction.changeDistributorCode()\"--><!--                         autocomplete=\"off\"--><!--                         ng-blur=\"Transaction.searchDistributor();\"--><!--                         ng-required=\"!Transaction.formData.distributorARN\"--><!--                         maxlength=\"12\" ng-pattern=\"/^[A-Z0-9]{12}/\"--><!--                         class=\"form-control\"--><!--                         placeholder=\"RIA Code\"--><!--                         capitalize--><!--                  >--><!--                  <span class=\"highlight\"></span>--><!--                  <span class=\"bar\"></span>--><!--                  <p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name: {{Transaction.formData.brokerName}}</p>--><!--                  <span class=\"error-input\"--><!--                        ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.required)\"--><!--                        ng-bind=\"Transaction.VALIDATE_DATA.RIA_REQUIRED\"></span>--><!--                  <span class=\"error-input\"--><!--                        ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.pattern)\"--><!--                        ng-bind=\"Transaction.VALIDATE_DATA.RIA_INVALID\"></span>--><!--                  <span class=\"error-input\"--><!--                        ng-show=\"Transaction.riaCodeError !== \'\' && !Transaction.tForm.riaCode.$invalid\"--><!--                        ng-bind=\"Transaction.riaCodeError\"></span>--><!--                </div>--><!--              </div>--><!--              <div class=\"checkbox col-md-10\">--><!--                <input ng-model=\"Transaction.isCheckedTandC\" type=\"checkbox\"--><!--                       ng-disabled=\"!Transaction.formData.riaBrokerCode || Transaction.riaCodeError !== \'\'\"--><!--                       ng-change=\"Transaction.setTandCVariable();\"--><!--                       ng-required=\"Transaction.formData.riaBrokerCode\"/>--><!--                <i class=\"icon-checkbox\"></i>--><!--                <ng-bind-html--><!--                  ng-bind-html = \"Transaction.riaMessage.content\"--><!--                ></ng-bind-html>--><!--              </div>--><!--            </div>--><!--            &lt;!&ndash;Scheme listing row&ndash;&gt;--><!--            <div class=\"row\">--><!--              <div class=\"col-md-5\">--><!--                <div class=\"scheme-fields\">--><!--                  <div class=\"row\">--><!--                    <div class=\"col-md-9\">--><!--                      <div class=\"form-input\">--><!--                        <label for=\"pInScheme1\" class=\"form-label\">Select a Scheme</label>--><!--                        <div class=\"search-input\" ng-class=\"{\'anything-disabled\':Transaction.formData.dynamicData.readOnly}\">--><!--                          <input type=\"text\" name=\"pInScheme1\" id=\"pInScheme1\" ng-change=\"Transaction.filterPurchaseInSchemeList()\"--><!--                                 ng-model=\"Transaction.formData.purchaseInSchemeName\" onpaste=\"return false;\" ondrop=\"return false;\"--><!--                                 autocomplete=\"off\" ng-disabled=\"!Transaction.formData.folioNumber\" class=\"form-select\" required>--><!--                          <span class=\"error-input\"--><!--                                ng-show=\"Transaction.tForm.pInScheme1.$dirty && Transaction.tForm.pInScheme1.$invalid && Transaction.tForm.pInScheme1.$error.required\"--><!--                                ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--                          <drop-down list-data=\"Transaction.purchaseInSchemeList\" display-key=\"scheme\"--><!--                                     hdfc-click=\"Transaction.purchaseInSchemeChanged(data)\" model=\"Transaction.formData.schemeCode\"--><!--                                     for=\"pInScheme1\">--><!--                          </drop-down>--><!--                        </div>--><!--                      </div>--><!--                    </div>--><!--                    <div class=\"col-md-3\">--><!--                      <div ng-if=\"!Transaction.formData.dynamicData.readOnly\" class=\"scheme-options\">--><!--                        <span class=\"else-option\">--><!--                          OR--><!--                        </span>--><!--                        <button class=\"btn btn-link text-primary cursor-pointer\" ng-disabled=\"!Transaction.formData.folioNumber\"--><!--                           ng-click=\"Transaction.purchaseSchemeListModal()\">View All </button>--><!--                      </div>--><!--                    </div>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            &lt;!&ndash; dividend options listing row starts here &ndash;&gt;--><!--            <div class=\"row\">--><!--              <div class=\"col-md-7 dividend-option-wrapper\" ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\"--><!--                   ng-if=\"Transaction.formData.purchaseInvestmentOption === Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">--><!--                <div class=\"radio-block\" ng-repeat=\"_option in Transaction.dividendOptions\"--><!--                     ng-class=\"{\'anything-disabled\': ((_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.purchaseValidations.isGrowth === false && Transaction.purchaseValidations.dividendReinvestmentApplicable === false)--><!--                 || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.purchaseValidations.isGrowth === false && Transaction.purchaseValidations.dividendPayoutApplicable === false)--><!--                 )}\">--><!--                  <span class=\"radio\">--><!--                    <input type=\"radio\" id=\"sDividendOption{{_option}}\" ng-value=\"_option\"--><!--                           ng-disabled=\"(_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)--><!--                           || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendPayoutApplicable === false)\"--><!--                           name=\"sDividendOption\"--><!--                           ng-model=\"Transaction.formData.dividendOption\"--><!--                           ng-change=\"Transaction.changeDividendOption()\"--><!--                    />--><!--                    <span class=\"check\"></span>--><!--                  </span>--><!--                  <span class=\"radio-label\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            <div class=\"row form-group\"--><!--                 ng-if=\"Transaction.isSchemeTypeELSS && Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">--><!--              <div class=\"info-primary\">--><!--                Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS--><!--              </div>--><!--            </div>--><!--            &lt;!&ndash; dividend options listing row ends here &ndash;&gt;--><!--          </div>--><!--        </div>--><!--        &lt;!&ndash;scheme details section ends here&ndash;&gt;--><!--        &lt;!&ndash;Investment details section starts from here&ndash;&gt;--><!--        <div class=\"card\" ng-class=\"{\'disabled-block\': !Transaction.formData.folioNumber, \'anything-disabled\': !Transaction.formData.folioNumber}\">--><!--          <div class=\"card-header\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-12\">--><!--                <h5>Instalment Details</h5>--><!--              </div>--><!--            </div>--><!--          </div>--><!--          <div class=\"card-body\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-5\">--><!--                <div class=\"amount-fields\">--><!--                  <div class=\"row\">--><!--                    <div class=\"col-md-9\">--><!--                      <div class=\"form-input\" ng-class=\"{error:(Transaction.tForm.pAmount.$dirty && Transaction.tForm.pAmount.$invalid)||(Transaction.formData.amount && Transaction.isPurchaseMin),\'has-data\':Transaction.formData.amount}\">--><!--                        <label class=\"form-label\">Amount</label>--><!--                        <div class=\"input-group\">--><!--                          <span class=\"input-group-text\" id=\"rupee-addon\">--><!--                            <img src=\"assets/images/icons/rupee-icon-black.svg\" alt=\"rupee-icon\" />--><!--                          </span>--><!--                          <input type=\"number\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=\"pAmount\"--><!--                                 ng-model=\"Transaction.formData.amount\"--><!--                                 ng-change=\"Transaction.checkPurchaseValidations()\"--><!--                                 onkeyup=\"NumToWord(this.value,\'divDisplayWords\');\"--><!--                                 ondrop=\"return false;\"--><!--                                 ng-disabled=\"(!Transaction.formData.folioNumber || !Transaction.formData.schemeCode)\"--><!--                                 class=\"form-control\"--><!--                                 aria-describedby=\"rupee-addon\"--><!--                                 required>--><!--                        </div>--><!--                        <span class=\"error-input \"--><!--                              ng-show=\"Transaction.tForm.pAmount.$dirty && Transaction.tForm.pAmount.$error.required\"--><!--                              ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>--><!--                        <span ng-if=\"Transaction.formData.amount && Transaction.isPurchaseMin\" class=\"error-input \">--><!--                          {{\'Minimum amount should be \'+ Transaction.purchaseMinAmount}}<span ng-if=\"Transaction.formData.amount % 1 != 0\">, </span>--><!--                        </span>--><!--                        <span ng-if=\"Transaction.formData.amount && !Transaction.isPurchaseMin && (Transaction.purchaseValidations.purchaseMultiple && !Transaction.isMultiples)\" class=\"error-input \">--><!--                          Please provide amount in multiples of &#8377;{{Transaction.purchaseValidations.purchaseMultiple|unit}}<span ng-if=\"Transaction.formData.amount % 1 != 0\">, </span>--><!--                        </span>--><!--                        <span ng-if=\"!Transaction.tForm.pAmount.$error.required && Transaction.formData.amount % 1 != 0\" class=\"error-input \" ng-class=\"{errorDown: Transaction.formData.amount && Transaction.isPurchaseMin}\">{{\"Amount can\'t be decimal\"}}</span>--><!--                        <label class=\"form-label\" id=\"divDisplayWords\">{{Transaction.amountInWords}}</label>--><!--                      </div>--><!--                    </div>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--          </div>--><!--        </div>--><!--        &lt;!&ndash;Investment details section ends here&ndash;&gt;--><!--        &lt;!&ndash;Payment details section starts from here&ndash;&gt;--><!--        <div class=\"card\">--><!--          <div class=\"card-header\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-12\">--><!--                <h5>Payment Options</h5>--><!--              </div>--><!--            </div>--><!--          </div>--><!--          <div class=\"card-body\">--><!--            <transaction-payment--><!--              class=\"payment-template\"--><!--              screen=\"TRANSACTION\"--><!--              form-data=\"Transaction.formData\">--><!--            </transaction-payment>--><!--          </div>--><!--        </div>--><!--        &lt;!&ndash;Payment details section ends here&ndash;&gt;--><!--        <div class=\"row\">--><!--          <div class=\"col-md-12\">--><!--            <button class=\"btn btn-link disclaimer-link f-family-inter f-weight-500\" type=\"button\">Read Disclaimer</button>--><!--          </div>--><!--        </div>--><!--      </form>--><!--<header>\n        <form name=\"fForm\" novalidate  autocomplete=\"off\">\n\n          <div class=\"pull-left or-part\" ng-if=\"Transaction.profile.folioCreationEnabled && !Transaction.formData.dynamicData.readOnly && Transaction.formData.modifyAction !== \'modifySip\'\"> OR</div>\n          <div ng-if=\"Transaction.profile.folioCreationEnabled && !Transaction.formData.dynamicData.readOnly && Transaction.formData.modifyAction !== \'modifySip\'\" class=\"pull-left text-primary cursor-pointer\"\n               ng-click=\"Transaction.redirectToFolioCreation();\">Proceed with a New Folio\n          </div>\n        </form>\n      </header>--><!--<fieldset ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\">\n        <div class=\"content-area\">\n          <form name=\"Transaction.tForm\" novalidate autocomplete=\"off\">\n            <div class=\"col-md-12\">\n              <div class=\"row borderline\">\n                <div class=\"col-md-12 row\">\n                  <table class=\"table borderless top-part\">\n                    <tr ng-if=\"false\">\n                      <td>\n                        Investment Type\n                      </td>\n                      <td> :</td>\n                      <td>\n                        <div class=\"radio-block\">\n                      <span class=\"radio\">\n                        <input type=\"radio\" id=\"purchase\" name=\"investmentType\"\n                               ng-model=\"Transaction.formData.investmentType\"\n                               ng-disabled=\"!fForm.$valid\"\n                               ng-value=\"Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE\"/>\n                        <span class=\"check\"></span>\n                      </span>\n                          <span class=\"radio-label\">Purchase</span>\n                        </div>\n\n                        <div class=\"radio-block\">\n                       <span class=\"radio\">\n                        <input type=\"radio\" id=\"sip\" name=\"investmentType\"\n                               ng-model=\"Transaction.formData.investmentType\"\n                               ng-disabled=\"!fForm.$valid\"\n                               ng-value=\"Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"/>\n                        <span class=\"check\"></span>\n                      </span>\n                          <span class=\"radio-label\">SIP</span>\n                        </div>\n                      </td>\n                    </tr>\n                    <tr>\n                      <td>\n                        Investor Name\n                      </td>\n                      <td> :</td>\n                      <td>\n                        {{Transaction.folioInvestorName||Transaction.formData.folioInvestorName}}\n                      </td>\n                    </tr>\n                    <tr>\n                      <td>\n                        Invest through\n                      </td>\n                      <td> :</td>\n                      <td>\n                        <div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\"\n                             class=\"radio-block\">\n                       <span class=\"radio\">\n                        <input type=\"radio\" name=\"throughDistributor\" ng-value=\"true\"\n                               ng-model=\"Transaction.formData.isDirect\"\n                               ng-disabled=\"!fForm.$valid\"\n                               ng-click=\"Transaction.changeThroughDistributor(\'DIRECT\')\"/>\n                        <span class=\"check\"></span>\n                      </span>\n                          <span class=\"radio-label\">Direct</span>\n                        </div>\n\n                        <div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\"\n                             class=\"radio-block\">\n                    <span class=\"radio\">\n                      <input type=\"radio\" name=\"throughDistributor\" ng-value=\"true\"\n                             ng-model=\"Transaction.formData.isThroughDistributor\"\n                             ng-disabled=\"!fForm.$valid\"\n                             ng-click=\"Transaction.changeThroughDistributor(\'ARN\')\"/>\n                      <span class=\"check\"></span>\n                    </span>\n                          <span class=\"radio-label\">Distributor</span>\n                        </div>\n\n                        <div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\"\n                             class=\"radio-block\">\n                        <span class=\"radio\">\n                          <input type=\"radio\" name=\"investThrough\"\n                                 ng-value=\"true\"\n                                 ng-model=\"Transaction.formData.isThroughRia\"\n                                 ng-disabled=\"!fForm.$valid\"\n                                 ng-change=\"Transaction.changeThroughDistributor(\'RIA\')\"/>\n                          <span class=\"check\"></span>\n                        </span>\n                          <span class=\"radio-label\">RIA</span>\n                        </div>\n                      </td>\n                    </tr>\n                    <tr ng-if=\"Transaction.formData.isThroughDistributor\">\n                      <td></td>\n                      <td></td>\n                      <td>\n                        <div class=\"col-sm-12 col-md-3\">\n                          <div class=\"input-normal\"\n                               ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\">\n                            <input type=\"text\" class=\"arn-no\" name=\"brokerCode\" id=\"brokerCode\"\n                                   ng-model=\"Transaction.formData.brokerCode\"\n                                   ng-change=\"Transaction.changeDistributorCode()\"\n                                   autocomplete=\"off\"\n                                   ng-blur=\"Transaction.searchDistributor();Transaction.showArnLabel=false\"\n                                   ng-required=\"!Transaction.formData.distributorARN\"\n                                   maxlength=\"10\" ng-pattern=\"/^[0-9]{4,10}$/\"\n                                   ng-focus=\"Transaction.showArnLabel=true\">\n                            <span class=\"highlight\"></span>\n                            <span class=\"bar\"></span>\n                            <span class=\"arn\" ng-show=\"Transaction.showArnLabel || Transaction.formData.brokerCode\">ARN -</span>\n                            <label>ARN</label>\n                            <p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name:\n                              {{Transaction.formData.brokerName}}</p>\n                            <span class=\"error-input\"\n                                  ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.required) && (!Transaction.formData.distributorName)\"\n                                  ng-bind=\"Transaction.VALIDATE_DATA.BROKER_REQUIRED\"></span>\n                            <span class=\"error-input\"\n                                  ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.pattern) && (!Transaction.formData.distributorName)\"\n                                  ng-bind=\"Transaction.VALIDATE_DATA.BROKER_VALID\"></span>\n                            <span class=\"error-input\"\n                                  ng-show=\"Transaction.brokerCodeError !== \'\' && !Transaction.tForm.brokerCode.$invalid\"\n                                  ng-bind=\"Transaction.brokerCodeError\"></span>\n                          </div>\n                        </div>\n                        <span class=\"col-sm-12 col-md-1 or-part text-center\">OR</span>\n                        <div class=\"col-sm-12 col-md-3\">\n                          <div class=\"input-select input-normal\"\n                               ng-class=\"{error:Transaction.tForm.distributorName.$dirty && Transaction.tForm.distributorName.$invalid}\">\n                            <input type=\"text\" name=\"distributorName\" id=\"distributorName\"\n                                   ng-change=\"Transaction.searchDistributorByName();Transaction.formData.isEuin=true\"\n                                   ng-model=\"Transaction.formData.distributorName\"\n                                   autocomplete=\"off\" ng-required=\"!Transaction.formData.brokerCode\" only-alphabets>\n                            <span class=\"highlight\"></span>\n                            <span class=\"bar\"></span>\n                            <label>Search Distributor</label>\n                            <drop-down list-data=\"Transaction.distributorList\"\n                                       display-key=\"name\"\n                                       display-key-second=\"arnCode\"\n                                       hdfc-click=\"Transaction.distributorListChanged(data)\"\n                                       model=\"Transaction.formData.distributorARN\"\n                                       for=\"distributorName\">\n                            </drop-down>\n                          </div>\n                        </div>\n                      </td>\n                    </tr>\n                    &lt;!&ndash;RIA sections&ndash;&gt;\n                    <tr ng-if=\"Transaction.formData.isThroughRia\">\n                      <td>RIA Code</td>\n                      <td> :</td>\n                      <td>\n                        <div class=\"col-sm-12 col-md-4\">\n                          <div class=\"input-normal\"\n                               ng-class=\"{error:(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid)||(Transaction.riaCodeError != \'\')}\">\n                            <input type=\"text\" name=\"riaCode\" id=\"riaCode\"\n                                   ng-model=\"Transaction.formData.riaBrokerCode\"\n                                   ng-change=\"Transaction.changeDistributorCode()\"\n                                   autocomplete=\"off\"\n                                   ng-blur=\"Transaction.searchDistributor();\"\n                                   ng-required=\"!Transaction.formData.distributorARN\"\n                                   maxlength=\"12\" ng-pattern=\"/^[A-Z0-9]{12}/\"\n                                   capitalize\n                            >\n                            <span class=\"highlight\"></span>\n                            <span class=\"bar\"></span>\n                            &lt;!&ndash;<p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name: {{Transaction.formData.brokerName}}</p>&ndash;&gt;\n                            <span class=\"error-input\"\n                                  ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.required)\"\n                                  ng-bind=\"Transaction.VALIDATE_DATA.RIA_REQUIRED\"></span>\n                            <span class=\"error-input\"\n                                  ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.pattern)\"\n                                  ng-bind=\"Transaction.VALIDATE_DATA.RIA_INVALID\"></span>\n                            <span class=\"error-input\"\n                                  ng-show=\"Transaction.riaCodeError !== \'\' && !Transaction.tForm.riaCode.$invalid\"\n                                  ng-bind=\"Transaction.riaCodeError\"></span>\n                          </div>\n                        </div>\n                      </td>\n                    </tr>\n                    &lt;!&ndash;RIA sections ends here&ndash;&gt;\n                  </table>\n                  <fieldset ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\">\n                    <table class=\"table borderless top-part\">\n\n                      <tr ng-if=\"Transaction.formData.isThroughDistributor\">\n                        <td></td>\n                        <td></td>\n                        <td>\n                          <div class=\"col-sm-12 col-md-3\">\n                            <div class=\"input-normal\"\n                                 ng-class=\"{error:(Transaction.tForm.subBrokerARN.$dirty&&Transaction.tForm.subBrokerARN.$invalid)||(Transaction.subBrokerCodeError !== \'\')}\">\n                              <input type=\"text\" class=\"arn-no\" name=\"subBrokerARN\" id=\"subBrokerARN\"\n                                     ng-model=\"Transaction.formData.subBrokerARN\"\n                                     ng-change=\"Transaction.changeSubBrokerArn()\"\n                                     ng-blur=\"Transaction.fetchEuinListSubBroker()\"\n                                     maxlength=\"10\" ng-pattern=\"/^[0-9]{4,10}$/\"\n                                     autocomplete=\"off\" restrict-special-charcter ng-trim=\"false\">\n                              <span class=\"highlight\"></span>\n                              <span class=\"bar\"></span>\n                              <span class=\"arn\">ARN -</span>\n                              <label>Sub Broker ARN</label>\n                              <p ng-if=\"Transaction.subBrokerName\" class=\"info-primary\">Sub Broker Name:\n                                {{Transaction.subBrokerName}}</p>\n                              <span class=\"error-input\"\n                                    ng-show=\"(Transaction.tForm.subBrokerARN.$dirty && Transaction.tForm.subBrokerARN.$invalid && Transaction.tForm.subBrokerARN.$error.pattern)\"\n                                    ng-bind=\"Transaction.VALIDATE_DATA.BROKER_VALID\"></span>\n                              <span class=\"error-input\"\n                                    ng-show=\"Transaction.subBrokerCodeError != \'\'&& !Transaction.tForm.subBrokerARN.$error.pattern\"\n                                    ng-bind=\"Transaction.subBrokerCodeError\"></span>\n                            </div>\n                          </div>\n                          <span class=\"col-sm-12 col-md-1\"></span>\n                          <div class=\"col-sm-12 col-md-3\">\n                            <div class=\"input-normal\"\n                                 ng-class=\"{error:Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$invalid}\">\n                              <input type=\"text\" name=\"subBrokerCode\" id=\"subBrokerCode\"\n                                     ng-model=\"Transaction.formData.subBrokerCode\"\n                                     autocomplete=\"off\"\n                                     ng-disabled=\"!Transaction.formData.subBrokerARN || Transaction.subBrokerCodeError !=\'\'\"\n                                     ng-change=\"Transaction.changeSubBrokerCode()\"\n                                     restrict-special-charcter\n                                     ng-trim=\"false\">\n                              <span class=\"highlight\"></span>\n                              <span class=\"bar\"></span>\n                              <label>Sub Broker Code</label>\n                              <span class=\"error-input\"\n                                    ng-show=\"Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$error.required\"\n                                    ng-bind=\"Transaction.VALIDATE_DATA.SUB_BROKER_REQUIRED\"></span>\n                            </div>\n                          </div>\n                        </td>\n                      </tr>\n                      <tr ng-if=\"Transaction.formData.isThroughDistributor\">\n                        <td></td>\n                        <td></td>\n                        <td>\n                          <div class=\"radio-block\">\n                    <span class=\"radio\">\n                      <input type=\"radio\" name=\"euinCheck\" ng-value=\"true\"\n                             ng-model=\"Transaction.formData.isEuin\"\n                             ng-click=\"Transaction.isCheckedTandC=false\"\n                             required/>\n                      <span class=\"check\"></span>\n                    </span>\n                            <span class=\"radio-label\">EUIN</span>\n                          </div>\n                          <div class=\"radio-block\">\n                       <span class=\"radio\">\n                        <input type=\"radio\" name=\"euinCheck\" ng-value=\"false\"\n                               ng-model=\"Transaction.formData.isEuin\"\n                               ng-click=\"Transaction.euinData.euinNameCode=\'\';Transaction.filterEuinList();Transaction.isSelectedEuin=true;\"/>\n                        <span class=\"check\"></span>\n                      </span>\n                            <span class=\"radio-label\">EUIN Declaration</span>\n                          </div>\n                        </td>\n                      </tr>\n                      <tr\n                        ng-if=\"Transaction.formData.isEuin != null && Transaction.formData.isEuin === false && Transaction.formData.isThroughDistributor\"\n                        ng-hide=\"!Transaction.distributorMessage\"\n                      >\n                        <td></td>\n                        <td></td>\n                        <td >\n                          <div class=\"checkbox\">\n                            <input ng-model=\"Transaction.isCheckedTandC\" type=\"checkbox\"\n                                   ng-disabled=\"Transaction.formData.isEuin\"\n                                   ng-required=\"(Transaction.formData.brokerCode || !Transaction.isArnSuccess) && !Transaction.formData.isEuin\"/>\n                            <i class=\"icon-checkbox\"></i>\n\n                            <ng-bind-html\n                              ng-bind-html = \"Transaction.distributorMessage.content\"\n                            ></ng-bind-html>\n\n                          </div>\n                        </td>\n                      </tr>\n\n                      <tr\n                        ng-if=\"Transaction.formData.isEuin != null && Transaction.formData.isEuin === true &&  Transaction.formData.isThroughDistributor\">\n                        <td></td>\n                        <td></td>\n                        <td>\n                          <div class=\"input-select input-normal selectfield\" ng-class=\"{error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}\">\n                            <input type=\"text\" name=\"euin\" id=\"euin\"\n                                   ng-model=\"Transaction.euinData.euinNameCode\"\n                                   ng-change=\"Transaction.filterEuinList()\"\n                                   ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributorName) && !Transaction.isCheckedTandC\"\n                                   autocomplete=\"off\">\n                            <span class=\"highlight\"></span>\n                            <span class=\"bar\"></span>\n                            <label>Select Euin</label>\n                            &lt;!&ndash;ng-disabled=\"!Transaction.euinList.length || Transaction.isArnSuccess || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess)\"&ndash;&gt;\n                            <span class=\"error-input\" ng-show=\"(Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required) || !Transaction.isSelectedEuin\"\n                                  ng-bind=\"Transaction.VALIDATE_DATA.EUIN_REQUIRED\"></span>\n                            <list-drop-down list-data=\"Transaction.euinList\"\n                                            display-key=\"euinName\"\n                                            display-key-second=\"euinCode\"\n                                            hdfc-click=\"Transaction.selectEuin(data)\"\n                                            model=\"Transaction.formData.euin\"\n                                            for=\"euin\">\n                            </list-drop-down>\n                          </div>\n                        </td>\n                      </tr>\n                    </table>\n                  </fieldset>\n                  <fieldset ng-class=\"{\'anything-disabled\': !Transaction.formData.riaBrokerCode || Transaction.riaCodeError !== \'\'}\" ng-hide=\"!Transaction.riaMessage\">\n                    <table class=\"table borderless top-part\">\n                      <tr ng-if=\"Transaction.formData.isThroughRia\">\n                        <td>\n                          <div class=\"checkbox\">\n                            <input ng-model=\"Transaction.isCheckedTandC\" type=\"checkbox\"\n                                   ng-disabled=\"!Transaction.formData.riaBrokerCode || Transaction.riaCodeError !== \'\'\"\n                                   ng-change=\"Transaction.setTandCVariable();\"\n                                   ng-required=\"Transaction.formData.riaBrokerCode\"/>\n                            <i class=\"icon-checkbox\"></i>\n\n                            <ng-bind-html\n                              ng-bind-html = \"Transaction.riaMessage.content\"\n                            ></ng-bind-html>\n\n                          </div>\n                        </td>\n                      </tr>\n                    </table>\n                  </fieldset>\n                </div>\n              </div>\n\n              &lt;!&ndash;<div data-ng-switch=\"Transaction.formData.investmentType\">\n                <div data-ng-switch-when=\"PURCHASE\">\n                  <div data-ng-include=\"\'app/transactions/initiate/sip-purchase/purchase/purchase.html\'\"></div>\n                </div>\n                <div data-ng-switch-when=\"SIP\">\n                  <div data-ng-include=\"\'app/transactions/initiate/sip-purchase/sip/sip.html\'\"></div>\n                </div>\n              </div>&ndash;&gt;\n\n              <div class=\"row\" ng-if=\"false\">\n                <div class=\"add-button\" ng-if=\"!Transaction.formData.optionalInvestmentType\"\n                     ng-click=\"fForm.$valid&&Transaction.addOptionalTransaction()\">\n                  <i class=\"expand-block-icon\"></i> Add\n                  {{Transaction.formData.investmentType===Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE?\'Sip\':\'Lumpsum\'}}\n                  Transaction (Optional)\n                </div>\n                <div class=\"add-button\" ng-if=\"Transaction.formData.optionalInvestmentType\"\n                     ng-click=\"Transaction.removeOptionalScheme()\">\n                  <i class=\"collapse-block-icon\"></i> Remove\n                  {{Transaction.formData.investmentType===Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE?\'Sip\':\'Lumpsum\'}}\n                  Transaction (Optional)\n                </div>\n\n              </div>\n\n              &lt;!&ndash;<div data-ng-switch=\"Transaction.formData.optionalInvestmentType\">\n                <div data-ng-switch-when=\"PURCHASE\">\n                  <div data-ng-include=\"\'app/transactions/initiate/sip-purchase/purchase/purchase.html\'\"></div>\n                </div>\n                <div data-ng-switch-when=\"SIP\">\n                  <div data-ng-include=\"\'app/transactions/initiate/sip-purchase/sip/sip.html\'\"></div>\n                </div>\n              </div>&ndash;&gt;\n            </div>\n            <div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"form-footer\">\n              <button ng-if=\"Transaction.transactionType==\'SIP\' && Transaction.formData.modifyAction !== \'modifySip\'\"\n                      ng-disabled=\"!Transaction.formData.inSchemeName\" class=\" btn btn-secondary-action\" type=\"button\"\n                      ng-click=\"Transaction.saveForm()\">Save\n              </button>\n              <button ng-if=\"Transaction.transactionType==\'PURCHASE\' || Transaction.transactionType==\'SCHEDULE_TRANSACTION_PURCHASE\'\"\n                      ng-disabled=\"!Transaction.formData.purchaseInSchemeName\" class=\" btn btn-secondary-action\"\n                      type=\"button\" ng-click=\"Transaction.saveForm()\">Save\n              </button>\n              &lt;!&ndash; Schedule Transaction button  &ndash;&gt;\n              <button ng-if=\"Transaction.transactionType==\'PURCHASE\' || Transaction.transactionType==\'SCHEDULE_TRANSACTION_PURCHASE\'\"\n                      ng-disabled=\"!Transaction.tForm.$valid||\n                Transaction.isInvalidForm || !Transaction.helper.isFormValid() || !Transaction.formData.purchaseInSchemeCode || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || !Transaction.isSelectedEuin || Transaction.purchaseValidations.purchaseMultiple && !Transaction.isMultiples\"\n                      class=\" btn btn-secondary-action\" type=\"button\"\n                      ng-click=\"Transaction.goToScheduleTransaction()\">\n                Schedule Transaction\n              </button>\n\n              <button ng-hide=\"Transaction.transactionType==\'SIP\' && (Transaction.formData.frequency !== \'OM\' || Transaction.sipFirstInstallment || Transaction.formData.sipTopupEnabled)\"\n                      ng-disabled=\"!Transaction.tForm.$valid||\n                Transaction.isInvalidForm || !Transaction.helper.isFormValid() || (Transaction.transactionType==\'PURCHASE\' && !Transaction.formData.purchaseInSchemeCode) || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || !Transaction.isSelectedEuin || (Transaction.transactionType==\'PURCHASE\' && Transaction.purchaseValidations.purchaseMultiple && !Transaction.isMultiples) ||\n                (Transaction.transactionType==\'SIP\' && (!Transaction.formData.startDate || !Transaction.formData.endDate || !Transaction.isMultiples || Transaction.amountExceeded || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (Transaction.formData.bankInfo.otmFrequency != null && Transaction.formData.bankInfo.otmFrequency != \'AWP\'\n                              && Transaction.formData.frequency === \' BZ\') || Transaction.isMax || Transaction.isMin || (!Transaction.kycVerifiedFlag) || !Transaction.formData.inSchemeCode || Transaction.isminCapAmount || Transaction.isOTMStartDate || Transaction.isOTMEndDate || (Transaction.formData.sipPaymentOption===\'E-mandate\' && (Transaction.isEmailinValid || Transaction.isEmailMobileinValid || Transaction.isMobileinValid))))\"\n                      class=\" btn btn-secondary-action\" type=\"button\"\n                      ng-click=\"Transaction.showNavApplicabilityModal()\">\n                Add to E-cart\n              </button>\n\n              &lt;!&ndash; Schedule Transaction button section ends here &ndash;&gt;\n              <button ng-if=\"Transaction.transactionType==\'SIP\' && Transaction.formData.sipPaymentOption!==\'E-mandate\'\" type=\"button\" ng-disabled=\"!Transaction.tForm.$valid||Transaction.isInvalidForm || !Transaction.helper.isFormValid() || Transaction.isOTMStartDate || Transaction.isOTMEndDate\n          || !Transaction.formData.inSchemeCode || Transaction.isminCapAmount || !Transaction.formData.startDate || !Transaction.formData.endDate || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (Transaction.formData.bankInfo.otmFrequency != null && Transaction.formData.bankInfo.otmFrequency != \'AWP\'\n                              && Transaction.formData.frequency === \' BZ\') || Transaction.isMax || Transaction.isMin || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || !Transaction.isMultiples || Transaction.amountExceeded || Transaction.formData.modifyAction == \'modifySip\' && Transaction.disableBtnForModify || (Transaction.formData.sipPaymentOption == \'UPI\' && !Transaction.formData.isUPIVerified)\"\n                      ng-click=\"Transaction.goToSipSummary()\" class=\" btn btn-primary-action\">Proceed to Transact\n              </button>\n              <button ng-if=\"Transaction.transactionType==\'SIP\' && Transaction.formData.sipPaymentOption===\'E-mandate\'\" type=\"button\" ng-disabled=\"!Transaction.tForm.$valid||Transaction.isInvalidForm || !Transaction.helper.isFormValid()\n          || !Transaction.formData.inSchemeCode || Transaction.isminCapAmount || !Transaction.formData.startDate || !Transaction.formData.endDate || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (Transaction.formData.bankInfo.otmFrequency != null && Transaction.formData.bankInfo.otmFrequency != \'AWP\'\n                              && Transaction.formData.frequency === \' BZ\') || Transaction.isMin || Transaction.isEmailinValid || Transaction.isEmailMobileinValid || Transaction.isMobileinValid || (!Transaction.kycVerifiedFlag) || !Transaction.isSelectedEuin || !Transaction.isMultiples || Transaction.amountExceeded || Transaction.formData.modifyAction == \'modifySip\' && Transaction.disableBtnForModify || Transaction.amountLess || Transaction.amountMore || Transaction.isLessThanSipAmount || Transaction.sipDateLessEmandate\"\n                      ng-click=\"Transaction.goToSipSummary()\" class=\" btn btn-primary-action\">Proceed to Transact\n              </button>\n              <button ng-if=\"Transaction.transactionType==\'PURCHASE\' || Transaction.transactionType==\'SCHEDULE_TRANSACTION_PURCHASE\'\" type=\"button\" ng-disabled=\"!Transaction.tForm.$valid||\n          Transaction.isInvalidForm || !Transaction.helper.isFormValid() || !Transaction.formData.purchaseInSchemeCode || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (!Transaction.kycVerifiedFlag) || (Transaction.isPurchaseAmountDecimal) || !Transaction.isSelectedEuin || Transaction.purchaseValidations.purchaseMultiple && !Transaction.isMultiples\"\n                      ng-click=\"Transaction.goToPurchaseSummary()\" class=\" btn btn-primary-action\">Proceed to Transact\n              </button>\n\n              &lt;!&ndash;{{!Transaction.tForm.$valid}}=1=={{Transaction.isInvalidForm }}=2=={{ Transaction.isOTMInvalidForm }}=3=={{\n              Transaction.isBankInvalidForm }}=4=={{ !Transaction.helper.isFormValid() }}=5=={{\n              !Transaction.formData.inSchemeCode }}=6=={{ransaction.formData.startDate }}=7=={{\n              !Transaction.formData.endDate }}=8=={{ Transaction.formData.brokerCode }}=9=={{\n              Transaction.formData.distributorARN }}=10=={{ Transaction.isArnSuccess\n              }}=11=={{ Transaction.formData.subBrokerARN }}\"=111==\"{{ Transaction.isSubarnSuccess\n              }}=12=={{ (Transaction.formData.bankInfo.otmFrequency != \'AWP\' )}}=13=={{ Transaction.formData.frequency === \'BZ\' }}=14=={{\n              Transaction.formData.sipPaymentOption === \'OTM\'\n              }}=15=={{ (Transaction.formData.sipTopupEnabled && (Transaction.formData.topupDetails.amount ?\n              Transaction.tForm.topupAmount.$invalid : Transaction.tForm.topupPercentage.$invalid))\n              }}=16=={{ransaction.formData.sipTopupEnabled && Transaction.isCapInvalidForm}}&ndash;&gt;\n            </div>\n          </form>\n        </div>\n      </fieldset>--><!--<div class=\"ecart-journey main-section-ecart\" ng-if=\"Transaction.showEcartModel\">\n        <div class=\"sidebar-container\" id=\"sidebarContainer\"\n             hdfc-ecart-sidebar\n             side-title=\"Transaction.sidebarTitle\"\n             investor-data = \"Transaction.investorData\"\n             cart-item = \"Transaction.ecartData\"\n             show-add-cart=\"Transaction.showAddCart\"\n             close-action=\"Transaction.closeAction(action)\">\n        </div>\n      </div>--><!--    </section>--><!--  </div>--><!--  <div class=\"transaction-footer\">--><!--  </div>--><!--</div>--><!------------------- separator ----------------><!--\n<div ng-if=\"Transaction.formData.isSummaryViewEnabled\">\n  <transaction-summary\n    form-data=\"Transaction.summaryData\"\n    is-summary-view-enabled=\"Transaction.formData.isSummaryViewEnabled\"\n    transaction-type=\"{{Transaction.transactionType}}\"\n    notes=\"Transaction.notesReview.content\"\n    show-terms = \"Transaction.showTerms\"\n    show-terms-emandate = \"Transaction.showTermsEmandate\"\n    note-upi-otp=\"Transaction.upiModalNote\"\n  ></transaction-summary>\n</div>--><!--\n\n<div id=\"lumpsum-form\">\n  <div class=\"row\">\n    <label class=\"form-label\">Add Scheme</label>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-12 col-md-3 row\">\n      <div class=\"input-select input-normal\" ng-class=\"{error:Transaction.tForm.pInScheme1.$dirty && Transaction.tForm.pInScheme1.$invalid,\n      \'anything-disabled\':Transaction.formData.dynamicData.readOnly}\">\n        <input type=\"text\" name=\"pInScheme1\" id=\"pInScheme1\"\n               ng-change=\"Transaction.filterPurchaseInSchemeList()\"\n               ng-model=\"Transaction.formData.purchaseInSchemeName\"\n               onpaste=\"return false;\"\n               ondrop=\"return false;\"\n               autocomplete=\"off\"\n               ng-disabled=\"!fForm.$valid\"\n               required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Select a Scheme</label>\n        <span class=\"error-input\"\n              ng-show=\"Transaction.tForm.pInScheme1.$dirty && Transaction.tForm.pInScheme1.$invalid && Transaction.tForm.pInScheme1.$error.required\"\n              ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>\n        <drop-down list-data=\"Transaction.purchaseInSchemeList\"\n                   display-key=\"scheme\"\n                   hdfc-click=\"Transaction.purchaseInSchemeChanged(data)\"\n                   model=\"Transaction.formData.purchaseInSchemeCode\"\n                   for=\"pInScheme1\">\n        </drop-down>\n        <p class=\"info-primary\">{{Transaction.formData.purchaseInSchemeName}}</p>\n      </div>\n    </div>\n    <div ng-if=\"!Transaction.formData.dynamicData.readOnly\" class=\"col-sm-12 col-md-offset-1 col-md-4 scheme-invoke\">\n      <span>OR</span>\n      <span class=\"text-primary cursor-pointer\" ng-click=\"fForm.$valid&&Transaction.purchaseSchemeListModal()\"><i\n        class=\"list-icon\"></i> Select from List </span>\n    </div>\n  </div>\n\n  <div class=\"row\"\n       ng-if=\"Transaction.formData.purchaseInvestmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">\n    <label class=\"form-label less\">Income Distribution cum Capital Withdrawal (IDCW) Option</label>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-12 col-md-12 form-group\" ng-class=\"{\'radio-disabled\':(Transaction.purchaseValidations.isEnabled==\'N\')}\" style=\"padding: 0\"\n         ng-if=\"Transaction.formData.purchaseInvestmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">\n      <div\n        class=\"radio-block\" ng-repeat=\"_option in Transaction.devidendOptions\"\n        ng-class=\"{\'anything-disabled\': ((_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.purchaseValidations.isGrowth === false && Transaction.purchaseValidations.dividendReinvestmentApplicable === false)\n                 || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.purchaseValidations.isGrowth === false && Transaction.purchaseValidations.dividendPayoutApplicable === false)\n                 )}\">\n        <span class=\"radio\">\n          <input type=\"radio\" id=\"pDividendOption{{_option}}\" ng-value=\"_option\"\n                 ng-disabled=\"!fForm.$valid\n                 || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.purchaseValidations.isGrowth === false && Transaction.purchaseValidations.dividendReinvestmentApplicable === false)\n                 || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.purchaseValidations.isGrowth === false && Transaction.purchaseValidations.dividendPayoutApplicable === false)\"\n                 name=\"pDividendOption\"\n                 ng-model=\"Transaction.formData.purchaseDividendOption\"/>\n          <span class=\"check\"></span>\n        </span>\n        <span class=\"radio-label\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span>\n      </div>\n    </div>\n  </div>\n  <div class=\"row form-group\"\n       ng-if=\"Transaction.isSchemeTypeELSS && Transaction.formData.purchaseInvestmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">\n    <div class=\"info-primary\">\n      Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-12 col-md-3 row\">\n      <div class=\"input-normal icon-input\"\n           ng-class=\"{error:(Transaction.tForm.pAmount.$dirty && Transaction.tForm.pAmount.$invalid)||(Transaction.formData.purchaseAmount&&Transaction.isPurchaseMin),\'has-data\':Transaction.formData.purchaseAmount}\">\n        <input type=\"number\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=\"pAmount\"\n               ng-model=\"Transaction.formData.purchaseAmount\"\n               ng-change=\"Transaction.checkPurchaseValidations()\"\n               onkeyup=\"NumToWord(this.value,\'divDisplayWords\');\"\n               ondrop=\"return false;\"\n               ng-disabled=\"!fForm.$valid\"\n               required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Amount</label>\n        <i class=\"rupee-grey-icon\"></i>\n        <span class=\"error-input \"\n              ng-show=\"Transaction.tForm.pAmount.$dirty && Transaction.tForm.pAmount.$error.required\"\n              ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>\n        <span ng-if=\"Transaction.formData.purchaseAmount && Transaction.isPurchaseMin\" class=\"error-input \">\n          {{\'Minimum amount should be \'+ Transaction.purchaseMinAmount}}<span ng-if=\"Transaction.formData.purchaseAmount%1 != 0\">, </span>\n        </span>\n        <span ng-if=\"Transaction.formData.purchaseAmount && !Transaction.isPurchaseMin && (Transaction.purchaseValidations.purchaseMultiple && !Transaction.isMultiples)\" class=\"error-input \">\n          Please provide amount in multiples of &#8377;{{Transaction.purchaseValidations.purchaseMultiple|unit}}<span ng-if=\"Transaction.formData.purchaseAmount%1 != 0\">, </span>\n        </span>\n        <span ng-if=\"!Transaction.tForm.pAmount.$error.required && Transaction.formData.purchaseAmount%1 != 0\" class=\"error-input \" ng-class=\"{errorDown: Transaction.formData.purchaseAmount && Transaction.isPurchaseMin}\">{{\"Amount can\'t be decimal\"}}</span>\n      </div>\n      <div class=\"form-group\">\n        <label id=\"divDisplayWords\">{{Transaction.amountInWords}} (In Words)</label>\n      </div>\n    </div>\n  </div>\n  <div class=\"tc-block row form-group\" ng-if=\"Transaction.nfoEnabled\">\n    <div class=\"checkbox\">\n      <input name=\"isAutoSwitch\" ng-model=\"Transaction.formData.isAutoSwitch\" type=\"checkbox\"\n             ng-change=\"Transaction.fetchSwitchInSchemes()\"/>\n      <i class=\"icon-checkbox\"></i>\n      <span class=\"checkbox-text\">Auto Switch on Maturity</span>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"Transaction.formData.isAutoSwitch\">\n    <div class=\"col-sm-12 col-md-3 row\">\n\n      <div class=\"input-select input-normal\"\n           ng-class=\"{error:Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid}\">\n        <input type=\"text\" name=\"inScheme\" id=\"inScheme\"\n               ng-change=\"Transaction.filterInSchemeList()\"\n               ng-model=\"Transaction.formData.inSchemeName\"\n               autocomplete=\"off\" required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Select Target Scheme</label>\n        <span class=\"error-input\"\n              ng-show=\"Transaction.tForm.inScheme.$dirty && Transaction.tForm.inScheme.$invalid && Transaction.tForm.inScheme.$error.required\"\n              ng-bind=\"Transaction.VALIDATE_DATA.TARGET_SCHEME_REQUIRED\"></span>\n        <drop-down list-data=\"Transaction.inSchemeList\"\n                   display-key=\"scheme\"\n                   hdfc-click=\"Transaction.inSchemeChanged(data)\"\n                   model=\"Transaction.formData.inSchemeCode\"\n                   for=\"inScheme\">\n        </drop-down>\n\n        <p class=\"info-primary\">{{Transaction.formData.inSchemeName}}</p>\n      </div>\n\n\n    </div>\n\n    <div class=\"form-group col-sm-12  col-md-offset-1 col-md-4 scheme-invoke \">\n      <span>OR</span>\n      <span>\n        <i class=\"list-icon\"></i>\n        <span class=\"text-primary cursor-pointer\"\n              ng-click=\"Transaction.schemeListModal()\">Select from list</span>\n      </span>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"Transaction.formData.isAutoSwitch\">\n    <div class=\"form-group\" ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\"\n         ng-if=\"Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">\n      <label class=\"form-label\"><strong>Select Income Distribution cum Capital Withdrawal (IDCW) Option</strong></label>\n      <div>\n        <div ng-class=\"{\'anything-disabled\': (_option==Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST\n                       && Transaction.validations.endingType === Transaction.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (_option==Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.isSchemeTypeELSS) }\"\n             class=\"radio-block\" ng-repeat=\"_option in Transaction.devidendOptions\">\n              <span class=\"radio\">\n                <input type=\"radio\" id=\"dividendOption{{$index}}\" ng-value=\"_option\"\n                       ng-disabled=\"(_option==Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST&& Transaction.validations.endingType === Transaction.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED) || (_option==Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.isSchemeTypeELSS)\"\n                       name=\"dividendOption\"\n                       ng-model=\"Transaction.formData.switchDividendOption\"/>\n                <span class=\"check\"></span>\n              </span>\n          <span class=\"radio-label\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span>\n        </div>\n      </div>\n    </div>\n    <div class=\"row form-group\"\n         ng-if=\"Transaction.isSchemeTypeELSS && Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">\n      <div class=\"info-primary\">\n        Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS\n      </div>\n    </div>\n  </div>\n\n<!--  <div class=\"row\">--><!--    <div class=\"col-sm-12 col-md-3\">--><!--      <div ng-if=\"Transaction.showChequeLeaf\">  &lt;!&ndash;ng-if=\"Transaction.showChequeLeaf\"&ndash;&gt;--><!--        <span class=\"mrg35\">Upload Retirement Proof</span>--><!--        <div class=\"upload-proof\">--><!--          <input type=\"file\" name=\"pic\" id=\"ageProof\" accept=\"image/*\"--><!--                 file-model-profile=\"Transaction.retirementAgeProofURL\"--><!--                 upload=\"Transaction.uploadRetirementProofFile(file)\"--><!--                 ng-model=\"Transaction.formData.retirementAgeProofURL\" required>--><!--          <div class=\"file-upload\">--><!--            <button>Choose File</button>--><!--            <span ng-if=\"Transaction.chooseAFile\">No File Chosen</span>--><!--            <span ng-click=\"Transaction.openUploadedDoc()\">{{Transaction.retirementAgeProofURL}}</span></div>--><!--          <span class=\"req\">*</span>--><!--        </div>--><!--      </div>--><!--    </div>--><!--  </div>-->--><div class=\"container-fluid sip-purchase main-section\" ng-hide=Transaction.formData.isSummaryViewEnabled><form name=Transaction.tForm ng-keypress=Transaction.handleEnter($event) novalidate autocomplete=off class=form-container><div class=transaction-header><h3 class=page-title>Purchase</h3></div><div class=transaction-body><section class=initiate-transaction><div class=\"row purchase-details-form-container\"><div class=col-md-8><fieldset ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber}\"><div class=main-content><!--Scheme listing row--><div class=\"row mb-4\"><div class=col-md-12><div class=scheme-fields><div class=row><div class=col-md-10><div class=form-input><label for=pInScheme1 class=\"form-label form-label-bold\">Select a Scheme</label><div class=\"search-input selection-width\" ng-class=\"{\'anything-disabled\':Transaction.formData.dynamicData.readOnly}\"><input type=text name=pInScheme1 id=pInScheme1 ng-change=Transaction.filterPurchaseInSchemeList() ng-model=Transaction.formData.purchaseInSchemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off ng-disabled=!Transaction.formData.folioNumber class=\"form-select text-center\" required> <span class=error-input ng-show=\"Transaction.tForm.pInScheme1.$dirty && Transaction.tForm.pInScheme1.$invalid && Transaction.tForm.pInScheme1.$error.required\" ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.purchaseInSchemeList display-key=scheme hdfc-click=\"Transaction.purchaseInSchemeChanged(data, true)\" model=Transaction.formData.schemeCode for=pInScheme1></drop-down><!--<p class=\"info-primary\">{{Transaction.formData.purchaseInSchemeName}}</p>--></div></div></div><div class=col-md-2><div ng-if=!Transaction.formData.dynamicData.readOnly class=\"scheme-options separator-wrapper\"><div class=else-option><span>OR</span></div><span class=\"text-primary cursor-pointer view-all-hide-m\" ng-disabled=!Transaction.formData.folioNumber ng-click=Transaction.purchaseSchemeListModal()()>View All</span><div class=\"or-divider d-md-none d-lg-none d-xl-none d-xxl-none\"><span class=divider-text>OR</span></div><div class=\"text-primary cursor-pointer view-all d-md-none d-lg-none d-xl-none d-xxl-none\" ng-disabled=!Transaction.formData.folioNumber ng-click=Transaction.purchaseSchemeListModal()()>View All</div></div></div></div></div></div></div><!-- IDCW Option --><div class=row><div class=\"col-md-10 d-flex justify-content-center dividend-option-wrapper\" ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\" ng-if=\"Transaction.formData.purchaseInvestmentOption === Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=radio-block ng-repeat=\"_option in Transaction.dividendOptions\" ng-class=\"{\'anything-disabled\': ((_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.purchaseValidations.isGrowth === false && Transaction.purchaseValidations.dividendReinvestmentApplicable === false)\n                 || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.purchaseValidations.isGrowth === false && Transaction.purchaseValidations.dividendPayoutApplicable === false)\n                 )}\"><span class=radio><input type=radio id=sDividendOption{{_option}} ng-value=_option ng-disabled=\"(_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)\n                           || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendPayoutApplicable === false)\" name=sDividendOption ng-model=Transaction.formData.dividendOption ng-change=Transaction.changeDividendOption()> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div><div ng-if=\"Transaction.isSchemeTypeELSS && Transaction.formData.purchaseInvestmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right style=\"margin-left: -7px\" data-bs-title=\"Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS\"></i></div></div></div><!-- Purchase Amount row --><div class=row><div class=\"col-sm-12 col-md-10 d-flex justify-content-center flex-column\"><div class=\"form-input sip-amt-container\"><label class=\"form-label form-label-bold d-flex justify-content-center\">Enter Purchase Amount</label><div class=\"input-normal icon-input\" ng-class=\"{error:(Transaction.tForm.pAmount.$dirty && Transaction.tForm.pAmount.$invalid)||(Transaction.formData.amount && Transaction.isPurchaseMin),\'has-data\':Transaction.formData.amount}\"><!--<span class=\"rupee-symbol-entity\">&#8377;</span>--> <input type=text onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=pAmount ng-model=Transaction.formData.displayAmount ng-change=Transaction.checkPurchaseValidations(true) onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ondrop=\"return false\" ng-disabled=\"(!Transaction.formData.folioNumber || !Transaction.formData.purchaseInSchemeCode)\" class=input-style aria-describedby=rupee-addon required> <span class=rupee-span-new ng-if=!Transaction.formData.displayAmount>₹</span> <span class=highlight></span> <span class=bar></span></div></div><div class=text-center><span class=error-input ng-show=\"Transaction.tForm.pAmount.$dirty && Transaction.tForm.pAmount.$error.required\" ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Transaction.formData.amount && Transaction.isPurchaseMin\" class=error-input>{{\'Minimum amount should be \'+ Transaction.purchaseMinAmount}}<span ng-if=\"Transaction.formData.amount % 1 != 0\">, </span></span><span ng-if=\"Transaction.formData.amount && !Transaction.isPurchaseMin && (Transaction.purchaseValidations.purchaseMultiple && !Transaction.isMultiples)\" class=error-input>Please provide amount in multiples of &#8377;{{Transaction.purchaseValidations.purchaseMultiple|unit}}<span ng-if=\"Transaction.formData.amount % 1 != 0\">, </span></span><span ng-if=\"!Transaction.tForm.pAmount.$error.required && Transaction.formData.amount % 1 != 0\" class=error-input ng-class=\"{errorDown: Transaction.formData.amount && Transaction.isPurchaseMin}\">{{\"Amount can\'t be decimal\"}}</span><div class=form-group ng-if=Transaction.formData.amount><label>{{Transaction.formData.amountInWords}}</label></div></div></div></div><!-- Start a SIP checkbox --><div class=row><div class=\"col-md-10 col-sm-12 sip-topup-checkbox-container d-flex justify-content-center flex-start\" ng-if=\"Transaction.purchaseValidations.sipEnabled && Transaction.purchaseValidations.sipEnabled === \'Y\'\"><div class=\"checkbox f-family-inter f-weight-400 p-0\"><input ng-model=Transaction.formData.sipViaPurchaseSelected type=checkbox ng-disabled=\"!Transaction.formData.folioNumber || !Transaction.formData.purchaseInSchemeName || Transaction.purchaseValidations.sipEnabled === \'N\'\" ng-change=Transaction.openSIPDetailsPopup(); ng-required=\"\"> <i class=icon-checkbox></i> Start a SIP</div><i class=edit-icon ng-if=Transaction.formData.sipViaPurchaseSelected ng-click=Transaction.helper.showSIPDetails()></i></div></div></div></fieldset></div><div class=col-md-4><div data-ng-include=\"\'app/transactions/initiate/sip-purchase/invest-through/invest-through-with-folio-section.html\'\"></div></div></div></section></div><div class=transaction-footer><button class=\"btn btn-primary-action\" type=submit ng-disabled=\"!Transaction.tForm.$valid || Transaction.isInvalidForm || !Transaction.helper.isFormValid() || !Transaction.formData.purchaseInSchemeCode || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess) || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || (!Transaction.kycVerifiedFlag) || (Transaction.isPurchaseAmountDecimal) || (Transaction.purchaseValidations.purchaseMultiple && !Transaction.isMultiples) || (Transaction.formData.isThroughDistributor && !Transaction.isSelectedEuin && Transaction.formData.isEuin)\" ng-click=Transaction.proceedToTransact()>Proceed</button></div></form><div class=\"initiate-transaction sipPurchase\"><div class=\"ecart-journey main-section-ecart\" ng-if=Transaction.showEcartModel><div class=sidebar-container id=sidebarContainer hdfc-ecart-sidebar side-title=Transaction.sidebarTitle investor-data=Transaction.investorData cart-item=Transaction.ecartData show-add-cart=Transaction.showAddCart pending-state=Transaction.redirectingState close-action=Transaction.helper.closeAction(action)></div></div></div></div><div ng-if=Transaction.formData.isSummaryViewEnabled><transaction-summary form-data=Transaction.summaryData is-summary-view-enabled=Transaction.formData.isSummaryViewEnabled transaction-type={{Transaction.transactionType}} notes=Transaction.notesReview.content show-terms=Transaction.showTerms show-terms-emandate=Transaction.showTermsEmandate note-upi-otp=Transaction.upiModalNote></transaction-summary></div>");
$templateCache.put("app/transactions/initiate/sip-purchase/sip/sip.html","<!--<div id=\"SIP-form\">--><!--  <div class=\"row\">--><!--    <label class=\"form-label\">Add Scheme</label>--><!--  </div>--><!--  <div class=\"row\">--><!--    <div class=\"col-sm-12 col-md-3 row\">--><!--      <div class=\"input-select input-normal\"--><!--           ng-class=\"{error:Transaction.tForm.sInScheme1.$dirty && Transaction.tForm.sInScheme1.$invalid,--><!--           \'anything-disabled\': Transaction.formData.dynamicData.readOnly }\">--><!--        <input type=\"text\" name=\"sInScheme1\" id=\"sInScheme1\"--><!--               ng-change=\"Transaction.filterInSchemeList()\"--><!--               ng-model=\"Transaction.formData.inSchemeName\"--><!--               onpaste=\"return false;\"--><!--               ondrop=\"return false;\"--><!--               autocomplete=\"off\"--><!--               ng-disabled=\"!fForm.$valid\"--><!--               required>--><!--        <span class=\"highlight\"></span>--><!--        <span class=\"bar\"></span>--><!--        <label>Select a Scheme</label>--><!--        <span class=\"error-input\"--><!--              ng-show=\"Transaction.tForm.sInScheme1.$dirty && Transaction.tForm.sInScheme1.$error.required\"--><!--              ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--        <drop-down list-data=\"Transaction.inSchemeList\"--><!--                   display-key=\"scheme\"--><!--                   hdfc-click=\"Transaction.inSchemeChanged(data, \'sip\')\"--><!--                   model=\"Transaction.formData.inSchemeCode\"--><!--                   for=\"sInScheme1\">--><!--        </drop-down>--><!--        <p class=\"info-primary\">{{Transaction.formData.inSchemeName}}</p>--><!--      </div>--><!--    </div>--><!--    <div ng-if=\"!Transaction.formData.dynamicData.readOnly\" class=\"col-sm-12 col-md-offset-1 col-md-4 scheme-invoke\">--><!--      <span>OR</span>--><!--      <span class=\"text-primary cursor-pointer\" ng-click=\"fForm.$valid&&Transaction.schemeListModal()\"><i--><!--        class=\"list-icon\"></i> Select from List </span>--><!--    </div>--><!--  </div>--><!--  <div class=\"row\">--><!--    <label class=\"form-label less\">Installment Frequency</label>--><!--  </div>--><!--  <div class=\"row\">--><!--    <div class=\"col-sm-12 col-md-6 form-group\">--><!--      <div class=\"radio-block\" ng-if=\"Transaction.formData.frequency && Transaction.frequencyList.length >= 1\" ng-repeat=\"freq in Transaction.frequencyList\" ng-class=\"{\'daily-anything-disabled\': freq.code === \'BZ\' && (!(Transaction.isOTMEnabled || Transaction.isEMandateEnabled))}\">--><!--        <span class=\"radio\">--><!--          <input type=\"radio\" id=\"{{freq.code+\'1\'}}\"--><!--                 ng-change=\"Transaction.changeFrequency(true)\"--><!--                 ng-model=\"Transaction.formData.frequency\"--><!--                 ng-disabled=\"!fForm.$valid\"--><!--                 ng-value=\"freq.code\" name=\"installmentFrequency\"/>--><!--          <span class=\"check\"></span>--><!--        </span>--><!--                <span class=\"radio-label\">{{freq.name}}</span>--><!--            <i class=\"info-icon base-tooltip\" ng-if=\"freq.code === \'BZ\'\" tooltip data-bs-toggle=\"tooltip\" data-bs-placement=\"right\"--><!--               title=\"Mode of payment through Daily SIP shall be only through OTM of frequency - As and when presented.--><!--               SIP Top Up facility is not available for Daily SIP. For Daily SIP, OTM bank must have OTM Instruction Type as AWP.Daily SIP end date can be only on a business day. \"--><!--               tooltip-side=\"right\"--><!--            >--><!--            </i>--><!--            </div>--><!--        </div>--><!--    </div>--><!--  <div class=\"row\">--><!--    <div class=\"col-sm-12 col-md-3 row\">--><!--      <div class=\"input-normal icon-input\"--><!--           ng-class=\"{error:(Transaction.tForm.sAmount.$invalid && Transaction.tForm.sAmount.$dirty),\'has-data\':Transaction.formData.amount}\">--><!--        <input type=\"number\" ignore-mouse-wheel name=\"sAmount\"--><!--               ng-model=\"Transaction.formData.amount\"--><!--               ng-disabled=\"!fForm.$valid\"--><!--               ng-change=\"Transaction.checkSipValidations();Transaction.changeAmount(false)\"--><!--               onkeyup=\"NumToWord(this.value,\'divDisplayWords\');\"--><!--               required>--><!--        <span class=\"highlight\"></span>--><!--        <span class=\"bar\"></span>--><!--        <label>SIP Amount</label>--><!--        <i class=\"rupee-grey-icon\"></i>--><!--        <span class=\"error-input\"--><!--              ng-show=\"Transaction.tForm.sAmount.$dirty && Transaction.tForm.sAmount.$error.required\"--><!--              ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>--><!--        <span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=\"error-input\">Minimum amount should be &#8377; {{Transaction.validations.minAmount|unit}}</span>--><!--&lt;!&ndash;        <span ng-if=\"Transaction.formData.amount && Transaction.isMax && Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=\"error-input\">SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode</span>&ndash;&gt;--><!--        <span ng-if=\"Transaction.formData.amount && Transaction.isMax && Transaction.formData.sipPaymentOption != Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=\"error-input\">Maximum amount should be &#8377; {{Transaction.validations.maxAmount|unit}}</span>--><!--        <span--><!--          ng-if=\"Transaction.formData.amount && !Transaction.isMax && !Transaction.isMin && (Transaction.validations.amountMultiples&&!Transaction.isMultiples) && !Transaction.amountExceeded\"--><!--          class=\"error-input\">Please Provide In multiples of &#8377; {{Transaction.validations.amountMultiples|unit}}</span>--><!--        <span ng-show=\"Transaction.tForm.sAmount.$dirty && Transaction.formData.amount && Transaction.amountExceeded\" ng-if=\"Transaction.formData.modifyAction !== \'modifySip\'\" class=\"error-input\" ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_EXCEEDED\"></span>--><!--        <span ng-show=\"Transaction.formData.amount && Transaction.amountExceeded\" ng-if=\"Transaction.formData.modifyAction === \'modifySip\'\" class=\"error-input\" ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_EXCEEDED\"></span>--><!--      </div>--><!--      <div class=\"form-group\">--><!--        <label id=\"divDisplayWords\">{{Transaction.amountInWords}} (In Words)</label>--><!--      </div>--><!--    </div >--><!--      <div class=\"col-sm-12 col-md-6 amount-button-container\" ng-if=\"Transaction.formData.inSchemeCode\">--><!--        <button class=\"btn-sip-first-install-action\" type=\"button\" ng-repeat=\"amount in Transaction.sipFirstInstallmentAmount\"--><!--                ng-click=\"Transaction.formData.amount=amount;Transaction.checkSipValidations()\">--><!--          <img src=\"../../assets/images/rupee-indian.svg\">{{amount}}--><!--        </button>--><!--    </div>--><!--  </div>--><!--  <div class=\"row\" ng-if=\"Transaction.formData.inSchemeCode && Transaction.formData.frequency !==\'BZ\' \">--><!--    <div class=\"col-md-12 p-0\">--><!--      <label class=\"form-label\">Do you wish to pay First installment with your SIP Registration:</label>--><!--      <div class=\"radio-block first-installment-radio\">--><!--                      <span class=\"radio\">--><!--                        <input type=\"radio\" name=\"sipFirstInstallment\"--><!--                               ng-model=\"Transaction.sipFirstInstallment\"--><!--                               ng-disabled=\"!fForm.$valid\"--><!--                               ng-change=\"Transaction.changeFirstInstallment(true)\"--><!--                               ng-value=\"true\"/>--><!--                        <span class=\"check\"></span>--><!--                      </span>--><!--        <span class=\"radio-label\">Yes</span>--><!--      </div>--><!--      <div class=\"radio-block first-installment-radio\">--><!--                       <span class=\"radio\">--><!--                        <input type=\"radio\" name=\"investmentType\"--><!--                               ng-model=\"Transaction.sipFirstInstallment\"--><!--                               ng-disabled=\"!fForm.$valid\"--><!--                               ng-change=\"Transaction.changeFirstInstallment(false)\"--><!--                               ng-value=\"false\"/>--><!--                        <span class=\"check\"></span>--><!--                      </span>--><!--        <span class=\"radio-label\">No</span>--><!--      </div>--><!--    </div>--><!--  </div>--><!--  &lt;!&ndash;<div class=\"row\" ng-if=\"Transaction.sipFirstInstallment && Transaction.formData.frequency !==\'BZ\'\">--><!--    <div class=\"col-md-3 row\">--><!--      <div class=\"input-normal icon-input\"--><!--           ng-class=\"{error:(Transaction.tForm.sFirstAmount.$invalid && Transaction.tForm.sFirstAmount.$dirty),\'has-data\':Transaction.formData.sipFirstAmount}\">--><!--        <input type=\"number\" ignore-mouse-wheel name=\"sFirstAmount\"--><!--               ng-model=\"Transaction.formData.sipFirstAmount\"--><!--               ng-disabled=\"!fForm.$valid\"--><!--               ng-change=\"Transaction.checkSipFirstValidations()\"--><!--               onkeyup=\"NumToWord(this.value,\'divDisplayWordFirstInstallment\');\"--><!--               required>--><!--        <span class=\"highlight\"></span>--><!--        <span class=\"bar\"></span>--><!--        <label>Amount</label>--><!--        <i class=\"rupee-grey-icon\"></i>--><!--        <span class=\"error-input\"--><!--              ng-show=\"Transaction.tForm.sFirstAmount.$dirty && Transaction.tForm.sFirstAmount.$error.required\"--><!--              ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>--><!--        <span ng-if=\"Transaction.formData.sipFirstAmount && Transaction.isFirstMin\" class=\"error-input\">Minimum amount should be &#8377; {{Transaction.validations.minAmount|unit}}</span>--><!--        <span ng-if=\"Transaction.formData.sipFirstAmount && Transaction.isFirstMax && Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=\"error-input\">SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode</span>--><!--        <span ng-if=\"Transaction.formData.sipFirstAmount && Transaction.isFirstMax && Transaction.formData.sipPaymentOption != Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=\"error-input\">Maximum amount should be &#8377; {{Transaction.validations.maxAmount|unit}}</span>--><!--        <span--><!--          ng-if=\"Transaction.formData.sipFirstAmount && !Transaction.isFirstMax && !Transaction.isFirstMin && (Transaction.validations.amountMultiples&&!Transaction.isFirstMultiples)\"--><!--          class=\"error-input\">Please Provide In multiples of &#8377; {{Transaction.validations.amountMultiples|unit}}</span>--><!--      </div>--><!--      <div class=\"form-group\">--><!--        <label id=\"divDisplayWordFirstInstallment\">{{Transaction.amountInWords}} (In Words)</label>--><!--      </div>--><!--    </div>--><!--    <div class=\"col-md-offset-3 row amount-button-container\" ng-if=\"Transaction.formData.inSchemeCode\">--><!--      <button class=\"btn-sip-first-install-action\" type=\"button\" ng-repeat=\"amount in Transaction.sipFirstInstallmentAmount\"--><!--              ng-click=\"Transaction.formData.sipFirstAmount = amount; Transaction.checkSipFirstValidations(); \">--><!--        <img src=\"../../assets/images/rupee-indian.svg\">{{amount}}--><!--      </button>--><!--    </div>--><!--  </div>&ndash;&gt;--><!--  <div class=\"row\"--><!--       ng-if=\"Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">--><!--    <label class=\"form-label less\">Income Distribution cum Capital Withdrawal (IDCW) Option</label>--><!--  </div>--><!--  <div class=\"row\">--><!--    <div class=\"col-md-12 form-group\" ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\" style=\"padding: 0\"--><!--         ng-if=\"Transaction.validations.investmentOption === Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">--><!--      <div--><!--        class=\"radio-block\" ng-repeat=\"_option in Transaction.devidendOptions\"--><!--        ng-class=\"{\'anything-disabled\': ((_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)--><!--                 || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendPayoutApplicable === false)) }\">--><!--        <span class=\"radio\">--><!--          <input type=\"radio\" id=\"sDividendOption{{_option}}\" ng-value=\"_option\"--><!--                 ng-disabled=\"!fForm.$valid--><!--                 || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)--><!--                 || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendPayoutApplicable === false)\"--><!--                 name=\"sDividendOption\"--><!--                 ng-model=\"Transaction.formData.sipDividendOption\"--><!--                 ng-change=\"Transaction.changeDividendOption()\"--><!--          />--><!--          <span class=\"check\"></span>--><!--        </span>--><!--        <span class=\"radio-label\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span>--><!--      </div>--><!--    </div>--><!--  </div>--><!--  {{Transaction.formData.purchaseInvestmentOption}}--><!--  <div class=\"row form-group\"--><!--       ng-if=\"Transaction.isSchemeTypeELSS && Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">--><!--    <div class=\"info-primary\">--><!--      Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS--><!--    </div>--><!--  </div>--><!--  &lt;!&ndash;Payment Start here&ndash;&gt;--><!--  <div class=\"row\">--><!--    <label class=\"form-label less\">Payment Options</label>--><!--  </div>--><!--  <div class=\"row\">--><!--    <div ng-if=\"Transaction.paymentOptions && Transaction.paymentOptions.length\">--><!--    <div class=\"col-md-12 form-group\" ng-if=\"Transaction.formData.frequency!=\'BZ\'\" style=\"padding-left: 0px;\">--><!--      <div class=\"radio-block\" ng-repeat=\"_option in Transaction.paymentOptions \">--><!--        <span class=\"radio\" ng-if=\"(!(!Transaction.isOTMEnabled && _option==\'OTM\')) && !((!Transaction.isEMandateEnabled && _option==\'E-mandate\')) && !(Transaction.formData.modifyAction === \'modifySip\' && _option==\'UPI\')\">--><!--          <input type=\"radio\" id=\"paymentOption{{_option}}\" ng-value=\"_option\"--><!--                 name=\"paymentOption\"--><!--                 ng-change=\"Transaction.changedPaymentOption(true)\"--><!--                 ng-disabled=\"!fForm.$valid\"--><!--                 ng-model=\"Transaction.formData.sipPaymentOption\"/>--><!--          <span class=\"check\"></span>--><!--        </span>--><!--        <span class=\"radio-label\" ng-if=\"(!(!Transaction.isOTMEnabled && _option==\'OTM\')) && !((!Transaction.isEMandateEnabled && _option==\'E-mandate\')) && !(Transaction.formData.modifyAction === \'modifySip\' && _option==\'UPI\')\"\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span>--><!--      </div>--><!--    </div>--><!--    <div class=\"col-md-12 p-0 form-group\" ng-if=\"Transaction.formData.frequency==\'BZ\'\">--><!--      <div class=\"radio-block\">--><!--        <span class=\"radio\" ng-if=\"Transaction.isOTMEnabled\">--><!--         <input type=\"radio\" id=\"paymentOptionOTM\" value=\"OTM\" name=\"paymentOption\"--><!--                ng-change=\"Transaction.changedPaymentOption(true)\"--><!--                ng-disabled=\"!fForm.$valid\"--><!--                ng-model=\"Transaction.formData.sipPaymentOption\"/>--><!--          <span class=\"check\"></span>--><!--        </span>--><!--        <span class=\"radio-label\" ng-if=\"Transaction.isOTMEnabled\">OTM (One Time Mandate)</span>--><!--      </div>--><!--      <div class=\"radio-block\">--><!--        <span class=\"radio\" style=\"margin-left: 10px;\" ng-if=\"Transaction.isEMandateEnabled\">--><!--         <input type=\"radio\" id=\"paymentOptionE-mandate\" value=\"E-mandate\" name=\"paymentOption\"--><!--                ng-change=\"Transaction.changedPaymentOption(true)\"--><!--                ng-disabled=\"!fForm.$valid\"--><!--                ng-model=\"Transaction.formData.sipPaymentOption\"/>--><!--          <span class=\"check\"></span>--><!--        </span>--><!--        <span class=\"radio-label\" ng-if=\"Transaction.isEMandateEnabled\">Register E-mandate (eOTM)</span>--><!--      </div>--><!--      <div class=\"radio-block\">--><!--        <span class=\"radio\" style=\"margin-left: 10px;\">--><!--         <input type=\"radio\" id=\"paymentOptionE-upi\" value=\"UPI\" name=\"paymentOption\"--><!--                ng-change=\"Transaction.changedPaymentOption()\"--><!--                ng-disabled=\"!fForm.$valid\"--><!--                ng-model=\"Transaction.formData.sipPaymentOption\"/>--><!--          <span class=\"check\"></span>--><!--        </span>--><!--        <span class=\"radio-label\">UPI Autopay</span>--><!--      </div>--><!--    </div>--><!--  </div>--><!--    <ng-bind-html--><!--      dynamic =\"Transaction.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review.content\" ng-if=\"Transaction.showNote\">--><!--    </ng-bind-html>--><!--  <div class=\"borderline\" ng-if=\"Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC\">--><!--    <div class=\"row\">--><!--      <div class=\"col-sm-12 col-md-3\">--><!--        <div class=\"selectfield\" ng-class=\"{error:Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$invalid}\">--><!--          <select class=\"\" name=\"bank\" ng-disabled=\"false\"--><!--                  ng-model=\"Transaction.formData.bankInfo\"--><!--                  ng-options=\"bank.bankName for bank in Transaction.bankList track by bank.id\"--><!--                  ng-change=\"Transaction.changeBank()\"--><!--                  ng-init=\"Transaction.formData.bankInfo = Transaction.formData.bankInfo ? Transaction.formData.bankInfo : null\"--><!--                  required>--><!--            <option value=\"\" selected>--><!--              {{Transaction.bankList&&!Transaction.bankList.length ?\'No Bank Available\':\'Select Bank\'}}--><!--            </option>--><!--          </select>--><!--          <label ng-if=\"Transaction.formData.bankInfo\">Select Bank</label>--><!--          <span class=\"error-input\"--><!--                ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required && !Transaction.formData.bankName\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.BANK_REQUIRED\"></span>--><!--        </div>--><!--      </div>--><!--      <div class=\"col-md-12\">--><!--        <ng-bind-html dynamic=\"Transaction.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.NOTE_SIP_SI.content\"></ng-bind-html>--><!--      </div>--><!--      &lt;!&ndash;<div class=\"col-md-1 text-center\" style=\"top:15px;\">OR</div>&ndash;&gt;--><!--      <div class=\"col-sm-12 col-md-3 \" ng-if=\"Transaction.formData.bankInfo.bankCode == \'OTHER\'\">--><!--        <div class=\"input-normal\" ng-if=\"Transaction.formData.bankInfo.bankCode == \'OTHER\'\"--><!--             ng-class=\"{error:Transaction.tForm.bankName.$dirty && Transaction.tForm.bankName.$invalid}\">--><!--          <input type=\"text\" ng-click=\"Transaction.otherBankSelected()\"--><!--                 ng-disabled=\"Transaction.formData.bankInfo.bankCode != \'OTHER\'||!fForm.$valid\"--><!--                 ng-model=\"Transaction.formData.bankName\"--><!--                 name=\"bankName\" ng-required=\"Transaction.formData.bankInfo.bankCode == \'OTHER\'\">--><!--          <span class=\"highlight\"></span>--><!--          <span class=\"bar\"></span>--><!--          <label>Bank Name</label>--><!--          <span class=\"error-input\"--><!--                ng-show=\"Transaction.tForm.bankName.$dirty && Transaction.tForm.bankName.$error.required\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.BANK_NAME_REQUIRED\"></span>--><!--        </div>--><!--      </div>--><!--      <div class=\"col-sm-12 col-md-3\" ng-if=\"Transaction.formData.bankInfo && !Transaction.formData.bankInfo.ifscCode\">--><!--        <div class=\"input-normal\" ng-class=\"{error:Transaction.tForm.ifscCode.$invalid && Transaction.tForm.ifscCode.$dirty}\">--><!--          <input type=\"text\" ng-model=\"Transaction.formData.ifscCode\" name=\"ifscCode\" required--><!--                 maxlength=\"11\" minlength=\"11\"--><!--                 ng-pattern=\"Transaction.IFSC_REGEX\" capitalize>--><!--          <div class=\"bar\"></div>--><!--          <div class=\"highlight\"></div>--><!--          <label>IFSC Code<span class=\"req\">*</span></label>--><!--          <span class=\"error-input\" ng-show=\"Transaction.tForm.ifscCode.$dirty && Transaction.tForm.ifscCode.$error.required\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.IFSC_CODE_FIELD\"></span>--><!--          <span class=\"error-input\" ng-show=\"Transaction.tForm.ifscCode.$dirty && Transaction.tForm.ifscCode.$error.pattern\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.IFSC_CODE_REGEX\"></span>--><!--        </div>--><!--      </div>--><!--      <div class=\"col-sm-12 col-md-3\" ng-if=\"Transaction.formData.bankInfo && !Transaction.formData.bankInfo.bankAcType\">--><!--        <div class=\"selectfield selectionIcon\" ng-class=\"{error:Transaction.formData.bankInfo.bankAcType.$dirty && Transaction.formData.bankInfo.bankAcType.$invalid}\">--><!--          <select class=\"select-box\" name=\"accountType\"--><!--            ng-model=\"Transaction.formData.bankAcType\"--><!--            ng-options=\"_type.accountTypeCode as _type.accountType for _type in Transaction.bankTypeList\"--><!--            required>--><!--            <option value=\"\" selected>Account Type</option>--><!--          </select>--><!--          <label ng-if=\"Transaction.formData.bankInfo.bankAcType\">Account Type</label>--><!--          <span class=\"req text-red\">*</span>--><!--          <span class=\"error-input\" ng-messages=\"Transaction.formData.bankInfo.bankAcType.$error\" ng-show=\"Transaction.formData.bankInfo.bankAcType.$dirty\">--><!--              <span ng-message=\"required\" ng-bind=\"Transaction.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED\"></span>--><!--          </span>--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <div class=\"row\" ng-if=\"Transaction.formData.bankInfo.bankName ==\'HDFC BANK\'\">--><!--      <div class=\"col-sm-12 col-md-3\">--><!--        <div class=\"input-normal\"--><!--             ng-class=\"{error:Transaction.tForm.bankAcNo.$dirty&&Transaction.tForm.bankAcNo.$invalid}\">--><!--          <input type=\"text\" ng-model=\"Transaction.formData.bankAcNo\" name=\"bankAcNo\" ng-disabled=\"!fForm.$valid\"--><!--                 required minlength=\"9\"--><!--                 onkeypress=\'return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\'--><!--                 directive.mask ng-keydown=\"Transaction.copyPasteHandler($event)\" ng-change=\"Transaction.accFocus();\">--><!--          <span class=\"highlight\"></span>--><!--          <span class=\"bar\"></span>--><!--          <label>Account Number</label>--><!--          <span ng-show=\"Transaction.accModelDirty\">--><!--                <span class=\"error-input\" ng-show=\"Transaction.formData.bankAcNo.split(\'\').length==0\"--><!--                      ng-bind=\"Transaction.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED\"></span>--><!--                <span class=\"error-input\"--><!--                      ng-show=\"(Transaction.formData.bankAcNo.split(\'\').length == null || (Transaction.formData.bankAcNo.split(\'\').length<9 && Transaction.formData.bankAcNo.split(\'\').length>0)) \"--><!--                      ng-bind=\"Transaction.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE\"></span>--><!--            </span>--><!--        </div>--><!--      </div>--><!--      <div class=\"col-sm-12 col-md-3 \">--><!--        <div class=\"input-normal\"--><!--             ng-class=\"{error:Transaction.tForm.verifyBankAcNo.$dirty&&Transaction.tForm.verifyBankAcNo.$invalid}\">--><!--          <input type=\"text\" ng-model=\"Transaction.formData.verifyBankAcNo\" name=\"verifyBankAcNo\"--><!--                 ng-disabled=\"!fForm.$valid\"--><!--                 required ng-keydown=\"Transaction.copyPasteHandler($event)\" ng-minlength=\"9\"--><!--                 ng-pattern=\"Transaction.formData.bankAcNo\"--><!--                 onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\">--><!--          <span class=\"highlight\"></span>--><!--          <span class=\"bar\"></span>--><!--          <label>Verify Account Number</label>--><!--          <span class=\"error-input\"--><!--                ng-show=\"Transaction.tForm.verifyBankAcNo.$dirty&&Transaction.tForm.verifyBankAcNo.$error.required\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED\"></span>--><!--          <span class=\"error-input\"--><!--                ng-show=\"!Transaction.tForm.verifyBankAcNo.$error.required&&Transaction.tForm.verifyBankAcNo.$error.minlength\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE\"></span>--><!--          <span class=\"error-input\"--><!--                ng-show=\"!Transaction.tForm.verifyBankAcNo.$error.required&&!Transaction.tForm.verifyBankAcNo.$error.minlength&&Transaction.tForm.verifyBankAcNo.$error.pattern\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE\"></span>--><!--        </div>--><!--      </div>--><!--    </div>--><!--  </div>--><!--  <div class=\"borderline\" ng-if=\"Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM\">--><!--    <div class=\"row\">--><!--      <div class=\"col-sm-12 col-md-3\" style=\"padding-left: 15px;padding-right: 15px\">--><!--        <div class=\"input-select input-normal selectfield\" ng-class=\"{error:(Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$invalid)--><!--        || (Transaction.formData.bankInfo--><!--                              && Transaction.formData.bankInfo.otmFrequency != \'AWP\'--><!--                              && Transaction.formData.frequency === \'BZ\')}\">--><!--          <input type=\"text\" name=\"bank\" id=\"otmBank\"--><!--                 ng-model=\"Transaction.formData.bankInfo.bankName\"--><!--                 ng-change=\"Transaction.changeBank()\"--><!--                 ng-init=\"Transaction.formData.bankInfo = Transaction.formData.bankInfo ? Transaction.formData.bankInfo : null\"--><!--                 autocomplete=\"off\" only-alphabets required readonly>--><!--          <span class=\"highlight\"></span>--><!--          <span class=\"bar\"></span>--><!--          <label>Select Bank</label>--><!--          <span class=\"error-input\" ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.BANK_REQUIRED\"></span>--><!--          <span ng-if=\"Transaction.tForm.bank.$dirty && (Transaction.formData.otmBank--><!--                              && Transaction.formData.frequency === \'BZ\'--><!--                              && Transaction.formData.bankInfo.otmFrequency != \'AWP\')\"--><!--                class=\"error-input\">--><!--                        &lt;!&ndash; Otm end date should be on or before selected end date.&ndash;&gt;--><!--                            Invalid OTM Bank, OTM Instruction Type not AWP(As & When Presented)--><!--                      </span>--><!--          <bank-drop-down list-data=\"Transaction.OTMbankList\"--><!--                          display-key=\"bankName\"--><!--                          display-key-second=\"bankAcNo\"--><!--                          hdfc-click=\"Transaction.changeBank()\"--><!--                          model=\"Transaction.formData.bankInfo\"--><!--                          for=\"otmBank\">--><!--          </bank-drop-down>--><!--        </div>--><!--        &lt;!&ndash;<div class=\"selectfield\" ng-class=\"{error:(Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$invalid)--><!--        || (Transaction.formData.bankInfo--><!--                              && Transaction.formData.bankInfo.otmFrequency != \'AWP\'--><!--                              && Transaction.formData.frequency === \'BZ\')}\">--><!--          <select class=\"\" name=\"bank\" ng-disabled=\"!Transaction.bankList||!fForm.$valid\"--><!--                  ng-model=\"Transaction.formData.bankInfo\"--><!--                  ng-options=\"bank as (bank.bankName+\' - \'+bank.bankAcNo) for bank in Transaction.OTMbankList track by bank.omUmrn\"--><!--                  ng-change=\"Transaction.changeBank()\"--><!--                  ng-init=\"Transaction.formData.bankInfo = Transaction.formData.bankInfo ? Transaction.formData.bankInfo : null\"--><!--                  easyassist-key=\"mask-element\"--><!--                  required>--><!--            <option value=\"\" selected>--><!--              {{Transaction.OTMbankList&&!Transaction.OTMbankList.length ?\'No Bank Available\':\'Select OTM Bank\'}}--><!--            </option>--><!--          </select>--><!--          <label ng-if=\"Transaction.formData.bankInfo\">Select Bank</label>--><!--          <span class=\"error-input\" ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required\"--><!--                                   ng-bind=\"Transaction.VALIDATE_DATA.BANK_REQUIRED\"></span>--><!--          <span ng-if=\"Transaction.tForm.bank.$dirty && (Transaction.formData.otmBank--><!--                              && Transaction.formData.frequency === \'BZ\'--><!--                              && Transaction.formData.bankInfo.otmFrequency != \'AWP\')\"--><!--                class=\"error-input\">--><!--                        &lt;!&ndash; Otm end date should be on or before selected end date.&ndash;&gt;--><!--                            Invalid OTM Bank, OTM Instruction Type not AWP(As & When Presented)--><!--                      </span>--><!--        </div>&ndash;&gt;--><!--      </div>--><!--      <div class=\"col-sm-12 col-md-3\" ng-if=\"Transaction.formData.bankInfo && !Transaction.formData.bankInfo.ifscCode\">--><!--        <div class=\"input-normal\" ng-class=\"{error:Transaction.tForm.ifscCode.$invalid && Transaction.tForm.ifscCode.$dirty}\">--><!--          <input type=\"text\" ng-model=\"Transaction.formData.ifscCode\" name=\"ifscCode\" required--><!--                 maxlength=\"11\" minlength=\"11\"--><!--                 ng-pattern=\"Transaction.IFSC_REGEX\" capitalize>--><!--          <div class=\"bar\"></div>--><!--          <div class=\"highlight\"></div>--><!--          <label>IFSC Code<span class=\"req\">*</span></label>--><!--          <span class=\"error-input\" ng-show=\"Transaction.tForm.ifscCode.$dirty && Transaction.tForm.ifscCode.$error.required\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.IFSC_CODE_FIELD\"></span>--><!--          <span class=\"error-input\" ng-show=\"Transaction.tForm.ifscCode.$dirty && Transaction.tForm.ifscCode.$error.pattern\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.IFSC_CODE_REGEX\"></span>--><!--        </div>--><!--      </div>--><!--      <div class=\"col-sm-12 col-md-3\" ng-if=\"Transaction.formData.bankInfo && !Transaction.formData.bankInfo.bankAcType\">--><!--        <div class=\"selectfield selectionIcon\" ng-class=\"{error:Transaction.formData.bankInfo.bankAcType.$dirty && Transaction.formData.bankInfo.bankAcType.$invalid}\">--><!--          <select class=\"select-box\" name=\"accountType\"--><!--                  ng-model=\"Transaction.formData.bankAcType\"--><!--                  ng-options=\"_type.accountTypeCode as _type.accountType for _type in Transaction.bankTypeList\"--><!--                  required>--><!--            <option value=\"\" selected>Account Type</option>--><!--          </select>--><!--          <label ng-if=\"Transaction.formData.bankAcType\">Account Type</label>--><!--          <span class=\"req text-red\">*</span>--><!--          <span class=\"error-input\" ng-messages=\"Transaction.formData.bankInfo.bankAcType.$error\" ng-show=\"Transaction.formData.bankInfo.bankAcType.$dirty\">--><!--              <span ng-message=\"required\" ng-bind=\"Transaction.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED\"></span>--><!--          </span>--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <div class=\"row\" ng-if=\"Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM\">--><!--      <ng-bind-html--><!--        ng-bind-html=\"Transaction.notesOtm.content\"--><!--        ng-if=\"Transaction.showOtmNote\"--><!--      ></ng-bind-html>--><!--      </div>--><!--    <div class=\"row\">--><!--      <div class=\"col-sm-12 col-md-9\">--><!--        <table class=\"table otm-bank-details borderless\" ng-if=\"Transaction.formData.bankInfo && Transaction.bankList.length\">--><!--          <tr>--><!--            <td>Account No:</td>--><!--            <td easyassist-key=\"mask-element\">{{Transaction.formData.bankInfo.bankAcNo}}</td>--><!--          </tr>--><!--          <tr>--><!--            <td>OTM UMRN No:</td>--><!--            <td>{{Transaction.formData.bankInfo.omUmrn}}</td>--><!--          </tr>--><!--          <tr>--><!--            <td>OTM Max Amount:</td>--><!--            <td><i class=\"rupee-small-icon\"></i>{{Transaction.formData.bankInfo.maxAmount}}--><!--              <span class=\"error-input\" ng-show=\"Transaction.isOTMAmount\"--><!--                    ng-bind=\"Transaction.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR\"></span>--><!--            </td>--><!--          </tr>--><!--          <tr>--><!--            <td>OTM Instruction Type:</td>--><!--            <td>{{Transaction.formData.bankInfo.otmFrequencyName ? Transaction.formData.bankInfo.otmFrequencyName : Transaction.formData.bankInfo.otmFrequency}}</td>--><!--          </tr>--><!--          <tr>--><!--            <td>OTM Start Date:</td>--><!--            <td>{{Transaction.formData.bankInfo.omStartDate}}--><!--            </td>--><!--          </tr>--><!--          <tr>--><!--            <td>OTM Expiry Date:</td>--><!--            <td>{{Transaction.formData.bankInfo.omExpiryDate}}--><!--              <span class=\"error-input\" ng-show=\"Transaction.isOTMDate\"--><!--                    ng-bind=\"Transaction.VALIDATE_DATA.DATE_VALIDATION_ERROR\"></span>--><!--            </td>--><!--          </tr>--><!--        </table>--><!--      </div>--><!--    </div>--><!--  </div>--><!--  </div>--><!--  <div ng-if=\"Transaction.paymentOptions.length == 0\" class=\"bank-error-msg marginBotNovalid\">--><!--    No valid payment mode available to proceed with SIP transaction--><!--  </div>--><!--  <div class=\"borderline emandate-section\" ng-if=\"Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && Transaction.emandateDisplay && Transaction.isEMandateEnabled\">--><!--    <div class=\"row\">--><!--      <div class=\"col-sm-12 col-md-3 label-emandate\">--><!--        Select Bank--><!--      </div>--><!--      <div class=\"col-md-3\">--><!--        <div class=\"input-select input-normal selectfield\">--><!--          <input type=\"text\" name=\"bank\" id=\"bank\"--><!--                 ng-model=\"Transaction.formData.bankInfo.bankName\"--><!--                 ng-change=\"Transaction.changeBank()\"--><!--                 ng-init=\"Transaction.formData.bankInfo = Transaction.formData.bankInfo ? Transaction.formData.bankInfo : null\"--><!--                 autocomplete=\"off\" only-alphabets required readonly>--><!--          <span class=\"highlight\"></span>--><!--          <span class=\"bar\"></span>--><!--          <label ng-if=\"!Transaction.formData.bankInfo\">Select Bank</label>--><!--          <span class=\"error-input\"  ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required && !Transaction.formData.bankName\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.BANK_REQUIRED\"></span>--><!--          <bank-drop-down list-data=\"Transaction.bankList\"--><!--                          display-key=\"bankNameOnly\"--><!--                          display-key-second=\"accountNumber\"--><!--                          hdfc-click=\"Transaction.changeBank()\"--><!--                          model=\"Transaction.formData.bankInfo\"--><!--                          for=\"bank\">--><!--          </bank-drop-down>--><!--        </div>--><!--        &lt;!&ndash;<div class=\"selectfield\">--><!--          <select class=\"\" name=\"bank\" ng-disabled=\"false\"--><!--                  ng-model=\"Transaction.formData.bankInfo\"--><!--                  ng-options=\"bank.bankName for bank in Transaction.bankList track by bank.accountNumber\"--><!--                  ng-change=\"Transaction.changeBank()\"--><!--                  ng-init=\"Transaction.formData.bankInfo = Transaction.formData.bankInfo ? Transaction.formData.bankInfo : null\"--><!--                  easyassist-key=\"mask-element\"--><!--                  required>--><!--            <option value=\"\" selected>--><!--              {{Transaction.bankList&&!Transaction.bankList.length ?\'No Bank Available\':\'Select Bank\'}}--><!--            </option>--><!--          </select>--><!--          <label ng-if=\"Transaction.formData.bankInfo\">Select Bank</label>--><!--          <span class=\"error-input\"--><!--                ng-show=\"Transaction.tForm.bank.$dirty && Transaction.tForm.bank.$error.required && !Transaction.formData.bankName\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.BANK_REQUIRED\"></span>--><!--        </div>&ndash;&gt;--><!--      </div>--><!--    </div>--><!--    <div class=\"row\">--><!--      <div class=\"col-md-3 label-emandate\">--><!--        Authentication Mode--><!--      </div>--><!--      <div class=\"col-md-3\">--><!--        <div class=\"selectfield\" ng-if=\"Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && Transaction.isEMandateEnabled\"--><!--             ng-class=\"{error:Transaction.tForm.authenticationMode.$dirty && Transaction.tForm.authenticationMode.$invalid}\">--><!--          <div class=\"selectauthdrop\">--><!--            <select  name=\"authenticationMode\" ng-disable=\"!Transaction.authenticationMode\" class=\"authModeDropdown\"--><!--                                                ng-model=\"Transaction.formData.authMode\"--><!--                                                ng-options=\"auth.text for auth in Transaction.authenticationMode\"--><!--                                                ng-init=\"Transaction.formData.authMode=Transaction.formData.authMode?Transaction.formData.authMode: null\"--><!--                                                required=\"required\">--><!--            <option value=\"\" selected>--><!--              {{Transaction.authenticationMode&&!Transaction.authenticationMode.length ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}--><!--            </option>--><!--          </select>--><!--            <span class=\"error-input\"--><!--                  ng-show=\"Transaction.tForm.authenticationMode.$dirty && Transaction.tForm.authenticationMode.$error.required && !Transaction.formData.authMode\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.AUTHENTICATION_MODE_REQUIRED\"></span>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <div class=\"row\">--><!--      <div class=\"col-md-3 label-emandate\">--><!--        Mandate Amount--><!--      </div>--><!--      <div class=\"col-md-3\">--><!--        <div class=\"input-normal icon-input\"--><!--             ng-class=\"{error:(Transaction.tForm.eAmount.$invalid && Transaction.tForm.eAmount.$dirty),\'has-data\':Transaction.formData.emandateAmount}\">--><!--          <input type=\"number\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=\"eAmount\"--><!--                 ng-model=\"Transaction.formData.emandateAmount\"--><!--                 ng-change=\"Transaction.checkAmountValidationEmandate()\"--><!--                 ng-disabled=\"!fForm.$valid\"--><!--                 ng-maxlength=\"10\" limit-to=\"10\"--><!--                 required>--><!--          <span class=\"highlight\"></span>--><!--          <span class=\"bar\"></span>--><!--          <i class=\"rupee-grey-icon\"></i>--><!--          <div class=\"amtWords\" ng-if=\"Transaction.formData.emandateAmount\">--><!--            <p id=\"amountInwordsEmandate\"> {{Transaction.formData.emandateWord.amountInWords}} (In Words)</p>--><!--          </div>--><!--&lt;!&ndash;          <span class=\"text-success\">&ndash;&gt;--><!--&lt;!&ndash;                  Maximum allowed for e-mandate is ₹ {{Transaction.mandateMaxString}}.&ndash;&gt;--><!--&lt;!&ndash;          </span>&ndash;&gt;--><!--          <div class=\"error-input\"--><!--               ng-show=\"Transaction.amountLess\">{{Transaction.VALIDATE_DATA.EMANDATE_MIN_ERROR + Transaction.emandateMinAmountLimit}}.</div>--><!--          <div class=\"error-input\"--><!--               ng-show=\"Transaction.amountMore\">{{Transaction.VALIDATE_DATA.EMANDATE_MAX_ERROR + Transaction.mandateMaxString}}.</div>--><!--          <div class=\"error-input\"--><!--               ng-show=\"!Transaction.amountLess && Transaction.isLessThanSipAmount\" ng-bind=\"Transaction.VALIDATE_DATA.EMANDATE_SIP_AMOUNT_ERROR\"></div>--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <div class=\"row\">--><!--      <div class=\"col-md-3 label-emandate\">--><!--        Mandate Start Date--><!--      </div>--><!--      <div class=\"col-md-3 anything-disabled\" ng-if=\"!Transaction.isReseting\">--><!--        <div class=\"input-select input-normal input-group date date-picker transaction-cal\"--><!--             date-calendar--><!--             data-viewmode=\"{{Transaction.viewMode}}\"--><!--             data-date-default=\"Transaction.formData.emandateDate\"--><!--             id=\"emandateStartDate\"--><!--             data-enable=\"true\"--><!--             style=\"position: relative;\">--><!--          <input type=\'text\' name=\"emandateStartDate\" placeholder=\"Start Date - DD-MMM-YYYY\" readonly/>--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <div class=\"row\">--><!--      <div class=\"col-md-3 label-emandate\">--><!--        Mandate End Date <i class=\"info-icon base-tooltip\"  tooltip data-toggle=\"tooltip\" data-bs-placement=\"right\" title= {{Transaction.mandateInfo}}> </i>--><!--      </div>--><!--      <div class=\"sip-dates col-md-3\">--><!--        <div ng-class=\"{\'anything-disabled\': !Transaction.formData.emandateDate}\">--><!--          <div class=\"form-group\" ng-if=\"!Transaction.isReseting\">--><!--            <div class=\"input-normal verify-acc input-group date date-picker transaction-cal eEndDate\"--><!--                 ng-class=\"{error:Transaction.tForm.endDateEmandate.$dirty && Transaction.tForm.endDateEmandate.$invalid}\"--><!--                 date-calendar--><!--                 format=\"DD-MMM-YYYY\"--><!--                 data-viewmode=\"days\"--><!--                 data-date-default=\"Transaction.formData.endDateEmandate\"--><!--                 data-enabled-dates=\"Transaction.enabledEmandateEndDatesList\"--><!--                 data-view-date=\"Transaction.enabledEndDateView\"--><!--                 data-max-date=\"Transaction.maxEndDateEmandate\"--><!--                 data-min-date=\"Transaction.minEndDateEmandate\"--><!--                 data-on-date-change=\"Transaction.changeEndDateEmandate\"--><!--                 data-enable=\"true\"--><!--                 id=\"endDateEmandate\"--><!--                 showdefault=\"false\">--><!--              &lt;!&ndash; data-min-date=\"Transaction.formData.minEndDate\"&ndash;&gt;--><!--              <input type=\'text\' name=\"endDateEmandate\" autocomplete=\"off\"--><!--                     placeholder=\"End Date - DD-MMM-YYYY\" readonly/>--><!--              <span class=\"input-group-addon\">--><!--                      <span class=\"glyphicon glyphicon-calendar\"></span>--><!--                    </span>--><!--              <span class=\"highlight\"></span>--><!--              <span class=\"bar\"></span>--><!--            </div>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <ng-bind-html--><!--      ng-bind-html=\"Transaction.notesEOtm.content\"--><!--      ng-if=\"Transaction.showEotmNote && Transaction.formData.authMode.value !== \'DEBIT_CARD\'\"--><!--    ></ng-bind-html>--><!--    <ng-bind-html--><!--      ng-bind-html=\"Transaction.notesEOtmDebitCard.content\"--><!--      ng-if=\"Transaction.showEotmNote && Transaction.formData.authMode.value === \'DEBIT_CARD\'\"--><!--    ></ng-bind-html>--><!--  </div>--><!--  <div class=\"borderline\" ng-if=\"Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\">--><!--    <div class=\"row\">--><!--      <div class=\"col-sm-12 col-md-3\">--><!--        <div class=\"input-select input-normal selectfield\" ng-class=\"{error:Transaction.tForm.bank.$dirty&&Transaction.tForm.bank.$invalid}\">--><!--          <input style=\"padding-top: 13px\" type=\"text\" name=\"bank\" id=\"upiBank\"--><!--                 ng-model=\"Transaction.formData.bankInfo.bankName\"--><!--                 ng-change=\"Transaction.changeBank()\"--><!--                 ng-init=\"Transaction.formData.bankInfo=Transaction.formData.bankInfo?Transaction.formData.bankInfo: null\"--><!--                 autocomplete=\"off\" ng-required=\"!Transaction.bankInfo\" only-alphabets readonly>--><!--          <span class=\"highlight\"></span>--><!--          <span class=\"bar\"></span>--><!--          <label>Select Bank</label>--><!--          <span class=\"error-input\"  ng-show=\"Transaction.tForm.bank.$dirty&&Transaction.tForm.bank.$error.required\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.BANK_REQUIRED\"></span>--><!--          <bank-drop-down list-data=\"Transaction.UPIbankList\"--><!--                          display-key=\"bankNameOnly\"--><!--                          display-key-second=\"accountNumber\"--><!--                          hdfc-click=\"Transaction.changeBank()\"--><!--                          model=\"Transaction.formData.bankInfo\"--><!--                          for=\"upiBank\">--><!--          </bank-drop-down>--><!--        </div>--><!--      </div>--><!--      <div class=\"col-sm-12 col-md-3\" ng-if=\"Transaction.formData.bankInfo && !Transaction.formData.bankInfo.ifscCode\">--><!--        <div class=\"input-normal\" ng-class=\"{error:Transaction.tForm.ifscCode.$invalid&&Transaction.tForm.ifscCode.$dirty}\">--><!--          <input style=\"padding-top: 13px\" type=\"text\" ng-model=\"Transaction.formData.ifscCode\" name=\"ifscCode\" required--><!--                 maxlength=\"11\" minlength=\"11\" ng-pattern=\"Transaction.IFSC_REGEX\" capitalize>--><!--          <div class=\"bar\"></div>--><!--          <div class=\"highlight\"></div>--><!--          <label>IFSC Code<span class=\"req\">*</span></label>--><!--          <span class=\"error-input\" ng-show=\"Transaction.tForm.ifscCode.$dirty&&Transaction.tForm.ifscCode.$error.required\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.IFSC_CODE_FIELD\"></span>--><!--          <span class=\"error-input\" ng-show=\"Transaction.tForm.ifscCode.$dirty&&Transaction.tForm.ifscCode.$error.pattern\"--><!--                ng-bind=\"Transaction.VALIDATE_DATA.IFSC_CODE_REGEX\"></span>--><!--        </div>--><!--      </div>--><!--      <div class=\"col-sm-12 col-md-3\" ng-if=\"Transaction.formData.bankInfo && !Transaction.formData.bankInfo.bankAcType\">--><!--        <div class=\"selectfield selectionIcon\" ng-class=\"{error:Transaction.tForm.bankAcType.$dirty && Transaction.tForm.bankAcType.$invalid}\">--><!--          <select class=\"select-box\" name=\"accountType\"--><!--                  ng-model=\"Transaction.formData.bankAcType\"--><!--                  ng-options=\"_type.accountTypeCode as _type.accountType for _type in Transaction.bankTypeList\"--><!--                  required>--><!--            <option value=\"\" selected>Account Type</option>--><!--          </select>--><!--          <label ng-if=\"Transaction.formData.bankAcType\">Account Type</label>--><!--          <span class=\"req text-red\">*</span>--><!--          <span class=\"error-input\" ng-messages=\"Transaction.tForm.bankAcType.$error\" ng-show=\"Transaction.tForm.bankAcType.$dirty\">--><!--                  <span ng-message=\"required\" ng-bind=\"Transaction.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED\"></span>--><!--                </span>--><!--        </div>--><!--      </div>--><!--      <div ng-if=\"Transaction.formData.bankInfo\" style=\"padding: 0px;\" ng-style=\"{\'margin-top\' : !Transaction.formData.bankInfo.ifscCode || !Transaction.formData.bankInfo.bankAcType ? \'20px\' : \'0px\'}\" ng-class=\"!Transaction.formData.bankInfo.ifscCode || !Transaction.formData.bankInfo.bankAcType ? \'col-md-12\' : \'col-md-9\'\">--><!--          <div class=\"col-sm-12\" style=\"margin-bottom: 20px\" ng-class=\"!Transaction.formData.bankInfo.ifscCode || !Transaction.formData.bankInfo.bankAcType ? \'col-md-3\' : \'col-md-4\'\">--><!--            <div class=\"input-normal\" ng-class=\"{error:Transaction.tForm.virtualAddress.$invalid&&Transaction.tForm.virtualAddress.$dirty}\">--><!--              <input style=\"padding-top: 13px;text-transform: lowercase;\" type=\"text\" ng-model=\"Transaction.formData.virtualAddress\" name=\"virtualAddress\"--><!--                     ng-pattern=\"Transaction.PATTERN.upi_virtual_addr_regex\" ng-change=\"Transaction.handleVpa()\"--><!--                     required ng-readonly=\"Transaction.formData.isUPIVerified && Transaction.formData.verifyUPIResp.valid === true\" easyassist-key=\"mask-element\">--><!--              <div class=\"bar\"></div>--><!--              <div class=\"highlight\"></div>--><!--              <label style=\"display: block;width: 100%\">Virtual Payment Address (UPI ID)--><!--                <span class=\"req\">*</span>--><!--                <i class=\"edit-icon\"--><!--                   style=\"position: absolute;right: 0px; top:16px; pointer-events: all; box-sizing: content-box;\"--><!--                   ng-if=\"Transaction.formData.isUPIVerified && Transaction.formData.verifyUPIResp.valid === true\"--><!--                   ng-click=\"Transaction.formData.isUPIVerified = false\"></i>--><!--              </label>--><!--              <span class=\"error-input\" ng-show=\"Transaction.tForm.virtualAddress.$dirty&&(Transaction.tForm.virtualAddress.$error.required||Transaction.tForm.virtualAddress.$error.pattern)\"--><!--                    ng-bind=\"Transaction.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED\"></span>--><!--              <span class=\"error-input\" ng-show=\"!Transaction.tForm.virtualAddress.$invalid--><!--                  &&  (!Transaction.formData.isUPIVerified && Transaction.formData.verifyUPIResp.valid === false)\"--><!--                    ng-bind=\"Transaction.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED\"></span>--><!--            </div>--><!--          </div>--><!--          <div class=\"col-sm-12\" ng-if=\"Transaction.formData.sipPaymentOption==\'UPI\' && !Transaction.formData.isUPIVerified\" ng-class=\"!Transaction.formData.bankInfo.ifscCode || !Transaction.formData.bankInfo.bankAcType ? \'col-md-2\' : \'col-md-3\'\">--><!--            <button blur-on-click--><!--                    class=\"btn btn-primary-action\" ng-disabled=\"!Transaction.formData.virtualAddress || (!Transaction.formData.minorFlag && Transaction.checkForMinorBankListCondition()) || (!Transaction.formData.isUPIVerified && Transaction.formData.verifyUPIResp.valid === false)\" ng-click=\"Transaction.verifyUPI()\">Verify--><!--            </button>--><!--          </div>--><!--          <div class=\"col-sm-12 col-md-2 verify-vpa verify-ack-padding\"  ng-if=\"Transaction.formData.isUPIVerified && Transaction.formData.verifyUPIResp.valid === true\">--><!--            <p><strong>Verified <i class=\"verify-small-icon\"></i></strong></p>--><!--            <span>Name: {{Transaction.formData.name}}</span>--><!--          </div>--><!--          <div class=\"col-sm-12 col-md-2 verify-vpa verify-ack-padding\"  ng-if=\"!Transaction.formData.isUPIVerified && Transaction.formData.verifyUPIResp.valid === false\">--><!--            <p><strong><span class=\"error-input\"--><!--                             style=\"display:inline;font-size:100%;margin-bottom: 20px;\">Not Verified</span>--><!--              <i class=\"cancel-icon error-input\"></i>--><!--            </strong>--><!--            </p>--><!--          </div>--><!--      </div>--><!--      <div class=\"initiate-transaction \">--><!--        <div class=\"text-red\"  ng-if=\"!Transaction.bankList||!Transaction.bankList.length\">--><!--              <span>--><!--                 In case your registered bank is not displayed, please choose other payment mode or add another bank.--><!--              </span>--><!--        </div>--><!--        <ng-bind-html--><!--          dynamic=\"Transaction.notesUPI.content\">--><!--        </ng-bind-html>--><!--      </div>--><!--    </div>--><!--  </div>--><!--  <div ng-if=\"(Transaction.isEmailinValid || Transaction.isEmailMobileinValid || Transaction.isMobileinValid) && (Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)\" class=\"emandateError\">--><!--  <span class=\"error-input\" ng-show=\"Transaction.isMobileinValid\"--><!--        ng-bind=\"Transaction.VALIDATE_DATA.INVALID_MOBILE_EMANDATE\"></span>--><!--  <span class=\"error-input\" ng-show=\"Transaction.isEmailinValid\"--><!--        ng-bind=\"Transaction.VALIDATE_DATA.INVALID_EMAIL_EMANDATE\"></span>--><!--  <span class=\"error-input\" ng-show=\"Transaction.isEmailMobileinValid\"--><!--        ng-bind=\"Transaction.VALIDATE_DATA.INVALID_EMAIL_MOBILE_EMANDATE\"></span>--><!--  </div>--><!--  &lt;!&ndash;Payment End here&ndash;&gt;--><!--  <div class=\"row\">--><!--    <label class=\"form-label less\">Installment Date Details</label>--><!--  </div>--><!--  <div ng-if=\"Transaction.paymentOptions.length !==0 && Transaction.formData.frequency === \'OW\'\">--><!--    <div class=\"row form-group\">--><!--      <div class=\"col-sm-12 col-md-3 selectfield\" style=\"padding: 0;\"--><!--           ng-class=\"{error:Transaction.tForm.weeklyDay.$dirty && Transaction.tForm.weeklyDay.$invalid}\">--><!--        <label ng-if=\"Transaction.formData.weeklyDay\">Select Day</label>--><!--        <select name=\"day\"--><!--                ng-model=\"Transaction.formData.weeklyDay\"--><!--                ng-change=\"Transaction.changeDay()\"--><!--                ng-options=\"day as day for day in Transaction.daysList\"--><!--                ng-init=\"Transaction.formData.weeklyDay=Transaction.formData.weeklyDay?Transaction.formData.weeklyDay: null\"--><!--                required>--><!--          <option value=\"\" selected>Select Day</option>--><!--        </select>--><!--        <span class=\"error-input\"--><!--              ng-show=\"Transaction.tForm.weeklyDay.$dirty && Transaction.tForm.day.$error.required\"--><!--              ng-bind=\"Transaction.VALIDATE_DATA.DAY_REQUIRED\"></span>--><!--      </div>--><!--    </div>--><!--    <div class=\"row\">--><!--      <div>--><!--        <div class=\"col-sm-12 col-md-3 row\" ng-class=\"{\'anything-disabled\':!Transaction.formData.weeklyDay}\" ng-if=\"!Transaction.isReseting\">--><!--          <div class=\"input-select input-normal input-group date date-picker transaction-cal\"--><!--               ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\"--><!--               date-calendar--><!--               data-viewmode=\"{{Transaction.viewMode}}\"--><!--               data-date-default=\"Transaction.formData.startDate\"--><!--               data-enabled-dates=\"Transaction.enabledStartDates\"--><!--               data-min-date=\"Transaction.startMinDateOTM\"--><!--               data-max-date=\"Transaction.startMaxDate\"--><!--               data-on-date-change=\"Transaction.changeStartDate\"--><!--               id=\"weeklyStartDate\"--><!--               data-enable=\"true\"--><!--               style=\"position: relative;\">--><!--            <input type=\'text\' name=\"startDate\" placeholder=\"Start Date - DD-MMM-YYYY\" readonly/>--><!--            <span class=\"input-group-addon\">--><!--                  <span class=\"glyphicon glyphicon-calendar\"></span>--><!--                </span>--><!--            <label ng-if=\"Transaction.formData.startDate\">Start Date - DD-MMM-YYYY</label>--><!--            <span class=\"highlight\"></span>--><!--            <span class=\"bar\"></span>--><!--            <span class=\"error-input\" ng-show=\"Transaction.tForm.startDate.$error.required\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.START_DATE_REQUIRED\"></span>--><!--            <span class=\"error-input\" ng-show=\"Transaction.isOTMStartDate\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.DATE_SIP_VALIDATION_ERROR + \' \' + Transaction.formData.bankInfo.omStartDate\"></span>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <div class=\"row borderline\">--><!--      <div class=\"sip-dates\">--><!--        <div class=\"col-sm-12 col-md-3 row\" ng-class=\"{\'anything-disabled\': !Transaction.formData.startDate || !Transaction.formData.inSchemeName,\'disable-date\': Transaction.disableEndDateSelection}\">--><!--          <div class=\"form-group\" ng-if=\"!Transaction.isReseting\">--><!--            <div class=\"input-normal verify-acc input-group date date-picker transaction-cal\"--><!--                 ng-class=\"{error:Transaction.tForm.endDate.$dirty && Transaction.tForm.endDate.$invalid}\"--><!--                 date-calendar--><!--                 format=\"DD-MMM-YYYY\"--><!--                 data-viewmode=\"days\"--><!--                 data-date-default=\"Transaction.formData.endDate\"--><!--                 data-on-date-change=\"Transaction.changeEndDate\"--><!--                 data-enabled-dates=\"Transaction.enabledEndDates\"--><!--                 data-view-date=\"Transaction.enabledEndDateView\"--><!--                 data-min-date=\"Transaction.enabledEndDates[0]\"--><!--                 data-max-date=\"Transaction.formData.maxEndDate\"--><!--                 data-enable=\"true\"--><!--                 id=\"weeklyEndDate\"--><!--                 showdefault=\"false\">--><!--              &lt;!&ndash; data-min-date=\"Transaction.formData.minEndDate\"&ndash;&gt;--><!--              <input type=\'text\' name=\"endDate\" autocomplete=\"off\" id=\"endDateCalenderWeekly\"--><!--                     placeholder=\"End Date - DD-MMM-YYYY\" readonly/>--><!--              <span class=\"input-group-addon\" ng-click=\"Transaction.handleMandateCalender()\">--><!--            <span class=\"glyphicon glyphicon-calendar\"></span>--><!--          </span>--><!--              <span class=\"highlight\"></span>--><!--              <label ng-if=\"Transaction.formData.endDate\">End Date - DD-MMM-YYYY</label>--><!--              <span class=\"bar\"></span>--><!--              <span class=\"error-input\" ng-show=\"Transaction.formData.weeklyDay && Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\"--><!--                    ng-bind=\"Transaction.VALIDATE_DATA.END_DATE_REQUIRED\"></span>--><!--              <span class=\"error-input\" ng-show=\"Transaction.isOTMEndDate\"--><!--                    ng-bind=\"Transaction.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR\"></span>--><!--              <span style=\"word-spacing: -1px\" class=\"error-input\" ng-show=\"Transaction.formData.sipPaymentOption === Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && Transaction.sipDateLessEmandate\"--><!--                    ng-bind=\"Transaction.VALIDATE_DATA.EMANDATE_DATE_EXCEED_ERROR\"></span>--><!--            </div>--><!--          </div>--><!--        </div>--><!--        <div  ng-if=\"Transaction.formData.sipPaymentOption !== \'E-mandate\' && Transaction.formData.sipPaymentOption !== Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\" class=\"col-sm-12 col-md-1 or-part text-center\">OR</div>--><!--        <div  ng-if=\"Transaction.formData.sipPaymentOption !== \'E-mandate\' && Transaction.formData.sipPaymentOption !== Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\" class=\"col-sm-12 col-md-4 default-date\" ng-class=\"{\'anything-disabled\': !Transaction.formData.startDate ||  !Transaction.formData.inSchemeName }\">--><!--          <span class=\"checkbox\" style=\"bottom: -3px;\">--><!--              <input type=\"checkbox\" id=\"weeklyDefaultDate\" ng-class=\"{\'anything-disabled\': !Transaction.formData.startDate || !Transaction.formData.inSchemeName }\"--><!--                     ng-model=\"Transaction.formData.isTillPerpetuity\"--><!--                     ng-change=\"Transaction.changeTillPerpetuityFlag()\"--><!--                     ng-disabled=\"!Transaction.formData.startDate || !Transaction.formData.inSchemeName\">--><!--              <span class=\"icon-checkbox\"></span>--><!--            </span>--><!--          <label for=\"weeklyDefaultDate\">Choose Default End Date, which is 2099</label>--><!--        </div>--><!--      </div>--><!--    </div>--><!--  </div>--><!--  <div ng-if=\"((Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) || (Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) ||--><!--   (Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && Transaction.isEMandateEnabled)) && Transaction.formData.frequency !== \'OW\'\">--><!--    <div class=\"row\">--><!--      <div>--><!--        <div class=\"col-sm-12 col-md-3 row\" ng-class=\"{\'anything-disabled\': !Transaction.formData.inSchemeName}\">--><!--          <div class=\"input-select input-normal input-group date date-picker transaction-cal\"--><!--               ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\"--><!--               date-calendar--><!--               format=\"DD-MMM-YYYY\"--><!--               data-viewmode=\"{{Transaction.viewMode}}\"--><!--               data-date-default=\"Transaction.formData.startDate\"--><!--               data-enabled-dates=\"Transaction.enabledBillerStartDatesList\"--><!--               data-min-date=\"Transaction.startMinDateBiller\"--><!--               data-max-date=\"Transaction.startMaxDate\"--><!--               data-on-date-change=\"Transaction.changeStartDate\"--><!--               id=\"startDate-EC\"--><!--               data-enable=\"true\"--><!--               style=\"position: relative;\">--><!--            <input type=\'text\' name=\"startDate\" placeholder=\"Start Date - DD-MMM-YYYY\" readonly/>--><!--            <span class=\"input-group-addon\">--><!--                    <span class=\"glyphicon glyphicon-calendar\"></span>--><!--                  </span>--><!--            <label ng-if=\"Transaction.formData.startDate\">Start Date - DD-MMM-YYYY</label>--><!--            <span class=\"highlight\"></span>--><!--            <span class=\"bar\"></span>--><!--            <span class=\"error-input\" ng-show=\"Transaction.tForm.startDate.$error.required\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.START_DATE_REQUIRED\"></span>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <div class=\"row borderline\">--><!--      <div class=\"sip-dates\">--><!--        <div class=\"col-sm-12 col-md-3 row\" ng-class=\"{\'anything-disabled\': !Transaction.formData.startDate ||  !Transaction.formData.inSchemeName,\'disable-date\': Transaction.disableEndDateSelection }\">--><!--          <div class=\"form-group\">--><!--            <div class=\"input-normal verify-acc input-group date date-picker transaction-cal\"--><!--                 ng-class=\"{error:Transaction.tForm.endDate.$dirty && Transaction.tForm.endDate.$invalid}\"--><!--                 date-calendar--><!--                 format=\"DD-MMM-YYYY\"--><!--                 data-viewmode=\"days\"--><!--                 data-date-default=\"Transaction.formData.endDate\"--><!--                 data-on-date-change=\"Transaction.changeEndDate\"--><!--                 data-enabled-dates=\"Transaction.enabledEndDates\"--><!--                 data-view-date=\"Transaction.enabledEndDateView\"--><!--                 data-min-date=\"Transaction.formData.minEndDate\"--><!--                 data-max-date=\"Transaction.formData.maxEndDate\"--><!--                 data-enable=\"true\"--><!--                 id=\"endDate-EC\"--><!--                 showdefault=\"false\">--><!--              &lt;!&ndash; data-min-date=\"Transaction.formData.minEndDate\"&ndash;&gt;--><!--              <input type=\'text\' name=\"endDate\" autocomplete=\"off\" id=\"endDateCalender\"--><!--                     placeholder=\"End Date - DD-MMM-YYYY\" readonly/>--><!--              <span class=\"input-group-addon\" ng-click=\"Transaction.handleMandateCalender()\">--><!--            <span class=\"glyphicon glyphicon-calendar\"></span>--><!--          </span>--><!--            <span class=\"highlight\"></span>--><!--            <label ng-if=\"Transaction.formData.endDate\">End Date - DD-MMM-YYYY</label>--><!--            <span class=\"bar\"></span>--><!--            <span class=\"error-input\" ng-show=\"Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.MONTH_REQUIRED\"></span>--><!--            <span style=\"word-spacing: -1px\" class=\"error-input\" ng-show=\"Transaction.formData.sipPaymentOption === Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && Transaction.sipDateLessEmandate\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.EMANDATE_DATE_EXCEED_ERROR\"></span>--><!--            </div>--><!--          </div>--><!--        </div>--><!--        <div ng-if=\"Transaction.formData.sipPaymentOption !== \'E-mandate\' && Transaction.formData.sipPaymentOption !== Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\" class=\"col-sm-12 col-md-1 or-part text-center\">OR</div>--><!--        <div ng-if=\"Transaction.formData.sipPaymentOption !== \'E-mandate\' && Transaction.formData.sipPaymentOption !== Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\" class=\"col-sm-12 col-md-4 default-date \" ng-class=\"{\'anything-disabled\': !Transaction.formData.startDate ||  !Transaction.formData.inSchemeName }\">--><!--      <span class=\"checkbox\" style=\"bottom: -3px;\">--><!--          <input type=\"checkbox\" id=\"defaultDate\" ng-class=\"{\'anything-disabled\': !Transaction.formData.startDate ||  !Transaction.formData.inSchemeName }\"--><!--                 ng-model=\"Transaction.formData.isTillPerpetuity\"--><!--                 ng-change=\"Transaction.changeTillPerpetuityFlag()\"--><!--                 ng-disabled=\"!Transaction.formData.startDate || !Transaction.formData.inSchemeName\">--><!--          <span class=\"icon-checkbox\"></span>--><!--        </span>--><!--          <label for=\"defaultDate\">Choose Default End Date, which is 2099</label>--><!--        </div>--><!--      </div>--><!--    </div>--><!--  </div>--><!--  <div ng-if=\"Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM && Transaction.formData.frequency !== \'OW\'\">--><!--    <div class=\"row\">--><!--      <div>--><!--        <div class=\"col-sm-12 col-md-3 row\" ng-class=\"{\'anything-disabled\': !Transaction.formData.inSchemeName}\">--><!--          <div class=\"input-select input-normal input-group date date-picker transaction-cal\"--><!--               ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\"--><!--               date-calendar--><!--               data-viewmode=\"{{Transaction.viewMode}}\"--><!--               data-date-default=\"Transaction.formData.startDate\"--><!--               data-enabled-dates=\"Transaction.enabledOTMStartDatesList\"--><!--               data-min-date=\"Transaction.startMinDateOTM\"--><!--               data-max-date=\"Transaction.startMaxDate\"--><!--               data-on-date-change=\"Transaction.changeStartDate\"--><!--               id=\"startDate-OTM\"--><!--               data-enable=\"true\"--><!--               style=\"position: relative;\">--><!--            <input type=\'text\' name=\"startDate\" placeholder=\"Start Date - DD-MMM-YYYY\" readonly/>--><!--            <span class=\"input-group-addon\">--><!--                    <span class=\"glyphicon glyphicon-calendar\"></span>--><!--                  </span>--><!--            <label ng-if=\"Transaction.formData.startDate\">Start Date - DD-MMM-YYYY</label>--><!--            <span class=\"highlight\"></span>--><!--            <span class=\"bar\"></span>--><!--            <span class=\"error-input\" ng-show=\"Transaction.tForm.startDate.$error.required\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.START_DATE_REQUIRED\"></span>--><!--            <span class=\"error-input\" ng-show=\"Transaction.isOTMStartDate\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.DATE_SIP_VALIDATION_ERROR + \' \' + Transaction.formData.bankInfo.omStartDate\"></span>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--><!--    <div class=\"row borderline\">--><!--      <div class=\"sip-dates\">--><!--        <div class=\"col-sm-12 col-md-3 row\" ng-class=\"{\'anything-disabled\': !Transaction.formData.startDate || !Transaction.formData.inSchemeName,\'disable-date\': Transaction.disableEndDateSelection }\">--><!--          <div class=\"form-group\" ng-if=\"!Transaction.isReseting\">--><!--            <div class=\"input-normal verify-acc input-group date date-picker transaction-cal\"--><!--                 ng-class=\"{error:Transaction.tForm.endDate.$dirty && Transaction.tForm.endDate.$invalid}\"--><!--                 date-calendar--><!--                 format=\"DD-MMM-YYYY\"--><!--                 data-viewmode=\"days\"--><!--                 data-date-default=\"Transaction.formData.endDate\"--><!--                 data-on-date-change=\"Transaction.changeEndDate\"--><!--                 data-enabled-dates=\"Transaction.enabledEndDates\"--><!--                 data-view-date=\"Transaction.enabledEndDateView\"--><!--                 data-min-date=\"Transaction.formData.minEndDate\"--><!--                 data-max-date=\"Transaction.formData.maxEndDate\"--><!--                 data-enable=\"true\"--><!--                 id=\"endDate-OTM\"--><!--                 showdefault=\"false\">--><!--              &lt;!&ndash; data-min-date=\"Transaction.formData.minEndDate\"&ndash;&gt;--><!--              <input type=\'text\' name=\"endDate\" autocomplete=\"off\"--><!--                     placeholder=\"End Date - DD-MMM-YYYY\" readonly/>--><!--              <span class=\"input-group-addon\">--><!--            <span class=\"glyphicon glyphicon-calendar\"></span>--><!--          </span>--><!--            <span class=\"highlight\"></span>--><!--            <label ng-if=\"Transaction.formData.endDate\">End Date - DD-MMM-YYYY</label>--><!--            <span class=\"bar\"></span>--><!--            <span class=\"error-input\" ng-show=\"Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.MONTH_REQUIRED\"></span>--><!--            <span class=\"error-input\" ng-show=\"Transaction.isOTMEndDate\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR\"></span>--><!--            <span style=\"word-spacing: -1px\" class=\"error-input\" ng-show=\"Transaction.formData.sipPaymentOption === Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE && Transaction.sipDateLessEmandate\"--><!--                  ng-bind=\"Transaction.VALIDATE_DATA.EMANDATE_DATE_EXCEED_ERROR\"></span>--><!--            </div>--><!--          </div>--><!--        </div>--><!--        <div ng-if=\"Transaction.formData.sipPaymentOption !== \'E-mandate\' && Transaction.formData.sipPaymentOption !== Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\" class=\"col-sm-12 col-md-1 or-part text-center\">OR</div>--><!--        <div ng-if=\"Transaction.formData.sipPaymentOption !== \'E-mandate\' && Transaction.formData.sipPaymentOption !== Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI\" class=\"col-sm-12 col-md-4 default-date\" ng-class=\"{\'anything-disabled\': !Transaction.formData.startDate ||  !Transaction.formData.inSchemeName }\">--><!--      <span class=\"checkbox\" style=\"bottom: -3px;\">--><!--          <input type=\"checkbox\" ng-class=\"{\'anything-disabled\': !Transaction.formData.startDate ||  !Transaction.formData.inSchemeName }\"--><!--                 id=\"defaultDate-OTM\" ng-model=\"Transaction.formData.isTillPerpetuity\"--><!--                 ng-change=\"Transaction.changeTillPerpetuityFlag()\"--><!--                 ng-disabled=\"!Transaction.formData.startDate || !Transaction.formData.inSchemeName\">--><!--          <span class=\"icon-checkbox\"></span>--><!--        </span>--><!--          <label for=\"defaultDate\">Choose Default End Date, which is 2099</label>--><!--        </div>--><!--      </div>--><!--    </div>--><!--  </div>--><!--    <div ng-if=\"Transaction.formData.showTopUpBlock\">--><!--      <div class=\"row\">--><!--        <label class=\"form-label less\">SIP Top-up Details</label>--><!--      </div>--><!--      <div class=\"row\">--><!--      <div class=\"col-sm-12 col-md-3 p-0 form-group\" ng-show=\"!Transaction.isReseting\">--><!--      <span class=\"checkbox\" style=\"bottom: -3px;\">--><!--          <input type=\"checkbox\" id=\"sipToptup\" ng-model=\"Transaction.formData.sipTopupEnabled\"--><!--                 ng-change=\"Transaction.changeSipTopupSelected(Transaction.formData.sipTopupEnabled)\">--><!--          <span class=\"icon-checkbox\"></span>--><!--        </span>&nbsp;--><!--        <label style=\"margin-left: 2px;\">SIP Top-up</label>--><!--      </div>--><!--    </div>--><!--    <div class=\"row\" ng-if=\"Transaction.formData.sipTopupSelected\">--><!--      <div ng-class=\"{\'anything-disabled\': !Transaction.formData.sipTopupSelected }\" class=\"col-md-12\">--><!--        <div class=\"\">--><!--          <div class=\"row\">--><!--            <div class=\"col-sm-12 col-md-3\">--><!--              <div class=\"input-normal icon-input\"--><!--                   ng-class=\"{error:(Transaction.tForm.topupAmount.$invalid && Transaction.tForm.topupAmount.$dirty),\'has-data\':Transaction.formData.topupDetails.amount}\">--><!--                <input type=\"number\" ignore-mouse-wheel name=\"topupAmount\"--><!--                       ng-model=\"Transaction.formData.topupDetails.amount\"--><!--                       ng-disabled=\"!fForm.$valid || Transaction.formData.topupDetails.percentage\"--><!--                       ng-change=\"Transaction.checkTopUpModified();Transaction.checkSipValidations(true);Transaction.getTopupFrequencyList();Transaction.resetCapAmount();\"--><!--                       onkeyup=\"NumToWord(this.value,\'divDisplayInWords\');\"--><!--                       ng-required=\"Transaction.formData.sipTopupEnabled && ((!Transaction.formData.topupDetails.percentage && !Transaction.formData.topupDetails.amount) || !Transaction.formData.topupDetails.percentage)\">--><!--                <span class=\"highlight\"></span>--><!--                <span class=\"bar\"></span>--><!--                <label>Amount</label>--><!--                <i class=\"rupee-grey-icon\"></i>--><!--                <span class=\"error-input\"--><!--                      ng-show=\"Transaction.tForm.topupAmount.$dirty && Transaction.tForm.topupAmount.$error.required\"--><!--                      ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>--><!--                <span ng-if=\"Transaction.formData.topupDetails.amount && Transaction.isTopupMinAmt\" class=\"error-input\">Minimum amount should be &#8377; {{Transaction.validations.topupMinAmt|unit}}</span>--><!--                <span--><!--                  ng-if=\"Transaction.formData.topupDetails.amount  && !Transaction.isTopupMinAmt && (Transaction.validations.topupAmtMultples&&!Transaction.isTopUpMultiples)\"--><!--                  class=\"error-input\">Please provide In multiples of &#8377; {{Transaction.validations.topupAmtMultples|unit}}</span>--><!--              </div>--><!--              <div class=\"form-group\">--><!--                <label id=\"divDisplayInWords\" ng-if=\"Transaction.formData.topupDetails.amount\">{{Transaction.amountInWords}} (In Words)</label>--><!--              </div>--><!--            </div>--><!--            <div  ng-if=\"Transaction.showTopUpPercentage\" class=\"col-sm-12 col-md-1 or-part text-center\">OR</div>--><!--              <div class=\"col-sm-12 col-md-3\" ng-if=\"Transaction.showTopUpPercentage\">--><!--                <div class=\"input-normal\"--><!--                     ng-class=\"{error:(Transaction.tForm.topupPercentage.$invalid && Transaction.tForm.topupPercentage.$dirty),\'has-data\':Transaction.formData.topupPercentage}\">--><!--                  <input type=\"number\" ignore-mouse-wheel name=\"topupPercentage\"--><!--                         ng-model=\"Transaction.formData.topupDetails.percentage\"--><!--                         ng-disabled=\"!fForm.$valid ||  Transaction.formData.topupDetails.amount\"--><!--                         ng-change=\"Transaction.checkSipValidations();Transaction.getTopupFrequencyList();Transaction.changeTopUpFreq()\"--><!--                         ng-required=\"Transaction.formData.sipTopupEnabled && ((!Transaction.formData.topupDetails.percentage && !Transaction.formData.topupDetails.amount) || !Transaction.formData.topupDetails.amount)\">--><!--                  <span class=\"highlight\"></span>--><!--                  <span class=\"bar\"></span>--><!--                  <label>Percentage (%)</label>--><!--                  <span class=\"error-input\"--><!--                        ng-show=\"Transaction.tForm.topupPercentage.$dirty && Transaction.tForm.topupPercentage.$error.required\"--><!--                        ng-bind=\"Transaction.VALIDATE_DATA.PERCENT_REQUIRED\"></span>--><!--                  <span ng-if=\"Transaction.formData.topupDetails.percentage && Transaction.isTopupMinPerc\"--><!--                        class=\"error-input\">Minimum percentage should be {{Transaction.validations.topupMinPercentage|unit}}%</span>--><!--                  <span--><!--                    ng-if=\"Transaction.formData.topupDetails.percentage && !Transaction.isTopupMinPerc && (Transaction.validations.topupPercentageMultples&&!Transaction.isTopupPercMultiples)\"--><!--                    class=\"error-input\">Please provide in multiple of {{Transaction.validations.topupPercentageMultples|unit}}%</span>--><!--                </div>--><!--              </div>--><!--            </div>--><!--          <div class=\"row\">--><!--            <div class=\"col-sm-12 col-md-12\">--><!--              <label class=\"form-label less\">Frequency</label>--><!--            </div>--><!--          </div>--><!--          <div class=\"row\">--><!--            <div class=\"col-sm-12 col-md-5 form-group\">--><!--              <div class=\"radio-block\" ng-repeat=\"freq in Transaction.topupFrequencyList\">--><!--        <span class=\"radio\">--><!--          <input type=\"radio\"--><!--                 ng-model=\"Transaction.formData.topupDetails.frequency\"--><!--                 ng-disabled=\"!fForm.$valid\"--><!--                 ng-value=\"freq.key\" name=\"topupFrequency\"--><!--                 ng-change=\"Transaction.changeTopUpFreq();Transaction.checkTopUpModified();\"/>--><!--          <span class=\"check\"></span>--><!--        </span>--><!--                  <span class=\"radio-label\">{{freq.value}}</span>--><!--                </div>--><!--              </div>--><!--            </div>--><!--          <div class=\"row\">--><!--            <div class=\"col-sm-12 col-md-12\">--><!--              <label class=\"form-label less\">SIP Top-up CAP</label>--><!--            </div>--><!--          </div>--><!--          <div class=\"row\">--><!--            <div class=\"col-sm-12 col-md-3\">--><!--              <div class=\"input-normal icon-input\"--><!--                   ng-class=\"{error:(Transaction.tForm.capAmount.$invalid && Transaction.tForm.capAmount.$dirty && Transaction.isminCapAmount),\'has-data\':Transaction.formData.capAmount}\">--><!--                <input type=\"number\" ignore-mouse-wheel name=\"capAmount\"--><!--                       ng-model=\"Transaction.formData.topupDetails.capAmount\"--><!--                       ng-disabled=\"!fForm.$valid || Transaction.formData.topupDetails.capMonthYear\"--><!--                       onkeyup=\"NumToWord(this.value,\'capAmntDisplayInWords\');\"--><!--                       ng-change=\"Transaction.capAmountChanged();\"--><!--                       ng-required=\"Transaction.formData.sipTopupEnabled && ((!Transaction.formData.topupDetails.capAmount && !Transaction.formData.topupDetails.capMonthYear) || !Transaction.formData.topupDetails.capMonthYear)\">--><!--                <span class=\"highlight\"></span>--><!--                <span class=\"bar\"></span>--><!--                <label>Amount</label>--><!--                <i class=\"rupee-grey-icon\"></i>--><!--                <span class=\"error-input\"--><!--                      ng-show=\"Transaction.tForm.capAmount.$dirty && Transaction.tForm.capAmount.$error.required\"--><!--                      ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>--><!--                <span ng-if=\"Transaction.formData.topupDetails.capAmount && Transaction.isminCapAmount\" class=\"error-input\">Minimum amount should be &#8377; {{Transaction.minCapAmount}}</span>--><!--              </div>--><!--              <div class=\"form-group\" ng-if=\"Transaction.formData.modifyAction !== \'modifySip\'\">--><!--                <label id=\"capAmntDisplayInWords\"><span ng-if=\"Transaction.formData.topupDetails.capAmount\">{{Transaction.amountInWords}} (In Words)</span></label>--><!--              </div>--><!--              <div class=\"form-group\" ng-if=\"Transaction.formData.modifyAction == \'modifySip\'\">--><!--                <label id=\"capAmntDisplayInWords\" ng-if=\"Transaction.formData.topupDetails.capAmount\">{{Transaction.amountInWords}} (In Words)</label>--><!--              </div>--><!--            </div>--><!--            <div class=\"col-sm-12 col-md-1 or-part text-center\">OR</div>--><!--            <div class=\"col-sm-12 col-md-4\">--><!--              <div class=\"col-sm-12 col-md-10\">--><!--                <div class=\"selectfield\"--><!--                     ng-class=\"{\'anything-disabled\': !fForm.$valid || Transaction.formData.topupDetails.capAmount }\">--><!--                  <select class=\"browser-default custom-select\" name=\"capDates\"--><!--                          ng-disabled=\"!fForm.$valid || Transaction.topupDetails.formData.capAmount\"--><!--                          ng-options=\"_dates for _dates in Transaction.capDates\"--><!--                          ng-model=\"Transaction.formData.topupDetails.capMonthYearSelect\"--><!--                          ng-change=\"Transaction.changeCapMonthYear()\"--><!--                            ng-init=\"Transaction.formData.topupDetails.capMonthYearSelect=Transaction.formData.topupDetails.capMonthYearSelect?Transaction.formData.topupDetails.capMonthYearSelect: null\"--><!--                          ng-required=\"Transaction.formData.sipTopupEnabled && ((!Transaction.formData.topupDetails.capAmount && !Transaction.formData.topupDetails.capMonthYearSelect) || !Transaction.formData.topupDetails.capAmount)\"--><!--                  >--><!--                    <option value=\"\">Cap Month Year - MM/YYYY</option>--><!--                  </select>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--><!--  </div>--><!--</div>--><!--<div class=\"container-fluid sip-purchase main-section clearfix\" ng-hide=\"Transaction.formData.isSummaryViewEnabled\">--><!--  <div ng-init=\"Transaction.init()\" class=\"transaction-header\">--><!--    <h3 ng-if=\"Transaction.formData.investmentType === \'PURCHASE\'\" class=\"page-title\">Purchase</h3>--><!--    <h3 ng-if=\"Transaction.formData.investmentType === \'SIP\'\" class=\"page-title\">SIP</h3>--><!--  </div>--><!--  <div class=\"transaction-body\">--><!--    <section class=\"initiate-transaction\">--><!--      <form name=\"Transaction.tForm\" ng-keypress=\"Transaction.handleEnter($event)\" novalidate autocomplete=\"off\">--><!--        &lt;!&ndash;folio card section&ndash;&gt;--><!--        <div class=\"card\">--><!--          <div class=\"card-body folio-card\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-3\">--><!--                <div ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly || Transaction.formData.modifyAction == \'modifySip\' }\" class=\"form-input folio-input\">--><!--                  <label for=\"folioInput\" class=\"form-label\">Existing Folio Number</label>--><!--                  <select name=\"folio\" id=\"folioInput\"--><!--                          ng-change=\"Transaction.folioChanged()\"--><!--                          ng-model=\"Transaction.formData.folioNumber\"--><!--                          class=\"select-folio-list form-select\"--><!--                          ng-options=\"folio.folioNumber as folio.taxStatus disable when (!folio.activeFlag) for folio in Transaction.folioList\"--><!--                          ng-init=\"Transaction.formData.folioNumber=Transaction.formData.folioNumber?Transaction.formData.folioNumber: null\"--><!--                          options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=\"Transaction.isRequired\">--><!--                    <option value=\"\">Select Folio</option>--><!--                  </select>--><!--                  <span class=\"error-input\"--><!--                        ng-show=\"Transaction.tForm.folio.$dirty && Transaction.tForm.folio.$invalid && Transaction.tForm.folio.$error.required\"--><!--                        ng-bind=\"Transaction.VALIDATE_DATA.FOLIO_REQUIRED\"></span>--><!--                </div>--><!--              </div>--><!--              <div class=\"col-md-9 d-flex\">--><!--                <div class=\"investor-intro\">--><!--                  <div>--><!--                    Hi, <span>Pranali</span>--><!--                  </div>--><!--                  <div>--><!--                    Embark on a journey towards achieving your goal.--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--          </div>--><!--        </div>--><!--        &lt;!&ndash;folio card section ends here&ndash;&gt;--><!--        &lt;!&ndash;Scheme Details section start from here&ndash;&gt;--><!--        <div class=\"card\">--><!--          <div class=\"card-header\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-12\">--><!--                <h5>Scheme Details</h5>--><!--              </div>--><!--            </div>--><!--          </div>--><!--          <div class=\"card-body\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-7\">--><!--                <div class=\"form-input\">--><!--                  <label class=\"form-label\">Invest Through</label>--><!--                  <div class=\"invest-through-options\" ng-class=\"{\'anything-disabled\': Transaction.formData.dynamicData.readOnly }\">--><!--                    <div class=\"radio-button\">--><!--                      <input type=\"radio\" id=\"direct\" name=\"throughDistributor\" ng-value=\"true\"--><!--                             ng-model=\"Transaction.formData.isDirect\"--><!--                             ng-disabled=\"!Transaction.tForm.$valid\"/>--><!--                      <label class=\"btn btn-default\" for=\"direct\" ng-click=\"Transaction.changeThroughDistributor(\'DIRECT\')\">Direct</label>--><!--                    </div>--><!--                    <div class=\"radio-button\">--><!--                      <input type=\"radio\" id=\"distributor\" name=\"throughDistributor\" ng-value=\"true\"--><!--                             ng-model=\"Transaction.formData.isThroughDistributor\"--><!--                             ng-disabled=\"!Transaction.tForm.$valid\"/>--><!--                      <label class=\"btn btn-default\" for=\"distributor\" ng-click=\"Transaction.changeThroughDistributor(\'ARN\')\">Distributor</label>--><!--                    </div>--><!--                    <div class=\"radio-button\">--><!--                      <input type=\"radio\" name=\"throughDistributor\" id=\"ria\"--><!--                             ng-value=\"true\"--><!--                             ng-model=\"Transaction.formData.isThroughRia\"--><!--                             ng-disabled=\"!Transaction.tForm.$valid\"/>--><!--                      <label class=\"btn btn-default\" for=\"ria\" ng-click=\"Transaction.changeThroughDistributor(\'RIA\')\">RIA</label>--><!--                    </div>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            <div class=\"row distributor-sub-content\" ng-if=\"Transaction.formData.isThroughDistributor\">--><!--              <div class=\"sub-broker-content\">--><!--                <div class=\"col-sm-12 col-md-2\">--><!--                  <div class=\"form-input\"--><!--                       ng-class=\"{error:(Transaction.tForm.brokerCode.$dirty&&Transaction.tForm.brokerCode.$invalid)||(Transaction.brokerCodeError != \'\')}\">--><!--                    <input type=\"text\" class=\"form-control\" name=\"brokerCode\" id=\"brokerCode\"--><!--                           ng-model=\"Transaction.formData.brokerCode\"--><!--                           ng-change=\"Transaction.changeDistributorCode()\"--><!--                           autocomplete=\"off\"--><!--                           ng-blur=\"Transaction.searchDistributor();Transaction.showArnLabel=false\"--><!--                           ng-required=\"!Transaction.formData.distributorARN\"--><!--                           maxlength=\"10\" ng-pattern=\"/^[0-9]{4,10}$/\"--><!--                           placeholder=\"Broker ARN\"--><!--                           ng-focus=\"Transaction.showArnLabel=true\">--><!--                    <span class=\"highlight\"></span>--><!--                    <span class=\"bar\"></span>--><!--&lt;!&ndash;                    <span class=\"arn\" ng-show=\"Transaction.showArnLabel || Transaction.formData.brokerCode\">ARN -</span>&ndash;&gt;--><!--&lt;!&ndash;                    <label>ARN</label>&ndash;&gt;--><!--                    <p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name:--><!--                      {{Transaction.formData.brokerName}}</p>--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.required) && (!Transaction.formData.distributorName)\"--><!--                          ng-bind=\"Transaction.VALIDATE_DATA.BROKER_REQUIRED\"></span>--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"(Transaction.tForm.brokerCode.$dirty && Transaction.tForm.brokerCode.$invalid &&Transaction.tForm.brokerCode.$error.pattern) && (!Transaction.formData.distributorName)\"--><!--                          ng-bind=\"Transaction.VALIDATE_DATA.BROKER_VALID\"></span>--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"Transaction.brokerCodeError !== \'\' && !Transaction.tForm.brokerCode.$invalid\"--><!--                          ng-bind=\"Transaction.brokerCodeError\"></span>--><!--                  </div>--><!--                </div>--><!--                <div class=\"col-sm-12 col-md-2\" ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\">--><!--                  <div class=\"form-input\"--><!--                       ng-class=\"{error:(Transaction.tForm.subBrokerARN.$dirty&&Transaction.tForm.subBrokerARN.$invalid)||(Transaction.subBrokerCodeError !== \'\')}\">--><!--                    <input type=\"text\" class=\"form-control\" name=\"subBrokerARN\" id=\"subBrokerARN\"--><!--                           ng-model=\"Transaction.formData.subBrokerARN\"--><!--                           ng-change=\"Transaction.changeSubBrokerArn()\"--><!--                           ng-blur=\"Transaction.fetchEuinListSubBroker()\"--><!--                           maxlength=\"10\" ng-pattern=\"/^[0-9]{4,10}$/\"--><!--                           placeholder=\"Sub Broker ARN\"--><!--                           autocomplete=\"off\" restrict-special-charcter ng-trim=\"false\">--><!--                    <p ng-if=\"Transaction.subBrokerName\" class=\"info-primary\">Sub Broker Name:--><!--                      {{Transaction.subBrokerName}}</p>--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"(Transaction.tForm.subBrokerARN.$dirty && Transaction.tForm.subBrokerARN.$invalid && Transaction.tForm.subBrokerARN.$error.pattern)\"--><!--                          ng-bind=\"Transaction.VALIDATE_DATA.BROKER_VALID\"></span>--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"Transaction.subBrokerCodeError != \'\'&& !Transaction.tForm.subBrokerARN.$error.pattern\"--><!--                          ng-bind=\"Transaction.subBrokerCodeError\"></span>--><!--                  </div>--><!--                </div>--><!--                <div class=\"col-sm-12 col-md-2\" ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\">--><!--                  <div class=\"form-input\"--><!--                       ng-class=\"{error:Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$invalid}\">--><!--                    <input type=\"text\" name=\"subBrokerCode\" id=\"subBrokerCode\" class=\"form-control\"--><!--                           ng-model=\"Transaction.formData.subBrokerCode\"--><!--                           autocomplete=\"off\"--><!--                           ng-disabled=\"!Transaction.formData.subBrokerARN || Transaction.subBrokerCodeError !=\'\'\"--><!--                           ng-change=\"Transaction.changeSubBrokerCode()\"--><!--                           restrict-special-charcter--><!--                           placeholder=\"Sub Broker Code\"--><!--                           ng-trim=\"false\">--><!--                    <span class=\"error-input\"--><!--                          ng-show=\"Transaction.tForm.subBrokerCode.$dirty&&Transaction.tForm.subBrokerCode.$error.required\"--><!--                          ng-bind=\"Transaction.VALIDATE_DATA.SUB_BROKER_REQUIRED\"></span>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--              <div class=\"radio-block-content\" ng-class=\"{\'anything-disabled\': Transaction.isArnSuccess || Transaction.brokerCodeError !==\'\'}\">--><!--                <div class=\"col-md-6\">--><!--                  <div class=\"radio-block\">--><!--                    <span class=\"radio\">--><!--                      <input type=\"radio\"--><!--                             name=\"euinCheck\"--><!--                             ng-value=\"true\"--><!--                             ng-model=\"Transaction.formData.isEuin\"--><!--                             ng-click=\"Transaction.isCheckedTandC=false\"--><!--                             required=\"\"--><!--                             class=\"\" value=\"true\"--><!--                      >--><!--                      <span class=\"check\"></span>--><!--                    </span>--><!--                    <span class=\"radio-label\">EUIN</span>--><!--                  </div>--><!--                  <div class=\"radio-block\">--><!--                    <span class=\"radio\">--><!--                      <input type=\"radio\"--><!--                             name=\"euinCheck\"--><!--                             ng-value=\"false\"--><!--                             ng-model=\"Transaction.formData.isEuin\"--><!--                             ng-click=\"Transaction.euinData.euinNameCode=\'\';Transaction.filterEuinList();Transaction.isSelectedEuin=true;\"--><!--                             class=\"\"--><!--                             value=\"false\"--><!--                      >--><!--                      <span class=\"check\"></span>--><!--                    </span>--><!--                    <span class=\"radio-label\">EUIN Declaration</span>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--              <div class=\"euin-block-content\" ng-if=\"!Transaction.isArnSuccess && Transaction.formData.isEuin != null && Transaction.formData.isEuin === true &&  Transaction.formData.isThroughDistributor\">--><!--                <div class=\"col-md-4 form-input\">--><!--                  <div class=\"\" ng-class=\"{error:Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$invalid}\">--><!--                    <input type=\"text\" name=\"euin\" id=\"euin\" class=\"form-select\"--><!--                           ng-model=\"Transaction.euinData.euinNameCode\"--><!--                           ng-change=\"Transaction.filterEuinList()\"--><!--                           placeholder=\"Select EUIN\"--><!--                           ng-required=\"(Transaction.formData.brokerCode || Transaction.formData.distributorName) && !Transaction.isCheckedTandC\"--><!--                           autocomplete=\"off\">--><!--                    <span class=\"highlight\"></span>--><!--                    <span class=\"bar\"></span>--><!--                    &lt;!&ndash;                    <label>Select Euin</label>&ndash;&gt;--><!--                    <span class=\"error-input\" ng-show=\"(Transaction.tForm.euin.$dirty&&Transaction.tForm.euin.$error.required) || !Transaction.isSelectedEuin\"--><!--                          ng-bind=\"Transaction.VALIDATE_DATA.EUIN_REQUIRED\"></span>--><!--                    <list-drop-down list-data=\"Transaction.euinList\"--><!--                                    display-key=\"euinName\"--><!--                                    display-key-second=\"euinCode\"--><!--                                    hdfc-click=\"Transaction.selectEuin(data)\"--><!--                                    model=\"Transaction.formData.euin\"--><!--                                    for=\"euin\">--><!--                    </list-drop-down>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--              <div class=\"euin-dec-block-content\" ng-if=\"!Transaction.isArnSuccess && Transaction.formData.isEuin != null && Transaction.formData.isEuin === false && Transaction.formData.isThroughDistributor\">--><!--                <div class=\"checkbox col-md-6\">--><!--                  <input ng-model=\"Transaction.isCheckedTandC\" type=\"checkbox\"--><!--                         ng-disabled=\"!Transaction.formData.riaBrokerCode || Transaction.riaCodeError !== \'\'\"--><!--                         ng-change=\"Transaction.setTandCVariable();\"--><!--                         ng-required=\"(Transaction.formData.brokerCode || !Transaction.isArnSuccess) && !Transaction.formData.isEuin\"/>--><!--                  <i class=\"icon-checkbox\"></i>--><!--                  <ng-bind-html--><!--                    ng-bind-html = \"Transaction.riaMessage.content\"--><!--                  ></ng-bind-html>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            <div class=\"row ria-sub-content\" ng-if=\"Transaction.formData.isThroughRia\">--><!--              <div class=\"col-sm-12 col-md-4\">--><!--                <div class=\"form-input\"--><!--                     ng-class=\"{error:(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid)||(Transaction.riaCodeError != \'\')}\">--><!--                  <input type=\"text\" name=\"riaCode\" id=\"riaCode\"--><!--                         ng-model=\"Transaction.formData.riaBrokerCode\"--><!--                         ng-change=\"Transaction.changeDistributorCode()\"--><!--                         autocomplete=\"off\"--><!--                         ng-blur=\"Transaction.searchDistributor();\"--><!--                         ng-required=\"!Transaction.formData.distributorARN\"--><!--                         maxlength=\"12\" ng-pattern=\"/^[A-Z0-9]{12}/\"--><!--                         class=\"form-control\"--><!--                         placeholder=\"RIA Code\"--><!--                         capitalize--><!--                  >--><!--                  <span class=\"highlight\"></span>--><!--                  <span class=\"bar\"></span>--><!--                  <p ng-if=\"Transaction.formData.brokerName\" class=\"info-primary\">Distributor Name: {{Transaction.formData.brokerName}}</p>--><!--                  <span class=\"error-input\"--><!--                        ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.required)\"--><!--                        ng-bind=\"Transaction.VALIDATE_DATA.RIA_REQUIRED\"></span>--><!--                  <span class=\"error-input\"--><!--                        ng-show=\"(Transaction.tForm.riaCode.$dirty && Transaction.tForm.riaCode.$invalid &&Transaction.tForm.riaCode.$error.pattern)\"--><!--                        ng-bind=\"Transaction.VALIDATE_DATA.RIA_INVALID\"></span>--><!--                  <span class=\"error-input\"--><!--                        ng-show=\"Transaction.riaCodeError !== \'\' && !Transaction.tForm.riaCode.$invalid\"--><!--                        ng-bind=\"Transaction.riaCodeError\"></span>--><!--                </div>--><!--              </div>--><!--              <div class=\"checkbox col-md-10\">--><!--                <input ng-model=\"Transaction.isCheckedTandC\" type=\"checkbox\"--><!--                       ng-disabled=\"!Transaction.formData.riaBrokerCode || Transaction.riaCodeError !== \'\'\"--><!--                       ng-change=\"Transaction.setTandCVariable();\"--><!--                       ng-required=\"Transaction.formData.riaBrokerCode\"/>--><!--                <i class=\"icon-checkbox\"></i>--><!--                <ng-bind-html--><!--                  ng-bind-html = \"Transaction.riaMessage.content\"--><!--                ></ng-bind-html>--><!--              </div>--><!--            </div>--><!--            <div class=\"row\">--><!--              <div class=\"col-md-5\">--><!--                <div class=\"scheme-fields\">--><!--                  <div class=\"row\">--><!--                    <div class=\"col-md-9\">--><!--                      <div class=\"form-input\">--><!--                        <label for=\"sInScheme1\" class=\"form-label\">Select a Scheme</label>--><!--                        <div class=\"search-input\" ng-class=\"{error:Transaction.tForm.sInScheme1.$dirty && Transaction.tForm.sInScheme1.$invalid,--><!--                            \'anything-disabled\': Transaction.formData.dynamicData.readOnly}\">--><!--                            <input type=\"text\" name=\"sInScheme1\" id=\"sInScheme1\"--><!--                                   ng-change=\"Transaction.filterSipInSchemeList()\"--><!--                                   ng-model=\"Transaction.formData.inSchemeName\"--><!--                                   onpaste=\"return false;\"--><!--                                   ondrop=\"return false;\"--><!--                                   autocomplete=\"off\"--><!--                                   class=\"form-select\"--><!--                                   ng-disabled=\"!Transaction.formData.folioNumber\"--><!--                                   required>--><!--                            <span class=\"error-input\"--><!--                                  ng-show=\"Transaction.tForm.sInScheme1.$dirty && Transaction.tForm.sInScheme1.$error.required\"--><!--                                  ng-bind=\"Transaction.VALIDATE_DATA.SCHEME_REQUIRED\"></span>--><!--                            <drop-down list-data=\"Transaction.inSchemeList\"--><!--                                       display-key=\"scheme\"--><!--                                       hdfc-click=\"Transaction.sipSchemeChanged(data, \'sip\')\"--><!--                                       model=\"Transaction.formData.inSchemeCode\"--><!--                                       for=\"sInScheme1\">--><!--                            </drop-down>--><!--                            <p class=\"info-primary\">{{Transaction.formData.inSchemeName}}</p>--><!--                        </div>--><!--                      </div>--><!--                    </div>--><!--                    <div class=\"col-md-3\">--><!--                      <div ng-if=\"!Transaction.formData.dynamicData.readOnly\" class=\"scheme-options\">--><!--                        <span class=\"else-option\">--><!--                          OR--><!--                        </span>--><!--                        <span class=\"text-primary cursor-pointer\" ng-click=\"Transaction.tForm.$valid && Transaction.sipSchemeListModal()\">View All </span>--><!--                      </div>--><!--                    </div>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            <div class=\"row\">--><!--              <div class=\"col-md-7 dividend-option-wrapper\" ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\"--><!--                   ng-if=\"Transaction.validations.investmentOption === Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">--><!--                <div class=\"radio-block\" ng-repeat=\"_option in Transaction.dividendOptions\"--><!--                     ng-class=\"{\'anything-disabled\': ((_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)--><!--                     || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendPayoutApplicable === false)) }\">--><!--                  <span class=\"radio\">--><!--                    <input type=\"radio\" id=\"sDividendOption{{_option}}\" ng-value=\"_option\"--><!--                           ng-disabled=\"!fForm.$valid--><!--                           || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)--><!--                           || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendPayoutApplicable === false)\"--><!--                           name=\"sDividendOption\"--><!--                           ng-model=\"Transaction.formData.sipDividendOption\"--><!--                           ng-change=\"Transaction.changeDividendOption()\"--><!--                    />--><!--                    <span class=\"check\"></span>--><!--                  </span>--><!--                  <span class=\"radio-label\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            <div class=\"row form-group\"--><!--                 ng-if=\"Transaction.isSchemeTypeELSS && Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">--><!--              <div class=\"info-primary\">--><!--                Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS--><!--              </div>--><!--            </div>--><!--          </div>--><!--        </div>--><!--        &lt;!&ndash;scheme details section ends here&ndash;&gt;--><!--        &lt;!&ndash;Investment details section starts from here&ndash;&gt;--><!--        <div class=\"card\" ng-class=\"{\'disabled-block\': !Transaction.formData.folioNumber, \'anything-disabled\': !Transaction.formData.folioNumber}\">--><!--          <div class=\"card-header\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-12\">--><!--                <h5>Installment Details</h5>--><!--              </div>--><!--            </div>--><!--          </div>--><!--          <div class=\"card-body\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-12\">--><!--                <div class=\"amount-fields\">--><!--                  <div class=\"row\">--><!--                    <div class=\"col-md-4\">--><!--                      <div class=\"form-input\"--><!--                           ng-class=\"{error:(Transaction.tForm.sAmount.$invalid && Transaction.tForm.sAmount.$dirty),\'has-data\':Transaction.formData.amount}\">--><!--                        <label class=\"form-label\">Amount</label>--><!--                        <div class=\"input-group\">--><!--                          <span class=\"input-group-text\" id=\"rupee-addon\">--><!--                            <img src=\"assets/images/icons/rupee-icon-black.svg\" alt=\"rupee-icon\" />--><!--                          </span>--><!--                          <input type=\"number\" ignore-mouse-wheel name=\"sAmount\"--><!--                                 ng-model=\"Transaction.formData.amount\"--><!--                                 ng-change=\"Transaction.checkSipValidations();Transaction.changeAmount(false)\"--><!--                                 onkeyup=\"NumToWord(this.value,\'divDisplayWords\');\"--><!--                                 class=\"form-control\"--><!--                                 required>--><!--                        </div>--><!--                        <span class=\"error-input\"--><!--                              ng-show=\"Transaction.tForm.sAmount.$dirty && Transaction.tForm.sAmount.$error.required\"--><!--                              ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>--><!--                        <span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=\"error-input\">Minimum amount should be &#8377; {{Transaction.validations.minAmount|unit}}</span>--><!--                        &lt;!&ndash;        <span ng-if=\"Transaction.formData.amount && Transaction.isMax && Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=\"error-input\">SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode</span>&ndash;&gt;--><!--                        <span ng-if=\"Transaction.formData.amount && Transaction.isMax && Transaction.formData.sipPaymentOption != Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=\"error-input\">Maximum amount should be &#8377; {{Transaction.validations.maxAmount|unit}}</span>--><!--                        <span--><!--                          ng-if=\"Transaction.formData.amount && !Transaction.isMax && !Transaction.isMin && (Transaction.validations.amountMultiples&&!Transaction.isMultiples) && !Transaction.amountExceeded\"--><!--                          class=\"error-input\">Please Provide In multiples of &#8377; {{Transaction.validations.amountMultiples|unit}}</span>--><!--                        <span ng-show=\"Transaction.tForm.sAmount.$dirty && Transaction.formData.amount && Transaction.amountExceeded\" ng-if=\"Transaction.formData.modifyAction !== \'modifySip\'\" class=\"error-input\" ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_EXCEEDED\"></span>--><!--                        <span ng-show=\"Transaction.formData.amount && Transaction.amountExceeded\" ng-if=\"Transaction.formData.modifyAction === \'modifySip\'\" class=\"error-input\" ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_EXCEEDED\"></span>--><!--                        <div class=\"form-group\">--><!--                          <label id=\"divDisplayWords\">{{Transaction.amountInWords}}</label>--><!--                        </div>--><!--                      </div>--><!--                    </div>--><!--                    <div class=\"col-md-4\">--><!--                      <div class=\"scheme-fields\">--><!--                        <div class=\"row\">--><!--                          <div class=\"col-md-12\">--><!--                            <div class=\"form-input\">--><!--                              <label for=\"freq\" class=\"form-label\">SIP Frequency</label>--><!--                              <div class=\"dropdown\">--><!--                                <div class=\"value-wrapper f-weight-500\" data-bs-toggle=\"dropdown\" id=\"freq\">{{Transaction.selectedFreq.name}}--><!--                                  <img src=\"../../../../../assets/images/icons/drop-arrow-red.svg\" alt=\"down\">--><!--                                </div>--><!--                                <ul class=\"dropdown-menu\">--><!--                                  <li class=\"list-group-item\" ng-repeat=\"freq in Transaction.frequencyList\" ng-click=\"Transaction.changeFrequency(freq)\">--><!--                                    {{freq.name}}--><!--                                    <div class=\"separator\"></div>--><!--                                  </li>--><!--                                </ul>--><!--                              </div>--><!--                            </div>--><!--                          </div>--><!--                        </div>--><!--                      </div>--><!--                    </div>--><!--                    <div class=\"col-md-4\" ng-if=\"Transaction.formData.frequency && (Transaction.formData.frequency == \'OW\')\">--><!--                      <div class=\"scheme-fields\">--><!--                        <div class=\"row\">--><!--                          <div class=\"form-input col-md-12\" style=\"margin: 23px 0px\">--><!--&lt;!&ndash;                            <label class=\"form-label\">Select Day<span class=\"req text-red\">*</span></label>&ndash;&gt;--><!--                            <div class=\"field-type-2\">--><!--                              <select name=\"day\"--><!--                                      ng-model=\"Transaction.formData.weeklyDay\"--><!--                                      ng-change=\"Transaction.changeDay()\"--><!--                                      class=\"form-select\"--><!--                                      ng-init=\"Transaction.formData.weeklyDay=Transaction.formData.weeklyDay?Transaction.formData.weeklyDay: null\"--><!--                                      ng-options=\"day as day for day in Transaction.daysList\"--><!--                                      required>--><!--                              </select>--><!--                              <label>Select Day<span class=\"req text-red\">*</span></label>--><!--                              <span class=\"error-input\"--><!--                                    ng-show=\"Transaction.tForm.weeklyDay.$dirty && Transaction.tForm.day.$error.required\"--><!--                                    ng-bind=\"Transaction.VALIDATE_DATA.DAY_REQUIRED\">--><!--                          </span>--><!--                            </div>--><!--                          </div>--><!--                        </div>--><!--                      </div>--><!--                    </div>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--            <div class=\"row\">--><!--              <div class=\"col-md-4\">--><!--                <div class=\"toggle-container\">--><!--                  <label class=\"switch\">--><!--                    <input type=\"checkbox\" ng-model=\"Transaction.formData.sipFirstInstallment\">--><!--                    <span class=\"slider\"></span>--><!--                  </label>--><!--                  <div class=\"label-black f-family-inter f-weight-400\">First Installment</div>--><!--                </div>--><!--              </div>--><!--              <div class=\"col-md-8\">--><!--                <div class=\"duration-content-wrapper\">--><!--                  <div class=\"head-title f-family-inter f-weight-600\">Duration</div>--><!--                  <div class=\"d-flex gap-2 mt-3\">--><!--                    &lt;!&ndash; Loop through the durations from API &ndash;&gt;--><!--                    <button type=\"button\" class=\"btn duration-btn f-weight-500\" ng-repeat=\"duration in Transaction.durations\"--><!--                            ng-disabled=\"duration.disabled\"--><!--                            ng-class=\"{\'active-btn\': Transaction.selectedDuration.value === duration.value}\"--><!--                            ng-click=\"Transaction.setDuration(duration)\">--><!--                      {{duration.text}}--><!--                    </button>--><!--                  </div>--><!--                  <div class=\"col-md-4 mt-4 rest-duration-container\" ng-if=\"Transaction.selectedDuration && Transaction.formData.startDate && Transaction.formData.endDate && (Transaction.selectedDuration.value !== 0)\">--><!--                    <div class=\"d-flex\">--><!--                      <span>--><!--                        <img src=\"../../../../../assets/images/icons/calender-revamp-blue-icon.svg\" alt=\"blue-calender-icon\"/>--><!--                      </span>--><!--                      <span class=\"dates f-family-inter f-weight-500\">{{Transaction.formData.startDate.format(\'DD-MMM-YYYY\')}} to {{Transaction.formData.endDate.format(\'DD-MMM-YYYY\')}}</span>--><!--                    </div>--><!--                  </div>--><!--                  <div class=\"col-md-11 mt-4 others-dates-container\" ng-if=\"Transaction.selectedDuration && (Transaction.selectedDuration.value === 0)\">--><!--                    <div class=\"row d-flex justify-content-evenly\">--><!--                      <div class=\"col-sm-12 col-md-6\" ng-class=\"\">--><!--                        <div class=\"form-input\">--><!--                          <div class=\"field-type-2\">--><!--                            <div class=\"input-group input-normal date date-picker transaction-cal\"--><!--                                 ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\"--><!--                                 date-calendar--><!--                                 data-viewmode=\"{{viewMode}}\"--><!--                                 data-date-default=\"Transaction.formData.startDate\"--><!--                                 data-enabled-dates=\"Transaction.enabledStartDates\"--><!--                                 data-min-date=\"Transaction.startMinDate\"--><!--                                 data-max-date=\"Transaction.startMaxDate\"--><!--                                 data-on-date-change=\"Transaction.changeStartDate\"--><!--                                 data-view-date=\"Transaction.enabledStartDates[0]\"--><!--                                 data-enable=\"true\"--><!--                                 style=\"position: relative;\">--><!--                              <input id=\"startDateId\" class=\"form-control\" type=\'text\' name=\"startDate\" ng-keyup=\"Transaction.autoDate(\'startDate\')\" required/>--><!--                              <label>SIP Start Date (DD/MM/YYYY)</label>--><!--                              <span class=\"input-group-addon\">--><!--                                <span class=\"glyphicon-calendar-revamp\"></span>--><!--                              </span>--><!--                            </div>--><!--                          </div>--><!--                          <div class=\"start-date-error\">--><!--                            <span class=\"error-input purchase-amount-error\" ng-if=\"formData.startDate && startDateError\">SIP Start Date is not valid. Please choose another date.</span>--><!--                          </div>--><!--                        </div>--><!--                      </div>--><!--                      <div class=\"col-sm-12 col-md-6\" ng-class=\"\">--><!--                        <div class=\"form-input\">--><!--                          <div class=\"field-type-2\">--><!--                            <div class=\"input-group input-normal date date-picker transaction-cal\"--><!--                                 ng-class=\"{error:Transaction.tForm.endDate.$dirty && Transaction.tForm.endDate.$invalid}\"--><!--                                 date-calendar--><!--                                 data-viewmode=\"{{viewMode}}\"--><!--                                 data-date-default=\"Transaction.formData.endDate\"--><!--                                 data-on-date-change=\"Transaction.changeEndDate\"--><!--                                 data-enabled-dates=\"Transaction.enabledEndDates\"--><!--                                 data-view-date=\"Transaction.enabledEndDateView\"--><!--                                 data-min-date=\"Transaction.enabledEndDates[0]\"--><!--                                 data-enable=\"true\"--><!--                                 id=\"endDate\"--><!--                                 showdefault=\"false\">--><!--                              <input id=\"endDateId\" class=\"form-control\" type=\'text\' name=\"endDate\" ng-keyup=\"Transaction.autoDate(\'endDate\')\" ng-blur=\"checkEnableEndDate()\" required/>--><!--                              <label>SIP End Date (DD/MM/YYYY)</label>--><!--                              <span class=\"input-group-addon\">--><!--                                <span class=\"glyphicon-calendar-revamp\"></span>--><!--                              </span>--><!--                            </div>--><!--                          </div>--><!--                          <div class=\"start-date-error\">--><!--                            <span class=\"error-input purchase-amount-error\" ng-if=\"formData.startDate && startDateError\">SIP Start Date is not valid. Please choose another date.</span>--><!--                          </div>--><!--                        </div>--><!--                      </div>--><!--                    </div>--><!--                    <div class=\"col-md-12\">--><!--                      <div class=\"seperators\">--><!--                        <span>OR</span>--><!--                      </div>--><!--                    </div>--><!--                    <div class=\"col-md-12 d-flex align-items-start checkbox-wrapper\">--><!--                      <span class=\"checkbox\">--><!--                        <input type=\"checkbox\" id=\"defaultDate\" ng-class=\"{\'anything-disabled\': !Transaction.formData.startDate || !Transaction.formData.inSchemeName }\"--><!--                               ng-model=\"Transaction.formData.isTillPerpetuity\"--><!--                               ng-change=\"Transaction.changeTillPerpetuityFlag()\"--><!--                               ng-disabled=\"!Transaction.formData.startDate || !Transaction.formData.inSchemeName\"--><!--                        >--><!--                        <span class=\"icon-checkbox\"></span>--><!--                      </span>--><!--                      <label for=\"defaultDate\" class=\"f-family-inter f-weight-400\">Mark Default End Date (2099)</label>--><!--                    </div>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--          </div>--><!--        </div>--><!--        &lt;!&ndash;Investment details section ends here&ndash;&gt;--><!--        &lt;!&ndash; Sip Top-up section start from here &ndash;&gt;--><!--        <div class=\"card\" ng-class=\"{\'disabled-block\': !Transaction.formData.showTopUpBlock || !Transaction.formData.folioNumber, \'anything-disabled\': !Transaction.formData.showTopUpBlock || !Transaction.formData.folioNumber}\">--><!--          <div class=\"card-header\">--><!--            <div class=\"row\">--><!--              <div class=\"col-sm-6 col-xs-6 col-md-6\">--><!--                <h5>SIP Top-up</h5>--><!--              </div>--><!--              <div class=\"col-sm-6 col-xs-6 col-md-6 d-flex justify-content-end\">--><!--                <label class=\"switch\">--><!--                  <input type=\"checkbox\" ng-model=\"Transaction.sipTopupEnabled\">--><!--                  <span class=\"slider\"></span>--><!--                </label>--><!--              </div>--><!--            </div>--><!--          </div>--><!--          <div class=\"card-body sip-topup-card-body\">--><!--            <div class=\"row\">--><!--              <div class=\"col-md-12\">--><!--                <div class=\"amount-fields\">--><!--                  <div class=\"row\">--><!--                    <div class=\"col-sm-12 col-md-4\">--><!--                      <div class=\"form-input\"--><!--                           ng-class=\"{error:(Transaction.tForm.topupAmount.$invalid && Transaction.tForm.topupAmount.$dirty),\'has-data\':Transaction.formData.topupDetails.amount}\">--><!--                        <label class=\"form-label\">Amount</label>--><!--                        <div class=\"input-group\">--><!--                          <span class=\"input-group-text\" id=\"rupee-addon\">--><!--                            <img src=\"assets/images/icons/rupee-icon-black.svg\" alt=\"rupee-icon\" />--><!--                          </span>--><!--                          <input type=\"number\" ignore-mouse-wheel name=\"topupAmount\"--><!--                                 ng-model=\"Transaction.formData.topupDetails.amount\"--><!--                                 ng-disabled=\"!Transaction.sipTopupEnabled || Transaction.formData.topupDetails.percentage\"--><!--                                 ng-change=\"Transaction.checkSipValidations(true);Transaction.resetCapAmount();\"--><!--                                 onkeyup=\"NumToWord(this.value,\'divDisplayInWords\');\"--><!--                                 class=\"form-control\"--><!--                                 ng-required=\"Transaction.formData.sipTopupEnabled && ((!Transaction.formData.topupDetails.percentage && !Transaction.formData.topupDetails.amount) || !Transaction.formData.topupDetails.percentage)\">--><!--                        </div>--><!--                        <span class=\"error-input\"--><!--                              ng-show=\"Transaction.tForm.topupAmount.$dirty && Transaction.tForm.topupAmount.$error.required\"--><!--                              ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_REQUIRED\"></span>--><!--                        <span ng-if=\"Transaction.formData.topupDetails.amount && Transaction.isTopupMinAmt\" class=\"error-input\">Minimum amount should be &#8377; {{Transaction.validations.topupMinAmt|unit}}</span>--><!--                        <span--><!--                          ng-if=\"Transaction.formData.topupDetails.amount  && !Transaction.isTopupMinAmt && (Transaction.validations.topupAmtMultples&&!Transaction.isTopUpMultiples)\"--><!--                          class=\"error-input\">Please provide In multiples of &#8377; {{Transaction.validations.topupAmtMultples|unit}}</span>--><!--                      </div>--><!--                      <div class=\"form-group\">--><!--                        <label id=\"divDisplayInWords\" ng-if=\"Transaction.formData.topupDetails.amount\">{{Transaction.amountInWords}} (In Words)</label>--><!--                      </div>--><!--                    </div>--><!--                    <div class=\"col-sm-12 col-md-2\">--><!--                      <div class=\"duration-content-wrapper\">--><!--                        <div class=\"head-title f-family-inter f-weight-600\">Frequency</div>--><!--                        <div class=\"d-flex gap-2 mt-3\">--><!--                          &lt;!&ndash; Loop through the topupFrequencyList from API &ndash;&gt;--><!--                          <button type=\"button\" class=\"btn duration-btn f-weight-500\" ng-repeat=\"topUpFreq in Transaction.topupFrequencyList\"--><!--                                  ng-class=\"{\'active-btn\': Transaction.formData.topupDetails.frequency === topUpFreq.key}\"--><!--                                  ng-click=\"Transaction.changeTopUpFreq(topUpFreq)\">--><!--                            {{topUpFreq.value}}--><!--                          </button>--><!--                        </div>--><!--                      </div>--><!--                    </div>--><!--                    <div class=\"col-md-1\"></div>--><!--                    <div class=\"col-sm-12 col-md-5 topup-amt-and-capyear-container\">--><!--                      <div class=\"row\">--><!--                        <div class=\"col-md-12 mb-2 f-family-inter f-weight-700 head-title\">SIP Top-up CAP</div>--><!--                        <div class=\"col-md-5\">--><!--                          <div class=\"form-input\"--><!--                               ng-class=\"{error:(Transaction.tForm.capAmount.$invalid && Transaction.tForm.capAmount.$dirty && Transaction.isminCapAmount),\'has-data\':Transaction.formData.capAmount}\">--><!--                            <label class=\"form-label\">Amount</label>--><!--                            <div class=\"input-group\">--><!--                              <span class=\"input-group-text\" id=\"rupee-addon\">--><!--                                <img src=\"assets/images/icons/rupee-icon-black.svg\" alt=\"rupee-icon\" />--><!--                              </span>--><!--                              <input type=\"number\" ignore-mouse-wheel name=\"capAmount\"--><!--                                     ng-model=\"Transaction.formData.topupDetails.capAmount\"--><!--                                     ng-disabled=\"!Transaction.sipTopupEnabled || Transaction.formData.topupDetails.capMonthYear\"--><!--                                     onkeyup=\"NumToWord(this.value,\'capAmntDisplayInWords\');\"--><!--                                     ng-change=\"Transaction.capAmountChanged();\"--><!--                                     class=\"form-control\"--><!--                                     ng-required=\"Transaction.formData.sipTopupEnabled && ((!Transaction.formData.topupDetails.capAmount && !Transaction.formData.topupDetails.capMonthYear) || !Transaction.formData.topupDetails.capMonthYear)\">--><!--                            </div>--><!--                            <span class=\"error-input\"--><!--                                  ng-show=\"Transaction.tForm.capAmount.$dirty && Transaction.tForm.capAmount.$error.required\"--><!--                                  ng-bind=\"Transaction.VALIDATE_DATA.AMOUNT_REQUIRED\">--><!--                            </span>--><!--                            <span ng-if=\"Transaction.formData.topupDetails.capAmount && Transaction.isminCapAmount\" class=\"error-input\">Minimum amount should be &#8377; {{Transaction.minCapAmount}}</span>--><!--                          </div>--><!--                          <div class=\"form-group\" ng-if=\"Transaction.formData.modifyAction !== \'modifySip\'\">--><!--                            <label id=\"capAmntDisplayInWords\"><span ng-if=\"Transaction.formData.topupDetails.capAmount\">{{Transaction.amountInWords}} (In Words)</span></label>--><!--                          </div>--><!--                          <div class=\"form-group\" ng-if=\"Transaction.formData.modifyAction == \'modifySip\'\">--><!--                            <label id=\"capAmntDisplayInWords\" ng-if=\"Transaction.formData.topupDetails.capAmount\">{{Transaction.amountInWords}} (In Words)</label>--><!--                          </div>--><!--                        </div>--><!--&lt;!&ndash;                        <span class=\"col-md-1 else-option\">OR</span>&ndash;&gt;--><!--&lt;!&ndash;                        <div class=\"col-md-5\">&ndash;&gt;--><!--&lt;!&ndash;                          <div class=\"form-input\">&ndash;&gt;--><!--&lt;!&ndash;                            <div class=\"field-type-2\">&ndash;&gt;--><!--&lt;!&ndash;                              <div class=\"input-group input-normal date date-picker transaction-cal\"&ndash;&gt;--><!--&lt;!&ndash;                                   ng-class=\"{error:Transaction.tForm.endDate.$dirty && Transaction.tForm.endDate.$invalid}\"&ndash;&gt;--><!--&lt;!&ndash;                                   date-calendar&ndash;&gt;--><!--&lt;!&ndash;                                   data-viewmode=\"years\"&ndash;&gt;--><!--&lt;!&ndash;                                   data-date-default=\"Transaction.formData.topupDetails.capMonthYearSelect\"&ndash;&gt;--><!--&lt;!&ndash;                                   data-on-date-change=\"Transaction.changeCapMonthYear\"&ndash;&gt;--><!--&lt;!&ndash;                                   data-enabled-dates=\"Transaction.capDates\"&ndash;&gt;--><!--&lt;!&ndash;                                   data-view-date=\"Transaction.enableCapDateView\"&ndash;&gt;--><!--&lt;!&ndash;                                   data-min-date=\"Transaction.capDates[0]\"&ndash;&gt;--><!--&lt;!&ndash;                                   format=\"MMM-YYYY\"&ndash;&gt;--><!--&lt;!&ndash;                                   data-enable=\"true\"&ndash;&gt;--><!--&lt;!&ndash;                                   id=\"capMonthYear\"&ndash;&gt;--><!--&lt;!&ndash;                                   showdefault=\"false\">&ndash;&gt;--><!--&lt;!&ndash;                                <input id=\"capMonthYearId\" class=\"form-control\" type=\'text\' name=\"endDate\" required/>&ndash;&gt;--><!--&lt;!&ndash;                                <label>Cap Month Year</label>&ndash;&gt;--><!--&lt;!&ndash;                                <span class=\"input-group-addon\">&ndash;&gt;--><!--&lt;!&ndash;                                <span class=\"glyphicon-calendar-revamp\"></span>&ndash;&gt;--><!--&lt;!&ndash;                              </span>&ndash;&gt;--><!--&lt;!&ndash;                              </div>&ndash;&gt;--><!--&lt;!&ndash;                            </div>&ndash;&gt;--><!--&lt;!&ndash;                            <div class=\"start-date-error\">&ndash;&gt;--><!--&lt;!&ndash;                              <span class=\"error-input purchase-amount-error\" ng-if=\"formData.startDate && startDateError\">SIP Start Date is not valid. Please choose another date.</span>&ndash;&gt;--><!--&lt;!&ndash;                            </div>&ndash;&gt;--><!--&lt;!&ndash;                          </div>&ndash;&gt;--><!--&lt;!&ndash;                        </div>&ndash;&gt;--><!--                      </div>--><!--                    </div>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><!--          </div>--><!--        </div>--><!--        &lt;!&ndash; Sip Top-up section ends here &ndash;&gt;--><!--      </form>--><!--    </section>--><!--  </div>--><!--  <div class=\"transaction-footer\">--><!--  </div>--><!--</div>--><div class=\"container-fluid sip-purchase main-section\"><form name=Transaction.tForm ng-keypress=Transaction.handleEnter($event) novalidate autocomplete=off class=form-container><div class=transaction-header><h3 class=page-title>SIP</h3></div><div class=transaction-body ng-if=!Transaction.showCancelledAndModifiedDetails><section class=initiate-transaction><div class=\"row sip-details-form-container\"><div class=col-md-8><fieldset ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber}\"><div class=main-content><!--Scheme listing row--><div class=\"row mb-4\"><div class=col-md-12><div class=scheme-fields><div class=row><div class=col-md-10><div class=form-input><label for=sInScheme1 class=\"form-label form-label-bold\">Select a Scheme</label><div class=\"search-input selection-width\" ng-class=\"{error:Transaction.tForm.sInScheme1.$dirty && Transaction.tForm.sInScheme1.$invalid,\n                              \'anything-disabled\': Transaction.formData.dynamicData.readOnly}\"><input type=text name=sInScheme1 id=sInScheme1 ng-change=Transaction.filterSipInSchemeList() ng-model=Transaction.formData.inSchemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off class=\"form-select text-center\" ng-disabled=!Transaction.formData.folioNumber required> <span class=error-input ng-show=\"Transaction.tForm.sInScheme1.$dirty && Transaction.tForm.sInScheme1.$error.required\" ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.inSchemeList display-key=scheme hdfc-click=\"Transaction.sipSchemeChanged(data, true)\" model=Transaction.formData.inSchemeCode for=sInScheme1></drop-down><!--                              <p class=\"info-primary\">{{Transaction.formData.inSchemeName}}</p>--></div></div></div><div class=col-md-2><div ng-if=!Transaction.formData.dynamicData.readOnly class=\"scheme-options separator-wrapper\"><div class=else-option><span>OR</span></div><span class=\"text-primary cursor-pointer view-all-hide-m\" ng-click=Transaction.sipSchemeListModal()>View All</span><div class=\"or-divider d-md-none d-lg-none d-xl-none d-xxl-none\"><span class=divider-text>OR</span></div><div class=\"text-primary cursor-pointer view-all d-md-none d-lg-none d-xl-none d-xxl-none\" ng-click=Transaction.sipSchemeListModal()>View All</div></div></div></div></div></div></div><!-- IDCW Option --><div class=row><div class=\"col-md-10 d-flex justify-content-center dividend-option-wrapper\" ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\" ng-if=\"Transaction.validations.investmentOption === Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><div class=radio-block ng-repeat=\"_option in Transaction.dividendOptions\" ng-class=\"{\'anything-disabled\': ((_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)\n                       || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendPayoutApplicable === false)) }\"><span class=radio><input type=radio id=sDividendOption{{_option}} ng-value=_option ng-disabled=\"\n                             (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendReinvestmentApplicable === false)\n                             || (_option == Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.PAYOUT  && Transaction.inSchemeValidations.isGrowth === false && Transaction.inSchemeValidations.dividendPayoutApplicable === false)\" name=sDividendOption ng-model=Transaction.formData.sipDividendOption ng-change=Transaction.helper.changeDividendOption()> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div><div ng-if=\"Transaction.isSchemeTypeELSS && Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><i class=\"info-icon base-tooltip\" data-bs-html=true tooltip data-bs-toggle=tooltip data-bs-placement=right style=\"margin-left: -7px\" data-bs-title=\"Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS\"></i></div></div></div><!-- SIP Amount row --><div class=row><div class=\"col-sm-12 col-md-10 d-flex justify-content-center flex-column\"><div class=\"form-input sip-amt-container\"><label class=\"form-label form-label-bold d-flex justify-content-center\">Enter SIP Amount</label><div class=\"input-normal icon-input\" ng-class=\"{error:(Transaction.tForm.sAmount.$invalid && Transaction.tForm.sAmount.$dirty),\'has-data\':Transaction.formData.amount}\"><!--<span class=\"rupee-symbol-entity\">&#8377;</span>--> <input type=text ignore-mouse-wheel name=sAmount ng-model=Transaction.formData.displayAmount ng-disabled=!Transaction.formData.inSchemeName class=input-style ng-change=\"Transaction.changeAmount(false, Transaction.formData.amount, true)\" onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" required> <span class=rupee-span-new ng-if=!Transaction.formData.displayAmount>₹</span> <span class=highlight></span> <span class=bar></span></div></div><div class=text-center><span class=error-input ng-show=\"Transaction.tForm.sAmount.$dirty && Transaction.tForm.sAmount.$error.required\" ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"Transaction.formData.amount && Transaction.isMin\" class=error-input>Minimum amount should be &#8377; {{Transaction.validations.minAmount|unit}}</span><!--        <span ng-if=\"Transaction.formData.amount && Transaction.isMax && Transaction.formData.sipPaymentOption===Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=\"error-input\">SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode</span>--> <span ng-if=\"Transaction.formData.amount && Transaction.isMax && Transaction.formData.sipPaymentOption != Transaction.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE\" class=error-input>Maximum amount should be &#8377; {{Transaction.validations.maxAmount|unit}}</span> <span ng-if=\"Transaction.formData.amount && !Transaction.isMax && !Transaction.isMin && (Transaction.validations.amountMultiples&&!Transaction.isMultiples) && !Transaction.amountExceeded\" class=error-input>Please Provide In multiples of &#8377; {{Transaction.validations.amountMultiples|unit}}</span> <span ng-show=\"Transaction.tForm.sAmount.$dirty && Transaction.formData.amount && Transaction.amountExceeded\" ng-if=\"Transaction.formData.modifyAction !== \'modifySip\'\" class=error-input ng-bind=Transaction.VALIDATE_DATA.AMOUNT_EXCEEDED></span> <span ng-show=\"Transaction.formData.amount && Transaction.amountExceeded\" ng-if=\"Transaction.formData.modifyAction === \'modifySip\'\" class=error-input ng-bind=Transaction.VALIDATE_DATA.AMOUNT_EXCEEDED></span><div class=form-group ng-if=Transaction.formData.amount><label>{{Transaction.formData.amountInWords}}</label></div></div></div></div><!-- SIP tenure and Frequency --><div class=\"row mb-3\"><div class=\"col-sm-12 col-md-6\" ng-class=\"{\'anything-disabled\': !Transaction.formData.inSchemeCode}\"><dual-date-picker enabled-start-dates=Transaction.enabledStartDates enabled-end-dates=Transaction.enabledEndDates current-view-start=Transaction.startDateView current-view-end=Transaction.endDateView start-date=Transaction.formData.startDate end-date=Transaction.formData.endDate on-change-start-date=Transaction.changeStartDate on-change-end-date=Transaction.changeEndDate input-placeholder=Transaction.sipTenurePlaceHolder></dual-date-picker></div><div class=\"col-sm-12 col-md-6\"><div class=scheme-fields><div class=row><div class=col-md-12><div class=form-input><label for=freq class=form-label>Frequency</label><div class=dropdown><div class=\"value-wrapper f-weight-500 dark-color\" data-bs-toggle=dropdown id=freq>{{Transaction.selectedFreq.name}} <img src=../../../../../assets/images/icons/drop-arrow-red.svg alt=down></div><ul class=\"dropdown-menu customize-dropdown\" ng-hide=!Transaction.frequencyList><li class=list-group-item ng-repeat=\"freq in Transaction.frequencyList\" ng-click=\"Transaction.changeFrequency(freq, true)\">{{freq.name}}<div class=separator></div></li></ul></div></div><div class=sip-message ng-if=\"Transaction.selectedFreq && Transaction.selectedFreq.code === \'BZ\'\"><i class=info-fill></i><p>Mode of payment through Daily SIP shall be only through OTM of frequency - As and when presented. SIP Top Up facility is not available for Daily SIP. For Daily SIP, OTM bank must have OTM Instruction Type as AWP. Daily SIP end date can be only on a business day.</p></div></div></div></div></div></div><div class=\"row mb-3\" ng-if=\"Transaction.selectedFreq && Transaction.selectedFreq.code === \'OW\'\"><div class=col-md-6></div><div class=col-md-6><div class=col-md-12><div class=scheme-fields><div class=row><div><div class=form-input><label for=freq class=form-label>Select Day</label><div class=dropdown><div class=\"value-wrapper f-weight-500\" data-bs-toggle=dropdown id=weeklyDay>{{Transaction.formData.weeklyDay}} <img src=../../../../../assets/images/icons/drop-arrow-red.svg alt=down></div><ul class=\"dropdown-menu customize-dropdown\"><li class=list-group-item ng-repeat=\"day in Transaction.daysList\" ng-click=Transaction.helper.changeDay(day)>{{day}}<div class=separator></div></li></ul></div></div></div></div></div></div></div></div><!-- SIP First Installment toggle --><div class=\"row mb-4\" ng-if=\"Transaction.formData.inSchemeCode && Transaction.formData.frequency !==\'BZ\' \"><div class=col-md-4><div class=toggle-container><label class=switch><input type=checkbox ng-model=Transaction.formData.sipFirstInstallment> <span class=slider></span></label><div class=\"label-black f-family-inter f-weight-400\">Pay SIP 1st installment</div></div></div></div><!-- SIP Top-up checkbox --><div class=\"row sip-topup-checkbox-container\" ng-if=Transaction.formData.showTopUpBlock><div class=\"checkbox f-family-inter f-weight-400\"><input ng-model=Transaction.formData.sipTopupSelected type=checkbox ng-disabled=\"\" ng-change=Transaction.openTopupDetailsPopup(); ng-required=\"\"> <i class=icon-checkbox></i> SIP Top-Up</div><i class=edit-icon ng-if=Transaction.formData.sipTopupSelected ng-click=Transaction.helper.showTopUpDetails()></i></div></div></fieldset></div><div class=col-md-4><div data-ng-include=\"\'app/transactions/initiate/sip-purchase/invest-through/invest-through-with-folio-section.html\'\"></div></div></div></section></div><div class=cancelled-and-modified-details ng-if=Transaction.showCancelledAndModifiedDetails><div class=row><div class=\"col-md-12 back-to-transaction\"><img src=assets/images/back-arrow-icon.svg class=\"arrowBackIcon resp-head-icon\" ng-click=\"Transaction.showCancelledAndModifiedDetails = false;\"></div><div class=col-md-6><p class=modified-details>Cancelled Details:</p><table class=\"table borderless\" ng-if=\"Transaction.formData.investmentType === Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || Transaction.formData.optionalInvestmentType === Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"><tr ng-if=Transaction.oldSipSystematicData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=Transaction.oldSipSystematicData.isThroughDistributor>{{Transaction.oldSipSystematicData.brokerCode?\'ARN-\'+Transaction.oldSipSystematicData.brokerCode:(Transaction.oldSipSystematicData.distributorARN?Transaction.oldSipSystematicData.distributorARN:\'\')}}</td><td ng-if=!Transaction.oldSipSystematicData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=Transaction.oldSipSystematicData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=Transaction.oldSipSystematicData.isThroughRia>{{Transaction.oldSipSystematicData.riaBrokerCode}}</td><td ng-if=!Transaction.oldSipSystematicData.riaBrokerCode>N/A</td></tr><tr ng-if=Transaction.oldSipSystematicData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=Transaction.oldSipSystematicData.riaBrokerName>{{Transaction.oldSipSystematicData.riaBrokerName}}</td><td ng-if=!Transaction.oldSipSystematicData.riaBrokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"Transaction.oldSipSystematicData.isThroughDistributor && Transaction.oldSipSystematicData.isEuin && Transaction.oldSipSystematicData.euinCode\"><td>EUIN Code</td><td>:</td><td>{{Transaction.oldSipSystematicData.euinCode}}</td></tr><tr ng-if=\"Transaction.oldSipSystematicData.isThroughDistributor && Transaction.oldSipSystematicData.isEuin && Transaction.oldSipSystematicData.euinName\"><td>EUIN Name</td><td>:</td><td>{{Transaction.oldSipSystematicData.euinName}}</td></tr><tr ng-if=\"Transaction.formData.isThroughDistributor && Transaction.oldSipSystematicData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td>{{\'ARN-\'+Transaction.oldSipSystematicData.subBrokerARN}}</td></tr><tr ng-if=\"Transaction.formData.isThroughDistributor && Transaction.oldSipSystematicData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td>{{Transaction.oldSipSystematicData.subBrokerCode}}</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Transaction.oldSipSystematicData.inSchemeName}}</td></tr><tr ng-if=Transaction.oldSipSystematicData.investmentOption><td>Investment Option</td><td>:</td><td>{{Transaction.oldSipSystematicData.investmentOption}}</td></tr><tr ng-if=\"Transaction.oldSipSystematicData.dividendOption && Transaction.oldSipSystematicData.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td><span ng-if=\"Transaction.oldSipSystematicData.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[Transaction.oldSipSystematicData.sipDividendOption]}}</span></td></tr><tr ng-if=Transaction.oldSipSystematicData.amount><td>Amount</td><td>:</td><td>{{Transaction.oldSipSystematicData.displayAmount}}<br><label id=amountInwords>{{Transaction.oldSipSystematicData.amountInWords}} (In Words)</label></td></tr><tr ng-if=Transaction.oldSipSystematicData.frequency><td>Installment Frequency</td><td>:</td><td>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Transaction.oldSipSystematicData.frequency]}}</td></tr><tr ng-if=\"Transaction.oldSipSystematicData.frequency == \'OW\' && Transaction.oldSipSystematicData.weeklyDay\"><td>SIP Day</td><td>:</td><td>{{Transaction.oldSipSystematicData.weeklyDay}}</td></tr><tr ng-if=Transaction.oldSipSystematicData.startDate><td>Start Date</td><td>:</td><td>{{Transaction.oldSipSystematicData.startDate}}</td></tr><tr ng-if=Transaction.oldSipSystematicData.endDate><td>End Date</td><td>:</td><td>{{Transaction.oldSipSystematicData.endDate}}</td></tr><tr ng-if=Transaction.oldSipSystematicData.sipPaymentOption><td>Payment Option</td><td>:</td><td ng-if=\"Transaction.oldSipSystematicData.sipPaymentOption ==\'EC\'\">Standing Instruction/Biller</td><td ng-if=\"Transaction.oldSipSystematicData.sipPaymentOption ==\'OTM\'\">OTM (One Time Mandate)</td><td ng-if=\"Transaction.oldSipSystematicData.sipPaymentOption == \'E-mandate\'\">E-mandate</td></tr><tr ng-if=Transaction.oldSipSystematicData.bankInfo.bankName><td>Bank Name</td><td>:</td><td ng-if=Transaction.oldSipSystematicData.bankInfo.bankName>{{Transaction.oldSipSystematicData.bankInfo.bankName | uppercase}}</td></tr><tr ng-if=Transaction.oldSipSystematicData.bankInfo.bankAcNo><td>Account Number</td><td>:</td><td>{{Transaction.oldSipSystematicData.bankInfo.bankAcNo}}</td></tr><tr ng-if=\"Transaction.oldSipSystematicData.sipPaymentOption ==\'OTM\'\"><td>OTM UMRN Number</td><td>:</td><td>{{Transaction.oldSipSystematicData.bankInfo.omUmrn}}</td></tr><tr ng-if=Transaction.oldSipSystematicData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"Transaction.oldSipSystematicData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=Transaction.oldSipSystematicData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=Transaction.oldSipSystematicData.inSchemeName></td></tr><tr ng-if=Transaction.oldSipSystematicData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"Transaction.oldSipSystematicData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr><tr ng-if=Transaction.oldSipSystematicData.sipFirstInstallment><td>SIP First Installment</td><td>:</td><td ng-bind=\"Transaction.oldSipSystematicData.sipFirstInstallment?\'Yes\':\'No\'\"></td></tr><tr ng-if=Transaction.oldSipSystematicData.sipFirstAmount><td>SIP First Installment Amount</td><td>:</td><td><i class=rupee-small-icon></i> {{Transaction.oldSipSystematicData.sipFirstAmount}}</td></tr></table><table class=\"borderless table\"><tr ng-if=!Transaction.oldSipSystematicData.sipTopupEnabled><td>SIP Topup Enabled</td><td>:</td><td>No</td></tr><tr ng-if=Transaction.oldSipSystematicData.sipTopupEnabled><td>SIP Topup Enabled</td><td>:</td><td>Yes</td></tr><tr ng-if=\"Transaction.oldSipSystematicData.sipTopupEnabled && Transaction.oldSipSystematicData.topupDetails.amount\"><td>SIP Topup Amount</td><td>:</td><td>{{Transaction.oldSipSystematicData.topupDetails.displayAmount}}<br><label id=topUpamountFromModify>{{Transaction.topupAmountFromModify.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"Transaction.oldSipSystematicData.sipTopupEnabled && Transaction.oldSipSystematicData.topupDetails.percentage\"><td>SIP Topup Percentage</td><td>:</td><td>{{Transaction.oldSipSystematicData.topupDetails.percentage}}%</td></tr><tr ng-if=\"Transaction.oldSipSystematicData.sipTopupEnabled && Transaction.oldSipSystematicData.topupDetails.frequency\"><td>SIP Topup Frequency</td><td>:</td><td>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Transaction.oldSipSystematicData.topupDetails.frequency]}}</td></tr><tr ng-if=\"Transaction.oldSipSystematicData.sipTopupEnabled && Transaction.oldSipSystematicData.topupDetails.capAmount\"><td>SIP Topup Cap Amount</td><td>:</td><td>{{Transaction.oldSipSystematicData.topupDetails.displayCapAmount}}<br><label id=topUpCapamountFromModify>{{Transaction.topupCapAmountFromModify.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"Transaction.oldSipSystematicData.sipTopupEnabled && Transaction.oldSipSystematicData.topupDetails.capMonthYear\"><td style=\"width: 200px\">SIP Topup Cap Month/Year</td><td>:</td><td>{{capMonthYear}}</td></tr></table><!--          <table class=\"table borderless\" ng-if=\"oldSipSystematicData.summaryType === \'SIP_TOPUP\'\">--><!--            <tr>--><!--              <td>Folio Number</td>--><!--              <td>:</td>--><!--              <td>{{oldSipSystematicData.folioNumber}}</td>--><!--            </tr>--><!--            <tr>--><!--              <td>Amount</td>--><!--              <td>:</td>--><!--              <td><i class=\"rupee-small-icon\"></i> {{oldSipSystematicData.amount}}<br>--><!--                <label id=\"amountInwords\"> {{oldSipSystematicData.amountInWords}} (In Words)</label> </td>--><!--            </tr>--><!--            <tr>--><!--              <td>Installment Frequency</td>--><!--              <td>:</td>--><!--              <td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[oldSipSystematicData.frequency]}}</td>--><!--            </tr>--><!--            <tr>--><!--              <td>Sip End Date</td>--><!--              <td>:</td>--><!--              <td>{{oldSipSystematicData.toDate}}</td>--><!--            </tr>--><!--            <tr ng-if=\"oldSipSystematicData.topupAmount\">--><!--              <td>Topup Amount</td>--><!--              <td>:</td>--><!--              <td><i class=\"rupee-small-icon\"></i> {{oldSipSystematicData.topupAmount}}</td>--><!--            </tr>--><!--            <tr ng-if=\"formData.topupPercentage\">--><!--              <td>Topup Percentage</td>--><!--              <td>:</td>--><!--              <td>{{oldSipSystematicData.topupPercentage}}%</td>--><!--            </tr>--><!--            <tr>--><!--              <td>Topup Frequency</td>--><!--              <td>:</td>--><!--              <td>{{TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[formData.topupFrequency]}}</td>--><!--            </tr>--><!--            <tr ng-if=\"oldSipSystematicData.topupCapAmount\">--><!--              <td>Topup Cap-Amount</td>--><!--              <td>:</td>--><!--              <td><i class=\"rupee-small-icon\"></i> {{oldSipSystematicData.topupCapAmount}}</td>--><!--            </tr>--><!--            <tr ng-if=\"oldSipSystematicData.topupCapMonthYear\">--><!--              <td>Topup Cap-Date</td>--><!--              <td>:</td>--><!--              <td>{{oldSipSystematicData.sipTopupCapMonthYear}}</td>--><!--            </tr>--><!--            <tr>--><!--              <td>Payment Option</td>--><!--              <td>:</td>--><!--              <td ng-if=\"oldSipSystematicData.bankDetailsForECS.paymentOption ==\'EC\'\">Standing Instruction/Biller</td>--><!--              <td ng-if=\"oldSipSystematicData.bankDetailsForECS.paymentOption ==\'OTM\'\">OTM (One Time Mandate)</td>--><!--            </tr>--><!--            <tr>--><!--              <td>Bank Name</td>--><!--              <td>:</td>--><!--              <td>{{oldSipSystematicData.bankInfo.bankName | uppercase}}</td>--><!--            </tr>--><!--            <tr ng-if=\"(oldSipSystematicData.bankInfo.bankName==\'HDFC BANK\' && oldSipSystematicData.sipPaymentOption ==\'EC\')\">--><!--              <td>Account Number</td>--><!--              <td>:</td>--><!--              <td>{{oldSipSystematicData.bankAcNo}}</td>--><!--            </tr>--><!--            <tr ng-if=\"oldSipSystematicData.sipPaymentOption ==\'OTM\'\">--><!--              <td>OTM UMRN Number</td>--><!--              <td>:</td>--><!--              <td>{{oldSipSystematicData.bankInfo.omUmrn}}</td>--><!--            </tr>--><!--            <tr ng-if=\"oldSipSystematicData.checkedNfoAutoSwitch\">--><!--              <td>Auto Switch On Maturity:</td>--><!--              <td ng-bind=\"oldSipSystematicData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td>--><!--            </tr>--><!--            <tr ng-if=\"oldSipSystematicData.checkedNfoAutoSwitch\">--><!--              <td>Auto Switch scheme:</td>--><!--              <td ng-bind=\"oldSipSystematicData.inSchemeName\"></td>--><!--            </tr>--><!--            <tr ng-if=\"oldSipSystematicData.checkedNfoAutoSwitch\">--><!--              <td>Auto Switch Scheme IDCW Option:</td>--><!--              <td ng-bind=\"oldSipSystematicData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td>--><!--            </tr>--><!--          </table>--></div><div class=\"col-md-6 modified-border-left\"><p class=modified-details>Modified Details:</p><table class=\"table borderless\" ng-if=\"Transaction.formData.investmentType === Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || Transaction.formData.optionalInvestmentType === Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP\"><tr ng-if=Transaction.formData.isThroughDistributor><td>Distributor ARN</td><td>:</td><td ng-if=Transaction.formData.isThroughDistributor ng-class=\"{modifedValue : Transaction.formData.brokerCode!== Transaction.oldSipSystematicData.brokerCode}\">{{Transaction.formData.brokerCode?\'ARN-\'+ Transaction.formData.brokerCode:(Transaction.formData.distributorARN ? Transaction.formData.distributorARN:\'\')}}</td><td ng-if=!Transaction.formData.isThroughDistributor>N/A</td></tr><!--RIA code columns--><tr ng-if=Transaction.formData.isThroughRia><td>RIA Code</td><td>:</td><td ng-if=Transaction.formData.isThroughRia ng-class=\"{modifedValue :Transaction.formData.isThroughRia !==Transaction.oldSipSystematicData.isThroughRia}\">{{Transaction.formData.riaBrokerCode}}</td><td ng-if=!Transaction.formData.riaBrokerCode>N/A</td></tr><tr ng-if=Transaction.formData.isThroughRia><td>RIA Name</td><td>:</td><td ng-if=Transaction.formData.riaBrokerName ng-class=\"{modifedValue :Transaction.formData.riaBrokerName !==Transaction.oldSipSystematicData.riaBrokerName}\">{{Transaction.formData.riaBrokerName}}</td><td ng-if=!Transaction.formData.riaBrokerName>N/A</td></tr><!--RIA code columns--><tr ng-if=\"Transaction.formData.isThroughDistributor && Transaction.formData.euin && Transaction.formData.euin.euinCode\"><td>EUIN Code</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.euin.euinCode !==Transaction.oldSipSystematicData.euinCode}\">{{Transaction.formData.euin.euinCode}}</td></tr><tr ng-if=\"Transaction.formData.isThroughDistributor && Transaction.formData.euin && Transaction.formData.euin.euinName\"><td>EUIN Name</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.euin.euinName !==Transaction.oldSipSystematicData.euinName}\">{{Transaction.formData.euin.euinName}}</td></tr><tr ng-if=\"Transaction.formData.isThroughDistributor && Transaction.formData.subBrokerARN\"><td>Sub Broker ARN</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.subBrokerARN !==Transaction.oldSipSystematicData.subBrokerARN}\">{{\'ARN-\'+Transaction.formData.subBrokerARN}}</td></tr><tr ng-if=\"Transaction.formData.isThroughDistributor && Transaction.formData.subBrokerCode\"><td>Sub Broker Code</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.subBrokerCode !==Transaction.oldSipSystematicData.subBrokerCode}\">{{Transaction.formData.subBrokerCode}}</td></tr><tr><td>Scheme Name</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.inSchemeName !==Transaction.oldSipSystematicData.inSchemeName}\">{{Transaction.formData.inSchemeName}}</td></tr><tr ng-if=Transaction.oldSipSystematicData.investmentOption><td>Investment Option</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.investmentOption !==Transaction.oldSipSystematicData.investmentOption}\">{{Transaction.formData.investmentOption}}</td></tr><tr ng-if=\"Transaction.formData.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td ng-class=\"{modifedValue:Transaction.formData.sipDividendOption !== Transaction.oldSipSystematicData.dividendOption}\"><span ng-if=\"Transaction.formData.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[Transaction.formData.sipDividendOption]}}</span></td></tr><tr><td>Amount</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.amount !==Transaction.oldSipSystematicData.amount}\">{{Transaction.formData.displayAmount}}<br><label id=divDisplayWordsModified>{{Transaction.formData.amountInWords}} (In Words)</label></td></tr><tr><td>Installment Frequency</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.frequency !==Transaction.oldSipSystematicData.frequency}\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Transaction.formData.frequency]}}</td></tr><tr ng-if=\"Transaction.formData.frequency == \'OW\'\"><td>SIP Day</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.weeklyDay !==Transaction.oldSipSystematicData.weeklyDay}\">{{Transaction.formData.weeklyDay}}</td></tr><tr><td>Start Date</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.startDate.format(\'DD-MMM-YYYY\') !==Transaction.oldSipSystematicData.startDate}\">{{Transaction.formData.startDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr><td>End Date</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.endDate.format(\'DD-MMM-YYYY\') !==Transaction.oldSipSystematicData.endDate}\">{{Transaction.formData.endDate.format(\'DD-MMM-YYYY\')}}</td></tr><tr ng-if=Transaction.formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-class=\"{modifedValue :Transaction.formData.checkedNfoAutoSwitch !==Transaction.oldSipSystematicData.checkedNfoAutoSwitch}\" ng-bind=\"Transaction.formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=Transaction.formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-class=\"{modifedValue :Transaction.formData.inSchemeName !==Transaction.oldSipSystematicData.inSchemeName}\" ng-bind=Transaction.formData.inSchemeName></td></tr><tr ng-if=Transaction.formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-class=\"{modifedValue :Transaction.formData.switchDividendOption !==Transaction.oldSipSystematicData.switchDividendOption}\" ng-bind=\"Transaction.formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr><tr ng-if=Transaction.formData.sipFirstInstallment><td>SIP First Installment</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.sipFirstInstallment !==Transaction.oldSipSystematicData.sipFirstInstallment}\" ng-bind=\"Transaction.formData.sipFirstInstallment?\'Yes\':\'No\'\"></td></tr><tr ng-if=Transaction.formData.sipFirstAmount><td>SIP First Installment Amount</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.sipFirstAmount !==Transaction.oldSipSystematicData.sipFirstAmount}\"><i class=rupee-small-icon></i> {{Transaction.formData.sipFirstAmount}}</td></tr></table><table class=\"borderless table\"><tr ng-if=!Transaction.formData.sipTopupSelected><td>SIP Topup Enabled</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.sipTopupSelected !==Transaction.oldSipSystematicData.sipTopupEnabled}\">No</td></tr><tr ng-if=Transaction.formData.sipTopupSelected><td>SIP Topup Enabled</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.sipTopupSelected !==Transaction.oldSipSystematicData.sipTopupEnabled}\">Yes</td></tr><tr ng-if=\"Transaction.formData.sipTopupSelected && Transaction.formData.topupDetails.amount\"><td>SIP Topup Amount</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.topupDetails.amount !==Transaction.oldSipSystematicData.topupDetails.amount}\">{{Transaction.formData.topupDetails.displayAmount}}<br><label id=topupAmountModified>{{Transaction.topupAmount.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"Transaction.formData.sipTopupSelected && Transaction.formData.topupDetails.percentage\"><td>SIP Topup Percentage</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.topupDetails.percentage !==Transaction.oldSipSystematicData.topupDetails.percentage}\">{{Transaction.formData.topupDetails.percentage}}%</td></tr><tr ng-if=\"Transaction.formData.sipTopupSelected && Transaction.formData.topupDetails.frequency\"><td>SIP Topup Frequency</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.topupDetails.frequency !== Transaction.oldSipSystematicData.topupDetails.frequency}\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Transaction.formData.topupDetails.frequency]}}</td></tr><tr ng-if=\"Transaction.formData.sipTopupSelected && Transaction.formData.topupDetails.capAmount\"><td>SIP Topup Cap Amount</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.topupDetails.capAmount !== Transaction.oldSipSystematicData.topupDetails.capAmount}\">{{Transaction.formData.topupDetails.displayCapAmount}}<br><label id=capAmountModified>{{Transaction.topupCapAmount.amountInWords}} (In Words)</label></td></tr><tr ng-if=\"Transaction.formData.sipTopupSelected && Transaction.formData.topupDetails.capMonthYearSelect\"><td style=\"width: 200px\">SIP Topup Cap Month/Year</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.topupDetails.capMonthYearSelect !== Transaction.oldSipSystematicData.topupDetails.capMonthYear}\">{{Transaction.formData.topupDetails.capMonthYearSelect.format(\"DD-MMM-YYYY\")}}</td></tr><tr><td class=eMandateReview></td><td class=eMandateRow></td><td easyassist-key=mask-element></td></tr><tr><td class=eMandateReview></td><td class=eMandateRow></td><td easyassist-key=mask-element></td></tr></table><table class=\"table borderless\" ng-if=\"Transaction.formData.summaryType === \'SIP_TOPUP\'\"><tr><td>Folio Number</td><td>:</td><td>{{Transaction.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>{{Transaction.TRANSACTIONS_CONST.TRANSACTION_TYPE[Transaction.formData.summaryType]}}</td></tr><tr><td>Amount</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.amount !== Transaction.oldSipSystematicData.amount}\"><i class=rupee-small-icon></i> {{Transaction.formData.amount}}<br><label id=amountInwordsModified>{{Transaction.oldSipSystematicData.amountInWords}} (In Words)</label></td></tr><tr><td>Installment Frequency</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.frequency !== Transaction.oldSipSystematicData.frequency}\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Transaction.formData.frequency]}}</td></tr><tr><td>Sip End Date</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.toDate !== Transaction.oldSipSystematicData.toDate}\">{{Transaction.formData.toDate}}</td></tr><tr ng-if=Transaction.formData.topupAmount><td>Topup Amount</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.topupAmount !== Transaction.oldSipSystematicData.topupAmount}\"><i class=rupee-small-icon></i> {{Transaction.formData.topupAmount}}</td></tr><tr ng-if=Transaction.formData.topupPercentage><td>Topup Percentage</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.topupPercentage !== Transaction.oldSipSystematicData.topupPercentage}\">{{Transaction.formData.topupPercentage}}%</td></tr><tr><td>Topup Frequency</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.topupFrequency !== Transaction.oldSipSystematicData.topupFrequency}\">{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS.FREQ[Transaction.formData.topupFrequency]}}</td></tr><tr ng-if=Transaction.formData.topupCapAmount><td>Topup Cap-Amount</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.topupCapAmount !== Transaction.oldSipSystematicData.topupCapAmount}\"><i class=rupee-small-icon></i> {{Transaction.formData.topupCapAmount}}</td></tr><tr ng-if=Transaction.formData.topupCapMonthYear><td>Topup Cap-Date</td><td>:</td><td ng-class=\"{modifedValue :Transaction.formData.sipTopupCapMonthYear !== Transaction.oldSipSystematicData.sipTopupCapMonthYear}\">{{Transaction..sipTopupCapMonthYear}}</td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-class=\"{modifedValue :formData.checkedNfoAutoSwitch !== oldSipSystematicData.checkedNfoAutoSwitch}\" ng-bind=\"formData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-class=\"{modifedValue :formData.inSchemeName !== oldSipSystematicData.inSchemeName}\" ng-bind=formData.inSchemeName></td></tr><tr ng-if=formData.checkedNfoAutoSwitch><td>Auto Switch Scheme IDCW Option:</td><td ng-class=\"{modifedValue :formData.switchDividendOption !== oldSipSystematicData.switchDividendOption}\" ng-bind=\"formData.switchDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table></div></div></div><div class=transaction-footer><button class=\"btn btn-primary-action\" ng-disabled=\"\n              !Transaction.tForm.$valid || Transaction.isInvalidForm || !Transaction.formData.inSchemeCode\n              || Transaction.isminCapAmount || !Transaction.formData.startDate || !Transaction.formData.endDate\n              || ((Transaction.formData.brokerCode || Transaction.formData.distributorARN) && Transaction.isArnSuccess)\n              || (Transaction.formData.subBrokerARN && Transaction.isSubarnSuccess) || Transaction.isMax || Transaction.isMin\n              || (!Transaction.kycVerifiedFlag) || !Transaction.isMultiples || Transaction.amountExceeded\n              || ((Transaction.stateParams.action !== \'modify\') && Transaction.formData.sipTopupSelected && !((Transaction.formData.topupDetails.amount && Transaction.formData.topupDetails.frequency) && (Transaction.formData.topupDetails.capAmount || Transaction.formData.topupDetails.capMonthYearSelect) && !(Transaction.isminCapAmount))) || (Transaction.formData.isThroughDistributor && !Transaction.isSelectedEuin && Transaction.formData.isEuin)\" ng-click=Transaction.proceedToTransact()>Proceed</button></div></form><div class=\"initiate-transaction sipPurchase\"><div class=\"ecart-journey main-section-ecart\" ng-if=Transaction.showEcartModel><div class=sidebar-container id=sidebarContainer hdfc-ecart-sidebar side-title=Transaction.sidebarTitle investor-data=Transaction.investorData cart-item=Transaction.ecartData show-add-cart=Transaction.showAddCart pending-state=Transaction.redirectingState close-action=Transaction.helper.closeAction(action)></div></div></div></div>");
$templateCache.put("app/transactions/status/payment-status/upi/upi.html","<section ng-if=!Upi.isLoading><div data-ng-include=\"\'app/payment/templates/loader/loader.html\'\"></div></section><div ui-view></div>");
$templateCache.put("app/transactions/status/payment-status/upi/upi-expired/upi.expired.html","<div class=header-section><hdfc-header ng-if=\"!UpiExpired.showWhatsApp && !UpiExpired.isMobile\"></hdfc-header><hdfc-sidebar ng-if=\"!UpiExpired.showWhatsApp && !UpiExpired.isMobile\"></hdfc-sidebar><div class=\"payment-header-container payment-header text-center\" ng-if=UpiExpired.showWhatsApp><div class=logo-btn-container><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo> <span></span></div><p>Acknowledgement</p></div></div><section class=\"content-section payment-status\" ng-class=\"{\'p-0\' : UpiExpired.isMobile}\"><div class=\"container-fluid height100\" ng-class=\"{\'header-spacing\': !UpiExpired.showWhatsApp && !UpiExpired.isMobile}\"><section class=height100 ng-class=\"{\'box-shadow\': !UpiExpired.showWhatsApp && !UpiExpired.isMobile}\"><div class=row><div class=col-md-12><div class=header ng-class=\"{\'header-background\': UpiExpired.summaryData.paymentStatus === UpiExpired.UPI_TRANSACTION_STATUS.SUCCESS}\"><div><div class=header-img><div class=failed><i class=header-failed></i></div></div><div class=\"text text-center\"><h3>Transaction Expired</h3><p style=\"margin-top: 20px; margin-bottom: 10px\">You’ve been inactive for a while or started another active session.</p></div></div></div></div></div><div class=row><div class=col-md-12><div class=body><div class=row ng-if=\"UpiExpired.summaryData.paymentStatus === UpiExpired.UPI_TRANSACTION_STATUS.SUCCESS\"><div class=col-md-12><p>Thank you for investing with us.</p></div></div><div class=row><div class=col-md-12><div class=\"fund-details fund-details-error\"><div><div class=\"main-text black-200\">{{UpiExpired.summaryData.schemeName}}</div><div class=\"sub-text black-200 font-weight-600\" ng-if=\"UpiExpired.transactionType !== \'SIPPURCHASE\'\">₹{{UpiExpired.utilService.getCommaSeperatedString(UpiExpired.summaryData.amount)}}</div><div class=\"sub-text black-200 font-weight-600\" ng-if=\"UpiExpired.transactionType === \'SIPPURCHASE\'\">UPI Autopay | {{UpiExpired.summaryData.brokerCode}}</div></div></div></div></div><div class=row><div class=\"mx-auto col-md-5\"><div class=transaction-details><div class=row ng-if=\"UpiExpired.transactionType === \'SIP\' && UpiExpired.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Type: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">SIP</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">SIP</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Tenure: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.sipTenure}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.sipTenure}}</span></p></div><div class=\"col-md-6 col-xs-6\" ng-if=UpiExpired.summaryData.sipWithFi><p class=\"sub-text black-80 font-weight-400\">First Installment Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiExpired.utilService.getCommaSeperatedString(UpiExpired.summaryData.amount)}}</span></p></div><div class=\"col-xs-6 visible-xs\" ng-if=UpiExpired.summaryData.sipWithFi><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiExpired.utilService.getCommaSeperatedString(UpiExpired.summaryData.amount)}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Investing Through: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.brokerCode}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.brokerCode}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Method: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">UPI Autopay</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">UPI Autopay</span></p></div><!--<div class=\"col-md-6 col-xs-6\">\n                      <p class=\"sub-text black-80 font-weight-400\">CAMS Reference Number: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.camsReferenceNo}}</span></p>\n                    </div>\n                    <div class=\"col-xs-6 visible-xs\"> &lt;!&ndash;specific to mobile device&ndash;&gt;\n                      <p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.camsReferenceNo}}</span></p>\n                    </div>--><div class=\"col-md-6 col-xs-6\" ng-if=UpiExpired.summaryData.sipTopUpAmount><p class=\"sub-text black-80 font-weight-400\">SIP Top Up Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiExpired.utilService.getCommaSeperatedString(UpiExpired.summaryData.sipTopUpAmount)}}/{{UpiExpired.constants.TRANSACTIONS.DESCRIPTIONS.FREQ[UpiExpired.summaryData.sipTopupFrequency]}}</span></p></div><div class=\"col-xs-6 visible-xs\" ng-if=UpiExpired.summaryData.sipTopUpAmount><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiExpired.utilService.getCommaSeperatedString(UpiExpired.summaryData.sipTopUpAmount)}}/{{UpiExpired.constants.TRANSACTIONS.DESCRIPTIONS.FREQ[UpiExpired.summaryData.sipTopupFrequency]}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SRN No: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.srnNumber}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.srnNumber}}</span></p></div></div><div class=row ng-if=\"UpiExpired.transactionType === \'PURCHASE\' && UpiExpired.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Type: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">Purchase</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">Purchase</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Date: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.transactionDateTime}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.transactionDateTime}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Investing Through: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.brokerCode}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.brokerCode}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Method: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.PAYMENT_OPTIONS.UPI}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.PAYMENT_OPTIONS.UPI}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">CAMS Reference No.: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.camsReferenceNo}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.camsReferenceNo}}</span></p></div></div><div class=row ng-if=\"UpiExpired.transactionType === \'SIPPURCHASE\' && UpiExpired.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-12\"><div class=\"col-md-12 col-xs-12\"><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600 hidden-xs\">Purchase Summary</span></p></div><div class=\"col-xs-12 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">Purchase Summary</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiExpired.utilService.getCommaSeperatedString(UpiExpired.summaryData.sipFiAmount)}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiExpired.utilService.getCommaSeperatedString(UpiExpired.summaryData.sipFiAmount)}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Date: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.transactionDateTime}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.transactionDateTime}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Status: <span ng-style=\"{\'color\' : UpiExpired.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.transStatus}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span ng-style=\"{\'color\' : UpiExpired.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600\">{{UpiExpired.transStatus}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Number: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.cartId}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.cartId}}</span></p></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"col-md-12 col-xs-12\"><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600 hidden-xs\">SIP Summary</span></p></div><div class=\"col-xs-12 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">SIP Summary</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiExpired.utilService.getCommaSeperatedString(UpiExpired.summaryData.amount)}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiExpired.utilService.getCommaSeperatedString(UpiExpired.summaryData.amount)}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Tenure: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.sipTenure}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.sipTenure}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Status: <span ng-style=\"{\'color\' : UpiExpired.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.transStatus}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span ng-style=\"{\'color\' : UpiExpired.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600\">{{UpiExpired.transStatus}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Registration Number (SRN): <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiExpired.summaryData.srnNumber}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiExpired.summaryData.srnNumber}}</span></p></div></div></div><div class=row ng-if=\"UpiExpired.summaryData.sourcePortal === \'WHATSAPP\'\"><div class=\"col-md-12 col-xs-12 whatsapp-message\"><p>Kindly check WhatsApp to view detailed acknowledgement</p></div></div></div></div></div><div class=\"row set-responsive-width-max\" ng-if=\"UpiExpired.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"mx-auto col-md-5\"><div class=action-container><button class=\"btn btn-secondary\" ng-click=UpiExpired.redirectToHome();>Go To Home</button></div></div></div></div></div></div><div class=\"row footer-row\" ng-if=!UpiExpired.showWhatsApp><div class=col-md-12><footer><div class=footer-text>For any clarification, please reach our customer service at <a href=mailto:Hello@hdfcfund.com>Hello@hdfcfund.com</a> or call us at <a href=\"tel:1800 3010 6767\">1800 3010 6767</a> or <a href=\"tel:1800 419 7676\">1800 419 7676</a>.</div></footer></div></div><div class=\"row footer-row\" ng-if=UpiExpired.showWhatsApp><div class=col-md-12><div><div class=footerSubDiv><img src=../../../assets/images/hdfcmf-Main.png alt=\"\" style=\"height: 20px\"><p class=footerSubHeading>Managed by HDFC MF Limited.<a href={{UpiExpired.CORPORATE_URL}} target=_blank style=\"color: blue;font-weight: 500\">Learn More</a>.</p></div></div></div></div></section></div></section><div class=footer-section ng-if=\"!UpiExpired.showWhatsApp && !UpiExpired.isMobile\"><div ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div></div>");
$templateCache.put("app/transactions/status/payment-status/upi/upi-failed/upi.failed.html","<div class=header-section><hdfc-header ng-if=\"!UpiFailed.showWhatsApp && !UpiFailed.isMobile\"></hdfc-header><hdfc-sidebar ng-if=\"!UpiFailed.showWhatsApp && !UpiFailed.isMobile\"></hdfc-sidebar><div class=\"payment-header-container payment-header text-center\" ng-if=UpiFailed.showWhatsApp><div class=logo-btn-container><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo> <span></span></div><p>Acknowledgement</p></div></div><section class=\"content-section payment-status\" ng-class=\"{\'p-0\' : UpiFailed.isMobile}\"><div class=\"container-fluid height100\" ng-class=\"{\'header-spacing\': !UpiFailed.showWhatsApp && !UpiFailed.isMobile}\"><section class=height100 ng-class=\"{\'box-shadow\': !UpiFailed.showWhatsApp && !UpiFailed.isMobile}\"><div class=row><div class=col-md-12><div class=header ng-class=\"{\'header-background\': UpiFailed.summaryData.paymentStatus === UpiFailed.UPI_TRANSACTION_STATUS.SUCCESS}\"><div><div class=header-img><div class=failed><i class=header-failed></i></div></div><div class=\"text text-center\"><h3>Transaction Failed</h3><p style=\"margin-top: 20px; margin-bottom: 10px\">{{UpiFailed.errorMessage}}</p></div></div></div></div></div><div class=row><div class=col-md-12><div class=body><div class=row ng-if=\"UpiFailed.summaryData.paymentStatus === UpiFailed.UPI_TRANSACTION_STATUS.SUCCESS\"><div class=col-md-12><p>Thank you for investing with us.</p></div></div><div class=row><div class=col-md-12><div class=fund-details ng-class=\"{\'fund-details-error\': UpiFailed.summaryData.error, \'fund-detail-spacing\' : !UpiFailed.summaryData.error}\"><div><div class=\"main-text black-200\">{{UpiFailed.summaryData.schemeName}}</div><div class=\"sub-text black-200 font-weight-600\" ng-if=\"UpiFailed.transactionType !== \'SIPPURCHASE\'\">₹{{UpiFailed.utilService.getCommaSeperatedString(UpiFailed.summaryData.amount)}}</div><div class=\"sub-text black-200 font-weight-600\" ng-if=\"UpiFailed.transactionType === \'SIPPURCHASE\'\">UPI Autopay | {{UpiFailed.summaryData.brokerCode}}</div></div></div></div></div><div class=row><div class=\"mx-auto col-md-5\"><div class=transaction-details><div class=row ng-if=\"UpiFailed.transactionType === \'SIP\' && UpiFailed.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Type: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">SIP</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">SIP</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Tenure: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.sipTenure}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.sipTenure}}</span></p></div><div class=\"col-md-6 col-xs-6\" ng-if=UpiFailed.summaryData.sipWithFi><p class=\"sub-text black-80 font-weight-400\">First Installment Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiFailed.utilService.getCommaSeperatedString(UpiFailed.summaryData.amount)}}</span></p></div><div class=\"col-xs-6 visible-xs\" ng-if=UpiFailed.summaryData.sipWithFi><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiFailed.utilService.getCommaSeperatedString(UpiFailed.summaryData.amount)}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Investing Through: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.brokerCode}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.brokerCode}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Method: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">UPI Autopay</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">UPI Autopay</span></p></div><!--<div class=\"col-md-6 col-xs-6\">\n                      <p class=\"sub-text black-80 font-weight-400\">CAMS Reference Number: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.camsReferenceNo}}</span></p>\n                    </div>\n                    <div class=\"col-xs-6 visible-xs\"> &lt;!&ndash;specific to mobile device&ndash;&gt;\n                      <p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.camsReferenceNo}}</span></p>\n                    </div>--><div class=\"col-md-6 col-xs-6\" ng-if=UpiFailed.summaryData.sipTopUpAmount><p class=\"sub-text black-80 font-weight-400\">SIP Top Up Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiFailed.utilService.getCommaSeperatedString(UpiFailed.summaryData.sipTopUpAmount)}}/{{UpiFailed.constants.TRANSACTIONS.DESCRIPTIONS.FREQ[UpiFailed.summaryData.sipTopupFrequency]}}</span></p></div><div class=\"col-xs-6 visible-xs\" ng-if=UpiFailed.summaryData.sipTopUpAmount><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiFailed.utilService.getCommaSeperatedString(UpiFailed.summaryData.sipTopUpAmount)}}/{{UpiFailed.constants.TRANSACTIONS.DESCRIPTIONS.FREQ[UpiFailed.summaryData.sipTopupFrequency]}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SRN No: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.srnNumber}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.srnNumber}}</span></p></div></div><div class=row ng-if=\"UpiFailed.transactionType === \'PURCHASE\' && UpiFailed.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Type: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">Purchase</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">Purchase</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Date: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.transactionDateTime}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.transactionDateTime}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Investing Through: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.brokerCode}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.brokerCode}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Method: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.PAYMENT_OPTIONS.UPI}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.PAYMENT_OPTIONS.UPI}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">CAMS Reference No.: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.camsReferenceNo}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.camsReferenceNo}}</span></p></div></div><div class=row ng-if=\"UpiFailed.transactionType === \'SIPPURCHASE\' && UpiFailed.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-12\"><div class=\"col-md-12 col-xs-12\"><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600 hidden-xs\">Purchase Summary</span></p></div><div class=\"col-xs-12 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">Purchase Summary</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiFailed.utilService.getCommaSeperatedString(UpiFailed.summaryData.sipFiAmount)}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiFailed.utilService.getCommaSeperatedString(UpiFailed.summaryData.sipFiAmount)}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Date: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.transactionDateTime}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.transactionDateTime}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Status: <span ng-style=\"{\'color\' : UpiFailed.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.transStatus}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span ng-style=\"{\'color\' : UpiFailed.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600\">{{UpiFailed.transStatus}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Number: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.cartId}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.cartId}}</span></p></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"col-md-12 col-xs-12\"><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600 hidden-xs\">SIP Summary</span></p></div><div class=\"col-xs-12 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">SIP Summary</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiFailed.utilService.getCommaSeperatedString(UpiFailed.summaryData.amount)}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiFailed.utilService.getCommaSeperatedString(UpiFailed.summaryData.amount)}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Tenure: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.sipTenure}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.sipTenure}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Status: <span ng-style=\"{\'color\' : UpiFailed.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.transStatus}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span ng-style=\"{\'color\' : UpiFailed.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600\">{{UpiFailed.transStatus}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Registration Number (SRN): <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiFailed.summaryData.srnNumber}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiFailed.summaryData.srnNumber}}</span></p></div></div></div><div class=row ng-if=\"UpiFailed.summaryData.sourcePortal === \'WHATSAPP\'\"><div class=\"col-md-12 col-xs-12 whatsapp-message\"><p>Kindly check WhatsApp to view detailed acknowledgement</p></div></div></div></div></div><div class=\"row set-responsive-width-max\" ng-if=\"UpiFailed.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"mx-auto col-md-5\"><div class=action-container><button class=\"btn btn-secondary\" ng-click=UpiFailed.redirectToHome();>Go To Home</button></div></div></div></div></div></div><div class=\"row footer-row\" ng-if=!UpiFailed.showWhatsApp><div class=col-md-12><footer><div class=footer-text>For any clarification, please reach our customer service at <a href=mailto:Hello@hdfcfund.com>Hello@hdfcfund.com</a> or call us at <a href=\"tel:1800 3010 6767\">1800 3010 6767</a> or <a href=\"tel:1800 419 7676\">1800 419 7676</a>.</div></footer></div></div><div class=\"row footer-row\" ng-if=UpiFailed.showWhatsApp><div class=col-md-12><div><div class=footerSubDiv><img src=../../../assets/images/hdfcmf-Main.png alt=\"\" style=\"height: 20px\"><p class=footerSubHeading>Managed by HDFC MF Limited.<a href={{UpiFailed.CORPORATE_URL}} target=_blank style=\"color: blue;font-weight: 500\">Learn More</a>.</p></div></div></div></div></section></div></section><div class=footer-section ng-if=\"!UpiFailed.showWhatsApp && !UpiFailed.isMobile\"><div ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div></div>");
$templateCache.put("app/transactions/status/payment-status/upi/upi-success/upi.success.html","<div class=header-section><hdfc-header ng-if=\"!UpiSuccess.showWhatsApp && !UpiSuccess.isMobile\"></hdfc-header><hdfc-sidebar ng-if=\"!UpiSuccess.showWhatsApp && !UpiSuccess.isMobile\"></hdfc-sidebar><div class=\"payment-header-container payment-header text-center\" ng-if=UpiSuccess.showWhatsApp><div class=logo-btn-container><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo> <span></span></div><p>Acknowledgement</p></div></div><section class=\"content-section payment-status\" ng-class=\"{\'p-0\' : UpiSuccess.isMobile}\"><div class=\"container-fluid height100\" ng-class=\"{\'header-spacing\': !UpiSuccess.showWhatsApp && !UpiSuccess.isMobile}\"><section class=height100 ng-class=\"{\'box-shadow\': !UpiSuccess.showWhatsApp && !UpiSuccess.isMobile}\"><div class=row><div class=col-md-12><div class=\"header header-background\"><div><div class=header-img><div class=success><i class=header-success></i></div></div><div class=text><h3>Transaction Successful</h3></div></div></div></div></div><div class=row><div class=col-md-12><div class=body><div class=row ng-if=\"UpiSuccess.summaryData.paymentStatus === UpiSuccess.UPI_TRANSACTION_STATUS.SUCCESS\"><div class=col-md-12><p>Thank you for investing with us.</p></div></div><div class=row><div class=col-md-12><div class=fund-details><div><div class=\"main-text black-200\">{{UpiSuccess.summaryData.schemeName}}</div><div class=\"sub-text black-200 font-weight-600\" ng-if=\"UpiSuccess.transactionType !== \'SIPPURCHASE\'\">₹{{UpiSuccess.utilService.getCommaSeperatedString(UpiSuccess.summaryData.amount)}}</div><div class=\"sub-text black-200 font-weight-600\" ng-if=\"UpiSuccess.transactionType === \'SIPPURCHASE\'\">UPI Autopay | {{UpiSuccess.summaryData.brokerCode}}</div></div></div></div><div class=row><div class=\"mx-auto col-md-5\"><div class=transaction-details><div class=row ng-if=\"UpiSuccess.transactionType === \'SIP\' && UpiSuccess.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Type: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">SIP</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">SIP</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Tenure: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.sipTenure}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.sipTenure}}</span></p></div><div class=\"col-md-6 col-xs-6\" ng-if=UpiSuccess.summaryData.sipWithFi><p class=\"sub-text black-80 font-weight-400\">First Installment Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiSuccess.utilService.getCommaSeperatedString(UpiSuccess.summaryData.amount)}}</span></p></div><div class=\"col-xs-6 visible-xs\" ng-if=UpiSuccess.summaryData.sipWithFi><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiSuccess.utilService.getCommaSeperatedString(UpiSuccess.summaryData.amount)}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Investing Through: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.brokerCode}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.brokerCode}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Method: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">UPI Autopay</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">UPI Autopay</span></p></div><div class=\"col-md-6 col-xs-6\" ng-if=UpiSuccess.summaryData.camsReferenceNo><p class=\"sub-text black-80 font-weight-400\">CAMS Reference Number: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.camsReferenceNo}}</span></p></div><div class=\"col-xs-6 visible-xs\" ng-if=UpiSuccess.summaryData.camsReferenceNo><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.camsReferenceNo}}</span></p></div><div class=\"col-md-6 col-xs-6\" ng-if=UpiSuccess.summaryData.sipTopUpAmount><p class=\"sub-text black-80 font-weight-400\">SIP Top-Up Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiSuccess.utilService.getCommaSeperatedString(UpiSuccess.summaryData.sipTopUpAmount)}}/{{UpiSuccess.constants.TRANSACTIONS.DESCRIPTIONS.FREQ[UpiSuccess.summaryData.sipTopupFrequency]}}</span></p></div><div class=\"col-xs-6 visible-xs\" ng-if=UpiSuccess.summaryData.sipTopUpAmount><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiSuccess.utilService.getCommaSeperatedString(UpiSuccess.summaryData.sipTopUpAmount)}}/{{UpiSuccess.constants.TRANSACTIONS.DESCRIPTIONS.FREQ[UpiSuccess.summaryData.sipTopupFrequency]}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Registration Number: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.srnNumber}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.srnNumber}}</span></p></div></div><div class=row ng-if=\"UpiSuccess.transactionType === \'PURCHASE\' && UpiSuccess.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Type: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">Purchase</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">Purchase</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Date: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.transactionDateTime}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.transactionDateTime}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Investing Through: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.brokerCode}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.brokerCode}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Method: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.PAYMENT_OPTIONS.UPI}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.PAYMENT_OPTIONS.UPI}}</span></p></div><div class=\"col-md-6 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">CAMS Reference No.: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.camsReferenceNo}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.camsReferenceNo}}</span></p></div></div><div class=row ng-if=\"UpiSuccess.transactionType === \'SIPPURCHASE\' && UpiSuccess.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-6 col-xs-12\"><div class=\"col-md-12 col-xs-12\"><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600 hidden-xs\">Purchase Summary</span></p></div><div class=\"col-xs-12 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">Purchase Summary</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiSuccess.utilService.getCommaSeperatedString(UpiSuccess.summaryData.sipFiAmount)}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiSuccess.utilService.getCommaSeperatedString(UpiSuccess.summaryData.sipFiAmount)}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Payment Date: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.transactionDateTimePurchase}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.transactionDateTimePurchase}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Status: <span ng-style=\"{\'color\' : UpiSuccess.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.transStatus}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span ng-style=\"{\'color\' : UpiSuccess.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.transStatus}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Transaction Number: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.cartId}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.cartId}}</span></p></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"col-md-12 col-xs-12\"><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600 hidden-xs\">SIP Summary</span></p></div><div class=\"col-xs-12 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">SIP Summary</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Amount: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">₹{{UpiSuccess.utilService.getCommaSeperatedString(UpiSuccess.summaryData.amount)}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">₹{{UpiSuccess.utilService.getCommaSeperatedString(UpiSuccess.summaryData.amount)}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Tenure: <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.sipTenure}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.sipTenure}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">Status: <span ng-style=\"{\'color\' : UpiSuccess.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.transStatus}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span ng-style=\"{\'color\' : UpiSuccess.transStatus === \'Successful\' ? \'green\' : \'red\'}\" class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.transStatus}}</span></p></div><div class=\"col-md-12 col-xs-6\"><p class=\"sub-text black-80 font-weight-400\">SIP Registration Number (SRN): <span class=\"sub-text black-200 font-weight-600 hidden-xs\">{{UpiSuccess.summaryData.srnNumber}}</span></p></div><div class=\"col-xs-6 visible-xs\"><!--specific to mobile device--><p class=\"sub-text black-80 font-weight-400\"><span class=\"sub-text black-200 font-weight-600\">{{UpiSuccess.summaryData.srnNumber}}</span></p></div></div></div><div class=row ng-if=\"UpiSuccess.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"col-md-12 col-xs-12 sip-message\"><i class=info-fill></i><p>Your next SIP installment shall be debited on {{UpiSuccess.summaryData.transactionDateTime}}. <span ng-if=UpiSuccess.showInstallments>Subsequent SIP installments shall be debited every {{UpiSuccess.installmentText}}.</span></p></div></div><div class=row ng-if=\"UpiSuccess.summaryData.sourcePortal === \'WHATSAPP\'\"><div class=\"col-md-12 col-xs-12 whatsapp-message\"><p>Kindly check WhatsApp to view detailed acknowledgement</p></div></div></div></div></div><div class=row ng-class=\"{\'set-responsive-width-max\' : UpiSuccess.transactionType === \'SIPPURCHASE\'}\" ng-if=\"UpiSuccess.summaryData.sourcePortal !== \'WHATSAPP\'\"><div class=\"mx-auto col-md-5\"><div class=action-container><button class=\"btn btn-secondary\" ng-click=UpiSuccess.redirectToHome();>Go To Home</button> <button class=\"btn btn-primary\" ng-if=\"UpiSuccess.transactionType === \'SIP\' && UpiSuccess.summaryData.paymentStatus === UpiSuccess.UPI_TRANSACTION_STATUS.SUCCESS\" ng-click=\"UpiSuccess.performRedirect(\'SIP\');\">Invest More</button> <button class=\"btn btn-primary\" ng-click=\"UpiSuccess.performRedirect(\'PURCHASE\');\" ng-if=\"UpiSuccess.transactionType === \'PURCHASE\' && UpiSuccess.summaryData.paymentStatus === UpiSuccess.UPI_TRANSACTION_STATUS.SUCCESS\">Invest More</button> <button class=\"btn btn-primary\" ng-click=\"UpiSuccess.performRedirect(\'SIP\');\" ng-if=\"UpiSuccess.transactionType === \'SIP\' && UpiSuccess.transactionType === \'PURCHASE\' && UpiSuccess.summaryData.paymentStatus === UpiSuccess.UPI_TRANSACTION_STATUS.SUCCESS\">Invest More</button></div></div></div></div></div></div><div class=\"row footer-row\" ng-if=!UpiSuccess.showWhatsApp><div class=col-md-12><footer><div class=footer-text>For any clarification, please reach our customer service at <a href=mailto:Hello@hdfcfund.com>Hello@hdfcfund.com</a> or call us at <a href=\"tel:1800 3010 6767\">1800 3010 6767</a> or <a href=\"tel:1800 419 7676\">1800 419 7676</a>.</div></footer></div></div><div class=\"row footer-row\" ng-if=UpiSuccess.showWhatsApp><div class=col-md-12><div><div class=footerSubDiv><img src=../../../assets/images/hdfcmf-Main.png alt=\"\" style=\"height: 20px\"><p class=footerSubHeading>Managed by HDFC MF Limited.<a href={{UpiSuccess.CORPORATE_URL}} target=_blank style=\"color: blue;font-weight: 500\">Learn More</a>.</p></div></div></div></div></div></section></div></section><div class=footer-section ng-if=\"!UpiSuccess.showWhatsApp && !UpiSuccess.isMobile\"><div ng-include=\"\'app/components/footer/footer-post-login.html\'\"></div></div>");
$templateCache.put("app/transactions/status/payment-status/upi/upi-waiting/upi.waiting.html","<div id=waiting-section><header class=mainNav ng-if=\"UpiWaiting.summaryData.sourcePortal !== \'WHATSAPP\' && !UpiWaiting.isMobile\"><div class=\"header-primary set-width d-flex justify-content-between\"><img src=assets/images/icons/payment/logo-main.png width=135 height=45 alt=\"HDFC MF\"> <a class=cancel-cta ng-click=UpiWaiting.redirecToWelcome()><img src=assets/images/icons/cross-white.svg alt=collapse style=\"height: 45px;width: 30px; cursor: pointer\"></a></div></header><div class=\"payment-header-container payment-header text-center\" ng-if=\"UpiWaiting.summaryData.sourcePortal === \'WHATSAPP\'\"><div class=logo-btn-container><img src=assets/images/hdfcmf-Main.svg alt=HDFC class=logo> <span></span></div><p>Payment in Process</p></div><main class=container><div class=row><div class=\"mx-auto col-md-10\"><div class=note-section><img src=assets/images/icons/payment/icons_info-fill.svg alt=info><p>Please do not press back button or close the screen until the payment is complete.</p></div></div><div class=\"mx-auto col-md-12\"><div class=main-banner><!--<h2>Complete your payment</h2>--> <img src=assets/images/icons/payment/banner_page.svg alt=\"Complete Payment\"></div></div><div class=\"mx-auto col-md-12\"><div class=heading-summary style=\"text-align: center\">This page will automatically expires in <strong id=timer></strong>. Kindly follow below steps to complete your payment</div></div><div class=\"mx-auto col-md-9\"><div class=payment-message><div class=payment-message-content><ol><li>Go to UPI ID linked mobile app or click on the notification from your UPI ID linked mobile app.</li><li>Check pending transactions.</li><li>Complete the payment by selecting the bank and entering UPI PIN.</li><li>Mandate registered via UPI autopay, shall get registered with start date as today\'s date.</li></ol><!--<p><strong>If you have entered the UPI ID of friends or family, they will need to authorise the payment from their UPI App.</strong></p>--></div></div></div></div></main></div><div ng-if=\"UpiWaiting.summaryData.sourcePortal === \'WHATSAPP\'\"><div class=footerSubDiv><img src=../../../assets/images/hdfcmf-Main.png alt=\"\" style=\"height: 20px\"><p class=footerSubHeading>Managed by HDFC MF Limited.<a href={{UpiWaiting.CORPORATE_URL}} target=_blank style=\"color: blue;font-weight: 500\">Learn More</a>.</p></div></div>");}]);